
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("VVnlL", function(module, exports) {

$parcel$export(module.exports, "getSpaRoutes", () => $ef6e862e848d08e0$export$10439de9ce871f28);

var $aNke7 = parcelRequire("aNke7");

var $Dkaoj = parcelRequire("Dkaoj");

var $fMVEG = parcelRequire("fMVEG");

var $4BdYV = parcelRequire("4BdYV");

var $laDqO = parcelRequire("laDqO");

var $2pvey = parcelRequire("2pvey");

var $lgfw1 = parcelRequire("lgfw1");

var $4x45G = parcelRequire("4x45G");

var $3rBGh = parcelRequire("3rBGh");

var $4PsEV = parcelRequire("4PsEV");

var $jWVY2 = parcelRequire("jWVY2");

var $dTwSZ = parcelRequire("dTwSZ");

var $ktEDA = parcelRequire("ktEDA");

var $caoz4 = parcelRequire("caoz4");

var $5BlCA = parcelRequire("5BlCA");

var $3Hflx = parcelRequire("3Hflx");

var $bUOZo = parcelRequire("bUOZo");

var $bC98V = parcelRequire("bC98V");

var $1mByb = parcelRequire("1mByb");

var $ew7DI = parcelRequire("ew7DI");

var $gCfQs = parcelRequire("gCfQs");

var $2UvYl = parcelRequire("2UvYl");

var $81ZCL = parcelRequire("81ZCL");

var $izUuJ = parcelRequire("izUuJ");

var $ipR0U = parcelRequire("ipR0U");

var $jovMq = parcelRequire("jovMq");

var $a4nP2 = parcelRequire("a4nP2");

var $h0ilo = parcelRequire("h0ilo");

var $k1TyW = parcelRequire("k1TyW");

var $hH7Cb = parcelRequire("hH7Cb");

var $dtLGm = parcelRequire("dtLGm");

var $f6OBR = parcelRequire("f6OBR");

var $5uMDF = parcelRequire("5uMDF");

var $3RvJ0 = parcelRequire("3RvJ0");

var $fpGzf = parcelRequire("fpGzf");

var $aVGYm = parcelRequire("aVGYm");

var $2DH60 = parcelRequire("2DH60");

var $a5XVU = parcelRequire("a5XVU");

var $lUhpq = parcelRequire("lUhpq");

var $43Rln = parcelRequire("43Rln");

var $6Z4jF = parcelRequire("6Z4jF");

var $eLT92 = parcelRequire("eLT92");

var $cgOe5 = parcelRequire("cgOe5");

var $2d9QY = parcelRequire("2d9QY");

var $jj70V = parcelRequire("jj70V");

var $4AqA1 = parcelRequire("4AqA1");

var $2FVZu = parcelRequire("2FVZu");

var $lGnoq = parcelRequire("lGnoq");

var $6cMQO = parcelRequire("6cMQO");

var $lxXtu = parcelRequire("lxXtu");

var $2l6sh = parcelRequire("2l6sh");

var $1C9Ha = parcelRequire("1C9Ha");

var $cChHY = parcelRequire("cChHY");

var $d1sI7 = parcelRequire("d1sI7");

var $gksya = parcelRequire("gksya");

var $l0UsI = parcelRequire("l0UsI");

var $bdHl5 = parcelRequire("bdHl5");

var $1oew5 = parcelRequire("1oew5");

var $5hvg3 = parcelRequire("5hvg3");

var $6oWts = parcelRequire("6oWts");

var $76RJj = parcelRequire("76RJj");

var $ikfu9 = parcelRequire("ikfu9");

var $g7fao = parcelRequire("g7fao");

var $8s6qp = parcelRequire("8s6qp");

var $qruNQ = parcelRequire("qruNQ");

var $4chTT = parcelRequire("4chTT");

var $5qx9W = parcelRequire("5qx9W");

var $5dqn2 = parcelRequire("5dqn2");

var $7gypr = parcelRequire("7gypr");

var $cwKGx = parcelRequire("cwKGx");

var $dfdSu = parcelRequire("dfdSu");

var $ieqGd = parcelRequire("ieqGd");

var $JQ5Vt = parcelRequire("JQ5Vt");

var $eOPb5 = parcelRequire("eOPb5");

var $vDjHk = parcelRequire("vDjHk");

var $jZMnM = parcelRequire("jZMnM");

var $5nA0V = parcelRequire("5nA0V");

var $bQ0RK = parcelRequire("bQ0RK");

var $7UDCM = parcelRequire("7UDCM");

var $hDCtq = parcelRequire("hDCtq");

var $9CxHM = parcelRequire("9CxHM");

var $eaKG5 = parcelRequire("eaKG5");

var $8zbqc = parcelRequire("8zbqc");

var $9HXcc = parcelRequire("9HXcc");

var $jq5xL = parcelRequire("jq5xL");

var $4r3FF = parcelRequire("4r3FF");

var $hHcn9 = parcelRequire("hHcn9");

var $igqAf = parcelRequire("igqAf");

var $gm7fA = parcelRequire("gm7fA");

var $gbj7F = parcelRequire("gbj7F");

var $8gEiV = parcelRequire("8gEiV");

var $dhiyM = parcelRequire("dhiyM");

var $21AP4 = parcelRequire("21AP4");

var $infHq = parcelRequire("infHq");

var $ilKWG = parcelRequire("ilKWG");

var $dUuHj = parcelRequire("dUuHj");

var $eiK9n = parcelRequire("eiK9n");

var $4KinX = parcelRequire("4KinX");

var $6IB0N = parcelRequire("6IB0N");

var $1sFpf = parcelRequire("1sFpf");

var $a2wNz = parcelRequire("a2wNz");

var $eghTD = parcelRequire("eghTD");

var $ajYJ1 = parcelRequire("ajYJ1");

var $huQRU = parcelRequire("huQRU");

var $47CVY = parcelRequire("47CVY");

var $hfeIi = parcelRequire("hfeIi");

var $hF0nU = parcelRequire("hF0nU");

var $ejDmq = parcelRequire("ejDmq");

var $9yqzH = parcelRequire("9yqzH");

var $gxVJf = parcelRequire("gxVJf");

var $c1v6Y = parcelRequire("c1v6Y");

var $bZEI9 = parcelRequire("bZEI9");

var $1EihZ = parcelRequire("1EihZ");

var $2IdR0 = parcelRequire("2IdR0");

var $cZPPs = parcelRequire("cZPPs");

var $frUin = parcelRequire("frUin");

var $difFp = parcelRequire("difFp");

var $dH2Tp = parcelRequire("dH2Tp");

var $6xRe5 = parcelRequire("6xRe5");

var $5eLaE = parcelRequire("5eLaE");

var $gnGkU = parcelRequire("gnGkU");

var $c74Xp = parcelRequire("c74Xp");

var $4Zw1h = parcelRequire("4Zw1h");

var $iLmKH = parcelRequire("iLmKH");

var $dqjth = parcelRequire("dqjth");

var $2fNbh = parcelRequire("2fNbh");

var $56moC = parcelRequire("56moC");

var $hfMX7 = parcelRequire("hfMX7");

var $1zhx7 = parcelRequire("1zhx7");

var $dxMNj = parcelRequire("dxMNj");

var $eTL4x = parcelRequire("eTL4x");

var $3av4N = parcelRequire("3av4N");

var $hwgIz = parcelRequire("hwgIz");

var $3ss0y = parcelRequire("3ss0y");

var $bNtXI = parcelRequire("bNtXI");

var $aNsRz = parcelRequire("aNsRz");

var $cmvi5 = parcelRequire("cmvi5");

var $8fgeg = parcelRequire("8fgeg");

var $f7gaE = parcelRequire("f7gaE");

var $pRrpu = parcelRequire("pRrpu");

var $cmIyb = parcelRequire("cmIyb");

var $fQyGL = parcelRequire("fQyGL");

var $ifEj3 = parcelRequire("ifEj3");

var $4CGuj = parcelRequire("4CGuj");

var $6VvYi = parcelRequire("6VvYi");

var $dSrOC = parcelRequire("dSrOC");

var $dTkCg = parcelRequire("dTkCg");

var $hs0Ni = parcelRequire("hs0Ni");

var $8m0RN = parcelRequire("8m0RN");

var $dt3ZS = parcelRequire("dt3ZS");

var $i27Sx = parcelRequire("i27Sx");

var $qjJTn = parcelRequire("qjJTn");

var $5xt55 = parcelRequire("5xt55");

var $GJOha = parcelRequire("GJOha");

var $hDU7Y = parcelRequire("hDU7Y");

var $dHqTd = parcelRequire("dHqTd");

var $9KhdI = parcelRequire("9KhdI");

var $7LUIt = parcelRequire("7LUIt");

var $3EMmS = parcelRequire("3EMmS");

var $q3duL = parcelRequire("q3duL");

var $4Ykyz = parcelRequire("4Ykyz");

var $dYoht = parcelRequire("dYoht");

var $75Ues = parcelRequire("75Ues");

var $4Yh3B = parcelRequire("4Yh3B");

var $4iFpq = parcelRequire("4iFpq");

var $kvJxs = parcelRequire("kvJxs");

var $kxvlX = parcelRequire("kxvlX");

var $0e4yJ = parcelRequire("0e4yJ");

var $4mhUQ = parcelRequire("4mhUQ");

var $lcAQi = parcelRequire("lcAQi");

var $68ycU = parcelRequire("68ycU");

var $4BuRo = parcelRequire("4BuRo");

var $6SWMv = parcelRequire("6SWMv");

var $jFY66 = parcelRequire("jFY66");

var $jPXYO = parcelRequire("jPXYO");

var $ktYro = parcelRequire("ktYro");

var $5H5Rm = parcelRequire("5H5Rm");

var $jAB8i = parcelRequire("jAB8i");

var $5KvQp = parcelRequire("5KvQp");

var $3Yng9 = parcelRequire("3Yng9");

var $2B61u = parcelRequire("2B61u");

var $e04XT = parcelRequire("e04XT");

var $hGFnn = parcelRequire("hGFnn");

var $iTGOF = parcelRequire("iTGOF");

var $adI0E = parcelRequire("adI0E");

var $dQtRM = parcelRequire("dQtRM");

var $iDxTp = parcelRequire("iDxTp");

var $bAN0d = parcelRequire("bAN0d");

var $cLm5J = parcelRequire("cLm5J");

var $dbAmH = parcelRequire("dbAmH");

var $4Xzif = parcelRequire("4Xzif");

var $7mf3n = parcelRequire("7mf3n");

var $jPcas = parcelRequire("jPcas");

var $k7VEf = parcelRequire("k7VEf");

var $4yINJ = parcelRequire("4yINJ");

var $bubms = parcelRequire("bubms");

var $fOrUU = parcelRequire("fOrUU");

var $g6Mf9 = parcelRequire("g6Mf9");

var $V3Ey7 = parcelRequire("V3Ey7");

var $01Za6 = parcelRequire("01Za6");

var $5fBQK = parcelRequire("5fBQK");

var $hxYI0 = parcelRequire("hxYI0");

var $dzSy7 = parcelRequire("dzSy7");

var $eKguf = parcelRequire("eKguf");

var $7vXQn = parcelRequire("7vXQn");

var $kCn5T = parcelRequire("kCn5T");

var $90Rrp = parcelRequire("90Rrp");

var $86qmt = parcelRequire("86qmt");

var $hxK6L = parcelRequire("hxK6L");

var $9jp5b = parcelRequire("9jp5b");

var $427L2 = parcelRequire("427L2");

var $6pwY1 = parcelRequire("6pwY1");

var $9sgxL = parcelRequire("9sgxL");

var $8wIny = parcelRequire("8wIny");

var $2krv1 = parcelRequire("2krv1");

var $alZMU = parcelRequire("alZMU");

var $6u3qv = parcelRequire("6u3qv");

var $j2SDi = parcelRequire("j2SDi");

var $e48vl = parcelRequire("e48vl");

var $jSJ1v = parcelRequire("jSJ1v");

var $lpcHT = parcelRequire("lpcHT");

var $fdHNd = parcelRequire("fdHNd");

var $1BQG3 = parcelRequire("1BQG3");

var $guURi = parcelRequire("guURi");

var $6RCDC = parcelRequire("6RCDC");

var $lCetQ = parcelRequire("lCetQ");

var $avQ9D = parcelRequire("avQ9D");

var $f7vKZ = parcelRequire("f7vKZ");

var $k826a = parcelRequire("k826a");

var $9aEQn = parcelRequire("9aEQn");

var $gZQLD = parcelRequire("gZQLD");

var $kzcqd = parcelRequire("kzcqd");

var $9yhVv = parcelRequire("9yhVv");

var $lDuCa = parcelRequire("lDuCa");

var $duVOn = parcelRequire("duVOn");

var $lVyEk = parcelRequire("lVyEk");

var $h82Z7 = parcelRequire("h82Z7");

var $9qXuz = parcelRequire("9qXuz");

var $9MSQj = parcelRequire("9MSQj");

var $3HGg1 = parcelRequire("3HGg1");

var $hkNW0 = parcelRequire("hkNW0");

var $1B0QU = parcelRequire("1B0QU");

var $6HuHg = parcelRequire("6HuHg");

var $4nXyN = parcelRequire("4nXyN");

var $jrl3R = parcelRequire("jrl3R");

var $3B53X = parcelRequire("3B53X");

var $glkO2 = parcelRequire("glkO2");

var $04Vlk = parcelRequire("04Vlk");

var $flsjf = parcelRequire("flsjf");

var $4Aamz = parcelRequire("4Aamz");

var $1hbMK = parcelRequire("1hbMK");

var $c2KPY = parcelRequire("c2KPY");

var $ghGCX = parcelRequire("ghGCX");

var $7MpwB = parcelRequire("7MpwB");

var $lLZ8x = parcelRequire("lLZ8x");

var $g5rwu = parcelRequire("g5rwu");

var $1XAMa = parcelRequire("1XAMa");

var $1kSIj = parcelRequire("1kSIj");

var $dBV2a = parcelRequire("dBV2a");

var $ickyX = parcelRequire("ickyX");

var $cQer4 = parcelRequire("cQer4");

var $eL5iv = parcelRequire("eL5iv");

var $7MlOX = parcelRequire("7MlOX");

var $jK6bT = parcelRequire("jK6bT");

var $hvbE3 = parcelRequire("hvbE3");

var $glwG4 = parcelRequire("glwG4");

var $lcFGc = parcelRequire("lcFGc");

var $056cU = parcelRequire("056cU");

var $6p9ik = parcelRequire("6p9ik");

var $SvIen = parcelRequire("SvIen");

var $frn0U = parcelRequire("frn0U");

var $fH16o = parcelRequire("fH16o");

var $5YggO = parcelRequire("5YggO");

var $g3kqr = parcelRequire("g3kqr");

var $d4tTc = parcelRequire("d4tTc");

var $lPLcB = parcelRequire("lPLcB");

var $3L1EU = parcelRequire("3L1EU");

var $g5olQ = parcelRequire("g5olQ");

var $ecUH3 = parcelRequire("ecUH3");

var $6okEU = parcelRequire("6okEU");

var $9YDUs = parcelRequire("9YDUs");

var $gAq9g = parcelRequire("gAq9g");

var $64Fhf = parcelRequire("64Fhf");

var $h3JFI = parcelRequire("h3JFI");

var $tdrXl = parcelRequire("tdrXl");

var $5EloX = parcelRequire("5EloX");

var $7p4oW = parcelRequire("7p4oW");

var $GIsnE = parcelRequire("GIsnE");

var $MSc9t = parcelRequire("MSc9t");

var $bpbCg = parcelRequire("bpbCg");

var $5X0aC = parcelRequire("5X0aC");

var $fkWQj = parcelRequire("fkWQj");

var $7NO6v = parcelRequire("7NO6v");

var $gtJvE = parcelRequire("gtJvE");

var $hMqu9 = parcelRequire("hMqu9");

var $7YRoH = parcelRequire("7YRoH");

var $i0b8q = parcelRequire("i0b8q");

var $jKCJe = parcelRequire("jKCJe");

var $iJIU8 = parcelRequire("iJIU8");

var $d6K18 = parcelRequire("d6K18");

var $lIfPP = parcelRequire("lIfPP");

var $1rMUU = parcelRequire("1rMUU");

var $36qRE = parcelRequire("36qRE");

var $2LfmF = parcelRequire("2LfmF");

var $gzdNI = parcelRequire("gzdNI");

var $64qpc = parcelRequire("64qpc");

var $87aC7 = parcelRequire("87aC7");

var $hPrN5 = parcelRequire("hPrN5");

var $kKEWZ = parcelRequire("kKEWZ");

var $ljItG = parcelRequire("ljItG");

var $6JQwt = parcelRequire("6JQwt");

var $dRm2C = parcelRequire("dRm2C");

var $1Ps9S = parcelRequire("1Ps9S");

var $bRRmd = parcelRequire("bRRmd");

var $52RSm = parcelRequire("52RSm");

var $jr7ke = parcelRequire("jr7ke");

var $gtcNN = parcelRequire("gtcNN");

var $gMkpP = parcelRequire("gMkpP");

var $6mo9H = parcelRequire("6mo9H");

var $cJoBA = parcelRequire("cJoBA");

var $SBgrM = parcelRequire("SBgrM");

var $7kGnZ = parcelRequire("7kGnZ");

var $6fdEz = parcelRequire("6fdEz");

var $8WMR9 = parcelRequire("8WMR9");

var $hSl7U = parcelRequire("hSl7U");

var $9F4ID = parcelRequire("9F4ID");

var $9CT95 = parcelRequire("9CT95");

var $gktyQ = parcelRequire("gktyQ");

var $elyxq = parcelRequire("elyxq");

var $3T2Ye = parcelRequire("3T2Ye");

var $cVgRQ = parcelRequire("cVgRQ");

var $8XfJX = parcelRequire("8XfJX");

var $5o5UE = parcelRequire("5o5UE");

var $2OBp2 = parcelRequire("2OBp2");

var $29XA4 = parcelRequire("29XA4");

var $aNc7A = parcelRequire("aNc7A");

var $4e4nJ = parcelRequire("4e4nJ");

var $5nU8P = parcelRequire("5nU8P");

var $kHVIE = parcelRequire("kHVIE");

var $eHeAh = parcelRequire("eHeAh");

var $9R3is = parcelRequire("9R3is");

var $lKkaY = parcelRequire("lKkaY");

var $brWuf = parcelRequire("brWuf");

var $iXsus = parcelRequire("iXsus");

var $xwXfC = parcelRequire("xwXfC");

var $3lpLH = parcelRequire("3lpLH");

var $kNZj9 = parcelRequire("kNZj9");

var $aw22a = parcelRequire("aw22a");

var $yVbxa = parcelRequire("yVbxa");

var $dCGUp = parcelRequire("dCGUp");

var $4KLVz = parcelRequire("4KLVz");

var $j0BAb = parcelRequire("j0BAb");

var $lqego = parcelRequire("lqego");

var $awOZa = parcelRequire("awOZa");

var $eoIQt = parcelRequire("eoIQt");

var $kTgg2 = parcelRequire("kTgg2");

var $agsO7 = parcelRequire("agsO7");

var $9y8sW = parcelRequire("9y8sW");

var $825dq = parcelRequire("825dq");

var $h8swE = parcelRequire("h8swE");

var $gGQIR = parcelRequire("gGQIR");

var $01hnS = parcelRequire("01hnS");

var $8jDeK = parcelRequire("8jDeK");

var $64Uyh = parcelRequire("64Uyh");

var $1T4J3 = parcelRequire("1T4J3");

var $8hATp = parcelRequire("8hATp");

var $lrPAp = parcelRequire("lrPAp");

var $ZVu1m = parcelRequire("ZVu1m");

var $l1PfI = parcelRequire("l1PfI");

var $iuWOh = parcelRequire("iuWOh");

var $cvYE5 = parcelRequire("cvYE5");

var $2cpS3 = parcelRequire("2cpS3");

var $c0JOH = parcelRequire("c0JOH");

var $iYfXI = parcelRequire("iYfXI");

var $dAmDY = parcelRequire("dAmDY");

var $3MI0Z = parcelRequire("3MI0Z");

var $8brgy = parcelRequire("8brgy");

var $3kqBW = parcelRequire("3kqBW");

var $79qCU = parcelRequire("79qCU");

var $lYzgn = parcelRequire("lYzgn");

var $6YHWn = parcelRequire("6YHWn");

var $aAIWh = parcelRequire("aAIWh");

var $5fOtJ = parcelRequire("5fOtJ");

var $gfz2f = parcelRequire("gfz2f");

var $gfW60 = parcelRequire("gfW60");

var $h51Kg = parcelRequire("h51Kg");

var $rsO8k = parcelRequire("rsO8k");

var $5JkxV = parcelRequire("5JkxV");

var $jIBei = parcelRequire("jIBei");

var $3oSi6 = parcelRequire("3oSi6");

var $96BnX = parcelRequire("96BnX");

var $fP1EY = parcelRequire("fP1EY");

var $lzLcy = parcelRequire("lzLcy");

var $kZgpC = parcelRequire("kZgpC");

var $auP5Z = parcelRequire("auP5Z");

var $6un8I = parcelRequire("6un8I");

var $c97hk = parcelRequire("c97hk");

var $7sSEm = parcelRequire("7sSEm");

var $eaXgt = parcelRequire("eaXgt");

var $moUwl = parcelRequire("moUwl");

var $7D3Yv = parcelRequire("7D3Yv");

var $dgneZ = parcelRequire("dgneZ");

var $hRN7l = parcelRequire("hRN7l");

var $cU5zd = parcelRequire("cU5zd");

var $fSktp = parcelRequire("fSktp");

var $5TKdO = parcelRequire("5TKdO");

var $4zSYf = parcelRequire("4zSYf");

var $j175z = parcelRequire("j175z");

var $gQWOR = parcelRequire("gQWOR");

var $zaQdk = parcelRequire("zaQdk");

var $4UU5H = parcelRequire("4UU5H");

var $izdjx = parcelRequire("izdjx");

var $eWSeK = parcelRequire("eWSeK");

var $16Svt = parcelRequire("16Svt");

var $7m5aN = parcelRequire("7m5aN");

var $kDimk = parcelRequire("kDimk");

var $fQCGk = parcelRequire("fQCGk");

var $1EVpW = parcelRequire("1EVpW");

var $azyVo = parcelRequire("azyVo");

var $7wXr4 = parcelRequire("7wXr4");

var $kutfD = parcelRequire("kutfD");

var $2z6Z2 = parcelRequire("2z6Z2");

var $jvZP3 = parcelRequire("jvZP3");

var $03taV = parcelRequire("03taV");

var $6KvsG = parcelRequire("6KvsG");

var $kg7GL = parcelRequire("kg7GL");

var $i0tax = parcelRequire("i0tax");

var $aviVh = parcelRequire("aviVh");

var $dl9zj = parcelRequire("dl9zj");

var $3gU47 = parcelRequire("3gU47");

var $iQsfj = parcelRequire("iQsfj");

var $8Yag1 = parcelRequire("8Yag1");

var $2toxI = parcelRequire("2toxI");

var $5xsFH = parcelRequire("5xsFH");

var $eFYGV = parcelRequire("eFYGV");

var $kxlGk = parcelRequire("kxlGk");

var $cyZLC = parcelRequire("cyZLC");

var $9EGBH = parcelRequire("9EGBH");

var $45nsl = parcelRequire("45nsl");

var $jejF3 = parcelRequire("jejF3");

var $eKEYN = parcelRequire("eKEYN");

var $fwjnc = parcelRequire("fwjnc");

var $1KC4N = parcelRequire("1KC4N");

var $7ApVe = parcelRequire("7ApVe");

var $2vUs2 = parcelRequire("2vUs2");

var $bCHhM = parcelRequire("bCHhM");

var $hjvN4 = parcelRequire("hjvN4");

var $03CAy = parcelRequire("03CAy");

var $heIfC = parcelRequire("heIfC");

var $cjFCA = parcelRequire("cjFCA");

var $hu1w9 = parcelRequire("hu1w9");

var $akFeA = parcelRequire("akFeA");

var $djlm6 = parcelRequire("djlm6");

var $3J8Cl = parcelRequire("3J8Cl");

var $bhft0 = parcelRequire("bhft0");

var $6FBN4 = parcelRequire("6FBN4");

var $1iYkP = parcelRequire("1iYkP");

var $CY8KI = parcelRequire("CY8KI");

var $3Jvzv = parcelRequire("3Jvzv");

var $kYzjv = parcelRequire("kYzjv");

var $lHzMh = parcelRequire("lHzMh");

var $711QI = parcelRequire("711QI");

var $gcVUu = parcelRequire("gcVUu");

var $dG6DF = parcelRequire("dG6DF");

var $efYyQ = parcelRequire("efYyQ");

var $kQjkp = parcelRequire("kQjkp");

var $1IhKQ = parcelRequire("1IhKQ");

var $iwgxt = parcelRequire("iwgxt");

var $e99fJ = parcelRequire("e99fJ");

var $hUUCw = parcelRequire("hUUCw");

var $knZRG = parcelRequire("knZRG");

var $7dbQR = parcelRequire("7dbQR");

var $jbAAG = parcelRequire("jbAAG");

var $58Cy7 = parcelRequire("58Cy7");

var $2XQq2 = parcelRequire("2XQq2");

var $4t69d = parcelRequire("4t69d");

var $e1cjg = parcelRequire("e1cjg");

var $4XUsE = parcelRequire("4XUsE");

var $jqbKy = parcelRequire("jqbKy");

var $e7GI8 = parcelRequire("e7GI8");

var $bbDvZ = parcelRequire("bbDvZ");

var $dR9Nr = parcelRequire("dR9Nr");

var $goreX = parcelRequire("goreX");

var $3eN7Y = parcelRequire("3eN7Y");

var $aA0rC = parcelRequire("aA0rC");

var $jss6V = parcelRequire("jss6V");

var $6B4GJ = parcelRequire("6B4GJ");

var $fMbaV = parcelRequire("fMbaV");

var $bi9fZ = parcelRequire("bi9fZ");

var $7Db7a = parcelRequire("7Db7a");

var $hjVS0 = parcelRequire("hjVS0");

var $aAF0I = parcelRequire("aAF0I");

var $4Mj46 = parcelRequire("4Mj46");

var $3I1TD = parcelRequire("3I1TD");

var $41tjC = parcelRequire("41tjC");

var $eAw5v = parcelRequire("eAw5v");

var $wwgc5 = parcelRequire("wwgc5");

var $iz3gR = parcelRequire("iz3gR");

var $icwb1 = parcelRequire("icwb1");

var $egxSq = parcelRequire("egxSq");

var $lhZGg = parcelRequire("lhZGg");

var $jr5gb = parcelRequire("jr5gb");

var $7lZOe = parcelRequire("7lZOe");

var $9rVvQ = parcelRequire("9rVvQ");

var $au6vg = parcelRequire("au6vg");

var $cLamq = parcelRequire("cLamq");

var $2vHPs = parcelRequire("2vHPs");

var $hztdR = parcelRequire("hztdR");

var $6cSNh = parcelRequire("6cSNh");

var $lIPtt = parcelRequire("lIPtt");

var $cWKD0 = parcelRequire("cWKD0");

var $d0eOH = parcelRequire("d0eOH");

var $bxg3m = parcelRequire("bxg3m");

var $e6Vbw = parcelRequire("e6Vbw");

var $7LwJB = parcelRequire("7LwJB");

var $66HfJ = parcelRequire("66HfJ");

var $aDZxG = parcelRequire("aDZxG");

var $anDMO = parcelRequire("anDMO");

var $dYbYB = parcelRequire("dYbYB");

var $ffFBX = parcelRequire("ffFBX");

var $1IKX7 = parcelRequire("1IKX7");

var $1K27j = parcelRequire("1K27j");

var $8DQ40 = parcelRequire("8DQ40");

var $hdWS0 = parcelRequire("hdWS0");

var $9MTKv = parcelRequire("9MTKv");

var $d2uL5 = parcelRequire("d2uL5");

var $2ubrr = parcelRequire("2ubrr");

var $d7mi1 = parcelRequire("d7mi1");

var $5HfC7 = parcelRequire("5HfC7");

var $7QAza = parcelRequire("7QAza");

var $5MiVl = parcelRequire("5MiVl");

var $ee5pi = parcelRequire("ee5pi");

var $3SReJ = parcelRequire("3SReJ");

var $aLuho = parcelRequire("aLuho");

var $3YX4q = parcelRequire("3YX4q");

var $kEFGH = parcelRequire("kEFGH");

var $kwWQ0 = parcelRequire("kwWQ0");

var $7F7I9 = parcelRequire("7F7I9");

var $2OQWG = parcelRequire("2OQWG");

var $4eRSO = parcelRequire("4eRSO");

var $b9Dpn = parcelRequire("b9Dpn");

var $eitw0 = parcelRequire("eitw0");

var $14ooS = parcelRequire("14ooS");

var $lWR9T = parcelRequire("lWR9T");

var $6DlqX = parcelRequire("6DlqX");

var $jCfr4 = parcelRequire("jCfr4");

var $kRn5i = parcelRequire("kRn5i");

var $3NIY8 = parcelRequire("3NIY8");

var $fjYA2 = parcelRequire("fjYA2");

var $qdq3O = parcelRequire("qdq3O");

var $aY70k = parcelRequire("aY70k");

var $2wF9u = parcelRequire("2wF9u");

var $feDOq = parcelRequire("feDOq");

var $cqk4B = parcelRequire("cqk4B");

var $d66ag = parcelRequire("d66ag");

var $84EwA = parcelRequire("84EwA");

var $7dYbE = parcelRequire("7dYbE");

var $ghTLp = parcelRequire("ghTLp");

var $jjqkz = parcelRequire("jjqkz");

var $7xqQs = parcelRequire("7xqQs");

var $peO7W = parcelRequire("peO7W");

var $f1JiD = parcelRequire("f1JiD");

var $138gn = parcelRequire("138gn");

var $fCX78 = parcelRequire("fCX78");

var $6NqDk = parcelRequire("6NqDk");

var $hWZAC = parcelRequire("hWZAC");

var $2kXpo = parcelRequire("2kXpo");

var $fhlje = parcelRequire("fhlje");

var $8to5X = parcelRequire("8to5X");

var $7B6VF = parcelRequire("7B6VF");

var $dyGLN = parcelRequire("dyGLN");

var $gwCoT = parcelRequire("gwCoT");

var $bbdey = parcelRequire("bbdey");

var $drVWM = parcelRequire("drVWM");

var $t2WaR = parcelRequire("t2WaR");

var $72XXS = parcelRequire("72XXS");

var $yVmHw = parcelRequire("yVmHw");

var $ljDIh = parcelRequire("ljDIh");

var $lAnjX = parcelRequire("lAnjX");

var $cONlw = parcelRequire("cONlw");

var $28AFT = parcelRequire("28AFT");

var $gsEXA = parcelRequire("gsEXA");

var $g3Gvc = parcelRequire("g3Gvc");

var $dseRA = parcelRequire("dseRA");

var $627LR = parcelRequire("627LR");

var $3wbIE = parcelRequire("3wbIE");

var $1XqXD = parcelRequire("1XqXD");

var $dDzIU = parcelRequire("dDzIU");

var $1aB8Z = parcelRequire("1aB8Z");

var $3M4hq = parcelRequire("3M4hq");

var $a2PeW = parcelRequire("a2PeW");

var $gXApH = parcelRequire("gXApH");

var $amBHA = parcelRequire("amBHA");

var $6agOS = parcelRequire("6agOS");

var $7fwfr = parcelRequire("7fwfr");

var $gUdrp = parcelRequire("gUdrp");

var $bERWs = parcelRequire("bERWs");

var $80PF8 = parcelRequire("80PF8");

var $2r2Gu = parcelRequire("2r2Gu");

var $hRMW9 = parcelRequire("hRMW9");

var $9eiXm = parcelRequire("9eiXm");

var $D5QBq = parcelRequire("D5QBq");

var $4eKYR = parcelRequire("4eKYR");

var $5W0wg = parcelRequire("5W0wg");

var $aQ85T = parcelRequire("aQ85T");

var $6kvQ5 = parcelRequire("6kvQ5");

var $bCnWj = parcelRequire("bCnWj");

var $kci7Q = parcelRequire("kci7Q");

var $9Dd5o = parcelRequire("9Dd5o");

var $h4Pr8 = parcelRequire("h4Pr8");

var $5XbrB = parcelRequire("5XbrB");

var $1ods3 = parcelRequire("1ods3");

var $gpVZm = parcelRequire("gpVZm");

var $i8buc = parcelRequire("i8buc");

var $hqIff = parcelRequire("hqIff");

var $1Y5eu = parcelRequire("1Y5eu");

var $kkXdG = parcelRequire("kkXdG");

var $gPxpf = parcelRequire("gPxpf");

var $3FG4O = parcelRequire("3FG4O");

var $bl8cB = parcelRequire("bl8cB");

var $fLbia = parcelRequire("fLbia");

var $ceMKm = parcelRequire("ceMKm");

var $UuOK7 = parcelRequire("UuOK7");

var $eAlzO = parcelRequire("eAlzO");

var $3KtPD = parcelRequire("3KtPD");

var $h3WYk = parcelRequire("h3WYk");

var $gjuAo = parcelRequire("gjuAo");

var $9z1Wd = parcelRequire("9z1Wd");

var $6fHM1 = parcelRequire("6fHM1");

var $1GAqb = parcelRequire("1GAqb");

var $2ytxj = parcelRequire("2ytxj");

var $7PtTb = parcelRequire("7PtTb");

var $8E1dI = parcelRequire("8E1dI");

var $2yO8h = parcelRequire("2yO8h");

var $fEAJ2 = parcelRequire("fEAJ2");

var $18W8Q = parcelRequire("18W8Q");

var $4VMm4 = parcelRequire("4VMm4");

var $bFlFq = parcelRequire("bFlFq");

var $eyDhF = parcelRequire("eyDhF");

var $lkwO5 = parcelRequire("lkwO5");

var $3Ro2a = parcelRequire("3Ro2a");
const $ef6e862e848d08e0$export$10439de9ce871f28 = ()=>[
        (0, $c74Xp.connectGeneralServiceDeskProjectRouteEntry),
        (0, $gnGkU.connectGeneralRouteEntry),
        (0, $5eLaE.connectGeneralInvalidRouteEntry),
        (0, $4Zw1h.connectProjectRouteEntry),
        (0, $hxYI0.forgeAdminSettingsRouteEntry),
        (0, $5fBQK.forgeAdminRouteEntry),
        (0, $kCn5T.forgeProjectRouteEntry),
        (0, $90Rrp.forgeProjectServicedeskRouteEntry),
        (0, $86qmt.forgeServicedeskQueueRouteEntry),
        (0, $dzSy7.forgeFieldContextualConfigurationRouteEntry),
        (0, $eKguf.forgeGlobalRouteEntry),
        (0, $7vXQn.forgePersonalSettingsRouteEntry),
        (0, $3I1TD.softwareViewNotFoundRouteEntry),
        (0, $41tjC.softwareViewNotFoundClassicRouteEntry),
        (0, $eAw5v.softwareBoardViewNotFoundRouteEntry),
        (0, $wwgc5.softwareBoardViewNotFoundClassicRouteEntry),
        (0, $azyVo.softwareBoardEmbedRouteEntry),
        (0, $7wXr4.softwareBoardRouteEntry),
        (0, $fQCGk.softwareBacklogEmbedRouteEntry),
        (0, $1EVpW.softwareBacklogRouteEntry),
        (0, $03taV.softwareFormBuilderRouteEntry),
        (0, $6KvsG.softwareFormRouteEntry),
        (0, $i0tax.softwareFormSubmitRouteEntry),
        (0, $kg7GL.softwareFormSubmitEmbedRouteEntry),
        (0, $aviVh.softwareFormSubmitPublicRouteEntry),
        (0, $dl9zj.softwareGoalsRouteEntry),
        (0, $cQer4.softwareReportsBurnupRouteEntry),
        (0, $lcFGc.softwareReportsVelocityRouteEntry),
        (0, $8E1dI.cmpVelocityRouteEntry),
        (0, $7MlOX.softwareReportsCumulativeRouteEntry),
        (0, $ickyX.softwareReportsBurndownRouteEntry),
        (0, $jK6bT.softwareReportsCycleTimeRouteEntry),
        (0, $hvbE3.softwareReportsDeploymentFrequencyRouteEntry),
        (0, $eL5iv.softwareReportsControlRouteEntry),
        (0, $glwG4.softwareReportsRouteEntry),
        (0, $dBV2a.softwareNextgenRedirectRouteEntry),
        (0, $1kSIj.softwareCodeRouteEntry),
        (0, $cyZLC.softwareSecurityNextGenRouteEntry),
        (0, $45nsl.softwareSummaryEmbedRouteEntry),
        (0, $9EGBH.softwareSummaryRouteEntry),
        (0, $jvZP3.softwareDeploymentsNextGenRouteEntry),
        (0, $eFYGV.softwarePeriscopeNextGenRouteEntry),
        (0, $eKEYN.softwareVersionDetailEmbedRouteEntry),
        (0, $7ApVe.softwareVersionDetailRouteEntry),
        (0, $1KC4N.softwareVersionDetailNoTabPathRedirectRouteEntry),
        (0, $fwjnc.softwareVersionDetailLegacyRedirectRouteEntry),
        (0, $jejF3.softwareTimelineRouteEntry),
        (0, $kxlGk.softwareRoadmapRouteEntry),
        (0, $kutfD.softwareCalendarEmbedRouteEntry),
        (0, $2z6Z2.softwareCalendarRouteEntry),
        (0, $8Yag1.softwareListEmbedRouteEntry),
        (0, $2toxI.softwareListRouteEntry),
        (0, $056cU.softwareRoadmapRedirectRouteEntry),
        (0, $9MSQj.softwareIncidentsNextGenRouteEntry),
        (0, $7PtTb.softwareStaffingRouteEntry),
        (0, $3L1EU.polarisCollectionsRouteEntry),
        (0, $g5olQ.polarisIdeasRouteEntry),
        (0, $ecUH3.polarisOnboardingRouteEntry),
        (0, $6okEU.polarisSettingsAccessRouteEntry),
        (0, $9YDUs.polarisSettingsGlobalFieldsRouteEntry),
        (0, $64Fhf.polarisSettingsFinancialYearRouteEntry),
        (0, $gAq9g.polarisSettingsEarlyAccessFeaturesRouteEntry),
        (0, $h3JFI.polarisUnlicensedRouteEntry),
        (0, $5xsFH.softwareOnboardingRouteEntry),
        (0, $03CAy.softwareRoadmapClassicRouteEntry),
        (0, $heIfC.softwareTimelineClassicRouteEntry),
        (0, $cjFCA.classicSoftwareBoardSettingsRouteEntry),
        (0, $hu1w9.classicSoftwareBoardSettingsInsightsRapidboardBacklogRouteEntry),
        (0, $akFeA.classicSoftwareBoardSettingsInsightsRapidboardBoardRouteEntry),
        (0, $djlm6.softwareCalendarClassicEmbedRouteEntry),
        (0, $3J8Cl.softwareCalendarClassicRouteEntry),
        (0, $bhft0.softwareListEmbedClassicRouteEntry),
        (0, $6FBN4.softwareListClassicRouteEntry),
        (0, $jbAAG.softwareReportsDeploymentFrequencyClassicBoardRouteEntry),
        (0, $lHzMh.softwareReportsCycleTimeClassicBoardRouteEntry),
        (0, $1iYkP.rapidboardReportRouteEntry),
        (0, $kYzjv.softwareReportsCycleTimeClassicRouteEntry),
        (0, $CY8KI.softwareReportsOverviewRouteEntry),
        (0, $3Jvzv.softwareReportsOverviewBoardlessRouteEntry),
        (0, $711QI.softwareFormBuilderClassicRouteEntry),
        (0, $gcVUu.softwareFormSubmitClassicRouteEntry),
        (0, $dG6DF.softwareFormSubmitEmbedClassicRouteEntry),
        (0, $efYyQ.softwareFormSubmitClassicPublicRouteEntry),
        (0, $kQjkp.softwareFormClassicRouteEntry),
        (0, $1IhKQ.softwareGoalsClassicRouteEntry),
        (0, $e99fJ.softwareSummaryEmbedClassicRouteEntry),
        (0, $iwgxt.softwareSummaryClassicRouteEntry),
        (0, $hUUCw.softwareClassicProformaIssueFormsDirectRouteEntry),
        (0, $knZRG.softwareClassicProformaIssueFormsDirectEmbedRouteEntry),
        (0, $7dbQR.softwareReportsDeploymentFrequencyClassicRouteEntry),
        (0, $2XQq2.classicSoftwareBacklogEmbedRouteEntry),
        (0, $58Cy7.classicSoftwareBacklogRouteEntry),
        (0, $e1cjg.classicSoftwareBoardEmbedRouteEntry),
        (0, $4t69d.classicSoftwareBoardRouteEntry),
        (0, $4XUsE.rapidboardUserBacklogRouteEntry),
        (0, $jqbKy.userBoardVelocityRouteEntry),
        (0, $bbDvZ.rapidboardUserReportRouteEntry),
        (0, $3eN7Y.userBoardViewNotFoundRouteEntry),
        (0, $dR9Nr.userBoardRouteEntry),
        (0, $e7GI8.rapidboardUserReportsOverviewRouteEntry),
        (0, $goreX.userBoardSettingsRouteEntry),
        (0, $aA0rC.rapidboardBacklog1RouteEntry),
        (0, $jss6V.rapidboardReport1RouteEntry),
        (0, $iz3gR.legacyRapidBoardRouteEntry),
        (0, $6B4GJ.softwareCodeClassicRouteEntry),
        (0, $fMbaV.softwareSecurityClassicRouteEntry),
        (0, $bi9fZ.softwareDeploymentsClassicRouteEntry),
        (0, $7Db7a.softwarePeriscopeClassicRouteEntry),
        (0, $hjVS0.rapidboardLastVisitedProjectRedirectRouteEntry),
        (0, $aAF0I.projectDirectoryRedirectRouteEntry),
        (0, $4Mj46.softwareIncidentsClassicRouteEntry),
        (0, $3gU47.softwareInboxNextGenRouteEntry),
        (0, $iQsfj.softwareInboxClassicRouteEntry),
        /*
	 *************************************************** ATTENTION PROJECT SETTINGS ROUTES ***************************************************
	 * Take special care with any redirect components you render. For legacy routes they should redirect to the legacy URL,
	 * and for product routes the should redirect to the product URL.
	 */ (0, $kRn5i.projectSettingsSoftwareIssuetypesRouteEntry),
        (0, $3NIY8.projectSettingsSoftwareIssuetypesWorkflowRouteEntry),
        (0, $3YX4q.projectSettingsSoftwareAppsFieldsRouteEntry),
        (0, $kEFGH.projectSettingsSoftwareAppsRouteEntry),
        (0, $6DlqX.projectSettingsSoftwareDetailsRouteEntry),
        (0, $jCfr4.projectSettingsSoftwareFieldsRouteEntry),
        (0, $aLuho.projectSettingsSoftwareAccessRouteEntry),
        (0, $3SReJ.projectSettingsSoftwareAccessRedirectRouteEntry),
        (0, $d66ag.projectSettingsSoftwareProformaProjectFormsRouteEntry),
        (0, $cqk4B.projectSettingsSoftwareProformaJiraFormBuilderRouteEntry),
        (0, $5HfC7.projectSettingsAutomationRouteEntry),
        (0, $lWR9T.projectSettingsSoftwareDataClassificationsRouteEntry),
        (0, $anDMO.classicProjectSettingsDetailsRouteEntry),
        (0, $fjYA2.projectSettingsSoftwareNextGenFeaturesRouteEntry),
        (0, $feDOq.projectSettingsSoftwareNotificationsRouteEntry),
        (0, $2wF9u.projectSettingsSoftwareNotificationsIssueLogsRouteEntry),
        (0, $ee5pi.projectSettingsOpsgenieRouteEntry),
        (0, $ffFBX.classicProjectSettingsOpsgenieRouteEntry),
        (0, $7dYbE.projectSettingsToolchainRouteEntry),
        (0, $9MTKv.classicProjectSettingsToolchainRouteEntry),
        (0, $dYbYB.classicProjectSettingsFeaturesRouteEntry),
        (0, $1IKX7.classicProjectSettingsSoftwareNotificationsIssueLogsRouteEntry),
        (0, $qdq3O.projectSettingsSoftwareNotificationEmailCRouteEntry),
        (0, $aY70k.projectSettingsSoftwareNotificationEmailRouteEntry),
        (0, $2ubrr.legacyProjectReleasesNoteRouteEntry),
        (0, $d2uL5.legacyProjectReleasesNoteConfigRouteEntry),
        (0, $ghTLp.softwareReleaseNotesRouteEntry),
        (0, $kwWQ0.projectSettingsSoftwareAutomationRouteEntry),
        (0, $8DQ40.classicProjectSettingsSoftwareProformaFormsRouteEntry),
        (0, $1K27j.classicProjectSettingsSoftwareProformaEditFormsRouteEntry),
        (0, $b9Dpn.projectSettingsSoftwareBoardsRedirectRouteEntry),
        (0, $2OQWG.projectSettingsSoftwareBoardsCsmRouteEntry),
        (0, $4eRSO.projectSettingsSoftwareBoardsCustomFiltersRouteEntry),
        (0, $7F7I9.projectSettingsSoftwareBoardsCardRouteEntry),
        (0, $eitw0.projectSettingsSoftwareBoardsRoadmapRouteEntry),
        (0, $14ooS.projectSettingsSoftwareBoardsTimelineRouteEntry),
        (0, $d7mi1.projectSettingsAutomationCRouteEntry),
        (0, $5MiVl.projectSettingsForgeAppsRouteEntry),
        (0, $7QAza.projectSettingsForgeAppsNextgenRouteEntry),
        (0, $84EwA.projectSettingsSoftwareRedirectRouteEntry),
        (0, $hdWS0.classicProjectSettingsSoftwareRedirectRouteEntry),
        (0, $jjqkz.projectSettingsServicedeskClassicAppsRouteEntry),
        (0, $f1JiD.projectSettingsServicedeskIssuetypesRouteEntry),
        (0, $138gn.projectSettingsServicedeskIssuetypesWorkflowRouteEntry),
        (0, $peO7W.projectSettingsServicedeskFieldsRouteEntry),
        (0, $fhlje.projectSettingsServicedeskAppsFieldsRouteEntry),
        (0, $8to5X.projectSettingsServicedeskAppsRouteEntry),
        (0, $7xqQs.projectSettingsServicedeskDetailsRouteEntry),
        (0, $2kXpo.projectSettingsServicedeskAccessRouteEntry),
        (0, $hWZAC.projectSettingsServicedeskAccessRedirectRouteEntry),
        (0, $6NqDk.projectSettingsServicedeskProformaProjectFormsRouteEntry),
        (0, $fCX78.projectSettingsServicedeskProformaJiraFormBuilderRouteEntry),
        (0, $7B6VF.projectSettingsServicedeskAutomationRouteEntry),
        (0, $dyGLN.projectSettingsServicedeskDataClassificationsRouteEntry),
        (0, $hqIff.projectSettingsServicedeskKbRouteEntry),
        (0, $1Y5eu.projectSettingsServicedeskUnassignedTicketTypeFieldsRouteEntry),
        (0, $kkXdG.projectSettingsServicedeskItsmTicketTypeFieldsRouteEntry),
        (0, $gPxpf.projectSettingsServicedeskTicketTypeFieldsRouteEntry),
        (0, $3FG4O.projectSettingsServicedeskUnassignedTicketTypesConfigRouteEntry),
        (0, $bl8cB.projectSettingsServicedeskItsmTicketTypesConfigRouteEntry),
        (0, $fLbia.projectSettingsServicedeskTicketTypesConfigRouteEntry),
        (0, $hRMW9.projectSettingsServicedeskAutomationEditRuleRouteEntry),
        (0, $9eiXm.projectSettingsServicedeskAutomationCopyRuleRouteEntry),
        (0, $D5QBq.projectSettingsServicedeskAutomationCreateRouteEntry),
        (0, $4eKYR.projectSettingsServicedeskAutomationViewLogRouteEntry),
        (0, $5W0wg.projectSettingsServicedeskAutomationSummaryRouteEntry),
        (0, $aQ85T.projectSettingsServicedeskLegacyAutomationRedirectCreateRouteEntry),
        (0, $6kvQ5.projectSettingsServicedeskLegacyAutomationRedirectEditRouteEntry),
        (0, $bCnWj.projectSettingsServicedeskLegacyAutomationRedirectCopyRouteEntry),
        (0, $kci7Q.projectSettingsServicedeskLegacyAutomationRedirectViewLogRouteEntry),
        (0, $9Dd5o.projectSettingsServicedeskLegacyAutomationRedirectSummaryRouteEntry),
        (0, $h4Pr8.projectSettingsServicedeskCustomerNotificationsRouteEntry),
        (0, $5XbrB.projectSettingsServicedeskNotificationsCustomerNotificationsRouteEntry),
        (0, $ceMKm.landingPageRouteEntry),
        (0, $3KtPD.browseIntentsRouteEntry),
        (0, $6fHM1.viewIntentRouteEntry),
        (0, $h3WYk.browseStandardFlowsRouteEntry),
        (0, $1GAqb.viewStandardFlowRouteEntry),
        (0, $eAlzO.browseConversationsRouteEntry),
        (0, $9z1Wd.settingsRouteEntry),
        (0, $UuOK7.aiAnswersRouteEntry),
        (0, $gjuAo.performanceRouteEntry),
        (0, $80PF8.servicedeskPlaybooksListRouteEntry),
        (0, $2r2Gu.servicedeskPlaybooksEditRouteEntry),
        (0, $lkwO5.projectSettingsCustomerServiceFeaturesRouteEntry),
        (0, $1ods3.projectSettingsServicedeskJourneysRouteEntry),
        (0, $gpVZm.projectSettingsServicedeskJourneyConfigurationRouteEntry),
        (0, $i8buc.projectSettingsServicedeskJourneyConfigurationEditRouteEntry),
        (0, $2ytxj.servicedeskWorkflowConfigRouteEntry),
        (0, $gwCoT.projectSettingsServicedeskItsmFeaturesRouteEntry),
        (0, $bbdey.projectSettingsServicedeskNotificationsInternalNotificationsRouteEntry),
        (0, $drVWM.projectSettingsServicedeskInternalNotificationsNextGenRouteEntry),
        (0, $t2WaR.projectSettingsServicedeskNotificationsNotificationEmailRouteEntry),
        (0, $72XXS.projectSettingsServicedeskNotificationsEmailRouteEntry),
        (0, $yVmHw.projectSettingsServicedeskNotificationsRouteEntry),
        (0, $ljDIh.projectSettingsServicedeskLanguageKeyRouteEntry),
        (0, $lAnjX.projectSettingsServicedeskLanguageRouteEntry),
        (0, $cONlw.projectSettingsServicedeskChannelsPermissionsNextGenRouteEntry),
        (0, $28AFT.projectSettingsServicedeskCustomerPermissionsRouteEntry),
        (0, $gsEXA.projectSettingsServicedeskChannelsEmailNextGenRouteEntry),
        (0, $g3Gvc.projectSettingsServicedeskEmailRouteEntry),
        (0, $dseRA.projectSettingsServicedeskPortalSettingsRouteEntry),
        (0, $627LR.projectSettingsServicedeskChannelsPortalRouteEntry),
        (0, $3wbIE.projectSettingsServicedeskExternalLinksRouteEntry),
        (0, $1XqXD.projectSettingsServicedeskChannelsWidgetRouteEntry),
        (0, $dDzIU.projectSettingsServicedeskWidgetRouteEntry),
        (0, $1aB8Z.projectSettingsServicedeskChangeManagementRouteEntry),
        (0, $3M4hq.projectSettingsServicedeskIncidentManagementRouteEntry),
        (0, $a2PeW.projectSettingsServicedeskChannelsChatRouteEntry),
        (0, $gXApH.projectSettingsServicedeskChatRouteEntry),
        (0, $amBHA.projectSettingsServicedeskChannelsRouteEntry),
        (0, $6agOS.servicedeskSlaSettingsRouteEntry),
        (0, $7fwfr.projectSettingsServicedeskFeedbackRouteEntry),
        (0, $gUdrp.projectSettingsServicedeskForgeAppsRouteEntry),
        (0, $bERWs.projectSettingsServicedeskRedirectRouteEntry),
        (0, $cWKD0.projectSettingsCoreIssueTypesRouteEntry),
        (0, $6cSNh.projectSettingsCoreFieldsRouteEntry),
        (0, $d0eOH.projectSettingsCoreIssueTypesWorkflowRouteEntry),
        (0, $jr5gb.projectSettingsCoreAppsFieldsRouteEntry),
        (0, $7lZOe.projectSettingsCoreAppsRouteEntry),
        (0, $hztdR.projectSettingsCoreDetailsRouteEntry),
        (0, $egxSq.projectSettingsCoreAccessRouteEntry),
        (0, $icwb1.projectSettingsCoreAccessRedirectRouteEntry),
        (0, $aDZxG.projectSettingsCoreProformaProjectFormsRouteEntry),
        (0, $66HfJ.projectSettingsCoreProformaJiraFormBuilderRouteEntry),
        (0, $au6vg.projectSettingsCoreAutomationV2RouteEntry),
        (0, $cLamq.projectSettingsCoreDataClassificationsRouteEntry),
        (0, $9rVvQ.projectSettingsCoreAutomationRouteEntry),
        (0, $7LwJB.projectSettingsCoreNotificationsRouteEntry),
        (0, $e6Vbw.projectSettingsCoreNotificationsIssueLogsRouteEntry),
        (0, $bxg3m.projectSettingsCoreNotificationsEmailRouteEntry),
        (0, $lIPtt.projectSettingsCoreForgeAppsRouteEntry),
        (0, $lhZGg.projectSettingsCoreApprovalsRouteEntry),
        (0, $2vHPs.projectSettingsCoreDefaultRedirectRouteEntry),
        (0, $ejDmq.classicBusinessProjectViewNotFoundRouteEntry),
        (0, $2IdR0.jiraBusinessSummaryRouteEntry),
        (0, $gbj7F.jiraBusinessBoardEmbedRouteEntry),
        (0, $8gEiV.jiraBusinessBoardCustomEmbedRouteEntry),
        (0, $dhiyM.jiraBusinessBoardRouteEntry),
        (0, $21AP4.jiraBusinessCalendarEmbedRouteEntry),
        (0, $infHq.jiraBusinessCalendarRouteEntry),
        (0, $ilKWG.jiraBusinessReportsOverviewRouteEntry),
        (0, $hF0nU.classicBusinessProjectShortcutRouteEntry),
        (0, $gxVJf.jiraBusinessListRouteEntry),
        (0, $a2wNz.classicBusinessProjectFormRouteEntry),
        (0, $ajYJ1.classicBusinessProjectFormSubmitRouteEntry),
        (0, $1sFpf.classicBusinessProjectFormBuilderRouteEntry),
        (0, $huQRU.classicBusinessProjectFormSubmitPublicRouteEntry),
        (0, $frUin.jiraBusinessTimelineRouteEntry),
        (0, $6IB0N.classicBusinessProjectApprovalsRouteEntry),
        (0, $47CVY.classicBusinessProjectPagesRouteEntry),
        (0, $gm7fA.jiraBusinessAttachmentsRouteEntry),
        (0, $cZPPs.jiraBusinessTimelineEmbedRouteEntry),
        (0, $9yqzH.jiraBusinessListEmbedRouteEntry),
        (0, $eghTD.classicBusinessProjectFormSubmitEmbedRouteEntry),
        (0, $1EihZ.jiraBusinessSummaryEmbedRouteEntry),
        (0, $hfeIi.classicBusinessProjectSampleOnboardingRouteEntry),
        (0, $4KinX.classicBusinessOverviewTimelineRouteEntry),
        (0, $dUuHj.classicBusinessOverviewCalendarRouteEntry),
        (0, $eiK9n.classicBusinessOverviewSummaryRouteEntry),
        (0, $bZEI9.jiraBusinessProjectRedirectRouteEntry),
        (0, $c1v6Y.jiraBusinessOverviewRedirectRouteEntry),
        (0, $jovMq.globalSettingsIssueFieldScreensRouteEntry),
        (0, $ipR0U.globalSettingsIssueFieldSchemesRouteEntry),
        (0, $a4nP2.globalSettingsIssueTypesScreenSchemesRouteEntry),
        (0, $f6OBR.globalSettingsIssueWorkflowEditRouteEntry),
        (0, $dtLGm.globalSettingsIssueWorkflow1RouteEntry),
        (0, $2pvey.globalSettingsIssueHierarchyRouteEntry),
        (0, $laDqO.globalSettingsIssueHierarchyRedirectRouteEntry),
        (0, $lgfw1.globalSettingsIssueTypesRouteEntry),
        (0, $4x45G.globalSettingsIssueTypesSchemesRouteEntry),
        (0, $aNke7.globalSettingsContactAdministratorRouteEntry),
        (0, $hH7Cb.globalSettingsSystemUiAnnouncementBannerRouteEntry),
        (0, $4PsEV.productsJsmCustomerAccessRouteEntry),
        (0, $3rBGh.productsJsmAuthenticationSettingsRouteEntry),
        (0, $dTwSZ.globalSettingsSystemBulkMailRouteEntry),
        (0, $1mByb.globalSettingsEditPermissionSchemesRouteEntry),
        (0, $ew7DI.globalSettingsPermissionSchemesRouteEntry),
        (0, $izUuJ.globalSettingsFormDataConnectionsRouteEntry),
        (0, $jWVY2.globalSettingsIssuesNewIssueSearchRouteEntry),
        (0, $3Hflx.globalSettingsPerformanceOverviewRouteEntry),
        (0, $5BlCA.globalSettingsPerformanceMetricDetailRouteEntry),
        (0, $bUOZo.globalSettingsPerformanceProjectCleanupRouteEntry),
        (0, $ktEDA.globalSettingsPerformanceCustomFieldRouteEntry),
        (0, $caoz4.globalSettingsPerformanceIssueArchivalRouteEntry),
        (0, $bC98V.globalSettingsPerformanceProjectRoleActorRouteEntry),
        (0, $2UvYl.globalSettingsIssueFieldsManagementRouteEntry),
        (0, $gCfQs.globalSettingsIssuesPrioritiesRouteEntry),
        (0, $81ZCL.globalSettingsIssuesPrioritySchemesRouteEntry),
        (0, $4BdYV.globalSettingsGlobalPermissionsRouteEntry),
        (0, $k1TyW.systemConfigurationRouteEntry),
        (0, $h0ilo.systemConfigurationRedirectRouteEntry),
        (0, $fMVEG.externalImportRouteEntry),
        (0, $Dkaoj.emailNotificationsLogAccessRouteEntry),
        (0, $hHcn9.archivedIssuesRedirectRouteEntry),
        (0, $jq5xL.archivedIssuesJswRouteEntry),
        (0, $9HXcc.archivedIssuesJswCompanyRouteEntry),
        (0, $8zbqc.archivedIssuesJsmRouteEntry),
        (0, $4r3FF.archivedIssuesJwmRouteEntry),
        (0, $3HGg1.issueCreateEmbedRouteEntry),
        (0, $eyDhF.piCreateIssueEmbedRouteEntry),
        (0, $bFlFq.piEditIssueEmbedRouteEntry),
        (0, $glkO2.issueNavigatorProjectClassicRouteEntry),
        (0, $flsjf.issueNavigatorProjectSoftwareRouteEntry),
        (0, $04Vlk.issueNavigatorProjectServicedeskRouteEntry),
        (0, $3B53X.issueNavigatorProjectBusinessRouteEntry),
        (0, $jrl3R.issueNavigatorGlobalRouteEntry),
        (0, $4nXyN.issueNavigatorGlobalJiraRouteEntry),
        (0, $4Aamz.projectIssueNavigatorRouteEntry),
        (0, $6HuHg.globalIssueNavigatorBrowseIssueRedirectRouteEntry),
        (0, $lLZ8x.appRequestsRouteEntry),
        (0, $1XAMa.promotionsRouteEntry),
        (0, $g5rwu.findAppsRouteEntry),
        (0, $jKCJe.proformaExportRouteEntry),
        (0, $iJIU8.proformaIssueFormsGeneralRouteEntry),
        (0, $36qRE.servicedeskProformaIssueFormsDirectRouteEntry),
        (0, $1rMUU.servicedeskProformaIssueFormsDirectEmbedRouteEntry),
        (0, $lIfPP.classicBusinessProformaIssueFormsDirectRouteEntry),
        (0, $d6K18.classicBusinessProformaIssueFormsDirectEmbedRouteEntry),
        (0, $gzdNI.softwareProformaIssueFormsDirectRouteEntry),
        (0, $2LfmF.softwareProformaIssueFormsDirectEmbedRouteEntry),
        (0, $hkNW0.browseIssueEmbedRouteEntry),
        (0, $1B0QU.browseIssueRouteEntry),
        (0, $6xRe5.compassProductSettingsRouteEntry),
        (0, $1hbMK.jiraHomeRouteEntry),
        (0, $c2KPY.jiraSearchRouteEntry),
        (0, $9qXuz.homeRedirectRouteEntry),
        (0, $h82Z7.homeOnboardingRedirectRouteEntry),
        (0, $hwgIz.devopsConnectedProjectRouteEntry),
        (0, $frn0U.peopleProfilesRouteEntry),
        (0, $2vUs2.trashProjectsDirectoryRedirectRouteEntry),
        (0, $16Svt.settingsAutomationRouteEntry),
        (0, $bCHhM.trashProjectsDirectoryRouteEntry),
        (0, $eaKG5.archivedProjectsDirectoryRouteEntry),
        (0, $6VvYi.projectsDirectoryRedirectRouteEntry),
        (0, $fQyGL.projectsDirectoryLegacyPathRedirectRouteEntry),
        (0, $dSrOC.projectsDirectoryRouteEntry),
        (0, $ifEj3.projectsDirectoryManageRedirectRouteEntry),
        (0, $pRrpu.manageProjectsDirectoryRouteEntry),
        (0, $4CGuj.projectsDirectoryManageRootRedirectRouteEntry),
        (0, $dH2Tp.classicProjectSettingsIssueLayoutRouteEntry),
        (0, $difFp.classicProjectSettingsDataClassificationsRouteEntry),
        (0, $64qpc.projectComponentsRedirectRouteEntry),
        (0, $87aC7.projectComponentsRouteEntry),
        (0, $6JQwt.projectSettingsComponentsRouteEntry),
        (0, $bRRmd.projectVersionsRouteEntry),
        (0, $dqjth.createProjectRouteEntry),
        (0, $dRm2C.projectSettingsVersionsRouteEntry),
        (0, $kKEWZ.projectPagesLegacyRouteEntry),
        (0, $ljItG.projectPagesRouteEntry),
        (0, $52RSm.rovoDemandTestsRouteEntry),
        (0, $6p9ik.opsgenieScheduleRedirectRouteEntry),
        (0, $SvIen.opsgenieScheduleRouteEntry),
        (0, $2fNbh.dashboardEditRouteEntry),
        (0, $dxMNj.dashboardWallboardRouteEntry),
        (0, $1zhx7.dashboardViewRouteEntry),
        (0, $hfMX7.dashboardViewEmbedRouteEntry),
        (0, $aNsRz.dashboardsDirectoryRedirectRouteEntry),
        (0, $cmvi5.dashboardsDirectoryRouteEntry),
        (0, $3ss0y.boardsDirectoryRedirectRouteEntry),
        (0, $bNtXI.boardsDirectoryRouteEntry),
        (0, $8fgeg.filtersDirectoryRedirectRouteEntry),
        (0, $f7gaE.filtersDirectoryRouteEntry),
        (0, $dTkCg.secureFiltersDirectoryRedirectRouteEntry),
        (0, $lPLcB.personalSettingsRouteEntry),
        (0, $fH16o.generalPersonalSettingsRouteEntry),
        (0, $5YggO.notificationsPersonalSettingsRouteEntry),
        (0, $d4tTc.digestsNotificationsPersonalSettingsRouteEntry),
        (0, $g3kqr.opsNotificationsPersonalSettingsRouteEntry),
        (0, $aw22a.customerServiceEscalationsRouteEntry),
        (0, $yVbxa.customerServiceProductsRouteEntry),
        (0, $vDjHk.archivedPlansRouteEntry),
        (0, $hDCtq.trashPlansRouteEntry),
        (0, $7UDCM.trashedPlanDirectLinkRouteEntry),
        (0, $jZMnM.arjSettingsFinancialYearPageRouteEntry),
        (0, $5nA0V.planIncrementRouteEntry),
        (0, $bQ0RK.planIncrementsRouteEntry),
        (0, $9jp5b.globalSettingsCustomFieldsRouteEntry),
        (0, $427L2.globalSettingsIssuesExplicitFieldAssociationRouteEntry),
        (0, $7m5aN.settingsCmdbFieldConfigRouteEntry),
        (0, $kDimk.settingsOauthCredentialsRouteEntry),
        (0, $1Ps9S.projectsRedirectRouteEntry),
        (0, $igqAf.browseProjectRedirectRouteEntry),
        (0, $7YRoH.productsJswConfigurationRouteEntry),
        (0, $i0b8q.productsJswStorageManagementRouteEntry),
        (0, $hMqu9.productsJsmOrganizationsRouteEntry),
        (0, $gtJvE.productsJsmOrganizationsDetailsRouteEntry),
        (0, $7p4oW.productsJsmConfigurationRouteEntry),
        (0, $5EloX.productsJsmComplianceRouteEntry),
        (0, $7NO6v.productsJsmKbPermissionsRouteEntry),
        (0, $GIsnE.productsJsmEmailRequestsRouteEntry),
        (0, $5uMDF.productsJcsCustomerAccessRouteEntry),
        (0, $3RvJ0.productsJcsFormFieldsRouteEntry),
        (0, $fOrUU.eocTeamCustomerLogsRouteEntry),
        (0, $bubms.eocTeamCustomerLogsDownloadRouteEntry),
        (0, $GJOha.eocApiKeyManagementRouteEntry),
        (0, $hxK6L.globalMailSettingsRouteEntry),
        (0, $fkWQj.productsJsmIncidentManagementToolsRouteEntry),
        (0, $MSc9t.productsJsmFeatureUsageRouteEntry),
        (0, $64Uyh.knowledgeHubLandingRouteEntry),
        (0, $9y8sW.knowledgeHubBrowseAllArticlesRouteEntry),
        (0, $8jDeK.knowledgeHubDraftsRouteEntry),
        (0, $825dq.knowledgeHubBrowseAllCategoriesRouteEntry),
        (0, $lrPAp.knowledgeHubSuggestedArticlesRouteEntry),
        (0, $h8swE.knowledgeHubBrowseViewArticleRouteEntry),
        (0, $kTgg2.knowledgeHubArticleEmbedEditorRouteEntry),
        (0, $eoIQt.knowledgeHubAllArticlesRouteEntry),
        (0, $agsO7.knowledgeHubArticleInCategoryRouteEntry),
        (0, $gGQIR.knowledgeHubCategoryPageRouteEntry),
        (0, $01hnS.knowledgeHubCategoryRouteEntry),
        (0, $1T4J3.knowledgeHubSearchRouteEntry),
        (0, $8hATp.knowledgeHubSetupRouteEntry),
        (0, $c97hk.servicedeskReports1RouteEntry),
        (0, $lzLcy.servicedeskAtlassianAnalyticsRouteEntry),
        (0, $4zSYf.servicedeskReportsWorkloadRouteEntry),
        (0, $cU5zd.servicedeskReportsSatisfactionIssueRouteEntry),
        (0, $fSktp.servicedeskReportsSatisfactionTimeScaleRouteEntry),
        (0, $hRN7l.servicedeskReportsSatisfaction2RouteEntry),
        (0, $auP5Z.servicedeskKbRequestsReportsIssueRouteEntry),
        (0, $6un8I.servicedeskKbRequestsReportsTimeScaleRouteEntry),
        (0, $kZgpC.servicedeskKbRequestsReports2RouteEntry),
        (0, $moUwl.servicedeskReportsCustomEditRouteEntry),
        (0, $eaXgt.servicedeskReportsCustomCreateRouteEntry),
        (0, $7D3Yv.servicedeskReportsCustomIssueRouteEntry),
        (0, $dgneZ.servicedeskReportsCustomTimeScaleRouteEntry),
        (0, $7sSEm.servicedeskReportsCustom4RouteEntry),
        (0, $5TKdO.servicedeskReportsTypeRouteEntry),
        (0, $6YHWn.servicedeskIssueRouteEntry),
        (0, $3oSi6.servicedeskQueuesLandingRouteEntry),
        (0, $fP1EY.servicedeskQueuesNewRouteEntry),
        (0, $2yO8h.servicedeskQueuesViewsConfigRouteEntry),
        (0, $fEAJ2.servicedeskPracticeViewsConfigRouteEntry),
        (0, $5JkxV.servicedeskQueuesEditRouteEntry),
        (0, $3MI0Z.customPracticeQueueCalendarRouteEntry),
        (0, $dAmDY.customPracticeQueueBoardRouteEntry),
        (0, $79qCU.customQueueCalendarRouteEntry),
        (0, $3kqBW.customQueueBoardRouteEntry),
        (0, $8brgy.customQueueRouteEntry),
        (0, $lYzgn.customIssueRouteEntry),
        (0, $jIBei.servicedeskQueuesIssueRouteEntry),
        (0, $96BnX.servicedeskQueuesManageViewRouteEntry),
        (0, $rsO8k.servicedeskQueuesAddonRouteEntry),
        (0, $gfz2f.servicedeskPracticeLandingRouteEntry),
        (0, $h51Kg.servicedeskPracticeNewRouteEntry),
        (0, $gfW60.servicedeskPracticeManageViewRouteEntry),
        (0, $aAIWh.servicedeskPracticeEditRouteEntry),
        (0, $iYfXI.customPracticeQueueRouteEntry),
        (0, $5fOtJ.servicedeskPracticeIssueRouteEntry),
        (0, $6mo9H.jsmBoardRouteEntry),
        (0, $lqego.jsmGSPPageRouteEntry),
        (0, $izdjx.servicedeskServicesRouteEntry),
        (0, $j175z.servicedeskServiceDetailsRouteEntry),
        (0, $eWSeK.serviceDeskServicesWithoutProjectRouteEntry),
        (0, $gQWOR.serviceDeskServiceDetailsWithoutProjectRouteEntry),
        (0, $4UU5H.servicedeskServiceModalNewRouteEntry),
        (0, $zaQdk.servicedeskServiceModalEditRouteEntry),
        (0, $dCGUp.servicedeskCustomerDetailsRouteEntry),
        (0, $4KLVz.servicedeskCustomersV2RouteEntry),
        (0, $cvYE5.servicedeskOrganizationDetailsRouteEntry),
        (0, $2cpS3.servicedeskOrganizationsRouteEntry),
        (0, $iuWOh.servicedeskOrganizationV2RouteEntry),
        (0, $l1PfI.servicedeskOncallScheduleRouteEntry),
        (0, $SBgrM.servicedeskChangeCalendarRouteEntry),
        (0, $cJoBA.servicedeskCalendarRouteEntry),
        (0, $c0JOH.servicedeskProjectSummaryRouteEntry),
        // /jira/assets/* routes
        (0, $7kGnZ.assetsRouteEntry),
        (0, $6fdEz.assetsReportsRouteEntry),
        (0, $8WMR9.assetsReportsTemplateRouteEntry),
        (0, $hSl7U.assetsReportsUnsubscribeRouteEntry),
        (0, $9F4ID.assetsSchemaRouteEntry),
        (0, $9CT95.assetsObjectTypeConfigurationRouteEntry),
        (0, $gktyQ.assetsConfigurationRouteEntry),
        (0, $elyxq.assetsSchemaConfigurationRouteEntry),
        (0, $3T2Ye.assetsObjectRouteEntry),
        (0, $18W8Q.assetsSearchRouteEntry),
        // /jira/servicedesk/assets/* routes
        (0, $kHVIE.servicedeskCmdbAssetsSchemasRouteEntry),
        (0, $aNc7A.servicedeskCmdbAssetsReportsRouteEntry),
        (0, $4e4nJ.servicedeskCmdbAssetsReportsTemplateRouteEntry),
        (0, $5nU8P.servicedeskCmdbAssetsReportsUnsubscribeRouteEntry),
        (0, $2OBp2.servicedeskCmdbAssetsObjectSchemaRouteEntry),
        (0, $29XA4.servicedeskCmdbAssetsObjectTypeConfigurationRouteEntry),
        (0, $cVgRQ.servicedeskCmdbAssetsGlobalConfigurationRouteEntry),
        (0, $5o5UE.servicedeskCmdbAssetsObjectSchemaConfigurationRouteEntry),
        (0, $8XfJX.servicedeskCmdbAssetsObjectRouteEntry),
        // /jira/servicedesk/insight/* routes
        (0, $3lpLH.servicedeskCmdbInsightRouteEntry),
        (0, $iXsus.servicedeskCmdbInsightObjectSchemaRouteEntry),
        (0, $xwXfC.servicedeskCmdbInsightObjectTypeConfigurationRouteEntry),
        (0, $eHeAh.servicedeskCmdbInsightConfigureGlobalRouteEntry),
        (0, $brWuf.servicedeskCmdbInsightObjectSchemaConfigurationRouteEntry),
        (0, $9R3is.servicedeskCmdbInsightConfigureRouteEntry),
        (0, $lKkaY.servicedeskCmdbInsightObject4RouteEntry),
        (0, $ZVu1m.notificationLogsRouteEntry),
        (0, $iLmKH.servicedeskConnectProjectRouteEntry),
        (0, $j0BAb.projectServiceDeskRouteEntry),
        (0, $awOZa.servicedeskItsmSampleSpaceRouteEntry),
        (0, $kNZj9.servicedeskCreateProjectRouteEntry),
        (0, $9CxHM.archivedProjectDirectLinkRouteEntry),
        (0, $eTL4x.selectedDashboardRouteEntry),
        (0, $56moC.dashboardRouteEntry),
        (0, $3av4N.systemDashboardEditRouteEntry),
        (0, $cwKGx.arjSettingsDependenciesRouteEntry),
        (0, $7gypr.arjSettingsDependenciesLegacyRedirectRouteEntry),
        (0, $ieqGd.arjSettingsLoadingLimitsRouteEntry),
        (0, $dfdSu.arjSettingsLoadingLimitsLegacyRedirectRouteEntry),
        (0, $JQ5Vt.arjSettingsPermissionsRouteEntry),
        (0, $eOPb5.arjSettingsPermissionsRouteLegacyRedirectRouteEntry),
        (0, $fpGzf.arjCalendarEmbedRouteEntry),
        (0, $aVGYm.arjDependenciesEmbedRouteEntry),
        (0, $2DH60.arjIncrementEmbedRouteEntry),
        (0, $a5XVU.arjSummaryEmbedRouteEntry),
        (0, $lUhpq.arjTimelineEmbedRouteEntry),
        (0, $6cMQO.softwarePlanDependenciesRouteEntry),
        (0, $8s6qp.softwarePlanSummaryRouteEntry),
        (0, $lGnoq.softwarePlanCalendarRouteEntry),
        (0, $lxXtu.softwarePlanReleasesRouteEntry),
        (0, $4chTT.softwarePlanTimelineRouteEntry),
        (0, $l0UsI.softwarePlanSettingsPermissionsRouteEntry),
        (0, $76RJj.softwarePlanSettingsSavedViewsRouteEntry),
        (0, $bdHl5.softwarePlanSettingsPlanInfoRouteEntry),
        (0, $1oew5.softwarePlanSettingsFeaturesRouteEntry),
        (0, $5hvg3.softwarePlanSettingsProgramBoardsRouteEntry),
        (0, $g7fao.softwarePlanSettingsSchedulingRouteEntry),
        (0, $ikfu9.softwarePlanSettingsScenariosRouteEntry),
        (0, $2l6sh.softwarePlanSettingsAutoSchedulerRouteEntry),
        (0, $1C9Ha.softwarePlanSettingsCustomFieldsRouteEntry),
        (0, $cChHY.softwarePlanSettingsExclusionRulesRouteEntry),
        (0, $gksya.softwarePlanSettingsIssueSourcesRouteEntry),
        (0, $d1sI7.softwarePlanSettingsFindYourIssueRouteEntry),
        (0, $6oWts.softwarePlanSettingsRemovedIssuesRouteEntry),
        (0, $qruNQ.softwarePlanTeamsRouteEntry),
        (0, $5dqn2.planViewNotFoundRouteEntry),
        (0, $5qx9W.planUpsellRouteEntry),
        (0, $2FVZu.softwareAdvancedRoadmapsGettingStartedRedirectRouteEntry),
        (0, $4AqA1.planSetupPageRouteEntry),
        (0, $eLT92.planExportPageRouteEntry),
        (0, $cgOe5.planPageRouteEntry),
        (0, $2d9QY.planPageWithoutScenarioIdRouteEntry),
        (0, $43Rln.legacyPlanPageRedirectRouteEntry),
        (0, $jj70V.planReportPageRouteEntry),
        (0, $6Z4jF.legacyPlanReportPageRedirectRouteEntry),
        (0, $cmIyb.plansDirectoryRouteEntry),
        (0, $jPcas.eocScheduleGlobalRouteEntry),
        (0, $7LUIt.eocGlobalAlertListRouteEntry),
        (0, $3EMmS.eocGlobalAlertsDetailRouteEntry),
        (0, $4yINJ.eocTeamAlertListRouteEntry),
        (0, $k7VEf.eocTeamAlertDetailRouteEntry),
        (0, $4Ykyz.eocGlobalGroupDetailRouteEntry),
        (0, $dYoht.eocTeamGroupDetailRouteEntry),
        (0, $7mf3n.roleBasedNotificationsRouteEntry),
        (0, $4Xzif.roleBasedNotificationDetailRouteEntry),
        (0, $kvJxs.globalIncomingCallRouteEntry),
        (0, $4iFpq.globalIncomingCallDetailRouteEntry),
        (0, $g6Mf9.unlockOperationsRouteEntry),
        (0, $ktYro.teamIntegrationsRouteEntry),
        (0, $jFY66.teamIntegrationListRouteEntry),
        (0, $4BuRo.teamIntegrationCreateRouteEntry),
        (0, $6SWMv.teamIntegrationDetailRouteEntry),
        (0, $jPXYO.teamIntegrationLogRouteEntry),
        (0, $68ycU.globalIntegrationsRouteEntry),
        (0, $4mhUQ.globalIntegrationListRouteEntry),
        (0, $kxvlX.globalIntegrationCreateRouteEntry),
        (0, $0e4yJ.globalIntegrationDetailRouteEntry),
        (0, $lcAQi.globalIntegrationLogRouteEntry),
        (0, $iTGOF.alertPoliciesRouteEntry),
        (0, $adI0E.globalPoliciesRouteEntry),
        (0, $q3duL.globalEscalationsRouteEntry),
        (0, $e04XT.eocOverviewRouteEntry),
        (0, $2B61u.eocOverviewAllTeamsRouteEntry),
        (0, $75Ues.eocHeartbeatsRouteEntry),
        (0, $4Yh3B.eocGlobalHeartbeatsRouteEntry),
        (0, $jAB8i.eocMaintenanceRouteEntry),
        (0, $5H5Rm.eocGlobalMaintenanceRouteEntry),
        (0, $5KvQp.eocOnCallRedirectRouteEntry),
        (0, $3Yng9.eocOnCallRouteEntry),
        (0, $V3Ey7.whoIsOnCallRouteEntry),
        (0, $hGFnn.eocPermissionsRouteEntry),
        (0, $dHqTd.eocAutomationsRouteEntry),
        (0, $5xt55.eocTeamAlertIssueSyncingRouteEntry),
        (0, $i27Sx.eocTeamAlertIssueSyncingCreateRouteEntry),
        (0, $qjJTn.eocTeamAlertIssueSyncingDetailRouteEntry),
        (0, $dt3ZS.eocAlertIssueSyncingRouteEntry),
        (0, $hs0Ni.eocAlertIssueSyncingCreateRouteEntry),
        (0, $8m0RN.eocAlertIssueSyncingDetailRouteEntry),
        (0, $bAN0d.eocReportsTeamRedirectRouteEntry),
        (0, $dbAmH.eocReportsUnsubscribeRouteEntry),
        (0, $dQtRM.eocGlobalReportsHomePageNav4RouteEntry),
        (0, $iDxTp.eocGlobalReportsNav4RouteEntry),
        (0, $cLm5J.eocReportsTeamRouteEntry),
        (0, $9KhdI.eocCustomRolesRouteEntry),
        (0, $hDU7Y.eocAssignCustomRolesRouteEntry),
        (0, $5X0aC.productsJsmGlobalOpsReportsRouteEntry),
        (0, $bpbCg.productsJsmGlobalOpsReportsRedirectRouteEntry),
        (0, $tdrXl.productsJsmChatopsAndVideosToolsRouteEntry),
        (0, $jr7ke.sandboxBundlerRouteEntry),
        (0, $gtcNN.sandboxBundlerBifrostRLLRouteEntry),
        (0, $gMkpP.sandboxBundlerBifrostEntrypointsRouteEntry),
        (0, $hPrN5.projectNotFoundRouteEntry),
        (0, $01Za6.errorsNotFoundRouteEntry),
        (0, $7MpwB.loginEmbedRouteEntry),
        (0, $2krv1.helpCenterSettingsAgentStudioActionsRouteEntry),
        (0, $8wIny.helpCenterSettingsAgentStudioChatSimulatorRouteEntry),
        (0, $6pwY1.helpCenterSettingsAgentStudioConversationReviewRouteEntry),
        (0, $9sgxL.helpCenterSettingsAgentStudioKnowledgeRouteEntry),
        (0, $alZMU.helpCenterSettingsAgentStudioRouteEntry),
        (0, $6u3qv.helpCenterSettingsArticlesRouteEntry),
        (0, $j2SDi.helpCenterSettingsArticlesViewArticleRouteEntry),
        (0, $e48vl.helpCenterSettingsCreateArticleRouteEntry),
        (0, $kzcqd.helpCenterSettingsKbRouteEntry),
        (0, $9yhVv.helpCenterSettingsKbOldRouteEntry),
        (0, $fdHNd.helpCenterSettingsCustomerNotificationsRouteEntry),
        (0, $1BQG3.helpCenterSettingsCustomerNotificationsOldRouteEntry),
        (0, $jSJ1v.helpCenterSettingsCustomerAccessRouteEntry),
        (0, $lpcHT.helpCenterSettingsCustomerAccessOldRouteEntry),
        (0, $guURi.helpCenterSettingsDetailsRouteEntry),
        (0, $6RCDC.helpCenterSettingsEmailRouteEntry),
        (0, $lCetQ.helpCenterSettingsEmailOldRouteEntry),
        (0, $avQ9D.helpCenterSettingsSupportWebsiteRouteEntry),
        (0, $f7vKZ.helpCenterSettingsSupportWebsiteOverviewRouteEntry),
        (0, $k826a.helpCenterSettingsSupportWebsitePagesRouteEntry),
        (0, $gZQLD.helpCenterSettingsFormsRouteEntry),
        (0, $9aEQn.helpCenterSettingsFormEditRouteEntry),
        (0, $lVyEk.helpCenterSettingsAnalyticsRouteEntry),
        (0, $lDuCa.helpCenterSettingsServiceHubsRouteEntry),
        (0, $duVOn.helpCenterSettingsNotFoundRouteEntry),
        (0, $hjvN4.userSegmentationRouteEntry),
        (0, $4VMm4.rovoSearchRouteEntry),
        (0, $3Ro2a.applinksExtraAuthHealthcheckRouteEntry),
        // [WARNING]: This route should be the last route.
        // This route redirects to the monolith for all routes we cannot match.
        // It is purposefully missing a path so it always matches and therefore needs to be last.
        // [WARNING]: Please don't add a new route below this. If you want to add, please contact the package owner team.
        (0, $ghGCX.legacyRedirectRouteEntry)
    ];

});
parcelRegister("aNke7", function(module, exports) {

$parcel$export(module.exports, "globalSettingsContactAdministratorRouteEntry", () => $2f78657934c6661f$export$d213125be8246eea);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $emDul = parcelRequire("emDul");

var $ksIuv = parcelRequire("ksIuv");
const $2f78657934c6661f$export$d213125be8246eea = (0, $7NszV.createEntry)((0, $emDul.globalSettingsContactAdministratorRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.contact-administrator',
        component: (0, $ksIuv.default),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ksIuv.LazyContactAdministratorPage)
        ]
    }));

});
parcelRegister("ffza4", function(module, exports) {

$parcel$export(module.exports, "LazyAtlassianNavigation", () => $772c987a24839dcf$export$4caed23aa0274abb);

var $fDtbf = parcelRequire("fDtbf");

var $2SVPM = parcelRequire("2SVPM");

var $b7Svb = parcelRequire("b7Svb");

const $772c987a24839dcf$export$4caed23aa0274abb = (0, $b7Svb.lazyForPaint)(()=>{
    const bundleReady = Promise.resolve((parcelRequire("9DfkH")));
    if (!false) bundleReady.then(()=>{
        (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $fDtbf.JS_EVAL_START))) {
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
            break;
        }
    });
    return bundleReady;
}, {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/index.tsx"
});

});
parcelRegister("2SVPM", function(module, exports) {

$parcel$export(module.exports, "setInitialPageLoadTimingFromPerformanceMarks", () => $b3ae4dfcfbbe07cd$export$15ca6669ae356831);
$parcel$export(module.exports, "stopInitialPageLoadTimingFromPerformanceMarkStart", () => $b3ae4dfcfbbe07cd$export$ab75d59423c060f4);
$parcel$export(module.exports, "measureInitialPageLoadTiming", () => $b3ae4dfcfbbe07cd$export$e18462760bac553c);
$parcel$export(module.exports, "setProductBundleReadyForInitialRender", () => $b3ae4dfcfbbe07cd$export$de1b4cf109d9ab65);

var $3fRWr = parcelRequire("3fRWr");

var $bl6ih = parcelRequire("bl6ih");
/**
 * `performance.measure` will throw if start/stop aren't set.
 *
 * This call sets a user-timing on the profiler timelines so we can see sections of the load.
 */ const $b3ae4dfcfbbe07cd$var$safeMeasure = (name, start, stop)=>{
    try {
        performance.measure(name, start, stop);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
    } catch (_err) {}
};
const $b3ae4dfcfbbe07cd$export$15ca6669ae356831 = (name, start, stop, cleanStart = false, cleanStop = false)=>{
    if (false) return;
    $b3ae4dfcfbbe07cd$var$safeMeasure(name, start, stop);
    (0, $bl6ih.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stop);
    (0, $3fRWr.addTimingFromPerformanceMark)(name, start, stop, cleanStart, cleanStop);
};
const $b3ae4dfcfbbe07cd$export$ab75d59423c060f4 = (name, start, cleanStart = false)=>{
    if (false) return;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(stopMark);
    $b3ae4dfcfbbe07cd$var$safeMeasure(name, start, stopMark);
    (0, $bl6ih.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stopMark);
    (0, $3fRWr.addTimingFromPerformanceMark)(name, start, stopMark, cleanStart, true);
};
const $b3ae4dfcfbbe07cd$export$e18462760bac553c = (name, fn)=>{
    if (false) return fn();
    const startMark = `${name}__start_mark$`;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(startMark);
    const result = fn();
    performance.mark(stopMark);
    $b3ae4dfcfbbe07cd$var$safeMeasure(name, startMark, stopMark);
    (0, $bl6ih.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
    (0, $3fRWr.addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
    return result;
};
const $b3ae4dfcfbbe07cd$export$53038a2e9d597818 = async (name, fn)=>{
    if (false) return fn();
    const startMark = `${name}__start_mark$`;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(startMark);
    const result = await fn();
    performance.mark(stopMark);
    (0, $bl6ih.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
    (0, $3fRWr.addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
    return result;
};
const $b3ae4dfcfbbe07cd$export$de1b4cf109d9ab65 = ()=>{
    if (false) return;
    $b3ae4dfcfbbe07cd$export$ab75d59423c060f4('product.bundle-ready', 'jira-spa.js:eval-stop');
};

});


parcelRegister("2BrOV", function(module, exports) {

$parcel$export(module.exports, "globalLayout", () => $6d4ecb0834e594e8$export$929cb72e7acb7fd9);

var $aPfsS = parcelRequire("aPfsS");
const $6d4ecb0834e594e8$var$rightSidebars = ()=>[];
const $6d4ecb0834e594e8$export$929cb72e7acb7fd9 = (0, $aPfsS.createLayout)({
    rightSidebars: $6d4ecb0834e594e8$var$rightSidebars()
});

});
parcelRegister("aPfsS", function(module, exports) {

$parcel$export(module.exports, "coalesce", () => $ba604ddd48a07730$export$6e5538615c060df7);
$parcel$export(module.exports, "renderGlobalComponents", () => $ba604ddd48a07730$export$fc28c9563350e5b8);
$parcel$export(module.exports, "createLayout", () => $ba604ddd48a07730$export$3dd437ade36ede40);
$parcel$export(module.exports, "composeLayouts", () => $ba604ddd48a07730$export$6c041b39c370853f);
$parcel$export(module.exports, "withProjectContext", () => $ba604ddd48a07730$export$e97a7da67a5b8ce4);

var $5uXOq = parcelRequire("5uXOq");

var $lpwtK = parcelRequire("lpwtK");

var $lfTZh = parcelRequire("lfTZh");

const $ba604ddd48a07730$export$6e5538615c060df7 = (maybeString)=>maybeString == null || maybeString === '' ? undefined : maybeString;
const $ba604ddd48a07730$export$fc28c9563350e5b8 = (components)=>components.map((Component, i)=>{
        const { displayName: displayName, name: name } = Component;
        const key = $ba604ddd48a07730$export$6e5538615c060df7(displayName) ?? $ba604ddd48a07730$export$6e5538615c060df7(name) ?? i;
        return(// TODO Only add suspense if lazy component, otherwise add suspense within component array
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: key?.toString(),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, null)));
    });
const $ba604ddd48a07730$export$3dd437ade36ede40 = ({ globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false } = {})=>({
        isChromeless: isChromeless,
        globalComponents: Array.from(new Set(globalComponents)),
        rightSidebars: Array.from(new Set(rightSidebars))
    });
const $ba604ddd48a07730$export$6c041b39c370853f = (...layouts)=>{
    if (layouts.length === 1) return $ba604ddd48a07730$export$3dd437ade36ede40(layouts[0]);
    const layout = layouts.reduce((l, { globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false })=>({
            isChromeless: isChromeless,
            globalComponents: [
                ...l.globalComponents,
                ...globalComponents
            ],
            rightSidebars: [
                ...l.rightSidebars,
                ...rightSidebars
            ]
        }), {
        globalComponents: [],
        rightSidebars: [],
        isChromeless: false
    });
    return $ba604ddd48a07730$export$3dd437ade36ede40(layout);
};
const $ba604ddd48a07730$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
const $ba604ddd48a07730$var$formatPrefix = (style, type)=>{
    if (!style && !type) return 'Empty';
    if (style === 'any' && type === 'any') return 'Any';
    const formattedStyle = $ba604ddd48a07730$var$capitalize(style === 'next-gen' ? 'nextGen' : style ?? '');
    if (type === 'any') return formattedStyle;
    const formattedType = $ba604ddd48a07730$var$capitalize(type === 'service_desk' ? 'service' : type ?? '');
    if (style === 'any') return formattedType;
    return `${formattedStyle}${formattedType}`;
};
const $ba604ddd48a07730$export$e97a7da67a5b8ce4 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
Component, options)=>{
    const { project: expectedProject } = options;
    const ScopedComponent = ()=>{
        const { data: project, loading: loading } = (0, $lpwtK.useProject)();
        if (loading) return null;
        if ((expectedProject?.type === 'any' ? !project : project?.type !== expectedProject?.type) || (expectedProject?.style === 'any' ? !project : project?.style !== expectedProject?.style)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, null);
    };
    const name = $ba604ddd48a07730$export$6e5538615c060df7(Component.displayName) ?? $ba604ddd48a07730$export$6e5538615c060df7(Component.name) ?? 'Component';
    const prefix = $ba604ddd48a07730$var$formatPrefix(expectedProject?.style, expectedProject?.type);
    ScopedComponent.displayName = `with${prefix}ProjectContext(${name})`;
    return ScopedComponent;
};

});
parcelRegister("lpwtK", function(module, exports) {

$parcel$export(module.exports, "useProject", () => $f3d7644b5666677d$export$51b1383ef8844a7);

var $5uXOq = parcelRequire("5uXOq");

var $bsuuc = parcelRequire("bsuuc");

var $1J3t1 = parcelRequire("1J3t1");
const $f3d7644b5666677d$export$51b1383ef8844a7 = (customContext)=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectSidebarNavigation)(customContext);
    const project = (0, $5uXOq.useMemo)(()=>data && (0, $bsuuc.extractData)(data), [
        data
    ]);
    return {
        data: project,
        loading: loading,
        error: error
    };
};

});
parcelRegister("bsuuc", function(module, exports) {

$parcel$export(module.exports, "getStyle", () => $36c780ae7e3dc8c8$export$3d2f074408bd1b82);
$parcel$export(module.exports, "extractData", () => $36c780ae7e3dc8c8$export$9df5fa0a366163d2);

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");
const $36c780ae7e3dc8c8$export$3d2f074408bd1b82 = (isSimplifiedProject)=>isSimplifiedProject ? (0, $2vSU6.ProjectStyle).NEXT_GEN : (0, $2vSU6.ProjectStyle).CLASSIC;
const $36c780ae7e3dc8c8$var$getProject = (project)=>({
        avatarUrl: project.avatarUrls['48x48'],
        id: Number(project.id),
        isSimplified: project.simplified,
        key: project.key,
        name: project.name,
        style: $36c780ae7e3dc8c8$export$3d2f074408bd1b82(project.simplified),
        type: project.projectTypeKey,
        ...typeof project.isLiveTemplate === 'boolean' && (0, $4R6GH.fg)('jira_custom_templates_ux') && {
            isLiveTemplate: project.isLiveTemplate
        }
    });
const $36c780ae7e3dc8c8$export$9df5fa0a366163d2 = (data)=>{
    const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
    switch(projectType){
        case 'jira_work_management':
            return jiraWorkManagementNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraWorkManagementNavData.project) : null;
        case 'jira_software':
            return jiraSoftwareNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraSoftwareNavData.project) : null;
        case 'jira_service_management':
        case 'jira_customer_service':
            return jiraServiceManagementNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraServiceManagementNavData.project) : null;
        case 'jira_product_discovery':
            return jiraProductDiscoveryNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraProductDiscoveryNavData.project) : null;
        case null:
        default:
            return null;
    }
};

});

parcelRegister("1J3t1", function(module, exports) {

$parcel$export(module.exports, "useProjectSidebarNavigation", () => $bb292f58b8ec7804$export$5a85006c180fb373);
$parcel$export(module.exports, "useProjectSidebarConnectNavigation", () => $bb292f58b8ec7804$export$2bed15cd7d167db5);
$parcel$export(module.exports, "useProjectReportsSidebarConnectNavigation", () => $bb292f58b8ec7804$export$a9d05fc2c1d94895);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectNavigation", () => $bb292f58b8ec7804$export$d48e3c3556894533);
$parcel$export(module.exports, "useJSMProjectConnectQueuesNavigation", () => $bb292f58b8ec7804$export$24a781cd863077aa);
$parcel$export(module.exports, "useJiraWorkmanagementProjectNavigation", () => $bb292f58b8ec7804$export$e16ecd2512eb0dc7);
$parcel$export(module.exports, "useJiraSoftwareProjectNavigation", () => $bb292f58b8ec7804$export$68dc0ecbea8211d2);
$parcel$export(module.exports, "useJiraServiceManagementProjectNavigation", () => $bb292f58b8ec7804$export$5cf90b625d0e1248);
$parcel$export(module.exports, "useJiraProductDiscoveryProjectNavigation", () => $bb292f58b8ec7804$export$d63d92edebe543d9);

var $5uXOq = parcelRequire("5uXOq");

var $b2pl3 = parcelRequire("b2pl3");

var $6zFAI = parcelRequire("6zFAI");

var $gcI3W = parcelRequire("gcI3W");

var $loy04 = parcelRequire("loy04");

var $ggg5j = parcelRequire("ggg5j");

var $324W5 = parcelRequire("324W5");

var $2YP9W = parcelRequire("2YP9W");

var $727Q1 = parcelRequire("727Q1");
const $bb292f58b8ec7804$export$5a85006c180fb373 = (customContext)=>{
    const { data: navResponse, loading: loading, error: error, refresh: refresh, clearAll: clearAll, ...rest } = (0, $324W5.useResourceWithCustomRouterContext)((0, $ggg5j.staticProjectSidebarNavigationResource), customContext);
    const memoizedResponse = (0, $5uXOq.useMemo)(()=>navResponse, [
        navResponse
    ]);
    (0, $727Q1.useJiraSoftwareCMPNavigationSynchronizer)(memoizedResponse);
    return {
        data: memoizedResponse,
        loading: memoizedResponse != null ? false : loading,
        refresh: refresh,
        clearAll: clearAll,
        error: error,
        ...rest
    };
};
const $bb292f58b8ec7804$export$2bed15cd7d167db5 = ()=>(0, $2YP9W.useResource)((0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource));
const $bb292f58b8ec7804$export$a9d05fc2c1d94895 = ()=>(0, $2YP9W.useResource)((0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource));
const $bb292f58b8ec7804$export$d48e3c3556894533 = ()=>(0, $2YP9W.useResource)((0, $loy04.staticProjectSettingsSidebarConnectAddonsNavigationResource));
const $bb292f58b8ec7804$export$24a781cd863077aa = ()=>(0, $2YP9W.useResource)((0, $b2pl3.staticJSMProjectConnectAddonsNavigationResource));
const $bb292f58b8ec7804$export$e16ecd2512eb0dc7 = ()=>{
    const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
    const response = data?.jiraWorkManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $bb292f58b8ec7804$export$68dc0ecbea8211d2 = ()=>{
    const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
    const response = data?.jiraSoftwareNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $bb292f58b8ec7804$export$5cf90b625d0e1248 = (customContext)=>{
    const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373(customContext);
    const response = data?.jiraServiceManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $bb292f58b8ec7804$export$d63d92edebe543d9 = ()=>{
    const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
    const response = data?.jiraProductDiscoveryNavData || null;
    return {
        data: response,
        ...rest
    };
};

});
parcelRegister("b2pl3", function(module, exports) {

$parcel$export(module.exports, "staticJSMProjectConnectAddonsNavigationResource", () => $565682b770797f58$export$fab84295e18e9246);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $jAGOQ = parcelRequire("jAGOQ");
const $565682b770797f58$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $565682b770797f58$export$fab84295e18e9246 = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
    getKey: ({ match: match, query: query })=>$565682b770797f58$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $565682b770797f58$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jAGOQ.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'jsm_queues');
        return navInfo;
    },
    maxAge: 300000
});

});
parcelRegister("1nb22", function(module, exports) {

$parcel$export(module.exports, "getProjectKey", () => $061afadfbcc74f44$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectIdOrKey", () => $061afadfbcc74f44$export$c072f183553fb7ea);
$parcel$export(module.exports, "getProjectKeyId", () => $061afadfbcc74f44$export$1f7213d0f9054f06);
const $061afadfbcc74f44$export$89040d072f281f85 = (query)=>query?.selectedProjectId || query?.pid || query?.projectId || query?.['project.id'];
const $061afadfbcc74f44$export$667f2a0f99c75faa = (match, query)=>match?.params.projectKey || query?.projectKey || query?.['project.key'] || (match.params?.issueKey || '').split('-')[0];
const $061afadfbcc74f44$export$c072f183553fb7ea = (match, query)=>$061afadfbcc74f44$export$89040d072f281f85(query) || $061afadfbcc74f44$export$667f2a0f99c75faa(match, query);
const $061afadfbcc74f44$export$1f7213d0f9054f06 = (match, query)=>{
    // handle reports legacy url or project settings details
    const projectId = $061afadfbcc74f44$export$89040d072f281f85(query);
    const projectKey = $061afadfbcc74f44$export$667f2a0f99c75faa(match, query);
    return {
        projectKey: projectKey,
        projectId: projectId
    };
};

});

parcelRegister("jAGOQ", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarConnectNavigationInfo", () => $45e9310ad65e3e88$export$b15f9f5cf6db359e);

var $eusud = parcelRequire("eusud");
const $45e9310ad65e3e88$export$b15f9f5cf6db359e = (projectKeyOrId, sidebarType)=>{
    if (projectKeyOrId == null) throw new Error('invalid identifier specified');
    return (0, $eusud.performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=${sidebarType}`);
};

});
parcelRegister("eusud", function(module, exports) {

$parcel$export(module.exports, "transformValidationErrorFromServer", () => $3637c0f7edbd2bb4$export$8e9baed7697e4959);
$parcel$export(module.exports, "applyErrorHandling", () => $3637c0f7edbd2bb4$export$e174dc943a170ff);
$parcel$export(module.exports, "performGetRequest", () => $3637c0f7edbd2bb4$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $3637c0f7edbd2bb4$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $3637c0f7edbd2bb4$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $3637c0f7edbd2bb4$export$8ef51cba9d28f819);
$parcel$export(module.exports, "performPatchRequest", () => $3637c0f7edbd2bb4$export$52be6ab13d7e758d);
$parcel$export(module.exports, "performGetRequestWithRetry", () => $3637c0f7edbd2bb4$export$659b5ee69e6eb976);
$parcel$export(module.exports, "performPutRequestWithRetry", () => $3637c0f7edbd2bb4$export$d7b48b2904a5d812);
$parcel$export(module.exports, "performPostRequestWithRetry", () => $3637c0f7edbd2bb4$export$a5717cbee13f28b7);


var $jQsty = parcelRequire("jQsty");

var $5HnTq = parcelRequire("5HnTq");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");

var $6b2ko = parcelRequire("6b2ko");

var $iwPwz = parcelRequire("iwPwz");
/**
 * Transform object with field errors from JIRA to an array of FieldValidationErrors
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3637c0f7edbd2bb4$var$transformFieldErrorsFromServer = (fieldErrors)=>Object.keys(fieldErrors).map((field)=>({
            field: field,
            error: fieldErrors[field]
        }));
const $3637c0f7edbd2bb4$export$8e9baed7697e4959 = (json, statusCode, traceId)=>{
    const message = json.errorMessages ? json.errorMessages.join('; ') : 'validation failed';
    const fieldErrorsJson = json.errors ?? json.fieldErrors;
    const fieldErrors = fieldErrorsJson ? $3637c0f7edbd2bb4$var$transformFieldErrorsFromServer(fieldErrorsJson) : [];
    return new (0, $jJZqs.ValidationError)(message, fieldErrors, statusCode, traceId, json);
};
const $3637c0f7edbd2bb4$var$putOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'PUT'
};
const $3637c0f7edbd2bb4$var$postOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'POST'
};
const $3637c0f7edbd2bb4$var$deleteOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'DELETE'
};
const $3637c0f7edbd2bb4$var$patchOptions = {
    ...(0, $5HnTq.defaultOptions),
    method: 'PATCH'
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3637c0f7edbd2bb4$var$handleNetworkErrors = (err)=>{
    if (err instanceof TypeError) throw new Error('Failed to fetch', {
        cause: err
    });
    throw err;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3637c0f7edbd2bb4$var$handleErrors = (response)=>{
    const traceId = (0, $iwPwz.getTraceId)(response);
    // CONTENT_TOO_LARGE errorMessage is used for Hard Limits and, we don't want to override the error message
    if ((0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977) === response.status || (0, $3cd8a0ece36fbae5$export$f90ac1df0b60853d) === response.status) return response.json().then((errorContent)=>{
        throw $3637c0f7edbd2bb4$export$8e9baed7697e4959(errorContent, response.status, traceId);
    });
    if (!response.ok) {
        if (traceId !== undefined && traceId.length > 0) throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`, traceId, response);
        else throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`, undefined, response);
    }
    return response;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3637c0f7edbd2bb4$var$processResponseFromServer = (response)=>{
    if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $3637c0f7edbd2bb4$export$e174dc943a170ff = (responsePromise)=>responsePromise.then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
const $3637c0f7edbd2bb4$export$22411cbfb09a5c5c = (url, options)=>{
    const { retryPredicate: retryPredicate, retryAttempts: retryAttempts, onRetry: onRetry, ...requestOptions } = options;
    const executeRequest = ()=>$3637c0f7edbd2bb4$export$e174dc943a170ff(fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, requestOptions)));
    if ((0, $jQsty.default)('platform_fetch_retries')) return executeRequest();
    return (0, $6b2ko.retryOnError)(executeRequest, {
        retryFunc: executeRequest,
        retryPredicate: retryPredicate,
        retryAttempts: retryAttempts,
        onRetry: onRetry
    });
};
const $3637c0f7edbd2bb4$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...(0, $5HnTq.defaultOptions),
        ...options
    })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
const $3637c0f7edbd2bb4$export$9ead1f9103e6de6b = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$putOptions,
        ...options
    })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
const $3637c0f7edbd2bb4$export$692a4d9808143175 = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$postOptions,
        ...options
    })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
const $3637c0f7edbd2bb4$export$8ef51cba9d28f819 = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$deleteOptions,
        ...options
    })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
const $3637c0f7edbd2bb4$export$52be6ab13d7e758d = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, {
        ...$3637c0f7edbd2bb4$var$patchOptions,
        ...options
    })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
const $3637c0f7edbd2bb4$export$659b5ee69e6eb976 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...(0, $5HnTq.defaultOptions),
        ...options
    });
const $3637c0f7edbd2bb4$export$d7b48b2904a5d812 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$putOptions,
        ...options
    });
const $3637c0f7edbd2bb4$export$a5717cbee13f28b7 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$postOptions,
        ...options
    });
const $3637c0f7edbd2bb4$export$6d01bf1146815b9b = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$deleteOptions,
        ...options
    });
const $3637c0f7edbd2bb4$export$560989ee94ad2a20 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
        ...$3637c0f7edbd2bb4$var$patchOptions,
        ...options
    });

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;

parcelRegister("8KpGl", function(module, exports) {

$parcel$export(module.exports, "getReroutableURL", () => $e8054b634989671a$export$23769875e8eebaf6);

var $g96Vw = parcelRequire("g96Vw");
// FIXME: Pillar to define entire URL, not just hostname.
const $e8054b634989671a$var$LOCAL_URL = new URL(`${'http'}://${(0, $g96Vw.getDevHostname)()}:${(0, $g96Vw.getProxyServerPort)()}`);
function $e8054b634989671a$export$23769875e8eebaf6(pathOrURL) {
    var e;
    return pathOrURL;
}

});
parcelRegister("g96Vw", function(module, exports) {

$parcel$export(module.exports, "getDevHostname", () => $e257580e5f260c28$export$a6aba27c4797e08b);
$parcel$export(module.exports, "getProxyServerPort", () => $e257580e5f260c28$export$6819122a922c6aaf);
/**
 * Get the hostname for the Pillar development server.
 *
 * In the always-on RDE, it will have a proper DNS name. In local development, it
 * will default to `localhost`.
 *
 * @returns The hostname for the development server.
 */ const $e257580e5f260c28$export$a6aba27c4797e08b = ()=>{
    const envDns = undefined;
    return typeof envDns === 'string' && envDns.trim() ? envDns.trim() : 'localhost';
};
function $e257580e5f260c28$export$6819122a922c6aaf() {
    return 9000;
}

});


parcelRegister("6b2ko", function(module, exports) {

$parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", () => $6910b563ec955346$export$81189edc9b923717);
$parcel$export(module.exports, "retryOnError", () => $6910b563ec955346$export$f859c88bfac2cf2c);
const $6910b563ec955346$export$81189edc9b923717 = 1;
const $6910b563ec955346$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $6910b563ec955346$export$81189edc9b923717, onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > $6910b563ec955346$export$81189edc9b923717 ? $6910b563ec955346$export$81189edc9b923717 : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};

});

parcelRegister("iwPwz", function(module, exports) {

$parcel$export(module.exports, "getTraceId", () => $19a21974d2ff6598$export$e88cb5bfb57ce9c4);
$parcel$export(module.exports, "getTraceIdJq", () => $19a21974d2ff6598$export$b569b31eebca952d);

var $fnyT4 = parcelRequire("fnyT4");
const $19a21974d2ff6598$export$e88cb5bfb57ce9c4 = (response)=>{
    const traceIdHeader = (0, $fnyT4.KNOWN_TRACE_ID_HEADERS).find((header)=>response.headers.has(header));
    return traceIdHeader === undefined ? undefined : response.headers.get(traceIdHeader) ?? undefined;
};
const $19a21974d2ff6598$export$b569b31eebca952d = (jqxhr)=>{
    if (!jqxhr || !jqxhr.getResponseHeader) // prefer a silent fail, so we don't accidentally swallow the original error being built
    return undefined;
    const traceIdHeader = (0, $fnyT4.KNOWN_TRACE_ID_HEADERS).find((header)=>jqxhr.getResponseHeader(header) != null);
    return traceIdHeader === undefined ? undefined : jqxhr.getResponseHeader(traceIdHeader);
};

});
parcelRegister("fnyT4", function(module, exports) {

$parcel$export(module.exports, "TRACE_ID_HEADER", () => $5d3410503b671c4b$export$4b69438fb7c7b9b2);
$parcel$export(module.exports, "KNOWN_TRACE_ID_HEADERS", () => $5d3410503b671c4b$export$830a89e935012abe);
const $5d3410503b671c4b$export$4b69438fb7c7b9b2 = 'atl-traceid';
const $5d3410503b671c4b$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $5d3410503b671c4b$export$830a89e935012abe = [
    $5d3410503b671c4b$export$4b69438fb7c7b9b2,
    $5d3410503b671c4b$var$TRACE_ID_HEADER_MICROS
];

});





parcelRegister("6zFAI", function(module, exports) {

$parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResource", () => $ee61b377cbb3343f$export$b8c6e2666f12f4bb);
$parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only", () => $ee61b377cbb3343f$export$a799c58e7bee6de4);

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $1nb22 = parcelRequire("1nb22");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");

var $jAGOQ = parcelRequire("jAGOQ");
const $ee61b377cbb3343f$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $ee61b377cbb3343f$export$b8c6e2666f12f4bb = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$ee61b377cbb3343f$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $ee61b377cbb3343f$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const projectHomeAddonNavInfo = await (0, $jAGOQ.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'home');
        return projectHomeAddonNavInfo;
    },
    maxAge: 300000
});
const $ee61b377cbb3343f$export$a799c58e7bee6de4 = (0, $gNStA.resourceWithCondition2)(()=>!((0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('perf-push-big-components-nav-remove-resources')), $ee61b377cbb3343f$export$b8c6e2666f12f4bb);

});
parcelRegister("gNStA", function(module, exports) {

$parcel$export(module.exports, "resourceWithCondition", () => $4fbc57fe7e788209$export$cac04afc5a06c544);
$parcel$export(module.exports, "resourceWithCondition2", () => $4fbc57fe7e788209$export$78488a529a07cd46);
$parcel$export(module.exports, "browserOnlyResourceWithCondition", () => $4fbc57fe7e788209$export$5284559c6d2f1a7b);

var $kbVA4 = parcelRequire("kbVA4");
const $4fbc57fe7e788209$export$cac04afc5a06c544 = (conditionGetter, resourceTrue)=>resourceTrue && {
        get type () {
            return conditionGetter() ? resourceTrue.type : (0, $kbVA4.RESOURCE_TYPE_NOOP);
        },
        getKey: resourceTrue.getKey,
        get maxAge () {
            return conditionGetter() ? resourceTrue.maxAge : Number.MAX_SAFE_INTEGER;
        },
        getData: (routerContext, customContext)=>conditionGetter() ? resourceTrue.getData(routerContext, customContext) : Promise.resolve(null),
        maxCache: resourceTrue.maxCache,
        get isBrowserOnly () {
            return resourceTrue.isBrowserOnly;
        },
        get depends () {
            return resourceTrue.depends;
        },
        get skipBrowser () {
            return resourceTrue.skipBrowser;
        }
    };
const $4fbc57fe7e788209$export$fbf6681b373be4c4 = (resource, amendments = {})=>// @ts-expect-error - TS2322 - Type 'Partial<RouteResource<any>>' is not assignable to type 'RouteResource<any>'.
    resource && // IMPORTANT - resources can be falsy in SSR "routes" build
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.defineProperties({}, {
        ...Object.getOwnPropertyDescriptors(resource),
        ...Object.getOwnPropertyDescriptors(amendments)
    });
const $4fbc57fe7e788209$export$78488a529a07cd46 = (conditionGetter, itemTrue, itemFalse = $4fbc57fe7e788209$export$fbf6681b373be4c4(itemTrue, {
    getKey: ()=>'DEGENERATE_KEY',
    getData: ()=>null,
    maxAge: Number.MAX_SAFE_INTEGER
}))=>// @ts-expect-error - TS2740 - Type '{}' is missing the following properties from type 'RouteResource<any>': type, getKey, maxAge, getData, and 3 more.
    itemTrue && // IMPORTANT - resources can be falsy in SSR "routes" build
    Object.defineProperties({}, Object.fromEntries([
        ...Object.keys(itemTrue),
        ...Object.keys(itemFalse)
    ].filter((v, i, a)=>a.indexOf(v) === i).map((key)=>[
            key,
            {
                configurable: false,
                enumerable: true,
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'.
                get: ()=>conditionGetter() ? itemTrue[key] : itemFalse[key]
            }
        ])));
const $4fbc57fe7e788209$export$5284559c6d2f1a7b = (conditionGetter, resource)=>resource && {
        ...resource,
        get isBrowserOnly () {
            return !!conditionGetter();
        }
    };

});
parcelRegister("kbVA4", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_NOOP", () => $513d12eeb22c04a1$export$eb37f5d331ea4de4);
$parcel$export(module.exports, "MIN_MAX_AGE", () => $513d12eeb22c04a1$export$5664a170ac5a9781);
const $513d12eeb22c04a1$export$eb37f5d331ea4de4 = 'NOOP';
const $513d12eeb22c04a1$export$5664a170ac5a9781 = 5000;

});



parcelRegister("gcI3W", function(module, exports) {

$parcel$export(module.exports, "staticProjectReportsSidebarConnectAddonsNavigationResource", () => $e60f9280597d4f0e$export$b662f3f877add30d);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $jAGOQ = parcelRequire("jAGOQ");
const $e60f9280597d4f0e$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $e60f9280597d4f0e$export$b662f3f877add30d = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_REPORTS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$e60f9280597d4f0e$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $e60f9280597d4f0e$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jAGOQ.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'reports');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("loy04", function(module, exports) {

$parcel$export(module.exports, "staticProjectSettingsSidebarConnectAddonsNavigationResource", () => $c5a0b9808c0c3182$export$e4bf33528101348c);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectAddonsNavigationResource", () => $c5a0b9808c0c3182$export$2d5a704ae6f6b050);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $jAGOQ = parcelRequire("jAGOQ");
const $c5a0b9808c0c3182$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $c5a0b9808c0c3182$export$e4bf33528101348c = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SETTINGS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$c5a0b9808c0c3182$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $c5a0b9808c0c3182$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jAGOQ.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'settings');
        return navInfo;
    },
    maxAge: 300000
});
const $c5a0b9808c0c3182$export$2d5a704ae6f6b050 = ()=>(0, $2YP9W.useResource)($c5a0b9808c0c3182$export$e4bf33528101348c);

});

parcelRegister("ggg5j", function(module, exports) {

$parcel$export(module.exports, "getIdentifier", () => $3ec7290d9b237c27$export$adb27ddab077e944);
$parcel$export(module.exports, "staticProjectSidebarNavigationResource", () => $3ec7290d9b237c27$export$f2dfc0f7b2d92691);
$parcel$export(module.exports, "useSidebarNavigationResource", () => $3ec7290d9b237c27$export$b692cfadccf4e047);

var $4R6GH = parcelRequire("4R6GH");

var $95bh0 = parcelRequire("95bh0");

var $8YTna = parcelRequire("8YTna");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $gDyED = parcelRequire("gDyED");
const $3ec7290d9b237c27$export$adb27ddab077e944 = (routeName, match, query)=>{
    /**
	 * `boardId` as an identifier should not be returned for JSM boards route,
	 * skip boards on `SERVICEDESK_BOARDS` or `SERVICEDESK_CALENDAR` route.
	 */ if (routeName === 'servicedesk-boards' || routeName === 'servicedesk-calendar' || query['servicedesk.serviceDeskId'] || (routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-custom-calendar' || routeName === 'servicedesk-queues-practice-custom-board' || routeName === 'servicedesk-queues-practice-custom-calendar' || routeName === 'servicedesk-queues-views-config' || routeName === 'servicedesk-practice-views-config') && (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) {
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        return (0, $95bh0.getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId
        });
    }
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    const boardId = (0, $8YTna.getBoardId)(match, query);
    return (0, $95bh0.getScopeIdentifier)({
        projectKey: projectKey,
        projectId: projectId,
        boardId: boardId
    });
};
const $3ec7290d9b237c27$var$getRouterKey = (routeName, match, query)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = $3ec7290d9b237c27$export$adb27ddab077e944(routeName, match, query);
    // Next-Gen software projects contain only one board. Hence, using the project key itself
    if (match.url.includes('/software/projects/')) return `projectKey-${match.params.projectKey || ''}`;
    return identifierType == null || identifierValue == null ? 'none' : `${identifierType}-${identifierValue}`;
};
const $3ec7290d9b237c27$export$f2dfc0f7b2d92691 = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PROJECT',
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    getKey: ({ match: match, query: query, route: { name: name } })=>$3ec7290d9b237c27$var$getRouterKey(name, match, query),
    /**
	 * is called on resource's init fetch, or .refresh()
	 */ getData: async ({ match: match, query: query, route: { name: name } })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const scopeIdentifier = $3ec7290d9b237c27$export$adb27ddab077e944(name, match, query);
        if (scopeIdentifier.identifierType == null || scopeIdentifier.identifierValue == null) return null;
        const navInfo = await (0, $gDyED.fetchProjectSidebarNavInfo)(scopeIdentifier);
        return navInfo;
    },
    maxAge: 300000
});
const $3ec7290d9b237c27$export$b692cfadccf4e047 = ()=>(0, $2YP9W.useResource)($3ec7290d9b237c27$export$f2dfc0f7b2d92691);

});
parcelRegister("95bh0", function(module, exports) {

$parcel$export(module.exports, "getScopeIdentifier", () => $4cc145d0cf66273c$export$68278f7cf66944f9);

const $4cc145d0cf66273c$export$68278f7cf66944f9 = (scope)=>{
    // We check for identifiers in order of specificity first. A board ID is more specific than a project key and so on
    const identifierValue = scope.boardId || scope.projectKey || scope.projectId;
    let identifierType = null;
    if (scope.boardId) identifierType = (0, $87844bbe4c23d937$export$929d50f83189406c);
    else if (scope.projectKey) identifierType = (0, $87844bbe4c23d937$export$b5a308a17bc991f3);
    else if (scope.projectId) identifierType = (0, $87844bbe4c23d937$export$da6f46390e1a426f);
    return {
        identifierValue: identifierValue,
        identifierType: identifierType
    };
};

});
const $87844bbe4c23d937$export$b5a308a17bc991f3 = 'projectKey';
const $87844bbe4c23d937$export$929d50f83189406c = 'boardId';
const $87844bbe4c23d937$export$da6f46390e1a426f = 'projectId';


parcelRegister("8YTna", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $f7f12dfb24bc320d$export$557c2f222778cea6);
const $f7f12dfb24bc320d$export$557c2f222778cea6 = (match, query)=>match.params.boardId || query.rapidView || query['board.id'];

});

parcelRegister("gDyED", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarNavInfo", () => $b6d61a4c2e3b518c$export$8a51470472777e11);

var $eusud = parcelRequire("eusud");
const $b6d61a4c2e3b518c$export$8a51470472777e11 = (scopeIdentifier)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = scopeIdentifier;
    if (identifierType == null || identifierValue == null) throw new Error('invalid identifier specified');
    let queryParam = '';
    switch(identifierType){
        case 'boardId':
            queryParam = `boardId=${identifierValue}`;
            break;
        case 'projectKey':
        case 'projectId':
            queryParam = `projectIdOrKey=${identifierValue}`;
            break;
        default:
            break;
    }
    return (0, $eusud.performGetRequest)(`/rest/navigation/4/sidebar?${queryParam}`);
};

});


parcelRegister("324W5", function(module, exports) {

$parcel$export(module.exports, "useResourceWithCustomRouterContext", () => $0c2698427b7aacc1$export$61dad767cf446185);

var $jNUyg = parcelRequire("jNUyg");
var $2YP9W = parcelRequire("2YP9W");

var $geWXd = parcelRequire("geWXd");
/**
 * DUMMY_ROUTE needs to be used by default, because `route` must not be undefined, it is required/used internally by RRR, e.g. in findRouterContext() on createRouterContext() call.
 * If `route` is undefined, those will throw runtime exceptions.
 * `project-sidebar-navigation-resource/software-cmp-nav-synchronizer/index.tsx` uses dummy route as well.
 *
 * Jfyi, createProjectRouteRouterContext() function in JSW uses dummy route, with :projectKey in its path (that resource fetch function uses)
 */ const $0c2698427b7aacc1$var$DUMMY_ROUTE = {
    name: 'DUMMY_ROUTE_NAME',
    path: '/projects/:projectKey/dummyroute'
};
function $0c2698427b7aacc1$export$61dad767cf446185(resource, customRouterContext, options = {}) {
    let resourceOptions;
    if (customRouterContext) {
        // NOTE: `route` must include /.../:paramKey/... in its url for all `matchParams` passed to the `createRouterContext`, otherwise they will be ignored. createRouterContext will throw an error if route is undefined: `route.path` is used in the library code at least.
        const { route: route = $0c2698427b7aacc1$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
        if (matchParams && Object.keys(matchParams).length > 0) resourceOptions = {
            routerContext: (0, $jNUyg.createRouterContext)(route, {
                params: matchParams
            })
        };
    }
    const { shouldPrefetch: shouldPrefetch } = options;
    const resourceResponse = (0, $2YP9W.useResource)(resource, resourceOptions);
    // we must call "fetch data" / refresh() manually, because react-resource-router will not fetch resources which are not defined in the current route's required resources.
    (0, $geWXd.usePrefetchableResource)(resourceResponse, shouldPrefetch ?? Boolean(customRouterContext));
    return resourceResponse;
}

});
parcelRegister("geWXd", function(module, exports) {

$parcel$export(module.exports, "usePrefetchableResource", () => $b632b0c18495344b$export$99f17ace416cfe75);

var $5uXOq = parcelRequire("5uXOq");
function $b632b0c18495344b$export$99f17ace416cfe75(resource, shouldPrefetch) {
    (0, $5uXOq.useEffect)(()=>{
        if (!shouldPrefetch) return;
        // "false" is a valid value for data here. We only want to trigger a refresh if data is null or undefined.
        if ((resource.data === null || resource.data === undefined) && !resource.loading && !resource.error) resource.refresh();
    // we only need this to happen only once at initial time. In addition, some resources return `data` = null when user does not have permissions etc., which makes all `data`, `loading` and `error` have falsy values.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("727Q1", function(module, exports) {

$parcel$export(module.exports, "useJiraSoftwareCMPNavigationSynchronizer", () => $5300bc04c6e3c00f$export$780174995da89d60);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $ggg5j = parcelRequire("ggg5j");

var $jNUyg = parcelRequire("jNUyg");
var $lODMY = parcelRequire("lODMY");
var $2YP9W = parcelRequire("2YP9W");
const $5300bc04c6e3c00f$export$90dbde7e33e6e21 = ()=>null;
const $5300bc04c6e3c00f$export$d647718555c2fdd8 = (projectKey)=>projectKey ? (0, $jNUyg.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/:projectKey/dummyroute',
        component: $5300bc04c6e3c00f$export$90dbde7e33e6e21
    }, {
        params: {
            projectKey: projectKey
        }
    }) : undefined;
const $5300bc04c6e3c00f$export$19001bab9e4b7f8f = (projectKey)=>{
    const { data: data, update: update } = (0, $2YP9W.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource), {
        routerContext: $5300bc04c6e3c00f$export$d647718555c2fdd8(projectKey)
    });
    return {
        data: data,
        update: update
    };
};
const $5300bc04c6e3c00f$export$23dc6491016cabdc = (boardId)=>boardId != null ? (0, $jNUyg.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/boards/:boardId/dummyroute',
        component: $5300bc04c6e3c00f$export$90dbde7e33e6e21
    }, {
        params: {
            boardId: `${boardId}`
        }
    }) : undefined;
const $5300bc04c6e3c00f$export$e2bb7877e6cec3eb = (boardId)=>{
    const { data: data, update: update } = (0, $2YP9W.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource), {
        routerContext: $5300bc04c6e3c00f$export$23dc6491016cabdc(boardId)
    });
    return {
        data: data,
        update: update
    };
};
const $5300bc04c6e3c00f$var$useIsOnBoardBasedRoute = (0, $lODMY.createRouterSelector)(({ route: route, query: query, match: match })=>(0, $ggg5j.getIdentifier)(route.name, match, query)?.identifierType === 'boardId');
const $5300bc04c6e3c00f$export$780174995da89d60 = (latestNavInfo)=>{
    const isOnBoardBasedRoute = $5300bc04c6e3c00f$var$useIsOnBoardBasedRoute();
    const isSoftwareCMP = latestNavInfo?.jiraSoftwareNavData?.project?.simplified === false;
    const pKey = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.project?.key || null;
    const boardId = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.boardInfo?.id || null;
    // explicitly get project data by forcing key to be project
    const { data: projectRouteNavInfo, update: updateProjectRoute } = $5300bc04c6e3c00f$export$19001bab9e4b7f8f(pKey);
    // explicitly get board data by forcing key to be board
    const { data: boardRouteNavInfo, update: updateBoardRoute } = $5300bc04c6e3c00f$export$e2bb7877e6cec3eb(boardId);
    // if software CMP project or board data is not in sync, then force update
    (0, $5uXOq.useEffect)(()=>{
        if (latestNavInfo != null && isSoftwareCMP) {
            if (isOnBoardBasedRoute && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(latestNavInfo, projectRouteNavInfo)) updateProjectRoute(()=>latestNavInfo);
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(latestNavInfo, boardRouteNavInfo)) updateBoardRoute(()=>latestNavInfo);
        }
    }, [
        isOnBoardBasedRoute,
        latestNavInfo,
        updateProjectRoute,
        updateBoardRoute,
        projectRouteNavInfo,
        boardRouteNavInfo,
        isSoftwareCMP
    ]);
};

});





parcelRegister("7NszV", function(module, exports) {

$parcel$export(module.exports, "createEntry", () => $82f1a9156abf3836$export$344b9c9ab5e66c9a);

var $hwKYN = parcelRequire("hwKYN");
const $82f1a9156abf3836$export$344b9c9ab5e66c9a = (0, $hwKYN.createRouteEntry);

});
parcelRegister("hwKYN", function(module, exports) {

$parcel$export(module.exports, "createRouteEntry", () => $d530719601daee4d$export$136cc45b1cabb43);
/**
 * Create route entry with entrypoint, resources, etc. override
 *
 * @param baseRoute Base route object that contains matching info
 * @param opts Route definition to fill and override
 */ function $d530719601daee4d$export$136cc45b1cabb43(baseRoute, opts) {
    // @ts-expect-error Re-using baseRoute to become the full route Object allows us to optimize
    // route transitions as RRR can directly use the route instead of comparing a separate InvariantRoute
    // against the full route list
    // eslint-disable-next-line no-param-reassign
    baseRoute.lazyOpts = opts;
    // @ts-expect-error TODO
    return baseRoute;
}

});


parcelRegister("3RJkv", function(module, exports) {

$parcel$export(module.exports, "getModernIssueTransitionResources", () => $4f455891fb36bf50$export$e1afa08027b1e44b);
$parcel$export(module.exports, "getNavigationResources", () => $4f455891fb36bf50$export$75cffd1aaecf4a2c);
$parcel$export(module.exports, "getUserBoardNavigationResources", () => $4f455891fb36bf50$export$c57dc1ea7f76f91f);
$parcel$export(module.exports, "getNavigationSidebarPlanResources", () => $4f455891fb36bf50$export$af2259a87f79645d);
$parcel$export(module.exports, "getNavigationSidebarProductsSettingResource", () => $4f455891fb36bf50$export$a103e99ad51f7bc3);
$parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", () => $4f455891fb36bf50$export$808691f5a412afa3);
// eslint-disable-next-line jira/import-whitelist

var $5kYzp = parcelRequire("5kYzp");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $5bkvv = parcelRequire("5bkvv");

var $7xTO3 = parcelRequire("7xTO3");

var $c1N9v = parcelRequire("c1N9v");

var $loy04 = parcelRequire("loy04");

var $2fwuR = parcelRequire("2fwuR");

var $fwzEJ = parcelRequire("fwzEJ");

var $3HwlS = parcelRequire("3HwlS");

var $h9iZl = parcelRequire("h9iZl");

var $2eyDn = parcelRequire("2eyDn");

var $drGWM = parcelRequire("drGWM");

var $kMiZJ = parcelRequire("kMiZJ");

var $bHhiy = parcelRequire("bHhiy");


var $aA974 = parcelRequire("aA974");

var $f5nIZ = parcelRequire("f5nIZ");

var $hZhhj = parcelRequire("hZhhj");

var $9MiT2 = parcelRequire("9MiT2");

var $fNOVA = parcelRequire("fNOVA");

var $kJQXA = parcelRequire("kJQXA");

var $atU1t = parcelRequire("atU1t");

var $c34Wf = parcelRequire("c34Wf");

var $eOlBz = parcelRequire("eOlBz");

var $3X1Xr = parcelRequire("3X1Xr");

var $dxCvy = parcelRequire("dxCvy");

var $4dc0x = parcelRequire("4dc0x");

var $51Yl2 = parcelRequire("51Yl2");

var $lXNZG = parcelRequire("lXNZG");

var $kkNtb = parcelRequire("kkNtb");

var $2Ql51 = parcelRequire("2Ql51");

var $9vlEn = parcelRequire("9vlEn");

var $gNStA = parcelRequire("gNStA");

var $5pSYQ = parcelRequire("5pSYQ");

var $2M1hQ = parcelRequire("2M1hQ");
const $4f455891fb36bf50$var$inExperimentCohortJiraSideNavMSRExperiment = ()=>{
    // We need to use UNSAFE_noExposureExp to check if jira-side-nav experiment is enabled without firing exposure events
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [sideNavExpConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('post_office_jira_side_nav_exp_msr_vs_no_rec');
    return sideNavExpConfig.get('isEnabled', false);
};
const $4f455891fb36bf50$var$conditionalPostOfficeJiraSideNavResource = (0, $gNStA.resourceWithCondition2)(()=>!(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('post_office_ssr_jira_side_nav_enabled') && $4f455891fb36bf50$var$inExperimentCohortJiraSideNavMSRExperiment(), (0, $5pSYQ.postOfficeJiraSideNavResource));
const $4f455891fb36bf50$var$isModernIssueTransitionSettingEnabled = ()=>{
    return (0, $6s1PB.expVal)('jira_issue_transition_screen_modernisation_toggle', 'value', 'OFF') !== 'OFF';
};
const $4f455891fb36bf50$var$conditionalGicOptInStatusResource = (0, $gNStA.resourceWithCondition)(()=>(0, $4R6GH.fg)('render_modern_global_issue_create_modal_experience'), (0, $f5nIZ.gicOptInStatusResources));
const $4f455891fb36bf50$var$conditionalIssueTransitionOptInStatusResource = (0, $gNStA.resourceWithCondition)($4f455891fb36bf50$var$isModernIssueTransitionSettingEnabled, (0, $fNOVA.issueTransitionOptInStatusResource));
const $4f455891fb36bf50$var$conditionalGicSmartFieldsOptoutResource = (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('migrate_gic_smart_fields_jira_labs'), (0, $aA974.gicSmartFieldsFeatureResource));
const $4f455891fb36bf50$export$e1afa08027b1e44b = ()=>[
        $4f455891fb36bf50$var$conditionalIssueTransitionOptInStatusResource,
        (0, $9MiT2.issueTransitionChangeboardingPreferencesResource)
    ];
const $4f455891fb36bf50$var$conditionalOperationsJiraSideNavResource = (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_ssr_jira_side_nav_enabled'), (0, $bHhiy.getConsolidationStateResource)(), (0, $2M1hQ.createResource)({
    type: `${(0, $5a94e356f9d5e220$export$25ee35b01de9d734)}_NOOP`,
    getKey: ()=>`${0, $5a94e356f9d5e220$export$25ee35b01de9d734}_NOOP`,
    getData: async ()=>null,
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: false
}));
// There is a best effort duplicate removal in the `getRoutes` function but it
// only works if the resources have the same instance. b/c resourceWithCondition2
// will create a new reference each time it is run, by keeping this outside the
// route factory, we can ensure that the duplicate removal works when it is used
// in multiple places.
const $4f455891fb36bf50$var$dedupableConditionalResources = [
    (0, $gNStA.resourceWithCondition2)((0, $3HwlS.getWillShowNav4), (0, $2fwuR.sidebarNav4Resource)),
    (0, $gNStA.resourceWithCondition2)((0, $3HwlS.getWillShowNav4), (0, $2fwuR.sidebarNav4UiStateResource)),
    (0, $gNStA.resourceWithCondition2)((0, $3HwlS.getWillShowNav4), (0, $fwzEJ.topNav4UIStateResource)),
    $4f455891fb36bf50$var$conditionalOperationsJiraSideNavResource
];
const $4f455891fb36bf50$export$75cffd1aaecf4a2c = ()=>[
        (0, $c34Wf.navigationUiStateResource),
        (0, $h9iZl.navigationPlansVisibilityResource),
        (0, $9vlEn.userHomepageResource),
        $4f455891fb36bf50$var$conditionalGicOptInStatusResource,
        (0, $5kYzp.announcementBannerSettingsV4Resource),
        (0, $2eyDn.consentBannerUserPreferencesResource),
        (0, $kMiZJ.consolidationUserStateResource),
        ...$4f455891fb36bf50$var$dedupableConditionalResources,
        (0, $2Ql51.themePreferenceResource),
        ...$4f455891fb36bf50$export$e1afa08027b1e44b(),
        (0, $3X1Xr.persistentIssueCreateModalViewResource),
        $4f455891fb36bf50$var$conditionalGicSmartFieldsOptoutResource,
        (0, $hZhhj.incomingMailServerExpiryStatusResource),
        (0, $kkNtb.rovoEntitlementResource),
        (0, $lXNZG.jpdRecommendationDismissedResource),
        (0, $51Yl2.fetchUserTraitsResource),
        (0, $4dc0x.fetchSiteTraitsResource),
        $4f455891fb36bf50$var$conditionalPostOfficeJiraSideNavResource
    ];
const $4f455891fb36bf50$export$c57dc1ea7f76f91f = ()=>[
        (0, $7xTO3.staticJSWUserBoardSidebarNavigationResource)
    ];
const $4f455891fb36bf50$export$af2259a87f79645d = ()=>[
        (0, $c1N9v.staticPlanSidebarNavigationResource)
    ];
const $4f455891fb36bf50$export$a103e99ad51f7bc3 = ()=>[
        (0, $atU1t.navigationSidebarGlobalResource),
        (0, $bHhiy.getConsolidationStateResource)(),
        (0, $drGWM.checkApiKeyManagementKeysResource)()
    ];
const $4f455891fb36bf50$export$808691f5a412afa3 = ()=>[
        (0, $eOlBz.newIssueViewTransitionLockInStatusResource),
        (0, $kJQXA.navigationSidebarAutomationLegacyEnabledResource),
        (0, $dxCvy.projectContextResourceWithCache),
        (0, $5bkvv.forgeProjectSettingsModuleResource),
        (0, $loy04.staticProjectSettingsSidebarConnectAddonsNavigationResource)
    ];

});
parcelRegister("5kYzp", function(module, exports) {

$parcel$export(module.exports, "announcementBannerSettingsV4Resource", () => $76a68e4d8702ab58$export$8fbe7f8de07afffd);
$parcel$export(module.exports, "useAnnouncementBannerSettingsV4Resource", () => $76a68e4d8702ab58$export$6fb72f4a0c177494);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $4AdUG = parcelRequire("4AdUG");

var $2EmJy = parcelRequire("2EmJy");

var $9UEf0 = parcelRequire("9UEf0");
const $76a68e4d8702ab58$export$2a421cd16fa9a95a = (0, $2M1hQ.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $2EmJy.get)(),
            (0, $9UEf0.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000
});
const $76a68e4d8702ab58$export$8fbe7f8de07afffd = (0, $2M1hQ.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS_V4',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $4AdUG.get)(),
            (0, $9UEf0.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000
});
const $76a68e4d8702ab58$export$43d4950a3e443fd3 = ()=>(0, $2YP9W.useResource)($76a68e4d8702ab58$export$2a421cd16fa9a95a);
const $76a68e4d8702ab58$export$6fb72f4a0c177494 = ()=>(0, $2YP9W.useResource)($76a68e4d8702ab58$export$8fbe7f8de07afffd);

});
parcelRegister("4AdUG", function(module, exports) {

$parcel$export(module.exports, "get", () => $90a9ae99ea774144$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $90a9ae99ea774144$export$adaa4cf7ef1b65be);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $90a9ae99ea774144$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $eusud.performGetRequest)('/rest/internal/4/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            content: '',
            bgColor: 'grey',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $jcw0u.default)({
            meta: {
                id: 'settingsV4Get',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};
const $90a9ae99ea774144$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $eusud.performPostRequest)('/rest/internal/4/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'settingsV4Set',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};

});

parcelRegister("2EmJy", function(module, exports) {

$parcel$export(module.exports, "get", () => $02ac2f2e29fd92e6$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $02ac2f2e29fd92e6$export$adaa4cf7ef1b65be);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

const $02ac2f2e29fd92e6$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $eusud.performGetRequest)('/rest/internal/3/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            message: '',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'settingsGet',
            packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $02ac2f2e29fd92e6$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $eusud.performPostRequest)('/rest/internal/3/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'settingsSet',
            packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});
const $981adbf91eeefd26$export$b8b9d90f9e5bd72b = '@atlassian/jira-admin-pages-system-ui-announcement-banner-resources';
const $981adbf91eeefd26$export$5e0c0e8c940630f8 = 'private';
const $981adbf91eeefd26$export$1d5a5b6462188eb3 = 'public';


parcelRegister("9UEf0", function(module, exports) {

$parcel$export(module.exports, "get", () => $0fff4d2d98ff5692$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $0fff4d2d98ff5692$export$adaa4cf7ef1b65be);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

const $0fff4d2d98ff5692$var$key = 'announcementBannerDismissedLast';
const $0fff4d2d98ff5692$export$3988ae62b71be9a3 = async (accoundId)=>{
    try {
        return accoundId != null ? (await (0, $89SaW.getUserProperty)(accoundId, $0fff4d2d98ff5692$var$key)).hashId : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 404 - property has not been previously set
        if (error.statusCode === 404) return null;
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'userDismissGet',
            packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $0fff4d2d98ff5692$export$adaa4cf7ef1b65be = async (accoundId, hashId)=>{
    try {
        return await (0, $89SaW.setUserProperties)(accoundId, $0fff4d2d98ff5692$var$key, JSON.stringify({
            hashId: hashId
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'userDismissSet',
            packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});
parcelRegister("89SaW", function(module, exports) {

$parcel$export(module.exports, "getUserPropertiesUrl", () => $646571db30c23ce6$export$f474e53c8191800a);
$parcel$export(module.exports, "setUserProperties", () => $646571db30c23ce6$export$d0e176862bf869b8);
$parcel$export(module.exports, "getUserProperty", () => $646571db30c23ce6$export$b3126db2ef6e34ed);

var $jJZqs = parcelRequire("jJZqs");

var $6no39 = parcelRequire("6no39");
const $646571db30c23ce6$export$f474e53c8191800a = (accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
const $646571db30c23ce6$export$d0e176862bf869b8 = async (accountId, propertyKey, data)=>{
    const url = $646571db30c23ce6$export$f474e53c8191800a(accountId, propertyKey);
    return fetch(url, {
        ...(0, $6no39.getDefaultOptions)(url),
        method: 'PUT',
        body: data
    });
};
const $646571db30c23ce6$export$b3126db2ef6e34ed = (accountId, propertyKey)=>{
    const url = $646571db30c23ce6$export$f474e53c8191800a(accountId, propertyKey);
    return fetch(url, (0, $6no39.getDefaultOptions)(url)).then((res)=>{
        if (res.status === 200) return res.json();
        return res.text().then((errResp)=>{
            throw new (0, $jJZqs.default)(res.status, errResp);
        });
    }).then((data)=>data.value);
};

});
parcelRegister("6no39", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $b41761551f5f2353$export$430a3269e24b912e);

var $51xpa = parcelRequire("51xpa");
function $b41761551f5f2353$export$430a3269e24b912e(url) {
    const options = {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-force-account-id': 'true',
            // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            Accept: [
                'application/json',
                'text/javascript',
                '*/*'
            ]
        }
    };
    return url ? (0, $51xpa.applyObservabilityHeaders)(url, options) : options;
}
const $b41761551f5f2353$export$ba43bf67f3d48107 = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        'x-atlassian-force-account-id': 'true',
        // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
};

});




parcelRegister("5bkvv", function(module, exports) {

$parcel$export(module.exports, "forgeAdminModuleResource", () => $3d515a0fe8e87c81$export$b9489d8c5c5e3626);
$parcel$export(module.exports, "getNavigationSidebarGlobalSettingsResources", () => $3d515a0fe8e87c81$export$dcc98f4b36ce9223);
$parcel$export(module.exports, "forgeProjectModuleResource", () => $3d515a0fe8e87c81$export$72db683c2914a65e);
$parcel$export(module.exports, "forgeProjectModuleResourceOnNav3Only", () => $3d515a0fe8e87c81$export$9f19b684a7493211);
$parcel$export(module.exports, "forgeBacklogModuleResource", () => $3d515a0fe8e87c81$export$7523db37432ba090);
$parcel$export(module.exports, "forgeBoardModuleResource", () => $3d515a0fe8e87c81$export$cfd99f451b423d3a);
$parcel$export(module.exports, "forgeSprintModuleResource", () => $3d515a0fe8e87c81$export$7b639f33f086f9f1);
$parcel$export(module.exports, "forgePersonalSettingsPageModuleResource", () => $3d515a0fe8e87c81$export$8a5aed164e925eb6);
$parcel$export(module.exports, "getNavigationForgePersonalSettingsPageResources", () => $3d515a0fe8e87c81$export$ec3265610584f9ce);
$parcel$export(module.exports, "forgeProjectSettingsModuleResource", () => $3d515a0fe8e87c81$export$7a928d209faf75f);
$parcel$export(module.exports, "useForgeProjectSettingsModuleResource", () => $3d515a0fe8e87c81$export$e81e11bbc3239153);
$parcel$export(module.exports, "forgeGlobalModuleResource", () => $3d515a0fe8e87c81$export$97b0827022fdafe3);
$parcel$export(module.exports, "getNavigationForgeGlobalPageResources", () => $3d515a0fe8e87c81$export$80b2f91dabb3dd65);
$parcel$export(module.exports, "forgeServiceDeskQueueModuleResource", () => $3d515a0fe8e87c81$export$ebf5369e4dcfad00);
$parcel$export(module.exports, "forgeCustomFieldTypeResource", () => $3d515a0fe8e87c81$export$e6be2f0ca0849869);

var $8O7FC = parcelRequire("8O7FC");

var $4R6GH = parcelRequire("4R6GH");

var $k2DRb = parcelRequire("k2DRb");

var $iVaKa = parcelRequire("iVaKa");

var $3HwlS = parcelRequire("3HwlS");

var $dK8AG = parcelRequire("dK8AG");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $1yLrr = parcelRequire("1yLrr");
const $3d515a0fe8e87c81$export$eb46cc3d7c1a6649 = (params, moduleName)=>{
    const isModuleWithAccessNarrowing = [
        (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE),
        (0, $k2DRb.PROJECT_PAGE_MODULE),
        (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE)
    ] // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .includes(moduleName);
    const projectIdOrKey = (0, $dK8AG.getProjectKeyOrId)(params);
    if (typeof projectIdOrKey === 'string' && projectIdOrKey !== '' && isModuleWithAccessNarrowing) return {
        projectIdOrKey: projectIdOrKey
    };
    return null;
};
const $3d515a0fe8e87c81$export$b9489d8c5c5e3626 = (0, $2M1hQ.createResource)({
    type: 'FORGE_ADMIN_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.ADMIN_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.ADMIN_PAGE_MODULE], (0, $1yLrr.adminPageFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$dcc98f4b36ce9223 = ()=>[
        $3d515a0fe8e87c81$export$b9489d8c5c5e3626
    ];
const $3d515a0fe8e87c81$export$72db683c2914a65e = (0, $2M1hQ.createResource)({
    type: 'FORGE_PROJECT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.PROJECT_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.PROJECT_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$9f19b684a7493211 = (0, $gNStA.resourceWithCondition2)(()=>!((0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('perf-push-big-components-nav-remove-resources')), $3d515a0fe8e87c81$export$72db683c2914a65e);
const $3d515a0fe8e87c81$export$88e58f509f84795a = (0, $2M1hQ.createResource)({
    type: 'FORGE_BACKLOG_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.BACKLOG_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_ROUTER)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.BACKLOG_ACTION_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$7523db37432ba090 = (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('forge-ui-project-web-items'), $3d515a0fe8e87c81$export$88e58f509f84795a);
const $3d515a0fe8e87c81$export$21d6f142a9a5af9d = (0, $2M1hQ.createResource)({
    type: 'FORGE_BOARD_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.BOARD_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_ROUTER)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.BOARD_ACTION_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$cfd99f451b423d3a = (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('forge-ui-project-web-items'), $3d515a0fe8e87c81$export$21d6f142a9a5af9d);
const $3d515a0fe8e87c81$export$359545c53f9bb33c = (0, $2M1hQ.createResource)({
    type: 'FORGE_SPRINT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.SPRINT_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_ROUTER)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.SPRINT_ACTION_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$7b639f33f086f9f1 = (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('forge-ui-project-web-items'), $3d515a0fe8e87c81$export$359545c53f9bb33c);
const $3d515a0fe8e87c81$export$72583833ca0600c0 = (0, $2M1hQ.createResource)({
    type: 'FORGE_PERSONAL_SETTINGS_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$8a5aed164e925eb6 = (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('forge-ui-project-web-items'), $3d515a0fe8e87c81$export$72583833ca0600c0);
const $3d515a0fe8e87c81$export$ec3265610584f9ce = ()=>[
        $3d515a0fe8e87c81$export$8a5aed164e925eb6
    ];
const $3d515a0fe8e87c81$export$7a928d209faf75f = (0, $2M1hQ.createResource)({
    type: 'FORGE_PROJECT_SETTINGS_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$e81e11bbc3239153 = ()=>(0, $2YP9W.useResource)($3d515a0fe8e87c81$export$7a928d209faf75f);
const $3d515a0fe8e87c81$export$97b0827022fdafe3 = (0, $2M1hQ.createResource)({
    type: 'FORGE_GLOBAL_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.GLOBAL_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.GLOBAL_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$80b2f91dabb3dd65 = ()=>[
        $3d515a0fe8e87c81$export$97b0827022fdafe3
    ];
const $3d515a0fe8e87c81$export$ebf5369e4dcfad00 = (0, $2M1hQ.createResource)({
    type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $dK8AG.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $dK8AG.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $k2DRb.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, $k2DRb.SERVICEDESK_QUEUE_PAGE_MODULE], (0, $1yLrr.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $3d515a0fe8e87c81$export$e6be2f0ca0849869 = (0, $2M1hQ.createResource)({
    type: 'FORGE_CUSTOM_FIELD_TYPE_MODULE',
    getKey: ()=>'extensions',
    getData: (_route, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_NAVIGATION)
        }).then(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (modules)=>modules[0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE]),
    maxAge: Number.MAX_SAFE_INTEGER
});
/**
 * Makes sure modules are filtered out depending on the predicate and sorted alphabetically by title.
 */ function $3d515a0fe8e87c81$var$normalizeModules(modules, filter) {
    return filter(modules).sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a.properties.title, b.properties.title));
}

});
parcelRegister("8O7FC", function(module, exports) {

$parcel$export(module.exports, "alphabeticalSort", () => $7c4745a46edf6307$export$89a1f01f2a7cb2a1);

var $dJl1T = parcelRequire("dJl1T");
const $7c4745a46edf6307$export$89a1f01f2a7cb2a1 = (a, b)=>{
    // @ts-expect-error This condition will always return true since this function is always defined. Did you mean to call it instead?ts(2774)
    if (a && b && a.localeCompare && b.localeCompare) return a.localeCompare(b, 'en', {
        numeric: true,
        caseFirst: 'upper'
    });
    const typeOfA = a === null ? 'null' : typeof a;
    const typeOfB = b === null ? 'null' : typeof b;
    const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
    (0, $dJl1T.default).safeErrorWithoutCustomerData('software.board.filter', 'localeCompare is not a function', error);
    return 1;
};

});

parcelRegister("k2DRb", function(module, exports) {

$parcel$export(module.exports, "STAGING_ENVIRONMENT", () => $e80aa4d4aac5b0dc$export$71acbd662c478c42);
$parcel$export(module.exports, "DEVELOPMENT_ENVIRONMENT", () => $e80aa4d4aac5b0dc$export$978072fd3fd149);
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT_KEY", () => $e80aa4d4aac5b0dc$export$ebc15d9cebfd6063);
$parcel$export(module.exports, "BACKLOG_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$516a8fb49ad5d50e);
$parcel$export(module.exports, "BOARD_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$6cc3a1f2111dee11);
$parcel$export(module.exports, "SPRINT_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$cfb15d127f20a01f);
$parcel$export(module.exports, "ISSUE_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16);
$parcel$export(module.exports, "COMMAND_PALETTE_MODULE", () => $e80aa4d4aac5b0dc$export$65ebd2e1f63d2992);
$parcel$export(module.exports, "ISSUE_GLANCE_MODULE", () => $e80aa4d4aac5b0dc$export$259bab989b0129d0);
$parcel$export(module.exports, "ISSUE_CONTEXT_MODULE", () => $e80aa4d4aac5b0dc$export$75f224942f595e13);
$parcel$export(module.exports, "ISSUE_PANEL_MODULE", () => $e80aa4d4aac5b0dc$export$ba0968f9752844);
$parcel$export(module.exports, "ISSUE_NAVIGATOR_ACTION_MODULE", () => $e80aa4d4aac5b0dc$export$7e2136b4285d29f5);
$parcel$export(module.exports, "ISSUE_ACTIVITY_MODULE", () => $e80aa4d4aac5b0dc$export$cc20a5638825fbb0);
$parcel$export(module.exports, "ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE", () => $e80aa4d4aac5b0dc$export$9069d4b945c3d532);
$parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", () => $e80aa4d4aac5b0dc$export$811b7f067a43b422);
$parcel$export(module.exports, "CUSTOM_FIELD_MODULE", () => $e80aa4d4aac5b0dc$export$e3887d6bafe8a17);
$parcel$export(module.exports, "CUSTOM_FIELD_TYPE_MODULE", () => $e80aa4d4aac5b0dc$export$7b7866c04a2ad947);
$parcel$export(module.exports, "ADMIN_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0);
$parcel$export(module.exports, "PERSONAL_SETTINGS_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$a8cd23a3cbda9d58);
$parcel$export(module.exports, "PROJECT_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$151b03356f566603);
$parcel$export(module.exports, "PROJECT_SETTINGS_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636);
$parcel$export(module.exports, "GLOBAL_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$31ac745ab2add7cc);
$parcel$export(module.exports, "DASHBOARD_BACKGROUND_SCRIPT_MODULE", () => $e80aa4d4aac5b0dc$export$353acf28daa75c79);
$parcel$export(module.exports, "DASHBOARD_GADGET_MODULE", () => $e80aa4d4aac5b0dc$export$25627f012b21b0b9);
$parcel$export(module.exports, "WORKFLOW_VALIDATOR_MODULE", () => $e80aa4d4aac5b0dc$export$42d6a8740fd42e58);
$parcel$export(module.exports, "WORKFLOW_CONDITION_MODULE", () => $e80aa4d4aac5b0dc$export$a7186e5a73395db4);
$parcel$export(module.exports, "WORKFLOW_POST_FUNCTION_MODULE", () => $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17);
$parcel$export(module.exports, "SERVICEDESK_QUEUE_PAGE_MODULE", () => $e80aa4d4aac5b0dc$export$8af4cb794979f60d);
$parcel$export(module.exports, "SERVICEDESK_ORGANIZATION_PANEL_MODULE", () => $e80aa4d4aac5b0dc$export$5592ab836d562168);
$parcel$export(module.exports, "SERVICEDESK_ASSETS_IMPORT_TYPE_MODULE", () => $e80aa4d4aac5b0dc$export$842eb4236828ac9);
$parcel$export(module.exports, "SUPPORTED_MODULES", () => $e80aa4d4aac5b0dc$export$9b1a91242ce2a1b7);
$parcel$export(module.exports, "ENTRY_POINT_EDIT", () => $e80aa4d4aac5b0dc$export$2b8aeda236486576);
$parcel$export(module.exports, "ENTRY_POINT_VIEW", () => $e80aa4d4aac5b0dc$export$c41ce1ec1ea6e73d);
$parcel$export(module.exports, "ENTRY_POINT_CREATE", () => $e80aa4d4aac5b0dc$export$b37d58c3ed77c139);
$parcel$export(module.exports, "ENTRY_POINT_CONTEXT_CONFIG", () => $e80aa4d4aac5b0dc$export$ab94dbd1d02ac251);
$parcel$export(module.exports, "NONE_PANEL_INSTANCE_ID", () => $e80aa4d4aac5b0dc$export$b6a67a3131c6c48d);
$parcel$export(module.exports, "ISSUE_PANEL_MULTIPLE_LIMIT", () => $e80aa4d4aac5b0dc$export$b75dc2bfd20898fe);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_NATIVE", () => $e80aa4d4aac5b0dc$export$8e96118a698216cb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BASIC", () => $e80aa4d4aac5b0dc$export$9b72a8e9b92658fb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BLANK", () => $e80aa4d4aac5b0dc$export$2d6539e7d0553ae7);
$parcel$export(module.exports, "SOURCE_UNKNOWN", () => $e80aa4d4aac5b0dc$export$ecbd7135d66cb322);
$parcel$export(module.exports, "SOURCE_GLOBAL_ISSUE_CREATE", () => $e80aa4d4aac5b0dc$export$61d882aa7aba51c);
$parcel$export(module.exports, "SOURCE_ISSUE_VIEW", () => $e80aa4d4aac5b0dc$export$46cb92762d68a048);
$parcel$export(module.exports, "SOURCE_NAVIGATION", () => $e80aa4d4aac5b0dc$export$fe90e46aea58e30b);
$parcel$export(module.exports, "SOURCE_FULL_PAGE_APP", () => $e80aa4d4aac5b0dc$export$c5ccbdb9893f2a6a);
$parcel$export(module.exports, "SOURCE_ROUTER", () => $e80aa4d4aac5b0dc$export$eae46a3c13473a8d);
$parcel$export(module.exports, "SOURCE_LEGACY", () => $e80aa4d4aac5b0dc$export$ac11ee191d09688f);
$parcel$export(module.exports, "SOURCE_ORGANIZATION_PANEL", () => $e80aa4d4aac5b0dc$export$4346e4e240c84319);
$parcel$export(module.exports, "SOURCE_ASSETS_IMPORT_TYPE", () => $e80aa4d4aac5b0dc$export$d719bb340dc354e4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JIRA", () => $e80aa4d4aac5b0dc$export$4b6228758e800433);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JSM", () => $e80aa4d4aac5b0dc$export$70495c8cc141a7a4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CMDB", () => $e80aa4d4aac5b0dc$export$bc3d408418fdf9d2);
$parcel$export(module.exports, "getEmptyExtensionsObject", () => $e80aa4d4aac5b0dc$export$218a328f66b86f7d);
$parcel$export(module.exports, "FORGE_FIELD_TYPE_PREFIX", () => $e80aa4d4aac5b0dc$export$3193d714ab54ee26);
$parcel$export(module.exports, "PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $e80aa4d4aac5b0dc$export$df7774a415710cce);
$parcel$export(module.exports, "LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $e80aa4d4aac5b0dc$export$51ab2784839ce348);
const $e80aa4d4aac5b0dc$export$9af0088c49bdedb = 'PRODUCTION';
const $e80aa4d4aac5b0dc$export$71acbd662c478c42 = 'STAGING';
const $e80aa4d4aac5b0dc$export$978072fd3fd149 = 'DEVELOPMENT';
const $e80aa4d4aac5b0dc$export$ebc15d9cebfd6063 = 'default';
const $e80aa4d4aac5b0dc$export$516a8fb49ad5d50e = 'jira:backlogAction';
const $e80aa4d4aac5b0dc$export$6cc3a1f2111dee11 = 'jira:boardAction';
const $e80aa4d4aac5b0dc$export$cfb15d127f20a01f = 'jira:sprintAction';
const $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16 = 'jira:issueAction';
const $e80aa4d4aac5b0dc$export$65ebd2e1f63d2992 = 'jira:command';
const $e80aa4d4aac5b0dc$export$259bab989b0129d0 = 'jira:issueGlance';
const $e80aa4d4aac5b0dc$export$75f224942f595e13 = 'jira:issueContext';
const $e80aa4d4aac5b0dc$export$ba0968f9752844 = 'jira:issuePanel';
const $e80aa4d4aac5b0dc$export$7e2136b4285d29f5 = 'jira:issueNavigatorAction';
const $e80aa4d4aac5b0dc$export$cc20a5638825fbb0 = 'jira:issueActivity';
const $e80aa4d4aac5b0dc$export$9069d4b945c3d532 = 'jira:issueViewBackgroundScript';
const $e80aa4d4aac5b0dc$export$811b7f067a43b422 = 'jira:uiModifications';
const $e80aa4d4aac5b0dc$export$e3887d6bafe8a17 = 'jira:customField';
const $e80aa4d4aac5b0dc$export$7b7866c04a2ad947 = 'jira:customFieldType';
const $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0 = 'jira:adminPage';
const $e80aa4d4aac5b0dc$export$a8cd23a3cbda9d58 = 'jira:personalSettingsPage';
const $e80aa4d4aac5b0dc$export$151b03356f566603 = 'jira:projectPage';
const $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636 = 'jira:projectSettingsPage';
const $e80aa4d4aac5b0dc$export$31ac745ab2add7cc = 'jira:globalPage';
const $e80aa4d4aac5b0dc$export$353acf28daa75c79 = 'jira:dashboardBackgroundScript';
const $e80aa4d4aac5b0dc$export$25627f012b21b0b9 = 'jira:dashboardGadget';
const $e80aa4d4aac5b0dc$export$42d6a8740fd42e58 = 'jira:workflowValidator';
const $e80aa4d4aac5b0dc$export$a7186e5a73395db4 = 'jira:workflowCondition';
const $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17 = 'jira:workflowPostFunction';
const $e80aa4d4aac5b0dc$export$8af4cb794979f60d = 'jiraServiceManagement:queuePage';
const $e80aa4d4aac5b0dc$export$5592ab836d562168 = 'jiraServiceManagement:organizationPanel';
const $e80aa4d4aac5b0dc$export$842eb4236828ac9 = 'jiraServiceManagement:assetsImportType';
const $e80aa4d4aac5b0dc$export$9b1a91242ce2a1b7 = [
    $e80aa4d4aac5b0dc$export$516a8fb49ad5d50e,
    $e80aa4d4aac5b0dc$export$65ebd2e1f63d2992,
    $e80aa4d4aac5b0dc$export$6cc3a1f2111dee11,
    $e80aa4d4aac5b0dc$export$cfb15d127f20a01f,
    $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16,
    $e80aa4d4aac5b0dc$export$259bab989b0129d0,
    $e80aa4d4aac5b0dc$export$75f224942f595e13,
    $e80aa4d4aac5b0dc$export$7e2136b4285d29f5,
    $e80aa4d4aac5b0dc$export$ba0968f9752844,
    $e80aa4d4aac5b0dc$export$cc20a5638825fbb0,
    $e80aa4d4aac5b0dc$export$9069d4b945c3d532,
    $e80aa4d4aac5b0dc$export$811b7f067a43b422,
    $e80aa4d4aac5b0dc$export$e3887d6bafe8a17,
    $e80aa4d4aac5b0dc$export$7b7866c04a2ad947,
    $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0,
    $e80aa4d4aac5b0dc$export$a8cd23a3cbda9d58,
    $e80aa4d4aac5b0dc$export$151b03356f566603,
    $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636,
    $e80aa4d4aac5b0dc$export$31ac745ab2add7cc,
    $e80aa4d4aac5b0dc$export$353acf28daa75c79,
    $e80aa4d4aac5b0dc$export$25627f012b21b0b9,
    $e80aa4d4aac5b0dc$export$8af4cb794979f60d,
    $e80aa4d4aac5b0dc$export$5592ab836d562168,
    $e80aa4d4aac5b0dc$export$842eb4236828ac9,
    $e80aa4d4aac5b0dc$export$42d6a8740fd42e58,
    $e80aa4d4aac5b0dc$export$a7186e5a73395db4,
    $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17
];
const $e80aa4d4aac5b0dc$export$2b8aeda236486576 = 'edit';
const $e80aa4d4aac5b0dc$export$c41ce1ec1ea6e73d = 'view';
const $e80aa4d4aac5b0dc$export$b37d58c3ed77c139 = 'create';
const $e80aa4d4aac5b0dc$export$ab94dbd1d02ac251 = 'contextConfig';
const $e80aa4d4aac5b0dc$export$b6a67a3131c6c48d = 'none';
const $e80aa4d4aac5b0dc$export$b75dc2bfd20898fe = 5;
const $e80aa4d4aac5b0dc$export$8e96118a698216cb = 'native';
const $e80aa4d4aac5b0dc$export$9b72a8e9b92658fb = 'basic';
const $e80aa4d4aac5b0dc$export$2d6539e7d0553ae7 = 'blank';
const $e80aa4d4aac5b0dc$export$ecbd7135d66cb322 = 'unknownSource';
const $e80aa4d4aac5b0dc$export$61d882aa7aba51c = 'global-issue-create';
const $e80aa4d4aac5b0dc$export$46cb92762d68a048 = 'issue-view';
const $e80aa4d4aac5b0dc$export$fe90e46aea58e30b = 'navigation';
const $e80aa4d4aac5b0dc$export$c5ccbdb9893f2a6a = 'full-page-app';
const $e80aa4d4aac5b0dc$export$eae46a3c13473a8d = 'router';
const $e80aa4d4aac5b0dc$export$ac11ee191d09688f = 'legacy';
const $e80aa4d4aac5b0dc$export$4346e4e240c84319 = 'organization-panel';
const $e80aa4d4aac5b0dc$export$d719bb340dc354e4 = 'assets-import-type';
const $e80aa4d4aac5b0dc$export$4b6228758e800433 = 'jira';
const $e80aa4d4aac5b0dc$export$70495c8cc141a7a4 = 'jsm';
const $e80aa4d4aac5b0dc$export$bc3d408418fdf9d2 = 'cmdb';
const $e80aa4d4aac5b0dc$export$a48dade1864725a = {
    jiraBacklogAction: [],
    jiraBoardAction: [],
    jiraSprintAction: [],
    jiraIssueAction: [],
    jiraIssueContext: [],
    jiraIssueGlance: [],
    jiraIssuePanel: [],
    jiraIssueNavigatorAction: [],
    jiraIssueActivity: [],
    jiraIssueViewBackgroundScript: [],
    jiraCustomField: [],
    jiraCustomFieldType: [],
    jiraUiModifications: [],
    jiraAdminPage: [],
    jiraGlobalPage: [],
    jiraPersonalSettingsPage: [],
    jiraProjectPage: [],
    jiraProjectSettingsPage: [],
    jiraDashboardBackgroundScript: [],
    jiraDashboardGadget: [],
    jiraServiceManagementQueuePage: [],
    jiraServiceManagementOrganizationPanel: [],
    jiraServiceManagementAssetsImportType: [],
    jiraWorkflowValidator: [],
    jiraWorkflowCondition: [],
    jiraWorkflowPostFunction: [],
    jiraCommand: []
};
/**
 * The above EMPTY_EXTENSIONS_OBJECT sometimes is mutated.
 * @see getEmptyExtensionsObject
 */ const $e80aa4d4aac5b0dc$var$STABLE_EMPTY_EXTENSIONS_OBJECT = {
    ...$e80aa4d4aac5b0dc$export$a48dade1864725a
};
const $e80aa4d4aac5b0dc$export$218a328f66b86f7d = ()=>({
        ...$e80aa4d4aac5b0dc$var$STABLE_EMPTY_EXTENSIONS_OBJECT
    });
const $e80aa4d4aac5b0dc$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
const $e80aa4d4aac5b0dc$export$df7774a415710cce = 'com.atlassian.forge:';
const $e80aa4d4aac5b0dc$export$51ab2784839ce348 = `${$e80aa4d4aac5b0dc$export$df7774a415710cce}${$e80aa4d4aac5b0dc$export$3193d714ab54ee26}`;

});

parcelRegister("iVaKa", function(module, exports) {

$parcel$export(module.exports, "fetchModules", () => $1b1a9656c7bb4ee4$export$24d8e11b15325c53);

var $gPjkL = parcelRequire("gPjkL");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $bPtOr = parcelRequire("bPtOr");

var $dYScp = parcelRequire("dYScp");

var $hBuqR = parcelRequire("hBuqR");

var $bOLUk = parcelRequire("bOLUk");

var $k2DRb = parcelRequire("k2DRb");

var $5yJb9 = parcelRequire("5yJb9");

var $gPjkL = parcelRequire("gPjkL");

var $d5W4H = parcelRequire("d5W4H");

var $h8M2b = parcelRequire("h8M2b");

var $ioGTN = parcelRequire("ioGTN");
const $1b1a9656c7bb4ee4$export$24d8e11b15325c53 = async (params)=>{
    const { types: types, cloudId: cloudId, isAnonymous: isAnonymous, source: source = (0, $k2DRb.SOURCE_UNKNOWN) } = params;
    if (!(0, $d5W4H.canFetchForgeModules)({
        cloudId: cloudId,
        isAnonymous: isAnonymous
    })) return (0, $h8M2b.toMappedExtensions)(types, []);
    try {
        const extensions = await (0, $dYScp.measureExecutionTimeMetrics)(()=>$1b1a9656c7bb4ee4$export$9f9fdbce0829073d(params));
        if (Math.random() * 100 < (0, $hBuqR.FORGE_SAMPLING_RATE)) (0, $bOLUk.fireInitializationFetchFinishedEvent)(source);
        return (0, $h8M2b.toMappedExtensions)(types, extensions);
    } catch (error) {
        const errorType = (0, $bPtOr.getErrorType)(error);
        (0, $bOLUk.fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error
        });
        if ($1b1a9656c7bb4ee4$export$458cbcb6374269d2.includes(errorType)) return (0, $h8M2b.toMappedExtensions)(types, []);
        throw error;
    }
};
function $1b1a9656c7bb4ee4$export$9f9fdbce0829073d(props) {
    const { cloudId: cloudId, types: types, context: context, includeHidden: includeHidden, includeScopes: includeScopes = false } = props;
    if (types.length === 0) throw new Error('No modules to fetch provided');
    const operationName = (0, $gPjkL.default).params.name;
    const { stopGraphQLErrorTracking: stopGraphQLErrorTracking, getGraphQLError: getGraphQLError } = (0, $ioGTN.trackGraphQLErrors)(operationName);
    let extensions;
    return new Promise((resolve, reject)=>{
        const subscription = (0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), /* eslint-disable @atlassian/relay/unused-fields */ (0, $gPjkL.default), /* eslint-enable @atlassian/relay/unused-fields */ {
            cloudId: cloudId,
            context: context,
            types: types,
            includeHidden: includeHidden,
            includeScopes: includeScopes,
            includeUserAccess: (0, $4R6GH.fg)('forge_query_include_user_access'),
            includeEgressOverridesForge: (0, $4R6GH.fg)('forge-ui-overrides-property-in-extension-list')
        }).subscribe({
            next: (response)=>{
                stopGraphQLErrorTracking();
                extensions = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                response.jira?.forge?.extensions?.concat() || null;
            },
            error: (error)=>{
                stopGraphQLErrorTracking();
                reject(error);
                subscription.unsubscribe();
            },
            complete: ()=>{
                // If there is a GraphQL error and extensions are `null`, it means a critical error has happened, and we have to reject the promise.
                // However, if the list of extensions is present in the response, it shouldn't be considered an error.
                const graphQLError = getGraphQLError();
                if (graphQLError) extensions != null ? resolve(extensions || []) : reject(graphQLError);
                else resolve(extensions || []);
                subscription.unsubscribe();
            }
        });
    });
}
const $1b1a9656c7bb4ee4$export$458cbcb6374269d2 = [
    (0, $bPtOr.FAILED_TO_FETCH),
    (0, $bPtOr.AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
    (0, $bPtOr.DATA_CLASSIFICATION_NO_ACCESS)
];

});
parcelRegister("gPjkL", function(module, exports) {

$parcel$export(module.exports, "default", () => $13cd104237d48c31$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<286bb4c6ceb265e5eb2e0d5df4a57064>>
 * @relayHash dd7c45d529c38ee961ca9a9708badae6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0e226234ccc68e568f2d830cfa59afe1dc09d6e2f777025a9d46b158e0f8f7a5
const $13cd104237d48c31$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeEgressOverridesForge"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeHidden"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeScopes"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeUserAccess"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "types"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraForgeQuery",
                    "kind": "LinkedField",
                    "name": "forge",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "context"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "includeHidden",
                                    "variableName": "includeHidden"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "types",
                                    "variableName": "types"
                                }
                            ],
                            "concreteType": "JiraForgeExtension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                {
                                    "condition": "includeHidden",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hiddenBy"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeScopes",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopes"
                                        }
                                    ]
                                },
                                v7 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "installationId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "appVersion"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "consentUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "properties"
                                },
                                {
                                    "condition": "includeUserAccess",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraUserAppAccess",
                                            "kind": "LinkedField",
                                            "name": "userAccess",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasAccess"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeAppEgressDeclaration",
                                    "kind": "LinkedField",
                                    "name": "egress",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "addresses"
                                        },
                                        v7 /*: any*/ ,
                                        {
                                            "condition": "includeEgressOverridesForge",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "category"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "inScopeEUD"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeEgressOverridesForge",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "overrides"
                                        },
                                        {
                                            "concreteType": "JiraForgeInstallationConfigExtension",
                                            "kind": "LinkedField",
                                            "name": "installationConfig",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeExtensionLicense",
                                    "kind": "LinkedField",
                                    "name": "license",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "active"
                                        },
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "supportEntitlementNumber"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "trialEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "subscriptionEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEvaluation"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "billingPeriod"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementSlug"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "capabilitySet"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fetchModulesV2Query",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fetchModulesV2Query",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "id": "0e226234ccc68e568f2d830cfa59afe1dc09d6e2f777025a9d46b158e0f8f7a5",
            "metadata": {},
            "name": "fetchModulesV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$13cd104237d48c31$var$node.hash = "075c3b6219ab1d19e86fef2a91134b0c";
var $13cd104237d48c31$export$2e2bcd8739ae039 = $13cd104237d48c31$var$node;

});

parcelRegister("bPtOr", function(module, exports) {

$parcel$export(module.exports, "DATA_CLASSIFICATION_NO_ACCESS", () => $e4bddb38a31390d9$export$23de3198bfe70090);
$parcel$export(module.exports, "FAILED_TO_FETCH", () => $e4bddb38a31390d9$export$f52aa41ccd776f01);
$parcel$export(module.exports, "AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS", () => $e4bddb38a31390d9$export$31d2ab0be67934f0);
$parcel$export(module.exports, "INVOKE_VALUE_FUNCTION_FAILED", () => $e4bddb38a31390d9$export$89a175d4190df42e);
$parcel$export(module.exports, "userConsentErrorRegex", () => $e4bddb38a31390d9$export$dddade71b333c01d);
$parcel$export(module.exports, "getErrorType", () => $e4bddb38a31390d9$export$e19f9f08a6d79fd2);


var $fZneA = parcelRequire("fZneA");

var $bvblX = parcelRequire("bvblX");

var $3vs13 = parcelRequire("3vs13");
const $e4bddb38a31390d9$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $e4bddb38a31390d9$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $e4bddb38a31390d9$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $e4bddb38a31390d9$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $e4bddb38a31390d9$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $e4bddb38a31390d9$export$89a175d4190df42e = 'Invoke value functions failed:';
const $e4bddb38a31390d9$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $e4bddb38a31390d9$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if ((0, $3vs13.isLoaderError)(error) || typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $e4bddb38a31390d9$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $e4bddb38a31390d9$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    // Tracked GraphQL errors contain useful info about internal errors like status codes
    // We want to categorize them more precisely, because some error types aren't SLO critical.
    if (error instanceof (0, $bvblX.TrackedGraphQLError)) {
        if (error.statusCode && error.statusCode >= 400) return error.statusCode === 429 ? $e4bddb38a31390d9$export$7a1bd8c001e7e9c : `ERROR_SERVER_RESPONSE_${error.statusCode}`;
        return 'TRACKED_GRAPHQL_ERROR';
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $e4bddb38a31390d9$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($e4bddb38a31390d9$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($e4bddb38a31390d9$export$89a175d4190df42e, 'i');
    /**
   * In case when we get bad request(400) from the BE it should be treated as an app error as there
   * are many ways to fail the value function
   */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === (0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977);
    /**
   * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
   * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
   */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === (0, $3cd8a0ece36fbae5$export$fa405bbf47d510e2);
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
   * 	Whole message:
   *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
   */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
   * 	Whole message:
   *	Invoke value functions failed: Error server response: 429
   */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $e4bddb38a31390d9$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($e4bddb38a31390d9$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($e4bddb38a31390d9$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $fZneA.isClientFetchError)(error)) return $e4bddb38a31390d9$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("bvblX", function(module, exports) {

$parcel$export(module.exports, "TrackedGraphQLError", () => $b1b2278e9c04b70b$export$f2062ad173e74c75);
class $b1b2278e9c04b70b$export$f2062ad173e74c75 extends Error {
    constructor(errorMessage, errors, traceIds){
        super(errorMessage), this.errorMessage = errorMessage, this.errors = errors, this.traceIds = traceIds;
        this.errors = errors;
        // Get first trace id
        this.traceId = traceIds?.[0];
        // Get first status code
        this.statusCode = errors?.map((graphQLError)=>graphQLError && 'extensions' in graphQLError ? graphQLError?.extensions?.statusCode : null).filter(Boolean)?.[0];
        // Combine error messages
        this.message = errors?.map((graphQLError)=>graphQLError?.message).filter(Boolean).join('; ') ?? errorMessage;
    }
}

});


parcelRegister("dYScp", function(module, exports) {

$parcel$export(module.exports, "measureExecutionTimeMetrics", () => $d79aabebae5ffeb3$export$a859f6866f4653e0);

var $7Jxgt = parcelRequire("7Jxgt");

var $hBuqR = parcelRequire("hBuqR");

var $8kVg1 = parcelRequire("8kVg1");
const $d79aabebae5ffeb3$export$a859f6866f4653e0 = async (action)=>{
    const concurrentId = (0, $7Jxgt.v4)();
    const shouldSendTimeMetric = Math.random() * 100 < (0, $hBuqR.FORGE_SAMPLING_RATE);
    try {
        if (shouldSendTimeMetric) (0, $8kVg1.forgeModulesConcurrentFetchTime)(concurrentId).start({
            startTime: performance.now()
        });
        const result = await action();
        if (shouldSendTimeMetric) (0, $8kVg1.forgeModulesConcurrentFetchTime)(concurrentId).stop({
            stopTime: performance.now()
        });
        return result;
    } catch (error) {
        if (shouldSendTimeMetric) (0, $8kVg1.forgeModulesConcurrentFetchTime)(concurrentId).cancel();
        throw error;
    }
};

});
parcelRegister("hBuqR", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME_GASV3", () => $bbc089ab376d4a7b$export$f892f621fb508154);
$parcel$export(module.exports, "MODULE_TYPE_TRIGGER", () => $bbc089ab376d4a7b$export$ed63b053e04e26df);
$parcel$export(module.exports, "MODULE_TYPE_EXTENSION", () => $bbc089ab376d4a7b$export$725bacc669333eef);
$parcel$export(module.exports, "FORGE_SAMPLING_RATE", () => $bbc089ab376d4a7b$export$d920cee73ec094d0);
$parcel$export(module.exports, "PERFORMANCE_KEYS", () => $bbc089ab376d4a7b$export$f048d91ccaf92408);
$parcel$export(module.exports, "UI_ACTIONS", () => $bbc089ab376d4a7b$export$2b7367f125154866);
$parcel$export(module.exports, "OPERATIONAL_ACTIONS", () => $bbc089ab376d4a7b$export$42bcca5cae2ce90b);
$parcel$export(module.exports, "TRACK_ACTIONS", () => $bbc089ab376d4a7b$export$2af0438304d7c4b2);
// TODO ARKEN-359: uniformise GASv3/BM3 keys to use kebab lowercase
const $bbc089ab376d4a7b$export$f892f621fb508154 = 'jiraForgeUi';
const $bbc089ab376d4a7b$export$273f5980517336e2 = 'jiraforgeui';
const $bbc089ab376d4a7b$export$ed63b053e04e26df = 'trigger';
const $bbc089ab376d4a7b$export$725bacc669333eef = 'extension';
const $bbc089ab376d4a7b$export$d920cee73ec094d0 = 10;
const $bbc089ab376d4a7b$export$f048d91ccaf92408 = {
    FORGE_MODULES: {
        FETCH_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.forge-modules.fetch-time`,
        LOAD_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.forge-modules.load-time`
    },
    REAL_TIME_ISSUE_EVENTS: {
        INVOKE_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.real-time-issue-events.invoke-time`
    },
    MARKS: {
        TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK',
        TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END'
    }
};
const $bbc089ab376d4a7b$export$2b7367f125154866 = {
    CLICKED: 'clicked',
    SELECTED: 'selected',
    CANCELED: 'canceled',
    ACTION_CLICKED: 'action clicked',
    COLLAPSE_EXPAND_CLICKED: 'collapse-expand clicked',
    REMOVE_CLICKED: 'remove clicked'
};
const $bbc089ab376d4a7b$export$42bcca5cae2ce90b = {
    FAILED: 'failed',
    INITIALIZED: 'initialized',
    EDIT_FAILED: 'edit failed',
    ACTION_FAILED: 'action failed',
    SAVE_FAILED: 'save failed',
    REMOVE_FAILED: 'remove failed',
    UPDATE_FAILED: 'update failed'
};
const $bbc089ab376d4a7b$export$2af0438304d7c4b2 = {
    EDITED: 'edited',
    SAVED: 'saved',
    REMOVED: 'removed',
    ACTION_SUCCEED: 'action succeed',
    UPDATE_SUCCEED: 'update succeed'
};

});

parcelRegister("8kVg1", function(module, exports) {

$parcel$export(module.exports, "forgeModulesConcurrentFetchTime", () => $f1fed22795d0c676$export$c3d8833fbea3e976);
$parcel$export(module.exports, "forgeModulesConcurrentLoadTime", () => $f1fed22795d0c676$export$292f3b557281044f);
$parcel$export(module.exports, "realTimeIssueEventInvokeTime", () => $f1fed22795d0c676$export$89ace7e2bb7d7685);
$parcel$export(module.exports, "measureInitialPageLoadAsyncResourcesTiming", () => $f1fed22795d0c676$export$94f65f3b2556df23);
$parcel$export(module.exports, "markAdditionalTimingsFromWindowPerformance", () => $f1fed22795d0c676$export$116d5e25caf0018d);
$parcel$export(module.exports, "customFieldPageSegmentLoadMetric", () => $f1fed22795d0c676$export$3bd38623c2543fc0);
$parcel$export(module.exports, "customFieldInteractionMetric", () => $f1fed22795d0c676$export$a318f99472db73c8);

var $2nKjG = parcelRequire("2nKjG");

var $6RCeq = parcelRequire("6RCeq");

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $hBuqR = parcelRequire("hBuqR");
const $f1fed22795d0c676$export$c3d8833fbea3e976 = (0, $2nKjG.metrics).concurrent.custom({
    key: (0, $hBuqR.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
});
const $f1fed22795d0c676$export$292f3b557281044f = (0, $2nKjG.metrics).concurrent.custom({
    key: (0, $hBuqR.PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
});
const $f1fed22795d0c676$export$89ace7e2bb7d7685 = new (0, $kkzI0.UFOExperience)((0, $hBuqR.PERFORMANCE_KEYS).REAL_TIME_ISSUE_EVENTS.INVOKE_TIME, {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
});
async function $f1fed22795d0c676$export$94f65f3b2556df23(startMark, endMark, fn) {
    if (false || (0, $6RCeq.default).getEntriesByName(startMark).length > 0 || (0, $6RCeq.default).getEntriesByName(endMark).length > 0) return fn();
    (0, $6RCeq.default).mark(startMark);
    const result = await fn();
    (0, $6RCeq.default).mark(endMark);
    return result;
}
const $f1fed22795d0c676$export$116d5e25caf0018d = (metric, additionalTimings)=>{
    additionalTimings.flatMap(({ startMark: startMark, endMark: endMark, cleanStart: cleanStart, cleanEnd: cleanEnd })=>[
            ...(0, $6RCeq.default).getEntriesByName(startMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: cleanStart,
                    cleanEnd: undefined
                })),
            ...(0, $6RCeq.default).getEntriesByName(endMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: undefined,
                    cleanEnd: cleanEnd
                }))
        ]).forEach(({ name: name, startTime: startTime, cleanStart: cleanStart, cleanEnd: cleanEnd })=>{
        metric.mark(name, startTime);
        if (cleanStart || cleanEnd) (0, $6RCeq.default).clearMarks(name);
    });
};
const $f1fed22795d0c676$export$3bd38623c2543fc0 = (additionalTimings = [])=>(0, $2nKjG.metrics).pageSegmentLoad({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings,
            {
                key: 'tti',
                startMark: (0, $hBuqR.PERFORMANCE_KEYS).MARKS.TTI_START,
                endMark: (0, $hBuqR.PERFORMANCE_KEYS).MARKS.TTI_END
            }
        ]
    });
const $f1fed22795d0c676$export$a318f99472db73c8 = (additionalTimings = [])=>(0, $2nKjG.metrics).interaction({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings
        ]
    });

});


parcelRegister("bOLUk", function(module, exports) {

$parcel$export(module.exports, "fireInitializationFetchFinishedEvent", () => $2f4555f4bd0f0eef$export$132ca822850e455f);
$parcel$export(module.exports, "fireInitializationFetchFailedEvent", () => $2f4555f4bd0f0eef$export$b5ca88b1053f1ad0);
$parcel$export(module.exports, "fireInitializationIssueViewFinishedEvent", () => $2f4555f4bd0f0eef$export$e914f7df1e4ad79b);
$parcel$export(module.exports, "fireInitializationIssueViewFailedEvent", () => $2f4555f4bd0f0eef$export$b274c658390b491b);

var $6yg2S = parcelRequire("6yg2S");

var $8uOa6 = parcelRequire("8uOa6");
const $2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS = {
    STARTED: 'started',
    FINISHED: 'finished',
    FAILED: 'failed'
};
const $2f4555f4bd0f0eef$export$917d0643b0111a02 = (0, $6yg2S.toEventId)('issueViewInitialization');
const $2f4555f4bd0f0eef$export$43e875fd63e64525 = (0, $6yg2S.toEventId)('fetchModulesInitialization');
const $2f4555f4bd0f0eef$export$132ca822850e455f = (source, attributes)=>(0, $8uOa6.fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $2f4555f4bd0f0eef$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $2f4555f4bd0f0eef$export$b5ca88b1053f1ad0 = (source, attributes)=>(0, $8uOa6.fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $2f4555f4bd0f0eef$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $2f4555f4bd0f0eef$export$e914f7df1e4ad79b = (source, attributes)=>(0, $8uOa6.fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $2f4555f4bd0f0eef$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });
const $2f4555f4bd0f0eef$export$b274c658390b491b = (source, attributes)=>(0, $8uOa6.fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $2f4555f4bd0f0eef$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });

});
parcelRegister("6yg2S", function(module, exports) {

$parcel$export(module.exports, "toEventId", () => $cb46d7d052e3d68d$export$75e84ef5a3771f9a);
const $cb46d7d052e3d68d$export$75e84ef5a3771f9a = (value)=>value;

});

parcelRegister("8uOa6", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $73635d33815c9f98$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireUiEvent", () => $73635d33815c9f98$export$bed7f228c94e5f2a);
$parcel$export(module.exports, "fireTrackEvent", () => $73635d33815c9f98$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireInitializationEvent", () => $73635d33815c9f98$export$390a62413962e4f0);

var $fjcgS = parcelRequire("fjcgS");

var $hBuqR = parcelRequire("hBuqR");

var $6MtPV = parcelRequire("6MtPV");

var $7yD9b = parcelRequire("7yD9b");

var $eGXs2 = parcelRequire("eGXs2");
const $73635d33815c9f98$var$createAnalyticsProps = ({ id: id, source: // Since source is required in sendOperationalEvent and sendUIEvent we need to pass here a fallback
// in case source is not provided
source = 'unknownSource', action: action, attributes: attributes })=>({
        actionSubject: `${0, $hBuqR.PACKAGE_NAME_GASV3}.${id}`,
        attributes: (0, $6MtPV.createAttributes)(attributes),
        source: source,
        action: action
    });
const $73635d33815c9f98$var$getAnalyticsClient = async ()=>(await (0, $fjcgS.getAnalyticsWebClientPromise)()).getInstance();
const $73635d33815c9f98$var$sendOperationalEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendOperationalEvent($73635d33815c9f98$var$createAnalyticsProps(props));
const $73635d33815c9f98$var$sendUiEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendUIEvent($73635d33815c9f98$var$createAnalyticsProps(props));
const $73635d33815c9f98$var$sendTrackEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendTrackEvent($73635d33815c9f98$var$createAnalyticsProps(props));
const $73635d33815c9f98$export$a1fb57756f0de62b = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendOperationalEvent({
        ...eventProps,
        source: (0, $6MtPV.parseSource)(source),
        action: action
    });
const $73635d33815c9f98$export$bed7f228c94e5f2a = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendUiEvent({
        ...eventProps,
        source: (0, $6MtPV.parseSource)(source),
        action: action
    });
const $73635d33815c9f98$export$574d2f19a52d67ca = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendTrackEvent({
        ...eventProps,
        source: (0, $6MtPV.parseSource)(source),
        action: action
    });
const $73635d33815c9f98$export$390a62413962e4f0 = async (action, { id: id, attributes: attributes, source: source })=>Promise.all([
        $73635d33815c9f98$export$a1fb57756f0de62b(action, {
            id: id,
            attributes: attributes,
            source: source
        }),
        attributes?.error && (0, $7yD9b.logError)((0, $7yD9b.ANALYTICS_UTIL), `Something went wrong with Forge initialization, isSynthetic=${(0, $eGXs2.isSynthetic)().toString()}, id=${id}, source=${(0, $6MtPV.parseSource)(source)}, action=${action}`, attributes.error) || Promise.resolve()
    ]);

});
parcelRegister("6MtPV", function(module, exports) {

$parcel$export(module.exports, "parseSource", () => $31dca5b0e1651a2f$export$e98201ef9a88ba70);
$parcel$export(module.exports, "createAttributes", () => $31dca5b0e1651a2f$export$c7c9603a6b1fd815);

var $84Tib = parcelRequire("84Tib");

var $9uiWt = parcelRequire("9uiWt");

var $bPtOr = parcelRequire("bPtOr");

var $eGXs2 = parcelRequire("eGXs2");
const $31dca5b0e1651a2f$export$e98201ef9a88ba70 = (source)=>source != null ? source.toString() : 'unknownSource';
const $31dca5b0e1651a2f$export$78c6267359db7e73 = (error)=>({
        ...error,
        stack: error.stack,
        message: error?.message
    });
const $31dca5b0e1651a2f$export$c7c9603a6b1fd815 = (rawAttributes)=>{
    const attributes = {
        isSynthetic: (0, $eGXs2.isSynthetic)(),
        isOverridingFragments: (0, $9uiWt.isOverridingFragments)(),
        isSSR: false
    };
    if (rawAttributes) {
        const { source: source, error: error, hasForgeAccess: hasForgeAccess } = rawAttributes;
        if (source) attributes.source = $31dca5b0e1651a2f$export$e98201ef9a88ba70(source);
        if (error) {
            attributes.error = $31dca5b0e1651a2f$export$78c6267359db7e73(error);
            attributes.errorType = (0, $bPtOr.getErrorType)(error);
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($84Tib)))(hasForgeAccess)) attributes.hasForgeAccess = hasForgeAccess;
    }
    return {
        ...rawAttributes,
        ...attributes
    };
};

});
parcelRegister("9uiWt", function(module, exports) {

$parcel$export(module.exports, "isOverridingFragments", () => $c677f4c9cc5e982f$export$1d1321d2b374d697);
const $c677f4c9cc5e982f$export$1d1321d2b374d697 = ()=>{
    if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
    if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
    return false;
};

});

parcelRegister("eGXs2", function(module, exports) {

$parcel$export(module.exports, "isSynthetic", () => $58ae13ec31f88266$export$947749d756ccb0a);

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");
const $58ae13ec31f88266$export$947749d756ccb0a = ()=>// Filter out synthetic tests using all known ways
    (0, $j8DrX.default)('ajs-is-synthetic') === 'true' || (0, $4R6GH.fg)('forge_ui_synthetic_check');

});


parcelRegister("7yD9b", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_UTIL", () => $187fc325525eefe3$export$d1e4f308040bb0d5);
$parcel$export(module.exports, "CUSTOM_FIELD_OBJECT_TYPE", () => $187fc325525eefe3$export$36f315a5c6daf40b);
$parcel$export(module.exports, "logError", () => $187fc325525eefe3$export$58da9968c3170cb1);

var $dJl1T = parcelRequire("dJl1T");

var $hBuqR = parcelRequire("hBuqR");
const $187fc325525eefe3$export$e31edcd35abe3bb1 = 'environment-mapping';
const $187fc325525eefe3$export$d1e4f308040bb0d5 = 'analytics';
const $187fc325525eefe3$export$36f315a5c6daf40b = 'custom-field-object-type';
const $187fc325525eefe3$export$6ee8198f29fffdb4 = {
    [$187fc325525eefe3$export$d1e4f308040bb0d5]: `${(0, $hBuqR.PACKAGE_NAME_GASV3)}.error.utils.analytics`,
    [$187fc325525eefe3$export$e31edcd35abe3bb1]: `${(0, $hBuqR.PACKAGE_NAME_GASV3)}.error.utils.environment-mapping`,
    [$187fc325525eefe3$export$36f315a5c6daf40b]: `${(0, $hBuqR.PACKAGE_NAME_GASV3)}.error.custom-field.object-type`
};
const $187fc325525eefe3$export$58da9968c3170cb1 = (key, message, event)=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData($187fc325525eefe3$export$6ee8198f29fffdb4[key], message, event);
};

});



parcelRegister("5yJb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dfb67cb8d2ba29a$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/relay-runtime

var $eiowN = parcelRequire("eiowN");

var $aWXMn = parcelRequire("aWXMn");
let $0dfb67cb8d2ba29a$var$relayEnvironment;
function $0dfb67cb8d2ba29a$export$2e2bcd8739ae039() {
    if (!$0dfb67cb8d2ba29a$var$relayEnvironment) {
        const environmentConfig = (0, $aWXMn.getRelayEnvironmentConfig)();
        $0dfb67cb8d2ba29a$var$relayEnvironment = new (0, $eiowN.Environment)(environmentConfig);
    }
    return $0dfb67cb8d2ba29a$var$relayEnvironment;
}

});
parcelRegister("aWXMn", function(module, exports) {

$parcel$export(module.exports, "getRelayEnvironmentConfig", () => $eb7981c11bea2531$export$a451c85db2d1cda3);

var $4XQuR = parcelRequire("4XQuR");

var $d89yU = parcelRequire("d89yU");

var $ajdBN = parcelRequire("ajdBN");
const $eb7981c11bea2531$export$a451c85db2d1cda3 = ()=>(0, $ajdBN.getDefaultRelayEnvironmentConfig)({
        network: (0, $d89yU.getNetwork)(),
        log: (0, $4XQuR.default),
        requiredFieldLogger: $4XQuR.requiredFieldLogger
    });

});
parcelRegister("4XQuR", function(module, exports) {

$parcel$export(module.exports, "requiredFieldLogger", () => $50b0aa0805b37d6d$export$1ab8b98d209afe85);
$parcel$export(module.exports, "default", () => $50b0aa0805b37d6d$export$2e2bcd8739ae039);

var $lAOer = parcelRequire("lAOer");

var $dJl1T = parcelRequire("dJl1T");

var $jQsty = parcelRequire("jQsty");
const $50b0aa0805b37d6d$var$RELAY_CLIENT_ID = 'AGG';
const $50b0aa0805b37d6d$var$LOG_NAMESPACE = `relay.${$50b0aa0805b37d6d$var$RELAY_CLIENT_ID}.error.graphql`;
const $50b0aa0805b37d6d$var$requests = {};
const $50b0aa0805b37d6d$var$queries = {};
const $50b0aa0805b37d6d$var$resources = {};
const $50b0aa0805b37d6d$var$executes = {};
const $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT = 300000; // 5 minutes
const $50b0aa0805b37d6d$export$1ab8b98d209afe85 = (event)=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData($50b0aa0805b37d6d$var$LOG_NAMESPACE, '[relay required field error]', {
        kind: event.kind,
        owner: event.owner,
        fieldPath: event.fieldPath,
        message: event.kind === 'relay_resolver.error' ? event.error?.message : null
    });
};
const $50b0aa0805b37d6d$var$getResponseSize = (resp)=>{
    if (resp.data === undefined) return 0;
    try {
        return JSON.stringify(resp.data).length;
    } catch (e) {
        return 0;
    }
};
function $50b0aa0805b37d6d$export$2e2bcd8739ae039(event) {
    if ((0, $jQsty.default)('relay_log')) return;
    switch(event.name){
        // NETWORK
        case 'network.start':
            {
                const networkStart = performance.now();
                const { networkRequestId: networkRequestId } = event;
                const { name: name } = event.params;
                const requestInfo = $50b0aa0805b37d6d$var$requests[networkRequestId];
                if (requestInfo == null) {
                    const newRequestInfo = {
                        name: name,
                        flushes: [],
                        start: networkStart,
                        networkStart: networkStart
                    };
                    $50b0aa0805b37d6d$var$queries[name] = newRequestInfo;
                    $50b0aa0805b37d6d$var$requests[networkRequestId] = newRequestInfo;
                    setTimeout(()=>{
                        delete $50b0aa0805b37d6d$var$requests[networkRequestId];
                        delete $50b0aa0805b37d6d$var$queries[name];
                    }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                } else requestInfo.networkStart = networkStart;
                break;
            }
        case 'network.next':
            {
                const requestInfo = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                if (requestInfo != null) {
                    const { response: response } = event;
                    const addFlush = (resp)=>{
                        if (resp.data !== null) {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const res = resp;
                            const flush = {
                                label: res.label != null ? res.label : 'root',
                                time: performance.now(),
                                size: $50b0aa0805b37d6d$var$getResponseSize(res)
                            };
                            requestInfo.flushes?.push(flush);
                        }
                    };
                    Array.isArray(response) ? response.forEach(addFlush) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    addFlush(response);
                }
                break;
            }
        case 'network.error':
            {
                const info = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                if (info != null) info.error = event.error;
                break;
            }
        case 'network.info':
            break;
        case 'network.complete':
            {
                const requestInfo = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                const networkComplete = performance.now();
                if (requestInfo != null) {
                    const size = requestInfo.flushes.map((f)=>f.size).reduce((p, c)=>p + c, 0);
                    requestInfo.size = size;
                    requestInfo.networkComplete = networkComplete;
                    requestInfo.flushes = [];
                    (0, $lAOer.addSpanToAll)('relay', requestInfo.name, [
                        {
                            name: 'network'
                        }
                    ], requestInfo.start, requestInfo.networkComplete, size);
                }
                break;
            }
        case 'network.unsubscribe':
            break;
        // SUSPENSE
        case 'suspense.fragment':
            break;
        case 'suspense.query':
            break;
        // QUERY
        case 'queryresource.fetch':
            {
                const { node: node } = event.operation.root;
                const fetchStart = performance.now();
                // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                if (node.name != null) {
                    // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                    const { name: name } = node;
                    const requestInfo = $50b0aa0805b37d6d$var$queries[name];
                    if (requestInfo != null) {
                        requestInfo.fetchStart = fetchStart;
                        $50b0aa0805b37d6d$var$resources[event.resourceID] = requestInfo;
                    } else {
                        const newRequestInfo = {
                            name: name,
                            flushes: [],
                            start: fetchStart,
                            fetchStart: fetchStart
                        };
                        $50b0aa0805b37d6d$var$queries[name] = newRequestInfo;
                        $50b0aa0805b37d6d$var$resources[event.resourceID] = newRequestInfo;
                        setTimeout(()=>{
                            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                            delete $50b0aa0805b37d6d$var$queries[node.name];
                        }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                    }
                    setTimeout(()=>{
                        delete $50b0aa0805b37d6d$var$resources[event.resourceID];
                    }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                }
                break;
            }
        case 'queryresource.retain':
            {
                const requestInfo = $50b0aa0805b37d6d$var$resources[event.resourceID];
                if (requestInfo != null && event.profilerContext != null) {
                    requestInfo.end = performance.now();
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const context = event.profilerContext;
                    context?.retainQuery?.(requestInfo);
                }
                break;
            }
        // EXECUTE
        case 'execute.start':
            $50b0aa0805b37d6d$var$executes[event.executeId] = {
                name: event.params.name,
                // @ts-expect-error - TS2322 - Type 'string' is not assignable to type '"query" | "mutation" | "subscription"'.
                kind: event.params.operationKind,
                start: performance.now(),
                duration: 0
            };
            break;
        case 'execute.next':
            $50b0aa0805b37d6d$var$executes[event.executeId].duration += event.duration;
            break;
        case 'execute.async.module':
            break;
        case 'execute.flight.payload_deserialize':
            break;
        case 'execute.error':
            delete $50b0aa0805b37d6d$var$executes[event.executeId];
            break;
        case 'execute.complete':
            {
                const op = $50b0aa0805b37d6d$var$executes[event.executeId];
                if (op != null) {
                    op.end = performance.now();
                    delete $50b0aa0805b37d6d$var$executes[event.executeId];
                }
                break;
            }
        // STORE
        case 'store.publish':
            break;
        case 'store.snapshot':
            break;
        case 'store.restore':
            break;
        case 'store.gc':
            break;
        // FLUSH
        case 'store.notify.start':
            break;
        case 'store.notify.complete':
            break;
        case 'store.notify.subscription':
            break;
        // ENTRYPOINT
        case 'entrypoint.root.consume':
            break;
        default:
            break;
    }
}

});

parcelRegister("d89yU", function(module, exports) {

$parcel$export(module.exports, "getNetwork", () => $7997274d03790a98$export$7de4970ebfd8206d);

var $eiowN = parcelRequire("eiowN");

var $gIJXH = parcelRequire("gIJXH");

var $k1TrK = parcelRequire("k1TrK");

var $fwvto = parcelRequire("fwvto");
const $7997274d03790a98$export$7de4970ebfd8206d = ()=>{
    if ((0, $fwvto.isSSR)()) (0, $eiowN.Network).create((0, $gIJXH.fetch));
    return (0, $eiowN.Network).create((0, $gIJXH.fetch), (0, $k1TrK.subscribe));
};

});
parcelRegister("gIJXH", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $2963ed038d5e3581$export$e7aa7bc5c1b3cfb3);

var $4R6GH = parcelRequire("4R6GH");

var $9XhfI = parcelRequire("9XhfI");

var $dMryf = parcelRequire("dMryf");
const $2963ed038d5e3581$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    return (0, $4R6GH.fg)('jfp-magma-support-defer') ? (0, $9XhfI.fetch)(request, variables, cacheConfig) : (0, $dMryf.fetch)(request, variables, cacheConfig);
};

});
parcelRegister("9XhfI", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $1ea431952d5687e8$export$e7aa7bc5c1b3cfb3);

var $hGgHi = parcelRequire("hGgHi");

var $eiowN = parcelRequire("eiowN");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $6b2ko = parcelRequire("6b2ko");

var $5a0Nh = parcelRequire("5a0Nh");

var $kipqU = parcelRequire("kipqU");

var $7pVV3 = parcelRequire("7pVV3");

var $ajjqZ = parcelRequire("ajjqZ");

var $86YLA = parcelRequire("86YLA");

var $gxvzd = parcelRequire("gxvzd");

var $1u51R = parcelRequire("1u51R");

var $lKFKm = parcelRequire("lKFKm");

var $7isEg = parcelRequire("7isEg");

var $aLyyN = parcelRequire("aLyyN");
const $1ea431952d5687e8$var$getQueryResponseCache = ()=>(0, $4R6GH.fg)('jfp_magma_fix_relay_query_cache_loading_from_ssr') ? (0, $7pVV3.getQueryResponseCache)() : (0, $7pVV3.QueryResponseCache);
const $1ea431952d5687e8$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    const redirecting = (0, $aLyyN.checkAuthentication)();
    if (redirecting) // Hang the request if we are redirecting - should be cleared on redirect
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return (0, $eiowN.Observable).from(new Promise(()=>{}));
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $7isEg.getLoggingAndMetricsHelper)(loggingMetadata);
    function augmentResponse(response) {
        (0, $1u51R.addTraceId)(queryName, (0, $aLyyN.getTraceIdFromExtensions)(response));
        (0, $86YLA.putExtensions)(queryName, response.extensions);
    }
    function validateResponse(response) {
        // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
        const errors = response.errors || undefined;
        if (errors != null) {
            const requestId = response?.extensions?.gateway?.request_id;
            if (!(0, $aLyyN.blocklist).includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
            (0, $5a0Nh.captureErrors)(errors, {
                operationName: queryName,
                requestId: requestId
            });
            if ((0, $5a0Nh.isUnauthenticated)(errors)) return false;
        }
        return true;
    }
    function enforceNonNullability(response) {
        if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    const earlyScriptPromise = !false && (0, $ajjqZ.claimEarlyScriptPromise)((0, $ajjqZ.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    return (0, $eiowN.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            const handleResponse = (response)=>{
                sink.next(response);
                if ('hasNext' in response && response.hasNext === true) ;
                else // The data is final; can close the observable.
                sink.complete();
            };
            const endpoint = (0, $gxvzd.getAggEndpoint)(request, cacheConfig);
            const body = (0, $gxvzd.getRequestBody)(request, variables);
            // On client...
            if (!false && requestID != null) {
                // read cache from window.SPA_STATE if available
                const ssrCache = $1ea431952d5687e8$var$getQueryResponseCache().get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(ssrCache)) {
                    $1ea431952d5687e8$var$getQueryResponseCache().delete(requestID, variables);
                    handleResponse(ssrCache);
                    return;
                }
            }
            const wrappedEarlyScriptPromise = earlyScriptPromise && (0, $6b2ko.retryOnError)(()=>(0, $eusud.applyErrorHandling)(earlyScriptPromise), {
                retryFunc: ()=>(0, $eusud.performPostRequest)(endpoint, (0, $aLyyN.generateOptions)({
                        body: body
                    }, endpoint)),
                retryPredicate: (0, $aLyyN.shouldRetry),
                retryAttempts: (0, $aLyyN.getRetryAttemptsForQuery)(queryName, operationKind),
                onRetry: loggingAndMetrics.logErrorRetry
            });
            // Throws HttpError
            const promise = !false && wrappedEarlyScriptPromise !== undefined ? wrappedEarlyScriptPromise : Promise.resolve((0, $eusud.performPostRequestWithRetry)(endpoint, {
                ...(0, $aLyyN.generateOptions)({
                    body: body
                }, endpoint),
                retryPredicate: (0, $aLyyN.shouldRetry),
                retryAttempts: (0, $aLyyN.getRetryAttemptsForQuery)(queryName, operationKind),
                onRetry: (error, attempt)=>{
                    loggingAndMetrics.logErrorRetry(error, attempt);
                }
            }));
            // todo: need to adjust so that we can handle multipart responses, decode in to graphql payloads, then push through sink appropriately
            const responses = (0, $eiowN.Observable).from(promise);
            // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
            // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
            let responseShouldHang = false;
            // todo: revisit contract for QueryResponseCache, would help clean this up a bit.
            let resolveFirstResponse;
            // todo: eventually will be used, once sufficient test coverage added to capture the scenario, QueryPromisesMap gets updated, other dust settles
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            let rejectFirstResponse;
            let firstResponseUsed = false;
            const firstResponse = new Promise((resolve, reject)=>{
                resolveFirstResponse = resolve;
                rejectFirstResponse = reject;
            });
            responses.subscribe({
                start: ()=>{
                    if (requestID != null) (0, $kipqU.QueryPromisesMap).set(requestID, firstResponse);
                },
                next: (response)=>{
                    false && firstResponseUsed;
                    if (!firstResponseUsed) {
                        firstResponseUsed = true;
                        // send response to query promises map, so that
                        // * on server, SSR SPA render can unblock once all are received
                        // * on client, ...?
                        resolveFirstResponse(response);
                        augmentResponse(response);
                        if (!validateResponse(response)) {
                            //  Short circuit operation and handle the unauthorized errors.
                            (0, $lKFKm.showUnauthenticatedFlag)(queryName);
                            responseShouldHang = true;
                            return;
                        }
                        enforceNonNullability(response);
                        // write cache query response on SSR
                        if (false && requestID != null) $1ea431952d5687e8$var$getQueryResponseCache().setWithMetadata(requestID, variables, response, loggingMetadata);
                    }
                    // pipe data through the relay-fetch observable itself
                    handleResponse(response);
                },
                error: (error)=>{
                    if (!firstResponseUsed) firstResponseUsed = true;
                    loggingAndMetrics.logError(error);
                    sink.error(error);
                },
                complete: ()=>{
                    if (responseShouldHang) return;
                    sink.complete();
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};

});
parcelRegister("5a0Nh", function(module, exports) {

$parcel$export(module.exports, "startCaptureGraphQlErrors", () => $cf86a52470c84b66$export$c211170518c6d0f6);
$parcel$export(module.exports, "stopCaptureGraphQlErrors", () => $cf86a52470c84b66$export$e0491a0d974dadfa);
$parcel$export(module.exports, "captureErrors", () => $cf86a52470c84b66$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isUnauthenticated", () => $cf86a52470c84b66$export$1724ecfee73c4768);
/**
 * Utility methods to capture GraphQl errors and expose them to the frontend for reporting.
 * ```
 * Sample usage:
 * const id = startErrorCapture();
 * ...
 * const errors = stopErrorCapture(id);
 * ```
 */ 
var $7Jxgt = parcelRequire("7Jxgt");
const $cf86a52470c84b66$var$errorCollector = new Map();
const $cf86a52470c84b66$export$da396ad2a542b095 = 120000; // 2min
const $cf86a52470c84b66$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $cf86a52470c84b66$var$errorCollector.delete(key);
    }, $cf86a52470c84b66$export$da396ad2a542b095);
};
const $cf86a52470c84b66$export$c211170518c6d0f6 = (key = (0, $7Jxgt.v4)())=>{
    $cf86a52470c84b66$var$errorCollector.set(key, []);
    $cf86a52470c84b66$var$scheduleCleanup(key);
    return key;
};
const $cf86a52470c84b66$export$e0491a0d974dadfa = (key)=>{
    const errors = $cf86a52470c84b66$var$errorCollector.get(key);
    $cf86a52470c84b66$var$errorCollector.delete(key);
    return errors || [];
};
const $cf86a52470c84b66$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $cf86a52470c84b66$var$errorCollector.forEach((value, key)=>{
        $cf86a52470c84b66$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $cf86a52470c84b66$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};

});

parcelRegister("kipqU", function(module, exports) {

$parcel$export(module.exports, "QueryPromisesMap", () => $f428f7f15822f637$export$607b80f5bc6e396d);
const $f428f7f15822f637$export$607b80f5bc6e396d = new Map();

});

parcelRegister("7pVV3", function(module, exports) {

$parcel$export(module.exports, "QueryResponseCache", () => $675c7f0a9d659efe$export$688bd21be71b9e5d);
$parcel$export(module.exports, "getQueryResponseCache", () => $675c7f0a9d659efe$export$3233e692a93c0cfd);

var $jqONe = parcelRequire("jqONe");

var $9XE6b = parcelRequire("9XE6b");

var $8QpSo = parcelRequire("8QpSo");

var $eiowN = parcelRequire("eiowN");

var $dJl1T = parcelRequire("dJl1T");

var $jJZqs = parcelRequire("jJZqs");

var $4R6GH = parcelRequire("4R6GH");

var $kizcd = parcelRequire("kizcd");
function $675c7f0a9d659efe$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $eiowN.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $675c7f0a9d659efe$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
const $675c7f0a9d659efe$export$da2711d74cd28aed = [
    'fetchModulesV2Query'
];
class $675c7f0a9d659efe$export$be21c283b097d175 extends (0, $eiowN.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl }){
        super({
            size: size,
            ttl: ttl
        });
        const cachedData = false ? {} : window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!false) setTimeout(()=>{
            this.logUnusedPayloadErrors();
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    logUnusedPayloadErrors() {
        const loggedQueries = new Set();
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'. | TS7006 - Parameter 'response' implicitly has an 'any' type. | TS7006 - Parameter 'key' implicitly has an 'any' type.
        this._responses.forEach((response, key)=>{
            const queryID = $675c7f0a9d659efe$export$1e65e863cf3a0f21(key);
            const metadata = this.requestMetadata.get(queryID);
            const { queryName: queryName = 'unknown', operationKind: operationKind = 'unknown' } = metadata ?? {
                queryName: 'unknown',
                operationKind: 'unknown'
            };
            if (!loggedQueries.has(queryName) && !$675c7f0a9d659efe$export$da2711d74cd28aed.includes(queryName)) {
                loggedQueries.add(queryName);
                const error = new (0, $kizcd.UnusedRelayResponseError)(queryID);
                const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, $jJZqs.default) ? 'network' : 'unknown';
                // Log any errors even in SSR
                (0, $dJl1T.default).safeErrorWithoutCustomerData('relay.AGG.error.graphql', `[${errorType} error]`, {
                    message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                        'name'
                    ], null)
                });
            }
        });
    }
    setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
	 * Deletes a request from the store, if found.
	 *
	 * IMPORTANT: Make sure DELETE method always has tests that include get/set
	 * to ensure our `getCacheKey` matches Relay's.
	 *
	 * @returns {boolean} indicating if an entry in the cache was deleted
	 */ delete(queryID, variables) {
        const cacheKey = $675c7f0a9d659efe$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}
const $675c7f0a9d659efe$export$688bd21be71b9e5d = new $675c7f0a9d659efe$export$be21c283b097d175({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
const $675c7f0a9d659efe$export$3233e692a93c0cfd = (0, $8QpSo.default)(()=>new $675c7f0a9d659efe$export$be21c283b097d175({
        cacheName: 'relay-cache/v2/AGG',
        size: Infinity,
        ttl: Infinity
    }));
const $675c7f0a9d659efe$export$94e535e06b7ade61 = ()=>((0, $4R6GH.fg)('jfp_magma_fix_relay_query_cache_loading_from_ssr') ? $675c7f0a9d659efe$export$3233e692a93c0cfd() : $675c7f0a9d659efe$export$688bd21be71b9e5d).serialize();

});
parcelRegister("kizcd", function(module, exports) {

$parcel$export(module.exports, "UnusedRelayResponseError", () => $f174935352f053b0$export$8431e42d062de453);
class $f174935352f053b0$export$8431e42d062de453 extends Error {
    constructor(queryID){
        super(`Relay Query ${queryID} was made during SSR but never used in the browser`), this.name = 'UnusedRelayResponseError';
    }
}

});


parcelRegister("ajjqZ", function(module, exports) {

$parcel$export(module.exports, "getEarlyScriptPromiseKey", () => $383b599fde987e1e$export$1102c06c7da91223);
$parcel$export(module.exports, "claimEarlyScriptPromise", () => $383b599fde987e1e$export$828ac0325bce4536);
$parcel$export(module.exports, "putEarlyScriptPromise", () => $383b599fde987e1e$export$e1336d32be02faf4);
$parcel$export(module.exports, "earlyFetch", () => $383b599fde987e1e$export$5b55058781674413);

var $7xBz2 = parcelRequire("7xBz2");

var $l83Uu = parcelRequire("l83Uu");

var $eKonk = parcelRequire("eKonk");

var $gxvzd = parcelRequire("gxvzd");
const $383b599fde987e1e$var$CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
const $383b599fde987e1e$export$b5fbc1430cbfd6e1 = (value)=>value;
const $383b599fde987e1e$export$6d670d323806bb37 = new Map();
const $383b599fde987e1e$export$1102c06c7da91223 = (params, variables)=>{
    if (params.name === 'mainIssueAggQuery') return `${params.name}|${params.id}|${variables?.cloudId}|${variables?.issueKey}`;
    const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
    const serializedVariables = variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';
    return `${params.name}|${String(queryId)}|${serializedVariables}`;
};
const $383b599fde987e1e$export$828ac0325bce4536 = (key)=>{
    const result = $383b599fde987e1e$export$6d670d323806bb37.get(key);
    if (result != null) $383b599fde987e1e$export$6d670d323806bb37.delete(key);
    return result;
};
const $383b599fde987e1e$export$e1336d32be02faf4 = (key, promise)=>{
    if (!$383b599fde987e1e$export$6d670d323806bb37.has(key)) $383b599fde987e1e$export$6d670d323806bb37.set(key, promise);
};
const $383b599fde987e1e$export$5b55058781674413 = (compiledQuery, variables, experimentalApis = [], capability)=>{
    (0, $l83Uu.setMark)('jira.fe-spa.early-preload:start');
    const endpoint = (0, $gxvzd.getAggEndpoint)(compiledQuery.params);
    const body = (0, $gxvzd.getRequestBody)(compiledQuery.params, variables);
    const capabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)(capability ?? null);
    $383b599fde987e1e$export$e1336d32be02faf4($383b599fde987e1e$export$1102c06c7da91223(compiledQuery.params, variables), fetch(endpoint, {
        credentials: 'same-origin',
        headers: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'Content-Type': 'application/json',
            Accept: 'application/json,text/javascript,*/*',
            'X-ExperimentalApi': experimentalApis.join(','),
            ...(0, $7xBz2.getActiveTraceHttpRequestHeaders)(endpoint),
            ...capabilityHeader ? {
                [$383b599fde987e1e$var$CAPABILITY_HEADER_NAME]: capabilityHeader
            } : {}
        },
        method: 'POST',
        body: body
    }).then((response)=>{
        (0, $l83Uu.setMark)('jira.fe-spa.early-preload:end');
        return response;
    }));
};

});
parcelRegister("l83Uu", function(module, exports) {

$parcel$export(module.exports, "setMark", () => $ef655a7b07a35675$export$f7a1fb90d8604165);
$parcel$export(module.exports, "getTraceId", () => $ef655a7b07a35675$export$e88cb5bfb57ce9c4);

var $dO0aE = parcelRequire("dO0aE");
const $ef655a7b07a35675$export$f7a1fb90d8604165 = (mark)=>{
    if (typeof performance !== 'object' || typeof performance.mark !== 'function') return;
    performance.mark(mark);
};
const $ef655a7b07a35675$var$TRACE_ID_HEADER = 'atl-traceid';
const $ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $ef655a7b07a35675$export$e88cb5bfb57ce9c4 = (response)=>response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER) || response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS);

});
parcelRegister("dO0aE", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $7345e390d0c3a088$export$26e841bcf1aeb894);
$parcel$export(module.exports, "ResponseNullError", () => $7345e390d0c3a088$export$895e385291c3b753);
/* eslint-disable max-classes-per-file */ class $7345e390d0c3a088$var$ExtensibleError extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message, options);
        this.message = message;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
class $7345e390d0c3a088$export$26e841bcf1aeb894 extends $7345e390d0c3a088$var$ExtensibleError {
    constructor(statusCode, message, traceId){
        super(message == null ? `Fetch call failed with status code: ${statusCode}` : message), this.graphQLErrors = [];
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.networkError = {
            statusCode: statusCode
        };
        this.skipSentry = true;
        if (traceId != null) this.traceId = traceId;
    }
}
class $7345e390d0c3a088$export$895e385291c3b753 extends $7345e390d0c3a088$var$ExtensibleError {
    constructor(message){
        super(message);
        this.name = 'ResponseNullError';
        this.skipSentry = true;
    }
}

});



parcelRegister("lKFKm", function(module, exports) {

$parcel$export(module.exports, "showUnauthenticatedFlag", () => $42cb6e1c2fdc593e$export$758fcc357484571e);

var $pa9q9 = parcelRequire("pa9q9");

var $fjcgS = parcelRequire("fjcgS");

var $8iiwm = parcelRequire("8iiwm");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $42cb6e1c2fdc593e$var$reloadPage = ()=>window.location.reload();
const $42cb6e1c2fdc593e$var$sendAnalyticEvent = (operationName)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'showed',
            actionSubject: 'unauthorizedFlag',
            attributes: {
                operation: operationName
            },
            source: 'jiraRelayFetch'
        });
    });
};
const $42cb6e1c2fdc593e$export$758fcc357484571e = (operationName)=>{
    (0, $pa9q9.showFlag)({
        type: 'error',
        title: (0, $8iiwm.default).title,
        description: (0, $8iiwm.default).description,
        messageId: 'relay-fetch.services.error-flags.show-flag.error.show-unauthenticated-flag',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $8iiwm.default).login,
                onClick: $42cb6e1c2fdc593e$var$reloadPage
            }
        ]
    });
    $42cb6e1c2fdc593e$var$sendAnalyticEvent(operationName);
};

});
parcelRegister("pa9q9", function(module, exports) {

$parcel$export(module.exports, "showFlag", () => $00ff685527f9e8c1$export$e12b2cc6b75b006b);
$parcel$export(module.exports, "dismissFlag", () => $00ff685527f9e8c1$export$900a08a292ad23cd);
$parcel$export(module.exports, "flagService", () => $00ff685527f9e8c1$export$dbb055af53fd81a0);
$parcel$export(module.exports, "useFlagsService", () => $00ff685527f9e8c1$export$eee61a1aafe3884);
$parcel$export(module.exports, "useFlagService", () => $00ff685527f9e8c1$export$dc4f8132c3090b32);
$parcel$export(module.exports, "isDismissFlag", () => $00ff685527f9e8c1$export$14b1864d9cf0809f);
$parcel$export(module.exports, "isFlagComponent", () => $00ff685527f9e8c1$export$d84ce5adcee46025);
$parcel$export(module.exports, "isBatchAction", () => $00ff685527f9e8c1$export$c126d8b307b8ab86);

var $fHfPB = parcelRequire("fHfPB");

var $gEdnQ = parcelRequire("gEdnQ");

var $01A9Z = parcelRequire("01A9Z");

var $7HGHK = parcelRequire("7HGHK");
const $00ff685527f9e8c1$export$e12b2cc6b75b006b = (0, $gEdnQ.default)((0, $01A9Z.store).dispatch);
const $00ff685527f9e8c1$export$900a08a292ad23cd = (0, $fHfPB.default)((0, $01A9Z.store).dispatch);
const $00ff685527f9e8c1$var$dismissFlagById = (id)=>{
    $00ff685527f9e8c1$export$900a08a292ad23cd((0, $fHfPB.dismissFlag)(id));
};
const $00ff685527f9e8c1$var$hasFlag = (id)=>Boolean((0, $01A9Z.store).getState().flags.find((flagInstance)=>'id' in flagInstance.flag && flagInstance.flag.id === id));
const $00ff685527f9e8c1$export$dbb055af53fd81a0 = {
    showFlag: $00ff685527f9e8c1$export$e12b2cc6b75b006b,
    dismissFlag: $00ff685527f9e8c1$export$900a08a292ad23cd
};
const $00ff685527f9e8c1$export$eee61a1aafe3884 = ()=>({
        showFlag: $00ff685527f9e8c1$export$e12b2cc6b75b006b,
        dismissFlag: $00ff685527f9e8c1$var$dismissFlagById,
        hasFlag: $00ff685527f9e8c1$var$hasFlag
    });
const $00ff685527f9e8c1$export$dc4f8132c3090b32 = ()=>$00ff685527f9e8c1$export$dbb055af53fd81a0;
const $00ff685527f9e8c1$export$14b1864d9cf0809f = (flag)=>typeof flag === 'object' && 'command' in flag && flag.command === (0, $7HGHK.DISMISS_COMMAND);
const $00ff685527f9e8c1$export$d84ce5adcee46025 = (flag)=>typeof flag === 'function' && !('type' in flag) && !('render' in flag);
const $00ff685527f9e8c1$export$cd5f9f2b991b82d9 = (flag)=>typeof flag === 'object' && 'render' in flag && typeof flag.render === 'function';
const $00ff685527f9e8c1$export$63ffd7d99470afd4 = (flag)=>!$00ff685527f9e8c1$export$14b1864d9cf0809f(flag) && !$00ff685527f9e8c1$export$d84ce5adcee46025(flag) && !$00ff685527f9e8c1$export$cd5f9f2b991b82d9(flag);
const $00ff685527f9e8c1$export$c126d8b307b8ab86 = (action)=>'meta' in action && action.meta && action.meta.batch && 'payload' in action && Array.isArray(action.payload);

});
parcelRegister("fHfPB", function(module, exports) {

$parcel$export(module.exports, "dismissFlag", () => $8eb241d1a1f5d9b7$export$900a08a292ad23cd);
$parcel$export(module.exports, "default", () => $8eb241d1a1f5d9b7$export$2e2bcd8739ae039);

var $d6YjM = parcelRequire("d6YjM");

var $7HGHK = parcelRequire("7HGHK");
const $8eb241d1a1f5d9b7$export$900a08a292ad23cd = (flagId)=>({
        command: (0, $7HGHK.DISMISS_COMMAND),
        id: flagId
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8eb241d1a1f5d9b7$export$2e2bcd8739ae039 = (dispatch)=>(action)=>{
        dispatch((0, $d6YjM.dismissFlagAction)(action.id));
    };

});
parcelRegister("d6YjM", function(module, exports) {

$parcel$export(module.exports, "SHOW", () => $07f19e2fef34903b$export$9d04158a25ce4cd);
$parcel$export(module.exports, "show", () => $07f19e2fef34903b$export$57bf213be019eeb0);
$parcel$export(module.exports, "DISMISS_INSTANCE", () => $07f19e2fef34903b$export$b31a07d2e6382678);
$parcel$export(module.exports, "dismiss", () => $07f19e2fef34903b$export$abf286bbe7073aba);
$parcel$export(module.exports, "DISMISS_FLAG", () => $07f19e2fef34903b$export$1eb56620df104bf);
$parcel$export(module.exports, "dismissFlagAction", () => $07f19e2fef34903b$export$4818b3c52448050d);
$parcel$export(module.exports, "RESET", () => $07f19e2fef34903b$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $07f19e2fef34903b$export$aad8462122ac592b);
const $07f19e2fef34903b$export$9d04158a25ce4cd = 'state.SHOW';
const $07f19e2fef34903b$export$57bf213be019eeb0 = (payload)=>({
        type: $07f19e2fef34903b$export$9d04158a25ce4cd,
        payload: payload
    });
const $07f19e2fef34903b$export$b31a07d2e6382678 = 'state.DISMISS_INSTANCE';
const $07f19e2fef34903b$export$abf286bbe7073aba = (payload)=>({
        type: $07f19e2fef34903b$export$b31a07d2e6382678,
        payload: payload
    });
const $07f19e2fef34903b$export$1eb56620df104bf = 'state.DISMISS_FLAG';
const $07f19e2fef34903b$export$4818b3c52448050d = (payload)=>({
        type: $07f19e2fef34903b$export$1eb56620df104bf,
        payload: payload
    });
const $07f19e2fef34903b$export$4a991c87e640ef77 = 'state.RESET';
const $07f19e2fef34903b$export$aad8462122ac592b = ()=>({
        type: $07f19e2fef34903b$export$4a991c87e640ef77
    });

});

parcelRegister("7HGHK", function(module, exports) {

$parcel$export(module.exports, "DISMISS_COMMAND", () => $9deb2cdefe93babb$export$e705274c5e156b93);
$parcel$export(module.exports, "toFlagId", () => $9deb2cdefe93babb$export$8184bc29de2aea90);
$parcel$export(module.exports, "fromFlagId", () => $9deb2cdefe93babb$export$188cdb77b72629d7);
const $9deb2cdefe93babb$export$e705274c5e156b93 = 'DISMISS';
const $9deb2cdefe93babb$export$8184bc29de2aea90 = (flagId)=>new String(flagId);
const $9deb2cdefe93babb$export$188cdb77b72629d7 = (flagId)=>flagId.valueOf();

});


parcelRegister("gEdnQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c019df33694ffbe1$export$2e2bcd8739ae039);

var $7Jxgt = parcelRequire("7Jxgt");

var $d6YjM = parcelRequire("d6YjM");

var $7HGHK = parcelRequire("7HGHK");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c019df33694ffbe1$export$2e2bcd8739ae039 = (dispatch)=>(flag)=>{
        // Flag is of type FlagComponent
        if (typeof flag === 'function') {
            dispatch((0, $d6YjM.show)(flag));
            return undefined;
        }
        const flagId = flag.id || (0, $7HGHK.toFlagId)((0, $7Jxgt.v4)());
        const newFlag = {
            ...flag,
            id: flagId
        };
        dispatch((0, $d6YjM.show)(newFlag));
        return flagId;
    };

});

parcelRegister("01A9Z", function(module, exports) {

$parcel$export(module.exports, "store", () => $5787309a6ab0ba9c$export$6f57813fe9f31bf9);

var $imvpl = parcelRequire("imvpl");
const $5787309a6ab0ba9c$export$6f57813fe9f31bf9 = (0, $imvpl.createStore)();

});
parcelRegister("imvpl", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $6bbcd4b408b9a94e$export$f51a9068ac82ea43);

var $F2Mxm = parcelRequire("F2Mxm");

var $gG398 = parcelRequire("gG398");
const $6bbcd4b408b9a94e$export$f51a9068ac82ea43 = (rootEpic)=>(0, $F2Mxm.default)({
        appName: 'flags',
        rootReducer: $gG398.default,
        rootEpic: rootEpic
    });

});
parcelRegister("F2Mxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $fca77440264e922e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3f2cs = parcelRequire("3f2cs");

var $aB8eX = parcelRequire("aB8eX");

var $e1AU2 = parcelRequire("e1AU2");

var $iGv2H = parcelRequire("iGv2H");

var $hkadP = parcelRequire("hkadP");

var $i9gPl = parcelRequire("i9gPl");

var /**
 * Initializes a Redux store with configurations for state management and middleware integration.
 * It addresses serialization challenges with non-serializable entities and enhances debugging capabilities.
 * The custom action listener middleware offers additional control over action dispatches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$fca77440264e922e$export$2e2bcd8739ae039 = ({ appName: appName, rootReducer: rootReducer, initialState: initialState, rootEpic: rootEpic, rootEpicDependencies: rootEpicDependencies, middlewares: middlewares = [], enhancers: enhancers = [] })=>{
    const actionListenerMiddleware = new (0, $i9gPl.default)();
    middlewares.push(actionListenerMiddleware.perform);
    if ((0, $iGv2H.debugEnabled)('redux-logger')) {
        // include logger only for development environment
        // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
        const { logger: logger } = (parcelRequire("korqb"));
        middlewares.push(logger);
    }
    if (rootEpic) middlewares.push((0, $e1AU2.createEpicMiddleware)(rootEpic, rootEpicDependencies ? {
        dependencies: rootEpicDependencies
    } : undefined));
    const store = (0, $3f2cs.createStore)((0, $aB8eX.enableBatching)(rootReducer), initialState, (0, $hkadP.default)({
        name: appName,
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; serialize: { replacer: (key: any, value: any) => any; }; }' is not assignable to parameter of type 'DevtoolsConfig'.
        serialize: {
            // Replacer function is necessary to fix redux-devtools because some actions and state are React Elements
            // and the default serialization gets into a loop in a circular dependency somewhere in internal React properties.
            // https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md#serialize
            // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
            replacer: (key, value)=>{
                if (/*#__PURE__*/ (0, $5uXOq.isValidElement)(value)) {
                    // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    if (value.type && value.type.displayName) // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    return `React Element <${value.type.displayName}>`;
                    return 'React Element';
                }
                // The benefit of using React + Redux + declarative API is that there is no more need to save DOM elements in store!
                // ... yet we still do. So when that happens, Redux devtools sometimes crashes because it tries to serialize circular DOM structure.
                if (typeof HTMLElement !== 'undefined' && value instanceof HTMLElement) return `HTMLElement<${value.tagName}>`;
                return value;
            }
        }
    })((0, $3f2cs.compose)(...enhancers, (0, $3f2cs.applyMiddleware)(...middlewares))));
    store.addActionListener = actionListenerMiddleware.add;
    store.removeActionListener = actionListenerMiddleware.remove;
    return store;
};

});
parcelRegister("iGv2H", function(module, exports) {

$parcel$export(module.exports, "debugEnabled", () => $a4079cece44c0fab$export$342c99cc1e9bc5c6);
const $a4079cece44c0fab$export$342c99cc1e9bc5c6 = (flag)=>''.split(',').includes(flag);

});

parcelRegister("hkadP", function(module, exports) {

$parcel$export(module.exports, "default", () => $607c98afd3082218$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");
var // An extended version of redux's 'compose' method, that
// will use redux devtools chrome extension if available
// https://github.com/zalmoxisus/redux-devtools-extension
//
// The 'devtoolsConfig' parameter is an object adhering to the following API:
// https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md
// eslint-disable-next-line jira/import/no-anonymous-default-export
$607c98afd3082218$export$2e2bcd8739ae039 = (devtoolsConfig = {})=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const devtoolsEnhancer = false ? null : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    const config = {
        ...devtoolsConfig
    };
    if (config.name != null && config.instanceId == null) config.instanceId = config.name;
    return 0, $3f2cs.compose;
};

});

parcelRegister("i9gPl", function(module, exports) {

$parcel$export(module.exports, "default", () => $330df53c22ed8aaf$export$2e2bcd8739ae039);
class $330df53c22ed8aaf$export$2e2bcd8739ae039 {
    constructor(){
        this.listeners = [];
        this.add = (listener)=>{
            this.listeners.push(listener);
        };
        this.remove = (listener)=>{
            this.listeners = this.listeners.filter((l)=>l !== listener);
        };
        // @ts-expect-error - TS2315 - Type 'Middleware' is not generic.
        this.perform = (api)=>(next)=>(action)=>{
                    const result = next(action);
                    this.listeners.forEach((listener)=>listener(action, api.getState()));
                    return result;
                };
    }
}

});


parcelRegister("gG398", function(module, exports) {

$parcel$export(module.exports, "default", () => $1feeabef4760da78$export$2e2bcd8739ae039);

var $ifg6x = parcelRequire("ifg6x");

var $7Jxgt = parcelRequire("7Jxgt");

var $d6YjM = parcelRequire("d6YjM");
const $1feeabef4760da78$var$defaultState = {
    flags: []
};
var /**
 * Manages the state transitions of a notification system by handling actions such as showing
 * new notifications, dismissing notifications (either individually or by type), and
 * resetting to the default state. It uniquely prioritizes high-priority notifications,
 * ensuring they are displayed before low-priority ones, enhancing the user's
 * attention to critical alerts.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$1feeabef4760da78$export$2e2bcd8739ae039 = (state = $1feeabef4760da78$var$defaultState, action)=>{
    switch(action.type){
        case 0, $d6YjM.SHOW:
            {
                // If flag is of type FlagComponent, it is treated as high priority
                const [lowPriorityFlags, highPriorityFlags] = (0, (/*@__PURE__*/$parcel$interopDefault($ifg6x)))([
                    {
                        id: (0, $7Jxgt.v4)(),
                        flag: action.payload
                    },
                    ...state.flags
                ], ({ flag: flag })=>typeof flag !== 'function' && flag?.isLowPriority);
                const flags = [
                    ...highPriorityFlags,
                    ...lowPriorityFlags
                ];
                return {
                    ...state,
                    flags: flags
                };
            }
        case 0, $d6YjM.DISMISS_INSTANCE:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>flagInstance.id !== id)
                };
            }
        case 0, $d6YjM.DISMISS_FLAG:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>{
                        // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        if (flagInstance.flag.id) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        return flagInstance.flag.id !== id;
                        return true;
                    })
                };
            }
        case 0, $d6YjM.RESET:
            return $1feeabef4760da78$var$defaultState;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});




parcelRegister("8iiwm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c7ec0f26423b786$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c7ec0f26423b786$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "relay-fetch.services.error-flags.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "relay-fetch.services.error-flags.description",
        "defaultMessage": "Looks like you've been signed out. Try logging in again. "
    },
    login: {
        "id": "relay-fetch.services.error-flags.login",
        "defaultMessage": "Log in"
    }
});

});


parcelRegister("7isEg", function(module, exports) {

$parcel$export(module.exports, "getLoggingAndMetricsHelper", () => $6c554999a424d172$export$726e1df8186bb981);

var $jqONe = parcelRequire("jqONe");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $dJl1T = parcelRequire("dJl1T");

var $jJZqs = parcelRequire("jJZqs");
const $6c554999a424d172$var$LOG_NAMESPACE = 'relay.AGG.error.graphql';
const $6c554999a424d172$export$726e1df8186bb981 = (graphqlDetails)=>{
    const { queryName: queryName, operationKind: operationKind } = graphqlDetails;
    return {
        logNonBreakingErrors: (errors, requestId)=>{
            if (false || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(errors) || !Array.isArray(errors)) return;
            errors.forEach((error)=>{
                error && (0, $dJl1T.default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, '[graphql error]', {
                    queryName: queryName,
                    operationKind: operationKind,
                    errorType: 'graphql',
                    message: error.message,
                    requestId: requestId
                });
            });
        },
        logError: (error)=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                'statusCode'
            ], null);
            const errorType = error instanceof (0, $jJZqs.default) ? 'network' : 'unknown';
            // Log any errors even in SSR
            (0, $dJl1T.default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, `[${errorType} error]`, {
                message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                errorType: errorType,
                statusCode: statusCode,
                queryName: queryName,
                operationKind: operationKind,
                errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                    'name'
                ], null)
            });
        },
        logErrorRetry: (error, retryAttempt)=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                'statusCode'
            ], null);
            const errorType = error instanceof (0, $jJZqs.default) ? 'network' : 'unknown';
            // Log any errors even in SSR
            (0, $dJl1T.default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, `[${errorType} error]`, {
                message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                errorType: errorType,
                statusCode: statusCode,
                queryName: queryName,
                operationKind: operationKind,
                errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                    'name'
                ], null),
                retryAttempt: retryAttempt
            });
        }
    };
};

});

parcelRegister("aLyyN", function(module, exports) {

$parcel$export(module.exports, "checkAuthentication", () => $00bea5ba58fba29b$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "blocklist", () => $00bea5ba58fba29b$export$c5c28c9e707bcda1);
$parcel$export(module.exports, "getRetryAttemptsForQuery", () => $00bea5ba58fba29b$export$9dec0f42cc67f6ab);
$parcel$export(module.exports, "getTraceIdFromExtensions", () => $00bea5ba58fba29b$export$eefb7f54c3b07211);
$parcel$export(module.exports, "generateOptions", () => $00bea5ba58fba29b$export$c21133b4499f5374);
$parcel$export(module.exports, "shouldRetry", () => $00bea5ba58fba29b$export$7bfea3c3d460ecd8);

var $hGgHi = parcelRequire("hGgHi");

var $1UikQ = parcelRequire("1UikQ");

var $2ys8y = parcelRequire("2ys8y");

var $7LdpZ = parcelRequire("7LdpZ");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");

var $6b2ko = parcelRequire("6b2ko");

var $4tcSU = parcelRequire("4tcSU");

var $gwtGO = parcelRequire("gwtGO");
let $00bea5ba58fba29b$var$redirecting = false;
const $00bea5ba58fba29b$var$redirect = ()=>{
    const identity = (0, $2ys8y.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href)}`;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href = redirectUrl;
};
const $00bea5ba58fba29b$export$b8dbb7d6029c5413 = ()=>{
    if (!false && !$00bea5ba58fba29b$var$redirecting) {
        const heartbeatService = (0, $7LdpZ.getInstance)();
        if (heartbeatService.isInitialized() && !heartbeatService.isAuthenticated()) {
            $00bea5ba58fba29b$var$redirect();
            // Set flag to prevent multiple redirects
            $00bea5ba58fba29b$var$redirecting = true;
        }
    }
    return $00bea5ba58fba29b$var$redirecting;
};
const $00bea5ba58fba29b$export$c5c28c9e707bcda1 = [
    'issueAggQuery'
];
const $00bea5ba58fba29b$export$9dec0f42cc67f6ab = (queryName, operationKind)=>{
    if (operationKind === 'query') return 0, $6b2ko.RETRY_ATTEMPTS_LIMIT;
    return 0;
};
const $00bea5ba58fba29b$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.request_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.request_id;
    return undefined;
};
const $00bea5ba58fba29b$export$c21133b4499f5374 = (options = {}, url = null)=>{
    // the token fetcher returns undefined if no cookie value was found, also in SSR cookies are unavailable
    const csrfToken = !false ? (0, $4tcSU.default)() : undefined;
    // If we don't get a token, there is no point trying to add the csrf header
    const csrfTokenHeader = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(csrfToken) ? {} : {
        'atl-xsrf-token': csrfToken
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, {
        // We have to provide general options here or the headers we provide will override the default ones found
        // here /src/packages/platform/utils/fetch/src/utils/requests.js due to a shallow merge
        ...(0, $5HnTq.getDefaultOptions)((0, $4R6GH.fg)('obsrve-2239-traceid-errorflag-issue-transition') ? url : null),
        ...options
    }, {
        headers: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $gwtGO.default).join(','),
            ...csrfTokenHeader
        }
    });
};
const $00bea5ba58fba29b$export$7bfea3c3d460ecd8 = (error)=>{
    if (error instanceof (0, $jJZqs.default)) return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};

});
parcelRegister("gwtGO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1019e315ad42f34a$export$2e2bcd8739ae039);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $1019e315ad42f34a$export$2e2bcd8739ae039 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs'
];

});



parcelRegister("dMryf", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $cad88c39422b51e7$export$e7aa7bc5c1b3cfb3);

var $hGgHi = parcelRequire("hGgHi");

var $eiowN = parcelRequire("eiowN");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $6b2ko = parcelRequire("6b2ko");

var $5a0Nh = parcelRequire("5a0Nh");

var $kipqU = parcelRequire("kipqU");

var $7pVV3 = parcelRequire("7pVV3");

var $ajjqZ = parcelRequire("ajjqZ");

var $86YLA = parcelRequire("86YLA");

var $gxvzd = parcelRequire("gxvzd");

var $1u51R = parcelRequire("1u51R");

var $lKFKm = parcelRequire("lKFKm");

var $7isEg = parcelRequire("7isEg");

var $aLyyN = parcelRequire("aLyyN");
const $cad88c39422b51e7$var$getQueryResponseCache = ()=>(0, $4R6GH.fg)('jfp_magma_fix_relay_query_cache_loading_from_ssr') ? (0, $7pVV3.getQueryResponseCache)() : (0, $7pVV3.QueryResponseCache);
const $cad88c39422b51e7$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    const redirecting = (0, $aLyyN.checkAuthentication)();
    if (redirecting) // Hang the request if we are redirecting - should be cleared on redirect
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return (0, $eiowN.Observable).from(new Promise(()=>{}));
    const { name: queryName, operationKind: operationKind } = request;
    const earlyScriptPromise = !false && (0, $ajjqZ.claimEarlyScriptPromise)((0, $ajjqZ.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $7isEg.getLoggingAndMetricsHelper)(loggingMetadata);
    return (0, $eiowN.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            const endpoint = (0, $gxvzd.getAggEndpoint)(request, cacheConfig);
            const body = (0, $gxvzd.getRequestBody)(request, variables);
            let ssrCache = null;
            if (!false && requestID != null) ssrCache = $cad88c39422b51e7$var$getQueryResponseCache().get(requestID, variables);
            // On client read cache from window.SPA_STATE if available
            if (!false && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(ssrCache)) {
                sink.next(ssrCache);
                if (requestID != null) $cad88c39422b51e7$var$getQueryResponseCache().delete(requestID, variables);
                sink.complete();
                return;
            }
            const wrappedEarlyScriptPromise = earlyScriptPromise && (0, $6b2ko.retryOnError)(()=>(0, $eusud.applyErrorHandling)(earlyScriptPromise), {
                retryFunc: ()=>(0, $eusud.performPostRequest)(endpoint, (0, $aLyyN.generateOptions)({
                        body: body
                    }, endpoint)),
                retryPredicate: (0, $aLyyN.shouldRetry),
                retryAttempts: (0, $aLyyN.getRetryAttemptsForQuery)(queryName, operationKind),
                onRetry: loggingAndMetrics.logErrorRetry
            });
            // Throws HttpError
            const promise = !false && wrappedEarlyScriptPromise !== undefined ? wrappedEarlyScriptPromise : Promise.resolve((0, $eusud.performPostRequestWithRetry)(endpoint, {
                ...(0, $aLyyN.generateOptions)({
                    body: body
                }, endpoint),
                retryPredicate: (0, $aLyyN.shouldRetry),
                retryAttempts: (0, $aLyyN.getRetryAttemptsForQuery)(queryName, operationKind),
                onRetry: (error, attempt)=>{
                    loggingAndMetrics.logErrorRetry(error, attempt);
                }
            }));
            promise.then((response)=>{
                (0, $1u51R.addTraceId)(queryName, (0, $aLyyN.getTraceIdFromExtensions)(response));
                (0, $86YLA.putExtensions)(queryName, response.extensions);
                // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
                const errors = response.errors || undefined;
                if (errors != null) {
                    const requestId = response?.extensions?.gateway?.request_id;
                    if (!(0, $aLyyN.blocklist).includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
                    (0, $5a0Nh.captureErrors)(errors, {
                        operationName: queryName,
                        requestId: requestId
                    });
                    if ((0, $5a0Nh.isUnauthenticated)(errors)) {
                        //  Short circuit operation and handle the unauthorized errors.
                        (0, $lKFKm.showUnauthenticatedFlag)(queryName);
                        // Surprise behaviour: the observable should hang indefinitely here!
                        // At least, that is the expectation of existing code; see src/packages/issue/issue-view/src/integration-tests/experience-tracking/view.cy-integration.tsx
                        // Which assumes that the operation never completes, so relay never receives a (null) response, so it never complains about the data.
                        // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                        return;
                    }
                }
                if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
                // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
                // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
                // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
                response.data = null;
                // cache query response on SSR
                if (false && requestID != null) $cad88c39422b51e7$var$getQueryResponseCache().setWithMetadata(requestID, variables, response, loggingMetadata);
                sink.next(response);
                sink.complete();
            })// We don't await the promise so the catch block below is never
            // triggered so we need an independent catch on the promise
            .catch((error)=>{
                loggingAndMetrics.logError(error);
                sink.error(error);
            });
            if (requestID != null) (0, $kipqU.QueryPromisesMap).set(requestID, promise);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};

});


parcelRegister("k1TrK", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $4ced6779db298dc0$export$ec068583843480e7);

var $eiowN = parcelRequire("eiowN");

var $jcw0u = parcelRequire("jcw0u");

var $lWhTC = parcelRequire("lWhTC");

var $1Uhm6 = parcelRequire("1Uhm6");

var $cfDZ3 = parcelRequire("cfDZ3");
const $4ced6779db298dc0$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $eiowN.Observable).create((sink)=>{
        const client = (0, $lWhTC.getClient)();
        if (!client) return sink.error(new Error('Unable to create subscription client'));
        const payload = {
            query: '',
            operationName: operationName,
            variables: variables,
            extensions: {
                pq: id
            }
        };
        let requestId;
        return client.subscribe(payload, {
            ...sink,
            next: (value)=>{
                // @ts-expect-error agg prop is missing on generic "extensions" type
                const aggRequestId = value?.extensions?.gateway?.request_id;
                requestId = aggRequestId ?? requestId;
                // @ts-expect-error incompatible types between two libraries
                sink.next(value);
            },
            error: (sinkError)=>{
                const errorInfo = (0, $1Uhm6.getSinkError)(sinkError);
                const attributes = {
                    operationName: operationName,
                    requestId: requestId,
                    userLocation: (0, $cfDZ3.getUserLocation)()
                };
                sink.error(errorInfo);
                (0, $jcw0u.default)({
                    meta: {
                        id: 'subscription',
                        packageName: 'jiraRelaySubscription',
                        teamName: 'uip-graphql'
                    },
                    error: errorInfo,
                    attributes: attributes,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    });

});
parcelRegister("lWhTC", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $2a46eca1e9133707$export$6bb76d6eba7e258c);

var $4U1PW = parcelRequire("4U1PW");

var $jQsty = parcelRequire("jQsty");

var $gwtGO = parcelRequire("gwtGO");


var $hoQbP = parcelRequire("hoQbP");
let $2a46eca1e9133707$var$client;
const $2a46eca1e9133707$export$6bb76d6eba7e258c = ()=>{
    if ((0, $hoQbP.isSSR)() || (0, $jQsty.default)('graphql_subscriptions')) return null;
    if (!$2a46eca1e9133707$var$client) $2a46eca1e9133707$var$client = (0, $4U1PW.createClient)({
        url: (0, $hoQbP.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, $37d1b046897e548f$export$8b012b965402e06a),
        retryAttempts: (0, $37d1b046897e548f$export$bf6cd96e19b2987f),
        connectionParams: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $gwtGO.default).join(',')
        }
    });
    return $2a46eca1e9133707$var$client;
};
const $2a46eca1e9133707$export$2f0afd443356d36f = ()=>{
    $2a46eca1e9133707$var$client = null;
};

});
const $37d1b046897e548f$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $37d1b046897e548f$export$bf6cd96e19b2987f = 100;
const $37d1b046897e548f$export$1ad8434180c5936c = 300000; // 5m

parcelRegister("hoQbP", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $9e6d9986231c3fe5$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $9e6d9986231c3fe5$export$29a72e89601dfc59);
const $9e6d9986231c3fe5$export$48d7c418edadb60c = ()=>false ?? false;
const $9e6d9986231c3fe5$export$29a72e89601dfc59 = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    `${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;

});


parcelRegister("1Uhm6", function(module, exports) {

$parcel$export(module.exports, "getSinkError", () => $db2d4e9951ebaa0f$export$ece4736473c28965);
const $db2d4e9951ebaa0f$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (typeof error === 'object' && 'type' in error && error.type === 'error') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`ErrorEvent: "${error.error}"`);
    else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    if (error instanceof Error && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};

});


parcelRegister("fwvto", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $c5bf640417859136$export$48d7c418edadb60c);
const $c5bf640417859136$export$48d7c418edadb60c = ()=>false ?? false;

});




parcelRegister("d5W4H", function(module, exports) {

$parcel$export(module.exports, "canFetchForgeModules", () => $f4d6ea2b45e6b20f$export$bb3a4a3b8e654c08);
const $f4d6ea2b45e6b20f$export$bb3a4a3b8e654c08 = ({ isAnonymous: isAnonymous, cloudId: cloudId })=>{
    /**
	 * SMT-1142
	 * A tenant named `bob` is most likely a local/ci instance started with `./jmake run ci`.
	 * It wasn't possible to find the hostname in a reasonable timeframe so this is the most feasible solution.
	 * In case more tenants like this spawn in the future we'd need to mark these instances instead and block here.
	 */ if (String(cloudId) === 'bob') return false;
    /**
	 * Similarly to the `bob` tenant situation above, we don't want to fetch Forge modules on monolith webdriver tests,
	 * that are also started with `./jmake run ci`, but this time with a valid `cloudId`.
	 * The reason for that is the heartbeat service that is not available in there, which leads to the login page redirects.
	 */ if (!false && $f4d6ea2b45e6b20f$export$489a82a1efc4cd04().endsWith('.atl-test.space')) return false;
    // There is no anonymous access for now
    return !isAnonymous;
};
const $f4d6ea2b45e6b20f$export$489a82a1efc4cd04 = ()=>window.location.hostname;

});

parcelRegister("h8M2b", function(module, exports) {

$parcel$export(module.exports, "toMappedExtensions", () => $cb129cf486f6f6f7$export$e073e0c0d1c23345);
function $cb129cf486f6f6f7$export$e073e0c0d1c23345(requestedModules, returnedExtensions) {
    const result = Object.fromEntries(requestedModules.map((type)=>[
            type,
            []
        ]));
    returnedExtensions.forEach((extension)=>{
        result[extension.type]?.push(extension);
    });
    // There is no better way to work this out and preserve a generic object response
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return result;
}

});

parcelRegister("ioGTN", function(module, exports) {

$parcel$export(module.exports, "trackGraphQLErrors", () => $03e8a2344fd340fa$export$a5c00ff206a4c88b);

var $5a0Nh = parcelRequire("5a0Nh");

var $bvblX = parcelRequire("bvblX");

var $1u51R = parcelRequire("1u51R");
function $03e8a2344fd340fa$export$a5c00ff206a4c88b(operationName) {
    const queryId = (0, $5a0Nh.startCaptureGraphQlErrors)();
    (0, $1u51R.startCapturingTraceIds)(operationName);
    return {
        stopGraphQLErrorTracking: ()=>(0, $1u51R.stopCapturingTraceIds)(operationName),
        getGraphQLError: ()=>$03e8a2344fd340fa$var$getGraphQLError(queryId, operationName)
    };
}
function $03e8a2344fd340fa$var$getGraphQLError(key, operationName) {
    const errors = (0, $5a0Nh.stopCaptureGraphQlErrors)(key).filter((errorWrapper)=>errorWrapper.meta.operationName === operationName).flatMap((errorWrapper)=>errorWrapper.errors);
    if (errors.length) return new (0, $bvblX.TrackedGraphQLError)(`Query ${operationName} had graphql errors`, errors, (0, $1u51R.getTraceIds)(operationName));
    return undefined;
}

});


parcelRegister("dK8AG", function(module, exports) {

$parcel$export(module.exports, "getProjectKeyOrId", () => $9ffe1ab8f180b628$export$43cde151f667c69e);
$parcel$export(module.exports, "getProjectKeyOrIdFromMatchAndQuery", () => $9ffe1ab8f180b628$export$b87af5b274141bd6);

var $1nb22 = parcelRequire("1nb22");
const $9ffe1ab8f180b628$export$43cde151f667c69e = (match)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, match.query);
    return projectKey || projectId || '';
};
const $9ffe1ab8f180b628$export$b87af5b274141bd6 = ({ match: match, query: query })=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};

});

parcelRegister("1yLrr", function(module, exports) {

$parcel$export(module.exports, "uniqueExtensionsFilter", () => $8bb90f56b7c2b78a$export$2b91ba95eded67f6);
$parcel$export(module.exports, "adminPageFilter", () => $8bb90f56b7c2b78a$export$1eefd1d9cde49fd5);

var $3JOCw = parcelRequire("3JOCw");

var $e0AC8 = parcelRequire("e0AC8");
const $8bb90f56b7c2b78a$export$2b91ba95eded67f6 = (extensions)=>(0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(extensions, (extension)=>{
        const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
        return `${appId}_${envId}`;
    });
const $8bb90f56b7c2b78a$export$1eefd1d9cde49fd5 = (extensions)=>{
    const configPageFilter = (extension)=>extension.properties.useAsConfig;
    const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
    const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
    return [
        ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(mainPageFilter)),
        ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(configPageFilter)),
        ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(getStartedPageFilter))
    ];
};

});
parcelRegister("3JOCw", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $7CoLY = parcelRequire("7CoLY");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $2b8cd72f1d3e4fca$var$uniqBy(array, iteratee) {
    return array && array.length ? $7CoLY(array, $bxDef(iteratee, 2)) : [];
}
module.exports = $2b8cd72f1d3e4fca$var$uniqBy;

});

parcelRegister("e0AC8", function(module, exports) {

$parcel$export(module.exports, "parseExtensionId", () => $d4c89d40e0b3eaac$export$bae42cbaf7fa3e1b);
$parcel$export(module.exports, "getSameEnvAppIdFromExtensionId", () => $d4c89d40e0b3eaac$export$a92b17288693d366);
const $d4c89d40e0b3eaac$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const [, appId, envId] = extensionId.split('/');
    return {
        appId: appId,
        envId: envId
    };
};
const $d4c89d40e0b3eaac$export$a92b17288693d366 = (extensionId)=>extensionId.split('/').slice(1, 3).join('/');

});



parcelRegister("7xTO3", function(module, exports) {

$parcel$export(module.exports, "staticJSWUserBoardSidebarNavigationResource", () => $7371ef5d04dd1248$export$5839dd8142de842e);

var $dJl1T = parcelRequire("dJl1T");

var $8YTna = parcelRequire("8YTna");

var $2M1hQ = parcelRequire("2M1hQ");

var $55UpE = parcelRequire("55UpE");
const $7371ef5d04dd1248$export$5839dd8142de842e = (0, $2M1hQ.createResource)({
    type: 'JIRA_USER_BOARD_NAVIGATION_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $8YTna.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $8YTna.getBoardId)(match, query);
        if (boardId == null) return null;
        try {
            const response = await (0, $55UpE.fetchUserBoardNavigationData)(boardId);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('navigation-apps.resources.static-jsw-userboard-sidebar', 'Fail to fetch user board', e);
            return null;
        }
    },
    maxAge: 300000
});

});
parcelRegister("55UpE", function(module, exports) {

$parcel$export(module.exports, "fetchUserBoardNavigationData", () => $e577b36e40c022cb$export$306fb49fca60b34);

var $eusud = parcelRequire("eusud");
const $e577b36e40c022cb$export$306fb49fca60b34 = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $eusud.performGetRequest)(`/rest/navigation/4/sidebar/people/boards/${boardId}`);
};

});


parcelRegister("c1N9v", function(module, exports) {

$parcel$export(module.exports, "staticPlanSidebarNavigationResource", () => $4a8a43738dc54d5c$export$e7e6c1b9d8d5ea7);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $2M1hQ = parcelRequire("2M1hQ");

var $ijN6s = parcelRequire("ijN6s");
const $4a8a43738dc54d5c$var$getRouterKey = (match)=>{
    if (match.url.includes('/plans/')) return `planId-${match.params.planId || ''}-scenarioId-${match.params.scenarioId || ''}`;
    return 'none';
};
const $4a8a43738dc54d5c$export$e7e6c1b9d8d5ea7 = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PLAN',
    getKey: ({ match: match })=>$4a8a43738dc54d5c$var$getRouterKey(match),
    getData: async ({ match: { params: { planId: planId, scenarioId: scenarioId } } })=>{
        if (planId == null || scenarioId == null) return null;
        return (0, $ijN6s.fetchPlanSidebarNavInfo)(planId, scenarioId);
    },
    maxAge: 300000
});

});
parcelRegister("ijN6s", function(module, exports) {

$parcel$export(module.exports, "fetchPlanSidebarNavInfo", () => $b2d0559c1bc2bb35$export$a49729698cfc5310);

var $eusud = parcelRequire("eusud");
const $b2d0559c1bc2bb35$var$requestSideBarInfo = (planId, scenarioId)=>(0, $eusud.performGetRequest)(`/rest/jpo/1.0/navigation/plans/${planId}/scenarios/${scenarioId}`);
const $b2d0559c1bc2bb35$export$a49729698cfc5310 = (planId, scenarioId)=>{
    if (planId == null || planId.trim() === '') throw new Error('Plan cannot be loaded without a planId');
    if (scenarioId == null || scenarioId.trim() === '') throw new Error('Plan cannot be loaded without a scenarioId');
    return $b2d0559c1bc2bb35$var$requestSideBarInfo(planId, scenarioId);
};

});


parcelRegister("2fwuR", function(module, exports) {

$parcel$export(module.exports, "sidebarNav4Resource", () => $692dbcae1edae2a1$export$7648dc6f76f4f83d);
$parcel$export(module.exports, "sidebarNav4UiStateResource", () => $692dbcae1edae2a1$export$a46129bd512544d7);

var $jhS4y = parcelRequire("jhS4y");

var $3Jbkp = parcelRequire("3Jbkp");

var $fMcVX = parcelRequire("fMcVX");

var $ao2h1 = parcelRequire("ao2h1");

var $2OeZv = parcelRequire("2OeZv");

var $fZBia = parcelRequire("fZBia");

var $kYHsT = parcelRequire("kYHsT");

var $k9L5z = parcelRequire("k9L5z");
const $692dbcae1edae2a1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY = 'SIDEBAR_V2_RELAY';
const $692dbcae1edae2a1$export$7648dc6f76f4f83d = (0, $ao2h1.createRelayResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${$692dbcae1edae2a1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY}`,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId, activationId: activationId, atlassianAccountId: atlassianAccountId } })=>{
        const initialSelectedPath = (0, $3Jbkp.getInitialSelectedPath)(routerContext);
        return {
            parameters: (0, $2OeZv.default),
            variables: {
                cloudId: cloudId,
                isAppsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_APPS)),
                isFiltersExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_FILTERS)),
                isPlansExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_PLANS)),
                isProjectsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_PROJECTS)),
                isOperationsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_OPERATIONS)),
                isOverviewsExpanded: (0, $fMcVX.isSelectedPath)(initialSelectedPath, (0, $jhS4y.MENU_ID_OVERVIEWS)),
                entityAriProjects: (0, $kYHsT.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'projects'
                }).toString(),
                ownerAri: atlassianAccountId && (0, $k9L5z.IdentityUserAri).create({
                    userId: atlassianAccountId
                }).toString()
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});
const $692dbcae1edae2a1$export$a46129bd512544d7 = (0, $ao2h1.createRelayResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_SIDEBAR_V2_UI_STATE_RELAY`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $fZBia.default),
            variables: {
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("jhS4y", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_APP_MENU_ID", () => $d66e3a3484b422c6$export$1bb3d16bc95080e3);
$parcel$export(module.exports, "CONFIGURABLE_MENU_ID", () => $d66e3a3484b422c6$export$7838b734e4cd5e8d);
$parcel$export(module.exports, "ENTITY_ID", () => $d66e3a3484b422c6$export$103ff18fe29ee1b);
$parcel$export(module.exports, "MENU_ID_APPS", () => $d66e3a3484b422c6$export$441cd608ea3204f4);
$parcel$export(module.exports, "MENU_ID_APP_MARKETPLACE_DISCOVER", () => $d66e3a3484b422c6$export$5baa9c2e3c3931c5);
$parcel$export(module.exports, "MENU_ID_ASSETS", () => $d66e3a3484b422c6$export$75c65bfc98b3a6e1);
$parcel$export(module.exports, "MENU_ID_ASSETS_SCHEMAS", () => $d66e3a3484b422c6$export$8a0af92d49f1d13d);
$parcel$export(module.exports, "MENU_ID_ASSETS_REPORTS", () => $d66e3a3484b422c6$export$a09300d15acc958a);
$parcel$export(module.exports, "MENU_ID_BOARDS_VIEW_ALL", () => $d66e3a3484b422c6$export$4d718fbd418eef5c);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS", () => $d66e3a3484b422c6$export$dd009509c2dabb5e);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL", () => $d66e3a3484b422c6$export$d3da0455b4200fb2);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL_STARRED", () => $d66e3a3484b422c6$export$b9dd2b5309d19763);
$parcel$export(module.exports, "MENU_ID_FILTERS", () => $d66e3a3484b422c6$export$3d81af172a8e3c57);
$parcel$export(module.exports, "MENU_ID_FILTERS_SEARCH", () => $d66e3a3484b422c6$export$1e2599eaf0039a97);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL", () => $d66e3a3484b422c6$export$53d274d993c9d5b5);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL_STARRED", () => $d66e3a3484b422c6$export$7661ea763be69cfa);
$parcel$export(module.exports, "MENU_ID_GOALS", () => $d66e3a3484b422c6$export$47c6ce6a83a59eab);
$parcel$export(module.exports, "MENU_ID_OPERATIONS", () => $d66e3a3484b422c6$export$ef89639b7d9c162a);
$parcel$export(module.exports, "MENU_ID_OPS_ALERTS", () => $d66e3a3484b422c6$export$af4ab6d4e920522a);
$parcel$export(module.exports, "MENU_ID_OPS_OVERVIEW", () => $d66e3a3484b422c6$export$25c40acb2c53a294);
$parcel$export(module.exports, "MENU_ID_OPS_REPORTS", () => $d66e3a3484b422c6$export$c7d8892f1628b844);
$parcel$export(module.exports, "MENU_ID_OPS_ON_CALL", () => $d66e3a3484b422c6$export$bb19a52e3df99541);
$parcel$export(module.exports, "MENU_ID_OVERVIEWS", () => $d66e3a3484b422c6$export$3bd12c092f8db11b);
$parcel$export(module.exports, "MENU_ID_PLANS", () => $d66e3a3484b422c6$export$f2533da33c749933);
$parcel$export(module.exports, "MENU_ID_PLANS_VIEW_ALL", () => $d66e3a3484b422c6$export$8468c5b6648f4f1f);
$parcel$export(module.exports, "MENU_ID_PROJECT_APPS", () => $d66e3a3484b422c6$export$fed17b4c0866b97d);
$parcel$export(module.exports, "MENU_ID_PROJECTS", () => $d66e3a3484b422c6$export$9c5278bd360a285);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL", () => $d66e3a3484b422c6$export$85389c606bb641dd);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL_STARRED", () => $d66e3a3484b422c6$export$4a1974b63c858e9c);
$parcel$export(module.exports, "MENU_ID_RECENT", () => $d66e3a3484b422c6$export$692b796030a796f3);
$parcel$export(module.exports, "MENU_ID_ROADMAPS", () => $d66e3a3484b422c6$export$cdc80d4b5ce0c6a);
$parcel$export(module.exports, "MENU_ID_ROADMAPS_VIEW_ALL", () => $d66e3a3484b422c6$export$7606c0134aabf3d7);
$parcel$export(module.exports, "MENU_ID_STARRED", () => $d66e3a3484b422c6$export$5637ca42a4d77f32);
$parcel$export(module.exports, "MENU_ID_TEAMS", () => $d66e3a3484b422c6$export$d4f6fcf571f9c50);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE", () => $d66e3a3484b422c6$export$11fcdf33179ef88e);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_HUBS", () => $d66e3a3484b422c6$export$d69bec513af84431);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE_ANALYTICS", () => $d66e3a3484b422c6$export$1d260f51eeaab73d);
$parcel$export(module.exports, "MENU_ID_YOUR_WORK", () => $d66e3a3484b422c6$export$80dc576e446bdb6b);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_ASSETS", () => $d66e3a3484b422c6$export$5aa3e4dd37f372d5);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_GOALS", () => $d66e3a3484b422c6$export$7986b535c183c592);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_ACCESS", () => $d66e3a3484b422c6$export$79c15668ed799a1b);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT", () => $d66e3a3484b422c6$export$e299bb06c4370c0d);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES", () => $d66e3a3484b422c6$export$713b9b0a69a79cf9);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_AUTOMATION", () => $d66e3a3484b422c6$export$f1d9c0f27216aa1c);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE", () => $d66e3a3484b422c6$export$45763fa331781074);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_NOTIFICATIONS", () => $d66e3a3484b422c6$export$6ee20c845dbab3e3);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_APPS", () => $d66e3a3484b422c6$export$b3815dd180ce5e61);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_OPERATIONS", () => $d66e3a3484b422c6$export$100a1a639a0db980);
const $d66e3a3484b422c6$export$1bb3d16bc95080e3 = {
    GLOBAL_APP_GOALS: 'jira.sidebar.globalApp.goals',
    GLOBAL_APP_ASSETS: 'jira.sidebar.globalApp.assets'
};
const $d66e3a3484b422c6$export$7838b734e4cd5e8d = {
    APPS: 'jira.sidebar.apps',
    ASSETS: 'jira.sidebar.assets',
    DASHBOARDS: 'jira.sidebar.dashboards',
    FILTERS: 'jira.sidebar.filters',
    GOALS: 'jira.sidebar.goals',
    OPERATIONS: 'jira.sidebar.operations',
    OVERVIEWS: 'jira.sidebar.overviews',
    PLANS: 'jira.sidebar.plans',
    PROJECTS: 'jira.sidebar.projects',
    RECENT: 'jira.sidebar.recent',
    STARRED: 'jira.sidebar.starred',
    TEAMS: 'jira.sidebar.teams',
    ROADMAPS: 'jira.sidebar.roadmaps',
    CUSTOMER_SERVICE: 'jira.sidebar.customerService',
    CUSTOMER_HUBS: 'jira.sidebar.customerHubs',
    CUSTOMER_SERVICE_ANALYTICS: 'jira.sidebar.customerServiceAnalytics',
    ...$d66e3a3484b422c6$export$1bb3d16bc95080e3
};
const $d66e3a3484b422c6$export$103ff18fe29ee1b = {
    ALARM_QUEUE: (id)=>`alrm_${id}`,
    APP: (id)=>`app_${id}`,
    BOARD: (id)=>`boar_${id}`,
    DASHBOARD: (id)=>`dash_${id}`,
    FILTER: (id)=>`filt_${id}`,
    FORM: (id)=>`form_${id}`,
    OVERVIEW: (id)=>`over_${id}`,
    PLAN: (id)=>`plan_${id}`,
    PROJECT: (id)=>`proj_${id}`,
    PROJECT_CALENDAR: (projectKey)=>`proj-${projectKey}-cal`,
    PROJECT_CHANGE_CALENDAR: (projectKey)=>`proj-${projectKey}-chgcal`,
    PROJECT_ESCALATIONS: (projectKey)=>`proj-${projectKey}-escl`,
    PROJECT_DIRECTORY: (projectKey)=>`proj-${projectKey}-dir`,
    PROJECT_FILTERS: (projectKey)=>`proj-${projectKey}-filters`,
    PROJECT_ISSUE_FILTER: (projectKey, filterId)=>`proj-${projectKey}-issf-${filterId}`,
    PROJECT_JSM_GETTING_STARTED: (projectKey)=>`proj-${projectKey}-jsm-gtst`,
    PROJECT_KNOWLEDGE_BASE: (projectKey)=>`proj-${projectKey}-kb`,
    PROJECT_OPERATIONS: (projectKey)=>`proj-${projectKey}-ops`,
    PROJECT_NOTIFICATION_LOGS: (projectKey)=>`proj-${projectKey}-nlog`,
    PROJECT_ONCALL_SCHEDULE: (projectKey)=>`proj-${projectKey}-oncs`,
    PROJECT_PRACTICE_QUEUE: (projectKey, practice)=>`proj-${projectKey}-pract-${practice}`,
    PROJECT_QUEUES: (projectKey)=>`proj-${projectKey}-queues`,
    PROJECT_REPORTS: (projectKey)=>`proj-${projectKey}-rprt`,
    PROJECT_SERVICES: (projectKey)=>`proj-${projectKey}-srvc`,
    PROJECT_SUMMARY: (projectKey)=>`proj-${projectKey}-summary`,
    PROJECT_VIEWS: (projectKey)=>`proj-${projectKey}-views`,
    ROADMAP: (id)=>`roadmap_${id}`,
    QUEUE: (id)=>`queu_${id}`,
    ISSUE: (id)=>`issue_${id}`,
    ARCHIVED_ISSUES: (id)=>`archived_issues_${id}`
}; // We MUST use the same IDs for the same components, otherwise we run into trouble (especially with peeking / more-menu)
const $d66e3a3484b422c6$export$441cd608ea3204f4 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.APPS;
const $d66e3a3484b422c6$export$5baa9c2e3c3931c5 = 'app_mrkt';
const $d66e3a3484b422c6$export$75c65bfc98b3a6e1 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.ASSETS;
const $d66e3a3484b422c6$export$8a0af92d49f1d13d = 'asst_schm';
const $d66e3a3484b422c6$export$a09300d15acc958a = 'asst_rprt';
const $d66e3a3484b422c6$export$4d718fbd418eef5c = 'board-view-all';
const $d66e3a3484b422c6$export$dd009509c2dabb5e = $d66e3a3484b422c6$export$7838b734e4cd5e8d.DASHBOARDS;
const $d66e3a3484b422c6$export$d3da0455b4200fb2 = 'dash-view';
const $d66e3a3484b422c6$export$b9dd2b5309d19763 = 'dash-view-starred';
const $d66e3a3484b422c6$export$3d81af172a8e3c57 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.FILTERS;
const $d66e3a3484b422c6$export$1e2599eaf0039a97 = 'filt-search';
const $d66e3a3484b422c6$export$53d274d993c9d5b5 = 'filt-view-all';
const $d66e3a3484b422c6$export$7661ea763be69cfa = 'filt-view-starred';
const $d66e3a3484b422c6$export$47c6ce6a83a59eab = $d66e3a3484b422c6$export$7838b734e4cd5e8d.GOALS;
const $d66e3a3484b422c6$export$ef89639b7d9c162a = $d66e3a3484b422c6$export$7838b734e4cd5e8d.OPERATIONS;
const $d66e3a3484b422c6$export$af4ab6d4e920522a = 'ops-alrt';
const $d66e3a3484b422c6$export$25c40acb2c53a294 = 'ops-over';
const $d66e3a3484b422c6$export$c7d8892f1628b844 = 'ops-rprt';
const $d66e3a3484b422c6$export$bb19a52e3df99541 = 'ops-oncl';
const $d66e3a3484b422c6$export$3bd12c092f8db11b = $d66e3a3484b422c6$export$7838b734e4cd5e8d.OVERVIEWS;
const $d66e3a3484b422c6$export$f2533da33c749933 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.PLANS;
const $d66e3a3484b422c6$export$8468c5b6648f4f1f = 'plan-view-all';
const $d66e3a3484b422c6$export$fed17b4c0866b97d = 'proj-app';
const $d66e3a3484b422c6$export$9c5278bd360a285 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.PROJECTS;
const $d66e3a3484b422c6$export$85389c606bb641dd = 'proj-view-all';
const $d66e3a3484b422c6$export$4a1974b63c858e9c = 'proj-view-starred';
const $d66e3a3484b422c6$export$692b796030a796f3 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.RECENT;
const $d66e3a3484b422c6$export$cdc80d4b5ce0c6a = $d66e3a3484b422c6$export$7838b734e4cd5e8d.ROADMAPS;
const $d66e3a3484b422c6$export$7606c0134aabf3d7 = 'roadmaps-view-all';
const $d66e3a3484b422c6$export$5637ca42a4d77f32 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.STARRED;
const $d66e3a3484b422c6$export$d4f6fcf571f9c50 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.TEAMS;
const $d66e3a3484b422c6$export$11fcdf33179ef88e = $d66e3a3484b422c6$export$7838b734e4cd5e8d.CUSTOMER_SERVICE;
const $d66e3a3484b422c6$export$d69bec513af84431 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.CUSTOMER_HUBS;
const $d66e3a3484b422c6$export$1d260f51eeaab73d = $d66e3a3484b422c6$export$7838b734e4cd5e8d.CUSTOMER_SERVICE_ANALYTICS;
const $d66e3a3484b422c6$export$80dc576e446bdb6b = 'yrwk';
const $d66e3a3484b422c6$export$5aa3e4dd37f372d5 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.GLOBAL_APP_ASSETS;
const $d66e3a3484b422c6$export$7986b535c183c592 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.GLOBAL_APP_GOALS;
const $d66e3a3484b422c6$export$79c15668ed799a1b = 'sd-sett-acc';
const $d66e3a3484b422c6$export$e299bb06c4370c0d = 'sd-sett-req-man';
const $d66e3a3484b422c6$export$713b9b0a69a79cf9 = 'sd-sett-req-typs';
const $d66e3a3484b422c6$export$f1d9c0f27216aa1c = 'sd-sett-aut';
const $d66e3a3484b422c6$export$45763fa331781074 = 'sd-sett-ch-slf-srv';
const $d66e3a3484b422c6$export$6ee20c845dbab3e3 = 'sd-sett-not';
const $d66e3a3484b422c6$export$b3815dd180ce5e61 = 'sd-sett-apps';
const $d66e3a3484b422c6$export$100a1a639a0db980 = 'sd-sett-ops';

});

parcelRegister("3Jbkp", function(module, exports) {

$parcel$export(module.exports, "getInitialSelectedPath", () => $e52131b0b61339d3$export$39f409bc5f59c5e);
/**
 * Why do we need the initialSelectedPath? It all stems from the workaround that Nav4 uses
 * to SSR the initial sidebar semi-correctly, while pretending to lazy-load everything else.
 *
 * Ideally we would be able to pre-load entrypoints that we know we need to load, and lazy-load
 * the rest. This would support SSR and be performant.
 * Unfortunately, unless all of the Jira routes are loaded via entry-points, we cannot use this approach.
 *
 * The workaround is to use Relay variables to tell Relay what data to preload, and then load
 * the corresponding UI component directly (not via an entrypoint) when we have the data for it.
 * When we don't have the preloaded data, we lazy load __the same component via an entrypoint__.
 * In other words, we sacrifice bundle size (by directly including the component for the data-available
 * case), in order to get SSR benefits.
 *
 * A consequence of this approach is we have two versions of the top-level menu item components - the
 * regular version (called *Landing) and the entrypoint version (called *Default). When navigating,
 * the router's state would change, causing the components to switch around. In the UI, this would
 * cause ExpandableMenuItem components to collapse, when they were open before navigating.
 *
 * To work around THIS problem, we store a computed-version of the initial state of the router, and
 * then query this value when deciding which component to show (the *Landing or the *Default). Because if
 * the initial state doesn't change, our components won't switch around after the first render.
 */ 
var $bxYf9 = parcelRequire("bxYf9");

var $7Ckoi = parcelRequire("7Ckoi");
const $e52131b0b61339d3$export$39f409bc5f59c5e = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))((0, $7Ckoi.routeToSelectedPath));

});
parcelRegister("7Ckoi", function(module, exports) {

$parcel$export(module.exports, "routeToSelectedPath", () => $551cdf5d088747a1$export$a92474c098a1fd13);
$parcel$export(module.exports, "useRouteToSelectedPath", () => $551cdf5d088747a1$export$a086f1986cac3253);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $4R6GH = parcelRequire("4R6GH");

var $lODMY = parcelRequire("lODMY");

var $fBDpl = parcelRequire("fBDpl");

var $ezq2z = parcelRequire("ezq2z");

var $j3mSh = parcelRequire("j3mSh");

var $1RoZ2 = parcelRequire("1RoZ2");

var $hdJn1 = parcelRequire("hdJn1");

var $2m3Yb = parcelRequire("2m3Yb");

var $3weqe = parcelRequire("3weqe");

var $c6hlO = parcelRequire("c6hlO");

var $3lNyZ = parcelRequire("3lNyZ");

var $8bXrC = parcelRequire("8bXrC");

var $eReVn = parcelRequire("eReVn");

var $djX45 = parcelRequire("djX45");
function $551cdf5d088747a1$export$a92474c098a1fd13(routeContext) {
    const routeName = routeContext.route.name;
    if ((0, $2m3Yb.topLevelConverter).routes.has(routeName)) return (0, $2m3Yb.topLevelConverter).convert(routeContext);
    if ((0, $fBDpl.appsConverter).routes.has(routeName)) return (0, $fBDpl.appsConverter).convert(routeContext);
    if ((0, $ezq2z.assetsConverter).routes.has(routeName)) return (0, $ezq2z.assetsConverter).convert(routeContext);
    if ((0, $j3mSh.dashboardsConverter).routes.has(routeName)) return (0, $j3mSh.dashboardsConverter).convert(routeContext);
    if ((0, $1RoZ2.filtersConverter).routes.has(routeName)) return (0, $1RoZ2.filtersConverter).convert(routeContext);
    if ((0, $hdJn1.operationsConverter).routes.has(routeName)) return (0, $hdJn1.operationsConverter).convert(routeContext);
    if ((0, $3weqe.overviewsConverter).routes.has(routeName)) return (0, $3weqe.overviewsConverter).convert(routeContext);
    if ((0, $3weqe.overviewsConverter).routes.has(routeName)) return (0, $3weqe.overviewsConverter).convert(routeContext);
    if ((0, $c6hlO.plansConverter).routes.has(routeName)) return (0, $c6hlO.plansConverter).convert(routeContext);
    if ((0, $3lNyZ.projectsConverter).routes.has(routeName)) return (0, $3lNyZ.projectsConverter).convert(routeContext);
    if ((0, $8bXrC.roadmapsConverter).routes.has(routeName)) return (0, $8bXrC.roadmapsConverter).convert(routeContext);
    if ((0, $eReVn.serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, $eReVn.serviceManagementProjectSettingsConverter).convert(routeContext);
    if ((0, $4R6GH.fg)('jcs_master_flag')) {
        if ((0, $djX45.customerServiceConverter).routes.has(routeName)) return (0, $djX45.customerServiceConverter).convert(routeContext);
    }
    return [];
}
function $551cdf5d088747a1$export$216c13b87ae41e0b(state) {
    const routeName = state.route.name;
    const match = state.match;
    const query = state.query;
    if ((0, $2m3Yb.topLevelConverter).routes.has(routeName)) return (0, $2m3Yb.topLevelConverter).convertNew({
        routeName: routeName
    });
    if ((0, $fBDpl.appsConverter).routes.has(routeName)) return (0, $fBDpl.appsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $ezq2z.assetsConverter).routes.has(routeName)) return (0, $ezq2z.assetsConverter).convertNew({
        routeName: routeName
    });
    if ((0, $j3mSh.dashboardsConverter).routes.has(routeName)) return (0, $j3mSh.dashboardsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $1RoZ2.filtersConverter).routes.has(routeName)) return (0, $1RoZ2.filtersConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $hdJn1.operationsConverter).routes.has(routeName)) return (0, $hdJn1.operationsConverter).convertNew({
        routeName: routeName,
        query: query
    });
    if ((0, $3weqe.overviewsConverter).routes.has(routeName)) return (0, $3weqe.overviewsConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $c6hlO.plansConverter).routes.has(routeName)) return (0, $c6hlO.plansConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $3lNyZ.projectsConverter).routes.has(routeName)) return (0, $3lNyZ.projectsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $8bXrC.roadmapsConverter).routes.has(routeName)) return (0, $8bXrC.roadmapsConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $eReVn.serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, $eReVn.serviceManagementProjectSettingsConverter).convertNew({
        routeName: routeName
    });
    if ((0, $4R6GH.fg)('jcs_master_flag')) {
        if ((0, $djX45.customerServiceConverter).routes.has(routeName)) return (0, $djX45.customerServiceConverter).convertNew({
            routeName: routeName
        });
    }
    return [];
}
function $551cdf5d088747a1$export$8eb45058a3aef67f() {
    return (0, $5uXOq.useState)(()=>{
        const selectedPath = $551cdf5d088747a1$export$216c13b87ae41e0b((0, $lODMY.getRouterState)());
        return {
            initialSelectedPath: selectedPath,
            selectedPath: selectedPath
        };
    });
}
function $551cdf5d088747a1$export$a086f1986cac3253() {
    const [selectedPathData, setSelectedPathData] = $551cdf5d088747a1$export$8eb45058a3aef67f();
    (0, $5uXOq.useEffect)(()=>(0, $lODMY.addRouteListener)((state)=>{
            const nextSelectedPath = $551cdf5d088747a1$export$216c13b87ae41e0b(state);
            const pathIsDifferent = (0, $4R6GH.fg)('jira-concurrent-nav4-fix-selected-path') ? !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(nextSelectedPath, selectedPathData.selectedPath) // Since this is an array and not a primitive, we need to do an isEqual check
             : nextSelectedPath !== selectedPathData.selectedPath;
            if (pathIsDifferent) setSelectedPathData({
                initialSelectedPath: selectedPathData.initialSelectedPath,
                selectedPath: nextSelectedPath
            });
        }), [
        selectedPathData.initialSelectedPath,
        selectedPathData.selectedPath,
        setSelectedPathData
    ]);
    return selectedPathData;
}

});
parcelRegister("fBDpl", function(module, exports) {

$parcel$export(module.exports, "appsConverter", () => $55a8ac7f9c56fb94$export$d017a63045c88c47);

var $jhS4y = parcelRequire("jhS4y");
// TODO: verify these routes
const $55a8ac7f9c56fb94$var$UNCERTAIN_APPS_SECTION_ROUTES = [
    'connect-general',
    'connect-general-invalid',
    'legacy-connect-general',
    'legacy-connect-project',
    /**
	 * This one tricky, and I wish it was documented somewhere, so here you go:
	 * Among different Connect app types, there are global Connect apps and JSM Connect apps (project apps).
	 * The URL of the global app looks like this:
	 *   `/plugins/servlet/ac/catlassian/catlassian-page?project.key=IP&project.id=10154`
	 * The URL of the JSM project app looks like this (there is also another URL pattern, but it is not relevant to this case):
	 *   `/plugins/servlet/ac/catlassian/catlassian-page-A?project.key=IP&project.id=10154&servicedesk.serviceDeskId=31`
	 * They have different route names and differ only by the `servicedesk.serviceDeskId` query parameter.
	 * But here's the catch: the global app URL can also contain a `servicedesk.serviceDeskId` query parameter,
	 * it is enough for the user to navigate to a specific JSM route in order for that JSM project to be saved as the most recent project,
	 * and it looks like Connect adds that most recent project context to the URL.
	 * Once that happens, the global app route is no longer matched, the JSM one is, which brings a lot of confusion since at this point
	 * we have no idea whether the "Apps" section should be expanded or the "Projects" one, since it is possible the app lives in either of those.
	 * You can navigate to the JSW project in order to override the JSM one and that query param will disappear from the global app URL.
	 * So what we are doing here? We are adding the route to the list of global Connect apps (just like its route name suggests) and potentially return a false positive value.
	 * Later on in the code we are going to check whether the app is global or not based on the data we have (the list of apps) and fix that.
	 */ 'connect-general-service-desk-project',
    'connect-project'
];
const $55a8ac7f9c56fb94$var$CERTAIN_APPS_SECTION_ROUTES = [
    'forge-spa-global',
    'marketplace-index',
    'forge-spa-personal-settings'
];
const $55a8ac7f9c56fb94$export$66b32f6f30eb4b4 = new Set([
    ...$55a8ac7f9c56fb94$var$UNCERTAIN_APPS_SECTION_ROUTES,
    ...$55a8ac7f9c56fb94$var$CERTAIN_APPS_SECTION_ROUTES
]);
function $55a8ac7f9c56fb94$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_APPS)
    ];
    return $55a8ac7f9c56fb94$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $55a8ac7f9c56fb94$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $jhS4y.MENU_ID_APPS)
    ];
    return $55a8ac7f9c56fb94$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $55a8ac7f9c56fb94$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'marketplace-index':
            path.push((0, $jhS4y.MENU_ID_APP_MARKETPLACE_DISCOVER));
            break;
        case 'connect-general':
        case 'connect-general-invalid':
        case 'forge-spa-global':
        case 'forge-spa-personal-settings':
        case 'legacy-connect-general':
            path.push((0, $jhS4y.ENTITY_ID).APP(match.url.replace(/\/$/, '')));
            break;
        case 'connect-project':
        case 'legacy-connect-project':
            {
                const { projectKey: projectKey } = match.params;
                return [
                    (0, $jhS4y.MENU_ID_PROJECTS),
                    (0, $jhS4y.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        case 'connect-general-service-desk-project':
            {
                const { projectKey: projectKey } = query;
                return [
                    (0, $jhS4y.MENU_ID_PROJECTS),
                    (0, $jhS4y.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        default:
            break;
    }
    return path;
}
const $55a8ac7f9c56fb94$export$d017a63045c88c47 = {
    routes: $55a8ac7f9c56fb94$export$66b32f6f30eb4b4,
    convert: $55a8ac7f9c56fb94$var$convert,
    convertNew: $55a8ac7f9c56fb94$var$convertNew
};

});

parcelRegister("ezq2z", function(module, exports) {

$parcel$export(module.exports, "assetsConverter", () => $bdd6509d07f3cefb$export$6cfeba0849032a84);

var $jhS4y = parcelRequire("jhS4y");
const $bdd6509d07f3cefb$var$routes = new Set([
    'assets',
    'assets-configure',
    'assets-object',
    'assets-schema',
    'assets-schema-configuration',
    'assets-object-type-configuration',
    'assets-reports',
    'assets-reports-default-redirect',
    'assets-reports-unsubscribe',
    'servicedesk-cmdb-assets',
    'servicedesk-cmdb-configure',
    'servicedesk-cmdb-object',
    'servicedesk-cmdb-object-schema',
    'servicedesk-cmdb-object-schema-configuration',
    'servicedesk-cmdb-object-type-configuration',
    'servicedesk-cmdb-assets-reports',
    'servicedesk-cmdb-assets-reports-default-redirect',
    'servicedesk-cmdb-assets-reports-unsubscribe',
    'servicedesk-cmdb-insight',
    'servicedesk-cmdb-configure',
    'servicedesk-cmdb-object',
    'servicedesk-cmdb-object-schema',
    'servicedesk-cmdb-object-schema-configuration',
    'servicedesk-cmdb-object-type-configuration'
]);
function $bdd6509d07f3cefb$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [
        (0, $jhS4y.MENU_ID_ASSETS)
    ];
    return $bdd6509d07f3cefb$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $bdd6509d07f3cefb$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [
        (0, $jhS4y.MENU_ID_ASSETS)
    ];
    return $bdd6509d07f3cefb$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $bdd6509d07f3cefb$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'servicedesk-cmdb-assets':
        case 'servicedesk-cmdb-object':
        case 'servicedesk-cmdb-object-schema':
        case 'servicedesk-cmdb-object-schema-configuration':
        case 'servicedesk-cmdb-object-type-configuration':
            path.push((0, $jhS4y.MENU_ID_ASSETS_SCHEMAS));
            break;
        // Duplicate route-names of the above routes
        // eslint-disable-next-line no-duplicate-case
        case 'servicedesk-cmdb-object':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-schema':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-schema-configuration':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-type-configuration':
            path.push((0, $jhS4y.MENU_ID_ASSETS_SCHEMAS));
            break;
        case 'servicedesk-cmdb-assets-reports':
        case 'servicedesk-cmdb-assets-reports-default-redirect':
        case 'servicedesk-cmdb-assets-reports-unsubscribe':
            path.push((0, $jhS4y.MENU_ID_ASSETS_REPORTS));
            break;
        default:
            break;
    }
    return path;
}
const $bdd6509d07f3cefb$export$6cfeba0849032a84 = {
    routes: $bdd6509d07f3cefb$var$routes,
    convert: $bdd6509d07f3cefb$var$convert,
    convertNew: $bdd6509d07f3cefb$var$convertNew
};

});

parcelRegister("j3mSh", function(module, exports) {

$parcel$export(module.exports, "dashboardsConverter", () => $257dabfdf8711aa2$export$6468819b4be328b1);

var $jhS4y = parcelRequire("jhS4y");
const $257dabfdf8711aa2$var$routes = new Set([
    'dashboards-directory',
    'dashboard-edit',
    'dashboard-view',
    'dashboard-wallboard'
]);
function $257dabfdf8711aa2$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_DASHBOARDS)
    ];
    return $257dabfdf8711aa2$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $257dabfdf8711aa2$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $jhS4y.MENU_ID_DASHBOARDS)
    ];
    return $257dabfdf8711aa2$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $257dabfdf8711aa2$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'dashboards-directory':
            path.push((0, $jhS4y.MENU_ID_DASHBOARDS_VIEW_ALL));
            break;
        case 'dashboard-wallboard':
            query.dashboardId && path.push((0, $jhS4y.ENTITY_ID).DASHBOARD(query.dashboardId));
            break;
        default:
            {
                const dashboardId = match.params.dashboardId;
                if (dashboardId === 'last-visited') // This is not really correct. The problem is we cannot tell what the true dashboardId is in this case.
                path.push((0, $jhS4y.MENU_ID_DASHBOARDS_VIEW_ALL));
                else dashboardId && path.push((0, $jhS4y.ENTITY_ID).DASHBOARD(dashboardId));
                break;
            }
    }
    return path;
}
const $257dabfdf8711aa2$export$6468819b4be328b1 = {
    routes: $257dabfdf8711aa2$var$routes,
    convert: $257dabfdf8711aa2$var$convert,
    convertNew: $257dabfdf8711aa2$var$convertNew
};

});

parcelRegister("1RoZ2", function(module, exports) {

$parcel$export(module.exports, "filtersConverter", () => $c2ae3b230f933dc6$export$6e91331b5debb7c8);

var $jhS4y = parcelRequire("jhS4y");
const $c2ae3b230f933dc6$var$routes = new Set([
    'filters-directory',
    'global-issue-navigator',
    'global-issue-navigator-browse-issue-redirect',
    'issue',
    'legacy-gin',
    'legacy-gin-issue',
    'legacy-gin-subscriptions'
]);
function $c2ae3b230f933dc6$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query, match: match } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_FILTERS)
    ];
    return $c2ae3b230f933dc6$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $c2ae3b230f933dc6$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $jhS4y.MENU_ID_FILTERS)
    ];
    return $c2ae3b230f933dc6$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $c2ae3b230f933dc6$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'filters-directory':
            path.push((0, $jhS4y.MENU_ID_FILTERS_VIEW_ALL));
            break;
        case 'issue':
            {
                const filterId = query.filter || query.filterId;
                if (filterId) path.push((0, $jhS4y.ENTITY_ID).FILTER(filterId));
                else if (match.params?.issueKey) {
                    const [projectKey] = (match.params?.issueKey || '').split('-'); // For this route to match, the issueKey will never be blank
                    return [
                        (0, $jhS4y.MENU_ID_PROJECTS),
                        (0, $jhS4y.ENTITY_ID).PROJECT(projectKey)
                    ];
                }
                break;
            }
        default:
            {
                const filterId = query.filter || query.filterId;
                // Search filters URL
                if (filterId === undefined) path.push((0, $jhS4y.MENU_ID_FILTERS_SEARCH));
                else // The rest of the URLs are using a filter ID.
                // Test this case: https://buglow-jsw.jira-dev.com/secure/ViewSubscriptions.jspa?filterId=10007
                path.push((0, $jhS4y.ENTITY_ID).FILTER(filterId));
                break;
            }
    }
    return path;
}
const $c2ae3b230f933dc6$export$6e91331b5debb7c8 = {
    routes: $c2ae3b230f933dc6$var$routes,
    convert: $c2ae3b230f933dc6$var$convert,
    convertNew: $c2ae3b230f933dc6$var$convertNew
};

});

parcelRegister("hdJn1", function(module, exports) {

$parcel$export(module.exports, "operationsConverter", () => $9b181cf5d70a46b3$export$7fc92455d5020e1);

var $jhS4y = parcelRequire("jhS4y");
const $9b181cf5d70a46b3$var$routes = new Set([
    'eoc-automations',
    'eoc-custom-roles',
    'eoc-global-alerts',
    'eoc-global-alert-detail',
    'eoc-global-group-detail',
    'eoc-global-reports',
    'eoc-global-report-dashboard',
    'eoc-heartbeats',
    'eoc-global-heartbeats',
    'eoc-maintenance',
    'eoc-on-call',
    'eoc-on-call-redirect',
    'eoc-overview',
    'eoc-overview-all-teams',
    'eoc-permissions',
    'eoc-reports',
    'eoc-reports-team',
    'eoc-reports-unsubscribe',
    'eoc-schedules',
    'eoc-team-alerts',
    'eoc-team-alert-detail',
    'eoc-team-alert-issue-syncing',
    'eoc-team-alert-issue-syncing-create',
    'eoc-team-alert-issue-syncing-detail',
    'eoc-team-group-detail',
    'eoc-team-integrations',
    'eoc-team-integration-create',
    'eoc-team-integration-detail',
    'eoc-team-integration-list',
    'eoc-team-integration-log',
    'eoc-team-policies',
    'eoc-who-is-on-call',
    'eoc-global-escalations'
]);
function $9b181cf5d70a46b3$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_OPERATIONS)
    ];
    return $9b181cf5d70a46b3$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $9b181cf5d70a46b3$var$convertNew(args) {
    const { routeName: routeName, query: query } = args;
    const path = [
        (0, $jhS4y.MENU_ID_OPERATIONS)
    ];
    return $9b181cf5d70a46b3$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $9b181cf5d70a46b3$var$convertRouteToPath(args) {
    const { routeName: routeName, query: query, path: path } = args;
    switch(routeName){
        case 'eoc-who-is-on-call':
            path.push((0, $jhS4y.MENU_ID_OPS_ON_CALL));
            break;
        case 'eoc-global-alerts':
        case 'eoc-global-alert-detail':
            {
                path.push((0, $jhS4y.MENU_ID_OPS_ALERTS));
                const { query: alarmQueue = '', view: view } = query;
                view && path.push((0, $jhS4y.ENTITY_ID).ALARM_QUEUE(alarmQueue));
                break;
            }
        case 'eoc-global-reports':
        case 'eoc-global-report-dashboard':
        case 'eoc-reports-unsubscribe':
            path.push((0, $jhS4y.MENU_ID_OPS_REPORTS));
            break;
        case 'eoc-automations':
        case 'eoc-global-group-detail':
        case 'eoc-heartbeats':
        case 'eoc-maintenance':
        case 'eoc-permissions':
        case 'eoc-on-call':
        case 'eoc-on-call-redirect':
        case 'eoc-overview':
        case 'eoc-overview-all-teams':
        case 'eoc-reports':
        case 'eoc-reports-team':
        case 'eoc-schedules':
        case 'eoc-team-group-detail':
        case 'eoc-team-alerts':
        case 'eoc-team-alert-detail':
        case 'eoc-team-policies':
        case 'eoc-team-alert-issue-syncing':
        case 'eoc-team-alert-issue-syncing-create':
        case 'eoc-team-alert-issue-syncing-detail':
        case 'eoc-team-integrations':
        case 'eoc-team-integration-create':
        case 'eoc-team-integration-detail':
        case 'eoc-team-integration-list':
        case 'eoc-team-integration-log':
            path.push((0, $jhS4y.MENU_ID_OPS_OVERVIEW));
            break;
        default:
            break;
    }
    return path;
}
const $9b181cf5d70a46b3$export$7fc92455d5020e1 = {
    routes: $9b181cf5d70a46b3$var$routes,
    convert: $9b181cf5d70a46b3$var$convert,
    convertNew: $9b181cf5d70a46b3$var$convertNew
};

});

parcelRegister("2m3Yb", function(module, exports) {

$parcel$export(module.exports, "topLevelConverter", () => $c60c27b55fbcd9c5$export$a33f2d74a674bf8a);

var $jhS4y = parcelRequire("jhS4y");
const $c60c27b55fbcd9c5$var$routes = new Set([
    'your-work',
    'people-index'
]);
function $c60c27b55fbcd9c5$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $c60c27b55fbcd9c5$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $c60c27b55fbcd9c5$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $c60c27b55fbcd9c5$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $c60c27b55fbcd9c5$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'your-work':
            path.push((0, $jhS4y.MENU_ID_YOUR_WORK));
            break;
        case 'people-index':
            path.push((0, $jhS4y.MENU_ID_TEAMS));
            break;
        default:
    }
    return path;
}
const $c60c27b55fbcd9c5$export$a33f2d74a674bf8a = {
    routes: $c60c27b55fbcd9c5$var$routes,
    convert: $c60c27b55fbcd9c5$var$convert,
    convertNew: $c60c27b55fbcd9c5$var$convertNew
};

});

parcelRegister("3weqe", function(module, exports) {

$parcel$export(module.exports, "overviewsConverter", () => $b8a10fc0a37e731b$export$5469f6c6536ca9c5);

var $jhS4y = parcelRequire("jhS4y");
const $b8a10fc0a37e731b$var$routes = new Set([
    'classic-business-overview-calendar',
    'classic-business-overview-redirect',
    'classic-business-overview-summary',
    'classic-business-overview-timeline'
]);
function $b8a10fc0a37e731b$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_OVERVIEWS)
    ];
    return $b8a10fc0a37e731b$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $b8a10fc0a37e731b$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $jhS4y.MENU_ID_OVERVIEWS)
    ];
    return $b8a10fc0a37e731b$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $b8a10fc0a37e731b$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    routeName;
    {
        const { overviewId: overviewId } = match.params;
        overviewId && path.push((0, $jhS4y.ENTITY_ID).OVERVIEW(overviewId));
    }
    return path;
}
const $b8a10fc0a37e731b$export$5469f6c6536ca9c5 = {
    routes: $b8a10fc0a37e731b$var$routes,
    convert: $b8a10fc0a37e731b$var$convert,
    convertNew: $b8a10fc0a37e731b$var$convertNew
};

});

parcelRegister("c6hlO", function(module, exports) {

$parcel$export(module.exports, "plansConverter", () => $a783e1b6f52291a3$export$3bde637b58016d1);

var $jhS4y = parcelRequire("jhS4y");
const $a783e1b6f52291a3$var$routes = new Set([
    'plans-directory',
    'software-advanced-roadmaps',
    'software-advanced-roadmaps-getting-started-redirect',
    'software-advanced-roadmaps-setup',
    'software-plan-calendar',
    'software-plan-dependencies',
    'software-plan-increment',
    'software-plan-increments',
    'software-plan-releases',
    'software-plan-summary',
    'software-plan-teams',
    'software-plan-timeline',
    'trashed-plan-direct-link',
    'software-plan-upsell'
]);
function $a783e1b6f52291a3$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_PLANS)
    ];
    return $a783e1b6f52291a3$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $a783e1b6f52291a3$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $jhS4y.MENU_ID_PLANS)
    ];
    return $a783e1b6f52291a3$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $a783e1b6f52291a3$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    switch(routeName){
        case 'plans-directory':
        case 'software-advanced-roadmaps-getting-started-redirect':
            path.push((0, $jhS4y.MENU_ID_PLANS_VIEW_ALL));
            break;
        case 'trashed-plan-direct-link':
            break;
        default:
            {
                const { planId: planId } = match.params;
                planId && path.push((0, $jhS4y.ENTITY_ID).PLAN(planId));
            }
    }
    return path;
}
const $a783e1b6f52291a3$export$3bde637b58016d1 = {
    routes: $a783e1b6f52291a3$var$routes,
    convert: $a783e1b6f52291a3$var$convert,
    convertNew: $a783e1b6f52291a3$var$convertNew
};

});

parcelRegister("3lNyZ", function(module, exports) {

$parcel$export(module.exports, "projectsConverter", () => $6eaade1a69d23d1d$export$c41b724886e5872b);

var $4R6GH = parcelRequire("4R6GH");

var $jhS4y = parcelRequire("jhS4y");
const $6eaade1a69d23d1d$var$routes = new Set([
    'browse-project-redirect',
    'legacy-all-reports',
    'projects-directory',
    'issue-navigator',
    'issue-navigator-core',
    'project-components',
    'project-not-found',
    'project-versions',
    'software-version-detail',
    'software-version-detail-no-tab-path',
    'forge-spa-project',
    'forge-spa-project-servicedesk',
    'forge-spa-servicedesk-queue',
    'polaris-ideas',
    'polaris-onboarding',
    'opsgenie-schedule',
    'issue-navigator-classic',
    'project-pages',
    'rapidboard-backlog',
    'rapidboard-board',
    'rapidboard-report',
    'software-backlog',
    'software-boards',
    'software-calendar',
    'software-calendar-classic',
    'classic-software-proforma-issue-forms-direct',
    'software-code',
    'software-code-classic',
    'software-deployments',
    'software-deployments-classic',
    'software-form',
    'software-form-classic',
    'software-form-builder',
    'software-form-builder-classic',
    'software-form-submit',
    'software-form-submit-classic',
    'software-form-submit-embed',
    'software-form-submit-public',
    'software-form-submit-classic-embed',
    'software-form-submit-classic-public',
    'software-goals',
    'software-goals-classic',
    'software-incidents',
    'software-incidents-classic',
    'software-issue-navigator',
    'software-list',
    'software-list-classic',
    'software-periscope',
    'software-periscope-classic',
    'software-reports',
    'software-reports-boardless',
    'software-reports-burndown',
    'software-reports-burnup',
    'software-reports-control',
    'software-reports-cumulative',
    'software-reports-cycle-time',
    'software-reports-cycle-time-classic',
    'software-reports-deployment-frequency',
    'software-reports-deployment-frequency-classic',
    'software-reports-velocity',
    'software-reports-velocity-cmp',
    'software-security',
    'software-security-classic',
    'software-summary',
    'software-summary-embed',
    'software-summary-classic',
    'software-summary-classic-embed',
    'software-timeline',
    'software-timeline-classic',
    'software-view-not-found',
    'software-view-not-found-classic',
    'software-board-view-not-found',
    'software-board-view-not-found-classic',
    'knowledge-hub-all-articles',
    'kb-article-embed-editor',
    'knowledge-hub-article-in-category',
    'knowledge-hub-browse-all-articles',
    'knowledge-hub-browse-all-categories',
    'knowledge-hub-browse-view-article',
    'knowledge-hub-category',
    'knowledge-hub-category-page',
    'knowledge-hub-drafts',
    'knowledge-hub-suggested-topics',
    'knowledge-hub-landing',
    'knowledge-hub-search',
    'knowledge-hub-setup',
    'notification-logs',
    'servicedesk-atlassian-analytics',
    'servicedesk-boards',
    'servicedesk-calendar',
    'servicedesk-project-summary',
    'servicedesk-change-calendar',
    'servicedesk-connect-project',
    'servicedesk-customers-v2',
    'servicedesk-customer-details',
    'servicedesk-customer-service-escalations',
    'servicedesk-customer-service-products',
    'servicedesk-getting-started-page',
    'servicedesk-issue',
    'servicedesk-issues',
    'servicedesk-kb-requests-reports',
    'servicedesk-kb-requests-reports-time-scale-issue',
    'servicedesk-kb-requests-reports-time-scale',
    'servicedesk-oncall-schedule',
    'servicedesk-organizations',
    'servicedesk-organization-details',
    'servicedesk-organization_v2',
    'servicedesk-queues-practice-custom-board',
    'servicedesk-queues-practice-custom-calendar',
    'servicedesk-practice-custom-and-issue',
    'servicedesk-practice-edit',
    'servicedesk-practice-issue',
    'servicedesk-practice-landing',
    'servicedesk-practice-manage-view',
    'servicedesk-practice-new',
    'servicedesk-queues-addon',
    'servicedesk-queues-custom-board',
    'servicedesk-queues-custom-calendar',
    'servicedesk-queues-custom-view',
    'servicedesk-queues-custom-issue-detail',
    'servicedesk-queues-edit',
    'servicedesk-practice-views-config',
    'servicedesk-queues-views-config',
    'servicedesk-queues-issue',
    'servicedesk-queues-manage-view',
    'servicedesk-queues-new',
    'servicedesk-reports',
    'servicedesk-reports-custom',
    'servicedesk-reports-custom-create',
    'servicedesk-reports-custom-edit',
    'servicedesk-reports-custom-time-scale-issue',
    'servicedesk-reports-custom-time-scale',
    'servicedesk-reports-satisfaction',
    'servicedesk-reports-satisfaction-time-scale-issue',
    'servicedesk-reports-satisfaction-time-scale',
    'servicedesk-reports-type',
    'servicedesk-reports-workload',
    'servicedesk-services',
    'servicedesk-service-details',
    'classic-business-approvals',
    'classic-business-attachments',
    'classic-business-board',
    'classic-business-calendar',
    'classic-business-form',
    'classic-business-form-builder',
    'classic-business-form-submit',
    'classic-business-form-submit-public',
    'classic-business-list',
    'classic-business-shortcut',
    'classic-business-summary',
    'classic-business-timeline',
    'classic-business-view-not-found',
    'classic-business-redirect',
    'inbox',
    'inbox-classic'
]);
const $6eaade1a69d23d1d$var$routesWithArchivedIssuesRoute = new Set($6eaade1a69d23d1d$var$routes);
$6eaade1a69d23d1d$var$routesWithArchivedIssuesRoute.add('archived-issues-directory');
function $6eaade1a69d23d1d$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_PROJECTS)
    ];
    return $6eaade1a69d23d1d$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $6eaade1a69d23d1d$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $jhS4y.MENU_ID_PROJECTS)
    ];
    return $6eaade1a69d23d1d$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $6eaade1a69d23d1d$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'polaris-onboarding':
            break;
        case 'projects-directory':
            path.push((0, $jhS4y.MENU_ID_PROJECTS_VIEW_ALL));
            break;
        case 'forge-spa-project':
        case 'forge-spa-project-servicedesk':
        case 'forge-spa-servicedesk-queue':
            {
                const { projectKey: projectKey, appId: appId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                path.push((0, $jhS4y.MENU_ID_PROJECT_APPS));
                appId && path.push((0, $jhS4y.ENTITY_ID).APP(appId));
                break;
            }
        case 'knowledge-hub-all-articles':
        case 'kb-article-embed-editor':
        case 'knowledge-hub-article-in-category':
        case 'knowledge-hub-browse-all-articles':
        case 'knowledge-hub-browse-all-categories':
        case 'knowledge-hub-browse-view-article':
        case 'knowledge-hub-category':
        case 'knowledge-hub-category-page':
        case 'knowledge-hub-drafts':
        case 'knowledge-hub-suggested-topics':
        case 'knowledge-hub-landing':
        case 'knowledge-hub-search':
        case 'knowledge-hub-setup':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_KNOWLEDGE_BASE(projectKey));
                break;
            }
        case 'servicedesk-getting-started-page':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_JSM_GETTING_STARTED(projectKey));
                break;
            }
        case 'notification-logs':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_NOTIFICATION_LOGS(projectKey));
                break;
            }
        case 'servicedesk-project-summary':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_SUMMARY(projectKey));
                break;
            }
        case 'servicedesk-boards':
            {
                const { projectKey: projectKey, boardId: boardId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_VIEWS(projectKey));
                boardId && path.push((0, $jhS4y.ENTITY_ID).BOARD(boardId));
                break;
            }
        case 'servicedesk-calendar':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_VIEWS(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_CALENDAR(projectKey));
                break;
            }
        case 'servicedesk-change-calendar':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_CHANGE_CALENDAR(projectKey));
                break;
            }
        case 'servicedesk-organizations':
        case 'servicedesk-organization-details':
        case 'servicedesk-organization_v2':
        case 'servicedesk-customers-v2':
        case 'servicedesk-customer-details':
        case 'servicedesk-customer-service-products':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_DIRECTORY(projectKey));
                break;
            }
        case 'servicedesk-customer-service-escalations':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_ESCALATIONS(projectKey));
                break;
            }
        case 'servicedesk-kb-requests-reports':
        case 'servicedesk-kb-requests-reports-time-scale-issue':
        case 'servicedesk-kb-requests-reports-time-scale':
        case 'servicedesk-reports':
        case 'servicedesk-reports-custom':
        case 'servicedesk-reports-custom-create':
        case 'servicedesk-reports-custom-edit':
        case 'servicedesk-reports-custom-time-scale-issue':
        case 'servicedesk-reports-custom-time-scale':
        case 'servicedesk-reports-satisfaction':
        case 'servicedesk-reports-satisfaction-time-scale-issue':
        case 'servicedesk-reports-satisfaction-time-scale':
        case 'servicedesk-reports-type':
        case 'servicedesk-reports-workload':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_REPORTS(projectKey));
                break;
            }
        case 'servicedesk-oncall-schedule':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_ONCALL_SCHEDULE(projectKey));
                break;
            }
        case 'servicedesk-issues':
            {
                const { projectKey: projectKey } = match.params;
                const filterId = query.filter || query.filterId;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                if (projectKey && filterId) {
                    path.push((0, $jhS4y.ENTITY_ID).PROJECT_FILTERS(projectKey));
                    path.push((0, $jhS4y.ENTITY_ID).PROJECT_ISSUE_FILTER(projectKey, filterId));
                }
                break;
            }
        case 'servicedesk-queues-practice-custom-board':
        case 'servicedesk-queues-practice-custom-calendar':
        case 'servicedesk-practice-custom-and-issue':
        case 'servicedesk-practice-edit':
        case 'servicedesk-practice-issue':
        case 'servicedesk-practice-landing':
        case 'servicedesk-practice-manage-view':
        case 'servicedesk-practice-views-config':
        case 'servicedesk-practice-new':
            {
                const { projectKey: projectKey, practiceType: practiceType, queueId: queueId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && practiceType && path.push((0, $jhS4y.ENTITY_ID).PROJECT_PRACTICE_QUEUE(projectKey, practiceType));
                queueId && path.push((0, $jhS4y.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 'servicedesk-queues-addon':
        case 'servicedesk-queues-custom-board':
        case 'servicedesk-queues-custom-calendar':
        case 'servicedesk-queues-custom-view':
        case 'servicedesk-queues-edit':
        case 'servicedesk-queues-issue':
        case 'servicedesk-queues-manage-view':
        case 'servicedesk-queues-views-config':
        case 'servicedesk-queues-new':
            {
                const { projectKey: projectKey, queueId: queueId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_QUEUES(projectKey));
                queueId && path.push((0, $jhS4y.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 'servicedesk-queues-custom-issue-detail':
            {
                const { projectKey: projectKey, queueId: queueId, issueKey: issueKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_QUEUES(projectKey));
                queueId && path.push((0, $jhS4y.ENTITY_ID).QUEUE(queueId));
                issueKey && path.push((0, $jhS4y.ENTITY_ID).ISSUE(issueKey));
                break;
            }
        case 'servicedesk-services':
        case 'servicedesk-service-details':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT_SERVICES(projectKey));
                break;
            }
        default:
            {
                const { projectKey: projectKey, boardId: boardId, formId: formId } = match.params;
                projectKey && path.push((0, $jhS4y.ENTITY_ID).PROJECT(projectKey));
                boardId && path.push((0, $jhS4y.ENTITY_ID).BOARD(boardId));
                formId && path.push((0, $jhS4y.ENTITY_ID).FORM(formId));
            }
    }
    if ((0, $4R6GH.fg)('fix-operations-menu-item-deselected-bug')) {
        const { projectKey: projectKey } = match.params;
        if ((routeName === 'servicedesk-change-calendar' || routeName === 'servicedesk-services' || routeName === 'servicedesk-service-details') && projectKey) path.push((0, $jhS4y.ENTITY_ID).PROJECT_OPERATIONS(projectKey));
    }
    return path;
}
const $6eaade1a69d23d1d$export$c41b724886e5872b = {
    get routes () {
        return (0, $4R6GH.fg)('ken_1984_archive_route_support_sidebar') ? $6eaade1a69d23d1d$var$routesWithArchivedIssuesRoute : $6eaade1a69d23d1d$var$routes;
    },
    convert: $6eaade1a69d23d1d$var$convert,
    convertNew: $6eaade1a69d23d1d$var$convertNew
};

});

parcelRegister("8bXrC", function(module, exports) {

$parcel$export(module.exports, "roadmapsConverter", () => $8c39d6aa787bb969$export$5761942b1e0c2dd0);

var $jhS4y = parcelRequire("jhS4y");
const $8c39d6aa787bb969$var$routes = new Set([
    'polaris-collections'
]);
function $8c39d6aa787bb969$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $jhS4y.MENU_ID_ROADMAPS)
    ];
    return $8c39d6aa787bb969$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $8c39d6aa787bb969$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $jhS4y.MENU_ID_ROADMAPS)
    ];
    return $8c39d6aa787bb969$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $8c39d6aa787bb969$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    switch(routeName){
        case 'polaris-collections':
            {
                const collectionId = match.params.collectionUUID;
                if (collectionId) path.push((0, $jhS4y.ENTITY_ID).ROADMAP(collectionId));
                else path.push((0, $jhS4y.MENU_ID_ROADMAPS_VIEW_ALL));
                break;
            }
        default:
    }
    return path;
}
const $8c39d6aa787bb969$export$5761942b1e0c2dd0 = {
    routes: $8c39d6aa787bb969$var$routes,
    convert: $8c39d6aa787bb969$var$convert,
    convertNew: $8c39d6aa787bb969$var$convertNew
};

});

parcelRegister("eReVn", function(module, exports) {

$parcel$export(module.exports, "serviceManagementProjectSettingsConverter", () => $59806d8088c642c3$export$dd307ede503fe0e);

var $7HDop = parcelRequire("7HDop");

var $9ujoJ = parcelRequire("9ujoJ");

var $buwAo = parcelRequire("buwAo");

var $ji59e = parcelRequire("ji59e");

var $cAtSX = parcelRequire("cAtSX");

var $g49yz = parcelRequire("g49yz");

var $aBfqj = parcelRequire("aBfqj");

var $9wUes = parcelRequire("9wUes");

var $8pE1n = parcelRequire("8pE1n");

var $cfj3a = parcelRequire("cfj3a");

var $d9ukL = parcelRequire("d9ukL");

var $2I1zE = parcelRequire("2I1zE");

var $4P4Lq = parcelRequire("4P4Lq");

var $fdCkK = parcelRequire("fdCkK");

var $i62iX = parcelRequire("i62iX");

var $eObGp = parcelRequire("eObGp");

var $6z8e6 = parcelRequire("6z8e6");

var $coidL = parcelRequire("coidL");

var $jHXos = parcelRequire("jHXos");

var $h6YNW = parcelRequire("h6YNW");

var $6EgCy = parcelRequire("6EgCy");

var $2CYtL = parcelRequire("2CYtL");

var $bveQD = parcelRequire("bveQD");

var $59iBR = parcelRequire("59iBR");

var $b7dWt = parcelRequire("b7dWt");

var $8qmAq = parcelRequire("8qmAq");

var $fQ161 = parcelRequire("fQ161");

var $9sAYT = parcelRequire("9sAYT");

var $jJkuR = parcelRequire("jJkuR");

var $kuaoc = parcelRequire("kuaoc");

var $ieCBx = parcelRequire("ieCBx");

var $1XuFh = parcelRequire("1XuFh");

var $3BQ4q = parcelRequire("3BQ4q");

var $2m3cT = parcelRequire("2m3cT");

var $hewRX = parcelRequire("hewRX");

var $cmEH1 = parcelRequire("cmEH1");

var $9xhY2 = parcelRequire("9xhY2");

var $043ka = parcelRequire("043ka");

var $jhS4y = parcelRequire("jhS4y");
const $59806d8088c642c3$var$routes = new Set([
    'legacy-project-settings-fields',
    'legacy-project-settings-issue-security',
    'legacy-project-settings-issue-types',
    'legacy-project-settings-notifications',
    'legacy-project-settings-people',
    'legacy-project-settings-permissions',
    'legacy-project-settings-screens',
    'legacy-project-settings-workflows',
    'legacy-project-settings-workflows-associate',
    'project-settings-automation',
    'servicedesk-sla-settings',
    (0, $ji59e.projectSettingsLegacyAutomationRoute).name,
    (0, $cAtSX.projectSettingsServicedeskAccessRoute).name,
    (0, $8pE1n.projectSettingsServicedeskChannelsPermissionsNextGenRoute).name,
    (0, $fdCkK.projectSettingsServicedeskCustomerPermissionsRoute).name,
    (0, $6z8e6.projectSettingsServicedeskFeedbackRoute).name,
    (0, $coidL.projectSettingsServicedeskFieldsRoute).name,
    (0, $59iBR.projectSettingsServicedeskProformaProjectFormsRoute).name,
    (0, $b7dWt.projectSettingsServicedeskRequestTypesWorkCategoryRoute).name,
    (0, $2I1zE.projectSettingsServicedeskChatRoute).name,
    (0, $i62iX.projectSettingsServicedeskEmailRoute).name,
    (0, $eObGp.projectSettingsServicedeskExternalLinksRoute).name,
    (0, $bveQD.projectSettingsServicedeskPortalSettingsRoute).name,
    (0, $8qmAq.projectSettingsServicedeskWidgetRoute).name,
    (0, $aBfqj.projectSettingsServicedeskChangeManagementRoute).name,
    (0, $jHXos.projectSettingsServicedeskIncidentManagementRoute).name,
    (0, $4P4Lq.projectSettingsServicedeskClassicAppsRoute).name,
    (0, $fQ161.projectSettingsVirtualAgentSettingsRoute).name,
    (0, $9wUes.projectSettingsServicedeskChannelsChatRoute).name,
    (0, $d9ukL.projectSettingsServicedeskChannelsWidgetRoute).name,
    (0, $9sAYT.virtualAgentConversationsRoute).name,
    (0, $jJkuR.virtualAgentIntentsRoute).name,
    (0, $kuaoc.virtualAgentSettingsRoute).name,
    (0, $ieCBx.virtualAgentStandardFlowsRoute).name,
    (0, $9ujoJ.projectSettingsServicedeskNotificationsEmailRoute).name,
    (0, $buwAo.projectSettingsServicedeskNotificationsNotificationEmailRoute).name,
    (0, $2CYtL.projectSettingsServicedeskNotificationsInternalNotificationsRoute).name,
    (0, $g49yz.projectSettingsServicedeskAppsFieldsRoute).name,
    (0, $1XuFh.projectSettingsServicedeskCustomerNotificationsRoute).name,
    (0, $3BQ4q.projectSettingsServicedeskNotificationsCustomerNotificationsRoute).name,
    (0, $2m3cT.projectSettingsServicedeskKbRoute).name,
    (0, $cmEH1.projectSettingsServicedeskTicketTypesConfigRoute).name,
    (0, $9xhY2.projectSettingsServicedeskUnassignedTicketTypesConfigRoute).name,
    (0, $043ka.servicedeskWorkflowConfigRoute).name,
    (0, $6EgCy.projectSettingsServicedeskIssuetypesRoute).name,
    (0, $cfj3a.projectSettingsServicedeskChannelsPortalRoute).name,
    (0, $7HDop.projectSettingsServicedeskAutomationRoute).name,
    (0, $hewRX.servicedeskSlaSettingsRoute).name,
    (0, $h6YNW.projectSettingsServicedeskInternalNotificationsNextGenRoute).name
]);
function $59806d8088c642c3$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $59806d8088c642c3$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $59806d8088c642c3$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $59806d8088c642c3$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $59806d8088c642c3$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        // Access Menu
        case 'legacy-project-settings-people':
        case (0, $cAtSX.projectSettingsServicedeskAccessRoute).name:
        case (0, $fdCkK.projectSettingsServicedeskCustomerPermissionsRoute).name:
        case (0, $8pE1n.projectSettingsServicedeskChannelsPermissionsNextGenRoute).name:
        case 'legacy-project-settings-permissions':
        case 'legacy-project-settings-issue-security':
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_ACCESS));
            break;
        // Request Management -> Request types menu
        case (0, $b7dWt.projectSettingsServicedeskRequestTypesWorkCategoryRoute).name:
        case (0, $9xhY2.projectSettingsServicedeskUnassignedTicketTypesConfigRoute).name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT), (0, $jhS4y.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES));
            break;
        // Request Management
        case (0, $cmEH1.projectSettingsServicedeskTicketTypesConfigRoute).name:
        case (0, $59iBR.projectSettingsServicedeskProformaProjectFormsRoute).name:
        case 'legacy-project-settings-workflows':
        case (0, $043ka.servicedeskWorkflowConfigRoute).name:
        case 'legacy-project-settings-workflows-associate':
        case 'servicedesk-sla-settings':
        case (0, $hewRX.servicedeskSlaSettingsRoute).name:
        case (0, $6z8e6.projectSettingsServicedeskFeedbackRoute).name:
        case 'legacy-project-settings-issue-types':
        case (0, $6EgCy.projectSettingsServicedeskIssuetypesRoute).name:
        case 'legacy-project-settings-fields':
        case (0, $coidL.projectSettingsServicedeskFieldsRoute).name:
        case 'legacy-project-settings-screens':
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT));
            break;
        // Automation
        case 'project-settings-automation':
        case (0, $ji59e.projectSettingsLegacyAutomationRoute).name:
        case (0, $7HDop.projectSettingsServicedeskAutomationRoute).name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_AUTOMATION));
            break;
        // Channels and self-service
        case (0, $bveQD.projectSettingsServicedeskPortalSettingsRoute).name:
        case (0, $cfj3a.projectSettingsServicedeskChannelsPortalRoute).name:
        case (0, $i62iX.projectSettingsServicedeskEmailRoute).name:
        case (0, $2I1zE.projectSettingsServicedeskChatRoute).name:
        case (0, $8qmAq.projectSettingsServicedeskWidgetRoute).name:
        case (0, $2m3cT.projectSettingsServicedeskKbRoute).name:
        case (0, $eObGp.projectSettingsServicedeskExternalLinksRoute).name:
        case (0, $9wUes.projectSettingsServicedeskChannelsChatRoute).name:
        case (0, $d9ukL.projectSettingsServicedeskChannelsWidgetRoute).name:
        case (0, $fQ161.projectSettingsVirtualAgentSettingsRoute).name:
        case (0, $jJkuR.virtualAgentIntentsRoute).name:
        case (0, $ieCBx.virtualAgentStandardFlowsRoute).name:
        case (0, $9sAYT.virtualAgentConversationsRoute).name:
        case (0, $kuaoc.virtualAgentSettingsRoute).name:
            // case issueCollectors.name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE));
            break;
        // Operations
        case (0, $aBfqj.projectSettingsServicedeskChangeManagementRoute).name:
        case (0, $jHXos.projectSettingsServicedeskIncidentManagementRoute).name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_OPERATIONS));
            break;
        // Notifications
        case 'legacy-project-settings-notifications':
        case (0, $1XuFh.projectSettingsServicedeskCustomerNotificationsRoute).name:
        case (0, $2CYtL.projectSettingsServicedeskNotificationsInternalNotificationsRoute).name:
        case (0, $3BQ4q.projectSettingsServicedeskNotificationsCustomerNotificationsRoute).name:
        case (0, $9ujoJ.projectSettingsServicedeskNotificationsEmailRoute).name:
        case (0, $buwAo.projectSettingsServicedeskNotificationsNotificationEmailRoute).name:
        case (0, $h6YNW.projectSettingsServicedeskInternalNotificationsNextGenRoute).name:
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_NOTIFICATIONS));
            break;
        // Apps
        case (0, $4P4Lq.projectSettingsServicedeskClassicAppsRoute).name:
        case (0, $g49yz.projectSettingsServicedeskAppsFieldsRoute).name:
            // ADD rest of the apps here
            path.push((0, $jhS4y.MENU_ID_SD_SETTINGS_APPS));
            break;
        default:
            break;
    }
    return path;
}
const $59806d8088c642c3$export$dd307ede503fe0e = {
    routes: $59806d8088c642c3$var$routes,
    convert: $59806d8088c642c3$var$convert,
    convertNew: $59806d8088c642c3$var$convertNew
};

});
parcelRegister("7HDop", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationRoute", () => $a850596cfe5a4de7$export$1a2228d5e07202a0);
const $a850596cfe5a4de7$export$1a2228d5e07202a0 = {
    name: 'project-settings-automation',
    path: '/jira/servicedesk/projects/:projectKey/settings/automate'
};

});

parcelRegister("9ujoJ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRoute", () => $0bae5d3040b6efcd$export$1f37a1aff4f594af);
const $0bae5d3040b6efcd$export$1f37a1aff4f594af = {
    name: 'project-settings-servicedesk-notification-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/notification-email',
    exact: true
};

});

parcelRegister("buwAo", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRoute", () => $a41537dc6d61dc3d$export$40539cb16771014e);
const $a41537dc6d61dc3d$export$40539cb16771014e = {
    name: 'project-settings-servicedesk-notifications-notification-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("ji59e", function(module, exports) {

$parcel$export(module.exports, "projectSettingsLegacyAutomationRoute", () => $8a393a176348cc6a$export$5f0797185fc4e6fe);
const $8a393a176348cc6a$export$5f0797185fc4e6fe = {
    name: 'project-settings-servicedesk-automation',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation',
    exact: true
};

});

parcelRegister("cAtSX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAccessRoute", () => $6b0529072d4abe8e$export$6473a81f1ee460ef);
const $6b0529072d4abe8e$export$6473a81f1ee460ef = {
    name: 'project-settings-servicedesk-access',
    path: '/jira/servicedesk/projects/:projectKey/settings/access',
    exact: true
};

});

parcelRegister("g49yz", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAppsFieldsRoute", () => $3fe31df45b0dec62$export$bb46672b3fb14eec);
const $3fe31df45b0dec62$export$bb46672b3fb14eec = {
    name: 'project-settings-servicedesk-apps-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("aBfqj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChangeManagementRoute", () => $f0657cd63f2eea62$export$1444ee3eb63a2ffc);
const $f0657cd63f2eea62$export$1444ee3eb63a2ffc = {
    name: 'project-settings-servicedesk-change-management',
    path: '/jira/servicedesk/projects/:projectKey/settings/change-management',
    exact: true
};

});

parcelRegister("9wUes", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsChatRoute", () => $6368b0346b5f497d$export$be5ad475040cd044);
const $6368b0346b5f497d$export$be5ad475040cd044 = {
    name: 'project-settings-servicedesk-channels-chat',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/chat',
    exact: true
};

});

parcelRegister("8pE1n", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsPermissionsNextGenRoute", () => $7daacba204902bb9$export$5fb39a9d3820886c);
const $7daacba204902bb9$export$5fb39a9d3820886c = {
    name: 'project-settings-servicedesk-channels-permissions-next-gen',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/customer-permissions',
    exact: true
};

});

parcelRegister("cfj3a", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsPortalRoute", () => $6736aa15bea6eefc$export$8f4234e4e79e03);
const $6736aa15bea6eefc$export$8f4234e4e79e03 = {
    name: 'project-settings-servicedesk-channels-portal',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/portal-settings',
    exact: true
};

});

parcelRegister("d9ukL", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsWidgetRoute", () => $1c3cc396f5e3294d$export$c66db54872d3b51c);
const $1c3cc396f5e3294d$export$c66db54872d3b51c = {
    name: 'project-settings-servicedesk-channels-widget',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/widget',
    exact: true
};

});

parcelRegister("2I1zE", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChatRoute", () => $2f07a87a169fe062$export$b22ac188582d1dbd);
const $2f07a87a169fe062$export$b22ac188582d1dbd = {
    name: 'project-settings-servicedesk-chat',
    path: '/jira/servicedesk/projects/:projectKey/settings/chat',
    exact: true
};

});

parcelRegister("4P4Lq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskClassicAppsRoute", () => $e517d51ddd605d2d$export$2b65324bb87228c5);
const $e517d51ddd605d2d$export$2b65324bb87228c5 = {
    name: 'project-settings-servicedesk-classic-apps',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps',
    exact: true
};

});

parcelRegister("fdCkK", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskCustomerPermissionsRoute", () => $b0729515e1c8c770$export$d8ed4a1eb0c01b5a);
const $b0729515e1c8c770$export$d8ed4a1eb0c01b5a = {
    name: 'project-settings-servicedesk-customer-permissions',
    path: '/jira/servicedesk/projects/:projectKey/settings/customer-permissions',
    exact: true
};

});

parcelRegister("i62iX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskEmailRoute", () => $6c48c7782385d153$export$d7d111417bfcd900);
const $6c48c7782385d153$export$d7d111417bfcd900 = {
    name: 'project-settings-servicedesk-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/email',
    exact: true
};

});

parcelRegister("eObGp", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskExternalLinksRoute", () => $9ab5fd15e07cb29b$export$2ec1a0d49a1f6ac2);
const $9ab5fd15e07cb29b$export$2ec1a0d49a1f6ac2 = {
    name: 'project-settings-servicedesk-external-links',
    path: '/jira/servicedesk/projects/:projectKey/settings/external-links',
    exact: true
};

});

parcelRegister("6z8e6", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskFeedbackRoute", () => $a459da1dd0fd4437$export$f21485e31d7839aa);
const $a459da1dd0fd4437$export$f21485e31d7839aa = {
    name: 'project-settings-servicedesk-feedback',
    path: '/jira/servicedesk/projects/:projectKey/settings/feedback-settings'
};

});

parcelRegister("coidL", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskFieldsRoute", () => $60fa813ddf92723e$export$44f665a50373c681);
const $60fa813ddf92723e$export$44f665a50373c681 = {
    name: 'project-settings-servicedesk-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("jHXos", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIncidentManagementRoute", () => $5158d983285fb183$export$f91bd0bb0d4783ff);
const $5158d983285fb183$export$f91bd0bb0d4783ff = {
    name: 'project-settings-servicedesk-incident-management',
    path: '/jira/servicedesk/projects/:projectKey/settings/incident-management',
    exact: true
};

});

parcelRegister("h6YNW", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskInternalNotificationsNextGenRoute", () => $35c040ff370a690c$export$5db62792327950b4);
const $35c040ff370a690c$export$5db62792327950b4 = {
    name: 'project-settings-servicedesk-internal-notifications-nextGen',
    path: '/jira/servicedesk/projects/:projectKey/settings/internal-notifications'
};

});

parcelRegister("6EgCy", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesRoute", () => $62f1cfaa37e848ed$export$2ffcb2e92bb4950b);
const $62f1cfaa37e848ed$export$2ffcb2e92bb4950b = {
    name: 'project-settings-servicedesk-issuetypes',
    path: '/jira/servicedesk/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});

parcelRegister("2CYtL", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsInternalNotificationsRoute", () => $944b1aaf3a971594$export$5108e41f558ecf03);
const $944b1aaf3a971594$export$5108e41f558ecf03 = {
    name: 'project-settings-servicedesk-notifications-internal-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/internal-notifications'
};

});

parcelRegister("bveQD", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskPortalSettingsRoute", () => $110f0f2897157711$export$7593a7e4a6fc0aaf);
const $110f0f2897157711$export$7593a7e4a6fc0aaf = {
    name: 'project-settings-servicedesk-portal-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/portal-settings/:subPath(portal-groups)?',
    exact: true
};

});

parcelRegister("59iBR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskProformaProjectFormsRoute", () => $7ab6606893b01740$export$ee87e5f9754e3600);
const $7ab6606893b01740$export$ee87e5f9754e3600 = {
    name: 'project-settings-servicedesk-proforma-project-forms',
    path: '/jira/servicedesk/projects/:projectKey/settings/forms',
    exact: true
};

});

parcelRegister("b7dWt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskRequestTypesWorkCategoryRoute", () => $5256905c61d3ff71$export$a0d1982e8b6c6462);
const $5256905c61d3ff71$export$a0d1982e8b6c6462 = {
    name: 'project-settings-servicedesk-request-types-work-category',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice',
    exact: true
};

});

parcelRegister("8qmAq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskWidgetRoute", () => $bf2d8be8b98d574c$export$ac674ffd39608325);
const $bf2d8be8b98d574c$export$ac674ffd39608325 = {
    name: 'project-settings-servicedesk-widget',
    path: '/jira/servicedesk/projects/:projectKey/settings/widget',
    exact: true
};

});

parcelRegister("fQ161", function(module, exports) {

$parcel$export(module.exports, "projectSettingsVirtualAgentSettingsRoute", () => $6114f059a1e6649c$export$22dd8d5d0c04aa51);
const $6114f059a1e6649c$export$22dd8d5d0c04aa51 = {
    name: 'project-settings-servicedesk-virtual-agent',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent',
    exact: true
};

});

parcelRegister("9sAYT", function(module, exports) {

$parcel$export(module.exports, "virtualAgentConversationsRoute", () => $411142b46ae04f14$export$837f003bb6f40f9);
const $411142b46ae04f14$export$837f003bb6f40f9 = {
    name: 'project-settings-servicedesk-virtual-agent-conversations',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/conversations',
    exact: true
};

});

parcelRegister("jJkuR", function(module, exports) {

$parcel$export(module.exports, "virtualAgentIntentsRoute", () => $0338de7d8107d11d$export$1e70273fc2a407f5);
const $0338de7d8107d11d$export$1e70273fc2a407f5 = {
    name: 'project-settings-servicedesk-virtual-agent-intents',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents',
    exact: true
};

});

parcelRegister("kuaoc", function(module, exports) {

$parcel$export(module.exports, "virtualAgentSettingsRoute", () => $bc551cda135ca5dc$export$80422a49e17dfd6b);
const $bc551cda135ca5dc$export$80422a49e17dfd6b = {
    name: 'project-settings-servicedesk-virtual-agent-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/settings',
    exact: true
};

});

parcelRegister("ieCBx", function(module, exports) {

$parcel$export(module.exports, "virtualAgentStandardFlowsRoute", () => $b2e651b968a46995$export$f45c942ecfcc5682);
const $b2e651b968a46995$export$f45c942ecfcc5682 = {
    name: 'project-settings-servicedesk-virtual-agent-standard-flows',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows',
    exact: true
};

});

parcelRegister("1XuFh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskCustomerNotificationsRoute", () => $312a1d56c159c7b3$export$176d388c5b23978e);
const $312a1d56c159c7b3$export$176d388c5b23978e = {
    name: 'project-settings-servicedesk-customer-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/customer-notifications'
};

});

parcelRegister("3BQ4q", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsCustomerNotificationsRoute", () => $767b3fa8d0e3f22f$export$6ce57d409e1934f2);
const $767b3fa8d0e3f22f$export$6ce57d409e1934f2 = {
    name: 'project-settings-servicedesk-notifications-customer-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/customer-notifications'
};

});

parcelRegister("2m3cT", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskKbRoute", () => $4098af05e7cf1529$export$725fadff9ae82302);
const $4098af05e7cf1529$export$725fadff9ae82302 = {
    name: 'project-settings-servicedesk-kb',
    path: '/jira/servicedesk/projects/:projectKey/settings/confluence-kb',
    exact: true
};

});

parcelRegister("hewRX", function(module, exports) {

$parcel$export(module.exports, "servicedeskSlaSettingsRoute", () => $e50829694a27cbc2$export$bfbf66468910573e);
const $e50829694a27cbc2$export$bfbf66468910573e = {
    name: 'servicedesk-sla-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/sla/(custom|new)?/:id?/(edit)?'
};

});

parcelRegister("cmEH1", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskTicketTypesConfigRoute", () => $f379cc48bbcca18e$export$31f95ad4356ce017);
const $f379cc48bbcca18e$export$31f95ad4356ce017 = {
    exact: true,
    name: 'project-settings-servicedesk-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types'
};

});

parcelRegister("9xhY2", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypesConfigRoute", () => $5bf710cc844476bb$export$8c897f53ff36fa6b);
const $5bf710cc844476bb$export$8c897f53ff36fa6b = {
    exact: true,
    name: 'project-settings-servicedesk-unassigned-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/unassigned'
};

});

parcelRegister("043ka", function(module, exports) {

$parcel$export(module.exports, "servicedeskWorkflowConfigRoute", () => $e90f1285b1062fcf$export$ecc771c0ee86ccb8);
const $e90f1285b1062fcf$export$ecc771c0ee86ccb8 = {
    name: 'project-settings-servicedesk-workflow-scheme-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/workflows',
    exact: true
};

});


parcelRegister("djX45", function(module, exports) {

$parcel$export(module.exports, "customerServiceConverter", () => $5d3cd05ec71a5c6d$export$8e632ccd3e33c9f1);

var $jhS4y = parcelRequire("jhS4y");
const $5d3cd05ec71a5c6d$var$routes = new Set([
    'customer-service-helpcenter'
]);
function $5d3cd05ec71a5c6d$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $5d3cd05ec71a5c6d$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $5d3cd05ec71a5c6d$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $5d3cd05ec71a5c6d$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $5d3cd05ec71a5c6d$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'customer-service-helpcenter':
            path.push((0, $jhS4y.MENU_ID_CUSTOMER_SERVICE));
            break;
        default:
    }
    return path;
}
const $5d3cd05ec71a5c6d$export$8e632ccd3e33c9f1 = {
    routes: $5d3cd05ec71a5c6d$var$routes,
    convert: $5d3cd05ec71a5c6d$var$convert,
    convertNew: $5d3cd05ec71a5c6d$var$convertNew
};

});



parcelRegister("fMcVX", function(module, exports) {

$parcel$export(module.exports, "isSelectedPath", () => $ad785f9726254880$export$cdcd6885320eec31);

var $lhMtU = parcelRequire("lhMtU");
function $ad785f9726254880$export$cdcd6885320eec31(path, ...args) {
    const next = (menuId)=>{
        return (0, $lhMtU.isMenuIdList)(menuId) ? (0, $lhMtU.toMenuIdList)(menuId).some((id)=>path.includes(id)) : path.includes(menuId);
    };
    if (args.length === 0) return next;
    return next(args[0]);
}

});
parcelRegister("lhMtU", function(module, exports) {

$parcel$export(module.exports, "toMenuIdFromMenuIdList", () => $dc9d941dfadd4b5a$export$253323efd0c41e72);
$parcel$export(module.exports, "isMenuIdList", () => $dc9d941dfadd4b5a$export$abdb8aa7ce9ed1ed);
$parcel$export(module.exports, "toMenuIdList", () => $dc9d941dfadd4b5a$export$d8e017f58178e379);
const $dc9d941dfadd4b5a$var$MENU_ID_DELIM = '   '; // Three spaces
function $dc9d941dfadd4b5a$export$253323efd0c41e72(menuIds) {
    return menuIds.join($dc9d941dfadd4b5a$var$MENU_ID_DELIM);
}
function $dc9d941dfadd4b5a$export$abdb8aa7ce9ed1ed(maybeMenuIdList) {
    return maybeMenuIdList.indexOf($dc9d941dfadd4b5a$var$MENU_ID_DELIM) !== -1;
}
function $dc9d941dfadd4b5a$export$d8e017f58178e379(menuIdList) {
    return menuIdList.split($dc9d941dfadd4b5a$var$MENU_ID_DELIM);
}

});


parcelRegister("ao2h1", function(module, exports) {

$parcel$export(module.exports, "RELAY_RESOURCE_TYPE", () => $5f6ac21695ec30bb$export$c6c8c12c0f1d8e54);
$parcel$export(module.exports, "createRelayResource", () => $5f6ac21695ec30bb$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $5f6ac21695ec30bb$export$42ca7b248c7aaee);

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $x9xyg = parcelRequire("x9xyg");

var $5yJb9 = parcelRequire("5yJb9");

var $5a0Nh = parcelRequire("5a0Nh");

var $kipqU = parcelRequire("kipqU");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $1u51R = parcelRequire("1u51R");
const $5f6ac21695ec30bb$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $5f6ac21695ec30bb$var$getData = ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
    const measureName = `relay_resource_get_data:${type}`;
    const startMark = `relay_resource_get_data:${type}:start`;
    const endMark = `relay_resource_get_data:${type}:end`;
    (0, $x9xyg.setMark)(startMark);
    const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
    // loadQuery returns not a Promise, but Observable.
    // Resource waits until query Observable is completed and returns a queryReference
    // later queryReference could be used by usePreloadedQuery
    const queryReference = (0, $x9xyg.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $8Uumt.loadQuery)((0, $5yJb9.default)(), parameters, variables || {}, options));
    if (false && queryReference.id != null) {
        const promise = (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        if (promise) return promise.then(()=>{
            (0, $x9xyg.setMark)(endMark);
            (0, $x9xyg.setMeasure)(measureName, startMark, endMark);
            /**
				 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
				 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
				 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
				 * as well as subsequent fetches made by route transitions between spa-apps.
				 */ if (captureErrors) (0, $5a0Nh.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $1u51R.startCapturingTraceIds)(queryReference.name);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return queryReference;
        });
    }
    if (queryReference.id != null) (0, $kipqU.QueryPromisesMap).get(queryReference.id)?.then(()=>{
        (0, $x9xyg.setMark)(endMark);
        (0, $x9xyg.setMeasure)(measureName, startMark, endMark);
    });
    /**
	 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
	 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
	 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
	 * as well as subsequent fetches made by route transitions between spa-apps.
	 */ if (captureErrors) (0, $5a0Nh.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
    if (captureTraceIds) (0, $1u51R.startCapturingTraceIds)(queryReference.name);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return queryReference;
};
const $5f6ac21695ec30bb$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, $2M1hQ.createResource)({
        type: `${$5f6ac21695ec30bb$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, customContext)=>{
            const { parameters: preloadableRequest, variables: variables } = getQuery(routerContext, customContext);
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            // sources: https://github.com/facebook/relay/blob/4b78c7dd27b286f9ee8f5b993ccb160163956999/packages/react-relay/relay-hooks/loadQuery.js#L273
            // @ts-expect-error - TS2339 - Property 'kind' does not exist on type 'GraphQLTaggedNode | PreloadableConcreteRequest<TQuery>'.
            if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                const preloadableConcreteRequest = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                preloadableRequest;
                ({ params: params } = preloadableConcreteRequest);
                ({ id: queryId } = params);
            } else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $eiowN.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: (routerContext, customContext)=>{
            return $5f6ac21695ec30bb$var$getData({
                routerContext: routerContext,
                customContext: customContext,
                type: type,
                getQuery: getQuery,
                captureErrors: captureErrors,
                captureTraceIds: captureTraceIds
            });
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly
    });
const $5f6ac21695ec30bb$export$1cc887c62079ea32 = $5f6ac21695ec30bb$var$createRelayResourceImpl;
const $5f6ac21695ec30bb$export$bbe949b85c06f763 = $5f6ac21695ec30bb$var$createRelayResourceImpl;
const $5f6ac21695ec30bb$export$42ca7b248c7aaee = (resource, options)=>{
    const { data: queryReference, loading: loading, promise: promise } = (0, $2YP9W.useResource)(resource);
    if (options?.suspendWhenLoading && loading) throw promise;
    return {
        queryReference: queryReference
    };
};

});

parcelRegister("2OeZv", function(module, exports) {

$parcel$export(module.exports, "default", () => $70949048397986dd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<24a7c5b8251bbed72b914ab17e954137>>
 * @relayHash 4c4a7c205ede4584fa49a36480caed71
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d5d6d42738d65c8ba647c421043a676f0276ebd5e724a2f75e455de401a89d3

var $apPdj = parcelRequire("apPdj");

var $bozkj = parcelRequire("bozkj");

var $57dih = parcelRequire("57dih");

var $kXP4b = parcelRequire("kXP4b");

var $95Z36 = parcelRequire("95Z36");
const $70949048397986dd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isAppsExpanded"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isFiltersExpanded"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOperationsExpanded"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOverviewsExpanded"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPlansExpanded"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isProjectsExpanded"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v11 = [
        v10 /*: any*/ 
    ], v12 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v13 = {
        "kind": "ScalarField",
        "name": "label"
    }, v14 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v15 = {
        "kind": "ScalarField",
        "name": "url"
    }, v16 = {
        "order": "DESC"
    }, v17 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v18 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "name"
    }, v20 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v21 = [
        v15 /*: any*/ 
    ], v22 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v23 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v24 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v25 = [
        v9 /*: any*/ ,
        {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        },
        v19 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        v20 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
                v12 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": v21 /*: any*/ ,
                    "type": "JiraNavigationItem",
                    "abstractKey": "__isJiraNavigationItem"
                },
                v22 /*: any*/ 
            ]
        },
        {
            "alias": "editProjectConfig",
            "args": v23 /*: any*/ ,
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v24 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "args": v23 /*: any*/ ,
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v24 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "alias": "editPermission",
            "args": v23 /*: any*/ ,
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v24 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "kind": "ScalarField",
            "name": "webUrl"
        },
        {
            "kind": "ScalarField",
            "name": "softwareBoardCount"
        }
    ], v26 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v27 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v28 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v25 /*: any*/ 
            }
        ]
    }, v29 = [
        v28 /*: any*/ ,
        v26 /*: any*/ 
    ], v30 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v31 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v32 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v9 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v33 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v12 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                v20 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "defaultNavigationItem",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v21 /*: any*/ ,
                                            "type": "JiraSoftwareBuiltInNavigationItem"
                                        },
                                        v22 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v22 /*: any*/ 
            ]
        }
    ], v34 = [
        v9 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ConfigurableMenuItems"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v1 /*: any*/ ,
                v8 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudID",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "navKey",
                                    "value": "NAV_SIDEBAR"
                                }
                            ],
                            "concreteType": "JiraUserNavigationConfiguration",
                            "kind": "LinkedField",
                            "name": "userNavigationConfiguration",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraConfigurableNavigationItem",
                                    "kind": "LinkedField",
                                    "name": "navItems",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "menuId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isVisible"
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "condition": "isAppsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "globalAppNavigationItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNavigationItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "envLabel"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppSection",
                                                                    "kind": "LinkedField",
                                                                    "name": "sections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAppNavigationItemNestedLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v13 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v14 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "settingsUrl"
                                                                },
                                                                v15 /*: any*/ 
                                                            ],
                                                            "type": "JiraAppNavigationItem"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "JiraWorkManagementGiraOverviewConnection",
                            "kind": "LinkedField",
                            "name": "jwmOverviews",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "JiraAdvancedRoadmapsNavigation",
                            "kind": "LinkedField",
                            "name": "advancedRoadmapsNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasEditPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCreateSamplePlanPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasGlobalPlansAdminPermissions"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isProjectsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementLicensing",
                                    "kind": "LinkedField",
                                    "name": "jwmLicensing",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "currentUserSeatEdition"
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "favouriteProjects",
                                            "args": [
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "sort": v16 /*: any*/ ,
                                                        "type": "PROJECT"
                                                    }
                                                },
                                                v17 /*: any*/ 
                                            ],
                                            "concreteType": "JiraFavouriteConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v25 /*: any*/ ,
                                                                    "type": "JiraProject"
                                                                },
                                                                v22 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v26 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": [
                                                v10 /*: any*/ ,
                                                v27 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "recentProjects",
                                            "plural": false,
                                            "selections": v29 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "GrowthRecQuery",
                                    "kind": "LinkedField",
                                    "name": "growthRecommendations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "fields": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "product",
                                                            "value": "jira"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "tenantId",
                                                            "variableName": "cloudId"
                                                        },
                                                        {
                                                            "kind": "Literal",
                                                            "name": "useCase",
                                                            "value": "jiraProjectMenuRecommendations"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "context"
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 2
                                                }
                                            ],
                                            "kind": "LinkedField",
                                            "name": "recommendations",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "data",
                                                            "plural": true,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "entityId"
                                                                        }
                                                                    ],
                                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "GrowthRecRecommendations"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "entityAri",
                                                    "variableName": "entityAriProjects"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "ownerAri",
                                                    "variableName": "ownerAri"
                                                }
                                            ],
                                            "concreteType": "SettingsNavigationCustomisation",
                                            "kind": "LinkedField",
                                            "name": "settings_navigationCustomisation",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "SettingsDisplayPropertyConnection",
                                                    "kind": "LinkedField",
                                                    "name": "properties",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "SettingsDisplayProperty",
                                                            "kind": "LinkedField",
                                                            "name": "nodes",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "key"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraProjectsSidebarMenu",
                                    "kind": "LinkedField",
                                    "name": "jira_projectsSidebarMenu",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "current",
                                            "plural": false,
                                            "selections": v25 /*: any*/ 
                                        },
                                        {
                                            "args": [
                                                v17 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ],
                                            "storageKey": "favourites(first:15)"
                                        },
                                        {
                                            "args": [
                                                v27 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "recents",
                                            "plural": false,
                                            "selections": v29 /*: any*/ ,
                                            "storageKey": "recents(first:20)"
                                        },
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isFiltersExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v16 /*: any*/ ,
                                                "type": "FILTER"
                                            }
                                        },
                                        v17 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v30 /*: any*/ ,
                                                                v19 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                v20 /*: any*/ ,
                                                                v31 /*: any*/ ,
                                                                v32 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v26 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentFilters",
                                    "args": [
                                        v10 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "FILTER"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v30 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v19 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v20 /*: any*/ ,
                                                                        v31 /*: any*/ ,
                                                                        v32 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                }
                                                            ],
                                                            "type": "JiraCustomFilter"
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v26 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraSystemFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "systemFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSystemFilter",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v30 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                v20 /*: any*/ ,
                                                                v31 /*: any*/ ,
                                                                v32 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isPlansExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouritePlans",
                                    "args": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v16 /*: any*/ ,
                                                "type": "PLAN"
                                            }
                                        },
                                        v17 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v33 /*: any*/ 
                                        },
                                        v26 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentPlans",
                                    "args": [
                                        v10 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "PLAN"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v33 /*: any*/ 
                                        },
                                        v26 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isOperationsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "OpsgenieQuery",
                            "kind": "LinkedField",
                            "name": "opsgenie",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "OpsgenieSavedSearches",
                                    "kind": "LinkedField",
                                    "name": "savedSearches",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": v34 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": v34 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isOverviewsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                    "kind": "LinkedField",
                                    "name": "jwmOverviews",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraWorkManagementGiraOverview",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3d5d6d42738d65c8ba647c421043a676f0276ebd5e724a2f75e455de401a89d3",
            "metadata": {},
            "name": "L1MenuItemsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $apPdj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $bozkj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider": (0, $57dih.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $kXP4b.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider": (0, $95Z36.default)
            }
        }
    };
}();
$70949048397986dd$var$node.hash = "2c0d42ef2bd0d870f4c048210d79296f";
var $70949048397986dd$export$2e2bcd8739ae039 = $70949048397986dd$var$node;

});
parcelRegister("apPdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3cb5e5a280f36f0$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $e3cb5e5a280f36f0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('blu-6315-display-settings-a-part-1', 'isEnabled', false);
    }
};

});

parcelRegister("bozkj", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ae0acd0b32b8d9$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $45ae0acd0b32b8d9$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false);
    }
};

});

parcelRegister("57dih", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd89b8ac04e69345$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $fd89b8ac04e69345$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('blu-3929-sidebar-menu-recommended');
    }
};

});

parcelRegister("kXP4b", function(module, exports) {

$parcel$export(module.exports, "default", () => $78c7049d0eb61e95$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $78c7049d0eb61e95$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jcs_project_type_m3');
    }
};

});

parcelRegister("95Z36", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0e06dd4ba5c9950$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $f0e06dd4ba5c9950$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('migrate_plans_navigation_to_relay');
    }
};

});


parcelRegister("fZBia", function(module, exports) {

$parcel$export(module.exports, "default", () => $79c8513a288fea00$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ee236c9dde5df6d7726d1decdbb50446>>
 * @relayHash 2166d8d37d2e3ef4bf77f06d60ad7574
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9bc3c19d8a70692e667edf5f8ab33de07cbacfb0efd83cfedbe8b4e1690d6c3
const $79c8513a288fea00$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v3 = {
        "kind": "ScalarField",
        "name": "leftSidebarWidth"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sidebarSelectorQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraNavigationUIStateUserProperty",
                                "kind": "LinkedField",
                                "name": "navigationUIState",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v2 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira.navigationUIState.isLeftSidebarCollapsed"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v3 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira.navigationUIState.leftSidebarWidth"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sidebarSelectorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b9bc3c19d8a70692e667edf5f8ab33de07cbacfb0efd83cfedbe8b4e1690d6c3",
            "metadata": {},
            "name": "sidebarSelectorQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$79c8513a288fea00$var$node.hash = "59f81414b49d936016b55cafd8c7ed95";
var $79c8513a288fea00$export$2e2bcd8739ae039 = $79c8513a288fea00$var$node;

});

parcelRegister("kYHsT", function(module, exports) {

$parcel$export(module.exports, "JiraNavigationSettingsAri", () => $f45b2077be41ed7f$export$d53f27b41a9a02bb);

var $jkf7e = parcelRequire("jkf7e");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/navigation-settings/manifest.ts
var $f45b2077be41ed7f$var$jiraNavigationSettingsAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $jkf7e.JiraNavigationSettingsAriResourceOwner),
    resourceType: (0, $jkf7e.JiraNavigationSettingsAriResourceType),
    resourceIdSlug: "activation/{activationId}/{navigationSettingScope}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        navigationSettingScope: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/navigation-settings/index.ts
var $f45b2077be41ed7f$export$d53f27b41a9a02bb = class _JiraNavigationSettingsAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._navigationSettingScope = opts.resourceIdSegmentValues.navigationSettingScope;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get navigationSettingScope() {
        return this._navigationSettingScope;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f45b2077be41ed7f$var$jiraNavigationSettingsAriStaticOpts.qualifier,
            platformQualifier: $f45b2077be41ed7f$var$jiraNavigationSettingsAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f45b2077be41ed7f$var$jiraNavigationSettingsAriStaticOpts.resourceOwner,
            resourceType: $f45b2077be41ed7f$var$jiraNavigationSettingsAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.navigationSettingScope}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                navigationSettingScope: opts.navigationSettingScope
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $f45b2077be41ed7f$var$jiraNavigationSettingsAriStaticOpts);
        return new _JiraNavigationSettingsAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $f45b2077be41ed7f$var$jiraNavigationSettingsAriStaticOpts);
        return new _JiraNavigationSettingsAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            navigationSettingScope: this.navigationSettingScope
        };
    }
};

});
parcelRegister("jkf7e", function(module, exports) {

$parcel$export(module.exports, "JiraNavigationSettingsAriResourceOwner", () => $e11b9c3acd7c102a$export$a71eb7f052c3a8f1);
$parcel$export(module.exports, "JiraNavigationSettingsAriResourceType", () => $e11b9c3acd7c102a$export$8c9eb6c30d1db6dc);
// src/jira/navigation-settings/types.ts
var $e11b9c3acd7c102a$export$a71eb7f052c3a8f1 = "jira", $e11b9c3acd7c102a$export$8c9eb6c30d1db6dc = "navigation-settings";

});


parcelRegister("k9L5z", function(module, exports) {

$parcel$export(module.exports, "IdentityUserAri", () => $eac92cc2828d3532$export$1e9d09c2be53e55e);

var $agYNt = parcelRequire("agYNt");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/identity/user/manifest.ts
var $eac92cc2828d3532$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $agYNt.IdentityUserAriResourceOwner),
    resourceType: (0, $agYNt.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $eac92cc2828d3532$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._userId = opts.resourceIdSegmentValues.userId;
    }
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $eac92cc2828d3532$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $eac92cc2828d3532$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $eac92cc2828d3532$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $eac92cc2828d3532$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $eac92cc2828d3532$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $eac92cc2828d3532$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
};

});
parcelRegister("agYNt", function(module, exports) {

$parcel$export(module.exports, "IdentityUserAriResourceOwner", () => $77aa8f07d2cc15ee$export$b4c14c54282a779d);
$parcel$export(module.exports, "IdentityUserAriResourceType", () => $77aa8f07d2cc15ee$export$e9b50e20f4fbfb71);
// src/identity/user/types.ts
var $77aa8f07d2cc15ee$export$b4c14c54282a779d = "identity", $77aa8f07d2cc15ee$export$e9b50e20f4fbfb71 = "user";

});



parcelRegister("fwzEJ", function(module, exports) {

$parcel$export(module.exports, "topNav4UIStateResource", () => $92bcd9e21d74460f$export$2d81c2e40eea9fba);

var $6s1PB = parcelRequire("6s1PB");

var $ao2h1 = parcelRequire("ao2h1");

var $9ZLcT = parcelRequire("9ZLcT");
const $92bcd9e21d74460f$export$2d81c2e40eea9fba = (0, $ao2h1.createRelayResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_TOPNAV_UI_STATE_RELAY`,
    getQuery: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>({
            parameters: (0, $9ZLcT.default),
            variables: {
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                includeExtraMenuItems: (0, $6s1PB.expVal)('jira_nav4_hot_113350_account_menu_experiment', 'cohort', false)
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("9ZLcT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b5c5aa00eda199b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2a461a3c25b918939e9d8a0a41a0a36a>>
 * @relayHash 5063dabd883604b31f448c60ea62e531
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0b1908e692a7aa5fc47c8b8f0d71d31204d850b421d061ad77e7cbb8ed5eccc4
const $3b5c5aa00eda199b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeExtraMenuItems"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAnonymous"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AtlaskitAtlassianNavigationNav4UIQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraNavigationUIStateUserProperty",
                                "kind": "LinkedField",
                                "name": "navigationUIState",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v2 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira.navigationUIState.isLeftSidebarCollapsed"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Profile"
                },
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "Nav4NotificationsData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AtlaskitAtlassianNavigationNav4UIQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "condition": "includeExtraMenuItems",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "email"
                                                }
                                            ],
                                            "type": "AtlassianAccountUser"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "InfluentsNotificationQuery",
                            "kind": "LinkedField",
                            "name": "notifications",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "unseenNotificationCount"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0b1908e692a7aa5fc47c8b8f0d71d31204d850b421d061ad77e7cbb8ed5eccc4",
            "metadata": {},
            "name": "AtlaskitAtlassianNavigationNav4UIQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3b5c5aa00eda199b$var$node.hash = "6fefcd1fdd1316e2af1f4f9d895a7580";
var $3b5c5aa00eda199b$export$2e2bcd8739ae039 = $3b5c5aa00eda199b$var$node;

});


parcelRegister("h9iZl", function(module, exports) {

$parcel$export(module.exports, "navigationPlansVisibilityResource", () => $66eb980ebca35ddf$export$fa475a9581133779);
$parcel$export(module.exports, "useNavigationPlansVisibility", () => $66eb980ebca35ddf$export$4524245d4e74edb2);
$parcel$export(module.exports, "useNavigationViewPlansPermission", () => $66eb980ebca35ddf$export$98eef08fd4586a4);
$parcel$export(module.exports, "useNavigationEditPlansPermission", () => $66eb980ebca35ddf$export$525db876ed776e0d);
$parcel$export(module.exports, "useIsAdvancedRoadmapsTrial", () => $66eb980ebca35ddf$export$54805a2120a31ad0);

var $dJl1T = parcelRequire("dJl1T");

var $7f4tk = parcelRequire("7f4tk");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $66eb980ebca35ddf$export$fa475a9581133779 = (0, $2M1hQ.createResource)({
    type: (0, $94526093207618a3$export$9260ddb6dfeafd7b),
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return false;
            const response = await (0, $7f4tk.default)(`${tenantContext.baseUrl}/rest/jpo/1.0/navigation/simple`);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData((0, $94526093207618a3$export$87d0ca22edb7493a), 'Error while fetching plans visibility', error);
        }
        return false;
    },
    maxAge: Infinity
});
const $66eb980ebca35ddf$export$4524245d4e74edb2 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
    let isVisible = false;
    if (!error && !loading && data !== null && typeof data === 'object') isVisible = data.isVisible;
    return [
        isVisible
    ];
};
const $66eb980ebca35ddf$export$98eef08fd4586a4 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
    let hasEditOrViewPermissions = false;
    if (!error && !loading && data !== null && typeof data === 'object') hasEditOrViewPermissions = data.hasEditOrViewPermissions;
    return [
        hasEditOrViewPermissions
    ];
};
const $66eb980ebca35ddf$export$525db876ed776e0d = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
    let canEditPlans = false;
    if (!error && !loading && data !== null && typeof data === 'object') canEditPlans = data.hasEditPermissions || false;
    return canEditPlans;
};
const $66eb980ebca35ddf$export$54805a2120a31ad0 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
    let isAdvancedRoadmapsTrial = false;
    if (!error && !loading && data !== null && typeof data === 'object') isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
    return isAdvancedRoadmapsTrial;
};

});
parcelRegister("7f4tk", function(module, exports) {

$parcel$export(module.exports, "default", () => $00a56387884fedf0$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $5HnTq = parcelRequire("5HnTq");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");

var $iwPwz = parcelRequire("iwPwz");
var /**
 * Fetch from the given URL, returning the json response.
 * <p>
 * If there are any HTTP errors the promise is rejected with a {@link FetchError}.
 *
 * @param {string} url - to fetch the JSON from
 * @param {object} options - for the fetch call
 * @returns promise containing the JSON
 * @throws {@link FetchError} if there was an HTTP Error. This will reject the promise.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$00a56387884fedf0$export$2e2bcd8739ae039 = (url, options = {})=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $51xpa.applyObservabilityHeaders)(url, (0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), options))).then((response)=>{
        if (!response.ok) {
            const traceId = (0, $iwPwz.getTraceId)(response);
            if (traceId !== undefined && traceId.length > 0) throw new (0, $jJZqs.default)(response.status, `Fetch call failed with status code: ${response.status}`, traceId, response);
            else throw new (0, $jJZqs.default)(response.status, undefined, undefined, response);
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return response.json();
    });

});

const $94526093207618a3$export$9260ddb6dfeafd7b = 'NAVIGATION_PLANS_VISIBILITY';
const $94526093207618a3$export$87d0ca22edb7493a = 'portfolio.services.plan-item-visibility';


parcelRegister("2eyDn", function(module, exports) {

$parcel$export(module.exports, "consentBannerUserPreferencesResource", () => $7912ae5bd04d670f$export$785c22104b6f2285);
$parcel$export(module.exports, "useConsentBannerUserPreferencesResource", () => $7912ae5bd04d670f$export$5bc7e83e85567fb4);
// eslint-disable-next-line jira/import-whitelist

var $2TWGo = parcelRequire("2TWGo");

var $3TzYp = parcelRequire("3TzYp");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $7912ae5bd04d670f$export$785c22104b6f2285 = (0, $2M1hQ.createResource)({
    type: (0, $f92ba51f7e46c4ce$export$c5397b7748ed6c7b),
    getKey: ()=>(0, $f92ba51f7e46c4ce$export$4a9dd42dbc707155),
    getData: async ()=>{
        const consentToken = (0, $3TzYp.getCookie)((0, $2TWGo.ATLASSIAN_CONSENT_COOKIE_KEY));
        const fallbackConsentToken = (0, $3TzYp.getCookie)((0, $2TWGo.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        // If we have cached cookie data, bundle it up, with a potential fallback token
        if ((0, $4R6GH.fg)('jfp-magma-browser-storage-bump-3')) {
            if (consentToken) return {
                consentToken: consentToken,
                fallbackConsentToken: fallbackConsentToken
            };
        } else {
            const currentLocale = (0, $3TzYp.getCookie)((0, $2TWGo.ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY));
            if (consentToken && currentLocale) return {
                consentToken: consentToken,
                currentLocale: currentLocale,
                fallbackConsentToken: fallbackConsentToken
            };
        }
        const data = await (0, $eusud.performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
        return data;
    },
    maxAge: 900000,
    isBrowserOnly: true
});
const $7912ae5bd04d670f$export$5bc7e83e85567fb4 = ()=>(0, $2YP9W.useResource)($7912ae5bd04d670f$export$785c22104b6f2285);

});
parcelRegister("3TzYp", function(module, exports) {

$parcel$export(module.exports, "getCookie", () => $7ade243d7fa91fea$export$4be65e66cfa2648a);

var $cyHbi = parcelRequire("cyHbi");
function $7ade243d7fa91fea$export$4be65e66cfa2648a(key) {
    return key ? (0, $cyHbi.getCookie)(key) : (0, $cyHbi.getCookie)();
}

});

const $f92ba51f7e46c4ce$export$c5397b7748ed6c7b = 'CONSENT_BANNER_USER_PREFERENCES';
const $f92ba51f7e46c4ce$export$4a9dd42dbc707155 = 'CONSENT_BANNER_USER_PREFERENCES_KEY';


parcelRegister("drGWM", function(module, exports) {

$parcel$export(module.exports, "checkApiKeyManagementKeysResource", () => $ea67ffb8a72e0299$export$b16eaa5246afc9b6);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.
// eslint-disable-next-line jira/import-whitelist

var $d9Cgl = parcelRequire("d9Cgl");

var $3H5ry = parcelRequire("3H5ry");


var $2M1hQ = parcelRequire("2M1hQ");

const $ea67ffb8a72e0299$var$fetchCheckApiKeyManagementKeys = async (accountId, isSiteAdmin, isTransitioning, appPermissions)=>{
    if (!isTransitioning || !isSiteAdmin || appPermissions && appPermissions.hasServiceDeskAccess === false) return Promise.resolve(false);
    return (0, $d9Cgl.eocFetch)(`/api-keys/web/check?accountId=${accountId}`).then(({ data: data })=>data);
};
const $ea67ffb8a72e0299$export$b16eaa5246afc9b6 = ()=>(0, $2M1hQ.createResource)({
        type: (0, $9b8f6422d397a375$export$5879151f0d972f18),
        getKey: ()=>'check-api-key-management-keys',
        getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, appPermissions: appPermissions, isSiteAdmin: isSiteAdmin } })=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const tenantInfo = await dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734]?.promise;
            const isTransitioning = (0, $3H5ry.checkIsTransitioning)(tenantInfo);
            return $ea67ffb8a72e0299$var$fetchCheckApiKeyManagementKeys(atlassianAccountId, isSiteAdmin, isTransitioning, appPermissions);
        },
        maxAge: Infinity,
        isBrowserOnly: true,
        depends: [
            (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
        ]
    });

});
parcelRegister("3H5ry", function(module, exports) {

$parcel$export(module.exports, "checkShouldUseJSM", () => $bc03080c674ccba2$export$5e0f3a0d8463fa21);
$parcel$export(module.exports, "checkIsTransitioning", () => $bc03080c674ccba2$export$d2f281fd4bf10855);
$parcel$export(module.exports, "checkIsConsolidated", () => $bc03080c674ccba2$export$57f75aebff17dd1e);
$parcel$export(module.exports, "checkIsTransitioned", () => $bc03080c674ccba2$export$b6461b23ee0e1471);
$parcel$export(module.exports, "checkIsTransitionEligible", () => $bc03080c674ccba2$export$24040115cac5fdc3);
$parcel$export(module.exports, "checkShouldAccessUnlockOperations", () => $bc03080c674ccba2$export$cd227238525e8d57);
$parcel$export(module.exports, "checkIsOpsAdmin", () => $bc03080c674ccba2$export$66a96ac2f07f6730);

var $bgC2H = parcelRequire("bgC2H");

const $bc03080c674ccba2$export$5e0f3a0d8463fa21 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState !== (0, $bgC2H.ConsolidationState).NOT_CONSOLIDATED;
};
const $bc03080c674ccba2$export$d2f281fd4bf10855 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $bgC2H.ConsolidationState).TRANSITIONING;
};
const $bc03080c674ccba2$export$57f75aebff17dd1e = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $bgC2H.ConsolidationState).CONSOLIDATED : tenantInfo.consolidationState === (0, $bgC2H.ConsolidationState).CONSOLIDATED;
};
const $bc03080c674ccba2$export$b6461b23ee0e1471 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $bgC2H.ConsolidationState).TRANSITIONED;
};
const $bc03080c674ccba2$export$24040115cac5fdc3 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $bgC2H.ConsolidationState).NOT_CONSOLIDATED && tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$650f6934db1290c1);
};
const $bc03080c674ccba2$export$cd227238525e8d57 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState !== (0, $bgC2H.ConsolidationState).CONSOLIDATED && (tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$650f6934db1290c1) || tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$a101f3562b5f0742));
};
const $bc03080c674ccba2$export$66a96ac2f07f6730 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? false : Boolean(tenantInfo.isAdmin);
};

});
parcelRegister("bgC2H", function(module, exports) {

$parcel$export(module.exports, "ConsolidationState", () => $927cd31b0e0ee4e8$export$9ef498b0a11fd37d);
const $927cd31b0e0ee4e8$export$9ef498b0a11fd37d = {
    NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
    TRANSITIONING: 'TRANSITIONING',
    TRANSITIONED: 'TRANSITIONED',
    CONSOLIDATED: 'CONSOLIDATED'
};

});

const $47a35bf911de1c9b$export$650f6934db1290c1 = 'cohort3';
const $47a35bf911de1c9b$export$a101f3562b5f0742 = 'cohort3.5';


const $5a94e356f9d5e220$export$25ee35b01de9d734 = 'EOC_TENANT';

const $9b8f6422d397a375$export$5879151f0d972f18 = 'EOC_CHECK_API_KEY';


parcelRegister("kMiZJ", function(module, exports) {

$parcel$export(module.exports, "consolidationUserStateResource", () => $1e0457dbe68ab17d$export$4b870505c49999ef);

var $jcw0u = parcelRequire("jcw0u");

var $2M1hQ = parcelRequire("2M1hQ");

var $9QTNT = parcelRequire("9QTNT");

const $1e0457dbe68ab17d$var$RESOURCE_KEY = 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE';
const $1e0457dbe68ab17d$export$4b870505c49999ef = (0, $2M1hQ.createResource)({
    type: $1e0457dbe68ab17d$var$RESOURCE_KEY,
    getKey: ()=>$1e0457dbe68ab17d$var$RESOURCE_KEY,
    getData: (_, { tenantContext: { atlassianAccountId: accountId } })=>(0, $9QTNT.getOgConsolidationUserState)(accountId).catch((error)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'consolidationUserStateResource',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }),
    maxAge: Infinity
});

});
parcelRegister("9QTNT", function(module, exports) {

$parcel$export(module.exports, "getOgConsolidationUserState", () => $1a9945d1ee35f024$export$df7594d56c9ebe57);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $iXaZ3 = parcelRequire("iXaZ3");
const $1a9945d1ee35f024$export$df7594d56c9ebe57 = (accountId)=>{
    if (!accountId) return Promise.resolve((0, $iXaZ3.ERROR_CONSOLIDATION_USER_STATE));
    return (0, $89SaW.getUserProperty)(accountId, (0, $iXaZ3.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY)).then((val)=>{
        if (!val || typeof val !== 'object') {
            (0, $jcw0u.default)({
                meta: {
                    id: 'getUserProperty',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: new (0, $jJZqs.ValidationError)('User property is not an object. It must be changed outside of the automated flow.'),
                sendToPrivacyUnsafeSplunk: true
            });
            return 0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE;
        }
        if (!Object.keys(val).every((key)=>Object.prototype.hasOwnProperty.call((0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE), key))) return {
            ...(0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE),
            ...Object.fromEntries(Object.entries(val).filter(([key])=>Object.prototype.hasOwnProperty.call((0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE), key)))
        };
        if (!Object.keys((0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE)).every((key)=>Object.prototype.hasOwnProperty.call(val, key))) // Missing properties will happen when adding new properties to the type,
        // we are making sure they are filled in from the defaults
        return {
            ...(0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE),
            ...val
        };
        return val;
    }).catch((error)=>{
        // Property not saved yet, so we return the default values
        if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) return 0, $iXaZ3.DEFAULT_CONSOLIDATION_USER_STATE;
        throw error;
    });
};

});
parcelRegister("iXaZ3", function(module, exports) {

$parcel$export(module.exports, "OG_CONSOLIDATION_USER_STATE_STORAGE_KEY", () => $58f10b27bad0d860$export$1980758e2622af02);
$parcel$export(module.exports, "DEFAULT_CONSOLIDATION_USER_STATE", () => $58f10b27bad0d860$export$51d9907e9d716d);
$parcel$export(module.exports, "ERROR_CONSOLIDATION_USER_STATE", () => $58f10b27bad0d860$export$23da4710c3a29eae);
const $58f10b27bad0d860$export$1980758e2622af02 = 'eoc_consolidation_user_state';
const $58f10b27bad0d860$export$51d9907e9d716d = {
    isPromotionBannerDismissed: false,
    isWelcomeModalDisplayed: false,
    isTransitionHomeHidden: false,
    isTransitionBannerDismissed: false,
    isBroadcastWidgetDismissed: false,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: false
};
const $58f10b27bad0d860$export$23da4710c3a29eae = {
    isPromotionBannerDismissed: true,
    isWelcomeModalDisplayed: true,
    isTransitionHomeHidden: true,
    isTransitionBannerDismissed: true,
    isBroadcastWidgetDismissed: true,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: true
};

});



parcelRegister("bHhiy", function(module, exports) {

$parcel$export(module.exports, "getConsolidationStateResource", () => $cd33a435a46904ef$export$a6cf5054d4f9f5dd);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.
// eslint-disable-next-line jira/import-whitelist

var $d9Cgl = parcelRequire("d9Cgl");

var $4R6GH = parcelRequire("4R6GH");

var $2M1hQ = parcelRequire("2M1hQ");

var $bgC2H = parcelRequire("bgC2H");

const $cd33a435a46904ef$export$de6c19ae237c1eb9 = (cloudId, atlassianAccountId, isAnonymous, appPermissions)=>{
    let url = (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? '/internal/v1/users/ops-user-info' : '/internal/v1/customers/tenant-info';
    if (cloudId) url = `${url}/${cloudId}`;
    else throw new Error('No tenant info exists.');
    let promise;
    if (appPermissions && appPermissions.hasServiceDeskAccess === false || isAnonymous) {
        promise = new Promise((resolve)=>{
            resolve({
                consolidationState: (0, $bgC2H.ConsolidationState).NOT_CONSOLIDATED,
                ...(0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? {
                    isAdmin: false
                } : {}
            });
        });
        return promise;
    }
    if ((0, $4R6GH.fg)('operations-tenant-info-endpoint-update')) url = `${url}/${atlassianAccountId}`;
    if (false) promise = (0, $d9Cgl.eocFetch)(url, {
        exactUrl: true,
        headers: {
            'x-ssr-service-name': (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? 'og-apps-user-int-api' : 'og-customer-int-api'
        }
    });
    else {
        const clientUrl = (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? '/v1/users/ops-user-info' : '/v1/customers/tenant-info';
        promise = (0, $d9Cgl.eocFetch)(clientUrl).then(({ data: data })=>data);
    }
    return promise;
};
const $cd33a435a46904ef$export$a6cf5054d4f9f5dd = (forceBrowser = false)=>(0, $2M1hQ.createResource)({
        type: (0, $5a94e356f9d5e220$export$25ee35b01de9d734),
        getKey: ()=>'tenantInformation',
        getData: (_, { tenantContext: { cloudId: cloudId, appPermissions: appPermissions, atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>$cd33a435a46904ef$export$de6c19ae237c1eb9(cloudId, atlassianAccountId, isAnonymous, appPermissions),
        maxAge: Infinity,
        isBrowserOnly: forceBrowser
    });

});

parcelRegister("aA974", function(module, exports) {

$parcel$export(module.exports, "gicSmartFieldsFeatureResource", () => $d18db694553f5610$export$ee94bb1f59b07e35);
$parcel$export(module.exports, "useIsSmartFieldsOptIn", () => $d18db694553f5610$export$3870b1ff1b155c73);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $aHuqL = parcelRequire("aHuqL");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $d18db694553f5610$export$ee94bb1f59b07e35 = (0, $2M1hQ.createResource)({
    type: (0, $814b0a0376a60368$export$6f0555de4f60e84e),
    getKey: ()=>(0, $814b0a0376a60368$export$7e7d7930e22ba39f),
    getData: async ()=>{
        try {
            const data = await (0, $aHuqL.userPreferenceAPI).get((0, $814b0a0376a60368$export$b94951a11282ae6a));
            if (!data) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: (0, $4R6GH.fg)('smart_fields_gic_toggle_fg') ? false : undefined
            };
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If value has never been set, we expect a 404
            if (error.statusCode === 404) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: (0, $4R6GH.fg)('smart_fields_gic_toggle_fg') ? false : undefined
            };
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'gicSmartFieldsFeatureResource',
                    packageName: (0, $814b0a0376a60368$export$b8b9d90f9e5bd72b),
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            hasUserOptedOut: false,
            hasUserDismissedReadMore: false,
            hasUserDismissedGicOnboarding: (0, $4R6GH.fg)('smart_fields_gic_toggle_fg') ? false : undefined
        };
    },
    maxAge: Number.MAX_VALUE
});
const $d18db694553f5610$export$3870b1ff1b155c73 = ()=>{
    const { data: data, update: update, loading: loading } = (0, $2YP9W.useResource)($d18db694553f5610$export$ee94bb1f59b07e35);
    const currentOptInStatus = typeof data?.hasUserOptedOut === 'boolean' ? !data.hasUserOptedOut : true;
    const currentDismissedReadMore = typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false;
    // eslint-disable-next-line no-nested-ternary
    const currentDismissedGicOnboarding = (0, $4R6GH.fg)('smart_fields_gic_toggle_fg') ? typeof data?.hasUserDismissedGicOnboarding === 'boolean' ? data.hasUserDismissedGicOnboarding : false : undefined;
    const dismissReadMore = (0, $5uXOq.useCallback)(()=>{
        update((previousData)=>({
                ...previousData?.hasUserOptedOut ? {
                    hasUserOptedOut: previousData.hasUserOptedOut
                } : {
                    hasUserOptedOut: false
                },
                hasUserDismissedReadMore: true,
                // eslint-disable-next-line no-nested-ternary
                ...(0, $4R6GH.fg)('smart_fields_gic_toggle_fg') ? previousData?.hasUserDismissedGicOnboarding ? {
                    hasUserDismissedGicOnboarding: previousData.hasUserDismissedGicOnboarding
                } : {
                    hasUserDismissedGicOnboarding: false
                } : {}
            }));
    }, [
        update
    ]);
    const dismissGicOnboarding = (0, $5uXOq.useCallback)(()=>{
        update((previousData)=>({
                ...previousData?.hasUserOptedOut ? {
                    hasUserOptedOut: previousData.hasUserOptedOut
                } : {
                    hasUserOptedOut: false
                },
                ...previousData?.hasUserDismissedReadMore ? {
                    hasUserDismissedReadMore: previousData.hasUserDismissedReadMore
                } : {
                    hasUserDismissedReadMore: false
                },
                hasUserDismissedGicOnboarding: true
            }));
    }, [
        update
    ]);
    return {
        isSmartFieldsOptIn: loading ? null : currentOptInStatus,
        isSmartFieldDismissedReadMore: loading ? null : currentDismissedReadMore,
        isSmartFieldsGicOnboardingDismissed: loading ? null : currentDismissedGicOnboarding,
        dismissReadMore: dismissReadMore,
        dismissGicOnboarding: dismissGicOnboarding,
        loading: loading
    };
};

});
parcelRegister("aHuqL", function(module, exports) {

$parcel$export(module.exports, "userPreferenceAPI", () => $0f87ed1c6d708024$export$4f7929ca6b50a436);


var $eusud = parcelRequire("eusud");
const $0f87ed1c6d708024$var$url = (key)=>`/rest/api/3/mypreferences?key=${key}`;
const $0f87ed1c6d708024$var$get = async (key)=>{
    try {
        const result = await (0, $eusud.performGetRequest)($0f87ed1c6d708024$var$url(key));
        return result?.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef)) return null;
        throw error;
    }
};
const $0f87ed1c6d708024$var$set = (key, value)=>(0, $eusud.performPutRequest)($0f87ed1c6d708024$var$url(key), {
        body: JSON.stringify({
            value: value
        })
    });
const $0f87ed1c6d708024$var$remove = (key)=>(0, $eusud.performDeleteRequest)($0f87ed1c6d708024$var$url(key));
const $0f87ed1c6d708024$export$4f7929ca6b50a436 = {
    get: $0f87ed1c6d708024$var$get,
    set: $0f87ed1c6d708024$var$set,
    remove: $0f87ed1c6d708024$var$remove
};

});

const $814b0a0376a60368$export$6f0555de4f60e84e = 'RESOURCE_TYPE_GIC_SMART_FIELDS';
const $814b0a0376a60368$export$7e7d7930e22ba39f = 'gsf-opt-out-resource-key'; // value is global for user
const $814b0a0376a60368$export$b94951a11282ae6a = 'gic-smart-fields-feature';
const $814b0a0376a60368$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGicSmartFields';


parcelRegister("f5nIZ", function(module, exports) {

$parcel$export(module.exports, "gicOptInStatusResources", () => $1dd3138bca6cac05$export$14c89b6b6a261524);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");


const $1dd3138bca6cac05$export$14c89b6b6a261524 = (0, $2M1hQ.createResource)({
    type: (0, $8e5bc4e5db4905c7$export$fe522736b61f6709),
    getKey: ()=>'gic_optin_status',
    getData: async ()=>{
        let gicOptInStatus = null;
        try {
            gicOptInStatus = await (0, $eusud.performGetRequest)('/rest/greenhopper/1.0/profile/labs-panel/modern-gic-visibility');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e.statusCode !== 404) (0, $dJl1T.default).safeErrorWithoutCustomerData('spa.router.resources.navigation.gicVisibility', 'getGICVisibility', e);
        }
        return {
            gicOptInStatus: gicOptInStatus ?? {
                isEnabled: false
            }
        };
    },
    maxAge: Number.MAX_VALUE
});

});
const $8e5bc4e5db4905c7$export$fe522736b61f6709 = 'RESOURCE_TYPE_GIC_OPTIN_STATUS';


parcelRegister("hZhhj", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RESPONSE", () => $0f1ada479bbc578a$export$32d9db53927095d3);
$parcel$export(module.exports, "incomingMailServerExpiryStatusResource", () => $0f1ada479bbc578a$export$369caf52ed1ad2b1);
$parcel$export(module.exports, "useIncomingMailExpiryStatus", () => $0f1ada479bbc578a$export$283aa034b7d4e2a0);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $0f1ada479bbc578a$var$fetchGetIncomingMailServerExpiryStatus = async ()=>(0, $eusud.performGetRequest)((0, $b9c933d7a799fa71$export$5bf8eb915287f5f4));
const $0f1ada479bbc578a$export$32d9db53927095d3 = {
    isAdmin: false,
    showBanner: true,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $0f1ada479bbc578a$export$369caf52ed1ad2b1 = (0, $2M1hQ.createResource)({
    type: (0, $b9c933d7a799fa71$export$3b9494e0dfc4de09),
    getKey: ()=>(0, $b9c933d7a799fa71$export$f2f2f265ccc09f82),
    getData: async ()=>{
        let incomingMailServerExpiryStatus = null;
        try {
            incomingMailServerExpiryStatus = await $0f1ada479bbc578a$var$fetchGetIncomingMailServerExpiryStatus();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'incomingMailServerExpiryStatus',
                    packageName: 'jiraRouterResourcesIncomingMailExpiryStatus',
                    teamName: 'maverick'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            incomingMailServerExpiryStatus: incomingMailServerExpiryStatus ?? $0f1ada479bbc578a$export$32d9db53927095d3
        };
    },
    maxAge: 3600000
});
const $0f1ada479bbc578a$export$283aa034b7d4e2a0 = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource } = (0, $2YP9W.useResource)($0f1ada479bbc578a$export$369caf52ed1ad2b1);
    const [incomingMailServerExpiryStatus, setIncomingMailServerExpiryStatus] = (0, $5uXOq.useState)(()=>{
        if (data?.incomingMailServerExpiryStatus) return data.incomingMailServerExpiryStatus;
        return $0f1ada479bbc578a$export$32d9db53927095d3;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
    (0, $5uXOq.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.incomingMailServerExpiryStatus) {
            setResponseStatusGet('success');
            setIncomingMailServerExpiryStatus(data.incomingMailServerExpiryStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.incomingMailServerExpiryStatus
    ]);
    return {
        responseStatus: responseStatusGet,
        state: incomingMailServerExpiryStatus
    };
};

});
const $b9c933d7a799fa71$export$3b9494e0dfc4de09 = 'mail_server_expiring';
const $b9c933d7a799fa71$export$f2f2f265ccc09f82 = 'is_oauth_mail_server_expiring';
const $b9c933d7a799fa71$export$5bf8eb915287f5f4 = '/rest/internal/3/incomingMailServers/isOauthMailServersExpiring';


parcelRegister("9MiT2", function(module, exports) {

$parcel$export(module.exports, "issueTransitionChangeboardingPreferencesResource", () => $2d6f7831c4394a60$export$1b6468a6eb7d9b09);
$parcel$export(module.exports, "useIssueTransitionChangeboardingPreferences", () => $2d6f7831c4394a60$export$e21c345b2538e96e);

var $5uXOq = parcelRequire("5uXOq");

var $561FV = parcelRequire("561FV");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $erLlC = parcelRequire("erLlC");
const $2d6f7831c4394a60$export$1b6468a6eb7d9b09 = (0, $2M1hQ.createResource)({
    type: (0, $erLlC.RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES),
    getKey: ()=>(0, $erLlC.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY),
    getData: async ()=>{
        let modalViewCount = 0;
        try {
            const apiResult = await (0, $eusud.performGetRequest)((0, $erLlC.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API));
            if ((0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(apiResult, 'value') || !(0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(apiResult, 'benefitsModalValue')) {
                    const error = new Error('Invalid preference value');
                    (0, $jcw0u.default)({
                        meta: {
                            id: 'issueTransitionChangeboardingPreferencesResource',
                            packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
                return {
                    numberOfTimesUserHasSeenChangeboarding: Number(apiResult.value) || 0,
                    benefitsModal: {
                        isDisabled: apiResult?.benefitsModal?.isDisabled || false,
                        nextDateToShowBenefitsModal: apiResult?.benefitsModal?.nextDateToShowBenefitsModal || null
                    }
                };
            }
            if (typeof apiResult !== 'object' || !(0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(apiResult, 'value')) {
                const error = new Error('Invalid preference value');
                (0, $jcw0u.default)({
                    meta: {
                        id: 'issueTransitionChangeboardingPreferencesResource',
                        packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } else {
                modalViewCount = Number(apiResult.value);
                return {
                    numberOfTimesUserHasSeenChangeboarding: modalViewCount
                };
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) {
                if ((0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) return {
                    numberOfTimesUserHasSeenChangeboarding: 0,
                    benefitsModal: {
                        isDisabled: false,
                        nextDateToShowBenefitsModal: null
                    }
                };
                return {
                    numberOfTimesUserHasSeenChangeboarding: 0
                };
            }
            (0, $jcw0u.default)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesResource',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            numberOfTimesUserHasSeenChangeboarding: modalViewCount,
            benefitsModal: {
                isDisabled: true,
                nextDateToShowBenefitsModal: null
            }
        };
    }
});
const $2d6f7831c4394a60$export$e21c345b2538e96e = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $2YP9W.useResource)($2d6f7831c4394a60$export$1b6468a6eb7d9b09);
    const [issueTransitionChangeboardingPreference, setIssueTransitionChangeboardingPreference] = (0, $5uXOq.useState)(()=>{
        if ((0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) return {
            numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
            benefitsModal: {
                isDisabled: Boolean(data?.benefitsModal?.isDisabled),
                nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
            }
        };
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') return data.numberOfTimesUserHasSeenChangeboarding;
        return 0, $erLlC.USER_SEEN_CARDINALITY_UNKNOWN;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $5uXOq.useState)('not started');
    const updateIssueTranstitionChangeboardingPreferences = (0, $5uXOq.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        const body = typeof updates !== 'number' && (0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal') ? {
            value: updates?.numberOfTimesUserHasSeenChangeboarding,
            benefitsModal: {
                isDisabled: updates?.benefitsModal?.isDisabled,
                nextDateToShowBenefitsModal: updates?.benefitsModal?.nextDateToShowBenefitsModal
            }
        } : {
            value: updates
        };
        try {
            await (0, $eusud.performPutRequest)((0, $erLlC.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API), {
                body: JSON.stringify(body)
            });
            setResponseStatusPut('success');
            let updateData;
            if (typeof updates !== 'number' && (0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) updateData = {
                numberOfTimesUserHasSeenChangeboarding: updates?.numberOfTimesUserHasSeenChangeboarding,
                benefitsModal: {
                    isDisabled: updates?.benefitsModal?.isDisabled || false,
                    nextDateToShowBenefitsModal: String(updates?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            };
            if (typeof updates === 'number') updateData = {
                numberOfTimesUserHasSeenChangeboarding: updates
            };
            update(()=>updateData);
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if ((0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference({
                numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
                benefitsModal: {
                    isDisabled: data?.benefitsModal?.isDisabled || false,
                    nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            });
            return;
        }
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference(data?.numberOfTimesUserHasSeenChangeboarding);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.numberOfTimesUserHasSeenChangeboarding,
        data?.benefitsModal?.isDisabled,
        data?.benefitsModal?.nextDateToShowBenefitsModal
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionChangeboardingPreference
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTranstitionChangeboardingPreferences
        }
    };
};

});
parcelRegister("erLlC", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES", () => $ca7314633d486db1$export$d66d4b761db3d20f);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY", () => $ca7314633d486db1$export$79fd70b908f71ddd);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API", () => $ca7314633d486db1$export$e5007258addba8aa);
$parcel$export(module.exports, "USER_SEEN_CARDINALITY_UNKNOWN", () => $ca7314633d486db1$export$91880069e7e73b18);
$parcel$export(module.exports, "DURATION_IN_DAYS_DEFAULT", () => $ca7314633d486db1$export$9ccdfd91f2512a27);
const $ca7314633d486db1$export$d66d4b761db3d20f = 'issue_transition_changeboarding_preferences';
const $ca7314633d486db1$export$79fd70b908f71ddd = 'issue_transition_changeboarding_preferences_status';
const $ca7314633d486db1$export$e5007258addba8aa = '/rest/api/3/mypreferences?key=jira.its.changeboarding.preferences';
const $ca7314633d486db1$export$91880069e7e73b18 = -1;
const $ca7314633d486db1$export$9ccdfd91f2512a27 = 14;

});


parcelRegister("fNOVA", function(module, exports) {

$parcel$export(module.exports, "issueTransitionOptInStatusResource", () => $cf959888902c771b$export$5fbcf4d7a6d9c477);
$parcel$export(module.exports, "useIssueTransitionLabsOptIn", () => $cf959888902c771b$export$bc11d4816053db5c);

var $5uXOq = parcelRequire("5uXOq");

var $b4PzF = parcelRequire("b4PzF");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $dO2g2 = parcelRequire("dO2g2");
/*
 * API Contract: https://hello.atlassian.net/wiki/spaces/JIE/pages/2983777277/Issue+Transition+Jira+Labs+Toggle+for+Legacy+Experience+Backend+API#API-Contract
 */ const $cf959888902c771b$var$fetchGetIssueTransitionOptInState = async ()=>(0, $eusud.performGetRequest)((0, $267ed65766cf1bd0$export$466b1c60da56c8ca));
const $cf959888902c771b$export$5fbcf4d7a6d9c477 = (0, $2M1hQ.createResource)({
    type: (0, $267ed65766cf1bd0$export$eb01e12fc3db65c0),
    getKey: ()=>(0, $267ed65766cf1bd0$export$a964df7bc15d81e),
    getData: async ()=>{
        let issueTransitionOptInStatus = null;
        const isModernIssueTransitionSRBCohort = (0, $4R6GH.fg)('issue-transition-customisation-for-srb') || (0, $b4PzF.isFedRamp)();
        const isModernITSRenderEnabled = (0, $4R6GH.fg)('render-modern-issue-transition') || (0, $b4PzF.isFedRamp)();
        if (!isModernITSRenderEnabled) return {
            issueTransitionOptInStatus: {
                isEnabled: false,
                expiryTime: -1
            }
        };
        if (isModernIssueTransitionSRBCohort) return {
            issueTransitionOptInStatus: {
                isEnabled: true
            }
        };
        try {
            issueTransitionOptInStatus = await $cf959888902c771b$var$fetchGetIssueTransitionOptInState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'issueTransitionOptInStatusResource',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            issueTransitionOptInStatus: issueTransitionOptInStatus ?? (0, $dO2g2.default)()
        };
    },
    maxAge: Number.MAX_VALUE
});
const $cf959888902c771b$var$fetchModifyIssueTransitionOptInState = async (payload)=>(0, $eusud.performPutRequest)((0, $267ed65766cf1bd0$export$466b1c60da56c8ca), {
        body: JSON.stringify(payload)
    });
const $cf959888902c771b$export$bc11d4816053db5c = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $2YP9W.useResource)($cf959888902c771b$export$5fbcf4d7a6d9c477);
    const [issueTransitionLabsOptInState, setIssueTransitionOptInState] = (0, $5uXOq.useState)(()=>{
        if (data?.issueTransitionOptInStatus) return data.issueTransitionOptInStatus;
        return (0, $dO2g2.default)();
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $5uXOq.useState)('not started');
    const updateIssueTransitionOptInStatus = (0, $5uXOq.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        try {
            const updatedPreferences = await $cf959888902c771b$var$fetchModifyIssueTransitionOptInState(updates);
            setResponseStatusPut('success');
            update(()=>({
                    issueTransitionOptInStatus: updatedPreferences
                }));
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $jcw0u.default)({
                error: err,
                meta: {
                    id: 'issueTransitionOptInStatusUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.issueTransitionOptInStatus) {
            setResponseStatusGet('success');
            setIssueTransitionOptInState(data.issueTransitionOptInStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.issueTransitionOptInStatus
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionLabsOptInState
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTransitionOptInStatus
        }
    };
};

});
const $267ed65766cf1bd0$export$eb01e12fc3db65c0 = 'issue_transition_opt_in';
const $267ed65766cf1bd0$export$a964df7bc15d81e = 'issue_transition_labs_opt_in_status';
const $267ed65766cf1bd0$export$466b1c60da56c8ca = '/rest/greenhopper/1.0/profile/labs-panel/modern-its-visibility';
const $267ed65766cf1bd0$export$880a78695d76498e = 8;

parcelRegister("dO2g2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa107364a5021d3$export$2e2bcd8739ae039);

var $b4PzF = parcelRequire("b4PzF");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");
const $8fa107364a5021d3$var$getDefaultIssueTransitionLabsOptInState = ()=>{
    const isModernITSRenderEnabled = (0, $4R6GH.fg)('render-modern-issue-transition') || (0, $b4PzF.isFedRamp)();
    if (!isModernITSRenderEnabled) return {
        isEnabled: false,
        expiryTime: -1
    };
    const isModernIssueTransitionSRBCohort = (0, $4R6GH.fg)('issue-transition-customisation-for-srb') || (0, $b4PzF.isFedRamp)();
    if (isModernIssueTransitionSRBCohort) return {
        isEnabled: true
    };
    return (0, $6s1PB.expValEquals)('jira_issue_transition_screen_modernisation_toggle', 'value', 'BY_DEFAULT_USER_OPT_OUT') ? {
        isEnabled: false,
        expiryTime: -1
    } : {
        isEnabled: true
    };
};
var $8fa107364a5021d3$export$2e2bcd8739ae039 = $8fa107364a5021d3$var$getDefaultIssueTransitionLabsOptInState;

});


parcelRegister("kJQXA", function(module, exports) {

$parcel$export(module.exports, "navigationSidebarAutomationLegacyEnabledResource", () => $273ba0463e1e3cac$export$fa191d7d71460a98);

var $4Pf62 = parcelRequire("4Pf62");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");

const $273ba0463e1e3cac$export$fa191d7d71460a98 = (0, $2M1hQ.createResource)({
    type: (0, $b830026e722fc8e6$export$fd4fc70ec71927d1),
    getKey: ({ query: query })=>`jsm-legacy-automation-enabled-${query.projectKey}`,
    getData: async (_, { tenantContext: { licensedProducts: licensedProducts } })=>{
        const defaultValue = {
            enabled: true
        };
        if (!licensedProducts || !licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_SERVICEDESK]) return defaultValue;
        const { enabled: enabled } = await (0, $eusud.performGetRequest)('/rest/servicedesk/automation/1/legacy/state');
        return {
            enabled: enabled
        };
    },
    maxAge: Infinity
});

});
const $b830026e722fc8e6$export$fd4fc70ec71927d1 = 'AUTOMATION_IS_LEGACY_ENABLED';


parcelRegister("atU1t", function(module, exports) {

$parcel$export(module.exports, "navigationSidebarGlobalResource", () => $587727b78e9bd173$export$44e7ad3c66a3f25f);

var $02g8e = parcelRequire("02g8e");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

const $587727b78e9bd173$export$44e7ad3c66a3f25f = (0, $2M1hQ.createResource)({
    type: (0, $f9d36ddc532997a4$export$fa5743fc6a1da5d8),
    getKey: ({ match: match, query: query })=>{
        // Refresh the data if the project key or id changes
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        return projectKey || projectId || '__state';
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { baseUrl: baseUrl } = tenantContext;
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const scope = {
            projectKey: projectKey,
            projectId: projectId
        };
        const response = await (0, $02g8e.fetchSidebarConfig)(baseUrl, scope, false);
        return {
            response: response,
            scope: scope
        };
    },
    maxAge: 300000
});

});
parcelRegister("02g8e", function(module, exports) {

$parcel$export(module.exports, "fetchSidebarConfig", () => $5da99daaa007f26b$export$d1d13c4b972a22f1);

var $dJl1T = parcelRequire("dJl1T");

var $7f4tk = parcelRequire("7f4tk");
const $5da99daaa007f26b$var$LOGGER_LOCATION = 'navigation-next.baskets.navigation.utils';

const $5da99daaa007f26b$var$fetchUsingProtobuf = async (url)=>{
    try {
        const fetchProtobuf = await (parcelRequire("laEEP"));
        if (!fetchProtobuf) (0, $dJl1T.default).safeErrorWithoutCustomerData($5da99daaa007f26b$var$LOGGER_LOCATION, 'Error dynamically loading protobuf fetch function');
        return fetchProtobuf.default(url);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData($5da99daaa007f26b$var$LOGGER_LOCATION, 'Error fetching Sidebar Configuration protocol buffer message', err);
        throw err;
    }
};
const $5da99daaa007f26b$export$94e808b2557f52e = (baseUrl, requestQuery, version = '2', queryParams)=>{
    const { pageType: pageType, identifierValue: identifierValue, identifierType: identifierType, exclude: exclude } = requestQuery || {};
    const params = {
        exclude: [
            'webItems.reports',
            'webItems.home',
            'webItems.gin',
            exclude
        ].filter(Boolean).join(',')
    };
    let path = '';
    if (pageType && identifierValue != null) path = `${pageType}/${identifierValue}`;
    else if (identifierType === 'boardId' && identifierValue != null) path = `board/${identifierValue}`;
    else if (identifierValue != null) path = `project/${identifierValue}`;
    else {
        path = 'product';
        const { projectId: projectId, projectKey: projectKey } = requestQuery || {};
        // Connect apps rely on project context even for the global/product scoped webItems
        const projectIdOrKey = projectId || projectKey;
        if (projectIdOrKey) params.projectIdOrKey = projectIdOrKey;
    }
    const queryString = [
        new URLSearchParams(params).toString(),
        queryParams
    ].filter(Boolean).join('&');
    return `${baseUrl}/rest/navigation/${version}/${path}?${queryString}`;
};
const $5da99daaa007f26b$export$d1d13c4b972a22f1 = async (baseUrl, requestQuery, isServer, queryParams)=>{
    if (isServer) {
        const protoUrl = $5da99daaa007f26b$export$94e808b2557f52e(baseUrl, requestQuery, '2.1', queryParams);
        return $5da99daaa007f26b$var$fetchUsingProtobuf(protoUrl);
    }
    const sidebarUrl = $5da99daaa007f26b$export$94e808b2557f52e(baseUrl, requestQuery, undefined, queryParams);
    return (0, $7f4tk.default)(sidebarUrl);
};

});
parcelRegister("laEEP", function(module, exports) {

let $03fa3a1847f5c79c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $03fa3a1847f5c79c$var$load("7erVk").then(()=>parcelRequire('g4I8Z'));

});


const $f9d36ddc532997a4$export$fa5743fc6a1da5d8 = 'NAVIGATION_SIDEBAR_GLOBAL';


parcelRegister("c34Wf", function(module, exports) {

$parcel$export(module.exports, "navigationUiStateResource", () => $976a0f933d5d0ba8$export$14c178691841b423);
// eslint-disable-next-line jira/import-whitelist

var $8QpSo = parcelRequire("8QpSo");

var $2M1hQ = parcelRequire("2M1hQ");

var $kJPyG = parcelRequire("kJPyG");

const $976a0f933d5d0ba8$var$getNavigationUiStateMemoized = (0, $8QpSo.default)((atlassianAccountId)=>(0, $kJPyG.getNavigationUiState)({
        tenantContext: {
            atlassianAccountId: atlassianAccountId
        }
    }));
const $976a0f933d5d0ba8$export$14c178691841b423 = (0, $2M1hQ.createResource)({
    type: 'RESOURCE_TYPE_NAVIGATION_UI',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>$976a0f933d5d0ba8$var$getNavigationUiStateMemoized(atlassianAccountId),
    maxAge: Infinity
});

});
parcelRegister("kJPyG", function(module, exports) {

$parcel$export(module.exports, "getNavigationUiState", () => $a5efaf793a61ef5e$export$29999268b070c9bd);

var $89SaW = parcelRequire("89SaW");


var $1yqku = parcelRequire("1yqku");
const $a5efaf793a61ef5e$export$29999268b070c9bd = async ({ tenantContext: tenantContext })=>{
    const { atlassianAccountId: accountId } = tenantContext;
    let uiState = await (0, $1yqku.queryLocalStorage)();
    if (uiState || !accountId) return uiState;
    try {
        uiState = await (0, $89SaW.getUserProperty)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8));
        // @ts-expect-error - TS2345 - Argument of type 'UIControllerShape | undefined' is not assignable to parameter of type 'UIControllerShape'.
        (0, $1yqku.updateLocalStorageData)(uiState);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // Don't log the error on purpose. This is very frequent for some reason :(
    }
    return uiState;
};

});
const $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8 = 'navigation_next_ui_state';
const $2ed2f0cf8ecb933e$export$c63f561360bafed1 = 'navigation-next.providers.ui-state-cache-provider';

parcelRegister("1yqku", function(module, exports) {

$parcel$export(module.exports, "queryLocalStorage", () => $fa4273588466a1c1$export$e192dcb908272d5);
$parcel$export(module.exports, "updateLocalStorageData", () => $fa4273588466a1c1$export$ec13c725e067146a);

var $8Rkzz = parcelRequire("8Rkzz");

var $4R6GH = parcelRequire("4R6GH");

var $dJl1T = parcelRequire("dJl1T");

var $bSSG7 = parcelRequire("bSSG7");

// TODO - JFP-2294 add prefix for webstorage
const $fa4273588466a1c1$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('');
const $fa4273588466a1c1$export$e7db3fa51c63bc5c = ()=>{
    if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') return window.localStorage;
    return {
        setItem: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        getItem: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    };
};
const $fa4273588466a1c1$var$queryLocalStorageSync = ()=>{
    const localStorage = $fa4273588466a1c1$export$e7db3fa51c63bc5c();
    const item = (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $fa4273588466a1c1$var$localStorageProvider.get((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8)) : localStorage.getItem((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8));
    if (!false && item) try {
        return (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? item : JSON.parse(item);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData((0, $2ed2f0cf8ecb933e$export$c63f561360bafed1), 'Fail to parse sync local storage data', e);
    }
};
const $fa4273588466a1c1$export$e192dcb908272d5 = ()=>new Promise((resolve)=>{
        const item = $fa4273588466a1c1$var$queryLocalStorageSync();
        resolve(item);
    });
const $fa4273588466a1c1$export$ec13c725e067146a = (data)=>{
    const localStorage = $fa4273588466a1c1$export$e7db3fa51c63bc5c();
    (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $fa4273588466a1c1$var$localStorageProvider.set((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), data) : localStorage.setItem((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(data));
};

});
parcelRegister("bSSG7", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageProvider", () => $63804f80e89e547d$export$697e65b1658f821b);
$parcel$export(module.exports, "createLocalExpirableStorageProvider", () => $63804f80e89e547d$export$59acef2b3ab1df90);

var $gJBT6 = parcelRequire("gJBT6");

var $fNVZf = parcelRequire("fNVZf");

var $dEJQ9 = parcelRequire("dEJQ9");
const $63804f80e89e547d$export$697e65b1658f821b = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix)=>(0, $fNVZf.createStorageProvider)((0, $fNVZf.WebStorageType).LocalStorage, appPrefix, (0, $dEJQ9.makeLocalStore)()));
const $63804f80e89e547d$export$59acef2b3ab1df90 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix)=>{
    return (0, $fNVZf.createExpirableStorageProvider)((0, $fNVZf.WebStorageType).LocalStorage, appPrefix, (0, $dEJQ9.makeLocalExpirableStore)());
});

});
parcelRegister("fNVZf", function(module, exports) {

$parcel$export(module.exports, "plugins", () => $04caddce42518619$export$8b3ca321c77fdea6);
$parcel$export(module.exports, "WebStorageType", () => $04caddce42518619$export$259e3a861f28589b);
$parcel$export(module.exports, "createStorageProvider", () => $04caddce42518619$export$8441605555fbd60c);
$parcel$export(module.exports, "createExpirableStorageProvider", () => $04caddce42518619$export$b793a81cf479272a);

var $fKgem = parcelRequire("fKgem");

var $1ohWS = parcelRequire("1ohWS");

var $4R6GH = parcelRequire("4R6GH");

var $c7J1U = parcelRequire("c7J1U");
const $04caddce42518619$export$8b3ca321c77fdea6 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($fKgem))),
    (0, $c7J1U.default)
];
const $04caddce42518619$export$259e3a861f28589b = {
    LocalStorage: 'LocalStorage',
    SessionStorage: 'SessionStorage'
};
const $04caddce42518619$export$8441605555fbd60c = (storageType, appPrefix = '', // eslint-disable-next-line @typescript-eslint/no-explicit-any
store)=>{
    const oldStore = store.namespace(appPrefix);
    const getKeyWithPrefix = (key)=>appPrefix?.trim().length ? `${appPrefix}.${key}` : key;
    const storageAPI = storageType === $04caddce42518619$export$259e3a861f28589b.LocalStorage ? (0, $1ohWS.AtlBrowserStorageLocal) : (0, $1ohWS.AtlBrowserStorageSession);
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set: (key, value)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                const stringValue = JSON.stringify(value);
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) storageAPI.setItem(prefixedKey, stringValue);
                else {
                    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-hot-114899')) // write to the old storejs store as well
                    oldStore.set(key, value);
                    store.set(prefixedKey, stringValue);
                }
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error setting item in storage:', err);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setStrictlyNecessaryItem: (key, value)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                const stringValue = JSON.stringify(value);
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) storageAPI.setStrictlyNecessaryItem(prefixedKey, stringValue);
                else throw Error('Method setStrictlyNecessaryItem is not supported.');
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error setting item in storage:', err);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        get: (key)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                let item;
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    item = storageAPI.getItem(prefixedKey);
                    if (typeof item === 'undefined') {
                        // handle a case when customer has all data with keys like `__storejs__`
                        const itemFromOldStore = oldStore.get(key);
                        const stringValue = JSON.stringify(itemFromOldStore);
                        storageAPI.setItem(prefixedKey, stringValue); // migrate to new store with new key
                        return itemFromOldStore;
                    }
                } else {
                    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-hot-114899')) {
                        // handle the hot
                        const itemFromOldStore = oldStore.get(key);
                        const itemFromNewStore = store.get(prefixedKey);
                        if (typeof itemFromNewStore !== 'undefined') return JSON.parse(itemFromNewStore);
                        if (typeof itemFromOldStore !== 'undefined') {
                            const stringValue = JSON.stringify(itemFromOldStore);
                            store.set(prefixedKey, stringValue); // copy that value to new store with new key
                            return itemFromOldStore;
                        }
                        return undefined;
                    }
                    item = store.get(prefixedKey);
                }
                return item ? JSON.parse(item) : undefined;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting item from storage:', err);
                return undefined;
            }
        },
        remove: (key)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    storageAPI.removeItem(prefixedKey); // remove data from new store
                    oldStore.remove(key); // remove data from old store as well
                } else {
                    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-hot-114899')) oldStore.remove(key);
                    store.remove(prefixedKey);
                }
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error removing item from storage:', err);
            }
        },
        clearAll: ()=>{
            if (!appPrefix) throw Error("appPrefix is necessary to access clearAll method. It's used to separate apps.");
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    for(let i = 0; i < storageAPI.length(); i++){
                        const key = storageAPI.key(i);
                        if (key && key.startsWith(`${appPrefix}.`)) {
                            storageAPI.removeItem(key);
                            i--;
                        }
                    }
                    oldStore.clearAll(); // clear old store as well
                } else {
                    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-hot-114899')) oldStore.clearAll();
                    store.clearAll();
                }
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        },
        length: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) return storageAPI.length();
                throw Error('Method length is not supported.');
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting storage length:', err);
            }
        }
    };
};
const $04caddce42518619$export$b793a81cf479272a = (storageType, appPrefix, // eslint-disable-next-line @typescript-eslint/no-explicit-any
store)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const oldStore = store.namespace(appPrefix);
    const getKeyWithPrefix = (key)=>`${appPrefix}.${key}`;
    const storageAPI = storageType === $04caddce42518619$export$259e3a861f28589b.LocalStorage ? (0, $1ohWS.AtlBrowserStorageLocal) : (0, $1ohWS.AtlBrowserStorageSession);
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set: (key, value, expiration)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                const item = {
                    value: value,
                    expiration: expiration
                };
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) storageAPI.setItem(prefixedKey, JSON.stringify(item));
                else {
                    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-hot-114899')) // handle the hot,write to old store as well
                    oldStore.set(key, value, expiration);
                    store.set(prefixedKey, JSON.stringify(item));
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, error);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setStrictlyNecessaryItem: (key, value, expiration)=>{
            try {
                const item = {
                    value: value,
                    expiration: expiration
                };
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) storageAPI.setStrictlyNecessaryItem(getKeyWithPrefix(key), JSON.stringify(item));
                else throw Error('Method setStrictlyNecessaryItem is not supported.');
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, error);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        get: (key)=>{
            const prefixedKey = getKeyWithPrefix(key);
            try {
                let itemStr;
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    itemStr = storageAPI.getItem(prefixedKey);
                    if (!itemStr) {
                        // check in the old store
                        const itemFromOldStore = oldStore.get(key);
                        if (typeof itemFromOldStore !== 'undefined') {
                            const item = {
                                value: itemFromOldStore,
                                expiration: oldStore.getExpiration(key)
                            };
                            storageAPI.setItem(prefixedKey, JSON.stringify(item)); // migrate to new store with new key
                            return itemFromOldStore;
                        }
                    }
                } else if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-hot-114899')) {
                    // handle the hot
                    const itemFromOldStore = oldStore.get(key);
                    const itemFromNewStore = store.get(prefixedKey);
                    if (typeof itemFromNewStore !== 'undefined') itemStr = itemFromNewStore;
                    else if (typeof itemFromOldStore !== 'undefined') {
                        const expiration = oldStore.getExpiration(key);
                        const item = {
                            value: itemFromOldStore,
                            expiration: expiration
                        };
                        store.set(prefixedKey, JSON.stringify(item)); // copy that value to new store with new key
                        return itemFromOldStore;
                    }
                } else itemStr = store.get(prefixedKey);
                if (!itemStr) return undefined;
                const item = JSON.parse(itemStr);
                if (!item.expiration || item.expiration >= Date.now()) return item.value;
                storageAPI.removeItem(prefixedKey);
                return undefined;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error getting item with key=${key}:`, error);
                return undefined;
            }
        },
        getExpiration: (key)=>{
            const prefixedKey = getKeyWithPrefix(key);
            try {
                let itemStr;
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    itemStr = storageAPI.getItem(prefixedKey);
                    if (!itemStr) {
                        // check in the old store
                        const itemFromOldStore = oldStore.get(key);
                        if (typeof itemFromOldStore !== 'undefined') {
                            const expiration = oldStore.getExpiration(key);
                            const item = {
                                value: itemFromOldStore,
                                expiration: expiration
                            };
                            storageAPI.setItem(prefixedKey, JSON.stringify(item)); // migrate to new store with new key
                            return expiration;
                        }
                    }
                } else if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-hot-114899')) {
                    // handle the hot
                    const itemFromOldStore = oldStore.get(key);
                    const itemFromNewStore = store.get(prefixedKey);
                    if (typeof itemFromNewStore !== 'undefined') itemStr = itemFromNewStore;
                    else if (typeof itemFromOldStore !== 'undefined') {
                        const expiration = oldStore.getExpiration(key);
                        const item = {
                            value: itemFromOldStore,
                            expiration: expiration
                        };
                        store.set(prefixedKey, JSON.stringify(item)); // copy that value to new store with new key
                        return expiration;
                    }
                } else itemStr = store.get(prefixedKey);
                if (!itemStr) return undefined;
                const item = JSON.parse(itemStr);
                if (item.expiration && item.expiration >= Date.now()) return item.expiration;
                storageAPI.removeItem(prefixedKey);
                return undefined;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error getting expiration for item with key=${key}:`, error);
                return undefined;
            }
        },
        remove: (key)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    storageAPI.removeItem(prefixedKey);
                    oldStore.remove(key);
                } else {
                    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-hot-114899')) oldStore.remove(key);
                    store.remove(prefixedKey);
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error removing item with key=${key}:`, error);
            }
        },
        removeExpiredKeys: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    for(let i = 0; i < storageAPI.length(); i++){
                        const key = storageAPI.key(i);
                        if (key && key.startsWith(`${appPrefix}.`)) {
                            const itemStr = storageAPI.getItem(key);
                            if (itemStr) {
                                const item = JSON.parse(itemStr);
                                if (item.expiration && item.expiration < Date.now()) {
                                    storageAPI.removeItem(key);
                                    i--;
                                }
                            }
                        }
                    }
                    oldStore.removeExpiredKeys(); // clean up old keys too
                } else {
                    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-hot-114899')) oldStore.removeExpiredKeys();
                    store.removeExpiredKeys();
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error removing expired keys:', error);
            }
        },
        clearAll: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) {
                    for(let i = 0; i < storageAPI.length(); i++){
                        const key = storageAPI.key(i);
                        if (key && key.startsWith(`${appPrefix}.`)) {
                            storageAPI.removeItem(key);
                            i--;
                        }
                    }
                    oldStore.clearAll();
                } else {
                    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-hot-114899')) oldStore.clearAll();
                    store.clearAll();
                }
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        },
        length: ()=>{
            try {
                if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-providers')) return storageAPI.length();
                throw Error('Method length is not supported.');
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting storage length:', err);
            }
        }
    };
};

});
parcelRegister("c7J1U", function(module, exports) {

$parcel$export(module.exports, "default", () => $99d922a6a243a194$export$2e2bcd8739ae039);

var $jcw0u = parcelRequire("jcw0u");

var $cuNKJ = parcelRequire("cuNKJ");
/**
 * Enhances storage operations with automated cleanup capabilities. This includes tracking
 * item timestamps for age-based cleanup, handling storage limits by removing older items,
 * and providing utility functions for managing storage contents. Designed to ensure
 * efficient use of storage space without manual intervention.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $99d922a6a243a194$var$cleanUpPlugin() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, $cuNKJ.NAMESPACE));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function set(superFn, key, val) {
        try {
            if (!self.hasNamespace((0, $cuNKJ.NAMESPACE))) timestamps.set(key, Date.now());
            superFn();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // storage is full. Relevant only for localStorage
            if (e.code === (0, $cuNKJ.LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, $cuNKJ.LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                // 22 - the correct code most browsers use
                // 1014 - Firefox's code
                (0, $jcw0u.default)({
                    meta: {
                        id: 'browserLocalStorageFullError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        namespace: self._namespacePrefix
                    },
                    error: e,
                    skipSentry: true
                });
                if (self.cleanWhenFull()) self.set(superFn, key, val);
            } else {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'storageCleanupPluginError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        isLegacyFunction: false
                    },
                    error: e
                });
                throw e;
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function remove(superFn, key) {
        if (!self.hasNamespace((0, $cuNKJ.NAMESPACE))) timestamps.remove(key);
        return superFn();
    }
    // quite stupid way of getting totals, but current library supports only this.each()
    function getTotalCount() {
        let count = 0;
        self.each(()=>{
            count += 1;
        });
        return count;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function cleanWhenFull(superFn, minAge = (0, $cuNKJ.FOUR_WEEKS)) {
        const currTime = Date.now();
        const numKeysBefore = self.getTotalCount();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        self.each((_value, key)=>{
            // return correct value for current collection
            // and return null for timestamps collection
            const created = !self.hasNamespace((0, $cuNKJ.NAMESPACE)) ? timestamps.get(key) : null;
            if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
        });
        const itemsRemovedCount = numKeysBefore - self.getTotalCount();
        if (!itemsRemovedCount && minAge - (0, $cuNKJ.ONE_WEEK) >= (0, $cuNKJ.ONE_WEEK)) return self.cleanWhenFull(minAge - (0, $cuNKJ.ONE_WEEK));
        return itemsRemovedCount === 0;
    }
    return {
        set: set,
        remove: remove,
        cleanWhenFull: cleanWhenFull,
        getTotalCount: getTotalCount
    };
}
var $99d922a6a243a194$export$2e2bcd8739ae039 = $99d922a6a243a194$var$cleanUpPlugin;

});
parcelRegister("cuNKJ", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE", () => $d21613ddd27d5bbf$export$6aad947bda0f3f46);
$parcel$export(module.exports, "ONE_WEEK", () => $d21613ddd27d5bbf$export$8187f416f1cc43d8);
$parcel$export(module.exports, "FOUR_WEEKS", () => $d21613ddd27d5bbf$export$6e952fa7d47190cf);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", () => $d21613ddd27d5bbf$export$da99ebca8f453abd);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", () => $d21613ddd27d5bbf$export$ea28dfd9333cda2d);
const $d21613ddd27d5bbf$export$6aad947bda0f3f46 = 'timestamps';
const $d21613ddd27d5bbf$export$8187f416f1cc43d8 = 604800000;
const $d21613ddd27d5bbf$export$6e952fa7d47190cf = 4 * $d21613ddd27d5bbf$export$8187f416f1cc43d8;
const $d21613ddd27d5bbf$export$da99ebca8f453abd = 22;
const $d21613ddd27d5bbf$export$ea28dfd9333cda2d = 1014;

});



parcelRegister("dEJQ9", function(module, exports) {

$parcel$export(module.exports, "makeLocalStore", () => $dcae70c06981fc99$export$b2631085fe8db7af);
$parcel$export(module.exports, "isLocalStorageAvailable", () => $dcae70c06981fc99$export$117a30df0da2af20);
$parcel$export(module.exports, "makeLocalExpirableStore", () => $dcae70c06981fc99$export$cf816b43e73de947);

var $fKgem = parcelRequire("fKgem");

var $kzObv = parcelRequire("kzObv");

var $c4CII = parcelRequire("c4CII");

var $4Zgux = parcelRequire("4Zgux");

var $2NjNT = parcelRequire("2NjNT");

var $fNVZf = parcelRequire("fNVZf");
const $dcae70c06981fc99$export$b2631085fe8db7af = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($4Zgux))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], (0, $fNVZf.plugins));
const $dcae70c06981fc99$export$117a30df0da2af20 = ()=>typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
const $dcae70c06981fc99$export$cf816b43e73de947 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($4Zgux))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($fKgem))),
        (0, (/*@__PURE__*/$parcel$interopDefault($kzObv)))
    ]);

});





parcelRegister("eOlBz", function(module, exports) {

$parcel$export(module.exports, "newIssueViewTransitionLockInStatusResource", () => $4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c);
$parcel$export(module.exports, "DEFAULT_TO_OLD_ISSUE_VIEW", () => $4e2e5fcdbf62dfaf$export$f269c0bf10ad77e2);
$parcel$export(module.exports, "useNewIssueViewLockedInStatus", () => $4e2e5fcdbf62dfaf$export$3b09097f2a423abd);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c = (0, $2M1hQ.createResource)({
    type: (0, $103a13dfd187b85c$export$fdb92aeacda42553),
    getKey: ()=>'newIssueViewTransitionLockingStatus',
    getDataLoader: ()=>(parcelRequire("4zEYO")),
    maxAge: Number.MAX_VALUE
});
const $4e2e5fcdbf62dfaf$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
const $4e2e5fcdbf62dfaf$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
const $4e2e5fcdbf62dfaf$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';
const $4e2e5fcdbf62dfaf$export$3b09097f2a423abd = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $2YP9W.useResource)($4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c);

});
const $103a13dfd187b85c$export$fdb92aeacda42553 = 'NEW_ISSUE_VIEW_LOCK_IN_STATUS';

parcelRegister("4zEYO", function(module, exports) {

let $354a380b35f18deb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $354a380b35f18deb$var$load("bDo1N").then(()=>parcelRequire('2RVA3'));

});


parcelRegister("3X1Xr", function(module, exports) {

$parcel$export(module.exports, "persistentIssueCreateModalViewResource", () => $950f2f2a5a65ba3f$export$266a039a005e8314);

var $2M1hQ = parcelRequire("2M1hQ");


const $950f2f2a5a65ba3f$export$266a039a005e8314 = (0, $2M1hQ.createResource)({
    type: (0, $fa76c7a777da2375$export$f658cfd591eb583e),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("imuoK")),
    maxAge: Number.MAX_VALUE
});

});
const $fa76c7a777da2375$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $fa76c7a777da2375$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $fa76c7a777da2375$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';

parcelRegister("imuoK", function(module, exports) {

let $d5e1dc84b8193e61$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d5e1dc84b8193e61$var$load("1Kt13").then(()=>parcelRequire('8FYIq'));

});


parcelRegister("dxCvy", function(module, exports) {

$parcel$export(module.exports, "projectContextResource", () => $fb0493b5a465ed74$export$27ad0d75c619be68);
$parcel$export(module.exports, "projectContextResourceWithCache", () => $fb0493b5a465ed74$export$d75816e37af81473);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");


const $fb0493b5a465ed74$var$getDataLoader = ()=>(parcelRequire("d9Fd3"));
const $fb0493b5a465ed74$export$27ad0d75c619be68 = (0, $2M1hQ.createResource)({
    type: (0, $0f463a88567f1621$export$80a60a092d9ab81),
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return projectKey || projectId;
    },
    getDataLoader: $fb0493b5a465ed74$var$getDataLoader,
    maxAge: 1800000
});
const $fb0493b5a465ed74$export$d75816e37af81473 = $fb0493b5a465ed74$export$27ad0d75c619be68;

});
const $0f463a88567f1621$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

parcelRegister("d9Fd3", function(module, exports) {

let $993c150105f6ec4c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $993c150105f6ec4c$var$load("7UkBG").then(()=>parcelRequire('fsLhR'));

});


parcelRegister("4dc0x", function(module, exports) {

$parcel$export(module.exports, "fetchSiteTraitsResource", () => $6bcb8e2c3d1b4192$export$379923e7c903a55d);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $3HwlS = parcelRequire("3HwlS");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");

var $e5wyW = parcelRequire("e5wyW");

var $jX0pr = parcelRequire("jX0pr");


const $6bcb8e2c3d1b4192$var$getDataOld = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}`;
        const clientUrl = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
        const response = false ? await (0, $eusud.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }) : await (0, $eusud.performGetRequest)(clientUrl);
        if (response?.attributes) return response.attributes;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: (0, $ecc0251f1d9f8566$export$7f111648ca05f056),
                packageName: (0, $2ffc5f2215c16253$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $6bcb8e2c3d1b4192$var$getDataNew = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}`;
        const response = false ? (await (0, $eusud.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }))?.attributes : await (0, $jX0pr.memoizedFetchSitePersonalization)({
            cloudId: cloudId
        });
        if (response) return response;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: (0, $ecc0251f1d9f8566$export$7f111648ca05f056),
                packageName: (0, $2ffc5f2215c16253$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $6bcb8e2c3d1b4192$export$379923e7c903a55d = (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('blu-3929-sidebar-menu-recommended'), (0, $2M1hQ.createResource)({
    type: (0, $ecc0251f1d9f8566$export$6f0555de4f60e84e),
    getKey: ()=>(0, $ecc0251f1d9f8566$export$7e7d7930e22ba39f),
    getData: (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('site-trait-iv-llc-unnecessary-api'), $6bcb8e2c3d1b4192$var$getDataNew, $6bcb8e2c3d1b4192$var$getDataOld),
    maxAge: Number.MAX_VALUE
}));

});
parcelRegister("e5wyW", function(module, exports) {

$parcel$export(module.exports, "functionWithCondition", () => $12199147dc0ae1fa$export$af3c0e82a18fc057);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $12199147dc0ae1fa$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $12199147dc0ae1fa$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $12199147dc0ae1fa$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});

parcelRegister("jX0pr", function(module, exports) {

$parcel$export(module.exports, "memoizedFetchSitePersonalization", () => $7b32fa3ce5d65e32$export$671fb03be30194c3);
$parcel$export(module.exports, "useSitePersonalization", () => $7b32fa3ce5d65e32$export$58982988039b926f);

var $8QpSo = parcelRequire("8QpSo");

var $ld2hZ = parcelRequire("ld2hZ");

var $7f4tk = parcelRequire("7f4tk");
const $7b32fa3ce5d65e32$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $7b32fa3ce5d65e32$export$ddf4964d2a406b6a = async ({ cloudId: cloudId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    const { attributes: attributes } = await (0, $7f4tk.default)($7b32fa3ce5d65e32$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $7b32fa3ce5d65e32$export$671fb03be30194c3 = (0, $8QpSo.default)($7b32fa3ce5d65e32$export$ddf4964d2a406b6a, ([{ cloudId: newCloudId }], [{ cloudId: lastCloudId }])=>newCloudId === lastCloudId);
const $7b32fa3ce5d65e32$export$58982988039b926f = ()=>(0, $ld2hZ.useService)($7b32fa3ce5d65e32$export$671fb03be30194c3);

});
parcelRegister("ld2hZ", function(module, exports) {

$parcel$export(module.exports, "useService", () => $b3ad55f76ff82cb6$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useLoadingStatusService", () => $b3ad55f76ff82cb6$export$c963713a27525aaf);

var $5uXOq = parcelRequire("5uXOq");
const $b3ad55f76ff82cb6$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setState] = (0, $5uXOq.useState)({
        loading: false,
        data: undefined,
        error: undefined,
        ...initialState
    });
    const fetch = (0, $5uXOq.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                loading: false,
                error: undefined,
                data: data
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
            return undefined;
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};
const $b3ad55f76ff82cb6$export$c963713a27525aaf = (request, initialState = {})=>{
    const [loadingStatus, setLoadingStatus] = (0, $5uXOq.useState)('idle');
    const { data: data, loading: loading, error: error, fetch: fetch } = $b3ad55f76ff82cb6$export$6de4685a6c88b4e9(request, initialState);
    (0, $5uXOq.useEffect)(()=>{
        if (loading) setLoadingStatus('started');
        else if (error) setLoadingStatus('error');
        else if (data) setLoadingStatus('success');
    }, [
        data,
        loading,
        error
    ]);
    return {
        data: data,
        loadingStatus: loadingStatus,
        error: error,
        fetch: fetch
    };
};

});


const $2ffc5f2215c16253$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGrowthRecommendations';

const $ecc0251f1d9f8566$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_SITE_TRAITS';
const $ecc0251f1d9f8566$export$7e7d7930e22ba39f = 'recommendations-fetch-site-traits-resource-key';
const $ecc0251f1d9f8566$export$7f111648ca05f056 = 'useResource.fetchRecommendationsSiteTraits';


parcelRegister("51Yl2", function(module, exports) {

$parcel$export(module.exports, "fetchUserTraitsResource", () => $7ddcc0e078ed27cf$export$d5198d02e9089545);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $3HwlS = parcelRequire("3HwlS");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");

var $8ilPk = parcelRequire("8ilPk");

var $e5wyW = parcelRequire("e5wyW");


const $7ddcc0e078ed27cf$var$getDataOld = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const accountId = tenantContext.atlassianAccountId;
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const clientUrl = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const response = false ? await (0, $eusud.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }) : await (0, $eusud.performGetRequest)(clientUrl);
        if (response?.attributes) return response.attributes;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: (0, $e07bc74223fe458d$export$7f111648ca05f056),
                packageName: (0, $2ffc5f2215c16253$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $7ddcc0e078ed27cf$var$getDataNew = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const accountId = tenantContext.atlassianAccountId ?? '';
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const response = false ? (await (0, $eusud.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }))?.attributes : await (0, $8ilPk.memoizedFetchSiteUserPersonalization)({
            cloudId: cloudId,
            userId: accountId
        });
        if (response) return response;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: (0, $e07bc74223fe458d$export$7f111648ca05f056),
                packageName: (0, $2ffc5f2215c16253$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $7ddcc0e078ed27cf$export$d5198d02e9089545 = (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('blu-3929-sidebar-menu-recommended'), (0, $2M1hQ.createResource)({
    type: (0, $e07bc74223fe458d$export$6f0555de4f60e84e),
    getKey: ()=>(0, $e07bc74223fe458d$export$7e7d7930e22ba39f),
    getData: (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('site-user-trait-iv-llc-unnecessary-api'), $7ddcc0e078ed27cf$var$getDataNew, $7ddcc0e078ed27cf$var$getDataOld),
    maxAge: Number.MAX_VALUE
}));

});
parcelRegister("8ilPk", function(module, exports) {

$parcel$export(module.exports, "memoizedFetchSiteUserPersonalization", () => $4ab23cf8c5a935d6$export$de93ec54b11be450);
$parcel$export(module.exports, "useSiteUserPersonalization", () => $4ab23cf8c5a935d6$export$8dc79ff315095801);

var $8QpSo = parcelRequire("8QpSo");

var $ld2hZ = parcelRequire("ld2hZ");

var $7f4tk = parcelRequire("7f4tk");
const $4ab23cf8c5a935d6$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $4ab23cf8c5a935d6$export$8f40704723ec6690 = async ({ cloudId: cloudId, userId: userId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    if (!userId) throw new Error('empty userId');
    const { attributes: attributes } = await (0, $7f4tk.default)($4ab23cf8c5a935d6$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $4ab23cf8c5a935d6$export$de93ec54b11be450 = (0, $8QpSo.default)($4ab23cf8c5a935d6$export$8f40704723ec6690, ([{ cloudId: newCloudId, userId: newUserId }], [{ cloudId: lastCloudId, userId: lastUserId }])=>newCloudId === lastCloudId && newUserId === lastUserId);
const $4ab23cf8c5a935d6$export$8dc79ff315095801 = ()=>(0, $ld2hZ.useService)($4ab23cf8c5a935d6$export$de93ec54b11be450);

});

const $e07bc74223fe458d$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_USER_TRAITS';
const $e07bc74223fe458d$export$7e7d7930e22ba39f = 'recommendations-fetch-traits-resource-key';
const $e07bc74223fe458d$export$7f111648ca05f056 = 'useResource.fetchRecommendationsUserTraits';


parcelRegister("lXNZG", function(module, exports) {

$parcel$export(module.exports, "jpdRecommendationDismissedResource", () => $5630a429b63403f9$export$5db7c4562b672f52);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $3HwlS = parcelRequire("3HwlS");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");


const $5630a429b63403f9$export$5db7c4562b672f52 = (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('blu-3929-sidebar-menu-recommended'), (0, $2M1hQ.createResource)({
    type: (0, $2a8d22514dc25dbd$export$6f0555de4f60e84e),
    getKey: ()=>(0, $2a8d22514dc25dbd$export$7e7d7930e22ba39f),
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return {
                hasDismissed: true
            };
            const accountId = tenantContext.atlassianAccountId;
            const response = await (0, $eusud.performGetRequest)(`/rest/api/latest/user/properties/JpdRecommendationDismissed?accountId=${accountId}`);
            return {
                hasDismissed: response?.value ?? false
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const initialValueNeverSet = error.statusCode === 404;
            if (initialValueNeverSet) /**
					 * If the user has never set the preference, they have never dismissed.
					 */ return {
                hasDismissed: false
            };
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: (0, $2a8d22514dc25dbd$export$7f111648ca05f056),
                    packageName: (0, $2ffc5f2215c16253$export$b8b9d90f9e5bd72b)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        /* on error return true - this ensures we don't show the recommendation if we don't know if they have dismissed */ return {
            hasDismissed: true
        };
    },
    maxAge: Number.MAX_VALUE
}));

});
const $2a8d22514dc25dbd$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_DISMISSED_JPD';
const $2a8d22514dc25dbd$export$7e7d7930e22ba39f = 'recommendations-dismissed-jpd-resource-key';
const $2a8d22514dc25dbd$export$7f111648ca05f056 = 'useResource.fetchRecommendationsDismissedJpd';


parcelRegister("kkNtb", function(module, exports) {

$parcel$export(module.exports, "rovoEntitlementResource", () => $10274390833bf523$export$a0974cf24d16bc5d);
$parcel$export(module.exports, "useRovoEntitlementResource", () => $10274390833bf523$export$b9cee3799212b85a);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $4R6GH = parcelRequire("4R6GH");

const $10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT = 'ROVO_ENTITLEMENT';
const $10274390833bf523$var$fetchRovoEntitlement = async (cloudId)=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $34f68d752b7fdd6c$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    shouldShowRovoLLMEnabled: (0, $4R6GH.fg)('rovo_use_rovo_llm_enabled_check')
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        // handle GraphQL errors
        if (response.errors) (0, $jcw0u.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: new Error(`RovoEntitlement Error. ${response.errors.map((error)=>error.message).join('; ')}; IsDataEmpty=${response.data?.jira === null || response.data?.jira === undefined}`),
            sendToPrivacyUnsafeSplunk: true
        });
        const isRovoEnabled = response.data?.jira?.isRovoEnabled ?? null;
        // defaulting to isRovoEnabled if the feature flag is not enabled
        const isRovoLLMEnabled = (0, $4R6GH.fg)('rovo_use_rovo_llm_enabled_check') ? response.data?.jira_isRovoLLMEnabled ?? null : isRovoEnabled;
        return {
            isRovoEnabled: isRovoEnabled,
            isRovoLLMEnabled: isRovoLLMEnabled
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return {
        isRovoEnabled: null,
        isRovoLLMEnabled: undefined
    };
};
const $10274390833bf523$export$a0974cf24d16bc5d = (0, $2M1hQ.createResource)({
    type: $10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getKey: ()=>$10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getData: (_, { tenantContext: { cloudId: cloudId } })=>$10274390833bf523$var$fetchRovoEntitlement(cloudId),
    maxAge: Infinity
});
const $10274390833bf523$export$b9cee3799212b85a = ()=>(0, $2YP9W.useResource)($10274390833bf523$export$a0974cf24d16bc5d);

});
const $34f68d752b7fdd6c$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!, $shouldShowRovoLLMEnabled: Boolean!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	}

	jira_isRovoLLMEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence") @include(if: $shouldShowRovoLLMEnabled)
}
`;


parcelRegister("2Ql51", function(module, exports) {

$parcel$export(module.exports, "themePreferenceResource", () => $14feb59df5995657$export$e5a423d1eb1cf1d0);
$parcel$export(module.exports, "useThemePreference", () => $14feb59df5995657$export$3416635c8aeb5bab);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $Y0b1l = parcelRequire("Y0b1l");

const $14feb59df5995657$var$getDataLoader = ()=>(parcelRequire("7iqTB"));
const $14feb59df5995657$export$e5a423d1eb1cf1d0 = (0, $2M1hQ.createResource)({
    type: 'RESOURCE_THEME_PREFERENCE',
    getKey: ()=>'state',
    getDataLoader: $14feb59df5995657$var$getDataLoader,
    maxAge: 300000
});
const $14feb59df5995657$export$3416635c8aeb5bab = ()=>{
    const { data: data, update: updateThemePreferenceResource } = (0, $2YP9W.useResource)($14feb59df5995657$export$e5a423d1eb1cf1d0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireThemeAnalytics = (0, $5uXOq.useCallback)((current, next)=>{
        const OStheme = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const analyticsEvent = createAnalyticsEvent({
            action: (0, $d0956fbcd917153f$export$89c5cf64ad15c3ea),
            actionSubject: (0, $d0956fbcd917153f$export$9e2cc65718a61846)
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
            newPreference: next,
            oldPreference: current,
            OStheme: OStheme
        });
    }, [
        createAnalyticsEvent
    ]);
    const setTheme = (0, $5uXOq.useCallback)(async (theme)=>{
        updateThemePreferenceResource(()=>({
                theme: theme
            }));
        if (data?.theme !== theme) {
            fireThemeAnalytics(data?.theme, theme);
            await (0, $Y0b1l.setThemePreference)(theme);
        }
    }, [
        data?.theme,
        updateThemePreferenceResource,
        fireThemeAnalytics
    ]);
    return {
        theme: data?.theme,
        setTheme: setTheme
    };
};

});
const $d0956fbcd917153f$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $d0956fbcd917153f$export$9e2cc65718a61846 = 'themePreference';
const $d0956fbcd917153f$export$89c5cf64ad15c3ea = 'changed';

parcelRegister("Y0b1l", function(module, exports) {

$parcel$export(module.exports, "setThemePreference", () => $fb319b2ef1da4e47$export$a6b84eebd33787e2);
$parcel$export(module.exports, "getThemePreference", () => $fb319b2ef1da4e47$export$2f7a12048d96237);

var $b9op4 = parcelRequire("b9op4");

var $jcw0u = parcelRequire("jcw0u");

var $aHuqL = parcelRequire("aHuqL");

const $fb319b2ef1da4e47$export$a6b84eebd33787e2 = (theme)=>{
    const promise = (0, $aHuqL.userPreferenceAPI).set((0, $d0956fbcd917153f$export$40bd77e1c9f49c27), theme);
    promise.catch((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'put',
                errName: String(error.name),
                statusCode: error.statusCode,
                param: `to:${theme}`
            }
        });
    });
    return promise;
};
const $fb319b2ef1da4e47$export$2f7a12048d96237 = async ()=>{
    const promise = (0, $aHuqL.userPreferenceAPI).get((0, $d0956fbcd917153f$export$40bd77e1c9f49c27));
    promise.catch((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'get',
                errName: String(error.name),
                statusCode: error.statusCode
            }
        });
    });
    promise.then((theme)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (theme && !(0, $b9op4.ThemeOptions).includes(theme)) // very unlikely but…
        (0, $jcw0u.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: new Error('Unrecognized theme!'),
            attributes: {
                op: 'get',
                theme: theme,
                errName: 'unrecognized value!'
            }
        });
    });
    const theme = await promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return theme && (0, $b9op4.ThemeOptions).includes(theme) ? theme : undefined;
};

});
parcelRegister("b9op4", function(module, exports) {

$parcel$export(module.exports, "ThemeOptions", () => $a1d11c8212b90b3e$export$abe7936539cefefe);
$parcel$export(module.exports, "DEFAULT_THEME", () => $a1d11c8212b90b3e$export$2faeed762aac6741);
// This type inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $a1d11c8212b90b3e$export$abe7936539cefefe = [
    'light',
    'dark',
    'auto'
];
const $a1d11c8212b90b3e$export$2faeed762aac6741 = 'light';

});


parcelRegister("7iqTB", function(module, exports) {

let $54ff13cf77e1512b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $54ff13cf77e1512b$var$load("h2MrD"),
    $54ff13cf77e1512b$var$load("bYT2S"),
    $54ff13cf77e1512b$var$load("5DvFw")
]).then(()=>parcelRequire('jyeNt'));

});


parcelRegister("9vlEn", function(module, exports) {

$parcel$export(module.exports, "userHomepageResource", () => $ea929e6a42e03883$export$16320dd0d1e6c145);

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");

const $ea929e6a42e03883$export$16320dd0d1e6c145 = (0, $2M1hQ.createResource)({
    type: (0, $a4d0f361741078de$export$2026a6db44b15de7),
    getKey: ()=>'state',
    getData: async (_, { tenantContext: { baseUrl: baseUrl } })=>{
        const { homepagePreference: homepagePreference } = await (0, $eusud.performGetRequest)(`${baseUrl}/rest/internal/3/homepage/`);
        return {
            homepagePreference: homepagePreference
        };
    },
    maxAge: Infinity
});

});
const $a4d0f361741078de$export$2026a6db44b15de7 = 'USER_HOMEPAGE';


parcelRegister("5pSYQ", function(module, exports) {

$parcel$export(module.exports, "postOfficeJiraSideNavResource", () => $e6f7d661dd665dbf$export$5fd5ab86e70497f7);
$parcel$export(module.exports, "postOfficeJiraYourWorkResource", () => $e6f7d661dd665dbf$export$5969dfe9b3b29cd3);
$parcel$export(module.exports, "postOfficeJiraTopBannerResource", () => $e6f7d661dd665dbf$export$af242b8c8ffaab42);
$parcel$export(module.exports, "conditionalPostOfficeJiraTopBannerResource", () => $e6f7d661dd665dbf$export$d1df0b3b482d298d);
// eslint-disable-next-line jira/import-whitelist

var $fyLzM = parcelRequire("fyLzM");

var $2M1hQ = parcelRequire("2M1hQ");

var $gNStA = parcelRequire("gNStA");

var $4R6GH = parcelRequire("4R6GH");
const $e6f7d661dd665dbf$export$fd097948b42db8d3 = (0, $2M1hQ.createResource)({
    type: 'POST_OFFICE_PLACEMENT__SCREEN_SPACE_FLAGS',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        return (0, $fyLzM.preloadPostOfficePlacementWithTenantContext)('screen-space-flags', tenantContext);
    },
    maxAge: Infinity
});
const $e6f7d661dd665dbf$export$5fd5ab86e70497f7 = (0, $2M1hQ.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_SIDE_NAV',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $fyLzM.preloadPostOfficePlacementWithTenantContext)('jira-side-nav', tenantContext);
    },
    maxAge: Infinity
});
const $e6f7d661dd665dbf$export$5969dfe9b3b29cd3 = (0, $2M1hQ.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_YOUR_WORK',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $fyLzM.preloadPostOfficePlacementWithTenantContext)('jira-your-work', tenantContext);
    },
    maxAge: Infinity
});
const $e6f7d661dd665dbf$export$af242b8c8ffaab42 = (0, $2M1hQ.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_TOP_BANNER',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isSiteAdmin: isSiteAdmin } = tenantContext;
        if (isSiteAdmin) return (0, $fyLzM.preloadPostOfficePlacementWithTenantContext)('jira-top-banner', tenantContext);
        return null;
    },
    maxAge: Infinity
});
const $e6f7d661dd665dbf$export$d1df0b3b482d298d = (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jira-issue-term-refresh-banner'), $e6f7d661dd665dbf$export$af242b8c8ffaab42);

});
parcelRegister("fyLzM", function(module, exports) {

$parcel$export(module.exports, "usePlacementSSRFetch", () => $121a6aea82ff4ae0$export$420f2f91a928b3b6);
$parcel$export(module.exports, "preloadPostOfficePlacementWithTenantContext", () => $121a6aea82ff4ae0$export$65b5eab182e1ca6f);

var $5uXOq = parcelRequire("5uXOq");

var $kBATP = parcelRequire("kBATP");

var $2eHYz = parcelRequire("2eHYz");

var $2YP9W = parcelRequire("2YP9W");

var $adncp = parcelRequire("adncp");
const $121a6aea82ff4ae0$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $121a6aea82ff4ae0$export$b3732c8ff6f9c463 = (res)=>{
    if (typeof res === 'undefined') throw new Error('No response from server');
    if (res.ok) return res;
    throw new Error($121a6aea82ff4ae0$export$18a0019e5439b209(res));
};
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $121a6aea82ff4ae0$var$preloadPostOfficePlacement = async (placementId, contextOptions)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    const jiraFetcherWithS2SHeaders = async (url)=>{
        let hostEnv = 'prod';
        if (environment.currentEnv !== 'production') hostEnv = 'staging';
        const fetchHeaders = {
            'x-ssr-service-name': 'post-office',
            'x-ssr-service-env': hostEnv
        };
        return (0, $2eHYz.defaultFetcher)(url.replace('gateway/api/post-office/', ''), fetchHeaders);
    };
    return (0, $2eHYz.requestInitialData)(placementId, postOfficeContext, false ? jiraFetcherWithS2SHeaders : undefined, (0, $kBATP.buildBasePath)(environment.currentEnv, environment.envConfigs)).then($121a6aea82ff4ae0$export$b3732c8ff6f9c463).then((res)=>res.json());
};
const $121a6aea82ff4ae0$export$420f2f91a928b3b6 = (resource)=>{
    const { data: data } = (0, $2YP9W.useResource)(resource);
    return (0, $5uXOq.useCallback)(()=>{
        if (data) {
            /**
			 * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
			 * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
			 */ const init = {
                status: 200,
                statusText: 'ok!'
            };
            return Promise.resolve(new Response(JSON.stringify(data), init));
        }
    }, [
        data
    ]);
};
const $121a6aea82ff4ae0$export$65b5eab182e1ca6f = async (placementId, preloadedTenantContext)=>{
    return $121a6aea82ff4ae0$var$preloadPostOfficePlacement(placementId, {
        postOfficeContext: (0, $adncp.tenantToPostOfficeContext)(preloadedTenantContext),
        environment: {
            currentEnv: (0, $adncp.transformJiraEnvToPostOfficeEnvironment)(preloadedTenantContext.environment)
        }
    });
};

});
parcelRegister("kBATP", function(module, exports) {

$parcel$export(module.exports, "buildBasePath", () => $3b58e0e6cbbeb7a4$export$e8b30f9c4a80230f);


var $k9ais = parcelRequire("k9ais");
const $3b58e0e6cbbeb7a4$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $k9ais.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $1714e508ecc83ea8$export$d4fe3482c88e73a8);
    return {
        baseUrl: baseUrl,
        path: path
    };
};

});
var $1714e508ecc83ea8$exports = {};

$parcel$export($1714e508ecc83ea8$exports, "API_ORIGIN_LOCAL", () => $1714e508ecc83ea8$export$1e9fed4c0197724c);
$parcel$export($1714e508ecc83ea8$exports, "API_PATHNAME_LOCAL", () => $1714e508ecc83ea8$export$919a9569bce66f17);
$parcel$export($1714e508ecc83ea8$exports, "API_PATHNAME_STG_PROD", () => $1714e508ecc83ea8$export$d4fe3482c88e73a8);
$parcel$export($1714e508ecc83ea8$exports, "REMOTE_MODULE_URI_LOCAL", () => $1714e508ecc83ea8$export$67be2569ef5d7666);
$parcel$export($1714e508ecc83ea8$exports, "REMOTE_MODULE_URI_STG", () => $1714e508ecc83ea8$export$b49738b89db261cd);
$parcel$export($1714e508ecc83ea8$exports, "REMOTE_MODULE_URI_PROD", () => $1714e508ecc83ea8$export$bbd96cd490b0df63);
const $1714e508ecc83ea8$export$1e9fed4c0197724c = 'http://localhost:8081';
const $1714e508ecc83ea8$export$919a9569bce66f17 = '/api/v1/placements/';
const $1714e508ecc83ea8$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $1714e508ecc83ea8$export$67be2569ef5d7666 = 'http://localhost:9009';
const $1714e508ecc83ea8$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $1714e508ecc83ea8$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';

parcelRegister("k9ais", function(module, exports) {

$parcel$export(module.exports, "defaultEnvironmentValues", () => $c4e64743392fadee$export$b4ede87479bfcf09);
$parcel$export(module.exports, "PostOfficeEnvironmentProvider", () => $c4e64743392fadee$export$604607f913ef367c);
$parcel$export(module.exports, "usePostOfficeEnvironment", () => $c4e64743392fadee$export$877b97169cc75e8b);

var $5uXOq = parcelRequire("5uXOq");

const $c4e64743392fadee$export$b4ede87479bfcf09 = {
    currentEnv: 'local',
    envConfigs: {
        test: {
            remoteModule: {
                origin: (0, $1714e508ecc83ea8$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $1714e508ecc83ea8$export$1e9fed4c0197724c),
                pathname: (0, $1714e508ecc83ea8$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        local: {
            remoteModule: {
                origin: (0, $1714e508ecc83ea8$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $1714e508ecc83ea8$export$1e9fed4c0197724c),
                pathname: (0, $1714e508ecc83ea8$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        dev: {
            remoteModule: {
                origin: (0, $1714e508ecc83ea8$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $1714e508ecc83ea8$export$1e9fed4c0197724c),
                pathname: (0, $1714e508ecc83ea8$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        staging: {
            remoteModule: {
                origin: (0, $1714e508ecc83ea8$export$b49738b89db261cd),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $1714e508ecc83ea8$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        'stg-fedm-east': {
            remoteModule: {
                origin: (0, $1714e508ecc83ea8$export$b49738b89db261cd),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $1714e508ecc83ea8$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        production: {
            remoteModule: {
                origin: (0, $1714e508ecc83ea8$export$bbd96cd490b0df63),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $1714e508ecc83ea8$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        'prod-fedm-east': {
            remoteModule: {
                origin: (0, $1714e508ecc83ea8$export$bbd96cd490b0df63),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $1714e508ecc83ea8$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        }
    }
};
const $c4e64743392fadee$export$fceca2c399b32565 = (0, $5uXOq.createContext)($c4e64743392fadee$export$b4ede87479bfcf09);
const $c4e64743392fadee$export$604607f913ef367c = $c4e64743392fadee$export$fceca2c399b32565.Provider;
const $c4e64743392fadee$export$877b97169cc75e8b = ()=>(0, $5uXOq.useContext)($c4e64743392fadee$export$fceca2c399b32565);

});


parcelRegister("2eHYz", function(module, exports) {

$parcel$export(module.exports, "defaultFetcher", () => $c01534d80bdf0f6b$export$77754e0ac9f8aba3);
$parcel$export(module.exports, "requestInitialData", () => $c01534d80bdf0f6b$export$c4c39037cc4b06ab);
const $c01534d80bdf0f6b$export$77754e0ac9f8aba3 = (url, headers)=>fetch(url, {
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json',
            ...headers
        }
    });
const $c01534d80bdf0f6b$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $c01534d80bdf0f6b$export$77754e0ac9f8aba3, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};

});

parcelRegister("adncp", function(module, exports) {

$parcel$export(module.exports, "tenantToPostOfficeContext", () => $8d0bdd2f51e19696$export$d8f2c334a0924146);
$parcel$export(module.exports, "subproductToEdition", () => $8d0bdd2f51e19696$export$2d690d13b91ea44f);
$parcel$export(module.exports, "transformJiraEnvToPostOfficeEnvironment", () => $8d0bdd2f51e19696$export$cfacfecb20987ff1);

var $8dYib = parcelRequire("8dYib");
const $8d0bdd2f51e19696$var$JIRA_PRODUCT = 'jira';
const $8d0bdd2f51e19696$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $8d0bdd2f51e19696$var$JIRA_PRODUCT,
    locale: 'en'
};
const $8d0bdd2f51e19696$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return (0, $8dYib.JiraWorkspaceAri).create({
        activationId: activationId,
        siteId: cloudId
    }).toString();
};
const $8d0bdd2f51e19696$export$d8f2c334a0924146 = (tenantData)=>{
    const { activationId: activationId, cloudId: cloudId, isSiteAdmin: isSiteAdmin, locale: locale } = tenantData;
    const workspaceAri = $8d0bdd2f51e19696$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$8d0bdd2f51e19696$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        isSiteAdmin: isSiteAdmin,
        tenantId: cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        orgId: undefined,
        subproduct: undefined,
        productEdition: undefined
    };
};
const $8d0bdd2f51e19696$export$2d690d13b91ea44f = (subproduct, editions)=>{
    switch(subproduct){
        case 'core':
            return editions.core;
        case 'software':
            return editions.software;
        case 'customerService':
            return editions.customerService;
        case 'serviceDesk':
            return editions.serviceDesk;
        default:
            undefined;
    }
};
const $8d0bdd2f51e19696$export$cfacfecb20987ff1 = (environment)=>{
    switch(environment){
        case 'dev':
        case 'staging':
            return 'staging';
        case 'prod':
            return 'production';
        case 'local':
            return 'local';
        default:
            return 'local';
    }
};

});
parcelRegister("8dYib", function(module, exports) {

$parcel$export(module.exports, "JiraWorkspaceAri", () => $5fce4e6fa5e3542e$export$d4d0794234e3fd53);

var $b1EkX = parcelRequire("b1EkX");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/workspace/manifest.ts
var $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $b1EkX.JiraWorkspaceAriResourceOwner),
    resourceType: (0, $b1EkX.JiraWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/jira/workspace/index.ts
var $5fce4e6fa5e3542e$export$d4d0794234e3fd53 = class _JiraWorkspaceAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $5fce4e6fa5e3542e$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
};

});
parcelRegister("b1EkX", function(module, exports) {

$parcel$export(module.exports, "JiraWorkspaceAriResourceOwner", () => $806f13cc47cff352$export$e52ccdf6abac8896);
$parcel$export(module.exports, "JiraWorkspaceAriResourceType", () => $806f13cc47cff352$export$669cd5f7b3746bb);
// src/jira/workspace/types.ts
var $806f13cc47cff352$export$e52ccdf6abac8896 = "jira", $806f13cc47cff352$export$669cd5f7b3746bb = "workspace";

});






parcelRegister("emDul", function(module, exports) {

$parcel$export(module.exports, "globalSettingsContactAdministratorRoute", () => $f70c16094aab0919$export$146910ddc36bf151);
const $f70c16094aab0919$export$146910ddc36bf151 = {
    name: 'global-settings-contact-administrator',
    path: '/jira/contact-administrator'
};

});

parcelRegister("ksIuv", function(module, exports) {

$parcel$export(module.exports, "LazyContactAdministratorPage", () => $817988e9accf1b9b$export$bf75747a931b9a2b);
$parcel$export(module.exports, "default", () => $817988e9accf1b9b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $817988e9accf1b9b$export$bf75747a931b9a2b = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eeyy6"))), {
    moduleId: "./src/packages/admin-pages/contact-administrator/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$817988e9accf1b9b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $817988e9accf1b9b$export$bf75747a931b9a2b,
        pageId: "jira-admin-pages-contact-administrator",
        shouldShowSpinner: true
    });

});
parcelRegister("7yO8g", function(module, exports) {

$parcel$export(module.exports, "markAsProductBundleReady", () => $beda9c6123873bbb$export$ff83c57004505abd);

var $2SVPM = parcelRequire("2SVPM");
const $beda9c6123873bbb$export$ff83c57004505abd = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        (0, $2SVPM.setProductBundleReadyForInitialRender)();
    });
    return importedBundle;
};

});

parcelRegister("5j7Th", function(module, exports) {

$parcel$export(module.exports, "LazyPage", () => $63937a96c08aaddb$export$a18c9c3dd309b8e6);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $dJl1T = parcelRequire("dJl1T");

var $lfTZh = parcelRequire("lfTZh");

var $6jY6G = parcelRequire("6jY6G");

var $7LpuY = parcelRequire("7LpuY");

var $dZw8H = parcelRequire("dZw8H");
const $63937a96c08aaddb$var$LOCATION = 'lazy-page';
const $63937a96c08aaddb$export$fb85bbdbfb3e6869 = ()=>null;
const $63937a96c08aaddb$export$a18c9c3dd309b8e6 = ({ pageId: pageId, Page: Page, shouldShowSpinner: shouldShowSpinner = true })=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const Skeleton = route.skeleton || (shouldShowSpinner ? (0, $kb4zh.default) : $63937a96c08aaddb$export$fb85bbdbfb3e6869);
    (0, $5uXOq.useEffect)(()=>{
        if (route.isRedirect) (0, $dJl1T.default).safeWarnWithoutCustomerData($63937a96c08aaddb$var$LOCATION, `LazyPage was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy_page_redirect",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Page, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7LpuY.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy_page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Page, null))));
};

});
parcelRegister("kb4zh", function(module, exports) {

$parcel$export(module.exports, "default", () => $c26967b2e10d397c$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8iquX = parcelRequire("8iquX");

var $clxo5 = parcelRequire("clxo5");
function $c26967b2e10d397c$export$2e2bcd8739ae039({ testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iquX.default), {
        name: "legacy-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c26967b2e10d397c$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c26967b2e10d397c$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
        size: "large",
        testId: testId
    }))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c26967b2e10d397c$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _ae4v1h6o _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $c26967b2e10d397c$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1wpz1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6jY6G", function(module, exports) {

$parcel$export(module.exports, "useCurrentRoute", () => $dda4cada2257eb1d$export$c4b7ea2942f2d0e);
$parcel$export(module.exports, "useRouteByName", () => $dda4cada2257eb1d$export$d69a946e2d0a1c12);
$parcel$export(module.exports, "usePreviousRouterState", () => $dda4cada2257eb1d$export$1e5fb68306bd0b92);

var $lODMY = parcelRequire("lODMY");
var $doZTA = parcelRequire("doZTA");

var $cfDZ3 = parcelRequire("cfDZ3");

const $dda4cada2257eb1d$export$c4b7ea2942f2d0e = (0, $lODMY.createRouterSelector)((state)=>state.route);
const $dda4cada2257eb1d$export$d69a946e2d0a1c12 = (0, $lODMY.createRouterSelector)((state, routeName)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    state.routes.find(({ name: name })=>name === routeName) ?? null);
const $dda4cada2257eb1d$export$94b319d3d90420ae = ({ name: name, path: path, query: query, exact: exact })=>({
        name: name,
        path: path,
        query: query,
        exact: exact
    });
const $dda4cada2257eb1d$export$1e5fb68306bd0b92 = ()=>{
    // Force updates whenever the current route changes
    (0, $doZTA.useRouter)();
    return (0, $cfDZ3.getPreviousRouterState)();
};

});

parcelRegister("7LpuY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c62dfc18679e80c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kUU4G = parcelRequire("kUU4G");

var $x9xyg = parcelRequire("x9xyg");

var $5h5Fg = parcelRequire("5h5Fg");

var $7N30e = parcelRequire("7N30e");

var $6b6Tk = parcelRequire("6b6Tk");


var $8Qrwl = parcelRequire("8Qrwl");

var $hXKq5 = parcelRequire("hXKq5");
class $6c62dfc18679e80c$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { children: children, pageId: pageId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Qrwl.default).Provider, {
            // @ts-expect-error - TS2322 - Type '{ pageId: string; onReady: (metricKeyForInitialRender: string, metricKeyForTransition: string, extra: { [key: string]: string | number | boolean; } | undefined, metric: BM3Metric) => void; onCustomMark: (markName: string) => void; }' is not assignable to type 'string'.
            value: {
                pageId: pageId,
                onReady: this.onReady,
                onCustomMark: this.onCustomMark
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: this.onStart,
            args: [
                pageId
            ]
        }), children));
    }
    constructor(...args){
        super(...args), this.customMarks = [], this.onStart = ()=>{
            (0, $kUU4G.default)((0, $ce556f125dee8174$export$56940a9488e85199));
            (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$45c4b6bf7935c69a));
        }, this.onCustomMark = (markName)=>{
            (0, $x9xyg.setMark)((0, $hXKq5.getPrefixedMarkName)(markName));
            // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
            this.customMarks.push(markName);
        }, this.onReady = (metricKeyForInitialRender, metricKeyForTransition, extra = {}, metric)=>{
            metric.stop({
                customData: extra
            });
            if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
        };
    }
}

});
parcelRegister("kUU4G", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cb4d2f8b5a69f79$export$2e2bcd8739ae039);

var $6RCeq = parcelRequire("6RCeq");
var /*
 * This utility finds all performance entries that is prefixed
 * with the `prefix` and does clearMarks on each entry.
 * All the entries that are cleared will be returned
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$6cb4d2f8b5a69f79$export$2e2bcd8739ae039 = (prefix)=>{
    // @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    if ((0, $6RCeq.default) && (0, $6RCeq.default).getEntries && (0, $6RCeq.default).clearMarks) return (0, $6RCeq.default)// @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    .getEntries()// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .filter((mark)=>mark.name.startsWith(prefix))// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .map((mark)=>{
        (0, $6RCeq.default).clearMarks(mark.name);
        return mark;
    });
    return [];
};

});

parcelRegister("5h5Fg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec2154d63d4be857$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");
// eslint-disable-next-line jira/react/no-class-components
class $ec2154d63d4be857$var$OpTrigger extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(this.props.args, nextProps.args);
    }
    componentDidUpdate() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $ec2154d63d4be857$export$2e2bcd8739ae039 = $ec2154d63d4be857$var$OpTrigger;

});

parcelRegister("7N30e", function(module, exports) {

$parcel$export(module.exports, "stopLowPriorityEventDelay", () => $5d68e3874efadecb$export$a928755af449867);
$parcel$export(module.exports, "startLowPriorityEventDelay", () => $5d68e3874efadecb$export$8bb8df5a93e9525);
$parcel$export(module.exports, "default", () => $5d68e3874efadecb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kUU4G = parcelRequire("kUU4G");

var $x9xyg = parcelRequire("x9xyg");

var $3vBBc = parcelRequire("3vBBc");

var $fjcgS = parcelRequire("fjcgS");

var $lsa9q = parcelRequire("lsa9q");

var $6b6Tk = parcelRequire("6b6Tk");

const $5d68e3874efadecb$var$STOP_DELAY_TIMEOUT = 10000;
let $5d68e3874efadecb$var$stopDelayTimeout;
let $5d68e3874efadecb$var$lastDelayActionPromise = (0, $fjcgS.getAnalyticsWebClientPromise)().then((clientWrapper)=>clientWrapper.getInstance());
const $5d68e3874efadecb$export$a928755af449867 = ()=>{
    $5d68e3874efadecb$var$lastDelayActionPromise = $5d68e3874efadecb$var$lastDelayActionPromise.then((client)=>{
        if (!(0, $3vBBc.isEventDelayActive)()) return client;
        clearTimeout($5d68e3874efadecb$var$stopDelayTimeout);
        // stopLowPriorityEventDelay performs a flush of the delayed events,
        // so the delayed period needs to be marked as ended _before_ calling that method.
        (0, $x9xyg.setMark)((0, $2eb1df3f82c48b0d$export$2d91d3eed1108e72));
        (0, $3vBBc.setEventDelayActive)(false);
        client.stopLowPriorityEventDelay();
        return client;
    });
};
const $5d68e3874efadecb$export$8bb8df5a93e9525 = ()=>{
    $5d68e3874efadecb$var$lastDelayActionPromise = $5d68e3874efadecb$var$lastDelayActionPromise.then((client)=>{
        // If startLowPriorityEventDelay is called when it's already active, then we are just extending
        // the delay period, so we don't want to reset any metadata we have captured about the original start.
        if (!(0, $3vBBc.isEventDelayActive)()) {
            (0, $kUU4G.default)((0, $2eb1df3f82c48b0d$export$358721a9d6125914));
            (0, $x9xyg.setMark)((0, $2eb1df3f82c48b0d$export$b2122dce85a27912));
        }
        client.startLowPriorityEventDelay();
        (0, $3vBBc.setEventDelayActive)(true);
        clearTimeout($5d68e3874efadecb$var$stopDelayTimeout);
        $5d68e3874efadecb$var$stopDelayTimeout = setTimeout($5d68e3874efadecb$export$a928755af449867, $5d68e3874efadecb$var$STOP_DELAY_TIMEOUT);
        return client;
    });
};
const $5d68e3874efadecb$export$778ebe2a4fab1ba7 = ()=>$5d68e3874efadecb$var$lastDelayActionPromise;
const $5d68e3874efadecb$var$EventDelayController = ()=>{
    const [loadedState] = (0, $lsa9q.default)();
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * The delay mechanism is currently locked so that only automatic exposure events
		 * can leverage it.
		 * We can remove the performance overhead of starting and stopping critical sections when
		 * these events won't be getting fired.
		 */ if (!loadedState.hasLoaded && (0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) $5d68e3874efadecb$export$8bb8df5a93e9525();
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
var $5d68e3874efadecb$export$2e2bcd8739ae039 = $5d68e3874efadecb$var$EventDelayController;

});
parcelRegister("3vBBc", function(module, exports) {

$parcel$export(module.exports, "setEventDelayActive", () => $63f3b8c0745d0500$export$9a4add6d6ddcc1a);
$parcel$export(module.exports, "isEventDelayActive", () => $63f3b8c0745d0500$export$3536b0184fa98d19);
let $63f3b8c0745d0500$var$eventDelayActive = false;
const $63f3b8c0745d0500$export$9a4add6d6ddcc1a = (isEventDelayActive)=>{
    $63f3b8c0745d0500$var$eventDelayActive = isEventDelayActive;
};
const $63f3b8c0745d0500$export$3536b0184fa98d19 = ()=>$63f3b8c0745d0500$var$eventDelayActive;

});

parcelRegister("lsa9q", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f20cb56a66aca22$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");


var $7w9eZ = parcelRequire("7w9eZ");
const $4f20cb56a66aca22$export$4a361c7505f72f5c = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    const determineHasLoaded = ()=>{
        /*
		 * During a transition, the top navigation is the only app loading. Additionally, legacy pages generally
		 * render a LegacyPage component, analytics, or nothing at all.
		 *
		 * This code ensures that the page is considered loaded when the content has finished loading in the
		 * SPA, or when the top navigation has finished loading for legacy pages.
		 *
		 * Ideally the LegacyPage component should include an app for the content, but the usage of route components
		 * in legacy routes is inconsistent and would need thorough testing. This should be good enough for now.
		 */ if (appIds.length === 1 && appIds[0] === (0, $146ecce9d079a34d$export$3a54edb6ba4daa82)) return !__SPA__;
        return appIds.length ? appIds.filter((id)=>id !== (0, $146ecce9d079a34d$export$2ee9e5a3556c1e43)).every((id)=>apps[id].endTime != null || apps[id].timeoutTime) : false;
    };
    const hasLoaded = determineHasLoaded();
    return {
        hasLoaded: hasLoaded
    };
};
const $4f20cb56a66aca22$var$usePageLoadedSubscriber = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: $4f20cb56a66aca22$export$4a361c7505f72f5c
});
var $4f20cb56a66aca22$export$2e2bcd8739ae039 = $4f20cb56a66aca22$var$usePageLoadedSubscriber;

});
const $146ecce9d079a34d$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $146ecce9d079a34d$export$2ee9e5a3556c1e43 = 'SIDEBAR';

parcelRegister("7w9eZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $85db42238a8acf29$export$2e2bcd8739ae039);

var $7Jxgt = parcelRequire("7Jxgt");

var $iXqE5 = parcelRequire("iXqE5");

var $6Bj8c = parcelRequire("6Bj8c");
const $85db42238a8acf29$export$d4c72bab9d6cc13a = {
    transitionCheckTimestamp: -1,
    currentPage: {
        uuid: false ? '' : (0, $7Jxgt.v4)(),
        startTime: typeof performance !== 'undefined' && performance.timing !== undefined && performance.timing.navigationStart || 0,
        apps: {},
        userLocation: ''
    },
    visitedPages: [],
    navigation: {
        isCollapsed: false,
        viewId: 'noView',
        viewType: '',
        projectType: null,
        isInitialEventSent: false,
        pageId: null,
        nextViewId: ''
    }
};
const $85db42238a8acf29$var$store = (0, $iXqE5.createStore)({
    name: 'spa-state',
    initialState: $85db42238a8acf29$export$d4c72bab9d6cc13a,
    actions: $6Bj8c
});
var $85db42238a8acf29$export$2e2bcd8739ae039 = $85db42238a8acf29$var$store;

});
parcelRegister("6Bj8c", function(module, exports) {

$parcel$export(module.exports, "setAppStart", () => (parcelRequire("fI6Pg")).setAppStart);
$parcel$export(module.exports, "setAppReady", () => (parcelRequire("fI6Pg")).setAppReady);
$parcel$export(module.exports, "setAppStartWithAppId", () => (parcelRequire("fI6Pg")).setAppStartWithAppId);
$parcel$export(module.exports, "setAppReadyWithAppId", () => (parcelRequire("fI6Pg")).setAppReadyWithAppId);
$parcel$export(module.exports, "setAppErrorReady", () => (parcelRequire("fI6Pg")).setAppErrorReady);
$parcel$export(module.exports, "setTimeoutReady", () => (parcelRequire("fI6Pg")).setTimeoutReady);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => (parcelRequire("fI6Pg")).setTimeoutReadyWithAppId);
$parcel$export(module.exports, "resetCurrentPage", () => (parcelRequire("fI6Pg")).resetCurrentPage);
$parcel$export(module.exports, "setResourceMetrics", () => (parcelRequire("fI6Pg")).setResourceMetrics);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $fI6Pg = parcelRequire("fI6Pg");

});
parcelRegister("fI6Pg", function(module, exports) {

$parcel$export(module.exports, "resetCurrentPage", () => $4a986cd3487bf863$export$5639685a1fb81722);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => $4a986cd3487bf863$export$8a98548dad2fa97b);
$parcel$export(module.exports, "setTimeoutReady", () => $4a986cd3487bf863$export$b9cc4378ea785421);
$parcel$export(module.exports, "setAppStartWithAppId", () => $4a986cd3487bf863$export$9d528722f2ff2999);
$parcel$export(module.exports, "setAppStart", () => $4a986cd3487bf863$export$71192061050856ad);
$parcel$export(module.exports, "setAppReadyWithAppId", () => $4a986cd3487bf863$export$6a25429a42d30f9a);
$parcel$export(module.exports, "setAppReady", () => $4a986cd3487bf863$export$fc59cc4ed9bba7cd);
$parcel$export(module.exports, "setAppErrorReady", () => $4a986cd3487bf863$export$aff63c1e41443b6a);
$parcel$export(module.exports, "setResourceMetrics", () => $4a986cd3487bf863$export$8ad155d489dcf34d);

var $7Jxgt = parcelRequire("7Jxgt");

var $j5G08 = parcelRequire("j5G08");

var $bl6ih = parcelRequire("bl6ih");

var $cfDZ3 = parcelRequire("cfDZ3");

var $iLrcb = parcelRequire("iLrcb");
const $4a986cd3487bf863$export$7bd623b29ec8e1eb = 10000;
const $4a986cd3487bf863$export$5639685a1fb81722 = (nextRouteUfoName, nextRouteName)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        performance.mark('resetCurrentPage');
        (0, $bl6ih.browserMetrics).startPageLoad({
            isInitial: false
        });
        (0, $j5G08.default)(nextRouteUfoName, nextRouteName);
        (0, $iLrcb.GlobalPageLoadExperience).abort({
            force: true
        });
        (0, $iLrcb.GlobalPageLoadExperience).startPageLoad('UNKNOWN', false);
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) setState({
            currentPage: {
                uuid: (0, $7Jxgt.v4)(),
                apps: {},
                startTime: Date.now(),
                userLocation: ''
            },
            visitedPages: [
                ...currentState.visitedPages,
                {
                    ...currentState.currentPage
                }
            ],
            transitionCheckTimestamp: 0
        });
    };
const $4a986cd3487bf863$export$8a98548dad2fa97b = (appId, timeoutTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].timeoutTime)) {
            const apps = {
                ...currentPage.apps
            };
            if (apps[appId] && apps[appId].expectingTimeout) {
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        ...apps,
                        [appId]: {
                            ...apps[appId],
                            timeoutTime: timeoutTime,
                            expectingTimeout: 0
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        }
    };
const $4a986cd3487bf863$export$b9cc4378ea785421 = (timeoutTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($4a986cd3487bf863$export$8a98548dad2fa97b(appId, timeoutTime));
    };
const $4a986cd3487bf863$export$9d528722f2ff2999 = (appId, startTime = Date.now())=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].startTime)) {
            const timeoutId = setTimeout(()=>{
                dispatch($4a986cd3487bf863$export$8a98548dad2fa97b(appId));
            }, $4a986cd3487bf863$export$7bd623b29ec8e1eb);
            const updatedPage = {
                ...currentPage,
                userLocation: (0, $cfDZ3.getUserLocation)(),
                apps: {
                    ...currentPage.apps,
                    [appId]: {
                        startTime: startTime,
                        expectingTimeout: timeoutId
                    }
                }
            };
            setState({
                // @ts-expect-error - TS2322 - Type '{ userLocation: string; apps: { [x: string]: AppState | { startTime: number; expectingTimeout: NodeJS.Timeout; }; }; uuid: string; startTime: number; resources?: ResourceMetrics[] | undefined; }' is not assignable to type 'PageTiming'.
                currentPage: updatedPage
            });
        }
    };
const $4a986cd3487bf863$export$71192061050856ad = (startTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($4a986cd3487bf863$export$9d528722f2ff2999(appId, startTime));
    };
const $4a986cd3487bf863$export$6a25429a42d30f9a = (appId, endTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps[appId] && currentPage.apps[appId].endTime === undefined) {
            const apps = {
                ...currentPage.apps
            };
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(currentPage.apps[appId].expectingTimeout);
            const updatedPage = {
                ...currentPage,
                apps: {
                    ...apps,
                    [appId]: {
                        ...apps[appId],
                        endTime: endTime,
                        expectingTimeout: 0
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $4a986cd3487bf863$export$fc59cc4ed9bba7cd = (endTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($4a986cd3487bf863$export$6a25429a42d30f9a(appId, endTime));
    };
const $4a986cd3487bf863$export$aff63c1e41443b6a = ()=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) {
            const updatedPage = {
                ...currentPage,
                apps: {
                    'error-page': {
                        endTime: Date.now()
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $4a986cd3487bf863$export$8ad155d489dcf34d = (resourceMetrics)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            currentPage: {
                ...currentState.currentPage,
                resources: [
                    ...currentState.currentPage.resources ? currentState.currentPage.resources : [],
                    resourceMetrics
                ]
            }
        });
    };

});




const $2eb1df3f82c48b0d$export$358721a9d6125914 = 'event-delay-controller.';
const $2eb1df3f82c48b0d$export$b2122dce85a27912 = `${$2eb1df3f82c48b0d$export$358721a9d6125914}start`;
const $2eb1df3f82c48b0d$export$2d91d3eed1108e72 = `${$2eb1df3f82c48b0d$export$358721a9d6125914}end`;


const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';

parcelRegister("8Qrwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d87d05828c384551$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $d87d05828c384551$var$contextName = 'SpaApdexAnalytics';
var $d87d05828c384551$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.createContext)($d87d05828c384551$var$contextName);

});

parcelRegister("hXKq5", function(module, exports) {

$parcel$export(module.exports, "getPrefixedMarkName", () => $f6cddc52a08e036c$export$c8f0e9837e7e9425);

const $f6cddc52a08e036c$export$c8f0e9837e7e9425 = (name)=>`${0, $ce556f125dee8174$export$56940a9488e85199}${name}`;

});


parcelRegister("dZw8H", function(module, exports) {

$parcel$export(module.exports, "SpaStateContainer", () => $b1cd152eb196251c$export$e9a92b877fe80e80);
$parcel$export(module.exports, "SpaStateAppStart", () => $b1cd152eb196251c$export$d18dd27183a635c);
$parcel$export(module.exports, "SpaStateAppStartWithMatchCheck", () => $b1cd152eb196251c$export$95a2912d76fb5433);
$parcel$export(module.exports, "SpaStatePageReady", () => $b1cd152eb196251c$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $b1cd152eb196251c$export$41e70078eeddaddc);
$parcel$export(module.exports, "SpaStatePageErrorReady", () => $b1cd152eb196251c$export$2583aa269898885c);
$parcel$export(module.exports, "getSpaStateLastUserLocation", () => $b1cd152eb196251c$export$6e9ab893e97cccef);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $lODMY = parcelRequire("lODMY");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $bKpgX = parcelRequire("bKpgX");

var $4oDnX = parcelRequire("4oDnX");

var $7w9eZ = parcelRequire("7w9eZ");
const $b1cd152eb196251c$export$e9a92b877fe80e80 = (0, $gg7kZ.createContainer)((0, $7w9eZ.default));
const $b1cd152eb196251c$export$d18dd27183a635c = ()=>{
    const startRef = (0, $5uXOq.useRef)(Date.now());
    const [{ visitedPages: visitedPages }, { setAppStart: setAppStart }] = (0, $4oDnX.useSpaState)();
    (0, $5uXOq.useMemo)(()=>{
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        visitedPages
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setAppStart(startRef.current);
    }, [
        setAppStart,
        visitedPages
    ]);
    return null;
};
const $b1cd152eb196251c$var$useRouterMatchSelector = (0, $lODMY.createRouterSelector)((state)=>state.match);
const $b1cd152eb196251c$var$useSpaStatePagesCount = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: ({ visitedPages: visitedPages })=>visitedPages.length
});
const $b1cd152eb196251c$export$95a2912d76fb5433 = ()=>{
    const match = $b1cd152eb196251c$var$useRouterMatchSelector();
    const [count, { setAppStart: setAppStart }] = $b1cd152eb196251c$var$useSpaStatePagesCount();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1cd152eb196251c$export$ada7e0ec445851a2, {
        visitedPagesLength: count,
        onSetAppStart: setAppStart,
        match: match
    });
};
const $b1cd152eb196251c$export$c34439f945fccbdf = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: setAppReady
        }));
const $b1cd152eb196251c$export$41e70078eeddaddc = ({ comparer: comparer } /* TODO - this should be using only the actions subscriber not state+actions subscriber */ )=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: setAppReady,
            args: comparer
        }));
const $b1cd152eb196251c$export$2583aa269898885c = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppErrorReady: setAppErrorReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: setAppErrorReady
        }));
class $b1cd152eb196251c$export$ada7e0ec445851a2 extends (0, $5uXOq.Component) {
    static getDerivedStateFromProps(props, state) {
        const visitedPageLengthHasChanged = props.visitedPagesLength !== state.visitedPagesLength;
        const matchHasChanged = props.match !== state.match;
        const setAppStart = !state.started || visitedPageLengthHasChanged && matchHasChanged;
        if (setAppStart) props.onSetAppStart(Date.now());
        // On transition visitedPageLength will always change before match, the only exception is when there is page
        // ids (e.g. issue types). When redirecting, the length doesn't change while the match changes (from issuetype to issuetype/xxxxx).
        // so if match changed without visitedPageLength changing, cache the new match and wait for both to update.
        if (setAppStart || !visitedPageLengthHasChanged) return {
            started: true,
            visitedPagesLength: props.visitedPagesLength,
            match: props.match
        };
        // if visitedPageLength changed, ignore and wait for update in match (which will trigger setAppStart next)
        return state;
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args), /** so the challenge we are facing is that, we need to reset page when there's a visitedPagesLength change and a route change,
	 * but they don't always happen at the the same time during the current spa router situation. The following code does this:
	 *
	 * if first render: set app start
	 *
	 * if subsequently render with only visitedPagesLength change, ignore this updates, cache the old visitedPagesLength,
	 * wait for incoming match change
	 *
	 * if subsequently render with only match change, ignore this updates, cache the old match, wait for incoming
	 * visitedPagesLength change
	 *
	 *  if incoming changes contain both route and length change, we update state and start app
	 *
	 */ this.state = {
            visitedPagesLength: 0,
            started: false,
            match: null
        };
    }
}
const $b1cd152eb196251c$export$6e9ab893e97cccef = ()=>{
    const { visitedPages: visitedPages } = (0, $bKpgX.defaultRegistry).getStore((0, $7w9eZ.default)).storeState.getState();
    return visitedPages.length ? visitedPages[visitedPages.length - 1].userLocation : '';
};

});
parcelRegister("4oDnX", function(module, exports) {

$parcel$export(module.exports, "SpaStateSubscriber", () => $363cd3235a9267e4$export$fd52daf2a3c1ec68);
$parcel$export(module.exports, "SpaStateActionsSubscriber", () => $363cd3235a9267e4$export$3dfa91988c213fbc);
$parcel$export(module.exports, "useSpaState", () => $363cd3235a9267e4$export$a57865516f6345d1);
$parcel$export(module.exports, "useSpaStateActions", () => $363cd3235a9267e4$export$b134752525935b78);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $7w9eZ = parcelRequire("7w9eZ");
const $363cd3235a9267e4$export$fd52daf2a3c1ec68 = (0, $51nlc.createSubscriber)((0, $7w9eZ.default));
const $363cd3235a9267e4$export$3dfa91988c213fbc = (0, $51nlc.createSubscriber)((0, $7w9eZ.default), {
    selector: null
});
const $363cd3235a9267e4$export$a57865516f6345d1 = (0, $3sQ5x.createHook)((0, $7w9eZ.default));
const $363cd3235a9267e4$export$b134752525935b78 = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: null
});

});



parcelRegister("eeyy6", function(module, exports) {

let $a5cd2c36c02aa62c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a5cd2c36c02aa62c$var$load("9xZgu").then(()=>parcelRequire('dnrkU'));

});



parcelRegister("Dkaoj", function(module, exports) {

$parcel$export(module.exports, "emailNotificationsLogAccessRouteEntry", () => $9945f9dd9a251453$export$4d57b993ce36e7b2);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $dmx0y = parcelRequire("dmx0y");

var $jsJ7J = parcelRequire("jsJ7J");

var $hBziA = parcelRequire("hBziA");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $5pSYQ = parcelRequire("5pSYQ");
const $9945f9dd9a251453$var$emailNotificationsLogEntryPointPage = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $hBziA.notificationLogsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});

const $9945f9dd9a251453$var$LazyNotificationLogsType = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iC3Q3"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/notification-logs/src/index.tsx"
});
const $9945f9dd9a251453$var$NotificationLogs = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9945f9dd9a251453$var$LazyNotificationLogsType,
        pageId: "Notification Logs",
        shouldShowSpinner: false
    });
const $9945f9dd9a251453$export$4d57b993ce36e7b2 = (0, $7NszV.createEntry)((0, $jsJ7J.emailNotificationsLogAccessRoute), ()=>({
        group: 'global-settings',
        component: $9945f9dd9a251453$var$NotificationLogs,
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $dmx0y.systemConfigurationGeneralResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $9945f9dd9a251453$var$LazyNotificationLogsType
        ],
        pageId: 'admin-settings-email-notifications-log',
        entryPoint () {
            return $9945f9dd9a251453$var$emailNotificationsLogEntryPointPage;
        }
    }));

});
parcelRegister("lkFvK", function(module, exports) {

$parcel$export(module.exports, "createChromelessEntryPoint", () => $6a0b20679c309df7$export$56ea489e9d4bfa04);
$parcel$export(module.exports, "createPageEntryPoint", () => $6a0b20679c309df7$export$955a7619d2679b4c);

var $adY3A = parcelRequire("adY3A");


var $3HwlS = parcelRequire("3HwlS");

var $4R6GH = parcelRequire("4R6GH");
const $6a0b20679c309df7$export$56ea489e9d4bfa04 = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    [(0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    }
                }
            }),
        toString: ()=>'ChromelessEntryPoint'
    });
const $6a0b20679c309df7$export$955a7619d2679b4c = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    [(0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    },
                    [(0, $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae)]: {
                        entryPoint: (0, $adY3A.topNavigationEntryPoint),
                        entryPointParams: {
                            menuId: page.topNavigationMenuId
                        }
                    },
                    ...page.leftSidebar && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? {
                        [(0, $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5)]: {
                            entryPoint: page.leftSidebar.sidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                entryPoints: {
                                    ...page.leftSidebar.entryPoints ? $6a0b20679c309df7$var$injectEntryPointParams(page.leftSidebar.entryPoints, entryPointParams) : undefined
                                },
                                isAppsExpanded: page.leftSidebar.isAppsExpanded ?? false,
                                isFiltersExpanded: page.leftSidebar.isFiltersExpanded ?? false,
                                isPlansExpanded: page.leftSidebar.isPlansExpanded ?? false,
                                isProjectsExpanded: page.leftSidebar.isProjectsExpanded ?? false,
                                isOperationsExpanded: page.leftSidebar.isOperationsExpanded ?? false,
                                isOverviewsExpanded: page.leftSidebar.isOverviewsExpanded ?? false
                            }
                        }
                    } : undefined,
                    ...page.horizontalNavigation && (0, $3HwlS.getWillShowNav4)() ? {
                        [(0, $6d6ccf8a2b2c5b3c$export$948d4d345566aed3)]: {
                            entryPoint: page.horizontalNavigation,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.horizontalNavigationFallback
                            }
                        }
                    } : undefined,
                    ...page.rightSidebar ? {
                        [(0, $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb)]: {
                            entryPoint: page.rightSidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.rightSidebarFallback
                            }
                        }
                    } : undefined
                }
            }),
        toString: ()=>'PageEntryPoint'
    });
function $6a0b20679c309df7$var$injectEntryPointParams(obj, entryPointParams) {
    const newParams = {};
    // https://stackoverflow.com/a/16735184
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) newParams[prop] = {
        entryPoint: obj[prop].entryPoint,
        entryPointParams: entryPointParams
    };
    return newParams;
}

});
parcelRegister("adY3A", function(module, exports) {

$parcel$export(module.exports, "topNavigationEntryPoint", () => $e6a45c27809ae082$export$f780be9e138f456f);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $e6a45c27809ae082$export$f780be9e138f456f = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("9DfkH"))), {
        moduleId: "1f1265b4"
    }),
    getPreloadProps: (extraProps)=>({
            extraProps: extraProps
        })
});

});

const $6d6ccf8a2b2c5b3c$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $6d6ccf8a2b2c5b3c$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';


parcelRegister("lmyls", function(module, exports) {

$parcel$export(module.exports, "ADDON_ID", () => $ee51d260cb059727$export$6c4866a933650d1d);
$parcel$export(module.exports, "MENU_ID", () => $ee51d260cb059727$export$d4cd258d01c03112);
$parcel$export(module.exports, "SIDEBAR_ID", () => $ee51d260cb059727$export$adf978edbdfaf080);
const $ee51d260cb059727$export$6c4866a933650d1d = {
    DISCOVER: 'com.atlassian.jira.emcee__enduser-discover'
};
const $ee51d260cb059727$export$d4cd258d01c03112 = {
    ADDONS: 'ADDONS',
    APP_SWITCHER: 'APP_SWITCHER',
    DASHBOARDS: 'DASHBOARDS',
    FILTERS: 'FILTERS',
    HELP: 'HELP',
    HOME: 'HOME',
    INSIGHT: 'INSIGHT',
    NOTIFICATIONS: 'NOTIFICATIONS',
    PEOPLE: 'PEOPLE',
    PLANS: 'PLANS',
    PROFILE: 'PROFILE',
    PROJECTS: 'PROJECTS',
    ROADMAPS: 'ROADMAPS',
    SEARCH: 'SEARCH',
    SERVICE_HUB: 'SERVICE_HUB',
    SETTINGS: 'SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};
const $ee51d260cb059727$export$adf978edbdfaf080 = {
    BOARD_SETTINGS: 'BOARD_SETTINGS',
    CONTENT: 'CONTENT',
    GLOBAL_APPS_SETTINGS: 'GLOBAL_APPS_SETTINGS',
    GLOBAL_ISSUES_SETTINGS: 'GLOBAL_ISSUES_SETTINGS',
    GLOBAL_PRODUCTS_SETTINGS: 'GLOBAL_PRODUCTS_SETTINGS',
    GLOBAL_PROJECTS_SETTINGS: 'GLOBAL_PROJECTS_SETTINGS',
    GLOBAL_SYSTEM_SETTINGS: 'GLOBAL_SYSTEM_SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    PLAN_SETTINGS: 'PLAN_SETTINGS',
    PROJECT_SETTINGS: 'PROJECT_SETTINGS',
    OPERATIONS_GENERAL_CONFIGURATION: 'OPERATIONS_GENERAL_CONFIGURATION'
};

});

parcelRegister("cOg46", function(module, exports) {

$parcel$export(module.exports, "default", () => $18dc7dd640caeb91$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

const $18dc7dd640caeb91$var$LazyGlobalSystemSettingsSidebar = (0, $b7Svb.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("6pa7K")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-system/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalSystemSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($18dc7dd640caeb91$var$LazyGlobalSystemSettingsSidebar, null)));
$18dc7dd640caeb91$var$GlobalSystemSettingsSidebar.displayName = 'GlobalSystemSettingsSidebar';
var $18dc7dd640caeb91$export$2e2bcd8739ae039 = $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar;

});
parcelRegister("dZQxE", function(module, exports) {

$parcel$export(module.exports, "SidebarBoundary", () => $e39fc1e1d73100a0$export$1edc778464f08256);

var $5uXOq = parcelRequire("5uXOq");

var $5e7oM = parcelRequire("5e7oM");

var $azzrO = parcelRequire("azzrO");

var $lfTZh = parcelRequire("lfTZh");

var $5Hj3V = parcelRequire("5Hj3V");

var $acDan = parcelRequire("acDan");

var $lGo7j = parcelRequire("lGo7j");
const $e39fc1e1d73100a0$export$1edc778464f08256 = ({ children: children, id: id })=>{
    const onFail = (0, $acDan.useSidebarFail)();
    const onSuccess = (0, $acDan.useSidebarSuccess)();
    const onError = (0, $5uXOq.useCallback)((location, error)=>{
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error'.
        const { statusCode: statusCode } = error;
        if (statusCode != null && statusCode >= 400 && statusCode < 500) onSuccess();
        else onFail(location, error);
    }, [
        onFail,
        onSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Hj3V.SidebarErrorBoundary), {
        id: id,
        packageName: "jiraSpaAppsSidebarCommon",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderAttempt
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarSSRPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderSsrStart
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav-sidebar",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
            isFull: true
        })
    }, children));
};

});
parcelRegister("5e7oM", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TOP_SEGMENT_NAME", () => $83022b592d1d8567$export$6635720e40ea7a7a);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_SEGMENT_NAME", () => $83022b592d1d8567$export$1d3c3cb357af0e86);
$parcel$export(module.exports, "NAVIGATION_SSR_MARK_PREFIX", () => $83022b592d1d8567$export$e7a14fa81b3c6488);
$parcel$export(module.exports, "NAVIGATION_TOP_MARKS", () => $83022b592d1d8567$export$ad760bb9734bf93f);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_MARKS", () => $83022b592d1d8567$export$1d10ee0c85c3cb21);
const $83022b592d1d8567$export$6635720e40ea7a7a = 'navigation.top';
const $83022b592d1d8567$export$1d3c3cb357af0e86 = 'navigation.sidebar';
const $83022b592d1d8567$export$e7a14fa81b3c6488 = 'nav-ssr-mark';
const $83022b592d1d8567$export$ad760bb9734bf93f = {
    renderStart: 'navigation-top.render.start',
    renderEnd: 'navigation-top.render.end',
    renderSsrStart: 'navigation-top.render.ssr.start',
    renderSsrEnd: 'navigation-top.render.ssr.end',
    bundleLoadStart: 'navigation-top.bundle-load.start'
};
const $83022b592d1d8567$export$1d10ee0c85c3cb21 = {
    renderAttempt: 'navigation-sidebar.render.attempt',
    renderStart: 'navigation-sidebar.render.start',
    renderEnd: 'navigation-sidebar.render.end',
    renderSsrStart: 'navigation-sidebar.render.ssr.start',
    renderSsrEnd: 'navigation-sidebar.render.ssr.end',
    loadStart: 'navigation-sidebar.load.start',
    loadEnd: 'navigation-sidebar.load.end'
};

});

parcelRegister("azzrO", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TOP_DROPDOWN_MARKS", () => $4d07bc740e316cc0$export$8df02628d98cae7e);
$parcel$export(module.exports, "pageSegmentStore", () => $4d07bc740e316cc0$export$26cadbe0bcaabcde);
$parcel$export(module.exports, "useNavPerformanceMetrics", () => $4d07bc740e316cc0$export$906025848d54198d);
$parcel$export(module.exports, "NavTopPerformanceMark", () => $4d07bc740e316cc0$export$b7f4caa65b0906fc);
$parcel$export(module.exports, "NavTopSSRPerformanceMark", () => $4d07bc740e316cc0$export$2c4a101f2cde4fc2);
$parcel$export(module.exports, "NavTopPerformanceReport", () => $4d07bc740e316cc0$export$c64b31449a6177d);
$parcel$export(module.exports, "NavSidebarPerformanceMark", () => $4d07bc740e316cc0$export$35b2aeea5cbc963e);
$parcel$export(module.exports, "NavSidebarSSRPerformanceMark", () => $4d07bc740e316cc0$export$14f711a2cb6a655a);
$parcel$export(module.exports, "NavSidebarPerformanceReport", () => $4d07bc740e316cc0$export$a018e347341b3640);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $2nKjG = parcelRequire("2nKjG");

var $cfDZ3 = parcelRequire("cfDZ3");

var $5M3R9 = parcelRequire("5M3R9");

var $4R6GH = parcelRequire("4R6GH");

var $5e7oM = parcelRequire("5e7oM");

const $4d07bc740e316cc0$var$createTopNavPageSegment = ()=>(0, $2nKjG.metrics).pageSegmentLoad({
        key: (0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME),
        timings: [
            {
                key: 'ttic',
                startMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderStart,
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderSsrStart,
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'bundle-load',
                startMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).bundleLoadStart,
                endMark: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderStart
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $4d07bc740e316cc0$export$8df02628d98cae7e = {
    ADDONS: (0, $2nKjG.metrics).interaction({
        key: 'navigation-top.addons-dropdown-opened'
    })
};
const $4d07bc740e316cc0$var$createSidebarPageSegment = ()=>(0, $2nKjG.metrics).pageSegmentLoad({
        key: (0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME),
        timings: [
            {
                key: 'renderAttempt',
                startMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderAttempt,
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderAttempt
            },
            {
                key: 'ttic',
                startMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderStart,
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderSsrStart,
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'load',
                startMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).loadStart,
                endMark: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).loadEnd
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $4d07bc740e316cc0$export$26cadbe0bcaabcde = (()=>{
    const segmentConstructors = {
        [(0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME)]: $4d07bc740e316cc0$var$createTopNavPageSegment,
        [(0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME)]: $4d07bc740e316cc0$var$createSidebarPageSegment
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const segments = {};
    return {
        getSegment: (key)=>{
            if (!segments[key]) {
                if (!segmentConstructors[key]) throw new Error(`Segment constructor for ${key} is not defined.`);
                segments[key] = segmentConstructors[key]();
            }
            return segments[key];
        }
    };
})();
const $4d07bc740e316cc0$export$906025848d54198d = (segmentKey = (0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME))=>{
    const startedRef = (0, $5uXOq.useRef)(false);
    const segment = (0, $5uXOq.useRef)($4d07bc740e316cc0$export$26cadbe0bcaabcde.getSegment(segmentKey)).current;
    if (!false && !startedRef.current) {
        segment && segment.startFromPageLoad();
        startedRef.current = true;
    }
    return (0, $5uXOq.useMemo)(()=>// object assign here to extend origianl segment object and save prototypes
        Object.assign(segment, {
            markSSR: (metricKey)=>{
                const tmpSsrMetricKey = `${(0, $5e7oM.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                if (window.SPA_STATE) {
                    // @ts-expect-error - TS2339 - Property 'startTime' does not exist on type 'unknown'. | TS2339 - Property 'duration' does not exist on type 'unknown'.
                    const { startTime: startTime = 0, duration: duration = 0 } = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $5M3R9.getRenderTraceFromSSRGlobal)(), [
                        'traces',
                        `render/${tmpSsrMetricKey}`
                    ]) || {};
                    const markTime = startTime + duration;
                    markTime && markTime > 0 && segment.mark(metricKey, markTime);
                }
            }
        }), [
        segment
    ]);
};
const $4d07bc740e316cc0$var$NavigationPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
    const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
    (0, $5uXOq.useEffect)(()=>navSegment.mark(metricKey), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return null;
};
const $4d07bc740e316cc0$var$NavigationSSRPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
    const tmpSsrMetricKey = `${(0, $5e7oM.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
    const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>navSegment.markSSR(metricKey), []);
    // All occurrences of this are redundant and importantly, super annoying in the perf portal waterfall (sidebar + app_navigation). Making start&end marks all "end" type means they all get reported as timers that start at 0. Instead of... you know... setting the mark type appropriately.
    return false && !(0, $4R6GH.fg)('jira-ssr-perf-portal-cleanup') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        type: "end",
        traceKey: tmpSsrMetricKey
    }) : null;
};
const $4d07bc740e316cc0$var$NavigationPerformanceReport = ({ segmentKey: segmentKey, customData: customData })=>{
    const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
    (0, $5uXOq.useEffect)(()=>{
        navSegment.stop({
            customData: {
                ...customData,
                userLocation: (0, $cfDZ3.getUserLocation)()
            }
        });
        navSegment.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $4d07bc740e316cc0$export$b7f4caa65b0906fc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $4d07bc740e316cc0$export$2c4a101f2cde4fc2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationSSRPerformanceMark, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $4d07bc740e316cc0$export$c64b31449a6177d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $4d07bc740e316cc0$export$35b2aeea5cbc963e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });
const $4d07bc740e316cc0$export$14f711a2cb6a655a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationSSRPerformanceMark, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });
const $4d07bc740e316cc0$export$a018e347341b3640 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });

});
parcelRegister("5M3R9", function(module, exports) {

$parcel$export(module.exports, "RenderTracerMark", () => $ca67b9a5090b457c$export$54c89059bb435049);
$parcel$export(module.exports, "getRenderTraceFromSSRGlobal", () => $ca67b9a5090b457c$export$345f21b0287f67e5);

var $5uXOq = parcelRequire("5uXOq");

var $6Csk1 = parcelRequire("6Csk1");

var $9XE6b = parcelRequire("9XE6b");

var $jR67t = parcelRequire("jR67t");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

const $ca67b9a5090b457c$var$initialState = {
    start: undefined,
    traces: {}
};
let $ca67b9a5090b457c$var$currentTraces = {};
const $ca67b9a5090b457c$export$2365ecd8218e21c7 = ()=>$ca67b9a5090b457c$var$currentTraces;
const $ca67b9a5090b457c$export$5c757eaa1990d0d7 = (key)=>{
    if ($ca67b9a5090b457c$var$currentTraces[key]) return;
    $ca67b9a5090b457c$var$currentTraces[key] = {
        startTime: (0, $jR67t.performance).now()
    };
};
const $ca67b9a5090b457c$export$16854dc18f8d976 = (key)=>{
    if (!$ca67b9a5090b457c$var$currentTraces[key] || $ca67b9a5090b457c$var$currentTraces[key].duration != null) return;
    $ca67b9a5090b457c$var$currentTraces[key].duration = (0, $jR67t.performance).now() - $ca67b9a5090b457c$var$currentTraces[key].startTime;
};
const $ca67b9a5090b457c$var$actions = {
    startTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            // If <RenderTracerContainer /> has not been setup with a startKey and startTime, return
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            if (traces[key]) return;
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($6Csk1)))({}, traces, {
                    [key]: {
                        startTime: time
                    }
                })
            });
        },
    endTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            const trace = traces[key] || {
                startTime: 0
            };
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($6Csk1)))({}, traces, {
                    [key]: {
                        ...trace,
                        duration: time - trace.startTime
                    }
                })
            });
            $ca67b9a5090b457c$var$currentTraces = Object.assign($ca67b9a5090b457c$var$currentTraces, getState().traces);
        }
};
const $ca67b9a5090b457c$var$Store = (0, $iXqE5.createStore)({
    name: 'jira-render-tracer',
    initialState: $ca67b9a5090b457c$var$initialState,
    actions: $ca67b9a5090b457c$var$actions
});
const $ca67b9a5090b457c$var$RenderTracerActions = (0, $51nlc.createSubscriber)($ca67b9a5090b457c$var$Store, {
    selector: null
});
const $ca67b9a5090b457c$export$719a95758870be58 = (0, $3sQ5x.createHook)($ca67b9a5090b457c$var$Store, {
    selector: null
});
const $ca67b9a5090b457c$var$RenderTracerContainerBase = (0, $gg7kZ.createContainer)($ca67b9a5090b457c$var$Store, {
    onInit: ()=>({ setState: setState }, { startKey: startKey, startTime: startTime })=>{
            setState({
                start: startTime,
                traces: {
                    [startKey]: {
                        startTime: (0, $jR67t.performance).now()
                    }
                }
            });
        }
});
const $ca67b9a5090b457c$export$37d31bee41ca1401 = ({ children: children, startKey: startKey, startTime: startTime })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$var$RenderTracerContainerBase, {
        startKey: startKey,
        startTime: startTime
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$export$54c89059bb435049, {
        traceKey: startKey,
        type: "end"
    }));
const $ca67b9a5090b457c$export$54c89059bb435049 = ({ traceKey: traceKey, type: type })=>// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$var$RenderTracerActions, null, (_, { startTrace: startTrace, endTrace: endTrace })=>{
        if (type === 'start') startTrace(traceKey, (0, $jR67t.performance).now());
        else if (type === 'end') endTrace(traceKey, (0, $jR67t.performance).now());
        return null;
    });
const $ca67b9a5090b457c$export$cba8addc8743389c = (appName = 'unknown', traces = $ca67b9a5090b457c$var$currentTraces)=>({
        [(0, $eb0760a6ada94ab6$export$3c96fa14fb694e11)]: {
            data: {
                traces: traces,
                routeName: appName
            }
        }
    });
const $ca67b9a5090b457c$export$345f21b0287f67e5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.SPA_STATE || window.SKELETON_NAVIGATION || {}, [
        (0, $eb0760a6ada94ab6$export$3c96fa14fb694e11),
        'data'
    ], {});

});
parcelRegister("jR67t", function(module, exports) {

$parcel$export(module.exports, "performance", () => $c026bc7061377d6e$export$f2d2284f5fec51f8);
const $c026bc7061377d6e$var$now = ()=>false ? Date.now() : $parcel$global.performance.now();
class $c026bc7061377d6e$export$9a0dbed22cbf63be {
    start() {
        if (false) this.startAt = $c026bc7061377d6e$var$now();
    }
    now() {
        if (false) return $c026bc7061377d6e$var$now() - this.startAt;
        return $c026bc7061377d6e$var$now();
    }
    constructor(){
        this.startAt = $c026bc7061377d6e$var$now();
    }
}
const $c026bc7061377d6e$export$f2d2284f5fec51f8 = new $c026bc7061377d6e$export$9a0dbed22cbf63be();

});

const $eb0760a6ada94ab6$export$3c96fa14fb694e11 = 'ssr/detail_render_trace';



parcelRegister("5Hj3V", function(module, exports) {

$parcel$export(module.exports, "SidebarErrorBoundary", () => $c3958cf153a091e2$export$62853c5766dad0c4);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $cfDZ3 = parcelRequire("cfDZ3");

var $kqzba = parcelRequire("kqzba");
const $c3958cf153a091e2$export$62853c5766dad0c4 = (props)=>{
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const extraEventData = (0, $5uXOq.useMemo)(()=>({
            ...props.extraEventData,
            userLocation: userLocation
        }), [
        props.extraEventData,
        userLocation
    ]);
    const fallback = (0, $5uXOq.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kqzba.Fallback), {
            error: error
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        ...props,
        extraEventData: extraEventData,
        fallback: fallback
    });
};

});
parcelRegister("kqzba", function(module, exports) {

$parcel$export(module.exports, "Fallback", () => $790c5d1c3d335eca$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bWfiu = parcelRequire("bWfiu");

var $kobfu = parcelRequire("kobfu");

var $koVbs = parcelRequire("koVbs");

var $evbHg = parcelRequire("evbHg");

var $h8OaL = parcelRequire("h8OaL");
const $790c5d1c3d335eca$var$styles = {
    wrapper: "_zulpu2gc _bfhk1jdc _syaz1mjl _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _y3gn1h6o _4cvr1h6o _1e0c1txw _2lx21bp4",
    error: "_2rko9j3y _11c8dcr7 _syaz131l _bfhk1v33 _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66",
    image: "_4t3i12am"
};
const $790c5d1c3d335eca$export$fb8d7f40caaeea67 = (props)=>{
    const { error: error } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $790c5d1c3d335eca$var$styles.wrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        alt: "",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($evbHg))),
        className: (0, $bwpsq.default)([
            $790c5d1c3d335eca$var$styles.image
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "xsmall"
    }, formatMessage((0, $h8OaL.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $h8OaL.default).errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("code", {
        className: (0, $bwpsq.default)([
            $790c5d1c3d335eca$var$styles.error
        ])
    }, "ERROR: ", (0, $kobfu.getErrorHash)(error)));
};

});
parcelRegister("evbHg", function(module, exports) {
module.exports = new URL("generic-error.76ff7c6a.svg", import.meta.url).toString();

});

parcelRegister("h8OaL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7c8a71ff5065c1e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e7c8a71ff5065c1e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorHeading: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    }
});

});



parcelRegister("acDan", function(module, exports) {

$parcel$export(module.exports, "SidebarStart", () => $b5a3a4467dac2130$export$6738d1299dc79710);
$parcel$export(module.exports, "SidebarRenderStart", () => $b5a3a4467dac2130$export$ba19e3624956e66);
$parcel$export(module.exports, "SidebarReady", () => $b5a3a4467dac2130$export$a06ecbbe5820282);
$parcel$export(module.exports, "useSidebarFail", () => $b5a3a4467dac2130$export$661ed14c8f75da9f);
$parcel$export(module.exports, "useSidebarSuccess", () => $b5a3a4467dac2130$export$ddb17534fdfb7dc6);

var $5uXOq = parcelRequire("5uXOq");

var $5e7oM = parcelRequire("5e7oM");

var $azzrO = parcelRequire("azzrO");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $4QcD9 = parcelRequire("4QcD9");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $6IzHB = parcelRequire("6IzHB");

var $doZTA = parcelRequire("doZTA");

var $kvHKs = parcelRequire("kvHKs");
// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
const { useValue: $b5a3a4467dac2130$var$useSidebarId } = (0, $4QcD9.createValueController)('sidebar-id');
const $b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES = {
    experience: (0, $kvHKs.SIDEBAR_EXPERIENCE),
    attributes: {
        sidebar: 'v3'
    }
};
const $b5a3a4467dac2130$export$6738d1299dc79710 = ()=>{
    const [{ route: route, match: match }] = (0, $doZTA.useRouter)();
    const pageId = (0, $6IzHB.usePageId)();
    const startRef = (0, $5uXOq.useRef)(Date.now());
    const onStartExperience = (0, $kaHBi.useExperienceStart)({
        experienceId: pageId,
        experience: (0, $kvHKs.SIDEBAR_EXPERIENCE),
        analyticsSource: 'Sidebar'
    });
    (0, $5uXOq.useMemo)(()=>{
        if (route.isRedirect ?? false) return;
        onStartExperience();
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        match
    ]);
    return null;
};
const $b5a3a4467dac2130$export$ba19e3624956e66 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderStart
    });
const $b5a3a4467dac2130$export$a06ecbbe5820282 = ({ id: id })=>{
    const [, setSidebarId] = $b5a3a4467dac2130$var$useSidebarId();
    const route = (0, $6jY6G.useCurrentRoute)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const onSuccess = (0, $3bQtK.useExperienceSuccess)($b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
    (0, $5uXOq.useEffect)(()=>{
        setSidebarId(id);
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        return ()=>setSidebarId();
    }, [
        setSidebarId,
        id
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (route.isRedirect ?? false) return;
        onSuccess();
    }, [
        onSuccess,
        route
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // Why are we injecting the route name into the global window state?
        // We currently don't have any way to get the route name when the sidenav is rendered OUTSIDE of the SPA
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__POLLINATOR__ = {
            ...window.__POLLINATOR__,
            routeName: routeName
        };
        const event = createAnalyticsEvent({
            action: 'ready',
            actionSubject: 'sidebar',
            meta: {
                teamName: 'endeavour'
            }
        });
        (0, $8zOmE.fireUIAnalytics)(event, 'Sidebar Ready', {
            route: routeName
        });
    }, [
        createAnalyticsEvent,
        routeName
    ]);
    const customData = (0, $5uXOq.useMemo)(()=>({
            route: routeName,
            sidebarId: id
        }), [
        routeName,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarPerformanceReport), {
        customData: customData
    }));
};
const $b5a3a4467dac2130$export$661ed14c8f75da9f = ()=>{
    const onFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $kvHKs.SIDEBAR_EXPERIENCE)
    });
    return (0, $5uXOq.useCallback)((location, error)=>{
        onFail(location, error);
    }, [
        onFail
    ]);
};
const $b5a3a4467dac2130$export$ddb17534fdfb7dc6 = ()=>(0, $3bQtK.useExperienceSuccess)($b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES);

});
parcelRegister("93jKl", function(module, exports) {

$parcel$export(module.exports, "useExperienceFail", () => $e2626e1ab0692489$export$606da7704d8eaf06);

var $5uXOq = parcelRequire("5uXOq");

var $fZneA = parcelRequire("fZneA");

var $3vs13 = parcelRequire("3vs13");

var $j8DrX = parcelRequire("j8DrX");

var $l9g16 = parcelRequire("l9g16");
const $e2626e1ab0692489$export$606da7704d8eaf06 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $l9g16.useExperienceContext)();
    const self = (0, $5uXOq.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $5uXOq.useCallback)((location, error, extraAttributes = {})=>{
        const { current: current } = self;
        // ignore client side errors from impacting experience metrics
        if ((0, $3vs13.isLoaderError)(error) && error.name === 'ChunkLoadError' || (0, $fZneA.isClientFetchError)(error)) return;
        const shardAndRegionAttributes = {
            shard: (0, $j8DrX.default)('ajs-shard'),
            region: (0, $j8DrX.default)('ajs-region')
        };
        current.experienceTracker.fail({
            name: current.name,
            error: error,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes,
                location: location
            }
        });
    }, [
        self
    ]);
};

});
parcelRegister("l9g16", function(module, exports) {

$parcel$export(module.exports, "useExperienceContext", () => $79f23c22d88dd8d5$export$be8ec22ac9208049);

var $5uXOq = parcelRequire("5uXOq");

var $47QoQ = parcelRequire("47QoQ");
const $79f23c22d88dd8d5$export$be8ec22ac9208049 = ()=>{
    const context = (0, $5uXOq.useContext)((0, $47QoQ.ExperienceTrackerContext));
    return context;
};

});


parcelRegister("kaHBi", function(module, exports) {

$parcel$export(module.exports, "useExperienceStart", () => $e1187df33c58b997$export$675e0d25df38d426);
$parcel$export(module.exports, "ExperienceStart", () => $e1187df33c58b997$export$f20b867e738a222c);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $l9g16 = parcelRequire("l9g16");
const $e1187df33c58b997$export$675e0d25df38d426 = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect = ()=>undefined })=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const experienceTracker = (0, $l9g16.useExperienceContext)();
    const userLocation = `${route.group ?? 'unknown'}:${route.name}`;
    const self = (0, $5uXOq.useRef)({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        experienceTracker: experienceTracker,
        disableSli: disableSli,
        userLocation: userLocation,
        collect: collect
    });
    self.current.experienceId = experienceId;
    self.current.experience = experience;
    self.current.timeout = timeout;
    self.current.analyticsSource = analyticsSource;
    self.current.application = application;
    self.current.edition = edition;
    self.current.experienceTracker = experienceTracker;
    self.current.userLocation = userLocation;
    self.current.collect = collect;
    return (0, $5uXOq.useCallback)(()=>{
        const { current: current } = self;
        current.experienceTracker.start({
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            id: current.experienceId,
            name: current.experience,
            timeout: current.timeout,
            attributes: {
                analyticsSource: current.analyticsSource,
                experience: current.experience,
                experienceId: current.experienceId,
                application: current.application,
                edition: current.edition,
                disableSli: current.disableSli,
                userLocation: current.userLocation
            },
            collect: current.collect,
            onSuccess: ()=>undefined
        });
    }, [
        self
    ]);
};
const $e1187df33c58b997$export$f20b867e738a222c = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect })=>{
    const onStart = $e1187df33c58b997$export$675e0d25df38d426({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        disableSli: disableSli,
        collect: collect
    });
    (0, $5uXOq.useMemo)(()=>{
        onStart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onStart,
        experienceId,
        experience,
        timeout,
        analyticsSource,
        application,
        edition,
        disableSli,
        collect
    ]);
    return null;
};

});

parcelRegister("3bQtK", function(module, exports) {

$parcel$export(module.exports, "useExperienceSuccess", () => $f46ca4b214d7cdb6$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "ExperienceSuccess", () => $f46ca4b214d7cdb6$export$4962f3898bd5c829);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $j8DrX = parcelRequire("j8DrX");

var $l9g16 = parcelRequire("l9g16");
const $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT = {};
const $f46ca4b214d7cdb6$export$e94f0da4fc0603c6 = ({ experience: experience, attributes: attributes = $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT })=>{
    const experienceTracker = (0, $l9g16.useExperienceContext)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const self = (0, $5uXOq.useRef)({
        experience: experience,
        attributes: attributes,
        experienceTracker: experienceTracker,
        route: route
    });
    self.current.route = route;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    self.current.experience = experience;
    return (0, $5uXOq.useCallback)((extraAttributes = {})=>{
        const { current: current } = self;
        if (current.route && current.route.isRedirect === true) return;
        const shardAndRegionAttributes = {
            shard: (0, $j8DrX.default)('ajs-shard'),
            region: (0, $j8DrX.default)('ajs-region')
        };
        current.experienceTracker.succeed({
            name: current.experience,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes
            }
        });
    }, [
        self
    ]);
};
const $f46ca4b214d7cdb6$export$4962f3898bd5c829 = ({ experience: experience, attributes: attributes = $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT })=>{
    const onExperienceSuccess = $f46ca4b214d7cdb6$export$e94f0da4fc0603c6({
        experience: experience,
        attributes: attributes
    });
    (0, $5uXOq.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        attributes,
        onExperienceSuccess
    ]);
    (0, $5uXOq.useMemo)(()=>{
        if (false) onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    return null;
};

});

parcelRegister("4QcD9", function(module, exports) {

$parcel$export(module.exports, "createValueController", () => $3f293f209341d999$export$ff0ab9dd4ceb4a93);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $3f293f209341d999$export$ff0ab9dd4ceb4a93 = (name, defaultValue)=>{
    const actions = {
        setValue: (value)=>({ setState: setState })=>setState({
                    value: value
                })
    };
    const initialState = {
        value: defaultValue
    };
    const store = (0, $iXqE5.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ValueContainer = (0, $gg7kZ.createContainer)(store);
    const selector = (state)=>state.value;
    const useValueInternal = (0, $3sQ5x.createHook)(store, {
        selector: selector
    });
    const useValue = ()=>{
        const [value, { setValue: setValue }] = useValueInternal();
        return [
            value,
            setValue
        ];
    };
    return {
        ValueContainer: ValueContainer,
        useValue: useValue
    };
};

});

parcelRegister("6IzHB", function(module, exports) {

$parcel$export(module.exports, "usePageId", () => $57184c749af08735$export$3434ba5eadb360dc);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $7w9eZ = parcelRequire("7w9eZ");
const $57184c749af08735$var$useSweetStatePageId = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: (state)=>state.currentPage.uuid
});
const $57184c749af08735$export$3434ba5eadb360dc = ()=>{
    const [pageId] = $57184c749af08735$var$useSweetStatePageId();
    return pageId;
};

});

parcelRegister("kvHKs", function(module, exports) {

$parcel$export(module.exports, "REPO_TYPE", () => $f1419662a60c783a$export$399c7e6858236b4);
$parcel$export(module.exports, "LINK_TYPE", () => $f1419662a60c783a$export$58125ce2bb1c3378);
$parcel$export(module.exports, "EMOJI_REGEX", () => $f1419662a60c783a$export$c79ed2783644934c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES", () => $f1419662a60c783a$export$25ae65041c800c9);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES", () => $f1419662a60c783a$export$e03c9beea817d44b);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES", () => $f1419662a60c783a$export$3d575bdf28c0d17c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES", () => $f1419662a60c783a$export$af84baced6970a17);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES", () => $f1419662a60c783a$export$c767f253046b1ea7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES", () => $f1419662a60c783a$export$265b9384cc2dfbd4);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES", () => $f1419662a60c783a$export$2de77b357e71c7a7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES", () => $f1419662a60c783a$export$7de7abb92169d6c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES", () => $f1419662a60c783a$export$fd7df8bd7600c65c);
$parcel$export(module.exports, "GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID", () => $f1419662a60c783a$export$dde074e512e80dff);
$parcel$export(module.exports, "REPORTS_IDS", () => $f1419662a60c783a$export$1f70a76cb421b107);
$parcel$export(module.exports, "SIDEBAR_EXPERIENCE", () => $f1419662a60c783a$export$71aaf2625ee54d10);
$parcel$export(module.exports, "staticLegacyIds", () => $f1419662a60c783a$export$f57650e6e7be03dc);
const $f1419662a60c783a$export$399c7e6858236b4 = 'source.code.link';
const $f1419662a60c783a$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
const $f1419662a60c783a$export$c79ed2783644934c = /^(?:[\u2600-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;
const $f1419662a60c783a$export$25ae65041c800c9 = 'pin-filter-myopenissues';
const $f1419662a60c783a$export$e03c9beea817d44b = 'pin-filter-reportedbyme';
const $f1419662a60c783a$export$3d575bdf28c0d17c = 'pin-filter-allissues';
const $f1419662a60c783a$export$af84baced6970a17 = 'pin-filter-allopenissues';
const $f1419662a60c783a$export$c767f253046b1ea7 = 'pin-filter-doneissues';
const $f1419662a60c783a$export$265b9384cc2dfbd4 = 'pin-filter-recentlyviewed';
const $f1419662a60c783a$export$2de77b357e71c7a7 = 'pin-filter-addedrecently';
const $f1419662a60c783a$export$7de7abb92169d6c = 'pin-filter-resolvedrecently';
const $f1419662a60c783a$export$fd7df8bd7600c65c = 'pin-filter-updatedrecently';
const $f1419662a60c783a$export$dde074e512e80dff = 'global-create-spotlight';
const $f1419662a60c783a$export$1f70a76cb421b107 = {
    REPORTS_ADDONS: 'sd-reports-addons'
};
const $f1419662a60c783a$export$71aaf2625ee54d10 = 'viewSidebarNavigation';
const $f1419662a60c783a$export$f57650e6e7be03dc = [
    // Global Settings Static Legacy Ids
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy Ids
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation'
];

});


parcelRegister("lGo7j", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $0c703bf4651638aa$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8iquX = parcelRequire("8iquX");

var $kxnYb = parcelRequire("kxnYb");
var $9K9UK = parcelRequire("9K9UK");
const $0c703bf4651638aa$export$8f31e4c4a37b8e9c = ({ isFull: isFull = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iquX.default), {
        name: "sidebar-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c703bf4651638aa$var$BackgroundedWrapper, null, isFull && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c703bf4651638aa$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), {
        hasIcon: isFull
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c703bf4651638aa$var$BackgroundedWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1tem _ca0qidpf _u5f31ejb _n3tdidpf _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $0c703bf4651638aa$var$HeadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt41k9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kxnYb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d656428246d2d6c1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $70rf1 = parcelRequire("70rf1");

var $c48kn = parcelRequire("c48kn");

var $fsi33 = parcelRequire("fsi33");
// Type needed on props to extract types with extract react types.
/**
 * __Section__
 *
 * Used to separate items into sections. Using the title prop makes a section
 * implicitly group the items for screen readers with no additional work required.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#section)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $d656428246d2d6c1$var$Section = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { shouldRender: shouldRender } = (0, $fsi33.useShouldNestedElementRender)();
    if (!shouldRender) return props.children;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $70rf1.default), {
        ...props,
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
        overrides: {
            HeadingItem: {
                cssFn: (0, $c48kn.sectionHeaderSpacingStyles)
            }
        }
    });
});
var $d656428246d2d6c1$export$2e2bcd8739ae039 = $d656428246d2d6c1$var$Section;

});
parcelRegister("c48kn", function(module, exports) {

$parcel$export(module.exports, "overrideStyleFunction", () => $4119079cc6831898$export$505cedac1a39aacf);
$parcel$export(module.exports, "baseSideNavItemStyle", () => $4119079cc6831898$export$aed216a85ec468ac);
$parcel$export(module.exports, "sectionHeaderSpacingStyles", () => $4119079cc6831898$export$a5c27bed78cfecb9);

const $4119079cc6831898$export$505cedac1a39aacf = (baseStyle, newStyle = ()=>({}))=>{
    return (state)=>{
        return [
            baseStyle(state),
            newStyle(state)
        ];
    };
};
const $4119079cc6831898$var$defaultStyles = {
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $a7f8c6b391092279$export$c39c0fe0f26207ae)})`,
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $a7f8c6b391092279$export$3e51e8f1440314ba)})`
    },
    '&:active': {
        color: `var(--ds-text-subtle, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`,
        backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $a7f8c6b391092279$export$226de0355ed012f8)})`
    }
};
const $4119079cc6831898$var$selectedStyles = {
    backgroundColor: `var(--ds-background-selected, ${(0, $a7f8c6b391092279$export$3e51e8f1440314ba)})`,
    color: `var(--ds-text-selected, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`,
    ':visited': {
        color: `var(--ds-text-selected, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`
    },
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${(0, $a7f8c6b391092279$export$3e51e8f1440314ba)})`,
        color: `var(--ds-text-selected, ${(0, $a7f8c6b391092279$export$c39c0fe0f26207ae)})`
    },
    '&:active': {
        backgroundColor: `var(--ds-background-selected-pressed, ${(0, $a7f8c6b391092279$export$226de0355ed012f8)})`,
        color: `var(--ds-text-selected, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`
    }
};
const $4119079cc6831898$export$aed216a85ec468ac = ({ isSelected: isSelected, isDisabled: isDisabled })=>{
    return {
        // This padding is set to ensure that the center of the left icon
        // is approximately center aligned with the horizontal app switcher.
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-100, 8px)",
        borderRadius: "var(--ds-border-radius, 3px)",
        // -- TODO: DELETE THESE COLOR OVERRIDES WHEN CLEANING UP FALLBACK THEMING --
        // Menu and side navigation are now color aligned so they do not need this!
        // See: https://product-fabric.atlassian.net/browse/DSP-1684
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        ...!isDisabled && !isSelected && $4119079cc6831898$var$defaultStyles,
        ...!isDisabled && isSelected && $4119079cc6831898$var$selectedStyles,
        // -- END TODO --------------------------------------------------------------
        ['& [data-item-elem-before]']: {
            height: '1.5rem',
            width: '1.5rem'
        }
    };
};
const $4119079cc6831898$export$a5c27bed78cfecb9 = ()=>{
    return {
        paddingInline: "var(--ds-space-100, 8px)"
    };
};

});
var $a7f8c6b391092279$exports = {};

$parcel$export($a7f8c6b391092279$exports, "R50", () => $a7f8c6b391092279$export$4b84fd0e2c617bd);
$parcel$export($a7f8c6b391092279$exports, "R75", () => $a7f8c6b391092279$export$b34b069eff244586);
$parcel$export($a7f8c6b391092279$exports, "R100", () => $a7f8c6b391092279$export$be802dd0d8b57f35);
$parcel$export($a7f8c6b391092279$exports, "R200", () => $a7f8c6b391092279$export$60847d42f9da92a6);
$parcel$export($a7f8c6b391092279$exports, "R300", () => $a7f8c6b391092279$export$4a7404f376229999);
$parcel$export($a7f8c6b391092279$exports, "R400", () => $a7f8c6b391092279$export$2010d0fb4295b346);
$parcel$export($a7f8c6b391092279$exports, "R500", () => $a7f8c6b391092279$export$2837b5a1a71d5c02);
$parcel$export($a7f8c6b391092279$exports, "Y50", () => $a7f8c6b391092279$export$8d9596b529bbb9cf);
$parcel$export($a7f8c6b391092279$exports, "Y75", () => $a7f8c6b391092279$export$41060a744ab0b7ae);
$parcel$export($a7f8c6b391092279$exports, "Y100", () => $a7f8c6b391092279$export$1cc05bbbf340e559);
$parcel$export($a7f8c6b391092279$exports, "Y200", () => $a7f8c6b391092279$export$5aae31392d72caaa);
$parcel$export($a7f8c6b391092279$exports, "Y300", () => $a7f8c6b391092279$export$c6930421db9fa514);
$parcel$export($a7f8c6b391092279$exports, "Y400", () => $a7f8c6b391092279$export$59619663aa6500fb);
$parcel$export($a7f8c6b391092279$exports, "Y500", () => $a7f8c6b391092279$export$874739ea9e379ab6);
$parcel$export($a7f8c6b391092279$exports, "G50", () => $a7f8c6b391092279$export$8a6341c32b6a3ee6);
$parcel$export($a7f8c6b391092279$exports, "G75", () => $a7f8c6b391092279$export$69a3bf21b9686c2b);
$parcel$export($a7f8c6b391092279$exports, "G100", () => $a7f8c6b391092279$export$afbce1382ec95f73);
$parcel$export($a7f8c6b391092279$exports, "G200", () => $a7f8c6b391092279$export$747d86715d4175de);
$parcel$export($a7f8c6b391092279$exports, "G300", () => $a7f8c6b391092279$export$940e1f69e873f202);
$parcel$export($a7f8c6b391092279$exports, "G400", () => $a7f8c6b391092279$export$a49394138f7b8e85);
$parcel$export($a7f8c6b391092279$exports, "G500", () => $a7f8c6b391092279$export$6fa04827ac68a4fb);
$parcel$export($a7f8c6b391092279$exports, "B50", () => $a7f8c6b391092279$export$226de0355ed012f8);
$parcel$export($a7f8c6b391092279$exports, "B75", () => $a7f8c6b391092279$export$8c13c2ee36917869);
$parcel$export($a7f8c6b391092279$exports, "B100", () => $a7f8c6b391092279$export$ecfc1dff386a3e7a);
$parcel$export($a7f8c6b391092279$exports, "B200", () => $a7f8c6b391092279$export$215b7063051591f1);
$parcel$export($a7f8c6b391092279$exports, "B300", () => $a7f8c6b391092279$export$e62e8919cca44969);
$parcel$export($a7f8c6b391092279$exports, "B400", () => $a7f8c6b391092279$export$b3de0ae08da2ce64);
$parcel$export($a7f8c6b391092279$exports, "B500", () => $a7f8c6b391092279$export$a6ee3d71bc067634);
$parcel$export($a7f8c6b391092279$exports, "B600", () => $a7f8c6b391092279$export$67f15409e87642a1);
$parcel$export($a7f8c6b391092279$exports, "B700", () => $a7f8c6b391092279$export$f0539dbc42dbb067);
$parcel$export($a7f8c6b391092279$exports, "P50", () => $a7f8c6b391092279$export$363e4475840015bb);
$parcel$export($a7f8c6b391092279$exports, "P75", () => $a7f8c6b391092279$export$4b0a4417ed59760f);
$parcel$export($a7f8c6b391092279$exports, "P100", () => $a7f8c6b391092279$export$6011520a64d9a187);
$parcel$export($a7f8c6b391092279$exports, "P200", () => $a7f8c6b391092279$export$a7175d4e9206bc80);
$parcel$export($a7f8c6b391092279$exports, "P300", () => $a7f8c6b391092279$export$b48405b95304b5a1);
$parcel$export($a7f8c6b391092279$exports, "P400", () => $a7f8c6b391092279$export$c71e4279dd54a18d);
$parcel$export($a7f8c6b391092279$exports, "P500", () => $a7f8c6b391092279$export$147899de772240ec);
$parcel$export($a7f8c6b391092279$exports, "T50", () => $a7f8c6b391092279$export$2cf711fe14c66f06);
$parcel$export($a7f8c6b391092279$exports, "T75", () => $a7f8c6b391092279$export$7a8f4d33f6f9772c);
$parcel$export($a7f8c6b391092279$exports, "T100", () => $a7f8c6b391092279$export$776c9c497ef08533);
$parcel$export($a7f8c6b391092279$exports, "T200", () => $a7f8c6b391092279$export$69cb3ca10c1e330e);
$parcel$export($a7f8c6b391092279$exports, "T300", () => $a7f8c6b391092279$export$9dc1ef0f3f48059b);
$parcel$export($a7f8c6b391092279$exports, "T400", () => $a7f8c6b391092279$export$7c835c78b6fcdef8);
$parcel$export($a7f8c6b391092279$exports, "T500", () => $a7f8c6b391092279$export$6036577f95c3877e);
$parcel$export($a7f8c6b391092279$exports, "N0", () => $a7f8c6b391092279$export$29a4f05edc054374);
$parcel$export($a7f8c6b391092279$exports, "N10", () => $a7f8c6b391092279$export$e655ef011c4aa1a2);
$parcel$export($a7f8c6b391092279$exports, "N20", () => $a7f8c6b391092279$export$9fdfb749e33cdf97);
$parcel$export($a7f8c6b391092279$exports, "N30", () => $a7f8c6b391092279$export$3e51e8f1440314ba);
$parcel$export($a7f8c6b391092279$exports, "N40", () => $a7f8c6b391092279$export$1ce2d1575d444ceb);
$parcel$export($a7f8c6b391092279$exports, "N50", () => $a7f8c6b391092279$export$8754fc7e6d8b3000);
$parcel$export($a7f8c6b391092279$exports, "N60", () => $a7f8c6b391092279$export$c2e91cbeada39b8b);
$parcel$export($a7f8c6b391092279$exports, "N70", () => $a7f8c6b391092279$export$5f71e19f3a7ad9de);
$parcel$export($a7f8c6b391092279$exports, "N80", () => $a7f8c6b391092279$export$eaa8c8a70ac22806);
$parcel$export($a7f8c6b391092279$exports, "N90", () => $a7f8c6b391092279$export$7c87d337fb91a97d);
$parcel$export($a7f8c6b391092279$exports, "N100", () => $a7f8c6b391092279$export$d6447c357493214f);
$parcel$export($a7f8c6b391092279$exports, "N200", () => $a7f8c6b391092279$export$f563ee71e9ee74cd);
$parcel$export($a7f8c6b391092279$exports, "N300", () => $a7f8c6b391092279$export$e2ef2124cf4024b1);
$parcel$export($a7f8c6b391092279$exports, "N400", () => $a7f8c6b391092279$export$eece5f492e429f08);
$parcel$export($a7f8c6b391092279$exports, "N500", () => $a7f8c6b391092279$export$c39c0fe0f26207ae);
$parcel$export($a7f8c6b391092279$exports, "N600", () => $a7f8c6b391092279$export$7090862dc3038a9f);
$parcel$export($a7f8c6b391092279$exports, "N700", () => $a7f8c6b391092279$export$ad0bacf983b7ddaa);
$parcel$export($a7f8c6b391092279$exports, "N800", () => $a7f8c6b391092279$export$7d61b15e0da132af);
$parcel$export($a7f8c6b391092279$exports, "N900", () => $a7f8c6b391092279$export$fbda843f0a27fe96);
$parcel$export($a7f8c6b391092279$exports, "N10A", () => $a7f8c6b391092279$export$791e57b27ca738ef);
$parcel$export($a7f8c6b391092279$exports, "N20A", () => $a7f8c6b391092279$export$8d43898f60b96a82);
$parcel$export($a7f8c6b391092279$exports, "N30A", () => $a7f8c6b391092279$export$920c0d5c49070351);
$parcel$export($a7f8c6b391092279$exports, "N40A", () => $a7f8c6b391092279$export$46987b49aab6d1a8);
$parcel$export($a7f8c6b391092279$exports, "N50A", () => $a7f8c6b391092279$export$7d3359664e8bb0e5);
$parcel$export($a7f8c6b391092279$exports, "N60A", () => $a7f8c6b391092279$export$d2d3bedfb276cac0);
$parcel$export($a7f8c6b391092279$exports, "N70A", () => $a7f8c6b391092279$export$6e5e7499ff054f6d);
$parcel$export($a7f8c6b391092279$exports, "N80A", () => $a7f8c6b391092279$export$59264b346c877fa7);
$parcel$export($a7f8c6b391092279$exports, "N90A", () => $a7f8c6b391092279$export$d092757d7c64925c);
$parcel$export($a7f8c6b391092279$exports, "N100A", () => $a7f8c6b391092279$export$486ab785e4bac3c6);
$parcel$export($a7f8c6b391092279$exports, "N200A", () => $a7f8c6b391092279$export$fba592bbc6419fea);
$parcel$export($a7f8c6b391092279$exports, "N300A", () => $a7f8c6b391092279$export$13609db0e6812ab8);
$parcel$export($a7f8c6b391092279$exports, "N400A", () => $a7f8c6b391092279$export$fbae4efaa892d883);
$parcel$export($a7f8c6b391092279$exports, "N500A", () => $a7f8c6b391092279$export$f13946d26f440ce6);
$parcel$export($a7f8c6b391092279$exports, "N600A", () => $a7f8c6b391092279$export$19f58225ac52a306);
$parcel$export($a7f8c6b391092279$exports, "N700A", () => $a7f8c6b391092279$export$6384f09da70e7b62);
$parcel$export($a7f8c6b391092279$exports, "N800A", () => $a7f8c6b391092279$export$d0dccc730683edc2);
$parcel$export($a7f8c6b391092279$exports, "DN900", () => $a7f8c6b391092279$export$2f6319cf7d736c2a);
$parcel$export($a7f8c6b391092279$exports, "DN800", () => $a7f8c6b391092279$export$95126bc8884d6634);
$parcel$export($a7f8c6b391092279$exports, "DN700", () => $a7f8c6b391092279$export$8338d8c35d44ff1);
$parcel$export($a7f8c6b391092279$exports, "DN600", () => $a7f8c6b391092279$export$5368d76ae4fbbda7);
$parcel$export($a7f8c6b391092279$exports, "DN500", () => $a7f8c6b391092279$export$9f0a771d16ec8d36);
$parcel$export($a7f8c6b391092279$exports, "DN400", () => $a7f8c6b391092279$export$abcf8c38338b4aa5);
$parcel$export($a7f8c6b391092279$exports, "DN300", () => $a7f8c6b391092279$export$97e81faa16a182c7);
$parcel$export($a7f8c6b391092279$exports, "DN200", () => $a7f8c6b391092279$export$bfe21c59123ecf33);
$parcel$export($a7f8c6b391092279$exports, "DN100", () => $a7f8c6b391092279$export$ee82aa2ea6a1558);
$parcel$export($a7f8c6b391092279$exports, "DN90", () => $a7f8c6b391092279$export$682927c6ed76be02);
$parcel$export($a7f8c6b391092279$exports, "DN80", () => $a7f8c6b391092279$export$91fd9994c5be9757);
$parcel$export($a7f8c6b391092279$exports, "DN70", () => $a7f8c6b391092279$export$d281fbfe3cff2df6);
$parcel$export($a7f8c6b391092279$exports, "DN60", () => $a7f8c6b391092279$export$3902c91d8b98a753);
$parcel$export($a7f8c6b391092279$exports, "DN50", () => $a7f8c6b391092279$export$8e8133c1ba5845b5);
$parcel$export($a7f8c6b391092279$exports, "DN40", () => $a7f8c6b391092279$export$33ff357f6620b39);
$parcel$export($a7f8c6b391092279$exports, "DN30", () => $a7f8c6b391092279$export$633847cf062b69e0);
$parcel$export($a7f8c6b391092279$exports, "DN20", () => $a7f8c6b391092279$export$9776a6e503bdbf76);
$parcel$export($a7f8c6b391092279$exports, "DN10", () => $a7f8c6b391092279$export$6c813d5160dff5db);
$parcel$export($a7f8c6b391092279$exports, "DN0", () => $a7f8c6b391092279$export$3d4f271a500072a);
$parcel$export($a7f8c6b391092279$exports, "DN800A", () => $a7f8c6b391092279$export$fe151285c22759ec);
$parcel$export($a7f8c6b391092279$exports, "DN700A", () => $a7f8c6b391092279$export$a101c6190d0da34);
$parcel$export($a7f8c6b391092279$exports, "DN600A", () => $a7f8c6b391092279$export$4b16f52932fda51);
$parcel$export($a7f8c6b391092279$exports, "DN500A", () => $a7f8c6b391092279$export$a74bcd7b9845b0d8);
$parcel$export($a7f8c6b391092279$exports, "DN400A", () => $a7f8c6b391092279$export$9209c179316d1751);
$parcel$export($a7f8c6b391092279$exports, "DN300A", () => $a7f8c6b391092279$export$88f55133f636c8dd);
$parcel$export($a7f8c6b391092279$exports, "DN200A", () => $a7f8c6b391092279$export$51126f85d1009512);
$parcel$export($a7f8c6b391092279$exports, "DN100A", () => $a7f8c6b391092279$export$a069b547bd23af78);
$parcel$export($a7f8c6b391092279$exports, "DN90A", () => $a7f8c6b391092279$export$40cce05af3b2600a);
$parcel$export($a7f8c6b391092279$exports, "DN80A", () => $a7f8c6b391092279$export$b78942185925a0d);
$parcel$export($a7f8c6b391092279$exports, "DN70A", () => $a7f8c6b391092279$export$e058fb44b8eaafca);
$parcel$export($a7f8c6b391092279$exports, "DN60A", () => $a7f8c6b391092279$export$92b0b8de26920c18);
$parcel$export($a7f8c6b391092279$exports, "DN50A", () => $a7f8c6b391092279$export$67564f7459d3fc9e);
$parcel$export($a7f8c6b391092279$exports, "DN40A", () => $a7f8c6b391092279$export$77868e1ca884ffa3);
$parcel$export($a7f8c6b391092279$exports, "DN30A", () => $a7f8c6b391092279$export$2afd71d7d3ea2cd5);
$parcel$export($a7f8c6b391092279$exports, "DN20A", () => $a7f8c6b391092279$export$f2a0acaab9972c70);
$parcel$export($a7f8c6b391092279$exports, "DN10A", () => $a7f8c6b391092279$export$9ab70e67d6475361);
$parcel$export($a7f8c6b391092279$exports, "T30", () => $a7f8c6b391092279$export$d2adc5dedf09fced);
$parcel$export($a7f8c6b391092279$exports, "L50", () => $a7f8c6b391092279$export$f51762073d2bb381);
$parcel$export($a7f8c6b391092279$exports, "L75", () => $a7f8c6b391092279$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $a7f8c6b391092279$export$4b84fd0e2c617bd = '#FFEBE6';
const $a7f8c6b391092279$export$b34b069eff244586 = '#FFBDAD';
const $a7f8c6b391092279$export$be802dd0d8b57f35 = '#FF8F73';
const $a7f8c6b391092279$export$60847d42f9da92a6 = '#FF7452';
const $a7f8c6b391092279$export$4a7404f376229999 = '#FF5630';
const $a7f8c6b391092279$export$2010d0fb4295b346 = '#DE350B';
const $a7f8c6b391092279$export$2837b5a1a71d5c02 = '#BF2600';
const $a7f8c6b391092279$export$8d9596b529bbb9cf = '#FFFAE6';
const $a7f8c6b391092279$export$41060a744ab0b7ae = '#FFF0B3';
const $a7f8c6b391092279$export$1cc05bbbf340e559 = '#FFE380';
const $a7f8c6b391092279$export$5aae31392d72caaa = '#FFC400';
const $a7f8c6b391092279$export$c6930421db9fa514 = '#FFAB00';
const $a7f8c6b391092279$export$59619663aa6500fb = '#FF991F';
const $a7f8c6b391092279$export$874739ea9e379ab6 = '#FF8B00';
const $a7f8c6b391092279$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $a7f8c6b391092279$export$69a3bf21b9686c2b = '#ABF5D1';
const $a7f8c6b391092279$export$afbce1382ec95f73 = '#79F2C0';
const $a7f8c6b391092279$export$747d86715d4175de = '#57D9A3';
const $a7f8c6b391092279$export$940e1f69e873f202 = '#36B37E';
const $a7f8c6b391092279$export$a49394138f7b8e85 = '#00875A';
const $a7f8c6b391092279$export$6fa04827ac68a4fb = '#006644';
const $a7f8c6b391092279$export$226de0355ed012f8 = '#DEEBFF';
const $a7f8c6b391092279$export$8c13c2ee36917869 = '#B3D4FF';
const $a7f8c6b391092279$export$ecfc1dff386a3e7a = '#4C9AFF';
const $a7f8c6b391092279$export$215b7063051591f1 = '#2684FF';
const $a7f8c6b391092279$export$e62e8919cca44969 = '#0065FF';
const $a7f8c6b391092279$export$b3de0ae08da2ce64 = '#0052CC';
const $a7f8c6b391092279$export$a6ee3d71bc067634 = '#0747A6';
const $a7f8c6b391092279$export$67f15409e87642a1 = '#669DF1';
const $a7f8c6b391092279$export$f0539dbc42dbb067 = '#8FB8F6';
const $a7f8c6b391092279$export$363e4475840015bb = '#EAE6FF';
const $a7f8c6b391092279$export$4b0a4417ed59760f = '#C0B6F2';
const $a7f8c6b391092279$export$6011520a64d9a187 = '#998DD9';
const $a7f8c6b391092279$export$a7175d4e9206bc80 = '#8777D9';
const $a7f8c6b391092279$export$b48405b95304b5a1 = '#6554C0';
const $a7f8c6b391092279$export$c71e4279dd54a18d = '#5243AA';
const $a7f8c6b391092279$export$147899de772240ec = '#403294';
const $a7f8c6b391092279$export$2cf711fe14c66f06 = '#E6FCFF';
const $a7f8c6b391092279$export$7a8f4d33f6f9772c = '#B3F5FF';
const $a7f8c6b391092279$export$776c9c497ef08533 = '#79E2F2';
const $a7f8c6b391092279$export$69cb3ca10c1e330e = '#00C7E6';
const $a7f8c6b391092279$export$9dc1ef0f3f48059b = '#00B8D9';
const $a7f8c6b391092279$export$7c835c78b6fcdef8 = '#00A3BF';
const $a7f8c6b391092279$export$6036577f95c3877e = '#008DA6';
const $a7f8c6b391092279$export$29a4f05edc054374 = '#FFFFFF';
const $a7f8c6b391092279$export$e655ef011c4aa1a2 = '#FAFBFC';
const $a7f8c6b391092279$export$9fdfb749e33cdf97 = '#F4F5F7';
const $a7f8c6b391092279$export$3e51e8f1440314ba = '#EBECF0';
const $a7f8c6b391092279$export$1ce2d1575d444ceb = '#DFE1E6';
const $a7f8c6b391092279$export$8754fc7e6d8b3000 = '#C1C7D0';
const $a7f8c6b391092279$export$c2e91cbeada39b8b = '#B3BAC5';
const $a7f8c6b391092279$export$5f71e19f3a7ad9de = '#A5ADBA';
const $a7f8c6b391092279$export$eaa8c8a70ac22806 = '#97A0AF';
const $a7f8c6b391092279$export$7c87d337fb91a97d = '#8993A4';
const $a7f8c6b391092279$export$d6447c357493214f = '#7A869A';
const $a7f8c6b391092279$export$f563ee71e9ee74cd = '#6B778C';
const $a7f8c6b391092279$export$e2ef2124cf4024b1 = '#5E6C84';
const $a7f8c6b391092279$export$eece5f492e429f08 = '#505F79';
const $a7f8c6b391092279$export$c39c0fe0f26207ae = '#42526E';
const $a7f8c6b391092279$export$7090862dc3038a9f = '#344563';
const $a7f8c6b391092279$export$ad0bacf983b7ddaa = '#253858';
const $a7f8c6b391092279$export$7d61b15e0da132af = '#172B4D';
const $a7f8c6b391092279$export$fbda843f0a27fe96 = '#091E42';
const $a7f8c6b391092279$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $a7f8c6b391092279$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $a7f8c6b391092279$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $a7f8c6b391092279$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $a7f8c6b391092279$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $a7f8c6b391092279$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $a7f8c6b391092279$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $a7f8c6b391092279$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $a7f8c6b391092279$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $a7f8c6b391092279$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $a7f8c6b391092279$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $a7f8c6b391092279$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $a7f8c6b391092279$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $a7f8c6b391092279$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $a7f8c6b391092279$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $a7f8c6b391092279$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $a7f8c6b391092279$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $a7f8c6b391092279$export$2f6319cf7d736c2a = '#E6EDFA';
const $a7f8c6b391092279$export$95126bc8884d6634 = '#DCE5F5';
const $a7f8c6b391092279$export$8338d8c35d44ff1 = '#CED9EB';
const $a7f8c6b391092279$export$5368d76ae4fbbda7 = '#B8C7E0';
const $a7f8c6b391092279$export$9f0a771d16ec8d36 = '#ABBBD6';
const $a7f8c6b391092279$export$abcf8c38338b4aa5 = '#9FB0CC';
const $a7f8c6b391092279$export$97e81faa16a182c7 = '#8C9CB8';
const $a7f8c6b391092279$export$bfe21c59123ecf33 = '#7988A3';
const $a7f8c6b391092279$export$ee82aa2ea6a1558 = '#67758F';
const $a7f8c6b391092279$export$682927c6ed76be02 = '#56637A';
const $a7f8c6b391092279$export$91fd9994c5be9757 = '#455166';
const $a7f8c6b391092279$export$d281fbfe3cff2df6 = '#3B475C';
const $a7f8c6b391092279$export$3902c91d8b98a753 = '#313D52';
const $a7f8c6b391092279$export$8e8133c1ba5845b5 = '#283447';
const $a7f8c6b391092279$export$33ff357f6620b39 = '#202B3D';
const $a7f8c6b391092279$export$633847cf062b69e0 = '#1B2638';
const $a7f8c6b391092279$export$9776a6e503bdbf76 = '#121A29';
const $a7f8c6b391092279$export$6c813d5160dff5db = '#0E1624';
const $a7f8c6b391092279$export$3d4f271a500072a = '#0D1424';
const $a7f8c6b391092279$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $a7f8c6b391092279$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $a7f8c6b391092279$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $a7f8c6b391092279$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $a7f8c6b391092279$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $a7f8c6b391092279$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $a7f8c6b391092279$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $a7f8c6b391092279$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $a7f8c6b391092279$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $a7f8c6b391092279$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $a7f8c6b391092279$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $a7f8c6b391092279$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $a7f8c6b391092279$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $a7f8c6b391092279$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $a7f8c6b391092279$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $a7f8c6b391092279$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $a7f8c6b391092279$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $a7f8c6b391092279$export$d2adc5dedf09fced = '#292A2E';
const $a7f8c6b391092279$export$f51762073d2bb381 = '#94C748';
const $a7f8c6b391092279$export$95e26d54def96891 = '#B3DF72';



parcelRegister("9K9UK", function(module, exports) {

$parcel$export(module.exports, "default", () => $386897d65382f1d4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eCE62 = parcelRequire("eCE62");

var $c48kn = parcelRequire("c48kn");

var $fsi33 = parcelRequire("fsi33");
/**
 * __Skeleton item__
 *
 * A skeleton item can be used to reduce the perceived loading time.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#loading)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $386897d65382f1d4$var$SkeletonItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $fsi33.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCE62.default), {
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
        cssFn: ()=>({
                ...(0, $c48kn.sectionHeaderSpacingStyles)(),
                // This doubles up & to get a higher specificity as well as to not overwite the base styles.
                '&&::before': {
                    height: '1.5rem',
                    marginRight: "var(--ds-space-200, 16px)",
                    width: '1.5rem'
                }
            }),
        ...props
    });
};
var $386897d65382f1d4$export$2e2bcd8739ae039 = $386897d65382f1d4$var$SkeletonItem;

});



parcelRegister("gbGmI", function(module, exports) {

$parcel$export(module.exports, "setPerformanceMarkLoadStart", () => $46c186c6902de7dc$export$4166241bf9111f66);
$parcel$export(module.exports, "setPerformanceMarkLoadEnd", () => $46c186c6902de7dc$export$edbd543f308bbef5);

var $5e7oM = parcelRequire("5e7oM");

var $azzrO = parcelRequire("azzrO");
const $46c186c6902de7dc$export$4166241bf9111f66 = ()=>{
    const sideBarSegment = (0, $azzrO.pageSegmentStore).getSegment((0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).loadStart);
};
const $46c186c6902de7dc$export$edbd543f308bbef5 = ()=>{
    const sideBarSegment = (0, $azzrO.pageSegmentStore).getSegment((0, $5e7oM.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).loadEnd);
};

});

parcelRegister("6pa7K", function(module, exports) {

let $4a9cee4a23223f39$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $4a9cee4a23223f39$var$load("h2MrD"),
    $4a9cee4a23223f39$var$load("bYT2S"),
    $4a9cee4a23223f39$var$load("cM9em"),
    $4a9cee4a23223f39$var$load("fr9NE"),
    $4a9cee4a23223f39$var$load("gQZpl")
]).then(()=>parcelRequire('6Pefo'));

});


parcelRegister("dmx0y", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationGeneralResource", () => $3e822b05b84662f2$export$b622f7400bfafd0d);

var $2M1hQ = parcelRequire("2M1hQ");


const $3e822b05b84662f2$export$b622f7400bfafd0d = (0, $2M1hQ.createResource)({
    type: (0, $3d90c62269ed88a0$export$e780b172f774b673),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("cYY7z"))
});

});
const $3d90c62269ed88a0$export$e780b172f774b673 = 'RESOURCE_TYPE_SYSTEM_CONFIGURATION_GENERAL';

parcelRegister("cYY7z", function(module, exports) {

let $9739b96b01a141ad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9739b96b01a141ad$var$load("6L998").then(()=>parcelRequire('khTCh'));

});


parcelRegister("jsJ7J", function(module, exports) {

$parcel$export(module.exports, "emailNotificationsLogAccessRoute", () => $acdb6757893e541c$export$aed294a4a292b909);
const $acdb6757893e541c$export$aed294a4a292b909 = {
    name: 'global-admin-helper-email-notifications-log',
    path: '/jira/settings/system/notification-logs',
    exact: true
};

});

parcelRegister("hBziA", function(module, exports) {

$parcel$export(module.exports, "notificationLogsEntryPoint", () => $e96cd1acff95af13$export$818d841e00bb3749);

var $aGYm3 = parcelRequire("aGYm3");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $e96cd1acff95af13$export$818d841e00bb3749 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("iC3Q3")), {
        moduleId: "d533cc53"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                notificationLogs: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $aGYm3.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectIds: context?.query?.projectId,
                        notificationType: 'INTERNAL_NOTIFICATION',
                        notificationActionType: 'USER_INVITE',
                        recipientId: ''
                    }
                }
            },
            extraProps: {
                accountId: tenantContext.atlassianAccountId
            }
        })
});

});
parcelRegister("aGYm3", function(module, exports) {

$parcel$export(module.exports, "default", () => $25a34f05175c2102$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6106f34f1da05e19191cff41bffd4296>>
 * @relayHash 1d90cf309bc3da9c32297c3b1e952819
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71e1f26fd67e2af410f2d8354171d8867b0efd6546709fc85bec1419f20e5b6d
const $25a34f05175c2102$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "71e1f26fd67e2af410f2d8354171d8867b0efd6546709fc85bec1419f20e5b6d",
        "metadata": {},
        "name": "uiNotificationLogsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $25a34f05175c2102$export$2e2bcd8739ae039 = $25a34f05175c2102$var$node;

});

parcelRegister("iC3Q3", function(module, exports) {

let $d8cec0e45d4c0937$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d8cec0e45d4c0937$var$load("3HpMo").then(()=>parcelRequire('ktpmL'));

});



parcelRegister("fMVEG", function(module, exports) {

$parcel$export(module.exports, "externalImportRouteEntry", () => $88a6b2c74571ee4b$export$d55ce647d8216437);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $4j39S = parcelRequire("4j39S");

var $5pSYQ = parcelRequire("5pSYQ");

var $5ZnBW = parcelRequire("5ZnBW");
const $88a6b2c74571ee4b$export$d55ce647d8216437 = (0, $7NszV.createEntry)((0, $4j39S.externalImportRoute), ()=>({
        group: 'global-settings',
        component: (0, $5ZnBW.default),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("4j39S", function(module, exports) {

$parcel$export(module.exports, "externalImportRoute", () => $105ac7e3a2002ccc$export$17c79100fc4c65a1);
const $105ac7e3a2002ccc$export$17c79100fc4c65a1 = {
    name: 'external-import',
    path: '/jira/settings/system/external-import'
};

});

parcelRegister("5ZnBW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b72a6c6c5d8947e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7b72a6c6c5d8947e$var$LazyExternalImport = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("6wIQl")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/admin-pages/external-import/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7b72a6c6c5d8947e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7b72a6c6c5d8947e$var$LazyExternalImport,
        pageId: "external-import-general",
        shouldShowSpinner: false
    });

});
parcelRegister("6wIQl", function(module, exports) {

let $4c088430ce553fc4$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $4c088430ce553fc4$var$load("eNmuD"),
    $4c088430ce553fc4$var$load("cM9em"),
    $4c088430ce553fc4$var$load("fr9NE"),
    $4c088430ce553fc4$var$load("h2MrD"),
    $4c088430ce553fc4$var$load("bYT2S"),
    $4c088430ce553fc4$var$load("kWrFZ"),
    $4c088430ce553fc4$var$load("jH0q0")
]).then(()=>parcelRequire('lBo8Z'));

});



parcelRegister("4BdYV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsGlobalPermissionsRouteEntry", () => $29ac5183332fb76e$export$34203273711b537f);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $kiD5R = parcelRequire("kiD5R");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $1U35o = parcelRequire("1U35o");

var $5lsNZ = parcelRequire("5lsNZ");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $5pSYQ = parcelRequire("5pSYQ");

const $29ac5183332fb76e$var$LazyGlobalPermissions = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7acLa"))), {
    moduleId: "./src/packages/permissions-administration/pages/global-permissions/src/index.tsx"
});
const $29ac5183332fb76e$var$LazyGlobalPermissionsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $29ac5183332fb76e$var$LazyGlobalPermissions,
        pageId: "jira-global-permissions",
        shouldShowSpinner: true
    });
const $29ac5183332fb76e$export$34203273711b537f = (0, $7NszV.createEntry)((0, $1U35o.globalSettingsGlobalPermissionsRoute), ()=>({
        group: 'global-settings',
        component: (0, $cSD7y.componentWithFG)('olympus-global-permissions-fe-modernisation', $29ac5183332fb76e$var$LazyGlobalPermissionsPage, (0, $5lsNZ.default)),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $kiD5R.globalPermissionsResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        canTransitionIn: ()=>(0, $4R6GH.fg)('olympus-global-permissions-fe-modernisation'),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $29ac5183332fb76e$var$LazyGlobalPermissions
        ],
        meta: {
            reporting: {
                id: 'GlobalPermissions',
                packageName: 'jiraAdminPagesGlobalPermissions',
                teamName: 'gordian'
            }
        }
    }));

});
parcelRegister("ibkIl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsLayout", () => $3eb51436f6201a33$export$e6aef6083548e882);

var $2BrOV = parcelRequire("2BrOV");

var $aPfsS = parcelRequire("aPfsS");
const $3eb51436f6201a33$export$e6aef6083548e882 = (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout));

});

parcelRegister("kiD5R", function(module, exports) {

$parcel$export(module.exports, "globalPermissionsResource", () => $896d1d986bb0ea74$export$9a5d1bc1ff678482);

var $ao2h1 = parcelRequire("ao2h1");

var $5Uo2r = parcelRequire("5Uo2r");
const $896d1d986bb0ea74$var$RESOURCE_TYPE_GLOBAL_PERMISSIONS = 'GLOBAL_PERMISSIONS';
const $896d1d986bb0ea74$export$9a5d1bc1ff678482 = (0, $ao2h1.createRelayResource)({
    type: $896d1d986bb0ea74$var$RESOURCE_TYPE_GLOBAL_PERMISSIONS,
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $5Uo2r.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("5Uo2r", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed1cca93794a5156$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f014b4044459efb94c4edb99f926dd1>>
 * @relayHash 402a674bdd82767605c36953e2732f07
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b2ad70438dbcc77ff45c7608ecd4e7382a18aa895a82fd26e83279a282b7ab6
const $ed1cca93794a5156$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_globalPermissionsAndGrantsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "globalPermissionsAndGrants",
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "getGlobalPermissionsAndGrants",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalPermissionsTable_globalPermissions"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "grantPermissionDialog_globalPermissions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.globalPermissionsAndGrants"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_globalPermissionsAndGrantsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "globalPermissionsAndGrants",
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "getGlobalPermissionsAndGrants",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraGlobalPermissionGrants",
                                            "kind": "LinkedField",
                                            "name": "globalPermissionGrants",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraGlobalPermission",
                                                    "kind": "LinkedField",
                                                    "name": "permission",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isManagedByJira"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraGroup",
                                                    "kind": "LinkedField",
                                                    "name": "groups",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "groupId"
                                                        },
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraGlobalPermissionGrantsList"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5b2ad70438dbcc77ff45c7608ecd4e7382a18aa895a82fd26e83279a282b7ab6",
            "metadata": {},
            "name": "main_globalPermissionsAndGrantsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ed1cca93794a5156$var$node.hash = "9f1b7eb98b606c41655e4fa1f200a351";
var $ed1cca93794a5156$export$2e2bcd8739ae039 = $ed1cca93794a5156$var$node;

});


parcelRegister("1U35o", function(module, exports) {

$parcel$export(module.exports, "globalSettingsGlobalPermissionsRoute", () => $efa019df4aa72b9f$export$236ce89eb737f752);
const $efa019df4aa72b9f$export$236ce89eb737f752 = {
    name: 'global-settings-global-permissions',
    path: '/secure/admin/global-permissions'
};

});

parcelRegister("5lsNZ", function(module, exports) {

$parcel$export(module.exports, "LazyNotFoundErrorPage", () => $5ed1828a3f7dd5a7$export$57c5c0b5a0cdb5b7);
$parcel$export(module.exports, "default", () => $5ed1828a3f7dd5a7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $5ed1828a3f7dd5a7$export$57c5c0b5a0cdb5b7 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("3p5C2")), {
    moduleId: "./src/packages/spa-apps/error-pages/not-found/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5ed1828a3f7dd5a7$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $5ed1828a3f7dd5a7$export$57c5c0b5a0cdb5b7,
        pageId: "errors-404",
        shouldShowSpinner: false
    });

});
parcelRegister("3p5C2", function(module, exports) {

let $27a80f6f77689595$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $27a80f6f77689595$var$load("kfXhT"),
    $27a80f6f77689595$var$load("2Lfdl"),
    $27a80f6f77689595$var$load("92sUi"),
    $27a80f6f77689595$var$load("i5RRW"),
    $27a80f6f77689595$var$load("eNmuD"),
    $27a80f6f77689595$var$load("cM9em"),
    $27a80f6f77689595$var$load("fr9NE"),
    $27a80f6f77689595$var$load("h2MrD"),
    $27a80f6f77689595$var$load("bYT2S"),
    $27a80f6f77689595$var$load("hPzOn"),
    $27a80f6f77689595$var$load("8uqRL")
]).then(()=>parcelRequire('6iSaB'));

});


parcelRegister("7acLa", function(module, exports) {

let $53735d6273261514$var$load = (parcelRequire("28QjX"))(4);
module.exports = $53735d6273261514$var$load("asO3X").then(()=>parcelRequire('csGky'));

});


parcelRegister("laDqO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueHierarchyRedirectRouteEntry", () => $7b04b3e8e151f1c0$export$ce3302d254f9c0b4);

var $5uXOq = parcelRequire("5uXOq");

var $g87MG = parcelRequire("g87MG");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $gTOS3 = parcelRequire("gTOS3");

var $ds5qV = parcelRequire("ds5qV");

var $dKJVX = parcelRequire("dKJVX");
const $7b04b3e8e151f1c0$export$ce3302d254f9c0b4 = (0, $7NszV.createEntry)((0, $gTOS3.globalSettingsIssueHierarchyRedirectRoute), ()=>({
        group: 'global-settings',
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
                to: "/jira/settings/issues/issue-hierarchy"
            }),
        isRedirect: true,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $g87MG.issueHierarchyPageResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dKJVX.LazyIssueHierarchyDirectory)
        ]
    }));

});
parcelRegister("g87MG", function(module, exports) {

$parcel$export(module.exports, "issueHierarchyPageResource", () => $6f06dee5876402c3$export$98d50a2e19509817);

var $ao2h1 = parcelRequire("ao2h1");

var $7a4aR = parcelRequire("7a4aR");
const $6f06dee5876402c3$export$98d50a2e19509817 = (0, $ao2h1.createRelayResource)({
    type: 'RESOURCE1',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $7a4aR.default),
            variables: {
                cloudId: tenantContext.cloudId
            }
        })
});

});
parcelRegister("7a4aR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ea8bf05e90a48f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8302ec971b0cf37e40bca801469af6c9>>
 * @relayHash 6acb7af1e94f5345e9b36a8cd44c4bee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b990d47758e2cd9b24e5dbee104f873a7f1b2aead336e44568500c9564afe54b
const $0ea8bf05e90a48f8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "level"
    }, v4 = [
        {
            "concreteType": "JiraIssueTypeHierarchyLevel",
            "kind": "LinkedField",
            "name": "hierarchyLevel",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ]
        },
        {
            "concreteType": "JiraIssueTypeConnection",
            "kind": "LinkedField",
            "name": "cmpIssueTypes",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "issueTypeId"
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                    "kind": "LinkedField",
                                    "name": "hierarchy",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "small"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v5 = {
        "concreteType": "JiraHierarchyConfigError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "code"
            },
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v6 = {
        "args": v1 /*: any*/ ,
        "concreteType": "JiraIssueHierarchyConfigurationQuery",
        "kind": "LinkedField",
        "name": "issueHierarchyConfig",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueHierarchyConfigData",
                "kind": "LinkedField",
                "name": "data",
                "plural": true,
                "selections": v4 /*: any*/ 
            },
            {
                "kind": "ScalarField",
                "name": "success"
            },
            v5 /*: any*/ 
        ]
    }, v7 = {
        "args": v1 /*: any*/ ,
        "concreteType": "JiraIssueHierarchyLimits",
        "kind": "LinkedField",
        "name": "issueHierarchyLimits",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "maxLevels"
            },
            {
                "kind": "ScalarField",
                "name": "nameLength"
            }
        ]
    }, v8 = {
        "args": v1 /*: any*/ ,
        "kind": "ScalarField",
        "name": "lockedIssueTypeIds"
    }, v9 = {
        "concreteType": "JiraIssueHierarchyConfigData",
        "kind": "LinkedField",
        "name": "issueHierarchyConfig",
        "plural": true,
        "selections": v4 /*: any*/ 
    }, v10 = {
        "concreteType": "JiraLongRunningTaskProgress",
        "kind": "LinkedField",
        "name": "taskProgress",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "kind": "ScalarField",
                "name": "progress"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainIssueHierarchyQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraHierarchyConfigTask",
                            "kind": "LinkedField",
                            "name": "issueHierarchyConfigUpdateTask",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "saveButton_adminPagesIssueHierarchyDirectory"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "saveDialog_adminPagesIssueHierarchyDirectory"
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainIssueHierarchyQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraHierarchyConfigTask",
                            "kind": "LinkedField",
                            "name": "issueHierarchyConfigUpdateTask",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b990d47758e2cd9b24e5dbee104f873a7f1b2aead336e44568500c9564afe54b",
            "metadata": {},
            "name": "mainIssueHierarchyQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0ea8bf05e90a48f8$var$node.hash = "e780e64aedcd2278004df68a042f1343";
var $0ea8bf05e90a48f8$export$2e2bcd8739ae039 = $0ea8bf05e90a48f8$var$node;

});


parcelRegister("78U7j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f593a4193eb44f7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

const $4f593a4193eb44f7$var$LazyGlobalIssuesSettingsSidebar = (0, $b7Svb.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("gvD3C")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-issues/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4f593a4193eb44f7$var$GlobalIssuesSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalIssuesSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f593a4193eb44f7$var$LazyGlobalIssuesSettingsSidebar, null)));
var $4f593a4193eb44f7$export$2e2bcd8739ae039 = $4f593a4193eb44f7$var$GlobalIssuesSettingsSidebar;

});
parcelRegister("gvD3C", function(module, exports) {

let $c04dd68f01cda7c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c04dd68f01cda7c0$var$load("jkFzD").then(()=>parcelRequire('dZptX'));

});


parcelRegister("gTOS3", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueHierarchyRedirectRoute", () => $68115cd41df3c3dd$export$6236a41e09bb858a);
const $68115cd41df3c3dd$export$6236a41e09bb858a = {
    name: 'global-settings-issues-hierarchy-redirect',
    path: '/secure/PortfolioHierarchy.jspa'
};

});

parcelRegister("ds5qV", function(module, exports) {

$parcel$export(module.exports, "ScreenRedirect", () => $7599a608c0c710a3$export$fdd3e60cd227c2f7);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $bVDE5 = parcelRequire("bVDE5");

var $7tQej = parcelRequire("7tQej");
var $doZTA = parcelRequire("doZTA");
const $7599a608c0c710a3$export$fdd3e60cd227c2f7 = ({ to: to, persistSearchParams: persistSearchParams = true })=>{
    const [{ route: route, location: location, query: query }] = (0, $doZTA.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [{ isInitialRender: isInitial }] = (0, $bVDE5.useSpaStateTransition)();
    const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
    (0, $5uXOq.useEffect)(()=>{
        if (!route || !eventRef.current) return;
        (0, $8zOmE.fireUIAnalytics)(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        route,
        isInitial
    ]);
    if (Array.isArray(persistSearchParams)) {
        const persistParams = Object.keys(query) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((result, currentKey)=>{
            const shouldPersist = persistSearchParams.some((persistKey)=>currentKey.includes(persistKey));
            if (shouldPersist) result.push(`${currentKey}=${query[currentKey]}`);
            return result;
        }, []).join('&');
        if (persistParams !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `${to}?${persistParams}`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: to
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `${to}${persistSearchParams ? location.search : ''}`
    });
};

});
parcelRegister("bVDE5", function(module, exports) {

$parcel$export(module.exports, "useSpaStateTransition", () => $1f866bb77da3c907$export$4d1974344641a2c9);
$parcel$export(module.exports, "default", () => $1f866bb77da3c907$export$2e2bcd8739ae039);

var $6RCeq = parcelRequire("6RCeq");

var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $7w9eZ = parcelRequire("7w9eZ");
const $1f866bb77da3c907$var$getNavigationStart = ()=>{
    // @ts-expect-error - TS2339 - Property 'timing' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'. | TS2339 - Property 'timing' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    const timestamp = (0, $6RCeq.default) && (0, $6RCeq.default).timing && (0, $6RCeq.default).timing.navigationStart;
    return timestamp ? new Date(timestamp).toISOString() : undefined;
};
const $1f866bb77da3c907$var$getLastTransition = (currentPage, visitedPages)=>{
    if (visitedPages.length === 0) return undefined;
    const collectAppNames = (page)=>Object.keys(page.apps || {}).sort();
    const appNamesToStr = (appNames)=>appNames.join('+') || '?';
    const prevPage = appNamesToStr(collectAppNames(visitedPages.slice(-1)[0]));
    const currPage = appNamesToStr(collectAppNames(currentPage));
    return `${prevPage} > ${currPage}`;
};
const $1f866bb77da3c907$var$getLastTransitionStartTime = (currentPage, visitedPages)=>{
    // If there are no previously visited pages the transition didn't have a place
    if (visitedPages.length === 0) return undefined;
    return currentPage.startTime;
};
const $1f866bb77da3c907$export$aea217a45095ce11 = ({ visitedPages: visitedPages, currentPage: currentPage })=>({
        isInitialRender: visitedPages.length === 0,
        transitionsCount: visitedPages.length,
        lastTransition: $1f866bb77da3c907$var$getLastTransition(currentPage, visitedPages),
        lastTransitionStartTime: $1f866bb77da3c907$var$getLastTransitionStartTime(currentPage, visitedPages),
        navigationStart: $1f866bb77da3c907$var$getNavigationStart(),
        currentPageId: currentPage.uuid
    });
// @ts-expect-error - TS2322 - Type 'SubscriberComponent<TransitionState, BoundActions<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/controllers/spa-state/src/actions/index")>, Record<...>>' is not assignable to type 'Subscriber'.
const $1f866bb77da3c907$var$SpaStateTransitionStateSubscriber = (0, $51nlc.createSubscriber)((0, $7w9eZ.default), {
    displayName: 'SpaStateTransitionStateSubscriber',
    selector: $1f866bb77da3c907$export$aea217a45095ce11
});
const $1f866bb77da3c907$export$4d1974344641a2c9 = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: $1f866bb77da3c907$export$aea217a45095ce11
});
var $1f866bb77da3c907$export$2e2bcd8739ae039 = $1f866bb77da3c907$var$SpaStateTransitionStateSubscriber;

});


parcelRegister("dKJVX", function(module, exports) {

$parcel$export(module.exports, "LazyIssueHierarchyDirectory", () => $1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd);
$parcel$export(module.exports, "default", () => $1c0ab549b6b1a06b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("aaw3F"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-hierarchy-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1c0ab549b6b1a06b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd,
        pageId: "jira-admin-pages-issue-hierarchy-directory",
        shouldShowSpinner: true
    });

});
parcelRegister("aaw3F", function(module, exports) {

let $7673b4a2e3716a0e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7673b4a2e3716a0e$var$load("6rF46").then(()=>parcelRequire('7PW51'));

});



parcelRegister("2pvey", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueHierarchyRouteEntry", () => $7693e36a7d632143$export$119e5b48edcee4ff);

var $g87MG = parcelRequire("g87MG");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $hrUKH = parcelRequire("hrUKH");

var $5pSYQ = parcelRequire("5pSYQ");

var $dKJVX = parcelRequire("dKJVX");
const $7693e36a7d632143$export$119e5b48edcee4ff = (0, $7NszV.createEntry)((0, $hrUKH.globalSettingsIssueHierarchyRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.issue-hierarchy-config',
        component: (0, $dKJVX.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $g87MG.issueHierarchyPageResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dKJVX.LazyIssueHierarchyDirectory)
        ]
    }));

});
parcelRegister("hrUKH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueHierarchyRoute", () => $b0028908d5aa290a$export$2c220ed11ae62e14);
const $b0028908d5aa290a$export$2c220ed11ae62e14 = {
    name: 'global-settings-issues-hierarchy-view',
    path: '/jira/settings/issues/issue-hierarchy'
};

});


parcelRegister("lgfw1", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesRouteEntry", () => $c4b1c133efa61697$export$680243b058188dc0);

var $hjmEZ = parcelRequire("hjmEZ");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $doDFU = parcelRequire("doDFU");

var $5pSYQ = parcelRequire("5pSYQ");

var $d9kjz = parcelRequire("d9kjz");
const $c4b1c133efa61697$export$680243b058188dc0 = (0, $7NszV.createEntry)((0, $doDFU.globalSettingsIssueTypesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.issue-types',
        component: (0, $d9kjz.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $hjmEZ.issueTypesResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $d9kjz.LazyIssueTypesDirectory)
        ]
    }));

});
parcelRegister("hjmEZ", function(module, exports) {

$parcel$export(module.exports, "issueTypesResource", () => $0c72c798ed369d5b$export$614e9d897c1ef917);

var $ebyGx = parcelRequire("ebyGx");

var $2M1hQ = parcelRequire("2M1hQ");

var $kXy4X = parcelRequire("kXy4X");
const $0c72c798ed369d5b$export$614e9d897c1ef917 = (0, $2M1hQ.createResource)({
    type: 'GLOBAL_ADMIN_ISSUE_TYPES_DIRECTORY',
    getKey: ()=>'issue types',
    getData: async ({ query: query })=>(0, $kXy4X.getIssueTypes)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query))
});

});
parcelRegister("kXy4X", function(module, exports) {

$parcel$export(module.exports, "getIssueTypes", () => $8b29c26e18cf4514$export$4cf4b24b88599615);

var $ebyGx = parcelRequire("ebyGx");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");


var $6tPCs = parcelRequire("6tPCs");
const $8b29c26e18cf4514$export$4cf4b24b88599615 = async (qs)=>{
    const filter = (0, $6tPCs.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify((0, $6tPCs.toApiUrlTransformer)(filter));
    try {
        return await (0, $7f4tk.default)(`/rest/internal/3/issuetype/search?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getIssueTypesRequest',
                packageName: (0, $f4edca700b2e0273$export$4adfbb237b083187),
                teamName: 'morphinecake'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
const $f4edca700b2e0273$export$4adfbb237b083187 = 'jiraAdminPagesIssueTypesResources';

parcelRegister("6tPCs", function(module, exports) {

$parcel$export(module.exports, "toUrlTransformer", () => $ddf87573da5ca99a$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $ddf87573da5ca99a$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toSearchFilterQsTransformer", () => $ddf87573da5ca99a$export$bcd1ab210547e2f5);
$parcel$export(module.exports, "toSortFieldFilterQsTransformer", () => $ddf87573da5ca99a$export$c114848fa733e5c4);
$parcel$export(module.exports, "toSortDirectionFilterQsTransformer", () => $ddf87573da5ca99a$export$c5d2609f8b4048d3);
$parcel$export(module.exports, "toApiUrlTransformer", () => $ddf87573da5ca99a$export$fb15afa686993f11);

var $dfl35 = parcelRequire("dfl35");

var $ebyGx = parcelRequire("ebyGx");



var $aud83 = parcelRequire("aud83");

var $eou7E = parcelRequire("eou7E");

var $iPfOK = parcelRequire("iPfOK");
const $ddf87573da5ca99a$var$sortDirectionMap = {
    [(0, $2a9e000a443b1a95$export$1dee026a19752d6b).toLowerCase()]: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
    [(0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65).toLowerCase()]: (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)
};
const $ddf87573da5ca99a$var$sortFieldMap = {
    [(0, $b140ee73c9ccd026$export$3c5e605ca7ade9f2).toLowerCase()]: (0, $b140ee73c9ccd026$export$3c5e605ca7ade9f2),
    [(0, $b140ee73c9ccd026$export$7673664bdc3ae979).toLowerCase()]: (0, $b140ee73c9ccd026$export$7673664bdc3ae979)
};
const $ddf87573da5ca99a$export$5b9f8ed2c34be88a = (filter)=>filter ? {
        page: filter.page !== undefined && filter.page >= 1 ? String(filter.page) : undefined,
        sortDirection: (0, $eou7E.fieldToParam)(filter.sortDirection),
        sortField: (0, $eou7E.fieldToParam)(filter.sortField),
        searchFilter: (0, $eou7E.trimSearchFilter)(filter.searchFilter)
    } : {};
const $ddf87573da5ca99a$export$bec67ef860c0d0e1 = (params)=>({
        page: Math.floor(Number((0, $aud83.number).parse(params.page))) || undefined,
        searchFilter: (0, $eou7E.trimSearchFilter)(params.searchFilter),
        sortDirection: (0, $eou7E.fieldFromParam)($ddf87573da5ca99a$var$sortDirectionMap, params.sortDirection),
        sortField: (0, $eou7E.fieldFromParam)($ddf87573da5ca99a$var$sortFieldMap, params.sortField)
    });
const $ddf87573da5ca99a$export$bcd1ab210547e2f5 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(qs);
    return parsed.searchFilter ? parsed.searchFilter : '';
};
const $ddf87573da5ca99a$export$c114848fa733e5c4 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(qs);
    return parsed.sortField && parsed.sortField === 'name' ? (0, $b140ee73c9ccd026$export$3c5e605ca7ade9f2) : (0, $b140ee73c9ccd026$export$7673664bdc3ae979);
};
const $ddf87573da5ca99a$export$c5d2609f8b4048d3 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(qs);
    return parsed.sortDirection && parsed.sortDirection === 'asc' ? (0, $2a9e000a443b1a95$export$1dee026a19752d6b) : (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65);
};
const $ddf87573da5ca99a$var$apiSortByMap = {
    [(0, $2a9e000a443b1a95$export$1dee026a19752d6b)]: '',
    [(0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)]: '-'
};
const $ddf87573da5ca99a$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = (0, (/*@__PURE__*/$parcel$interopDefault($dfl35)))({}, filter, (0, $iPfOK.DEFAULT_FILTER));
    // this additional mapping here is needed because the BE issue type search API already supports sorting by hierarchy level using the "type" parameter. It was decided to add mapping on frontend. More details here https://atlassian.slack.com/archives/C02HN05MC8K/p1680683395059279
    const sortFieldMapping = fullFilter.sortField === 'hierarchy-level' ? 'type' : fullFilter.sortField;
    return {
        maxResults: (0, $iPfOK.MAX_RESULTS),
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        startAt: (fullFilter.page - 1) * (0, $iPfOK.MAX_RESULTS),
        query: (0, $eou7E.trimSearchFilter)(fullFilter.searchFilter),
        // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
        orderBy: `${$ddf87573da5ca99a$var$apiSortByMap[fullFilter.sortDirection]}${sortFieldMapping}`
    };
};

});
parcelRegister("dfl35", function(module, exports) {

var $g7i7g = parcelRequire("g7i7g");

var $dGT4U = parcelRequire("dGT4U");

var $4rDUz = parcelRequire("4rDUz");

var $lbyKY = parcelRequire("lbyKY");
/** Used for built-in method references. */ var $9a4d00e997b9e158$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9a4d00e997b9e158$var$hasOwnProperty = $9a4d00e997b9e158$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $9a4d00e997b9e158$var$defaults = $g7i7g(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $4rDUz(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $lbyKY(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $dGT4U(value, $9a4d00e997b9e158$var$objectProto[key]) && !$9a4d00e997b9e158$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
module.exports = $9a4d00e997b9e158$var$defaults;

});

// data field names
const $b140ee73c9ccd026$export$3c5e605ca7ade9f2 = 'name';
const $b140ee73c9ccd026$export$d44826c816b5619b = 'description';
const $b140ee73c9ccd026$export$b87f371cbc396fcf = 'type';
const $b140ee73c9ccd026$export$7673664bdc3ae979 = 'hierarchy-level';
const $b140ee73c9ccd026$export$68e97ee499f7c743 = 'related-schemes';
const $b140ee73c9ccd026$export$92a1a3b7554e9387 = 'actions';
const $b140ee73c9ccd026$export$23ba45d5f8d54fed = 'level-number';
const $b140ee73c9ccd026$export$1dc71bc9f1a3749a = 'arrow';
const $b140ee73c9ccd026$export$8be5a31a21d0c723 = 'level-name';
const $b140ee73c9ccd026$export$6ad51af4785d6548 = 'jira-issue-types';
const $b140ee73c9ccd026$export$20068afc6f8c1737 = 'label-space';

const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';

parcelRegister("aud83", function(module, exports) {

$parcel$export(module.exports, "string", () => $b7c0843f761cef5f$export$22b082955e083ec3);
$parcel$export(module.exports, "bool", () => $b7c0843f761cef5f$export$87b259aa03e3d267);
$parcel$export(module.exports, "array", () => $b7c0843f761cef5f$export$2f23118c22fb2630);
$parcel$export(module.exports, "multiple", () => $b7c0843f761cef5f$export$939ddaa3205df08e);
$parcel$export(module.exports, "number", () => $b7c0843f761cef5f$export$98e628dec113755e);

var $etyzk = parcelRequire("etyzk");
const $b7c0843f761cef5f$export$22b082955e083ec3 = {
    stringify: (0, (/*@__PURE__*/$parcel$interopDefault($etyzk))),
    parse: (0, (/*@__PURE__*/$parcel$interopDefault($etyzk)))
};
const $b7c0843f761cef5f$export$87b259aa03e3d267 = {
    stringify: (value)=>String(value),
    parse: (value)=>{
        if (value === 'true') return true;
        if (value === 'false') return false;
        return undefined;
    }
};
const $b7c0843f761cef5f$export$2f23118c22fb2630 = {
    stringify: (value)=>value && Array.isArray(value) ? value.join(',') : undefined,
    parse: (value)=>typeof value === 'string' ? value?.split(',') : undefined
};
const $b7c0843f761cef5f$export$939ddaa3205df08e = {
    stringify: (value)=>{
        if (!value || !Array.isArray(value)) return undefined;
        return value.length === 1 ? value[0] : value;
    },
    parse: (value)=>value && Array.isArray(value) ? value : [
            String(value)
        ]
};
const $b7c0843f761cef5f$export$98e628dec113755e = {
    stringify: (value)=>`${value}`,
    parse: (value)=>Number(value)
};

});

parcelRegister("eou7E", function(module, exports) {

$parcel$export(module.exports, "fieldToParam", () => $56517d5895d07b39$export$7341f299e7b93e87);
$parcel$export(module.exports, "fieldFromParam", () => $56517d5895d07b39$export$c876451e094c0060);
$parcel$export(module.exports, "trimSearchFilter", () => $56517d5895d07b39$export$ed1722f41c23aaaf);
const $56517d5895d07b39$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
const $56517d5895d07b39$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
const $56517d5895d07b39$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});

parcelRegister("iPfOK", function(module, exports) {

$parcel$export(module.exports, "MAX_RESULTS", () => $68af332912f0171f$export$f6b2881bc1090cea);
$parcel$export(module.exports, "DEFAULT_FILTER", () => $68af332912f0171f$export$6deee0e4f2fb784e);


const $68af332912f0171f$export$f6b2881bc1090cea = 15;
const $68af332912f0171f$export$6deee0e4f2fb784e = {
    page: 1,
    sortDirection: (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65),
    sortField: (0, $b140ee73c9ccd026$export$7673664bdc3ae979)
};

});




parcelRegister("doDFU", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesRoute", () => $eae4c8452b1a9d87$export$7358263a3bbb38b1);
const $eae4c8452b1a9d87$export$7358263a3bbb38b1 = {
    name: 'global-settings-issues-types-view',
    path: '/jira/settings/issues/issue-types'
};

});

parcelRegister("d9kjz", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypesDirectory", () => $3e26a0063e6eb003$export$661e1bf38bb82270);
$parcel$export(module.exports, "default", () => $3e26a0063e6eb003$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $3e26a0063e6eb003$export$661e1bf38bb82270 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("01uod"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-types-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3e26a0063e6eb003$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3e26a0063e6eb003$export$661e1bf38bb82270,
        pageId: "jira-admin-pages-issue-types-directory",
        shouldShowSpinner: true
    });

});
parcelRegister("01uod", function(module, exports) {

let $0047aad5923e6f6c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0047aad5923e6f6c$var$load("h2MrD"),
    $0047aad5923e6f6c$var$load("bYT2S"),
    $0047aad5923e6f6c$var$load("bg3Kg")
]).then(()=>parcelRequire('g8Lpc'));

});



parcelRegister("4x45G", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesSchemesRouteEntry", () => $50729a11180c681f$export$8f940be66a7e7324);

var $6oOqs = parcelRequire("6oOqs");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $fZtiC = parcelRequire("fZtiC");

var $5pSYQ = parcelRequire("5pSYQ");

var $eISHy = parcelRequire("eISHy");
const $50729a11180c681f$export$8f940be66a7e7324 = (0, $7NszV.createEntry)((0, $fZtiC.globalSettingsIssueTypesSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.view-issue-type-schemes',
        component: (0, $eISHy.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $6oOqs.default),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eISHy.LazyIssueTypeSchemesDirectory)
        ]
    }));

});
parcelRegister("6oOqs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b64e685bc951c633$export$2e2bcd8739ae039);

var $ebyGx = parcelRequire("ebyGx");

var $2M1hQ = parcelRequire("2M1hQ");

var $8yNp1 = parcelRequire("8yNp1");

const $b64e685bc951c633$var$issueTypeSchemeResource = (0, $2M1hQ.createResource)({
    type: (0, $e899d40884b470a8$export$1d678052bb5ae54d),
    getKey: ({ query: query })=>`${0, $e899d40884b470a8$export$41cf50ee50d5da20}-${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query)}`,
    maxAge: 0,
    getData: async ({ query: query })=>(0, $8yNp1.getIssueTypeSchemes)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query))
});
var $b64e685bc951c633$export$2e2bcd8739ae039 = $b64e685bc951c633$var$issueTypeSchemeResource;

});
parcelRegister("8yNp1", function(module, exports) {

$parcel$export(module.exports, "getIssueTypeSchemes", () => $b3d43746aaf616dc$export$2844cac611eecaa7);

var $ebyGx = parcelRequire("ebyGx");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $7vF3l = parcelRequire("7vF3l");

var $bLpq9 = parcelRequire("bLpq9");
const $b3d43746aaf616dc$export$2844cac611eecaa7 = async (qs)=>{
    const filter = (0, $bLpq9.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify((0, $bLpq9.toApiUrlTransformer)(filter));
    try {
        return await (0, $eusud.performGetRequest)(`/rest/api/3/issuetypescheme?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getIssueTypesRequest',
                packageName: (0, $7vF3l.PACKAGE_NAME),
                teamName: 'morphinecake'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("7vF3l", function(module, exports) {

$parcel$export(module.exports, "SOURCE_NAME", () => $72a1bf464873d379$export$a3821bc63538b210);
$parcel$export(module.exports, "ISSUE_TYPE_SCHEMES_TABLE", () => $72a1bf464873d379$export$91570d508c93485d);
$parcel$export(module.exports, "ORDER", () => $72a1bf464873d379$export$11e75bce9f7ea886);
$parcel$export(module.exports, "MAX_RESULTS", () => $72a1bf464873d379$export$f6b2881bc1090cea);
$parcel$export(module.exports, "defaultIssueTypeSchemesFilter", () => $72a1bf464873d379$export$625de46796f967ae);
$parcel$export(module.exports, "EMPTY_PROJECTS_PAGE", () => $72a1bf464873d379$export$81a0343467d0e9a9);
$parcel$export(module.exports, "PACKAGE_NAME", () => $72a1bf464873d379$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", () => $72a1bf464873d379$export$9ac56b2484c2d4e9);
// analytics constants

const $72a1bf464873d379$export$a3821bc63538b210 = 'issueTypeSchemeDirectory';
const $72a1bf464873d379$export$91570d508c93485d = 'issueTypeSchemesTable';
const $72a1bf464873d379$export$11e75bce9f7ea886 = Object.freeze({
    ASC: 'asc',
    DESC: 'desc'
});
const $72a1bf464873d379$export$f6b2881bc1090cea = 10;
const $72a1bf464873d379$export$625de46796f967ae = {
    pageNumber: 1,
    pageSize: $72a1bf464873d379$export$f6b2881bc1090cea,
    expand: [
        'projects',
        'issueTypes'
    ],
    orderBy: 'name',
    sortDirection: (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)
};
const $72a1bf464873d379$export$81a0343467d0e9a9 = {
    startAt: 0,
    maxResults: 10,
    values: [],
    total: 0,
    isLast: true
};
const $72a1bf464873d379$export$b8b9d90f9e5bd72b = 'jiraAdminPagesIssueTypeSchemesDirectory';
const $72a1bf464873d379$export$9ac56b2484c2d4e9 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'filterSearch'
});

});

parcelRegister("bLpq9", function(module, exports) {

$parcel$export(module.exports, "toUrlTransformer", () => $90d499beb7e9cb88$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $90d499beb7e9cb88$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toApiUrlTransformer", () => $90d499beb7e9cb88$export$fb15afa686993f11);

var $dfl35 = parcelRequire("dfl35");

var $aud83 = parcelRequire("aud83");

var $7vF3l = parcelRequire("7vF3l");

var $lL6pH = parcelRequire("lL6pH");
const $90d499beb7e9cb88$export$5b9f8ed2c34be88a = (filter)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = filter || {};
    return {
        pageNumber: pageNumber,
        searchFilter: searchFilter,
        orderBy: orderBy
    };
};
const $90d499beb7e9cb88$export$bec67ef860c0d0e1 = (params)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = params;
    const parsedNumber = Number.isNaN((0, $aud83.number).parse(pageNumber)) ? (0, $7vF3l.defaultIssueTypeSchemesFilter).pageNumber : (0, $aud83.number).parse(pageNumber);
    const parsedOrderBy = orderBy === 'name' || orderBy === '-name' ? orderBy : undefined;
    return {
        ...(0, $7vF3l.defaultIssueTypeSchemesFilter),
        pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
        searchFilter: searchFilter,
        orderBy: parsedOrderBy
    };
};
const $90d499beb7e9cb88$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = (0, (/*@__PURE__*/$parcel$interopDefault($dfl35)))({}, filter, (0, $7vF3l.defaultIssueTypeSchemesFilter));
    let requestParams = {
        maxResults: (0, $7vF3l.MAX_RESULTS),
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        startAt: (fullFilter.pageNumber - 1) * (0, $7vF3l.MAX_RESULTS),
        orderBy: fullFilter.orderBy,
        queryString: (0, $lL6pH.trimSearchFilter)(fullFilter.searchFilter)
    };
    if (fullFilter.expand != null) // @ts-expect-error - TS2322 - Type '{ expand: string; maxResults: number; startAt: number; orderBy: IssueTypeOrderBy | undefined; queryString: string | undefined; }' is not assignable to type '{ maxResults: number; startAt: number; orderBy: IssueTypeOrderBy | undefined; queryString: string | undefined; }'.
    requestParams = {
        ...requestParams,
        expand: fullFilter.expand.join(',')
    };
    return requestParams;
};

});
parcelRegister("lL6pH", function(module, exports) {

$parcel$export(module.exports, "trimSearchFilter", () => $8bfdbd5ef20cefa5$export$ed1722f41c23aaaf);
const $8bfdbd5ef20cefa5$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});



const $e899d40884b470a8$export$1d678052bb5ae54d = 'ISSUE_TYPE_SCHEME_TABLE';
const $e899d40884b470a8$export$41cf50ee50d5da20 = 'ISSUE_TYPE_SCHEME_TABLE_KEY';


parcelRegister("fZtiC", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesSchemesRoute", () => $2bc2621ba9f684f5$export$2aba97aa663f43b3);
const $2bc2621ba9f684f5$export$2aba97aa663f43b3 = {
    name: 'global-settings-issues-types-schemes-manage',
    path: '/jira/settings/issues/issue-type-schemes'
};

});

parcelRegister("eISHy", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeSchemesDirectory", () => $651db9488b9701c8$export$611728a54ba37830);
$parcel$export(module.exports, "default", () => $651db9488b9701c8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $651db9488b9701c8$export$611728a54ba37830 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6vuHZ"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-type-schemes-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$651db9488b9701c8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $651db9488b9701c8$export$611728a54ba37830,
        pageId: "jira-admin-pages-issue-type-schemes-directory",
        shouldShowSpinner: true
    });

});
parcelRegister("6vuHZ", function(module, exports) {

let $4bcd75605c94bd1c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4bcd75605c94bd1c$var$load("cfCwZ").then(()=>parcelRequire('1dsYb'));

});



parcelRegister("3rBGh", function(module, exports) {

$parcel$export(module.exports, "productsJsmAuthenticationSettingsRouteEntry", () => $9cff46e3a47cb509$export$de5cc5a334946074);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $jKASa = parcelRequire("jKASa");

var $3RJkv = parcelRequire("3RJkv");

var $5ANfe = parcelRequire("5ANfe");

var $1xsZo = parcelRequire("1xsZo");
const $9cff46e3a47cb509$export$de5cc5a334946074 = (0, $7NszV.createEntry)((0, $5ANfe.productsJsmAuthenticationSettingsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-authentication-settings',
        component: (0, $1xsZo.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $jKASa.jsmCustomerAuthenticationSettingsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1xsZo.LazyAuthenticationSettings)
        ]
    }));

});
parcelRegister("2Fj5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9ddf603830cf6c5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

const $a9ddf603830cf6c5$var$LazyGlobalProductsSettingsSidebar = (0, $b7Svb.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("dWVny")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-products/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalProductsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9ddf603830cf6c5$var$LazyGlobalProductsSettingsSidebar, null)));
$a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar.displayName = 'GlobalProductsSettingsSidebar';
var $a9ddf603830cf6c5$export$2e2bcd8739ae039 = $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar;

});
parcelRegister("dWVny", function(module, exports) {

let $a27d33650e3052b5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a27d33650e3052b5$var$load("eNmuD"),
    $a27d33650e3052b5$var$load("h2MrD"),
    $a27d33650e3052b5$var$load("bYT2S"),
    $a27d33650e3052b5$var$load("cM9em"),
    $a27d33650e3052b5$var$load("fr9NE"),
    $a27d33650e3052b5$var$load("3FDyC")
]).then(()=>parcelRequire('hTSvC'));

});


parcelRegister("jKASa", function(module, exports) {

$parcel$export(module.exports, "jsmCustomerAuthenticationSettingsResource", () => $3f20045f00d71d00$export$73134c05a3c27bd);

var $2M1hQ = parcelRequire("2M1hQ");

var $8Pbm3 = parcelRequire("8Pbm3");

const $3f20045f00d71d00$export$73134c05a3c27bd = (0, $2M1hQ.createResource)({
    type: (0, $8Pbm3.RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS),
    getKey: ()=>'settings',
    getDataLoader: ()=>(parcelRequire("8L7LV")),
    maxAge: (0, $8Pbm3.ONE_DAY_IN_MILLIS)
});

});
parcelRegister("8Pbm3", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS", () => $bbe3b013803e2d85$export$6a2799d78d98b915);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $bbe3b013803e2d85$export$5a00268156ea5027);
const $bbe3b013803e2d85$export$6a2799d78d98b915 = 'JSM_CUSTOMER_AUTHENTICATION_SETTINGS';
const $bbe3b013803e2d85$export$5a00268156ea5027 = 86400000;

});

parcelRegister("8L7LV", function(module, exports) {

let $6608bdda046c5b2c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6608bdda046c5b2c$var$load("hLF9k").then(()=>parcelRequire('7xEnC'));

});


parcelRegister("5ANfe", function(module, exports) {

$parcel$export(module.exports, "productsJsmAuthenticationSettingsRoute", () => $a5162dfcc59db4dc$export$6395086ce7e72e37);
const $a5162dfcc59db4dc$export$6395086ce7e72e37 = {
    name: 'products-jsm-authentication-settings',
    path: '/jira/settings/products/servicedesk/authentication',
    exact: true
};

});

parcelRegister("1xsZo", function(module, exports) {

$parcel$export(module.exports, "LazyAuthenticationSettings", () => $a330db909964048e$export$6cd59b0135f3fe86);
$parcel$export(module.exports, "default", () => $a330db909964048e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $a330db909964048e$export$6cd59b0135f3fe86 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hTM0j"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-authentication-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a330db909964048e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a330db909964048e$export$6cd59b0135f3fe86,
        pageId: "spa-apps/admin-pages/jsm-authentication-settings",
        shouldShowSpinner: false
    });

});
parcelRegister("hTM0j", function(module, exports) {

let $d07ccf4f9fe82fc3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d07ccf4f9fe82fc3$var$load("atQhk").then(()=>parcelRequire('8YmLU'));

});



parcelRegister("4PsEV", function(module, exports) {

$parcel$export(module.exports, "productsJsmCustomerAccessRouteEntry", () => $1b073120d1b5fb73$export$d014f5ba2dec6c16);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $6IgbX = parcelRequire("6IgbX");

var $cuwqc = parcelRequire("cuwqc");

var $3RJkv = parcelRequire("3RJkv");

var $kMtnK = parcelRequire("kMtnK");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $1b073120d1b5fb73$var$LazyCustomerAccess = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("aUlNl"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/customer-access/src/index.tsx"
});
const $1b073120d1b5fb73$var$ServiceDeskCustomerAccess = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1b073120d1b5fb73$var$LazyCustomerAccess,
        pageId: "spa-apps/admin-pages/customer-access",
        shouldShowSpinner: false
    });
const $1b073120d1b5fb73$export$d014f5ba2dec6c16 = (0, $7NszV.createEntry)((0, $kMtnK.productsJsmCustomerAccessRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-customer-access',
        component: $1b073120d1b5fb73$var$ServiceDeskCustomerAccess,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $cuwqc.jsmGlobalCustomerAccessSettingsResource),
            (0, $6IgbX.jsmGlobalCustomerAccessAffectedProjectsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $1b073120d1b5fb73$var$LazyCustomerAccess
        ]
    }));

});
parcelRegister("6IgbX", function(module, exports) {

$parcel$export(module.exports, "jsmGlobalCustomerAccessAffectedProjectsResource", () => $da9f8bab48dab68f$export$f27acbd4701f5dfe);

var $2M1hQ = parcelRequire("2M1hQ");

const $da9f8bab48dab68f$var$ONE_DAY_IN_MILLIS = 86400000;

const $da9f8bab48dab68f$export$f27acbd4701f5dfe = (0, $2M1hQ.createResource)({
    type: (0, $700dba149c7972be$export$341f26dde034af5b),
    getKey: ()=>'affected-projects',
    getDataLoader: ()=>(parcelRequire("kH5yy")),
    maxAge: $da9f8bab48dab68f$var$ONE_DAY_IN_MILLIS
});

});
const $700dba149c7972be$export$341f26dde034af5b = 'JSM_CUSTOMER_ACCESS_AFFECTED_PROJECTS';
const $700dba149c7972be$export$eb7818fb178a80b4 = 'JSM_GLOBAL_CUSTOMER_ACCESS_SETTINGS';

parcelRegister("kH5yy", function(module, exports) {

let $f10c2230c9ecddc4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f10c2230c9ecddc4$var$load("3iYiJ").then(()=>parcelRequire('8QdIc'));

});


parcelRegister("cuwqc", function(module, exports) {

$parcel$export(module.exports, "jsmGlobalCustomerAccessSettingsResource", () => $ab848c99e9d2daf7$export$b1a50ad717b4ca61);

var $2M1hQ = parcelRequire("2M1hQ");

const $ab848c99e9d2daf7$var$ONE_DAY_IN_MILLIS = 86400000;

const $ab848c99e9d2daf7$export$b1a50ad717b4ca61 = (0, $2M1hQ.createResource)({
    type: (0, $700dba149c7972be$export$eb7818fb178a80b4),
    getKey: ()=>'settings',
    getDataLoader: ()=>(parcelRequire("2a94l")),
    maxAge: $ab848c99e9d2daf7$var$ONE_DAY_IN_MILLIS
});

});
parcelRegister("2a94l", function(module, exports) {

let $19338ce48b8e4277$var$load = (parcelRequire("28QjX"))(4);
module.exports = $19338ce48b8e4277$var$load("jTKK6").then(()=>parcelRequire('4pG8m'));

});


parcelRegister("kMtnK", function(module, exports) {

$parcel$export(module.exports, "productsJsmCustomerAccessRoute", () => $3ca187dfdc0607c8$export$b97e3b6231be8149);
const $3ca187dfdc0607c8$export$b97e3b6231be8149 = {
    name: 'products-jsm-customer-access',
    path: '/jira/settings/products/servicedesk/customer-access',
    exact: true
};

});

parcelRegister("aUlNl", function(module, exports) {

let $7f100a5c2befdbd6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7f100a5c2befdbd6$var$load("iTi1A").then(()=>parcelRequire('faXQs'));

});


parcelRegister("jWVY2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNewIssueSearchRouteEntry", () => $d3d6f049267991fe$export$ecfeb067cb61f7f7);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $5AJNe = parcelRequire("5AJNe");

var $5pSYQ = parcelRequire("5pSYQ");

var $2FG9c = parcelRequire("2FG9c");
const $d3d6f049267991fe$export$ecfeb067cb61f7f7 = (0, $7NszV.createEntry)((0, $5AJNe.globalSettingsIssuesNewIssueSearchRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.new-issue-search-transition',
        component: (0, $2FG9c.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2FG9c.LazyNewIssueSearchTransition)
        ],
        canTransitionIn: ()=>true
    }));

});
parcelRegister("5AJNe", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNewIssueSearchRoute", () => $2c4dc81da03ffb36$export$774dc60e785b8ae8);
const $2c4dc81da03ffb36$export$774dc60e785b8ae8 = {
    name: 'global-settings-issues-new-issue-search',
    path: '/jira/settings/issues/new-issue-search-transition'
};

});

parcelRegister("2FG9c", function(module, exports) {

$parcel$export(module.exports, "LazyNewIssueSearchTransition", () => $4f134f463ddf0416$export$aa5e318abd957ad);
$parcel$export(module.exports, "default", () => $4f134f463ddf0416$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $4f134f463ddf0416$export$aa5e318abd957ad = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("96tGN"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/new-issue-search-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4f134f463ddf0416$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4f134f463ddf0416$export$aa5e318abd957ad,
        pageId: "jira-admin-pages-new-issue-search-transition",
        shouldShowSpinner: true
    });

});
parcelRegister("96tGN", function(module, exports) {

let $6a0bb444d898d0c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6a0bb444d898d0c0$var$load("9iFSf").then(()=>parcelRequire('7sYTD'));

});



parcelRegister("dTwSZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemBulkMailRouteEntry", () => $afbfb00c133db3e2$export$f1e14d1857713e35);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $d8FBC = parcelRequire("d8FBC");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $gRmqY = parcelRequire("gRmqY");

var $5FGTk = parcelRequire("5FGTk");
const $afbfb00c133db3e2$export$f1e14d1857713e35 = (0, $7NszV.createEntry)((0, $gRmqY.globalSettingsSystemBulkMailRoute), ()=>({
        group: 'global-settings',
        component: (0, $5FGTk.default),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $d8FBC.SidebarGlobalSettingsSystem)
        },
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5FGTk.LazyBulkEmail)
        ]
    }));

});
parcelRegister("d8FBC", function(module, exports) {

$parcel$export(module.exports, "SidebarGlobalSettingsSystem", () => $6ea6596802956a9d$export$52af3150b9f64726);

var $5uXOq = parcelRequire("5uXOq");

var $fobme = parcelRequire("fobme");

var $acDan = parcelRequire("acDan");

var $hcbSm = parcelRequire("hcbSm");
const $6ea6596802956a9d$export$52af3150b9f64726 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarRenderStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcbSm.Menu), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarReady), {
        id: (0, $fobme.SIDEBAR_ID).GLOBAL_SETTINGS_SYSTEM
    }));

});
parcelRegister("fobme", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_ID", () => $4b9be639c0c7f77b$export$adf978edbdfaf080);
const $4b9be639c0c7f77b$export$adf978edbdfaf080 = {
    CONNECT: 'CONNECT',
    CORE: 'CORE',
    FILTERS: 'FILTERS',
    FILTERS_GLOBAL: 'FILTERS_GLOBAL',
    FORGE_GLOBAL_PAGE: 'FORGE_GLOBAL_PAGE',
    GLOBAL_SETTINGS_APPS: 'GLOBAL_SETTINGS_APPS',
    GLOBAL_SETTINGS_ISSUES: 'GLOBAL_SETTINGS_ISSUES',
    GLOBAL_SETTINGS_PRODUCTS: 'GLOBAL_SETTINGS_PRODUCTS',
    GLOBAL_SETTINGS_PROJECTS: 'GLOBAL_SETTINGS_PROJECTS',
    GLOBAL_SETTINGS_SYSTEM: 'GLOBAL_SETTINGS_SYSTEM',
    JSM: 'JSM',
    JSW_CLASSIC: 'JSW_CLASSIC',
    JSW_NEXT_GEN: 'JSW_NEXT_GEN',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    EOC_OPERATIONS: 'EOC_OPERATIONS',
    POLARIS: 'POLARIS',
    USER: 'USER',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};

});

parcelRegister("hcbSm", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $e261d6c9e28d2ed4$export$d9b273488cd8ce6f);

var $5uXOq = parcelRequire("5uXOq");

var $bNEt5 = parcelRequire("bNEt5");
var $a4hJx = parcelRequire("a4hJx");
var $2zFxf = parcelRequire("2zFxf");
var $9K9UK = parcelRequire("9K9UK");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $3OGaE = parcelRequire("3OGaE");

var $juTur = parcelRequire("juTur");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $3tHFY = parcelRequire("3tHFY");

var $6jY6G = parcelRequire("6jY6G");

var $eaZ4X = parcelRequire("eaZ4X");

var $jMBA3 = parcelRequire("jMBA3");

var $aVTmi = parcelRequire("aVTmi");

var $cip1u = parcelRequire("cip1u");

var $8wyB3 = parcelRequire("8wyB3");

var $230Wm = parcelRequire("230Wm");

var $je2KE = parcelRequire("je2KE");

var $iAlf2 = parcelRequire("iAlf2");

var $fwlYA = parcelRequire("fwlYA");

var $9O5DC = parcelRequire("9O5DC");

var $1y2CG = parcelRequire("1y2CG");

var $71ORT = parcelRequire("71ORT");

var $3jrxv = parcelRequire("3jrxv");
const $e261d6c9e28d2ed4$var$calculateStack = (route)=>{
    const routeName = route && route.name;
    if ([
        'global-settings-performance-metric-detail',
        'global-settings-performance-overview',
        'global-settings-performance-project-cleanup',
        'global-settings-performance-project-role-actor',
        'global-settings-performance-custom-field',
        'global-settings-performance-issue'
    ].includes(routeName)) return [
        (0, $eaZ4X.SECTION_ID).PERFORMANCE_AND_SCALE
    ];
    return [];
};
const $e261d6c9e28d2ed4$export$d9b273488cd8ce6f = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const { data: connectItems } = (0, $jMBA3.useGlobalSettingsSystemConnectItems)();
    const [stack, setStack] = (0, $5uXOq.useState)($e261d6c9e28d2ed4$var$calculateStack(route));
    (0, $5uXOq.useEffect)(()=>{
        setStack($e261d6c9e28d2ed4$var$calculateStack(route));
    }, [
        route
    ]);
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    const generalConfigurationPath = navigationPath.generalConfiguration;
    if (features == null || connectItems == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), null);
    const navigationContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, features.hasGeneralConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'general-configuration'
        },
        href: generalConfigurationPath,
        selectedOn: (0, $3jrxv.isGeneralConfigurationSelected)
    }, formatMessage((0, $iAlf2.default).generalConfiguration)), features.hasDarkFeatures && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'dark-features'
        },
        href: navigationPath.darkFeatures,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $iAlf2.default).darkFeatures)), features.hasTroubleshootingAndSupportSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1y2CG.TroubleshootingAndSupportSection), null), features.hasSecuritySection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fwlYA.SecuritySection), null), features.hasCollectors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'collectors'
        },
        href: navigationPath.issueCollectors,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $iAlf2.default).issueCollectorsIssueTermRefresh : (0, $iAlf2.default).issueCollectors)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wyB3.AutomationSection), null), features.hasUserInterfaceSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $71ORT.UserInterfaceSection), null), features.hasImportExportSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $230Wm.ImportExportSection), null), features.hasMailSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $je2KE.MailSection), null), features.hasAdminHelperSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aVTmi.AdminHelperSection), null), features.hasSharedSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9O5DC.SharedSection), null), features.hasAdvancedSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cip1u.AdvancedSection), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3tHFY.ConnectMenu), {
        items: connectItems,
        overrides: {
            BackMenuItem: {
                href: '/jira/settings/system/general-configuration',
                title: formatMessage((0, $4R6GH.fg)('eax-958_fix_a11y_issues_on_jira_system_settings') ? (0, $iAlf2.default).systemGroup : (0, $iAlf2.default).systemGroupOld)
            }
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juTur.ContextualAnalyticsData), {
        menuId: "global-settings/system",
        stack: stack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2zFxf.default), {
        label: formatMessage((0, $iAlf2.default).globalSettingsSystemSidebarLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bNEt5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, formatMessage((0, $4R6GH.fg)('eax-958_fix_a11y_issues_on_jira_system_settings') ? (0, $iAlf2.default).systemGroup : (0, $iAlf2.default).systemGroupOld))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a4hJx.default), {
        stack: stack,
        onChange: setStack
    }, navigationContent)));
};

});
parcelRegister("bNEt5", function(module, exports) {

$parcel$export(module.exports, "default", () => $17ac19a84e29fc0b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
const $17ac19a84e29fc0b$var$styles = {
    navigationFooter: "_1e0c1ule _85i5u2gc _1q511ejb _y4tiu2gc _bozgu2gc"
};
/**
 * __Navigation header__
 *
 * Allows for customisation of the header.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $17ac19a84e29fc0b$var$NavigationHeader = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $17ac19a84e29fc0b$var$styles.navigationFooter,
        "data-navheader": true,
        children: children
    });
};
var $17ac19a84e29fc0b$export$2e2bcd8739ae039 = $17ac19a84e29fc0b$var$NavigationHeader;

});

parcelRegister("a4hJx", function(module, exports) {

$parcel$export(module.exports, "ROOT_ID", () => $60ed2743269ce34a$export$ec71a3379b43ae5c);
$parcel$export(module.exports, "default", () => $60ed2743269ce34a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $7xhdA = parcelRequire("7xhdA");

var $fHpHg = parcelRequire("fHpHg");

var $79Hag = parcelRequire("79Hag");

var $65Cwx = parcelRequire("65Cwx");

var $4bO8w = parcelRequire("4bO8w");

var $fsi33 = parcelRequire("fsi33");

var $atNen = parcelRequire("atNen");
const $60ed2743269ce34a$export$ec71a3379b43ae5c = 'ATLASKIT_NESTED_ROOT';
const $60ed2743269ce34a$var$nestableNavigationContentStyles = null;
const $60ed2743269ce34a$var$nestingRootStyles = null;
/**
 * __Nestable navigation content__
 *
 * The container for navigation items with nested views
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#nested-navigation)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $60ed2743269ce34a$var$NestableNavigationContent = (props)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const { children: children, testId: testId, overrides: overrides, initialStack: initialStack, onChange: onChange, onUnknownNest: onUnknownNest, stack: stack, showTopScrollIndicator: showTopScrollIndicator, isDefaultFocusControl: isDefaultFocusControl = true } = props;
    const goBackButtonRef = (0, $5uXOq.useRef)(null);
    const [committedStack, setCommittedStack] = (0, $5uXOq.useState)(stack || initialStack || []);
    const controlledStack = stack || undefined;
    const currentStackId = committedStack[committedStack.length - 1] || $60ed2743269ce34a$export$ec71a3379b43ae5c;
    const [transition, setTransition] = (0, $5uXOq.useState)('nesting');
    const backTestId = testId && `${testId}--go-back-item`;
    const [activeParentId, setActiveParentId] = (0, $5uXOq.useState)('');
    const [focusGoBackButton, setFocusGoBackButton] = (0, $5uXOq.useState)(false);
    const shouldFocus = isDefaultFocusControl && (0, $fHpHg.fg)('platform-side-navigation-keyboard-focus');
    const renderGoBackItem = overrides && overrides.GoBackItem && overrides.GoBackItem.render ? overrides.GoBackItem.render : (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $79Hag.default), {
            ...props,
            children: "Go back"
        });
    const { childIdsRef: childIdsRef } = (0, $4bO8w.useChildIds)(currentStackId, committedStack, onUnknownNest);
    const onNestHandler = (0, $5uXOq.useCallback)((layerId)=>{
        onChange && onChange(committedStack.concat(layerId));
        setFocusGoBackButton(true);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.concat(layerId);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack
    ]);
    const onUnNestHandler = (0, $5uXOq.useCallback)(()=>{
        onChange && onChange(committedStack.slice(0, committedStack.length - 1));
        setActiveParentId(currentStackId);
        setFocusGoBackButton(false);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('unnesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.slice(0, prev.length - 1);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack,
        setActiveParentId,
        currentStackId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!controlledStack) // We aren't in controlled mode - bail out.
        return;
        if (JSON.stringify(committedStack) === JSON.stringify(controlledStack)) // stacks are equal - do nothing!
        return;
        // Controlled prop updated, let's figure out if we're nesting or unnesting.
        if (controlledStack.length < committedStack.length) // We are unnesting (removing from the stack)
        setTransition('unnesting');
        else // We are nesting (adding to the stack)
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack(controlledStack);
        });
    }, [
        committedStack,
        controlledStack
    ]);
    const backButton = renderGoBackItem({
        onClick: onUnNestHandler,
        testId: backTestId,
        ref: shouldFocus ? goBackButtonRef : null
    });
    const context = (0, $5uXOq.useMemo)(()=>({
            currentStackId: currentStackId,
            backButton: backButton,
            stack: committedStack,
            onNest: onNestHandler,
            onUnNest: onUnNestHandler,
            parentId: $60ed2743269ce34a$export$ec71a3379b43ae5c,
            childIds: childIdsRef,
            forceShowTopScrollIndicator: showTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        currentStackId,
        backButton,
        committedStack,
        onNestHandler,
        onUnNestHandler,
        childIdsRef,
        showTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    const manageFocus = (event)=>{
        const triggeredByKeyboard = event.nativeEvent.detail === 0;
        if (triggeredByKeyboard) containerRef.current && containerRef.current.focus();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": testId,
            ref: containerRef,
            tabIndex: -1,
            onClick: manageFocus,
            className: (0, $bwpsq.default)([
                "_12ji1r31 _1qu2glyw _12y31o36 _4t3i1osq _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7xhdA.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $atNen.NestingMotion), {
                    enterFrom: transition === 'nesting' ? 'right' : 'left',
                    exitTo: transition === 'nesting' ? 'left' : 'right',
                    testId: testId && `${testId}-anim`,
                    children: (motion)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ...motion,
                            className: (0, $bwpsq.default)([
                                "_1e0c1txw _1bsb1osq _4t3i1osq _kqswstnw _2lx21bp4",
                                motion.className
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fsi33.NestedContext).Provider, {
                                // This provider is inside the NestingMotion to ensure it keeps a stale
                                // reference to the previous value.
                                value: context,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $65Cwx.default), {
                                    title: "",
                                    id: $60ed2743269ce34a$export$ec71a3379b43ae5c,
                                    children: children
                                })
                            })
                        })
                }, currentStackId)
            })
        })
    });
};
var $60ed2743269ce34a$export$2e2bcd8739ae039 = $60ed2743269ce34a$var$NestableNavigationContent;

});
parcelRegister("79Hag", function(module, exports) {

$parcel$export(module.exports, "default", () => $46dfc43720f75948$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3xWPD = parcelRequire("3xWPD");


var $4iTJw = parcelRequire("4iTJw");
/**
 * __Go back item__
 *
 * A go back item is used to provide a customized "go back" button in nested
 * navigations.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#go-back-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $46dfc43720f75948$var$GoBackItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ cssFn: cssFn, iconBefore: iconBefore = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3xWPD))), {
    color: "currentColor",
    LEGACY_secondaryColor: `var(--ds-surface, ${(0, $a7f8c6b391092279$export$e655ef011c4aa1a2)})`,
    label: ""
}), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
    const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
    const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        if (isInteracted) return;
        setIsInteracted(true);
        onClick && onClick(e);
    }, [
        onClick,
        isInteracted
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4iTJw.default), {
        isSelected: isSelected,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        cssFn: cssFn,
        iconBefore: iconBefore,
        onClick: onClickHandler,
        ref: ref,
        ...rest
    });
});
var $46dfc43720f75948$export$2e2bcd8739ae039 = $46dfc43720f75948$var$GoBackItem;

});
parcelRegister("3xWPD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19a10e1149a5b84d93e6a05c6f1be0d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $295216f354fff637$var$_react = $295216f354fff637$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $295216f354fff637$var$_arrowLeft = $295216f354fff637$var$_interopRequireDefault((parcelRequire("kmtfL")));

var $295216f354fff637$var$_arrowLeftCircle = $295216f354fff637$var$_interopRequireDefault((parcelRequire("2H8VS")));
function $295216f354fff637$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $295216f354fff637$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $295216f354fff637$var$_react.default.createElement($295216f354fff637$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $295216f354fff637$var$_arrowLeftCircle.default
    }, props));
$295216f354fff637$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
var $295216f354fff637$var$_default = module.exports.default = $295216f354fff637$var$ArrowLeftIcon;

});
parcelRegister("kmtfL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efa63c6a59a6ee993a0458e40fc93a18>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed2c8dd1c17ad869$var$_react = $ed2c8dd1c17ad869$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ed2c8dd1c17ad869$var$_baseNew = $ed2c8dd1c17ad869$var$_interopRequireDefault((parcelRequire("enEmH")));
function $ed2c8dd1c17ad869$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed2c8dd1c17ad869$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $ed2c8dd1c17ad869$var$_react.default.createElement($ed2c8dd1c17ad869$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$ed2c8dd1c17ad869$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $ed2c8dd1c17ad869$var$_default = module.exports.default = $ed2c8dd1c17ad869$var$ArrowLeftIcon;

});

parcelRegister("2H8VS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f6686b5a2de8be4$var$_react = $1f6686b5a2de8be4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $1f6686b5a2de8be4$var$_arrowLeft = $1f6686b5a2de8be4$var$_interopRequireDefault((parcelRequire("kmtfL")));
function $1f6686b5a2de8be4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1f6686b5a2de8be4$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $1f6686b5a2de8be4$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
    }, props, {
        newIcon: $1f6686b5a2de8be4$var$_arrowLeft.default
    }));
$1f6686b5a2de8be4$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
var $1f6686b5a2de8be4$var$_default = module.exports.default = $1f6686b5a2de8be4$var$ArrowLeftCircleIcon;

});


parcelRegister("4iTJw", function(module, exports) {

$parcel$export(module.exports, "default", () => $23465bf5670bf66e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7H980 = parcelRequire("7H980");

var $c48kn = parcelRequire("c48kn");

var $fsi33 = parcelRequire("fsi33");
/**
 * __Button item__
 *
 * A button item renders an item wrapped in a button tag, used primarily when an
 * action does something other than changing routes.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#button-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $23465bf5670bf66e$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
({ cssFn: cssFn, ...rest }, ref)=>{
    const { shouldRender: shouldRender } = (0, $fsi33.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssOverride = (0, $c48kn.overrideStyleFunction)((0, $c48kn.baseSideNavItemStyle), cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7H980.default), {
        ref: ref,
        cssFn: cssOverride,
        ...rest
    });
});
var $23465bf5670bf66e$export$2e2bcd8739ae039 = $23465bf5670bf66e$var$ButtonItem;

});


parcelRegister("65Cwx", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fee06468e5ae9b2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6gA2o = parcelRequire("6gA2o");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");


var $c48kn = parcelRequire("c48kn");

var $4iTJw = parcelRequire("4iTJw");
var $bY5Mc = parcelRequire("bY5Mc");
var $2uGoK = parcelRequire("2uGoK");

var $a4hJx = parcelRequire("a4hJx");

var $fsi33 = parcelRequire("fsi33");

var $4bO8w = parcelRequire("4bO8w");

var $hE0bV = parcelRequire("hE0bV");
const $1fee06468e5ae9b2$var$styles = {
    iconContainer: "_1e0c1nu9"
};
/**
 * NestingItem will render itself differently depending in what context it is rendered in.
 * When not open - it will render itself as an item.
 * When open - it will render its children.
 */ const $1fee06468e5ae9b2$var$NestingItem = (props)=>{
    const { children: children, iconAfter: iconAfter, title: title, onClick: onClick, cssFn: cssFn, isSelected: isSelected, id: id, component: component, testId: testId, ...rest } = props;
    const { currentStackId: currentStackId, onNest: onNest, onUnNest: onUnNest, backButton: contextualBackButton, stack: stack, childIds: childIds, forceShowTopScrollIndicator: forceShowTopScrollIndicator, activeParentId: activeParentId, goBackButtonRef: goBackButtonRef, isDefaultFocusControl: isDefaultFocusControl, focusGoBackButton: focusGoBackButton } = (0, $fsi33.useNestedContext)();
    const mergedStyles = (0, $c48kn.overrideStyleFunction)((0, $hE0bV.nestingItemStyle), cssFn);
    const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
    const parentItemRef = (0, $5uXOq.useRef)(null);
    // To avoid error we need to make sure that the component is wrapped in ForwardRef
    const isForwardRefCheck = (component)=>{
        if (component?.prototype?.isReactComponent) return false;
        return component?.$$typeof === Symbol.for('react.forward_ref');
    };
    const shouldFocus = isDefaultFocusControl && (0, $fHpHg.fg)('platform-side-navigation-keyboard-focus');
    const backButtonRef = shouldFocus ? goBackButtonRef : null;
    const activeParentRef = shouldFocus ? parentItemRef : null;
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFocus) {
            if (activeParentId === id) parentItemRef?.current?.focus();
            if (focusGoBackButton) goBackButtonRef?.current?.focus();
        }
    }, [
        activeParentId,
        id,
        goBackButtonRef,
        focusGoBackButton,
        isDefaultFocusControl,
        shouldFocus
    ]);
    const backButton = props.overrides && props.overrides.GoBackItem && props.overrides.GoBackItem.render && props.overrides.GoBackItem.render({
        onClick: onUnNest,
        testId: testId && `${testId}--go-back-item`,
        ref: backButtonRef
    }) || contextualBackButton;
    const context = (0, $5uXOq.useMemo)(()=>({
            stack: stack,
            currentStackId: currentStackId,
            onNest: onNest,
            onUnNest: onUnNest,
            backButton: backButton,
            parentId: id,
            childIds: childIds,
            forceShowTopScrollIndicator: forceShowTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        stack,
        currentStackId,
        onNest,
        onUnNest,
        backButton,
        id,
        childIds,
        forceShowTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    (0, $4bO8w.useChildIdsEffect)(childIds, id);
    const isNormalClick = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
    /**
   * We want both the on nest handler and the onclick handler to be called.
   * We create a wrapper function to call both.
   */ const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        if (isInteracted) // We return early if this has been interacted with because its assumed
        // this will be already exiting - so we don't want to double up the click.
        return;
        // Avoid a nesting transition if a modifier key is detected during click.
        // @ts-expect-error - Argument of type 'MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>' is not assignable to parameter of type 'MouseEvent'
        if (isNormalClick(e)) {
            setIsInteracted(true);
            onNest(id);
        }
        onClick && onClick(e);
    }, [
        isInteracted,
        onClick,
        onNest,
        id
    ]);
    if (currentStackId === id) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $fsi33.NestedContext).Provider, {
        value: context,
        children: [
            stack.length >= 1 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                paddingBlock: "space.075",
                paddingInline: "space.100",
                children: backButton
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2uGoK.default), {
                testId: testId,
                showTopScrollIndicator: forceShowTopScrollIndicator || stack.length >= 1,
                children: children
            })
        ]
    });
    if ([
        (0, $a4hJx.ROOT_ID),
        ...stack
    ].includes(id)) return children;
    const componentProps = {
        iconAfter: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                iconAfter ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    xcss: $1fee06468e5ae9b2$var$styles.iconContainer,
                    "data-custom-icon": true,
                    as: "span",
                    children: iconAfter
                }) : null,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    "data-right-arrow": true,
                    xcss: $1fee06468e5ae9b2$var$styles.iconContainer,
                    as: "span",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6gA2o))), {
                        testId: testId && `${testId}--item--right-arrow`,
                        color: "currentColor",
                        LEGACY_secondaryColor: `var(--ds-surface, ${(0, $a7f8c6b391092279$export$e655ef011c4aa1a2)})`,
                        label: ""
                    })
                })
            ]
        }),
        onClick: onClickHandler,
        isSelected: isSelected,
        testId: testId && `${testId}--item`,
        ...rest,
        children: title,
        cssFn: mergedStyles
    };
    if (component) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bY5Mc.default), {
        ref: isForwardRefCheck(component) ? parentItemRef : null,
        ...componentProps,
        //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
        component: component
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4iTJw.default), {
        ref: activeParentRef,
        ...componentProps
    });
};
var $1fee06468e5ae9b2$export$2e2bcd8739ae039 = $1fee06468e5ae9b2$var$NestingItem;

});
parcelRegister("6gA2o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dbc8100b1314a43ce0868b8331a89007>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $490030febd58df31$var$_react = $490030febd58df31$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $490030febd58df31$var$_arrowRight = $490030febd58df31$var$_interopRequireDefault((parcelRequire("kAczT")));

var $490030febd58df31$var$_arrowRightCircle = $490030febd58df31$var$_interopRequireDefault((parcelRequire("ax5oF")));
function $490030febd58df31$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $490030febd58df31$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $490030febd58df31$var$_react.default.createElement($490030febd58df31$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $490030febd58df31$var$_arrowRightCircle.default
    }, props));
$490030febd58df31$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $490030febd58df31$var$_default = module.exports.default = $490030febd58df31$var$ArrowRightIcon;

});
parcelRegister("kAczT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $efc0ed230d3ca890$var$_react = $efc0ed230d3ca890$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $efc0ed230d3ca890$var$_baseNew = $efc0ed230d3ca890$var$_interopRequireDefault((parcelRequire("enEmH")));
function $efc0ed230d3ca890$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $efc0ed230d3ca890$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $efc0ed230d3ca890$var$_react.default.createElement($efc0ed230d3ca890$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$efc0ed230d3ca890$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $efc0ed230d3ca890$var$_default = module.exports.default = $efc0ed230d3ca890$var$ArrowRightIcon;

});

parcelRegister("ax5oF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ab12c2904bc0560$var$_react = $7ab12c2904bc0560$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $7ab12c2904bc0560$var$_arrowRight = $7ab12c2904bc0560$var$_interopRequireDefault((parcelRequire("kAczT")));
function $7ab12c2904bc0560$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7ab12c2904bc0560$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $7ab12c2904bc0560$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
    }, props, {
        newIcon: $7ab12c2904bc0560$var$_arrowRight.default
    }));
$7ab12c2904bc0560$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
var $7ab12c2904bc0560$var$_default = module.exports.default = $7ab12c2904bc0560$var$ArrowRightCircleIcon;

});


parcelRegister("bY5Mc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1bca491cca55dea$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-overrides */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2COCu = parcelRequire("2COCu");

var $c48kn = parcelRequire("c48kn");

var $fsi33 = parcelRequire("fsi33");
/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */ const $f1bca491cca55dea$var$CustomItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
({ cssFn: cssFn, ...rest }, ref)=>{
    const { shouldRender: shouldRender } = (0, $fsi33.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssOverride = (0, $c48kn.overrideStyleFunction)((0, $c48kn.baseSideNavItemStyle), cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2COCu.default), {
        ref: ref,
        cssFn: cssOverride,
        ...rest
    });
});
var $f1bca491cca55dea$export$2e2bcd8739ae039 = $f1bca491cca55dea$var$CustomItem;

});

parcelRegister("2uGoK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0522d7db65b02790$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $iIWB4 = parcelRequire("iIWB4");

var $fsi33 = parcelRequire("fsi33");
const $0522d7db65b02790$var$outerContainerCSS = null;
const $0522d7db65b02790$var$innerContainerCSS = {
    basic: "_1reo1wug _18m91wug _1e0c1txw _vchhusvi _1bsb1osq _kqswh2mm _2lx21bp4 _14mjgqwt _1ywu1ule _1qdgyh40 _18poh2mm _1bqqcs5v _tua5idpf _1hfk1q2g _aetrb3bt _3mxo1wug",
    topScrollIndicator: "_rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vcs5v _1rus1q2g _1kt9b3bt _1enwidpf _z5wtidpf"
};
const $0522d7db65b02790$var$containerCSS = {
    basic: "_kqswh2mm _12l2u2gc _ahbqu2gc _1pfhidpf _1p3h12x7 _1l6bpxbi _auo4rdoj _hp2110yn",
    marginBlockStart: "_1pfhv77o"
};
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $0522d7db65b02790$var$NavigationContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $fsi33.useShouldNestedElementRender)();
    const scrollbar = (0, $iIWB4.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: typedRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _kqswh2mm _rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vkb7n _1rus1p09 _1kt9b3bt _1enwftgi _z5wtu2gc _14mjgqwt _1ywu1ule _1qdgyh40 _18postnw _1bqqkb7n _tua5idpf _1hfk1p09 _aetrb3bt _1gufidpf _1czdftgi _g0nfu2gc"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: scrollbar.ref,
            className: (0, $bwpsq.default)([
                $0522d7db65b02790$var$innerContainerCSS.basic,
                !showTopScrollIndicator && $0522d7db65b02790$var$innerContainerCSS.topScrollIndicator
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $0522d7db65b02790$var$containerCSS.basic,
                    showTopScrollIndicator && $0522d7db65b02790$var$containerCSS.marginBlockStart
                ]),
                children: children
            })
        })
    });
});
var $0522d7db65b02790$export$2e2bcd8739ae039 = $0522d7db65b02790$var$NavigationContent;

});
parcelRegister("iIWB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $16e79fe7c7a46990$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $16e79fe7c7a46990$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $5uXOq.useState)(0);
    const elementRef = (0, $5uXOq.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});


parcelRegister("4bO8w", function(module, exports) {

$parcel$export(module.exports, "useChildIds", () => $59c19cb7551d7415$export$61b3ef4f009a9474);
$parcel$export(module.exports, "useChildIdsEffect", () => $59c19cb7551d7415$export$ea18c2b5f0e24612);

var $5uXOq = parcelRequire("5uXOq");

var $a4hJx = parcelRequire("a4hJx");
const $59c19cb7551d7415$export$61b3ef4f009a9474 = (currentStackId, committedStack, onUnknownNest)=>{
    const childIdsRef = (0, $5uXOq.useRef)(new Set());
    (0, $5uXOq.useEffect)(()=>{
        // we are holding navigation item IDs in childIdsRef
        // check if the current displayed nav item (currentStackId) is in childIdsRef. if it's not, this means it's undefined
        if (currentStackId === (0, $a4hJx.ROOT_ID) || !childIdsRef.current.size || childIdsRef.current.has(currentStackId) || !onUnknownNest) return;
        onUnknownNest(committedStack || [
            currentStackId
        ]);
    }, [
        currentStackId,
        committedStack,
        onUnknownNest
    ]);
    return {
        childIdsRef: childIdsRef
    };
};
const $59c19cb7551d7415$export$ea18c2b5f0e24612 = (childIds, id)=>{
    (0, $5uXOq.useEffect)(()=>{
        if (!childIds || !childIds.current) return;
        if (!childIds.current.has(id)) childIds.current.add(id);
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            childIds.current.delete(id);
        };
    // childIds shouldn't change as it's a ref
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
};

});

parcelRegister("hE0bV", function(module, exports) {

$parcel$export(module.exports, "nestingItemStyle", () => $9bf7631033ec0b7d$export$38e770f85519b259);
const $9bf7631033ec0b7d$export$4c36b5b1b67ee1e8 = {
    ['&:hover [data-custom-icon]']: {
        display: 'none'
    },
    ['&:active [data-custom-icon]']: {
        display: 'none'
    },
    ['&:focus [data-custom-icon]']: {
        display: 'none'
    },
    ['& [data-custom-icon]']: {
        display: 'inherit'
    },
    ['&:hover [data-right-arrow]']: {
        display: 'inherit'
    },
    ['&:active [data-right-arrow]']: {
        display: 'inherit'
    },
    ['&:focus [data-right-arrow]']: {
        display: 'inherit'
    },
    ['& [data-right-arrow]']: {
        display: 'none'
    }
};
const $9bf7631033ec0b7d$var$disabledCSS = {
    ['[data-item-elem-after]']: {
        opacity: 0
    },
    ['& [data-right-arrow]']: {
        display: 'none'
    }
};
const $9bf7631033ec0b7d$export$38e770f85519b259 = (state)=>{
    return {
        ...state.isDisabled ? $9bf7631033ec0b7d$var$disabledCSS : $9bf7631033ec0b7d$export$4c36b5b1b67ee1e8
    };
};

});


parcelRegister("atNen", function(module, exports) {

$parcel$export(module.exports, "NestingMotion", () => $73b6973e2eaccf98$export$9e743a8c2a6b450e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3aB43 = parcelRequire("3aB43");
const $73b6973e2eaccf98$export$9e743a8c2a6b450e = (props)=>{
    const { children: children, enterFrom: enterFrom, exitTo: exitTo, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3aB43.default), {
        exitTo: exitTo,
        enterFrom: enterFrom,
        animationTimingFunction: "ease-out",
        children: (innerProps, direction)=>children({
                'data-enter-from': enterFrom,
                'data-exit-to': exitTo,
                'data-testid': testId && `${testId}-${direction}`,
                ...innerProps
            })
    });
};

});


parcelRegister("2zFxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $75770a0a8b5fef07$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8ZVfC = parcelRequire("8ZVfC");
const $75770a0a8b5fef07$var$sidebarMinWidth = '240px';
const $75770a0a8b5fef07$var$sideNavStyles = null;
/**
 * __Side navigation__
 *
 * A highly composable side navigation component that supports nested views.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 * - [Usage](https://atlassian.design/components/side-navigation/usage)
 */ const $75770a0a8b5fef07$var$SideNavigation = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, label: label, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("nav", {
        ref: ref,
        "data-testid": testId,
        "aria-label": label,
        "data-vc": `side-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'side-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'side-navigation-placeholder'
        },
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _1ul9p3fh _4t3i1osq _kqswh2mm _2lx21bp4 _bfhkw70a _syazjjyb"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8ZVfC.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "notch",
            children: children
        })
    });
});
var $75770a0a8b5fef07$export$2e2bcd8739ae039 = $75770a0a8b5fef07$var$SideNavigation;

});

parcelRegister("k0ZZ2", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $5e6269ab5deb76fb$export$2ce376c2cc3355c8);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aZsz6 = parcelRequire("aZsz6");

var $bY5Mc = parcelRequire("bY5Mc");

var $hjSul = parcelRequire("hjSul");
var $doZTA = parcelRequire("doZTA");

var $fpoBX = parcelRequire("fpoBX");

var $jvqf4 = parcelRequire("jvqf4");
const $5e6269ab5deb76fb$var$cssVarPrefix = '--sidebar-menu-item';
const $5e6269ab5deb76fb$var$bgColorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color`;
const $5e6269ab5deb76fb$var$bgColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-hover`;
const $5e6269ab5deb76fb$var$bgColorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-active`;
const $5e6269ab5deb76fb$var$colorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color`;
const $5e6269ab5deb76fb$var$colorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-hover`;
const $5e6269ab5deb76fb$var$colorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-active`;
const $5e6269ab5deb76fb$var$boxShadowCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-box-shadow`;
const $5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-icon-secondary-color-hover`;
const $5e6269ab5deb76fb$var$styles = {
    root: "_ow0718uv _vwjz18uv _el8t18uv _17rj1kw7 _1f981kw7 _12pi1kw7 _1iqunqa1 _6xf7nqa1 _1lwpnqa1 _144v1r31 _3m4d1r31 _epv21r31 _chl4glyw _1bblglyw _1xhsglyw _1txwidpf _fg45idpf _gmaiidpf _10fu1oxo _iozn1cd0 _1vzi1w2z _davf29yu _1lfucjiy _s3s5tlke _12pzh2mm",
    selected: "_1cmdaqb7",
    themeColorDefault: "_1w905hvc _zelm5hvc _1f1j5hvc _1cmd5hvc",
    themeColorHover: "_1fh1smn3",
    themeColorActive: "_1l5a14t4 _1gdc14t4 _g8mu14t4 _434t14t4",
    themeBgColorDefault: "_16hgrn9c",
    themeBgColorHover: "_u1mb58tq",
    themeBgColorActive: "_1lg618j6",
    themeIconSecondaryColorHover: "_1k5811db"
};
const $5e6269ab5deb76fb$var$WrapperComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, className: className, legacyClassName: legacyClassName, href: href, to: to, target: target, useButtonLink: // @ts-expect-error - TS2339 - Property 'useButtonLink' does not exist on type 'CustomItemComponentProps & AnchorHTMLAttributes<HTMLAnchorElement> & { children: ReactNode; ... 10 more ...; prefetch?: false | ... 2 more ... | undefined; } & { ...; }'.
useButtonLink, ...props }, ref)=>{
    const commonProps = {
        ...props,
        children: children,
        className: `${className ?? ''} ${legacyClassName ?? ''}`
    };
    return href != null || to != null ? /*#__PURE__*/ $5uXOq.createElement((0, $hjSul.Link), {
        ...commonProps,
        href: href,
        to: to,
        target: target,
        ref: ref,
        type: useButtonLink ? 'button' : 'a'
    }) : // @ts-expect-error Type 'HTMLAnchorElement | HTMLButtonElement | null' is not assignable to type 'HTMLButtonElement | null'
    /*#__PURE__*/ $5uXOq.createElement($5e6269ab5deb76fb$var$ButtonItem, {
        ...commonProps,
        type: "button",
        ref: ref
    });
});
const $5e6269ab5deb76fb$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, overrides: overrides, selectedOn: selectedOn, className: className, useButtonLink: useButtonLink = false, ...rest }, ref)=>{
    const onClickHandler = (0, $jvqf4.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    const [{ route: route, query: query, location: location }] = (0, $doZTA.useRouter)();
    let isSelected;
    // Currently, because the CMP project settings are not part of the SPA, the whole sidebar reloads everytime a menu item
    // is clicked -> As part of the Lunar Project Settings improvements, we're scrolling selected items into view once the
    // page reloads.
    //
    // We're setting a timeout to wait for the event loop to complete prior to scrolling.
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
        if (isSelected && ref?.current != null) setTimeout(()=>{
            // using ref?.current doesn't seem to work specifically here
            // Flow complianed about this part here specifically :/
            ref && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current != null && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    }, [
        selectedOn,
        ref,
        // @ts-expect-error - Variable 'isSelected' is used before being assigned.
        isSelected
    ]);
    if (typeof selectedOn === 'function') isSelected = route != null && // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
    selectedOn({
        ...location,
        query: query
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(href || '/', true));
    else isSelected = Boolean(selectedOn) && route != null && selectedOn != null && selectedOn.includes(route.name);
    const theme = (0, $fpoBX.useSidebarTheme)();
    const itemTheme = theme?.navigation?.item;
    const iconTheme = theme?.navigation?.icon;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customProps = {
        ...rest,
        component: $5e6269ab5deb76fb$var$WrapperComponent,
        href: href,
        isSelected: isSelected,
        onClick: onClickHandler,
        overrides: overrides,
        ref: ref,
        useButtonLink: useButtonLink,
        'aria-current': isSelected ? 'page' : undefined,
        style: {
            [$5e6269ab5deb76fb$var$bgColorCssVar]: itemTheme?.background?.default ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorHoverCssVar]: itemTheme?.background?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorActiveCssVar]: itemTheme?.background?.active ?? undefined,
            [$5e6269ab5deb76fb$var$colorCssVar]: itemTheme?.color?.default ?? undefined,
            [$5e6269ab5deb76fb$var$colorHoverCssVar]: itemTheme?.color?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$colorActiveCssVar]: itemTheme?.color?.active ?? undefined,
            [$5e6269ab5deb76fb$var$boxShadowCssVar]: itemTheme?.color?.active != null ? `${itemTheme?.color?.active} 0 0 0 2px inset` : `${"var(--ds-border-focused, #388BFF)"} 0 0 0 2px inset`,
            [$5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar]: iconTheme?.secondary?.color?.hover ?? undefined
        }
    };
    if (overrides?.CustomItem?.render) return overrides?.CustomItem?.render({
        ...customProps,
        className: (0, $bwpsq.default)([
            (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.root
            ]),
            isSelected && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.selected
            ]),
            itemTheme?.color?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorDefault
            ]),
            itemTheme?.background?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorDefault
            ]),
            itemTheme?.background?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorHover
            ]),
            itemTheme?.background?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorActive
            ]),
            itemTheme?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorHover
            ]),
            itemTheme?.color?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorActive
            ]),
            iconTheme?.secondary?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover
            ]),
            className
        ])
    });
    return /*#__PURE__*/ $5uXOq.createElement((0, $bY5Mc.default), {
        ...customProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            $5e6269ab5deb76fb$var$styles.root,
            isSelected && $5e6269ab5deb76fb$var$styles.selected,
            itemTheme?.color?.default && $5e6269ab5deb76fb$var$styles.themeColorDefault,
            itemTheme?.background?.default && $5e6269ab5deb76fb$var$styles.themeBgColorDefault,
            itemTheme?.background?.hover && $5e6269ab5deb76fb$var$styles.themeBgColorHover,
            itemTheme?.background?.active && $5e6269ab5deb76fb$var$styles.themeBgColorActive,
            itemTheme?.color?.hover && $5e6269ab5deb76fb$var$styles.themeColorHover,
            itemTheme?.color?.active && $5e6269ab5deb76fb$var$styles.themeColorActive,
            iconTheme?.secondary?.color?.hover && $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover,
            className
        ])
    });
});
// this should be same as ButtonItem in '@atlaskit/menu'
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e6269ab5deb76fb$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fpoBX", function(module, exports) {

$parcel$export(module.exports, "SidebarThemeProvider", () => $c9116269ddc1accc$export$92cd68117b68bf5f);
$parcel$export(module.exports, "useSidebarTheme", () => $c9116269ddc1accc$export$b1a81b4626bc52c3);

var $5uXOq = parcelRequire("5uXOq");
const $c9116269ddc1accc$var$ThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $c9116269ddc1accc$export$92cd68117b68bf5f = ({ theme: theme, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9116269ddc1accc$var$ThemeContext.Provider, {
        value: theme
    }, children);
const $c9116269ddc1accc$export$b1a81b4626bc52c3 = ()=>(0, $5uXOq.useContext)($c9116269ddc1accc$var$ThemeContext);

});

parcelRegister("jvqf4", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $568e03d72b926f2a$export$a81c45382e7253ac);

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");
const $568e03d72b926f2a$export$a81c45382e7253ac = ({ analytics: analytics, onClick: onClick } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        if (analytics) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar', analytics);
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar');
        onClick && onClick(event);
    };
};

});


parcelRegister("3OGaE", function(module, exports) {

$parcel$export(module.exports, "TitleHeader", () => $09f1bcc415909488$export$de3705f3d2162955);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fJoTF = parcelRequire("fJoTF");
const $09f1bcc415909488$var$overrideStyles = null;
const $09f1bcc415909488$export$de3705f3d2162955 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJoTF.CustomHeader), {
        testId: "navigation-apps-sidebar-common.common.ui.title-header",
        className: (0, $bwpsq.default)([
            "_dqi54jg8 _1lfu4jg8"
        ])
    }, children);
};

});
parcelRegister("fJoTF", function(module, exports) {

$parcel$export(module.exports, "CustomHeader", () => $d2408f7c0923c3e9$export$a231a61d189ef09a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bY5Mc = parcelRequire("bY5Mc");

var $fpoBX = parcelRequire("fpoBX");
const $d2408f7c0923c3e9$var$bgColorCssVar = '--header-bg-color';
const $d2408f7c0923c3e9$var$textColorCssVar = '--header-text-color';
const $d2408f7c0923c3e9$var$containerStyles = null;
const $d2408f7c0923c3e9$var$bgColorThemeStyles = null;
const $d2408f7c0923c3e9$var$colorThemeStyles = null;
const $d2408f7c0923c3e9$export$1e86fd0e1db89578 = ({ className: className, ...props })=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_vrjt140y _1cmdleuv _1w901jnk _14n4h2mm _1cg71wug _jl2n73ad _1v6j1fxt",
            item?.background?.default && "_16hg1im0",
            item?.color?.default && "_1w901jnk _i9a11jnk",
            className
        ]),
        // eslint-disable-next-line jira/react/no-style-attribute
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            [$d2408f7c0923c3e9$var$bgColorCssVar]: item?.background?.default,
            [$d2408f7c0923c3e9$var$textColorCssVar]: item?.color?.default
        },
        ...props
    });
};
const $d2408f7c0923c3e9$export$a231a61d189ef09a = ({ iconBefore: iconBefore, iconAfter: iconAfter, children: children, ...rest })=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $bY5Mc.default), {
        ...rest,
        component: $d2408f7c0923c3e9$export$1e86fd0e1db89578,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
        overrides: {
            Title: {
                // eslint-disable-next-line @atlaskit/design-system/use-heading
                render: (_, { children: title, ...props })=>/*#__PURE__*/ $5uXOq.createElement("h2", props, title)
            }
        }
    }, children);
};

});


parcelRegister("juTur", function(module, exports) {

$parcel$export(module.exports, "ContextualAnalyticsData", () => $ffb2d49dc0e79e64$export$198470770171c65);
$parcel$export(module.exports, "IssuesContextualAnalyticsData", () => $ffb2d49dc0e79e64$export$bc7f6eebc16e6127);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $iXVV6 = parcelRequire("iXVV6");

var $lpwtK = parcelRequire("lpwtK");

var $3d1up = parcelRequire("3d1up");
const $ffb2d49dc0e79e64$export$198470770171c65 = ({ attributes: attributes, menuId: menuId, stack: stack = [], ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
            navVersion: '3',
            viewId: (0, $3d1up.generateViewId)(menuId, ...stack),
            navigationLayer: 'container',
            ...attributes
        }
    });
const $ffb2d49dc0e79e64$export$bc7f6eebc16e6127 = ({ attributes: attributes, navigatorScope: navigatorScope, useProject: useProject = (0, $lpwtK.useProject), ...rest })=>{
    const { data: project } = useProject();
    const projectConfig = (project?.isSimplified ? (0, $2vSU6.ProjectStyle).NEXT_GEN : (0, $2vSU6.ProjectStyle).CLASSIC) || undefined;
    const projectType = project?.type || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            ...attributes,
            projectConfig: projectConfig,
            projectType: projectType,
            navigatorScope: navigatorScope
        }
    });
};

});
parcelRegister("3d1up", function(module, exports) {

$parcel$export(module.exports, "generateViewId", () => $2f6f53381b1f04e0$export$5b5545ed894dc47a);
const $2f6f53381b1f04e0$export$5b5545ed894dc47a = (...ids)=>ids.join('/');

});


parcelRegister("17bH5", function(module, exports) {

$parcel$export(module.exports, "getSystemNavigationPaths", () => $0ac95c37050f315f$export$76c5f80c8d9bdb0e);
$parcel$export(module.exports, "isSystemNavPath", () => $0ac95c37050f315f$export$3e53a29d6e499ec4);

var $4R6GH = parcelRequire("4R6GH");
const $0ac95c37050f315f$export$76c5f80c8d9bdb0e = ()=>({
        generalConfiguration: '/jira/settings/system/general-configuration',
        darkFeatures: '/secure/admin/SiteDarkFeatures!default.jspa',
        issueCollectors: '/secure/admin/ViewGlobalCollectors!default.jspa',
        globalAutomation: '/jira/settings/automation',
        // troubleshooting
        troubleshootingAuditLog: '/auditing/view',
        troubleshootingPluginViewer: '/plugins/servlet/depview/plugins',
        troubleshootingModulesViewer: '/plugins/servlet/depview/modules',
        troubleshootingSystemInfo: '/secure/admin/ViewSystemInfo.jspa',
        troubleshootingIntegrityChecker: '/secure/admin/IntegrityChecker!default.jspa',
        troubleshootingLoggingProfiling: '/secure/admin/ViewLogging.jspa',
        troubleshootingSchedulerDetails: '/secure/admin/SchedulerAdmin.jspa',
        troubleshootingPerformanceAndScale: '/jira/settings/system/performance/overview',
        // security
        securityProjectRoles: '/secure/project/ViewProjectRoles.jspa',
        securityGlobalPermissions: (0, $4R6GH.fg)('olympus-global-permissions-fe-modernisation') ? '/secure/admin/global-permissions' : '/secure/admin/GlobalPermissions!default.jspa',
        // user interface
        userInterfacesUserDefaults: '/secure/admin/ViewUserDefaultSettings.jspa',
        userInterfacesEditDefaultDashboard: '/secure/admin/EditDefaultDashboard!default.jspa',
        userInterfacesLookAndFeel: '/secure/admin/LookAndFeel!default.jspa',
        userInterfacesPasAdmin: '/plugins/servlet/pas/admin',
        userInterfacesSiteAdmin: '/jira/settings/system/ui/announcement-banner',
        // import and export
        importSectionBackupManager: '/secure/admin/CloudExport.jspa',
        importSectionExternalImport: '/secure/admin/ExternalImport1.jspa',
        importSectionExternalImportNew: '/jira/settings/system/external-import',
        importSectionCloudImport: '/secure/admin/CloudImport!start.jspa?source=import_cloud',
        importSectionServerImport: '/secure/admin/CloudImport!start.jspa?source=import_server',
        // mail
        mailSectionGlobalMailSettings: '/secure/admin/GlobalMailSettings.jspa',
        mailSectionOutgoingMail: '/secure/admin/OutgoingMailServers.jspa',
        mailSectionIncomingMail: '/secure/admin/IncomingMailServers.jspa',
        mailSectionSendMail: '/secure/admin/SendBulkMail!default.jspa',
        // admin
        adminHelperPermissionHelper: '/secure/admin/PermissionHelperAdmin.jspa',
        adminHelperEmailNotificationsLogHelper: '/jira/settings/system/notification-logs',
        // shared
        sharedSectionManageFilters: '/secure/admin/filters/ViewSharedFilters.jspa',
        sharedManageDashboards: '/secure/admin/dashboards/ViewSharedDashboards.jspa',
        // advanced
        advancedSectionAttachments: '/secure/admin/ViewAttachmentSettings.jspa',
        advancedSectionEvents: '/secure/admin/ListEventTypes.jspa',
        advancedSectionWebHooks: '/plugins/servlet/webhooks',
        advancedSectionServices: '/secure/admin/ViewServices!default.jspa',
        advancedLexoRankManagement: '/secure/GHLexoRankManage.jspa?decorator=admin'
    });
const $0ac95c37050f315f$var$getSystemNavPaths = ()=>{
    return [
        '/jira/settings/system/general-configuration',
        '/secure/admin/SiteDarkFeatures',
        '/secure/admin/ViewGlobalCollectors',
        '/jira/settings/automation',
        '/auditing/view',
        '/secure/project/ViewProjectRoles',
        '/secure/admin/global-permissions',
        '/secure/admin/GlobalPermissions',
        '/secure/admin/ViewUserDefaultSettings',
        '/secure/admin/EditDefaultDashboard',
        '/secure/admin/LookAndFeel',
        '/jira/settings/system/ui/announcement-banner',
        '/secure/admin/CloudExport',
        '/jira/settings/system/external-import',
        '/secure/admin/CloudImport',
        '/secure/admin/GlobalMailSettings',
        '/secure/admin/global-mail-settings',
        '/secure/admin/OutgoingMailServers',
        '/secure/admin/IncomingMailServers',
        '/secure/admin/SendBulkMail',
        '/secure/admin/PermissionHelperAdmin',
        '/jira/settings/system/notification-logs',
        '/secure/admin/filters/ViewSharedFilters',
        '/secure/admin/dashboards/ViewSharedDashboards',
        '/secure/admin/ViewAttachmentSettings',
        '/secure/admin/ListEventTypes',
        '/plugins/servlet/webhooks',
        '/secure/GHLexoRankManage'
    ];
};
const $0ac95c37050f315f$export$3e53a29d6e499ec4 = (path)=>{
    const paths = $0ac95c37050f315f$var$getSystemNavPaths();
    return path && paths.some((p)=>path.includes(p));
};

});

parcelRegister("4OCke", function(module, exports) {

$parcel$export(module.exports, "matchPathname", () => $cf3ce1d2a79b8e17$export$b71b01274a8bb9ec);
$parcel$export(module.exports, "matchUrlPathname", () => $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c);
$parcel$export(module.exports, "matchPartialUrlPathname", () => $cf3ce1d2a79b8e17$export$9870a2fa97808ed7);
$parcel$export(module.exports, "matchUrlExact", () => $cf3ce1d2a79b8e17$export$422d2a799c6e30b8);
$parcel$export(module.exports, "matchUrlParams", () => $cf3ce1d2a79b8e17$export$63fdecce99465869);

var $f8l56 = parcelRequire("f8l56");
// Jira url paths are messy, so we have to try to clean them to avoid missing matches
// - pages urls sometimes have /secure, sometimes they don't
// - jspa pages urls sometimes have !action, sometimes they don't
const $cf3ce1d2a79b8e17$var$cleanPath = (path)=>path.replace('/secure/', '/').replace(/!\w+\.jspa/, '.jspa');
const $cf3ce1d2a79b8e17$export$b71b01274a8bb9ec = (currentUrlPath, itemUrlPath)=>$cf3ce1d2a79b8e17$var$cleanPath(currentUrlPath) === $cf3ce1d2a79b8e17$var$cleanPath(itemUrlPath);
const $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$b71b01274a8bb9ec(currentLocation.pathname, itemLocation.pathname);
const $cf3ce1d2a79b8e17$export$9870a2fa97808ed7 = ()=>(currentLocation, itemLocation)=>currentLocation.pathname.includes(itemLocation.pathname);
const $cf3ce1d2a79b8e17$export$422d2a799c6e30b8 = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation) && (0, (/*@__PURE__*/$parcel$interopDefault($f8l56)))(currentLocation.query, itemLocation.query);
const $cf3ce1d2a79b8e17$export$63fdecce99465869 = (withParams, withPathname = true)=>(currentLocation, itemLocation)=>(!withPathname || $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation)) && withParams.every((p)=>currentLocation.query[p] && currentLocation.query[p] === itemLocation.query[p]);

});

parcelRegister("3tHFY", function(module, exports) {

$parcel$export(module.exports, "ConnectMenu", () => $1b0be5b9936240ae$export$19d0925d424b864a);

var $5uXOq = parcelRequire("5uXOq");

var $au6nA = parcelRequire("au6nA");

var $fh2pW = parcelRequire("fh2pW");
const $1b0be5b9936240ae$export$19d0925d424b864a = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '' })=>{
    const filteredItems = (0, $au6nA.useFilteredItems)(items || null, shouldFilter);
    if (filteredItems == null || !filteredItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, filteredItems.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fh2pW.ConnectItem), {
            item: item,
            key: item.id,
            index: index,
            overrides: overrides,
            showIcons: showIcons,
            submenuId: submenuId
        })));
};

});
parcelRegister("au6nA", function(module, exports) {

$parcel$export(module.exports, "useFilteredItems", () => $cb371d7d8e582719$export$79762159776e61da);

var $5uXOq = parcelRequire("5uXOq");

var $kvHKs = parcelRequire("kvHKs");
const $cb371d7d8e582719$export$79762159776e61da = (items, shouldFilter = true)=>(0, $5uXOq.useMemo)(()=>{
        if (!shouldFilter) return items || [];
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"services" | "collectors" | "attachments" | "eventtypes" | "webhooks-admin" | "greenhopper-lexorank-manage" | "admin-helper-admin-section" | "advanced_section" | "dark_features" | ... 74 more ... | "com.codebarrel.addons.automation__cb-automation"'.
        return items?.filter((item)=>!(0, $kvHKs.staticLegacyIds).includes(item.id)) || [];
    }, [
        items,
        shouldFilter
    ]);

});

parcelRegister("fh2pW", function(module, exports) {

$parcel$export(module.exports, "ConnectItem", () => $f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $41Nl9 = parcelRequire("41Nl9");

var $kxnYb = parcelRequire("kxnYb");

var $3TzYp = parcelRequire("3TzYp");

var $iUo88 = parcelRequire("iUo88");

var $jjUR3 = parcelRequire("jjUR3");

var $hrlU6 = parcelRequire("hrlU6");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $eYDk7 = parcelRequire("eYDk7");

var $3OGaE = parcelRequire("3OGaE");

var $kZj7F = parcelRequire("kZj7F");

var $4OCke = parcelRequire("4OCke");
const $f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea = ({ index: index, item: item, overrides: overrides, showIcons: showIcons, submenuId: submenuId = '', isNested: isNested = false })=>{
    const { addNew: addNew } = (0, $jjUR3.useConnectItemClickHistory)();
    const isDialog = item.styleClass && (0, $hrlU6.isConnectDialogWebItem)(item.styleClass);
    const webItemRef = (0, $5uXOq.useRef)(null);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const BackMenuItem = {
        ...overrides.BackMenuItem,
        onClick: (ev)=>{
            // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
            // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
            // This is to satisfy a requirement for open expandable menus to remain open
            // when users return to the project settings menu
            if (submenuId != null) {
                const cookieData = (0, $3TzYp.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
                let parsedCookieData = null;
                try {
                    // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                    parsedCookieData = JSON.parse(cookieData);
                } catch  {
                    // Rather than throw an error - just set the default state
                    parsedCookieData = {
                        submenuActive: false,
                        expanded: false
                    };
                }
                const newCookieData = {
                    ...parsedCookieData,
                    submenuActive: false
                };
                (0, $iUo88.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newCookieData));
            }
            // Setting navigateOnBackMenuItemClick to true will allow backToProject link to take user to the default project page
            if (overrides?.navigateOnBackMenuItemClick !== true) ev.preventDefault();
            overrides.BackMenuItem?.onClick?.(ev);
        }
    };
    const icon = (0, $5uXOq.useMemo)(()=>{
        if (showIcons !== true) return null;
        return item.iconUrl != null && item.iconUrl.trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$var$ConnectIcon, {
            src: item.iconUrl,
            alt: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($41Nl9))), {
            spacing: "spacious",
            label: ""
        });
    }, [
        showIcons,
        item.iconUrl
    ]);
    const onItemClick = (0, $5uXOq.useCallback)((event)=>{
        // We need to check we're clicking an item inside a nested menu for a connect item.
        // if we are deep linking to a nested connect item -> we need to maintain the hiding of nav-modules
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick && isNested) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        if (isDialog) (0, $hrlU6.withConnectHost)((connectHost)=>{
            if (webItemRef.current && item.styleClass && item.url) connectHost.triggerWebItem(webItemRef.current, item.styleClass, item.url);
        });
        else item.url != null && addNew(item.url);
    }, [
        addNew,
        isDialog,
        isNested,
        item.styleClass,
        item.url,
        overrides
    ]);
    const onNestedMenuItemClick = (0, $5uXOq.useCallback)((event)=>{
        // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
        // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
        // This is to satisfy a requirement for open expandable menus to remain open
        // when users return to the project settings menu
        if (submenuId != null) {
            const cookieData = (0, $3TzYp.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
            if (cookieData != null) (0, $iUo88.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify({
                ...JSON.parse(cookieData),
                submenuActive: true
            }));
        }
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        return ()=>null;
    }, [
        overrides,
        submenuId
    ]);
    if (item.section === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        title: item.name,
        hasSeparator: Boolean(index)
    }, (item.items || []).map((si, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            overrides: {
                ...overrides,
                BackMenuItem: BackMenuItem
            },
            index: idx,
            isNested: isNested
        })));
    if (item.items) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        id: item.id,
        analytics: {
            itemId: item.id
        },
        iconBefore: icon,
        overrides: {
            ...overrides,
            BackMenuItem: BackMenuItem
        },
        title: item.name,
        onClick: onNestedMenuItemClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYDk7.NavigationContentWrapper), {
        submenuActive: true,
        nestedMenuOpen: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, item.name), (item.items || []).map((si, nestIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            index: nestIndex,
            overrides: {
                ...overrides,
                BackMenuItem: {
                    href: item.url,
                    title: si.name,
                    onClick: (ev)=>ev.preventDefault()
                }
            },
            isNested: true
        })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: item.id
        },
        selectedOn: (0, $4OCke.matchUrlExact)(),
        iconBefore: icon,
        href: isDialog ? undefined : item.url,
        onClick: onItemClick,
        ref: webItemRef
    }, item.name);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f2bd062d7c8c5e44$var$ConnectIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iUo88", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $89b5b8a4b358ad27$export$93509ff9a62ee022);

var $eb1mj = parcelRequire("eb1mj");
const $89b5b8a4b358ad27$export$93509ff9a62ee022 = (key, value, attributes)=>{
    (0, $eb1mj.setStrictlyNecessaryCookie)(key, value, attributes);
};

});

parcelRegister("jjUR3", function(module, exports) {

$parcel$export(module.exports, "useConnectItemClickHistory", () => $c499ec49965fe6fe$export$c251e3fda1cce4a3);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");
// A single instance for the entire SPA session
const $c499ec49965fe6fe$var$history = {
    unique: []
};
const $c499ec49965fe6fe$export$c251e3fda1cce4a3 = ()=>{
    (0, $gKZoD.di)(window);
    const addNew = (0, $5uXOq.useCallback)((historyItem)=>{
        // Here we want to store only unique items. For example, if the add-on updates Jira hash
        // and user clicks the same navigation link we consider it as a unique navigation action
        // so we can use this info later on to rerender the iframe
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.location.href.endsWith(historyItem) === false) // @ts-expect-error - TS2339 - Property 'push' does not exist on type 'readonly []'.
        $c499ec49965fe6fe$var$history.unique.push(historyItem);
    }, []);
    return (0, $5uXOq.useMemo)(()=>({
            history: $c499ec49965fe6fe$var$history,
            addNew: addNew
        }), [
        addNew
    ]);
};
const $c499ec49965fe6fe$export$ef04cd58bebb0345 = ()=>{
    // @ts-expect-error TS2540: Cannot assign to 'length' because it is a read-only property.
    $c499ec49965fe6fe$var$history.unique.length = 0;
};

});

parcelRegister("hrlU6", function(module, exports) {

$parcel$export(module.exports, "withConnectHost", () => $9316db67541b8a94$export$970e2411dd8601c8);
$parcel$export(module.exports, "getConnectHost", () => $9316db67541b8a94$export$186d423c00af146c);
$parcel$export(module.exports, "isConnectDialogWebItem", () => $9316db67541b8a94$export$920fb4b46d4f2eec);

var $dJZWD = parcelRequire("dJZWD");
const $9316db67541b8a94$export$970e2411dd8601c8 = async (action)=>{
    const connectHost = await (0, $dJZWD.setupConnectJs)();
    action(connectHost);
};
const $9316db67541b8a94$export$186d423c00af146c = ()=>window.connectHost;
const $9316db67541b8a94$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');

});
parcelRegister("dJZWD", function(module, exports) {

$parcel$export(module.exports, "setupConnectJs", () => $762ba9fa524ea8e6$export$891414b605e5f038);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
var $cQZXC = parcelRequire("cQZXC");

var $dH9DT = parcelRequire("dH9DT");

const $762ba9fa524ea8e6$var$installConnectJs = async ()=>{
    // we need the heritage to load in order for WRM core and jQuery to exist.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $cQZXC.waitForHeritage)();
    await (0, $dH9DT.waitForJQuery)();
    const loader = await (parcelRequire("3hUjN"));
    await loader.performSideEffects();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};
let $762ba9fa524ea8e6$var$installConnectJsPromise = null;
const $762ba9fa524ea8e6$export$891414b605e5f038 = async ()=>{
    // Only pages in the SPA will benefit from modernising connect
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__SPA__) {
        if ($762ba9fa524ea8e6$var$installConnectJsPromise === null) $762ba9fa524ea8e6$var$installConnectJsPromise = $762ba9fa524ea8e6$var$installConnectJs();
        return $762ba9fa524ea8e6$var$installConnectJsPromise;
    }
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $6BZYo.loadBridge)({
        name: 'ac/create',
        wrmKeys: [
            'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
            // Undeclared Dependency: jira/navigation
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
        ]
    });
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};

});
parcelRegister("6BZYo", function(module, exports) {

$parcel$export(module.exports, "loadBridge", () => $ce95ee3fd66207c7$export$df8409da353bde5a);

var $fqWWz = parcelRequire("fqWWz");
var $3GASE = parcelRequire("3GASE");
var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");

var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");
var $8JNtu = parcelRequire("8JNtu");
var $5Ik5Y = parcelRequire("5Ik5Y");
const $ce95ee3fd66207c7$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $fqWWz.MAX_RETRIES), timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $7T84i.loadBridgeStrict)({
        name: name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $3GASE.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $ig88W.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});
parcelRegister("fqWWz", function(module, exports) {

$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $71bf66166926d1dc$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $71bf66166926d1dc$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $71bf66166926d1dc$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $71bf66166926d1dc$export$37f20f0ff732fcd7);

var $dJl1T = parcelRequire("dJl1T");
const { safeErrorWithoutCustomerData: $71bf66166926d1dc$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $71bf66166926d1dc$export$ea810ce67e3c8eac } = (0, $dJl1T.default);
const $71bf66166926d1dc$export$1f86472c1374185a = 40;
const $71bf66166926d1dc$export$7bd623b29ec8e1eb = 500;
const $71bf66166926d1dc$export$37f20f0ff732fcd7 = true;

});

parcelRegister("3GASE", function(module, exports) {

$parcel$export(module.exports, "loadBridgeBail", () => $e512b6cc4a8702e5$export$a036f92c2465504e);

var $wRU6t = parcelRequire("wRU6t");

var $fqWWz = parcelRequire("fqWWz");
const $e512b6cc4a8702e5$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $wRU6t.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("wRU6t", function(module, exports) {

$parcel$export(module.exports, "safeStringify", () => $7e2bd894031d4476$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7e2bd894031d4476$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});


parcelRegister("ig88W", function(module, exports) {

$parcel$export(module.exports, "loadBridgeRace", () => $64f1dbae1ea314ee$export$20c32b4579d78b92);

var $3GASE = parcelRequire("3GASE");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $64f1dbae1ea314ee$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $9B86Q.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $3GASE.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});
parcelRegister("9B86Q", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $61b2a5aa3a2a1160$export$3cefda82396756a1);

var $ifVVd = parcelRequire("ifVVd");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $61b2a5aa3a2a1160$var$pollingSingleton = null;
const $61b2a5aa3a2a1160$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $61b2a5aa3a2a1160$var$pollingSingleton ?? (0, $ifVVd.createPollingCollection)((v)=>window.require(v), 100);
    $61b2a5aa3a2a1160$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("ifVVd", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $60e6b0d4bc46beac$export$f163446a982a8077);

var $gKZoD = parcelRequire("gKZoD");

var $aePFs = parcelRequire("aePFs");
const $60e6b0d4bc46beac$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $gKZoD.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $aePFs.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $aePFs.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("aePFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f3c6551bf5b1ff$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $02f3c6551bf5b1ff$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});




parcelRegister("7T84i", function(module, exports) {

$parcel$export(module.exports, "loadBridgeStrict", () => $89a95eb8b151782d$export$eba600d28decc4ac);

var $c56lL = parcelRequire("c56lL");

var $ig88W = parcelRequire("ig88W");

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $89a95eb8b151782d$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    (0, $c56lL.saveStats)(name, wrmKeys);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $fVOHM.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $ig88W.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("c56lL", function(module, exports) {

$parcel$export(module.exports, "saveStats", () => $6c875a5034ae8433$export$9ea3ff7978093559);
const $6c875a5034ae8433$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // eslint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // eslint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $6c875a5034ae8433$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $6c875a5034ae8433$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $6c875a5034ae8433$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $6c875a5034ae8433$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6c875a5034ae8433$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $6c875a5034ae8433$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $6c875a5034ae8433$var$initStats();
        // stop accumulating stats at TTI mark
        if ($6c875a5034ae8433$var$isPageInteractive()) return;
        stats.requests += 1;
        $6c875a5034ae8433$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$6c875a5034ae8433$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $6c875a5034ae8433$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("fVOHM", function(module, exports) {

$parcel$export(module.exports, "loadWrmResources", () => $0c0552c7bb135144$export$6cda16b6eff75f59);

var $wRU6t = parcelRequire("wRU6t");

var $294PS = parcelRequire("294PS");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $0c0552c7bb135144$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $9B86Q.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $294PS.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("294PS", function(module, exports) {

$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $a437264dd6b89021$export$93d9db5fbabad1b0);

var $1r4rO = parcelRequire("1r4rO");
let $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = false;
const $a437264dd6b89021$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $a437264dd6b89021$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($a437264dd6b89021$var$isSuperBatchDependenciesLoaded || $a437264dd6b89021$var$isOnRapidBoardsPage()) return wrmKeys;
    $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = true;
    return (0, $1r4rO.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("1r4rO", function(module, exports) {

$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $e87d6a02e2466ae8$export$f14a6b583ce9e077);
const $e87d6a02e2466ae8$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});




parcelRegister("cQZXC", function(module, exports) {

$parcel$export(module.exports, "waitForHeritage", () => $90def0f7a7aa11d6$export$c61060338d026f78);

var $7aBP4 = parcelRequire("7aBP4");

var $aePFs = parcelRequire("aePFs");
const $90def0f7a7aa11d6$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.__WAIT_FOR_HERITAGE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WAIT_FOR_HERITAGE__ = new (0, $aePFs.default)();
        (0, $7aBP4.bootstrapWrmClient)().then(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__WAIT_FOR_HERITAGE__.resolve();
        });
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WAIT_FOR_HERITAGE__;
};

});
parcelRegister("7aBP4", function(module, exports) {

$parcel$export(module.exports, "bootstrapWrmClient", () => $f93199c7ae9c59d8$export$d001f71dd306cb0c);

var $7f4tk = parcelRequire("7f4tk");
const $f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
const $f93199c7ae9c59d8$var$fetchSpaWrmContext = async ()=>{
    return (0, $7f4tk.default)($f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT);
};
const $f93199c7ae9c59d8$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
    let element;
    if (resourceType === 'JAVASCRIPT') {
        element = globalThis.document?.createElement('script');
        element.setAttribute('crossorigin', '');
        element.setAttribute('src', url);
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    } else {
        element = globalThis.document?.createElement('link');
        element.setAttribute('crossorigin', '');
        element.setAttribute('href', url);
        element.setAttribute('rel', 'stylesheet');
        element.setAttribute('media', 'all');
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    }
    return element;
};
let $f93199c7ae9c59d8$var$hasWrmInitialised;
const $f93199c7ae9c59d8$var$runBootstrap = ()=>{
    const spaWrmContext = $f93199c7ae9c59d8$var$fetchSpaWrmContext();
    return new Promise((resolve)=>{
        spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
            // eslint-disable-next-line no-multi-assign
            const WRM = globalThis.WRM = globalThis.WRM || {};
            WRM._unparsedData = data;
            WRM._unparsedErrors = errors;
            if (WRM._dataArrived) WRM._dataArrived();
            resources.map($f93199c7ae9c59d8$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
            resolve();
        });
    });
};
const $f93199c7ae9c59d8$export$d001f71dd306cb0c = ()=>{
    if (false) return Promise.resolve();
    if ($f93199c7ae9c59d8$var$hasWrmInitialised) return $f93199c7ae9c59d8$var$hasWrmInitialised;
    // todo maybe a more robust check to validate whether WRM initialisation already underway?
    if (typeof globalThis.WRM !== 'undefined') $f93199c7ae9c59d8$var$hasWrmInitialised = Promise.resolve();
    else $f93199c7ae9c59d8$var$hasWrmInitialised = $f93199c7ae9c59d8$var$runBootstrap();
    return $f93199c7ae9c59d8$var$hasWrmInitialised;
};

});


parcelRegister("8JNtu", function(module, exports) {

$parcel$export(module.exports, "wrmRequire", () => $17e2d7d864398bad$export$cc9d8f51375ef66a);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $17e2d7d864398bad$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});

parcelRegister("5Ik5Y", function(module, exports) {

$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $a1df1daee76d40f7$export$e53a5db19a39ed2f);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $a1df1daee76d40f7$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});


parcelRegister("dH9DT", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $a78c52ec7ed5d025$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getJQuery", () => $a78c52ec7ed5d025$export$7232a6dc780f9887);
$parcel$export(module.exports, "getGlobalAP", () => $a78c52ec7ed5d025$export$fbc82125a6bd8012);
$parcel$export(module.exports, "isObject", () => $a78c52ec7ed5d025$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "escapeSelector", () => $a78c52ec7ed5d025$export$c8c0ea01c118c2eb);
$parcel$export(module.exports, "waitForJQuery", () => $a78c52ec7ed5d025$export$97214de9c546981c);
$parcel$export(module.exports, "ErrorDebugAddonKeys", () => $a78c52ec7ed5d025$export$d690da9bc8146677);

var $jcw0u = parcelRequire("jcw0u");

const $a78c52ec7ed5d025$export$c47913ca32a5c6f7 = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
    return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
};
const $a78c52ec7ed5d025$export$7232a6dc780f9887 = ()=>AJS.$;
const $a78c52ec7ed5d025$export$fbc82125a6bd8012 = ()=>// In the future, we can add analytics events to know how this can fail to access the global variable.
    // We can improve it to load WRM in async
    // Just to add some context for future reviewers: `window._AP` is the actual Connect module that will no longer be loaded via WRM.
    // Its properties are both appended from modules like the dialog options and the public atlassian-connect-js library.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window._AP;
const $a78c52ec7ed5d025$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
const $a78c52ec7ed5d025$export$c8c0ea01c118c2eb = (s)=>{
    if (!s) throw new Error('No selector to escape');
    return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
};
const $a78c52ec7ed5d025$var$FIVE_MINUTES = 300000;
const $a78c52ec7ed5d025$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
        const interval = setInterval(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.AJS?.$) {
                clearInterval(interval);
                resolve();
            }
        }, 10);
        setTimeout(()=>{
            clearInterval(interval);
            (0, $jcw0u.default)({
                meta: {
                    id: 'connect-jquery-timeout',
                    packageName: 'jiraConnect'
                },
                error: new Error('Timeout when waiting for jQuery to be available on the page'),
                // this is an extremely common error, so we don't want to spam Sentry with it
                skipSentry: true
            });
            reject();
        }, $a78c52ec7ed5d025$var$FIVE_MINUTES);
    });
const $a78c52ec7ed5d025$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
const $a78c52ec7ed5d025$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
const $a78c52ec7ed5d025$export$d690da9bc8146677 = [
    $a78c52ec7ed5d025$export$cb954c21735b28e4,
    $a78c52ec7ed5d025$export$7315c38dc71bd41f
];

});

parcelRegister("3hUjN", function(module, exports) {

let $264ea540dc548cff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $264ea540dc548cff$var$load("aVR4N").then(()=>parcelRequire('8vJyT'));

});



parcelRegister("eYDk7", function(module, exports) {

$parcel$export(module.exports, "NavigationHeaderWrapper", () => $eea5dc8ebf00d36e$export$bae9b35e967353d5);
$parcel$export(module.exports, "NavigationExpandableContentWrapper", () => $eea5dc8ebf00d36e$export$4e88508e6904469e);
$parcel$export(module.exports, "NavigationContentWrapper", () => $eea5dc8ebf00d36e$export$e7d691a5a9258e1b);
$parcel$export(module.exports, "NextGenIssueTypesWrapper", () => $eea5dc8ebf00d36e$export$f094f7aad76e4268);
$parcel$export(module.exports, "ExpandableProjectSettingsWrapper", () => $eea5dc8ebf00d36e$export$e38bb288d890ec2f);
$parcel$export(module.exports, "ShortCutsAndAppsWrapper", () => $eea5dc8ebf00d36e$export$337add4342ee7986);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");
const $eea5dc8ebf00d36e$export$bae9b35e967353d5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer, null, props.children);
const $eea5dc8ebf00d36e$export$4e88508e6904469e = (props)=>{
    const { nestedAppOpen: nestedAppOpen, submenuActive: submenuActive, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer, {
        nestedAppOpen: nestedAppOpen,
        submenuActive: submenuActive
    }, children);
};
const $eea5dc8ebf00d36e$export$e7d691a5a9258e1b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationContentWrapperContainer, {
        submenuActive: props.submenuActive,
        nestedMenuOpen: props.nestedMenuOpen,
        "data-component-selector": "NavigationContentWrapperContainer"
    }, props.children);
const $eea5dc8ebf00d36e$export$f094f7aad76e4268 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer, null, props.children);
const $eea5dc8ebf00d36e$export$e38bb288d890ec2f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ExpandableProjectContainer, null, props.children);
const $eea5dc8ebf00d36e$export$337add4342ee7986 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer, null, props.children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _1s541012 _1lfu1012",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedAppOpen: nestedAppOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ykp9lh": (0, $lD23V.default)(__cmplp.nestedAppOpen ? 'auto' : '100%'),
            "--_1qrlsbv": (0, $lD23V.default)(Math.round((0, $gwIPs.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _1q1o54a6 _1dul54a6 _ofxb54a6 _179m54a6 _vnu9l52n _19iyl52n _t6kll52n _shi3l52n _15sk1v6z _178k1v6z _18pc1v6z _1bc71v6z _yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive && "_4t3i1qw7",
            __cmplp.submenuActive ? "_bq2uyjp0 _1n80yjp0 _di7gyjp0 _1lozyjp0" : "_bq2u1d7o _1n801d7o _di7g1d7o _1loz1d7o",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NavigationContentWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedMenuOpen: nestedMenuOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6w8gix": (0, $lD23V.default)(__cmplp.nestedMenuOpen ? 0 : 7.5 * (0, $gwIPs.gridSize), "px"),
            "--_1qrlsbv": (0, $lD23V.default)(Math.round((0, $gwIPs.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive ? "_4t3iu4z3" : "_4t3i1wug",
            __cmplp.submenuActive ? "_vnu91tcg _19iy1tcg _t6kl1tcg _shi31tcg" : "_vnu9l52n _19iyl52n _t6kll52n _shi3l52n",
            __cmplp.nestedMenuOpen && "_1reo1wug _18m91wug _14tk183y",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _vpnr1ejb _14tk72c6 _cb62utpp _1wtp1txs _l9o61txs _f6zi1txs",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$ExpandableProjectContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3i1osq _1wtppxbi _df5vpxbi",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _14tk72c6 _t3zc183y _1so41gjq _1thc1skh _a6avqslr _dnyv1skh",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gwIPs", function(module, exports) {

$parcel$export(module.exports, "gridSize", () => $80d528dbc2b11cbc$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "borderRadius", () => $80d528dbc2b11cbc$export$7a57f79000377ca2);
$parcel$export(module.exports, "contentHorizontalSpacing", () => $80d528dbc2b11cbc$export$22dec01f2c854397);
$parcel$export(module.exports, "layers", () => $80d528dbc2b11cbc$export$7be255094ccdc533);

var $b4a3S = parcelRequire("b4a3S");
const $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 = 8;
const $80d528dbc2b11cbc$export$7a57f79000377ca2 = (0, $b4a3S.borderRadius)();
const $80d528dbc2b11cbc$export$22dec01f2c854397 = 40;
const $80d528dbc2b11cbc$export$dab5ea164c6f81a = 100;
const $80d528dbc2b11cbc$export$7be255094ccdc533 = {
    banner: (0, $b4a3S.layers).navigation(),
    card: (0, $b4a3S.layers).card(),
    dialog: (0, $b4a3S.layers).dialog(),
    navigation: (0, $b4a3S.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $b4a3S.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $b4a3S.layers).navigation() - 1,
    layer: (0, $b4a3S.layers).layer(),
    blanket: (0, $b4a3S.layers).blanket(),
    modal: (0, $b4a3S.layers).modal(),
    flag: (0, $b4a3S.layers).flag(),
    spotlight: (0, $b4a3S.layers).spotlight(),
    tooltip: (0, $b4a3S.layers).tooltip(),
    mobileBanner: $80d528dbc2b11cbc$export$dab5ea164c6f81a
};
const $80d528dbc2b11cbc$export$b3219800bda33a1f = {
    issueIconSize: 16
};

});


parcelRegister("kZj7F", function(module, exports) {

$parcel$export(module.exports, "NestingMenuItem", () => $2fbfde7c900477f4$export$4c594f24f8e4128a);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $1UikQ = parcelRequire("1UikQ");

var $3xWPD = parcelRequire("3xWPD");

var $65Cwx = parcelRequire("65Cwx");

var $5Hj3V = parcelRequire("5Hj3V");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $hg4VT = parcelRequire("hg4VT");

var $kZ5sr = parcelRequire("kZ5sr");

var $fpoBX = parcelRequire("fpoBX");

var $ai0LF = parcelRequire("ai0LF");

var $kavsL = parcelRequire("kavsL");
const $2fbfde7c900477f4$var$customCssFn = (0, $ai0LF.castRealCSSFnToWronglyTypedCSSFn)((currentStateAndStyles)=>{
    const activeColor = typeof currentStateAndStyles['&:active'] === 'object' ? `${currentStateAndStyles['&:active'].color} !important` : 'inherit';
    const baseColor = typeof currentStateAndStyles['&:hover'] === 'object' ? currentStateAndStyles['&:hover'].color : 'inherit';
    const newStyle = {
        ...(0, $kZ5sr.cssFn)(currentStateAndStyles),
        /* fixes CSS leaking from the monolith */ '&:visited, &:focus, &:active': {
            textDecoration: 'inherit',
            outline: 0
        },
        /* fixes CSS leaking from the monolith */ '&:active': {
            color: activeColor
        },
        /* fixes CSS leaking from the monolith */ '&:visited, &:focus': {
            color: baseColor
        },
        '& [data-item-title]': {
            color: baseColor
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(currentStateAndStyles, newStyle);
});
const $2fbfde7c900477f4$var$WrappingLinkComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", props, props.children);
const $2fbfde7c900477f4$export$4c594f24f8e4128a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, reloadOnNavigationToNesting: reloadOnNavigationToNesting, overrides: overrides = {}, title: title, ...rest }, ref)=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const backButtonCssFn = (0, $hg4VT.generateBackButtonCssFn)(theme);
    const { BackMenuItem: BackMenuItem = {} } = overrides;
    const { title: backTitle = 'Back', wrapper: WrapperComponent = (0, $5uXOq.Fragment), ...backItemProps } = BackMenuItem; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    const renderBackItem = (0, $5uXOq.useCallback)(({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            ...backItemProps,
            analytics: {
                itemId: 'back'
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3xWPD))), {
                spacing: "spacious",
                label: ""
            }),
            onClick: (ev)=>{
                if ((0, $kavsL.isNormalClick)(ev)) {
                    onClick();
                    backItemProps.onClick?.(ev);
                }
            },
            cssFn: backButtonCssFn
        }, backTitle)), [
        WrapperComponent,
        backItemProps,
        backButtonCssFn,
        backTitle
    ]);
    const renderCustomItem = (0, $5uXOq.useCallback)(({ children: itemTitle, onClick: onClick, cssFn: customItemCssFn, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $65Cwx.default), {
            ...props,
            id: id,
            component: reloadOnNavigationToNesting ? $2fbfde7c900477f4$var$WrappingLinkComponent : props.component,
            onClick: (ev)=>{
                // if nesting item already selected do not trigger route change
                if (props.isSelected === true) ev.preventDefault();
                onClick && onClick(ev);
            },
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            overrides: {
                GoBackItem: {
                    render: renderBackItem
                }
            },
            title: itemTitle,
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            cssFn: customItemCssFn ? (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))([
                customItemCssFn,
                $2fbfde7c900477f4$var$customCssFn
            ]) : $2fbfde7c900477f4$var$customCssFn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Hj3V.SidebarErrorBoundary), {
            id: `${id}Nesting`,
            packageName: "jiraSpaAppsSidebarCommon"
        }, children)), [
        children,
        id,
        reloadOnNavigationToNesting,
        renderBackItem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        ...rest,
        ref: ref,
        overrides: {
            CustomItem: {
                render: renderCustomItem
            }
        }
    }, title);
});

});
parcelRegister("hg4VT", function(module, exports) {

$parcel$export(module.exports, "generateBackButtonCssFn", () => $1e5fb9a53caeb1aa$export$56644251c3f2ea82);
const $1e5fb9a53caeb1aa$export$56644251c3f2ea82 = (theme)=>()=>{
        if (theme?.navigation) {
            const { icon: icon } = theme.navigation;
            return {
                '& [data-item-elem-before], &:active span[data-item-elem-before]': {
                    color: icon?.secondary?.color?.active ?? undefined
                }
            };
        }
        return {};
    };

});

parcelRegister("kZ5sr", function(module, exports) {

$parcel$export(module.exports, "cssFn", () => $399c9dca906145c0$export$d722961e96b459c5);

var $1UikQ = parcelRequire("1UikQ");

var $gwIPs = parcelRequire("gwIPs");

var $ai0LF = parcelRequire("ai0LF");
const $399c9dca906145c0$export$d722961e96b459c5 = (0, $ai0LF.castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
    const newStyle = {
        '[data-item-elem-after] [data-right-arrow]': {
            display: 'none'
        },
        '&:hover [data-item-elem-after]': {
            '& > :not([data-right-arrow])': {
                display: 'none'
            },
            '& [data-right-arrow]': {
                display: 'flex'
            }
        },
        height: `${(0, $gwIPs.gridSize) * 5.5}px`
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(currentStyles, newStyle);
});

});
parcelRegister("ai0LF", function(module, exports) {

$parcel$export(module.exports, "castRealCSSFnToWronglyTypedCSSFn", () => $2bb346e8dcf8bbae$export$3f662b014fa1806e);
function $2bb346e8dcf8bbae$export$3f662b014fa1806e(fn) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    return fn;
}
function $2bb346e8dcf8bbae$export$17f32e2573d62daa(fn) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    return fn;
}

});


parcelRegister("kavsL", function(module, exports) {

$parcel$export(module.exports, "isNormalClick", () => $e059487e30c8155a$export$729f3684d5c2b9b9);
const $e059487e30c8155a$export$729f3684d5c2b9b9 = (e)=>!('button' in e && e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);

});




parcelRegister("eaZ4X", function(module, exports) {

$parcel$export(module.exports, "SECTION_ID", () => $b36275c07d465a0e$export$501955bd67991a25);
const $b36275c07d465a0e$export$501955bd67991a25 = {
    MIGRATE_TO_CLOUD_SITE: 'migrate-to-cloud-site',
    PERFORMANCE_AND_SCALE: 'performance-and-scale'
};

});

parcelRegister("jMBA3", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $4023bf6b28a8dc58$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", () => $4023bf6b28a8dc58$export$f601efaceb0636f4);

var $5uXOq = parcelRequire("5uXOq");

var $aUDLa = parcelRequire("aUDLa");

var $7OqB4 = parcelRequire("7OqB4");

var $awp39 = parcelRequire("awp39");

var $9OXo1 = parcelRequire("9OXo1");

var $gJkov = parcelRequire("gJkov");
const $4023bf6b28a8dc58$export$4a39035bacc4ed76 = (0, $7OqB4.withThrowOnError)(()=>{
    const { data: data, loading: loading, error: error } = (0, $aUDLa.useNavigationGlobalResource)();
    const { isDevMode: isDevMode, isAdmin: isAdmin } = (0, $9OXo1.useTenantContext)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $gJkov.extractData)(data, isDevMode, isAdmin), [
        data,
        isDevMode,
        isAdmin
    ]);
    return {
        data: extractedData,
        loading: loading,
        error: error
    };
});
const $4023bf6b28a8dc58$export$f601efaceb0636f4 = (0, $7OqB4.withThrowOnError)((0, $awp39.useGlobalSettingsSystemConnectItems));

});
parcelRegister("aUDLa", function(module, exports) {

$parcel$export(module.exports, "useNavigationGlobalResource", () => $dbad5a19b82e4911$export$1e1c317ed5b99faa);

var $5uXOq = parcelRequire("5uXOq");

var $atU1t = parcelRequire("atU1t");

var $2YP9W = parcelRequire("2YP9W");
const $dbad5a19b82e4911$export$1e1c317ed5b99faa = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $atU1t.navigationSidebarGlobalResource));
    const response = (0, $5uXOq.useMemo)(()=>data && data.response, [
        data
    ]);
    return {
        data: response,
        loading: loading,
        error: error
    };
};

});

parcelRegister("7OqB4", function(module, exports) {

$parcel$export(module.exports, "withThrowOnError", () => $f0eadb98e9fdd0d1$export$a018832f2ec4dc91);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $gKZoD = parcelRequire("gKZoD");
const $f0eadb98e9fdd0d1$var$isDataEmpty = (data)=>data == null;
function $f0eadb98e9fdd0d1$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        // tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
        (0, $gKZoD.di)(theHook);
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $f0eadb98e9fdd0d1$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});

parcelRegister("awp39", function(module, exports) {

$parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", () => $6ac80db07eab2a1e$export$f601efaceb0636f4);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $aUDLa = parcelRequire("aUDLa");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $4gymV = parcelRequire("4gymV");

var $5W6pd = parcelRequire("5W6pd");
// use memoised functions per hook to avoid re-computation between same hooks
const $6ac80db07eab2a1e$var$getItemsMemo = (0, $8QpSo.default)((d)=>(0, $4gymV.getLinks)(d, [
        'admin_system_menu'
    ], {
        skipFilter: true
    }).map((0, $5W6pd.transformLink)).filter(Boolean));
const $6ac80db07eab2a1e$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $6ac80db07eab2a1e$export$f601efaceb0636f4 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $aUDLa.useNavigationGlobalResource)();
    const items = (0, $5uXOq.useMemo)(()=>data && $6ac80db07eab2a1e$var$getItemsMemo(data), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $6ac80db07eab2a1e$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});
parcelRegister("7tsV0", function(module, exports) {

$parcel$export(module.exports, "findItemAndStack", () => $93fa8c16baad19b1$export$751e2e6237002565);

var $ajpes = parcelRequire("ajpes");

var $k0iPT = parcelRequire("k0iPT");
// JSPA-1062 remove qs items that might not always be there
const $93fa8c16baad19b1$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $93fa8c16baad19b1$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $93fa8c16baad19b1$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
    let found = null;
    if (!(0, $k0iPT.CONNECT_ROUTES_SET).has(routeName)) return found;
    const locationQuery = $93fa8c16baad19b1$var$splitRelevantQs(location.search);
    items.some((item)=>{
        const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
        const itemQuery = $93fa8c16baad19b1$var$splitRelevantQs(itemQs);
        const sameQuery = $93fa8c16baad19b1$var$isSameQuery(locationQuery, itemQuery);
        if (item.section !== true && itemPath === location.pathname && sameQuery) {
            found = {
                stack: parentStack,
                selected: item
            };
            return true;
        }
        if (item.items) {
            const stack = item.section === true ? parentStack : parentStack.concat(item.id);
            found = $93fa8c16baad19b1$export$751e2e6237002565(item.items, routeName, location, stack);
        }
        return Boolean(found);
    });
    return found;
};

});
parcelRegister("k0iPT", function(module, exports) {

$parcel$export(module.exports, "JWM_OVERVIEWS_ROUTE_SET", () => $c82776b15970ab04$export$a8aac2ba4dc1f57);
$parcel$export(module.exports, "CONNECT_ROUTES_SET", () => $c82776b15970ab04$export$c47bf667d3008c53);
$parcel$export(module.exports, "JSM_BOARD_ROUTES_SET", () => $c82776b15970ab04$export$50c2d6bcb0b94b74);
const $c82776b15970ab04$export$a8aac2ba4dc1f57 = new Set([
    'classic-business-overview-summary',
    'classic-business-overview-calendar',
    'classic-business-overview-timeline',
    'classic-business-overview-redirect'
]);
const $c82776b15970ab04$export$c47bf667d3008c53 = new Set([
    'connect-project',
    'connect-general',
    'connect-general-service-desk-project',
    'legacy-connect-project',
    'legacy-connect-general'
]);
const $c82776b15970ab04$export$50c2d6bcb0b94b74 = new Set([
    'servicedesk-boards',
    'servicedesk-queues-views-config',
    'servicedesk-practice-views-config'
]);

});


parcelRegister("4gymV", function(module, exports) {

$parcel$export(module.exports, "getLinks", () => $6dc7ee8ba2a1371f$export$8054dcb2b42da45c);

var $83mn0 = parcelRequire("83mn0");

var $7NH5Y = parcelRequire("7NH5Y");
const $6dc7ee8ba2a1371f$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
    const acc = [];
    locations.forEach((location)=>{
        const links = (0, $83mn0.getLinksFromSidebar)(sidebarConfig, location);
        if (omitSections === true) {
            // merge 2 arrays in good performance way
            Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
            return;
        }
        // merge 2 arrays in good performance way
        Array.prototype.push.apply(acc, links);
    });
    return acc.filter((item)=>{
        if (!item) return false;
        if (skipFilter === true) return true;
        const hasConnectPrefix = item.id && item.id.includes((0, $7NH5Y.connectPrefix));
        if (hasConnectPrefix) return true;
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"sd-reports-addons" | "sd-queues-addons" | "com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent"'.
        const isConnectSection = (0, $7NH5Y.connectSections).includes(item.id);
        if (isConnectSection) return true;
        const isJsdConnectSection = item.id && item.id.includes((0, $7NH5Y.jsdConnectPrefix));
        if (isJsdConnectSection) return true;
        return false;
    });
};

});
parcelRegister("83mn0", function(module, exports) {

$parcel$export(module.exports, "hasItemInSidebar", () => $90215f5482fce08d$export$57dd40eec4c64521);
$parcel$export(module.exports, "getLinksFromSidebar", () => $90215f5482fce08d$export$9b7e0e4dd8bfade8);
const $90215f5482fce08d$var$findLink = (arrayOfLinks, legacyId, partialMatch = false)=>{
    if (!Array.isArray(arrayOfLinks)) return undefined;
    for(let i = 0; i < arrayOfLinks.length; i += 1){
        const link = arrayOfLinks[i];
        if (partialMatch && link.id.indexOf(legacyId) === 0) return link;
        if (link.id === legacyId) return link;
        if (link.links) {
            const linkFound = $90215f5482fce08d$var$findLink(link.links, legacyId, partialMatch);
            if (linkFound) return linkFound;
        }
    }
    return undefined;
};
const $90215f5482fce08d$export$f62346e9b1894488 = (sidebarConfig, legacyId, partialMatch = false)=>sidebarConfig && sidebarConfig.product && $90215f5482fce08d$var$findLink(sidebarConfig.product.links, legacyId, partialMatch) || undefined;
const $90215f5482fce08d$export$57dd40eec4c64521 = (sidebarConfig, legacyId, partialMatch)=>Boolean($90215f5482fce08d$export$f62346e9b1894488(sidebarConfig, legacyId, partialMatch));
const $90215f5482fce08d$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
        if (item.id === legacyId) return item.links;
        return item.links && $90215f5482fce08d$var$findChildLinks(item.links, legacyId);
    }).find(Boolean);
const $90215f5482fce08d$export$9b7e0e4dd8bfade8 = (sidebarConfig, legacyId)=>{
    const links = legacyId != null ? $90215f5482fce08d$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
    return links || [];
};

});

parcelRegister("7NH5Y", function(module, exports) {

$parcel$export(module.exports, "connectPrefix", () => $a36a125359bfc961$export$196d83ebd873fb40);
$parcel$export(module.exports, "jsdConnectPrefix", () => $a36a125359bfc961$export$7fac8f726f52d70);
$parcel$export(module.exports, "connectSections", () => $a36a125359bfc961$export$b1c2c1fc5d10280);

var $kvHKs = parcelRequire("kvHKs");
const $a36a125359bfc961$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
const $a36a125359bfc961$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
const $a36a125359bfc961$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
const $a36a125359bfc961$var$jsdQueuesConnectSection = 'sd-queues-addons';
const $a36a125359bfc961$export$b1c2c1fc5d10280 = [
    $a36a125359bfc961$var$legacyAddonPanelLinkId,
    (0, $kvHKs.REPORTS_IDS).REPORTS_ADDONS,
    $a36a125359bfc961$var$jsdQueuesConnectSection
];

});


parcelRegister("5W6pd", function(module, exports) {

$parcel$export(module.exports, "transformLink", () => $1efacbf40a7b73c8$export$5a32dc366b1d641f);
$parcel$export(module.exports, "transformLinkV4", () => $1efacbf40a7b73c8$export$27267b6b6650eaa5);
const $1efacbf40a7b73c8$export$5a32dc366b1d641f = (link)=>{
    const items = link.links && link.links.length ? link.links.map($1efacbf40a7b73c8$export$5a32dc366b1d641f).filter(Boolean) : undefined;
    // section item
    if (link.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(link.name)
        };
        return {
            id: link.id,
            name: String(link.name),
            section: !!link.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: link.id,
        name: String(link.name),
        url: link.url,
        iconUrl: link.iconUrl || '',
        styleClass: link.styleClass || '',
        items: items
    };
};
const $1efacbf40a7b73c8$export$27267b6b6650eaa5 = (data)=>{
    const items = data.links && data.links.length ? data.links.map($1efacbf40a7b73c8$export$27267b6b6650eaa5).filter(Boolean) : undefined;
    // section item
    if (data.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(data.name)
        };
        return {
            id: data.id,
            name: String(data.name),
            section: !!data.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: data.id,
        name: String(data.name),
        url: data.url,
        iconUrl: data.iconUrl || '',
        styleClass: data.styleClass || '',
        items: items
    };
};

});


parcelRegister("gJkov", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $63e1d07edc3ef769$export$9df5fa0a366163d2);

var $83mn0 = parcelRequire("83mn0");
const $63e1d07edc3ef769$export$9df5fa0a366163d2 = (data, isDevMode, isAdmin)=>({
        hasGeneralConfiguration: isAdmin,
        hasDarkFeatures: (0, $83mn0.hasItemInSidebar)(data, 'dark_features'),
        hasTroubleshootingAndSupportSection: isAdmin,
        hasViewAuditing: isAdmin,
        hasPluginViewer: isDevMode && isAdmin,
        hasModulesViewer: isDevMode && isAdmin,
        hasSystemInfo: (0, $83mn0.hasItemInSidebar)(data, 'system_info'),
        hasIntegrityChecker: (0, $83mn0.hasItemInSidebar)(data, 'integrity_checker'),
        hasLoggingProfiling: (0, $83mn0.hasItemInSidebar)(data, 'logging_profiling'),
        hasSchedulerDetails: (0, $83mn0.hasItemInSidebar)(data, 'scheduler_details'),
        hasSecuritySection: isAdmin,
        hasProjectRoles: isAdmin,
        hasGlobalPermissions: isAdmin,
        hasCollectors: isAdmin,
        hasUserInterfaceSection: isAdmin,
        hasUserDefaults: isAdmin,
        hasEditDefaultDashboard: isAdmin,
        hasLookAndFeel: isAdmin,
        hasPasAdmin: (0, $83mn0.hasItemInSidebar)(data, 'com.atlassian.pas:pas-admin-link-jira'),
        hasImportExportSection: isAdmin,
        hasBackupManager: isAdmin,
        hasExternalImport: isAdmin,
        hasRestoreSystem: (0, $83mn0.hasItemInSidebar)(data, 'vertigo_import'),
        hasCloudImport: (0, $83mn0.hasItemInSidebar)(data, 'vertigo_import_jira_cloud'),
        hasServerImport: (0, $83mn0.hasItemInSidebar)(data, 'vertigo_import_jira_server'),
        hasMailSection: isAdmin,
        hasGlobalMailSettings: isAdmin,
        hasOutgoingMail: isAdmin,
        hasIncomingMail: isAdmin,
        hasSendMail: isAdmin,
        hasAdminHelperSection: isAdmin,
        hasPermissionHelper: isAdmin,
        hasSharedSection: isAdmin,
        hasManageDashboards: isAdmin,
        hasManageFilters: isAdmin,
        // advanced
        hasAdvancedSection: isAdmin,
        hasAttachments: isAdmin,
        hasEvents: isAdmin,
        hasWebHooks: isAdmin,
        hasServices: isAdmin,
        hasLexoRankManagement: (0, $83mn0.hasItemInSidebar)(data, 'greenhopper-lexorank-manage')
    });

});


parcelRegister("aVTmi", function(module, exports) {

$parcel$export(module.exports, "AdminHelperSection", () => $f6a1ba8c0486741e$export$4855b2d78f0d666a);

var $5uXOq = parcelRequire("5uXOq");

var $6puUq = parcelRequire("6puUq");

var $Pxnvj = parcelRequire("Pxnvj");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $kxnYb = parcelRequire("kxnYb");
var $9K9UK = parcelRequire("9K9UK");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $jMBA3 = parcelRequire("jMBA3");

var $3B8mV = parcelRequire("3B8mV");
const $f6a1ba8c0486741e$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY = 'blocking-invitations-log-spotlight';
const $f6a1ba8c0486741e$export$4855b2d78f0d666a = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        title: formatMessage((0, $3B8mV.default).adminHelper)
    }, features.hasPermissionHelper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'permission-helper'
        },
        href: navigationPath.adminHelperPermissionHelper,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $3B8mV.default).permissionHelper)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
        name: $f6a1ba8c0486741e$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'email-notifications-log'
        },
        href: navigationPath.adminHelperEmailNotificationsLogHelper,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $f6a1ba8c0486741e$var$emailNotificationsLogContainerStyles
    }, formatMessage((0, $3B8mV.default).adminEmailAuditNotificationsLog))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6puUq.EngagementSpotlight), {
        engagementId: $f6a1ba8c0486741e$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
    })));
};
const $f6a1ba8c0486741e$var$emailNotificationsLogContainerStyles = (0, $2s57o.xcss)({
    display: 'flex',
    justifyContent: 'space-between'
});

});
parcelRegister("3B8mV", function(module, exports) {

$parcel$export(module.exports, "default", () => $82b0a510e0e13823$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $82b0a510e0e13823$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    adminHelper: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.admin-helper",
        "defaultMessage": "Admin helper"
    },
    permissionHelper: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.permission-helper",
        "defaultMessage": "Permission helper"
    },
    adminEmailAuditNotificationsLog: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.admin-email-audit-notifications-log",
        "defaultMessage": "Admin email audit"
    }
});

});


parcelRegister("cip1u", function(module, exports) {

$parcel$export(module.exports, "AdvancedSection", () => $55fa8f6cf375a533$export$32bea920eaad7efb);

var $5uXOq = parcelRequire("5uXOq");

var $kxnYb = parcelRequire("kxnYb");
var $9K9UK = parcelRequire("9K9UK");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $jMBA3 = parcelRequire("jMBA3");

var $68MUk = parcelRequire("68MUk");
const $55fa8f6cf375a533$export$32bea920eaad7efb = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        title: formatMessage((0, $68MUk.default).advanced)
    }, features.hasAttachments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'attachments'
        },
        href: navigationPath.advancedSectionAttachments,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $68MUk.default).attachments)), features.hasEvents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'events'
        },
        href: navigationPath.advancedSectionEvents,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $68MUk.default).events)), features.hasWebHooks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'webhooks'
        },
        href: navigationPath.advancedSectionWebHooks,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $68MUk.default).webhooks)), features.hasLexoRankManagement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'lexorank-management'
        },
        href: navigationPath.advancedLexoRankManagement,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $68MUk.default).lexorankManagement)));
};

});
parcelRegister("68MUk", function(module, exports) {

$parcel$export(module.exports, "default", () => $24a7ac619834e463$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $24a7ac619834e463$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    advanced: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.advanced",
        "defaultMessage": "Advanced"
    },
    attachments: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.attachments",
        "defaultMessage": "Attachments"
    },
    events: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.events",
        "defaultMessage": "Events"
    },
    webhooks: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.webhooks",
        "defaultMessage": "WebHooks"
    },
    lexorankManagement: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.lexorank-management",
        "defaultMessage": "LexoRank management"
    }
});

});


parcelRegister("8wyB3", function(module, exports) {

$parcel$export(module.exports, "AutomationSection", () => $ae233f5e809ec072$export$5fa01e4d25d8e6ec);

var $5uXOq = parcelRequire("5uXOq");

var $kxnYb = parcelRequire("kxnYb");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $6tKa8 = parcelRequire("6tKa8");
const $ae233f5e809ec072$export$5fa01e4d25d8e6ec = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        title: formatMessage((0, $6tKa8.default).automationGroup)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'automation'
        },
        href: navigationPath.globalAutomation,
        selectedOn: [
            'global-automation'
        ]
    }, formatMessage((0, $6tKa8.default).globalAutomation)));
};

});
parcelRegister("6tKa8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1b0e49ecb7c48dd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b1b0e49ecb7c48dd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    automationGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.automation.automation-group",
        "defaultMessage": "Automation"
    },
    globalAutomation: {
        "id": "spa-apps-sidebar-global-settings-system.menu.automation.global-automation",
        "defaultMessage": "Global automation"
    }
});

});


parcelRegister("230Wm", function(module, exports) {

$parcel$export(module.exports, "ImportExportSection", () => $45f1c30d97953942$export$2e4cb1dc5b398447);

var $5uXOq = parcelRequire("5uXOq");

var $kxnYb = parcelRequire("kxnYb");
var $9K9UK = parcelRequire("9K9UK");

var $2vSU6 = parcelRequire("2vSU6");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $9OXo1 = parcelRequire("9OXo1");

var $jMBA3 = parcelRequire("jMBA3");

var $8136S = parcelRequire("8136S");
const $45f1c30d97953942$export$2e4cb1dc5b398447 = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { licensedProducts: licensedProducts } = (0, $9OXo1.useTenantContext)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), null);
    const hasSupportedLicense = licensedProducts[(0, $2vSU6.projectTypeToCanonicalId)((0, $2vSU6.SOFTWARE_PROJECT))] || licensedProducts[(0, $2vSU6.projectTypeToCanonicalId)((0, $2vSU6.CORE_PROJECT))];
    const showNewExternalImport = hasSupportedLicense;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        title: formatMessage((0, $8136S.default).importExportGroup)
    }, features.hasBackupManager && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'cloud-export'
        },
        href: navigationPath.importSectionBackupManager,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $8136S.default).backupManager)), features.hasExternalImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'external-import'
        },
        href: showNewExternalImport ? navigationPath.importSectionExternalImportNew : navigationPath.importSectionExternalImport,
        selectedOn: (currentLocation, itemLocation)=>(0, $4OCke.matchUrlExact)()(currentLocation, itemLocation) || showNewExternalImport && currentLocation.pathname.includes(navigationPath.importSectionExternalImport)
    }, formatMessage((0, $8136S.default).externalImport)), features.hasCloudImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'cloud-import'
        },
        href: navigationPath.importSectionCloudImport,
        selectedOn: (0, $4OCke.matchUrlExact)()
    }, formatMessage((0, $8136S.default).importJiraCloud)), features.hasServerImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'server-import'
        },
        href: navigationPath.importSectionServerImport,
        selectedOn: (0, $4OCke.matchUrlExact)()
    }, formatMessage((0, $8136S.default).importJiraServer)));
};

});
parcelRegister("8136S", function(module, exports) {

$parcel$export(module.exports, "default", () => $e31be53e6f399aac$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e31be53e6f399aac$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    importExportGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-export-group",
        "defaultMessage": "Import and export"
    },
    backupManager: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.backup-manager",
        "defaultMessage": "Backup manager"
    },
    externalImport: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.external-import",
        "defaultMessage": "External System Import"
    },
    restoreSystem: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.restore-system",
        "defaultMessage": "Restore system"
    },
    importJiraCloud: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-cloud",
        "defaultMessage": "Import Jira Cloud"
    },
    importJiraServer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-server",
        "defaultMessage": "Import Jira Server"
    }
});

});


parcelRegister("je2KE", function(module, exports) {

$parcel$export(module.exports, "MailSection", () => $6a76fa07c85a01a9$export$6e0cda39522c0aa7);

var $5uXOq = parcelRequire("5uXOq");

var $kxnYb = parcelRequire("kxnYb");
var $9K9UK = parcelRequire("9K9UK");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $jMBA3 = parcelRequire("jMBA3");

var $1c6JR = parcelRequire("1c6JR");

var $gb7H7 = parcelRequire("gb7H7");
const $6a76fa07c85a01a9$export$6e0cda39522c0aa7 = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        title: formatMessage((0, $1c6JR.default).mailGroup)
    }, features.hasGlobalMailSettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'global-mail-settings'
        },
        href: navigationPath.mailSectionGlobalMailSettings,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $1c6JR.default).globalMailSettings)), features.hasOutgoingMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'outgoing-mail'
        },
        href: navigationPath.mailSectionOutgoingMail,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $1c6JR.default).outgoingMail)), features.hasIncomingMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'incoming-mail'
        },
        href: navigationPath.mailSectionIncomingMail,
        selectedOn: (0, $gb7H7.isIncomingMailSelected)
    }, formatMessage((0, $1c6JR.default).incomingMail)), features.hasSendMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'send-email'
        },
        href: navigationPath.mailSectionSendMail,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $1c6JR.default).sendEmail)));
};

});
parcelRegister("1c6JR", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa5900167b5101d6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fa5900167b5101d6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    mailGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.mail-group",
        "defaultMessage": "Mail"
    },
    globalMailSettings: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.global-mail-settings",
        "defaultMessage": "Global Mail Settings"
    },
    outgoingMail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.outgoing-mail",
        "defaultMessage": "Outgoing Mail"
    },
    incomingMail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.incoming-mail",
        "defaultMessage": "Incoming Mail"
    },
    sendEmail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.send-email",
        "defaultMessage": "Send email"
    }
});

});

parcelRegister("gb7H7", function(module, exports) {

$parcel$export(module.exports, "isIncomingMailSelected", () => $d695081436bd6a1d$export$3f53f72603975cb0);

var $4OCke = parcelRequire("4OCke");
const $d695081436bd6a1d$var$INCOMING_MAIL_PATH_REGEXP = /\/admin\/(\w+)Pop(Mail)?Server/i;
const $d695081436bd6a1d$export$3f53f72603975cb0 = (currentLocation, itemLocation)=>(0, $4OCke.matchUrlExact)()(currentLocation, itemLocation) || $d695081436bd6a1d$var$INCOMING_MAIL_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("iAlf2", function(module, exports) {

$parcel$export(module.exports, "default", () => $979d16a4bf22949b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $979d16a4bf22949b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    systemGroupOld: {
        "id": "spa-apps-sidebar-global-settings-system.menu.system-group-old",
        "defaultMessage": "System"
    },
    systemGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.system-group",
        "defaultMessage": "System settings"
    },
    generalConfiguration: {
        "id": "spa-apps-sidebar-global-settings-system.menu.general-configuration",
        "defaultMessage": "General configuration"
    },
    darkFeatures: {
        "id": "spa-apps-sidebar-global-settings-system.menu.dark-features",
        "defaultMessage": "Dark features"
    },
    issueCollectors: {
        "id": "spa-apps-sidebar-global-settings-system.menu.issue-collectors",
        "defaultMessage": "Issue collectors"
    },
    globalSettingsSystemSidebarLabel: {
        "id": "spa-apps-sidebar-global-settings-system.menu.global-settings-system-sidebar-label",
        "defaultMessage": "Sidebar"
    },
    issueCollectorsIssueTermRefresh: {
        "id": "spa-apps-sidebar-global-settings-system.menu.issue-collectors-issue-term-refresh",
        "defaultMessage": "Work item collectors"
    }
});

});

parcelRegister("fwlYA", function(module, exports) {

$parcel$export(module.exports, "SecuritySection", () => $76b3d515542acad4$export$4f16aec1633bed7d);

var $5uXOq = parcelRequire("5uXOq");

var $kxnYb = parcelRequire("kxnYb");
var $9K9UK = parcelRequire("9K9UK");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $jMBA3 = parcelRequire("jMBA3");

var $eTPZ8 = parcelRequire("eTPZ8");

var $icmgW = parcelRequire("icmgW");
const $76b3d515542acad4$export$4f16aec1633bed7d = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), null);
    const globalPermissionsPath = navigationPath.securityGlobalPermissions;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        title: formatMessage((0, $eTPZ8.default).securityGroup)
    }, features.hasProjectRoles && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'project-roles'
        },
        href: navigationPath.securityProjectRoles,
        selectedOn: (0, $icmgW.isProjectRolesSelected)
    }, formatMessage((0, $eTPZ8.default).projectRoles)), features.hasGlobalPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'global-permissions'
        },
        href: globalPermissionsPath,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $eTPZ8.default).globalPermissions)));
};

});
parcelRegister("eTPZ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $db51b59205472bbf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $db51b59205472bbf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    securityGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.security-group",
        "defaultMessage": "Security"
    },
    projectRoles: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.project-roles",
        "defaultMessage": "Project roles"
    },
    globalPermissions: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.global-permissions",
        "defaultMessage": "Global permissions"
    }
});

});

parcelRegister("icmgW", function(module, exports) {

$parcel$export(module.exports, "isProjectRolesSelected", () => $f6a84fa88243c239$export$ca9501e7fedfce90);

var $4OCke = parcelRequire("4OCke");
const $f6a84fa88243c239$var$PROJECT_ROLES_PATH_REGEXP = /\/project\/(\w+)ProjectRole/i;
const $f6a84fa88243c239$export$ca9501e7fedfce90 = (currentLocation, itemLocation)=>(0, $4OCke.matchUrlExact)()(currentLocation, itemLocation) || $f6a84fa88243c239$var$PROJECT_ROLES_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("9O5DC", function(module, exports) {

$parcel$export(module.exports, "SharedSection", () => $440640fab2704f98$export$230e518497f06fdc);

var $5uXOq = parcelRequire("5uXOq");

var $kxnYb = parcelRequire("kxnYb");
var $9K9UK = parcelRequire("9K9UK");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $jMBA3 = parcelRequire("jMBA3");

var $hw0ew = parcelRequire("hw0ew");
const $440640fab2704f98$export$230e518497f06fdc = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        title: formatMessage((0, $hw0ew.default).sharedItems)
    }, features.hasManageFilters && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'manage-filters'
        },
        href: navigationPath.sharedSectionManageFilters,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $hw0ew.default).filters)), features.hasManageDashboards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'manage-dashboards'
        },
        href: navigationPath.sharedManageDashboards,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $hw0ew.default).dashboards)));
};

});
parcelRegister("hw0ew", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a51482729945d2e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4a51482729945d2e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sharedItems: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-items",
        "defaultMessage": "Shared Items"
    },
    sharedFilters: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-filters",
        "defaultMessage": "Shared filters"
    },
    sharedDashboards: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-dashboards",
        "defaultMessage": "Shared dashboards"
    },
    filters: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.dashboards",
        "defaultMessage": "Dashboards"
    }
});

});


parcelRegister("1y2CG", function(module, exports) {

$parcel$export(module.exports, "TroubleshootingAndSupportSection", () => $5fd448f06aadda25$export$dad01649916e6a2d);

var $5uXOq = parcelRequire("5uXOq");

var $kxnYb = parcelRequire("kxnYb");
var $9K9UK = parcelRequire("9K9UK");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $fRwoF = parcelRequire("fRwoF");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $jMBA3 = parcelRequire("jMBA3");

var $4oL80 = parcelRequire("4oL80");

var $81Iv5 = parcelRequire("81Iv5");

var $ie4oV = parcelRequire("ie4oV");
const $5fd448f06aadda25$export$dad01649916e6a2d = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { hasSiteOptimizerEntitlement: hasSiteOptimizerEntitlement } = (0, $fRwoF.useSiteOptimizerCheck)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        title: formatMessage((0, $4oL80.default).troubleshootingGroup)
    }, features.hasViewAuditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'view-auditing'
        },
        href: navigationPath.troubleshootingAuditLog,
        selectedOn: (0, $ie4oV.isViewAuditingSelected)
    }, formatMessage((0, $4oL80.default).auditLog)), features.hasPluginViewer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'plugin-viewer'
        },
        href: navigationPath.troubleshootingPluginViewer,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4oL80.default).pluginViewer)), features.hasModulesViewer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'modules-viewer'
        },
        href: navigationPath.troubleshootingModulesViewer,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4oL80.default).modulesViewer)), features.hasSystemInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'system-info'
        },
        href: navigationPath.troubleshootingSystemInfo,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4oL80.default).systemInfo)), features.hasIntegrityChecker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'integrity-checker'
        },
        href: navigationPath.troubleshootingIntegrityChecker,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4oL80.default).integrityChecker)), features.hasLoggingProfiling && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'logging-profiling'
        },
        href: navigationPath.troubleshootingLoggingProfiling,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4oL80.default).loggingProfiling)), features.hasSchedulerDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'scheduler-details'
        },
        href: navigationPath.troubleshootingSchedulerDetails,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4oL80.default).schedulerDetails)), hasSiteOptimizerEntitlement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $81Iv5.PerformanceMenuItem), null));
};

});
parcelRegister("fRwoF", function(module, exports) {

$parcel$export(module.exports, "useSiteOptimizerCheck", () => $31e8f2ad3b3f051f$export$7df80afc329cd61);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");
const $31e8f2ad3b3f051f$export$e9921a980669184 = ()=>(0, $eusud.performGetRequest)('/rest/internal/psi/latest/licence/check');
const $31e8f2ad3b3f051f$export$7df80afc329cd61 = ()=>{
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [hasEntitlement, setHasEntitlement] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)();
    const fetch = async ()=>{
        try {
            setLoading(true);
            setError(undefined);
            if ((0, $4R6GH.fg)('override-enable-performance-and-scale-admin-menu')) setHasEntitlement(true);
            else {
                const data = await $31e8f2ad3b3f051f$export$e9921a980669184();
                setHasEntitlement(data?.isVisible ?? false);
            }
            setLoading(false);
        } catch (apiError) {
            setLoading(false);
            setError(apiError);
        }
    };
    (0, $5uXOq.useEffect)(()=>{
        fetch();
    }, []);
    return {
        loading: loading,
        hasSiteOptimizerEntitlement: hasEntitlement,
        error: error
    };
};

});

parcelRegister("4oL80", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ca98bc392d099f0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9ca98bc392d099f0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    troubleshootingGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.troubleshooting-group",
        "defaultMessage": "Troubleshooting and Support"
    },
    auditLog: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.audit-log",
        "defaultMessage": "Audit Log"
    },
    pluginViewer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.plugin-viewer",
        "defaultMessage": "Plugin Viewer"
    },
    modulesViewer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.modules-viewer",
        "defaultMessage": "Modules Viewer"
    },
    systemInfo: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.system-info",
        "defaultMessage": "System info"
    },
    integrityChecker: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.integrity-checker",
        "defaultMessage": "Integrity checker"
    },
    loggingProfiling: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.logging-profiling",
        "defaultMessage": "Logging profiling"
    },
    schedulerDetails: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.scheduler-details",
        "defaultMessage": "Scheduler details"
    }
});

});

parcelRegister("81Iv5", function(module, exports) {

$parcel$export(module.exports, "PerformanceMenuItem", () => $ca611bfc0be59ae0$export$b4e98631ff0b3fb5);

var $5uXOq = parcelRequire("5uXOq");

var $eOat1 = parcelRequire("eOat1");

var $inni2 = parcelRequire("inni2");
var $Pxnvj = parcelRequire("Pxnvj");
var $98UVV = parcelRequire("98UVV");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");

var $koVbs = parcelRequire("koVbs");

var $kZj7F = parcelRequire("kZj7F");

var $17bH5 = parcelRequire("17bH5");

var $8zOmE = parcelRequire("8zOmE");

var $ehdJY = parcelRequire("ehdJY");

var $90yGq = parcelRequire("90yGq");

var $eaZ4X = parcelRequire("eaZ4X");

var $1ssva = parcelRequire("1ssva");

var $iWjQg = parcelRequire("iWjQg");

var $fM231 = parcelRequire("fM231");
const $ca611bfc0be59ae0$export$b4e98631ff0b3fb5 = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOptimiserSpotlightActive, setIsOptimiserSpotlightActive] = (0, $5uXOq.useState)(false);
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    const BackMenuItem = {
        href: '/jira/settings/system/general-configuration',
        title: formatMessage((0, $1ssva.default).itemBack)
    };
    const fetchSpotlightState = (0, $5uXOq.useCallback)(async ()=>{
        if (accountId != null) {
            const response = await (0, $fM231.hasSeenSiteOptimiserSpotlight)(accountId);
            setIsOptimiserSpotlightActive(!response);
        }
    }, [
        accountId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchSpotlightState();
    }, [
        fetchSpotlightState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inni2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
        name: "site-optimiser-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'performance-and-scale'
        },
        href: navigationPath.troubleshootingPerformanceAndScale,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
            gap: "space.050",
            justifyContent: "start",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, formatMessage((0, $1ssva.default).performanceAndScale)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
            appearance: "new"
        }, formatMessage((0, $1ssva.default).beta))),
        overrides: {
            BackMenuItem: BackMenuItem
        },
        id: (0, $eaZ4X.SECTION_ID).PERFORMANCE_AND_SCALE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iWjQg.PerformanceAndScaleMenu), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $98UVV.default), null, isOptimiserSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                onClick: (_, analyticsEvent)=>{
                    setIsOptimiserSpotlightActive(false);
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'performanceMenuItemSpotlightComplete');
                },
                text: formatMessage((0, $1ssva.default).spotlightAction)
            }
        ],
        heading: formatMessage((0, $1ssva.default).spotlightHeading),
        target: "site-optimiser-spotlight",
        key: "site-optimiser-spotlight",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        dialogPlacement: "right top",
        messageId: "navigation-apps-sidebar-global-settings-system.ui.menu.troubleshooting-and-support.performance-menu-item.jira-spotlight.site-optimiser-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $1ssva.default).spotlightBody))));
};

});
parcelRegister("ehdJY", function(module, exports) {

$parcel$export(module.exports, "JiraSpotlight", () => $61a8dc1ff1116911$export$e209c6be9ab8c4f4);

var $5uXOq = parcelRequire("5uXOq");

var $bkS4F = parcelRequire("bkS4F");

var $10xFf = parcelRequire("10xFf");

var $5NHqU = parcelRequire("5NHqU");
const $61a8dc1ff1116911$export$e209c6be9ab8c4f4 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5NHqU.ChoreographerSpotlight), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bkS4F.default), rest);
};

});
parcelRegister("10xFf", function(module, exports) {

$parcel$export(module.exports, "shouldBeChoreographed", () => $36201c75b4df20a7$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "environmentToEnvType", () => $36201c75b4df20a7$export$e2cf19200849be9e);

var $9etNK = parcelRequire("9etNK");

var $t6tX9 = parcelRequire("t6tX9");
function $36201c75b4df20a7$export$a8ba9111c7eec9ac(props) {
    return !!props?.messageType && (0, $t6tX9.IntegratedChoreographerMessageTypesEnum).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    props.messageType);
}
function $36201c75b4df20a7$export$e2cf19200849be9e(environment) {
    switch(environment){
        case 'dev':
            return (0, $9etNK.envType).DEV;
        case 'staging':
            return (0, $9etNK.envType).STAGING;
        case 'prod':
            return (0, $9etNK.envType).PROD;
        default:
            return (0, $9etNK.envType).LOCAL;
    }
}

});
parcelRegister("t6tX9", function(module, exports) {

$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $b5642a17fa90b00d$export$dbe9e38c9d6f26d0);
const $b5642a17fa90b00d$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $b5642a17fa90b00d$export$dbe9e38c9d6f26d0 = [
    $b5642a17fa90b00d$export$94e85cf3348f045a.ENGAGEMENT,
    $b5642a17fa90b00d$export$94e85cf3348f045a.MARKETING
];

});


parcelRegister("5NHqU", function(module, exports) {

$parcel$export(module.exports, "ChoreographerSpotlight", () => $b7d2a49fe3b12822$export$e01943d134357d00);
// eslint-disable-next-line jira/import/no-restricted-import

var $bkS4F = parcelRequire("bkS4F");

var $cSWNW = parcelRequire("cSWNW");
const $b7d2a49fe3b12822$export$e01943d134357d00 = (0, $cSWNW.withChoreographedRender)((0, $bkS4F.default));

});
parcelRegister("cSWNW", function(module, exports) {

$parcel$export(module.exports, "withChoreographedRender", () => $620c1a9f3fec1a68$export$c1160fdac17030e);

var $5uXOq = parcelRequire("5uXOq");

var $ioD1B = parcelRequire("ioD1B");

var $fG5AJ = parcelRequire("fG5AJ");
function $620c1a9f3fec1a68$export$c1160fdac17030e(Component) {
    function ChoreographedComponent(props) {
        const { messageId: messageId, onMessageDisposition: onMessageDisposition } = props;
        const shouldRender = (0, $fG5AJ.useChoreographedRender)({
            messageId: messageId,
            onMessageDisposition: onMessageDisposition
        });
        if (shouldRender) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
            isChoreographed: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props));
        return null;
    }
    ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
    function WithChoreographedRenderComponent(props) {
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $ioD1B.useChoreographedStatusContext)();
        if (isAlreadyChoreographedAtAncestor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChoreographedComponent, props);
    }
    WithChoreographedRenderComponent.displayName = `WithChoreographedRender${Component.displayName ?? 'Component'}`;
    return WithChoreographedRenderComponent;
}

});
parcelRegister("ioD1B", function(module, exports) {

$parcel$export(module.exports, "ChoreographerContextProvider", () => $c141e5ba3428702a$export$c3226151caaf2fbf);
$parcel$export(module.exports, "useChoreographedStatusContext", () => $c141e5ba3428702a$export$2eb1efa814fe4a);

var $5uXOq = parcelRequire("5uXOq");
const $c141e5ba3428702a$var$choreographedStatusContextValue = {
    isAlreadyChoreographedAtAncestor: true
};
const $c141e5ba3428702a$export$c3226151caaf2fbf = ({ isChoreographed: isChoreographed, children: children })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $c141e5ba3428702a$export$2eb1efa814fe4a();
    const shouldUseChoreographerContextProvider = !isAlreadyChoreographedAtAncestor && isChoreographed;
    return shouldUseChoreographerContextProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c141e5ba3428702a$export$3ff96dbefca6b00d.Provider, {
        value: $c141e5ba3428702a$var$choreographedStatusContextValue
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $c141e5ba3428702a$export$3ff96dbefca6b00d = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isAlreadyChoreographedAtAncestor: false
});
const $c141e5ba3428702a$export$2eb1efa814fe4a = ()=>(0, $5uXOq.useContext)($c141e5ba3428702a$export$3ff96dbefca6b00d);

});

parcelRegister("fG5AJ", function(module, exports) {

$parcel$export(module.exports, "getPendoPlugin", () => $596f0fde3f3a2d5a$export$3d3a86b2d636214b);
$parcel$export(module.exports, "withChoreographedToggle", () => $596f0fde3f3a2d5a$export$a646002207b915ac);
$parcel$export(module.exports, "useChoreographedRender", () => $596f0fde3f3a2d5a$export$2cfd68294be82811);

var $5uXOq = parcelRequire("5uXOq");

var $21iT5 = parcelRequire("21iT5");
var $g3Ayl = parcelRequire("g3Ayl");
var $1T9zJ = parcelRequire("1T9zJ");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $7qPn9 = parcelRequire("7qPn9");

var $ioD1B = parcelRequire("ioD1B");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $596f0fde3f3a2d5a$var$environment = (0, $7qPn9.toEnvironment)((0, $j8DrX.default)('ajs-environment')) ?? 'prod';
const $596f0fde3f3a2d5a$var$createChoreographerFactory = ()=>{
    if (false) return {
        useChoreographer: (..._)=>({
                startMessage: ()=>Promise.resolve((0, $g3Ayl.MessageDeliveryStatus).STARTED),
                stopMessage: ()=>Promise.resolve((0, $g3Ayl.MessageDeliveryStatus).STOPPED),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                toggleMessage: ()=>Promise.resolve('')
            }),
        withChoreographedToggle: (Component)=>Component
    };
    return (0, $21iT5.choreographerFactory)((0, $g3Ayl.ProductIds).JIRA, $596f0fde3f3a2d5a$var$environment);
};
let $596f0fde3f3a2d5a$var$pendoPlugin;
function $596f0fde3f3a2d5a$export$3d3a86b2d636214b(env) {
    if (!$596f0fde3f3a2d5a$var$pendoPlugin) $596f0fde3f3a2d5a$var$pendoPlugin = new (0, $1T9zJ.PendoChoreographerPlugin)(env, {
        sourceProductId: (0, $g3Ayl.ProductIds).JIRA
    });
    return $596f0fde3f3a2d5a$var$pendoPlugin;
}
/**
 * Stupid hack alert: useChoreographer is throwing a TS compiler error about using MessageEventType
 * internally, and not being able to resolve that name... The usual fix for this is to add the
 * offending type to the project's exports, and then import it here so that the compiler has some
 * knowledge of what that type definition is... In this case, it doesn't seem to be working, but
 * for whatever reason, I can cast the choreographerFactory's return type using nothing more than
 * the information provided by the ReturnType<typeof choreographerFactory> type above, and then
 * define the useChoreographer type as an args list that conforms to its Parameters list, and a
 * return type that conforms to its ReturnType, and that seems to work just fine. Hopefully, somebody
 * can figure out what's going wrong here, and remove this idiocy in favor of something more sane.
 */ const { useChoreographer: $596f0fde3f3a2d5a$export$9f0e2488ffd90f11, withChoreographedToggle: $596f0fde3f3a2d5a$var$withChoreographedToggleFromFactory } = $596f0fde3f3a2d5a$var$createChoreographerFactory();
const $596f0fde3f3a2d5a$export$a646002207b915ac = (Component, toggleableProp, toggleableContentProp)=>{
    const WithChoreographedToggleComponent = (props)=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $ioD1B.useChoreographedStatusContext)();
        const ChoreographedComponent = (0, $5uXOq.useMemo)(()=>$596f0fde3f3a2d5a$var$withChoreographedToggleFromFactory(Component, toggleableProp), []);
        if (isAlreadyChoreographedAtAncestor || !(0, $4R6GH.fg)('jira_with_choreographed_toggle_fix')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props);
        const propsWithContextProviderWrapper = {
            ...props
        };
        if (toggleableContentProp) {
            const { [toggleableContentProp]: toggleableContentPropValue } = propsWithContextProviderWrapper;
            if (typeof toggleableContentPropValue === 'function') // @ts-expect-error TS doesn't know this is a callback with variable params that returns ReactNode, but we do
            propsWithContextProviderWrapper[toggleableContentProp] = (...args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
                    isChoreographed: true
                }, toggleableContentPropValue(...args));
            else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const content = toggleableContentPropValue;
                // @ts-expect-error TS doesn't know this is a ReactNode, but we do
                propsWithContextProviderWrapper[toggleableContentProp] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
                    isChoreographed: true
                }, content);
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChoreographedComponent, propsWithContextProviderWrapper);
    };
    WithChoreographedToggleComponent.displayName = `WithChoreographedToggle(${Component.displayName ?? Component.name ?? 'Component'})`;
    return WithChoreographedToggleComponent;
};
const $596f0fde3f3a2d5a$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $ioD1B.useChoreographedStatusContext)();
    const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = $596f0fde3f3a2d5a$export$9f0e2488ffd90f11(messageId, {
        start: ()=>setShouldRender(true)
    });
    (0, $5uXOq.useEffect)(()=>{
        if (!isAlreadyChoreographedAtAncestor) {
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>{
                stopMessage();
            };
        }
    }, [
        onMessageDisposition,
        startMessage,
        stopMessage,
        isAlreadyChoreographedAtAncestor
    ]);
    return shouldRender || isAlreadyChoreographedAtAncestor;
};

});




parcelRegister("90yGq", function(module, exports) {

$parcel$export(module.exports, "useAccountId", () => $903db0de2618ef6c$export$e72033e0f5baa3e);

var $9OXo1 = parcelRequire("9OXo1");
const $903db0de2618ef6c$export$e72033e0f5baa3e = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.atlassianAccountId || null;
};

});

parcelRegister("1ssva", function(module, exports) {

$parcel$export(module.exports, "default", () => $46da0b37092f9f6a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $46da0b37092f9f6a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    performanceAndScale: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale",
        "defaultMessage": "Site optimizer"
    },
    itemBack: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.item-back",
        "defaultMessage": "Back to system"
    },
    spotlightHeading: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-heading",
        "defaultMessage": "Clean up your site"
    },
    spotlightBody: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-body",
        "defaultMessage": "Remove old data that might be slowing down your site in a few clicks."
    },
    spotlightAction: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-action",
        "defaultMessage": "Ok"
    },
    beta: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.beta",
        "defaultMessage": "Beta"
    }
});

});

parcelRegister("iWjQg", function(module, exports) {

$parcel$export(module.exports, "PerformanceAndScaleMenu", () => $4bb22b80a7726eba$export$442d4ccb0d25fc50);

var $5uXOq = parcelRequire("5uXOq");

var $Pxnvj = parcelRequire("Pxnvj");

var $kxnYb = parcelRequire("kxnYb");

var $lzUDm = parcelRequire("lzUDm");

var $fgWYz = parcelRequire("fgWYz");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $3OGaE = parcelRequire("3OGaE");

var $4OCke = parcelRequire("4OCke");

var $etuUp = parcelRequire("etuUp");

var $jWIOc = parcelRequire("jWIOc");
const $4bb22b80a7726eba$export$442d4ccb0d25fc50 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const basePerformanceUrl = '/jira/settings/system/performance';
    const allVisibleMetrics = (0, $fgWYz.getAllVisibleMetrics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, formatMessage((0, $etuUp.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'performance-overview'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `${basePerformanceUrl}/overview`
    }, formatMessage((0, $etuUp.default).overview))), allVisibleMetrics.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        title: formatMessage((0, $etuUp.default).allReports)
    }, allVisibleMetrics.map((metric)=>{
        if (metric.key === (0, $lzUDm.PROJECT_CLEANUP_KEY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: "project-cleanup-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
            name: (0, $jWIOc.PROJECT_CLEANUP_SPOTLIGHT_NAME)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            analytics: {
                itemId: `performance-metric-${metric.key}`
            },
            href: `${basePerformanceUrl}/metrics/${metric.key}`,
            selectedOn: (0, $4OCke.matchUrlPathname)(),
            key: metric.key
        }, formatMessage(metric.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jWIOc.ProjectCleanupSpotlight), null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            analytics: {
                itemId: `performance-metric-${metric.key}`
            },
            href: `${basePerformanceUrl}/metrics/${metric.key}`,
            selectedOn: (0, $4OCke.matchUrlPathname)(),
            key: metric.key
        }, formatMessage(metric.name));
    })));
};

});
parcelRegister("lzUDm", function(module, exports) {

$parcel$export(module.exports, "PROJECT_CLEANUP_KEY", () => $3bfe695ee69b7be4$export$4e9bf1d386c2f0c);
$parcel$export(module.exports, "PROJECT_CLEANUP", () => $3bfe695ee69b7be4$export$761acf34bef3a717);

var $iHO6d = parcelRequire("iHO6d");
const $3bfe695ee69b7be4$export$4e9bf1d386c2f0c = 'projectcleanup';
const $3bfe695ee69b7be4$export$761acf34bef3a717 = {
    key: $3bfe695ee69b7be4$export$4e9bf1d386c2f0c,
    visible: true,
    name: (0, $iHO6d.default).nameNonFinal,
    description: (0, $iHO6d.default).descriptionNonFinal,
    tabLabels: [
        (0, $iHO6d.default).analysisNonFinal,
        (0, $iHO6d.default).activityLogNonFinal
    ],
    warningMessage: (0, $iHO6d.default).warningNonFinal,
    exceededMessage: (0, $iHO6d.default).exceededNonFinal,
    risks: [],
    mitigations: [],
    currentValueLabel: (0, $iHO6d.default).currentValueLabel,
    cleanupValueLabel: (0, $iHO6d.default).cleanupValueLabel,
    graphHeader: (0, $iHO6d.default).graphHeader,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-the-number-of-projects-in-your-site/',
    recommendationUrlText: (0, $iHO6d.default).recommendationUrlText
};

});
parcelRegister("iHO6d", function(module, exports) {

$parcel$export(module.exports, "default", () => $622f291bdb5f6890$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically. This duplication is OK.
const $622f291bdb5f6890$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $622f291bdb5f6890$var$DESCRIPTION_DESC = 'Description of the site optimizer metric.';
const $622f291bdb5f6890$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $622f291bdb5f6890$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $622f291bdb5f6890$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $622f291bdb5f6890$var$CLEANUP_VALUE_LABEL_DESC = 'Label to be shown next to the cleanup value of the metric.';
const $622f291bdb5f6890$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
const $622f291bdb5f6890$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
var $622f291bdb5f6890$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    nameNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.name-non-final",
        "defaultMessage": "Projects"
    },
    descriptionNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.description-non-final",
        "defaultMessage": "Below, we\u2019ve identified company-managed and team-managed projects in your site that can be archived or trashed because they contain no issues. Removing these projects can improve site performance and stability."
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.project-cleanup.recommendation-url-text",
        "defaultMessage": "See how we identify these projects."
    },
    analysisNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.analysis-non-final",
        "defaultMessage": "Analysis"
    },
    activityLogNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.activity-log-non-final",
        "defaultMessage": "Activity log"
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.project-role-actor.graph-header",
        "defaultMessage": "Projects over time"
    },
    // Since we don't have a threshold, these messages below will be unused - keeping them purely to satisfy the Metric type
    // We should make this type more flexible in the future
    warningNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.warning-non-final",
        "defaultMessage": "The number of projects is nearing our recommended threshold."
    },
    exceededNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.exceeded-non-final",
        "defaultMessage": "There are some project..."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.project-cleanup.current-value-label",
        "defaultMessage": "Projects in your site"
    },
    cleanupValueLabel: {
        "id": "admin-pages-performance.common.assets.project-cleanup.cleanup-value-label",
        "defaultMessage": "Recommended for cleanup"
    }
});

});


parcelRegister("fgWYz", function(module, exports) {

$parcel$export(module.exports, "getAllVisibleMetrics", () => $2cc6642f29a0adee$export$e6140fda06493d18);
$parcel$export(module.exports, "getMetric", () => $2cc6642f29a0adee$export$ed0dc1178a679c67);
$parcel$export(module.exports, "getAllVisibleMetricKeys", () => $2cc6642f29a0adee$export$1f2abf3e170d35d2);
$parcel$export(module.exports, "assertNever", () => $2cc6642f29a0adee$export$cbadc5a7223772a8);
$parcel$export(module.exports, "TooltipMap", () => $2cc6642f29a0adee$export$9bd9f2d76c500145);

var $4R6GH = parcelRequire("4R6GH");

var $a4FfD = parcelRequire("a4FfD");

var $8MHQY = parcelRequire("8MHQY");

var $cOrKR = parcelRequire("cOrKR");

var $lzUDm = parcelRequire("lzUDm");

var $3AEMX = parcelRequire("3AEMX");

var $gtb9f = parcelRequire("gtb9f");
class $2cc6642f29a0adee$export$9419457073a1750 {
    constructor(metrics){
        this.metrics = metrics;
    }
    getMetric(key) {
        return this.metrics.find((m)=>m.key === key);
    }
    getAllVisibleMetrics() {
        return this.metrics.filter((metric)=>metric.visible && $2cc6642f29a0adee$var$mitigationEnabled(metric.key));
    }
    getAllVisibleMetricsKeys() {
        return $2cc6642f29a0adee$export$e6140fda06493d18().map((m)=>m.key);
    }
}
/**
 * Metric registry singleton. We should not be creating another registry.
 */ const $2cc6642f29a0adee$var$REGISTRY = new $2cc6642f29a0adee$export$9419457073a1750((0, $gtb9f.METRICS));
const $2cc6642f29a0adee$export$ed0dc1178a679c67 = $2cc6642f29a0adee$var$REGISTRY.getMetric.bind($2cc6642f29a0adee$var$REGISTRY);
const $2cc6642f29a0adee$export$e6140fda06493d18 = $2cc6642f29a0adee$var$REGISTRY.getAllVisibleMetrics.bind($2cc6642f29a0adee$var$REGISTRY);
const $2cc6642f29a0adee$export$1f2abf3e170d35d2 = $2cc6642f29a0adee$var$REGISTRY.getAllVisibleMetricsKeys.bind($2cc6642f29a0adee$var$REGISTRY);
const $2cc6642f29a0adee$var$mitigationEnabled = (metricKey)=>{
    switch(metricKey){
        case 0, $lzUDm.PROJECT_CLEANUP_KEY:
            return (0, $4R6GH.fg)('site-optimizer-project-cleanup');
        case 0, $3AEMX.PROJECT_ROLE_ACTOR_KEY:
        case 0, $8MHQY.CUSTOM_FIELDS_KEY:
        case 0, $cOrKR.ISSUE_KEY:
            return true;
        default:
            return false;
    }
};
const $2cc6642f29a0adee$export$cbadc5a7223772a8 = (_, message)=>{
    throw new Error(message);
};
const $2cc6642f29a0adee$export$9bd9f2d76c500145 = {
    [(0, $8MHQY.CUSTOM_FIELDS_KEY)]: (0, $a4FfD.CustomFieldsTooltip)
};

});
parcelRegister("a4FfD", function(module, exports) {

$parcel$export(module.exports, "CustomFieldsTooltip", () => $dcdb15fd0fe38e4b$export$9a2f1f96cf156e26);

var $l5IZ6 = parcelRequire("l5IZ6");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $6tzHJ = parcelRequire("6tzHJ");

var $0yZbT = parcelRequire("0yZbT");

var $5KCCi = parcelRequire("5KCCi");
var $1Jlkv = parcelRequire("1Jlkv");

var $koVbs = parcelRequire("koVbs");

var $9TSwz = parcelRequire("9TSwz");
const $dcdb15fd0fe38e4b$var$CustomTooltip = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, ...rest }, ref)=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $1Jlkv.default), {
        ...rest,
        ref: ref,
        className: (0, $bwpsq.default)([
            $dcdb15fd0fe38e4b$var$styles.tooltipStyles
        ])
    }, children);
});
const $dcdb15fd0fe38e4b$export$9a2f1f96cf156e26 = ({ children: children, dataRef: dataRef, metricState: metricState })=>{
    const { resourceUsageMetricV2: metricUsageData } = (0, $8Uumt.useFragment)((0, $l5IZ6.default), dataRef);
    if (metricUsageData === null || metricUsageData === undefined) return null;
    const customFieldsCount = {
        globalScopedCustomFieldsCount: metricUsageData.globalScopedCustomFieldsCount,
        projectScopedCustomFieldsCount: metricUsageData.projectScopedCustomFieldsCount
    };
    const customFieldsCountLabels = {
        globalScopedCustomFieldsCountLabel: (0, $9TSwz.default).globalScopedCustomFieldsCountLabel,
        projectScopedCustomFieldsCountLabel: (0, $9TSwz.default).projectScopedCustomFieldsCountLabel,
        globalScopedCustomFieldsCountAriaLabel: (0, $9TSwz.default).globalScopedCustomFieldsCountAriaLabel,
        projectScopedCustomFieldsCountArialLabel: (0, $9TSwz.default).projectScopedCustomFieldsCountAriaLabel
    };
    return /*#__PURE__*/ $5uXOq.createElement((0, $5KCCi.default), {
        content: /*#__PURE__*/ $5uXOq.createElement($dcdb15fd0fe38e4b$var$CustomFieldsTooltipContent, {
            customFieldsCount: customFieldsCount,
            customFieldsCountLabels: customFieldsCountLabels,
            metricState: metricState
        }),
        component: $dcdb15fd0fe38e4b$var$CustomTooltip
    }, children);
};
const $dcdb15fd0fe38e4b$var$CustomFieldsTooltipContent = ({ customFieldsCount: customFieldsCount, customFieldsCountLabels: customFieldsCountLabels, metricState: metricState })=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $koVbs.default)();
    const { globalScopedCustomFieldsCount: globalScopedCustomFieldsCount, projectScopedCustomFieldsCount: projectScopedCustomFieldsCount } = customFieldsCount;
    const { globalScopedCustomFieldsCountLabel: globalScopedCustomFieldsCountLabel, projectScopedCustomFieldsCountLabel: projectScopedCustomFieldsCountLabel, globalScopedCustomFieldsCountAriaLabel: globalScopedCustomFieldsCountAriaLabel, projectScopedCustomFieldsCountArialLabel: projectScopedCustomFieldsCountArialLabel } = customFieldsCountLabels;
    return /*#__PURE__*/ $5uXOq.createElement((0, $0yZbT.default), {
        xcss: $dcdb15fd0fe38e4b$var$styles.numbersContainer
    }, globalScopedCustomFieldsCount != null && globalScopedCustomFieldsCountLabel && /*#__PURE__*/ $5uXOq.createElement((0, $0yZbT.default), {
        xcss: $dcdb15fd0fe38e4b$var$styles.numberContainer,
        tabIndex: 0,
        "aria-label": globalScopedCustomFieldsCountAriaLabel ? formatMessage(globalScopedCustomFieldsCountAriaLabel, {
            number: formatNumber(globalScopedCustomFieldsCount)
        }) : undefined
    }, /*#__PURE__*/ $5uXOq.createElement((0, $0yZbT.default), {
        xcss: (0, $6tzHJ.cx)(metricState === 'none' && $dcdb15fd0fe38e4b$var$styles.successNumber, metricState === 'warning' && $dcdb15fd0fe38e4b$var$styles.warningNumber, metricState === 'exceeded' && $dcdb15fd0fe38e4b$var$styles.errorNumber, $dcdb15fd0fe38e4b$var$styles.fontWeightStyles),
        "aria-describedby": "global-scoped-custom-fields-count-desc"
    }, formatNumber(globalScopedCustomFieldsCount)), /*#__PURE__*/ $5uXOq.createElement((0, $0yZbT.default), {
        xcss: $dcdb15fd0fe38e4b$var$styles.textContainer
    }, /*#__PURE__*/ $5uXOq.createElement("small", {
        id: "global-scoped-custom-fields-count-desc"
    }, formatMessage(globalScopedCustomFieldsCountLabel)))), projectScopedCustomFieldsCount != null && projectScopedCustomFieldsCountLabel && /*#__PURE__*/ $5uXOq.createElement((0, $0yZbT.default), {
        xcss: $dcdb15fd0fe38e4b$var$styles.numberContainer,
        tabIndex: 0,
        "aria-label": projectScopedCustomFieldsCountArialLabel ? formatMessage(projectScopedCustomFieldsCountArialLabel, {
            number: formatNumber(projectScopedCustomFieldsCount)
        }) : undefined
    }, /*#__PURE__*/ $5uXOq.createElement((0, $0yZbT.default), {
        xcss: (0, $6tzHJ.cx)(metricState === 'none' && $dcdb15fd0fe38e4b$var$styles.successNumber, metricState === 'warning' && $dcdb15fd0fe38e4b$var$styles.warningNumber, metricState === 'exceeded' && $dcdb15fd0fe38e4b$var$styles.errorNumber, $dcdb15fd0fe38e4b$var$styles.fontWeightStyles),
        "aria-describedby": "project-scoped-custom-fields-count-desc"
    }, formatNumber(projectScopedCustomFieldsCount)), /*#__PURE__*/ $5uXOq.createElement((0, $0yZbT.default), {
        xcss: $dcdb15fd0fe38e4b$var$styles.textContainer
    }, /*#__PURE__*/ $5uXOq.createElement("small", {
        id: "project-scoped-custom-fields-count-desc"
    }, formatMessage(projectScopedCustomFieldsCountLabel)))));
};
const $dcdb15fd0fe38e4b$var$styles = {
    numbersContainer: "_1e0c1txw _y3gn1h6o _1bsb1mjv _1bah1yb4 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
    numberContainer: "_16jlidpf _1o9zidpf _i0dl1wug",
    successNumber: "_11c8nf1z _syazaqb7",
    warningNumber: "_11c8nf1z _syaz1q28",
    errorNumber: "_11c8nf1z _syaz9lu1",
    fontWeightStyles: "_k48p1pd9",
    textContainer: "_p12f1lit",
    tooltipStyles: "_2rkoiti9 _bfhk1j9a _syaz15cr _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _16qszucj"
};

});
parcelRegister("l5IZ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $51f76bd051a38e39$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7720db90ecfa6c4681831e9e06d103aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $51f76bd051a38e39$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "metricKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "tooltipEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "tooltip_adminPagesPerformance_CustomFieldsTooltip",
    "selections": [
        {
            "condition": "tooltipEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "metricKey",
                            "variableName": "metricKey"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "resourceUsageMetricV2",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "globalScopedCustomFieldsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectScopedCustomFieldsCount"
                                }
                            ],
                            "type": "JiraCustomFieldUsageMetric"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$51f76bd051a38e39$var$node.hash = "e6113bc43303a707291b62cbe6c2b46f";
var $51f76bd051a38e39$export$2e2bcd8739ae039 = $51f76bd051a38e39$var$node;

});

parcelRegister("9TSwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb4cda92a9b67081$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically. This duplication is OK.
const $eb4cda92a9b67081$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $eb4cda92a9b67081$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
const $eb4cda92a9b67081$var$CHART_DESC = 'A tab label of Custom Field Tabs, to show custom fields chart';
const $eb4cda92a9b67081$var$REVIEW_AND_ANALYZE_DESC = 'A tab label of Custom Field Tabs, to show custom fields review and analyze';
const $eb4cda92a9b67081$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $eb4cda92a9b67081$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $eb4cda92a9b67081$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
const $eb4cda92a9b67081$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
const $eb4cda92a9b67081$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $eb4cda92a9b67081$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
const $eb4cda92a9b67081$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
const $eb4cda92a9b67081$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
var $eb4cda92a9b67081$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.custom-fields.name",
        "defaultMessage": "Custom fields"
    },
    description: {
        "id": "admin-pages-performance.common.assets.custom-fields.description",
        "defaultMessage": "Here are the custom fields in your site, including ones we think can be removed because they\u2019re not used. Removing unused fields could improve site performance and stability."
    },
    chart: {
        "id": "admin-pages-performance.common.assets.custom-fields.chart",
        "defaultMessage": "Overview"
    },
    reviewAndAnalyze: {
        "id": "admin-pages-performance.common.assets.custom-fields.review-and-analyze",
        "defaultMessage": "Analysis"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.custom-fields.warning",
        "defaultMessage": "The number of custom fields is nearing our recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.custom-fields.exceeded",
        "defaultMessage": "There are more custom fields than our recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.custom-fields.risk-1",
        "defaultMessage": "Custom fields can make searching for issues (JQL and boards) and creating issues slow."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.custom-fields.mitigation-1",
        "defaultMessage": "Edit the context for the custom field to make it visible only for specific projects."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.custom-fields.mitigation-2",
        "defaultMessage": "Limit the number of custom fields across all projects and use the same custom field in multiple projects."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.current-value-label",
        "defaultMessage": "Custom fields in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-label",
        "defaultMessage": "Recommended maximum number of custom fields"
    },
    globalScopedCustomFieldsCountLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.global-scoped-custom-fields-count-label",
        "defaultMessage": "CMP custom fields count"
    },
    projectScopedCustomFieldsCountLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.project-scoped-custom-fields-count-label",
        "defaultMessage": "TMP custom fields count"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.current-value-aria-label",
        "defaultMessage": "{number} custom fields in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of custom fields"
    },
    globalScopedCustomFieldsCountAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.global-scoped-custom-fields-count-aria-label",
        "defaultMessage": "{number} {number, plural, one {global scoped custom field} other {global scoped custom fields}}"
    },
    projectScopedCustomFieldsCountAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.project-scoped-custom-fields-count-aria-label",
        "defaultMessage": "{number} {number, plural, one {project scoped custom field} other {global scoped custom fields}}"
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.custom-fields.recommendation-url-text",
        "defaultMessage": "See how we identify these fields."
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.custom-fields.graph-header",
        "defaultMessage": "Custom fields over time"
    },
    risk1IssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.custom-fields.risk-1-issue-term-refresh",
        "defaultMessage": "Custom fields can make searching (JQL and boards) and creating work items slow."
    }
});

});


parcelRegister("8MHQY", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_FIELDS_KEY", () => $1dd393ebccb36050$export$d214286a7039b004);
$parcel$export(module.exports, "CUSTOM_FIELDS", () => $1dd393ebccb36050$export$459112111ad5b136);

var $9TSwz = parcelRequire("9TSwz");
const $1dd393ebccb36050$export$d214286a7039b004 = 'customField';
const $1dd393ebccb36050$export$459112111ad5b136 = {
    key: $1dd393ebccb36050$export$d214286a7039b004,
    visible: true,
    name: (0, $9TSwz.default).name,
    description: (0, $9TSwz.default).description,
    tabLabels: [
        (0, $9TSwz.default).chart,
        (0, $9TSwz.default).reviewAndAnalyze
    ],
    warningMessage: (0, $9TSwz.default).warning,
    exceededMessage: (0, $9TSwz.default).exceeded,
    risks: [
        (0, $9TSwz.default).risk1
    ],
    mitigations: [],
    currentValueLabel: (0, $9TSwz.default).currentValueLabel,
    currentValueAriaLabel: (0, $9TSwz.default).currentValueAriaLabel,
    thresholdValueLabel: (0, $9TSwz.default).thresholdValueLabel,
    thresholdValueAriaLabel: (0, $9TSwz.default).thresholdValueAriaLabel,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-custom-fields/',
    recommendationUrlText: (0, $9TSwz.default).recommendationUrlText,
    graphHeader: (0, $9TSwz.default).graphHeader,
    showTooltip: true
};

});

parcelRegister("cOrKR", function(module, exports) {

$parcel$export(module.exports, "ISSUE_KEY", () => $a0748d951ae09b9b$export$5daa28d10e23592);
$parcel$export(module.exports, "ISSUE", () => $a0748d951ae09b9b$export$76a449e52fa0e1e8);

var $jWT6h = parcelRequire("jWT6h");
const $a0748d951ae09b9b$export$5daa28d10e23592 = 'issue';
const $a0748d951ae09b9b$export$76a449e52fa0e1e8 = {
    key: $a0748d951ae09b9b$export$5daa28d10e23592,
    visible: true,
    name: (0, $jWT6h.default).name,
    description: (0, $jWT6h.default).description,
    tabLabels: [
        (0, $jWT6h.default).reviewAndAnalyze,
        (0, $jWT6h.default).activityLog
    ],
    warningMessage: (0, $jWT6h.default).warning,
    exceededMessage: (0, $jWT6h.default).exceeded,
    risks: [
        (0, $jWT6h.default).risk1
    ],
    mitigations: [
        (0, $jWT6h.default).mitigation1,
        (0, $jWT6h.default).mitigation2,
        (0, $jWT6h.default).mitigation3
    ],
    currentValueLabel: (0, $jWT6h.default).currentValueLabel,
    currentValueAriaLabel: (0, $jWT6h.default).currentValueAriaLabel,
    thresholdValueLabel: (0, $jWT6h.default).thresholdValueLabel,
    thresholdValueAriaLabel: (0, $jWT6h.default).thresholdValueAriaLabel,
    graphHeader: (0, $jWT6h.default).graphHeader
};

});
parcelRegister("jWT6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5991724b8695ea5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically. This duplication is OK.
const $a5991724b8695ea5$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $a5991724b8695ea5$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
const $a5991724b8695ea5$var$CHART_DESC = 'A tab label of Issue Tabs, to show Issue chart';
const $a5991724b8695ea5$var$REVIEW_AND_ANALYZE_DESC = 'A tab label of Issue Tabs, to show issue review and analyze';
const $a5991724b8695ea5$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $a5991724b8695ea5$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $a5991724b8695ea5$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
const $a5991724b8695ea5$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
const $a5991724b8695ea5$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $a5991724b8695ea5$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
const $a5991724b8695ea5$var$ACTIVITY_LOG_DESC = 'A tab label of Activity Log Tabs, to show Issue Archival past operations';
const $a5991724b8695ea5$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
var $a5991724b8695ea5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.issue.name",
        "defaultMessage": "Issues"
    },
    description: {
        "id": "admin-pages-performance.common.assets.issue.description",
        "defaultMessage": "Here\u2019s a quick snapshot of the total number of issues in your site, including some that we think can be archived. Archiving unused issues can improve performance and stability of your site."
    },
    chart: {
        "id": "admin-pages-performance.common.assets.issue.chart",
        "defaultMessage": "Overview"
    },
    reviewAndAnalyze: {
        "id": "admin-pages-performance.common.assets.issue.review-and-analyze",
        "defaultMessage": "Analysis"
    },
    activityLog: {
        "id": "admin-pages-performance.common.assets.issue.activity-log",
        "defaultMessage": "Activity log"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.issue.warning",
        "defaultMessage": "The number of issues in the system is nearing our recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.issue.exceeded",
        "defaultMessage": "There are more issues in the system than our recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.issue.risk-1",
        "defaultMessage": "If you have too many issues you may find searches, automations, and workflow rules are slower than usual."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-1",
        "defaultMessage": "Delete any projects that are no longer required."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-2",
        "defaultMessage": "Disable Jira integrations that create issues you don't need."
    },
    mitigation3: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-3",
        "defaultMessage": "Delete old issues that are no longer required. Use a JQL query to find issues older than a year (\u201Ccreated < -365d order by created DESC\u201C)."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.issue.current-value-label",
        "defaultMessage": "Total current issues in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-label",
        "defaultMessage": "Recommended maximum number of issues"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.issue.current-value-aria-label",
        "defaultMessage": "{number} total current issues in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of issues"
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.issue.graph-header",
        "defaultMessage": "Issues over time"
    },
    nameIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.name-issue-term-refresh",
        "defaultMessage": "Work items"
    },
    warningIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.warning-issue-term-refresh",
        "defaultMessage": "The number of work items in the system is nearing our recommended threshold."
    },
    exceededIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.exceeded-issue-term-refresh",
        "defaultMessage": "There are more work items in the system than our recommended threshold."
    },
    risk1IssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.risk-1-issue-term-refresh",
        "defaultMessage": "If you have too many work items you may find searches, automations, and workflow rules are slower than usual."
    },
    mitigation2IssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-2-issue-term-refresh",
        "defaultMessage": "Disable Jira integrations that create work items you don't need"
    },
    mitigation3IssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-3-issue-term-refresh",
        "defaultMessage": "Delete old work items that are no longer required. Use a JQL query to find work items older than a year (\u201Ccreated < -365d order by created DESC\u201C)."
    },
    currentValueLabelIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.current-value-label-issue-term-refresh",
        "defaultMessage": "Total current work items in your site"
    },
    thresholdValueLabelIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-label-issue-term-refresh",
        "defaultMessage": "Recommended maximum number of work items"
    },
    currentValueAriaLabelIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.current-value-aria-label-issue-term-refresh",
        "defaultMessage": "{number} total current work items in your site"
    },
    thresholdValueAriaLabelIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-aria-label-issue-term-refresh",
        "defaultMessage": "{number} recommended maximum number of work items"
    },
    graphHeaderIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.graph-header-issue-term-refresh",
        "defaultMessage": "Work items over time"
    }
});

});


parcelRegister("3AEMX", function(module, exports) {

$parcel$export(module.exports, "PROJECT_ROLE_ACTOR_KEY", () => $c7627c0e6530f4b1$export$a570ca3f6cc5e280);
$parcel$export(module.exports, "PROJECT_ROLE_ACTOR", () => $c7627c0e6530f4b1$export$fc3d2ee6c3fb3908);

var $j0D55 = parcelRequire("j0D55");
const $c7627c0e6530f4b1$export$a570ca3f6cc5e280 = 'projectroleactor';
const $c7627c0e6530f4b1$export$fc3d2ee6c3fb3908 = {
    key: $c7627c0e6530f4b1$export$a570ca3f6cc5e280,
    visible: true,
    name: (0, $j0D55.default).name,
    description: (0, $j0D55.default).description,
    tabLabels: [
        (0, $j0D55.default).analysis,
        (0, $j0D55.default).activityLog
    ],
    warningMessage: (0, $j0D55.default).warning,
    exceededMessage: (0, $j0D55.default).exceeded,
    risks: [
        (0, $j0D55.default).risk1
    ],
    mitigations: [
        (0, $j0D55.default).mitigation1,
        (0, $j0D55.default).mitigation2,
        (0, $j0D55.default).mitigation3
    ],
    currentValueLabel: (0, $j0D55.default).currentValueLabel,
    currentValueAriaLabel: (0, $j0D55.default).currentValueAriaLabel,
    thresholdValueLabel: (0, $j0D55.default).thresholdValueLabel,
    thresholdValueAriaLabel: (0, $j0D55.default).thresholdValueAriaLabel,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-number-of-project-role-memberships/',
    recommendationUrlText: (0, $j0D55.default).recommendationUrlText,
    graphHeader: (0, $j0D55.default).graphHeader
};

});
parcelRegister("j0D55", function(module, exports) {

$parcel$export(module.exports, "default", () => $6549fa32a8352dcb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically.
const $6549fa32a8352dcb$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $6549fa32a8352dcb$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
const $6549fa32a8352dcb$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $6549fa32a8352dcb$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $6549fa32a8352dcb$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
const $6549fa32a8352dcb$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
const $6549fa32a8352dcb$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $6549fa32a8352dcb$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
const $6549fa32a8352dcb$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
const $6549fa32a8352dcb$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
var $6549fa32a8352dcb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.project-role-actor.name",
        "defaultMessage": "Project role permissions"
    },
    description: {
        "id": "admin-pages-performance.common.assets.project-role-actor.description",
        "defaultMessage": "Here's a quick snapshot of the total number of project role permissions across your site."
    },
    analysis: {
        "id": "admin-pages-performance.common.assets.project-role-actor.analysis",
        "defaultMessage": "Analysis"
    },
    activityLog: {
        "id": "admin-pages-performance.common.assets.project-role-actor.activity-log",
        "defaultMessage": "Activity log"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.project-role-actor.warning",
        "defaultMessage": "Your number of project role memberships is nearing the recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.project-role-actor.exceeded",
        "defaultMessage": "Your number of project role memberships is over the recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.project-role-actor.risk-1",
        "defaultMessage": "When the number of project role memberships (users or groups) increases, viewing, searching, and creating issues becomes slower."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-1",
        "defaultMessage": "Remove users who no longer need access to your site rather than only suspending them. Suspending users removes their permission but not their project role membership."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-2",
        "defaultMessage": "Give memberships to groups of users instead of individual users. Granting membership to a group of 50 users count as 1 membership whereas granting memberships to 50 single users counts as 50 memberships."
    },
    mitigation3: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-3",
        "defaultMessage": "Use the default project role members in your permission scheme."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.current-value-label",
        "defaultMessage": "Current project role permissions in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-label",
        "defaultMessage": "Recommended maximum number of permissions"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.current-value-aria-label",
        "defaultMessage": "{number} current project role permissions in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of permissions"
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.project-role-actor.recommendation-url-text",
        "defaultMessage": "Learn more about optimizing your project role memberships."
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.project-role-actor.graph-header",
        "defaultMessage": "Project role permissions over time"
    }
});

});


parcelRegister("gtb9f", function(module, exports) {

$parcel$export(module.exports, "METRICS", () => $713364f722667f6e$export$3f0e99ae6e0ec541);
$parcel$export(module.exports, "RUN_ANALYSIS", () => $713364f722667f6e$export$769b1a9477352cf9);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS", () => $713364f722667f6e$export$e7e31b14c32e055a);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_DROPDOWN", () => $713364f722667f6e$export$d96fe00ff2b38bae);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CONFIRM", () => $713364f722667f6e$export$3d4bb5f187c6844e);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CANCEL", () => $713364f722667f6e$export$5c1079e323f5d5bd);
$parcel$export(module.exports, "TAB_CLICKED", () => $713364f722667f6e$export$d358fc12daa9f606);
$parcel$export(module.exports, "RECOMMENDATIONS_LOADED", () => $713364f722667f6e$export$60cc0c61c99a5b81);
$parcel$export(module.exports, "METRIC_CARD_CLICKED", () => $713364f722667f6e$export$71794f4d197278dc);
$parcel$export(module.exports, "PROJECT_ROLE_ACTOR_FILTER_BY_PROJECT", () => $713364f722667f6e$export$9e34afbf86922b4a);
$parcel$export(module.exports, "projectRoleActorAttributes", () => $713364f722667f6e$export$d6761557c91eea50);
$parcel$export(module.exports, "ARCHIVE_ISSUES_CONFIRM", () => $713364f722667f6e$export$4e4b9391f7936ba2);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES", () => $713364f722667f6e$export$70525d18051240f4);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_CANCEL", () => $713364f722667f6e$export$4951e0e034b50b9c);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_TRY_AGAIN", () => $713364f722667f6e$export$108288df7758f60c);
$parcel$export(module.exports, "VIEW_ISSUES", () => $713364f722667f6e$export$972d5a8da0d9f4c3);
$parcel$export(module.exports, "STOP_ISSUE_ARCHIVAL", () => $713364f722667f6e$export$b920363d50bcf753);
$parcel$export(module.exports, "ISSUE_UNARCHIVAL_COMPLETED", () => $713364f722667f6e$export$a84a5210fbad774);
$parcel$export(module.exports, "JQL_SEARCH", () => $713364f722667f6e$export$5c2df36fdd8476f7);
$parcel$export(module.exports, "DEFAULT_QUERY_SELECTED", () => $713364f722667f6e$export$77f23f1b921d5321);
$parcel$export(module.exports, "issueAnalyticsAttributes", () => $713364f722667f6e$export$c62a52f3f7d80ec3);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH", () => $713364f722667f6e$export$8daffc99348bf555);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CONFIRM", () => $713364f722667f6e$export$20f13a04bc3e5d74);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CANCEL", () => $713364f722667f6e$export$ed285e0e924b673c);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_SUCCEEDED", () => $713364f722667f6e$export$26f5d7eae10db511);
$parcel$export(module.exports, "customFieldAttributes", () => $713364f722667f6e$export$33989f74b6ba0674);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_STARTED", () => $713364f722667f6e$export$d39b24a650c6c79d);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_DISMISSED", () => $713364f722667f6e$export$eca4028936acf763);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_COMPLETED", () => $713364f722667f6e$export$9ba0a5caedb0ff37);
$parcel$export(module.exports, "RESTORE_ACTIVITY_LOG", () => $713364f722667f6e$export$7b6bf63452d40db8);
$parcel$export(module.exports, "DOWNLOAD_CSV", () => $713364f722667f6e$export$efdb93c7210090d1);
$parcel$export(module.exports, "PROJECT_CLEANUP_FILTERS_CLEARED", () => $713364f722667f6e$export$6c650be5c2b4774f);
$parcel$export(module.exports, "PROJECT_CLEANUP_FILTER_BY_PROJECT", () => $713364f722667f6e$export$6493dd0e190d3f58);
$parcel$export(module.exports, "PROJECT_CLEANUP_FILTER_BY_STALE", () => $713364f722667f6e$export$422673ba1cec4aed);
$parcel$export(module.exports, "PROJECT_CLEAN_UP", () => $713364f722667f6e$export$3a7186fc63c9e188);
$parcel$export(module.exports, "PROJECT_CLEANUP_COMPLETED", () => $713364f722667f6e$export$8e0b8859a3cbd9e6);
$parcel$export(module.exports, "ACTION_TRASH", () => $713364f722667f6e$export$342d8b9804e407c7);
$parcel$export(module.exports, "ACTION_ARCHIVE", () => $713364f722667f6e$export$b685f2109baf2b4f);
$parcel$export(module.exports, "ACTION_UNARCHIVE", () => $713364f722667f6e$export$3ac60b381ed426ca);

var $8MHQY = parcelRequire("8MHQY");

var $cOrKR = parcelRequire("cOrKR");

var $lzUDm = parcelRequire("lzUDm");

var $3AEMX = parcelRequire("3AEMX");
const $713364f722667f6e$export$3f0e99ae6e0ec541 = [
    // Inclusion of issues in metrics is dependent on improving mitigation strategies for issues.
    // Inclusion of issue links in metrics is dependent on improving mitigation strategies for issue links.
    // ISSUE_LINKS,
    // CUSTOM_FIELD_OPTIONS,
    (0, $8MHQY.CUSTOM_FIELDS),
    (0, $cOrKR.ISSUE),
    (0, $3AEMX.PROJECT_ROLE_ACTOR),
    // Inclusion of file attachments in metrics is dependent on improving mitigation strategies for file attachments.
    // FILE_ATTACHMENTS,
    (0, $lzUDm.PROJECT_CLEANUP)
];
const $713364f722667f6e$export$769b1a9477352cf9 = 'runAnalysis';
const $713364f722667f6e$export$e7e31b14c32e055a = 'deleteRecommendations';
const $713364f722667f6e$export$d96fe00ff2b38bae = 'deleteRecommendationsDropdown';
const $713364f722667f6e$export$3d4bb5f187c6844e = 'deleteRecommendationsConfirm';
const $713364f722667f6e$export$5c1079e323f5d5bd = 'deleteRecommendationsCancel';
const $713364f722667f6e$export$d358fc12daa9f606 = 'psiTab';
const $713364f722667f6e$export$60cc0c61c99a5b81 = 'recommendations loaded';
const $713364f722667f6e$export$71794f4d197278dc = 'mitigationMetricCard';
const $713364f722667f6e$export$9e34afbf86922b4a = 'projectRoleActorFilterByProject';
const $713364f722667f6e$export$d6761557c91eea50 = {
    metric: (0, $3AEMX.PROJECT_ROLE_ACTOR_KEY)
};
const $713364f722667f6e$export$4e4b9391f7936ba2 = 'archiveIssuesConfirm';
const $713364f722667f6e$export$70525d18051240f4 = 'restoreIssueArchival';
const $713364f722667f6e$export$4951e0e034b50b9c = 'restoreIssueCancel';
const $713364f722667f6e$export$108288df7758f60c = 'restoreIssueTryAgain';
const $713364f722667f6e$export$972d5a8da0d9f4c3 = 'viewIssues';
const $713364f722667f6e$export$b920363d50bcf753 = 'stopIssueArchival';
const $713364f722667f6e$export$a84a5210fbad774 = 'restoreIssueArchival completed';
const $713364f722667f6e$export$5c2df36fdd8476f7 = 'jqlSearch';
const $713364f722667f6e$export$77f23f1b921d5321 = 'defaultQuerySelected';
const $713364f722667f6e$export$c62a52f3f7d80ec3 = {
    metric: (0, $cOrKR.ISSUE_KEY)
};
const $713364f722667f6e$export$8daffc99348bf555 = 'customFieldMoveToTrash';
const $713364f722667f6e$export$20f13a04bc3e5d74 = 'customFieldMoveToTrashConfirm';
const $713364f722667f6e$export$ed285e0e924b673c = 'customFieldMoveToTrashCancel';
const $713364f722667f6e$export$26f5d7eae10db511 = 'customFieldMoveToTrash succeeded';
const $713364f722667f6e$export$33989f74b6ba0674 = {
    metric: (0, $8MHQY.CUSTOM_FIELDS).key
};
const $713364f722667f6e$export$d39b24a650c6c79d = 'metricPerformanceSpotlight started';
const $713364f722667f6e$export$eca4028936acf763 = 'metricPerformanceSpotlightDismissed';
const $713364f722667f6e$export$9ba0a5caedb0ff37 = 'metricPerformanceSpotlight completed';
const $713364f722667f6e$export$7b6bf63452d40db8 = 'restoreActivityLog';
const $713364f722667f6e$export$efdb93c7210090d1 = 'downloadActivityLogCsv';
const $713364f722667f6e$export$6c650be5c2b4774f = 'projectCleanupFiltersCleared';
const $713364f722667f6e$export$6493dd0e190d3f58 = 'projectCleanupFilterByProjectState';
const $713364f722667f6e$export$422673ba1cec4aed = 'projectCleanupFilterByStale';
const $713364f722667f6e$export$3a7186fc63c9e188 = 'projectCleanUp';
const $713364f722667f6e$export$8e0b8859a3cbd9e6 = 'projectCleanup completed';
const $713364f722667f6e$export$342d8b9804e407c7 = 'TRASH';
const $713364f722667f6e$export$b685f2109baf2b4f = 'ARCHIVE';
const $713364f722667f6e$export$3ac60b381ed426ca = 'UNARCHIVE';

});


parcelRegister("etuUp", function(module, exports) {

$parcel$export(module.exports, "default", () => $df7d950b94f108ee$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $df7d950b94f108ee$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.title",
        "defaultMessage": "Site optimizer"
    },
    overview: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.overview",
        "defaultMessage": "Overview"
    },
    allReports: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.all-reports",
        "defaultMessage": "All reports"
    }
});

});

parcelRegister("jWIOc", function(module, exports) {

$parcel$export(module.exports, "PROJECT_CLEANUP_SPOTLIGHT_NAME", () => $fa0cf627da3f1f38$export$4150c6a7c9be0102);
$parcel$export(module.exports, "ProjectCleanupSpotlight", () => $fa0cf627da3f1f38$export$6dc8afd0c00f9525);

var $5uXOq = parcelRequire("5uXOq");

var $98UVV = parcelRequire("98UVV");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $k43Y2 = parcelRequire("k43Y2");

var $8881D = parcelRequire("8881D");
const $fa0cf627da3f1f38$export$4150c6a7c9be0102 = 'site-optimiser-project-cleanup-spotlight-nav';
const $fa0cf627da3f1f38$export$6dc8afd0c00f9525 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] = (0, $k43Y2.useProjectCleanupSpotlight)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $98UVV.default), null, isProjectCleanupSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                onClick: ()=>setIsProjectCleanupSpotlightActive(false),
                text: formatMessage((0, $8881D.default).spotlightAction)
            }
        ],
        heading: formatMessage((0, $8881D.default).spotlightHeading),
        target: $fa0cf627da3f1f38$export$4150c6a7c9be0102,
        key: $fa0cf627da3f1f38$export$4150c6a7c9be0102,
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        dialogPlacement: "right top",
        messageId: "navigation-apps-sidebar-global-settings-system.ui.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.jira-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $8881D.default).spotlightDescription)));
});

});
parcelRegister("k43Y2", function(module, exports) {

$parcel$export(module.exports, "useProjectCleanupSpotlight", () => $249ebdaf0c0fc22c$export$780bcf6e3ebf2d12);

var $5uXOq = parcelRequire("5uXOq");

var $iyJxC = parcelRequire("iyJxC");

var $90yGq = parcelRequire("90yGq");
// Ensure this key matches the key in the old nav in navigation-apps/sidebar package
const $249ebdaf0c0fc22c$var$PROPERTY_KEY = 'jira.user.settings.system.project-cleanup-onboarding-spotlight';
const $249ebdaf0c0fc22c$export$780bcf6e3ebf2d12 = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    const [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] = (0, $5uXOq.useState)(false);
    const getHasSeenProjectCleanupSpotlight = async (id)=>{
        const response = await (0, $iyJxC.getUserProperty)({
            accountId: id,
            propertyKey: $249ebdaf0c0fc22c$var$PROPERTY_KEY,
            defaultValue: false
        });
        // If they have not seen the spotlight, return true and mark as shown
        if (!response.value) {
            await (0, $iyJxC.setUserProperty)({
                accountId: id,
                propertyKey: $249ebdaf0c0fc22c$var$PROPERTY_KEY,
                propertyValue: true
            });
            return false;
        }
        return true;
    };
    const fetchSpotlightState = (0, $5uXOq.useCallback)(async ()=>{
        if (accountId !== null) {
            const response = await getHasSeenProjectCleanupSpotlight(accountId);
            setIsProjectCleanupSpotlightActive(!response);
        }
    }, [
        accountId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchSpotlightState();
    }, [
        fetchSpotlightState
    ]);
    return [
        isProjectCleanupSpotlightActive,
        setIsProjectCleanupSpotlightActive
    ];
};

});
parcelRegister("iyJxC", function(module, exports) {

$parcel$export(module.exports, "getUserProperty", () => $5455121d227e33bb$export$b3126db2ef6e34ed);
$parcel$export(module.exports, "setUserProperty", () => $5455121d227e33bb$export$ba821ce5e177c7ef);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $5455121d227e33bb$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $5455121d227e33bb$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $5455121d227e33bb$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await fetch(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // The API deliberately returns 404 if user property is not found - we will return default value
        if (response.status === 404) return {
            key: propertyKey,
            value: defaultValue
        };
        if (response.ok) return await response.json();
        throw new Error(`Fetching ${propertyKey} user property failed.`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getUserProperty',
                packageName: 'jiraAdminPagesPerformance',
                teamName: 'cherenkov'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};
const $5455121d227e33bb$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $5455121d227e33bb$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $eusud.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'setUserProperty',
                packageName: 'jiraAdminPagesPerformance',
                teamName: 'cherenkov'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});


parcelRegister("8881D", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d0877c08ff02be$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $86d0877c08ff02be$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    spotlightHeading: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-heading",
        "defaultMessage": "Clean out unused projects"
    },
    spotlightDescription: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-description",
        "defaultMessage": "Quickly remove inactive or empty projects to improve your site\u2019s performance. "
    },
    spotlightAction: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-action",
        "defaultMessage": "Ok"
    }
});

});



parcelRegister("fM231", function(module, exports) {

$parcel$export(module.exports, "hasSeenSiteOptimiserSpotlight", () => $879944d685aae4de$export$3ed4e8541d8ba40);

var $iyJxC = parcelRequire("iyJxC");
const $879944d685aae4de$var$PROPERTY_KEY = 'jira.user.settings.system.site-optimizer-spotlight';
const $879944d685aae4de$export$3ed4e8541d8ba40 = async (accountId)=>{
    const response = await (0, $iyJxC.getUserProperty)({
        accountId: accountId,
        propertyKey: $879944d685aae4de$var$PROPERTY_KEY,
        defaultValue: false
    });
    // If they have not seen the spotlight, return true and mark as shown
    if (!response.value) {
        await (0, $iyJxC.setUserProperty)({
            accountId: accountId,
            propertyKey: $879944d685aae4de$var$PROPERTY_KEY,
            propertyValue: true
        });
        return false;
    }
    return true;
};

});


parcelRegister("ie4oV", function(module, exports) {

$parcel$export(module.exports, "isViewAuditingSelected", () => $84aa4044b145a05a$export$6da8ca04904513f9);

var $4OCke = parcelRequire("4OCke");
const $84aa4044b145a05a$var$VIEW_AUDITING_PATH_REGEXP = /\/auditing\/(\w+)/i;
const $84aa4044b145a05a$export$6da8ca04904513f9 = (currentLocation, itemLocation)=>(0, $4OCke.matchUrlExact)()(currentLocation, itemLocation) || $84aa4044b145a05a$var$VIEW_AUDITING_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("71ORT", function(module, exports) {

$parcel$export(module.exports, "UserInterfaceSection", () => $4dae17d9419cb38f$export$c4128359313d3f58);

var $5uXOq = parcelRequire("5uXOq");

var $kxnYb = parcelRequire("kxnYb");
var $9K9UK = parcelRequire("9K9UK");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $itmJb = parcelRequire("itmJb");

var $jMBA3 = parcelRequire("jMBA3");

var $jDUf4 = parcelRequire("jDUf4");
const $4dae17d9419cb38f$export$c4128359313d3f58 = ()=>{
    const isJiraAdmin = (0, $itmJb.useIsAdmin)();
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        title: formatMessage((0, $jDUf4.default).userInterface)
    }, features.hasUserDefaults && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'user-defaults'
        },
        href: navigationPath.userInterfacesUserDefaults,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $jDUf4.default).userDefaults)), features.hasEditDefaultDashboard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'edit-default-dashboard'
        },
        href: navigationPath.userInterfacesEditDefaultDashboard,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $jDUf4.default).systemDashboard)), features.hasLookAndFeel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'look-and-feel'
        },
        href: navigationPath.userInterfacesLookAndFeel,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $jDUf4.default).lookAndFeel)), features.hasPasAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'pas-admin-link-jira'
        },
        href: navigationPath.userInterfacesPasAdmin,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $jDUf4.default).pasAdmin)), isJiraAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'announcement-banner'
        },
        href: navigationPath.userInterfacesSiteAdmin,
        selectedOn: [
            'global-settings-system-ui-announcement-banner'
        ]
    }, formatMessage((0, $jDUf4.default).announcementBanner)));
};

});
parcelRegister("itmJb", function(module, exports) {

$parcel$export(module.exports, "useIsAdmin", () => $dfb6d33a8a8c98ed$export$99a5e4bc80d231ca);

var $9OXo1 = parcelRequire("9OXo1");
const $dfb6d33a8a8c98ed$export$99a5e4bc80d231ca = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isAdmin || false;
};

});

parcelRegister("jDUf4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f12d9a643fcf4ed$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6f12d9a643fcf4ed$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    userInterface: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-interface",
        "defaultMessage": "User Interface"
    },
    userDefaults: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-defaults",
        "defaultMessage": "Default user preferences"
    },
    systemDashboard: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.system-dashboard",
        "defaultMessage": "Default dashboard"
    },
    lookAndFeel: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.look-and-feel",
        "defaultMessage": "Look and feel"
    },
    pasAdmin: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.pas-admin",
        "defaultMessage": "Public Announcement Service"
    },
    announcementBanner: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.announcement-banner",
        "defaultMessage": "Announcement banner"
    }
});

});


parcelRegister("3jrxv", function(module, exports) {

$parcel$export(module.exports, "isGeneralConfigurationSelected", () => $e6139421bb00cae6$export$ba31cfa97c56eefd);

var $4OCke = parcelRequire("4OCke");
const $e6139421bb00cae6$var$APPLICATION_PROPERTIES_PATH_REGEXP = /\/admin\/(\w+)ApplicationProperties/i;
const $e6139421bb00cae6$export$ba31cfa97c56eefd = (currentLocation, itemLocation)=>(0, $4OCke.matchUrlExact)()(currentLocation, itemLocation) || $e6139421bb00cae6$var$APPLICATION_PROPERTIES_PATH_REGEXP.test(currentLocation.pathname);

});



parcelRegister("gRmqY", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemBulkMailRoute", () => $47674b1aa9d0fa81$export$2b269dcf51f5a4d3);
const $47674b1aa9d0fa81$export$2b269dcf51f5a4d3 = {
    name: 'global-settings-system-bulk-mail',
    path: '/jira/settings/system/send-email'
};

});

parcelRegister("5FGTk", function(module, exports) {

$parcel$export(module.exports, "LazyBulkEmail", () => $0240d4f2c2b35825$export$416f8039fbf50bea);
$parcel$export(module.exports, "default", () => $0240d4f2c2b35825$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $0240d4f2c2b35825$export$416f8039fbf50bea = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("bvoCK"))), {
    moduleId: "./src/packages/admin-pages/bulk-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0240d4f2c2b35825$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0240d4f2c2b35825$export$416f8039fbf50bea,
        pageId: "jira-admin-pages-bulk-email",
        shouldShowSpinner: true
    });

});
parcelRegister("bvoCK", function(module, exports) {

let $8605b0c90f1b82a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8605b0c90f1b82a1$var$load("h9UUp").then(()=>parcelRequire('8Z6uP'));

});



parcelRegister("ktEDA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldRouteEntry", () => $082dced0cf5c2e43$export$8cc68908e4ed5a16);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $b51sv = parcelRequire("b51sv");

var $6kCEi = parcelRequire("6kCEi");
const $082dced0cf5c2e43$export$8cc68908e4ed5a16 = (0, $7NszV.createEntry)((0, $b51sv.globalSettingsPerformanceCustomFieldRoute), ()=>({
        group: 'global-settings',
        component: (0, $6kCEi.CustomFieldMetricDetail),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6kCEi.LazyCustomFieldDetail)
        ]
    }));

});
parcelRegister("b51sv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldRoute", () => $43a348db022c66e4$export$198b0dea5bcb104d);
const $43a348db022c66e4$export$198b0dea5bcb104d = {
    name: 'global-settings-performance-custom-field',
    path: '/jira/settings/system/performance/metrics/customfield'
};

});

parcelRegister("6kCEi", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldDetail", () => $416b07e85e5902e2$export$d323aa888b5be0c2);
$parcel$export(module.exports, "CustomFieldMetricDetail", () => $416b07e85e5902e2$export$446bf9be075b3cb);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $416b07e85e5902e2$export$d323aa888b5be0c2 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4Yy5q"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-custom-field/src/index.tsx"
});
const $416b07e85e5902e2$export$446bf9be075b3cb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $416b07e85e5902e2$export$d323aa888b5be0c2,
        pageId: "system-performance-metric-detail-custom-field",
        shouldShowSpinner: true
    });

});
parcelRegister("4Yy5q", function(module, exports) {

let $39f734e84d36709a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $39f734e84d36709a$var$load("h2MrD"),
    $39f734e84d36709a$var$load("bYT2S"),
    $39f734e84d36709a$var$load("cM9em"),
    $39f734e84d36709a$var$load("fr9NE"),
    $39f734e84d36709a$var$load("dsiAd"),
    $39f734e84d36709a$var$load("kZEdw")
]).then(()=>parcelRequire('PZuxA'));

});



parcelRegister("caoz4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceIssueArchivalRouteEntry", () => $bf0d17e8163c3686$export$6f8a930d1f2f4103);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $46SKm = parcelRequire("46SKm");

var $2vX6Y = parcelRequire("2vX6Y");
const $bf0d17e8163c3686$export$6f8a930d1f2f4103 = (0, $7NszV.createEntry)((0, $46SKm.globalSettingsPerformanceIssueArchivalRoute), ()=>({
        group: 'global-settings',
        component: (0, $2vX6Y.IssueMetricDetail),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2vX6Y.LazyIssueDetail)
        ]
    }));

});
parcelRegister("46SKm", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceIssueArchivalRoute", () => $cad08cbdd7ac177a$export$a615b79ae9fb06e5);
const $cad08cbdd7ac177a$export$a615b79ae9fb06e5 = {
    name: 'global-settings-performance-issue',
    path: '/jira/settings/system/performance/metrics/issue'
};

});

parcelRegister("2vX6Y", function(module, exports) {

$parcel$export(module.exports, "LazyIssueDetail", () => $cc878f5a65037830$export$e44cbefb7c57e031);
$parcel$export(module.exports, "IssueMetricDetail", () => $cc878f5a65037830$export$30b22d5292fcd86f);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $cc878f5a65037830$export$e44cbefb7c57e031 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hVk9B"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-issue/src/index.tsx"
});
const $cc878f5a65037830$export$30b22d5292fcd86f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cc878f5a65037830$export$e44cbefb7c57e031,
        pageId: "system-performance-metric-detail-issue",
        shouldShowSpinner: true
    });

});
parcelRegister("hVk9B", function(module, exports) {

let $d0c764ac818cfb46$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d0c764ac818cfb46$var$load("h2MrD"),
    $d0c764ac818cfb46$var$load("bYT2S"),
    $d0c764ac818cfb46$var$load("cM9em"),
    $d0c764ac818cfb46$var$load("fr9NE"),
    $d0c764ac818cfb46$var$load("dsiAd"),
    $d0c764ac818cfb46$var$load("kbq0s")
]).then(()=>parcelRequire('9HctW'));

});



parcelRegister("5BlCA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceMetricDetailRouteEntry", () => $233fa7d3de1e95a8$export$4b547a5bd165bd83);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $vq7VV = parcelRequire("vq7VV");

var $gq1Xn = parcelRequire("gq1Xn");
const $233fa7d3de1e95a8$export$4b547a5bd165bd83 = (0, $7NszV.createEntry)((0, $vq7VV.globalSettingsPerformanceMetricDetailRoute), ()=>({
        group: 'global-settings',
        component: (0, $gq1Xn.RedirectToExactMetricRoutes),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("vq7VV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceMetricDetailRoute", () => $cd34eae2613f8100$export$d4f7a24791f8b506);
const $cd34eae2613f8100$export$d4f7a24791f8b506 = {
    name: 'global-settings-performance-metric-detail',
    path: '/jira/settings/system/performance/metric/:metricKey'
};

});

parcelRegister("gq1Xn", function(module, exports) {

$parcel$export(module.exports, "RedirectToExactMetricRoutes", () => $a9257ec476fbe8e1$export$dda90f06f8afe9ec);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $8zOmE = parcelRequire("8zOmE");

var $ds5qV = parcelRequire("ds5qV");

var $doZTA = parcelRequire("doZTA");
const $a9257ec476fbe8e1$export$dda90f06f8afe9ec = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // If we have a metric key in the URL, we know the user has accessed the old route
        // and we should fire an operational analytics event.
        // Once the frequency of this event is 0, we can consider removing the redirect.
        if (match?.params?.metricKey) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'old-metric-detail-route visited', {
            metricKey: match.params.metricKey
        });
    }, [
        match?.params?.metricKey,
        createAnalyticsEvent
    ]);
    if (match == null || match.params == null || match.params.metricKey == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/settings/system/performance/overview"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/settings/system/performance/metrics/${match.params.metricKey}`
    });
};

});


parcelRegister("3Hflx", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceOverviewRouteEntry", () => $13d7b69aa99de9b5$export$6f957aade53e2c17);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $clE6J = parcelRequire("clE6J");

var $btX5r = parcelRequire("btX5r");

var $408O8 = parcelRequire("408O8");
const $13d7b69aa99de9b5$export$6f957aade53e2c17 = (0, $7NszV.createEntry)((0, $btX5r.globalSettingsPerformanceOverviewRoute), ()=>({
        group: 'global-settings',
        component: (0, $408O8.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $clE6J.metricsOverviewPageResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $408O8.LazyOverview)
        ]
    }));

});
parcelRegister("clE6J", function(module, exports) {

$parcel$export(module.exports, "metricsOverviewPageResource", () => $624fad9c7a7951b4$export$ac0b4ef4ec4987ae);

var $4R6GH = parcelRequire("4R6GH");

var $ao2h1 = parcelRequire("ao2h1");

var $hOOQr = parcelRequire("hOOQr");
const $624fad9c7a7951b4$export$ac0b4ef4ec4987ae = (0, $ao2h1.createRelayResource)({
    type: 'ADMIN_PAGES_PERFORMANCE_OVERVIEW',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $hOOQr.default),
            variables: {
                cloudId: tenantContext.cloudId,
                schemaMigrationEnabled: (0, $4R6GH.fg)('site_optimiser_schema_migration')
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("hOOQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $69a9f121a9ac63a8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<669304670c931d09af8646f09ee71460>>
 * @relayHash 3b0412c013eb910bffa938b54599e765
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 589c5cc207a17b7fcd72acde1a46f074a3ac0a2e82da10793f61efb4fb0a786e
const $69a9f121a9ac63a8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "schemaMigrationEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "currentValue"
    }, v4 = {
        "kind": "ScalarField",
        "name": "warningValue"
    }, v5 = {
        "kind": "ScalarField",
        "name": "thresholdValue"
    }, v6 = {
        "kind": "ScalarField",
        "name": "cleanupValue"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_adminPagesPerformance_Overview_Query",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "schemaMigrationEnabled",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v1 /*: any*/ ,
                                            "concreteType": "JiraResourceUsageMetricConnection",
                                            "kind": "LinkedField",
                                            "name": "resourceUsageMetrics",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "main_adminPagesPerformance_OverviewPage"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.resourceUsageMetrics"
                                    }
                                ]
                            },
                            {
                                "condition": "schemaMigrationEnabled",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v1 /*: any*/ ,
                                            "concreteType": "JiraResourceUsageMetricConnectionV2",
                                            "kind": "LinkedField",
                                            "name": "resourceUsageMetricsV2",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "main_adminPagesPerformance_OverviewPageV2"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.resourceUsageMetricsV2"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_adminPagesPerformance_Overview_Query",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "schemaMigrationEnabled",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraResourceUsageMetricConnection",
                                    "kind": "LinkedField",
                                    "name": "resourceUsageMetrics",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraResourceUsageMetric",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "schemaMigrationEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraResourceUsageMetricConnectionV2",
                                    "kind": "LinkedField",
                                    "name": "resourceUsageMetricsV2",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "589c5cc207a17b7fcd72acde1a46f074a3ac0a2e82da10793f61efb4fb0a786e",
            "metadata": {},
            "name": "main_adminPagesPerformance_Overview_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$69a9f121a9ac63a8$var$node.hash = "f41d000bf8612aeb0ad7a3bfa4b9b2cb";
var $69a9f121a9ac63a8$export$2e2bcd8739ae039 = $69a9f121a9ac63a8$var$node;

});


parcelRegister("btX5r", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceOverviewRoute", () => $895fc96119706708$export$677fc3a2086479d2);
const $895fc96119706708$export$677fc3a2086479d2 = {
    name: 'global-settings-performance-overview',
    path: '/jira/settings/system/performance/overview'
};

});

parcelRegister("408O8", function(module, exports) {

$parcel$export(module.exports, "LazyOverview", () => $53afac4f83d10b4d$export$17b4d4eaede5f445);
$parcel$export(module.exports, "default", () => $53afac4f83d10b4d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $53afac4f83d10b4d$export$17b4d4eaede5f445 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("bvIsL"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/overview/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$53afac4f83d10b4d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $53afac4f83d10b4d$export$17b4d4eaede5f445,
        pageId: "system-performance-overview",
        shouldShowSpinner: true
    });

});
parcelRegister("bvIsL", function(module, exports) {

let $861514645580caff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $861514645580caff$var$load("8auDC").then(()=>parcelRequire('aJlr3'));

});



parcelRegister("bUOZo", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceProjectCleanupRouteEntry", () => $5db1194ddce6c383$export$7048705fd224d040);

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $66tAT = parcelRequire("66tAT");

var $5lsNZ = parcelRequire("5lsNZ");

var $kxXsG = parcelRequire("kxXsG");
const $5db1194ddce6c383$export$7048705fd224d040 = (0, $7NszV.createEntry)((0, $66tAT.globalSettingsPerformanceProjectCleanupRoute), ()=>({
        group: 'global-settings',
        // On FF cleanup of site-optimizer-project-cleanup replace with ProjectCleanupMetricDetail
        component: (0, $cSD7y.componentWithFG)('site-optimizer-project-cleanup', (0, $kxXsG.ProjectCleanupMetricDetail), (0, $5lsNZ.default)),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kxXsG.LazyProjectCleanupDetail)
        ]
    }));

});
parcelRegister("66tAT", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceProjectCleanupRoute", () => $2cfd8d591a3d3df9$export$c0d3487a9dc79ff3);
const $2cfd8d591a3d3df9$export$c0d3487a9dc79ff3 = {
    name: 'global-settings-performance-project-cleanup',
    path: '/jira/settings/system/performance/metrics/projectCleanup'
};

});

parcelRegister("kxXsG", function(module, exports) {

$parcel$export(module.exports, "LazyProjectCleanupDetail", () => $a4333be24d8fdde0$export$a02cb3bfa11d0dc0);
$parcel$export(module.exports, "ProjectCleanupMetricDetail", () => $a4333be24d8fdde0$export$2adb5abd6651c182);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $a4333be24d8fdde0$export$a02cb3bfa11d0dc0 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("k8ki4"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-cleanup/src/index.tsx"
});
const $a4333be24d8fdde0$export$2adb5abd6651c182 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a4333be24d8fdde0$export$a02cb3bfa11d0dc0,
        pageId: "system-performance-metric-detail-project-cleanup",
        shouldShowSpinner: true
    });

});
parcelRegister("k8ki4", function(module, exports) {

let $ea844b48bf11015e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ea844b48bf11015e$var$load("h2MrD"),
    $ea844b48bf11015e$var$load("bYT2S"),
    $ea844b48bf11015e$var$load("cM9em"),
    $ea844b48bf11015e$var$load("fr9NE"),
    $ea844b48bf11015e$var$load("dsiAd"),
    $ea844b48bf11015e$var$load("7gdHv")
]).then(()=>parcelRequire('fJoHG'));

});



parcelRegister("bC98V", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceProjectRoleActorRouteEntry", () => $b0ecc0767e5528eb$export$a37cab737d8b474a);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $lG365 = parcelRequire("lG365");

var $7BrHr = parcelRequire("7BrHr");
const $b0ecc0767e5528eb$export$a37cab737d8b474a = (0, $7NszV.createEntry)((0, $lG365.globalSettingsPerformanceProjectRoleActorRoute), ()=>({
        group: 'global-settings',
        component: (0, $7BrHr.ProjectRoleActorMetricDetail),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7BrHr.LazyProjectRoleActorDetail)
        ]
    }));

});
parcelRegister("lG365", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceProjectRoleActorRoute", () => $a0135d88210046c6$export$c81695f590e65a42);
const $a0135d88210046c6$export$c81695f590e65a42 = {
    name: 'global-settings-performance-project-role-actor',
    path: '/jira/settings/system/performance/metrics/projectroleactor'
};

});

parcelRegister("7BrHr", function(module, exports) {

$parcel$export(module.exports, "LazyProjectRoleActorDetail", () => $e00517ee35b4ce44$export$41ecfa31d3d81e1c);
$parcel$export(module.exports, "ProjectRoleActorMetricDetail", () => $e00517ee35b4ce44$export$3c58376b89706313);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $e00517ee35b4ce44$export$41ecfa31d3d81e1c = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cB6cW"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-role-actor/src/index.tsx"
});
const $e00517ee35b4ce44$export$3c58376b89706313 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e00517ee35b4ce44$export$41ecfa31d3d81e1c,
        pageId: "system-performance-metric-detail-project-role-actor",
        shouldShowSpinner: true
    });

});
parcelRegister("cB6cW", function(module, exports) {

let $92bdc17c280a40f6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $92bdc17c280a40f6$var$load("h2MrD"),
    $92bdc17c280a40f6$var$load("bYT2S"),
    $92bdc17c280a40f6$var$load("cM9em"),
    $92bdc17c280a40f6$var$load("fr9NE"),
    $92bdc17c280a40f6$var$load("dsiAd"),
    $92bdc17c280a40f6$var$load("7u0xh")
]).then(()=>parcelRequire('eQgAh'));

});



parcelRegister("1mByb", function(module, exports) {

$parcel$export(module.exports, "globalSettingsEditPermissionSchemesRouteEntry", () => $28d525b59d36751f$export$25dca167915e813c);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $1Sn7L = parcelRequire("1Sn7L");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $j15ln = parcelRequire("j15ln");

var $aVbhY = parcelRequire("aVbhY");
const $28d525b59d36751f$export$25dca167915e813c = (0, $7NszV.createEntry)((0, $j15ln.globalSettingsEditPermissionSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.configure-permission-scheme',
        component: (0, $aVbhY.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $1Sn7L.editPermissionSchemePageResource)
        ],
        canTransitionIn: ()=>true,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aVbhY.LazyEditPermissionSchemePage)
        ],
        meta: {
            reporting: {
                id: 'EditPermissionScheme',
                packageName: 'jiraAdminPagesEditPermissionScheme',
                teamName: 'gordian'
            }
        }
    }));

});
parcelRegister("1Sn7L", function(module, exports) {

$parcel$export(module.exports, "editPermissionSchemePageResource", () => $c133ac01577799ff$export$2b6bb2f543863b53);

var $ao2h1 = parcelRequire("ao2h1");

var $eZzoq = parcelRequire("eZzoq");
const $c133ac01577799ff$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE = 'EDIT_PERMISSION_SCHEME_PAGE';
const $c133ac01577799ff$export$2b6bb2f543863b53 = (0, $ao2h1.createRelayResource)({
    type: $c133ac01577799ff$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $eZzoq.default),
            variables: {
                // To Do: use ari-typescript library once it is approved
                // https://hello.atlassian.net/wiki/spaces/TGR/pages/1374189554/Dependency+review+atlassian+ari
                schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`,
                first: 50
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("eZzoq", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d709337e778f61$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e6d2609b22da674852d0d8a556caee0>>
 * @relayHash a8302edc7839549073bdffce737596f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c97cc5e281ea579c44e87ac7f80e5f399b27b3ac304b7267d4210b282a7a4b1
const $95d709337e778f61$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "schemeId"
    }, v2 = {
        "kind": "Variable",
        "name": "schemeId",
        "variableName": "schemeId"
    }, v3 = [
        v2 /*: any*/ 
    ], v4 = {
        "kind": "ScalarField",
        "name": "isEditable"
    }, v5 = {
        "concreteType": "JiraPermissionSchemeConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
            v4 /*: any*/ 
        ]
    }, v6 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v2 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "key"
    }, v11 = {
        "kind": "ScalarField",
        "name": "description"
    }, v12 = {
        "kind": "ScalarField",
        "name": "text"
    }, v13 = {
        "kind": "ScalarField",
        "name": "id"
    }, v14 = [
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v13 /*: any*/ 
    ], v15 = [
        v9 /*: any*/ ,
        v13 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v3 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "PermissionCategories"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "header_editPermissionScheme"
                                            },
                                            v5 /*: any*/ 
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.viewPermissionScheme"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v6 /*: any*/ ,
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "getProjectsByPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v7 /*: any*/ ,
                                                                "action": "LOG",
                                                                "path": "jira.getProjectsByPermissionScheme.edges.node.projectId"
                                                            }
                                                        ]
                                                    },
                                                    "action": "LOG",
                                                    "path": "jira.getProjectsByPermissionScheme.edges.node"
                                                }
                                            ]
                                        },
                                        "action": "LOG",
                                        "path": "jira.getProjectsByPermissionScheme.edges"
                                    }
                                ]
                            },
                            "action": "LOG",
                            "path": "jira.getProjectsByPermissionScheme"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "viewPermissionScheme",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraPermissionSchemeGrantGroup",
                                            "kind": "LinkedField",
                                            "name": "grantGroups",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectPermissionCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraPermissionGrantHolder",
                                                    "kind": "LinkedField",
                                                    "name": "grantHolders",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProjectPermission",
                                                            "kind": "LinkedField",
                                                            "name": "permission",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionConfiguration",
                                                            "kind": "LinkedField",
                                                            "name": "configuration",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "tag"
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionMessageExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "message",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v12 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionDocumentationExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "documentation",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ]
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionGrants",
                                                            "kind": "LinkedField",
                                                            "name": "grants",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGrantTypeKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v9 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionGrantValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantValues",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "value",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDefaultGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v14 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraUserGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraGroup",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "group",
                                                                                            "plural": false,
                                                                                            "selections": v15 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraGroupGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraRole",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "role",
                                                                                            "plural": false,
                                                                                            "selections": v15 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectRoleGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "field",
                                                                                            "plural": false,
                                                                                            "selections": v14 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueFieldGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v13 /*: any*/ 
                                                                                    ],
                                                                                    "type": "Node",
                                                                                    "abstractKey": "__isNode"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v13 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "totalCount"
                                                                },
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPermissionScheme",
                                            "kind": "LinkedField",
                                            "name": "scheme",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ],
                                    "type": "JiraPermissionSchemeView"
                                }
                            ]
                        },
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "getProjectsByPermissionScheme",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8c97cc5e281ea579c44e87ac7f80e5f399b27b3ac304b7267d4210b282a7a4b1",
            "metadata": {},
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$95d709337e778f61$var$node.hash = "9e1e7326d79aae057f4943753d3cd309";
var $95d709337e778f61$export$2e2bcd8739ae039 = $95d709337e778f61$var$node;

});


parcelRegister("j15ln", function(module, exports) {

$parcel$export(module.exports, "globalSettingsEditPermissionSchemesRoute", () => $b0eb7fc8ea8a5934$export$d57f448badd0561f);
const $b0eb7fc8ea8a5934$export$d57f448badd0561f = {
    name: 'global-settings-issues-edit-permissions-schemes',
    path: '/jira/settings/issues/permission-schemes/:schemeId'
};

});

parcelRegister("aVbhY", function(module, exports) {

$parcel$export(module.exports, "LazyEditPermissionSchemePage", () => $9fc866887d4bbe6b$export$4549705b02900c32);
$parcel$export(module.exports, "default", () => $9fc866887d4bbe6b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $9fc866887d4bbe6b$export$4549705b02900c32 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5YZ0f"))), {
    moduleId: "./src/packages/permissions-administration/pages/edit-permission-scheme/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9fc866887d4bbe6b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9fc866887d4bbe6b$export$4549705b02900c32,
        pageId: "jira-edit-permission-scheme",
        shouldShowSpinner: true
    });

});
parcelRegister("5YZ0f", function(module, exports) {

let $45b1e03fe7c6521c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $45b1e03fe7c6521c$var$load("2s3c1").then(()=>parcelRequire('hZT3b'));

});



parcelRegister("ew7DI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPermissionSchemesRouteEntry", () => $1a723dff8ec4c1fb$export$85d07cd59d004b5b);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $bFrLw = parcelRequire("bFrLw");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $f7vTI = parcelRequire("f7vTI");

var $j8IEt = parcelRequire("j8IEt");
const $1a723dff8ec4c1fb$export$85d07cd59d004b5b = (0, $7NszV.createEntry)((0, $f7vTI.globalSettingsPermissionSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.configure-permission-scheme',
        component: (0, $j8IEt.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $bFrLw.permissionSchemePageResource)
        ],
        canTransitionIn: ()=>true,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $j8IEt.LazyPermissionSchemePage)
        ],
        meta: {
            reporting: {
                id: 'PermissionScheme',
                packageName: 'jiraAdminPagesPermissionScheme',
                teamName: 'gordian'
            }
        }
    }));

});
parcelRegister("bFrLw", function(module, exports) {

$parcel$export(module.exports, "permissionSchemePageResource", () => $b39d37deff00f918$export$58d9013f694fc9d0);

var $ao2h1 = parcelRequire("ao2h1");

var $kf7Zr = parcelRequire("kf7Zr");
const $b39d37deff00f918$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE = 'PERMISSION_SCHEME_PAGE';
const $b39d37deff00f918$export$58d9013f694fc9d0 = (0, $ao2h1.createRelayResource)({
    type: $b39d37deff00f918$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $kf7Zr.default),
            variables: {
                // To Do: use ari-typescript library once it is approved
                // https://hello.atlassian.net/wiki/spaces/TGR/pages/1374189554/Dependency+review+atlassian+ari
                schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("kf7Zr", function(module, exports) {

$parcel$export(module.exports, "default", () => $667e2dd268ebb83a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf59478679f84bf44b49fd41a2544ee4>>
 * @relayHash 0250f6408e8d8064d7cc97a77e2f5386
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5642572e212db64091380e916543cde0402cdfaa01db716befcdd494efd5feb
const $667e2dd268ebb83a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "schemeId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "schemeId",
            "variableName": "schemeId"
        }
    ], v2 = {
        "concreteType": "JiraPermissionSchemeConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "description"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v6 /*: any*/ 
    ], v9 = [
        v4 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v1 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "header_permissionScheme"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "PermissionsTable"
                                            },
                                            v2 /*: any*/ 
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.viewPermissionScheme"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "viewPermissionScheme",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraPermissionScheme",
                                            "kind": "LinkedField",
                                            "name": "scheme",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPermissionSchemeGrantGroup",
                                            "kind": "LinkedField",
                                            "name": "grantGroups",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectPermissionCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraPermissionGrantHolder",
                                                    "kind": "LinkedField",
                                                    "name": "grantHolders",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProjectPermission",
                                                            "kind": "LinkedField",
                                                            "name": "permission",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionGrants",
                                                            "kind": "LinkedField",
                                                            "name": "grants",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGrantTypeKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionGrantValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantValues",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "value",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        v4 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDefaultGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v8 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraUserGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraGroup",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "group",
                                                                                            "plural": false,
                                                                                            "selections": v9 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraGroupGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "field",
                                                                                            "plural": false,
                                                                                            "selections": v8 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueFieldGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraRole",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "role",
                                                                                            "plural": false,
                                                                                            "selections": v9 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectRoleGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ 
                                                                                    ],
                                                                                    "type": "Node",
                                                                                    "abstractKey": "__isNode"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v6 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v2 /*: any*/ 
                                    ],
                                    "type": "JiraPermissionSchemeView"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b5642572e212db64091380e916543cde0402cdfaa01db716befcdd494efd5feb",
            "metadata": {},
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$667e2dd268ebb83a$var$node.hash = "41dd09a71a35c8ed416631b02fa73316";
var $667e2dd268ebb83a$export$2e2bcd8739ae039 = $667e2dd268ebb83a$var$node;

});


parcelRegister("f7vTI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPermissionSchemesRoute", () => $1ed22cbad427b1e6$export$ceade8e040291782);
const $1ed22cbad427b1e6$export$ceade8e040291782 = {
    name: 'global-settings-permissions-schemes',
    path: '/jira/settings/issues/permission-schemes-new/:schemeId'
};

});

parcelRegister("j8IEt", function(module, exports) {

$parcel$export(module.exports, "LazyPermissionSchemePage", () => $d6d274858940e39c$export$f7fcf8304eb17dda);
$parcel$export(module.exports, "default", () => $d6d274858940e39c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $d6d274858940e39c$export$f7fcf8304eb17dda = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cTNQL"))), {
    moduleId: "./src/packages/permissions-administration/pages/permission-scheme/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d6d274858940e39c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d6d274858940e39c$export$f7fcf8304eb17dda,
        pageId: "jira-permission-scheme",
        shouldShowSpinner: true
    });

});
parcelRegister("cTNQL", function(module, exports) {

let $96414a4a093fe58c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $96414a4a093fe58c$var$load("ibJV0").then(()=>parcelRequire('cHxvv'));

});



parcelRegister("gCfQs", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRouteEntry", () => $90f1ccdb6a2bda75$export$63a56a096ab0d260);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $72PKZ = parcelRequire("72PKZ");

var $5pSYQ = parcelRequire("5pSYQ");

var $jE90b = parcelRequire("jE90b");
const $90f1ccdb6a2bda75$export$63a56a096ab0d260 = (0, $7NszV.createEntry)((0, $72PKZ.globalSettingsIssuesPrioritiesRoute), ()=>({
        group: 'global-settings',
        component: (0, $jE90b.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jE90b.LazyPrioritiesPage)
        ]
    }));

});
parcelRegister("72PKZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRoute", () => $20f25386b191950e$export$518516cdf6b7cd83);
const $20f25386b191950e$export$518516cdf6b7cd83 = {
    name: 'global-settings-issues-priorities',
    path: '/jira/settings/issues/priorities'
};

});

parcelRegister("jE90b", function(module, exports) {

$parcel$export(module.exports, "LazyPrioritiesPage", () => $bf15af7ed924092e$export$2b5843205130631c);
$parcel$export(module.exports, "default", () => $bf15af7ed924092e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $bf15af7ed924092e$export$2b5843205130631c = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hOMLE"))), {
    moduleId: "./src/packages/admin-pages/priorities/src/index.tsx"
});
const $bf15af7ed924092e$var$PrioritiesPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $bf15af7ed924092e$export$2b5843205130631c,
        pageId: "jira-admin-pages-priorities",
        shouldShowSpinner: true
    });
var $bf15af7ed924092e$export$2e2bcd8739ae039 = $bf15af7ed924092e$var$PrioritiesPage;

});
parcelRegister("hOMLE", function(module, exports) {

let $cf8cef6b4f6bbf08$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cf8cef6b4f6bbf08$var$load("dRzJO").then(()=>parcelRequire('7oC7C'));

});



parcelRegister("2UvYl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldsManagementRouteEntry", () => $f3cfe226a311fac7$export$b0811d27c1832ea1);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $lKiq6 = parcelRequire("lKiq6");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $5lsNZ = parcelRequire("5lsNZ");

var $5pSYQ = parcelRequire("5pSYQ");

var $1lvfV = parcelRequire("1lvfV");
const $f3cfe226a311fac7$export$b0811d27c1832ea1 = (0, $7NszV.createEntry)((0, $lKiq6.globalSettingsIssueFieldsManagementRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.fields',
        component: (0, $cSD7y.componentWithFG)('centralized-fields-page-m1', (0, $1lvfV.FieldsPage), (0, $5lsNZ.default)),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        canTransitionIn: ()=>(0, $4R6GH.fg)('centralized-fields-page-m1'),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1lvfV.LazyFieldsPage)
        ]
    }));

});
parcelRegister("lKiq6", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldsManagementRoute", () => $4325708462413ccd$export$6e571c84819449f5);
const $4325708462413ccd$export$6e571c84819449f5 = {
    name: 'global-settings-issues-fields-management-view',
    path: '/jira/settings/issues/fields'
};

});

parcelRegister("1lvfV", function(module, exports) {

$parcel$export(module.exports, "LazyFieldsPage", () => $864804fabace9e3f$export$f3eb02d60196989a);
$parcel$export(module.exports, "FieldsPage", () => $864804fabace9e3f$export$642e36be5f0881cd);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $864804fabace9e3f$export$f3eb02d60196989a = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5F80t"))), {
    moduleId: "./src/packages/admin-pages/fields/src/index.tsx"
});
const $864804fabace9e3f$export$642e36be5f0881cd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $864804fabace9e3f$export$f3eb02d60196989a,
        pageId: "jira-admin-pages-fields-page",
        shouldShowSpinner: true
    });

});
parcelRegister("5F80t", function(module, exports) {

let $41f6fe0922fc8d2e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $41f6fe0922fc8d2e$var$load("63spp").then(()=>parcelRequire('1hPWF'));

});



parcelRegister("81ZCL", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritySchemesRouteEntry", () => $e7cda76e463e35e5$export$a5ac2a64ed09e754);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $fZEim = parcelRequire("fZEim");

var $5pSYQ = parcelRequire("5pSYQ");

var $3qE1A = parcelRequire("3qE1A");
const $e7cda76e463e35e5$export$a5ac2a64ed09e754 = (0, $7NszV.createEntry)((0, $fZEim.globalSettingsIssuesPrioritySchemesRoute), ()=>({
        group: 'global-settings',
        component: (0, $3qE1A.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $3qE1A.LazyPrioritySchemes)
        ]
    }));

});
parcelRegister("fZEim", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritySchemesRoute", () => $9dde78a6f0fc7878$export$185af30f53271c10);
const $9dde78a6f0fc7878$export$185af30f53271c10 = {
    name: 'global-settings-issues-priority-schemes',
    path: '/jira/settings/issues/priority-schemes'
};

});

parcelRegister("3qE1A", function(module, exports) {

$parcel$export(module.exports, "LazyPrioritySchemes", () => $a7002d7e57e81458$export$20bb8a3b40a3add4);
$parcel$export(module.exports, "default", () => $a7002d7e57e81458$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $a7002d7e57e81458$export$20bb8a3b40a3add4 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("98IT7"))), {
    moduleId: "./src/packages/admin-pages/priority-schemes/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a7002d7e57e81458$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a7002d7e57e81458$export$20bb8a3b40a3add4,
        pageId: "jira-admin-pages-priority-schemes",
        shouldShowSpinner: true
    });

});
parcelRegister("98IT7", function(module, exports) {

let $6a77ae3da91f69a4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6a77ae3da91f69a4$var$load("7MbJW").then(()=>parcelRequire('4bg9b'));

});



parcelRegister("izUuJ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFormDataConnectionsRouteEntry", () => $3bc9e61b7154fc39$export$d975ee3e4df0b4d2);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $cL7r8 = parcelRequire("cL7r8");

var $4R6GH = parcelRequire("4R6GH");

var $dwY5M = parcelRequire("dwY5M");

var $lkFvK = parcelRequire("lkFvK");

var $6MVyv = parcelRequire("6MVyv");
const $3bc9e61b7154fc39$var$jiraAdminProformaDataConnectionsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dwY5M.default),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});
const $3bc9e61b7154fc39$export$d975ee3e4df0b4d2 = (0, $7NszV.createEntry)((0, $cL7r8.globalSettingsFormDataConnectionsRoute), ()=>({
        group: 'global-settings',
        component: (0, $6MVyv.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6MVyv.LazyProformaJiraDataConnectionsPage)
        ],
        entryPoint () {
            return (0, $4R6GH.fg)('jira-data-connections-without-mobx') ? $3bc9e61b7154fc39$var$jiraAdminProformaDataConnectionsPageEntryPoint : undefined;
        }
    }));

});
parcelRegister("cL7r8", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFormDataConnectionsRoute", () => $e95abb1b467ec66d$export$6633247975d81f28);
const $e95abb1b467ec66d$export$6633247975d81f28 = {
    name: 'global-settings-issues-form-data-connections',
    path: '/jira/settings/forms/data-connections'
};

});

parcelRegister("dwY5M", function(module, exports) {

$parcel$export(module.exports, "default", () => $86888a626e8a4290$export$2e2bcd8739ae039);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $86888a626e8a4290$var$JiraAdminProformaDataConnectionsEntryPoint = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("kKdAK")), {
        moduleId: "606040fa"
    }),
    getPreloadProps: ()=>({})
});
var $86888a626e8a4290$export$2e2bcd8739ae039 = $86888a626e8a4290$var$JiraAdminProformaDataConnectionsEntryPoint;

});
parcelRegister("kKdAK", function(module, exports) {

let $f1a2a58882f6b60a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f1a2a58882f6b60a$var$load("9oTUH").then(()=>parcelRequire('5syWw'));

});


parcelRegister("6MVyv", function(module, exports) {

$parcel$export(module.exports, "LazyProformaJiraDataConnectionsPage", () => $013d0419ad26989f$export$a81885366284dc75);
$parcel$export(module.exports, "default", () => $013d0419ad26989f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $013d0419ad26989f$export$a81885366284dc75 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("3Qcar"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/proforma/data-connections/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$013d0419ad26989f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $013d0419ad26989f$export$a81885366284dc75,
        pageId: "jira-admin-pages-forms-data-connections",
        shouldShowSpinner: true
    });

});
parcelRegister("3Qcar", function(module, exports) {

let $2cbfaa9e650b0bf8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2cbfaa9e650b0bf8$var$load("jKdTq").then(()=>parcelRequire('jSKfU'));

});



parcelRegister("ipR0U", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldSchemesRouteEntry", () => $040da6ab68bb362d$export$d76b41f577aeeba5);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $g0QAg = parcelRequire("g0QAg");

var $5pSYQ = parcelRequire("5pSYQ");

var $MjvHI = parcelRequire("MjvHI");
const $040da6ab68bb362d$export$d76b41f577aeeba5 = (0, $7NszV.createEntry)((0, $g0QAg.globalSettingsIssueFieldSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.screen-schemes',
        component: (0, $MjvHI.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $MjvHI.LazyScreenSchemesPage)
        ]
    }));

});
parcelRegister("g0QAg", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldSchemesRoute", () => $f7a16e4417c90525$export$3c5a0cf6ecc1bdf1);
const $f7a16e4417c90525$export$3c5a0cf6ecc1bdf1 = {
    name: 'global-settings-issues-field-schemes-view',
    path: '/jira/settings/issues/screen-schemes'
};

});

parcelRegister("MjvHI", function(module, exports) {

$parcel$export(module.exports, "LazyScreenSchemesPage", () => $3b08a72bf07c6137$export$342ae41503f611f1);
$parcel$export(module.exports, "default", () => $3b08a72bf07c6137$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $3b08a72bf07c6137$export$342ae41503f611f1 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8LzEB"))), {
    moduleId: "./src/packages/admin-pages/screens/screen-schemes-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3b08a72bf07c6137$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3b08a72bf07c6137$export$342ae41503f611f1,
        pageId: "jira-admin-pages-screen-schemes-page",
        shouldShowSpinner: true
    });

});
parcelRegister("8LzEB", function(module, exports) {

let $661e5ea5aad62050$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $661e5ea5aad62050$var$load("h2MrD"),
    $661e5ea5aad62050$var$load("bYT2S"),
    $661e5ea5aad62050$var$load("FB5JX")
]).then(()=>parcelRequire('bwE6o'));

});



parcelRegister("jovMq", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldScreensRouteEntry", () => $39823af69179fb5e$export$ea08b1064c32ddb2);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $eHWkH = parcelRequire("eHWkH");

var $5pSYQ = parcelRequire("5pSYQ");

var $P0dqS = parcelRequire("P0dqS");
const $39823af69179fb5e$export$ea08b1064c32ddb2 = (0, $7NszV.createEntry)((0, $eHWkH.globalSettingsIssueFieldScreensRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.screens',
        component: (0, $P0dqS.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $P0dqS.LazyScreensPage)
        ]
    }));

});
parcelRegister("eHWkH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldScreensRoute", () => $d6c79c93cf657eb0$export$197fd5d0ee709ca4);
const $d6c79c93cf657eb0$export$197fd5d0ee709ca4 = {
    name: 'global-settings-issues-field-screens',
    path: '/jira/settings/issues/screens'
};

});

parcelRegister("P0dqS", function(module, exports) {

$parcel$export(module.exports, "LazyScreensPage", () => $38a54f3b8a5e1e01$export$f4e6d546d7f2894c);
$parcel$export(module.exports, "default", () => $38a54f3b8a5e1e01$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $38a54f3b8a5e1e01$export$f4e6d546d7f2894c = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hmix6"))), {
    moduleId: "./src/packages/admin-pages/screens/screens-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$38a54f3b8a5e1e01$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $38a54f3b8a5e1e01$export$f4e6d546d7f2894c,
        pageId: "jira-admin-pages-screens-page",
        shouldShowSpinner: true
    });

});
parcelRegister("hmix6", function(module, exports) {

let $ca32ddfee19a6404$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ca32ddfee19a6404$var$load("h2MrD"),
    $ca32ddfee19a6404$var$load("bYT2S"),
    $ca32ddfee19a6404$var$load("8WK9x")
]).then(()=>parcelRequire('lgmh3'));

});



parcelRegister("a4nP2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesScreenSchemesRouteEntry", () => $3911900520b0c6a8$export$e2c2c1569887e684);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $4gtHC = parcelRequire("4gtHC");

var $5pSYQ = parcelRequire("5pSYQ");

var $kMjOg = parcelRequire("kMjOg");
const $3911900520b0c6a8$export$e2c2c1569887e684 = (0, $7NszV.createEntry)((0, $4gtHC.globalSettingsIssueTypesScreenSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.issue-type-screen-schemes',
        component: (0, $kMjOg.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kMjOg.LazyIssueTypeScreenSchemesPage)
        ]
    }));

});
parcelRegister("4gtHC", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesScreenSchemesRoute", () => $2245c71c2bdfe600$export$df93a4addc359237);
const $2245c71c2bdfe600$export$df93a4addc359237 = {
    name: 'global-settings-issues-types-screen-schemes-view',
    path: '/jira/settings/issues/issue-type-screen-schemes'
};

});

parcelRegister("kMjOg", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeScreenSchemesPage", () => $73b6b725092289e9$export$350edfb57b335a57);
$parcel$export(module.exports, "default", () => $73b6b725092289e9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $73b6b725092289e9$export$350edfb57b335a57 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4tME5"))), {
    moduleId: "./src/packages/admin-pages/screens/issue-type-screen-schemes-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$73b6b725092289e9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $73b6b725092289e9$export$350edfb57b335a57,
        pageId: "jira-admin-pages-issue-type-screen-schemes-page",
        shouldShowSpinner: true
    });

});
parcelRegister("4tME5", function(module, exports) {

let $342f9ada63345370$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $342f9ada63345370$var$load("h2MrD"),
    $342f9ada63345370$var$load("bYT2S"),
    $342f9ada63345370$var$load("jTAHY")
]).then(()=>parcelRequire('5K98P'));

});



parcelRegister("h0ilo", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationRedirectRouteEntry", () => $8e2136bf66ce50f4$export$7c2e1ea4fc4a192f);

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $dmx0y = parcelRequire("dmx0y");

var $4TSoB = parcelRequire("4TSoB");

var $j2LKP = parcelRequire("j2LKP");
const $8e2136bf66ce50f4$export$7c2e1ea4fc4a192f = (0, $7NszV.createEntry)((0, $4TSoB.systemConfigurationRedirectRoute), ()=>({
        group: 'global-settings',
        component: (0, $j2LKP.default),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $dmx0y.systemConfigurationGeneralResource)
        ]
    }));

});
parcelRegister("4TSoB", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationRedirectRoute", () => $3fbd0d392c74d663$export$fe4807c49c838619);
const $3fbd0d392c74d663$export$fe4807c49c838619 = {
    name: 'system-configuration-general-redirect',
    path: '/secure/admin/ViewApplicationProperties.jspa',
    exact: true
};

});

parcelRegister("j2LKP", function(module, exports) {

$parcel$export(module.exports, "default", () => $71a705d1d999c26b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$71a705d1d999c26b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/settings/system/general-configuration"
    });

});


parcelRegister("k1TyW", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationRouteEntry", () => $1805c641c87a2931$export$360a82088f35f2f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $dmx0y = parcelRequire("dmx0y");

var $99CoR = parcelRequire("99CoR");

var $5pSYQ = parcelRequire("5pSYQ");

var $k7R2k = parcelRequire("k7R2k");
const $1805c641c87a2931$export$360a82088f35f2f = (0, $7NszV.createEntry)((0, $99CoR.systemConfigurationRoute), ()=>({
        group: 'global-settings',
        component: (0, $k7R2k.default),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $dmx0y.systemConfigurationGeneralResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $k7R2k.LazySystemConfigurationGeneral)
        ]
    }));

});
parcelRegister("99CoR", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationRoute", () => $6c77a2c05982af00$export$6823cb5626e61bc7);
const $6c77a2c05982af00$export$6823cb5626e61bc7 = {
    name: 'system-configuration-general',
    path: '/jira/settings/system/general-configuration',
    exact: true
};

});

parcelRegister("k7R2k", function(module, exports) {

$parcel$export(module.exports, "LazySystemConfigurationGeneral", () => $ece5afb522908971$export$c452a8c622781ccd);
$parcel$export(module.exports, "default", () => $ece5afb522908971$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $ece5afb522908971$export$c452a8c622781ccd = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("77zUX"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/system-configuration-general/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ece5afb522908971$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ece5afb522908971$export$c452a8c622781ccd,
        pageId: "system-configuration-general",
        shouldShowSpinner: false
    });

});
parcelRegister("77zUX", function(module, exports) {

let $52f50c579259e4ea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $52f50c579259e4ea$var$load("aUVUi").then(()=>parcelRequire('7S4i0'));

});



parcelRegister("hH7Cb", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUiAnnouncementBannerRouteEntry", () => $375c8c577ca5ebf6$export$416d225883781012);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $49jFu = parcelRequire("49jFu");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $5pSYQ = parcelRequire("5pSYQ");

const $375c8c577ca5ebf6$var$LazyAnnouncementBanner = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jOsZh"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/system/ui/announcement-banner/src/index.tsx"
});
const $375c8c577ca5ebf6$var$AnnouncementBanner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $375c8c577ca5ebf6$var$LazyAnnouncementBanner,
        pageId: "admin-pages-system-ui-announcement-banner",
        shouldShowSpinner: true
    });
const $375c8c577ca5ebf6$export$416d225883781012 = (0, $7NszV.createEntry)((0, $49jFu.globalSettingsSystemUiAnnouncementBannerRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.system.ui.announcement-banner',
        component: $375c8c577ca5ebf6$var$AnnouncementBanner,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $375c8c577ca5ebf6$var$LazyAnnouncementBanner
        ]
    }));

});
parcelRegister("49jFu", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUiAnnouncementBannerRoute", () => $0f7678f7ab7e2ce6$export$20631ff3b13dafc0);
const $0f7678f7ab7e2ce6$export$20631ff3b13dafc0 = {
    name: 'global-settings-system-ui-announcement-banner',
    path: '/jira/settings/system/ui/announcement-banner'
};

});

parcelRegister("jOsZh", function(module, exports) {

let $e6c92c250b3f6d8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e6c92c250b3f6d8b$var$load("h2MrD"),
    $e6c92c250b3f6d8b$var$load("bYT2S"),
    $e6c92c250b3f6d8b$var$load("dsiAd"),
    $e6c92c250b3f6d8b$var$load("1eCvc")
]).then(()=>parcelRequire('e7RG2'));

});


parcelRegister("dtLGm", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflow1RouteEntry", () => $68897fd2bacb1927$export$55e4c1d21a9b75e6);

var $3aIZg = parcelRequire("3aIZg");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $cPrje = parcelRequire("cPrje");

var $5pSYQ = parcelRequire("5pSYQ");

var $i6RvY = parcelRequire("i6RvY");
const $68897fd2bacb1927$export$55e4c1d21a9b75e6 = (0, $7NszV.createEntry)((0, $cPrje.globalSettingsIssueWorkflow1Route), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.view-workflows',
        component: (0, $i6RvY.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $3aIZg.default),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $i6RvY.LazyListWorkflows)
        ]
    }));

});
parcelRegister("3aIZg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9146315a1662307e$export$2e2bcd8739ae039);

var $ebyGx = parcelRequire("ebyGx");

var $2M1hQ = parcelRequire("2M1hQ");

var $AdkCT = parcelRequire("AdkCT");

const $9146315a1662307e$var$workFlowsResource = (0, $2M1hQ.createResource)({
    type: (0, $5c95bdf76715894f$export$b11854972ecaecc7),
    getKey: ({ query: query })=>`${0, $5c95bdf76715894f$export$6602c5404301813f}-${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query)}`,
    maxAge: 0,
    getData: async ({ query: query })=>(0, $AdkCT.getListWorkFlows)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query))
});
var $9146315a1662307e$export$2e2bcd8739ae039 = $9146315a1662307e$var$workFlowsResource;

});
parcelRegister("AdkCT", function(module, exports) {

$parcel$export(module.exports, "getListWorkFlows", () => $bd8703d90d89a06c$export$952f5d693c3c0d4e);

var $ebyGx = parcelRequire("ebyGx");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $lNKJm = parcelRequire("lNKJm");

var $9KDge = parcelRequire("9KDge");
const $bd8703d90d89a06c$export$952f5d693c3c0d4e = async (qs)=>{
    const filter = (0, $9KDge.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify((0, $9KDge.toApiUrlTransformer)(filter));
    try {
        return await (0, $eusud.performGetRequest)(`/rest/api/3/workflow/search?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'getWorkflowsSearchAPI',
                packageName: (0, $lNKJm.PACKAGE_NAME),
                teamName: 'helix'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("lNKJm", function(module, exports) {

$parcel$export(module.exports, "SOURCE_NAME", () => $51adf94ab22e1863$export$a3821bc63538b210);
$parcel$export(module.exports, "WORKFLOW_NAME", () => $51adf94ab22e1863$export$a69699c3acbd94ca);
$parcel$export(module.exports, "PACKAGE_NAME", () => $51adf94ab22e1863$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "WORKFLOWS_ACTIONS", () => $51adf94ab22e1863$export$f3ab46ae5f3c01ad);
$parcel$export(module.exports, "WORKFLOWS_SCHEME", () => $51adf94ab22e1863$export$81c9aaf617cb2f01);
$parcel$export(module.exports, "SYSTEM_WORKFLOW_JIRA_NAME", () => $51adf94ab22e1863$export$615f1d8b29794ae);
$parcel$export(module.exports, "SYSTEM_WORKFLOW_BUILDS_WORKFLOWS_NAME", () => $51adf94ab22e1863$export$fccd4c1ce5f0896f);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $51adf94ab22e1863$export$5716e8bcb003888d);
$parcel$export(module.exports, "defaultListWorkFlowsFilter", () => $51adf94ab22e1863$export$dc5aae53031515c);
$parcel$export(module.exports, "ORDER", () => $51adf94ab22e1863$export$11e75bce9f7ea886);
$parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", () => $51adf94ab22e1863$export$9ac56b2484c2d4e9);
$parcel$export(module.exports, "PAGE_SIZE_CHANGE_ANALYTICS", () => $51adf94ab22e1863$export$e6613a3c77896936);
$parcel$export(module.exports, "API_PREFIX", () => $51adf94ab22e1863$export$a3f6840410eb0571);

const $51adf94ab22e1863$export$a3821bc63538b210 = 'listWorkflows';
const $51adf94ab22e1863$export$a69699c3acbd94ca = 'workflowName';
const $51adf94ab22e1863$export$b8b9d90f9e5bd72b = 'jira-admin-pages-list-workflows';
const $51adf94ab22e1863$export$f3ab46ae5f3c01ad = 'workflowsActions';
const $51adf94ab22e1863$export$81c9aaf617cb2f01 = 'workflowScheme';
const $51adf94ab22e1863$export$615f1d8b29794ae = 'jira';
const $51adf94ab22e1863$export$fccd4c1ce5f0896f = 'Builds Workflow';
const $51adf94ab22e1863$export$5716e8bcb003888d = 10;
const $51adf94ab22e1863$export$dc5aae53031515c = {
    pageNumber: 1,
    pageSize: $51adf94ab22e1863$export$5716e8bcb003888d,
    expand: [
        'default',
        'hasDraftWorkflow',
        'schemes',
        'operations',
        'projects'
    ],
    orderBy: 'name',
    sortDirection: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
    isActive: true
};
const $51adf94ab22e1863$export$11e75bce9f7ea886 = Object.freeze({
    ASC: 'asc',
    DESC: 'desc'
});
const $51adf94ab22e1863$export$9ac56b2484c2d4e9 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'filterSearch'
});
const $51adf94ab22e1863$export$e6613a3c77896936 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'pageSize'
});
const $51adf94ab22e1863$export$a3f6840410eb0571 = 'gateway/api/jira/project-configuration';

});

parcelRegister("9KDge", function(module, exports) {

$parcel$export(module.exports, "toUrlTransformer", () => $f0642d0f1e447d39$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $f0642d0f1e447d39$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toApiUrlTransformer", () => $f0642d0f1e447d39$export$fb15afa686993f11);

var $aud83 = parcelRequire("aud83");

var $lNKJm = parcelRequire("lNKJm");

var $lgmUP = parcelRequire("lgmUP");
const $f0642d0f1e447d39$export$5b9f8ed2c34be88a = (filter)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = filter || {};
    return {
        pageNumber: pageNumber,
        searchFilter: searchFilter,
        orderBy: orderBy,
        isActive: isActive,
        pageSize: pageSize
    };
};
const $f0642d0f1e447d39$export$bec67ef860c0d0e1 = (params)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = params;
    const parsedNumber = Number.isNaN((0, $aud83.number).parse(pageNumber)) ? (0, $lNKJm.defaultListWorkFlowsFilter).pageNumber : (0, $aud83.number).parse(pageNumber);
    const parsedSize = Number.isNaN((0, $aud83.number).parse(pageSize)) ? (0, $lNKJm.defaultListWorkFlowsFilter).pageSize : (0, $aud83.number).parse(pageSize);
    const parsedOrderBy = orderBy === 'name' || orderBy === '-name' || orderBy === 'updated' || orderBy === '-updated' ? orderBy : undefined;
    const isActiveFinal = isActive != null ? isActive === 'true' : (0, $lNKJm.defaultListWorkFlowsFilter).isActive;
    return {
        ...(0, $lNKJm.defaultListWorkFlowsFilter),
        pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
        pageSize: parsedSize != null ? Number(parsedSize) : undefined,
        searchFilter: searchFilter,
        orderBy: parsedOrderBy,
        isActive: isActiveFinal
    };
};
const $f0642d0f1e447d39$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = {
        ...(0, $lNKJm.defaultListWorkFlowsFilter),
        ...filter
    };
    const { pageNumber: pageNumber = 1, pageSize: pageSize = (0, $lNKJm.DEFAULT_PAGE_SIZE) } = fullFilter;
    let requestParams = {
        maxResults: pageSize,
        startAt: (pageNumber - 1) * pageSize,
        orderBy: fullFilter.orderBy,
        queryString: (0, $lgmUP.trimSearchFilter)(fullFilter.searchFilter),
        isActive: fullFilter.isActive
    };
    if (fullFilter.expand != null) // @ts-expect-error - TS2322 - Type '{ expand: string; maxResults: number; startAt: number; orderBy: WorkflowOrderBy | undefined; queryString: string | undefined; isActive: boolean; }' is not assignable to type '{ maxResults: number; startAt: number; orderBy: WorkflowOrderBy | undefined; queryString: string | undefined; isActive: boolean; }'.
    requestParams = {
        ...requestParams,
        expand: fullFilter.expand.join(',')
    };
    return requestParams;
};

});
parcelRegister("lgmUP", function(module, exports) {

$parcel$export(module.exports, "trimSearchFilter", () => $d92ccc09aa62d68e$export$ed1722f41c23aaaf);
const $d92ccc09aa62d68e$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
const $d92ccc09aa62d68e$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
const $d92ccc09aa62d68e$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});



const $5c95bdf76715894f$export$b11854972ecaecc7 = 'WORKFLOWS_TABLE';
const $5c95bdf76715894f$export$6602c5404301813f = 'WORKFLOWS_TABLE_KEY';


parcelRegister("cPrje", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflow1Route", () => $416b12e52ba65191$export$f8f2a617a2f4d53);
const $416b12e52ba65191$export$f8f2a617a2f4d53 = {
    name: 'global-settings-issues-workflows-pages',
    path: '/jira/settings/issues/workflows'
};

});

parcelRegister("i6RvY", function(module, exports) {

$parcel$export(module.exports, "LazyListWorkflows", () => $fe432a8ece476800$export$4c64b4f1ecf22fc8);
$parcel$export(module.exports, "default", () => $fe432a8ece476800$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $fe432a8ece476800$export$4c64b4f1ecf22fc8 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8HISe"))), {
    moduleId: "./src/packages/admin-pages/workflows/list-workflows/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fe432a8ece476800$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $fe432a8ece476800$export$4c64b4f1ecf22fc8,
        pageId: "jira-admin-pages-list-workflows",
        shouldShowSpinner: true
    });

});
parcelRegister("8HISe", function(module, exports) {

let $656525d9563c2852$var$load = (parcelRequire("28QjX"))(4);
module.exports = $656525d9563c2852$var$load("9Lhq3").then(()=>parcelRequire('b9R9h'));

});



parcelRegister("f6OBR", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowEditRouteEntry", () => $e62e629a6fa746d6$export$d2b3121978e344e);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $3P1Nf = parcelRequire("3P1Nf");

var $5pSYQ = parcelRequire("5pSYQ");

var $c7jVr = parcelRequire("c7jVr");
const $e62e629a6fa746d6$export$d2b3121978e344e = (0, $7NszV.createEntry)((0, $3P1Nf.globalSettingsIssueWorkflowEditRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.edit-workflow',
        component: (0, $c7jVr.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $c7jVr.LazyEditWorkflow)
        ]
    }));

});
parcelRegister("3P1Nf", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowEditRoute", () => $69ca7ef2aafafa96$export$9d533f08a4447cc);
const $69ca7ef2aafafa96$export$9d533f08a4447cc = {
    name: 'global-settings-issues-workflow-edit',
    path: '/jira/settings/issues/workflows/:workflowId'
};

});

parcelRegister("c7jVr", function(module, exports) {

$parcel$export(module.exports, "LazyEditWorkflow", () => $793ac7f9af5a2945$export$cb79ebb337a95317);
$parcel$export(module.exports, "default", () => $793ac7f9af5a2945$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $793ac7f9af5a2945$export$cb79ebb337a95317 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5K4u3"))), {
    moduleId: "./src/packages/admin-pages/workflows/edit-workflow/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$793ac7f9af5a2945$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $793ac7f9af5a2945$export$cb79ebb337a95317,
        pageId: "jira-admin-pages-edit-workflow",
        shouldShowSpinner: true
    });

});
parcelRegister("5K4u3", function(module, exports) {

let $42e4b9fe7eb4f618$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $42e4b9fe7eb4f618$var$load("hPzOn"),
    $42e4b9fe7eb4f618$var$load("h2MrD"),
    $42e4b9fe7eb4f618$var$load("bYT2S"),
    $42e4b9fe7eb4f618$var$load("cM9em"),
    $42e4b9fe7eb4f618$var$load("fr9NE"),
    $42e4b9fe7eb4f618$var$load("1hdHP")
]).then(()=>parcelRequire('c8ahc'));

});



parcelRegister("5uMDF", function(module, exports) {

$parcel$export(module.exports, "productsJcsCustomerAccessRouteEntry", () => $896a9842aa03470c$export$487fd1bbb9f3684e);

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $jGT6h = parcelRequire("jGT6h");

var $8xIbV = parcelRequire("8xIbV");

var $5lsNZ = parcelRequire("5lsNZ");

var $6IgbX = parcelRequire("6IgbX");

var $cuwqc = parcelRequire("cuwqc");
const $896a9842aa03470c$var$productsJcsCustomerAccessEntryPointPage = (0, $lkFvK.createPageEntryPoint)({
    main: $8xIbV.productsJcsCustomerAccessEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});
const $896a9842aa03470c$export$487fd1bbb9f3684e = (0, $7NszV.createEntry)((0, $jGT6h.productsJcsCustomerAccessRoute), ()=>({
        group: 'global-settings',
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs_master_flag') ? $896a9842aa03470c$var$productsJcsCustomerAccessEntryPointPage : undefined;
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $cuwqc.jsmGlobalCustomerAccessSettingsResource),
            (0, $6IgbX.jsmGlobalCustomerAccessAffectedProjectsResource)
        ]
    }));

});
parcelRegister("jGT6h", function(module, exports) {

$parcel$export(module.exports, "productsJcsCustomerAccessRoute", () => $810d264c2a8581fd$export$db5278559525ffee);
const $810d264c2a8581fd$export$db5278559525ffee = {
    name: 'products-jcs-customer-access',
    path: '/jira/settings/products/customerservice/customer-access',
    exact: true
};

});

parcelRegister("8xIbV", function(module, exports) {

$parcel$export(module.exports, "productsJcsCustomerAccessEntryPoint", () => $2f553626bc230951$export$a10305920ea7bd7);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $2f553626bc230951$export$a10305920ea7bd7 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("4GxVo")), {
        moduleId: "d1f6773e"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4GxVo", function(module, exports) {

let $36956667f969337b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $36956667f969337b$var$load("fPczA").then(()=>parcelRequire('8f4JT'));

});



parcelRegister("3RvJ0", function(module, exports) {

$parcel$export(module.exports, "productsJcsFormFieldsRouteEntry", () => $5e479a4488e4cc4e$export$ce43ae01ccf4d9b6);

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $3niDA = parcelRequire("3niDA");

var $ftS5c = parcelRequire("ftS5c");

var $5lsNZ = parcelRequire("5lsNZ");

var $4oU7e = parcelRequire("4oU7e");
const $5e479a4488e4cc4e$var$productsJcsFormFieldsEntryPointPage = (0, $lkFvK.createPageEntryPoint)({
    main: $ftS5c.productsJcsFormFieldsEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});
const $5e479a4488e4cc4e$export$ce43ae01ccf4d9b6 = (0, $7NszV.createEntry)((0, $3niDA.productsJcsFormFieldsRoute), ()=>({
        group: 'global-settings',
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs_forms_resiliency_fast_follows') ? $5e479a4488e4cc4e$var$productsJcsFormFieldsEntryPointPage : undefined;
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $4oU7e.formFieldsResource)
        ]
    }));

});
parcelRegister("3niDA", function(module, exports) {

$parcel$export(module.exports, "productsJcsFormFieldsRoute", () => $29928e55102e185a$export$ace810399baa80ca);
const $29928e55102e185a$export$ace810399baa80ca = {
    name: 'products-jcs-form-fields',
    path: '/jira/settings/products/customerservice/form-fields',
    exact: true
};

});

parcelRegister("ftS5c", function(module, exports) {

$parcel$export(module.exports, "productsJcsFormFieldsEntryPoint", () => $18c73624925e2d30$export$4afec7b2100b3396);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $18c73624925e2d30$export$4afec7b2100b3396 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("5cWLN")), {
        moduleId: "b263f162"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5cWLN", function(module, exports) {

let $3caba93523eb29d4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3caba93523eb29d4$var$load("3StFR").then(()=>parcelRequire('kL0fx'));

});


parcelRegister("4oU7e", function(module, exports) {

$parcel$export(module.exports, "setSearchFieldsFormQuery", () => $5806ca2e66378d57$export$52917d9e09f11230);
$parcel$export(module.exports, "formFieldsResource", () => $5806ca2e66378d57$export$cf387af041de8a73);

var $2M1hQ = parcelRequire("2M1hQ");

var $7f4tk = parcelRequire("7f4tk");

var $1m4nn = parcelRequire("1m4nn");
const $5806ca2e66378d57$export$2345ec6675b232f1 = {};
const $5806ca2e66378d57$export$52917d9e09f11230 = (query)=>{
    $5806ca2e66378d57$export$2345ec6675b232f1.query = query;
};
const $5806ca2e66378d57$export$cf387af041de8a73 = (0, $2M1hQ.createResource)({
    type: 'FORM_FIELDS_RESOURCE',
    // The query.page in getData() is cached, and only changes if getKey() returns a new value
    getKey: ({ query: query })=>`form-fields${query?.page || 1}`,
    getData: async ({ query: query })=>(0, $7f4tk.default)((0, $1m4nn.getUrl)(query?.page, $5806ca2e66378d57$export$2345ec6675b232f1.query)),
    maxAge: 0
});

});
parcelRegister("1m4nn", function(module, exports) {

$parcel$export(module.exports, "PAGE_SIZE", () => $1f5621e396d56d5b$export$8ec3d08588d2eeda);
$parcel$export(module.exports, "getUrl", () => $1f5621e396d56d5b$export$94df0e59ebebf4a7);
const $1f5621e396d56d5b$export$8ec3d08588d2eeda = 50;
const $1f5621e396d56d5b$var$getStartAt = (page)=>{
    const pageNum = Number(page);
    if (!page || Number.isNaN(pageNum)) return 0;
    return (pageNum - 1) * $1f5621e396d56d5b$export$8ec3d08588d2eeda;
};
const $1f5621e396d56d5b$export$94df0e59ebebf4a7 = (page, query)=>`/rest/jcs/admin/v1/request-intake/global-fields?startAt=${$1f5621e396d56d5b$var$getStartAt(page)}${query ? `&query=${query}` : ''}`;

});



parcelRegister("fpGzf", function(module, exports) {

$parcel$export(module.exports, "arjCalendarEmbedRouteEntry", () => $e45e5c76e61613b2$export$309ed92381819b04);

var $5uXOq = parcelRequire("5uXOq");


var $87OsA = parcelRequire("87OsA");

var $lkFvK = parcelRequire("lkFvK");

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $2Ql51 = parcelRequire("2Ql51");

var $6vwaX = parcelRequire("6vwaX");

var $5lsNZ = parcelRequire("5lsNZ");

var $kZOse = parcelRequire("kZOse");

var $02tNK = parcelRequire("02tNK");
const $e45e5c76e61613b2$var$planCalendarEmbedRouteEntry = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $02tNK.calendarEntryPoint)
});
const $e45e5c76e61613b2$export$309ed92381819b04 = (0, $7NszV.createEntry)((0, $6vwaX.arjCalendarEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-calendar-embed',
        // Remove 'component' when cleanup 'smart_links_for_plans' FG
        component: (0, $5lsNZ.default),
        skeleton: ()=>{
            if ((0, $4R6GH.fg)('smart_links_for_plans')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZOse.CalendarSkeleton), null);
            return undefined;
        },
        entryPoint () {
            if ((0, $4R6GH.fg)('smart_links_for_plans')) {
                (0, $87OsA.setCapability)((0, $281cbd47ba46dd7d$export$f999749ac7a2cd1));
                return $e45e5c76e61613b2$var$planCalendarEmbedRouteEntry;
            }
            return undefined;
        },
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $2Ql51.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$f999749ac7a2cd1)
        },
        forPaint: []
    }));

});
const $281cbd47ba46dd7d$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $281cbd47ba46dd7d$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $281cbd47ba46dd7d$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $281cbd47ba46dd7d$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$4695c1a423ffe431 = 'DASHBOARD';
const $281cbd47ba46dd7d$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $281cbd47ba46dd7d$export$9a80695e72849f84 = 'X-Atlassian-Capability';

parcelRegister("c3WQb", function(module, exports) {

$parcel$export(module.exports, "advancedRoadmapsReduxStoreStateResource", () => $20c66b93015d9910$export$6ca262338f199e4b);
$parcel$export(module.exports, "advancedRoadmapsScenarioIdResource", () => $20c66b93015d9910$export$aec847b4ce72891);
$parcel$export(module.exports, "advancedRoadmapsPlanPageInitialChecksResource", () => $20c66b93015d9910$export$7431e46c7ad56c3d);
$parcel$export(module.exports, "advancedRoadmapsPlanReportPageInitialChecksResource", () => $20c66b93015d9910$export$bf0c5395c73cc255);
$parcel$export(module.exports, "advancedRoadmapsLastVisitedProgramBoardIdResource", () => $20c66b93015d9910$export$f5b159e1fb19e04e);

var $hGgHi = parcelRequire("hGgHi");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");

const $20c66b93015d9910$export$6ca262338f199e4b = (0, $2M1hQ.createResource)({
    type: 'ADVANCED_ROADMAPS_REDUX_STORE_STATE',
    getKey: ({ match: match })=>{
        const { params: params, query: query } = match;
        if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
        if (params.reportId != null) return params.reportId;
        if (query.r != null) return query.r;
        throw new Error('Unable to get resource key for ADVANCED_ROADMAPS_REDUX_STORE_STATE.');
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getData: async ()=>undefined,
    isBrowserOnly: true,
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $20c66b93015d9910$export$aec847b4ce72891 = (0, $2M1hQ.createResource)({
    type: (0, $025c2a539475c8ec$export$a0893d695ebee984),
    getKey: ({ query: query })=>`scenarioId_${query.id}`,
    getData: async ({ query: query })=>{
        const planId = query.id;
        const { id: id } = await (0, $eusud.performGetRequest)(`/rest/jpo/1.0/scenarios/${planId}`);
        return {
            scenarioId: id
        };
    },
    maxAge: 0
});
const $20c66b93015d9910$export$7431e46c7ad56c3d = (0, $2M1hQ.createResource)({
    type: (0, $025c2a539475c8ec$export$68390102872336b6),
    getKey: ({ match: match })=>{
        const { planId: planId, scenarioId: scenarioId } = match.params;
        return `planPageInitialChecks_${planId != null ? planId : ''}_${scenarioId != null ? scenarioId : ''}`;
    },
    getData: async ({ match: match })=>{
        const { planId: planId, scenarioId: scenarioId } = match.params;
        // @ts-expect-error - TS2367 - This condition will always return 'false' since the types '"null"' and '"undefined"' have no overlap.
        if (planId == null || planId === 'null' && planId === 'undefined' && planId === '') throw new Error('Plan cannot be loaded without a planId');
        let url = `/rest/jpo/1.0/plans/${planId}/checks`;
        if (scenarioId != null && scenarioId !== 'null' && scenarioId !== 'undefined' && scenarioId !== '') url = `${url}?sid=${scenarioId}`;
        const response = await (0, $eusud.performGetRequest)(url);
        return response;
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $20c66b93015d9910$export$bf0c5395c73cc255 = (0, $2M1hQ.createResource)({
    type: (0, $025c2a539475c8ec$export$a00e869cafd63140),
    getKey: ({ match: match })=>`planReportPageInitialChecks_${match.params.reportId == null ? '' : match.params.reportId}`,
    getData: async ({ match: match })=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const initialPlanChecksPromise = window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        delete window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
        if (initialPlanChecksPromise) {
            const response = await initialPlanChecksPromise;
            return response;
        }
        const { reportId: reportId } = match.params;
        const response = await (0, $eusud.performGetRequest)(`/rest/jpo/1.0/reportinfo/generic/${reportId == null ? '' : reportId}/checks`);
        return response;
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $20c66b93015d9910$export$f5b159e1fb19e04e = (0, $2M1hQ.createResource)({
    type: (0, $025c2a539475c8ec$export$179a0d35e95a4d61),
    getKey: ({ query: query, match: match })=>`lastVisitedProgramBoardId_${query.id}_${match.params.planId}_${match.params.scenarioId}`,
    getData: async ({ match: match })=>{
        // Sometimes currentPlanId isn't yet ready - we retry a few times to check if it has loaded in before making the request
        const RETRIES = 3;
        const DELAY = 500;
        const attemptFetch = async (remainingRetries)=>{
            const currentPlanId = match.params.planId;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(currentPlanId)) {
                const defaultBoardIdResponse = await (0, $eusud.performGetRequest)(`/rest/jpo/2.0/plans/${currentPlanId}/increments/default`);
                if (defaultBoardIdResponse === null) return {
                    boardId: null
                };
                const { id: id } = defaultBoardIdResponse;
                return {
                    boardId: id
                };
            }
            if (remainingRetries > 0) {
                await new Promise((resolve)=>setTimeout(resolve, DELAY));
                return attemptFetch(remainingRetries - 1);
            }
            throw new Error('Attempted to get the last visited program board of a plan without a plan id after multiple retries.');
        };
        return attemptFetch(RETRIES);
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});

});
const $025c2a539475c8ec$export$68390102872336b6 = 'ADVANCED_ROADMAPS_PLAN_INITIAL_CHECKS';
const $025c2a539475c8ec$export$a00e869cafd63140 = 'ADVANCED_ROADMAPS_REPORT_INITIAL_CHECKS';
const $025c2a539475c8ec$export$a0893d695ebee984 = 'ADVANCED_ROADMAPS_SCENARIO_ID';
const $025c2a539475c8ec$export$179a0d35e95a4d61 = 'ADVANCED_ROADMAPS_LAST_VISITED_PROGRAM_BOARD_ID';


parcelRegister("6vwaX", function(module, exports) {

$parcel$export(module.exports, "arjCalendarEmbedRoute", () => $6f41180defbce930$export$30779cab3c860456);
const $6f41180defbce930$export$30779cab3c860456 = {
    name: 'software-plan-calendar-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/calendar/embed'
};

});

parcelRegister("kZOse", function(module, exports) {

$parcel$export(module.exports, "CalendarSkeleton", () => $7999bdaf81f7939b$export$ebc7c47cc535837e);
$parcel$export(module.exports, "CalendarEmbedSkeleton", () => $7999bdaf81f7939b$export$bf543fe31d33292e);
$parcel$export(module.exports, "CalendarNoHeaderSkeleton", () => $7999bdaf81f7939b$export$504e7b05f3c54bf2);
/* CalendarSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $3a8Pq = parcelRequire("3a8Pq");

var $eqvk7 = parcelRequire("eqvk7");

var $hbVDT = parcelRequire("hbVDT");
const $7999bdaf81f7939b$var$customCssStyles = null;
const $7999bdaf81f7939b$export$ebc7c47cc535837e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3a8Pq)))
    });
const $7999bdaf81f7939b$export$bf543fe31d33292e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eqvk7)))
    });
const $7999bdaf81f7939b$export$504e7b05f3c54bf2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hbVDT))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("hCy6k", function(module, exports) {

$parcel$export(module.exports, "AppSkeletonImage", () => $a2cd0a6153845fd0$export$45b107c5dc7b51a5);
/* AppSkeletonImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8iquX = parcelRequire("8iquX");


var $koVbs = parcelRequire("koVbs");

var $d0Ozr = parcelRequire("d0Ozr");
const $a2cd0a6153845fd0$var$skeletonImageStyles = null;
const $a2cd0a6153845fd0$export$45b107c5dc7b51a5 = /*#__PURE__*/ (0, $5uXOq.memo)(({ src: src, className: className, containerStyles: containerStyles, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iquX.default), {
        name: "app-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2cd0a6153845fd0$var$SkeletonWrapper // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: src,
        "data-testid": testId,
        alt: `${formatMessage((0, $d0Ozr.default).loading)}...`,
        className: (0, $bwpsq.default)([
            "_1dqonqa1 _1h6d3acm _1e0c1ule _vchhusvi _1bsb1osq _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
            className
        ])
    })));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a2cd0a6153845fd0$var$SkeletonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d0Ozr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6abc81adadf77f72$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6abc81adadf77f72$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loading: {
        "id": "skeletons.common.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("3a8Pq", function(module, exports) {
module.exports = new URL("calendar-app-skeleton.tpl.77b09222.svg", import.meta.url).toString();

});

parcelRegister("eqvk7", function(module, exports) {
module.exports = new URL("calendar-embed-app-skeleton.tpl.29c9a641.svg", import.meta.url).toString();

});

parcelRegister("hbVDT", function(module, exports) {
module.exports = new URL("calendar-no-header-skeleton.tpl.d6779107.svg", import.meta.url).toString();

});


parcelRegister("02tNK", function(module, exports) {

$parcel$export(module.exports, "calendarEntryPoint", () => $8623df52c8647276$export$19cf4b398f638dc6);

var $4R6GH = parcelRequire("4R6GH");

var $7JhZX = parcelRequire("7JhZX");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");
const $8623df52c8647276$var$ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED = 'software-plan-calendar-embed';
const $8623df52c8647276$var$SETTINGS_STORAGE_KEY = 'plans_calendar_view_settings';
function $8623df52c8647276$var$getViewSettings(key) {
    try {
        const serializedValue = globalThis.localStorage?.getItem(key);
        return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
    } catch  {
        return undefined;
    }
}
function $8623df52c8647276$var$toPlanScenarioAri({ siteId: siteId, activationId: activationId, planId: planId, scenarioId: scenarioId }) {
    return `ari:cloud:jira:${siteId}:plan-scenario/activation/${activationId}/${planId}/scenario/${scenarioId}`;
}
function $8623df52c8647276$var$getStorageKeyFromScope(context) {
    const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
    const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
    return `${LOCALSTORAGE_KEY_PREFIX}/plan/${planId}/scenario/${scenarioId}`;
}
function $8623df52c8647276$var$getStorageValueFromScope(key) {
    const storedData = globalThis.localStorage?.getItem(key) || '';
    return storedData;
}
function $8623df52c8647276$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $8623df52c8647276$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $8623df52c8647276$var$createScope({ context: context, tenantContext: tenantContext }) {
    const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
    const { cloudId: cloudId, activationId: activationId } = tenantContext;
    const planScenarioAri = $8623df52c8647276$var$toPlanScenarioAri({
        siteId: cloudId,
        activationId: activationId,
        planId: String(planId),
        scenarioId: String(scenarioId)
    });
    return {
        type: 'plan',
        ids: [
            planScenarioAri
        ]
    };
}
function $8623df52c8647276$var$buildScopeInput(scope) {
    return {
        ids: scope.ids
    };
}
function $8623df52c8647276$var$buildViewId(scope) {
    // plan scenario ARI is the view id
    return scope.ids?.[0] ?? '';
}
function $8623df52c8647276$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $8623df52c8647276$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $8623df52c8647276$var$toCalendarWeekStart(weekStart) {
    switch(weekStart){
        case 'sunday':
            return 'sunday';
        case 'saturday':
            return 'saturday';
        default:
            return 'monday';
    }
}
function $8623df52c8647276$var$toCalendarColorBy(colorBy) {
    switch(colorBy){
        case 'none':
            return 'none';
        case 'status':
            return 'status';
        default:
            return 'status';
    }
}
function $8623df52c8647276$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField, viewId: viewId }) {
    return {
        date: $8623df52c8647276$var$toMidnightUTCString(selectedDate),
        mode: $8623df52c8647276$var$toViewMode(viewRange),
        weekStart: $8623df52c8647276$var$toWeekStart(weekStartsOn),
        ...(0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? {
            startDateField: startDateField,
            endDateField: endDateField
        } : {},
        viewId: viewId
    };
}
function $8623df52c8647276$var$buildIssuesSearchInput(storageKey, // remove optional attribute when cleaning up fg smart_links_for_plans
filter, isEmbed) {
    if ((0, $4R6GH.fg)('smart_links_for_plans')) return {
        additionalFilterQuery: isEmbed === true ? filter ?? '' : filter || $8623df52c8647276$var$getStorageValueFromScope(storageKey)
    };
    return {
        additionalFilterQuery: $8623df52c8647276$var$getStorageValueFromScope(storageKey)
    };
}
function $8623df52c8647276$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $8623df52c8647276$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $8623df52c8647276$var$buildCalendarCrossProjectVersionsInput() {
    return {
        statuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $8623df52c8647276$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}
function $8623df52c8647276$var$buildSettingsParams(hideWeekends, hideSprints, hideVersions, hideIssues, hideIssueKey, weekStartsOnQueryParam, colorBy) {
    if (hideWeekends || hideSprints || hideVersions || hideIssues || hideIssueKey || weekStartsOnQueryParam || colorBy) return {
        hideWeekends: hideWeekends === 'true' || undefined,
        hideSprints: hideSprints === 'true' || undefined,
        hideVersions: hideVersions === 'true' || undefined,
        hideIssues: hideIssues === 'true' || undefined,
        hideIssueKey: hideIssueKey === 'true' || undefined,
        weekStartsOn: $8623df52c8647276$var$toCalendarWeekStart(weekStartsOnQueryParam),
        colorBy: $8623df52c8647276$var$toCalendarColorBy(colorBy)
    };
    return undefined;
}

const $8623df52c8647276$export$19cf4b398f638dc6 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("8TKMO")), {
        moduleId: "53aec496"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const scope = $8623df52c8647276$var$createScope(entryPointRouteParams);
        const scopeInput = $8623df52c8647276$var$buildScopeInput(scope);
        const { date: date, filter: filter, hideWeekends: hideWeekends, hideSprints: hideSprints, hideVersions: hideVersions, hideIssues: hideIssues, hideIssueKey: hideIssueKey, weekStartsOn: weekStartsOnQueryParam, colorBy: colorByQueryParam } = context.query;
        const selectedDate = $8623df52c8647276$var$toDate(date);
        const hasFilterQueryParam = (0, $4R6GH.fg)('smart_links_for_plans') ? Boolean(filter) : false;
        const routeName = (0, $4R6GH.fg)('smart_links_for_plans') ? context.route.name : '';
        const settingsQueryParams = (0, $4R6GH.fg)('smart_links_for_plans') ? $8623df52c8647276$var$buildSettingsParams(hideWeekends, hideSprints, hideVersions, hideIssues, hideIssueKey, weekStartsOnQueryParam, colorByQueryParam) : {};
        const isEmbed = (0, $4R6GH.fg)('smart_links_for_plans') ? routeName === $8623df52c8647276$var$ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED : false;
        const settings = (0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? $8623df52c8647276$var$getViewSettings($8623df52c8647276$var$SETTINGS_STORAGE_KEY) : undefined;
        const viewRange = 'month';
        const weekStartsOn = (0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? settingsQueryParams?.weekStartsOn ?? settings?.weekStartsOn ?? 'monday' : 'monday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        const storageKey = $8623df52c8647276$var$getStorageKeyFromScope(context);
        const viewId = $8623df52c8647276$var$buildViewId(scope);
        const filterQuery = (0, $4R6GH.fg)('smart_links_for_plans') ? $8623df52c8647276$var$buildIssuesSearchInput(storageKey, filter, isEmbed) : $8623df52c8647276$var$buildIssuesSearchInput(storageKey);
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $7JhZX.default,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: scopeInput,
                        configurationInput: $8623df52c8647276$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField,
                            viewId: viewId
                        }),
                        issuesPageSize: 50,
                        issuesSearchInput: filterQuery,
                        unscheduledIssuesSearchInput: $8623df52c8647276$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $8623df52c8647276$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $8623df52c8647276$var$buildSprintsSearchInput(),
                        crossProjectVersionsSearchInput: $8623df52c8647276$var$buildCalendarCrossProjectVersionsInput(),
                        viewId: viewId,
                        skipSprintSearch: false,
                        skipPanelIssueSearch: true,
                        skipCrossProjectVersionSearch: false,
                        schedulePermissionsEnabled: (0, $4R6GH.fg)('calendar_schedule_issue_permissions_check'),
                        pageLoadMoreEnabled: (0, $4R6GH.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV1Search: (0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        skipVersionsV2Search: !(0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        includeRecurrenceIndicator: false,
                        pageLoadMoreEnabledViewSettings: (0, $4R6GH.fg)('jira_calendar_load_more_pagination_view_settings')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                storageKey: storageKey,
                hasFilterQueryParam: hasFilterQueryParam,
                routeName: routeName,
                settingsQueryParams: settingsQueryParams,
                filterQuery: (0, $4R6GH.fg)('smart_links_for_plans') ? filterQuery.additionalFilterQuery : undefined
            }
        };
    }
});

});
parcelRegister("7JhZX", function(module, exports) {

$parcel$export(module.exports, "default", () => $122674b135b0c50b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2d36a9f85c5349b0ef9cbca078ed35a3>>
 * @relayHash ce78f88e717be15868a81b929e46b29a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8992349e96ccc6c73b6fb84302696f5d4cd0750beeeff610bc86d29382273273

var $jczjB = parcelRequire("jczjB");
const $122674b135b0c50b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8992349e96ccc6c73b6fb84302696f5d4cd0750beeeff610bc86d29382273273",
        "metadata": {},
        "name": "ui_jiraCalendarQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjiracalendarreleaseflyoutlazyloadingenabledrelayprovider": (0, $jczjB.default)
        }
    }
};
var $122674b135b0c50b$export$2e2bcd8739ae039 = $122674b135b0c50b$var$node;

});
parcelRegister("jczjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b693d306308748$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $51b693d306308748$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('jira_calendar_release_flyout_lazy_loading', 'isEnabled', false);
    }
};

});


parcelRegister("8TKMO", function(module, exports) {

let $67a7c08f006d53f0$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $67a7c08f006d53f0$var$load("kfXhT"),
    $67a7c08f006d53f0$var$load("2Lfdl"),
    $67a7c08f006d53f0$var$load("cM9em"),
    $67a7c08f006d53f0$var$load("fr9NE"),
    $67a7c08f006d53f0$var$load("h2MrD"),
    $67a7c08f006d53f0$var$load("bYT2S"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("axKNq"), 4)),
    $67a7c08f006d53f0$var$load("dsiAd"),
    $67a7c08f006d53f0$var$load("gsa5D")
]).then(()=>parcelRequire('5zu1k'));

});
parcelRegister("aMHR6", function(module, exports) {
"use strict";

var $g1Pp8 = parcelRequire("g1Pp8");
module.exports = $g1Pp8(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("g1Pp8", function(module, exports) {
"use strict";
let $bab49d2fea43af49$var$cachedBundles = {};
let $bab49d2fea43af49$var$cachedPreloads = {};
let $bab49d2fea43af49$var$cachedPrefetches = {};
function $bab49d2fea43af49$var$getCache(type) {
    switch(type){
        case 'preload':
            return $bab49d2fea43af49$var$cachedPreloads;
        case 'prefetch':
            return $bab49d2fea43af49$var$cachedPrefetches;
        default:
            return $bab49d2fea43af49$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        let cache = $bab49d2fea43af49$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});





parcelRegister("aVGYm", function(module, exports) {

$parcel$export(module.exports, "arjDependenciesEmbedRouteEntry", () => $b6a501a17ba8d16b$export$2506a377ba649c46);

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $2Ql51 = parcelRequire("2Ql51");

var $2NIIP = parcelRequire("2NIIP");

var $5lsNZ = parcelRequire("5lsNZ");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $1zjAp = parcelRequire("1zjAp");

var $k7MTs = parcelRequire("k7MTs");
const $b6a501a17ba8d16b$var$planDependenciesReportEmbedRouteEntry = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $1zjAp.planDependenciesReportEntryPoint)
});
const $b6a501a17ba8d16b$export$2506a377ba649c46 = (0, $7NszV.createEntry)((0, $2NIIP.arjDependenciesEmbedRoute), ()=>({
        group: 'software',
        component: (0, $cSD7y.componentWithFG)('smart_links_for_plans', (0, $k7MTs.PlanDependenciesReportEmbedPage), (0, $5lsNZ.default)),
        entryPoint: ()=>(0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? $b6a501a17ba8d16b$var$planDependenciesReportEmbedRouteEntry : undefined,
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $2Ql51.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            (0, $k7MTs.LazyPlanDependenciesReportEmbed)
        ]
    }));

});
parcelRegister("2NIIP", function(module, exports) {

$parcel$export(module.exports, "arjDependenciesEmbedRoute", () => $994711b55bffb4b7$export$96aaf89753980215);
const $994711b55bffb4b7$export$96aaf89753980215 = {
    name: 'software-plan-dependencies-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies/embed'
};

});

parcelRegister("1zjAp", function(module, exports) {

$parcel$export(module.exports, "planDependenciesReportEntryPoint", () => $d023c1f5bac3e782$export$e4ba4cc5a2304191);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $d023c1f5bac3e782$export$e4ba4cc5a2304191 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>{
        if (!false) return (parcelRequire("aDNig"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "1a1a3500"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aDNig", function(module, exports) {

let $7bf3c88f9a4247c8$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $7bf3c88f9a4247c8$var$load("kfXhT"),
    $7bf3c88f9a4247c8$var$load("2Lfdl"),
    $7bf3c88f9a4247c8$var$load("cM9em"),
    $7bf3c88f9a4247c8$var$load("fr9NE"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("4XDQa"), 4)),
    $7bf3c88f9a4247c8$var$load("dsiAd"),
    $7bf3c88f9a4247c8$var$load("8czeq")
]).then(()=>parcelRequire('9WfFd'));

});


parcelRegister("k7MTs", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSummaryEmbed", () => $39df6cea3ba994f5$export$b0feb6e650be3c8c);
$parcel$export(module.exports, "PlanSummaryEmbedPage", () => $39df6cea3ba994f5$export$a37f296d90476a73);
$parcel$export(module.exports, "LazyPlanDependenciesReportEmbed", () => $39df6cea3ba994f5$export$48681ab0b4246654);
$parcel$export(module.exports, "PlanDependenciesReportEmbedPage", () => $39df6cea3ba994f5$export$4ece7fb6c15037f9);
$parcel$export(module.exports, "LazyPlanIncrementEmbed", () => $39df6cea3ba994f5$export$51f2083dff1ee684);
$parcel$export(module.exports, "PlanIncrementEmbedPage", () => $39df6cea3ba994f5$export$a2ae011b90c17927);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $39df6cea3ba994f5$export$b0feb6e650be3c8c = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4OJVt"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-summary/index.tsx"
});
const $39df6cea3ba994f5$export$a37f296d90476a73 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $39df6cea3ba994f5$export$b0feb6e650be3c8c,
        pageId: "plan-summary-embed-old",
        shouldShowSpinner: true
    });

const $39df6cea3ba994f5$export$48681ab0b4246654 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("koHo3")).then(({ PlanDependenciesReportWithoutPageHeader: PlanDependenciesReportWithoutPageHeader })=>PlanDependenciesReportWithoutPageHeader)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-dependencies-report/index-old.tsx"
});
const $39df6cea3ba994f5$export$4ece7fb6c15037f9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $39df6cea3ba994f5$export$48681ab0b4246654,
        pageId: "plan-dependencies-report-embed-old",
        shouldShowSpinner: true
    });

const $39df6cea3ba994f5$export$51f2083dff1ee684 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("63F1J")).then(({ PlanIncrementWithoutPageHeader: PlanIncrementWithoutPageHeader })=>PlanIncrementWithoutPageHeader)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increment/index-old.tsx"
});
const $39df6cea3ba994f5$export$a2ae011b90c17927 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $39df6cea3ba994f5$export$51f2083dff1ee684,
        pageId: "plan-increment-embed-old",
        shouldShowSpinner: true
    });

});
parcelRegister("4OJVt", function(module, exports) {

let $381f74e1f32d8742$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("8kWVn"), 4)),
    $381f74e1f32d8742$var$load("83FIe")
]).then(()=>parcelRequire('3Wpua'));

});

parcelRegister("koHo3", function(module, exports) {

let $ed97b44a4ef4a536$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $ed97b44a4ef4a536$var$load("kfXhT"),
    $ed97b44a4ef4a536$var$load("2Lfdl"),
    $ed97b44a4ef4a536$var$load("cM9em"),
    $ed97b44a4ef4a536$var$load("fr9NE"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("iPFEM"), 4)),
    $ed97b44a4ef4a536$var$load("dsiAd"),
    $ed97b44a4ef4a536$var$load("fb0ZT")
]).then(()=>parcelRequire('kTf8P'));

});

parcelRegister("63F1J", function(module, exports) {

let $4692d8fa53ee4b27$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $4692d8fa53ee4b27$var$load("kfXhT"),
    $4692d8fa53ee4b27$var$load("2Lfdl"),
    $4692d8fa53ee4b27$var$load("hPzOn"),
    $4692d8fa53ee4b27$var$load("h2MrD"),
    $4692d8fa53ee4b27$var$load("bYT2S"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("6SJaf"), 4)),
    $4692d8fa53ee4b27$var$load("cM9em"),
    $4692d8fa53ee4b27$var$load("fr9NE"),
    $4692d8fa53ee4b27$var$load("dsiAd"),
    $4692d8fa53ee4b27$var$load("bG97A")
]).then(()=>parcelRequire('fgv4D'));

});



parcelRegister("2DH60", function(module, exports) {

$parcel$export(module.exports, "arjIncrementEmbedRouteEntry", () => $ddc531e0f3e9c8bc$export$3feed0b4da010c52);

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $2Ql51 = parcelRequire("2Ql51");

var $ddtN3 = parcelRequire("ddtN3");

var $5lsNZ = parcelRequire("5lsNZ");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $8tlKP = parcelRequire("8tlKP");

var $k7MTs = parcelRequire("k7MTs");
const $ddc531e0f3e9c8bc$var$planProgramEmbedRouteEntry = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $8tlKP.planIncrementEntryPoint)
});
const $ddc531e0f3e9c8bc$export$3feed0b4da010c52 = (0, $7NszV.createEntry)((0, $ddtN3.arjIncrementEmbedRoute), ()=>({
        group: 'software',
        component: (0, $cSD7y.componentWithFG)('smart_links_for_plans', (0, $k7MTs.PlanIncrementEmbedPage), (0, $5lsNZ.default)),
        entryPoint: ()=>(0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? $ddc531e0f3e9c8bc$var$planProgramEmbedRouteEntry : undefined,
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $2Ql51.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            (0, $k7MTs.LazyPlanIncrementEmbed)
        ]
    }));

});
parcelRegister("ddtN3", function(module, exports) {

$parcel$export(module.exports, "arjIncrementEmbedRoute", () => $0b961407c2693247$export$88913ef2dfa37bc1);
const $0b961407c2693247$export$88913ef2dfa37bc1 = {
    name: 'software-plan-increment-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId/embed'
};

});

parcelRegister("8tlKP", function(module, exports) {

$parcel$export(module.exports, "planIncrementEntryPoint", () => $fe259e4b6c6f1cb0$export$72cc8a7d91a08ace);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $fe259e4b6c6f1cb0$export$72cc8a7d91a08ace = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>{
        if (!false) return (parcelRequire("iLrgP"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "6d0a9b0d"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iLrgP", function(module, exports) {

let $da91c5229fedfb42$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $da91c5229fedfb42$var$load("kfXhT"),
    $da91c5229fedfb42$var$load("2Lfdl"),
    $da91c5229fedfb42$var$load("hPzOn"),
    $da91c5229fedfb42$var$load("h2MrD"),
    $da91c5229fedfb42$var$load("bYT2S"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("bxjtM"), 4)),
    $da91c5229fedfb42$var$load("cM9em"),
    $da91c5229fedfb42$var$load("fr9NE"),
    $da91c5229fedfb42$var$load("dsiAd"),
    $da91c5229fedfb42$var$load("jcetw")
]).then(()=>parcelRequire('f3Kyg'));

});



parcelRegister("a5XVU", function(module, exports) {

$parcel$export(module.exports, "arjSummaryEmbedRouteEntry", () => $6fb04257162ebb90$export$bdc2c75e02c29d7);

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $lv9xW = parcelRequire("lv9xW");

var $3RJkv = parcelRequire("3RJkv");

var $2Ql51 = parcelRequire("2Ql51");

var $7BjJ7 = parcelRequire("7BjJ7");

var $5lsNZ = parcelRequire("5lsNZ");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $739vE = parcelRequire("739vE");

var $k7MTs = parcelRequire("k7MTs");
const $6fb04257162ebb90$var$planSummaryEmbedRouteEntry = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $739vE.planSummaryEntryPoint)
});
const $6fb04257162ebb90$export$bdc2c75e02c29d7 = (0, $7NszV.createEntry)((0, $7BjJ7.arjSummaryEmbedRoute), ()=>({
        group: 'software',
        component: (0, $cSD7y.componentWithFG)('smart_links_for_plans', (0, $k7MTs.PlanSummaryEmbedPage), (0, $5lsNZ.default)),
        entryPoint: ()=>(0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? $6fb04257162ebb90$var$planSummaryEmbedRouteEntry : undefined,
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $lv9xW.advancedRoadmapsSummaryDataResource),
            (0, $2Ql51.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            (0, $k7MTs.LazyPlanSummaryEmbed)
        ]
    }));

});
parcelRegister("lv9xW", function(module, exports) {

$parcel$export(module.exports, "advancedRoadmapsSummaryDataResource", () => $f87ae7e2901ac155$export$f9061628830b5175);
$parcel$export(module.exports, "fetchAdvancedRoadmapsSummaryData", () => $f87ae7e2901ac155$export$2dfe99460dae6bc6);

var $4R6GH = parcelRequire("4R6GH");

var $7f4tk = parcelRequire("7f4tk");

var $2M1hQ = parcelRequire("2M1hQ");

var $5m5rT = parcelRequire("5m5rT");

var $iz4dr = parcelRequire("iz4dr");
// we have to use location.search as we want to get params dynamically and rrr doesn't support it
// more info: https://atlassian-labs.github.io/react-resource-router/#/resources/usage?id=accessing-resource-state-for-another-route-or-url
const $f87ae7e2901ac155$var$getQueryParams = (routerQuery)=>{
    if (typeof window !== 'undefined') return Object.fromEntries(new URLSearchParams(window.location.search));
    return routerQuery;
};
const $f87ae7e2901ac155$export$f9061628830b5175 = (0, $2M1hQ.createResource)({
    type: 'ADVANCED_ROADMAPS_SUMMARY_DATA',
    getKey: ({ match: match })=>{
        const { params: params } = match;
        if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
        // Just return fallback string if on a page that doesn't have a planId or scenarioId
        return 'none';
    },
    getData: async ({ match: match, query: query })=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.__ARJ_SUMMARY_PAGE_PROMISE__) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const response = window.__ARJ_SUMMARY_PAGE_PROMISE__;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__ARJ_SUMMARY_PAGE_PROMISE__ = null;
            return response;
        }
        const { params: params } = match;
        return $f87ae7e2901ac155$export$2dfe99460dae6bc6(params, query, (0, $5m5rT.AVAILABLE_CHARTS));
    },
    maxAge: Infinity,
    isBrowserOnly: true
});
const $f87ae7e2901ac155$export$2dfe99460dae6bc6 = async (params, query, chartTypes)=>{
    if (params.planId == null) throw new Error('Unable to get fetch data for ADVANCED_ROADMAPS_SUMMARY_DATA. planId is not defined');
    if ((0, $4R6GH.fg)('smart_links_for_plans')) {
        const dateRange = (0, $iz4dr.validateDateRange)((0, $iz4dr.parseDateRange)($f87ae7e2901ac155$var$getQueryParams(query)));
        const data = await (0, $7f4tk.default)('/rest/jpo/1.0/summary/data', {
            method: 'POST',
            body: JSON.stringify({
                planId: params.planId,
                scenarioId: params.scenarioId,
                chartTypes: chartTypes,
                ...dateRange ? {
                    dateRange: dateRange
                } : {}
            })
        });
        return dateRange ? {
            ...data,
            customDateRange: dateRange
        } : data;
    }
    const { startDate: startDate, endDate: endDate } = $f87ae7e2901ac155$var$getQueryParams(query);
    const customDateRangeParams = startDate && endDate ? {
        startDate: startDate,
        endDate: endDate
    } : {};
    const data = await (0, $7f4tk.default)('/rest/jpo/1.0/summary/data', {
        method: 'POST',
        body: JSON.stringify({
            planId: params.planId,
            scenarioId: params.scenarioId,
            chartTypes: chartTypes,
            ...customDateRangeParams
        })
    });
    return data;
};

});
parcelRegister("5m5rT", function(module, exports) {

$parcel$export(module.exports, "CHART_TYPES", () => $d315f648a94f47c0$export$3251435144ca69e2);
$parcel$export(module.exports, "AVAILABLE_CHARTS", () => $d315f648a94f47c0$export$79cf9c14f738d70b);
$parcel$export(module.exports, "SCHEDULING_MODES", () => $d315f648a94f47c0$export$92daf59e30346cd2);
$parcel$export(module.exports, "CAPACITY_UNIT", () => $d315f648a94f47c0$export$494e761f17fc60a9);
$parcel$export(module.exports, "SPRINT_STATE", () => $d315f648a94f47c0$export$38e437924c2adbda);
const $d315f648a94f47c0$export$3251435144ca69e2 = {
    statusCategory: 'STATUS_CATEGORY',
    issueProgress: 'ISSUE_PROGRESS',
    teamProgress: 'TEAM_PROGRESS',
    teamCapacity: 'TEAM_CAPACITY',
    blockers: 'BLOCKERS',
    highestPriority: 'HIGHEST_PRIORITY',
    unassignedIssues: 'UNASSIGNED_ISSUES',
    overlappingBlockers: 'OVERLAPPING_BLOCKERS',
    overdue: 'OVERDUE'
};
const $d315f648a94f47c0$export$79cf9c14f738d70b = [
    $d315f648a94f47c0$export$3251435144ca69e2.statusCategory,
    $d315f648a94f47c0$export$3251435144ca69e2.issueProgress,
    $d315f648a94f47c0$export$3251435144ca69e2.teamProgress,
    $d315f648a94f47c0$export$3251435144ca69e2.teamCapacity,
    $d315f648a94f47c0$export$3251435144ca69e2.blockers,
    $d315f648a94f47c0$export$3251435144ca69e2.highestPriority,
    $d315f648a94f47c0$export$3251435144ca69e2.unassignedIssues,
    $d315f648a94f47c0$export$3251435144ca69e2.overlappingBlockers,
    $d315f648a94f47c0$export$3251435144ca69e2.overdue
];
const $d315f648a94f47c0$export$92daf59e30346cd2 = {
    SCRUM: 'Scrum',
    KANBAN: 'Kanban'
};
const $d315f648a94f47c0$export$494e761f17fc60a9 = {
    HOURS: 'HOURS',
    POINTS: 'STORY_POINTS',
    DAYS: 'DAYS'
};
const $d315f648a94f47c0$export$38e437924c2adbda = {
    CLOSED: 'CLOSED',
    ACTIVE: 'ACTIVE',
    FUTURE: 'FUTURE'
};

});

parcelRegister("iz4dr", function(module, exports) {

$parcel$export(module.exports, "parseDateRange", () => $8d575024c745c5c9$export$1cd7060bc72a318c);
$parcel$export(module.exports, "validateDateRange", () => $8d575024c745c5c9$export$b3e10550232e39db);
/**
 * Most of the code here is duplicated from `@atlassian/portfolio-3-summary-page`. We do not want to depend on all
 * the code from that package, but we want to parse and validate the date range before sending to the backend.
 */ 
var $gZ6zR = parcelRequire("gZ6zR");
const $8d575024c745c5c9$export$637d8b0948b783c7 = {
    [(0, $gZ6zR.DATE_UNITS).DAYS]: 3650,
    [(0, $gZ6zR.DATE_UNITS).WEEKS]: 520,
    [(0, $gZ6zR.DATE_UNITS).MONTHS]: 120
};
const $8d575024c745c5c9$export$cf70eebe96d0cb07 = (type)=>{
    switch(type){
        case (0, $gZ6zR.CUSTOM_TIME_RANGE_TYPES).FIXED:
        case (0, $gZ6zR.CUSTOM_TIME_RANGE_TYPES).RELATIVE:
            return type;
        default:
            return undefined;
    }
};
const $8d575024c745c5c9$export$6bf0e8cf8e1d780d = (value)=>{
    if (value === undefined) return undefined;
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? undefined : parsed;
};
const $8d575024c745c5c9$export$c777dd44ece05114 = (unit)=>{
    switch(unit){
        case (0, $gZ6zR.DATE_UNITS).DAYS:
        case (0, $gZ6zR.DATE_UNITS).WEEKS:
        case (0, $gZ6zR.DATE_UNITS).MONTHS:
            return unit;
        default:
            return undefined;
    }
};
const $8d575024c745c5c9$export$1cd7060bc72a318c = (query)=>{
    const { fromDate: fromDate, toDate: toDate, toNow: toNow, fromNow: fromNow, toNowUnit: toNowUnit, fromNowUnit: fromNowUnit, dateRangeType: dateRangeType } = query;
    return {
        typeOfCustomDateRange: $8d575024c745c5c9$export$cf70eebe96d0cb07(dateRangeType),
        fromDate: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(fromDate),
        toDate: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(toDate),
        fromNowUnitCount: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(fromNow),
        toNowUnitCount: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(toNow),
        fromNowUnit: $8d575024c745c5c9$export$c777dd44ece05114(fromNowUnit),
        toNowUnit: $8d575024c745c5c9$export$c777dd44ece05114(toNowUnit)
    };
};
const $8d575024c745c5c9$export$68346777682e262 = (count, unit)=>{
    if (count === undefined || unit === undefined) return false;
    return count >= 0 && count <= $8d575024c745c5c9$export$637d8b0948b783c7[unit];
};
const $8d575024c745c5c9$export$1ba31c57b50b4374 = (timestamp)=>{
    if (timestamp === undefined) return false;
    const date = new Date(timestamp);
    return !Number.isNaN(date.getTime());
};
const $8d575024c745c5c9$export$b3e10550232e39db = (dateRange)=>{
    const { fromDate: fromDate, toDate: toDate, toNowUnitCount: toNowUnitCount, toNowUnit: toNowUnit, fromNowUnitCount: fromNowUnitCount, fromNowUnit: fromNowUnit, typeOfCustomDateRange: typeOfCustomDateRange } = dateRange;
    if (typeOfCustomDateRange === (0, $gZ6zR.CUSTOM_TIME_RANGE_TYPES).RELATIVE && $8d575024c745c5c9$export$68346777682e262(toNowUnitCount, toNowUnit) && $8d575024c745c5c9$export$68346777682e262(fromNowUnitCount, fromNowUnit)) return {
        toNowUnitCount: toNowUnitCount,
        toNowUnit: toNowUnit,
        fromNowUnitCount: fromNowUnitCount,
        fromNowUnit: fromNowUnit,
        typeOfCustomDateRange: typeOfCustomDateRange
    };
    if (typeOfCustomDateRange === (0, $gZ6zR.CUSTOM_TIME_RANGE_TYPES).FIXED && $8d575024c745c5c9$export$1ba31c57b50b4374(fromDate) && $8d575024c745c5c9$export$1ba31c57b50b4374(toDate)) return {
        fromDate: fromDate,
        toDate: toDate,
        typeOfCustomDateRange: typeOfCustomDateRange
    };
    return undefined;
};

});
parcelRegister("gZ6zR", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_TIME_RANGE_TYPES", () => $ad83cd0410dc011b$export$78e07fecfaf51c7b);
$parcel$export(module.exports, "DATE_UNITS", () => $ad83cd0410dc011b$export$c99d20cdba4a5739);
$parcel$export(module.exports, "IssueStatus", () => $ad83cd0410dc011b$export$559eb15a98685419);
$parcel$export(module.exports, "BlockType", () => $ad83cd0410dc011b$export$48808c686fe495c4);
const $ad83cd0410dc011b$export$78e07fecfaf51c7b = {
    FIXED: 'fixed',
    RELATIVE: 'relative'
};
const $ad83cd0410dc011b$export$c99d20cdba4a5739 = {
    DAYS: 'days',
    MONTHS: 'months',
    WEEKS: 'weeks'
};
const $ad83cd0410dc011b$export$559eb15a98685419 = {
    TODO: 'TODO',
    IN_PROGRESS: 'IN_PROGRESS',
    DONE: 'DONE'
};
const $ad83cd0410dc011b$export$de194318c6dccbc1 = {
    INITIATIVE: 'INITIATIVE',
    EPIC: 'EPIC'
};
const $ad83cd0410dc011b$export$48808c686fe495c4 = {
    DELAY_WORK: 'DELAY_WORK',
    CRITICAL_PATH: 'CRITICAL_PATH',
    BLOCK_WORK: 'BLOCK_WORK'
};

});



parcelRegister("7BjJ7", function(module, exports) {

$parcel$export(module.exports, "arjSummaryEmbedRoute", () => $426fb5656e35864d$export$126053e8fb441b66);
const $426fb5656e35864d$export$126053e8fb441b66 = {
    name: 'software-plan-summary-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/summary/embed'
};

});

parcelRegister("739vE", function(module, exports) {

$parcel$export(module.exports, "planSummaryEntryPoint", () => $dd4685bcee1d8b30$export$82d8368ec1a526b);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $dd4685bcee1d8b30$export$82d8368ec1a526b = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>{
        if (!false) return (parcelRequire("4OJVt"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "c48db9c0"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("lUhpq", function(module, exports) {

$parcel$export(module.exports, "arjTimelineEmbedRouteEntry", () => $f243e346f149e756$export$a977d398db1904ff);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $2Ql51 = parcelRequire("2Ql51");

var $in8iE = parcelRequire("in8iE");

var $5lsNZ = parcelRequire("5lsNZ");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $lkFvK = parcelRequire("lkFvK");

var $4Xa0b = parcelRequire("4Xa0b");
const $f243e346f149e756$var$planTimelineEmbedRouteEntry = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $4Xa0b.planTimelineEntryPoint)
});

// Update to default import when cleaning getWillShowNav4
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f243e346f149e756$var$LazyPlanTimelineEmbed = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7M3Xq")).then(({ PlanTimelineWithoutHeader: PlanTimelineWithoutHeader })=>PlanTimelineWithoutHeader)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-timeline/index-old.tsx"
});
const $f243e346f149e756$var$PlanTimelineEmbedPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f243e346f149e756$var$LazyPlanTimelineEmbed,
        pageId: "plan-timeline-embed",
        shouldShowSpinner: true
    });
const $f243e346f149e756$export$a977d398db1904ff = (0, $7NszV.createEntry)((0, $in8iE.arjTimelineEmbedRoute), ()=>({
        group: 'software',
        component: (0, $cSD7y.componentWithFG)('smart_links_for_plans', $f243e346f149e756$var$PlanTimelineEmbedPage, (0, $5lsNZ.default)),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-opt-out-timeline'),
        entryPoint: ()=>(0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? $f243e346f149e756$var$planTimelineEmbedRouteEntry : undefined,
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $2Ql51.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            $f243e346f149e756$var$LazyPlanTimelineEmbed
        ]
    }));

});
parcelRegister("in8iE", function(module, exports) {

$parcel$export(module.exports, "arjTimelineEmbedRoute", () => $2ec71a69a22a9944$export$aadc28402ef87b84);
const $2ec71a69a22a9944$export$aadc28402ef87b84 = {
    name: 'software-advanced-roadmaps-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/timeline/embed'
};

});

parcelRegister("4Xa0b", function(module, exports) {

$parcel$export(module.exports, "planTimelineEntryPoint", () => $dfb41ee95126f54b$export$a36e3fca8afefb5b);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $dfb41ee95126f54b$export$a36e3fca8afefb5b = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>{
        if (!false) return (parcelRequire("7eEXf"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "0b69767e"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7eEXf", function(module, exports) {

let $54499beb5afb1c56$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $54499beb5afb1c56$var$load("kfXhT"),
    $54499beb5afb1c56$var$load("2Lfdl"),
    $54499beb5afb1c56$var$load("cM9em"),
    $54499beb5afb1c56$var$load("fr9NE"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("6uHGD"), 4)),
    $54499beb5afb1c56$var$load("dsiAd"),
    $54499beb5afb1c56$var$load("29Kha")
]).then(()=>parcelRequire('iL9n8'));

});


parcelRegister("7M3Xq", function(module, exports) {

let $5a9015f3bc5dbe0b$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $5a9015f3bc5dbe0b$var$load("kfXhT"),
    $5a9015f3bc5dbe0b$var$load("2Lfdl"),
    $5a9015f3bc5dbe0b$var$load("cM9em"),
    $5a9015f3bc5dbe0b$var$load("fr9NE"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("lLMA2"), 4)),
    $5a9015f3bc5dbe0b$var$load("dsiAd"),
    $5a9015f3bc5dbe0b$var$load("kfJJ8")
]).then(()=>parcelRequire('aT9Sm'));

});


parcelRegister("43Rln", function(module, exports) {

$parcel$export(module.exports, "legacyPlanPageRedirectRouteEntry", () => $10eae15c25a3521c$export$e9cfdb950d40e917);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4e0eu = parcelRequire("4e0eu");

var $3ibi7 = parcelRequire("3ibi7");

var $g6wgl = parcelRequire("g6wgl");
const $10eae15c25a3521c$export$e9cfdb950d40e917 = (0, $7NszV.createEntry)((0, $4e0eu.legacyPlanPageRedirectRoute), ()=>({
        group: 'software',
        component: (0, $3ibi7.RedirectLegacyPlanPage),
        isRedirect: true,
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $c3WQb.advancedRoadmapsScenarioIdResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("4e0eu", function(module, exports) {

$parcel$export(module.exports, "legacyPlanPageRedirectRoute", () => $72e984bd321d5543$export$1e324bd9675918a8);
const $72e984bd321d5543$export$1e324bd9675918a8 = {
    name: 'software-advanced-roadmaps-redirect',
    path: '/secure/PortfolioPlanView.jspa'
};

});

parcelRegister("3ibi7", function(module, exports) {

$parcel$export(module.exports, "RedirectLegacyPlanPage", () => $3e6624904a2f18eb$export$c3e4fda2290a52bf);
$parcel$export(module.exports, "RedirectPlanPageWithoutScenarioId", () => $3e6624904a2f18eb$export$ff420400c9900835);
$parcel$export(module.exports, "RedirectPlanPageWithoutScenarioIdLoadQuery", () => $3e6624904a2f18eb$export$e57364775e9e9634);

var $697YZ = parcelRequire("697YZ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $kb4zh = parcelRequire("kb4zh");

var $c3WQb = parcelRequire("c3WQb");

var $ds5qV = parcelRequire("ds5qV");

var $5W2CW = parcelRequire("5W2CW");

var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");

var $697YZ = parcelRequire("697YZ");

var $9OXo1 = parcelRequire("9OXo1");
const $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS = [
    'search'
];
const $3e6624904a2f18eb$var$RedirectLegacyPlanPageWithoutScenarioId = ()=>{
    const [{ query: query }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $c3WQb.advancedRoadmapsScenarioIdResource));
    if (loading || data === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/plans/${query.id}/scenarios/${data.scenarioId}`,
        persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
    });
};
const $3e6624904a2f18eb$export$c3e4fda2290a52bf = ()=>{
    const [{ query: query }] = (0, $doZTA.useRouter)();
    const { id: id, sid: sid } = query;
    if (Number.isNaN(Number.parseFloat(sid))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3e6624904a2f18eb$var$RedirectLegacyPlanPageWithoutScenarioId, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/plans/${id}/scenarios/${sid}`,
        persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
    });
};
const $3e6624904a2f18eb$export$ff420400c9900835 = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const { planId: planId } = match.params;
    if (planId === null || planId === undefined || Number.isNaN(Number.parseFloat(planId))) throw new Error('Plan cannot be loaded without planId');
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource));
    if (loading || data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
    if (!data.success) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5W2CW.ErrorScreen), {
        errorMessage: data.errorMessage
    });
    if (data.scenarioId === null || data.scenarioId === undefined || typeof data.scenarioId === 'string' && Number.isNaN(Number.parseFloat(data.scenarioId))) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/plans/${planId}/scenarios/${data.scenarioId}`,
        persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
    });
};
const $3e6624904a2f18eb$export$b2194d886d9f3b64 = ({ queryRef: queryRef, planId: planId })=>{
    const gqlData = (0, $8Uumt.usePreloadedQuery)((0, $697YZ.default), queryRef);
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource));
    const defaultTabUrl = gqlData?.jira?.planById?.defaultNavigationItem?.url;
    if (defaultTabUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: defaultTabUrl,
        persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
    });
    // Fallback if can not get defaultTabUrl
    if (loading || data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
    if (!data.success) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5W2CW.ErrorScreen), {
        errorMessage: data.errorMessage
    });
    if (data.scenarioId === null || data.scenarioId === undefined || typeof data.scenarioId === 'string' && Number.isNaN(Number.parseFloat(data.scenarioId))) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/plans/${planId}/scenarios/${data.scenarioId}`,
        persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
    });
};
const $3e6624904a2f18eb$export$e57364775e9e9634 = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const { planId: planId } = match.params;
    if (planId === null || planId === undefined || Number.isNaN(Number.parseFloat(planId))) throw new Error('Plan cannot be loaded without planId');
    const { cloudId: cloudId, activationId: activationId } = (0, $9OXo1.useTenantContext)();
    const [queryRef, loadQuery, disposeQuery] = (0, $8Uumt.useQueryLoader)((0, $697YZ.default));
    (0, $5uXOq.useEffect)(()=>{
        loadQuery({
            planId: `ari:cloud:jira:${cloudId}:plan/activation/${activationId}/${planId}`
        }, {
            fetchPolicy: 'store-or-network'
        });
        return disposeQuery;
    }, [
        loadQuery,
        disposeQuery,
        cloudId,
        activationId,
        planId
    ]);
    return queryRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3e6624904a2f18eb$export$b2194d886d9f3b64, {
        queryRef: queryRef,
        planId: planId
    }) : null;
};

});
parcelRegister("697YZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $da05f469fe76f276$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<513d91abcf431d67cd831934eb3cdd81>>
 * @relayHash c7ba33b8e7695997c7bbf9e29b42c7ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b22213e57ba6874b345876f3c35d0dda118f459e6007f6c559d80ba94b6d1fe
const $da05f469fe76f276$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "planId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "planId"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "JiraNavigationItem",
        "abstractKey": "__isJiraNavigationItem"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "planNoScenarioQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPlan",
                            "kind": "LinkedField",
                            "name": "planById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "LinkedField",
                                        "name": "defaultNavigationItem",
                                        "plural": false,
                                        "selections": [
                                            v2 /*: any*/ 
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.planById.defaultNavigationItem"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "planNoScenarioQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPlan",
                            "kind": "LinkedField",
                            "name": "planById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "defaultNavigationItem",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7b22213e57ba6874b345876f3c35d0dda118f459e6007f6c559d80ba94b6d1fe",
            "metadata": {},
            "name": "planNoScenarioQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$da05f469fe76f276$var$node.hash = "7791279196ac8025a83cda3fc2b29b08";
var $da05f469fe76f276$export$2e2bcd8739ae039 = $da05f469fe76f276$var$node;

});

parcelRegister("5W2CW", function(module, exports) {

$parcel$export(module.exports, "ErrorScreen", () => $50454f3b2d1014d6$export$42f84e610f279c31);

var $5uXOq = parcelRequire("5uXOq");

var $38Y30 = parcelRequire("38Y30");


var $6AaZy = parcelRequire("6AaZy");

var $1v2QX = parcelRequire("1v2QX");

var $jMY1T = parcelRequire("jMY1T");
const $50454f3b2d1014d6$export$42f84e610f279c31 = ({ errorMessage: errorMessage, isEmbedded: isEmbedded = false, planId: planId })=>{
    /**
	 * Clearing the early-preload promises here otherwise they get carried on to the following plan loads.
	 *
	 * The SPA app renders the ErrorScreen instead of the PlanApp when the validation fails,
	 * hence the early-preload promises did not get cleaned up.
	 */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.__ARJ_BACKLOG_PROMISE__;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.__ARJ_INFO_METADATA_PROMISE__;
    switch(errorMessage){
        case 0, $b31dd89598859846$export$aa64437890e7b596:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Y30.RedirectToLoginPage), null);
        case 0, $b31dd89598859846$export$3fe2400c9d24940d:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6AaZy.AsyncLicenseViolationErrorPage), {
                isEmbedded: isEmbedded
            });
        case 0, $b31dd89598859846$export$4589763db20bfd7f:
        case 0, $b31dd89598859846$export$7e6358a0c21dff8c:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jMY1T.AsyncNotFoundErrorPage), {
                entity: (0, $b31dd89598859846$export$c303e491e026ebc6),
                isEmbedded: isEmbedded
            });
        case 0, $b31dd89598859846$export$6519152a5f0e081:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jMY1T.AsyncNotFoundErrorPage), {
                entity: (0, $b31dd89598859846$export$9b928fc5e710e864),
                isEmbedded: isEmbedded,
                planId: planId
            });
        case 0, $b31dd89598859846$export$6128dc888243fa0a:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1v2QX.AsyncNoPlanPermissionErrorPage), {
                isEmbedded: isEmbedded
            });
        default:
            return null;
    }
};

});
parcelRegister("38Y30", function(module, exports) {

$parcel$export(module.exports, "RedirectToLoginPage", () => $08f8c3f776d557a9$export$938182bd3fddc3a8);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
var $ieDtd = parcelRequire("ieDtd");
var $doZTA = parcelRequire("doZTA");
const $08f8c3f776d557a9$export$3da29de62ed7a388 = ({ to: to })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window.location.assign("${to}")`
        }
    });
$08f8c3f776d557a9$export$3da29de62ed7a388.displayName = 'InlineRedirect';
const $08f8c3f776d557a9$export$938182bd3fddc3a8 = ()=>{
    const [{ location: { pathname: pathname, search: search } }] = (0, $doZTA.useRouter)();
    const redirectUrl = pathname + search;
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    let path = `/login.jsp?os_destination=${encodedRedirectUrl}`;
    const parentProductQueryName = 'parentProduct';
    const [parentProduct] = (0, $ieDtd.useQueryParam)(parentProductQueryName);
    if (pathname.endsWith('/embed')) {
        const searchParams = new URLSearchParams(search);
        // We need to remove parentProduct param as it is only used in embed urls
        searchParams.delete(parentProductQueryName);
        /**
		 * encodedLink is the link to the non embedded version of the embed url.
		 * So, we strip out the /embed suffix from path
		 */ let encodedLink = encodeURIComponent(`${pathname.slice(0, -6)}?${searchParams}`);
        /**
		 * this is the specific case for create issue embed, where we need to redirect
		 * user to your-work page with create issue as true to open GIC by default.
		 * We will remove this when we FPIC exp implemented for GIC
		 */ if (pathname.includes('/issues/create')) encodedLink = encodeURIComponent('/jira/your-work?createissue=true');
        const encodedParentProduct = encodeURIComponent(parentProduct || '');
        path = `/jira-login/embed?destination=${encodedRedirectUrl}&link=${encodedLink}&parentProduct=${encodedParentProduct}`;
    }
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08f8c3f776d557a9$export$3da29de62ed7a388, {
        to: path
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: path
    });
};

});

const $b31dd89598859846$export$aa64437890e7b596 = 'permission-violation';
const $b31dd89598859846$export$3fe2400c9d24940d = 'license-violation';
const $b31dd89598859846$export$4589763db20bfd7f = 'plan-not-found';
const $b31dd89598859846$export$6519152a5f0e081 = 'scenario-not-found';
const $b31dd89598859846$export$7e6358a0c21dff8c = 'report-not-found';
const $b31dd89598859846$export$6128dc888243fa0a = 'no-plan-permission';
const $b31dd89598859846$export$c303e491e026ebc6 = 'PLAN';
const $b31dd89598859846$export$9b928fc5e710e864 = 'SCENARIO';

parcelRegister("6AaZy", function(module, exports) {

$parcel$export(module.exports, "AsyncLicenseViolationErrorPage", () => $05d56fdddce8137e$export$f5d9764f07badc4d);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $05d56fdddce8137e$var$LazyLicenseViolationErrorPage = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("jCzEZ")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/license-violation/index.tsx"
});
const $05d56fdddce8137e$export$f5d9764f07badc4d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "arj-license-violation-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($05d56fdddce8137e$var$LazyLicenseViolationErrorPage, props));

});
parcelRegister("jCzEZ", function(module, exports) {

let $e48d3a4c710373c4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e48d3a4c710373c4$var$load("ikYJz").then(()=>parcelRequire('cGdIS'));

});


parcelRegister("1v2QX", function(module, exports) {

$parcel$export(module.exports, "AsyncNoPlanPermissionErrorPage", () => $d08fb773ac6c1816$export$e595d2c5dfcb1d5a);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $d08fb773ac6c1816$var$LazyNoPlanPermissionErrorPage = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("cEDBU")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/no-plan-permission/index.tsx"
});
const $d08fb773ac6c1816$export$e595d2c5dfcb1d5a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "arj-no-plan-permission",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d08fb773ac6c1816$var$LazyNoPlanPermissionErrorPage, props));

});
parcelRegister("cEDBU", function(module, exports) {

let $9367f2482a9feaf4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9367f2482a9feaf4$var$load("db3ID").then(()=>parcelRequire('dycHB'));

});


parcelRegister("jMY1T", function(module, exports) {

$parcel$export(module.exports, "AsyncNotFoundErrorPage", () => $900bf2ccc30cc7be$export$8f6c907860218fdc);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $900bf2ccc30cc7be$var$LazyNotFoundErrorPage = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("7vZj3")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/not-found/index.tsx"
});
const $900bf2ccc30cc7be$export$8f6c907860218fdc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "arj-not-found-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($900bf2ccc30cc7be$var$LazyNotFoundErrorPage, props));

});
parcelRegister("7vZj3", function(module, exports) {

let $578afbd567a9ac29$var$load = (parcelRequire("28QjX"))(4);
module.exports = $578afbd567a9ac29$var$load("4cS57").then(()=>parcelRequire('3jte6'));

});




parcelRegister("g6wgl", function(module, exports) {

$parcel$export(module.exports, "LazyPlanTimeline", () => $c8bd5810f2180a4a$export$bf48e5f1529ddaeb);
$parcel$export(module.exports, "default", () => $c8bd5810f2180a4a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $c8bd5810f2180a4a$export$bf48e5f1529ddaeb = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7M3Xq"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-timeline/index-old.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c8bd5810f2180a4a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c8bd5810f2180a4a$export$bf48e5f1529ddaeb,
        pageId: "plan-timeline",
        shouldShowSpinner: true
    });

});


parcelRegister("6Z4jF", function(module, exports) {

$parcel$export(module.exports, "legacyPlanReportPageRedirectRouteEntry", () => $be1254c729965d54$export$c2a4c5c6576a704c);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $j5aum = parcelRequire("j5aum");

var $5WheG = parcelRequire("5WheG");

var $g6wgl = parcelRequire("g6wgl");
const $be1254c729965d54$export$c2a4c5c6576a704c = (0, $7NszV.createEntry)((0, $j5aum.legacyPlanReportPageRedirectRoute), ()=>({
        group: 'software',
        component: (0, $5WheG.default),
        isRedirect: true,
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("j5aum", function(module, exports) {

$parcel$export(module.exports, "legacyPlanReportPageRedirectRoute", () => $c3430a8e44cc7ca2$export$7747547e845a016c);
const $c3430a8e44cc7ca2$export$7747547e845a016c = {
    name: 'software-advanced-roadmaps-redirect',
    path: '/secure/PortfolioReportView.jspa'
};

});

parcelRegister("5WheG", function(module, exports) {

$parcel$export(module.exports, "default", () => $135d7141d14abe41$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");

var $doZTA = parcelRequire("doZTA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$135d7141d14abe41$export$2e2bcd8739ae039 = ()=>{
    const [{ query: query }] = (0, $doZTA.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/plans/reports/${query.r}`,
        persistSearchParams: false
    });
};

});


parcelRegister("eLT92", function(module, exports) {

$parcel$export(module.exports, "planExportPageRouteEntry", () => $e17ef7a70aea4a64$export$d751e3552b21c604);

var $5uXOq = parcelRequire("5uXOq");

var $7NszV = parcelRequire("7NszV");

var $c3WQb = parcelRequire("c3WQb");

var $dht4a = parcelRequire("dht4a");

var $5j7Th = parcelRequire("5j7Th");

var $hGLha = parcelRequire("hGLha");

var $g6wgl = parcelRequire("g6wgl");
/**
 * Export Page
 */ const $e17ef7a70aea4a64$var$ExportPageComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hGLha.LazyAdvancedRoadmapsPlanExport), null);
const $e17ef7a70aea4a64$var$ExportPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e17ef7a70aea4a64$var$ExportPageComponent,
        pageId: "advanced-roadmap",
        shouldShowSpinner: true
    });
const $e17ef7a70aea4a64$export$d751e3552b21c604 = (0, $7NszV.createEntry)((0, $dht4a.planExportPageRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-scenario-export',
        component: $e17ef7a70aea4a64$var$ExportPage,
        layout: {
            isChromeless: true,
            globalComponents: [],
            rightSidebars: []
        },
        resources: [
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource)
        ],
        forPaint: [
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("dht4a", function(module, exports) {

$parcel$export(module.exports, "planExportPageRoute", () => $76c19eff2b41ddc4$export$2ca5fe6f9ab466c1);
const $76c19eff2b41ddc4$export$2ca5fe6f9ab466c1 = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/:planId/scenarios/:scenarioId/export'
};

});

parcelRegister("hGLha", function(module, exports) {

$parcel$export(module.exports, "LazyAdvancedRoadmapsPlanExport", () => $b6ed3ac1658c948e$export$890fb5003e472449);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $b6ed3ac1658c948e$export$890fb5003e472449 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("SbEsg"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b6ed3ac1658c948e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b6ed3ac1658c948e$export$890fb5003e472449,
        pageId: "advanced-roadmaps-plan",
        shouldShowSpinner: true
    });

});
parcelRegister("SbEsg", function(module, exports) {

let $0a2e15016a537276$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $0a2e15016a537276$var$load("kfXhT"),
    $0a2e15016a537276$var$load("2Lfdl"),
    $0a2e15016a537276$var$load("cM9em"),
    $0a2e15016a537276$var$load("fr9NE"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("ioM1b"), 4)),
    $0a2e15016a537276$var$load("dsiAd"),
    $0a2e15016a537276$var$load("LIqdo")
]).then(()=>parcelRequire('ecw8s'));

});



parcelRegister("cgOe5", function(module, exports) {

$parcel$export(module.exports, "planPageRouteEntry", () => $877bd5b2a7f04d5c$export$f85a75f1604118ff);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $eG65S = parcelRequire("eG65S");

var $g6wgl = parcelRequire("g6wgl");

var $caKhF = parcelRequire("caKhF");
// This redirect is required to support legacy routes, it should never be deleted
const $877bd5b2a7f04d5c$var$planPageRedirect = (0, $caKhF.withRedirection)((0, $g6wgl.default), {
    to: '/timeline',
    redirectCondition: ()=>true
});
const $877bd5b2a7f04d5c$export$f85a75f1604118ff = (0, $7NszV.createEntry)((0, $eG65S.planPageRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-scenario',
        component: $877bd5b2a7f04d5c$var$planPageRedirect,
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("eG65S", function(module, exports) {

$parcel$export(module.exports, "planPageRoute", () => $39ce5190353a5838$export$26495e043d80cccc);
const $39ce5190353a5838$export$26495e043d80cccc = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/:planId/scenarios/:scenarioId'
};

});

parcelRegister("caKhF", function(module, exports) {

$parcel$export(module.exports, "withRedirection", () => $25bed75d5ee084fd$export$2c9e4550ef8bdea9);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");

var $doZTA = parcelRequire("doZTA");
function $25bed75d5ee084fd$export$2c9e4550ef8bdea9(Component, { to: to, redirectCondition: redirectCondition }) {
    return ()=>{
        const [{ match: match }] = (0, $doZTA.useRouter)();
        if (match == null || match.params == null || match.params.planId == null || match.params.scenarioId == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
            to: "/jira/plans"
        });
        if (!redirectCondition()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
            to: `/jira/plans/${match.params.planId}/scenarios/${match.params.scenarioId}${to}`
        });
    };
}

});


parcelRegister("2d9QY", function(module, exports) {

$parcel$export(module.exports, "planPageWithoutScenarioIdRouteEntry", () => $c926071780746d94$export$9cbef73b51558ef);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4qTS7 = parcelRequire("4qTS7");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $3ibi7 = parcelRequire("3ibi7");

var $g6wgl = parcelRequire("g6wgl");
const $c926071780746d94$export$9cbef73b51558ef = (0, $7NszV.createEntry)((0, $4qTS7.planPageWithoutScenarioIdRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-plan',
        component: (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('plan-nav4-fix-plan-listing-redirection') ? (0, $3ibi7.RedirectPlanPageWithoutScenarioIdLoadQuery) : (0, $3ibi7.RedirectPlanPageWithoutScenarioId),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("4qTS7", function(module, exports) {

$parcel$export(module.exports, "planPageWithoutScenarioIdRoute", () => $d753ed11fe1ac80a$export$610e14c9c89d0afb);
const $d753ed11fe1ac80a$export$610e14c9c89d0afb = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/:planId(\\d+)'
};

});


parcelRegister("jj70V", function(module, exports) {

$parcel$export(module.exports, "planReportPageRouteEntry", () => $7a323ef2c1a2c74a$export$e71031acce6d7e47);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $aZkeA = parcelRequire("aZkeA");

var $3bZgP = parcelRequire("3bZgP");
const $7a323ef2c1a2c74a$export$e71031acce6d7e47 = (0, $7NszV.createEntry)((0, $aZkeA.planReportPageRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-report',
        component: (0, $3bZgP.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $c3WQb.advancedRoadmapsPlanReportPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3bZgP.LazyPlanReport)
        ]
    }));

});
parcelRegister("451ix", function(module, exports) {

$parcel$export(module.exports, "planLayout", () => $fa12faadb00e7e4f$export$94e1d79bf65579e2);

var $aPfsS = parcelRequire("aPfsS");

var $b7Svb = parcelRequire("b7Svb");

const $fa12faadb00e7e4f$export$b6292b5f7e5b5fad = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("bAnsq")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx"
});
const $fa12faadb00e7e4f$export$94e1d79bf65579e2 = (0, $aPfsS.createLayout)({
    globalComponents: [
        $fa12faadb00e7e4f$export$b6292b5f7e5b5fad
    ]
});

});
parcelRegister("bAnsq", function(module, exports) {

let $86f540ac39e02c6c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $86f540ac39e02c6c$var$load("9iCqI").then(()=>parcelRequire('ikoZN'));

});


parcelRegister("aZkeA", function(module, exports) {

$parcel$export(module.exports, "planReportPageRoute", () => $082ad5157a706ae9$export$7c8c0761b1ba57bb);
const $082ad5157a706ae9$export$7c8c0761b1ba57bb = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/reports/:reportId'
};

});

parcelRegister("3bZgP", function(module, exports) {

$parcel$export(module.exports, "LazyPlanReport", () => $620253f0b511b587$export$fe1fc08f511671db);
$parcel$export(module.exports, "default", () => $620253f0b511b587$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $620253f0b511b587$export$fe1fc08f511671db = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hcO9g"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-report/index.tsx"
});
const $620253f0b511b587$var$PlanReport = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $620253f0b511b587$export$fe1fc08f511671db,
        pageId: "plan-report",
        shouldShowSpinner: true
    });
var $620253f0b511b587$export$2e2bcd8739ae039 = $620253f0b511b587$var$PlanReport;

});
parcelRegister("hcO9g", function(module, exports) {

let $c86a751565d7b1bd$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $c86a751565d7b1bd$var$load("kfXhT"),
    $c86a751565d7b1bd$var$load("2Lfdl"),
    $c86a751565d7b1bd$var$load("cM9em"),
    $c86a751565d7b1bd$var$load("fr9NE"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("gWdbV"), 4)),
    $c86a751565d7b1bd$var$load("dsiAd"),
    $c86a751565d7b1bd$var$load("gF51l")
]).then(()=>parcelRequire('9UXSF'));

});



parcelRegister("4AqA1", function(module, exports) {

$parcel$export(module.exports, "planSetupPageRouteEntry", () => $3d84c56e2a698202$export$2a24acea4e628148);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $2wBti = parcelRequire("2wBti");

var $2RtMw = parcelRequire("2RtMw");
const $3d84c56e2a698202$export$2a24acea4e628148 = (0, $7NszV.createEntry)((0, $2wBti.planSetupPageRoute), ()=>({
        group: 'software',
        component: (0, $2RtMw.default),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2RtMw.LazyAdvancedRoadmapsSetup)
        ]
    }));

});
parcelRegister("2wBti", function(module, exports) {

$parcel$export(module.exports, "planSetupPageRoute", () => $08361bcde105abef$export$4815756bb523904e);
const $08361bcde105abef$export$4815756bb523904e = {
    name: 'software-advanced-roadmaps-setup',
    path: '/jira/plans/:planId/setup'
};

});

parcelRegister("2RtMw", function(module, exports) {

$parcel$export(module.exports, "LazyAdvancedRoadmapsSetup", () => $360fed07fa6fa9e9$export$46bb3a1779d7815b);
$parcel$export(module.exports, "default", () => $360fed07fa6fa9e9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $360fed07fa6fa9e9$export$46bb3a1779d7815b = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("2KBql"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/setup/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$360fed07fa6fa9e9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $360fed07fa6fa9e9$export$46bb3a1779d7815b,
        pageId: "advanced-roadmaps-setup",
        shouldShowSpinner: true
    });

});
parcelRegister("2KBql", function(module, exports) {

let $200ce83e870e0159$var$load = (parcelRequire("28QjX"))(4);
module.exports = $200ce83e870e0159$var$load("aRh7g").then(()=>parcelRequire('bF4NR'));

});



parcelRegister("2FVZu", function(module, exports) {

$parcel$export(module.exports, "softwareAdvancedRoadmapsGettingStartedRedirectRouteEntry", () => $c59b8ec61d58752b$export$4652a26319dca4d0);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $cSxBV = parcelRequire("cSxBV");

var $ds5qV = parcelRequire("ds5qV");

var $g6wgl = parcelRequire("g6wgl");
const $c59b8ec61d58752b$export$4652a26319dca4d0 = (0, $7NszV.createEntry)((0, $cSxBV.softwareAdvancedRoadmapsGettingStartedRedirectRoute), ()=>({
        group: 'software',
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
                to: "/jira/plans?create-sample-plan=true"
            }),
        isRedirect: true,
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("cSxBV", function(module, exports) {

$parcel$export(module.exports, "softwareAdvancedRoadmapsGettingStartedRedirectRoute", () => $c9008f0cd6cfcbbf$export$38c76ea9ddc85b3);
const $c9008f0cd6cfcbbf$export$38c76ea9ddc85b3 = {
    name: 'software-advanced-roadmaps-getting-started-redirect',
    path: '/secure/PortfolioGettingStarted.jspa'
};

});


parcelRegister("lGnoq", function(module, exports) {

$parcel$export(module.exports, "softwarePlanCalendarRouteEntry", () => $4711dd8590f23118$export$67c64fea9be584ed);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");


var $87OsA = parcelRequire("87OsA");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $8JbXO = parcelRequire("8JbXO");

var $kZOse = parcelRequire("kZOse");

var $4R6GH = parcelRequire("4R6GH");

var $bscjm = parcelRequire("bscjm");
const $4711dd8590f23118$export$67c64fea9be584ed = (0, $7NszV.createEntry)((0, $8JbXO.softwarePlanCalendarRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-calendar',
        skeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZOse.CalendarSkeleton), null),
        entryPoint () {
            (0, $87OsA.setCapability)((0, $281cbd47ba46dd7d$export$f999749ac7a2cd1));
            return (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $bscjm.planCalendarPageEntryPoint) : (0, $bscjm.planCalendarPageEntryPointWithoutHorizontalNavigation);
        },
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$f999749ac7a2cd1)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("8iyFV", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalNavPlans", () => $ee88d7a7192b9e04$export$84e1a5f003939496);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $ee88d7a7192b9e04$var$LazyHorizontalPlansNav = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("5mgJ9")).then(({ HorizontalPlansNav: HorizontalPlansNav })=>HorizontalPlansNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-plans/src/ui/index.tsx"
});
const $ee88d7a7192b9e04$export$84e1a5f003939496 = ({ store: store })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-software-plans-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ee88d7a7192b9e04$var$LazyHorizontalPlansNav, {
        store: store
    }));

});
parcelRegister("5mgJ9", function(module, exports) {

let $3e6bfb7d9314a580$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("gnY34"), 4)),
    $3e6bfb7d9314a580$var$load("dsiAd"),
    $3e6bfb7d9314a580$var$load("h2MrD"),
    $3e6bfb7d9314a580$var$load("bYT2S"),
    $3e6bfb7d9314a580$var$load("hPzOn"),
    $3e6bfb7d9314a580$var$load("eNmuD"),
    $3e6bfb7d9314a580$var$load("cM9em"),
    $3e6bfb7d9314a580$var$load("fr9NE"),
    $3e6bfb7d9314a580$var$load("aqH3P")
]).then(()=>parcelRequire('fYibJ'));

});


parcelRegister("937TY", function(module, exports) {

$parcel$export(module.exports, "default", () => $375ae1bde651f684$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

const $375ae1bde651f684$var$LazyPlanSidebar = (0, $b7Svb.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("eHjba")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/plan/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $375ae1bde651f684$var$PlanSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "Plan"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($375ae1bde651f684$var$LazyPlanSidebar, null)));
$375ae1bde651f684$var$PlanSidebar.displayName = 'PlanSidebar';
var $375ae1bde651f684$export$2e2bcd8739ae039 = $375ae1bde651f684$var$PlanSidebar;

});
parcelRegister("eHjba", function(module, exports) {

let $ab33f56a4100b676$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ab33f56a4100b676$var$load("exGqx").then(()=>parcelRequire('5q8CD'));

});


parcelRegister("8JbXO", function(module, exports) {

$parcel$export(module.exports, "softwarePlanCalendarRoute", () => $56322e0cc9119168$export$ca4c39d60ec156a2);
const $56322e0cc9119168$export$ca4c39d60ec156a2 = {
    name: 'software-plan-calendar',
    path: '/jira/plans/:planId/scenarios/:scenarioId/calendar'
};

});

parcelRegister("bscjm", function(module, exports) {

$parcel$export(module.exports, "planCalendarPageEntryPoint", () => $49df381ba8f49311$export$6e8a1c5de1f63c61);
$parcel$export(module.exports, "planCalendarPageEntryPointWithoutHorizontalNavigation", () => $49df381ba8f49311$export$71d7feb91869903);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $02tNK = parcelRequire("02tNK");

var $57oLc = parcelRequire("57oLc");
const $49df381ba8f49311$export$6e8a1c5de1f63c61 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $02tNK.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $49df381ba8f49311$export$71d7feb91869903 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $02tNK.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});
parcelRegister("57oLc", function(module, exports) {

$parcel$export(module.exports, "plansHorizontalNavigationEntryPoint", () => $9252b8e5bbb4c32e$export$172a11f0d118de01);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $3rdd7 = parcelRequire("3rdd7");

var $aNsVT = parcelRequire("aNsVT");

var $6LB8G = parcelRequire("6LB8G");

var $ktofH = parcelRequire("ktofH");
function $9252b8e5bbb4c32e$var$toPlanScenarioAri({ siteId: siteId, activationId: activationId, planId: planId, scenarioId: scenarioId }) {
    return `ari:cloud:jira:${siteId}:plan-scenario/activation/${activationId}/${planId}/scenario/${scenarioId}`;
}

const $9252b8e5bbb4c32e$export$172a11f0d118de01 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("croqW")), {
        moduleId: "8c821489",
        moduleName: "HorizontalNavPlans"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        const planId = match.params.planId;
        const scenarioId = match.params.scenarioId;
        if (!planId) throw new Error('Plan Id is missing');
        if (!scenarioId) throw new Error('Scenario Id is missing');
        const planScenarioAri = $9252b8e5bbb4c32e$var$toPlanScenarioAri({
            siteId: cloudId,
            activationId: activationId,
            planId: planId,
            scenarioId: scenarioId
        });
        return {
            queries: {
                horizontalNavPlansQuery: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $6LB8G.default,
                    variables: {
                        first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE),
                        cloudId: cloudId,
                        containerNavigationInput: {
                            scopeId: planScenarioAri
                        }
                    }
                }
            }
        };
    }
});

});
parcelRegister("6LB8G", function(module, exports) {

$parcel$export(module.exports, "default", () => $de2da6d338535497$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<579d50b31430815e25d91a9a65380319>>
 * @relayHash 164c48c3824ef2f0755f6d70fb373e5c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5ae63d79ee56070a78fcd0f81b3991516463430dbed3ae6bcd427e7e0f13d71c
const $de2da6d338535497$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5ae63d79ee56070a78fcd0f81b3991516463430dbed3ae6bcd427e7e0f13d71c",
        "metadata": {},
        "name": "HorizontalNavPlansQuery",
        "operationKind": "query",
        "text": null
    }
};
var $de2da6d338535497$export$2e2bcd8739ae039 = $de2da6d338535497$var$node;

});

parcelRegister("ktofH", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_ITEMS_PAGE_SIZE", () => $e6d4097fc653a273$export$4653cda61a4943d6);
$parcel$export(module.exports, "TAB_UNDERLINE_HEIGHT", () => $e6d4097fc653a273$export$d1b9ea3245b6a5de);
$parcel$export(module.exports, "TAB_HEIGHT", () => $e6d4097fc653a273$export$d07bba395c9390f1);
$parcel$export(module.exports, "TAB_GAP", () => $e6d4097fc653a273$export$b61e6f89a9db76de);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports


const $e6d4097fc653a273$export$4653cda61a4943d6 = 75;
const $e6d4097fc653a273$export$d1b9ea3245b6a5de = 2;
const $e6d4097fc653a273$export$d07bba395c9390f1 = 36;
const $e6d4097fc653a273$export$29911ec08ab2ca2d = 5;
const $e6d4097fc653a273$export$b61e6f89a9db76de = 12;
const $e6d4097fc653a273$export$7fd2e391116c6ef5 = 9;
const $e6d4097fc653a273$export$e1633e494d305bfb = 'MORE';

});

parcelRegister("croqW", function(module, exports) {

let $90eaf5a1d428e6f3$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("4ulU1"), 4)),
    $90eaf5a1d428e6f3$var$load("dsiAd"),
    $90eaf5a1d428e6f3$var$load("eq36h")
]).then(()=>parcelRequire('2NXnj'));

});




parcelRegister("6cMQO", function(module, exports) {

$parcel$export(module.exports, "softwarePlanDependenciesRouteEntry", () => $35d5ce46f5d8e5a8$export$103062f08086fba0);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4twOY = parcelRequire("4twOY");

var $4R6GH = parcelRequire("4R6GH");

var $fq8uf = parcelRequire("fq8uf");

var $4xae4 = parcelRequire("4xae4");
const $35d5ce46f5d8e5a8$export$103062f08086fba0 = (0, $7NszV.createEntry)((0, $4twOY.softwarePlanDependenciesRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $4xae4.planDependenciesReportPageEntryPoint) : (0, $4xae4.planDependenciesReportPageEntryPointWithoutHorizontalNavigation) : undefined,
        component: (0, $fq8uf.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fq8uf.LazyPlanDependenciesReport)
        ]
    }));

});
parcelRegister("4twOY", function(module, exports) {

$parcel$export(module.exports, "softwarePlanDependenciesRoute", () => $a253d414fb5970e7$export$ad8296aa5394f696);
const $a253d414fb5970e7$export$ad8296aa5394f696 = {
    name: 'software-plan-dependencies',
    path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies'
};

});

parcelRegister("fq8uf", function(module, exports) {

$parcel$export(module.exports, "LazyPlanDependenciesReport", () => $bba44615f3e187dc$export$d4669c7a2f17c261);
$parcel$export(module.exports, "default", () => $bba44615f3e187dc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $bba44615f3e187dc$export$d4669c7a2f17c261 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("koHo3"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-dependencies-report/index-old.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bba44615f3e187dc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $bba44615f3e187dc$export$d4669c7a2f17c261,
        pageId: "plan-dependencies-report",
        shouldShowSpinner: true
    });

});

parcelRegister("4xae4", function(module, exports) {

$parcel$export(module.exports, "planDependenciesReportPageEntryPoint", () => $49c9e6a9627b668c$export$1d873335adb647af);
$parcel$export(module.exports, "planDependenciesReportPageEntryPointWithoutHorizontalNavigation", () => $49c9e6a9627b668c$export$5d979b028f8d2115);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $1zjAp = parcelRequire("1zjAp");

var $57oLc = parcelRequire("57oLc");
const $49c9e6a9627b668c$export$1d873335adb647af = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1zjAp.planDependenciesReportEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $49c9e6a9627b668c$export$5d979b028f8d2115 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1zjAp.planDependenciesReportEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});


parcelRegister("lxXtu", function(module, exports) {

$parcel$export(module.exports, "softwarePlanReleasesRouteEntry", () => $4095f2c0ec8f50cf$export$b874fabd66f10ff4);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4doUI = parcelRequire("4doUI");

var $4R6GH = parcelRequire("4R6GH");

var $gbVLg = parcelRequire("gbVLg");

var $iSVrv = parcelRequire("iSVrv");
const $4095f2c0ec8f50cf$export$b874fabd66f10ff4 = (0, $7NszV.createEntry)((0, $4doUI.softwarePlanReleasesRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $iSVrv.planReleasesPageEntryPoint) : (0, $iSVrv.planReleasesPageEntryPointWithoutHorizontalNavigation) : undefined,
        component: (0, $gbVLg.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gbVLg.LazyPlanReleases)
        ]
    }));

});
parcelRegister("4doUI", function(module, exports) {

$parcel$export(module.exports, "softwarePlanReleasesRoute", () => $f06c9277915d7c48$export$850236b64b0aa28b);
const $f06c9277915d7c48$export$850236b64b0aa28b = {
    name: 'software-plan-releases',
    path: '/jira/plans/:planId/scenarios/:scenarioId/releases'
};

});

parcelRegister("gbVLg", function(module, exports) {

$parcel$export(module.exports, "LazyPlanReleases", () => $17bd378321c97c37$export$749f5d2513e04ec0);
$parcel$export(module.exports, "default", () => $17bd378321c97c37$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $17bd378321c97c37$export$749f5d2513e04ec0 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eNr7s"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-releases/index-old.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$17bd378321c97c37$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $17bd378321c97c37$export$749f5d2513e04ec0,
        pageId: "plan-releases",
        shouldShowSpinner: true
    });

});
parcelRegister("eNr7s", function(module, exports) {

let $ac5aada4503828cc$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $ac5aada4503828cc$var$load("kfXhT"),
    $ac5aada4503828cc$var$load("2Lfdl"),
    $ac5aada4503828cc$var$load("cM9em"),
    $ac5aada4503828cc$var$load("fr9NE"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("KveVL"), 4)),
    $ac5aada4503828cc$var$load("dsiAd"),
    $ac5aada4503828cc$var$load("jEziL")
]).then(()=>parcelRequire('jRZ9A'));

});


parcelRegister("iSVrv", function(module, exports) {

$parcel$export(module.exports, "planReleasesPageEntryPoint", () => $dc2ebda85f38ad5d$export$accb0033190d648e);
$parcel$export(module.exports, "planReleasesPageEntryPointWithoutHorizontalNavigation", () => $dc2ebda85f38ad5d$export$10abe27e6c5044b);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $a3dKc = parcelRequire("a3dKc");

var $57oLc = parcelRequire("57oLc");
const $dc2ebda85f38ad5d$export$accb0033190d648e = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $a3dKc.planReleasesEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $dc2ebda85f38ad5d$export$10abe27e6c5044b = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $a3dKc.planReleasesEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});
parcelRegister("a3dKc", function(module, exports) {

$parcel$export(module.exports, "planReleasesEntryPoint", () => $68da7936f39bec4e$export$4e18896acd7f3236);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $68da7936f39bec4e$export$4e18896acd7f3236 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>{
        if (!false) return (parcelRequire("6hJoU"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "e3e1145d"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6hJoU", function(module, exports) {

let $49378c41f19af08c$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $49378c41f19af08c$var$load("kfXhT"),
    $49378c41f19af08c$var$load("2Lfdl"),
    $49378c41f19af08c$var$load("cM9em"),
    $49378c41f19af08c$var$load("fr9NE"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("auj8r"), 4)),
    $49378c41f19af08c$var$load("dsiAd"),
    $49378c41f19af08c$var$load("aEaZR")
]).then(()=>parcelRequire('1rmO9'));

});




parcelRegister("2l6sh", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsAutoSchedulerRouteEntry", () => $78ac61c21ed5f382$export$fc7007717398c727);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4AnBP = parcelRequire("4AnBP");

var $gicWA = parcelRequire("gicWA");
const $78ac61c21ed5f382$export$fc7007717398c727 = (0, $7NszV.createEntry)((0, $4AnBP.softwarePlanSettingsAutoSchedulerRoute), ()=>({
        group: 'software',
        component: (0, $gicWA.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gicWA.LazyPlanSettingsAutoScheduler)
        ]
    }));

});
parcelRegister("4AnBP", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsAutoSchedulerRoute", () => $4586083606b00135$export$e44088b2cc0206cf);
const $4586083606b00135$export$e44088b2cc0206cf = {
    name: 'plan-settings-auto-scheduler',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/auto-scheduler'
};

});

parcelRegister("gicWA", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsAutoScheduler", () => $632fd0e21b8de9c8$export$8bcf7155849993f5);
$parcel$export(module.exports, "default", () => $632fd0e21b8de9c8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $632fd0e21b8de9c8$export$8bcf7155849993f5 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kGOmX"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/auto-scheduler/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$632fd0e21b8de9c8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $632fd0e21b8de9c8$export$8bcf7155849993f5,
        pageId: "plan-settings-auto-scheduler",
        shouldShowSpinner: true
    });

});
parcelRegister("kGOmX", function(module, exports) {

let $f0fecd31f6d14d2a$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("5TMh3"), 4)),
    $f0fecd31f6d14d2a$var$load("kssvB")
]).then(()=>parcelRequire('9U7wJ'));

});



parcelRegister("1C9Ha", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsCustomFieldsRouteEntry", () => $e3235a40cee1f9ea$export$89472d9db6946668);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $6UGjg = parcelRequire("6UGjg");

var $eNKly = parcelRequire("eNKly");
const $e3235a40cee1f9ea$export$89472d9db6946668 = (0, $7NszV.createEntry)((0, $6UGjg.softwarePlanSettingsCustomFieldsRoute), ()=>({
        group: 'software',
        component: (0, $eNKly.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eNKly.LazyPlanSettingsCustomFields)
        ]
    }));

});
parcelRegister("6UGjg", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsCustomFieldsRoute", () => $8173736a5bf38da1$export$2634cd63c73f7a35);
const $8173736a5bf38da1$export$2634cd63c73f7a35 = {
    name: 'plan-settings-custom-fields',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/custom-fields'
};

});

parcelRegister("eNKly", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsCustomFields", () => $7a181f322c9e7d25$export$72bf44dbae2383e5);
$parcel$export(module.exports, "default", () => $7a181f322c9e7d25$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $7a181f322c9e7d25$export$72bf44dbae2383e5 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7mC0v"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/custom-fields/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7a181f322c9e7d25$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7a181f322c9e7d25$export$72bf44dbae2383e5,
        pageId: "plan-settings-custom-fields",
        shouldShowSpinner: true
    });

});
parcelRegister("7mC0v", function(module, exports) {

let $55c811ea032adb61$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $55c811ea032adb61$var$load("h2MrD"),
    $55c811ea032adb61$var$load("bYT2S"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("4NK3n"), 4)),
    $55c811ea032adb61$var$load("1osJI")
]).then(()=>parcelRequire('j09X0'));

});



parcelRegister("cChHY", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsExclusionRulesRouteEntry", () => $8d454372873657bb$export$cd1b612d0c014154);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $47gJb = parcelRequire("47gJb");

var $e3mpc = parcelRequire("e3mpc");
const $8d454372873657bb$export$cd1b612d0c014154 = (0, $7NszV.createEntry)((0, $47gJb.softwarePlanSettingsExclusionRulesRoute), ()=>({
        group: 'software',
        component: (0, $e3mpc.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $e3mpc.LazyPlanSettingsExclusionRules)
        ]
    }));

});
parcelRegister("47gJb", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsExclusionRulesRoute", () => $520050550cd1f444$export$358b0ca69a4bd731);
const $520050550cd1f444$export$358b0ca69a4bd731 = {
    name: 'plan-settings-exclusion-rules',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/exclusion-rules'
};

});

parcelRegister("e3mpc", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsExclusionRules", () => $9ac014b7d5fdabc4$export$78f61b03c267e6d9);
$parcel$export(module.exports, "default", () => $9ac014b7d5fdabc4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $9ac014b7d5fdabc4$export$78f61b03c267e6d9 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("irC9b"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/exclusion-rules/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9ac014b7d5fdabc4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9ac014b7d5fdabc4$export$78f61b03c267e6d9,
        pageId: "plan-settings-exclusion-rules",
        shouldShowSpinner: true
    });

});
parcelRegister("irC9b", function(module, exports) {

let $d6d856d79cd3d875$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("krPFv"), 4)),
    $d6d856d79cd3d875$var$load("cQMR4")
]).then(()=>parcelRequire('8InOA'));

});



parcelRegister("d1sI7", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsFindYourIssueRouteEntry", () => $e49a66463b867d46$export$2f975c505121e139);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $7sttJ = parcelRequire("7sttJ");

var $4tFWF = parcelRequire("4tFWF");
const $e49a66463b867d46$export$2f975c505121e139 = (0, $7NszV.createEntry)((0, $7sttJ.softwarePlanSettingsFindYourIssueRoute), ()=>({
        group: 'software',
        component: (0, $4tFWF.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4tFWF.LazyPlanSettingsFindYourIssue)
        ]
    }));

});
parcelRegister("7sttJ", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsFindYourIssueRoute", () => $bcf3aac3d05c5191$export$ab61883f74eb27c2);
const $bcf3aac3d05c5191$export$ab61883f74eb27c2 = {
    name: 'plan-settings-find-your-issue',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/find-your-issue'
};

});

parcelRegister("4tFWF", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsFindYourIssue", () => $428ba58b4dd0959f$export$731998664b7d5e72);
$parcel$export(module.exports, "default", () => $428ba58b4dd0959f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $428ba58b4dd0959f$export$731998664b7d5e72 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jsZaV"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/find-your-issue/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$428ba58b4dd0959f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $428ba58b4dd0959f$export$731998664b7d5e72,
        pageId: "plan-settings-find-your-issue",
        shouldShowSpinner: true
    });

});
parcelRegister("jsZaV", function(module, exports) {

let $e2c015fe3213a74d$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("jGDgV"), 4)),
    $e2c015fe3213a74d$var$load("fi5lj")
]).then(()=>parcelRequire('ZLjUl'));

});



parcelRegister("gksya", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsIssueSourcesRouteEntry", () => $c2b7559ef928e7c4$export$f0b7e9788ab79be0);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $ewGjs = parcelRequire("ewGjs");

var $f4F08 = parcelRequire("f4F08");
const $c2b7559ef928e7c4$export$f0b7e9788ab79be0 = (0, $7NszV.createEntry)((0, $ewGjs.softwarePlanSettingsIssueSourcesRoute), ()=>({
        group: 'software',
        component: (0, $f4F08.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $f4F08.LazyPlanSettingsIssueSources)
        ]
    }));

});
parcelRegister("ewGjs", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsIssueSourcesRoute", () => $da9ac2a12ec5cdcc$export$fa18324265e4400c);
const $da9ac2a12ec5cdcc$export$fa18324265e4400c = {
    name: 'plan-settings-issue-sources',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/issue-sources'
};

});

parcelRegister("f4F08", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsIssueSources", () => $b7fcbd3d5b96d4a9$export$7ba4b487efcedeb3);
$parcel$export(module.exports, "default", () => $b7fcbd3d5b96d4a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $b7fcbd3d5b96d4a9$export$7ba4b487efcedeb3 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("bsFKI"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/issue-sources/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b7fcbd3d5b96d4a9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b7fcbd3d5b96d4a9$export$7ba4b487efcedeb3,
        pageId: "plan-settings-issue-sources",
        shouldShowSpinner: true
    });

});
parcelRegister("bsFKI", function(module, exports) {

let $8582b26c550d850e$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("h4JBs"), 4)),
    $8582b26c550d850e$var$load("9lRZr")
]).then(()=>parcelRequire('1GCm8'));

});



parcelRegister("l0UsI", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsPermissionsRouteEntry", () => $d78d9c80df28a675$export$1afc7a9efa99340);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $gofRF = parcelRequire("gofRF");

var $9X2gP = parcelRequire("9X2gP");
const $d78d9c80df28a675$export$1afc7a9efa99340 = (0, $7NszV.createEntry)((0, $gofRF.softwarePlanSettingsPermissionsRoute), ()=>({
        group: 'software',
        component: (0, $9X2gP.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9X2gP.LazyPlanSettingsPermissions)
        ]
    }));

});
parcelRegister("gofRF", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsPermissionsRoute", () => $c8e4ae667061a76b$export$6734c29372722a5e);
const $c8e4ae667061a76b$export$6734c29372722a5e = {
    name: 'plan-settings-permissions',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/permissions'
};

});

parcelRegister("9X2gP", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsPermissions", () => $8e8c7a9f7faf5b90$export$49f5b76ad5c06a42);
$parcel$export(module.exports, "default", () => $8e8c7a9f7faf5b90$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $8e8c7a9f7faf5b90$export$49f5b76ad5c06a42 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("ewNcv"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/permissions/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8e8c7a9f7faf5b90$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8e8c7a9f7faf5b90$export$49f5b76ad5c06a42,
        pageId: "plan-settings-permissions",
        shouldShowSpinner: true
    });

});
parcelRegister("ewNcv", function(module, exports) {

let $a93a381b20a3d836$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("cSV9k"), 4)),
    $a93a381b20a3d836$var$load("fHQhR")
]).then(()=>parcelRequire('dx76p'));

});



parcelRegister("bdHl5", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsPlanInfoRouteEntry", () => $d7dc38a99726fee2$export$1d6300da0c837e02);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $91wHh = parcelRequire("91wHh");

var $l3vqO = parcelRequire("l3vqO");
const $d7dc38a99726fee2$export$1d6300da0c837e02 = (0, $7NszV.createEntry)((0, $91wHh.softwarePlanSettingsPlanInfoRoute), ()=>({
        group: 'software',
        component: (0, $l3vqO.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $l3vqO.LazyPlanSettingsPlanInfo)
        ]
    }));

});
parcelRegister("91wHh", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsPlanInfoRoute", () => $6fdc9140d3fd71a2$export$76e6bdc959f6fa97);
const $6fdc9140d3fd71a2$export$76e6bdc959f6fa97 = {
    name: 'plan-settings-plan-info',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/plan-info'
};

});

parcelRegister("l3vqO", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsPlanInfo", () => $891dc4fe265590fb$export$c1344fd7d24991b3);
$parcel$export(module.exports, "default", () => $891dc4fe265590fb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $891dc4fe265590fb$export$c1344fd7d24991b3 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("882BQ"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/plan-info/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$891dc4fe265590fb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $891dc4fe265590fb$export$c1344fd7d24991b3,
        pageId: "plan-settings-plan-info",
        shouldShowSpinner: true
    });

});
parcelRegister("882BQ", function(module, exports) {

let $5eb11840259f22f1$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("deC5G"), 4)),
    $5eb11840259f22f1$var$load("8REMF")
]).then(()=>parcelRequire('8aOgd'));

});



parcelRegister("1oew5", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsFeaturesRouteEntry", () => $4837f30fa1f1d2ac$export$591e778de9bccacd);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $6s1PB = parcelRequire("6s1PB");

var $5M6NY = parcelRequire("5M6NY");

var $YTuky = parcelRequire("YTuky");
const $4837f30fa1f1d2ac$export$591e778de9bccacd = (0, $7NszV.createEntry)((0, $5M6NY.softwarePlanSettingsFeaturesRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $6s1PB.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? (0, $YTuky.planSettingsFeaturesRouteEntry) : undefined,
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("5M6NY", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsFeaturesRoute", () => $858c2043fb3d5ae0$export$2e79af7413eb4921);
const $858c2043fb3d5ae0$export$2e79af7413eb4921 = {
    name: 'plan-settings-features',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/features'
};

});

parcelRegister("YTuky", function(module, exports) {

$parcel$export(module.exports, "planSettingsFeaturesRouteEntry", () => $d035cdee6bee40d9$export$2cf26c8369ef29cd);

var $lkFvK = parcelRequire("lkFvK");

var $i91HP = parcelRequire("i91HP");

var $lmyls = parcelRequire("lmyls");
const $d035cdee6bee40d9$export$2cf26c8369ef29cd = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $i91HP.planSettingsFeaturesEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});
parcelRegister("i91HP", function(module, exports) {

$parcel$export(module.exports, "planSettingsFeaturesEntryPoint", () => $d303a29161d5fb6f$export$ae1839f07bffa153);

var $cfawy = parcelRequire("cfawy");

var $3rdd7 = parcelRequire("3rdd7");

var $gXbDA = parcelRequire("gXbDA");

const $d303a29161d5fb6f$export$ae1839f07bffa153 = (0, $3rdd7.createEntryPoint)({
    root: (0, $cfawy.JSResourceForUserVisible)(()=>(parcelRequire("cbuHV")), {
        moduleId: "3d5245c7"
    }),
    getPreloadProps: (entryPointParams)=>{
        return {
            entryPoints: {
                preLoadFeaturesEntryPoint: {
                    entryPoint: (0, $gXbDA.featuresEntryPoint),
                    entryPointParams: entryPointParams
                }
            }
        };
    }
});

});
parcelRegister("cfawy", function(module, exports) {

$parcel$export(module.exports, "JSResourceForUserVisible", () => $aac7f8e7296c07e2$export$58f934f3d33a84b6);

var $8X8ig = parcelRequire("8X8ig");

var $6FeX8 = parcelRequire("6FeX8");

var $fpppF = parcelRequire("fpppF");
const $aac7f8e7296c07e2$var$cache = (0, $8X8ig.createCache)(new Map());
function $aac7f8e7296c07e2$export$58f934f3d33a84b6(loader, opts) {
    return $aac7f8e7296c07e2$var$cache.get(opts.moduleId, ()=>(0, $6FeX8.PreloadableJSResource)(()=>(0, $fpppF.postTask)(loader, {
                priority: 'user-blocking'
            }), opts));
}

});

parcelRegister("gXbDA", function(module, exports) {

$parcel$export(module.exports, "featuresEntryPoint", () => $fad526df981ee212$export$e283e7092d12783d);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $ep7p9 = parcelRequire("ep7p9");
const $fad526df981ee212$var$toPlanAri = ({ siteId: siteId, activationId: activationId, planId: planId })=>{
    return `ari:cloud:jira:${siteId}:plan/activation/${activationId}/${planId}`;
};

const $fad526df981ee212$export$e283e7092d12783d = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("dPNxn")), {
        moduleId: "2bffebe5"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: tenantContext })=>{
        return {
            queries: {
                plan: {
                    variables: {
                        planId: $fad526df981ee212$var$toPlanAri({
                            siteId: tenantContext.cloudId,
                            activationId: tenantContext.activationId,
                            planId: String(match.params.planId)
                        })
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $ep7p9.default
                }
            }
        };
    }
});

});
parcelRegister("ep7p9", function(module, exports) {

$parcel$export(module.exports, "default", () => $32ff4e592db83849$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<805f3d821edff5b2ea87f2af2fd659c8>>
 * @relayHash f04cb6d0378b9b0715942f271eacb8f0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 143b3fe6f1188b3f1e858aa0c1ab0ac681eecff7cea7e1f05e6951e1d37cec33
const $32ff4e592db83849$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "143b3fe6f1188b3f1e858aa0c1ab0ac681eecff7cea7e1f05e6951e1d37cec33",
        "metadata": {},
        "name": "uiFeaturesPlansSettingsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $32ff4e592db83849$export$2e2bcd8739ae039 = $32ff4e592db83849$var$node;

});

parcelRegister("dPNxn", function(module, exports) {

let $a12676dff5eb8193$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("izvr2"), 4)),
    $a12676dff5eb8193$var$load("2cma0")
]).then(()=>parcelRequire('3CODU'));

});


parcelRegister("cbuHV", function(module, exports) {

let $8dee54f9b9246a28$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("jL85n"), 4)),
    $8dee54f9b9246a28$var$load("d5wZ0")
]).then(()=>parcelRequire('3DDDy'));

});




parcelRegister("5hvg3", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsProgramBoardsRouteEntry", () => $6183d6997fcdbcf0$export$be96222796ad98f0);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4jvUD = parcelRequire("4jvUD");

var $jMgFt = parcelRequire("jMgFt");
const $6183d6997fcdbcf0$export$be96222796ad98f0 = (0, $7NszV.createEntry)((0, $4jvUD.softwarePlanSettingsProgramBoardsRoute), ()=>({
        group: 'software',
        component: (0, $jMgFt.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jMgFt.LazyPlanSettingsProgramBoards)
        ]
    }));

});
parcelRegister("4jvUD", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsProgramBoardsRoute", () => $8498ace38f0217d4$export$3d54c48a91a178c0);
const $8498ace38f0217d4$export$3d54c48a91a178c0 = {
    name: 'plan-settings-program-boards',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/program-boards'
};

});

parcelRegister("jMgFt", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsProgramBoards", () => $fc0346cc52c0eaa1$export$ffdec728a47c437c);
$parcel$export(module.exports, "default", () => $fc0346cc52c0eaa1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $fc0346cc52c0eaa1$export$ffdec728a47c437c = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("dNGju"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/program-boards/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fc0346cc52c0eaa1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $fc0346cc52c0eaa1$export$ffdec728a47c437c,
        pageId: "plan-settings-program-boards",
        shouldShowSpinner: true
    });

});
parcelRegister("dNGju", function(module, exports) {

let $a0c0ac82dde05277$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("1QmTP"), 4)),
    $a0c0ac82dde05277$var$load("6qkFP")
]).then(()=>parcelRequire('cckoo'));

});



parcelRegister("6oWts", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsRemovedIssuesRouteEntry", () => $304853a89d046ccf$export$53a9ea0e0b05ceb5);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $12t4Y = parcelRequire("12t4Y");

var $4a0AK = parcelRequire("4a0AK");
const $304853a89d046ccf$export$53a9ea0e0b05ceb5 = (0, $7NszV.createEntry)((0, $12t4Y.softwarePlanSettingsRemovedIssuesRoute), ()=>({
        group: 'software',
        component: (0, $4a0AK.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4a0AK.LazyPlanSettingsRemovedIssues)
        ]
    }));

});
parcelRegister("12t4Y", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsRemovedIssuesRoute", () => $1a8d996cecbe9939$export$8b77532ba9798e64);
const $1a8d996cecbe9939$export$8b77532ba9798e64 = {
    name: 'plan-settings-removed-issues',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/removed-issues'
};

});

parcelRegister("4a0AK", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsRemovedIssues", () => $1ba44a18046961e4$export$759df6301ec72119);
$parcel$export(module.exports, "default", () => $1ba44a18046961e4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $1ba44a18046961e4$export$759df6301ec72119 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("dJ610"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/removed-issues/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1ba44a18046961e4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1ba44a18046961e4$export$759df6301ec72119,
        pageId: "plan-settings-removed-issues",
        shouldShowSpinner: true
    });

});
parcelRegister("dJ610", function(module, exports) {

let $9fe424d54e0cc7cf$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("4f2RV"), 4)),
    $9fe424d54e0cc7cf$var$load("5hVzx")
]).then(()=>parcelRequire('mRA5P'));

});



parcelRegister("76RJj", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsSavedViewsRouteEntry", () => $cbe1aa5484552af9$export$64d5b46da2e58194);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $gEyvh = parcelRequire("gEyvh");

var $lY1iq = parcelRequire("lY1iq");
const $cbe1aa5484552af9$export$64d5b46da2e58194 = (0, $7NszV.createEntry)((0, $gEyvh.softwarePlanSettingsSavedViewsRoute), ()=>({
        group: 'software',
        component: (0, $lY1iq.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lY1iq.LazyPlanSettingsSavedViews)
        ]
    }));

});
parcelRegister("gEyvh", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsSavedViewsRoute", () => $606c26c5c4fe38cc$export$a0fec30f475e8756);
const $606c26c5c4fe38cc$export$a0fec30f475e8756 = {
    name: 'plan-settings-saved-views',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/saved-views'
};

});

parcelRegister("lY1iq", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsSavedViews", () => $9469a9a95c6fd42f$export$a5398542699d356a);
$parcel$export(module.exports, "default", () => $9469a9a95c6fd42f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $9469a9a95c6fd42f$export$a5398542699d356a = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8VM7o"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/saved-views/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9469a9a95c6fd42f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9469a9a95c6fd42f$export$a5398542699d356a,
        pageId: "plan-settings-saved-views",
        shouldShowSpinner: true
    });

});
parcelRegister("8VM7o", function(module, exports) {

let $6808f8e242e78c79$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("4IywT"), 4)),
    $6808f8e242e78c79$var$load("81iXg")
]).then(()=>parcelRequire('k5TsF'));

});



parcelRegister("ikfu9", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsScenariosRouteEntry", () => $9368211e7352bb42$export$9b6e6b5d471b90f);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4a5PZ = parcelRequire("4a5PZ");

var $6o8sS = parcelRequire("6o8sS");
const $9368211e7352bb42$export$9b6e6b5d471b90f = (0, $7NszV.createEntry)((0, $4a5PZ.softwarePlanSettingsScenariosRoute), ()=>({
        group: 'software',
        component: (0, $6o8sS.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6o8sS.LazyPlanSettingsScenarios)
        ]
    }));

});
parcelRegister("4a5PZ", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsScenariosRoute", () => $56e039c24697690f$export$d32efeefb944c6b7);
const $56e039c24697690f$export$d32efeefb944c6b7 = {
    name: 'plan-settings-scenarios',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scenarios'
};

});

parcelRegister("6o8sS", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsScenarios", () => $3744eed80f080771$export$94104fcc1a6f460f);
$parcel$export(module.exports, "default", () => $3744eed80f080771$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $3744eed80f080771$export$94104fcc1a6f460f = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("agC7n"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scenarios/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3744eed80f080771$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3744eed80f080771$export$94104fcc1a6f460f,
        pageId: "plan-settings-scenarios",
        shouldShowSpinner: true
    });

});
parcelRegister("agC7n", function(module, exports) {

let $7798f7716ee790af$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("a8N0m"), 4)),
    $7798f7716ee790af$var$load("dZydx")
]).then(()=>parcelRequire('iF2yt'));

});



parcelRegister("g7fao", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsSchedulingRouteEntry", () => $cf0e25b45377825b$export$c1319dec79812860);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $eLpuR = parcelRequire("eLpuR");

var $TAgAs = parcelRequire("TAgAs");
const $cf0e25b45377825b$export$c1319dec79812860 = (0, $7NszV.createEntry)((0, $eLpuR.softwarePlanSettingsSchedulingRoute), ()=>({
        group: 'software',
        component: (0, $TAgAs.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $TAgAs.LazyPlanSettingsScheduling)
        ]
    }));

});
parcelRegister("eLpuR", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsSchedulingRoute", () => $e1fdd34e8b323da3$export$a215ef374dd2a8a9);
const $e1fdd34e8b323da3$export$a215ef374dd2a8a9 = {
    name: 'plan-settings-scheduling',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scheduling'
};

});

parcelRegister("TAgAs", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsScheduling", () => $5e451d261b446f20$export$3bf11db1bbeae73e);
$parcel$export(module.exports, "default", () => $5e451d261b446f20$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $5e451d261b446f20$export$3bf11db1bbeae73e = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8K8RU"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scheduling/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5e451d261b446f20$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $5e451d261b446f20$export$3bf11db1bbeae73e,
        pageId: "plan-settings-scheduling",
        shouldShowSpinner: true
    });

});
parcelRegister("8K8RU", function(module, exports) {

let $65d97fbb723020c9$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $65d97fbb723020c9$var$load("kfXhT"),
    $65d97fbb723020c9$var$load("2Lfdl"),
    $65d97fbb723020c9$var$load("cM9em"),
    $65d97fbb723020c9$var$load("fr9NE"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("5gjrg"), 4)),
    $65d97fbb723020c9$var$load("dsiAd"),
    $65d97fbb723020c9$var$load("X6lWy")
]).then(()=>parcelRequire('j3U5Q'));

});



parcelRegister("8s6qp", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSummaryRouteEntry", () => $e2353036f7312b49$export$4bc10767887a84cc);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $lv9xW = parcelRequire("lv9xW");

var $3RJkv = parcelRequire("3RJkv");

var $jUoVn = parcelRequire("jUoVn");

var $4R6GH = parcelRequire("4R6GH");

var $35bOg = parcelRequire("35bOg");

var $3v1Zf = parcelRequire("3v1Zf");
const $e2353036f7312b49$export$4bc10767887a84cc = (0, $7NszV.createEntry)((0, $jUoVn.softwarePlanSummaryRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $3v1Zf.planSummaryPageEntryPoint) : (0, $3v1Zf.planSummaryPageEntryPointWithoutHorizontalNavigation) : undefined,
        ufoName: 'software-advanced-roadmaps-summary',
        component: (0, $35bOg.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $lv9xW.advancedRoadmapsSummaryDataResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $35bOg.LazyPlanSummary)
        ]
    }));

});
parcelRegister("jUoVn", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSummaryRoute", () => $ad2d61946557db6b$export$25a8cf27557a612d);
const $ad2d61946557db6b$export$25a8cf27557a612d = {
    name: 'software-plan-summary',
    path: '/jira/plans/:planId/scenarios/:scenarioId/summary'
};

});

parcelRegister("35bOg", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSummary", () => $d70e7ef12abe6465$export$c717f0d9d7f11b49);
$parcel$export(module.exports, "default", () => $d70e7ef12abe6465$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $d70e7ef12abe6465$export$c717f0d9d7f11b49 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4OJVt"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-summary/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d70e7ef12abe6465$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d70e7ef12abe6465$export$c717f0d9d7f11b49,
        pageId: "plan-summary",
        shouldShowSpinner: true
    });

});

parcelRegister("3v1Zf", function(module, exports) {

$parcel$export(module.exports, "planSummaryPageEntryPoint", () => $2ab6a879960150e5$export$a3858cce1e973f19);
$parcel$export(module.exports, "planSummaryPageEntryPointWithoutHorizontalNavigation", () => $2ab6a879960150e5$export$581542c1c5ef42f8);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $739vE = parcelRequire("739vE");

var $57oLc = parcelRequire("57oLc");
const $2ab6a879960150e5$export$a3858cce1e973f19 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $739vE.planSummaryEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $2ab6a879960150e5$export$581542c1c5ef42f8 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $739vE.planSummaryEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});


parcelRegister("qruNQ", function(module, exports) {

$parcel$export(module.exports, "softwarePlanTeamsRouteEntry", () => $ed7f2a4db7ff0a01$export$cc5b7d3f8546a313);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $fFiNA = parcelRequire("fFiNA");

var $4R6GH = parcelRequire("4R6GH");

var $44giz = parcelRequire("44giz");

var $40ny3 = parcelRequire("40ny3");
const $ed7f2a4db7ff0a01$export$cc5b7d3f8546a313 = (0, $7NszV.createEntry)((0, $fFiNA.softwarePlanTeamsRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $40ny3.planTeamsPageEntryPoint) : (0, $40ny3.planTeamsPageEntryPointWithoutHorizontalNavigation) : undefined,
        component: (0, $44giz.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $44giz.LazyPlanTeams)
        ]
    }));

});
parcelRegister("fFiNA", function(module, exports) {

$parcel$export(module.exports, "softwarePlanTeamsRoute", () => $132f449f27d99391$export$fc66f5c0de18ddc7);
const $132f449f27d99391$export$fc66f5c0de18ddc7 = {
    name: 'software-plan-teams',
    path: '/jira/plans/:planId/scenarios/:scenarioId/teams'
};

});

parcelRegister("44giz", function(module, exports) {

$parcel$export(module.exports, "LazyPlanTeams", () => $243c6380c0240648$export$f85952f98f28fed0);
$parcel$export(module.exports, "default", () => $243c6380c0240648$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $243c6380c0240648$export$f85952f98f28fed0 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9mbp4"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-teams/index-old.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$243c6380c0240648$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $243c6380c0240648$export$f85952f98f28fed0,
        pageId: "plan-teams",
        shouldShowSpinner: true
    });

});
parcelRegister("9mbp4", function(module, exports) {

let $6cff0397cc48542e$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $6cff0397cc48542e$var$load("kfXhT"),
    $6cff0397cc48542e$var$load("2Lfdl"),
    $6cff0397cc48542e$var$load("cM9em"),
    $6cff0397cc48542e$var$load("fr9NE"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("dt4Kr"), 4)),
    $6cff0397cc48542e$var$load("dsiAd"),
    $6cff0397cc48542e$var$load("h9jxu")
]).then(()=>parcelRequire('gEN7m'));

});


parcelRegister("40ny3", function(module, exports) {

$parcel$export(module.exports, "planTeamsPageEntryPoint", () => $7b0bfdd4f2079663$export$e75b3c6626974862);
$parcel$export(module.exports, "planTeamsPageEntryPointWithoutHorizontalNavigation", () => $7b0bfdd4f2079663$export$16a85e75293f1984);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $dhgMR = parcelRequire("dhgMR");

var $57oLc = parcelRequire("57oLc");
const $7b0bfdd4f2079663$export$e75b3c6626974862 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dhgMR.planTeamsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $7b0bfdd4f2079663$export$16a85e75293f1984 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dhgMR.planTeamsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});
parcelRegister("dhgMR", function(module, exports) {

$parcel$export(module.exports, "planTeamsEntryPoint", () => $1ae70864b1d134b4$export$afd1c95955e9abac);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $1ae70864b1d134b4$export$afd1c95955e9abac = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>{
        if (!false) return (parcelRequire("i1ytB"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "8c4bf459"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("i1ytB", function(module, exports) {

let $d1f31049a18aec39$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $d1f31049a18aec39$var$load("kfXhT"),
    $d1f31049a18aec39$var$load("2Lfdl"),
    $d1f31049a18aec39$var$load("cM9em"),
    $d1f31049a18aec39$var$load("fr9NE"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("g1QGP"), 4)),
    $d1f31049a18aec39$var$load("dsiAd"),
    $d1f31049a18aec39$var$load("itwp0")
]).then(()=>parcelRequire('j7IwW'));

});




parcelRegister("4chTT", function(module, exports) {

$parcel$export(module.exports, "softwarePlanTimelineRouteEntry", () => $970ae3ae6d33a9e3$export$c5b46ecd4d9a8abd);

var $ffza4 = parcelRequire("ffza4");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $2oTRI = parcelRequire("2oTRI");

var $g6wgl = parcelRequire("g6wgl");

var $cnLXu = parcelRequire("cnLXu");
const $970ae3ae6d33a9e3$export$c5b46ecd4d9a8abd = (0, $7NszV.createEntry)((0, $2oTRI.softwarePlanTimelineRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $cnLXu.planTimelinePageEntryPoint) : (0, $cnLXu.planTimelinePageEntryPointWithoutHorizontalNavigation) : undefined,
        component: (0, $g6wgl.default),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-opt-out-timeline'),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("2oTRI", function(module, exports) {

$parcel$export(module.exports, "softwarePlanTimelineRoute", () => $946f497d921d5041$export$61abeb6a03d23dd3);
const $946f497d921d5041$export$61abeb6a03d23dd3 = {
    name: 'software-plan-timeline',
    path: '/jira/plans/:planId/scenarios/:scenarioId/timeline'
};

});

parcelRegister("cnLXu", function(module, exports) {

$parcel$export(module.exports, "planTimelinePageEntryPoint", () => $1450d939edbc2ee3$export$7ee5b399f9530a72);
$parcel$export(module.exports, "planTimelinePageEntryPointWithoutHorizontalNavigation", () => $1450d939edbc2ee3$export$2476bbde953fbfc0);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $4Xa0b = parcelRequire("4Xa0b");

var $57oLc = parcelRequire("57oLc");
const $1450d939edbc2ee3$export$7ee5b399f9530a72 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4Xa0b.planTimelineEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $1450d939edbc2ee3$export$2476bbde953fbfc0 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4Xa0b.planTimelineEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});


parcelRegister("5qx9W", function(module, exports) {

$parcel$export(module.exports, "planUpsellRouteEntry", () => $7ff38098f11bff34$export$363894d991872cbf);

var $7NszV = parcelRequire("7NszV");

var $eCT4E = parcelRequire("eCT4E");

var $lmyls = parcelRequire("lmyls");

var $2BrOV = parcelRequire("2BrOV");

var $3RJkv = parcelRequire("3RJkv");

var $eeeSt = parcelRequire("eeeSt");
const $7ff38098f11bff34$export$363894d991872cbf = (0, $7NszV.createEntry)((0, $eCT4E.planUpsellRoute), ()=>({
        group: 'software',
        entryPoint () {
            return 0, $eeeSt.planUpsellPageEntryPoint;
        },
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        }
    }));

});
parcelRegister("eCT4E", function(module, exports) {

$parcel$export(module.exports, "planUpsellRoute", () => $e26c6899078b71eb$export$bda76e09a8dec9a0);
const $e26c6899078b71eb$export$bda76e09a8dec9a0 = {
    name: 'software-plan-upsell',
    path: '/jira/plans/getting-started'
};

});

parcelRegister("eeeSt", function(module, exports) {

$parcel$export(module.exports, "planUpsellPageEntryPoint", () => $8fee77540cc4840f$export$7551fe27e3c0a4bf);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fzr0K = parcelRequire("fzr0K");
const $8fee77540cc4840f$export$7551fe27e3c0a4bf = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fzr0K.planUpsellEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});
parcelRegister("fzr0K", function(module, exports) {

$parcel$export(module.exports, "planUpsellEntryPoint", () => $8cc471b800a3023f$export$2fc05036b41321cf);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $8cc471b800a3023f$export$2fc05036b41321cf = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("dnjFj")), {
        moduleId: "8a4ffc36"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dnjFj", function(module, exports) {

let $02834d1edb02c9aa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $02834d1edb02c9aa$var$load("ekkeS").then(()=>parcelRequire('gUsws'));

});




parcelRegister("5dqn2", function(module, exports) {

$parcel$export(module.exports, "planViewNotFoundRouteEntry", () => $e166e971b74a927b$export$19c7bb0eeda48c06);

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $NONdU = parcelRequire("NONdU");

var $aPfsS = parcelRequire("aPfsS");

var $2BrOV = parcelRequire("2BrOV");

var $451ix = parcelRequire("451ix");

var $937TY = parcelRequire("937TY");

var $lEqGO = parcelRequire("lEqGO");
const $e166e971b74a927b$export$19c7bb0eeda48c06 = (0, $7NszV.createEntry)((0, $NONdU.planViewNotFoundRoute), ()=>({
        group: 'software',
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)()
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        entryPoint: ()=>(0, $lEqGO.planViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("NONdU", function(module, exports) {

$parcel$export(module.exports, "planViewNotFoundRoute", () => $81b3aac8927596c6$export$f2531e319f8b4274);
const $81b3aac8927596c6$export$f2531e319f8b4274 = {
    name: 'plan-view-not-found',
    path: '/jira/plans/:planId/scenarios/:scenarioId/not-found'
};

});

parcelRegister("lEqGO", function(module, exports) {

$parcel$export(module.exports, "planViewNotFoundPageEntrypoint", () => $5fbb9e47837eed67$export$18e8a0d930f394a2);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $1RGLt = parcelRequire("1RGLt");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $57oLc = parcelRequire("57oLc");

const $5fbb9e47837eed67$var$main = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("j5pem")), {
        moduleId: "f2ea0209",
        moduleName: "PlanViewNotFound"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        const planId = match.params.planId;
        if (!planId) throw new Error('Plan Id is missing');
        return {
            queries: {
                mainQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $1RGLt.default,
                    variables: {
                        planId: `ari:cloud:jira:${cloudId}:plan/activation/${activationId}/${planId}`
                    }
                }
            }
        };
    }
});
const $5fbb9e47837eed67$export$18e8a0d930f394a2 = (0, $lkFvK.createPageEntryPoint)({
    main: $5fbb9e47837eed67$var$main,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});
parcelRegister("1RGLt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e981f11ecdd6cbe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f97e78ab59091e8012bd8a05696ce789>>
 * @relayHash c51281360f2d7bd5387e9bb058f11f6d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 29dd5915a4af58bbd22d79842971790506a1f3ab87507ab96eca150acfd91229
const $5e981f11ecdd6cbe$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "29dd5915a4af58bbd22d79842971790506a1f3ab87507ab96eca150acfd91229",
        "metadata": {},
        "name": "PlanViewNotFoundQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5e981f11ecdd6cbe$export$2e2bcd8739ae039 = $5e981f11ecdd6cbe$var$node;

});

parcelRegister("j5pem", function(module, exports) {

let $de520e370d2f0ae3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $de520e370d2f0ae3$var$load("cMROm").then(()=>parcelRequire('eIJQP'));

});



parcelRegister("7gypr", function(module, exports) {

$parcel$export(module.exports, "arjSettingsDependenciesLegacyRedirectRouteEntry", () => $3678ca52b1bdf235$export$804f2d81dfbdd5c9);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3DNgf = parcelRequire("3DNgf");

var $3RJkv = parcelRequire("3RJkv");

var $6i7U6 = parcelRequire("6i7U6");

var $a9hcp = parcelRequire("a9hcp");

var $i8IhR = parcelRequire("i8IhR");
const $3678ca52b1bdf235$export$804f2d81dfbdd5c9 = (0, $7NszV.createEntry)((0, $6i7U6.arjSettingsDependenciesLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $i8IhR.redirectTo)('/jira/plans/settings/dependencies'),
        isRedirect: true,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $3DNgf.issueLinkInformationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a9hcp.LazyArjSettingsDependencies)
        ]
    }));

});
parcelRegister("3DNgf", function(module, exports) {

$parcel$export(module.exports, "issueLinkInformationResource", () => $8163e55c16e335dc$export$8d8544ca08d98837);

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
const $8163e55c16e335dc$var$body = {
    providers: [
        'issueLinks',
        'dependencySettings'
    ]
};
const $8163e55c16e335dc$var$url = '/rest/jpo/1.0/info/query';
const $8163e55c16e335dc$var$fetchIssueLinkInformation = ()=>(0, $eusud.performPostRequest)($8163e55c16e335dc$var$url, {
        body: JSON.stringify($8163e55c16e335dc$var$body)
    });
const $8163e55c16e335dc$export$8d8544ca08d98837 = (0, $2M1hQ.createResource)({
    type: 'ISSUE_LINK_INFORMATION',
    getKey: ()=>'issue-link-information',
    getData: async ()=>$8163e55c16e335dc$var$fetchIssueLinkInformation(),
    maxAge: 0
});

});

parcelRegister("6i7U6", function(module, exports) {

$parcel$export(module.exports, "arjSettingsDependenciesLegacyRedirectRoute", () => $461a54dd9cfd2345$export$f96bfb0a2b0ad0f4);
const $461a54dd9cfd2345$export$f96bfb0a2b0ad0f4 = {
    name: 'arj-settings-dependencies-redirect',
    path: '/secure/PortfolioDependencySettings.jspa'
};

});

parcelRegister("a9hcp", function(module, exports) {

$parcel$export(module.exports, "LazyArjSettingsDependencies", () => $8f893c79e2990b05$export$4fcc3c0f6e792efc);
$parcel$export(module.exports, "ArjSettingsDependencies", () => $8f893c79e2990b05$export$d6f045c7c1aaff50);
$parcel$export(module.exports, "LazyArjSettingsLoadingLimits", () => $8f893c79e2990b05$export$64761ea1912fdcd9);
$parcel$export(module.exports, "ArjSettingsLoadingLimits", () => $8f893c79e2990b05$export$7bb4c0f22b467385);
$parcel$export(module.exports, "LazyArjSettingsPermissions", () => $8f893c79e2990b05$export$edb4ae7e85c7908d);
$parcel$export(module.exports, "ArjSettingsPermissions", () => $8f893c79e2990b05$export$fa852ea42b98d3de);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $8f893c79e2990b05$export$4fcc3c0f6e792efc = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9ljbD"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/dependencies/index.tsx"
});
const $8f893c79e2990b05$export$d6f045c7c1aaff50 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8f893c79e2990b05$export$4fcc3c0f6e792efc,
        pageId: "arj-settings-dependencies",
        shouldShowSpinner: true
    });

const $8f893c79e2990b05$export$64761ea1912fdcd9 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("3apPi"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/loading-limits/index.tsx"
});
const $8f893c79e2990b05$export$7bb4c0f22b467385 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8f893c79e2990b05$export$64761ea1912fdcd9,
        pageId: "arj-settings-loading-limits",
        shouldShowSpinner: true
    });

const $8f893c79e2990b05$export$edb4ae7e85c7908d = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("Ov3bE"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/permissions/index.tsx"
});
const $8f893c79e2990b05$export$fa852ea42b98d3de = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8f893c79e2990b05$export$edb4ae7e85c7908d,
        pageId: "arj-settings-permissions",
        shouldShowSpinner: true
    });

});
parcelRegister("9ljbD", function(module, exports) {

let $6cd4f54ca1149aed$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6cd4f54ca1149aed$var$load("bLzp5").then(()=>parcelRequire('1Ba8D'));

});

parcelRegister("3apPi", function(module, exports) {

let $24e656d7fe3b1919$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("7EBJU"), 4)),
    $24e656d7fe3b1919$var$load("bDZ6z")
]).then(()=>parcelRequire('ieFCi'));

});

parcelRegister("Ov3bE", function(module, exports) {

let $097cc196d1d64c6b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $097cc196d1d64c6b$var$load("31VzL").then(()=>parcelRequire('luimD'));

});


parcelRegister("i8IhR", function(module, exports) {

$parcel$export(module.exports, "redirectTo", () => $cf0b6f0a8f874806$export$2d47ce6f15e624e5);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");
const $cf0b6f0a8f874806$export$2d47ce6f15e624e5 = (redirectUrl)=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
            to: redirectUrl
        });

});


parcelRegister("cwKGx", function(module, exports) {

$parcel$export(module.exports, "arjSettingsDependenciesRouteEntry", () => $98e5774d92d39cbd$export$70386609aff5ba12);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3DNgf = parcelRequire("3DNgf");

var $3RJkv = parcelRequire("3RJkv");

var $3NV88 = parcelRequire("3NV88");

var $a9hcp = parcelRequire("a9hcp");
const $98e5774d92d39cbd$export$70386609aff5ba12 = (0, $7NszV.createEntry)((0, $3NV88.arjSettingsDependenciesRoute), ()=>({
        group: 'software',
        component: (0, $a9hcp.ArjSettingsDependencies),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $3DNgf.issueLinkInformationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a9hcp.LazyArjSettingsDependencies)
        ]
    }));

});
parcelRegister("3NV88", function(module, exports) {

$parcel$export(module.exports, "arjSettingsDependenciesRoute", () => $2117b55ed774a2be$export$ff9b90f9d680e34);
const $2117b55ed774a2be$export$ff9b90f9d680e34 = {
    name: 'arj-settings-dependencies',
    path: '/jira/plans/settings/dependencies'
};

});


parcelRegister("dfdSu", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsLegacyRedirectRouteEntry", () => $99f00cddc0758136$export$9f80102c0f64ad9b);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $44HQw = parcelRequire("44HQw");

var $a9hcp = parcelRequire("a9hcp");

var $i8IhR = parcelRequire("i8IhR");
const $99f00cddc0758136$export$9f80102c0f64ad9b = (0, $7NszV.createEntry)((0, $44HQw.arjSettingsLoadingLimitsLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $i8IhR.redirectTo)('/jira/plans/settings/loading-limits'),
        isRedirect: true,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a9hcp.LazyArjSettingsLoadingLimits)
        ]
    }));

});
parcelRegister("44HQw", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsLegacyRedirectRoute", () => $abfe17fb063fcb4e$export$7c71e235d628daf5);
const $abfe17fb063fcb4e$export$7c71e235d628daf5 = {
    name: 'arj-settings-loading-limits-redirect',
    path: '/secure/PortfolioLoadingLimits.jspa'
};

});


parcelRegister("ieqGd", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsRouteEntry", () => $f2c5f02fe8472718$export$6786257309f86d8c);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $azWKH = parcelRequire("azWKH");

var $3RJkv = parcelRequire("3RJkv");

var $hTLqB = parcelRequire("hTLqB");

var $a9hcp = parcelRequire("a9hcp");
const $f2c5f02fe8472718$export$6786257309f86d8c = (0, $7NszV.createEntry)((0, $hTLqB.arjSettingsLoadingLimitsRoute), ()=>({
        group: 'software',
        component: (0, $a9hcp.ArjSettingsLoadingLimits),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $azWKH.arjSettingsLoadingLimitsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a9hcp.LazyArjSettingsLoadingLimits)
        ]
    }));

});
parcelRegister("azWKH", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsResource", () => $a9399ce8867d02dc$export$c9e47fa9b57975f5);

var $7f4tk = parcelRequire("7f4tk");

var $2M1hQ = parcelRequire("2M1hQ");

const $a9399ce8867d02dc$export$c9e47fa9b57975f5 = (0, $2M1hQ.createResource)({
    type: (0, $a9d74ae4a12ce55b$export$cd7bb91dd2e30684),
    getKey: ()=>'loading-limits-information',
    getData: async ()=>(0, $7f4tk.default)('/rest/jpo/1.0/configuration'),
    maxAge: 0
});

});
const $a9d74ae4a12ce55b$export$cd7bb91dd2e30684 = 'RESOURCE_TYPE_ARJ_SETTINGS_LOADING_LIMITS';


parcelRegister("hTLqB", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsRoute", () => $46a780a2a2e80d5e$export$f90dc3a45fadc1e2);
const $46a780a2a2e80d5e$export$f90dc3a45fadc1e2 = {
    name: 'arj-settings-loading-limits',
    path: '/jira/plans/settings/loading-limits'
};

});


parcelRegister("JQ5Vt", function(module, exports) {

$parcel$export(module.exports, "arjSettingsPermissionsRouteEntry", () => $c52f49db3f216f46$export$4e97658a5cc15eaa);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $1aR84 = parcelRequire("1aR84");

var $3RJkv = parcelRequire("3RJkv");

var $a8ttb = parcelRequire("a8ttb");

var $a9hcp = parcelRequire("a9hcp");
const $c52f49db3f216f46$export$4e97658a5cc15eaa = (0, $7NszV.createEntry)((0, $a8ttb.arjSettingsPermissionsRoute), ()=>({
        group: 'software',
        component: (0, $a9hcp.ArjSettingsPermissions),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $1aR84.getGlobalPermissionPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a9hcp.LazyArjSettingsPermissions)
        ]
    }));

});
parcelRegister("1aR84", function(module, exports) {

$parcel$export(module.exports, "grantedPermissionsResource", () => $d675e556a71c706a$export$aa3daf3280e2a2d7);
$parcel$export(module.exports, "permissionGroupsResource", () => $d675e556a71c706a$export$950060d83722e3bd);
$parcel$export(module.exports, "getGlobalPermissionPageResources", () => $d675e556a71c706a$export$a09a91246a866817);

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
const $d675e556a71c706a$var$fetchGrantedPermissions = ()=>(0, $eusud.performPostRequest)('/rest/roadmaps/1.0/info/query', {
        body: JSON.stringify({
            providers: [
                'permissions'
            ]
        })
    });
const $d675e556a71c706a$var$fetchPermissionGroups = ()=>(0, $eusud.performPostRequest)('/rest/jpo/1.0/groupsandusers', {
        body: JSON.stringify({
            includeUsers: false,
            excludedGroups: [],
            excludedUsers: [],
            query: ''
        })
    });
const $d675e556a71c706a$export$aa3daf3280e2a2d7 = (0, $2M1hQ.createResource)({
    type: 'ARJ_GLOBAL_PERMISSIONS_GRANTED',
    getKey: ()=>'arj-granted-permissions',
    getData: async ()=>$d675e556a71c706a$var$fetchGrantedPermissions(),
    maxAge: 0
});
const $d675e556a71c706a$export$950060d83722e3bd = (0, $2M1hQ.createResource)({
    type: 'ARJ_GLOBAL_PERMISSIONS_GROUPS',
    getKey: ()=>'arj-permission-groups',
    getData: async ()=>$d675e556a71c706a$var$fetchPermissionGroups(),
    maxAge: 0
});
const $d675e556a71c706a$export$a09a91246a866817 = ()=>[
        $d675e556a71c706a$export$aa3daf3280e2a2d7,
        $d675e556a71c706a$export$950060d83722e3bd
    ];

});

parcelRegister("a8ttb", function(module, exports) {

$parcel$export(module.exports, "arjSettingsPermissionsRoute", () => $b264455695405ab2$export$4501213a8b1d3a10);
const $b264455695405ab2$export$4501213a8b1d3a10 = {
    name: 'arj-settings-permissions',
    path: '/jira/plans/settings/permissions'
};

});


parcelRegister("eOPb5", function(module, exports) {

$parcel$export(module.exports, "arjSettingsPermissionsRouteLegacyRedirectRouteEntry", () => $75e3fe7119ee0518$export$949c8177281fcc39);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $1aR84 = parcelRequire("1aR84");

var $3RJkv = parcelRequire("3RJkv");

var $dl4rj = parcelRequire("dl4rj");

var $a9hcp = parcelRequire("a9hcp");

var $i8IhR = parcelRequire("i8IhR");
const $75e3fe7119ee0518$export$949c8177281fcc39 = (0, $7NszV.createEntry)((0, $dl4rj.arjSettingsPermissionsRouteLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $i8IhR.redirectTo)('/jira/plans/settings/permissions'),
        isRedirect: true,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $1aR84.getGlobalPermissionPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a9hcp.LazyArjSettingsPermissions)
        ]
    }));

});
parcelRegister("dl4rj", function(module, exports) {

$parcel$export(module.exports, "arjSettingsPermissionsRouteLegacyRedirectRoute", () => $a53440ab81155fb2$export$24bf73f2d1dbf0db);
const $a53440ab81155fb2$export$24bf73f2d1dbf0db = {
    name: 'arj-settings-permissions-redirect',
    path: '/secure/PortfolioPermissions.jspa'
};

});


parcelRegister("vDjHk", function(module, exports) {

$parcel$export(module.exports, "archivedPlansRouteEntry", () => $2934b1049cdc0b54$export$b9921058a8a65710);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $ixtmm = parcelRequire("ixtmm");

var $7kSGc = parcelRequire("7kSGc");
const $2934b1049cdc0b54$export$b9921058a8a65710 = (0, $7NszV.createEntry)((0, $ixtmm.archivedPlansRoute), ()=>({
        group: 'global-settings',
        component: (0, $7kSGc.ArchivedPlansDirectory),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7kSGc.LazyArchivedPlans)
        ]
    }));

});
parcelRegister("ixtmm", function(module, exports) {

$parcel$export(module.exports, "archivedPlansRoute", () => $8d4bd95d29fd1b87$export$29647353386ad146);
const $8d4bd95d29fd1b87$export$29647353386ad146 = {
    name: 'archived-plans-directory',
    path: '/jira/plans/settings/archive',
    exact: true
};

});

parcelRegister("7kSGc", function(module, exports) {

$parcel$export(module.exports, "LazyArchivedPlans", () => $e8a09ac95de555a1$export$cf676f47aba10db8);
$parcel$export(module.exports, "ArchivedPlansDirectory", () => $e8a09ac95de555a1$export$ed59bbc59461c00f);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $e8a09ac95de555a1$export$cf676f47aba10db8 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("g0R4J")).then((module)=>module.ArchivedPlans)), {
    moduleId: "./src/packages/spa-apps/admin-pages/archived-plans/src/index.tsx"
});
const $e8a09ac95de555a1$export$ed59bbc59461c00f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e8a09ac95de555a1$export$cf676f47aba10db8,
        pageId: "archived-plans",
        shouldShowSpinner: true
    });

});
parcelRegister("g0R4J", function(module, exports) {

let $ba85d10fc7c19e1b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ba85d10fc7c19e1b$var$load("19M8q").then(()=>parcelRequire('14EEk'));

});



parcelRegister("jZMnM", function(module, exports) {

$parcel$export(module.exports, "arjSettingsFinancialYearPageRouteEntry", () => $a36cb3f650c3074c$export$b6bba25826e621b9);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $7j3uW = parcelRequire("7j3uW");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $avmE3 = parcelRequire("avmE3");

var $Jhp2x = parcelRequire("Jhp2x");
const $a36cb3f650c3074c$export$b6bba25826e621b9 = (0, $7NszV.createEntry)((0, $avmE3.arjSettingsFinancialYearPageRoute), ()=>({
        group: 'software',
        component: (0, $Jhp2x.ArjSettingsFinancialYear),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $7j3uW.arjSettingsFinancialYearResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $Jhp2x.LazyArjSettingsFinancialYear)
        ]
    }));

});
parcelRegister("7j3uW", function(module, exports) {

$parcel$export(module.exports, "arjSettingsFinancialYearResource", () => $59a235170c0d382a$export$da45020eede4a793);

var $7f4tk = parcelRequire("7f4tk");

var $2M1hQ = parcelRequire("2M1hQ");

const $59a235170c0d382a$export$da45020eede4a793 = (0, $2M1hQ.createResource)({
    type: (0, $b242b5aa0787944c$export$e8e0384e95388aa3),
    getKey: ()=>'financial-year-information',
    getData: async ()=>(0, $7f4tk.default)('/rest/jpo/1.0/fiscalYear'),
    maxAge: 0
});

});
const $b242b5aa0787944c$export$e8e0384e95388aa3 = 'RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR';


parcelRegister("avmE3", function(module, exports) {

$parcel$export(module.exports, "arjSettingsFinancialYearPageRoute", () => $7565a345f1dea2b4$export$7208300f00a36a5f);
const $7565a345f1dea2b4$export$7208300f00a36a5f = {
    name: 'arj-settings-financial-year',
    path: '/jira/plans/settings/financial-year',
    exact: true
};

});

parcelRegister("Jhp2x", function(module, exports) {

$parcel$export(module.exports, "LazyArjSettingsFinancialYear", () => $b5d39848dc9e7ba6$export$dd67c2f01a58231e);
$parcel$export(module.exports, "ArjSettingsFinancialYear", () => $b5d39848dc9e7ba6$export$785180185eba7ed9);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $b5d39848dc9e7ba6$export$dd67c2f01a58231e = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jqlm0")).then((module)=>module.ArjSettingsFinancialYear)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/financial-year/index.tsx"
});
const $b5d39848dc9e7ba6$export$785180185eba7ed9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b5d39848dc9e7ba6$export$dd67c2f01a58231e,
        pageId: "arj-settings-financial-year",
        shouldShowSpinner: true
    });

});
parcelRegister("jqlm0", function(module, exports) {

let $e241027da8f72ffb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e241027da8f72ffb$var$load("hCaEC").then(()=>parcelRequire('7bDNN'));

});



parcelRegister("5nA0V", function(module, exports) {

$parcel$export(module.exports, "planIncrementRouteEntry", () => $13d9e6b7582fbfc8$export$a26fa5cabff8bc7c);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $czMjG = parcelRequire("czMjG");

var $4R6GH = parcelRequire("4R6GH");

var $eCdAs = parcelRequire("eCdAs");

var $8iKh5 = parcelRequire("8iKh5");
const $13d9e6b7582fbfc8$export$a26fa5cabff8bc7c = (0, $7NszV.createEntry)((0, $czMjG.planIncrementRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $eCdAs.planIncrementPageEntryPoint) : (0, $eCdAs.planIncrementPageEntryPointWithoutHorizontalNavigation) : undefined,
        component: (0, $8iKh5.PlanIncrement),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8iKh5.LazyPlanIncrement)
        ]
    }));

});
parcelRegister("czMjG", function(module, exports) {

$parcel$export(module.exports, "planIncrementRoute", () => $1f9e3780cba4a3e0$export$ef33a75556fde209);
const $1f9e3780cba4a3e0$export$ef33a75556fde209 = {
    name: 'software-plan-increment',
    path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId',
    exact: true
};

});

parcelRegister("eCdAs", function(module, exports) {

$parcel$export(module.exports, "planIncrementPageEntryPoint", () => $fd8b21deba1fc1a8$export$a87dd3f7b0d2f7c2);
$parcel$export(module.exports, "planIncrementPageEntryPointWithoutHorizontalNavigation", () => $fd8b21deba1fc1a8$export$1d20f43e7336cbe6);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $8tlKP = parcelRequire("8tlKP");

var $57oLc = parcelRequire("57oLc");
const $fd8b21deba1fc1a8$export$a87dd3f7b0d2f7c2 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8tlKP.planIncrementEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $fd8b21deba1fc1a8$export$1d20f43e7336cbe6 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8tlKP.planIncrementEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});

parcelRegister("8iKh5", function(module, exports) {

$parcel$export(module.exports, "LazyPlanIncrement", () => $e45281955bb769d7$export$e7b9f83d442bac51);
$parcel$export(module.exports, "PlanIncrement", () => $e45281955bb769d7$export$5e1035d0876d64db);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $e45281955bb769d7$export$e7b9f83d442bac51 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("63F1J"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increment/index-old.tsx"
});
const $e45281955bb769d7$export$5e1035d0876d64db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e45281955bb769d7$export$e7b9f83d442bac51,
        pageId: "plan-increment",
        shouldShowSpinner: true
    });

});


parcelRegister("bQ0RK", function(module, exports) {

$parcel$export(module.exports, "planIncrementsRouteEntry", () => $38c9ffd9e7c2e0a9$export$f7abc47036ff7dd9);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $f3F6W = parcelRequire("f3F6W");

var $4R6GH = parcelRequire("4R6GH");

var $iHuPr = parcelRequire("iHuPr");

var $fw6rG = parcelRequire("fw6rG");
const $38c9ffd9e7c2e0a9$export$f7abc47036ff7dd9 = (0, $7NszV.createEntry)((0, $f3F6W.planIncrementsRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $fw6rG.planProgramPageEntryPoint) : (0, $fw6rG.planProgramPageEntryPointWithoutHorizontalNavigation) : undefined,
        component: (0, $iHuPr.PlanProgram),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $iHuPr.LazyPlanProgram)
        ]
    }));

});
parcelRegister("f3F6W", function(module, exports) {

$parcel$export(module.exports, "planIncrementsRoute", () => $1fae537885c9da25$export$d0986e4bd9568b30);
const $1fae537885c9da25$export$d0986e4bd9568b30 = {
    name: 'software-plan-increments',
    path: '/jira/plans/:planId/scenarios/:scenarioId/program',
    exact: true
};

});

parcelRegister("iHuPr", function(module, exports) {

$parcel$export(module.exports, "LazyPlanProgram", () => $ad7f54b0993adadc$export$9da4d4d5c4d7f749);
$parcel$export(module.exports, "PlanProgram", () => $ad7f54b0993adadc$export$fb30c2b19a4f5d59);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $ad7f54b0993adadc$export$9da4d4d5c4d7f749 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("3BZBU"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-program/index-old.tsx"
});
const $ad7f54b0993adadc$export$fb30c2b19a4f5d59 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ad7f54b0993adadc$export$9da4d4d5c4d7f749,
        pageId: "plan-program",
        shouldShowSpinner: true
    });

});
parcelRegister("3BZBU", function(module, exports) {

let $2a149e5aeb97f994$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("3uTiv"), 4)),
    $2a149e5aeb97f994$var$load("R0NVt")
]).then(()=>parcelRequire('hWHTd'));

});


parcelRegister("fw6rG", function(module, exports) {

$parcel$export(module.exports, "planProgramPageEntryPoint", () => $d0d482e714f6dec6$export$cb6ac90e8faddaeb);
$parcel$export(module.exports, "planProgramPageEntryPointWithoutHorizontalNavigation", () => $d0d482e714f6dec6$export$4d1acef570d425d5);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $avgZu = parcelRequire("avgZu");

var $57oLc = parcelRequire("57oLc");
const $d0d482e714f6dec6$export$cb6ac90e8faddaeb = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $avgZu.planProgramEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $d0d482e714f6dec6$export$4d1acef570d425d5 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $avgZu.planProgramEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});
parcelRegister("avgZu", function(module, exports) {

$parcel$export(module.exports, "planProgramEntryPoint", () => $9e8c359432edc7ee$export$da91c765d9841bae);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $9e8c359432edc7ee$export$da91c765d9841bae = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>{
        if (!false) return (parcelRequire("kCANa"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "1b761aac"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kCANa", function(module, exports) {

let $f033e5639d3226e3$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("64R0p"), 4)),
    $f033e5639d3226e3$var$load("8elb9")
]).then(()=>parcelRequire('laRNy'));

});




parcelRegister("7UDCM", function(module, exports) {

$parcel$export(module.exports, "trashedPlanDirectLinkRouteEntry", () => $5f2b7d10b2a973db$export$dbcd0bd16f12397d);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $3V9Zd = parcelRequire("3V9Zd");

var $7Knxu = parcelRequire("7Knxu");
const $5f2b7d10b2a973db$export$dbcd0bd16f12397d = (0, $7NszV.createEntry)((0, $3V9Zd.trashedPlanDirectLinkRoute), ()=>({
        group: 'software',
        component: (0, $7Knxu.TrashedPlanDirectLink),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7Knxu.LazyTrashedPlanDirectLink)
        ],
        ufoName: 'plan-trashed'
    }));

});
parcelRegister("3V9Zd", function(module, exports) {

$parcel$export(module.exports, "trashedPlanDirectLinkRoute", () => $378d003abbed757a$export$1a9edb72cd49ca79);
const $378d003abbed757a$export$1a9edb72cd49ca79 = {
    name: 'trashed-plan-direct-link',
    path: '/jira/plans/plan-trashed',
    exact: true
};

});

parcelRegister("7Knxu", function(module, exports) {

$parcel$export(module.exports, "LazyTrashedPlanDirectLink", () => $1e04fb6816f8b0a0$export$20a71ac28e6a3c8f);
$parcel$export(module.exports, "TrashedPlanDirectLink", () => $1e04fb6816f8b0a0$export$38f3a061bb1fceee);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $1e04fb6816f8b0a0$export$20a71ac28e6a3c8f = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8Zxm4"))), {
    moduleId: "./src/packages/portfolio-3/plan-trashed-direct-link/src/index.tsx"
});
const $1e04fb6816f8b0a0$export$38f3a061bb1fceee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1e04fb6816f8b0a0$export$20a71ac28e6a3c8f,
        pageId: "trashed-plan-direct-link",
        shouldShowSpinner: false
    });

});
parcelRegister("8Zxm4", function(module, exports) {

let $68bde4d9c882e3ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $68bde4d9c882e3ca$var$load("1U1DX").then(()=>parcelRequire('kIqMQ'));

});



parcelRegister("hDCtq", function(module, exports) {

$parcel$export(module.exports, "trashPlansRouteEntry", () => $2d67b465f26d4e76$export$eabcbe4dd6fc9f1f);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $711SD = parcelRequire("711SD");

var $cm0sO = parcelRequire("cm0sO");
const $2d67b465f26d4e76$export$eabcbe4dd6fc9f1f = (0, $7NszV.createEntry)((0, $711SD.trashPlansRoute), ()=>({
        group: 'software',
        component: (0, $cm0sO.TrashedPlansDirectory),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cm0sO.LazyTrashedPlans)
        ]
    }));

});
parcelRegister("711SD", function(module, exports) {

$parcel$export(module.exports, "trashPlansRoute", () => $83fe99f2cd6e2d28$export$6f5b50c5dc090fd1);
const $83fe99f2cd6e2d28$export$6f5b50c5dc090fd1 = {
    name: 'trash-plans-directory',
    path: '/jira/plans/settings/trash',
    exact: true
};

});

parcelRegister("cm0sO", function(module, exports) {

$parcel$export(module.exports, "LazyTrashedPlans", () => $87393f1bbf5aac77$export$6ac18b311b7e51a1);
$parcel$export(module.exports, "TrashedPlansDirectory", () => $87393f1bbf5aac77$export$b145fa65818ff157);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $87393f1bbf5aac77$export$6ac18b311b7e51a1 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6jJXF")).then((module)=>module.TrashedPlans)), {
    moduleId: "./src/packages/spa-apps/admin-pages/trashed-plans/src/index.tsx"
});
const $87393f1bbf5aac77$export$b145fa65818ff157 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $87393f1bbf5aac77$export$6ac18b311b7e51a1,
        pageId: "trashed-plans",
        shouldShowSpinner: true
    });

});
parcelRegister("6jJXF", function(module, exports) {

let $49982b672906eb55$var$load = (parcelRequire("28QjX"))(4);
module.exports = $49982b672906eb55$var$load("573g9").then(()=>parcelRequire('95BjK'));

});



parcelRegister("9CxHM", function(module, exports) {

$parcel$export(module.exports, "archivedProjectDirectLinkRouteEntry", () => $83811b47cb2e3e0c$export$45e68d450757a753);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $lQihQ = parcelRequire("lQihQ");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $83811b47cb2e3e0c$var$LazyArchivedDirectLink = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("dUBot"))), {
    moduleId: "./src/packages/project-pages/project-archive/project-archived-direct-link/src/index.tsx"
});
const $83811b47cb2e3e0c$var$ArchivedProjectDirectLink = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $83811b47cb2e3e0c$var$LazyArchivedDirectLink,
        pageId: "archived-project-direct-link",
        shouldShowSpinner: false
    });
const $83811b47cb2e3e0c$export$45e68d450757a753 = (0, $7NszV.createEntry)((0, $lQihQ.archivedProjectDirectLinkRoute), ()=>({
        group: 'redirects',
        component: $83811b47cb2e3e0c$var$ArchivedProjectDirectLink,
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $83811b47cb2e3e0c$var$LazyArchivedDirectLink
        ],
        ufoName: 'project-archived'
    }));

});
parcelRegister("lQihQ", function(module, exports) {

$parcel$export(module.exports, "archivedProjectDirectLinkRoute", () => $fcb9d046350a5535$export$cd3fc26cf9f696e6);
const $fcb9d046350a5535$export$cd3fc26cf9f696e6 = {
    name: 'archived-project-direct-link',
    path: '/jira/errors/project-archived',
    exact: true
};

});

parcelRegister("dUBot", function(module, exports) {

let $a20d82f3998ce8eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a20d82f3998ce8eb$var$load("aLLse").then(()=>parcelRequire('hCnfn'));

});


parcelRegister("eaKG5", function(module, exports) {

$parcel$export(module.exports, "archivedProjectsDirectoryRouteEntry", () => $e0db3e001ba4740c$export$dc5f9e3c3931cc36);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $4jMkc = parcelRequire("4jMkc");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $hxN3x = parcelRequire("hxN3x");

var $5I9ar = parcelRequire("5I9ar");
const $e0db3e001ba4740c$export$dc5f9e3c3931cc36 = (0, $7NszV.createEntry)((0, $hxN3x.archivedProjectsDirectoryRoute), ()=>({
        group: 'global-settings',
        component: (0, $5I9ar.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5I9ar.LazyArchivedProjectsAdmin)
        ],
        ufoName: 'admin.archived-projects'
    }));

});
parcelRegister("4jMkc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb7b1354cffbd527$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

const $bb7b1354cffbd527$var$LazyGlobalProjectsSettingsSidebar = (0, $b7Svb.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("lMg9f")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-projects/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalProjectsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb7b1354cffbd527$var$LazyGlobalProjectsSettingsSidebar, null)));
$bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar.displayName = 'GlobalProjectsSettingsSidebar';
var $bb7b1354cffbd527$export$2e2bcd8739ae039 = $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar;

});
parcelRegister("lMg9f", function(module, exports) {

let $fdaa9b5cc9e99622$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fdaa9b5cc9e99622$var$load("lhVk0").then(()=>parcelRequire('1tunp'));

});


parcelRegister("hxN3x", function(module, exports) {

$parcel$export(module.exports, "archivedProjectsDirectoryRoute", () => $cdb39a82bf3cd9b0$export$b60634d0fa43f719);
const $cdb39a82bf3cd9b0$export$b60634d0fa43f719 = {
    name: 'archived-projects-directory',
    path: '/jira/settings/projects/archive',
    exact: true
};

});

parcelRegister("5I9ar", function(module, exports) {

$parcel$export(module.exports, "LazyArchivedProjectsAdmin", () => $7076addc4fa02bdc$export$b220ffb582ee39aa);
$parcel$export(module.exports, "default", () => $7076addc4fa02bdc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $7076addc4fa02bdc$export$b220ffb582ee39aa = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iDgJ5"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/archived-projects/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7076addc4fa02bdc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7076addc4fa02bdc$export$b220ffb582ee39aa,
        pageId: "archived-projects",
        shouldShowSpinner: true
    });

});
parcelRegister("iDgJ5", function(module, exports) {

let $d908d7fc1b2dd329$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d908d7fc1b2dd329$var$load("dsiAd"),
    $d908d7fc1b2dd329$var$load("8Dqf0")
]).then(()=>parcelRequire('jOclj'));

});



parcelRegister("8zbqc", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesJsmRouteEntry", () => $b2269bc905327468$export$334720f484807a91);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $dHGAL = parcelRequire("dHGAL");

var $6Z2mh = parcelRequire("6Z2mh");

var $gDHR4 = parcelRequire("gDHR4");
const $b2269bc905327468$export$334720f484807a91 = (0, $7NszV.createEntry)((0, $dHGAL.archivedIssuesJsmRoute), ()=>({
        group: 'archive-issues',
        // Refer: issueNavigatorProjectServicedeskRoute from issue-navigator
        layout: (0, $6Z2mh.serviceProjectLayout),
        entryPoint: ()=>(0, $gDHR4.archivedIssuesWithoutHorizontalNavPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ]
    }));

});
parcelRegister("iEUaw", function(module, exports) {

$parcel$export(module.exports, "staticSidebarShortcutsResource", () => $681ca3c44ff39b04$export$4847c29b4786b3b4);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $bskkv = parcelRequire("bskkv");
const $681ca3c44ff39b04$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $681ca3c44ff39b04$export$4847c29b4786b3b4 = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SHORTCUTS',
    getKey: ({ match: match, query: query })=>$681ca3c44ff39b04$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $681ca3c44ff39b04$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const shortcuts = await (0, $bskkv.fetchShortcuts)(projectKeyOrId);
        return shortcuts;
    },
    maxAge: 300000
});

});
parcelRegister("bskkv", function(module, exports) {

$parcel$export(module.exports, "fetchShortcuts", () => $b1e90e13aab5fe84$export$49d696bf2525d700);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");
const $b1e90e13aab5fe84$export$49d696bf2525d700 = (projectKeyOrId)=>{
    try {
        return (0, $7f4tk.default)(`/rest/projects/1.0/project/${projectKeyOrId}/shortcut`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'fetchProjectShortcuts',
            packageName: 'jiraNavigationAppsResources'
        });
        throw error;
    }
};

});


parcelRegister("h0bZU", function(module, exports) {

$parcel$export(module.exports, "ForPaintServicedeskSidebar", () => $ca3f1b5dd616f02b$export$c72ea37d21335def);
$parcel$export(module.exports, "default", () => $ca3f1b5dd616f02b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

var $lODMY = parcelRequire("lODMY");

const $ca3f1b5dd616f02b$export$4553575c70a669bf = (0, $b7Svb.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("epreh")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
});

const $ca3f1b5dd616f02b$var$LazyForPaintServicedeskSidebar = (0, $b7Svb.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("epreh")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
});
const $ca3f1b5dd616f02b$var$AfterPaintServicedeskSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca3f1b5dd616f02b$export$4553575c70a669bf, null)));
const $ca3f1b5dd616f02b$export$c72ea37d21335def = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca3f1b5dd616f02b$var$LazyForPaintServicedeskSidebar, null)));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ca3f1b5dd616f02b$var$ServicedeskSidebarLazyForPaintIssueRouteOnly = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const isIssueRoute = (0, $lODMY.useIsActiveRoute)('issue');
    return isIssueRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca3f1b5dd616f02b$export$c72ea37d21335def, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca3f1b5dd616f02b$var$AfterPaintServicedeskSidebar, null);
});
const $ca3f1b5dd616f02b$var$ServicedeskSidebar = (0, $cSD7y.componentWithFG)('nav_sidebar_software_classic_lazyforpaint', $ca3f1b5dd616f02b$var$ServicedeskSidebarLazyForPaintIssueRouteOnly, $ca3f1b5dd616f02b$var$AfterPaintServicedeskSidebar);
$ca3f1b5dd616f02b$var$ServicedeskSidebar.displayName = 'ServicedeskSidebar';
$ca3f1b5dd616f02b$export$c72ea37d21335def.displayName = 'ServicedeskSidebar';
var $ca3f1b5dd616f02b$export$2e2bcd8739ae039 = $ca3f1b5dd616f02b$var$ServicedeskSidebar;

});
parcelRegister("epreh", function(module, exports) {

let $a7d885a5c6ed3409$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a7d885a5c6ed3409$var$load("kWrFZ"),
    $a7d885a5c6ed3409$var$load("kfXhT"),
    $a7d885a5c6ed3409$var$load("2Lfdl"),
    $a7d885a5c6ed3409$var$load("eNmuD"),
    $a7d885a5c6ed3409$var$load("hPzOn"),
    $a7d885a5c6ed3409$var$load("h2MrD"),
    $a7d885a5c6ed3409$var$load("bYT2S"),
    $a7d885a5c6ed3409$var$load("cM9em"),
    $a7d885a5c6ed3409$var$load("fr9NE"),
    $a7d885a5c6ed3409$var$load("aOxtZ")
]).then(()=>parcelRequire('eufGV'));

});


parcelRegister("7GnDe", function(module, exports) {

$parcel$export(module.exports, "incidentsInitialPageChecksResource", () => $08a008dcde68e650$export$b2b94ce8ba590cc8);
$parcel$export(module.exports, "incidentsCustomFieldIdResource", () => $08a008dcde68e650$export$e81d7afef87ae597);
$parcel$export(module.exports, "incidentExperimentTraitResource", () => $08a008dcde68e650$export$31c6945718067be3);
$parcel$export(module.exports, "incidentExperimentTraitResourceOnNav3Only", () => $08a008dcde68e650$export$6fc19cf1d90e9453);
$parcel$export(module.exports, "incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes", () => $08a008dcde68e650$export$2e6b9e6402ff1d9b);

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");


const $08a008dcde68e650$export$b2b94ce8ba590cc8 = (0, $2M1hQ.createResource)({
    type: (0, $0ec4f2aa733ae93d$export$9018fdf9116edd9b),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("dLBCq"))
});

const $08a008dcde68e650$export$e81d7afef87ae597 = (0, $2M1hQ.createResource)({
    type: (0, $0ec4f2aa733ae93d$export$508a7d8e5c6b1bf),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("imXLO"))
});

const $08a008dcde68e650$export$31c6945718067be3 = (0, $2M1hQ.createResource)({
    type: (0, $0ec4f2aa733ae93d$export$1d954e05e596a51e),
    getKey: ()=>'incident_experiment_traits',
    getDataLoader: ()=>(parcelRequire("hL2wD")),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $08a008dcde68e650$export$6fc19cf1d90e9453 = (0, $gNStA.resourceWithCondition2)(()=>!((0, $3HwlS.getWillShowNav4)() && ((0, $4R6GH.fg)('perf-push-big-components-remove-incidents-resource') || (0, $4R6GH.fg)('perf-push-big-components-nav-remove-resources'))), $08a008dcde68e650$export$31c6945718067be3);
const $08a008dcde68e650$export$2e6b9e6402ff1d9b = (0, $gNStA.resourceWithCondition2)(()=>!((0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('blu-5573-remove-incident-resouce')), $08a008dcde68e650$export$31c6945718067be3);

});
const $0ec4f2aa733ae93d$export$9018fdf9116edd9b = 'INCIDENTS_PAGE_INITIAL_CHECKS';
const $0ec4f2aa733ae93d$export$508a7d8e5c6b1bf = 'INCIDENTS_PAGE_CUSTOM_FIELD_ID';
const $0ec4f2aa733ae93d$export$1d954e05e596a51e = 'INCIDENT_EXPERIMENT_TRAITS';

parcelRegister("dLBCq", function(module, exports) {

let $a05cd876f683a893$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a05cd876f683a893$var$load("jEfvB").then(()=>parcelRequire('8lQN4'));

});

parcelRegister("imXLO", function(module, exports) {

let $d5f8a52d9862c97d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d5f8a52d9862c97d$var$load("8rk6s").then(()=>parcelRequire('i0mY9'));

});

parcelRegister("hL2wD", function(module, exports) {

let $ced8c8f4a6c90a12$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ced8c8f4a6c90a12$var$load("ajWVH").then(()=>parcelRequire('iwLnj'));

});


parcelRegister("dHGAL", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesJsmRoute", () => $96c61d85c5909907$export$1c7220e12a2118ce);
const $96c61d85c5909907$export$1c7220e12a2118ce = {
    name: 'archived-issues-directory',
    path: '/jira/servicedesk/projects/:projectKey/issues/archive',
    exact: true
};

});

parcelRegister("6Z2mh", function(module, exports) {

$parcel$export(module.exports, "serviceProjectLayout", () => $0836cf39cca1e468$export$e321cb31c875d1ba);
$parcel$export(module.exports, "rightSidebarsLayout", () => $0836cf39cca1e468$export$820f9bb834280408);

var $2vSU6 = parcelRequire("2vSU6");

var $2BrOV = parcelRequire("2BrOV");

var $i90UH = parcelRequire("i90UH");

var $1Du13 = parcelRequire("1Du13");

var $aPfsS = parcelRequire("aPfsS");

var $ln7rs = parcelRequire("ln7rs");

var $b7Svb = parcelRequire("b7Svb");
// TODO Remove this whenever all service project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0836cf39cca1e468$var$withServiceProjectContext = (Component)=>(0, $aPfsS.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $2vSU6.SERVICE_DESK_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0836cf39cca1e468$var$ProjectBuilder = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("9RzoX")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/project-builder/ProjectBuilderWithQueryParam.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0836cf39cca1e468$var$Onboarding = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("j1Nx6")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0836cf39cca1e468$var$RightSidebars = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("juLka")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $0836cf39cca1e468$export$e321cb31c875d1ba = (0, $aPfsS.composeLayouts)((0, $1Du13.projectLayout), {
    globalComponents: [
        $0836cf39cca1e468$var$withServiceProjectContext($0836cf39cca1e468$var$Onboarding),
        ...(0, $ln7rs.serviceProjectFirstImpressionsLayout).globalComponents.map($0836cf39cca1e468$var$withServiceProjectContext),
        $0836cf39cca1e468$var$withServiceProjectContext((0, $i90UH.AsyncJsmCustomDomainChangeBoardingFlag)),
        $0836cf39cca1e468$var$ProjectBuilder
    ],
    rightSidebars: [
        $0836cf39cca1e468$var$withServiceProjectContext($0836cf39cca1e468$var$RightSidebars),
        ...(0, $ln7rs.serviceProjectFirstImpressionsLayout).rightSidebars.map($0836cf39cca1e468$var$withServiceProjectContext)
    ]
});
const $0836cf39cca1e468$export$820f9bb834280408 = (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), {
    rightSidebars: [
        $0836cf39cca1e468$var$RightSidebars
    ]
});

});
parcelRegister("i90UH", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmCustomDomainChangeBoardingFlag", () => $3ba5f01428db990d$export$b1ef5e3da6e1959d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3ba5f01428db990d$var$LazyJsmCustomDomainChangeBoardingFlag = (0, $b7Svb.lazy)(()=>(parcelRequire("66ybD")), {
    moduleId: "./src/packages/servicedesk/custom-domain-change-boarding/src/ui/index.tsx"
});
const $3ba5f01428db990d$export$b1ef5e3da6e1959d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-jsm-custom-domain-change-boarding-flag",
        packageName: "jira-help-center-custom-domain-change-boarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-custom-domain-change-boarding-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ba5f01428db990d$var$LazyJsmCustomDomainChangeBoardingFlag, null)));

});
parcelRegister("66ybD", function(module, exports) {

let $471dd26449881dff$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $471dd26449881dff$var$load("h2MrD"),
    $471dd26449881dff$var$load("bYT2S"),
    $471dd26449881dff$var$load("fgCot")
]).then(()=>parcelRequire('9d42Z'));

});


parcelRegister("1Du13", function(module, exports) {

$parcel$export(module.exports, "projectLayout", () => $08491b76212b7395$export$204149bac601d20c);

var $fpzhz = parcelRequire("fpzhz");

var $aPfsS = parcelRequire("aPfsS");

var $b7Svb = parcelRequire("b7Svb");

var $hMrxB = parcelRequire("hMrxB");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $08491b76212b7395$var$withAnyProjectContext = (Component)=>(0, $aPfsS.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: 'any'
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $08491b76212b7395$var$ProjectTrackers = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("bcZY0")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/project-layout/src/ui/trackers/index.tsx"
});
const $08491b76212b7395$var$ProjectFavicon = ()=>{
    (0, $hMrxB.useProjectFavicon)();
    return null;
};
const $08491b76212b7395$var$rightSidebars = ()=>[];
const $08491b76212b7395$var$globalComponents = [
    $08491b76212b7395$var$withAnyProjectContext($08491b76212b7395$var$ProjectFavicon),
    $08491b76212b7395$var$withAnyProjectContext($08491b76212b7395$var$ProjectTrackers),
    $08491b76212b7395$var$withAnyProjectContext((0, $fpzhz.ProjectRouteListener))
];
const $08491b76212b7395$export$204149bac601d20c = (0, $aPfsS.createLayout)({
    globalComponents: $08491b76212b7395$var$globalComponents,
    rightSidebars: $08491b76212b7395$var$rightSidebars()
});

});
parcelRegister("fpzhz", function(module, exports) {

$parcel$export(module.exports, "ProjectRouteListener", () => $a96b9050ddfb05f9$export$159f09d701320911);

var $5uXOq = parcelRequire("5uXOq");

var $dxCvy = parcelRequire("dxCvy");

var $itmJb = parcelRequire("itmJb");

var $2YP9W = parcelRequire("2YP9W");

var $hVf1M = parcelRequire("hVf1M");
const $a96b9050ddfb05f9$export$159f09d701320911 = ()=>{
    const isSiteAdmin = (0, $itmJb.useIsAdmin)();
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $dxCvy.projectContextResource));
    (0, $5uXOq.useEffect)(()=>{
        if (isSiteAdmin) (0, $hVf1M.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: true
        });
        else if (data != null) (0, $hVf1M.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: data.isProjectAdmin
        });
        else (0, $hVf1M.setIsProjectAdmin)({
            loading: loading,
            isProjectAdmin: null
        });
    }, [
        data,
        loading,
        isSiteAdmin
    ]);
    // Cleanup when component is unmounted. This means we are no longer in a project route
    (0, $5uXOq.useEffect)(()=>()=>(0, $hVf1M.setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: null
            }), []);
    return null;
};

});
parcelRegister("hVf1M", function(module, exports) {

$parcel$export(module.exports, "getIsProjectAdmin", () => $d8c128d9b214e073$export$34ff06260ad17f2b);
$parcel$export(module.exports, "setIsProjectAdmin", () => $d8c128d9b214e073$export$d53e6d79d3fa5f31);
let $d8c128d9b214e073$var$projectAdmin = null;
const $d8c128d9b214e073$export$34ff06260ad17f2b = ()=>{
    // Initialised as null, this likely means we aren't in a
    // project route and the listener hasn't been rendered
    if ($d8c128d9b214e073$var$projectAdmin == null || !$d8c128d9b214e073$var$projectAdmin.loading && $d8c128d9b214e073$var$projectAdmin.isProjectAdmin == null) return 'UNKNOWN';
    if ($d8c128d9b214e073$var$projectAdmin.loading === true) return 'LOADING';
    return Boolean($d8c128d9b214e073$var$projectAdmin.isProjectAdmin);
};
const $d8c128d9b214e073$export$d53e6d79d3fa5f31 = (projectAdminState)=>{
    $d8c128d9b214e073$var$projectAdmin = projectAdminState;
};

});


parcelRegister("hMrxB", function(module, exports) {

$parcel$export(module.exports, "useProjectFavicon", () => $6ee68e956a566e2d$export$32abcb1f939de016);

var $5uXOq = parcelRequire("5uXOq");

var $j8DrX = parcelRequire("j8DrX");

var $lpwtK = parcelRequire("lpwtK");
const $6ee68e956a566e2d$export$32abcb1f939de016 = false ? ()=>undefined : ()=>{
    const { data: project } = (0, $lpwtK.useProject)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const iconEle = document.querySelector("link[rel='shortcut icon']");
    // Keep a copy of the default favicon
    const defaultFavicon = (0, $5uXOq.useMemo)(()=>iconEle instanceof HTMLLinkElement ? iconEle.href : '', [
        iconEle
    ]);
    const enabled = (0, $5uXOq.useMemo)(()=>(0, $j8DrX.default)('ajs-favicon-use-projecticon') === 'true', []);
    (0, $5uXOq.useEffect)(()=>{
        const favicon = project ? project.avatarUrl : defaultFavicon;
        if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = favicon;
        // Switch back to default favicon
        return ()=>{
            if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = defaultFavicon;
        };
    }, [
        project,
        iconEle,
        defaultFavicon,
        enabled
    ]);
};

});

parcelRegister("bcZY0", function(module, exports) {

let $8290e2012e5cbb8e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8290e2012e5cbb8e$var$load("gw9ua").then(()=>parcelRequire('8DuT4'));

});


parcelRegister("ln7rs", function(module, exports) {

$parcel$export(module.exports, "serviceProjectFirstImpressionsLayout", () => $f6f2168537ade4c7$export$2562b2d784eadc10);

var $5uXOq = parcelRequire("5uXOq");

var $ctjgZ = parcelRequire("ctjgZ");

var $aPfsS = parcelRequire("aPfsS");

var $b7Svb = parcelRequire("b7Svb");
const $f6f2168537ade4c7$var$withServiceProjectAccess = (Component)=>{
    const ScopedComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctjgZ.default), {
            hasServiceDeskAccess: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, null));
    const name = (0, $aPfsS.coalesce)(Component.displayName) ?? (0, $aPfsS.coalesce)(Component.name) ?? 'Component';
    ScopedComponent.displayName = `withServiceProjectAccess(${name})`;
    return ScopedComponent;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f6f2168537ade4c7$var$Onboarding = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("bcw12")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f6f2168537ade4c7$var$RightSidebars = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("4Ua47")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $f6f2168537ade4c7$export$2562b2d784eadc10 = (0, $aPfsS.createLayout)({
    globalComponents: [
        $f6f2168537ade4c7$var$withServiceProjectAccess($f6f2168537ade4c7$var$Onboarding)
    ],
    rightSidebars: [
        $f6f2168537ade4c7$var$withServiceProjectAccess($f6f2168537ade4c7$var$RightSidebars)
    ]
});

});
parcelRegister("ctjgZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ead1b5a586c4cb4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");

var $1Yett = parcelRequire("1Yett");
/**
 * Manages the visibility of child components based on user permissions within a multi-tenant environment.
 * It leverages the application's permission settings to determine access rights, ensuring components are only accessible to users with the appropriate permissions.
 * In development environments, it issues a warning when no access-related properties are provided, aiding in debug and development processes.
 */ const $4ead1b5a586c4cb4$var$AppPermissionsCheck = (props)=>{
    const { appPermissions: appPermissions } = (0, $9OXo1.useTenantContext)();
    if (props.hasServiceDeskAccess !== undefined && appPermissions.hasServiceDeskAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    if (props.hasCoreAccess !== undefined && appPermissions.hasCoreAccess === props.hasCoreAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    if (props.hasSoftwareAccess !== undefined && appPermissions.hasSoftwareAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    if (props.hasServiceDeskAccess === undefined && props.hasCoreAccess === undefined && props.hasSoftwareAccess === undefined) {
        if ((0, $1Yett.isDevelopmentEnv)()) // eslint-disable-next-line no-console
        console.warn('AppPermissionsCheck should have defined at least one of access prop');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    }
    return null;
};
$4ead1b5a586c4cb4$var$AppPermissionsCheck.defaultProps = {
    hasCoreAccess: undefined,
    hasSoftwareAccess: undefined,
    hasServiceDeskAccess: undefined
};
var $4ead1b5a586c4cb4$export$2e2bcd8739ae039 = $4ead1b5a586c4cb4$var$AppPermissionsCheck;

});
parcelRegister("1Yett", function(module, exports) {

$parcel$export(module.exports, "isDevelopmentEnv", () => $7b47955f7b675219$export$48e5fb80244b95c5);
const $7b47955f7b675219$export$48e5fb80244b95c5 = ()=>false;

});


parcelRegister("bcw12", function(module, exports) {

let $8279a6597839e52b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8279a6597839e52b$var$load("eNmuD"),
    $8279a6597839e52b$var$load("cM9em"),
    $8279a6597839e52b$var$load("fr9NE"),
    $8279a6597839e52b$var$load("lBhEF")
]).then(()=>parcelRequire('fY1ne'));

});

parcelRegister("4Ua47", function(module, exports) {

let $39243332315a933e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $39243332315a933e$var$load("eNmuD"),
    $39243332315a933e$var$load("cM9em"),
    $39243332315a933e$var$load("fr9NE"),
    $39243332315a933e$var$load("aEk0C")
]).then(()=>parcelRequire('71Xxe'));

});


parcelRegister("9RzoX", function(module, exports) {

let $72e48650a0354baf$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $72e48650a0354baf$var$load("eNmuD"),
    $72e48650a0354baf$var$load("9gTl3")
]).then(()=>parcelRequire('ekO4Z'));

});

parcelRegister("j1Nx6", function(module, exports) {

let $dda48883d7c9acd3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dda48883d7c9acd3$var$load("eNmuD"),
    $dda48883d7c9acd3$var$load("h2MrD"),
    $dda48883d7c9acd3$var$load("bYT2S"),
    $dda48883d7c9acd3$var$load("cM9em"),
    $dda48883d7c9acd3$var$load("fr9NE"),
    $dda48883d7c9acd3$var$load("eZivQ")
]).then(()=>parcelRequire('dOvA3'));

});

parcelRegister("juLka", function(module, exports) {

let $e315874985d17ad6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e315874985d17ad6$var$load("eNmuD"),
    $e315874985d17ad6$var$load("h2MrD"),
    $e315874985d17ad6$var$load("bYT2S"),
    $e315874985d17ad6$var$load("cM9em"),
    $e315874985d17ad6$var$load("fr9NE"),
    $e315874985d17ad6$var$load("0xcBC")
]).then(()=>parcelRequire('islsJ'));

});


parcelRegister("gDHR4", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesPageEntryPoint", () => $64109391b810c516$export$e2fa7de87c15a81d);
$parcel$export(module.exports, "archivedIssuesWithoutHorizontalNavPageEntryPoint", () => $64109391b810c516$export$c001d316b1f89101);
$parcel$export(module.exports, "getCommonProjectLayout", () => $64109391b810c516$export$3dbe917a4c13b1e);

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $aPfsS = parcelRequire("aPfsS");

var $fo6b8 = parcelRequire("fo6b8");

var $lmyls = parcelRequire("lmyls");

var $1Qr8L = parcelRequire("1Qr8L");
const $64109391b810c516$export$e2fa7de87c15a81d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1Qr8L.archivedIssuesEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $64109391b810c516$export$c001d316b1f89101 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1Qr8L.archivedIssuesEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $64109391b810c516$export$3dbe917a4c13b1e = ()=>(0, $aPfsS.createLayout)((0, $gyYxw.genericProjectLayout));

});
parcelRegister("gyYxw", function(module, exports) {

$parcel$export(module.exports, "genericProjectLayout", () => $177735c975452188$export$85dad8e9886563f6);

var $18N1t = parcelRequire("18N1t");

var $aPfsS = parcelRequire("aPfsS");

var $6Z2mh = parcelRequire("6Z2mh");

var $e7bC3 = parcelRequire("e7bC3");

var $9Y3Lc = parcelRequire("9Y3Lc");
const $177735c975452188$export$85dad8e9886563f6 = (0, $aPfsS.composeLayouts)((0, $e7bC3.classicSoftwareProjectLayout), (0, $18N1t.coreProjectLayout), (0, $6Z2mh.serviceProjectLayout), (0, $e7bC3.softwareProjectLayout), (0, $9Y3Lc.userBoardLayout));

});
parcelRegister("18N1t", function(module, exports) {

$parcel$export(module.exports, "coreProjectLayout", () => $32b20434a17da609$export$3c06ced9943ca671);

var $1Du13 = parcelRequire("1Du13");

var $aPfsS = parcelRequire("aPfsS");
const $32b20434a17da609$export$3c06ced9943ca671 = (0, $aPfsS.composeLayouts)((0, $1Du13.projectLayout));

});

parcelRegister("e7bC3", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareProjectLayout", () => $43d4c7537a1fee65$export$3791efdd32024063);
$parcel$export(module.exports, "softwareProjectLayout", () => $43d4c7537a1fee65$export$9a918616afa3328c);
$parcel$export(module.exports, "softwareProjectLayoutNoOnboarding", () => $43d4c7537a1fee65$export$ada52b1309832862);
$parcel$export(module.exports, "classicSoftwareProjectLayoutNoOnboarding", () => $43d4c7537a1fee65$export$6c1958653c44ba37);
$parcel$export(module.exports, "softwareProjectLayoutCode", () => $43d4c7537a1fee65$export$ab7e607e8441dc61);

var $2vSU6 = parcelRequire("2vSU6");

var $1Du13 = parcelRequire("1Du13");

var $aPfsS = parcelRequire("aPfsS");

var $b7Svb = parcelRequire("b7Svb");
// TODO Remove this whenever all software project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $43d4c7537a1fee65$var$withAnySoftwareProjectContext = (Component)=>(0, $aPfsS.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $2vSU6.SOFTWARE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$Onboarding = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("4vukc")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$OnboardingCode = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("cEw9d")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding-code/OnboardingCode.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$RightSidebars = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("3GTpa")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$RightSidebarsCode = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("a8L0B")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars-code/RightSidebarsCode.tsx"
});
const $43d4c7537a1fee65$var$SoftWareOnboarding = $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$Onboarding);
const $43d4c7537a1fee65$var$SoftWareOnboardingCode = $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$OnboardingCode);
const $43d4c7537a1fee65$var$nonSettingsRightSidebars = [
    $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$RightSidebars)
];
const $43d4c7537a1fee65$var$nonSettingsRightSidebarsCode = [
    $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$RightSidebarsCode)
];
const $43d4c7537a1fee65$var$sharedSoftwareProjectLayout = (0, $aPfsS.composeLayouts)((0, $1Du13.projectLayout), {});
const $43d4c7537a1fee65$export$3791efdd32024063 = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
    rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebars,
    globalComponents: [
        $43d4c7537a1fee65$var$SoftWareOnboarding
    ]
});
const $43d4c7537a1fee65$export$9a918616afa3328c = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
    rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebars,
    globalComponents: [
        $43d4c7537a1fee65$var$SoftWareOnboarding
    ]
});
const $43d4c7537a1fee65$export$ada52b1309832862 = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout);
const $43d4c7537a1fee65$export$6c1958653c44ba37 = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout);
const $43d4c7537a1fee65$export$ab7e607e8441dc61 = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
    rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebarsCode,
    globalComponents: [
        $43d4c7537a1fee65$var$SoftWareOnboardingCode
    ]
});

});
parcelRegister("4vukc", function(module, exports) {

let $3481949173c775d8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3481949173c775d8$var$load("eNmuD"),
    $3481949173c775d8$var$load("h2MrD"),
    $3481949173c775d8$var$load("bYT2S"),
    $3481949173c775d8$var$load("cM9em"),
    $3481949173c775d8$var$load("fr9NE"),
    $3481949173c775d8$var$load("5zn1B")
]).then(()=>parcelRequire('67mQl'));

});

parcelRegister("cEw9d", function(module, exports) {

let $93622855a419f8d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $93622855a419f8d0$var$load("eNmuD"),
    $93622855a419f8d0$var$load("h2MrD"),
    $93622855a419f8d0$var$load("bYT2S"),
    $93622855a419f8d0$var$load("cM9em"),
    $93622855a419f8d0$var$load("fr9NE"),
    $93622855a419f8d0$var$load("3aL8T")
]).then(()=>parcelRequire('g03yq'));

});

parcelRegister("3GTpa", function(module, exports) {

let $2b004597c191b0c9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2b004597c191b0c9$var$load("eNmuD"),
    $2b004597c191b0c9$var$load("h2MrD"),
    $2b004597c191b0c9$var$load("bYT2S"),
    $2b004597c191b0c9$var$load("cM9em"),
    $2b004597c191b0c9$var$load("fr9NE"),
    $2b004597c191b0c9$var$load("9w7x8")
]).then(()=>parcelRequire('jorgl'));

});

parcelRegister("a8L0B", function(module, exports) {

let $761f1db04694acdd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $761f1db04694acdd$var$load("eNmuD"),
    $761f1db04694acdd$var$load("h2MrD"),
    $761f1db04694acdd$var$load("bYT2S"),
    $761f1db04694acdd$var$load("cM9em"),
    $761f1db04694acdd$var$load("fr9NE"),
    $761f1db04694acdd$var$load("4mQEr")
]).then(()=>parcelRequire('egnL1'));

});


parcelRegister("9Y3Lc", function(module, exports) {

$parcel$export(module.exports, "userBoardLayout", () => $1760a1663e36faa5$export$7092b4ee86ae0b71);

var $aPfsS = parcelRequire("aPfsS");
const $1760a1663e36faa5$export$7092b4ee86ae0b71 = (0, $aPfsS.createLayout)();

});


parcelRegister("fo6b8", function(module, exports) {

$parcel$export(module.exports, "jiraHorizontalNavEntrypoint", () => $a30042c3f693dfff$export$e9ee9fa1097f370e);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $LjVkh = parcelRequire("LjVkh");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $j5YhT = parcelRequire("j5YhT");

var $1nb22 = parcelRequire("1nb22");

var $ktofH = parcelRequire("ktofH");

const $a30042c3f693dfff$export$e9ee9fa1097f370e = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("dDJOG")), {
        moduleId: "99477251",
        moduleName: "HorizontalNavJiraInner"
    }),
    getPreloadProps: ({ context: { match: match, query: query }, tenantContext: { cloudId: cloudId } })=>{
        const boardId = match.params.boardId;
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const projectIdOrKey = projectId || projectKey;
        const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
        const boardAri = boardId ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '';
        const projectAri = projectId ? (0, $j5YhT.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString() : '';
        let containerNavigationInput;
        if (isTMPBoardRoute) containerNavigationInput = projectAri ? {
            scopeId: boardAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        else containerNavigationInput = boardAri || projectAri ? {
            scopeId: boardAri || projectAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                horizontalNavQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $LjVkh.default,
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        withProject: Boolean(projectIdOrKey),
                        boardId: boardAri,
                        withBoard: Boolean(boardAri),
                        containerNavigationInput: containerNavigationInput,
                        isTMPBoardRoute: isTMPBoardRoute,
                        first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE)
                    }
                }
            }
        };
    }
});

});
parcelRegister("LjVkh", function(module, exports) {

$parcel$export(module.exports, "default", () => $153fec52554cdddf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<316338130c9c3fbda0a8b0dc00d5ed92>>
 * @relayHash 5aecbf8ced643dda0fbf2090719a11fd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 39760e4b78a60f61d7048792cfa7feb88268d21339076646ce2f06ff23b00cb9

var $58v9Y = parcelRequire("58v9Y");

var $9pmwJ = parcelRequire("9pmwJ");
const $153fec52554cdddf$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "39760e4b78a60f61d7048792cfa7feb88268d21339076646ce2f06ff23b00cb9",
        "metadata": {},
        "name": "HorizontalNavJiraInnerQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $58v9Y.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": (0, $9pmwJ.default)
        }
    }
};
var $153fec52554cdddf$export$2e2bcd8739ae039 = $153fec52554cdddf$var$node;

});
parcelRegister("58v9Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a08f169582fc62e$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $2a08f169582fc62e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jira_custom_templates_ux');
    }
};

});

parcelRegister("9pmwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $979d1b4861d86eeb$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $979d1b4861d86eeb$var$JiraTeamButtonRelayProvider = {
    get () {
        return (0, $4R6GH.fg)('team-connection-visibility-in-jira');
    }
};
var $979d1b4861d86eeb$export$2e2bcd8739ae039 = $979d1b4861d86eeb$var$JiraTeamButtonRelayProvider;

});


parcelRegister("dDJOG", function(module, exports) {

let $9ee27513b8256f26$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9ee27513b8256f26$var$load("hPzOn"),
    $9ee27513b8256f26$var$load("eNmuD"),
    $9ee27513b8256f26$var$load("cM9em"),
    $9ee27513b8256f26$var$load("fr9NE"),
    $9ee27513b8256f26$var$load("h2MrD"),
    $9ee27513b8256f26$var$load("bYT2S"),
    $9ee27513b8256f26$var$load("luVbU")
]).then(()=>parcelRequire('l7ScM'));

});


parcelRegister("1Qr8L", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesEntrypoint", () => $c1768d5987ec2034$export$3f35189530920ce3);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $c1768d5987ec2034$export$3f35189530920ce3 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("iaSYV")), {
        moduleId: "c61780dd"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iaSYV", function(module, exports) {

let $d3b3cf65082ae8ee$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d3b3cf65082ae8ee$var$load("2y2gh").then(()=>parcelRequire('f45ZV'));

});




parcelRegister("9HXcc", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesJswCompanyRouteEntry", () => $8d888d2aca144cd1$export$26f89b9d922d1bea);

var $5f2bR = parcelRequire("5f2bR");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $hR9i4 = parcelRequire("hR9i4");

var $gDHR4 = parcelRequire("gDHR4");
const $8d888d2aca144cd1$export$26f89b9d922d1bea = (0, $7NszV.createEntry)((0, $hR9i4.archivedIssuesJswCompanyRoute), ()=>({
        group: 'archive-issues',
        // Refer: issueNavigatorProjectClassicRoute from issue-navigator
        layout: (0, $gDHR4.getCommonProjectLayout)(),
        entryPoint: ()=>(0, $gDHR4.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ]
    }));

});
parcelRegister("5f2bR", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalNavJira", () => $8a898ce31719feb2$export$ea83697d960a1a23);

var $5uXOq = parcelRequire("5uXOq");

var $b7Svb = parcelRequire("b7Svb");

var $3HwlS = parcelRequire("3HwlS");

var $7XYc4 = parcelRequire("7XYc4");

var $5NiYd = parcelRequire("5NiYd");

var $l71WK = parcelRequire("l71WK");

var $lfTZh = parcelRequire("lfTZh");

const $8a898ce31719feb2$var$LazyHorizontalNavJira = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("gQ387")).then((HorizontalNavJira)=>HorizontalNavJira), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jira/src/ui/HorizontalNavJira.tsx"
});
const $8a898ce31719feb2$var$AsyncHorizontalNav = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-nav-jira",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5NiYd.HorizontalNavSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8a898ce31719feb2$var$LazyHorizontalNavJira, null));
const $8a898ce31719feb2$export$ea83697d960a1a23 = (0, $7XYc4.componentWithCondition)(()=>(0, $3HwlS.getWillShowNav4)(), $8a898ce31719feb2$var$AsyncHorizontalNav, (0, $l71WK.AsyncHorizontalProjectNav));

});
parcelRegister("5NiYd", function(module, exports) {

$parcel$export(module.exports, "HorizontalNavSkeleton", () => $0a3d218ca404c936$export$e29d51df5420bf39);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $2Eqc8 = parcelRequire("2Eqc8");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");

var $4R6GH = parcelRequire("4R6GH");
const $0a3d218ca404c936$export$807fef2beb9debc2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        xcss: [
            $0a3d218ca404c936$var$tabsWrapperSkeletonStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $0a3d218ca404c936$var$tabSkeletonStyles
    }));
const $0a3d218ca404c936$export$e29d51df5420bf39 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.050",
        alignBlock: "end",
        xcss: [
            $0a3d218ca404c936$var$horizontalNavWrapperStyles,
            (0, $4R6GH.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') && $0a3d218ca404c936$var$horizontalNavWrapperStylesNew
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            $0a3d218ca404c936$var$baseSkeletonStyles,
            $0a3d218ca404c936$var$breadcrumbStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        spread: "space-between",
        xcss: $0a3d218ca404c936$var$headerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $0a3d218ca404c936$var$primaryContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            $0a3d218ca404c936$var$baseSkeletonStyles,
            $0a3d218ca404c936$var$squareStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            $0a3d218ca404c936$var$baseSkeletonStyles,
            $0a3d218ca404c936$var$projectTitleStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            $0a3d218ca404c936$var$baseSkeletonStyles,
            $0a3d218ca404c936$var$squareStyles
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        space: "space.150",
        xcss: $0a3d218ca404c936$var$actionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            $0a3d218ca404c936$var$baseSkeletonStyles,
            $0a3d218ca404c936$var$squareStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            $0a3d218ca404c936$var$baseSkeletonStyles,
            $0a3d218ca404c936$var$squareStyles
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a3d218ca404c936$export$807fef2beb9debc2, null));
const $0a3d218ca404c936$var$tabsWrapperSkeletonStyles = (0, $2s57o.xcss)({
    gap: 'space.150',
    height: '32px',
    paddingInlineStart: 'space.300',
    paddingInlineEnd: 'space.300',
    paddingBlockEnd: 'space.150',
    marginBlockStart: 'space.100',
    position: 'relative',
    '::after': {
        content: '""',
        position: 'absolute',
        bottom: '0',
        backgroundColor: 'color.skeleton',
        height: '2px',
        left: '0',
        right: '0'
    }
});
const $0a3d218ca404c936$var$tabSkeletonStyles = (0, $2s57o.xcss)({
    minWidth: "var(--ds-space-1000, 80px)",
    backgroundColor: 'color.skeleton',
    borderRadius: "var(--ds-border-radius, 4px)"
});
const $0a3d218ca404c936$var$horizontalNavWrapperStyles = (0, $2s57o.xcss)({
    paddingTop: 'space.300',
    minBlockSize: '122px'
});
// merge to main styling and remove it when cleaning blu-6305_tab_item_styling_in_horizontal_navigation
const $0a3d218ca404c936$var$horizontalNavWrapperStylesNew = (0, $2s57o.xcss)({
    minBlockSize: '130px'
});
const $0a3d218ca404c936$var$baseSkeletonStyles = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius'
});
const $0a3d218ca404c936$var$breadcrumbStyles = (0, $2s57o.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: '60px',
    marginInlineStart: 'space.300',
    marginBlockEnd: 'space.025'
});
const $0a3d218ca404c936$var$primaryContainerStyles = (0, $2s57o.xcss)({
    display: 'flex',
    gap: 'space.100',
    marginInlineStart: 'space.300'
});
const $0a3d218ca404c936$var$squareStyles = (0, $2s57o.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: "var(--ds-space-300, 24px)"
});
const $0a3d218ca404c936$var$headerWrapperStyles = (0, $2s57o.xcss)({
    marginBlockStart: 'space.050'
});
const $0a3d218ca404c936$var$projectTitleStyles = (0, $2s57o.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: '180px'
});
const $0a3d218ca404c936$var$actionStyles = (0, $2s57o.xcss)({
    marginInlineEnd: 'space.300'
});

});

parcelRegister("l71WK", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalProjectNav", () => $7e6dac351b79a914$export$862dd1c0126bb181);
$parcel$export(module.exports, "AsyncHorizontalOverviewNav", () => $7e6dac351b79a914$export$beabdf5c49f01377);
/* eslint-disable jira/import/webpack-magic-comment-entries */ 
var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $7e6dac351b79a914$var$LazyHorizontalProjectNav = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("cX2JU")), {
    moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/project-navigation/index.tsx"
});
const $7e6dac351b79a914$export$862dd1c0126bb181 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-project-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e6dac351b79a914$var$LazyHorizontalProjectNav, null));

const $7e6dac351b79a914$var$LazyHorizontalOverviewNav = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("bX9Za")), {
    moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/overview-navigation/index.tsx"
});
const $7e6dac351b79a914$export$beabdf5c49f01377 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-overview-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e6dac351b79a914$var$LazyHorizontalOverviewNav, null));

});
parcelRegister("cX2JU", function(module, exports) {

let $96dd1ebb71ff5b61$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $96dd1ebb71ff5b61$var$load("kfXhT"),
    $96dd1ebb71ff5b61$var$load("2Lfdl"),
    $96dd1ebb71ff5b61$var$load("hPzOn"),
    $96dd1ebb71ff5b61$var$load("eNmuD"),
    $96dd1ebb71ff5b61$var$load("h2MrD"),
    $96dd1ebb71ff5b61$var$load("bYT2S"),
    $96dd1ebb71ff5b61$var$load("cM9em"),
    $96dd1ebb71ff5b61$var$load("fr9NE"),
    $96dd1ebb71ff5b61$var$load("4RRJO")
]).then(()=>parcelRequire('bwmXM'));

});

parcelRegister("bX9Za", function(module, exports) {

let $8b3cf351ee9dffe0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8b3cf351ee9dffe0$var$load("h2MrD"),
    $8b3cf351ee9dffe0$var$load("bYT2S"),
    $8b3cf351ee9dffe0$var$load("hPzOn"),
    $8b3cf351ee9dffe0$var$load("eNmuD"),
    $8b3cf351ee9dffe0$var$load("cM9em"),
    $8b3cf351ee9dffe0$var$load("fr9NE"),
    $8b3cf351ee9dffe0$var$load("hTo1l")
]).then(()=>parcelRequire('bNzBR'));

});


parcelRegister("gQ387", function(module, exports) {

let $c423ee3cd4a1308d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c423ee3cd4a1308d$var$load("hPzOn"),
    $c423ee3cd4a1308d$var$load("eNmuD"),
    $c423ee3cd4a1308d$var$load("cM9em"),
    $c423ee3cd4a1308d$var$load("fr9NE"),
    $c423ee3cd4a1308d$var$load("h2MrD"),
    $c423ee3cd4a1308d$var$load("bYT2S"),
    $c423ee3cd4a1308d$var$load("2Ed9h")
]).then(()=>parcelRequire('5zGmz'));

});


parcelRegister("9s3j1", function(module, exports) {

$parcel$export(module.exports, "ForPaintClassicSoftwareProjectSidebar", () => $ed71aad279526f75$export$a70fda37b3fc5365);
$parcel$export(module.exports, "default", () => $ed71aad279526f75$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

var $lODMY = parcelRequire("lODMY");

const $ed71aad279526f75$var$LazyAfterPaintClassicSoftwareProjectSidebar = (0, $b7Svb.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("hFY22")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
});

const $ed71aad279526f75$var$LazyForPaintClassicSoftwareProjectSidebar = (0, $b7Svb.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("hFY22")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ed71aad279526f75$var$AfterPaintClassicSoftwareProjectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "classicSoftwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed71aad279526f75$var$LazyAfterPaintClassicSoftwareProjectSidebar, null)));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ed71aad279526f75$export$a70fda37b3fc5365 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "classicSoftwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed71aad279526f75$var$LazyForPaintClassicSoftwareProjectSidebar, null)));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ed71aad279526f75$var$ClassicSoftwareProjectSidebarLazyForPaintIssueRouteOnly = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const isIssueRoute = (0, $lODMY.useIsActiveRoute)('issue');
    return isIssueRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed71aad279526f75$export$a70fda37b3fc5365, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed71aad279526f75$var$AfterPaintClassicSoftwareProjectSidebar, null);
});
const $ed71aad279526f75$var$ClassicSoftwareProjectSidebar = (0, $cSD7y.componentWithFG)('nav_sidebar_software_classic_lazyforpaint', $ed71aad279526f75$var$ClassicSoftwareProjectSidebarLazyForPaintIssueRouteOnly, $ed71aad279526f75$var$AfterPaintClassicSoftwareProjectSidebar);
$ed71aad279526f75$var$ClassicSoftwareProjectSidebar.displayName = 'ClassicSoftwareProjectSidebar';
$ed71aad279526f75$export$a70fda37b3fc5365.displayName = 'ClassicSoftwareProjectSidebar';
var $ed71aad279526f75$export$2e2bcd8739ae039 = $ed71aad279526f75$var$ClassicSoftwareProjectSidebar;

});
parcelRegister("hFY22", function(module, exports) {

let $cde4d51540c0ea10$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cde4d51540c0ea10$var$load("kfXhT"),
    $cde4d51540c0ea10$var$load("2Lfdl"),
    $cde4d51540c0ea10$var$load("hPzOn"),
    $cde4d51540c0ea10$var$load("eNmuD"),
    $cde4d51540c0ea10$var$load("h2MrD"),
    $cde4d51540c0ea10$var$load("bYT2S"),
    $cde4d51540c0ea10$var$load("cM9em"),
    $cde4d51540c0ea10$var$load("fr9NE"),
    $cde4d51540c0ea10$var$load("hXBFn")
]).then(()=>parcelRequire('dydBa'));

});


parcelRegister("hR9i4", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesJswCompanyRoute", () => $df1ff4159dc216e6$export$cd10ef5fdf01245b);
const $df1ff4159dc216e6$export$cd10ef5fdf01245b = {
    name: 'archived-issues-directory',
    path: '/jira/software/c/projects/:projectKey/issues/archive',
    exact: true
};

});


parcelRegister("jq5xL", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesJswRouteEntry", () => $0bcebe438fd2464d$export$39e83fab54222094);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $dBI73 = parcelRequire("dBI73");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $gDHR4 = parcelRequire("gDHR4");
const $0bcebe438fd2464d$export$39e83fab54222094 = (0, $7NszV.createEntry)((0, $dBI73.archivedIssuesJswRoute), ()=>({
        group: 'archive-issues',
        // Refer: issueNavigatorProjectSoftwareRoute from issue-navigator
        layout: (0, $aPfsS.createLayout)((0, $e7bC3.softwareProjectLayoutNoOnboarding)),
        entryPoint: ()=>(0, $gDHR4.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ]
    }));

});
parcelRegister("koWFd", function(module, exports) {

$parcel$export(module.exports, "ForPaintSoftwareProjectSidebar", () => $73e9a7a50d60fc40$export$16261c6a2217f29d);
$parcel$export(module.exports, "default", () => $73e9a7a50d60fc40$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

var $lODMY = parcelRequire("lODMY");

const $73e9a7a50d60fc40$var$LazyAfterPaintClassicSoftwareProjectSidebar = (0, $b7Svb.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("ikt6r")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
});

const $73e9a7a50d60fc40$var$LazyForPaintClassicSoftwareProjectSidebar = (0, $b7Svb.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("ikt6r")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $73e9a7a50d60fc40$var$AfterPaintSoftwareProjectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "softwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73e9a7a50d60fc40$var$LazyAfterPaintClassicSoftwareProjectSidebar, null)));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $73e9a7a50d60fc40$export$16261c6a2217f29d = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "softwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73e9a7a50d60fc40$var$LazyForPaintClassicSoftwareProjectSidebar, null)));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $73e9a7a50d60fc40$var$SoftwareProjectSidebarLazyForPaintIssueRouteOnly = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const isIssueRoute = (0, $lODMY.useIsActiveRoute)('issue');
    return isIssueRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73e9a7a50d60fc40$export$16261c6a2217f29d, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73e9a7a50d60fc40$var$AfterPaintSoftwareProjectSidebar, null);
});
const $73e9a7a50d60fc40$var$SoftwareProjectSidebar = (0, $cSD7y.componentWithFG)('nav_sidebar_software_classic_lazyforpaint', $73e9a7a50d60fc40$var$SoftwareProjectSidebarLazyForPaintIssueRouteOnly, $73e9a7a50d60fc40$var$AfterPaintSoftwareProjectSidebar);
$73e9a7a50d60fc40$var$SoftwareProjectSidebar.displayName = 'SoftwareProjectSidebar';
$73e9a7a50d60fc40$export$16261c6a2217f29d.displayName = 'SoftwareProjectSidebar';
var $73e9a7a50d60fc40$export$2e2bcd8739ae039 = $73e9a7a50d60fc40$var$SoftwareProjectSidebar;

});
parcelRegister("ikt6r", function(module, exports) {

let $d580ab8080ffbf4c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d580ab8080ffbf4c$var$load("kfXhT"),
    $d580ab8080ffbf4c$var$load("2Lfdl"),
    $d580ab8080ffbf4c$var$load("eNmuD"),
    $d580ab8080ffbf4c$var$load("h2MrD"),
    $d580ab8080ffbf4c$var$load("bYT2S"),
    $d580ab8080ffbf4c$var$load("cM9em"),
    $d580ab8080ffbf4c$var$load("fr9NE"),
    $d580ab8080ffbf4c$var$load("4OI1j")
]).then(()=>parcelRequire('4WgKv'));

});


parcelRegister("dBI73", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesJswRoute", () => $ff62ef27527a44d2$export$15745ddd07707d60);
const $ff62ef27527a44d2$export$15745ddd07707d60 = {
    name: 'archived-issues-directory',
    path: '/jira/software/projects/:projectKey/issues/archive',
    exact: true
};

});


parcelRegister("4r3FF", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesJwmRouteEntry", () => $66bc19155bc886e3$export$cccc8c9dd9619d7f);

var $5f2bR = parcelRequire("5f2bR");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $iBU4N = parcelRequire("iBU4N");

var $gDHR4 = parcelRequire("gDHR4");
const $66bc19155bc886e3$export$cccc8c9dd9619d7f = (0, $7NszV.createEntry)((0, $iBU4N.archivedIssuesJwmRoute), ()=>({
        group: 'archive-issues',
        // Refer: issueNavigatorProjectBusinessRoute from issue-navigator
        layout: (0, $gDHR4.getCommonProjectLayout)(),
        entryPoint: ()=>(0, $gDHR4.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $lNicp.getBusinessProjectResources)()
        ]
    }));

});
parcelRegister("dmKXV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac63d95d52d9688b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

const $ac63d95d52d9688b$var$LazyCoreProjectSidebar = (0, $b7Svb.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("8JDm8")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/business/navigation/sidebar/src/ui/index.tsx"
});
// delete when cleaning up getWillShowNav4
const $ac63d95d52d9688b$var$CoreProjectSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "coreProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac63d95d52d9688b$var$LazyCoreProjectSidebar, null));
var $ac63d95d52d9688b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($ac63d95d52d9688b$var$CoreProjectSidebar);

});
parcelRegister("8JDm8", function(module, exports) {

let $65c10dffcba294a5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $65c10dffcba294a5$var$load("eNmuD"),
    $65c10dffcba294a5$var$load("h2MrD"),
    $65c10dffcba294a5$var$load("bYT2S"),
    $65c10dffcba294a5$var$load("cM9em"),
    $65c10dffcba294a5$var$load("fr9NE"),
    $65c10dffcba294a5$var$load("bpTJC")
]).then(()=>parcelRequire('8rIQt'));

});


parcelRegister("lNicp", function(module, exports) {

$parcel$export(module.exports, "getBusinessProjectResources", () => $492115de1a4c9f28$export$20e8c2951e444b08);
$parcel$export(module.exports, "getProjectViewResources", () => $492115de1a4c9f28$export$fcbe882e18ee4a35);
$parcel$export(module.exports, "getOverviewViewResources", () => $492115de1a4c9f28$export$21c5527b459d56fe);

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $g4ZHz = parcelRequire("g4ZHz");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $1E3vT = parcelRequire("1E3vT");

var $iNzEe = parcelRequire("iNzEe");

var $jrO9m = parcelRequire("jrO9m");

var $gNStA = parcelRequire("gNStA");

var $l2N2a = parcelRequire("l2N2a");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $cSUZZ = parcelRequire("cSUZZ");

var $aFVvc = parcelRequire("aFVvc");

var $9V5k0 = parcelRequire("9V5k0");
const $492115de1a4c9f28$export$20e8c2951e444b08 = ()=>(0, $3HwlS.getWillShowNav4)() ? [
        // eslint-disable-next-line camelcase
        (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jira_theming_relay_migration'), (0, $9V5k0.projectThemeResource))
    ] : [
        (0, $aFVvc.projectCreatePermissionsResource),
        (0, $iNzEe.navigationResource),
        // eslint-disable-next-line camelcase
        (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $1E3vT.businessHorizontalNav3Resource),
        (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jira_theming_relay_migration'), (0, $9V5k0.projectThemeResource))
    ];
const $492115de1a4c9f28$export$fcbe882e18ee4a35 = ()=>[
        ...$492115de1a4c9f28$export$20e8c2951e444b08(),
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        (0, $g4ZHz.fieldsResource)
    ];
const $492115de1a4c9f28$export$46471673e66df5c1 = ()=>[
        (0, $aFVvc.projectCreatePermissionsResource),
        (0, $iNzEe.navigationResource),
        (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
        (0, $jrO9m.overviewDetailsResource)
    ];
const $492115de1a4c9f28$export$21c5527b459d56fe = ()=>[
        ...$492115de1a4c9f28$export$46471673e66df5c1(),
        ...(0, $3RJkv.getNavigationResources)(),
        (0, $g4ZHz.fieldsResource)
    ];

});
parcelRegister("g4ZHz", function(module, exports) {

$parcel$export(module.exports, "fieldsResource", () => $410efef54f79d33f$export$8bca6c1954ae9308);
$parcel$export(module.exports, "useFieldsResource", () => $410efef54f79d33f$export$c0cd85886917fe89);

var $7q3cr = parcelRequire("7q3cr");

var $jlq4V = parcelRequire("jlq4V");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $ljySl = parcelRequire("ljySl");

var $kig09 = parcelRequire("kig09");
const $410efef54f79d33f$var$RESOURCE_TYPE_KEY = 'BUSINESS_FIELDS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $410efef54f79d33f$var$handleProjectResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jqlBuilder?.fields?.edges == null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
    return (0, $kig09.transformData)(response.data?.jira?.jqlBuilder?.fields?.edges);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $410efef54f79d33f$var$handleOverviewResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jwmOverview?.fields?.edges == null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
    return (0, $kig09.transformData)(response.data?.jira?.jwmOverview?.fields?.edges);
};
const $410efef54f79d33f$export$8bca6c1954ae9308 = (0, $2M1hQ.createResource)({
    type: $410efef54f79d33f$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        if (matchedRoute.match.params.overviewId) return `${$410efef54f79d33f$var$RESOURCE_TYPE_KEY}_overview_${matchedRoute.match.params.overviewId}`;
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$410efef54f79d33f$var$RESOURCE_TYPE_KEY}_project_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        if (match.params.overviewId) return (0, $ljySl.fetchFields)((0, $8441414a9e015afb$export$c378ca4a0e2c9fec), $410efef54f79d33f$var$handleOverviewResponse, {
            overviewAri: (0, $7q3cr.JiraProjectOverviewAri).create({
                siteId: cloudId,
                activationId: activationId,
                overviewId: match.params.overviewId
            }).toString()
        });
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        return (0, $ljySl.fetchFields)((0, $8441414a9e015afb$export$4d41378da3f70f0f), $410efef54f79d33f$var$handleProjectResponse, {
            cloudId: cloudId,
            jqlContext: `project = '${projectIdOrKey}'`
        });
    },
    maxAge: 3600000
});
const $410efef54f79d33f$export$c0cd85886917fe89 = ()=>(0, $2YP9W.useResource)($410efef54f79d33f$export$8bca6c1954ae9308);

});
parcelRegister("7q3cr", function(module, exports) {

$parcel$export(module.exports, "JiraProjectOverviewAri", () => $566d717b3b39d3ba$export$714879003922a622);

var $gPEvR = parcelRequire("gPEvR");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/project-overview/manifest.ts
var $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $gPEvR.JiraProjectOverviewAriResourceOwner),
    resourceType: (0, $gPEvR.JiraProjectOverviewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{overviewId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        overviewId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/jira/project-overview/index.ts
var $566d717b3b39d3ba$export$714879003922a622 = class _JiraProjectOverviewAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._overviewId = opts.resourceIdSegmentValues.overviewId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get overviewId() {
        return this._overviewId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts.qualifier,
            platformQualifier: $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts.resourceOwner,
            resourceType: $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.overviewId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                overviewId: opts.overviewId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts);
        return new _JiraProjectOverviewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $566d717b3b39d3ba$var$jiraProjectOverviewAriStaticOpts);
        return new _JiraProjectOverviewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            overviewId: this.overviewId
        };
    }
};

});
parcelRegister("gPEvR", function(module, exports) {

$parcel$export(module.exports, "JiraProjectOverviewAriResourceOwner", () => $c410d5ca87dd2023$export$d68ef32d028cea3e);
$parcel$export(module.exports, "JiraProjectOverviewAriResourceType", () => $c410d5ca87dd2023$export$491d1b3b0151dbc4);
// src/jira/project-overview/types.ts
var $c410d5ca87dd2023$export$d68ef32d028cea3e = "jira", $c410d5ca87dd2023$export$491d1b3b0151dbc4 = "project-overview";

});


parcelRegister("jlq4V", function(module, exports) {

$parcel$export(module.exports, "GraphQLErrors", () => $503bc83696833cc0$export$89c202e66b2de2b6);

var $7hpBk = parcelRequire("7hpBk");

var $8LQ84 = parcelRequire("8LQ84");
// Sets the error message on this error according to the
// the GraphQL errors that are present.
const $503bc83696833cc0$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8LQ84)))(err.graphQLErrors) && err.graphQLErrors.length > 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `${errorMessage}\n`;
    });
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $503bc83696833cc0$export$89c202e66b2de2b6 extends Error {
    constructor(graphQLErrors){
        super();
        this.graphQLErrors = graphQLErrors != null ? (0, (/*@__PURE__*/$parcel$interopDefault($7hpBk)))(graphQLErrors) : [];
        this.message = $503bc83696833cc0$var$generateErrorMessage(this);
        this.cause = this.graphQLErrors?.[0];
        this.statusCode = this.cause?.extensions?.statusCode ?? this.cause?.extensions?.[0]?.statusCode ?? -1;
        this.errorType = this.cause?.extensions?.errorType ?? this.cause?.extensions?.[0]?.errorType ?? null;
    }
}

});
parcelRegister("7hpBk", function(module, exports) {

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */ function $54cdfac2bc83c2a9$var$castArray() {
    if (!arguments.length) return [];
    var value = arguments[0];
    return $8LQ84(value) ? value : [
        value
    ];
}
module.exports = $54cdfac2bc83c2a9$var$castArray;

});


const $8441414a9e015afb$export$4d41378da3f70f0f = `
query JWMProjectFields($cloudId: ID!, $jqlContext: String!, $first: Int) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
      fields (jqlContext: $jqlContext, forClause: WHERE, viewContext: JWM, first: $first) {
        ... on JiraJqlFieldConnection {
          edges {
            node {
              jqlTerm
              type
              displayName,
            }
          }
        }
      }
    }
  }
}`;
const $8441414a9e015afb$export$c378ca4a0e2c9fec = `
query JWMOverviewFields($overviewAri: ID!, $first: Int) {
  jira {
    jwmOverview(id: $overviewAri) {
      ... on JiraWorkManagementGiraOverview {
        fields (first: $first) {
          ... on JiraJqlFieldConnection {
            edges {
              node {
                jqlTerm
                type
                displayName,
              }
            }
          }
        }
      }
    }
  }
}`;

parcelRegister("ljySl", function(module, exports) {

$parcel$export(module.exports, "fetchFields", () => $90e7c5e5920e8507$export$f3ddd735c360919);

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $90e7c5e5920e8507$var$PAGE_SIZE = 100;
const $90e7c5e5920e8507$export$f3ddd735c360919 = async (query, handler, params)=>{
    try {
        const promise = (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: $90e7c5e5920e8507$var$PAGE_SIZE,
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return await handler(promise);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessFields', 'Something went wrong while fetching fields');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $jcw0u.default)({
            meta: {
                id: 'fieldsResource',
                packageName: 'jiraRouterResourcesBusinessFields',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};

});

parcelRegister("kig09", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $3d209f684c72dca4$export$3ceb62baab058c6b);
const $3d209f684c72dca4$export$3ceb62baab058c6b = (data)=>data.map((edge)=>edge.node);

});


parcelRegister("1E3vT", function(module, exports) {

$parcel$export(module.exports, "businessHorizontalNav3Resource", () => $4f364072ed560b43$export$b3359003584ee2b0);

var $j5YhT = parcelRequire("j5YhT");

var $dJl1T = parcelRequire("dJl1T");

var $4R6GH = parcelRequire("4R6GH");

var $6YG83 = parcelRequire("6YG83");

var $ktofH = parcelRequire("ktofH");

var $ao2h1 = parcelRequire("ao2h1");

var $6SGt4 = parcelRequire("6SGt4");

var $1nb22 = parcelRequire("1nb22");
const $4f364072ed560b43$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_HORIZONTAL_NAVIGATION';
const $4f364072ed560b43$var$getProjectAri = (projectId, cloudId)=>{
    try {
        return projectId ? (0, $j5YhT.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString() : '';
    } catch (err) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jiraRouterResourcesNavigationItems', 'Failed to get project ari');
        return '';
    }
};
const $4f364072ed560b43$export$b3359003584ee2b0 = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: $4f364072ed560b43$var$RESOURCE_TYPE_KEY,
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const { cloudId: cloudId } = tenantContext;
        const projectIdOrKey = projectKey || projectId;
        const scopeId = $4f364072ed560b43$var$getProjectAri(projectId, cloudId);
        return {
            parameters: (0, $6SGt4.default),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectIdOrKey,
                first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE),
                isConsolidatedQuery: false,
                containerNavigationInput: scopeId ? {
                    scopeId: scopeId
                } : {
                    projectKeyQuery: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                useContainerNavigation: false,
                useNewProjectHeader: false,
                projectKey: projectKey,
                projectAri: scopeId,
                useProjectKey: Boolean(projectKey),
                isJiraCustomTemplatesUxEnabled: (0, $4R6GH.fg)('jira_custom_templates_ux')
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
}));

});
parcelRegister("6YG83", function(module, exports) {

$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $895edd6ed19f0aa8$export$f4b29e78f4c0a526);
const $895edd6ed19f0aa8$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});

parcelRegister("6SGt4", function(module, exports) {

$parcel$export(module.exports, "default", () => $fed7f561d3a05da6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<820042db950ffe26b91d34ffe7050138>>
 * @relayHash bef16a6db03ecc4506e2c317ed3ec3dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c6a8fb0afe8804c6d8b040f3b4ccf6926f7a96b57ad873204c81c3a0ee4ada5
const $fed7f561d3a05da6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJiraCustomTemplatesUxEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useProjectKey"
    }, v7 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v8 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v9 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v11 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "alias": "canEditProjectConfig",
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v14 = {
        "condition": "isJiraCustomTemplatesUxEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "customTemplateBusinessProjectBanner_businessHorizontalNav"
            }
        ]
    }, v15 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v16 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "projectIdOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = [
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "condition": "isJiraCustomTemplatesUxEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLiveTemplate"
                }
            ]
        },
        v18 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "projectNavigation_horizontalNavigationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "tabs_businessHorizontalNav_TabsContent"
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "alias": "projectDataByKey",
                                        "args": v8 /*: any*/ ,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v10 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.projectDataByKey.projectId"
                                            },
                                            v11 /*: any*/ ,
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "alias": "projectDataById",
                                        "args": v15 /*: any*/ ,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProject",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v10 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.projectDataById.projectId"
                                            },
                                            v11 /*: any*/ ,
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "projectNavigation_horizontalNavigationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "navigationItems",
                            "args": v16 /*: any*/ ,
                            "concreteType": "JiraNavigationItemConnection",
                            "kind": "LinkedField",
                            "name": "jwmSavedViewsByProject",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNavigationItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isDefault"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "typeKey"
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraNavigationItem"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canRemove"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canSetAsDefault"
                                                }
                                            ]
                                        },
                                        v17 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "navigationItems",
                            "args": v16 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "projectIdOrKey"
                            ],
                            "handle": "connection",
                            "key": "tabs_jiraNavigation__navigationItems",
                            "kind": "LinkedHandle",
                            "name": "jwmSavedViewsByProject"
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "projectDataByKey",
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": v19 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "projectDataById",
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": v19 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4c6a8fb0afe8804c6d8b040f3b4ccf6926f7a96b57ad873204c81c3a0ee4ada5",
            "metadata": {},
            "name": "projectNavigation_horizontalNavigationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fed7f561d3a05da6$var$node.hash = "73d9509696eb943ac9eaa2deb0444981";
var $fed7f561d3a05da6$export$2e2bcd8739ae039 = $fed7f561d3a05da6$var$node;

});


parcelRegister("iNzEe", function(module, exports) {

$parcel$export(module.exports, "navigationResource", () => $6b942b0827824c4b$export$62940941ee574cdc);
$parcel$export(module.exports, "useNavigationResource", () => $6b942b0827824c4b$export$c17011c09e042a31);

var $gccSB = parcelRequire("gccSB");

var $j5YhT = parcelRequire("j5YhT");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $geiy6 = parcelRequire("geiy6");

const $6b942b0827824c4b$export$62940941ee574cdc = (0, $2M1hQ.createResource)({
    type: 'BUSINESS_NAVIGATION',
    getKey: ()=>'BUSINESS_NAVIGATION',
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(projectKey)) return (0, $geiy6.fetchNavigation)((0, $77516b48757f52de$export$a40c5d12b8a53ba2), {
            cloudId: cloudId,
            projectKey: projectKey
        });
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(projectId)) return (0, $geiy6.fetchNavigation)((0, $77516b48757f52de$export$7c9197b656229b53), {
            cloudId: cloudId,
            projectId: (0, $j5YhT.JiraProjectAri).create({
                siteId: cloudId,
                projectId: projectId
            }).toString()
        });
        return (0, $geiy6.fetchNavigation)((0, $77516b48757f52de$export$c378ca4a0e2c9fec), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity
});
const $6b942b0827824c4b$export$c17011c09e042a31 = ()=>(0, $2YP9W.useResource)($6b942b0827824c4b$export$62940941ee574cdc);

});
const $77516b48757f52de$var$ProjectFragment = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectStyle
  projectType
  isFavourite
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
  defaultView: jwmDefaultSavedView {
    ... on JiraNavigationItem {
      typeKey
    }
  }
}
`;
const $77516b48757f52de$var$ProjectConnectionFragment = `
fragment ProjectConnectionFragment on JiraProjectConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...ProjectFragment
    }
  }
}
`;
const $77516b48757f52de$var$OverviewFragment = `
fragment OverviewFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
}
`;
const $77516b48757f52de$var$OverviewConnectionFragment = `
fragment OverviewConnectionFragment on JiraWorkManagementGiraOverviewConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...OverviewFragment
    }
  }
}
`;
const $77516b48757f52de$var$NavigationDataFragment = `
fragment NavigationFragment on JiraWorkManagementNavigation {
  jwmLicensing {
    currentUserSeatEdition
  }
  recentProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  favoriteProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  overviews: jwmOverviews(cloudId: $cloudId, first: $first) @optIn(to: "JiraWorkManagementGiraOverviews") {
    __typename
    ... on JiraWorkManagementGiraOverviewConnection {
      ...OverviewConnectionFragment
    }
  }
}
`;
const $77516b48757f52de$export$7c9197b656229b53 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectId(projectId: $projectId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$a40c5d12b8a53ba2 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectKey: String!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectKey(cloudId: $cloudId, projectKey: $projectKey) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$c378ca4a0e2c9fec = `
query JiraBusinessOverviewNavigation($cloudId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigation(cloudId: $cloudId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;

parcelRegister("geiy6", function(module, exports) {

$parcel$export(module.exports, "fetchNavigation", () => $446f8b979bebb841$export$1fc5fff73d9a570c);

var $jlq4V = parcelRequire("jlq4V");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");


var $ifwpM = parcelRequire("ifwpM");
const $446f8b979bebb841$var$EMPTY_RESPONSE = {
    recents: [],
    favorites: [],
    hasMoreFavorite: false,
    overviews: [],
    overviewsError: null,
    isPremiumUserSeat: false,
    shouldHideOverviews: false
};
const $446f8b979bebb841$export$1fc5fff73d9a570c = async (query, params)=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: (0, $4ee2cfa1c76e72ed$export$3349219a88ac77cd),
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        // checking only for undefined, as null is a valid value (not applicable)
        if (response.data?.jira?.navigation === undefined) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
        let areOverviewsGone = false;
        if (Array.isArray(response.errors)) // Overviews have been migrated to plans and should no longer be shown to the user
        areOverviewsGone = response.errors.some((error)=>error.extensions?.statusCode === 410);
        return (0, $ifwpM.transformData)(response.data.jira.navigation, areOverviewsGone);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessNavigation', 'Something went wrong while fetching the navigation items');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $jcw0u.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesBusinessNavigation',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $446f8b979bebb841$var$EMPTY_RESPONSE;
};

});
const $4ee2cfa1c76e72ed$export$3349219a88ac77cd = 10;
const $4ee2cfa1c76e72ed$export$e8958a6508ec5b71 = 'NOT_APPLICABLE';

parcelRegister("ifwpM", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $9031e5290b70d3d6$export$3ceb62baab058c6b);

var $6cG4N = parcelRequire("6cG4N");


var $027FQ = parcelRequire("027FQ");
const $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
const $9031e5290b70d3d6$var$PREMIUM = 'PREMIUM';
const $9031e5290b70d3d6$var$mapProjectNode = (node)=>({
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.projectStyle === $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE,
        isFavorite: node.isFavourite,
        permissions: {
            viewIssues: node.viewIssues.canPerform
        },
        defaultView: node.defaultView?.typeKey?.toLowerCase()
    });
const $9031e5290b70d3d6$var$mapOverviewNode = (node)=>({
        id: node.id,
        name: node.name,
        theme: node?.theme ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG).name
    });
const $9031e5290b70d3d6$export$3ceb62baab058c6b = (navigation, areOverviewsGone)=>{
    if (navigation == null) // not a JWM context
    return 0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71;
    let overviews = [];
    let overviewsError = null;
    const isPremiumUserSeat = navigation.jwmLicensing?.currentUserSeatEdition === $9031e5290b70d3d6$var$PREMIUM;
    if (isPremiumUserSeat) {
        if (navigation.overviews?.__typename === (0, $027FQ.OVERVIEWS_SUCCESS_RESPONSE_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        overviews = navigation.overviews.edges.map((edge)=>$9031e5290b70d3d6$var$mapOverviewNode(edge.node));
        else overviewsError = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        navigation.overviews ?? new Error('Unknown overviews error');
    }
    let recents = navigation.recentProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
    const favorites = navigation.favoriteProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
    // Remove favorited projects from the recent projects list
    recents = recents.filter((recentProject)=>!favorites.some((favProject)=>favProject.id === recentProject.id));
    return {
        recents: recents,
        favorites: favorites,
        hasMoreFavorite: navigation.favoriteProjects?.pageInfo?.hasNextPage ?? false,
        overviews: overviews,
        overviewsError: overviewsError,
        isPremiumUserSeat: isPremiumUserSeat,
        shouldHideOverviews: areOverviewsGone
    };
};

});
parcelRegister("6cG4N", function(module, exports) {

$parcel$export(module.exports, "STAR_ICON_COLOR", () => $cd302866fea6f361$export$9e0962e0cb41695d);
$parcel$export(module.exports, "Variables", () => $cd302866fea6f361$export$8bb9d79ea938efc9);
$parcel$export(module.exports, "Tokens", () => $cd302866fea6f361$export$8e1e81ac145e31be);
$parcel$export(module.exports, "BASE_THEME", () => $cd302866fea6f361$export$8a6e9b3370a0f87a);
$parcel$export(module.exports, "HIGH_BRIGHTNESS_THEME", () => $cd302866fea6f361$export$f286efa6bd1e8f9d);
$parcel$export(module.exports, "LOW_BRIGHTNESS_THEME", () => $cd302866fea6f361$export$97cb21c6432e07e8);
$parcel$export(module.exports, "GRADIENT_THEME", () => $cd302866fea6f361$export$b124f62a6aab972);
$parcel$export(module.exports, "IMAGE_BACKGROUND_CONFIG", () => $cd302866fea6f361$export$9441e0d8f766c59a);
$parcel$export(module.exports, "NO_BACKGROUND_CONFIG", () => $cd302866fea6f361$export$4c351ec1dc290344);
$parcel$export(module.exports, "BACKGROUND_CONFIGS_OLD", () => $cd302866fea6f361$export$34373eced7ee212e);
$parcel$export(module.exports, "FIXED_COLOR_BACKGROUND_CONFIGS", () => $cd302866fea6f361$export$bc16bf654619d060);
$parcel$export(module.exports, "ADAPTIVE_COLOR_BACKGROUND_CONFIGS", () => $cd302866fea6f361$export$4b188262dd47f902);
$parcel$export(module.exports, "GRADIENT_BACKGROUND_CONFIGS", () => $cd302866fea6f361$export$242b2d2213fedf27);
$parcel$export(module.exports, "ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS", () => $cd302866fea6f361$export$8a6c8dd4a86d3f7d);
$parcel$export(module.exports, "OLD_TO_NEW_BACKGROUND_CONFIG_MAP", () => $cd302866fea6f361$export$fe05a238062e2c3d);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_CONFIG", () => $cd302866fea6f361$export$cab9d853866386f2);
$parcel$export(module.exports, "BUSINESS_WRAPPER_PADDING", () => $cd302866fea6f361$export$8e357501548afe78);
$parcel$export(module.exports, "HORIZONTAL_NAV_HEIGHT", () => $cd302866fea6f361$export$baaf8255c30ea280);
$parcel$export(module.exports, "BUSINESS_NAV_HEIGHT", () => $cd302866fea6f361$export$d9035bc768f8226d);
$parcel$export(module.exports, "BUSINESS_WRAPPER_HEIGHT", () => $cd302866fea6f361$export$4810531e30462f89);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $cd302866fea6f361$export$1c0b806722927549);
$parcel$export(module.exports, "NAV4_HORIZONTAL_NAV_HEIGHT", () => $cd302866fea6f361$export$2af5673c2fa63c55);
$parcel$export(module.exports, "NAV4_HORIZONTAL_NAV_HEIGHT_NEW", () => $cd302866fea6f361$export$e03b923d879c011b);
$parcel$export(module.exports, "NAV4_BUSINESS_NAV_HEIGHT", () => $cd302866fea6f361$export$5771162cdeebfb85);
$parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_HEIGHT", () => $cd302866fea6f361$export$a1626d6d785092a2);
$parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $cd302866fea6f361$export$410e3d6221a052e);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WIDTH", () => $cd302866fea6f361$export$77cdace62a821419);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH", () => $cd302866fea6f361$export$3efe68325dd9dc02);
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// eslint-disable-next-line jira/restricted/@atlaskit+page-layout



const $cd302866fea6f361$export$9e0962e0cb41695d = '#FFAB00';
const $cd302866fea6f361$export$8bb9d79ea938efc9 = {
    BACKDROP_FILTER: '--project-backdrop-filter',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST: '--project-color-background-neutral-subtle-hovered-contrast',
    COLOR_BACKGROUND_ACCENT_SELECTED: '--project-color-background-accent-selected',
    COLOR_BACKGROUND_BRAND_BOLD: '--project-color-background-brand-bold',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: '--project-color-background-brand-bold-hovered',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: '--project-color-background-brand-bold-pressed',
    COLOR_BACKGROUND_DISABLED: '--project-color-background-disabled',
    COLOR_BACKGROUND_INPUT: '--project-background-input',
    COLOR_BACKGROUND_NEUTRAL: '--project-background-neutral',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: '--project-background-neutral-hovered',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: '--project-background-neutral-pressed',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: '--project-background-neutral-subtle-hovered',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: '--project-background-neutral-subtle-pressed',
    COLOR_BACKGROUND_SELECTED: '--project-background-selected',
    COLOR_BORDER: '--project-color-border',
    COLOR_BORDER_INPUT: '--project-color-border-input',
    COLOR_BORDER_INVERSE: '--project-color-border-inverse',
    COLOR_BORDER_SELECTED: '--project-color-border-selected',
    COLOR_ELEVATION_SURFACE: '--project-color-elevation-surface',
    COLOR_ELEVATION_SURFACE_SUNKEN: '--project-color-elevation-surface-sunken',
    COLOR_ICON_DANGER: '--project-color-icon-danger',
    COLOR_ICON_INFORMATION: '--project-color-icon-information',
    COLOR_ICON_SUCCESS: '--project-color-icon-success',
    COLOR_ICON_WARNING: '--project-color-icon-warning',
    COLOR_LINK: '--project-color-link',
    COLOR_LINK_PRESSED: '--project-color-link-pressed',
    COLOR_SKELETON: '--project-skeleton',
    COLOR_TEXT: '--project-color-text',
    COLOR_TEXT_ACCENT_SELECTED: '--project-text-accent-selected',
    COLOR_TEXT_DISABLED: '--project-color-text-disabled',
    COLOR_TEXT_INVERSE: '--project-color-text-inverse',
    COLOR_TEXT_SELECTED: '--project-color-text-selected',
    COLOR_TEXT_SUBTLE: '--project-color-text-subtle',
    COLOR_TEXT_SUBTLEST: '--project-color-text-subtlest',
    CONTENT_HEIGHT: '--project-content-height',
    CONTENT_WIDTH: '--project-content-width',
    ELEVATION_SURFACE: '--project-elevation-surface',
    ELEVATION_SURFACE_CONTRAST: '--project-elevation-surface-contrast',
    ELEVATION_SURFACE_CONTRAST_BOLDER: '--project-elevation-surface-contrast-bolder',
    WRAPPER_BACKGROUND: '--project-wrapper-background',
    WRAPPER_BORDER_RADIUS: '--project-wrapper-border-radius',
    WRAPPER_HEIGHT: '--project-wrapper-height',
    WRAPPER_PADDING: '--project-wrapper-padding',
    WRAPPER_WIDTH: '--project-wrapper-width'
};
const $cd302866fea6f361$export$8e1e81ac145e31be = {
    BACKDROP_FILTER: 'var(--project-backdrop-filter)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST: 'var(--project-color-background-neutral-subtle-hovered-contrast)',
    COLOR_BACKGROUND_ACCENT_SELECTED: 'var(--project-color-background-accent-selected)',
    COLOR_BACKGROUND_BRAND_BOLD: 'var(--project-color-background-brand-bold)',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: 'var(--project-color-background-brand-bold-hovered)',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: 'var(--project-color-background-brand-bold-pressed)',
    COLOR_BACKGROUND_DISABLED: 'var(--project-color-background-disabled)',
    COLOR_BACKGROUND_INPUT: 'var(--project-background-input)',
    COLOR_BACKGROUND_NEUTRAL: 'var(--project-background-neutral)',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: 'var(--project-background-neutral-hovered)',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: 'var(--project-background-neutral-pressed)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: 'var(--project-background-neutral-subtle-hovered)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: 'var(--project-background-neutral-subtle-pressed)',
    COLOR_BACKGROUND_SELECTED: 'var(--project-background-selected)',
    COLOR_BORDER: 'var(--project-color-border)',
    COLOR_BORDER_INPUT: 'var(--project-color-border-input)',
    COLOR_BORDER_INVERSE: 'var(--project-color-border-inverse)',
    COLOR_BORDER_SELECTED: 'var(--project-color-border-selected)',
    COLOR_ELEVATION_SURFACE: 'var(--project-color-elevation-surface)',
    COLOR_ELEVATION_SURFACE_SUNKEN: 'var(--project-color-elevation-surface-sunken)',
    COLOR_ICON_DANGER: 'var(--project-color-icon-danger)',
    COLOR_ICON_INFORMATION: 'var(--project-color-icon-information)',
    COLOR_ICON_SUCCESS: 'var(--project-color-icon-success)',
    COLOR_ICON_WARNING: 'var(--project-color-icon-warning)',
    COLOR_LINK: 'var(--project-color-link)',
    COLOR_LINK_PRESSED: 'var(--project-color-link-pressed)',
    COLOR_SKELETON: 'var(--project-skeleton)',
    COLOR_TEXT: 'var(--project-color-text)',
    COLOR_TEXT_ACCENT_SELECTED: 'var(--project-text-accent-selected)',
    COLOR_TEXT_DISABLED: 'var(--project-color-text-disabled)',
    COLOR_TEXT_INVERSE: 'var(--project-color-text-inverse)',
    COLOR_TEXT_SELECTED: 'var(--project-color-text-selected)',
    COLOR_TEXT_SUBTLE: 'var(--project-color-text-subtle)',
    COLOR_TEXT_SUBTLEST: 'var(--project-color-text-subtlest)',
    CONTENT_HEIGHT: 'var(--project-content-height)',
    CONTENT_WIDTH: 'var(--project-content-width)',
    ELEVATION_SURFACE: 'var(--project-elevation-surface)',
    ELEVATION_SURFACE_CONTRAST: 'var(--project-elevation-surface-contrast)',
    ELEVATION_SURFACE_CONTRAST_BOLDER: 'var(--project-elevation-surface-contrast-bolder)',
    WRAPPER_BACKGROUND: 'var(--project-wrapper-background)',
    WRAPPER_BORDER_RADIUS: 'var(--project-wrapper-border-radius)',
    WRAPPER_HEIGHT: 'var(--project-wrapper-height)',
    WRAPPER_PADDING: 'var(--project-wrapper-padding)',
    WRAPPER_WIDTH: 'var(--project-wrapper-width)'
};
const $cd302866fea6f361$export$8a6e9b3370a0f87a = {
    'color.background.neutral.subtle.hovered.contrast': "var(--ds-background-neutral-subtle-hovered, #091E420F)",
    'color.background.accent.selected': (0, $a7f8c6b391092279$exports).B700,
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0C66E4)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0055CC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #09326C)",
    'color.background.disabled': "var(--ds-background-disabled, #091E4208)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.neutral': "var(--ds-background-neutral, #091E420F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #091E424F)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091E420F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #091E4224)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FF)",
    'color.elevation.surface': "var(--ds-surface, #FFFFFF)",
    'color.elevation.surface.sunken': "var(--ds-surface-sunken, #F7F8F9)",
    'color.border': "var(--ds-border, #091E4224)",
    'color.border.input': "var(--ds-border-input, #8590A2)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0C66E4)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.information': "var(--ds-icon-information, #1D7AFC)",
    'color.icon.success': "var(--ds-icon-success, #22A06B)",
    'color.icon.warning': "var(--ds-icon-warning, #E56910)",
    'color.link': "var(--ds-link, #0C66E4)",
    'color.link.pressed': "var(--ds-link-pressed, #0055CC)",
    'color.skeleton': "var(--ds-background-neutral, #091E420F)",
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.selected': "var(--ds-text, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #091E424F)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0C66E4)",
    'color.text.subtle': "var(--ds-text-subtle, #44546F)",
    'color.text.subtlest': "var(--ds-text-subtlest, #626F86)",
    'elevation.surface.contrast': 'transparent',
    'elevation.surface.contrast.bolder': 'transparent'
};
const $cd302866fea6f361$export$f286efa6bd1e8f9d = {
    'color.background.accent.selected': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
    'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.background.disabled': "var(--ds-background-neutral, #091E420F)",
    'color.background.input': 'rgba(255, 255, 255, 0.8)',
    'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.text.selected': "var(--ds-text-inverse, #FFFFFF)"
};
const $cd302866fea6f361$export$97cb21c6432e07e8 = {
    'color.background.neutral.subtle.hovered.contrast': 'rgba(255, 255, 255, 0.08)',
    'color.background.accent.selected': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.brand.bold': 'rgba(255, 255, 255, 0.8)',
    'color.background.brand.bold.hovered': 'rgba(255, 255, 255, 0.6)',
    'color.background.brand.bold.pressed': 'rgba(255, 255, 255, 0.4)',
    'color.background.disabled': 'rgba(255, 255, 255, 0.08)',
    'color.background.input': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.hovered': 'rgba(255, 255, 255, 0.16)',
    'color.background.neutral.pressed': 'rgba(255, 255, 255, 0.28)',
    'color.background.neutral.subtle.hovered': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.subtle.pressed': 'rgba(255, 255, 255, 0.16)',
    'color.background.selected': 'rgba(255, 255, 255, 0.6)',
    'color.elevation.surface': '#172b4d',
    'color.border': 'rgba(255, 255, 255, 0.14)',
    'color.border.input': 'rgba(255, 255, 255, 0.3)',
    'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
    'color.border.selected': (0, $a7f8c6b391092279$exports).N0,
    'color.icon.danger': (0, $a7f8c6b391092279$exports).N0,
    'color.icon.information': (0, $a7f8c6b391092279$exports).N0,
    'color.icon.success': (0, $a7f8c6b391092279$exports).N0,
    'color.icon.warning': (0, $a7f8c6b391092279$exports).N0,
    'color.skeleton': 'rgba(255,255,255,0.08)',
    'color.text': (0, $a7f8c6b391092279$exports).N0,
    'color.text.disabled': 'rgba(255, 255, 255, 0.6)',
    'color.text.inverse': '#172B4D',
    // Neutral 1000
    'color.text.selected': '#172B4D',
    // Neutral 1000
    'color.text.subtle': 'rgba(255, 255, 255, 0.8)',
    'color.text.subtlest': 'rgba(255, 255, 255, 0.8)'
};
const $cd302866fea6f361$export$b124f62a6aab972 = {
    'color.link': '#CCE0FF',
    // Blue 200
    'color.link.pressed': '#E9F2FF' // Blue 100
};
const $cd302866fea6f361$export$9441e0d8f766c59a = {
    name: 'image',
    brightness: 'high',
    theme: {
        light: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.text.selected': "var(--ds-text-inverse, #FFFFFF)",
            'elevation.surface.contrast': 'rgba(255,255,255,0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #FFFFFF)"
        },
        dark: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.background.input': 'rgba(34, 39, 43, 0.8)',
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.elevation.surface': '#172b4d',
            'color.border': 'rgba(255, 255, 255, 0.14)',
            'color.border.input': 'rgba(255, 255, 255, 0.3)',
            'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
            'color.icon.danger': (0, $a7f8c6b391092279$exports).N0,
            'color.icon.information': (0, $a7f8c6b391092279$exports).N0,
            'color.icon.success': (0, $a7f8c6b391092279$exports).N0,
            'color.icon.warning': (0, $a7f8c6b391092279$exports).N0,
            'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.skeleton': 'rgba(255,255,255,0.8)',
            'color.text': (0, $a7f8c6b391092279$exports).N0,
            'color.text.selected': "var(--ds-text-inverse, #FFFFFF)",
            'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #FFFFFF)"
        }
    }
};
// Old Colors
const $cd302866fea6f361$var$WHITE_BACKGROUND_CONFIG = {
    name: 'white'
};
const $cd302866fea6f361$var$LIGHT_PURPLE_BACKGROUND_CONFIG = {
    name: 'light-purple'
};
const $cd302866fea6f361$var$LIGHT_BLUE_BACKGROUND_CONFIG = {
    name: 'light-blue'
};
const $cd302866fea6f361$var$LIGHT_TEAL_BACKGROUND_CONFIG = {
    name: 'light-teal'
};
const $cd302866fea6f361$var$LIGHT_GREEN_BACKGROUND_CONFIG = {
    name: 'light-green'
};
const $cd302866fea6f361$var$LIGHT_YELLOW_BACKGROUND_CONFIG = {
    name: 'light-yellow'
};
const $cd302866fea6f361$var$LIGHT_RED_BACKGROUND_CONFIG = {
    name: 'light-red'
};
const $cd302866fea6f361$var$LIGHT_MAGENTA_BACKGROUND_CONFIG = {
    name: 'light-magenta'
};
const $cd302866fea6f361$var$LIGHT_ORANGE_BACKGROUND_CONFIG = {
    name: 'light-orange'
};
const $cd302866fea6f361$var$DARK_BACKGROUND_CONFIG = {
    name: 'dark'
};
const $cd302866fea6f361$var$PURPLE_BACKGROUND_CONFIG = {
    name: 'purple'
};
const $cd302866fea6f361$var$BLUE_BACKGROUND_CONFIG = {
    name: 'blue'
};
const $cd302866fea6f361$var$TEAL_BACKGROUND_CONFIG = {
    name: 'teal'
};
const $cd302866fea6f361$var$GREEN_BACKGROUND_CONFIG = {
    name: 'green'
};
const $cd302866fea6f361$var$YELLOW_BACKGROUND_CONFIG = {
    name: 'yellow'
};
const $cd302866fea6f361$var$RED_BACKGROUND_CONFIG = {
    name: 'red'
};
const $cd302866fea6f361$var$MAGENTA_BACKGROUND_CONFIG = {
    name: 'magenta'
};
const $cd302866fea6f361$var$ORANGE_BACKGROUND_CONFIG = {
    name: 'orange'
};
// New Colors
const $cd302866fea6f361$var$DARKER_GRAY_BACKGROUND_CONFIG = {
    name: 'darker-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG = {
    name: 'darker-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG = {
    name: 'darker-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG = {
    name: 'darker-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG = {
    name: 'darker-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_LIME_BACKGROUND_CONFIG = {
    name: 'darker-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG = {
    name: 'darker-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG = {
    name: 'darker-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG = {
    name: 'darker-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darker-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG = {
    name: 'darkest-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'darkest-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_BLUE_BACKGROUND_CONFIG = {
    name: 'darkest-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_TEAL_BACKGROUND_CONFIG = {
    name: 'darkest-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_GREEN_BACKGROUND_CONFIG = {
    name: 'darkest-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_LIME_BACKGROUND_CONFIG = {
    name: 'darkest-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'darkest-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'darkest-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_RED_BACKGROUND_CONFIG = {
    name: 'darkest-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $cd302866fea6f361$var$DARKEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darkest-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_GRAY_BACKGROUND_CONFIG = {
    name: 'lightest-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F1F2F4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'lightest-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F3F0FF',
            // Purple 100
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG = {
    name: 'lightest-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E9F2FF',
            // Blue 100
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG = {
    name: 'lightest-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E7F9FF',
            // Teal 100
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG = {
    name: 'lightest-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCFFF1',
            // Green 100
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_LIME_BACKGROUND_CONFIG = {
    name: 'lightest-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#EFFFD6',
            // Lime 100
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'lightest-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF7D6',
            // Yellow 100
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'lightest-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF3EB',
            // Orange 100
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG = {
    name: 'lightest-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECEB',
            // Red 100
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lightest-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECF8',
            // Magenta 100
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_GRAY_BACKGROUND_CONFIG = {
    name: 'lighter-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCDFE4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_PURPLE_BACKGROUND_CONFIG = {
    name: 'lighter-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DFD8FD',
            // Purple 200
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_BLUE_BACKGROUND_CONFIG = {
    name: 'lighter-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#CCE0FF',
            // Blue 200
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_TEAL_BACKGROUND_CONFIG = {
    name: 'lighter-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#C6EDFB',
            // Teal 200
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_GREEN_BACKGROUND_CONFIG = {
    name: 'lighter-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#BAF3DB',
            // Green 200
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_LIME_BACKGROUND_CONFIG = {
    name: 'lighter-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#D3F1A7',
            // Lime 200
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_YELLOW_BACKGROUND_CONFIG = {
    name: 'lighter-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F8E6A0',
            // Yellow 200
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_ORANGE_BACKGROUND_CONFIG = {
    name: 'lighter-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FEDEC8',
            // Orange 200
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_RED_BACKGROUND_CONFIG = {
    name: 'lighter-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFD5D2',
            // Red 200
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $cd302866fea6f361$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lighter-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FDD0EC',
            // Magenta 200
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $cd302866fea6f361$export$4c351ec1dc290344 = {
    name: 'no-background',
    brightness: 'high',
    theme: {
        light: $cd302866fea6f361$export$8a6e9b3370a0f87a,
        dark: {
            ...$cd302866fea6f361$export$8a6e9b3370a0f87a,
            'color.text.accent.selected': "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
const $cd302866fea6f361$export$68930f4689402226 = {
    name: 'adaptive-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': "var(--ds-surface-hovered, #F1F2F4)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text, #172B4D)",
            'color.link.pressed': "var(--ds-text, #172B4D)",
            'color.elevation.surface.sunken': "var(--ds-surface-pressed, #DCDFE4)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        },
        dark: {
            'color.elevation.surface': "var(--ds-surface-hovered, #F1F2F4)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text, #172B4D)",
            'color.link.pressed': "var(--ds-text, #172B4D)",
            'color.elevation.surface.sunken': "var(--ds-surface-pressed, #DCDFE4)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.text': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }
    }
};
const $cd302866fea6f361$export$e013fca1233b4f7f = {
    name: 'adaptive-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-purple, #5E4DB2)",
            'color.link.pressed': "var(--ds-text-accent-purple, #5E4DB2)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-purple-subtler, #DFD8FD)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        },
        dark: {
            'color.elevation.surface': "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-purple, #5E4DB2)",
            'color.link.pressed': "var(--ds-text-accent-purple, #5E4DB2)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-purple-subtler, #DFD8FD)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.text': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }
    }
};
const $cd302866fea6f361$export$81ad18a6866e27ad = {
    name: 'adaptive-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-blue, #0055CC)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-blue-subtler, #CCE0FF)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        },
        dark: {
            'color.elevation.surface': "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-blue, #0055CC)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-blue-subtler, #CCE0FF)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.text': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }
    }
};
const $cd302866fea6f361$export$e41eaa7177d56baf = {
    name: 'adaptive-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-teal, #206A83)",
            'color.link.pressed': "var(--ds-text-accent-teal, #206A83)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        },
        dark: {
            'color.elevation.surface': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-teal, #206A83)",
            'color.link.pressed': "var(--ds-text-accent-teal, #206A83)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.text': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }
    }
};
const $cd302866fea6f361$export$31b6c9185eea93be = {
    name: 'adaptive-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-green, #216E4E)",
            'color.link.pressed': "var(--ds-text-accent-green, #216E4E)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-green-subtler, #BAF3DB)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        },
        dark: {
            'color.elevation.surface': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-green, #216E4E)",
            'color.link.pressed': "var(--ds-text-accent-green, #216E4E)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-green-subtler, #BAF3DB)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.text': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }
    }
};
const $cd302866fea6f361$export$3214417ed3fa0b58 = {
    name: 'adaptive-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-magenta, #943D73)",
            'color.link.pressed': "var(--ds-text-accent-magenta, #943D73)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        },
        dark: {
            'color.elevation.surface': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
            'color.background.input': "var(--ds-background-neutral, #091E420F)",
            'color.link': "var(--ds-text-accent-magenta, #943D73)",
            'color.link.pressed': "var(--ds-text-accent-magenta, #943D73)",
            'color.elevation.surface.sunken': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
            'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
            'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
            'color.border.selected': "var(--ds-border-bold, #758195)",
            'color.text.selected': "var(--ds-text, #172B4D)",
            'color.text': "var(--ds-text, #172B4D)",
            'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
            'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
            'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
        }
    }
};
// Gradients
const $cd302866fea6f361$var$GRADIENT_GRAY_TO_BLACK_META = {
    name: 'gradient-gray-to-black',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META = {
    name: 'gradient-dark-to-medium-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_LIGHT_TO_DARK_BLUE_META = {
    name: 'gradient-light-to-dark-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_BLUE_TO_TEAL_META = {
    name: 'gradient-blue-to-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_PURPLE_TO_MAGENTA_META = {
    name: 'gradient-purple-to-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_MAGENTA_TO_ORANGE_META = {
    name: 'gradient-magenta-to-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_RED_META = {
    name: 'gradient-dark-to-light-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META = {
    name: 'gradient-dark-to-light-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_GREEN_TO_LIME_META = {
    name: 'gradient-dark-green-to-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#133911',
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        },
        dark: {
            'color.elevation.surface': '#133911',
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        }
    }
};
const $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META = {
    name: 'gradient-dark-to-medium-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#01233D',
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        },
        dark: {
            'color.elevation.surface': '#01233D',
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        }
    }
};
const $cd302866fea6f361$var$ADAPTIVE_GRADIENT_GRAY_TO_BLACK_META = {
    name: 'adaptive-gradient-gray-to-black',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#182A46',
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4'
        },
        dark: {
            'color.elevation.surface': '#182A46',
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4',
            'color.text': "var(--ds-text, #172B4D)"
        }
    }
};
const $cd302866fea6f361$var$ADAPTIVE_GRADIENT_MAGENTA_TO_ORANGE_META = {
    name: 'adaptive-gradient-magenta-to-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#7D014B',
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4'
        },
        dark: {
            'color.elevation.surface': '#7D014B',
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4',
            'color.text': "var(--ds-text, #172B4D)"
        }
    }
};
const $cd302866fea6f361$var$ADAPTIVE_GRADIENT_LIGHT_TO_DARK_BLUE_META = {
    name: 'adaptive-gradient-light-to-dark-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#01235F',
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4'
        },
        dark: {
            'color.elevation.surface': '#01235F',
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4',
            'color.text': "var(--ds-text, #172B4D)"
        }
    }
};
const $cd302866fea6f361$var$ADAPTIVE_GRADIENT_DARK_TO_MEDIUM_TEAL_META = {
    name: 'adaptive-gradient-dark-to-medium-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#01233D',
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4'
        },
        dark: {
            'color.elevation.surface': '#01233D',
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4',
            'color.text': "var(--ds-text, #172B4D)"
        }
    }
};
const $cd302866fea6f361$var$ADAPTIVE_GRADIENT_DARK_GREEN_TO_LIME_META = {
    name: 'adaptive-gradient-dark-green-to-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#133911',
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4'
        },
        dark: {
            'color.elevation.surface': '#133911',
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4',
            'color.text': "var(--ds-text, #172B4D)"
        }
    }
};
const $cd302866fea6f361$var$ADAPTIVE_GRADIENT_PURPLE_TO_MAGENTA_META = {
    name: 'adaptive-gradient-purple-to-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#132564',
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4'
        },
        dark: {
            'color.elevation.surface': '#132564',
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)',
            'color.link': '#E2E3E4',
            'color.link.pressed': '#E2E3E4',
            'color.text.subtle': '#BFC1C4',
            'color.text': "var(--ds-text, #172B4D)"
        }
    }
};
const $cd302866fea6f361$export$34373eced7ee212e = [
    $cd302866fea6f361$var$WHITE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHT_MAGENTA_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARK_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$MAGENTA_BACKGROUND_CONFIG
];
const $cd302866fea6f361$export$bc16bf654619d060 = [
    $cd302866fea6f361$var$LIGHTEST_GRAY_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_LIME_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_GRAY_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_LIME_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_GRAY_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_LIME_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_PURPLE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_BLUE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_TEAL_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_GREEN_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_LIME_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_YELLOW_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_ORANGE_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_RED_BACKGROUND_CONFIG,
    $cd302866fea6f361$var$DARKEST_MAGENTA_BACKGROUND_CONFIG
];
const $cd302866fea6f361$export$4b188262dd47f902 = [
    $cd302866fea6f361$export$68930f4689402226,
    $cd302866fea6f361$export$e013fca1233b4f7f,
    $cd302866fea6f361$export$81ad18a6866e27ad,
    $cd302866fea6f361$export$e41eaa7177d56baf,
    $cd302866fea6f361$export$31b6c9185eea93be,
    $cd302866fea6f361$export$3214417ed3fa0b58
];
const $cd302866fea6f361$export$242b2d2213fedf27 = [
    $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_RED_META,
    $cd302866fea6f361$var$GRADIENT_MAGENTA_TO_ORANGE_META,
    $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META,
    $cd302866fea6f361$var$GRADIENT_DARK_GREEN_TO_LIME_META,
    $cd302866fea6f361$var$GRADIENT_BLUE_TO_TEAL_META,
    $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META,
    $cd302866fea6f361$var$GRADIENT_LIGHT_TO_DARK_BLUE_META,
    $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META,
    $cd302866fea6f361$var$GRADIENT_PURPLE_TO_MAGENTA_META,
    $cd302866fea6f361$var$GRADIENT_GRAY_TO_BLACK_META
];
const $cd302866fea6f361$export$8a6c8dd4a86d3f7d = [
    $cd302866fea6f361$var$ADAPTIVE_GRADIENT_GRAY_TO_BLACK_META,
    $cd302866fea6f361$var$ADAPTIVE_GRADIENT_MAGENTA_TO_ORANGE_META,
    $cd302866fea6f361$var$ADAPTIVE_GRADIENT_LIGHT_TO_DARK_BLUE_META,
    $cd302866fea6f361$var$ADAPTIVE_GRADIENT_DARK_TO_MEDIUM_TEAL_META,
    $cd302866fea6f361$var$ADAPTIVE_GRADIENT_DARK_GREEN_TO_LIME_META,
    $cd302866fea6f361$var$ADAPTIVE_GRADIENT_PURPLE_TO_MAGENTA_META
];
const $cd302866fea6f361$export$fe05a238062e2c3d = {
    white: $cd302866fea6f361$export$4c351ec1dc290344,
    'light-purple': $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    'light-blue': $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    'light-teal': $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    'light-green': $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    'light-yellow': $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    'light-orange': $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    'light-red': $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    'light-magenta': $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    dark: $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    purple: $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    blue: $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG,
    teal: $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG,
    green: $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG,
    yellow: $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    orange: $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    red: $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG,
    magenta: $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG
};
const $cd302866fea6f361$export$cab9d853866386f2 = $cd302866fea6f361$export$4c351ec1dc290344;
const $cd302866fea6f361$export$8e357501548afe78 = 24;
const $cd302866fea6f361$export$baaf8255c30ea280 = 95;
const $cd302866fea6f361$export$d9035bc768f8226d = `${$cd302866fea6f361$export$baaf8255c30ea280}px`;
const $cd302866fea6f361$export$4810531e30462f89 = `calc(100vh - ${(0, $81918a2ef6db1f93$export$d60454526e2281af)} - ${$cd302866fea6f361$export$d9035bc768f8226d})`;
const $cd302866fea6f361$export$1c0b806722927549 = `calc(100vh - ${(0, $81918a2ef6db1f93$export$d60454526e2281af)} - ${$cd302866fea6f361$export$d9035bc768f8226d} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
const $cd302866fea6f361$export$2af5673c2fa63c55 = 122;
const $cd302866fea6f361$export$e03b923d879c011b = 104;
const $cd302866fea6f361$export$5771162cdeebfb85 = `${$cd302866fea6f361$export$2af5673c2fa63c55}px`;
const $cd302866fea6f361$export$a1626d6d785092a2 = `calc(100vh - ${(0, $81918a2ef6db1f93$export$d60454526e2281af)} - ${$cd302866fea6f361$export$5771162cdeebfb85})`;
const $cd302866fea6f361$export$410e3d6221a052e = `calc(100vh - ${(0, $81918a2ef6db1f93$export$d60454526e2281af)} - ${$cd302866fea6f361$export$5771162cdeebfb85} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
const $cd302866fea6f361$export$77cdace62a821419 = `calc(100vw - ${(0, $62b79b702763d93f$export$f963aecf2d4465bd)} - ${(0, $62b79b702763d93f$export$f897e1ed9f8ed251)} - ${(0, $62b79b702763d93f$export$750459958906793)} - ${(0, $62b79b702763d93f$export$b44ab66843c05a69)}) !important`;
const $cd302866fea6f361$export$3efe68325dd9dc02 = `calc(100vw - ${(0, $62b79b702763d93f$export$f963aecf2d4465bd)} - ${(0, $62b79b702763d93f$export$f897e1ed9f8ed251)} - ${(0, $62b79b702763d93f$export$750459958906793)} - ${(0, $62b79b702763d93f$export$b44ab66843c05a69)} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px) !important`;

});
// dimension vars
const $62b79b702763d93f$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $62b79b702763d93f$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $62b79b702763d93f$export$c103b605cd368aed = 'rightSidebarWidth';
const $62b79b702763d93f$export$fa34f417972d6341 = 'rightPanelWidth';
const $62b79b702763d93f$export$3a6a779d9181047c = 'topNavigationHeight';
const $62b79b702763d93f$export$bcd94a6a792e7f96 = 'bannerHeight';
const $62b79b702763d93f$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $62b79b702763d93f$export$344062f7cfc9528e = 'left-panel';
const $62b79b702763d93f$export$c7139cc2d6110b5f = 'right-panel';
const $62b79b702763d93f$export$238d30785c4bca84 = 'banner';
const $62b79b702763d93f$export$bec6dca2e63de4ae = 'top-navigation';
const $62b79b702763d93f$export$d1213e82613ff4df = 'content';
const $62b79b702763d93f$export$be83e7118304b28e = 56;
const $62b79b702763d93f$export$4a98ee0bd1ae362 = 56;
const $62b79b702763d93f$export$539e68c09584883a = 240;
const $62b79b702763d93f$export$b92df8810d2fcd01 = 280;
const $62b79b702763d93f$export$c3e41153b9288bcf = 368;
const $62b79b702763d93f$export$c4d6152f86ea28f6 = 368;
const $62b79b702763d93f$export$46acf8758e9e2636 = 20;
const $62b79b702763d93f$export$70740f5ad8360a78 = 16;
const $62b79b702763d93f$export$991d5285ad765a3d = 240;
const $62b79b702763d93f$export$6949d4f32b161684 = 200;
const $62b79b702763d93f$export$d6e7e8af042815bb = 350;
const $62b79b702763d93f$export$3749e1104328fde4 = 300;
const $62b79b702763d93f$export$1074d925b0b82be5 = 200;
const $62b79b702763d93f$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $62b79b702763d93f$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $62b79b702763d93f$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $62b79b702763d93f$export$70c702a8c5895f03 = 'data-grab-area-line';
const $62b79b702763d93f$export$48a43f91e4becf4e = 'data-grab-area';
const $62b79b702763d93f$export$dac2fb31a9f6844d = 'data-resize-button';
const $62b79b702763d93f$export$9ecd22db14e6c70e = 'data-resize-control';
const $62b79b702763d93f$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $62b79b702763d93f$export$206a08f7f8beb554 = 'Skip to:';
const $62b79b702763d93f$export$659ee746b31b360d = 'data-layout-container';
const $62b79b702763d93f$export$f963aecf2d4465bd = `var(--${$62b79b702763d93f$export$cbfb0f5b2869b17b}, 0px)`;
const $62b79b702763d93f$export$750459958906793 = `var(--${$62b79b702763d93f$export$fa34f417972d6341}, 0px)`;
const $62b79b702763d93f$export$f897e1ed9f8ed251 = `var(--${$62b79b702763d93f$export$a30f2e00489a8957}, 0px)`;
const $62b79b702763d93f$export$b44ab66843c05a69 = `var(--${$62b79b702763d93f$export$c103b605cd368aed}, 0px)`;
const $62b79b702763d93f$export$aeff86a16f13529 = `var(--${$62b79b702763d93f$export$3a6a779d9181047c}, 0px)`;
const $62b79b702763d93f$export$ed7cc0d417ee89e = `var(--${$62b79b702763d93f$export$bcd94a6a792e7f96}, 0px)`;
const $62b79b702763d93f$export$d2fa14f05b61e66 = `var(--${$62b79b702763d93f$export$b6744d31294864fd}, ${$62b79b702763d93f$export$991d5285ad765a3d}px)`;

// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// These variables are inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT = 'var(--bannerHeight, 0px)';
const $81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT = 'var(--topNavigationHeight, 0px)';
const $81918a2ef6db1f93$export$638757b621fbf475 = `${$81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT} + ${$81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT}`;
const $81918a2ef6db1f93$export$d60454526e2281af = `(${$81918a2ef6db1f93$export$638757b621fbf475})`;


parcelRegister("027FQ", function(module, exports) {

$parcel$export(module.exports, "OVERVIEWS_SUCCESS_RESPONSE_TYPE", () => $fd4c320fd9ec6c35$export$ddf2fc82885279d);
const $fd4c320fd9ec6c35$export$ddf2fc82885279d = 'JiraWorkManagementGiraOverviewConnection';
const $fd4c320fd9ec6c35$export$39284f7325536558 = {
    ServiceDesk: 'SERVICE_DESK',
    Business: 'BUSINESS',
    Software: 'SOFTWARE'
};
const $fd4c320fd9ec6c35$export$1f66f9f05afa05a8 = {
    TeamManagedProject: 'TEAM_MANAGED_PROJECT',
    CompanyManagedProject: 'COMPANY_MANAGED_PROJECT'
};

});




parcelRegister("jrO9m", function(module, exports) {

$parcel$export(module.exports, "overviewDetailsResource", () => $e1715b61e2fa96e9$export$cd57aa046b167312);
$parcel$export(module.exports, "useOverview", () => $e1715b61e2fa96e9$export$626541a5c6f2cfa1);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $hFi7P = parcelRequire("hFi7P");
const $e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY = 'BUSINESS_OVERVIEW_DETAILS';
const $e1715b61e2fa96e9$export$cd57aa046b167312 = (0, $2M1hQ.createResource)({
    type: $e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY,
    getKey: ({ match: match })=>`${$e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY}_${match.params.overviewId}`,
    getData: async ({ match: match }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>(0, $hFi7P.fetchOverviewDetails)(cloudId, activationId, match.params.overviewId),
    maxAge: 3600000
});
const $e1715b61e2fa96e9$export$626541a5c6f2cfa1 = ()=>(0, $2YP9W.useResource)($e1715b61e2fa96e9$export$cd57aa046b167312);

});
parcelRegister("hFi7P", function(module, exports) {

$parcel$export(module.exports, "fetchOverviewDetails", () => $692d3aa28ecf0a74$export$f0395142dbdd6c61);

var $7q3cr = parcelRequire("7q3cr");

var $63wRx = parcelRequire("63wRx");

var $jlq4V = parcelRequire("jlq4V");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $dpLxG = parcelRequire("dpLxG");

const $692d3aa28ecf0a74$export$f0395142dbdd6c61 = async (cloudId, activationId, overviewId)=>{
    if (!overviewId) return null;
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $dpLxG.QUERY),
                variables: {
                    id: (0, $7q3cr.JiraProjectOverviewAri).create({
                        siteId: cloudId,
                        activationId: activationId,
                        overviewId: overviewId
                    }).toString()
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        if (response?.data?.jira?.overview?.__typename === (0, $4bd5c695609ae115$export$62a5da7e3fa5ff88)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $63wRx.mapOverviewFragment)(response.data.jira.overview);
        throw new (0, $jlq4V.GraphQLErrors)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        response?.data?.jira?.overview ?? response.errors);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 410 means that overviews have been migrated to plans and
        // we will show a different message on the not found page.
        if (error?.statusCode === 410) throw error;
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessOverviewDetails', 'Something went wrong while fetching business overview details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'overviewDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessOverviewDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return null;
};

});
parcelRegister("63wRx", function(module, exports) {

$parcel$export(module.exports, "mapOverviewFragment", () => $bc1a4d4cd369fa52$export$e79bf238de33eabb);
const $bc1a4d4cd369fa52$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bc1a4d4cd369fa52$var$mapProjectsNode = (edges)=>edges.map((edge)=>{
        const { node: node } = edge || {};
        if (node == null) return null;
        return {
            key: node.key,
            id: Number(node.projectId),
            avatarUrl: node.avatar?.large ?? '',
            name: node.name,
            type: node.projectType.toLowerCase(),
            isSimplified: node.projectStyle === $bc1a4d4cd369fa52$var$SIMPLIFIED_PROJECT_STYLE,
            isFavorite: node.isFavourite === true,
            permissions: {
                assignIssues: false,
                administerProject: node.administerProject.canPerform,
                createIssues: node.createIssues.canPerform,
                deleteIssues: node.deleteIssues.canPerform,
                editIssues: node.editIssues.canPerform,
                linkIssues: node.linkIssues.canPerform,
                scheduleIssues: node.scheduleIssues.canPerform,
                // remove optional chaining when jwm-use-updated-graphql-querymutation-for-overview is cleaned up
                transitionIssues: node.transitionIssues?.canPerform === true,
                viewIssues: node.viewIssues.canPerform
            }
        };
    }).filter((project)=>project);
const $bc1a4d4cd369fa52$export$e79bf238de33eabb = (overview)=>{
    const { id: id, name: name, theme: theme, projects: projectsData } = overview;
    const projects = $bc1a4d4cd369fa52$var$mapProjectsNode(projectsData.edges);
    const unreachableProjectsCount = projectsData.edges.length - projects.length;
    return {
        id: id,
        name: name,
        theme: theme,
        projects: projects,
        unreachableProjectsCount: unreachableProjectsCount
    };
};

});

parcelRegister("dpLxG", function(module, exports) {

$parcel$export(module.exports, "QUERY", () => $42259e945f9fd88b$export$2b91517d6d5b4365);

const $42259e945f9fd88b$export$2b91517d6d5b4365 = `
    query JwmOverviewDetails($id:ID!) {
      jira {
        overview: jwmOverview(id: $id) {
          __typename
          ... on JiraWorkManagementGiraOverview {
            ...OverviewGiraFragment
          }
          ... on QueryError {
            message
            extensions {
              errorType
              statusCode
            }
          }
        }
      }
    }
    ${(0, $71cc1a0cc3cc977d$export$6f4bda7ea1dcf892)}
`;

});
const $71cc1a0cc3cc977d$export$6f4bda7ea1dcf892 = `
fragment OverviewGiraFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
  projects {
    edges {
      node {
        key
        projectId
        avatar {
          large
        }
        name
        projectType
        projectStyle
        isFavourite
        administerProject: action(type: EDIT_PROJECT_CONFIG) {
          canPerform
        }
        createIssues: action(type: CREATE_ISSUES) {
          canPerform
        }
        deleteIssues: action(type: DELETE_ISSUES) {
          canPerform
        }
        editIssues: action(type: EDIT_ISSUES) {
          canPerform
        }
        linkIssues: action(type: LINK_ISSUES) {
          canPerform
        }
        scheduleIssues: action(type: SCHEDULE_ISSUES) {
          canPerform
        }
        transitionIssues: action(type: TRANSITION_ISSUES) {
          canPerform
        }
        viewIssues: action(type: VIEW_ISSUES) {
          canPerform
        }
      }
    }
  }
}
`;


const $4bd5c695609ae115$export$62a5da7e3fa5ff88 = 'JiraWorkManagementGiraOverview';



parcelRegister("l2N2a", function(module, exports) {

$parcel$export(module.exports, "DEPRECATED_DO_NOT_USE_projectDetailsResource", () => $a72df1053ff3c9a0$export$ced53bf9d9551fef);
$parcel$export(module.exports, "useProject_DEPRECATED_DO_NOT_USE", () => $a72df1053ff3c9a0$export$97def3841413167f);
$parcel$export(module.exports, "useMediaConfiguration_DEPRECATED_DO_NOT_USE", () => $a72df1053ff3c9a0$export$a16859df2012e349);
/* eslint-disable camelcase */ 
var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $8s4PA = parcelRequire("8s4PA");
const $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_PROJECT_DETAILS';
const $a72df1053ff3c9a0$export$ced53bf9d9551fef = (0, $2M1hQ.createResource)({
    type: $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY}_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        return (0, $8s4PA.fetchProjectDetails)(cloudId, projectKey, projectId);
    },
    maxAge: 3600000
});
const $a72df1053ff3c9a0$export$97def3841413167f = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($a72df1053ff3c9a0$export$ced53bf9d9551fef);
    return {
        data: data?.currentProject ?? null,
        loading: loading,
        error: error
    };
};
const $a72df1053ff3c9a0$export$a16859df2012e349 = ()=>{
    const { data: data } = (0, $2YP9W.useResource)($a72df1053ff3c9a0$export$ced53bf9d9551fef);
    return data?.media ?? null;
};

});
parcelRegister("8s4PA", function(module, exports) {

$parcel$export(module.exports, "fetchProjectDetails", () => $3400333a67b09775$export$78aa221476efa1c6);

var $j5YhT = parcelRequire("j5YhT");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");


var $2D9kr = parcelRequire("2D9kr");
const $3400333a67b09775$var$EMPTY_VALUE = {
    themeSetting: null,
    media: null
};
const $3400333a67b09775$export$78aa221476efa1c6 = async (cloudId, projectKey, projectId)=>{
    const projectIdOrKey = projectId || projectKey;
    if (!projectIdOrKey) return null;
    try {
        const response = await (0, $eusud.performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
            body: JSON.stringify({
                query: (0, $7ceb2e31b4137f58$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey,
                    usingProjectKey: projectId == null,
                    projectId: projectId != null ? (0, $j5YhT.JiraProjectAri).create({
                        siteId: cloudId,
                        projectId: projectId
                    }).toString() : '',
                    isJiraThemingInRelay: (0, $4R6GH.fg)('jira_theming_relay_migration')
                }
            })
        });
        return (0, $2D9kr.transformData)(response.data, projectIdOrKey);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessProjectDetails', 'Something went wrong while fetching business project details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'projectDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessProjectDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return $3400333a67b09775$var$EMPTY_VALUE;
};

});
const $7ceb2e31b4137f58$var$PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  simplified
  favorite
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;
const $7ceb2e31b4137f58$export$2b91517d6d5b4365 = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!, $isJiraThemingInRelay: Boolean!) {
  jira @skip(if: $isJiraThemingInRelay) {
    mediaClientId(cloudId: $cloudId)
    mediaExternalEndpointUrl(cloudId: $cloudId)
  }
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
    theme: jwmActiveBackgroundByProject(projectIdOrKey: $projectIdOrKey) @skip(if: $isJiraThemingInRelay) {
      __typename
      ... on QueryError {
        identifier
        message
        extensions {
          statusCode
          errorType
        }
      }
      ... on JiraWorkManagementBackground {
        ... on JiraWorkManagementColorBackground {
          colorValue
        }
        ... on JiraWorkManagementGradientBackground {
          gradientValue
        }
        ... on JiraWorkManagementMediaBackground {
          customBackground {
            id
            mediaApiFileId
            mediaReadToken (durationInSeconds: 600)
            sourceType
            sourceIdentifier
            altText
          }
        }
      }
    }
  }
}
${$7ceb2e31b4137f58$var$PROJECT_FRAGMENT}
`;

parcelRegister("2D9kr", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $a9016a2d391e1663$export$3ceb62baab058c6b);

var $4R6GH = parcelRequire("4R6GH");
const $a9016a2d391e1663$var$mapProjectNode = (node)=>{
    if (node == null) return null;
    return {
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.simplified,
        isFavorite: node.favorite === true,
        permissions: {
            administerProject: node.administerProject.canPerform,
            createIssues: node.createIssues.canPerform,
            viewIssues: node.viewIssues.canPerform
        }
    };
};
const $a9016a2d391e1663$var$parseThemeSetting = (data)=>{
    const theme = data?.jwmSidebar?.theme;
    if (theme?.__typename === 'JiraWorkManagementColorBackground') return {
        type: 'color',
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: theme.colorValue
    };
    if (theme?.__typename === 'JiraWorkManagementGradientBackground') return {
        type: 'color',
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: theme.gradientValue
    };
    if (theme?.__typename === 'JiraWorkManagementMediaBackground') {
        const { customBackground: customBackground } = theme;
        const { id: id, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken, sourceType: sourceType, sourceIdentifier: sourceIdentifier, altText: altText } = customBackground;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            type: 'image',
            value: 'image',
            id: id,
            mediaApiFileId: mediaApiFileId,
            mediaReadToken: mediaReadToken,
            sourceType: sourceType,
            sourceIdentifier: sourceIdentifier,
            altText: altText
        };
    }
    return null;
};
const $a9016a2d391e1663$var$parseMediaConfiguration = (data)=>{
    const clientId = data?.jira?.mediaClientId;
    const externalEndpointUrl = data?.jira?.mediaExternalEndpointUrl;
    if (clientId == null || externalEndpointUrl == null) return null;
    return {
        clientId: clientId,
        externalEndpointUrl: externalEndpointUrl
    };
};
const $a9016a2d391e1663$export$3ceb62baab058c6b = (data, projectIdOrKey)=>({
        ...(0, $4R6GH.fg)('jira_theming_relay_migration') ? {} : {
            themeSetting: $a9016a2d391e1663$var$parseThemeSetting(data)
        },
        currentProject: $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ?? $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectById) ?? null,
        projectIdOrKey: projectIdOrKey,
        ...(0, $4R6GH.fg)('jira_theming_relay_migration') ? {} : {
            media: $a9016a2d391e1663$var$parseMediaConfiguration(data)
        }
    });

});



parcelRegister("cSUZZ", function(module, exports) {

$parcel$export(module.exports, "licenseDetailsResource_DEPRECATED_DO_NOT_USE", () => $203c641f0a3380f5$export$92c4069b5349d086);
$parcel$export(module.exports, "useIsPremiumUserSeat", () => $203c641f0a3380f5$export$90749419e9042370);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $9dQKJ = parcelRequire("9dQKJ");
const $203c641f0a3380f5$export$92c4069b5349d086 = (0, $2M1hQ.createResource)({
    type: 'BUSINESS_LICENSE_DETAILS',
    getKey: ()=>'BUSINESS_LICENSE_DETAILS',
    getData: async (_routerContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        return (0, $9dQKJ.fetchLicenseDetails)((0, $2993c3eadd0dda3e$export$2b91517d6d5b4365), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity
});
const $203c641f0a3380f5$export$90749419e9042370 = ()=>{
    const { data: data } = (0, $2YP9W.useResource)($203c641f0a3380f5$export$92c4069b5349d086);
    return Boolean(data?.isPremiumUserSeat);
};

});
const $2993c3eadd0dda3e$export$2b91517d6d5b4365 = `
query JiraBusinessLicenseDetails($cloudId:ID!) {
  jira {
    jwmLicensing(cloudId: $cloudId) {
      currentUserSeatEdition
    }
  }
}
`;

parcelRegister("9dQKJ", function(module, exports) {

$parcel$export(module.exports, "fetchLicenseDetails", () => $164a09ef89830ae9$export$ec058a82eccb31e);

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $164a09ef89830ae9$var$EMPTY_RESPONSE = {
    isPremiumUserSeat: false
};
const $164a09ef89830ae9$export$ec058a82eccb31e = async (query, { cloudId: cloudId })=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        return {
            isPremiumUserSeat: response.data?.jira?.jwmLicensing?.currentUserSeatEdition === 'PREMIUM'
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessLicenseDetails', 'Something went wrong while fetching the license details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $jcw0u.default)({
            meta: {
                id: 'licenseDetailsResource',
                packageName: 'jiraRouterResourcesBusinessLicenseDetails',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $164a09ef89830ae9$var$EMPTY_RESPONSE;
};

});


parcelRegister("aFVvc", function(module, exports) {

$parcel$export(module.exports, "projectCreatePermissionsResource", () => $9880b75bed11d4d0$export$f6c05eaea53ab4ae);
$parcel$export(module.exports, "useProjectCreatePermissionsResource", () => $9880b75bed11d4d0$export$2bd0d3b374549a68);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $9880b75bed11d4d0$var$getDataLoader = ()=>(parcelRequire("dTuZJ"));
const $9880b75bed11d4d0$export$f6c05eaea53ab4ae = (0, $2M1hQ.createResource)({
    type: (0, $acc15b1fbe2101c5$export$8bc44dee8c6d28f),
    getKey: ()=>'state',
    getDataLoader: $9880b75bed11d4d0$var$getDataLoader,
    maxAge: Infinity
});
const $9880b75bed11d4d0$export$2bd0d3b374549a68 = ()=>(0, $2YP9W.useResource)($9880b75bed11d4d0$export$f6c05eaea53ab4ae);

});
const $acc15b1fbe2101c5$export$8bc44dee8c6d28f = 'RESOURCE_TYPE_PROJECT_PERMISSIONS';

parcelRegister("dTuZJ", function(module, exports) {

let $a1d8744defbc7f9d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a1d8744defbc7f9d$var$load("bqWWL").then(()=>parcelRequire('5Yzmr'));

});


parcelRegister("9V5k0", function(module, exports) {

$parcel$export(module.exports, "projectThemeResource", () => $3c09c2af07d8e6b3$export$84730adce8987203);

var $cEpZ8 = parcelRequire("cEpZ8");

var $1nb22 = parcelRequire("1nb22");

var $ao2h1 = parcelRequire("ao2h1");

var $9Yclo = parcelRequire("9Yclo");
const $3c09c2af07d8e6b3$export$84730adce8987203 = (0, $9Yclo.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'JIRA_PROJECT_THEME',
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const { cloudId: cloudId } = tenantContext;
        return {
            parameters: (0, $cEpZ8.default),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectKey ?? projectId ?? ''
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
}));

});
parcelRegister("cEpZ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e482e6cdf4681d7d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a19b0ee1237722cea826fe3e759bd4aa>>
 * @relayHash 3363f5643451362c315aa623a9a6eca6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f053a7beff09849363174d0715005f1055d86b9a61f13d7519b416ad239b2f0c

var $eiowN = parcelRequire("eiowN");
const $e482e6cdf4681d7d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "args": v2 /*: any*/ ,
                "kind": "ScalarField",
                "name": "mediaClientId"
            },
            {
                "args": v2 /*: any*/ ,
                "kind": "ScalarField",
                "name": "mediaExternalEndpointUrl"
            }
        ]
    }, v4 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ThemeSetterQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v3 /*: any*/ ,
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "background",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ThemeSetterBackground"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ThemeSetterQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "background",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraActiveBackgroundDetailsResult"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "colorValue"
                                        }
                                    ],
                                    "type": "JiraColorBackground"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "gradientValue"
                                        }
                                    ],
                                    "type": "JiraGradientBackground"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraCustomBackground",
                                            "kind": "LinkedField",
                                            "name": "customBackground",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "mediaApiFileId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "durationInSeconds",
                                                            "value": 900
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "mediaReadToken",
                                                    "storageKey": "mediaReadToken(durationInSeconds:900)"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "sourceType"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "sourceIdentifier"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "altText"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraMediaBackground"
                                }
                            ]
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "f053a7beff09849363174d0715005f1055d86b9a61f13d7519b416ad239b2f0c",
            "metadata": {},
            "name": "ThemeSetterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e482e6cdf4681d7d$var$node.hash = "9864ab22015f44482ad59ad489f945e0";
(0, $eiowN.PreloadableQueryRegistry).set($e482e6cdf4681d7d$var$node.params.id, $e482e6cdf4681d7d$var$node);
var $e482e6cdf4681d7d$export$2e2bcd8739ae039 = $e482e6cdf4681d7d$var$node;

});

parcelRegister("9Yclo", function(module, exports) {

$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $ee875458deba4a50$export$f4b29e78f4c0a526);
const $ee875458deba4a50$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});



parcelRegister("iBU4N", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesJwmRoute", () => $c7c815cf6f8e49d3$export$4a6781d620bb402);
const $c7c815cf6f8e49d3$export$4a6781d620bb402 = {
    name: 'archived-issues-directory',
    path: '/jira/core/projects/:projectKey/issues/archive',
    exact: true
};

});


parcelRegister("hHcn9", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesRedirectRouteEntry", () => $eb7a8f12766dfa01$export$f7d3667678a21360);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $bkxko = parcelRequire("bkxko");

var $gDHR4 = parcelRequire("gDHR4");
const $eb7a8f12766dfa01$export$f7d3667678a21360 = (0, $7NszV.createEntry)((0, $bkxko.archivedIssuesRedirectRoute), ()=>({
        group: 'archive-issues',
        layout: (0, $gyYxw.genericProjectLayout),
        entryPoint: ()=>(0, $gDHR4.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ]
    }));

});
parcelRegister("bkxko", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesRedirectRoute", () => $65e0e6d0c8ec9fed$export$1bfee70ca366d995);
const $65e0e6d0c8ec9fed$export$1bfee70ca366d995 = {
    name: 'archived-issues-directory',
    path: '/jira/issues/archive',
    exact: true
};

});


parcelRegister("igqAf", function(module, exports) {

$parcel$export(module.exports, "browseProjectRedirectRouteEntry", () => $7846fd35a7cb282e$export$f9891419b34ab305);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $1WlLE = parcelRequire("1WlLE");

var $iN5FK = parcelRequire("iN5FK");

var $7MCPm = parcelRequire("7MCPm");
const $7846fd35a7cb282e$export$f9891419b34ab305 = (0, $7NszV.createEntry)((0, $iN5FK.browseProjectRedirectRoute), ()=>({
        group: 'redirects',
        isRedirect: true,
        component: (0, $7MCPm.RedirectToLastVisitedProjectPage),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $1WlLE.queuesNavigationItems),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
/**
 * @deprecated sharing routes between products leads to over-fetching resources. Please define
 * routes per-product and only define the resources + navigation components required for that product instead.
 */ const $0c2b5b2aa81ed54b$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';
const $0c2b5b2aa81ed54b$export$712453ef44fd2eba = 'GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV';

parcelRegister("hBv66", function(module, exports) {

$parcel$export(module.exports, "genericProjectSidebars", () => $0b920001492d0ef4$export$d88d2d25355bc89a);
$parcel$export(module.exports, "classicBoardSidebars", () => $0b920001492d0ef4$export$c04daf123cec1f1e);
$parcel$export(module.exports, "genericConnectSidebars", () => $0b920001492d0ef4$export$844d342b575ead35);

var $cin8p = parcelRequire("cin8p");

var $dmKXV = parcelRequire("dmKXV");

var $iHiHz = parcelRequire("iHiHz");

var $cOg46 = parcelRequire("cOg46");

var $koWFd = parcelRequire("koWFd");

var $h0bZU = parcelRequire("h0bZU");

var $9s3j1 = parcelRequire("9s3j1");

var $2IHt2 = parcelRequire("2IHt2");
const $0b920001492d0ef4$export$d88d2d25355bc89a = [
    // delete when cleaning up getWillShowNav4
    (0, $dmKXV.default),
    (0, $koWFd.default),
    (0, $h0bZU.default),
    (0, $9s3j1.default),
    (0, $2IHt2.default)
];
const $0b920001492d0ef4$export$c04daf123cec1f1e = [
    (0, $9s3j1.default),
    (0, $2IHt2.default)
];
const $0b920001492d0ef4$export$844d342b575ead35 = [
    ...$0b920001492d0ef4$export$d88d2d25355bc89a,
    (0, $cin8p.default),
    (0, $iHiHz.default),
    (0, $cOg46.default)
];

});
parcelRegister("cin8p", function(module, exports) {

$parcel$export(module.exports, "default", () => $760a63d3e4200cc2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

const $760a63d3e4200cc2$var$LazyConnectSidebar = (0, $b7Svb.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("aoq5h")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/connect/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $760a63d3e4200cc2$var$ConnectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "connect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($760a63d3e4200cc2$var$LazyConnectSidebar, null)));
$760a63d3e4200cc2$var$ConnectSidebar.displayName = 'ConnectSidebar';
var $760a63d3e4200cc2$export$2e2bcd8739ae039 = $760a63d3e4200cc2$var$ConnectSidebar;

});
parcelRegister("aoq5h", function(module, exports) {

let $79106110966e33bf$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $79106110966e33bf$var$load("h2MrD"),
    $79106110966e33bf$var$load("bYT2S"),
    $79106110966e33bf$var$load("cM9em"),
    $79106110966e33bf$var$load("fr9NE"),
    $79106110966e33bf$var$load("a8u2l")
]).then(()=>parcelRequire('caET0'));

});


parcelRegister("iHiHz", function(module, exports) {

$parcel$export(module.exports, "default", () => $883820dc444dc59c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

const $883820dc444dc59c$var$LazyGlobalAppsSettingsSidebar = (0, $b7Svb.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("gZExY")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-apps/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $883820dc444dc59c$var$GlobalAppsSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalAppsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($883820dc444dc59c$var$LazyGlobalAppsSettingsSidebar, null)));
$883820dc444dc59c$var$GlobalAppsSettingsSidebar.displayName = 'GlobalAppsSettingsSidebar';
var $883820dc444dc59c$export$2e2bcd8739ae039 = $883820dc444dc59c$var$GlobalAppsSettingsSidebar;

});
parcelRegister("gZExY", function(module, exports) {

let $c5f1cba21c0a420f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c5f1cba21c0a420f$var$load("h2MrD"),
    $c5f1cba21c0a420f$var$load("bYT2S"),
    $c5f1cba21c0a420f$var$load("cM9em"),
    $c5f1cba21c0a420f$var$load("fr9NE"),
    $c5f1cba21c0a420f$var$load("3EO4A")
]).then(()=>parcelRequire('kO26e'));

});


parcelRegister("2IHt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8627747b0236ab96$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

const $8627747b0236ab96$var$LazyUserSidebar = (0, $b7Svb.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("arXlp")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/user/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8627747b0236ab96$var$UserSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "user"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8627747b0236ab96$var$LazyUserSidebar, null)));
$8627747b0236ab96$var$UserSidebar.displayName = 'UserSidebar';
var $8627747b0236ab96$export$2e2bcd8739ae039 = $8627747b0236ab96$var$UserSidebar;

});
parcelRegister("arXlp", function(module, exports) {

let $79ba758f689778fa$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $79ba758f689778fa$var$load("hPzOn"),
    $79ba758f689778fa$var$load("eNmuD"),
    $79ba758f689778fa$var$load("h2MrD"),
    $79ba758f689778fa$var$load("bYT2S"),
    $79ba758f689778fa$var$load("cM9em"),
    $79ba758f689778fa$var$load("fr9NE"),
    $79ba758f689778fa$var$load("36IoX")
]).then(()=>parcelRequire('3AQ56'));

});



parcelRegister("1WlLE", function(module, exports) {

$parcel$export(module.exports, "queuesNavigationItems", () => $c68314f43531feff$export$4fed8be571897bef);
$parcel$export(module.exports, "priorityGroupResource", () => $c68314f43531feff$export$1f9ab301771fe42e);
$parcel$export(module.exports, "priorityGroupByProjectIdResource", () => $c68314f43531feff$export$f6133a181a1ec201);
$parcel$export(module.exports, "issueListSsrResource", () => $c68314f43531feff$export$3d03cbaac8581e65);

var $9XE6b = parcelRequire("9XE6b");

var $jcw0u = parcelRequire("jcw0u");


var $jthxb = parcelRequire("jthxb");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $8w6CZ = parcelRequire("8w6CZ");

var $fRrvi = parcelRequire("fRrvi");

const $c68314f43531feff$var$getDataLoader = ()=>(parcelRequire("17Fyq"));

const $c68314f43531feff$var$getPriorityGroupDataLoader = ()=>(parcelRequire("5u46E"));

const $c68314f43531feff$var$fetchIssueListDataLoader = ()=>(parcelRequire("57gkn"));
const $c68314f43531feff$var$getCombinedProjectKeyAndQueueId = ({ match: match, query: query })=>`${(0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0]}-${(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.queueId', '')}`;
const $c68314f43531feff$export$4fed8be571897bef = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
    getKey: ({ match: match, query: query })=>// projectKey from url path/query or browse/{issueKey}
        (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $c68314f43531feff$var$getDataLoader,
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS)
});
const $c68314f43531feff$export$1f9ab301771fe42e = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $c68314f43531feff$var$getPriorityGroupDataLoader,
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS),
    /**
	 * This resource will not load in SSR. Because priority group data resides in the JSM Kukama microservice.
	 * If we wanna fetch this resource during SSR, the request we're making from Tesseract -> Kukama is S2S, where Tesseract needs to know cookies information.
	 * We initially skipped SSR for fetching this resource, because we couldn’t retrieve the request cookie from JFE.
	 * Iiuc, the Jira team doesnt doesnt support this due to security concerns (the info is from JSM Queues team).
	 */ isBrowserOnly: true
});
const $c68314f43531feff$export$f6133a181a1ec201 = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS_BY_PROJECT_ID),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
    getData: async ({ match: match, query: query, dependencies: dependencies }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const { projectId: projectId } = await (0, $jthxb.consumeDependency)(dependencies, (0, $0f463a88567f1621$export$80a60a092d9ab81));
            return (0, $fRrvi.getPriorityGroupDataByProjectId)(projectId, projectKey, cloudId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchProjectContextError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $fRrvi.getPriorityGroupDataByProjectId)(undefined, projectKey, cloudId);
        }
    },
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS),
    isBrowserOnly: true,
    depends: [
        (0, $0f463a88567f1621$export$80a60a092d9ab81)
    ]
});
const $c68314f43531feff$export$3d03cbaac8581e65 = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR),
    getKey: $c68314f43531feff$var$getCombinedProjectKeyAndQueueId,
    getDataLoader: $c68314f43531feff$var$fetchIssueListDataLoader,
    maxAge: 0,
    // run this resource from server only
    skipBrowser: true
});

});
parcelRegister("jthxb", function(module, exports) {

$parcel$export(module.exports, "consumeDependency", () => $c406e66b8b597668$export$a973ef9e17a326f);
async function $c406e66b8b597668$export$a973ef9e17a326f(dependencies, key) {
    // There is an inflight request, the response is source of truth
    if (dependencies[key]?.loading) return dependencies[key]?.promise;
    if (dependencies[key]?.error) // Our dependency errored out the last time it ran, we don't have the data
    throw dependencies[key]?.error;
    // Last response is what we want
    return dependencies[key]?.data;
}

});

parcelRegister("8w6CZ", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", () => $a4c66eaf20e13a4d$export$a401e6d6b205c72b);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", () => $a4c66eaf20e13a4d$export$2064262c540606ba);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS_BY_PROJECT_ID", () => $a4c66eaf20e13a4d$export$efa043b0bbc0ab6d);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR", () => $a4c66eaf20e13a4d$export$2733615da5b906f0);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $a4c66eaf20e13a4d$export$5a00268156ea5027);
const $a4c66eaf20e13a4d$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
const $a4c66eaf20e13a4d$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
const $a4c66eaf20e13a4d$export$efa043b0bbc0ab6d = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS_BY_PROJECT_ID';
const $a4c66eaf20e13a4d$export$2733615da5b906f0 = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';
const $a4c66eaf20e13a4d$export$5a00268156ea5027 = 86400000;

});

parcelRegister("fRrvi", function(module, exports) {

$parcel$export(module.exports, "getPriorityGroupDataByProjectId", () => $2d01df2d1057a1ad$export$cf2bd2ec601ed920);

var $fn8B5 = parcelRequire("fn8B5");

var $lAOer = parcelRequire("lAOer");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");
const $2d01df2d1057a1ad$var$fetchGroupsByKey = async (projectKey, cloudId)=>{
    return (0, $7f4tk.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectIdOrKey=${projectKey}`);
};
const $2d01df2d1057a1ad$var$fetchGroupsById = async (projectId, cloudId)=>{
    return (0, $7f4tk.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectId=${projectId}`);
};
const $2d01df2d1057a1ad$export$cf2bd2ec601ed920 = async (projectId, projectKey, cloudId)=>{
    const fetchStartTime = performance.now();
    let data;
    if (projectId) {
        data = await $2d01df2d1057a1ad$var$fetchGroupsById(projectId, cloudId);
        (0, $lAOer.addSpanToAll)('fetch', 'fetchPriorityGroupsByProjectId', [
            {
                name: 'network'
            }
        ], fetchStartTime, performance.now());
    } else {
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchPriorityGroupsProjectIdUndefined',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        data = await $2d01df2d1057a1ad$var$fetchGroupsByKey(projectKey, cloudId);
        (0, $lAOer.addSpanToAll)('fetch', 'fetchPriorityGroups', [
            {
                name: 'network'
            }
        ], fetchStartTime, performance.now());
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const processedData = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(data.results.map((group)=>({
            ...group,
            queues: group.queueIds || []
        })), 'category'); // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return processedData;
};

});
parcelRegister("fn8B5", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/** Used for built-in method references. */ var $b30fac385487af61$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b30fac385487af61$var$hasOwnProperty = $b30fac385487af61$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $b30fac385487af61$var$groupBy = $4CZTG(function(result, value, key) {
    if ($b30fac385487af61$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $1m3dq(result, key, [
        value
    ]);
});
module.exports = $b30fac385487af61$var$groupBy;

});


parcelRegister("17Fyq", function(module, exports) {

let $0d16adb72e72a0d2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0d16adb72e72a0d2$var$load("eNmuD"),
    $0d16adb72e72a0d2$var$load("fYHqp")
]).then(()=>parcelRequire('lini2'));

});

parcelRegister("5u46E", function(module, exports) {

let $3fe2f07d36e8f0eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3fe2f07d36e8f0eb$var$load("2mLKW").then(()=>parcelRequire('etJR3'));

});

parcelRegister("57gkn", function(module, exports) {

let $3b9a45894e4111de$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3b9a45894e4111de$var$load("jmkWj").then(()=>parcelRequire('bmzqI'));

});


parcelRegister("iN5FK", function(module, exports) {

$parcel$export(module.exports, "browseProjectRedirectRoute", () => $84aa7aa5982a6e60$export$f9cac37753487f39);
const $84aa7aa5982a6e60$export$f9cac37753487f39 = {
    name: 'browse-project-redirect',
    path: "/browse/:projectKey([0-9a-zA-Z_$.+!*']+)",
    exact: true
};

});

parcelRegister("7MCPm", function(module, exports) {

$parcel$export(module.exports, "RedirectToLastVisitedProjectPage", () => $4c121c4cc7d1faa6$export$86041af020f4c959);

var $5uXOq = parcelRequire("5uXOq");

var $hqxtv = parcelRequire("hqxtv");
const $4c121c4cc7d1faa6$export$86041af020f4c959 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hqxtv.default), null);

});
parcelRegister("hqxtv", function(module, exports) {

$parcel$export(module.exports, "default", () => $bda9d95137e1a17a$export$2e2bcd8739ae039);

var $1bQGJ = parcelRequire("1bQGJ");

var $aNBa3 = parcelRequire("aNBa3");
var $bda9d95137e1a17a$export$2e2bcd8739ae039 = (0, $1bQGJ.withRouter)((0, $aNBa3.default));

});
parcelRegister("aNBa3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d9c467899b3389b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $ebyGx = parcelRequire("ebyGx");

var $8iquX = parcelRequire("8iquX");

var $fDtbf = parcelRequire("fDtbf");

var $kUU4G = parcelRequire("kUU4G");

var $4Pf62 = parcelRequire("4Pf62");

var $dJl1T = parcelRequire("dJl1T");

var $7f4tk = parcelRequire("7f4tk");


var $ebbSc = parcelRequire("ebbSc");
const $8d9c467899b3389b$var$buildEndpoint = (projectKey, initialRedirect)=>`/rest/internal/2/projectlandingpage/${projectKey}${initialRedirect ? '?initialRedirect=true' : ''}`;
const $8d9c467899b3389b$var$allowListedSearchParams = [
    (0, $0592ef8772eedefd$export$29d3926e3d72cfb),
    (0, $0592ef8772eedefd$export$b3233b76460c1e7c)
];
const $8d9c467899b3389b$var$redirectForAnonymousUser = (projectKey, history, startTime)=>{
    const destination = `/projects/${projectKey}/issues/?filter=allissues`;
    history.replace(destination);
    // Log success
    (0, $dJl1T.default).safeInfoWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), 'History replace correctly triggered for anonymous user', {
        requestTime: (0, $ebbSc.getNow)() - startTime,
        destination: destination
    });
};
const $8d9c467899b3389b$export$c79af62ad7a1fe8a = (query)=>Object.fromEntries(Object.entries(query).filter(([key])=>$8d9c467899b3389b$var$allowListedSearchParams.some((allowedParam)=>key === allowedParam) || key.includes((0, $0592ef8772eedefd$export$29d3926e3d72cfb))));
const $8d9c467899b3389b$export$283f1587d7a5369f = (searchQuery, queryInitializer)=>{
    const queryKeys = new URLSearchParams(searchQuery).toString();
    return queryKeys.length > 0 ? `${queryInitializer}${queryKeys}` : '';
};
class $8d9c467899b3389b$export$bf8d1fdc3b47a835 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { history: history, location: location, query: query, match: { params: params } } = this.props;
        // First time a project is created
        const { initial: initial } = query;
        // Clear the SSR Ready Mark if present
        (0, $kUU4G.default)((0, $fDtbf.SPA_SSR_RENDERED_MARK));
        const startTime = (0, $ebbSc.getNow)();
        const projectKey = // @ts-expect-error - TS2345 - Argument of type 'string | {}' is not assignable to parameter of type 'string'.
        params.projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(location, 'search', {})).projectKey;
        if (!params.projectKey) (0, $dJl1T.default).safeInfoWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), 'queryString', {
            duration: (0, $ebbSc.getNow)() - startTime
        });
        if (projectKey) (0, $7f4tk.default)($8d9c467899b3389b$var$buildEndpoint(projectKey, !!initial)).then((response)=>{
            const endTime = (0, $ebbSc.getNow)();
            let searchQueryParams = '';
            const searchQuery = $8d9c467899b3389b$export$c79af62ad7a1fe8a(query);
            const queryInitializer = response.data.url.includes('?') ? '&' : '?';
            searchQueryParams = $8d9c467899b3389b$export$283f1587d7a5369f(searchQuery, queryInitializer);
            const destination = response.data.url + searchQueryParams;
            history.replace(destination);
            // Log success
            (0, $dJl1T.default).safeInfoWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), 'History replace correctly triggered', {
                requestTime: endTime - startTime,
                destination: destination
            });
        }, (error)=>{
            const endTime = (0, $ebbSc.getNow)();
            if ((0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)().isAnonymous) $8d9c467899b3389b$var$redirectForAnonymousUser(projectKey, history, startTime);
            else // Log failures
            (0, $dJl1T.default).safeErrorWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), `Error on request. Request time: ${endTime - startTime}`, error);
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iquX.default), {
            name: "last-visited-project-page-redirect"
        });
    }
}
var $8d9c467899b3389b$export$2e2bcd8739ae039 = $8d9c467899b3389b$export$bf8d1fdc3b47a835;

});
const $0592ef8772eedefd$export$25a759e49d5049db = 'spa-apps.common.redirect.last-visited-project-page';
const $0592ef8772eedefd$export$29d3926e3d72cfb = 'search';
const $0592ef8772eedefd$export$b3233b76460c1e7c = 'showProjectBuilder';

parcelRegister("ebbSc", function(module, exports) {

$parcel$export(module.exports, "getNow", () => $fa5a995d36ebfbde$export$3991332aae1fc754);
const $fa5a995d36ebfbde$export$3991332aae1fc754 = ()=>Date.now();

});





parcelRegister("gm7fA", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessAttachmentsRouteEntry", () => $dfc0a30c9444e0ae$export$62c45d8ff658b6c2);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bokkA = parcelRequire("bokkA");

var $6DXrm = parcelRequire("6DXrm");

var $lkFvK = parcelRequire("lkFvK");

var $fo6b8 = parcelRequire("fo6b8");
const $dfc0a30c9444e0ae$var$attachmentsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6DXrm.attachmentsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $dfc0a30c9444e0ae$export$62c45d8ff658b6c2 = (0, $7NszV.createEntry)((0, $bokkA.jiraBusinessAttachmentsRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.attachments-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        entryPoint: ()=>$dfc0a30c9444e0ae$var$attachmentsPageEntryPoint,
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)()
    }));

});
parcelRegister("lRPBw", function(module, exports) {

$parcel$export(module.exports, "businessProjectLayout", () => $d0bc40d3dc70d875$export$dfb0c3e0348f4429);

var $2vSU6 = parcelRequire("2vSU6");

var $1Du13 = parcelRequire("1Du13");

var $aPfsS = parcelRequire("aPfsS");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d0bc40d3dc70d875$var$Onboarding = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("kVeWE")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/onboarding/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d0bc40d3dc70d875$var$withAnyBusinessProjectContext = (Component)=>(0, $aPfsS.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $2vSU6.CORE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d0bc40d3dc70d875$var$RightSidebars = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("89Lf0")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/right-sidebars/index.tsx"
});
const $d0bc40d3dc70d875$var$BusinessOnboarding = $d0bc40d3dc70d875$var$withAnyBusinessProjectContext($d0bc40d3dc70d875$var$Onboarding);
const $d0bc40d3dc70d875$var$nonSettingsRightSidebars = [
    $d0bc40d3dc70d875$var$withAnyBusinessProjectContext($d0bc40d3dc70d875$var$RightSidebars)
];
const $d0bc40d3dc70d875$var$sharedBusinessProjectLayout = (0, $aPfsS.composeLayouts)((0, $1Du13.projectLayout));
const $d0bc40d3dc70d875$export$dfb0c3e0348f4429 = (0, $aPfsS.composeLayouts)($d0bc40d3dc70d875$var$sharedBusinessProjectLayout, {
    rightSidebars: $d0bc40d3dc70d875$var$nonSettingsRightSidebars,
    globalComponents: [
        $d0bc40d3dc70d875$var$BusinessOnboarding
    ]
});

});
parcelRegister("kVeWE", function(module, exports) {

let $f3b4b94af41847b5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f3b4b94af41847b5$var$load("8VawK").then(()=>parcelRequire('3PxNF'));

});

parcelRegister("89Lf0", function(module, exports) {

let $5f03cf0d9f7bc7c9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5f03cf0d9f7bc7c9$var$load("b2COn").then(()=>parcelRequire('lktzL'));

});


parcelRegister("aVFIE", function(module, exports) {

$parcel$export(module.exports, "ThemedLazySkeleton", () => $136611be2ae39444$export$ddeb5d943c4f17e3);
/* ThemedLazySkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8iquX = parcelRequire("8iquX");

var $lob44 = parcelRequire("lob44");
const $136611be2ae39444$export$ddeb5d943c4f17e3 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($136611be2ae39444$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iquX.default), {
        name: "themed-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lob44.ThemedSpinner), null))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $136611be2ae39444$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1osq _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lob44", function(module, exports) {

$parcel$export(module.exports, "ThemedSpinner", () => $150e941eee16207a$export$271c7b154ad6c401);
/* ThemedSpinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $clxo5 = parcelRequire("clxo5");
const $150e941eee16207a$export$271c7b154ad6c401 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($150e941eee16207a$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
        size: "large",
        ...props,
        testId: "project-theme-components.ui.themed-spinner"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $150e941eee16207a$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1xjgvy9e",
            __cmplp.className
        ])
    });
});

});


parcelRegister("bokkA", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessAttachmentsRoute", () => $8ee02e904721e8ab$export$81237c0b791e592e);
const $8ee02e904721e8ab$export$81237c0b791e592e = {
    name: 'classic-business-attachments',
    path: '/jira/core/projects/:projectKey/attachments'
};

});

parcelRegister("6DXrm", function(module, exports) {

$parcel$export(module.exports, "attachmentsEntryPoint", () => $5488b7c894698968$export$d94bafd9d893ec98);

var $e31y9 = parcelRequire("e31y9");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $5488b7c894698968$export$d94bafd9d893ec98 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("3aI5O")), {
        moduleId: "26a1d436"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        // This entry point should only load in this route
        // once overview is supported by backend, we should have a different entry point for it
        const { projectKey: projectKey } = context.match.params;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            queries: {
                jwmAttachmentsQuery: {
                    parameters: $e31y9.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: projectKey,
                        projectKeys: [
                            projectKey
                        ],
                        filters: {
                            fileName: '',
                            authorIds: [],
                            mimeTypes: [],
                            dateRange: {
                                before: undefined,
                                after: undefined
                            }
                        },
                        durationInSeconds: 900,
                        maxTokenLength: 65534,
                        attachmentCount: 100
                    },
                    options: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fetchPolicy: 'network-only'
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        };
    }
});

});
parcelRegister("e31y9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6955691f2f41efa8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<27cf8d4c8476b55ad0214615c4321597>>
 * @relayHash c6e9983b2d202d37d436585f73068bb1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c2e6d7f1e46fae7f20940e5f2d25270db884f9c4ffb727bc5ca1be7cef02546
const $6955691f2f41efa8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "9c2e6d7f1e46fae7f20940e5f2d25270db884f9c4ffb727bc5ca1be7cef02546",
        "metadata": {},
        "name": "src_jiraBusinessAttachmentsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6955691f2f41efa8$export$2e2bcd8739ae039 = $6955691f2f41efa8$var$node;

});

parcelRegister("3aI5O", function(module, exports) {

let $24f48227ecb7344b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $24f48227ecb7344b$var$load("hg0ML").then(()=>parcelRequire('hLT0c'));

});



parcelRegister("gbj7F", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardEmbedRouteEntry", () => $0142438b20a4e9a9$export$7a97e5e258f37b2a);

var $6e4Kt = parcelRequire("6e4Kt");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $d8VYe = parcelRequire("d8VYe");

var $lNicp = parcelRequire("lNicp");

var $0sAwf = parcelRequire("0sAwf");

var $93hm0 = parcelRequire("93hm0");
const $0142438b20a4e9a9$export$7a97e5e258f37b2a = (0, $7NszV.createEntry)((0, $0sAwf.jiraBusinessBoardEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-board-embed',
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: [
            ...(0, $lNicp.getProjectViewResources)(),
            (0, $d8VYe.workflowIssuesResource)
        ],
        entryPoint: ()=>(0, $93hm0.boardEmbedPageEntryPoint)
    }));

});
parcelRegister("6e4Kt", function(module, exports) {

$parcel$export(module.exports, "chromelessLayout", () => $c3106f352857c22e$export$17e73ed8c35891cb);

var $aPfsS = parcelRequire("aPfsS");
const $c3106f352857c22e$export$17e73ed8c35891cb = (0, $aPfsS.createLayout)({
    isChromeless: true
});

});

parcelRegister("d8VYe", function(module, exports) {

$parcel$export(module.exports, "workflowIssuesResource", () => $6a9e21653771d63a$export$49027035af709702);
$parcel$export(module.exports, "useWorkflowIssues", () => $6a9e21653771d63a$export$86b7de71bf71360d);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $9YrR3 = parcelRequire("9YrR3");
const $6a9e21653771d63a$var$RESOURCE_TYPE_KEY = 'BUSINESS_WORKFLOW_ISSUES';

const $6a9e21653771d63a$export$49027035af709702 = (0, $2M1hQ.createResource)({
    type: $6a9e21653771d63a$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$6a9e21653771d63a$var$RESOURCE_TYPE_KEY}_${projectKey}_${matchedRoute.match?.params?.itemId ?? 'default'}`;
    },
    getDataLoader: ()=>Promise.resolve((parcelRequire("9YrR3"))),
    getData: (0, $9YrR3.default),
    maxAge: 1000,
    isBrowserOnly: true
});
const $6a9e21653771d63a$export$86b7de71bf71360d = ()=>// forcing the return type due to react-resource-router's weird error types
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $2YP9W.useResource)($6a9e21653771d63a$export$49027035af709702);

});
parcelRegister("9YrR3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $465154b480a996b2$export$2e2bcd8739ae039);

var $7juH2 = parcelRequire("7juH2");

var $x9xyg = parcelRequire("x9xyg");

var $jJZqs = parcelRequire("jJZqs");

var $8PRuf = parcelRequire("8PRuf");

var $iR3GG = parcelRequire("iR3GG");
const $465154b480a996b2$var$EMPTY_DATA = {
    workflows: [],
    lastChangedTime: null
};
function $465154b480a996b2$var$getEarlyPreload() {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const earlyPreloadPromise = window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__ = null;
        return earlyPreloadPromise.then((response)=>{
            if (!response.success) {
                if (response.error.status === 304) throw new (0, $7juH2.Unchanged)('Workflow issues have not changed since the last request');
                throw new (0, $jJZqs.default)(response.error.status);
            }
            return {
                workflows: response.workflows,
                lastChangedTime: null
            };
        });
    }
    return null;
}
function $465154b480a996b2$var$fetchData({ projectKey: projectKey, itemId: itemId }) {
    const earlyPreload = $465154b480a996b2$var$getEarlyPreload();
    if (earlyPreload !== null) return earlyPreload;
    return (0, $7juH2.fetchWorkflowIssues)({
        projectKey: projectKey,
        itemId: itemId
    });
}
async function $465154b480a996b2$export$2e2bcd8739ae039({ match: match }, { tenantContext: tenantContext }) {
    const { isAnonymous: isAnonymous } = tenantContext;
    if (isAnonymous) return $465154b480a996b2$var$EMPTY_DATA;
    try {
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiStartMark));
        const workflows = await $465154b480a996b2$var$fetchData({
            projectKey: match.params.projectKey ?? '',
            itemId: match.params.itemId ?? undefined
        });
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return workflows;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.business.board-workflows.getData',
            message: 'An error was thrown while prefetching board data',
            name: 'ResourceError'
        }, error);
    }
}

});
parcelRegister("7juH2", function(module, exports) {

$parcel$export(module.exports, "Unchanged", () => $16e71a1b1f979cb0$export$eccd6db33b8f6a89);
$parcel$export(module.exports, "fetchWorkflowIssues", () => $16e71a1b1f979cb0$export$17e2e8212d93f58d);

var $gKZoD = parcelRequire("gKZoD");


var $gN11a = parcelRequire("gN11a");

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");
class $16e71a1b1f979cb0$export$eccd6db33b8f6a89 extends Error {
}
const $16e71a1b1f979cb0$export$17e2e8212d93f58d = async ({ projectKey: projectKey, itemId: itemId, ifChangedSince: ifChangedSince })=>{
    (0, $gKZoD.di)(fetch);
    try {
        (0, $gN11a.markViewMetric)('jwm-board', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
        let url = `/rest/board-api/1/board/${projectKey}/workflows?excludeLabels=true`;
        if (itemId) url += `&viewItemId=${itemId}`;
        const defaultOptions = (0, $5HnTq.getDefaultOptions)(url);
        const response = await fetch(url, {
            ...defaultOptions,
            headers: {
                ...defaultOptions.headers,
                ...ifChangedSince ? {
                    'x-aif-changed-since': ifChangedSince
                } : undefined
            }
        });
        if (!response.ok) {
            if (response.status === 304) throw new $16e71a1b1f979cb0$export$eccd6db33b8f6a89('Workflow issues have not changed since the last request');
            throw new (0, $jJZqs.default)(response.status);
        }
        const lastChangedTime = response.headers.get('x-alast-changed-time');
        const workflows = await response.json();
        return {
            workflows: workflows.data,
            lastChangedTime: lastChangedTime
        };
    } finally{
        (0, $gN11a.markViewMetric)('jwm-board', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
    }
};

});
const $a286480ec63fa4c8$export$747aad128920134d = 3000;
const $a286480ec63fa4c8$export$e4f8d353742c04ac = 4000;
const $a286480ec63fa4c8$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $a286480ec63fa4c8$export$23e322eb7c526958 = 'REQUEST_START';
const $a286480ec63fa4c8$export$83ca21a50372ea3b = 'REQUEST_END';
const $a286480ec63fa4c8$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $a286480ec63fa4c8$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $a286480ec63fa4c8$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $a286480ec63fa4c8$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $a286480ec63fa4c8$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $a286480ec63fa4c8$export$88ea1e280513690f = 'UI_RENDER_END';

parcelRegister("gN11a", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetrics", () => $f9c6206c3cbbca63$export$2878bf482e539059);
$parcel$export(module.exports, "markViewMetric", () => $f9c6206c3cbbca63$export$8d15b4fb25f90514);

var $2nKjG = parcelRequire("2nKjG");

const $f9c6206c3cbbca63$var$slo = {
    fmp: {
        initial: {
            threshold: (0, $a286480ec63fa4c8$export$747aad128920134d)
        },
        transition: {
            threshold: (0, $a286480ec63fa4c8$export$747aad128920134d)
        }
    },
    tti: {
        initial: {
            threshold: (0, $a286480ec63fa4c8$export$e4f8d353742c04ac)
        },
        transition: {
            threshold: (0, $a286480ec63fa4c8$export$e4f8d353742c04ac)
        }
    }
};
const $f9c6206c3cbbca63$var$timings = [
    {
        key: (0, $a286480ec63fa4c8$export$540ffd289e5e0562),
        startMark: (0, $a286480ec63fa4c8$export$23e322eb7c526958),
        endMark: (0, $a286480ec63fa4c8$export$83ca21a50372ea3b)
    },
    {
        key: (0, $a286480ec63fa4c8$export$821ca6ff41f300ec),
        startMark: (0, $a286480ec63fa4c8$export$7b887ee35f2b465e),
        endMark: (0, $a286480ec63fa4c8$export$ac953882305d6102)
    },
    {
        key: (0, $a286480ec63fa4c8$export$7f7f60b5526c5ee3),
        startMark: (0, $a286480ec63fa4c8$export$b78f0bbf209e5f4),
        endMark: (0, $a286480ec63fa4c8$export$88ea1e280513690f)
    }
];
const $f9c6206c3cbbca63$export$2878bf482e539059 = {
    'approvals-view': (0, $2nKjG.metrics).pageLoad({
        key: 'jwm.approvals-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    summary: (0, $2nKjG.metrics).pageLoad({
        key: 'jwm.summary-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'summary-embed': (0, $2nKjG.metrics).pageLoad({
        key: 'jwm.summary-view-embed',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    list: (0, $2nKjG.metrics).pageLoad({
        key: 'jwm.list-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'list-embed': (0, $2nKjG.metrics).pageLoad({
        key: 'jwm.list-embed-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'software-form-submit-embed': (0, $2nKjG.metrics).pageLoad({
        key: 'jsw.form-submit-embed',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'software-list': (0, $2nKjG.metrics).pageLoad({
        key: 'jsw.list-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'software-list-embed': (0, $2nKjG.metrics).pageLoad({
        key: 'jsw.list-view-embed',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    timeline: (0, $2nKjG.metrics).pageLoad({
        key: 'jwm.timeline-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'timeline-embed': (0, $2nKjG.metrics).pageLoad({
        key: 'jwm.timeline-embed-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    calendar: (0, $2nKjG.metrics).pageLoad({
        key: 'jwm.calendar-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'calendar-embed': (0, $2nKjG.metrics).pageLoad({
        key: 'jwm.calendar-embed-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    form: (0, $2nKjG.metrics).pageLoad({
        key: 'jwm.form-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'form-submit': (0, $2nKjG.metrics).pageLoad({
        key: 'jwm.form-submit-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'form-submit-embed': (0, $2nKjG.metrics).pageLoad({
        key: 'jwm.form-submit-embed-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'form-submit-public': (0, $2nKjG.metrics).pageLoad({
        key: 'jwm.form-submit-public-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'form-directory': (0, $2nKjG.metrics).pageLoad({
        key: 'jwm.form-directory-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    board: (0, $2nKjG.metrics).pageLoad({
        key: 'jwm.board-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'jwm-board': (0, $2nKjG.metrics).pageLoad({
        key: 'jwm.jwm-board',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'jwm-board-embed': (0, $2nKjG.metrics).pageLoad({
        key: 'jwm.jwm-board-embed',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'jwm-pages': (0, $2nKjG.metrics).pageLoad({
        key: 'jwm.jwm-pages',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    // TODO: will be removed with sploverview-decouple-calendar-perf-metrics
    'software-plan-calendar': (0, $2nKjG.metrics).pageLoad({
        key: 'jsw.plan-calendar-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    })
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f9c6206c3cbbca63$var$startedMarks = {};
const $f9c6206c3cbbca63$export$8d15b4fb25f90514 = (view, mark)=>{
    const markKey = `${view}-${mark}`;
    // prevent overriding marks when markViewMetric() is called many times with the same param
    if ($f9c6206c3cbbca63$var$startedMarks[markKey]) return;
    $f9c6206c3cbbca63$var$startedMarks[markKey] = true;
    const metric = $f9c6206c3cbbca63$export$2878bf482e539059[view];
    metric?.mark(mark);
};

});


parcelRegister("8PRuf", function(module, exports) {

$parcel$export(module.exports, "appBundleReadyMark", () => $0ec5205bf4957ca4$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $0ec5205bf4957ca4$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $0ec5205bf4957ca4$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $0ec5205bf4957ca4$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $0ec5205bf4957ca4$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $0ec5205bf4957ca4$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $0ec5205bf4957ca4$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $0ec5205bf4957ca4$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $0ec5205bf4957ca4$export$4eb8d44ddb14424a);


var $hXKq5 = parcelRequire("hXKq5");
const $0ec5205bf4957ca4$export$7e50945a65dd40e = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ff834eccc35b9089));
const $0ec5205bf4957ca4$export$17cbe723d23101d8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$86b05e34d462ead8));
const $0ec5205bf4957ca4$export$887fadb22e7c7735 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$d6a604a7d9a390fb));
const $0ec5205bf4957ca4$export$bd099c0a906f4b3f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$3ae43cc1782d058f));
const $0ec5205bf4957ca4$export$d23ef9e7633e30e7 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$363f6703ffa600be));
const $0ec5205bf4957ca4$export$319da6d901948a6d = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$e87b74567b79c8));
const $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$99fe642459a8b02));
const $0ec5205bf4957ca4$export$37e82663aa1e79a8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ab1f5705fc8e0571));
const $0ec5205bf4957ca4$export$21146514eacceb12 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$8c3a9046da692c35));
const $0ec5205bf4957ca4$export$4eb8d44ddb14424a = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$5aa497d1efdcc5bf));

});

parcelRegister("iR3GG", function(module, exports) {

$parcel$export(module.exports, "createResourceError", () => $d895341acba1e817$export$13487d18466bc8a5);

var $dJl1T = parcelRequire("dJl1T");
class $d895341acba1e817$var$ResourceErrorClass extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $d895341acba1e817$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $d895341acba1e817$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});



parcelRegister("0sAwf", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardEmbedRoute", () => $143b8615692fbb7d$export$bd75a810572fe27d);
const $143b8615692fbb7d$export$bd75a810572fe27d = {
    name: 'classic-business-board-embed',
    path: '/jira/core/projects/:projectKey/board/embed',
    exact: true
};

});

parcelRegister("93hm0", function(module, exports) {

$parcel$export(module.exports, "boardEmbedPageEntryPoint", () => $b8780d447378502c$export$5046daadb8899791);

var $lkFvK = parcelRequire("lkFvK");

var $9715X = parcelRequire("9715X");
const $b8780d447378502c$export$5046daadb8899791 = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $9715X.boardEmbedEntryPoint)
});

});
parcelRegister("9715X", function(module, exports) {

$parcel$export(module.exports, "boardEmbedEntryPoint", () => $302c841aa900e4ab$export$416ba69e2e054935);

var $kCyK0 = parcelRequire("kCyK0");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $302c841aa900e4ab$export$416ba69e2e054935 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("6JivU")), {
        moduleId: "c853cc44"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        const itemId = context.match.params.itemId ?? '';
        let filterJql = context.query?.filter;
        let groupBy = context.query?.groupBy;
        // if in a client environment, check whether the router url matches the current window pathname
        // if it does, use the filter and groupBy from the current window location instead of the router query
        // this avoids reloading the query without the overrides when a user hovers over prefetching links that don't include them
        if (typeof window !== 'undefined' && window.location.pathname === context.match.url) {
            const searchParams = new URLSearchParams(window.location.search);
            filterJql = searchParams.get('filter') ?? undefined;
            groupBy = searchParams.get('groupBy') ?? undefined;
        }
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                boardEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $kCyK0.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        viewInput: {
                            jiraBoardViewQueryInput: {
                                projectKeyAndItemIdQuery: {
                                    cloudId: cloudId,
                                    projectKey: projectKey,
                                    itemId: itemId
                                }
                            },
                            settings: {
                                filterJql: filterJql,
                                groupBy: groupBy
                            }
                        }
                    }
                }
            }
        };
    }
});

});
parcelRegister("kCyK0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc9b07a0cf3a6615$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bb6ccc7eac08a1105992bebc60cef8e3>>
 * @relayHash 468bd2fd6be3e0a524cf768954902ed2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 821883c1b29c6cacbbff1f0c106e332dc2690e95a2824e7c748095e1acabdf4a

var $apYuT = parcelRequire("apYuT");

var $6FfOn = parcelRequire("6FfOn");
const $cc9b07a0cf3a6615$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "821883c1b29c6cacbbff1f0c106e332dc2690e95a2824e7c748095e1acabdf4a",
        "metadata": {},
        "name": "src_jiraBusinessBoardEmbedQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaycategoryfieldrelayprovider": (0, $6FfOn.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": (0, $apYuT.default)
        }
    }
};
var $cc9b07a0cf3a6615$export$2e2bcd8739ae039 = $cc9b07a0cf3a6615$var$node;

});
parcelRegister("apYuT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4118540cc4c9ddd7$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
const $4118540cc4c9ddd7$var$MergeBoardWorkflowsRelayProvider = {
    get () {
        return (0, $6s1PB.expVal)('merge_board_workflows', 'enabled', false);
    }
};
var $4118540cc4c9ddd7$export$2e2bcd8739ae039 = $4118540cc4c9ddd7$var$MergeBoardWorkflowsRelayProvider;

});

parcelRegister("6FfOn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f9c253012ba44be$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $0f9c253012ba44be$var$RelayProvider = {
    get () {
        return (0, $4R6GH.fg)('sv-357_relay_category_field');
    }
};
var $0f9c253012ba44be$export$2e2bcd8739ae039 = $0f9c253012ba44be$var$RelayProvider;

});


parcelRegister("6JivU", function(module, exports) {

let $4e654e7ed359ddd7$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("hUhek"), 4)),
    $4e654e7ed359ddd7$var$load("dsiAd"),
    $4e654e7ed359ddd7$var$load("fRBgo")
]).then(()=>parcelRequire('azXNC'));

});




parcelRegister("8gEiV", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardCustomEmbedRouteEntry", () => $8fc4c7c9ffb4bf6a$export$4622ad4c7294f3a7);

var $6e4Kt = parcelRequire("6e4Kt");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $d8VYe = parcelRequire("d8VYe");

var $lNicp = parcelRequire("lNicp");

var $5JXXx = parcelRequire("5JXXx");

var $93hm0 = parcelRequire("93hm0");
const $8fc4c7c9ffb4bf6a$export$4622ad4c7294f3a7 = (0, $7NszV.createEntry)((0, $5JXXx.jiraBusinessBoardCustomEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-board-embed',
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: [
            ...(0, $lNicp.getProjectViewResources)(),
            (0, $d8VYe.workflowIssuesResource)
        ],
        entryPoint: ()=>(0, $93hm0.boardEmbedPageEntryPoint)
    }));

});
parcelRegister("5JXXx", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardCustomEmbedRoute", () => $609d5e332788d2ad$export$7d977a74e9d9d32b);
const $609d5e332788d2ad$export$7d977a74e9d9d32b = {
    name: 'classic-business-board-custom-embed',
    path: '/jira/core/projects/:projectKey/board/:itemId/embed',
    exact: true
};

});


parcelRegister("dhiyM", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardRouteEntry", () => $0eb25cb247c76465$export$c7fe0dd4417407a0);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $d8VYe = parcelRequire("d8VYe");

var $lNicp = parcelRequire("lNicp");

var $g8BTw = parcelRequire("g8BTw");

var $gkbjZ = parcelRequire("gkbjZ");
const $0eb25cb247c76465$export$c7fe0dd4417407a0 = (0, $7NszV.createEntry)((0, $g8BTw.jiraBusinessBoardRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-board',
        layout: (0, $aPfsS.composeLayouts)((0, $lRPBw.businessProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $lNicp.getProjectViewResources)(),
            (0, $d8VYe.workflowIssuesResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'business-board-early-entry'
            ]
        },
        entryPoint: ()=>(0, $gkbjZ.boardPageEntryPoint)
    }));

});
parcelRegister("g5RGc", function(module, exports) {

$parcel$export(module.exports, "fullPageIssuePreloadLayout", () => $59d96d961d806fee$export$98e337c40eb151da);
$parcel$export(module.exports, "embeddedIssuePreloadLayoutBuilder", () => $59d96d961d806fee$export$7b113174a456921a);
$parcel$export(module.exports, "pageLoadIssuePreloadLayoutBuilder", () => $59d96d961d806fee$export$682dcbf7cc80ba11);

var $aPfsS = parcelRequire("aPfsS");

var $lGGIs = parcelRequire("lGGIs");

var $b7Svb = parcelRequire("b7Svb");

var $lODMY = parcelRequire("lODMY");
var $4sxG1 = parcelRequire("4sxG1");

var $l7Ytp = parcelRequire("l7Ytp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $59d96d961d806fee$var$LazyIssuePage = (0, $b7Svb.lazyAfterPaint)(()=>(0, $lGGIs.markAsBentoBundleReady)((parcelRequire("5hJCC"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $59d96d961d806fee$var$AsyncIssueAppComponent = (0, $b7Svb.lazyAfterPaint)(()=>(0, $lGGIs.markAsBentoBundleReady)((parcelRequire("7F3Js"))), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $59d96d961d806fee$var$IssueModal = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("6TobW")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $59d96d961d806fee$var$IssueModalContents = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("6hA6f")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-view.tsx"
});
const $59d96d961d806fee$var$imports = {
    fullPage: ()=>$59d96d961d806fee$var$LazyIssuePage.preload(),
    embedded: ()=>$59d96d961d806fee$var$AsyncIssueAppComponent.preload(),
    pageLoad: (viewModeToPreload)=>{
        // issue view that opens as a modal
        if (viewModeToPreload === 'MODAL' || viewModeToPreload === 'DEFAULT') {
            $59d96d961d806fee$var$IssueModal.preload();
            $59d96d961d806fee$var$IssueModalContents.preload();
        }
        // issue view that opens as a side panel
        if (viewModeToPreload === 'SIDEBAR') $59d96d961d806fee$var$AsyncIssueAppComponent.preload();
    }
};

const $59d96d961d806fee$var$PrefetchCBBResourcesComponent = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("9nwbw")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/prefetch-wrm-bundle/index.tsx"
});
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
if (!false && window.SPA_STATE?.serverIssuePreload) {
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly fullPage: () => Promise<typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/spa-apps/issue/src/index")>; readonly embedded: () => Promise<...>; }'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const importSupplier = $59d96d961d806fee$var$imports[window.SPA_STATE.serverIssuePreload];
    importSupplier && importSupplier();
}
const $59d96d961d806fee$var$ISSUE_PRELOAD_COMPONENT_MARK = 'IssuePreloadComponent:rendered';
const $59d96d961d806fee$var$useParamsSelector = (0, $lODMY.createRouterSelector)((state)=>({
        query: state.query,
        params: state.match.params
    }));
const $59d96d961d806fee$var$IssuePreloadComponentBuilder = (identifier, preloadSupplier, preloadContract)=>()=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { query: query, params: params } = $59d96d961d806fee$var$useParamsSelector();
        if (// If we have an undefined contract, assume we want to preload
        !preloadContract || // Preload if we match the contract
        preloadContract.some((preloadingMatch)=>// Match query with router function
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            (!preloadingMatch.query || (0, $4sxG1.default)(preloadingMatch.query, query)) && // Match path params with simple object structure, where if value is undefined
            // we assume we match all values
            (!preloadingMatch.params || preloadingMatch.params.every(({ key: key, value: value })=>params && params[key] !== undefined && (value === undefined || params[key] === value))))) {
            if (!false) preloadSupplier();
            if (false) (0, $l7Ytp.setServerEvaluatedIssuePreload)(identifier);
            else performance.mark($59d96d961d806fee$var$ISSUE_PRELOAD_COMPONENT_MARK);
        }
        return null;
    };
const $59d96d961d806fee$var$FullPageIssuePreloadComponent = $59d96d961d806fee$var$IssuePreloadComponentBuilder('fullPage', $59d96d961d806fee$var$imports.fullPage);
$59d96d961d806fee$var$FullPageIssuePreloadComponent.displayName = 'FullPageIssuePreloadComponent';
const $59d96d961d806fee$export$98e337c40eb151da = (0, $aPfsS.createLayout)({
    globalComponents: [
        $59d96d961d806fee$var$FullPageIssuePreloadComponent,
        $59d96d961d806fee$var$PrefetchCBBResourcesComponent
    ]
});
const $59d96d961d806fee$export$7b113174a456921a = (preloadContract)=>{
    const EmbeddedIssuePreloadComponent = $59d96d961d806fee$var$IssuePreloadComponentBuilder('embedded', $59d96d961d806fee$var$imports.embedded, preloadContract);
    EmbeddedIssuePreloadComponent.displayName = 'EmbeddedIssuePreloadComponent';
    return (0, $aPfsS.createLayout)({
        globalComponents: [
            EmbeddedIssuePreloadComponent
        ]
    });
};
const $59d96d961d806fee$export$682dcbf7cc80ba11 = (preloadContract, viewModeToPreload)=>{
    const PageLoadIssuePreloadComponent = $59d96d961d806fee$var$IssuePreloadComponentBuilder('pageLoad', ()=>$59d96d961d806fee$var$imports.pageLoad(viewModeToPreload || 'DEFAULT'), preloadContract);
    PageLoadIssuePreloadComponent.displayName = 'PageLoadIssuePreloadComponent';
    return (0, $aPfsS.createLayout)({
        globalComponents: [
            PageLoadIssuePreloadComponent
        ]
    });
};

});
parcelRegister("lGGIs", function(module, exports) {

$parcel$export(module.exports, "markAsBentoBundleReady", () => $7671cdebcdce4d73$export$d9ff0b3329728986);

var $fDtbf = parcelRequire("fDtbf");

var $2SVPM = parcelRequire("2SVPM");
let $7671cdebcdce4d73$var$reportedBentoBundleReady = false;
const $7671cdebcdce4d73$export$d9ff0b3329728986 = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        // Mutex for reporter
        if ($7671cdebcdce4d73$var$reportedBentoBundleReady) return;
        $7671cdebcdce4d73$var$reportedBentoBundleReady = true;
        (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if (resources[i].name.startsWith('async-issue-app') && resources[i].name.endsWith((0, $fDtbf.JS_EVAL_START))) {
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.eval', resources[i].name);
            break;
        }
    });
    return importedBundle;
};

});

parcelRegister("l7Ytp", function(module, exports) {

$parcel$export(module.exports, "setServerEvaluatedIssuePreload", () => $1e750e126dd1eeef$export$d2077b3b0eac1c19);
/* eslint-disable jira/filename-case */ // We can start the evaluation at module level if we ran the component in SSR
// This needs to be an empty string because the router breaks if it's null or undefined
let $1e750e126dd1eeef$var$serverIssuePreloadIdentifier = '';
const $1e750e126dd1eeef$export$d2077b3b0eac1c19 = (identifier)=>{
    $1e750e126dd1eeef$var$serverIssuePreloadIdentifier = identifier;
};
const $1e750e126dd1eeef$export$f55e6973062dc859 = ()=>$1e750e126dd1eeef$var$serverIssuePreloadIdentifier;

});

parcelRegister("5hJCC", function(module, exports) {

let $3d91eddb3386826f$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $3d91eddb3386826f$var$load("kCvaU")
        ]);
    }),
    $3d91eddb3386826f$var$load("kfXhT"),
    $3d91eddb3386826f$var$load("2Lfdl"),
    $3d91eddb3386826f$var$load("cM9em"),
    $3d91eddb3386826f$var$load("fr9NE"),
    $3d91eddb3386826f$var$load("eNmuD"),
    $3d91eddb3386826f$var$load("h2MrD"),
    $3d91eddb3386826f$var$load("bYT2S"),
    $3d91eddb3386826f$var$load("kWrFZ"),
    $3d91eddb3386826f$var$load("dsiAd"),
    $3d91eddb3386826f$var$load("92sUi"),
    $3d91eddb3386826f$var$load("i5RRW"),
    $3d91eddb3386826f$var$load("hPzOn"),
    $3d91eddb3386826f$var$load("4GOBq")
]).then(()=>parcelRequire('kW74N'));

});
parcelRegister("avM1e", function(module, exports) {
"use strict";
module.exports = function(cond, ifTrue, ifFalse) {
    return globalThis.__MCOND && globalThis.__MCOND(cond) ? ifTrue() : ifFalse();
};

});


parcelRegister("7F3Js", function(module, exports) {

let $593f41e45c567fb3$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $593f41e45c567fb3$var$load("kCvaU")
        ]);
    }),
    $593f41e45c567fb3$var$load("kWrFZ"),
    $593f41e45c567fb3$var$load("dsiAd"),
    $593f41e45c567fb3$var$load("kfXhT"),
    $593f41e45c567fb3$var$load("2Lfdl"),
    $593f41e45c567fb3$var$load("92sUi"),
    $593f41e45c567fb3$var$load("i5RRW"),
    $593f41e45c567fb3$var$load("eNmuD"),
    $593f41e45c567fb3$var$load("hPzOn"),
    $593f41e45c567fb3$var$load("h2MrD"),
    $593f41e45c567fb3$var$load("bYT2S"),
    $593f41e45c567fb3$var$load("cM9em"),
    $593f41e45c567fb3$var$load("fr9NE"),
    $593f41e45c567fb3$var$load("cggv6")
]).then(()=>parcelRequire('6qbjz'));

});

parcelRegister("6TobW", function(module, exports) {

let $504aa51aafa0634f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $504aa51aafa0634f$var$load("cM9em"),
    $504aa51aafa0634f$var$load("fr9NE"),
    $504aa51aafa0634f$var$load("h2MrD"),
    $504aa51aafa0634f$var$load("bYT2S"),
    $504aa51aafa0634f$var$load("hPzOn"),
    $504aa51aafa0634f$var$load("8SBrF")
]).then(()=>parcelRequire('2555l'));

});

parcelRegister("6hA6f", function(module, exports) {

let $4930554940810b9b$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $4930554940810b9b$var$load("kCvaU")
        ]);
    }),
    $4930554940810b9b$var$load("kWrFZ"),
    $4930554940810b9b$var$load("dsiAd"),
    $4930554940810b9b$var$load("kfXhT"),
    $4930554940810b9b$var$load("2Lfdl"),
    $4930554940810b9b$var$load("92sUi"),
    $4930554940810b9b$var$load("i5RRW"),
    $4930554940810b9b$var$load("eNmuD"),
    $4930554940810b9b$var$load("hPzOn"),
    $4930554940810b9b$var$load("h2MrD"),
    $4930554940810b9b$var$load("bYT2S"),
    $4930554940810b9b$var$load("cM9em"),
    $4930554940810b9b$var$load("fr9NE"),
    $4930554940810b9b$var$load("1FpMi")
]).then(()=>parcelRequire('kMGHs'));

});

parcelRegister("9nwbw", function(module, exports) {

let $6d3f3a47d69faca6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6d3f3a47d69faca6$var$load("c6aDa").then(()=>parcelRequire('4n6tJ'));

});


parcelRegister("g8BTw", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardRoute", () => $66846ddeea123664$export$14a5cbbd7e1e2dc2);
const $66846ddeea123664$export$14a5cbbd7e1e2dc2 = {
    name: 'classic-business-board',
    exact: true,
    path: '/jira/core/projects/:projectKey/board/:itemId?'
};

});

parcelRegister("gkbjZ", function(module, exports) {

$parcel$export(module.exports, "boardPageEntryPoint", () => $39c257a891cf9743$export$552f44bed039f041);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $7AGbN = parcelRequire("7AGbN");

var $fo6b8 = parcelRequire("fo6b8");
const $39c257a891cf9743$export$552f44bed039f041 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7AGbN.boardEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("7AGbN", function(module, exports) {

$parcel$export(module.exports, "boardEntryPoint", () => $a4aaf8c5264c4217$export$937ca5a4cdc1a12e);

var $lzufP = parcelRequire("lzufP");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $a4aaf8c5264c4217$export$937ca5a4cdc1a12e = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("jrBnO")), {
        moduleId: "8dcbcc62"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        const itemId = context.match.params.itemId ?? '';
        let filterJql = context.query?.filter;
        let groupBy = context.query?.groupBy;
        // if in a client environment, check whether the router url matches the current window pathname
        // if it does, use the filter and groupBy from the current window location instead of the router query
        // this avoids reloading the query without the overrides when a user hovers over prefetching links that don't include them
        if (typeof window !== 'undefined' && window.location.pathname === context.match.url) {
            const searchParams = new URLSearchParams(window.location.search);
            filterJql = searchParams.get('filter') ?? undefined;
            groupBy = searchParams.get('groupBy') ?? undefined;
        }
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                boardQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $lzufP.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        viewInput: {
                            jiraBoardViewQueryInput: {
                                projectKeyAndItemIdQuery: {
                                    cloudId: cloudId,
                                    projectKey: projectKey,
                                    itemId: itemId
                                }
                            },
                            settings: {
                                filterJql: filterJql,
                                groupBy: groupBy
                            }
                        }
                    }
                }
            }
        };
    }
});

});
parcelRegister("lzufP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e141afb773c5347$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<af33340b1c12ba480e03891ae5f7511e>>
 * @relayHash be8f6c458776de62707aa70112a83cbd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cd0128d6dbbcdf38592708e32a1421e1843a69ba4c93b6f7ee4c040e9dd3d890

var $apYuT = parcelRequire("apYuT");

var $6FfOn = parcelRequire("6FfOn");
const $5e141afb773c5347$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "cd0128d6dbbcdf38592708e32a1421e1843a69ba4c93b6f7ee4c040e9dd3d890",
        "metadata": {},
        "name": "src_jiraBusinessBoardQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaycategoryfieldrelayprovider": (0, $6FfOn.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": (0, $apYuT.default)
        }
    }
};
var $5e141afb773c5347$export$2e2bcd8739ae039 = $5e141afb773c5347$var$node;

});

parcelRegister("jrBnO", function(module, exports) {

let $e27d896c9774e983$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("3xlWT"), 4)),
    $e27d896c9774e983$var$load("dsiAd"),
    $e27d896c9774e983$var$load("iL8G9")
]).then(()=>parcelRequire('ac4Ca'));

});




parcelRegister("21AP4", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessCalendarEmbedRouteEntry", () => $600d33daee8526e1$export$d75a7b48d8838f92);

var $6e4Kt = parcelRequire("6e4Kt");

var $6s1PB = parcelRequire("6s1PB");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $d5vH1 = parcelRequire("d5vH1");

var $lkFvK = parcelRequire("lkFvK");

var $1SDlb = parcelRequire("1SDlb");

var $4wa6C = parcelRequire("4wa6C");
const $600d33daee8526e1$var$calendarEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $4wa6C.calendarEntryPoint)
});
const $600d33daee8526e1$var$legacyCalendarEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $1SDlb.calendarEmbedEntrypoint)
});
const $600d33daee8526e1$export$d75a7b48d8838f92 = (0, $7NszV.createEntry)((0, $d5vH1.jiraBusinessCalendarEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.calendar-embed-view',
        entryPoint () {
            return (0, $6s1PB.expValEquals)('business_projects_shared_calendar', 'cohort', 'variation') ? $600d33daee8526e1$var$calendarEmbedPageEntrypoint : $600d33daee8526e1$var$legacyCalendarEmbedPageEntrypoint;
        },
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: (0, $lNicp.getProjectViewResources)()
    }));

});
parcelRegister("d5vH1", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessCalendarEmbedRoute", () => $085faca8e3760e1d$export$71a801c267234959);
const $085faca8e3760e1d$export$71a801c267234959 = {
    name: 'classic-business-calendar-embed',
    path: '/jira/core/projects/:projectKey/calendar/embed',
    exact: true
};

});

parcelRegister("1SDlb", function(module, exports) {

$parcel$export(module.exports, "calendarEmbedEntrypoint", () => $6e0458699dd28572$export$6ce8d7eff8d6b026);

var $48x8r = parcelRequire("48x8r");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $6e0458699dd28572$export$6ce8d7eff8d6b026 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("9mSgU")), {
        moduleId: "806194a7"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                calendarEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $48x8r.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("48x8r", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a5d8de5abeff379$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<77de2caa00c4513223c7b713bf724e5a>>
 * @relayHash a2b6adfd1ec94da5c71c412634dec345
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1d84d0c28258d14a680ab0152bc4d8da9f3b50260fa20b67f6cd4c7587391ac3
const $6a5d8de5abeff379$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "1d84d0c28258d14a680ab0152bc4d8da9f3b50260fa20b67f6cd4c7587391ac3",
        "metadata": {},
        "name": "src_jiraBusinessCalendarEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6a5d8de5abeff379$export$2e2bcd8739ae039 = $6a5d8de5abeff379$var$node;

});

parcelRegister("9mSgU", function(module, exports) {

let $6d204457ff446303$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6d204457ff446303$var$load("h2MrD"),
    $6d204457ff446303$var$load("bYT2S"),
    $6d204457ff446303$var$load("1IlDx")
]).then(()=>parcelRequire('icB4w'));

});


parcelRegister("4wa6C", function(module, exports) {

$parcel$export(module.exports, "calendarEntryPoint", () => $38193f9d05bd632a$export$19cf4b398f638dc6);

var $4R6GH = parcelRequire("4R6GH");

var $8s8gU = parcelRequire("8s8gU");

var $7JhZX = parcelRequire("7JhZX");

var $6s1PB = parcelRequire("6s1PB");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");
const $38193f9d05bd632a$var$SETTINGS_STORAGE_KEY = 'calendar:settings:business';
function $38193f9d05bd632a$var$getViewSettings(key) {
    try {
        const serializedValue = globalThis.localStorage?.getItem(key);
        return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
    } catch  {
        return undefined;
    }
}
const $38193f9d05bd632a$var$and = (clauses)=>{
    return clauses.map((clause)=>clause.trim()).filter((clause)=>clause.length > 0).join(' AND ');
};
function $38193f9d05bd632a$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $38193f9d05bd632a$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $38193f9d05bd632a$var$createScope({ context: context }) {
    return {
        type: 'project',
        projectKeys: [
            String(context.match.params.projectKey)
        ]
    };
}
function $38193f9d05bd632a$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    return {
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
}
function $38193f9d05bd632a$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $38193f9d05bd632a$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $38193f9d05bd632a$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
    return {
        date: $38193f9d05bd632a$var$toMidnightUTCString(selectedDate),
        mode: $38193f9d05bd632a$var$toViewMode(viewRange),
        weekStart: $38193f9d05bd632a$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField,
        viewId: null
    };
}
/** Extracted from business/shared/simpleSearch */ function $38193f9d05bd632a$var$jqlSearchText(text) {
    if (text === undefined || text.trim() === '') return '';
    const sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
    const ISSUEKEY_REGEX = '([A-Z][A-Z0-9_]+-\\d+)';
    const issueKeyRegex = new RegExp(`^${ISSUEKEY_REGEX}$`);
    const japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
    let search = sanitize(text);
    if (issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
}
function $38193f9d05bd632a$var$buildIssuesSearchInput(filter = '', text = '', hideDoneItems) {
    if (!(0, $4R6GH.fg)('jira_calendar_load_more_pagination')) return {
        additionalFilterQuery: ''
    };
    const hideDoneItemsQuery = "StatusCategory != 'Complete'";
    const search = $38193f9d05bd632a$var$jqlSearchText(text);
    return {
        additionalFilterQuery: $38193f9d05bd632a$var$and([
            search,
            filter,
            ...hideDoneItems ? [
                hideDoneItemsQuery
            ] : []
        ])
    };
}
function $38193f9d05bd632a$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}

const $38193f9d05bd632a$export$19cf4b398f638dc6 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("3bufb")), {
        moduleId: "70b39bf1"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        const scope = $38193f9d05bd632a$var$createScope(entryPointRouteParams);
        const { date: date, filter: filter, hideDone: hideDone, text: text } = context.query;
        const selectedDate = $38193f9d05bd632a$var$toDate(date);
        const settings = (0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? $38193f9d05bd632a$var$getViewSettings($38193f9d05bd632a$var$SETTINGS_STORAGE_KEY) : undefined;
        const viewRange = 'month';
        const hideDoneItems = hideDone && (0, $4R6GH.fg)('calendar-hide-done-query-param') ? true : settings?.hideDoneItems ?? false;
        const weekStartsOn = (0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? settings?.weekStartsOn ?? 'sunday' : 'sunday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        return {
            queries: {
                calendarQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $8s8gU.default),
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                calendarData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $7JhZX.default),
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $38193f9d05bd632a$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $38193f9d05bd632a$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField
                        }),
                        issuesPageSize: (0, $4R6GH.fg)('jira_calendar_lazy_load') ? 200 : 50,
                        issuesSearchInput: $38193f9d05bd632a$var$buildIssuesSearchInput(filter, text, hideDoneItems),
                        unscheduledIssuesSearchInput: $38193f9d05bd632a$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: {
                            versionStatuses: [
                                'RELEASED',
                                'UNRELEASED'
                            ],
                            includeSharedReleases: true
                        },
                        sprintsSearchInput: null,
                        skipSprintSearch: true,
                        viewId: null,
                        schedulePermissionsEnabled: (0, $4R6GH.fg)('calendar_schedule_issue_permissions_check'),
                        pageLoadMoreEnabled: (0, $4R6GH.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV1Search: (0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        skipVersionsV2Search: !(0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        includeRecurrenceIndicator: (0, $6s1PB.expValEquals)('jira-recur-single-work-item-on-schedule', 'isRecurrenceCalendarViewEnabled', true),
                        pageLoadMoreEnabledViewSettings: (0, $4R6GH.fg)('jira_calendar_load_more_pagination_view_settings')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                hasRecurrenceItemIndicator: (0, $6s1PB.expValEquals)('jira-recur-single-work-item-on-schedule', 'isRecurrenceCalendarViewEnabled', true)
            }
        };
    }
});

});
parcelRegister("8s8gU", function(module, exports) {

$parcel$export(module.exports, "default", () => $04b6b433e450264c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<620394e61554de6b4de7fc13153ce658>>
 * @relayHash e7f526a757abd5ec137c62e6d5d37fb3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 23ff8ebcf7d113448b039ee2b0b9d7d1d70d6a6af70115838ee65796d163a423
const $04b6b433e450264c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "23ff8ebcf7d113448b039ee2b0b9d7d1d70d6a6af70115838ee65796d163a423",
        "metadata": {},
        "name": "src_jiraBusinessSharedCalendarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $04b6b433e450264c$export$2e2bcd8739ae039 = $04b6b433e450264c$var$node;

});

parcelRegister("3bufb", function(module, exports) {

let $2519dc023845f9b5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2519dc023845f9b5$var$load("h2MrD"),
    $2519dc023845f9b5$var$load("bYT2S"),
    $2519dc023845f9b5$var$load("kkvf2")
]).then(()=>parcelRequire('jJF0P'));

});



parcelRegister("infHq", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessCalendarRouteEntry", () => $2bf1458ced078f1f$export$b8f4785659c5349e);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $6s1PB = parcelRequire("6s1PB");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $aMqk7 = parcelRequire("aMqk7");

var $lkFvK = parcelRequire("lkFvK");

var $4wa6C = parcelRequire("4wa6C");

var $86YN8 = parcelRequire("86YN8");

var $fo6b8 = parcelRequire("fo6b8");
const $2bf1458ced078f1f$var$calendarPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4wa6C.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $2bf1458ced078f1f$var$legacyCalendarPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $86YN8.calendarEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $2bf1458ced078f1f$export$b8f4785659c5349e = (0, $7NszV.createEntry)((0, $aMqk7.jiraBusinessCalendarRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.calendar-view',
        entryPoint () {
            return (0, $6s1PB.expValEquals)('business_projects_shared_calendar', 'cohort', 'variation') ? $2bf1458ced078f1f$var$calendarPageEntrypoint : $2bf1458ced078f1f$var$legacyCalendarPageEntrypoint;
        },
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)()
    }));

});
parcelRegister("aMqk7", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessCalendarRoute", () => $4cb3bab25d5027cf$export$3f1924073260dde6);
const $4cb3bab25d5027cf$export$3f1924073260dde6 = {
    name: 'classic-business-calendar',
    path: '/jira/core/projects/:projectKey/calendar',
    exact: true
};

});

parcelRegister("86YN8", function(module, exports) {

$parcel$export(module.exports, "calendarEntrypoint", () => $1d5ded87a815c51a$export$642797ae4b06d84d);

var $2Bdp5 = parcelRequire("2Bdp5");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $1d5ded87a815c51a$export$642797ae4b06d84d = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("jngZ9")), {
        moduleId: "5d7f32eb"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                calendarQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $2Bdp5.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("2Bdp5", function(module, exports) {

$parcel$export(module.exports, "default", () => $28130442660fe442$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<85f01dd9a4cb6fbc8475a6a481fd9b0c>>
 * @relayHash 75f3bb306c6596d20be18db68be629b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aae4d7be0b1132780de81554c978143eee155583036b48e02a7d4324df80cc9c
const $28130442660fe442$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "aae4d7be0b1132780de81554c978143eee155583036b48e02a7d4324df80cc9c",
        "metadata": {},
        "name": "src_jiraBusinessCalendarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $28130442660fe442$export$2e2bcd8739ae039 = $28130442660fe442$var$node;

});

parcelRegister("jngZ9", function(module, exports) {

let $e1ad573cbad30c28$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e1ad573cbad30c28$var$load("h2MrD"),
    $e1ad573cbad30c28$var$load("bYT2S"),
    $e1ad573cbad30c28$var$load("fBNW3")
]).then(()=>parcelRequire('425eT'));

});



parcelRegister("ilKWG", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessReportsOverviewRouteEntry", () => $c06ed3cb1d5f7aff$export$2cde310731fa9055);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $6e5qs = parcelRequire("6e5qs");

var $lkFvK = parcelRequire("lkFvK");

var $fo6b8 = parcelRequire("fo6b8");

var $fh5Sl = parcelRequire("fh5Sl");
const $c06ed3cb1d5f7aff$var$reportsOverviewPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fh5Sl.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $c06ed3cb1d5f7aff$export$2cde310731fa9055 = (0, $7NszV.createEntry)((0, $6e5qs.jiraBusinessReportsOverviewRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.reports-overview',
        entryPoint () {
            return $c06ed3cb1d5f7aff$var$reportsOverviewPageEntryPoint;
        },
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)()
    }));

});
parcelRegister("6e5qs", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessReportsOverviewRoute", () => $4545a709b63712be$export$5881ca008f82b9d8);
const $4545a709b63712be$export$5881ca008f82b9d8 = {
    name: 'classic-business-reports-overview',
    path: '/jira/core/projects/:projectKey/reports',
    exact: true
};

});

parcelRegister("fh5Sl", function(module, exports) {

$parcel$export(module.exports, "reportsOverviewPageEntryPoint", () => $cb9d07f6a92b0ec7$export$9dfa968d9e20b359);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $6hHfS = parcelRequire("6hHfS");

const $cb9d07f6a92b0ec7$export$9dfa968d9e20b359 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("cMrbe")).then((mod)=>mod.ReportsOverviewPage), {
        moduleId: "b8514977"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const boardId = context.match.params.boardId ? String(context.match.params.boardId) : null;
        const projectKey = context.match.params.projectKey ? String(context.match.params.projectKey) : null;
        const isBoardContext = !!boardId;
        const isProjectContext = !!projectKey;
        const cloudId = tenantContext.cloudId;
        return {
            queries: {
                reportsOverviewPage: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $6hHfS.default,
                    variables: {
                        boardId: isBoardContext ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '',
                        projectKey: !isBoardContext && isProjectContext ? projectKey : '',
                        cloudId: cloudId,
                        isBoardContext: isBoardContext
                    }
                }
            }
        };
    }
});

});
parcelRegister("6hHfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $868a790b54436928$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d07eb7632c7c8519e83224e9ac018576>>
 * @relayHash 497df43b1252a8dc0b4f0ec9cd482e92
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fa621fa4bb6543d468797211342e1086ef2a6b35d10869637d74ad38c4e9685b
const $868a790b54436928$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isBoardContext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "concreteType": "JiraReportCategoryConnection",
        "kind": "LinkedField",
        "name": "reportCategories",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraReportCategoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraReportCategoryNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v6 /*: any*/ ,
                            {
                                "concreteType": "JiraReportConnection",
                                "kind": "LinkedField",
                                "name": "reports",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraReportConnectionEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraReport",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v7 /*: any*/ ,
                                                    v6 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "key"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "imageUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "description"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "url"
                                                    },
                                                    v8 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            v8 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "srcReportsOverviewPageQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "reportCategories_reportsOverviewPage"
                },
                {
                    "condition": "isBoardContext",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v4 /*: any*/ ,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jira_projectByIdOrKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v5 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira_projectByIdOrKey.projectType"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira_projectByIdOrKey"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "srcReportsOverviewPageQuery",
            "selections": [
                {
                    "condition": "isBoardContext",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jira_projectByIdOrKey",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v8 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "isBoardContext",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "boardId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraBoard",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v9 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v8 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fa621fa4bb6543d468797211342e1086ef2a6b35d10869637d74ad38c4e9685b",
            "metadata": {},
            "name": "srcReportsOverviewPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$868a790b54436928$var$node.hash = "48e488c0e3939efa5d53df92fe5fb373";
var $868a790b54436928$export$2e2bcd8739ae039 = $868a790b54436928$var$node;

});

parcelRegister("cMrbe", function(module, exports) {

let $94df0d2ae2ae7f33$var$load = (parcelRequire("28QjX"))(4);
module.exports = $94df0d2ae2ae7f33$var$load("fNJPD").then(()=>parcelRequire('b8Z4e'));

});



parcelRegister("dUuHj", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewCalendarRouteEntry", () => $8bbf45fcd3a87ffb$export$93f05037a457ce22);

var $l71WK = parcelRequire("l71WK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $8bcrt = parcelRequire("8bcrt");

var $lkFvK = parcelRequire("lkFvK");

var $4tESa = parcelRequire("4tESa");
const $8bbf45fcd3a87ffb$var$overviewCalendarPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4tESa.overviewCalendarEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $8bbf45fcd3a87ffb$export$93f05037a457ce22 = (0, $7NszV.createEntry)((0, $8bcrt.classicBusinessOverviewCalendarRoute), ()=>({
        group: 'classic-business',
        layout: (0, $2BrOV.globalLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $l71WK.AsyncHorizontalOverviewNav)
        },
        resources: (0, $lNicp.getOverviewViewResources)(),
        entryPoint: ()=>$8bbf45fcd3a87ffb$var$overviewCalendarPageEntrypoint
    }));

});
parcelRegister("8bcrt", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewCalendarRoute", () => $c0fa680257c9f3d1$export$61383e5418d2ffe3);
const $c0fa680257c9f3d1$export$61383e5418d2ffe3 = {
    name: 'classic-business-overview-calendar',
    path: '/jira/core/overviews/:overviewId/calendar',
    exact: true
};

});

parcelRegister("4tESa", function(module, exports) {

$parcel$export(module.exports, "overviewCalendarEntrypoint", () => $9344d5422559b8bf$export$b7094a9bdb66fbad);

var $aNsVT = parcelRequire("aNsVT");

var $dnOYu = parcelRequire("dnOYu");

var $3rdd7 = parcelRequire("3rdd7");

const $9344d5422559b8bf$export$b7094a9bdb66fbad = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("f3t38")), {
        moduleId: "a9cf6a8e"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId } })=>{
        return {
            queries: {
                overviewCalendarQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $dnOYu.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("dnOYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a44115091e7f597$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e514564c1688822aea8c6efba8699694>>
 * @relayHash 466f1e55c408e59be27b44b8156f9147
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 82d517df2c5a9cef088b63278282f98c94356907ff3ba4c909173bfd3d9477f7
const $7a44115091e7f597$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "82d517df2c5a9cef088b63278282f98c94356907ff3ba4c909173bfd3d9477f7",
        "metadata": {},
        "name": "src_jiraBusinessOverviewCalendarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7a44115091e7f597$export$2e2bcd8739ae039 = $7a44115091e7f597$var$node;

});

parcelRegister("f3t38", function(module, exports) {

let $af5dab73774723ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $af5dab73774723ca$var$load("h2MrD"),
    $af5dab73774723ca$var$load("bYT2S"),
    $af5dab73774723ca$var$load("fukyz")
]).then(()=>parcelRequire('UcTEy'));

});



parcelRegister("eiK9n", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewSummaryRouteEntry", () => $e86d6c5f1551d7af$export$f8fd32e123428b9a);

var $l71WK = parcelRequire("l71WK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $a8LXv = parcelRequire("a8LXv");

var $lkFvK = parcelRequire("lkFvK");

var $eQQpY = parcelRequire("eQQpY");
const $e86d6c5f1551d7af$var$overviewSummaryPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $eQQpY.overviewSummaryEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $e86d6c5f1551d7af$export$f8fd32e123428b9a = (0, $7NszV.createEntry)((0, $a8LXv.classicBusinessOverviewSummaryRoute), ()=>({
        group: 'classic-business',
        layout: (0, $2BrOV.globalLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $l71WK.AsyncHorizontalOverviewNav)
        },
        resources: (0, $lNicp.getOverviewViewResources)(),
        entryPoint: ()=>$e86d6c5f1551d7af$var$overviewSummaryPageEntrypoint
    }));

});
parcelRegister("a8LXv", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewSummaryRoute", () => $64a453e593a46414$export$4a86e6b12ce49af9);
const $64a453e593a46414$export$4a86e6b12ce49af9 = {
    name: 'classic-business-overview-summary',
    path: '/jira/core/overviews/:overviewId/summary',
    exact: true
};

});

parcelRegister("eQQpY", function(module, exports) {

$parcel$export(module.exports, "overviewSummaryEntrypoint", () => $d80730b6496fafc5$export$3793bbcc33b62692);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $d80730b6496fafc5$export$3793bbcc33b62692 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("hjplE")), {
        moduleId: "5d9f07b1"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hjplE", function(module, exports) {

let $c9a7dfa3ef30b056$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c9a7dfa3ef30b056$var$load("6hewl").then(()=>parcelRequire('6QJpB'));

});



parcelRegister("4KinX", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewTimelineRouteEntry", () => $068b485441948b61$export$9d9d562e489097b3);

var $l71WK = parcelRequire("l71WK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $8s9V5 = parcelRequire("8s9V5");

var $lkFvK = parcelRequire("lkFvK");

var $bB7nn = parcelRequire("bB7nn");
const $068b485441948b61$var$overviewTimelinePageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $bB7nn.overviewTimelineEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $068b485441948b61$export$9d9d562e489097b3 = (0, $7NszV.createEntry)((0, $8s9V5.classicBusinessOverviewTimelineRoute), ()=>({
        group: 'classic-business',
        layout: (0, $2BrOV.globalLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $l71WK.AsyncHorizontalOverviewNav)
        },
        resources: (0, $lNicp.getOverviewViewResources)(),
        entryPoint: ()=>$068b485441948b61$var$overviewTimelinePageEntrypoint
    }));

});
parcelRegister("8s9V5", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewTimelineRoute", () => $2de2a62458dcdd8a$export$13f0c823ff3059c2);
const $2de2a62458dcdd8a$export$13f0c823ff3059c2 = {
    name: 'classic-business-overview-timeline',
    path: '/jira/core/overviews/:overviewId/timeline',
    exact: true
};

});

parcelRegister("bB7nn", function(module, exports) {

$parcel$export(module.exports, "overviewTimelineEntrypoint", () => $41c8e0eb43e05110$export$d00505893f9d5d11);

var $aNsVT = parcelRequire("aNsVT");

var $gfPQt = parcelRequire("gfPQt");

var $3rdd7 = parcelRequire("3rdd7");

const $41c8e0eb43e05110$export$d00505893f9d5d11 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("2yjGY")), {
        moduleId: "ae6650bb"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId } })=>{
        return {
            queries: {
                overviewTimelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $gfPQt.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("gfPQt", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a8e66778cabfaa5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eb4ae6aae065c938f532a846255332dc>>
 * @relayHash 007933a1073bb512097f0e95cf95622d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 554086782541cb72a7484650860ffea7ea940346b5eb77793d5681f9e287d807
const $0a8e66778cabfaa5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "554086782541cb72a7484650860ffea7ea940346b5eb77793d5681f9e287d807",
        "metadata": {},
        "name": "src_jiraBusinessOverviewTimelineQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0a8e66778cabfaa5$export$2e2bcd8739ae039 = $0a8e66778cabfaa5$var$node;

});

parcelRegister("2yjGY", function(module, exports) {

let $1dbe0832c764a440$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1dbe0832c764a440$var$load("8IHqF").then(()=>parcelRequire('ge8BQ'));

});



parcelRegister("6IB0N", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectApprovalsRouteEntry", () => $89b695e5f9f3673a$export$563b4fef899fe540);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $hsU7j = parcelRequire("hsU7j");

var $8roOm = parcelRequire("8roOm");
const $89b695e5f9f3673a$export$563b4fef899fe540 = (0, $7NszV.createEntry)((0, $hsU7j.classicBusinessProjectApprovalsRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.approvals-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $8roOm.approvalsPageEntryPoint)
    }));

});
parcelRegister("hsU7j", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectApprovalsRoute", () => $5bb44f21c5956447$export$3109a183a442a02d);
const $5bb44f21c5956447$export$3109a183a442a02d = {
    name: 'classic-business-approvals',
    path: '/jira/core/projects/:projectKey/approvals',
    exact: true
};

});

parcelRegister("8roOm", function(module, exports) {

$parcel$export(module.exports, "approvalsPageEntryPoint", () => $09fa0192771673de$export$52c40d37705be5fa);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $4gsaJ = parcelRequire("4gsaJ");

var $fo6b8 = parcelRequire("fo6b8");
const $09fa0192771673de$export$52c40d37705be5fa = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4gsaJ.approvalsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("4gsaJ", function(module, exports) {

$parcel$export(module.exports, "approvalsEntryPoint", () => $300bb28bd2b40101$export$25d4a03de93a440e);

var $dFopv = parcelRequire("dFopv");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $300bb28bd2b40101$export$25d4a03de93a440e = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("1yz9H")), {
        moduleId: "6a9ba200"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                approvalsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $dFopv.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("dFopv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cf737eba0cc3036$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc6e2d903d7a5160ec3c02b7156848e4>>
 * @relayHash 2cc1b2be473185de0346970d79002539
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a7b24f841e6d55f0b788183900c0f5208b596d9f5efe804ede9c194b19f5e8d
const $4cf737eba0cc3036$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2a7b24f841e6d55f0b788183900c0f5208b596d9f5efe804ede9c194b19f5e8d",
        "metadata": {},
        "name": "src_jiraBusinessApprovalsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $4cf737eba0cc3036$export$2e2bcd8739ae039 = $4cf737eba0cc3036$var$node;

});

parcelRegister("1yz9H", function(module, exports) {

let $12243c93c8db8bf4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $12243c93c8db8bf4$var$load("bZeJi").then(()=>parcelRequire('iJtUd'));

});




parcelRegister("1sFpf", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormBuilderRouteEntry", () => $b4b68e41808a2055$export$9eb15893d080e73b);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $a2PcO = parcelRequire("a2PcO");

var $d9uEV = parcelRequire("d9uEV");
const $b4b68e41808a2055$export$9eb15893d080e73b = (0, $7NszV.createEntry)((0, $a2PcO.classicBusinessProjectFormBuilderRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $d9uEV.formBuilderPageEntrypoint)
    }));

});
parcelRegister("a2PcO", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormBuilderRoute", () => $939973d6db7f74a6$export$5f684808e671de5);
const $939973d6db7f74a6$export$5f684808e671de5 = {
    name: 'classic-business-form-builder',
    path: '/jira/core/projects/:projectKey/form/:formId/builder',
    exact: true
};

});

parcelRegister("d9uEV", function(module, exports) {

$parcel$export(module.exports, "formBuilderPageEntrypoint", () => $69b26f1a607bfd2a$export$e0f4bcb9440be5eb);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $3SMwn = parcelRequire("3SMwn");

var $fo6b8 = parcelRequire("fo6b8");
const $69b26f1a607bfd2a$export$e0f4bcb9440be5eb = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3SMwn.formBuilderEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("3SMwn", function(module, exports) {

$parcel$export(module.exports, "formBuilderEntrypoint", () => $5ed17fe91cd922c4$export$6d3c9fa7232f412c);

var $kNhf9 = parcelRequire("kNhf9");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $5ed17fe91cd922c4$export$6d3c9fa7232f412c = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("6yCXh")), {
        moduleId: "86254720"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formBuilderQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $kNhf9.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("kNhf9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8916cebd6c30ef65$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f4e5285cf738fae5658c117e04609239>>
 * @relayHash d97c7a633d846788784b53e47412dba2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f1558c868f827e5a17035db5860c9c66151d5a49619d6606fa69856264023f5
const $8916cebd6c30ef65$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4f1558c868f827e5a17035db5860c9c66151d5a49619d6606fa69856264023f5",
        "metadata": {},
        "name": "src_jiraBusinessFormBuilderQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8916cebd6c30ef65$export$2e2bcd8739ae039 = $8916cebd6c30ef65$var$node;

});

parcelRegister("6yCXh", function(module, exports) {

let $4c6422c1948977b5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4c6422c1948977b5$var$load("4nk9B").then(()=>parcelRequire('fU1n9'));

});




parcelRegister("a2wNz", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormRouteEntry", () => $78b7bb0633a93217$export$4798edf139084d2e);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $aPjV2 = parcelRequire("aPjV2");

var $7VVhE = parcelRequire("7VVhE");
const $78b7bb0633a93217$export$4798edf139084d2e = (0, $7NszV.createEntry)((0, $aPjV2.classicBusinessProjectFormRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-directory-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $7VVhE.formPageEntrypoint)
    }));

});
parcelRegister("aPjV2", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormRoute", () => $63fab73853b00f48$export$e98776bdf96c88ac);
const $63fab73853b00f48$export$e98776bdf96c88ac = {
    name: 'classic-business-form',
    path: '/jira/core/projects/:projectKey/form',
    exact: true
};

});

parcelRegister("7VVhE", function(module, exports) {

$parcel$export(module.exports, "formPageEntrypoint", () => $32842b78cbaba6f2$export$ebaf30a031a61671);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $13ZHy = parcelRequire("13ZHy");

var $fo6b8 = parcelRequire("fo6b8");
const $32842b78cbaba6f2$export$ebaf30a031a61671 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $13ZHy.formEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("13ZHy", function(module, exports) {

$parcel$export(module.exports, "formEntrypoint", () => $c30c690af04301b5$export$b931eb60522f687a);

var $41sHw = parcelRequire("41sHw");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $c30c690af04301b5$export$b931eb60522f687a = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("9qyKe")), {
        moduleId: "77eafb5a"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $41sHw.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("41sHw", function(module, exports) {

$parcel$export(module.exports, "default", () => $333e5c56ad243628$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f62e7b05d75adf93c826705d7992eb93>>
 * @relayHash 8e0b57fc78588fab5ce6e2ba76089a61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 00dfb7b57058946faf78573ea5754789e6b3e2dd7eab0b5c0a813c3db15e260b
const $333e5c56ad243628$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "00dfb7b57058946faf78573ea5754789e6b3e2dd7eab0b5c0a813c3db15e260b",
        "metadata": {},
        "name": "src_jiraBusinessFormQuery",
        "operationKind": "query",
        "text": null
    }
};
var $333e5c56ad243628$export$2e2bcd8739ae039 = $333e5c56ad243628$var$node;

});

parcelRegister("9qyKe", function(module, exports) {

let $6dd17e4ebc507eff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6dd17e4ebc507eff$var$load("jA7gz").then(()=>parcelRequire('4qzdE'));

});




parcelRegister("eghTD", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitEmbedRouteEntry", () => $ea2f0b4ec45df3b4$export$c2f698be6eedea1a);

var $6e4Kt = parcelRequire("6e4Kt");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $4xJea = parcelRequire("4xJea");

var $MxpLn = parcelRequire("MxpLn");
const $ea2f0b4ec45df3b4$export$c2f698be6eedea1a = (0, $7NszV.createEntry)((0, $4xJea.classicBusinessProjectFormSubmitEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-submit-embed-view',
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $MxpLn.formSubmitEmbedPageEntrypoint)
    }));

});
parcelRegister("4xJea", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitEmbedRoute", () => $bab948378ba6b470$export$7e8fd15fdfa29385);
const $bab948378ba6b470$export$7e8fd15fdfa29385 = {
    name: 'classic-business-form-submit-embed',
    path: '/jira/core/projects/:projectKey/form/:formId/embed',
    exact: true
};

});

parcelRegister("MxpLn", function(module, exports) {

$parcel$export(module.exports, "formSubmitEmbedPageEntrypoint", () => $7b75b9ef7f4c7083$export$93f08d580854f4a7);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $1XDMK = parcelRequire("1XDMK");

var $fo6b8 = parcelRequire("fo6b8");
const $7b75b9ef7f4c7083$export$93f08d580854f4a7 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1XDMK.formSubmitEmbedEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("1XDMK", function(module, exports) {

$parcel$export(module.exports, "formSubmitEmbedEntrypoint", () => $aa01aa42cf2471d0$export$4c748d8ca82fc24);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $aa01aa42cf2471d0$export$4c748d8ca82fc24 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("3Vo6X")), {
        moduleId: "20838510"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3Vo6X", function(module, exports) {

let $2db965f93954b778$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2db965f93954b778$var$load("lY6ya").then(()=>parcelRequire('7H3bY'));

});




parcelRegister("ajYJ1", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitRouteEntry", () => $1ad0e25a3297ce2b$export$bd59a50eb595d1d5);

var $5f2bR = parcelRequire("5f2bR");

var $6e4Kt = parcelRequire("6e4Kt");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $5VxfF = parcelRequire("5VxfF");

var $kimPG = parcelRequire("kimPG");
const $1ad0e25a3297ce2b$export$bd59a50eb595d1d5 = (0, $7NszV.createEntry)((0, $5VxfF.classicBusinessProjectFormSubmitRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-submit-view',
        layout: (0, $6e4Kt.chromelessLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $kimPG.formSubmitPageEntrypoint)
    }));

});
parcelRegister("5VxfF", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitRoute", () => $6637feb602e2c6a2$export$3cd93ff55b29f07f);
const $6637feb602e2c6a2$export$3cd93ff55b29f07f = {
    name: 'classic-business-form-submit',
    path: '/jira/core/projects/:projectKey/form/:formId',
    exact: true
};

});

parcelRegister("kimPG", function(module, exports) {

$parcel$export(module.exports, "formSubmitPageEntrypoint", () => $86d107866af1a870$export$26755d0805847061);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $ap0Y4 = parcelRequire("ap0Y4");
const $86d107866af1a870$export$26755d0805847061 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $ap0Y4.formSubmitEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("ap0Y4", function(module, exports) {

$parcel$export(module.exports, "formSubmitEntrypoint", () => $b9d2e58129000f4b$export$d33b8db02e0a0cb5);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $b9d2e58129000f4b$export$d33b8db02e0a0cb5 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("4jxfJ")), {
        moduleId: "1cf8636b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4jxfJ", function(module, exports) {

let $3242bb0f017674f2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3242bb0f017674f2$var$load("d9GTB").then(()=>parcelRequire('hcjUE'));

});




parcelRegister("huQRU", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitPublicRouteEntry", () => $8ba2931eff60855d$export$69d2365670c516de);

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $82Fi7 = parcelRequire("82Fi7");

var $6s1PB = parcelRequire("6s1PB");

var $6LsQE = parcelRequire("6LsQE");

var $2Ql51 = parcelRequire("2Ql51");

var $eRU3k = parcelRequire("eRU3k");
const $8ba2931eff60855d$export$69d2365670c516de = (0, $7NszV.createEntry)((0, $82Fi7.classicBusinessProjectFormSubmitPublicRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-submit-public-view',
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $2Ql51.themePreferenceResource)
        ],
        entryPoint: ()=>(0, $6s1PB.expVal)('jira_forms_public_access_experiment', 'isEnabled', 'false') ? (0, $eRU3k.formSubmitPageEntrypoint) : (0, $6LsQE.notFoundPageEntrypoint)
    }));

});
parcelRegister("82Fi7", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitPublicRoute", () => $93f319f0fd75fd27$export$865063615075df54);
const $93f319f0fd75fd27$export$865063615075df54 = {
    name: 'classic-business-form-submit-public',
    path: '/jira/core/form/:formUuid',
    exact: true
};

});

parcelRegister("6LsQE", function(module, exports) {

$parcel$export(module.exports, "notFoundPageEntrypoint", () => $8a0b47b5f1d82a69$export$eb748b014da0ac9a);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $6ApJI = parcelRequire("6ApJI");
const $8a0b47b5f1d82a69$export$eb748b014da0ac9a = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6ApJI.notFoundEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).HOME
});

});
parcelRegister("6ApJI", function(module, exports) {

$parcel$export(module.exports, "notFoundEntrypoint", () => $04e61a5f550e74fe$export$7fdee4826a30b643);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $04e61a5f550e74fe$export$7fdee4826a30b643 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("3p5C2")), {
        moduleId: "4e8af128"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("eRU3k", function(module, exports) {

$parcel$export(module.exports, "formSubmitPageEntrypoint", () => $605ab26c97fbe982$export$26755d0805847061);

var $lkFvK = parcelRequire("lkFvK");

var $iGgme = parcelRequire("iGgme");
const $605ab26c97fbe982$export$26755d0805847061 = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $iGgme.formSubmitPublicEntrypoint)
});

});
parcelRegister("iGgme", function(module, exports) {

$parcel$export(module.exports, "formSubmitPublicEntrypoint", () => $ea12db6778cfe8c5$export$345530940ab03dbd);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $ea12db6778cfe8c5$export$345530940ab03dbd = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("2S7i0")), {
        moduleId: "d418c43d"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2S7i0", function(module, exports) {

let $217647712f71f6d4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $217647712f71f6d4$var$load("jbJnV").then(()=>parcelRequire('hkafd'));

});




parcelRegister("47CVY", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectPagesRouteEntry", () => $64d1b6dc76e76b9d$export$7a55e12f93813823);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $a0g4h = parcelRequire("a0g4h");

var $cRzP7 = parcelRequire("cRzP7");
const $64d1b6dc76e76b9d$export$7a55e12f93813823 = (0, $7NszV.createEntry)((0, $a0g4h.classicBusinessProjectPagesRoute), ()=>({
        group: 'classic-business',
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource)
        ],
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        ufoName: 'jwm.jwm-pages',
        entryPoint: ()=>(0, $cRzP7.pagesPageEntrypoint)
    }));

});
parcelRegister("a0g4h", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectPagesRoute", () => $c3d7ad3cf5e0901f$export$573cc697c2d33124);
const $c3d7ad3cf5e0901f$export$573cc697c2d33124 = {
    name: 'project-pages',
    path: '/jira/core/projects/:projectKey/pages'
};

});

parcelRegister("cRzP7", function(module, exports) {

$parcel$export(module.exports, "pagesPageEntrypoint", () => $7e318392f3d5106d$export$4ce394de88f5b54a);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $i0f3c = parcelRequire("i0f3c");

var $fo6b8 = parcelRequire("fo6b8");
const $7e318392f3d5106d$export$4ce394de88f5b54a = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $i0f3c.pagesEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("i0f3c", function(module, exports) {

$parcel$export(module.exports, "pagesEntrypoint", () => $cc22f4626e458394$export$49834d404673808c);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $cc22f4626e458394$export$49834d404673808c = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("dUcqX")), {
        moduleId: "671532d1"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dUcqX", function(module, exports) {

let $a1fa266a1f8c2623$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a1fa266a1f8c2623$var$load("lKmFv").then(()=>parcelRequire('719qB'));

});




parcelRegister("hfeIi", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectSampleOnboardingRouteEntry", () => $c7f4c7d963439815$export$d047e2b436470b0a);

var $6e4Kt = parcelRequire("6e4Kt");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $7Zyb9 = parcelRequire("7Zyb9");

var $7wcBz = parcelRequire("7wcBz");
const $c7f4c7d963439815$export$d047e2b436470b0a = (0, $7NszV.createEntry)((0, $7Zyb9.classicBusinessProjectSampleOnboardingRoute), ()=>({
        group: 'classic-business',
        component: (0, $7wcBz.default),
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: (0, $3RJkv.getNavigationResources)(),
        forPaint: [
            (0, $7wcBz.LazySampleOnboardingView)
        ]
    }));

});
parcelRegister("7Zyb9", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectSampleOnboardingRoute", () => $cc13a94c19681f9f$export$cd9c218d7c968d2d);
const $cc13a94c19681f9f$export$cd9c218d7c968d2d = {
    name: 'classic-business-sample-onboarding',
    path: '/jira/core/sample/onboarding/:taskId',
    exact: true
};

});

parcelRegister("7wcBz", function(module, exports) {

$parcel$export(module.exports, "LazySampleOnboardingView", () => $d8c7c044abd4283c$export$e39375ab6521f3ef);
$parcel$export(module.exports, "default", () => $d8c7c044abd4283c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $d8c7c044abd4283c$export$e39375ab6521f3ef = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("6ot9k")), {
    moduleId: "./src/packages/spa-apps/business/sample-onboarding/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d8c7c044abd4283c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d8c7c044abd4283c$export$e39375ab6521f3ef,
        pageId: "async-business-sample-onboarding",
        shouldShowSpinner: true
    });

});
parcelRegister("6ot9k", function(module, exports) {

let $4a7b986b2478857a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4a7b986b2478857a$var$load("lkM4h").then(()=>parcelRequire('ePHET'));

});



parcelRegister("hF0nU", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectShortcutRouteEntry", () => $4d5ae7b8b70c8e78$export$22248cc626626132);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $403gp = parcelRequire("403gp");

var $6JJeH = parcelRequire("6JJeH");
const $4d5ae7b8b70c8e78$export$22248cc626626132 = (0, $7NszV.createEntry)((0, $403gp.classicBusinessProjectShortcutRoute), ()=>({
        group: 'classic-business',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $6JJeH.shortcutsPageEntrypoint)
    }));

});
parcelRegister("403gp", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectShortcutRoute", () => $60aa8b153682dfa1$export$2dd4e8a37d8ac978);
const $60aa8b153682dfa1$export$2dd4e8a37d8ac978 = {
    name: 'classic-business-shortcut',
    path: '/jira/core/projects/:projectKey/shortcuts',
    exact: true
};

});

parcelRegister("6JJeH", function(module, exports) {

$parcel$export(module.exports, "shortcutsPageEntrypoint", () => $19b2198152d557fa$export$57a2f1af23fcbb8b);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $8qyT8 = parcelRequire("8qyT8");

var $fo6b8 = parcelRequire("fo6b8");
const $19b2198152d557fa$export$57a2f1af23fcbb8b = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8qyT8.shortcutsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("8qyT8", function(module, exports) {

$parcel$export(module.exports, "shortcutsEntrypoint", () => $2c08d7e07e3e2760$export$212fd76838eeb6ad);

var $hSK0t = parcelRequire("hSK0t");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $2c08d7e07e3e2760$export$212fd76838eeb6ad = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("7WuLH")), {
        moduleId: "736f6fc2"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                shortcutsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $hSK0t.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("hSK0t", function(module, exports) {

$parcel$export(module.exports, "default", () => $c56df58cb6ff2ae3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<571227a0b71f1eebd07db7bde4b71b10>>
 * @relayHash f251714abaead8d7f256f75b2cbcdd4e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b84b6702f8ba5906f411cf39e6585519029e426840a702a9fe6d1e6e094c95e
const $c56df58cb6ff2ae3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "1b84b6702f8ba5906f411cf39e6585519029e426840a702a9fe6d1e6e094c95e",
        "metadata": {},
        "name": "src_jiraBusinessShortcutsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c56df58cb6ff2ae3$export$2e2bcd8739ae039 = $c56df58cb6ff2ae3$var$node;

});

parcelRegister("7WuLH", function(module, exports) {

let $5c85d11da0ff1af1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5c85d11da0ff1af1$var$load("dsiAd"),
    $5c85d11da0ff1af1$var$load("dczku")
]).then(()=>parcelRequire('7WItf'));

});




parcelRegister("ejDmq", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectViewNotFoundRouteEntry", () => $c521464132416e2d$export$e23e06ae81848c38);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $8RNDo = parcelRequire("8RNDo");

var $1g8oF = parcelRequire("1g8oF");
const $c521464132416e2d$export$e23e06ae81848c38 = (0, $7NszV.createEntry)((0, $8RNDo.classicBusinessProjectViewNotFoundRoute), ()=>({
        group: 'classic-business',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $1g8oF.projectViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("8RNDo", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectViewNotFoundRoute", () => $20583b3f5bf95ee3$export$1194a530fb12fc37);
const $20583b3f5bf95ee3$export$1194a530fb12fc37 = {
    name: 'classic-business-view-not-found',
    path: '/jira/core/projects/:projectKey/not-found',
    exact: true
};

});

parcelRegister("1g8oF", function(module, exports) {

$parcel$export(module.exports, "projectViewNotFoundPageEntrypoint", () => $cdbfface63bc99c3$export$31e63eef3cc009c6);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $bclj6 = parcelRequire("bclj6");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

const $cdbfface63bc99c3$var$main = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("gHpXJ")), {
        moduleId: "24c3dcc7",
        moduleName: "ProjectViewNotFound"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                mainQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $bclj6.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});
const $cdbfface63bc99c3$export$31e63eef3cc009c6 = (0, $lkFvK.createPageEntryPoint)({
    main: $cdbfface63bc99c3$var$main,
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("bclj6", function(module, exports) {

$parcel$export(module.exports, "default", () => $70fb7cc296b150fc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c9a08656b81123b3a899ed443afd14f3>>
 * @relayHash 4f9cc1b4eefda38b80dcbc5247f75776
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4e080d38c866eb2caaf06903fd96c2653d506a6f20f6ba761d204c141a5466d9
const $70fb7cc296b150fc$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4e080d38c866eb2caaf06903fd96c2653d506a6f20f6ba761d204c141a5466d9",
        "metadata": {},
        "name": "ProjectViewNotFoundQuery",
        "operationKind": "query",
        "text": null
    }
};
var $70fb7cc296b150fc$export$2e2bcd8739ae039 = $70fb7cc296b150fc$var$node;

});

parcelRegister("gHpXJ", function(module, exports) {

let $c284cd17c92c4d6d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c284cd17c92c4d6d$var$load("7wi5E").then(()=>parcelRequire('8HTcg'));

});



parcelRegister("9yqzH", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessListEmbedRouteEntry", () => $965e54647b28fbce$export$a6737d9a8c0f9d4f);

var $6e4Kt = parcelRequire("6e4Kt");

var $lkFvK = parcelRequire("lkFvK");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $jwVzG = parcelRequire("jwVzG");

var $dfTsw = parcelRequire("dfTsw");
const $965e54647b28fbce$var$listEmbedPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $dfTsw.listEmbedEntryPoint)
});
const $965e54647b28fbce$export$a6737d9a8c0f9d4f = (0, $7NszV.createEntry)((0, $jwVzG.jiraBusinessListEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.list-embed-view',
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        entryPoint: ()=>$965e54647b28fbce$var$listEmbedPageEntryPoint,
        resources: (0, $lNicp.getProjectViewResources)()
    }));

});
parcelRegister("jwVzG", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessListEmbedRoute", () => $9db7312602117a3c$export$40306068630dfc2);
const $9db7312602117a3c$export$40306068630dfc2 = {
    name: 'classic-business-list-embed',
    path: '/jira/core/projects/:projectKey/list/embed',
    exact: true
};

});

parcelRegister("dfTsw", function(module, exports) {

$parcel$export(module.exports, "listEmbedEntryPoint", () => $4eb9b872b8483ed3$export$519bb55e1612f243);

var $EVQo4 = parcelRequire("EVQo4");

var $iptXe = parcelRequire("iptXe");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");
const $4eb9b872b8483ed3$var$FORMAT_RULES_FIRST = 20;

const $4eb9b872b8483ed3$export$519bb55e1612f243 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("gWrWX")), {
        moduleId: "543152bd"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $iptXe.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $EVQo4.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $4eb9b872b8483ed3$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("EVQo4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fc143a99d34d8f4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5883fb1edc7ab15af020f0e2872a12f9>>
 * @relayHash fe655b1c8f3fbc00448359fc7bbdb4a2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19617cae23dba3619feb6b7d7006b077c3444a7b0f92752732863a7b7f39d16b
const $6fc143a99d34d8f4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "19617cae23dba3619feb6b7d7006b077c3444a7b0f92752732863a7b7f39d16b",
        "metadata": {},
        "name": "formatRulesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6fc143a99d34d8f4$export$2e2bcd8739ae039 = $6fc143a99d34d8f4$var$node;

});

parcelRegister("iptXe", function(module, exports) {

$parcel$export(module.exports, "default", () => $286e0bf23cd75683$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3fbad09b7a5f56fa90258f09408fcab9>>
 * @relayHash 09e2853d076a3827094f0b2a31a60cad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e0425937923f1cfadd146be550944e5e36b0ec94fb0732af23a465a8c1c70cf5
const $286e0bf23cd75683$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e0425937923f1cfadd146be550944e5e36b0ec94fb0732af23a465a8c1c70cf5",
        "metadata": {},
        "name": "src_jiraBusinessListEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $286e0bf23cd75683$export$2e2bcd8739ae039 = $286e0bf23cd75683$var$node;

});

parcelRegister("gWrWX", function(module, exports) {

let $c557be6a602377cd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c557be6a602377cd$var$load("h2MrD"),
    $c557be6a602377cd$var$load("bYT2S"),
    $c557be6a602377cd$var$load("lOtTG")
]).then(()=>parcelRequire('ik71Z'));

});



parcelRegister("gxVJf", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessListRouteEntry", () => $ea798fc0f4203cc1$export$9ef24aa950399eaf);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $hCAN5 = parcelRequire("hCAN5");

var $2C7sQ = parcelRequire("2C7sQ");

var $fo6b8 = parcelRequire("fo6b8");
const $ea798fc0f4203cc1$var$listPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $2C7sQ.listEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $ea798fc0f4203cc1$export$9ef24aa950399eaf = (0, $7NszV.createEntry)((0, $hCAN5.jiraBusinessListRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.list-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        entryPoint: ()=>$ea798fc0f4203cc1$var$listPageEntryPoint,
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)()
    }));

});
parcelRegister("hCAN5", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessListRoute", () => $257b3e3c032338e6$export$ea171f7670960cff);
const $257b3e3c032338e6$export$ea171f7670960cff = {
    name: 'classic-business-list',
    path: '/jira/core/projects/:projectKey/list',
    exact: true
};

});

parcelRegister("2C7sQ", function(module, exports) {

$parcel$export(module.exports, "listEntryPoint", () => $7b34153964734d60$export$6be4f10150ff6073);

var $EVQo4 = parcelRequire("EVQo4");

var $91hzp = parcelRequire("91hzp");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");
const $7b34153964734d60$var$FORMAT_RULES_FIRST = 20;

const $7b34153964734d60$export$6be4f10150ff6073 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("82YZh")), {
        moduleId: "b03343a1"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $91hzp.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $EVQo4.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $7b34153964734d60$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("91hzp", function(module, exports) {

$parcel$export(module.exports, "default", () => $169ed3aa08e6bba7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9516f6b957580a1dd0913ff88ae3e10d>>
 * @relayHash 8ab96395b697c5b81fab0afb4eebcfef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e0cc007557fb53672f36f25ae9fd169cd95e4b69654d21b1f471f604abc11db8
const $169ed3aa08e6bba7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e0cc007557fb53672f36f25ae9fd169cd95e4b69654d21b1f471f604abc11db8",
        "metadata": {},
        "name": "src_jiraBusinessListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $169ed3aa08e6bba7$export$2e2bcd8739ae039 = $169ed3aa08e6bba7$var$node;

});

parcelRegister("82YZh", function(module, exports) {

let $5dbdd1725f2d9dae$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5dbdd1725f2d9dae$var$load("h2MrD"),
    $5dbdd1725f2d9dae$var$load("bYT2S"),
    $5dbdd1725f2d9dae$var$load("5NrjM")
]).then(()=>parcelRequire('zU4ax'));

});



parcelRegister("c1v6Y", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessOverviewRedirectRouteEntry", () => $653443b3f7416d46$export$3aa9116f715693e1);

var $ffza4 = parcelRequire("ffza4");

var $l71WK = parcelRequire("l71WK");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bG2it = parcelRequire("bG2it");

var $6475a = parcelRequire("6475a");
const $653443b3f7416d46$export$3aa9116f715693e1 = (0, $7NszV.createEntry)((0, $bG2it.jiraBusinessOverviewRedirectRoute), ()=>({
        group: 'classic-business',
        isRedirect: true,
        component: (0, $6475a.default),
        layout: (0, $lRPBw.businessProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $l71WK.AsyncHorizontalOverviewNav)
        },
        resources: (0, $lNicp.getOverviewViewResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("bG2it", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessOverviewRedirectRoute", () => $2d98eac94414a73a$export$5ab0e07528c31349);
const $2d98eac94414a73a$export$5ab0e07528c31349 = {
    name: 'classic-business-overview-redirect',
    path: '/jira/core/overviews/:overviewId',
    exact: true
};

});

parcelRegister("6475a", function(module, exports) {

$parcel$export(module.exports, "default", () => $31755126abaef7af$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");

var $bmKPg = parcelRequire("bmKPg");
const $31755126abaef7af$var$OverviewRedirect = ()=>{
    const [overviewId] = (0, $bmKPg.usePathParam)('overviewId');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/core/overviews/${overviewId}/summary`
    });
};
var $31755126abaef7af$export$2e2bcd8739ae039 = $31755126abaef7af$var$OverviewRedirect;

});


parcelRegister("bZEI9", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessProjectRedirectRouteEntry", () => $8fd82d52927aa17f$export$766e305da4c78de5);

var $ffza4 = parcelRequire("ffza4");

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $hqguB = parcelRequire("hqguB");

var $7MCPm = parcelRequire("7MCPm");
const $8fd82d52927aa17f$export$766e305da4c78de5 = (0, $7NszV.createEntry)((0, $hqguB.jiraBusinessProjectRedirectRoute), ()=>({
        group: 'classic-business',
        isRedirect: true,
        component: (0, $7MCPm.RedirectToLastVisitedProjectPage),
        layout: (0, $lRPBw.businessProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("hqguB", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessProjectRedirectRoute", () => $abd9824736763ae8$export$73b60789ceb8e1eb);
const $abd9824736763ae8$export$73b60789ceb8e1eb = {
    name: 'classic-business-redirect',
    path: '/jira/core/projects/:projectKey',
    exact: true
};

});


parcelRegister("1EihZ", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessSummaryEmbedRouteEntry", () => $f7c860425219110c$export$2c37f93832ff9919);

var $6e4Kt = parcelRequire("6e4Kt");

var $lkFvK = parcelRequire("lkFvK");

var $6s1PB = parcelRequire("6s1PB");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $kqhaB = parcelRequire("kqhaB");

var $3zj3N = parcelRequire("3zj3N");

var $f1r4M = parcelRequire("f1r4M");

var $eASai = parcelRequire("eASai");

var $7yKXN = parcelRequire("7yKXN");

var $4R6GH = parcelRequire("4R6GH");
/**
 * @deprecated delete this entrypoint when cleaning up jwm-summary-page-migration experiment flag
 */ const $f7c860425219110c$var$summaryEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $eASai.summaryEmbedEntrypoint)
});
const $f7c860425219110c$var$summaryEmbedBusimessPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $7yKXN.summaryBusinessEmbedEntrypoint)
});
const $f7c860425219110c$var$getSummaryPageResource = ()=>{
    return [
        ...(0, $4R6GH.fg)('helios_biz_project_remove_rrr') ? [] : [
            (0, $3zj3N.summaryDataResource)
        ],
        ...(0, $4R6GH.fg)('helios_biz_project_fast_activity_feed') ? [] : [
            (0, $kqhaB.activityFeedResource)
        ]
    ];
};
const $f7c860425219110c$export$2c37f93832ff9919 = (0, $7NszV.createEntry)((0, $f1r4M.jiraBusinessSummaryEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.summary-view-embed',
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: [
            ...(0, $lNicp.getProjectViewResources)(),
            ...$f7c860425219110c$var$getSummaryPageResource()
        ],
        entryPoint: ()=>{
            if ((0, $6s1PB.expVal)('jwm-summary-page-migration', 'isEnabled', false)) return $f7c860425219110c$var$summaryEmbedBusimessPageEntrypoint;
            return $f7c860425219110c$var$summaryEmbedPageEntrypoint;
        }
    }));

});
parcelRegister("kqhaB", function(module, exports) {

$parcel$export(module.exports, "activityFeedResource", () => $1609d8a65ae37e85$export$928ea152e5c5de54);
$parcel$export(module.exports, "useActivityFeed", () => $1609d8a65ae37e85$export$ee1fe267047f502f);

var $4NbWL = parcelRequire("4NbWL");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");
const $1609d8a65ae37e85$var$RESOURCE_TYPE_KEY = 'BUSINESS_ACTIVITY_FEED';
const $1609d8a65ae37e85$var$EMPTY_DATA = {
    data: [],
    pageInfo: {
        hasNextPage: false,
        endCursor: ''
    }
};
const $1609d8a65ae37e85$export$928ea152e5c5de54 = (0, $2M1hQ.createResource)({
    type: $1609d8a65ae37e85$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$1609d8a65ae37e85$var$RESOURCE_TYPE_KEY}_${projectKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return $1609d8a65ae37e85$var$EMPTY_DATA;
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        return (0, $4NbWL.fetchActivityFeed)(null, projectKey);
    },
    maxAge: 5000,
    isBrowserOnly: true
});
const $1609d8a65ae37e85$export$ee1fe267047f502f = ()=>// forcing the return type due to react-resource-router's weird error types
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $2YP9W.useResource)($1609d8a65ae37e85$export$928ea152e5c5de54);

});
parcelRegister("4NbWL", function(module, exports) {

$parcel$export(module.exports, "fetchActivityFeed", () => $72e600639fed107e$export$967c92ed76f908b6);

var $gKZoD = parcelRequire("gKZoD");

var $jJZqs = parcelRequire("jJZqs");

var $a8I18 = parcelRequire("a8I18");
const $72e600639fed107e$var$PAGE_SIZE = 10;
const $72e600639fed107e$var$CONTENT_TYPE = 'application/atom+xml; charset=UTF-8';
const $72e600639fed107e$var$STREAM_PROVIDERS = 'thirdparty issues';
const $72e600639fed107e$export$967c92ed76f908b6 = (after, projectKey)=>{
    (0, $gKZoD.di)(fetch);
    const firstIndex = after != null ? Number(after) : 0;
    const maxResults = firstIndex + $72e600639fed107e$var$PAGE_SIZE;
    return fetch(// @ts-expect-error - TS2345: Types of property 'maxResults' are incompatible. Type 'number' is not assignable to type 'string'.
    `/plugins/servlet/streams?${new URLSearchParams({
        maxResults: maxResults,
        relativeLinks: true,
        streams: `key IS ${projectKey}`,
        providers: $72e600639fed107e$var$STREAM_PROVIDERS
    }).toString()}`, {
        headers: {
            'content-type': $72e600639fed107e$var$CONTENT_TYPE
        }
    }).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`);
        return response.text();
    }).then((rawResponse)=>{
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(rawResponse, 'application/xml');
        const entries = (0, $a8I18.transformData)(xmlDoc);
        return {
            data: entries,
            pageInfo: {
                hasNextPage: entries.length >= maxResults,
                endCursor: String(entries.length)
            }
        };
    });
};

});
parcelRegister("a8I18", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $26b06333cc6e5e1f$export$3ceb62baab058c6b);
const $26b06333cc6e5e1f$export$3ceb62baab058c6b = (xmlDoc)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'ActivityFeedItem'.
    const result = [];
    // Typecheck with project references identifies this as error but existing typecheck is not so doesnt allow ts-expect-error, so used ts-ignore
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - Type 'NodeListOf<Element>' must have a '[Symbol.iterator]()' method that returns an iterator.
    for (const entry of xmlDoc.querySelectorAll('entry')){
        const id = entry.querySelector('id')?.textContent ?? '';
        const published = entry.querySelector('published')?.textContent ?? '';
        const name = entry.querySelector('author > name')?.textContent ?? '';
        const title = entry.querySelector('title')?.textContent ?? '';
        const iconUrl = entry.querySelector('[rel="http://streams.atlassian.com/syndication/icon"]')?.getAttribute('href') ?? '';
        const content = entry.querySelector('content')?.textContent;
        const feedItem = {
            id: id,
            author: {
                name: name,
                avatarUrl: ''
            },
            published: published,
            title: title,
            iconUrl: iconUrl,
            content: content
        };
        entry.querySelectorAll('author > link[rel=photo]').forEach((link)=>{
            if (link.getAttribute('media:height') === '48') feedItem.author.avatarUrl = link.getAttribute('href') ?? '';
        });
        result.push(feedItem);
    }
    return result;
};

});



parcelRegister("3zj3N", function(module, exports) {

$parcel$export(module.exports, "summaryDataResource", () => $acdbc5801b5f9bec$export$cdfee963587c1ea4);
$parcel$export(module.exports, "useSummaryData", () => $acdbc5801b5f9bec$export$c82acf736eaa253c);

var $aR4Ot = parcelRequire("aR4Ot");

var $iR3GG = parcelRequire("iR3GG");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");
const $acdbc5801b5f9bec$var$RESOURCE_TYPE_KEY = 'BUSINESS_SUMMARY_DATA';
const $acdbc5801b5f9bec$var$EMPTY_DATA = {
    overviewItems: null,
    issuesByStatus: null,
    issuesByPriority: null,
    issuesByAssignee: null,
    issuesByType: null,
    workflowsCount: null
};
const $acdbc5801b5f9bec$export$cdfee963587c1ea4 = (0, $2M1hQ.createResource)({
    type: $acdbc5801b5f9bec$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$acdbc5801b5f9bec$var$RESOURCE_TYPE_KEY}_${projectKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return $acdbc5801b5f9bec$var$EMPTY_DATA;
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        const jqlContext = `project = "${projectKey}"`;
        try {
            return await (0, $aR4Ot.fetchSummaryPageData)({
                cloudId: cloudId,
                jqlContext: jqlContext,
                projectKey: projectKey
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            throw (0, $iR3GG.createResourceError)({
                component: 'spa.view.routes.business.summary-data.getData',
                message: `An error was thrown while prefetching the summary data. Status code: ${error?.statusCode}. Message: ${error?.message}`,
                name: 'ResourceError',
                skipSentry: isClientError
            });
        }
    },
    maxAge: 5000,
    isBrowserOnly: true
});
const $acdbc5801b5f9bec$export$c82acf736eaa253c = ()=>// forcing the return type due to react-resource-router's weird error types
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $2YP9W.useResource)($acdbc5801b5f9bec$export$cdfee963587c1ea4);

});
parcelRegister("aR4Ot", function(module, exports) {

$parcel$export(module.exports, "fetchSummaryPageData", () => $86d3799d8fb43b74$export$a3fa5b61d6f8cf86);

var $jlq4V = parcelRequire("jlq4V");

var $6s1PB = parcelRequire("6s1PB");

var $eusud = parcelRequire("eusud");


var $6FqTo = parcelRequire("6FqTo");

var $7P4vu = parcelRequire("7P4vu");
const $86d3799d8fb43b74$var$QUERY_NAME = 'SummaryPageData';
const $86d3799d8fb43b74$export$a3fa5b61d6f8cf86 = async ({ cloudId: cloudId, jqlContext: jqlContext, projectKey: projectKey })=>{
    // We must use UNSAFE_noExposureExp to check if experiment is enabled without actually firing exposure events
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expInlineStatusConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('business_summary_page_inline_status');
    const isExperimentSummaryPageInlineStatusEnabled = expInlineStatusConfig.get('isInlineStatusChangeEnabled', false);
    const response = await (0, $eusud.performPostRequest)(`/rest/gira/1/?operation=${$86d3799d8fb43b74$var$QUERY_NAME}`, {
        body: JSON.stringify({
            query: (0, $6s1PB.expVal)('jwm-summary-page-migration', 'isEnabled', false) ? (0, $6FqTo.SUMMARY_PAGE_DATA_QUERY) : (0, $6FqTo.SUMMARY_PAGE_DATA_QUERY_OLD),
            variables: {
                cloudId: cloudId,
                jqlContext: jqlContext,
                // unused variable for the new GQL query
                projectKey: (0, $6s1PB.expVal)('jwm-summary-page-migration', 'isEnabled', false) ? undefined : projectKey,
                doneThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$d5aac1de7fafa2b0)}`,
                updatedThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$b10a33c38cc20983)}`,
                createdThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$48eb4b4c930c6378)}`,
                dueThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$2573f5b8014b4068)}`,
                issuesByStatusJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$8cca17e1017ba894)}`,
                issuesByPriorityJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                issuesByAssigneeJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                issuesByTypeJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                pagedDataPageSize: (0, $cd053842fd66588d$export$c0ecd9bd08a86184),
                // unused variable for the new GQL query
                isWorkflowsCountEnabled: (0, $6s1PB.expVal)('jwm-summary-page-migration', 'isEnabled', false) ? undefined : isExperimentSummaryPageInlineStatusEnabled
            }
        })
    });
    if (response.errors != null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
    if (response.data == null) throw new Error('GraphQL response has no data');
    return (0, $7P4vu.transformData)(response.data);
};

});
const $cd053842fd66588d$export$d5aac1de7fafa2b0 = 'statusCategory = Done AND statusCategoryChangedDate >= -1w';
const $cd053842fd66588d$export$b10a33c38cc20983 = 'updatedDate >= -1w';
const $cd053842fd66588d$export$48eb4b4c930c6378 = 'createdDate >= -1w';
const $cd053842fd66588d$export$2573f5b8014b4068 = 'statusCategory != Done AND (duedate >= 0d AND duedate < 1w)';
const $cd053842fd66588d$export$8cca17e1017ba894 = '(statusCategory != Done OR (statusCategory = Done AND statusCategoryChangedDate >= -2w))';
const $cd053842fd66588d$export$c49e48bfa75ab23c = 'statusCategory != Done';
const $cd053842fd66588d$export$c0ecd9bd08a86184 = 8;
const $cd053842fd66588d$export$27f4fb65edc908d0 = `
  fragment IssuesByAssigneeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on UserField {
          userValue {
            accountId,
            avatarUrl,
            displayName
          }
        }
      }
      id,
      totalCount
    }
  }
`;
const $cd053842fd66588d$export$5b2a5373659a0414 = `
  fragment IssuesByTypeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on IssueTypeField {
              id
              name
              iconUrl
        }
      }
      id,
      totalCount
    }
  }
`;

parcelRegister("6FqTo", function(module, exports) {

$parcel$export(module.exports, "SUMMARY_PAGE_DATA_QUERY_OLD", () => $7511339abc68f96a$export$d825244d8ba23e54);
$parcel$export(module.exports, "SUMMARY_PAGE_DATA_QUERY", () => $7511339abc68f96a$export$7ea8f81ff5bf6361);

const $7511339abc68f96a$export$d825244d8ba23e54 = `
  query JiraBusinessSummaryPageData($cloudId: ID!, $jqlContext: String!, $doneThisWeekJql: String!, $updatedThisWeekJql: String!, $createdThisWeekJql: String!, $dueThisWeekJql: String!, $issuesByStatusJql: String!, $issuesByPriorityJql: String!, $issuesByAssigneeJql: String!, $issuesByTypeJql: String!, $pagedDataPageSize: Int!, $projectKey: String!, $isWorkflowsCountEnabled: Boolean!) {
    jira {
      jqlBuilder(cloudId: $cloudId) {
        status: fieldValues(
          jqlTerm: "status"
          jqlContext: $jqlContext
          viewContext: JWM
        ) {
          edges {
            node {
              jqlTerm
              displayName
            }
          }
        }
      }
      doneThisWeek: jwmViewItems(cloudId: $cloudId, jql: $doneThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      updatedThisWeek: jwmViewItems(cloudId: $cloudId, jql: $updatedThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      createdThisWeek: jwmViewItems(cloudId: $cloudId, jql: $createdThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      dueThisWeek: jwmViewItems(cloudId: $cloudId, jql: $dueThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      totalUnresolvedIssues: jwmViewItems(cloudId: $cloudId, jql: $issuesByAssigneeJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
    }
    issuesByStatus: jwmItemGroups(jql: $issuesByStatusJql, groupByFieldId: "status", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on StatusField {
              name
							statusId
              category {
                key
              }
          }
        }
        totalCount
      }
    }
    issuesByPriority: jwmItemGroups(jql: $issuesByPriorityJql, groupByFieldId: "priority", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on PriorityField {
            iconUrl
            name
          }
        }
        totalCount
      }
    }
    issuesByAssignee: jwmItemGroups(jql: $issuesByAssigneeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "assignee", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByAssigneeFragment
    }
    issuesByType: jwmItemGroups(jql: $issuesByTypeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "issuetype", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByTypeFragment
    }
    workflowsCount: jwmWorkflowWithIssueTypes(projectIdOrKey: $projectKey) @include(if: $isWorkflowsCountEnabled) {
      totalCount
    }
  }

  ${(0, $cd053842fd66588d$export$27f4fb65edc908d0)}
  ${(0, $cd053842fd66588d$export$5b2a5373659a0414)}
`;
const $7511339abc68f96a$export$7ea8f81ff5bf6361 = `
  query JiraBusinessSummaryPageData($cloudId: ID!, $jqlContext: String!, $doneThisWeekJql: String!, $updatedThisWeekJql: String!, $createdThisWeekJql: String!, $dueThisWeekJql: String!, $issuesByStatusJql: String!, $issuesByPriorityJql: String!, $issuesByAssigneeJql: String!, $issuesByTypeJql: String!, $pagedDataPageSize: Int!) {
    jira {
      jqlBuilder(cloudId: $cloudId) {
        status: fieldValues(
          jqlTerm: "status"
          jqlContext: $jqlContext
          viewContext: JWM
        ) {
          edges {
            node {
              jqlTerm
              displayName
            }
          }
        }
        priority: fieldValues(
          jqlTerm: "priority"
          jqlContext: $jqlContext
          viewContext: JWM
        ) {
          edges {
            node {
              jqlTerm
              displayName
            }
          }
        }
      }
      doneThisWeek: jwmViewItems(cloudId: $cloudId, jql: $doneThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      updatedThisWeek: jwmViewItems(cloudId: $cloudId, jql: $updatedThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      createdThisWeek: jwmViewItems(cloudId: $cloudId, jql: $createdThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      dueThisWeek: jwmViewItems(cloudId: $cloudId, jql: $dueThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      totalUnresolvedIssues: jwmViewItems(cloudId: $cloudId, jql: $issuesByAssigneeJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
    }
    issuesByStatus: jwmItemGroups(jql: $issuesByStatusJql, groupByFieldId: "status", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on StatusField {
              name
							statusId
              category {
                key
              }
          }
        }
        totalCount
      }
    }
    issuesByPriority: jwmItemGroups(jql: $issuesByPriorityJql, groupByFieldId: "priority", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on PriorityField {
            iconUrl
            name
          }
        }
        totalCount
      }
    }
    issuesByAssignee: jwmItemGroups(jql: $issuesByAssigneeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "assignee", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByAssigneeFragment
    }
    issuesByType: jwmItemGroups(jql: $issuesByTypeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "issuetype", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByTypeFragment
    }
  }

  ${(0, $cd053842fd66588d$export$27f4fb65edc908d0)}
  ${(0, $cd053842fd66588d$export$5b2a5373659a0414)}
`;

});

parcelRegister("7P4vu", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $583dacb5a6b553e9$export$3ceb62baab058c6b);

var $6s1PB = parcelRequire("6s1PB");

var $egekd = parcelRequire("egekd");
const $583dacb5a6b553e9$export$3ceb62baab058c6b = (data)=>{
    return {
        overviewItems: {
            doneThisWeek: data.jira.doneThisWeek?.totalCount ?? 0,
            updatedThisWeek: data.jira.updatedThisWeek?.totalCount ?? 0,
            createdThisWeek: data.jira.createdThisWeek?.totalCount ?? 0,
            dueThisWeek: data.jira.dueThisWeek?.totalCount ?? 0
        },
        issuesByStatus: // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data.issuesByStatus?.nodes.map((node)=>({
                id: node.id,
                count: node.totalCount,
                status: {
                    name: node.field.name,
                    statusId: node.field.statusId,
                    jqlTerm: data.jira.jqlBuilder?.status.edges.find((status)=>status.node.displayName === node.field.name)?.node.jqlTerm,
                    category: {
                        key: node.field.category.key
                    }
                }
            })) ?? null,
        issuesByPriority: // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data.issuesByPriority?.nodes.map((node)=>{
            const priorityJqlTerm = data.jira.jqlBuilder?.priority?.edges.find((priority)=>priority.node?.displayName === node.field.name)?.node?.jqlTerm;
            return {
                id: node.id,
                count: node.totalCount,
                priority: {
                    name: node.field.name,
                    iconUrl: node.field.iconUrl,
                    jqlTerm: priorityJqlTerm
                }
            };
        }) ?? null,
        issuesByAssignee: data.issuesByAssignee ? {
            ...(0, $egekd.transformIssuesByAssigneeData)(data.issuesByAssignee),
            totalUnresolvedIssues: data.jira.totalUnresolvedIssues?.totalCount ?? 0
        } : null,
        issuesByType: data.issuesByType ? {
            ...(0, $egekd.transformIssuesByTypeData)(data.issuesByType),
            totalUnresolvedIssues: data.jira.totalUnresolvedIssues?.totalCount ?? 0
        } : null,
        workflowsCount: (0, $6s1PB.expVal)('jwm-summary-page-migration', 'isEnabled', false) ? undefined : data?.workflowsCount?.totalCount ?? null
    };
};

});
parcelRegister("egekd", function(module, exports) {

$parcel$export(module.exports, "transformIssuesByAssigneeData", () => $0d59c4e7b34bf6f1$export$cef1c6c4edf3287b);
$parcel$export(module.exports, "transformIssuesByTypeData", () => $0d59c4e7b34bf6f1$export$bc7f7d59cba70a26);
const $0d59c4e7b34bf6f1$export$cef1c6c4edf3287b = (data)=>({
        pageInfo: {
            hasNextPage: data.pageInfo.hasNextPage,
            endCursor: data.pageInfo.endCursor
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data: data.nodes.map((node)=>({
                id: node.id,
                user: node.field.userValue ? {
                    avatarUrl: node.field.userValue.avatarUrl ?? '',
                    displayName: node.field.userValue.displayName,
                    accountId: node.field.userValue.accountId
                } : null,
                count: node.totalCount
            }))
    });
const $0d59c4e7b34bf6f1$export$bc7f7d59cba70a26 = (data)=>({
        pageInfo: {
            hasNextPage: data.pageInfo.hasNextPage,
            endCursor: data.pageInfo.endCursor
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data: data.nodes.map((node)=>({
                id: node.id,
                issueType: node.field ? {
                    iconUrl: node.field.iconUrl,
                    name: node.field.name,
                    id: node.field.id
                } : null,
                count: node.totalCount
            }))
    });

});




parcelRegister("f1r4M", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessSummaryEmbedRoute", () => $75bf41a31996f0a6$export$d4aa7e677d381961);
const $75bf41a31996f0a6$export$d4aa7e677d381961 = {
    name: 'classic-business-summary-embed',
    path: '/jira/core/projects/:projectKey/summary/embed',
    exact: true
};

});

parcelRegister("eASai", function(module, exports) {

$parcel$export(module.exports, "summaryEmbedEntrypoint", () => $99cc4adc5066587d$export$5a118ab60ce38554);

var $gIFn8 = parcelRequire("gIFn8");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $99cc4adc5066587d$export$5a118ab60ce38554 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("ixMMa")), {
        moduleId: "936313f5"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $gIFn8.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("gIFn8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a7b94e3ffb3bd2f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1a20b087016d45df0229b06077572278>>
 * @relayHash 3820c91496cd6ed2417544137170dd18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c794c308a61b48d1203cad5842636c8f860239cf229202638ed7468403107c2
const $6a7b94e3ffb3bd2f$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "9c794c308a61b48d1203cad5842636c8f860239cf229202638ed7468403107c2",
        "metadata": {},
        "name": "src_jiraBusinessSummaryEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6a7b94e3ffb3bd2f$export$2e2bcd8739ae039 = $6a7b94e3ffb3bd2f$var$node;

});

parcelRegister("ixMMa", function(module, exports) {

let $d80124ed1212253b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d80124ed1212253b$var$load("4uhfd").then(()=>parcelRequire('kB5po'));

});


parcelRegister("7yKXN", function(module, exports) {

$parcel$export(module.exports, "summaryBusinessEmbedEntrypoint", () => $2cd94e1a653bd86e$export$a027511631595373);

var $3N2oG = parcelRequire("3N2oG");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $2cd94e1a653bd86e$export$a027511631595373 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("ipP1i")), {
        moduleId: "bfeee3c2"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $3N2oG.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("3N2oG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dea5c0730559df4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2161716a6a9ddd596df65d397a277cb5>>
 * @relayHash 4f557a85d513d521d9088e7217fed3ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15dd5fffb84db9cd2e32bf1439d87098cf295ac5f7e1bcaae80f031fdad2d763
const $9dea5c0730559df4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "15dd5fffb84db9cd2e32bf1439d87098cf295ac5f7e1bcaae80f031fdad2d763",
        "metadata": {},
        "name": "src_jiraSummaryBusinessEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $9dea5c0730559df4$export$2e2bcd8739ae039 = $9dea5c0730559df4$var$node;

});

parcelRegister("ipP1i", function(module, exports) {

let $d6822345e6ce9bb3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d6822345e6ce9bb3$var$load("dsiAd"),
    $d6822345e6ce9bb3$var$load("5p0Ye")
]).then(()=>parcelRequire('7biA2'));

});



parcelRegister("2IdR0", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessSummaryRouteEntry", () => $388a84b6edfc3b2f$export$66365c0c5e8430d2);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lkFvK = parcelRequire("lkFvK");

var $6s1PB = parcelRequire("6s1PB");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $kqhaB = parcelRequire("kqhaB");

var $3zj3N = parcelRequire("3zj3N");

var $3x7be = parcelRequire("3x7be");

var $7QgtY = parcelRequire("7QgtY");

var $3RnWB = parcelRequire("3RnWB");

var $fo6b8 = parcelRequire("fo6b8");

var $4R6GH = parcelRequire("4R6GH");
/**
 * @deprecated delete this entrypoint when cleaning up jwm-summary-page-migration experiment flag
 */ const $388a84b6edfc3b2f$var$summaryPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7QgtY.summaryEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $388a84b6edfc3b2f$var$summaryBusinessPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3RnWB.summaryBusinessEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $388a84b6edfc3b2f$var$getSummaryPageResource = ()=>{
    return [
        ...(0, $4R6GH.fg)('helios_biz_project_remove_rrr') ? [] : [
            (0, $3zj3N.summaryDataResource)
        ],
        ...(0, $4R6GH.fg)('helios_biz_project_fast_activity_feed') ? [] : [
            (0, $kqhaB.activityFeedResource)
        ]
    ];
};
const $388a84b6edfc3b2f$export$66365c0c5e8430d2 = (0, $7NszV.createEntry)((0, $3x7be.jiraBusinessSummaryRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.summary-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $lNicp.getProjectViewResources)(),
            ...$388a84b6edfc3b2f$var$getSummaryPageResource()
        ],
        entryPoint: ()=>{
            if ((0, $6s1PB.expVal)('jwm-summary-page-migration', 'isEnabled', false)) return $388a84b6edfc3b2f$var$summaryBusinessPageEntrypoint;
            return $388a84b6edfc3b2f$var$summaryPageEntrypoint;
        }
    }));

});
parcelRegister("3x7be", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessSummaryRoute", () => $da1a77dee609f26a$export$ad0ce411d14c71d7);
const $da1a77dee609f26a$export$ad0ce411d14c71d7 = {
    name: 'classic-business-summary',
    path: '/jira/core/projects/:projectKey/summary',
    exact: true
};

});

parcelRegister("7QgtY", function(module, exports) {

$parcel$export(module.exports, "summaryEntrypoint", () => $e408b66321f42c9a$export$3d50a9cba1287544);

var $5o8fa = parcelRequire("5o8fa");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $e408b66321f42c9a$export$3d50a9cba1287544 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("gLeMQ")), {
        moduleId: "75fba772"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $5o8fa.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("5o8fa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e3b5ebe8bc3ce2b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b98870a9a14cc3127b27958d6372112f>>
 * @relayHash c3f96584d95baf5fcb618835c22e3826
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2313ad2fdb6e791eef71a3a51657d606a68b9c66e72b580fa0b63e9475ba0787
const $8e3b5ebe8bc3ce2b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2313ad2fdb6e791eef71a3a51657d606a68b9c66e72b580fa0b63e9475ba0787",
        "metadata": {},
        "name": "src_jiraBusinessSummaryQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8e3b5ebe8bc3ce2b$export$2e2bcd8739ae039 = $8e3b5ebe8bc3ce2b$var$node;

});

parcelRegister("gLeMQ", function(module, exports) {

let $c33c817a1726c427$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c33c817a1726c427$var$load("8VzxY").then(()=>parcelRequire('j5uWP'));

});


parcelRegister("3RnWB", function(module, exports) {

$parcel$export(module.exports, "summaryBusinessEntrypoint", () => $52c89b30c31bd0d6$export$1655de4ea7d4bb73);

var $ixLIQ = parcelRequire("ixLIQ");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $52c89b30c31bd0d6$export$1655de4ea7d4bb73 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("63t54")), {
        moduleId: "e788cf2e"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $ixLIQ.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("ixLIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $27bcdcea8e0fdaf7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e999f38de92db02cb900ff3e39b1c9b5>>
 * @relayHash e1db5ab6de3c01b21716a8934a36cc9b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0b047866626fc08071e5717fa8caf4a6c7867aefae410e0168cbc01019589055
const $27bcdcea8e0fdaf7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "0b047866626fc08071e5717fa8caf4a6c7867aefae410e0168cbc01019589055",
        "metadata": {},
        "name": "src_jiraSummaryBusinessQuery",
        "operationKind": "query",
        "text": null
    }
};
var $27bcdcea8e0fdaf7$export$2e2bcd8739ae039 = $27bcdcea8e0fdaf7$var$node;

});

parcelRegister("63t54", function(module, exports) {

let $468994b664cba608$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $468994b664cba608$var$load("dsiAd"),
    $468994b664cba608$var$load("5uUNf")
]).then(()=>parcelRequire('eGmqi'));

});



parcelRegister("cZPPs", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessTimelineEmbedRouteEntry", () => $1c46fc585f965612$export$ef65a62ced1a9df1);

var $6e4Kt = parcelRequire("6e4Kt");

var $lkFvK = parcelRequire("lkFvK");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $1kHS4 = parcelRequire("1kHS4");

var $2vlnX = parcelRequire("2vlnX");

var $1FhoW = parcelRequire("1FhoW");
const $1c46fc585f965612$var$timelineEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $1FhoW.timelineEntrypoint)
});
const $1c46fc585f965612$var$legacyimelineEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $2vlnX.timelineEmbedEntrypoint)
});
const $1c46fc585f965612$export$ef65a62ced1a9df1 = (0, $7NszV.createEntry)((0, $1kHS4.jiraBusinessTimelineEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.timeline-embed-view',
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>/**
			 * IMPORTANT - we can't use `isJiraTimelineHarmonisationM1Enabled`
			 * here, as static route generation needs us to use `expValEquals`
			 * and `fg` directly. Any changes to this logic must be duplicated
			 * in `@atlassian/jira-business-timeline-rollout`
			 */ // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $6s1PB.expValEquals)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', true) && (0, $4R6GH.fg)('refactor_nin_to_jira_view_schema') && (0, $4R6GH.fg)('jira_list_hierarchy_extraction') && (0, $6s1PB.expValEquals)('jira_timeline_harmonisation_m1', 'isEnabled', true) ? $1c46fc585f965612$var$timelineEmbedPageEntrypoint : $1c46fc585f965612$var$legacyimelineEmbedPageEntrypoint
    }));

});
parcelRegister("1kHS4", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessTimelineEmbedRoute", () => $12b838a84c0952a0$export$d85fbccfa0ba559a);
const $12b838a84c0952a0$export$d85fbccfa0ba559a = {
    name: 'classic-business-timeline-embed',
    path: '/jira/core/projects/:projectKey/timeline/embed',
    exact: true
};

});

parcelRegister("2vlnX", function(module, exports) {

$parcel$export(module.exports, "timelineEmbedEntrypoint", () => $94157aa0ce3558d4$export$12a9d017aa53985f);

var $6orcY = parcelRequire("6orcY");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $94157aa0ce3558d4$export$12a9d017aa53985f = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("3US2w")), {
        moduleId: "88bc99ab"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                timelineEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $6orcY.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("6orcY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c96eaccedf3004ad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c25e21ec05fd2b676e0b39f50f317308>>
 * @relayHash aaa779177ef49e606102f9e257279c2f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52e90730f9edc63b8e9c272f467903f50d287b068a5e9571a6fd34719bb2539c
const $c96eaccedf3004ad$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "52e90730f9edc63b8e9c272f467903f50d287b068a5e9571a6fd34719bb2539c",
        "metadata": {},
        "name": "src_jiraBusinessTimelineEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c96eaccedf3004ad$export$2e2bcd8739ae039 = $c96eaccedf3004ad$var$node;

});

parcelRegister("3US2w", function(module, exports) {

let $2da0853d6b1fa8a9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2da0853d6b1fa8a9$var$load("d88J6").then(()=>parcelRequire('fm6i9'));

});


parcelRegister("1FhoW", function(module, exports) {

$parcel$export(module.exports, "timelineEntrypoint", () => $081fe9ef67594c5f$export$7586afa83216512a);

var $b8ALi = parcelRequire("b8ALi");

var $esiIm = parcelRequire("esiIm");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");
const $081fe9ef67594c5f$var$and = (clauses)=>{
    return clauses.map((clause)=>clause.trim()).filter((clause)=>clause.length > 0).join(' AND ');
};
const $081fe9ef67594c5f$var$getProjectJql = (projectKey)=>projectKey.length > 0 ? `project = '${projectKey}'` : '';
const $081fe9ef67594c5f$var$getSearchTextJql = (text)=>{
    if (text === undefined || text.trim() === '') return '';
    const sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
    const issueKeyRegex = new RegExp('^([A-Z][A-Z0-9_]+-\\d+)$');
    const japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
    let search = sanitize(text);
    if (issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
};
const $081fe9ef67594c5f$var$buildIssuesSearchInput = (filter = '', text = '', projectKey = '')=>{
    const search = $081fe9ef67594c5f$var$getSearchTextJql(text);
    const project = $081fe9ef67594c5f$var$getProjectJql(projectKey);
    return {
        jql: $081fe9ef67594c5f$var$and([
            search,
            filter,
            project
        ])
    };
};

const $081fe9ef67594c5f$export$7586afa83216512a = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("4rqgs")), {
        moduleId: "ea9f2eb3"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const namespace = 'ISSUE_NAVIGATOR';
        const projectKey = context.match.params.projectKey;
        const { filter: filter, text: text } = context.query;
        if (projectKey == null) throw new Error('Project key missing');
        const fieldSetIds = [
            'issuetype',
            'issuekey',
            'summary',
            'Start date[Date]',
            'duedate'
        ];
        return {
            queries: {
                businessTimelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $b8ALi.default),
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                timelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $esiIm.default),
                    variables: {
                        amountOfColumns: 500,
                        cloudId: cloudId,
                        fieldSetIds: fieldSetIds,
                        fieldSetsInput: {
                            fieldSetIds: fieldSetIds
                        },
                        filterId: null,
                        first: 50,
                        issueSearchInput: $081fe9ef67594c5f$var$buildIssuesSearchInput(filter, text, projectKey),
                        namespace: namespace,
                        projectKey: projectKey,
                        shouldQueryFieldSetsById: false,
                        shouldQueryHasChildren: true,
                        staticViewInput: {
                            isGroupingEnabled: false
                        },
                        viewConfigInput: {
                            viewInput: {
                                namespace: namespace
                            }
                        },
                        viewId: 'list_default'
                    }
                }
            }
        };
    }
});

});
parcelRegister("b8ALi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9449fe427e3fdb1b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b44f9761057ed7ea0b277fcdeb998d61>>
 * @relayHash 91af7345571ae29b0bcaa8c35ba4c2fe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 937f60fcad28d0549884b2d0d71ae578315c0f9d27f22e844f8d3bf73d6dcd99
const $9449fe427e3fdb1b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "937f60fcad28d0549884b2d0d71ae578315c0f9d27f22e844f8d3bf73d6dcd99",
        "metadata": {},
        "name": "src_jiraHarmonisedBusinessTimelineQuery",
        "operationKind": "query",
        "text": null
    }
};
var $9449fe427e3fdb1b$export$2e2bcd8739ae039 = $9449fe427e3fdb1b$var$node;

});

parcelRegister("esiIm", function(module, exports) {

$parcel$export(module.exports, "default", () => $29bb48365820fb9e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c3b22ffa9ed2c14848b19ca8cc635181>>
 * @relayHash c8fb5b6464354fafede1c2581047fbe1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ebf43c056107d5bb691db1df67e3752e72afb4f6128d2ebd9084e96841a8c534

var $5oQtH = parcelRequire("5oQtH");

var $k3PJZ = parcelRequire("k3PJZ");

var $5qm7M = parcelRequire("5qm7M");

var $dttgK = parcelRequire("dttgK");

var $hBvdF = parcelRequire("hBvdF");
const $29bb48365820fb9e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ebf43c056107d5bb691db1df67e3752e72afb4f6128d2ebd9084e96841a8c534",
        "metadata": {},
        "name": "src_timelineQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $k3PJZ.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
        }
    }
};
var $29bb48365820fb9e$export$2e2bcd8739ae039 = $29bb48365820fb9e$var$node;

});
parcelRegister("5oQtH", function(module, exports) {

$parcel$export(module.exports, "default", () => $63783baa7e252f12$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $63783baa7e252f12$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false);
    }
};

});

parcelRegister("k3PJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3084fb4096ebf03f$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $3084fb4096ebf03f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsc_list_reparenting');
    }
};

});

parcelRegister("5qm7M", function(module, exports) {

$parcel$export(module.exports, "default", () => $124cec54bee44ed1$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $124cec54bee44ed1$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsc_inline_editing_field_refactor');
    }
};

});

parcelRegister("dttgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b98ab24c97dab4$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $c7b98ab24c97dab4$var$JscM2FeChangesRelayProvider = {
    get () {
        return (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes');
    }
};
var $c7b98ab24c97dab4$export$2e2bcd8739ae039 = $c7b98ab24c97dab4$var$JscM2FeChangesRelayProvider;

});

parcelRegister("hBvdF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de224b7b5e8adbe$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5de224b7b5e8adbe$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('thor_colourful_single_select_milestone2_gate');
    }
};

});


parcelRegister("4rqgs", function(module, exports) {

let $33be0e989e155754$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $33be0e989e155754$var$load("hPzOn"),
    $33be0e989e155754$var$load("h2MrD"),
    $33be0e989e155754$var$load("bYT2S"),
    $33be0e989e155754$var$load("dsiAd"),
    $33be0e989e155754$var$load("d98eV")
]).then(()=>parcelRequire('izPvq'));

});



parcelRegister("frUin", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessTimelineRouteEntry", () => $a1408a3d6b1a5eeb$export$5725375da49b5772);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lkFvK = parcelRequire("lkFvK");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $54kZi = parcelRequire("54kZi");

var $bOakJ = parcelRequire("bOakJ");

var $1FhoW = parcelRequire("1FhoW");

var $fo6b8 = parcelRequire("fo6b8");
const $a1408a3d6b1a5eeb$var$timelinePageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1FhoW.timelineEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $a1408a3d6b1a5eeb$var$legacyTimelinePageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $bOakJ.timelineEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $a1408a3d6b1a5eeb$export$5725375da49b5772 = (0, $7NszV.createEntry)((0, $54kZi.jiraBusinessTimelineRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.timeline-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>/**
		 * IMPORTANT - we can't use `isJiraTimelineHarmonisationM1Enabled`
		 * here, as static route generation needs us to use `expValEquals`
		 * and `fg` directly. Any changes to this logic must be duplicated
		 * in `@atlassian/jira-business-timeline-rollout`
		 */ // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $6s1PB.expValEquals)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', true) && (0, $4R6GH.fg)('refactor_nin_to_jira_view_schema') && (0, $4R6GH.fg)('jira_list_hierarchy_extraction') && (0, $6s1PB.expValEquals)('jira_timeline_harmonisation_m1', 'isEnabled', true) ? $a1408a3d6b1a5eeb$var$timelinePageEntrypoint : $a1408a3d6b1a5eeb$var$legacyTimelinePageEntrypoint
    }));

});
parcelRegister("54kZi", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessTimelineRoute", () => $d72294ad8bab4281$export$4c71cfbf61bf0bf3);
const $d72294ad8bab4281$export$4c71cfbf61bf0bf3 = {
    name: 'classic-business-timeline',
    path: '/jira/core/projects/:projectKey/timeline',
    exact: true
};

});

parcelRegister("bOakJ", function(module, exports) {

$parcel$export(module.exports, "timelineEntrypoint", () => $49d4c306324fda15$export$7586afa83216512a);

var $6T238 = parcelRequire("6T238");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $49d4c306324fda15$export$7586afa83216512a = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("cETnm")), {
        moduleId: "cac371d1"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                timelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $6T238.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("6T238", function(module, exports) {

$parcel$export(module.exports, "default", () => $5232f385be868c01$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ec0d5db49437667573ca835bd84e9756>>
 * @relayHash 841436c7487840af84c959f83e5a4493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4443dbc3773e515f952da0ae8f171c483657c4548c4768b6b9c144da0822a4f1
const $5232f385be868c01$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4443dbc3773e515f952da0ae8f171c483657c4548c4768b6b9c144da0822a4f1",
        "metadata": {},
        "name": "src_jiraBusinessTimelineQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5232f385be868c01$export$2e2bcd8739ae039 = $5232f385be868c01$var$node;

});

parcelRegister("cETnm", function(module, exports) {

let $93742cef12bb7466$var$load = (parcelRequire("28QjX"))(4);
module.exports = $93742cef12bb7466$var$load("bvt9E").then(()=>parcelRequire('2sFVY'));

});



parcelRegister("difFp", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsDataClassificationsRouteEntry", () => $72c99d901431c503$export$5b0670f37204a43d);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $cSUZZ = parcelRequire("cSUZZ");

var $7GnDe = parcelRequire("7GnDe");

var $gADc2 = parcelRequire("gADc2");

var $5H2aw = parcelRequire("5H2aw");
const $72c99d901431c503$export$5b0670f37204a43d = (0, $7NszV.createEntry)((0, $gADc2.classicProjectSettingsDataClassificationsRoute), ()=>({
        group: 'project-settings-classic',
        component: (0, $5H2aw.default),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5H2aw.LazyDataClassificationsSettings)
        ]
    }));

});
parcelRegister("gADc2", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsDataClassificationsRoute", () => $fa8df43e7f1ddeea$export$952eefa1907e877a);
const $fa8df43e7f1ddeea$export$952eefa1907e877a = {
    name: 'project-settings-classic-data-classifications',
    path: '/plugins/servlet/project-config/:projectKey/data-classifications',
    exact: true
};

});

parcelRegister("5H2aw", function(module, exports) {

$parcel$export(module.exports, "LazyDataClassificationsSettings", () => $b4450c735413409b$export$b8abcf8aa8f4df56);
$parcel$export(module.exports, "default", () => $b4450c735413409b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $b4450c735413409b$export$b8abcf8aa8f4df56 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1LZO6"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b4450c735413409b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b4450c735413409b$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });

});
parcelRegister("1LZO6", function(module, exports) {

let $14aa1fd50776d1e3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $14aa1fd50776d1e3$var$load("6ibtl").then(()=>parcelRequire('9iqsx'));

});



parcelRegister("dH2Tp", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsIssueLayoutRouteEntry", () => $72a8f02a914333fc$export$47b3bdf88a7d176b);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $58ViO = parcelRequire("58ViO");

var $33syc = parcelRequire("33syc");
const $72a8f02a914333fc$export$47b3bdf88a7d176b = (0, $7NszV.createEntry)((0, $58ViO.classicProjectSettingsIssueLayoutRoute), ()=>({
        group: 'project-settings-classic',
        ufoName: 'project-settings.issue-type.jsw-cmp',
        component: (0, $33syc.default),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $33syc.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("58ViO", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsIssueLayoutRoute", () => $3beddbd9a85d45eb$export$c593179674352d0);
const $3beddbd9a85d45eb$export$c593179674352d0 = {
    name: 'project-settings-classic-issue-layout',
    path: '/plugins/servlet/project-config/:projectKey/issuelayout',
    query: [
        'screenId'
    ],
    exact: true
};

});

parcelRegister("33syc", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeSettings", () => $f7c23974aa64ecd2$export$36dcfb52d47cb93a);
$parcel$export(module.exports, "default", () => $f7c23974aa64ecd2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $f7c23974aa64ecd2$export$36dcfb52d47cb93a = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("72vEr"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f7c23974aa64ecd2$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f7c23974aa64ecd2$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

});
parcelRegister("72vEr", function(module, exports) {

let $5201459a429ecedb$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5201459a429ecedb$var$load("h2MrD"),
    $5201459a429ecedb$var$load("bYT2S"),
    $5201459a429ecedb$var$load("6BhXI")
]).then(()=>parcelRequire('8SAZe'));

});



parcelRegister("6xRe5", function(module, exports) {

$parcel$export(module.exports, "compassProductSettingsRouteEntry", () => $8b91974ef292d61a$export$703b5090da478c9c);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $bTLzO = parcelRequire("bTLzO");

var $3RJkv = parcelRequire("3RJkv");

var $2g9Jq = parcelRequire("2g9Jq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $8b91974ef292d61a$var$LazyCompassProductSettingsPage = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6kGqY"))), {
    moduleId: "./src/packages/spa-apps/compass-product-settings/src/index.tsx"
});
const $8b91974ef292d61a$var$CompassProductSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8b91974ef292d61a$var$LazyCompassProductSettingsPage,
        pageId: "async-compass-product-settings",
        shouldShowSpinner: true
    });
const $8b91974ef292d61a$export$703b5090da478c9c = (0, $7NszV.createEntry)((0, $2g9Jq.compassProductSettingsRoute), ()=>({
        group: 'global-settings',
        component: $8b91974ef292d61a$var$CompassProductSettingsComponent,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $bTLzO.compassProductSettingsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $8b91974ef292d61a$var$LazyCompassProductSettingsPage
        ]
    }));

});
parcelRegister("bTLzO", function(module, exports) {

$parcel$export(module.exports, "compassProductSettingsResource", () => $cfea6057f91373db$export$d18ff068d6c25455);
$parcel$export(module.exports, "useCompassProductSettingsResource", () => $cfea6057f91373db$export$6cbcbd11d26ae36f);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $cfea6057f91373db$export$d18ff068d6c25455 = (0, $2M1hQ.createResource)({
    type: (0, $0e2163be65099f64$export$6f0555de4f60e84e),
    getKey: ()=>'state',
    getData: async ()=>{
        try {
            const isCompassEnabledForNewProjects = await (0, $eusud.performGetRequest)(`/rest/api/3/application-properties?key=${(0, $0e2163be65099f64$export$5685d70c20140008)}`).then(({ value: value })=>value.toLowerCase().trim() === 'true');
            return {
                isCompassEnabledForNewProjects: isCompassEnabledForNewProjects
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error?.statusCode === 404) return {
                isCompassEnabledForNewProjects: true
            };
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'compassProductSettingsResource',
                    packageName: 'jiraRouterResourcesCompassProductSettings',
                    teamName: 'compass-lodestone'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
});
const $cfea6057f91373db$export$6cbcbd11d26ae36f = ()=>(0, $2YP9W.useResource)($cfea6057f91373db$export$d18ff068d6c25455);

});
const $0e2163be65099f64$export$6f0555de4f60e84e = 'RESOURCE_TYPE_COMPASS_PRODUCT_SETTINGS';
const $0e2163be65099f64$export$5685d70c20140008 = 'jira.admin.compass.is-enabled-for-new-project';


parcelRegister("2g9Jq", function(module, exports) {

$parcel$export(module.exports, "compassProductSettingsRoute", () => $b5f6af89eb99da17$export$48d633ce1d0d2a0e);
const $b5f6af89eb99da17$export$48d633ce1d0d2a0e = {
    name: 'compass-product-settings',
    path: '/jira/settings/products/compass',
    exact: true
};

});

parcelRegister("6kGqY", function(module, exports) {

let $49c586d8f7d824d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $49c586d8f7d824d5$var$load("8asz0").then(()=>parcelRequire('lIMc4'));

});


parcelRegister("5eLaE", function(module, exports) {

$parcel$export(module.exports, "connectGeneralInvalidRouteEntry", () => $eea4a938c8d518ff$export$d8088cb4e7cc7efd);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $evs4R = parcelRequire("evs4R");

var $cYYI7 = parcelRequire("cYYI7");

var $3wwwB = parcelRequire("3wwwB");
const $eea4a938c8d518ff$export$d8088cb4e7cc7efd = (0, $7NszV.createEntry)((0, $evs4R.connectGeneralInvalidRoute), ()=>({
        group: 'connect',
        layout: (0, $aPfsS.createLayout)(),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $hBv66.genericConnectSidebars)
        },
        component: (0, $3wwwB.default),
        resources: (0, $cYYI7.getGeneralConnectRouteResources)(),
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
            // block transitions to mobile version
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            // block transitions to marketplace app as it requires specialised Connect API -
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3wwwB.LazyGeneralConnect)
        ],
        ufoName: 'jira-connect'
    }));

});
parcelRegister("evs4R", function(module, exports) {

$parcel$export(module.exports, "connectGeneralInvalidRoute", () => $178b17cd972d15af$export$486ffffd0a2797a5);

var $3Ra5L = parcelRequire("3Ra5L");
const $178b17cd972d15af$export$486ffffd0a2797a5 = {
    name: 'connect-general-invalid',
    path: '/plugins/servlet/ac/:addonKey//:moduleKey',
    query: (0, $3Ra5L.CONNECT_GENERAL_QUERY_PARAMS)
};

});
parcelRegister("3Ra5L", function(module, exports) {

$parcel$export(module.exports, "CONNECT_GENERAL_QUERY_PARAMS", () => $0bf6b9f3f002a423$export$2fdb05fdbf78d595);
// must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
const $0bf6b9f3f002a423$export$2fdb05fdbf78d595 = [
    'mobile?!=true',
    'includeWebResources?!=true',
    'classifier?!=json',
    'project.key?',
    'project.id?'
];

});


parcelRegister("cYYI7", function(module, exports) {

$parcel$export(module.exports, "getGeneralConnectRouteResources", () => $7a1fe7edd9b898b4$export$2c86c2f79b80cf77);
$parcel$export(module.exports, "getProjectConnectRouteDefaultResources", () => $7a1fe7edd9b898b4$export$4c06110e7d14ab3c);

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $lNicp = parcelRequire("lNicp");

var $hz6Yb = parcelRequire("hz6Yb");

var $9UABi = parcelRequire("9UABi");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");
const $7a1fe7edd9b898b4$export$2c86c2f79b80cf77 = ()=>[
        ...(0, $lNicp.getBusinessProjectResources)(),
        ...(0, $3RJkv.getNavigationResources)(),
        (0, $atU1t.navigationSidebarGlobalResource),
        ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
        (0, $hz6Yb.connectGeneralResources),
        (0, $bHhiy.getConsolidationStateResource)()
    ];
const $7a1fe7edd9b898b4$export$4c06110e7d14ab3c = ()=>[
        ...(0, $lNicp.getBusinessProjectResources)(),
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
        (0, $9UABi.connectProjectResources)
    ];

});
parcelRegister("hz6Yb", function(module, exports) {

$parcel$export(module.exports, "connectGeneralResources", () => $07e636c36bc19b52$export$f34ab0d904621847);
$parcel$export(module.exports, "useConnectGeneralResource", () => $07e636c36bc19b52$export$53479840ec6d4024);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $07e636c36bc19b52$export$f34ab0d904621847 = (0, $2M1hQ.createResource)({
    type: (0, $1130bd470474fe6f$export$d5eed449bb62d4c1),
    getKey: ({ match: { params: { addonKey: addonKey, moduleKey: moduleKey } } })=>{
        // spa-router/src/common/types.js:
        /** TODO we are supporting `undefined` here because we are currently using both
		 * this version of the `Match` type, and react-routers version (which allows for `undefined`)
		 * To fix this we should move `matchPath` to our own util so we can apply our own types, then
		 * decide if we want to support undefined types.
		 */ if (addonKey !== null && addonKey !== undefined && moduleKey !== null && moduleKey !== undefined) return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("68gkZ"))
});
const $07e636c36bc19b52$export$53479840ec6d4024 = ()=>(0, $2YP9W.useResource)($07e636c36bc19b52$export$f34ab0d904621847);

});
const $1130bd470474fe6f$export$d5eed449bb62d4c1 = 'CONNECT_GENERAL';

parcelRegister("68gkZ", function(module, exports) {

let $0126f86a480a67fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0126f86a480a67fd$var$load("W2aDd").then(()=>parcelRequire('6LiLg'));

});


parcelRegister("9UABi", function(module, exports) {

$parcel$export(module.exports, "connectProjectResources", () => $fce046ce7cfaa8c3$export$7d2d082a4b91a6c7);
// eslint-disable-next-line jira/import-whitelist

var $8Vh1q = parcelRequire("8Vh1q");

var $ggg5j = parcelRequire("ggg5j");

var $2M1hQ = parcelRequire("2M1hQ");


const $fce046ce7cfaa8c3$export$7d2d082a4b91a6c7 = (0, $2M1hQ.createResource)({
    type: (0, $35b0c7feb103121f$export$da32d27651782c3),
    getKey: ({ query: query })=>{
        const { addonKey: addonKey, moduleKey: moduleKey } = (0, $8Vh1q.transformUrlToAddonAndModuleKeys)(query);
        if (addonKey !== '' && moduleKey !== '') return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    depends: [
        (0, $ggg5j.staticProjectSidebarNavigationResource).type
    ],
    getDataLoader: ()=>(parcelRequire("3lgtI"))
});

});
parcelRegister("8Vh1q", function(module, exports) {

$parcel$export(module.exports, "transformResponse", () => $beff5be7f4728df2$export$3361e9be8093ddcc);
$parcel$export(module.exports, "extractContext", () => $beff5be7f4728df2$export$efdbd45f3e77a161);
$parcel$export(module.exports, "transformQueryParams", () => $beff5be7f4728df2$export$9e3c3f47fc3ab3d0);
$parcel$export(module.exports, "transformUrlToAddonAndModuleKeys", () => $beff5be7f4728df2$export$752ef5ab3d7ab15f);

var $dJl1T = parcelRequire("dJl1T");

var $6VnTH = parcelRequire("6VnTH");

var $3HwlS = parcelRequire("3HwlS");

var $bsuuc = parcelRequire("bsuuc");
const $beff5be7f4728df2$export$3361e9be8093ddcc = (response)=>{
    try {
        const productContext = response.productCtx ? JSON.parse(response.productCtx) : {};
        let structuredContext = response.structuredContext ? JSON.parse(response.structuredContext) : {};
        structuredContext = {
            ...structuredContext,
            jira: {
                ...structuredContext.jira,
                horizontalNavigation: (0, $3HwlS.getWillShowNav4)()
            }
        };
        const context = {
            productContext: productContext,
            structuredContext: structuredContext,
            productCtx: productContext
        };
        return {
            ...response,
            ...context,
            isFullPage: response.general === '1',
            user: {
                timeZone: response.timeZone,
                uid: response.uid || undefined,
                ukey: response.ukey || undefined,
                fullName: response.fullName || undefined
            },
            targets: {
                env: {
                    resize: 'both'
                }
            },
            history: {
                state: ''
            },
            autoresize: true,
            ns: response.uniqueKey,
            containerId: `embedded-${response.uniqueKey}`,
            contextPath: response.cp,
            width: response.w || response.width,
            height: response.h || response.height
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const location = 'connect-iframe.transformer';
        (0, $dJl1T.default).safeErrorWithoutCustomerData(location, 'Failed to transform response', error);
        return {
            autoresize: true,
            productCtx: undefined,
            structuredContext: undefined,
            isFullPage: true,
            history: {
                state: ''
            },
            targets: {
                env: {
                    resize: 'both'
                }
            }
        };
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $beff5be7f4728df2$var$checkValueAndMapToNewName = (object, oldName, newName)=>{
    const newValue = object !== null && object[oldName] ? String(object[oldName]) : null;
    return newValue !== null ? {
        [newName]: newValue
    } : null;
};
const $beff5be7f4728df2$export$1f8eea5a5a32169f = (contextData)=>{
    const scope = contextData && contextData.scope || null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const project = contextData && contextData.project || null;
    const projectId = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $beff5be7f4728df2$var$checkValueAndMapToNewName(scope, 'type', 'board.type');
    const boardId = $beff5be7f4728df2$var$checkValueAndMapToNewName(scope, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $beff5be7f4728df2$export$efdbd45f3e77a161 = (projectSidebarNavInfo)=>{
    const project = projectSidebarNavInfo && (0, $bsuuc.extractData)(projectSidebarNavInfo) || null;
    const board = projectSidebarNavInfo?.jiraSoftwareNavData && (0, $6VnTH.extractData)(projectSidebarNavInfo.jiraSoftwareNavData) || null;
    const projectId = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $beff5be7f4728df2$var$checkValueAndMapToNewName(board, 'type', 'board.type');
    const boardId = $beff5be7f4728df2$var$checkValueAndMapToNewName(board, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $beff5be7f4728df2$export$9e3c3f47fc3ab3d0 = (contextData, query)=>{
    const context = $beff5be7f4728df2$export$1f8eea5a5a32169f(contextData);
    return {
        ...query,
        ...context
    };
};
const $beff5be7f4728df2$export$752ef5ab3d7ab15f = (query)=>{
    const { selectedItem: selectedItem } = query;
    let addonKey = '';
    let moduleKey = '';
    if (selectedItem) {
        const urlPattern = selectedItem.includes('%3A') ? 'com.atlassian.plugins.atlassian-connect-plugin%3A' : 'com.atlassian.plugins.atlassian-connect-plugin:';
        [addonKey, moduleKey] = selectedItem.replace(urlPattern, '').split('__');
    }
    return {
        addonKey: addonKey,
        moduleKey: moduleKey
    };
};

});
parcelRegister("6VnTH", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $4d73b10ca351bbb3$export$9df5fa0a366163d2);
$parcel$export(module.exports, "extractUserBoard", () => $4d73b10ca351bbb3$export$67db9e2d1b6ed865);
const $4d73b10ca351bbb3$export$9df5fa0a366163d2 = (jiraSoftwareNavData)=>{
    if (jiraSoftwareNavData.boardInfo == null) return null;
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = jiraSoftwareNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: true
    };
};
const $4d73b10ca351bbb3$export$67db9e2d1b6ed865 = (userBoardNavData)=>{
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = userBoardNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: false
    };
};

});


const $35b0c7feb103121f$export$da32d27651782c3 = 'CONNECT_PROJECT';

parcelRegister("3lgtI", function(module, exports) {

let $26f01d85e144aa9e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $26f01d85e144aa9e$var$load("g7yss").then(()=>parcelRequire('4ECv0'));

});



parcelRegister("3wwwB", function(module, exports) {

$parcel$export(module.exports, "LazyGeneralConnect", () => $49a774cbbfe614f4$export$c33275abe6c1e577);
$parcel$export(module.exports, "default", () => $49a774cbbfe614f4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $49a774cbbfe614f4$export$c33275abe6c1e577 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gFfRJ"))), {
    moduleId: "./src/packages/spa-apps/jira-connect/general-pages/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$49a774cbbfe614f4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $49a774cbbfe614f4$export$c33275abe6c1e577,
        pageId: "connect",
        shouldShowSpinner: true
    });

});
parcelRegister("gFfRJ", function(module, exports) {

let $c21cc83e5b8cadd8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c21cc83e5b8cadd8$var$load("cTtOi").then(()=>parcelRequire('crFp4'));

});



parcelRegister("gnGkU", function(module, exports) {

$parcel$export(module.exports, "connectGeneralRouteEntry", () => $a1bee888763609f4$export$46273ee39bcd958b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $luBXp = parcelRequire("luBXp");

var $cYYI7 = parcelRequire("cYYI7");

var $3wwwB = parcelRequire("3wwwB");
const $a1bee888763609f4$export$46273ee39bcd958b = (0, $7NszV.createEntry)((0, $luBXp.connectGeneralRoute), ()=>({
        group: 'connect',
        layout: (0, $aPfsS.createLayout)(),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $hBv66.genericConnectSidebars)
        },
        component: (0, $3wwwB.default),
        resources: (0, $cYYI7.getGeneralConnectRouteResources)(),
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
            // block transitions to mobile version
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            // block transitions to marketplace app as it requires specialised Connect API -
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3wwwB.LazyGeneralConnect)
        ],
        ufoName: 'jira-connect'
    }));

});
parcelRegister("luBXp", function(module, exports) {

$parcel$export(module.exports, "connectGeneralRoute", () => $1153a77cb71c1b79$export$1fda4850b6314ff0);

var $3Ra5L = parcelRequire("3Ra5L");
const $1153a77cb71c1b79$export$1fda4850b6314ff0 = {
    name: 'connect-general',
    path: '/plugins/servlet/ac/:addonKey/:moduleKey',
    query: (0, $3Ra5L.CONNECT_GENERAL_QUERY_PARAMS)
};

});


parcelRegister("c74Xp", function(module, exports) {

$parcel$export(module.exports, "connectGeneralServiceDeskProjectRouteEntry", () => $70d164d9674a0900$export$487a360459ad1bea);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $fpjJX = parcelRequire("fpjJX");

var $k7Q6G = parcelRequire("k7Q6G");

var $cYYI7 = parcelRequire("cYYI7");

var $3wwwB = parcelRequire("3wwwB");
const $70d164d9674a0900$export$487a360459ad1bea = (0, $7NszV.createEntry)((0, $k7Q6G.connectGeneralServiceDeskProjectRoute), ()=>({
        group: 'connect',
        layout: (0, $aPfsS.createLayout)(),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $hBv66.genericConnectSidebars)
        },
        component: (0, $3wwwB.default),
        resources: [
            ...(0, $cYYI7.getGeneralConnectRouteResources)(),
            ...(0, $fpjJX.getServiceDeskNavigationSingleResources)()
        ],
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
            // block transitions to mobile version
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            // block transitions to marketplace app as it requires specialised Connect API -
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3wwwB.LazyGeneralConnect)
        ],
        ufoName: 'jira-connect'
    }));

});
parcelRegister("fpjJX", function(module, exports) {

$parcel$export(module.exports, "getServiceDeskNavigationResources", () => $491f4fde535ee8ab$export$bc0bd65e6da57c1f);
$parcel$export(module.exports, "getServiceDeskNavigationSingleResources", () => $491f4fde535ee8ab$export$41a9145ddbba28e5);
$parcel$export(module.exports, "getServiceDeskSharedNavigationSingleResources", () => $491f4fde535ee8ab$export$2c543d6accc1eb9b);
$parcel$export(module.exports, "getServiceDeskSettingsResources", () => $491f4fde535ee8ab$export$7bb3c4a2f6b127fb);
$parcel$export(module.exports, "getServicedeskPageContextResources", () => $491f4fde535ee8ab$export$a8b852f03a310dc0);
$parcel$export(module.exports, "getQueuesResources", () => $491f4fde535ee8ab$export$70b97995f4d5ef9f);
$parcel$export(module.exports, "getIssueListSsrResource", () => $491f4fde535ee8ab$export$e1016cce62543991);
$parcel$export(module.exports, "getKnowledgeBaseResources", () => $491f4fde535ee8ab$export$ed87d3b71544c4ef);
$parcel$export(module.exports, "getInsightResources", () => $491f4fde535ee8ab$export$9e0cf1fab0581096);
$parcel$export(module.exports, "getQueueConfigResource", () => $491f4fde535ee8ab$export$5f7bcaa978a3e51);
$parcel$export(module.exports, "getQueueViewConfigResource", () => $491f4fde535ee8ab$export$54079077c6768752);

var $b4PzF = parcelRequire("b4PzF");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $5bkvv = parcelRequire("5bkvv");

var $b2pl3 = parcelRequire("b2pl3");

var $gS5PF = parcelRequire("gS5PF");

var $jYeNO = parcelRequire("jYeNO");

var $6zFAI = parcelRequire("6zFAI");

var $gcI3W = parcelRequire("gcI3W");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $3HwlS = parcelRequire("3HwlS");

var $bjZiV = parcelRequire("bjZiV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $8H3A4 = parcelRequire("8H3A4");

var $cAofY = parcelRequire("cAofY");

var $aNLeB = parcelRequire("aNLeB");

var $eUvlM = parcelRequire("eUvlM");

var $lbaDt = parcelRequire("lbaDt");

var $1WlLE = parcelRequire("1WlLE");

var $2cxgG = parcelRequire("2cxgG");

var $6sNnq = parcelRequire("6sNnq");

var $7GnDe = parcelRequire("7GnDe");

var $gNStA = parcelRequire("gNStA");

var $gRzZD = parcelRequire("gRzZD");

var $6s1PB = parcelRequire("6s1PB");

var $lfnsv = parcelRequire("lfnsv");

var $f5kpo = parcelRequire("f5kpo");

var $f7Y15 = parcelRequire("f7Y15");

var $lJ1FP = parcelRequire("lJ1FP");
const $491f4fde535ee8ab$export$bc0bd65e6da57c1f = ()=>[
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...$491f4fde535ee8ab$export$41a9145ddbba28e5()
    ];
const $491f4fde535ee8ab$var$fetchPriorityGroupByProjectId = ()=>(0, $4R6GH.fg)('jsm_flash_priority_group_api_optimisation') && !(0, $3HwlS.getWillShowNav4)();
const $491f4fde535ee8ab$export$41a9145ddbba28e5 = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>$491f4fde535ee8ab$var$fetchPriorityGroupByProjectId(), (0, $dxCvy.projectContextResource)),
        ...$491f4fde535ee8ab$export$9c1c5e389bd00e56(),
        ...$491f4fde535ee8ab$export$2c543d6accc1eb9b()
    ];
const $491f4fde535ee8ab$var$isNav4ResourcesFixEnabled = ()=>(0, $3HwlS.getWillShowNav4)() && (0, $6s1PB.expVal)('hot-113350-ssr-jsm-project-menu-fix', 'isEnabled', false);
const $491f4fde535ee8ab$export$9c1c5e389bd00e56 = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>!$491f4fde535ee8ab$var$fetchPriorityGroupByProjectId(), (0, $1WlLE.priorityGroupResource)),
        (0, $gNStA.resourceWithCondition2)(()=>$491f4fde535ee8ab$var$fetchPriorityGroupByProjectId(), (0, $1WlLE.priorityGroupByProjectIdResource)),
        (0, $6sNnq.featuresResource),
        (0, $gS5PF.staticSidebarJsmReportsResource),
        (0, $gNStA.resourceWithCondition2)($491f4fde535ee8ab$var$isNav4ResourcesFixEnabled, (0, $bHhiy.getConsolidationStateResource)()),
        (0, $gNStA.resourceWithCondition2)($491f4fde535ee8ab$var$isNav4ResourcesFixEnabled, (0, $aNLeB.servicedeskIsItsmProjectResource))
    ];
const $491f4fde535ee8ab$export$2c543d6accc1eb9b = ()=>[
        (0, $1WlLE.queuesNavigationItems),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('ssr_nav4_queues_sidebar'), (0, $lbaDt.requiredProjectProperties)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('ssr_nav4_queues_sidebar'), (0, $lbaDt.requiredFrontendProperties)),
        (0, $5bkvv.forgeServiceDeskQueueModuleResource),
        (0, $b2pl3.staticJSMProjectConnectAddonsNavigationResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        // for Getting Started menu item
        // resourceWithCondition2(isNav4ResourcesFixEnabled, requiredFrontendProperties),
        (0, $gNStA.resourceWithCondition2)($491f4fde535ee8ab$var$isNav4ResourcesFixEnabled, (0, $dxCvy.projectContextResourceWithCache)),
        (0, $gNStA.resourceWithCondition2)($491f4fde535ee8ab$var$isNav4ResourcesFixEnabled, (0, $lbaDt.firstProjectResource))
    ];
const $491f4fde535ee8ab$export$7bb3c4a2f6b127fb = ()=>[
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
        (0, $eUvlM.servicedeskPracticesResource),
        (0, $cAofY.serviceDeskContextResource),
        (0, $8H3A4.serviceDeskAnalyticsContextResource),
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $b4PzF.isFedRamp)(), (0, $2cxgG.virtualAgentOnboardingResource))
    ];
const $491f4fde535ee8ab$export$a8b852f03a310dc0 = ()=>[
        (0, $dxCvy.projectContextResourceWithCache),
        (0, $cAofY.serviceDeskContextResource),
        (0, $8H3A4.serviceDeskAnalyticsContextResource)
    ];
const $491f4fde535ee8ab$export$70b97995f4d5ef9f = ()=>[
        ...$491f4fde535ee8ab$export$a8b852f03a310dc0(),
        ...$491f4fde535ee8ab$export$bc0bd65e6da57c1f(),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $co1wz.ff)('automation-templates-team-types-refactor-m1_isj0e'), (0, $eUvlM.servicedeskPracticesResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('corcap-2944-add-jqlbuilder-to-jsm-queues'), (0, $jYeNO.getCalendarFilterFieldsResource)())
    ];
const $491f4fde535ee8ab$export$e1016cce62543991 = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('ssr_view_queues_issuelist'), (0, $1WlLE.issueListSsrResource))
    ];
const $491f4fde535ee8ab$export$ed87d3b71544c4ef = ()=>[
        (0, $bjZiV.kbConfluenceContextResource)
    ];
const $491f4fde535ee8ab$export$9e0cf1fab0581096 = ()=>[
        (0, $gRzZD.workspaceResource)
    ];
const $491f4fde535ee8ab$export$5f7bcaa978a3e51 = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('jsm-views-inside-queues-fastfollow') && (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $1WlLE.priorityGroupResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $dxCvy.projectContextResource))
    ];
const $491f4fde535ee8ab$export$54079077c6768752 = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('jsm-views-inside-queues-fastfollow') && (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $f5kpo.getRapidBoardDataResource)()),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $lJ1FP.getEditModelResource)()),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $lfnsv.getBoardDetailsResource)()),
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('jsm-views-inside-queues-fastfollow') && (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $1WlLE.priorityGroupResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $dxCvy.projectContextResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $f7Y15.uifBoardResource)),
        ...(0, $f5kpo.getRapidboardResources)().map((resource)=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), resource))
    ];

});
parcelRegister("gS5PF", function(module, exports) {

$parcel$export(module.exports, "staticSidebarJsmReportsResource", () => $e7e607725980fdf6$export$ec28065a31cce4ce);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $cQGRH = parcelRequire("cQGRH");
const $e7e607725980fdf6$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $e7e607725980fdf6$export$ec28065a31cce4ce = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_SERVICE_MANAGEMENT_REPORTS',
    getKey: ({ match: match, query: query })=>$e7e607725980fdf6$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $e7e607725980fdf6$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        return (0, $cQGRH.fetchJsmReportsSidebarNavInfo)(projectKeyOrId);
    },
    maxAge: 300000
});

});
parcelRegister("cQGRH", function(module, exports) {

$parcel$export(module.exports, "fetchJsmReportsSidebarNavInfo", () => $ed2ba0d649a8d8eb$export$c1dd51127051647d);

var $eusud = parcelRequire("eusud");
const $ed2ba0d649a8d8eb$export$c1dd51127051647d = (projectIdOrKey)=>{
    if (projectIdOrKey == null) throw new Error('invalid project id or key');
    return (0, $eusud.performGetRequest)(`/rest/navigation/4/servicedesk/project/${projectIdOrKey}/reports`);
};

});


parcelRegister("jYeNO", function(module, exports) {

$parcel$export(module.exports, "getCalendarFilterFieldsResource", () => $4dc70aab7904ddfa$export$5f02bf5f04197ed7);
$parcel$export(module.exports, "useCalendarFilterResource", () => $4dc70aab7904ddfa$export$70361b748d216408);

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $4R6GH = parcelRequire("4R6GH");

var $3ezTL = parcelRequire("3ezTL");


var $30Hlr = parcelRequire("30Hlr");
const $4dc70aab7904ddfa$var$fetchFilterFields = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $8c2713286c62bdd7$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    contextFieldsFilter: {
                        searchString: (0, $3ezTL.REQUEST_TYPE_FILTER)
                    },
                    jqlContext: jqlContext
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return (0, $30Hlr.transformAndReport)(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $fZneA.isHttpClientErrorResponse)(error)) (0, $30Hlr.reportError)(error);
        return 0, $3ezTL.DEFAULT_CALENDAR_FILTER_FIELDS;
    }
};
const $4dc70aab7904ddfa$var$filterFieldsResource = (0, $2M1hQ.createResource)({
    type: (0, $3ezTL.RESOURCE_TYPE_FILTER_FIELD),
    getKey: ({ match: match, query: query })=>{
        if ((0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) {
            const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
            const projectIdOrKey = projectKey || projectId;
            return (0, $3ezTL.RESOURCE_TYPE_FILTER_FIELD) + projectIdOrKey;
        }
        return 0, $3ezTL.RESOURCE_TYPE_FILTER_FIELD;
    },
    getData: ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        const jqlContext = `project = '${projectIdOrKey}'`;
        return $4dc70aab7904ddfa$var$fetchFilterFields(cloudId, jqlContext);
    },
    maxAge: Infinity
});
const $4dc70aab7904ddfa$export$5f02bf5f04197ed7 = ()=>$4dc70aab7904ddfa$var$filterFieldsResource;
const $4dc70aab7904ddfa$export$70361b748d216408 = ()=>(0, $2YP9W.useResource)($4dc70aab7904ddfa$var$filterFieldsResource);

});
parcelRegister("3ezTL", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_NAME", () => $2fdfca9bb2287268$export$186e93e8ef3f9358);
$parcel$export(module.exports, "PACKAGE_NAME", () => $2fdfca9bb2287268$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $2fdfca9bb2287268$export$d57b6b390e78d90f);
$parcel$export(module.exports, "REQUEST_TYPE_FILTER", () => $2fdfca9bb2287268$export$2c388650eabddf5e);
$parcel$export(module.exports, "RESOURCE_TYPE_FILTER_FIELD", () => $2fdfca9bb2287268$export$2019de80301f1da);
$parcel$export(module.exports, "DEFAULT_CALENDAR_FILTER_FIELDS", () => $2fdfca9bb2287268$export$2912f30d4328fc00);
const $2fdfca9bb2287268$export$186e93e8ef3f9358 = 'calendarFilterFieldResource';
const $2fdfca9bb2287268$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesServicedeskCalendar';
const $2fdfca9bb2287268$export$d57b6b390e78d90f = 'jsd-shield';
const $2fdfca9bb2287268$export$2c388650eabddf5e = 'request type';
const $2fdfca9bb2287268$export$2019de80301f1da = 'RESOURCE_TYPE_FILTER_FIELD';
const $2fdfca9bb2287268$export$2912f30d4328fc00 = [
    'status',
    'assignee'
];

});

const $8c2713286c62bdd7$export$2b91517d6d5b4365 = `
query findRequestTypeCustomFieldQuery($cloudId: ID!, $contextFieldsFilter: JiraJQLContextFieldsFilter!, $jqlContext: String!) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
        fields(jqlContextFieldsFilter: $contextFieldsFilter, jqlContext: $jqlContext) {
          ... on JiraJqlFieldConnection {
            __typename
            edges {
              node {
                jqlTerm
                displayName
                type
                searchTemplate {
                  key
                }
                operators
              }
            }
          }
          ... on QueryError {
            __typename
          }
        }
      }
  }
}
`;

parcelRegister("30Hlr", function(module, exports) {

$parcel$export(module.exports, "TARGET_FILTER_TYPE", () => $f86becf4a18b4f1f$export$64f54b13b7aea793);
$parcel$export(module.exports, "reportError", () => $f86becf4a18b4f1f$export$b33b857ad1d9900e);
$parcel$export(module.exports, "transformAndReport", () => $f86becf4a18b4f1f$export$af2aa11c88c551af);

var $jcw0u = parcelRequire("jcw0u");

var $3ezTL = parcelRequire("3ezTL");
const $f86becf4a18b4f1f$export$64f54b13b7aea793 = 'com.atlassian.servicedesk:vp-origin';
const $f86becf4a18b4f1f$var$TARGET_FILTER_SEARCH_TEMPLATE = 'com.atlassian.servicedesk:vp-origin-searcher';
const $f86becf4a18b4f1f$export$b33b857ad1d9900e = (error)=>{
    (0, $jcw0u.default)({
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        meta: {
            id: (0, $3ezTL.RESOURCE_TYPE_NAME),
            packageName: (0, $3ezTL.PACKAGE_NAME),
            teamName: (0, $3ezTL.TEAM_NAME)
        }
    });
};
const $f86becf4a18b4f1f$export$af2aa11c88c551af = (response)=>{
    const edges = response.data?.jira?.jqlBuilder?.fields?.edges;
    // There may be ambigious custom fields with same name, so find the correct one and pass to JQLBuilder
    const requestType = edges?.find((edge)=>edge?.node?.type === $f86becf4a18b4f1f$export$64f54b13b7aea793 && edge?.node?.searchTemplate?.key === $f86becf4a18b4f1f$var$TARGET_FILTER_SEARCH_TEMPLATE)?.node;
    if (!requestType) $f86becf4a18b4f1f$export$b33b857ad1d9900e(new Error('Unable to prefetch request type'));
    // if requestType field found, add it to existing default calendar filter fields
    return requestType ? [
        {
            ...requestType,
            searchTemplate: requestType.searchTemplate.key,
            fieldType: requestType.type
        },
        ...(0, $3ezTL.DEFAULT_CALENDAR_FILTER_FIELDS)
    ] : (0, $3ezTL.DEFAULT_CALENDAR_FILTER_FIELDS);
};

});


parcelRegister("bjZiV", function(module, exports) {

$parcel$export(module.exports, "kbConfluenceContextResource", () => $450040dc63d5cc0e$export$8b58be1423986d17);

var $2M1hQ = parcelRequire("2M1hQ");


const $450040dc63d5cc0e$var$getDataLoader = ()=>(parcelRequire("9vHSl"));
const $450040dc63d5cc0e$export$8b58be1423986d17 = (0, $2M1hQ.createResource)({
    type: (0, $3139e13cdf89be01$export$54b5a0d1e8c78de6),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: $450040dc63d5cc0e$var$getDataLoader,
    maxAge: Infinity
});

});
const $3139e13cdf89be01$export$54b5a0d1e8c78de6 = 'KB_CONFLUENCE_CONTEXT';

parcelRegister("9vHSl", function(module, exports) {

let $6ec90b0ff8c4d279$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6ec90b0ff8c4d279$var$load("2CTCs").then(()=>parcelRequire('2SeLy'));

});


parcelRegister("8H3A4", function(module, exports) {

$parcel$export(module.exports, "serviceDeskAnalyticsContextResource", () => $4d76b3bac8f2b7c8$export$d6f4f0483916919f);
$parcel$export(module.exports, "useServiceDeskAnalyticsContext", () => $4d76b3bac8f2b7c8$export$bc2de1c42df30b10);

var $5uXOq = parcelRequire("5uXOq");

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $4d76b3bac8f2b7c8$var$getDataLoader = ()=>(parcelRequire("6CvjL"));
const $4d76b3bac8f2b7c8$var$ONE_DAY_IN_MILLIS = 86400000;
const $4d76b3bac8f2b7c8$export$d6f4f0483916919f = (0, $2M1hQ.createResource)({
    type: (0, $3b4b6bf0bbdfa955$export$285b47583a5bdd0f),
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $4d76b3bac8f2b7c8$var$getDataLoader,
    maxAge: $4d76b3bac8f2b7c8$var$ONE_DAY_IN_MILLIS
});
const $4d76b3bac8f2b7c8$export$bc2de1c42df30b10 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)($4d76b3bac8f2b7c8$export$d6f4f0483916919f);
    (0, $5uXOq.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
const $3b4b6bf0bbdfa955$export$285b47583a5bdd0f = 'SERVICEDESK_ANALYTICS_CONTEXT';

parcelRegister("6CvjL", function(module, exports) {

let $4d1e95bdbe0f0190$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $4d1e95bdbe0f0190$var$load("eNmuD"),
    $4d1e95bdbe0f0190$var$load("3rvO2")
]).then(()=>parcelRequire('btHFe'));

});


parcelRegister("cAofY", function(module, exports) {

$parcel$export(module.exports, "serviceDeskContextResource", () => $9c517de0cdc23225$export$5eaaf465969a9171);

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");


const $9c517de0cdc23225$var$getDataLoader = ()=>(parcelRequire("2WfJW"));
const $9c517de0cdc23225$export$5eaaf465969a9171 = (0, $2M1hQ.createResource)({
    type: (0, $4595635dbd9fca21$export$ac01662d5287bc5c),
    getKey: ({ match: match, query: query })=>(0, $dK8AG.getProjectKeyOrIdFromMatchAndQuery)({
            match: match,
            query: query
        }),
    getDataLoader: $9c517de0cdc23225$var$getDataLoader,
    maxAge: Infinity
});

});
const $4595635dbd9fca21$export$ac01662d5287bc5c = 'SERVICEDESK_CONTEXT';

parcelRegister("2WfJW", function(module, exports) {

let $223d3531a11189cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $223d3531a11189cf$var$load("iNITq").then(()=>parcelRequire('g4PUK'));

});


parcelRegister("aNLeB", function(module, exports) {

$parcel$export(module.exports, "servicedeskIsItsmProjectResource", () => $31e43d0718118496$export$920308cef4e291b1);
$parcel$export(module.exports, "useIsItsmTemplateProject", () => $31e43d0718118496$export$7bb46948fb84f164);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");


const $31e43d0718118496$var$getDataLoader = ()=>(parcelRequire("llgGA"));
const $31e43d0718118496$var$ONE_DAY_IN_MILLIS = 86400000;
const $31e43d0718118496$export$920308cef4e291b1 = (0, $2M1hQ.createResource)({
    type: (0, $6249ccfa4eeeb82a$export$543a8644640f4092),
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $31e43d0718118496$var$getDataLoader,
    maxAge: $31e43d0718118496$var$ONE_DAY_IN_MILLIS
});
const $31e43d0718118496$export$7bb46948fb84f164 = (projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $324W5.useResourceWithCustomRouterContext)($31e43d0718118496$export$920308cef4e291b1, projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined, {
        shouldPrefetch: true
    });
    return (0, $5uXOq.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
const $6249ccfa4eeeb82a$export$543a8644640f4092 = 'SERVICEDESK_IS_ITSM_PROJECT';

parcelRegister("llgGA", function(module, exports) {

let $f8988094fa9dc0bc$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f8988094fa9dc0bc$var$load("eNmuD"),
    $f8988094fa9dc0bc$var$load("4CXUh")
]).then(()=>parcelRequire('k9PUn'));

});


parcelRegister("eUvlM", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticesResource", () => $9479f477b801290f$export$2ae319305481e7de);
$parcel$export(module.exports, "useWorkCategoriesQueueSupported", () => $9479f477b801290f$export$a86ac771006f14b3);
$parcel$export(module.exports, "useWorkCategoriesAllSupported", () => $9479f477b801290f$export$fe081b1a59d3c818);
$parcel$export(module.exports, "useWorkCategoriesAllSupportedWithForceRefreshOnMount", () => $9479f477b801290f$export$4d46346ef0bdc6b9);

var $5uXOq = parcelRequire("5uXOq");

var $dK8AG = parcelRequire("dK8AG");

var $oCMSG = parcelRequire("oCMSG");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $9479f477b801290f$var$getDataLoader = ()=>(parcelRequire("4Wb3o"));
const $9479f477b801290f$var$ONE_DAY_IN_MILLIS = 86400000;
const $9479f477b801290f$export$2ae319305481e7de = (0, $2M1hQ.createResource)({
    type: (0, $990f0449915d93bf$export$45919c8f50bb1db5),
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $9479f477b801290f$var$getDataLoader,
    maxAge: $9479f477b801290f$var$ONE_DAY_IN_MILLIS
});
const $9479f477b801290f$var$queuesOrder = [
    ...(0, $oCMSG.WORK_CATEGORIES_QUEUE_SUPPORTED)
];
const $9479f477b801290f$var$workCategoryOrder = [
    ...$9479f477b801290f$var$queuesOrder,
    (0, $oCMSG.DEVELOPER_ESCALATION)
];
const $9479f477b801290f$var$transformItsmPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $9479f477b801290f$var$queuesOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $9479f477b801290f$var$transformServiceDeskPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $9479f477b801290f$var$workCategoryOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $9479f477b801290f$export$a86ac771006f14b3 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $2YP9W.useResource)($9479f477b801290f$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $5uXOq.useMemo)(()=>({
            data: $9479f477b801290f$var$transformItsmPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $9479f477b801290f$export$fe081b1a59d3c818 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $2YP9W.useResource)($9479f477b801290f$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $5uXOq.useMemo)(()=>({
            data: $9479f477b801290f$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $9479f477b801290f$export$4d46346ef0bdc6b9 = ()=>{
    const { data: data, loading: loading, refresh: refreshPractices, ...resource } = (0, $2YP9W.useResource)($9479f477b801290f$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    (0, $5uXOq.useEffect)(()=>{
        if (!loading && !data && !error) refreshPractices();
    }, [
        data,
        error,
        loading,
        refreshPractices
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: $9479f477b801290f$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};

});
parcelRegister("oCMSG", function(module, exports) {

$parcel$export(module.exports, "CHANGES", () => $4f9c4406e75c8aa5$export$8598196f74460271);
$parcel$export(module.exports, "INCIDENTS", () => $4f9c4406e75c8aa5$export$a50b49a533b5f7bc);
$parcel$export(module.exports, "PROBLEMS", () => $4f9c4406e75c8aa5$export$ceba70db1edb1def);
$parcel$export(module.exports, "SERVICE_REQUEST", () => $4f9c4406e75c8aa5$export$3d1cda9bd50505e8);
$parcel$export(module.exports, "POST_INCIDENT_REVIEWS", () => $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f);
$parcel$export(module.exports, "DEVELOPER_ESCALATION", () => $4f9c4406e75c8aa5$export$81e62964cc725098);
$parcel$export(module.exports, "NO_CATEGORY", () => $4f9c4406e75c8aa5$export$485b1216c42d8d4);
$parcel$export(module.exports, "NO_PRACTICE", () => $4f9c4406e75c8aa5$export$52bf3f16b7812704);
$parcel$export(module.exports, "SHORT_FORM_CHANGES", () => $4f9c4406e75c8aa5$export$a50185c8e9fb007e);
$parcel$export(module.exports, "SHORT_FORM_INCIDENTS", () => $4f9c4406e75c8aa5$export$a54a30a3c3cce634);
$parcel$export(module.exports, "SHORT_FORM_PROBLEMS", () => $4f9c4406e75c8aa5$export$354f3a4c6ac0c903);
$parcel$export(module.exports, "SHORT_FORM_SERVICE_REQUEST", () => $4f9c4406e75c8aa5$export$335d3ac0c367f03f);
$parcel$export(module.exports, "SHORT_FORM_POST_INCIDENT_REVIEWS", () => $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f);
$parcel$export(module.exports, "SHORT_FORM_DEVELOPER_ESCALATION", () => $4f9c4406e75c8aa5$export$cb41b99ca54e6bd);
$parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED", () => $4f9c4406e75c8aa5$export$a2b1f8f055150f02);
$parcel$export(module.exports, "ItsmPracticeToShortForm", () => $4f9c4406e75c8aa5$export$56c57f7ad650c45c);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP", () => $4f9c4406e75c8aa5$export$fbf0dfd01228e38d);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP_LOWER_CASE", () => $4f9c4406e75c8aa5$export$45ba5f49e9509c4d);
$parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED_LABELS", () => $4f9c4406e75c8aa5$export$45952424a7f29b99);
$parcel$export(module.exports, "CHANGES_JQL_NAME", () => $4f9c4406e75c8aa5$export$6c24c440228eac9c);
$parcel$export(module.exports, "INCIDENTS_JQL_NAME", () => $4f9c4406e75c8aa5$export$5b65d27ec2d28d18);
$parcel$export(module.exports, "DEVELOPER_ESCALATION_JQL_NAME", () => $4f9c4406e75c8aa5$export$3f757c5e00588ffd);
$parcel$export(module.exports, "practiceKeyJqlNameMapping", () => $4f9c4406e75c8aa5$export$b78213db77524b5b);

var $7c0in = parcelRequire("7c0in");

var $kVZSN = parcelRequire("kVZSN");
const $4f9c4406e75c8aa5$export$8598196f74460271 = 'change-management';
const $4f9c4406e75c8aa5$export$a50b49a533b5f7bc = 'incident-management';
const $4f9c4406e75c8aa5$export$ceba70db1edb1def = 'problem-management';
const $4f9c4406e75c8aa5$export$3d1cda9bd50505e8 = 'service-request';
const $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f = 'post-incident-review';
const $4f9c4406e75c8aa5$export$81e62964cc725098 = 'developer-escalation';
const $4f9c4406e75c8aa5$export$485b1216c42d8d4 = 'no-category';
const $4f9c4406e75c8aa5$var$NO_CATEGORY_NEW = 'no-category-new';
const $4f9c4406e75c8aa5$export$52bf3f16b7812704 = 'no-practice'; // BERRY-1358 should consolidate into NO_CATEGORY
const $4f9c4406e75c8aa5$export$a50185c8e9fb007e = 'changes';
const $4f9c4406e75c8aa5$export$a54a30a3c3cce634 = 'incidents';
const $4f9c4406e75c8aa5$export$354f3a4c6ac0c903 = 'problems';
const $4f9c4406e75c8aa5$export$335d3ac0c367f03f = 'service-requests';
const $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f = 'post-incident-reviews';
const $4f9c4406e75c8aa5$export$cb41b99ca54e6bd = 'developer-escalations';
const $4f9c4406e75c8aa5$export$a613d808168c7b25 = [
    $4f9c4406e75c8aa5$export$8598196f74460271,
    $4f9c4406e75c8aa5$export$a50b49a533b5f7bc,
    $4f9c4406e75c8aa5$export$ceba70db1edb1def,
    $4f9c4406e75c8aa5$export$3d1cda9bd50505e8,
    $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f,
    $4f9c4406e75c8aa5$export$81e62964cc725098
]; // /!\ defines WorkCategoryApiResource type
const $4f9c4406e75c8aa5$export$a2b1f8f055150f02 = [
    $4f9c4406e75c8aa5$export$3d1cda9bd50505e8,
    $4f9c4406e75c8aa5$export$a50b49a533b5f7bc,
    $4f9c4406e75c8aa5$export$ceba70db1edb1def,
    $4f9c4406e75c8aa5$export$8598196f74460271,
    $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f
]; // /!\ defines WorkCategoryQueueSupported type
const $4f9c4406e75c8aa5$export$5a9122a4028fb8ef = [
    ...$4f9c4406e75c8aa5$export$a2b1f8f055150f02,
    $4f9c4406e75c8aa5$export$485b1216c42d8d4
];
const $4f9c4406e75c8aa5$export$f1b813cd23817ade = [
    $4f9c4406e75c8aa5$export$a50185c8e9fb007e,
    $4f9c4406e75c8aa5$export$a54a30a3c3cce634,
    $4f9c4406e75c8aa5$export$354f3a4c6ac0c903,
    $4f9c4406e75c8aa5$export$335d3ac0c367f03f,
    $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f,
    $4f9c4406e75c8aa5$export$cb41b99ca54e6bd
]; // /!\ defines WorkCategoryShortForm type
const $4f9c4406e75c8aa5$export$56c57f7ad650c45c = {
    [$4f9c4406e75c8aa5$export$8598196f74460271]: $4f9c4406e75c8aa5$export$a50185c8e9fb007e,
    [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: $4f9c4406e75c8aa5$export$a54a30a3c3cce634,
    [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: $4f9c4406e75c8aa5$export$354f3a4c6ac0c903,
    [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: $4f9c4406e75c8aa5$export$335d3ac0c367f03f,
    [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f,
    [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: $4f9c4406e75c8aa5$var$NO_CATEGORY_NEW
};
const $4f9c4406e75c8aa5$export$fbf0dfd01228e38d = {
    [$4f9c4406e75c8aa5$export$8598196f74460271]: (0, $kVZSN.default).changes,
    [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: (0, $kVZSN.default).serviceRequests,
    [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: (0, $kVZSN.default).problems,
    [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: (0, $kVZSN.default).incidents,
    [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: (0, $kVZSN.default).postIncidentReviews,
    [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: (0, $kVZSN.default).queues,
    [$4f9c4406e75c8aa5$export$81e62964cc725098]: (0, $kVZSN.default).developerEscalation,
    [$4f9c4406e75c8aa5$export$52bf3f16b7812704]: (0, $kVZSN.default).noCategory
};
const $4f9c4406e75c8aa5$export$45ba5f49e9509c4d = {
    [$4f9c4406e75c8aa5$export$8598196f74460271]: (0, $kVZSN.default).changesLower,
    [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: (0, $kVZSN.default).serviceRequestsLower,
    [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: (0, $kVZSN.default).problemsLower,
    [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: (0, $kVZSN.default).incidentsLower,
    [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: (0, $kVZSN.default).postIncidentReviewsLower,
    [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: (0, $kVZSN.default).queuesLower,
    [$4f9c4406e75c8aa5$export$81e62964cc725098]: (0, $kVZSN.default).developerEscalationLower,
    [$4f9c4406e75c8aa5$export$52bf3f16b7812704]: (0, $kVZSN.default).noCategoryLower
};
const $4f9c4406e75c8aa5$export$45952424a7f29b99 = (0, $7c0in.getTypedKeys)($4f9c4406e75c8aa5$export$fbf0dfd01228e38d).reduce((acc, labelMapKey)=>{
    // cannot type .indexOf() as not-string in Ts, therefore need to use .find(). And shows error if `key` in acc[key] being of wider type than the result (than ItsmPracticeCategory), therefore, need to use different keys in the `acc[queueKey] =` line
    const queueKey = $4f9c4406e75c8aa5$export$a2b1f8f055150f02.find((key)=>key === labelMapKey);
    if (queueKey) acc[queueKey] = $4f9c4406e75c8aa5$export$fbf0dfd01228e38d[labelMapKey];
    return acc;
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
}, {});
const $4f9c4406e75c8aa5$export$6c24c440228eac9c = 'Changes';
const $4f9c4406e75c8aa5$export$5b65d27ec2d28d18 = 'Incidents';
const $4f9c4406e75c8aa5$var$PROBLEMS_JQL_NAME = 'Problems';
const $4f9c4406e75c8aa5$var$SERVICE_REQUEST_JQL_NAME = 'Service requests';
const $4f9c4406e75c8aa5$var$POST_INCIDENT_REVIEWS_JQL_NAME = 'Post-incident reviews';
const $4f9c4406e75c8aa5$export$3f757c5e00588ffd = 'Developer escalation';
const $4f9c4406e75c8aa5$export$b78213db77524b5b = {
    [$4f9c4406e75c8aa5$export$8598196f74460271]: $4f9c4406e75c8aa5$export$6c24c440228eac9c,
    [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: $4f9c4406e75c8aa5$export$5b65d27ec2d28d18,
    [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: $4f9c4406e75c8aa5$var$PROBLEMS_JQL_NAME,
    [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: $4f9c4406e75c8aa5$var$SERVICE_REQUEST_JQL_NAME,
    [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: $4f9c4406e75c8aa5$var$POST_INCIDENT_REVIEWS_JQL_NAME,
    [$4f9c4406e75c8aa5$export$81e62964cc725098]: $4f9c4406e75c8aa5$export$3f757c5e00588ffd
};

});
parcelRegister("7c0in", function(module, exports) {

$parcel$export(module.exports, "hasProp", () => $2dc9189f096b533d$export$dd642ef726dcde21);
$parcel$export(module.exports, "getTypedKeys", () => $2dc9189f096b533d$export$5206d47972fefe20);
/**
 * Use to remove `TS2339: Property 'id' does not exist on type 'object'` errors, e.g. when checking/refining variable of `unknown' type
 */ const $2dc9189f096b533d$export$dd642ef726dcde21 = (data, prop)=>prop in data;
const $2dc9189f096b533d$export$5206d47972fefe20 = (obj)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(obj);
};

});

parcelRegister("kVZSN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d218b9a030da8fd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5d218b9a030da8fd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    queues: {
        "id": "work-category.common.queues",
        "defaultMessage": "Queues"
    },
    serviceRequests: {
        "id": "work-category.common.service-requests",
        "defaultMessage": "Service requests"
    },
    incidents: {
        "id": "work-category.common.incidents",
        "defaultMessage": "Incidents"
    },
    changes: {
        "id": "work-category.common.changes",
        "defaultMessage": "Changes"
    },
    problems: {
        "id": "work-category.common.problems",
        "defaultMessage": "Problems"
    },
    postIncidentReviews: {
        "id": "work-category.common.post-incident-reviews",
        "defaultMessage": "Post-incident reviews"
    },
    noCategory: {
        "id": "work-category.common.no-category",
        "defaultMessage": "General"
    },
    queuesLower: {
        "id": "work-category.common.queues-lower",
        "defaultMessage": "queues"
    },
    serviceRequestsLower: {
        "id": "work-category.common.service-requests-lower",
        "defaultMessage": "service requests"
    },
    incidentsLower: {
        "id": "work-category.common.incidents-lower",
        "defaultMessage": "incidents"
    },
    changesLower: {
        "id": "work-category.common.changes-lower",
        "defaultMessage": "changes"
    },
    problemsLower: {
        "id": "work-category.common.problems-lower",
        "defaultMessage": "problems"
    },
    postIncidentReviewsLower: {
        "id": "work-category.common.post-incident-reviews-lower",
        "defaultMessage": "post-incident reviews"
    },
    noCategoryLower: {
        "id": "work-category.common.no-category-lower",
        "defaultMessage": "general"
    },
    developerEscalation: {
        "id": "work-category.common.developer-escalation",
        "defaultMessage": "Developer escalations"
    },
    developerEscalationLower: {
        "id": "work-category.common.developer-escalation-lower",
        "defaultMessage": "developer escalations"
    }
});

});


const $990f0449915d93bf$export$45919c8f50bb1db5 = 'SERVICEDESK_PRACTICES';

parcelRegister("4Wb3o", function(module, exports) {

let $39852742b1504c54$var$load = (parcelRequire("28QjX"))(4);
module.exports = $39852742b1504c54$var$load("jhLKO").then(()=>parcelRequire('8khb6'));

});


parcelRegister("lbaDt", function(module, exports) {

$parcel$export(module.exports, "requiredProjectProperties", () => $3477ceb4f9b98b2e$export$fbeae45a65f4a5a6);
$parcel$export(module.exports, "requiredFrontendProperties", () => $3477ceb4f9b98b2e$export$47241956725e3029);
$parcel$export(module.exports, "firstProjectResource", () => $3477ceb4f9b98b2e$export$f620cebb7e8eeeae);

var $9XE6b = parcelRequire("9XE6b");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
const $3477ceb4f9b98b2e$var$getKey = ({ match: match, query: query })=>// projectKey from url path/query or browse/{issueKey}
    (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0];

const $3477ceb4f9b98b2e$var$getRequiredProjectPropertiesDataLoader = ()=>(parcelRequire("cB0XL"));
const $3477ceb4f9b98b2e$export$fbeae45a65f4a5a6 = (0, $2M1hQ.createResource)({
    type: 'SERVICEDESK_REQUIRED_PROJECT_PROPERTIES',
    getKey: $3477ceb4f9b98b2e$var$getKey,
    getDataLoader: $3477ceb4f9b98b2e$var$getRequiredProjectPropertiesDataLoader,
    maxAge: 300000
});

const $3477ceb4f9b98b2e$var$getRequiredFrontendPropertiesDataLoader = ()=>(parcelRequire("5QIw2"));
const $3477ceb4f9b98b2e$var$ONE_DAY_IN_MILLIS = 86400000;
const $3477ceb4f9b98b2e$export$47241956725e3029 = (0, $2M1hQ.createResource)({
    type: 'SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES',
    getKey: $3477ceb4f9b98b2e$var$getKey,
    getDataLoader: $3477ceb4f9b98b2e$var$getRequiredFrontendPropertiesDataLoader,
    maxAge: $3477ceb4f9b98b2e$var$ONE_DAY_IN_MILLIS
});

const $3477ceb4f9b98b2e$var$getFirstProjectDataLoader = ()=>(parcelRequire("3sevG"));
const $3477ceb4f9b98b2e$var$TWELVE_HOURS_IN_MILLIS = 43200000;
const $3477ceb4f9b98b2e$export$f620cebb7e8eeeae = (0, $2M1hQ.createResource)({
    type: 'JSM_FIRST_PROJECT_RESOURCE',
    // first project is the same for the tenantId (there is also no per-project arg in request url). Therefore, only 1 key value is used.
    getKey: ()=>'none',
    getDataLoader: $3477ceb4f9b98b2e$var$getFirstProjectDataLoader,
    maxAge: $3477ceb4f9b98b2e$var$TWELVE_HOURS_IN_MILLIS
});

});
parcelRegister("cB0XL", function(module, exports) {

let $92b9aff04352e21b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $92b9aff04352e21b$var$load("7aPU6").then(()=>parcelRequire('d4USv'));

});

parcelRegister("5QIw2", function(module, exports) {

let $442456f5c4332281$var$load = (parcelRequire("28QjX"))(4);
module.exports = $442456f5c4332281$var$load("4Lrpj").then(()=>parcelRequire('7UDgf'));

});

parcelRegister("3sevG", function(module, exports) {

let $283f3e089e6ae6ab$var$load = (parcelRequire("28QjX"))(4);
module.exports = $283f3e089e6ae6ab$var$load("i5GnG").then(()=>parcelRequire('KbkKO'));

});


parcelRegister("2cxgG", function(module, exports) {

$parcel$export(module.exports, "virtualAgentOnboardingResource", () => $e9d51fb7135f5412$export$d39827c053fda3aa);

var $4R6GH = parcelRequire("4R6GH");

var $ao2h1 = parcelRequire("ao2h1");

var $2j6fy = parcelRequire("2j6fy");
const $e9d51fb7135f5412$export$d39827c053fda3aa = (0, $ao2h1.createRelayResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING',
    isBrowserOnly: true,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $2j6fy.default),
            variables: {
                cloudId: tenantContext.cloudId,
                key: match.params.projectKey || '',
                checkForAiEnabledFF: (0, $4R6GH.fg)('require_ai_enabled_for_jsm_virtual_agent')
            }
        })
});

});
parcelRegister("2j6fy", function(module, exports) {

$parcel$export(module.exports, "default", () => $45b605658e5ce20d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8391836c727c96074b367b5cee339a0d>>
 * @relayHash a752dde009c93b4975b47e740db8b1bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 43c453bca1e65ebbd87f7974bea4d6b5c78178b9b9507ff8b40972a4e4fe9ecf

var $7oHmH = parcelRequire("7oHmH");
const $45b605658e5ce20d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "43c453bca1e65ebbd87f7974bea4d6b5c78178b9b9507ff8b40972a4e4fe9ecf",
        "metadata": {},
        "name": "mainVirtualAgentSidebarQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $45b605658e5ce20d$export$2e2bcd8739ae039 = $45b605658e5ce20d$var$node;

});
parcelRegister("7oHmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f0ef421b1798a33$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $3f0ef421b1798a33$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('require_ai_enabled_for_jsm_virtual_agent');
    }
};

});



parcelRegister("6sNnq", function(module, exports) {

$parcel$export(module.exports, "featuresResource", () => $d0a02e466fb63798$export$16f81cc9da2c6c47);

var $9XE6b = parcelRequire("9XE6b");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");


const $d0a02e466fb63798$var$getDataLoader = ()=>Promise.resolve((parcelRequire("frQmB")));
const $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS = 86400000;
const $d0a02e466fb63798$export$16f81cc9da2c6c47 = (0, $2M1hQ.createResource)({
    type: (0, $68b2e6d16c6e9952$export$3441b129810f29ed),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $d0a02e466fb63798$var$getDataLoader,
    maxAge: $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS
});

});
const $68b2e6d16c6e9952$export$3441b129810f29ed = 'SERVICEDESK_FEATURES';


parcelRegister("gRzZD", function(module, exports) {

$parcel$export(module.exports, "workspaceResource", () => $d68afc54033ea939$export$2f02c3f971168d17);

var $2M1hQ = parcelRequire("2M1hQ");

var $ahEft = parcelRequire("ahEft");
const $d68afc54033ea939$export$9b3a4d71d46e5ee7 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
const $d68afc54033ea939$export$2f02c3f971168d17 = (0, $2M1hQ.createResource)({
    type: $d68afc54033ea939$export$9b3a4d71d46e5ee7,
    getKey: ()=>'state',
    getData: async (_, routerContext)=>{
        const workspaceId = await (0, $ahEft.default)(_, routerContext);
        return workspaceId;
    },
    maxAge: Infinity
});

});
parcelRegister("ahEft", function(module, exports) {

$parcel$export(module.exports, "getUserJsmLicenceState", () => $b8bed038f2dce149$export$65bf73aad2afa39);
$parcel$export(module.exports, "isPremiumInstance", () => $b8bed038f2dce149$export$abb609d3bcbb74f6);
$parcel$export(module.exports, "isLicensedPremiumUser", () => $b8bed038f2dce149$export$d7b4c32773b1c643);
$parcel$export(module.exports, "default", () => $b8bed038f2dce149$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $4VpwK = parcelRequire("4VpwK");

var $ktP1V = parcelRequire("ktP1V");

var $5Ny9E = parcelRequire("5Ny9E");

var $ldyPw = parcelRequire("ldyPw");

const $b8bed038f2dce149$export$530f260cc76f04ff = (baseUrl)=>`${baseUrl}/rest/servicedesk/cmdb/latest/workspace`;
const $b8bed038f2dce149$export$65bf73aad2afa39 = (tenantContext)=>{
    const { licensedProducts: licensedProducts, appPermissions: appPermissions } = tenantContext;
    const hasJsmLicence = licensedProducts && licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61];
    const isJsmLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
    if (!hasJsmLicence) return {
        siteHasJsmInstalled: false
    };
    return {
        siteHasJsmInstalled: true,
        siteIsPremium: $b8bed038f2dce149$export$abb609d3bcbb74f6(tenantContext),
        userLicensed: isJsmLicensedUser
    };
};
const $b8bed038f2dce149$export$abb609d3bcbb74f6 = (tenantContext)=>{
    const { appEditions: { serviceDesk: serviceDeskAppEdition } } = tenantContext;
    const isPremium = serviceDeskAppEdition === (0, $ldyPw.PREMIUM_EDITION);
    return isPremium;
};
const $b8bed038f2dce149$export$d7b4c32773b1c643 = (tenantContext)=>{
    const { appPermissions: appPermissions } = tenantContext;
    const isPremium = $b8bed038f2dce149$export$abb609d3bcbb74f6(tenantContext);
    const isLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
    return isPremium && isLicensedUser;
};
const $b8bed038f2dce149$var$transformResponse = (response)=>{
    const ids = response.results ?? [];
    return ids.length ? (0, $5Ny9E.toWorkspaceId)(ids[0].id) : null;
};
const $b8bed038f2dce149$export$e1d718dfe6dad973 = (routerContext, { tenantContext: tenantContext })=>{
    const { baseUrl: baseUrl } = tenantContext;
    if ($b8bed038f2dce149$export$d7b4c32773b1c643(tenantContext) === false || !(0, $ktP1V.isCMDBEnabledInEnvironment)()) return null;
    return (0, $4VpwK.performCmdbGetRequest)($b8bed038f2dce149$export$530f260cc76f04ff(baseUrl)).then($b8bed038f2dce149$var$transformResponse).catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('spa.view.routes.servicedesk.workspace-id', 'Error while fetching servicedesk Insight workspace id', error);
        return null;
    });
};
var $b8bed038f2dce149$export$2e2bcd8739ae039 = $b8bed038f2dce149$export$e1d718dfe6dad973;

});
parcelRegister("4VpwK", function(module, exports) {

$parcel$export(module.exports, "performCmdbGetRequest", () => $270bf98960acb19c$export$a252413f43ec7247);
$parcel$export(module.exports, "performCmdbPostRequest", () => $270bf98960acb19c$export$d68a9f67166d25a2);
$parcel$export(module.exports, "performCmdbPutRequest", () => $270bf98960acb19c$export$326b7407f501f98b);
$parcel$export(module.exports, "performCmdbDeleteRequest", () => $270bf98960acb19c$export$b198eb14f22c12e6);

var $4R6GH = parcelRequire("4R6GH");

var $5HnTq = parcelRequire("5HnTq");

var $eusud = parcelRequire("eusud");
const $270bf98960acb19c$export$d5e211a0106aa636 = {
    'X-Request-Source': 'cmdb-frontend'
};
const $270bf98960acb19c$export$a252413f43ec7247 = (url, options)=>(0, $eusud.performGetRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(url, options));
const $270bf98960acb19c$export$d68a9f67166d25a2 = (url, options)=>(0, $eusud.performPostRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(url, options));
const $270bf98960acb19c$export$326b7407f501f98b = (url, options)=>(0, $eusud.performPutRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(url, options));
const $270bf98960acb19c$export$b198eb14f22c12e6 = (url, options)=>(0, $eusud.performDeleteRequest)(url, $270bf98960acb19c$export$235b7fc70b9fc359(url, options));
const $270bf98960acb19c$export$235b7fc70b9fc359 = (url, options)=>{
    const defaultOptions = (0, $5HnTq.getDefaultOptions)(url);
    return (0, $4R6GH.fg)('fly-2529-cmdb-client-send-request-source-header') ? {
        ...defaultOptions,
        ...options,
        headers: {
            ...defaultOptions.headers,
            ...options?.headers,
            ...$270bf98960acb19c$export$d5e211a0106aa636
        }
    } : options;
};

});

parcelRegister("ktP1V", function(module, exports) {

$parcel$export(module.exports, "isCMDBEnabledInEnvironment", () => $84a32a7226f836c4$export$6dbfb62369f79a64);

var $b4PzF = parcelRequire("b4PzF");

var $4R6GH = parcelRequire("4R6GH");
const $84a32a7226f836c4$export$6dbfb62369f79a64 = ()=>!(0, $b4PzF.isFedRamp)() || (0, $b4PzF.isFedRamp)() && (0, $4R6GH.fg)('jsm-assets-fedramp-ui');

});

parcelRegister("5Ny9E", function(module, exports) {

$parcel$export(module.exports, "toSchemaId", () => $a330a4171d28d64c$export$d577b7f3b832f656);
$parcel$export(module.exports, "toCmdbObjectId", () => $a330a4171d28d64c$export$1ba342595bc7be13);
$parcel$export(module.exports, "toCmdbObjectTypeId", () => $a330a4171d28d64c$export$b46e25afa2bab6a);
$parcel$export(module.exports, "toObjectCommentId", () => $a330a4171d28d64c$export$ece2917434bb0a8c);
$parcel$export(module.exports, "toWorkspaceId", () => $a330a4171d28d64c$export$d002b8d7821b6b59);
$parcel$export(module.exports, "toObjectTypeAttributeId", () => $a330a4171d28d64c$export$cfd92c18cee8add7);
const $a330a4171d28d64c$export$d577b7f3b832f656 = (id)=>id;
const $a330a4171d28d64c$export$1ba342595bc7be13 = (id)=>id;
const $a330a4171d28d64c$export$b46e25afa2bab6a = (id)=>id;
const $a330a4171d28d64c$export$ece2917434bb0a8c = (id)=>id;
const $a330a4171d28d64c$export$d002b8d7821b6b59 = (id)=>id;
const $a330a4171d28d64c$export$cfd92c18cee8add7 = (id)=>id;

});

const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';



parcelRegister("lfnsv", function(module, exports) {

$parcel$export(module.exports, "boardDetailsResource", () => $d78990d38f225e07$export$6c6984c55b171c5d);
$parcel$export(module.exports, "getBoardDetailsResource", () => $d78990d38f225e07$export$b67eabcfc08e7c62);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $7f4tk = parcelRequire("7f4tk");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");

var $PK2Tm = parcelRequire("PK2Tm");
const $d78990d38f225e07$export$90ce361a5838e31e = async (boardId)=>{
    try {
        return await (0, $7f4tk.default)(`/rest/agile/1.0/board/${boardId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getBoardDetailsRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $d78990d38f225e07$export$6c6984c55b171c5d = (0, $2M1hQ.createResource)({
    type: 'CLASSIC_BOARD_SETTING_BOARD_DETAILS',
    getKey: (routerContext)=>(0, $PK2Tm.getConfigFromRouterContext)(routerContext) ? 'cmp-board-settings' : 'not-cmp-board-setting',
    getData: async (routerContext)=>{
        const boardId = routerContext.match.params?.boardId ?? '';
        if ((0, $PK2Tm.getConfigFromRouterContext)(routerContext)) return $d78990d38f225e07$export$90ce361a5838e31e(boardId);
        return null;
    }
});
const $d78990d38f225e07$export$b67eabcfc08e7c62 = ()=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('simplified-boards-milestone-2_07hbk'), $d78990d38f225e07$export$6c6984c55b171c5d);

});
parcelRegister("PK2Tm", function(module, exports) {

$parcel$export(module.exports, "buildAllDataQueryParams", () => $df00ee708c57537c$export$487708debaea6de3);
$parcel$export(module.exports, "getInlineScriptData", () => $df00ee708c57537c$export$7bd4b867b9305f97);
$parcel$export(module.exports, "getRapidViewConfigFromRouteName", () => $df00ee708c57537c$export$62c86c4062215346);
$parcel$export(module.exports, "getRequiredResourceList", () => $df00ee708c57537c$export$7bff98a3d459b1b8);
$parcel$export(module.exports, "getConfigFromRouterContext", () => $df00ee708c57537c$export$1705c550e5b835bf);

var $4R6GH = parcelRequire("4R6GH");

var $1odlY = parcelRequire("1odlY");

var $9hNId = parcelRequire("9hNId");
const $df00ee708c57537c$export$487708debaea6de3 = (query, match)=>{
    const { rapidView: rapidView, quickFilter: quickFilter, projectKey: queryProjectKey, etag: etag } = query;
    const boardId = match.params.boardId || rapidView;
    const projectKey = match.params.projectKey || queryProjectKey;
    let activeQuickFilters = '';
    if (quickFilter) activeQuickFilters = Array.isArray(quickFilter) ? quickFilter.reduce((prevFilter, nextFilter)=>`${prevFilter}&activeQuickFilters=${nextFilter}`, activeQuickFilters) : `&activeQuickFilters=${quickFilter}`;
    const etagParam = etag ? `&etag=${etag}` : '';
    const projectKeyParam = projectKey ? `&selectedProjectKey=${projectKey}` : '';
    const { GH: GH } = window;
    const forceConsistency = '&forceConsistency=true';
    GH?.RapidBoard?.State?.setRapidViewIdForEventuallyConsistentBoard(undefined);
    return `rapidViewId=${boardId}${projectKeyParam}${activeQuickFilters}${etagParam}${forceConsistency}`;
};
const $df00ee708c57537c$var$cleanUpInlineScript = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window[dataName];
};
const $df00ee708c57537c$export$7bd4b867b9305f97 = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const req = window[dataName];
    if (!req) return null;
    if (req.readyState === req.DONE && req.status !== 200) {
        $df00ee708c57537c$var$cleanUpInlineScript(dataName);
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new Promise((r)=>{
        if (req.readyState === req.DONE && req.status === 200) {
            $df00ee708c57537c$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        } else req.addEventListener('load', ()=>{
            $df00ee708c57537c$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        });
    });
};
const $df00ee708c57537c$export$62c86c4062215346 = (routeName)=>{
    for (const routeConfig of Object.values((0, $9hNId.RAPID_VIEW_ROUTE_CONFIG))){
        if (routeConfig.routes?.includes(routeName)) return routeConfig;
    }
    return (0, $9hNId.RAPID_VIEW_ROUTE_CONFIG).DEFAULT;
};
const $df00ee708c57537c$export$7bff98a3d459b1b8 = (view)=>{
    let rapidboardResources = (0, $1odlY.WRM_RESOURCES_ARRAY);
    if ((0, $4R6GH.fg)('reports-overview-page-migration')) {
        if (view) {
            const routeConfig = $df00ee708c57537c$export$62c86c4062215346(view);
            return [
                ...(0, $1odlY.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
                ...routeConfig.resources
            ];
        }
        return [
            ...(0, $1odlY.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
            ...(0, $9hNId.RAPID_VIEW_ROUTE_CONFIG).DEFAULT.resources
        ];
    }
    // eslint-disable-next-line default-case
    switch(view){
        case 'rapidboard-board':
        case 'rapidboard-board-embed':
        case 'rapidboard-user-board':
        case 'servicedesk-boards':
        case 'servicedesk-queues-custom-board':
        case 'servicedesk-queues-practice-custom-board':
            rapidboardResources = (0, $1odlY.WRM_BOARD_RESOURCES_FHD_ARRAY);
            break;
        case 'rapidboard-backlog':
        case 'rapidboard-user-backlog':
        case 'rapidboard-backlog-embed':
            rapidboardResources = (0, $1odlY.WRM_BACKLOG_RESOURCES_FHD_ARRAY);
            break;
    }
    return [
        ...(0, $1odlY.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
        ...rapidboardResources
    ];
};
function $df00ee708c57537c$export$1705c550e5b835bf(routerContext) {
    return routerContext.match?.params.config || routerContext.query?.config || '';
}

});
parcelRegister("1odlY", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG", () => $fa7f7a1583a8dcf1$export$88e2a0b89be042c1);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA", () => $fa7f7a1583a8dcf1$export$ba075d0985968d1c);
$parcel$export(module.exports, "RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS", () => $fa7f7a1583a8dcf1$export$395f77888d07f2e0);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_RESOURCE", () => $fa7f7a1583a8dcf1$export$4f7c4e3508fd2a07);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE", () => $fa7f7a1583a8dcf1$export$3328c8e71fda97bb);
$parcel$export(module.exports, "WRM_RESOURCES_ARRAY", () => $fa7f7a1583a8dcf1$export$ef21257df3d71188);
$parcel$export(module.exports, "WRM_HERITAGE_RESOURCES_FHD_ARRAY", () => $fa7f7a1583a8dcf1$export$ccd0929652c235de);
$parcel$export(module.exports, "WRM_BOARD_RESOURCES_FHD_ARRAY", () => $fa7f7a1583a8dcf1$export$1d16bdcc94a40107);
$parcel$export(module.exports, "WRM_BACKLOG_RESOURCES_FHD_ARRAY", () => $fa7f7a1583a8dcf1$export$1f599d2eef0a7281);
const $fa7f7a1583a8dcf1$export$88e2a0b89be042c1 = 'RESOURCE_RAPIDBOARDS_BOARD_CONFIG';
const $fa7f7a1583a8dcf1$export$ba075d0985968d1c = 'RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA';
const $fa7f7a1583a8dcf1$export$395f77888d07f2e0 = 'PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS';
const $fa7f7a1583a8dcf1$export$4f7c4e3508fd2a07 = 'RESOURCE_TYPE_RAPIDBOARDS_RESOURCE';
const $fa7f7a1583a8dcf1$export$3328c8e71fda97bb = 'RESOURCE_RAPIDBOARDS_WRM_BUNDLE';
const $fa7f7a1583a8dcf1$export$ef21257df3d71188 = [
    '_super',
    'wrc!greenhopper-rapid-non-gadget',
    'wrc!gh-rapid',
    'wrc!jira.global',
    'wrc!jira.general',
    'wrc!atl.global',
    // Required to prevent an error on initial loading of reports
    'wrc!jira.webresources:header',
    // Required for Control Chart report page
    'wrc!jira.webresources:calendar',
    'wrc!jira.webresources:calendar-en',
    'wrc!jira.webresources:jira.webresources:calendar-localisation-moment',
    // Required for explicit usage of jQuery
    'wrc!com.atlassian.jira.project-templates-plugin:project-templates-plugin-resources',
    // Required for the styles of the toggle button when transitioning from reports to board settings
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-aui-toggle',
    // Required for the profile card in board settings, that doesn't really render because it has wrong
    // parameters and it has been broken for ages, but at least prevents noisy errors
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:profilecard',
    'wrc!gh-rapid-config',
    'wrc!gh-rapid-analytics',
    'wrc!gh-rapid-charts',
    'wrc!jira.webresources:mentions-feature',
    'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-dialog-resources-ctx'
];
const $fa7f7a1583a8dcf1$export$ccd0929652c235de = [];
const $fa7f7a1583a8dcf1$export$1d16bdcc94a40107 = [
    'wrc!gh-rapid-lwf-board-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];
const $fa7f7a1583a8dcf1$export$1f599d2eef0a7281 = [
    'wrc!gh-rapid-backlog-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:header',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];

});

parcelRegister("9hNId", function(module, exports) {

$parcel$export(module.exports, "RAPID_VIEW_ROUTE_CONFIG", () => $f34cebd5a04e9077$export$99d0df2f58f37dfe);

var $1odlY = parcelRequire("1odlY");
const $f34cebd5a04e9077$export$99d0df2f58f37dfe = {
    BOARD: {
        routes: [
            'rapidboard-board',
            'rapidboard-board-embed',
            'rapidboard-user-board',
            'servicedesk-boards',
            'servicedesk-queues-custom-board',
            'servicedesk-queues-practice-custom-board'
        ],
        resources: (0, $1odlY.WRM_BOARD_RESOURCES_FHD_ARRAY),
        stateKey: 'board-state'
    },
    BACKLOG: {
        routes: [
            'rapidboard-backlog',
            'rapidboard-user-backlog',
            'rapidboard-backlog-embed'
        ],
        resources: (0, $1odlY.WRM_BACKLOG_RESOURCES_FHD_ARRAY),
        stateKey: 'backlog-state'
    },
    DEFAULT: {
        resources: (0, $1odlY.WRM_RESOURCES_ARRAY),
        stateKey: 'report-state'
    }
};

});



parcelRegister("f5kpo", function(module, exports) {

$parcel$export(module.exports, "shouldLoadUIFBoardResources", () => $e96bf35f407138bb$export$d8d4641986a9ac7f);
$parcel$export(module.exports, "getRapidboardResources", () => $e96bf35f407138bb$export$3a5e56bd5231a56b);
$parcel$export(module.exports, "getRapidBoardDataResource", () => $e96bf35f407138bb$export$1c63de7f548f965f);
$parcel$export(module.exports, "getUIFBacklogDataResource", () => $e96bf35f407138bb$export$ee826506b3baa13a);

var $4R6GH = parcelRequire("4R6GH");

var $5Nutl = parcelRequire("5Nutl");

var $gNStA = parcelRequire("gNStA");

var $i6CNv = parcelRequire("i6CNv");

var $kdyVI = parcelRequire("kdyVI");

var $gQ2J4 = parcelRequire("gQ2J4");

var $fox5Q = parcelRequire("fox5Q");
const $e96bf35f407138bb$export$d8d4641986a9ac7f = ()=>!false;
const $e96bf35f407138bb$export$462ca08d6ce67848 = ()=>!$e96bf35f407138bb$export$d8d4641986a9ac7f();
const $e96bf35f407138bb$export$3a5e56bd5231a56b = ()=>[
        (0, $fox5Q.wrmBundleResource),
        (0, $i6CNv.boardConfigApiResource),
        (0, $gNStA.resourceWithCondition2)($e96bf35f407138bb$export$462ca08d6ce67848, (0, $gQ2J4.rapidboardResource))
    ];
const $e96bf35f407138bb$export$1c63de7f548f965f = ()=>(0, $kdyVI.boardDataResource);
const $e96bf35f407138bb$export$ee826506b3baa13a = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && (0, $4R6GH.fg)('jsw-backlog-preload-config-data'), (0, $5Nutl.backlogConfigResource)),
        (0, $gNStA.resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && (0, $4R6GH.fg)('jsw-backlog-preload-config-data'), (0, $5Nutl.backlogGlobalConfigResource)),
        (0, $gNStA.resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && !(0, $4R6GH.fg)('indexeddb_cache_for_backlog'), (0, $5Nutl.uifBacklogResourceOld)),
        (0, $gNStA.resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && (0, $4R6GH.fg)('indexeddb_cache_for_backlog'), (0, $5Nutl.uifBacklogResource))
    ];

});
parcelRegister("5Nutl", function(module, exports) {

$parcel$export(module.exports, "uifBacklogResourceOld", () => $9905b3c28d313f7e$export$db83ef0443397b85);
$parcel$export(module.exports, "uifBacklogResource", () => $9905b3c28d313f7e$export$c182dffb98985208);
$parcel$export(module.exports, "backlogConfigResource", () => $9905b3c28d313f7e$export$f894eb38e7ada0d6);
$parcel$export(module.exports, "backlogGlobalConfigResource", () => $9905b3c28d313f7e$export$ee2927bb14d7fd87);

var $2M1hQ = parcelRequire("2M1hQ");


const $9905b3c28d313f7e$export$db83ef0443397b85 = (0, $2M1hQ.createResource)({
    type: (0, $2fdbe99f6cbea4f1$export$8f9824ba4409b537),
    getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */ [
            'uif-backlog-data'
        ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
    getDataLoader: ()=>(parcelRequire("co9mN")),
    // Setting mexAge to 0 so it will get the data again after coming back from a config page
    maxAge: 0
});

const $9905b3c28d313f7e$export$c182dffb98985208 = (0, $2M1hQ.createResource)({
    type: (0, $2fdbe99f6cbea4f1$export$d15ce4feabd76ea),
    getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */ [
            'uif-backlog-data'
        ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
    getDataLoader: ()=>(parcelRequire("8Ax6r")),
    // Setting mexAge to 0 so it will get the data again after coming back from a config page
    maxAge: 0
});

const $9905b3c28d313f7e$export$f894eb38e7ada0d6 = (0, $2M1hQ.createResource)({
    type: (0, $2fdbe99f6cbea4f1$export$213e774bb8f521ee),
    getKey: ({ match: { params: { boardId: boardId } } })=>`backlog-config-data-${boardId ?? ''}`,
    getDataLoader: ()=>(parcelRequire("jY5eD"))
});

const $9905b3c28d313f7e$export$ee2927bb14d7fd87 = (0, $2M1hQ.createResource)({
    type: (0, $2fdbe99f6cbea4f1$export$285d72b0274b22cc),
    getKey: ({ match: { params: { boardId: boardId } } })=>`backlog-global-config-data-${boardId ?? ''}`,
    getDataLoader: ()=>(parcelRequire("ccl9g"))
});

});
const $2fdbe99f6cbea4f1$export$d15ce4feabd76ea = 'NEXTGEN_BACKLOG_REST';
const $2fdbe99f6cbea4f1$export$8f9824ba4409b537 = 'NEXTGEN_BACKLOG_REST_OLD';
const $2fdbe99f6cbea4f1$export$213e774bb8f521ee = 'NEXTGEN_BACKLOG_CONFIG_DATA';
const $2fdbe99f6cbea4f1$export$285d72b0274b22cc = 'NEXTGEN_BACKLOG_GLOBAL_CONFIG_DATA';

parcelRegister("co9mN", function(module, exports) {

let $904efdee7a70da66$var$load = (parcelRequire("28QjX"))(4);
module.exports = $904efdee7a70da66$var$load("hgAfI").then(()=>parcelRequire('gTjY8'));

});

parcelRegister("8Ax6r", function(module, exports) {

let $640b5d17b6b42f1a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $640b5d17b6b42f1a$var$load("8723H").then(()=>parcelRequire('cpSf8'));

});

parcelRegister("jY5eD", function(module, exports) {

let $e897ae7f423abd03$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e897ae7f423abd03$var$load("7gWra").then(()=>parcelRequire('fARTX'));

});

parcelRegister("ccl9g", function(module, exports) {

let $8e1702ac327d92bb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8e1702ac327d92bb$var$load("8d4vK").then(()=>parcelRequire('sSRsi'));

});


parcelRegister("i6CNv", function(module, exports) {

$parcel$export(module.exports, "boardConfigApiResource", () => $8a55ba0bef7e0e2a$export$dd9dec064acb0c4e);
// eslint-disable-next-line jira/import-whitelist

var $6s1PB = parcelRequire("6s1PB");

var $2M1hQ = parcelRequire("2M1hQ");

var $1odlY = parcelRequire("1odlY");
const $8a55ba0bef7e0e2a$var$getMaxAge = ()=>false ? 0 : (0, $6s1PB.expVal)('jsw-classic-board-api-calls-config-cache-time', 'value', 0) * 1000;

const $8a55ba0bef7e0e2a$export$dd9dec064acb0c4e = (0, $2M1hQ.createResource)({
    type: (0, $1odlY.RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG),
    getKey: ({ match: match, query: query })=>{
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        return `rapidViewConfig-${boardId}`; // Should Also have a mode but for now lets use only id
    },
    getDataLoader: ()=>(parcelRequire("gsqVU")),
    maxAge: $8a55ba0bef7e0e2a$var$getMaxAge(),
    isBrowserOnly: true
});

});
parcelRegister("gsqVU", function(module, exports) {

let $bfb4273a60bf77b0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bfb4273a60bf77b0$var$load("dz3p9").then(()=>parcelRequire('aCQV9'));

});


parcelRegister("kdyVI", function(module, exports) {

$parcel$export(module.exports, "boardDataResource", () => $18aa0ee73b651f62$export$138fa635416978f7);

var $2M1hQ = parcelRequire("2M1hQ");

var $1odlY = parcelRequire("1odlY");

var $9g2vH = parcelRequire("9g2vH");

const $18aa0ee73b651f62$export$138fa635416978f7 = (0, $2M1hQ.createResource)({
    type: (0, $1odlY.RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA),
    getKey: ({ match: match, query: query, route: route })=>{
        const { name: name = '' } = route || {};
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        const { config: config } = query;
        const hasConfig = Boolean(config);
        let key = 'rapidBoardData';
        if ((0, $9g2vH.isBoardRoute)(name)) key = `boardData-${boardId}::hasConfig=${hasConfig}`;
        else if ((0, $9g2vH.isBacklogRoute)(name)) key = `backlogData-${boardId}::hasConfig=${hasConfig}`;
        return key;
    },
    getDataLoader: ()=>(parcelRequire("ma8fm")),
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("9g2vH", function(module, exports) {

$parcel$export(module.exports, "isBoardRoute", () => $ccbac8c858ea0da2$export$437d4d6e25681588);
$parcel$export(module.exports, "isBacklogRoute", () => $ccbac8c858ea0da2$export$bcb853db5e3e8054);
const $ccbac8c858ea0da2$export$437d4d6e25681588 = (routeName)=>routeName === 'rapidboard-board' || routeName === 'rapidboard-board-embed' || routeName === 'rapidboard-board-settings' || routeName === 'rapidboard-user-board' || routeName === 'rapidboard-user-board-settings' || routeName === 'servicedesk-boards' || routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-practice-custom-board';
const $ccbac8c858ea0da2$export$bcb853db5e3e8054 = (routeName)=>routeName === 'rapidboard-backlog' || routeName === 'rapidboard-user-backlog' || routeName === 'rapidboard-backlog-embed';

});

parcelRegister("ma8fm", function(module, exports) {

let $0429ea31ef544334$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0429ea31ef544334$var$load("75jqm").then(()=>parcelRequire('iW9CS'));

});


parcelRegister("gQ2J4", function(module, exports) {

$parcel$export(module.exports, "rapidboardResource", () => $b172ecb4db4f1d22$export$d0f42a55e7c5752c);

var $2M1hQ = parcelRequire("2M1hQ");

var $1odlY = parcelRequire("1odlY");

const $b172ecb4db4f1d22$export$d0f42a55e7c5752c = (0, $2M1hQ.createResource)({
    type: (0, $1odlY.RESOURCE_TYPE_RAPIDBOARDS_RESOURCE),
    getKey: ({ match: match })=>match.query.rapidView || '',
    getDataLoader: ()=>(parcelRequire("EuXLN")),
    maxAge: Number.MAX_VALUE,
    isBrowserOnly: true
});

});
parcelRegister("EuXLN", function(module, exports) {

let $079bc1279c32054a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $079bc1279c32054a$var$load("hq4Ox").then(()=>parcelRequire('LP66E'));

});


parcelRegister("fox5Q", function(module, exports) {

$parcel$export(module.exports, "wrmBundleResource", () => $bb15c3971b88e6fc$export$f199d15b7cd18df1);

var $2M1hQ = parcelRequire("2M1hQ");

var $4R6GH = parcelRequire("4R6GH");

var $1odlY = parcelRequire("1odlY");

var $PK2Tm = parcelRequire("PK2Tm");

const $bb15c3971b88e6fc$export$f199d15b7cd18df1 = (0, $2M1hQ.createResource)({
    type: (0, $1odlY.RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE),
    getKey: ({ route: route })=>{
        if ((0, $4R6GH.fg)('reports-overview-page-migration')) return (0, $PK2Tm.getRapidViewConfigFromRouteName)(route.name).stateKey;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("dbFSD")),
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
parcelRegister("dbFSD", function(module, exports) {

let $999cc9fff1a468f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $999cc9fff1a468f5$var$load("3c33e").then(()=>parcelRequire('bdOyr'));

});



parcelRegister("f7Y15", function(module, exports) {

$parcel$export(module.exports, "uifBoardResource", () => $6f8724e78df4e830$export$b65bcbbccad354ac);

var $2M1hQ = parcelRequire("2M1hQ");


const $6f8724e78df4e830$export$b65bcbbccad354ac = (0, $2M1hQ.createResource)({
    type: (0, $16d4c226f5e6f5f8$export$cfae566ecf2855f8),
    getKey: ({ match: { params: { boardId: boardId } }, route: { name: routeName }, query: { config: config } })=>{
        if (config) return `uif-board::${routeName}::config`;
        if (boardId == null) return `uif-board::${routeName}::not-found`;
        return `uif-board::${routeName}::${boardId}`;
    },
    getDataLoader: ()=>(parcelRequire("bjRyj")),
    maxAge: 0
});

});
const $16d4c226f5e6f5f8$export$cfae566ecf2855f8 = 'UIF_BOARD';

parcelRegister("bjRyj", function(module, exports) {

let $83db0270c34ab46d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $83db0270c34ab46d$var$load("bLcEa").then(()=>parcelRequire('1HjYz'));

});


parcelRegister("lJ1FP", function(module, exports) {

$parcel$export(module.exports, "editModelResource", () => $16cc53c7df259df5$export$ab9a4786826fd2d);
$parcel$export(module.exports, "getEditModelResource", () => $16cc53c7df259df5$export$5b9bac2cc4bf4511);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $7f4tk = parcelRequire("7f4tk");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");

var $PK2Tm = parcelRequire("PK2Tm");
const $16cc53c7df259df5$export$ddbb511f9111736a = async (boardId)=>{
    try {
        return await (0, $7f4tk.default)(`/rest/greenhopper/1.0/rapidviewconfig/editmodel.json?cardLayoutConfig=false&rapidViewId=${boardId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getEditModelRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $16cc53c7df259df5$export$ab9a4786826fd2d = (0, $2M1hQ.createResource)({
    type: 'CLASSIC_BOARD_SETTING_EDIT_MODEL',
    getKey: (routerContext)=>(0, $PK2Tm.getConfigFromRouterContext)(routerContext) ? 'edit-model' : 'not-edit-model',
    getData: async (routerContext)=>{
        if ((0, $PK2Tm.getConfigFromRouterContext)(routerContext)) {
            const boardId = routerContext.match.params?.boardId ?? '';
            return $16cc53c7df259df5$export$ddbb511f9111736a(boardId);
        }
        return null;
    }
});
const $16cc53c7df259df5$export$5b9bac2cc4bf4511 = ()=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('simplified-boards-milestone-2_07hbk') && !(0, $4R6GH.fg)('board-settings-graphql-refactor_cyvz9'), $16cc53c7df259df5$export$ab9a4786826fd2d);

});


parcelRegister("k7Q6G", function(module, exports) {

$parcel$export(module.exports, "connectGeneralServiceDeskProjectRoute", () => $d699769fc97b2ccd$export$e8a58aee75961b55);
const $d699769fc97b2ccd$export$e8a58aee75961b55 = {
    name: 'connect-general-service-desk-project',
    path: '/plugins/servlet/ac/:addonKey/:moduleKey',
    query: [
        'mobile?!=true',
        'includeWebResources?!=true',
        'classifier?!=json',
        'project.key?',
        'project.id?',
        'project.key',
        'servicedesk.serviceDeskId'
    ]
};

});


parcelRegister("4Zw1h", function(module, exports) {

$parcel$export(module.exports, "connectProjectRouteEntry", () => $88ce8816647240e1$export$96bdc57a01f2ee48);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $dx5ZK = parcelRequire("dx5ZK");

var $cYYI7 = parcelRequire("cYYI7");

var $iTDbG = parcelRequire("iTDbG");
const $88ce8816647240e1$export$96bdc57a01f2ee48 = (0, $7NszV.createEntry)((0, $dx5ZK.connectProjectRoute), ()=>({
        group: 'connect',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        layout: (0, $gyYxw.genericProjectLayout),
        ufoName: 'jira-connect',
        // Match resources that are fetched for legacyConnectProjectRouteEntry
        // See src/packages/router-routes/legacy/connect-project/entries/src/index.tsx
        resources: [
            ...(0, $cYYI7.getProjectConnectRouteDefaultResources)(),
            ...(0, $fpjJX.getServiceDeskSharedNavigationSingleResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $iTDbG.connectProjectsPageEntrypoint)
    }));

});
parcelRegister("dx5ZK", function(module, exports) {

$parcel$export(module.exports, "connectProjectRoute", () => $e3a0435584f46760$export$27e7531864dfb704);

var $kUeZd = parcelRequire("kUeZd");
const $e3a0435584f46760$export$27e7531864dfb704 = {
    name: 'connect-project',
    path: '/projects/:projectKey',
    query: (0, $kUeZd.CONNECT_PROJECT_QUERY_PARAMS)
};

});
parcelRegister("kUeZd", function(module, exports) {

$parcel$export(module.exports, "CONNECT_PROJECT_QUERY_PARAMS", () => $e64562bb8c3fa371$export$9bb839aee83bf4d8);
const $e64562bb8c3fa371$export$9bb839aee83bf4d8 = [
    'selectedItem=(^com.atlassian.plugins.atlassian-connect-plugin.*)'
];

});


parcelRegister("iTDbG", function(module, exports) {

$parcel$export(module.exports, "connectProjectsPageEntrypoint", () => $c9a4402f23043c3c$export$d7105af2aa9527d0);
$parcel$export(module.exports, "connectProjectsWithoutHorizontalNavPageEntrypoint", () => $c9a4402f23043c3c$export$8df81c5e9c00a7b4);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $8vOSr = parcelRequire("8vOSr");

var $fo6b8 = parcelRequire("fo6b8");
const $c9a4402f23043c3c$export$d7105af2aa9527d0 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8vOSr.connectProjectsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $c9a4402f23043c3c$export$8df81c5e9c00a7b4 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8vOSr.connectProjectsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("8vOSr", function(module, exports) {

$parcel$export(module.exports, "connectProjectsEntrypoint", () => $b7bf9b62cbd74d5f$export$4ff832a017f5175c);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $b7bf9b62cbd74d5f$export$4ff832a017f5175c = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("5sRNh")), {
        moduleId: "2203c501"
    }),
    getPreloadProps: ({ context: context })=>({
            extraProps: {
                query: context.query
            }
        })
});

});
parcelRegister("5sRNh", function(module, exports) {

let $3fa94b97422ad26a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3fa94b97422ad26a$var$load("6lBjo").then(()=>parcelRequire('2GYK9'));

});




parcelRegister("iLmKH", function(module, exports) {

$parcel$export(module.exports, "servicedeskConnectProjectRouteEntry", () => $ec6bba63502dd6b2$export$72138a83eeba68eb);

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $4IAAz = parcelRequire("4IAAz");

var $6Z2mh = parcelRequire("6Z2mh");

var $cYYI7 = parcelRequire("cYYI7");

var $iTDbG = parcelRequire("iTDbG");
const $ec6bba63502dd6b2$export$72138a83eeba68eb = (0, $7NszV.createEntry)((0, $4IAAz.servicedeskConnectProjectRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $cYYI7.getProjectConnectRouteDefaultResources)(),
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'jira-connect',
        entryPoint: ()=>(0, $iTDbG.connectProjectsWithoutHorizontalNavPageEntrypoint)
    }));

});
parcelRegister("4IAAz", function(module, exports) {

$parcel$export(module.exports, "servicedeskConnectProjectRoute", () => $03d8cdc4dcb18bd2$export$148fcbe26061b2c9);

var $kUeZd = parcelRequire("kUeZd");
const $03d8cdc4dcb18bd2$export$148fcbe26061b2c9 = {
    name: 'servicedesk-connect-project',
    path: '/jira/servicedesk/projects/:projectKey',
    query: (0, $kUeZd.CONNECT_PROJECT_QUERY_PARAMS),
    exact: true
};

});


parcelRegister("dqjth", function(module, exports) {

$parcel$export(module.exports, "createProjectRouteEntry", () => $7e202110676952db$export$28887e2da22c839a);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $R0AuF = parcelRequire("R0AuF");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $7e202110676952db$var$LazyCreateProject = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("cA5jr")), {
    moduleId: "./src/packages/spa-apps/create-project/src/index.tsx"
});
const $7e202110676952db$var$CreateProject = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7e202110676952db$var$LazyCreateProject,
        pageId: "spa-apps/create-project",
        shouldShowSpinner: true
    });
const $7e202110676952db$export$28887e2da22c839a = (0, $7NszV.createEntry)((0, $R0AuF.createProjectRoute), ()=>({
        group: 'components',
        component: $7e202110676952db$var$CreateProject,
        layout: (0, $gyYxw.genericProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $7e202110676952db$var$LazyCreateProject
        ]
    }));

});
parcelRegister("R0AuF", function(module, exports) {

$parcel$export(module.exports, "createProjectRoute", () => $e9869d33b741028e$export$5ce9108542315ac8);
const $e9869d33b741028e$export$5ce9108542315ac8 = {
    name: 'create-project',
    path: '/jira/create-project',
    exact: true
};

});

parcelRegister("cA5jr", function(module, exports) {

let $928cf7ceaa8a8742$var$load = (parcelRequire("28QjX"))(4);
module.exports = $928cf7ceaa8a8742$var$load("p91SI").then(()=>parcelRequire('6cT2s'));

});


parcelRegister("2fNbh", function(module, exports) {

$parcel$export(module.exports, "dashboardEditRouteEntry", () => $ff9c4f8f4f936d52$export$9b0fdfd6a51a17de);

var $j6woB = parcelRequire("j6woB");


var $e2ctp = parcelRequire("e2ctp");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $gh1hi = parcelRequire("gh1hi");

var $3RJkv = parcelRequire("3RJkv");

var $gCJaT = parcelRequire("gCJaT");

var $h4rc7 = parcelRequire("h4rc7");

var $irlpm = parcelRequire("irlpm");

var $lkFvK = parcelRequire("lkFvK");

var $fT58V = parcelRequire("fT58V");

var $ernoj = parcelRequire("ernoj");
const $ff9c4f8f4f936d52$export$9b0fdfd6a51a17de = (0, $7NszV.createEntry)((0, $gCJaT.dashboardEditRoute), ()=>({
        group: 'dashboard',
        entryPoint: ()=>$ff9c4f8f4f936d52$var$pageEntryPoint,
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $j6woB.dashboardBackgroundScriptsLayout)),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ernoj.dashboardResources)(),
            (0, $gh1hi.gadgetDirectoryResource)
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));
// Page entrypoint, referred to above...
const $ff9c4f8f4f936d52$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $irlpm.dashboardEditEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).DASHBOARDS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $h4rc7.nav4DashboardsContentEntryPoint)
            }
        }
    }
});

});
parcelRegister("j6woB", function(module, exports) {

$parcel$export(module.exports, "dashboardBackgroundScriptsLayout", () => $90a067693c09e346$export$f0a12e66953aa38a);

var $aPfsS = parcelRequire("aPfsS");

var $Xtn30 = parcelRequire("Xtn30");
const $90a067693c09e346$export$f0a12e66953aa38a = (0, $aPfsS.createLayout)({
    globalComponents: [
        (0, $Xtn30.DashboardBackgroundScripts)
    ]
});

});
parcelRegister("Xtn30", function(module, exports) {

$parcel$export(module.exports, "DashboardBackgroundScripts", () => $79510dabdd765f30$export$4095842bb2e8d712);

var $fZUl0 = parcelRequire("fZUl0");
const $79510dabdd765f30$export$4095842bb2e8d712 = (0, $fZUl0.LazyAfterPaintBackgroundScripts);
$79510dabdd765f30$export$4095842bb2e8d712.displayName = 'ConditionalDashboardBackgroundScripts';

});
parcelRegister("fZUl0", function(module, exports) {

$parcel$export(module.exports, "LazyAfterPaintBackgroundScripts", () => $f2fce09c535c3a19$export$d4768112536c9dc9);

var $b7Svb = parcelRequire("b7Svb");

const $f2fce09c535c3a19$export$d4768112536c9dc9 = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("2EyJT")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/dashboard/background-scripts/src/ui/index.tsx"
});

});
parcelRegister("2EyJT", function(module, exports) {

let $1eea43b0b8c45f89$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1eea43b0b8c45f89$var$load("7t741").then(()=>parcelRequire('bjmK5'));

});




parcelRegister("e2ctp", function(module, exports) {

$parcel$export(module.exports, "NORMAL_EARLY_ASSET_STRATEGY", () => $f36666704bcc2bab$export$137d6d169f402a59);
$parcel$export(module.exports, "AGGRESSIVE_EARLY_ASSET_STRATEGY", () => $f36666704bcc2bab$export$ad16a91905cefb0a);
const $f36666704bcc2bab$var$COMMON_ASSET_REGEX = /.*\/commons(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $f36666704bcc2bab$var$VENDOR_ASSET_REGEX = /.*\/vendor(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $f36666704bcc2bab$var$PARCEL_COMMON_ASSET_REGEX = /.*\/shared~commons(~ar)?(\.[0-9a-z]*)\.js/;
const $f36666704bcc2bab$var$PARCEL_VENDOR_ASSET_REGEX = /.*\/shared~vendor(~ar)?(\.[0-9a-z]*)\.js/;
const $f36666704bcc2bab$export$137d6d169f402a59 = [
    $f36666704bcc2bab$var$VENDOR_ASSET_REGEX,
    $f36666704bcc2bab$var$PARCEL_VENDOR_ASSET_REGEX
];
const $f36666704bcc2bab$export$ad16a91905cefb0a = [
    $f36666704bcc2bab$var$VENDOR_ASSET_REGEX,
    $f36666704bcc2bab$var$COMMON_ASSET_REGEX,
    $f36666704bcc2bab$var$PARCEL_VENDOR_ASSET_REGEX,
    $f36666704bcc2bab$var$PARCEL_COMMON_ASSET_REGEX
];

});

parcelRegister("gh1hi", function(module, exports) {

$parcel$export(module.exports, "dashboardConfigAndWRMResource", () => $ca62b878c99c7128$export$2853c0e656e89346);
$parcel$export(module.exports, "useDashboardResource", () => $ca62b878c99c7128$export$e5e5b3f462d6a4cb);
$parcel$export(module.exports, "useMultiDashboardsResource", () => $ca62b878c99c7128$export$6a46406b05d8d13c);
$parcel$export(module.exports, "dashboardAMDModulesResource", () => $ca62b878c99c7128$export$ef3fa55626812fa4);
$parcel$export(module.exports, "useDashboardAMDModulesResource", () => $ca62b878c99c7128$export$efe0eb9a44e08d38);
$parcel$export(module.exports, "dashboardReactGadgetsResource", () => $ca62b878c99c7128$export$39804ce8cc42cd04);
$parcel$export(module.exports, "useDashboardReactGadgetsResource", () => $ca62b878c99c7128$export$31b430e01a1caab5);
$parcel$export(module.exports, "dashboardForgeResource", () => $ca62b878c99c7128$export$4e0719e53da01e93);
$parcel$export(module.exports, "gadgetDirectoryResource", () => $ca62b878c99c7128$export$36c9632be21fbb06);
$parcel$export(module.exports, "useGadgetDirectoryResource", () => $ca62b878c99c7128$export$27f4c12e781b4572);
$parcel$export(module.exports, "useDashboardForgeResource", () => $ca62b878c99c7128$export$75ca1b431898fd09);

var $k2DRb = parcelRequire("k2DRb");

var $iVaKa = parcelRequire("iVaKa");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $3Yd87 = parcelRequire("3Yd87");

var $abozY = parcelRequire("abozY");


var $04Brv = parcelRequire("04Brv");

var $3cb5I = parcelRequire("3cb5I");

var $aVFmC = parcelRequire("aVFmC");

var $3Zhqx = parcelRequire("3Zhqx");

var $8oOn8 = parcelRequire("8oOn8");
const $ca62b878c99c7128$export$2853c0e656e89346 = (0, $2M1hQ.createResource)({
    type: (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16),
    getKey: $abozY.getKey,
    getData: (0, $3cb5I.default),
    maxAge: Infinity
});
// the type signature of promise and update is different on the useDashboardResource and useMultiDashboardsResource hook
const $ca62b878c99c7128$var$extractFirstPromise = (promise)=>promise ? promise.then((configs)=>configs && configs[0]) : null;
const $ca62b878c99c7128$export$e5e5b3f462d6a4cb = ()=>{
    // the response will have different signature on update, promise and clear etc
    const resourceResponse = $ca62b878c99c7128$export$6a46406b05d8d13c();
    const { loading: loading, error: error, data: data, promise: promiseOfMultiConfigs, ...rest } = resourceResponse;
    const extractFirstUpdate = (getNewData)=>resourceResponse.update(([a])=>[
                getNewData(a)
            ]);
    // RouteResourceResponseLoading type
    if (loading) return {
        ...rest,
        error: null,
        data: null,
        promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs),
        loading: true,
        update: extractFirstUpdate
    };
    // RouteResourceResponseError type
    if (error) return {
        ...rest,
        error: error,
        data: null,
        promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs),
        loading: false,
        update: extractFirstUpdate
    };
    // RouteResourceResponseLoaded type
    if (data && !error) return {
        ...rest,
        loading: false,
        update: extractFirstUpdate,
        data: data[0],
        error: null,
        promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs)
    };
    // RouteResourceResponseInitial type
    return {
        ...rest,
        loading: false,
        error: error,
        data: null,
        promise: null,
        update: extractFirstUpdate
    };
};
const $ca62b878c99c7128$export$6a46406b05d8d13c = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$2853c0e656e89346);
const $ca62b878c99c7128$export$ef3fa55626812fa4 = (0, $3Yd87.createDependentResource)({
    type: (0, $e03099b7bef7f4cd$export$e239393fd4e2bc85),
    getKey: $abozY.getKey,
    depends: [
        (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16)
    ],
    mapToSharedValue: (0, $3Yd87.withEitherDataOrError)((data)=>{
        const { gadgets: gadgets, preloadedModuleNames: preloadedModuleNames } = data.reduce((prev, curr)=>({
                gadgets: prev.gadgets.concat(curr.gadgets),
                preloadedModuleNames: prev.preloadedModuleNames.concat(curr.preloadedModuleNames)
            }), {
            gadgets: [],
            preloadedModuleNames: []
        });
        const moduleNames = (0, $8oOn8.gadgetsToUniqueSortedAmdModules)(gadgets);
        const isPreloaded = moduleNames.every((name)=>preloadedModuleNames.includes(name));
        return {
            moduleNames: moduleNames,
            isPreloaded: isPreloaded
        };
    }, (x)=>x),
    shouldUpdate: ({ sharedValue: a, amdModules: amdModules }, b)=>(0, $3Yd87.withEitherDataOrError)((prev, next)=>next.moduleNames.length > prev.moduleNames.length || next.moduleNames.some((name)=>amdModules?.[name] == null), ()=>true)(a, b),
    getData: (0, $04Brv.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $ca62b878c99c7128$export$efe0eb9a44e08d38 = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$ef3fa55626812fa4);
const $ca62b878c99c7128$export$39804ce8cc42cd04 = (0, $3Yd87.createDependentResource)({
    type: (0, $e03099b7bef7f4cd$export$9e5db01432b13b67),
    getKey: $abozY.getKey,
    depends: [
        (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16)
    ],
    mapToSharedValue: (0, $3Yd87.withEitherDataOrError)((data)=>{
        const gadgets = data.flatMap((dashboard)=>dashboard.gadgets);
        return {
            reactGadgets: (0, $8oOn8.gadgetsToSortedReactGadgets)(gadgets)
        };
    }, (x)=>x),
    shouldUpdate: ({ sharedValue: a, reactGadgetsState: reactGadgetsState }, b)=>(0, $3Yd87.withEitherDataOrError)((prev, next)=>JSON.stringify(next.reactGadgets) !== JSON.stringify(prev.reactGadgets) || reactGadgetsState != null && Object.values(reactGadgetsState).some((v)=>!v), ()=>true)(a, b),
    getData: (0, $3Zhqx.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $ca62b878c99c7128$export$31b430e01a1caab5 = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$39804ce8cc42cd04);
const $ca62b878c99c7128$export$4e0719e53da01e93 = (0, $2M1hQ.createResource)({
    type: (0, $e03099b7bef7f4cd$export$bce41807cc929d0f),
    getKey: $abozY.getKey,
    getData: async (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        const modules = await (0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.DASHBOARD_GADGET_MODULE),
                (0, $k2DRb.DASHBOARD_BACKGROUND_SCRIPT_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_ROUTER)
        });
        return {
            gadgets: modules[0, $k2DRb.DASHBOARD_GADGET_MODULE],
            backgroundScripts: modules[0, $k2DRb.DASHBOARD_BACKGROUND_SCRIPT_MODULE]
        };
    },
    maxAge: Infinity
});
const $ca62b878c99c7128$export$36c9632be21fbb06 = (0, $2M1hQ.createResource)({
    type: (0, $e03099b7bef7f4cd$export$c07a25ebb6af1e84),
    getKey: ()=>'gadgetDirectoryItems',
    getData: (0, $aVFmC.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $ca62b878c99c7128$export$27f4c12e781b4572 = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$36c9632be21fbb06);
const $ca62b878c99c7128$export$75ca1b431898fd09 = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$4e0719e53da01e93);

});
parcelRegister("3Yd87", function(module, exports) {

$parcel$export(module.exports, "withEitherDataOrError", () => $3e606a4e02c14aae$export$54e973088fdd59a1);
$parcel$export(module.exports, "createDependentResource", () => $3e606a4e02c14aae$export$7f8dd41bdfd85a47);
$parcel$export(module.exports, "SharedValueAggregateError", () => $3e606a4e02c14aae$export$36d5102d613df7c6);

var $2M1hQ = parcelRequire("2M1hQ");
var $htn2f = parcelRequire("htn2f");
const $3e606a4e02c14aae$export$54e973088fdd59a1 = (dataFn, errorFn)=>(...args)=>{
        const invalidArgs = args.filter((v)=>v == null || v instanceof Error);
        return invalidArgs.length ? errorFn(invalidArgs[0]) : dataFn(...args);
    };
const $3e606a4e02c14aae$export$fcdc85dfc621ec7a = (dependencies, type)=>{
    // the standard in react-resource-router is to fail getData() for dependency errors
    const { [type]: resourceSlice } = dependencies;
    if (!resourceSlice) throw new (0, $htn2f.ResourceDependencyError)(`Cannot decode dependency "${type}", it may be missing from resource depends field`);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return resourceSlice.data;
};
const $3e606a4e02c14aae$export$bee6a631bfb54474 = (dependencies, type)=>{
    // the standard in react-resource-router is to fail getData() for dependency errors
    const { [type]: resourceSlice } = dependencies;
    if (!resourceSlice) throw new Error(`Cannot decode dependency: "${type}" must be included in the resource depends field`);
    // prefer previous value rather than error
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { loading: loading, data: data, promise: promise, error: error } = resourceSlice;
    return loading && promise ? promise.then((v)=>v, (e)=>data ?? e) : data ?? error;
};
const $3e606a4e02c14aae$export$7f8dd41bdfd85a47 = ({ type: type, depends: depends, mapToSharedValue: mapToSharedValue, shouldUpdate: shouldUpdate, getData: getData, ...rest })=>(0, $2M1hQ.createResource)({
        ...rest,
        type: type,
        depends: [
            ...depends,
            type
        ],
        getData: (dataContext, storeContext)=>{
            const { dependencies: dependencies } = dataContext;
            const prevValue = $3e606a4e02c14aae$export$fcdc85dfc621ec7a(dependencies, type);
            const valuesOrPromises = depends.map((d)=>$3e606a4e02c14aae$export$bee6a631bfb54474(dependencies, d));
            const implementation = (depDataOrErrorOrNull)=>{
                const newShared = mapToSharedValue(...depDataOrErrorOrNull);
                return prevValue == null || prevValue instanceof Error || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                shouldUpdate(prevValue, newShared) ? getData(prevValue, newShared)(dataContext, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                storeContext) : prevValue;
            };
            return valuesOrPromises.some((v)=>v instanceof Promise) ? Promise.allSettled(valuesOrPromises).then((arr)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                arr.map((v)=>v.status === 'fulfilled' ? v.value : v.reason)).then(implementation) : implementation(valuesOrPromises);
        }
    });
class $3e606a4e02c14aae$export$36d5102d613df7c6 extends Error {
    constructor({ name: name, isPrefetch: isPrefetch, sharedValue: sharedValue }){
        super(`${name} is missing dependency, prefetch [${isPrefetch}] sharedValue [${sharedValue}]`);
        this.skipSentry = true;
    }
}

});

parcelRegister("abozY", function(module, exports) {

$parcel$export(module.exports, "getKey", () => $707c98c2b1b4b40d$export$a47fb462a08de82f);
// eslint-disable-next-line jira/import-whitelist

var $JIPqS = parcelRequire("JIPqS");
const $707c98c2b1b4b40d$export$a47fb462a08de82f = ({ route: route, query: query, match: { params: params } })=>{
    if (route.name === 'system-dashboard-edit') return 0, $JIPqS.SYSTEM_DASHBOARD_ID;
    if (route.name === 'dashboard-wallboard') // NOTE - Currently we will only load the first dashboard in the list
    return query.dashboardId?.split(',')[0];
    return params.dashboardId?.replace('last-visited', 'lastVisited') ?? query.selectPageId ?? 'lastVisited';
};

});
parcelRegister("JIPqS", function(module, exports) {

$parcel$export(module.exports, "GADGET_DISPLAY", () => $6c7fd970bbaee123$export$d7e1dfcefcde2410);
$parcel$export(module.exports, "MAXIMIZED_PARAM", () => $6c7fd970bbaee123$export$86eaa19ea940a4f5);
$parcel$export(module.exports, "CONNECT_ITEM_AMD_MODULE", () => $6c7fd970bbaee123$export$a1baea8b97610fd);
$parcel$export(module.exports, "WEB_RESOURCE_MAP", () => $6c7fd970bbaee123$export$c6d360a8456d120a);
$parcel$export(module.exports, "PRELOADED_GADGET_DATA_KEY", () => $6c7fd970bbaee123$export$30b970d16c2f5e0a);
$parcel$export(module.exports, "SYSTEM_DASHBOARD_ID", () => $6c7fd970bbaee123$export$50eac80bcbebc737);
$parcel$export(module.exports, "DASHBOARD_HEADER_HEIGHT", () => $6c7fd970bbaee123$export$e11ffd0409aa6522);
$parcel$export(module.exports, "FOOTER_MARGIN", () => $6c7fd970bbaee123$export$4d708f4c16ae3a73);
$parcel$export(module.exports, "GADGET_LOCAL_STORAGE_NAME", () => $6c7fd970bbaee123$export$255117c9adec50a5);
$parcel$export(module.exports, "DASHBOARD_LOCAL_STORAGE_KEY_NAME", () => $6c7fd970bbaee123$export$e281465c09f561d4);
$parcel$export(module.exports, "GADGET_DEFAULT_HEIGHT", () => $6c7fd970bbaee123$export$46dd0168a7875b47);
$parcel$export(module.exports, "COLOR_MAP", () => $6c7fd970bbaee123$export$1468aefba37090f9);
$parcel$export(module.exports, "COLOR_NAME_MAP", () => $6c7fd970bbaee123$export$5d9e688e192a63ae);
$parcel$export(module.exports, "COLOR_CHECKMARK_MAP", () => $6c7fd970bbaee123$export$6906a4beef307ac4);
$parcel$export(module.exports, "MODAL_ID", () => $6c7fd970bbaee123$export$ebdd5a8e5b1c2de5);
$parcel$export(module.exports, "LAYOUTS", () => $6c7fd970bbaee123$export$87e50aced9c52ebb);
$parcel$export(module.exports, "GADGET_HEIGHT_UPDATE_WAIT_TIME", () => $6c7fd970bbaee123$export$b0234a47b1a4a515);
$parcel$export(module.exports, "GADGET_DRAG_CONTAINER_HEIGHT", () => $6c7fd970bbaee123$export$9674cd14c20d1c89);
$parcel$export(module.exports, "GADGET_METRICS_TYPE", () => $6c7fd970bbaee123$export$46b6c8eb53069613);
$parcel$export(module.exports, "PAGE_READY_METRIC_KEY", () => $6c7fd970bbaee123$export$464d2a6bcb398791);
$parcel$export(module.exports, "DELETE_DASHBOARD_EXPERIENCE", () => $6c7fd970bbaee123$export$4f74f1f13671c49d);
$parcel$export(module.exports, "COPY_DASHBOARD_EXPERIENCE", () => $6c7fd970bbaee123$export$3853fce65645c557);
$parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE", () => $6c7fd970bbaee123$export$c8c77659771c38b9);
$parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD_EXPERIENCE", () => $6c7fd970bbaee123$export$707702c47e5b9648);
$parcel$export(module.exports, "CREATE_DASHBOARD_EXPERIENCE", () => $6c7fd970bbaee123$export$efbab4efa7252143);
$parcel$export(module.exports, "VIEW_DASHBOARD_EDITABLE_EXPERIENCE", () => $6c7fd970bbaee123$export$7b6f3ec1189de156);
$parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EXPERIENCE", () => $6c7fd970bbaee123$export$f0e105144716a420);
$parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EMBED_EXPERIENCE", () => $6c7fd970bbaee123$export$5ba84cd082269cd5);
$parcel$export(module.exports, "VIEW_DASHBOARD_WALLBOARD_READONLY_EXPERIENCE", () => $6c7fd970bbaee123$export$6c84c6099fed3c23);
$parcel$export(module.exports, "ADD_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$3b17b4f7f722b1ae);
$parcel$export(module.exports, "SAVE_AMD_GADGET_CONFIG_PREFERENCES", () => $6c7fd970bbaee123$export$c8900d7e874d42ca);
$parcel$export(module.exports, "SAVE_FORGE_GADGET_CONFIG_PREFERENCES", () => $6c7fd970bbaee123$export$bac5a3e9d008da59);
$parcel$export(module.exports, "SAVE_CUSTOM_GADGET_TITLE_PREFERENCES", () => $6c7fd970bbaee123$export$18b54b2c53cf6acd);
$parcel$export(module.exports, "VIEW_WRM_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$a3d5b76ea0c8f4ca);
$parcel$export(module.exports, "CHANGE_LAYOUT_EXPERIENCE", () => $6c7fd970bbaee123$export$7254246f25b4cbc8);
$parcel$export(module.exports, "DELETE_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$40c4d345e57fce2d);
$parcel$export(module.exports, "VIEW_REACT_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$43fb10a4d8374f1a);
$parcel$export(module.exports, "DASHBOARD_VIEW_SOURCENAME", () => $6c7fd970bbaee123$export$2f961c74af6d8735);
$parcel$export(module.exports, "DASHBOARD_VIEW_EMBED_SOURCENAME", () => $6c7fd970bbaee123$export$dab1096b356df1cc);
$parcel$export(module.exports, "DASHBOARD_EDIT_SOURCENAME", () => $6c7fd970bbaee123$export$32f0edca4eebb9c7);
$parcel$export(module.exports, "DASHBOARD_WALLBOARD_VIEW_SOURCENAME", () => $6c7fd970bbaee123$export$791f7067c41dc5b1);
$parcel$export(module.exports, "SYSTEM_DASHBOARD_EDIT_SOURCENAME", () => $6c7fd970bbaee123$export$eba1a497984af3ae);
$parcel$export(module.exports, "COPY_DASHBOARD", () => $6c7fd970bbaee123$export$3578044b625436f9);
$parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH", () => $6c7fd970bbaee123$export$48bb59a846d62ea0);
$parcel$export(module.exports, "DELETE_DASHBOARD", () => $6c7fd970bbaee123$export$e7dfbcf33cf2b19a);
$parcel$export(module.exports, "DUPLICATE_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$fabf79b25b44377f);
$parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD", () => $6c7fd970bbaee123$export$abba919f32a1a776);
$parcel$export(module.exports, "GADGET_ERROR_TYPE", () => $6c7fd970bbaee123$export$768dad6811159849);
$parcel$export(module.exports, "DASHBOARD_REFRESH_LOAD_BUFFER_MS", () => $6c7fd970bbaee123$export$ada294d471e7dfc3);
$parcel$export(module.exports, "REFRESH_LABEL_UPDATE_INTERVAL", () => $6c7fd970bbaee123$export$f4280aaeba4d1d08);
$parcel$export(module.exports, "CONNECT_GADGET_REFRESH_REQUEST_EVENT", () => $6c7fd970bbaee123$export$685171fdf5112bc4);
$parcel$export(module.exports, "FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT", () => $6c7fd970bbaee123$export$4d8c12b9aaeac619);
$parcel$export(module.exports, "ISSUE_SEARCH_DEFAULT_COLUMNS", () => $6c7fd970bbaee123$export$f07dac7b8de3bda);
$parcel$export(module.exports, "DEPRECATED_GADGETS_MAP", () => $6c7fd970bbaee123$export$4ac59ce79d9e7591);
$parcel$export(module.exports, "DEPRECATION_BANNER_V1_DISMISS", () => $6c7fd970bbaee123$export$288d365366bd5af2);


var $gwIPs = parcelRequire("gwIPs");

var $cKw8Y = parcelRequire("cKw8Y");
const $6c7fd970bbaee123$export$d7e1dfcefcde2410 = {
    MAXIMIZED: 'maximized',
    NORMAL: 'normal',
    HIDDEN: 'hidden'
};
const $6c7fd970bbaee123$export$86eaa19ea940a4f5 = 'maximized';
const $6c7fd970bbaee123$export$a1baea8b97610fd = 'atlassian-connect/connect-dashboard-item';
const $6c7fd970bbaee123$export$c6d360a8456d120a = {
    'jira-dashboard-items/assigned-to-me': 'com.atlassian.jira.gadgets:assigned-to-me-dashboard-item-resources',
    'jira-dashboard-items/filter-results': 'com.atlassian.jira.gadgets:filter-results-dashboard-item-resources',
    'jira-dashboard-items/createdvsresolved': 'com.atlassian.jira.gadgets:createdvsresolved-dashboard-item-resources',
    'jira-dashboard-items/favourite-filters': 'com.atlassian.jira.gadgets:favourite-filters-dashboard-item-resources',
    'jira-dashboard-items/in-progress': 'com.atlassian.jira.gadgets:in-progress-dashboard-item-resources',
    'jira-dashboard-items/stats': 'com.atlassian.jira.gadgets:stats-dashboard-item-resources',
    'jira-dashboard-items/watched': 'com.atlassian.jira.gadgets:watched-dashboard-item-resources',
    'jira-dashboard-items/labels': 'com.atlassian.jira.gadgets:labels-dashboard-item-resources',
    'jira-dashboard-items/bubble-chart-dashboard-item': 'com.atlassian.jira.gadgets:bubble-chart-dashboard-item-resources',
    'jira-dashboard-items/piechart': 'com.atlassian.jira.gadgets:piechart-dashboard-item-resources',
    'jira-dashboard-items/voted': 'com.atlassian.jira.gadgets:voted-dashboard-item-resources',
    'jira-dashboard-items/two-dimensional-stats': 'com.atlassian.jira.gadgets:two-dimensional-stats-dashboard-item-resources',
    'jira-dashboard-items/sprint-health': 'com.pyxis.greenhopper.jira:greenhopper-sprint-health-dashboard-item-resources',
    'jira-dashboard-items/sprint-days-remaining': 'com.pyxis.greenhopper.jira:greenhopper-days-remaining-dashboard-item-resources',
    'servicedesk/internal/dashboard-items/filter/filter-dashboard-item': 'com.atlassian.servicedesk.dashboard-items-plugin:spa-filter-dashboard-item-resources',
    'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'com.atlassian.servicedesk.servicedesk-reports-plugin:custom-report-dashboard-item-resources-spa',
    'jira-dashboard-items/projects': 'com.atlassian.jira.gadgets:projects-dashboard-item-resources',
    'jira-dashboard-items/issuescalendar': 'com.atlassian.jira.ext.calendar:issues-calendar-dashboard-item-resources',
    'jira-dashboard-items/activitystream': 'com.atlassian.streams.streams-jira-plugin:activitystream-dashboard-item-resources',
    'jira-dashboard-items/recently-created': 'com.atlassian.jira.gadgets:recently-created-chart-dashboard-item-resources',
    'jira-dashboard-items/resolution-time': 'com.atlassian.jira.gadgets:resolution-time-dashboard-item-resources',
    'jira-dashboard-items/timesince': 'com.atlassian.jira.gadgets:timesince-dashboard-item-resources',
    'jira-dashboard-items/spacer': 'com.atlassian.jira.gadgets:spacer-dashboard-item-resources',
    'jira-dashboard-items/sprint-burndown': 'com.pyxis.greenhopper.jira:greenhopper-sprint-burndown-dashboard-item-resources',
    'jira-dashboard-items/workload-pie-chart': 'com.atlassian.jira.gadgets:workload-pie-chart-dashboard-item-resources',
    'jira-dashboard-items/roadmap': 'com.atlassian.jira.gadgets:roadmap-dashboard-item-resources',
    'jira-dashboard-items/average-age-chart': 'com.atlassian.jira.gadgets:average-age-chart-dashboard-item-resources',
    'jira-dashboard-items/average-time-in-status-chart': 'com.atlassian.jira.gadgets:average-time-in-status-chart-dashboard-item-resources',
    'jira-dashboard-items/average-number-of-times-in-status-chart': 'com.atlassian.jira.gadgets:average-number-of-times-in-status-chart-dashboard-item-resources',
    'jira-dashboard-items/heat-map': 'com.atlassian.jira.gadgets:heat-map-dashboard-item-resources',
    'jira-dashboard-items/time-to-first-response': 'com.atlassian.jira.gadgets:time-to-first-response-dashboard-item-resources',
    'jira-dashboard-items/rapid-view': 'com.pyxis.greenhopper.jira:greenhopper-rapid-view-dashboard-item-resources',
    'jira-dashboard-items/version-report': 'com.pyxis.greenhopper.jira:greenhopper-version-report-dashboard-item-resources'
};
const $6c7fd970bbaee123$export$30b970d16c2f5e0a = 'DASHBOARD_GADGET_PRELOADED_DATA';
const $6c7fd970bbaee123$export$50eac80bcbebc737 = '10000';
const $6c7fd970bbaee123$export$e11ffd0409aa6522 = (0, $gwIPs.gridSize) * 10;
const $6c7fd970bbaee123$export$4d708f4c16ae3a73 = (0, $gwIPs.gridSize) * 2;
const $6c7fd970bbaee123$export$255117c9adec50a5 = 'AG.congolmerate.cookie';
const $6c7fd970bbaee123$export$e281465c09f561d4 = 'dashboard-data';
const $6c7fd970bbaee123$export$46dd0168a7875b47 = 160;
const $6c7fd970bbaee123$var$COLOR_BLUE = '#2684ff';
const $6c7fd970bbaee123$var$COLOR_RED = '#ff5630';
const $6c7fd970bbaee123$var$COLOR_YELLOW = '#ffab00';
const $6c7fd970bbaee123$var$COLOR_GREEN = '#36b37e';
const $6c7fd970bbaee123$var$COLOR_TEAL = '#00b8d9';
const $6c7fd970bbaee123$var$COLOR_PURPLE = '#6554c0';
const $6c7fd970bbaee123$var$COLOR_GRAY = '#97a0af';
const $6c7fd970bbaee123$var$COLOR_WHITE = '#ffffff';
const $6c7fd970bbaee123$export$1468aefba37090f9 = {
    color1: $6c7fd970bbaee123$var$COLOR_BLUE,
    color2: $6c7fd970bbaee123$var$COLOR_RED,
    color3: $6c7fd970bbaee123$var$COLOR_YELLOW,
    color4: $6c7fd970bbaee123$var$COLOR_GREEN,
    color5: $6c7fd970bbaee123$var$COLOR_TEAL,
    color6: $6c7fd970bbaee123$var$COLOR_PURPLE,
    color7: $6c7fd970bbaee123$var$COLOR_GRAY,
    color8: $6c7fd970bbaee123$var$COLOR_WHITE
};
const $6c7fd970bbaee123$export$5d9e688e192a63ae = {
    [$6c7fd970bbaee123$var$COLOR_BLUE]: (0, $cKw8Y.default).blue,
    [$6c7fd970bbaee123$var$COLOR_RED]: (0, $cKw8Y.default).red,
    [$6c7fd970bbaee123$var$COLOR_YELLOW]: (0, $cKw8Y.default).yellow,
    [$6c7fd970bbaee123$var$COLOR_GREEN]: (0, $cKw8Y.default).green,
    [$6c7fd970bbaee123$var$COLOR_TEAL]: (0, $cKw8Y.default).teal,
    [$6c7fd970bbaee123$var$COLOR_PURPLE]: (0, $cKw8Y.default).purple,
    [$6c7fd970bbaee123$var$COLOR_GRAY]: (0, $cKw8Y.default).gray,
    [$6c7fd970bbaee123$var$COLOR_WHITE]: (0, $cKw8Y.default).white
};
const $6c7fd970bbaee123$export$6906a4beef307ac4 = {
    color1: (0, $a7f8c6b391092279$exports).N10,
    color2: (0, $a7f8c6b391092279$exports).N10,
    color3: (0, $a7f8c6b391092279$exports).N500,
    color4: (0, $a7f8c6b391092279$exports).N10,
    color5: (0, $a7f8c6b391092279$exports).N500,
    color6: (0, $a7f8c6b391092279$exports).N10,
    color7: (0, $a7f8c6b391092279$exports).N10,
    color8: (0, $a7f8c6b391092279$exports).N500
};
const $6c7fd970bbaee123$export$ebdd5a8e5b1c2de5 = {
    EDIT_LAYOUT: 'edit-layout',
    DASHBOARD_COPY: 'dashboard-copy',
    AUTOMATIC_REFRESH: 'dashboard-automatic-refresh',
    DASHBOARD_RENAME_OR_SHARE: 'dashboard-rename-or-share',
    DASHBOARD_DELETE: 'dashboard-delete',
    CONFIGURE_WALLBOARD: 'configure-wallboard',
    DASHBOARD_CREATE: 'dashboard-create-on-dashboard-page'
};
const $6c7fd970bbaee123$export$87e50aced9c52ebb = [
    'A',
    'AA',
    'AAA',
    'BA',
    'AB'
];
const $6c7fd970bbaee123$export$b0234a47b1a4a515 = 350;
const $6c7fd970bbaee123$export$9674cd14c20d1c89 = 250;
const $6c7fd970bbaee123$export$46b6c8eb53069613 = {
    REPORT: 'REPORT_GADGET_METRICS',
    TIMEOUT: 'TIMEOUT_GADGET_METRICS'
};
const $6c7fd970bbaee123$export$464d2a6bcb398791 = 'JIRA_SPA_PAGE_READY';
const $6c7fd970bbaee123$export$4f74f1f13671c49d = 'delete-dashboard';
const $6c7fd970bbaee123$export$3853fce65645c557 = 'copy-dashboard';
const $6c7fd970bbaee123$export$c8c77659771c38b9 = 'dashboard-automatic-refresh';
const $6c7fd970bbaee123$export$707702c47e5b9648 = 'rename-or-share-dashboard';
const $6c7fd970bbaee123$export$efbab4efa7252143 = 'create-dashboard';
const $6c7fd970bbaee123$export$7b6f3ec1189de156 = 'view-dashboard-editable';
const $6c7fd970bbaee123$export$f0e105144716a420 = 'view-dashboard-readonly';
const $6c7fd970bbaee123$export$5ba84cd082269cd5 = 'view-dashboard-readonly-embed';
const $6c7fd970bbaee123$export$6c84c6099fed3c23 = 'view-dashboard-wallboard-readonly';
const $6c7fd970bbaee123$export$3b17b4f7f722b1ae = 'add-gadget';
const $6c7fd970bbaee123$export$c8900d7e874d42ca = 'save-amd-gadget-config';
const $6c7fd970bbaee123$export$bac5a3e9d008da59 = 'save-forge-gadget-config';
const $6c7fd970bbaee123$export$18b54b2c53cf6acd = 'save-custom-gadget-title-config';
const $6c7fd970bbaee123$export$a3d5b76ea0c8f4ca = 'view-wrm-gadget';
const $6c7fd970bbaee123$export$7254246f25b4cbc8 = 'change-layout';
const $6c7fd970bbaee123$export$40c4d345e57fce2d = 'delete-gadget';
const $6c7fd970bbaee123$export$43fb10a4d8374f1a = 'view-react-gadget';
const $6c7fd970bbaee123$export$2f961c74af6d8735 = 'dashboardView';
const $6c7fd970bbaee123$export$dab1096b356df1cc = 'dashboardViewEmbed';
const $6c7fd970bbaee123$export$32f0edca4eebb9c7 = 'dashboardEdit';
const $6c7fd970bbaee123$export$791f7067c41dc5b1 = 'dashboardWallboardView';
const $6c7fd970bbaee123$export$eba1a497984af3ae = 'systemDashboardEdit';
const $6c7fd970bbaee123$export$3578044b625436f9 = 'copyDashboard';
const $6c7fd970bbaee123$export$48bb59a846d62ea0 = 'automaticRefresh';
const $6c7fd970bbaee123$export$e7dfbcf33cf2b19a = 'deleteDashboard';
const $6c7fd970bbaee123$export$fabf79b25b44377f = 'duplicateGadget';
const $6c7fd970bbaee123$export$abba919f32a1a776 = 'renameOrShareDashboard';
const $6c7fd970bbaee123$export$768dad6811159849 = {
    VIEW_ERROR: 'viewError',
    EDIT_ERROR: 'editError',
    CONFIG_ERROR: 'configError',
    NOT_SUPPORTED_ERROR: 'notSupportedError'
};
const $6c7fd970bbaee123$export$ada294d471e7dfc3 = 1000;
const $6c7fd970bbaee123$export$f4280aaeba4d1d08 = 30000;
const $6c7fd970bbaee123$export$685171fdf5112bc4 = 'jira_dashboard_item_refresh';
const $6c7fd970bbaee123$export$4d8c12b9aaeac619 = 'JIRA_DASHBOARD_GADGET_REFRESH';
const $6c7fd970bbaee123$export$f07dac7b8de3bda = [
    'issuetype',
    'issuekey',
    'summary',
    'priority'
];
const $6c7fd970bbaee123$export$4ac59ce79d9e7591 = {
    'jira-dashboard-items/bubble-chart-dashboard-item': 'com.atlassian.jira.gadgets:bubble-chart-dashboard-item',
    'jira-dashboard-items/heat-map': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:heat-map-gadget/gadgets/heatmap-gadget.xml',
    'jira-dashboard-items/projects': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:project-gadget/gadgets/project-gadget.xml',
    'jira-dashboard-items/labels': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:labels-gadget/gadgets/labels-gadget.xml',
    'jira-dashboard-items/roadmap': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:road-map-gadget/gadgets/roadmap-gadget.xml'
};
const $6c7fd970bbaee123$export$288d365366bd5af2 = 'deprecatedGadgetBannerDismissedV1';
const $6c7fd970bbaee123$export$d63651276dbece56 = {
    'jira-dashboard-items/activitystream': 'rest/gadgets/1.0/g/com.atlassian.streams.streams-jira-plugin:activitystream-gadget/gadgets/activitystream-gadget.xml'
};

});
parcelRegister("cKw8Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $81c05dd6e2dcad70$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $81c05dd6e2dcad70$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    blue: {
        "id": "dashboard-common.blue",
        "defaultMessage": "Blue"
    },
    red: {
        "id": "dashboard-common.red",
        "defaultMessage": "Red"
    },
    yellow: {
        "id": "dashboard-common.yellow",
        "defaultMessage": "Yellow"
    },
    green: {
        "id": "dashboard-common.green",
        "defaultMessage": "Green"
    },
    teal: {
        "id": "dashboard-common.teal",
        "defaultMessage": "Teal"
    },
    purple: {
        "id": "dashboard-common.purple",
        "defaultMessage": "Purple"
    },
    gray: {
        "id": "dashboard-common.gray",
        "defaultMessage": "Gray"
    },
    white: {
        "id": "dashboard-common.white",
        "defaultMessage": "White"
    }
});

});



const $e03099b7bef7f4cd$export$ca03ff6cc792cc16 = 'DASHBOARD_CONFIG_AND_WRM';
const $e03099b7bef7f4cd$export$e239393fd4e2bc85 = 'DASHBOARD_AMD_MODULES';
const $e03099b7bef7f4cd$export$9e5db01432b13b67 = 'DASHBOARD_REACT_GADGETS';
const $e03099b7bef7f4cd$export$bce41807cc929d0f = 'DASHBOARD_FORGE';
const $e03099b7bef7f4cd$export$c07a25ebb6af1e84 = 'DASHBOARD_GADGET_DIRECTORY';

parcelRegister("04Brv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff7f8eda58c85578$export$2e2bcd8739ae039);

var $4su49 = parcelRequire("4su49");

var $3Yd87 = parcelRequire("3Yd87");

var $1IY2I = parcelRequire("1IY2I");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ff7f8eda58c85578$export$2e2bcd8739ae039 = (_maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch })=>{
        if (!sharedValue || sharedValue instanceof Error) throw new (0, $3Yd87.SharedValueAggregateError)({
            sharedValue: sharedValue,
            isPrefetch: isPrefetch,
            name: 'AMD modules resource'
        });
        return (async ()=>{
            const { moduleNames: moduleNames, isPreloaded: isPreloaded } = sharedValue;
            const maybePromiseAmdModules = isPreloaded || await (0, $1IY2I.loadAmdModules)((0, $4su49.asyncWrmRequire), moduleNames) ? (0, $1IY2I.evalAmdModules)(moduleNames) : null;
            const amdModules = maybePromiseAmdModules instanceof Promise ? await maybePromiseAmdModules : maybePromiseAmdModules;
            return {
                sharedValue: sharedValue,
                amdModules: amdModules
            };
        })();
    };

});
parcelRegister("4su49", function(module, exports) {

$parcel$export(module.exports, "asyncWrmRequire", () => $ae90ef6541667ecb$export$1024fe099ca05f05);
$parcel$export(module.exports, "asyncWrmRequireWithPrefetch", () => $ae90ef6541667ecb$export$3ca0de203efa570e);
/* eslint-disable jira/wrm/no-load-bridge */ 
var $8JNtu = parcelRequire("8JNtu");
var $5Ik5Y = parcelRequire("5Ik5Y");
const $ae90ef6541667ecb$export$1024fe099ca05f05 = (resourcesToRequire)=>(0, $8JNtu.wrmRequire)(resourcesToRequire);
const $ae90ef6541667ecb$export$3ca0de203efa570e = (resourcesToRequire, batchUrl)=>(0, $5Ik5Y.wrmRequireWithPrefetch)(resourcesToRequire, batchUrl);

});

parcelRegister("1IY2I", function(module, exports) {

$parcel$export(module.exports, "loadAmdModules", () => $d6efeb87a1192ef7$export$2c79895bd69a8d54);
$parcel$export(module.exports, "evalAmdModules", () => $d6efeb87a1192ef7$export$d74eab33af9baaea);

var $dJl1T = parcelRequire("dJl1T");

var $JIPqS = parcelRequire("JIPqS");
/**
 * Dummy implementation for a Connect gadget, as rendering and editing are
 * managed externally.
 */ class $d6efeb87a1192ef7$var$ConnectDashboardItem {
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    render() {}
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    renderEdit() {}
}
const $d6efeb87a1192ef7$export$3bf37adbbdcafcc8 = (moduleName, retries = 5)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (typeof window.require !== 'function') throw new TypeError('window.require is not a function');
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return window.require(moduleName);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // amd module could throw a non-Error
        if (error instanceof Error && /^No \S+$|^\S+ missing \S+$/.test(error.message)) {
            // some AMD modules have define() inside a require() block in which case the module is not immediately ready to be window.require()'d
            // this is due to the 4ms timeout in requirejs' require(), we need a retry logic here to make sure the module is loaded.
            // see the comment section for https://jdog.jira-dev.com/browse/WRM-71
            if (retries > 0) return new Promise((r)=>setTimeout(r, 100)).then(()=>$d6efeb87a1192ef7$export$3bf37adbbdcafcc8(moduleName, retries - 1));
        }
        throw error;
    }
};
const $d6efeb87a1192ef7$export$2c79895bd69a8d54 = async (wrmRequire, moduleNames)=>{
    if (moduleNames.length === 0) return false;
    const prefixedAmdResources = moduleNames.map((amdModule)=>(0, $JIPqS.WEB_RESOURCE_MAP)[amdModule]).map((resourceName)=>`wrc!${resourceName}`);
    try {
        // no result from the promise only the side effect of having loaded the AMD module via WRM
        await wrmRequire(prefixedAmdResources);
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.resource', `Failed to load web resources [${prefixedAmdResources.join(',')}]`, error);
        return false;
    }
};
const $d6efeb87a1192ef7$var$getSortedModuleNamesFromTuples = (tuples)=>tuples.map(([moduleName])=>moduleName).sort((a, b)=>a.localeCompare(b)).join(',');
const $d6efeb87a1192ef7$export$d74eab33af9baaea = (amdModuleNames)=>{
    const tuplesOrPromises = amdModuleNames.map((amdModuleName)=>{
        try {
            const module = amdModuleName === (0, $JIPqS.CONNECT_ITEM_AMD_MODULE) ? $d6efeb87a1192ef7$var$ConnectDashboardItem : $d6efeb87a1192ef7$export$3bf37adbbdcafcc8(amdModuleName);
            return module instanceof Promise ? module.then((v)=>[
                    amdModuleName,
                    v
                ]) : [
                amdModuleName,
                module
            ];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return Promise.reject(error);
        }
    });
    const hasPromise = tuplesOrPromises.some((entry)=>entry instanceof Promise);
    if (!hasPromise) {
        (0, $dJl1T.default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful synchronous bulk eval AMD modules');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Object.fromEntries(tuplesOrPromises);
    }
    return Promise.allSettled(tuplesOrPromises).then((results)=>{
        const tuples = results.map((result, i)=>{
            if (result.status === 'fulfilled') return result.value;
            const { reason: error } = result;
            const amdModuleName = amdModuleNames[i];
            const message = error instanceof Error ? error.message : String(error);
            (0, $dJl1T.default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD module [${amdModuleName}] with error [${message}]`, error);
            return [
                amdModuleName,
                null
            ];
        });
        const failedTuples = tuples.filter((module)=>module[1] === null);
        failedTuples.length > 0 ? (0, $dJl1T.default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD modules [${$d6efeb87a1192ef7$var$getSortedModuleNamesFromTuples(failedTuples)}]`) : (0, $dJl1T.default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful asynchronous bulk eval AMD modules');
        return Object.fromEntries(tuples);
    });
};

});


parcelRegister("3cb5I", function(module, exports) {

$parcel$export(module.exports, "default", () => $f465c16c9ac91f45$export$2e2bcd8739ae039);

var $7RGnr = parcelRequire("7RGnr");

var $2j5ho = parcelRequire("2j5ho");

var $1LNzH = parcelRequire("1LNzH");

var $hoLk6 = parcelRequire("hoLk6");

var $6T8HZ = parcelRequire("6T8HZ");

var $abozY = parcelRequire("abozY");

var $8oOn8 = parcelRequire("8oOn8");
const $f465c16c9ac91f45$var$generateScriptTagAndPreloadedModuleNames = async (configs)=>{
    const gadgets = configs.flatMap((config)=>config.gadgets);
    const preloadedModuleNames = (0, $8oOn8.gadgetsToUniqueSortedAmdModules)(gadgets);
    const wrmBundleDescriptor = await (0, $1LNzH.default)(preloadedModuleNames);
    return configs.map((config)=>{
        const scriptTags = [
            wrmBundleDescriptor ? (0, $6T8HZ.default)(wrmBundleDescriptor) : null,
            (0, $hoLk6.default)(config)
        ].filter(Boolean).join('\n') || null;
        return {
            ...config,
            scriptTags: scriptTags,
            preloadedModuleNames: preloadedModuleNames
        };
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f465c16c9ac91f45$export$2e2bcd8739ae039 = async (context)=>{
    // this is either for single dashboard/wallboard or wallboard slide show with multiple dashboards
    const { route: route, query: query } = context;
    const originalConfigs = route.name === 'dashboard-wallboard' ? await (0, $2j5ho.getDashboardsConfig)(query.dashboardId) : [
        await (0, $2j5ho.default)((0, $abozY.getKey)(context))
    ];
    const configs = originalConfigs.map((config)=>({
            ...config,
            gadgets: (0, $7RGnr.mapToReactGadgets)(config.gadgets)
        }));
    if (!false) return configs.map((config)=>({
            ...config,
            preloadedModuleNames: []
        }));
    return $f465c16c9ac91f45$var$generateScriptTagAndPreloadedModuleNames(configs);
};

});
parcelRegister("7RGnr", function(module, exports) {

$parcel$export(module.exports, "mapToReactGadgets", () => $119a071fe5fec8f8$export$c90615c5eb218d50);

var $4R6GH = parcelRequire("4R6GH");
const $119a071fe5fec8f8$export$c90615c5eb218d50 = (gadgets)=>{
    const gadgetMapping = {
        ...(0, $4R6GH.fg)('endeavour_nin_filter_results_gadget') ? {
            'jira-dashboard-items/filter-results': 'react/filter-results'
        } : {},
        'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'react/custom-report',
        ...(0, $4R6GH.fg)('endeavour_nin_assigned_to_me_gadget') ? {
            'jira-dashboard-items/assigned-to-me': 'react/assigned-to-me'
        } : {},
        ...(0, $4R6GH.fg)('endeavour_nin_issues_in_progress_gadget') ? {
            'jira-dashboard-items/in-progress': 'react/issues-in-progress'
        } : {},
        ...(0, $4R6GH.fg)('endeavour_nin_voted_issues_gadget') ? {
            'jira-dashboard-items/voted': 'react/voted-issues'
        } : {},
        ...(0, $4R6GH.fg)('endeavour_nin_watched_issues_gadget') ? {
            'jira-dashboard-items/watched': 'react/watched-issues'
        } : {}
    }; // satisfies Record<string, ReactKey>; SSR image build Thread Loader doesn't understand 'satisfies'
    const isMapped = (module)=>module !== undefined && module in gadgetMapping;
    return gadgets.map((gadget)=>{
        if (isMapped(gadget.amdModule)) return {
            ...gadget,
            reactKey: gadgetMapping[gadget.amdModule],
            amdModule: undefined,
            configurable: false,
            inlineHtml: undefined
        };
        return gadget;
    });
};

});

parcelRegister("2j5ho", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ef874ace7c3cd69$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getDashboardsConfig", () => $3ef874ace7c3cd69$export$1264b6af3adf5084);

var $7f4tk = parcelRequire("7f4tk");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3ef874ace7c3cd69$export$2e2bcd8739ae039 = (id)=>(0, $7f4tk.default)(`/rest/dashboards/1.0/${id}.json`);
const $3ef874ace7c3cd69$export$1264b6af3adf5084 = (idsCsv)=>(0, $7f4tk.default)(`/rest/dashboards/1.0?dashboardId=${idsCsv}`);

});

parcelRegister("1LNzH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e5794ac0c0d1780$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $JIPqS = parcelRequire("JIPqS");

var $7f4tk = parcelRequire("7f4tk");
const $1e5794ac0c0d1780$var$CRITICAL_DEPENDENCIES = [
    'jira.webresources:util',
    'jira.webresources:feature-flags',
    'com.atlassian.jira.jira-atlaskit-plugin:overrides-general'
];
const $1e5794ac0c0d1780$var$JIRA_HERITAGE_CRITICAL_BATCH = 'jira.heritage.critical';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1e5794ac0c0d1780$export$2e2bcd8739ae039 = async (moduleNames)=>{
    if (moduleNames.length === 0) return Promise.resolve(null);
    const contextsToRequire = moduleNames.map((amdModule)=>(0, $JIPqS.WEB_RESOURCE_MAP)[amdModule]);
    const payload = {
        r: [],
        c: [
            ...$1e5794ac0c0d1780$var$CRITICAL_DEPENDENCIES,
            ...contextsToRequire
        ],
        xc: [
            $1e5794ac0c0d1780$var$JIRA_HERITAGE_CRITICAL_BATCH
        ],
        xr: []
    };
    return (0, $7f4tk.default)('/rest/webResources/1.0/resources?operation=FetchWRMData', {
        method: 'POST',
        body: JSON.stringify(payload)
    });
};

});

parcelRegister("hoLk6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9b2d88076d11343$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $JIPqS = parcelRequire("JIPqS");

var $83oax = parcelRequire("83oax");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d9b2d88076d11343$export$2e2bcd8739ae039 = (dashboardConfig)=>{
    if (dashboardConfig.gadgets.length === 0) return null;
    const prefetches = (0, $83oax.getPrefetches)(dashboardConfig);
    const preloadLinks = prefetches.map((prefetch)=>`<link rel="preload" as="fetch" href="${prefetch.url}" crossorigin="anonymous" />`).join('\n') || null;
    const syncPrefetchUrls = prefetches.filter((prefetch)=>prefetch.isSyncLoadingSupported()).map((prefetch)=>prefetch.url);
    if (preloadLinks != null && syncPrefetchUrls.length > 0) {
        const fetchScript = `
            <script type="text/javascript" data-defer-skip>
                const preloadUrls = ${JSON.stringify(syncPrefetchUrls)};
                window['${(0, $JIPqS.PRELOADED_GADGET_DATA_KEY)}'] = {};

                preloadUrls.forEach((preloadUrl) => {
                    fetch(preloadUrl)
                        .then(res => res.json())
                        .then(data => {
                            window['${(0, $JIPqS.PRELOADED_GADGET_DATA_KEY)}'][preloadUrl] = data;
                        });
                });
            </script>
        `;
        return preloadLinks + fetchScript;
    }
    return preloadLinks;
};

});
parcelRegister("83oax", function(module, exports) {

$parcel$export(module.exports, "getPrefetches", () => $6e3ee08c53b7707c$export$3144db3718ad5e57);

var $bT0sh = parcelRequire("bT0sh");
const $6e3ee08c53b7707c$export$3144db3718ad5e57 = ({ gadgets: gadgets })=>{
    const lookup = (0, $bT0sh.getPrefetchDict)();
    return gadgets.flatMap((gadget)=>{
        const identifier = gadget.amdModule;
        const prefechProp = identifier != null ? lookup[identifier] : undefined;
        if (!prefechProp || !prefechProp.enabled) return [];
        const { func: func, priority: priority, isSyncLoadingSupported: isSyncLoadingSupported } = prefechProp;
        return func(gadget).map((url)=>({
                url: url,
                priority: priority,
                isSyncLoadingSupported: isSyncLoadingSupported
            }));
    });
};

});
parcelRegister("bT0sh", function(module, exports) {

$parcel$export(module.exports, "getPrefetchDict", () => $e3f3a590c57f26d7$export$244cea94cab19e07);

var $4R6GH = parcelRequire("4R6GH");

var $ltNbR = parcelRequire("ltNbR");

var $8lc67 = parcelRequire("8lc67");

var $cdUf4 = parcelRequire("cdUf4");
const $e3f3a590c57f26d7$export$244cea94cab19e07 = ()=>({
        'jira-dashboard-items/activitystream': {
            func: (0, $8lc67.getActivityStreamPrefetchLink),
            priority: (0, $ltNbR.LOADING_PRIORITY).HIGH,
            enabled: true,
            isSyncLoadingSupported: ()=>false
        },
        'jira-dashboard-items/filter-results': {
            func: (0, $cdUf4.getFilterResultsPrefetchLink),
            priority: (0, $ltNbR.LOADING_PRIORITY).LOW,
            enabled: !(0, $4R6GH.fg)('endeavour_nin_filter_results_gadget'),
            isSyncLoadingSupported: ()=>true
        }
    });

});
parcelRegister("ltNbR", function(module, exports) {

$parcel$export(module.exports, "LOADING_PRIORITY", () => $5a106311215627b2$export$cb9b1f2232733c1b);
const $5a106311215627b2$export$cb9b1f2232733c1b = {
    HIGH: 'preload',
    LOW: 'prefetch'
};

});

parcelRegister("8lc67", function(module, exports) {

$parcel$export(module.exports, "getActivityStreamPrefetchLink", () => $cadf517d0dd42b8b$export$360928f5bf059a9e);

var $ebyGx = parcelRequire("ebyGx");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cadf517d0dd42b8b$var$replacer = (match, part1)=>String.fromCharCode(part1);
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#63-81
// @ts-expect-error - TS7006 - Parameter 'operatorLower' implicitly has an 'any' type.
const $cadf517d0dd42b8b$var$getDateValue = (dateValue, operatorLower)=>{
    // make sure we're dealing with a string so we can use indexOf and split without errors
    const dateStr = `${dateValue}`;
    const operator = operatorLower.toUpperCase();
    let dateArr;
    if (dateStr.indexOf(' ') !== -1) dateArr = dateStr.split(' ');
    else if (operator === 'BETWEEN') dateArr = [
        dateValue,
        dateValue
    ];
    else dateArr = [
        dateValue
    ];
    return dateArr.map((date, index)=>{
        // make sure we're adding numbers and not concatenating strings
        const dateInt = parseInt(date, 10);
        if (operator === 'AFTER' || operator === 'BETWEEN' && index === 1) return dateInt + 86400000 - 1; // Add 23 hours, 59 minutes, 59 seconds to get to end of day
        return dateInt;
    }).join(' ');
};
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#20
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cadf517d0dd42b8b$var$handleSpecialCases = (rule)=>{
    let { value: value, operator: operator } = rule;
    const { type: type } = rule;
    if (Array.isArray(value)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const encodedValues = [];
        value.forEach((val)=>{
            // additional level of encoding for spaces because otherwise the spaces
            // will be mistaken for value delimiters (STRM-1857); escape space as "_"
            // and escape any existing "_" as "\_"
            encodedValues.push(val.replace(/_/g, '\\_').replace(/ /g, '_'));
        });
        value = encodedValues.join(' ');
    }
    if (type === 'date') {
        if (operator === 'is') // back end doesn't support "IS", we have to turn it into a between
        operator = 'between';
        value = $cadf517d0dd42b8b$var$getDateValue(value, operator);
        // We had some problems getting the date values
        // Return empty rule so it won't be included
        if (value.indexOf('NaN') !== -1) return {};
    } else if (type === 'list' || type === 'user') {
        // allow comma-separated values (in addition to space separated) for issue keys and usernames
        value = value.replace(/,/g, ' ');
        // escape underscores as "\_" (because "_" is used to escape spaces in lists)
        value = value.replace(/_/g, '\\_');
    }
    return {
        value: value,
        operator: operator
    };
};
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#651-683
const $cadf517d0dd42b8b$var$getParamsFromRules = (rules)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const params = {};
    const providers = JSON.parse(decodeURIComponent(rules.replace(/&#([0-9]+);/g, $cadf517d0dd42b8b$var$replacer)))?.providers || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const enabledProviders = [];
    // @ts-expect-error - TS7006 - Parameter 'provider' implicitly has an 'any' type.
    providers.forEach((provider)=>{
        const providerKey = provider.provider;
        const { rules: providerRules } = provider;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stringifiedRules = [];
        if (!provider.disabled) {
            if (providerKey !== 'streams') enabledProviders.push(providerKey);
            // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
            providerRules.forEach((rule)=>{
                const modifiedRuleObj = $cadf517d0dd42b8b$var$handleSpecialCases(rule);
                const { operator: operator, value: value } = modifiedRuleObj;
                if (operator && value) stringifiedRules.push([
                    rule.rule,
                    operator.toUpperCase(),
                    value
                ].join(' '));
            });
            params[providerKey] = stringifiedRules;
        }
    });
    if (enabledProviders.length < providers.length - 1) params.providers = enabledProviders.join(' ');
    return params;
};
const $cadf517d0dd42b8b$export$3d7deb7cf8a9de04 = (gadget)=>{
    const prefs = Object.fromEntries(gadget.userPrefs?.fields.map((field)=>[
            field.name,
            field.value
        ]) ?? []);
    const params = {
        maxResults: prefs.numofentries ?? 25,
        relativeLinks: true,
        ...prefs.rules ? $cadf517d0dd42b8b$var$getParamsFromRules(prefs.rules) : {}
    };
    // Gadget encodes spaces as '+', rather than '%20'.  Need to replace here to match URL exactly.
    return (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(params).replace(/%20/g, '+');
};
const $cadf517d0dd42b8b$var$ACTIVITY_STREAM_REST_URL = 'plugins/servlet/streams';
const $cadf517d0dd42b8b$export$360928f5bf059a9e = (gadgetData)=>{
    const paramStr = $cadf517d0dd42b8b$export$3d7deb7cf8a9de04(gadgetData);
    return [
        `/${$cadf517d0dd42b8b$var$ACTIVITY_STREAM_REST_URL}?${paramStr}`
    ];
};

});

parcelRegister("cdUf4", function(module, exports) {

$parcel$export(module.exports, "getFilterResultsPrefetchLink", () => $7e69dbaeb4189994$export$947cd90004054337);

var $ebyGx = parcelRequire("ebyGx");
const $7e69dbaeb4189994$var$FILTER_RESULTS_REST_URL = 'rest/gadget/1.0/issueTable';
const $7e69dbaeb4189994$export$947cd90004054337 = (gadgetData)=>{
    const { properties: properties } = gadgetData.context.dashboardItem;
    const data = {
        num: properties.num,
        tableContext: 'jira.table.cols.dashboard',
        addDefault: false,
        columnNames: typeof properties.columnNames === 'string' ? properties.columnNames.split('|') : undefined,
        enableSorting: true,
        paging: true,
        showActions: true,
        filterId: undefined,
        jql: undefined,
        sortBy: String(properties.sortBy && properties.sortBy !== '' ? properties.sortBy : null),
        startIndex: properties.startIndex ? properties.startIndex : 0
    };
    let queryType = '';
    if (properties.filterId) {
        queryType = 'filter';
        Object.assign(data, {
            filterId: properties.filterId
        });
    } else if (properties.jql) {
        queryType = 'jql';
        Object.assign(data, {
            jql: properties.jql
        });
    }
    // IMPORTANT - type definitions are incorrect, sort is definitely an option
    // @see https://www.npmjs.com/package/query-string/v/5.1.0
    // @ts-expect-error - TS2345 - Argument of type '{ sort: boolean; }' is not assignable to parameter of type 'StringifyOptions'.
    const paramStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(data, {
        sort: false
    }).replace(/%20/g, '+');
    const preloadUrl = `/${$7e69dbaeb4189994$var$FILTER_RESULTS_REST_URL}/${queryType}?${paramStr}`;
    return [
        preloadUrl
    ];
};

});




parcelRegister("6T8HZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c547330881220e9$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8c547330881220e9$export$2e2bcd8739ae039 = (response)=>{
    let resourceHtml = `
        <script type="text/javascript" data-defer-skip>
            window.WRM=window.WRM||{};window.WRM._unparsedData=window.WRM._unparsedData||{};window.WRM._unparsedErrors=window.WRM._unparsedErrors||{};
            WRM._unparsedData = Object.assign({}, WRM._unparsedData, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedData))}));
            WRM._unparsedErrors = Object.assign({}, WRM._unparsedErrors, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedErrors))}));
            if(window.WRM._dataArrived)window.WRM._dataArrived();
        </script>
    `;
    response.resources.forEach((resource)=>{
        const { url: url, resourceType: resourceType, key: key } = resource;
        if (resourceType === 'CSS') {
            const cssResource = `<link
                href=${url}
                type="text/css"
                rel="stylesheet"
                media="all"
                data-wrm-key=${key}
                data-wrm-batch-type="context"
            />`;
            resourceHtml += cssResource;
        } else {
            const jsResource = `<div>
                <script
                    type="text/javascript"
                    data-initially-rendered
                    data-defer-skip
                    src=${url}
                    data-wrm-key=${key}
                    data-wrm-batch-type="context"
                ></script>
            </div>`;
            resourceHtml += jsResource;
        }
    });
    return resourceHtml;
};

});

parcelRegister("8oOn8", function(module, exports) {

$parcel$export(module.exports, "gadgetsToUniqueSortedAmdModules", () => $d83f51a78c4f458b$export$598e0ea2a7525181);
$parcel$export(module.exports, "gadgetsToSortedReactGadgets", () => $d83f51a78c4f458b$export$f98787198c197952);
// eslint-disable-next-line jira/import-whitelist

var $JIPqS = parcelRequire("JIPqS");

var $kspzT = parcelRequire("kspzT");
const $d83f51a78c4f458b$export$598e0ea2a7525181 = (gadgets)=>gadgets // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .map(({ amdModule: amdModule })=>amdModule) // validated below
    .filter(Boolean).filter((amdModule)=>amdModule in (0, $JIPqS.WEB_RESOURCE_MAP)).filter((v, i, a)=>a.indexOf(v) === i).sort() ?? [];
const $d83f51a78c4f458b$export$f98787198c197952 = (gadgets)=>gadgets.reduce((gadgetsAccumulator, gadget)=>{
        if (!(0, $kspzT.isReactKey)(gadget.reactKey)) return gadgetsAccumulator;
        gadgetsAccumulator.push({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            reactKey: gadget.reactKey,
            id: gadget.id,
            userPrefs: gadget.userPrefs
        });
        return gadgetsAccumulator;
    }, []).sort((a, b)=>a.id.localeCompare(b.id));

});
parcelRegister("kspzT", function(module, exports) {

$parcel$export(module.exports, "isReactKey", () => $7a81ea406ace6c08$export$6acd06c99f745b49);
$parcel$export(module.exports, "default", () => $7a81ea406ace6c08$export$2e2bcd8739ae039);

var $9zbBl = parcelRequire("9zbBl");

var $kvkwL = parcelRequire("kvkwL");

var $26UOd = parcelRequire("26UOd");
/** This is a gadgets definition file.  */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7a81ea406ace6c08$var$GADGETS_DEFINITION = {
    [(0, $26UOd.REACT_KEY).FILTER_RESULTS]: (0, $kvkwL.FILTER_RESULTS_DEFINITION),
    [(0, $26UOd.REACT_KEY).ASSIGNED_TO_ME]: (0, $kvkwL.ASSIGNED_TO_ME_DEFINITION),
    [(0, $26UOd.REACT_KEY).ISSUES_IN_PROGRESS]: (0, $kvkwL.ISSUES_IN_PROGRESS_DEFINITION),
    [(0, $26UOd.REACT_KEY).VOTED_ISSUES]: (0, $kvkwL.VOTED_ISSUES_DEFINITION),
    [(0, $26UOd.REACT_KEY).WATCHED_ISSUES]: (0, $kvkwL.WATCHED_ISSUES_DEFINITION),
    [(0, $26UOd.REACT_KEY).CUSTOM_REPORT]: (0, $9zbBl.default)
};
function $7a81ea406ace6c08$export$6acd06c99f745b49(key) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return !!(key && Object.values((0, $26UOd.REACT_KEY)).includes(key));
}
var $7a81ea406ace6c08$export$2e2bcd8739ae039 = $7a81ea406ace6c08$var$GADGETS_DEFINITION;

});
parcelRegister("9zbBl", function(module, exports) {

$parcel$export(module.exports, "default", () => $088534adc4ba7ffc$export$2e2bcd8739ae039);

var $cDOH2 = parcelRequire("cDOH2");

var $jUheV = parcelRequire("jUheV");

var $gM7kh = parcelRequire("gM7kh");
const $088534adc4ba7ffc$var$CUSTOM_REPORT_DEFINITION = {
    componentView: (0, $jUheV.LazyCustomReportGadgetView),
    componentEdit: (0, $cDOH2.LazyCustomReportGadgetEdit),
    getInitialState: $gM7kh.default,
    preload: $jUheV.preload
};
var $088534adc4ba7ffc$export$2e2bcd8739ae039 = $088534adc4ba7ffc$var$CUSTOM_REPORT_DEFINITION;

});
parcelRegister("cDOH2", function(module, exports) {

$parcel$export(module.exports, "LazyCustomReportGadgetEdit", () => $e8ab1a4d1d8a6eb4$export$475e4a6fb8f40116);

var $b7Svb = parcelRequire("b7Svb");

const $e8ab1a4d1d8a6eb4$export$475e4a6fb8f40116 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("acpBQ")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/edit/main.tsx"
});

});
parcelRegister("acpBQ", function(module, exports) {

let $76cee3e20ad849c9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $76cee3e20ad849c9$var$load("3Na4y").then(()=>parcelRequire('chhAm'));

});


parcelRegister("jUheV", function(module, exports) {

$parcel$export(module.exports, "LazyCustomReportGadgetView", () => $e43675722e4e42c6$export$27df795d4f3ff173);
$parcel$export(module.exports, "preload", () => $e43675722e4e42c6$export$513ccb98c53b8039);

var $b7Svb = parcelRequire("b7Svb");

const $e43675722e4e42c6$export$27df795d4f3ff173 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("dhWOU")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/view/main.tsx"
});
const { preload: $e43675722e4e42c6$export$513ccb98c53b8039 } = $e43675722e4e42c6$export$27df795d4f3ff173;

});
parcelRegister("dhWOU", function(module, exports) {

let $9aca7d58a717da77$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9aca7d58a717da77$var$load("fBPHr").then(()=>parcelRequire('e2l8c'));

});


parcelRegister("gM7kh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1132aa73a645b93$export$2e2bcd8739ae039);
const $d1132aa73a645b93$var$getInitialState = ()=>Promise.resolve({
        intervalValue: '1',
        isCustom: 'false',
        projectValue: '0',
        refresh: 'false',
        reportValue: '0',
        gadgetContentTitle: ''
    });
var $d1132aa73a645b93$export$2e2bcd8739ae039 = $d1132aa73a645b93$var$getInitialState;

});


parcelRegister("kvkwL", function(module, exports) {

$parcel$export(module.exports, "FILTER_RESULTS_DEFINITION", () => $676d00abfb59f2ab$export$3581891d04da6bb8);
$parcel$export(module.exports, "ASSIGNED_TO_ME_DEFINITION", () => $676d00abfb59f2ab$export$652d5a9cc2c18d2e);
$parcel$export(module.exports, "ISSUES_IN_PROGRESS_DEFINITION", () => $676d00abfb59f2ab$export$54b46348d1ed5d22);
$parcel$export(module.exports, "VOTED_ISSUES_DEFINITION", () => $676d00abfb59f2ab$export$ea96ce30d34ce354);
$parcel$export(module.exports, "WATCHED_ISSUES_DEFINITION", () => $676d00abfb59f2ab$export$5109728db227eae);

var $5uXOq = parcelRequire("5uXOq");

var $2egG3 = parcelRequire("2egG3");

var $eZ5lN = parcelRequire("eZ5lN");

var $kdIR9 = parcelRequire("kdIR9");

var $dzPNh = parcelRequire("dzPNh");

var $9KhHm = parcelRequire("9KhHm");

var $5ALJk = parcelRequire("5ALJk");

var $hfHPa = parcelRequire("hfHPa");
const $676d00abfb59f2ab$var$componentViewWithAdditionalState = (Component, additionalStateProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            state: props.state ? {
                ...props.state,
                ...additionalStateProps
            } : null
        });
const $676d00abfb59f2ab$var$componentEditWithAdditionalState = (Component, additionalStateProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            state: props.state ? {
                ...props.state,
                ...additionalStateProps
            } : null
        });
const $676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG = {
    testId: 'react-issue-table-gadgets.filter-results.view'
};
const $676d00abfb59f2ab$export$3581891d04da6bb8 = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG),
    componentEdit: (0, $eZ5lN.FilterResultsGadgetEdit),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG),
    preload: (0, $dzPNh.preload)
};
const $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG = {
    predeterminedJql: 'assignee = currentUser() AND statusCategory != 3 ORDER BY priority DESC, created ASC',
    defaultSortPrefs: {
        field: 'priority',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.assigned-to-me.view'
};
const $676d00abfb59f2ab$export$652d5a9cc2c18d2e = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
    componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, $2egG3.AssignedToMeGadgetEdit), $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
    preload: (0, $dzPNh.preload)
};
const $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG = {
    predeterminedJql: 'status = "In Progress" AND statusCategory != Done AND assignee = currentUser() ORDER BY priority DESC, created ASC',
    defaultSortPrefs: {
        field: 'priority',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.issues-in-progress.view'
};
const $676d00abfb59f2ab$export$54b46348d1ed5d22 = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
    componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, $kdIR9.IssuesInProgressGadgetEdit), $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
    preload: (0, $dzPNh.preload)
};
const $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG = {
    predeterminedJql: 'issue in votedIssues() AND statusCategory != Done ORDER BY votes DESC',
    predeterminedJqlIncludeResolved: 'issue in votedIssues() ORDER BY votes DESC',
    defaultSortPrefs: {
        field: 'votes',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.voted-issues.view'
};
const $676d00abfb59f2ab$export$ea96ce30d34ce354 = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
    componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, $9KhHm.VotedIssuesGadgetEdit), $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
    preload: (0, $dzPNh.preload)
};
const $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG = {
    predeterminedJql: 'issue in watchedIssues() AND statusCategory != Done ORDER BY watchers DESC',
    predeterminedJqlIncludeResolved: 'issue in watchedIssues() ORDER BY watchers DESC',
    defaultSortPrefs: {
        field: 'watchers',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.watched-issues.view'
};
const $676d00abfb59f2ab$export$5109728db227eae = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
    componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, $5ALJk.WatchedIssuesGadgetEdit), $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
    preload: (0, $dzPNh.preload)
};

});
parcelRegister("2egG3", function(module, exports) {

$parcel$export(module.exports, "AssignedToMeGadgetEdit", () => $91d75e80303bba8c$export$3ae3568d16dc8f35);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $b7Svb = parcelRequire("b7Svb");

const $91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("hn7z5")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/assigned-to-me/edit/main.tsx"
});
const $91d75e80303bba8c$export$3ae3568d16dc8f35 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "assigned-to-me-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit, props));
const { preload: $91d75e80303bba8c$export$513ccb98c53b8039 } = $91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit;

});
parcelRegister("834mM", function(module, exports) {

$parcel$export(module.exports, "FilterResultsEditSkeleton", () => $92b82de956011a8a$export$e10d91ce257e7374);
/* filter-results-edit.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $cuyZg = parcelRequire("cuyZg");
const $92b82de956011a8a$var$customCssStyles = null;
const $92b82de956011a8a$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT = '698px';
const $92b82de956011a8a$export$e10d91ce257e7374 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cuyZg))),
        containerStyles: {
            height: $92b82de956011a8a$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT
        },
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("cuyZg", function(module, exports) {
module.exports = new URL("filter-results-edit-skeleton.tpl.783fb7b7.svg", import.meta.url).toString();

});


parcelRegister("hn7z5", function(module, exports) {

let $ca5a73e51fa3974f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ca5a73e51fa3974f$var$load("hPzOn"),
    $ca5a73e51fa3974f$var$load("h2MrD"),
    $ca5a73e51fa3974f$var$load("bYT2S"),
    $ca5a73e51fa3974f$var$load("dsiAd"),
    $ca5a73e51fa3974f$var$load("a1jim")
]).then(()=>parcelRequire('1SEAb'));

});


parcelRegister("eZ5lN", function(module, exports) {

$parcel$export(module.exports, "FilterResultsGadgetEdit", () => $fa7c1c640e166488$export$6dfceca003c43832);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $b7Svb = parcelRequire("b7Svb");

const $fa7c1c640e166488$var$LazyFilterResultsGadgetEdit = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("1rwHO")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/filter-results/edit/main.tsx"
});
const $fa7c1c640e166488$export$6dfceca003c43832 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "filter-results-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa7c1c640e166488$var$LazyFilterResultsGadgetEdit, props));
const { preload: $fa7c1c640e166488$export$513ccb98c53b8039 } = $fa7c1c640e166488$var$LazyFilterResultsGadgetEdit;

});
parcelRegister("1rwHO", function(module, exports) {

let $10d1aeb41282e5d7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $10d1aeb41282e5d7$var$load("hPzOn"),
    $10d1aeb41282e5d7$var$load("h2MrD"),
    $10d1aeb41282e5d7$var$load("bYT2S"),
    $10d1aeb41282e5d7$var$load("dsiAd"),
    $10d1aeb41282e5d7$var$load("2WaJa")
]).then(()=>parcelRequire('eKgKX'));

});


parcelRegister("kdIR9", function(module, exports) {

$parcel$export(module.exports, "IssuesInProgressGadgetEdit", () => $04f85077310bce7f$export$199fec410a0f70a2);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $b7Svb = parcelRequire("b7Svb");

const $04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("dzPzY")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/issues-in-progress/edit/main.tsx"
});
const $04f85077310bce7f$export$199fec410a0f70a2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issues-in-progress-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit, props));
const { preload: $04f85077310bce7f$export$513ccb98c53b8039 } = $04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit;

});
parcelRegister("dzPzY", function(module, exports) {

let $9e268dd2dc26e3db$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9e268dd2dc26e3db$var$load("hPzOn"),
    $9e268dd2dc26e3db$var$load("h2MrD"),
    $9e268dd2dc26e3db$var$load("bYT2S"),
    $9e268dd2dc26e3db$var$load("dsiAd"),
    $9e268dd2dc26e3db$var$load("lNlvX")
]).then(()=>parcelRequire('dk51x'));

});


parcelRegister("dzPNh", function(module, exports) {

$parcel$export(module.exports, "IssueTableGadgetView", () => $0c0c24e495111ec5$export$da0765a3c10e16a3);
$parcel$export(module.exports, "preload", () => $0c0c24e495111ec5$export$513ccb98c53b8039);

var $5uXOq = parcelRequire("5uXOq");

var $JIPqS = parcelRequire("JIPqS");

var $lfTZh = parcelRequire("lfTZh");

var $dNZVN = parcelRequire("dNZVN");

var $b7Svb = parcelRequire("b7Svb");

const $0c0c24e495111ec5$var$LazyIssueTableGadgetView = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("i1Z5d")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/view/main.tsx"
});
const $0c0c24e495111ec5$export$da0765a3c10e16a3 = ({ customSkeletonHeightInPx: customSkeletonHeightInPx, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "filter-results-gadget-view",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dNZVN.FilterResultsIssueTableSkeleton), {
            height: `${customSkeletonHeightInPx ?? (0, $JIPqS.GADGET_DEFAULT_HEIGHT)}px`
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c0c24e495111ec5$var$LazyIssueTableGadgetView, {
        customSkeletonHeightInPx: customSkeletonHeightInPx,
        ...props
    }));
const { preload: $0c0c24e495111ec5$export$513ccb98c53b8039 } = $0c0c24e495111ec5$var$LazyIssueTableGadgetView;

});
parcelRegister("dNZVN", function(module, exports) {

$parcel$export(module.exports, "FilterResultsIssueTableSkeleton", () => $a73c71eae267b518$export$35d754053deeac73);
/* filter-results-issue-table.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $dCGjE = parcelRequire("dCGjE");
const $a73c71eae267b518$var$customCssStyles = null;
const $a73c71eae267b518$export$35d754053deeac73 = ({ height: height })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dCGjE))),
        containerStyles: {
            height: height
        },
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("dCGjE", function(module, exports) {
module.exports = new URL("filter-results-issue-table-skeleton.tpl.a502204a.svg", import.meta.url).toString();

});


parcelRegister("i1Z5d", function(module, exports) {

let $d207b3cf616561f6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d207b3cf616561f6$var$load("hPzOn"),
    $d207b3cf616561f6$var$load("h2MrD"),
    $d207b3cf616561f6$var$load("bYT2S"),
    $d207b3cf616561f6$var$load("dsiAd"),
    $d207b3cf616561f6$var$load("kLRoU")
]).then(()=>parcelRequire('dfMo9'));

});


parcelRegister("9KhHm", function(module, exports) {

$parcel$export(module.exports, "VotedIssuesGadgetEdit", () => $0ca7bf6a0d6f5346$export$7650b85a7a54914);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $b7Svb = parcelRequire("b7Svb");

const $0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("2qWwe")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/voted-issues/edit/main.tsx"
});
const $0ca7bf6a0d6f5346$export$7650b85a7a54914 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "voted-issues-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit, props));
const { preload: $0ca7bf6a0d6f5346$export$513ccb98c53b8039 } = $0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit;

});
parcelRegister("2qWwe", function(module, exports) {

let $1c5b672074f5568f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1c5b672074f5568f$var$load("hPzOn"),
    $1c5b672074f5568f$var$load("h2MrD"),
    $1c5b672074f5568f$var$load("bYT2S"),
    $1c5b672074f5568f$var$load("dsiAd"),
    $1c5b672074f5568f$var$load("bNNoR")
]).then(()=>parcelRequire('irHWu'));

});


parcelRegister("5ALJk", function(module, exports) {

$parcel$export(module.exports, "WatchedIssuesGadgetEdit", () => $278dbe55a7acf378$export$a53864bd0bf8a85f);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $b7Svb = parcelRequire("b7Svb");

const $278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("kpdby")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/watched-issues/edit/main.tsx"
});
const $278dbe55a7acf378$export$a53864bd0bf8a85f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "watched-issues-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit, props));
const { preload: $278dbe55a7acf378$export$513ccb98c53b8039 } = $278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit;

});
parcelRegister("kpdby", function(module, exports) {

let $edb05ecd079cb15f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $edb05ecd079cb15f$var$load("hPzOn"),
    $edb05ecd079cb15f$var$load("h2MrD"),
    $edb05ecd079cb15f$var$load("bYT2S"),
    $edb05ecd079cb15f$var$load("dsiAd"),
    $edb05ecd079cb15f$var$load("h7Bte")
]).then(()=>parcelRequire('iLll9'));

});


parcelRegister("hfHPa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f27ae6f4005fc53$export$2e2bcd8739ae039);

var $fJpBG = parcelRequire("fJpBG");

var $lgZ6q = parcelRequire("lgZ6q");

var $8rq2P = parcelRequire("8rq2P");

var $jyMtv = parcelRequire("jyMtv");
const $9f27ae6f4005fc53$var$createGetInitialState = ({ predeterminedJql: predeterminedJql, predeterminedJqlIncludeResolved: predeterminedJqlIncludeResolved, defaultSortPrefs: defaultSortPrefs, testId: testId })=>async (resourceContext, userPrefs)=>{
        if (resourceContext?.tenantContext == null) throw new Error('Tenant context is not available');
        const { cloudId: cloudId, activationId: activationId } = resourceContext.tenantContext;
        const validUserPrefs = (0, $jyMtv.transformToValidUserPrefs)((0, $fJpBG.decodeUserPreferences)(userPrefs));
        if (validUserPrefs.filterId === undefined && predeterminedJql === undefined && predeterminedJqlIncludeResolved === undefined) throw new Error('FilterId or JQL has to be available to be able to load the gadget initial state');
        const sortPrefs = (()=>{
            if (validUserPrefs.sortField) return {
                sortField: validUserPrefs.sortField,
                sortDirection: validUserPrefs.sortDirection
            };
            if (defaultSortPrefs) return {
                sortField: defaultSortPrefs.field,
                sortDirection: defaultSortPrefs.direction
            };
        })();
        const includeResolved = validUserPrefs.showResolved;
        const jql = includeResolved ? predeterminedJqlIncludeResolved : predeterminedJql;
        const queryReference = await (0, $8rq2P.loadQueryWithUserPrefs)({
            ...validUserPrefs,
            ...sortPrefs
        }, (0, $lgZ6q.default), cloudId, activationId, 'store-and-network', jql);
        return {
            queryReference: queryReference,
            predeterminedJql: predeterminedJql,
            defaultSortPrefs: defaultSortPrefs,
            testId: testId
        };
    };
var $9f27ae6f4005fc53$export$2e2bcd8739ae039 = $9f27ae6f4005fc53$var$createGetInitialState;

});
parcelRegister("fJpBG", function(module, exports) {

$parcel$export(module.exports, "getUserPreferences", () => $a6145919a3771254$export$ae3f5fa351e2f57a);
$parcel$export(module.exports, "decodeUserPreferences", () => $a6145919a3771254$export$ebdfc6c2778ef8e2);

var $7f4tk = parcelRequire("7f4tk");
const $a6145919a3771254$var$isBooleanString = (str)=>[
        'true',
        'false'
    ].includes(str.toLowerCase().trim());
const $a6145919a3771254$var$stringToBoolean = (str)=>str.toLowerCase().trim() === 'true';
const $a6145919a3771254$export$ae3f5fa351e2f57a = (action)=>(0, $7f4tk.default)(action);
const $a6145919a3771254$export$ebdfc6c2778ef8e2 = (userPreferences = [])=>userPreferences.reduce((output, { value: value, name: name })=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...output,
            [name]: $a6145919a3771254$var$isBooleanString(value) ? $a6145919a3771254$var$stringToBoolean(value) : value
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});

});

parcelRegister("lgZ6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $328d775330990290$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<feaae89a17e49d190216bf7fce58bb88>>
 * @relayHash 3c5b396bbe096181578855ba91790234
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 99eaaa913f4fe7afb5d47aeb7a560dbff452461583ed2bc52a87ebe5953dae45

var $5oQtH = parcelRequire("5oQtH");

var $5qm7M = parcelRequire("5qm7M");

var $dttgK = parcelRequire("dttgK");

var $hBvdF = parcelRequire("hBvdF");
const $328d775330990290$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsContext"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterAri"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isNotFilterFetch"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v14 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v15 = {
        "kind": "ScalarField",
        "name": "key"
    }, v16 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v21 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            v19 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v21 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v23 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v25 = {
        "kind": "Variable",
        "name": "fieldSetIds",
        "variableName": "fieldSetIds"
    }, v26 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v27 = {
        "kind": "ScalarField",
        "name": "type"
    }, v28 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v29 = {
        "kind": "ScalarField",
        "name": "name"
    }, v30 = {
        "kind": "ScalarField",
        "name": "value"
    }, v31 = [
        v30 /*: any*/ ,
        v17 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v32 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lazyIsEditableInIssueView"
            }
        ]
    }, v33 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v34 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v35 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v36 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v37 = {
        "kind": "ScalarField",
        "name": "text"
    }, v38 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            v29 /*: any*/ ,
            v32 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v39 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v40 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v17 /*: any*/ 
        ]
    }, v41 = [
        v40 /*: any*/ 
    ], v42 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v43 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v44 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v45 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v46 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v47 = [
        v29 /*: any*/ ,
        v17 /*: any*/ 
    ], v48 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v49 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v37 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v50 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v40 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v51 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v52 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v51 /*: any*/ ,
                    v29 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            },
            v17 /*: any*/ 
        ]
    }, v53 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v54 = {
        "kind": "ScalarField",
        "name": "number"
    }, v55 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v27 /*: any*/ ,
                        v28 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraIssueField"
                                                },
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAffectedServiceConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedAffectedServicesConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAffectedService",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "serviceId"
                                                                                },
                                                                                v29 /*: any*/ ,
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraAffectedServicesField"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraCascadingOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "cascadingOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOption",
                                                                            "kind": "LinkedField",
                                                                            "name": "parentOptionValue",
                                                                            "plural": false,
                                                                            "selections": v31 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraOption",
                                                                            "kind": "LinkedField",
                                                                            "name": "childOptionValue",
                                                                            "plural": false,
                                                                            "selections": v31 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v32 /*: any*/ 
                                                            ],
                                                            "type": "JiraCascadingSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                {
                                                                    "args": v33 /*: any*/ ,
                                                                    "concreteType": "JiraComponentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedComponentsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraComponentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraComponent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        v35 /*: any*/ ,
                                                                                        v17 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                },
                                                                v32 /*: any*/ 
                                                            ],
                                                            "type": "JiraComponentsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v36 /*: any*/ ,
                                                                v29 /*: any*/ ,
                                                                v32 /*: any*/ 
                                                            ],
                                                            "type": "JiraDateTimePickerField"
                                                        },
                                                        v38 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraCommentSummary",
                                                                    "kind": "LinkedField",
                                                                    "name": "commentSummary",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canAddComment"
                                                                        },
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraCommentSummaryField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "uri"
                                                                },
                                                                v32 /*: any*/ 
                                                            ],
                                                            "type": "JiraUrlField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v30 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v41 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v41 /*: any*/ 
                                                                        },
                                                                        v17 /*: any*/ ,
                                                                        v42 /*: any*/ 
                                                                    ]
                                                                },
                                                                v32 /*: any*/ 
                                                            ],
                                                            "type": "JiraSingleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOptionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v17 /*: any*/ ,
                                                                                        v30 /*: any*/ ,
                                                                                        v42 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v32 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOptionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v17 /*: any*/ ,
                                                                                        v30 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v32 /*: any*/ 
                                                            ],
                                                            "type": "JiraCheckboxesField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraUserConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedUsersConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraUserEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v18 /*: any*/ ,
                                                                                        v43 /*: any*/ ,
                                                                                        v29 /*: any*/ ,
                                                                                        v44 /*: any*/ ,
                                                                                        v17 /*: any*/ ,
                                                                                        v45 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "email"
                                                                                                }
                                                                                            ],
                                                                                            "type": "AtlassianAccountUser"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v32 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraTeamView",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedTeam",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jiraSuppliedId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jiraSuppliedName"
                                                                        }
                                                                    ]
                                                                },
                                                                v32 /*: any*/ 
                                                            ],
                                                            "type": "JiraTeamViewField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraTimeTrackingField",
                                                                            "kind": "LinkedField",
                                                                            "name": "timeTrackingField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v17 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraEstimate",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "originalEstimate",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "timeInSeconds"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraTimeTrackingSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "timeTrackingSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "workingHoursPerDay"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "workingDaysPerWeek"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "defaultFormat"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "defaultUnit"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v19 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v32 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v17 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraOriginalTimeEstimateField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": "label",
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        },
                                                                        v17 /*: any*/ ,
                                                                        v34 /*: any*/ 
                                                                    ]
                                                                },
                                                                v32 /*: any*/ 
                                                            ],
                                                            "type": "JiraRadioSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                {
                                                                    "args": v33 /*: any*/ ,
                                                                    "concreteType": "JiraVersionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedVersionsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraVersion",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v17 /*: any*/ ,
                                                                                        v29 /*: any*/ ,
                                                                                        v34 /*: any*/ ,
                                                                                        v35 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "versionId"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                },
                                                                v32 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleVersionPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v33 /*: any*/ ,
                                                                    "concreteType": "JiraGoalConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedGoals",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraGoalEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraGoal",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v17 /*: any*/ ,
                                                                                        v15 /*: any*/ ,
                                                                                        v18 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v46 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "PageInfo",
                                                                            "kind": "LinkedField",
                                                                            "name": "pageInfo",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "endCursor"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "hasNextPage"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                },
                                                                {
                                                                    "args": v33 /*: any*/ ,
                                                                    "handle": "connection",
                                                                    "key": "Goals_selectedGoals",
                                                                    "kind": "LinkedHandle",
                                                                    "name": "selectedGoals"
                                                                }
                                                            ],
                                                            "type": "JiraGoalsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                {
                                                                    "args": v33 /*: any*/ ,
                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "confluenceRemoteIssueLinks",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v17 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "href"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v39 /*: any*/ 
                                                                    ],
                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                },
                                                                v32 /*: any*/ 
                                                            ],
                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraCmdbObjectConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedCmdbObjectsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraCmdbObject",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "objectId"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "label"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "avatar",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "mediaClientConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "clientId"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "fileId"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "mediaBaseUrl"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "mediaJwtToken"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "url48"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "QueryError",
                                                                    "kind": "LinkedField",
                                                                    "name": "errors",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "message"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraCMDBField"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "alias": "componentsOld",
                                                                    "concreteType": "JiraComponentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedComponentsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraComponentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraComponent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": v47 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraComponentsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v37 /*: any*/ 
                                                            ],
                                                            "type": "JiraSingleLineTextField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "date"
                                                        },
                                                        v29 /*: any*/ ,
                                                        v48 /*: any*/ ,
                                                        v32 /*: any*/ 
                                                    ],
                                                    "type": "JiraDatePickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v36 /*: any*/ 
                                                    ],
                                                    "type": "JiraDateTimePickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraEpic",
                                                            "kind": "LinkedField",
                                                            "name": "epic",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "summary"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "color"
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraEpicLinkField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "renderedFieldHtml"
                                                        }
                                                    ],
                                                    "type": "JiraFallbackField"
                                                },
                                                v38 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatusCategory",
                                                            "kind": "LinkedField",
                                                            "name": "statusCategory",
                                                            "plural": false,
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                v20 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusCategoryField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusId"
                                                                },
                                                                v21 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v33 /*: any*/ ,
                                                            "concreteType": "JiraLabelConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedLabelsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraLabelEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraLabel",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v29 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v39 /*: any*/ 
                                                            ],
                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                        },
                                                        v29 /*: any*/ ,
                                                        v32 /*: any*/ 
                                                    ],
                                                    "type": "JiraLabelsField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "small"
                                                                        }
                                                                    ]
                                                                },
                                                                v29 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraIssueTypeField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "parentIssue",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                v49 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v15 /*: any*/ ,
                                                                        v50 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v17 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v15 /*: any*/ ,
                                                                        v50 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v17 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "ids",
                                                                                    "value": [
                                                                                        "summary",
                                                                                        "issuetype",
                                                                                        "status"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsById",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v19 /*: any*/ ,
                                                                                                        v37 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v19 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "issueTypeId"
                                                                                                                },
                                                                                                                v29 /*: any*/ ,
                                                                                                                v51 /*: any*/ ,
                                                                                                                v23 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                v22 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                                                        }
                                                                    ]
                                                                },
                                                                v29 /*: any*/ ,
                                                                v32 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraParentIssueField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraPriority",
                                                            "kind": "LinkedField",
                                                            "name": "priority",
                                                            "plural": false,
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        },
                                                        v29 /*: any*/ ,
                                                        v32 /*: any*/ 
                                                    ],
                                                    "type": "JiraPriorityField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "large"
                                                                        }
                                                                    ]
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraProjectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraResolution",
                                                            "kind": "LinkedField",
                                                            "name": "resolution",
                                                            "plural": false,
                                                            "selections": v47 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraResolutionField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSprintConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedSprintsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprint",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v17 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "sprintId"
                                                                                },
                                                                                v29 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "state"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "endDate"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v29 /*: any*/ ,
                                                        v32 /*: any*/ 
                                                    ],
                                                    "type": "JiraSprintField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                v43 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v29 /*: any*/ ,
                                                                v17 /*: any*/ ,
                                                                v45 /*: any*/ 
                                                            ]
                                                        },
                                                        v29 /*: any*/ ,
                                                        v48 /*: any*/ ,
                                                        v32 /*: any*/ 
                                                    ],
                                                    "type": "JiraSingleSelectUserPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v29 /*: any*/ ,
                                                        {
                                                            "args": v33 /*: any*/ ,
                                                            "concreteType": "JiraVersionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedVersionsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersion",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": v47 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                        }
                                                    ],
                                                    "type": "JiraMultipleVersionPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraRichText",
                                                            "kind": "LinkedField",
                                                            "name": "richText",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraADF",
                                                                    "kind": "LinkedField",
                                                                    "name": "adfValue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "json"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraRichTextField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraServiceManagementRequestType",
                                                            "kind": "LinkedField",
                                                            "name": "requestType",
                                                            "plural": false,
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                v51 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementRequestTypeField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 1
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinkConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v53 /*: any*/ ,
                                                                                        v15 /*: any*/ ,
                                                                                        {
                                                                                            "args": [
                                                                                                {
                                                                                                    "kind": "Literal",
                                                                                                    "name": "ids",
                                                                                                    "value": [
                                                                                                        "statusCategory"
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldsById",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v18 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v21 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                },
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                        },
                                                                                        v17 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "relationName"
                                                                                },
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinkConnection(first:1)"
                                                        }
                                                    ],
                                                    "type": "JiraIssueLinkField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isStoryPointField"
                                                        },
                                                        v54 /*: any*/ ,
                                                        v29 /*: any*/ ,
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                v54 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v54 /*: any*/ ,
                                                                v29 /*: any*/ ,
                                                                v32 /*: any*/ 
                                                            ]
                                                        },
                                                        v32 /*: any*/ 
                                                    ],
                                                    "type": "JiraNumberField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v56 = {
        "kind": "ClientExtension",
        "selections": [
            v24 /*: any*/ 
        ]
    }, v57 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v58 = [
        v46 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ], v59 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueTableViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "issueTableView_reactIssueTableGadgets"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v12 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v8 /*: any*/ ,
                v6 /*: any*/ ,
                v9 /*: any*/ ,
                v7 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "issueTableViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "after",
                                    "variableName": "after"
                                },
                                v14 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "fieldSetsInput",
                                    "variableName": "fieldSetsInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isResolved"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                                "status"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v18 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v17 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldsById(ids:[\"status\"])"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canBeExported"
                                                },
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v23 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ]
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "condition": "shouldQueryFieldSetsById",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "args": [
                                                                        v25 /*: any*/ ,
                                                                        v26 /*: any*/ 
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsById",
                                                                    "plural": false,
                                                                    "selections": v55 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "shouldQueryFieldSetsById",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "context",
                                                                            "variableName": "fieldSetsContext"
                                                                        },
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "filterId",
                                                                            "variableName": "filterId"
                                                                        },
                                                                        v26 /*: any*/ ,
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "namespace",
                                                                            "variableName": "namespace"
                                                                        },
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "viewId",
                                                                            "variableName": "viewId"
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsForIssueSearchView",
                                                                    "plural": false,
                                                                    "selections": v55 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v18 /*: any*/ ,
                                        v56 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 500
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": v55 /*: any*/ ,
                                                    "storageKey": "fieldSets(first:500)"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v57 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "JiraIssueNavigatorPageInfo",
                                    "kind": "LinkedField",
                                    "name": "issueNavigatorPageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssuePosition"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "maxCursors",
                                            "value": 7
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "pageSize",
                                            "variableName": "first"
                                        }
                                    ],
                                    "concreteType": "JiraPageCursors",
                                    "kind": "LinkedField",
                                    "name": "pageCursors",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "first",
                                            "plural": false,
                                            "selections": v58 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "around",
                                            "plural": true,
                                            "selections": v58 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "last",
                                            "plural": false,
                                            "selections": v58 /*: any*/ 
                                        }
                                    ]
                                },
                                v56 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v14 /*: any*/ ,
                                v25 /*: any*/ 
                            ],
                            "concreteType": "JiraIssueSearchFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchFieldSet",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v28 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                v59 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jqlTerm"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isSortable"
                                                },
                                                {
                                                    "concreteType": "JiraFieldSetPreferences",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetPreferences",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "width"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isPlaceHolderField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraFieldType",
                                                    "kind": "LinkedField",
                                                    "name": "fieldType",
                                                    "plural": false,
                                                    "selections": [
                                                        v59 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v39 /*: any*/ ,
                                v56 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "isNotFilterFetch",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v57 /*: any*/ ,
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "99eaaa913f4fe7afb5d47aeb7a560dbff452461583ed2bc52a87ebe5953dae45",
            "metadata": {},
            "name": "issueTableViewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
            }
        }
    };
}();
$328d775330990290$var$node.hash = "b9be546215dff0bc5951b61ed28bf1f5";
var $328d775330990290$export$2e2bcd8739ae039 = $328d775330990290$var$node;

});

parcelRegister("8rq2P", function(module, exports) {

$parcel$export(module.exports, "loadQueryWithUserPrefs", () => $3de2b9db429d32f1$export$700e212b8b5c678f);

var $8Uumt = parcelRequire("8Uumt");

var $5yJb9 = parcelRequire("5yJb9");

var $kipqU = parcelRequire("kipqU");

var $2mSjU = parcelRequire("2mSjU");
async function $3de2b9db429d32f1$export$700e212b8b5c678f({ filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection }, query, cloudId, activationId, fetchPolicy = 'store-or-network', jql) {
    const { variables: variables } = await (0, $2mSjU.transformToVariables)({
        userPrefs: {
            filterId: filterId,
            columnNames: columnNames,
            num: num,
            sortField: sortField,
            sortDirection: sortDirection
        },
        cloudId: cloudId,
        activationId: activationId,
        jql: jql
    });
    const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), query, variables, {
        fetchPolicy: fetchPolicy
    });
    if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
    return queryReference;
}

});
parcelRegister("2mSjU", function(module, exports) {

$parcel$export(module.exports, "transformToVariables", () => $1eea58ad38e5fdd1$export$a5cefa50115212b3);

var $gbLWS = parcelRequire("gbLWS");

var $6s1PB = parcelRequire("6s1PB");

var $czfFt = parcelRequire("czfFt");

var $t3Q07 = parcelRequire("t3Q07");

var $796ok = parcelRequire("796ok");



const $1eea58ad38e5fdd1$export$a5cefa50115212b3 = async ({ userPrefs: userPrefs, cloudId: cloudId, activationId: activationId, jql: jql, fetchIssueTableJqlFields: fetchIssueTableJqlFields })=>{
    const { filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection, showResolved: showResolved } = userPrefs;
    const filterAri = !jql && filterId ? (0, $gbLWS.JiraFilterAri).create({
        filterId: filterId,
        siteId: cloudId,
        activationId: activationId
    }).toString() : '';
    const variables = {
        cloudId: cloudId,
        issueSearchInput: {
            ...jql ? {
                jql: jql
            } : {
                filterId: filterId
            }
        },
        after: null,
        first: num,
        fieldSetIds: columnNames,
        amountOfColumns: (0, $czfFt.MAX_COLUMNS),
        shouldQueryFieldSetsById: true,
        fieldSetsInput: (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? {
            fieldSetIds: columnNames
        } : null,
        isNotFilterFetch: !filterAri,
        filterAri: filterAri
    };
    let fieldToJqlTermMap = new Map();
    if (!sortField || !sortDirection || ![
        'ASC',
        'DESC'
    ].includes(sortDirection)) return {
        variables: variables,
        fieldToJqlTermMap: fieldToJqlTermMap
    };
    let jqlToModify = jql;
    if (fetchIssueTableJqlFields && !jqlToModify && filterAri) {
        const result = await fetchIssueTableJqlFields(filterAri, variables.fieldSetIds, cloudId);
        fieldToJqlTermMap = result.fieldToJqlTermMap;
        jqlToModify = result.searchJql;
    }
    if (!jqlToModify) return {
        variables: variables,
        fieldToJqlTermMap: fieldToJqlTermMap
    };
    // This pulls in over 600KB of code, and if it's not deferred it's eagerly loaded as
    // part of the main jira-spa route map
    const [{ JqlUtils: JqlUtils }, { default: removeFieldClauseFromJql }, { default: findClauseInAst }] = await Promise.all([
        (parcelRequire("4UHoK")),
        (parcelRequire("5bqk6")),
        (parcelRequire("fZ9VJ"))
    ]);
    const jqlUtils = new JqlUtils();
    const jqlTermForSortField = (0, $796ok.getJqlTermForField)(sortField, fieldToJqlTermMap);
    const modifiedJql = jqlUtils.jql(jqlToModify);
    const oldPrimarySortField = modifiedJql.getPrimarySortField();
    if (oldPrimarySortField) {
        // if the sort field in original filter jql is using alias, we need to pass all possible aliases in
        // so that jqlUtils knows to replace it instead of append it as a new field
        const aliases = (0, $t3Q07.getAliasesForField)(jqlTermForSortField, fieldToJqlTermMap);
        // Sometimes, oldPrimarySortField from the JQL has
        // quotations around it which we should include
        const inclusiveAliases = Array.from(new Set([
            ...aliases,
            oldPrimarySortField
        ]));
        modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, inclusiveAliases);
    } else modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, []);
    let finalJql = modifiedJql.jqlString;
    if (showResolved) {
        const jast = modifiedJql.jast;
        if (jast) {
            const statusClause = findClauseInAst(jast, 'statusCategory');
            if (statusClause) finalJql = removeFieldClauseFromJql(jast, statusClause);
        }
    }
    return {
        variables: {
            ...variables,
            issueSearchInput: {
                jql: finalJql
            }
        },
        fieldToJqlTermMap: fieldToJqlTermMap
    };
};

});
parcelRegister("czfFt", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $7f8ee02f08da8eac$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $7f8ee02f08da8eac$export$d57b6b390e78d90f);
$parcel$export(module.exports, "SORT_ASC", () => $7f8ee02f08da8eac$export$88956207daf9a17e);
$parcel$export(module.exports, "SORT_DESC", () => $7f8ee02f08da8eac$export$bc14f97913aaf2a);
$parcel$export(module.exports, "SORT_NONE", () => $7f8ee02f08da8eac$export$9c424bf3e8ffe64e);
$parcel$export(module.exports, "MODIFY_COLUMNS", () => $7f8ee02f08da8eac$export$1f921c78ce6d243c);
$parcel$export(module.exports, "REORDER_COLUMNS", () => $7f8ee02f08da8eac$export$83371d6c41a974aa);
$parcel$export(module.exports, "MOVE_COLUMN_FIRST", () => $7f8ee02f08da8eac$export$957d455bb65919d8);
$parcel$export(module.exports, "MOVE_COLUMN_LEFT", () => $7f8ee02f08da8eac$export$2082861c970802b0);
$parcel$export(module.exports, "MOVE_COLUMN_RIGHT", () => $7f8ee02f08da8eac$export$21847d308b0769ad);
$parcel$export(module.exports, "MOVE_COLUMN_LAST", () => $7f8ee02f08da8eac$export$c32913bc261af82d);
$parcel$export(module.exports, "HEADER_HEIGHT", () => $7f8ee02f08da8eac$export$cdb7fd9d999c7168);
$parcel$export(module.exports, "ROW_HEIGHT", () => $7f8ee02f08da8eac$export$88e6c5bab2ff80e8);
$parcel$export(module.exports, "COLUMN_ID_MEATBALL_MENU", () => $7f8ee02f08da8eac$export$de4c02b525d877fa);
$parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", () => $7f8ee02f08da8eac$export$c3266da279aa6b84);
$parcel$export(module.exports, "COLUMN_ID_CHECKBOX", () => $7f8ee02f08da8eac$export$66b2a4a5f67468ac);
$parcel$export(module.exports, "COLUMN_ID_INTERNAL_COLUMN", () => $7f8ee02f08da8eac$export$b4e9105b7f5f1b0f);
$parcel$export(module.exports, "ACTION_COLUMNS", () => $7f8ee02f08da8eac$export$3dbdc5c16825be4d);
$parcel$export(module.exports, "EXPAND_BUTTON_WIDTH", () => $7f8ee02f08da8eac$export$a1c171a82c45d53f);
$parcel$export(module.exports, "CREATE_CHILD_BUTTON_WIDTH", () => $7f8ee02f08da8eac$export$43ff8c492b8a2e1b);
$parcel$export(module.exports, "EXPAND_CELL_PADDING", () => $7f8ee02f08da8eac$export$9c5dd6078b37aac2);
$parcel$export(module.exports, "DEPTH_WIDTH", () => $7f8ee02f08da8eac$export$a8273d7d48e89fce);
$parcel$export(module.exports, "MAX_COLUMNS", () => $7f8ee02f08da8eac$export$7ec4af037f372df4);
$parcel$export(module.exports, "CHILD_QUERY_PAGE_SIZE", () => $7f8ee02f08da8eac$export$d2372dfbd4e91a11);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $7f8ee02f08da8eac$export$1adf7afff96bbf16);
$parcel$export(module.exports, "COLUMN_TYPE_DATE_PICKER", () => $7f8ee02f08da8eac$export$c1d348661674e922);
$parcel$export(module.exports, "COLUMN_TYPE_SATISFACTION_FEEDBACK", () => $7f8ee02f08da8eac$export$67082d449d5ec91);
$parcel$export(module.exports, "COLUMN_TYPE_SENTIMENT", () => $7f8ee02f08da8eac$export$145a4a20f394acf9);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH_COMPACT", () => $7f8ee02f08da8eac$export$10016003aa27fa67);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$5575b9e0ed3ff59f);
$parcel$export(module.exports, "DEFAULT_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$7c3f559e2ca95fa);
$parcel$export(module.exports, "MAXIMUM_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$e1a42c2fefb5af25);
$parcel$export(module.exports, "MINIMUM_DATETIME_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$a194aa0e243a27f9);
$parcel$export(module.exports, "MINIMUM_MULTI_USER_SELECT_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$87a3548b97ce2540);
$parcel$export(module.exports, "MINIMUM_DATEPICKER_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$4fd6711c21931f5b);
$parcel$export(module.exports, "MINIMUM_SATISFACTION_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$9b72110b9a7c0a39);
$parcel$export(module.exports, "MINIMUM_SENTIMENT_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$54c15048528650a8);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_LONG", () => $7f8ee02f08da8eac$export$bfe09a9186b98f8f);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SHORT", () => $7f8ee02f08da8eac$export$f2540f34b796306d);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SUMMARY", () => $7f8ee02f08da8eac$export$954afb0fcf5a326);
$parcel$export(module.exports, "COLUMN_OPERATION_REORDER", () => $7f8ee02f08da8eac$export$93758649595b2d58);
$parcel$export(module.exports, "COLUMN_OPERATION_RESIZE", () => $7f8ee02f08da8eac$export$cad8c6a0b6e78898);
$parcel$export(module.exports, "INSERT_COLUMN_BUTTON_Y_OFFSET", () => $7f8ee02f08da8eac$export$5252387dc65db584);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_FULL_HEIGHT", () => $7f8ee02f08da8eac$export$754b76ac8fa63350);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_HEADER_ONLY", () => $7f8ee02f08da8eac$export$fa5c7dad7ee16383);
$parcel$export(module.exports, "ROW_OPERATION_REORDER", () => $7f8ee02f08da8eac$export$4e8abe16cd1126dd);
$parcel$export(module.exports, "DENSITY_COMPACT", () => $7f8ee02f08da8eac$export$6c0a5a77457ca62);
$parcel$export(module.exports, "DENSITY_FULL", () => $7f8ee02f08da8eac$export$119d8ab9a5bc4b2);
$parcel$export(module.exports, "LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE", () => $7f8ee02f08da8eac$export$9ef77944c441ad07);
$parcel$export(module.exports, "LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE", () => $7f8ee02f08da8eac$export$c1f680390b97c9e1);
$parcel$export(module.exports, "CHILD_ITEMS_EXPERIENCE", () => $7f8ee02f08da8eac$export$e03155205bf92428);
$parcel$export(module.exports, "CHILD_ITEMS_LOAD_MORE_EXPERIENCE", () => $7f8ee02f08da8eac$export$311c64c0d94dcdf3);
$parcel$export(module.exports, "GROUPED_ITEMS_EXPERIENCE", () => $7f8ee02f08da8eac$export$f5d215df3c6473e9);
$parcel$export(module.exports, "GROUPED_LOAD_MORE_EXPERIENCE", () => $7f8ee02f08da8eac$export$b4fd503bf7cccacd);
$parcel$export(module.exports, "INLINE_ISSUE_CREATE_EXPERIENCE", () => $7f8ee02f08da8eac$export$70f80a241e016093);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $7f8ee02f08da8eac$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "MAKE_CHILD", () => $7f8ee02f08da8eac$export$5eb61e3ff74a4f58);
$parcel$export(module.exports, "REORDER_ABOVE", () => $7f8ee02f08da8eac$export$9213b5774112217f);
$parcel$export(module.exports, "REORDER_BELOW", () => $7f8ee02f08da8eac$export$118b06a03e2c672f);
$parcel$export(module.exports, "SUBTASK_HIERARCHY_LEVEL", () => $7f8ee02f08da8eac$export$5b388ccfa29be01);
$parcel$export(module.exports, "COLUMN_PICKER_CONFIGURATION_CONTAINER", () => $7f8ee02f08da8eac$export$f6d7582f33b86010);
$parcel$export(module.exports, "COLUMN_PICKER_ADD_COLUMN_CONTAINER", () => $7f8ee02f08da8eac$export$f92486d03c064eac);
$parcel$export(module.exports, "MAX_LINE_WRAP_OLD", () => $7f8ee02f08da8eac$export$139bffb2a576e8c0);
$parcel$export(module.exports, "MAX_LINE_WRAP_NEW", () => $7f8ee02f08da8eac$export$3b696b0ac06c2cc4);
$parcel$export(module.exports, "HIGHLIGHT_LINGER_DURATION_MS", () => $7f8ee02f08da8eac$export$6ba5aaedfd1b5319);
const $7f8ee02f08da8eac$export$b8b9d90f9e5bd72b = 'jiraNativeIssueTable';
const $7f8ee02f08da8eac$export$d57b6b390e78d90f = 'empanada';
const $7f8ee02f08da8eac$export$88956207daf9a17e = 'ASC';
const $7f8ee02f08da8eac$export$bc14f97913aaf2a = 'DESC';
const $7f8ee02f08da8eac$export$9c424bf3e8ffe64e = 'NONE';
const $7f8ee02f08da8eac$export$1f921c78ce6d243c = 'MODIFY_COLUMNS';
const $7f8ee02f08da8eac$export$83371d6c41a974aa = 'REORDER_COLUMNS';
const $7f8ee02f08da8eac$export$957d455bb65919d8 = 'MOVE_COLUMN_FIRST';
const $7f8ee02f08da8eac$export$2082861c970802b0 = 'MOVE_COLUMN_LEFT';
const $7f8ee02f08da8eac$export$21847d308b0769ad = 'MOVE_COLUMN_RIGHT';
const $7f8ee02f08da8eac$export$c32913bc261af82d = 'MOVE_COLUMN_LAST';
const $7f8ee02f08da8eac$export$e2bd4c1faded7921 = '1px';
const $7f8ee02f08da8eac$export$cdb7fd9d999c7168 = 40;
const $7f8ee02f08da8eac$export$88e6c5bab2ff80e8 = 40;
const $7f8ee02f08da8eac$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $7f8ee02f08da8eac$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
const $7f8ee02f08da8eac$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';
const $7f8ee02f08da8eac$export$b4e9105b7f5f1b0f = '__issuetable_internal';
const $7f8ee02f08da8eac$export$3dbdc5c16825be4d = [
    $7f8ee02f08da8eac$export$c3266da279aa6b84,
    $7f8ee02f08da8eac$export$de4c02b525d877fa,
    $7f8ee02f08da8eac$export$66b2a4a5f67468ac
];
const $7f8ee02f08da8eac$export$a1c171a82c45d53f = 24;
const $7f8ee02f08da8eac$export$43ff8c492b8a2e1b = 24;
const $7f8ee02f08da8eac$export$9c5dd6078b37aac2 = 16;
const $7f8ee02f08da8eac$export$a8273d7d48e89fce = 24;
const $7f8ee02f08da8eac$export$7ec4af037f372df4 = 500;
const $7f8ee02f08da8eac$export$d2372dfbd4e91a11 = 50;
const $7f8ee02f08da8eac$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $7f8ee02f08da8eac$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $7f8ee02f08da8eac$export$c1d348661674e922 = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $7f8ee02f08da8eac$export$67082d449d5ec91 = 'com.atlassian.servicedesk:sd-request-feedback';
const $7f8ee02f08da8eac$export$145a4a20f394acf9 = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $7f8ee02f08da8eac$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $7f8ee02f08da8eac$export$10016003aa27fa67 = 40; // 2 x 8px cell padding + 24px icon size
const $7f8ee02f08da8eac$export$5575b9e0ed3ff59f = 69; // 2 x 8px cell padding + 2 x 24px icon size + 4px gap + 1px border
const $7f8ee02f08da8eac$export$7c3f559e2ca95fa = 170;
const $7f8ee02f08da8eac$export$e1a42c2fefb5af25 = 999;
const $7f8ee02f08da8eac$export$a194aa0e243a27f9 = 148;
const $7f8ee02f08da8eac$export$87a3548b97ce2540 = 136;
const $7f8ee02f08da8eac$export$4fd6711c21931f5b = 110;
const $7f8ee02f08da8eac$export$9b72110b9a7c0a39 = 102;
const $7f8ee02f08da8eac$export$54c15048528650a8 = 84;
const $7f8ee02f08da8eac$export$bfe09a9186b98f8f = 400;
const $7f8ee02f08da8eac$export$f2540f34b796306d = 300;
const $7f8ee02f08da8eac$export$954afb0fcf5a326 = 450;
const $7f8ee02f08da8eac$export$93758649595b2d58 = 'reorder';
const $7f8ee02f08da8eac$export$cad8c6a0b6e78898 = 'resize';
const $7f8ee02f08da8eac$export$5252387dc65db584 = -12;
const $7f8ee02f08da8eac$export$754b76ac8fa63350 = 'FULL_HEIGHT';
const $7f8ee02f08da8eac$export$fa5c7dad7ee16383 = 'HEADER_ONLY';
const $7f8ee02f08da8eac$export$4e8abe16cd1126dd = 'rowReorder';
const $7f8ee02f08da8eac$export$6c0a5a77457ca62 = 'COMPACT';
const $7f8ee02f08da8eac$export$119d8ab9a5bc4b2 = 'FULL';
const $7f8ee02f08da8eac$export$9ef77944c441ad07 = 'LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE';
const $7f8ee02f08da8eac$export$c1f680390b97c9e1 = 'LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE';
const $7f8ee02f08da8eac$export$e03155205bf92428 = 'loadChildItems';
const $7f8ee02f08da8eac$export$311c64c0d94dcdf3 = 'loadMoreChildItems';
const $7f8ee02f08da8eac$export$f5d215df3c6473e9 = 'loadGroupChildren';
const $7f8ee02f08da8eac$export$b4fd503bf7cccacd = 'loadMoreGroupedItems';
const $7f8ee02f08da8eac$export$70f80a241e016093 = 'createIssue';
const $7f8ee02f08da8eac$export$f7109619a5e9e0d6 = 'jira-native-issue-table';
const $7f8ee02f08da8eac$export$5eb61e3ff74a4f58 = 'make-child';
const $7f8ee02f08da8eac$export$9213b5774112217f = 'reorder-above';
const $7f8ee02f08da8eac$export$118b06a03e2c672f = 'reorder-below';
const $7f8ee02f08da8eac$export$5b388ccfa29be01 = -1;
const $7f8ee02f08da8eac$export$f6d7582f33b86010 = 'COLUMN_PICKER_CONFIGURATION_CONTAINER';
const $7f8ee02f08da8eac$export$f92486d03c064eac = 'COLUMN_PICKER_ADD_COLUMN_CONTAINER';
const $7f8ee02f08da8eac$export$139bffb2a576e8c0 = 2;
const $7f8ee02f08da8eac$export$3b696b0ac06c2cc4 = 1;
const $7f8ee02f08da8eac$export$6ba5aaedfd1b5319 = 2000;

});

parcelRegister("t3Q07", function(module, exports) {

$parcel$export(module.exports, "getAliasesForField", () => $a3816529ae558e1d$export$94d69942fbe58a01);
const $a3816529ae558e1d$export$94d69942fbe58a01 = (field, fieldToJqlTermMap)=>{
    // provided field could be a field id, name, an alias, or a jql term
    let term = fieldToJqlTermMap.get(field);
    if (term === undefined) {
        // it may be a jql term itself
        // filter is still an experiment feature in Iterator so we do old school looping
        for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === field) {
            term = keyValuePair[1];
            break;
        }
    }
    if (term === undefined) return [];
    // we do a reverse look-up to find any other keys of this jql term, they can all be used in a jql
    const set = new Set();
    set.add(term);
    for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === term) set.add(keyValuePair[0]);
    return Array.from(set);
};

});

parcelRegister("796ok", function(module, exports) {

$parcel$export(module.exports, "getJqlTermForField", () => $ad837b869bddcad8$export$ef4e8b2c9bc7bd4d);

var $bCU3R = parcelRequire("bCU3R");
const $ad837b869bddcad8$export$ef4e8b2c9bc7bd4d = (field, fieldToJqlTermMap)=>{
    const convertedField = (0, $bCU3R.convertFieldToJqlTerm)(field);
    const jqlTermForField = fieldToJqlTermMap.get(convertedField) ?? convertedField;
    return jqlTermForField;
};

});
parcelRegister("bCU3R", function(module, exports) {

$parcel$export(module.exports, "convertFieldToJqlTerm", () => $1e1011370a3a12e2$export$29f734dc2c61ea9d);
const $1e1011370a3a12e2$export$29f734dc2c61ea9d = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    // fieldName match regex for customfield_<number> exactly
    // legacy gadget may have it stored as customfield_<number> in user prefs
    if (/^customfield_\d+$/.test(fieldName)) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    return fieldName;
};

});


parcelRegister("4UHoK", function(module, exports) {

let $393e0e5736ab7a3f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $393e0e5736ab7a3f$var$load("dsheJ").then(()=>parcelRequire('aWG9Z'));

});

parcelRegister("5bqk6", function(module, exports) {

let $3c6266137f199656$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3c6266137f199656$var$load("1OMFw").then(()=>parcelRequire('eWn4R'));

});

parcelRegister("fZ9VJ", function(module, exports) {

let $ba34416cafb90726$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ba34416cafb90726$var$load("kK5xY").then(()=>parcelRequire('ajrrh'));

});



parcelRegister("jyMtv", function(module, exports) {

$parcel$export(module.exports, "transformToValidUserPrefs", () => $8cfaebab7e294873$export$e9345b021afd3cc3);

var $hwva3 = parcelRequire("hwva3");

var $Z4X9T = parcelRequire("Z4X9T");

var $hCluT = parcelRequire("hCluT");
const $8cfaebab7e294873$export$e9345b021afd3cc3 = (rawUserPrefs)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const pageSize = parseInt(rawUserPrefs.num, 10);
    const fieldSetIds = (0, $hwva3.convertUserPrefsToColumnNames)(rawUserPrefs.columnNames);
    const stringifiedFilterId = `${rawUserPrefs.filterId}`;
    const { sortDirection: sortDirection, sortField: sortField } = (0, $Z4X9T.getSortFieldAndDirection)(rawUserPrefs.sortBy);
    const showResolved = !!rawUserPrefs.showResolved;
    return {
        filterId: (0, $hCluT.isFilterId)(stringifiedFilterId) ? stringifiedFilterId : undefined,
        columnNames: fieldSetIds,
        num: !Number.isNaN(pageSize) ? pageSize : 10,
        sortDirection: sortDirection,
        sortField: sortField,
        showResolved: showResolved
    };
};

});
parcelRegister("hwva3", function(module, exports) {

$parcel$export(module.exports, "convertUserPrefsToColumnNames", () => $ffa5f3be2fc11704$export$6e5cdc232ebb20cf);

var $JIPqS = parcelRequire("JIPqS");

const $ffa5f3be2fc11704$export$6e5cdc232ebb20cf = (columns)=>typeof columns === 'string' && columns !== '' && columns !== '--Default--' ? columns.split((0, $e997f85ca70fa8bf$export$a3d4af30107c4f4d)).map((col)=>col.replaceAll((0, $e997f85ca70fa8bf$export$952287cc7aef3a4c), (0, $e997f85ca70fa8bf$export$a3d4af30107c4f4d))) : (0, $JIPqS.ISSUE_SEARCH_DEFAULT_COLUMNS);

});
const $e997f85ca70fa8bf$export$dd03181e30c7d559 = 5;
const $e997f85ca70fa8bf$export$a3d4af30107c4f4d = '|';
const $e997f85ca70fa8bf$export$952287cc7aef3a4c = '%7C';


parcelRegister("Z4X9T", function(module, exports) {

$parcel$export(module.exports, "getSortFieldAndDirection", () => $834bd6f85e4a1e0d$export$e535bb2dfaa4d10b);
const $834bd6f85e4a1e0d$export$e535bb2dfaa4d10b = (sortByFromUserPrefs)=>{
    const [sortField, sortDirection] = typeof sortByFromUserPrefs === 'string' ? sortByFromUserPrefs.split(':') : [];
    if (!sortField || sortDirection !== 'ASC' && sortDirection !== 'DESC') return {};
    return {
        sortField: sortField,
        sortDirection: sortDirection
    };
};

});

parcelRegister("hCluT", function(module, exports) {

$parcel$export(module.exports, "isFilterId", () => $39fbd6b125bd3cbf$export$23be85030bd58047);
// this is copied from NIN https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/issue-navigator/actions/common/src/utils/filters/index.tsx?at=abdc1df97c8cee2475285ab25c47a938ce99d65a
const $39fbd6b125bd3cbf$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);

});




parcelRegister("26UOd", function(module, exports) {

$parcel$export(module.exports, "REACT_KEY", () => $c373d1a6bf5d7ef6$export$e0e89108956f58f6);
// React gadget keys
const $c373d1a6bf5d7ef6$export$c8ae0b83405368ed = 'react/filter-results';
const $c373d1a6bf5d7ef6$var$REACT_KEY_ASSIGNED_TO_ME = 'react/assigned-to-me';
const $c373d1a6bf5d7ef6$var$REACT_KEY_ISSUES_IN_PROGRESS = 'react/issues-in-progress';
const $c373d1a6bf5d7ef6$var$REACT_KEY_VOTED_ISSUES = 'react/voted-issues';
const $c373d1a6bf5d7ef6$var$REACT_KEY_WATCHED_ISSUES = 'react/watched-issues';
const $c373d1a6bf5d7ef6$var$REACT_KEY_CUSTOM_REPORT = 'react/custom-report';
const $c373d1a6bf5d7ef6$export$e0e89108956f58f6 = {
    FILTER_RESULTS: $c373d1a6bf5d7ef6$export$c8ae0b83405368ed,
    ASSIGNED_TO_ME: $c373d1a6bf5d7ef6$var$REACT_KEY_ASSIGNED_TO_ME,
    ISSUES_IN_PROGRESS: $c373d1a6bf5d7ef6$var$REACT_KEY_ISSUES_IN_PROGRESS,
    VOTED_ISSUES: $c373d1a6bf5d7ef6$var$REACT_KEY_VOTED_ISSUES,
    WATCHED_ISSUES: $c373d1a6bf5d7ef6$var$REACT_KEY_WATCHED_ISSUES,
    CUSTOM_REPORT: $c373d1a6bf5d7ef6$var$REACT_KEY_CUSTOM_REPORT
};

});




parcelRegister("aVFmC", function(module, exports) {

$parcel$export(module.exports, "default", () => $31463ce0406b73cb$export$2e2bcd8739ae039);

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$31463ce0406b73cb$export$2e2bcd8739ae039 = async ()=>(0, $eusud.performGetRequest)('/rest/config/1.0/directoryitems.json');

});

parcelRegister("3Zhqx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1c788e303134293$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $5IKQ6 = parcelRequire("5IKQ6");

var $kspzT = parcelRequire("kspzT");

var $3Yd87 = parcelRequire("3Yd87");

var $kGR9w = parcelRequire("kGR9w");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b1c788e303134293$export$2e2bcd8739ae039 = (maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch }, spaContext)=>{
        if (!sharedValue || sharedValue instanceof Error) throw new (0, $3Yd87.SharedValueAggregateError)({
            sharedValue: sharedValue,
            isPrefetch: isPrefetch,
            name: 'AMD modules resource'
        });
        return (async ()=>{
            const { reactGadgets: nextGadgets } = sharedValue;
            const prev = maybePrevData != null && !(maybePrevData instanceof Error) && maybePrevData.reactGadgetsState || {};
            const persistedGadgets = nextGadgets.filter(({ id: id })=>!!prev[id]);
            const gadgetsToLoad = nextGadgets.filter((gadget)=>{
                // componentEdit will be optional in the future, although currently types say that it's required
                const isConfigurable = !!(0, $kspzT.default)[gadget.reactKey].componentEdit;
                const isUnconfigured = isConfigurable && !(0, $5IKQ6.isGadgetConfigured)(gadget.userPrefs);
                return !prev[gadget.id] && !isUnconfigured;
            });
            const skippedGadgets = nextGadgets.filter((gadget)=>!prev[gadget.id] && !gadgetsToLoad.some(({ id: id })=>id === gadget.id));
            const reactGadgetsState = {
                ...Object.fromEntries(persistedGadgets.map(({ id: id })=>[
                        id,
                        prev[id]
                    ])),
                ...Object.fromEntries(skippedGadgets.map(({ id: id })=>[
                        id,
                        {}
                    ])),
                ...await (0, $kGR9w.loadReactGadgets)(gadgetsToLoad, spaContext)
            };
            return {
                sharedValue: sharedValue,
                reactGadgetsState: reactGadgetsState
            };
        })();
    };

});
parcelRegister("5IKQ6", function(module, exports) {

$parcel$export(module.exports, "isGadgetConfigured", () => $ce7e823be599a5b0$export$b625fae487818738);
const $ce7e823be599a5b0$export$b625fae487818738 = (userPrefs)=>userPrefs?.fields.some(({ name: name, value: value })=>name === 'isConfigured' && value === 'true') ?? false;

});

parcelRegister("kGR9w", function(module, exports) {

$parcel$export(module.exports, "loadReactGadgets", () => $ae0204181dcaff49$export$7e1a3455761184a2);
// eslint-disable-next-line jira/import-whitelist

var $kspzT = parcelRequire("kspzT");
const $ae0204181dcaff49$var$preloadGadgetBundles = (reactKeys)=>reactKeys.forEach((reactKey)=>{
        (0, $kspzT.default)[reactKey].preload();
    });
const $ae0204181dcaff49$export$7e1a3455761184a2 = async (gadgets, spaContext)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const distinctReactKeys = [
        ...new Set(gadgets.map((gadget)=>gadget.reactKey))
    ];
    $ae0204181dcaff49$var$preloadGadgetBundles(distinctReactKeys);
    return Object.fromEntries(await Promise.all(gadgets.map(({ id: id, reactKey: reactKey, userPrefs: userPrefs })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $kspzT.default)[reactKey]?.getInitialState(spaContext, userPrefs?.fields || []).then((state)=>[
                id,
                state
            ], (error)=>[
                id,
                error
            ]))));
};

});



parcelRegister("gCJaT", function(module, exports) {

$parcel$export(module.exports, "dashboardEditRoute", () => $28f71741a95efd1f$export$b6e00d2cd7369fbd);
const $28f71741a95efd1f$export$b6e00d2cd7369fbd = {
    name: 'dashboard-edit',
    path: '/jira/dashboards/:dashboardId(\\d+)/edit',
    query: [
        'maximized?'
    ],
    exact: true
};

});

parcelRegister("h4rc7", function(module, exports) {

$parcel$export(module.exports, "nav4DashboardsContentEntryPoint", () => $3f7d81973c7cae41$export$d6e6956d3748383b);

var $fTvGY = parcelRequire("fTvGY");

var $cfawy = parcelRequire("cfawy");

var $3rdd7 = parcelRequire("3rdd7");

const $3f7d81973c7cae41$export$d6e6956d3748383b = (0, $3rdd7.createEntryPoint)({
    root: (0, $cfawy.JSResourceForUserVisible)(()=>(parcelRequire("b4Mgq")).then(({ DashboardsContentViewQuery: DashboardsContentViewQuery })=>DashboardsContentViewQuery), {
        moduleId: "d524dcfe",
        moduleName: "DashboardsContentViewQuery"
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId || '';
        return {
            queries: {
                queryRef: {
                    parameters: $fTvGY.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("fTvGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb948c176bb6527e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6793555e2dbfaf8db2fe4c7edd9d81f4>>
 * @relayHash 9a58486151638f4e45660f746394b248
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 187971dfb7440b89eb5a98f67e766ec91b921dc8dd450612125a7211123e347d
const $cb948c176bb6527e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "187971dfb7440b89eb5a98f67e766ec91b921dc8dd450612125a7211123e347d",
        "metadata": {},
        "name": "DashboardsContentViewQuery",
        "operationKind": "query",
        "text": null
    }
};
var $cb948c176bb6527e$export$2e2bcd8739ae039 = $cb948c176bb6527e$var$node;

});

parcelRegister("b4Mgq", function(module, exports) {

let $810581a174a054ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = $810581a174a054ec$var$load("1A69V").then(()=>parcelRequire('gSGR3'));

});


parcelRegister("irlpm", function(module, exports) {

$parcel$export(module.exports, "dashboardEditEntryPoint", () => $c73267a50536209c$export$eb39305ec6fcebf1);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $c73267a50536209c$export$eb39305ec6fcebf1 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("lv1Fp")), {
        moduleId: "4d5a5b34"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("lv1Fp", function(module, exports) {

let $fa6dc93c5355c485$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fa6dc93c5355c485$var$load("9VuHS").then(()=>parcelRequire('7AfLj'));

});


parcelRegister("fT58V", function(module, exports) {

$parcel$export(module.exports, "nav4SidebarContentCoreEntryPoint", () => $b83318e39ccb6f4a$export$c5a39ebd1638fa7);

var $2OeZv = parcelRequire("2OeZv");

var $cfawy = parcelRequire("cfawy");

var $3rdd7 = parcelRequire("3rdd7");

const $b83318e39ccb6f4a$export$c5a39ebd1638fa7 = (0, $3rdd7.createEntryPoint)({
    // sidebar is critical to rendering the initial view of a page
    root: (0, $cfawy.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("gyZtn"))).then(({ SidebarContentForEntryPoint: SidebarContentForEntryPoint })=>SidebarContentForEntryPoint), {
        moduleId: "4c2c284d"
    }),
    // Result matches the generics of the async component's EntryPointProps
    // except for TComponentProps which is derived from `root`
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getPreloadProps (params) {
        const { context: context, tenantContext: tenantContext, entryPoints: entryPoints = {}, isAppsExpanded: isAppsExpanded, isFiltersExpanded: isFiltersExpanded, isPlansExpanded: isPlansExpanded, isProjectsExpanded: isProjectsExpanded, isOperationsExpanded: isOperationsExpanded, isOverviewsExpanded: isOverviewsExpanded } = params;
        // The two parameters have been injected by the theme setter, and should
        // not be here. Setting them naively just to be able to use the sidebar entryPoint again.
        const projectAri = '';
        const projectKey = context.match.params.projectKey || '';
        return {
            // Queries your async component uses
            queries: {
                nav4SidebarContentCore: {
                    // generated .graphql
                    parameters: (0, $2OeZv.default),
                    // variables for your query
                    variables: {
                        cloudId: tenantContext.cloudId,
                        isAppsExpanded: isAppsExpanded,
                        isFiltersExpanded: isFiltersExpanded,
                        isPlansExpanded: isPlansExpanded,
                        isProjectsExpanded: isProjectsExpanded,
                        isOperationsExpanded: isOperationsExpanded,
                        isOverviewsExpanded: isOverviewsExpanded,
                        projectAri: projectAri,
                        projectKey: projectKey,
                        entityAriProjects: `ari:cloud:jira:${tenantContext.cloudId}:navigation-settings/activation/${tenantContext.activationId}/projects`,
                        ownerAri: tenantContext.atlassianAccountId && `ari:cloud:identity::user/${tenantContext.atlassianAccountId}`
                    },
                    // fetch options
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            },
            entryPoints: entryPoints
        };
    }
});

});
parcelRegister("gyZtn", function(module, exports) {

$parcel$export(module.exports, "SidebarContent", () => $b739c7529929160b$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "SidebarContentForEntryPoint", () => $b739c7529929160b$export$ece6bd06aa8b2350);

var $5uXOq = parcelRequire("5uXOq");

var $7GXsr = parcelRequire("7GXsr");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $2fwuR = parcelRequire("2fwuR");

var $46Cti = parcelRequire("46Cti");

var $cKjfv = parcelRequire("cKjfv");

var $dUyqZ = parcelRequire("dUyqZ");

var $lfTZh = parcelRequire("lfTZh");

var $ao2h1 = parcelRequire("ao2h1");

var $cZpsT = parcelRequire("cZpsT");

var $l8ruj = parcelRequire("l8ruj");

var $g9c75 = parcelRequire("g9c75");

var $ctUNb = parcelRequire("ctUNb");

var $4IIGx = parcelRequire("4IIGx");

var $doZTA = parcelRequire("doZTA");

var $1zjdl = parcelRequire("1zjdl");

var $2TuwK = parcelRequire("2TuwK");
const $b739c7529929160b$export$49e8f7b58a4df4ea = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $2fwuR.sidebarNav4Resource));
    const queryReferenceRef = (0, $5uXOq.useRef)(null);
    if (isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b739c7529929160b$export$57e04c8c2365ae3b, null);
    // We don't want to use null query references. So only remember the non-null ones,
    // and pass the non-null query reference to the children.
    // From Slack: https://atlassian.slack.com/archives/C01E2MPPLE4/p1654736794416059?thread_ts=1654051102.548519&cid=C01E2MPPLE4
    if (queryReference) queryReferenceRef.current = queryReference;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b739c7529929160b$export$a18798f247d81ed3, {
        queryReference: queryReferenceRef.current
    });
};
function $b739c7529929160b$export$ece6bd06aa8b2350({ queries: { nav4SidebarContentCore: nav4SidebarContentCore } }) {
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    if (isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b739c7529929160b$export$57e04c8c2365ae3b, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b739c7529929160b$export$a18798f247d81ed3, {
        queryReference: nav4SidebarContentCore
    });
}
function $b739c7529929160b$export$a18798f247d81ed3({ queryReference: queryReference }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "l1-nav-menu-items",
        packageName: (0, $1zjdl.PACKAGE_NAME),
        teamName: (0, $1zjdl.TEAM_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g9c75.SideNavContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "l1-nav-menu-items",
        fallback: null
    }, queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2TuwK.L1MenuItems), {
        queryReference: queryReference
    })))), (0, $4R6GH.fg)('blu-2735_nav4_onboarding') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7GXsr.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cKjfv.SidebarReady), null)));
}
function $b739c7529929160b$export$57e04c8c2365ae3b() {
    const { formattedMessage: projectsMessage, icon: projectsIcon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).PROJECTS);
    const { formattedMessage: dashboardsMessage, icon: dashboardsIcon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).DASHBOARDS);
    const { formattedMessage: filtersMessage, icon: filtersIcon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).FILTERS);
    // We want to remove useRouter but the anonymous path is not as urgent as the authenticated path
    const [{ match: match }] = (0, $doZTA.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "l1-nav-menu-items",
        packageName: (0, $1zjdl.PACKAGE_NAME),
        teamName: (0, $1zjdl.TEAM_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g9c75.SideNavContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "l1-nav-menu-items",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctUNb.MenuLinkItem), {
        elemBefore: projectsIcon,
        href: "/jira/projects",
        isSelected: match.path.startsWith('/jira/projects')
    }, projectsMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctUNb.MenuLinkItem), {
        elemBefore: filtersIcon,
        href: "/jira/filters",
        isSelected: match.path === '/jira/filters' || match.path.startsWith('/issues/')
    }, filtersMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctUNb.MenuLinkItem), {
        elemBefore: dashboardsIcon,
        href: "/jira/dashboards",
        isSelected: match.path.startsWith('/jira/dashboards')
    }, dashboardsMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cKjfv.SidebarReady), null));
}

});
parcelRegister("7GXsr", function(module, exports) {

$parcel$export(module.exports, "default", () => $485ad0479413a47e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kkd2O = parcelRequire("kkd2O");

var $7CMCs = parcelRequire("7CMCs");

var $b7Svb = parcelRequire("b7Svb");

var $lfTZh = parcelRequire("lfTZh");

var $4R6GH = parcelRequire("4R6GH");

const $485ad0479413a47e$var$LazyAtlassianOnboardingNav4 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("cDOuy")).then(({ Nav4Onboarding: Nav4Onboarding })=>Nav4Onboarding), {
    moduleId: "./src/packages/navigation-apps/onboarding-nav4/src/index.tsx"
});
const $485ad0479413a47e$var$AsyncAtlassianOnboardingNav4 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    if ((0, $4R6GH.fg)('jfp-magma-fix-misaligned-suspense-boundaries')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncAtlassianOnboardingNav4",
        packageName: "jiraAtlassianOnboardingNav4",
        teamName: "jira-cosmos",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazyAtlassianOnboardingNav4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($485ad0479413a47e$var$LazyAtlassianOnboardingNav4, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncAtlassianOnboardingNav4",
        packageName: "jiraAtlassianOnboardingNav4",
        teamName: "jira-cosmos",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkd2O.default), {
        name: "lazyAtlassianOnboardingNav4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($485ad0479413a47e$var$LazyAtlassianOnboardingNav4, null)));
});
$485ad0479413a47e$var$AsyncAtlassianOnboardingNav4.displayName = 'AsyncAtlassianOnboardingNav4';
var $485ad0479413a47e$export$2e2bcd8739ae039 = $485ad0479413a47e$var$AsyncAtlassianOnboardingNav4;

});
parcelRegister("cDOuy", function(module, exports) {

let $93404b2cd59dc085$var$load = (parcelRequire("28QjX"))(4);
module.exports = $93404b2cd59dc085$var$load("gl0SS").then(()=>parcelRequire('1UJgx'));

});


parcelRegister("46Cti", function(module, exports) {

$parcel$export(module.exports, "L1_MENU_ID", () => $2d5b83df0b5ff159$export$918aea3cf024d90b);

var $jhS4y = parcelRequire("jhS4y");
const $2d5b83df0b5ff159$var$OPERATIONS_MENU_ID = {
    OPERATIONS_ALERT_SAVED_SEARCH_SHARED_WITH_ME: 'jira.sidebar.operations.alert.savedSearches.sharedWithMe',
    OPERATIONS_ALERT_SAVED_SEARCH_CREATED_BY_ME: 'jira.sidebar.operations.alert.savedSearches.createdByMe'
};
const $2d5b83df0b5ff159$export$bb47524d7f3cb1f8 = {
    ...(0, $jhS4y.CONFIGURABLE_MENU_ID),
    BOARDS: 'jira.sidebar.boards',
    QUEUES: 'jira.sidebar.queues',
    ALL: 'jira.sidebar.all'
};
const $2d5b83df0b5ff159$export$918aea3cf024d90b = {
    YOUR_WORK: 'jira.sidebar.yourWork',
    ...(0, $jhS4y.CONFIGURABLE_MENU_ID),
    ...$2d5b83df0b5ff159$var$OPERATIONS_MENU_ID
};

});

parcelRegister("cKjfv", function(module, exports) {

$parcel$export(module.exports, "useSidebarExperience", () => $c4243e40cbbf3b86$export$d4fa533dfe4d7583);
$parcel$export(module.exports, "SidebarStart", () => $c4243e40cbbf3b86$export$6738d1299dc79710);
$parcel$export(module.exports, "SidebarReady", () => $c4243e40cbbf3b86$export$a06ecbbe5820282);

var $5uXOq = parcelRequire("5uXOq");

var $eyWK5 = parcelRequire("eyWK5");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $6IzHB = parcelRequire("6IzHB");

var $92h6i = parcelRequire("92h6i");
const $c4243e40cbbf3b86$export$d4fa533dfe4d7583 = ()=>{
    const pageId = (0, $6IzHB.usePageId)();
    return (0, $5uXOq.useMemo)(()=>({
            experience: 'viewSidebarNavigation',
            experienceId: pageId,
            analyticsSource: 'Sidebar',
            attributes: {
                sidebar: 'v4'
            }
        }), [
        pageId
    ]);
};
const $c4243e40cbbf3b86$export$6738d1299dc79710 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const { experience: experience, experienceId: experienceId, analyticsSource: analyticsSource } = $c4243e40cbbf3b86$export$d4fa533dfe4d7583();
    const onStartExperience = (0, $kaHBi.useExperienceStart)({
        experience: experience,
        experienceId: experienceId,
        analyticsSource: analyticsSource
    });
    (0, $5uXOq.useEffect)(()=>{
        if (route.isRedirect) return;
        onStartExperience();
    }, [
        onStartExperience,
        route
    ]);
    return null;
};
const $c4243e40cbbf3b86$export$a06ecbbe5820282 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const { experience: experience, attributes: attributes } = $c4243e40cbbf3b86$export$d4fa533dfe4d7583();
    const onSuccessfulExperience = (0, $3bQtK.useExperienceSuccess)({
        experience: experience,
        attributes: attributes
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const doNotRunEffects = route.isRedirect || false;
    const sidebarId = route.navigation?.sidebarId ?? 'default';
    (0, $92h6i.useEffectWithoutConcurrency)(()=>{
        if (doNotRunEffects) return;
        const event = createAnalyticsEvent({
            action: 'ready',
            actionSubject: 'sidebar',
            meta: {
                teamName: 'endeavour'
            }
        });
        (0, $8zOmE.fireUIAnalytics)(event, 'Sidebar Ready', {
            route: routeName
        });
    }, [
        createAnalyticsEvent,
        doNotRunEffects,
        routeName
    ]);
    (0, $92h6i.useEffectWithoutConcurrency)(()=>{
        if (doNotRunEffects) return;
        onSuccessfulExperience();
    }, [
        doNotRunEffects,
        onSuccessfulExperience,
        route
    ]);
    const customData = (0, $5uXOq.useMemo)(()=>({
            sidebarType: sidebarId
        }), [
        sidebarId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyWK5.default), {
        data: customData
    });
};

});
parcelRegister("92h6i", function(module, exports) {

$parcel$export(module.exports, "useEffectWithoutConcurrency", () => $f224f3606a6cd92d$export$e44126cd87ea434);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $3joPi = parcelRequire("3joPi");
function $f224f3606a6cd92d$export$e44126cd87ea434(effect, dependencies) {
    const effectCalledRef = (0, $5uXOq.useRef)(false);
    const depsRef = (0, $5uXOq.useRef)(dependencies);
    (0, $5uXOq.useEffect)(()=>{
        // If the dependencies have changed, reset the state of the ref.
        // This is how we catch the strict-mode execution.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(depsRef.current, dependencies)) {
            depsRef.current = dependencies;
            effectCalledRef.current = false;
        }
        // If the effect has already executed, we shouldn't be executing again unless we do a cleanup first.
        // This is the code that ignores the strict-mode update
        if (effectCalledRef.current) return;
        // Set this immediately
        effectCalledRef.current = true;
        const cleanup = effect();
        // If we do get a cleanup function, throw an error
        (0, $3joPi.default)(typeof cleanup !== 'function', 'useEffectWithoutConcurrency() cannot be used with cleanup functions');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}

});


parcelRegister("dUyqZ", function(module, exports) {

$parcel$export(module.exports, "useConfigurableMessageAndIconMap", () => $5654470bb2a53aff$export$783a136280b37c09);

var $4DrQd = parcelRequire("4DrQd");

var $24a2m = parcelRequire("24a2m");
const $5654470bb2a53aff$export$783a136280b37c09 = (menuId)=>{
    const { message: message, Icon: Icon } = (0, $4DrQd.CONFIGURABLE_MESSAGE_AND_ICON_MAP)[menuId];
    return (0, $24a2m.useFormattedMessageAndIcon)(message, Icon);
};

});
parcelRegister("4DrQd", function(module, exports) {

$parcel$export(module.exports, "MENU_GROUP_MIN_WIDTH", () => $e2413e530566d4f6$export$47f3715a07cde7e8);
$parcel$export(module.exports, "CONFIGURABLE_MENU_IDS_AS_STRINGS", () => $e2413e530566d4f6$export$f5a7bd7eb586e4e8);
$parcel$export(module.exports, "GLOBAL_APP_MENU_IDS_AS_STRINGS", () => $e2413e530566d4f6$export$de634ec0f98ab74b);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP", () => $e2413e530566d4f6$export$6a976dc7193b8a18);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_AND_ICON_MAP", () => $e2413e530566d4f6$export$5034ad0032cd499d);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_STRING", () => $e2413e530566d4f6$export$b66ae8c18ec95bc6);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_STRING", () => $e2413e530566d4f6$export$da92a6698d96e3f2);
$parcel$export(module.exports, "LEFT_SIDEBAR_EXPANDED_MIN_WIDTH", () => $e2413e530566d4f6$export$9fcc53f3b36e0949);
$parcel$export(module.exports, "IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT", () => $e2413e530566d4f6$export$2eb8dda9e83d33ff);
$parcel$export(module.exports, "NAV4_OPT_OUT_FEEDBACK_GROUP_ID", () => $e2413e530566d4f6$export$9cf873ba2e9a3ce0);
$parcel$export(module.exports, "NAV4_GENERAL_FEEDBACK_GROUP_ID", () => $e2413e530566d4f6$export$a495ba70b16d4d90);
$parcel$export(module.exports, "NO_OF_BOARDS_TO_SHOW", () => $e2413e530566d4f6$export$89de709e88232646);

var $dDsAl = parcelRequire("dDsAl");

var $6YfOV = parcelRequire("6YfOV");

var $7uikU = parcelRequire("7uikU");

var $5purl = parcelRequire("5purl");

var $gdqFV = parcelRequire("gdqFV");

var $2tGrM = parcelRequire("2tGrM");

var $3pK7p = parcelRequire("3pK7p");

var $dncoP = parcelRequire("dncoP");

var $15tSY = parcelRequire("15tSY");

var $hkaoh = parcelRequire("hkaoh");

var $7PkLr = parcelRequire("7PkLr");

var $aCAjf = parcelRequire("aCAjf");

var $fkyxu = parcelRequire("fkyxu");

var $3kZDu = parcelRequire("3kZDu");

var $l1s8i = parcelRequire("l1s8i");

var $bqwqE = parcelRequire("bqwqE");

var $ab1Yt = parcelRequire("ab1Yt");

var $g95pD = parcelRequire("g95pD");

var $jhS4y = parcelRequire("jhS4y");

var $6x874 = parcelRequire("6x874");

var $ih7ba = parcelRequire("ih7ba");

var $46Cti = parcelRequire("46Cti");
const $e2413e530566d4f6$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Common';
const $e2413e530566d4f6$export$d57b6b390e78d90f = 'jira-cosmos';
const $e2413e530566d4f6$export$47f3715a07cde7e8 = 250;
const $e2413e530566d4f6$export$421b92818c76ee2d = Object.values((0, $jhS4y.CONFIGURABLE_MENU_ID));
const $e2413e530566d4f6$export$f5a7bd7eb586e4e8 = $e2413e530566d4f6$export$421b92818c76ee2d;
const $e2413e530566d4f6$export$c52c93cc28495ab0 = Object.values((0, $jhS4y.GLOBAL_APP_MENU_ID));
const $e2413e530566d4f6$export$de634ec0f98ab74b = $e2413e530566d4f6$export$c52c93cc28495ab0;
const $e2413e530566d4f6$export$6a976dc7193b8a18 = {
    [(0, $46Cti.L1_MENU_ID).APPS]: {
        message: (0, $ih7ba.default).apps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YfOV)))
    },
    [(0, $46Cti.L1_MENU_ID).GOALS]: {
        message: (0, $ih7ba.default).goals,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dncoP)))
    },
    [(0, $46Cti.L1_MENU_ID).ROADMAPS]: {
        message: (0, $ih7ba.default).roadmaps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dDsAl)))
    },
    [(0, $46Cti.L1_MENU_ID).PLANS]: {
        message: (0, $ih7ba.default).plans,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aCAjf)))
    },
    [(0, $46Cti.L1_MENU_ID).PROJECTS]: {
        message: (0, $ih7ba.default).projects,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7PkLr)))
    },
    [(0, $46Cti.L1_MENU_ID).FILTERS]: {
        message: (0, $ih7ba.default).filters,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2tGrM)))
    },
    [(0, $46Cti.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $ih7ba.default).dashboards,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gdqFV)))
    },
    [(0, $46Cti.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $ih7ba.default).overviews,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3pK7p)))
    },
    [(0, $46Cti.L1_MENU_ID).OPERATIONS]: {
        message: (0, $ih7ba.default).operations,
        Icon: (0, $6x874.default)
    },
    [(0, $46Cti.L1_MENU_ID).ASSETS]: {
        message: (0, $ih7ba.default).assets,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7uikU)))
    },
    [(0, $46Cti.L1_MENU_ID).TEAMS]: {
        message: (0, $ih7ba.default).teams,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3kZDu)))
    },
    [(0, $46Cti.L1_MENU_ID).RECENT]: {
        message: (0, $ih7ba.default).recent,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5purl)))
    },
    [(0, $46Cti.L1_MENU_ID).STARRED]: {
        message: (0, $ih7ba.default).starred,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fkyxu)))
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $ih7ba.default).customerService,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($15tSY)))
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_HUBS]: {
        message: (0, $ih7ba.default).customerHubs,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hkaoh)))
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $ih7ba.default).customerServiceAnalytics,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($g95pD)))
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $ih7ba.default).assets,
        Icon: (0, $bqwqE.AssetsIcon)
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $ih7ba.default).goals,
        Icon: (0, $ab1Yt.GoalsIcon)
    }
};
const $e2413e530566d4f6$export$5034ad0032cd499d = {
    message: (0, $ih7ba.default).forYou,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($l1s8i)))
};
const $e2413e530566d4f6$export$b66ae8c18ec95bc6 = {
    message: (0, $ih7ba.default).forYou.defaultMessage
};
const $e2413e530566d4f6$export$da92a6698d96e3f2 = {
    [(0, $46Cti.L1_MENU_ID).APPS]: {
        message: (0, $ih7ba.default).apps.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GOALS]: {
        message: (0, $ih7ba.default).goals.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).ROADMAPS]: {
        message: (0, $ih7ba.default).roadmaps.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).PLANS]: {
        message: (0, $ih7ba.default).plans.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).PROJECTS]: {
        message: (0, $ih7ba.default).projects.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).FILTERS]: {
        message: (0, $ih7ba.default).filters.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $ih7ba.default).dashboards.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $ih7ba.default).overviews.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).OPERATIONS]: {
        message: (0, $ih7ba.default).operations.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).ASSETS]: {
        message: (0, $ih7ba.default).assets.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).TEAMS]: {
        message: (0, $ih7ba.default).teams.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).RECENT]: {
        message: (0, $ih7ba.default).recent.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).STARRED]: {
        message: (0, $ih7ba.default).starred.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $ih7ba.default).customerService.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_HUBS]: {
        message: (0, $ih7ba.default).customerHubs.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $ih7ba.default).customerServiceAnalytics.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $ih7ba.default).assets.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $ih7ba.default).goals.defaultMessage
    }
};
const $e2413e530566d4f6$export$9fcc53f3b36e0949 = 240; // in pixels
const $e2413e530566d4f6$export$6621cd553335536a = 320; // in pixels
const $e2413e530566d4f6$export$2eb8dda9e83d33ff = false;
const $e2413e530566d4f6$export$b4b2658405615c86 = 'TEAM_MANAGED_PROJECT';
const $e2413e530566d4f6$export$2336313834642df = 'COMPANY_MANAGED_PROJECT';
const $e2413e530566d4f6$export$9cf873ba2e9a3ce0 = 'nav4-opt-out';
const $e2413e530566d4f6$export$a495ba70b16d4d90 = 'nav4-sidebar';
const $e2413e530566d4f6$export$89de709e88232646 = 25;

});
parcelRegister("6x874", function(module, exports) {

$parcel$export(module.exports, "default", () => $079d8146cc6d581f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hivz8 = parcelRequire("hivz8");

var $e7Klx = parcelRequire("e7Klx");

var $4R6GH = parcelRequire("4R6GH");
const $079d8146cc6d581f$var$OperationsIcon = ({ ...props })=>{
    if ((0, $4R6GH.fg)('nav4_operations_icon_update')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hivz8))), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e7Klx))), props);
};
var $079d8146cc6d581f$export$2e2bcd8739ae039 = $079d8146cc6d581f$var$OperationsIcon;

});

parcelRegister("ih7ba", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c16ecaa1449e546$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7c16ecaa1449e546$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projects: {
        "id": "navigation-apps-sidebar-nav4-common.common.projects",
        "defaultMessage": "Projects"
    },
    filters: {
        "id": "navigation-apps-sidebar-nav4-common.common.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "navigation-apps-sidebar-nav4-common.common.dashboards",
        "defaultMessage": "Dashboards"
    },
    overviews: {
        "id": "navigation-apps-sidebar-nav4-common.common.overviews",
        "defaultMessage": "Overviews"
    },
    teams: {
        "id": "navigation-apps-sidebar-nav4-common.common.teams",
        "defaultMessage": "Teams"
    },
    assets: {
        "id": "navigation-apps-sidebar-nav4-common.common.assets",
        "defaultMessage": "Assets"
    },
    plans: {
        "id": "navigation-apps-sidebar-nav4-common.common.plans",
        "defaultMessage": "Plans"
    },
    apps: {
        "id": "navigation-apps-sidebar-nav4-common.common.apps",
        "defaultMessage": "Apps"
    },
    operations: {
        "id": "navigation-apps-sidebar-nav4-common.common.operations",
        "defaultMessage": "Operations"
    },
    goals: {
        "id": "navigation-apps-sidebar-nav4-common.common.goals",
        "defaultMessage": "Goals"
    },
    recent: {
        "id": "navigation-apps-sidebar-nav4-common.common.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-common.common.starred",
        "defaultMessage": "Starred"
    },
    roadmaps: {
        "id": "navigation-apps-sidebar-nav4-common.common.roadmaps",
        "defaultMessage": "Roadmaps"
    },
    customerService: {
        "id": "navigation-apps-sidebar-nav4-common.common.customer-service",
        "defaultMessage": "Customer service"
    },
    customerHubs: {
        "id": "navigation-apps-sidebar-nav4-common.common.customer-hubs",
        "defaultMessage": "Customer hubs"
    },
    customerServiceAnalytics: {
        "id": "navigation-apps-sidebar-nav4-common.common.customerServiceAnalytics",
        "defaultMessage": "Insights"
    },
    forYou: {
        "id": "navigation-apps-sidebar-nav4-common.common.forYou",
        "defaultMessage": "For you"
    }
});

});


parcelRegister("24a2m", function(module, exports) {

$parcel$export(module.exports, "useFormattedMessageAndIcon", () => $a546a39b12f7f59a$export$efa1c7d3cd2d4f5c);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");
const $a546a39b12f7f59a$export$efa1c7d3cd2d4f5c = (message, Icon)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formattedMessage = formatMessage(message);
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        label: formattedMessage,
        spacing: "spacious",
        color: "currentColor"
    });
    return {
        formattedMessage: formattedMessage,
        icon: icon
    };
};

});


parcelRegister("cZpsT", function(module, exports) {

$parcel$export(module.exports, "useIsAnonymous", () => $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b);

var $9OXo1 = parcelRequire("9OXo1");
const $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});

parcelRegister("l8ruj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6056b4460d0127e0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $aatTc = parcelRequire("aatTc");

var $lAOer = parcelRequire("lAOer");

var $5tDD0 = parcelRequire("5tDD0");

var $5i16O = parcelRequire("5i16O");

var $4R6GH = parcelRequire("4R6GH");

var $c1haS = parcelRequire("c1haS");
/** A portion of the page we apply measurement to */ function $6056b4460d0127e0$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $aatTc.useInteractionContext)();
    const relayProfilerContext = (0, $5uXOq.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $5uXOq.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    this.getInteractionContext().addPreload((0, $lAOer.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $lAOer.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5i16O.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children));
}
function $6056b4460d0127e0$export$2e2bcd8739ae039({ name: segmentName, children: children, mode: mode = 'single' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5tDD0.default), {
        name: segmentName,
        mode: mode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6056b4460d0127e0$var$JiraUFOSegmentWrapper, null, children));
}

});

parcelRegister("g9c75", function(module, exports) {

$parcel$export(module.exports, "SideNavContent", () => $3db8f73fd27174f8$export$babe3c784778f3ba);
/* side-nav-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $3db8f73fd27174f8$export$babe3c784778f3ba = /*#__PURE__*/ (0, $5uXOq.forwardRef)($3db8f73fd27174f8$var$_SideNavContent);
// Placing this const below the function breaks Compiled!
const $3db8f73fd27174f8$var$styles = {
    scrollContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug",
    paddingContainer: "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
function $3db8f73fd27174f8$var$_SideNavContent({ children: children, testId: testId }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $3db8f73fd27174f8$var$styles.scrollContainer
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                $3db8f73fd27174f8$var$styles.paddingContainer
            ]),
            children: children
        })
    });
}

});

parcelRegister("ctUNb", function(module, exports) {

$parcel$export(module.exports, "MenuLinkItem", () => $4dbaf7d7c0a024c6$export$68ef190193a37bc2);
/* menu-link-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cD7p8 = parcelRequire("cD7p8");

var $aoFID = parcelRequire("aoFID");

var $92SLf = parcelRequire("92SLf");

var $kTSv9 = parcelRequire("kTSv9");

var $aJFme = parcelRequire("aJFme");
const $4dbaf7d7c0a024c6$var$listItemStyles = {
    root: "_10m98stt"
};
const $4dbaf7d7c0a024c6$var$MenuLinkItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef }, forwardedRef)=>{
    const itemRef = (0, $5uXOq.useRef)(null);
    (0, $aJFme.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $5uXOq.useMemo)(()=>{
        return (0, $cD7p8.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        listItemRef,
        itemRef
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $92SLf.ListItem), {
        ref: ref,
        xcss: $4dbaf7d7c0a024c6$var$listItemStyles.root,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kTSv9.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            children: children
        })
    });
};
const $4dbaf7d7c0a024c6$export$68ef190193a37bc2 = (0, $aoFID.forwardRefWithGeneric)($4dbaf7d7c0a024c6$var$MenuLinkItemNoRef);

});
parcelRegister("kTSv9", function(module, exports) {

$parcel$export(module.exports, "MenuItemBase", () => $2fda06f6df9236af$export$859b390bf71e044e);
/* menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $l0Vn1 = parcelRequire("l0Vn1");

var $cD7p8 = parcelRequire("cD7p8");

var $gHU1R = parcelRequire("gHU1R");
var $gVM6m = parcelRequire("gVM6m");
var $6eFvr = parcelRequire("6eFvr");

var $5KCCi = parcelRequire("5KCCi");
var $1Jlkv = parcelRequire("1Jlkv");

var $aoFID = parcelRequire("aoFID");


var $fOnXR = parcelRequire("fOnXR");

var $1Nq4x = parcelRequire("1Nq4x");

var $62Ekk = parcelRequire("62Ekk");
const $2fda06f6df9236af$var$tooltipStyles = {
    root: "_2rkoglpi _11c8dcr7 _1e0c1txw _2lx21bp4 _1bah1h6o _1tkezwfg _p12f1pna _vchhusvi _1q51v77o _y4ti12x7 _85i5v77o _bozg12x7 _bfhkcdhy _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _slp31hna"
};
const $2fda06f6df9236af$var$MenuItemTooltip = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function MenuItemTooltip({ children: children, className: className, ...rest }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Jlkv.default), {
        ...rest,
        // Manually passing on `className` so it gets merged correctly in the build output.
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $2fda06f6df9236af$var$tooltipStyles.root,
            className
        ]),
        // "css" does not "exist" - it gets transformed into "className" by compiled
        ref: ref,
        children: children
    });
});
function $2fda06f6df9236af$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const $2fda06f6df9236af$var$defaultAvatarValues = {
    size: 'small'
};
const $2fda06f6df9236af$var$elemAfterDisplayVar = '--elem-after-display';
const $2fda06f6df9236af$var$actionsOnHoverDisplayVar = '--actions-on-hover-display';
const $2fda06f6df9236af$var$notchColorVar = '--notch-color';
/**
 * ## 🤹 `position:relative`
 *
 * We need `position:relative` on an element that takes
 * up the full size of the interactive element so we
 * can correctly use `position:absolute` to place:
 * 1. the notch for links
 * 2. a child of button / anchor to stretch it out to
 *    increase it's pressable area.
 *
 * ⛔️ We cannot add `position:relative` _only_ on the
 * button / anchor as that will cause sibling elements
 * to be rendered under the button / anchor when setting
 * a background color on the button / anchor.
 *
 * 📖 Note: `position:relative` elements are painted after
 * elements with `position:static` (the default)
 * https://drafts.csswg.org/css-position-4/#painting-order
 *
 * ⛔️ We cannot add `position:relative` to the container
 * element, as then the `:focus` ring styles on the
 * button / anchor can be cut off by the next sibling if it has
 * has a background color set (eg when selected)
 *
 * ✅ Add `position:relative` to all first level descendants
 * of the container element so that we don't impact DOM ordered
 * paint ordering within the item and the button / anchor focus
 * ring can still bleed over siblings
 *
 * 📖 We could use `> * { position: relative; }` on the container,
 * but that would violate our styling standard.
 */ const $2fda06f6df9236af$var$topLevelSiblingStyles = {
    root: "_kqswh2mm"
};
/**
 * All slots on the menu item (eg `elemBefore`) are rendered as siblings
 * of our main button / anchor element and they are visually placed on
 * top of the main button / anchor.
 *
 * 📖 This is done so that we don't nest interactive elements in our markup.
 *
 * ✅ This is great when element in the slot is an interactive element
 * as we don't want the main menu item button / anchor to be triggered
 * when interacting with the element in the slot.
 *
 * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
 * prevent the main button / anchor (that is visually behind the element in
 * the slot) from being clicked. The element in the slot is a sibling of our
 * main button / anchor (not a child of it) so clicking on the element in the
 * slot will not bubble up to the button / anchor.
 *
 * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
 * element so that static content in a slot does not prevent clicking on the main
 * button / anchor.
 */ const $2fda06f6df9236af$var$onTopOfButtonOrAnchorStyles = {
    root: "_18ukglyw"
};
const $2fda06f6df9236af$export$91f7cd3f990d8a52 = '&:has([aria-expanded="true"][aria-haspopup="true"])';
const $2fda06f6df9236af$var$containerStyles = {
    root: "_2rkoglpi _vchhusvi _1e0c11p5 _yv0eaa4y _1ul9t9kd _4t3izwfg _4cvr1h6o _uiztglyw _syaz1gjq _ek6gglyw _1yyu3acm _91ju1txw _1swv108i _1ojv1txw _irr3108i _1brr1txw _109x1txw",
    removeElemAfter: "_91juglyw",
    showHoverActions: "_ek6g1txw",
    removeElemAfterOnHover: "_1mfcglyw _1sjuglyw",
    removeElemAfterOnHoverOrOpenNestedPopup: "_1djyglyw _1mfcglyw _1sjuglyw",
    selected: "_bfhkfg4m _syazaqb7 _1yyu1fvw _1swvi1yw _30l3aqb7 _irr3i1yw",
    disabled: "_syaz1lh4 _irr3n7od",
    hasDescription: "_4t3ickbl"
};
const $2fda06f6df9236af$var$buttonOrAnchorStyles = {
    root: "_2rkoglpi _yyhyjvu9 _1ii7kb7n _1e0c11p5 _yv0enbh3 _4t3i1osq _1q511b66 _y4ti1b66 _85i51b66 _bozg1b66 _bfhk18uv _syaz1gjq _4cvr1h6o _y3gnv2br",
    active: "_14iu1ji5",
    selected: "_syazaqb7 _1di619ru"
};
const $2fda06f6df9236af$var$extendButtonOrAnchorStyles = {
    root: "_1r04ze3t _kqswstnw"
};
const $2fda06f6df9236af$var$notchStyles = {
    root: "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
};
const $2fda06f6df9236af$var$actionStyles = {
    root: "_zulp1b66 _1reo15vq _18m915vq _1ii7kb7n _yyhyqfx8 _1e0c1txw _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const $2fda06f6df9236af$var$actionsOnHoverStyles = {
    root: "_zulp1b66 _1reo15vq _18m915vq _1ii7kb7n _yyhy11wp _1e0c1c3z _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const $2fda06f6df9236af$var$textStyles = {
    root: "_zulpv77o _1reo15vq _18m915vq _yyhycs5v _y4ti1b66 _bozg1b66 _1e0c1txw _2lx21bp4 _1ul91c9m _1guo18uv _12s918uv",
    noElemBeforeIndent: "_bozg12x7"
};
const $2fda06f6df9236af$var$elemBeforeStyles = {
    root: "_1reo15vq _18m915vq _yyhykb7n _1ii7kb7n _1e0c1txw _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _bozg1b66 _vchh18uv _1guo18uv _12s918uv"
};
const $2fda06f6df9236af$var$elemAfterStyles = {
    root: "_1reo15vq _18m915vq _yyhyegat _1ii7kb7n _1e0c13yo _1o9zidpf _4t3i1tcg _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
function $2fda06f6df9236af$var$getTextColor({ isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'color.text.disabled';
    if (isSelected) return 'color.text.selected';
    return 'color.text.subtle';
}
/**
 * This is the internal version of the component, to be passed into `forwardRef`.
 *
 * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
 * This can be inferred from the type of the `onClick` prop.
 */ const $2fda06f6df9236af$var$MenuItemBaseNoRef = ({ testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef }, forwardedRef)=>{
    const level = (0, $fOnXR.useLevel)();
    const setFlyoutMenuOpen = (0, $1Nq4x.useSetFlyoutMenuOpen)();
    const isFlyoutMenuOpen = (0, $1Nq4x.useFlyoutMenuOpen)();
    const isLink = typeof href !== 'undefined';
    const labelRef = (0, $5uXOq.useRef)(null);
    const descriptionRef = (0, $5uXOq.useRef)(null);
    const tooltipOnClick = (0, $5uXOq.useRef)(null);
    const handleClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        // Toggle flyout menu open state when inside a flyout context provider
        setFlyoutMenuOpen(!isFlyoutMenuOpen);
        tooltipOnClick.current?.(event);
    }, [
        onClick,
        setFlyoutMenuOpen,
        isFlyoutMenuOpen
    ]);
    /**
   * Show the tooltip if _either_ label or description is truncated
   */ const canTooltipAppear = (0, $5uXOq.useCallback)(()=>{
        if (isContentTooltipDisabled) return false;
        // Show tooltip if _either_ label or description are clamped
        const label = labelRef.current;
        const description = descriptionRef.current;
        if (label && $2fda06f6df9236af$var$isTextClamped(label)) return true;
        return Boolean(description && $2fda06f6df9236af$var$isTextClamped(description));
    }, [
        isContentTooltipDisabled
    ]);
    // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    const showElemBefore = elemBefore !== (0, $62Ekk.COLLAPSE_ELEM_BEFORE);
    const interactiveElemContent = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                // This extends the clickable area of nested menu items to the width
                // of the root level menu items, while being visually indented.
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                style: {
                    insetInlineStart: `calc(-1 * ${level} * ${(0, $114f6ecece683ed7$export$d492445a79a49b48)})`
                },
                "aria-hidden": "true",
                className: (0, $bwpsq.default)([
                    $2fda06f6df9236af$var$extendButtonOrAnchorStyles.root
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $bwpsq.default)([
                    $2fda06f6df9236af$var$textStyles.root,
                    !showElemBefore && $2fda06f6df9236af$var$textStyles.noElemBeforeIndent
                ]),
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6eFvr.default), {
                        weight: "medium",
                        maxLines: 1,
                        color: $2fda06f6df9236af$var$getTextColor({
                            isDisabled: isDisabled,
                            isSelected: isSelected
                        }),
                        ref: labelRef,
                        children: children
                    }),
                    description && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6eFvr.default), {
                        color: isDisabled ? 'color.text.disabled' : 'color.text.subtle',
                        size: "small",
                        maxLines: 1,
                        ref: descriptionRef,
                        children: description
                    })
                ]
            })
        ]
    });
    /**
   *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
   *
   * Note: we also remove the `elemAfter` when showing `actionsOnHover`
   */ const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l0Vn1.AvatarContext).Provider, {
        value: $2fda06f6df9236af$var$defaultAvatarValues,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            ref: visualContentRef,
            "data-testid": testId ? `${testId}-container` : undefined,
            "data-selected": isSelected,
            className: (0, $bwpsq.default)([
                $2fda06f6df9236af$var$containerStyles.root,
                isSelected && $2fda06f6df9236af$var$containerStyles.selected,
                description && $2fda06f6df9236af$var$containerStyles.hasDescription,
                showHoverActionsWhenNotHovered && $2fda06f6df9236af$var$containerStyles.showHoverActions,
                showHoverActionsWhenNotHovered && elemAfter && $2fda06f6df9236af$var$containerStyles.removeElemAfter,
                actionsOnHover && elemAfter && $2fda06f6df9236af$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
                isDisabled && $2fda06f6df9236af$var$containerStyles.disabled
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
                    content: ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                    children: children
                                }),
                                description ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                    children: description
                                }) : null
                            ]
                        }),
                    position: "right",
                    // NOTE: Types in React 18 have changed and `forwardRef(() => <TooltipPrimitive>)` no longer appears to match 100%
                    component: $2fda06f6df9236af$var$MenuItemTooltip,
                    ignoreTooltipPointerEvents: true,
                    hideTooltipOnMouseDown: true,
                    // We don't need a duplicate hidden element containing tooltip content
                    // as the content of the tooltip matches what is rendered for the menu item.
                    isScreenReaderAnnouncementDisabled: true,
                    canAppear: canTooltipAppear,
                    children: (tooltipProps)=>{
                        // Putting the tooltip onClick into a ref.
                        // This way we don't need to create a new `onClick` function on each
                        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
                        tooltipOnClick.current = tooltipProps.onClick;
                        const sharedProps = {
                            ...tooltipProps,
                            'aria-controls': ariaControls,
                            'aria-haspopup': ariaHasPopup,
                            ref: (0, $cD7p8.default)([
                                forwardedRef,
                                tooltipProps.ref
                            ]),
                            testId: testId,
                            interactionName: interactionName
                        };
                        return isLink ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gHU1R.default), {
                            ...sharedProps,
                            onClick: handleClick,
                            xcss: (0, $DEWI6.cx)($2fda06f6df9236af$var$buttonOrAnchorStyles.root, $2fda06f6df9236af$var$topLevelSiblingStyles.root, isSelected && $2fda06f6df9236af$var$buttonOrAnchorStyles.selected),
                            // Needed to override Anchor style due to a compiled/emotion conflict
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                            style: {
                                textDecoration: 'none'
                            },
                            "aria-current": isSelected ? 'page' : undefined,
                            href: href,
                            target: target,
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                    "aria-hidden": "true",
                                    className: (0, $bwpsq.default)([
                                        $2fda06f6df9236af$var$notchStyles.root
                                    ])
                                }),
                                interactiveElemContent
                            ]
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gVM6m.default), {
                            ...sharedProps,
                            onClick: handleClick,
                            xcss: (0, $DEWI6.cx)($2fda06f6df9236af$var$buttonOrAnchorStyles.root, $2fda06f6df9236af$var$buttonOrAnchorStyles.active, $2fda06f6df9236af$var$topLevelSiblingStyles.root, isSelected && $2fda06f6df9236af$var$buttonOrAnchorStyles.selected),
                            "aria-expanded": ariaExpanded,
                            isDisabled: isDisabled,
                            children: interactiveElemContent
                        });
                    }
                }),
                showElemBefore && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2fda06f6df9236af$var$elemBeforeStyles.root,
                        $2fda06f6df9236af$var$topLevelSiblingStyles.root,
                        $2fda06f6df9236af$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: elemBefore
                }),
                actionsOnHover && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2fda06f6df9236af$var$actionsOnHoverStyles.root
                    ]),
                    children: actionsOnHover
                }),
                elemAfter && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2fda06f6df9236af$var$elemAfterStyles.root,
                        $2fda06f6df9236af$var$topLevelSiblingStyles.root,
                        $2fda06f6df9236af$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: elemAfter
                }),
                actions && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2fda06f6df9236af$var$actionStyles.root,
                        $2fda06f6df9236af$var$topLevelSiblingStyles.root,
                        $2fda06f6df9236af$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: actions
                })
            ]
        })
    });
};
const $2fda06f6df9236af$export$859b390bf71e044e = (0, $aoFID.forwardRefWithGeneric)($2fda06f6df9236af$var$MenuItemBaseNoRef);

});
/**
 * _Internally_ shared value for the menu item indentation. Used in:
 * - Expandable menu item content, to add padding for each expandable level
 * - The base menu item, to set the negative inset to extend the clickable area of nested menu items
 * to the root level menu items.
 *
 * Internal to the package only. Should not be exported from the package.
 *
 * Note: We're unable to use a token() call here, as Compiled complains about function calls in imported
 * values - it requires statically defined values only.
 *
 * @private
 * @internal
 */ const $114f6ecece683ed7$export$d492445a79a49b48 = '12px';

parcelRegister("fOnXR", function(module, exports) {

$parcel$export(module.exports, "AreAllAncestorsExpandedContext", () => $8c6e69ee6befc140$export$9c01e0e6a504d553);
$parcel$export(module.exports, "IsExpandedContext", () => $8c6e69ee6befc140$export$c856e5885cc34d81);
$parcel$export(module.exports, "SetIsExpandedContext", () => $8c6e69ee6befc140$export$48cb11cb8691f597);
$parcel$export(module.exports, "OnExpansionToggleContext", () => $8c6e69ee6befc140$export$572ce188c913ceba);
$parcel$export(module.exports, "LevelContext", () => $8c6e69ee6befc140$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "useIsExpanded", () => $8c6e69ee6befc140$export$37e565a09598825e);
$parcel$export(module.exports, "useSetIsExpanded", () => $8c6e69ee6befc140$export$c9a171ea8de5861b);
$parcel$export(module.exports, "useOnExpansionToggle", () => $8c6e69ee6befc140$export$56c8438498b72c7a);
$parcel$export(module.exports, "useLevel", () => $8c6e69ee6befc140$export$fdfe9e5e8183d4f2);
$parcel$export(module.exports, "useAreAllAncestorsExpanded", () => $8c6e69ee6befc140$export$57108b5f08ae5194);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");
const $8c6e69ee6befc140$export$9c01e0e6a504d553 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $8c6e69ee6befc140$export$c856e5885cc34d81 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $8c6e69ee6befc140$export$48cb11cb8691f597 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $8c6e69ee6befc140$export$572ce188c913ceba = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $8c6e69ee6befc140$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5uXOq.createContext)(0);
const $8c6e69ee6befc140$export$37e565a09598825e = ()=>{
    const context = (0, $5uXOq.useContext)($8c6e69ee6befc140$export$c856e5885cc34d81);
    (0, $3joPi.default)(context !== null, 'useIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $8c6e69ee6befc140$export$c9a171ea8de5861b = ()=>{
    const context = (0, $5uXOq.useContext)($8c6e69ee6befc140$export$48cb11cb8691f597);
    (0, $3joPi.default)(context !== null, 'useSetIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $8c6e69ee6befc140$export$56c8438498b72c7a = ()=>(0, $5uXOq.useContext)($8c6e69ee6befc140$export$572ce188c913ceba);
const $8c6e69ee6befc140$export$fdfe9e5e8183d4f2 = ()=>(0, $5uXOq.useContext)($8c6e69ee6befc140$export$650d12d3c2ddb8fc);
const $8c6e69ee6befc140$export$57108b5f08ae5194 = ()=>(0, $5uXOq.useContext)($8c6e69ee6befc140$export$9c01e0e6a504d553) ?? true;

});

parcelRegister("1Nq4x", function(module, exports) {

$parcel$export(module.exports, "IsOpenContext", () => $95a6c78f806cb16b$export$efa4d9670e96ac31);
$parcel$export(module.exports, "SetIsOpenContext", () => $95a6c78f806cb16b$export$4c55b1c61a116b42);
$parcel$export(module.exports, "useFlyoutMenuOpen", () => $95a6c78f806cb16b$export$6927118f874a49aa);
$parcel$export(module.exports, "useSetFlyoutMenuOpen", () => $95a6c78f806cb16b$export$538ac1aa421adb94);

var $5uXOq = parcelRequire("5uXOq");

var $bKnKN = parcelRequire("bKnKN");
const $95a6c78f806cb16b$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const $95a6c78f806cb16b$export$4c55b1c61a116b42 = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $bKnKN.default));
const $95a6c78f806cb16b$export$6927118f874a49aa = ()=>(0, $5uXOq.useContext)($95a6c78f806cb16b$export$efa4d9670e96ac31);
const $95a6c78f806cb16b$export$538ac1aa421adb94 = ()=>(0, $5uXOq.useContext)($95a6c78f806cb16b$export$4c55b1c61a116b42);

});

parcelRegister("62Ekk", function(module, exports) {

$parcel$export(module.exports, "COLLAPSE_ELEM_BEFORE", () => $c765e95fa4287711$export$f4b8e24fae579c6f);
const $c765e95fa4287711$export$f4b8e24fae579c6f = Symbol('collapse-elem-before');

});


parcelRegister("aJFme", function(module, exports) {

$parcel$export(module.exports, "useScrollMenuItemIntoView", () => $f35e5b0839c57d23$export$2c52ec851fcc6058);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $fOnXR = parcelRequire("fOnXR");
function $f35e5b0839c57d23$var$scrollMenuItemIntoView(element) {
    /**
	 * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
	 * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
	 * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
	 *
	 * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
	 */ if (typeof element.scrollIntoViewIfNeeded === 'function') {
        element.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
function $f35e5b0839c57d23$export$2c52ec851fcc6058({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $fOnXR.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $5uXOq.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $5uXOq.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $3joPi.default)(element, 'Element ref must be set');
            $f35e5b0839c57d23$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}

});


parcelRegister("4IIGx", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $e9ad1ba8569aee06$export$d4c4e98c5044dc8);

var $baVkR = parcelRequire("baVkR");
const $e9ad1ba8569aee06$export$d4c4e98c5044dc8 = (0, $baVkR.List);

});

parcelRegister("1zjdl", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $5d2bb3999d13b3c1$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $5d2bb3999d13b3c1$export$d57b6b390e78d90f);
$parcel$export(module.exports, "USER_NAVIGATION_ITEM_LINKS", () => $5d2bb3999d13b3c1$export$d34001b14a9e6d48);
$parcel$export(module.exports, "USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS", () => $5d2bb3999d13b3c1$export$c2614ebabc74446e);

var $46Cti = parcelRequire("46Cti");

var $dDmlh = parcelRequire("dDmlh");
const $5d2bb3999d13b3c1$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4SidebarContent';
const $5d2bb3999d13b3c1$export$d57b6b390e78d90f = 'jira-cosmos';
const $5d2bb3999d13b3c1$export$d34001b14a9e6d48 = {
    [(0, $46Cti.L1_MENU_ID).APPS]: '/jira/marketplace/discover?source=apps-menu',
    [(0, $46Cti.L1_MENU_ID).GOALS]: '/jira/your-work?goals',
    [(0, $46Cti.L1_MENU_ID).DASHBOARDS]: (0, $dDmlh.dashboardsDirectoryRoute).path,
    [(0, $46Cti.L1_MENU_ID).TEAMS]: '/jira/people/search',
    [(0, $46Cti.L1_MENU_ID).ROADMAPS]: '/jira/polaris/roadmaps',
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS]: '/jira/assets',
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]: 'https://home.atlassian.com/goals'
};
const $5d2bb3999d13b3c1$export$6f21b70acbf71216 = {
    navKey: 'JIRA_SIDEBAR',
    navItems: [
        {
            menuId: (0, $46Cti.L1_MENU_ID).RECENT,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).STARRED,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).APPS,
            isVisible: true
        },
        // See https://jplat.jira.atlassian.cloud/browse/BLU-3307
        // For the Dogfooding phase of Nav4 we are going to intentionally hide the Goals menu item.
        // Keeping code in comments so it can be easily reintroduced during EAP
        // {
        // 	menuId: L1_MENU_ID.GOALS,
        // 	isVisible: true,
        // },
        {
            menuId: (0, $46Cti.L1_MENU_ID).ROADMAPS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).OVERVIEWS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).PLANS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).PROJECTS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).FILTERS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).DASHBOARDS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).OPERATIONS,
            isVisible: true
        },
        {
            /* remove this on
			 * blu-6313_sidebar_global_app_shortcuts cleanup &&
			 * assets_as_an_app_v2 cleanup &&
			 * blu-6576_migrate_to_platform_customisation cleanup
			 */ menuId: (0, $46Cti.L1_MENU_ID).ASSETS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).TEAMS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS,
            isVisible: true
        },
        {
            menuId: (0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS,
            isVisible: true
        }
    ]
};
const $5d2bb3999d13b3c1$export$c2614ebabc74446e = $5d2bb3999d13b3c1$export$6f21b70acbf71216.navItems.map(({ menuId: menuId })=>menuId);

});
parcelRegister("dDmlh", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRoute", () => $fd66dc0239264856$export$41bba408475cab16);
const $fd66dc0239264856$export$41bba408475cab16 = {
    name: 'dashboards-directory',
    path: '/jira/dashboards'
};

});


parcelRegister("2TuwK", function(module, exports) {

$parcel$export(module.exports, "L1MenuItems", () => $acec8e7e455fe5dc$export$a1e3b15bccd7433c);

var $2OeZv = parcelRequire("2OeZv");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6kIiE = parcelRequire("6kIiE");

var $60xWx = parcelRequire("60xWx");
function $acec8e7e455fe5dc$export$a1e3b15bccd7433c({ queryReference: queryReference }) {
    // We define a query which requires a few variables: $cloudId and others
    // Looking at https://relay.dev/docs/guided-tour/rendering/variables/, we can either:
    // a) pass these query-level variables down to the fragments as arguments, OR,
    // b) allow the fragments to reference the query-level variables directly.
    // We've chosen b) for now, as it would be a hassle to have to specify 8+ variables
    // at every level of the component tree.
    const l1MenuData = (0, $8Uumt.usePreloadedQuery)((0, $2OeZv.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6kIiE.YourWork), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60xWx.ConfigurableMenuItems), {
        menuData: l1MenuData
    }));
}

});
parcelRegister("6kIiE", function(module, exports) {

$parcel$export(module.exports, "YourWork", () => $62ee6641d8028b84$export$c7da207c25eb3776);

var $5uXOq = parcelRequire("5uXOq");

var $l1s8i = parcelRequire("l1s8i");

var $cPLt3 = parcelRequire("cPLt3");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $24a2m = parcelRequire("24a2m");

var $dIHnK = parcelRequire("dIHnK");

var $4R6GH = parcelRequire("4R6GH");

var $lCMI0 = parcelRequire("lCMI0");
const $62ee6641d8028b84$var$JIRA_HOME_PATH = (0, $dIHnK.jiraHomeRoute).path;
const $62ee6641d8028b84$var$analytics = {
    actionSubjectId: (0, $jecJ3.SECTION_ITEM_YOUR_WORK),
    itemId: 'yourWork',
    level: 1,
    // Note: Your work doesn't seem to be configurable via Customise sidebar - More menu
    isInMore: false
};
const $62ee6641d8028b84$export$c7da207c25eb3776 = ()=>{
    const { formattedMessage: formattedMessageOld, icon: iconOld } = (0, $24a2m.useFormattedMessageAndIcon)((0, $lCMI0.default).yourWork, (0, (/*@__PURE__*/$parcel$interopDefault($cPLt3))));
    const { formattedMessage: formattedMessage, icon: icon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $lCMI0.default).forYou, (0, (/*@__PURE__*/$parcel$interopDefault($l1s8i))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        analytics: $62ee6641d8028b84$var$analytics,
        elemBefore: (0, $4R6GH.fg)('blu-6576_migrate_to_platform_customisation') ? icon : iconOld,
        href: $62ee6641d8028b84$var$JIRA_HOME_PATH,
        menuId: (0, $jhS4y.MENU_ID_YOUR_WORK)
    }, (0, $4R6GH.fg)('blu-6576_migrate_to_platform_customisation') ? formattedMessage : formattedMessageOld);
};

});
parcelRegister("cPLt3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::81177d596079c24ecbc8bf8bc933664f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $957f1184ab7d3cf5$var$_react = $957f1184ab7d3cf5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $957f1184ab7d3cf5$var$_baseNew = $957f1184ab7d3cf5$var$_interopRequireDefault((parcelRequire("enEmH")));
function $957f1184ab7d3cf5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Inbox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: 'Your work' in Confluence, inbox, mail.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $957f1184ab7d3cf5$var$InboxIcon = (props)=>/*#__PURE__*/ $957f1184ab7d3cf5$var$_react.default.createElement($957f1184ab7d3cf5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v5h3a.75.75 0 0 1 .75.75 1.75 1.75 0 1 0 3.5 0A.75.75 0 0 1 10.5 8h3V3a.5.5 0 0 0-.5-.5zm10.5 7h-2.337a3.251 3.251 0 0 1-6.326 0H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM12 6H4V4.5h8z" clip-rule="evenodd"/>`
    }, props));
$957f1184ab7d3cf5$var$InboxIcon.displayName = 'InboxIcon';
var $957f1184ab7d3cf5$var$_default = module.exports.default = $957f1184ab7d3cf5$var$InboxIcon;

});

parcelRegister("jecJ3", function(module, exports) {

$parcel$export(module.exports, "SECTION_ITEM_RECENT", () => $06147718dc8a8493$export$ed5276b2863990a4);
$parcel$export(module.exports, "SECTION_ITEM_STARRED", () => $06147718dc8a8493$export$73b9e2753c0313a);
$parcel$export(module.exports, "SECTION_ITEM_YOUR_WORK", () => $06147718dc8a8493$export$a7cdcfc40ede2092);
$parcel$export(module.exports, "SECTION_ITEM_APPS", () => $06147718dc8a8493$export$31b95a89c6fecef5);
$parcel$export(module.exports, "SECTION_ITEM_PLANS", () => $06147718dc8a8493$export$b8d778ecbc8de386);
$parcel$export(module.exports, "SECTION_ITEM_PROJECTS", () => $06147718dc8a8493$export$31111a67d393221);
$parcel$export(module.exports, "SECTION_ITEM_FILTERS", () => $06147718dc8a8493$export$15cffe8e769011f4);
$parcel$export(module.exports, "SECTION_ITEM_DASHBOARDS", () => $06147718dc8a8493$export$573d88e8f19dee53);
$parcel$export(module.exports, "SECTION_ITEM_OPERATIONS", () => $06147718dc8a8493$export$4d8d544db40ea55b);
$parcel$export(module.exports, "SECTION_ITEM_TEAMS", () => $06147718dc8a8493$export$ee4743a74ca6b2b4);
$parcel$export(module.exports, "SECTION_ITEM_ASSETS", () => $06147718dc8a8493$export$935694b184853c59);
$parcel$export(module.exports, "SECTION_ITEM_MORE", () => $06147718dc8a8493$export$b0aa6b1b7598bca0);
$parcel$export(module.exports, "SECTION_ITEM_CUSTOMIZE_SIDEBAR", () => $06147718dc8a8493$export$60a8edfaff189e32);
$parcel$export(module.exports, "SECTION_ITEM_OVERVIEW", () => $06147718dc8a8493$export$c15c267765b7c087);
$parcel$export(module.exports, "SECTION_ITEM_ROADMAPS", () => $06147718dc8a8493$export$1e1623e43a47b758);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_ASSETS", () => $06147718dc8a8493$export$be1ee97c6c39a7a0);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_GOALS", () => $06147718dc8a8493$export$340dfb7166bc7df6);
$parcel$export(module.exports, "SECTION_ITEM_MAP", () => $06147718dc8a8493$export$1a73d7f5e6997c6d);

var $jhS4y = parcelRequire("jhS4y");
const $06147718dc8a8493$export$ed5276b2863990a4 = 'recent';
const $06147718dc8a8493$export$73b9e2753c0313a = 'starred';
const $06147718dc8a8493$export$a01a58e0d3083eac = 'yourApps';
const $06147718dc8a8493$export$a7cdcfc40ede2092 = 'yourWork';
const $06147718dc8a8493$export$31b95a89c6fecef5 = 'apps';
const $06147718dc8a8493$export$b8d778ecbc8de386 = 'plans';
const $06147718dc8a8493$export$31111a67d393221 = 'projects';
const $06147718dc8a8493$export$15cffe8e769011f4 = 'filters';
const $06147718dc8a8493$export$573d88e8f19dee53 = 'dashboards';
const $06147718dc8a8493$export$4d8d544db40ea55b = 'operations';
const $06147718dc8a8493$export$ee4743a74ca6b2b4 = 'teams';
const $06147718dc8a8493$export$935694b184853c59 = 'assets';
const $06147718dc8a8493$export$b0aa6b1b7598bca0 = 'more';
const $06147718dc8a8493$export$60a8edfaff189e32 = 'customiseSidebar';
const $06147718dc8a8493$export$c15c267765b7c087 = 'overviews';
const $06147718dc8a8493$export$61feca79c347b0c7 = 'goals';
const $06147718dc8a8493$export$1e1623e43a47b758 = 'roadmaps';
const $06147718dc8a8493$export$99cd56faa69bbbb6 = 'customerService';
const $06147718dc8a8493$export$f3045e909a12df36 = 'customerHubs';
const $06147718dc8a8493$export$f780439bdf7412c6 = 'customerServiceAnalytics';
const $06147718dc8a8493$export$be1ee97c6c39a7a0 = 'assetsGlobalAppShortcut';
const $06147718dc8a8493$export$340dfb7166bc7df6 = 'goalsGlobalAppShortcut';
const $06147718dc8a8493$export$1a73d7f5e6997c6d = {
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).APPS]: $06147718dc8a8493$export$31b95a89c6fecef5,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).ASSETS]: $06147718dc8a8493$export$935694b184853c59,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).DASHBOARDS]: $06147718dc8a8493$export$573d88e8f19dee53,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).FILTERS]: $06147718dc8a8493$export$15cffe8e769011f4,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).OPERATIONS]: $06147718dc8a8493$export$4d8d544db40ea55b,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).PLANS]: $06147718dc8a8493$export$b8d778ecbc8de386,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).PROJECTS]: $06147718dc8a8493$export$31111a67d393221,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).RECENT]: $06147718dc8a8493$export$ed5276b2863990a4,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).STARRED]: $06147718dc8a8493$export$73b9e2753c0313a,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).TEAMS]: $06147718dc8a8493$export$ee4743a74ca6b2b4,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GOALS]: $06147718dc8a8493$export$61feca79c347b0c7,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).OVERVIEWS]: $06147718dc8a8493$export$c15c267765b7c087,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).ROADMAPS]: $06147718dc8a8493$export$1e1623e43a47b758,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE]: $06147718dc8a8493$export$99cd56faa69bbbb6,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_HUBS]: $06147718dc8a8493$export$f3045e909a12df36,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: $06147718dc8a8493$export$f780439bdf7412c6,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_GOALS]: $06147718dc8a8493$export$340dfb7166bc7df6,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_ASSETS]: $06147718dc8a8493$export$be1ee97c6c39a7a0
};

});

parcelRegister("5FnJJ", function(module, exports) {

$parcel$export(module.exports, "Nav4MenuLinkItem", () => $0d86e9008b98ae27$export$3253d78f1560490f);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");

var $c6x3L = parcelRequire("c6x3L");

var $lJ5jf = parcelRequire("lJ5jf");

var $bSYPZ = parcelRequire("bSYPZ");

var $dQbFB = parcelRequire("dQbFB");
const $0d86e9008b98ae27$export$3253d78f1560490f = /*#__PURE__*/ (0, $5uXOq.forwardRef)($0d86e9008b98ae27$var$_Nav4MenuLinkItem);
function $0d86e9008b98ae27$var$_Nav4MenuLinkItem(props, ref) {
    const { menuId: menuId } = props;
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { isSelectedPath: isSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { isControlledPath: isControlledPath } = (0, $lJ5jf.useSidebarNav4Controller)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bSYPZ.default), {
        ref: ref,
        ...props,
        isSelected: isSelectedPath(menuId) || isControlledPath(menuId),
        testId: (0, $dQbFB.getTestId)(menuId)
    });
}

});
parcelRegister("c6x3L", function(module, exports) {

$parcel$export(module.exports, "SidebarNav4ContextProvider", () => $313dc1bbe6a8339e$export$ebf7cdfc2e83bcef);
$parcel$export(module.exports, "useSidebarNav4", () => $313dc1bbe6a8339e$export$dc46c14934833db2);

var $5uXOq = parcelRequire("5uXOq");

var $doZTA = parcelRequire("doZTA");

var $3Jbkp = parcelRequire("3Jbkp");

var $fMcVX = parcelRequire("fMcVX");

var $7Ckoi = parcelRequire("7Ckoi");
const $313dc1bbe6a8339e$var$SidebarNav4Context = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
function $313dc1bbe6a8339e$export$2854101beb9a2d8d(props) {
    const { children: children, isInitialSelectedPath: isInitialSelectedPath } = props;
    const [routerContext] = (0, $doZTA.useRouter)();
    const initialSelectedPath = (0, $3Jbkp.getInitialSelectedPath)(routerContext);
    const [selectedPath, setSelectedPath] = (0, $5uXOq.useState)(initialSelectedPath);
    // When the `routerContext` changes, we need to recalculate the selected path.
    // useLayoutEffect, so this happens before render.
    (0, $5uXOq.useLayoutEffect)(()=>{
        setSelectedPath((currentPath)=>{
            const newPath = (0, $7Ckoi.routeToSelectedPath)(routerContext);
            return currentPath.toString() === newPath.toString() ? currentPath : newPath;
        });
    }, [
        routerContext
    ]);
    const sidebarNav4Controller = (0, $5uXOq.useMemo)(()=>({
            isInitialSelectedPath: isInitialSelectedPath ?? (0, $fMcVX.isSelectedPath)(initialSelectedPath),
            isSelectedPath: (0, $fMcVX.isSelectedPath)(selectedPath)
        }), [
        initialSelectedPath,
        isInitialSelectedPath,
        selectedPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($313dc1bbe6a8339e$var$SidebarNav4Context.Provider, {
        value: sidebarNav4Controller
    }, children);
}
function $313dc1bbe6a8339e$export$ebf7cdfc2e83bcef(props) {
    const { children: children, isInitialSelectedPath: isInitialSelectedPath } = props;
    const selectedPathData = (0, $7Ckoi.useRouteToSelectedPath)();
    const sidebarNav4Controller = (0, $5uXOq.useMemo)(()=>({
            isInitialSelectedPath: isInitialSelectedPath ?? (0, $fMcVX.isSelectedPath)(selectedPathData.initialSelectedPath),
            isSelectedPath: (0, $fMcVX.isSelectedPath)(selectedPathData.selectedPath)
        }), [
        isInitialSelectedPath,
        selectedPathData.initialSelectedPath,
        selectedPathData.selectedPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($313dc1bbe6a8339e$var$SidebarNav4Context.Provider, {
        value: sidebarNav4Controller
    }, children);
}
function $313dc1bbe6a8339e$export$dc46c14934833db2() {
    const context = (0, $5uXOq.useContext)($313dc1bbe6a8339e$var$SidebarNav4Context);
    if (context == null) throw new Error('useSidebarNav4 must be used inside a SidebarNav4ContextProvider');
    return context;
}

});

parcelRegister("lJ5jf", function(module, exports) {

$parcel$export(module.exports, "SidebarNav4ControllerProvider", () => $ba2af518cd3fa886$export$ec25d268893d889d);
$parcel$export(module.exports, "useSidebarNav4Controller", () => $ba2af518cd3fa886$export$641950c86d73374);

var $5uXOq = parcelRequire("5uXOq");

var $fMcVX = parcelRequire("fMcVX");
const $ba2af518cd3fa886$var$SidebarNav4ControllerContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
function $ba2af518cd3fa886$export$ec25d268893d889d(props) {
    const { children: children, controlledPath: initialControlledPath = null } = props;
    const [controlledPath, setControlledPath] = (0, $5uXOq.useState)(initialControlledPath); // null means "not being controlled"
    const sidebarNav4Controller = (0, $5uXOq.useMemo)(()=>({
            // is any path in Navigation a controlled one
            isControlledNav: controlledPath !== null,
            isControlledPath: (0, $fMcVX.isSelectedPath)(controlledPath ?? []),
            setControlledPath: setControlledPath
        }), [
        controlledPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ba2af518cd3fa886$var$SidebarNav4ControllerContext.Provider, {
        value: sidebarNav4Controller
    }, children);
}
function $ba2af518cd3fa886$export$641950c86d73374() {
    const context = (0, $5uXOq.useContext)($ba2af518cd3fa886$var$SidebarNav4ControllerContext);
    if (context == null) throw new Error('useSidebarNav4Controller must be used inside a SidebarNav4ControllerContext');
    return context;
}

});

parcelRegister("bSYPZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec275bd8d21ab84a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $ctUNb = parcelRequire("ctUNb");
function $ec275bd8d21ab84a$var$MenuLinkItemWithAnalytics({ analytics: analytics, onClick: onClick, ...rest }, ref) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const handleClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        if (!analytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = analytics;
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        }), actionSubjectId, analyticsAttributes);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctUNb.MenuLinkItem), {
        ref: ref,
        onClick: handleClick,
        ...rest
    });
}
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$ec275bd8d21ab84a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.forwardRef)($ec275bd8d21ab84a$var$MenuLinkItemWithAnalytics);

});
const $ce8062101363feb9$export$6dd9406e478a1fe2 = 'navigationItem';
const $ce8062101363feb9$export$b887e88d8d0739f6 = 'button';
const $ce8062101363feb9$export$64fed82162bd367 = 'dropdownItem';


parcelRegister("dQbFB", function(module, exports) {

$parcel$export(module.exports, "getTestId", () => $f598f66a6b396d35$export$ec17b125bc42c229);
// By giving all of the Nav4-HTMLElements a test-id prefix, we can find them again,
// and even build a path from each leaf to the root. We do this in Storybook to
// simulate link-click-selection, since we are not using a real router in SB.
function $f598f66a6b396d35$export$ec17b125bc42c229(suffix) {
    return `NAV4_${suffix}`;
}

});


parcelRegister("dIHnK", function(module, exports) {

$parcel$export(module.exports, "jiraHomeRoute", () => $90d9eefc14df7b5b$export$11ebbd6d4e57759c);
const $90d9eefc14df7b5b$export$11ebbd6d4e57759c = {
    name: 'your-work',
    path: '/jira/your-work'
};

});

parcelRegister("lCMI0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f35f2103e05fea00$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f35f2103e05fea00$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    yourWork: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-your-work.your-work.your-work",
        "defaultMessage": "Your work"
    },
    forYou: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-your-work.your-work.for-you",
        "defaultMessage": "For you"
    }
});

});


parcelRegister("60xWx", function(module, exports) {

$parcel$export(module.exports, "ConfigurableMenuItems", () => $b2e090acb983f40f$export$4aa1992a31b27e16);

var $4yzqs = parcelRequire("4yzqs");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $iszzG = parcelRequire("iszzG");

var $fiYXQ = parcelRequire("fiYXQ");

var $lxgkT = parcelRequire("lxgkT");

var $jybPW = parcelRequire("jybPW");

var $eUfQ2 = parcelRequire("eUfQ2");

var $11ALy = parcelRequire("11ALy");

var $4R6GH = parcelRequire("4R6GH");

var $3muxY = parcelRequire("3muxY");

var $cam2y = parcelRequire("cam2y");

var $jM4TX = parcelRequire("jM4TX");

var $i98eP = parcelRequire("i98eP");

var $1tKM7 = parcelRequire("1tKM7");

var $8FnIk = parcelRequire("8FnIk");

var $ef14J = parcelRequire("ef14J");
function $b2e090acb983f40f$export$4aa1992a31b27e16({ menuData: menuData }) {
    const data = (0, $8Uumt.useFragment)((0, $4yzqs.default), menuData);
    const globalAppLicense = (0, $eUfQ2.useGlobalApps)();
    const navItems = (0, $cam2y.useFilterL1MenuItemsByEditionAndLicense)(// Add back any missing menu ids before filtering in case licensing has changed or a new L1 has been created.
    // This also handles when a user has no configuration yet.
    (0, $jM4TX.useRefreshL1MenuItems)(data.jira?.userNavigationConfiguration?.navItems));
    const navItemsContext = (0, $5uXOq.useMemo)(()=>({
            navItems: navItems,
            visibleMenuIds: (0, $fiYXQ.getConfigurableMenuIds)(navItems, true),
            moreMenuIds: (0, $fiYXQ.getConfigurableMenuIds)(navItems, false),
            productItemsData: (0, $lxgkT.getProductItemsData)(navItems)
        }), [
        navItems
    ]);
    const visibleGlobalAppMenuIds = (0, $lxgkT.getVisibleAppItemsData)(navItems, globalAppLicense);
    const appItemsData = (0, $lxgkT.getAppItemsData)(navItems, globalAppLicense);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iszzG.NavItemsContext).Provider, {
        value: navItemsContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8FnIk.PeekMenuIdContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i98eP.MoreMenuIsOpenContextProvider), null, navItemsContext.visibleMenuIds.map((menuId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3muxY.ConfigurableMenuItem), {
            key: menuId,
            menuData: data,
            menuId: menuId
        })), visibleGlobalAppMenuIds.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $11ALy.TopLevelSpacer), null), visibleGlobalAppMenuIds.map((menuId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jybPW.GlobalAppShortcuts), {
            menuId: menuId,
            key: menuId
        }))), (0, $4R6GH.fg)('nav4_global_links_jira') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ef14J.GlobalShortcuts), null), (0, $4R6GH.fg)('blu-6576_migrate_to_platform_customisation') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $11ALy.TopLevelSpacer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1tKM7.SidebarCustomization), {
        navItems: navItems,
        menuData: data,
        productItemsData: navItemsContext.productItemsData,
        appItemsData: appItemsData
    }))));
}

});
parcelRegister("4yzqs", function(module, exports) {

$parcel$export(module.exports, "default", () => $456c834cb9e35bf5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<00967a64cef8c686dca07727f080bd28>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $456c834cb9e35bf5$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "ConfigurableMenuItems",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudID",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "navKey",
                            "value": "NAV_SIDEBAR"
                        }
                    ],
                    "concreteType": "JiraUserNavigationConfiguration",
                    "kind": "LinkedField",
                    "name": "userNavigationConfiguration",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraConfigurableNavigationItem",
                            "kind": "LinkedField",
                            "name": "navItems",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "menuId"
                                    },
                                    "action": "THROW",
                                    "path": "jira.userNavigationConfiguration.navItems.menuId"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "isVisible"
                                    },
                                    "action": "THROW",
                                    "path": "jira.userNavigationConfiguration.navItems.isVisible"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ConfigurableMenuItem"
        }
    ],
    "type": "Query"
};
$456c834cb9e35bf5$var$node.hash = "186fc107bcd2a8ade003841f3137d27b";
var $456c834cb9e35bf5$export$2e2bcd8739ae039 = $456c834cb9e35bf5$var$node;

});

parcelRegister("iszzG", function(module, exports) {

$parcel$export(module.exports, "NavItemsContext", () => $71af5d0260a148da$export$a2018da95558f5c);
$parcel$export(module.exports, "PeekMenuIdContext", () => $71af5d0260a148da$export$390c771b9e3f4124);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");
const $71af5d0260a148da$export$a2018da95558f5c = /*#__PURE__*/ (0, $5uXOq.createContext)({
    navItems: [],
    visibleMenuIds: [],
    moreMenuIds: []
});
const $71af5d0260a148da$export$390c771b9e3f4124 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    peekMenuId: undefined,
    setPeekMenuId: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});

});

parcelRegister("fiYXQ", function(module, exports) {

$parcel$export(module.exports, "getConfigurableMenuIds", () => $9312141792122626$export$6071c13fba14d7fa);

var $5Yh04 = parcelRequire("5Yh04");
const $9312141792122626$export$6071c13fba14d7fa = (navItems, isVisible)=>navItems.filter((navItem)=>navItem.isVisible === isVisible).map(({ menuId: menuId })=>menuId).filter((0, $5Yh04.isConfigurableMenuId));

});
parcelRegister("5Yh04", function(module, exports) {

$parcel$export(module.exports, "isConfigurableMenuId", () => $a5f9a046dfa6b79b$export$454094eefbaf1797);

var $4DrQd = parcelRequire("4DrQd");
const $a5f9a046dfa6b79b$export$454094eefbaf1797 = (value)=>(0, $4DrQd.CONFIGURABLE_MENU_IDS_AS_STRINGS).includes(value);

});


parcelRegister("lxgkT", function(module, exports) {

$parcel$export(module.exports, "getProductItemsData", () => $22d59b84f7f46516$export$92d3bf799aea2628);
$parcel$export(module.exports, "getAppItemsData", () => $22d59b84f7f46516$export$153d0c6accbfb26a);
$parcel$export(module.exports, "getVisibleAppItemsData", () => $22d59b84f7f46516$export$b7cc8dd7bef58aa3);

var $eUfQ2 = parcelRequire("eUfQ2");
const $22d59b84f7f46516$export$92d3bf799aea2628 = (navItems)=>navItems.filter((navItem)=>!(0, $eUfQ2.isGlobalAppMenuId)(navItem.menuId)).map((item)=>{
        return {
            menuId: item.menuId,
            visible: item.isVisible
        };
    });
const $22d59b84f7f46516$export$153d0c6accbfb26a = (navItems, globalAppLicense)=>navItems.filter((navItem)=>(0, $eUfQ2.isGlobalAppMenuId)(navItem.menuId)).filter((navItem)=>(0, $eUfQ2.hasGlobalAppLicense)(navItem.menuId, globalAppLicense)).map((item)=>{
        return {
            menuId: item.menuId,
            visible: item.isVisible
        };
    });
const $22d59b84f7f46516$export$b7cc8dd7bef58aa3 = (navItems, globalAppLicense)=>{
    return navItems.filter((navItem)=>navItem.isVisible).map(({ menuId: menuId })=>menuId).filter((0, $eUfQ2.isGlobalAppMenuId)).filter((menuId)=>(0, $eUfQ2.hasGlobalAppLicense)(menuId, globalAppLicense));
};

});
parcelRegister("eUfQ2", function(module, exports) {

$parcel$export(module.exports, "useGlobalApps", () => $ee3038da8e9367b5$export$3a835823210524f1);
$parcel$export(module.exports, "isGlobalAppMenuId", () => $ee3038da8e9367b5$export$4c0a3527505b04c5);
$parcel$export(module.exports, "hasGlobalAppLicense", () => $ee3038da8e9367b5$export$f97a769ad5c10cb4);

var $4R6GH = parcelRequire("4R6GH");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $4DrQd = parcelRequire("4DrQd");

var $46Cti = parcelRequire("46Cti");
function $ee3038da8e9367b5$export$3a835823210524f1() {
    const appEditions = (0, $k9JTq.useAppEditions)();
    const shouldShowGoals = // eslint-disable-next-line jira/ff/no-preconditioning
    (appEditions.productDiscovery !== (0, $ldyPw.UNLICENSED) || appEditions.software !== (0, $ldyPw.UNLICENSED) || // JSM comes with a free core license. Goals don't display with JSM-only, so checking for unlicensed JSM
    appEditions.core !== (0, $ldyPw.UNLICENSED) && appEditions.serviceDesk === (0, $ldyPw.UNLICENSED)) && (0, $4R6GH.fg)('blu-6313_sidebar_global_app_shortcuts') && (0, $4R6GH.fg)('blu-6576_migrate_to_platform_customisation');
    const shouldShowAssets = // eslint-disable-next-line jira/ff/no-preconditioning
    appEditions.serviceDesk !== (0, $ldyPw.UNLICENSED) && (0, $4R6GH.fg)('assets_as_an_app_v2') && (0, $4R6GH.fg)('blu-6313_sidebar_global_app_shortcuts') && (0, $4R6GH.fg)('blu-6576_migrate_to_platform_customisation');
    return {
        goals: shouldShowGoals,
        assets: shouldShowAssets
    };
}
const $ee3038da8e9367b5$export$4c0a3527505b04c5 = (value)=>(0, $4DrQd.GLOBAL_APP_MENU_IDS_AS_STRINGS).includes(value);
const $ee3038da8e9367b5$export$f97a769ad5c10cb4 = (value, globalAppLicense)=>{
    switch(value){
        case (0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS:
            return globalAppLicense.assets;
        case (0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS:
            return globalAppLicense.goals;
        default:
            return false;
    }
};

});
parcelRegister("k9JTq", function(module, exports) {

$parcel$export(module.exports, "useAppEditions", () => $dde261c9da85268a$export$92ed15881fc090d7);

var $9OXo1 = parcelRequire("9OXo1");
const $dde261c9da85268a$export$92ed15881fc090d7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.appEditions;
};

});



parcelRegister("jybPW", function(module, exports) {

$parcel$export(module.exports, "GlobalAppShortcuts", () => $caac9dedc6905047$export$69209b4d7b9e00bc);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lzGRO = parcelRequire("lzGRO");

const $caac9dedc6905047$export$69209b4d7b9e00bc = ({ menuId: menuId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "global-app-shortcuts-section",
        packageName: (0, $3287f4a6e09b4c02$export$b8b9d90f9e5bd72b),
        teamName: (0, $3287f4a6e09b4c02$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lzGRO.GlobalAppShortcuts), {
        menuId: menuId
    }));

});
parcelRegister("lzGRO", function(module, exports) {

$parcel$export(module.exports, "GlobalAppShortcuts", () => $6b4660393b5fff8f$export$69209b4d7b9e00bc);

var $5uXOq = parcelRequire("5uXOq");

var $jhS4y = parcelRequire("jhS4y");

var $eQV8d = parcelRequire("eQV8d");

var $jecJ3 = parcelRequire("jecJ3");

var $iiqUN = parcelRequire("iiqUN");

var $RMW1a = parcelRequire("RMW1a");
function $6b4660393b5fff8f$export$69209b4d7b9e00bc({ menuId: menuId }) {
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const onClick = ()=>{
        sendSectionItemAnalyticsEvent({
            menuId: menuId,
            sectionItem: (0, $jecJ3.SECTION_ITEM_MAP)[menuId]
        });
    };
    switch(menuId){
        case (0, $jhS4y.GLOBAL_APP_MENU_ID).GLOBAL_APP_GOALS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $RMW1a.Goals), {
                onClick: onClick
            });
        case (0, $jhS4y.GLOBAL_APP_MENU_ID).GLOBAL_APP_ASSETS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iiqUN.Assets), {
                onClick: onClick
            });
        default:
            return null;
    }
}

});
parcelRegister("eQV8d", function(module, exports) {

$parcel$export(module.exports, "useSectionItemAnalytics", () => $209417640a04fcbd$export$88869d054e1fb00a);

var $5uXOq = parcelRequire("5uXOq");


var $jecJ3 = parcelRequire("jecJ3");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $iszzG = parcelRequire("iszzG");
const $209417640a04fcbd$export$ee0f05907a733e87 = ({ sectionItem: sectionItem, menuId: menuId, moreMenuIds: moreMenuIds })=>{
    if (sectionItem === (0, $jecJ3.SECTION_ITEM_CUSTOMIZE_SIDEBAR)) return moreMenuIds.length !== 0;
    if (menuId) return moreMenuIds.includes(menuId);
    return false;
};
function $209417640a04fcbd$export$88869d054e1fb00a() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, $iszzG.NavItemsContext));
    const sendSectionItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ menuId: menuId, sectionItem: sectionItem })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        });
        const isInMore = $209417640a04fcbd$export$ee0f05907a733e87({
            sectionItem: sectionItem,
            menuId: menuId,
            moreMenuIds: moreMenuIds
        });
        (0, $8zOmE.fireUIAnalytics)(event, sectionItem, {
            isInMore: isInMore
        });
    }, [
        createAnalyticsEvent,
        moreMenuIds
    ]);
    return sendSectionItemAnalyticsEvent;
}

});

parcelRegister("iiqUN", function(module, exports) {

$parcel$export(module.exports, "Assets", () => $4bdc039a652f8e65$export$c8eca95e306f7116);

var $5uXOq = parcelRequire("5uXOq");

var $bqwqE = parcelRequire("bqwqE");

var $lNrAz = parcelRequire("lNrAz");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $koVbs = parcelRequire("koVbs");

var $46Cti = parcelRequire("46Cti");

var $k9JTq = parcelRequire("k9JTq");

var $j054R = parcelRequire("j054R");

var $cNd4s = parcelRequire("cNd4s");

var $ldyPw = parcelRequire("ldyPw");

var $ctUNb = parcelRequire("ctUNb");

var $3RvHe = parcelRequire("3RvHe");
function $4bdc039a652f8e65$export$c8eca95e306f7116({ onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const url = '/jira/assets';
    const appEditions = (0, $k9JTq.useAppEditions)();
    const isNotJsmPremium = appEditions.serviceDesk !== (0, $ldyPw.PREMIUM_EDITION);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    if (isNotJsmPremium) {
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'cmdbUpsellPageButton viewed', {
            serviceDeskEdition: appEditions.serviceDesk,
            isSiteAdmin: isSiteAdmin
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j054R.AssetsUpsellButton), {
            configurableMenuId: (0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS,
            lozengeText: formatMessage((0, $3RvHe.default).lozenge)
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctUNb.MenuLinkItem), {
        href: url,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lNrAz))), {
            label: ""
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bqwqE.AssetsIcon), null),
        target: "_blank",
        onClick: onClick,
        testId: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.assets.menu-link-item"
    }, formatMessage((0, $3RvHe.default).assets));
}

});
parcelRegister("lNrAz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1959b1db9d7d7f74dcc029cd008a599f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fde3932a759d5d45$var$_react = $fde3932a759d5d45$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fde3932a759d5d45$var$_baseNew = $fde3932a759d5d45$var$_interopRequireDefault((parcelRequire("enEmH")));
function $fde3932a759d5d45$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for links that open up a new tab as a secondary/tertiary action.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fde3932a759d5d45$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $fde3932a759d5d45$var$_react.default.createElement($fde3932a759d5d45$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.688 2.5a.19.19 0 0 0-.188.188v6.624c0 .104.084.188.188.188h6.624a.19.19 0 0 0 .188-.187V8.5H11v.813C11 10.244 10.245 11 9.313 11H2.686A1.687 1.687 0 0 1 1 9.313V2.686C1 1.757 1.756 1 2.688 1H3.5v1.5zM5.75 1h4.5a.75.75 0 0 1 .75.75v4.5H9.5V3.56L5.53 7.53 4.47 6.47 8.44 2.5H5.75z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$fde3932a759d5d45$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $fde3932a759d5d45$var$_default = module.exports.default = $fde3932a759d5d45$var$LinkExternalIcon;

});

parcelRegister("j054R", function(module, exports) {

$parcel$export(module.exports, "AssetsUpsellButton", () => $6d4c03fd42d36bed$export$a04ba1c400e85b23);
$parcel$export(module.exports, "AssetsAppItem", () => $6d4c03fd42d36bed$export$5803e5f720bc19ab);

var $5uXOq = parcelRequire("5uXOq");

var $lggcf = parcelRequire("lggcf");

var $eOat1 = parcelRequire("eOat1");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $b0J2Z = parcelRequire("b0J2Z");
var $ak8Tx = parcelRequire("ak8Tx");
var $dpz5x = parcelRequire("dpz5x");
var $141xu = parcelRequire("141xu");

var $koVbs = parcelRequire("koVbs");

var $24a2m = parcelRequire("24a2m");

var $blEB6 = parcelRequire("blEB6");

var $46Cti = parcelRequire("46Cti");

var $dUyqZ = parcelRequire("dUyqZ");

var $eaKdt = parcelRequire("eaKdt");

var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $c6lNO = parcelRequire("c6lNO");

var $aCS3f = parcelRequire("aCS3f");

var $85JfV = parcelRequire("85JfV");



var $9wUqW = parcelRequire("9wUqW");
const $6d4c03fd42d36bed$var$actionsOnHover = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
    MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
            menuId: (0, $46Cti.L1_MENU_ID).ASSETS
        })
});
const $6d4c03fd42d36bed$var$linkAnalytics = {
    actionSubjectId: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
    itemId: (0, $jhS4y.MENU_ID_ASSETS),
    level: 1
};
const $6d4c03fd42d36bed$var$upsellButtonAnalytics = {
    ...$6d4c03fd42d36bed$var$linkAnalytics,
    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147)
};
const $6d4c03fd42d36bed$var$AssetsExternalLink = ()=>{
    const { formattedMessage: assetsMessage, icon: assetsIcon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).ASSETS);
    const { icon: openExternalLinkIcon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $9wUqW.default).openAssetsApp, (0, (/*@__PURE__*/$parcel$interopDefault($lggcf))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        href: (0, $blEB6.getRootPath)(),
        target: "_blank",
        menuId: (0, $jhS4y.MENU_ID_ASSETS),
        analytics: $6d4c03fd42d36bed$var$linkAnalytics,
        elemBefore: assetsIcon,
        elemAfter: openExternalLinkIcon,
        actionsOnHover: $6d4c03fd42d36bed$var$actionsOnHover
    }, assetsMessage);
};
const $6d4c03fd42d36bed$export$a04ba1c400e85b23 = ({ configurableMenuId: configurableMenuId, lozengeText: lozengeText })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const configurableMessageIcon = configurableMenuId ?? (0, $46Cti.L1_MENU_ID).ASSETS;
    const { formattedMessage: assetsMessage, icon: assetsIcon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)(configurableMessageIcon);
    const upsellText = lozengeText ?? formatMessage((0, $9wUqW.default).upsellLozengeText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c6lNO.default), {
        elemBefore: assetsIcon,
        analytics: $6d4c03fd42d36bed$var$upsellButtonAnalytics,
        onClick: ()=>{
            setIsOpen(true);
        },
        actionsOnHover: configurableMessageIcon === (0, $46Cti.L1_MENU_ID).ASSETS ? $6d4c03fd42d36bed$var$actionsOnHover : null,
        testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.nav-4-menu-button-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $6d4c03fd42d36bed$var$assetsUpsellButtonStyles
    }, assetsMessage, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.upsell-lozenge",
        appearance: "new"
    }, upsellText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b0J2Z.Drawer), {
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
        },
        width: "full",
        testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.drawer",
        label: assetsMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $141xu.DrawerSidebar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ak8Tx.DrawerCloseButton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpz5x.DrawerContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $85JfV.AsyncCmdbUpsellPage), null))));
};
const $6d4c03fd42d36bed$export$5803e5f720bc19ab = ({ showUpsell: showUpsell })=>{
    if (showUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6d4c03fd42d36bed$export$a04ba1c400e85b23, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6d4c03fd42d36bed$var$AssetsExternalLink, null);
};
const $6d4c03fd42d36bed$var$assetsUpsellButtonStyles = (0, $2s57o.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
    alignContent: 'center'
});

});
parcelRegister("b0J2Z", function(module, exports) {

$parcel$export(module.exports, "Drawer", () => $2d9c3535e15cabbf$export$4071300121a182f5);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lv4Ny = parcelRequire("lv4Ny");

var $eNCZ4 = parcelRequire("eNCZ4");

var $86D9T = parcelRequire("86D9T");
var $aLUgv = parcelRequire("aLUgv");

var $5g2iQ = parcelRequire("5g2iQ");

var $cxQCD = parcelRequire("cxQCD");

var $4lvK7 = parcelRequire("4lvK7");
// escape close manager for layering
const $2d9c3535e15cabbf$var$EscapeCloseManager = ({ onClose: onClose })=>{
    // wrap so that we can cast the event to a React.KeyboardEvent
    const handleClose = (0, $5uXOq.useCallback)((evt)=>{
        onClose && onClose(evt);
    }, [
        onClose
    ]);
    (0, $aLUgv.useCloseOnEscapePress)({
        onClose: handleClose
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {});
};
const $2d9c3535e15cabbf$export$4071300121a182f5 = ({ width: width = 'narrow', isOpen: isOpen, isFocusLockEnabled: isFocusLockEnabled = true, shouldReturnFocus: shouldReturnFocus = true, autoFocusFirstElem: autoFocusFirstElem = true, onKeyDown: onKeyDown, testId: testId, children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, zIndex: zIndex = 'unset', label: label, titleId: titleId, enterFrom: enterFrom })=>{
    const handleClose = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'escKey'
        }
    });
    const handleKeyDown = (0, $5uXOq.useCallback)((evt)=>{
        onKeyDown && onKeyDown(evt);
    }, [
        onKeyDown
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen) window.addEventListener('keydown', handleKeyDown);
        return ()=>{
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleKeyDown,
        isOpen
    ]);
    const handleBlanketClick = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'blanket'
        }
    });
    const handleBackButtonClick = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'backButton'
        }
    });
    const body = (0, $lv4Ny.canUseDOM) ? document.querySelector('body') : undefined;
    if (!body) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5g2iQ.default), {
        zIndex: zIndex,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cxQCD.default), {
                isOpen: isOpen,
                onBlanketClicked: handleBlanketClick,
                testId: testId && `${testId}--blanket`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4lvK7.DrawerPanel), {
                testId: testId,
                isOpen: isOpen,
                onClose: handleBackButtonClick,
                onCloseComplete: onCloseComplete,
                onOpenComplete: onOpenComplete,
                width: width,
                enterFrom: enterFrom,
                label: label,
                titleId: titleId,
                autoFocusFirstElem: autoFocusFirstElem,
                isFocusLockEnabled: isFocusLockEnabled,
                shouldReturnFocus: shouldReturnFocus,
                children: isOpen ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $86D9T.Layering), {
                    isDisabled: false,
                    children: [
                        children,
                        /*#__PURE__*/ (0, $2OMIu.jsx)($2d9c3535e15cabbf$var$EscapeCloseManager, {
                            onClose: handleClose
                        })
                    ]
                }) : children
            })
        ]
    });
};

});
parcelRegister("cxQCD", function(module, exports) {

$parcel$export(module.exports, "default", () => $d133fe4f16a1e764$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $1wnUy = parcelRequire("1wnUy");

var $7xhdA = parcelRequire("7xhdA");
var $geBdj = parcelRequire("geBdj");
const $d133fe4f16a1e764$var$styles = {
    blanket: "_kqswh2mm"
};
/**
 * A wrapper around `@atlaskit/blanket` that adds a fade in/out transition.
 */ const $d133fe4f16a1e764$var$Blanket = ({ isOpen: isOpen, onBlanketClicked: onBlanketClicked, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7xhdA.default), {
        appear: true,
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $geBdj.default), {
            /*
     * The fade out animation uses half the passed duration so it evens out.
     */ duration: "large",
            /**
     * We don't expose this on `FadeIn` but it does get passed down.
     * TODO: figure out how we want to handle this...
     */ // @ts-ignore
            animationTimingFunction: "ease-out",
            children: ({ className: className })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $d133fe4f16a1e764$var$styles.blanket,
                        className
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1wnUy.default), {
                        isTinted: true,
                        onBlanketClicked: onBlanketClicked,
                        testId: testId && testId
                    })
                })
        })
    });
};
var $d133fe4f16a1e764$export$2e2bcd8739ae039 = $d133fe4f16a1e764$var$Blanket;

});

parcelRegister("4lvK7", function(module, exports) {

$parcel$export(module.exports, "DrawerPanel", () => $df44c7f301145997$export$96114a266f19b4d0);
/* drawer-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7xhdA = parcelRequire("7xhdA");
var $3aB43 = parcelRequire("3aB43");

var $5QQVa = parcelRequire("5QQVa");

var $ilzbj = parcelRequire("ilzbj");
const $df44c7f301145997$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $df44c7f301145997$var$styles = {
    root: "_1reo15vq _18m915vq _1e0c1txw _4t3i1kxc _kqsw1n9t _1pbybfng _bfhk1bhr _1q1l1bhr _152tze3t _1e02ze3t _ect41gqc",
    full: "_1bsbauwl",
    extended: "_1bsb1mwr",
    narrow: "_1bsb1gwv",
    medium: "_1bsb1y37",
    wide: "_1bsb1ogm"
}; /**
    * This wrapper is used to specify separate durations for enter and exit.
    */ 
const $df44c7f301145997$var$CustomSlideIn = ({ children: children, onFinish: onFinish, enterFrom: enterFrom })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3aB43.default), {
        animationTimingFunction: "ease-out",
        duration: "small",
        enterFrom: enterFrom,
        exitTo: enterFrom,
        fade: "none",
        onFinish: onFinish,
        children: children
    });
}; /**
    * __Drawer panel__
    */ 
const $df44c7f301145997$export$96114a266f19b4d0 = ({ children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, testId: testId, isOpen: isOpen, shouldReturnFocus: shouldReturnFocus, autoFocusFirstElem: autoFocusFirstElem, isFocusLockEnabled: isFocusLockEnabled, width: width = 'narrow', label: label, titleId: titleId, enterFrom: enterFrom = 'left' })=>{
    /**
   * A ref to point to our wrapper, passed to `onCloseComplete` and `onOpenComplete` callbacks.
   */ const drawerRef = (0, $5uXOq.useRef)(null);
    const onFinish = (0, $5uXOq.useCallback)((state)=>{
        if (state === 'entering') onOpenComplete?.(drawerRef.current);
        else if (state === 'exiting') onCloseComplete?.(drawerRef.current);
    }, [
        onCloseComplete,
        onOpenComplete
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7xhdA.default), {
        appear: true,
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsx)($df44c7f301145997$var$CustomSlideIn, {
            onFinish: onFinish,
            enterFrom: enterFrom,
            children: ({ className: className })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ilzbj.default), {
                    autoFocusFirstElem: autoFocusFirstElem,
                    isFocusLockEnabled: isFocusLockEnabled,
                    shouldReturnFocus: shouldReturnFocus,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    , {
                        className: (0, $bwpsq.default)([
                            $df44c7f301145997$var$styles.root,
                            $df44c7f301145997$var$styles[width],
                            className
                        ]),
                        "data-testid": testId,
                        ref: drawerRef,
                        "aria-modal": true,
                        role: "dialog",
                        "aria-label": label,
                        "aria-labelledby": titleId,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5QQVa.EnsureIsInsideDrawerContext).Provider, {
                            value: true,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5QQVa.OnCloseContext).Provider, {
                                value: onClose,
                                children: children
                            })
                        })
                    })
                })
        })
    });
};

});
parcelRegister("5QQVa", function(module, exports) {

$parcel$export(module.exports, "OnCloseContext", () => $d1f8dc1248f60b03$export$7376ab1fc7707bdd);
$parcel$export(module.exports, "useOnClose", () => $d1f8dc1248f60b03$export$c2b12c82f332a6fb);
$parcel$export(module.exports, "EnsureIsInsideDrawerContext", () => $d1f8dc1248f60b03$export$e3662b8677049786);
$parcel$export(module.exports, "useEnsureIsInsideDrawer", () => $d1f8dc1248f60b03$export$780b9799f6bfecd8);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");
const $d1f8dc1248f60b03$export$7376ab1fc7707bdd = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $d1f8dc1248f60b03$export$c2b12c82f332a6fb = ()=>(0, $5uXOq.useContext)($d1f8dc1248f60b03$export$7376ab1fc7707bdd);
const $d1f8dc1248f60b03$export$e3662b8677049786 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const $d1f8dc1248f60b03$export$780b9799f6bfecd8 = ()=>{
    const context = (0, $5uXOq.useContext)($d1f8dc1248f60b03$export$e3662b8677049786);
    (0, $3joPi.default)(context, 'Drawer sub-components must be used within a Drawer component.');
};

});

parcelRegister("ilzbj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8e975ea6f459656$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ao4Ml = parcelRequire("ao4Ml");
/**
 * __Focus lock__
 *
 * Thin wrapper around react-focus-lock.
 */ const $f8e975ea6f459656$var$FocusLock = ({ isFocusLockEnabled: isFocusLockEnabled = true, autoFocusFirstElem: autoFocusFirstElem = true, shouldReturnFocus: shouldReturnFocus = true, children: children })=>{
    const getFocusTarget = ()=>{
        if (typeof shouldReturnFocus === 'boolean') return shouldReturnFocus;
        return false;
    };
    const onDeactivation = ()=>{
        if (typeof shouldReturnFocus !== 'boolean') window.setTimeout(()=>{
            shouldReturnFocus?.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ao4Ml.default), {
        disabled: !isFocusLockEnabled,
        autoFocus: autoFocusFirstElem,
        returnFocus: getFocusTarget(),
        onDeactivation: onDeactivation,
        children: children
    });
};
var $f8e975ea6f459656$export$2e2bcd8739ae039 = $f8e975ea6f459656$var$FocusLock;

});



parcelRegister("ak8Tx", function(module, exports) {

$parcel$export(module.exports, "DrawerCloseButton", () => $95fdf7fcf9014b44$export$d0c3a75c17ac0cab);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1Seuh = parcelRequire("1Seuh");

var $jsLTH = parcelRequire("jsLTH");

var $5QQVa = parcelRequire("5QQVa");
const $95fdf7fcf9014b44$export$d0c3a75c17ac0cab = ({ icon: Icon, label: label = 'Close drawer', testId: testId = 'DrawerCloseButton' })=>{
    (0, $5QQVa.useEnsureIsInsideDrawer)();
    const onClose = (0, $5QQVa.useOnClose)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
        onClick: onClose,
        testId: testId,
        icon: Icon ? (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                ...iconProps,
                size: "large",
                LEGACY_size: "large"
            }) : (0, (/*@__PURE__*/$parcel$interopDefault($jsLTH))),
        label: label,
        shape: "circle",
        appearance: "subtle"
    });
};

});
parcelRegister("jsLTH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::707984c4bf43fbcb724a560e605082a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2b5c93f02a4f670$var$_react = $e2b5c93f02a4f670$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e2b5c93f02a4f670$var$_arrowLeft = $e2b5c93f02a4f670$var$_interopRequireDefault((parcelRequire("kmtfL")));

var $e2b5c93f02a4f670$var$_arrowLeft2 = $e2b5c93f02a4f670$var$_interopRequireDefault((parcelRequire("gpI4P")));
function $e2b5c93f02a4f670$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e2b5c93f02a4f670$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $e2b5c93f02a4f670$var$_react.default.createElement($e2b5c93f02a4f670$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $e2b5c93f02a4f670$var$_arrowLeft2.default
    }, props));
$e2b5c93f02a4f670$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
var $e2b5c93f02a4f670$var$_default = module.exports.default = $e2b5c93f02a4f670$var$ArrowLeftIcon;

});
parcelRegister("gpI4P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf312be5ba437a9c$var$_react = $bf312be5ba437a9c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $bf312be5ba437a9c$var$_arrowLeft = $bf312be5ba437a9c$var$_interopRequireDefault((parcelRequire("kmtfL")));
function $bf312be5ba437a9c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bf312be5ba437a9c$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $bf312be5ba437a9c$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.207 5.793a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.793 3.793a1 1 0 1 1-1.415 1.414l-5.499-5.5A1 1 0 0 1 5 12.028v-.057a1 1 0 0 1 .293-.678l5.499-5.5a1 1 0 0 1 1.415 0" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $bf312be5ba437a9c$var$_arrowLeft.default
    }));
$bf312be5ba437a9c$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $bf312be5ba437a9c$var$_default = module.exports.default = $bf312be5ba437a9c$var$ArrowLeftIcon;

});



parcelRegister("dpz5x", function(module, exports) {

$parcel$export(module.exports, "DrawerContent", () => $438ba9934f623f30$export$57ca055474bc0056);
/* drawer-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2alJM = parcelRequire("2alJM");

var $bWn3s = parcelRequire("bWn3s");

var $5QQVa = parcelRequire("5QQVa");

var $lvKCO = parcelRequire("lvKCO");
const $438ba9934f623f30$var$styles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug _19pk1ejb"
};
const $438ba9934f623f30$var$DrawerContentBase = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, scrollContentLabel: scrollContentLabel = 'Scrollable content', xcss: xcss }, scrollableRef)=>{
    const [showContentFocus, setContentFocus] = (0, $5uXOq.useState)(false);
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const setLazyContentFocus = ()=>{
            const target = ref.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        };
        setLazyContentFocus();
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $438ba9934f623f30$var$styles.default,
            xcss
        ]),
        ref: (0, $bWn3s.mergeRefs)([
            ref,
            scrollableRef
        ]),
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? scrollContentLabel : undefined,
        "data-testid": "drawer-contents",
        children: children
    });
});
const $438ba9934f623f30$export$57ca055474bc0056 = ({ children: children, scrollContentLabel: scrollContentLabel, xcss: xcss })=>{
    (0, $5QQVa.useEnsureIsInsideDrawer)();
    (0, $lvKCO.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2alJM))), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($438ba9934f623f30$var$DrawerContentBase, {
            scrollContentLabel: scrollContentLabel,
            xcss: xcss,
            children: children
        })
    });
};

});
parcelRegister("bWn3s", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $8b16fea90e636ddb$export$c9058316764c140e);

var $dv0OY = parcelRequire("dv0OY");

var $3XwZB = parcelRequire("3XwZB");
function $8b16fea90e636ddb$export$c9058316764c140e(refs) {
    return (0, $3XwZB.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $dv0OY.assignRef)(ref, newValue)));
}

});
parcelRegister("3XwZB", function(module, exports) {

$parcel$export(module.exports, "createCallbackRef", () => $2e2079715de82b22$export$35a19128eb4acba4);
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $2e2079715de82b22$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}

});


parcelRegister("lvKCO", function(module, exports) {

$parcel$export(module.exports, "default", () => $545f8e69d4304cc6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 * ⚠️ This is copied from `packages/design-system/modal-dialog/src/internal/hooks/use-prevent-programmatic-scroll.tsx`
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $545f8e69d4304cc6$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $545f8e69d4304cc6$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $5uXOq.useState)(0);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setScrollTopOffset($545f8e69d4304cc6$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $5uXOq.useCallback)(()=>{
        if ($545f8e69d4304cc6$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $5uXOq.useEffect)(()=>{
        return (0, $cBeZP.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("141xu", function(module, exports) {

$parcel$export(module.exports, "DrawerSidebar", () => $c45d3b8da941eb64$export$25c48648e7980210);
/* drawer-sidebar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5QQVa = parcelRequire("5QQVa");
const $c45d3b8da941eb64$var$styles = {
    default: "_4cvr1h6o _vchhusvi _syaz1gjq _1e0c1txw _1o9zidpf _2lx21bp4 _4t3i1kxc _n3tdpxbi _ca0q1ejb _1bsbxncg"
};
const $c45d3b8da941eb64$export$25c48648e7980210 = ({ children: children, xcss: xcss })=>{
    (0, $5QQVa.useEnsureIsInsideDrawer)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $c45d3b8da941eb64$var$styles.default,
            xcss
        ]),
        "data-testid": "drawer-sidebar",
        children: children
    });
};

});

parcelRegister("blEB6", function(module, exports) {

$parcel$export(module.exports, "ASSETS_APP_ROUTE_PREFIX", () => $587a2dd53fdae2e8$export$42e57fb76a904fc3);
$parcel$export(module.exports, "isInsightRoute", () => $587a2dd53fdae2e8$export$296d80f3ce129968);
$parcel$export(module.exports, "getCreateServiceUrl", () => $587a2dd53fdae2e8$export$1f9b8b558a361aaf);
$parcel$export(module.exports, "getRootPath", () => $587a2dd53fdae2e8$export$5413f45d031c7806);
$parcel$export(module.exports, "getLandingPageUrl", () => $587a2dd53fdae2e8$export$9366da5a373815e5);
$parcel$export(module.exports, "getGlobalConfigUrl", () => $587a2dd53fdae2e8$export$20fd4a0aec335970);
$parcel$export(module.exports, "getDataManagerUrl", () => $587a2dd53fdae2e8$export$c9b27b0d2e19d52f);
$parcel$export(module.exports, "getDataManagerAdaptersUrl", () => $587a2dd53fdae2e8$export$cd6b35373ba077a);
$parcel$export(module.exports, "getAssetsReportsUrl", () => $587a2dd53fdae2e8$export$c1909404b7ea317f);
$parcel$export(module.exports, "getAssetsReportUrl", () => $587a2dd53fdae2e8$export$272d35cbff1c220e);
$parcel$export(module.exports, "getAssetsSearchResultsUrl", () => $587a2dd53fdae2e8$export$97bfda8f5f38a121);
$parcel$export(module.exports, "createObjectSchemasUrl", () => $587a2dd53fdae2e8$export$c48ea1282c74411e);
$parcel$export(module.exports, "createObjectSchemaUrl", () => $587a2dd53fdae2e8$export$3a0332e980fe56cf);
$parcel$export(module.exports, "createObjectTypeUrl", () => $587a2dd53fdae2e8$export$cfefb90cfb86b528);
$parcel$export(module.exports, "createObjectSchemaConfigUrl", () => $587a2dd53fdae2e8$export$f02479149ce3cac7);
$parcel$export(module.exports, "createObjectDetailUrl", () => $587a2dd53fdae2e8$export$51e4229f2c7d3866);
$parcel$export(module.exports, "createObjectTypeSettingsUrl", () => $587a2dd53fdae2e8$export$4b4b7d2c3df4fa58);
$parcel$export(module.exports, "createObjectTypeListWithObjectSelectedUrl", () => $587a2dd53fdae2e8$export$c1790fa8f0d8e89a);
$parcel$export(module.exports, "getFeatureUsagePageUrl", () => $587a2dd53fdae2e8$export$5ba89eed0cf60033);
$parcel$export(module.exports, "getFeatureUsageVirtualAgentPageUrl", () => $587a2dd53fdae2e8$export$415502b49e27270d);

var $ebyGx = parcelRequire("ebyGx");

var $4R6GH = parcelRequire("4R6GH");

var $9PhlU = parcelRequire("9PhlU");
const $587a2dd53fdae2e8$export$ee637ecb2dfa4f6a = '/jira/servicedesk/service-modal';
const $587a2dd53fdae2e8$export$42e57fb76a904fc3 = '/jira/assets';
const $587a2dd53fdae2e8$export$80e512187a5e0d10 = '/jira/servicedesk/assets';
const $587a2dd53fdae2e8$export$6d7574dbda22cf7 = '/jira/servicedesk/insight';
const $587a2dd53fdae2e8$export$296d80f3ce129968 = (pathname)=>pathname.includes($587a2dd53fdae2e8$export$6d7574dbda22cf7);
const $587a2dd53fdae2e8$export$1f9b8b558a361aaf = ()=>$587a2dd53fdae2e8$export$ee637ecb2dfa4f6a;
const $587a2dd53fdae2e8$export$5413f45d031c7806 = ()=>(0, $4R6GH.fg)('assets_as_an_app_v2') ? $587a2dd53fdae2e8$export$42e57fb76a904fc3 : $587a2dd53fdae2e8$export$80e512187a5e0d10;
const $587a2dd53fdae2e8$export$9366da5a373815e5 = ()=>$587a2dd53fdae2e8$export$5413f45d031c7806();
const $587a2dd53fdae2e8$export$20fd4a0aec335970 = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/configure/global`;
const $587a2dd53fdae2e8$export$c9b27b0d2e19d52f = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/data-manager/`;
const $587a2dd53fdae2e8$export$cd6b35373ba077a = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/data-manager/adapters/`;
const $587a2dd53fdae2e8$export$c1909404b7ea317f = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/reports`;
const $587a2dd53fdae2e8$export$272d35cbff1c220e = (reportId)=>`${$587a2dd53fdae2e8$export$c1909404b7ea317f()}/${reportId}`;
const $587a2dd53fdae2e8$export$97bfda8f5f38a121 = (query)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/search${query ? `?${query}` : ''}`;
const $587a2dd53fdae2e8$export$c48ea1282c74411e = ()=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/object-schemas`;
const $587a2dd53fdae2e8$export$3a0332e980fe56cf = (objectSchemaId)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/object-schema/${objectSchemaId}`;
const $587a2dd53fdae2e8$export$cfefb90cfb86b528 = (objectSchemaId, objectTypeId)=>`${$587a2dd53fdae2e8$export$3a0332e980fe56cf(objectSchemaId)}?${(0, $9PhlU.SCHEMA_PAGE_QUERY_PARAMS).objectTypeId}=${objectTypeId}`;
const $587a2dd53fdae2e8$export$f02479149ce3cac7 = (objectSchemaId)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/configure/object-schema/${objectSchemaId}`;
const $587a2dd53fdae2e8$export$51e4229f2c7d3866 = (objectId)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/object/${objectId}`;
const $587a2dd53fdae2e8$export$4b4b7d2c3df4fa58 = (objectTypeId)=>`${$587a2dd53fdae2e8$export$5413f45d031c7806()}/configure/object-type/${objectTypeId}`;
const $587a2dd53fdae2e8$export$c1790fa8f0d8e89a = (objectSchemaId, objectTypeId, objectId)=>`${$587a2dd53fdae2e8$export$cfefb90cfb86b528(objectSchemaId, objectTypeId)}&view=list&objectId=${objectId}`;
const $587a2dd53fdae2e8$export$6e21e6efe57484c5 = (queryParams = {})=>{
    const base = `${$587a2dd53fdae2e8$export$42e57fb76a904fc3}/search`;
    if (Object.keys(queryParams).length > 0) {
        const encodedParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(queryParams);
        return `${base}?${encodedParams}`;
    }
    return base;
};
const $587a2dd53fdae2e8$export$5ba89eed0cf60033 = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=assets${showChangeLimitModal ? '&changeLimit=true' : ''}`;
const $587a2dd53fdae2e8$export$415502b49e27270d = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=virtual-agent${showChangeLimitModal ? '&changeLimit=true' : ''}`;

});
parcelRegister("9PhlU", function(module, exports) {

$parcel$export(module.exports, "SCHEMA_PAGE_QUERY_PARAMS", () => $dee65df3d835c7b2$export$a73deb42718b5c4);
$parcel$export(module.exports, "TAB_QUERY_PARAM_REFERENCE_TYPES", () => $dee65df3d835c7b2$export$f7855185bab37329);
$parcel$export(module.exports, "TAB_QUERY_PARAM_STATUSES", () => $dee65df3d835c7b2$export$3739ebbc7c6e87e8);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ICONS", () => $dee65df3d835c7b2$export$2c22dc6c729ae0bd);
$parcel$export(module.exports, "TAB_QUERY_PARAM_DATA_MANAGER", () => $dee65df3d835c7b2$export$f37b3a97acf56eaf);
$parcel$export(module.exports, "TAB_QUERY_PARAM_GENERAL", () => $dee65df3d835c7b2$export$12ebb1d5017e1d6d);
$parcel$export(module.exports, "TAB_QUERY_PARAM_ROLES", () => $dee65df3d835c7b2$export$a77734d9ea30fe44);
$parcel$export(module.exports, "TAB_QUERY_PARAM_IMPORT", () => $dee65df3d835c7b2$export$be37b820df30c947);
$parcel$export(module.exports, "TAB_QUERY_PARAM_INHERITANCE", () => $dee65df3d835c7b2$export$670faa8ae93e0903);
$parcel$export(module.exports, "useUpdateQueryParams", () => $dee65df3d835c7b2$export$e66acc5f4583ce1c);
$parcel$export(module.exports, "useObjectTypeIdQueryParam", () => $dee65df3d835c7b2$export$f5a33d51dd6de08);
$parcel$export(module.exports, "useObjectIdQueryParam", () => $dee65df3d835c7b2$export$a6e3187c87554a1e);
$parcel$export(module.exports, "useSchemaViewModeQueryParam", () => $dee65df3d835c7b2$export$6abda0ad26022eff);
$parcel$export(module.exports, "useObjectViewModeQueryParam", () => $dee65df3d835c7b2$export$1927b50f7d074492);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $5Ny9E = parcelRequire("5Ny9E");

var $ieDtd = parcelRequire("ieDtd");
var $doZTA = parcelRequire("doZTA");
var $lVJAU = parcelRequire("lVJAU");
const $dee65df3d835c7b2$export$a73deb42718b5c4 = {
    // Values are 'object' or 'attribute'
    schemaMode: 'mode',
    // Values are 'list' or undefined
    objectViewMode: 'view',
    // Both of these params are supported to set the object type ID. 'typeId' is preferred and is the one that is updated.
    // 'objecttypeid' is only used on initial load to support customers who have bookmarked this URL.
    objectTypeId: 'typeId',
    fallbackObjectTypeId: 'objecttypeid',
    objectId: 'objectId'
};
const $dee65df3d835c7b2$export$f7855185bab37329 = 'reference-types';
const $dee65df3d835c7b2$export$3739ebbc7c6e87e8 = 'statuses';
const $dee65df3d835c7b2$export$2c22dc6c729ae0bd = 'icons';
const $dee65df3d835c7b2$export$f37b3a97acf56eaf = 'data-manager';
const $dee65df3d835c7b2$export$12ebb1d5017e1d6d = 'general';
const $dee65df3d835c7b2$export$a77734d9ea30fe44 = 'roles';
const $dee65df3d835c7b2$export$be37b820df30c947 = 'import';
const $dee65df3d835c7b2$export$670faa8ae93e0903 = 'inheritance';
const $dee65df3d835c7b2$export$e66acc5f4583ce1c = ()=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const [{ location: location }] = (0, $doZTA.useRouter)();
    const updateQueryParams = (0, $5uXOq.useCallback)((queryParams = {})=>{
        const { pathname: pathname, search: search } = location;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedQueryParams = {};
        Object.keys(queryParams).forEach((key)=>{
            updatedQueryParams[key] = queryParams[key] ?? undefined;
        });
        return `${pathname}?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
            ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search),
            ...updatedQueryParams
        })}`;
    }, [
        location
    ]);
    const pushRouterAction = (0, $5uXOq.useCallback)((path)=>{
        push(path);
    }, [
        push
    ]);
    return [
        {
            updateQueryParams: updateQueryParams,
            pushRouterAction: pushRouterAction
        }
    ];
};
const $dee65df3d835c7b2$export$f5a33d51dd6de08 = ()=>{
    const [objectTypeId, setObjectTypeId] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.objectTypeId);
    const [fallbackObjectTypeId, setFallbackObjectTypeId] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.fallbackObjectTypeId);
    (0, $5uXOq.useEffect)(()=>{
        if (fallbackObjectTypeId !== undefined) {
            setObjectTypeId((0, $5Ny9E.toCmdbObjectTypeId)(fallbackObjectTypeId), 'replace');
            setFallbackObjectTypeId(undefined, 'replace');
        }
    }, [
        fallbackObjectTypeId,
        setObjectTypeId,
        setFallbackObjectTypeId
    ]);
    const nullableMain = objectTypeId !== undefined ? (0, $5Ny9E.toCmdbObjectTypeId)(objectTypeId) : null;
    const nullableFallback = fallbackObjectTypeId !== undefined ? (0, $5Ny9E.toCmdbObjectTypeId)(fallbackObjectTypeId) : null;
    const setter = (newObjectTypeId, updateType)=>{
        setObjectTypeId(newObjectTypeId !== null ? newObjectTypeId : undefined, updateType);
    };
    return [
        nullableMain !== null ? nullableMain : nullableFallback,
        setter
    ];
};
const $dee65df3d835c7b2$export$a6e3187c87554a1e = ()=>{
    const [objectId, setObjectId] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.objectId);
    const nullableObjectId = objectId !== undefined ? (0, $5Ny9E.toCmdbObjectId)(objectId) : null;
    const setter = (newObjectId, updateType)=>{
        setObjectId(newObjectId !== null ? newObjectId : undefined, updateType);
    };
    return [
        nullableObjectId,
        setter
    ];
};
const $dee65df3d835c7b2$export$6abda0ad26022eff = ()=>{
    const [rawParamValue, setSchemaMode] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.schemaMode);
    const schemaMode = rawParamValue === 'attribute' ? 'attribute' : 'object';
    return [
        schemaMode,
        setSchemaMode
    ];
};
const $dee65df3d835c7b2$export$1927b50f7d074492 = ()=>{
    const [rawParamValue, setObjectViewMode] = (0, $ieDtd.useQueryParam)($dee65df3d835c7b2$export$a73deb42718b5c4.objectViewMode);
    const objectViewMode = rawParamValue === 'list' ? 'list' : 'details';
    const setter = (newValue, updateMode)=>{
        setObjectViewMode(newValue === 'list' ? 'list' : undefined, updateMode);
    };
    return [
        objectViewMode,
        setter
    ];
};

});


parcelRegister("eaKdt", function(module, exports) {

$parcel$export(module.exports, "HideL1MenuItemSection", () => $6a7321776d8332cb$export$a6246d2fccf72824);

var $bcArA = parcelRequire("bcArA");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7H980 = parcelRequire("7H980");
var $70rf1 = parcelRequire("70rf1");

var $6eFvr = parcelRequire("6eFvr");

var $fraBZ = parcelRequire("fraBZ");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");




var $jecJ3 = parcelRequire("jecJ3");

var $ivGSs = parcelRequire("ivGSs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $iszzG = parcelRequire("iszzG");

var $fS0Tg = parcelRequire("fS0Tg");

var $bMQWP = parcelRequire("bMQWP");

var $ji6RV = parcelRequire("ji6RV");
const $6a7321776d8332cb$var$HIDE_ROOT_MENU_ITEM_SUCCESS = 'HIDE_ROOT_MENU_ITEM_SUCCESS';
const $6a7321776d8332cb$var$RESTORE_ROOT_MENU_ITEM_SUCCESS = 'RESTORE_ROOT_MENU_ITEM_SUCCESS';
function $6a7321776d8332cb$var$HideL1MenuItemSectionInner(props) {
    const { menuId: menuId } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { navItems: navItems } = (0, $5uXOq.useContext)((0, $iszzG.NavItemsContext));
    const { peekMenuId: peekMenuId } = (0, $5uXOq.useContext)((0, $iszzG.PeekMenuIdContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const cloudID = (0, $koeKL.useCloudId)();
    const [isHidden, setIsHidden] = (0, $5uXOq.useState)(false);
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const [commit] = (0, $8Uumt.useMutation)((0, $bcArA.default));
    const onSave = (0, $5uXOq.useCallback)((newNavItems)=>{
        commit({
            variables: {
                input: {
                    cloudID: cloudID,
                    navKey: 'NAV_SIDEBAR',
                    navItems: newNavItems
                }
            }
        });
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'sidebarNavItems changed', {
            originalNavItems: navItems,
            updatedNavItems: newNavItems,
            changedFrom: 'hideFromSidebarButton'
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[menuId],
            attributes: {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
                parentItemId: (0, $jecJ3.SECTION_ITEM_MAP)[menuId],
                itemId: 'hideFromSidebar'
            }
        });
    }, [
        cloudID,
        commit,
        createAnalyticsEvent,
        menuId,
        navItems
    ]);
    const toggleNavItemVisibility = (0, $5uXOq.useCallback)(({ isVisible: isVisible })=>{
        const newNavItems = navItems.map((item)=>{
            if (item.menuId === menuId) return {
                ...item,
                isVisible: isVisible
            };
            return {
                ...item
            };
        });
        return newNavItems;
    }, [
        menuId,
        navItems
    ]);
    const onRestoreRootMenuItem = ()=>{
        if (navItems !== undefined) {
            const newNavItems = toggleNavItemVisibility({
                isVisible: true
            });
            onSave(newNavItems);
            setIsHidden(false);
            showFlag({
                type: 'success',
                id: $6a7321776d8332cb$var$RESTORE_ROOT_MENU_ITEM_SUCCESS,
                title: (0, $ji6RV.getNavItemRestoredFromSideBarFlagTitle)(menuId),
                isAutoDismiss: true,
                messageId: 'navigation-apps-sidebar-nav4-sidebars-common-core.ui.hide-l1-menu-item-action.show-flag.success.restore-root-menu-item-success',
                messageType: 'transactional'
            });
        }
    };
    const onHideRootMenuItem = ()=>{
        if (navItems !== undefined) {
            const newNavItems = toggleNavItemVisibility({
                isVisible: false
            });
            onSave(newNavItems);
            setIsHidden(true);
            showFlag({
                type: 'success',
                id: $6a7321776d8332cb$var$HIDE_ROOT_MENU_ITEM_SUCCESS,
                title: (0, $ji6RV.getNavItemHiddenFromSideBarFlagTitle)(menuId),
                isAutoDismiss: true,
                messageId: 'navigation-apps-sidebar-nav4-sidebars-common-core.ui.hide-l1-menu-item-action.show-flag.success.hide-root-menu-item-success',
                messageType: 'transactional',
                actions: [
                    {
                        content: (0, $bMQWP.default).moveBackToSidebar,
                        onClick: ()=>{
                            onRestoreRootMenuItem();
                            dismissFlag($6a7321776d8332cb$var$HIDE_ROOT_MENU_ITEM_SUCCESS);
                        }
                    }
                ]
            });
        }
    };
    // When the peekend menu id is the same as the menu id, the menu item is disabled because it's not possible
    // to hide an already hidden menu item. Do indicate this we need to both disable the button and set the color
    // of the icon and text appropriately.
    const isDisabled = peekMenuId === menuId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fraBZ.AnnouncerV2), {
        message: formatMessage((0, $ji6RV.getA11YAlert)(menuId)),
        shouldAnnounce: isHidden
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fS0Tg.HideIcon), {
            label: "",
            primaryColor: isDisabled ? 'color.icon.disabled' : 'color.icon'
        }),
        onClick: onHideRootMenuItem,
        isDisabled: isDisabled,
        "aria-label": formatMessage((0, $ji6RV.getA11YLabel)(menuId))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: isDisabled ? 'color.text.disabled' : 'color.text'
    }, formatMessage((0, $bMQWP.default).hideFromSidebar))));
}
function $6a7321776d8332cb$export$a6246d2fccf72824(props) {
    const { hasSeparator: hasSeparator = true, hasSection: hasSection = true } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: (0, $e0b5a9368b34b1c5$export$a3821bc63538b210),
        sourceType: (0, $4d5e0871c06cee03$export$d1123261ca8831d2),
        containerId: (0, $e0b5a9368b34b1c5$export$3c19576bd92ff564),
        containerType: (0, $e0b5a9368b34b1c5$export$fba7c3adda5094d9)
    }, hasSection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        hasSeparator: hasSeparator
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6a7321776d8332cb$var$HideL1MenuItemSectionInner, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6a7321776d8332cb$var$HideL1MenuItemSectionInner, props));
}

});
parcelRegister("bcArA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6858b1c2ad9da191$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<051e81191e9528d0339140ee7536941d>>
 * @relayHash 66baa10107c8516c24b8ed85cb97aa27
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b23a1defc70b85ce697c0dc1d84377c11fe03c64d3dbd4d0cb309c2158ac9e77
const $6858b1c2ad9da191$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "JiraConfigurableNavigationItem",
        "kind": "LinkedField",
        "name": "navItems",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "menuId"
            },
            {
                "kind": "ScalarField",
                "name": "isVisible"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "hideL1MenuItemActionMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserNavigationConfigurationPayload",
                            "kind": "LinkedField",
                            "name": "updateUserNavigationConfiguration",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraUserNavigationConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userNavigationConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "hideL1MenuItemActionMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserNavigationConfigurationPayload",
                            "kind": "LinkedField",
                            "name": "updateUserNavigationConfiguration",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraUserNavigationConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userNavigationConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b23a1defc70b85ce697c0dc1d84377c11fe03c64d3dbd4d0cb309c2158ac9e77",
            "metadata": {},
            "name": "hideL1MenuItemActionMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$6858b1c2ad9da191$var$node.hash = "1b96ba09e281b673ec1bfa126587621b";
var $6858b1c2ad9da191$export$2e2bcd8739ae039 = $6858b1c2ad9da191$var$node;

});

parcelRegister("fraBZ", function(module, exports) {

$parcel$export(module.exports, "AnnouncerV2", () => $f73a83ae5cba96ea$export$a43c8a2f4981e0e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dqoiX = parcelRequire("dqoiX");
const $f73a83ae5cba96ea$var$NON_BREAKING_SPACE = '\u00A0';
const $f73a83ae5cba96ea$export$a43c8a2f4981e0e = /*#__PURE__*/ (0, $5uXOq.memo)(({ message: originalMessage, liveMode: liveMode = 'polite', shouldAnnounce: shouldAnnounce = true, testId: testId })=>{
    const previousMessage = (0, $5uXOq.useRef)('');
    const setAlternatePolite = (0, $5uXOq.useRef)(false);
    const addSuffix = (0, $5uXOq.useRef)(false);
    const [oldMessage, setOldMessage] = (0, $5uXOq.useState)('');
    const [newMessage, setNewMessage] = (0, $5uXOq.useState)('');
    (0, $5uXOq.useEffect)(()=>{
        let message = shouldAnnounce ? originalMessage : $f73a83ae5cba96ea$var$NON_BREAKING_SPACE;
        if (previousMessage.current === message) {
            addSuffix.current = !addSuffix.current;
            if (addSuffix.current) message += $f73a83ae5cba96ea$var$NON_BREAKING_SPACE;
        }
        setOldMessage(setAlternatePolite.current ? '' : message);
        setNewMessage(setAlternatePolite.current ? message : '');
        if (shouldAnnounce) setAlternatePolite.current = !setAlternatePolite.current;
        previousMessage.current = originalMessage;
    }, [
        originalMessage,
        shouldAnnounce
    ]);
    // 2 aria-live containers needed to prevent bugs in browsers that will stop
    // announcing updates to the same div if these are too repetitive.
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dqoiX.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, oldMessage), /*#__PURE__*/ $5uXOq.createElement((0, $dqoiX.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, newMessage));
});
const $f73a83ae5cba96ea$var$positionRelative = null;

});
parcelRegister("dqoiX", function(module, exports) {

$parcel$export(module.exports, "visuallyHiddenStyles", () => $11827e0613b04108$export$8dd524ceb40e3d16);
$parcel$export(module.exports, "ScreenReaderText", () => $11827e0613b04108$export$88fad6aa294f111c);
$parcel$export(module.exports, "ScreenReaderCaption", () => $11827e0613b04108$export$200c8e5d652aa9af);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Visible only to screenreaders. Use when there is a need
 * to provide more context to a non-sighted user.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $11827e0613b04108$export$8dd524ceb40e3d16 = {
    clip: 'rect(1px, 1px, 1px, 1px)',
    clipPath: 'inset(50%)',
    height: '1px',
    width: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute'
};
const $11827e0613b04108$export$88fad6aa294f111c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _kqswstnw",
            __cmplp.className
        ])
    });
});
const $11827e0613b04108$export$200c8e5d652aa9af = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _kqswstnw",
            __cmplp.className
        ])
    });
});

});


const $1e554a683893bd46$export$4165a3d0da3bd147 = 'fixedItem';
const $1e554a683893bd46$export$95b0c331af13d819 = 'fixedItemButton';
const $1e554a683893bd46$export$74712b62056d422e = 'fixedItemAction';
const $1e554a683893bd46$export$3ac911b122986477 = 'customItem';
const $1e554a683893bd46$export$9bd6c21d500ae611 = 'customItemButton';
const $1e554a683893bd46$export$5374c2c2d3ece55e = 'customItemAction';
const $1e554a683893bd46$export$56981f28056f258e = 'customItemDropdownAction';
const $1e554a683893bd46$export$17bca95234dea43b = 'fixedItemDropdownAction';

const $e0b5a9368b34b1c5$export$a3821bc63538b210 = 'customiseSidebar';
const $e0b5a9368b34b1c5$export$fba7c3adda5094d9 = 'sidebar-nav4';
const $e0b5a9368b34b1c5$export$3c19576bd92ff564 = 'sidebar-content';

const $951a0ed422513987$export$265c523d1a8f25cf = '1';
const $951a0ed422513987$export$fe3b012b0224e4e1 = '2';
const $951a0ed422513987$export$f9db6a58b4aabd18 = '3';
const $951a0ed422513987$export$35ac629b8b943d5a = '4';

parcelRegister("ivGSs", function(module, exports) {

$parcel$export(module.exports, "getSideNavToggleButtonAnalyticEventPayload", () => $968dc7093f3ba590$export$7165a1ebf1926b86);
$parcel$export(module.exports, "MENU_ID_ANALYTIC_EVENT_IDS", () => $968dc7093f3ba590$export$d70e7a5f39328991);

var $jhS4y = parcelRequire("jhS4y");





var $jecJ3 = parcelRequire("jecJ3");
const $968dc7093f3ba590$var$SIDEBAR_TOGGLE = 'sidebarToggle';
const $968dc7093f3ba590$var$SIDEBAR_TOGGLE_ACTION_COLLAPSE = 'collapse';
const $968dc7093f3ba590$var$SIDEBAR_TOGGLE_ACTION_EXPAND = 'expand';
const $968dc7093f3ba590$var$CLICKED = 'clicked';
const $968dc7093f3ba590$export$7165a1ebf1926b86 = (isSideNavVisible, stage)=>{
    const toggleAction = isSideNavVisible ? $968dc7093f3ba590$var$SIDEBAR_TOGGLE_ACTION_COLLAPSE : $968dc7093f3ba590$var$SIDEBAR_TOGGLE_ACTION_EXPAND;
    const payload = {
        action: $968dc7093f3ba590$var$CLICKED,
        actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
        actionSubjectId: $968dc7093f3ba590$var$SIDEBAR_TOGGLE,
        attributes: {
            navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $68cb678dc917978e$export$793ed84f5e13fedc),
            stage: stage,
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            toggleAction: toggleAction
        }
    };
    return payload;
};
const $968dc7093f3ba590$export$d70e7a5f39328991 = {
    [(0, $jhS4y.MENU_ID_APPS)]: 'appsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_ASSETS)]: 'assetsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_DASHBOARDS)]: 'dashboardsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_FILTERS)]: 'filtersNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_GOALS)]: 'goalsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_OPERATIONS)]: 'operationsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_OVERVIEWS)]: 'overviewsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_PLANS)]: 'plansNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_PROJECTS)]: 'projectsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_RECENT)]: 'recentNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_STARRED)]: 'starredNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_TEAMS)]: 'teamsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_ROADMAPS)]: 'roadmapsNavigationMenuItem',
    [(0, $jhS4y.MENU_ID_CUSTOMER_SERVICE)]: 'customerServiceMenuItem',
    [(0, $jhS4y.MENU_ID_CUSTOMER_HUBS)]: 'customerHubsMenuItem',
    [(0, $jhS4y.MENU_ID_CUSTOMER_SERVICE_ANALYTICS)]: 'customerServiceAnalyticsMenuItem',
    [(0, $jhS4y.MENU_ID_GLOBAL_APP_ASSETS)]: (0, $jecJ3.GLOBAL_APP_SHORTCUT_ASSETS),
    [(0, $jhS4y.MENU_ID_GLOBAL_APP_GOALS)]: (0, $jecJ3.GLOBAL_APP_SHORTCUT_GOALS)
};

});
const $1520d876660a71bd$export$d2aa6c54a5925f01 = 'v3';
const $1520d876660a71bd$export$2bd315ece9f68967 = 'v4';

const $68cb678dc917978e$export$2ee9e5a3556c1e43 = 'sidebar';
const $68cb678dc917978e$export$793ed84f5e13fedc = 'top';
const $68cb678dc917978e$export$f1c9dd0f5207dd5e = 'tab';
const $68cb678dc917978e$export$b83d0ee9325a2d0a = 'projectTitle';

// TopNav or sidebar
const $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22 = 'global';
const $ce9c0831aed9ffb3$export$33d8c916a600c5e9 = 'container';


// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("koeKL", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $559e3c14e9652b55$export$9da0f7c65f28ed16);

var $9OXo1 = parcelRequire("9OXo1");
const $559e3c14e9652b55$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("fS0Tg", function(module, exports) {

$parcel$export(module.exports, "HideIcon", () => $a110cc98d6df0e48$export$3fa055d21925b0d3);

var $5uXOq = parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $a110cc98d6df0e48$var$CustomGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        id: "icon <icon>"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        id: "Vector",
        d: "M19.2405 10.6209L18.9347 11.3057C18.734 11.7553 18.3679 12.2877 17.8832 12.8226L18.5909 13.5303C18.8838 13.8232 18.8838 14.2981 18.5909 14.591C18.298 14.8839 17.8231 14.8839 17.5302 14.591L16.7926 13.8534C16.6895 13.9372 16.5839 14.0197 16.4761 14.1004C15.998 14.4583 15.4587 14.795 14.8732 15.0696L15.3415 16.0062C15.5267 16.3767 15.3766 16.8272 15.0061 17.0125C14.6356 17.1977 14.1851 17.0475 13.9999 16.677L13.4486 15.5744C12.9819 15.6864 12.4971 15.75 11.9999 15.75C11.5026 15.75 11.0179 15.6864 10.5512 15.5744L9.99986 16.677C9.81462 17.0475 9.36412 17.1977 8.99363 17.0125C8.62315 16.8272 8.47298 16.3767 8.65822 16.0062L9.12653 15.0696C8.54102 14.795 8.00173 14.4583 7.5236 14.1004C7.41582 14.0197 7.31026 13.9372 7.20713 13.8534L6.46955 14.591C6.17666 14.8839 5.70179 14.8839 5.40889 14.591C5.116 14.2981 5.116 13.8232 5.40889 13.5303L6.11656 12.8227C5.63186 12.2877 5.26571 11.7553 5.06502 11.3057L4.75928 10.6209L6.12898 10.0094L6.43472 10.6943C6.66455 11.2091 7.37568 12.1158 8.42257 12.8996C9.45878 13.6754 10.7174 14.25 11.9999 14.25C13.2823 14.25 14.541 13.6754 15.5772 12.8996C16.6241 12.1158 17.3352 11.2091 17.565 10.6943L17.8708 10.0094L19.2405 10.6209Z",
        fill: "currentColor"
    })));
const $a110cc98d6df0e48$export$3fa055d21925b0d3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ltBcH.default), {
        glyph: $a110cc98d6df0e48$var$CustomGlyph,
        ...props
    });

});

parcelRegister("bMQWP", function(module, exports) {

$parcel$export(module.exports, "default", () => $101e40a24fd8093e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $101e40a24fd8093e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    hideFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.hide-from-sidebar",
        "defaultMessage": "Hide from sidebar"
    },
    a11YAlertHideDefaultFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-default-from-sidebar",
        "defaultMessage": "Menu Item have been hidden from the sidebar"
    },
    // apps
    a11YHideAppsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-apps-from-sidebar",
        "defaultMessage": "Hide apps from sidebar"
    },
    a11YAlertHideAppsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-apps-from-sidebar",
        "defaultMessage": "Apps have been hidden from the sidebar"
    },
    // assets
    a11YHideAssetsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-assets-from-sidebar",
        "defaultMessage": "Hide assets from sidebar"
    },
    a11YAlertHideAssetsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-assets-from-sidebar",
        "defaultMessage": "Assets have been hidden from the sidebar"
    },
    // dashboards
    a11YHideDashboardsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-dashboards-from-sidebar",
        "defaultMessage": "Hide dashboards from sidebar"
    },
    a11YAlertHideDashboardsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-dashboards-from-sidebar",
        "defaultMessage": "Dashboards have been hidden from the sidebar"
    },
    // filters
    a11YHideFiltersFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-filters-from-sidebar",
        "defaultMessage": "Hide filters from sidebar"
    },
    a11YAlertHideFiltersFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-filters-from-sidebar",
        "defaultMessage": "Filters have been hidden from the sidebar"
    },
    // goals
    a11YHideGoalsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-goals-from-sidebar",
        "defaultMessage": "Hide goals from sidebar"
    },
    a11YAlertHideGoalsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-goals-from-sidebar",
        "defaultMessage": "Goals have been hidden from the sidebar"
    },
    // operations
    a11YHideOperationsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-operations-from-sidebar",
        "defaultMessage": "Hide operations from sidebar"
    },
    a11YAlertHideOperationsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-operations-from-sidebar",
        "defaultMessage": "Operations have been hidden from the sidebar"
    },
    // overviews
    a11YHideOverviewsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-overviews-from-sidebar",
        "defaultMessage": "Hide overviews from sidebar"
    },
    a11YAlertHideOverviewsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-overviews-from-sidebar",
        "defaultMessage": "Overviews have been hidden from the sidebar"
    },
    // plans
    a11YHidePlansFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-plans-from-sidebar",
        "defaultMessage": "Hide plans from sidebar"
    },
    a11YAlertHidePlansFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-plans-from-sidebar",
        "defaultMessage": "Plans have been hidden from the sidebar"
    },
    // projects
    a11YHideProjectsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-projects-from-sidebar",
        "defaultMessage": "Hide projects from sidebar"
    },
    a11YAlertHideProjectsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-projects-from-sidebar",
        "defaultMessage": "Projects have been hidden from the sidebar"
    },
    // teams
    a11YHideTeamsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-teams-from-sidebar",
        "defaultMessage": "Hide teams from sidebar"
    },
    a11YAlertHideTeamsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-teams-from-sidebar",
        "defaultMessage": "Teams have been hidden from the sidebar"
    },
    // roadmaps
    a11YHideRoadmapsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-hide-roadmaps-from-sidebar",
        "defaultMessage": "Hide roadmaps from sidebar"
    },
    a11YAlertHideRoadmapsFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.a-11-y-alert-hide-roadmaps-from-sidebar",
        "defaultMessage": "Roadmaps have been hidden from the sidebar"
    },
    // flags related texts
    moveBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.move-back-to-sidebar",
        "defaultMessage": "Move back to sidebar"
    },
    defaultHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.default-hidden-from-sidebar",
        "defaultMessage": "Hidden from sidebar"
    },
    appsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.apps-hidden-from-sidebar",
        "defaultMessage": "Apps hidden from sidebar"
    },
    assetsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.assets-hidden-from-sidebar",
        "defaultMessage": "Assets hidden from sidebar"
    },
    dashboardsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.dashboards-hidden-from-sidebar",
        "defaultMessage": "Dashboards hidden from sidebar"
    },
    filtersHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.filters-hidden-from-sidebar",
        "defaultMessage": "Filters hidden from sidebar"
    },
    goalsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.goals-hidden-from-sidebar",
        "defaultMessage": "Goals hidden from sidebar"
    },
    operationsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.operations-hidden-from-sidebar",
        "defaultMessage": "Operations hidden from sidebar"
    },
    overviewsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.overviews-hidden-from-sidebar",
        "defaultMessage": "Overviews hidden from sidebar"
    },
    plansHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.plans-hidden-from-sidebar",
        "defaultMessage": "Plans hidden from sidebar"
    },
    projectsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-hidden-from-sidebar",
        "defaultMessage": "Projects hidden from sidebar"
    },
    teamsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.teams-hidden-from-sidebar",
        "defaultMessage": "Teams hidden from sidebar"
    },
    roadmapsHiddenFromSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.roadmaps-hidden-from-sidebar",
        "defaultMessage": "Roadmaps hidden from sidebar"
    },
    defaultMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.default-moved-back-to-sidebar",
        "defaultMessage": "Moved back to sidebar"
    },
    appsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.apps-moved-back-to-sidebar",
        "defaultMessage": "Apps moved back to sidebar"
    },
    assetsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.assets-moved-back-to-sidebar",
        "defaultMessage": "Assets moved back to sidebar"
    },
    dashboardsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.dashboards-moved-back-to-sidebar",
        "defaultMessage": "Dashboards moved back to sidebar"
    },
    filtersMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.filters-moved-back-to-sidebar",
        "defaultMessage": "Filters moved back to sidebar"
    },
    goalsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.goals-moved-back-to-sidebar",
        "defaultMessage": "Goals moved back to sidebar"
    },
    operationsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.operations-moved-back-to-sidebar",
        "defaultMessage": "Operations moved back to sidebar"
    },
    overviewsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.overviews-moved-back-to-sidebar",
        "defaultMessage": "Overviews moved back to sidebar"
    },
    plansMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.plans-moved-back-to-sidebar",
        "defaultMessage": "Plans moved back to sidebar"
    },
    projectsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.projects-moved-back-to-sidebar",
        "defaultMessage": "Projects moved back to sidebar"
    },
    teamsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.teams-moved-back-to-sidebar",
        "defaultMessage": "Teams moved back to sidebar"
    },
    roadmapsMovedBackToSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-core.hide-l1-menu-item-action.roadmaps-moved-back-to-sidebar",
        "defaultMessage": "Roadmaps moved back to sidebar"
    }
});

});

parcelRegister("ji6RV", function(module, exports) {

$parcel$export(module.exports, "getA11YLabel", () => $88b27df430ca218e$export$fcb002b66b92bf50);
$parcel$export(module.exports, "getA11YAlert", () => $88b27df430ca218e$export$45edd6abaa8989eb);
$parcel$export(module.exports, "getNavItemHiddenFromSideBarFlagTitle", () => $88b27df430ca218e$export$95caae642a80ad);
$parcel$export(module.exports, "getNavItemRestoredFromSideBarFlagTitle", () => $88b27df430ca218e$export$d4ad18508eb0e1ec);

var $46Cti = parcelRequire("46Cti");

var $bMQWP = parcelRequire("bMQWP");
const $88b27df430ca218e$export$fcb002b66b92bf50 = (menuId)=>{
    switch(menuId){
        case (0, $46Cti.L1_MENU_ID).APPS:
            return (0, $bMQWP.default).a11YHideAppsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).GOALS:
            return (0, $bMQWP.default).a11YHideGoalsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).ROADMAPS:
            return (0, $bMQWP.default).a11YHideRoadmapsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).PLANS:
            return (0, $bMQWP.default).a11YHidePlansFromSidebar;
        case (0, $46Cti.L1_MENU_ID).PROJECTS:
            return (0, $bMQWP.default).a11YHideProjectsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).FILTERS:
            return (0, $bMQWP.default).a11YHideFiltersFromSidebar;
        case (0, $46Cti.L1_MENU_ID).DASHBOARDS:
            return (0, $bMQWP.default).a11YHideDashboardsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).OVERVIEWS:
            return (0, $bMQWP.default).a11YHideOverviewsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).OPERATIONS:
            return (0, $bMQWP.default).a11YHideOperationsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).ASSETS:
            return (0, $bMQWP.default).a11YHideAssetsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).TEAMS:
            return (0, $bMQWP.default).a11YHideTeamsFromSidebar;
        default:
            return (0, $bMQWP.default).hideFromSidebar;
    }
};
const $88b27df430ca218e$export$45edd6abaa8989eb = (menuId)=>{
    switch(menuId){
        case (0, $46Cti.L1_MENU_ID).APPS:
            return (0, $bMQWP.default).a11YAlertHideAppsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).GOALS:
            return (0, $bMQWP.default).a11YAlertHideGoalsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).ROADMAPS:
            return (0, $bMQWP.default).a11YAlertHideRoadmapsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).PLANS:
            return (0, $bMQWP.default).a11YAlertHidePlansFromSidebar;
        case (0, $46Cti.L1_MENU_ID).PROJECTS:
            return (0, $bMQWP.default).a11YAlertHideProjectsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).FILTERS:
            return (0, $bMQWP.default).a11YAlertHideFiltersFromSidebar;
        case (0, $46Cti.L1_MENU_ID).DASHBOARDS:
            return (0, $bMQWP.default).a11YAlertHideDashboardsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).OVERVIEWS:
            return (0, $bMQWP.default).a11YAlertHideOverviewsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).OPERATIONS:
            return (0, $bMQWP.default).a11YAlertHideOperationsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).ASSETS:
            return (0, $bMQWP.default).a11YAlertHideAssetsFromSidebar;
        case (0, $46Cti.L1_MENU_ID).TEAMS:
            return (0, $bMQWP.default).a11YAlertHideTeamsFromSidebar;
        default:
            return (0, $bMQWP.default).a11YAlertHideDefaultFromSidebar;
    }
};
const $88b27df430ca218e$export$95caae642a80ad = (menuId)=>{
    switch(menuId){
        case (0, $46Cti.L1_MENU_ID).APPS:
            return (0, $bMQWP.default).appsHiddenFromSidebar;
        case (0, $46Cti.L1_MENU_ID).GOALS:
            return (0, $bMQWP.default).goalsHiddenFromSidebar;
        case (0, $46Cti.L1_MENU_ID).ROADMAPS:
            return (0, $bMQWP.default).roadmapsHiddenFromSidebar;
        case (0, $46Cti.L1_MENU_ID).PLANS:
            return (0, $bMQWP.default).plansHiddenFromSidebar;
        case (0, $46Cti.L1_MENU_ID).PROJECTS:
            return (0, $bMQWP.default).projectsHiddenFromSidebar;
        case (0, $46Cti.L1_MENU_ID).FILTERS:
            return (0, $bMQWP.default).filtersMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).DASHBOARDS:
            return (0, $bMQWP.default).dashboardsHiddenFromSidebar;
        case (0, $46Cti.L1_MENU_ID).OVERVIEWS:
            return (0, $bMQWP.default).overviewsHiddenFromSidebar;
        case (0, $46Cti.L1_MENU_ID).OPERATIONS:
            return (0, $bMQWP.default).operationsHiddenFromSidebar;
        case (0, $46Cti.L1_MENU_ID).ASSETS:
            return (0, $bMQWP.default).assetsHiddenFromSidebar;
        case (0, $46Cti.L1_MENU_ID).TEAMS:
            return (0, $bMQWP.default).teamsHiddenFromSidebar;
        default:
            return (0, $bMQWP.default).defaultHiddenFromSidebar;
    }
};
const $88b27df430ca218e$export$d4ad18508eb0e1ec = (menuId)=>{
    switch(menuId){
        case (0, $46Cti.L1_MENU_ID).APPS:
            return (0, $bMQWP.default).appsMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).GOALS:
            return (0, $bMQWP.default).goalsMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).ROADMAPS:
            return (0, $bMQWP.default).roadmapsMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).PLANS:
            return (0, $bMQWP.default).plansMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).PROJECTS:
            return (0, $bMQWP.default).projectsMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).FILTERS:
            return (0, $bMQWP.default).filtersMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).DASHBOARDS:
            return (0, $bMQWP.default).dashboardsMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).OVERVIEWS:
            return (0, $bMQWP.default).overviewsMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).OPERATIONS:
            return (0, $bMQWP.default).operationsMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).ASSETS:
            return (0, $bMQWP.default).assetsMovedBackToSidebar;
        case (0, $46Cti.L1_MENU_ID).TEAMS:
            return (0, $bMQWP.default).teamsMovedBackToSidebar;
        default:
            return (0, $bMQWP.default).defaultMovedBackToSidebar;
    }
};

});


parcelRegister("c6lNO", function(module, exports) {

$parcel$export(module.exports, "default", () => $13e6c2b0b872598c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $3yFuy = parcelRequire("3yFuy");
const $13e6c2b0b872598c$var$MenuButtonItemWithAnalytics = ({ analytics: analytics, onClick: onClick, ...rest }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const handleClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        if (!analytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = analytics;
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), actionSubjectId, analyticsAttributes);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3yFuy.MenuButtonItem), {
        ref: ref,
        onClick: handleClick,
        ...rest
    });
};
var $13e6c2b0b872598c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.forwardRef)($13e6c2b0b872598c$var$MenuButtonItemWithAnalytics);

});
parcelRegister("3yFuy", function(module, exports) {

$parcel$export(module.exports, "MenuButtonItem", () => $6b5048cf3b871243$export$35e89d121b5de79a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kTSv9 = parcelRequire("kTSv9");

var $4vWwj = parcelRequire("4vWwj");
const $6b5048cf3b871243$export$35e89d121b5de79a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef }, forwardedRef)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4vWwj.MenuListItem), {
        ref: listItemRef,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kTSv9.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            /**
				 * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
				 * so they aren't rendered in the disabled state.
				 */ actions: isDisabled ? undefined : actions,
            actionsOnHover: isDisabled ? undefined : actionsOnHover,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            children: children
        })
    }));

});
parcelRegister("4vWwj", function(module, exports) {

$parcel$export(module.exports, "MenuListItem", () => $302dd396973afac9$export$6c2f3257abc4825b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $92SLf = parcelRequire("92SLf");
const $302dd396973afac9$export$6c2f3257abc4825b = (0, $92SLf.ListItem);

});



parcelRegister("aCS3f", function(module, exports) {

$parcel$export(module.exports, "MoreNavMenuButton", () => $75aa993ce8b7228b$export$df3f5812ef8777cb);

var $5uXOq = parcelRequire("5uXOq");

var $jgJNO = parcelRequire("jgJNO");

var $cDvOQ = parcelRequire("cDvOQ");

var $fa1Fm = parcelRequire("fa1Fm");

var $98dJo = parcelRequire("98dJo");
const $75aa993ce8b7228b$export$df3f5812ef8777cb = ({ MenuItems: MenuItems, name: name, onOpen: onOpen, onClose: onCloseFlyout })=>{
    const { isOpen: isOpen, onClose: onCloseDropdown, onToggle: onToggle } = (0, $cDvOQ.useOpenable)();
    const content = (contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fa1Fm.MoreNavMenuButtonSubmenu), {
            ...contentProps,
            MenuItems: MenuItems
        });
    const onClose = (0, $5uXOq.useCallback)((e)=>{
        try {
            onCloseFlyout?.(e);
        } finally{
            onCloseDropdown();
        }
    }, [
        onCloseFlyout,
        onCloseDropdown
    ]);
    const onTriggerClick = (0, $5uXOq.useCallback)(()=>{
        try {
            if (!isOpen) onOpen?.();
        } finally{
            onToggle();
        }
    }, [
        isOpen,
        onOpen,
        onToggle
    ]);
    const trigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $98dJo.MoreNavMenuButtonTrigger), {
            ...triggerProps,
            name: name,
            onClick: onTriggerClick
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        content: content,
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        messageId: "navigation-apps-sidebar-nav4-sidebars-common-core.ui.more-nav-menu-button.popup",
        messageType: "transactional",
        trigger: trigger,
        shouldRenderToParent: true
    });
};

});
parcelRegister("jgJNO", function(module, exports) {

$parcel$export(module.exports, "JiraPopup", () => $93ebfe5964b2617d$export$2da4be1e3f9adef3);

var $5uXOq = parcelRequire("5uXOq");

var $vCqQa = parcelRequire("vCqQa");

var $10xFf = parcelRequire("10xFf");

var $egZ8z = parcelRequire("egZ8z");
const $93ebfe5964b2617d$export$2da4be1e3f9adef3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egZ8z.ChoreographerPopup), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $vCqQa.Popup), rest);
};

});
parcelRegister("egZ8z", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPopup", () => $985c2abc03675c6b$export$8ecc19d18d3df807);

var $vCqQa = parcelRequire("vCqQa");

var $fG5AJ = parcelRequire("fG5AJ");
const $985c2abc03675c6b$export$8ecc19d18d3df807 = (0, $fG5AJ.withChoreographedToggle)((0, $vCqQa.Popup), 'isOpen', 'content');

});


parcelRegister("cDvOQ", function(module, exports) {

$parcel$export(module.exports, "useOpenable", () => $89d72d59f9676a7b$export$e07f550759260fd7);

var $5uXOq = parcelRequire("5uXOq");
const $89d72d59f9676a7b$export$e07f550759260fd7 = (initialState = false)=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(initialState);
    const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const onOpen = (0, $5uXOq.useCallback)(()=>setIsOpen(true), [
        setIsOpen
    ]);
    const onToggle = (0, $5uXOq.useCallback)(()=>setIsOpen((value)=>!value), [
        setIsOpen
    ]);
    return {
        isOpen: isOpen,
        onClose: onClose,
        onOpen: onOpen,
        onToggle: onToggle,
        setIsOpen: setIsOpen
    };
};

});

parcelRegister("fa1Fm", function(module, exports) {

$parcel$export(module.exports, "MoreNavMenuButtonSubmenu", () => $60df3cdd5682c247$export$ac88f3e136748c4a);

var $5uXOq = parcelRequire("5uXOq");

var $aOrxC = parcelRequire("aOrxC");

var $0yZbT = parcelRequire("0yZbT");

var $4DrQd = parcelRequire("4DrQd");
const $60df3cdd5682c247$var$stopEventPropagation = (event)=>event.stopPropagation();
const $60df3cdd5682c247$export$ac88f3e136748c4a = ({ MenuItems: MenuItems, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        onMouseEnter: $60df3cdd5682c247$var$stopEventPropagation,
        onMouseLeave: $60df3cdd5682c247$var$stopEventPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), {
        minWidth: (0, $4DrQd.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItems, {
        onClose: onClose
    })));

});

parcelRegister("98dJo", function(module, exports) {

$parcel$export(module.exports, "MoreNavMenuButtonTrigger", () => $404df4ddac9bf885$export$c1fd214ac7085e79);

var $5uXOq = parcelRequire("5uXOq");

var $4AeHp = parcelRequire("4AeHp");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $1xonH = parcelRequire("1xonH");

var $cwTmj = parcelRequire("cwTmj");
const $404df4ddac9bf885$export$c1fd214ac7085e79 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ name: name, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xonH.CommonNavMenuButton), {
        ...props,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4AeHp))),
        label: name ? formatMessage((0, $cwTmj.default).moreActionsFor, {
            name: name
        }) : formatMessage((0, $cwTmj.default).moreActions),
        ref: ref,
        ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-meatball-menu-button-tooltips') ? {
            isTooltipDisabled: false,
            tooltip: {
                content: formatMessage((0, $cwTmj.default).moreActions),
                hideTooltipOnClick: true
            }
        } : {}
    });
});

});
parcelRegister("4AeHp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab63f49f3262af83b926e204475086f6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3565ed240e83552e$var$_react = $3565ed240e83552e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3565ed240e83552e$var$_baseNew = $3565ed240e83552e$var$_interopRequireDefault((parcelRequire("enEmH")));
function $3565ed240e83552e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for secondary/tertiary more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3565ed240e83552e$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $3565ed240e83552e$var$_react.default.createElement($3565ed240e83552e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.25 6.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M0 6a1.25 1.25 0 1 1 2.5 0A1.25 1.25 0 0 1 0 6m6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M4.75 6a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M9.5 6A1.25 1.25 0 1 1 12 6a1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"/><path fill="currentcolor" d="M1.5 6A.25.25 0 1 1 1 6a.25.25 0 0 1 .5 0m4.75 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M11 6a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"/>`,
        type: 'utility'
    }, props));
$3565ed240e83552e$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $3565ed240e83552e$var$_default = module.exports.default = $3565ed240e83552e$var$ShowMoreHorizontalIcon;

});

parcelRegister("dCm1o", function(module, exports) {

$parcel$export(module.exports, "isVisualRefreshEnabled", () => $322f7f27e3ad3058$export$48345cb467db19b6);

var $3HwlS = parcelRequire("3HwlS");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $1i1R1 = parcelRequire("1i1R1");
const $322f7f27e3ad3058$export$48345cb467db19b6 = ()=>{
    if ((0, $4R6GH.fg)('nav4_visual_refresh_merger')) return (0, $3HwlS.getWillShowNav4)();
    return (0, $4R6GH.fg)('visual-refresh') && // Kill switch for the entire rollout of the visual refresh
    ($322f7f27e3ad3058$var$isVisualRefreshInDogfooding() || $322f7f27e3ad3058$var$isVisualRefreshInEAP() || $322f7f27e3ad3058$var$isVisualRefreshInOpenBeta());
};
// Used for the dogfooding of the visual refresh
const $322f7f27e3ad3058$var$isVisualRefreshInDogfooding = ()=>(0, $4R6GH.fg)('visual-refresh-dogfood') && !(0, $1i1R1.getIsNav4UserOptOut)();
// Used for the EAP of the visual refresh
const $322f7f27e3ad3058$var$isVisualRefreshInEAP = ()=>(0, $4R6GH.fg)('visual-refresh-eap') && !(0, $1i1R1.getIsNav4UserOptOut)();
// Used for the OpenBeta of the visual refresh
const $322f7f27e3ad3058$var$isVisualRefreshInOpenBeta = ()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('visual-refresh-beta-existing-customers') && !(0, $1i1R1.getIsNav4UserOptOut)() || (0, $4R6GH.fg)('visual-refresh-beta-sandboxes') || (0, $6s1PB.expVal)('jira_nav4_beta_free-customers', 'isVisualRefreshEnabled', false) || (0, $6s1PB.expVal)('jira_nav4_beta_new-customers', 'isVisualRefreshEnabled', false) || (0, $6s1PB.expVal)('confluence_jira_nav4_new_customers', 'isVisualRefreshEnabled', false);

});

parcelRegister("1xonH", function(module, exports) {

$parcel$export(module.exports, "CommonNavMenuButton", () => $aa94212e0d70bb87$export$358f21998d56a71e);

var $5uXOq = parcelRequire("5uXOq");

var $1Seuh = parcelRequire("1Seuh");
const $aa94212e0d70bb87$export$358f21998d56a71e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, icon: Icon, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
        ...props,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
                ...iconProps,
                size: "small"
            }),
        onClick: onClick,
        ref: ref,
        spacing: "compact",
        appearance: "subtle"
    }));

});

parcelRegister("cwTmj", function(module, exports) {

$parcel$export(module.exports, "default", () => $83d1dc5b83237d0a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $83d1dc5b83237d0a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moreActions: {
        "id": "navigation-apps-sidebar-nav4-common.more-nav-menu-button.trigger.more-actions",
        "defaultMessage": "More actions"
    },
    moreActionsFor: {
        "id": "navigation-apps-sidebar-nav4-common.more-nav-menu-button.trigger.more-actions-for",
        "defaultMessage": "More actions for {name}"
    }
});

});



parcelRegister("85JfV", function(module, exports) {

$parcel$export(module.exports, "AsyncCmdbUpsellPage", () => $b37619bcb54c01d2$export$659eb30d49d6ed87);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b37619bcb54c01d2$var$LazyCmdbUpsellPage = (0, $b7Svb.lazy)(()=>(parcelRequire("7UIWD")).then((module)=>module.UpsellPage), {
    moduleId: "./src/packages/servicedesk/cmdb/cmdb-upsell-page/src/ui/index.tsx"
});
const $b37619bcb54c01d2$export$659eb30d49d6ed87 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "cmdb-upsell-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b37619bcb54c01d2$var$LazyCmdbUpsellPage, null));

});
parcelRegister("7UIWD", function(module, exports) {

let $017ca7bfc2467bf2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $017ca7bfc2467bf2$var$load("8TQcW").then(()=>parcelRequire('dhOKV'));

});


parcelRegister("9wUqW", function(module, exports) {

$parcel$export(module.exports, "default", () => $63c530e31abad1b1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $63c530e31abad1b1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    openAssetsApp: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.open-assets-app",
        "defaultMessage": "Open Assets"
    },
    upsellLozengeText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-app-item.upsell-lozenge-text",
        "defaultMessage": "Premium"
    }
});

});


parcelRegister("cNd4s", function(module, exports) {

$parcel$export(module.exports, "useIsSiteAdmin", () => $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef);

var $9OXo1 = parcelRequire("9OXo1");
const $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isSiteAdmin || false;
};

});

parcelRegister("3RvHe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e923a6c97ae94827$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e923a6c97ae94827$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    lozenge: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.assets.lozenge",
        "defaultMessage": "Try"
    },
    assets: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.assets.assets",
        "defaultMessage": "Assets"
    }
});

});


parcelRegister("RMW1a", function(module, exports) {

$parcel$export(module.exports, "Goals", () => $a9a9e246a26b4e96$export$3c4000465299790);

var $5uXOq = parcelRequire("5uXOq");

var $ab1Yt = parcelRequire("ab1Yt");

var $lNrAz = parcelRequire("lNrAz");

var $koVbs = parcelRequire("koVbs");

var $ctUNb = parcelRequire("ctUNb");

var $2YlU4 = parcelRequire("2YlU4");
function $a9a9e246a26b4e96$export$3c4000465299790({ onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const url = 'https://home.atlassian.com/goals';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctUNb.MenuLinkItem), {
        href: url,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lNrAz))), {
            label: ""
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ab1Yt.GoalsIcon), null),
        target: "_blank",
        onClick: onClick,
        testId: "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.ui.goals.menu-link-item"
    }, formatMessage((0, $2YlU4.default).goals));
}

});
parcelRegister("2YlU4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddddb229bf99ab01$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ddddb229bf99ab01$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    goals: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.goals.goals",
        "defaultMessage": "Goals"
    }
});

});



const $3287f4a6e09b4c02$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4GlobalAppShortcuts';
const $3287f4a6e09b4c02$export$d57b6b390e78d90f = 'jira-cosmos';


parcelRegister("11ALy", function(module, exports) {

$parcel$export(module.exports, "TopLevelSpacer", () => $8b4317baeb21df06$export$5776f68925982056);
/* top-level-spacer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fOnXR = parcelRequire("fOnXR");
const $8b4317baeb21df06$var$styles = {
    root: "_4t3iutpp"
};
function $8b4317baeb21df06$export$5776f68925982056() {
    const level = (0, $fOnXR.useLevel)();
    (0, $5uXOq.useEffect)(()=>{}, [
        level
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $8b4317baeb21df06$var$styles.root
        ])
    });
}

});

parcelRegister("3muxY", function(module, exports) {

$parcel$export(module.exports, "ConfigurableMenuItem", () => $8be3eed13df9fa08$export$5de02966decf8405);

var $59EX7 = parcelRequire("59EX7");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $46Cti = parcelRequire("46Cti");

var $3iY1w = parcelRequire("3iY1w");

var $67KAW = parcelRequire("67KAW");

var $kcT7A = parcelRequire("kcT7A");

var $aXxBX = parcelRequire("aXxBX");

var $kcmzD = parcelRequire("kcmzD");

var $blbXb = parcelRequire("blbXb");

var $VyuC0 = parcelRequire("VyuC0");

var $iKHgp = parcelRequire("iKHgp");

var $lz3si = parcelRequire("lz3si");

var $1YUDD = parcelRequire("1YUDD");

var $3nmOf = parcelRequire("3nmOf");

var $abrAF = parcelRequire("abrAF");

var $3J4Wg = parcelRequire("3J4Wg");

var $cq1bX = parcelRequire("cq1bX");

var $96poX = parcelRequire("96poX");

var $1zjdl = parcelRequire("1zjdl");

var $3cFRo = parcelRequire("3cFRo");
function $8be3eed13df9fa08$export$5de02966decf8405({ isDefaultOpen: isDefaultOpen = false, menuData: menuData, menuId: menuId }) {
    const data = (0, $8Uumt.useFragment)((0, $59EX7.default), menuData);
    const shouldRenderOverviews = (0, $iKHgp.useShouldRenderOverviews)();
    switch(menuId){
        case (0, $46Cti.L1_MENU_ID).APPS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iY1w.Nav4Apps), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $46Cti.L1_MENU_ID).ASSETS:
            /* remove this case on
       * blu-6313_sidebar_global_app_shortcuts cleanup &&
       * assets_as_an_app_v2 cleanup &&
       * blu-6576_migrate_to_platform_customisation cleanup
       */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67KAW.Nav4Assets), {
                isExpanded: isDefaultOpen
            });
        case (0, $46Cti.L1_MENU_ID).DASHBOARDS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kcmzD.Nav4Dashboards), {
                isExpanded: isDefaultOpen
            });
        case (0, $46Cti.L1_MENU_ID).FILTERS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $blbXb.Nav4Filters), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $46Cti.L1_MENU_ID).GOALS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3cFRo.Stub), {
                menuId: (0, $46Cti.L1_MENU_ID).GOALS,
                href: (0, $1zjdl.USER_NAVIGATION_ITEM_LINKS)[(0, $46Cti.L1_MENU_ID).GOALS]
            });
        case (0, $46Cti.L1_MENU_ID).OPERATIONS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $VyuC0.Nav4Operations), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $46Cti.L1_MENU_ID).PLANS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1YUDD.Nav4Plans), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $46Cti.L1_MENU_ID).OVERVIEWS:
            return shouldRenderOverviews && (0, $4R6GH.fg)('blu-2858-sidebar-menu-overviews') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lz3si.Nav4Overviews), {
                isExpanded: isDefaultOpen,
                queryRef: data
            }) : null;
        case (0, $46Cti.L1_MENU_ID).PROJECTS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3nmOf.Nav4Projects), {
                isExpanded: isDefaultOpen,
                queryRef: data
            });
        case (0, $46Cti.L1_MENU_ID).RECENT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $abrAF.Recent), null);
        case (0, $46Cti.L1_MENU_ID).ROADMAPS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3J4Wg.Nav4Roadmaps), {
                isExpanded: isDefaultOpen
            });
        case (0, $46Cti.L1_MENU_ID).STARRED:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cq1bX.Starred), null);
        case (0, $46Cti.L1_MENU_ID).TEAMS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96poX.Teams), null);
        case (0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE:
            return (0, $4R6GH.fg)('jcs_master_flag') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aXxBX.CustomerService), null) : null;
        case (0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS:
            return (0, $4R6GH.fg)('jcs-analytics-page') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kcT7A.CustomerServiceAnalytics), null) : null;
        default:
            return null;
    }
}

});
parcelRegister("59EX7", function(module, exports) {

$parcel$export(module.exports, "default", () => $047ebaf8cd6dba5c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<237b885497b658573d984371ca06695a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $047ebaf8cd6dba5c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfigurableMenuItem",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4Projects"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Filters"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Plans"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Apps"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Operations"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4Overviews"
        }
    ],
    "type": "Query"
};
$047ebaf8cd6dba5c$var$node.hash = "5c4da86f47569a65309ccf227624f58f";
var $047ebaf8cd6dba5c$export$2e2bcd8739ae039 = $047ebaf8cd6dba5c$var$node;

});

parcelRegister("3iY1w", function(module, exports) {

$parcel$export(module.exports, "Nav4Apps", () => $37401459bf6b58c5$export$8473036ee9e92881);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $ksJl5 = parcelRequire("ksJl5");

var $l8ruj = parcelRequire("l8ruj");


var $6EHtA = parcelRequire("6EHtA");
const $37401459bf6b58c5$export$8473036ee9e92881 = (props)=>{
    const getAttributes = (0, $5uXOq.useCallback)((error)=>(0, $6EHtA.createAttributes)({
            error: error,
            component: 'Nav4Apps'
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-apps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "apps-section",
        attributes: getAttributes,
        packageName: (0, $13973d4cc5182a50$export$b8b9d90f9e5bd72b),
        teamName: (0, $13973d4cc5182a50$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ksJl5.Nav4Apps), props)));
};

});
parcelRegister("ksJl5", function(module, exports) {

$parcel$export(module.exports, "Nav4Apps", () => $00f56297c031450d$export$8473036ee9e92881);

var $c8TfS = parcelRequire("c8TfS");

var $gQbcG = parcelRequire("gQbcG");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $9ETtY = parcelRequire("9ETtY");

var $jEa4c = parcelRequire("jEa4c");

var $cbY68 = parcelRequire("cbY68");

var $iJgtS = parcelRequire("iJgtS");

var $nX8wH = parcelRequire("nX8wH");

var $bhapp = parcelRequire("bhapp");
function $00f56297c031450d$export$8473036ee9e92881(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bhapp.Nav4AppsSpotlightWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($00f56297c031450d$var$Nav4AppsInner, props));
}
function $00f56297c031450d$var$Nav4AppsInner({ isExpanded: isExpanded, queryRef: queryRef }) {
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const data = (0, $8Uumt.useFragment)((0, $gQbcG.default), queryRef);
    /* eslint-disable @atlassian/relay/unused-fields */ const globalAppNavigationItems = (0, $8Uumt.useFragment)((0, $c8TfS.default), data.jira);
    /* eslint-enable @atlassian/relay/unused-fields */ // $isAppsExpanded (in the query) is based on the same logic as in isInitialSelectedPath(MENU_ID_APPS).
    // However, below we filter out false positives based on extra data we retrieve from GraphQL.
    // We simply can't determine whether the general Connect app is a part of the "Apps" section or not without that extra data.
    // And we would like to avoid situations where the "Apps" section is expanded when it shouldn't be.
    // Keep in mind that global Connect app != general Connect app. Global app is a subset of the general app.
    // General app can be rendered in various contexts, while the global one only under the "Apps" section.
    const isMaybeAppsSectionRoute = isInitialSelectedPath((0, $jhS4y.MENU_ID_APPS));
    const isGeneralConnectRoute = (0, $9ETtY.useIsGeneralConnectRoute)();
    const isGlobalConnectAppRoute = (0, $nX8wH.useIsGlobalConnectAppRoute)({
        data: globalAppNavigationItems
    });
    const isAppsSectionExpanded = isMaybeAppsSectionRoute && (isGeneralConnectRoute ? isGlobalConnectAppRoute : true);
    const sectionActions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jEa4c.SectionActions), null);
    return isAppsSectionExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iJgtS.Nav4AppsForLanding), {
        actionsOnHover: sectionActions,
        isExpanded: isExpanded,
        queryRef: data.jira
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cbY68.Nav4AppsDefault), {
        actionsOnHover: sectionActions,
        isExpanded: isExpanded
    });
}

});
parcelRegister("c8TfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $58cc3d53236e7f5f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b841eae00c140d0fa10ac87feab52bf9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $58cc3d53236e7f5f$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "isAppsExpanded"
            }
        ],
        "kind": "Fragment",
        "name": "Nav4Apps_GlobalAppsFragment",
        "selections": [
            {
                "condition": "isAppsExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "JiraNavigationItemConnection",
                        "kind": "LinkedField",
                        "name": "globalAppNavigationItems",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraNavigationItemEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "appType"
                                                    },
                                                    v0 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraAppSection",
                                                        "kind": "LinkedField",
                                                        "name": "sections",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraAppNavigationItemNestedLink",
                                                                "kind": "LinkedField",
                                                                "name": "links",
                                                                "plural": true,
                                                                "selections": [
                                                                    v0 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraAppNavigationItem"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
}();
$58cc3d53236e7f5f$var$node.hash = "fcee4331eb5ce6a0f2c7ee593634458d";
var $58cc3d53236e7f5f$export$2e2bcd8739ae039 = $58cc3d53236e7f5f$var$node;

});

parcelRegister("gQbcG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea6f03604759aa38$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf10716a4c00972068007e73ef5b1c3f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ea6f03604759aa38$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isAppsExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Apps",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "isAppsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "Nav4AppsForLanding"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "Nav4Apps_GlobalAppsFragment"
                    }
                ]
            },
            "action": "THROW",
            "path": "jira"
        }
    ],
    "type": "Query"
};
$ea6f03604759aa38$var$node.hash = "c3df504da3663fd99ebe67a0d32de67f";
var $ea6f03604759aa38$export$2e2bcd8739ae039 = $ea6f03604759aa38$var$node;

});

parcelRegister("9ETtY", function(module, exports) {

$parcel$export(module.exports, "useIsGeneralConnectRoute", () => $06f03c6d90d3978b$export$db179b21b0be87a1);

var $8j0rr = parcelRequire("8j0rr");
const $06f03c6d90d3978b$var$GENERAL_CONNECT_ROUTES = new Set([
    'connect-general',
    'connect-general-invalid',
    'legacy-connect-general',
    'connect-general-service-desk-project'
]);
const $06f03c6d90d3978b$var$UNCERTAIN_APPS_SECTION_ROUTES = $06f03c6d90d3978b$var$GENERAL_CONNECT_ROUTES;
const $06f03c6d90d3978b$var$CERTAIN_APPS_SECTION_ROUTES = new Set([
    'forge-spa-global',
    'marketplace-index'
]);
const $06f03c6d90d3978b$export$22e210b2ba662e30 = new Set([
    ...$06f03c6d90d3978b$var$UNCERTAIN_APPS_SECTION_ROUTES,
    ...$06f03c6d90d3978b$var$CERTAIN_APPS_SECTION_ROUTES
]);
function $06f03c6d90d3978b$export$db179b21b0be87a1() {
    const route = (0, $8j0rr.useRoute)();
    return $06f03c6d90d3978b$var$GENERAL_CONNECT_ROUTES.has(route.name);
}

});
parcelRegister("8j0rr", function(module, exports) {

$parcel$export(module.exports, "useRoute", () => $71494baa766bb420$export$3f79f0b98112cf57);

var $lODMY = parcelRequire("lODMY");
const $71494baa766bb420$export$3f79f0b98112cf57 = (0, $lODMY.createRouterSelector)((state)=>state.route);

});


parcelRegister("jEa4c", function(module, exports) {

$parcel$export(module.exports, "SectionActions", () => $e6bcc3c836f7b03e$export$51f8029abf8c56ce);

var $5uXOq = parcelRequire("5uXOq");

var $IS9QB = parcelRequire("IS9QB");

var $51oeD = parcelRequire("51oeD");

var $44qT7 = parcelRequire("44qT7");
var $70rf1 = parcelRequire("70rf1");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2ys8y = parcelRequire("2ys8y");



var $jecJ3 = parcelRequire("jecJ3");

var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $9eeFp = parcelRequire("9eeFp");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $6awYZ = parcelRequire("6awYZ");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $9OXo1 = parcelRequire("9OXo1");

var $iFqOo = parcelRequire("iFqOo");
function $e6bcc3c836f7b03e$export$51f8029abf8c56ce({ onClose: onClose }) {
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = tenantContext;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const showManageApps = isAdmin || isSiteAdmin;
    const showAppAuditLogs = (0, $4R6GH.fg)('upm_frontend_deprecation') && (isAdmin || isSiteAdmin);
    const showViewAppRequests = (0, $6s1PB.expVal)('enduser-emcee-discover', 'value', true) && isSiteAdmin;
    const fireOpenEvent = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_APPS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: 'meatballDropdown'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        MenuItems: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e6bcc3c836f7b03e$var$MoreMenuItems, {
                showManageApps: showManageApps,
                showViewAppRequests: showViewAppRequests,
                showAppAuditLogs: showAppAuditLogs,
                ...props
            }),
        onOpen: fireOpenEvent,
        onClose: onClose
    });
}
function $e6bcc3c836f7b03e$var$MoreMenuItems({ onClose: onClose, showManageApps: showManageApps, showViewAppRequests: showViewAppRequests, showAppAuditLogs: showAppAuditLogs }) {
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { cloudId: cloudId } = tenantContext;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const adminHubAppRequestsUrl = `https://${(0, $2ys8y.getATLContextDomain)('admin')}/s/${cloudId}/user-connected-apps/tab/requested`;
    const viewAppRequestsLink = (0, $5uXOq.useMemo)(()=>(0, $4R6GH.fg)('should_redirect_to_admin-hub_for_app_requests') ? adminHubAppRequestsUrl : (0, $6awYZ.getAppRequestsLink)(), [
        adminHubAppRequestsUrl
    ]);
    const onCloseWithStopPropagation = (0, $9eeFp.useStopPropagation)(onClose);
    const showTopSection = showManageApps || showViewAppRequests;
    const fireClickEvent = (0, $5uXOq.useCallback)((itemId)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_APPS],
            attributes: {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$74712b62056d422e),
                itemId: itemId,
                parentItemId: (0, $jecJ3.SECTION_ITEM_APPS)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showTopSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), null, showManageApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44qT7.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($51oeD))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: "/plugins/servlet/upm",
        target: "_blank",
        onClick: (...args)=>{
            fireClickEvent('manageApps');
            onCloseWithStopPropagation(...args);
        }
    }, formatMessage((0, $iFqOo.default).manageApps)), showAppAuditLogs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44qT7.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($51oeD))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: "/plugins/servlet/upm/log",
        onClick: (...args)=>{
            onCloseWithStopPropagation(...args);
        },
        target: "_blank"
    }, formatMessage((0, $iFqOo.default).appAuditLogs)), showViewAppRequests && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44qT7.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($IS9QB))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: viewAppRequestsLink,
        target: "_blank",
        onClick: (...args)=>{
            fireClickEvent('viewAppRequests');
            onCloseWithStopPropagation(...args);
        }
    }, formatMessage((0, $iFqOo.default).viewAppRequests))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
        menuId: (0, $46Cti.L1_MENU_ID).APPS,
        hasSeparator: showTopSection
    }));
}

});
parcelRegister("9eeFp", function(module, exports) {

$parcel$export(module.exports, "useStopPropagation", () => $9838019739bca90d$export$f7bb512e68bcecd9);

var $5uXOq = parcelRequire("5uXOq");
const $9838019739bca90d$export$f7bb512e68bcecd9 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
onEvent)=>(0, $5uXOq.useCallback)((e, ...args)=>{
        try {
            onEvent?.(e, ...args);
        } finally{
            e?.stopPropagation();
        }
    }, [
        onEvent
    ]);

});

parcelRegister("6awYZ", function(module, exports) {

$parcel$export(module.exports, "getEmceeDiscoverLink", () => $3f6cbde73539e62b$export$f26dabf284aefb17);
$parcel$export(module.exports, "getEmceeAppListingLink", () => $3f6cbde73539e62b$export$eb09695b9e9f6a3);
$parcel$export(module.exports, "getAppRequestsLink", () => $3f6cbde73539e62b$export$7ab8c48f9081e976);
$parcel$export(module.exports, "getManagePromotionsLink", () => $3f6cbde73539e62b$export$350ca33eed6a2742);
const $3f6cbde73539e62b$var$sanitiseParams = (params)=>params ? Object.entries(params).reduce((res, [key, value])=>{
        if (value) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'EmceeQueryParams | JiraQueryParams'.
        res[key] = params[key];
        return res;
    }, {}) : {};
const $3f6cbde73539e62b$var$addQueryParamsToLink = (params, link)=>{
    // @ts-expect-error - TS2345 - Argument of type 'EmceeQueryParams | JiraQueryParams | null | undefined' is not assignable to parameter of type 'EmceeQueryParams | JiraQueryParams | undefined'.
    const queryParams = $3f6cbde73539e62b$var$sanitiseParams(params);
    const queryString = new URLSearchParams(queryParams).toString();
    return queryString ? `${link}?${queryString}` : link;
};
const $3f6cbde73539e62b$export$f26dabf284aefb17 = (params)=>{
    const link = '/jira/marketplace/discover';
    return $3f6cbde73539e62b$var$addQueryParamsToLink(params, link);
};
const $3f6cbde73539e62b$export$eb09695b9e9f6a3 = (appKey, params, jiraQueryParams)=>$3f6cbde73539e62b$var$addQueryParamsToLink({
        ...jiraQueryParams,
        ...params
    }, `/jira/marketplace/discover/app/${appKey}`);
const $3f6cbde73539e62b$export$7ab8c48f9081e976 = (params)=>{
    const link = '/jira/marketplace/manage/app-requests';
    return $3f6cbde73539e62b$var$addQueryParamsToLink(params, link);
};
const $3f6cbde73539e62b$export$350ca33eed6a2742 = (params)=>{
    const link = '/jira/marketplace/manage/promotions';
    return $3f6cbde73539e62b$var$addQueryParamsToLink(params, link);
};

});

parcelRegister("iFqOo", function(module, exports) {

$parcel$export(module.exports, "default", () => $560cd06a0adfd8ce$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $560cd06a0adfd8ce$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    manageApps: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.section-actions.manage-apps",
        "defaultMessage": "Manage apps"
    },
    appAuditLogs: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.section-actions.app-audit-logs",
        "defaultMessage": "App audit logs"
    },
    viewAppRequests: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.section-actions.view-app-requests",
        "defaultMessage": "View app requests"
    }
});

});


parcelRegister("cbY68", function(module, exports) {

$parcel$export(module.exports, "Nav4AppsDefault", () => $18bb1ac270cbc9bf$export$3732a771b6ecd66d);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");


var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $iszzG = parcelRequire("iszzG");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $338xa = parcelRequire("338xa");

var $dQbFB = parcelRequire("dQbFB");

var $dUyqZ = parcelRequire("dUyqZ");

var $4zcxJ = parcelRequire("4zcxJ");

var $7Y7Js = parcelRequire("7Y7Js");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $koeKL = parcelRequire("koeKL");

var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");


var $6EHtA = parcelRequire("6EHtA");

var $g72iU = parcelRequire("g72iU");
function $18bb1ac270cbc9bf$export$3732a771b6ecd66d(props) {
    const { actionsOnHover: actionsOnHover, simulateLoading: simulateLoading = false, isExpanded: isExpanded = simulateLoading } = props;
    const cloudId = (0, $koeKL.useCloudId)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $g72iU.asyncNav4AppsContentViewQuery), entryPointParams);
    const triggerRef = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).APPS);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, $iszzG.NavItemsContext));
    const getAttributes = (0, $5uXOq.useCallback)((error)=>(0, $6EHtA.createAttributes)({
            error: error,
            component: 'Nav4AppsDefault'
        }), []);
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    const menuId = (0, $jhS4y.MENU_ID_APPS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) {
                entryPointActions.load();
                const event = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
                });
                const isInMore = moreMenuIds.includes((0, $46Cti.L1_MENU_ID).APPS);
                (0, $8zOmE.fireUIAnalytics)(event, (0, $jecJ3.SECTION_ITEM_APPS), {
                    isInMore: isInMore
                });
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-apps-default",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, simulateLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-apps-default",
        errorAttributes: getAttributes,
        packageName: (0, $13973d4cc5182a50$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $13973d4cc5182a50$export$d57b6b390e78d90f),
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
        // Props for the root component.
        runtimeProps: entryPointParams
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Y7Js.ExploreMoreApps), null)));
}

});
parcelRegister("7XluA", function(module, exports) {

$parcel$export(module.exports, "JiraEntryPointContainer", () => $f4c300dcb0cbacff$export$ee1e46af8fa2fb93);
$parcel$export(module.exports, "NestedEntryPointContainer", () => $f4c300dcb0cbacff$export$54db9e88249c9162);

var $5uXOq = parcelRequire("5uXOq");

var $8Bm0k = parcelRequire("8Bm0k");

var $c5vfY = parcelRequire("c5vfY");
const $f4c300dcb0cbacff$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
    const entryPointReference = (0, $8Bm0k.useEntryPointSubscription)(entryPointReferenceSubject);
    return entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5vfY.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        placeholderName: "jira-entry-point-container"
    }) : null;
};
const $f4c300dcb0cbacff$export$54db9e88249c9162 = (0, $c5vfY.InternalEntryPointContainer);

});
parcelRegister("8Bm0k", function(module, exports) {

$parcel$export(module.exports, "useEntryPointSubscription", () => $0458c70c3d6616bf$export$3cd1c81e13390c49);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
const $0458c70c3d6616bf$export$3cd1c81e13390c49 = (subject)=>{
    const [entryPointReference, setEntryPointReference] = (0, $5uXOq.useState)(subject.getValue);
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subject.subscribe(setEntryPointReference);
        setEntryPointReference(subject.getValue());
        return unsubscribe;
    }, [
        subject
    ]);
    // We should never provide an entrypoint that has been disposed.
    // This check guards against race conditions that could be triggered by the entrypoint load manager + concurrent rendering.
    if (entryPointReference?.isDisposed && (0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) return null;
    return entryPointReference;
};

});

parcelRegister("c5vfY", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $df42b2d5b5551f77$export$5d4dc37edd8a3adb);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $l8ruj = parcelRequire("l8ruj");
const $df42b2d5b5551f77$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>/* eslint-disable-next-line jira/ufo/valid-labels */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: errorAttributes,
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: placeholderName ?? packageName ?? 'internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    }))));

});


parcelRegister("4mO32", function(module, exports) {

$parcel$export(module.exports, "useEntryPoint", () => $f8987436643ccece$export$338256068bc140fb);

var $5uXOq = parcelRequire("5uXOq");

var $c8WsS = parcelRequire("c8WsS");

var $9CqsK = parcelRequire("9CqsK");

var $j1gA4 = parcelRequire("j1gA4");

var $bzXq1 = parcelRequire("bzXq1");
const $f8987436643ccece$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, $c8WsS.DEFAULT_OPTIONS))=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, $j1gA4.useEntryPointLoadManager)(entryPoint, entryPointParams);
    const { startMetric: startMetric, stopMetric: stopMetric } = (0, $bzXq1.useMetricLogger)(metric);
    const entryPointActions = (0, $9CqsK.useEntryPointActions)(loadActions, options, startMetric);
    return (0, $5uXOq.useMemo)(()=>({
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            stopMetric: stopMetric
        }), [
        entryPointActions,
        entryPointReferenceSubject,
        stopMetric
    ]);
};

});
parcelRegister("c8WsS", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $34664e57314d5c26$export$93ca5d3f8675ae4c);
const $34664e57314d5c26$export$93ca5d3f8675ae4c = {
    preloadMaxAge: 2000,
    timeToIntent: 200
};

});

parcelRegister("9CqsK", function(module, exports) {

$parcel$export(module.exports, "useEntryPointActions", () => $7bc2afeacf23b901$export$90681c8c3a56f09a);

var $5uXOq = parcelRequire("5uXOq");

var $jQsty = parcelRequire("jQsty");

var $c8WsS = parcelRequire("c8WsS");
const $7bc2afeacf23b901$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
const $7bc2afeacf23b901$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, $c8WsS.DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, $c8WsS.DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
    const preloadIntentTimeout = (0, $5uXOq.useRef)();
    const preloadMaxAgeTimeout = (0, $5uXOq.useRef)();
    const preloadLastRequested = (0, $5uXOq.useRef)(0);
    const cancelPreload = (0, $5uXOq.useCallback)(()=>{
        if (!(0, $jQsty.default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) {
            clearTimeout(preloadIntentTimeout.current);
            clearTimeout(preloadMaxAgeTimeout.current);
        }
    }, []);
    const load = (0, $5uXOq.useCallback)(()=>{
        cancelPreload();
        startMetric(preloadLastRequested.current);
        if (preloadLastRequested.current > 0) commitPreload();
        else loadEntryPoint();
        preloadLastRequested.current = 0;
    }, [
        cancelPreload,
        commitPreload,
        loadEntryPoint,
        startMetric
    ]);
    const preload = (0, $5uXOq.useCallback)(()=>{
        if ((0, $jQsty.default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) return;
        cancelPreload();
        preloadIntentTimeout.current = setTimeout(()=>{
            preloadLastRequested.current = Date.now();
            loadEntryPoint({
                isPreload: true
            });
            preloadMaxAgeTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = 0;
            }, preloadMaxAge);
        }, timeToIntent);
    }, [
        cancelPreload,
        loadEntryPoint,
        preloadMaxAge,
        timeToIntent
    ]);
    (0, $5uXOq.useEffect)(()=>cancelPreload, [
        cancelPreload
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            cancelPreload: cancelPreload,
            load: load,
            preload: preload,
            unload: unloadEntryPoint
        }), [
        cancelPreload,
        load,
        preload,
        unloadEntryPoint
    ]);
};

});

parcelRegister("j1gA4", function(module, exports) {

$parcel$export(module.exports, "useEntryPointLoadManager", () => $d6e83c6db8fa388b$export$bfae318f9651db2f);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $fiv1r = parcelRequire("fiv1r");

var $iU8T2 = parcelRequire("iU8T2");
const $d6e83c6db8fa388b$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
    const environmentProvider = (0, $fiv1r.useJiraRelayEnvironmentProvider)();
    const canLoad = (0, $5uXOq.useRef)(true);
    const timer = (0, $5uXOq.useRef)();
    const removeInactiveLoadsIdleCallback = (0, $5uXOq.useRef)(null);
    const entryPointReferenceQueue = (0, $5uXOq.useRef)([]);
    const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, $iU8T2.useEntryPointReferenceSubject)(entryPoint);
    const setNextUpdate = (0, $5uXOq.useCallback)((nextEntryPointReference)=>{
        setEntryPointReference(nextEntryPointReference);
        if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) {
            // Delay clean up to prioritise render cycle in case
            // prior queries get used again
            $d6e83c6db8fa388b$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
            removeInactiveLoadsIdleCallback.current = $d6e83c6db8fa388b$var$callWhenIdle(()=>{
                const { current: currentQueue } = entryPointReferenceQueue;
                entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $iU8T2.removeAll)(currentQueue) : (0, $iU8T2.removeInactiveLoads)(currentQueue);
            });
        } else // Delay clean up to prioritise render cycle in case
        // prior queries get used again
        timer.current = setTimeout(()=>{
            const { current: currentQueue } = entryPointReferenceQueue;
            entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $iU8T2.removeAll)(currentQueue) : (0, $iU8T2.removeInactiveLoads)(currentQueue);
        }, 0);
    }, [
        setEntryPointReference
    ]);
    const load = (0, $5uXOq.useCallback)(({ isPreload: isPreload } = {
        isPreload: false
    })=>{
        if (canLoad.current) {
            const reference = (0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
            entryPointReferenceQueue.current.unshift({
                value: reference,
                isPreload: isPreload
            });
            if (isPreload) entryPointReferenceQueue.current = (0, $iU8T2.removeRedundantPreloads)(entryPointReferenceQueue.current);
            else setNextUpdate(reference);
        }
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        setNextUpdate
    ]);
    const unload = (0, $5uXOq.useCallback)(()=>{
        setNextUpdate(null);
    }, [
        setNextUpdate
    ]);
    const commitPreload = (0, $5uXOq.useCallback)(()=>{
        const [firstItem] = entryPointReferenceQueue.current;
        if (firstItem?.isPreload) {
            firstItem.isPreload = false;
            setNextUpdate(firstItem.value);
        }
    }, [
        setNextUpdate
    ]);
    if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        // In concurrent mode especially with strict mode, we would get stuck on canLoad.current = false
        // and it would never be turned back on to true without this
        canLoad.current = true;
        return ()=>{
            $d6e83c6db8fa388b$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $iU8T2.removeAll)(entryPointReferenceQueue.current);
        };
    }, []);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>()=>{
            clearTimeout(timer.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $iU8T2.removeAll)(entryPointReferenceQueue.current);
        }, []);
    return {
        entryPointReferenceSubject: (0, $5uXOq.useMemo)(()=>({
                getValue: getValue,
                subscribe: subscribe
            }), [
            getValue,
            subscribe
        ]),
        loadEntryPoint: load,
        unloadEntryPoint: unload,
        commitPreload: commitPreload
    };
};
function $d6e83c6db8fa388b$var$callWhenIdle(callback) {
    if ('requestIdleCallback' in window && typeof requestIdleCallback === 'function') return requestIdleCallback(callback);
    if ('requestAnimationFrame' in window && typeof requestAnimationFrame === 'function') return requestAnimationFrame(callback);
    return setTimeout(callback, 0);
}
function $d6e83c6db8fa388b$var$maybeCancelIdleCallback(idleCallbackId) {
    if (idleCallbackId === null) return;
    if ('cancelIdleCallback' in window && typeof cancelIdleCallback === 'function') {
        if (typeof idleCallbackId === 'number') return cancelIdleCallback(idleCallbackId);
        return;
    }
    if ('cancelAnimationFrame' in window && typeof cancelAnimationFrame === 'function') {
        if (typeof idleCallbackId === 'number') return cancelAnimationFrame(idleCallbackId);
        return;
    }
    return clearTimeout(idleCallbackId);
}

});
parcelRegister("fiv1r", function(module, exports) {

$parcel$export(module.exports, "default", () => $41dee5a929ec50c3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useJiraRelayEnvironmentProvider", () => $41dee5a929ec50c3$export$83fb48644dee72f0);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $5yJb9 = parcelRequire("5yJb9");
function $41dee5a929ec50c3$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.RelayEnvironmentProvider), {
        environment: (0, $5yJb9.default)()
    }, children);
}
function $41dee5a929ec50c3$export$83fb48644dee72f0() {
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});

parcelRegister("iU8T2", function(module, exports) {

$parcel$export(module.exports, "removeRedundantPreloads", () => $011b3d8d407c2901$export$a5b3b808f05fede2);
$parcel$export(module.exports, "removeInactiveLoads", () => $011b3d8d407c2901$export$ae329fe3ea179cb4);
$parcel$export(module.exports, "removeAll", () => $011b3d8d407c2901$export$1cfc7aad5cb1833b);
$parcel$export(module.exports, "useEntryPointReferenceSubject", () => $011b3d8d407c2901$export$322c8997d351da6a);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $4R6GH = parcelRequire("4R6GH");
const $011b3d8d407c2901$export$a5b3b808f05fede2 = (queue)=>{
    const [, ...potentialRedundantItems] = queue;
    potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
        if (isPreload) value.dispose();
    });
    return queue.filter(({ value: value })=>!value.isDisposed);
};
const $011b3d8d407c2901$export$ae329fe3ea179cb4 = (queue)=>{
    if (queue.length === 0) return [];
    const [activeItem, ...redundantItems] = queue;
    redundantItems.forEach(({ value: value })=>{
        value.dispose();
    });
    return [
        activeItem
    ];
};
const $011b3d8d407c2901$export$1cfc7aad5cb1833b = (queue)=>{
    queue.forEach(({ value: value })=>{
        value.dispose();
    });
    return [];
};
const $011b3d8d407c2901$export$322c8997d351da6a = (entryPoint)=>{
    const value = (0, $5uXOq.useRef)(null);
    const subscribers = (0, $5uXOq.useRef)();
    const unsub = (0, $5uXOq.useRef)(null);
    const subscribe = (0, $5uXOq.useCallback)((subscriber)=>{
        if (!subscribers.current) subscribers.current = new Set();
        subscribers.current.add(subscriber);
        return ()=>{
            subscribers.current?.delete(subscriber);
        };
    }, []);
    const setEntryPointReference = (0, $5uXOq.useCallback)((entryPointReference)=>{
        value.current = entryPointReference;
        const notifySubscribers = ()=>{
            (0, $7nsd3.unstable_batchedUpdates)(()=>{
                if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                    subscriber(entryPointReference);
                });
            });
        };
        if ($011b3d8d407c2901$var$isReactAsyncJSResourceReference(entryPoint?.root) && (0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) unsub.current = entryPoint?.root?.onComplete?.(()=>{
            notifySubscribers();
        });
        else notifySubscribers();
    }, [
        entryPoint
    ]);
    const getValue = (0, $5uXOq.useCallback)(()=>value.current, []);
    (0, $5uXOq.useEffect)(()=>()=>{
            subscribers.current?.clear();
            if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) unsub.current?.();
        }, []);
    return {
        getValue: getValue,
        setEntryPointReference: setEntryPointReference,
        subscribe: subscribe
    };
};
/**
 * JSResourceReference's in react-relay don't have an onComplete method,
 * but the version that we actually use from @atlassian/react-async does.
 */ function $011b3d8d407c2901$var$isReactAsyncJSResourceReference(value) {
    return Boolean(value && 'onComplete' in value && 'getModuleName' in value);
}

});


parcelRegister("bzXq1", function(module, exports) {

$parcel$export(module.exports, "useMetricLogger", () => $25198ca8fad8a13c$export$f291ec7cea728e1);

var $5uXOq = parcelRequire("5uXOq");
const $25198ca8fad8a13c$export$f291ec7cea728e1 = (metric)=>{
    const preloadStartTime = (0, $5uXOq.useRef)(0);
    const loadStartTime = (0, $5uXOq.useRef)(0);
    const startMetric = (0, $5uXOq.useCallback)((preloadTime = 0)=>{
        if (metric) {
            metric.start();
            preloadStartTime.current = preloadTime;
            loadStartTime.current = Date.now();
        }
    }, [
        metric
    ]);
    const stopMetric = (0, $5uXOq.useCallback)((additionalCustomData)=>{
        if (metric) {
            const preloadData = preloadStartTime.current > 0 ? {
                preloadToStartDuration: loadStartTime.current - preloadStartTime.current
            } : undefined;
            const metricData = preloadData || additionalCustomData ? {
                customData: {
                    ...preloadData,
                    ...additionalCustomData
                }
            } : undefined;
            metric.stop(metricData);
        }
    }, [
        metric
    ]);
    return {
        startMetric: startMetric,
        stopMetric: stopMetric
    };
};

});


parcelRegister("c16H2", function(module, exports) {

$parcel$export(module.exports, "Nav4ExpandableMenuItem", () => $ea944fd631b4ab3b$export$3c0db18b09c9af3e);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $c6x3L = parcelRequire("c6x3L");

var $lJ5jf = parcelRequire("lJ5jf");

var $f3k4O = parcelRequire("f3k4O");
const $ea944fd631b4ab3b$export$3c0db18b09c9af3e = /*#__PURE__*/ (0, $5uXOq.forwardRef)($ea944fd631b4ab3b$var$_Nav4ExpandableMenuItem);
function $ea944fd631b4ab3b$var$_Nav4ExpandableMenuItem(props, ref) {
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { isSelectedPath: isSelectedPath, isInitialSelectedPath: isInitialSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { isControlledNav: isControlledNav, isControlledPath: isControlledPath } = (0, $lJ5jf.useSidebarNav4Controller)();
    const { children: children, menuId: menuId, onExpansionToggle: onExpansionToggle, isExpanded: isExpanded = false, onSystemToggle: onSystemToggle, expandedRef: expandedRef, collapsedRef: collapsedRef } = props;
    // controlled state, `isActuallyExpanded` decides whether the component is expanded or not (based on logic in this component and props.isExpanded)
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [isActuallyExpanded, setActuallyExpanded] = (0, $5uXOq.useState)(isInitialSelectedPath(menuId) || isExpanded);
    // By default, the expandable component is closed. When we want it to be initially open, we also need to trigger onExpansionToggle().
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (isActuallyExpanded === true && isExpanded === false) onSystemToggle?.(isActuallyExpanded);
    // We want to run this only once, on init.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // If isSelectedPath changes (external change), update our internal state.
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        // Fyi, the following logic causes the component to _collapse_ when the selectedPath changes (preserved here for posterity):
        //   const localIsExpanded = isSelectedPath(menuId);
        // ...but this logic _keeps the component expanded_ (if it is) when the selectedPath changes. We can only auto-expand component, not auto-collapse it though (which is fine, for current UX):
        const localIsExpanded = isSelectedPath(menuId) || isActuallyExpanded;
        // Trigger the callbacks ONLY when the previous state doesn't match the new state.
        if (localIsExpanded !== isActuallyExpanded) {
            setActuallyExpanded(localIsExpanded);
            onSystemToggle?.(localIsExpanded);
        }
    // We only want to run this when isSelectedPath() changes, not when isActuallyExpanded changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSelectedPath
    ]);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (!isControlledNav) return;
        const localIsExpanded = isControlledPath(menuId);
        if (localIsExpanded !== isActuallyExpanded) {
            setActuallyExpanded(localIsExpanded);
            onSystemToggle?.(localIsExpanded);
        }
    // We only want to run this when isControlledPath() changes, not when isActuallyExpanded changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isControlledPath
    ]);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const expandableMenuItemRef = (0, $5uXOq.useMemo)(()=>{
        if ((0, $4R6GH.fg)('blu-6100-plan-action-menu-entrypoint')) {
            if (isActuallyExpanded) return expandedRef ?? ref;
            return collapsedRef ?? ref;
        }
        return ref;
    }, [
        collapsedRef,
        expandedRef,
        isActuallyExpanded,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f3k4O.ExpandableMenuItem), {
        ref: expandableMenuItemRef,
        isExpanded: isActuallyExpanded,
        onExpansionToggle: (hasExpanded)=>{
            // Since we are controlling `isExpanded` state in this component (via `isActuallyExpanded`), we need to change it on onExpansionToggle user-event too.
            setActuallyExpanded(hasExpanded);
            onExpansionToggle?.(hasExpanded);
        }
    }, children);
}

});
parcelRegister("f3k4O", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItem", () => $e5ca1cb076d754a0$export$341dea48c30b36ff);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8yr9w = parcelRequire("8yr9w");

var $4vWwj = parcelRequire("4vWwj");

var $fOnXR = parcelRequire("fOnXR");
const $e5ca1cb076d754a0$export$341dea48c30b36ff = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, onExpansionToggle: onExpansionToggle, children: children }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $8yr9w.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fOnXR.IsExpandedContext).Provider, {
        value: isExpanded,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fOnXR.SetIsExpandedContext).Provider, {
            value: setIsExpanded,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fOnXR.OnExpansionToggleContext).Provider, {
                value: onExpansionToggle ?? null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4vWwj.MenuListItem), {
                    ref: forwardedRef,
                    children: children
                })
            })
        })
    });
});

});


parcelRegister("338xa", function(module, exports) {

$parcel$export(module.exports, "SkeletonNavMenuItems", () => $32c488973b24b27b$export$c3a3a246584433d7);

var $5uXOq = parcelRequire("5uXOq");

var $9PCp5 = parcelRequire("9PCp5");

var $eCE62 = parcelRequire("eCE62");

var $4vWwj = parcelRequire("4vWwj");
const $32c488973b24b27b$export$c3a3a246584433d7 = ({ count: count = 5 })=>(0, (/*@__PURE__*/$parcel$interopDefault($9PCp5)))(0, count).map((index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4vWwj.MenuListItem), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
            isShimmering: true
        })));

});
parcelRegister("9PCp5", function(module, exports) {

var $lVx1a = parcelRequire("lVx1a");

var $7286aa9f89a20bb7$var$func = $lVx1a('range', (parcelRequire("iASWI")));

$7286aa9f89a20bb7$var$func.placeholder = (parcelRequire("aPsMW"));
module.exports = $7286aa9f89a20bb7$var$func;

});
parcelRegister("lVx1a", function(module, exports) {

var $iIayQ = parcelRequire("iIayQ");

var $7sR67 = parcelRequire("7sR67");
/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $ff688881095ae098$var$convert(name, func, options) {
    return $iIayQ($7sR67, name, func, options);
}
module.exports = $ff688881095ae098$var$convert;

});
parcelRegister("iIayQ", function(module, exports) {

var $lTdwm = parcelRequire("lTdwm");

var $aPsMW = parcelRequire("aPsMW");
/** Built-in value reference. */ var $d9f487426e0f9b59$var$push = Array.prototype.push;
/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */ function $d9f487426e0f9b59$var$baseArity(func, n) {
    return n == 2 ? function(a, b) {
        return func.apply(undefined, arguments);
    } : function(a) {
        return func.apply(undefined, arguments);
    };
}
/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */ function $d9f487426e0f9b59$var$baseAry(func, n) {
    return n == 2 ? function(a, b) {
        return func(a, b);
    } : function(a) {
        return func(a);
    };
}
/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */ function $d9f487426e0f9b59$var$cloneArray(array) {
    var length = array ? array.length : 0, result = Array(length);
    while(length--)result[length] = array[length];
    return result;
}
/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */ function $d9f487426e0f9b59$var$createCloner(func) {
    return function(object) {
        return func({}, object);
    };
}
/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */ function $d9f487426e0f9b59$var$flatSpread(func, start) {
    return function() {
        var length = arguments.length, lastIndex = length - 1, args = Array(length);
        while(length--)args[length] = arguments[length];
        var array = args[start], otherArgs = args.slice(0, start);
        if (array) $d9f487426e0f9b59$var$push.apply(otherArgs, array);
        if (start != lastIndex) $d9f487426e0f9b59$var$push.apply(otherArgs, args.slice(start + 1));
        return func.apply(this, otherArgs);
    };
}
/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */ function $d9f487426e0f9b59$var$wrapImmutable(func, cloner) {
    return function() {
        var length = arguments.length;
        if (!length) return;
        var args = Array(length);
        while(length--)args[length] = arguments[length];
        var result = args[0] = cloner.apply(undefined, args);
        func.apply(undefined, args);
        return result;
    };
}
/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $d9f487426e0f9b59$var$baseConvert(util, name, func, options) {
    var isLib = typeof name == 'function', isObj = name === Object(name);
    if (isObj) {
        options = func;
        func = name;
        name = undefined;
    }
    if (func == null) throw new TypeError;
    options || (options = {});
    var config = {
        'cap': 'cap' in options ? options.cap : true,
        'curry': 'curry' in options ? options.curry : true,
        'fixed': 'fixed' in options ? options.fixed : true,
        'immutable': 'immutable' in options ? options.immutable : true,
        'rearg': 'rearg' in options ? options.rearg : true
    };
    var defaultHolder = isLib ? func : $aPsMW, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
    var helpers = isLib ? func : {
        'ary': util.ary,
        'assign': util.assign,
        'clone': util.clone,
        'curry': util.curry,
        'forEach': util.forEach,
        'isArray': util.isArray,
        'isError': util.isError,
        'isFunction': util.isFunction,
        'isWeakMap': util.isWeakMap,
        'iteratee': util.iteratee,
        'keys': util.keys,
        'rearg': util.rearg,
        'toInteger': util.toInteger,
        'toPath': util.toPath
    };
    var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
    var aryMethodKeys = keys($lTdwm.aryMethod);
    var wrappers = {
        'castArray': function(castArray) {
            return function() {
                var value = arguments[0];
                return isArray(value) ? castArray($d9f487426e0f9b59$var$cloneArray(value)) : castArray.apply(undefined, arguments);
            };
        },
        'iteratee': function(iteratee) {
            return function() {
                var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                if (config.cap && typeof arity == 'number') {
                    arity = arity > 2 ? arity - 2 : 1;
                    return length && length <= arity ? result : $d9f487426e0f9b59$var$baseAry(result, arity);
                }
                return result;
            };
        },
        'mixin': function(mixin) {
            return function(source) {
                var func = this;
                if (!isFunction(func)) return mixin(func, Object(source));
                var pairs = [];
                each(keys(source), function(key) {
                    if (isFunction(source[key])) pairs.push([
                        key,
                        func.prototype[key]
                    ]);
                });
                mixin(func, Object(source));
                each(pairs, function(pair) {
                    var value = pair[1];
                    if (isFunction(value)) func.prototype[pair[0]] = value;
                    else delete func.prototype[pair[0]];
                });
                return func;
            };
        },
        'nthArg': function(nthArg) {
            return function(n) {
                var arity = n < 0 ? 1 : toInteger(n) + 1;
                return curry(nthArg(n), arity);
            };
        },
        'rearg': function(rearg) {
            return function(func, indexes) {
                var arity = indexes ? indexes.length : 0;
                return curry(rearg(func, indexes), arity);
            };
        },
        'runInContext': function(runInContext) {
            return function(context) {
                return $d9f487426e0f9b59$var$baseConvert(util, runInContext(context), options);
            };
        }
    };
    /*--------------------------------------------------------------------------*/ /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */ function castCap(name, func) {
        if (config.cap) {
            var indexes = $lTdwm.iterateeRearg[name];
            if (indexes) return iterateeRearg(func, indexes);
            var n = !isLib && $lTdwm.iterateeAry[name];
            if (n) return iterateeAry(func, n);
        }
        return func;
    }
    /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castCurry(name, func, n) {
        return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
    }
    /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */ function castFixed(name, func, n) {
        if (config.fixed && (forceFixed || !$lTdwm.skipFixed[name])) {
            var data = $lTdwm.methodSpread[name], start = data && data.start;
            return start === undefined ? ary(func, n) : $d9f487426e0f9b59$var$flatSpread(func, start);
        }
        return func;
    }
    /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castRearg(name, func, n) {
        return config.rearg && n > 1 && (forceRearg || !$lTdwm.skipRearg[name]) ? rearg(func, $lTdwm.methodRearg[name] || $lTdwm.aryRearg[n]) : func;
    }
    /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */ function cloneByPath(object, path) {
        path = toPath(path);
        var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
        while(nested != null && ++index < length){
            var key = path[index], value = nested[key];
            if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
            nested = nested[key];
        }
        return result;
    }
    /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */ function convertLib(options) {
        return _.runInContext.convert(options)(undefined);
    }
    /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */ function createConverter(name, func) {
        var realName = $lTdwm.aliasToReal[name] || name, methodName = $lTdwm.remap[realName] || realName, oldOptions = options;
        return function(options) {
            var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
            return $d9f487426e0f9b59$var$baseConvert(newUtil, realName, newFunc, newOptions);
        };
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */ function iterateeAry(func, n) {
        return overArg(func, function(func) {
            return typeof func == 'function' ? $d9f487426e0f9b59$var$baseAry(func, n) : func;
        });
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */ function iterateeRearg(func, indexes) {
        return overArg(func, function(func) {
            var n = indexes.length;
            return $d9f487426e0f9b59$var$baseArity(rearg($d9f487426e0f9b59$var$baseAry(func, n), indexes), n);
        });
    }
    /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function() {
            var length = arguments.length;
            if (!length) return func();
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var index = config.rearg ? 0 : length - 1;
            args[index] = transform(args[index]);
            return func.apply(undefined, args);
        };
    }
    /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */ function wrap(name, func, placeholder) {
        var result, realName = $lTdwm.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
        if (wrapper) wrapped = wrapper(func);
        else if (config.immutable) {
            if ($lTdwm.mutate.array[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, $d9f487426e0f9b59$var$cloneArray);
            else if ($lTdwm.mutate.object[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, $d9f487426e0f9b59$var$createCloner(func));
            else if ($lTdwm.mutate.set[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, cloneByPath);
        }
        each(aryMethodKeys, function(aryKey) {
            each($lTdwm.aryMethod[aryKey], function(otherName) {
                if (realName == otherName) {
                    var data = $lTdwm.methodSpread[realName], afterRearg = data && data.afterRearg;
                    result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                    result = castCap(realName, result);
                    result = castCurry(realName, result, aryKey);
                    return false;
                }
            });
            return !result;
        });
        result || (result = wrapped);
        if (result == func) result = forceCurry ? curry(result, 1) : function() {
            return func.apply(this, arguments);
        };
        result.convert = createConverter(realName, func);
        result.placeholder = func.placeholder = placeholder;
        return result;
    }
    /*--------------------------------------------------------------------------*/ if (!isObj) return wrap(name, func, defaultHolder);
    var _ = func;
    // Convert methods by ary cap.
    var pairs = [];
    each(aryMethodKeys, function(aryKey) {
        each($lTdwm.aryMethod[aryKey], function(key) {
            var func = _[$lTdwm.remap[key] || key];
            if (func) pairs.push([
                key,
                wrap(key, func, _)
            ]);
        });
    });
    // Convert remaining methods.
    each(keys(_), function(key) {
        var func = _[key];
        if (typeof func == 'function') {
            var length = pairs.length;
            while(length--){
                if (pairs[length][0] == key) return;
            }
            func.convert = createConverter(key, func);
            pairs.push([
                key,
                func
            ]);
        }
    });
    // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
    each(pairs, function(pair) {
        _[pair[0]] = pair[1];
    });
    _.convert = convertLib;
    _.placeholder = _;
    // Assign aliases.
    each(keys(_), function(key) {
        each($lTdwm.realToAlias[key] || [], function(alias) {
            _[alias] = _[key];
        });
    });
    return _;
}
module.exports = $d9f487426e0f9b59$var$baseConvert;

});
parcelRegister("lTdwm", function(module, exports) {

$parcel$export(module.exports, "aliasToReal", () => $fef938fb92c31507$export$bd0f5e6e44efa6b4, (v) => $fef938fb92c31507$export$bd0f5e6e44efa6b4 = v);
$parcel$export(module.exports, "aryMethod", () => $fef938fb92c31507$export$85c665b4d7da9cb4, (v) => $fef938fb92c31507$export$85c665b4d7da9cb4 = v);
$parcel$export(module.exports, "aryRearg", () => $fef938fb92c31507$export$42564e045b285e32, (v) => $fef938fb92c31507$export$42564e045b285e32 = v);
$parcel$export(module.exports, "iterateeAry", () => $fef938fb92c31507$export$81e17196e6a22b07, (v) => $fef938fb92c31507$export$81e17196e6a22b07 = v);
$parcel$export(module.exports, "iterateeRearg", () => $fef938fb92c31507$export$30975ceb42167ebd, (v) => $fef938fb92c31507$export$30975ceb42167ebd = v);
$parcel$export(module.exports, "methodRearg", () => $fef938fb92c31507$export$8ceb0ad7e94d3801, (v) => $fef938fb92c31507$export$8ceb0ad7e94d3801 = v);
$parcel$export(module.exports, "methodSpread", () => $fef938fb92c31507$export$fbaeb3f87df3cf26, (v) => $fef938fb92c31507$export$fbaeb3f87df3cf26 = v);
$parcel$export(module.exports, "mutate", () => $fef938fb92c31507$export$57e795267c26e600, (v) => $fef938fb92c31507$export$57e795267c26e600 = v);
$parcel$export(module.exports, "realToAlias", () => $fef938fb92c31507$export$1eb71a7e27943e71, (v) => $fef938fb92c31507$export$1eb71a7e27943e71 = v);
$parcel$export(module.exports, "remap", () => $fef938fb92c31507$export$aee1dbae5de2db9d, (v) => $fef938fb92c31507$export$aee1dbae5de2db9d = v);
$parcel$export(module.exports, "skipFixed", () => $fef938fb92c31507$export$87ffbe4821a5d5e0, (v) => $fef938fb92c31507$export$87ffbe4821a5d5e0 = v);
$parcel$export(module.exports, "skipRearg", () => $fef938fb92c31507$export$b4d07413ce528c90, (v) => $fef938fb92c31507$export$b4d07413ce528c90 = v);
/** Used to map aliases to their real names. */ var $fef938fb92c31507$export$bd0f5e6e44efa6b4;
/** Used to map ary to method names. */ var $fef938fb92c31507$export$85c665b4d7da9cb4;
/** Used to map ary to rearg configs. */ var $fef938fb92c31507$export$42564e045b285e32;
/** Used to map method names to their iteratee ary. */ var $fef938fb92c31507$export$81e17196e6a22b07;
/** Used to map method names to iteratee rearg configs. */ var $fef938fb92c31507$export$30975ceb42167ebd;
/** Used to map method names to rearg configs. */ var $fef938fb92c31507$export$8ceb0ad7e94d3801;
/** Used to map method names to spread configs. */ var $fef938fb92c31507$export$fbaeb3f87df3cf26;
/** Used to identify methods which mutate arrays or objects. */ var $fef938fb92c31507$export$57e795267c26e600;
/** Used to map real names to their aliases. */ var $fef938fb92c31507$export$1eb71a7e27943e71;
/** Used to map method names to other names. */ var $fef938fb92c31507$export$aee1dbae5de2db9d;
/** Used to track methods that skip fixing their arity. */ var $fef938fb92c31507$export$87ffbe4821a5d5e0;
/** Used to track methods that skip rearranging arguments. */ var $fef938fb92c31507$export$b4d07413ce528c90;
$fef938fb92c31507$export$bd0f5e6e44efa6b4 = {
    // Lodash aliases.
    'each': 'forEach',
    'eachRight': 'forEachRight',
    'entries': 'toPairs',
    'entriesIn': 'toPairsIn',
    'extend': 'assignIn',
    'extendAll': 'assignInAll',
    'extendAllWith': 'assignInAllWith',
    'extendWith': 'assignInWith',
    'first': 'head',
    // Methods that are curried variants of others.
    'conforms': 'conformsTo',
    'matches': 'isMatch',
    'property': 'get',
    // Ramda aliases.
    '__': 'placeholder',
    'F': 'stubFalse',
    'T': 'stubTrue',
    'all': 'every',
    'allPass': 'overEvery',
    'always': 'constant',
    'any': 'some',
    'anyPass': 'overSome',
    'apply': 'spread',
    'assoc': 'set',
    'assocPath': 'set',
    'complement': 'negate',
    'compose': 'flowRight',
    'contains': 'includes',
    'dissoc': 'unset',
    'dissocPath': 'unset',
    'dropLast': 'dropRight',
    'dropLastWhile': 'dropRightWhile',
    'equals': 'isEqual',
    'identical': 'eq',
    'indexBy': 'keyBy',
    'init': 'initial',
    'invertObj': 'invert',
    'juxt': 'over',
    'omitAll': 'omit',
    'nAry': 'ary',
    'path': 'get',
    'pathEq': 'matchesProperty',
    'pathOr': 'getOr',
    'paths': 'at',
    'pickAll': 'pick',
    'pipe': 'flow',
    'pluck': 'map',
    'prop': 'get',
    'propEq': 'matchesProperty',
    'propOr': 'getOr',
    'props': 'at',
    'symmetricDifference': 'xor',
    'symmetricDifferenceBy': 'xorBy',
    'symmetricDifferenceWith': 'xorWith',
    'takeLast': 'takeRight',
    'takeLastWhile': 'takeRightWhile',
    'unapply': 'rest',
    'unnest': 'flatten',
    'useWith': 'overArgs',
    'where': 'conformsTo',
    'whereEq': 'isMatch',
    'zipObj': 'zipObject'
};
$fef938fb92c31507$export$85c665b4d7da9cb4 = {
    '1': [
        'assignAll',
        'assignInAll',
        'attempt',
        'castArray',
        'ceil',
        'create',
        'curry',
        'curryRight',
        'defaultsAll',
        'defaultsDeepAll',
        'floor',
        'flow',
        'flowRight',
        'fromPairs',
        'invert',
        'iteratee',
        'memoize',
        'method',
        'mergeAll',
        'methodOf',
        'mixin',
        'nthArg',
        'over',
        'overEvery',
        'overSome',
        'rest',
        'reverse',
        'round',
        'runInContext',
        'spread',
        'template',
        'trim',
        'trimEnd',
        'trimStart',
        'uniqueId',
        'words',
        'zipAll'
    ],
    '2': [
        'add',
        'after',
        'ary',
        'assign',
        'assignAllWith',
        'assignIn',
        'assignInAllWith',
        'at',
        'before',
        'bind',
        'bindAll',
        'bindKey',
        'chunk',
        'cloneDeepWith',
        'cloneWith',
        'concat',
        'conformsTo',
        'countBy',
        'curryN',
        'curryRightN',
        'debounce',
        'defaults',
        'defaultsDeep',
        'defaultTo',
        'delay',
        'difference',
        'divide',
        'drop',
        'dropRight',
        'dropRightWhile',
        'dropWhile',
        'endsWith',
        'eq',
        'every',
        'filter',
        'find',
        'findIndex',
        'findKey',
        'findLast',
        'findLastIndex',
        'findLastKey',
        'flatMap',
        'flatMapDeep',
        'flattenDepth',
        'forEach',
        'forEachRight',
        'forIn',
        'forInRight',
        'forOwn',
        'forOwnRight',
        'get',
        'groupBy',
        'gt',
        'gte',
        'has',
        'hasIn',
        'includes',
        'indexOf',
        'intersection',
        'invertBy',
        'invoke',
        'invokeMap',
        'isEqual',
        'isMatch',
        'join',
        'keyBy',
        'lastIndexOf',
        'lt',
        'lte',
        'map',
        'mapKeys',
        'mapValues',
        'matchesProperty',
        'maxBy',
        'meanBy',
        'merge',
        'mergeAllWith',
        'minBy',
        'multiply',
        'nth',
        'omit',
        'omitBy',
        'overArgs',
        'pad',
        'padEnd',
        'padStart',
        'parseInt',
        'partial',
        'partialRight',
        'partition',
        'pick',
        'pickBy',
        'propertyOf',
        'pull',
        'pullAll',
        'pullAt',
        'random',
        'range',
        'rangeRight',
        'rearg',
        'reject',
        'remove',
        'repeat',
        'restFrom',
        'result',
        'sampleSize',
        'some',
        'sortBy',
        'sortedIndex',
        'sortedIndexOf',
        'sortedLastIndex',
        'sortedLastIndexOf',
        'sortedUniqBy',
        'split',
        'spreadFrom',
        'startsWith',
        'subtract',
        'sumBy',
        'take',
        'takeRight',
        'takeRightWhile',
        'takeWhile',
        'tap',
        'throttle',
        'thru',
        'times',
        'trimChars',
        'trimCharsEnd',
        'trimCharsStart',
        'truncate',
        'union',
        'uniqBy',
        'uniqWith',
        'unset',
        'unzipWith',
        'without',
        'wrap',
        'xor',
        'zip',
        'zipObject',
        'zipObjectDeep'
    ],
    '3': [
        'assignInWith',
        'assignWith',
        'clamp',
        'differenceBy',
        'differenceWith',
        'findFrom',
        'findIndexFrom',
        'findLastFrom',
        'findLastIndexFrom',
        'getOr',
        'includesFrom',
        'indexOfFrom',
        'inRange',
        'intersectionBy',
        'intersectionWith',
        'invokeArgs',
        'invokeArgsMap',
        'isEqualWith',
        'isMatchWith',
        'flatMapDepth',
        'lastIndexOfFrom',
        'mergeWith',
        'orderBy',
        'padChars',
        'padCharsEnd',
        'padCharsStart',
        'pullAllBy',
        'pullAllWith',
        'rangeStep',
        'rangeStepRight',
        'reduce',
        'reduceRight',
        'replace',
        'set',
        'slice',
        'sortedIndexBy',
        'sortedLastIndexBy',
        'transform',
        'unionBy',
        'unionWith',
        'update',
        'xorBy',
        'xorWith',
        'zipWith'
    ],
    '4': [
        'fill',
        'setWith',
        'updateWith'
    ]
};
$fef938fb92c31507$export$42564e045b285e32 = {
    '2': [
        1,
        0
    ],
    '3': [
        2,
        0,
        1
    ],
    '4': [
        3,
        2,
        0,
        1
    ]
};
$fef938fb92c31507$export$81e17196e6a22b07 = {
    'dropRightWhile': 1,
    'dropWhile': 1,
    'every': 1,
    'filter': 1,
    'find': 1,
    'findFrom': 1,
    'findIndex': 1,
    'findIndexFrom': 1,
    'findKey': 1,
    'findLast': 1,
    'findLastFrom': 1,
    'findLastIndex': 1,
    'findLastIndexFrom': 1,
    'findLastKey': 1,
    'flatMap': 1,
    'flatMapDeep': 1,
    'flatMapDepth': 1,
    'forEach': 1,
    'forEachRight': 1,
    'forIn': 1,
    'forInRight': 1,
    'forOwn': 1,
    'forOwnRight': 1,
    'map': 1,
    'mapKeys': 1,
    'mapValues': 1,
    'partition': 1,
    'reduce': 2,
    'reduceRight': 2,
    'reject': 1,
    'remove': 1,
    'some': 1,
    'takeRightWhile': 1,
    'takeWhile': 1,
    'times': 1,
    'transform': 2
};
$fef938fb92c31507$export$30975ceb42167ebd = {
    'mapKeys': [
        1
    ],
    'reduceRight': [
        1,
        0
    ]
};
$fef938fb92c31507$export$8ceb0ad7e94d3801 = {
    'assignInAllWith': [
        1,
        0
    ],
    'assignInWith': [
        1,
        2,
        0
    ],
    'assignAllWith': [
        1,
        0
    ],
    'assignWith': [
        1,
        2,
        0
    ],
    'differenceBy': [
        1,
        2,
        0
    ],
    'differenceWith': [
        1,
        2,
        0
    ],
    'getOr': [
        2,
        1,
        0
    ],
    'intersectionBy': [
        1,
        2,
        0
    ],
    'intersectionWith': [
        1,
        2,
        0
    ],
    'isEqualWith': [
        1,
        2,
        0
    ],
    'isMatchWith': [
        2,
        1,
        0
    ],
    'mergeAllWith': [
        1,
        0
    ],
    'mergeWith': [
        1,
        2,
        0
    ],
    'padChars': [
        2,
        1,
        0
    ],
    'padCharsEnd': [
        2,
        1,
        0
    ],
    'padCharsStart': [
        2,
        1,
        0
    ],
    'pullAllBy': [
        2,
        1,
        0
    ],
    'pullAllWith': [
        2,
        1,
        0
    ],
    'rangeStep': [
        1,
        2,
        0
    ],
    'rangeStepRight': [
        1,
        2,
        0
    ],
    'setWith': [
        3,
        1,
        2,
        0
    ],
    'sortedIndexBy': [
        2,
        1,
        0
    ],
    'sortedLastIndexBy': [
        2,
        1,
        0
    ],
    'unionBy': [
        1,
        2,
        0
    ],
    'unionWith': [
        1,
        2,
        0
    ],
    'updateWith': [
        3,
        1,
        2,
        0
    ],
    'xorBy': [
        1,
        2,
        0
    ],
    'xorWith': [
        1,
        2,
        0
    ],
    'zipWith': [
        1,
        2,
        0
    ]
};
$fef938fb92c31507$export$fbaeb3f87df3cf26 = {
    'assignAll': {
        'start': 0
    },
    'assignAllWith': {
        'start': 0
    },
    'assignInAll': {
        'start': 0
    },
    'assignInAllWith': {
        'start': 0
    },
    'defaultsAll': {
        'start': 0
    },
    'defaultsDeepAll': {
        'start': 0
    },
    'invokeArgs': {
        'start': 2
    },
    'invokeArgsMap': {
        'start': 2
    },
    'mergeAll': {
        'start': 0
    },
    'mergeAllWith': {
        'start': 0
    },
    'partial': {
        'start': 1
    },
    'partialRight': {
        'start': 1
    },
    'without': {
        'start': 1
    },
    'zipAll': {
        'start': 0
    }
};
$fef938fb92c31507$export$57e795267c26e600 = {
    'array': {
        'fill': true,
        'pull': true,
        'pullAll': true,
        'pullAllBy': true,
        'pullAllWith': true,
        'pullAt': true,
        'remove': true,
        'reverse': true
    },
    'object': {
        'assign': true,
        'assignAll': true,
        'assignAllWith': true,
        'assignIn': true,
        'assignInAll': true,
        'assignInAllWith': true,
        'assignInWith': true,
        'assignWith': true,
        'defaults': true,
        'defaultsAll': true,
        'defaultsDeep': true,
        'defaultsDeepAll': true,
        'merge': true,
        'mergeAll': true,
        'mergeAllWith': true,
        'mergeWith': true
    },
    'set': {
        'set': true,
        'setWith': true,
        'unset': true,
        'update': true,
        'updateWith': true
    }
};
$fef938fb92c31507$export$1eb71a7e27943e71 = function() {
    var hasOwnProperty = Object.prototype.hasOwnProperty, object = $fef938fb92c31507$export$bd0f5e6e44efa6b4, result = {};
    for(var key in object){
        var value = object[key];
        if (hasOwnProperty.call(result, value)) result[value].push(key);
        else result[value] = [
            key
        ];
    }
    return result;
}();
$fef938fb92c31507$export$aee1dbae5de2db9d = {
    'assignAll': 'assign',
    'assignAllWith': 'assignWith',
    'assignInAll': 'assignIn',
    'assignInAllWith': 'assignInWith',
    'curryN': 'curry',
    'curryRightN': 'curryRight',
    'defaultsAll': 'defaults',
    'defaultsDeepAll': 'defaultsDeep',
    'findFrom': 'find',
    'findIndexFrom': 'findIndex',
    'findLastFrom': 'findLast',
    'findLastIndexFrom': 'findLastIndex',
    'getOr': 'get',
    'includesFrom': 'includes',
    'indexOfFrom': 'indexOf',
    'invokeArgs': 'invoke',
    'invokeArgsMap': 'invokeMap',
    'lastIndexOfFrom': 'lastIndexOf',
    'mergeAll': 'merge',
    'mergeAllWith': 'mergeWith',
    'padChars': 'pad',
    'padCharsEnd': 'padEnd',
    'padCharsStart': 'padStart',
    'propertyOf': 'get',
    'rangeStep': 'range',
    'rangeStepRight': 'rangeRight',
    'restFrom': 'rest',
    'spreadFrom': 'spread',
    'trimChars': 'trim',
    'trimCharsEnd': 'trimEnd',
    'trimCharsStart': 'trimStart',
    'zipAll': 'zip'
};
$fef938fb92c31507$export$87ffbe4821a5d5e0 = {
    'castArray': true,
    'flow': true,
    'flowRight': true,
    'iteratee': true,
    'mixin': true,
    'rearg': true,
    'runInContext': true
};
$fef938fb92c31507$export$b4d07413ce528c90 = {
    'add': true,
    'assign': true,
    'assignIn': true,
    'bind': true,
    'bindKey': true,
    'concat': true,
    'difference': true,
    'divide': true,
    'eq': true,
    'gt': true,
    'gte': true,
    'isEqual': true,
    'lt': true,
    'lte': true,
    'matchesProperty': true,
    'merge': true,
    'multiply': true,
    'overArgs': true,
    'partial': true,
    'partialRight': true,
    'propertyOf': true,
    'random': true,
    'range': true,
    'rangeRight': true,
    'subtract': true,
    'zip': true,
    'zipObject': true,
    'zipObjectDeep': true
};

});

parcelRegister("aPsMW", function(module, exports) {
/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */ module.exports = {};

});


parcelRegister("7sR67", function(module, exports) {














module.exports = {
    'ary': (parcelRequire("lEyvi")),
    'assign': (parcelRequire("bqJNK")),
    'clone': (parcelRequire("91VA7")),
    'curry': (parcelRequire("a7NzZ")),
    'forEach': (parcelRequire("fmP8r")),
    'isArray': (parcelRequire("8LQ84")),
    'isError': (parcelRequire("aZFhV")),
    'isFunction': (parcelRequire("5vD8v")),
    'isWeakMap': (parcelRequire("5UxIS")),
    'iteratee': (parcelRequire("5qDt4")),
    'keys': (parcelRequire("hR3Ue")),
    'rearg': (parcelRequire("iZlmO")),
    'toInteger': (parcelRequire("kPZpS")),
    'toPath': (parcelRequire("6TYHJ"))
};

});
parcelRegister("lEyvi", function(module, exports) {

var $5oTQF = parcelRequire("5oTQF");
/** Used to compose bitmasks for function metadata. */ var $fc3819207d6eebc6$var$WRAP_ARY_FLAG = 128;
/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */ function $fc3819207d6eebc6$var$ary(func, n, guard) {
    n = guard ? undefined : n;
    n = func && n == null ? func.length : n;
    return $5oTQF(func, $fc3819207d6eebc6$var$WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}
module.exports = $fc3819207d6eebc6$var$ary;

});
parcelRegister("5oTQF", function(module, exports) {

var $g1o5k = parcelRequire("g1o5k");

var $1BSxH = parcelRequire("1BSxH");

var $gQoGK = parcelRequire("gQoGK");

var $2pq1V = parcelRequire("2pq1V");

var $cwXqG = parcelRequire("cwXqG");

var $dzqxs = parcelRequire("dzqxs");

var $c8pf3 = parcelRequire("c8pf3");

var $4EzKU = parcelRequire("4EzKU");

var $iKqmZ = parcelRequire("iKqmZ");

var $kPZpS = parcelRequire("kPZpS");
/** Error message constants. */ var $3eea84024a50d6cf$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $3eea84024a50d6cf$var$WRAP_BIND_FLAG = 1, $3eea84024a50d6cf$var$WRAP_BIND_KEY_FLAG = 2, $3eea84024a50d6cf$var$WRAP_CURRY_FLAG = 8, $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG = 16, $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG = 32, $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3eea84024a50d6cf$var$nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $3eea84024a50d6cf$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & $3eea84024a50d6cf$var$WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != 'function') throw new TypeError($3eea84024a50d6cf$var$FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~($3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG | $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : $3eea84024a50d6cf$var$nativeMax($kPZpS(ary), 0);
    arity = arity === undefined ? arity : $kPZpS(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : $dzqxs(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) $c8pf3(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $3eea84024a50d6cf$var$nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & ($3eea84024a50d6cf$var$WRAP_CURRY_FLAG | $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($3eea84024a50d6cf$var$WRAP_CURRY_FLAG | $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == $3eea84024a50d6cf$var$WRAP_BIND_FLAG) var result = $1BSxH(func, bitmask, thisArg);
    else if (bitmask == $3eea84024a50d6cf$var$WRAP_CURRY_FLAG || bitmask == $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG) result = $gQoGK(func, bitmask, arity);
    else if ((bitmask == $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG || bitmask == ($3eea84024a50d6cf$var$WRAP_BIND_FLAG | $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $cwXqG(func, bitmask, thisArg, partials);
    else result = $2pq1V.apply(undefined, newData);
    var setter = data ? $g1o5k : $4EzKU;
    return $iKqmZ(setter(result, newData), func, bitmask);
}
module.exports = $3eea84024a50d6cf$var$createWrap;

});
parcelRegister("g1o5k", function(module, exports) {

var $etyzk = parcelRequire("etyzk");

var $hQCy5 = parcelRequire("hQCy5");
/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $ba9f6c1d52531584$var$baseSetData = !$hQCy5 ? $etyzk : function(func, data) {
    $hQCy5.set(func, data);
    return func;
};
module.exports = $ba9f6c1d52531584$var$baseSetData;

});

parcelRegister("1BSxH", function(module, exports) {

var $iJkMv = parcelRequire("iJkMv");

var $1V15E = parcelRequire("1V15E");
/** Used to compose bitmasks for function metadata. */ var $12c38e2c5009183b$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $12c38e2c5009183b$var$createBind(func, bitmask, thisArg) {
    var isBind = bitmask & $12c38e2c5009183b$var$WRAP_BIND_FLAG, Ctor = $iJkMv(func);
    function wrapper() {
        var fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
module.exports = $12c38e2c5009183b$var$createBind;

});
parcelRegister("iJkMv", function(module, exports) {

var $ady43 = parcelRequire("ady43");

var $k0qYG = parcelRequire("k0qYG");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function $da2c8caf7ae3955a$var$createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = $ady43(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return $k0qYG(result) ? result : thisBinding;
    };
}
module.exports = $da2c8caf7ae3955a$var$createCtor;

});


parcelRegister("gQoGK", function(module, exports) {

var $hlchF = parcelRequire("hlchF");

var $iJkMv = parcelRequire("iJkMv");

var $2pq1V = parcelRequire("2pq1V");

var $6fuEo = parcelRequire("6fuEo");

var $8ZIC5 = parcelRequire("8ZIC5");

var $kBUUu = parcelRequire("kBUUu");

var $1V15E = parcelRequire("1V15E");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $c434a7442e0e841e$var$createCurry(func, bitmask, arity) {
    var Ctor = $iJkMv(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = $8ZIC5(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $kBUUu(args, placeholder);
        length -= holders.length;
        if (length < arity) return $6fuEo(func, bitmask, $2pq1V, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
        return $hlchF(fn, this, args);
    }
    return wrapper;
}
module.exports = $c434a7442e0e841e$var$createCurry;

});
parcelRegister("2pq1V", function(module, exports) {

var $k8MLc = parcelRequire("k8MLc");

var $eqXBf = parcelRequire("eqXBf");

var $khpbX = parcelRequire("khpbX");

var $iJkMv = parcelRequire("iJkMv");

var $6fuEo = parcelRequire("6fuEo");

var $8ZIC5 = parcelRequire("8ZIC5");

var $3Prcz = parcelRequire("3Prcz");

var $kBUUu = parcelRequire("kBUUu");

var $1V15E = parcelRequire("1V15E");
/** Used to compose bitmasks for function metadata. */ var $1c121b92b9034c1f$var$WRAP_BIND_FLAG = 1, $1c121b92b9034c1f$var$WRAP_BIND_KEY_FLAG = 2, $1c121b92b9034c1f$var$WRAP_CURRY_FLAG = 8, $1c121b92b9034c1f$var$WRAP_CURRY_RIGHT_FLAG = 16, $1c121b92b9034c1f$var$WRAP_ARY_FLAG = 128, $1c121b92b9034c1f$var$WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $1c121b92b9034c1f$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & $1c121b92b9034c1f$var$WRAP_ARY_FLAG, isBind = bitmask & $1c121b92b9034c1f$var$WRAP_BIND_FLAG, isBindKey = bitmask & $1c121b92b9034c1f$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($1c121b92b9034c1f$var$WRAP_CURRY_FLAG | $1c121b92b9034c1f$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $1c121b92b9034c1f$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $iJkMv(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = $8ZIC5(wrapper), holdersCount = $khpbX(args, placeholder);
        if (partials) args = $k8MLc(args, partials, holders, isCurried);
        if (partialsRight) args = $eqXBf(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = $kBUUu(args, placeholder);
            return $6fuEo(func, bitmask, $1c121b92b9034c1f$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = $3Prcz(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== $1V15E && this instanceof wrapper) fn = Ctor || $iJkMv(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = $1c121b92b9034c1f$var$createHybrid;

});
parcelRegister("k8MLc", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ea9a60ca966f8da9$var$nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $ea9a60ca966f8da9$var$composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $ea9a60ca966f8da9$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = $ea9a60ca966f8da9$var$composeArgs;

});

parcelRegister("eqXBf", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a821b9ab167c5b82$var$nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $a821b9ab167c5b82$var$composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $a821b9ab167c5b82$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = $a821b9ab167c5b82$var$composeArgsRight;

});

parcelRegister("khpbX", function(module, exports) {
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function $ec38efbc1ab3f809$var$countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
module.exports = $ec38efbc1ab3f809$var$countHolders;

});

parcelRegister("6fuEo", function(module, exports) {

var $2dCKt = parcelRequire("2dCKt");

var $4EzKU = parcelRequire("4EzKU");

var $iKqmZ = parcelRequire("iKqmZ");
/** Used to compose bitmasks for function metadata. */ var $48cbeb57943323d5$var$WRAP_BIND_FLAG = 1, $48cbeb57943323d5$var$WRAP_BIND_KEY_FLAG = 2, $48cbeb57943323d5$var$WRAP_CURRY_BOUND_FLAG = 4, $48cbeb57943323d5$var$WRAP_CURRY_FLAG = 8, $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG = 32, $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $48cbeb57943323d5$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & $48cbeb57943323d5$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG : $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG : $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG);
    if (!(bitmask & $48cbeb57943323d5$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($48cbeb57943323d5$var$WRAP_BIND_FLAG | $48cbeb57943323d5$var$WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if ($2dCKt(func)) $4EzKU(result, newData);
    result.placeholder = placeholder;
    return $iKqmZ(result, func, bitmask);
}
module.exports = $48cbeb57943323d5$var$createRecurry;

});
parcelRegister("4EzKU", function(module, exports) {

var $g1o5k = parcelRequire("g1o5k");

var $eqv0t = parcelRequire("eqv0t");
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $3636a22a88d50b78$var$setData = $eqv0t($g1o5k);
module.exports = $3636a22a88d50b78$var$setData;

});

parcelRegister("iKqmZ", function(module, exports) {

var $d25DY = parcelRequire("d25DY");

var $iPKwQ = parcelRequire("iPKwQ");

var $8pgNR = parcelRequire("8pgNR");

var $1ZcUe = parcelRequire("1ZcUe");
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function $da60fa5a8c702882$var$setWrapToString(wrapper, reference, bitmask) {
    var source = reference + '';
    return $8pgNR(wrapper, $iPKwQ(source, $1ZcUe($d25DY(source), bitmask)));
}
module.exports = $da60fa5a8c702882$var$setWrapToString;

});
parcelRegister("d25DY", function(module, exports) {
/** Used to match wrap detail comments. */ var $97cfd7023a392295$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $97cfd7023a392295$var$reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function $97cfd7023a392295$var$getWrapDetails(source) {
    var match = source.match($97cfd7023a392295$var$reWrapDetails);
    return match ? match[1].split($97cfd7023a392295$var$reSplitDetails) : [];
}
module.exports = $97cfd7023a392295$var$getWrapDetails;

});

parcelRegister("iPKwQ", function(module, exports) {
/** Used to match wrap detail comments. */ var $db61150bcd231438$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function $db61150bcd231438$var$insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
    details = details.join(length > 2 ? ', ' : ' ');
    return source.replace($db61150bcd231438$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}
module.exports = $db61150bcd231438$var$insertWrapDetails;

});

parcelRegister("1ZcUe", function(module, exports) {

var $fmP8r = parcelRequire("fmP8r");

var $fUP98 = parcelRequire("fUP98");
/** Used to compose bitmasks for function metadata. */ var $17257fcfcc231370$var$WRAP_BIND_FLAG = 1, $17257fcfcc231370$var$WRAP_BIND_KEY_FLAG = 2, $17257fcfcc231370$var$WRAP_CURRY_FLAG = 8, $17257fcfcc231370$var$WRAP_CURRY_RIGHT_FLAG = 16, $17257fcfcc231370$var$WRAP_PARTIAL_FLAG = 32, $17257fcfcc231370$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $17257fcfcc231370$var$WRAP_ARY_FLAG = 128, $17257fcfcc231370$var$WRAP_REARG_FLAG = 256, $17257fcfcc231370$var$WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var $17257fcfcc231370$var$wrapFlags = [
    [
        'ary',
        $17257fcfcc231370$var$WRAP_ARY_FLAG
    ],
    [
        'bind',
        $17257fcfcc231370$var$WRAP_BIND_FLAG
    ],
    [
        'bindKey',
        $17257fcfcc231370$var$WRAP_BIND_KEY_FLAG
    ],
    [
        'curry',
        $17257fcfcc231370$var$WRAP_CURRY_FLAG
    ],
    [
        'curryRight',
        $17257fcfcc231370$var$WRAP_CURRY_RIGHT_FLAG
    ],
    [
        'flip',
        $17257fcfcc231370$var$WRAP_FLIP_FLAG
    ],
    [
        'partial',
        $17257fcfcc231370$var$WRAP_PARTIAL_FLAG
    ],
    [
        'partialRight',
        $17257fcfcc231370$var$WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        'rearg',
        $17257fcfcc231370$var$WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function $17257fcfcc231370$var$updateWrapDetails(details, bitmask) {
    $fmP8r($17257fcfcc231370$var$wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if (bitmask & pair[1] && !$fUP98(details, value)) details.push(value);
    });
    return details.sort();
}
module.exports = $17257fcfcc231370$var$updateWrapDetails;

});



parcelRegister("8ZIC5", function(module, exports) {
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function $68c6a086039b9437$var$getHolder(func) {
    var object = func;
    return object.placeholder;
}
module.exports = $68c6a086039b9437$var$getHolder;

});

parcelRegister("3Prcz", function(module, exports) {

var $jHlUS = parcelRequire("jHlUS");

var $e8U1z = parcelRequire("e8U1z");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2c9b3c36ffa24094$var$nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function $2c9b3c36ffa24094$var$reorder(array, indexes) {
    var arrLength = array.length, length = $2c9b3c36ffa24094$var$nativeMin(indexes.length, arrLength), oldArray = $jHlUS(array);
    while(length--){
        var index = indexes[length];
        array[length] = $e8U1z(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = $2c9b3c36ffa24094$var$reorder;

});

parcelRegister("kBUUu", function(module, exports) {
/** Used as the internal argument placeholder. */ var $f0136883d4267917$var$PLACEHOLDER = '__lodash_placeholder__';
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function $f0136883d4267917$var$replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === $f0136883d4267917$var$PLACEHOLDER) {
            array[index] = $f0136883d4267917$var$PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
module.exports = $f0136883d4267917$var$replaceHolders;

});



parcelRegister("cwXqG", function(module, exports) {

var $hlchF = parcelRequire("hlchF");

var $iJkMv = parcelRequire("iJkMv");

var $1V15E = parcelRequire("1V15E");
/** Used to compose bitmasks for function metadata. */ var $91f6929c17575724$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function $91f6929c17575724$var$createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & $91f6929c17575724$var$WRAP_BIND_FLAG, Ctor = $iJkMv(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return $hlchF(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = $91f6929c17575724$var$createPartial;

});

parcelRegister("c8pf3", function(module, exports) {

var $k8MLc = parcelRequire("k8MLc");

var $eqXBf = parcelRequire("eqXBf");

var $kBUUu = parcelRequire("kBUUu");
/** Used as the internal argument placeholder. */ var $8d59cfe3586d6695$var$PLACEHOLDER = '__lodash_placeholder__';
/** Used to compose bitmasks for function metadata. */ var $8d59cfe3586d6695$var$WRAP_BIND_FLAG = 1, $8d59cfe3586d6695$var$WRAP_BIND_KEY_FLAG = 2, $8d59cfe3586d6695$var$WRAP_CURRY_BOUND_FLAG = 4, $8d59cfe3586d6695$var$WRAP_CURRY_FLAG = 8, $8d59cfe3586d6695$var$WRAP_ARY_FLAG = 128, $8d59cfe3586d6695$var$WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8d59cfe3586d6695$var$nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function $8d59cfe3586d6695$var$mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($8d59cfe3586d6695$var$WRAP_BIND_FLAG | $8d59cfe3586d6695$var$WRAP_BIND_KEY_FLAG | $8d59cfe3586d6695$var$WRAP_ARY_FLAG);
    var isCombo = srcBitmask == $8d59cfe3586d6695$var$WRAP_ARY_FLAG && bitmask == $8d59cfe3586d6695$var$WRAP_CURRY_FLAG || srcBitmask == $8d59cfe3586d6695$var$WRAP_ARY_FLAG && bitmask == $8d59cfe3586d6695$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($8d59cfe3586d6695$var$WRAP_ARY_FLAG | $8d59cfe3586d6695$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $8d59cfe3586d6695$var$WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & $8d59cfe3586d6695$var$WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & $8d59cfe3586d6695$var$WRAP_BIND_FLAG ? 0 : $8d59cfe3586d6695$var$WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? $k8MLc(partials, value, source[4]) : value;
        data[4] = partials ? $kBUUu(data[3], $8d59cfe3586d6695$var$PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? $eqXBf(partials, value, source[6]) : value;
        data[6] = partials ? $kBUUu(data[5], $8d59cfe3586d6695$var$PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & $8d59cfe3586d6695$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $8d59cfe3586d6695$var$nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = $8d59cfe3586d6695$var$mergeData;

});



parcelRegister("91VA7", function(module, exports) {

var $7MmCC = parcelRequire("7MmCC");
/** Used to compose bitmasks for cloning. */ var $6930df867851495d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $6930df867851495d$var$clone(value) {
    return $7MmCC(value, $6930df867851495d$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $6930df867851495d$var$clone;

});

parcelRegister("a7NzZ", function(module, exports) {

var $5oTQF = parcelRequire("5oTQF");
/** Used to compose bitmasks for function metadata. */ var $75f10447dad5f8f2$var$WRAP_CURRY_FLAG = 8;
/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */ function $75f10447dad5f8f2$var$curry(func, arity, guard) {
    arity = guard ? undefined : arity;
    var result = $5oTQF(func, $75f10447dad5f8f2$var$WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
    result.placeholder = $75f10447dad5f8f2$var$curry.placeholder;
    return result;
}
// Assign default placeholders.
$75f10447dad5f8f2$var$curry.placeholder = {};
module.exports = $75f10447dad5f8f2$var$curry;

});

parcelRegister("aZFhV", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");

var $1QOns = parcelRequire("1QOns");
/** `Object#toString` result references. */ var $800fa0dabdb52684$var$domExcTag = '[object DOMException]', $800fa0dabdb52684$var$errorTag = '[object Error]';
/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */ function $800fa0dabdb52684$var$isError(value) {
    if (!$fC1Kz(value)) return false;
    var tag = $beQoo(value);
    return tag == $800fa0dabdb52684$var$errorTag || tag == $800fa0dabdb52684$var$domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !$1QOns(value);
}
module.exports = $800fa0dabdb52684$var$isError;

});

parcelRegister("5UxIS", function(module, exports) {

var $jtBGw = parcelRequire("jtBGw");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $44dc5758474a5c9f$var$weakMapTag = '[object WeakMap]';
/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */ function $44dc5758474a5c9f$var$isWeakMap(value) {
    return $fC1Kz(value) && $jtBGw(value) == $44dc5758474a5c9f$var$weakMapTag;
}
module.exports = $44dc5758474a5c9f$var$isWeakMap;

});

parcelRegister("5qDt4", function(module, exports) {

var $7MmCC = parcelRequire("7MmCC");

var $bxDef = parcelRequire("bxDef");
/** Used to compose bitmasks for cloning. */ var $3f3dfefad45dde4d$var$CLONE_DEEP_FLAG = 1;
/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */ function $3f3dfefad45dde4d$var$iteratee(func) {
    return $bxDef(typeof func == 'function' ? func : $7MmCC(func, $3f3dfefad45dde4d$var$CLONE_DEEP_FLAG));
}
module.exports = $3f3dfefad45dde4d$var$iteratee;

});

parcelRegister("iZlmO", function(module, exports) {

var $5oTQF = parcelRequire("5oTQF");

var $9SRAA = parcelRequire("9SRAA");
/** Used to compose bitmasks for function metadata. */ var $dd2e7f874e5ccea3$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */ var $dd2e7f874e5ccea3$var$rearg = $9SRAA(function(func, indexes) {
    return $5oTQF(func, $dd2e7f874e5ccea3$var$WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});
module.exports = $dd2e7f874e5ccea3$var$rearg;

});

parcelRegister("6TYHJ", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $jHlUS = parcelRequire("jHlUS");

var $8LQ84 = parcelRequire("8LQ84");

var $4faK3 = parcelRequire("4faK3");

var $h5JBK = parcelRequire("h5JBK");

var $gzebZ = parcelRequire("gzebZ");

var $jJVtR = parcelRequire("jJVtR");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $5066f7c1bc1a55ec$var$toPath(value) {
    if ($8LQ84(value)) return $1nIHN(value, $gzebZ);
    return $4faK3(value) ? [
        value
    ] : $jHlUS($h5JBK($jJVtR(value)));
}
module.exports = $5066f7c1bc1a55ec$var$toPath;

});



parcelRegister("iASWI", function(module, exports) {

var $irTmi = parcelRequire("irTmi");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $d89635f071f7433a$var$range = $irTmi();
module.exports = $d89635f071f7433a$var$range;

});
parcelRegister("irTmi", function(module, exports) {

var $7DMj9 = parcelRequire("7DMj9");

var $4rDUz = parcelRequire("4rDUz");

var $kJ0Lf = parcelRequire("kJ0Lf");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $d6e5b0af0cc26ead$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $4rDUz(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $kJ0Lf(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $kJ0Lf(end);
        step = step === undefined ? start < end ? 1 : -1 : $kJ0Lf(step);
        return $7DMj9(start, end, step, fromRight);
    };
}
module.exports = $d6e5b0af0cc26ead$var$createRange;

});
parcelRegister("7DMj9", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5901a5dd7694a169$var$nativeCeil = Math.ceil, $5901a5dd7694a169$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $5901a5dd7694a169$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $5901a5dd7694a169$var$nativeMax($5901a5dd7694a169$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = $5901a5dd7694a169$var$baseRange;

});





parcelRegister("4zcxJ", function(module, exports) {

$parcel$export(module.exports, "useExpandableEntryPointTrigger", () => $a613456b7f090bbf$export$569294f6ae10bba9);

var $5uXOq = parcelRequire("5uXOq");

var $47gW9 = parcelRequire("47gW9");
const $a613456b7f090bbf$export$569294f6ae10bba9 = (actions, isActive = true)=>{
    // We don't want the click-handler, as ExpandableMenuItem handles the entry-point loading itself
    const eventMap = (0, $5uXOq.useMemo)(()=>Object.fromEntries(Object.entries((0, $47gW9.getDefaultEntrypointActionEventMap)(actions)).filter(([key])=>key !== 'click')), [
        actions
    ]);
    return (0, $47gW9.useEntryPointButtonTrigger)(actions, isActive, eventMap);
};

});
parcelRegister("47gW9", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $1be876415a945060$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $1be876415a945060$export$5f13515bd3a35325);

var $5uXOq = parcelRequire("5uXOq");

var $iRKpN = parcelRequire("iRKpN");
const $1be876415a945060$export$25d2524a63315ed = (actions, isActive = true, eventMap)=>{
    const removePreviousListeners = (0, $5uXOq.useRef)(null);
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $5uXOq.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        const elementEventMap = eventMap || $1be876415a945060$export$5f13515bd3a35325(actions);
        if (element && isActive) {
            (0, $iRKpN.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: elementEventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $iRKpN.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: elementEventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        actions,
        eventMap,
        isActive
    ]);
};
const $1be876415a945060$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("iRKpN", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $62bae43418420b8a$export$15257a36a7e3f9d6);
function $62bae43418420b8a$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});



parcelRegister("7Y7Js", function(module, exports) {

$parcel$export(module.exports, "ExploreMoreApps", () => $f69daa56854375f6$export$e3e10d2adcb07330);

var $5uXOq = parcelRequire("5uXOq");

var $6YfOV = parcelRequire("6YfOV");



var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $24a2m = parcelRequire("24a2m");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $9OXo1 = parcelRequire("9OXo1");

var $6s1PB = parcelRequire("6s1PB");

var $jGx9e = parcelRequire("jGx9e");
const $f69daa56854375f6$var$pathToNavigate = '/jira/marketplace/discover';
function $f69daa56854375f6$export$e3e10d2adcb07330() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = tenantContext;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $jGx9e.default).exploreMoreApps, (0, (/*@__PURE__*/$parcel$interopDefault($6YfOV))));
    const onClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_APPS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                itemId: 'exploreMoreApps'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const showExploreMoreApps = isAdmin ? isSiteAdmin && (0, $6s1PB.expVal)('emcee-discover', 'value', true) : (0, $6s1PB.expVal)('enduser-emcee-discover', 'value', true);
    if (!showExploreMoreApps) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        elemBefore: icon,
        href: $f69daa56854375f6$var$pathToNavigate,
        menuId: (0, $jhS4y.MENU_ID_APP_MARKETPLACE_DISCOVER),
        onClick: onClick
    }, formattedMessage);
}

});
parcelRegister("jGx9e", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1d28052ecc552f9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c1d28052ecc552f9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    exploreMoreApps: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.explore-more-apps.explore-more-apps",
        "defaultMessage": "Explore more apps"
    }
});

});


parcelRegister("a9Ndx", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItemContent", () => $5ff34b094c5ae0ff$export$bd680a81504a92e9);
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $baVkR = parcelRequire("baVkR");

var $fOnXR = parcelRequire("fOnXR");
const $5ff34b094c5ae0ff$var$styles = {
    content: "_bozg1crf",
    collapsedContent: "_1e0cglyw"
};
const $5ff34b094c5ae0ff$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $fOnXR.useIsExpanded)();
    const level = (0, $fOnXR.useLevel)();
    const hasExpanded = (0, $5uXOq.useRef)(false);
    const areAllAncestorsExpanded = (0, $fOnXR.useAreAllAncestorsExpanded)();
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fOnXR.LevelContext).Provider, {
        value: level + 1,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fOnXR.AreAllAncestorsExpandedContext).Provider, {
            value: /**
     * By combining the current ancestor and with the current menu item's state, all nested menu items will know if their
     * ancestor menu items are all expanded.
     */ areAllAncestorsExpanded && isExpanded,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $baVkR.List), {
                ref: forwardedRef,
                xcss: (0, $DEWI6.cx)($5ff34b094c5ae0ff$var$styles.content, !isExpanded && $5ff34b094c5ae0ff$var$styles.collapsedContent),
                children: children
            })
        })
    });
});

});

parcelRegister("4bjXD", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItemTrigger", () => $44fed75b745ec739$export$fe6fe51056867f4d);
/* expandable-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $1Seuh = parcelRequire("1Seuh");

var $jVpd1 = parcelRequire("jVpd1");

var $LD2gx = parcelRequire("LD2gx");

var $kTSv9 = parcelRequire("kTSv9");

var $aJFme = parcelRequire("aJFme");

var $fOnXR = parcelRequire("fOnXR");
// Widening type to `string` to side-step Compiled cssMap typescript warnings with unknown properties
const $44fed75b745ec739$var$chevronDisplayCssVar = '--expandable-chevron-display';
const $44fed75b745ec739$var$providedElemBeforeDisplayCssVar = '--expandable-provided-elembefore-display';
const $44fed75b745ec739$var$wrapperStyles = {
    root: "_1mmi1bgi _165nglyw",
    showProvidedElemBefore: "_1mmiglyw _165n1bgi _v9u71bgi _1hl9glyw _b31z1bgi _1vnl1bgi _12xsglyw _p8btglyw"
};
const $44fed75b745ec739$var$iconStyles = {
    chevron: "_1e0ciw0t",
    providedElemBefore: "_1e0c1xb2"
};
const $44fed75b745ec739$var$ExpandableMenuItemIcon = ({ iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($jVpd1))) : (0, (/*@__PURE__*/$parcel$interopDefault($LD2gx)));
    const chevronElem = /*#__PURE__*/ (0, $2OMIu.jsx)(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #0C66E4)" : undefined
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $44fed75b745ec739$var$iconStyles.chevron
                ]),
                children: chevronElem
            }),
            providedElemBefore && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $44fed75b745ec739$var$iconStyles.providedElemBefore
                ]),
                children: providedElemBefore
            })
        ]
    });
};
const $44fed75b745ec739$export$fe6fe51056867f4d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef }, forwardedRef)=>{
    const onExpansionToggle = (0, $fOnXR.useOnExpansionToggle)();
    const isExpanded = (0, $fOnXR.useIsExpanded)();
    const setIsExpanded = (0, $fOnXR.useSetIsExpanded)();
    const itemRef = (0, $5uXOq.useRef)(null);
    const handleIconClick = (0, $5uXOq.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        const newValue = !isExpanded;
        onClick?.(event, analyticsEvent, {
            isExpanded: newValue
        });
        onExpansionToggle?.(newValue);
        setIsExpanded(newValue);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    (0, $aJFme.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: Boolean(isSelectable && isSelected)
    });
    // Wrapped in an IconButton if the expandable menu item trigger is selectable
    const elemBefore = isSelectable ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)($44fed75b745ec739$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            }),
        "aria-expanded": isExpanded,
        label: isExpanded ? 'Collapse' : 'Expand',
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($44fed75b745ec739$var$ExpandableMenuItemIcon, {
        isExpanded: isExpanded,
        isSelected: isSelected,
        providedElemBefore: providedElemBefore
    });
    // For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: itemRef,
        className: (0, $bwpsq.default)([
            $44fed75b745ec739$var$wrapperStyles.root,
            providedElemBefore && $44fed75b745ec739$var$wrapperStyles.showProvidedElemBefore
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kTSv9.MenuItemBase), {
            actions: actions,
            actionsOnHover: actionsOnHover,
            elemBefore: elemBefore,
            ariaExpanded: isExpanded,
            elemAfter: elemAfter,
            href: href,
            isSelected: isSelected,
            onClick: handleMenuContentClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            testId: testId,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            children: children
        })
    });
});

});

const $13973d4cc5182a50$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Apps';
const $13973d4cc5182a50$export$d57b6b390e78d90f = 'smite';

parcelRegister("6EHtA", function(module, exports) {

$parcel$export(module.exports, "createAttributes", () => $5df5d3b717f9866b$export$c7c9603a6b1fd815);

var $4R6GH = parcelRequire("4R6GH");

var $fZneA = parcelRequire("fZneA");

var $j8DrX = parcelRequire("j8DrX");
const $5df5d3b717f9866b$var$isSynthetic = ()=>// Filter out synthetic tests using all known ways
    (0, $j8DrX.default)('ajs-is-synthetic') === 'true' || (0, $4R6GH.fg)('forge_ui_synthetic_check');
const $5df5d3b717f9866b$var$FAILED_TO_FETCH = 'FAILED_TO_FETCH';
const $5df5d3b717f9866b$var$getErrorType = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ((0, $fZneA.isClientFetchError)(error)) return $5df5d3b717f9866b$var$FAILED_TO_FETCH;
    return 'OTHER';
};
const $5df5d3b717f9866b$export$78c6267359db7e73 = (error)=>({
        ...error,
        stack: error.stack,
        message: error?.message
    });
const $5df5d3b717f9866b$export$c7c9603a6b1fd815 = (rawAttributes)=>{
    const attributes = {
        isSynthetic: $5df5d3b717f9866b$var$isSynthetic(),
        isSSR: false
    };
    if (rawAttributes) {
        const { error: error } = rawAttributes;
        if (error) {
            attributes.error = $5df5d3b717f9866b$export$78c6267359db7e73(error);
            attributes.errorType = $5df5d3b717f9866b$var$getErrorType(error);
        }
    }
    return {
        ...rawAttributes,
        ...attributes
    };
};

});

parcelRegister("g72iU", function(module, exports) {

$parcel$export(module.exports, "asyncNav4AppsContentViewQuery", () => $cda04b3061c529f3$export$3cc582e017e659a5);

var $2W8ID = parcelRequire("2W8ID");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $cda04b3061c529f3$export$3cc582e017e659a5 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("8wTDx")).then(({ Nav4AppsContentViewQuery: Nav4AppsContentViewQuery })=>Nav4AppsContentViewQuery), {
        moduleId: "5e1e3d10",
        moduleName: "Nav4AppsContentViewQuery"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                apps: {
                    parameters: $2W8ID.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("2W8ID", function(module, exports) {

$parcel$export(module.exports, "default", () => $997a21b7e3836e4d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c3466e83c238f159467fc840ff1cb0e1>>
 * @relayHash de318b509d0ab4c8f6f3bb43a255428f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2775e0119718d7da79e84dfb1c18e4b8a69f2027bcfdf8309725027ec63f453f
const $997a21b7e3836e4d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "label"
    }, v2 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v3 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4AppsContentViewQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "Nav4AppsContent"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4AppsContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraNavigationItemConnection",
                            "kind": "LinkedField",
                            "name": "globalAppNavigationItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNavigationItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "envLabel"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "iconUrl"
                                                        },
                                                        v2 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraAppSection",
                                                            "kind": "LinkedField",
                                                            "name": "sections",
                                                            "plural": true,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                    "kind": "LinkedField",
                                                                    "name": "links",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        v3 /*: any*/ ,
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "settingsUrl"
                                                        },
                                                        v3 /*: any*/ 
                                                    ],
                                                    "type": "JiraAppNavigationItem"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2775e0119718d7da79e84dfb1c18e4b8a69f2027bcfdf8309725027ec63f453f",
            "metadata": {},
            "name": "Nav4AppsContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$997a21b7e3836e4d$var$node.hash = "157a8cfe104b1d671cc09c5f8aee481a";
var $997a21b7e3836e4d$export$2e2bcd8739ae039 = $997a21b7e3836e4d$var$node;

});

parcelRegister("8wTDx", function(module, exports) {

let $635c782dc6c73013$var$load = (parcelRequire("28QjX"))(4);
module.exports = $635c782dc6c73013$var$load("F3QUg").then(()=>parcelRequire('30ibK'));

});



parcelRegister("iJgtS", function(module, exports) {

$parcel$export(module.exports, "Nav4AppsForLanding", () => $e9ee9ccd4f89fb22$export$889c9c34c80104b2);

var $3iyZg = parcelRequire("3iyZg");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");


var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $iszzG = parcelRequire("iszzG");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $dQbFB = parcelRequire("dQbFB");

var $dUyqZ = parcelRequire("dUyqZ");

var $gpcgC = parcelRequire("gpcgC");

var $7Y7Js = parcelRequire("7Y7Js");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $l8ruj = parcelRequire("l8ruj");

var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");
function $e9ee9ccd4f89fb22$export$889c9c34c80104b2(props) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, $iszzG.NavItemsContext));
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).APPS);
    const data = (0, $8Uumt.useFragment)((0, $3iyZg.default), queryRef);
    const menuId = (0, $jhS4y.MENU_ID_APPS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) {
                const event = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
                });
                const isInMore = moreMenuIds.includes((0, $46Cti.L1_MENU_ID).APPS);
                (0, $8zOmE.fireUIAnalytics)(event, (0, $jecJ3.SECTION_ITEM_APPS), {
                    isInMore: isInMore
                });
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon + text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-apps-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gpcgC.Nav4AppsContent), {
        queryRef: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Y7Js.ExploreMoreApps), null))));
}

});
parcelRegister("3iyZg", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf7940716f9101a5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<43a8cee8bfdf430e242ac6d6e2f5e807>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bf7940716f9101a5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4AppsForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4AppsContent"
        }
    ],
    "type": "JiraQuery"
};
$bf7940716f9101a5$var$node.hash = "9c28cb4a0c92a920a58010f91f4f4f0e";
var $bf7940716f9101a5$export$2e2bcd8739ae039 = $bf7940716f9101a5$var$node;

});

parcelRegister("gpcgC", function(module, exports) {

$parcel$export(module.exports, "Nav4AppsContent", () => $23e70e20d1d66b25$export$aaf45d195a81792d);

var $67Dt2 = parcelRequire("67Dt2");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $1rTGO = parcelRequire("1rTGO");

var $3wOYX = parcelRequire("3wOYX");

var $k2DRb = parcelRequire("k2DRb");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $i2fHy = parcelRequire("i2fHy");

var $8MAOw = parcelRequire("8MAOw");

var $4IIGx = parcelRequire("4IIGx");
var $4vWwj = parcelRequire("4vWwj");
var $ch7sx = parcelRequire("ch7sx");
var $l3A2e = parcelRequire("l3A2e");

var $j02Uq = parcelRequire("j02Uq");

var $hDULT = parcelRequire("hDULT");
function $23e70e20d1d66b25$export$aaf45d195a81792d({ queryRef: queryRef }) {
    const data = (0, $8Uumt.useFragment)((0, $67Dt2.default), queryRef);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const menuItemNodes = (0, $5uXOq.useMemo)(()=>(data?.globalAppNavigationItems?.edges || []).filter((edge)=>{
            // Keep only Forge and Connect apps on the list
            if (edge?.node?.appType !== 'CONNECT' && edge?.node?.appType !== 'FORGE') return false;
            // Filter out system apps just like it was done in the old navigation
            return edge?.node?.appId !== (0, $lmyls.ADDON_ID).DISCOVER;
        }).map((edge)=>edge?.node).sort((a, b)=>(a?.label || '').localeCompare(b?.label || '')) || [], [
        data?.globalAppNavigationItems
    ]);
    const renderedMenuItems = (0, $5uXOq.useMemo)(()=>menuItemNodes.map((node)=>{
            switch(node?.appType){
                case 'CONNECT':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2fHy.Nav4ConnectMenuItem), {
                        key: node.id,
                        queryRef: node
                    });
                case 'FORGE':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8MAOw.Nav4ForgeMenuItem), {
                        key: node.id,
                        queryRef: node
                    });
                default:
                    return null;
            }
        }).filter(Boolean), [
        menuItemNodes
    ]);
    const hasForgeApps = (0, $5uXOq.useMemo)(()=>menuItemNodes.some((node)=>node?.appType === 'FORGE'), [
        menuItemNodes
    ]);
    return renderedMenuItems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($23e70e20d1d66b25$var$ForgeAnalyticsWrapper, {
        shouldReport: hasForgeApps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4vWwj.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ch7sx.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l3A2e.MenuSectionHeading), null, formatMessage((0, $hDULT.default).yourApps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, renderedMenuItems, hasForgeApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.GLOBAL_PAGE_MODULE)
        }
    })))), (0, $4R6GH.fg)('jira_nav4_apps_menu_recommend') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j02Uq.AsyncDiscoverSection), null) : null) : null;
}
function $23e70e20d1d66b25$var$ForgeAnalyticsWrapper({ shouldReport: shouldReport, children: children }) {
    return shouldReport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wOYX.TriggerAnalyticsWrapper), null, children) : children;
}

});
parcelRegister("67Dt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1c56b3bd1de4f5e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ddb8a1bbce6fff611878abb761dbf404>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c1c56b3bd1de4f5e$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4AppsContent",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraNavigationItemConnection",
            "kind": "LinkedField",
            "name": "globalAppNavigationItems",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraNavigationItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            },
                                            "action": "THROW",
                                            "path": "globalAppNavigationItems.edges.node.id"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appType"
                                                }
                                            ],
                                            "type": "JiraAppNavigationItem"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "Nav4ConnectMenuItem"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "Nav4ForgeMenuItem"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "globalAppNavigationItems.edges.node"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "globalAppNavigationItems.edges"
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$c1c56b3bd1de4f5e$var$node.hash = "6074e52ca012374d836fe32977dd1a14";
var $c1c56b3bd1de4f5e$export$2e2bcd8739ae039 = $c1c56b3bd1de4f5e$var$node;

});

parcelRegister("1rTGO", function(module, exports) {

$parcel$export(module.exports, "ForgeScreenEvent", () => $abbdb580491d9d09$export$92d758d83665314b);
$parcel$export(module.exports, "ForgeOperationaFailedEvent", () => $abbdb580491d9d09$export$a238c3c13f29c134);
$parcel$export(module.exports, "ForgeErrorBoundary", () => $abbdb580491d9d09$export$ac7e7464cefab440);
$parcel$export(module.exports, "ForgeAnalyticsWrapper", () => $abbdb580491d9d09$export$ad2a5d9127152fb8);
$parcel$export(module.exports, "withMetrics", () => $abbdb580491d9d09$export$14e56d7f5d3f917c);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $k2DRb = parcelRequire("k2DRb");

var $3mOWa = parcelRequire("3mOWa");

var $eOGyv = parcelRequire("eOGyv");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $isuse = parcelRequire("isuse");

var $4R6GH = parcelRequire("4R6GH");

var $hBuqR = parcelRequire("hBuqR");

var $6MtPV = parcelRequire("6MtPV");

var $dd7Uh = parcelRequire("dd7Uh");

var $2RhPB = parcelRequire("2RhPB");

var $9BrHy = parcelRequire("9BrHy");

var $8kVg1 = parcelRequire("8kVg1");
const $abbdb580491d9d09$export$92d758d83665314b = ({ attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: (0, $6MtPV.createAttributes)(attributes)
    });
const $abbdb580491d9d09$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $dd7Uh.fireOperationalFailedEvent)({
        eventId: eventId,
        attributes: attributes
    });
    return null;
};
const $abbdb580491d9d09$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
    const hasForgeAccess = (0, $eOGyv.useHasForgeAccess)();
    const analyticsAttributes = (0, $4R6GH.fg)('custom_fields_attempt_event_optimization') ? (0, $5uXOq.useMemo)(()=>(0, $6MtPV.createAttributes)({
            ...attributes,
            hasForgeAccess: hasForgeAccess
        }), [
        attributes,
        hasForgeAccess
    ]) : (0, $6MtPV.createAttributes)({
        ...attributes,
        hasForgeAccess: hasForgeAccess
    });
    const fireEvent = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, (0, $9BrHy.getEventActionName)(eventId, action), analyticsAttributes);
    }, [
        eventId,
        action,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: fireEvent
    });
};
const $abbdb580491d9d09$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: `${(0, $hBuqR.PACKAGE_NAME_GASV3)}.${eventId}`
    }, children);
const $abbdb580491d9d09$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
    const fallback = (0, $5uXOq.useMemo)(()=>errorFallback || 'unmount', [
        errorFallback
    ]);
    const getAttributes = (0, $5uXOq.useCallback)((error)=>(0, $6MtPV.createAttributes)({
            ...attributes,
            error: error
        }), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: eventId,
        packageName: (0, $hBuqR.PACKAGE_NAME_GASV3),
        teamName: "smite",
        fallback: fallback,
        attributes: getAttributes,
        onError: onError,
        resetCaughtError: resetCaughtError
    }, children);
};
const $abbdb580491d9d09$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
    const eventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    }) : (0, $9BrHy.getEventIdOld)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    });
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>(0, $6MtPV.createAttributes)(attributes), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
        eventId: eventId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$ac7e7464cefab440, {
        eventId: eventId,
        attributes: analyticsAttributes,
        errorFallback: errorFallback,
        resetCaughtError: resetCaughtError
    }, shouldFireInitializedEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$4c46624a93517c10, {
        eventId: eventId,
        action: "initialized",
        attributes: analyticsAttributes
    }), children));
};
function $abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
    if ((extensionModule === (0, $k2DRb.CUSTOM_FIELD_MODULE) || extensionModule === (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
    if (extensionModule === (0, $k2DRb.ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
    return /* eslint-disable @typescript-eslint/consistent-type-assertions */ [
        (0, $k2DRb.GLOBAL_PAGE_MODULE),
        (0, $k2DRb.ISSUE_ACTION_MODULE),
        (0, $k2DRb.ISSUE_ACTIVITY_MODULE),
        (0, $k2DRb.ISSUE_CONTEXT_MODULE),
        (0, $k2DRb.ISSUE_GLANCE_MODULE),
        (0, $k2DRb.ISSUE_NAVIGATOR_ACTION_MODULE),
        (0, $k2DRb.ISSUE_PANEL_MODULE),
        (0, $k2DRb.CUSTOM_FIELD_MODULE),
        (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE),
        (0, $k2DRb.PROJECT_PAGE_MODULE),
        (0, $k2DRb.ADMIN_PAGE_MODULE),
        (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE),
        (0, $k2DRb.BACKLOG_ACTION_MODULE),
        (0, $k2DRb.BOARD_ACTION_MODULE),
        (0, $k2DRb.SPRINT_ACTION_MODULE),
        (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
    ].includes(extensionModule);
}
const $abbdb580491d9d09$export$14e56d7f5d3f917c = (Component)=>(props)=>{
        const startTime = (0, $5uXOq.useRef)(performance.now());
        const isCustomUI = (0, $3mOWa.isCustomUIExtension)(props.extension, props.entryPoint);
        const [isExtensionRendered, setExtensionRendered] = (0, $5uXOq.useState)(false);
        const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, localId: localId = '', onInitialRender: onInitialRender, onLoad: onLoad, extension: extension } = props;
        const extensionId = props.extension?.id;
        const eventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: module,
            entryPoint: entryPoint
        }) : (0, $9BrHy.getEventIdOld)({
            module: module,
            entryPoint: entryPoint
        });
        const browserMetricsEventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getBrowserMetricsEventId)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $3mOWa.getForgeUIType)(extension, entryPoint)
        }) : (0, $9BrHy.getBrowserMetricsEventIdOld)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $3mOWa.getForgeUIType)(extension, entryPoint)
        });
        const attributes = (0, $5uXOq.useMemo)(()=>({
                ...analyticsAttributes,
                ...(0, $2RhPB.getAnalyticsAttributesFromExtension)(extension, entryPoint)
            }), // because extension is an object but we only want extension.id to trigger re-render
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            analyticsAttributes,
            entryPoint,
            extension.id,
            isCustomUI
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!$abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId) (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).start({
                startTime: startTime.current
            });
        }, // We want to run this code only once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);
        const onError = (0, $5uXOq.useCallback)(()=>{
            extensionId && (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).cancel();
        }, [
            extensionId
        ]);
        const onInitialRenderUiKitWithMetrics = (0, $5uXOq.useCallback)((payload)=>{
            onInitialRender && onInitialRender(payload);
            if (payload?.error == null) {
                const stopTimeDeduction = payload?.appTime || 0;
                setExtensionRendered(true);
                extensionId && (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).stop({
                    stopTime: performance.now() - stopTimeDeduction,
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
            } else {
                onError();
                (0, $dd7Uh.fireOperationalFailedEvent)({
                    eventId: eventId,
                    attributes: {
                        error: new Error(payload.error),
                        ...attributes
                    }
                });
            }
        }, [
            onInitialRender,
            extensionId,
            browserMetricsEventId,
            onError,
            eventId,
            attributes
        ]);
        const onLoadCustomUiWithMetrics = (0, $5uXOq.useCallback)(()=>{
            onLoad && onLoad();
            setExtensionRendered(true);
            extensionId && (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).stop({
                stopTime: performance.now(),
                customData: {
                    eventId: browserMetricsEventId
                }
            });
        // SMT-1418
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            analyticsAttributes,
            extensionId,
            localId,
            onLoad
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
            eventId: eventId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            ...isCustomUI ? {
                onLoad: onLoadCustomUiWithMetrics
            } : {
                onInitialRender: onInitialRenderUiKitWithMetrics
            }
        }), isExtensionRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$92d758d83665314b, {
            attributes: attributes
        }));
    };

});
parcelRegister("3mOWa", function(module, exports) {

$parcel$export(module.exports, "getForgeUIType", () => $e79bbc527e600bd1$export$aed4d8a86badbf61);
$parcel$export(module.exports, "isCustomUIExtension", () => $e79bbc527e600bd1$export$edb00cfe4962b026);
$parcel$export(module.exports, "isNativeUiExtension", () => $e79bbc527e600bd1$export$2ecba06e617fea0a);
$parcel$export(module.exports, "overrideExtension", () => $e79bbc527e600bd1$export$42b85bc9b386c977);

var $gccSB = parcelRequire("gccSB");
const $e79bbc527e600bd1$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
    const { render: render, resource: resource } = extension.properties;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
        extension.properties[entryPoint];
        if (entryPointResource == null) return 'ui-kit';
        if (entryPointRender === 'native') return 'native-ui';
        return 'custom-ui';
    }
    if (resource == null) return 'ui-kit';
    if (render === 'native') return 'native-ui';
    return 'custom-ui';
};
const $e79bbc527e600bd1$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
const $e79bbc527e600bd1$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
const $e79bbc527e600bd1$export$42b85bc9b386c977 = (extension, propsToOverride)=>{
    if (extension == null) return extension;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(propsToOverride)) return extension;
    const { resource: resource } = propsToOverride;
    // We must also spread `extension.properties` because JS doesn't deep-copy objects.
    // Only spreading `extension` will result in `resource` on the original `extension`
    // object being modified.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const extensionCopy = {
        ...extension,
        properties: {
            ...extension.properties
        }
    }; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (resource != null) extensionCopy.properties.resource = resource;
    return extensionCopy;
};

});

parcelRegister("eOGyv", function(module, exports) {

$parcel$export(module.exports, "useHasForgeAccess", () => $5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2);

var $cZpsT = parcelRequire("cZpsT");
const $5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2 = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return !isAnonymous;
};

});

parcelRegister("5oFIy", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $3ea3e1dfbcd8cda6$export$2ccf161b817b43b);

var $5uXOq = parcelRequire("5uXOq");

var $3TR0I = parcelRequire("3TR0I");


var $8zOmE = parcelRequire("8zOmE");
// eslint-disable-next-line jira/react/no-class-components
class $3ea3e1dfbcd8cda6$var$FireComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $8zOmE.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $3ea3e1dfbcd8cda6$export$64eb47d7b94ba089 = (0, $3TR0I.default)()($3ea3e1dfbcd8cda6$var$FireComponent);
const $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e)
    });
const $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$947dac6c72b26f81)
    });
const $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$12346a674644c156)
    });
const $3ea3e1dfbcd8cda6$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});

parcelRegister("isuse", function(module, exports) {

$parcel$export(module.exports, "MountEvent", () => $1df0619a43ad69d9$export$2c6963927dbc68f1);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $3TR0I = parcelRequire("3TR0I");
// eslint-disable-next-line jira/react/no-class-components
class $1df0619a43ad69d9$var$MountEventComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $1df0619a43ad69d9$export$2c6963927dbc68f1 = (0, $3TR0I.default)()($1df0619a43ad69d9$var$MountEventComponent);

});

parcelRegister("dd7Uh", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $7d829a81d29f9e72$export$add44f896fb31ba3);

var $hBuqR = parcelRequire("hBuqR");

var $8uOa6 = parcelRequire("8uOa6");
const $7d829a81d29f9e72$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).FAILED, {
        id: eventId,
        attributes: attributes
    });
};

});

parcelRegister("2RhPB", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAttributesFromExtension", () => $3fba0b567cec1fe0$export$5d3b06ab08af139e);

var $3mOWa = parcelRequire("3mOWa");

var $e0AC8 = parcelRequire("e0AC8");
const $3fba0b567cec1fe0$export$5d3b06ab08af139e = (extension, entryPoint)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return {
        appId: appId,
        envId: envId,
        forgeType: (0, $3mOWa.getForgeUIType)(extension, entryPoint),
        envType: extension?.environmentType
    };
};

});

parcelRegister("9BrHy", function(module, exports) {

$parcel$export(module.exports, "getEventId", () => $10bc2a9e37d5a5bb$export$5639f6a927500d9);
$parcel$export(module.exports, "getEventIdOld", () => $10bc2a9e37d5a5bb$export$b2919e256f1e5dfc);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $10bc2a9e37d5a5bb$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getBrowserMetricsEventIdOld", () => $10bc2a9e37d5a5bb$export$66db5d4145894f38);
$parcel$export(module.exports, "getEventActionName", () => $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1);

var $k2DRb = parcelRequire("k2DRb");

var $6yg2S = parcelRequire("6yg2S");

var $hBuqR = parcelRequire("hBuqR");
const $10bc2a9e37d5a5bb$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $10bc2a9e37d5a5bb$var$prepareModuleMode = (entryPoint)=>`${$10bc2a9e37d5a5bb$var$capitalizeFirstLetter(entryPoint)}`;
const $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $10bc2a9e37d5a5bb$var$prepareModuleName = (moduleName)=>(0, $k2DRb.SUPPORTED_MODULES).includes(moduleName) ? $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $10bc2a9e37d5a5bb$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${eventNamePostfix}`);
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $10bc2a9e37d5a5bb$export$b2919e256f1e5dfc = ({ module: module, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $10bc2a9e37d5a5bb$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}-${forgeUiType}`);
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $10bc2a9e37d5a5bb$export$66db5d4145894f38 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $hBuqR.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});


parcelRegister("3wOYX", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $5b5e8901ec23bf19$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $5b5e8901ec23bf19$export$e1a79e3d472c925a);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");
const $5b5e8901ec23bf19$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.GLOBAL_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $5b5e8901ec23bf19$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.GLOBAL_PAGE_MODULE),
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("i2fHy", function(module, exports) {

$parcel$export(module.exports, "Nav4ConnectMenuItem", () => $ee90bbc4e1163598$export$d311b4cb0fdc0b92);

var $4Oh0F = parcelRequire("4Oh0F");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jjUR3 = parcelRequire("jjUR3");

var $hrlU6 = parcelRequire("hrlU6");

var $46ae2 = parcelRequire("46ae2");

var $fmg3f = parcelRequire("fmg3f");
function $ee90bbc4e1163598$export$d311b4cb0fdc0b92({ queryRef: queryRef }) {
    const data = (0, $8Uumt.useFragment)((0, $4Oh0F.default), queryRef);
    const { addNew: addNew } = (0, $jjUR3.useConnectItemClickHistory)();
    const onClick = (0, $5uXOq.useCallback)((e, target, styleClass, url)=>{
        if (url == null) return;
        addNew(url);
        if (target == null) return;
        (0, $hrlU6.withConnectHost)((connectHost)=>{
            connectHost.triggerWebItem(target, styleClass, url);
        });
        if ((0, $hrlU6.isConnectDialogWebItem)(styleClass)) e.preventDefault();
    }, [
        addNew
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $46ae2.Nav4AppMenuItem), {
        queryRef: data,
        onData: $ee90bbc4e1163598$var$transformData,
        onClick: onClick
    });
}
/**
 * Data transformer for Connect.
 * We are going to convert multi-page Connect apps into single-page ones in case their subpages don't contain a url that matches the root one.
 * For more details, see {@link canHaveSubpages}.
 */ function $ee90bbc4e1163598$var$transformData(data) {
    return (0, $fmg3f.canHaveSubpages)(data) ? data : {
        ...data,
        sections: null
    };
}

});
parcelRegister("4Oh0F", function(module, exports) {

$parcel$export(module.exports, "default", () => $6486cfe515f60293$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f245c96814deb8f505d2b497ec43b86d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6486cfe515f60293$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4ConnectMenuItem",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4AppMenuItem"
        }
    ],
    "type": "JiraAppNavigationItem"
};
$6486cfe515f60293$var$node.hash = "76baf08d707245f4a5aadd384fd44056";
var $6486cfe515f60293$export$2e2bcd8739ae039 = $6486cfe515f60293$var$node;

});

parcelRegister("46ae2", function(module, exports) {

$parcel$export(module.exports, "Nav4AppMenuItem", () => $0602058127748c94$export$549160040f86c542);

var $jX06n = parcelRequire("jX06n");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");




var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $lhMtU = parcelRequire("lhMtU");

var $c16H2 = parcelRequire("c16H2");

var $5FnJJ = parcelRequire("5FnJJ");

var $dQbFB = parcelRequire("dQbFB");

var $fLtNy = parcelRequire("fLtNy");

var $5QCWL = parcelRequire("5QCWL");

var $9Ft6m = parcelRequire("9Ft6m");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $gkEOT = parcelRequire("gkEOT");
var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");
var $4IIGx = parcelRequire("4IIGx");
var $4vWwj = parcelRequire("4vWwj");
var $ch7sx = parcelRequire("ch7sx");
function $0602058127748c94$export$549160040f86c542({ queryRef: queryRef, onData: onData, onClick: onClick }) {
    const rawData = (0, $8Uumt.useFragment)((0, $jX06n.default), queryRef);
    const data = (0, $5uXOq.useMemo)(()=>onData ? onData($0602058127748c94$var$normalizeData(rawData)) : $0602058127748c94$var$normalizeData(rawData), [
        onData,
        rawData
    ]);
    const icon = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5QCWL.AppIcon), {
            iconUrl: data.iconUrl || ''
        }), [
        data.iconUrl
    ]);
    const withSeparators = (0, $5uXOq.useMemo)(()=>$0602058127748c94$var$shouldUseSeparators(data), [
        data
    ]);
    const envLozenge = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ft6m.EnvLozenge), {
            label: data.envLabel || ''
        }), [
        data.envLabel
    ]);
    const actionsOnHover = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fLtNy.AppActions), {
            settingsUrl: data.settingsUrl || '',
            appId: data.appId || ''
        }), [
        data.settingsUrl,
        data.appId
    ]);
    const expandable = (0, $5uXOq.useMemo)(()=>{
        if ((data.sections || []).length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0602058127748c94$var$MaybeExpandable, {
            actionsOnHover: actionsOnHover,
            appId: data.appId || '',
            envLozenge: envLozenge,
            icon: icon,
            label: data.label || 'Unknown app',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            menuIds: $0602058127748c94$var$toExpandableMenuId(data.sections),
            itemId: data.appId || '',
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf)
        }, (data.sections || []).map((section, sectionIndex)=>(section?.links || []).length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4vWwj.MenuListItem), {
                key: `${sectionIndex}-${section?.label}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ch7sx.MenuSection), null, withSeparators && sectionIndex > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gkEOT.Divider), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0602058127748c94$var$MaybeExpandable, {
                appId: data.appId || '',
                label: section?.label || '',
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                menuIds: $0602058127748c94$var$toExpandableMenuId([
                    {
                        links: section?.links
                    }
                ]),
                itemId: `section/${sectionIndex}`,
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1)
            }, (section?.links || []).map((link, linkIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0602058127748c94$var$SimpleItem, {
                    appId: data.appId || '',
                    key: link?.url || '',
                    label: link?.label || '',
                    onClick: onClick,
                    styleClass: link?.styleClass || '',
                    url: link?.url == null ? null : $0602058127748c94$var$removeTrailingSlash(link?.url),
                    itemId: `section/${sectionIndex}/link/${linkIndex}`,
                    level: section?.label ? (0, $951a0ed422513987$export$f9db6a58b4aabd18) : (0, $951a0ed422513987$export$fe3b012b0224e4e1)
                })))))) : null));
    }, [
        data.sections,
        data.label,
        data.appId,
        icon,
        envLozenge,
        actionsOnHover,
        withSeparators,
        onClick
    ]);
    if (expandable) return expandable;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0602058127748c94$var$SimpleItem, {
        actionsOnHover: actionsOnHover,
        appId: data.appId || '',
        envLozenge: envLozenge,
        icon: icon,
        label: data.label || 'Unknown app',
        onClick: onClick,
        styleClass: data.styleClass || '',
        url: data.url == null ? null : $0602058127748c94$var$removeTrailingSlash(data.url || ''),
        itemId: data.appId || '',
        level: (0, $951a0ed422513987$export$265c523d1a8f25cf)
    });
}
function $0602058127748c94$var$SimpleItem({ actionsOnHover: actionsOnHover, appId: appId, envLozenge: envLozenge, icon: icon, label: label, onClick: onClick, styleClass: styleClass, url: url, itemId: itemId, level: level }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const anchorElement = (0, $5uXOq.useRef)(null);
    const onItemClick = (0, $5uXOq.useCallback)((e)=>{
        $0602058127748c94$var$fireAppClickEvent({
            event: createAnalyticsEvent({}),
            itemId: itemId,
            appId: appId,
            level: level
        });
        onClick?.(e, anchorElement.current, styleClass || '', url);
    }, [
        url,
        onClick,
        itemId,
        appId,
        level,
        styleClass,
        createAnalyticsEvent
    ]);
    // If a Connect app does NOT have a URL, we should use a MenuButtonItem instead.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        href: $0602058127748c94$var$removeTrailingSlash(url ?? ''),
        elemBefore: icon,
        elemAfter: envLozenge,
        actionsOnHover: actionsOnHover,
        menuId: $0602058127748c94$export$171d73a56172dba4(url ?? ''),
        ref: anchorElement,
        onClick: onItemClick
    }, label);
}
function $0602058127748c94$var$MaybeExpandable(params) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { actionsOnHover: actionsOnHover, children: children, envLozenge: envLozenge, icon: icon, label: label, menuIds: menuIds, itemId: itemId, appId: appId, level: level } = params;
    const menuId = (0, $lhMtU.toMenuIdFromMenuIdList)(menuIds);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        $0602058127748c94$var$fireAppClickEvent({
            event: createAnalyticsEvent({}),
            itemId: itemId,
            appId: appId,
            level: level,
            isExpandable: true
        });
    }, [
        createAnalyticsEvent,
        itemId,
        appId,
        level
    ]);
    return label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        menuId: menuId,
        isExpanded: level !== (0, $951a0ed422513987$export$265c523d1a8f25cf),
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) onClick();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        elemBefore: icon,
        elemAfter: envLozenge,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
}
function $0602058127748c94$var$fireAppClickEvent(params) {
    const { event: event, itemId: itemId, appId: appId, level: level, isExpandable: isExpandable } = params;
    (0, $8zOmE.fireUIAnalytics)(event, {
        action: 'clicked',
        actionSubject: 'navigationItem',
        actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_APPS],
        attributes: {
            level: level,
            componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
            itemId: itemId,
            isExpandable: isExpandable,
            section: 'yourApps',
            ...level === (0, $951a0ed422513987$export$265c523d1a8f25cf) ? {
                itemType: (0, $632bd8725b437a12$export$c3d83ca6855fa0d0)
            } : {
                itemType: (0, $632bd8725b437a12$export$509e83d3c8d91279),
                parentItemId: appId,
                parentItemType: (0, $632bd8725b437a12$export$c3d83ca6855fa0d0)
            }
        }
    });
}
function $0602058127748c94$var$shouldUseSeparators(data) {
    for (const section of data.sections || []){
        if (section?.label) return false;
    }
    return true;
}
/**
 * Common data transformer.
 * Filters out sections with empty links.
 */ function $0602058127748c94$var$normalizeData(data) {
    return {
        ...data,
        sections: (data.sections || []).filter((section)=>(section?.links || []).length > 0)
    };
}
const $0602058127748c94$var$removeTrailingSlash = (url = '')=>url.replace(/\/$/, '');
const $0602058127748c94$var$removeQueryParams = (url)=>url.split('?')[0];
const $0602058127748c94$var$removeHash = (url)=>url.split('#')[0];
const $0602058127748c94$export$171d73a56172dba4 = (path_ = '')=>{
    let path = path_;
    // This is the format we ask Connect vendors to use: /plugins/servlet/ac/:addonKey/:moduleKey
    // However, there are Connect apps that do not follow our recommendations and add extra path segments.
    // As result they might look like this: /plugins/servlet/ac/:addonKey/:moduleKey/:extraPathSegment
    // Because of that we have issues with menu ids matching since the path created out of current route differs from the actual url.
    // To fix this we remove those extra path segments from the url.
    if (path.startsWith('/plugins/servlet/ac/')) path = path.split('/').slice(0, 6).join('/');
    return (0, $jhS4y.ENTITY_ID).APP($0602058127748c94$var$removeTrailingSlash($0602058127748c94$var$removeQueryParams($0602058127748c94$var$removeHash(path))));
};
// Because of the apps nature, the parent url may differ from the child url.
// And if we want to make sure the expand state is properly calculated, we must pass down children menu ids.
const $0602058127748c94$var$toExpandableMenuId = (sections)=>(sections || []).flatMap(({ links: links })=>(links || []).map((link)=>$0602058127748c94$export$171d73a56172dba4(link.url)));

});
parcelRegister("jX06n", function(module, exports) {

$parcel$export(module.exports, "default", () => $af6546e449d47625$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f1dd304f2b2075cf9083f0c067a308e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $af6546e449d47625$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "label"
    }, v1 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4AppMenuItem",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "appId"
            },
            {
                "kind": "ScalarField",
                "name": "envLabel"
            },
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "concreteType": "JiraAppSection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "concreteType": "JiraAppNavigationItemNestedLink",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            v2 /*: any*/ ,
                            v1 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "settingsUrl"
            },
            v2 /*: any*/ 
        ],
        "type": "JiraAppNavigationItem"
    };
}();
$af6546e449d47625$var$node.hash = "fe622bd16e14b11ec5e3f21d8553bac3";
var $af6546e449d47625$export$2e2bcd8739ae039 = $af6546e449d47625$var$node;

});

const $632bd8725b437a12$export$9b8283d5878d2491 = 'board';
const $632bd8725b437a12$export$c3d83ca6855fa0d0 = 'app';
const $632bd8725b437a12$export$c1c49903035a02df = 'filter';
const $632bd8725b437a12$export$6deee0e4f2fb784e = 'defaultFilter';
const $632bd8725b437a12$export$4695c1a423ffe431 = 'dashboard';
const $632bd8725b437a12$export$5828682c822c26e7 = 'queue';
const $632bd8725b437a12$export$fe791c4fa892e400 = 'project';
const $632bd8725b437a12$export$c303e491e026ebc6 = 'plan';
const $632bd8725b437a12$export$509e83d3c8d91279 = 'appSubpage';
const $632bd8725b437a12$export$a2e7d1d0a3d169f4 = 'asset';
const $632bd8725b437a12$export$b56168d831461ce2 = 'operation';
const $632bd8725b437a12$export$499a3e77858b7713 = 'translationGroup';
const $632bd8725b437a12$export$bb8a37ab8d9ba82b = 'roadmap';
const $632bd8725b437a12$export$9a778ca616c24a93 = 'projectRecommendation';
const $632bd8725b437a12$export$9cbb0f231a0ab7ea = 'overview';
const $632bd8725b437a12$export$119dad133da0b4a = 'changeView';

parcelRegister("fLtNy", function(module, exports) {

$parcel$export(module.exports, "AppActions", () => $c30e381fa79c5849$export$6b031ef628e5f9c2);

var $5uXOq = parcelRequire("5uXOq");

var $51oeD = parcelRequire("51oeD");

var $44qT7 = parcelRequire("44qT7");
var $70rf1 = parcelRequire("70rf1");

var $koVbs = parcelRequire("koVbs");




var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $aCS3f = parcelRequire("aCS3f");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $cSaAc = parcelRequire("cSaAc");
function $c30e381fa79c5849$export$6b031ef628e5f9c2({ settingsUrl: settingsUrl, appId: appId, onClose: onClose }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireOpenEvent = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_APPS],
            attributes: {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$9bd6c21d500ae611),
                itemId: 'meatballDropdown',
                section: 'yourApps'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireClickEvent = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_APPS],
            attributes: {
                level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                componentType: (0, $1e554a683893bd46$export$5374c2c2d3ece55e),
                parentItemId: appId,
                parentItemType: (0, $632bd8725b437a12$export$c3d83ca6855fa0d0),
                itemId: 'appSettings',
                section: 'yourApps'
            }
        });
    }, [
        createAnalyticsEvent,
        appId
    ]);
    if (!settingsUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        MenuItems: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44qT7.default), {
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($51oeD))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                }),
                href: settingsUrl,
                target: "_blank",
                onClick: (...args)=>{
                    fireClickEvent();
                    props.onClose?.(...args);
                }
            }, formatMessage((0, $cSaAc.default).appSettings))),
        onOpen: fireOpenEvent,
        onClose: onClose
    });
}

});
parcelRegister("cSaAc", function(module, exports) {

$parcel$export(module.exports, "default", () => $9feae85879e795be$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9feae85879e795be$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    appSettings: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.app-actions.app-settings",
        "defaultMessage": "App settings"
    }
});

});


parcelRegister("5QCWL", function(module, exports) {

$parcel$export(module.exports, "AppIcon", () => $1ef09001d2a6006a$export$5153830bdfb71453);

var $5uXOq = parcelRequire("5uXOq");

var $IS9QB = parcelRequire("IS9QB");

var $k4j3t = parcelRequire("k4j3t");
function $1ef09001d2a6006a$export$5153830bdfb71453({ iconUrl: iconUrl }) {
    return iconUrl.trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k4j3t.IconCustom), {
        url: iconUrl
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($IS9QB))), {
        label: "",
        color: "var(--ds-icon, #44546F)"
    });
}

});
parcelRegister("k4j3t", function(module, exports) {

$parcel$export(module.exports, "IconCustom", () => $0744fb0e35ced980$export$5b6504ec6adf0047);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $ljMUk = parcelRequire("ljMUk");
// got this value through trial and error
// in the long term, we should change the color of icon generated for the conntect apps
const $0744fb0e35ced980$var$colorMatrixValues = '0.08, 0, 0, 0, 0, 0, 0.1, 0, 0, 0, 0, 0,0.2, 0, 0, 0, 0, 0, 1, 0';
const $0744fb0e35ced980$export$5b6504ec6adf0047 = ({ url: url, shouldChangeFillColor: shouldChangeFillColor = true, ariaLabelledBy: ariaLabelledBy })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $0744fb0e35ced980$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        viewBox: "0 0 20 20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("filter", {
        id: "changeFillColor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feColorMatrix", {
        type: "matrix",
        values: $0744fb0e35ced980$var$colorMatrixValues
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("image", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xlinkHref: url,
        width: "20",
        height: "20",
        x: "0",
        y: "0",
        filter: shouldChangeFillColor && (0, $ljMUk.checkForSvg)(url) ? 'url(#changeFillColor)' : '',
        "aria-labelledby": ariaLabelledBy
    })));
};
const $0744fb0e35ced980$var$styles = (0, $2s57o.xcss)({
    display: 'inline-block',
    margin: 'space.025',
    height: "var(--ds-space-250, 20px)",
    width: "var(--ds-space-250, 20px)"
});

});
parcelRegister("ljMUk", function(module, exports) {

$parcel$export(module.exports, "checkForSvg", () => $c203648fb17df2d9$export$9a369805b0fabb72);
const $c203648fb17df2d9$export$9a369805b0fabb72 = (url)=>{
    const fileType = url.split(/#|\?/)[0].split('.').pop();
    // falsey check is for Ts
    return fileType ? fileType.trim() === 'svg' : false;
};

});



parcelRegister("9Ft6m", function(module, exports) {

$parcel$export(module.exports, "EnvLozenge", () => $5f161ee51f6727e1$export$61c90f482f9775c6);

var $5uXOq = parcelRequire("5uXOq");

var $eOat1 = parcelRequire("eOat1");
function $5f161ee51f6727e1$export$61c90f482f9775c6({ label: label }) {
    return label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: label === 'Dev' ? 'default' : 'moved'
    }, label) : null;
}

});

parcelRegister("gkEOT", function(module, exports) {

$parcel$export(module.exports, "Divider", () => $237844e903ed3b62$export$2e0a83ec2e27ecbb);
/* divider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $237844e903ed3b62$var$styles = null;
const $237844e903ed3b62$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("hr", {
        /**
 * The existing usage of these dividers is presentational,
 * so we are removing the separator semantics by default.
 *
 * In the future we may consider allowing opt-in separator semantics,
 * but it probably isn't necessary.
 */ role: "none",
        className: (0, $bwpsq.default)([
            "_h7alglyw _179rglyw _mqm2zgxb _1bsb1osq"
        ])
    });

});

parcelRegister("ch7sx", function(module, exports) {

$parcel$export(module.exports, "MenuSection", () => $9f732a11797e01da$export$4b1545b4f2016d26);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jJsBW = parcelRequire("jJsBW");

var $4vWwj = parcelRequire("4vWwj");

var $hhsbw = parcelRequire("hhsbw");
const $9f732a11797e01da$export$4b1545b4f2016d26 = ({ children: children, isMenuListItem: isMenuListItem = false })=>{
    const id = (0, $jJsBW.useId)();
    const Wrapper = isMenuListItem ? (0, $4vWwj.MenuListItem) : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hhsbw.MenuSectionContext).Provider, {
        value: id,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                role: "group",
                "aria-labelledby": `${id}-heading`,
                children: children
            })
        })
    });
};

});
parcelRegister("hhsbw", function(module, exports) {

$parcel$export(module.exports, "MenuSectionContext", () => $ca9fa6176761bfb7$export$728ac99b9c7eea8a);
$parcel$export(module.exports, "useMenuSectionContext", () => $ca9fa6176761bfb7$export$8100cda602411810);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");
const $ca9fa6176761bfb7$export$728ac99b9c7eea8a = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $ca9fa6176761bfb7$export$8100cda602411810 = ()=>{
    const context = (0, $5uXOq.useContext)($ca9fa6176761bfb7$export$728ac99b9c7eea8a);
    (0, $3joPi.default)(context, 'useMenuSectionContext must be used within a MenuSection');
    return context;
};

});



parcelRegister("fmg3f", function(module, exports) {

$parcel$export(module.exports, "canHaveSubpages", () => $9085d7a7b2e046cd$export$352a285d5cb56873);
/**
 * The magic is copied from jira/src/packages/navigation-apps/sidebar/connect/src/common/utils/find-item-stack/index.tsx
 * No clue what that `s` query param stands for, just keeping the link comparison logic 1:1 to avoid regressions.
 */ 
var $ajpes = parcelRequire("ajpes");
// JSPA-1062 remove qs items that might not always be there
const $9085d7a7b2e046cd$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $9085d7a7b2e046cd$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $9085d7a7b2e046cd$var$parseUrl = (url = '')=>{
    const [pathname, qs = ''] = url.split('#')[0].split('?');
    return {
        pathname: pathname,
        query: $9085d7a7b2e046cd$var$splitRelevantQs(qs)
    };
};
function $9085d7a7b2e046cd$export$352a285d5cb56873(data) {
    const sections = data.sections || [];
    const { pathname: rootPagePathname, query: rootPageQuery } = $9085d7a7b2e046cd$var$parseUrl(data.url || '');
    for (const section of sections){
        if ((section?.links || []).some((link)=>{
            const { pathname: pathname, query: query } = $9085d7a7b2e046cd$var$parseUrl(link?.url || '');
            return rootPagePathname === pathname && $9085d7a7b2e046cd$var$isSameQuery(rootPageQuery, query);
        })) return true;
    }
    return false;
}

});


parcelRegister("8MAOw", function(module, exports) {

$parcel$export(module.exports, "Nav4ForgeMenuItem", () => $a309e8f531726635$export$9d5c2149f38ae387);

var $4QYEU = parcelRequire("4QYEU");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $8kVg1 = parcelRequire("8kVg1");

var $46ae2 = parcelRequire("46ae2");

var $4R6GH = parcelRequire("4R6GH");
function $a309e8f531726635$export$9d5c2149f38ae387({ queryRef: queryRef }) {
    const data = (0, $8Uumt.useFragment)((0, $4QYEU.default), queryRef);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        (0, $4R6GH.fg)('arken-1562_full_page_performance_metric_addition') ? undefined : (0, $8kVg1.forgeModulesConcurrentLoadTime)(data.appId || '').start({
            startTime: performance.now()
        });
    }, [
        data.appId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $46ae2.Nav4AppMenuItem), {
        queryRef: data,
        onClick: onClick
    });
}

});
parcelRegister("4QYEU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c19f8830116fdeb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f3ebb1500de8062c306351fd3ba143ed>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7c19f8830116fdeb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4ForgeMenuItem",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "appId"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4AppMenuItem"
        }
    ],
    "type": "JiraAppNavigationItem"
};
$7c19f8830116fdeb$var$node.hash = "44fc7efec94eb8a16f192074436bd021";
var $7c19f8830116fdeb$export$2e2bcd8739ae039 = $7c19f8830116fdeb$var$node;

});


parcelRegister("l3A2e", function(module, exports) {

$parcel$export(module.exports, "MenuSectionHeading", () => $6b702268e1e4dda3$export$5d3acdbf9237a364);
/* menu-section-heading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hhsbw = parcelRequire("hhsbw");
const $6b702268e1e4dda3$var$styles = {
    root: "_11c81vhk _1rjcu2gc _syaz131l _bozg12x7"
};
const $6b702268e1e4dda3$export$5d3acdbf9237a364 = ({ children: children })=>{
    const id = (0, $hhsbw.useMenuSectionContext)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h2", {
        id: `${id}-heading`,
        className: (0, $bwpsq.default)([
            $6b702268e1e4dda3$var$styles.root
        ]),
        children: children
    });
};

});

parcelRegister("j02Uq", function(module, exports) {

$parcel$export(module.exports, "AsyncDiscoverSection", () => $c252b5269b2661b3$export$45fe6164578a6f29);

var $b7Svb = parcelRequire("b7Svb");

const $c252b5269b2661b3$export$45fe6164578a6f29 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("jjf3z")).then((module)=>module.DiscoverSection), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/marketplace-recommendations/src/ui/discover-section/DiscoverSection.tsx"
});

});
parcelRegister("jjf3z", function(module, exports) {

let $e0eb7898b467e53c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e0eb7898b467e53c$var$load("bL0B7").then(()=>parcelRequire('3xy6E'));

});


parcelRegister("hDULT", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfa76cb9830908a5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cfa76cb9830908a5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    yourApps: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-apps.common.content.your-apps",
        "defaultMessage": "Your apps"
    }
});

});



parcelRegister("nX8wH", function(module, exports) {

$parcel$export(module.exports, "useIsGlobalConnectAppRoute", () => $cf4b597ee7e1007d$export$32897ea1251cd6aa);

var $5uXOq = parcelRequire("5uXOq");

var $aZsz6 = parcelRequire("aZsz6");

var $4OCke = parcelRequire("4OCke");

var $3TY9o = parcelRequire("3TY9o");

var $5LMr7 = parcelRequire("5LMr7");

var $fmg3f = parcelRequire("fmg3f");
const $cf4b597ee7e1007d$export$32897ea1251cd6aa = ({ data: data })=>{
    const location = (0, $3TY9o.useLocation)();
    const query = (0, $5LMr7.useQuery)();
    const locations = (0, $5uXOq.useMemo)(()=>(data?.globalAppNavigationItems?.edges || []).filter((edge)=>edge?.node?.appType === 'CONNECT').flatMap((edge)=>(edge?.node && (0, $fmg3f.canHaveSubpages)(edge?.node) && edge?.node?.sections || [
                {
                    links: [
                        {
                            url: edge?.node?.url
                        }
                    ]
                }
            ]).flatMap((section)=>(section?.links || []).map((link)=>(0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(link?.url || '/', true)))), [
        data
    ]);
    return (0, $5uXOq.useMemo)(()=>{
        const matcher = (0, $4OCke.matchUrlExact)();
        const currentLocation = {
            ...location,
            query: query
        };
        // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
        return locations.some((loc)=>matcher(currentLocation, loc));
    }, [
        locations,
        location,
        query
    ]);
};

});
parcelRegister("3TY9o", function(module, exports) {

$parcel$export(module.exports, "useLocation", () => $98b56a9c283f50ed$export$45d76561a5302f2b);

var $lODMY = parcelRequire("lODMY");
const $98b56a9c283f50ed$export$45d76561a5302f2b = (0, $lODMY.createRouterSelector)((state)=>state.location);

});

parcelRegister("5LMr7", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $29396ff44ea7e839$export$dd0a697e1782aedd);

var $lODMY = parcelRequire("lODMY");
const $29396ff44ea7e839$export$dd0a697e1782aedd = (0, $lODMY.createRouterSelector)((state)=>state.query);

});


parcelRegister("bhapp", function(module, exports) {

$parcel$export(module.exports, "Nav4AppsSpotlightWrapper", () => $b4dbfb30b95b8dd8$export$d148eb6657a374a);

var $5uXOq = parcelRequire("5uXOq");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $a4k7n = parcelRequire("a4k7n");

var $heI7y = parcelRequire("heI7y");

var $1Qlos = parcelRequire("1Qlos");
function $b4dbfb30b95b8dd8$export$d148eb6657a374a({ children: children }) {
    const [{ hasOpened: shouldShowNudge }] = (0, $heI7y.useHasOpened)();
    const [isUnloaded] = (0, $cE2Qr.useIsDismissed)();
    const expandSideNav = (0, $1Qlos.useExpandSideNav)();
    const [openTask] = (0, $cE2Qr.useOpenTask)();
    const [, { setHasNudgeActive: setHasNudgeActive }] = (0, $cE2Qr.useQuickstartActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isUnloaded && openTask === (0, $8Bc5A.CAPTURE_INTEGRATIONS_TASK) && shouldShowNudge) {
            expandSideNav();
            setHasNudgeActive(true); // This re-shows the button-highlight, which can be hidden if the user tries to hide the sidebar
        }
    }, [
        isUnloaded,
        openTask,
        shouldShowNudge,
        setHasNudgeActive,
        expandSideNav
    ]);
    return !false && shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a4k7n.NavigationAppsNavItemWrapperNudgeAsync), null, children) : children;
}

});
parcelRegister("8Bc5A", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $5f07ce956337ba8b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $5f07ce956337ba8b$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $5f07ce956337ba8b$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $5f07ce956337ba8b$export$b580da85daad7757);
$parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", () => $5f07ce956337ba8b$export$5eef19b26a4bbe70);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $5f07ce956337ba8b$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $5f07ce956337ba8b$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $5f07ce956337ba8b$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $5f07ce956337ba8b$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $5f07ce956337ba8b$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $5f07ce956337ba8b$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $5f07ce956337ba8b$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $5f07ce956337ba8b$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "KEY_IS_DEVOPS_PROJECT", () => $5f07ce956337ba8b$export$e5b557e3bbb7ec52);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $5f07ce956337ba8b$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $5f07ce956337ba8b$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $5f07ce956337ba8b$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $5f07ce956337ba8b$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "ADD_COLUMNS_TASK", () => $5f07ce956337ba8b$export$cbeb719208f32c8a);
$parcel$export(module.exports, "CREATE_PROJECT_TASK", () => $5f07ce956337ba8b$export$88c918f2cfaff86);
$parcel$export(module.exports, "CREATE_ISSUE_TASK", () => $5f07ce956337ba8b$export$abbbea7c37c93cb5);
$parcel$export(module.exports, "CREATE_ISSUE_TASK_SIMPLIFIED", () => $5f07ce956337ba8b$export$2a0253cb20f48a8);
$parcel$export(module.exports, "INVITE_TEAMMATES_TASK", () => $5f07ce956337ba8b$export$f97428bb4b1991ec);
$parcel$export(module.exports, "INVITE_TEAMMATES_VIDEO_TASK", () => $5f07ce956337ba8b$export$45eaf4204fcc7);
$parcel$export(module.exports, "CAPTURE_INTEGRATIONS_TASK", () => $5f07ce956337ba8b$export$af57685e201438e8);
$parcel$export(module.exports, "FIND_HELP_TASK", () => $5f07ce956337ba8b$export$d6c67e9aab4e2b26);
$parcel$export(module.exports, "SET_UP_BOARD_TASK", () => $5f07ce956337ba8b$export$3de8c242d2b82f26);
$parcel$export(module.exports, "GET_MOBILE_APP_TASK", () => $5f07ce956337ba8b$export$a01fa44f793dbfac);
$parcel$export(module.exports, "MAP_OUT_YOUR_PROJECT_GOALS_TASK", () => $5f07ce956337ba8b$export$6a4507e462fd41da);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK", () => $5f07ce956337ba8b$export$e64c1dced6ac4458);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $5f07ce956337ba8b$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "MONITOR_MANAGE_RISK_TASK", () => $5f07ce956337ba8b$export$c1effb1c8979fe22);
$parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", () => $5f07ce956337ba8b$export$d97d31d934dbb194);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK", () => $5f07ce956337ba8b$export$cafb5bd13b02056b);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN", () => $5f07ce956337ba8b$export$e55c18b809946e72);
$parcel$export(module.exports, "STANDARD_EDITION_OVERVIEW_TASK", () => $5f07ce956337ba8b$export$de5640b9ae8140a7);
$parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", () => $5f07ce956337ba8b$export$540b5c3c4b6ce459);
$parcel$export(module.exports, "CHANGE_CONTROL_TASK", () => $5f07ce956337ba8b$export$6f71dff531ff592);
$parcel$export(module.exports, "AUTOMATIONS_TASK", () => $5f07ce956337ba8b$export$83255ab79e45f34f);
$parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", () => $5f07ce956337ba8b$export$b57d172af9ad7647);
$parcel$export(module.exports, "USER_MANAGEMENT_TASK", () => $5f07ce956337ba8b$export$ff4c933c1fe90b68);
$parcel$export(module.exports, "SCRUM_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$3e2776d61f3662dc);
$parcel$export(module.exports, "CUSTOMIZE_SITE_NAME_TASK", () => $5f07ce956337ba8b$export$9048315f2c03fd9d);
$parcel$export(module.exports, "GET_TO_KNOW_YOUR_TEMPLATE_TASK", () => $5f07ce956337ba8b$export$a333714599f14a6);
$parcel$export(module.exports, "CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK", () => $5f07ce956337ba8b$export$4145c2cec2da6f9b);
$parcel$export(module.exports, "TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$4957a1ad203cf6dd);
$parcel$export(module.exports, "CALENDAR_VIEW_TASK", () => $5f07ce956337ba8b$export$190b5dd0a1322552);
$parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", () => $5f07ce956337ba8b$export$501166b25f254aab);
$parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", () => $5f07ce956337ba8b$export$94ad6507a703f4eb);
$parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", () => $5f07ce956337ba8b$export$be1c522400a1bd7c);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $5f07ce956337ba8b$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $5f07ce956337ba8b$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $5f07ce956337ba8b$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_FEEDBACK_TASK", () => $5f07ce956337ba8b$export$2ae00586da7cb606);
$parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", () => $5f07ce956337ba8b$export$b86266e6594a97bb);
$parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", () => $5f07ce956337ba8b$export$20bc3dc137ac1c38);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $5f07ce956337ba8b$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", () => $5f07ce956337ba8b$export$9c89f946f05d884a);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $5f07ce956337ba8b$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $5f07ce956337ba8b$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $5f07ce956337ba8b$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $5f07ce956337ba8b$export$3380e677209260fe);
$parcel$export(module.exports, "GET_STARTED_LIST_TASK", () => $5f07ce956337ba8b$export$7a2fcaad1564e6b7);
$parcel$export(module.exports, "OPS_JTBD_1_LIST", () => $5f07ce956337ba8b$export$da23b72d32bfad9e);
$parcel$export(module.exports, "OPS_JTBD_2_BOARD", () => $5f07ce956337ba8b$export$4b064659282e0238);
$parcel$export(module.exports, "OPS_JTBD_2_FORMS", () => $5f07ce956337ba8b$export$3ab51851f6d823e);
$parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", () => $5f07ce956337ba8b$export$e4a1a37a9a1350ad);
$parcel$export(module.exports, "OPS_JTBD_3_LIST", () => $5f07ce956337ba8b$export$b7f7da5e795f0327);
$parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", () => $5f07ce956337ba8b$export$80a401c1aa47a377);
$parcel$export(module.exports, "OPS_JTBD_3_PAGES", () => $5f07ce956337ba8b$export$934ac7a251b26dc7);
$parcel$export(module.exports, "OPS_JTBD_4_LIST", () => $5f07ce956337ba8b$export$4634f6395df3ebbe);
$parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", () => $5f07ce956337ba8b$export$768fb41107a1e8d7);
$parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", () => $5f07ce956337ba8b$export$d797a81bace17184);
$parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", () => $5f07ce956337ba8b$export$746102c94db9df1f);
$parcel$export(module.exports, "OPS_JTBD_5_LIST", () => $5f07ce956337ba8b$export$5f1efd797d65e349);
$parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", () => $5f07ce956337ba8b$export$cccc812ccafbf11f);
$parcel$export(module.exports, "OPS_JTBD_5_PAGES", () => $5f07ce956337ba8b$export$64822db87abd8a47);
$parcel$export(module.exports, "OPS_JTBD_6_PAGES", () => $5f07ce956337ba8b$export$64f764d8be495c82);
$parcel$export(module.exports, "OPS_JTBD_7_LIST", () => $5f07ce956337ba8b$export$24eae23dc1c68bbd);
$parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", () => $5f07ce956337ba8b$export$50fa92eba6f82feb);
$parcel$export(module.exports, "OPS_JTBD_0_LIST", () => $5f07ce956337ba8b$export$4155d22fe3f14cd6);
$parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", () => $5f07ce956337ba8b$export$76813cbead887191);
$parcel$export(module.exports, "OPS_JTBD_0_PAGES", () => $5f07ce956337ba8b$export$90aab2ff89daf770);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", () => $5f07ce956337ba8b$export$a2bc0cbad2e6e605);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", () => $5f07ce956337ba8b$export$f90872a1280728bb);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", () => $5f07ce956337ba8b$export$bce644e96518cbd2);
$parcel$export(module.exports, "MKT_JTBD_1_LIST", () => $5f07ce956337ba8b$export$241aaebffac0a3e5);
$parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", () => $5f07ce956337ba8b$export$f9dfc43b5b31c4b7);
$parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", () => $5f07ce956337ba8b$export$79759e9e62fb9312);
$parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", () => $5f07ce956337ba8b$export$992d1e0dce255d19);
$parcel$export(module.exports, "MKT_JTBD_2_PAGES", () => $5f07ce956337ba8b$export$d28c1b0e5b3e768);
$parcel$export(module.exports, "MKT_JTBD_3_PAGES", () => $5f07ce956337ba8b$export$ca714ee197bed4ec);
$parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", () => $5f07ce956337ba8b$export$faae55ceea4b6073);
$parcel$export(module.exports, "MKT_JTBD_4_LIST", () => $5f07ce956337ba8b$export$200bc24cd120667e);
$parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", () => $5f07ce956337ba8b$export$a0d784a48b4e886c);
$parcel$export(module.exports, "MKT_JTBD_4_PAGES", () => $5f07ce956337ba8b$export$baf5bd09b4b33b8a);
$parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", () => $5f07ce956337ba8b$export$4702007eedbca8ab);
$parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", () => $5f07ce956337ba8b$export$aa9d2d635ea63898);
$parcel$export(module.exports, "MKT_JTBD_6_FORMS", () => $5f07ce956337ba8b$export$2ea449225c1f6cac);
$parcel$export(module.exports, "MKT_JTBD_0_LIST", () => $5f07ce956337ba8b$export$deb8b557e735e26a);
$parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", () => $5f07ce956337ba8b$export$d45754df44e4c309);
$parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", () => $5f07ce956337ba8b$export$78b2913b550edbb);
$parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", () => $5f07ce956337ba8b$export$71243272608c58ab);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", () => $5f07ce956337ba8b$export$39a08f215c33bc39);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", () => $5f07ce956337ba8b$export$d2377f6a6fa3b49c);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", () => $5f07ce956337ba8b$export$befa8f6533309779);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", () => $5f07ce956337ba8b$export$736b40db8701ba6c);
$parcel$export(module.exports, "TAILORED_ONBOARDING_SUMMARY", () => $5f07ce956337ba8b$export$11eff6ae2f70b67b);
$parcel$export(module.exports, "TAILORED_ONBOARDING_LIST", () => $5f07ce956337ba8b$export$fb2d23e5315a67a9);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CALENDAR", () => $5f07ce956337ba8b$export$32e794bb49d60b6);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BOARD", () => $5f07ce956337ba8b$export$fed256238b27db06);
$parcel$export(module.exports, "TAILORED_ONBOARDING_TIMELINE", () => $5f07ce956337ba8b$export$132eecb4d35a590d);
$parcel$export(module.exports, "TAILORED_ONBOARDING_PAGES", () => $5f07ce956337ba8b$export$2579c51cadd45eca);
$parcel$export(module.exports, "TAILORED_ONBOARDING_FORM", () => $5f07ce956337ba8b$export$4b1a0cefa966ea0);
$parcel$export(module.exports, "TAILORED_ONBOARDING_INVITE", () => $5f07ce956337ba8b$export$f6558daacc312a65);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BACKLOG", () => $5f07ce956337ba8b$export$925efa2e24e86b88);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CODE", () => $5f07ce956337ba8b$export$40454d3e062dcd44);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $5f07ce956337ba8b$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $5f07ce956337ba8b$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $5f07ce956337ba8b$export$1de5766b7e640d6b);
$parcel$export(module.exports, "DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK", () => $5f07ce956337ba8b$export$8ab0859f5b30b013);
$parcel$export(module.exports, "DEVOPS_GET_TO_KNOW_JIRA_TASK", () => $5f07ce956337ba8b$export$d1f6d18c6698104c);
$parcel$export(module.exports, "DEVOPS_NAVIGATE_YOUR_TOOLS_TASK", () => $5f07ce956337ba8b$export$e6ee159eee7adc1c);
$parcel$export(module.exports, "DEVOPS_CAPTURE_INTEGRATIONS_TASK", () => $5f07ce956337ba8b$export$dd267ca1e3cd3bad);
$parcel$export(module.exports, "DEVOPS_CREATE_AUTOMATION_RULES_TASK", () => $5f07ce956337ba8b$export$f14c8bffc35200d3);
$parcel$export(module.exports, "DEVOPS_INVITE_TEAMMATES_TASK", () => $5f07ce956337ba8b$export$36cc22c9997d92a);
$parcel$export(module.exports, "DEVOPS_FIND_HELP_TASK", () => $5f07ce956337ba8b$export$d651cc94a46ff383);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $5f07ce956337ba8b$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $5f07ce956337ba8b$export$c8ab6996f562d0db);
$parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$2b5f951ad8e70cfe);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $5f07ce956337ba8b$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $5f07ce956337ba8b$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $5f07ce956337ba8b$export$f779bbfe667acddc);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $5f07ce956337ba8b$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", () => $5f07ce956337ba8b$export$7578902c7f420a3);

var $g5X3G = parcelRequire("g5X3G");
const $5f07ce956337ba8b$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeDevopsTaskName = (taskId)=>`devops-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $5f07ce956337ba8b$export$2b3151a089bc8780 = 'jlove-makkuro';
const $5f07ce956337ba8b$export$6826d33e9a2c0119 = 320;
const $5f07ce956337ba8b$export$b580da85daad7757 = 'root';
const $5f07ce956337ba8b$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
const $5f07ce956337ba8b$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $5f07ce956337ba8b$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $5f07ce956337ba8b$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $5f07ce956337ba8b$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $5f07ce956337ba8b$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $5f07ce956337ba8b$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $5f07ce956337ba8b$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $5f07ce956337ba8b$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $5f07ce956337ba8b$export$e5b557e3bbb7ec52 = 'isDevopsProject';
const $5f07ce956337ba8b$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $5f07ce956337ba8b$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $5f07ce956337ba8b$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $5f07ce956337ba8b$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $5f07ce956337ba8b$export$cbeb719208f32c8a = $5f07ce956337ba8b$var$completeJswTaskName('add-columns-task');
const $5f07ce956337ba8b$export$88c918f2cfaff86 = $5f07ce956337ba8b$var$completeJswTaskName('create-project-task');
const $5f07ce956337ba8b$export$abbbea7c37c93cb5 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task');
const $5f07ce956337ba8b$export$2a0253cb20f48a8 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task-simplified');
const $5f07ce956337ba8b$export$f97428bb4b1991ec = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-task');
const $5f07ce956337ba8b$export$45eaf4204fcc7 = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-video-task');
const $5f07ce956337ba8b$export$af57685e201438e8 = $5f07ce956337ba8b$var$completeJswTaskName('capture-integrations-task');
const $5f07ce956337ba8b$export$d6c67e9aab4e2b26 = $5f07ce956337ba8b$var$completeJswTaskName('find-help-task');
const $5f07ce956337ba8b$export$3de8c242d2b82f26 = $5f07ce956337ba8b$var$completeJswTaskName('set-up-board-task');
const $5f07ce956337ba8b$export$a01fa44f793dbfac = $5f07ce956337ba8b$var$completeJswTaskName('get-mobile-app-task');
const $5f07ce956337ba8b$export$6a4507e462fd41da = $5f07ce956337ba8b$var$completeJswTaskName('map-out-your-project-goals');
const $5f07ce956337ba8b$export$e64c1dced6ac4458 = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work');
const $5f07ce956337ba8b$export$63b0e55f9c6454ac = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $5f07ce956337ba8b$export$c1effb1c8979fe22 = $5f07ce956337ba8b$var$completeJswTaskName('monitor-manage-risk');
const $5f07ce956337ba8b$export$d97d31d934dbb194 = $5f07ce956337ba8b$var$completeJswTaskName('premium-reverse-trial-task');
const $5f07ce956337ba8b$export$cafb5bd13b02056b = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task');
const $5f07ce956337ba8b$export$e55c18b809946e72 = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task-non-admin');
const $5f07ce956337ba8b$export$de5640b9ae8140a7 = $5f07ce956337ba8b$var$completeJswTaskName('standard-edition-overview-task');
const $5f07ce956337ba8b$export$540b5c3c4b6ce459 = $5f07ce956337ba8b$var$completeJswTaskName('advanced-roadmaps-task');
const $5f07ce956337ba8b$export$6f71dff531ff592 = $5f07ce956337ba8b$var$completeJswTaskName('change-control-task');
const $5f07ce956337ba8b$export$83255ab79e45f34f = $5f07ce956337ba8b$var$completeJswTaskName('automations-task');
const $5f07ce956337ba8b$export$b57d172af9ad7647 = $5f07ce956337ba8b$var$completeJswTaskName('site-administrations-task');
const $5f07ce956337ba8b$export$ff4c933c1fe90b68 = $5f07ce956337ba8b$var$completeJswTaskName('user-management-task');
const $5f07ce956337ba8b$export$3e2776d61f3662dc = $5f07ce956337ba8b$var$completeJswTaskName('scrum-onboarding-task');
const $5f07ce956337ba8b$export$9048315f2c03fd9d = $5f07ce956337ba8b$var$completeJswTaskName('customize-site-name-task');
const $5f07ce956337ba8b$export$a333714599f14a6 = $5f07ce956337ba8b$var$completeJswTaskName('get-to-know-your-template-task');
const $5f07ce956337ba8b$export$4145c2cec2da6f9b = $5f07ce956337ba8b$var$completeJswTaskName('create-business-project-from-jsw-quickstart-task');
const $5f07ce956337ba8b$export$4957a1ad203cf6dd = $5f07ce956337ba8b$var$completeJswTaskName('try-atlassian-university-task');
const $5f07ce956337ba8b$export$190b5dd0a1322552 = $5f07ce956337ba8b$var$completeJswTaskName('calendar-view-task');
const $5f07ce956337ba8b$export$501166b25f254aab = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-project-summary-task');
const $5f07ce956337ba8b$export$94ad6507a703f4eb = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-sample-project-task');
const $5f07ce956337ba8b$export$be1c522400a1bd7c = $5f07ce956337ba8b$var$completeJwmTaskName('background-color-task');
const $5f07ce956337ba8b$export$2aa6e7b6e24a04f5 = $5f07ce956337ba8b$var$completeJwmTaskName('calendar-task');
const $5f07ce956337ba8b$export$f3b53199b07af2a1 = $5f07ce956337ba8b$var$completeJwmTaskName('timeline-task');
const $5f07ce956337ba8b$export$d37415ffddcf2142 = $5f07ce956337ba8b$var$completeJwmTaskName('build-form-task');
const $5f07ce956337ba8b$export$2ae00586da7cb606 = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-task');
const $5f07ce956337ba8b$export$b86266e6594a97bb = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-sample-project-task');
const $5f07ce956337ba8b$export$20bc3dc137ac1c38 = $5f07ce956337ba8b$var$completeJwmTaskName('create-your-own-project-task');
const $5f07ce956337ba8b$export$77071b77e2801b18 = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-project-task');
const $5f07ce956337ba8b$export$9c89f946f05d884a = $5f07ce956337ba8b$var$completeJwmTaskName('share-project-task');
const $5f07ce956337ba8b$export$b52a7c936684cfc5 = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-import');
const $5f07ce956337ba8b$export$b5555f24061f9fb = $5f07ce956337ba8b$var$completeJwmTaskName('summary-and-reports-task');
const $5f07ce956337ba8b$export$ff25449f34b8abf = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $5f07ce956337ba8b$export$3380e677209260fe = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-key-differences');
const $5f07ce956337ba8b$export$7a2fcaad1564e6b7 = $5f07ce956337ba8b$var$completeJwmTaskName('get-started-list-task');
const $5f07ce956337ba8b$export$da23b72d32bfad9e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_1_LIST');
const $5f07ce956337ba8b$export$4b064659282e0238 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
const $5f07ce956337ba8b$export$3ab51851f6d823e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
const $5f07ce956337ba8b$export$e4a1a37a9a1350ad = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
const $5f07ce956337ba8b$export$b7f7da5e795f0327 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_LIST');
const $5f07ce956337ba8b$export$80a401c1aa47a377 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
const $5f07ce956337ba8b$export$934ac7a251b26dc7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
const $5f07ce956337ba8b$export$4634f6395df3ebbe = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_LIST');
const $5f07ce956337ba8b$export$768fb41107a1e8d7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
const $5f07ce956337ba8b$export$d797a81bace17184 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
const $5f07ce956337ba8b$export$746102c94db9df1f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
const $5f07ce956337ba8b$export$5f1efd797d65e349 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_LIST');
const $5f07ce956337ba8b$export$cccc812ccafbf11f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
const $5f07ce956337ba8b$export$64822db87abd8a47 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
const $5f07ce956337ba8b$export$64f764d8be495c82 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
const $5f07ce956337ba8b$export$24eae23dc1c68bbd = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_LIST');
const $5f07ce956337ba8b$export$50fa92eba6f82feb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
const $5f07ce956337ba8b$export$4155d22fe3f14cd6 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_LIST');
const $5f07ce956337ba8b$export$76813cbead887191 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
const $5f07ce956337ba8b$export$90aab2ff89daf770 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
const $5f07ce956337ba8b$export$a2bc0cbad2e6e605 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
const $5f07ce956337ba8b$export$f90872a1280728bb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
const $5f07ce956337ba8b$export$bce644e96518cbd2 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
const $5f07ce956337ba8b$export$241aaebffac0a3e5 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_LIST');
const $5f07ce956337ba8b$export$f9dfc43b5b31c4b7 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
const $5f07ce956337ba8b$export$79759e9e62fb9312 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
const $5f07ce956337ba8b$export$992d1e0dce255d19 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
const $5f07ce956337ba8b$export$d28c1b0e5b3e768 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
const $5f07ce956337ba8b$export$ca714ee197bed4ec = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
const $5f07ce956337ba8b$export$faae55ceea4b6073 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
const $5f07ce956337ba8b$export$200bc24cd120667e = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_LIST');
const $5f07ce956337ba8b$export$a0d784a48b4e886c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
const $5f07ce956337ba8b$export$baf5bd09b4b33b8a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
const $5f07ce956337ba8b$export$4702007eedbca8ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
const $5f07ce956337ba8b$export$aa9d2d635ea63898 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
const $5f07ce956337ba8b$export$2ea449225c1f6cac = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
const $5f07ce956337ba8b$export$deb8b557e735e26a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_LIST');
const $5f07ce956337ba8b$export$d45754df44e4c309 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
const $5f07ce956337ba8b$export$78b2913b550edbb = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
const $5f07ce956337ba8b$export$71243272608c58ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
const $5f07ce956337ba8b$export$39a08f215c33bc39 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
const $5f07ce956337ba8b$export$d2377f6a6fa3b49c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
const $5f07ce956337ba8b$export$befa8f6533309779 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
const $5f07ce956337ba8b$export$736b40db8701ba6c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
const $5f07ce956337ba8b$export$11eff6ae2f70b67b = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_SUMMARY');
const $5f07ce956337ba8b$export$fb2d23e5315a67a9 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_LIST');
const $5f07ce956337ba8b$export$32e794bb49d60b6 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_CALENDAR');
const $5f07ce956337ba8b$export$fed256238b27db06 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_BOARD');
const $5f07ce956337ba8b$export$132eecb4d35a590d = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_TIMELINE');
const $5f07ce956337ba8b$export$2579c51cadd45eca = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_PAGES');
const $5f07ce956337ba8b$export$4b1a0cefa966ea0 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_FORM');
const $5f07ce956337ba8b$export$f6558daacc312a65 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_INVITE');
const $5f07ce956337ba8b$export$925efa2e24e86b88 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_BACKLOG');
const $5f07ce956337ba8b$export$40454d3e062dcd44 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_CODE');
const $5f07ce956337ba8b$export$99b0e09ff6f00490 = $5f07ce956337ba8b$var$completeJsmTaskName('customize-your-request-types-task');
const $5f07ce956337ba8b$export$2a82344eb273eeff = $5f07ce956337ba8b$var$completeJsmTaskName('review-your-channels-task');
const $5f07ce956337ba8b$export$1de5766b7e640d6b = $5f07ce956337ba8b$var$completeJsmTaskName('invite-your-team-task');
const $5f07ce956337ba8b$export$8ab0859f5b30b013 = $5f07ce956337ba8b$var$completeDevopsTaskName('welcome-to-your-project-task');
const $5f07ce956337ba8b$export$d1f6d18c6698104c = $5f07ce956337ba8b$var$completeDevopsTaskName('get-to-know-jira-task');
const $5f07ce956337ba8b$export$e6ee159eee7adc1c = $5f07ce956337ba8b$var$completeDevopsTaskName('navigate-your-tools-task');
const $5f07ce956337ba8b$export$dd267ca1e3cd3bad = $5f07ce956337ba8b$var$completeDevopsTaskName('capture-integrations-task');
const $5f07ce956337ba8b$export$f14c8bffc35200d3 = $5f07ce956337ba8b$var$completeDevopsTaskName('create-automation-rules-task');
const $5f07ce956337ba8b$export$36cc22c9997d92a = $5f07ce956337ba8b$var$completeDevopsTaskName('invite-teammates-task');
const $5f07ce956337ba8b$export$d651cc94a46ff383 = $5f07ce956337ba8b$var$completeDevopsTaskName('find-help-task');
const $5f07ce956337ba8b$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $5f07ce956337ba8b$export$c8ab6996f562d0db = (0, $g5X3G.toAccountId)('accountId');
const $5f07ce956337ba8b$export$2b5f951ad8e70cfe = $5f07ce956337ba8b$var$completeJswTaskName('kanban-onboarding-task');
const $5f07ce956337ba8b$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $5f07ce956337ba8b$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $5f07ce956337ba8b$export$f779bbfe667acddc = [
    'legacy-project-settings-people',
    'project-settings-software-access'
];
const $5f07ce956337ba8b$export$38fbac7a5bf4aa33 = [
    $5f07ce956337ba8b$export$2a82344eb273eeff,
    $5f07ce956337ba8b$export$99b0e09ff6f00490,
    $5f07ce956337ba8b$export$1de5766b7e640d6b
];
const $5f07ce956337ba8b$export$7578902c7f420a3 = [
    $5f07ce956337ba8b$export$88c918f2cfaff86,
    $5f07ce956337ba8b$export$6a4507e462fd41da,
    $5f07ce956337ba8b$export$e64c1dced6ac4458,
    $5f07ce956337ba8b$export$63b0e55f9c6454ac,
    $5f07ce956337ba8b$export$c1effb1c8979fe22,
    $5f07ce956337ba8b$export$cbeb719208f32c8a,
    $5f07ce956337ba8b$export$abbbea7c37c93cb5,
    $5f07ce956337ba8b$export$2a0253cb20f48a8,
    $5f07ce956337ba8b$export$f97428bb4b1991ec,
    $5f07ce956337ba8b$export$d6c67e9aab4e2b26,
    $5f07ce956337ba8b$export$3de8c242d2b82f26,
    $5f07ce956337ba8b$export$a01fa44f793dbfac,
    $5f07ce956337ba8b$export$45eaf4204fcc7,
    $5f07ce956337ba8b$export$af57685e201438e8,
    $5f07ce956337ba8b$export$d97d31d934dbb194,
    $5f07ce956337ba8b$export$cafb5bd13b02056b,
    $5f07ce956337ba8b$export$e55c18b809946e72,
    $5f07ce956337ba8b$export$de5640b9ae8140a7,
    $5f07ce956337ba8b$export$540b5c3c4b6ce459,
    $5f07ce956337ba8b$export$6f71dff531ff592,
    $5f07ce956337ba8b$export$83255ab79e45f34f,
    $5f07ce956337ba8b$export$b57d172af9ad7647,
    $5f07ce956337ba8b$export$ff4c933c1fe90b68,
    $5f07ce956337ba8b$export$77071b77e2801b18,
    $5f07ce956337ba8b$export$94ad6507a703f4eb,
    $5f07ce956337ba8b$export$501166b25f254aab,
    $5f07ce956337ba8b$export$be1c522400a1bd7c,
    $5f07ce956337ba8b$export$2aa6e7b6e24a04f5,
    $5f07ce956337ba8b$export$f3b53199b07af2a1,
    $5f07ce956337ba8b$export$d37415ffddcf2142,
    $5f07ce956337ba8b$export$2ae00586da7cb606,
    $5f07ce956337ba8b$export$9c89f946f05d884a,
    $5f07ce956337ba8b$export$20bc3dc137ac1c38,
    $5f07ce956337ba8b$export$b52a7c936684cfc5,
    $5f07ce956337ba8b$export$b5555f24061f9fb,
    $5f07ce956337ba8b$export$ff25449f34b8abf,
    $5f07ce956337ba8b$export$3380e677209260fe,
    $5f07ce956337ba8b$export$b86266e6594a97bb,
    $5f07ce956337ba8b$export$8ab0859f5b30b013,
    $5f07ce956337ba8b$export$d1f6d18c6698104c,
    $5f07ce956337ba8b$export$e6ee159eee7adc1c,
    $5f07ce956337ba8b$export$dd267ca1e3cd3bad,
    $5f07ce956337ba8b$export$f14c8bffc35200d3,
    $5f07ce956337ba8b$export$36cc22c9997d92a,
    $5f07ce956337ba8b$export$d651cc94a46ff383,
    $5f07ce956337ba8b$export$3e2776d61f3662dc,
    $5f07ce956337ba8b$export$2b5f951ad8e70cfe,
    $5f07ce956337ba8b$export$9048315f2c03fd9d,
    $5f07ce956337ba8b$export$a333714599f14a6,
    $5f07ce956337ba8b$export$4145c2cec2da6f9b,
    $5f07ce956337ba8b$export$4957a1ad203cf6dd,
    $5f07ce956337ba8b$export$7a2fcaad1564e6b7,
    $5f07ce956337ba8b$export$190b5dd0a1322552,
    $5f07ce956337ba8b$export$da23b72d32bfad9e,
    $5f07ce956337ba8b$export$4b064659282e0238,
    $5f07ce956337ba8b$export$3ab51851f6d823e,
    $5f07ce956337ba8b$export$e4a1a37a9a1350ad,
    $5f07ce956337ba8b$export$b7f7da5e795f0327,
    $5f07ce956337ba8b$export$80a401c1aa47a377,
    $5f07ce956337ba8b$export$934ac7a251b26dc7,
    $5f07ce956337ba8b$export$4634f6395df3ebbe,
    $5f07ce956337ba8b$export$768fb41107a1e8d7,
    $5f07ce956337ba8b$export$d797a81bace17184,
    $5f07ce956337ba8b$export$746102c94db9df1f,
    $5f07ce956337ba8b$export$5f1efd797d65e349,
    $5f07ce956337ba8b$export$cccc812ccafbf11f,
    $5f07ce956337ba8b$export$64822db87abd8a47,
    $5f07ce956337ba8b$export$64f764d8be495c82,
    $5f07ce956337ba8b$export$24eae23dc1c68bbd,
    $5f07ce956337ba8b$export$50fa92eba6f82feb,
    $5f07ce956337ba8b$export$4155d22fe3f14cd6,
    $5f07ce956337ba8b$export$76813cbead887191,
    $5f07ce956337ba8b$export$90aab2ff89daf770,
    $5f07ce956337ba8b$export$a2bc0cbad2e6e605,
    $5f07ce956337ba8b$export$f90872a1280728bb,
    $5f07ce956337ba8b$export$bce644e96518cbd2,
    $5f07ce956337ba8b$export$241aaebffac0a3e5,
    $5f07ce956337ba8b$export$f9dfc43b5b31c4b7,
    $5f07ce956337ba8b$export$79759e9e62fb9312,
    $5f07ce956337ba8b$export$992d1e0dce255d19,
    $5f07ce956337ba8b$export$d28c1b0e5b3e768,
    $5f07ce956337ba8b$export$ca714ee197bed4ec,
    $5f07ce956337ba8b$export$faae55ceea4b6073,
    $5f07ce956337ba8b$export$200bc24cd120667e,
    $5f07ce956337ba8b$export$a0d784a48b4e886c,
    $5f07ce956337ba8b$export$baf5bd09b4b33b8a,
    $5f07ce956337ba8b$export$4702007eedbca8ab,
    $5f07ce956337ba8b$export$aa9d2d635ea63898,
    $5f07ce956337ba8b$export$2ea449225c1f6cac,
    $5f07ce956337ba8b$export$deb8b557e735e26a,
    $5f07ce956337ba8b$export$d45754df44e4c309,
    $5f07ce956337ba8b$export$78b2913b550edbb,
    $5f07ce956337ba8b$export$71243272608c58ab,
    $5f07ce956337ba8b$export$39a08f215c33bc39,
    $5f07ce956337ba8b$export$d2377f6a6fa3b49c,
    $5f07ce956337ba8b$export$befa8f6533309779,
    $5f07ce956337ba8b$export$736b40db8701ba6c,
    // Tailored onboarding M3
    $5f07ce956337ba8b$export$11eff6ae2f70b67b,
    $5f07ce956337ba8b$export$fb2d23e5315a67a9,
    $5f07ce956337ba8b$export$32e794bb49d60b6,
    $5f07ce956337ba8b$export$fed256238b27db06,
    $5f07ce956337ba8b$export$132eecb4d35a590d,
    $5f07ce956337ba8b$export$2579c51cadd45eca,
    $5f07ce956337ba8b$export$4b1a0cefa966ea0,
    $5f07ce956337ba8b$export$f6558daacc312a65,
    $5f07ce956337ba8b$export$925efa2e24e86b88,
    $5f07ce956337ba8b$export$40454d3e062dcd44
];

});

parcelRegister("cE2Qr", function(module, exports) {

$parcel$export(module.exports, "useJswOnboarding", () => $796be817ff5bbbfa$export$7d91c0af4772787a);
$parcel$export(module.exports, "useOpenTask", () => $796be817ff5bbbfa$export$594f006fa6a1b2e5);
$parcel$export(module.exports, "useNudgeStep", () => $796be817ff5bbbfa$export$c5e63e44ad178ae8);
$parcel$export(module.exports, "useQuickstartActions", () => $796be817ff5bbbfa$export$2c3cd14fff9d6e43);
$parcel$export(module.exports, "useShouldShowNudge", () => $796be817ff5bbbfa$export$b0db7e46e369e1d9);
$parcel$export(module.exports, "useInviteToProject", () => $796be817ff5bbbfa$export$71de79653346a1ea);
$parcel$export(module.exports, "useShowVideoCards", () => $796be817ff5bbbfa$export$61185a9266f1f57a);
$parcel$export(module.exports, "useProjectState", () => $796be817ff5bbbfa$export$ef4747ba36826d6a);
$parcel$export(module.exports, "useQuickstartUiStatus", () => $796be817ff5bbbfa$export$522993b46d9f8266);
$parcel$export(module.exports, "useIsLoaded", () => $796be817ff5bbbfa$export$aa4ba29241532382);
$parcel$export(module.exports, "useIsFocusedOn", () => $796be817ff5bbbfa$export$ed5c755b733bf2b1);
$parcel$export(module.exports, "useIsDismissed", () => $796be817ff5bbbfa$export$35fe0366802512dd);
$parcel$export(module.exports, "useCompletedTaskList", () => $796be817ff5bbbfa$export$a41ee0d3b6938099);
$parcel$export(module.exports, "useAllTasksCompleted", () => $796be817ff5bbbfa$export$4ae7b465b076be9);
$parcel$export(module.exports, "useMountedNudges", () => $796be817ff5bbbfa$export$bf6e646c0476acad);
$parcel$export(module.exports, "useHasEverSeen", () => $796be817ff5bbbfa$export$6b706bff94798d11);
$parcel$export(module.exports, "useRoadmapState", () => $796be817ff5bbbfa$export$c98db656edc5b3e1);
$parcel$export(module.exports, "useShouldShowScrumOnboardingExperience", () => $796be817ff5bbbfa$export$a823278ac9d1112b);
$parcel$export(module.exports, "useShouldShowOnboardingKanbanTour", () => $796be817ff5bbbfa$export$cb9e0e8fe4df8490);
$parcel$export(module.exports, "useHasNudgeActive", () => $796be817ff5bbbfa$export$521909e3dc7ab811);
$parcel$export(module.exports, "useSelectedProjectTemplateKeyFromOnboarding", () => $796be817ff5bbbfa$export$f4a2be940259bf95);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => (parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS);

var $58GFP = parcelRequire("58GFP");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $8Bc5A = parcelRequire("8Bc5A");

var $6RAg1 = parcelRequire("6RAg1");

var $ieqoN = parcelRequire("ieqoN");

var $cGE52 = parcelRequire("cGE52");

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");

const $796be817ff5bbbfa$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'jsw-onboarding-quickstart',
    initialState: $cGE52.initialState,
    actions: $6RAg1
});
const $796be817ff5bbbfa$export$1cbc60d8dd921852 = (0, $51nlc.createSubscriber)($796be817ff5bbbfa$export$390f32400eaf98c9);
const $796be817ff5bbbfa$export$7d91c0af4772787a = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9);
const $796be817ff5bbbfa$export$638bfcfce1254bb8 = (0, $gg7kZ.createContainer)($796be817ff5bbbfa$export$390f32400eaf98c9, {});
const $796be817ff5bbbfa$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
    const commonConditionsToShowNudge = state.shouldRenderComponent && state.visibility[(0, $3B5jO.getQuickstartTypeSelector)(state)] === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    itemNames.includes(state.openTask);
    return commonConditionsToShowNudge && state.hasNudgeActive;
};
const $796be817ff5bbbfa$export$ea14030920a5d8e6 = (state)=>state.openTask;
const $796be817ff5bbbfa$export$594f006fa6a1b2e5 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: $796be817ff5bbbfa$export$ea14030920a5d8e6
});
const $796be817ff5bbbfa$export$a943afa434e9487a = (state)=>state.nudgeStep;
const $796be817ff5bbbfa$export$c5e63e44ad178ae8 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: $796be817ff5bbbfa$export$a943afa434e9487a
});
const $796be817ff5bbbfa$export$2c3cd14fff9d6e43 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: null
});
const $796be817ff5bbbfa$export$b0db7e46e369e1d9 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: $796be817ff5bbbfa$export$9d731f44f82af09f
});
const $796be817ff5bbbfa$export$71de79653346a1ea = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
});
const $796be817ff5bbbfa$export$61185a9266f1f57a = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.projectState) return false;
        const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
        return Boolean(isNextGen && (userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN || userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN || isProjectAdmin));
    }
});
const $796be817ff5bbbfa$export$ef4747ba36826d6a = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.projectState
});
const $796be817ff5bbbfa$export$522993b46d9f8266 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        if (state.shouldRenderComponent === false) return (0, $4ji4w.getLocalStorageItem)(`${quickstartType}.visibility`) ?? (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED;
        return state.visibility[quickstartType];
    }
});
const $796be817ff5bbbfa$export$aa4ba29241532382 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.isQuickstartLoaded
});
const $796be817ff5bbbfa$export$ed5c755b733bf2b1 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.isFocusedOn
});
const $796be817ff5bbbfa$export$35fe0366802512dd = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        const visibility = state.visibility[(0, $3B5jO.getQuickstartTypeSelector)(state)];
        return visibility === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED || visibility === (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED;
    }
});
const $796be817ff5bbbfa$export$a41ee0d3b6938099 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.completedTaskList
});
const $796be817ff5bbbfa$export$4ae7b465b076be9 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.tasks) return null;
        return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
    }
});
const $796be817ff5bbbfa$export$bf6e646c0476acad = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.mountedNudges
});
const $796be817ff5bbbfa$export$6b706bff94798d11 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.hasEverSeenRoute
});
const $796be817ff5bbbfa$export$c98db656edc5b3e1 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>({
            roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
            roadmapIsListEmpty: state.roadmapIsListEmpty
        })
});
const $796be817ff5bbbfa$export$a823278ac9d1112b = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && !state.isDevOpsProject && state.selectedProjectTemplateKeyFromOnboarding === (0, $58GFP.SCRUM_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN)
});
const $796be817ff5bbbfa$export$cb9e0e8fe4df8490 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && !state.isDevOpsProject && state.selectedProjectTemplateKeyFromOnboarding === (0, $58GFP.KANBAN_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN && // edge case - if e.g. welcome modal failed to load, and user completed task by themself, then the welcome modal should be skipped on subsequent page loads.
        !state.completedTaskList.includes((0, $8Bc5A.KANBAN_ONBOARDING_TASK)))
});
const $796be817ff5bbbfa$export$521909e3dc7ab811 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.hasNudgeActive
});
const $796be817ff5bbbfa$export$f4a2be940259bf95 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
});

});
parcelRegister("58GFP", function(module, exports) {

$parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$f40a08fc76eb112d);
$parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$e3844688f2693533);
$parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$e3cec071fcb2fbd3);
$parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$21783d461e3ef6d);
$parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$6cd1c1b2ba0f6e2d);
$parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$57d877f2e01e0029);
$parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$6f4213a3addc3fdb);
$parcel$export(module.exports, "JWM_TEMPLATE_PREFIX", () => $c364c398187f9175$export$7492b6cc3ef89883);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7d9a4e0ef5194fe1);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$477ca3550da12e43);
$parcel$export(module.exports, "BLANK_TEMPLATE_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7c0307155b744916);
$parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$b5ab111fb8825075);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$14139f0ec41d437e);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$ebf7af45376deb8b);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7b6945581ccdab4a);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$310a9ac5c28d65f6);
$parcel$export(module.exports, "TASK_TRACKING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$136d17feb2f4285d);
$parcel$export(module.exports, "DOCUMENT_APPROVAL_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$e288f4758e94a8cc);
$parcel$export(module.exports, "PROCESS_CONTROL_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$4e9ac1417ba54bba);
$parcel$export(module.exports, "POLICY_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$560c9f6765bf9af4);
$parcel$export(module.exports, "SALES_PIPELINE_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$14d4c6dbbb62a127);
$parcel$export(module.exports, "PROCUREMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$1367ee12532c525f);
$parcel$export(module.exports, "WEB_DESIGN_PROCESS_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$278632cc7ed9a312);
$parcel$export(module.exports, "BUDGET_CREATION_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$594d0d4f5ecbf4c7);
$parcel$export(module.exports, "EMPLOYEE_ONBOARDING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$dda85c7a8278e495);
$parcel$export(module.exports, "RECRUITMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$b92c431651f9ee91);
$parcel$export(module.exports, "LEAD_TRACKING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$d72d75d9d0e071fc);
$parcel$export(module.exports, "IP_INFRINGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$753322ed1c32ff89);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$4d29ee0c00eb5df4);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$6278b41164dbde6c);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_BASIC_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$17a2f771efabf02f);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_OPERATIONS_TEMPLATE_KEY", () => $c364c398187f9175$export$df7d1440e0a80c03);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$bd14946bcde77195);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", () => $c364c398187f9175$export$e8df553a3f519284);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", () => $c364c398187f9175$export$97fc32bd703bb4d1);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", () => $c364c398187f9175$export$8eecdf6acea9494);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", () => $c364c398187f9175$export$ff16be7794ed4222);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$9917830b560a2f4);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$b0928b02ffab3875);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$fd75f6abc7861439);
$parcel$export(module.exports, "HR_SERVICE_PROJECT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$2bc7db2da3df8313);
$parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", () => $c364c398187f9175$export$87a8fff98b5bc81);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$7c567eb725bd36f);
$parcel$export(module.exports, "getIsJsmBlankProjectTemplate", () => $c364c398187f9175$export$73fd025e86012868);
$parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", () => $c364c398187f9175$export$a062badd78c9993);
$parcel$export(module.exports, "isJwmTmpTemplateKey", () => $c364c398187f9175$export$aff130309b9a2baf);
// Project template type keys are used to create projects.
// TODO: KURO-1818 consolidate keys from `project-template-keys` in this file.
// Software template keys
const $c364c398187f9175$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
const $c364c398187f9175$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
const $c364c398187f9175$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
const $c364c398187f9175$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
const $c364c398187f9175$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
const $c364c398187f9175$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
const $c364c398187f9175$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
const $c364c398187f9175$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
const $c364c398187f9175$export$7d9a4e0ef5194fe1 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
const $c364c398187f9175$export$477ca3550da12e43 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
const $c364c398187f9175$export$7c0307155b744916 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
const $c364c398187f9175$export$b5ab111fb8825075 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
const $c364c398187f9175$export$14139f0ec41d437e = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
const $c364c398187f9175$export$ebf7af45376deb8b = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
const $c364c398187f9175$export$7b6945581ccdab4a = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
const $c364c398187f9175$export$310a9ac5c28d65f6 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
const $c364c398187f9175$export$136d17feb2f4285d = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-task-tracking-team-managed`;
const $c364c398187f9175$export$e288f4758e94a8cc = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-document-approval-team-managed`;
const $c364c398187f9175$export$4e9ac1417ba54bba = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-process-control-team-managed`;
const $c364c398187f9175$export$560c9f6765bf9af4 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-policy-management-team-managed`;
const $c364c398187f9175$export$14d4c6dbbb62a127 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-sales-pipeline-team-managed`;
const $c364c398187f9175$export$1367ee12532c525f = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-procurement-team-managed`;
const $c364c398187f9175$export$278632cc7ed9a312 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-web-design-process-team-managed`;
const $c364c398187f9175$export$594d0d4f5ecbf4c7 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-budget-creation-team-managed`;
const $c364c398187f9175$export$dda85c7a8278e495 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-employee-onboarding-team-managed`;
const $c364c398187f9175$export$b92c431651f9ee91 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-recruitment-team-managed`;
const $c364c398187f9175$export$d72d75d9d0e071fc = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-lead-tracking-team-managed`;
const $c364c398187f9175$export$753322ed1c32ff89 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-ip-infringement-team-managed`;
const $c364c398187f9175$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
const $c364c398187f9175$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
const $c364c398187f9175$export$17a2f771efabf02f = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
const $c364c398187f9175$export$df7d1440e0a80c03 = 'com.atlassian.servicedesk:simplified-it-service-management-operations';
const $c364c398187f9175$export$bd14946bcde77195 = 'com.atlassian.jcs:customer-service-management';
const $c364c398187f9175$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
const $c364c398187f9175$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
const $c364c398187f9175$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
const $c364c398187f9175$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
const $c364c398187f9175$export$9e38ad41d19608ee = 'jsm.blank-service-management';
const $c364c398187f9175$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
const $c364c398187f9175$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
const $c364c398187f9175$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
const $c364c398187f9175$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
const $c364c398187f9175$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
const $c364c398187f9175$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
const $c364c398187f9175$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
const $c364c398187f9175$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
const $c364c398187f9175$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
const $c364c398187f9175$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
const $c364c398187f9175$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
const $c364c398187f9175$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
const $c364c398187f9175$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
const $c364c398187f9175$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
const $c364c398187f9175$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
const $c364c398187f9175$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
const $c364c398187f9175$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
const $c364c398187f9175$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
const $c364c398187f9175$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
const $c364c398187f9175$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
const $c364c398187f9175$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
const $c364c398187f9175$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
const $c364c398187f9175$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
const $c364c398187f9175$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
const $c364c398187f9175$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
const $c364c398187f9175$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
const $c364c398187f9175$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
const $c364c398187f9175$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
const $c364c398187f9175$export$87a8fff98b5bc81 = 'initial.project.template.name';
const $c364c398187f9175$export$7c567eb725bd36f = 'jira.polaris:discovery';
const $c364c398187f9175$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
const $c364c398187f9175$export$f9776303073903dd = 'jira.polaris:roadmap';
const $c364c398187f9175$export$b7c4ca557ac2074e = 'jira.polaris:prioritization';
const $c364c398187f9175$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $c364c398187f9175$export$e8df553a3f519284 || T4JTemplateKey === $c364c398187f9175$export$8eecdf6acea9494 || T4JTemplateKey === $c364c398187f9175$export$9e38ad41d19608ee;
const $c364c398187f9175$export$a062badd78c9993 = {
    [$c364c398187f9175$export$e82092c4fb277f9b]: $c364c398187f9175$export$b0928b02ffab3875,
    [$c364c398187f9175$export$fd75f6abc7861439]: $c364c398187f9175$export$b0928b02ffab3875,
    [$c364c398187f9175$export$5eddf3b31dd1858f]: $c364c398187f9175$export$50478ee5ecbf7a4d,
    [$c364c398187f9175$export$fb658bddae7f81bb]: $c364c398187f9175$export$50478ee5ecbf7a4d
};
const $c364c398187f9175$export$aff130309b9a2baf = (templateKey)=>{
    return [
        $c364c398187f9175$export$477ca3550da12e43,
        $c364c398187f9175$export$b5ab111fb8825075,
        $c364c398187f9175$export$ebf7af45376deb8b,
        $c364c398187f9175$export$310a9ac5c28d65f6,
        $c364c398187f9175$export$136d17feb2f4285d,
        $c364c398187f9175$export$e288f4758e94a8cc,
        $c364c398187f9175$export$4e9ac1417ba54bba,
        $c364c398187f9175$export$560c9f6765bf9af4,
        $c364c398187f9175$export$14d4c6dbbb62a127,
        $c364c398187f9175$export$1367ee12532c525f,
        $c364c398187f9175$export$278632cc7ed9a312,
        $c364c398187f9175$export$594d0d4f5ecbf4c7,
        $c364c398187f9175$export$dda85c7a8278e495,
        $c364c398187f9175$export$b92c431651f9ee91,
        $c364c398187f9175$export$d72d75d9d0e071fc,
        $c364c398187f9175$export$753322ed1c32ff89
    ].includes(templateKey);
};

});

parcelRegister("6RAg1", function(module, exports) {

$parcel$export(module.exports, "changeTaskGroupParent", () => (parcelRequire("6fSBR")).nextChangeTaskGroupParent);
$parcel$export(module.exports, "goBackToPreviousTaskGroup", () => (parcelRequire("6fSBR")).nextGoBackToPreviousTaskGroup);
$parcel$export(module.exports, "setIsOpen", () => (parcelRequire("j6wxT")).setIsOpen);
$parcel$export(module.exports, "refreshAppState", () => (parcelRequire("7mZ3t")).refreshAppState);
$parcel$export(module.exports, "setNudgeStep", () => (parcelRequire("8UXiA")).setNudgeStep);
$parcel$export(module.exports, "addMountedNudge", () => (parcelRequire("3iEb4")).addMountedNudge);
$parcel$export(module.exports, "removeMountedNudge", () => (parcelRequire("3iEb4")).removeMountedNudge);
$parcel$export(module.exports, "setShouldRenderComponent", () => (parcelRequire("7yDu9")).setShouldRenderComponent);
$parcel$export(module.exports, "setProjectState", () => (parcelRequire("5UBG2")).setProjectState);
$parcel$export(module.exports, "setHasNudgeActive", () => (parcelRequire("lHcRB")).setHasNudgeActive);
$parcel$export(module.exports, "forceHideNudge", () => (parcelRequire("eiyXc")).forceHideNudge);
$parcel$export(module.exports, "setHasEverSeenRoute", () => (parcelRequire("jZvbN")).setHasEverSeenRoute);
$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => (parcelRequire("azcAL")).setRoadmapIsCreateEnabled);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => (parcelRequire("azcAL")).setRoadmapIsListEmpty);
$parcel$export(module.exports, "openNextTask", () => (parcelRequire("gbXQ5")).openNextTask);
$parcel$export(module.exports, "resetIsQuickstartLoaded", () => (parcelRequire("iZuFy")).resetIsQuickstartLoaded);
$parcel$export(module.exports, "refreshAppStateUiStatusOnly", () => (parcelRequire("70Fss")).refreshAppStateUiStatusOnly);
$parcel$export(module.exports, "nextMarkAsCompletedTask", () => (parcelRequire("erLQY")).nextMarkAsCompletedTask);
$parcel$export(module.exports, "nextSetChecklistItemSeen", () => (parcelRequire("dQPsy")).nextSetChecklistItemSeen);
$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => (parcelRequire("abQXL")).nextSetChecklistIsDismissed);
$parcel$export(module.exports, "nextSetChecklistIsOpen", () => (parcelRequire("4VXxO")).nextSetChecklistIsOpen);
$parcel$export(module.exports, "nextOpenTask", () => (parcelRequire("cUGWT")).nextOpenTask);
$parcel$export(module.exports, "nextAutoExpand", () => (parcelRequire("boV1S")).nextAutoExpand);
$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => (parcelRequire("4Viq4")).nextShouldShowNudgeAfterNavigation);
$parcel$export(module.exports, "nextGetTasks", () => (parcelRequire("jIoq4")).nextGetTasks);
$parcel$export(module.exports, "syncVisibilityWithLocal", () => (parcelRequire("75A1x")).syncVisibilityWithLocal);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $6fSBR = parcelRequire("6fSBR");

var $j6wxT = parcelRequire("j6wxT");

var $7mZ3t = parcelRequire("7mZ3t");

var $8UXiA = parcelRequire("8UXiA");

var $3iEb4 = parcelRequire("3iEb4");

var $7yDu9 = parcelRequire("7yDu9");

var $5UBG2 = parcelRequire("5UBG2");

var $lHcRB = parcelRequire("lHcRB");

var $eiyXc = parcelRequire("eiyXc");

var $jZvbN = parcelRequire("jZvbN");

var $azcAL = parcelRequire("azcAL");

var $gbXQ5 = parcelRequire("gbXQ5");

var $iZuFy = parcelRequire("iZuFy");

var $70Fss = parcelRequire("70Fss");

var $erLQY = parcelRequire("erLQY");

var $dQPsy = parcelRequire("dQPsy");

var $abQXL = parcelRequire("abQXL");

var $4VXxO = parcelRequire("4VXxO");

var $cUGWT = parcelRequire("cUGWT");

var $boV1S = parcelRequire("boV1S");

var $4Viq4 = parcelRequire("4Viq4");

var $jIoq4 = parcelRequire("jIoq4");

var $75A1x = parcelRequire("75A1x");

});
parcelRegister("6fSBR", function(module, exports) {

$parcel$export(module.exports, "nextChangeTaskGroupParent", () => $0f1566e1d3fc2987$export$76708cce5888039a);
$parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", () => $0f1566e1d3fc2987$export$57534cbc400a434c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");
const $0f1566e1d3fc2987$var$setTaskGroup = (taskGroup)=>({ setState: setState })=>{
        setState({
            ...taskGroup,
            openTask: ''
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_TASK_GROUP),
            value: {
                taskGroup: taskGroup
            }
        });
    };
const $0f1566e1d3fc2987$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
        if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) // prevent infinite loop nesting
        return;
        previousTaskGroupParents.push(currentTaskGroupParent);
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newCurrentTaskGroupParent
        };
        dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup));
    };
const $0f1566e1d3fc2987$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
        const { previousTaskGroupParents: previousTaskGroupParents } = getState();
        const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $8Bc5A.ROOT_TASK) : previousTaskGroupParents.pop();
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newTaskGroupParent
        };
        // @ts-expect-error - TS2345 - Argument of type '{ previousTaskGroupParents: string[]; currentTaskGroupParent: string | undefined; }' is not assignable to parameter of type 'TaskGroup'.
        dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup));
    };

});
parcelRegister("1ftPQ", function(module, exports) {

$parcel$export(module.exports, "pushToBackend", () => $d3dd40bf54ad27bf$export$583b2d2422a6757f);

var $89SaW = parcelRequire("89SaW");

var $4Pf62 = parcelRequire("4Pf62");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");
const $d3dd40bf54ad27bf$var$getAccountId = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
    return atlassianAccountId;
};
const $d3dd40bf54ad27bf$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, $89SaW.setUserProperties)($d3dd40bf54ad27bf$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
    });
const $d3dd40bf54ad27bf$var$trySetUserProperties = async (props, attemptCount)=>{
    try {
        await $d3dd40bf54ad27bf$var$setRemoteUserProperties(props);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'pushToBackend',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'pushToBackend',
                actionSubject: 'jiraOnboardingChecklistCore',
                attemptCount: attemptCount,
                key: props.key,
                reason: error && error.message
            },
            error: error
        });
        return false;
    }
    return true;
};
const $d3dd40bf54ad27bf$export$583b2d2422a6757f = async (props)=>{
    const success = await $d3dd40bf54ad27bf$var$trySetUserProperties(props, 1);
    if (!success) // On failure retry - if retry fails data is lost.
    await $d3dd40bf54ad27bf$var$trySetUserProperties(props, 2);
};

});


parcelRegister("j6wxT", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $eefde484654068e9$export$dcf23146e0a40195);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $3B5jO = parcelRequire("3B5jO");
const $eefde484654068e9$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            }
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        // Delete code below when cleaning up isOpen in state
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: isOpen
        });
    };
var $eefde484654068e9$export$2e2bcd8739ae039 = $eefde484654068e9$export$dcf23146e0a40195;

});
parcelRegister("3B5jO", function(module, exports) {

$parcel$export(module.exports, "getQuickstartTypeSelector", () => $47424244d57f6abc$export$eae834ce0286017a);

var $2vSU6 = parcelRequire("2vSU6");

var $8Bc5A = parcelRequire("8Bc5A");
const $47424244d57f6abc$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
const $47424244d57f6abc$export$eae834ce0286017a = (state)=>{
    if ($47424244d57f6abc$export$6f17f2cb816105eb(state)) return (0, $8Bc5A.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
    return (0, $8Bc5A.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
};

});


parcelRegister("7mZ3t", function(module, exports) {

$parcel$export(module.exports, "refreshAppState", () => $ecf6e94ad9c4f8d6$export$797c35e2e1d0d014);

var $4R6GH = parcelRequire("4R6GH");


var $8fqy8 = parcelRequire("8fqy8");

var $8zOmE = parcelRequire("8zOmE");

var $bfWlw = parcelRequire("bfWlw");

var $ldyPw = parcelRequire("ldyPw");

var $8Bc5A = parcelRequire("8Bc5A");

var $6yhDy = parcelRequire("6yhDy");

var $1ftPQ = parcelRequire("1ftPQ");

var $52Vcw = parcelRequire("52Vcw");

var $ljzlb = parcelRequire("ljzlb");

var $3ORcf = parcelRequire("3ORcf");

var $6ypzr = parcelRequire("6ypzr");

var $4ji4w = parcelRequire("4ji4w");

var $abQXL = parcelRequire("abQXL");

var $4VXxO = parcelRequire("4VXxO");

var $erLQY = parcelRequire("erLQY");

var $6fSBR = parcelRequire("6fSBR");
const $ecf6e94ad9c4f8d6$var$allTasks = [
    ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks),
    ...(0, $8Bc5A.JSM_BUSINESS_TASKS)
];
const $ecf6e94ad9c4f8d6$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial, isTargetedForReverseTrials: isTargetedForReverseTrials, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const hasSeenTasks = [
            (0, $8Bc5A.convertToHaveSeenItTask)((0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK)),
            (0, $8Bc5A.convertToHaveSeenItTask)((0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)),
            (0, $8Bc5A.convertToHaveSeenItTask)((0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK))
        ];
        const { projectState: projectState = null } = getState();
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectType;
        let backendVisibilityKeys = [];
        let jsmTaskProjectKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).map((type)=>(0, $8Bc5A.getBackendVisibilityKey)(type));
        if (projectState?.projectId) jsmTaskProjectKeys = (0, $8Bc5A.JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
        const backendState = await (0, $6yhDy.pollBackend)({
            keys: [
                (0, $8Bc5A.KEY_OPEN),
                (0, $8Bc5A.KEY_DISMISSED),
                (0, $8Bc5A.KEY_OPEN_TASK),
                (0, $8Bc5A.KEY_TASK_GROUP),
                (0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $8Bc5A.KEY_JSW_ONBOARDING),
                (0, $8Bc5A.KEY_PREMIUM_TRIAL_REOPENED),
                ...$ecf6e94ad9c4f8d6$var$allTasks,
                ...hasSeenTasks,
                ...backendVisibilityKeys,
                ...jsmTaskProjectKeys
            ]
        });
        if (projectState && projectState.projectKey) updatedState.isDevOpsProject = await (0, $3ORcf.getIsDevOpsProject)(projectState.projectKey);
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks),
                    ...jsmTaskProjectKeys
                ].includes(key) && backendState[key] === true);
            updatedState.hasSeenTasks = hasSeenTasks.filter((key)=>backendState[key] === true);
            Object.values((0, $8Bc5A.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $8Bc5A.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $8Bc5A.getBackendVisibilityKey)(type)];
                else if ((0, $8Bc5A.KEY_DISMISSED) in backendState && backendState[0, $8Bc5A.KEY_DISMISSED]) updatedState.visibility[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $8Bc5A.KEY_OPEN] ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
                (0, $4ji4w.setLocalStorageItem)(`${type}.visibility`, updatedState.visibility[type]);
            });
            // Delete when cleaning up isDismissed in state
            if ((0, $8Bc5A.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $8Bc5A.KEY_DISMISSED];
            // Delete when cleaning up isOpen in state
            if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $8Bc5A.KEY_OPEN];
            if ((0, $8Bc5A.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $8Bc5A.KEY_OPEN_TASK];
            if ((0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $8Bc5A.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $8Bc5A.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] !== null && (0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe) in backendState[0, $8Bc5A.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $8Bc5A.KEY_JSW_ONBOARDING][0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe];
            }
        }
        // Important that this call is before the dismiss migration logic and the premium card permission migration, otherwise it would
        // override the dismiss and currentTaskGroupParent
        setState(updatedState);
        // Bit of a migration
        // Handles case where non-admin premium users have a premium card child open which they can no longer access as we added more permission checks
        // Or, if a user was on a premium trial and saw premium content but is now free,
        // We take them to the root instead
        if ((updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)) && !canEditPlans || (updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK) || updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)) && appEditions.software !== (0, $ldyPw.PREMIUM_EDITION)) {
            dispatch((0, $6fSBR.nextGoBackToPreviousTaskGroup)());
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState premiumCardPermissionsRevoked');
        }
        if (!(backendStateExists && (0, $8Bc5A.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $6ypzr.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $abQXL.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $52Vcw.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        const jswTrackDeferSitenameSiteTrait = await (0, $8fqy8.getJswTrackDeferSitenameSiteTrait)(cloudId, {
            packageName: (0, $8Bc5A.PACKAGE_NAME),
            teamName: (0, $8Bc5A.PACKAGE_TEAM_NAME)
        });
        setState({
            isEligibleToUpdateSitename: jswTrackDeferSitenameSiteTrait?.value === 'experiment-generated-site-name'
        });
        const setPremiumCardAudienceTrait = async (accountId)=>{
            if (accountId === null) return;
            const trait = await (0, $ljzlb.getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
            setState({
                isCrossProjectBoardToPlanUpsell: trait?.value === true || false
            });
        };
        // We only want to check if a non-admin user has the CPB trait if they are in a
        // premium evaluation of jira software (i.e. they have access to Advanced Roadmaps)
        if (appEditions.software === (0, $ldyPw.PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
        const { isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell } = getState();
        // If the user is on a JSW Premium instance, perform a fetch to check that they signed up with a Premium Reverse Trial.
        let isReverseTrialForJSW;
        if (isTargetedForReverseTrials && (0, $4R6GH.fg)('jsw_reverse_trials_feature_gate')) {
            const isOnboardingPremiumTrial = await (0, $bfWlw.getOnboardingPremiumTrial)();
            isReverseTrialForJSW = isOnboardingPremiumTrial?.premiumTrialOnSignup;
        }
        /**
		 * Re-open QS for:
		 *  - admins on an AdvancedRoadmaps trial who haven't had it re-opened for them yet
		 *  - non-admins on an AdvancedRoadmaps trial with isCrossProjectBoardToPlanUpsell trait
		 */ if (!isReverseTrialForJSW && appEditions.software === (0, $ldyPw.PREMIUM_EDITION) && isAdvancedRoadmapsTrial && (isAdmin || isCrossProjectBoardToPlanUpsell) && atlassianAccountId != null && !backendState[0, $8Bc5A.KEY_PREMIUM_TRIAL_REOPENED]) {
            // Re-open QS if not already opened
            dispatch((0, $4VXxO.nextSetChecklistIsOpen)(true));
            dispatch((0, $abQXL.nextSetChecklistIsDismissed)(false));
            const taskToDispatch = isAdmin ? (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK) : (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN);
            // Go to advanced roadmaps task
            dispatch((0, $erLQY.nextMarkAsCompletedTask)(taskToDispatch));
            dispatch((0, $6fSBR.nextChangeTaskGroupParent)(taskToDispatch));
            await (0, $1ftPQ.pushToBackend)({
                key: (0, $8Bc5A.KEY_PREMIUM_TRIAL_REOPENED),
                value: true
            });
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'advancedRoadmapsTask reopened', {
                isAdmin: isAdmin
            });
        }
        setState({
            canEditPlans: canEditPlans
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $6784cbc7d62e5d7c$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$6e69f8dc03075ef8 = 'team-type';
const $6784cbc7d62e5d7c$export$c06666264cd35603 = 'team-type-shorthand';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $6784cbc7d62e5d7c$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $6784cbc7d62e5d7c$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$f93b83d735f01fa3 = 'pagesCreatePageNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $6784cbc7d62e5d7c$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $6784cbc7d62e5d7c$export$699265ec8ad9a740 = 'Software Development';
const $6784cbc7d62e5d7c$export$e07d1fa2da8ed874 = 'Customer Service';
const $6784cbc7d62e5d7c$export$76dcec3f438d9e56 = 'IT Support';
const $6784cbc7d62e5d7c$export$9a574c301f67ba30 = 'Human Resources';
const $6784cbc7d62e5d7c$export$363ec144a94029c8 = 'Finance';
const $6784cbc7d62e5d7c$export$df0fb32d68ae1e78 = 'Legal';
const $6784cbc7d62e5d7c$export$d9c0e3e59442fb4 = 'Marketing';
const $6784cbc7d62e5d7c$export$27dbc7d7ce66e6e3 = 'Operations';
const $6784cbc7d62e5d7c$export$a5dce388adf922bd = 'Sales';
const $6784cbc7d62e5d7c$export$e1473b31a257caff = 'Data Science';
const $6784cbc7d62e5d7c$export$85657457db93c2c2 = 'Product Management';
const $6784cbc7d62e5d7c$export$c0c2d1dfaeba89dd = 'Project Management';
const $6784cbc7d62e5d7c$export$2e6a7ad3ab9c82a3 = 'Design';
const $6784cbc7d62e5d7c$export$7b60378c3b4372e9 = 'Other or Personal';
const $6784cbc7d62e5d7c$export$572242e58bd07594 = 'CS';
const $6784cbc7d62e5d7c$export$d7de553940261eba = 'ITS';
const $6784cbc7d62e5d7c$export$4c29d0d04c15e55d = 'HR';
const $6784cbc7d62e5d7c$export$3950f7f841bf94b6 = 'FNC';
const $6784cbc7d62e5d7c$export$881249b988b6030f = 'LGL';
const $6784cbc7d62e5d7c$export$e4824f74b9879164 = 'MKT';
const $6784cbc7d62e5d7c$export$4f3cb0844009af52 = 'OPS';
const $6784cbc7d62e5d7c$export$1a65d50c4a641bb4 = 'SAL';
const $6784cbc7d62e5d7c$export$9ee64e8fbd8b03a2 = 'DS';
const $6784cbc7d62e5d7c$export$b8b1ac856ba1434b = 'DEV';
const $6784cbc7d62e5d7c$export$4f54a09a24fd1d74 = 'PDM';
const $6784cbc7d62e5d7c$export$79685802e8ff1098 = 'PJM';
const $6784cbc7d62e5d7c$export$e5c438b7501b5a24 = 'DES';
const $6784cbc7d62e5d7c$export$cbc0e551d91a692d = 'OTR';

parcelRegister("8fqy8", function(module, exports) {

$parcel$export(module.exports, "getSignupTrackDeferSitenameUserTrait", () => $77364531dfabe700$export$686752df505238be);
$parcel$export(module.exports, "getJswTrackDeferSitenameSiteTrait", () => $77364531dfabe700$export$6da79f996c267010);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $77364531dfabe700$var$PERSONALIZATION_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $77364531dfabe700$var$SITE_PERSONALIZATION_ENDPOINT = `${$77364531dfabe700$var$PERSONALIZATION_ENDPOINT}/site/`;
const $77364531dfabe700$var$USER_PERSONALIZATION_ENDPOINT = `${$77364531dfabe700$var$PERSONALIZATION_ENDPOINT}/user/`;
const $77364531dfabe700$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT = 'marketing-signup_track_deferred-sitename_signup_server_enrollment';
const $77364531dfabe700$var$JSW_TRACK_DEFER_SITENAME_TRAIT = 'jira_track_instance_created_server_defer_site_rename_cohort';
const $77364531dfabe700$var$fetchPersonalization = (endpoint, subject)=>async (id, meta)=>{
        try {
            const url = endpoint + id;
            return await (0, $eusud.performGetRequest)(url);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'onboarding',
                    teamName: 'jlove-makkuro',
                    ...meta
                },
                attributes: {
                    subject: subject
                },
                error: error
            });
            return undefined;
        }
    };
const $77364531dfabe700$var$getTraits = (fetch, traitName)=>async (id, meta)=>{
        const personalization = await fetch(id, meta);
        return personalization?.attributes?.find((att)=>att.name === traitName);
    };
const $77364531dfabe700$export$686752df505238be = $77364531dfabe700$var$getTraits($77364531dfabe700$var$fetchPersonalization($77364531dfabe700$var$USER_PERSONALIZATION_ENDPOINT, 'fetchUserPersonalization'), $77364531dfabe700$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT);
const $77364531dfabe700$export$6da79f996c267010 = $77364531dfabe700$var$getTraits($77364531dfabe700$var$fetchPersonalization($77364531dfabe700$var$SITE_PERSONALIZATION_ENDPOINT, 'fetchSitePersonalization'), $77364531dfabe700$var$JSW_TRACK_DEFER_SITENAME_TRAIT);

});

parcelRegister("bfWlw", function(module, exports) {

$parcel$export(module.exports, "getOnboardingPremiumTrialWithRethrow", () => $a55f3307b43c0521$export$d9a9dd6206da5bef);
$parcel$export(module.exports, "getOnboardingPremiumTrial", () => $a55f3307b43c0521$export$ef676f7f369f74fe);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $6c7t9 = parcelRequire("6c7t9");
const $a55f3307b43c0521$var$endpoint = '/rest/onboarding/1.0/premium-trial';
const $a55f3307b43c0521$export$d9a9dd6206da5bef = async ()=>{
    try {
        // Attempt to get from localStorage
        const localStorageOnboardingPremiumTrial = (0, $6c7t9.localStorageGetOnboardingPremiumTrial)();
        const localStorageOnboardingPremiumTrialCohort = (0, $6c7t9.localStorageGetOnboardingPremiumTrialCohort)();
        if (typeof localStorageOnboardingPremiumTrial === 'boolean' && typeof localStorageOnboardingPremiumTrialCohort === 'string') return {
            premiumTrialOnSignup: localStorageOnboardingPremiumTrial,
            reverseTrialCohort: localStorageOnboardingPremiumTrialCohort
        };
        const response = await (0, $eusud.performGetRequestWithRetry)($a55f3307b43c0521$var$endpoint);
        const premiumTrialOnSignup = response?.premiumTrialOnSignup;
        const reverseTrialCohort = response?.reverseTrialCohort;
        if (typeof premiumTrialOnSignup === 'boolean' && typeof reverseTrialCohort === 'string') {
            // Set into localStorage
            (0, $6c7t9.localStorageSetOnboardingPremiumTrial)(premiumTrialOnSignup);
            (0, $6c7t9.localStorageSetOnboardingPremiumTrialCohort)(reverseTrialCohort);
            return {
                premiumTrialOnSignup: premiumTrialOnSignup,
                reverseTrialCohort: reverseTrialCohort
            };
        }
        throw new Error('response?.premiumTrialOnSignup or response?.reverseTrialCohort is undefined');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getOnboardingPremiumTrialWithRethrow',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $a55f3307b43c0521$export$ef676f7f369f74fe = async ()=>{
    try {
        return await $a55f3307b43c0521$export$d9a9dd6206da5bef();
    } catch (e) {
    // ignored
    }
};

});
parcelRegister("6c7t9", function(module, exports) {

$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrial", () => $fab9df2877e9db77$export$782df5489e5cfd1e);
$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrialCohort", () => $fab9df2877e9db77$export$c3378895d06b5528);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrial", () => $fab9df2877e9db77$export$f83a7a49524e74ad);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrialCohort", () => $fab9df2877e9db77$export$f389f8ca168b4a3a);

var $bSSG7 = parcelRequire("bSSG7");

var $jcw0u = parcelRequire("jcw0u");
const $fab9df2877e9db77$export$3538ee3f5c6c8b5c = 'premiumTrialOnSignup';
const $fab9df2877e9db77$export$2f93fdc3330233dc = 'reverseTrialCohort';
const $fab9df2877e9db77$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('jsw-onboarding-premium-reverse-trial');
const $fab9df2877e9db77$export$782df5489e5cfd1e = ()=>{
    try {
        const value = $fab9df2877e9db77$var$localStorage.get($fab9df2877e9db77$export$3538ee3f5c6c8b5c);
        // localStorage.get is able to return proper booleans and not stringified booleans like "true"/"false"
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $fab9df2877e9db77$export$c3378895d06b5528 = ()=>{
    try {
        const value = $fab9df2877e9db77$var$localStorage.get($fab9df2877e9db77$export$2f93fdc3330233dc);
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $fab9df2877e9db77$export$f83a7a49524e74ad = (premiumTrialOnSignup)=>{
    try {
        $fab9df2877e9db77$var$localStorage.set($fab9df2877e9db77$export$3538ee3f5c6c8b5c, premiumTrialOnSignup);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $fab9df2877e9db77$export$f389f8ca168b4a3a = (reverseTrialCohort)=>{
    try {
        $fab9df2877e9db77$var$localStorage.set($fab9df2877e9db77$export$2f93fdc3330233dc, reverseTrialCohort);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});


parcelRegister("6yhDy", function(module, exports) {

$parcel$export(module.exports, "pollBackend", () => $760653e5a4f27459$export$8420ef0cee98de);

var $1sYcL = parcelRequire("1sYcL");

var $g5X3G = parcelRequire("g5X3G");

var $8Bc5A = parcelRequire("8Bc5A");
const $760653e5a4f27459$export$8420ef0cee98de = async ({ keys: keys })=>{
    const { user: user } = await (0, $1sYcL.get)((0, $g5X3G.toBaseUrl)(''), {
        userProperties: keys,
        consumerMeta: {
            id: 'fetchUserProperties',
            packageName: (0, $8Bc5A.PACKAGE_NAME),
            teamName: (0, $8Bc5A.PACKAGE_TEAM_NAME)
        }
    });
    return user;
};

});
parcelRegister("1sYcL", function(module, exports) {

$parcel$export(module.exports, "get", () => $7fc92c544211ac93$export$3988ae62b71be9a3);

var $lbWm4 = parcelRequire("lbWm4");

var $3T6Xo = parcelRequire("3T6Xo");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

var $fjcgS = parcelRequire("fjcgS");

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");
let $7fc92c544211ac93$var$ufoExperiencesMap = {};
const $7fc92c544211ac93$var$getUfoExperience = (key)=>{
    if (!$7fc92c544211ac93$var$ufoExperiencesMap[key]) $7fc92c544211ac93$var$ufoExperiencesMap[key] = new (0, $kkzI0.UFOExperience)(key, {
        type: (0, $lrUJ4.ExperienceTypes).Operation,
        performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom
    });
    return $7fc92c544211ac93$var$ufoExperiencesMap[key];
};
const $7fc92c544211ac93$export$c907f169d33b2e25 = ()=>{
    $7fc92c544211ac93$var$ufoExperiencesMap = {};
};
const $7fc92c544211ac93$export$a5b7a8c3b1c6e775 = (baseUrl, { userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
    const params = new URLSearchParams();
    userProperties && params.append('user', userProperties.join(','));
    projectId !== undefined && params.append('projectId', projectId);
    projectProperties && params.append('project', projectProperties.join(','));
    instanceProperties && params.append('instance', instanceProperties.join(','));
    return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7fc92c544211ac93$var$patchProperties = (response, propertiesPath)=>((0, $4R6GH.fg)('handle_null_response_for_fe_config_properties_call') ? response : true) && (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(response[propertiesPath], (value, prop)=>{
        try {
            response[propertiesPath][prop] = JSON.parse(value);
        } catch (error) {
            // TODO: Endpoint should ideally only return stringified values
            if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
            else throw error;
        }
    });
const $7fc92c544211ac93$export$3988ae62b71be9a3 = async (baseUrl, options)=>{
    const ufoExperience = $7fc92c544211ac93$var$getUfoExperience(`${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(options.consumerMeta.packageName)}.${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(options.consumerMeta.id)}`);
    try {
        ufoExperience?.start();
        const url = $7fc92c544211ac93$export$a5b7a8c3b1c6e775(baseUrl, options);
        const response = await (0, $eusud.performGetRequest)(url);
        if (response === null) (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                action: 'succeeded',
                actionSubject: 'jiraCommonRestInternalLatest.getConfigProperties',
                source: 'frontendConfigProperties',
                attributes: {
                    package: consumerMeta.packageName,
                    id: consumerMeta.id,
                    isNullResponse: true
                }
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        $7fc92c544211ac93$var$patchProperties(response, 'user');
        $7fc92c544211ac93$var$patchProperties(response, 'instance');
        $7fc92c544211ac93$var$patchProperties(response, 'project');
        const { consumerMeta: consumerMeta } = options;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'frontendConfigProperties',
                action: 'success',
                actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        ufoExperience?.success();
        return (0, $4R6GH.fg)('handle_null_response_for_fe_config_properties_call') ? response || {
            user: {},
            instance: {},
            project: {}
        } : response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const { consumerMeta: consumerMeta } = options;
        !(0, $fZneA.isClientFetchError)(error) && (0, $jcw0u.default)({
            error: error,
            meta: {
                id: consumerMeta.id,
                packageName: consumerMeta.packageName,
                teamName: consumerMeta.teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
        ufoExperience?.failure();
        throw error;
    }
};

});


parcelRegister("52Vcw", function(module, exports) {

$parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", () => $5dab66e6da9554ae$export$c98a6ee6aadb8055);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", () => $5dab66e6da9554ae$export$45d8c76e0490b3ec);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", () => $5dab66e6da9554ae$export$b1be4ae35a43115d);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", () => $5dab66e6da9554ae$export$fa4f266bd2444d14);
$parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", () => $5dab66e6da9554ae$export$a68a2e5a69c8cd74);
$parcel$export(module.exports, "fireAPIErrorAnalytics", () => $5dab66e6da9554ae$export$a4d7f1a52677d339);
$parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", () => $5dab66e6da9554ae$export$160bb78a3b11a5a9);
$parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", () => $5dab66e6da9554ae$export$6ccbe54cd3a5a12);
$parcel$export(module.exports, "fireAnalyticsOnCloseRightHandSidebar", () => $5dab66e6da9554ae$export$6c39ca65ca354e59);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $8Bc5A = parcelRequire("8Bc5A");

var $izv86 = parcelRequire("izv86");
const $5dab66e6da9554ae$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
    analyticsEvent.update({
        action: 'closed',
        actionSubject: 'button'
    });
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button closed', (0, $8Bc5A.ACTION_SUBJECT_ID), attributes);
};
const $5dab66e6da9554ae$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
    if (source === 'button') (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
    else if (source === 'checklist') (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
};
const $5dab66e6da9554ae$export$b1be4ae35a43115d = (analyticsEvent)=>{
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
};
const $5dab66e6da9554ae$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $5dab66e6da9554ae$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, $izv86.convertTaskIdToActionSubjectId)(completedTaskId), {
        taskId: completedTaskId
    });
};
const $5dab66e6da9554ae$export$a4d7f1a52677d339 = (error, endpointSource)=>{
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: 'quickstartApiError',
            packageName: 'jiraOnboardingQuickstartCore',
            teamName: 'jlove-makkuro'
        },
        attributes: {
            error: error.message,
            endpointSource: endpointSource
        }
    });
};
const $5dab66e6da9554ae$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $5dab66e6da9554ae$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $5dab66e6da9554ae$export$6c39ca65ca354e59 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart closeRightSidebar', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};

});
parcelRegister("izv86", function(module, exports) {

$parcel$export(module.exports, "getProductType", () => $4725f5ccfabd2231$export$27e53caf66bae1d);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => $4725f5ccfabd2231$export$3b914201960fa7a6);

var $e4eHl = parcelRequire("e4eHl");

var $2vSU6 = parcelRequire("2vSU6");
const $4725f5ccfabd2231$export$d64a7dd8c7cd80e0 = {
    [(0, $2vSU6.CORE_PROJECT)]: 'workManagement',
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'serviceManagement'
};
const $4725f5ccfabd2231$export$27e53caf66bae1d = (projectType)=>{
    if (projectType) return $4725f5ccfabd2231$export$d64a7dd8c7cd80e0[projectType] || (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(projectType);
    return null;
};
const $4725f5ccfabd2231$export$3b914201960fa7a6 = (taskId)=>{
    if (!taskId) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(taskId.split('.').pop());
};

});


parcelRegister("ljzlb", function(module, exports) {

$parcel$export(module.exports, "getCrossProjectBoardTrait", () => $9217b5bb53dd29c2$export$7f2186c37a3d095d);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");

var $8Bc5A = parcelRequire("8Bc5A");

var $k9OK8 = parcelRequire("k9OK8");
const $9217b5bb53dd29c2$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
const $9217b5bb53dd29c2$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $9217b5bb53dd29c2$var$ONE_DAY = 86400000;
const $9217b5bb53dd29c2$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
    try {
        const url = `${$9217b5bb53dd29c2$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
        const result = await (0, $eusud.performGetRequest)(url);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
            synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $8Bc5A.PACKAGE_NAME),
                teamName: (0, $8Bc5A.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: error.message,
                endpointSource: 'getJSWCrossProjectBoardTrait',
                synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            attributes: []
        };
    }
};
const $9217b5bb53dd29c2$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
    const { get: get, persist: persist } = (0, $k9OK8.crossProjectBoardTraitSessionStorageProvider)();
    // Check session storage
    const sessionStorage = get();
    if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $9217b5bb53dd29c2$var$ONE_DAY) {
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
            synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
        });
        return sessionStorage.attribute;
    }
    // Fetch from personalization
    const personalization = await $9217b5bb53dd29c2$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
    const attribute = personalization.attributes.find((att)=>att.name === $9217b5bb53dd29c2$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
    if (attribute !== undefined) persist({
        attribute: attribute,
        date: Date.now(),
        userId: userId,
        siteId: siteId
    });
    return attribute;
};

});
parcelRegister("k9OK8", function(module, exports) {

$parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", () => $ee27e8acf854e0ab$export$99f3e48748c2a8c3);

var $eNf8a = parcelRequire("eNf8a");

const $ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider = (0, $eNf8a.createSessionExpirableStorageProvider)((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a));
const $ee27e8acf854e0ab$export$99f3e48748c2a8c3 = ()=>{
    const persist = (toPersist)=>{
        $ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider.set((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a), toPersist);
    };
    const get = ()=>$ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider.get((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a));
    return {
        get: get,
        persist: persist
    };
};

});
parcelRegister("eNf8a", function(module, exports) {

$parcel$export(module.exports, "createSessionStorageProvider", () => $b98f887ad675a269$export$a922b987e648d2fa);
$parcel$export(module.exports, "createSessionExpirableStorageProvider", () => $b98f887ad675a269$export$e0a2e9a062c6a695);

var $gJBT6 = parcelRequire("gJBT6");

var $fNVZf = parcelRequire("fNVZf");

var $j9Vq5 = parcelRequire("j9Vq5");
const $b98f887ad675a269$export$a922b987e648d2fa = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix)=>(0, $fNVZf.createStorageProvider)((0, $fNVZf.WebStorageType).SessionStorage, appPrefix, (0, $j9Vq5.makeSessionStore)()));
const $b98f887ad675a269$export$e0a2e9a062c6a695 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    return (0, $fNVZf.createExpirableStorageProvider)((0, $fNVZf.WebStorageType).SessionStorage, appPrefix, (0, $j9Vq5.makeSessionExpirableStore)());
});

});
parcelRegister("j9Vq5", function(module, exports) {

$parcel$export(module.exports, "makeSessionStore", () => $93ac2abe604287b3$export$fb690882d627b3b5);
$parcel$export(module.exports, "makeSessionExpirableStore", () => $93ac2abe604287b3$export$a8f626c8ded9a06c);

var $fKgem = parcelRequire("fKgem");

var $kzObv = parcelRequire("kzObv");

var $c4CII = parcelRequire("c4CII");

var $2NjNT = parcelRequire("2NjNT");

var $c74za = parcelRequire("c74za");

var $fNVZf = parcelRequire("fNVZf");
const $93ac2abe604287b3$export$fb690882d627b3b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($c74za))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], (0, $fNVZf.plugins));
const $93ac2abe604287b3$export$a8f626c8ded9a06c = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c4CII))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($c74za))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2NjNT)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($fKgem))),
        (0, (/*@__PURE__*/$parcel$interopDefault($kzObv)))
    ]);

});


const $111ca51573c84ae8$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';



parcelRegister("3ORcf", function(module, exports) {

$parcel$export(module.exports, "getIsDevOpsProject", () => $d5d39abfab8df073$export$88ee873472aa9bb7);

var $8Bc5A = parcelRequire("8Bc5A");
const $d5d39abfab8df073$var$projectPropertyUrl = (projectKey)=>`/rest/api/2/project/${projectKey}/properties/${0, $8Bc5A.KEY_IS_DEVOPS_PROJECT}`;
const $d5d39abfab8df073$export$88ee873472aa9bb7 = async (projectKey)=>{
    const url = $d5d39abfab8df073$var$projectPropertyUrl(projectKey);
    const response = await fetch(url);
    if (response.ok) {
        const result = await response.json();
        return result.value;
    }
    return false;
};

});

parcelRegister("6ypzr", function(module, exports) {

$parcel$export(module.exports, "getOnboardingSkipApplicationProperty", () => $98fe78eb4dc2e758$export$980c26b6f100081d);

var $eusud = parcelRequire("eusud");
const $98fe78eb4dc2e758$export$980c26b6f100081d = ()=>(0, $eusud.performGetRequest)('/rest/onboarding/1.0/skip');

});

parcelRegister("4ji4w", function(module, exports) {

$parcel$export(module.exports, "getNextNonCompleteTask", () => $af696889329ec63a$export$b61dc70e2ed3fae3);
$parcel$export(module.exports, "getNextTask", () => $af696889329ec63a$export$404421ce8f3cbf9a);
$parcel$export(module.exports, "setLocalStorageItem", () => $af696889329ec63a$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $af696889329ec63a$export$93d719890ad66653);

var $bSSG7 = parcelRequire("bSSG7");

var $aFsRe = parcelRequire("aFsRe");
const $af696889329ec63a$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
    const taskPosition = (0, $aFsRe.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const start = taskPosition === -1 ? 0 : taskPosition;
    const len = tasks.length;
    // This loop:
    // 1) searches for non completed items from the start index to last index of the array
    // 2) searches from 0 until start if nothing was found during 1)
    for(let i = start; i < start + len; i += 1){
        const ind = i % len;
        if (!completed.includes(tasks[ind])) return tasks[ind];
    }
    // nothing was found there is no task to open
    return null;
};
const $af696889329ec63a$export$404421ce8f3cbf9a = (tasks, openTask)=>{
    const taskPosition = (0, $aFsRe.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const ind = taskPosition === -1 ? 0 : taskPosition;
    return tasks[ind] ? tasks[ind] : null;
};
const $af696889329ec63a$var$store = (0, $bSSG7.createLocalStorageProvider)('quickstart');
const $af696889329ec63a$export$5aa524d86254b4f = (key, value)=>{
    $af696889329ec63a$var$store.set(key, value);
};
const $af696889329ec63a$export$93d719890ad66653 = (key)=>$af696889329ec63a$var$store.get(key);

});
parcelRegister("aFsRe", function(module, exports) {

$parcel$export(module.exports, "getTaskIndex", () => $856e0575daef172f$export$9ba3adcb1954c00);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForShowMe", () => $856e0575daef172f$export$9711f11998d5795c);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForLink", () => $856e0575daef172f$export$995248f3b43d8505);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForCta", () => $856e0575daef172f$export$293f6b2affa6ea5a);

var $izv86 = parcelRequire("izv86");







const $856e0575daef172f$export$9ba3adcb1954c00 = (taskList, taskId)=>{
    if (!taskList || taskId === null) return -1;
    return taskList.indexOf(taskId) + 1;
};
const $856e0575daef172f$export$9711f11998d5795c = (taskId)=>`${(0, $izv86.convertTaskIdToActionSubjectId)(taskId)}ShowMe`;
const $856e0575daef172f$export$995248f3b43d8505 = (taskId)=>`${(0, $izv86.convertTaskIdToActionSubjectId)(taskId)}Link`;
const $856e0575daef172f$export$293f6b2affa6ea5a = (taskId)=>`${(0, $izv86.convertTaskIdToActionSubjectId)(taskId)}Cta`;

});


parcelRegister("abQXL", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => $dc09dffee9419aae$export$f24c05f83b880547);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");
const $dc09dffee9419aae$export$f24c05f83b880547 = (isDismissed)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const currentIsDismissed = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED;
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        const quickstartStatus = isDismissed ? (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED : (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            isFocusedOn: !isDismissed
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $4ji4w.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isDismissed in state
        if (isDismissed === false) // When setting IsDismissed to false, also setting QS status to OPEN so checklist appears in open state
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: true
        });
        else // When setting IsDismissed, also toggle the open state of the checklist to match.
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: false
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_DISMISSED),
            value: isDismissed
        });
    };

});

parcelRegister("4VXxO", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsOpen", () => $7815e3bf96163d46$export$4249eabbb34e2e69);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");
const $7815e3bf96163d46$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
        const currentIsMinimised = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
        if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            hasNudgeActive: false,
            isFocusedOn: isOpen
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $4ji4w.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isOpen in state
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: isOpen
        });
    };

});

parcelRegister("erLQY", function(module, exports) {

$parcel$export(module.exports, "nextMarkAsCompletedTask", () => $f082da41253fd664$export$d6628d41a3bec42d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1ftPQ = parcelRequire("1ftPQ");
const $f082da41253fd664$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
        // When a task is complete:
        // Check to see if the task is complete in the completedKeys already
        // update the checklist dict (maybe should be at a different point or use setState)
        const { completedTaskList: completedTaskList } = getState();
        if (completedTaskList.includes(taskId)) return;
        // update the backend with the KEY and true
        (0, $1ftPQ.pushToBackend)({
            key: taskId,
            value: true
        });
        // update itemsList to reflect checked status. clone -> update -> override
        setState({
            completedTaskList: [
                ...completedTaskList,
                taskId
            ]
        });
    };

});


parcelRegister("8UXiA", function(module, exports) {

$parcel$export(module.exports, "setNudgeStep", () => $2d15900fae273e3c$export$4debc323813b6997);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2d15900fae273e3c$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { nudgeStep: nudgeStep } = getState();
        if (nudge === nudgeStep) return;
        setState({
            nudgeStep: nudge
        });
    };
var $2d15900fae273e3c$export$2e2bcd8739ae039 = $2d15900fae273e3c$export$4debc323813b6997;

});

parcelRegister("3iEb4", function(module, exports) {

$parcel$export(module.exports, "addMountedNudge", () => $d23aba2b0749d2be$export$92a89c32d0ea3943);
$parcel$export(module.exports, "removeMountedNudge", () => $d23aba2b0749d2be$export$748f4cda8ab98c91);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d23aba2b0749d2be$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already added
        if (mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: [
                ...mountedNudges,
                nudge
            ]
        });
    };
const $d23aba2b0749d2be$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already removed
        if (!mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
        });
    };

});

parcelRegister("7yDu9", function(module, exports) {

$parcel$export(module.exports, "setShouldRenderComponent", () => $e7988e1b8f7782bd$export$1f9c6770ed938b6e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e7988e1b8f7782bd$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is shouldRenderComponent */ const { shouldRenderComponent: currentShouldRenderComponent } = getState();
        if (shouldRenderComponent === currentShouldRenderComponent) // if state has not been updated we just return
        return;
        setState({
            shouldRenderComponent: shouldRenderComponent
        });
    };
var $e7988e1b8f7782bd$export$2e2bcd8739ae039 = $e7988e1b8f7782bd$export$1f9c6770ed938b6e;

});

parcelRegister("5UBG2", function(module, exports) {

$parcel$export(module.exports, "setProjectState", () => $72dc29ca0b198f0e$export$1ba498e440c0a1e4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $72dc29ca0b198f0e$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
        setState({
            projectState: projectState
        });
    };
var $72dc29ca0b198f0e$export$2e2bcd8739ae039 = $72dc29ca0b198f0e$export$1ba498e440c0a1e4;

});

parcelRegister("lHcRB", function(module, exports) {

$parcel$export(module.exports, "setHasNudgeActive", () => $4ecbca1b06d3bc5e$export$497c281e6eb0786e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $4ecbca1b06d3bc5e$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is currentHasNudgeActive */ const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
        if (hasNudgeActive === currentHasNudgeActive) // if state has not been updated we just return
        return;
        if (hasNudgeActive === false && itemName !== openTask) // do not update a nudge if the current open task is different than the one we called the function with
        return;
        setState({
            hasNudgeActive: hasNudgeActive
        });
    };
var $4ecbca1b06d3bc5e$export$2e2bcd8739ae039 = $4ecbca1b06d3bc5e$export$497c281e6eb0786e;

});

parcelRegister("eiyXc", function(module, exports) {

$parcel$export(module.exports, "forceHideNudge", () => $7ab5d12e3e83c16f$export$6d1ed97b83a62e8e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
// We use this action in cases where we want to hide the nudge no matter what.
const $7ab5d12e3e83c16f$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
        setState({
            hasNudgeActive: false
        });
    };

});

parcelRegister("jZvbN", function(module, exports) {

$parcel$export(module.exports, "setHasEverSeenRoute", () => $bde38543b00c29f3$export$28e0a4314a1ce52f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");
const $bde38543b00c29f3$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
        const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
        const somethingHasBeenUpdated = Object.keys(update).some(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap", boolean>>'.
        (key)=>update[key] !== currentHasEverSeenRoute[key]);
        if (!somethingHasBeenUpdated) return;
        const newHasEverSeenRoute = {
            ...currentHasEverSeenRoute,
            ...update
        };
        setState({
            hasEverSeenRoute: newHasEverSeenRoute
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE),
            value: newHasEverSeenRoute
        });
    };
var $bde38543b00c29f3$export$2e2bcd8739ae039 = $bde38543b00c29f3$export$28e0a4314a1ce52f;

});

parcelRegister("azcAL", function(module, exports) {

$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => $f19987e3027503ab$export$35ea35d1a8e07307);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => $f19987e3027503ab$export$932967764e7a0b31);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $f19987e3027503ab$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
        // skip store update if no state change
        if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
        setState({
            roadmapIsCreateEnabled: roadmapIsCreateEnabled
        });
    };
const $f19987e3027503ab$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
        // skip store update if no state change
        if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
        setState({
            roadmapIsListEmpty: roadmapIsListEmpty
        });
    };

});

parcelRegister("gbXQ5", function(module, exports) {

$parcel$export(module.exports, "openNextTask", () => $460159056a360dfc$export$867dbb6d61569ae9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4ji4w = parcelRequire("4ji4w");

var $cUGWT = parcelRequire("cUGWT");
const $460159056a360dfc$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { openTask: openTask, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        const taskIdToExpand = (0, $4ji4w.getNextTask)(items, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $cUGWT.nextOpenTask)(taskIdToExpand));
    };

});
parcelRegister("cUGWT", function(module, exports) {

$parcel$export(module.exports, "nextOpenTask", () => $f8b3135a172025f8$export$5deb889489d2f989);
$parcel$export(module.exports, "nextAutoOpenTask", () => $f8b3135a172025f8$export$cc5f3544a6cb2922);


var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $8UXiA = parcelRequire("8UXiA");

var $lHcRB = parcelRequire("lHcRB");
const $f8b3135a172025f8$var$openTask = (taskId)=>({ setState: setState })=>{
        setState({
            openTask: taskId
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN_TASK),
            value: taskId
        });
    };
const $f8b3135a172025f8$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
        dispatch($f8b3135a172025f8$var$openTask(taskId));
        const { completedTaskList: completedTaskList } = getState();
        const taskIsCompleted = completedTaskList.includes(taskId);
        const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
        if (closeNudge) dispatch((0, $lHcRB.setHasNudgeActive)(false, taskId));
        else dispatch((0, $lHcRB.setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
        // This is a temporary solution for Scrum Onboarding.
        // See https://hello.atlassian.net/wiki/spaces/agile/pages/1321008806/Draft+Quickstart+Nudge+Interaction for details
        if (taskIdExistsAndIsNotCompleted && taskId === (0, $8Bc5A.SCRUM_ONBOARDING_TASK)) dispatch((0, $8UXiA.setNudgeStep)((0, $6784cbc7d62e5d7c$export$b1a6ab17737f33e)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $8Bc5A.KANBAN_ONBOARDING_TASK)) dispatch((0, $8UXiA.setNudgeStep)((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $8Bc5A.ADD_COLUMNS_TASK)) dispatch((0, $8UXiA.setNudgeStep)((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)));
        else dispatch((0, $8UXiA.setNudgeStep)(''));
    };
const $f8b3135a172025f8$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
        dispatch($f8b3135a172025f8$var$openTask(taskId));
        dispatch((0, $lHcRB.setHasNudgeActive)(false, taskId));
        dispatch((0, $8UXiA.setNudgeStep)(''));
    };

});


parcelRegister("iZuFy", function(module, exports) {

$parcel$export(module.exports, "resetIsQuickstartLoaded", () => $b50ce46f86d3e3d7$export$bda085a823763e5a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $3B5jO = parcelRequire("3B5jO");
const $b50ce46f86d3e3d7$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED
            },
            hasNudgeActive: false,
            isQuickstartLoaded: false
        });
    };

});

parcelRegister("70Fss", function(module, exports) {

$parcel$export(module.exports, "refreshAppStateUiStatusOnly", () => $f0fdda8951af3bde$export$87fe8079a4ed9766);


var $8Bc5A = parcelRequire("8Bc5A");

var $6yhDy = parcelRequire("6yhDy");

var $52Vcw = parcelRequire("52Vcw");

var $6ypzr = parcelRequire("6ypzr");

var $abQXL = parcelRequire("abQXL");
const $f0fdda8951af3bde$export$87fe8079a4ed9766 = ({ taskList: taskList })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const { projectState: projectState } = getState();
        if (!projectState) return;
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectState.projectType;
        let backendVisibilityKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).map((type)=>(0, $8Bc5A.getBackendVisibilityKey)(type));
        const backendState = await (0, $6yhDy.pollBackend)({
            keys: [
                (0, $8Bc5A.KEY_OPEN),
                (0, $8Bc5A.KEY_DISMISSED),
                (0, $8Bc5A.KEY_OPEN_TASK),
                (0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $8Bc5A.KEY_JSW_ONBOARDING),
                ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks),
                ...backendVisibilityKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks)
                ].includes(key) && backendState[key] === true);
            Object.values((0, $8Bc5A.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $8Bc5A.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $8Bc5A.getBackendVisibilityKey)(type)];
                else if ((0, $8Bc5A.KEY_DISMISSED) in backendState && backendState[0, $8Bc5A.KEY_DISMISSED]) updatedState.visibility[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $8Bc5A.KEY_OPEN] ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
            });
            if ((0, $8Bc5A.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $8Bc5A.KEY_DISMISSED];
            if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $8Bc5A.KEY_OPEN];
            if ((0, $8Bc5A.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $8Bc5A.KEY_OPEN_TASK];
            if ((0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $8Bc5A.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $8Bc5A.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] !== null && (0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe) in backendState[0, $8Bc5A.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $8Bc5A.KEY_JSW_ONBOARDING][0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe];
            }
        }
        setState(updatedState);
        if (!(backendStateExists && (0, $8Bc5A.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $6ypzr.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $abQXL.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $52Vcw.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        setState({
            taskList: taskList
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});

parcelRegister("dQPsy", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistItemSeen", () => $82a74350685dcd25$export$4eac017dcde0be8f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");
const $82a74350685dcd25$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState })=>{
        const hasSeenTaskId = (0, $8Bc5A.convertToHaveSeenItTask)(taskId);
        const { hasSeenTasks: hasSeenTasks } = getState();
        if (hasSeenTasks.includes(hasSeenTaskId)) return;
        setState({
            hasSeenTasks: [
                ...hasSeenTasks,
                hasSeenTaskId
            ]
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.convertToHaveSeenItTask)(taskId),
            value: true
        });
    };

});

parcelRegister("boV1S", function(module, exports) {

$parcel$export(module.exports, "nextAutoExpand", () => $35a410a5fb89f79b$export$3d24e97d30cfd09e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $984bX = parcelRequire("984bX");

var $4ji4w = parcelRequire("4ji4w");

var $cUGWT = parcelRequire("cUGWT");
const $35a410a5fb89f79b$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
        const hasNudgeToShowAfterNavigation = (0, $984bX.localStorageProvider)().get({
            accountId: (0, $8Bc5A.ACCOUNT_ID),
            key: (0, $8Bc5A.KEY_HAS_NAVIGATED_FROM_LINK)
        });
        if (hasNudgeToShowAfterNavigation) return;
        const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        if (// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        items.includes(openTask) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        !completedTaskList.includes(openTask)) return;
        const taskIdToExpand = (0, $4ji4w.getNextNonCompleteTask)(items, completedTaskList, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $cUGWT.nextAutoOpenTask)(taskIdToExpand));
    };

});
parcelRegister("984bX", function(module, exports) {

$parcel$export(module.exports, "localStorageProvider", () => $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5);
$parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", () => $a6d0a6873aa6f7aa$export$f2666fae743fa5f);

var $eNf8a = parcelRequire("eNf8a");

var $jcw0u = parcelRequire("jcw0u");

var $8Bc5A = parcelRequire("8Bc5A");
const $a6d0a6873aa6f7aa$var$DAYS_BEFORE_EXPIRY = 1;
const $a6d0a6873aa6f7aa$var$DAY = 86400000;
const $a6d0a6873aa6f7aa$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
const $a6d0a6873aa6f7aa$var$getExpiryTime = ()=>{
    const now = Date.now();
    return now + $a6d0a6873aa6f7aa$var$DAYS_BEFORE_EXPIRY * $a6d0a6873aa6f7aa$var$DAY;
};
let $a6d0a6873aa6f7aa$var$localStorage;
const $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5 = ()=>{
    if ($a6d0a6873aa6f7aa$var$localStorage) return $a6d0a6873aa6f7aa$var$localStorage;
    const provider = (0, $eNf8a.createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
    try {
        provider.removeExpiredKeys();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            meta: {
                id: 'localStorageProviderKeyRemoval',
                packageName: 'jiraOnboardingQuickstartCore'
            },
            error: e
        });
    }
    const get = ({ accountId: accountId, key: key })=>provider.get($a6d0a6873aa6f7aa$var$getKey({
            accountId: accountId,
            key: key
        }));
    const set = ({ accountId: accountId, key: key, value: value })=>provider.set($a6d0a6873aa6f7aa$var$getKey({
            accountId: accountId,
            key: key
        }), value, $a6d0a6873aa6f7aa$var$getExpiryTime());
    const remove = ({ accountId: accountId, key: key })=>provider.remove($a6d0a6873aa6f7aa$var$getKey({
            accountId: accountId,
            key: key
        }));
    $a6d0a6873aa6f7aa$var$localStorage = {
        provider: provider,
        remove: remove,
        get: get,
        set: set
    };
    return $a6d0a6873aa6f7aa$var$localStorage;
};
const $a6d0a6873aa6f7aa$export$f2666fae743fa5f = (value)=>{
    $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5().set({
        accountId: (0, $8Bc5A.ACCOUNT_ID),
        key: (0, $8Bc5A.KEY_HAS_NAVIGATED_FROM_LINK),
        value: value
    });
};

});


parcelRegister("4Viq4", function(module, exports) {

$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => $0d74d0b8a43d2c5f$export$6f336ccb6432fcd0);
// Special case for nudges that need to show after a navigation.
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $984bX = parcelRequire("984bX");

var $lHcRB = parcelRequire("lHcRB");
const $0d74d0b8a43d2c5f$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
        const nudgeToShowAfterNavigationKeyPair = {
            accountId: (0, $8Bc5A.ACCOUNT_ID),
            key: (0, $8Bc5A.KEY_HAS_NAVIGATED_FROM_LINK)
        };
        const shouldShowNudge = (0, $984bX.localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
        if (shouldShowNudge) {
            dispatch((0, $lHcRB.setHasNudgeActive)(true));
            (0, $984bX.localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
        }
    };

});

parcelRegister("jIoq4", function(module, exports) {

$parcel$export(module.exports, "nextGetTasks", () => $034f263b888956c9$export$15d877e1f3abf489);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $ikZFc = parcelRequire("ikZFc");
const $034f263b888956c9$export$15d877e1f3abf489 = (props)=>({ getState: getState, setState: setState })=>{
        const { taskList: taskList } = getState();
        const tasks = (0, $ikZFc.getAllTasks)({
            ...props,
            taskList: taskList
        });
        setState({
            tasks: tasks
        });
    };

});
parcelRegister("ikZFc", function(module, exports) {

$parcel$export(module.exports, "getAllTasks", () => $cb6c1b1dc7b1b225$export$d1f442602a91e7cc);

var $6s1PB = parcelRequire("6s1PB");

var $b4PzF = parcelRequire("b4PzF");

var $4R6GH = parcelRequire("4R6GH");


var $ldyPw = parcelRequire("ldyPw");

var $jtI3q = parcelRequire("jtI3q");

var $8Bc5A = parcelRequire("8Bc5A");

var $1ffS1 = parcelRequire("1ffS1");

var $ieqoN = parcelRequire("ieqoN");

var $h3PyW = parcelRequire("h3PyW");

var $3Iaiu = parcelRequire("3Iaiu");

var $aHo1U = parcelRequire("aHo1U");

var $5yUqp = parcelRequire("5yUqp");

var $5zzQl = parcelRequire("5zzQl");

var $jJca1 = parcelRequire("jJca1");

var $d7Knl = parcelRequire("d7Knl");

var $8VfDj = parcelRequire("8VfDj");

var $pDX5d = parcelRequire("pDX5d");
const $cb6c1b1dc7b1b225$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_rt_quickstart_m1');
    if (variants.includes((0, $aHo1U.JSW).experiment.jswReverseTrial) && !expConfig.get('isEnabled', false)) {
        const { title: title, items: items } = taskList[taskGroupParent === (0, $8Bc5A.ROOT_TASK) ? (0, $8Bc5A.REVERSE_TRIAL_ROOT_TASK) : taskGroupParent] ?? taskList[0, $8Bc5A.REVERSE_TRIAL_ROOT_TASK];
        return {
            title: title,
            items: (0, $5zzQl.getTasks)(variants, taskVariants, items)
        };
    }
    const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, $8Bc5A.ROOT_TASK];
    return {
        title: title,
        items: (0, $5zzQl.getTasks)(variants, taskVariants, items)
    };
};
const $cb6c1b1dc7b1b225$var$createJswTasks = (projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, isWizardSimplifyQS, canEditPlans, premiumTrialOnSignup)=>{
    const variants = new Set();
    const isTmpScrumWithSprintPermission = mountedNudges.includes((0, $8Bc5A.BACKLOG_CREATE_SPRINT_NUDGE_ID));
    const isEligibleForKanbanTour = mountedNudges.includes((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112));
    if ((0, $b4PzF.isFedRamp)()) variants.add((0, $aHo1U.JSW).experience.fedRamp);
    if (premiumTrialOnSignup && (0, $4R6GH.fg)('jsw_reverse_trials_feature_gate')) {
        variants.add((0, $aHo1U.JSW).experiment.jswReverseTrial);
        (0, $6s1PB.expValEquals)('jira_rt_quickstart_m1', 'isEnabled', true) && variants.add((0, $aHo1U.JSW).experiment.rtQuickstartM1);
    }
    if (isCustomerTemplateProject) variants.add((0, $aHo1U.JSW).projectProperties.isCreatedFromCustomerTemplate);
    if (shouldShowScrumOnboardingExperience && isTmpScrumWithSprintPermission) variants.add((0, $aHo1U.JSW).experiment.scrumOnboarding);
    if (isCrossProjectBoardToPlanUpsell) variants.add((0, $aHo1U.JSW).trait.crossProjectBoardToPlanUpsell);
    if (canEditPlans) variants.add((0, $aHo1U.JSW).permissions.hasPlanEditPermissions);
    if (isEligibleForKanbanTour || routeName !== 'software-boards') variants.add((0, $aHo1U.JSW).experience.kanbanOnboarding);
    if (isWizardSimplifyQS) variants.add((0, $aHo1U.JSW).experiment.wizard);
    if (canCreateProject === false) variants.add((0, $aHo1U.JSW).permissions.notCanCreateProject);
    if (projectState?.isNextGen) variants.add((0, $aHo1U.JSW).projectStyle.teamManaged);
    else variants.add((0, $aHo1U.JSW).projectStyle.companyManaged);
    if (projectState?.isProjectAdmin) variants.add((0, $aHo1U.JSW).userRole.projectAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN) {
        variants.add((0, $aHo1U.JSW).userRole.jiraAdmin);
        variants.add((0, $aHo1U.JSW).userRole.admin);
    }
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN) {
        variants.add((0, $aHo1U.JSW).userRole.siteAdmin);
        variants.add((0, $aHo1U.JSW).userRole.admin);
    }
    if (projectState?.edition === (0, $ldyPw.FREE_EDITION)) variants.add((0, $aHo1U.JSW).edition.free);
    else if (projectState?.edition === (0, $ldyPw.STANDARD_EDITION)) variants.add((0, $aHo1U.JSW).edition.standard);
    else if (projectState?.edition === (0, $ldyPw.PREMIUM_EDITION)) variants.add((0, $aHo1U.JSW).edition.premium);
    if ((0, $1ffS1.isRoadmapRoute)(routeName)) variants.add((0, $aHo1U.JSW).route.softwareRoadmap);
    else if (routeName === 'software-backlog') variants.add((0, $aHo1U.JSW).route.softwareBacklog);
    else if (routeName === 'software-boards') variants.add((0, $aHo1U.JSW).route.softwareBoard);
    else if (routeName === 'software-list' || routeName === 'software-list-classic') variants.add((0, $aHo1U.JSW).route.softwareList);
    else if (routeName === 'project-settings-software-access') variants.add((0, $aHo1U.JSW).route.projectSettingsSoftwareAccess);
    else if (routeName === 'issue') variants.add((0, $aHo1U.JSW).route.issue);
    else if ((routeName === 'software-calendar' || routeName === 'software-calendar-classic') && (0, $4R6GH.fg)('software_calendar_quickstart_onboarding')) variants.add((0, $aHo1U.JSW).route.softwareCalendar);
    if (isEligibleToUpdateSitename) variants.add((0, $aHo1U.JSW).experiment.customizeSiteName);
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: Array.from(variants.values()),
        taskVariants: (0, $aHo1U.JSW).taskVariants,
        taskList: (0, $aHo1U.JSW).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$var$createJwmTasks = ({ projectState: projectState, taskGroupParent: taskGroupParent, taskList: taskList = (0, $5yUqp.JWM).taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5 })=>{
    const variants = [];
    variants.push((0, $5yUqp.JWM).experiments.projectTheming);
    if (isEligibleForTailoredOnboardingM2P5) return $cb6c1b1dc7b1b225$var$createTailoredOnboardingTasksM2P5({
        taskGroupParent: taskGroupParent,
        teamType: teamType
    });
    if (projectState?.isProjectAdmin) variants.push((0, $5yUqp.JWM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN) variants.push((0, $5yUqp.JWM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN) variants.push((0, $5yUqp.JWM).userRole.siteAdmin);
    if (projectState?.isSampleProject) variants.push((0, $5yUqp.JWM).experiments.isSampleProject);
    else variants.push((0, $5yUqp.JWM).experiments.isNotSampleProject);
    if (projectState?.isTrelloCrossflow) variants.push((0, $5yUqp.JWM).experiments.trelloCrossflow);
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $5yUqp.JWM).taskVariants,
        taskList: taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$var$createJsmTasks = (projectState, taskGroupParent)=>{
    const variants = [];
    variants.push((0, $3Iaiu.JSM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $3Iaiu.JSM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN) variants.push((0, $3Iaiu.JSM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN) variants.push((0, $3Iaiu.JSM).userRole.siteAdmin);
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $3Iaiu.JSM).taskVariants,
        taskList: (0, $3Iaiu.JSM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$var$createDevopsTasks = (taskGroupParent)=>{
    const variants = [];
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $h3PyW.DEVOPS).taskVariants,
        taskList: (0, $h3PyW.DEVOPS).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$export$d9d83c8e96505820 = (taskGroupParent, teamType, features, isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban)=>{
    if ((0, $4R6GH.fg)('jira_tailored_onboarding_single_config')) {
        const variants = [];
        if (features?.hasBacklog) variants.push((0, $pDX5d.Feature).hasBacklog);
        if (features?.hasSprint) variants.push((0, $pDX5d.Feature).hasSprint);
        if (isEligibleForTailoredOnboardingM3) variants.push((0, $8VfDj.Experiment).tailoredOnboardingM3Eligible);
        if (isEligibleForTailoredOnboardingScrumAndSoftwareKanban) variants.push((0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible);
        if (teamType && (0, $jtI3q.isTailoredOnboardingWithScrumAndSoftwareKanbanTeamType)(teamType)) variants.push(`teamType.${teamType}`);
        else variants.push('teamType.everythingElse');
        return $cb6c1b1dc7b1b225$var$getTaskListItem({
            variants: variants,
            taskVariants: (0, $d7Knl.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskVariants,
            taskList: (0, $d7Knl.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskList,
            taskGroupParent: taskGroupParent
        });
    }
    // Following the same pattern as other configs and using an array here
    // but right now only one value(team type) will ever be in this array
    const variants = [];
    if (teamType && (0, $jtI3q.isTailoredOnboardingTailoredTeamType)(teamType)) variants.push(teamType);
    else variants.push('everythingElse');
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $d7Knl.TAILORED_ONBOARDING).getTaskVariants(teamType ?? 'everythingElse'),
        taskList: (0, $d7Knl.TAILORED_ONBOARDING).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$var$createTailoredOnboardingTasksM2P5 = ({ taskGroupParent: taskGroupParent, teamType: teamType })=>{
    const variants = [];
    if (teamType && (0, $jtI3q.isTailoredOnboardingM2P5TailoredTeamType)(teamType)) variants.push(teamType);
    else variants.push('everythingElse');
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $d7Knl.TAILORED_ONBOARDING_M2P5).getM2P5TaskVariants(teamType ?? 'everythingElse'),
        taskList: (0, $d7Knl.TAILORED_ONBOARDING_M2P5).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$export$d1f442602a91e7cc = ({ projectState: projectState, isDevOpsProject: isDevOpsProject, taskGroupParent: taskGroupParent, routeName: routeName, shouldShowScrumOnboardingExperience: shouldShowScrumOnboardingExperience, mountedNudges: mountedNudges, canCreateProject: canCreateProject, isEligibleToUpdateSitename: isEligibleToUpdateSitename, isCustomerTemplateProject: isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell, isWizardSimplifyQS: isWizardSimplifyQS = false, canEditPlans: canEditPlans, premiumTrialOnSignup: premiumTrialOnSignup, taskList: taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5, isEligibleForTailoredOnboardingM3: isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban: isEligibleForTailoredOnboardingScrumAndSoftwareKanban, features: features })=>{
    if ((0, $jJca1.isJwmProject)(projectState)) return $cb6c1b1dc7b1b225$var$createJwmTasks({
        projectState: projectState,
        taskGroupParent: taskGroupParent,
        taskList: taskList,
        teamType: teamType,
        isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5
    });
    if ((0, $jJca1.isJsmProject)(projectState)) return $cb6c1b1dc7b1b225$var$createJsmTasks(projectState, taskGroupParent);
    if (isDevOpsProject) return $cb6c1b1dc7b1b225$var$createDevopsTasks(taskGroupParent);
    // We cannot do these in the config itself as we need to fallback to createJswTasks for other users
    // And unlike previous QS experiments, we want to change the entire QS for these users so a new config makes sense over variants to the existing JSW one
    if (isEligibleForTailoredOnboardingM3 || isEligibleForTailoredOnboardingScrumAndSoftwareKanban) return $cb6c1b1dc7b1b225$export$d9d83c8e96505820(taskGroupParent, teamType, features, isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban);
    return $cb6c1b1dc7b1b225$var$createJswTasks(projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, isWizardSimplifyQS, canEditPlans, premiumTrialOnSignup);
};

});
parcelRegister("jtI3q", function(module, exports) {

$parcel$export(module.exports, "isTailoredOnboardingTailoredTeamType", () => $606262a699c9299e$export$8ea98ac9729b7e09);
$parcel$export(module.exports, "isTailoredOnboardingWithScrumAndSoftwareKanbanTeamType", () => $606262a699c9299e$export$a40edd97e5cbfaa9);
$parcel$export(module.exports, "isTailoredOnboardingM2P5TailoredTeamType", () => $606262a699c9299e$export$26c385918d734203);

var $370Ye = parcelRequire("370Ye");
const $606262a699c9299e$export$8ea98ac9729b7e09 = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $370Ye.tailoredTeamTypes).includes(teamType);
};
const $606262a699c9299e$export$a40edd97e5cbfaa9 = (teamType)=>{
    return (0, $370Ye.tailoredTeamTypesWithSoftware).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    teamType);
};
const $606262a699c9299e$export$26c385918d734203 = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $370Ye.tailoredM2P5TeamTypes).includes(teamType);
};

});
parcelRegister("370Ye", function(module, exports) {

$parcel$export(module.exports, "tailoredTeamTypes", () => $06c84b7af2a23aee$export$a1fbb7d965e15a39);
$parcel$export(module.exports, "tailoredTeamTypesWithSoftware", () => $06c84b7af2a23aee$export$7e2d6cf3886ecaf7);
$parcel$export(module.exports, "tailoredM2P5TeamTypes", () => $06c84b7af2a23aee$export$52c5394d6e6cfcf3);

const $06c84b7af2a23aee$export$a1fbb7d965e15a39 = [
    (0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24),
    (0, $6784cbc7d62e5d7c$export$d7de553940261eba),
    (0, $6784cbc7d62e5d7c$export$e4824f74b9879164),
    (0, $6784cbc7d62e5d7c$export$4f3cb0844009af52),
    (0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d),
    (0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74),
    (0, $6784cbc7d62e5d7c$export$79685802e8ff1098)
];
const $06c84b7af2a23aee$export$7e2d6cf3886ecaf7 = [
    ...$06c84b7af2a23aee$export$a1fbb7d965e15a39,
    (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b)
];
const $06c84b7af2a23aee$export$52c5394d6e6cfcf3 = [
    (0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24),
    (0, $6784cbc7d62e5d7c$export$d7de553940261eba),
    (0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d),
    (0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74),
    (0, $6784cbc7d62e5d7c$export$79685802e8ff1098),
    (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b)
];

});


parcelRegister("1ffS1", function(module, exports) {

$parcel$export(module.exports, "isRoadmapRoute", () => $ee93e5dd18635f6d$export$d1fa67c1ffb68871);
const $ee93e5dd18635f6d$export$d1fa67c1ffb68871 = (routeName)=>{
    if (routeName === undefined) return false;
    return routeName === 'software-timeline' || routeName === 'software-timeline-classic';
};

});

parcelRegister("ieqoN", function(module, exports) {

$parcel$export(module.exports, "USER_ROLE", () => $353950c3dd35bbc6$export$8eeb199b23203523);
const $353950c3dd35bbc6$export$8eeb199b23203523 = {
    END_USER: 'end-user',
    SITE_ADMIN: 'site-admin',
    JIRA_ADMIN: 'jira-admin'
};

});

parcelRegister("h3PyW", function(module, exports) {

$parcel$export(module.exports, "DEVOPS", () => $866b9189a2842e55$export$bb75b6064c92010c);

var $j6cCw = parcelRequire("j6cCw");
const $866b9189a2842e55$export$bb75b6064c92010c = {
    taskList: (0, $j6cCw.TASK_LIST),
    taskVariants: (0, $j6cCw.TASK_VARIANTS),
    experiment: (0, $j6cCw.Experiment)
};

});
parcelRegister("j6cCw", function(module, exports) {

$parcel$export(module.exports, "Experiment", () => $7149b1f98b73c1fd$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "TASK_LIST", () => $7149b1f98b73c1fd$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $7149b1f98b73c1fd$export$36f4d47dfe11b613);

var $8Bc5A = parcelRequire("8Bc5A");

var $1AiUr = parcelRequire("1AiUr");
const $7149b1f98b73c1fd$export$4e0ab25c8a7e4009 = {};
const $7149b1f98b73c1fd$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $1AiUr.messages).rootTitle,
        items: [
            (0, $8Bc5A.DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK),
            (0, $8Bc5A.DEVOPS_GET_TO_KNOW_JIRA_TASK),
            (0, $8Bc5A.DEVOPS_NAVIGATE_YOUR_TOOLS_TASK),
            (0, $8Bc5A.DEVOPS_CAPTURE_INTEGRATIONS_TASK),
            (0, $8Bc5A.DEVOPS_CREATE_AUTOMATION_RULES_TASK),
            (0, $8Bc5A.DEVOPS_INVITE_TEAMMATES_TASK),
            (0, $8Bc5A.DEVOPS_FIND_HELP_TASK)
        ]
    }
});
const $7149b1f98b73c1fd$export$36f4d47dfe11b613 = {
    [(0, $8Bc5A.DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.DEVOPS_GET_TO_KNOW_JIRA_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.DEVOPS_NAVIGATE_YOUR_TOOLS_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.DEVOPS_CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.DEVOPS_CREATE_AUTOMATION_RULES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.DEVOPS_INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.DEVOPS_FIND_HELP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("1AiUr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6eae5132e152d792$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $6eae5132e152d792$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.devops.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("3Iaiu", function(module, exports) {

$parcel$export(module.exports, "JSM", () => $56a077523ddf70fb$export$63f289f2da861d35);

var $58IQc = parcelRequire("58IQc");
const $56a077523ddf70fb$export$63f289f2da861d35 = {
    taskList: (0, $58IQc.JSM_TASK_LIST),
    taskVariants: (0, $58IQc.JSM_TASK_VARIANTS),
    userRole: (0, $58IQc.UserRole),
    experiments: (0, $58IQc.Experiments)
};

});
parcelRegister("58IQc", function(module, exports) {

$parcel$export(module.exports, "JSM_TASK_LIST", () => $3c13225c81ad4b5c$export$6c6c561944d49bcb);
$parcel$export(module.exports, "Experiments", () => $3c13225c81ad4b5c$export$c8d6ffd15214553a);
$parcel$export(module.exports, "UserRole", () => $3c13225c81ad4b5c$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "JSM_TASK_VARIANTS", () => $3c13225c81ad4b5c$export$5b68aef408c932d9);

var $8Bc5A = parcelRequire("8Bc5A");

var $kTSRm = parcelRequire("kTSRm");
const $3c13225c81ad4b5c$export$6c6c561944d49bcb = Object.freeze({
    root: {
        title: (0, $kTSRm.messages).rootTitle,
        items: [
            (0, $8Bc5A.JSM_REVIEW_YOUR_CHANNELS_TASK),
            (0, $8Bc5A.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
            (0, $8Bc5A.JSM_INVITE_YOUR_TEAM_TASK)
        ]
    }
});
const $3c13225c81ad4b5c$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming'
};
const $3c13225c81ad4b5c$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};
const $3c13225c81ad4b5c$export$5b68aef408c932d9 = {
    [(0, $8Bc5A.JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
        position: {
            default: 1
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.JSM_INVITE_YOUR_TEAM_TASK)]: {
        position: {
            default: 2
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("kTSRm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f1f6142c4170f38e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f1f6142c4170f38e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("aHo1U", function(module, exports) {

$parcel$export(module.exports, "JSW", () => $563027753d017a60$export$4cfe6e52f2e72a54);

var $8VfDj = parcelRequire("8VfDj");
const $563027753d017a60$export$4cfe6e52f2e72a54 = {
    taskList: (0, $8VfDj.TASK_LIST),
    taskVariants: (0, $8VfDj.TASK_VARIANTS),
    experiment: (0, $8VfDj.Experiment),
    experience: (0, $8VfDj.Experience),
    projectStyle: (0, $8VfDj.ProjectStyle),
    projectProperties: (0, $8VfDj.ProjectProperties),
    userRole: (0, $8VfDj.UserRole),
    edition: (0, $8VfDj.Edition),
    route: (0, $8VfDj.Route),
    permissions: (0, $8VfDj.Permissions),
    trait: (0, $8VfDj.Trait)
};

});
parcelRegister("8VfDj", function(module, exports) {

$parcel$export(module.exports, "Experiment", () => $ea3903bb15047c3b$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "Experience", () => $ea3903bb15047c3b$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "ProjectStyle", () => $ea3903bb15047c3b$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "ProjectProperties", () => $ea3903bb15047c3b$export$543c19ee8dba9252);
$parcel$export(module.exports, "UserRole", () => $ea3903bb15047c3b$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "Edition", () => $ea3903bb15047c3b$export$6f4a0f769e61929);
$parcel$export(module.exports, "Route", () => $ea3903bb15047c3b$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Permissions", () => $ea3903bb15047c3b$export$2d41982586bbb6be);
$parcel$export(module.exports, "Trait", () => $ea3903bb15047c3b$export$2d08cfa40d69142e);
$parcel$export(module.exports, "TASK_LIST", () => $ea3903bb15047c3b$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $ea3903bb15047c3b$export$36f4d47dfe11b613);

var $8Bc5A = parcelRequire("8Bc5A");

var $ciLFO = parcelRequire("ciLFO");
const $ea3903bb15047c3b$export$4e0ab25c8a7e4009 = {
    scrumOnboarding: 'experiment.scrumOnboarding',
    customizeSiteName: 'experiment.customizeSiteName',
    jswReverseTrial: 'experiment.jswReverseTrial',
    rtQuickstartM1: 'experiment.rtQuickstartM1',
    wizard: 'experiment.wizard',
    tailoredOnboardingM3Eligible: 'experiment.tailoredOnboardingM3Eligible',
    tailoredOnboardingScrumAndSoftwareKanbanEligible: 'experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible'
};
const $ea3903bb15047c3b$export$c90b54e658fc4d7c = {
    kanbanOnboarding: 'experience.kanbanOnboarding',
    fedRamp: 'experience.fedRamp'
};
const $ea3903bb15047c3b$export$1f66f9f05afa05a8 = {
    teamManaged: 'projectStyle.teamManaged',
    companyManaged: 'projectStyle.companyManaged'
};
const $ea3903bb15047c3b$export$543c19ee8dba9252 = {
    isCreatedFromCustomerTemplate: 'projectProperties.isCreatedFromCustomerTemplate'
};
const $ea3903bb15047c3b$export$eb3485a690c2f0b8 = {
    siteAdmin: 'userRole.siteAdmin',
    jiraAdmin: 'userRole.jiraAdmin',
    admin: 'userRole.admin',
    projectAdmin: 'userRole.projectAdmin'
};
const $ea3903bb15047c3b$export$6f4a0f769e61929 = {
    free: 'productEdition.free',
    standard: 'productEdition.standard',
    premium: 'productEdition.premium'
};
const $ea3903bb15047c3b$export$e7b0ac011bb776c6 = {
    softwareRoadmap: 'route.softwareRoadmap',
    softwareBacklog: 'route.softwareBacklog',
    softwareBoard: 'route.softwareBoard',
    softwareList: 'route.softwareList',
    projectSettingsSoftwareAccess: 'route.projectSettingsSoftwareAccess',
    issue: 'route.issue',
    softwareCalendar: 'route.softwareCalendar'
};
const $ea3903bb15047c3b$export$2d41982586bbb6be = {
    notCanCreateProject: 'permissions.notCanCreateProject',
    hasPlanEditPermissions: 'permissions.hasPlanEditPermissions'
};
const $ea3903bb15047c3b$export$2d08cfa40d69142e = {
    crossProjectBoardToPlanUpsell: 'trait.crossProjectBoardToPlanUpsell'
};
const $ea3903bb15047c3b$var$DEFAULT_TASK_LIST = [
    (0, $8Bc5A.ADD_COLUMNS_TASK),
    (0, $8Bc5A.CREATE_PROJECT_TASK),
    (0, $8Bc5A.CREATE_ISSUE_TASK),
    (0, $8Bc5A.CREATE_ISSUE_TASK_SIMPLIFIED),
    (0, $8Bc5A.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK),
    (0, $8Bc5A.INVITE_TEAMMATES_TASK),
    (0, $8Bc5A.INVITE_TEAMMATES_VIDEO_TASK),
    (0, $8Bc5A.CAPTURE_INTEGRATIONS_TASK),
    (0, $8Bc5A.FIND_HELP_TASK),
    (0, $8Bc5A.SET_UP_BOARD_TASK),
    (0, $8Bc5A.GET_MOBILE_APP_TASK),
    (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK),
    (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK),
    (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN),
    (0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK),
    (0, $8Bc5A.MAP_OUT_YOUR_PROJECT_GOALS_TASK),
    (0, $8Bc5A.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK),
    (0, $8Bc5A.MONITOR_MANAGE_RISK_TASK),
    (0, $8Bc5A.SCRUM_ONBOARDING_TASK),
    (0, $8Bc5A.CUSTOMIZE_SITE_NAME_TASK),
    (0, $8Bc5A.GET_TO_KNOW_YOUR_TEMPLATE_TASK),
    (0, $8Bc5A.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK),
    (0, $8Bc5A.GET_STARTED_LIST_TASK),
    (0, $8Bc5A.CALENDAR_VIEW_TASK)
];
const $ea3903bb15047c3b$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $ciLFO.messages).rootTitle,
        items: $ea3903bb15047c3b$var$DEFAULT_TASK_LIST
    },
    reverseTrialRoot: {
        title: (0, $ciLFO.messages).reverseTrialRootTitle,
        items: $ea3903bb15047c3b$var$DEFAULT_TASK_LIST
    },
    [(0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)]: {
        title: (0, $ciLFO.messages).reverseTrialCardTitle,
        items: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK),
            (0, $8Bc5A.CHANGE_CONTROL_TASK),
            (0, $8Bc5A.AUTOMATIONS_TASK),
            (0, $8Bc5A.SITE_ADMINISTRATIONS_TASK),
            (0, $8Bc5A.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        title: (0, $ciLFO.messages).premiumPlanTitle,
        items: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK),
            (0, $8Bc5A.CHANGE_CONTROL_TASK),
            (0, $8Bc5A.AUTOMATIONS_TASK),
            (0, $8Bc5A.SITE_ADMINISTRATIONS_TASK),
            (0, $8Bc5A.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        title: (0, $ciLFO.messages).premiumPlanTitle,
        items: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK),
            (0, $8Bc5A.AUTOMATIONS_TASK)
        ]
    },
    [(0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK)]: {
        title: (0, $ciLFO.messages).standardPlanTitle,
        items: [
            (0, $8Bc5A.AUTOMATIONS_TASK),
            (0, $8Bc5A.USER_MANAGEMENT_TASK),
            (0, $8Bc5A.SITE_ADMINISTRATIONS_TASK)
        ]
    }
});
const $ea3903bb15047c3b$var$PLAN_ONBOARDING_TASKS = {
    [(0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.rtQuickstartM1,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    // This condition needs to be the opposite condition to PREMIUM_EDITION_OVERVIEW_TASK
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.ADVANCED_ROADMAPS_TASK)]: {
        position: {
            default: 105
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.AUTOMATIONS_TASK)]: {
        position: {
            default: 110
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.USER_MANAGEMENT_TASK)]: {
        position: {
            default: 115
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CHANGE_CONTROL_TASK)]: {
        position: {
            default: 120
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.SITE_ADMINISTRATIONS_TASK)]: {
        position: {
            default: 125
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $ea3903bb15047c3b$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS = {
    [(0, $8Bc5A.GET_TO_KNOW_YOUR_TEMPLATE_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$543c19ee8dba9252.isCreatedFromCustomerTemplate,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $ea3903bb15047c3b$export$36f4d47dfe11b613 = {
    ...$ea3903bb15047c3b$var$PLAN_ONBOARDING_TASKS,
    ...$ea3903bb15047c3b$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS,
    [(0, $8Bc5A.CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$543c19ee8dba9252.isCreatedFromCustomerTemplate
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.CUSTOMIZE_SITE_NAME_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin,
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.customizeSiteName
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CALENDAR_VIEW_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    value: true,
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareCalendar
                    ]
                }
            ]
        }
    },
    [(0, $8Bc5A.SCRUM_ONBOARDING_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin,
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.scrumOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBacklog
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.MAP_OUT_YOUR_PROJECT_GOALS_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK)]: {
        position: {
            default: 151
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.MONITOR_MANAGE_RISK_TASK)]: {
        position: {
            default: 152
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.SET_UP_BOARD_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CREATE_ISSUE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.CREATE_ISSUE_TASK_SIMPLIFIED)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.ADD_COLUMNS_TASK)]: {
        position: {
            default: 310
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 320
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK)]: {
        position: {
            default: 350
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.INVITE_TEAMMATES_VIDEO_TASK)]: {
        position: {
            default: 400,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.GET_MOBILE_APP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.FIND_HELP_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    }
};

});
parcelRegister("ciLFO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $609e253829546460$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $609e253829546460$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsw.root-title.no-translate",
        "defaultMessage": "Quickstart"
    },
    premiumPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.premium-plan-title",
        "defaultMessage": "Included in your Premium plan"
    },
    standardPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.standard-plan-title",
        "defaultMessage": "Your Standard plan"
    },
    reverseTrialRootTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-root-title",
        "defaultMessage": "Your 30-day Premium trial"
    },
    reverseTrialCardTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-card-title",
        "defaultMessage": "Included in your Premium trial"
    }
});

});



parcelRegister("5yUqp", function(module, exports) {

$parcel$export(module.exports, "JWM", () => $80382801c7786de6$export$3ff26c80cb588e12);

var $82B5j = parcelRequire("82B5j");

var $8jC8d = parcelRequire("8jC8d");

var $5PFhq = parcelRequire("5PFhq");
const $80382801c7786de6$export$3ff26c80cb588e12 = {
    taskList: (0, $82B5j.TASK_LIST),
    taskVariants: (0, $82B5j.TASK_VARIANTS),
    userRole: (0, $5PFhq.UserRole),
    experiments: (0, $8jC8d.Experiments)
};

});
parcelRegister("82B5j", function(module, exports) {

$parcel$export(module.exports, "TASK_LIST", () => $3b1179694682c8c8$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $3b1179694682c8c8$export$36f4d47dfe11b613);

var $8Bc5A = parcelRequire("8Bc5A");

var $8jC8d = parcelRequire("8jC8d");

var $aQMWP = parcelRequire("aQMWP");

var $5PFhq = parcelRequire("5PFhq");
const $3b1179694682c8c8$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $aQMWP.messages).rootTitle,
        items: [
            (0, $8Bc5A.JWM_CREATE_PROJECT_TASK),
            (0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            (0, $8Bc5A.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $8Bc5A.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $8Bc5A.JWM_CREATE_SAMPLE_PROJECT_TASK),
            (0, $8Bc5A.JWM_PROJECT_SUMMARY_TASK),
            (0, $8Bc5A.GET_STARTED_LIST_TASK),
            (0, $8Bc5A.JWM_CALENDAR_TASK),
            (0, $8Bc5A.JWM_TIMELINE_TASK),
            (0, $8Bc5A.JWM_BUILD_FORM_TASK),
            (0, $8Bc5A.JWM_BACKGROUND_COLOR_TASK),
            (0, $8Bc5A.JWM_FEEDBACK_TASK),
            (0, $8Bc5A.JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
            (0, $8Bc5A.JWM_SHARE_PROJECT_TASK),
            (0, $8Bc5A.JWM_CREATE_YOUR_OWN_PROJECT_TASK)
        ]
    }
});
const $3b1179694682c8c8$var$OPS_TAILORED_ONBOARDING_TASK_VARIANTS = {
    [(0, $8Bc5A.OPS_JTBD_3_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $8Bc5A.OPS_JTBD_3_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $8Bc5A.OPS_JTBD_3_PAGES)]: {
        position: {
            default: 300
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_LIST)]: {
        position: {
            default: 400
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_CALENDAR)]: {
        position: {
            default: 500
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_TIMELINE)]: {
        position: {
            default: 600
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_SUMMARY)]: {
        position: {
            default: 700
        }
    },
    [(0, $8Bc5A.OPS_JTBD_5_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $8Bc5A.OPS_JTBD_5_TIMELINE)]: {
        position: {
            default: 900
        }
    },
    [(0, $8Bc5A.OPS_JTBD_5_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $8Bc5A.OPS_JTBD_7_LIST)]: {
        position: {
            default: 1100
        }
    },
    [(0, $8Bc5A.OPS_JTBD_7_CALENDAR)]: {
        position: {
            default: 1200
        }
    },
    [(0, $8Bc5A.OPS_JTBD_2_BOARD)]: {
        position: {
            default: 1300
        }
    },
    [(0, $8Bc5A.OPS_JTBD_2_FORMS)]: {
        position: {
            default: 1400
        }
    },
    [(0, $8Bc5A.OPS_JTBD_2_SUMMARY)]: {
        position: {
            default: 1500
        }
    },
    [(0, $8Bc5A.OPS_JTBD_1_LIST)]: {
        position: {
            default: 1600
        }
    },
    [(0, $8Bc5A.OPS_JTBD_6_PAGES)]: {
        position: {
            default: 1700
        }
    },
    [(0, $8Bc5A.OPS_JTBD_0_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $8Bc5A.OPS_JTBD_0_TIMELINE)]: {
        position: {
            default: 1900
        }
    },
    [(0, $8Bc5A.OPS_JTBD_0_PAGES)]: {
        position: {
            default: 2000
        }
    },
    [(0, $8Bc5A.OPS_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 2100
        }
    },
    [(0, $8Bc5A.OPS_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 2200
        }
    },
    [(0, $8Bc5A.OPS_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2300
        }
    }
};
const $3b1179694682c8c8$var$MKT_TAILORED_ONBOARDING_TASK_VARIANTS = {
    [(0, $8Bc5A.MKT_JTBD_1_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $8Bc5A.MKT_JTBD_1_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $8Bc5A.MKT_JTBD_1_TIMELINE)]: {
        position: {
            default: 300
        }
    },
    [(0, $8Bc5A.MKT_JTBD_2_CALENDAR)]: {
        position: {
            default: 400
        }
    },
    [(0, $8Bc5A.MKT_JTBD_2_PAGES)]: {
        position: {
            default: 500
        }
    },
    [(0, $8Bc5A.MKT_JTBD_3_PAGES)]: {
        position: {
            default: 600
        }
    },
    [(0, $8Bc5A.MKT_JTBD_3_TIMELINE)]: {
        position: {
            default: 700
        }
    },
    [(0, $8Bc5A.MKT_JTBD_4_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $8Bc5A.MKT_JTBD_4_SUMMARY)]: {
        position: {
            default: 900
        }
    },
    [(0, $8Bc5A.MKT_JTBD_4_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $8Bc5A.MKT_JTBD_5_TIMELINE)]: {
        position: {
            default: 1100
        }
    },
    [(0, $8Bc5A.MKT_JTBD_5_SUMMARY)]: {
        position: {
            default: 1200
        }
    },
    [(0, $8Bc5A.MKT_JTBD_6_FORMS)]: {
        position: {
            default: 1300
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_LIST)]: {
        position: {
            default: 1400
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_CALENDAR)]: {
        position: {
            default: 1500
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_TIMELINE)]: {
        position: {
            default: 1600
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_SUMMARY)]: {
        position: {
            default: 1700
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 1900
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_PROJECT)]: {
        position: {
            default: 2000
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2100
        }
    }
};
const $3b1179694682c8c8$export$36f4d47dfe11b613 = {
    ...$3b1179694682c8c8$var$OPS_TAILORED_ONBOARDING_TASK_VARIANTS,
    ...$3b1179694682c8c8$var$MKT_TAILORED_ONBOARDING_TASK_VARIANTS,
    [(0, $8Bc5A.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_CREATE_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 40
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_PROJECT_SUMMARY_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_CALENDAR_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_TIMELINE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_BACKGROUND_COLOR_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).projectTheming,
                        (0, $5PFhq.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).projectTheming,
                        (0, $5PFhq.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).projectTheming,
                        (0, $5PFhq.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_SHARE_PROJECT_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow,
                        (0, $5PFhq.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_FEEDBACK_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_FEEDBACK_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_CREATE_YOUR_OWN_PROJECT_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject,
                        (0, $5PFhq.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject,
                        (0, $5PFhq.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject,
                        (0, $5PFhq.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("8jC8d", function(module, exports) {

$parcel$export(module.exports, "Experiments", () => $6cd173da51fb2ca8$export$c8d6ffd15214553a);
const $6cd173da51fb2ca8$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming',
    isSampleProject: 'isSampleProject',
    isNotSampleProject: 'isNotSampleProject',
    trelloCrossflow: 'trelloCrossflow'
};

});

parcelRegister("aQMWP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $40755a70921f89dd$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $40755a70921f89dd$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("5PFhq", function(module, exports) {

$parcel$export(module.exports, "UserRole", () => $637dacd99a3a1727$export$eb3485a690c2f0b8);
const $637dacd99a3a1727$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};

});



parcelRegister("5zzQl", function(module, exports) {

$parcel$export(module.exports, "getTasks", () => $f17c108f7b3045ad$export$20b82b4a32771893);

var $fNtu3 = parcelRequire("fNtu3");
const $f17c108f7b3045ad$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, $fNtu3.getConditional)(visibility, variants) : true;
const $f17c108f7b3045ad$var$getTaskPosition = (variants, position)=>(0, $fNtu3.getConditional)(position, variants);
const $f17c108f7b3045ad$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$f17c108f7b3045ad$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$f17c108f7b3045ad$var$getTaskPosition(variants, taskVariants[taskA].position) - $f17c108f7b3045ad$var$getTaskPosition(variants, taskVariants[taskB].position));

});
parcelRegister("fNtu3", function(module, exports) {

$parcel$export(module.exports, "getConditional", () => $8978a3b25f57d9ac$export$fe3161cde0106bba);
const $8978a3b25f57d9ac$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
    if (conditions === undefined) return defaultValue;
    const variantsIncludesCondition = (c)=>variants.includes(c);
    const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
    return conditionObj ? conditionObj.value : defaultValue;
};

});


parcelRegister("jJca1", function(module, exports) {

$parcel$export(module.exports, "isJwmProject", () => $6249819f9bc2846f$export$ea2e5a5c1a1a6748);
$parcel$export(module.exports, "isJsmProject", () => $6249819f9bc2846f$export$a972ed853ed1d469);

var $2vSU6 = parcelRequire("2vSU6");
const $6249819f9bc2846f$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, $2vSU6.CORE_PROJECT);
const $6249819f9bc2846f$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);

});

parcelRegister("d7Knl", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING", () => $98ba598c6688dfac$export$861e712b5b639c2a);
$parcel$export(module.exports, "TAILORED_ONBOARDING_WITH_SINGLE_CONFIG", () => $98ba598c6688dfac$export$83849aa73c0a20db);
$parcel$export(module.exports, "TAILORED_ONBOARDING_M2P5", () => $98ba598c6688dfac$export$eb17ad7838835d2a);


var $8Bc5A = parcelRequire("8Bc5A");

var $57ZKw = parcelRequire("57ZKw");

var $i2O9c = parcelRequire("i2O9c");

var $643hq = parcelRequire("643hq");

var $2Ld7w = parcelRequire("2Ld7w");

var $1bW8Q = parcelRequire("1bW8Q");

var $9mlnS = parcelRequire("9mlnS");

var $aRLWM = parcelRequire("aRLWM");

var $8oUbS = parcelRequire("8oUbS");

var $f4rKN = parcelRequire("f4rKN");

var $3YqPl = parcelRequire("3YqPl");

var $xk58e = parcelRequire("xk58e");
const $98ba598c6688dfac$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $57ZKw.messages).rootTitle,
        items: [
            (0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY),
            (0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR),
            (0, $8Bc5A.TAILORED_ONBOARDING_LIST),
            (0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE),
            (0, $8Bc5A.TAILORED_ONBOARDING_PAGES),
            (0, $8Bc5A.TAILORED_ONBOARDING_FORM),
            (0, $8Bc5A.TAILORED_ONBOARDING_INVITE),
            (0, $8Bc5A.TAILORED_ONBOARDING_BOARD)
        ]
    }
});
const $98ba598c6688dfac$export$36f4d47dfe11b613 = {
    ...(0, $643hq.PRODUCT_MANAGEMENT_VARIANTS),
    ...(0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS),
    ...(0, $2Ld7w.DESIGN_VARIANTS),
    ...(0, $1bW8Q.IT_SUPPORT_VARIANTS),
    ...(0, $9mlnS.OTHER_PERSONAL_VARIANTS),
    ...(0, $aRLWM.MARKETING_VARIANTS),
    ...(0, $8oUbS.OPERATIONS_VARIANTS),
    ...(0, $f4rKN.EVERYTHING_ELSE_VARIANTS)
};
const $98ba598c6688dfac$var$getTaskVariants = (teamType)=>{
    switch(teamType){
        case 0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74:
            return 0, $643hq.PRODUCT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$79685802e8ff1098:
            return 0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24:
            return 0, $2Ld7w.DESIGN_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$d7de553940261eba:
            return 0, $1bW8Q.IT_SUPPORT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d:
            return 0, $9mlnS.OTHER_PERSONAL_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$e4824f74b9879164:
            return 0, $aRLWM.MARKETING_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$4f3cb0844009af52:
            return 0, $8oUbS.OPERATIONS_VARIANTS;
        default:
            return 0, $f4rKN.EVERYTHING_ELSE_VARIANTS;
    }
};
const $98ba598c6688dfac$export$861e712b5b639c2a = {
    taskList: $98ba598c6688dfac$export$601c8c0f45aeb0a0,
    getTaskVariants: $98ba598c6688dfac$var$getTaskVariants
};
const $98ba598c6688dfac$export$2757f7b23d120b9b = Object.freeze({
    root: {
        title: (0, $57ZKw.messages).rootTitle,
        items: [
            (0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY),
            (0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR),
            (0, $8Bc5A.TAILORED_ONBOARDING_LIST),
            (0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE),
            (0, $8Bc5A.TAILORED_ONBOARDING_PAGES),
            (0, $8Bc5A.TAILORED_ONBOARDING_FORM),
            (0, $8Bc5A.TAILORED_ONBOARDING_INVITE),
            (0, $8Bc5A.TAILORED_ONBOARDING_BOARD),
            (0, $8Bc5A.TAILORED_ONBOARDING_BACKLOG),
            (0, $8Bc5A.TAILORED_ONBOARDING_CODE)
        ]
    }
});
const $98ba598c6688dfac$export$83849aa73c0a20db = {
    taskList: $98ba598c6688dfac$export$2757f7b23d120b9b,
    taskVariants: (0, $xk58e.TAILORED_ONBOARDING_SINGLE_CONFIG)
};
const $98ba598c6688dfac$export$fd94bb9b6d992528 = Object.freeze({
    root: {
        title: (0, $57ZKw.messages).rootTitle,
        items: [
            (0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY),
            (0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR),
            (0, $8Bc5A.TAILORED_ONBOARDING_LIST),
            (0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE),
            (0, $8Bc5A.TAILORED_ONBOARDING_PAGES),
            (0, $8Bc5A.TAILORED_ONBOARDING_FORM),
            (0, $8Bc5A.TAILORED_ONBOARDING_INVITE),
            (0, $8Bc5A.TAILORED_ONBOARDING_BOARD)
        ]
    }
});
const $98ba598c6688dfac$export$be9c097e18825d4c = {
    ...(0, $643hq.PRODUCT_MANAGEMENT_VARIANTS),
    ...(0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS),
    ...(0, $2Ld7w.DESIGN_VARIANTS),
    ...(0, $1bW8Q.IT_SUPPORT_VARIANTS),
    ...(0, $3YqPl.SOFTWARE_VARIANTS),
    ...(0, $9mlnS.OTHER_PERSONAL_VARIANTS),
    ...(0, $f4rKN.EVERYTHING_ELSE_VARIANTS)
};
const $98ba598c6688dfac$export$3c409334669aec75 = (teamType)=>{
    switch(teamType){
        case 0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74:
            return 0, $643hq.PRODUCT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$79685802e8ff1098:
            return 0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24:
            return 0, $2Ld7w.DESIGN_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$d7de553940261eba:
            return 0, $1bW8Q.IT_SUPPORT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d:
            return 0, $9mlnS.OTHER_PERSONAL_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b:
            return 0, $3YqPl.SOFTWARE_VARIANTS;
        default:
            return 0, $f4rKN.EVERYTHING_ELSE_VARIANTS;
    }
};
const $98ba598c6688dfac$export$eb17ad7838835d2a = {
    taskList: $98ba598c6688dfac$export$fd94bb9b6d992528,
    getM2P5TaskVariants: $98ba598c6688dfac$export$3c409334669aec75
};

});
parcelRegister("57ZKw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b241f4df6ba82218$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b241f4df6ba82218$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.tailored-onboarding.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("i2O9c", function(module, exports) {

$parcel$export(module.exports, "PROJECT_MANAGEMENT_VARIANTS", () => $c81c85368d94bebb$export$bdd338c80f8962df);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $c81c85368d94bebb$export$bdd338c80f8962df = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("pDX5d", function(module, exports) {

$parcel$export(module.exports, "TeamType", () => $c47e1ea5de95ecc4$export$26bc40b960693765);
$parcel$export(module.exports, "TeamTypeWithPrefix", () => $c47e1ea5de95ecc4$export$668a7c1cbabc62a);
$parcel$export(module.exports, "Feature", () => $c47e1ea5de95ecc4$export$6e91cf7616333d5);

const $c47e1ea5de95ecc4$export$26bc40b960693765 = {
    productManagement: (0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74),
    projectManagement: (0, $6784cbc7d62e5d7c$export$79685802e8ff1098),
    design: (0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24),
    itSupport: (0, $6784cbc7d62e5d7c$export$d7de553940261eba),
    otherPersonal: (0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d),
    marketing: (0, $6784cbc7d62e5d7c$export$e4824f74b9879164),
    operations: (0, $6784cbc7d62e5d7c$export$4f3cb0844009af52),
    software: (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b),
    // Fallback team type config used for team types we aren't catering for e.g. Data science
    // and also used if the team type is unexpected/unknown
    everythingElse: 'everythingElse'
};
const $c47e1ea5de95ecc4$export$668a7c1cbabc62a = {
    productManagement: `teamType.${(0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74)}`,
    projectManagement: `teamType.${(0, $6784cbc7d62e5d7c$export$79685802e8ff1098)}`,
    design: `teamType.${(0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24)}`,
    itSupport: `teamType.${(0, $6784cbc7d62e5d7c$export$d7de553940261eba)}`,
    otherPersonal: `teamType.${(0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d)}`,
    marketing: `teamType.${(0, $6784cbc7d62e5d7c$export$e4824f74b9879164)}`,
    operations: `teamType.${(0, $6784cbc7d62e5d7c$export$4f3cb0844009af52)}`,
    software: `teamType.${(0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b)}`,
    // Fallback team type config used for team types we aren't catering for e.g. Data science
    // and also used if the team type is unexpected/unknown
    everythingElse: 'teamType.everythingElse'
};
const $c47e1ea5de95ecc4$export$6e91cf7616333d5 = {
    hasBacklog: 'feature.hasBacklog',
    hasSprint: 'feature.hasSprint'
};

});


parcelRegister("643hq", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_MANAGEMENT_VARIANTS", () => $fed1dddbfb0b30cf$export$b07ea6a2d29f9c08);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $fed1dddbfb0b30cf$export$b07ea6a2d29f9c08 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("2Ld7w", function(module, exports) {

$parcel$export(module.exports, "DESIGN_VARIANTS", () => $d62d711ad5ddd92f$export$a3c4cd8e420f13a);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $d62d711ad5ddd92f$export$a3c4cd8e420f13a = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("1bW8Q", function(module, exports) {

$parcel$export(module.exports, "IT_SUPPORT_VARIANTS", () => $09c03dfb484f3e93$export$a25e809b52945082);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $09c03dfb484f3e93$export$a25e809b52945082 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("9mlnS", function(module, exports) {

$parcel$export(module.exports, "OTHER_PERSONAL_VARIANTS", () => $6398fc5437bfee58$export$916be3c140ae8c0);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $6398fc5437bfee58$export$916be3c140ae8c0 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("aRLWM", function(module, exports) {

$parcel$export(module.exports, "MARKETING_VARIANTS", () => $ca6dac271f81ec57$export$5580e2b7ba40f572);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $ca6dac271f81ec57$export$5580e2b7ba40f572 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("8oUbS", function(module, exports) {

$parcel$export(module.exports, "OPERATIONS_VARIANTS", () => $7ebba77bc28e7956$export$cd166ee66dc078f4);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $7ebba77bc28e7956$export$cd166ee66dc078f4 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 600
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("f4rKN", function(module, exports) {

$parcel$export(module.exports, "EVERYTHING_ELSE_VARIANTS", () => $dc653043c34d0d58$export$7a0daeb069f34de3);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $dc653043c34d0d58$export$7a0daeb069f34de3 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("3YqPl", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_VARIANTS", () => $136badd6870fea88$export$76a143792cc73994);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $136badd6870fea88$export$76a143792cc73994 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("xk58e", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING_SINGLE_CONFIG", () => $70190108b7b6e00a$export$64855550cee11b78);

var $8Bc5A = parcelRequire("8Bc5A");

var $8VfDj = parcelRequire("8VfDj");

var $pDX5d = parcelRequire("pDX5d");
const $70190108b7b6e00a$export$64855550cee11b78 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 0,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0,
            conditional: []
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BACKLOG)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CODE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 700
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible
                    ],
                    value: 700
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});




parcelRegister("75A1x", function(module, exports) {

$parcel$export(module.exports, "syncVisibilityWithLocal", () => $f9427b1514e1931c$export$4aab9a98fc53b894);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");
const $f9427b1514e1931c$export$4aab9a98fc53b894 = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const visibilityLocal = (0, $4ji4w.getLocalStorageItem)(`${quickstartType}.visibility`);
        if (visibilityLocal === state.visibility[quickstartType]) return;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: visibilityLocal
            }
        });
    };

});


parcelRegister("cGE52", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $d175a7a443e10f6d$export$d4c72bab9d6cc13a);

var $8Bc5A = parcelRequire("8Bc5A");
const $d175a7a443e10f6d$export$d4c72bab9d6cc13a = {
    shouldRenderComponent: false,
    completedTaskList: [],
    hasSeenTasks: [],
    isDismissed: true,
    isOpen: false,
    isFocusedOn: false,
    openTask: '',
    projectState: null,
    hasNudgeActive: false,
    isQuickstartLoaded: false,
    isDevOpsProject: false,
    nudgeStep: '',
    mountedNudges: [],
    hasEverSeenRoute: {
        'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
    },
    roadmapIsCreateEnabled: false,
    roadmapIsListEmpty: true,
    previousTaskGroupParents: [],
    currentTaskGroupParent: (0, $8Bc5A.ROOT_TASK),
    selectedProjectTemplateKeyFromOnboarding: undefined,
    isEligibleToUpdateSitename: false,
    isCrossProjectBoardToPlanUpsell: false,
    canEditPlans: false,
    visibility: {
        [(0, $8Bc5A.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED,
        [(0, $8Bc5A.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED
    }
};

});


parcelRegister("a4k7n", function(module, exports) {

$parcel$export(module.exports, "NavigationAppsNavItemWrapperNudgeAsync", () => $86c9ba44b2aedf6e$export$c143067f544307f);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $86c9ba44b2aedf6e$var$NavigationAppsNavItemLazy = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("2Z9D4")).then((exportedModule)=>exportedModule.NavigationAppsNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-apps/index.tsx"
});
const $86c9ba44b2aedf6e$export$c143067f544307f = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$dd63d0099d95ba4f),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$dd63d0099d95ba4f)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "navigation-apps-nav-item-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86c9ba44b2aedf6e$var$NavigationAppsNavItemLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$dd63d0099d95ba4f),
        isInsideMenu: isInsideMenu
    }, children)));

});
parcelRegister("bBbEG", function(module, exports) {

$parcel$export(module.exports, "OnboardingNudgeErrorBoundary", () => $383be1d115a6551b$export$3915a8814b99f0b);

var $5uXOq = parcelRequire("5uXOq");

var $lkem5 = parcelRequire("lkem5");

var $8Bc5A = parcelRequire("8Bc5A");
const $383be1d115a6551b$export$3915a8814b99f0b = (props)=>{
    const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkem5.ErrorBoundaryWithChunkErrorLogging), {
        id: id,
        packageName: (0, $8Bc5A.PACKAGE_NAME),
        render: ()=>fallback,
        attributes: attributes
    }, children);
};

});
parcelRegister("lkem5", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", () => $3df8b034ebbd68e5$export$9171acf2e93b7d4d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $30rnQ = parcelRequire("30rnQ");
const $3df8b034ebbd68e5$export$9171acf2e93b7d4d = (props)=>{
    const { attributes: attributes, children: children, ...rest } = props;
    const addErrorBoundaryAnalyticsAttributes = (0, $30rnQ.useAddErrorBoundaryAnalyticsAttributes)(attributes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        ...rest,
        attributes: addErrorBoundaryAnalyticsAttributes
    }, children);
};

});
parcelRegister("30rnQ", function(module, exports) {

$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", () => $53c68ff9a9edd0fe$export$807be5f3f1ea996);

var $5uXOq = parcelRequire("5uXOq");

var $3vs13 = parcelRequire("3vs13");
const $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $3vs13.isLoaderError)(error)
    });
const $53c68ff9a9edd0fe$export$807be5f3f1ea996 = (attributes = {})=>(0, $5uXOq.useCallback)((error)=>({
            ...attributes,
            ...$53c68ff9a9edd0fe$export$94ee0b5fca1e74d2(error)
        }), [
        attributes
    ]);

});



parcelRegister("2Z9D4", function(module, exports) {

let $22c8bf6d651b531f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $22c8bf6d651b531f$var$load("1whFq").then(()=>parcelRequire('3Hy6N'));

});


parcelRegister("heI7y", function(module, exports) {

$parcel$export(module.exports, "useHasOpened", () => $c02ba9c4f48115f2$export$cbaabcded53b5c1f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $h97QA = parcelRequire("h97QA");
const $c02ba9c4f48115f2$var$actions = {
    setHasOpened: $h97QA.setHasOpened
};
const $c02ba9c4f48115f2$var$initialState = {
    hasOpened: false
};
const $c02ba9c4f48115f2$var$Store = (0, $iXqE5.createStore)({
    initialState: $c02ba9c4f48115f2$var$initialState,
    actions: $c02ba9c4f48115f2$var$actions,
    name: 'jsw-onboarding-quickstart-has-opened'
});
const $c02ba9c4f48115f2$export$cbaabcded53b5c1f = (0, $3sQ5x.createHook)($c02ba9c4f48115f2$var$Store);

});
parcelRegister("h97QA", function(module, exports) {

$parcel$export(module.exports, "setHasOpened", () => $68011af9f70af395$export$c4743c64a7c42294);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $68011af9f70af395$export$c4743c64a7c42294 = ()=>({ getState: getState, setState: setState })=>{
        const { hasOpened: hasOpened } = getState();
        if (hasOpened === true) // if state has been updated already return
        return;
        setState({
            hasOpened: true
        });
    };
var $68011af9f70af395$export$2e2bcd8739ae039 = $68011af9f70af395$export$c4743c64a7c42294;

});





parcelRegister("67KAW", function(module, exports) {

$parcel$export(module.exports, "Nav4Assets", () => $ddf4be88098c0b0a$export$ae278c7655ee6005);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $7DxXA = parcelRequire("7DxXA");

var $ahEft = parcelRequire("ahEft");

var $j8qoE = parcelRequire("j8qoE");

var $9OXo1 = parcelRequire("9OXo1");

var $4R6GH = parcelRequire("4R6GH");

var $kT9FG = parcelRequire("kT9FG");

var $j054R = parcelRequire("j054R");
function $ddf4be88098c0b0a$export$ae278c7655ee6005({ isExpanded: isExpanded }) {
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    // useInsightVisibility can help fetch WorkspaceId
    const _ = (0, $7DxXA.useInsightVisibility)();
    const isPremiumUser = (0, $ahEft.isLicensedPremiumUser)(tenantContext);
    const { workspaceId: workspaceId } = (0, $7DxXA.useWorkspaceContext)();
    if (!isPremiumUser) {
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'cmdbUpsellPageButton viewed', {
            serviceDeskEdition: tenantContext.appEditions?.serviceDesk,
            isSiteAdmin: tenantContext.isSiteAdmin
        });
        if ((0, $4R6GH.fg)('assets_as_an_app_v2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j054R.AssetsAppItem), {
            showUpsell: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kT9FG.AssetsSingleMenuItem), {
            showUpsellLozenge: true
        });
    }
    if ((0, $4R6GH.fg)('assets_as_an_app_v2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j054R.AssetsAppItem), {
        showUpsell: false
    });
    return workspaceId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8qoE.InsightGlobalConfigContainer), {
        isGlobal: true,
        workspaceId: workspaceId,
        createAnalyticsEvent: createAnalyticsEvent,
        disableOnInit: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kT9FG.AssetsMenu), {
        isExpanded: isExpanded
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kT9FG.AssetsSingleMenuItem), {
        showUpsellLozenge: false
    });
}

});
parcelRegister("7DxXA", function(module, exports) {

$parcel$export(module.exports, "useWorkspaceContext", () => $5d7c6ac21f7af915$export$827d903316fc333c);
$parcel$export(module.exports, "useInsightVisibility", () => $5d7c6ac21f7af915$export$74ebc9a49f60d38a);

var $5uXOq = parcelRequire("5uXOq");

var $ktP1V = parcelRequire("ktP1V");

var $9OXo1 = parcelRequire("9OXo1");

var $2YP9W = parcelRequire("2YP9W");

var $ahEft = parcelRequire("ahEft");

var $gRzZD = parcelRequire("gRzZD");
const $5d7c6ac21f7af915$export$a0002067fa97246a = '/rest/servicedesk/cmdb/latest/workspace';
const $5d7c6ac21f7af915$export$122fccf0bbbc9acc = 30000;
const $5d7c6ac21f7af915$export$827d903316fc333c = ()=>{
    const { data: data, loading: loading, error: error, refresh: fetchWorkspaceId } = (0, $2YP9W.useResource)((0, $gRzZD.workspaceResource));
    const workspaceId = data ?? undefined;
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null | undefined'.
        error,
        workspaceId: workspaceId,
        fetchWorkspaceId: fetchWorkspaceId
    };
};
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
const $5d7c6ac21f7af915$var$useInterval = (callback, delay)=>{
    const savedCallback = (0, $5uXOq.useRef)(callback);
    // Remember the latest callback.
    (0, $5uXOq.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0, $5uXOq.useEffect)(()=>{
        const tick = ()=>{
            savedCallback.current();
        };
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
        return undefined;
    }, [
        delay
    ]);
};
const $5d7c6ac21f7af915$export$74ebc9a49f60d38a = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { workspaceId: workspaceId, fetchWorkspaceId: fetchWorkspaceId, loading: loading } = $5d7c6ac21f7af915$export$827d903316fc333c();
    // Optimistically set this true if user is premium and CMDB is enabled in environment - which will prevent a flash for the majority of users
    const [isVisible, setIsVisible] = (0, $5uXOq.useState)((0, $ktP1V.isCMDBEnabledInEnvironment)() && (0, $ahEft.isLicensedPremiumUser)(tenantContext));
    const [shouldPollForWorkspaceId, setShouldPollForWorkspaceId] = (0, $5uXOq.useState)(false);
    const [hasFetchedWorkspaceId, setHasFetchedWorkspaceId] = (0, $5uXOq.useState)(false);
    // Can't test this component without a rerender on each poll — so am just increment a counter with each poll
    const [, setPollCount] = (0, $5uXOq.useState)(0);
    // Run an initial fetch of the workspaceId if the resource wasn't already fetched as
    // part of the route definition (like for the Insight menu in the global nav)
    (0, $5uXOq.useEffect)(()=>{
        if (!workspaceId && (0, $ahEft.isLicensedPremiumUser)(tenantContext) && (0, $ktP1V.isCMDBEnabledInEnvironment)()) {
            fetchWorkspaceId();
            setHasFetchedWorkspaceId(true);
        }
    }, [
        fetchWorkspaceId,
        tenantContext,
        workspaceId
    ]);
    // Starts/stops the polling of workspaceId
    $5d7c6ac21f7af915$var$useInterval(()=>{
        fetchWorkspaceId();
        setPollCount((a)=>a + 1);
    }, shouldPollForWorkspaceId ? $5d7c6ac21f7af915$export$122fccf0bbbc9acc : null);
    // Main check to see if insight should be visible
    // If user has premium subscription but no workspace ID, we begin polling for the
    // workspace ID as it means their Insight instance hasn’t completed provisioning yet
    (0, $5uXOq.useEffect)(()=>{
        if (hasFetchedWorkspaceId && !loading) {
            if ((0, $ahEft.isLicensedPremiumUser)(tenantContext)) {
                if (workspaceId !== undefined) {
                    setIsVisible(true);
                    setShouldPollForWorkspaceId(false);
                } else {
                    setIsVisible(false);
                    setShouldPollForWorkspaceId(true);
                }
            } else {
                setIsVisible(false);
                setShouldPollForWorkspaceId(false);
            }
        }
    }, [
        tenantContext,
        workspaceId,
        loading,
        hasFetchedWorkspaceId
    ]);
    return isVisible;
};

});

parcelRegister("j8qoE", function(module, exports) {

$parcel$export(module.exports, "useInsightGlobalConfig", () => $39a17ba3a31a7663$export$ee996472bb397b41);
$parcel$export(module.exports, "useInsightReferenceTypes", () => $39a17ba3a31a7663$export$efb93af726a65b26);
$parcel$export(module.exports, "useInsightStatusTypes", () => $39a17ba3a31a7663$export$7eefa9cea32e596a);
$parcel$export(module.exports, "useInsightIcons", () => $39a17ba3a31a7663$export$8336b36336c9f3c8);
$parcel$export(module.exports, "useDataManager", () => $39a17ba3a31a7663$export$143bcc72da01e561);
$parcel$export(module.exports, "useNamedInsightIcons", () => $39a17ba3a31a7663$export$979b264266dab4ed);
$parcel$export(module.exports, "useIsRestrictedSchema", () => $39a17ba3a31a7663$export$d07372ba961b2bc5);
$parcel$export(module.exports, "InsightGlobalConfigContainer", () => $39a17ba3a31a7663$export$c4c69c73d422ea06);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");

var $5Jzjf = parcelRequire("5Jzjf");

var $3SYcN = parcelRequire("3SYcN");
const $39a17ba3a31a7663$export$d4c72bab9d6cc13a = {
    loading: false,
    error: undefined,
    config: undefined,
    referenceTypes: {
        data: undefined,
        createLoading: false,
        createError: undefined,
        deleteLoading: false,
        deleteError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    statusTypes: {
        data: undefined,
        createLoading: false,
        createError: undefined,
        deleteLoading: false,
        deleteError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    icons: {
        data: undefined,
        deleteLoading: false,
        deleteError: undefined,
        addLoading: false,
        addError: undefined,
        updateLoading: false,
        updateError: undefined
    },
    dataManager: {
        rolesData: undefined,
        rolesError: undefined,
        rolesLoading: false,
        rolesUpdateLoading: false,
        rolesUpdateError: undefined,
        tokensLoading: false,
        tokensData: undefined,
        tokensError: undefined,
        tokenRevokeLoading: false,
        tokenRevokeError: undefined,
        isProvisioned: undefined,
        provisioningLoading: false,
        provisioningError: undefined,
        provisioningUpdateLoading: false,
        provisioningUpdateError: undefined,
        myRoles: undefined,
        myRolesError: undefined,
        myRolesLoading: false
    }
};
const $39a17ba3a31a7663$var$Store = (0, $iXqE5.createStore)({
    initialState: $39a17ba3a31a7663$export$d4c72bab9d6cc13a,
    actions: $5Jzjf.actions
});
const $39a17ba3a31a7663$export$ee996472bb397b41 = (0, $3sQ5x.createHook)($39a17ba3a31a7663$var$Store, {
    selector: (state)=>state
});
const $39a17ba3a31a7663$export$efb93af726a65b26 = (0, $3sQ5x.createHook)($39a17ba3a31a7663$var$Store, {
    selector: ({ referenceTypes: referenceTypes })=>({
            ...referenceTypes,
            data: referenceTypes.data ? (0, $3SYcN.sortReferenceTypes)(referenceTypes.data) : undefined
        })
});
const $39a17ba3a31a7663$export$7eefa9cea32e596a = (0, $3sQ5x.createHook)($39a17ba3a31a7663$var$Store, {
    selector: ({ statusTypes: statusTypes })=>({
            ...statusTypes,
            data: statusTypes.data ? (0, $3SYcN.sortStatusTypes)(statusTypes.data) : undefined
        })
});
const $39a17ba3a31a7663$export$8336b36336c9f3c8 = (0, $3sQ5x.createHook)($39a17ba3a31a7663$var$Store, {
    selector: ({ icons: icons })=>icons
});
const $39a17ba3a31a7663$export$143bcc72da01e561 = (0, $3sQ5x.createHook)($39a17ba3a31a7663$var$Store, {
    selector: ({ dataManager: dataManager })=>dataManager
});
const $39a17ba3a31a7663$export$979b264266dab4ed = (0, $3sQ5x.createStateHook)($39a17ba3a31a7663$var$Store, {
    selector: ({ icons: icons })=>{
        const map = {};
        (icons.data ?? []).forEach((icon)=>{
            map[icon.name] = icon;
        });
        return map;
    }
});
const $39a17ba3a31a7663$export$9c8eee3abcaa634e = (state, schemaId)=>{
    const restrictedObjectSchemaIds = state.config?.restrictedObjectSchemaIds ?? [];
    return restrictedObjectSchemaIds.includes(parseInt(schemaId, 10));
};
const $39a17ba3a31a7663$export$d07372ba961b2bc5 = (0, $3sQ5x.createHook)($39a17ba3a31a7663$var$Store, {
    selector: $39a17ba3a31a7663$export$9c8eee3abcaa634e
});
const $39a17ba3a31a7663$var$autoFetchGlobalConfig = ()=>({ dispatch: dispatch, getState: getState }, { disableOnInit: disableOnInit })=>{
        const { loading: loading, error: error, config: config } = getState();
        if (!disableOnInit && !loading && !error && !config) {
            dispatch((0, $5Jzjf.actions).fetchGlobalConfig());
            if ((0, $4R6GH.fg)('assets_as_an_app_v2')) {
                dispatch((0, $5Jzjf.actions).fetchProvisioningStatus());
                dispatch((0, $5Jzjf.actions).fetchMyDataManagerRoles());
            }
        }
    };
const $39a17ba3a31a7663$export$c4c69c73d422ea06 = (0, $gg7kZ.createContainer)($39a17ba3a31a7663$var$Store, {
    onInit: $39a17ba3a31a7663$var$autoFetchGlobalConfig
});

});
parcelRegister("5Jzjf", function(module, exports) {

$parcel$export(module.exports, "actions", () => $f2ab8bdfc51ba92b$export$e324594224ef24da);

var $h3JSQ = parcelRequire("h3JSQ");

var $afOgx = parcelRequire("afOgx");

var $dLfth = parcelRequire("dLfth");

var $irXYU = parcelRequire("irXYU");

var $jz1my = parcelRequire("jz1my");

var $3MY0W = parcelRequire("3MY0W");

var $3WfMh = parcelRequire("3WfMh");

var $eiTPs = parcelRequire("eiTPs");

var $8u5AZ = parcelRequire("8u5AZ");

var $5VTnO = parcelRequire("5VTnO");

var $axmNY = parcelRequire("axmNY");

var $j9kxm = parcelRequire("j9kxm");

var $yPoOn = parcelRequire("yPoOn");

var $akTZj = parcelRequire("akTZj");

var $czU2t = parcelRequire("czU2t");

var $lsHFw = parcelRequire("lsHFw");
const $f2ab8bdfc51ba92b$export$e324594224ef24da = {
    addIcon: $h3JSQ.addIcon,
    createReferenceType: $afOgx.createReferenceType,
    createStatusType: $dLfth.createStatusType,
    deleteIcon: $irXYU.deleteIcon,
    deleteReferenceType: $jz1my.deleteReferenceType,
    deleteStatusType: $3MY0W.deleteStatusType,
    fetchDataManagerTokens: $axmNY.fetchDataManagerTokens,
    fetchGlobalConfig: $3WfMh.fetchGlobalConfig,
    fetchMyDataManagerRoles: $eiTPs.fetchMyDataManagerRoles,
    fetchPrincipalsForRoles: $8u5AZ.fetchPrincipalsForRoles,
    fetchProvisioningStatus: $5VTnO.fetchProvisioningStatus,
    setIcon: $yPoOn.setIcon,
    setReferenceType: $czU2t.setReferenceType,
    setStatusType: $lsHFw.setStatusType,
    updateDataManagerRole: $j9kxm.updateDataManagerRole,
    updateIcon: $yPoOn.updateIcon,
    updateProvisioningStatus: $akTZj.updateProvisioningStatus,
    updateReferenceType: $czU2t.updateReferenceType,
    updateStatusType: $lsHFw.updateStatusType
};

});
parcelRegister("h3JSQ", function(module, exports) {

$parcel$export(module.exports, "addIcon", () => $8a6a0321f1a1ecf0$export$3488242433cbedb);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $5Ny9E = parcelRequire("5Ny9E");

var $gm5wx = parcelRequire("gm5wx");

var $lbRfL = parcelRequire("lbRfL");
const $8a6a0321f1a1ecf0$export$3488242433cbedb = (newIcon)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                addLoading: true
            }
        });
        try {
            const uploadCredentials = await (0, $lbRfL.mediaInfoForUpload)((0, $5Ny9E.toWorkspaceId)(workspaceId));
            const uploadMediaResult = await (0, $lbRfL.mediaUploadFile)({
                mediaBaseUrl: (0, $gm5wx.toMediaBaseUrl)(uploadCredentials.mediaBaseUrl),
                collectionId: (0, $gm5wx.toCollectionId)(uploadCredentials.collectionId),
                fileName: (0, $gm5wx.toFileName)(newIcon.fileName),
                clientId: (0, $gm5wx.toMediaClientId)(uploadCredentials.clientId),
                mediaJwtToken: (0, $gm5wx.toMediaJwt)(uploadCredentials.mediaJwtToken),
                blob: newIcon.blob
            });
            const mediaInfoForPullingResult = await (0, $lbRfL.mediaInfoForPulling)((0, $5Ny9E.toWorkspaceId)(workspaceId), (0, $gm5wx.toMediaFileUuid)(uploadMediaResult.data.id));
            const pollMediaFileReady = ()=>{
                const getMediaFileStatus = ()=>(0, $lbRfL.mediaGetFileInfo)({
                        mediaBaseUrl: (0, $gm5wx.toMediaBaseUrl)(mediaInfoForPullingResult.mediaBaseUrl),
                        mediaFileUuid: (0, $gm5wx.toMediaFileUuid)(uploadMediaResult.data.id),
                        clientId: (0, $gm5wx.toMediaClientId)(uploadCredentials.clientId),
                        mediaJwtToken: (0, $gm5wx.toMediaJwt)(mediaInfoForPullingResult.mediaJwtToken)
                    });
                return new Promise((resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
                reject)=>{
                    const poll = (attempt = 0)=>{
                        const statusPromise = getMediaFileStatus();
                        statusPromise.then((response)=>{
                            const status = response.data.processingStatus;
                            switch(status){
                                default:
                                case (0, $gm5wx.MEDIA_PROCESS_STATUS).PENDING:
                                case (0, $gm5wx.MEDIA_PROCESS_STATUS).RUNNING:
                                    return setTimeout(()=>{
                                        // 20 tries before throwing an error
                                        if (attempt > 20) return reject(new Error('Failed to add icon after 10 tries'));
                                        return poll(attempt + 1);
                                    }, 5000);
                                case (0, $gm5wx.MEDIA_PROCESS_STATUS).SUCCEEDED:
                                    // @ts-expect-error - TS2794 - Expected 1 arguments, but got 0. Did you forget to include 'void' in your type argument to 'Promise'?
                                    return resolve();
                                case (0, $gm5wx.MEDIA_PROCESS_STATUS).FAILED:
                                    return reject(new Error('Media services failed to process file!'));
                            }
                        }).catch((error)=>reject(new Error(error)));
                    };
                    poll();
                });
            };
            await pollMediaFileReady();
            const savedIconEntry = await (0, $lbRfL.publishNewIcon)((0, $5Ny9E.toWorkspaceId)(workspaceId), (0, $gm5wx.toIconName)(newIcon.iconName), (0, $gm5wx.toMediaFileUuid)(uploadMediaResult.data.id));
            // Make flow happy
            if (!Array.isArray(state.icons.data)) throw new Error('Invalid state! Icons data is not array!');
            const newIconsData = state.icons.data.slice(0);
            newIconsData.unshift(savedIconEntry);
            const newState = {
                ...state,
                icons: {
                    ...state.icons,
                    addLoading: false,
                    data: newIconsData
                }
            };
            setState(newState);
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'addIcon succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    addLoading: false,
                    addError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'addIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("xJtdX", function(module, exports) {

$parcel$export(module.exports, "fireCmdbErrorAnalytics", () => $f8d3fdda5fdae8d1$export$50d4fa14efd248c2);

var $jcw0u = parcelRequire("jcw0u");
const $f8d3fdda5fdae8d1$export$50d4fa14efd248c2 = (payload)=>{
    return (0, $jcw0u.default)(payload);
};

});

parcelRegister("gm5wx", function(module, exports) {

$parcel$export(module.exports, "MEDIA_PROCESS_STATUS", () => $1ed2f93c2402a594$export$a760cae7c12e7f51);
$parcel$export(module.exports, "toMediaBaseUrl", () => $1ed2f93c2402a594$export$342e5c2fdd47297c);
$parcel$export(module.exports, "toCollectionId", () => $1ed2f93c2402a594$export$59b8a2c37e183bf5);
$parcel$export(module.exports, "toIconName", () => $1ed2f93c2402a594$export$41540e96af228b1a);
$parcel$export(module.exports, "toFileName", () => $1ed2f93c2402a594$export$249aa0c12095aafd);
$parcel$export(module.exports, "toMediaJwt", () => $1ed2f93c2402a594$export$dce78fe68aa68f20);
$parcel$export(module.exports, "toMediaFileUuid", () => $1ed2f93c2402a594$export$79083a8ab294d28e);
$parcel$export(module.exports, "toMediaClientId", () => $1ed2f93c2402a594$export$b105972f97cb69fa);
const $1ed2f93c2402a594$export$a760cae7c12e7f51 = {
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    PENDING: 'pending',
    RUNNING: 'running'
};
const $1ed2f93c2402a594$export$342e5c2fdd47297c = (url)=>url;
const $1ed2f93c2402a594$export$59b8a2c37e183bf5 = (uuid)=>uuid;
const $1ed2f93c2402a594$export$41540e96af228b1a = (iconName)=>iconName;
const $1ed2f93c2402a594$export$249aa0c12095aafd = (fileName)=>fileName;
const $1ed2f93c2402a594$export$9dd52a3c923cba73 = (mediaIssuer)=>mediaIssuer;
const $1ed2f93c2402a594$export$dce78fe68aa68f20 = (mediaIssuer)=>mediaIssuer;
const $1ed2f93c2402a594$export$79083a8ab294d28e = (mediaFileUuid)=>mediaFileUuid;
const $1ed2f93c2402a594$export$b105972f97cb69fa = (mediaClientId)=>mediaClientId;

});

parcelRegister("lbRfL", function(module, exports) {

$parcel$export(module.exports, "mediaInfoForUpload", () => $4a8bb82a4fdfb7bb$export$c7944179dc1cb15d);
$parcel$export(module.exports, "mediaUploadFile", () => $4a8bb82a4fdfb7bb$export$6fba374ded90c76b);
$parcel$export(module.exports, "mediaInfoForPulling", () => $4a8bb82a4fdfb7bb$export$4138ca7fa1c5dcbc);
$parcel$export(module.exports, "mediaGetFileInfo", () => $4a8bb82a4fdfb7bb$export$c607c6f99a3a53ca);
$parcel$export(module.exports, "publishNewIcon", () => $4a8bb82a4fdfb7bb$export$a7fc7d8db8ccf9da);

var $eusud = parcelRequire("eusud");

var $4VpwK = parcelRequire("4VpwK");

var $3jFL4 = parcelRequire("3jFL4");
const $4a8bb82a4fdfb7bb$export$336c36f125eba39c = ({ clientId: clientId, mediaJwtToken: mediaJwtToken })=>{
    return {
        'X-Client-Id': clientId,
        Authorization: `Bearer ${mediaJwtToken}`
    };
};
const $4a8bb82a4fdfb7bb$export$c7944179dc1cb15d = (workspaceId)=>(0, $4VpwK.performCmdbGetRequest)((0, $3jFL4.getCmdbIconTokenUploadingUrl)(workspaceId));
const $4a8bb82a4fdfb7bb$export$6fba374ded90c76b = ({ mediaBaseUrl: mediaBaseUrl, collectionId: collectionId, fileName: fileName, mediaJwtToken: mediaJwtToken, blob: blob, clientId: clientId })=>(0, $eusud.performPostRequest)(`${String(mediaBaseUrl)}/file/binary?collection=${String(collectionId)}&name=${String(fileName)}&deletable=true`, {
        headers: {
            ...$4a8bb82a4fdfb7bb$export$336c36f125eba39c({
                clientId: clientId,
                mediaJwtToken: mediaJwtToken
            }),
            'Content-Type': blob.type
        },
        body: blob
    });
const $4a8bb82a4fdfb7bb$export$4138ca7fa1c5dcbc = (workspaceId, fileUuid)=>(0, $4VpwK.performCmdbGetRequest)((0, $3jFL4.getCmdbIconTokenFetchingUrl)(workspaceId, fileUuid));
const $4a8bb82a4fdfb7bb$export$c607c6f99a3a53ca = ({ mediaBaseUrl: mediaBaseUrl, mediaFileUuid: mediaFileUuid, mediaJwtToken: mediaJwtToken, clientId: clientId })=>(0, $eusud.performGetRequest)(`${String(mediaBaseUrl)}/file/${String(mediaFileUuid)}`, {
        headers: $4a8bb82a4fdfb7bb$export$336c36f125eba39c({
            clientId: clientId,
            mediaJwtToken: mediaJwtToken
        })
    });
const $4a8bb82a4fdfb7bb$export$a7fc7d8db8ccf9da = (workspaceId, iconName, mediaFileUuid)=>(0, $4VpwK.performCmdbPostRequest)((0, $3jFL4.getCmdbIconCreateUrl)(workspaceId), {
        body: JSON.stringify({
            name: iconName,
            mediaFileUuid: mediaFileUuid
        })
    });

});
parcelRegister("3jFL4", function(module, exports) {

$parcel$export(module.exports, "getCmdbIconCreateUrl", () => $af0daf8901be8d29$export$4c6ff27b48881aba);
$parcel$export(module.exports, "getCmdbIconTokenFetchingUrl", () => $af0daf8901be8d29$export$39e83f10cc93fe99);
$parcel$export(module.exports, "getCmdbIconTokenUploadingUrl", () => $af0daf8901be8d29$export$7fdc9cd59a492763);
$parcel$export(module.exports, "getCmdbIconByIdUrl", () => $af0daf8901be8d29$export$b881a625e1bc4876);

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/icon
 */ const $af0daf8901be8d29$var$getCmdbIconUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/icon`;
const $af0daf8901be8d29$export$4c6ff27b48881aba = (workspaceId)=>`${$af0daf8901be8d29$var$getCmdbIconUrl(workspaceId)}/create`;
const $af0daf8901be8d29$export$39e83f10cc93fe99 = (workspaceId, fileUuid)=>`${$af0daf8901be8d29$var$getCmdbIconUrl(workspaceId)}/token-for-fetching-icon/${fileUuid}`;
const $af0daf8901be8d29$export$7fdc9cd59a492763 = (workspaceId)=>`${$af0daf8901be8d29$var$getCmdbIconUrl(workspaceId)}/token-for-uploading-icon`;
const $af0daf8901be8d29$export$b881a625e1bc4876 = (workspaceId, iconId)=>`${$af0daf8901be8d29$var$getCmdbIconUrl(workspaceId)}/${iconId}`;

});
parcelRegister("klJ8b", function(module, exports) {

$parcel$export(module.exports, "getCmdbRestBaseUrl", () => $a22cc15ea8014e15$export$28b6c003daedf1c2);
const $a22cc15ea8014e15$export$28b6c003daedf1c2 = (workspaceId)=>`/gateway/api/jsm/assets/workspace/${workspaceId}/v1`;

});




parcelRegister("afOgx", function(module, exports) {

$parcel$export(module.exports, "createReferenceType", () => $e882d4e4e4fabf3c$export$ac28770630794807);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $Zsxbh = parcelRequire("Zsxbh");
const $e882d4e4e4fabf3c$export$ac28770630794807 = (data)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                createLoading: true
            }
        });
        try {
            const response = await (0, $4VpwK.performCmdbPostRequest)((0, $Zsxbh.getCmdbConfigReferenceTypeUrl)(workspaceId), {
                body: JSON.stringify({
                    ...data,
                    color: data.color.replace('#', '')
                })
            });
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    createLoading: false,
                    data: [
                        ...state.referenceTypes.data ?? [],
                        response
                    ]
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'createReferenceType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    createLoading: false,
                    createError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'createReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("Zsxbh", function(module, exports) {

$parcel$export(module.exports, "getCmdbConfigStatusTypeUrl", () => $72391202dbecf10a$export$3269d36b59c9d27f);
$parcel$export(module.exports, "getCmdbConfigStatusTypeByIdUrl", () => $72391202dbecf10a$export$229964acb6a55e5);
$parcel$export(module.exports, "getCmdbConfigStatusTypePickerUrl", () => $72391202dbecf10a$export$1991fb4d07b18469);
$parcel$export(module.exports, "getCmdbConfigReferenceTypeUrl", () => $72391202dbecf10a$export$ad07341c88d2bbab);
$parcel$export(module.exports, "getCmdbConfigReferenceTypeByIdUrl", () => $72391202dbecf10a$export$293e2bfa6752a2aa);
$parcel$export(module.exports, "getCmdbConfigRoleByIdUrl", () => $72391202dbecf10a$export$225d5f547cc90d86);
$parcel$export(module.exports, "getCmdbConfigRoleObjectSchemaByIdUrl", () => $72391202dbecf10a$export$9c1d73050da32aae);
$parcel$export(module.exports, "getCmdbConfigRoleObjectTypeByIdUrl", () => $72391202dbecf10a$export$6583ed007df50d2b);
$parcel$export(module.exports, "getCmdbPermsPrincipalUrl", () => $72391202dbecf10a$export$a635e2e9382b1621);
$parcel$export(module.exports, "getCmdbPermsRoleAssignmentUrl", () => $72391202dbecf10a$export$b3cb4590859563b0);
$parcel$export(module.exports, "getCmdbPermsTokenStatusUrl", () => $72391202dbecf10a$export$8ae00db5fd7218c5);
$parcel$export(module.exports, "getMyDataManagerRolesUrl", () => $72391202dbecf10a$export$794aa3ae46133f30);

var $ebyGx = parcelRequire("ebyGx");

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/config
 */ const $72391202dbecf10a$var$getCmdbConfigUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/config`;
const $72391202dbecf10a$export$3269d36b59c9d27f = (workspaceId, queryParams)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/statustype${queryParams ? `?${(0, $ebyGx.stringify)(queryParams)}` : ''}`;
const $72391202dbecf10a$export$229964acb6a55e5 = (workspaceId, statusTypeId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/statustype/${statusTypeId}`;
const $72391202dbecf10a$export$1991fb4d07b18469 = (workspaceId, queryParams)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/statustype/picker?${(0, $ebyGx.stringify)(queryParams)}`;
const $72391202dbecf10a$export$ad07341c88d2bbab = (workspaceId, queryParams)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/referencetype${queryParams ? `?${(0, $ebyGx.stringify)(queryParams)}` : ''}`;
const $72391202dbecf10a$export$293e2bfa6752a2aa = (workspaceId, referenceTypeId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/referencetype/${referenceTypeId}`;
const $72391202dbecf10a$export$225d5f547cc90d86 = (workspaceId, roleId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/role/${roleId}`;
const $72391202dbecf10a$export$9c1d73050da32aae = (workspaceId, objectSchemaId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/role/objectschema/${objectSchemaId}`;
const $72391202dbecf10a$export$6583ed007df50d2b = (workspaceId, objectTypeId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/role/objecttype/${objectTypeId}`;
const $72391202dbecf10a$export$a635e2e9382b1621 = (workspaceId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/perms/principal`;
const $72391202dbecf10a$export$b3cb4590859563b0 = (workspaceId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/perms/role-assignment`;
const $72391202dbecf10a$export$8ae00db5fd7218c5 = (workspaceId, token)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/perms/token-status?token=${token}`;
const $72391202dbecf10a$export$794aa3ae46133f30 = (workspaceId)=>`${$72391202dbecf10a$var$getCmdbConfigUrl(workspaceId)}/perms/my-roles`;

});


parcelRegister("dLfth", function(module, exports) {

$parcel$export(module.exports, "createStatusType", () => $98b79b2a12298162$export$8c874b16a69a1b9d);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $Zsxbh = parcelRequire("Zsxbh");
const $98b79b2a12298162$export$8c874b16a69a1b9d = (data)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                createLoading: true
            }
        });
        try {
            const response = await (0, $4VpwK.performCmdbPostRequest)((0, $Zsxbh.getCmdbConfigStatusTypeUrl)(workspaceId), {
                body: JSON.stringify(data)
            });
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    createLoading: false,
                    data: [
                        ...state.statusTypes.data ?? [],
                        response
                    ]
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({
                source: 'insightGlobalConfigStatuses',
                action: 'created',
                actionSubject: 'insightGlobalConfigStatuses'
            }), 'insightGlobalConfigStatuses created');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    createLoading: false,
                    createError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'createStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("irXYU", function(module, exports) {

$parcel$export(module.exports, "deleteIcon", () => $2669ccdf98bb7ce7$export$12d45ee5c2161b75);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $3jFL4 = parcelRequire("3jFL4");
const $2669ccdf98bb7ce7$export$12d45ee5c2161b75 = (icon)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                deleteLoading: true
            }
        });
        try {
            await (0, $4VpwK.performCmdbDeleteRequest)((0, $3jFL4.getCmdbIconByIdUrl)(workspaceId, icon.id));
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    deleteLoading: false,
                    data: state.icons.data ? state.icons.data.filter(({ id: id })=>id !== icon.id) : undefined
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteIcon succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'deleteIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("jz1my", function(module, exports) {

$parcel$export(module.exports, "deleteReferenceType", () => $a2a9cfda90a52e02$export$432ee1f3819316e5);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $Zsxbh = parcelRequire("Zsxbh");
const $a2a9cfda90a52e02$export$432ee1f3819316e5 = (referenceType)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                deleteLoading: true
            }
        });
        try {
            await (0, $4VpwK.performCmdbDeleteRequest)((0, $Zsxbh.getCmdbConfigReferenceTypeByIdUrl)(workspaceId, referenceType.id));
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    deleteLoading: false,
                    data: state.referenceTypes.data ? state.referenceTypes.data.filter(({ id: id })=>id !== referenceType.id) : undefined
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteReferenceType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                referenceTypes: {
                    ...state.referenceTypes,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'deleteReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("3MY0W", function(module, exports) {

$parcel$export(module.exports, "deleteStatusType", () => $b29c0bec337815ce$export$812423dc05f0fc3d);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $Zsxbh = parcelRequire("Zsxbh");
const $b29c0bec337815ce$export$812423dc05f0fc3d = (statusType)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                deleteLoading: true
            }
        });
        try {
            await (0, $4VpwK.performCmdbDeleteRequest)((0, $Zsxbh.getCmdbConfigStatusTypeByIdUrl)(workspaceId, statusType.id));
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    deleteLoading: false,
                    data: state.statusTypes.data ? state.statusTypes.data.filter(({ id: id })=>id !== statusType.id) : undefined
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteStatusType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                statusTypes: {
                    ...state.statusTypes,
                    deleteLoading: false,
                    deleteError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'deleteStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("3WfMh", function(module, exports) {

$parcel$export(module.exports, "fetchGlobalConfig", () => $032f1f2dd067f8fc$export$14c75ba3f0e48e21);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $juXmc = parcelRequire("juXmc");
const $032f1f2dd067f8fc$export$14c75ba3f0e48e21 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().loading || !shouldRefetch && getState().config) return;
        setState({
            loading: true,
            error: undefined
        });
        try {
            const response = await (0, $4VpwK.performCmdbGetRequest)((0, $juXmc.getCmdbGlobalConfigUrl)(workspaceId));
            const iconListWithServiceOTEntriesRemoved = response ? response.icons.filter((item)=>item.name !== 'Applications' && item.name !== 'Business Services' && item.name !== 'Capabilities' && item.name !== 'Software Services') : undefined;
            setState({
                loading: false,
                config: {
                    ...response,
                    restrictedObjectSchemaIds: response?.restrictedObjectSchemaIds ?? [],
                    icons: iconListWithServiceOTEntriesRemoved || []
                },
                referenceTypes: {
                    ...getState().referenceTypes,
                    data: response ? response.referenceTypes : undefined
                },
                statusTypes: {
                    ...getState().statusTypes,
                    data: response ? response.statusTypes : undefined
                },
                icons: {
                    ...getState().icons,
                    data: iconListWithServiceOTEntriesRemoved
                },
                dataManager: {
                    ...getState().dataManager
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchInsightGlobalConfig succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchInsightGlobalConfig',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("juXmc", function(module, exports) {

$parcel$export(module.exports, "getCmdbGlobalConfigUrl", () => $d0e7aed8ea80c147$export$50437136a9a5e2d3);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectUrl", () => $d0e7aed8ea80c147$export$73e58b72a1074528);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectSchemaByIdUrl", () => $d0e7aed8ea80c147$export$e2019224257efde3);
$parcel$export(module.exports, "getCmdbGlobalConfigObjectSchemaByIdPropertyUrl", () => $d0e7aed8ea80c147$export$d1b25f8feb06db8a);

var $ebyGx = parcelRequire("ebyGx");

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/global
 */ const $d0e7aed8ea80c147$var$getCmdbGlobalUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/global`;
const $d0e7aed8ea80c147$export$50437136a9a5e2d3 = (workspaceId)=>`${$d0e7aed8ea80c147$var$getCmdbGlobalUrl(workspaceId)}/config`;
const $d0e7aed8ea80c147$export$73e58b72a1074528 = (workspaceId, queryParams)=>`${$d0e7aed8ea80c147$var$getCmdbGlobalUrl(workspaceId)}/config/object?${(0, $ebyGx.stringify)(queryParams)}`;
const $d0e7aed8ea80c147$export$e2019224257efde3 = (workspaceId, objectSchemaId)=>`${$d0e7aed8ea80c147$var$getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}`;
const $d0e7aed8ea80c147$export$d1b25f8feb06db8a = (workspaceId, objectSchemaId)=>`${$d0e7aed8ea80c147$var$getCmdbGlobalUrl(workspaceId)}/config/objectschema/${objectSchemaId}/property`;

});


parcelRegister("eiTPs", function(module, exports) {

$parcel$export(module.exports, "fetchMyDataManagerRoles", () => $716ec7c261a3e8b3$export$2211f294ebd95b92);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $Zsxbh = parcelRequire("Zsxbh");
const $716ec7c261a3e8b3$export$2211f294ebd95b92 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().dataManager.myRolesLoading || !shouldRefetch && getState().dataManager.myRoles) return;
        setState({
            dataManager: {
                ...getState().dataManager,
                myRolesLoading: true,
                myRolesError: undefined
            }
        });
        try {
            const myRoles = await (0, $4VpwK.performCmdbGetRequest)((0, $Zsxbh.getMyDataManagerRolesUrl)(workspaceId));
            setState({
                dataManager: {
                    ...getState().dataManager,
                    myRoles: myRoles.results,
                    myRolesLoading: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchMyDataManagerRoles succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                dataManager: {
                    ...getState().dataManager,
                    myRolesLoading: false,
                    myRolesError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchMyDataManagerRoles',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("8u5AZ", function(module, exports) {

$parcel$export(module.exports, "fetchPrincipalsForRoles", () => $3daa0c86c5959b28$export$9c5110cfdcb72b5);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $Zsxbh = parcelRequire("Zsxbh");
const $3daa0c86c5959b28$export$9c5110cfdcb72b5 = (roleIds)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.rolesLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                rolesLoading: true
            }
        });
        try {
            const requestBody = {
                roleIds: roleIds,
                resourceId: `ari:cloud:cmdb::workspace/${workspaceId}`
            };
            const principalIdsForRoles = await (0, $4VpwK.performCmdbPostRequest)((0, $Zsxbh.getCmdbPermsPrincipalUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            setState({
                dataManager: {
                    ...state.dataManager,
                    rolesData: principalIdsForRoles.results,
                    rolesLoading: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchPrincipalsForRoles succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesLoading: false,
                    rolesError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchPrincipalsForRoles',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("5VTnO", function(module, exports) {

$parcel$export(module.exports, "fetchProvisioningStatus", () => $1d2259843f354494$export$aa3ea988cce42be1);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $8OEkP = parcelRequire("8OEkP");
const $1d2259843f354494$export$aa3ea988cce42be1 = (shouldRefetch = true)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().dataManager.provisioningLoading || !shouldRefetch && // isProvisioned is a boolean so needs to specifically check undefined
        getState().dataManager.isProvisioned !== undefined) return;
        setState({
            dataManager: {
                ...getState().dataManager,
                provisioningLoading: true,
                provisioningError: undefined
            }
        });
        try {
            const result = await (0, $4VpwK.performCmdbGetRequest)((0, $8OEkP.getDataManagerProvisioningStatusUrl)(workspaceId));
            setState({
                dataManager: {
                    ...getState().dataManager,
                    isProvisioned: $1d2259843f354494$var$isProvisioned(result.enabled),
                    provisioningLoading: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchProvisioningStatus succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                dataManager: {
                    ...getState().dataManager,
                    provisioningLoading: false,
                    provisioningError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchProvisioningStatus',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };
const $1d2259843f354494$var$isProvisioned = (status)=>status === 'ON';

});
parcelRegister("8OEkP", function(module, exports) {

$parcel$export(module.exports, "getDataManagerGenerateContainerTokenUrl", () => $5d534e44ee8c7958$export$5f42b4e80a66d7c);
$parcel$export(module.exports, "delDataManagerContainerTokenUrl", () => $5d534e44ee8c7958$export$ddc5a4cb751fae27);
$parcel$export(module.exports, "getDataManagerFetchContainerTokenUrl", () => $5d534e44ee8c7958$export$591d877d695dbd95);
$parcel$export(module.exports, "getDataManagerProvisioningStatusUrl", () => $5d534e44ee8c7958$export$1dd01c50c7948938);

var $klJ8b = parcelRequire("klJ8b");
const $5d534e44ee8c7958$export$5f42b4e80a66d7c = (workspaceId, label, type, duration)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token/${type}?label=${label}&duration=${duration}`;
const $5d534e44ee8c7958$export$ddc5a4cb751fae27 = (workspaceId, tokenID)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token/${tokenID}`;
const $5d534e44ee8c7958$export$591d877d695dbd95 = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/data-manager/token`;
const $5d534e44ee8c7958$export$1dd01c50c7948938 = (workspaceId)=>`${$5d534e44ee8c7958$var$getAirtrackAppRestBaseUrl(workspaceId)}/config/sync/provisioningstatus`;
const $5d534e44ee8c7958$var$getAirtrackAppRestBaseUrl = (workspaceId)=>`/gateway/api/jsm/data-manager/workspace/${workspaceId}/app`;

});


parcelRegister("axmNY", function(module, exports) {

$parcel$export(module.exports, "fetchDataManagerTokens", () => $7c2d95880f7fa57e$export$c6b3de84befa4259);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $8OEkP = parcelRequire("8OEkP");
const $7c2d95880f7fa57e$export$c6b3de84befa4259 = ()=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.tokensLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                tokensLoading: true
            }
        });
        try {
            const tokenDetails = await (0, $4VpwK.performCmdbGetRequest)((0, $8OEkP.getDataManagerFetchContainerTokenUrl)(workspaceId));
            setState({
                dataManager: {
                    ...state.dataManager,
                    tokensData: tokenDetails.tokens,
                    tokensLoading: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchDataManagerTokens succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    tokensLoading: false,
                    tokensError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchDataManagerTokens',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("j9kxm", function(module, exports) {

$parcel$export(module.exports, "updateDataManagerRole", () => $4b933e04f7b1c1e3$export$314337b594e79a51);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $Zsxbh = parcelRequire("Zsxbh");
const $4b933e04f7b1c1e3$export$93aad6482f82f57d = 5000;
const $4b933e04f7b1c1e3$export$214f23982cabf5f8 = 1000;
const $4b933e04f7b1c1e3$export$314337b594e79a51 = ({ principalIds: principalIds, roleId: roleId })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.rolesUpdateLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                rolesUpdateLoading: true
            }
        });
        try {
            const requestBody = {
                principalIds: principalIds,
                roleId: roleId,
                resourceType: 'workspace'
            };
            const updateRolesResponse = await (0, $4VpwK.performCmdbPutRequest)((0, $Zsxbh.getCmdbPermsRoleAssignmentUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            const pollTimeoutTime = new Date(Date.now() + $4b933e04f7b1c1e3$export$93aad6482f82f57d).getTime();
            // poll the checking of the token status for 5 seconds as updating of
            // Identity role assignments have eventually consistency
            const tryPollTokenStatus = async (resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
            reject)=>{
                if (Date.now() > pollTimeoutTime) {
                    reject(new Error('Some role assignments have failed or is still in progress'));
                    return;
                }
                try {
                    const url = (0, $Zsxbh.getCmdbPermsTokenStatusUrl)(workspaceId, updateRolesResponse.tokens[updateRolesResponse.tokens.length - 1]);
                    const updateRoleAssignmentToken = await (0, $4VpwK.performCmdbGetRequest)(url);
                    if (updateRoleAssignmentToken.isSuccessful) {
                        resolve();
                        return;
                    }
                    setTimeout(()=>{
                        tryPollTokenStatus(resolve, reject);
                    }, $4b933e04f7b1c1e3$export$214f23982cabf5f8);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    // Ignore unexpected network/server error and quickly retry
                    setTimeout(()=>{
                        tryPollTokenStatus(resolve, reject);
                    }, $4b933e04f7b1c1e3$export$214f23982cabf5f8);
                }
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            await new Promise((res, rej)=>tryPollTokenStatus(res, rej));
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesUpdateLoading: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateDataManagerRole succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    rolesUpdateLoading: false,
                    rolesUpdateError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateDataManagerRole',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'data-manager'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("yPoOn", function(module, exports) {

$parcel$export(module.exports, "setIcon", () => $95e73dfa2b8a3d46$export$33914de34c28be6c);
$parcel$export(module.exports, "updateIcon", () => $95e73dfa2b8a3d46$export$89ea7ff652eb14dd);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $3jFL4 = parcelRequire("3jFL4");
const $95e73dfa2b8a3d46$export$33914de34c28be6c = (updatedIcon)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.icons.data?.map((icon)=>icon.id === updatedIcon.id ? updatedIcon : icon);
        setState({
            ...state,
            icons: {
                ...state.icons,
                data: updatedData
            }
        });
    };
const $95e73dfa2b8a3d46$export$89ea7ff652eb14dd = ({ iconId: iconId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            icons: {
                ...state.icons,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $4VpwK.performCmdbPutRequest)((0, $3jFL4.getCmdbIconByIdUrl)(workspaceId, iconId), {
                body: JSON.stringify(updatedProperties)
            });
            const updatedState = getState();
            const updatedData = updatedState.icons.data?.map((icon)=>icon.id === response.id ? response : icon);
            setState({
                ...updatedState,
                icons: {
                    ...updatedState.icons,
                    updateLoading: false,
                    data: updatedData
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateIcon succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                icons: {
                    ...updatedState.icons,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateIcon',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("akTZj", function(module, exports) {

$parcel$export(module.exports, "updateProvisioningStatus", () => $d823977f3c28c840$export$ae3c5292a85a06f4);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $8OEkP = parcelRequire("8OEkP");
const $d823977f3c28c840$export$ae3c5292a85a06f4 = ({ isEnabled: isEnabled })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        if (state.dataManager.provisioningUpdateLoading) return;
        setState({
            ...state,
            dataManager: {
                ...state.dataManager,
                isProvisioned: isEnabled,
                provisioningUpdateLoading: true
            }
        });
        try {
            const requestBody = {
                enabled: isEnabled
            };
            await (0, $4VpwK.performCmdbPutRequest)((0, $8OEkP.getDataManagerProvisioningStatusUrl)(workspaceId), {
                body: JSON.stringify(requestBody)
            });
            const result = await (0, $4VpwK.performCmdbGetRequest)((0, $8OEkP.getDataManagerProvisioningStatusUrl)(workspaceId));
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    isProvisioned: result.enabled === 'ON',
                    provisioningUpdateLoading: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateProvisioningStatus succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...state,
                dataManager: {
                    ...state.dataManager,
                    provisioningUpdateLoading: false,
                    provisioningUpdateError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateProvisioningStatus',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("czU2t", function(module, exports) {

$parcel$export(module.exports, "setReferenceType", () => $d89b12ad155fa4aa$export$7c6efce0302318d);
$parcel$export(module.exports, "updateReferenceType", () => $d89b12ad155fa4aa$export$f9e29a0f21a33136);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $Zsxbh = parcelRequire("Zsxbh");
const $d89b12ad155fa4aa$export$7c6efce0302318d = (updatedReferenceType)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.referenceTypes.data?.map((referenceType)=>referenceType.id === updatedReferenceType.id ? updatedReferenceType : referenceType);
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                data: updatedData
            }
        });
    };
const $d89b12ad155fa4aa$export$f9e29a0f21a33136 = ({ referenceTypeId: referenceTypeId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            referenceTypes: {
                ...state.referenceTypes,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $4VpwK.performCmdbPutRequest)((0, $Zsxbh.getCmdbConfigReferenceTypeByIdUrl)(workspaceId, referenceTypeId), {
                body: JSON.stringify({
                    ...updatedProperties,
                    color: updatedProperties.color !== undefined ? updatedProperties.color.replace('#', '') : undefined
                })
            });
            const updatedState = getState();
            const updatedData = updatedState.referenceTypes.data?.map((referenceType)=>referenceType.id === response.id ? response : referenceType);
            setState({
                ...updatedState,
                referenceTypes: {
                    ...updatedState.referenceTypes,
                    updateLoading: false,
                    data: updatedData || undefined
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateReferenceType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                referenceTypes: {
                    ...updatedState.referenceTypes,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateReferenceType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});

parcelRegister("lsHFw", function(module, exports) {

$parcel$export(module.exports, "setStatusType", () => $800507e86f7d8a8e$export$80a24939e43be67c);
$parcel$export(module.exports, "updateStatusType", () => $800507e86f7d8a8e$export$2174575c3f57e8f8);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $Zsxbh = parcelRequire("Zsxbh");
const $800507e86f7d8a8e$export$80a24939e43be67c = (updatedStatusType)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const updatedData = state.statusTypes.data?.map((statusType)=>statusType.id === updatedStatusType.id ? updatedStatusType : statusType);
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                data: updatedData
            }
        });
    };
const $800507e86f7d8a8e$export$2174575c3f57e8f8 = ({ statusTypeId: statusTypeId, updatedProperties: updatedProperties })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const state = getState();
        setState({
            ...state,
            statusTypes: {
                ...state.statusTypes,
                updateLoading: true
            }
        });
        try {
            const response = await (0, $4VpwK.performCmdbPutRequest)((0, $Zsxbh.getCmdbConfigStatusTypeByIdUrl)(workspaceId, statusTypeId), {
                body: JSON.stringify(updatedProperties)
            });
            const updatedState = getState();
            const updatedData = updatedState.statusTypes.data?.map((statusType)=>statusType.id === response.id ? response : statusType);
            setState({
                ...updatedState,
                statusTypes: {
                    ...updatedState.statusTypes,
                    updateLoading: false,
                    data: updatedData || undefined
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateStatusType succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const updatedState = getState();
            setState({
                ...updatedState,
                statusTypes: {
                    ...updatedState.statusTypes,
                    updateLoading: false,
                    updateError: error
                }
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateStatusType',
                    packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
                    teamName: 'falcons'
                },
                error: error
            });
            throw error;
        }
    };

});


parcelRegister("3SYcN", function(module, exports) {

$parcel$export(module.exports, "sortReferenceTypes", () => $52d2d568421769f9$export$7e55dd84e7cc0829);
$parcel$export(module.exports, "sortStatusTypes", () => $52d2d568421769f9$export$5f25bb3183b5823d);
const $52d2d568421769f9$export$7e55dd84e7cc0829 = (referenceTypes)=>referenceTypes.sort((a, b)=>a.name.localeCompare(b.name)).sort((a, b)=>{
        if (a.removable === b.removable) return 0;
        return a.removable ? 1 : -1;
    });
const $52d2d568421769f9$export$5f25bb3183b5823d = (statusTypes)=>statusTypes.sort((a, b)=>a.name.localeCompare(b.name));

});


parcelRegister("kT9FG", function(module, exports) {

$parcel$export(module.exports, "AssetsMenu", () => $68b59dd7ae4cb0b4$export$a578a9f5b9517a27);
$parcel$export(module.exports, "AssetsSingleMenuItem", () => $68b59dd7ae4cb0b4$export$252d7ffe38b4e8ef);

var $5uXOq = parcelRequire("5uXOq");

var $eOat1 = parcelRequire("eOat1");

var $koVbs = parcelRequire("koVbs");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $5FnJJ = parcelRequire("5FnJJ");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $eKq7N = parcelRequire("eKq7N");

var $j8qoE = parcelRequire("j8qoE");

var $blEB6 = parcelRequire("blEB6");

var $cNd4s = parcelRequire("cNd4s");

var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");

var $iHwh4 = parcelRequire("iHwh4");

var $tKTx3 = parcelRequire("tKTx3");

var $2Wh2X = parcelRequire("2Wh2X");

var $8Hhya = parcelRequire("8Hhya");
function $68b59dd7ae4cb0b4$export$a578a9f5b9517a27({ isExpanded: isExpanded }) {
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).ASSETS);
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const [{ config: config, dataManager: dataManager, loading: loading }, { fetchGlobalConfig: fetchGlobalConfig, fetchProvisioningStatus: fetchProvisioningStatus, fetchMyDataManagerRoles: fetchMyDataManagerRoles }] = (0, $j8qoE.useInsightGlobalConfig)();
    const fetchAssetsConfig = (0, $5uXOq.useCallback)(async ()=>{
        fetchGlobalConfig(false);
        fetchProvisioningStatus(false);
        fetchMyDataManagerRoles(false);
    }, [
        fetchGlobalConfig,
        fetchMyDataManagerRoles,
        fetchProvisioningStatus
    ]);
    const menuId = (0, $jhS4y.MENU_ID_ASSETS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).ASSETS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_ASSETS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        elemBefore: icon,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Hhya.SectionActions), {
            isInsightAdministrator: config?.insightAdministrator
        }),
        testId: (0, $dQbFB.getTestId)(menuId),
        onClick: (_e, _a, { isExpanded: hasExpanded })=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).ASSETS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_ASSETS)
            });
        }
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Wh2X.HeaderSchemasMenuItems), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eKq7N.L1ExpandableMenuItemSubmenu), {
        fetch: fetchAssetsConfig,
        isFetching: loading || dataManager.provisioningLoading || dataManager.myRolesLoading,
        MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iHwh4.AssetsMenuItems), {
                dataManagerIsProvisioned: dataManager.isProvisioned,
                dataManagerMyRoles: dataManager.myRoles,
                isSiteAdmin: isSiteAdmin,
                insightAdministrator: config?.insightAdministrator,
                insightReporting: config?.insightReporting
            }),
        skeletonCount: 2
    })));
}
const $68b59dd7ae4cb0b4$export$252d7ffe38b4e8ef = ({ showUpsellLozenge: showUpsellLozenge = false })=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).ASSETS);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        onClick: ()=>{
            sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).ASSETS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_ASSETS)
            });
        },
        menuId: (0, $jhS4y.MENU_ID_ASSETS),
        elemBefore: icon,
        href: (0, $blEB6.getLandingPageUrl)(),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Hhya.SectionActions), {
            isInsightAdministrator: false
        })
    }, `${formattedMessage} `, showUpsellLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-assets.ui.assets-menu.upsell-lozenge",
        appearance: "new"
    }, formatMessage((0, $tKTx3.default).upsellLozengeText)));
};

});
parcelRegister("eKq7N", function(module, exports) {

$parcel$export(module.exports, "L1ExpandableMenuItemSubmenu", () => $791f4f5cc9cec4d6$export$a0d95f81c9ddf0e9);

var $5uXOq = parcelRequire("5uXOq");

var $5qw5u = parcelRequire("5qw5u");
const $791f4f5cc9cec4d6$export$a0d95f81c9ddf0e9 = (props)=>{
    const { fetch: fetch, Footer: Footer, isFetching: isFetching, MenuItems: MenuItems, skeletonCount: skeletonCount } = props;
    const expandableMenuItems = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItems, null);
    const expandableFooter = Footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Footer, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qw5u.ExpandableMenuItemSubmenu), {
        fetch: fetch,
        footer: expandableFooter,
        isFetching: isFetching,
        menuItems: expandableMenuItems,
        skeletonCount: skeletonCount
    });
};

});
parcelRegister("5qw5u", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItemSubmenu", () => $71e5e00939216601$export$216998a85b3335a2);

var $5uXOq = parcelRequire("5uXOq");

var $fOnXR = parcelRequire("fOnXR");

var $1oZ5x = parcelRequire("1oZ5x");

var $338xa = parcelRequire("338xa");
const $71e5e00939216601$export$216998a85b3335a2 = (props)=>{
    const { fetch: fetchMaybe, footer: footer, isFetching: isFetchingMaybe, menuItems: menuItems, skeletonCount: skeletonCount } = props;
    const { isFetching: isFetching, fetch: fetch } = (0, $1oZ5x.useFetchActual)(isFetchingMaybe, fetchMaybe);
    const isExpanded = (0, $fOnXR.useIsExpanded)();
    // Fetch on open to refresh.
    (0, $5uXOq.useEffect)(()=>{
        if (isExpanded && !isFetching) fetch();
    }, // Don't include `isFetching` or this effect will go into an endless loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isExpanded,
        fetch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isFetching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), {
        count: skeletonCount
    }) : menuItems, footer);
};

});
parcelRegister("1oZ5x", function(module, exports) {

$parcel$export(module.exports, "useFetchActual", () => $e36b0174fdde90f4$export$49f3bd519990bec7);

var $5uXOq = parcelRequire("5uXOq");
const $e36b0174fdde90f4$export$49f3bd519990bec7 = (isFetchingMaybe, fetchMaybe)=>{
    const [isFetching, setIsFetching] = (0, $5uXOq.useState)(false);
    const fetch = (0, $5uXOq.useCallback)(async ()=>{
        if (!fetchMaybe) return;
        setIsFetching(true);
        try {
            await fetchMaybe();
        } finally{
            setIsFetching(false);
        }
    }, [
        fetchMaybe,
        setIsFetching
    ]);
    return {
        isFetching: !!isFetchingMaybe || isFetching,
        fetch: fetch
    };
};

});



parcelRegister("iHwh4", function(module, exports) {

$parcel$export(module.exports, "AssetsMenuItems", () => $a72239a654789f48$export$eca9d73b7de13f6a);

var $5uXOq = parcelRequire("5uXOq");

var $cfud7 = parcelRequire("cfud7");

var $b4PzF = parcelRequire("b4PzF");

var $jRK4a = parcelRequire("jRK4a");

var $3aBrO = parcelRequire("3aBrO");

var $cyPK0 = parcelRequire("cyPK0");
const $a72239a654789f48$export$eca9d73b7de13f6a = ({ dataManagerIsProvisioned: dataManagerIsProvisioned, dataManagerMyRoles: dataManagerMyRoles, isSiteAdmin: isSiteAdmin, insightAdministrator: insightAdministrator, insightReporting: insightReporting })=>{
    const showDataManagerLink = (0, $5uXOq.useCallback)(()=>{
        if (dataManagerIsProvisioned && dataManagerMyRoles) {
            const hasDMRoles = dataManagerMyRoles.some((myRole)=>(0, $cfud7.DATA_MANAGER_ROLES).includes(myRole));
            const hasAdapterRoles = dataManagerMyRoles.some((myRole)=>(0, $cfud7.DATA_MANAGER_ADAPTERS_ROLES).includes(myRole));
            if (hasDMRoles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3aBrO.DataManagerMenuItems), null);
            if (hasAdapterRoles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jRK4a.DataManagerAdapterMenuItems), null);
        }
    }, [
        dataManagerIsProvisioned,
        dataManagerMyRoles
    ]);
    const isInsightReportsEnabled = (0, $5uXOq.useCallback)(()=>(isSiteAdmin || insightAdministrator) && insightReporting, [
        insightAdministrator,
        insightReporting,
        isSiteAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isInsightReportsEnabled() && !(0, $b4PzF.isFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cyPK0.ReportsMenuItem), null), showDataManagerLink());
};

});
parcelRegister("cfud7", function(module, exports) {

$parcel$export(module.exports, "DATA_MANAGER_ADMIN", () => $b7b7b13be4edcaed$export$48abe9ccfdd98170);
$parcel$export(module.exports, "DATA_MANAGER_REPORT_VIEWER", () => $b7b7b13be4edcaed$export$8939b849d295aa4c);
$parcel$export(module.exports, "DATA_MANAGER_REPORT_EDITOR", () => $b7b7b13be4edcaed$export$4ca2081d195ddbdb);
$parcel$export(module.exports, "DATA_MANAGER_ADAPTERS_ADMIN", () => $b7b7b13be4edcaed$export$4c3d5fe6bdc107f1);
$parcel$export(module.exports, "DATA_MANAGER_ROLES", () => $b7b7b13be4edcaed$export$48703faa5030b273);
$parcel$export(module.exports, "DATA_MANAGER_ADAPTERS_ROLES", () => $b7b7b13be4edcaed$export$8b2dfd13f5f35ee4);
$parcel$export(module.exports, "ORDERED_ASSETS_DATA_MANAGER_ROLES", () => $b7b7b13be4edcaed$export$1d276f65230af2e);
const $b7b7b13be4edcaed$export$48abe9ccfdd98170 = 'ari:cloud:cmdb::role/airtrack/admin';
const $b7b7b13be4edcaed$export$8939b849d295aa4c = 'ari:cloud:cmdb::role/airtrack/report-viewer';
const $b7b7b13be4edcaed$export$4ca2081d195ddbdb = 'ari:cloud:cmdb::role/airtrack/report-editor';
const $b7b7b13be4edcaed$export$4c3d5fe6bdc107f1 = 'ari:cloud:cmdb::role/airtrack-buoy/admin';
const $b7b7b13be4edcaed$export$48703faa5030b273 = [
    $b7b7b13be4edcaed$export$48abe9ccfdd98170,
    $b7b7b13be4edcaed$export$8939b849d295aa4c,
    $b7b7b13be4edcaed$export$4ca2081d195ddbdb
];
const $b7b7b13be4edcaed$export$8b2dfd13f5f35ee4 = [
    $b7b7b13be4edcaed$export$4c3d5fe6bdc107f1
];
const $b7b7b13be4edcaed$export$1d276f65230af2e = [
    $b7b7b13be4edcaed$export$48abe9ccfdd98170,
    $b7b7b13be4edcaed$export$4c3d5fe6bdc107f1,
    $b7b7b13be4edcaed$export$4ca2081d195ddbdb,
    $b7b7b13be4edcaed$export$8939b849d295aa4c
];

});

parcelRegister("jRK4a", function(module, exports) {

$parcel$export(module.exports, "DataManagerAdapterMenuItems", () => $34fbfe3fa95e91ec$export$f74d67a8d693b664);

var $5uXOq = parcelRequire("5uXOq");

var $2Do6f = parcelRequire("2Do6f");

var $eOat1 = parcelRequire("eOat1");

var $2Eqc8 = parcelRequire("2Eqc8");

var $koVbs = parcelRequire("koVbs");


var $24a2m = parcelRequire("24a2m");

var $c0oSL = parcelRequire("c0oSL");

var $blEB6 = parcelRequire("blEB6");

var $ctUNb = parcelRequire("ctUNb");

var $isEeX = parcelRequire("isEeX");

var $i1on6 = parcelRequire("i1on6");
const $34fbfe3fa95e91ec$export$f74d67a8d693b664 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { icon: formattedAdapterIcon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $i1on6.default).jsmAssetsDataManagerAdapters, (0, $c0oSL.DataManagerAdaptersGlyph));
    const { icon: formattedOpenIcon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $i1on6.default).jsmAssetsOpenDataManager, (0, (/*@__PURE__*/$parcel$interopDefault($2Do6f))));
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $isEeX.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctUNb.MenuLinkItem), {
        elemBefore: formattedAdapterIcon,
        elemAfter: formattedOpenIcon,
        href: (0, $blEB6.getDataManagerAdaptersUrl)(),
        target: "_blank",
        onClick: ()=>fireUINavigationItemAnalytics((0, $496585bee7985bb9$export$ee52916f9ebd8000))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        space: "space.050",
        alignBlock: "baseline"
    }, formatMessage((0, $i1on6.default).jsmAssetsDataManagerAdapters), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: "new"
    }, formatMessage((0, $i1on6.default).assetsDataManagerBeta))));
};

});
const $496585bee7985bb9$export$f06dfcec5ff912e = 'meatballDropdown';
const $496585bee7985bb9$export$7ae7abcf2c19d3e5 = 'removeFromStarred';
const $496585bee7985bb9$export$78fd0bd637fe1684 = 'addToStarred';
const $496585bee7985bb9$export$c540230986f848f6 = 'addPeople';
const $496585bee7985bb9$export$44d67b522cbcce6d = 'projects';
const $496585bee7985bb9$export$3cc9ab700c406a19 = 'projectSettings';
const $496585bee7985bb9$export$dc23a793cf9e9de8 = 'archiveProject';
const $496585bee7985bb9$export$a68d619e7022f2c3 = 'deleteBoard';
const $496585bee7985bb9$export$22748439827110a4 = 'deleteProject';
const $496585bee7985bb9$export$192d610b0b7719f4 = 'boardSettings';
const $496585bee7985bb9$export$a65812b4aab631bb = 'alertSettings';
const $496585bee7985bb9$export$ca6db12118be69a1 = 'schemas';
const $496585bee7985bb9$export$f2eca6cf19c9a973 = 'reports';
const $496585bee7985bb9$export$147264622218a553 = 'dataManager';
const $496585bee7985bb9$export$ee52916f9ebd8000 = 'adapters';
const $496585bee7985bb9$export$83d40997eb7cc5b7 = 'assetsGlobalConfiguration';
const $496585bee7985bb9$export$5c09fa42f8d45ed8 = 'dismissRecommendation';
const $496585bee7985bb9$export$de9ad1ebeca97ec1 = 'newDiscoveryProject';
const $496585bee7985bb9$export$27e4092edca7bb97 = 'jwmSampleProject';
const $496585bee7985bb9$export$ce0bea1467165424 = 'whyAmISeeingThis';
const $496585bee7985bb9$export$98d08638c2a90c44 = 'starredAndRecentProjects';
const $496585bee7985bb9$export$ed36b1ade72db400 = 'starredProjectsOnly';
const $496585bee7985bb9$export$d40e6671b6dd5bcc = 'mostRecentOnly';

parcelRegister("c0oSL", function(module, exports) {

$parcel$export(module.exports, "DataManagerAdaptersGlyph", () => $1cdb3cd51030e227$export$cff497901afe8164);
$parcel$export(module.exports, "DataManagerLink", () => $1cdb3cd51030e227$export$905e681c1cad3de);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $ltBcH = parcelRequire("ltBcH");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $eOat1 = parcelRequire("eOat1");

var $hjSul = parcelRequire("hjSul");
const $1cdb3cd51030e227$export$fb5ad6208dd8d5f1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 6.5C7.5 7.05228 7.05228 7.5 6.5 7.5C5.94772 7.5 5.5 7.05228 5.5 6.5C5.5 5.94772 5.94772 5.5 6.5 5.5C7.05228 5.5 7.5 5.94772 7.5 6.5ZM7.5 17.5C7.5 18.0523 7.05228 18.5 6.5 18.5C5.94772 18.5 5.5 18.0523 5.5 17.5C5.5 16.9477 5.94772 16.5 6.5 16.5C7.05228 16.5 7.5 16.9477 7.5 17.5ZM18.5 12C18.5 12.5523 18.0523 13 17.5 13C16.9477 13 16.5 12.5523 16.5 12C16.5 11.4477 16.9477 11 17.5 11C18.0523 11 18.5 11.4477 18.5 12ZM8.88555 7.25C8.56698 8.26428 7.61941 9 6.5 9C5.11929 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.61941 4 8.56698 4.73572 8.88555 5.75H10.5523C11.697 5.75 12.625 6.67797 12.625 7.82267V11.25H14.5H15.1145C15.433 10.2357 16.3806 9.5 17.5 9.5C18.8807 9.5 20 10.6193 20 12C20 13.3807 18.8807 14.5 17.5 14.5C16.3806 14.5 15.433 13.7643 15.1145 12.75H14.5H12.625V16.1773C12.625 17.322 11.697 18.25 10.5523 18.25H8.88555C8.56698 19.2643 7.61941 20 6.5 20C5.11929 20 4 18.8807 4 17.5C4 16.1193 5.11929 15 6.5 15C7.61941 15 8.56698 15.7357 8.88555 16.75H10.5523C10.8686 16.75 11.125 16.4936 11.125 16.1773V12.75V12V11.25V7.82267C11.125 7.50639 10.8686 7.25 10.5523 7.25H8.88555Z",
        fill: "#44546F"
    }));
const $1cdb3cd51030e227$export$cff497901afe8164 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#clip0_2374_102539)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5076 15.8019C10.8212 16.0862 11 16.4898 11 16.913V18.5H13V16.913C13 16.4898 13.1788 16.0862 13.4924 15.8019L16.5 13.0745V9.5H7.5V13.0745L10.5076 15.8019ZM6 13.7391V9C6 8.44771 6.44772 8 7 8H17C17.5523 8 18 8.44772 18 9V13.7391L14.5 16.913V19C14.5 19.5523 14.0523 20 13.5 20H10.5C9.94772 20 9.5 19.5523 9.5 19V16.913L6 13.7391Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 9L9 4L10.5 4V9H9Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5 9V4L15 4V9H13.5Z",
        fill: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "clip0_2374_102539"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "currentColor"
    }))));
const $1cdb3cd51030e227$export$905e681c1cad3de = ({ children: children, onClick: onClick, testId: testId, to: to, app: app })=>{
    const getIcon = ()=>{
        if (app === 'data-manager') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ltBcH.default), {
            glyph: $1cdb3cd51030e227$export$fb5ad6208dd8d5f1,
            label: "Data manager icon",
            size: "medium"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ltBcH.default), {
            glyph: $1cdb3cd51030e227$export$cff497901afe8164,
            label: "Adapters icon",
            size: "medium"
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $1cdb3cd51030e227$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        href: to,
        component: (0, $hjSul.Link),
        appearance: "subtle",
        iconBefore: getIcon(),
        testId: testId,
        onClick: (event, analyticsEvent)=>{
            onClick?.(analyticsEvent);
        },
        target: "_blank"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $1cdb3cd51030e227$var$lozengeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: "new"
    }, "BETA"))));
};
const $1cdb3cd51030e227$var$lozengeStyles = (0, $2s57o.xcss)({
    display: 'inline-block',
    marginLeft: 'space.050'
});
const $1cdb3cd51030e227$var$wrapperStyles = (0, $2s57o.xcss)({});

});

parcelRegister("isEeX", function(module, exports) {

$parcel$export(module.exports, "useAssetsUIAnalytics", () => $9e3bbdcdefd1cee6$export$2eb4a7a38c92c87f);

var $5uXOq = parcelRequire("5uXOq");




var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");
const $9e3bbdcdefd1cee6$export$2eb4a7a38c92c87f = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireUINavigationItemAnalytics = (0, $5uXOq.useCallback)((analyticsItemId)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        }), (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_ASSETS], {
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
            itemId: analyticsItemId
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireUINavigationItemAnalytics: fireUINavigationItemAnalytics
    };
};

});

parcelRegister("i1on6", function(module, exports) {

$parcel$export(module.exports, "default", () => $43eab5367bedc66d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $43eab5367bedc66d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    jsmAssetsDataManagerAdapters: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.jsm-assets-data-manager-adapters",
        "defaultMessage": "Adapters"
    },
    jsmAssetsOpenDataManager: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.jsm-assets-open-data-manager",
        "defaultMessage": "Open data manager"
    },
    assetsDataManagerBeta: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.assets-data-manager-beta",
        "defaultMessage": "Beta"
    }
});

});


parcelRegister("3aBrO", function(module, exports) {

$parcel$export(module.exports, "DataManagerMenuItems", () => $be611fc140bff39d$export$34300598ca712097);

var $5uXOq = parcelRequire("5uXOq");

var $2Do6f = parcelRequire("2Do6f");

var $2Eqc8 = parcelRequire("2Eqc8");

var $eOat1 = parcelRequire("eOat1");

var $la5Q6 = parcelRequire("la5Q6");

var $koVbs = parcelRequire("koVbs");


var $24a2m = parcelRequire("24a2m");

var $blEB6 = parcelRequire("blEB6");

var $ctUNb = parcelRequire("ctUNb");

var $isEeX = parcelRequire("isEeX");

var $drPTS = parcelRequire("drPTS");
const $be611fc140bff39d$export$34300598ca712097 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { icon: formattedOpenIcon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $drPTS.default).assetsOpenDataManager, (0, (/*@__PURE__*/$parcel$interopDefault($2Do6f))));
    const { icon: formattedDataManagerIcon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $drPTS.default).assetsDataManager, (0, $la5Q6.default));
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $isEeX.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctUNb.MenuLinkItem), {
        elemBefore: formattedDataManagerIcon,
        elemAfter: formattedOpenIcon,
        href: (0, $blEB6.getDataManagerUrl)(),
        target: "_blank",
        onClick: ()=>fireUINavigationItemAnalytics((0, $496585bee7985bb9$export$147264622218a553))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        space: "space.050",
        alignBlock: "baseline"
    }, formatMessage((0, $drPTS.default).assetsDataManager), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: "new"
    }, formatMessage((0, $drPTS.default).assetsDataManagerBeta))));
};

});
parcelRegister("la5Q6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb221b5381fce3c6$export$2e2bcd8739ae039);
/**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $fb221b5381fce3c6$var$JSMAssetsDataManagerGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 6.5C7.5 7.05228 7.05228 7.5 6.5 7.5C5.94772 7.5 5.5 7.05228 5.5 6.5C5.5 5.94772 5.94772 5.5 6.5 5.5C7.05228 5.5 7.5 5.94772 7.5 6.5ZM8.88555 7.25C8.56698 8.26428 7.61941 9 6.5 9C5.11929 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.61941 4 8.56698 4.73572 8.88555 5.75H10.5523C11.697 5.75 12.625 6.67797 12.625 7.82267V8.5V11.25H14.5H15.1145C15.433 10.2357 16.3806 9.5 17.5 9.5C18.8807 9.5 20 10.6193 20 12C20 13.3807 18.8807 14.5 17.5 14.5C16.3806 14.5 15.433 13.7643 15.1145 12.75H14.5H12.625V15.5V16.1773C12.625 17.322 11.697 18.25 10.5523 18.25H8.88555C8.56698 19.2643 7.61941 20 6.5 20C5.11929 20 4 18.8807 4 17.5C4 16.1193 5.11929 15 6.5 15C7.61941 15 8.56698 15.7357 8.88555 16.75H10.5523C10.8686 16.75 11.125 16.4936 11.125 16.1773V15.5V12.75V12V11.25V8.5V7.82267C11.125 7.50639 10.8686 7.25 10.5523 7.25H8.88555ZM6.5 18.5C7.05228 18.5 7.5 18.0523 7.5 17.5C7.5 16.9477 7.05228 16.5 6.5 16.5C5.94772 16.5 5.5 16.9477 5.5 17.5C5.5 18.0523 5.94772 18.5 6.5 18.5ZM18.5 12C18.5 12.5523 18.0523 13 17.5 13C16.9477 13 16.5 12.5523 16.5 12C16.5 11.4477 16.9477 11 17.5 11C18.0523 11 18.5 11.4477 18.5 12Z",
        fill: "currentColor"
    }));
const $fb221b5381fce3c6$var$JSMAssetsDataManagerIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ltBcH.default), {
        ...props,
        glyph: $fb221b5381fce3c6$var$JSMAssetsDataManagerGlyph
    });
var $fb221b5381fce3c6$export$2e2bcd8739ae039 = $fb221b5381fce3c6$var$JSMAssetsDataManagerIcon;

});

parcelRegister("drPTS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bef7773ffc3fd68$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0bef7773ffc3fd68$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    assetsDataManager: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.assets-data-manager",
        "defaultMessage": "Data Manager"
    },
    assetsOpenDataManager: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.assets-open-data-manager",
        "defaultMessage": "Open Data Manager"
    },
    assetsDataManagerBeta: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.assets-data-manager-beta",
        "defaultMessage": "Beta"
    }
});

});


parcelRegister("cyPK0", function(module, exports) {

$parcel$export(module.exports, "ReportsMenuItem", () => $ebc6899836d65f8e$export$156f96ce3bb16879);

var $5uXOq = parcelRequire("5uXOq");

var $dNhsC = parcelRequire("dNhsC");

var $koVbs = parcelRequire("koVbs");


var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $blEB6 = parcelRequire("blEB6");

var $isEeX = parcelRequire("isEeX");

var $4UvDQ = parcelRequire("4UvDQ");
const $ebc6899836d65f8e$export$156f96ce3bb16879 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const reportsLink = (0, $5uXOq.useMemo)(()=>(0, $blEB6.getAssetsReportsUrl)(), []);
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $isEeX.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dNhsC))), {
            label: formatMessage((0, $4UvDQ.default).jsmAssetsReports),
            color: "currentColor",
            spacing: "spacious"
        }),
        href: reportsLink,
        menuId: (0, $jhS4y.MENU_ID_ASSETS_REPORTS),
        onClick: ()=>fireUINavigationItemAnalytics((0, $496585bee7985bb9$export$f2eca6cf19c9a973))
    }, formatMessage((0, $4UvDQ.default).jsmAssetsReports));
};

});
parcelRegister("dNhsC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::938052aeb81071adc088ccde54cc9808>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0ad654b113130c7$var$_react = $a0ad654b113130c7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a0ad654b113130c7$var$_baseNew = $a0ad654b113130c7$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a0ad654b113130c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Reports in JSM, Space Analytics in Confluence, and other graph charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0ad654b113130c7$var$ChartBarIcon = (props)=>/*#__PURE__*/ $a0ad654b113130c7$var$_react.default.createElement($a0ad654b113130c7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.333 1.75a.75.75 0 0 1 .75-.75h4.167a.75.75 0 0 1 .75.75V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9.75A.75.75 0 0 1 1.75 9h3.417V5.75a.75.75 0 0 1 .75-.75h3.416zm0 4.75H6.667v7h2.666zm1.5 7H13a.5.5 0 0 0 .5-.5V2.5h-2.667zm-5.666 0v-3H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$a0ad654b113130c7$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $a0ad654b113130c7$var$_default = module.exports.default = $a0ad654b113130c7$var$ChartBarIcon;

});

parcelRegister("4UvDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $884cac664127c061$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $884cac664127c061$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    jsmAssetsReports: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.common.reports.jsm-assets-reports",
        "defaultMessage": "Reports"
    }
});

});



parcelRegister("tKTx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $aac539a54eaf043d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $aac539a54eaf043d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    upsellLozengeText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.upsell-lozenge-text",
        "defaultMessage": "Premium"
    }
});

});

parcelRegister("2Wh2X", function(module, exports) {

$parcel$export(module.exports, "HeaderSchemasMenuItems", () => $77dfa228afe7bffb$export$7243359973253e5);

var $5uXOq = parcelRequire("5uXOq");

var $er8sA = parcelRequire("er8sA");

var $koVbs = parcelRequire("koVbs");


var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $24a2m = parcelRequire("24a2m");

var $blEB6 = parcelRequire("blEB6");

var $isEeX = parcelRequire("isEeX");

var $aGzpx = parcelRequire("aGzpx");
const $77dfa228afe7bffb$export$7243359973253e5 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const schemasLink = (0, $5uXOq.useMemo)(()=>(0, $blEB6.getLandingPageUrl)(), []);
    const { icon: formattedSchemasIcon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $aGzpx.default).jsmAssetsSchemas, (0, $er8sA.default));
    const { fireUINavigationItemAnalytics: fireUINavigationItemAnalytics } = (0, $isEeX.useAssetsUIAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        menuId: (0, $jhS4y.MENU_ID_ASSETS_SCHEMAS),
        elemBefore: formattedSchemasIcon,
        href: schemasLink,
        onClick: ()=>fireUINavigationItemAnalytics((0, $496585bee7985bb9$export$ca6db12118be69a1))
    }, formatMessage((0, $aGzpx.default).jsmAssetsSchemas));
};

});
parcelRegister("er8sA", function(module, exports) {

$parcel$export(module.exports, "default", () => $53e65d8c0991a293$export$2e2bcd8739ae039);
/**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $53e65d8c0991a293$var$JSMAssetsSchemasGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 7.5C8.05228 7.5 8.5 7.05228 8.5 6.5C8.5 5.94772 8.05228 5.5 7.5 5.5C6.94772 5.5 6.5 5.94772 6.5 6.5C6.5 7.05228 6.94772 7.5 7.5 7.5ZM10 6.5C10 7.61941 9.26428 8.56698 8.25 8.88555V10.5H14.1145C14.433 9.48572 15.3806 8.75 16.5 8.75C17.8807 8.75 19 9.86929 19 11.25C19 12.6307 17.8807 13.75 16.5 13.75C15.3806 13.75 14.433 13.0143 14.1145 12H8.25V16.25C8.25 16.6642 8.58579 17 9 17H14.05C14.2816 15.8589 15.2905 15 16.5 15C17.8807 15 19 16.1193 19 17.5C19 18.8807 17.8807 20 16.5 20C15.4748 20 14.5938 19.383 14.208 18.5H9C7.75736 18.5 6.75 17.4926 6.75 16.25V12V10.5V8.88555C5.73572 8.56698 5 7.61941 5 6.5C5 5.11929 6.11929 4 7.5 4C8.88071 4 10 5.11929 10 6.5ZM16.5 18.5C17.0523 18.5 17.5 18.0523 17.5 17.5C17.5 16.9477 17.0523 16.5 16.5 16.5C15.9477 16.5 15.5 16.9477 15.5 17.5C15.5 18.0523 15.9477 18.5 16.5 18.5ZM17.5 11.25C17.5 11.8023 17.0523 12.25 16.5 12.25C15.9477 12.25 15.5 11.8023 15.5 11.25C15.5 10.6977 15.9477 10.25 16.5 10.25C17.0523 10.25 17.5 10.6977 17.5 11.25Z",
        fill: "currentColor"
    }));
const $53e65d8c0991a293$var$JSMAssetsSchemasIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ltBcH.default), {
        ...props,
        glyph: $53e65d8c0991a293$var$JSMAssetsSchemasGlyph
    });
var $53e65d8c0991a293$export$2e2bcd8739ae039 = $53e65d8c0991a293$var$JSMAssetsSchemasIcon;

});

parcelRegister("aGzpx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfefc3311594219e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bfefc3311594219e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    jsmAssetsSchemas: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.schemas.jsm-assets-schemas",
        "defaultMessage": "Schemas"
    }
});

});


parcelRegister("8Hhya", function(module, exports) {

$parcel$export(module.exports, "SectionActions", () => $cad83d2e8a58ef00$export$51f8029abf8c56ce);

var $5uXOq = parcelRequire("5uXOq");

var $51oeD = parcelRequire("51oeD");

var $44qT7 = parcelRequire("44qT7");
var $70rf1 = parcelRequire("70rf1");

var $2Eqc8 = parcelRequire("2Eqc8");

var $koVbs = parcelRequire("koVbs");




var $jecJ3 = parcelRequire("jecJ3");

var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $9eeFp = parcelRequire("9eeFp");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $blEB6 = parcelRequire("blEB6");

var $bwEvZ = parcelRequire("bwEvZ");
function $cad83d2e8a58ef00$export$51f8029abf8c56ce({ onClose: onClose, isInsightAdministrator: isInsightAdministrator = false }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const onOpen = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        }), (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_ASSETS], {
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
            itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        MenuItems: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cad83d2e8a58ef00$var$MoreMenuItems, {
                ...props,
                isInsightAdministrator: isInsightAdministrator
            }),
        onClose: onClose,
        onOpen: ()=>onOpen()
    });
}
function $cad83d2e8a58ef00$var$MoreMenuItems({ onClose: onClose, isInsightAdministrator: isInsightAdministrator = false }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const configLink = (0, $5uXOq.useMemo)(()=>(0, $blEB6.getGlobalConfigUrl)(), []);
    const onCloseWithStopPropagation = (0, $9eeFp.useStopPropagation)(onClose);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const onClick = (e)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_ASSETS], {
            level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
            componentType: (0, $1e554a683893bd46$export$74712b62056d422e),
            parentItemId: (0, $jecJ3.SECTION_ITEM_ASSETS),
            itemId: (0, $496585bee7985bb9$export$83d40997eb7cc5b7)
        });
        onCloseWithStopPropagation(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isInsightAdministrator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44qT7.default), {
        href: configLink,
        onClick: (e)=>onClick(e)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($51oeD))), {
        label: formatMessage((0, $bwEvZ.default).jsmAssetsSettingsIcon),
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }), formatMessage((0, $bwEvZ.default).jsmAssetsGlobalConfiguration)))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
        menuId: (0, $46Cti.L1_MENU_ID).ASSETS
    }));
}

});
parcelRegister("bwEvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $41b3b3b94f3d9484$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $41b3b3b94f3d9484$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    jsmAssetsGlobalConfiguration: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.section-actions.jsm-assets-global-configuration",
        "defaultMessage": "General configuration"
    },
    jsmAssetsSettingsIcon: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.section-actions.jsm-assets-settings-icon",
        "defaultMessage": "Settings"
    }
});

});




parcelRegister("kcT7A", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceAnalytics", () => $8beddc3162728349$export$5b58aa15c2701e8);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $1JmlQ = parcelRequire("1JmlQ");
const $8beddc3162728349$export$5b58aa15c2701e8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "assets",
        packageName: "jiraNavigationAppsSidebarNav4SidebarsContentCustomerService",
        teamName: "Kalari"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1JmlQ.CustomerServiceAnalyticsMenuLinkItem), null));

});
parcelRegister("1JmlQ", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceAnalyticsMenuLinkItem", () => $0ffa5fb0eea93988$export$d4508bff4cbbd271);

var $5uXOq = parcelRequire("5uXOq");

var $aOrxC = parcelRequire("aOrxC");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $5FnJJ = parcelRequire("5FnJJ");

var $dUyqZ = parcelRequire("dUyqZ");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");
const $0ffa5fb0eea93988$export$df8bbcec1e54e3c3 = '/jira/helpcenter/analytics';
const $0ffa5fb0eea93988$export$d4508bff4cbbd271 = ()=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-customer-service-analytics.ui.sidenav-customer-service",
        href: $0ffa5fb0eea93988$export$df8bbcec1e54e3c3,
        menuId: (0, $jhS4y.MENU_ID_CUSTOMER_SERVICE_ANALYTICS),
        elemBefore: icon,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
            MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
                    menuId: (0, $jhS4y.MENU_ID_CUSTOMER_SERVICE_ANALYTICS),
                    hasSeparator: false
                }))
        })
    }, formattedMessage);
};

});


parcelRegister("aXxBX", function(module, exports) {

$parcel$export(module.exports, "CustomerService", () => $a426b2d854204abe$export$5c26f0ffd7a4820d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $6oVYF = parcelRequire("6oVYF");
const $a426b2d854204abe$export$5c26f0ffd7a4820d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "assets",
        packageName: "jiraNavigationAppsSidebarNav4SidebarsContentCustomerService",
        teamName: "Boysenberry"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6oVYF.CustomerServiceMenuLinkItem), null));

});
parcelRegister("6oVYF", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceMenuLinkItem", () => $f06b8199f1c8d83f$export$276375fee74f0f11);

var $5uXOq = parcelRequire("5uXOq");

var $aOrxC = parcelRequire("aOrxC");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $5FnJJ = parcelRequire("5FnJJ");

var $dUyqZ = parcelRequire("dUyqZ");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $4R6GH = parcelRequire("4R6GH");
const $f06b8199f1c8d83f$export$208752a9164e5a6d = '/jira/helpcenter';
const $f06b8199f1c8d83f$export$276375fee74f0f11 = ()=>{
    const customerServiceMenuId = (0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $46Cti.L1_MENU_ID).CUSTOMER_HUBS : (0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)(customerServiceMenuId);
    const menuId = (0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $jhS4y.MENU_ID_CUSTOMER_HUBS) : (0, $jhS4y.MENU_ID_CUSTOMER_SERVICE);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-customer-service.ui.sidenav-customer-service",
        href: $f06b8199f1c8d83f$export$208752a9164e5a6d,
        menuId: menuId,
        elemBefore: icon,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
            MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
                    menuId: menuId,
                    hasSeparator: false
                }))
        })
    }, formattedMessage);
};

});


parcelRegister("kcmzD", function(module, exports) {

$parcel$export(module.exports, "Nav4Dashboards", () => $66938623734b1b6f$export$14aa7c6c8f362b5b);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");

var $ahfXZ = parcelRequire("ahfXZ");

var $6MFxN = parcelRequire("6MFxN");

const $66938623734b1b6f$export$14aa7c6c8f362b5b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-dashboards"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "dashboards-section",
        packageName: (0, $ddbe4b334e21c7a1$export$b8b9d90f9e5bd72b),
        teamName: (0, $ddbe4b334e21c7a1$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6MFxN.AnalyticContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ahfXZ.Nav4Dashboards), props))));

});
parcelRegister("ahfXZ", function(module, exports) {

$parcel$export(module.exports, "Nav4Dashboards", () => $a67ed45d3a5ce5eb$export$14aa7c6c8f362b5b);

var $5uXOq = parcelRequire("5uXOq");

var $ayvjE = parcelRequire("ayvjE");

var $8urqk = parcelRequire("8urqk");
function $a67ed45d3a5ce5eb$export$14aa7c6c8f362b5b({ isExpanded: isExpanded }) {
    const actionButtons = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ayvjE.ActionButtons), null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8urqk.DashboardsDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
}

});
parcelRegister("ayvjE", function(module, exports) {

$parcel$export(module.exports, "ActionButtons", () => $feeebb4436f3de85$export$88c65d2d98aab183);

var $5uXOq = parcelRequire("5uXOq");

var $g7g8o = parcelRequire("g7g8o");

var $aOrxC = parcelRequire("aOrxC");

var $5KCCi = parcelRequire("5KCCi");

var $Mp6qH = parcelRequire("Mp6qH");

var $jgE05 = parcelRequire("jgE05");

var $koVbs = parcelRequire("koVbs");

var $46Cti = parcelRequire("46Cti");

var $1xonH = parcelRequire("1xonH");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $6jY6G = parcelRequire("6jY6G");

var $e9QkH = parcelRequire("e9QkH");

var $9VXkC = parcelRequire("9VXkC");
var $lVJAU = parcelRequire("lVJAU");


var $6MFxN = parcelRequire("6MFxN");

var $kg2u4 = parcelRequire("kg2u4");
function $feeebb4436f3de85$export$88c65d2d98aab183() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { off: modalClose }] = (0, $e9QkH.useSwitchModals)((0, $Mp6qH.MODAL_ID).DASHBOARD_CREATE);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { path: path } = (0, $6jY6G.useRouteByName)('dashboard-edit') ?? {};
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const onSuccess = (0, $5uXOq.useCallback)((_, { id: id })=>{
        path && push((0, $9VXkC.generatePath)(path, {
            dashboardId: id
        }));
        setIsOpen(false);
        modalClose();
    }, [
        modalClose,
        path,
        push
    ]);
    const { fireUIAnalyticForFixButton: fireUIAnalyticForFixButton } = (0, $5uXOq.useContext)((0, $6MFxN.AnalyticContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgE05.default), {
        onSuccess: onSuccess,
        onCancel: ()=>{
            setIsOpen(false);
            modalClose();
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: formatMessage((0, $kg2u4.default).createDashboard)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xonH.CommonNavMenuButton), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g7g8o))),
        label: formatMessage((0, $kg2u4.default).createDashboard),
        onClick: ()=>{
            fireUIAnalyticForFixButton({
                itemId: (0, $ddbe4b334e21c7a1$export$7be02fe416808d26)
            });
            setIsOpen(true);
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        onOpen: ()=>fireUIAnalyticForFixButton({
                itemId: (0, $ddbe4b334e21c7a1$export$f06dfcec5ff912e)
            }),
        MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
                menuId: (0, $46Cti.L1_MENU_ID).DASHBOARDS,
                hasSeparator: false
            }))
    }));
}

});
parcelRegister("g7g8o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73693506539a99d0ae3d26d395e92ac2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $030720451248870d$var$_react = $030720451248870d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $030720451248870d$var$_baseNew = $030720451248870d$var$_interopRequireDefault((parcelRequire("enEmH")));
function $030720451248870d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for creating and adding an object as a secondary/tertiary action in a menu item.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $030720451248870d$var$AddIcon = (props)=>/*#__PURE__*/ $030720451248870d$var$_react.default.createElement($030720451248870d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.25 6.75V11h1.5V6.75H11v-1.5H6.75V1h-1.5v4.25H1v1.5z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$030720451248870d$var$AddIcon.displayName = 'AddIcon';
var $030720451248870d$var$_default = module.exports.default = $030720451248870d$var$AddIcon;

});

parcelRegister("Mp6qH", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $d722fd8ef23adae6$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $d722fd8ef23adae6$export$d57b6b390e78d90f);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_FAV", () => $d722fd8ef23adae6$export$ea341e6cc435ed40);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_VIEWED", () => $d722fd8ef23adae6$export$cb66c02d110b1531);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_RECENT", () => $d722fd8ef23adae6$export$22ea57e66775a6b2);
$parcel$export(module.exports, "TOP_LEVEL_ERROR_BOUNDARY_ID", () => $d722fd8ef23adae6$export$4766f0c4b6fe35dc);
$parcel$export(module.exports, "NAVIGATION_ITEM_ID", () => $d722fd8ef23adae6$export$1a9b265c626e9d44);
$parcel$export(module.exports, "MODAL_ID", () => $d722fd8ef23adae6$export$ebdd5a8e5b1c2de5);
$parcel$export(module.exports, "PROFILE_SPOTLIGHT_KEY", () => $d722fd8ef23adae6$export$6037915bf3452cf3);
$parcel$export(module.exports, "HELP_SPOTLIGHT_KEY", () => $d722fd8ef23adae6$export$286c2faa2103eb9c);
$parcel$export(module.exports, "SEARCH_SPOTLIGHT_KEY", () => $d722fd8ef23adae6$export$c0d6ac131d4391b9);
$parcel$export(module.exports, "PROJECTS_SPOTLIGHT_KEY", () => $d722fd8ef23adae6$export$8d9442dfaec4086f);
$parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MAIN", () => $d722fd8ef23adae6$export$3014c5ec440d8824);
$parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MENU", () => $d722fd8ef23adae6$export$69cbedccc0df48);
$parcel$export(module.exports, "YOUR_WORK_DROPDOWN_TAB_ID", () => $d722fd8ef23adae6$export$1935aad1d702494c);
$parcel$export(module.exports, "JSW_TMP_BACKLOG_BOARD_REGEXP", () => $d722fd8ef23adae6$export$cc578bc72d7a7308);
const $d722fd8ef23adae6$export$b8b9d90f9e5bd72b = '@atlassian/jira-atlassian-navigation';
const $d722fd8ef23adae6$export$d57b6b390e78d90f = 'navigation';
const $d722fd8ef23adae6$export$ea341e6cc435ed40 = 15;
const $d722fd8ef23adae6$export$cb66c02d110b1531 = 10;
const $d722fd8ef23adae6$export$22ea57e66775a6b2 = 5;
const $d722fd8ef23adae6$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $d722fd8ef23adae6$export$1a9b265c626e9d44 = {
    ADDONS: 'apps',
    CREATE: 'createIssue',
    APP_SWITCHER: 'atlassianSwitcher',
    DASHBOARDS: 'dashboards',
    FILTERS: 'filters',
    HELP: 'help',
    HELP_BADGE: 'helpBadge',
    HOME: 'home',
    INSIGHT: 'insight',
    LOGO: 'productLogo',
    NOTIFICATIONS: 'notifications',
    PEOPLE: 'people',
    PLANS: 'plans',
    PROFILE: 'profile',
    PROJECTS: 'projects',
    ROADMAPS: 'roadmaps',
    SEARCH: 'search',
    SERVICE_HUB: 'services',
    SETTINGS: 'settings',
    SIGN_IN: 'signIn',
    YOUR_WORK_DROPDOWN: 'yourWorkDropdown',
    CONVERSATION_ASSISTANT: 'conversationAssistant',
    ROVO_DEMAND_TESTS: 'rovoDemandTests'
};
const $d722fd8ef23adae6$export$ebdd5a8e5b1c2de5 = {
    DASHBOARD_CREATE: 'DASHBOARD_CREATE',
    KEYBOARD_SHORTCUTS: 'keyboard-shortcuts',
    PROJECT_CREATE: 'PROJECT_CREATE'
};
const $d722fd8ef23adae6$export$6037915bf3452cf3 = 'profile-spotlight';
const $d722fd8ef23adae6$export$286c2faa2103eb9c = 'help-spotlight';
const $d722fd8ef23adae6$export$c0d6ac131d4391b9 = 'search-spotlight';
const $d722fd8ef23adae6$export$8d9442dfaec4086f = 'projects-spotlight';
const $d722fd8ef23adae6$export$3014c5ec440d8824 = 'viewAtlassianNavigation';
const $d722fd8ef23adae6$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
const $d722fd8ef23adae6$export$1935aad1d702494c = {
    RECENT: 'RECENT',
    BOARDS: 'BOARDS',
    QUEUES: 'QUEUES',
    ASSIGNED_TO_ME: 'ASSIGNED_TO_ME',
    ADD_FILTER: 'ADD_FILTER',
    ALERTS: 'ALERTS'
};
const $d722fd8ef23adae6$export$cc578bc72d7a7308 = /jira\/software\/projects\/[a-zA-Z0-9]+\/boards\/\d+(\/backlog)?/;

});

parcelRegister("jgE05", function(module, exports) {

$parcel$export(module.exports, "default", () => $927aeb284ed7a228$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $927aeb284ed7a228$var$AsyncCreateDashboardModal = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("gUk7e")), {
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/create-dashboard-modal/src/index.tsx"
});
const $927aeb284ed7a228$var$AsyncCreateDashboardModalContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "create-dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($927aeb284ed7a228$var$AsyncCreateDashboardModal, props));
var $927aeb284ed7a228$export$2e2bcd8739ae039 = $927aeb284ed7a228$var$AsyncCreateDashboardModalContainer;

});
parcelRegister("gUk7e", function(module, exports) {

let $c4f17adbe87c7f61$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c4f17adbe87c7f61$var$load("h2MrD"),
    $c4f17adbe87c7f61$var$load("bYT2S"),
    $c4f17adbe87c7f61$var$load("8bdSJ")
]).then(()=>parcelRequire('eTZZm'));

});


parcelRegister("e9QkH", function(module, exports) {

$parcel$export(module.exports, "useSwitchModals", () => $bbe85969245206f0$export$5ed4b99cbad4ebd6);

var $2qauD = parcelRequire("2qauD");
const { useSwitch: $bbe85969245206f0$var$useSwitch } = (0, $2qauD.createSwitchController)('jira-switch-modals');
const $bbe85969245206f0$export$5ed4b99cbad4ebd6 = $bbe85969245206f0$var$useSwitch;

});
parcelRegister("2qauD", function(module, exports) {

$parcel$export(module.exports, "createSwitchController", () => $a539fc33301c42ee$export$1856548326159ec8);

var $5uXOq = parcelRequire("5uXOq");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $a539fc33301c42ee$export$1856548326159ec8 = (name, activeByDefault)=>{
    const actions = {
        on: (active)=>({ setState: setState })=>setState({
                    active: active
                }),
        off: (active)=>({ setState: setState, getState: getState })=>{
                if (getState().active === active || active === undefined) setState({
                    active: undefined
                });
            },
        toggle: (active)=>({ getState: getState, dispatch: dispatch })=>{
                if (getState().active === active) dispatch(actions.off(active));
                else dispatch(actions.on(active));
            }
    };
    const initialState = {
        active: activeByDefault
    };
    const store = (0, $iXqE5.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    const SwitchContainer = (0, $gg7kZ.createContainer)(store);
    const selector = (state, key)=>state.active === key;
    const useSwitchInternal = (0, $3sQ5x.createHook)(store, {
        selector: selector
    });
    const useSwitch = (active)=>{
        const [isActive, { on: onSwitch, off: offSwitch, toggle: toggleSwitch }] = useSwitchInternal(active);
        const on = (0, $5uXOq.useCallback)(()=>onSwitch(active), [
            onSwitch,
            active
        ]);
        const off = (0, $5uXOq.useCallback)(()=>offSwitch(active), [
            active,
            offSwitch
        ]);
        const toggle = (0, $5uXOq.useCallback)(()=>toggleSwitch(active), [
            toggleSwitch,
            active
        ]);
        return [
            isActive,
            {
                on: on,
                off: off,
                toggle: toggle
            }
        ];
    };
    return {
        SwitchContainer: SwitchContainer,
        useSwitch: useSwitch
    };
};

});


const $ddbe4b334e21c7a1$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Dashboards';
const $ddbe4b334e21c7a1$export$d57b6b390e78d90f = 'jira-cosmos';
const $ddbe4b334e21c7a1$export$65b778215f917c60 = 'viewAllDashboards';
const $ddbe4b334e21c7a1$export$7be02fe416808d26 = 'createDashboard';
const $ddbe4b334e21c7a1$export$f06dfcec5ff912e = 'meatballDropdown';

parcelRegister("6MFxN", function(module, exports) {

$parcel$export(module.exports, "AnalyticContext", () => $12282e91517b56b8$export$da0556bf821b3494);
$parcel$export(module.exports, "AnalyticContextProvider", () => $12282e91517b56b8$export$aea8e3edcdec81e3);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");




var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

const $12282e91517b56b8$export$da0556bf821b3494 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    fireUIAnalyticForFixMenuItem: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    fireUIAnalyticForFixButton: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    fireUIAnalyticForFavouriteToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    fireUIAnalyticForDashboardItems: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});
const $12282e91517b56b8$export$aea8e3edcdec81e3 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireUIAnalyticForFixMenuItem = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                itemId: (0, $ddbe4b334e21c7a1$export$65b778215f917c60)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFixButton = (0, $5uXOq.useCallback)(({ itemId: itemId })=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: itemId
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFavouriteToggle = (0, $5uXOq.useCallback)(({ starType: starType, parentItemId: parentItemId })=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$74712b62056d422e),
                parentItemId: parentItemId,
                parentItemType: 'dashboard',
                itemId: starType
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForDashboardItems = (0, $5uXOq.useCallback)(({ itemId: itemId, section: section })=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_DASHBOARDS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                itemType: (0, $632bd8725b437a12$export$4695c1a423ffe431).toLowerCase(),
                itemId: itemId,
                section: section
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const memoValue = (0, $5uXOq.useMemo)(()=>({
            fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem,
            fireUIAnalyticForFixButton: fireUIAnalyticForFixButton,
            fireUIAnalyticForFavouriteToggle: fireUIAnalyticForFavouriteToggle,
            fireUIAnalyticForDashboardItems: fireUIAnalyticForDashboardItems
        }), [
        fireUIAnalyticForDashboardItems,
        fireUIAnalyticForFavouriteToggle,
        fireUIAnalyticForFixButton,
        fireUIAnalyticForFixMenuItem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12282e91517b56b8$export$da0556bf821b3494.Provider, {
        value: memoValue
    }, children);
};

});

parcelRegister("kg2u4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0357cb1b75baecf6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0357cb1b75baecf6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createDashboard: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.action-buttons.create-dashboard",
        "defaultMessage": "Create dashboard"
    }
});

});


parcelRegister("8urqk", function(module, exports) {

$parcel$export(module.exports, "DashboardsDefault", () => $ddb064d4de558bd2$export$bffc92c7e4f51e0b);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $338xa = parcelRequire("338xa");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $4zcxJ = parcelRequire("4zcxJ");

var $koeKL = parcelRequire("koeKL");

var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");


var $2Ioew = parcelRequire("2Ioew");

var $5GG0x = parcelRequire("5GG0x");


var $ehnIE = parcelRequire("ehnIE");

var $h4rc7 = parcelRequire("h4rc7");
const $ddb064d4de558bd2$export$bffc92c7e4f51e0b = /*#__PURE__*/ (0, $5uXOq.memo)($ddb064d4de558bd2$var$_DashboardsDefault);
function $ddb064d4de558bd2$var$_DashboardsDefault(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded } = props;
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const cloudId = (0, $koeKL.useCloudId)();
    // Ignore this error as our component does not need the context.
    // @ts-expect-error - Property 'context' is missing in type '{ tenantContext: { cloudId: string; }; }' but required in type 'EntryPointRouteParams'.ts(2741)
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            tenantContext: {
                cloudId: cloudId
            }
        }), [
        cloudId
    ]);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, react-hooks/rules-of-hooks
    const leftSidebarEPRef = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5));
    const dashboardsEPRef = leftSidebarEPRef?.entryPoints?.dashboards;
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $h4rc7.nav4DashboardsContentEntryPoint), entryPointParams);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const triggerRef = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActions);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).DASHBOARDS);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const epContainerProps = (0, $5uXOq.useMemo)(()=>({
            id: 'nav4-sidebar-dashboards-default',
            packageName: (0, $ddbe4b334e21c7a1$export$b8b9d90f9e5bd72b),
            teamName: (0, $ddbe4b334e21c7a1$export$d57b6b390e78d90f),
            errorFallback: 'flag',
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            runtimeProps: entryPointParams
        }), [
        entryPointParams
    ]);
    // This callback makes sure that the EP is loaded when the _system_ determines that the expandable
    // should be open.
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const onSystemToggleFn = (0, $5uXOq.useCallback)((hasExpanded)=>{
        if (hasExpanded) entryPointActions.load();
    }, [
        entryPointActions
    ]);
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const onExpansionToggleFn = (0, $5uXOq.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            entryPointActions.load();
            sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).DASHBOARDS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_DASHBOARDS)
            });
        }
    }, [
        entryPointActions,
        sendSectionItemAnalyticsEvent
    ]);
    const menuId = (0, $jhS4y.MENU_ID_DASHBOARDS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: onSystemToggleFn,
        onExpansionToggle: onExpansionToggleFn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-dashboards-default",
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5GG0x.RouteEntryPointContainer), {
        epContainerProps: epContainerProps,
        jiraEPRef: entryPointReferenceSubject,
        nestedEPRef: dashboardsEPRef,
        placeholderEntryPoint: (0, $h4rc7.nav4DashboardsContentEntryPoint)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehnIE.Footer), null)));
}

});
parcelRegister("2Ioew", function(module, exports) {

$parcel$export(module.exports, "usePageLayoutEntryPoint", () => $dcf886ac39f7cfda$export$fe1c839e8baf4110);

var $h22md = parcelRequire("h22md");

var $6jY6G = parcelRequire("6jY6G");
const $dcf886ac39f7cfda$export$fe1c839e8baf4110 = (layoutField)=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const entryPointReference = (0, $h22md.useRouteEntryPoint)({
        route: route
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return entryPointReference?.entryPoints[layoutField];
};

});
parcelRegister("h22md", function(module, exports) {

$parcel$export(module.exports, "useRouteEntryPoint", () => $4e1bc9edc261b42d$export$c96377f800cdddb4);

var $3I4nj = parcelRequire("3I4nj");
const $4e1bc9edc261b42d$export$c96377f800cdddb4 = ({ route: route })=>{
    const [lastLoadedRoute] = (0, $3I4nj.useLastLoadedRoute)();
    // route.entryPoint is already loaded
    if (lastLoadedRoute && lastLoadedRoute.entryPointReference && lastLoadedRoute.route === route) return lastLoadedRoute.entryPointReference;
    return null;
};

});
parcelRegister("3I4nj", function(module, exports) {

$parcel$export(module.exports, "useLastLoadedRoute", () => $f09634e8d32626d1$export$895238443fc3eae4);
$parcel$export(module.exports, "getEntryPointsStore", () => $f09634e8d32626d1$export$fe654a734624d17f);
$parcel$export(module.exports, "getLastLoadedRoute", () => $f09634e8d32626d1$export$5763b2305b3056df);
$parcel$export(module.exports, "getPrefetchingRoute", () => $f09634e8d32626d1$export$7e18f3e3cbd04326);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $bKpgX = parcelRequire("bKpgX");
const $f09634e8d32626d1$export$1cec83a23d40a9fa = ({ route: route, entryPointReference: entryPointReference })=>({ setState: setState })=>{
        setState({
            lastLoadedRoute: {
                route: route,
                entryPointReference: entryPointReference
            }
        });
    };
const $f09634e8d32626d1$export$bb3dc9c55f78173e = ({ routerContext: routerContext, entryPointReference: entryPointReference, expiresAt: expiresAt })=>({ setState: setState })=>{
        setState({
            prefetchingRoute: {
                routerContext: routerContext,
                expiresAt: expiresAt,
                entryPointReference: entryPointReference
            }
        });
    };
const $f09634e8d32626d1$var$actions = {
    setLastLoadedRoute: $f09634e8d32626d1$export$1cec83a23d40a9fa,
    setPrefetchingRoute: $f09634e8d32626d1$export$bb3dc9c55f78173e
};
const $f09634e8d32626d1$var$EntryPointsStore = (0, $iXqE5.createStore)({
    initialState: {
        lastLoadedRoute: null,
        prefetchingRoute: null
    },
    actions: $f09634e8d32626d1$var$actions,
    name: 'react-resource-router/entry-points'
});
const $f09634e8d32626d1$export$895238443fc3eae4 = (0, $3sQ5x.createHook)($f09634e8d32626d1$var$EntryPointsStore, {
    selector: (state)=>state.lastLoadedRoute
});
const $f09634e8d32626d1$export$fe654a734624d17f = ()=>(0, $bKpgX.defaultRegistry).getStore($f09634e8d32626d1$var$EntryPointsStore);
const $f09634e8d32626d1$export$b28ecd0e4705f6b7 = ()=>$f09634e8d32626d1$export$fe654a734624d17f().storeState.getState();
const $f09634e8d32626d1$export$5763b2305b3056df = ()=>$f09634e8d32626d1$export$b28ecd0e4705f6b7().lastLoadedRoute;
const $f09634e8d32626d1$export$7e18f3e3cbd04326 = ()=>$f09634e8d32626d1$export$b28ecd0e4705f6b7().prefetchingRoute;

});



parcelRegister("5GG0x", function(module, exports) {

$parcel$export(module.exports, "RouteEntryPointContainer", () => $36ec2bd8bdc583ac$export$3e4cdfb894377bc9);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $frBVt = parcelRequire("frBVt");

var $7XluA = parcelRequire("7XluA");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");
const $36ec2bd8bdc583ac$export$3e4cdfb894377bc9 = /*#__PURE__*/ (0, $5uXOq.memo)(({ epContainerProps: epContainerProps, jiraEPRef: jiraEPRef, nestedEPRef: nestedEPRef, shouldRenderNestedEntryPoint: shouldRenderNestedEntryPoint = true })=>{
    // If the route is an entryPoint, and the initialRoute was an entryPoint, use EntryPointContainer.
    // Otherwise, use the JiraEntryPointContainer.
    return shouldRenderNestedEntryPoint && nestedEPRef ? // eslint-disable-next-line jira/ufo/valid-labels
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: `${epContainerProps.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        attributes: epContainerProps.errorAttributes,
        fallback: epContainerProps.errorFallback,
        id: epContainerProps.id,
        packageName: epContainerProps.packageName,
        teamName: epContainerProps.teamName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointReferencePlaceholder), {
        name: `${epContainerProps.id || 'route-entrypoint-adapter'}-entrypoint-placeholder`,
        fallback: epContainerProps.fallback,
        entryPointReference: nestedEPRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: nestedEPRef,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        ...epContainerProps,
        entryPointReferenceSubject: jiraEPRef
    });
});

});
parcelRegister("frBVt", function(module, exports) {

$parcel$export(module.exports, "getPlaceholdersFromHTML", () => $126443352ff757de$export$9e9f35acc3af3a9a);
$parcel$export(module.exports, "EntryPointPlaceholderContext", () => $126443352ff757de$export$b5b377bb81310c48);
$parcel$export(module.exports, "EntryPointReferencePlaceholder", () => $126443352ff757de$export$35247b69e0cfe74);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");
const $126443352ff757de$var$styles = {
    root: "_1e0c1bgi"
};
function $126443352ff757de$export$9e9f35acc3af3a9a() {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const placeholders = document.querySelectorAll('[data-ep-placeholder-id]');
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return new Map(Array.from(placeholders, (el)=>[
            el.dataset.epPlaceholderId,
            el.innerHTML
        ]));
}
const $126443352ff757de$export$b5b377bb81310c48 = /*#__PURE__*/ (0, $5uXOq.createContext)(new Map());
function $126443352ff757de$export$35247b69e0cfe74({ children: children, entryPointReference: entryPointReference, fallback: originalFallback, name: name, ...placeholderProps }) {
    const hasMounted = (0, $5uXOq.useRef)(false);
    // using useState to ensure the entryPointReference is loaded synchronously
    // for the initial render (enabling SSR)
    const [component] = (0, $5uXOq.useState)(()=>{
        if (entryPointReference) try {
            return entryPointReference.getComponent();
        } catch (thrown) {
            return undefined;
        }
    });
    const placeholders = (0, $5uXOq.useContext)($126443352ff757de$export$b5b377bb81310c48);
    const ssrFallback = placeholders.get(name);
    const [fallback, setFallback] = (0, $5uXOq.useState)(!ssrFallback || component ? originalFallback : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: ssrFallback
        },
        "data-ep-placeholder-id": name,
        className: (0, $bwpsq.default)([
            $126443352ff757de$var$styles.root
        ])
    }));
    const lastOriginalFallback = (0, $5uXOq.useRef)(originalFallback);
    lastOriginalFallback.current = originalFallback;
    const resetFallback = (0, $5uXOq.useCallback)(()=>{
        if (placeholders.has(name)) {
            placeholders.delete(name);
            setFallback(lastOriginalFallback.current);
        }
    }, [
        name,
        placeholders,
        setFallback
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // reset the fallback when the entrypoint reference changes
        if (hasMounted.current) resetFallback();
    }, [
        entryPointReference,
        resetFallback
    ]);
    (0, $5uXOq.useEffect)(()=>{
        hasMounted.current = true;
        // reset fallback on unmount
        return resetFallback;
    }, [
        resetFallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        fallback: fallback,
        name: name,
        ...placeholderProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-ep-placeholder-id": name,
        className: (0, $bwpsq.default)([
            $126443352ff757de$var$styles.root
        ])
    }, children));
}

});


parcelRegister("ehnIE", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $efafdfdbad2ab24a$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $jhS4y = parcelRequire("jhS4y");

var $34PKs = parcelRequire("34PKs");

var $dDmlh = parcelRequire("dDmlh");

var $4IIGx = parcelRequire("4IIGx");
var $4vWwj = parcelRequire("4vWwj");
var $ch7sx = parcelRequire("ch7sx");

var $6MFxN = parcelRequire("6MFxN");

var $djUjd = parcelRequire("djUjd");
const $efafdfdbad2ab24a$var$VIEW_ALL_DASHBOARDS_HREF = (0, $dDmlh.dashboardsDirectoryRoute).path;
const $efafdfdbad2ab24a$export$a06f1c675e846f6f = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem } = (0, $5uXOq.useContext)((0, $6MFxN.AnalyticContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4vWwj.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ch7sx.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34PKs.ViewAllEntityMenuItem), {
        href: $efafdfdbad2ab24a$var$VIEW_ALL_DASHBOARDS_HREF,
        menuId: (0, $jhS4y.MENU_ID_DASHBOARDS_VIEW_ALL),
        onClick: (e)=>{
            fireUIAnalyticForFixMenuItem();
            onClose?.(e);
        }
    }, formatMessage((0, $djUjd.default).viewAllDashboards)))));
};

});
parcelRegister("34PKs", function(module, exports) {

$parcel$export(module.exports, "ViewAllEntityMenuItem", () => $5926a0296e1ab93a$export$505e81ff2081288b);

var $5uXOq = parcelRequire("5uXOq");

var $6cJvk = parcelRequire("6cJvk");

var $5FnJJ = parcelRequire("5FnJJ");
function $5926a0296e1ab93a$export$505e81ff2081288b(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        ...props,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cJvk))), {
            label: "",
            color: "currentColor"
        })
    });
}

});
parcelRegister("6cJvk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8c17960d483820ffdc74817869db42b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $48472942bb4411ca$var$_react = $48472942bb4411ca$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $48472942bb4411ca$var$_baseNew = $48472942bb4411ca$var$_interopRequireDefault((parcelRequire("enEmH")));
function $48472942bb4411ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $48472942bb4411ca$var$AlignTextLeftIcon = (props)=>/*#__PURE__*/ $48472942bb4411ca$var$_react.default.createElement($48472942bb4411ca$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM8 14H1v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$48472942bb4411ca$var$AlignTextLeftIcon.displayName = 'AlignTextLeftIcon';
var $48472942bb4411ca$var$_default = module.exports.default = $48472942bb4411ca$var$AlignTextLeftIcon;

});


parcelRegister("djUjd", function(module, exports) {

$parcel$export(module.exports, "default", () => $93087624b28395ab$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $93087624b28395ab$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAllDashboards: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.footer.view-all-dashboards",
        "defaultMessage": "View all dashboards"
    }
});

});





parcelRegister("blbXb", function(module, exports) {

$parcel$export(module.exports, "Nav4Filters", () => $6d9491a946e77dbf$export$caf6e58bb8560bb2);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $iuhhQ = parcelRequire("iuhhQ");

var $l8ruj = parcelRequire("l8ruj");

const $6d9491a946e77dbf$export$caf6e58bb8560bb2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "filters-section",
        packageName: (0, $095930ee3b140077$export$b8b9d90f9e5bd72b),
        teamName: (0, $095930ee3b140077$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iuhhQ.Nav4Filters), props)));

});
parcelRegister("iuhhQ", function(module, exports) {

$parcel$export(module.exports, "Nav4Filters", () => $37c0282fd3f73bb5$export$caf6e58bb8560bb2);

var $avYh4 = parcelRequire("avYh4");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $c0v8V = parcelRequire("c0v8V");

var $iaOwN = parcelRequire("iaOwN");

var $6jcf1 = parcelRequire("6jcf1");
function $37c0282fd3f73bb5$export$caf6e58bb8560bb2({ isExpanded: isExpanded, queryRef: queryRef }) {
    const data = (0, $8Uumt.useFragment)((0, $avYh4.default), queryRef);
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const actionButtons = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaOwN.ActionButtons), null), []);
    return isInitialSelectedPath((0, $jhS4y.MENU_ID_FILTERS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0v8V.Nav4FiltersForLanding), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded,
        queryRef: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6jcf1.Nav4FiltersDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
}

});
parcelRegister("avYh4", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f2d98cdc206343c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9cb82d8b8a0606478bd6482643028af4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4f2d98cdc206343c$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isFiltersExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Filters",
    "selections": [
        {
            "condition": "isFiltersExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4FiltersForLanding"
                }
            ]
        }
    ],
    "type": "Query"
};
$4f2d98cdc206343c$var$node.hash = "bc99d6e3499fdf4ab0d2fdec5f064e1f";
var $4f2d98cdc206343c$export$2e2bcd8739ae039 = $4f2d98cdc206343c$var$node;

});

parcelRegister("c0v8V", function(module, exports) {

$parcel$export(module.exports, "Nav4FiltersForLanding", () => $c780ddd933f6ccc4$export$90658bd06cecabd4);

var $f0kDR = parcelRequire("f0kDR");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $jNsky = parcelRequire("jNsky");

var $l8ruj = parcelRequire("l8ruj");

var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");


var $eYeHi = parcelRequire("eYeHi");

var $3XHNc = parcelRequire("3XHNc");
function $c780ddd933f6ccc4$export$90658bd06cecabd4(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).FILTERS);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const data = (0, $8Uumt.useFragment)((0, $f0kDR.default), queryRef);
    const menuId = (0, $jhS4y.MENU_ID_FILTERS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).FILTERS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_FILTERS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon + text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3XHNc.Header), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-filters-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "nav4-sidebar-filters-landing",
        packageName: (0, $095930ee3b140077$export$b8b9d90f9e5bd72b),
        teamName: (0, $095930ee3b140077$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jNsky.Nav4FiltersContent), {
        queryRef: data
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYeHi.Footer), null)));
}

});
parcelRegister("f0kDR", function(module, exports) {

$parcel$export(module.exports, "default", () => $73859602a3769ede$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e3cce317c9d4d64ec51601d1438d8020>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $73859602a3769ede$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4FiltersForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4FiltersContent"
        }
    ],
    "type": "Query"
};
$73859602a3769ede$var$node.hash = "6171665054b4de86e6a0c40316984aba";
var $73859602a3769ede$export$2e2bcd8739ae039 = $73859602a3769ede$var$node;

});

parcelRegister("jNsky", function(module, exports) {

$parcel$export(module.exports, "Nav4FiltersContent", () => $18f5885dbaabbc22$export$e0cd6afcf36dd0ac);

var $7eMNW = parcelRequire("7eMNW");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7hmi2 = parcelRequire("7hmi2");

var $koVbs = parcelRequire("koVbs");




var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $9Gyp5 = parcelRequire("9Gyp5");

var $5FnJJ = parcelRequire("5FnJJ");

var $gxbcq = parcelRequire("gxbcq");

var $1b6zA = parcelRequire("1b6zA");

var $GgrBz = parcelRequire("GgrBz");

var $2SzoU = parcelRequire("2SzoU");

var $koeKL = parcelRequire("koeKL");

var $cZpsT = parcelRequire("cZpsT");

var $f3k4O = parcelRequire("f3k4O");
var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");
var $4IIGx = parcelRequire("4IIGx");
var $4vWwj = parcelRequire("4vWwj");
var $ch7sx = parcelRequire("ch7sx");
var $l3A2e = parcelRequire("l3A2e");

var $qBWno = parcelRequire("qBWno");

var $jjTbl = parcelRequire("jjTbl");
const $18f5885dbaabbc22$var$MAX_RECENT_FILTERS = 5;
const $18f5885dbaabbc22$export$1f869c99ead9db5f = 15;
const $18f5885dbaabbc22$var$VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';
const $18f5885dbaabbc22$var$defaultFiltersRequiringLogin = [
    {
        id: '-1'
    },
    {
        id: '-2'
    },
    {
        id: '-3'
    }
];
const $18f5885dbaabbc22$var$entityTypenames = [
    'JiraCustomFilter',
    'JiraSystemFilter'
];
function $18f5885dbaabbc22$export$e0cd6afcf36dd0ac({ queryRef: queryRef }) {
    const cloudId = (0, $koeKL.useCloudId)();
    const { getStableItems: getStableItems } = (0, $1b6zA.useStableItems)();
    const { isSelectedPath: isSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    // We intentionally request 15 starred and 20 recent filters.
    // Recent filters should exclude system/default filters.
    // Then, if all 15 starred filters were recently visited, we still show 5 recent filters as well.
    const [fragmentData, refetch] = (0, $8Uumt.useRefetchableFragment)((0, $7eMNW.default), queryRef);
    const { jira: { favouriteFilters: favouriteFilters, recentFilters: recentFilters, systemFilters: systemFilters } } = fragmentData;
    (0, $9Gyp5.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $2SzoU.default,
        refetch: refetch,
        menuId: (0, $jhS4y.MENU_ID_FILTERS)
    });
    const refetchOnChange = (0, $5uXOq.useCallback)(({ onComplete: onComplete })=>{
        refetch({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network',
            onComplete: onComplete
        });
    }, [
        cloudId,
        refetch
    ]);
    (0, $gxbcq.useSubscribeAndUpdateFavorites)({
        entityTypename: $18f5885dbaabbc22$var$entityTypenames,
        favouriteConnectionId: favouriteFilters.__id,
        recentConnectionId: recentFilters.__id,
        refetch: refetchOnChange
    });
    const { subscribe: subscribe, unsubscribe: unsubscribe } = (0, $7hmi2.useDeleteChangeActions)();
    // allows the sidebar to reflect filter changes when a filter is deleted from the filters directory page
    (0, $5uXOq.useEffect)(()=>{
        subscribe(refetchOnChange);
        return ()=>{
            unsubscribe(refetchOnChange);
        };
    }, [
        refetchOnChange,
        subscribe,
        unsubscribe
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const starred = formatMessage((0, $jjTbl.default).starred);
    const recent = formatMessage((0, $jjTbl.default).recent);
    const sendFilterAnalytics = (0, $qBWno.useFilterActionsAnalytics)();
    const favorites = (0, $5uXOq.useMemo)(()=>{
        const ids = favouriteFilters.edges?.map((edge)=>edge?.node.filterId).filter(Boolean) ?? [];
        const list = favouriteFilters.edges?.filter(Boolean).map((edge)=>{
            const isCustom = edge.node.__typename === 'JiraCustomFilter';
            const sendFavouriteFilterAnalytics = ()=>sendFilterAnalytics((0, $ce8062101363feb9$export$6dd9406e478a1fe2), (0, $qBWno.getRecentAndFavouriteFilterAttributes)({
                    isCustom: isCustom,
                    filterId: edge.node.filterId,
                    section: (0, $jecJ3.SECTION_ITEM_STARRED)
                }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $GgrBz.Nav4FilterMenuItem), {
                key: edge.node.filterId,
                queryRef: edge.node,
                onRefetch: refetchOnChange,
                onClick: sendFavouriteFilterAnalytics
            });
        }) ?? [];
        return {
            idSet: new Set(ids),
            list: list.slice(0, $18f5885dbaabbc22$export$1f869c99ead9db5f),
            hasItems: Boolean(list.length),
            hasMore: favouriteFilters.pageInfo?.hasNextPage || list.length > $18f5885dbaabbc22$export$1f869c99ead9db5f
        };
    }, [
        favouriteFilters,
        refetchOnChange,
        sendFilterAnalytics
    ]);
    const recentItems = (0, $5uXOq.useMemo)(()=>{
        const nodes = recentFilters.edges?.filter(Boolean).filter((edge)=>edge.node.filterId && !favorites.idSet.has(edge.node.filterId)).map((edge)=>edge.node).slice(0, $18f5885dbaabbc22$var$MAX_RECENT_FILTERS) ?? [];
        const stableOrderedNodes = getStableItems({
            nodes: nodes,
            idKey: 'filterId'
        });
        const list = stableOrderedNodes.map((node)=>{
            const sendRecentFilterAnalytics = ()=>sendFilterAnalytics((0, $ce8062101363feb9$export$6dd9406e478a1fe2), (0, $qBWno.getRecentAndFavouriteFilterAttributes)({
                    isCustom: true,
                    filterId: node.filterId,
                    section: (0, $jecJ3.SECTION_ITEM_RECENT)
                }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $GgrBz.Nav4FilterMenuItem), {
                key: node.filterId,
                queryRef: node,
                onRefetch: refetchOnChange,
                onClick: sendRecentFilterAnalytics
            });
        });
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        recentFilters.edges,
        getStableItems,
        favorites.idSet,
        refetchOnChange,
        sendFilterAnalytics
    ]);
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const defaultItems = (0, $5uXOq.useMemo)(()=>{
        const filterIds = [];
        const list = systemFilters.edges?.filter((edge)=>edge?.node?.filterId && !favorites.idSet.has(edge.node.filterId))?.filter((edge)=>edge?.node?.filterId && (!isAnonymous || !$18f5885dbaabbc22$var$defaultFiltersRequiringLogin.find((filter)=>filter.id === edge.node.filterId))).map((edge)=>{
            edge?.node && filterIds.push(edge?.node.filterId);
            return edge;
        }).map((edge)=>{
            if (!edge?.node) return null;
            const sendDefaultFilterAnalytics = ()=>sendFilterAnalytics((0, $ce8062101363feb9$export$6dd9406e478a1fe2), (0, $qBWno.getDefaulFilterAttributes)({
                    filterId: edge.node.filterId
                }));
            return edge?.node ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $GgrBz.Nav4FilterMenuItem), {
                key: edge.node.filterId,
                queryRef: edge.node,
                onRefetch: refetchOnChange,
                onClick: sendDefaultFilterAnalytics
            }) : null;
        }) || [];
        return {
            list: list,
            hasItems: Boolean(list.length),
            filterIds: filterIds
        };
    }, [
        systemFilters.edges,
        favorites.idSet,
        isAnonymous,
        refetchOnChange,
        sendFilterAnalytics
    ]);
    const sendViewAllStarredAnalytics = (0, $5uXOq.useCallback)(()=>{
        sendFilterAnalytics((0, $ce8062101363feb9$export$6dd9406e478a1fe2), {
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
            itemId: 'viewAllStarred'
        });
    }, [
        sendFilterAnalytics
    ]);
    const sendDefaultFilterDropdownAnalytics = (0, $5uXOq.useCallback)(()=>{
        sendFilterAnalytics((0, $ce8062101363feb9$export$b887e88d8d0739f6), {
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
            itemId: 'defaultFilters'
        });
    }, [
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, favorites.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4vWwj.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ch7sx.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l3A2e.MenuSectionHeading), null, starred), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, favorites.list))), favouriteFilters.pageInfo?.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        href: $18f5885dbaabbc22$var$VIEW_ALL_STARRED_HREF,
        menuId: (0, $jhS4y.MENU_ID_FILTERS_VIEW_ALL_STARRED),
        onClick: sendViewAllStarredAnalytics
    }, formatMessage((0, $jjTbl.default).viewAllStarred))), recentItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4vWwj.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ch7sx.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l3A2e.MenuSectionHeading), null, recent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, recentItems.list))), defaultItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f3k4O.ExpandableMenuItem), {
        isDefaultExpanded: true,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendDefaultFilterDropdownAnalytics();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), null, formatMessage((0, $jjTbl.default).defaultFilters)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, defaultItems.list)));
}

});
parcelRegister("7eMNW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecbe3a8ee266c1ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ffa5b5733326eabb56fcfb6e2f05b1d3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $2SzoU = parcelRequire("2SzoU");
const $ecbe3a8ee266c1ca$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v2 = {
        "kind": "FragmentSpread",
        "name": "Nav4FilterMenuItem"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v4 = [
        v1 /*: any*/ ,
        v2 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURL"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $2SzoU.default)
            }
        },
        "name": "Nav4FiltersContent",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "favouriteFilters",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "FILTER"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                v1 /*: any*/ ,
                                                                v2 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.favouriteFilters.edges.node"
                                            }
                                        ]
                                    },
                                    v3 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.favouriteFilters"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "recentFilters",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "currentURL",
                                        "variableName": "currentURL"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "FILTER"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v4 /*: any*/ ,
                                                            "type": "JiraCustomFilter"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.recentFilters.edges.node"
                                            }
                                        ]
                                    },
                                    v3 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.recentFilters"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    v0 /*: any*/ 
                                ],
                                "concreteType": "JiraSystemFilterConnection",
                                "kind": "LinkedField",
                                "name": "systemFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSystemFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "JiraSystemFilter",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": v4 /*: any*/ 
                                                },
                                                "action": "THROW",
                                                "path": "jira.systemFilters.edges.node"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.systemFilters"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$ecbe3a8ee266c1ca$var$node.hash = "3f2ab01091a0154bb13d2ed1b15e13ef";
var $ecbe3a8ee266c1ca$export$2e2bcd8739ae039 = $ecbe3a8ee266c1ca$var$node;

});
parcelRegister("2SzoU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4b5e5aaa6a2bc38$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e4100b4266ad9f2bb1c31ed34ee8522f>>
 * @relayHash 99bea4c9d007a836d2f2aee3f9d2e63e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7050d00d8eefcfbd4847d47076260938acf8d0a28ab345db32aaed09d76e8fc5
const $c4b5e5aaa6a2bc38$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURL"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v8 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v6 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v11 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4FiltersContentQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "Nav4FiltersContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4FiltersContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouriteFilters",
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "FILTER"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v11 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentFilters",
                            "args": [
                                v2 /*: any*/ ,
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "FILTER"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ],
                                                    "type": "JiraCustomFilter"
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v11 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v2 /*: any*/ 
                            ],
                            "concreteType": "JiraSystemFilterConnection",
                            "kind": "LinkedField",
                            "name": "systemFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSystemFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilter",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7050d00d8eefcfbd4847d47076260938acf8d0a28ab345db32aaed09d76e8fc5",
            "metadata": {},
            "name": "Nav4FiltersContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c4b5e5aaa6a2bc38$var$node.hash = "3f2ab01091a0154bb13d2ed1b15e13ef";
var $c4b5e5aaa6a2bc38$export$2e2bcd8739ae039 = $c4b5e5aaa6a2bc38$var$node;

});


parcelRegister("7hmi2", function(module, exports) {

$parcel$export(module.exports, "useDeleteChangeActions", () => $4b1281a69eb8a7ab$export$ebbca0408972222d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $4b1281a69eb8a7ab$var$initialState = {
    callbacks: []
};
const $4b1281a69eb8a7ab$export$e324594224ef24da = {
    subscribe: (callback)=>({ getState: getState, setState: setState })=>{
            if (!getState().callbacks.includes(callback)) setState({
                callbacks: [
                    ...getState().callbacks,
                    callback
                ]
            });
        },
    unsubscribe: (callback)=>({ getState: getState, setState: setState })=>{
            if (getState().callbacks.includes(callback)) setState({
                callbacks: getState().callbacks.filter((item)=>item !== callback)
            });
        },
    publish: ()=>({ getState: getState })=>{
            getState().callbacks.forEach((callback)=>callback({
                    onComplete: ()=>undefined
                }));
        }
};
const $4b1281a69eb8a7ab$var$Store = (0, $iXqE5.createStore)({
    initialState: $4b1281a69eb8a7ab$var$initialState,
    actions: $4b1281a69eb8a7ab$export$e324594224ef24da
});
const $4b1281a69eb8a7ab$export$440b46140bc86b64 = (0, $3sQ5x.createStateHook)($4b1281a69eb8a7ab$var$Store);
const $4b1281a69eb8a7ab$export$ebbca0408972222d = (0, $3sQ5x.createActionsHook)($4b1281a69eb8a7ab$var$Store);

});

parcelRegister("9Gyp5", function(module, exports) {

$parcel$export(module.exports, "useRefetchWhenIsSelected", () => $b6947c490b25f582$export$ed209ae428704c56);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $aGONy = parcelRequire("aGONy");
function $b6947c490b25f582$export$ed209ae428704c56(params) {
    const { cloudId: cloudId, isSelectedPath: isSelectedPath, menuId: menuId, refetch: refetch, queryVariables: queryVariables, QUERY: QUERY } = params;
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const currentURL = (0, $aGONy.useGetCurrentUrl)();
    const currentURLPath = (0, $aGONy.useGetCurrentUrlPath)();
    (0, $5uXOq.useEffect)(()=>{
        if (isSelectedPath(menuId)) (0, $8Uumt.fetchQuery)(environment, QUERY, {
            cloudId: cloudId,
            currentURL: currentURL,
            currentURLPath: currentURLPath,
            ...queryVariables
        }).subscribe({
            complete: ()=>{
                refetch({
                    cloudId: cloudId,
                    currentURL: currentURL,
                    ...queryVariables
                }, {
                    fetchPolicy: 'store-only'
                });
            }
        });
    }, [
        cloudId,
        isSelectedPath,
        menuId,
        refetch,
        currentURL,
        currentURLPath,
        environment,
        queryVariables,
        QUERY
    ]);
}

});
parcelRegister("aGONy", function(module, exports) {

$parcel$export(module.exports, "useGetCurrentUrl", () => $e40fd709c4a3ab1d$export$d758ec3f153761c1);
$parcel$export(module.exports, "useGetCurrentUrlPath", () => $e40fd709c4a3ab1d$export$f61d14d754da11cc);

var $lODMY = parcelRequire("lODMY");

var $edUVe = parcelRequire("edUVe");

var $5LMr7 = parcelRequire("5LMr7");
function $e40fd709c4a3ab1d$export$d758ec3f153761c1() {
    const match = (0, $edUVe.useMatch)();
    const query = (0, $5LMr7.useQuery)();
    const searchParams = new URLSearchParams(query ?? {});
    const url = new URL(`http://example.com${match.url}/?${searchParams.toString()}`);
    return url.toString();
}
const $e40fd709c4a3ab1d$export$f61d14d754da11cc = (0, $lODMY.createRouterSelector)((routerContext)=>{
    const url = new URL(`http://example.com${routerContext.match.url}`);
    return url.toString();
});

});
parcelRegister("edUVe", function(module, exports) {

$parcel$export(module.exports, "useMatch", () => $02f34894572f6fbe$export$6c330e8992e8a295);

var $lODMY = parcelRequire("lODMY");
const $02f34894572f6fbe$export$6c330e8992e8a295 = (0, $lODMY.createRouterSelector)((state)=>state.match);

});



parcelRegister("gxbcq", function(module, exports) {

$parcel$export(module.exports, "useSubscribeAndUpdateFavorites", () => $7a04a668720dad88$export$1032774f8dab9cec);

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");

var $7lK06 = parcelRequire("7lK06");
const $7a04a668720dad88$export$923c488bb9fac2df = (favouriteConnectionId, recentConnectionId)=>(0, $5uXOq.useCallback)(({ store: store, dataId: dataId, isFavourite: isFavourite })=>{
        const node = store.get(dataId);
        const favorites = store.get(favouriteConnectionId);
        // Exit if we can't find the relevant data to optimistically update
        if (!node || !favorites) return false;
        if (isFavourite) {
            const recentEdges = store.get(recentConnectionId)?.getLinkedRecords('edges') ?? [];
            const existingEdge = recentEdges.find((edge)=>edge.getLinkedRecord('node')?.getDataID() === dataId);
            // Only optimistically insert a new favorite edge if it exists in the recent connection so we know it
            // has required fragment data.
            if (!existingEdge) return false;
            const edge = (0, $eiowN.ConnectionHandler).createEdge(store, favorites, node, 'JiraFavouriteEdge');
            (0, $eiowN.ConnectionHandler).insertEdgeBefore(favorites, edge);
        } else (0, $eiowN.ConnectionHandler).deleteNode(favorites, dataId);
        return true;
    }, [
        favouriteConnectionId,
        recentConnectionId
    ]);
const $7a04a668720dad88$export$1032774f8dab9cec = ({ entityTypename: entityTypename, favouriteConnectionId: favouriteConnectionId, recentConnectionId: recentConnectionId, refetch: refetch })=>{
    const updateFavoriteConnection = $7a04a668720dad88$export$923c488bb9fac2df(favouriteConnectionId, recentConnectionId);
    const pendingRefetch = (0, $5uXOq.useRef)(false); // Track in-flight refetch requests
    const trailingRefetch = (0, $5uXOq.useRef)(false); // Track queued refetch requests
    const onRefetch = (0, $5uXOq.useCallback)(()=>{
        // If there is already an in-flight refetch then wait until the request is complete before fetching again
        // Relay will dedupe refetch calls with matching variables. Therefore, we need to wait until any pending request
        // has finished before executing the latest refetch
        if (pendingRefetch.current) {
            trailingRefetch.current = true;
            return;
        }
        pendingRefetch.current = true;
        trailingRefetch.current = false;
        refetch({
            onComplete: ()=>{
                pendingRefetch.current = false;
                // Recursively refetch if it has been queued while a request was in-flight.
                if (trailingRefetch.current) // Wait for Relay to delete the cached request before refetching
                setTimeout(onRefetch, 0);
            }
        });
    }, [
        refetch
    ]);
    const subscriber = (0, $5uXOq.useCallback)((payload)=>{
        if (payload.type === 'MUTATION') {
            const success = updateFavoriteConnection(payload);
            // If we successfully updated the connection or it's an optimistic update, exit without further action
            if (success || payload.isOptimistic) return;
        }
        // If we can't update the record directly in the Relay store then perform a refetch
        onRefetch();
    }, [
        onRefetch,
        updateFavoriteConnection
    ]);
    (0, $7lK06.useSubscribeToFavorite)(entityTypename, subscriber);
};

});
parcelRegister("7lK06", function(module, exports) {

$parcel$export(module.exports, "publishFavorite", () => $703ce7b9c2eadfdd$export$229a24253fb568e1);
$parcel$export(module.exports, "useSubscribeToFavorite", () => $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2);

var $5uXOq = parcelRequire("5uXOq");
/**
 * Simple pub-sub implementation to emit and listen to change events for the favorite state of an entity.
 */ class $703ce7b9c2eadfdd$var$FavoritePubSub {
    constructor(){
        this.subscribers = {};
        this.subscribe = (typename, subscriber)=>{
            this.subscribers[typename] = [
                ...this.subscribers[typename] ?? [],
                subscriber
            ];
            return ()=>{
                this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
            };
        };
        this.publish = (typename, payload)=>{
            this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
        };
    }
}
// Singleton to emit and listen to events
const $703ce7b9c2eadfdd$var$favoritePubSub = new $703ce7b9c2eadfdd$var$FavoritePubSub();
const $703ce7b9c2eadfdd$export$229a24253fb568e1 = $703ce7b9c2eadfdd$var$favoritePubSub.publish;
const $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
    (0, $5uXOq.useEffect)(()=>{
        const typenames = Array.isArray(typename) ? typename : [
            typename
        ];
        const unsubscribes = typenames.map((val)=>$703ce7b9c2eadfdd$var$favoritePubSub.subscribe(val, subscriber));
        return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
    }, [
        typename,
        subscriber
    ]);
};

});


parcelRegister("1b6zA", function(module, exports) {

$parcel$export(module.exports, "useStableItems", () => $5cc76236fb007e50$export$cb9e0e36b6d0277e);

var $5uXOq = parcelRequire("5uXOq");
const $5cc76236fb007e50$export$cb9e0e36b6d0277e = ()=>{
    const stableIdMapRef = (0, $5uXOq.useRef)(new Map());
    const getStableItems = (0, $5uXOq.useCallback)(({ nodes: nodes, idKey: idKey })=>{
        const getStringId = (node)=>`${node[idKey]}`;
        const intersectedNodes = nodes.filter((node)=>stableIdMapRef.current.has(getStringId(node))).sort((nodeA, nodeB)=>{
            const indexA = stableIdMapRef.current.get(getStringId(nodeA)) ?? 0;
            const indexB = stableIdMapRef.current.get(getStringId(nodeB)) ?? 0;
            return indexA - indexB;
        });
        const hasIntersectedNodes = Boolean(intersectedNodes.length);
        const stableOrderedNodes = hasIntersectedNodes ? nodes.reduceRight((acc, node, index, array)=>{
            if (!stableIdMapRef.current.has(getStringId(node))) {
                const addToStart = index + 1 !== array.length;
                addToStart ? acc.unshift(node) : acc.push(node);
            }
            return acc;
        }, intersectedNodes) : nodes;
        stableIdMapRef.current = new Map(stableOrderedNodes.map((node, index)=>[
                getStringId(node),
                index
            ]));
        return stableOrderedNodes;
    }, []);
    return {
        getStableItems: getStableItems
    };
};

});

parcelRegister("GgrBz", function(module, exports) {

$parcel$export(module.exports, "Nav4FilterMenuItem", () => $e1d0066c79c6dc07$export$6c93ee534b1d4d10);

var $m231W = parcelRequire("m231W");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $iyWGS = parcelRequire("iyWGS");

var $cZpsT = parcelRequire("cZpsT");

var $MaZbq = parcelRequire("MaZbq");
function $e1d0066c79c6dc07$export$6c93ee534b1d4d10({ queryRef: queryRef, onRefetch: onRefetch, onClick: onClick }) {
    const data = (0, $8Uumt.useFragment)((0, $m231W.default), queryRef);
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MaZbq.SimpleFilterMenuItem), {
        actionsOnHover: !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iyWGS.Nav4FilterActions), {
            queryRef: data,
            onRefetch: onRefetch
        }),
        filterId: data.filterId,
        name: data.name,
        onClick: onClick
    });
}

});
parcelRegister("m231W", function(module, exports) {

$parcel$export(module.exports, "default", () => $11acb6858e14c1d4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6139076109a0e91490e1fa3e8272c1fa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $11acb6858e14c1d4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4FilterMenuItem",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "FragmentSpread",
            "name": "Nav4FilterActions"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$11acb6858e14c1d4$var$node.hash = "db4e5c3fb6fe1fa05a10eea572e428b4";
var $11acb6858e14c1d4$export$2e2bcd8739ae039 = $11acb6858e14c1d4$var$node;

});

parcelRegister("iyWGS", function(module, exports) {

$parcel$export(module.exports, "Nav4FilterActions", () => $013d853f5bcf1d51$export$7077dee41f8ad33d);

var $jaCjz = parcelRequire("jaCjz");

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $8Uumt = parcelRequire("8Uumt");

var $lGgwk = parcelRequire("lGgwk");

var $bGsST = parcelRequire("bGsST");

var $084bx = parcelRequire("084bx");

var $dvv9E = parcelRequire("dvv9E");

var $3cwUp = parcelRequire("3cwUp");

var $7H980 = parcelRequire("7H980");
var $44qT7 = parcelRequire("44qT7");
var $70rf1 = parcelRequire("70rf1");

var $6eFvr = parcelRequire("6eFvr");

var $7WnQL = parcelRequire("7WnQL");

var $koVbs = parcelRequire("koVbs");



var $d62in = parcelRequire("d62in");

var $aCS3f = parcelRequire("aCS3f");

var $4tcSU = parcelRequire("4tcSU");

var $cKjus = parcelRequire("cKjus");

var $6KXPO = parcelRequire("6KXPO");

var $90yGq = parcelRequire("90yGq");

var $itmJb = parcelRequire("itmJb");

var $lVJAU = parcelRequire("lVJAU");

var $4R6GH = parcelRequire("4R6GH");

var $koeKL = parcelRequire("koeKL");

var $fY39E = parcelRequire("fY39E");

var $dXq4S = parcelRequire("dXq4S");

var $2KAtx = parcelRequire("2KAtx");

var $c88gN = parcelRequire("c88gN");

var $dPDY8 = parcelRequire("dPDY8");

var $qBWno = parcelRequire("qBWno");

var $gDIE0 = parcelRequire("gDIE0");

var $l3IPn = parcelRequire("l3IPn");

var $199zy = parcelRequire("199zy");

var $eKG0o = parcelRequire("eKG0o");
const $013d853f5bcf1d51$export$7077dee41f8ad33d = ({ queryRef: queryRef, onRefetch: onRefetch })=>{
    const { __typename: __typename, isEditable: isEditable, isFavourite: isFavourite, name: name, owner: owner, id: id, filterId: filterId, jql: jql } = (0, $8Uumt.useFragment)((0, $jaCjz.default), queryRef);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const accountId = (0, $90yGq.useAccountId)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const sendFilterAnalytics = (0, $qBWno.useFilterActionsAnalytics)();
    const { isOpen: isCopyFilterModalOpen, onOpen: openCopyFilterModal, onClose: closeCopyFilterModal } = (0, $eKG0o.useModalState)(false);
    const { isOpen: isEditFilterModalOpen, onOpen: openEditFilterModal, onClose: closeEditFilterModal } = (0, $eKG0o.useModalState)(false);
    const { isOpen: isChangeOwnerModalOpen, onOpen: openChangeOwnerModal, onClose: closeChangeOwnerModal } = (0, $eKG0o.useModalState)(false);
    const { isOpen: isDeleteFilterModalOpen, onOpen: openDeleteFilterModal, onClose: closeDeleteFilterModal } = (0, $eKG0o.useModalState)(false);
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const onFilterSave = (0, $5uXOq.useCallback)((copiedFilterId)=>{
        push(`/issues/?filter=${copiedFilterId}`);
    }, [
        push
    ]);
    const isCustom = __typename === 'JiraCustomFilter';
    const isOwner = owner?.accountId && owner.accountId === accountId;
    const sendFilterActionAnalytics = (0, $5uXOq.useCallback)((itemId)=>{
        sendFilterAnalytics((0, $ce8062101363feb9$export$64fed82162bd367), (0, $qBWno.getFilterActionAttributes)({
            itemId: itemId,
            isCustom: isCustom,
            isFavourite: isFavourite,
            filterId: filterId
        }));
    }, [
        filterId,
        isCustom,
        isFavourite,
        sendFilterAnalytics
    ]);
    let modalProps;
    let saveFilterEntryPointProps;
    let updateFilterEntryPointProps;
    let entryPointParams;
    if ((0, $4R6GH.fg)('nin-save-filter-dialog-entry-point')) {
        modalProps = {
            width: 'medium',
            shouldScrollInViewport: true
        };
        // eslint-disable-next-line react-hooks/rules-of-hooks
        saveFilterEntryPointProps = (0, $5uXOq.useMemo)(()=>({
                jql: jql,
                filterId: filterId,
                onFilterSave: onFilterSave,
                title: formatMessage((0, $199zy.default).copyFilterDialogTitle)
            }), [
            jql,
            filterId,
            onFilterSave,
            formatMessage
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        updateFilterEntryPointProps = (0, $5uXOq.useMemo)(()=>({
                filterId: filterId ?? ''
            }), [
            filterId
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const cloudId = (0, $koeKL.useCloudId)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const activationId = (0, $fY39E.useActivationId)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        entryPointParams = (0, $5uXOq.useMemo)(()=>({
                filterAri: filterId !== null && filterId !== undefined ? (0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'filter',
                    resourceId: filterId,
                    activationId: activationId
                }) : undefined
            }), [
            filterId,
            cloudId,
            activationId
        ]);
    }
    const MenuItems = (0, $5uXOq.useCallback)(({ onClose: onClose })=>{
        const getManageSubscriptionsUrl = (actionType)=>{
            const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
                atl_token: (0, $4tcSU.default)(),
                returnUrl: 'ManageFilters.jspa',
                filterId: filterId
            });
            return `/${actionType}!default.jspa?${parsed}`;
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
            isList: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d62in.FavoriteToggleButton), {
            entityId: id,
            defaultIsStarred: Boolean(isFavourite),
            entityTypeName: (0, $7WnQL.isFavoritableItemTypename)(__typename) ? __typename : 'JiraCustomFilter',
            onClick: ()=>sendFilterActionAnalytics(isFavourite ? (0, $496585bee7985bb9$export$7ae7abcf2c19d3e5) : (0, $496585bee7985bb9$export$78fd0bd637fe1684)),
            name: name
        }), isCustom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44qT7.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dvv9E))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            href: getManageSubscriptionsUrl('ViewSubscriptions'),
            "aria-label": formatMessage((0, $199zy.default).manageSubscriptionWithName, {
                name: name
            }),
            onClick: ()=>sendFilterActionAnalytics('manageSubscription')
        }, formatMessage((0, $199zy.default).manageSubscription)), (0, $4R6GH.fg)('nin-save-filter-dialog-entry-point') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
            modalProps: modalProps,
            entryPoint: (0, $c88gN.saveFilterDialogEntryPoint),
            entryPointProps: saveFilterEntryPointProps,
            entryPointParams: entryPointParams,
            useInternalModal: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
                onClick: (e)=>{
                    sendFilterActionAnalytics('copyFilter');
                    onClose && onClose(e);
                },
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lGgwk))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                "aria-label": formatMessage((0, $199zy.default).copyFilterWithName, {
                    name: name
                }),
                ref: ref
            }, formatMessage((0, $199zy.default).copyFilter))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
            onClick: (e)=>{
                openCopyFilterModal();
                sendFilterActionAnalytics('copyFilter');
                onClose && onClose(e);
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lGgwk))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            "aria-label": formatMessage((0, $199zy.default).copyFilterWithName, {
                name: name
            })
        }, formatMessage((0, $199zy.default).copyFilter)), isCustom && (isOwner || isEditable) && ((0, $4R6GH.fg)('nin-save-filter-dialog-entry-point') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
            modalProps: modalProps,
            entryPoint: (0, $dPDY8.updateFilterDialogEntryPoint),
            entryPointProps: updateFilterEntryPointProps,
            entryPointParams: entryPointParams,
            useInternalModal: true
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
                onClick: (e)=>{
                    sendFilterActionAnalytics('editFilter');
                    onClose && onClose(e);
                },
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($084bx))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                "aria-label": formatMessage((0, $199zy.default).editWithName, {
                    name: name
                }),
                ref: ref
            }, formatMessage((0, $199zy.default).edit))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($084bx))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            onClick: (e)=>{
                openEditFilterModal();
                sendFilterActionAnalytics('editFilter');
                onClose && onClose(e);
            },
            "aria-label": formatMessage((0, $199zy.default).editWithName, {
                name: name
            })
        }, formatMessage((0, $199zy.default).edit))), isCustom && (isOwner || isAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
            onClick: (e)=>{
                openChangeOwnerModal();
                sendFilterActionAnalytics('changeOwner');
                onClose && onClose(e);
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3cwUp))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            "aria-label": formatMessage((0, $199zy.default).changeOwnerWithName, {
                name: name
            })
        }, formatMessage((0, $199zy.default).changeOwner))), isCustom && (isOwner || isAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
            hasSeparator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
            onClick: (e)=>{
                openDeleteFilterModal();
                sendFilterActionAnalytics('deleteFilter');
                onClose && onClose(e);
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bGsST))), {
                label: "",
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "spacious"
            }),
            "aria-label": formatMessage((0, $199zy.default).deleteWithName, {
                name: name
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
            color: "color.text.danger"
        }, formatMessage((0, $199zy.default).delete)))));
    }, [
        id,
        isFavourite,
        __typename,
        name,
        isCustom,
        formatMessage,
        isOwner,
        isEditable,
        isAdmin,
        filterId,
        sendFilterActionAnalytics,
        openCopyFilterModal,
        openEditFilterModal,
        openChangeOwnerModal,
        openDeleteFilterModal,
        modalProps,
        saveFilterEntryPointProps,
        updateFilterEntryPointProps,
        entryPointParams
    ]);
    const sendMeatballAnalytics = (0, $5uXOq.useCallback)(()=>{
        sendFilterAnalytics((0, $ce8062101363feb9$export$b887e88d8d0739f6), (0, $qBWno.getFilterMeatBallAttributes)({
            isCustom: isCustom,
            isFavourite: isFavourite,
            filterId: filterId
        }));
    }, [
        filterId,
        isCustom,
        isFavourite,
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        onOpen: sendMeatballAnalytics,
        MenuItems: MenuItems,
        name: name
    }), !(0, $4R6GH.fg)('nin-save-filter-dialog-entry-point') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cKjus.AsyncSaveFilterDialogContent), {
        isOpen: isCopyFilterModalOpen,
        filterId: filterId,
        jql: jql,
        title: formatMessage((0, $199zy.default).copyFilterDialogTitle),
        onClose: closeCopyFilterModal,
        onFilterSave: onFilterSave
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6KXPO.AsyncUpdateFilterDialog), {
        isOpen: isEditFilterModalOpen,
        filterId: filterId ?? '',
        onClose: closeEditFilterModal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gDIE0.ChangeOwnerModal), {
        isOpen: isChangeOwnerModalOpen,
        filterId: filterId,
        onRefetch: onRefetch,
        onClose: closeChangeOwnerModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l3IPn.DeleteFilterModal), {
        isOpen: isDeleteFilterModalOpen,
        name: name,
        filterId: filterId,
        onRefetch: onRefetch,
        onClose: closeDeleteFilterModal
    }));
};

});
parcelRegister("jaCjz", function(module, exports) {

$parcel$export(module.exports, "default", () => $349d0551267ba34b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b02630a993ab57f513c5d9a5a5ea9816>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $349d0551267ba34b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4FilterActions",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        }
                    ]
                }
            ],
            "type": "JiraCustomFilter"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$349d0551267ba34b$var$node.hash = "ceac0ec9e5b4a025e25fe096d35c5d3b";
var $349d0551267ba34b$export$2e2bcd8739ae039 = $349d0551267ba34b$var$node;

});

parcelRegister("lGgwk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbd1068d7fb082440154244857d12f2c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc8a55d93b109359$var$_react = $fc8a55d93b109359$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fc8a55d93b109359$var$_baseNew = $fc8a55d93b109359$var$_interopRequireDefault((parcelRequire("enEmH")));
function $fc8a55d93b109359$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc8a55d93b109359$var$CopyIcon = (props)=>/*#__PURE__*/ $fc8a55d93b109359$var$_react.default.createElement($fc8a55d93b109359$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$fc8a55d93b109359$var$CopyIcon.displayName = 'CopyIcon';
var $fc8a55d93b109359$var$_default = module.exports.default = $fc8a55d93b109359$var$CopyIcon;

});

parcelRegister("bGsST", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32784ef133e6e682f32ae3035edbf69e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $881a05c6f4edd719$var$_react = $881a05c6f4edd719$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $881a05c6f4edd719$var$_baseNew = $881a05c6f4edd719$var$_interopRequireDefault((parcelRequire("enEmH")));
function $881a05c6f4edd719$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $881a05c6f4edd719$var$DeleteIcon = (props)=>/*#__PURE__*/ $881a05c6f4edd719$var$_react.default.createElement($881a05c6f4edd719$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75V2.5h3.5V4h-1v10a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V4h-1V2.5H5zM6.5 2.5h3v-1h-3zM4 4v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zm1.75 9V5.5h1.5V13zm3 0V5.5h1.5V13z" clip-rule="evenodd"/>`
    }, props));
$881a05c6f4edd719$var$DeleteIcon.displayName = 'DeleteIcon';
var $881a05c6f4edd719$var$_default = module.exports.default = $881a05c6f4edd719$var$DeleteIcon;

});

parcelRegister("084bx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0006420a77150094$var$_react = $0006420a77150094$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0006420a77150094$var$_baseNew = $0006420a77150094$var$_interopRequireDefault((parcelRequire("enEmH")));
function $0006420a77150094$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0006420a77150094$var$EditIcon = (props)=>/*#__PURE__*/ $0006420a77150094$var$_react.default.createElement($0006420a77150094$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$0006420a77150094$var$EditIcon.displayName = 'EditIcon';
var $0006420a77150094$var$_default = module.exports.default = $0006420a77150094$var$EditIcon;

});

parcelRegister("dvv9E", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19440c8dd0e3db5766add744ad314d45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d565642138875e6$var$_react = $9d565642138875e6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9d565642138875e6$var$_baseNew = $9d565642138875e6$var$_interopRequireDefault((parcelRequire("enEmH")));
function $9d565642138875e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9d565642138875e6$var$EmailIcon = (props)=>/*#__PURE__*/ $9d565642138875e6$var$_react.default.createElement($9d565642138875e6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$9d565642138875e6$var$EmailIcon.displayName = 'EmailIcon';
var $9d565642138875e6$var$_default = module.exports.default = $9d565642138875e6$var$EmailIcon;

});

parcelRegister("7WnQL", function(module, exports) {

$parcel$export(module.exports, "isFavoritableItemTypename", () => $28a998bf88e6dba6$export$2bcd2af12bfc25b5);

var $eXQym = parcelRequire("eXQym");
const $28a998bf88e6dba6$export$2bcd2af12bfc25b5 = (typename)=>(0, $eXQym.VALID_ITEM_TYPENAMES).some((itemTypename)=>itemTypename === typename);

});
parcelRegister("eXQym", function(module, exports) {

$parcel$export(module.exports, "BOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$aade82542e73ffc8);
$parcel$export(module.exports, "FILTERS_ITEM_TYPE", () => $6c76a5a290814989$export$a448ebfa10cebc74);
$parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$f8099f229527572c);
$parcel$export(module.exports, "ISSUES_ITEM_TYPE", () => $6c76a5a290814989$export$8e58083dcbb878d);
$parcel$export(module.exports, "PLANS_ITEM_TYPE", () => $6c76a5a290814989$export$2fd44a6cb58b66cb);
$parcel$export(module.exports, "PROJECTS_ITEM_TYPE", () => $6c76a5a290814989$export$8e2cd98172988d7e);
$parcel$export(module.exports, "QUEUES_ITEM_TYPE", () => $6c76a5a290814989$export$6b0c8e47d2c7f1d9);
$parcel$export(module.exports, "VALID_ITEM_TYPES", () => $6c76a5a290814989$export$9c8cfad65800ddfb);
$parcel$export(module.exports, "VALID_ITEM_TYPENAMES", () => $6c76a5a290814989$export$2d63a9c2e78633c8);
const $6c76a5a290814989$export$aade82542e73ffc8 = 'boards';
const $6c76a5a290814989$export$a448ebfa10cebc74 = 'filters';
const $6c76a5a290814989$export$f8099f229527572c = 'dashboards';
const $6c76a5a290814989$export$8e58083dcbb878d = 'issues';
const $6c76a5a290814989$export$2fd44a6cb58b66cb = 'plans';
const $6c76a5a290814989$export$8e2cd98172988d7e = 'projects';
const $6c76a5a290814989$export$6b0c8e47d2c7f1d9 = 'queues';
const $6c76a5a290814989$export$9c8cfad65800ddfb = [
    $6c76a5a290814989$export$aade82542e73ffc8,
    $6c76a5a290814989$export$f8099f229527572c,
    $6c76a5a290814989$export$a448ebfa10cebc74,
    $6c76a5a290814989$export$8e58083dcbb878d,
    $6c76a5a290814989$export$2fd44a6cb58b66cb,
    $6c76a5a290814989$export$8e2cd98172988d7e,
    $6c76a5a290814989$export$6b0c8e47d2c7f1d9
];
const $6c76a5a290814989$export$2d63a9c2e78633c8 = [
    'JiraProject',
    'JiraCustomFilter',
    'JiraSystemFilter',
    'JiraDashboard',
    'JiraPlan',
    'JiraBoard',
    'JiraServiceManagementQueue'
];

});


parcelRegister("d62in", function(module, exports) {

$parcel$export(module.exports, "FavoriteToggleButton", () => $177932fc5526585a$export$b01f3062fe4ad89b);

var $5uXOq = parcelRequire("5uXOq");

var $X3Phd = parcelRequire("X3Phd");

var $fkyxu = parcelRequire("fkyxu");

var $7H980 = parcelRequire("7H980");

var $6eFvr = parcelRequire("6eFvr");

var $4041n = parcelRequire("4041n");

var $koVbs = parcelRequire("koVbs");

var $9eeFp = parcelRequire("9eeFp");

var $9WLyc = parcelRequire("9WLyc");
const $177932fc5526585a$var$UnstarredIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fkyxu))), {
    label: "",
    color: "currentColor",
    spacing: "spacious"
});
const $177932fc5526585a$var$StarredIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($X3Phd))), {
    label: "",
    color: "var(--ds-icon-accent-yellow, #B38600)",
    spacing: "spacious"
});
const $177932fc5526585a$export$b01f3062fe4ad89b = ({ entityId: entityId, entityTypeName: entityTypeName, defaultIsStarred: defaultIsStarred = false, name: name, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isStarred, setIsStarred] = (0, $5uXOq.useState)(defaultIsStarred);
    const { changeFavoriteMutation: changeFavoriteMutation } = (0, $4041n.useChangeFavorite)();
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        setIsStarred((prevIsStarred)=>!prevIsStarred);
        onClick?.();
    }, [
        onClick
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isStarred !== defaultIsStarred) changeFavoriteMutation({
            id: entityId,
            typename: entityTypeName,
            value: isStarred
        });
    }, [
        entityId,
        entityTypeName,
        isStarred,
        defaultIsStarred,
        changeFavoriteMutation
    ]);
    const handleOnClickWithStopPropagation = (0, $9eeFp.useStopPropagation)(handleOnClick);
    return isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        iconBefore: $177932fc5526585a$var$StarredIcon,
        onClick: handleOnClickWithStopPropagation,
        "aria-label": name ? formatMessage((0, $9WLyc.default).removeFromStarredWithName, {
            name: name
        }) : formatMessage((0, $9WLyc.default).removeFromStarred)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text"
    }, formatMessage((0, $9WLyc.default).removeFromStarred))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        iconBefore: $177932fc5526585a$var$UnstarredIcon,
        onClick: handleOnClickWithStopPropagation,
        "aria-label": name ? formatMessage((0, $9WLyc.default).addToStarredWithName, {
            name: name
        }) : formatMessage((0, $9WLyc.default).addToStarred)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text"
    }, formatMessage((0, $9WLyc.default).addToStarred)));
};

});
parcelRegister("4041n", function(module, exports) {

$parcel$export(module.exports, "FavoriteChangeContext", () => $e574e5c3227b76f4$export$a5d258b9665ce94b);
$parcel$export(module.exports, "FavoriteChangeProvider", () => $e574e5c3227b76f4$export$b06b5ce59fd5e408);
$parcel$export(module.exports, "FavoriteChangeConsumer", () => $e574e5c3227b76f4$export$f227cdfbb355444a);
$parcel$export(module.exports, "useChangeFavorite", () => $e574e5c3227b76f4$export$cfa169f3278459e8);

var $kZupY = parcelRequire("kZupY");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $jcw0u = parcelRequire("jcw0u");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $erN97 = parcelRequire("erN97");

var $j6ttF = parcelRequire("j6ttF");

var $7lK06 = parcelRequire("7lK06");

var $eXQym = parcelRequire("eXQym");

var $5c9oS = parcelRequire("5c9oS");

var $7SIuT = parcelRequire("7SIuT");
const $e574e5c3227b76f4$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
            ...state,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [item.type]: {
                ...state[item.type],
                [item.id]: item
            }
        });
const $e574e5c3227b76f4$export$72b8c6d38aa6195b = (item)=>(state)=>({
            ...state,
            items: {
                ...state.items,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [item.type]: {
                    ...state.items[item.type],
                    [item.id]: item
                }
            }
        });
const $e574e5c3227b76f4$export$b212ddc707077772 = {
    items: {
        boards: {},
        filters: {},
        issues: {},
        dashboards: {},
        projects: {},
        queues: {},
        plans: {}
    },
    changeFavorite: ()=>new Promise((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))),
    changeFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    updateFavoriteState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $e574e5c3227b76f4$export$a5d258b9665ce94b = /*#__PURE__*/ (0, $5uXOq.createContext)($e574e5c3227b76f4$export$b212ddc707077772);
// supports project types only for now
const $e574e5c3227b76f4$var$useRelayFavoriteUpdate = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const commitUpdate = (0, $5uXOq.useCallback)(({ id: id, type: type, value: value })=>{
        if (type === (0, $eXQym.PROJECTS_ITEM_TYPE)) (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
            const ari = (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                resourceType: 'project',
                resourceId: id,
                cloudId: cloudId
            });
            const projectRecordId = (0, $erN97.default)({
                id: ari
            }, 'JiraProject');
            if (projectRecordId) {
                const projectRecord = store.get(projectRecordId);
                const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                favoriteRecord?.setValue(value, 'isFavourite');
            }
        });
    }, [
        cloudId,
        environment
    ]);
    return {
        commitUpdate: commitUpdate
    };
};
const $e574e5c3227b76f4$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
    const { commitUpdate: commitUpdate } = $e574e5c3227b76f4$var$useRelayFavoriteUpdate();
    const [items, setItems] = (0, $5uXOq.useState)({
        boards: {},
        filters: {},
        dashboards: {},
        issues: {},
        projects: {},
        queues: {},
        plans: {}
    });
    const onChangeStart = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: true
        }));
    }, []);
    const onChangeSuccess = (0, $5uXOq.useCallback)((item, analyticsEvent)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
        if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, // removing last letter to make item.type singular tense (i.e. boards => board)
        `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
    }, []);
    const onChangeFail = (0, $5uXOq.useCallback)((item, analyticsId, error)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            value: !item.value,
            pending: false
        }));
        if (onShowFlag) onShowFlag((0, $7SIuT.errorFlag)());
        (0, $jcw0u.default)({
            meta: {
                id: analyticsId,
                packageName: 'jiraFavouriteChangeProvider',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onShowFlag
    ]);
    const changeFavorite = (0, $5uXOq.useCallback)(async (item, analyticsEvent)=>{
        const performChange = async ()=>{
            onChangeStart(item);
            try {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: item.value
                });
                await (0, $5c9oS.default)(item);
                const typename = (0, $j6ttF.favoriteTypeToTypename)(item.type, item.id);
                if (typename) (0, $7lK06.publishFavorite)(typename, {
                    type: 'REST',
                    entityId: item.id,
                    isFavourite: item.value
                });
                onChangeSuccess(item, analyticsEvent);
            } catch (error) {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: !item.value
                });
                onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
            }
        };
        return performChange();
    }, [
        commitUpdate,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $kZupY.default));
    const changeFavoriteMutation = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        const dataId = (0, $erN97.default)({
            id: payload.id
        }, payload.typename);
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        const onUpdate = (store, isOptimistic)=>{
            if (!dataId) return;
            (0, $7lK06.publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: isOptimistic
            });
            const record = store.get(dataId);
            if (record) {
                // Some favoritable entities provide an `isFavourite` field, e.g. `JiraFilter`, `JiraProject`.
                if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                // Optimistically update the `favouriteValue` node associated with the updated entity (if present).
                // We only need to do this during optimistic update as the node will be returned in a successful
                // mutation response.
                if (isOptimistic) {
                    const favoriteRecord = record.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(payload.value, 'isFavourite');
                }
            }
        };
        onChangeStart(restItem);
        commitMutation({
            variables: {
                input: {
                    entityId: payload.id,
                    isFavourite: payload.value,
                    beforeEntityId: payload.beforeEntity?.id ?? null
                }
            },
            optimisticUpdater: (store)=>{
                onUpdate(store, true);
            },
            updater: (store, response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
            },
            onCompleted: (response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                else onChangeFail(restItem, 'changeFavoriteMutation');
            },
            onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
        });
    }, [
        commitMutation,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const updateFavoriteState = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
    }, []);
    const emitChangedFavorite = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        onChangeSuccess(payload, analyticsEvent);
        const typeName = (0, $j6ttF.favoriteTypeToTypename)(payload.type, payload.id);
        if (typeName) (0, $7lK06.publishFavorite)(typeName, {
            type: 'REST',
            entityId: payload.id,
            isFavourite: payload.value
        });
    }, [
        onChangeSuccess
    ]);
    const emitChangedFavoriteMutation = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (payload, store, analyticsEvent)=>{
        const dataId = (0, $erN97.default)({
            id: payload.id
        }, payload.typename) ?? '';
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        onChangeSuccess(restItem, analyticsEvent);
        (0, $7lK06.publishFavorite)(payload.typename, {
            type: 'MUTATION',
            store: store,
            dataId: dataId,
            entityId: payload.id,
            isFavourite: payload.value,
            isOptimistic: false
        });
    }, [
        onChangeSuccess
    ]);
    const providerValue = (0, $5uXOq.useMemo)(()=>({
            items: items,
            changeFavorite: changeFavorite,
            changeFavoriteMutation: changeFavoriteMutation,
            emitChangedFavorite: emitChangedFavorite,
            emitChangedFavoriteMutation: emitChangedFavoriteMutation,
            updateFavoriteState: updateFavoriteState
        }), [
        items,
        changeFavorite,
        changeFavoriteMutation,
        emitChangedFavorite,
        emitChangedFavoriteMutation,
        updateFavoriteState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$a5d258b9665ce94b.Provider, {
        value: providerValue
    }, children);
};
const $e574e5c3227b76f4$export$f227cdfbb355444a = $e574e5c3227b76f4$export$a5d258b9665ce94b.Consumer;
const $e574e5c3227b76f4$export$61944ffe37754ff2 = (WrappedComponent)=>{
    const WithFavoriteChangeConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$f227cdfbb355444a, null, (favoriteChangeContext)=>// @ts-expect-error - TS2322 - Type 'P & { favoriteChangeContext: FavoriteChangeContextType; }' is not assignable to type 'IntrinsicAttributes & W & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                favoriteChangeContext: favoriteChangeContext
            }));
    const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
    return WithFavoriteChangeConsumer;
};
const $e574e5c3227b76f4$export$cfa169f3278459e8 = ()=>(0, $5uXOq.useContext)($e574e5c3227b76f4$export$a5d258b9665ce94b);

});
parcelRegister("kZupY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64781493fbfe6b0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<581ee8573bf9ee1f32ccc64539d4c7bc>>
 * @relayHash 6de546c6546651e6c4572b78dca9bcd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f
const $d64781493fbfe6b0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSetIsFavouritePayload",
                    "kind": "LinkedField",
                    "name": "setEntityIsFavourite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
            "metadata": {},
            "name": "viewSetFavouriteMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d64781493fbfe6b0$var$node.hash = "af74e48c451986374e11a5b801d5009f";
var $d64781493fbfe6b0$export$2e2bcd8739ae039 = $d64781493fbfe6b0$var$node;

});

parcelRegister("dXq4S", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $5c4418bd595ae8cf$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $5c4418bd595ae8cf$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $5c4418bd595ae8cf$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $5c4418bd595ae8cf$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $5c4418bd595ae8cf$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $5c4418bd595ae8cf$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $5c4418bd595ae8cf$export$8e68286aef4c3a8b = (ari)=>$5c4418bd595ae8cf$var$ARI_REG_EXP.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $5c4418bd595ae8cf$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $5c4418bd595ae8cf$export$24b47820a324e614 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $5c4418bd595ae8cf$export$e2789192113e8b07 = (ari, defaultValue = '')=>$5c4418bd595ae8cf$export$24b47820a324e614(ari) ?? defaultValue;
const $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) {
        const parts = $5c4418bd595ae8cf$var$ARI_REG_EXP.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $5c4418bd595ae8cf$export$3d8d7031a11613fd = (ari)=>{
    const config = $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});

parcelRegister("j6ttF", function(module, exports) {

$parcel$export(module.exports, "favoriteTypeToTypename", () => $b9c3378eb0d73712$export$b98f76d96728a853);
$parcel$export(module.exports, "favoriteMutationToRestPayload", () => $b9c3378eb0d73712$export$717886a1047f1287);

var $1Y49U = parcelRequire("1Y49U");

var $1WQct = parcelRequire("1WQct");

var $k0goX = parcelRequire("k0goX");

var $gbLWS = parcelRequire("gbLWS");

var $89DrR = parcelRequire("89DrR");

var $j5YhT = parcelRequire("j5YhT");
function $b9c3378eb0d73712$var$assertUnreachable(_) {
    throw new Error('Unexpected entity type');
}
const $b9c3378eb0d73712$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $b9c3378eb0d73712$export$b98f76d96728a853 = (type, resourceId)=>{
    switch(type){
        case 'projects':
            return 'JiraProject';
        case 'filters':
            return $b9c3378eb0d73712$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
        case 'dashboards':
            return 'JiraDashboard';
        case 'plans':
            return 'JiraPlan';
        case 'boards':
            return 'JiraBoard';
        case 'queues':
            return 'JiraServiceManagementQueue';
        default:
            return undefined;
    }
};
const $b9c3378eb0d73712$var$favoriteAriToId = (typename, ari)=>{
    switch(typename){
        case 'JiraProject':
            return (0, $j5YhT.JiraProjectAri).parse(ari).projectId;
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return (0, $gbLWS.JiraFilterAri).parse(ari).filterId;
        case 'JiraDashboard':
            return (0, $k0goX.JiraDashboardAri).parse(ari).dashboardId;
        case 'JiraPlan':
            return (0, $89DrR.JiraPlanAri).parse(ari).planId;
        case 'JiraBoard':
            return (0, $1WQct.JiraSoftwareBoardAri).parse(ari).boardId;
        case 'JiraServiceManagementQueue':
            return (0, $1Y49U.JiraServicedeskQueueAri).parse(ari).queueId;
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$var$favoriteTypenameToType = (typename)=>{
    switch(typename){
        case 'JiraProject':
            return 'projects';
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return 'filters';
        case 'JiraDashboard':
            return 'dashboards';
        case 'JiraPlan':
            return 'plans';
        case 'JiraBoard':
            return 'boards';
        case 'JiraServiceManagementQueue':
            return 'queues';
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
        id: $b9c3378eb0d73712$var$favoriteAriToId(typename, id),
        type: $b9c3378eb0d73712$var$favoriteTypenameToType(typename),
        value: value,
        beforeEntity: beforeEntity ? {
            id: $b9c3378eb0d73712$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
            type: $b9c3378eb0d73712$var$favoriteTypenameToType(beforeEntity.typename)
        } : undefined
    });

});

parcelRegister("5c9oS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9559749111f2eca$export$2e2bcd8739ae039);

var $7eYK2 = parcelRequire("7eYK2");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f9559749111f2eca$export$2e2bcd8739ae039 = async (request)=>(0, $7eYK2.updateFavorite)(request);

});
parcelRegister("7eYK2", function(module, exports) {

$parcel$export(module.exports, "updateFavorite", () => $16085bb5bdb7219b$export$8c2f00130cc945dc);

var $eusud = parcelRequire("eusud");
const $16085bb5bdb7219b$export$8c2f00130cc945dc = async (request)=>{
    if (request.value) return (0, $eusud.performPostRequest)('/rest/internal/2/favourites', {
        body: JSON.stringify({
            entity: {
                id: request.id,
                type: request.type
            },
            beforeEntityPosition: request.beforeEntity || null
        })
    });
    return (0, $eusud.performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
};

});


parcelRegister("7SIuT", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $7252fdcfc0e15292$export$b9a7f1ebeaa76953);

var $0YlRJ = parcelRequire("0YlRJ");
const $7252fdcfc0e15292$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        ...(0, $0YlRJ.default)
    });

});
parcelRegister("0YlRJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ad72b3da53041c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $87ad72b3da53041c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
        "defaultMessage": "Something\u2019s gone wrong"
    },
    description: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
        "defaultMessage": "You cannot star items right now due to an error."
    }
});

});



parcelRegister("9WLyc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ff4f0ec548b713f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0ff4f0ec548b713f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addToStarred: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred",
        "defaultMessage": "Add to starred"
    },
    removeFromStarred: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred",
        "defaultMessage": "Remove from starred"
    },
    addToStarredWithName: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred-with-name",
        "defaultMessage": "Add \"{name}\" to starred"
    },
    removeFromStarredWithName: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred-with-name",
        "defaultMessage": "Remove \"{name}\" from starred"
    }
});

});


parcelRegister("cKjus", function(module, exports) {

$parcel$export(module.exports, "AsyncSaveFilterDialogContent", () => $c23de2261bd2f58d$export$e0d40cb0f88fa57d);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c23de2261bd2f58d$var$SaveFilterDialogContent = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("fs03C")).then((module)=>({
            default: module.OldSaveFilterDialogContent
        })), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/save-filter-dialog/save-filter-dialog-content/index.tsx"
});
const $c23de2261bd2f58d$export$e0d40cb0f88fa57d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-save-filters-dialog-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c23de2261bd2f58d$var$SaveFilterDialogContent, props));

});
parcelRegister("fs03C", function(module, exports) {

let $b3f983f21d4b4841$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b3f983f21d4b4841$var$load("h2MrD"),
    $b3f983f21d4b4841$var$load("bYT2S"),
    $b3f983f21d4b4841$var$load("3ChD0")
]).then(()=>parcelRequire('2lPrs'));

});


parcelRegister("6KXPO", function(module, exports) {

$parcel$export(module.exports, "AsyncUpdateFilterDialog", () => $5522efbabcc83563$export$8692e2751472dade);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5522efbabcc83563$var$UpdateFilterDialog = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("gGQ2v")).then((module)=>({
            default: module.OldUpdateFilterDialog
        })), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/update-filter-dialog/index.tsx"
});
const $5522efbabcc83563$export$8692e2751472dade = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-update-filter-dialog",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5522efbabcc83563$var$UpdateFilterDialog, props));

});
parcelRegister("gGQ2v", function(module, exports) {

let $c268ef8607cf1e29$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c268ef8607cf1e29$var$load("h2MrD"),
    $c268ef8607cf1e29$var$load("bYT2S"),
    $c268ef8607cf1e29$var$load("fBWcb")
]).then(()=>parcelRequire('36hTn'));

});


parcelRegister("fY39E", function(module, exports) {

$parcel$export(module.exports, "useActivationId", () => $d72c67677898c114$export$43686faa787c943);

var $9OXo1 = parcelRequire("9OXo1");
const $d72c67677898c114$export$43686faa787c943 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.activationId;
};

});

parcelRegister("2KAtx", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointPressableTrigger", () => $a17c22dd70443cfd$export$defad645fcc21c0a);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eCE62 = parcelRequire("eCE62");

var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");

var $bEIgH = parcelRequire("bEIgH");

var $3RTQl = parcelRequire("3RTQl");

var $7NYq5 = parcelRequire("7NYq5");

var $4R6GH = parcelRequire("4R6GH");

var $9fuVs = parcelRequire("9fuVs");

var $c5vfY = parcelRequire("c5vfY");

var $7mPT9 = parcelRequire("7mPT9");

var $gJdig = parcelRequire("gJdig");

var $fiv1r = parcelRequire("fiv1r");

var $dWBzX = parcelRequire("dWBzX");
const $a17c22dd70443cfd$var$emptyObject = {};
const $a17c22dd70443cfd$export$defad645fcc21c0a = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, title: title, modalProps: modalProps, useInternalModal: useInternalModal, forwardedRef: forwardedRef })=>{
    const { openModal: openModal } = (0, $5uXOq.useContext)((0, $gJdig.ModalContext));
    const environmentProvider = (0, $fiv1r.useJiraRelayEnvironmentProvider)();
    const metricName = (0, $5uXOq.useMemo)(()=>{
        if (interactionName) return interactionName;
        // @ts-expect-error Need to fix the types on this
        return entryPoint?.root?.getModuleName() ?? 'unknown';
    }, [
        entryPoint,
        interactionName
    ]);
    // eslint-disable-next-line jira/ufo/valid-labels
    const pressTracing = (0, $3RTQl.default)(metricName);
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, // @ts-expect-error TS cannot infer that emptyObject is the correct params
        // type for TEntryPoint even when performing an explicit undefined check
        entryPointParams ?? $a17c22dd70443cfd$var$emptyObject), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onBeforeLoad = (0, $5uXOq.useCallback)(()=>{
        if (interactionName) pressTracing();
    }, [
        interactionName,
        pressTracing
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = ()=>{
                entryPointProps?.onClose?.();
                closeModal();
                dispose();
            };
            const defaultFallbackInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUaFh.default), null, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Sb4G.default), null, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
                grow: "fill"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1QfP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CjwE.default), null));
            const defaultFallback = useInternalModal ? defaultFallbackInner : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
                messageId: "modal-entry-point-pressable-trigger.modal.fallback",
                messageType: "transactional",
                onClose: closeModal,
                width: modalProps?.width,
                height: modalProps?.height
            }, defaultFallbackInner);
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5vfY.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorAttributes: errorAttributes,
                errorFallback: "flag",
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                // @ts-expect-error Some type mismatch, should fix it one day
                runtimeProps: {
                    ...entryPointProps ?? $a17c22dd70443cfd$var$emptyObject,
                    onClose: onClose,
                    ...(0, $4R6GH.fg)('jpo-31059_modal_close_behaviour_controls') ? {
                        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                        shouldCloseOnEscapePress: shouldCloseOnEscapePress
                    } : {}
                }
            });
            return useInternalModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
                ...modalProps,
                messageId: "modal-entry-point-pressable-trigger.modal",
                messageType: "transactional",
                onClose: onClose,
                ...(0, $4R6GH.fg)('jpo-31059_modal_close_behaviour_controls') ? {
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress
                } : {}
            }, container)) : container;
        });
    }, [
        openModal,
        title,
        useInternalModal,
        modalProps,
        errorAttributes,
        Fallback,
        metricName,
        entryPointProps
    ]);
    const triggerRef = (0, $dWBzX.usePressablePreloadRef)({
        load: load,
        onBeforeLoad: onBeforeLoad,
        onLoad: onLoad
    });
    if (forwardedRef != null) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const ref = (0, $7mPT9.default)(triggerRef, forwardedRef);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return children({
            ref: ref
        });
    }
    return children({
        ref: triggerRef
    });
};

});
parcelRegister("7NYq5", function(module, exports) {

$parcel$export(module.exports, "JiraModal", () => $d308ab9275c4cac7$export$3782fcca1f68992e);

var $5uXOq = parcelRequire("5uXOq");

var $hordk = parcelRequire("hordk");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $1WAOl = parcelRequire("1WAOl");
const $d308ab9275c4cac7$export$3782fcca1f68992e = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1WAOl.ChoreographerModal), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hordk.default), rest);
};
$d308ab9275c4cac7$export$3782fcca1f68992e.displayName = 'JiraModal';

});
parcelRegister("1WAOl", function(module, exports) {

$parcel$export(module.exports, "ChoreographerModal", () => $ae3d8c3c4e97b978$export$3f5d627caa6fc630);
// eslint-disable-next-line @typescript-eslint/no-restricted-imports

var $hordk = parcelRequire("hordk");

var $cSWNW = parcelRequire("cSWNW");
const $ae3d8c3c4e97b978$export$3f5d627caa6fc630 = (0, $cSWNW.withChoreographedRender)((0, $hordk.default));

});


parcelRegister("9fuVs", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $1dd87679d9ca363b$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $1dd87679d9ca363b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $k4r7E = parcelRequire("k4r7E");
const $1dd87679d9ca363b$export$ebbb59327adb551a = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $k4r7E.rootRegistry));
const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $5uXOq.useMemo)(()=>new (0, $k4r7E.ShortcutRegistry)(), []);
    const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, $k4r7E.rootRegistry);
    (0, $5uXOq.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;

});
parcelRegister("k4r7E", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $a65fecdbaed23de2$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $lbWm4 = parcelRequire("lbWm4");

var $561FV = parcelRequire("561FV");

var $hGgHi = parcelRequire("hGgHi");

var $FISJv = parcelRequire("FISJv");

var $lIZQG = parcelRequire("lIZQG");
const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $lIZQG.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $lIZQG.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $lIZQG.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($FISJv)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();

});
parcelRegister("lIZQG", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $ca3344250c7b7406$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $ca3344250c7b7406$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $ca3344250c7b7406$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $ca3344250c7b7406$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $ca3344250c7b7406$var$toKey = (e)=>{
    if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("7mPT9", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $d1da29f25d5b5e0a$export$c9058316764c140e);
$parcel$export(module.exports, "default", () => $d1da29f25d5b5e0a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $d1da29f25d5b5e0a$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref.current = value; // eslint-disable-line no-param-reassign
        });
    };
}
function $d1da29f25d5b5e0a$export$2e2bcd8739ae039(...refs) {
    return (0, $5uXOq.useMemo)(()=>$d1da29f25d5b5e0a$export$c9058316764c140e(...refs), // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}

});

parcelRegister("gJdig", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $308ba6e6ba886f08$export$ab57792b9b6974a6);

var $5uXOq = parcelRequire("5uXOq");
const $308ba6e6ba886f08$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openModal: ()=>{}
});

});

parcelRegister("dWBzX", function(module, exports) {

$parcel$export(module.exports, "usePressablePreloadRef", () => $01294bc664dce1e5$export$1ff47f24e06a5d2d);

var $5uXOq = parcelRequire("5uXOq");
const $01294bc664dce1e5$var$PRELOAD_MAX_AGE = 2000;
const $01294bc664dce1e5$var$TIME_TO_INTENT = 200;
function $01294bc664dce1e5$export$1ff47f24e06a5d2d({ load: load, onBeforeLoad: onBeforeLoad, onLoad: onLoad }) {
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const clickListener = ()=>{
            clearPreloadTimeouts();
            onBeforeLoad();
            onLoad(loadReference());
        };
        const mouseDownListener = ()=>{
            clearPreloadTimeouts();
            loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $01294bc664dce1e5$var$PRELOAD_MAX_AGE);
            }, $01294bc664dce1e5$var$TIME_TO_INTENT);
        };
        el.addEventListener('click', clickListener);
        el.addEventListener('mousedown', mouseDownListener);
        el.addEventListener('mouseenter', preloadReference);
        el.addEventListener('mouseleave', cancelPreload);
        return ()=>{
            cancelPreload();
            el.removeEventListener('click', clickListener);
            el.removeEventListener('mousedown', mouseDownListener);
            el.removeEventListener('mouseenter', preloadReference);
            el.removeEventListener('mouseleave', cancelPreload);
        };
    }, [
        load,
        onBeforeLoad,
        onLoad
    ]);
    return ref;
}

});


parcelRegister("c88gN", function(module, exports) {

$parcel$export(module.exports, "saveFilterDialogEntryPoint", () => $cfe7c72484f65a07$export$7485e0220e11838f);

var $8Wzbc = parcelRequire("8Wzbc");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $cfe7c72484f65a07$export$7485e0220e11838f = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("fs03C")), {
        moduleId: "6b7b6fa9"
    }),
    getPreloadProps: ({ filterAri: filterAri })=>({
            queries: {
                filterDataQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $8Wzbc.default,
                    variables: {
                        filterAri: filterAri ?? '',
                        includeFilter: !!filterAri
                    }
                }
            }
        })
});

});
parcelRegister("8Wzbc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5367ef59b8680269$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<023defe713d59713b501c494a8f5f82d>>
 * @relayHash 1cbad96d89377cc6461f652661fc6f1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fd504e29d4dc200a7bd2aa6320fb29407cc36c5f68c5b1d8ee23563f54a69190
const $5367ef59b8680269$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "filterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "description"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v7 = {
        "kind": "RequiredField",
        "field": {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v2 /*: any*/ ,
                    "action": "THROW",
                    "path": "jira.filter.shareGrants.edges.node.project.id"
                },
                v3 /*: any*/ ,
                v6 /*: any*/ 
            ]
        },
        "action": "THROW",
        "path": "jira.filter.shareGrants.edges.node.project"
    }, v8 = {
        "kind": "ScalarField",
        "name": "roleId"
    }, v9 = {
        "concreteType": "JiraRole",
        "kind": "LinkedField",
        "name": "role",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v3 /*: any*/ 
        ]
    }, v10 = {
        "concreteType": "JiraGroup",
        "kind": "LinkedField",
        "name": "group",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v3 /*: any*/ 
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v13 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v3 /*: any*/ ,
            v12 /*: any*/ 
        ]
    }, v14 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v6 /*: any*/ 
        ]
    }, v15 = {
        "kind": "RequiredField",
        "field": v14 /*: any*/ ,
        "action": "THROW",
        "path": "jira.filter.editGrants.edges.node.project"
    }, v16 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v5 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v14 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityProjectGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v14 /*: any*/ ,
                        {
                            "concreteType": "JiraRole",
                            "kind": "LinkedField",
                            "name": "role",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v3 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraShareableEntityProjectRoleGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v10 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityGroupGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v11 /*: any*/ ,
                                v3 /*: any*/ ,
                                v12 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraShareableEntityUserGrant"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "saveFilterDialogBaseQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraShareableEntityShareGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "shareGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityShareGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v9 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.shareGrants.edges.node.role"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectRoleGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v10 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.shareGrants.edges.node.group"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityGroupGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v13 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.shareGrants.edges.node.user"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityUserGrant"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraShareableEntityEditGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "editGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityEditGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v15 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v15 /*: any*/ ,
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v9 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.editGrants.edges.node.role"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityProjectRoleGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v10 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.editGrants.edges.node.group"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityGroupGrant"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v13 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.filter.editGrants.edges.node.user"
                                                                                }
                                                                            ],
                                                                            "type": "JiraShareableEntityUserGrant"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "saveFilterDialogBaseQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraShareableEntityShareGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "shareGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityShareGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": v16 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraShareableEntityEditGrantConnection",
                                                    "kind": "LinkedField",
                                                    "name": "editGrants",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraShareableEntityEditGrantEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": v16 /*: any*/ 
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fd504e29d4dc200a7bd2aa6320fb29407cc36c5f68c5b1d8ee23563f54a69190",
            "metadata": {},
            "name": "saveFilterDialogBaseQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5367ef59b8680269$var$node.hash = "45c8d5891e94a17785f8230bd778c3e5";
var $5367ef59b8680269$export$2e2bcd8739ae039 = $5367ef59b8680269$var$node;

});


parcelRegister("dPDY8", function(module, exports) {

$parcel$export(module.exports, "updateFilterDialogEntryPoint", () => $d618886bc2f027fb$export$89f63332d1b5f8db);

var $8Wzbc = parcelRequire("8Wzbc");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $d618886bc2f027fb$export$89f63332d1b5f8db = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("gGQ2v")), {
        moduleId: "a40748cc"
    }),
    getPreloadProps: ({ filterAri: filterAri })=>({
            queries: {
                filterDataQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $8Wzbc.default,
                    variables: {
                        filterAri: filterAri ?? '',
                        includeFilter: !!filterAri
                    }
                }
            }
        })
});

});

parcelRegister("qBWno", function(module, exports) {

$parcel$export(module.exports, "useFilterActionsAnalytics", () => $e63dd990973b9127$export$97e99df7fbddf9f6);
$parcel$export(module.exports, "getFilterActionAttributes", () => $e63dd990973b9127$export$b06742bfd24ebf9f);
$parcel$export(module.exports, "getFilterMeatBallAttributes", () => $e63dd990973b9127$export$b8e6b9b84ba340a2);
$parcel$export(module.exports, "getRecentAndFavouriteFilterAttributes", () => $e63dd990973b9127$export$2108e20c9691c7e4);
$parcel$export(module.exports, "getDefaulFilterAttributes", () => $e63dd990973b9127$export$15e07b997aa6036a);





var $jecJ3 = parcelRequire("jecJ3");

var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");
const $e63dd990973b9127$export$97e99df7fbddf9f6 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireFilterActionAnalytics = (actionSubject, attributes)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: actionSubject
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_FILTERS], attributes);
    };
    return fireFilterActionAnalytics;
};
const $e63dd990973b9127$var$systemFilterNameMap = [
    {
        name: 'myOpenIssues',
        id: '-1'
    },
    {
        name: 'reportedByMe',
        id: '-2'
    },
    {
        name: 'allIssues',
        id: '-4'
    },
    {
        name: 'openIssues',
        id: '-5'
    },
    {
        name: 'doneIssues',
        id: '-9'
    },
    {
        name: 'viewedRecently',
        id: '-3'
    },
    {
        name: 'resolvedRecently',
        id: '-7'
    },
    {
        name: 'updatedRecently',
        id: '-8'
    },
    {
        name: 'createdRecently',
        id: '-6'
    }
];
const $e63dd990973b9127$export$c8c77a62dd73e040 = (id)=>{
    const systemFilter = $e63dd990973b9127$var$systemFilterNameMap.find((filter)=>filter.id === id);
    return systemFilter?.name || '';
};
const $e63dd990973b9127$var$getSection = (isCustom, isFavourite)=>{
    let section;
    if (!isCustom && !isFavourite) section = 'defaultFilters';
    else if (isFavourite) section = (0, $jecJ3.SECTION_ITEM_STARRED);
    else section = (0, $jecJ3.SECTION_ITEM_RECENT);
    return section;
};
const $e63dd990973b9127$var$getFilterId = (isCustom, filterId)=>{
    if (!filterId) return null;
    return (0, $jhS4y.ENTITY_ID).FILTER(isCustom ? filterId : $e63dd990973b9127$export$c8c77a62dd73e040(filterId));
};
const $e63dd990973b9127$export$b06742bfd24ebf9f = ({ itemId: itemId, isCustom: isCustom, isFavourite: isFavourite, filterId: filterId })=>{
    const section = $e63dd990973b9127$var$getSection(isCustom, Boolean(isFavourite));
    return {
        itemId: itemId,
        section: section,
        level: section === 'defaultFilters' ? (0, $951a0ed422513987$export$35ac629b8b943d5a) : (0, $951a0ed422513987$export$f9db6a58b4aabd18),
        componentType: isCustom ? (0, $1e554a683893bd46$export$5374c2c2d3ece55e) : (0, $1e554a683893bd46$export$74712b62056d422e),
        parentItemType: isCustom ? (0, $632bd8725b437a12$export$c1c49903035a02df) : (0, $632bd8725b437a12$export$6deee0e4f2fb784e),
        parentItemId: $e63dd990973b9127$var$getFilterId(isCustom, filterId)
    };
};
const $e63dd990973b9127$export$b8e6b9b84ba340a2 = ({ isCustom: isCustom, isFavourite: isFavourite, filterId: filterId })=>{
    const section = $e63dd990973b9127$var$getSection(isCustom, Boolean(isFavourite));
    return {
        section: section,
        level: section === 'defaultFilters' ? (0, $951a0ed422513987$export$f9db6a58b4aabd18) : (0, $951a0ed422513987$export$fe3b012b0224e4e1),
        componentType: isCustom ? (0, $1e554a683893bd46$export$9bd6c21d500ae611) : (0, $1e554a683893bd46$export$95b0c331af13d819),
        itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e),
        parentItemType: isCustom ? (0, $632bd8725b437a12$export$c1c49903035a02df) : (0, $632bd8725b437a12$export$6deee0e4f2fb784e),
        parentItemId: $e63dd990973b9127$var$getFilterId(isCustom, filterId)
    };
};
const $e63dd990973b9127$export$2108e20c9691c7e4 = ({ isCustom: isCustom, filterId: filterId, section: section })=>{
    return {
        level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
        section: section,
        componentType: isCustom ? (0, $1e554a683893bd46$export$3ac911b122986477) : (0, $1e554a683893bd46$export$4165a3d0da3bd147),
        itemId: $e63dd990973b9127$var$getFilterId(isCustom, filterId),
        itemType: isCustom ? (0, $632bd8725b437a12$export$c1c49903035a02df) : (0, $632bd8725b437a12$export$6deee0e4f2fb784e)
    };
};
const $e63dd990973b9127$export$15e07b997aa6036a = ({ filterId: filterId })=>{
    return {
        level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
        itemId: $e63dd990973b9127$var$getFilterId(false, filterId),
        section: 'defaultFilters',
        componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
        itemType: (0, $632bd8725b437a12$export$6deee0e4f2fb784e)
    };
};

});

parcelRegister("gDIE0", function(module, exports) {

$parcel$export(module.exports, "ChangeOwnerModal", () => $af6a0238933bbda1$export$fe3f500d38bfe0df);

var $5uXOq = parcelRequire("5uXOq");

var $bSlMQ = parcelRequire("bSlMQ");
const $af6a0238933bbda1$export$fe3f500d38bfe0df = ({ isOpen: isOpen, filterId: filterId, onRefetch: onRefetch, onClose: onClose })=>{
    const onSuccess = (0, $5uXOq.useCallback)(()=>{
        onRefetch({
            onComplete: ()=>undefined
        });
        onClose();
    }, [
        onRefetch,
        onClose
    ]);
    return isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bSlMQ.default), {
        id: filterId,
        onInitiateSuccess: ()=>undefined,
        onSuccess: onSuccess,
        onCancel: onClose,
        onInitiateFailed: ()=>undefined
    });
};

});
parcelRegister("bSlMQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b0e45c1a3e32250$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1wnUy = parcelRequire("1wnUy");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5b0e45c1a3e32250$var$NoLazyAsyncChangeOwnerFilterModal = (0, $b7Svb.lazy)(()=>(parcelRequire("2MdXv")), {
    moduleId: "./src/packages/global-pages/directories/filters-directory-v2/change-owner-filter-modal/src/index.tsx"
});
const $5b0e45c1a3e32250$var$AsyncChangeOwnerFilterModal = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "configure-owner-modal",
        packageName: "filter",
        fallback: "flag",
        teamName: "endeavour"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "change-owner-filter-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wnUy.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5b0e45c1a3e32250$var$NoLazyAsyncChangeOwnerFilterModal, props)));
var $5b0e45c1a3e32250$export$2e2bcd8739ae039 = $5b0e45c1a3e32250$var$AsyncChangeOwnerFilterModal;

});
parcelRegister("2MdXv", function(module, exports) {

let $205ae45daa3c6b8f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $205ae45daa3c6b8f$var$load("8g8En").then(()=>parcelRequire('2gMly'));

});



parcelRegister("l3IPn", function(module, exports) {

$parcel$export(module.exports, "DeleteFilterModal", () => $fae9ebce90c122ba$export$7eeb027d3dbb72df);

var $5uXOq = parcelRequire("5uXOq");

var $eM3no = parcelRequire("eM3no");

var $pa9q9 = parcelRequire("pa9q9");

var $ieDtd = parcelRequire("ieDtd");
var $lVJAU = parcelRequire("lVJAU");

var $ddrvO = parcelRequire("ddrvO");
const $fae9ebce90c122ba$export$7eeb027d3dbb72df = ({ isOpen: isOpen, name: name, filterId: filterId, onClose: onClose, onRefetch: onRefetch })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const [filterQueryParam] = (0, $ieDtd.useQueryParam)('filter');
    const onSuccess = (0, $5uXOq.useCallback)(()=>{
        onRefetch({
            onComplete: ()=>undefined
        });
        if (filterQueryParam === filterId) push('/jira/filters');
        onClose();
        showFlag({
            id: 'filter-deleted',
            title: [
                (0, $ddrvO.default).filterDeletedModalTitleSuccessNonFinal,
                {
                    name: name
                }
            ],
            type: 'success',
            messageId: 'navigation-apps-sidebar-nav4-sidebars-content-filters.common.ui.filter-actions.delete-filter-modal.show-flag.success',
            messageType: 'transactional'
        });
    }, [
        filterId,
        filterQueryParam,
        name,
        onClose,
        onRefetch,
        push,
        showFlag
    ]);
    const onFailure = (0, $5uXOq.useCallback)(()=>{
        onClose();
        showFlag({
            id: 'filter-delete-failed',
            title: (0, $ddrvO.default).filterDeletedModalTitleErrorNonFinal,
            description: (0, $ddrvO.default).filterDeletedModalDescriptionErrorNonFinal,
            type: 'error',
            messageId: 'navigation-apps-sidebar-nav4-sidebars-content-filters.common.ui.filter-actions.delete-filter-modal.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        onClose,
        showFlag
    ]);
    const filter = {
        name: name,
        id: filterId
    };
    return isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eM3no.default), {
        baseUrl: "",
        filter: filter,
        onFilterDeleted: onSuccess,
        onFilterDeleteFailed: onFailure,
        onFilterInitiateFailed: onFailure,
        onCancel: onClose
    });
};

});
parcelRegister("eM3no", function(module, exports) {

$parcel$export(module.exports, "default", () => $06cd5fbdfa743d8b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jzjy1 = parcelRequire("jzjy1");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $7iJwP = parcelRequire("7iJwP");


var $dZMvI = parcelRequire("dZMvI");

var $jemkP = parcelRequire("jemkP");

var $aDeVF = parcelRequire("aDeVF");

var $9ekJG = parcelRequire("9ekJG");

// eslint-disable-next-line jira/react/no-class-components
class $06cd5fbdfa743d8b$var$DeleteModal extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onInitialised: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onFilterDeleted: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $aDeVF.default)((0, $dZMvI.default));
        this.store.dispatch((0, $jemkP.setAppProps)(this.props));
        this.store.dispatch((0, $jemkP.getAssociatedItems)());
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store,
            hasErrorBoundary: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
            id: "unhandled",
            packageName: "jiraDeleteFiltersModal",
            teamName: "jira-cosmos"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ekJG.default), null))));
    }
}
var $06cd5fbdfa743d8b$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSource)('deleteFilter', (0, $4d5e0871c06cee03$export$1171103ea9083ffa))($06cd5fbdfa743d8b$var$DeleteModal);

});
parcelRegister("jzjy1", function(module, exports) {

$parcel$export(module.exports, "AnalyticsSource", () => $578c443a5ba38dde$export$6890652a1aff7d1c);
$parcel$export(module.exports, "AnalyticsSubject", () => $578c443a5ba38dde$export$ec9f54bd4341ceb);

var $asiGE = parcelRequire("asiGE");
const $578c443a5ba38dde$export$6890652a1aff7d1c = (name, type)=>(WrappedComponent)=>(0, $asiGE.default)({
            source: `${name}${type}`
        })(WrappedComponent);
const $578c443a5ba38dde$export$ec9f54bd4341ceb = (name, attributes)=>(WrappedComponent)=>(0, $asiGE.default)({
            actionSubject: name,
            attributes: attributes
        })(WrappedComponent);

});

parcelRegister("lf2Au", function(module, exports) {

$parcel$export(module.exports, "default", () => $9249f8c63b854f95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $9249f8c63b854f95$var$AppStyle = ({ children: children })=>/*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_11c82smr _4t3i1kw7"
        ])
    }, children);
const $9249f8c63b854f95$var$appStyles = null;
var $9249f8c63b854f95$export$2e2bcd8739ae039 = $9249f8c63b854f95$var$AppStyle;

});

parcelRegister("dZMvI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8e39f8e320e7804$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $kzfeq = parcelRequire("kzfeq");

var $b5iht = parcelRequire("b5iht");
var // @ts-expect-error - TS2769 - No overload matches this call.
$a8e39f8e320e7804$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $kzfeq.default), (0, $b5iht.default));

});
parcelRegister("kzfeq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b20171187c0eaaf$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $fsh9d = parcelRequire("fsh9d");


var $3HwlS = parcelRequire("3HwlS");

var $i2hR1 = parcelRequire("i2hR1");

var $jemkP = parcelRequire("jemkP");

var $iOraS = parcelRequire("iOraS");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1b20171187c0eaaf$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $jemkP.DELETE_FILTER)).mergeMap(({ onComplete: onComplete })=>{
        const state = store.getState();
        const baseUrl = (0, $iOraS.getBaseUrl)(state);
        const filter = (0, $iOraS.getFilter)(state);
        return (0, $kVLXA.Observable).fromPromise((0, $i2hR1.default)(baseUrl, filter.id)).mergeMap(()=>{
            (0, $iOraS.getOnFilterDeleted)(state)(filter);
            (0, $3HwlS.getWillShowNav4)() && onComplete?.();
            return (0, $kVLXA.Observable).of((0, $jemkP.filterDeleted)());
        }).catch((error)=>{
            (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, 'directories.filters-v2.delete-modal.ops.delete-filter', (0, $c6c682f59adc6c63$export$9c2a9d62bcf944f8));
            (0, $iOraS.getOnFilterDeleteFailed)(state)(filter);
            return (0, $kVLXA.Observable).of((0, $jemkP.deleteFilterFailed)());
        });
    });

});
parcelRegister("fsh9d", function(module, exports) {

$parcel$export(module.exports, "logSafeErrorWithoutCustomerData", () => $064efdbf2b7e743c$export$c77be5886e7f1d9e);

var $dJl1T = parcelRequire("dJl1T");
const $064efdbf2b7e743c$export$b94ad046ae639a1c = (error, location, suffix, message)=>(0, $dJl1T.default).safeErrorWithoutCustomerData(location, message || error.message, error);
const $064efdbf2b7e743c$export$c77be5886e7f1d9e = (error, location, suffix, message)=>(0, $dJl1T.default).safeErrorWithoutCustomerData(location, message || error.message, error);

});

const $c6c682f59adc6c63$export$9c2a9d62bcf944f8 = 'directories.filters.error';

parcelRegister("i2hR1", function(module, exports) {

$parcel$export(module.exports, "default", () => $f063f6444575f430$export$2e2bcd8739ae039);

var $lNsNP = parcelRequire("lNsNP");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f063f6444575f430$export$2e2bcd8739ae039 = (baseUrl, filterId)=>(0, $lNsNP.default)(baseUrl, filterId);

});
parcelRegister("lNsNP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3cc82205e32ffce$export$2e2bcd8739ae039);

var $eusud = parcelRequire("eusud");
const $d3cc82205e32ffce$export$7138c24907de3954 = (baseUrl, filterId)=>`/rest/api/3/filter/${filterId}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d3cc82205e32ffce$export$2e2bcd8739ae039 = (baseUrl, filterId)=>(0, $eusud.performDeleteRequest)($d3cc82205e32ffce$export$7138c24907de3954(baseUrl, filterId));

});


parcelRegister("jemkP", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $62c4330949a1ef35$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $62c4330949a1ef35$export$cfda7627848a58cd);
$parcel$export(module.exports, "GET_ASSOCIATED_ITEMS", () => $62c4330949a1ef35$export$30d51c320095bdf2);
$parcel$export(module.exports, "getAssociatedItems", () => $62c4330949a1ef35$export$41e54fd4a1e5f9ba);
$parcel$export(module.exports, "ASSOCIATED_ITEMS_RETRIEVED", () => $62c4330949a1ef35$export$ba1e7147572f059);
$parcel$export(module.exports, "associatedItemsRetrieved", () => $62c4330949a1ef35$export$25e9475c64e5eda0);
$parcel$export(module.exports, "GET_ASSOCIATED_ITEMS_FAILED", () => $62c4330949a1ef35$export$4c7da338bde02996);
$parcel$export(module.exports, "getAssociatedItemsFailed", () => $62c4330949a1ef35$export$bc1efa3ceb08db7b);
$parcel$export(module.exports, "DELETE_FILTER", () => $62c4330949a1ef35$export$c90b00f6f11adca7);
$parcel$export(module.exports, "deleteFilter", () => $62c4330949a1ef35$export$d80cc0328fcc6685);
$parcel$export(module.exports, "DELETE_FILTER_FAILED", () => $62c4330949a1ef35$export$d3f2a09b0efe5b07);
$parcel$export(module.exports, "deleteFilterFailed", () => $62c4330949a1ef35$export$e303ddf5f6d63378);
$parcel$export(module.exports, "FILTER_DELETED", () => $62c4330949a1ef35$export$c8cf94be5a7baff9);
$parcel$export(module.exports, "filterDeleted", () => $62c4330949a1ef35$export$9411fafcb56b5a87);
const $62c4330949a1ef35$export$8aefe701a6f431e0 = 'state.SET_APP_PROPS';
const $62c4330949a1ef35$export$cfda7627848a58cd = (payload)=>({
        type: $62c4330949a1ef35$export$8aefe701a6f431e0,
        payload: payload
    });
const $62c4330949a1ef35$export$30d51c320095bdf2 = 'state.GET_ASSOCIATED_ITEMS';
const $62c4330949a1ef35$export$41e54fd4a1e5f9ba = ()=>({
        type: $62c4330949a1ef35$export$30d51c320095bdf2
    });
const $62c4330949a1ef35$export$ba1e7147572f059 = 'state.ASSOCIATED_ITEMS_RETRIEVED';
const $62c4330949a1ef35$export$25e9475c64e5eda0 = (payload)=>({
        type: $62c4330949a1ef35$export$ba1e7147572f059,
        payload: payload
    });
const $62c4330949a1ef35$export$4c7da338bde02996 = 'state.GET_ASSOCIATED_ITEMS_FAILED';
const $62c4330949a1ef35$export$bc1efa3ceb08db7b = ()=>({
        type: $62c4330949a1ef35$export$4c7da338bde02996
    });
const $62c4330949a1ef35$export$c90b00f6f11adca7 = 'state.DELETE_FILTER';
const $62c4330949a1ef35$export$d80cc0328fcc6685 = (onComplete)=>({
        type: $62c4330949a1ef35$export$c90b00f6f11adca7,
        onComplete: onComplete
    });
const $62c4330949a1ef35$export$d3f2a09b0efe5b07 = 'state.DELETE_FILTER_FAILED';
const $62c4330949a1ef35$export$e303ddf5f6d63378 = ()=>({
        type: $62c4330949a1ef35$export$d3f2a09b0efe5b07
    });
const $62c4330949a1ef35$export$c8cf94be5a7baff9 = 'state.FILTER_DELETED';
const $62c4330949a1ef35$export$9411fafcb56b5a87 = ()=>({
        type: $62c4330949a1ef35$export$c8cf94be5a7baff9
    });

});

parcelRegister("iOraS", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $317d9690ead12f9d$export$f654b28f82155665);
$parcel$export(module.exports, "getFilter", () => $317d9690ead12f9d$export$61ec8404f465cd36);
$parcel$export(module.exports, "getFilterName", () => $317d9690ead12f9d$export$b055b0a980ec5c8b);
$parcel$export(module.exports, "getOnInitialised", () => $317d9690ead12f9d$export$47263859bc15a8b8);
$parcel$export(module.exports, "getOnFilterDeleted", () => $317d9690ead12f9d$export$f5f4c932a633fd32);
$parcel$export(module.exports, "getOnFilterDeleteFailed", () => $317d9690ead12f9d$export$eb50a3cf06607a3c);
$parcel$export(module.exports, "getOnFilterInitiateFailed", () => $317d9690ead12f9d$export$9ef18d2a82ac120);
$parcel$export(module.exports, "getOnCancel", () => $317d9690ead12f9d$export$2c6267c00ffc9906);
$parcel$export(module.exports, "isDeleteInProgress", () => $317d9690ead12f9d$export$906c0d65e4ece39d);
$parcel$export(module.exports, "isDataRetrieved", () => $317d9690ead12f9d$export$a9211cdc0a6969f);
$parcel$export(module.exports, "getAssociatedBoards", () => $317d9690ead12f9d$export$2de9e9ee805a66);
$parcel$export(module.exports, "getAssociatedUsers", () => $317d9690ead12f9d$export$4004cc0feaedb1d1);
$parcel$export(module.exports, "getAssociatedGroups", () => $317d9690ead12f9d$export$4f21761c9913ab49);
$parcel$export(module.exports, "getCanDelete", () => $317d9690ead12f9d$export$e31d21defdc79bd5);
const $317d9690ead12f9d$export$f654b28f82155665 = (state)=>state.appProps.baseUrl;
const $317d9690ead12f9d$export$61ec8404f465cd36 = (state)=>state.appProps.filter;
const $317d9690ead12f9d$export$b055b0a980ec5c8b = (state)=>state.appProps.filter.name;
const $317d9690ead12f9d$export$47263859bc15a8b8 = (state)=>state.appProps.onInitialised;
const $317d9690ead12f9d$export$f5f4c932a633fd32 = (state)=>state.appProps.onFilterDeleted;
const $317d9690ead12f9d$export$eb50a3cf06607a3c = (state)=>state.appProps.onFilterDeleteFailed;
const $317d9690ead12f9d$export$9ef18d2a82ac120 = (state)=>state.appProps.onFilterInitiateFailed;
const $317d9690ead12f9d$export$2c6267c00ffc9906 = (state)=>state.appProps.onCancel;
const $317d9690ead12f9d$export$906c0d65e4ece39d = (state)=>state.isDeleteInProgress;
const $317d9690ead12f9d$export$a9211cdc0a6969f = (state)=>state.isDataRetrieved;
const $317d9690ead12f9d$export$2de9e9ee805a66 = (state)=>state.boards;
const $317d9690ead12f9d$export$4004cc0feaedb1d1 = (state)=>state.users;
const $317d9690ead12f9d$export$4f21761c9913ab49 = (state)=>state.groups;
const $317d9690ead12f9d$export$e31d21defdc79bd5 = (state)=>Array.isArray(state.boards) && state.boards.length === 0;

});


parcelRegister("b5iht", function(module, exports) {

$parcel$export(module.exports, "default", () => $b80972f9b3fefbb4$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("9IWoG");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $fsh9d = parcelRequire("fsh9d");


var $2idt2 = parcelRequire("2idt2");

var $7r08o = parcelRequire("7r08o");

var $jemkP = parcelRequire("jemkP");

var $iOraS = parcelRequire("iOraS");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b80972f9b3fefbb4$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $jemkP.GET_ASSOCIATED_ITEMS)).mergeMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $iOraS.getBaseUrl)(state);
        const filter = (0, $iOraS.getFilter)(state);
        return (0, $kVLXA.Observable).forkJoin((0, $kVLXA.Observable).fromPromise((0, $2idt2.default)(baseUrl, filter.id)), (0, $kVLXA.Observable).fromPromise((0, $7r08o.default)(baseUrl, filter.id))) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .map(([boards, subscriptions])=>{
            const { users: users, groups: groups } = subscriptions;
            (0, $iOraS.getOnInitialised)(state)();
            return (0, $jemkP.associatedItemsRetrieved)({
                boards: boards,
                users: users,
                groups: groups
            });
        }).catch((error)=>{
            (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, 'directories.filters-v2.delete-modal.ops.get-associated-items', (0, $c6c682f59adc6c63$export$9c2a9d62bcf944f8));
            (0, $iOraS.getOnFilterInitiateFailed)(state)(filter);
            return (0, $kVLXA.Observable).of((0, $jemkP.getAssociatedItemsFailed)());
        });
    });

});
parcelRegister("2idt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f9e6e4df190511d$export$2e2bcd8739ae039);

var $fDRaW = parcelRequire("fDRaW");

var $1rV38 = parcelRequire("1rV38");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5f9e6e4df190511d$export$2e2bcd8739ae039 = async (baseUrl, filterId)=>{
    const response = await (0, $fDRaW.default)(baseUrl, filterId);
    return (0, $1rV38.default)(response, baseUrl);
};

});
parcelRegister("fDRaW", function(module, exports) {

$parcel$export(module.exports, "default", () => $57ef3264d1641307$export$2e2bcd8739ae039);

var $7f4tk = parcelRequire("7f4tk");
const $57ef3264d1641307$export$7138c24907de3954 = (baseUrl, filterId)=>`/rest/agile/1.0/board/filter/${filterId}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$57ef3264d1641307$export$2e2bcd8739ae039 = (baseUrl, filterId)=>(0, $7f4tk.default)($57ef3264d1641307$export$7138c24907de3954(baseUrl, filterId));

});

parcelRegister("1rV38", function(module, exports) {

$parcel$export(module.exports, "default", () => $af931ea4cf63d8b4$export$2e2bcd8739ae039);
const $af931ea4cf63d8b4$export$b708cb7873d8352c = (baseUrl, id)=>`/secure/RapidBoard.jspa?rapidView=${id}&useStoredSettings=true`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$af931ea4cf63d8b4$export$2e2bcd8739ae039 = (response, baseUrl)=>{
    const boards = response && response.values || [];
    return boards.map((board)=>{
        const { name: name, id: id } = board;
        const href = $af931ea4cf63d8b4$export$b708cb7873d8352c(baseUrl, id);
        return {
            name: name,
            id: id,
            href: href
        };
    });
};

});


parcelRegister("7r08o", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddd004cba93b1adc$export$2e2bcd8739ae039);

var $eAHx9 = parcelRequire("eAHx9");

var $79DFK = parcelRequire("79DFK");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ddd004cba93b1adc$export$2e2bcd8739ae039 = async (baseUrl, filterId)=>{
    const response = await (0, $eAHx9.default)(baseUrl, filterId);
    return (0, $79DFK.default)(response, baseUrl);
};

});
parcelRegister("eAHx9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7443769520e58a35$export$2e2bcd8739ae039);

var $7f4tk = parcelRequire("7f4tk");
const $7443769520e58a35$export$7138c24907de3954 = (baseUrl, filterId)=>`/rest/api/3/filter/${filterId}?expand=subscriptions`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7443769520e58a35$export$2e2bcd8739ae039 = (baseUrl, filterId)=>(0, $7f4tk.default)($7443769520e58a35$export$7138c24907de3954(baseUrl, filterId));

});

parcelRegister("79DFK", function(module, exports) {

$parcel$export(module.exports, "default", () => $196e75ab8ca89e74$export$2e2bcd8739ae039);
const $196e75ab8ca89e74$export$d62b55bf0ad74ba2 = (baseUrl, id)=>`/jira/people/${id}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$196e75ab8ca89e74$export$2e2bcd8739ae039 = (response, baseUrl)=>{
    const subscriptions = response && response.subscriptions && response.subscriptions.items || [];
    const users = [];
    const groups = [];
    subscriptions.forEach((subscription)=>{
        const { user: user, group: group } = subscription;
        if (group) return groups.push({
            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'never'.
            name: group.name
        });
        // @ts-expect-error - TS2339 - Property 'accountId' does not exist on type 'never'.
        const href = $196e75ab8ca89e74$export$d62b55bf0ad74ba2(baseUrl, user.accountId);
        return user && users.push({
            // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'never'.
            displayName: user.displayName,
            href: href
        });
    });
    return {
        users: users,
        groups: groups
    };
};

});




parcelRegister("aDeVF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ce4dd7ecc996a54$export$2e2bcd8739ae039);

var $F2Mxm = parcelRequire("F2Mxm");

var $aXcJn = parcelRequire("aXcJn");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9ce4dd7ecc996a54$export$2e2bcd8739ae039 = (rootEpic)=>(0, $F2Mxm.default)({
        appName: 'directories/filters-v2/delete-modal',
        rootReducer: $aXcJn.default,
        rootEpic: rootEpic
    });

});
parcelRegister("aXcJn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3e77f8c76d4fb6d$export$2e2bcd8739ae039);

var $jemkP = parcelRequire("jemkP");
const $f3e77f8c76d4fb6d$export$49d5fc8cba920a0 = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    appProps: undefined,
    boards: [],
    users: [],
    groups: [],
    isDataRetrieved: false,
    isDeleteInProgress: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f3e77f8c76d4fb6d$export$2e2bcd8739ae039 = (state = $f3e77f8c76d4fb6d$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $jemkP.SET_APP_PROPS:
            return {
                ...state,
                appProps: action.payload
            };
        case 0, $jemkP.DELETE_FILTER:
            return {
                ...state,
                isDeleteInProgress: true
            };
        case 0, $jemkP.FILTER_DELETED:
        case 0, $jemkP.DELETE_FILTER_FAILED:
            return {
                ...state,
                isDeleteInProgress: false
            };
        case 0, $jemkP.ASSOCIATED_ITEMS_RETRIEVED:
            {
                const { boards: boards, users: users, groups: groups } = action.payload;
                return {
                    ...state,
                    isDataRetrieved: true,
                    ...boards ? {
                        boards: boards
                    } : undefined,
                    ...users ? {
                        users: users
                    } : undefined,
                    ...groups ? {
                        groups: groups
                    } : undefined
                };
            }
        case 0, $jemkP.GET_ASSOCIATED_ITEMS_FAILED:
        case 0, $jemkP.GET_ASSOCIATED_ITEMS:
            return state;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});


parcelRegister("9ekJG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffbff3d345f85465$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $iOraS = parcelRequire("iOraS");

var $5d0Op = parcelRequire("5d0Op");

var $6EW7m = parcelRequire("6EW7m");

var $7rRaV = parcelRequire("7rRaV");
const $ffbff3d345f85465$var$mapStateToProps = (state)=>({
        Content: $5d0Op.default,
        Footer: $6EW7m.default,
        name: (0, $iOraS.getFilterName)(state),
        onCancel: (0, $iOraS.getOnCancel)(state),
        isOpen: (0, $iOraS.isDataRetrieved)(state)
    });
var $ffbff3d345f85465$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($ffbff3d345f85465$var$mapStateToProps, {})((0, $7rRaV.default));

});
parcelRegister("5d0Op", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1dc72c582811a16$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $iOraS = parcelRequire("iOraS");

var $8SnWj = parcelRequire("8SnWj");
const $d1dc72c582811a16$var$mapStateToProps = (state)=>({
        filter: (0, $iOraS.getFilter)(state),
        boards: (0, $iOraS.getAssociatedBoards)(state),
        users: (0, $iOraS.getAssociatedUsers)(state),
        groups: (0, $iOraS.getAssociatedGroups)(state)
    });
var $d1dc72c582811a16$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($d1dc72c582811a16$var$mapStateToProps, {})((0, $8SnWj.default));

});
parcelRegister("8SnWj", function(module, exports) {

$parcel$export(module.exports, "default", () => $62e1c0ece3b30ec8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8zIDr = parcelRequire("8zIDr");

var $koVbs = parcelRequire("koVbs");

var $cRRmC = parcelRequire("cRRmC");
const $62e1c0ece3b30ec8$var$ContentWithoutBoardsAndSubscriptions = ({ formatMessage: formatMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).noSubscriptionsAndBoards));
const $62e1c0ece3b30ec8$var$ContentWithAssociatedSubscriptions = ({ formatMessage: formatMessage, groups: groups, users: users })=>users.length === 1 && groups.length === 0 || users.length === 0 && groups.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).singleSubscription), users.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zIDr.default), {
        href: users[0].href
    }, `${users[0].displayName}.`) : null, groups.length === 1 ? `${groups[0].name}.` : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).multipleBoardsWarning))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).multipleSubscriptions, {
        number: users.length + groups.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", null, users.map(({ displayName: displayName, href: href }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zIDr.default), {
            href: href
        }, displayName))), groups.map(({ name: name }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
            key: index
        }, name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).multipleSubscriptionsWarning)));
const $62e1c0ece3b30ec8$var$ContentWithAssociatedBoards = ({ boards: boards, formatMessage: formatMessage })=>boards.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).singleBoard), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zIDr.default), {
        href: boards[0].href
    }, `${boards[0].name}.`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).multipleBoardsWarning))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).multipleBoards, {
        number: boards.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", null, boards.map(({ name: name, href: href }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zIDr.default), {
            href: href
        }, name)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).multipleBoardsWarning)));
const $62e1c0ece3b30ec8$export$7c6e2c02157bb7d2 = ({ boards: boards, groups: groups, users: users })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (users.length === 0 && groups.length === 0 && boards.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($62e1c0ece3b30ec8$var$ContentWithoutBoardsAndSubscriptions, {
        formatMessage: formatMessage
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $cRRmC.default).associatedItems)), boards.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($62e1c0ece3b30ec8$var$ContentWithAssociatedBoards, {
        boards: boards,
        formatMessage: formatMessage
    }) : null, users.length > 0 || groups.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($62e1c0ece3b30ec8$var$ContentWithAssociatedSubscriptions, {
        users: users,
        groups: groups,
        formatMessage: formatMessage
    }) : null);
};
var $62e1c0ece3b30ec8$export$2e2bcd8739ae039 = $62e1c0ece3b30ec8$export$7c6e2c02157bb7d2;

});
parcelRegister("cRRmC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3531ea37b151c3e0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3531ea37b151c3e0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noSubscriptionsAndBoards: {
        "id": "directories.filters-v2.delete-modal.content.no-subscriptions-and-boards",
        "defaultMessage": "Are you sure you want to delete this filter?"
    },
    associatedItems: {
        "id": "directories.filters-v2.delete-modal.content.associated-items",
        "defaultMessage": "This filter is used elsewhere. Deleting it may impact other people's work."
    },
    multipleSubscriptions: {
        "id": "directories.filters-v2.delete-modal.content.multiple-subscriptions",
        "defaultMessage": "This filter has currently {number} subscriptions:"
    },
    singleSubscription: {
        "id": "directories.filters-v2.delete-modal.content.single-subscription",
        "defaultMessage": "This filter has a subscription for "
    },
    multipleSubscriptionsWarning: {
        "id": "directories.filters-v2.delete-modal.content.multiple-subscriptions-warning",
        "defaultMessage": "Deleting this filter will cause subscription emails for these users and groups to no longer be delivered."
    },
    multipleBoards: {
        "id": "directories.filters-v2.delete-modal.content.multiple-boards",
        "defaultMessage": "This filter is currently being used by {number} boards:"
    },
    singleBoard: {
        "id": "directories.filters-v2.delete-modal.content.single-board",
        "defaultMessage": "This filter is currently being used by "
    },
    multipleBoardsWarning: {
        "id": "directories.filters-v2.delete-modal.content.multiple-boards-warning",
        "defaultMessage": "You'll need to remove this filters associations to the boards before it can be removed."
    }
});

});



parcelRegister("6EW7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $310670aed312a399$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $iQv12 = parcelRequire("iQv12");

var $bC2fB = parcelRequire("bC2fB");

var $jemkP = parcelRequire("jemkP");

var $iOraS = parcelRequire("iOraS");

var $9pknF = parcelRequire("9pknF");
const $310670aed312a399$var$mapStateToProps = (state)=>({
        filter: (0, $iOraS.getFilter)(state),
        canDelete: (0, $iOraS.getCanDelete)(state),
        deleteInProgress: (0, $iOraS.isDeleteInProgress)(state),
        onCancel: (0, $iOraS.getOnCancel)(state)
    });
var $310670aed312a399$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onDelete: 'filterDeleted',
    onCancel: 'filterDeleteCanceled'
}), (0, $bC2fB.connect)($310670aed312a399$var$mapStateToProps, {
    onDelete: (0, $jemkP.deleteFilter)
}))((0, $9pknF.default));

});
parcelRegister("iQv12", function(module, exports) {

$parcel$export(module.exports, "default", () => $945500a9598c3ac2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gvRPW = parcelRequire("gvRPW");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $5uXOq.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;

});

parcelRegister("9pknF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8841fecfbc7d37be$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $cNW3X = parcelRequire("cNW3X");

var $jHTSg = parcelRequire("jHTSg");

var $7CjwE = parcelRequire("7CjwE");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $clxo5 = parcelRequire("clxo5");

var $az4zD = parcelRequire("az4zD");

var $3HwlS = parcelRequire("3HwlS");

var $7hmi2 = parcelRequire("7hmi2");

var $7kS0u = parcelRequire("7kS0u");
const $8841fecfbc7d37be$var$Footer = ({ intl: { formatMessage: formatMessage }, canDelete: canDelete, deleteInProgress: deleteInProgress, onCancel: onCancel, onDelete: onDelete })=>{
    const { publish: publish } = (0, $7hmi2.useDeleteChangeActions)();
    const onDeleteWithEvent = (event, analyticsEvent)=>{
        // additional args aside from event & analyticsEvent that you wish to pass down needs to be passed as the first argument
        onDelete(publish, event, analyticsEvent);
    };
    const onDeleteOld = (event, analyticsEvent)=>{
        onDelete(undefined, event, analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CjwE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8841fecfbc7d37be$var$Container, null, deleteInProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $8841fecfbc7d37be$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHTSg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "danger",
        type: "submit",
        isDisabled: !canDelete,
        onClick: (0, $3HwlS.getWillShowNav4)() ? onDeleteWithEvent : onDeleteOld
    }, formatMessage((0, $7kS0u.default).delete)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "subtle-link",
        isDisabled: deleteInProgress,
        onClick: onCancel
    }, formatMessage((0, $7kS0u.default).cancelButtonCaption)))));
};
$8841fecfbc7d37be$var$Footer.defaultProps = {
    onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    deleteInProgress: false,
    canDelete: true
};
var $8841fecfbc7d37be$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($8841fecfbc7d37be$var$Footer);
const $8841fecfbc7d37be$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $8841fecfbc7d37be$var$spinnerContainerStyles = (0, $2s57o.xcss)({
    marginRight: 'space.200'
});

});
parcelRegister("az4zD", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $90dc1bd887533804$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");

var $dY8Js = parcelRequire("dY8Js");

var $koVbs = parcelRequire("koVbs");
const $90dc1bd887533804$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $90dc1bd887533804$var$getDisplayName(Component) {
    if ($90dc1bd887533804$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($90dc1bd887533804$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $90dc1bd887533804$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $koVbs.default)();
        const intlRef = (0, $5uXOq.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$90dc1bd887533804$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(WithIntl, WrappedComponent);
};

});

parcelRegister("7kS0u", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc97edda63b98d49$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bc97edda63b98d49$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    delete: {
        "id": "directories.filters-v2.delete-modal.footer.delete",
        "defaultMessage": "Delete"
    },
    cancelButtonCaption: {
        "id": "directories.filters-v2.delete-modal.footer.cancel-button-caption",
        "defaultMessage": "Cancel"
    }
});

});



parcelRegister("7rRaV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3b1435469220d97$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $g1QfP = parcelRequire("g1QfP");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");
var $kW74I = parcelRequire("kW74I");

var $7NYq5 = parcelRequire("7NYq5");

var $hZHze = parcelRequire("hZHze");

var $9fuVs = parcelRequire("9fuVs");

var $az4zD = parcelRequire("az4zD");

var $cSD7y = parcelRequire("cSD7y");

var $1ppIJ = parcelRequire("1ppIJ");

var $liKYS = parcelRequire("liKYS");
const $d3b1435469220d97$var$ModalDialog = (0, $cSD7y.componentWithFG)('jfp_a11y_fix_filter_actions_modal_focus', (0, $1ppIJ.ModalDialog), (0, $7NYq5.JiraModal));
const $d3b1435469220d97$var$DeleteModal = ({ intl: { formatMessage: formatMessage }, isOpen: isOpen, Content: Content, Footer: Footer, onCancel: onCancel, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kW74I.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d3b1435469220d97$var$ModalDialog, {
        messageId: "delete-filters-modal.modal-dialog",
        messageType: "transactional",
        width: "small",
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUaFh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Sb4G.default), {
        appearance: "danger"
    }, formatMessage((0, $liKYS.default).title, {
        name: name
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1QfP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Content, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Footer, {
        onClose: onCancel
    }))));
var $d3b1435469220d97$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($d3b1435469220d97$var$DeleteModal);

});
parcelRegister("hZHze", function(module, exports) {

$parcel$export(module.exports, "default", () => $69dc4a27be9f367e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $asiGE = parcelRequire("asiGE");
var $3TR0I = parcelRequire("3TR0I");

var $gvRPW = parcelRequire("gvRPW");
// eslint-disable-next-line jira/react/no-class-components
class $69dc4a27be9f367e$var$ViewTracker extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $69dc4a27be9f367e$var$ViewTrackerWithAnalytics = (0, $asiGE.default)({
    componentName: 'view-tracker'
})((0, $3TR0I.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $gvRPW.PAGE_EVENT_ACTION)
        }).fire()
})($69dc4a27be9f367e$var$ViewTracker));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$69dc4a27be9f367e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($69dc4a27be9f367e$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    });

});

parcelRegister("1ppIJ", function(module, exports) {

$parcel$export(module.exports, "ModalDialog", () => $8fbdebf88f199b98$export$1fa217be60c2f188);

var $5uXOq = parcelRequire("5uXOq");

var $7NYq5 = parcelRequire("7NYq5");

var $lu5k0 = parcelRequire("lu5k0");
const $8fbdebf88f199b98$export$1fa217be60c2f188 = ({ shouldReturnFocus: shouldReturnFocus, ...rest })=>{
    const returnFocusTarget = (0, $lu5k0.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    (0, $5uXOq.useEffect)(()=>()=>{
            if (returnFocusTarget?.current) {
                !shouldReturnFocus && returnFocusTarget.current.focus();
                setReturnFocusTo(null);
            }
        }, [
        returnFocusTarget,
        setReturnFocusTo,
        shouldReturnFocus
    ]);
    /**
	 *  when shouldReturnFocus is defined,
	 * 	we won't handle passing focus back to this element
	 *	we will ignore the returnFocusTarget
	 */ const returnFocus = shouldReturnFocus ?? !returnFocusTarget;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        shouldReturnFocus: returnFocus,
        ...rest,
        messageId: rest.messageId ?? 'software.modal-dialog.ui.ak-modal-dialog',
        messageType: rest.messageType ?? 'transactional'
    });
};

});
parcelRegister("lu5k0", function(module, exports) {

$parcel$export(module.exports, "useModalDialogActions", () => $5f429bdcb9dbbc95$export$3cf2e4b6d3541465);
$parcel$export(module.exports, "useReturnFocusTo", () => $5f429bdcb9dbbc95$export$217308a4ece853b2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $49R2H = parcelRequire("49R2H");

var $a3Qjd = parcelRequire("a3Qjd");

var $kIxMH = parcelRequire("kIxMH");
const $5f429bdcb9dbbc95$var$Store = (0, $iXqE5.createStore)({
    name: 'JiraSoftwareModalDialog',
    initialState: $49R2H.initialState,
    actions: $a3Qjd.actions
});
const $5f429bdcb9dbbc95$export$3cf2e4b6d3541465 = (0, $3sQ5x.createActionsHook)($5f429bdcb9dbbc95$var$Store);
const $5f429bdcb9dbbc95$export$217308a4ece853b2 = (0, $3sQ5x.createStateHook)($5f429bdcb9dbbc95$var$Store, {
    selector: (0, $kIxMH.getReturnFocusTo)
});

});
parcelRegister("49R2H", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $1a3a816977643252$export$d4c72bab9d6cc13a);
const $1a3a816977643252$export$d4c72bab9d6cc13a = {
    returnFocusTo: null
};

});

parcelRegister("a3Qjd", function(module, exports) {

$parcel$export(module.exports, "actions", () => $1886bc9c17d47b9b$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $1886bc9c17d47b9b$export$b263d1e638b131c2 = (returnFocusTo)=>({ setState: setState })=>{
        setState({
            returnFocusTo: returnFocusTo
        });
    };
const $1886bc9c17d47b9b$export$e324594224ef24da = {
    setReturnFocusTo: $1886bc9c17d47b9b$export$b263d1e638b131c2
};

});

parcelRegister("kIxMH", function(module, exports) {

$parcel$export(module.exports, "getReturnFocusTo", () => $cd4eb273a1fc9e15$export$d5f8692765ccd209);
const $cd4eb273a1fc9e15$export$d5f8692765ccd209 = (state)=>state.returnFocusTo;

});



parcelRegister("liKYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $33404efbe1d974cc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $33404efbe1d974cc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "directories.filters-v2.delete-modal.title",
        "defaultMessage": "Delete {name}"
    }
});

});




parcelRegister("ddrvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d826b76ed7b00be0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d826b76ed7b00be0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filterDeletedModalTitleSuccessNonFinal: {
        "id": "navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-title-success-non-final",
        "defaultMessage": "{name} was deleted"
    },
    filterDeletedModalTitleErrorNonFinal: {
        "id": "navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-title-error-non-final",
        "defaultMessage": "We couldn't delete filter"
    },
    filterDeletedModalDescriptionErrorNonFinal: {
        "id": "navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-description-error-non-final",
        "defaultMessage": "There was an error, please try again."
    }
});

});


parcelRegister("199zy", function(module, exports) {

$parcel$export(module.exports, "default", () => $d773a1ee239d0f58$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d773a1ee239d0f58$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    manageSubscription: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.manage-subscription",
        "defaultMessage": "Manage subscriptions"
    },
    copyFilter: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter",
        "defaultMessage": "Copy filter"
    },
    copyFilterDialogTitle: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter-dialog-title",
        "defaultMessage": "Copy filter"
    },
    edit: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.edit",
        "defaultMessage": "Edit filter"
    },
    changeOwner: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.change-owner",
        "defaultMessage": "Change owner"
    },
    delete: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.delete",
        "defaultMessage": "Delete filter"
    },
    manageSubscriptionWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.manage-subscription-with-name",
        "defaultMessage": "Manage subscriptions for {name}"
    },
    copyFilterWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.copy-filter-with-name",
        "defaultMessage": "Copy filter {name}"
    },
    editWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.edit-with-name",
        "defaultMessage": "Edit filter {name}"
    },
    changeOwnerWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.change-owner-with-name",
        "defaultMessage": "Change owner for {name}"
    },
    deleteWithName: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.filter-actions.delete-with-name",
        "defaultMessage": "Delete filter {name}"
    }
});

});

parcelRegister("eKG0o", function(module, exports) {

$parcel$export(module.exports, "useModalState", () => $d7462e2c0d74d90a$export$baa48889c42cc6cb);

var $5uXOq = parcelRequire("5uXOq");
const $d7462e2c0d74d90a$export$baa48889c42cc6cb = (defaultOpen = false)=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultOpen);
    const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const onOpen = (0, $5uXOq.useCallback)(()=>setIsOpen(true), [
        setIsOpen
    ]);
    return {
        isOpen: isOpen,
        onClose: onClose,
        onOpen: onOpen
    };
};

});


parcelRegister("MaZbq", function(module, exports) {

$parcel$export(module.exports, "SimpleFilterMenuItem", () => $43f8c4d99214e245$export$608d42ceb4060968);

var $5uXOq = parcelRequire("5uXOq");

var $2tGrM = parcelRequire("2tGrM");

var $4zlUA = parcelRequire("4zlUA");

var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");
function $43f8c4d99214e245$export$608d42ceb4060968({ actionsOnHover: actionsOnHover, filterId: filterId, name: name, onClick: onClick }) {
    const handlOnClick = (0, $5uXOq.useCallback)((e)=>{
        onClick?.();
        (0, $4zlUA.handleGinSPAClick)(e);
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        actionsOnHover: actionsOnHover,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2tGrM))), {
            label: "",
            color: "currentColor"
        }),
        href: `/issues/?filter=${filterId}`,
        menuId: (0, $jhS4y.ENTITY_ID).FILTER(filterId),
        onClick: handlOnClick
    }, name);
}

});
parcelRegister("4zlUA", function(module, exports) {

$parcel$export(module.exports, "handleGinSPAClick", () => $7b30a009e09f47e3$export$f74673b086629362);
const $7b30a009e09f47e3$export$f74673b086629362 = (e)=>{
    const href = // @ts-expect-error - TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & HTMLAnchorElement)'. | TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & HTMLAnchorElement)'.
    typeof e.currentTarget.href === 'string' ? e.currentTarget.href : undefined;
    const openInNewTab = // @ts-expect-error - TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<EventTarget, MouseEvent> | KeyboardEvent<...>'. | TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<EventTarget, MouseEvent> | KeyboardEvent<...>'.
    e.metaKey || e.altKey || e.ctrlKey || e.shiftKey || e.button != null && e.button === 1;
    if (href == null || href === '' || e.defaultPrevented || openInNewTab) return;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.JIRA?.Issues?.Application) {
        e.preventDefault();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.JIRA.Issues.Application.execute('navigation:navigateToUrl', href, {
            forceRefresh: true,
            checkPermission: true,
            replace: false,
            reset: true,
            routerEvent: true
        });
    }
};

});



parcelRegister("jjTbl", function(module, exports) {

$parcel$export(module.exports, "default", () => $0092439b070ce89c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0092439b070ce89c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.starred",
        "defaultMessage": "Starred"
    },
    viewAllStarred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.view-all-starred",
        "defaultMessage": "View all starred items"
    },
    defaultFilters: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.content.default-filters",
        "defaultMessage": "Default filters"
    }
});

});


const $095930ee3b140077$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Filters';
const $095930ee3b140077$export$d57b6b390e78d90f = 'empanada';

parcelRegister("eYeHi", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $36b3581ba956a97e$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");




var $jhS4y = parcelRequire("jhS4y");

var $34PKs = parcelRequire("34PKs");

var $b6S3k = parcelRequire("b6S3k");

var $4IIGx = parcelRequire("4IIGx");
var $4vWwj = parcelRequire("4vWwj");
var $ch7sx = parcelRequire("ch7sx");

var $qBWno = parcelRequire("qBWno");

var $8sLEz = parcelRequire("8sLEz");
const $36b3581ba956a97e$var$VIEW_ALL_FILTERS_PATH = (0, $b6S3k.filtersDirectoryRoute).path;
function $36b3581ba956a97e$export$a06f1c675e846f6f() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const sendFilterAnalytics = (0, $qBWno.useFilterActionsAnalytics)();
    const sendDefaultFilterDropdownAnalytics = (0, $5uXOq.useCallback)(()=>{
        sendFilterAnalytics((0, $ce8062101363feb9$export$6dd9406e478a1fe2), {
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
            itemId: 'viewAllFilters'
        });
    }, [
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4vWwj.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ch7sx.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34PKs.ViewAllEntityMenuItem), {
        onClick: sendDefaultFilterDropdownAnalytics,
        href: $36b3581ba956a97e$var$VIEW_ALL_FILTERS_PATH,
        menuId: (0, $jhS4y.MENU_ID_FILTERS_VIEW_ALL)
    }, formatMessage((0, $8sLEz.default).viewAllFilters)))));
}

});
parcelRegister("b6S3k", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRoute", () => $45a85df0dbaf23d9$export$6350f52c8b40042d);
const $45a85df0dbaf23d9$export$6350f52c8b40042d = {
    name: 'filters-directory',
    path: '/jira/filters'
};

});

parcelRegister("8sLEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6fd2ed1497d7321$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b6fd2ed1497d7321$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAllFilters: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.footer.view-all-filters",
        "defaultMessage": "View all filters"
    }
});

});


parcelRegister("3XHNc", function(module, exports) {

$parcel$export(module.exports, "Header", () => $7b1d5262779046c2$export$8b251419efc915eb);

var $5uXOq = parcelRequire("5uXOq");

var $aWy0H = parcelRequire("aWy0H");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");




var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $qBWno = parcelRequire("qBWno");

var $bqhl5 = parcelRequire("bqhl5");
const $7b1d5262779046c2$export$8b251419efc915eb = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const sendFilterAnalytics = (0, $qBWno.useFilterActionsAnalytics)();
    const handleOnClick = (0, $5uXOq.useCallback)((event)=>{
        sendFilterAnalytics((0, $ce8062101363feb9$export$6dd9406e478a1fe2), {
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
            itemId: 'searchAllIssues'
        });
        onClose?.(event);
    }, [
        onClose,
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        href: "/issues/?jql=created%20%3E%3D%20-30d%20order%20by%20created%20DESC",
        onClick: handleOnClick,
        menuId: (0, $jhS4y.MENU_ID_FILTERS_SEARCH),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWy0H))), {
            label: "",
            color: "currentColor"
        })
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $bqhl5.default).searchAllIssuesIssueTermRefresh : (0, $bqhl5.default).searchAllIssues));
};

});
parcelRegister("bqhl5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2997cabf9dd4d5cf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2997cabf9dd4d5cf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    searchAllIssues: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.header.search-all-issues",
        "defaultMessage": "Search issues"
    },
    searchAllIssuesIssueTermRefresh: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-filters.common.header.search-all-issues-issue-term-refresh",
        "defaultMessage": "Search work items"
    }
});

});



parcelRegister("iaOwN", function(module, exports) {

$parcel$export(module.exports, "ActionButtons", () => $0188d5ec8b84466a$export$88c65d2d98aab183);

var $5uXOq = parcelRequire("5uXOq");

var $aOrxC = parcelRequire("aOrxC");





var $46Cti = parcelRequire("46Cti");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $qBWno = parcelRequire("qBWno");
function $0188d5ec8b84466a$export$88c65d2d98aab183({ onClose: onClose }) {
    const sendFilterAnalytics = (0, $qBWno.useFilterActionsAnalytics)();
    const sendMeatballAnalytics = (0, $5uXOq.useCallback)(()=>{
        sendFilterAnalytics((0, $ce8062101363feb9$export$b887e88d8d0739f6), {
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
            itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
        });
    }, [
        sendFilterAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        onOpen: sendMeatballAnalytics,
        MenuItems: $0188d5ec8b84466a$var$MoreMenuItems,
        onClose: onClose
    });
}
function $0188d5ec8b84466a$var$MoreMenuItems(_) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
        menuId: (0, $46Cti.L1_MENU_ID).FILTERS,
        hasSeparator: false
    }));
}

});

parcelRegister("6jcf1", function(module, exports) {

$parcel$export(module.exports, "Nav4FiltersDefault", () => $58a856783fb255e5$export$c9a2a24425c3fa5e);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $aGONy = parcelRequire("aGONy");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $338xa = parcelRequire("338xa");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $4zcxJ = parcelRequire("4zcxJ");

var $koeKL = parcelRequire("koeKL");

var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");


var $eYeHi = parcelRequire("eYeHi");

var $3XHNc = parcelRequire("3XHNc");

var $bq9gb = parcelRequire("bq9gb");
function $58a856783fb255e5$export$c9a2a24425c3fa5e(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, simulateLoading: simulateLoading = false } = props;
    const cloudId = (0, $koeKL.useCloudId)();
    const currentURL = (0, $aGONy.useGetCurrentUrl)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            currentURL: currentURL
        }), [
        cloudId,
        currentURL
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $bq9gb.asyncFiltersContentViewQuery), entryPointParams);
    const triggerRef = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).FILTERS);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    const menuId = (0, $jhS4y.MENU_ID_FILTERS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) {
                entryPointActions.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $46Cti.L1_MENU_ID).FILTERS,
                    sectionItem: (0, $jecJ3.SECTION_ITEM_FILTERS)
                });
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-filters-default",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3XHNc.Header), null), simulateLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-filters-default",
        packageName: (0, $095930ee3b140077$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $095930ee3b140077$export$d57b6b390e78d90f),
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
        // Props for the root component.
        runtimeProps: entryPointParams
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYeHi.Footer), null)));
}

});
parcelRegister("bq9gb", function(module, exports) {

$parcel$export(module.exports, "asyncFiltersContentViewQuery", () => $54738359b90672c7$export$fae48e64221e5e6e);

var $h5aHz = parcelRequire("h5aHz");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $54738359b90672c7$export$fae48e64221e5e6e = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("7a8qB")).then(({ Nav4FiltersContentViewQuery: Nav4FiltersContentViewQuery })=>Nav4FiltersContentViewQuery), {
        moduleId: "efb9eb25",
        moduleName: "Nav4FiltersContentViewQuery"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                filters: {
                    parameters: $h5aHz.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("h5aHz", function(module, exports) {

$parcel$export(module.exports, "default", () => $e23e452905350c49$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b09b73015f6d4eda410be086a0ec06e>>
 * @relayHash c3bc46f986acdf13f968e5919fcd2d52
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c97505ceda772c1ff0a6ccf4c08e12237f9f7d57f5f99db7c9b61da8af86b7e
const $e23e452905350c49$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v7 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v5 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v10 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4FiltersContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4FiltersContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4FiltersContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouriteFilters",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "FILTER"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentFilters",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "FILTER"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ],
                                                    "type": "JiraCustomFilter"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v1 /*: any*/ 
                            ],
                            "concreteType": "JiraSystemFilterConnection",
                            "kind": "LinkedField",
                            "name": "systemFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSystemFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilter",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3c97505ceda772c1ff0a6ccf4c08e12237f9f7d57f5f99db7c9b61da8af86b7e",
            "metadata": {},
            "name": "Nav4FiltersContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e23e452905350c49$var$node.hash = "9218fd54b0172bf14bf1082dd5032107";
var $e23e452905350c49$export$2e2bcd8739ae039 = $e23e452905350c49$var$node;

});

parcelRegister("7a8qB", function(module, exports) {

let $5370013ce72ebc05$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5370013ce72ebc05$var$load("akgtj").then(()=>parcelRequire('7EWLy'));

});





parcelRegister("VyuC0", function(module, exports) {

$parcel$export(module.exports, "Nav4Operations", () => $7b6a2654543e51de$export$bc4d01c843cee95e);

var $e2y3Y = parcelRequire("e2y3Y");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $37Ssu = parcelRequire("37Ssu");

var $2CMcE = parcelRequire("2CMcE");
const $7b6a2654543e51de$export$bc4d01c843cee95e = ({ isExpanded: isExpanded, queryRef: queryRef })=>{
    const data = (0, $8Uumt.useFragment)((0, $e2y3Y.default), queryRef);
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    return isInitialSelectedPath((0, $jhS4y.MENU_ID_OPERATIONS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CMcE.OperationsMenuForLanding), {
        isExpanded: isExpanded,
        queryRef: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $37Ssu.OperationsMenuDefault), {
        isExpanded: isExpanded
    });
};

});
parcelRegister("e2y3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $8997765d9fbf503d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3902b07ebd67a0b3cbf092c1d6ea3a35>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8997765d9fbf503d$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isOperationsExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Operations",
    "selections": [
        {
            "condition": "isOperationsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "OperationsMenuForLanding"
                }
            ]
        }
    ],
    "type": "Query"
};
$8997765d9fbf503d$var$node.hash = "1d297012078c362907ac313c8068c25a";
var $8997765d9fbf503d$export$2e2bcd8739ae039 = $8997765d9fbf503d$var$node;

});

parcelRegister("37Ssu", function(module, exports) {

$parcel$export(module.exports, "OperationsMenuDefault", () => $82831b0d881f1209$export$ef19d9521d85a60a);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $338xa = parcelRequire("338xa");

var $4zcxJ = parcelRequire("4zcxJ");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $83AHd = parcelRequire("83AHd");

var $gzxPn = parcelRequire("gzxPn");

var $8BItO = parcelRequire("8BItO");
function $82831b0d881f1209$export$ef19d9521d85a60a(props) {
    const { isExpanded: isExpanded } = props;
    const cloudId = (0, $koeKL.useCloudId)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $83AHd.asyncAlertsContentViewQuery), entryPointParams);
    const triggerRef = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActions);
    const { state: { isPoppedOut: isPoppedOut }, setContent: setContent } = (0, $8BItO.useAlertsPopoutStore)();
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('operations_nav4_remaining_items_detachable_menu')) {
            if (isPoppedOut) setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                // Data stream, will subscribe to load updates.
                entryPointReferenceSubject: entryPointReferenceSubject,
                // Required props for error JSErrorBoundary.
                id: "operations-menu-default",
                packageName: "jiraNavigationAppsSidebarNav4Operations",
                // Optional props for error JSErrorBoundary.
                errorFallback: "flag",
                teamName: "platform-united",
                // Fallback for `Suspense`.
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
                // Props for the root component.
                runtimeProps: {
                    ...entryPointParams,
                    location: 'popOutPanel'
                }
            }));
            return ()=>{
                setContent(null);
            };
        }
    }, [
        entryPointParams,
        entryPointReferenceSubject,
        isPoppedOut,
        setContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzxPn.OperationsExpandableMenuItem), {
        isExpanded: props.isExpanded,
        onSystemToggle: (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        triggerRef: triggerRef,
        AlertsMenuItemContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            // Data stream, will subscribe to load updates.
            entryPointReferenceSubject: entryPointReferenceSubject,
            // Required props for error JSErrorBoundary.
            id: "operations-menu-default",
            packageName: "jiraNavigationAppsSidebarNav4Operations",
            // Optional props for error JSErrorBoundary.
            errorFallback: "flag",
            teamName: "platform-united",
            // Fallback for `Suspense`.
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
            // Props for the root component.
            runtimeProps: (0, $4R6GH.fg)('operations_nav4_remaining_items_detachable_menu') ? {
                ...entryPointParams,
                location: 'sidenav'
            } : entryPointParams
        })
    });
}

});
parcelRegister("83AHd", function(module, exports) {

$parcel$export(module.exports, "asyncAlertsContentViewQuery", () => $f6fac0db87404723$export$182f7de76119e38a);

var $8myYV = parcelRequire("8myYV");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $f6fac0db87404723$export$182f7de76119e38a = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("bm18D")).then(({ AlertsContentViewQuery: AlertsContentViewQuery })=>AlertsContentViewQuery), {
        moduleId: "4fcb17ab",
        moduleName: "AlertsContentViewQuery"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryRef: {
                    parameters: $8myYV.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("8myYV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ef6ab9035056fc1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d8f87fd6efcb3b2793833812a581fd4f>>
 * @relayHash 539d81342bcb3bdab170556f3882c1e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1354395b89d1b40a39f597c3f378eb87813ab2626873be265cad98b57286915d
const $4ef6ab9035056fc1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AlertsContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "AlertsMenuItemContentNew"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "AlertsMenuItemContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AlertsContentViewQuery",
            "selections": [
                {
                    "concreteType": "OpsgenieQuery",
                    "kind": "LinkedField",
                    "name": "opsgenie",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "OpsgenieSavedSearches",
                            "kind": "LinkedField",
                            "name": "savedSearches",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "OpsgenieSavedSearch",
                                    "kind": "LinkedField",
                                    "name": "sharedWithMe",
                                    "plural": true,
                                    "selections": v1 /*: any*/ 
                                },
                                {
                                    "concreteType": "OpsgenieSavedSearch",
                                    "kind": "LinkedField",
                                    "name": "createdByMe",
                                    "plural": true,
                                    "selections": v1 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1354395b89d1b40a39f597c3f378eb87813ab2626873be265cad98b57286915d",
            "metadata": {},
            "name": "AlertsContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4ef6ab9035056fc1$var$node.hash = "879968e67a244943ed377d7fb5da054d";
var $4ef6ab9035056fc1$export$2e2bcd8739ae039 = $4ef6ab9035056fc1$var$node;

});

parcelRegister("bm18D", function(module, exports) {

let $8442a1d5d99ae822$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8442a1d5d99ae822$var$load("6gpSK").then(()=>parcelRequire('7GeK2'));

});


parcelRegister("gzxPn", function(module, exports) {

$parcel$export(module.exports, "OperationsExpandableMenuItem", () => $13a888bc5715405b$export$a04d9e9cc5ec19d3);

var $5uXOq = parcelRequire("5uXOq");

var $aWFr5 = parcelRequire("aWFr5");

var $6cJvk = parcelRequire("6cJvk");

var $dNhsC = parcelRequire("dNhsC");

var $g3RTv = parcelRequire("g3RTv");

var $3RTQl = parcelRequire("3RTQl");




var $jecJ3 = parcelRequire("jecJ3");

var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $5FnJJ = parcelRequire("5FnJJ");

var $dQbFB = parcelRequire("dQbFB");

var $24a2m = parcelRequire("24a2m");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");

var $lODMY = parcelRequire("lODMY");

var $4R6GH = parcelRequire("4R6GH");

var $lUaB2 = parcelRequire("lUaB2");

var $fnZCh = parcelRequire("fnZCh");

var $9MLkJ = parcelRequire("9MLkJ");

var $7Qdrb = parcelRequire("7Qdrb");

var $7zFZv = parcelRequire("7zFZv");

var $87kQ4 = parcelRequire("87kQ4");

var $8BItO = parcelRequire("8BItO");
const $13a888bc5715405b$var$Nav4ExpandableMenuItemWithPressInteraction = ({ onExpansionToggle: onExpansionToggle, children: children, ...props })=>{
    const pressTracing = (0, $3RTQl.default)('operations-sidebar-alerts-pressed');
    const expansionToggleCallback = (0, $5uXOq.useCallback)((hasExpanded)=>{
        if (hasExpanded) {
            pressTracing();
            onExpansionToggle?.(hasExpanded);
        }
    }, [
        pressTracing,
        onExpansionToggle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        ...props,
        onExpansionToggle: expansionToggleCallback
    }, children);
};
function $13a888bc5715405b$export$a04d9e9cc5ec19d3(props) {
    const isAlertsRoute = (0, $lODMY.useIsActiveRoute)(new Set([
        (0, $lUaB2.eocGlobalAlertListRoute).name,
        (0, $fnZCh.eocTeamAlertDetailRoute).name
    ]));
    const { AlertsMenuItemContent: AlertsMenuItemContent, isExpanded: isExpanded, onExpansionToggle: onExpansionToggle, onSystemToggle: onSystemToggle, triggerRef: triggerRef } = props;
    const { hasReports: hasReports } = (0, $7Qdrb.useFeatures)();
    const { icon: alertsIcon, formattedMessage: alertsMessage } = (0, $24a2m.useFormattedMessageAndIcon)((0, $9MLkJ.default).alerts, (0, (/*@__PURE__*/$parcel$interopDefault($aWFr5))));
    const { icon: overviewIcon, formattedMessage: overviewMessage } = (0, $24a2m.useFormattedMessageAndIcon)((0, $7zFZv.default).overview, (0, (/*@__PURE__*/$parcel$interopDefault($6cJvk))));
    const { icon: oncallSchedulesIcon, formattedMessage: oncallSchedulesMessage } = (0, $24a2m.useFormattedMessageAndIcon)((0, $7zFZv.default).onCallSchedules, (0, (/*@__PURE__*/$parcel$interopDefault($g3RTv))));
    const { icon: reportsIcon, formattedMessage: reportsMessage } = (0, $24a2m.useFormattedMessageAndIcon)((0, $7zFZv.default).reports, (0, (/*@__PURE__*/$parcel$interopDefault($dNhsC))));
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).OPERATIONS);
    const { state: { isPoppedOut: isPoppedOut }, setIsPoppedOut: setIsPoppedOut } = (0, $8BItO.useAlertsPopoutStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const menuId = (0, $jhS4y.MENU_ID_OPERATIONS);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isAlertsRoute) setIsPoppedOut(false);
        return ()=>{
            setIsPoppedOut(false);
        };
    }, [
        isAlertsRoute,
        setIsPoppedOut
    ]);
    const alertsChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        actions: isAlertsRoute && (0, $4R6GH.fg)('operations_nav4_remaining_items_detachable_menu') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $87kQ4.PopoutToggleButton), null) : undefined,
        onClick: (_e, _a, { isExpanded: hasExpanded })=>{
            if (hasExpanded) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    itemId: 'alerts'
                }
            });
        },
        elemBefore: alertsIcon,
        testId: (0, $dQbFB.getTestId)((0, $jhS4y.MENU_ID_OPS_ALERTS))
    }, alertsMessage), (!isPoppedOut || !(0, $4R6GH.fg)('operations_nav4_remaining_items_detachable_menu')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, AlertsMenuItemContent));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).OPERATIONS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_OPERATIONS)
            });
            onExpansionToggle?.(hasExpanded);
        },
        onSystemToggle: onSystemToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $87kQ4.ActionButtons), null),
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        elemBefore: overviewIcon,
        href: "/jira/ops/overview",
        menuId: (0, $jhS4y.MENU_ID_OPS_OVERVIEW),
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    itemId: 'overview'
                }
            });
        }
    }, overviewMessage), (0, $4R6GH.fg)('press_interaction_for_operations_alert_menu') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13a888bc5715405b$var$Nav4ExpandableMenuItemWithPressInteraction, {
        menuId: (0, $jhS4y.MENU_ID_OPS_ALERTS)
    }, alertsChildren) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        menuId: (0, $jhS4y.MENU_ID_OPS_ALERTS)
    }, alertsChildren), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        elemBefore: oncallSchedulesIcon,
        href: "/jira/ops/who-is-on-call",
        menuId: (0, $jhS4y.MENU_ID_OPS_ON_CALL),
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    itemId: 'onCallSchedules'
                }
            });
        }
    }, oncallSchedulesMessage), hasReports && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        elemBefore: reportsIcon,
        href: "/jira/ops/reports",
        menuId: (0, $jhS4y.MENU_ID_OPS_REPORTS),
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    itemId: 'reports'
                }
            });
        }
    }, reportsMessage)));
}

});
parcelRegister("aWFr5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76f067d08aa7c324d1505318ade2e26f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f7f767408bdccc6$var$_react = $7f7f767408bdccc6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7f7f767408bdccc6$var$_baseNew = $7f7f767408bdccc6$var$_interopRequireDefault((parcelRequire("enEmH")));
function $7f7f767408bdccc6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Alert".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for alerts in JSM and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f7f767408bdccc6$var$AlertIcon = (props)=>/*#__PURE__*/ $7f7f767408bdccc6$var$_react.default.createElement($7f7f767408bdccc6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 0v3h-1.5V0zM2.123 1.063 4.172 3.11 3.11 4.17 1.063 2.124zm12.814 1.06L12.89 4.172 11.83 3.11l2.047-2.048zM4.195 5.875A1.5 1.5 0 0 1 5.69 4.5h4.62a1.5 1.5 0 0 1 1.495 1.375l.635 7.625H14V15H2v-1.5h1.56zm.87 7.625h5.87L10.31 6H5.69z" clip-rule="evenodd"/>`
    }, props));
$7f7f767408bdccc6$var$AlertIcon.displayName = 'AlertIcon';
var $7f7f767408bdccc6$var$_default = module.exports.default = $7f7f767408bdccc6$var$AlertIcon;

});

parcelRegister("g3RTv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b34e6857b52d4ec156a688609aa0810c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb16bb6971a454c5$var$_react = $bb16bb6971a454c5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bb16bb6971a454c5$var$_baseNew = $bb16bb6971a454c5$var$_interopRequireDefault((parcelRequire("enEmH")));
function $bb16bb6971a454c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Phone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: call us, phone number input.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb16bb6971a454c5$var$PhoneIcon = (props)=>/*#__PURE__*/ $bb16bb6971a454c5$var$_react.default.createElement($bb16bb6971a454c5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h3.5a.75.75 0 0 1 .721.544l.821 2.874a1.75 1.75 0 0 1-.562 1.825L4.29 7.86c.975 1.55 2.3 2.875 3.85 3.85l1.617-1.94a1.75 1.75 0 0 1 1.825-.562l2.874.82a.75.75 0 0 1 .544.722v3.5a.75.75 0 0 1-.75.75c-2.266 0-4.422-.61-6.309-1.664a13.77 13.77 0 0 1-5.277-5.277A12.9 12.9 0 0 1 1 1.75m8.484 10.69c1.25.578 2.606.94 4.016 1.035v-2.16l-2.33-.665a.25.25 0 0 0-.26.08zM3.56 6.516 5.27 5.09a.25.25 0 0 0 .08-.261L4.684 2.5H2.525A11.4 11.4 0 0 0 3.56 6.516" clip-rule="evenodd"/>`
    }, props));
$bb16bb6971a454c5$var$PhoneIcon.displayName = 'PhoneIcon';
var $bb16bb6971a454c5$var$_default = module.exports.default = $bb16bb6971a454c5$var$PhoneIcon;

});

parcelRegister("lUaB2", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertListRoute", () => $ea0b3602049f5b80$export$29721341dde2ed3d);
const $ea0b3602049f5b80$export$29721341dde2ed3d = {
    name: 'eoc-global-alerts',
    path: '/jira/ops/alerts',
    exact: true
};

});

parcelRegister("fnZCh", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertDetailRoute", () => $6dfda5a4ad42a793$export$ac102dc13a0f4aff);
const $6dfda5a4ad42a793$export$ac102dc13a0f4aff = {
    name: 'eoc-team-alert-detail',
    path: '/jira/ops/teams/:teamId/alerts/:id',
    exact: true
};

});

parcelRegister("9MLkJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0593e321a36ff6ce$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0593e321a36ff6ce$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    alerts: {
        "id": "navigation-apps-sidebar-nav4-operations.alerts",
        "defaultMessage": "Alerts"
    }
});

});

parcelRegister("7Qdrb", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $9e533ca5776ffda5$export$4a39035bacc4ed76);

var $8J6rn = parcelRequire("8J6rn");

var $4PFfc = parcelRequire("4PFfc");


var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $hqBSi = parcelRequire("hqBSi");
const $9e533ca5776ffda5$export$4a39035bacc4ed76 = ()=>{
    const { isByokCustomer: isByokCustomer } = (0, $4PFfc.useByokComplianceSettingWithInitialisation)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const { shouldUseJSM: shouldUseJSM, loading: ogTenantInfoLoading } = (0, $8J6rn.useOgTenantInfo)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const hasReports = !ogTenantInfoLoading && (isSiteAdmin || isAdmin) && !isByokCustomer && shouldUseJSM && !!licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && appEditions.serviceDesk !== (0, $ldyPw.FREE_EDITION);
    return {
        hasReports: hasReports
    };
};

});
parcelRegister("8J6rn", function(module, exports) {

$parcel$export(module.exports, "useOgTenantInfo", () => $31f27587daf0b28f$export$990ea9ff15ca04f7);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $bHhiy = parcelRequire("bHhiy");

var $daoB1 = parcelRequire("daoB1");

var $2YP9W = parcelRequire("2YP9W");

var $3H5ry = parcelRequire("3H5ry");
/**
 * This hook is used to refresh the tenant info resource when the server side
 * rendering fails due to an error or never actually happens.
 */ const $31f27587daf0b28f$var$useConsolidationStateResourceRefresh = (tenantInfoResource)=>{
    // It is important that this ff should stop any new behaviour except for
    // safe hook calls. That's why we only do very minimal stuff here.
    const { data: data, loading: loading, refresh: refresh } = tenantInfoResource;
    const isRefreshed = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('refresh_tenant_info_on_client_for_ssr_error') && data === null && loading === false && isRefreshed.current === false) {
            refresh();
            isRefreshed.current = true;
        }
    }, [
        data,
        loading,
        refresh
    ]);
};
const $31f27587daf0b28f$export$990ea9ff15ca04f7 = ()=>{
    const tenantInfoResource = (0, $2YP9W.useResource)((0, $bHhiy.getConsolidationStateResource)());
    const applicationPermissions = (0, $daoB1.useApplicationPermissions)();
    $31f27587daf0b28f$var$useConsolidationStateResourceRefresh(tenantInfoResource);
    if (// TODO: Remove this check after the feature flag is removed
    // The refresh is handled in useConsolidationStateResourceRefresh
    // and this one is only for the old behaviour.
    !(0, $4R6GH.fg)('refresh_tenant_info_on_client_for_ssr_error') && tenantInfoResource.data === null && tenantInfoResource.loading === false && tenantInfoResource.error === null) tenantInfoResource.refresh();
    return {
        loading: tenantInfoResource.loading,
        error: tenantInfoResource.error,
        shouldUseJSM: (0, $3H5ry.checkShouldUseJSM)(tenantInfoResource.data),
        isConsolidated: (0, $3H5ry.checkIsConsolidated)(tenantInfoResource.data),
        isOpsAdmin: (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') && (0, $3H5ry.checkIsOpsAdmin)(tenantInfoResource.data),
        isTransitioning: (0, $3H5ry.checkIsTransitioning)(tenantInfoResource.data),
        isTransitioned: (0, $3H5ry.checkIsTransitioned)(tenantInfoResource.data),
        isTransitionEligible: applicationPermissions.hasServiceDeskAccess && (0, $3H5ry.checkIsTransitionEligible)(tenantInfoResource.data),
        shouldAccessUnlockOperations: applicationPermissions.hasServiceDeskAccess && (0, $3H5ry.checkShouldAccessUnlockOperations)(tenantInfoResource.data),
        cohort: typeof tenantInfoResource.data === 'string' ? undefined : tenantInfoResource.data?.cohortInfo
    };
};

});
parcelRegister("daoB1", function(module, exports) {

$parcel$export(module.exports, "ApplicationPermissionsSubscriber", () => $77add4b5420e5058$export$d8c76f7e52d0a856);
$parcel$export(module.exports, "useApplicationPermissions", () => $77add4b5420e5058$export$4d9cadb4042acc1b);

var $dGvGJ = parcelRequire("dGvGJ");

var $51nlc = parcelRequire("51nlc");

var $2gywT = parcelRequire("2gywT");

var $9OXo1 = parcelRequire("9OXo1");
const $77add4b5420e5058$var$selector = (0, $dGvGJ.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
        data: {
            applicationPermissions: applicationPermissions
        }
    }));
const $77add4b5420e5058$export$d8c76f7e52d0a856 = (0, $51nlc.createSubscriber)((0, $2gywT.default), {
    displayName: 'ApplicationPermissionsSubscriber',
    selector: $77add4b5420e5058$var$selector
});
const $77add4b5420e5058$export$4d9cadb4042acc1b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.appPermissions;
};

});


parcelRegister("4PFfc", function(module, exports) {

$parcel$export(module.exports, "useByokComplianceSettingWithInitialisation", () => $4598a5eb88f036a1$export$fb68f4844474e7cb);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $9OXo1 = parcelRequire("9OXo1");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");

var $6rXpq = parcelRequire("6rXpq");
const $4598a5eb88f036a1$export$f907f15fb3e7d5a9 = (0, $7HGHK.toFlagId)('byok-settings-enabled-success-flag-key');
const $4598a5eb88f036a1$var$LEARN_MORE_ABOUT_BYOK_COMPLIANCE_SETTING_LINK = 'https://support.atlassian.com/security-and-access-policies/docs/data-managed-with-byok-encryption/24h';
const $4598a5eb88f036a1$var$actions = {
    fetchByokComplianceSetting: (cloudId)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.loading === true) return;
            setState({
                ...state,
                loading: true
            });
            try {
                const { data: data } = await (0, $eusud.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/byok-setting`);
                setState({
                    ...state,
                    data: data,
                    loading: false,
                    error: undefined
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...state,
                    loading: false,
                    error: error
                });
            }
        },
    updateByokComplianceSetting: (option, cloudId)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.loading === true) return;
            const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
            setState({
                ...state,
                loading: true
            });
            try {
                await (0, $eusud.performPatchRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/byok-setting`, {
                    body: JSON.stringify({
                        ugcPrimaryLogEnabledForByok: option
                    })
                });
                if (option) showFlag({
                    id: $4598a5eb88f036a1$export$f907f15fb3e7d5a9,
                    title: (0, $6rXpq.default).byokComplianceSettingEnabledSuccessTitle,
                    type: 'success',
                    description: (0, $6rXpq.default).byokComplianceSettingEnabledSuccessDescription,
                    messageId: 'products-jsm-compliance-main.services.byok-compliance-setting.show-flag.success',
                    messageType: 'transactional',
                    actions: [
                        {
                            content: (0, $6rXpq.default).flagOk,
                            onClick: ()=>{
                                dismissFlag($4598a5eb88f036a1$export$f907f15fb3e7d5a9);
                            }
                        },
                        {
                            content: (0, $6rXpq.default).flagLearnMore,
                            href: $4598a5eb88f036a1$var$LEARN_MORE_ABOUT_BYOK_COMPLIANCE_SETTING_LINK,
                            target: '_blank'
                        }
                    ]
                });
                setState({
                    ...state,
                    data: {
                        byokCustomer: state.data?.byokCustomer ?? false,
                        ugcPrimaryLogEnabledForByok: option
                    },
                    loading: false,
                    error: undefined
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...state,
                    loading: false,
                    error: error
                });
            }
        }
};
const $4598a5eb88f036a1$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        data: null,
        loading: false,
        error: undefined
    },
    actions: $4598a5eb88f036a1$var$actions,
    name: 'BYOKComplianceSetting'
});
const $4598a5eb88f036a1$var$useByokComplianceSettingData = (0, $3sQ5x.createHook)($4598a5eb88f036a1$var$Store);
const $4598a5eb88f036a1$export$fb68f4844474e7cb = ()=>{
    const [ByokComplianceSettingState, { fetchByokComplianceSetting: fetchByokComplianceSetting, updateByokComplianceSetting: updateByokComplianceSetting }] = $4598a5eb88f036a1$var$useByokComplianceSettingData();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    (0, $5uXOq.useEffect)(()=>{
        if (!ByokComplianceSettingState.data && (0, $4R6GH.fg)('audit-logs-byok-encrypted-data')) fetchByokComplianceSetting(cloudId);
    }, [
        ByokComplianceSettingState.data,
        cloudId,
        fetchByokComplianceSetting
    ]);
    return {
        loading: ByokComplianceSettingState.loading,
        error: ByokComplianceSettingState.error,
        data: ByokComplianceSettingState.data,
        isByokComplianceSettingEnabled: ByokComplianceSettingState.data?.ugcPrimaryLogEnabledForByok ?? false,
        isByokCustomer: ByokComplianceSettingState.data?.byokCustomer ?? false,
        enableSetting: ()=>updateByokComplianceSetting(true, cloudId),
        disableSetting: ()=>updateByokComplianceSetting(false, cloudId)
    };
};

});
parcelRegister("6rXpq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a126756b74ac450$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5a126756b74ac450$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    byokComplianceSettingEnabledSuccessTitle: {
        "id": "products-jsm-compliance-main.services.byok-compliance-setting.byok-compliance-setting-enabled-success-title",
        "defaultMessage": "HIPAA-compliant alert notifications turned on"
    },
    byokComplianceSettingEnabledSuccessDescription: {
        "id": "products-jsm-compliance-main.services.byok-compliance-setting.byok-compliance-setting-enabled-success-description",
        "defaultMessage": "Let your team admins know about the recommended actions they can take."
    },
    flagOk: {
        "id": "products-jsm-compliance-main.services.byok-compliance-setting.flag-ok",
        "defaultMessage": "Ok"
    },
    flagLearnMore: {
        "id": "products-jsm-compliance-main.services.byok-compliance-setting.flag-learn-more",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("hqBSi", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $7564850c0894983d$export$54d534cc91e54850);

var $9OXo1 = parcelRequire("9OXo1");
const $7564850c0894983d$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});


parcelRegister("7zFZv", function(module, exports) {

$parcel$export(module.exports, "default", () => $adc2a9b3f9b765e0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $adc2a9b3f9b765e0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    overview: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.overview",
        "defaultMessage": "Overview"
    },
    alerts: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts",
        "defaultMessage": "Alerts"
    },
    onCallSchedules: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.on-call-schedules",
        "defaultMessage": "On-call schedules"
    },
    generalConfiguration: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.general-configuration",
        "defaultMessage": "General configuration"
    },
    reports: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.reports",
        "defaultMessage": "Reports"
    },
    defaultFilters: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.default-filters",
        "defaultMessage": "Default filters"
    },
    sharedWithMe: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.shared-with-me",
        "defaultMessage": "Shared with me"
    },
    createdByMe: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.created-by-me",
        "defaultMessage": "Created by me"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.starred",
        "defaultMessage": "Starred"
    },
    allAlerts: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.all-alerts",
        "defaultMessage": "All alerts"
    },
    myAlerts: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.my-alerts",
        "defaultMessage": "My alerts"
    },
    viewAllFiltersPopupMenuButtonText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.view-all-filters-popup-menu-button-text",
        "defaultMessage": "View all"
    },
    viewAllFiltersSearchPlaceholder: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.view-all-filters-search-placeholder",
        "defaultMessage": "Search"
    },
    viewAllFiltersNoResultsFoundText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.view-all-filters-no-results-found-text",
        "defaultMessage": "No search results found"
    },
    allSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.all-search",
        "defaultMessage": "All"
    },
    openSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.open-search",
        "defaultMessage": "Open"
    },
    closedSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.closed-search",
        "defaultMessage": "Closed"
    },
    unackedSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.unacked-search",
        "defaultMessage": "Unacknowledged"
    },
    notSeenSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.not-seen-search",
        "defaultMessage": "Not seen"
    },
    assignedToMeSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.assigned-to-me-search",
        "defaultMessage": "Assigned to me"
    }
});

});

parcelRegister("87kQ4", function(module, exports) {

$parcel$export(module.exports, "ActionButtons", () => $cfb53a200327fce3$export$88c65d2d98aab183);
$parcel$export(module.exports, "PopoutToggleButton", () => $cfb53a200327fce3$export$a9edf85e3b30c33a);

var $5uXOq = parcelRequire("5uXOq");

var $51oeD = parcelRequire("51oeD");

var $44qT7 = parcelRequire("44qT7");
var $70rf1 = parcelRequire("70rf1");

var $5KCCi = parcelRequire("5KCCi");

var $1Seuh = parcelRequire("1Seuh");

var $8J6rn = parcelRequire("8J6rn");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");





var $jecJ3 = parcelRequire("jecJ3");

var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $9eeFp = parcelRequire("9eeFp");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");


var $9OXo1 = parcelRequire("9OXo1");

var $gmjIb = parcelRequire("gmjIb");

var $bLVOJ = parcelRequire("bLVOJ");

var $8BItO = parcelRequire("8BItO");
function $cfb53a200327fce3$export$88c65d2d98aab183({ onClose: onClose }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        onOpen: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
                }
            });
        },
        MenuItems: $cfb53a200327fce3$var$MoreMenuItems,
        onClose: onClose
    });
}
function $cfb53a200327fce3$var$MoreMenuItems({ onClose: onClose }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onCloseWithStopPropagation = (0, $9eeFp.useStopPropagation)((event)=>{
        onClose?.(event);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367),
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
            attributes: {
                componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                itemId: 'generalConfiguration',
                parentItemId: (0, $jecJ3.SECTION_ITEM_OPERATIONS)
            }
        });
    });
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { isOpsAdmin: isOpsAdmin } = (0, $8J6rn.useOgTenantInfo)();
    const shouldShowGeneralConfiguration = (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? (tenantContext.isAdmin || isOpsAdmin) && tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] : tenantContext.isAdmin && tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldShowGeneralConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44qT7.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($51oeD))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: "/jira/settings/products/ops/jira-service-management-audit-logs",
        onClick: onCloseWithStopPropagation
    }, formatMessage((0, $bLVOJ.default).generalConfiguration))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
        menuId: (0, $46Cti.L1_MENU_ID).OPERATIONS,
        hasSeparator: shouldShowGeneralConfiguration
    }));
}
const $cfb53a200327fce3$export$a9edf85e3b30c33a = ({ onClick: onClick })=>{
    const { state: { isPoppedOut: isPoppedOut }, setIsPoppedOut: setIsPoppedOut } = (0, $8BItO.useAlertsPopoutStore)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleToggle = (_, analyticsEvent)=>{
        onClick?.();
        setIsPoppedOut(!isPoppedOut);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'jsmOperationsAlertsPopoutButtonToggle', {
            isPoppedOut: !isPoppedOut
        });
    };
    const iconButtonLabel = isPoppedOut ? formatMessage((0, $bLVOJ.default).popInLabel) : formatMessage((0, $bLVOJ.default).popOutLabel);
    const tooltipContent = isPoppedOut ? formatMessage((0, $bLVOJ.default).popInTooltip) : formatMessage((0, $bLVOJ.default).popOutTooltip);
    const Icon = isPoppedOut ? (0, $gmjIb.PopinIcon) : (0, $gmjIb.PopoutIcon);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: tooltipContent
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
            ...tooltipProps,
            label: iconButtonLabel,
            onClick: handleToggle,
            icon: Icon,
            spacing: "compact",
            appearance: "subtle"
        }));
};

});
parcelRegister("gmjIb", function(module, exports) {

$parcel$export(module.exports, "PopoutIcon", () => $33c760ffcaee3f88$export$a837275bb5fcc92e);
$parcel$export(module.exports, "PopinIcon", () => $33c760ffcaee3f88$export$5b106f296c88ef0);

var $5uXOq = parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");

var $koVbs = parcelRequire("koVbs");

var $1Rqx4 = parcelRequire("1Rqx4");
const $33c760ffcaee3f88$var$PoputGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 4L19.25 4C19.4489 4 19.6397 4.07902 19.7803 4.21967C19.921 4.36032 20 4.55109 20 4.75V9H18.5V6.56066L15.0303 10.0303L13.9697 8.96967L17.4393 5.5L15 5.5V4ZM7 7.5C6.72386 7.5 6.5 7.72386 6.5 8L6.5 10.5H11.5C12.6046 10.5 13.5 11.3954 13.5 12.5L13.5 17.5H16C16.2761 17.5 16.5 17.2761 16.5 17V12H18V17C18 18.1046 17.1046 19 16 19H12.7512C12.7508 19 12.7504 19 12.75 19L7 19C5.89543 19 5 18.1046 5 17L5 11.25C5 11.2498 5 11.2497 5 11.2495L5 8C5 6.89543 5.89543 6 7 6L12 6V7.5L7 7.5ZM7 17.5L12 17.5L12 12.5C12 12.2239 11.7761 12 11.5 12H6.5L6.5 17C6.5 17.2761 6.72386 17.5 7 17.5Z"
    }));
const $33c760ffcaee3f88$var$PopinGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 4L18 4C19.1046 4 20 4.89543 20 6V10C20 11.1046 19.1046 12 18 12H14C13.7229 12 13.4589 11.9436 13.2189 11.8417L11.0607 14H13.5V15.5H9.25C8.83579 15.5 8.5 15.1642 8.5 14.75L8.5 10.5H10L10 12.9393L12.1583 10.7811C12.0564 10.5411 12 10.2771 12 10V6C12 4.89543 12.8954 4 14 4ZM18 5.5L14 5.5C13.7239 5.5 13.5 5.72386 13.5 6V10C13.5 10.2761 13.7239 10.5 14 10.5H18C18.2761 10.5 18.5 10.2761 18.5 10V6C18.5 5.72386 18.2761 5.5 18 5.5ZM7 6L10 6V7.5H7C6.72386 7.5 6.5 7.72386 6.5 8L6.5 17C6.5 17.2761 6.72386 17.5 7 17.5L16 17.5C16.2761 17.5 16.5 17.2761 16.5 17V14H18V17C18 18.1046 17.1046 19 16 19L7 19C5.89543 19 5 18.1046 5 17L5 8C5 6.89543 5.89543 6 7 6Z"
    }));
const $33c760ffcaee3f88$export$a837275bb5fcc92e = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ltBcH.default), {
        glyph: $33c760ffcaee3f88$var$PoputGlyph,
        label: formatMessage((0, $1Rqx4.messages).popoutIconLabel)
    });
};
const $33c760ffcaee3f88$export$5b106f296c88ef0 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ltBcH.default), {
        glyph: $33c760ffcaee3f88$var$PopinGlyph,
        label: formatMessage((0, $1Rqx4.messages).popinIconLabel)
    });
};

});
parcelRegister("1Rqx4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9c37dc5930389b51$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9c37dc5930389b51$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    popoutIconLabel: {
        "id": "servicedesk-queues-nav4.common.popout-toggle-button.icons.popout-icon-label",
        "defaultMessage": "Pop out icon"
    },
    popinIconLabel: {
        "id": "servicedesk-queues-nav4.common.popout-toggle-button.icons.popin-icon-label",
        "defaultMessage": "Pop in icon"
    }
});

});


parcelRegister("bLVOJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $305b1dd418fc2a25$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $305b1dd418fc2a25$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    generalConfiguration: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.general-configuration",
        "defaultMessage": "General configuration"
    },
    popOutLabel: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-out-label",
        "defaultMessage": "Pop out operations alert searches"
    },
    popOutTooltip: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-out-tooltip",
        "defaultMessage": "Pop out from sidebar"
    },
    popInLabel: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-in-label",
        "defaultMessage": "Pop in operations alert searches"
    },
    popInTooltip: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.operations-expandable-menu-item.action-buttons.pop-in-tooltip",
        "defaultMessage": "Move back to sidebar"
    }
});

});

parcelRegister("8BItO", function(module, exports) {

$parcel$export(module.exports, "useAlertsPopoutStore", () => $57b94178b916bb11$export$f89494880a713101);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
// This is the value of the store on initialisation
const $57b94178b916bb11$var$initialState = {
    isPoppedOut: false,
    content: null
};
const $57b94178b916bb11$var$actions = {
    setIsPoppedOut: (value)=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isPoppedOut: value
            });
        },
    setContent: (content)=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                content: content
            });
        }
};
const $57b94178b916bb11$var$Store = (0, $iXqE5.createStore)({
    initialState: $57b94178b916bb11$var$initialState,
    actions: $57b94178b916bb11$var$actions,
    name: 'AlertsPopoutStore'
});
const $57b94178b916bb11$var$useHook = (0, $3sQ5x.createHook)($57b94178b916bb11$var$Store);
const $57b94178b916bb11$export$f89494880a713101 = ()=>{
    const [state, hookActions] = $57b94178b916bb11$var$useHook();
    return {
        state: state,
        ...hookActions
    };
};

});




parcelRegister("2CMcE", function(module, exports) {

$parcel$export(module.exports, "OperationsMenuForLanding", () => $4f2124831a167c55$export$b37dd5cf3b893940);

var $df0z5 = parcelRequire("df0z5");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $l8ruj = parcelRequire("l8ruj");

var $dGQgy = parcelRequire("dGQgy");

var $gzxPn = parcelRequire("gzxPn");

var $ePmXi = parcelRequire("ePmXi");

var $8BItO = parcelRequire("8BItO");
const $4f2124831a167c55$export$b37dd5cf3b893940 = ({ isExpanded: isExpanded, queryRef: queryRef })=>{
    const data = (0, $8Uumt.useFragment)((0, $df0z5.default), queryRef);
    const { state: { isPoppedOut: isPoppedOut }, setContent: setContent } = (0, $8BItO.useAlertsPopoutStore)();
    (0, $5uXOq.useEffect)(()=>{
        if (isPoppedOut) setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dGQgy.AlertsMenuItemContent), {
            queryRef: data
        }));
        return ()=>{
            setContent(null);
        };
    }, [
        data,
        isPoppedOut,
        setContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzxPn.OperationsExpandableMenuItem), {
        isExpanded: isExpanded,
        AlertsMenuItemContent: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: "nav4-sidebar-operations-landing"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePmXi.AlertsMenuItemContentNew), {
            queryRef: data
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dGQgy.AlertsMenuItemContent), {
            queryRef: data
        })
    });
};

});
parcelRegister("df0z5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a039eea1ea338a10$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4581c0468a5d4ef30519c5609a70ff06>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a039eea1ea338a10$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "OperationsMenuForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "AlertsMenuItemContentNew"
        },
        {
            "kind": "FragmentSpread",
            "name": "AlertsMenuItemContent"
        }
    ],
    "type": "Query"
};
$a039eea1ea338a10$var$node.hash = "539a9dffb7945e99bc6a650607eca8e4";
var $a039eea1ea338a10$export$2e2bcd8739ae039 = $a039eea1ea338a10$var$node;

});

parcelRegister("dGQgy", function(module, exports) {

$parcel$export(module.exports, "AlertsMenuItemContent", () => $ab6d77ca097b26bb$export$fcbb0679bb6c6da1);

var $k3zlg = parcelRequire("k3zlg");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $8N3cd = parcelRequire("8N3cd");

var $5zvRj = parcelRequire("5zvRj");

var $koVbs = parcelRequire("koVbs");




var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $lhMtU = parcelRequire("lhMtU");

var $c6x3L = parcelRequire("c6x3L");

var $c16H2 = parcelRequire("c16H2");

var $5FnJJ = parcelRequire("5FnJJ");

var $dQbFB = parcelRequire("dQbFB");

var $24a2m = parcelRequire("24a2m");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $90yGq = parcelRequire("90yGq");

var $l8ruj = parcelRequire("l8ruj");

var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");

var $ieDtd = parcelRequire("ieDtd");

var $9MLkJ = parcelRequire("9MLkJ");

var $7zFZv = parcelRequire("7zFZv");

var $gtYPY = parcelRequire("gtYPY");
function $ab6d77ca097b26bb$export$fcbb0679bb6c6da1({ queryRef: queryRef }) {
    const data = (0, $8Uumt.useFragment)((0, $k3zlg.default), queryRef);
    const [selectedFilter, setSelectedFilter] = (0, $5uXOq.useState)('');
    const { isSelectedPath: isSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const { sharedWithMe: sharedWithMe, createdByMe: createdByMe } = data.opsgenie.savedSearches;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const accountId = (0, $90yGq.useAccountId)();
    const [viewType] = (0, $ieDtd.useQueryParam)('view');
    const { icon: pagesIcon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $9MLkJ.default).alerts, (0, (/*@__PURE__*/$parcel$interopDefault($8N3cd))));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const defaultFilters = [
        {
            id: 'all',
            name: formatMessage((0, $7zFZv.default).allSearch),
            alertSearchQuery: ''
        },
        {
            id: 'open',
            name: formatMessage((0, $7zFZv.default).openSearch),
            alertSearchQuery: `${(0, $5zvRj.IDENTIFIER_STATUS)}${(0, $5zvRj.OPERATOR_EQUAL_TO)} ${(0, $5zvRj.STRING_LITERAL_STATUS_OPEN)}`
        },
        {
            id: 'closed',
            name: formatMessage((0, $7zFZv.default).closedSearch),
            alertSearchQuery: `${(0, $5zvRj.IDENTIFIER_STATUS)}${(0, $5zvRj.OPERATOR_EQUAL_TO)} ${(0, $5zvRj.STRING_LITERAL_STATUS_CLOSED)}`
        },
        {
            id: 'unacked',
            name: formatMessage((0, $7zFZv.default).unackedSearch),
            alertSearchQuery: `${(0, $5zvRj.IDENTIFIER_STATUS)}${(0, $5zvRj.OPERATOR_EQUAL_TO)} ${(0, $5zvRj.STRING_LITERAL_STATUS_OPEN)} ${(0, $5zvRj.LOGICAL_OPERATOR_AND)} ${(0, $5zvRj.IDENTIFIER_ACKNOWLEDGED)}${(0, $5zvRj.OPERATOR_EQUAL_TO)} ${(0, $5zvRj.BOOLEAN_LITERAL_FALSE)}`
        },
        {
            id: 'notSeen',
            name: formatMessage((0, $7zFZv.default).notSeenSearch),
            alertSearchQuery: `${(0, $5zvRj.IDENTIFIER_IS_SEEN)}${(0, $5zvRj.OPERATOR_EQUAL_TO)} ${(0, $5zvRj.BOOLEAN_LITERAL_FALSE)}`
        },
        {
            id: 'assignedToMe',
            name: formatMessage((0, $7zFZv.default).assignedToMeSearch),
            alertSearchQuery: `${(0, $5zvRj.IDENTIFIER_ASSIGNEE)}${(0, $5zvRj.OPERATOR_EQUAL_TO)} "${accountId || 'me'}"`
        }
    ];
    const defaultFilterMenuIds = $ab6d77ca097b26bb$var$getParentMenuId(defaultFilters);
    const sharedWithMeMenuIds = $ab6d77ca097b26bb$var$getParentMenuId(sharedWithMe);
    const createdByMeMenuIds = $ab6d77ca097b26bb$var$getParentMenuId(createdByMe);
    (0, $5uXOq.useEffect)(()=>{
        if (!isSelectedPath((0, $jhS4y.MENU_ID_OPS_ALERTS)) && selectedFilter !== '') setSelectedFilter('');
    }, [
        isSelectedPath,
        selectedFilter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4.sidebar.operations.alerts"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        menuId: defaultFilterMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                    itemId: 'defaultFilters',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        testId: (0, $dQbFB.getTestId)(defaultFilterMenuIds)
    }, formatMessage((0, $7zFZv.default).defaultFilters)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, defaultFilters.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
            elemBefore: pagesIcon,
            key: item.id,
            href: `/jira/ops/alerts?view=${viewType ?? 'list'}${item.alertSearchQuery ? `&query=${item.alertSearchQuery}` : ''}`,
            menuId: (0, $jhS4y.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter(item.id);
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                        level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        parentItemId: 'defaultFilters',
                        itemType: 'defaultFilter'
                    }
                });
            }
        }, item.name)))), sharedWithMe && sharedWithMe.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        menuId: sharedWithMeMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                    itemId: 'sharedWithMe',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        testId: (0, $dQbFB.getTestId)(sharedWithMeMenuIds)
    }, formatMessage((0, $7zFZv.default).sharedWithMe), sharedWithMe.some((filter)=>isSelectedPath(filter.alertSearchQuery))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, sharedWithMe.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
            elemBefore: pagesIcon,
            href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`,
            key: item.id,
            menuId: (0, $jhS4y.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter('');
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                        level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        itemType: 'savedSearch',
                        parentItemId: 'sharedWithMe'
                    }
                });
            }
        }, item.name)))), createdByMe && createdByMe.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        menuId: createdByMeMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                    itemId: 'createdByMe',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        testId: (0, $dQbFB.getTestId)(createdByMeMenuIds)
    }, formatMessage((0, $7zFZv.default).createdByMe)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, createdByMe.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
            elemBefore: pagesIcon,
            href: `/jira/ops/alerts?view=${viewType ?? 'list'}&query=${item.alertSearchQuery}`,
            key: item.id,
            menuId: (0, $jhS4y.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter('');
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                        level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        itemType: 'savedSearch',
                        parentItemId: 'createdByMe'
                    }
                });
            },
            actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gtYPY.SavedSearchActionButtons), {
                savedSearch: item
            })
        }, item.name)))));
}
function $ab6d77ca097b26bb$var$getParentMenuId(arr) {
    return (0, $lhMtU.toMenuIdFromMenuIdList)((arr || []).map((i)=>(0, $jhS4y.ENTITY_ID).ALARM_QUEUE(i.alertSearchQuery)));
}

});
parcelRegister("k3zlg", function(module, exports) {

$parcel$export(module.exports, "default", () => $06087129a1b4fe18$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<689cf2b5810d4bbc255bc019eedff1fa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $06087129a1b4fe18$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    }, v2 = {
        "kind": "ScalarField",
        "name": "alertSearchQuery"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "AlertsMenuItemContent",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "OpsgenieQuery",
                    "kind": "LinkedField",
                    "name": "opsgenie",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "OpsgenieSavedSearches",
                                "kind": "LinkedField",
                                "name": "savedSearches",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v1 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.name"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.alertSearchQuery"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "opsgenie.savedSearches.sharedWithMe"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v1 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.name"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.alertSearchQuery"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "opsgenie.savedSearches.createdByMe"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "opsgenie.savedSearches"
                        }
                    ]
                },
                "action": "THROW",
                "path": "opsgenie"
            }
        ],
        "type": "Query"
    };
}();
$06087129a1b4fe18$var$node.hash = "a966b3b30f116da10c5f94a5f11eefaa";
var $06087129a1b4fe18$export$2e2bcd8739ae039 = $06087129a1b4fe18$var$node;

});

parcelRegister("8N3cd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aff4cd926156d74fe58acdf2d87dd6f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $666560fc2c4c361a$var$_react = $666560fc2c4c361a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $666560fc2c4c361a$var$_baseNew = $666560fc2c4c361a$var$_interopRequireDefault((parcelRequire("enEmH")));
function $666560fc2c4c361a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $666560fc2c4c361a$var$PagesIcon = (props)=>/*#__PURE__*/ $666560fc2c4c361a$var$_react.default.createElement($666560fc2c4c361a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$666560fc2c4c361a$var$PagesIcon.displayName = 'PagesIcon';
var $666560fc2c4c361a$var$_default = module.exports.default = $666560fc2c4c361a$var$PagesIcon;

});

parcelRegister("5zvRj", function(module, exports) {

$parcel$export(module.exports, "TOKEN_TYPES", () => $b04e82ae7af2d21f$export$e92b897d610f2aba);
$parcel$export(module.exports, "LEFT_PARENTHESIS", () => $b04e82ae7af2d21f$export$9ce7f372949a1546);
$parcel$export(module.exports, "RIGHT_PARENTHESIS", () => $b04e82ae7af2d21f$export$bbbb3f477a9839e0);
$parcel$export(module.exports, "OPERATOR_EQUAL_TO", () => $b04e82ae7af2d21f$export$ea7497008076d6d2);
$parcel$export(module.exports, "OPERATOR_GROUP_FOR_ASSISTANT", () => $b04e82ae7af2d21f$export$e75c84803c67e1f4);
$parcel$export(module.exports, "LOGICAL_OPERATOR_AND", () => $b04e82ae7af2d21f$export$61308b2610174a70);
$parcel$export(module.exports, "LOGICAL_OPERATOR_OR", () => $b04e82ae7af2d21f$export$1de654320eb3e523);
$parcel$export(module.exports, "BOOLEAN_LITERAL_TRUE", () => $b04e82ae7af2d21f$export$ff7eed6ac2251302);
$parcel$export(module.exports, "BOOLEAN_LITERAL_FALSE", () => $b04e82ae7af2d21f$export$4b436fec6f13b741);
$parcel$export(module.exports, "BOOLEAN_LITERAL_GROUP", () => $b04e82ae7af2d21f$export$8cbc171ac4843075);
$parcel$export(module.exports, "STRING_LITERAL_DOUBLE_QUOTE", () => $b04e82ae7af2d21f$export$347c7cb6285a1d61);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_OPEN", () => $b04e82ae7af2d21f$export$910131ff5cd3d496);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_CLOSED", () => $b04e82ae7af2d21f$export$2aa0d26cb4549272);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_ACKED", () => $b04e82ae7af2d21f$export$572cec90aa166025);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_SNOOZED", () => $b04e82ae7af2d21f$export$f94109650ec67751);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_GROUP", () => $b04e82ae7af2d21f$export$3a3a37e9da45a2a4);
$parcel$export(module.exports, "STRING_LITERAL_PRIORITY_GROUP", () => $b04e82ae7af2d21f$export$9ef3f42fa10fce44);
$parcel$export(module.exports, "NULL_LITERAL", () => $b04e82ae7af2d21f$export$c2b6d31a7a2d40ba);
$parcel$export(module.exports, "IDENTIFIER_ALIAS", () => $b04e82ae7af2d21f$export$21c480ed86e9d13);
$parcel$export(module.exports, "IDENTIFIER_CLOSED_BY", () => $b04e82ae7af2d21f$export$534c195089710c34);
$parcel$export(module.exports, "IDENTIFIER_DEDUPLICATION", () => $b04e82ae7af2d21f$export$4699ad3805947d4d);
$parcel$export(module.exports, "IDENTIFIER_ENTITY", () => $b04e82ae7af2d21f$export$2a30b5099ba66c99);
$parcel$export(module.exports, "IDENTIFIER_IS_SEEN", () => $b04e82ae7af2d21f$export$7926b4c2836db847);
$parcel$export(module.exports, "IDENTIFIER_MESSAGE", () => $b04e82ae7af2d21f$export$5a8895646b1d5248);
$parcel$export(module.exports, "IDENTIFIER_ASSIGNEE", () => $b04e82ae7af2d21f$export$4047502bdab1e205);
$parcel$export(module.exports, "IDENTIFIER_PRIORITY", () => $b04e82ae7af2d21f$export$5922c06b76ebb57d);
$parcel$export(module.exports, "IDENTIFIER_COMPONENTS", () => $b04e82ae7af2d21f$export$1122634b5d555f05);
$parcel$export(module.exports, "IDENTIFIER_SERVICES", () => $b04e82ae7af2d21f$export$ec912454cd7d858a);
$parcel$export(module.exports, "IDENTIFIER_RESPONDERS", () => $b04e82ae7af2d21f$export$44673ddac1790242);
$parcel$export(module.exports, "IDENTIFIER_SOURCE", () => $b04e82ae7af2d21f$export$f250d53474e801dc);
$parcel$export(module.exports, "IDENTIFIER_STATUS", () => $b04e82ae7af2d21f$export$43181828ba8680e4);
$parcel$export(module.exports, "IDENTIFIER_TAG", () => $b04e82ae7af2d21f$export$8242733866920892);
$parcel$export(module.exports, "IDENTIFIER_TINY_ID", () => $b04e82ae7af2d21f$export$c833829cf31052f0);
$parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED", () => $b04e82ae7af2d21f$export$5f1e5c89a704810f);
$parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED_BY", () => $b04e82ae7af2d21f$export$89d93eb7117999c0);
$parcel$export(module.exports, "IDENTIFIER_TEAMS", () => $b04e82ae7af2d21f$export$a79eb1864dd7b745);
$parcel$export(module.exports, "IDENTIFIER_GROUP_ALERT", () => $b04e82ae7af2d21f$export$888a9cda49b5e18c);
$parcel$export(module.exports, "IDENTIFIER_BOOLEAN_GROUP", () => $b04e82ae7af2d21f$export$60745b712d37edf9);
$parcel$export(module.exports, "IDENTIFIER_GROUP_ALL", () => $b04e82ae7af2d21f$export$b38df7dc61d42293);
$parcel$export(module.exports, "splitToTokensRegex", () => $b04e82ae7af2d21f$export$28041d1d2a85f002);
$parcel$export(module.exports, "isKeywordRegex", () => $b04e82ae7af2d21f$export$290f3472231a2ca1);
$parcel$export(module.exports, "isModifierRegex", () => $b04e82ae7af2d21f$export$56079d3966b6b26c);
$parcel$export(module.exports, "isComplexOperatorRegex", () => $b04e82ae7af2d21f$export$3f6ac43c2355116b);
$parcel$export(module.exports, "isWSRegex", () => $b04e82ae7af2d21f$export$b1b0fc0dc5c83a12);
$parcel$export(module.exports, "isIdentifierRegex", () => $b04e82ae7af2d21f$export$218cf3eb73c65394);
$parcel$export(module.exports, "isLogicalOperatorRegex", () => $b04e82ae7af2d21f$export$a46484930d6fa80f);
$parcel$export(module.exports, "isOperatorRegex", () => $b04e82ae7af2d21f$export$d48805fc5b137dc9);
/**
 * Token types
 */ const $b04e82ae7af2d21f$export$e92b897d610f2aba = [
    'WHITE_SPACE',
    'SEPARATOR',
    'IDENTIFIER',
    'MODIFIER',
    'KEYWORD',
    'LOGICAL_OPERATOR',
    'STRING_LITERAL',
    'NUMBER_LITERAL',
    'BOOLEAN_LITERAL',
    'NULL_LITERAL',
    'OPERATOR'
];
const $b04e82ae7af2d21f$export$9ce7f372949a1546 = '(';
const $b04e82ae7af2d21f$export$bbbb3f477a9839e0 = ')';
const $b04e82ae7af2d21f$export$adbc66edc544fda9 = '=';
const $b04e82ae7af2d21f$export$fbd271ef020db0c = '!=';
const $b04e82ae7af2d21f$export$ea7497008076d6d2 = ':';
const $b04e82ae7af2d21f$export$6d44219c9e0c2567 = '!:';
const $b04e82ae7af2d21f$export$f8636d23c210043c = '<';
const $b04e82ae7af2d21f$export$1892bd0c818db570 = '<=';
const $b04e82ae7af2d21f$export$386b1ae18a32d690 = '>';
const $b04e82ae7af2d21f$export$44a62afa61d82568 = '>=';
const $b04e82ae7af2d21f$export$e75c84803c67e1f4 = [
    $b04e82ae7af2d21f$export$adbc66edc544fda9,
    $b04e82ae7af2d21f$export$f8636d23c210043c,
    $b04e82ae7af2d21f$export$1892bd0c818db570,
    $b04e82ae7af2d21f$export$386b1ae18a32d690,
    $b04e82ae7af2d21f$export$44a62afa61d82568
];
const $b04e82ae7af2d21f$export$61308b2610174a70 = 'AND';
const $b04e82ae7af2d21f$export$1de654320eb3e523 = 'OR';
const $b04e82ae7af2d21f$export$184522872a5410fc = 'not';
const $b04e82ae7af2d21f$export$ff7eed6ac2251302 = 'true';
const $b04e82ae7af2d21f$export$4b436fec6f13b741 = 'false';
const $b04e82ae7af2d21f$export$8cbc171ac4843075 = [
    $b04e82ae7af2d21f$export$ff7eed6ac2251302,
    $b04e82ae7af2d21f$export$4b436fec6f13b741
];
const $b04e82ae7af2d21f$export$347c7cb6285a1d61 = '"';
const $b04e82ae7af2d21f$export$d84ab70dc909b702 = "'";
const $b04e82ae7af2d21f$export$910131ff5cd3d496 = `${$b04e82ae7af2d21f$export$347c7cb6285a1d61}open${$b04e82ae7af2d21f$export$347c7cb6285a1d61}`;
const $b04e82ae7af2d21f$export$2aa0d26cb4549272 = `${$b04e82ae7af2d21f$export$347c7cb6285a1d61}closed${$b04e82ae7af2d21f$export$347c7cb6285a1d61}`;
const $b04e82ae7af2d21f$export$572cec90aa166025 = `${$b04e82ae7af2d21f$export$347c7cb6285a1d61}acknowledged${$b04e82ae7af2d21f$export$347c7cb6285a1d61}`;
const $b04e82ae7af2d21f$export$f94109650ec67751 = `${$b04e82ae7af2d21f$export$347c7cb6285a1d61}snoozed${$b04e82ae7af2d21f$export$347c7cb6285a1d61}`;
const $b04e82ae7af2d21f$export$3a3a37e9da45a2a4 = [
    $b04e82ae7af2d21f$export$910131ff5cd3d496,
    $b04e82ae7af2d21f$export$2aa0d26cb4549272,
    $b04e82ae7af2d21f$export$572cec90aa166025,
    $b04e82ae7af2d21f$export$f94109650ec67751
];
const $b04e82ae7af2d21f$export$928c1edd572e94f0 = 'P1';
const $b04e82ae7af2d21f$export$22202070e5f64c55 = 'P2';
const $b04e82ae7af2d21f$export$537865d58d2072a3 = 'P3';
const $b04e82ae7af2d21f$export$3d5cfea3feefee83 = 'P4';
const $b04e82ae7af2d21f$export$fe945cac89cd21a5 = 'P5';
const $b04e82ae7af2d21f$export$9ef3f42fa10fce44 = [
    $b04e82ae7af2d21f$export$928c1edd572e94f0,
    $b04e82ae7af2d21f$export$22202070e5f64c55,
    $b04e82ae7af2d21f$export$537865d58d2072a3,
    $b04e82ae7af2d21f$export$3d5cfea3feefee83,
    $b04e82ae7af2d21f$export$fe945cac89cd21a5
];
const $b04e82ae7af2d21f$export$c2b6d31a7a2d40ba = 'null';
const $b04e82ae7af2d21f$export$5a484b762b542c13 = 'actions';
const $b04e82ae7af2d21f$export$21c480ed86e9d13 = 'alias';
const $b04e82ae7af2d21f$export$534c195089710c34 = 'closedBy';
const $b04e82ae7af2d21f$export$4699ad3805947d4d = 'count';
const $b04e82ae7af2d21f$export$7c3401d7874d69f5 = 'createdAt';
const $b04e82ae7af2d21f$export$afffcbd5b444e040 = 'description';
const $b04e82ae7af2d21f$export$e1e61c3bf43fff11 = 'details.key';
const $b04e82ae7af2d21f$export$aa35da9746edbfe2 = 'details.value';
const $b04e82ae7af2d21f$export$b620b7163533b409 = 'detailsPair';
const $b04e82ae7af2d21f$export$2a30b5099ba66c99 = 'entity';
const $b04e82ae7af2d21f$export$2bfb49435a331d16 = 'integration.name';
const $b04e82ae7af2d21f$export$feced558810f4b3e = 'integration.type';
const $b04e82ae7af2d21f$export$7926b4c2836db847 = 'isSeen';
const $b04e82ae7af2d21f$export$5a8895646b1d5248 = 'message';
const $b04e82ae7af2d21f$export$4047502bdab1e205 = 'owner';
const $b04e82ae7af2d21f$export$5922c06b76ebb57d = 'priority';
const $b04e82ae7af2d21f$export$1122634b5d555f05 = 'components';
const $b04e82ae7af2d21f$export$ec912454cd7d858a = 'services';
const $b04e82ae7af2d21f$export$44673ddac1790242 = 'responders';
const $b04e82ae7af2d21f$export$f250d53474e801dc = 'source';
const $b04e82ae7af2d21f$export$43181828ba8680e4 = 'status';
const $b04e82ae7af2d21f$export$a1959e1b76e880dd = 'sync.name';
const $b04e82ae7af2d21f$export$8417ff61f7a57db6 = 'sync.type';
const $b04e82ae7af2d21f$export$8242733866920892 = 'tags';
const $b04e82ae7af2d21f$export$c833829cf31052f0 = 'tinyId';
const $b04e82ae7af2d21f$export$78d4faf48faf13c2 = 'updatedAt';
const $b04e82ae7af2d21f$export$5f1e5c89a704810f = 'acknowledged';
const $b04e82ae7af2d21f$export$89d93eb7117999c0 = 'acknowledgedBy';
const $b04e82ae7af2d21f$export$1ee0ad656333fc23 = 'aggregatorIds';
const $b04e82ae7af2d21f$export$d42da2034504d6de = 'alertId';
const $b04e82ae7af2d21f$export$8464a15b62fb09bb = 'alertType';
const $b04e82ae7af2d21f$export$2f7ba2848fc019c6 = 'encrypted';
const $b04e82ae7af2d21f$export$86e4b68c61c8cca5 = 'encryptionId';
const $b04e82ae7af2d21f$export$cd9dc7ab4d04d11c = 'lastOccurredAt';
const $b04e82ae7af2d21f$export$8508b76d4c14d7e = 'notify';
const $b04e82ae7af2d21f$export$e73ddf8d219f28b7 = 'snoozedUntil';
const $b04e82ae7af2d21f$export$a79eb1864dd7b745 = 'teams';
const $b04e82ae7af2d21f$export$888a9cda49b5e18c = [
    $b04e82ae7af2d21f$export$5f1e5c89a704810f,
    $b04e82ae7af2d21f$export$89d93eb7117999c0,
    $b04e82ae7af2d21f$export$1ee0ad656333fc23,
    $b04e82ae7af2d21f$export$d42da2034504d6de,
    $b04e82ae7af2d21f$export$8464a15b62fb09bb,
    $b04e82ae7af2d21f$export$2f7ba2848fc019c6,
    $b04e82ae7af2d21f$export$86e4b68c61c8cca5,
    $b04e82ae7af2d21f$export$cd9dc7ab4d04d11c,
    $b04e82ae7af2d21f$export$8508b76d4c14d7e,
    $b04e82ae7af2d21f$export$e73ddf8d219f28b7,
    $b04e82ae7af2d21f$export$a79eb1864dd7b745,
    $b04e82ae7af2d21f$export$5a484b762b542c13,
    $b04e82ae7af2d21f$export$21c480ed86e9d13,
    $b04e82ae7af2d21f$export$534c195089710c34,
    $b04e82ae7af2d21f$export$4699ad3805947d4d,
    $b04e82ae7af2d21f$export$7c3401d7874d69f5,
    $b04e82ae7af2d21f$export$afffcbd5b444e040,
    $b04e82ae7af2d21f$export$e1e61c3bf43fff11,
    $b04e82ae7af2d21f$export$aa35da9746edbfe2,
    $b04e82ae7af2d21f$export$b620b7163533b409,
    $b04e82ae7af2d21f$export$2a30b5099ba66c99,
    $b04e82ae7af2d21f$export$2bfb49435a331d16,
    $b04e82ae7af2d21f$export$feced558810f4b3e,
    $b04e82ae7af2d21f$export$7926b4c2836db847,
    $b04e82ae7af2d21f$export$5a8895646b1d5248,
    $b04e82ae7af2d21f$export$4047502bdab1e205,
    $b04e82ae7af2d21f$export$5922c06b76ebb57d,
    $b04e82ae7af2d21f$export$44673ddac1790242,
    $b04e82ae7af2d21f$export$1122634b5d555f05,
    $b04e82ae7af2d21f$export$ec912454cd7d858a,
    $b04e82ae7af2d21f$export$f250d53474e801dc,
    $b04e82ae7af2d21f$export$43181828ba8680e4,
    $b04e82ae7af2d21f$export$a1959e1b76e880dd,
    $b04e82ae7af2d21f$export$8417ff61f7a57db6,
    $b04e82ae7af2d21f$export$8242733866920892,
    $b04e82ae7af2d21f$export$c833829cf31052f0,
    $b04e82ae7af2d21f$export$78d4faf48faf13c2
];
const $b04e82ae7af2d21f$export$60745b712d37edf9 = [
    $b04e82ae7af2d21f$export$5f1e5c89a704810f,
    $b04e82ae7af2d21f$export$7926b4c2836db847
];
const $b04e82ae7af2d21f$export$b38df7dc61d42293 = [
    ...$b04e82ae7af2d21f$export$888a9cda49b5e18c
];
/**
 * Regex definitions
 */ // The main regex to split any given query into smaller tokens.
// Please be aware that token order has a meaning here.
const $b04e82ae7af2d21f$var$splitToTokensCases = [
    // 1. Split single and double quotes
    ...[
        $b04e82ae7af2d21f$export$d84ab70dc909b702,
        $b04e82ae7af2d21f$export$347c7cb6285a1d61
    ].map((i)=>`(${i}.*?${i})`),
    ...[
        $b04e82ae7af2d21f$export$d84ab70dc909b702,
        $b04e82ae7af2d21f$export$347c7cb6285a1d61
    ].map((i)=>`(${i}.*)`),
    // 2. Split operators and separators
    ...[
        $b04e82ae7af2d21f$export$9ce7f372949a1546,
        $b04e82ae7af2d21f$export$bbbb3f477a9839e0,
        $b04e82ae7af2d21f$export$adbc66edc544fda9,
        $b04e82ae7af2d21f$export$fbd271ef020db0c,
        $b04e82ae7af2d21f$export$ea7497008076d6d2,
        $b04e82ae7af2d21f$export$6d44219c9e0c2567,
        $b04e82ae7af2d21f$export$44a62afa61d82568,
        $b04e82ae7af2d21f$export$386b1ae18a32d690,
        $b04e82ae7af2d21f$export$1892bd0c818db570,
        $b04e82ae7af2d21f$export$f8636d23c210043c
    ].map((i)=>`(\\${i})`),
    // 3. Split the exact keywords when it's a known literal
    // Known issue: The word boundary in the beginning does not capture letters except latin chars, digits and underscore, i.e. "+and" results to STRING_LITERAL + BOOLEAN_LITERAL
    ...[
        $b04e82ae7af2d21f$export$61308b2610174a70,
        $b04e82ae7af2d21f$export$1de654320eb3e523,
        $b04e82ae7af2d21f$export$ff7eed6ac2251302,
        $b04e82ae7af2d21f$export$4b436fec6f13b741,
        $b04e82ae7af2d21f$export$184522872a5410fc,
        `is\\s*null`,
        `is\\s*not\\s*null`
    ].map((i)=>`(\\b${i}(?=\\s|$))`),
    // 4. Empty spaces
    '(\\s+)'
];
const $b04e82ae7af2d21f$export$28041d1d2a85f002 = new RegExp($b04e82ae7af2d21f$var$splitToTokensCases.join('|'), 'gi');
const $b04e82ae7af2d21f$export$290f3472231a2ca1 = /^(is(  *)not(  *)null)$|^(is(  *)null)$/i;
const $b04e82ae7af2d21f$export$56079d3966b6b26c = /^not$/i;
const $b04e82ae7af2d21f$export$3f6ac43c2355116b = /^<=$|^>=$|^!=$|^!:$/;
const $b04e82ae7af2d21f$export$b1b0fc0dc5c83a12 = /^\s+$/;
const $b04e82ae7af2d21f$export$218cf3eb73c65394 = new RegExp($b04e82ae7af2d21f$export$b38df7dc61d42293.map((i)=>`^${i}$`).join('|'));
const $b04e82ae7af2d21f$export$a46484930d6fa80f = /^and$|^or$/i;
const $b04e82ae7af2d21f$export$d48805fc5b137dc9 = /^[=:<>]$/;

});

parcelRegister("gtYPY", function(module, exports) {

$parcel$export(module.exports, "SavedSearchActionButtons", () => $aec190113be184ad$export$78ee2939aff842cb);

var $5uXOq = parcelRequire("5uXOq");

var $4qnvw = parcelRequire("4qnvw");

var $7H980 = parcelRequire("7H980");
var $70rf1 = parcelRequire("70rf1");

var $jlNRx = parcelRequire("jlNRx");

var $6pZGL = parcelRequire("6pZGL");

var $fwwof = parcelRequire("fwwof");
var $fAM0v = parcelRequire("fAM0v");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");





var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $9eeFp = parcelRequire("9eeFp");

var $aCS3f = parcelRequire("aCS3f");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");


var $dfzUf = parcelRequire("dfzUf");
const $aec190113be184ad$export$78ee2939aff842cb = ({ onClose: onClose, savedSearch: savedSearch })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        onOpen: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                    level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                    itemId: (0, $496585bee7985bb9$export$a65812b4aab631bb),
                    parentItemType: 'savedSearch',
                    parentItemId: savedSearch.id
                }
            });
        },
        MenuItems: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aec190113be184ad$var$MoreMenuItems, {
                ...props,
                savedSearch: savedSearch
            }),
        onClose: onClose
    });
};
const $aec190113be184ad$var$MoreMenuItems = ({ onClose: onClose, savedSearch: savedSearch })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [modalType, setModalType] = (0, $5uXOq.useState)(undefined);
    const onCloseWithStopPropagation = (0, $9eeFp.useStopPropagation)(onClose);
    const { removeSavedSearchFromCreatedByMe: removeSavedSearchFromCreatedByMe } = (0, $fAM0v.useSavedSearchRelayUtils)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const deleteSavedSearch = (0, $5uXOq.useCallback)((e)=>{
        setIsLoading(true);
        const savedSearchId = (0, $jlNRx.OpsgenieSavedSearchAri).parse(savedSearch.id).savedSearchId;
        (0, $fwwof.deleteSearchEndpoint)(savedSearchId).then(()=>{
            removeSavedSearchFromCreatedByMe(savedSearch.id);
        }).catch(()=>{
            showFlag({
                key: (0, $7HGHK.toFlagId)((0, $f4d30246a2d1df81$export$337d30e19f17af0f)),
                type: 'error',
                title: (0, $dfzUf.default).errorTitle,
                description: (0, $dfzUf.default).errorMessage,
                messageId: 'navigation-apps-sidebar-nav4-sidebars-content-operations.ui.alerts-content.alerts-menu-item.action-button.show-flag.error',
                messageType: 'transactional'
            });
        }).finally(()=>{
            setIsLoading(false);
            if (onClose) onClose(e);
        });
    }, [
        savedSearch,
        onClose,
        removeSavedSearchFromCreatedByMe,
        showFlag
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4qnvw))), {
            LEGACY_size: "small",
            color: "var(--ds-icon-danger, #C9372C)",
            label: ""
        }),
        onClick: (e)=>{
            e.preventDefault();
            setModalType('delete');
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$56981f28056f258e),
                    level: (0, $951a0ed422513987$export$35ac629b8b943d5a),
                    itemId: 'deleteSavedSearch',
                    parentItemType: 'savedSearch',
                    parentItemId: savedSearch.id
                }
            });
        }
    }, formatMessage((0, $dfzUf.default).deleteSavedSearch))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6pZGL.DeleteModal), {
        messageDescriptors: {
            title: (0, $dfzUf.default).confirmTrashHeading,
            description: (0, $dfzUf.default).confirmTrashMessage
        },
        isDeleteDialogOpen: modalType === 'delete',
        onDeleteAttemptCancel: onCloseWithStopPropagation,
        isLoading: isLoading,
        onDelete: (e)=>deleteSavedSearch(e)
    }));
};

});
parcelRegister("4qnvw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aba66ada45c058f49805b51f0ffb84ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $338bd33ca23c2016$var$_react = $338bd33ca23c2016$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $338bd33ca23c2016$var$_delete = $338bd33ca23c2016$var$_interopRequireDefault((parcelRequire("bGsST")));

var $338bd33ca23c2016$var$_trash = $338bd33ca23c2016$var$_interopRequireDefault((parcelRequire("9da6M")));
function $338bd33ca23c2016$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DeleteIcon.
 * This component is DeleteIcon, with `UNSAFE_fallbackIcon` set to "TrashIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $338bd33ca23c2016$var$DeleteIcon = (props)=>/*#__PURE__*/ $338bd33ca23c2016$var$_react.default.createElement($338bd33ca23c2016$var$_delete.default, Object.assign({
        LEGACY_fallbackIcon: $338bd33ca23c2016$var$_trash.default
    }, props));
$338bd33ca23c2016$var$DeleteIcon.Name = 'DeleteIconMigration';
var $338bd33ca23c2016$var$_default = module.exports.default = $338bd33ca23c2016$var$DeleteIcon;

});
parcelRegister("9da6M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b4d2b48731fd610$var$_react = $6b4d2b48731fd610$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $6b4d2b48731fd610$var$_delete = $6b4d2b48731fd610$var$_interopRequireDefault((parcelRequire("bGsST")));
function $6b4d2b48731fd610$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6b4d2b48731fd610$var$TrashIcon = (props)=>/*#__PURE__*/ $6b4d2b48731fd610$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5a1 1 0 0 0-1 1v1h16V6a1 1 0 0 0-1-1zm11.15 15h-8.3a1 1 0 0 1-.99-.83L5 8h14l-1.86 11.17a1 1 0 0 1-.99.83M9 4.5a.5.5 0 0 1 .49-.5h5.02a.5.5 0 0 1 .49.5V5H9z"/></svg>`
    }, props, {
        newIcon: $6b4d2b48731fd610$var$_delete.default
    }));
$6b4d2b48731fd610$var$TrashIcon.displayName = 'TrashIcon';
var $6b4d2b48731fd610$var$_default = module.exports.default = $6b4d2b48731fd610$var$TrashIcon;

});


parcelRegister("jlNRx", function(module, exports) {

$parcel$export(module.exports, "OpsgenieSavedSearchAri", () => $e166a829386cfc65$export$1dc7f741fb628a10);

var $47ByP = parcelRequire("47ByP");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/opsgenie/saved-search/manifest.ts
var $e166a829386cfc65$var$opsgenieSavedSearchAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $47ByP.OpsgenieSavedSearchAriResourceOwner),
    resourceType: (0, $47ByP.OpsgenieSavedSearchAriResourceType),
    resourceIdSlug: "{workspaceId}/{savedSearchId}",
    resourceIdSegmentFormats: {
        workspaceId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        savedSearchId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/opsgenie/saved-search/index.ts
var $e166a829386cfc65$export$1dc7f741fb628a10 = class _OpsgenieSavedSearchAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._workspaceId = opts.resourceIdSegmentValues.workspaceId, this._savedSearchId = opts.resourceIdSegmentValues.savedSearchId;
    }
    get workspaceId() {
        return this._workspaceId;
    }
    get savedSearchId() {
        return this._savedSearchId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e166a829386cfc65$var$opsgenieSavedSearchAriStaticOpts.qualifier,
            platformQualifier: $e166a829386cfc65$var$opsgenieSavedSearchAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $e166a829386cfc65$var$opsgenieSavedSearchAriStaticOpts.resourceOwner,
            resourceType: $e166a829386cfc65$var$opsgenieSavedSearchAriStaticOpts.resourceType,
            resourceId: `${opts.workspaceId}/${opts.savedSearchId}`,
            resourceIdSegmentValues: {
                workspaceId: opts.workspaceId,
                savedSearchId: opts.savedSearchId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $e166a829386cfc65$var$opsgenieSavedSearchAriStaticOpts);
        return new _OpsgenieSavedSearchAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $e166a829386cfc65$var$opsgenieSavedSearchAriStaticOpts);
        return new _OpsgenieSavedSearchAri(opts);
    }
    getVariables() {
        return {
            workspaceId: this.workspaceId,
            savedSearchId: this.savedSearchId
        };
    }
};

});
parcelRegister("47ByP", function(module, exports) {

$parcel$export(module.exports, "OpsgenieSavedSearchAriResourceOwner", () => $3004f3ab9c3d798b$export$7416cc1df15f6b85);
$parcel$export(module.exports, "OpsgenieSavedSearchAriResourceType", () => $3004f3ab9c3d798b$export$1db52fe39936618e);
// src/opsgenie/saved-search/types.ts
var $3004f3ab9c3d798b$export$7416cc1df15f6b85 = "opsgenie", $3004f3ab9c3d798b$export$1db52fe39936618e = "saved-search";

});


parcelRegister("6pZGL", function(module, exports) {

$parcel$export(module.exports, "DeleteModal", () => $84ae8a8840e0905c$export$73392e09138fecd6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $cNW3X = parcelRequire("cNW3X");
var $i95f5 = parcelRequire("i95f5");

var $hordk = parcelRequire("hordk");
var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");
var $kW74I = parcelRequire("kW74I");

var $heisI = parcelRequire("heisI");
const $84ae8a8840e0905c$export$73392e09138fecd6 = ({ isDeleteDialogOpen: isDeleteDialogOpen, onDeleteAttemptCancel: onDeleteAttemptCancel, onDelete: onDelete, isLoading: isLoading, messageDescriptors: messageDescriptors, returnFocusRef: returnFocusRef })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kW74I.default), {
        children: isDeleteDialogOpen && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hordk.default), {
            shouldCloseOnOverlayClick: !isLoading,
            onClose: onDeleteAttemptCancel,
            shouldReturnFocus: returnFocusRef,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eUaFh.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Sb4G.default), {
                        appearance: "danger",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...messageDescriptors.title
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g1QfP.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...messageDescriptors.description
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7CjwE.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                            isDisabled: isLoading,
                            appearance: "subtle",
                            onClick: onDeleteAttemptCancel,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $heisI.messages).cancelButton
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i95f5.default), {
                            appearance: "danger",
                            onClick: onDelete,
                            autoFocus: true,
                            isLoading: isLoading,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $heisI.messages).deleteButton
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("heisI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0d41f233ff591015$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0d41f233ff591015$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    cancelButton: {
        id: 'eoc.alert-detail.delete-modal.cancel-button.no-translate',
        defaultMessage: 'Cancel',
        description: 'The text will be displayed in the delete modal footer for cancel button.'
    },
    deleteButton: {
        id: 'eoc.alert-detail.extra-property.delete-modal.delete-button.no-translate',
        defaultMessage: 'Delete',
        description: 'The text will be displayed in the delete modal footer for delete button.'
    }
});

});


parcelRegister("fwwof", function(module, exports) {

$parcel$export(module.exports, "getSavedSearchesEndpoint", () => $204be93734e7f0a4$export$3b7b44889eb94cd0);
$parcel$export(module.exports, "createSavedSearchEndpoint", () => $204be93734e7f0a4$export$4976332c0ec66407);
$parcel$export(module.exports, "deleteSearchEndpoint", () => $204be93734e7f0a4$export$401da4a793944201);

var $d9Cgl = parcelRequire("d9Cgl");
const $204be93734e7f0a4$export$3b7b44889eb94cd0 = ()=>{
    return (0, $d9Cgl.eocFetch)('/v1/alerts/saved-searches');
};
const $204be93734e7f0a4$export$4976332c0ec66407 = (data)=>{
    return (0, $d9Cgl.eocFetch)('/v1/alerts/saved-searches', {
        method: 'POST',
        body: data
    });
};
const $204be93734e7f0a4$export$401da4a793944201 = (id)=>{
    return (0, $d9Cgl.eocFetch)(`/v1/alerts/saved-searches/${id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};

});

parcelRegister("fAM0v", function(module, exports) {

$parcel$export(module.exports, "useSavedSearchRelayUtils", () => $9bf057ce8cd06b83$export$e07c40a7acca4305);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jlNRx = parcelRequire("jlNRx");

var $gtuj9 = parcelRequire("gtuj9");
var $9dX4l = parcelRequire("9dX4l");

var $he0mL = parcelRequire("he0mL");

var $4KhXr = parcelRequire("4KhXr");
const $9bf057ce8cd06b83$export$e07c40a7acca4305 = ()=>{
    const relayEnvironment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $he0mL.getMeta)('ajs-cloud-id') ?? (0, $4KhXr.getCloudIdForDevEnvironment)();
    (0, $gtuj9.assert)(!!cloudId, new (0, $9dX4l.AssertionError)('cloudId', 'useSavedSarchRelayUtils: cloudId is undefined'));
    const removeSavedSearch = (0, $5uXOq.useCallback)((savedSearchId, key)=>{
        (0, $8Uumt.commitLocalUpdate)(relayEnvironment, (store)=>{
            const root = store.getRoot();
            const opsgenieRecord = root.getLinkedRecord('opsgenie');
            if (opsgenieRecord) {
                const savedSearches = opsgenieRecord.getLinkedRecord('savedSearches', {
                    cloudId: cloudId
                });
                if (savedSearches) {
                    const removeItem = savedSearches.getLinkedRecords(key);
                    if (removeItem) {
                        const filteredItems = removeItem.filter((record)=>record.getValue('id') !== savedSearchId);
                        savedSearches.setLinkedRecords(filteredItems, key);
                    }
                }
            }
        });
    }, [
        cloudId,
        relayEnvironment
    ]);
    const addSavedSearch = (0, $5uXOq.useCallback)((savedSearch, key)=>{
        (0, $8Uumt.commitLocalUpdate)(relayEnvironment, (store)=>{
            const newSavedSearchId = (0, $jlNRx.OpsgenieSavedSearchAri).create({
                workspaceId: cloudId,
                savedSearchId: savedSearch.id
            }).toString();
            const newSavedSearch = store.create(newSavedSearchId, 'OpsgenieSavedSearch');
            newSavedSearch.setValue(newSavedSearchId, 'id');
            newSavedSearch.setValue(savedSearch.name, 'name');
            newSavedSearch.setValue(savedSearch.query, 'alertSearchQuery');
            const root = store.getRoot();
            const opsgenieRecord = root.getLinkedRecord('opsgenie');
            if (opsgenieRecord) {
                const savedSearches = opsgenieRecord.getLinkedRecord('savedSearches', {
                    cloudId: cloudId
                });
                if (savedSearches) {
                    const savedSearchesList = savedSearches.getLinkedRecords(key) || [];
                    const updatedSavedSearches = [
                        ...savedSearchesList,
                        newSavedSearch
                    ];
                    savedSearches.setLinkedRecords(updatedSavedSearches, key);
                }
            }
        });
    }, [
        cloudId,
        relayEnvironment
    ]);
    const addSavedSearchToCreatedByMe = (0, $5uXOq.useCallback)((savedSearch)=>{
        addSavedSearch(savedSearch, 'createdByMe');
    }, [
        addSavedSearch
    ]);
    const removeSavedSearchFromCreatedByMe = (0, $5uXOq.useCallback)((savedSearchId)=>{
        removeSavedSearch(savedSearchId, 'createdByMe');
    }, [
        removeSavedSearch
    ]);
    return {
        addSavedSearchToCreatedByMe: addSavedSearchToCreatedByMe,
        removeSavedSearchFromCreatedByMe: removeSavedSearchFromCreatedByMe
    };
};

});
parcelRegister("gtuj9", function(module, exports) {

$parcel$export(module.exports, "assert", () => $b007bd15050d5626$export$a7a9523472993e97);

var $9dX4l = parcelRequire("9dX4l");
/**
 * Throws when the condition is true
 * @param condition Condition to assert - can use type assertions thanks to ts's "asserts condition"
 * @param err An AssertionError object extending js error object
 */ const $b007bd15050d5626$export$a7a9523472993e97 = function(condition, err) {
    if (!condition) throw err;
};

});
parcelRegister("9dX4l", function(module, exports) {

$parcel$export(module.exports, "AssertionError", () => $b090f894167771e6$export$7750cdfb4db2c3d);
class $b090f894167771e6$export$7750cdfb4db2c3d extends Error {
    constructor(id, message){
        super(`[${id}] ${message}`), this.id = id;
    }
}

});


parcelRegister("4KhXr", function(module, exports) {

$parcel$export(module.exports, "validateTimeInput", () => $732201514f328955$export$8880da3ae4274888);
$parcel$export(module.exports, "validateBetweenInput", () => $732201514f328955$export$57c3e855fbf300fa);
$parcel$export(module.exports, "isInvalidDateValue", () => $732201514f328955$export$f18cd4bc58b99a27);
$parcel$export(module.exports, "removeQuotes", () => $732201514f328955$export$dd2bdf5049bf0915);
$parcel$export(module.exports, "withQuote", () => $732201514f328955$export$8708814d32e406db);
$parcel$export(module.exports, "calculateTimes", () => $732201514f328955$export$b362bc6892126b7a);
$parcel$export(module.exports, "getDefaultFilterQuery", () => $732201514f328955$export$16cce822d8159876);
$parcel$export(module.exports, "isResponderAlert", () => $732201514f328955$export$78656db4ffc3ccd8);
$parcel$export(module.exports, "isGroupAlert", () => $732201514f328955$export$be2243d4df51c704);
$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $732201514f328955$export$81c70e0016508593);
$parcel$export(module.exports, "getCloudIdForDevEnvironment", () => $732201514f328955$export$fc6ce7ac2248d7f5);

var $jovBr = parcelRequire("jovBr");

var $eZDAP = parcelRequire("eZDAP");

var $gn1v9 = parcelRequire("gn1v9");

var $he0mL = parcelRequire("he0mL");

var $eZdO2 = parcelRequire("eZdO2");
var $5zvRj = parcelRequire("5zvRj");

var $4nQCG = parcelRequire("4nQCG");

var $6cAn5 = parcelRequire("6cAn5");
const $732201514f328955$export$8880da3ae4274888 = (intl, timeDigits, timeUnit)=>{
    if (!timeDigits) return;
    const timeDigitsNumber = parseInt(timeDigits);
    if (isNaN(timeDigitsNumber)) return intl.formatMessage((0, $4nQCG.default).validNumber);
    if (timeUnit === 'hours' && (timeDigitsNumber < 1 || timeDigitsNumber > 99999)) return intl.formatMessage((0, $4nQCG.default).hoursNotInRange);
    if (timeUnit === 'days' && (timeDigitsNumber < 1 || timeDigitsNumber > 9999)) return intl.formatMessage((0, $4nQCG.default).daysNotInRange);
    if (timeUnit === 'weeks' && (timeDigitsNumber < 1 || timeDigitsNumber > 999)) return intl.formatMessage((0, $4nQCG.default).weeksNotInRange);
    if (timeUnit === 'months' && (timeDigitsNumber < 1 || timeDigitsNumber > 99)) return intl.formatMessage((0, $4nQCG.default).monthsNotInRange);
    if (timeUnit === 'years' && (timeDigitsNumber < 1 || timeDigitsNumber > 9)) return intl.formatMessage((0, $4nQCG.default).yearsNotInRange);
};
const $732201514f328955$export$57c3e855fbf300fa = (intl, value)=>{
    if (value) {
        const { startDate: startDate, endDate: endDate } = value;
        if (!startDate && !endDate) return;
        if (startDate && endDate && new Date(startDate) > new Date(endDate)) return intl.formatMessage((0, $4nQCG.default).validationMessageBeforeGreaterThanAfter);
        if (value && (startDate !== '' && !(0, $jovBr.default)(new Date(startDate)) || endDate !== '' && !(0, $jovBr.default)(new Date(endDate)))) return intl.formatMessage((0, $4nQCG.default).validationMessageInvalidDateFormat);
    }
    return;
};
const $732201514f328955$export$f18cd4bc58b99a27 = (value)=>{
    return !(0, $jovBr.default)((0, $eZDAP.default)(value)) && value !== '';
};
const $732201514f328955$export$dd2bdf5049bf0915 = (value)=>{
    return value.replace(/^"(.*)"$/, '$1');
};
const $732201514f328955$export$d4aae9ad13afd6c = (data)=>{
    return {
        ...data,
        label: data.name,
        value: data.id
    };
};
const $732201514f328955$export$8708814d32e406db = (value)=>{
    if ((0, $eZdO2.hasSpaceRegEx).test(value) || (0, $eZdO2.hasColonRegex).test(value)) return `${0, $5zvRj.STRING_LITERAL_DOUBLE_QUOTE}${value}${0, $5zvRj.STRING_LITERAL_DOUBLE_QUOTE}`;
    else return value;
};
const $732201514f328955$export$b362bc6892126b7a = (time)=>{
    if (!time) return {
        from: undefined,
        to: undefined
    };
    if (time.range === 'all') return {
        from: undefined,
        to: undefined
    };
    if (time.range === 'custom') return {
        from: time.from,
        to: time.to
    };
    const now = new Date();
    const subAmount = {
        [time.range]: time.value
    };
    return {
        from: (0, $gn1v9.default)(now, subAmount).getTime(),
        to: now.getTime()
    };
};
const $732201514f328955$export$16cce822d8159876 = (query, teamId)=>{
    if (teamId) {
        if (query) return `${0, $5zvRj.IDENTIFIER_RESPONDERS}: ${teamId} ${0, $5zvRj.LOGICAL_OPERATOR_AND} ${query}`;
        return `${0, $5zvRj.IDENTIFIER_RESPONDERS}: ${teamId}`;
    }
    return query;
};
const $732201514f328955$export$78656db4ffc3ccd8 = (alert)=>alert && alert.alertType === 'responder';
const $732201514f328955$export$be2243d4df51c704 = (alert)=>alert.entityType === 'group';
const $732201514f328955$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $he0mL.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};
const $732201514f328955$var$isDevEnvironment = ()=>{
    return typeof $6cAn5 !== 'undefined' && ($6cAn5?.env?.STORYBOOK === 'true' || $6cAn5?.env?.NODE_ENV === 'development') || window.location.hostname === 'localhost';
};
const $732201514f328955$export$fc6ce7ac2248d7f5 = ()=>{
    if ($732201514f328955$var$isDevEnvironment()) return 'abc-def-ghi-jkl';
    return undefined;
};

});
parcelRegister("eZdO2", function(module, exports) {

$parcel$export(module.exports, "TAB_KEY", () => $335649bf7a204290$export$da8c7facc28740b1);
$parcel$export(module.exports, "ENTER_KEY", () => $335649bf7a204290$export$4162dbd8c730437);
$parcel$export(module.exports, "ESCAPE_KEY", () => $335649bf7a204290$export$728705b4513abbb5);
$parcel$export(module.exports, "SPACE_KEY", () => $335649bf7a204290$export$a47625ee19580f99);
$parcel$export(module.exports, "LEFT_KEY", () => $335649bf7a204290$export$ba950c21a0561bed);
$parcel$export(module.exports, "UP_KEY", () => $335649bf7a204290$export$16859d5882a95fea);
$parcel$export(module.exports, "RIGHT_KEY", () => $335649bf7a204290$export$4b96cad863d88376);
$parcel$export(module.exports, "DOWN_KEY", () => $335649bf7a204290$export$fc0cf2556509233e);
$parcel$export(module.exports, "SUGGESTION_CARD_Y_POS", () => $335649bf7a204290$export$87b2b08fc4c97f78);
$parcel$export(module.exports, "hasSpaceRegEx", () => $335649bf7a204290$export$a07ca273fbeffcb8);
$parcel$export(module.exports, "hasStartingQuotesRegex", () => $335649bf7a204290$export$a3aaedcec21ac282);
$parcel$export(module.exports, "hasEndingQuotesRegex", () => $335649bf7a204290$export$e5ad519d04ef012a);
$parcel$export(module.exports, "hasNewLinesRegex", () => $335649bf7a204290$export$7645e556e9948ecd);
$parcel$export(module.exports, "EMAIL_REGEX", () => $335649bf7a204290$export$7b7637218245c8a);
$parcel$export(module.exports, "hasColonRegex", () => $335649bf7a204290$export$65a2b373cb60e599);
const $335649bf7a204290$export$da8c7facc28740b1 = 'Tab';
const $335649bf7a204290$export$4162dbd8c730437 = 'Enter';
const $335649bf7a204290$export$728705b4513abbb5 = 'Escape';
const $335649bf7a204290$export$a47625ee19580f99 = ' ';
const $335649bf7a204290$export$ba950c21a0561bed = 'ArrowLeft';
const $335649bf7a204290$export$16859d5882a95fea = 'ArrowUp';
const $335649bf7a204290$export$4b96cad863d88376 = 'ArrowRight';
const $335649bf7a204290$export$fc0cf2556509233e = 'ArrowDown';
const $335649bf7a204290$export$87b2b08fc4c97f78 = 28;
const $335649bf7a204290$export$a07ca273fbeffcb8 = /\s/;
const $335649bf7a204290$export$8866d083cd03ffd7 = /^\s|\s$/;
const $335649bf7a204290$export$a3aaedcec21ac282 = /^('|")/;
const $335649bf7a204290$export$e5ad519d04ef012a = /('|")$/;
const $335649bf7a204290$export$7645e556e9948ecd = /(\r\n|\n|\r)/gm;
const $335649bf7a204290$export$7b7637218245c8a = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const $335649bf7a204290$export$65a2b373cb60e599 = /:/;

});

parcelRegister("4nQCG", function(module, exports) {

$parcel$export(module.exports, "default", () => $52bfe033c7b1b100$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $52bfe033c7b1b100$var$messages = (0, $7VHMR.defineMessages)({
    validationMessageBeforeGreaterThanAfter: {
        id: `eoc.alert-list.common.utils.validation-message-before-greater-than-after.no-translate`,
        defaultMessage: "'Before' field cannot be later than 'After' field.",
        description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
    },
    validationMessageInvalidDateFormat: {
        id: `eoc.alert-list.common.utils.validation-message-invalid-date-format.no-translate`,
        defaultMessage: 'Invalid date format.',
        description: 'Invalid date format.'
    },
    validNumber: {
        id: `eoc.alert-list.common.utils.validation-not-number.no-translate`,
        defaultMessage: 'Enter a valid number.',
        description: 'The error message that shown when user write different chars other than numeric chars.'
    },
    hoursNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-hours-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-99999.',
        description: 'Message displayed to the user when hours value is not in range'
    },
    daysNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-days-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-9999.',
        description: 'Message displayed to the user when days value is not in range'
    },
    weeksNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-weeks-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-999.',
        description: 'Message displayed to the user when weeks value is not in range'
    },
    monthsNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-months-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-99.',
        description: 'Message displayed to the user when months value is not in range'
    },
    yearsNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-years-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-9.',
        description: 'Message displayed to the user when years value is not in range'
    }
});
var $52bfe033c7b1b100$export$2e2bcd8739ae039 = $52bfe033c7b1b100$var$messages;

});



const $f4d30246a2d1df81$export$337d30e19f17af0f = 'fetchError';

parcelRegister("dfzUf", function(module, exports) {

$parcel$export(module.exports, "default", () => $57b524cf9eff8335$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $57b524cf9eff8335$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    deleteSavedSearch: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.delete-saved-search",
        "defaultMessage": "Delete"
    },
    confirmTrashHeading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.confirm-trash-heading",
        "defaultMessage": "Delete saved search"
    },
    confirmTrashMessage: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.confirm-trash-message",
        "defaultMessage": "Are you sure you want to delete this saved search?"
    },
    errorTitle: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.error-title",
        "defaultMessage": "Error"
    },
    errorMessage: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-operations.alerts-content.alerts-menu-item.action-button.error-message",
        "defaultMessage": "Something went wrong. Please try again."
    }
});

});



parcelRegister("ePmXi", function(module, exports) {

$parcel$export(module.exports, "AlertsMenuItemContentNew", () => $52a00eeba0ac60fa$export$f0f13aaf6210507e);

var $4gZTO = parcelRequire("4gZTO");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $8N3cd = parcelRequire("8N3cd");

var $5zvRj = parcelRequire("5zvRj");

var $koVbs = parcelRequire("koVbs");




var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $lhMtU = parcelRequire("lhMtU");

var $c16H2 = parcelRequire("c16H2");

var $5FnJJ = parcelRequire("5FnJJ");

var $dQbFB = parcelRequire("dQbFB");

var $24a2m = parcelRequire("24a2m");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $90yGq = parcelRequire("90yGq");

var $l8ruj = parcelRequire("l8ruj");

var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");

var $ieDtd = parcelRequire("ieDtd");

var $9MLkJ = parcelRequire("9MLkJ");

var $7zFZv = parcelRequire("7zFZv");

var $9At5X = parcelRequire("9At5X");

var $gtYPY = parcelRequire("gtYPY");
function $52a00eeba0ac60fa$export$f0f13aaf6210507e({ queryRef: queryRef }) {
    const data = (0, $8Uumt.useFragment)((0, $4gZTO.default), queryRef);
    const [alertSearchQuery] = (0, $ieDtd.useQueryParam)('query');
    const [selectedFilter, setSelectedFilter] = (0, $5uXOq.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const accountId = (0, $90yGq.useAccountId)();
    const [viewType] = (0, $ieDtd.useQueryParam)('view');
    const { icon: pagesIcon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $9MLkJ.default).alerts, (0, (/*@__PURE__*/$parcel$interopDefault($8N3cd))));
    const { sharedWithMe: sharedWithMe, createdByMe: createdByMe } = data.opsgenie.savedSearches;
    const defaultFilters = (0, $5uXOq.useMemo)(()=>[
            {
                id: 'all',
                name: formatMessage((0, $7zFZv.default).allSearch),
                alertSearchQuery: ''
            },
            {
                id: 'open',
                name: formatMessage((0, $7zFZv.default).openSearch),
                alertSearchQuery: `${(0, $5zvRj.IDENTIFIER_STATUS)}${(0, $5zvRj.OPERATOR_EQUAL_TO)} ${(0, $5zvRj.STRING_LITERAL_STATUS_OPEN)}`
            },
            {
                id: 'closed',
                name: formatMessage((0, $7zFZv.default).closedSearch),
                alertSearchQuery: `${(0, $5zvRj.IDENTIFIER_STATUS)}${(0, $5zvRj.OPERATOR_EQUAL_TO)} ${(0, $5zvRj.STRING_LITERAL_STATUS_CLOSED)}`
            },
            {
                id: 'unacked',
                name: formatMessage((0, $7zFZv.default).unackedSearch),
                alertSearchQuery: `${(0, $5zvRj.IDENTIFIER_STATUS)}${(0, $5zvRj.OPERATOR_EQUAL_TO)} ${(0, $5zvRj.STRING_LITERAL_STATUS_OPEN)} ${(0, $5zvRj.LOGICAL_OPERATOR_AND)} ${(0, $5zvRj.IDENTIFIER_ACKNOWLEDGED)}${(0, $5zvRj.OPERATOR_EQUAL_TO)} ${(0, $5zvRj.BOOLEAN_LITERAL_FALSE)}`
            },
            {
                id: 'notSeen',
                name: formatMessage((0, $7zFZv.default).notSeenSearch),
                alertSearchQuery: `${(0, $5zvRj.IDENTIFIER_IS_SEEN)}${(0, $5zvRj.OPERATOR_EQUAL_TO)} ${(0, $5zvRj.BOOLEAN_LITERAL_FALSE)}`
            },
            {
                id: 'assignedToMe',
                name: formatMessage((0, $7zFZv.default).assignedToMeSearch),
                alertSearchQuery: `${(0, $5zvRj.IDENTIFIER_ASSIGNEE)}${(0, $5zvRj.OPERATOR_EQUAL_TO)} "${accountId || 'me'}"`
            }
        ], [
        formatMessage,
        accountId
    ]);
    const defaultFilterMenuIds = $52a00eeba0ac60fa$var$getParentMenuId(defaultFilters);
    const defaultFilterWithComponentList = $52a00eeba0ac60fa$var$getComponentAddedSearchObjects(defaultFilters, pagesIcon, viewType, 'default', setSelectedFilter, createAnalyticsEvent);
    const sharedWithMeWithComponentList = $52a00eeba0ac60fa$var$getComponentAddedSearchObjects(sharedWithMe, pagesIcon, viewType, 'sharedWithMe', setSelectedFilter, createAnalyticsEvent);
    const createdByMeWithComponentList = $52a00eeba0ac60fa$var$getComponentAddedSearchObjects(createdByMe, pagesIcon, viewType, 'createdByMe', setSelectedFilter, createAnalyticsEvent);
    const allFiltersWithComponentList = (0, $5uXOq.useMemo)(()=>[
            ...defaultFilterWithComponentList,
            ...sharedWithMeWithComponentList,
            ...createdByMeWithComponentList
        ], [
        createdByMeWithComponentList,
        defaultFilterWithComponentList,
        sharedWithMeWithComponentList
    ]);
    const getSelectedFilterComponentIfNotDefault = (0, $5uXOq.useMemo)(()=>(filterId)=>{
            if (defaultFilters.find((item)=>item.id === filterId)) return;
            const foundComponent = [
                ...sharedWithMeWithComponentList,
                ...createdByMeWithComponentList
            ].find((item)=>item.id === filterId)?.component;
            return foundComponent;
        }, [
        createdByMeWithComponentList,
        defaultFilters,
        sharedWithMeWithComponentList
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (selectedFilter === '') {
            for (const item of allFiltersWithComponentList)// FIXME: This approach is not ideal. We should somehow use id instead of the alertSearchQuery.
            // https://ifountain.atlassian.net/browse/ALX-9535
            if (item.alertSearchQuery === alertSearchQuery) {
                setSelectedFilter(item.id);
                break;
            }
        }
    }, [
        alertSearchQuery,
        allFiltersWithComponentList,
        selectedFilter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4.sidebar.operations.alerts"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        menuId: defaultFilterMenuIds,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                attributes: {
                    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                    level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                    itemId: 'defaultFilters',
                    parentItemId: 'alerts'
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        testId: (0, $dQbFB.getTestId)(defaultFilterMenuIds)
    }, formatMessage((0, $7zFZv.default).defaultFilters)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, defaultFilters.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
            elemBefore: pagesIcon,
            key: item.id,
            href: `/jira/ops/alerts?view=${viewType ?? 'list'}${item.alertSearchQuery ? `&query=${item.alertSearchQuery}` : ''}`,
            menuId: (0, $jhS4y.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
            onClick: ()=>{
                setSelectedFilter(item.id);
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                    actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                    attributes: {
                        componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                        level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                        itemId: item.id,
                        parentItemId: 'defaultFilters',
                        itemType: 'defaultFilter'
                    }
                });
            }
        }, item.name)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, getSelectedFilterComponentIfNotDefault(selectedFilter)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9At5X.AlertsFlyoutMenuItem), {
        defaultFilterWithComponentList: defaultFilterWithComponentList,
        sharedWithMeWithComponentList: sharedWithMeWithComponentList,
        createdByMeWithComponentList: createdByMeWithComponentList,
        allFiltersWithComponentList: allFiltersWithComponentList
    }));
}
function $52a00eeba0ac60fa$var$getParentMenuId(arr) {
    return (0, $lhMtU.toMenuIdFromMenuIdList)((arr || []).map((i)=>(0, $jhS4y.ENTITY_ID).ALARM_QUEUE(i.alertSearchQuery)));
}
function $52a00eeba0ac60fa$var$getComponentAddedSearchObjects(arrayList, pagesIcon, viewType, savedSearchType, setSelectedFilter, createAnalyticsEvent) {
    return arrayList.map((item)=>({
            ...item,
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
                elemBefore: pagesIcon,
                key: item.id,
                href: `/jira/ops/alerts?view=${viewType ?? 'list'}${item.alertSearchQuery ? `&query=${item.alertSearchQuery}` : ''}`,
                menuId: (0, $jhS4y.ENTITY_ID).ALARM_QUEUE(item.alertSearchQuery),
                onClick: ()=>{
                    setSelectedFilter(item.id);
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                        action: 'clicked',
                        actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
                        actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OPERATIONS],
                        attributes: {
                            componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                            level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
                            itemId: item.id,
                            parentItemId: 'defaultFilters',
                            itemType: 'defaultFilter'
                        }
                    });
                },
                ...savedSearchType === 'createdByMe' && {
                    actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gtYPY.SavedSearchActionButtons), {
                        savedSearch: item
                    })
                }
            }, item.name)
        }));
}

});
parcelRegister("4gZTO", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ff80c65f890cde$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0a496a9de054c99bd4966c9618d3727f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $01ff80c65f890cde$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    }, v2 = {
        "kind": "ScalarField",
        "name": "alertSearchQuery"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "AlertsMenuItemContentNew",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "OpsgenieQuery",
                    "kind": "LinkedField",
                    "name": "opsgenie",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "OpsgenieSavedSearches",
                                "kind": "LinkedField",
                                "name": "savedSearches",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v1 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.name"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.sharedWithMe.alertSearchQuery"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "opsgenie.savedSearches.sharedWithMe"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v1 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.name"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "opsgenie.savedSearches.createdByMe.alertSearchQuery"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "opsgenie.savedSearches.createdByMe"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "opsgenie.savedSearches"
                        }
                    ]
                },
                "action": "THROW",
                "path": "opsgenie"
            }
        ],
        "type": "Query"
    };
}();
$01ff80c65f890cde$var$node.hash = "62c2524a94628923eca8ac7d6870a893";
var $01ff80c65f890cde$export$2e2bcd8739ae039 = $01ff80c65f890cde$var$node;

});

parcelRegister("9At5X", function(module, exports) {

$parcel$export(module.exports, "AlertsFlyoutMenuItem", () => $029eccda8b472a6e$export$22af2a033e73b845);

var $5uXOq = parcelRequire("5uXOq");

var $9r7BT = parcelRequire("9r7BT");

var $0yZbT = parcelRequire("0yZbT");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");

var $aWy0H = parcelRequire("aWy0H");

var $6cJvk = parcelRequire("6cJvk");

var $bWfiu = parcelRequire("bWfiu");

var $3senf = parcelRequire("3senf");
var $l7Vqz = parcelRequire("l7Vqz");
var $8luXP = parcelRequire("8luXP");
var $ch7sx = parcelRequire("ch7sx");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $7zFZv = parcelRequire("7zFZv");
const $029eccda8b472a6e$export$22af2a033e73b845 = ({ defaultFilterWithComponentList: defaultFilterWithComponentList, sharedWithMeWithComponentList: sharedWithMeWithComponentList, createdByMeWithComponentList: createdByMeWithComponentList, allFiltersWithComponentList: allFiltersWithComponentList })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [textFilterValue, setTextFilterValue] = (0, $5uXOq.useState)('');
    const [foundItems, setFoundItems] = (0, $5uXOq.useState)([]);
    const handleChange = (0, $5uXOq.useCallback)((event)=>{
        const value = event.currentTarget.value;
        setTextFilterValue(value);
        const foundItemsList = allFiltersWithComponentList.filter((item)=>item.name.toLowerCase().includes(value.toLowerCase()));
        const components = foundItemsList.map((item)=>item.component);
        setFoundItems(components);
    }, [
        allFiltersWithComponentList
    ]);
    const onStopSavedSearch = (0, $5uXOq.useCallback)(()=>{
        const savedSearchesEvent = createAnalyticsEvent({
            action: 'blurred',
            actionSubject: 'jsmViewAllSavedSearchesFlyoutSearch'
        });
        (0, $8zOmE.fireUIAnalytics)(savedSearchesEvent, 'stopViewAllQueueSearch');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3senf.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8luXP.FlyoutMenuItemTrigger), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cJvk))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        })
    }, formatMessage((0, $7zFZv.default).viewAllFiltersPopupMenuButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l7Vqz.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ch7sx.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.050",
        xcss: $029eccda8b472a6e$var$flyoutContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $029eccda8b472a6e$var$stickyBarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "xsmall"
    }, formatMessage((0, $7zFZv.default).alerts))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $029eccda8b472a6e$var$textfieldStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9r7BT.default), {
        isCompact: true,
        value: textFilterValue,
        onChange: handleChange,
        "aria-label": formatMessage((0, $7zFZv.default).viewAllFiltersSearchPlaceholder),
        placeholder: formatMessage((0, $7zFZv.default).viewAllFiltersSearchPlaceholder),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWy0H))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        }),
        onBlur: onStopSavedSearch
    }))), !textFilterValue.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "xxsmall"
    }, formatMessage((0, $7zFZv.default).defaultFilters))), defaultFilterWithComponentList.map((item)=>item.component), sharedWithMeWithComponentList && sharedWithMeWithComponentList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "xxsmall"
    }, formatMessage((0, $7zFZv.default).sharedWithMe))), sharedWithMeWithComponentList.map((item)=>item.component)), createdByMeWithComponentList && createdByMeWithComponentList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "xxsmall"
    }, formatMessage((0, $7zFZv.default).createdByMe))), createdByMeWithComponentList.map((item)=>item.component))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, foundItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        key: "no-item-found",
        paddingBlock: "space.100",
        xcss: $029eccda8b472a6e$var$noSearchResultsFoundStyles
    }, formatMessage((0, $7zFZv.default).viewAllFiltersNoResultsFoundText)) : foundItems)))));
};
const $029eccda8b472a6e$var$stickyBarStyles = (0, $2s57o.xcss)({
    position: 'sticky',
    top: '0',
    backgroundColor: 'utility.elevation.surface.current',
    zIndex: 'navigation'
});
const $029eccda8b472a6e$var$textfieldStyles = (0, $2s57o.xcss)({
    paddingRight: 'space.100'
});
const $029eccda8b472a6e$var$noSearchResultsFoundStyles = (0, $2s57o.xcss)({
    fontStyle: 'italic'
});
const $029eccda8b472a6e$var$flyoutContentStyles = (0, $2s57o.xcss)({
    maxHeight: '500px',
    overflowY: 'auto'
});

});
parcelRegister("9r7BT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7747ff173c91dd60$export$2e2bcd8739ae039);
/* text-field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $fHpHg = parcelRequire("fHpHg");
const $7747ff173c91dd60$var$containerMedia = {
    invalid: "_srjtgir2",
    disabled: "_6up518qt"
};
const $7747ff173c91dd60$var$inputMediaDisabled = null;
const $7747ff173c91dd60$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $7747ff173c91dd60$var$disabledStyle = {
    standard: "_1h6dsyzs _bfhksyzs _syaz1lh4 _80om13gf",
    subtle: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf",
    none: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf"
};
const $7747ff173c91dd60$var$invalidStyle = null;
const $7747ff173c91dd60$var$focusWithinStyle = {
    standard: "_ochr1p6i _195er01l _bqhtq049",
    subtle: "_ochr1p6i _195er01l _bqhtq049",
    none: "_ochr3acm _195e18uv _bqhtnruj"
};
const $7747ff173c91dd60$var$hoverStyle = {
    standard: "_4cvx1elr _irr31d5g",
    subtle: "_4cvx1elr _irr31d5g",
    none: "_4cvx3acm _irr318uv"
};
const $7747ff173c91dd60$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6d1elr _1dqonqa1 _syaz1fxt _80om1kdv _bfhk1j9a _srjtgir2",
    subtle: "_1h6d3acm _1dqonqa1 _syaz1fxt _80om1kdv _16hg18uv _srjtgir2",
    none: "_1h6d3acm _1dqoglyw _syaz1fxt _80om1kdv _16hg18uv _srjtgir2"
};
const $7747ff173c91dd60$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $7747ff173c91dd60$var$getMaxWidth = (width)=>!width ? `100%` : width in $7747ff173c91dd60$var$widthMap ? `${$7747ff173c91dd60$var$widthMap[width]}px` : `${+width}px`;
const $7747ff173c91dd60$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
const $7747ff173c91dd60$var$containerStyles = null;
const $7747ff173c91dd60$var$inputDisabledStyle = null;
const $7747ff173c91dd60$var$inputCompactStyleWithFg = null;
const $7747ff173c91dd60$var$inputCompactStyle = null;
const $7747ff173c91dd60$var$inputMonospacedStyle = null;
const $7747ff173c91dd60$var$inputFontStyleWithFG = null;
const $7747ff173c91dd60$var$inputStyleMonospacedWithFg = null;
const $7747ff173c91dd60$var$inputStyleNotDataCompactWithFG = null;
const $7747ff173c91dd60$var$inputStyle = null; /**
                          * __Textfield__
                          *
                          * A text field is an input that allows a user to write or edit text.
                          *
                          * - [Examples](https://atlassian.design/components/textfield/examples)
                          * - [Code](https://atlassian.design/components/textfield/code)
                          * - [Usage](https://atlassian.design/components/textfield/usage)
                          */ 
const $7747ff173c91dd60$var$Textfield = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $5uXOq.useRef)(null);
    const handleOnFocus = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$7747ff173c91dd60$var$analyticsParams
    });
    const handleOnBlur = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$7747ff173c91dd60$var$analyticsParams
    });
    const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${$7747ff173c91dd60$var$getMaxWidth(width)}`
        },
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c82smr _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnq1l7b",
            $7747ff173c91dd60$var$getContainerTextBgAndBorderColor[appearance],
            $7747ff173c91dd60$var$containerStyleAppearance[appearance],
            !isDisabled && $7747ff173c91dd60$var$focusWithinStyle[appearance],
            !isDisabled && $7747ff173c91dd60$var$hoverStyle[appearance],
            isDisabled && $7747ff173c91dd60$var$containerMedia.disabled,
            isDisabled && $7747ff173c91dd60$var$disabledStyle[appearance],
            isInvalid && $7747ff173c91dd60$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _10j7r01l",
            className
        ]),
        children: [
            elemBeforeInput,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ...spreadProps,
                "aria-invalid": isInvalid ? isInvalid : undefined,
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                "data-compact": isCompact ? isCompact : undefined,
                "data-ds--text-field--input": true,
                "data-monospaced": isMonospaced ? isMonospaced : undefined,
                "data-testid": testId,
                disabled: isDisabled,
                name: name,
                onBlur: handleOnBlur,
                onChange: onChange,
                onFocus: handleOnFocus,
                placeholder: placeholder,
                readOnly: isReadOnly,
                ref: setInputRef,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    "_19itidpf _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk18uv _syaz1kw7 _80om1kw7 _14jiu2gc _olc6u2gc _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr131l",
                    isMonospaced && "_ect41odn",
                    isCompact && "_85i51b66 _1q511b66 _y4ti12x7 _bozg12x7",
                    isDisabled && "_syaz1lh4 _1idr1lh4",
                    isDisabled && "_1fnx18qt",
                    !isCompact && (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') && "_14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
                    (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') && "_11c81ixg _1tn22smr",
                    isCompact && (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
                    isMonospaced && (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') && "_ect41odn _14md1odn"
                ])
            }),
            elemAfterInput
        ]
    });
});
var $7747ff173c91dd60$export$2e2bcd8739ae039 = $7747ff173c91dd60$var$Textfield;

});

parcelRegister("3senf", function(module, exports) {

$parcel$export(module.exports, "FlyoutMenuItem", () => $101497706e1552e9$export$34e3b4eaa687835);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8yr9w = parcelRequire("8yr9w");

var $jOvxk = parcelRequire("jOvxk");

var $bH54c = parcelRequire("bH54c");

var $4vWwj = parcelRequire("4vWwj");

var $1Nq4x = parcelRequire("1Nq4x");
const $101497706e1552e9$export$34e3b4eaa687835 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, isOpen: isOpenControlled, isDefaultOpen: isDefaultOpen = false, onOpenChange: onOpenChange }, forwardedRef)=>{
    const [isOpen, setIsOpen] = (0, $8yr9w.default)(isOpenControlled, ()=>isDefaultOpen);
    const previousIsOpen = (0, $jOvxk.default)(isOpen);
    (0, $5uXOq.useEffect)(()=>{
        if (previousIsOpen === undefined || previousIsOpen === isOpen) /**
				 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
				 *
				 * The previous value can be equal to the current one if the component re-renders due to something else changing.
				 *
				 * In both cases the value hasn't changed and we don't want to notify consumers.
				 */ return;
        onOpenChange?.(isOpen);
    }, [
        isOpen,
        onOpenChange,
        previousIsOpen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Nq4x.IsOpenContext).Provider, {
        value: isOpen,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Nq4x.SetIsOpenContext).Provider, {
            value: setIsOpen,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4vWwj.MenuListItem), {
                ref: forwardedRef,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bH54c.Popup), {
                    id: id,
                    isOpen: isOpen,
                    children: children
                })
            })
        })
    });
});

});
parcelRegister("bH54c", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $367eaae8c53fb3de$export$129a32eedafa97c5);
$parcel$export(module.exports, "PopupTrigger", () => $367eaae8c53fb3de$export$95d4acdbab2fc6ef);
$parcel$export(module.exports, "PopupContent", () => $367eaae8c53fb3de$export$2a2c7ba12d3231e3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $bKnKN = parcelRequire("bKnKN");

var $jJsBW = parcelRequire("jJsBW");

var $86D9T = parcelRequire("86D9T");

var $8Oct0 = parcelRequire("8Oct0");

var $7Ye64 = parcelRequire("7Ye64");
var $87gQG = parcelRequire("87gQG");

var $5g2iQ = parcelRequire("5g2iQ");

var $gS2FY = parcelRequire("gS2FY");

var $S4sWI = parcelRequire("S4sWI");

var $iuqDB = parcelRequire("iuqDB");
const $367eaae8c53fb3de$var$IsOpenContext = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const $367eaae8c53fb3de$var$IdContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $367eaae8c53fb3de$var$TriggerRefContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $367eaae8c53fb3de$var$SetTriggerRefContext = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $bKnKN.default));
const $367eaae8c53fb3de$var$EnsureIsInsidePopupContext = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
// Used to ensure popup sub-components are used within a Popup
// and provide a useful error message if not.
const $367eaae8c53fb3de$var$useEnsureIsInsidePopup = ()=>{
    const context = (0, $5uXOq.useContext)($367eaae8c53fb3de$var$EnsureIsInsidePopupContext);
    (0, $3joPi.default)(context, 'PopupTrigger and PopupContent components must be used within a Popup');
};
const $367eaae8c53fb3de$export$129a32eedafa97c5 = ({ children: children, id: providedId, isOpen: isOpen = false })=>{
    const [triggerRef, setTriggerRef] = (0, $5uXOq.useState)(null);
    const generatedId = (0, $jJsBW.useId)();
    const id = providedId || generatedId;
    return /*#__PURE__*/ (0, $2OMIu.jsx)($367eaae8c53fb3de$var$EnsureIsInsidePopupContext.Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($367eaae8c53fb3de$var$IdContext.Provider, {
            value: id,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($367eaae8c53fb3de$var$TriggerRefContext.Provider, {
                value: triggerRef,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($367eaae8c53fb3de$var$SetTriggerRefContext.Provider, {
                    value: setTriggerRef,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($367eaae8c53fb3de$var$IsOpenContext.Provider, {
                        value: isOpen,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Ye64.Manager), {
                            children: children
                        })
                    })
                })
            })
        })
    });
};
const $367eaae8c53fb3de$export$95d4acdbab2fc6ef = ({ children: children })=>{
    $367eaae8c53fb3de$var$useEnsureIsInsidePopup();
    const isOpen = (0, $5uXOq.useContext)($367eaae8c53fb3de$var$IsOpenContext);
    const id = (0, $5uXOq.useContext)($367eaae8c53fb3de$var$IdContext);
    const setTriggerRef = (0, $5uXOq.useContext)($367eaae8c53fb3de$var$SetTriggerRefContext);
    const getMergedTriggerRef = (0, $iuqDB.useGetMemoizedMergedTriggerRef)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $87gQG.Reference), {
        children: ({ ref: ref })=>children({
                ref: getMergedTriggerRef(ref, setTriggerRef, isOpen),
                'aria-controls': id,
                'aria-expanded': isOpen,
                'aria-haspopup': true
            })
    });
};
const $367eaae8c53fb3de$var$defaultLayer = 400;
/**
 * Disables popper.js GPU acceleration for this popup.
 * This means only positioning will be used, without any transforms.
 *
 * Performance will be degraded if the popup is expected to move.
 */ const $367eaae8c53fb3de$var$shouldDisableGpuAccelerationModifiers = [
    {
        name: 'computeStyles',
        options: {
            gpuAcceleration: false
        }
    }
];
const $367eaae8c53fb3de$export$2a2c7ba12d3231e3 = ({ xcss: xcss, appearance: inAppearance = 'default', children: children, boundary: boundary, offset: offset, strategy: strategy, onClose: onClose, testId: testId, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: popupComponent, autoFocus: autoFocus = true, zIndex: zIndex = $367eaae8c53fb3de$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: inShouldRenderToParent, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport, shouldDisableGpuAcceleration: shouldDisableGpuAcceleration = false })=>{
    $367eaae8c53fb3de$var$useEnsureIsInsidePopup();
    const isOpen = (0, $5uXOq.useContext)($367eaae8c53fb3de$var$IsOpenContext);
    const id = (0, $5uXOq.useContext)($367eaae8c53fb3de$var$IdContext);
    const triggerRef = (0, $5uXOq.useContext)($367eaae8c53fb3de$var$TriggerRefContext);
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $S4sWI.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const handleOpenLayerObserverCloseSignal = (0, $5uXOq.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    (0, $8Oct0.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal
    });
    if (!isOpen) return null;
    const popperWrapper = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $86D9T.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gS2FY.default), {
            xcss: xcss,
            appearance: appearance,
            content: children,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: popupComponent,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldFitContainer: shouldFitContainer,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldRenderToParent: shouldRenderToParent,
            shouldDisableFocusLock: shouldDisableFocusLock,
            triggerRef: triggerRef,
            strategy: strategy,
            shouldFitViewport: shouldFitViewport,
            modifiers: shouldDisableGpuAcceleration ? $367eaae8c53fb3de$var$shouldDisableGpuAccelerationModifiers : undefined
        })
    });
    if (shouldRenderToParent) return popperWrapper;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5g2iQ.default), {
        zIndex: zIndex,
        children: popperWrapper
    });
};

});


parcelRegister("l7Vqz", function(module, exports) {

$parcel$export(module.exports, "FlyoutMenuItemContent", () => $03f7b266799a3711$export$2ca9a13c57a8839a);
/* flyout-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bH54c = parcelRequire("bH54c");

var $1Nq4x = parcelRequire("1Nq4x");
const $03f7b266799a3711$var$flyoutMenuItemContentStyles = {
    root: "_1yt4u2gc _14b51kdj"
};
const $03f7b266799a3711$export$2ca9a13c57a8839a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, containerTestId: containerTestId, onClose: onClose, autoFocus: autoFocus }, forwardedRef)=>{
    const setIsOpen = (0, $5uXOq.useContext)((0, $1Nq4x.SetIsOpenContext));
    const handleClose = (0, $5uXOq.useCallback)(()=>{
        onClose?.();
        setIsOpen(false);
    }, [
        setIsOpen,
        onClose
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bH54c.PopupContent), {
        appearance: "UNSAFE_modal-below-sm",
        onClose: handleClose,
        placement: "right-start",
        shouldFitViewport: true,
        testId: containerTestId,
        xcss: $03f7b266799a3711$var$flyoutMenuItemContentStyles.root,
        autoFocus: autoFocus,
        /**
   * Disabling GPU acceleration removes the use of `transform` by popper.js for this popup.
   *
   * This allows makers to use popups with `shouldRenderToParent` inside the flyout.
   *
   * Without this, the `transform` makes the flyout the containing element for fixed positioning.
   * Because the flyout is also a scroll container then any nested, layered element is unable to
   * escape the flyout.
   *
   * Disabling the `transform` is the simplest way to resolve this layering issue,
   * and should have negligible performance impacts, because the flyout menus should rarely
   * need to be repositioned.
   */ shouldDisableGpuAcceleration: true,
        children: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: forwardedRef,
                children: children
            })
    });
});

});

parcelRegister("8luXP", function(module, exports) {

$parcel$export(module.exports, "FlyoutMenuItemTrigger", () => $513894c355a80def$export$9f59f399fe37b6ca);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cD7p8 = parcelRequire("cD7p8");

var $LD2gx = parcelRequire("LD2gx");

var $bH54c = parcelRequire("bH54c");

var $0yZbT = parcelRequire("0yZbT");

var $kTSv9 = parcelRequire("kTSv9");
const $513894c355a80def$export$9f59f399fe37b6ca = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, elemBefore: elemBefore, onClick: onClick, isSelected: isSelected, interactionName: interactionName, testId: testId, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef }, forwardedRef)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bH54c.PopupTrigger), {
        children: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kTSv9.MenuItemBase), {
                testId: testId,
                ref: (0, $cD7p8.default)([
                    ref,
                    forwardedRef
                ]),
                visualContentRef: visualContentRef,
                elemBefore: elemBefore,
                elemAfter: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                    paddingInline: "space.075",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($LD2gx))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    })
                }),
                onClick: onClick,
                ariaControls: ariaControls,
                ariaExpanded: ariaExpanded,
                ariaHasPopup: ariaHasPopup,
                interactionName: interactionName,
                isContentTooltipDisabled: isContentTooltipDisabled,
                isSelected: isSelected,
                children: children
            })
    }));

});





parcelRegister("iKHgp", function(module, exports) {

$parcel$export(module.exports, "useShouldRenderOverviews", () => $fb6128b9861df989$export$4ce95cd18a7f8574);

var $4R6GH = parcelRequire("4R6GH");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");
const $fb6128b9861df989$export$4ce95cd18a7f8574 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    if (!(0, $4R6GH.fg)('blu-2858-sidebar-menu-overviews')) return false;
    // JSW Premium does not have Overviews because it has the newer Plans feature available
    if (appEditions.software === (0, $ldyPw.PREMIUM_EDITION)) return false;
    // JWM Premium has Overviews if JSW Premium is not also present
    // Note: This means there are some cases where both the Plans and Overviews menu items will be available;
    // in these cases it's because the user should see the Plans upsell (that logic is taken care of within the Plans menu item)
    if (appEditions.core === (0, $ldyPw.PREMIUM_EDITION)) return true;
    // JSM Premium has Overviews if any edition of JWM is also present
    if (appEditions.serviceDesk === (0, $ldyPw.PREMIUM_EDITION) && (appEditions.core === (0, $ldyPw.FREE_EDITION) || appEditions.core === (0, $ldyPw.STANDARD_EDITION))) return true;
    return false;
};

});

parcelRegister("lz3si", function(module, exports) {

$parcel$export(module.exports, "Nav4Overviews", () => $dddda2f6dd48ba2b$export$2c62779314f9754a);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");


var $hWrpp = parcelRequire("hWrpp");
function $dddda2f6dd48ba2b$export$2c62779314f9754a(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-overviews"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "overviews-section",
        packageName: (0, $cdfe315557fc43d2$export$b8b9d90f9e5bd72b),
        teamName: (0, $cdfe315557fc43d2$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hWrpp.Nav4Overviews), props)));
}

});
const $cdfe315557fc43d2$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Overviews';
const $cdfe315557fc43d2$export$d57b6b390e78d90f = 'jira-cosmos';

parcelRegister("hWrpp", function(module, exports) {

$parcel$export(module.exports, "Nav4Overviews", () => $441eac7217d261af$export$2c62779314f9754a);

var $8tKjq = parcelRequire("8tKjq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $gQORo = parcelRequire("gQORo");

var $VgtWG = parcelRequire("VgtWG");

var $aKoWU = parcelRequire("aKoWU");
function $441eac7217d261af$export$2c62779314f9754a({ isExpanded: isExpanded, queryRef: queryRef }) {
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const data = (0, $8Uumt.useFragment)((0, $8tKjq.default), queryRef);
    const actionButtons = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gQORo.SectionActions), {
            totalCount: data?.jira?.jwmOverviews?.totalCount ?? 0
        }), [
        data?.jira?.jwmOverviews?.totalCount
    ]);
    return isInitialSelectedPath((0, $jhS4y.MENU_ID_OVERVIEWS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aKoWU.Nav4OverviewsForLanding), {
        isExpanded: isExpanded,
        queryRef: data,
        actionsOnHover: actionButtons
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $VgtWG.Nav4OverviewsDefault), {
        isExpanded: isExpanded,
        actionsOnHover: actionButtons
    });
}

});
parcelRegister("8tKjq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fc06df8a8701f9c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d103d7389206befab32513e4690206a4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3fc06df8a8701f9c$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "isOverviewsExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Overviews",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraWorkManagementGiraOverviewConnection",
                    "kind": "LinkedField",
                    "name": "jwmOverviews",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        }
                    ]
                }
            ]
        },
        {
            "condition": "isOverviewsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4OverviewsForLanding"
                }
            ]
        }
    ],
    "type": "Query"
};
$3fc06df8a8701f9c$var$node.hash = "49456eee5b5999aee543e784e4db7323";
var $3fc06df8a8701f9c$export$2e2bcd8739ae039 = $3fc06df8a8701f9c$var$node;

});

parcelRegister("gQORo", function(module, exports) {

$parcel$export(module.exports, "SectionActions", () => $782e3beee288b950$export$51f8029abf8c56ce);

var $5uXOq = parcelRequire("5uXOq");

var $c0tV6 = parcelRequire("c0tV6");

var $g7g8o = parcelRequire("g7g8o");

var $kW74I = parcelRequire("kW74I");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $6eFvr = parcelRequire("6eFvr");

var $5KCCi = parcelRequire("5KCCi");

var $7yUJn = parcelRequire("7yUJn");

var $koVbs = parcelRequire("koVbs");



var $ivGSs = parcelRequire("ivGSs");

var $i3a7M = parcelRequire("i3a7M");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $1xonH = parcelRequire("1xonH");

var $cDvOQ = parcelRequire("cDvOQ");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $92djE = parcelRequire("92djE");
function $782e3beee288b950$export$51f8029abf8c56ce({ totalCount: totalCount }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isOpen: isOpen, onClose: onClose, onOpen: onOpen, onToggle: onToggle } = (0, $cDvOQ.useOpenable)();
    const { sendCreateOverviewAnalyticsEvent: sendCreateOverviewAnalyticsEvent } = (0, $i3a7M.useOverviewsAnalyticsL1)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireOpenEvent = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_OVERVIEWS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: 'meatballDropdown'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onCreateOverviewHandler = (0, $5uXOq.useCallback)(()=>{
        sendCreateOverviewAnalyticsEvent({
            overviewLimitReached: false
        });
        onOpen();
    }, [
        onOpen,
        sendCreateOverviewAnalyticsEvent
    ]);
    const onToggleOverviewHandler = (0, $5uXOq.useCallback)(()=>{
        sendCreateOverviewAnalyticsEvent({
            overviewLimitReached: true
        });
        onToggle();
    }, [
        onToggle,
        sendCreateOverviewAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, totalCount < 10 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kW74I.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7yUJn.default), {
        onClose: onClose
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: formatMessage((0, $92djE.default).createOverview)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xonH.CommonNavMenuButton), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g7g8o))),
        label: formatMessage((0, $92djE.default).createOverview),
        onClick: onCreateOverviewHandler
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: onClose,
        placement: "right",
        messageId: "navigation-apps-sidebar-nav4-sidebars-content-overviews.common.ui.section-actions.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                padding: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
                space: "space.200",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c0tV6))), {
                spacing: "none",
                label: "",
                color: "var(--ds-icon-warning, #E56910)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, formatMessage((0, $92djE.default).moreThanTenWarning)))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
                content: formatMessage((0, $92djE.default).createOverview)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xonH.CommonNavMenuButton), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($g7g8o))),
                label: formatMessage((0, $92djE.default).createOverview),
                onClick: onToggleOverviewHandler,
                ...triggerProps
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($782e3beee288b950$var$MoreMenuItems, null),
        onOpen: fireOpenEvent
    }));
}
function $782e3beee288b950$var$MoreMenuItems() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
        menuId: (0, $46Cti.L1_MENU_ID).OVERVIEWS
    });
}

});
parcelRegister("7yUJn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb121a7f5478dbf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cm8b5 = parcelRequire("cm8b5");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $bTIks = parcelRequire("bTIks");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2eb121a7f5478dbf$var$LazyCreateOverviewModal = (0, $b7Svb.lazy)(()=>(parcelRequire("iiO8n")), {
    ssr: false,
    moduleId: "./src/packages/business/entity/overview/src/ui/create-overview-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2eb121a7f5478dbf$export$2e2bcd8739ae039 = ({ onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceErrorBoundary), {
        experience: (0, $bTIks.CREATE_OVERVIEW_EXPERIENCE),
        fallback: "unmount",
        shouldStartExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "overview-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2eb121a7f5478dbf$var$LazyCreateOverviewModal, {
        onClose: onClose
    })));

});
parcelRegister("cm8b5", function(module, exports) {

$parcel$export(module.exports, "useExperienceStart", () => $aca94fc714dddc77$export$675e0d25df38d426);
$parcel$export(module.exports, "useExperienceAbort", () => $aca94fc714dddc77$export$cc92b7ce453f4403);
$parcel$export(module.exports, "useExperienceSuccess", () => $aca94fc714dddc77$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceFail", () => $aca94fc714dddc77$export$606da7704d8eaf06);
$parcel$export(module.exports, "useQueryBasedViewAutomaticTracking", () => $aca94fc714dddc77$export$8ca25d6ff1437be3);
$parcel$export(module.exports, "ExperienceStart", () => $aca94fc714dddc77$export$f20b867e738a222c);
$parcel$export(module.exports, "ExperienceFailed", () => $aca94fc714dddc77$export$ae65a9e09c4516b3);
$parcel$export(module.exports, "ExperienceErrorBoundary", () => $aca94fc714dddc77$export$139c4a4ad101c3c5);
$parcel$export(module.exports, "ExperienceSuccess", () => $aca94fc714dddc77$export$4962f3898bd5c829);
$parcel$export(module.exports, "ExperienceAbort", () => $aca94fc714dddc77$export$c9b6bcd70239a39c);

var $5uXOq = parcelRequire("5uXOq");

var $8Wswo = parcelRequire("8Wswo");

var $j8DrX = parcelRequire("j8DrX");

var $4R6GH = parcelRequire("4R6GH");

var $8UpTw = parcelRequire("8UpTw");

var $7CMCs = parcelRequire("7CMCs");

var $jcw0u = parcelRequire("jcw0u");

var $8dXDG = parcelRequire("8dXDG");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $jJZqs = parcelRequire("jJZqs");
const $aca94fc714dddc77$export$675e0d25df38d426 = ({ experience: experience, experienceId: experienceId, packageName: packageName })=>(0, $kaHBi.useExperienceStart)({
        experience: experience,
        experienceId: experienceId,
        analyticsSource: packageName
    });
const $aca94fc714dddc77$export$cc92b7ce453f4403 = ({ experience: experience }, attributes)=>(0, $8dXDG.useExperienceAbort)({
        experience: experience,
        attributes: attributes
    });
const $aca94fc714dddc77$var$shard = (0, $j8DrX.default)('ajs-shard');
const $aca94fc714dddc77$var$region = (0, $j8DrX.default)('ajs-region');
const $aca94fc714dddc77$export$e94f0da4fc0603c6 = ({ experience: experience })=>(0, $3bQtK.useExperienceSuccess)({
        experience: experience,
        ...(0, $4R6GH.fg)('jira_list_experience_tracker_with_shard') ? {
            attributes: {
                shard: $aca94fc714dddc77$var$shard,
                region: $aca94fc714dddc77$var$region
            }
        } : {}
    });
const $aca94fc714dddc77$export$606da7704d8eaf06 = ({ experience: experience, experienceId: experienceId, packageName: packageName, teamName: teamName })=>{
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: experience,
        ...(0, $4R6GH.fg)('jira_list_experience_tracker_with_shard') ? {
            attributes: {
                shard: $aca94fc714dddc77$var$shard,
                region: $aca94fc714dddc77$var$region
            }
        } : {}
    });
    const onFail = (0, $5uXOq.useCallback)((location, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error, extraAttributes)=>{
        const relevantError = error?.networkError ?? error;
        if (relevantError instanceof (0, $jJZqs.ValidationError) && relevantError.message === '' && relevantError.errors.length) relevantError.message = relevantError.errors[0].error;
        extraAttributes !== undefined ? onExperienceFail(location, relevantError, extraAttributes) : onExperienceFail(location, relevantError);
        (0, $jcw0u.default)({
            meta: {
                id: `experience-tracker-${experienceId ?? experience}`,
                packageName: packageName,
                teamName: teamName
            },
            attributes: {
                location: location
            },
            error: relevantError,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onExperienceFail,
        experienceId,
        experience,
        packageName,
        teamName
    ]);
    return onFail;
};
const $aca94fc714dddc77$export$8ca25d6ff1437be3 = (experience, { loading: loading, error: error, shouldStartExperience: shouldStartExperience })=>{
    const [hasStarted, setHasStarted] = (0, $5uXOq.useState)(loading);
    const [hasCompleted, setHasCompleted] = (0, $5uXOq.useState)(false);
    const [hasExperienceBeenTracked, setHasExperienceBeenTracked] = (0, $5uXOq.useState)(false);
    const startExperience = $aca94fc714dddc77$export$675e0d25df38d426(experience);
    const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
    const onSuccess = $aca94fc714dddc77$export$e94f0da4fc0603c6(experience);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldStartExperience === true) startExperience();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldStartExperience
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasStarted === false && loading === true) setHasStarted(true);
        if (hasStarted === true && loading === false) {
            setHasCompleted(true);
            setHasExperienceBeenTracked(false);
        }
    }, [
        hasStarted,
        loading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasCompleted && !hasExperienceBeenTracked) {
            // make sure experience is tracked once despite re-rendering of the view
            setHasExperienceBeenTracked(true);
            if (typeof error !== 'undefined') {
                onFail(`${experience.experience} ${experience.experienceId || ''} useEffect error handling`, error, (0, $8Wswo.getGraphqlErrorAttributes)(error));
                return;
            }
            onSuccess({
                loaded: true
            });
        }
    }, [
        error,
        experience,
        hasCompleted,
        hasExperienceBeenTracked,
        onFail,
        onSuccess
    ]);
};
const $aca94fc714dddc77$export$f20b867e738a222c = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience })=>{
    const start = $aca94fc714dddc77$export$675e0d25df38d426(experience);
    (0, $5uXOq.useEffect)(()=>{
        start();
    }, [
        start
    ]);
    return null;
});
const $aca94fc714dddc77$export$ae65a9e09c4516b3 = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, error: error, attributes: attributes })=>{
    const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
    (0, $5uXOq.useEffect)(()=>{
        onFail(experience.experience, error, attributes);
    }, [
        attributes,
        error,
        experience,
        onFail
    ]);
    return null;
});
const $aca94fc714dddc77$export$139c4a4ad101c3c5 = ({ experience: experience, shouldStartExperience: shouldStartExperience, fallback: fallback = (0, $8UpTw.ErrorPage), children: children })=>{
    const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: experience.packageName,
        teamName: experience.teamName,
        id: experience.experience,
        onError: onFail,
        fallback: fallback
    }, shouldStartExperience === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aca94fc714dddc77$export$f20b867e738a222c, {
        experience: experience
    }), children);
};
const $aca94fc714dddc77$export$4962f3898bd5c829 = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: experience.experience,
        attributes: {
            ...experience.experienceId == null ? undefined : {
                experienceId: experience.experienceId
            },
            ...attributes
        }
    }));
const $aca94fc714dddc77$export$c9b6bcd70239a39c = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, error: error })=>{
    const onAbort = $aca94fc714dddc77$export$cc92b7ce453f4403(experience);
    (0, $5uXOq.useEffect)(()=>{
        onAbort(experience.experience, {
            error: error.message
        });
    }, [
        error,
        experience,
        onAbort
    ]);
    return null;
});

});
parcelRegister("8Wswo", function(module, exports) {

$parcel$export(module.exports, "shouldHandleTheError", () => $6f94bc39289ec711$export$47770c8b6d645cdb);
$parcel$export(module.exports, "getGraphqlErrorAttributes", () => $6f94bc39289ec711$export$b19e649eafc62480);

var $e3a3O = parcelRequire("e3a3O");
const $6f94bc39289ec711$var$errorWhitelist = [
    'EXPERIENCE_UNAVAILABLE',
    'FIELD_UNAVAILABLE',
    'ISSUE_UNAVAILABLE'
];
const $6f94bc39289ec711$export$47770c8b6d645cdb = (error)=>{
    if (error?.networkError) return true;
    // when issue links are disabled at the instance level and we request it, it throws an error but we still get the whole response
    // There is a issue links perm check that happens after loading the list so the UI already deals with this properly and we can ignore it
    // similarly, even when issue links are enabled, but the field itself is hidden in every screen it will throw an error but we'll still get the whole response
    const filterIssueLinksDisabledErrors = (graphQLError)=>{
        const isWhitelisted = $6f94bc39289ec711$var$errorWhitelist.includes(graphQLError?.extensions?.errorType);
        return !isWhitelisted;
    };
    const errorsToShow = (error?.graphQLErrors || []).filter(filterIssueLinksDisabledErrors);
    return errorsToShow.length > 0;
};
const $6f94bc39289ec711$export$b19e649eafc62480 = (error)=>{
    const isApolloError = error instanceof (0, $e3a3O.ApolloError);
    if (!isApolloError) return {};
    const getErrorAttribute = (graphQLErrors, errorAttribute)=>{
        const errors = graphQLErrors.map((graphQLError)=>graphQLError?.extensions?.[errorAttribute]).filter(Boolean);
        return JSON.stringify(errors);
    };
    return {
        statusCodes: getErrorAttribute(error?.graphQLErrors || [], 'statusCode'),
        errorTypes: getErrorAttribute(error?.graphQLErrors || [], 'errorType')
    };
};

});
parcelRegister("e3a3O", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $02a3c2aebc919401$export$bd096ddbd246c79c);
$parcel$export(module.exports, "isApolloError", () => $02a3c2aebc919401$export$17f5e6bd290bb15d);
$parcel$export(module.exports, "ApolloError", () => $02a3c2aebc919401$export$26a337512320b8c6);
$parcel$export(module.exports, "ApolloClient", () => $02a3c2aebc919401$export$13f5a5f0f1dbab88);
$parcel$export(module.exports, "default", () => $02a3c2aebc919401$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");
var $bqMzA = parcelRequire("bqMzA");

var $clSzL = parcelRequire("clSzL");
var $aS6b9 = parcelRequire("aS6b9");

var $ebaCz = parcelRequire("ebaCz");

var $1DiV8 = parcelRequire("1DiV8");

var $12QNw = parcelRequire("12QNw");
var $02a3c2aebc919401$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($02a3c2aebc919401$export$bd096ddbd246c79c || ($02a3c2aebc919401$export$bd096ddbd246c79c = {}));
function $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $02a3c2aebc919401$var$Observable = function(_super) {
    (0, $3VFsf.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $ebaCz.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $aS6b9.default));
function $02a3c2aebc919401$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $02a3c2aebc919401$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $02a3c2aebc919401$var$generateErrorMessage = function(err) {
    var message = '';
    if ($02a3c2aebc919401$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $02a3c2aebc919401$export$26a337512320b8c6 = function(_super) {
    (0, $3VFsf.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $02a3c2aebc919401$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $02a3c2aebc919401$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($02a3c2aebc919401$export$160bafb6ac1e0641 || ($02a3c2aebc919401$export$160bafb6ac1e0641 = {}));
var $02a3c2aebc919401$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $02a3c2aebc919401$export$6c1b56eac59c9584 = function(_super) {
    (0, $3VFsf.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $jojW6.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($02a3c2aebc919401$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $02a3c2aebc919401$export$bd096ddbd246c79c.loading : $02a3c2aebc919401$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            stale: false
        }));
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $bqMzA.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $1DiV8.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $bqMzA.equal)(this.variables, variables)) this.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.variables), variables);
        if (!(0, $bqMzA.equal)(this.options.variables, this.variables)) this.options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $02a3c2aebc919401$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $1DiV8.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $02a3c2aebc919401$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $bqMzA.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $jojW6.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $jojW6.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $bqMzA.equal)(previousVariables, variables)) _this.refetch();
                        else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($02a3c2aebc919401$var$Observable);
function $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback(error) {}
function $02a3c2aebc919401$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $1DiV8.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $02a3c2aebc919401$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $02a3c2aebc919401$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $1DiV8.invariant)(!previousQuery || previousQuery.document === query.document || (0, $bqMzA.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.loading) {
            if (!(0, $bqMzA.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.refetch;
        else networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $02a3c2aebc919401$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $02a3c2aebc919401$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $jojW6.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $jojW6.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            return (0, $3VFsf.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $jojW6.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $jojW6.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $1DiV8.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            return (0, $3VFsf.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $3VFsf.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $12QNw.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $12QNw.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $jojW6.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $3VFsf.__generator)(this, function(_b) {
                mainDefinition = (0, $jojW6.getMainDefinition)(document);
                fragments = (0, $jojW6.getFragmentDefinitions)(document);
                fragmentMap = (0, $jojW6.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $02a3c2aebc919401$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $3VFsf.__generator)(this, function(_a) {
                            if (!(0, $jojW6.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $jojW6.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $jojW6.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $1DiV8.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $jojW6.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $jojW6.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $jojW6.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $02a3c2aebc919401$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $02a3c2aebc919401$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $02a3c2aebc919401$var$asyncMap(observable, mapFn) {
    return new $02a3c2aebc919401$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $02a3c2aebc919401$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $02a3c2aebc919401$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $02a3c2aebc919401$var$MutationStore();
        this.queryStore = new $02a3c2aebc919401$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $jojW6.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $02a3c2aebc919401$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $1DiV8.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $1DiV8.invariant)(mutation, 9);
                        (0, $1DiV8.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $02a3c2aebc919401$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $jojW6.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $02a3c2aebc919401$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($02a3c2aebc919401$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $jojW6.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $jojW6.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($02a3c2aebc919401$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $02a3c2aebc919401$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $02a3c2aebc919401$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $jojW6.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $jojW6.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $jojW6.getDefaultValues)((0, $jojW6.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $1DiV8.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $3VFsf.__assign)({}, options);
        return new $02a3c2aebc919401$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $1DiV8.invariant)(options.query, 12);
        (0, $1DiV8.invariant)(options.query.kind === 'Document', 13);
        (0, $1DiV8.invariant)(!options.returnPartialData, 14);
        (0, $1DiV8.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $1DiV8.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $jojW6.graphQLResultHasError)(result)) throw new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $02a3c2aebc919401$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $1DiV8.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $jojW6.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $02a3c2aebc919401$var$multiplex((0, $clSzL.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $02a3c2aebc919401$var$multiplex((0, $clSzL.execute)(link, operation));
        } else {
            observable = $02a3c2aebc919401$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $02a3c2aebc919401$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(result.errors)) return reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.ready && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $1DiV8.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $02a3c2aebc919401$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $02a3c2aebc919401$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $jojW6.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $jojW6.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $jojW6.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $jojW6.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $jojW6.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $jojW6.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $jojW6.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $02a3c2aebc919401$var$version = "2.6.10";
var $02a3c2aebc919401$var$hasSuggestedDevtools = false;
var $02a3c2aebc919401$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $clSzL.ApolloLink).empty();
        if (!link || !cache) throw new (0, $1DiV8.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $02a3c2aebc919401$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $02a3c2aebc919401$var$version;
        this.localState = new $02a3c2aebc919401$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $02a3c2aebc919401$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.query), options);
        (0, $1DiV8.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $clSzL.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $02a3c2aebc919401$export$2e2bcd8739ae039 = $02a3c2aebc919401$export$13f5a5f0f1dbab88;

});
parcelRegister("jojW6", function(module, exports) {

$parcel$export(module.exports, "storeKeyNameFromField", () => $e1dfb923a27ca793$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $e1dfb923a27ca793$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $e1dfb923a27ca793$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $e1dfb923a27ca793$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $e1dfb923a27ca793$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $e1dfb923a27ca793$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $e1dfb923a27ca793$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $e1dfb923a27ca793$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $e1dfb923a27ca793$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $e1dfb923a27ca793$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $e1dfb923a27ca793$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $e1dfb923a27ca793$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $e1dfb923a27ca793$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $e1dfb923a27ca793$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $e1dfb923a27ca793$export$e6e34fd1f2686227);
$parcel$export(module.exports, "checkDocument", () => $e1dfb923a27ca793$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $e1dfb923a27ca793$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $e1dfb923a27ca793$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $e1dfb923a27ca793$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $e1dfb923a27ca793$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $e1dfb923a27ca793$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $e1dfb923a27ca793$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $e1dfb923a27ca793$export$84c19026e616569e);
$parcel$export(module.exports, "removeDirectivesFromDocument", () => $e1dfb923a27ca793$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $e1dfb923a27ca793$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $e1dfb923a27ca793$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $e1dfb923a27ca793$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $e1dfb923a27ca793$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $e1dfb923a27ca793$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $e1dfb923a27ca793$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $e1dfb923a27ca793$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $e1dfb923a27ca793$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $e1dfb923a27ca793$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $e1dfb923a27ca793$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $e1dfb923a27ca793$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $e1dfb923a27ca793$export$160070228be94b08);

var $12QNw = parcelRequire("12QNw");

var $1DiV8 = parcelRequire("1DiV8");

var $3VFsf = parcelRequire("3VFsf");

var $fkrBp = parcelRequire("fkrBp");

var $bqMzA = parcelRequire("bqMzA");

var $6cAn5 = parcelRequire("6cAn5");
function $e1dfb923a27ca793$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $e1dfb923a27ca793$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $e1dfb923a27ca793$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $e1dfb923a27ca793$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $e1dfb923a27ca793$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $e1dfb923a27ca793$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $e1dfb923a27ca793$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $e1dfb923a27ca793$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $e1dfb923a27ca793$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $e1dfb923a27ca793$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $e1dfb923a27ca793$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($e1dfb923a27ca793$var$isIntValue(value) || $e1dfb923a27ca793$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($e1dfb923a27ca793$var$isBooleanValue(value) || $e1dfb923a27ca793$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($e1dfb923a27ca793$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($e1dfb923a27ca793$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($e1dfb923a27ca793$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($e1dfb923a27ca793$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($e1dfb923a27ca793$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $1DiV8.InvariantError)(17);
}
function $e1dfb923a27ca793$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $e1dfb923a27ca793$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $e1dfb923a27ca793$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $e1dfb923a27ca793$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $e1dfb923a27ca793$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($fkrBp)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($e1dfb923a27ca793$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $e1dfb923a27ca793$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $e1dfb923a27ca793$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $e1dfb923a27ca793$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $e1dfb923a27ca793$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $3VFsf.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $e1dfb923a27ca793$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $e1dfb923a27ca793$var$defaultValueFromVariable(node) {
    throw new (0, $1DiV8.InvariantError)(18);
}
function $e1dfb923a27ca793$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $e1dfb923a27ca793$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $e1dfb923a27ca793$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $e1dfb923a27ca793$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $e1dfb923a27ca793$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $e1dfb923a27ca793$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $e1dfb923a27ca793$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $1DiV8.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $e1dfb923a27ca793$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $12QNw.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $e1dfb923a27ca793$export$2dafb573e282fe8d(names, doc) {
    return $e1dfb923a27ca793$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $e1dfb923a27ca793$export$8d1e9e5bbfa5d09a(document) {
    return document && $e1dfb923a27ca793$export$2dafb573e282fe8d([
        'client'
    ], document) && $e1dfb923a27ca793$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $e1dfb923a27ca793$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($e1dfb923a27ca793$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $1DiV8.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $1DiV8.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $1DiV8.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $e1dfb923a27ca793$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $1DiV8.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, document), {
        definitions: (0, $3VFsf.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $e1dfb923a27ca793$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $e1dfb923a27ca793$export$a92e7a440b22bdf0(doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $1DiV8.invariant)(mutationDef, 1);
    return mutationDef;
}
function $e1dfb923a27ca793$export$a7d0d8111d2386df(doc) {
    (0, $1DiV8.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(3);
        return definition;
    });
    (0, $1DiV8.invariant)(operations.length <= 1, 4);
    return doc;
}
function $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $e1dfb923a27ca793$export$78a8e95d8d43ad7f(document) {
    var def = $e1dfb923a27ca793$export$7a5b1fa979d2c158(document);
    (0, $1DiV8.invariant)(def, 5);
    return def;
}
function $e1dfb923a27ca793$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $e1dfb923a27ca793$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $e1dfb923a27ca793$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc);
    (0, $1DiV8.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $e1dfb923a27ca793$export$772111caef41b3f5(doc) {
    (0, $1DiV8.invariant)(doc.kind === 'Document', 7);
    (0, $1DiV8.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $1DiV8.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $e1dfb923a27ca793$export$f431198736b7f96d(queryDoc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $1DiV8.InvariantError)(10);
}
function $e1dfb923a27ca793$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $e1dfb923a27ca793$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $e1dfb923a27ca793$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $e1dfb923a27ca793$export$e6e34fd1f2686227.apply(void 0, (0, $3VFsf.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $e1dfb923a27ca793$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $e1dfb923a27ca793$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $e1dfb923a27ca793$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $e1dfb923a27ca793$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $e1dfb923a27ca793$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $e1dfb923a27ca793$var$nullIfDocIsEmpty(doc) {
    return $e1dfb923a27ca793$var$isEmpty($e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) || $e1dfb923a27ca793$export$772111caef41b3f5(doc), $e1dfb923a27ca793$export$193789b4c8246dd4($e1dfb923a27ca793$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $e1dfb923a27ca793$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $e1dfb923a27ca793$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($e1dfb923a27ca793$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $e1dfb923a27ca793$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $e1dfb923a27ca793$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $e1dfb923a27ca793$export$43b332f87950a467(doc) {
    return (0, $12QNw.visit)($e1dfb923a27ca793$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($e1dfb923a27ca793$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    selections: (0, $3VFsf.__spreadArrays)(selections, [
                        $e1dfb923a27ca793$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $e1dfb923a27ca793$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $e1dfb923a27ca793$export$74985f3324559867(doc) {
    return $e1dfb923a27ca793$export$e5ae0530da5fe96c([
        $e1dfb923a27ca793$var$connectionRemoveConfig
    ], $e1dfb923a27ca793$export$a7d0d8111d2386df(doc));
}
function $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$e1dfb923a27ca793$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives)) || nestedCheck && $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $e1dfb923a27ca793$export$deed3420cb5d2e1d(directives, doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $e1dfb923a27ca793$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $e1dfb923a27ca793$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $e1dfb923a27ca793$var$getArgumentMatcher(config);
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $e1dfb923a27ca793$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($e1dfb923a27ca793$export$fb56ad75dd311c12(selection) || $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $e1dfb923a27ca793$export$57c368c23873f32b(document) {
    var definition = $e1dfb923a27ca793$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $12QNw.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $e1dfb923a27ca793$export$8eae69e876ee321e(document) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(document);
    var modifiedDoc = $e1dfb923a27ca793$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $12QNw.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $e1dfb923a27ca793$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $e1dfb923a27ca793$var$toString = Object.prototype.toString;
function $e1dfb923a27ca793$export$629a2bd3f5a49ecc(value) {
    return $e1dfb923a27ca793$var$cloneDeepHelper(value, new Map());
}
function $e1dfb923a27ca793$var$cloneDeepHelper(val, seen) {
    switch($e1dfb923a27ca793$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $e1dfb923a27ca793$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $e1dfb923a27ca793$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() {
    if (typeof $6cAn5 !== 'undefined' && "production") return "production";
    return 'development';
}
function $e1dfb923a27ca793$export$f0cb0fda19c18b37(env) {
    return $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() === env;
}
function $e1dfb923a27ca793$export$f15d00aa73aafac4() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('production') === true;
}
function $e1dfb923a27ca793$export$df77466336fe5355() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('development') === true;
}
function $e1dfb923a27ca793$export$410cbc2864fa25b5() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('test') === true;
}
function $e1dfb923a27ca793$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $e1dfb923a27ca793$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $e1dfb923a27ca793$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $e1dfb923a27ca793$var$deepFreeze(o[prop]);
    });
    return o;
}
function $e1dfb923a27ca793$export$7f9c177735b71f18(obj) {
    if ($e1dfb923a27ca793$export$df77466336fe5355() || $e1dfb923a27ca793$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $e1dfb923a27ca793$var$deepFreeze(obj);
    }
    return obj;
}
var $e1dfb923a27ca793$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e1dfb923a27ca793$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $e1dfb923a27ca793$export$160070228be94b08(sources);
}
function $e1dfb923a27ca793$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $e1dfb923a27ca793$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $e1dfb923a27ca793$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $e1dfb923a27ca793$var$mergeHelper(target, source, pastCopies) {
    if ($e1dfb923a27ca793$var$isObject(source) && $e1dfb923a27ca793$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($e1dfb923a27ca793$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $e1dfb923a27ca793$var$mergeHelper($e1dfb923a27ca793$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $e1dfb923a27ca793$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $3VFsf.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $e1dfb923a27ca793$var$haveWarned = Object.create({});
function $e1dfb923a27ca793$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$e1dfb923a27ca793$export$f15d00aa73aafac4() && !$e1dfb923a27ca793$var$haveWarned[msg]) {
        if (!$e1dfb923a27ca793$export$410cbc2864fa25b5()) $e1dfb923a27ca793$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $e1dfb923a27ca793$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("1DiV8", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $13081c324be1f9ab$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $13081c324be1f9ab$export$f5708dca728d7177);

var $3VFsf = parcelRequire("3VFsf");

var $6cAn5 = parcelRequire("6cAn5");
var $13081c324be1f9ab$var$genericMessage = "Invariant Violation";
var $13081c324be1f9ab$var$_a = Object.setPrototypeOf, $13081c324be1f9ab$var$setPrototypeOf = $13081c324be1f9ab$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $13081c324be1f9ab$var$_a;
var $13081c324be1f9ab$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $13081c324be1f9ab$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $13081c324be1f9ab$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $13081c324be1f9ab$var$genericMessage;
        $13081c324be1f9ab$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $13081c324be1f9ab$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $13081c324be1f9ab$export$cea12affaee22fe8(message);
}
function $13081c324be1f9ab$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $13081c324be1f9ab$var$wrapConsoleMethod("warn");
    invariant.error = $13081c324be1f9ab$var$wrapConsoleMethod("error");
})($13081c324be1f9ab$export$f5708dca728d7177 || ($13081c324be1f9ab$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $13081c324be1f9ab$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $6cAn5 === "object") $13081c324be1f9ab$export$e54fe5b0f43758f7 = $6cAn5;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($13081c324be1f9ab$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $13081c324be1f9ab$var$invariant$1 = $13081c324be1f9ab$export$f5708dca728d7177;
var $13081c324be1f9ab$export$2e2bcd8739ae039 = $13081c324be1f9ab$var$invariant$1;

});

parcelRegister("fkrBp", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("bqMzA", function(module, exports) {

$parcel$export(module.exports, "equal", () => $8527cd05038b1b96$export$411ce8e5a71e3069);
var $8527cd05038b1b96$var$_a = Object.prototype, $8527cd05038b1b96$var$toString = $8527cd05038b1b96$var$_a.toString, $8527cd05038b1b96$var$hasOwnProperty = $8527cd05038b1b96$var$_a.hasOwnProperty;
var $8527cd05038b1b96$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $8527cd05038b1b96$export$411ce8e5a71e3069(a, b) {
    try {
        return $8527cd05038b1b96$var$check(a, b);
    } finally{
        $8527cd05038b1b96$var$previousComparisons.clear();
    }
}
function $8527cd05038b1b96$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $8527cd05038b1b96$var$toString.call(a);
    var bTag = $8527cd05038b1b96$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$8527cd05038b1b96$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$8527cd05038b1b96$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$8527cd05038b1b96$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $8527cd05038b1b96$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $8527cd05038b1b96$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $8527cd05038b1b96$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $8527cd05038b1b96$export$2e2bcd8739ae039 = $8527cd05038b1b96$export$411ce8e5a71e3069;

});


parcelRegister("clSzL", function(module, exports) {

$parcel$export(module.exports, "makePromise", () => makePromise);
$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "from", () => from);
$parcel$export(module.exports, "split", () => split);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("aS6b9")).default);

var $aS6b9 = parcelRequire("aS6b9");

var $1DiV8 = parcelRequire("1DiV8");

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $1DiV8.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $3VFsf.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $aS6b9.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $aS6b9.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $jojW6.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $3VFsf.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $3VFsf.__assign)({}, context, next(context));
        else context = (0, $3VFsf.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $3VFsf.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $aS6b9.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $aS6b9.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $aS6b9.default).of() : rightLink.request(operation) || (0, $aS6b9.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $aS6b9.default).of() : rightLink.request(operation, forward) || (0, $aS6b9.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $aS6b9.default).of();
        }) || (0, $aS6b9.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $aS6b9.default).of();
        }) || (0, $aS6b9.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $1DiV8.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $aS6b9.default).of();
}

});
parcelRegister("aS6b9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ea3bd7f736c1eb4$export$2e2bcd8739ae039);

var $4osjv = parcelRequire("4osjv");
var $7ea3bd7f736c1eb4$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($4osjv)));
var $7ea3bd7f736c1eb4$export$2e2bcd8739ae039 = $7ea3bd7f736c1eb4$export$77cea355fa80b5f4;

});
parcelRegister("4osjv", function(module, exports) {

module.exports = (parcelRequire("k0hXK")).Observable;

});
parcelRegister("k0hXK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $e901bdc1c9a5edd7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e901bdc1c9a5edd7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e901bdc1c9a5edd7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $e901bdc1c9a5edd7$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $e901bdc1c9a5edd7$var$hasSymbol = function(name) {
    return $e901bdc1c9a5edd7$var$hasSymbols() && Boolean(Symbol[name]);
};
var $e901bdc1c9a5edd7$var$getSymbol = function(name) {
    return $e901bdc1c9a5edd7$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($e901bdc1c9a5edd7$var$hasSymbols() && !$e901bdc1c9a5edd7$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $e901bdc1c9a5edd7$var$SymbolIterator = $e901bdc1c9a5edd7$var$getSymbol('iterator');
var $e901bdc1c9a5edd7$var$SymbolObservable = $e901bdc1c9a5edd7$var$getSymbol('observable');
var $e901bdc1c9a5edd7$var$SymbolSpecies = $e901bdc1c9a5edd7$var$getSymbol('species'); // === Abstract Operations ===
function $e901bdc1c9a5edd7$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $e901bdc1c9a5edd7$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$e901bdc1c9a5edd7$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $e901bdc1c9a5edd7$var$Observable;
}
function $e901bdc1c9a5edd7$var$isObservable(x) {
    return x instanceof $e901bdc1c9a5edd7$var$Observable; // SPEC: Brand check
}
function $e901bdc1c9a5edd7$var$hostReportError(e) {
    if ($e901bdc1c9a5edd7$var$hostReportError.log) $e901bdc1c9a5edd7$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $e901bdc1c9a5edd7$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $e901bdc1c9a5edd7$var$hostReportError(e);
        }
    });
}
function $e901bdc1c9a5edd7$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $e901bdc1c9a5edd7$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $e901bdc1c9a5edd7$var$hostReportError(e);
    }
}
function $e901bdc1c9a5edd7$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $e901bdc1c9a5edd7$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $e901bdc1c9a5edd7$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $e901bdc1c9a5edd7$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $e901bdc1c9a5edd7$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $e901bdc1c9a5edd7$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $e901bdc1c9a5edd7$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $e901bdc1c9a5edd7$var$enqueue(function() {
            return $e901bdc1c9a5edd7$var$flushSubscription(subscription);
        });
        return;
    }
    $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value);
}
var $e901bdc1c9a5edd7$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $e901bdc1c9a5edd7$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $e901bdc1c9a5edd7$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $e901bdc1c9a5edd7$var$closeSubscription(this);
                    $e901bdc1c9a5edd7$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $e901bdc1c9a5edd7$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $e901bdc1c9a5edd7$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $e901bdc1c9a5edd7$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $e901bdc1c9a5edd7$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $e901bdc1c9a5edd7$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $e901bdc1c9a5edd7$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($e901bdc1c9a5edd7$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($e901bdc1c9a5edd7$var$hasSymbol('iterator')) {
                    method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $e901bdc1c9a5edd7$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $e901bdc1c9a5edd7$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $e901bdc1c9a5edd7$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $e901bdc1c9a5edd7$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $e901bdc1c9a5edd7$var$Observable;
if ($e901bdc1c9a5edd7$var$hasSymbols()) Object.defineProperty($e901bdc1c9a5edd7$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $e901bdc1c9a5edd7$var$SymbolObservable,
        hostReportError: $e901bdc1c9a5edd7$var$hostReportError
    },
    configurable: true
});

});






parcelRegister("8UpTw", function(module, exports) {

$parcel$export(module.exports, "ErrorPage", () => $5a72c35b5a5b98e9$export$c120a0e80fd44ca6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $beRD7 = parcelRequire("beRD7");
const $5a72c35b5a5b98e9$export$c120a0e80fd44ca6 = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5a72c35b5a5b98e9$var$ErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.JSErrorPageAsync), {
        error: error
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5a72c35b5a5b98e9$var$ErrorWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhkvuon _syaz1fxt",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8dXDG", function(module, exports) {

$parcel$export(module.exports, "useExperienceAbort", () => $2df1decadd95b490$export$cc92b7ce453f4403);

var $5uXOq = parcelRequire("5uXOq");

var $l9g16 = parcelRequire("l9g16");
const $2df1decadd95b490$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $l9g16.useExperienceContext)();
    const self = (0, $5uXOq.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $5uXOq.useCallback)((reason, extraAttributes = {})=>{
        const { current: current } = self;
        current.experienceTracker.abort({
            name: current.name,
            reason: reason,
            attributes: {
                ...current.attributes,
                ...extraAttributes
            }
        });
    }, [
        self
    ]);
};

});


parcelRegister("bTIks", function(module, exports) {

$parcel$export(module.exports, "CREATE_OVERVIEW_EXPERIENCE", () => $43e56627abfe9003$export$9b5e8e07ff330ef2);
$parcel$export(module.exports, "EDIT_OVERVIEW_EXPERIENCE", () => $43e56627abfe9003$export$a58227116ceb8b81);
$parcel$export(module.exports, "DELETE_OVERVIEW_EXPERIENCE", () => $43e56627abfe9003$export$e17a11e4247a14f7);
$parcel$export(module.exports, "MODAL_WIDTH", () => $43e56627abfe9003$export$3d931b64f46140b3);

var $gwIPs = parcelRequire("gwIPs");
const $43e56627abfe9003$var$PACKAGE_NAME = 'jiraBusinessEntityOverview';
const $43e56627abfe9003$export$9b5e8e07ff330ef2 = {
    experience: 'create-overview',
    packageName: $43e56627abfe9003$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $43e56627abfe9003$export$a58227116ceb8b81 = {
    experience: 'edit-overview',
    packageName: $43e56627abfe9003$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $43e56627abfe9003$export$e17a11e4247a14f7 = {
    experience: 'delete-overview',
    packageName: $43e56627abfe9003$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $43e56627abfe9003$export$d03d4e78ea5b909a = (0, $gwIPs.gridSize) * 2;
const $43e56627abfe9003$export$57ee5df6bad94642 = 400;
const $43e56627abfe9003$export$7c9c92ba6b198ac4 = (0, $gwIPs.gridSize) * 3;
const $43e56627abfe9003$export$c4232794452dc6e3 = 480;
const $43e56627abfe9003$export$3d931b64f46140b3 = $43e56627abfe9003$export$c4232794452dc6e3 + $43e56627abfe9003$export$57ee5df6bad94642 + $43e56627abfe9003$export$7c9c92ba6b198ac4 * 2 + $43e56627abfe9003$export$d03d4e78ea5b909a * 2;
const $43e56627abfe9003$var$MODAL_DIALOG_MARGIN = 120;
const $43e56627abfe9003$export$68bc124b0fa13de0 = $43e56627abfe9003$export$3d931b64f46140b3 + $43e56627abfe9003$var$MODAL_DIALOG_MARGIN;

});

parcelRegister("iiO8n", function(module, exports) {

let $d530cc06213c875b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d530cc06213c875b$var$load("h2MrD"),
    $d530cc06213c875b$var$load("bYT2S"),
    $d530cc06213c875b$var$load("hPzOn"),
    $d530cc06213c875b$var$load("7Thkj")
]).then(()=>parcelRequire('6gB2z'));

});


parcelRegister("i3a7M", function(module, exports) {

$parcel$export(module.exports, "useOverviewsAnalyticsL1", () => $2236103400b31729$export$209953a8bcc0c02c);

var $5uXOq = parcelRequire("5uXOq");






var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");
const $2236103400b31729$var$OVERVIEWS_NAVIGATION_MENU_ITEM = 'overviewsNavigationMenuItem';
const $2236103400b31729$export$209953a8bcc0c02c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const commonAttributes = (0, $5uXOq.useMemo)(()=>({
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22)
        }), []);
    // fixed item - create overview (+) button on overviews menu (top level)
    const sendCreateOverviewAnalyticsEvent = (0, $5uXOq.useCallback)(({ overviewLimitReached: overviewLimitReached })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
            itemId: 'createOverview',
            overviewLimitReached: overviewLimitReached
        };
        (0, $8zOmE.fireUIAnalytics)(event, $2236103400b31729$var$OVERVIEWS_NAVIGATION_MENU_ITEM, attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // custom item - overview menu item that displays overview name (can be expandable menu or a link)
    const sendOverviewMenuItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ overviewId: overviewId })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
            itemType: (0, $632bd8725b437a12$export$9cbb0f231a0ab7ea),
            itemId: overviewId
        };
        (0, $8zOmE.fireUIAnalytics)(event, $2236103400b31729$var$OVERVIEWS_NAVIGATION_MENU_ITEM, attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendOverviewMenuItemAnalyticsEvent: sendOverviewMenuItemAnalyticsEvent,
        sendCreateOverviewAnalyticsEvent: sendCreateOverviewAnalyticsEvent
    };
};

});

parcelRegister("92djE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9921e9af9b1e8681$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9921e9af9b1e8681$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createOverview: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-overviews.common.section-actions.create-overview",
        "defaultMessage": "Create overview"
    },
    moreThanTenWarning: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-overviews.common.section-actions.more-than-ten-warning",
        "defaultMessage": "You\u2019ve reached the limit of 10 overviews."
    }
});

});


parcelRegister("VgtWG", function(module, exports) {

$parcel$export(module.exports, "Nav4OverviewsDefault", () => $2bb69cfcdc8635b0$export$b582325fc571fa20);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $338xa = parcelRequire("338xa");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $4zcxJ = parcelRequire("4zcxJ");

var $koeKL = parcelRequire("koeKL");

var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");


var $cCqmP = parcelRequire("cCqmP");
function $2bb69cfcdc8635b0$export$b582325fc571fa20({ isExpanded: isExpanded, actionsOnHover: actionsOnHover }) {
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).OVERVIEWS);
    const cloudId = (0, $koeKL.useCloudId)();
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $cCqmP.asyncOverviewsContentViewQuery), entryPointParams);
    const triggerRef = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActions);
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (isExpanded) entryPointActions.load();
    }, [
        entryPointActions,
        isExpanded
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: (0, $jhS4y.MENU_ID_OVERVIEWS),
        onSystemToggle: (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) {
                entryPointActions.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $46Cti.L1_MENU_ID).OVERVIEWS,
                    sectionItem: (0, $jecJ3.SECTION_ITEM_OVERVIEW)
                });
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-overviews-default",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $dQbFB.getTestId)((0, $jhS4y.MENU_ID_OVERVIEWS))
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-overviews-default",
        packageName: (0, $cdfe315557fc43d2$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $cdfe315557fc43d2$export$d57b6b390e78d90f),
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
        // Props for the root component.
        runtimeProps: entryPointParams
    })));
}

});
parcelRegister("cCqmP", function(module, exports) {

$parcel$export(module.exports, "asyncOverviewsContentViewQuery", () => $68f93ca11a5596c0$export$355176fbb80f2347);

var $i7pdK = parcelRequire("i7pdK");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $68f93ca11a5596c0$export$355176fbb80f2347 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("dMG6o")).then(({ OverviewsContentViewQuery: OverviewsContentViewQuery })=>OverviewsContentViewQuery), {
        moduleId: "6f0ac280",
        moduleName: "OverviewsContentViewQuery"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryRef: {
                    parameters: $i7pdK.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("i7pdK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ae4c5ed97c4768f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<560d7e5e0cd70de1d6c924f49a1b8b29>>
 * @relayHash cf2a8f845ae7c967ae307cc40eb4b07f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e61d234924072f4c43fcca2a72d097f86d33239be52bd1855eefa77b25c7cd4c
const $5ae4c5ed97c4768f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "OverviewsContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4OverviewsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "OverviewsContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraWorkManagementGiraOverviewConnection",
                            "kind": "LinkedField",
                            "name": "jwmOverviews",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraWorkManagementGiraOverview",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e61d234924072f4c43fcca2a72d097f86d33239be52bd1855eefa77b25c7cd4c",
            "metadata": {},
            "name": "OverviewsContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5ae4c5ed97c4768f$var$node.hash = "5c526a403c104de05313b5b30d6f67e2";
var $5ae4c5ed97c4768f$export$2e2bcd8739ae039 = $5ae4c5ed97c4768f$var$node;

});

parcelRegister("dMG6o", function(module, exports) {

let $a0906aa4b8faa823$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a0906aa4b8faa823$var$load("hNRRw").then(()=>parcelRequire('cG9Gr'));

});



parcelRegister("aKoWU", function(module, exports) {

$parcel$export(module.exports, "Nav4OverviewsForLanding", () => $3fb52decc5a00e35$export$a2711da4a3d7eaa1);

var $5O4cG = parcelRequire("5O4cG");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $l8ruj = parcelRequire("l8ruj");

var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");


var $1M5y9 = parcelRequire("1M5y9");
function $3fb52decc5a00e35$export$a2711da4a3d7eaa1({ isExpanded: isExpanded, queryRef: queryRef, actionsOnHover: actionsOnHover }) {
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).OVERVIEWS);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const data = (0, $8Uumt.useFragment)((0, $5O4cG.default), queryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).OVERVIEWS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_OVERVIEW)
            });
        },
        isExpanded: isExpanded,
        menuId: (0, $jhS4y.MENU_ID_OVERVIEWS)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-overviews-landing",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        // ref={triggerRef}
        testId: (0, $dQbFB.getTestId)((0, $jhS4y.MENU_ID_OVERVIEWS))
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-overviews-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "nav4-sidebar-overviews-landing",
        packageName: (0, $cdfe315557fc43d2$export$b8b9d90f9e5bd72b),
        teamName: (0, $cdfe315557fc43d2$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1M5y9.Nav4OverviewsContent), {
        queryRef: data
    })))));
}

});
parcelRegister("5O4cG", function(module, exports) {

$parcel$export(module.exports, "default", () => $773b1024053c443b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<24c44c1cc97a0ce676ed07f685505cfc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $773b1024053c443b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4OverviewsForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4OverviewsContent"
        }
    ],
    "type": "Query"
};
$773b1024053c443b$var$node.hash = "dca06bec8549dba3e1ff2c708224de6f";
var $773b1024053c443b$export$2e2bcd8739ae039 = $773b1024053c443b$var$node;

});

parcelRegister("1M5y9", function(module, exports) {

$parcel$export(module.exports, "Nav4OverviewsContent", () => $fb2fd91a88d04b6c$export$50145651ea4a827);

var $luy4t = parcelRequire("luy4t");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $9Gyp5 = parcelRequire("9Gyp5");

var $lOwQh = parcelRequire("lOwQh");

var $koeKL = parcelRequire("koeKL");

var $4IIGx = parcelRequire("4IIGx");
var $4vWwj = parcelRequire("4vWwj");
var $ch7sx = parcelRequire("ch7sx");

var $hkziz = parcelRequire("hkziz");

var $bbRBT = parcelRequire("bbRBT");
function $fb2fd91a88d04b6c$export$50145651ea4a827({ queryRef: queryRef }) {
    const { isSelectedPath: isSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [{ jira: { jwmOverviews: jwmOverviews } }, refetch] = (0, $8Uumt.useRefetchableFragment)((0, $luy4t.default), queryRef);
    (0, $9Gyp5.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $lOwQh.default,
        refetch: refetch,
        menuId: (0, $jhS4y.MENU_ID_OVERVIEWS)
    });
    const items = (0, $5uXOq.useMemo)(()=>{
        const nodes = jwmOverviews?.edges?.filter(Boolean).map((edge)=>edge.node) || [];
        const list = nodes.filter(Boolean).map((node)=>node.name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bbRBT.OverviewsMenuItem), {
                key: node.id,
                id: node.id,
                name: node.name
            }) : null).filter(Boolean) ?? [];
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        jwmOverviews
    ]);
    if (!items.hasItems) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkziz.OverviewsEmptyState), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, items.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4vWwj.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ch7sx.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, items.list))));
}

});
parcelRegister("luy4t", function(module, exports) {

$parcel$export(module.exports, "default", () => $12db70c4555ca789$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<36e48bbc800f6fcd05f9ae0af54e02a8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $lOwQh = parcelRequire("lOwQh");
const $12db70c4555ca789$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $lOwQh.default)
        }
    },
    "name": "Nav4OverviewsContent",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "JiraWorkManagementGiraOverviewConnection",
                        "kind": "LinkedField",
                        "name": "jwmOverviews",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraWorkManagementGiraOverview",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "jira"
        }
    ],
    "type": "Query"
};
$12db70c4555ca789$var$node.hash = "e24d9b35e956ee89177e09fcc3033bc6";
var $12db70c4555ca789$export$2e2bcd8739ae039 = $12db70c4555ca789$var$node;

});
parcelRegister("lOwQh", function(module, exports) {

$parcel$export(module.exports, "default", () => $396f1fb6c862454c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<abb8f4cb57d30ce17b791d146f8f5c1e>>
 * @relayHash 89a071a83d7086613e54267a83ad5589
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e49fb6b80c74d3109cdaeee9b0845e45ba88362a09ef2d27ffccd0095c0d334
const $396f1fb6c862454c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4OverviewsContentQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4OverviewsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4OverviewsContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraWorkManagementGiraOverviewConnection",
                            "kind": "LinkedField",
                            "name": "jwmOverviews",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraWorkManagementGiraOverview",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3e49fb6b80c74d3109cdaeee9b0845e45ba88362a09ef2d27ffccd0095c0d334",
            "metadata": {},
            "name": "Nav4OverviewsContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$396f1fb6c862454c$var$node.hash = "e24d9b35e956ee89177e09fcc3033bc6";
var $396f1fb6c862454c$export$2e2bcd8739ae039 = $396f1fb6c862454c$var$node;

});


parcelRegister("hkziz", function(module, exports) {

$parcel$export(module.exports, "OverviewsEmptyState", () => $ff6bee69ca61a432$export$84d2991bdf490d9e);

var $5uXOq = parcelRequire("5uXOq");

var $6eFvr = parcelRequire("6eFvr");

var $koVbs = parcelRequire("koVbs");

var $7lgBG = parcelRequire("7lgBG");

var $80d0n = parcelRequire("80d0n");
function $ff6bee69ca61a432$export$84d2991bdf490d9e() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7lgBG.EmptyContentMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        size: "small",
        align: "center",
        color: "color.text.subtlest"
    }, formatMessage((0, $80d0n.messages).noOverviews)));
}

});
parcelRegister("7lgBG", function(module, exports) {

$parcel$export(module.exports, "EmptyContentMenuItem", () => $e3e887a0aac5853d$export$1d5b0e5e21ec7e84);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");

var $4vWwj = parcelRequire("4vWwj");
const $e3e887a0aac5853d$var$styles = {
    box: "_18u01b66"
};
function $e3e887a0aac5853d$export$1d5b0e5e21ec7e84({ children: children }) {
    return /*#__PURE__*/ $5uXOq.createElement((0, $4vWwj.MenuListItem), null, /*#__PURE__*/ $5uXOq.createElement((0, $0yZbT.default), {
        paddingInline: "space.050",
        xcss: $e3e887a0aac5853d$var$styles.box
    }, children));
}

});

parcelRegister("80d0n", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2efe397547e443b7$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2efe397547e443b7$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    noOverviews: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-overviews.common.empty-state.no-overviews",
        "defaultMessage": "Once you create an overview, it'll show up here."
    }
});

});


parcelRegister("bbRBT", function(module, exports) {

$parcel$export(module.exports, "OverviewsMenuItem", () => $68e0e3e271034bfa$export$1110bfd7980f0ad5);

var $5uXOq = parcelRequire("5uXOq");

var $i3a7M = parcelRequire("i3a7M");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $5FnJJ = parcelRequire("5FnJJ");

var $dUyqZ = parcelRequire("dUyqZ");
function $68e0e3e271034bfa$export$1110bfd7980f0ad5({ id: id, name: name }) {
    const { icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).OVERVIEWS);
    const { sendOverviewMenuItemAnalyticsEvent: sendOverviewMenuItemAnalyticsEvent } = (0, $i3a7M.useOverviewsAnalyticsL1)();
    const overviewUrl = `/jira/core/overviews/${id}/summary`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        onClick: ()=>{
            sendOverviewMenuItemAnalyticsEvent({
                overviewId: id
            });
        },
        href: overviewUrl,
        menuId: (0, $jhS4y.ENTITY_ID).OVERVIEW(String(id)),
        elemBefore: icon
    }, name);
}

});





parcelRegister("1YUDD", function(module, exports) {

$parcel$export(module.exports, "Nav4Plans", () => $c0a13e2d05128c7b$export$a9599e1720ee6c82);

var $5uXOq = parcelRequire("5uXOq");

var $7Fvqy = parcelRequire("7Fvqy");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");


var $d6uAw = parcelRequire("d6uAw");

var $iUfQY = parcelRequire("iUfQY");
function $c0a13e2d05128c7b$export$a9599e1720ee6c82(props) {
    const isStandardOrFree = (0, $7Fvqy.useIsStandardOrFreeJSW)();
    const isUnlicensedJsw = (0, $7Fvqy.useIsUnlicensedJSW)();
    if (isUnlicensedJsw) return null;
    if (isStandardOrFree) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iUfQY.Nav4PlansPremiumUpsellFeatureGate), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4.sidebar.plans"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "plans-section",
        packageName: (0, $b0ee4c2dffa12273$export$b8b9d90f9e5bd72b),
        teamName: (0, $b0ee4c2dffa12273$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6uAw.Nav4Plans), props)));
}

});
parcelRegister("7Fvqy", function(module, exports) {

$parcel$export(module.exports, "useIsStandardOrFreeJSW", () => $ac0a44b8f9a76c7a$export$5edaea31b41b30b);
$parcel$export(module.exports, "useIsPremiumJSW", () => $ac0a44b8f9a76c7a$export$d245a3118a8b4004);
$parcel$export(module.exports, "useIsUnlicensedJSW", () => $ac0a44b8f9a76c7a$export$47ec61465121ff53);

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");
const $ac0a44b8f9a76c7a$export$a2bbf41e67157372 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $ldyPw.STANDARD_EDITION);
};
const $ac0a44b8f9a76c7a$export$a55cc88b2381611c = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $ldyPw.FREE_EDITION);
};
const $ac0a44b8f9a76c7a$export$5edaea31b41b30b = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $ldyPw.STANDARD_EDITION) || jswEdition === (0, $ldyPw.FREE_EDITION);
};
const $ac0a44b8f9a76c7a$export$d245a3118a8b4004 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $ldyPw.PREMIUM_EDITION);
};
const $ac0a44b8f9a76c7a$export$47ec61465121ff53 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    return !jswEdition || jswEdition === (0, $ldyPw.UNLICENSED);
};

});

const $b0ee4c2dffa12273$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Plans';
const $b0ee4c2dffa12273$export$d57b6b390e78d90f = 'jet-chronos-team';

parcelRegister("d6uAw", function(module, exports) {

$parcel$export(module.exports, "Nav4Plans", () => $985d33464497955f$export$a9599e1720ee6c82);

var $gSE3m = parcelRequire("gSE3m");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7Fvqy = parcelRequire("7Fvqy");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $h9iZl = parcelRequire("h9iZl");

var $b9Pg6 = parcelRequire("b9Pg6");

var $kicJ4 = parcelRequire("kicJ4");

var $iC65q = parcelRequire("iC65q");

var $iUfQY = parcelRequire("iUfQY");
function $985d33464497955f$export$a9599e1720ee6c82({ isExpanded: isExpanded, queryRef: queryRef }) {
    const data = (0, $8Uumt.useFragment)((0, $gSE3m.default), queryRef);
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const hasEditPermissions = data.jira?.advancedRoadmapsNavigation?.hasEditPermissions ?? false;
    const hasCreateSamplePlanPermissions = data.jira?.advancedRoadmapsNavigation?.hasCreateSamplePlanPermissions ?? false;
    const hasGlobalPlansAdminPermissions = data.jira?.advancedRoadmapsNavigation?.hasGlobalPlansAdminPermissions ?? false;
    const actionButtons = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9Pg6.Nav4PlansActionButtons), {
            hasEditPermissions: hasEditPermissions,
            hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions,
            hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions
        }), [
        hasEditPermissions,
        hasCreateSamplePlanPermissions,
        hasGlobalPlansAdminPermissions
    ]);
    const [shouldRender] = (0, $h9iZl.useNavigationPlansVisibility)();
    const isPremium = (0, $7Fvqy.useIsPremiumJSW)();
    if (!shouldRender) return null;
    if (!isPremium) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iUfQY.Nav4PlansPremiumUpsellFeatureGate), null);
    return isInitialSelectedPath((0, $jhS4y.MENU_ID_PLANS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iC65q.Nav4PlansForLanding), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded,
        queryRef: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kicJ4.Nav4PlansDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
}

});
parcelRegister("gSE3m", function(module, exports) {

$parcel$export(module.exports, "default", () => $59ba99e1087de085$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<269bc8637c7fb324ac64325d1917d50e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $59ba99e1087de085$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "isPlansExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Plans",
    "selections": [
        {
            "condition": "isPlansExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4PlansForLanding"
                }
            ]
        },
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraAdvancedRoadmapsNavigation",
                    "kind": "LinkedField",
                    "name": "advancedRoadmapsNavigation",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasEditPermissions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasCreateSamplePlanPermissions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasGlobalPlansAdminPermissions"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$59ba99e1087de085$var$node.hash = "3aadd0d82198a5c14ad1e7da7343031b";
var $59ba99e1087de085$export$2e2bcd8739ae039 = $59ba99e1087de085$var$node;

});

parcelRegister("b9Pg6", function(module, exports) {

$parcel$export(module.exports, "Nav4PlansActionButtons", () => $06dac252aee09a8f$export$a7d6536605f62394);

var $5uXOq = parcelRequire("5uXOq");

var $1MV6x = parcelRequire("1MV6x");

var $agyyr = parcelRequire("agyyr");
const $06dac252aee09a8f$export$a7d6536605f62394 = ({ hasEditPermissions: hasEditPermissions, hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions, hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, hasEditPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1MV6x.CreatePlanMenuButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $agyyr.MoreMenuButton), {
        hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions,
        hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions
    }));
};

});
parcelRegister("1MV6x", function(module, exports) {

$parcel$export(module.exports, "CreatePlanMenuButton", () => $672e78f60f326b1f$export$fd3582c8dd19f9f6);

var $5uXOq = parcelRequire("5uXOq");

var $g7g8o = parcelRequire("g7g8o");

var $5KCCi = parcelRequire("5KCCi");

var $koVbs = parcelRequire("koVbs");



var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $1xonH = parcelRequire("1xonH");

var $gD5Z0 = parcelRequire("gD5Z0");

var $bngFq = parcelRequire("bngFq");

var $8zOmE = parcelRequire("8zOmE");

var $ydGxv = parcelRequire("ydGxv");
const $672e78f60f326b1f$export$fd3582c8dd19f9f6 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { openDrawer: openCreateNewPlanWizardDrawer }] = (0, $gD5Z0.useCreateNewPlanWizardDrawer)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const clickHandler = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_PLANS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: 'createPlan'
            }
        });
        openCreateNewPlanWizardDrawer();
    }, [
        openCreateNewPlanWizardDrawer,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: formatMessage((0, $ydGxv.default).createPlan)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xonH.CommonNavMenuButton), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g7g8o))),
        label: formatMessage((0, $ydGxv.default).createPlan),
        onClick: clickHandler
    }));
};

});
parcelRegister("gD5Z0", function(module, exports) {

$parcel$export(module.exports, "useCreateNewPlanWizardDrawer", () => $13f82bb8cfc1f7f2$export$f3e7d3fc94eda89a);
$parcel$export(module.exports, "useImportedMessagesForLocale", () => $13f82bb8cfc1f7f2$export$52303468eeac3ad0);

var $5uXOq = parcelRequire("5uXOq");

var $8yVxK = parcelRequire("8yVxK");

var $koVbs = parcelRequire("koVbs");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");
const $13f82bb8cfc1f7f2$var$CONTROLLER_NAME = 'create-new-plan-wizard-drawer';
const $13f82bb8cfc1f7f2$var$initialState = {
    isOpen: false,
    plan: undefined
};
const $13f82bb8cfc1f7f2$var$Store = (0, $iXqE5.createStore)({
    name: $13f82bb8cfc1f7f2$var$CONTROLLER_NAME,
    initialState: $13f82bb8cfc1f7f2$var$initialState,
    actions: {
        openDrawer: (plan)=>{
            (0, $8yVxK.default)('arj-create-plan-wizard-drawer');
            return ({ setState: setState })=>setState({
                    isOpen: true,
                    plan: plan
                });
        },
        closeDrawer: ()=>({ setState: setState })=>setState({
                    isOpen: false,
                    plan: undefined
                })
    }
});
const $13f82bb8cfc1f7f2$export$f3e7d3fc94eda89a = (0, $3sQ5x.createHook)($13f82bb8cfc1f7f2$var$Store);
const $13f82bb8cfc1f7f2$export$9ec7b5762fb72de2 = (0, $gg7kZ.createContainer)($13f82bb8cfc1f7f2$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen, plan: plan })=>{
            setState({
                isOpen: isOpen,
                plan: plan
            });
        }
});
const $13f82bb8cfc1f7f2$var$EXCLUDED_I18N_FILES = [
    'index',
    'languages',
    'en'
];
const $13f82bb8cfc1f7f2$var$FALLBACK_INTL_MESSAGES = Object.freeze({});
const $13f82bb8cfc1f7f2$export$19442c17ab279a67 = async (rawlocale = 'en')=>{
    // Filter out country code as the AFE i18n does not use them e.g en => en-US
    const locale = rawlocale.split('-')[0];
    if (!locale || $13f82bb8cfc1f7f2$var$EXCLUDED_I18N_FILES.includes(locale)) return {
        default: $13f82bb8cfc1f7f2$var$FALLBACK_INTL_MESSAGES
    };
    const packageName = (0, $4R6GH.fg)('finish_jira-portfolio-3-plan-wizard_migration') ? 'jira-portfolio-3-plan-wizard' : 'jira-portfolio-plan-wizard';
    try {
        {
            // eslint-disable-next-line jira/import/webpack-magic-comment-entries
            const i18nModule = await import(`@atlassian/${packageName}/dist/esm/i18n/*.js`);
            const result = i18nModule[locale]();
            return result;
        }
        // eslint-disable-next-line jira/import/webpack-magic-comment-entries
        const result = await import(`@atlassian/${packageName}/dist/cjs/i18n/${locale}`);
        return result;
    } catch  {
        return {
            default: $13f82bb8cfc1f7f2$var$FALLBACK_INTL_MESSAGES
        };
    }
};
const $13f82bb8cfc1f7f2$export$52303468eeac3ad0 = ()=>{
    const { locale: locale } = (0, $koVbs.default)();
    const [state, setState] = (0, $5uXOq.useState)({
        locale: locale,
        loading: true,
        intlMessages: undefined
    });
    (0, $5uXOq.useEffect)(()=>{
        let mounted = true;
        const load = async ()=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            setState((state)=>({
                    ...state,
                    loading: true
                }));
            const { default: intlMessages } = await $13f82bb8cfc1f7f2$export$19442c17ab279a67(locale);
            if (!mounted) return;
            // eslint-disable-next-line @typescript-eslint/no-shadow
            setState((state)=>({
                    ...state,
                    loading: false,
                    intlMessages: intlMessages
                }));
        };
        load();
        return ()=>{
            mounted = false;
        };
    }, [
        locale
    ]);
    return state;
};

});

parcelRegister("ydGxv", function(module, exports) {

$parcel$export(module.exports, "default", () => $12c7f7332437bfb0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $12c7f7332437bfb0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createPlan: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.create-plan-menu-button.create-plan",
        "defaultMessage": "Create plan"
    }
});

});


parcelRegister("agyyr", function(module, exports) {

$parcel$export(module.exports, "MoreMenuButton", () => $070d86da22a28dce$export$b13d6ccdb9a8b0c5);

var $5uXOq = parcelRequire("5uXOq");

var $46OkO = parcelRequire("46OkO");

var $51oeD = parcelRequire("51oeD");

var $7H980 = parcelRequire("7H980");
var $44qT7 = parcelRequire("44qT7");
var $aOrxC = parcelRequire("aOrxC");
var $70rf1 = parcelRequire("70rf1");

var $koVbs = parcelRequire("koVbs");



var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $4LAva = parcelRequire("4LAva");

var $bngFq = parcelRequire("bngFq");

var $8zOmE = parcelRequire("8zOmE");

var $ivGXF = parcelRequire("ivGXF");
const $070d86da22a28dce$var$MoreMenuItems = ({ hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions, hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { open: openCreateSamplePlanModal }] = (0, $4LAva.useCreateSamplePlan)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const createDemoPlanClickHandler = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_PLANS],
            attributes: {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: 'createDemoPlan'
            }
        });
        openCreateSamplePlanModal();
    }, [
        openCreateSamplePlanModal,
        createAnalyticsEvent
    ]);
    const adminSettingsClickHandler = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_PLANS],
            attributes: {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: 'adminSettings'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), null, (hasCreateSamplePlanPermissions || hasGlobalPlansAdminPermissions) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        isList: true
    }, hasCreateSamplePlanPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($46OkO))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        onClick: createDemoPlanClickHandler
    }, formatMessage((0, $ivGXF.default).createDemoPlan)), hasGlobalPlansAdminPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44qT7.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($51oeD))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: "/jira/plans/settings/permissions",
        onClick: adminSettingsClickHandler
    }, formatMessage((0, $ivGXF.default).adminSettings))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
        menuId: (0, $46Cti.L1_MENU_ID).PLANS
    }));
};
const $070d86da22a28dce$export$b13d6ccdb9a8b0c5 = ({ hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions, hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const clickHandler = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_PLANS],
            attributes: {
                level: '1',
                componentType: 'fixedItemButton',
                itemId: 'meatballDropdown'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($070d86da22a28dce$var$MoreMenuItems, {
                hasCreateSamplePlanPermissions: hasCreateSamplePlanPermissions,
                hasGlobalPlansAdminPermissions: hasGlobalPlansAdminPermissions
            }),
        name: formatMessage((0, $ivGXF.default).plansMoreMenu),
        onOpen: clickHandler
    });
};

});
parcelRegister("4LAva", function(module, exports) {

$parcel$export(module.exports, "useCreateSamplePlan", () => $8f6b3552bc4c872c$export$53d6fde96f096b86);
$parcel$export(module.exports, "CreateSamplePlanProvider", () => $8f6b3552bc4c872c$export$88b99aa46c223622);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $e0K2C = parcelRequire("e0K2C");

var $hK1fQ = parcelRequire("hK1fQ");
const $8f6b3552bc4c872c$var$CONTROLLER_NAME = 'create-sample-plan';
const $8f6b3552bc4c872c$var$initialState = {
    /**
	 * This field controls modal dismissible status
	 */ isOpen: false,
    /**
	 * This field is only used to redirect the user to plan page if the modal is not closed.
	 */ planId: null,
    /**
	 * This field is used to detect the correct redirection creation session,
	 * without this field, we don't know which creation session needs to be redirected
	 * e.g. the user started multiple sample creation and stays on the last one - in this case,
	 * only the last creation needs to be redirected.
	 */ taskId: null,
    /**
	 * Progress of the ongoing task
	 */ progressPercentage: null,
    /**
	 * Once this field has been set to `true`, we'll know we can call the actions returned
	 * by our useCreateSamplePlan hook.
	 */ hasBeenInitialised: false
};
const $8f6b3552bc4c872c$var$actions = {
    open: ()=>({ setState: setState })=>{
            setState({
                isOpen: true
            });
        },
    close: ()=>({ setState: setState })=>{
            const nextState = (({ hasBeenInitialised: hasBeenInitialised, ...rest })=>rest)($8f6b3552bc4c872c$var$initialState);
            setState(nextState);
        },
    setPlanId: (planId)=>({ setState: setState })=>{
            setState({
                planId: planId
            });
        },
    setTaskId: (taskId)=>({ setState: setState })=>{
            setState({
                taskId: taskId
            });
        },
    setProgressPercentage: (progressPercentage)=>({ setState: setState })=>{
            setState({
                progressPercentage: progressPercentage
            });
        },
    submitSamplePlan: ({ planName: planName, flags: { success: SuccessFlag, error: ErrorFlag } })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { showFlag: showFlag, redirectToPlan: redirectToPlan, leadAccountId: leadAccountId })=>{
            try {
                const taskId = await (0, $hK1fQ.createSamplePlanAsync)({
                    body: JSON.stringify({
                        title: planName,
                        leadAccountId: leadAccountId
                    })
                });
                setState({
                    taskId: taskId
                });
                const response = await (0, $hK1fQ.pollCreateSamplePlan)(taskId, (progressPercentage)=>{
                    const { taskId: latestTaskId } = getState();
                    // progressPercentage should reflect the progress of the most recent taskId
                    // If they don't match, skip updating
                    if (taskId !== latestTaskId) return;
                    setState({
                        progressPercentage: progressPercentage
                    });
                });
                const { plan: plan } = response.samplePlan;
                const currentState = getState();
                // We only want to redirect them if the taskId for the current modal is the same as the one for this request
                // Else it might belong to a previous modal
                if (currentState.isOpen && taskId === currentState.taskId) {
                    redirectToPlan(plan.id);
                    dispatch($8f6b3552bc4c872c$var$actions.close());
                } else {
                    const flagId = (0, $e0K2C.CREATE_SUCCESS_FLAG_ID) + plan.id;
                    showFlag({
                        id: flagId,
                        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SuccessFlag, {
                                id: flagId,
                                planName: plan.name,
                                planId: plan.id
                            })
                    });
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                // we only want to track errors unrelated to user settings
                if (!(0, $e0K2C.USER_SETTINGS_ERRORS).includes(err.message)) (0, $jcw0u.default)({
                    error: err,
                    meta: {
                        id: `${(0, $e0K2C.ERROR_REPORTING_PACKAGE)}SubmitFailed`,
                        packageName: (0, $e0K2C.ERROR_REPORTING_PACKAGE),
                        teamName: (0, $e0K2C.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                const props = {
                    id: (0, $e0K2C.CREATE_ERROR_FLAG_ID),
                    errorCode: err.message
                };
                showFlag({
                    id: (0, $e0K2C.CREATE_ERROR_FLAG_ID),
                    render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorFlag, props)
                });
                dispatch($8f6b3552bc4c872c$var$actions.close());
            }
        }
};
const $8f6b3552bc4c872c$var$Store = (0, $iXqE5.createStore)({
    name: $8f6b3552bc4c872c$var$CONTROLLER_NAME,
    initialState: $8f6b3552bc4c872c$var$initialState,
    actions: $8f6b3552bc4c872c$var$actions
});
const $8f6b3552bc4c872c$export$53d6fde96f096b86 = (0, $3sQ5x.createHook)($8f6b3552bc4c872c$var$Store);
const $8f6b3552bc4c872c$export$88b99aa46c223622 = (0, $gg7kZ.createContainer)($8f6b3552bc4c872c$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen = false })=>{
            setState({
                isOpen: isOpen,
                hasBeenInitialised: true
            });
        }
});

});
parcelRegister("e0K2C", function(module, exports) {

$parcel$export(module.exports, "ERROR_REPORTING_PACKAGE", () => $3613c4dc2e67ca96$export$f27a837467ec20e5);
$parcel$export(module.exports, "ERROR_REPORTING_TEAM", () => $3613c4dc2e67ca96$export$cfeee2ee86ead336);
$parcel$export(module.exports, "MAX_PLAN_NAME_LENGTH", () => $3613c4dc2e67ca96$export$62da4a2465b3b309);
$parcel$export(module.exports, "CREATE_SUCCESS_FLAG_ID", () => $3613c4dc2e67ca96$export$d526356745046017);
$parcel$export(module.exports, "CREATE_ERROR_FLAG_ID", () => $3613c4dc2e67ca96$export$abd17266df221a92);
$parcel$export(module.exports, "UNKNOWN_EXCEPTION", () => $3613c4dc2e67ca96$export$cfba07bc71f884c1);
$parcel$export(module.exports, "USER_SETTINGS_ERRORS", () => $3613c4dc2e67ca96$export$4a3e779cd3c10125);
$parcel$export(module.exports, "ERROR_CODE_TITLE_MAPPING", () => $3613c4dc2e67ca96$export$91ec80863c2c2030);
$parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING", () => $3613c4dc2e67ca96$export$c43e20911e13ca0);
$parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING_ISSUE_TERM_REFRESH", () => $3613c4dc2e67ca96$export$525cba92c9b435f4);
$parcel$export(module.exports, "ERROR_LINK_MAPPING", () => $3613c4dc2e67ca96$export$2c5a783ab3215ce1);

var $2L5wO = parcelRequire("2L5wO");
const $3613c4dc2e67ca96$export$f27a837467ec20e5 = 'jiraPortfolio3CreateSamplePlan';
const $3613c4dc2e67ca96$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $3613c4dc2e67ca96$var$CONTACT_SUPPORT_URL = 'https://support.atlassian.com/contact';
const $3613c4dc2e67ca96$var$LEARN_MORE_URL = 'https://support.atlassian.com/jira-software-cloud/docs/view-a-sample-advanced-roadmaps-plan/';
const $3613c4dc2e67ca96$export$62da4a2465b3b309 = 255;
const $3613c4dc2e67ca96$export$d526356745046017 = 'samplePlanCreatedSuccessfully';
const $3613c4dc2e67ca96$export$abd17266df221a92 = 'samplePlanError';
const $3613c4dc2e67ca96$export$e6515d2009b1dba7 = 'REQUIRED_FIELDS_CONFIGURED_ON_ISSUE';
const $3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS = 'EMPTY_ISSUE_LINKS';
const $3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION = 'NO_BROWSE_PROJECTS_PERMISSION';
const $3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION = 'NO_CREATE_ISSUES_PERMISSION';
const $3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION = 'NO_TRANSITION_ISSUES_PERMISSION';
const $3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION = 'NO_EDIT_ISSUES_PERMISSION';
const $3613c4dc2e67ca96$var$WATCHING_DISABLED = 'WATCHING_DISABLED';
const $3613c4dc2e67ca96$export$cfba07bc71f884c1 = 'UNKNOWN_EXCEPTION';
const $3613c4dc2e67ca96$export$4a3e779cd3c10125 = [
    $3613c4dc2e67ca96$export$e6515d2009b1dba7,
    $3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS,
    $3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION,
    $3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION,
    $3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION,
    $3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION,
    $3613c4dc2e67ca96$var$WATCHING_DISABLED
];
const $3613c4dc2e67ca96$export$91ec80863c2c2030 = {
    [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: (0, $2L5wO.default).configurationErrorTitle,
    [$3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS]: (0, $2L5wO.default).configurationErrorTitle,
    [$3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION]: (0, $2L5wO.default).permissionErrorTitle,
    [$3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION]: (0, $2L5wO.default).permissionErrorTitle,
    [$3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION]: (0, $2L5wO.default).permissionErrorTitle,
    [$3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION]: (0, $2L5wO.default).permissionErrorTitle,
    [$3613c4dc2e67ca96$var$WATCHING_DISABLED]: (0, $2L5wO.default).configurationErrorTitle,
    [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: (0, $2L5wO.default).tryAgainErrorTitle
};
const $3613c4dc2e67ca96$export$c43e20911e13ca0 = {
    [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: (0, $2L5wO.default).requiredFieldsConfiguredOnIssueError,
    [$3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS]: (0, $2L5wO.default).emptyIssueLinksError,
    [$3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION]: (0, $2L5wO.default).noBrowseProjectsPermissionError,
    [$3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION]: (0, $2L5wO.default).noCreateIssuesPermissionError,
    [$3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION]: (0, $2L5wO.default).noTransitionIssuesPermissionError,
    [$3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION]: (0, $2L5wO.default).noEditIssuesPermissionError,
    [$3613c4dc2e67ca96$var$WATCHING_DISABLED]: (0, $2L5wO.default).watchingDisabledError,
    [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: (0, $2L5wO.default).unknownExceptionError
};
const $3613c4dc2e67ca96$export$525cba92c9b435f4 = {
    [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: (0, $2L5wO.default).requiredFieldsConfiguredOnIssueErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS]: (0, $2L5wO.default).emptyIssueLinksErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION]: (0, $2L5wO.default).noBrowseProjectsPermissionError,
    [$3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION]: (0, $2L5wO.default).noCreateIssuesPermissionErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION]: (0, $2L5wO.default).noTransitionIssuesPermissionErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION]: (0, $2L5wO.default).noEditIssuesPermissionErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$var$WATCHING_DISABLED]: (0, $2L5wO.default).watchingDisabledErrorIssueTermRefresh,
    [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: (0, $2L5wO.default).unknownExceptionError
};
const $3613c4dc2e67ca96$export$2c5a783ab3215ce1 = {
    [$3613c4dc2e67ca96$export$e6515d2009b1dba7]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$EMPTY_ISSUE_LINKS]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$NO_BROWSE_PROJECTS_PERMISSION]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$NO_CREATE_ISSUES_PERMISSION]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$NO_TRANSITION_ISSUES_PERMISSION]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$NO_EDIT_ISSUES_PERMISSION]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$var$WATCHING_DISABLED]: {
        text: (0, $2L5wO.default).learnMore,
        href: $3613c4dc2e67ca96$var$LEARN_MORE_URL
    },
    [$3613c4dc2e67ca96$export$cfba07bc71f884c1]: {
        text: (0, $2L5wO.default).contactSupport,
        href: $3613c4dc2e67ca96$var$CONTACT_SUPPORT_URL
    }
};

});
parcelRegister("2L5wO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4969e0d482b1a0a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e4969e0d482b1a0a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    configurationErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.configuration-error-title",
        "defaultMessage": "Your demo plan couldn't be created because of a configuration error"
    },
    permissionErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.permission-error-title",
        "defaultMessage": "Your demo plan couldn't be created because you\u2019re missing a required permission"
    },
    tryAgainErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.try-again-error-title",
        "defaultMessage": "Try to create your demo plan again"
    },
    requiredFieldsConfiguredOnIssueError: {
        "id": "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error",
        "defaultMessage": "Your issues have required fields which blocked your demo plan from being created. {readMoreLink}"
    },
    emptyIssueLinksError: {
        "id": "portfolio-3-create-sample-plan.common.empty-issue-links-error",
        "defaultMessage": "Your site doesn't have issue links configured, which are required to create a demo plan. {readMoreLink}"
    },
    noBrowseProjectsPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-browse-projects-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Browse Projects</permission-type> permission. {readMoreLink}"
    },
    noCreateIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-create-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Create Issues</permission-type> permission. {readMoreLink}"
    },
    noTransitionIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Transition Issues</permission-type> permission. {readMoreLink}"
    },
    noEditIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Edit Issues</permission-type> permission. {readMoreLink}"
    },
    watchingDisabledError: {
        "id": "portfolio-3-create-sample-plan.common.watching-disabled-error",
        "defaultMessage": "Your demo plan couldn't be created because you have issue watching disabled. {readMoreLink}"
    },
    unknownExceptionError: {
        "id": "portfolio-3-create-sample-plan.common.unknown-exception-error",
        "defaultMessage": "Your demo plan couldn't be created, but we\u2019re not sure why. If the problem persists, contact Atlassian support. {readMoreLink}"
    },
    learnMore: {
        "id": "portfolio-3-create-sample-plan.common.learn-more",
        "defaultMessage": "Learn more"
    },
    contactSupport: {
        "id": "portfolio-3-create-sample-plan.common.contact-support",
        "defaultMessage": "Contact Atlassian support"
    },
    requiredFieldsConfiguredOnIssueErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error-issue-term-refresh",
        "defaultMessage": "Your work items have required fields which blocked your demo plan from being created. {readMoreLink}"
    },
    emptyIssueLinksErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.empty-issue-links-error-issue-term-refresh",
        "defaultMessage": "Your site doesn't have work item links configured, which are required to create a demo plan. {readMoreLink}"
    },
    noCreateIssuesPermissionErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.no-create-issues-permission-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Create work items</permission-type> permission. {readMoreLink}"
    },
    noTransitionIssuesPermissionErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Transition work items</permission-type> permission. {readMoreLink}"
    },
    noEditIssuesPermissionErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Edit work items</permission-type> permission. {readMoreLink}"
    },
    watchingDisabledErrorIssueTermRefresh: {
        "id": "portfolio-3-create-sample-plan.common.watching-disabled-error-issue-term-refresh",
        "defaultMessage": "Your demo plan couldn't be created because you have work item watching disabled. {readMoreLink}"
    }
});

});


parcelRegister("hK1fQ", function(module, exports) {

$parcel$export(module.exports, "createSamplePlanAsync", () => $4a753946a320d2b7$export$fed9130b90cf6213);
$parcel$export(module.exports, "pollCreateSamplePlan", () => $4a753946a320d2b7$export$5d240a69af545c0d);
/**
 * Consider moving into service
 */ 
var $jcw0u = parcelRequire("jcw0u");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");

var $e0K2C = parcelRequire("e0K2C");
const $4a753946a320d2b7$var$throwIfNotOk = async (response)=>{
    if (response.ok) return response;
    if (response.status === 500) throw new (0, $jJZqs.default)(response.status, (0, $e0K2C.UNKNOWN_EXCEPTION), response.headers.get((0, $fnyT4.TRACE_ID_HEADER)) ?? undefined, response);
};
const $4a753946a320d2b7$var$throwIfFailed = (result)=>{
    if (result.samplePlan && !result.samplePlan.success) throw new Error(result.samplePlan.error);
};
const $4a753946a320d2b7$var$delay = (ms = 3000)=>new Promise((res)=>setTimeout(res, ms));
const $4a753946a320d2b7$export$fed9130b90cf6213 = async (data)=>{
    const response = await (0, $eusud.performPostRequest)('/rest/jpo/1.0/plans/sampleplan/async', data);
    const { taskId: taskId } = response;
    if (!taskId) throw new Error('Invalid response from createSamplePlan');
    return taskId;
};
const $4a753946a320d2b7$export$5d240a69af545c0d = async (taskId, onUpdate)=>{
    const url = `/rest/jpo/1.0/plans/sampleplan/async/${taskId}`;
    try {
        const response = await fetch(url);
        await $4a753946a320d2b7$var$throwIfNotOk(response);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const raw = await response.json();
        $4a753946a320d2b7$var$throwIfFailed(raw);
        onUpdate(raw.progressPercent);
        if (raw.done) return raw;
        await $4a753946a320d2b7$var$delay();
        return $4a753946a320d2b7$export$5d240a69af545c0d(taskId, onUpdate);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // we only want to track errors unrelated to user settings
        if (!(0, $e0K2C.USER_SETTINGS_ERRORS).includes(error.message)) (0, $jcw0u.default)({
            meta: {
                id: `${(0, $e0K2C.ERROR_REPORTING_PACKAGE)}PollingFailed`,
                packageName: (0, $e0K2C.ERROR_REPORTING_PACKAGE),
                teamName: (0, $e0K2C.ERROR_REPORTING_TEAM)
            },
            attributes: {
                message: 'Polling create sample plan failed'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("ivGXF", function(module, exports) {

$parcel$export(module.exports, "default", () => $97d8a8b002f64e68$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $97d8a8b002f64e68$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    adminSettings: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.more-menu-button.admin-settings",
        "defaultMessage": "Admin configuration"
    },
    plansMoreMenu: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.more-menu-button.plans-more-menu",
        "defaultMessage": "Plans"
    },
    createDemoPlan: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.more-menu-button.create-demo-plan",
        "defaultMessage": "Create demo plan"
    }
});

});



parcelRegister("kicJ4", function(module, exports) {

$parcel$export(module.exports, "Nav4PlansDefault", () => $f508957e3c5a5c81$export$8edda76b63bd4bcb);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $aGONy = parcelRequire("aGONy");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $338xa = parcelRequire("338xa");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $4zcxJ = parcelRequire("4zcxJ");


var $fb8Lj = parcelRequire("fb8Lj");

var $koeKL = parcelRequire("koeKL");

var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");

var $5layf = parcelRequire("5layf");
const $f508957e3c5a5c81$export$8edda76b63bd4bcb = ({ actionsOnHover: actionsOnHover, isExpanded: isExpanded })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const currentURLPath = (0, $aGONy.useGetCurrentUrlPath)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            currentURLPath: currentURLPath
        }), [
        cloudId,
        currentURLPath
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $5layf.asyncPlansSectionPlanListViewQuery), entryPointParams);
    const triggerRef = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).PLANS);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const menuId = (0, $jhS4y.MENU_ID_PLANS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        onSystemToggle: (hasExpanded)=>{
            if (hasExpanded) entryPointActions.load();
        },
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) {
                entryPointActions.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $46Cti.L1_MENU_ID).PLANS,
                    sectionItem: (0, $jecJ3.SECTION_ITEM_PLANS)
                });
            }
        },
        menuId: menuId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-plans-default",
        packageName: (0, $b0ee4c2dffa12273$export$b8b9d90f9e5bd72b),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        teamName: (0, $b0ee4c2dffa12273$export$d57b6b390e78d90f),
        // Fallback for Suspense
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
        // Props for the root component
        runtimeProps: entryPointParams
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fb8Lj.Nav4PlansFooter), null)));
};

});
parcelRegister("fb8Lj", function(module, exports) {

$parcel$export(module.exports, "Nav4PlansFooter", () => $42fbc7ad9b24b6aa$export$484b1d8ed55fea0a);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");



var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $34PKs = parcelRequire("34PKs");

var $bngFq = parcelRequire("bngFq");

var $8zOmE = parcelRequire("8zOmE");

var $8jQu6 = parcelRequire("8jQu6");

var $4IIGx = parcelRequire("4IIGx");
var $4vWwj = parcelRequire("4vWwj");
var $ch7sx = parcelRequire("ch7sx");

var $5WlKy = parcelRequire("5WlKy");
const $42fbc7ad9b24b6aa$var$VIEW_ALL_PLANS_HREF = (0, $8jQu6.plansDirectoryRoute).path;
const $42fbc7ad9b24b6aa$export$484b1d8ed55fea0a = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const viewAllPlansClickHandler = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_PLANS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                itemId: 'viewAllPlans'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4vWwj.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ch7sx.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34PKs.ViewAllEntityMenuItem), {
        href: $42fbc7ad9b24b6aa$var$VIEW_ALL_PLANS_HREF,
        menuId: (0, $jhS4y.MENU_ID_PLANS_VIEW_ALL),
        onClick: viewAllPlansClickHandler
    }, formatMessage((0, $5WlKy.default).viewAllPlans)))));
};

});
parcelRegister("8jQu6", function(module, exports) {

$parcel$export(module.exports, "plansDirectoryRoute", () => $f8b07af15c3bb184$export$143b4a1ef2ffc051);
const $f8b07af15c3bb184$export$143b4a1ef2ffc051 = {
    name: 'plans-directory',
    path: '/jira/plans'
};

});

parcelRegister("5WlKy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f511387c8725975f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f511387c8725975f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAllPlans: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.footer.view-all-plans",
        "defaultMessage": "View all plans"
    }
});

});


parcelRegister("5layf", function(module, exports) {

$parcel$export(module.exports, "asyncPlansSectionPlanListViewQuery", () => $fd20310af43be2cc$export$c2f76ac2cce77bea);

var $52dVj = parcelRequire("52dVj");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $fd20310af43be2cc$export$c2f76ac2cce77bea = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("c72oM")).then((module)=>module.Nav4PlansListViewQuery), {
        moduleId: "90d35cd1",
        moduleName: "Nav4PlansListViewQuery"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryRef: {
                    parameters: $52dVj.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("52dVj", function(module, exports) {

$parcel$export(module.exports, "default", () => $31e75d27297f8a2d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<13ada8ab5784924200cecfb33f227c54>>
 * @relayHash b54037546462386bcbf5461949d12fa7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 269fd60bec2d8a735ea27d4119024830098f5c9a3eec94ace82ccb0911de1867

var $95Z36 = parcelRequire("95Z36");
const $31e75d27297f8a2d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v5 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "defaultNavigationItem",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "url"
                                                }
                                            ],
                                            "type": "JiraSoftwareBuiltInNavigationItem"
                                        },
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v4 /*: any*/ 
            ]
        }
    ], v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "Nav4PlansListViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "PlansList"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "Nav4PlansListViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouritePlans",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "PLAN"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v5 /*: any*/ 
                                },
                                v6 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentPlans",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "PLAN"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v5 /*: any*/ 
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "269fd60bec2d8a735ea27d4119024830098f5c9a3eec94ace82ccb0911de1867",
            "metadata": {},
            "name": "Nav4PlansListViewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider": (0, $95Z36.default)
            }
        }
    };
}();
$31e75d27297f8a2d$var$node.hash = "e67bfd2d42ed8352fb6fada08981300c";
var $31e75d27297f8a2d$export$2e2bcd8739ae039 = $31e75d27297f8a2d$var$node;

});

parcelRegister("c72oM", function(module, exports) {

let $8d17ffca45f5f69e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8d17ffca45f5f69e$var$load("kqK1D").then(()=>parcelRequire('2N2w4'));

});



parcelRegister("iC65q", function(module, exports) {

$parcel$export(module.exports, "Nav4PlansForLanding", () => $7e0bd176a951675e$export$5e6b364538aa2f20);

var $lkgPQ = parcelRequire("lkgPQ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $fb8Lj = parcelRequire("fb8Lj");

var $bQ7Ub = parcelRequire("bQ7Ub");

var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");
function $7e0bd176a951675e$export$5e6b364538aa2f20(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).PLANS);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const data = (0, $8Uumt.useFragment)((0, $lkgPQ.default), queryRef);
    const menuId = (0, $jhS4y.MENU_ID_PLANS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).PLANS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_PLANS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        elemBefore: icon,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bQ7Ub.PlansList), {
        fragmentRef: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fb8Lj.Nav4PlansFooter), null)));
}

});
parcelRegister("lkgPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $df8c46c4fcd1f5f0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bc8f47418a0aaa6d19370311cfed6f24>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $df8c46c4fcd1f5f0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4PlansForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PlansList"
        }
    ],
    "type": "Query"
};
$df8c46c4fcd1f5f0$var$node.hash = "4a68bb76768003096c8b0a4da492d88a";
var $df8c46c4fcd1f5f0$export$2e2bcd8739ae039 = $df8c46c4fcd1f5f0$var$node;

});

parcelRegister("bQ7Ub", function(module, exports) {

$parcel$export(module.exports, "PlansList", () => $fd1fb502ced6933e$export$610289543b80d1e7);

var $9Ye9m = parcelRequire("9Ye9m");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $9Gyp5 = parcelRequire("9Gyp5");

var $gxbcq = parcelRequire("gxbcq");

var $1b6zA = parcelRequire("1b6zA");

var $92lvB = parcelRequire("92lvB");

var $koeKL = parcelRequire("koeKL");

var $4IIGx = parcelRequire("4IIGx");
var $4vWwj = parcelRequire("4vWwj");
var $ch7sx = parcelRequire("ch7sx");
var $l3A2e = parcelRequire("l3A2e");

var $aQcVR = parcelRequire("aQcVR");

var $gT8yh = parcelRequire("gT8yh");

var $a6aJc = parcelRequire("a6aJc");
const $fd1fb502ced6933e$var$MAX_RECENT_PLANS = 5;
const $fd1fb502ced6933e$export$610289543b80d1e7 = ({ fragmentRef: fragmentRef })=>{
    const { isSelectedPath: isSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { getStableItems: getStableItems } = (0, $1b6zA.useStableItems)();
    const [data, refetch] = (0, $8Uumt.useRefetchableFragment)((0, $9Ye9m.default), fragmentRef);
    (0, $9Gyp5.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $92lvB.default,
        refetch: refetch,
        menuId: (0, $jhS4y.MENU_ID_PLANS)
    });
    const refetchOnChange = (0, $5uXOq.useCallback)(({ onComplete: onComplete })=>{
        refetch({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network',
            onComplete: onComplete
        });
    }, [
        cloudId,
        refetch
    ]);
    (0, $gxbcq.useSubscribeAndUpdateFavorites)({
        entityTypename: 'JiraPlan',
        favouriteConnectionId: data.jira.favouritePlans.__id,
        recentConnectionId: data.jira.recentPlans.__id,
        refetch: refetchOnChange
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const starred = formatMessage((0, $gT8yh.default).starred);
    const recent = formatMessage((0, $gT8yh.default).recent);
    const favorites = (0, $5uXOq.useMemo)(()=>{
        const ids = data.jira.favouritePlans.edges?.map((edge)=>edge?.node.id).filter(Boolean) ?? [];
        const list = data.jira.favouritePlans.edges?.filter(Boolean).map((edge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a6aJc.PlanMenuItem), {
                key: edge.node.planId,
                fragmentRef: edge.node,
                favouriteConnectionId: data.jira.favouritePlans.__id
            })) ?? [];
        return {
            idSet: new Set(ids),
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        data.jira.favouritePlans.__id,
        data.jira.favouritePlans.edges
    ]);
    const recentPlans = (0, $5uXOq.useMemo)(()=>{
        const nodes = data.jira.recentPlans.edges?.filter(Boolean).filter((edge)=>edge.node.id && !favorites.idSet.has(edge.node.id)).map((edge)=>edge.node).slice(0, $fd1fb502ced6933e$var$MAX_RECENT_PLANS) ?? [];
        const stableOrderedNodes = getStableItems({
            nodes: nodes,
            idKey: 'id'
        });
        const list = stableOrderedNodes.map((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a6aJc.PlanMenuItem), {
                key: node.planId,
                fragmentRef: node,
                favouriteConnectionId: data.jira.favouritePlans.__id
            }));
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        data.jira.favouritePlans.__id,
        data.jira.recentPlans.edges,
        favorites.idSet,
        getStableItems
    ]);
    if (!favorites.hasItems && !recentPlans.hasItems) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aQcVR.PlansEmptyContent), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, favorites.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4vWwj.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ch7sx.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l3A2e.MenuSectionHeading), null, starred), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, favorites.list))), recentPlans.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4vWwj.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ch7sx.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l3A2e.MenuSectionHeading), null, recent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, recentPlans.list))));
};

});
parcelRegister("9Ye9m", function(module, exports) {

$parcel$export(module.exports, "default", () => $231987b90f34a9fa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<120b845077a6318f4e9bf4f527b3a3e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $92lvB = parcelRequire("92lvB");
const $231987b90f34a9fa$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "planId"
    }, v3 = {
        "kind": "FragmentSpread",
        "name": "PlanMenuItem"
    }, v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURLPath"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $92lvB.default)
            }
        },
        "name": "PlansList",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "favouritePlans",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "PLAN"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v1 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.favouritePlans.edges.node.id"
                                                                },
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ],
                                                            "type": "JiraPlan"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.favouritePlans.edges.node"
                                            }
                                        ]
                                    },
                                    v4 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.favouritePlans"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "recentPlans",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "currentURL",
                                        "variableName": "currentURLPath"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "PLAN"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v1 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.recentPlans.edges.node.id"
                                                                },
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ],
                                                            "type": "JiraPlan"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.recentPlans.edges.node"
                                            }
                                        ]
                                    },
                                    v4 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.recentPlans"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$231987b90f34a9fa$var$node.hash = "c8de83b9c22a2a08040b53650c90d657";
var $231987b90f34a9fa$export$2e2bcd8739ae039 = $231987b90f34a9fa$var$node;

});
parcelRegister("92lvB", function(module, exports) {

$parcel$export(module.exports, "default", () => $1036deebd1a68627$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<10c6f582b6f208645f591ffa170ad461>>
 * @relayHash dc8a00662ff37b67d74342ec40bed340
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d42636d7783b046b016d9b617758731771505ab2695a72eb1ab950f3c0ec1101

var $95Z36 = parcelRequire("95Z36");
const $1036deebd1a68627$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "currentURLPath"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            v4 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v6 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "defaultNavigationItem",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "url"
                                                }
                                            ],
                                            "type": "JiraSoftwareBuiltInNavigationItem"
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v5 /*: any*/ 
            ]
        }
    ], v7 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PlanListQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "currentURLPath",
                            "variableName": "currentURLPath"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "PlansList"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "PlanListQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "favouritePlans",
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "PLAN"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v6 /*: any*/ 
                                },
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "recentPlans",
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "currentURL",
                                    "variableName": "currentURLPath"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "PLAN"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v6 /*: any*/ 
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d42636d7783b046b016d9b617758731771505ab2695a72eb1ab950f3c0ec1101",
            "metadata": {},
            "name": "PlanListQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider": (0, $95Z36.default)
            }
        }
    };
}();
$1036deebd1a68627$var$node.hash = "c8de83b9c22a2a08040b53650c90d657";
var $1036deebd1a68627$export$2e2bcd8739ae039 = $1036deebd1a68627$var$node;

});


parcelRegister("aQcVR", function(module, exports) {

$parcel$export(module.exports, "PlansEmptyContent", () => $eeca831f93fd0984$export$2b2efe96e6f14be5);

var $5uXOq = parcelRequire("5uXOq");

var $6eFvr = parcelRequire("6eFvr");

var $koVbs = parcelRequire("koVbs");

var $7lgBG = parcelRequire("7lgBG");

var $8Pg2W = parcelRequire("8Pg2W");
function $eeca831f93fd0984$export$2b2efe96e6f14be5() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7lgBG.EmptyContentMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $8Pg2W.default).noPlans)));
}

});
parcelRegister("8Pg2W", function(module, exports) {

$parcel$export(module.exports, "default", () => $07cf8d171bf729c5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $07cf8d171bf729c5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noPlans: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.empty-content.no-plans",
        "defaultMessage": "Once you open or create plans, they'll show up here."
    }
});

});


parcelRegister("gT8yh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b67eb75de0b9f683$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b67eb75de0b9f683$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.plans-list.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-plans.plans.common.plans-list.starred",
        "defaultMessage": "Starred"
    }
});

});

parcelRegister("a6aJc", function(module, exports) {

$parcel$export(module.exports, "PlanMenuItem", () => $73683d423a412055$export$5805f023607bba3d);

var $1rvIC = parcelRequire("1rvIC");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $aCAjf = parcelRequire("aCAjf");



var $jecJ3 = parcelRequire("jecJ3");

var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $2oTRI = parcelRequire("2oTRI");

var $8jQu6 = parcelRequire("8jQu6");

var $9VXkC = parcelRequire("9VXkC");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $9n0dK = parcelRequire("9n0dK");

var $1d5uQ = parcelRequire("1d5uQ");

var $4R6GH = parcelRequire("4R6GH");


var $bjtEO = parcelRequire("bjtEO");
const $73683d423a412055$var$VIEW_ALL_PLANS_HREF = (0, $8jQu6.plansDirectoryRoute).path;
const $73683d423a412055$export$5805f023607bba3d = ({ fragmentRef: fragmentRef, favouriteConnectionId: favouriteConnectionId })=>{
    const data = (0, $8Uumt.useFragment)((0, $1rvIC.default), fragmentRef);
    const planId = data?.planId;
    const isStarred = data?.favouriteValue?.isFavourite ?? false;
    const scenarioId = data.scenario.scenarioId;
    const planTitle = data.title || '';
    const planUrl = data.defaultNavigationItem?.url || (0, $9VXkC.generatePath)((0, $2oTRI.softwarePlanTimelineRoute).path, {
        planId: planId,
        scenarioId: scenarioId
    });
    const isReadOnly = data.isReadOnly || false;
    const isArchived = data.planStatus === 'ARCHIVED';
    const analytics = (0, $5uXOq.useMemo)(()=>({
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_PLANS],
            level: 1,
            componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
            itemId: (0, $632bd8725b437a12$export$c303e491e026ebc6),
            planId: planId ?? undefined,
            // TODO BLU-5544 send section via a single <ContextualAnalyticsData instead (which wraps the Starred or Recent panel). Use static object or useMemo, not to have rerendering issues.
            section: isStarred ? (0, $jecJ3.SECTION_ITEM_STARRED) : (0, $jecJ3.SECTION_ITEM_RECENT)
        }), [
        planId,
        isStarred
    ]);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            planId: planId,
            scenarioId: scenarioId,
            planTitle: planTitle,
            isReadOnly: isReadOnly,
            isArchived: isArchived,
            isStarred: isStarred,
            isUsedForSidebarNav: true,
            favouriteConnectionId: favouriteConnectionId
        }), [
        planId,
        scenarioId,
        planTitle,
        isReadOnly,
        isArchived,
        isStarred,
        favouriteConnectionId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $bjtEO.asyncPlanActionMenu), entryPointParams);
    const triggerRef = (0, $9n0dK.useHoverEntryPointTrigger)(entryPointActions);
    if (!data) return null;
    return planId && scenarioId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        analytics: analytics,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aCAjf))), {
            label: "",
            color: "currentColor"
        }),
        href: planUrl || $73683d423a412055$var$VIEW_ALL_PLANS_HREF,
        menuId: (0, $jhS4y.ENTITY_ID).PLAN(String(planId)),
        ref: (0, $4R6GH.fg)('blu-6100-plan-action-menu-entrypoint') ? triggerRef : undefined,
        actionsOnHover: (0, $4R6GH.fg)('blu-6100-plan-action-menu-entrypoint') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "nav4-sidebar-plan-action-menu",
            packageName: (0, $b0ee4c2dffa12273$export$b8b9d90f9e5bd72b),
            errorFallback: "flag",
            teamName: (0, $b0ee4c2dffa12273$export$d57b6b390e78d90f),
            runtimeProps: entryPointParams
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1d5uQ.PlanActionMenu), {
            planId: planId,
            scenarioId: scenarioId,
            planTitle: planTitle,
            isReadOnly: isReadOnly,
            isArchived: isArchived,
            isStarred: isStarred,
            isUsedForSidebarNav: true,
            favouriteConnectionId: favouriteConnectionId
        })
    }, planTitle);
};

});
parcelRegister("1rvIC", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d8c7f66b9423475$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ad0f12f4849b9a67be4a9939134d918e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7d8c7f66b9423475$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "PlanMenuItem",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "planId"
            },
            "action": "THROW",
            "path": "planId"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "isReadOnly"
        },
        {
            "kind": "ScalarField",
            "name": "planStatus"
        },
        {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                }
            ]
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraScenario",
                "kind": "LinkedField",
                "name": "scenario",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "scenarioId"
                        },
                        "action": "THROW",
                        "path": "scenario.scenarioId"
                    }
                ]
            },
            "action": "THROW",
            "path": "scenario"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "defaultNavigationItem",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                }
                            ],
                            "type": "JiraSoftwareBuiltInNavigationItem"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraPlan"
};
$7d8c7f66b9423475$var$node.hash = "7f7a892ec8cae58cbf0430a7e53973c3";
var $7d8c7f66b9423475$export$2e2bcd8739ae039 = $7d8c7f66b9423475$var$node;

});

parcelRegister("9n0dK", function(module, exports) {

$parcel$export(module.exports, "useHoverEntryPointTrigger", () => $d6bed0b5126727ff$export$129b8109f51bc05b);

var $5uXOq = parcelRequire("5uXOq");

var $47gW9 = parcelRequire("47gW9");
const $d6bed0b5126727ff$export$129b8109f51bc05b = (actions, isActive = true)=>{
    const eventMap = (0, $5uXOq.useMemo)(()=>({
            mouseenter: actions.load,
            focusin: actions.load
        }), [
        actions
    ]);
    return (0, $47gW9.useEntryPointButtonTrigger)(actions, isActive, eventMap);
};

});

parcelRegister("1d5uQ", function(module, exports) {

$parcel$export(module.exports, "PlanActionMenu", () => $0ccf34db8111d9c6$export$318b39ffb145c221);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");


var $4M7go = parcelRequire("4M7go");
const $0ccf34db8111d9c6$export$318b39ffb145c221 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "jira-plans-plan-action-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "plans-plan-action-menu",
        packageName: (0, $bb16664676a7b4ee$export$b8b9d90f9e5bd72b),
        teamName: (0, $bb16664676a7b4ee$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4M7go.PlanActionMenu), props)));

});
const $bb16664676a7b4ee$export$b8b9d90f9e5bd72b = 'jiraJetPlanActionMenu';
const $bb16664676a7b4ee$export$d57b6b390e78d90f = 'jet-chronos-team';
const $bb16664676a7b4ee$export$257be95a51c84145 = 'DUPLICATE';
const $bb16664676a7b4ee$export$a7c1ec142e70d69d = 'ARCHIVE';
const $bb16664676a7b4ee$export$2b848a0670941e75 = 'TRASH';
const $bb16664676a7b4ee$export$baea05a041537207 = 'plansNavigationMenuItem';

parcelRegister("4M7go", function(module, exports) {

$parcel$export(module.exports, "PlanActionMenu", () => $e0179333fb312a5a$export$318b39ffb145c221);

var $5uXOq = parcelRequire("5uXOq");

var $7mIBt = parcelRequire("7mIBt");

var $86vzA = parcelRequire("86vzA");

var $4qnvw = parcelRequire("4qnvw");

var $5AgDz = parcelRequire("5AgDz");

var $3vNgn = parcelRequire("3vNgn");

var $dnGcR = parcelRequire("dnGcR");

var $caKPP = parcelRequire("caKPP");

var $1lcIk = parcelRequire("1lcIk");

var $7H980 = parcelRequire("7H980");
var $44qT7 = parcelRequire("44qT7");
var $aOrxC = parcelRequire("aOrxC");
var $70rf1 = parcelRequire("70rf1");

var $6eFvr = parcelRequire("6eFvr");

var $89DrR = parcelRequire("89DrR");

var $4R6GH = parcelRequire("4R6GH");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $1UEDB = parcelRequire("1UEDB");


var $g295Q = parcelRequire("g295Q");

var $8pynQ = parcelRequire("8pynQ");

var $dUk9j = parcelRequire("dUk9j");

var $4hkqI = parcelRequire("4hkqI");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");

var $doZTA = parcelRequire("doZTA");


var $aIQvD = parcelRequire("aIQvD");

var $6DQw3 = parcelRequire("6DQw3");

var $1Vnxw = parcelRequire("1Vnxw");

var $5Gcoq = parcelRequire("5Gcoq");

var $gPwud = parcelRequire("gPwud");

var $b6Up7 = parcelRequire("b6Up7");

var $49Q1d = parcelRequire("49Q1d");

var $gPhGo = parcelRequire("gPhGo");
const $e0179333fb312a5a$export$318b39ffb145c221 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aIQvD.PlanActionMenuStoreContainer), {
        scope: props.isUsedForSidebarNav ? `sidebar-plan-${props.planId}` : 'main-plan'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e0179333fb312a5a$var$PlanActionMenuInternal, props));
const $e0179333fb312a5a$export$484cb592f6f633ea = ({ isStarred: isStarred, isArchived: isArchived, isReadOnly: isReadOnly, onChangeFavouriteClicked: onChangeFavouriteClicked, onDuplicateClicked: onDuplicateClicked, onSettingsMenuItemClicked: onSettingsMenuItemClicked, onArchiveRestoreClicked: onArchiveRestoreClicked, onDeleteClicked: onDeleteClicked, onHelpLinkClicked: onHelpLinkClicked, onTakeTourClicked: onTakeTourClicked })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), {
        testId: "jet-plan-action-menu.ui.menu-group"
    }, (0, $4R6GH.fg)('jet-fix-plan-action-menu') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        isList: true
    }, !isArchived && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        onClick: onChangeFavouriteClicked,
        iconBefore: isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($caKPP))), {
            label: "",
            color: "var(--ds-icon-accent-yellow, #B38600)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1lcIk))), {
            label: "",
            color: "currentColor"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text"
    }, isStarred ? formatMessage((0, $gPwud.default).unstarPlan) : formatMessage((0, $gPwud.default).starPlan))), !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        onClick: onDuplicateClicked,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86vzA))), {
            label: "",
            color: "currentColor"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text"
    }, formatMessage((0, $gPwud.default).duplicate))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dUk9j.SpotlightTarget), {
        name: (0, $g295Q.CttSpotlights).Settings,
        delayOn: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        onClick: onSettingsMenuItemClicked,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dnGcR))), {
            label: "",
            color: "currentColor"
        }),
        testId: "jet-plan-action-menu.ui.button-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text"
    }, formatMessage((0, $gPwud.default).planSettings)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        isList: true,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        onClick: onArchiveRestoreClicked,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7mIBt))), {
            label: "",
            color: "currentColor"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text"
    }, isArchived ? formatMessage((0, $gPwud.default).restore) : formatMessage((0, $gPwud.default).archive))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        onClick: onDeleteClicked,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4qnvw))), {
            label: "",
            color: "var(--ds-icon-danger, #C9372C)"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text.danger"
    }, formatMessage((0, $gPwud.default).trash)))))) : !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        isList: true
    }, !isArchived && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        onClick: onChangeFavouriteClicked,
        iconBefore: isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($caKPP))), {
            label: "",
            color: "var(--ds-icon-accent-yellow, #B38600)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1lcIk))), {
            label: "",
            color: "currentColor"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text"
    }, isStarred ? formatMessage((0, $gPwud.default).unstarPlan) : formatMessage((0, $gPwud.default).starPlan))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        onClick: onDuplicateClicked,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86vzA))), {
            label: "",
            color: "currentColor"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text"
    }, formatMessage((0, $gPwud.default).duplicate))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dUk9j.SpotlightTarget), {
        name: (0, $g295Q.CttSpotlights).Settings,
        delayOn: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        onClick: onSettingsMenuItemClicked,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dnGcR))), {
            label: "",
            color: "currentColor"
        }),
        testId: "jet-plan-action-menu.ui.button-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text"
    }, formatMessage((0, $gPwud.default).planSettings))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        isList: true,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        onClick: onArchiveRestoreClicked,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7mIBt))), {
            label: "",
            color: "currentColor"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text"
    }, isArchived ? formatMessage((0, $gPwud.default).restore) : formatMessage((0, $gPwud.default).archive))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        onClick: onDeleteClicked,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4qnvw))), {
            label: "",
            color: "var(--ds-icon-danger, #C9372C)"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text.danger"
    }, formatMessage((0, $gPwud.default).trash))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        isList: true,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44qT7.default), {
        onClick: onHelpLinkClicked,
        target: "_blank",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3vNgn))), {
            label: "",
            color: "currentColor"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text"
    }, formatMessage((0, $gPwud.default).help))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        onClick: onTakeTourClicked,
        iconBefore: (0, $4R6GH.fg)('plan_take_a_tour_icon_spacing') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5AgDz))), {
            label: "",
            color: "currentColor"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5AgDz))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text"
    }, formatMessage((0, $gPwud.default).takeTour)))));
};
const $e0179333fb312a5a$var$PlanActionMenuInternal = ({ planId: planId, scenarioId: scenarioId, planTitle: planTitle, isReadOnly: isReadOnly, isArchived: isArchived, isStarred: isStarred, isUsedForSidebarNav: isUsedForSidebarNav = false, favouriteConnectionId: favouriteConnectionId })=>{
    // eslint-disable-next-line jira/router/no-useRouter-in-components
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const [{ isOpen: isOpen }, { toggleMenu: toggleMenu, closeMenu: closeMenu }] = (0, $aIQvD.usePlanActionMenuStore)();
    const redirectToSpaPlanPage = (0, $4hkqI.useRedirectToSpaPlanPage)();
    const [modalState, setModalState] = (0, $5uXOq.useState)(undefined);
    const resetModalState = ()=>setModalState(undefined);
    const [onboarding, setOnboarding] = (0, $5uXOq.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const { loading: loading, data: data, update: updateResource } = (0, $1UEDB.usePlan)();
    const { setFavourite: setFavourite } = (0, $6DQw3.useSetFavourite)();
    const isThePlanAndScenarioSameAsInTheUrl = match.params ? (0, $gPhGo.isPlanAndScenarioMatchingUrl)({
        urlPlanId: match.params.planId,
        urlScenarioId: match.params.scenarioId,
        planId: planId,
        scenarioId: scenarioId
    }) : false;
    const updateUsePlanResource = (0, $5uXOq.useCallback)((newState)=>{
        if (isThePlanAndScenarioSameAsInTheUrl && data) updateResource((oldState)=>({
                ...oldState || data,
                ...newState
            }));
    }, [
        updateResource,
        isThePlanAndScenarioSameAsInTheUrl,
        data
    ]);
    const setPlanArchiveStatus = (0, $5uXOq.useCallback)(()=>{
        if (data) {
            const newStatus = data.planStatus === 'ARCHIVED' ? 'ACTIVE' : 'ARCHIVED';
            updateUsePlanResource({
                planStatus: newStatus
            });
        }
    }, [
        updateUsePlanResource,
        data
    ]);
    const toggleFavourite = (0, $5uXOq.useCallback)(()=>{
        const entityId = (0, $89DrR.JiraPlanAri).create({
            siteId: cloudId,
            activationId: activationId,
            planId: String(planId)
        }).toString();
        const onErrorCallback = ()=>{
            // If setFavourite API call fails, we want to revert the usePlan resource.
            updateUsePlanResource({
                isFavourite: isStarred
            });
        };
        setFavourite({
            entityId: entityId,
            favouriteConnectionId: favouriteConnectionId,
            planTitle: data?.title || '',
            isFavourite: !isStarred,
            onErrorCallback: onErrorCallback
        });
        updateUsePlanResource({
            isFavourite: !isStarred
        });
    }, [
        data,
        planId,
        cloudId,
        activationId,
        isStarred,
        favouriteConnectionId,
        updateUsePlanResource,
        setFavourite
    ]);
    const openInProductHelp = (0, $5Zxxp.useHelpPanelLink)();
    const onPlanMenuButtonClicked = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $bb16664676a7b4ee$export$baea05a041537207),
            attributes: {
                itemId: 'meatballDropdown',
                componentType: 'fixedItemButton',
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const onHelpLinkClicked = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdown',
            actionSubjectId: (0, $bb16664676a7b4ee$export$baea05a041537207),
            attributes: {
                itemId: 'openHelpPanel',
                componentType: 'fixedItemDropdownAction',
                parentItemId: 'plans',
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1)
            }
        });
        openInProductHelp('');
        closeMenu();
    }, [
        createAnalyticsEvent,
        closeMenu,
        openInProductHelp
    ]);
    const onTakeTourClicked = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdown',
            actionSubjectId: (0, $bb16664676a7b4ee$export$baea05a041537207),
            attributes: {
                itemId: 'takePlanTour',
                componentType: 'fixedItemDropdownAction',
                parentItemId: 'plans'
            }
        });
        redirectToSpaPlanPage('/timeline', {
            planId: String(planId),
            scenarioId: String(scenarioId)
        });
        setOnboarding(Math.random().toString(36).substring(2));
        closeMenu();
    }, [
        createAnalyticsEvent,
        redirectToSpaPlanPage,
        closeMenu,
        planId,
        scenarioId
    ]);
    const onDuplicateClicked = (0, $5uXOq.useCallback)(()=>{
        setModalState((0, $bb16664676a7b4ee$export$257be95a51c84145));
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdown',
            actionSubjectId: (0, $bb16664676a7b4ee$export$baea05a041537207),
            attributes: {
                itemId: 'duplicatePlan',
                componentType: 'fixedItemDropdownAction',
                parentItemId: 'plans',
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1)
            }
        });
        closeMenu();
    }, [
        createAnalyticsEvent,
        closeMenu
    ]);
    const onDeleteClicked = (0, $5uXOq.useCallback)(()=>{
        setModalState((0, $bb16664676a7b4ee$export$2b848a0670941e75));
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdown',
            actionSubjectId: (0, $bb16664676a7b4ee$export$baea05a041537207),
            attributes: {
                itemId: 'movePlanToTrash',
                componentType: 'fixedItemDropdownAction',
                parentItemId: 'plans',
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1)
            }
        });
        closeMenu();
    }, [
        createAnalyticsEvent,
        closeMenu
    ]);
    const onArchiveRestoreClicked = (0, $5uXOq.useCallback)(()=>{
        setModalState((0, $bb16664676a7b4ee$export$a7c1ec142e70d69d));
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdown',
            actionSubjectId: (0, $bb16664676a7b4ee$export$baea05a041537207),
            attributes: {
                itemId: isArchived ? 'restorePlan' : 'archivePlan',
                componentType: 'fixedItemDropdownAction',
                parentItemId: 'plans',
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1)
            }
        });
        closeMenu();
    }, [
        createAnalyticsEvent,
        isArchived,
        closeMenu
    ]);
    const onChangeFavouriteClicked = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdown',
            actionSubjectId: (0, $bb16664676a7b4ee$export$baea05a041537207),
            attributes: {
                itemId: 'favoritePlan',
                componentType: 'fixedItemDropdownAction',
                parentItemId: 'plans',
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1)
            }
        });
        toggleFavourite();
        closeMenu();
    }, [
        createAnalyticsEvent,
        toggleFavourite,
        closeMenu
    ]);
    const onSettingsMenuItemClicked = (0, $5uXOq.useCallback)(()=>{
        redirectToSpaPlanPage('/settings/scheduling', {
            planId: String(planId),
            scenarioId: String(scenarioId)
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdown',
            actionSubjectId: (0, $bb16664676a7b4ee$export$baea05a041537207),
            attributes: {
                itemId: 'openPlanSettings',
                componentType: 'fixedItemDropdownAction',
                parentItemId: 'plans',
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1)
            }
        });
        closeMenu();
    }, [
        createAnalyticsEvent,
        planId,
        redirectToSpaPlanPage,
        scenarioId,
        closeMenu
    ]);
    const closeOnboarding = (0, $5uXOq.useCallback)((options)=>!options?.silent && setOnboarding(undefined), []);
    const MenuItems = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e0179333fb312a5a$export$484cb592f6f633ea, {
            isStarred: isStarred,
            isArchived: isArchived,
            isReadOnly: isReadOnly,
            onChangeFavouriteClicked: onChangeFavouriteClicked,
            onDuplicateClicked: onDuplicateClicked,
            onSettingsMenuItemClicked: onSettingsMenuItemClicked,
            onArchiveRestoreClicked: onArchiveRestoreClicked,
            onDeleteClicked: onDeleteClicked,
            onHelpLinkClicked: onHelpLinkClicked,
            onTakeTourClicked: onTakeTourClicked
        }), [
        isStarred,
        onChangeFavouriteClicked,
        onDuplicateClicked,
        onSettingsMenuItemClicked,
        onArchiveRestoreClicked,
        onDeleteClicked,
        onHelpLinkClicked,
        onTakeTourClicked,
        isArchived,
        isReadOnly
    ]);
    if (isThePlanAndScenarioSameAsInTheUrl && (loading || !data)) return;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b6Up7.MoreNavMenuButton), {
        isOpen: isOpen,
        MenuItems: MenuItems,
        onClick: ()=>{
            if (!isOpen) onPlanMenuButtonClicked();
            toggleMenu();
        },
        onCloseMenu: closeMenu,
        isUsedForSidebarNav: isUsedForSidebarNav
    }), modalState === (0, $bb16664676a7b4ee$export$257be95a51c84145) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Gcoq.DuplicatePlanModal), {
        planId: Number(planId),
        planTitle: planTitle,
        setClosed: resetModalState
    }), modalState === (0, $bb16664676a7b4ee$export$2b848a0670941e75) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $49Q1d.TrashPlanModal), {
        planId: Number(planId),
        setClosed: resetModalState,
        planTitle: planTitle
    }), modalState === (0, $bb16664676a7b4ee$export$a7c1ec142e70d69d) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Vnxw.ArchivePlanModal), {
        planId: Number(planId),
        scenarioId: Number(scenarioId),
        planTitle: planTitle,
        isArchived: isArchived,
        setClosed: resetModalState,
        setPlanArchiveStatus: setPlanArchiveStatus
    }), onboarding && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pynQ.Onboarding), {
        visible: true,
        key: onboarding,
        onClose: closeOnboarding
    }));
};

});
parcelRegister("7mIBt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::542b8587e912458cb1fe6aa28ca83d10>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $55cd2fc561012e90$var$_react = $55cd2fc561012e90$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $55cd2fc561012e90$var$_archiveBox = $55cd2fc561012e90$var$_interopRequireDefault((parcelRequire("lgPyf")));

var $55cd2fc561012e90$var$_archive = $55cd2fc561012e90$var$_interopRequireDefault((parcelRequire("wjLwN")));
function $55cd2fc561012e90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArchiveBoxIcon.
 * This component is ArchiveBoxIcon, with `UNSAFE_fallbackIcon` set to "ArchiveIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $55cd2fc561012e90$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $55cd2fc561012e90$var$_react.default.createElement($55cd2fc561012e90$var$_archiveBox.default, Object.assign({
        LEGACY_fallbackIcon: $55cd2fc561012e90$var$_archive.default
    }, props));
$55cd2fc561012e90$var$ArchiveBoxIcon.Name = 'ArchiveBoxIconMigration';
var $55cd2fc561012e90$var$_default = module.exports.default = $55cd2fc561012e90$var$ArchiveBoxIcon;

});
parcelRegister("lgPyf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53af402aec64299fbaefa11fd3d04c88>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7c314a31c145780$var$_react = $f7c314a31c145780$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f7c314a31c145780$var$_baseNew = $f7c314a31c145780$var$_interopRequireDefault((parcelRequire("enEmH")));
function $f7c314a31c145780$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArchiveBox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7c314a31c145780$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $f7c314a31c145780$var$_react.default.createElement($f7c314a31c145780$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v5h-1v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6H1zm2.5 5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V6zm10-1.5h-11v-2h11zm-3 4.5h-5V7.5h5z" clip-rule="evenodd"/>`
    }, props));
$f7c314a31c145780$var$ArchiveBoxIcon.displayName = 'ArchiveBoxIcon';
var $f7c314a31c145780$var$_default = module.exports.default = $f7c314a31c145780$var$ArchiveBoxIcon;

});

parcelRegister("wjLwN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0612524e773ce519$var$_react = $0612524e773ce519$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $0612524e773ce519$var$_archiveBox = $0612524e773ce519$var$_interopRequireDefault((parcelRequire("lgPyf")));
function $0612524e773ce519$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0612524e773ce519$var$ArchiveIcon = (props)=>/*#__PURE__*/ $0612524e773ce519$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 3H4.85A2 2 0 0 0 3 5v4h1v10.45A1.67 1.67 0 0 0 5.77 21h12.46A1.67 1.67 0 0 0 20 19.45V9h1V5a2 2 0 0 0-2-2m-1 16H6V9h12zm1-12H5V5h14zm-4 7H9v-2h6z" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $0612524e773ce519$var$_archiveBox.default
    }));
$0612524e773ce519$var$ArchiveIcon.displayName = 'ArchiveIcon';
var $0612524e773ce519$var$_default = module.exports.default = $0612524e773ce519$var$ArchiveIcon;

});


parcelRegister("86vzA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::746afd86dff7a846534476462b8fe4e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e675ffdbb1e2869$var$_react = $5e675ffdbb1e2869$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5e675ffdbb1e2869$var$_copy = $5e675ffdbb1e2869$var$_interopRequireDefault((parcelRequire("lGgwk")));

var $5e675ffdbb1e2869$var$_copy2 = $5e675ffdbb1e2869$var$_interopRequireDefault((parcelRequire("4eDNL")));
function $5e675ffdbb1e2869$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5e675ffdbb1e2869$var$CopyIcon = (props)=>/*#__PURE__*/ $5e675ffdbb1e2869$var$_react.default.createElement($5e675ffdbb1e2869$var$_copy.default, Object.assign({
        LEGACY_fallbackIcon: $5e675ffdbb1e2869$var$_copy2.default
    }, props));
$5e675ffdbb1e2869$var$CopyIcon.Name = 'CopyIconMigration';
var $5e675ffdbb1e2869$var$_default = module.exports.default = $5e675ffdbb1e2869$var$CopyIcon;

});
parcelRegister("4eDNL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $315758064ed07d4d$var$_react = $315758064ed07d4d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $315758064ed07d4d$var$_copy = $315758064ed07d4d$var$_interopRequireDefault((parcelRequire("lGgwk")));
function $315758064ed07d4d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $315758064ed07d4d$var$CopyIcon = (props)=>/*#__PURE__*/ $315758064ed07d4d$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $315758064ed07d4d$var$_copy.default
    }));
$315758064ed07d4d$var$CopyIcon.displayName = 'CopyIcon';
var $315758064ed07d4d$var$_default = module.exports.default = $315758064ed07d4d$var$CopyIcon;

});


parcelRegister("5AgDz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ac8ee7dfd9e5ca9b5d73c3de75009b06>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $410d3858287f3ef1$var$_react = $410d3858287f3ef1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $410d3858287f3ef1$var$_flag = $410d3858287f3ef1$var$_interopRequireDefault((parcelRequire("cF7iY")));

var $410d3858287f3ef1$var$_flags = $410d3858287f3ef1$var$_interopRequireDefault((parcelRequire("a68Cn")));
function $410d3858287f3ef1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FlagIcon.
 * This component is FlagIcon, with `UNSAFE_fallbackIcon` set to "EmojiFlagsIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: flags in Editor, feature flags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $410d3858287f3ef1$var$FlagIcon = (props)=>/*#__PURE__*/ $410d3858287f3ef1$var$_react.default.createElement($410d3858287f3ef1$var$_flag.default, Object.assign({
        LEGACY_fallbackIcon: $410d3858287f3ef1$var$_flags.default
    }, props));
$410d3858287f3ef1$var$FlagIcon.Name = 'FlagIconMigration';
var $410d3858287f3ef1$var$_default = module.exports.default = $410d3858287f3ef1$var$FlagIcon;

});
parcelRegister("cF7iY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16a72127bfc0e3d91a970ca1d9129c37>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $937efb01f22f0613$var$_react = $937efb01f22f0613$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $937efb01f22f0613$var$_baseNew = $937efb01f22f0613$var$_interopRequireDefault((parcelRequire("enEmH")));
function $937efb01f22f0613$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Flag".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: flags in Editor, feature flags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $937efb01f22f0613$var$FlagIcon = (props)=>/*#__PURE__*/ $937efb01f22f0613$var$_react.default.createElement($937efb01f22f0613$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.22 1.22A.75.75 0 0 1 2.75 1H14a.75.75 0 0 1 .6 1.2l-2.662 3.55L14.6 9.3a.75.75 0 0 1-.6 1.2H3.5V15H2V1.75a.75.75 0 0 1 .22-.53M3.5 9h9l-2.1-2.8a.75.75 0 0 1 0-.9l2.1-2.8h-9z" clip-rule="evenodd"/>`
    }, props));
$937efb01f22f0613$var$FlagIcon.displayName = 'FlagIcon';
var $937efb01f22f0613$var$_default = module.exports.default = $937efb01f22f0613$var$FlagIcon;

});

parcelRegister("a68Cn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $01e5b22a7d35614b$var$_react = $01e5b22a7d35614b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $01e5b22a7d35614b$var$_flag = $01e5b22a7d35614b$var$_interopRequireDefault((parcelRequire("cF7iY")));
function $01e5b22a7d35614b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $01e5b22a7d35614b$var$EmojiFlagsIcon = (props)=>/*#__PURE__*/ $01e5b22a7d35614b$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.7 5.7 0 0 0 2.547-.567 1 1 0 0 0 .563-.9V5.466a.998.998 0 0 0-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 0 0 6 5.466zm3.111-1.48c1.094 0 2.148.256 3.129.495 1.381.335 2.6.63 3.768.289V6.836c-1.488.27-2.93-.08-4.24-.398-1.379-.335-2.598-.632-3.768-.29v4.704a6 6 0 0 1 1.111-.097"/></svg>`
    }, props, {
        newIcon: $01e5b22a7d35614b$var$_flag.default
    }));
$01e5b22a7d35614b$var$EmojiFlagsIcon.displayName = 'EmojiFlagsIcon';
var $01e5b22a7d35614b$var$_default = module.exports.default = $01e5b22a7d35614b$var$EmojiFlagsIcon;

});


parcelRegister("caKPP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b98083f7180ee5a6483375174c0842e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8dcabfa799419cb8$var$_react = $8dcabfa799419cb8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8dcabfa799419cb8$var$_starStarred = $8dcabfa799419cb8$var$_interopRequireDefault((parcelRequire("X3Phd")));

var $8dcabfa799419cb8$var$_starFilled = $8dcabfa799419cb8$var$_interopRequireDefault((parcelRequire("awkL7")));
function $8dcabfa799419cb8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StarStarredIcon.
 * This component is StarStarredIcon, with `UNSAFE_fallbackIcon` set to "StarFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8dcabfa799419cb8$var$StarStarredIcon = (props)=>/*#__PURE__*/ $8dcabfa799419cb8$var$_react.default.createElement($8dcabfa799419cb8$var$_starStarred.default, Object.assign({
        LEGACY_fallbackIcon: $8dcabfa799419cb8$var$_starFilled.default
    }, props));
$8dcabfa799419cb8$var$StarStarredIcon.Name = 'StarStarredIconMigration';
var $8dcabfa799419cb8$var$_default = module.exports.default = $8dcabfa799419cb8$var$StarStarredIcon;

});

parcelRegister("1lcIk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::981bc152c9d73fe857301cf222775bab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0fa19d558bcef4b4$var$_react = $0fa19d558bcef4b4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0fa19d558bcef4b4$var$_starUnstarred = $0fa19d558bcef4b4$var$_interopRequireDefault((parcelRequire("fkyxu")));

var $0fa19d558bcef4b4$var$_star = $0fa19d558bcef4b4$var$_interopRequireDefault((parcelRequire("k71Jv")));
function $0fa19d558bcef4b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StarUnstarredIcon.
 * This component is StarUnstarredIcon, with `UNSAFE_fallbackIcon` set to "StarIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0fa19d558bcef4b4$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $0fa19d558bcef4b4$var$_react.default.createElement($0fa19d558bcef4b4$var$_starUnstarred.default, Object.assign({
        LEGACY_fallbackIcon: $0fa19d558bcef4b4$var$_star.default
    }, props));
$0fa19d558bcef4b4$var$StarUnstarredIcon.Name = 'StarUnstarredIconMigration';
var $0fa19d558bcef4b4$var$_default = module.exports.default = $0fa19d558bcef4b4$var$StarUnstarredIcon;

});

parcelRegister("5Zxxp", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $b0d1b3c2fea05784$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $b0d1b3c2fea05784$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $8zIDr = parcelRequire("8zIDr");

var $4R6GH = parcelRequire("4R6GH");

var $6BNJk = parcelRequire("6BNJk");

var $kspz4 = parcelRequire("kspz4");

var $hsmeR = parcelRequire("hsmeR");

var $6s1PB = parcelRequire("6s1PB");
const $b0d1b3c2fea05784$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $kspz4.useHelpPanelActions)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $6BNJk.HELP_PANEL_ID), (0, $6BNJk.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: type
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: type
            }
        });
    };
    return handleOnClick;
};
const $b0d1b3c2fea05784$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, // unused, but needs to be here so it's not passed to Link/Button in the ...props splat
...props })=>{
    const onOpenInProductHelpArticle = $b0d1b3c2fea05784$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        if ((0, $4R6GH.fg)('help_panel_as_link')) event.preventDefault();
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle(articleId, type);
    };
    if ((0, $4R6GH.fg)('help_panel_as_link')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zIDr.default), {
        ...props,
        onClick: handleOnClick,
        href: href ?? 'https://support.atlassian.com',
        appearance: "default",
        testId: props.testId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        ...props,
        appearance: props.appearance === 'subtle-link' && (0, $6s1PB.expVal)('m1_features_page_experiment', 'cohort', 'not-enrolled') === 'variation' ? 'link' : props.appearance,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            props.appearance === 'subtle-link' && (0, $6s1PB.expVal)('m1_features_page_experiment', 'cohort', 'not-enrolled') === 'variation' && "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1"
        ])
    }, children);
};
var $b0d1b3c2fea05784$export$2e2bcd8739ae039 = $b0d1b3c2fea05784$var$HelpPanelLink;
const $b0d1b3c2fea05784$var$buttonWrapperStyles = null;
const $b0d1b3c2fea05784$var$buttonWrapperSubtleStyles = null;

});
parcelRegister("6BNJk", function(module, exports) {

$parcel$export(module.exports, "HELP_PANEL_VERSION", () => $20386d7da4313ff0$export$c43c7444da662fa1);
$parcel$export(module.exports, "HELP_PANEL_ID", () => $20386d7da4313ff0$export$e99efa3985fa3c26);
$parcel$export(module.exports, "HELP_PANEL_WIDTH", () => $20386d7da4313ff0$export$23aa6670f346c214);

var $gwIPs = parcelRequire("gwIPs");
const $20386d7da4313ff0$export$c43c7444da662fa1 = '1';
const $20386d7da4313ff0$export$e99efa3985fa3c26 = 'helpPanel';
const $20386d7da4313ff0$export$23aa6670f346c214 = (0, $gwIPs.gridSize) * 46;

});

parcelRegister("kspz4", function(module, exports) {

$parcel$export(module.exports, "useHelpPanel", () => $aee6103177ce0723$export$3fe94d66377a53b8);
$parcel$export(module.exports, "useHelpPanelActions", () => $aee6103177ce0723$export$c61f56f4797e22db);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $jgGDm = parcelRequire("jgGDm");
const $aee6103177ce0723$export$3fe94d66377a53b8 = (0, $3sQ5x.createHook)((0, $jgGDm.default));
const $aee6103177ce0723$export$c61f56f4797e22db = (0, $3sQ5x.createHook)((0, $jgGDm.default), {
    selector: null
});
const $aee6103177ce0723$export$513717a84f55db1a = (0, $51nlc.createSubscriber)((0, $jgGDm.default), {
    displayName: 'HelpPanelSubscriber'
});
const $aee6103177ce0723$export$5f4de38bd79f4446 = (0, $51nlc.createSubscriber)((0, $jgGDm.default), {
    displayName: 'HelpPanelActionsSubscriber',
    selector: null
});

});
parcelRegister("jgGDm", function(module, exports) {

$parcel$export(module.exports, "default", () => $465615692863cce9$export$2e2bcd8739ae039);

var $eNf8a = parcelRequire("eNf8a");

var $iXqE5 = parcelRequire("iXqE5");

var $958ua = parcelRequire("958ua");
let $465615692863cce9$var$iphStorage;
const $465615692863cce9$var$createStorage = ()=>{
    if ($465615692863cce9$var$iphStorage) return $465615692863cce9$var$iphStorage;
    $465615692863cce9$var$iphStorage = (0, $eNf8a.createSessionStorageProvider)('iph');
    return $465615692863cce9$var$iphStorage;
};
const $465615692863cce9$var$initialState = {
    navigationData: {
        articleId: {
            id: '',
            type: 'HELP_ARTICLE'
        },
        // FIXME: initialState breaks SSR
        history: false ? [] : $465615692863cce9$var$createStorage().get('navigationData') || []
    },
    releaseNotesNotifications: 100
};
var $465615692863cce9$export$2e2bcd8739ae039 = (0, $iXqE5.createStore)({
    name: 'help-panel',
    initialState: $465615692863cce9$var$initialState,
    actions: $958ua
});

});
parcelRegister("958ua", function(module, exports) {

$parcel$export(module.exports, "setNavigationData", () => $177ac56c5a5bf49e$export$ab1b80f40ca898ed);
$parcel$export(module.exports, "setReleaseNotesNotifications", () => $177ac56c5a5bf49e$export$cdabe01d01a8da1e);

var $eNf8a = parcelRequire("eNf8a");
const $177ac56c5a5bf49e$var$iphStorage = (0, $eNf8a.createSessionStorageProvider)('iph');
const $177ac56c5a5bf49e$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            navigationData: {
                articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                history: navigationData.history ? navigationData.history : currentState.navigationData.history
            }
        });
        $177ac56c5a5bf49e$var$iphStorage.set('history', []);
    };
const $177ac56c5a5bf49e$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
        setState({
            releaseNotesNotifications: releaseNotesNotifications
        });
    };

});



parcelRegister("hsmeR", function(module, exports) {

$parcel$export(module.exports, "useActiveRightSidebarState", () => $39a48ee662f10943$export$ba763ab7661c3103);
$parcel$export(module.exports, "useRightSidebarState", () => $39a48ee662f10943$export$d1828e7f46a4960b);
$parcel$export(module.exports, "useRightSidebarController", () => $39a48ee662f10943$export$ebe5e907fb0bb63a);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");

var $byk51 = parcelRequire("byk51");

var $5e5zm = parcelRequire("5e5zm");
const $39a48ee662f10943$var$useActiveRightSidebar = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>{
        const rightSidebarState = (0, $byk51.selectCurrentRightSidebar)(state.content.rightSidebar);
        if (!rightSidebarState) return null;
        return {
            ...rightSidebarState,
            shouldRender: !state.isChromeless
        };
    }
});
const $39a48ee662f10943$export$ba763ab7661c3103 = ()=>{
    const [rightSidebar] = $39a48ee662f10943$var$useActiveRightSidebar();
    return rightSidebar;
};
const $39a48ee662f10943$var$useRightSidebar = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.content.rightSidebar
});
const $39a48ee662f10943$export$d1828e7f46a4960b = ()=>{
    const [rightSidebarState] = $39a48ee662f10943$var$useRightSidebar();
    return rightSidebarState;
};
const $39a48ee662f10943$export$ebe5e907fb0bb63a = ()=>{
    const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, $5e5zm.useLayoutStoreActions)();
    return (0, $5uXOq.useMemo)(()=>({
            setRightSidebarState: setRightSidebarState,
            closeRightSidebar: closeRightSidebar,
            openRightSidebar: openRightSidebar,
            closeCurrentRightSidebar: closeCurrentRightSidebar,
            closeAllRightSidebar: closeAllRightSidebar,
            minimiseRightSidebar: minimiseRightSidebar
        }), [
        closeAllRightSidebar,
        closeCurrentRightSidebar,
        closeRightSidebar,
        openRightSidebar,
        setRightSidebarState,
        minimiseRightSidebar
    ]);
};

});
parcelRegister("byk51", function(module, exports) {

$parcel$export(module.exports, "selectCurrentRightSidebar", () => $4dabd377b098e1a2$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $4dabd377b098e1a2$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $4dabd377b098e1a2$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $4dabd377b098e1a2$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $4dabd377b098e1a2$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $4dabd377b098e1a2$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $4dabd377b098e1a2$export$c8dafe074328c4ca);

var $ajpes = parcelRequire("ajpes");
const $4dabd377b098e1a2$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $4dabd377b098e1a2$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $4dabd377b098e1a2$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $4dabd377b098e1a2$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $4dabd377b098e1a2$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $4dabd377b098e1a2$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $4dabd377b098e1a2$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $4dabd377b098e1a2$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $4dabd377b098e1a2$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});

parcelRegister("5e5zm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $0c99a19d69d506cf$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $0c99a19d69d506cf$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $0c99a19d69d506cf$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $0c99a19d69d506cf$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $0c99a19d69d506cf$export$99e05a60cac05e86);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $8CM3x = parcelRequire("8CM3x");
const $0c99a19d69d506cf$export$539e68c09584883a = 240;
const $0c99a19d69d506cf$export$b92df8810d2fcd01 = 0;
const $0c99a19d69d506cf$var$initialState = {
    isChromeless: false,
    isFullscreen: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $0c99a19d69d506cf$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false
        },
        rightSidebar: {
            stackState: []
        }
    }
};
const $0c99a19d69d506cf$export$b8cdfd44cddaf07 = (0, $iXqE5.createStore)({
    initialState: $0c99a19d69d506cf$var$initialState,
    actions: $8CM3x.actions,
    name: 'JiraLayoutStore'
});
const $0c99a19d69d506cf$export$6136bc3b9858cff4 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$export$b8cdfd44cddaf07, {
    selector: null
});
const $0c99a19d69d506cf$var$detailPanelWidthStore = (0, $iXqE5.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $0c99a19d69d506cf$export$95fd7b6da3b9bbb0 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
const $0c99a19d69d506cf$export$99e05a60cac05e86 = (0, $3sQ5x.createActionsHook)($0c99a19d69d506cf$var$detailPanelWidthStore);

});
parcelRegister("8CM3x", function(module, exports) {

$parcel$export(module.exports, "actions", () => $939ad82f8ddcb8d9$export$e324594224ef24da);

var $4oU0I = parcelRequire("4oU0I");

var $flhve = parcelRequire("flhve");

var $f5TQt = parcelRequire("f5TQt");

var $hPsAX = parcelRequire("hPsAX");

var $gqQUV = parcelRequire("gqQUV");

var $byk51 = parcelRequire("byk51");
const $939ad82f8ddcb8d9$export$e324594224ef24da = {
    setIsChromeless: // global
    $f5TQt.setIsChromeless,
    setIsFullscreen: $hPsAX.setIsFullscreen,
    showBanner: // banner
    $4oU0I.showBanner,
    dismissCurrentBanner: $4oU0I.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $gqQUV.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $byk51.setRightSidebarState,
    openRightSidebar: $byk51.openRightSidebar,
    closeRightSidebar: $byk51.closeRightSidebar,
    closeAllRightSidebar: $byk51.closeAllRightSidebar,
    closeCurrentRightSidebar: $byk51.closeCurrentRightSidebar,
    minimiseRightSidebar: $byk51.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $flhve.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $flhve.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $flhve.removeBottomRightCornerPortal
};

});
parcelRegister("4oU0I", function(module, exports) {

$parcel$export(module.exports, "showBanner", () => $820929f36789bf81$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $820929f36789bf81$export$a45bccc0cc9ac424);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $820929f36789bf81$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $820929f36789bf81$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($820929f36789bf81$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("flhve", function(module, exports) {

$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $560ff4740e75fa9e$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $560ff4740e75fa9e$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $560ff4740e75fa9e$export$928bf7e228ce06d2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $560ff4740e75fa9e$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $560ff4740e75fa9e$export$3ed25a6bee272520 = (item)=>// @ts-expect-error - TS2322 - Type '({ setState, getState }: StoreActionApi<LayoutState>) => number' is not assignable to type 'Action<LayoutState, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $560ff4740e75fa9e$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("f5TQt", function(module, exports) {

$parcel$export(module.exports, "setIsChromeless", () => $0389a2d5715d1f25$export$1998c4816ad37edb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $0389a2d5715d1f25$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("hPsAX", function(module, exports) {

$parcel$export(module.exports, "setIsFullscreen", () => $e3c9e6899dc6b3f0$export$9c73b2f282069160);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e3c9e6899dc6b3f0$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
        setState({
            isFullscreen: isFullscreen
        });
    };

});

parcelRegister("gqQUV", function(module, exports) {

$parcel$export(module.exports, "setLeftSidebarState", () => $54ca906cbb882b25$export$3e0fd2d894ef83c8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $54ca906cbb882b25$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});





parcelRegister("1UEDB", function(module, exports) {

$parcel$export(module.exports, "usePlan", () => $fe5ea6cf6b4cbe02$export$6734677f23034ac5);

var $c1N9v = parcelRequire("c1N9v");

var $2YP9W = parcelRequire("2YP9W");
const $fe5ea6cf6b4cbe02$export$6734677f23034ac5 = ()=>(0, $2YP9W.useResource)((0, $c1N9v.staticPlanSidebarNavigationResource));

});

parcelRegister("g295Q", function(module, exports) {

$parcel$export(module.exports, "CttSpotlights", () => $f81f0ad0752c64b1$export$d87db548b153c65d);
const $f81f0ad0752c64b1$export$d87db548b153c65d = {
    Inactive: 'INACTIVE',
    CreateIssue: 'portfolio-3/ctt-onboarding/create-issue',
    TitleInput: 'portfolio-3/ctt-onboarding/title-input',
    Settings: 'portfolio-3/ctt-onboarding/settings',
    IssueSources: 'portfolio-3/ctt-onboarding/issue-source',
    BackToPlan: 'portfolio-3/ctt-onboarding/back-to-plan',
    EpicSection: 'portfolio-3/ctt-onboarding/epic-section',
    Scope: 'portfolio-3/ctt-onboarding/scope',
    ReviewChanges: 'portfolio-3/ctt-onboarding/review-changes'
};

});

parcelRegister("8pynQ", function(module, exports) {

$parcel$export(module.exports, "Onboarding", () => $ca8d1bbbb0038aee$export$70238cd3868b67c9);

var $5uXOq = parcelRequire("5uXOq");

var $kweMg = parcelRequire("kweMg");

var $10zpr = parcelRequire("10zpr");
var $kW74I = parcelRequire("kW74I");
var $98UVV = parcelRequire("98UVV");

var $5Zxxp = parcelRequire("5Zxxp");

var $ePUEm = parcelRequire("ePUEm");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $iqLcb = parcelRequire("iqLcb");

var $1gQ7U = parcelRequire("1gQ7U");

var $5oFIy = parcelRequire("5oFIy");

var $aPRoZ = parcelRequire("aPRoZ");

var $aGkaA = parcelRequire("aGkaA");

var $9yfXJ = parcelRequire("9yfXJ");

var $eld9u = parcelRequire("eld9u");

var $taGZB = parcelRequire("taGZB");

var $6IYrl = parcelRequire("6IYrl");

var $eNZ9d = parcelRequire("eNZ9d");

var $kRDXu = parcelRequire("kRDXu");

var $bHAma = parcelRequire("bHAma");

var $adqnA = parcelRequire("adqnA");
const $ca8d1bbbb0038aee$var$IconButtonStyles = {
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};
const $ca8d1bbbb0038aee$export$70238cd3868b67c9 = (props)=>{
    const useCurrentSpotlight = (0, $3HwlS.getWillShowNav4)() ? (0, $aPRoZ.useCurrentSpotlight) : (0, $aPRoZ.useCurrentSpotlightOld);
    const [{ visible: visible }, { init: init, close: close }] = (0, $adqnA.useController)(props);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [step, { next: next, start: start, finish: finish, skip: skip }] = (0, $adqnA.useStep)();
    const [{ spotlight: spotlight, currentStepCount: currentStepCount, totalStepCount: totalStepCount }, { reset: resetSpotlight, start: startSpotlight, next: nextSpotlight }] = useCurrentSpotlight();
    const { expandLeftSidebar: expandLeftSidebarChangingEveryRender } = (0, $iqLcb.usePageLayoutResize)();
    const [expandLeftSidebar] = (0, $5uXOq.useState)(()=>expandLeftSidebarChangingEveryRender);
    const openInProductHelp = (0, $5Zxxp.useHelpPanelLink)();
    (0, $5uXOq.useEffect)(()=>{
        init();
    }, [
        init
    ]);
    // Auto-start
    (0, $5uXOq.useEffect)(()=>{
        if (visible) start();
    }, [
        start,
        visible
    ]);
    // Start the spotlight
    (0, $5uXOq.useEffect)(()=>{
        if (step === 'spotlight') startSpotlight();
    }, [
        step,
        startSpotlight
    ]);
    // When the spotlight finishes
    (0, $5uXOq.useEffect)(()=>{
        if (spotlight === undefined) next();
    }, [
        next,
        spotlight
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (step === 'spotlight' && spotlight === (0, $aPRoZ.Spotlights).Views) expandLeftSidebar();
        if (step === 'flag') {
            resetSpotlight();
            close({
                silent: true
            });
        }
        if (step === 'finished') {
            if ((0, $adqnA.isCrossTeamPlanningTemplateExperimentEnabled)()) // We must ensure the 'CLOSED' state of the plans onboarding is set on the state
            // when the plans onboarding finishes to allow display of onboardings that follow
            close({
                silent: false
            });
            else close();
        }
    }, [
        step,
        spotlight,
        resetSpotlight,
        expandLeftSidebar,
        close
    ]);
    const spotlightActions = ({ learnMoreURL: learnMoreURL })=>{
        const nextAction = {
            onClick: nextSpotlight,
            text: formatMessage((0, $9yfXJ.messages).spotlightNext)
        };
        return learnMoreURL ? [
            nextAction,
            {
                text: formatMessage((0, $9yfXJ.messages).spotlightLearnMore),
                appearance: 'subtle-link',
                href: learnMoreURL,
                target: '_blank'
            }
        ] : [
            nextAction
        ];
    };
    const spotlightHeadingAfterElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1gQ7U.IconButton), {
        onClick: skip,
        ariaLabel: formatMessage((0, $9yfXJ.messages).spotlightCloseLabel),
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $ca8d1bbbb0038aee$var$IconButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kweMg))), {
        LEGACY_size: "small",
        label: "",
        color: "currentColor"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kW74I.default), null, step === 'modal' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10zpr.default), {
        heading: formatMessage((0, $9yfXJ.messages).modalHeadingPlansSpork),
        header: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePUEm.default), {
                alt: ""
            }),
        actions: [
            {
                onClick: finish,
                appearance: 'subtle',
                text: formatMessage((0, $9yfXJ.messages).modalSkip)
            },
            {
                onClick: next,
                appearance: 'primary',
                text: formatMessage((0, $9yfXJ.messages).modalTakeTour)
            }
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "modal",
        action: "viewed",
        actionSubjectId: "advancedRoadmapsOnboarding"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $9yfXJ.messages).modalContentParagraphPlansSpork))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $98UVV.default), null, step === 'spotlight' && spotlight === (0, $aPRoZ.Spotlights).HeartOfPlan && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $taGZB.HeartOfPlanSpotlight), {
        target: (0, $aPRoZ.Spotlights).HeartOfPlan,
        actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
        actions: spotlightActions,
        headingAfterElement: spotlightHeadingAfterElement
    }), step === 'spotlight' && spotlight === (0, $aPRoZ.Spotlights).ListMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6IYrl.ListModeSpotlight), {
        target: (0, $aPRoZ.Spotlights).ListMode,
        actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
        actions: spotlightActions,
        headingAfterElement: spotlightHeadingAfterElement
    }), step === 'spotlight' && spotlight === (0, $aPRoZ.Spotlights).Views && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bHAma.ViewsSpotlight), {
        target: (0, $aPRoZ.Spotlights).Views,
        actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
        actions: spotlightActions,
        headingAfterElement: spotlightHeadingAfterElement
    }), step === 'spotlight' && spotlight === (0, $aPRoZ.Spotlights).ShowAndTell && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kRDXu.ShowAndTellSpotlight), {
        target: (0, $aPRoZ.Spotlights).ShowAndTell,
        actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
        actions: spotlightActions,
        headingAfterElement: spotlightHeadingAfterElement
    }), step === 'spotlight' && spotlight === (0, $aPRoZ.Spotlights).SaveYourChanges && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eNZ9d.SaveYourChangesSpotlight), {
        target: (0, $aPRoZ.Spotlights).SaveYourChanges,
        actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
        actions: spotlightActions,
        headingAfterElement: spotlightHeadingAfterElement
    }), step === 'spotlight' && spotlight === (0, $aPRoZ.Spotlights).FindYourLook && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eld9u.FindYourLookSpotlight), {
        target: (0, $aPRoZ.Spotlights).FindYourLook,
        actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
        actions: spotlightActions,
        headingAfterElement: spotlightHeadingAfterElement
    })), step === 'flag' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aGkaA.FinishFlag), {
        onDismiss: next,
        openInProductHelp: openInProductHelp
    }));
};

});
parcelRegister("10zpr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c47915a0e850a8af$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1nSOt = parcelRequire("1nSOt");
var $ep3GE = parcelRequire("ep3GE");

var $hordk = parcelRequire("hordk");
var $g1QfP = parcelRequire("g1QfP");
var $i2ajl = parcelRequire("i2ajl");

var $4RcUC = parcelRequire("4RcUC");

var $65PNM = parcelRequire("65PNM");
class $c47915a0e850a8af$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { actions: actions, children: children, heading: heading, experimental_shouldShowPrimaryButtonOnRight: // All of the following props except `...rest` are unused but were being
        // spread into the Modal, which it does not accept.
        experimental_shouldShowPrimaryButtonOnRight, footer: footer, header: header, image: image, ...rest } = this.props;
        const Header = this.headerComponent(this.props);
        const Footer = this.footerComponent(this.props);
        const CustomHeader = ()=>{
            const { titleId: titleId } = (0, $i2ajl.useModal)();
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4RcUC.ModalHeading), {
                id: titleId,
                children: heading
            });
        };
        return(// TODO: This is a problem that needs solving: https://product-fabric.atlassian.net/browse/DSP-22238
        // eslint-disable-next-line @atlaskit/design-system/use-modal-dialog-close-button
        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hordk.default), {
            autoFocus: true,
            shouldCloseOnEscapePress: false,
            shouldCloseOnOverlayClick: false,
            shouldScrollInViewport: true,
            // @ts-ignore All of the following props were in the rest props, so I'm
            // making them explicit here even though the Modal doesn't accept them.
            experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight,
            footer: footer,
            header: header,
            heading: heading,
            image: image,
            ...rest,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)(Header, {}),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g1QfP.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4RcUC.ModalBody), {
                        children: [
                            heading && /*#__PURE__*/ (0, $2OMIu.jsx)(CustomHeader, {}),
                            children
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)(Footer, {})
            ]
        }));
    }
    constructor(...args){
        super(...args), this.headerComponent = (props)=>{
            const { header: HeaderElement, image: src } = props;
            const ImageElement = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4RcUC.ModalImage), {
                    src: src,
                    alt: ""
                });
            return HeaderElement || ImageElement;
        }, this.footerComponent = (props)=>{
            const { footer: FooterElement, actions: actionList, experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight = false } = props;
            const ActionsElement = ()=>actionList ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ep3GE.default).Provider, {
                    value: (0, $65PNM.modalButtonTheme),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4RcUC.ModalActionContainer), {
                        shouldReverseButtonOrder: experimental_shouldShowPrimaryButtonOnRight,
                        children: actionList.map(({ text: text, key: key, ...rest }, idx)=>{
                            const variant = idx ? 'subtle-link' : 'primary';
                            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4RcUC.ModalActionItem), {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1nSOt.default), {
                                    appearance: variant,
                                    autoFocus: !idx,
                                    ...rest,
                                    children: text
                                })
                            }, key || (typeof text === 'string' ? text : `${idx}`));
                        })
                    })
                }) : null;
            return FooterElement || ActionsElement;
        };
    }
}

});
parcelRegister("4RcUC", function(module, exports) {

$parcel$export(module.exports, "ModalBody", () => $0e02ae92fe658613$export$cb540d8b0ef7906c);
$parcel$export(module.exports, "ModalHeading", () => $0e02ae92fe658613$export$9af27c346834c182);
$parcel$export(module.exports, "ModalImage", () => $0e02ae92fe658613$export$1355685fd5f8d257);
$parcel$export(module.exports, "ModalActionContainer", () => $0e02ae92fe658613$export$633dda6b40ac1ac3);
$parcel$export(module.exports, "ModalActionItem", () => $0e02ae92fe658613$export$c245e9f76e3299b1);
/* modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5sRpy = parcelRequire("5sRpy");
const $0e02ae92fe658613$var$modalBodyStyles = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-array-arguments -- Ignored via go/DSP-18766
const $0e02ae92fe658613$var$modalHeadingStyles = null;
const $0e02ae92fe658613$var$modalImageStyles = null;
const $0e02ae92fe658613$var$modalActionContainerStyles = null;
const $0e02ae92fe658613$var$modalActionContainerReversedStyles = null;
const $0e02ae92fe658613$var$modalActionItemStyles = {
    root: "_6rth1b66 _1pfhze3t _12l21b66 _ahbq1b66"
};
const $0e02ae92fe658613$export$cb540d8b0ef7906c = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_85i51jfw _1q511jfw _y4tipxbi _bozgpxbi _y3gn1h6o"
        ]),
        children: children
    });
const $0e02ae92fe658613$export$9af27c346834c182 = ({ children: children, id: id })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h1", {
        id: id,
        className: (0, $bwpsq.default)([
            "_11c8lodh _syaz1kw7 _6rthu2gc"
        ]),
        children: children
    });
};
const $0e02ae92fe658613$export$1355685fd5f8d257 = ({ alt: alt, src: src })=>/*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        alt: alt,
        src: src,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1wug _5fbc1sit _1s1g1sit _j722idpf"
        ])
    });
const $0e02ae92fe658613$export$633dda6b40ac1ac3 = ({ children: children, shouldReverseButtonOrder: shouldReverseButtonOrder })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_2lx2vrvc _1n261g80 _1e0c1txw _1bah1h6o _85i514no _1q51ze3t _y4ti1jfw _bozg1jfw",
            shouldReverseButtonOrder && "_2lx21sbv"
        ]),
        children: children
    });
const $0e02ae92fe658613$export$c245e9f76e3299b1 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $0e02ae92fe658613$var$modalActionItemStyles.root,
        children: children
    });

});


parcelRegister("ePUEm", function(module, exports) {

$parcel$export(module.exports, "default", () => $571a362f39767dc7$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $dCLgq = parcelRequire("dCLgq");

var $cfHe5 = parcelRequire("cfHe5");
const $571a362f39767dc7$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($cfHe5)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($cfHe5))
});
var $571a362f39767dc7$export$2e2bcd8739ae039 = $571a362f39767dc7$var$Illustration;
// for advanced use only
const $571a362f39767dc7$export$a179c88182cb9d56 = [
    0,
    0,
    600,
    371
];

});
parcelRegister("dCLgq", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $191b30bb5e9fa934$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "createIllustration", () => $191b30bb5e9fa934$export$4d00e7be716a0093);

var $5uXOq = parcelRequire("5uXOq");

var $10ozQ = parcelRequire("10ozQ");
function $191b30bb5e9fa934$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10ozQ.AsImg), props);
}
function $191b30bb5e9fa934$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($191b30bb5e9fa934$export$d43c2e2ca9b2c105, {
            srcLight: srcLight,
            srcDark: srcDark,
            autoDark: autoDark,
            ...props
        });
}

});
parcelRegister("10ozQ", function(module, exports) {

$parcel$export(module.exports, "AsImg", () => $b5af8835f639f069$export$75e378065cb7d6c0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // This is an INTENTIONAL FORK of @atlaskit/image
// copied 2023-11-09 v1.1.6
// with permission from @DDC from Design System,
// in order to refine the API and use cases.
// Will be back-ported to @atlaskit/image https://hello.atlassian.net/browse/ERAI-1660

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");
// suggested defaults, the consumer is free to override
const $b5af8835f639f069$var$defaultStyles = null;
const $b5af8835f639f069$var$fillStyles = null;
const $b5af8835f639f069$var$autoDarkModeStyles = null;
function $b5af8835f639f069$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: colorMode === 'dark' ? srcDark : srcLight,
        alt: alt,
        "data-testid": testId,
        ...imgProps,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
            fill && "_1r04idpf _kqswstnw _1bsb1osq _4t3i1osq",
            colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
        ])
    });
}

});


parcelRegister("cfHe5", function(module, exports) {
module.exports = new URL("plans-review-changes.d344422b.gif", import.meta.url).toString();

});


parcelRegister("iqLcb", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $3d7d84f3bc65155e$export$6d1402fb58384e4f);
$parcel$export(module.exports, "Banner", () => $3d7d84f3bc65155e$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopNavigation", () => $3d7d84f3bc65155e$export$8a421bddecb2bf5b);
$parcel$export(module.exports, "LeftPanel", () => $3d7d84f3bc65155e$export$110709f040143804);
$parcel$export(module.exports, "LeftSidebarWithoutResize", () => $3d7d84f3bc65155e$export$43ae342508cf8cc9);
$parcel$export(module.exports, "LeftSidebar", () => $3d7d84f3bc65155e$export$3cabf771c4f2de);
$parcel$export(module.exports, "Main", () => $3d7d84f3bc65155e$export$861edd1ccea2f746);
$parcel$export(module.exports, "Content", () => $3d7d84f3bc65155e$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "RightSidebar", () => $3d7d84f3bc65155e$export$84d58c19c21f637f);
$parcel$export(module.exports, "RightPanel", () => $3d7d84f3bc65155e$export$364a989a35814102);
$parcel$export(module.exports, "useCustomSkipLink", () => $3d7d84f3bc65155e$export$ee6b12c2613bdf8e);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $3d7d84f3bc65155e$export$94561f6055639ef7);
$parcel$export(module.exports, "usePageLayoutResize", () => $3d7d84f3bc65155e$export$10c7104037a7af62);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", () => $3d7d84f3bc65155e$export$991ef8098f87814a);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$7eaf986ecb4d5cac);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$e95b388ca8c92019);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$2ab8b83eed76656c);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$ac017575d43f5da);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", () => $3d7d84f3bc65155e$export$d697087c06fd5e25);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $gWVyJ = parcelRequire("gWVyJ");
var $l2AH9 = parcelRequire("l2AH9");
var $iCvLW = parcelRequire("iCvLW");
var $56fJj = parcelRequire("56fJj");
var $by9S8 = parcelRequire("by9S8");
var $7Stls = parcelRequire("7Stls");
var $33D3Q = parcelRequire("33D3Q");
var $jreT6 = parcelRequire("jreT6");
var $3IHID = parcelRequire("3IHID");
var $7EYXE = parcelRequire("7EYXE");
var $3fzVB = parcelRequire("3fzVB");
var $02o6B = parcelRequire("02o6B");

var $3HwlS = parcelRequire("3HwlS");

var $geqKu = parcelRequire("geqKu");
var $7YDkZ = parcelRequire("7YDkZ");
var $gXjR2 = parcelRequire("gXjR2");
var $ehQHm = parcelRequire("ehQHm");
var $dkD6V = parcelRequire("dkD6V");
var $jN4ko = parcelRequire("jN4ko");
var $fZJPK = parcelRequire("fZJPK");
function $3d7d84f3bc65155e$export$6d1402fb58384e4f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dkD6V.Root), {
        UNSAFE_dangerouslyHoistSlotSizes: true,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $33D3Q.default), props);
}
function $3d7d84f3bc65155e$export$3b4e64e77073e307(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7YDkZ.Banner), {
        UNSAFE_height: props.height,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gWVyJ.default), props);
}
function $3d7d84f3bc65155e$export$8a421bddecb2bf5b(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fZJPK.TopBar), {
        UNSAFE_height: props.height,
        testId: props.testId,
        UNSAFE_theme: props.theme
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7EYXE.default), props);
}
function $3d7d84f3bc65155e$export$110709f040143804(props) {
    // LeftPanel is not supported in new page layout
    return (0, $3HwlS.getWillShowNav4)() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iCvLW.default), props);
}
function $3d7d84f3bc65155e$export$43ae342508cf8cc9(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jN4ko.SideNav), {
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $by9S8.default), props);
}
function $3d7d84f3bc65155e$export$3cabf771c4f2de(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jN4ko.SideNav), {
        defaultCollapsed: props.collapsedState === 'collapsed',
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $56fJj.default), props);
}
function $3d7d84f3bc65155e$export$861edd1ccea2f746(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gXjR2.Main), {
        isFixed: props.isFixed,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Stls.default), props);
}
function $3d7d84f3bc65155e$export$7c6e2c02157bb7d2(props) {
    return (0, $3HwlS.getWillShowNav4)() ? // There isn't a concept of a `Content` wrapper component in the new page layout
    props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l2AH9.default), props);
}
function $3d7d84f3bc65155e$export$84d58c19c21f637f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $geqKu.Aside), {
        isFixed: props.isFixed,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3IHID.default), props);
}
function $3d7d84f3bc65155e$export$364a989a35814102(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehQHm.Panel), {
        xcss: $3d7d84f3bc65155e$var$rightPanelStyles.root,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jreT6.default), props);
}
const $3d7d84f3bc65155e$export$ee6b12c2613bdf8e = (id, title, index)=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3fzVB.useCustomSkipLink)(id, title, index);
const $3d7d84f3bc65155e$export$94561f6055639ef7 = ()=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $02o6B.useLeftSidebarFlyoutLock)();
// A mock value is needed to match the signature of the hook
const $3d7d84f3bc65155e$var$mockPageLayoutResize = {
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    collapseLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    leftSidebarState: {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    },
    setLeftSidebarState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    toggleLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $3d7d84f3bc65155e$export$10c7104037a7af62 = ()=>(0, $3HwlS.getWillShowNav4)() ? $3d7d84f3bc65155e$var$mockPageLayoutResize : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $02o6B.usePageLayoutResize)();
const $3d7d84f3bc65155e$var$rightPanelStyles = {
    root: "_bfhk1bhr"
};
const $3d7d84f3bc65155e$export$991ef8098f87814a = (0, $62b79b702763d93f$export$ed7cc0d417ee89e);
const $3d7d84f3bc65155e$export$7eaf986ecb4d5cac = (0, $62b79b702763d93f$export$f963aecf2d4465bd);
const $3d7d84f3bc65155e$export$e95b388ca8c92019 = (0, $62b79b702763d93f$export$f897e1ed9f8ed251);
const $3d7d84f3bc65155e$export$2ab8b83eed76656c = (0, $62b79b702763d93f$export$750459958906793);
const $3d7d84f3bc65155e$export$ac017575d43f5da = (0, $62b79b702763d93f$export$b44ab66843c05a69);
const $3d7d84f3bc65155e$export$d697087c06fd5e25 = (0, $62b79b702763d93f$export$aeff86a16f13529);

});

parcelRegister("1gQ7U", function(module, exports) {

$parcel$export(module.exports, "IconButton", () => $fbf6cc8e79de0577$export$c25acd513dcc8062);

var $5uXOq = parcelRequire("5uXOq");

var $aA2jH = parcelRequire("aA2jH");
const $fbf6cc8e79de0577$export$f173127635a15d2 = {
    small: 16,
    medium: 24,
    large: 32,
    xlarge: 48
};
const $fbf6cc8e79de0577$export$c25acd513dcc8062 = ({ children: children, onClick: onClick, ariaLabel: ariaLabel, style: style, tabIndex: tabIndex })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("button", {
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $aA2jH.button,
        "aria-label": ariaLabel,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        tabIndex: tabIndex
    }, children);
$fbf6cc8e79de0577$export$c25acd513dcc8062.displayName = 'IconButton';

});
parcelRegister("aA2jH", function(module, exports) {

$parcel$export(module.exports, "button", () => $7b3f104004304d6c$export$2ba01fb71ed41cb6, (v) => $7b3f104004304d6c$export$2ba01fb71ed41cb6 = v);
var $7b3f104004304d6c$export$2ba01fb71ed41cb6;
$7b3f104004304d6c$export$2ba01fb71ed41cb6 = `WWOkVG_button`;

});


parcelRegister("aPRoZ", function(module, exports) {

$parcel$export(module.exports, "Spotlights", () => $ffac7af5fe45e020$export$c7b90ff96148d0e3);
$parcel$export(module.exports, "useCurrentSpotlightOld", () => $ffac7af5fe45e020$export$28754d85fe333691);
$parcel$export(module.exports, "useCurrentSpotlight", () => $ffac7af5fe45e020$export$26b0bb53036d8513);
$parcel$export(module.exports, "OnboardingHeaderModeUpdater", () => $ffac7af5fe45e020$export$e9f9953833722cbb);

var $5uXOq = parcelRequire("5uXOq");

var $3HwlS = parcelRequire("3HwlS");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $ffac7af5fe45e020$export$c7b90ff96148d0e3 = {
    Inactive: 'INACTIVE',
    Views: 'portfolio-3/onboarding/views',
    HeartOfPlan: 'portfolio-3/onboarding/heart-of-plan',
    ShowAndTell: 'portfolio-3/onboarding/show-and-tell',
    ListMode: 'portfolio-3/onboarding/list-mode',
    FindYourLook: 'portfolio-3/onboarding/find-your-look',
    SaveYourChanges: 'portfolio-3/onboarding/save-your-changes'
};
const $ffac7af5fe45e020$var$SpotlightStepsOld = [
    $ffac7af5fe45e020$export$c7b90ff96148d0e3.Inactive,
    $ffac7af5fe45e020$export$c7b90ff96148d0e3.Views,
    $ffac7af5fe45e020$export$c7b90ff96148d0e3.HeartOfPlan,
    $ffac7af5fe45e020$export$c7b90ff96148d0e3.ShowAndTell,
    $ffac7af5fe45e020$export$c7b90ff96148d0e3.ListMode,
    $ffac7af5fe45e020$export$c7b90ff96148d0e3.FindYourLook,
    $ffac7af5fe45e020$export$c7b90ff96148d0e3.SaveYourChanges
];
const $ffac7af5fe45e020$var$SpotlightSteps = [
    $ffac7af5fe45e020$export$c7b90ff96148d0e3.Inactive,
    $ffac7af5fe45e020$export$c7b90ff96148d0e3.Views,
    $ffac7af5fe45e020$export$c7b90ff96148d0e3.ShowAndTell,
    $ffac7af5fe45e020$export$c7b90ff96148d0e3.ListMode,
    $ffac7af5fe45e020$export$c7b90ff96148d0e3.FindYourLook,
    $ffac7af5fe45e020$export$c7b90ff96148d0e3.SaveYourChanges
];
const $ffac7af5fe45e020$var$store = (0, $iXqE5.createStore)({
    initialState: {
        current: 0
    },
    actions: {
        reset: ()=>({ setState: setState })=>setState({
                    current: 0
                }),
        start: ()=>({ setState: setState })=>{
                setState({
                    current: 1
                });
            },
        next: ()=>({ getState: getState, setState: setState })=>{
                setState({
                    current: getState().current + 1
                });
            }
    },
    name: 'portfolio-3/onboarding/spotlights'
});
const $ffac7af5fe45e020$export$28754d85fe333691 = ()=>(0, $3sQ5x.createHook)($ffac7af5fe45e020$var$store, {
        selector: ({ current: current })=>{
            const totalStepCount = $ffac7af5fe45e020$var$SpotlightStepsOld.length - 1; // NOTE: All spotlights enums start with an invisible INACTIVE step (step 0)
            return {
                spotlight: $ffac7af5fe45e020$var$SpotlightStepsOld[current],
                currentStepCount: current,
                totalStepCount: totalStepCount
            };
        }
    })();
const $ffac7af5fe45e020$export$26b0bb53036d8513 = ()=>(0, $3sQ5x.createHook)($ffac7af5fe45e020$var$store, {
        selector: ({ current: current })=>{
            const totalStepCount = $ffac7af5fe45e020$var$SpotlightSteps.length - 1; // NOTE: All spotlights enums start with an invisible INACTIVE step (step 0)
            return {
                spotlight: $ffac7af5fe45e020$var$SpotlightSteps[current],
                currentStepCount: current,
                totalStepCount: totalStepCount
            };
        }
    })();
const $ffac7af5fe45e020$export$d52beefead77af4c = (0, $3sQ5x.createHook)($ffac7af5fe45e020$var$store, {
    selector: null
});
const $ffac7af5fe45e020$export$e9f9953833722cbb = ({ headerMode: headerMode, setHeaderMode: setHeaderMode })=>{
    const [{ spotlight: spotlight }] = $ffac7af5fe45e020$export$28754d85fe333691();
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $3HwlS.getWillShowNav4)()) {
            if (headerMode !== 'visible' && spotlight === $ffac7af5fe45e020$export$c7b90ff96148d0e3.HeartOfPlan) setHeaderMode('visible');
        }
    }, [
        spotlight,
        headerMode,
        setHeaderMode
    ]);
    return null;
};

});

parcelRegister("aGkaA", function(module, exports) {

$parcel$export(module.exports, "FinishFlag", () => $3f7aa109e30819d7$export$35e948d10c687c6d);

var $5uXOq = parcelRequire("5uXOq");

var $bMdrA = parcelRequire("bMdrA");

var $ousew = parcelRequire("ousew");

var $5oFIy = parcelRequire("5oFIy");

var $cRxyr = parcelRequire("cRxyr");

var $g9t2t = parcelRequire("g9t2t");
const $3f7aa109e30819d7$export$35e948d10c687c6d = ({ onDismiss: onDismiss, openInProductHelp: openInProductHelp })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "flag",
        action: "viewed",
        actionSubjectId: "finishedAdvancedRoadmapsOnboarding"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cRxyr.Flag), {
        isAutoDismissed: true,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))), {
            spacing: "spacious",
            label: "",
            color: "var(--ds-icon-success, #22A06B)"
        }),
        onDismissed: onDismiss,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $g9t2t.messages).flagTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $g9t2t.messages).plansFlagContent),
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $g9t2t.messages).flagClose),
                onClick: onDismiss
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $g9t2t.messages).flagViewDocumentation),
                onClick: ()=>openInProductHelp('')
            }
        ]
    }));

});
parcelRegister("cRxyr", function(module, exports) {

$parcel$export(module.exports, "Flag", () => $b49d89a15d12a3ed$export$48ea269755562084);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $pa9q9 = parcelRequire("pa9q9");

var $gOHSJ = parcelRequire("gOHSJ");
const $b49d89a15d12a3ed$export$48ea269755562084 = ({ id: id, isAutoDismissed: isAutoDismissed, onDismissed: onDismissed, ...props })=>{
    const [uid] = (0, $5uXOq.useState)(()=>id ?? Math.random().toString(36).substring(2));
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const onDismissedWrapper = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-shadow
    (id, analyticsEvent)=>{
        dismissFlag(String(id));
        onDismissed && onDismissed(id, analyticsEvent);
    }, [
        dismissFlag,
        onDismissed
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setTimeout(()=>showFlag({
                id: uid,
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b49d89a15d12a3ed$var$FlagWrapper, {
                        key: uid
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gOHSJ.JiraCommonFlag), {
                        id: uid,
                        onDismissed: onDismissedWrapper,
                        isAutoDismiss: isAutoDismissed,
                        messageId: "portfolio-3-onboarding.common.ui.flag.jira-common-flag",
                        messageType: "engagement",
                        flagType: "info",
                        ...props
                    }))
            }), 0 /* This is to prevent glitches when show/hide flags simultaneously */ );
        return ()=>dismissFlag(uid);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b49d89a15d12a3ed$var$FlagWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_88dhagmp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gOHSJ", function(module, exports) {

$parcel$export(module.exports, "JiraCommonFlag", () => $8f9a85e85178b852$export$1d9a3324fc0eb52);

var $5uXOq = parcelRequire("5uXOq");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $59YvY = parcelRequire("59YvY");

var $6TwEp = parcelRequire("6TwEp");
const $8f9a85e85178b852$export$1d9a3324fc0eb52 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $59YvY.ChoreographerCommonFlag), props);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6TwEp.default), rest);
};

});
parcelRegister("59YvY", function(module, exports) {

$parcel$export(module.exports, "ChoreographerCommonFlag", () => $3f981fa4d7c05e5a$export$ef12cdd486f28a7a);

var $cSWNW = parcelRequire("cSWNW");

var $6TwEp = parcelRequire("6TwEp");
const $3f981fa4d7c05e5a$export$ef12cdd486f28a7a = (0, $cSWNW.withChoreographedRender)((0, $6TwEp.default));

});
parcelRegister("6TwEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffb99bb14be92466$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1D5Rp = parcelRequire("1D5Rp");
var $9WdAg = parcelRequire("9WdAg");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $6pLjz = parcelRequire("6pLjz");

var $7fDjk = parcelRequire("7fDjk");
const $ffb99bb14be92466$export$b020578ce674a70f = 'platform.ui.flags.common.ui.common-flag-v2';
// standard delay time in ms, added for SR users to announce the status flag
const $ffb99bb14be92466$var$ANNOUNCEMENT_DELAY = 2500;
/**
 * Renders a flag component with dynamic behavior, automatically choosing between auto-dismissing
 * and standard modes based on properties. It dynamically selects an appropriate icon and supports
 * internationalization and accessibility, making it versatile for various use cases.
 */ const $ffb99bb14be92466$var$CommonFlag = (props)=>{
    const { flagType: flagType, icon: icon, delayAnnouncement: delayAnnouncement = $ffb99bb14be92466$var$ANNOUNCEMENT_DELAY, isAutoDismiss: isAutoDismiss, ...flagProps } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const StyledIcon = flagProps.appearance ? (0, $6pLjz.boldIconMap)[flagType] : (0, $6pLjz.iconMap)[flagType];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $ffb99bb14be92466$var$containerStyles,
        ...flagProps.testId && {
            'data-test-id': flagProps.testId
        }
    }, isAutoDismiss ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1D5Rp.default), {
        testId: `${$ffb99bb14be92466$export$b020578ce674a70f}-auto-dismiss`,
        ...flagProps,
        delayAnnouncement: delayAnnouncement,
        icon: icon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyledIcon, {
            label: formatMessage((0, $7fDjk.messages)[flagType])
        }) ?? null
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9WdAg.default), {
        testId: $ffb99bb14be92466$export$b020578ce674a70f,
        ...flagProps,
        delayAnnouncement: delayAnnouncement,
        icon: icon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyledIcon, {
            label: formatMessage((0, $7fDjk.messages)[flagType])
        }) ?? null
    }));
};
var $ffb99bb14be92466$export$2e2bcd8739ae039 = $ffb99bb14be92466$var$CommonFlag;
const $ffb99bb14be92466$var$containerStyles = (0, $2s57o.xcss)({
    wordWrap: 'break-word'
});

});
parcelRegister("6pLjz", function(module, exports) {

$parcel$export(module.exports, "iconMap", () => $38acb16b2f8a5dd3$export$6d49a893c897b0cc);
$parcel$export(module.exports, "boldIconMap", () => $38acb16b2f8a5dd3$export$6c71c95b1e390472);

var $jEF9d = parcelRequire("jEF9d");
const $38acb16b2f8a5dd3$export$6d49a893c897b0cc = {
    error: (0, $jEF9d.IconError),
    success: (0, $jEF9d.IconSuccess),
    info: (0, $jEF9d.IconInfo),
    warning: (0, $jEF9d.IconWarning)
};
const $38acb16b2f8a5dd3$export$6c71c95b1e390472 = {
    error: (0, $jEF9d.BoldIconError),
    success: (0, $jEF9d.BoldIconSuccess),
    info: (0, $jEF9d.BoldIconInfo),
    warning: (0, $jEF9d.BoldIconWarning)
};

});
parcelRegister("jEF9d", function(module, exports) {

$parcel$export(module.exports, "IconError", () => $29d87fe42743cbe5$export$66493327321323ad);
$parcel$export(module.exports, "IconSuccess", () => $29d87fe42743cbe5$export$9cae035d1b6ae1dc);
$parcel$export(module.exports, "IconInfo", () => $29d87fe42743cbe5$export$340bfce9b4df026b);
$parcel$export(module.exports, "IconWarning", () => $29d87fe42743cbe5$export$5be70e40251e6f9b);
$parcel$export(module.exports, "BoldIconError", () => $29d87fe42743cbe5$export$4d6c0ef1e9e095ae);
$parcel$export(module.exports, "BoldIconSuccess", () => $29d87fe42743cbe5$export$23fdc8fccd51d997);
$parcel$export(module.exports, "BoldIconInfo", () => $29d87fe42743cbe5$export$4c05116eb19cc3aa);
$parcel$export(module.exports, "BoldIconWarning", () => $29d87fe42743cbe5$export$522238647b7d04fc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $bMdrA = parcelRequire("bMdrA");

var $5E93O = parcelRequire("5E93O");

var $k01Ou = parcelRequire("k01Ou");

var $85eFT = parcelRequire("85eFT");
const $29d87fe42743cbe5$export$66493327321323ad = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29d87fe42743cbe5$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-danger, #C9372C)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
        spacing: "spacious",
        label: label
    }));
const $29d87fe42743cbe5$export$9cae035d1b6ae1dc = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29d87fe42743cbe5$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-success, #22A06B)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))), {
        spacing: "spacious",
        label: label
    }));
const $29d87fe42743cbe5$export$340bfce9b4df026b = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29d87fe42743cbe5$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-discovery, #8270DB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k01Ou))), {
        spacing: "spacious",
        label: label
    }));
const $29d87fe42743cbe5$export$5be70e40251e6f9b = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29d87fe42743cbe5$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-warning, #E56910)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($85eFT))), {
        spacing: "spacious",
        label: label
    }));
const $29d87fe42743cbe5$export$4d6c0ef1e9e095ae = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-danger, #C9372C)"
    });
const $29d87fe42743cbe5$export$23fdc8fccd51d997 = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-success, #22A06B)"
    });
const $29d87fe42743cbe5$export$4c05116eb19cc3aa = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k01Ou))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-discovery, #8270DB)"
    });
const $29d87fe42743cbe5$export$522238647b7d04fc = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($85eFT))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-warning, #E56910)"
    });
const $29d87fe42743cbe5$export$8f314e512d92575f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconColor: iconColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1weumv": (0, $lD23V.default)(__cmplp.iconColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1kah",
            __cmplp.className
        ])
    });
});

});


parcelRegister("7fDjk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $de522aa55d5b135d$export$defe85febe8b728c);
// Should not remove this disabled-line and don't run eslint --fix for this file

var $7VHMR = parcelRequire("7VHMR");
const $de522aa55d5b135d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    error: {
        "id": "platform.flags.common.components.common-flag.error",
        "defaultMessage": "Error"
    },
    success: {
        "id": "platform.flags.common.components.common-flag.success",
        "defaultMessage": "Success"
    },
    info: {
        "id": "platform.flags.common.components.common-flag.info",
        "defaultMessage": "Information"
    },
    warning: {
        "id": "platform.flags.common.components.common-flag.warning",
        "defaultMessage": "Warning"
    }
});

});





parcelRegister("g9t2t", function(module, exports) {

$parcel$export(module.exports, "messages", () => $40985028cc21dd23$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $40985028cc21dd23$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    flagTitle: {
        "id": "portfolio-3-onboarding.onboarding.flag-finish.flag-title",
        "defaultMessage": "Happy planning!"
    },
    plansFlagContent: {
        "id": "portfolio-3-onboarding.onboarding.flag-finish.plans-flag-content",
        "defaultMessage": "For more information on how to get started with Plans, check out our latest documentation."
    },
    flagClose: {
        "id": "portfolio-3-onboarding.onboarding.flag-finish.flag-close",
        "defaultMessage": "Close"
    },
    flagViewDocumentation: {
        "id": "portfolio-3-onboarding.onboarding.flag-finish.flag-view-documentation",
        "defaultMessage": "View documentation"
    }
});

});


parcelRegister("9yfXJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d44f9a86b0041aa3$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d44f9a86b0041aa3$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    spotlightCloseLabel: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-close-label",
        "defaultMessage": "Close"
    },
    modalHeadingPlansSpork: {
        "id": "portfolio-3-onboarding.onboarding.modal-heading-plans-spork",
        "defaultMessage": "Welcome to Plans"
    },
    modalContentParagraphPlansSpork: {
        "id": "portfolio-3-onboarding.onboarding.modal-content-paragraph-plans-spork",
        "defaultMessage": "Track dependencies from multiple teams, monitor team's capacity, and view the status of work in real time so you can see everything happening across Jira."
    },
    modalTakeTour: {
        "id": "portfolio-3-onboarding.onboarding.modal-take-tour",
        "defaultMessage": "Take tour"
    },
    modalSkip: {
        "id": "portfolio-3-onboarding.onboarding.modal-skip",
        "defaultMessage": "Skip"
    },
    spotlightNext: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-next",
        "defaultMessage": "Next"
    },
    spotlightLearnMore: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-learn-more",
        "defaultMessage": "Learn more"
    }
});

});

parcelRegister("eld9u", function(module, exports) {

$parcel$export(module.exports, "FindYourLookSpotlight", () => $8ccbb0bbae14bf06$export$854c6a85659497df);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $ltOVK = parcelRequire("ltOVK");
const $8ccbb0bbae14bf06$export$854c6a85659497df = ({ target: target, actionsBeforeElement: actionsBeforeElement, headingAfterElement: headingAfterElement, actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        target: target,
        targetRadius: 0,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        heading: formatMessage((0, $ltOVK.messages).title),
        actionsBeforeElement: actionsBeforeElement,
        actions: actions({
            learnMoreURL: 'https://support.atlassian.com/jira-software-cloud/docs/change-how-advanced-roadmaps-displays-your-timeline-data/'
        }),
        headingAfterElement: headingAfterElement,
        messageId: "portfolio-3-onboarding.ui.onboarding.spotlight-find-your-look.jira-spotlight",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $ltOVK.messages).contentIssueTermRefresh : (0, $ltOVK.messages).content));
};

});
parcelRegister("ltOVK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d200c51d356269e3$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d200c51d356269e3$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-find-your-look.title",
        "defaultMessage": "Find your look"
    },
    content: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-find-your-look.content",
        "defaultMessage": "Add a personal touch to your plan by changing how your issues are grouped, sorted or displayed."
    },
    contentIssueTermRefresh: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-find-your-look.content-issue-term-refresh",
        "defaultMessage": "Add a personal touch to your plan by changing how your work items are grouped, sorted or displayed."
    }
});

});


parcelRegister("taGZB", function(module, exports) {

$parcel$export(module.exports, "HeartOfPlanSpotlight", () => $d8652916e0161872$export$859e382090c26be5);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $ehdJY = parcelRequire("ehdJY");

var $2pHvq = parcelRequire("2pHvq");
const $d8652916e0161872$export$859e382090c26be5 = ({ target: target, actionsBeforeElement: actionsBeforeElement, actions: actions, headingAfterElement: headingAfterElement })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        target: target,
        targetBgColor: (0, $3HwlS.getWillShowNav4)() ? undefined : "var(--ds-surface, #FFFFFF)",
        dialogPlacement: "top left",
        heading: formatMessage((0, $2pHvq.messages).title),
        actionsBeforeElement: actionsBeforeElement,
        actions: actions({
            learnMoreURL: 'https://support.atlassian.com/jira-software-cloud/docs/how-do-i-read-my-advanced-roadmaps-plan/#1.-Issue-column'
        }),
        headingAfterElement: headingAfterElement,
        messageId: "portfolio-3-onboarding.ui.onboarding.spotlight-heart-of-plan.jira-spotlight",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $2pHvq.messages).content));
};

});
parcelRegister("2pHvq", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4ab20231f3500e31$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $4ab20231f3500e31$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-heart-of-plan.title",
        "defaultMessage": "The heart of your plan"
    },
    content: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-heart-of-plan.content",
        "defaultMessage": "View, create, and schedule tasks, then customize which data fields you want to see in context."
    }
});

});


parcelRegister("6IYrl", function(module, exports) {

$parcel$export(module.exports, "ListModeSpotlight", () => $9138092740ea1ef6$export$5c026a266f250837);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $6eFvr = parcelRequire("6eFvr");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $fWyY6 = parcelRequire("fWyY6");
const $9138092740ea1ef6$export$5c026a266f250837 = ({ target: target, actionsBeforeElement: actionsBeforeElement, headingAfterElement: headingAfterElement, actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        target: target,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        dialogPlacement: "bottom right",
        actionsBeforeElement: actionsBeforeElement,
        actions: actions({
            learnMoreURL: ''
        }),
        headingAfterElement: headingAfterElement,
        heading: formatMessage((0, $fWyY6.messages).heading),
        messageId: "portfolio-3-onboarding.ui.onboarding.spotlight-list-mode.jira-spotlight",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, formatMessage((0, $fWyY6.messages).description, {
        b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
                weight: "bold"
            }, chunks)
    }))));
};

});
parcelRegister("fWyY6", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e66d5fb1b51efc17$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e66d5fb1b51efc17$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-list-mode.heading",
        "defaultMessage": "More room for planning"
    },
    description: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-list-mode.description",
        "defaultMessage": "Select <b>Timeline</b> to view the timeline bars and capacity information, or choose <b>List</b> to hide them and add as many fields as you want."
    }
});

});


parcelRegister("eNZ9d", function(module, exports) {

$parcel$export(module.exports, "SaveYourChangesSpotlight", () => $5dc2e1ded0fb55fd$export$6558b61777516cff);

var $5uXOq = parcelRequire("5uXOq");

var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $8M0Cn = parcelRequire("8M0Cn");
const $5dc2e1ded0fb55fd$export$6558b61777516cff = ({ target: target, actionsBeforeElement: actionsBeforeElement, headingAfterElement: headingAfterElement, actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        target: target,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        targetRadius: 3,
        heading: formatMessage((0, $8M0Cn.messages).heading),
        actionsBeforeElement: actionsBeforeElement,
        dialogPlacement: "bottom right",
        actions: actions({
            learnMoreURL: 'https://support.atlassian.com/jira-software-cloud/docs/save-changes-made-in-advanced-roadmaps/'
        }),
        headingAfterElement: headingAfterElement,
        messageId: "portfolio-3-onboarding.ui.onboarding.spotlight-save-your-changes.jira-spotlight",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $8M0Cn.messages).spotlightBodyIssueTermRefresh : (0, $8M0Cn.messages).spotlightBody, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
                weight: "bold"
            }, chunks)
    }))));
};

});
parcelRegister("8M0Cn", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b930cca5b60bdb12$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b930cca5b60bdb12$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-save-your-changes.heading",
        "defaultMessage": "A plan is a draft until you save changes"
    },
    spotlightBody: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-save-your-changes.spotlight-body",
        "defaultMessage": "Use <b>Unsaved changes</b> to save issues, teams or releases created or changed in your plan so they update in projects."
    },
    spotlightBodyIssueTermRefresh: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-save-your-changes.spotlight-body-issue-term-refresh",
        "defaultMessage": "Use <b>Unsaved changes</b> to save work items, teams or releases created or changed in your plan so they update in projects."
    }
});

});


parcelRegister("kRDXu", function(module, exports) {

$parcel$export(module.exports, "ShowAndTellSpotlight", () => $2bba1ae05d7717f4$export$1cbd09eb9384dd3b);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $4nGXJ = parcelRequire("4nGXJ");
const $2bba1ae05d7717f4$export$1cbd09eb9384dd3b = ({ target: target, actionsBeforeElement: actionsBeforeElement, headingAfterElement: headingAfterElement, actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        target: target,
        targetRadius: 0,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        heading: formatMessage((0, $4nGXJ.messages).heading),
        actionsBeforeElement: actionsBeforeElement,
        actions: actions({
            learnMoreURL: 'https://support.atlassian.com/jira-software-cloud/docs/preconfigured-views-in-advanced-roadmaps/'
        }),
        headingAfterElement: headingAfterElement,
        messageId: "portfolio-3-onboarding.ui.onboarding.spotlight-show-and-tell.jira-spotlight",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $4nGXJ.messages).descriptionIssueTermRefresh : (0, $4nGXJ.messages).description));
};

});
parcelRegister("4nGXJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4e47141a06dd9222$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $4e47141a06dd9222$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-show-and-tell.heading",
        "defaultMessage": "A view to remember"
    },
    description: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-show-and-tell.description",
        "defaultMessage": "Filter issues based on what's relevant to you, then save it to tell a unique story. Make multiple views to curate your plan for different audiences."
    },
    descriptionIssueTermRefresh: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-show-and-tell.description-issue-term-refresh",
        "defaultMessage": "Filter work items based on what's relevant to you, then save it to tell a unique story. Make multiple views to curate your plan for different audiences."
    }
});

});


parcelRegister("bHAma", function(module, exports) {

$parcel$export(module.exports, "ViewsSpotlight", () => $d0ca4d0cf0f6e816$export$9ea3305cd20bda43);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $5eomS = parcelRequire("5eomS");
const $d0ca4d0cf0f6e816$export$9ea3305cd20bda43 = ({ target: target, actionsBeforeElement: actionsBeforeElement, actions: actions, headingAfterElement: headingAfterElement })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        target: target,
        targetRadius: 0,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        heading: formatMessage((0, $5eomS.messages).heading),
        actionsBeforeElement: actionsBeforeElement,
        actions: actions({
            learnMoreURL: 'https://support.atlassian.com/jira-software-cloud/docs/how-do-i-navigate-advanced-roadmaps/'
        }),
        headingAfterElement: headingAfterElement,
        messageId: "portfolio-3-onboarding.ui.onboarding.spotlight-views.jira-spotlight",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5eomS.messages).description));
};

});
parcelRegister("5eomS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5ea1485678dc96f8$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5ea1485678dc96f8$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-views.heading",
        "defaultMessage": "Views for different needs"
    },
    description: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-views.description",
        "defaultMessage": "Each page shows you a different aspect of your plan so you can quickly find the information you need."
    }
});

});


parcelRegister("adqnA", function(module, exports) {

$parcel$export(module.exports, "useStep", () => $c9798353b0407725$export$7896576cb7635832);
$parcel$export(module.exports, "useController", () => $c9798353b0407725$export$e8c786024a2b0a79);
$parcel$export(module.exports, "isCrossTeamPlanningTemplateExperimentEnabled", () => $c9798353b0407725$export$5d06510124eb14f8);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $6s1PB = parcelRequire("6s1PB");

var $83qPh = parcelRequire("83qPh");
const $c9798353b0407725$export$7896576cb7635832 = ()=>{
    const [step, setStep] = (0, $5uXOq.useState)('inactive');
    const start = (0, $5uXOq.useCallback)(()=>setStep('modal'), []);
    const finish = (0, $5uXOq.useCallback)(()=>setStep('finished'), []);
    const skipToFlag = (0, $5uXOq.useCallback)(()=>setStep('flag'), []);
    const next = (0, $5uXOq.useCallback)(()=>setStep((current)=>{
            switch(current){
                case 'modal':
                    return 'spotlight';
                case 'spotlight':
                    return 'flag';
                case 'flag':
                default:
                    return 'finished';
            }
        }), []);
    return [
        step,
        {
            next: next,
            start: start,
            finish: finish,
            skip: skipToFlag
        }
    ];
};
const $c9798353b0407725$var$useStoreController = ()=>{
    const [{ visible: visible }, { initOnboarding: initOnboarding, closeOnboarding: closeOnboarding }] = (0, $83qPh.useOnboardingTour)();
    return [
        {
            visible: visible
        },
        {
            init: initOnboarding,
            close: closeOnboarding
        }
    ];
};
const $c9798353b0407725$var$usePropsController = (props)=>{
    if (!('visible' in props)) return undefined;
    const { visible: visible, onClose: onClose } = props;
    return [
        {
            visible: visible
        },
        {
            init: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            close: onClose
        }
    ];
};
const $c9798353b0407725$export$e8c786024a2b0a79 = (props)=>{
    const storeController = $c9798353b0407725$var$useStoreController();
    const propsController = $c9798353b0407725$var$usePropsController(props);
    return propsController ?? storeController;
};
const $c9798353b0407725$export$5d06510124eb14f8 = ()=>(0, $6s1PB.expValEquals)('second_premium_template_experiment', 'cohort', 'variation');

});
parcelRegister("83qPh", function(module, exports) {

$parcel$export(module.exports, "useRehydrated", () => $54a3c2fc6e2e14ac$export$783184fef467e477);
$parcel$export(module.exports, "useChangeboarding", () => $54a3c2fc6e2e14ac$export$4a515e2e15159bbe);
$parcel$export(module.exports, "useOnboardingTour", () => $54a3c2fc6e2e14ac$export$c7824882d969afa7);
$parcel$export(module.exports, "OnboardingProvider", () => $54a3c2fc6e2e14ac$export$54ba648a75d332de);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $frrR0 = parcelRequire("frrR0");

var $heO5n = parcelRequire("heO5n");

var $7Y3eR = parcelRequire("7Y3eR");
const $54a3c2fc6e2e14ac$var$initialState = {
    _rehydrated: false
};
const $54a3c2fc6e2e14ac$var$store = (0, $iXqE5.createStore)({
    initialState: $54a3c2fc6e2e14ac$var$initialState,
    actions: $frrR0.actions,
    name: 'portfolio-3/onboarding'
});
const $54a3c2fc6e2e14ac$export$783184fef467e477 = (0, $3sQ5x.createHook)($54a3c2fc6e2e14ac$var$store, {
    selector: (state)=>state._rehydrated
});
const $54a3c2fc6e2e14ac$export$4a515e2e15159bbe = (0, $3sQ5x.createHook)($54a3c2fc6e2e14ac$var$store, {
    selector: (0, $heO5n.selectChangeboarding)
});
const $54a3c2fc6e2e14ac$export$c7824882d969afa7 = (0, $3sQ5x.createHook)($54a3c2fc6e2e14ac$var$store, {
    selector: (0, $heO5n.selectOnboardingTour)
});
const $54a3c2fc6e2e14ac$export$54ba648a75d332de = (0, $gg7kZ.createContainer)($54a3c2fc6e2e14ac$var$store, {
    onInit: ()=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            if (getState()._rehydratePromise === undefined) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const promise = dispatch((0, $7Y3eR.rehydrate));
                setState({
                    _rehydratePromise: promise
                });
                await promise;
            }
        }
});

});
parcelRegister("frrR0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5aa18b8c8f01ed9e$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7Y3eR = parcelRequire("7Y3eR");
const $5aa18b8c8f01ed9e$var$changeboardingActions = {
    initChangeboarding: ()=>async ({ getState: getState, setState: setState })=>{
            await getState()._rehydratePromise;
            if (getState().changeboarding?.stage === undefined) setState({
                changeboarding: {
                    stage: 'READY'
                }
            });
        },
    closeChangeboarding: ({ silent: silent } = {
        silent: true
    }, at = new Date())=>({ dispatch: dispatch })=>{
            dispatch((0, $7Y3eR.update)({
                ui: !silent,
                persist: true
            })({
                changeboarding: {
                    stage: 'CLOSED',
                    closedAt: at
                }
            }));
        }
};
const $5aa18b8c8f01ed9e$var$onboardingActions = {
    initOnboarding: ()=>async ({ getState: getState, setState: setState })=>{
            await getState()._rehydratePromise;
            if (getState().onboarding?.stage === undefined) setState({
                onboarding: {
                    stage: 'READY'
                }
            });
        },
    closeOnboarding: ({ silent: silent } = {
        silent: true
    })=>({ dispatch: dispatch })=>{
            dispatch((0, $7Y3eR.update)({
                ui: !silent,
                persist: true
            })({
                onboarding: {
                    stage: 'CLOSED'
                }
            }));
        }
};
const $5aa18b8c8f01ed9e$export$e324594224ef24da = {
    ...$5aa18b8c8f01ed9e$var$changeboardingActions,
    ...$5aa18b8c8f01ed9e$var$onboardingActions
};

});
parcelRegister("7Y3eR", function(module, exports) {

$parcel$export(module.exports, "rehydrate", () => $f45884e079f0c3e6$export$27af23fc693b4501);
$parcel$export(module.exports, "update", () => $f45884e079f0c3e6$export$722fbec263ad908a);

var $hjAWb = parcelRequire("hjAWb");

var $aHuqL = parcelRequire("aHuqL");
const $f45884e079f0c3e6$var$PERSIST_KEY = 'jira.user.arj.onboarding';
const $f45884e079f0c3e6$export$27af23fc693b4501 = async ({ getState: getState, setState: setState })=>{
    if (getState()._rehydrated) return;
    const assertUnreachable = (_)=>{
        throw new Error("Didn't expect to get here");
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const parseDate = (raw)=>{
        const maybeDate = new Date(raw);
        return !Number.isNaN(maybeDate.getTime()) ? maybeDate : new Date();
    };
    // Mark as any since it's assumed to be opaque, we ensure type safety in the code below.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const raw = await (0, $aHuqL.userPreferenceAPI).get($f45884e079f0c3e6$var$PERSIST_KEY) ?? {};
    const changeboarding = (()=>{
        try {
            const stage = raw.changeboarding?.stage;
            switch(stage){
                case 'READY':
                    return {
                        stage: stage
                    };
                case 'CLOSED':
                    return {
                        stage: stage,
                        closedAt: parseDate(raw.changeboarding?.closedAt)
                    };
                default:
                    assertUnreachable(stage);
                    return undefined;
            }
        } catch (err) {
            return undefined;
        }
    })();
    const onboarding = (()=>{
        try {
            const stage = raw.onboarding?.stage;
            switch(stage){
                case 'READY':
                    return {
                        stage: stage
                    };
                case 'CLOSED':
                    return {
                        stage: stage
                    };
                default:
                    assertUnreachable(stage);
                    return undefined;
            }
        } catch (err) {
            return undefined;
        }
    })();
    setState({
        _rehydrated: true,
        changeboarding: changeboarding,
        onboarding: onboarding
    });
};
const $f45884e079f0c3e6$var$persist = (update)=>async ({ getState: getState })=>{
        const serialize = (0, (/*@__PURE__*/$parcel$interopDefault($hjAWb)))([
            'changeboarding',
            'onboarding'
        ]);
        (0, $aHuqL.userPreferenceAPI).set($f45884e079f0c3e6$var$PERSIST_KEY, serialize({
            ...getState(),
            ...update
        }));
    };
const $f45884e079f0c3e6$export$722fbec263ad908a = (options = {
    ui: true,
    persist: true
})=>(partial)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { _rehydrated: _rehydrated, _rehydratePromise: _rehydratePromise } = getState();
            if (!_rehydrated) await _rehydratePromise;
            if (options.ui) setState(partial);
            if (options.persist) dispatch($f45884e079f0c3e6$var$persist({
                ...getState(),
                ...partial
            }));
        };

});
parcelRegister("hjAWb", function(module, exports) {

var $lVx1a = parcelRequire("lVx1a");

var $c9b0dcffc2009ee0$var$func = $lVx1a('pick', (parcelRequire("3NMrl")));

$c9b0dcffc2009ee0$var$func.placeholder = (parcelRequire("aPsMW"));
module.exports = $c9b0dcffc2009ee0$var$func;

});
parcelRegister("3NMrl", function(module, exports) {

var $i2e26 = parcelRequire("i2e26");

var $9SRAA = parcelRequire("9SRAA");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $2c4b85df1af41471$var$pick = $9SRAA(function(object, paths) {
    return object == null ? {} : $i2e26(object, paths);
});
module.exports = $2c4b85df1af41471$var$pick;

});
parcelRegister("i2e26", function(module, exports) {

var $4gaCO = parcelRequire("4gaCO");

var $fh9gH = parcelRequire("fh9gH");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $d2134c8f0f8064b1$var$basePick(object, paths) {
    return $4gaCO(object, paths, function(value, path) {
        return $fh9gH(object, path);
    });
}
module.exports = $d2134c8f0f8064b1$var$basePick;

});





parcelRegister("heO5n", function(module, exports) {

$parcel$export(module.exports, "selectChangeboarding", () => $991c975959a83374$export$763e5c2849fd2595);
$parcel$export(module.exports, "selectOnboardingTour", () => $991c975959a83374$export$66bbb450debbfc1b);
const $991c975959a83374$export$763e5c2849fd2595 = ({ changeboarding: changeboarding })=>({
        visible: changeboarding?.stage === 'READY'
    });
const $991c975959a83374$export$66bbb450debbfc1b = ({ onboarding: onboarding })=>({
        visible: onboarding?.stage === 'READY',
        closed: onboarding?.stage === 'CLOSED'
    });

});




parcelRegister("dUk9j", function(module, exports) {

$parcel$export(module.exports, "SpotlightTarget", () => $0033ead13d224938$export$e29577842f211e22);
$parcel$export(module.exports, "EpicLevelSpotlightTarget", () => $0033ead13d224938$export$27903a60ba199e9f);

var $5uXOq = parcelRequire("5uXOq");

var $Pxnvj = parcelRequire("Pxnvj");

var $c12LJ = parcelRequire("c12LJ");

var $g295Q = parcelRequire("g295Q");
const $0033ead13d224938$export$e29577842f211e22 = ({ children: children, delayOn: delayOn, name: name })=>{
    const [withSpotlight, setWithSpotlight] = (0, $5uXOq.useState)(true);
    (0, $5uXOq.useEffect)(()=>{
        if (delayOn === undefined) return;
        setWithSpotlight(false);
        setTimeout(()=>setWithSpotlight(true), 1000);
    }, [
        delayOn
    ]);
    return withSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
        name: name
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $0033ead13d224938$export$27903a60ba199e9f = (children, isGroupByNone, level)=>level === (0, $c12LJ.EPIC_LEVEL) && isGroupByNone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0033ead13d224938$export$e29577842f211e22, {
        delayOn: true,
        name: (0, $g295Q.CttSpotlights).EpicSection,
        key: (0, $g295Q.CttSpotlights).EpicSection
    }, children) : children;

});
parcelRegister("c12LJ", function(module, exports) {

$parcel$export(module.exports, "SUB_TASK_LEVEL", () => $3e10307c482ddd45$export$629eb88199636e31);
$parcel$export(module.exports, "STORY_LEVEL", () => $3e10307c482ddd45$export$5851ccd68c79bc39);
$parcel$export(module.exports, "EPIC_LEVEL", () => $3e10307c482ddd45$export$346285e0085a3842);
$parcel$export(module.exports, "INITIATIVE_LEVEL", () => $3e10307c482ddd45$export$3dc28f07aa7629a3);
$parcel$export(module.exports, "STRATEGY_LEVEL", () => $3e10307c482ddd45$export$6b568e78303247cb);
$parcel$export(module.exports, "GOAL_LEVEL", () => $3e10307c482ddd45$export$8d7949e6fbe9c22a);

var $g4tDr = parcelRequire("g4tDr");
const $3e10307c482ddd45$export$629eb88199636e31 = (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_SUBTASK);
const $3e10307c482ddd45$export$5851ccd68c79bc39 = (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_BASE);
const $3e10307c482ddd45$export$346285e0085a3842 = (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_EPIC);
const $3e10307c482ddd45$export$3dc28f07aa7629a3 = (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_INITIATIVE);
const $3e10307c482ddd45$export$6b568e78303247cb = (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_STRATEGY);
const $3e10307c482ddd45$export$8d7949e6fbe9c22a = (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_GOAL);

});
parcelRegister("g4tDr", function(module, exports) {

$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", () => $03dd5f7faa501890$export$2294cfc7730248df);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", () => $03dd5f7faa501890$export$961a1d6da881600c);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", () => $03dd5f7faa501890$export$e11dea67b88ee556);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", () => $03dd5f7faa501890$export$9ad20e435294162a);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", () => $03dd5f7faa501890$export$a454b3474c5ee5f5);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", () => $03dd5f7faa501890$export$b69c1b48ce8f83de);
$parcel$export(module.exports, "BASE_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$ba7c785763a2a58f);
$parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$e09d07f2dcff2603);
$parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$1165245f61159842);
$parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$8a96a83b3f957e58);
$parcel$export(module.exports, "toHierarchyLevel", () => $03dd5f7faa501890$export$c0c893ca5ccae9dd);
$parcel$export(module.exports, "isBaseHierarchyLevel", () => $03dd5f7faa501890$export$bcf91a9d8c5b0f58);
$parcel$export(module.exports, "isEpicHierarchyLevel", () => $03dd5f7faa501890$export$e415cf60723c7aae);
$parcel$export(module.exports, "isSubtaskHierarchyLevel", () => $03dd5f7faa501890$export$41f00a40e2ebd6e8);
$parcel$export(module.exports, "getHierarchyLevelType", () => $03dd5f7faa501890$export$556b686fea6fb229);
$parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", () => $03dd5f7faa501890$export$638ac52227e67c8);
const $03dd5f7faa501890$export$2294cfc7730248df = 4;
const $03dd5f7faa501890$export$961a1d6da881600c = 3;
const $03dd5f7faa501890$export$e11dea67b88ee556 = 2;
const $03dd5f7faa501890$export$9ad20e435294162a = 1;
const $03dd5f7faa501890$export$a454b3474c5ee5f5 = 0;
const $03dd5f7faa501890$export$b69c1b48ce8f83de = -1;
const $03dd5f7faa501890$export$ba7c785763a2a58f = 'BASE';
const $03dd5f7faa501890$export$e09d07f2dcff2603 = 'CHILD';
const $03dd5f7faa501890$export$1165245f61159842 = 'PARENT';
const $03dd5f7faa501890$export$8a96a83b3f957e58 = 'EPIC';
const $03dd5f7faa501890$export$c0c893ca5ccae9dd = (level)=>level;
const $03dd5f7faa501890$export$bcf91a9d8c5b0f58 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return true;
    return numericLevel === $03dd5f7faa501890$export$a454b3474c5ee5f5;
};
const $03dd5f7faa501890$export$e415cf60723c7aae = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $03dd5f7faa501890$export$9ad20e435294162a;
};
const $03dd5f7faa501890$export$41f00a40e2ebd6e8 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $03dd5f7faa501890$export$b69c1b48ce8f83de;
};
const $03dd5f7faa501890$export$556b686fea6fb229 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) > 0) return $03dd5f7faa501890$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
    return $03dd5f7faa501890$export$ba7c785763a2a58f;
};
const $03dd5f7faa501890$export$638ac52227e67c8 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) === 1) return $03dd5f7faa501890$export$8a96a83b3f957e58;
    if (Number(hierarchyLevel) > 1) return $03dd5f7faa501890$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
    return $03dd5f7faa501890$export$ba7c785763a2a58f;
};

});



parcelRegister("4hkqI", function(module, exports) {

$parcel$export(module.exports, "useRedirectToSpaPlanPage", () => $a636e5d36faab830$export$ca60ba613d31bd2a);
$parcel$export(module.exports, "default", () => $a636e5d36faab830$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3HwlS = parcelRequire("3HwlS");

var $doZTA = parcelRequire("doZTA");
const $a636e5d36faab830$export$ca60ba613d31bd2a = ()=>{
    const [{ match: match, location: location }, { replace: replace, push: push }] = (0, $doZTA.useRouter)();
    return (page, plan)=>{
        if ((0, $3HwlS.getWillShowNav4)() && plan) {
            const newUrl = `/jira/plans/${plan.planId}/scenarios/${plan.scenarioId}${page}`;
            if (newUrl === location.pathname) // short-circuit if the redirect url is the same
            return;
            push(newUrl);
        } else {
            if (!match.params?.planId || !match.params?.scenarioId) return;
            const newUrl = `/jira/plans/${match.params.planId}/scenarios/${match.params.scenarioId}${page}`;
            if (newUrl === location.pathname) // short-circuit if the redirect url is the same
            return;
            replace(newUrl);
        }
    };
};
const $a636e5d36faab830$var$withRedirectToSpaPlanPage = (WrappedComponent)=>(props)=>{
        const redirectToSpaPlanPage = $a636e5d36faab830$export$ca60ba613d31bd2a();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            redirectToSpaPlanPage: redirectToSpaPlanPage
        });
    };
var $a636e5d36faab830$export$2e2bcd8739ae039 = $a636e5d36faab830$var$withRedirectToSpaPlanPage;

});

parcelRegister("aIQvD", function(module, exports) {

$parcel$export(module.exports, "PlanActionMenuStoreContainer", () => $9067e37eff8fd2bd$export$841c6ae48f972846);
$parcel$export(module.exports, "usePlanActionMenuStore", () => $9067e37eff8fd2bd$export$17c41990ccc1d1f5);
$parcel$export(module.exports, "PlanActionMenuStoreSubscriber", () => $9067e37eff8fd2bd$export$472a04ea3fff8528);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $9067e37eff8fd2bd$var$actions = {
    toggleMenu: (open)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                isOpen: open ?? !getState().isOpen
            });
        },
    closeMenu: ()=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                isOpen: false
            });
        }
};
const $9067e37eff8fd2bd$export$841c6ae48f972846 = (0, $gg7kZ.createContainer)();
/**
 * This stores the state of the plan action menu. For both the sidebar and the horizontal navigation.
 * Using this one store you can programmatically open and close any plan action menu. This is useful for in onboarding.
 */ const $9067e37eff8fd2bd$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        isOpen: false
    },
    actions: $9067e37eff8fd2bd$var$actions,
    containedBy: $9067e37eff8fd2bd$export$841c6ae48f972846,
    name: 'plan-action-menu-store'
});
const $9067e37eff8fd2bd$export$17c41990ccc1d1f5 = (0, $3sQ5x.createHook)($9067e37eff8fd2bd$var$Store);
const $9067e37eff8fd2bd$export$472a04ea3fff8528 = (0, $51nlc.createSubscriber)($9067e37eff8fd2bd$var$Store);

});

parcelRegister("6DQw3", function(module, exports) {

$parcel$export(module.exports, "useSetFavourite", () => $a44d05465d132d3b$export$28faf8ea68a6d1b8);

var $lc0Q9 = parcelRequire("lc0Q9");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $h3yCb = parcelRequire("h3yCb");

var $iHHEg = parcelRequire("iHHEg");
const $a44d05465d132d3b$export$28faf8ea68a6d1b8 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const displayErrorFlag = (0, $5uXOq.useCallback)((planTitle, isFavourite)=>{
        const addFavouriteErrorFlag = ()=>({
                id: 'set-favourite-error',
                type: 'error',
                title: (0, $h3yCb.default).errorFlagTitleNonFinal,
                description: formatMessage((0, $h3yCb.default).errorFlagDescriptionFailedAddNonFinal, {
                    planTitle: planTitle
                }),
                isAutoDismiss: true,
                messageId: 'jet-plan-action-menu.services.set-favourite.flag.error.display-error-flag.error.add-favourite-error-flag',
                messageType: 'transactional'
            });
        const removeFavouriteErrorFlag = ()=>({
                id: 'remove-favourite-error',
                type: 'error',
                title: (0, $h3yCb.default).errorFlagTitleNonFinal,
                description: formatMessage((0, $h3yCb.default).errorFlagDescriptionFailedRemoveNonFinal, {
                    planTitle: planTitle
                }),
                isAutoDismiss: true,
                messageId: 'jet-plan-action-menu.services.set-favourite.flag.error.display-error-flag.error.remove-favourite-error-flag',
                messageType: 'transactional'
            });
        showFlag(isFavourite ? addFavouriteErrorFlag() : removeFavouriteErrorFlag());
    }, [
        formatMessage,
        showFlag
    ]);
    const [commitMutation, isLoading] = (0, $8Uumt.useMutation)((0, $lc0Q9.default));
    const setFavourite = (0, $5uXOq.useCallback)(({ entityId: entityId, planTitle: planTitle, isFavourite: isFavourite, favouriteConnectionId: favouriteConnectionId, beforeEntityId: beforeEntityId = null, onErrorCallback: onErrorCallback })=>{
        commitMutation({
            variables: {
                input: {
                    entityId: entityId,
                    isFavourite: isFavourite,
                    beforeEntityId: beforeEntityId
                }
            },
            optimisticUpdater: (store)=>(0, $iHHEg.updateRelayStore)({
                    cloudId: cloudId,
                    isFavourite: isFavourite,
                    entityId: entityId,
                    favouriteConnectionId: favouriteConnectionId,
                    store: store
                }),
            updater: (store, response)=>{
                if (response?.jira?.setEntityIsFavourite?.success && response.jira.setEntityIsFavourite.favouriteValue?.isFavourite != null) (0, $iHHEg.updateRelayStore)({
                    cloudId: cloudId,
                    isFavourite: response.jira.setEntityIsFavourite.favouriteValue.isFavourite,
                    entityId: entityId,
                    favouriteConnectionId: favouriteConnectionId,
                    store: store
                });
            },
            onCompleted: (response)=>{
                if (!response?.jira?.setEntityIsFavourite?.success) {
                    displayErrorFlag(planTitle, isFavourite);
                    onErrorCallback();
                }
            },
            onError: ()=>{
                displayErrorFlag(planTitle, isFavourite);
                onErrorCallback();
            }
        });
    }, [
        commitMutation,
        cloudId,
        displayErrorFlag
    ]);
    return {
        setFavourite: setFavourite,
        isLoading: isLoading
    };
};

});
parcelRegister("lc0Q9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad2e9fd1b6d85505$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f2580beff69de76304b7ee37badbb488>>
 * @relayHash 15e5ac1f5bf073f876f3bc05be6d805f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dd3d3c721753ed1a9509f36f8085ff3e2a22365f89ab238c3a4ab1851d20517c
const $ad2e9fd1b6d85505$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v7 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "setFavouritePlanMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSetIsFavouritePayload",
                            "kind": "LinkedField",
                            "name": "setEntityIsFavourite",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "setFavouritePlanMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSetIsFavouritePayload",
                            "kind": "LinkedField",
                            "name": "setEntityIsFavourite",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "dd3d3c721753ed1a9509f36f8085ff3e2a22365f89ab238c3a4ab1851d20517c",
            "metadata": {},
            "name": "setFavouritePlanMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$ad2e9fd1b6d85505$var$node.hash = "3d9667a5509bfdf5d0b3cadff5c35398";
var $ad2e9fd1b6d85505$export$2e2bcd8739ae039 = $ad2e9fd1b6d85505$var$node;

});

parcelRegister("h3yCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b752d41397f42984$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b752d41397f42984$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitleNonFinal: {
        id: 'jet-plan-action-menu.services.set-favourite.error-flag-title-non-final',
        defaultMessage: "We couldn't save the changes",
        description: 'Title for the flag shown if the favourite update fails'
    },
    errorFlagDescriptionFailedAddNonFinal: {
        id: 'jet-plan-action-menu.services.set-favourite.error-flag-description-failed-add-non-final',
        defaultMessage: "We couldn't add {planTitle} to starred. Refresh and try again.",
        description: 'Description for the flag shown if adding plan to favourite fails'
    },
    errorFlagDescriptionFailedRemoveNonFinal: {
        id: 'jet-plan-action-menu.services.set-favourite.error-flag-description-failed-remove-non-final',
        defaultMessage: "We couldn't remove {planTitle} from starred. Refresh and try again.",
        description: 'Description for the flag shown if removing plan from favourite fails'
    }
});

});

parcelRegister("iHHEg", function(module, exports) {

$parcel$export(module.exports, "updateRelayStore", () => $69bff9eefbac6075$export$b75a687ab1368503);

var $eiowN = parcelRequire("eiowN");

var $erN97 = parcelRequire("erN97");
const $69bff9eefbac6075$export$b75a687ab1368503 = ({ cloudId: cloudId, isFavourite: isFavourite, store: store, favouriteConnectionId: favouriteConnectionId, entityId: entityId })=>{
    const entityTypeName = 'JiraPlan';
    const nodeId = (0, $erN97.default)({
        id: entityId
    }, entityTypeName) ?? '';
    const node = store.get(nodeId);
    let favourites;
    if (favouriteConnectionId) /**
		 * We first try to fetch connection using connectionId, but in the header of individual
		 * plan, we don't have access to this connection. Hence we are manually access
		 * the connection in the else block.
		 */ favourites = store.get(favouriteConnectionId);
    else {
        /**
		 * Make sure the "first: 15" below matches with the firstCount in the graphql query written in the
		 * file below. Else this will not work.
		 *
		 * jira/src/packages/navigation-apps/sidebar-nav4/plans/src/ui/plans/common/plans-list/PlansList.tsx
		 */ const jiraRecord = store.getRoot().getLinkedRecord('jira');
        favourites = jiraRecord?.getLinkedRecord('favourites', {
            cloudId: cloudId,
            filter: {
                type: 'PLAN'
            },
            first: 15
        });
    }
    // Exit if we can't find the relevant node or favourite connection
    if (!node || !favourites) return;
    node.getLinkedRecord('favouriteValue')?.setValue(isFavourite, 'isFavourite');
    if (isFavourite) {
        const edge = (0, $eiowN.ConnectionHandler).createEdge(store, favourites, node, 'JiraFavouriteEdge');
        (0, $eiowN.ConnectionHandler).insertEdgeBefore(favourites, edge);
    } else (0, $eiowN.ConnectionHandler).deleteNode(favourites, nodeId);
};

});


parcelRegister("1Vnxw", function(module, exports) {

$parcel$export(module.exports, "ArchivePlanModal", () => $63d6a0b93b4e0a74$export$18a8da6e12f1ef88);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $9DMzk = parcelRequire("9DMzk");

var $lVJAU = parcelRequire("lVJAU");

var $eBvEd = parcelRequire("eBvEd");
const $63d6a0b93b4e0a74$export$18a8da6e12f1ef88 = ({ planId: planId, scenarioId: scenarioId, planTitle: planTitle, isArchived: isArchived, setClosed: setClosed, setPlanArchiveStatus: setPlanArchiveStatus })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onComplete = ()=>{
        setPlanArchiveStatus();
        const title = isArchived ? (0, $eBvEd.default).restored : (0, $eBvEd.default).archived;
        showFlag({
            title: title,
            type: 'success',
            isAutoDismiss: false,
            messageId: 'jet-plan-action-menu.ui.archive-modal.show-flag.success.plan-archiving-async.on-complete',
            messageType: 'transactional'
        });
        push(`/jira/plans/${planId}/scenarios/${scenarioId}`);
    };
    const onError = ()=>{
        setClosed();
        showFlag({
            id: isArchived ? 'restorePlanError' : 'archivePlanError',
            title: isArchived ? (0, $eBvEd.default).restoreErrorTitle : (0, $eBvEd.default).archiveErrorTitle,
            description: isArchived ? formatMessage((0, $eBvEd.default).restoreErrorDescription, {
                planTitle: planTitle
            }) : formatMessage((0, $eBvEd.default).archiveErrorDescription, {
                planTitle: planTitle
            }),
            type: 'error',
            messageId: 'jet-plan-action-menu.ui.archive-modal.show-flag.error.plan-archiving-async.on-error',
            messageType: 'transactional'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9DMzk.default), {
        planId: planId,
        planTitle: planTitle,
        isArchived: isArchived,
        onClose: setClosed,
        onComplete: onComplete,
        onError: onError,
        fallback: null
    });
};

});
parcelRegister("9DMzk", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1fa3ce63a819423$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $clxo5 = parcelRequire("clxo5");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $f1fa3ce63a819423$var$LazyComponent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("fBTA1")).then((module)=>module.ArchivePlanModal), {
    moduleId: "./src/packages/portfolio-3/plan-archiving/src/index.tsx"
});
const $f1fa3ce63a819423$var$AsyncComponent = ({ fallback: fallback, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "bundle-portfolio-3-plan-archiving",
        fallback: "flag",
        packageName: "jira-plan-archiving"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "plan-archiving",
        fallback: fallback !== undefined ? fallback : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
            size: "small"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1fa3ce63a819423$var$LazyComponent, props)));
$f1fa3ce63a819423$var$AsyncComponent.defaultProps = {
    fallback: undefined
};
var $f1fa3ce63a819423$export$2e2bcd8739ae039 = $f1fa3ce63a819423$var$AsyncComponent;

});
parcelRegister("fBTA1", function(module, exports) {

let $b5d56cbc13d734d2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b5d56cbc13d734d2$var$load("jzMKv").then(()=>parcelRequire('9JT0Q'));

});


parcelRegister("eBvEd", function(module, exports) {

$parcel$export(module.exports, "default", () => $8518b0fcff5c42fa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8518b0fcff5c42fa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    archived: {
        "id": "jet-plan-action-menu.archive-modal.archived",
        "defaultMessage": "Plan archived successfully"
    },
    restored: {
        "id": "jet-plan-action-menu.archive-modal.restored",
        "defaultMessage": "Plan restored successfully"
    },
    archiveErrorTitle: {
        "id": "jet-plan-action-menu.archive-modal.archive-error-title",
        "defaultMessage": "We couldn't archive your plan"
    },
    archiveErrorDescription: {
        "id": "jet-plan-action-menu.archive-modal.archive-error-description",
        "defaultMessage": "We couldn't archive {planTitle}.\nRefresh the page and try again."
    },
    restoreErrorTitle: {
        "id": "jet-plan-action-menu.archive-modal.restore-error-title",
        "defaultMessage": "We couldn't restore your plan"
    },
    restoreErrorDescription: {
        "id": "jet-plan-action-menu.archive-modal.restore-error-description",
        "defaultMessage": "We couldn't restore {planTitle}.\nRefresh the page and try again."
    }
});

});


parcelRegister("5Gcoq", function(module, exports) {

$parcel$export(module.exports, "DuplicatePlanModal", () => $9fd119bc95c27f66$export$d87287bf306868bb);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $l5kCn = parcelRequire("l5kCn");

var $lVJAU = parcelRequire("lVJAU");

var $iFVf9 = parcelRequire("iFVf9");
const $9fd119bc95c27f66$export$d87287bf306868bb = ({ planId: planId, planTitle: planTitle, setClosed: setClosed })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onComplete = (newPlanId, newScenarioId)=>{
        setClosed();
        push(`/jira/plans/${newPlanId}/scenarios/${newScenarioId}`);
    };
    const onError = ()=>{
        setClosed();
        showFlag({
            id: 'duplicatePlanError',
            type: 'error',
            title: (0, $iFVf9.default).errorTitle,
            description: formatMessage((0, $iFVf9.default).errorDescription, {
                planTitle: planTitle
            }),
            messageId: 'jet-plan-action-menu.ui.duplicate-modal.show-flag.error.plan-duplicating-async.on-error',
            messageType: 'transactional'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l5kCn.default), {
        planId: planId,
        planTitle: planTitle,
        onClose: setClosed,
        onComplete: onComplete,
        onError: onError,
        fallback: null
    });
};

});
parcelRegister("l5kCn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e86dc1bbc2087d03$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $clxo5 = parcelRequire("clxo5");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $e86dc1bbc2087d03$var$LazyComponent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("8EMF3")), {
    moduleId: "./src/packages/portfolio-3/plan-duplicating/src/index.tsx"
});
const $e86dc1bbc2087d03$var$AsyncComponent = ({ fallback: fallback, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "bundle-portfolio-3-plan-duplicating",
        fallback: "flag",
        packageName: "jira-plan-duplicating"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "plan-duplicating",
        fallback: fallback !== undefined ? fallback : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
            size: "large"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e86dc1bbc2087d03$var$LazyComponent, props)));
$e86dc1bbc2087d03$var$AsyncComponent.defaultProps = {
    fallback: undefined
};
var $e86dc1bbc2087d03$export$2e2bcd8739ae039 = $e86dc1bbc2087d03$var$AsyncComponent;

});
parcelRegister("8EMF3", function(module, exports) {

let $64d7ce4347724d76$var$load = (parcelRequire("28QjX"))(4);
module.exports = $64d7ce4347724d76$var$load("3TK0k").then(()=>parcelRequire('ciROb'));

});


parcelRegister("iFVf9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cf350efa14a61a8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0cf350efa14a61a8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "jet-plan-action-menu.duplicate-modal.error-title",
        "defaultMessage": "We couldn't duplicate your plan"
    },
    errorDescription: {
        "id": "jet-plan-action-menu.duplicate-modal.error-description",
        "defaultMessage": "We couldn't duplicate {planTitle}.\nRefresh the page and try again."
    }
});

});


parcelRegister("gPwud", function(module, exports) {

$parcel$export(module.exports, "default", () => $e559f9b9c0f28c83$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e559f9b9c0f28c83$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    triggerLabel: {
        "id": "jet-plan-action-menu.trigger-label",
        "defaultMessage": "Plan settings"
    },
    help: {
        "id": "jet-plan-action-menu.help",
        "defaultMessage": "Get started with plans"
    },
    duplicate: {
        "id": "jet-plan-action-menu.duplicate",
        "defaultMessage": "Duplicate plan"
    },
    trash: {
        "id": "jet-plan-action-menu.trash",
        "defaultMessage": "Move to trash"
    },
    archive: {
        "id": "jet-plan-action-menu.archive",
        "defaultMessage": "Archive"
    },
    restore: {
        "id": "jet-plan-action-menu.restore",
        "defaultMessage": "Restore"
    },
    takeTour: {
        "id": "jet-plan-action-menu.take-tour",
        "defaultMessage": "Take tour"
    },
    starPlan: {
        "id": "jet-plan-action-menu.star-plan",
        "defaultMessage": "Add to starred"
    },
    unstarPlan: {
        "id": "jet-plan-action-menu.unstar-plan",
        "defaultMessage": "Remove from starred"
    },
    planSettings: {
        "id": "jet-plan-action-menu.plan-settings",
        "defaultMessage": "Plan settings"
    }
});

});

parcelRegister("b6Up7", function(module, exports) {

$parcel$export(module.exports, "MoreNavMenuButton", () => $03a56dc7de7d041b$export$df3f5812ef8777cb);

var $5uXOq = parcelRequire("5uXOq");

var $1Seuh = parcelRequire("1Seuh");

var $elaEw = parcelRequire("elaEw");

var $4AeHp = parcelRequire("4AeHp");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $jgJNO = parcelRequire("jgJNO");

var $dCm1o = parcelRequire("dCm1o");

var $9bWB7 = parcelRequire("9bWB7");

var $hgY6g = parcelRequire("hgY6g");
const $03a56dc7de7d041b$export$df3f5812ef8777cb = ({ MenuItems: MenuItems, onCloseMenu: onCloseMenu, isOpen: isOpen, onClick: onClick, isUsedForSidebarNav: isUsedForSidebarNav })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const content = (contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hgY6g.MoreNavMenuButtonSubmenu), {
            ...contentProps,
            MenuItems: MenuItems
        });
    const onClose = (0, $5uXOq.useCallback)(()=>{
        onCloseMenu();
    }, [
        onCloseMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        content: content,
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        messageId: "jet-plan-action-menu.ui.more-nav-menu-button.popup",
        messageType: "transactional",
        trigger: ({ ref: ref, ...props })=>isUsedForSidebarNav ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
                ...props,
                onClick: onClick,
                label: formatMessage((0, $9bWB7.default).triggerLabel),
                ref: ref,
                icon: (0, $4R6GH.fg)('update_plan_more_menu_icon') ? (0, (/*@__PURE__*/$parcel$interopDefault($4AeHp))) : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($elaEw))), {
                        LEGACY_size: "small",
                        label: ""
                    }),
                appearance: (0, $4R6GH.fg)('update_plan_more_menu_icon') ? 'subtle' : 'default',
                spacing: "compact",
                testId: "jet-plan-action-menu.ui.more-nav-menu-button.sidebar",
                ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-meatball-menu-button-tooltips') ? {
                    isTooltipDisabled: false,
                    tooltip: {
                        content: formatMessage((0, $9bWB7.default).moreActionsTooltip),
                        hideTooltipOnClick: true
                    }
                } : {
                    isTooltipDisabled: true
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
                ...props,
                isSelected: isOpen,
                onClick: onClick,
                label: formatMessage((0, $9bWB7.default).triggerLabel),
                ref: ref,
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($elaEw))),
                isTooltipDisabled: false,
                testId: "jet-plan-action-menu.ui.more-nav-menu-button.horizontal"
            }),
        shouldRenderToParent: true
    });
};

});
parcelRegister("9bWB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f6b8f8823cfc9b2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1f6b8f8823cfc9b2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    triggerLabel: {
        "id": "jet-plan-action-menu.more-nav-menu-button.trigger-label",
        "defaultMessage": "Plan settings"
    },
    moreActionsTooltip: {
        "id": "jet-plan-action-menu.more-nav-menu-button.tooltip",
        "defaultMessage": "More actions"
    }
});

});

parcelRegister("hgY6g", function(module, exports) {

$parcel$export(module.exports, "MoreNavMenuButtonSubmenu", () => $760a228c1d0decc4$export$ac88f3e136748c4a);

var $5uXOq = parcelRequire("5uXOq");

var $aOrxC = parcelRequire("aOrxC");
const $760a228c1d0decc4$export$ac88f3e136748c4a = ({ MenuItems: MenuItems, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), {
        minWidth: 250
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItems, {
        onClose: onClose
    }));

});


parcelRegister("49Q1d", function(module, exports) {

$parcel$export(module.exports, "TrashPlanModal", () => $8495ccc444a51798$export$904566914f982884);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $1UdpC = parcelRequire("1UdpC");

var $lVJAU = parcelRequire("lVJAU");

var $8meBj = parcelRequire("8meBj");
const $8495ccc444a51798$export$904566914f982884 = ({ planId: planId, setClosed: setClosed, planTitle: planTitle })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onComplete = ()=>{
        push('/jira/plans');
        setClosed();
    };
    const onError = ()=>{
        setClosed();
        showFlag({
            id: 'trashPlanError',
            type: 'error',
            title: (0, $8meBj.default).errorTitle,
            description: formatMessage((0, $8meBj.default).errorDescription, {
                planTitle: planTitle
            }),
            messageId: 'jet-plan-action-menu.ui.trash-modal.show-flag.error.plan-trash-async',
            messageType: 'transactional'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1UdpC.default), {
        planId: planId,
        onCancel: setClosed,
        onComplete: onComplete,
        onError: onError,
        fallback: null
    });
};

});
parcelRegister("1UdpC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac5576cc8d5796eb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $clxo5 = parcelRequire("clxo5");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $ac5576cc8d5796eb$var$LazyComponent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("1jbcM")).then((module)=>module.TrashPlanModal), {
    moduleId: "./src/packages/portfolio-3/plan-trash/src/index.tsx"
});
const $ac5576cc8d5796eb$var$AsyncComponent = ({ fallback: fallback, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "bundle-portfolio-3-plan-trash",
        fallback: "flag",
        packageName: "jira-plan-trash"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "plan-trash",
        fallback: fallback !== undefined ? fallback : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
            size: "small"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac5576cc8d5796eb$var$LazyComponent, props)));
$ac5576cc8d5796eb$var$AsyncComponent.defaultProps = {
    fallback: undefined
};
var $ac5576cc8d5796eb$export$2e2bcd8739ae039 = $ac5576cc8d5796eb$var$AsyncComponent;

});
parcelRegister("1jbcM", function(module, exports) {

let $0f4041e19f3ac27d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0f4041e19f3ac27d$var$load("ex6pL").then(()=>parcelRequire('JXA9h'));

});


parcelRegister("8meBj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0f94a0b459116de$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d0f94a0b459116de$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "jet-plan-action-menu.trash-modal.error-title",
        "defaultMessage": "We couldn't delete your plan"
    },
    errorDescription: {
        "id": "jet-plan-action-menu.trash-modal.error-description",
        "defaultMessage": "We couldn't move {planTitle} to the trash.\nRefresh the page and try again."
    }
});

});


parcelRegister("gPhGo", function(module, exports) {

$parcel$export(module.exports, "isPlanAndScenarioMatchingUrl", () => $86a26bb326292102$export$b28296022e253b2f);
const $86a26bb326292102$export$b28296022e253b2f = ({ urlPlanId: urlPlanId, urlScenarioId: urlScenarioId, planId: planId, scenarioId: scenarioId })=>{
    if (!urlPlanId || !urlScenarioId) return false;
    return Number(urlPlanId) === planId && Number(urlScenarioId) === scenarioId;
};

});



parcelRegister("bjtEO", function(module, exports) {

$parcel$export(module.exports, "asyncPlanActionMenu", () => $9dac3a4e8eabd3c7$export$62f1bed3a2f7698);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $9dac3a4e8eabd3c7$export$62f1bed3a2f7698 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("3pG3p")).then(({ AsyncPlanActionMenuContent: AsyncPlanActionMenuContent })=>AsyncPlanActionMenuContent), {
        moduleId: "3038e241"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3pG3p", function(module, exports) {

let $27c453f508f7b231$var$load = (parcelRequire("28QjX"))(4);
module.exports = $27c453f508f7b231$var$load("5vCVP").then(()=>parcelRequire('k16yv'));

});





parcelRegister("iUfQY", function(module, exports) {

$parcel$export(module.exports, "Nav4PlansPremiumUpsellFeatureGate", () => $dd47fda66af0f6fa$export$87c172423f26b2a0);

var $5uXOq = parcelRequire("5uXOq");

var $eOat1 = parcelRequire("eOat1");

var $aProA = parcelRequire("aProA");

var $46Cti = parcelRequire("46Cti");

var $4R6GH = parcelRequire("4R6GH");

var $dUyqZ = parcelRequire("dUyqZ");

var $3senf = parcelRequire("3senf");
var $l7Vqz = parcelRequire("l7Vqz");
var $8luXP = parcelRequire("8luXP");

var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $tKTx3 = parcelRequire("tKTx3");

var $koVbs = parcelRequire("koVbs");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $fzr0K = parcelRequire("fzr0K");

var $eCT4E = parcelRequire("eCT4E");
const $dd47fda66af0f6fa$export$87c172423f26b2a0 = ()=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).PLANS);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { entryPointActions: entryPointActions } = (0, $4mO32.useEntryPoint)((0, $fzr0K.planUpsellEntryPoint), {});
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    if ((0, $4R6GH.fg)('migrate_plans_upsell_to_full_page')) {
        const { path: path } = (0, $eCT4E.planUpsellRoute);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
            menuId: (0, $jhS4y.MENU_ID_PLANS),
            elemBefore: icon,
            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
                testId: "navigation-apps-sidebar-nav4-sidebars-content-plans.ui.plans.premium-upsell-feature-gate.upsell-lozenge",
                appearance: "new"
            }, formatMessage((0, $tKTx3.default).upsellLozengeText)),
            href: path,
            ref: triggerRef
        }, formattedMessage);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3senf.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8luXP.FlyoutMenuItemTrigger), {
        elemBefore: icon
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l7Vqz.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aProA.default), null)));
};

});
parcelRegister("aProA", function(module, exports) {

$parcel$export(module.exports, "default", () => $59ef1621dccedbfe$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1nSOt = parcelRequire("1nSOt");

var $bWfiu = parcelRequire("bWfiu");

var $hWGQo = parcelRequire("hWGQo");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $6VxGE = parcelRequire("6VxGE");

var $iwnVa = parcelRequire("iwnVa");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $liGrj = parcelRequire("liGrj");

var $8zOmE = parcelRequire("8zOmE");

var $dCm1o = parcelRequire("dCm1o");

var $Mp6qH = parcelRequire("Mp6qH");

var $iIz7a = parcelRequire("iIz7a");

var $gblI8 = parcelRequire("gblI8");
const $59ef1621dccedbfe$var$LEARN_MORE_LINK = 'https://www.atlassian.com/software/jira/guides/advanced-roadmaps/overview#what-are-advanced-roadmaps';
// Statsig experiment `plans_menu_try_it_free_one_stop_shop_modal`
// the control cohort will be shown the modal, whereas the test cohort will be redirected to the billing page instead.
// if the check errors for whatever reason, we still want to show the modal, hence why it defaults to true
const $59ef1621dccedbfe$var$PremiumFeatureGate = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    const { data: { premiumTrialUpgradeLink: premiumTrialUpgradeLink } } = (0, $6s1PB.expVal)('plans_menu_try_it_free_one_stop_shop_modal', 'isOneStopShopModalEnabled', true) ? {
        data: {
            premiumTrialUpgradeLink: undefined
        }
    } : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $iwnVa.useJswPremiumTrialUpgradeLink)({
        caller: (0, $Mp6qH.PACKAGE_NAME)
    });
    const onStartTrialClick = (_, analyticsEvent)=>{
        if ((0, $dCm1o.isVisualRefreshEnabled)()) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'plansNavigationMenuItem', {
            level: 2,
            componentType: 'fixedItemAction',
            parentItemId: 'plans',
            itemId: 'tryItFree'
        });
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'navigationUpgradeToPremiumFromPlansMenu');
    };
    const onLearnMoreClick = (_, analyticsEvent)=>{
        if ((0, $dCm1o.isVisualRefreshEnabled)()) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'plansNavigationMenuItem', {
            level: 2,
            componentType: 'fixedItemAction',
            parentItemId: 'plans',
            itemId: 'readTheGuide'
        });
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'navigationLearnMoreAboutPremiumFromPlansMenu');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$MenuContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$MenuHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iIz7a.FeatureGateLogo), {
        alt: "",
        colorMode: colorMode
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $gblI8.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $59ef1621dccedbfe$var$contentDescriptionStyles
    }, formatMessage((0, $gblI8.default).description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$LearnMoreButton, {
        appearance: "link",
        href: $59ef1621dccedbfe$var$LEARN_MORE_LINK,
        target: "_blank",
        onClick: onLearnMoreClick
    }, formatMessage((0, $gblI8.default).learnMoreLink)), (0, $6s1PB.expVal)('plans_menu_try_it_free_one_stop_shop_modal', 'isOneStopShopModalEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$TryPremiumButton, {
        onClick: onStartTrialClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWGQo))), {
            LEGACY_size: "small",
            label: formatMessage((0, $gblI8.default).imageAlt),
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    }, formatMessage((0, $gblI8.default).startTrialButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59ef1621dccedbfe$var$TryPremiumButtonDirectLink, {
        href: premiumTrialUpgradeLink,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWGQo))), {
            LEGACY_size: "small",
            label: formatMessage((0, $gblI8.default).imageAlt),
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    }, formatMessage((0, $gblI8.default).startTrialButton))));
};
var $59ef1621dccedbfe$export$2e2bcd8739ae039 = $59ef1621dccedbfe$var$PremiumFeatureGate;
const $59ef1621dccedbfe$var$TryPremiumButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $liGrj.PremiumUpgradeModalEntryPointButton), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    });
const $59ef1621dccedbfe$var$TryPremiumButtonDirectLink = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1nSOt.default), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    });
const $59ef1621dccedbfe$var$LearnMoreButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1nSOt.default), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    maxWidth: '250px',
                    marginRight: "var(--ds-space-200, 16px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59ef1621dccedbfe$var$MenuContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1b66 _11q717kt _189et94y _1dqonqa1 _1h6d3acm _vchhusvi _qjkjusvi _1y1m18uv _p12f4lgm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59ef1621dccedbfe$var$MenuHeaderContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7gup1 _2rko1xsr _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4t3il1r9 _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59ef1621dccedbfe$var$ContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7vuon _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $59ef1621dccedbfe$var$contentDescriptionStyles = (0, $2s57o.xcss)({
    marginTop: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59ef1621dccedbfe$var$FooterContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7vuon _2rko4dok _ca0qidpf _u5f31ejb _n3td1ejb _19bv1ejb _1e0c1txw _4cvr1h6o _1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iwnVa", function(module, exports) {

$parcel$export(module.exports, "useJswPremiumTrialUpgradeLink", () => $fc84e0a2b7204935$export$645eda3f5f2163ec);

var $2vSU6 = parcelRequire("2vSU6");


var $ldyPw = parcelRequire("ldyPw");

var $9OXo1 = parcelRequire("9OXo1");

var $7qMMP = parcelRequire("7qMMP");
const $fc84e0a2b7204935$export$645eda3f5f2163ec = ({ deepLink: deepLink = true, skip: skip = false, caller: caller })=>{
    const { productEntitlementDetails: productEntitlementDetails } = (0, $9OXo1.useTenantContext)();
    const jswEntitlement = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d];
    const isJswUsingCcp = jswEntitlement?.billingSourceSystem === 'CCP';
    const { data: data, ...rest } = (0, $7qMMP.useGetBillingPageUrl)({
        isUsingCcp: isJswUsingCcp,
        editionToUpgradeTo: deepLink ? (0, $ldyPw.PREMIUM_EDITION) : undefined,
        caller: caller,
        skip: skip,
        subProduct: (0, $2vSU6.SOFTWARE_PROJECT)
    });
    return {
        data: {
            premiumTrialUpgradeLink: data.billingPageUrl
        },
        ...rest
    };
};

});
parcelRegister("7qMMP", function(module, exports) {

$parcel$export(module.exports, "useGetBillingPageUrl", () => $8899a5adc0f59798$export$7b1495b7581dcd01);

var $5uXOq = parcelRequire("5uXOq");

var $cVzoY = parcelRequire("cVzoY");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $14XJw = parcelRequire("14XJw");


var $ldyPw = parcelRequire("ldyPw");

var $16v4H = parcelRequire("16v4H");

var $9OXo1 = parcelRequire("9OXo1");

var $7j7Ij = parcelRequire("7j7Ij");

var $5aye8 = parcelRequire("5aye8");

var $5Q4f1 = parcelRequire("5Q4f1");

var $iHAwr = parcelRequire("iHAwr");
const $8899a5adc0f59798$export$7b1495b7581dcd01 = ({ isUsingCcp: isUsingCcp, editionToUpgradeTo: editionToUpgradeTo, caller: caller, skip: skip = false, subProduct: subProduct, onError: onError })=>{
    const [billingPageUrl, setBillingPageUrl] = (0, $5uXOq.useState)();
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const contextSubProduct = (0, $16v4H.useSubProduct)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const subProductToUse = subProduct || contextSubProduct;
    (0, $5uXOq.useEffect)(()=>{
        if (skip) return;
        const loadBillingInfo = async ()=>{
            try {
                const explicitlyLicensedProducts = (0, $cVzoY.default)(tenantContext);
                const productKey = (0, $iHAwr.getProductKey)(subProductToUse, explicitlyLicensedProducts);
                const referrerKey = (0, $5aye8.getProductReferrerKey)(productKey);
                // The product key as used by Commerce.
                // JPD product key as used by Commerce does not include .ondemand
                const commerceProductKey = productKey === (0, $c06e1abca7c13910$export$202f50ee62667e32) ? productKey : `${productKey}.ondemand`;
                const entitlementId = productKey ? tenantContext.productEntitlementDetails?.[productKey]?.entitlementId : null;
                if (isUsingCcp) {
                    if (!entitlementId) {
                        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'RetrieveEntitlementId failed', {
                            caller: caller,
                            productKey: productKey,
                            productEntitlementDetails: JSON.stringify(tenantContext.productEntitlementDetails),
                            subProduct: subProductToUse
                        });
                        throw new Error('Empty entitlement ID');
                    }
                    const ccpTransactionAccountId = await (0, $5aye8.getCcpTransactionAccountId)(entitlementId);
                    // List of valid referrer values
                    // https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2652063891/How+to+Deeplink+to+BAC+s+change+plan#How-to-use-this-deeplink%3F
                    const ccpBaseUrl = `${(0, $5Q4f1.getAdminBaseUrl)()}/billing/o/${orgId}/${ccpTransactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=${referrerKey}&enableMpucup=true`;
                    switch(editionToUpgradeTo){
                        case 0, $ldyPw.STANDARD_EDITION:
                        case 0, $ldyPw.PREMIUM_EDITION:
                            setBillingPageUrl(`${ccpBaseUrl}&offeringName=${(0, $7j7Ij.EDITION_KEY)[editionToUpgradeTo]}`);
                            break;
                        default:
                            setBillingPageUrl(ccpBaseUrl);
                    }
                } else // HAMS Billing System
                switch(editionToUpgradeTo){
                    case 0, $ldyPw.STANDARD_EDITION:
                    case 0, $ldyPw.PREMIUM_EDITION:
                        setBillingPageUrl(`${(0, $5Q4f1.getAdminBaseUrl)()}/s/${tenantContext.cloudId}/billing/applications/change-edition/${commerceProductKey}/${(0, $7j7Ij.EDITION_KEY)[editionToUpgradeTo]}`);
                        break;
                    default:
                        setBillingPageUrl(`${(0, $5Q4f1.getAdminBaseUrl)()}/s/${tenantContext.cloudId}/billing/applications/change-edition/${commerceProductKey}`);
                }
            } catch (e) {
                setError(e);
                if (onError && e instanceof Error) onError(e);
            } finally{
                setLoading(false);
            }
        };
        loadBillingInfo();
    }, [
        caller,
        createAnalyticsEvent,
        editionToUpgradeTo,
        isUsingCcp,
        onError,
        orgId,
        skip,
        subProduct,
        subProductToUse,
        tenantContext,
        tenantContext.cloudId
    ]);
    return {
        data: {
            billingPageUrl: billingPageUrl
        },
        loading: loading,
        error: error
    };
};

});
parcelRegister("cVzoY", function(module, exports) {

$parcel$export(module.exports, "default", () => $386aacc800b616d8$export$2e2bcd8739ae039);

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$386aacc800b616d8$export$2e2bcd8739ae039 = (tenantContext)=>{
    const { licensedProducts: licensedProducts } = tenantContext;
    const result = [];
    licensedProducts[0, $c06e1abca7c13910$export$db515c8cec1e6f79] && result.push((0, $c06e1abca7c13910$export$db515c8cec1e6f79));
    licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && result.push((0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61));
    licensedProducts[0, $c06e1abca7c13910$export$1346c9aa3cbb477d] && result.push((0, $c06e1abca7c13910$export$1346c9aa3cbb477d));
    licensedProducts[0, $c06e1abca7c13910$export$202f50ee62667e32] && result.push((0, $c06e1abca7c13910$export$202f50ee62667e32));
    return result;
};

});

parcelRegister("16v4H", function(module, exports) {

$parcel$export(module.exports, "subProductFromProjectType", () => $f7eda04ad2dc7e84$export$246e1e2a5c86a633);
$parcel$export(module.exports, "useSubProduct", () => $f7eda04ad2dc7e84$export$16aa2ad52cd8992a);

var $4DPZY = parcelRequire("4DPZY");
const $f7eda04ad2dc7e84$export$246e1e2a5c86a633 = (projectType)=>{
    switch(projectType){
        case 'business':
            return 'core';
        case 'product_discovery':
        case 'software':
            return 'software';
        case 'service_desk':
            return 'serviceDesk';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            projectType;
            return 'unknown';
    }
};
const $f7eda04ad2dc7e84$export$16aa2ad52cd8992a = ()=>{
    const [{ data: data }] = (0, $4DPZY.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (!data?.project) return null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    return $f7eda04ad2dc7e84$export$246e1e2a5c86a633(data.project.type);
};

});
parcelRegister("4DPZY", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $a65e0c39573f7437$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $a65e0c39573f7437$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7xTO3 = parcelRequire("7xTO3");

var $ggg5j = parcelRequire("ggg5j");

var $2YP9W = parcelRequire("2YP9W");

var $6SkQo = parcelRequire("6SkQo");
const $a65e0c39573f7437$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource));
    const projectContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $7xTO3.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$export$c7066c2d215990cf = ()=>{
    const projectContext = $a65e0c39573f7437$var$useProjectContext();
    const userBoardContext = $a65e0c39573f7437$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $a65e0c39573f7437$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $a65e0c39573f7437$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$a65e0c39573f7437$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("6SkQo", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $84cf60e2c9c0e289$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $84cf60e2c9c0e289$export$d17fffd59c7b3c60);

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $bsuuc = parcelRequire("bsuuc");
const $84cf60e2c9c0e289$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $84cf60e2c9c0e289$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $84cf60e2c9c0e289$var$getProjectType = (projectType)=>{
    if (projectType === 'customer_service' && (0, $4R6GH.fg)('jcs_project_type_m3')) return 0, $2vSU6.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'business':
            return 0, $2vSU6.CORE_PROJECT;
        case 'software':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $84cf60e2c9c0e289$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $bsuuc.extractData)(projectNavInfo);
    const scope = $84cf60e2c9c0e289$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $84cf60e2c9c0e289$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $bsuuc.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});



parcelRegister("7j7Ij", function(module, exports) {

$parcel$export(module.exports, "EDITION_KEY", () => $2797dd9db1687273$export$d73720c31c622c1f);

var $ldyPw = parcelRequire("ldyPw");
const $2797dd9db1687273$export$d73720c31c622c1f = {
    STANDARD_EDITION: (0, $ldyPw.STANDARD_EDITION_KEY),
    PREMIUM_EDITION: (0, $ldyPw.PREMIUM_EDITION_KEY)
};

});

parcelRegister("5aye8", function(module, exports) {

$parcel$export(module.exports, "getProductReferrerKey", () => $c065e9df012feb0c$export$b4fb3304d5d8fc5f);
$parcel$export(module.exports, "getCcpTransactionAccountId", () => $c065e9df012feb0c$export$5186b9d213f626fd);

var $7f4tk = parcelRequire("7f4tk");

const $c065e9df012feb0c$export$b4fb3304d5d8fc5f = (productKey)=>{
    if (productKey === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)) return 'jsw';
    if (productKey === (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61)) return 'jsm';
    if (productKey === (0, $c06e1abca7c13910$export$202f50ee62667e32)) return 'jpd';
    if (productKey === (0, $c06e1abca7c13910$export$db515c8cec1e6f79)) return 'jwm';
    return null;
};
const $c065e9df012feb0c$export$5186b9d213f626fd = async (entitlementId)=>{
    const entitlementDetails = await (0, $7f4tk.default)(`/gateway/api/ccp/api/v1/entitlements/${entitlementId}/details`);
    if (!entitlementDetails?.transactionAccountId) // TODO: Handle errors properly
    throw Error('Could not get transactionAccountId');
    return (entitlementDetails ?? {}).transactionAccountId;
};

});

parcelRegister("5Q4f1", function(module, exports) {

$parcel$export(module.exports, "getAdminBaseUrl", () => $2c9346932f4dad13$export$76bb37a926058cca);

var $2ys8y = parcelRequire("2ys8y");
const $2c9346932f4dad13$export$76bb37a926058cca = ()=>`https://${(0, $2ys8y.getATLContextDomain)('admin')}`;

});

parcelRegister("iHAwr", function(module, exports) {

$parcel$export(module.exports, "getProductKey", () => $a2785a755bdb8c08$export$d0b7f02493f85477);

const $a2785a755bdb8c08$export$d0b7f02493f85477 = (subProduct, explicitlyLicensedProducts)=>{
    if (subProduct === 'software') return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
    if (subProduct === 'serviceDesk') return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
    // useSubProduct currently doesn't support polaris
    // JPD's subproduct currently falls under to 'software'
    // https://hello.atlassian.net/wiki/spaces/STAR/pages/2940457206/Detach+from+JSW+analytics+subproduct
    if (subProduct === 'polaris') return 0, $c06e1abca7c13910$export$202f50ee62667e32;
    if (subProduct === 'core') return 0, $c06e1abca7c13910$export$db515c8cec1e6f79;
    // If subProduct is null, we may be on a product-agnostic page e.g. "Your Work".
    // If there is only one licensed product, we can infer what the user is using.
    if (explicitlyLicensedProducts.length === 1) return explicitlyLicensedProducts[0];
    return null;
};

});



parcelRegister("liGrj", function(module, exports) {

$parcel$export(module.exports, "PremiumUpgradeModalEntryPointButton", () => $c0d01fc7cb7615a5$export$9901be7804227da7);

var $5uXOq = parcelRequire("5uXOq");

var $1nSOt = parcelRequire("1nSOt");

var $47gW9 = parcelRequire("47gW9");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $b3Gth = parcelRequire("b3Gth");
const $c0d01fc7cb7615a5$var$entryPointParams = {};
const $c0d01fc7cb7615a5$export$9901be7804227da7 = (buttonProps)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $b3Gth.entryPointPremiumUpgradeModal), $c0d01fc7cb7615a5$var$entryPointParams);
    const buttonTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1nSOt.default), {
        ...buttonProps,
        ref: buttonTrigger
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jira-premium-upgrade-modal",
        packageName: "jiraPremiumUpgradeModal",
        errorFallback: "flag",
        runtimeProps: {
            onClose: entryPointActions.unload
        },
        entryPointActions: entryPointActions
    }));
};

});
parcelRegister("ivDCs", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointContainer", () => $832a9e21b9f9d7ff$export$4d67c6ee49f3d14d);

var $5uXOq = parcelRequire("5uXOq");

var $kW74I = parcelRequire("kW74I");

var $8Bm0k = parcelRequire("8Bm0k");

var $c5vfY = parcelRequire("c5vfY");
const $832a9e21b9f9d7ff$export$4d67c6ee49f3d14d = ({ entryPointActions: { unload: unload }, entryPointReferenceSubject: entryPointReferenceSubject, errorFallback: errorFallback, runtimeProps: runtimeProps, ...containerProps })=>{
    const entryPointReference = (0, $8Bm0k.useEntryPointSubscription)(entryPointReferenceSubject);
    const props = (0, $5uXOq.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            ...runtimeProps,
            onClose () {
                runtimeProps.onClose?.();
                unload();
            }
        }), [
        runtimeProps,
        unload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kW74I.default), null, entryPointReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5vfY.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        errorFallback: errorFallback || 'flag',
        placeholderName: "modal-entry-point-container",
        runtimeProps: props
    }));
};

});

parcelRegister("b3Gth", function(module, exports) {

$parcel$export(module.exports, "entryPointPremiumUpgradeModal", () => $a50fd4829307668f$export$7116d5b1a93db8d6);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $a50fd4829307668f$export$7116d5b1a93db8d6 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("7I91G")).then((module)=>module.PremiumUpgradeModalEntryPoint), {
        moduleId: "1102b440"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7I91G", function(module, exports) {

let $59d3a4db2986cf00$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $59d3a4db2986cf00$var$load("h2MrD"),
    $59d3a4db2986cf00$var$load("bYT2S"),
    $59d3a4db2986cf00$var$load("hPzOn"),
    $59d3a4db2986cf00$var$load("5azfZ")
]).then(()=>parcelRequire('5s8iH'));

});



parcelRegister("iIz7a", function(module, exports) {

$parcel$export(module.exports, "FeatureGateLogo", () => $bde809f68e5981c8$export$83d4ce06fb8c3c0);

var $5uXOq = parcelRequire("5uXOq");

var $5FmWx = parcelRequire("5FmWx");

var $bsqOw = parcelRequire("bsqOw");

var $4pbFL = parcelRequire("4pbFL");
const $bde809f68e5981c8$export$83d4ce06fb8c3c0 = ({ colorMode: colorMode, alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FmWx.default), {
        src: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($bsqOw))) : (0, (/*@__PURE__*/$parcel$interopDefault($4pbFL))),
        alt: alt
    });

});
parcelRegister("bsqOw", function(module, exports) {
module.exports = new URL("plans-standard-dark.fce82c99.svg", import.meta.url).toString();

});

parcelRegister("4pbFL", function(module, exports) {
module.exports = new URL("plans-standard-light.fde35b0d.svg", import.meta.url).toString();

});


parcelRegister("gblI8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ba9ec5dc8deac7d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9ba9ec5dc8deac7d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.title",
        "defaultMessage": "Unlock advanced planning tools"
    },
    imageAlt: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.image-alt",
        "defaultMessage": "Upgrade to Jira Premium"
    },
    description: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.description",
        "defaultMessage": "Boost agility with capacity planning, dependency mapping, and more. Try Jira Premium's high-level cross-team planning tools."
    },
    learnMoreLink: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.learn-more-link",
        "defaultMessage": "Read the guide"
    },
    startTrialButton: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.start-trial-button",
        "defaultMessage": "Try it free"
    }
});

});





parcelRegister("3nmOf", function(module, exports) {

$parcel$export(module.exports, "Nav4Projects", () => $f8e01865477e7c50$export$5baf9fa0c4742f3f);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lwsjn = parcelRequire("lwsjn");

var $l8ruj = parcelRequire("l8ruj");

const $f8e01865477e7c50$export$5baf9fa0c4742f3f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-projects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "projects-section",
        packageName: (0, $4e61701b07fca41a$export$b8b9d90f9e5bd72b),
        teamName: (0, $4e61701b07fca41a$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lwsjn.Nav4Projects), props)));

});
parcelRegister("lwsjn", function(module, exports) {

$parcel$export(module.exports, "Nav4Projects", () => $68918da9ad272fce$export$5baf9fa0c4742f3f);

var $1634p = parcelRequire("1634p");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $fzcoo = parcelRequire("fzcoo");

var $QXHTz = parcelRequire("QXHTz");

var $8syLG = parcelRequire("8syLG");
function $68918da9ad272fce$export$5baf9fa0c4742f3f({ isExpanded: isExpanded, queryRef: queryRef }) {
    const data = (0, $8Uumt.useFragment)((0, $1634p.default), queryRef);
    const { isInitialSelectedPath: isInitialSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const canCreateProject = !!data?.jira?.canCreateProject;
    const actionButtons = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fzcoo.ActionButtons), {
        canCreateProject: canCreateProject
    });
    return isInitialSelectedPath((0, $jhS4y.MENU_ID_PROJECTS)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8syLG.Nav4ProjectsForLanding), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded,
        queryRef: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $QXHTz.Nav4ProjectsDefault), {
        actionsOnHover: actionButtons,
        isExpanded: isExpanded
    });
}

});
parcelRegister("1634p", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf369e5549cfa857$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<16f7b7e2f22cb823a54baf0f889d22af>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cf369e5549cfa857$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "isProjectsExpanded"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Projects",
    "selections": [
        {
            "condition": "isProjectsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4ProjectsForLanding"
                }
            ]
        },
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "alias": "canCreateProject",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_PROJECT"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ]
        }
    ],
    "type": "Query"
};
$cf369e5549cfa857$var$node.hash = "82f2e75eda840a347e0f322cf6e2dade";
var $cf369e5549cfa857$export$2e2bcd8739ae039 = $cf369e5549cfa857$var$node;

});

parcelRegister("fzcoo", function(module, exports) {

$parcel$export(module.exports, "ActionButtons", () => $47193506b60deede$export$88c65d2d98aab183);

var $5uXOq = parcelRequire("5uXOq");

var $51oeD = parcelRequire("51oeD");

var $g7g8o = parcelRequire("g7g8o");

var $44qT7 = parcelRequire("44qT7");
var $aOrxC = parcelRequire("aOrxC");
var $70rf1 = parcelRequire("70rf1");

var $5KCCi = parcelRequire("5KCCi");

var $Mp6qH = parcelRequire("Mp6qH");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $4OlXf = parcelRequire("4OlXf");

var $6ckjW = parcelRequire("6ckjW");

var $80ha2 = parcelRequire("80ha2");

var $fNJRN = parcelRequire("fNJRN");

var $hUpXm = parcelRequire("hUpXm");

var $eDLAW = parcelRequire("eDLAW");


var $46Cti = parcelRequire("46Cti");

var $1xonH = parcelRequire("1xonH");

var $9eeFp = parcelRequire("9eeFp");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $e9QkH = parcelRequire("e9QkH");

var $4R6GH = parcelRequire("4R6GH");

var $7uwUx = parcelRequire("7uwUx");
function $47193506b60deede$export$88c65d2d98aab183({ onClose: onClose, canCreateProject: canCreateProject }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { on: openProjectCreateDrawer }] = (0, $e9QkH.useSwitchModals)((0, $Mp6qH.MODAL_ID).PROJECT_CREATE);
    const { sendMeatBallDropDownAnalyticsEvent: sendMeatBallDropDownAnalyticsEvent, sendCreateProjectAnalyticsEvent: sendCreateProjectAnalyticsEvent } = (0, $fNJRN.useProjectsAnalyticsL1)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, canCreateProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: formatMessage((0, $7uwUx.default).createProject)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xonH.CommonNavMenuButton), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g7g8o))),
        label: formatMessage((0, $7uwUx.default).createProject),
        onClick: ()=>{
            openProjectCreateDrawer();
            sendCreateProjectAnalyticsEvent();
        }
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        onOpen: ()=>{
            sendMeatBallDropDownAnalyticsEvent();
        },
        MenuItems: $47193506b60deede$var$MoreMenuItems,
        onClose: onClose
    }));
}
function $47193506b60deede$var$MoreMenuItems({ onClose: onClose }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const href = (0, $5uXOq.useMemo)(()=>(0, $4OlXf.getProjectsNavigationPaths)().projectsViewProjects, []);
    const { sendMeatBallDropDownManageProjectsAnalyticsEvent: sendMeatBallDropDownManageProjectsAnalyticsEvent, sendChangeViewAnalyticsEvent: sendChangeViewAnalyticsEvent } = (0, $hUpXm.useProjectsAnalyticsL2)();
    const { sendChangeViewViewOptionAnalyticsEvent: sendChangeViewViewOptionAnalyticsEvent } = (0, $eDLAW.useProjectsAnalyticsL3)();
    const onCloseWithStopPropagation = (0, $9eeFp.useStopPropagation)((e)=>{
        sendMeatBallDropDownManageProjectsAnalyticsEvent();
        onClose?.(e);
    });
    const onChangeViewOptionChange = (viewOptionValue)=>{
        const getItemId = ()=>{
            switch(viewOptionValue){
                case (0, $80ha2.ViewOptions).STARRED:
                    return 0, $496585bee7985bb9$export$ed36b1ade72db400;
                case (0, $80ha2.ViewOptions).STARRED_AND_RECENT:
                    return 0, $496585bee7985bb9$export$98d08638c2a90c44;
                case (0, $80ha2.ViewOptions).MOST_RECENT_ONLY:
                    return 0, $496585bee7985bb9$export$d40e6671b6dd5bcc;
                default:
                    return 0, $496585bee7985bb9$export$98d08638c2a90c44;
            }
        };
        sendChangeViewViewOptionAnalyticsEvent({
            itemId: getItemId()
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44qT7.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($51oeD))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        href: href,
        onClick: onCloseWithStopPropagation
    }, formatMessage((0, $7uwUx.default).manageProjects))), (0, $6s1PB.expVal)('blu-6315-display-settings-a-part-1', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        hasSeparator: true,
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ckjW.ChangeViewMenuItem), {
        onOpen: sendChangeViewAnalyticsEvent,
        onChange: onChangeViewOptionChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
        hasSeparator: false,
        menuId: (0, $46Cti.L1_MENU_ID).PROJECTS,
        hasSection: !(0, $4R6GH.fg)('blu-6899_nested_menu_section_bugfix')
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
        menuId: (0, $46Cti.L1_MENU_ID).PROJECTS,
        hasSection: true
    }));
}

});
parcelRegister("4OlXf", function(module, exports) {

$parcel$export(module.exports, "getProjectsNavigationPaths", () => $318f62ba2cbc5bcb$export$5b37488a9fd89879);
const $318f62ba2cbc5bcb$export$5b37488a9fd89879 = ()=>({
        projectsViewProjects: '/jira/settings/projects/manage',
        projectsViewCategories: '/secure/admin/projectcategories/ViewProjectCategories!default.jspa',
        projectsTrashedProjects: '/jira/settings/projects/trash',
        projectsArchivedProjects: '/jira/settings/projects/archive'
    });

});

parcelRegister("6ckjW", function(module, exports) {

$parcel$export(module.exports, "ChangeViewMenuItem", () => $131fc53490d82838$export$3bc1c3c28804a19b);

var $5uXOq = parcelRequire("5uXOq");

var $ll5rh = parcelRequire("ll5rh");

var $LD2gx = parcelRequire("LD2gx");

var $7H980 = parcelRequire("7H980");

var $7mPT9 = parcelRequire("7mPT9");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $kytLE = parcelRequire("kytLE");

var $koeKL = parcelRequire("koeKL");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $h0Kon = parcelRequire("h0Kon");

var $eDBFR = parcelRequire("eDBFR");

var $h2mzI = parcelRequire("h2mzI");

var $8vLvT = parcelRequire("8vLvT");
const $131fc53490d82838$export$3bc1c3c28804a19b = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false), $131fc53490d82838$var$ChangeViewMenuItemNew, $131fc53490d82838$var$ChangeViewMenuItemOld);
function $131fc53490d82838$var$ChangeViewMenuItemOld({ onOpen: onOpen, onChange: onChange }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const onChangeViewMenuItemClick = ()=>{
        if (!isOpen && onOpen) onOpen();
        setIsOpen(!isOpen);
    };
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $h2mzI.ViewOptionsMenuPopupContentEntrypoint), {
        scope: (0, $kytLE.DisplaySettingsScope).PROJECTS,
        onChange: onChange
    });
    const entrypointRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "display-settings-menu-popup-content",
                packageName: "jira-navigation-apps-sidebar-nav4-display-settings",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h0Kon.Skeleton), null),
                runtimeProps: {}
            }),
        placement: "right-start",
        messageId: "navigation-apps-sidebar-nav4-display-settings.ui.change-view-menu-item.popup",
        messageType: "transactional",
        shouldRenderToParent: true,
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
                ...triggerProps,
                ref: (0, $7mPT9.default)(ref, entrypointRef),
                isSelected: isOpen,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ll5rh))), {
                    label: formatMessage((0, $eDBFR.default).listBulletedIcon),
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($LD2gx))), {
                    label: formatMessage((0, $eDBFR.default).chevronRightIcon)
                }),
                onClick: onChangeViewMenuItemClick,
                "aria-label": formatMessage((0, $eDBFR.default).changeViewMenuItemLabel),
                "aria-expanded": isOpen,
                "aria-haspopup": "true"
            }, formatMessage((0, $eDBFR.default).changeViewMenuItemLabel))
    });
}
function $131fc53490d82838$var$ChangeViewMenuItemNew({ onOpen: onOpen, onChange: onChange }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const cloudId = (0, $koeKL.useCloudId)();
    const onChangeViewMenuItemClick = ()=>{
        if (!isOpen && onOpen) onOpen();
        setIsOpen(!isOpen);
    };
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $8vLvT.ProjectsViewOptionsEntrypoint), {
        cloudId: cloudId,
        onChange: onChange
    });
    const entrypointRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "display-settings-menu-popup-content",
                packageName: "jira-navigation-apps-sidebar-nav4-display-settings",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h0Kon.Skeleton), null),
                runtimeProps: {}
            }),
        placement: "right-start",
        // Duplicate messageId due to experiment conditional component
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: "navigation-apps-sidebar-nav4-display-settings.ui.change-view-menu-item.popup",
        messageType: "transactional",
        shouldRenderToParent: true,
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
                ...triggerProps,
                ref: (0, $7mPT9.default)(ref, entrypointRef),
                isSelected: isOpen,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ll5rh))), {
                    label: formatMessage((0, $eDBFR.default).listBulletedIcon),
                    spacing: "spacious",
                    color: "var(--ds-icon, #44546F)"
                }),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($LD2gx))), {
                    label: formatMessage((0, $eDBFR.default).chevronRightIcon)
                }),
                onClick: onChangeViewMenuItemClick,
                "aria-label": formatMessage((0, $eDBFR.default).changeViewMenuItemLabel),
                "aria-expanded": isOpen,
                "aria-haspopup": "true"
            }, formatMessage((0, $eDBFR.default).changeViewMenuItemLabel))
    });
}

});
parcelRegister("kytLE", function(module, exports) {

$parcel$export(module.exports, "DisplaySettingsScope", () => $63cf99b9cfa7c103$export$5df97773a9667af8);
$parcel$export(module.exports, "DisplaySettingsPropertyKeys", () => $63cf99b9cfa7c103$export$5d9ca2391194d3c8);
$parcel$export(module.exports, "DisplaySettingsAllowedValuesMap", () => $63cf99b9cfa7c103$export$3938c8b7d6f592c);

var $80ha2 = parcelRequire("80ha2");
const $63cf99b9cfa7c103$var$PROJECTS = 'projects';
const $63cf99b9cfa7c103$export$5df97773a9667af8 = {
    PROJECTS: $63cf99b9cfa7c103$var$PROJECTS
};
const $63cf99b9cfa7c103$var$VIEW_OPTION = 'VIEW_OPTION';
const $63cf99b9cfa7c103$export$5d9ca2391194d3c8 = {
    VIEW_OPTION: $63cf99b9cfa7c103$var$VIEW_OPTION
};
const $63cf99b9cfa7c103$export$3938c8b7d6f592c = {
    [$63cf99b9cfa7c103$export$5d9ca2391194d3c8.VIEW_OPTION]: Object.values((0, $80ha2.ViewOptions))
};

});
parcelRegister("80ha2", function(module, exports) {

$parcel$export(module.exports, "ViewOptions", () => $8b62df6457429612$export$8cd3967b7c246658);
$parcel$export(module.exports, "DefaultViewOption", () => $8b62df6457429612$export$8df870734bca67fa);
const $8b62df6457429612$var$STARRED_AND_RECENT = 'STARRED_AND_RECENT';
const $8b62df6457429612$var$STARRED = 'STARRED';
const $8b62df6457429612$var$MOST_RECENT_ONLY = 'MOST_RECENT_ONLY';
const $8b62df6457429612$export$8cd3967b7c246658 = {
    STARRED_AND_RECENT: $8b62df6457429612$var$STARRED_AND_RECENT,
    STARRED: $8b62df6457429612$var$STARRED,
    MOST_RECENT_ONLY: $8b62df6457429612$var$MOST_RECENT_ONLY
};
const $8b62df6457429612$export$8df870734bca67fa = $8b62df6457429612$export$8cd3967b7c246658.STARRED_AND_RECENT;

});


parcelRegister("h0Kon", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $87dff8971b16ac84$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $aOrxC = parcelRequire("aOrxC");
var $70rf1 = parcelRequire("70rf1");
var $eCE62 = parcelRequire("eCE62");

var $4DrQd = parcelRequire("4DrQd");

var $6s1PB = parcelRequire("6s1PB");
const $87dff8971b16ac84$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), {
        minWidth: (0, $4DrQd.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), null), (0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), null)));

});

parcelRegister("eDBFR", function(module, exports) {

$parcel$export(module.exports, "default", () => $153017ee62a4e587$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $153017ee62a4e587$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    changeViewMenuItemLabel: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.change-view-menu-item-label",
        "defaultMessage": "Change view"
    },
    starredAndRecentProjectsLabel: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.starred-and-recent-projects-label",
        "defaultMessage": "Starred and recent projects"
    },
    starredProjectsLabel: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.starred-projects-label",
        "defaultMessage": "Starred projects only"
    },
    mostRecentOnlyLabel: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.most-recent-only-label",
        "defaultMessage": "Most recent project only"
    },
    listBulletedIcon: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.list-bulleted-icon",
        "defaultMessage": "List bulleted icon"
    },
    chevronRightIcon: {
        "id": "navigation-apps-sidebar-nav4-display-settings.change-view-action.chevron-right-icon",
        "defaultMessage": "Chevron right icon"
    }
});

});

parcelRegister("h2mzI", function(module, exports) {

$parcel$export(module.exports, "ViewOptionsMenuPopupContentEntrypoint", () => $cdd618e0ad32331d$export$ebd1be9f4df3fdb7);

var $3rdd7 = parcelRequire("3rdd7");

var $aNsVT = parcelRequire("aNsVT");

const $cdd618e0ad32331d$export$ebd1be9f4df3fdb7 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("aVlVC")).then(({ ViewOptionsWithDisplaySettings: ViewOptionsWithDisplaySettings })=>ViewOptionsWithDisplaySettings), {
        moduleId: "846bfedf"
    }),
    getPreloadProps: (extraProps)=>({
            queries: {},
            extraProps: extraProps
        })
});

});
parcelRegister("aVlVC", function(module, exports) {

let $7f403cc87448ac58$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7f403cc87448ac58$var$load("gJqWu").then(()=>parcelRequire('8wK7s'));

});


parcelRegister("8vLvT", function(module, exports) {

$parcel$export(module.exports, "ProjectsViewOptionsEntrypoint", () => $1a2621f1381c8965$export$cd53b98c3c72dc78);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $azPPd = parcelRequire("azPPd");

const $1a2621f1381c8965$export$cd53b98c3c72dc78 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("9rEXK")).then(({ ProjectsViewOptions: ProjectsViewOptions })=>ProjectsViewOptions), {
        moduleId: "bd6faa13"
    }),
    getPreloadProps: ({ cloudId: cloudId, onChange: onChange })=>({
            queries: {
                projectsViewOptions: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $azPPd.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            },
            extraProps: {
                onChange: onChange
            }
        })
});

});
parcelRegister("azPPd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e71402a50e901502$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4a7eabd336a54085b12e6024b67b0182>>
 * @relayHash 367268a979a58b37662cf273a88851ee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dd468ae0c857364119a123f5e1f38c418844966a4acd4018dddf66eb56286f0b
const $e71402a50e901502$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "displayMode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "projectsViewOptionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "projectsViewOptionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProjectsSidebarMenu",
                    "kind": "LinkedField",
                    "name": "jira_projectsSidebarMenu",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "dd468ae0c857364119a123f5e1f38c418844966a4acd4018dddf66eb56286f0b",
            "metadata": {},
            "name": "projectsViewOptionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e71402a50e901502$var$node.hash = "fc0b49221c780edfae3aba8b40f0e778";
var $e71402a50e901502$export$2e2bcd8739ae039 = $e71402a50e901502$var$node;

});

parcelRegister("9rEXK", function(module, exports) {

let $6e0668fd95b9d807$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6e0668fd95b9d807$var$load("cdke4").then(()=>parcelRequire('kwqIJ'));

});



parcelRegister("fNJRN", function(module, exports) {

$parcel$export(module.exports, "useProjectsAnalyticsL1", () => $4b3d1af28d24ea21$export$7d9a1a79b1bd1338);

var $5uXOq = parcelRequire("5uXOq");







var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $aTtGi = parcelRequire("aTtGi");
const $4b3d1af28d24ea21$export$7d9a1a79b1bd1338 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const commonAttributes = (0, $5uXOq.useMemo)(()=>({
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22)
        }), []);
    // fixed item - view all projects link
    const sendViewAllProjectsAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
            itemId: 'viewAllProjects'
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - meatball icon button on projects menu (top level)
    const sendMeatBallDropDownAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
            itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - create project (+) button on projects menu (top level)
    const sendCreateProjectAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
            itemId: 'createProject'
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // custom item - project menu item that displays project name (can be expandable menu or a link)
    const sendProjectMenuItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ starred: starred, recent: recent, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
            itemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
            itemId: projectId,
            projectType: projectType,
            section: (0, $aTtGi.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendViewAllProjectsAnalyticsEvent: sendViewAllProjectsAnalyticsEvent,
        sendMeatBallDropDownAnalyticsEvent: sendMeatBallDropDownAnalyticsEvent,
        sendCreateProjectAnalyticsEvent: sendCreateProjectAnalyticsEvent,
        sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent
    };
};

});
parcelRegister("aTtGi", function(module, exports) {

$parcel$export(module.exports, "getSectionByStarredOrRecent", () => $085f7c8df53a9d4d$export$542854f16c0127e7);

var $jecJ3 = parcelRequire("jecJ3");
const $085f7c8df53a9d4d$export$542854f16c0127e7 = ({ starred: starred, recent: recent })=>{
    if (starred) return 0, $jecJ3.SECTION_ITEM_STARRED;
    if (recent) return 0, $jecJ3.SECTION_ITEM_RECENT;
    return '';
};

});


parcelRegister("hUpXm", function(module, exports) {

$parcel$export(module.exports, "useProjectsAnalyticsL2", () => $d51064a0c3301a50$export$1e04fadc2cea284c);

var $5uXOq = parcelRequire("5uXOq");







var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $aTtGi = parcelRequire("aTtGi");
const $d51064a0c3301a50$export$1e04fadc2cea284c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const commonAttributes = (0, $5uXOq.useMemo)(()=>({
            level: (0, $951a0ed422513987$export$fe3b012b0224e4e1)
        }), []);
    const sendMeatBallDropDownManageProjectsAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
            itemId: 'manageProjects',
            parentItemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
        };
        (0, $8zOmE.fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // board navigation item under each project when project is expandable menu
    const sendBoardNavigationItemInsideProjectsAnalyticsEvent = (0, $5uXOq.useCallback)(({ boardId: boardId, projectId: projectId, recent: recent, starred: starred, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
            itemId: boardId,
            itemType: (0, $632bd8725b437a12$export$9b8283d5878d2491),
            parentItemId: projectId,
            parentItemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $aTtGi.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $8zOmE.fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // meatball menu on projects
    const getMeatBallDropDownOnProjectsAnalytics = (0, $5uXOq.useCallback)(({ recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        return {
            ...commonAttributes,
            actionSubjectId: (0, $d59b407ab907bf7b$export$8d155d2412839524),
            componentType: (0, $1e554a683893bd46$export$9bd6c21d500ae611),
            itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e),
            parentItemId: projectId,
            parentItemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $aTtGi.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
    }, [
        commonAttributes
    ]);
    /** @deprecated, replace with getMeatBallDropDownOnProjectsAnalytics  */ const sendMeatBallDropDownOnProjectsAnalyticsEvent = (0, $5uXOq.useCallback)((params)=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
        });
        const { actionSubjectId: actionSubjectId, ...attributes } = getMeatBallDropDownOnProjectsAnalytics(params);
        (0, $8zOmE.fireUIAnalytics)(event, actionSubjectId, attributes);
    }, [
        createAnalyticsEvent,
        getMeatBallDropDownOnProjectsAnalytics
    ]);
    // create board button
    const sendCreateBoardOnBoardMenuItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$9bd6c21d500ae611),
            itemId: 'createBoard',
            parentItemId: projectId,
            parentItemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $aTtGi.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $8zOmE.fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - view all boards link
    const sendViewAllBoardsAnalyticsEvent = (0, $5uXOq.useCallback)(({ projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
            itemId: 'viewAllBoards',
            parentItemId: projectId,
            parentItemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
            projectType: projectType
        };
        (0, $8zOmE.fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // fixed item - Change View in Meatball Menu on Projects section
    const sendChangeViewAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
            parentItemId: (0, $496585bee7985bb9$export$44d67b522cbcce6d),
            itemId: (0, $632bd8725b437a12$export$119dad133da0b4a)
        };
        (0, $8zOmE.fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownManageProjectsAnalyticsEvent: sendMeatBallDropDownManageProjectsAnalyticsEvent,
        sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent,
        sendBoardNavigationItemInsideProjectsAnalyticsEvent: sendBoardNavigationItemInsideProjectsAnalyticsEvent,
        sendCreateBoardOnBoardMenuItemAnalyticsEvent: sendCreateBoardOnBoardMenuItemAnalyticsEvent,
        sendViewAllBoardsAnalyticsEvent: sendViewAllBoardsAnalyticsEvent,
        sendChangeViewAnalyticsEvent: sendChangeViewAnalyticsEvent
    };
};

});
const $d59b407ab907bf7b$export$8d155d2412839524 = 'projectsNavigationMenuItem';
const $d59b407ab907bf7b$export$13171e509c859bbf = 'projectSettingsNavigationMenuItem';


parcelRegister("eDLAW", function(module, exports) {

$parcel$export(module.exports, "useProjectsAnalyticsL3", () => $304a05e3ff22f010$export$619b8904be99ed7c);

var $5uXOq = parcelRequire("5uXOq");






var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $aTtGi = parcelRequire("aTtGi");

const $304a05e3ff22f010$export$619b8904be99ed7c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const commonAttributes = (0, $5uXOq.useMemo)(()=>({
            level: (0, $951a0ed422513987$export$f9db6a58b4aabd18)
        }), []);
    // actions inside meatball menu on projects
    const sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ itemId: itemId, recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$56981f28056f258e),
            itemId: itemId,
            parentItemId: projectId,
            parentItemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $aTtGi.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // meatball menu on boards
    const sendMeatBallDropDownOnBoardsAnalyticsEvent = (0, $5uXOq.useCallback)(({ recent: recent, starred: starred, boardId: boardId, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$9bd6c21d500ae611),
            itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e),
            projectId: projectId,
            parentItemId: boardId,
            parentItemType: (0, $632bd8725b437a12$export$9b8283d5878d2491),
            projectType: projectType,
            section: (0, $aTtGi.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    const sendChangeViewViewOptionAnalyticsEvent = (0, $5uXOq.useCallback)(({ itemId: itemId })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
            itemId: itemId,
            parentItemId: (0, $496585bee7985bb9$export$44d67b522cbcce6d)
        };
        (0, $8zOmE.fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent: sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent,
        sendMeatBallDropDownOnBoardsAnalyticsEvent: sendMeatBallDropDownOnBoardsAnalyticsEvent,
        sendChangeViewViewOptionAnalyticsEvent: sendChangeViewViewOptionAnalyticsEvent
    };
};

});

parcelRegister("7uwUx", function(module, exports) {

$parcel$export(module.exports, "default", () => $865591b1f83edfae$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $865591b1f83edfae$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createProject: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.create-project",
        "defaultMessage": "Create project"
    },
    manageProjects: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.action-buttons.manage-projects",
        "defaultMessage": "Manage projects"
    }
});

});


parcelRegister("QXHTz", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectsDefault", () => $8547587d73014b07$export$373934ae259d74df);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $aGONy = parcelRequire("aGONy");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $338xa = parcelRequire("338xa");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $4zcxJ = parcelRequire("4zcxJ");

var $90yGq = parcelRequire("90yGq");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");

var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");

var $4R6GH = parcelRequire("4R6GH");

var $2Ioew = parcelRequire("2Ioew");


var $5GG0x = parcelRequire("5GG0x");


var $bWLzw = parcelRequire("bWLzw");

var $krpZe = parcelRequire("krpZe");

var $c5WDi = parcelRequire("c5WDi");
function $8547587d73014b07$export$373934ae259d74df(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, simulateLoading: simulateLoading = false } = props;
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const currentURL = (0, $aGONy.useGetCurrentUrl)();
    const entryPointParamsOld = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            currentURL: currentURL,
            activationId: activationId,
            atlassianAccountId: atlassianAccountId
        }), [
        cloudId,
        currentURL,
        activationId,
        atlassianAccountId
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            tenantContext: {
                cloudId: cloudId,
                activationId: activationId,
                atlassianAccountId: atlassianAccountId
            }
        }), [
        cloudId,
        activationId,
        atlassianAccountId
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const leftSidebarEPRef = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5));
    const projectsEPRef = leftSidebarEPRef?.entryPoints?.projects;
    const { entryPointActions: entryPointActionsOld, entryPointReferenceSubject: entryPointReferenceSubjectOld } = (0, $4mO32.useEntryPoint)((0, $c5WDi.asyncNav4ProjectsContentViewQuery), entryPointParamsOld);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $krpZe.nav4ProjectsContentEntryPoint), entryPointParams);
    const triggerRef = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).PROJECTS);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    // If starting life expanded, make sure to load.
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) // We intentionally won't re-evaluate this if the route changes.
        {
            if (!projectsEPRef && isExpanded) entryPointActions.load();
        } else if (isExpanded) entryPointActionsOld.load();
    }, [
        entryPointActions,
        entryPointActionsOld,
        projectsEPRef,
        isExpanded
    ]);
    const menuId = (0, $jhS4y.MENU_ID_PROJECTS);
    // Create this component once, then keep using it FOREVER.
    // We don't want to keep switching the implementation as the user does SPA transitions.
    // We set the state this to cater for components that may be an entrypoint so that we don't keep switching between the entryPoint version and the non-entryPoint version
    const [entryPointConfig] = (0, $5uXOq.useState)(()=>{
        const epContainerProps = {
            id: 'nav4-sidebar-projects-default',
            packageName: (0, $4e61701b07fca41a$export$b8b9d90f9e5bd72b),
            teamName: (0, $4e61701b07fca41a$export$d57b6b390e78d90f),
            errorFallback: 'flag',
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            runtimeProps: entryPointParamsOld
        };
        return {
            Component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5GG0x.RouteEntryPointContainer), {
                    epContainerProps: epContainerProps,
                    jiraEPRef: entryPointReferenceSubject,
                    nestedEPRef: projectsEPRef,
                    placeholderEntryPoint: (0, $krpZe.nav4ProjectsContentEntryPoint)
                })
        };
    });
    const content = ()=>{
        if ((0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(entryPointConfig.Component, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            // Data stream, will subscribe to load updates.
            entryPointReferenceSubject: entryPointReferenceSubjectOld,
            // Required props for error JSErrorBoundary.
            id: "nav4-sidebar-projects-default",
            packageName: (0, $4e61701b07fca41a$export$b8b9d90f9e5bd72b),
            // Optional props for error JSErrorBoundary.
            errorFallback: "flag",
            teamName: (0, $4e61701b07fca41a$export$d57b6b390e78d90f),
            // Fallback for `Suspense`.
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
            // Props for the root component.
            runtimeProps: entryPointParamsOld
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onSystemToggle: (hasExpanded)=>{
            if (hasExpanded) {
                if ((0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) entryPointActions.load();
                entryPointActionsOld.load();
            }
        },
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) {
                if ((0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) entryPointActions.load();
                entryPointActionsOld.load();
                sendSectionItemAnalyticsEvent({
                    menuId: (0, $46Cti.L1_MENU_ID).PROJECTS,
                    sectionItem: (0, $jecJ3.SECTION_ITEM_PROJECTS)
                });
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-projects-default",
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon+text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        ref: triggerRef,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, simulateLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null) : content(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWLzw.Footer), null)));
}

});
const $4e61701b07fca41a$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Projects';
const $4e61701b07fca41a$export$d57b6b390e78d90f = 'jira-cosmos';

parcelRegister("bWLzw", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $e368b38fa5e093fd$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $fNJRN = parcelRequire("fNJRN");

var $jhS4y = parcelRequire("jhS4y");

var $34PKs = parcelRequire("34PKs");

var $foR3E = parcelRequire("foR3E");

var $4IIGx = parcelRequire("4IIGx");
var $4vWwj = parcelRequire("4vWwj");
var $ch7sx = parcelRequire("ch7sx");

var $59fBA = parcelRequire("59fBA");
const $e368b38fa5e093fd$var$VIEW_ALL_PROJECTS_HREF = (0, $foR3E.projectsDirectoryRoute).path;
function $e368b38fa5e093fd$export$a06f1c675e846f6f() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { sendViewAllProjectsAnalyticsEvent: sendViewAllProjectsAnalyticsEvent } = (0, $fNJRN.useProjectsAnalyticsL1)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4vWwj.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ch7sx.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34PKs.ViewAllEntityMenuItem), {
        onClick: ()=>{
            sendViewAllProjectsAnalyticsEvent();
        },
        href: $e368b38fa5e093fd$var$VIEW_ALL_PROJECTS_HREF,
        menuId: (0, $jhS4y.MENU_ID_PROJECTS_VIEW_ALL)
    }, formatMessage((0, $59fBA.default).viewAllProjects)))));
}

});
parcelRegister("foR3E", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRoute", () => $00577c595d2649c4$export$74114064f06cd71b);
const $00577c595d2649c4$export$74114064f06cd71b = {
    name: 'projects-directory',
    path: '/jira/projects',
    exact: true
};

});

parcelRegister("59fBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $db103a2a10f2ba8d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $db103a2a10f2ba8d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAllProjects: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.view-all-projects",
        "defaultMessage": "View all projects"
    }
});

});


parcelRegister("krpZe", function(module, exports) {

$parcel$export(module.exports, "nav4ProjectsContentEntryPoint", () => $2be41113a8ef5aa9$export$a457f9fdcd1ea5d3);

var $4Hv8l = parcelRequire("4Hv8l");

var $cfawy = parcelRequire("cfawy");

var $3rdd7 = parcelRequire("3rdd7");

var $kYHsT = parcelRequire("kYHsT");

var $k9L5z = parcelRequire("k9L5z");

const $2be41113a8ef5aa9$export$a457f9fdcd1ea5d3 = (0, $3rdd7.createEntryPoint)({
    root: (0, $cfawy.JSResourceForUserVisible)(()=>(parcelRequire("01lC7")).then(({ Nav4ProjectsContentViewQuery: Nav4ProjectsContentViewQuery })=>Nav4ProjectsContentViewQuery), {
        moduleId: "90670c8d",
        moduleName: "Nav4ProjectsContentViewQuery"
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId || '';
        const activationId = params.tenantContext.activationId;
        const atlassianAccountId = params.tenantContext.atlassianAccountId;
        return {
            queries: {
                projects: {
                    parameters: $4Hv8l.default,
                    variables: {
                        cloudId: cloudId,
                        entityAriProjects: (0, $kYHsT.JiraNavigationSettingsAri).create({
                            siteId: cloudId,
                            activationId: activationId,
                            navigationSettingScope: 'projects'
                        }).toString(),
                        ownerAri: atlassianAccountId && (0, $k9L5z.IdentityUserAri).create({
                            userId: atlassianAccountId
                        }).toString()
                    }
                }
            }
        };
    }
});

});
parcelRegister("4Hv8l", function(module, exports) {

$parcel$export(module.exports, "default", () => $e314997e36328d05$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<43d99c4cfc87b54f5b91a4203f882848>>
 * @relayHash 75dcd09acf91137e18ef27a2837583d5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 58c051cd7080e42b8d18c90b11e7e5bd3667c052f913639234ca4bdf244b1dc6

var $apPdj = parcelRequire("apPdj");

var $bozkj = parcelRequire("bozkj");

var $57dih = parcelRequire("57dih");

var $kXP4b = parcelRequire("kXP4b");

var $eiowN = parcelRequire("eiowN");
const $e314997e36328d05$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = [
        v3 /*: any*/ 
    ], v5 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v6 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v8 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v10 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v11 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v12 = [
        v8 /*: any*/ ,
        {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
                v7 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        }
                    ],
                    "type": "JiraNavigationItem",
                    "abstractKey": "__isJiraNavigationItem"
                },
                v9 /*: any*/ 
            ]
        },
        {
            "alias": "editProjectConfig",
            "args": v10 /*: any*/ ,
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v11 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "args": v10 /*: any*/ ,
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v11 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "alias": "editPermission",
            "args": v10 /*: any*/ ,
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v11 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "kind": "ScalarField",
            "name": "webUrl"
        },
        {
            "kind": "ScalarField",
            "name": "softwareBoardCount"
        }
    ], v13 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v14 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v15 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v12 /*: any*/ 
            }
        ]
    }, v16 = [
        v15 /*: any*/ ,
        v13 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "Nav4ProjectsContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4ProjectsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                }
            ],
            "kind": "Operation",
            "name": "Nav4ProjectsContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "favouriteProjects",
                                    "args": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "PROJECT"
                                            }
                                        },
                                        v5 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v12 /*: any*/ ,
                                                            "type": "JiraProject"
                                                        },
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v13 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        v3 /*: any*/ ,
                                        v14 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recentProjects",
                                    "plural": false,
                                    "selections": v16 /*: any*/ 
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "GrowthRecQuery",
                            "kind": "LinkedField",
                            "name": "growthRecommendations",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "product",
                                                    "value": "jira"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "tenantId",
                                                    "variableName": "cloudId"
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "useCase",
                                                    "value": "jiraProjectMenuRecommendations"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "context"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 2
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "recommendations",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "data",
                                                    "plural": true,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "entityId"
                                                                }
                                                            ],
                                                            "type": "GrowthRecJiraTemplateRecommendation"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "GrowthRecRecommendations"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "entityAri",
                                            "variableName": "entityAriProjects"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "ownerAri",
                                            "variableName": "ownerAri"
                                        }
                                    ],
                                    "concreteType": "SettingsNavigationCustomisation",
                                    "kind": "LinkedField",
                                    "name": "settings_navigationCustomisation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "SettingsDisplayPropertyConnection",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "SettingsDisplayProperty",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraProjectsSidebarMenu",
                            "kind": "LinkedField",
                            "name": "jira_projectsSidebarMenu",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "current",
                                    "plural": false,
                                    "selections": v12 /*: any*/ 
                                },
                                {
                                    "args": [
                                        v5 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v13 /*: any*/ 
                                    ],
                                    "storageKey": "favourites(first:15)"
                                },
                                {
                                    "args": [
                                        v14 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recents",
                                    "plural": false,
                                    "selections": v16 /*: any*/ ,
                                    "storageKey": "recents(first:20)"
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "58c051cd7080e42b8d18c90b11e7e5bd3667c052f913639234ca4bdf244b1dc6",
            "metadata": {},
            "name": "Nav4ProjectsContentViewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $apPdj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $bozkj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider": (0, $57dih.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $kXP4b.default)
            }
        }
    };
}();
$e314997e36328d05$var$node.hash = "147c5d1f620c190c7d67a3ae20325c0e";
(0, $eiowN.PreloadableQueryRegistry).set($e314997e36328d05$var$node.params.id, $e314997e36328d05$var$node);
var $e314997e36328d05$export$2e2bcd8739ae039 = $e314997e36328d05$var$node;

});

parcelRegister("01lC7", function(module, exports) {

let $0040dc2633df94e1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0040dc2633df94e1$var$load("7RSYT").then(()=>parcelRequire('6Hnkk'));

});


parcelRegister("c5WDi", function(module, exports) {

$parcel$export(module.exports, "asyncNav4ProjectsContentViewQuery", () => $6ba297934bb2a480$export$e22bacdc9273cba3);

var $6cYfS = parcelRequire("6cYfS");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $kYHsT = parcelRequire("kYHsT");

var $k9L5z = parcelRequire("k9L5z");

const $6ba297934bb2a480$export$e22bacdc9273cba3 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("4Ww6j")).then(({ Nav4ProjectsContentViewOldQuery: Nav4ProjectsContentViewOldQuery })=>Nav4ProjectsContentViewOldQuery), {
        moduleId: "f2a58372",
        moduleName: "Nav4ProjectsContentViewOldQuery"
    }),
    getPreloadProps: ({ cloudId: cloudId, activationId: activationId, atlassianAccountId: atlassianAccountId })=>({
            queries: {
                projects: {
                    parameters: $6cYfS.default,
                    variables: {
                        cloudId: cloudId,
                        entityAriProjects: (0, $kYHsT.JiraNavigationSettingsAri).create({
                            siteId: cloudId,
                            activationId: activationId,
                            navigationSettingScope: 'projects'
                        }).toString(),
                        ownerAri: atlassianAccountId && (0, $k9L5z.IdentityUserAri).create({
                            userId: atlassianAccountId
                        }).toString()
                    }
                }
            }
        })
});

});
parcelRegister("6cYfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0c67aa043b90c1a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d11770abb8c73d1d75895e2b0b5e3f91>>
 * @relayHash 76873355473bc48d6d96e53db6c3cd3b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b595c7c65c1b8a878c69a8da1ef05be2de341430043ac737a98d383871398fb9

var $apPdj = parcelRequire("apPdj");

var $bozkj = parcelRequire("bozkj");

var $57dih = parcelRequire("57dih");

var $kXP4b = parcelRequire("kXP4b");
const $b0c67aa043b90c1a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = [
        v3 /*: any*/ 
    ], v5 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v6 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v8 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v10 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v11 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v12 = [
        v8 /*: any*/ ,
        {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
                v7 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        }
                    ],
                    "type": "JiraNavigationItem",
                    "abstractKey": "__isJiraNavigationItem"
                },
                v9 /*: any*/ 
            ]
        },
        {
            "alias": "editProjectConfig",
            "args": v10 /*: any*/ ,
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v11 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "args": v10 /*: any*/ ,
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v11 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "alias": "editPermission",
            "args": v10 /*: any*/ ,
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v11 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "kind": "ScalarField",
            "name": "webUrl"
        },
        {
            "kind": "ScalarField",
            "name": "softwareBoardCount"
        }
    ], v13 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v14 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v15 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v12 /*: any*/ 
            }
        ]
    }, v16 = [
        v15 /*: any*/ ,
        v13 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "Nav4ProjectsContentViewOldQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4ProjectsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                }
            ],
            "kind": "Operation",
            "name": "Nav4ProjectsContentViewOldQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "favouriteProjects",
                                    "args": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "PROJECT"
                                            }
                                        },
                                        v5 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v12 /*: any*/ ,
                                                            "type": "JiraProject"
                                                        },
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v13 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        v3 /*: any*/ ,
                                        v14 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recentProjects",
                                    "plural": false,
                                    "selections": v16 /*: any*/ 
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "GrowthRecQuery",
                            "kind": "LinkedField",
                            "name": "growthRecommendations",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "product",
                                                    "value": "jira"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "tenantId",
                                                    "variableName": "cloudId"
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "useCase",
                                                    "value": "jiraProjectMenuRecommendations"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "context"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 2
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "recommendations",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "data",
                                                    "plural": true,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "entityId"
                                                                }
                                                            ],
                                                            "type": "GrowthRecJiraTemplateRecommendation"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "GrowthRecRecommendations"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "entityAri",
                                            "variableName": "entityAriProjects"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "ownerAri",
                                            "variableName": "ownerAri"
                                        }
                                    ],
                                    "concreteType": "SettingsNavigationCustomisation",
                                    "kind": "LinkedField",
                                    "name": "settings_navigationCustomisation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "SettingsDisplayPropertyConnection",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "SettingsDisplayProperty",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraProjectsSidebarMenu",
                            "kind": "LinkedField",
                            "name": "jira_projectsSidebarMenu",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "current",
                                    "plural": false,
                                    "selections": v12 /*: any*/ 
                                },
                                {
                                    "args": [
                                        v5 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v13 /*: any*/ 
                                    ],
                                    "storageKey": "favourites(first:15)"
                                },
                                {
                                    "args": [
                                        v14 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recents",
                                    "plural": false,
                                    "selections": v16 /*: any*/ ,
                                    "storageKey": "recents(first:20)"
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b595c7c65c1b8a878c69a8da1ef05be2de341430043ac737a98d383871398fb9",
            "metadata": {},
            "name": "Nav4ProjectsContentViewOldQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $apPdj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $bozkj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider": (0, $57dih.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $kXP4b.default)
            }
        }
    };
}();
$b0c67aa043b90c1a$var$node.hash = "e9dbe371555b08c40fa0fff884abed7c";
var $b0c67aa043b90c1a$export$2e2bcd8739ae039 = $b0c67aa043b90c1a$var$node;

});

parcelRegister("4Ww6j", function(module, exports) {

let $39957ac0ef5496cb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $39957ac0ef5496cb$var$load("4NHao").then(()=>parcelRequire('hNn1a'));

});



parcelRegister("8syLG", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectsForLanding", () => $34b8fcf67bf73580$export$8c948b59812f90e9);

var $j4EOM = parcelRequire("j4EOM");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $jcSAX = parcelRequire("jcSAX");

var $l8ruj = parcelRequire("l8ruj");

var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");


var $bWLzw = parcelRequire("bWLzw");
function $34b8fcf67bf73580$export$8c948b59812f90e9(props) {
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded, queryRef: queryRef } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).PROJECTS);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const data = (0, $8Uumt.useFragment)((0, $j4EOM.default), queryRef);
    const menuId = (0, $jhS4y.MENU_ID_PROJECTS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).PROJECTS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_PROJECTS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        actionsOnHover: actionsOnHover,
        // Prevent double-up of accessible name that occurs in icon + text situation.
        "aria-label": formattedMessage,
        elemBefore: icon,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-projects-landing"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "nav4-sidebar-projects-landing",
        packageName: (0, $4e61701b07fca41a$export$b8b9d90f9e5bd72b),
        teamName: (0, $4e61701b07fca41a$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jcSAX.Nav4ProjectsContent), {
        queryRef: data
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWLzw.Footer), null)));
}

});
parcelRegister("j4EOM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea186c046425d9b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4c21586a3492cb3ed09327f8fd2de9ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ea186c046425d9b2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4ProjectsForLanding",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4ProjectsContent"
        }
    ],
    "type": "Query"
};
$ea186c046425d9b2$var$node.hash = "4d3bdf6d5d5d912aac0901d592694d15";
var $ea186c046425d9b2$export$2e2bcd8739ae039 = $ea186c046425d9b2$var$node;

});

parcelRegister("jcSAX", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectsContent", () => $610b3e666862e79d$export$74ce18a8a4837259);

var $73EMs = parcelRequire("73EMs");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $kW74I = parcelRequire("kW74I");

var $6s1PB = parcelRequire("6s1PB");

var $5NM6P = parcelRequire("5NM6P");

var $6Lyip = parcelRequire("6Lyip");

var $e4A2P = parcelRequire("e4A2P");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $9Gyp5 = parcelRequire("9Gyp5");

var $gxbcq = parcelRequire("gxbcq");

var $1b6zA = parcelRequire("1b6zA");

var $aq8kS = parcelRequire("aq8kS");

var $4iaU1 = parcelRequire("4iaU1");

var $7RJ5F = parcelRequire("7RJ5F");

var $hohDO = parcelRequire("hohDO");

var $dWDWP = parcelRequire("dWDWP");

var $koeKL = parcelRequire("koeKL");

var $gKabe = parcelRequire("gKabe");

var $dLakp = parcelRequire("dLakp");

var $5alFY = parcelRequire("5alFY");
const $610b3e666862e79d$var$MAX_RECENT_PROJECTS = 5;
const $610b3e666862e79d$export$4319a8d1db123861 = 15;
function $610b3e666862e79d$export$74ce18a8a4837259({ queryRef: queryRef }) {
    const cloudId = (0, $koeKL.useCloudId)();
    const { getStableItems: getStableItems } = (0, $1b6zA.useStableItems)();
    const { isSelectedPath: isSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const [projectToRestore, setProjectToRestore] = (0, $5uXOq.useState)(null);
    // https://jplat.jira.atlassian.cloud/browse/BLU-2719
    // We intentionally request 10 starred and 15 recent projects.
    // Then, if all 10 starred projects were recently visited, we still show 5 recent projects as well.
    const data = (0, $8Uumt.useRefetchableFragment)((0, $73EMs.default), queryRef);
    const [{ jira: jira, jira_projectsSidebarMenu: projectsSidebarMenu }, refetch] = data;
    const { jwmLicensing: jwmLicensing } = jira;
    const favouriteProjects = (0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) ? projectsSidebarMenu?.favourites : jira.favouriteProjects;
    const recentProjects = (0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) ? projectsSidebarMenu?.recents : jira.recentProjects;
    // throwing here enforces the mutually exclusive @include/@skip directives which otherwise would be handled by @required
    if (!favouriteProjects || !recentProjects) throw new Error('JiraProjectConnection is missing in Nav4ProjectsContent for favourite or recent projects');
    const currentProject = projectsSidebarMenu?.current;
    const entityAriProjects = (0, $7RJ5F.useSidebarSettingsAri)('projects');
    const ownerAri = (0, $7RJ5F.useOwnerAri)();
    const queryVariables = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            entityAriProjects: entityAriProjects,
            ownerAri: ownerAri
        }), [
        cloudId,
        entityAriProjects,
        ownerAri
    ]);
    (0, $9Gyp5.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $dWDWP.default,
        refetch: refetch,
        menuId: (0, $jhS4y.MENU_ID_PROJECTS),
        queryVariables: queryVariables
    });
    const refetchOnChange = (0, $5uXOq.useCallback)(({ onComplete: onComplete })=>{
        refetch(queryVariables, {
            fetchPolicy: 'store-and-network',
            onComplete: onComplete
        });
    }, [
        queryVariables,
        refetch
    ]);
    (0, $gxbcq.useSubscribeAndUpdateFavorites)({
        entityTypename: 'JiraProject',
        favouriteConnectionId: favouriteProjects.__id,
        recentConnectionId: recentProjects.__id,
        refetch: refetchOnChange
    });
    const favorites = (0, $5uXOq.useMemo)(()=>{
        const ids = favouriteProjects.edges?.map((edge)=>edge?.node.id).filter(Boolean) ?? [];
        const list = favouriteProjects.edges?.filter(Boolean).map((edge)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4iaU1.Nav4ProjectMenuItem), {
                key: edge.node.projectKey,
                queryRef: edge.node,
                isCorePremiumUserSeat: jwmLicensing?.currentUserSeatEdition === 'PREMIUM',
                setProjectToRestore: setProjectToRestore,
                // Show onboarding spotlight on the first item
                spotlight: edge.node.id === ids[0] ? (0, $5NM6P.Nav4OnboardingComponentNames).SIDEBAR_PROJECT_SPOTLIGHT : undefined
            });
        }) ?? [];
        return {
            idSet: new Set(ids),
            list: list.slice(0, $610b3e666862e79d$export$4319a8d1db123861),
            hasItems: Boolean(list.length),
            hasNextPage: favouriteProjects.pageInfo?.hasNextPage || list.length > $610b3e666862e79d$export$4319a8d1db123861
        };
    }, [
        favouriteProjects,
        jwmLicensing
    ]);
    const recentItems = (0, $5uXOq.useMemo)(()=>{
        const recentItemsIdSet = new Set(recentProjects.edges?.map((edge)=>edge?.node.id).filter(Boolean) ?? []);
        const currentHiddenProject = currentProject && !favorites.idSet.has(currentProject.id) && !recentItemsIdSet.has(currentProject.id) && (0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) ? [
            currentProject
        ] : [];
        const allNodes = recentProjects.edges?.filter(Boolean).filter((edge)=>edge.node.id && !favorites.idSet.has(edge.node.id)).map((edge)=>edge.node) ?? [];
        const nodes = [
            ...currentHiddenProject,
            ...allNodes
        ].slice(0, $610b3e666862e79d$var$MAX_RECENT_PROJECTS);
        const stableOrderedNodes = getStableItems({
            nodes: nodes,
            idKey: 'id'
        });
        const firstItemKey = stableOrderedNodes[0]?.projectKey;
        const list = stableOrderedNodes.map((node)=>{
            // Show onboarding spotlight on the first item if there are no favorites
            const showSpotlight = !favorites.hasItems && node.projectKey === firstItemKey;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4iaU1.Nav4ProjectMenuItem), {
                key: node.projectKey,
                queryRef: node,
                isCorePremiumUserSeat: jwmLicensing?.currentUserSeatEdition === 'PREMIUM',
                setProjectToRestore: setProjectToRestore,
                spotlight: showSpotlight ? (0, $5NM6P.Nav4OnboardingComponentNames).SIDEBAR_PROJECT_SPOTLIGHT : undefined
            });
        });
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        recentProjects.edges,
        getStableItems,
        favorites.idSet,
        jwmLicensing?.currentUserSeatEdition,
        favorites.hasItems,
        currentProject
    ]);
    const restoreProjectModal = (0, $5uXOq.useCallback)(()=>{
        if (projectToRestore) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kW74I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hohDO.default), {
            ...projectToRestore,
            onProjectRestoreSuccess: ()=>{
                setProjectToRestore(null);
                refetch(queryVariables, {
                    fetchPolicy: 'store-and-network'
                });
            },
            onProjectRestoreFailure: ()=>{
                setProjectToRestore(null);
            },
            onClose: ()=>setProjectToRestore(null)
        }));
    }, [
        queryVariables,
        projectToRestore,
        refetch
    ]);
    if (!favorites.hasItems && !recentItems.hasItems) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lyip.OnboardingSpotlightMaybe), {
        spotlight: (0, $5NM6P.Nav4OnboardingComponentNames).SIDEBAR_PROJECT_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aq8kS.Nav4ProjectsEmptyContent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gKabe.Nav4Recommendations), {
        queryRef: data[0]
    }), restoreProjectModal());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4A2P.UpdateProjectsProvider), {
        favouriteConnectionId: favouriteProjects.__id,
        recentConnectionId: recentProjects.__id
    }, !(0, $6s1PB.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) && (0, $6s1PB.expVal)('blu-6315-display-settings-a-part-1', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5alFY.Nav4ProjectsSectionsWithDisplaySettings), {
        favoriteItems: favorites,
        recentItems: recentItems,
        queryRef: data[0]
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dLakp.Nav4ProjectsSections), {
        favoriteItems: favorites,
        recentItems: recentItems
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gKabe.Nav4Recommendations), {
        queryRef: data[0]
    }), restoreProjectModal());
}

});
parcelRegister("73EMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0cd0ab2a500c3f5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<15c9ae96f4028d81805430160ec46868>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $dWDWP = parcelRequire("dWDWP");
const $c0cd0ab2a500c3f5$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v2 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "FragmentSpread",
        "name": "Nav4ProjectMenuItem"
    }, v6 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v7 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v8 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURL"
            },
            {
                "kind": "RootArgument",
                "name": "entityAriProjects"
            },
            {
                "kind": "RootArgument",
                "name": "ownerAri"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $dWDWP.default)
            }
        },
        "name": "Nav4ProjectsContent",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "Nav4Recommendations"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "entityAri",
                                        "variableName": "entityAriProjects"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "ownerAri",
                                        "variableName": "ownerAri"
                                    }
                                ],
                                "kind": "FragmentSpread",
                                "name": "Nav4ProjectsSectionsWithDisplaySettings"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "alias": "favouriteProjects",
                                        "args": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": {
                                                        "order": "DESC"
                                                    },
                                                    "type": "PROJECT"
                                                }
                                            },
                                            v1 /*: any*/ 
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v2 /*: any*/ ,
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v3 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "jira.favouriteProjects.edges.node.id"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v4 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "jira.favouriteProjects.edges.node.projectKey"
                                                                        },
                                                                        v5 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraProject"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.favouriteProjects.edges.node"
                                                    }
                                                ]
                                            },
                                            v6 /*: any*/ 
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.favouriteProjects"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": [
                                            v0 /*: any*/ ,
                                            v7 /*: any*/ ,
                                            v8 /*: any*/ 
                                        ],
                                        "concreteType": "JiraProjectConnection",
                                        "kind": "LinkedField",
                                        "name": "recentProjects",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProjectEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.recentProjects.edges.node.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.recentProjects.edges.node.projectKey"
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.recentProjects.edges.node"
                                                    }
                                                ]
                                            },
                                            v6 /*: any*/ 
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.recentProjects"
                                }
                            ]
                        },
                        {
                            "args": [
                                v0 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": [
                                v0 /*: any*/ ,
                                v7 /*: any*/ 
                            ],
                            "concreteType": "JiraProjectsSidebarMenu",
                            "kind": "LinkedField",
                            "name": "jira_projectsSidebarMenu",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "current",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira_projectsSidebarMenu.current.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira_projectsSidebarMenu.current.projectKey"
                                        },
                                        v5 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": [
                                            v1 /*: any*/ 
                                        ],
                                        "concreteType": "JiraProjectConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v2 /*: any*/ ,
                                            {
                                                "concreteType": "JiraProjectEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira_projectsSidebarMenu.favourites.edges.node.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira_projectsSidebarMenu.favourites.edges.node.projectKey"
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira_projectsSidebarMenu.favourites.edges.node"
                                                    }
                                                ]
                                            },
                                            v6 /*: any*/ 
                                        ],
                                        "storageKey": "favourites(first:15)"
                                    },
                                    "action": "THROW",
                                    "path": "jira_projectsSidebarMenu.favourites"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": [
                                            v8 /*: any*/ 
                                        ],
                                        "concreteType": "JiraProjectConnection",
                                        "kind": "LinkedField",
                                        "name": "recents",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProjectEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira_projectsSidebarMenu.recents.edges.node.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira_projectsSidebarMenu.recents.edges.node.projectKey"
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira_projectsSidebarMenu.recents.edges.node"
                                                    }
                                                ]
                                            },
                                            v6 /*: any*/ 
                                        ],
                                        "storageKey": "recents(first:20)"
                                    },
                                    "action": "THROW",
                                    "path": "jira_projectsSidebarMenu.recents"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira_projectsSidebarMenu"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$c0cd0ab2a500c3f5$var$node.hash = "b0416203ad03d7912efe15fabde20269";
var $c0cd0ab2a500c3f5$export$2e2bcd8739ae039 = $c0cd0ab2a500c3f5$var$node;

});
parcelRegister("dWDWP", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc98d32cef1447c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5666ed04e9a2e83caea032b01a644e56>>
 * @relayHash d0b248a628f36db0b34ade6672994ffd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c79b3786f6919fbd23c348dbd30027bec79a9b40316b469c8bbceaf8cf103cc1

var $apPdj = parcelRequire("apPdj");

var $bozkj = parcelRequire("bozkj");

var $57dih = parcelRequire("57dih");

var $kXP4b = parcelRequire("kXP4b");
const $2cc98d32cef1447c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "currentURL"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "displaySettingsAPart1Enabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "displaySettingsPostGaEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v6 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v7 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v8 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v9 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v11 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v13 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v14 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v15 = [
        v11 /*: any*/ ,
        {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
                v10 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        }
                    ],
                    "type": "JiraNavigationItem",
                    "abstractKey": "__isJiraNavigationItem"
                },
                v12 /*: any*/ 
            ]
        },
        {
            "alias": "editProjectConfig",
            "args": v13 /*: any*/ ,
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v14 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "args": v13 /*: any*/ ,
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v14 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "alias": "editPermission",
            "args": v13 /*: any*/ ,
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v14 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "kind": "ScalarField",
            "name": "webUrl"
        },
        {
            "kind": "ScalarField",
            "name": "softwareBoardCount"
        }
    ], v16 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v17 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v18 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v15 /*: any*/ 
            }
        ]
    }, v19 = [
        v18 /*: any*/ ,
        v16 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "Nav4ProjectsContentQuery",
            "selections": [
                {
                    "args": [
                        v6 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "Nav4ProjectsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                }
            ],
            "kind": "Operation",
            "name": "Nav4ProjectsContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "args": [
                                v7 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "favouriteProjects",
                                    "args": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "PROJECT"
                                            }
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v15 /*: any*/ ,
                                                            "type": "JiraProject"
                                                        },
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        v7 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v17 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recentProjects",
                                    "plural": false,
                                    "selections": v19 /*: any*/ 
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "GrowthRecQuery",
                            "kind": "LinkedField",
                            "name": "growthRecommendations",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "product",
                                                    "value": "jira"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "tenantId",
                                                    "variableName": "cloudId"
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "useCase",
                                                    "value": "jiraProjectMenuRecommendations"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "context"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 2
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "recommendations",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "data",
                                                    "plural": true,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "entityId"
                                                                }
                                                            ],
                                                            "type": "GrowthRecJiraTemplateRecommendation"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "GrowthRecRecommendations"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "entityAri",
                                            "variableName": "entityAriProjects"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "ownerAri",
                                            "variableName": "ownerAri"
                                        }
                                    ],
                                    "concreteType": "SettingsNavigationCustomisation",
                                    "kind": "LinkedField",
                                    "name": "settings_navigationCustomisation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "SettingsDisplayPropertyConnection",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "SettingsDisplayProperty",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v7 /*: any*/ ,
                                v6 /*: any*/ 
                            ],
                            "concreteType": "JiraProjectsSidebarMenu",
                            "kind": "LinkedField",
                            "name": "jira_projectsSidebarMenu",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "current",
                                    "plural": false,
                                    "selections": v15 /*: any*/ 
                                },
                                {
                                    "args": [
                                        v8 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ],
                                    "storageKey": "favourites(first:15)"
                                },
                                {
                                    "args": [
                                        v17 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recents",
                                    "plural": false,
                                    "selections": v19 /*: any*/ ,
                                    "storageKey": "recents(first:20)"
                                },
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c79b3786f6919fbd23c348dbd30027bec79a9b40316b469c8bbceaf8cf103cc1",
            "metadata": {},
            "name": "Nav4ProjectsContentQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "displaySettingsAPart1Enabled": (0, $apPdj.default),
                "displaySettingsPostGaEnabled": (0, $bozkj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $apPdj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $bozkj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider": (0, $57dih.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $kXP4b.default)
            }
        }
    };
}();
$2cc98d32cef1447c$var$node.hash = "b0416203ad03d7912efe15fabde20269";
var $2cc98d32cef1447c$export$2e2bcd8739ae039 = $2cc98d32cef1447c$var$node;

});


parcelRegister("5NM6P", function(module, exports) {

$parcel$export(module.exports, "Nav4OnboardingComponentNames", () => $b94a87b237943b7f$export$f813aeb3fcf8b623);
$parcel$export(module.exports, "COMPONENT_TAP_TRAIT_MAP", () => $b94a87b237943b7f$export$c1a4e03cc30032f5);
const $b94a87b237943b7f$export$f813aeb3fcf8b623 = {
    GLOBAL_MODAL: 'nav4GlobalOnboardingModal',
    JIRA_SIDEBAR_TOGGLE_SPOTLIGHT: 'nav4SidebarToggleOnboardingSpotlight',
    // CONFLUENCE_SIDEBAR_TOGGLE_SPOTLIGHT: 'nav4ConfluenceSidebarToggleOnboardingSpotlight', // TODO: Spotlight has not been implemented in Confluence yet so this may change
    SIDEBAR_PROJECT_SPOTLIGHT: 'nav4SidebarProjectsOnboardingSpotlight',
    TAB_NAV_SPOTLIGHT: 'nav4TabNavigationOnboardingSpotlight',
    ATLAS_GLOBAL_MODAL: 'nav4AtlasGlobalOnboardingModal',
    ATLAS_GLOBAL_MODAL2: 'nav4AtlasGlobalOnboardingModal2'
};
const $b94a87b237943b7f$export$c1a4e03cc30032f5 = {
    nav4GlobalOnboardingModal: 'jira-platform_ui_nav4globalonboardingmodal_dismissed_jiraatlassianonboardingnav4_changed',
    nav4SidebarToggleOnboardingSpotlight: 'jira-platform_ui_nav4sidebartoggleonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    // nav4ConfluenceSidebarToggleOnboardingSpotlight: '', // TODO: Add when Confluence spotlight is implemented
    nav4SidebarProjectsOnboardingSpotlight: 'jira-platform_ui_nav4sidebarprojectsonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    nav4TabNavigationOnboardingSpotlight: 'jira-platform_ui_nav4tabnavigationonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    nav4AtlasGlobalOnboardingModal: 'townsquare_ui_atlassianhomeonboardingnav4_dismissed_teamcentral_changed'
};

});

parcelRegister("6Lyip", function(module, exports) {

$parcel$export(module.exports, "OnboardingSpotlightMaybe", () => $ea144642b34a7c1d$export$77e61d078c8501ca);

var $5uXOq = parcelRequire("5uXOq");

var $Pxnvj = parcelRequire("Pxnvj");

var $4R6GH = parcelRequire("4R6GH");
function $ea144642b34a7c1d$export$77e61d078c8501ca({ children: children, spotlight: spotlight }) {
    if (!(0, $4R6GH.fg)('blu-2735_nav4_onboarding')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return spotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
        name: spotlight
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
}

});

parcelRegister("e4A2P", function(module, exports) {

$parcel$export(module.exports, "UpdateProjectsProvider", () => $ac3747600c671f53$export$a50917f7cd2aeeda);
$parcel$export(module.exports, "useUpdateProjectsInRelayStoreContext", () => $ac3747600c671f53$export$5105901d98bfdbf1);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");
const $ac3747600c671f53$var$UpdateProjectsContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $ac3747600c671f53$export$c80374615e2c5b2 = ({ environment: environment, favouriteConnectionId: favouriteConnectionId, recentConnectionId: recentConnectionId })=>{
    const removeProjectRecord = (projectDataId)=>{
        (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
            const favorites = store.get(favouriteConnectionId);
            const recents = store.get(recentConnectionId);
            if (favorites && projectDataId) (0, $8Uumt.ConnectionHandler).deleteNode(favorites, projectDataId);
            if (recents && projectDataId) (0, $8Uumt.ConnectionHandler).deleteNode(recents, projectDataId);
        });
    };
    const archiveProject = (projectDataId)=>{
        (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
            store.get(projectDataId)?.setValue('ARCHIVED', 'status');
        });
    };
    return {
        deleteProject: removeProjectRecord,
        archiveProject: archiveProject
    };
};
const $ac3747600c671f53$export$a50917f7cd2aeeda = ({ children: children, favouriteConnectionId: favouriteConnectionId, recentConnectionId: recentConnectionId })=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const updateRelayStore = $ac3747600c671f53$export$c80374615e2c5b2({
        environment: environment,
        favouriteConnectionId: favouriteConnectionId,
        recentConnectionId: recentConnectionId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac3747600c671f53$var$UpdateProjectsContext.Provider, {
        value: updateRelayStore
    }, children);
};
const $ac3747600c671f53$export$5105901d98bfdbf1 = ()=>(0, $5uXOq.useContext)($ac3747600c671f53$var$UpdateProjectsContext);

});

parcelRegister("aq8kS", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectsEmptyContent", () => $960e03f6eb83ee0c$export$7a7cd6cdc84cf8eb);
/* Nav4ProjectsEmptyContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $6eFvr = parcelRequire("6eFvr");

var $koVbs = parcelRequire("koVbs");

var $7lgBG = parcelRequire("7lgBG");

var $6m6lr = parcelRequire("6m6lr");
function $960e03f6eb83ee0c$export$7a7cd6cdc84cf8eb() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $7lgBG.EmptyContentMenuItem), null, /*#__PURE__*/ $5uXOq.createElement((0, $6eFvr.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $6m6lr.default).emptyProjectsMessage)));
}

});
parcelRegister("6m6lr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6781a034e171c4cc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6781a034e171c4cc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyProjectsMessage: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.empty-content.empty-projects-message",
        "defaultMessage": "Once you visit or create projects, they'll show up here."
    }
});

});


parcelRegister("4iaU1", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectMenuItem", () => $0448e2d1aaca7c74$export$6a41b9c2eac627cc);

var $98QWa = parcelRequire("98QWa");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $i7frX = parcelRequire("i7frX");

var $enCNl = parcelRequire("enCNl");

var $38b7M = parcelRequire("38b7M");

var $5O6Px = parcelRequire("5O6Px");

var $k2PPW = parcelRequire("k2PPW");

var $Xn42p = parcelRequire("Xn42p");
function $0448e2d1aaca7c74$export$6a41b9c2eac627cc({ queryRef: queryRef, setProjectToRestore: setProjectToRestore, isCorePremiumUserSeat: isCorePremiumUserSeat = false, spotlight: spotlight }) {
    const data = (0, $8Uumt.useFragment)((0, $98QWa.default), queryRef);
    if (!data) return null;
    if (data.status === 'ARCHIVED') return null;
    const renderMenuItem = ()=>{
        if ((0, $4R6GH.fg)('jcs_project_type_m3')) switch(data.projectType){
            case 0, $2vSU6.JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38b7M.AsyncJsmProjectMenu), {
                    projectData: data,
                    spotlight: spotlight
                });
            case 0, $2vSU6.JIRA_PROJECT_TYPE_CUSTOMER_SERVICE_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5O6Px.AsyncJcsProjectMenu), {
                    projectData: data,
                    spotlight: spotlight
                });
            case 0, $2vSU6.JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $enCNl.AsyncJpdProjectMenu), {
                    projectData: data,
                    spotlight: spotlight
                });
            case 0, $2vSU6.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2PPW.JswProjectMenu), {
                    projectData: data,
                    spotlight: spotlight
                });
            case 0, $2vSU6.JIRA_PROJECT_TYPE_CORE_PROJECT:
            default:
                // TODO: One day, we will call this JwmProjectMenu, and subsequently JiraProjectMenu (Spork!)
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i7frX.JiraBusinessProjectMenu), {
                    projectData: data,
                    isCorePremiumUserSeat: isCorePremiumUserSeat,
                    spotlight: spotlight
                });
        }
        switch(data.projectType){
            case 0, $2vSU6.JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT:
            case 0, $2vSU6.JIRA_PROJECT_TYPE_CUSTOMER_SERVICE_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38b7M.AsyncJsmProjectMenu), {
                    projectData: data,
                    spotlight: spotlight
                });
            case 0, $2vSU6.JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $enCNl.AsyncJpdProjectMenu), {
                    projectData: data,
                    spotlight: spotlight
                });
            case 0, $2vSU6.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2PPW.JswProjectMenu), {
                    projectData: data,
                    spotlight: spotlight
                });
            case 0, $2vSU6.JIRA_PROJECT_TYPE_CORE_PROJECT:
            default:
                // TODO: One day, we will call this JwmProjectMenu, and subsequently JiraProjectMenu (Spork!)
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i7frX.JiraBusinessProjectMenu), {
                    projectData: data,
                    isCorePremiumUserSeat: isCorePremiumUserSeat,
                    spotlight: spotlight
                });
        }
    };
    // Using a switch to support a fallback option
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Xn42p.ProjectRestoreContext).Provider, {
        value: setProjectToRestore
    }, renderMenuItem());
}

});
parcelRegister("98QWa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f106e3f340d1fe74$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e12d4f314c52bc34112ad7130fbed63f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f106e3f340d1fe74$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4ProjectMenuItem",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "status"
            },
            "action": "THROW",
            "path": "status"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW",
            "path": "projectType"
        },
        {
            "kind": "FragmentSpread",
            "name": "JiraBusinessProjectMenu"
        },
        {
            "kind": "FragmentSpread",
            "name": "JsmProjectMenu"
        },
        {
            "kind": "FragmentSpread",
            "name": "JpdProjectMenu"
        },
        {
            "kind": "FragmentSpread",
            "name": "JswProjectMenu"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JcsProjectMenu"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$f106e3f340d1fe74$var$node.hash = "02c3a87c3a12d872d12055c4d3fcc2b5";
var $f106e3f340d1fe74$export$2e2bcd8739ae039 = $f106e3f340d1fe74$var$node;

});

parcelRegister("i7frX", function(module, exports) {

$parcel$export(module.exports, "JiraBusinessProjectMenu", () => $1f543ab89d3e759b$export$6145b58afae943e6);

var $47xky = parcelRequire("47xky");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6Lyip = parcelRequire("6Lyip");

var $lpwtK = parcelRequire("lpwtK");

var $hUpXm = parcelRequire("hUpXm");

var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $ccuaM = parcelRequire("ccuaM");

var $44kzF = parcelRequire("44kzF");

var $itmJb = parcelRequire("itmJb");

var $buihy = parcelRequire("buihy");
const $1f543ab89d3e759b$export$6145b58afae943e6 = ({ projectData: projectData, isCorePremiumUserSeat: isCorePremiumUserSeat = false, spotlight: spotlight })=>{
    const { sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent } = (0, $hUpXm.useProjectsAnalyticsL2)();
    const project = (0, $8Uumt.useFragment)((0, $47xky.default), projectData);
    const routerLinkConfig = (0, $5uXOq.useMemo)(()=>({
            to: project.defaultNavigationItem?.url ?? `/browse/${project.projectKey}`,
            prefetch: 'hover'
        }), [
        project.defaultNavigationItem?.url,
        project.projectKey
    ]);
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const hasChangeThemeFeature = isAdmin || project.editProjectConfig?.canPerform;
    // here we reference the project that is currently displayed in the main content area
    // it can be different from `project` here as `project` refers to any of the projects in the sidebar
    const { data: activeProject } = (0, $lpwtK.useProject)();
    const projectIdOrKey = String(activeProject?.key || activeProject?.id);
    const isCurrentProject = projectIdOrKey === project.projectKey || projectIdOrKey === project.projectId;
    const shouldRenderThemePicker = hasChangeThemeFeature && isCurrentProject;
    const projectActionMenuOnClickHandler = (0, $5uXOq.useCallback)(()=>{
        const { isFavourite: isFavourite, projectId: projectId, projectType: projectType } = project;
        sendMeatBallDropDownOnProjectsAnalyticsEvent({
            // TODO BLU-5544 send section via <ContextualAnalyticsData instead (which wraps the Starred or Recent panel; and each project). Use static object or useMemo, not to have rerendering issues. Then you can also use static object for meatBallDropDownOnProjectsAnalytics. See Jsm and Wanjel components
            starred: isFavourite ?? false,
            recent: !isFavourite,
            projectId: projectId,
            projectType: projectType
        });
    }, [
        project,
        sendMeatBallDropDownOnProjectsAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lyip.OnboardingSpotlightMaybe), {
        key: project.projectKey,
        spotlight: spotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buihy.ContainerAvatar), {
            src: project.avatar.large || ''
        }),
        href: routerLinkConfig,
        menuId: (0, $jhS4y.ENTITY_ID).PROJECT(project.projectKey),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ccuaM.ProjectActionMenu), {
            projectKey: project.projectKey,
            isCorePremiumUserSeat: isCorePremiumUserSeat,
            additionalMenuItems: shouldRenderThemePicker && !!activeProject?.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44kzF.ThemePicker), {
                projectId: activeProject.id,
                withAdaptiveColorTheme: false
            }) : undefined,
            onClick: projectActionMenuOnClickHandler
        })
    }, project.name));
};

});
parcelRegister("47xky", function(module, exports) {

$parcel$export(module.exports, "default", () => $26729977ea3d44a6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dac31c30fe03e7a0b37bf23913873e09>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $26729977ea3d44a6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JiraBusinessProjectMenu",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "large"
                        },
                        "action": "THROW",
                        "path": "avatar.large"
                    }
                ]
            },
            "action": "THROW",
            "path": "avatar"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "projectKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW",
            "path": "projectType"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        }
                    ],
                    "type": "JiraNavigationItem",
                    "abstractKey": "__isJiraNavigationItem"
                }
            ]
        },
        {
            "alias": "editProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ],
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        }
    ],
    "type": "JiraProject"
};
$26729977ea3d44a6$var$node.hash = "72e6a38905e40c49d04bf9ee58ef5d8f";
var $26729977ea3d44a6$export$2e2bcd8739ae039 = $26729977ea3d44a6$var$node;

});

parcelRegister("ccuaM", function(module, exports) {

$parcel$export(module.exports, "ProjectActionMenu", () => $8b67ffb58d27733b$export$b71a0a4e7f29cfd6);

var $5uXOq = parcelRequire("5uXOq");

var $c8rIN = parcelRequire("c8rIN");

var $5KCCi = parcelRequire("5KCCi");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $22OQR = parcelRequire("22OQR");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $03DFc = parcelRequire("03DFc");

var $bMW22 = parcelRequire("bMW22");
const $8b67ffb58d27733b$var$CustomTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const triggerButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        ...props,
        ref: ref,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8rIN))), {
            label: formatMessage((0, $bMW22.default).moreActions),
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "navigation-project-action-menu.ui.themed-button"
    });
    return (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-meatball-menu-button-tooltips') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: formatMessage((0, $bMW22.default).moreActions),
        hideTooltipOnClick: true
    }, triggerButton) : triggerButton;
});
const $8b67ffb58d27733b$export$b71a0a4e7f29cfd6 = ({ additionalMenuItems: additionalMenuItems, isCorePremiumUserSeat: isCorePremiumUserSeat = false, withThemedTrigger: withThemedTrigger = false, projectKey: projectKey, onClick: onClick, shouldRenderToParent: shouldRenderToParent })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $03DFc.EntryPointContent), {
        additionalMenuItems: additionalMenuItems,
        onClick: onClick,
        isCorePremiumUserSeat: isCorePremiumUserSeat,
        CustomTrigger: withThemedTrigger && (0, $3HwlS.getWillShowNav4)() ? $8b67ffb58d27733b$var$CustomTrigger : undefined,
        projectKey: projectKey,
        shouldRenderToParent: shouldRenderToParent
    });
};

});
parcelRegister("22OQR", function(module, exports) {

$parcel$export(module.exports, "ThemedButton", () => $87e6157378e1cf19$export$f67fb575035cc7d0);
/* ThemedButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $i95f5 = parcelRequire("i95f5");
const $87e6157378e1cf19$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87e6157378e1cf19$var$CustomButton, {
        ...props,
        as: as,
        ref: ref
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87e6157378e1cf19$var$CustomButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $i95f5.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1qt3kjry _1g9h1tex _1umfuwj9 _6l8r3x59 _9se5176f _12rallho _zk5uzt2a _18vg2zyf _192e1jcw _fnp717ga _1xjgvy9e _1u0u14e8 _17z218zq _7n83frbu _n2ul1jo4 _1cf1r7td _1d7c1ag4 _nwukvy9e _fsjd4zrn _z1i3eyly",
            __cmplp.className
        ])
    });
});

});

parcelRegister("03DFc", function(module, exports) {

$parcel$export(module.exports, "EntryPointContent", () => $507768618964e449$export$912f81dce8d58e46);

var $5uXOq = parcelRequire("5uXOq");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $koeKL = parcelRequire("koeKL");

var $2oEQb = parcelRequire("2oEQb");

var $7ju32 = parcelRequire("7ju32");

var $eSIes = parcelRequire("eSIes");
const $507768618964e449$export$912f81dce8d58e46 = ({ CustomTrigger: CustomTrigger, onClick: onClick, additionalMenuItems: additionalMenuItems, isCorePremiumUserSeat: isCorePremiumUserSeat = false, projectKey: projectKey, shouldRenderToParent: shouldRenderToParent })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $2oEQb.projectActionMenuEntryPoint), (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]));
    const buttonTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const content = (0, $5uXOq.useCallback)((contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "project-actions-menu-popup-content",
            packageName: "jira-navigation-apps-project-action-menu",
            runtimeProps: {
                isCorePremiumUserSeat: isCorePremiumUserSeat,
                additionalMenuItems: additionalMenuItems,
                contentProps: contentProps
            },
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eSIes.Skeleton), null)
        }), [
        entryPointReferenceSubject,
        additionalMenuItems,
        isCorePremiumUserSeat
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ju32.MenuContainer), {
        content: content,
        CustomTrigger: CustomTrigger,
        onClick: onClick,
        buttonTriggerRef: buttonTriggerRef,
        shouldRenderToParent: shouldRenderToParent
    });
};

});
parcelRegister("2oEQb", function(module, exports) {

$parcel$export(module.exports, "projectActionMenuEntryPoint", () => $a5951ff1cd0da4db$export$30ec6de22da54fa0);

var $lvLIW = parcelRequire("lvLIW");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");
const $a5951ff1cd0da4db$var$fetchPolicy = 'network-only';

const $a5951ff1cd0da4db$export$30ec6de22da54fa0 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("ce2kj")).then((module)=>module.AsyncMenuWithQuery), {
        moduleId: "eb74dcae"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>{
        const projectActionMenuQuery = {
            parameters: (0, $lvLIW.default),
            variables: {
                cloudId: cloudId,
                projectKey: projectKey
            },
            options: {
                fetchPolicy: $a5951ff1cd0da4db$var$fetchPolicy
            }
        };
        return {
            queries: {
                projectActionMenuQuery: projectActionMenuQuery
            }
        };
    }
});

});
parcelRegister("lvLIW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f29594fd996b113$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d360e49d5eb693192c7fbc1eac496f85>>
 * @relayHash a9a48f3ed05422d23cacd580dcce751d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e05d6d8357d9d7fabad007766bd445c51b79afe818cc226061c1c9209b8fd76e
const $8f29594fd996b113$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e05d6d8357d9d7fabad007766bd445c51b79afe818cc226061c1c9209b8fd76e",
        "metadata": {},
        "name": "async_AsyncMenuContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8f29594fd996b113$export$2e2bcd8739ae039 = $8f29594fd996b113$var$node;

});

parcelRegister("ce2kj", function(module, exports) {

let $8e6898d627eed951$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8e6898d627eed951$var$load("cM9em"),
    $8e6898d627eed951$var$load("fr9NE"),
    $8e6898d627eed951$var$load("h2MrD"),
    $8e6898d627eed951$var$load("bYT2S"),
    $8e6898d627eed951$var$load("a0WjB")
]).then(()=>parcelRequire('aSeFh'));

});


parcelRegister("7ju32", function(module, exports) {

$parcel$export(module.exports, "MenuContainer", () => $12b2a0349669ab51$export$b286f91cddfedb5a);

var $5uXOq = parcelRequire("5uXOq");

var $3HwlS = parcelRequire("3HwlS");

var $cDvOQ = parcelRequire("cDvOQ");

var $6jY6G = parcelRequire("6jY6G");

var $jgJNO = parcelRequire("jgJNO");

var $1aCfv = parcelRequire("1aCfv");
const $12b2a0349669ab51$export$b286f91cddfedb5a = ({ content: content, CustomTrigger: CustomTrigger, onClick: onClick, onClose: onCloseCustom, buttonTriggerRef: buttonTriggerRef, shouldRenderToParent: shouldRenderToParent = true })=>{
    const { isOpen: isOpen, onClose: onClose, onToggle: onToggle } = (0, $cDvOQ.useOpenable)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const handleClose = (0, $5uXOq.useCallback)((e)=>{
        try {
            onCloseCustom?.(e);
        } finally{
            onClose();
        }
    }, [
        onCloseCustom,
        onClose
    ]);
    const onClickHandler = (0, $5uXOq.useCallback)(()=>{
        onToggle();
        onClick?.();
    }, [
        onClick,
        onToggle
    ]);
    const trigger = (triggerProps)=>{
        const { ref: ref, ...restTriggerProps } = triggerProps;
        return CustomTrigger ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomTrigger, {
            isSelected: isOpen,
            onClick: onClickHandler,
            ref: (element)=>{
                buttonTriggerRef && buttonTriggerRef(element);
                if (typeof ref === 'function') ref(element);
            },
            ...restTriggerProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1aCfv.MenuTriggerButton), {
            isSelected: isOpen,
            onClick: onClickHandler,
            ref: (element)=>{
                buttonTriggerRef && buttonTriggerRef(element);
                if (typeof ref === 'function') ref(element);
            },
            ...restTriggerProps
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        content: content,
        isOpen: isOpen,
        onClose: handleClose,
        placement: "bottom-start",
        messageId: "navigation-project-action-menu.ui.menu-container.popup",
        messageType: "transactional",
        trigger: trigger,
        shouldRenderToParent: // eslint-disable-next-line no-nested-ternary
        (0, $3HwlS.getWillShowNav4)() ? route.name.includes('legacy') ? false : shouldRenderToParent : true,
        strategy: (0, $3HwlS.getWillShowNav4)() ? 'absolute' : 'fixed'
    });
};

});
parcelRegister("1aCfv", function(module, exports) {

$parcel$export(module.exports, "MenuTriggerButton", () => $697832058741b131$export$a24e6f6ddd974e33);

var $5uXOq = parcelRequire("5uXOq");

var $1Seuh = parcelRequire("1Seuh");

var $4AeHp = parcelRequire("4AeHp");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $UPOcN = parcelRequire("UPOcN");
const $697832058741b131$export$a24e6f6ddd974e33 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
        ...props,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AeHp))), {
                ...iconProps,
                color: "var(--ds-icon, #44546F)"
            }),
        label: formatMessage((0, $UPOcN.default).projectActionsMenu),
        onClick: onClick,
        ref: ref,
        spacing: "compact",
        appearance: "subtle",
        testId: "navigation-project-action-menu.ui.menu-container.themed-button",
        ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-meatball-menu-button-tooltips') ? {
            isTooltipDisabled: false,
            tooltip: {
                content: formatMessage((0, $UPOcN.default).projectActionsMenu),
                hideTooltipOnClick: true
            }
        } : {}
    });
});

});
parcelRegister("UPOcN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5484f6b90ae9d06c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5484f6b90ae9d06c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectActionsMenu: {
        "id": "navigation-project-action-menu.menu-container.project-actions-menu",
        "defaultMessage": "More actions"
    }
});

});



parcelRegister("eSIes", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $618f6270b8f60e9b$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $aOrxC = parcelRequire("aOrxC");
var $70rf1 = parcelRequire("70rf1");
var $eCE62 = parcelRequire("eCE62");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $2s57o = parcelRequire("2s57o");

var $4DrQd = parcelRequire("4DrQd");
const $618f6270b8f60e9b$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $618f6270b8f60e9b$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), {
        minWidth: (0, $4DrQd.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        isList: true,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $618f6270b8f60e9b$var$projectTileSkeleton
    }))));
const $618f6270b8f60e9b$var$wrapperStyles = (0, $2s57o.xcss)({
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    inlineSize: `${(0, $4DrQd.MENU_GROUP_MIN_WIDTH)}px`
});
const $618f6270b8f60e9b$var$projectTileSkeleton = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-600, 48px)",
    flex: 1
});

});


parcelRegister("bMW22", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5136b67e6c38f9a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f5136b67e6c38f9a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectSettings: {
        "id": "navigation-project-action-menu.project-settings",
        "defaultMessage": "Project settings"
    },
    moreActions: {
        "id": "navigation-project-action-menu.more-actions",
        "defaultMessage": "More actions"
    }
});

});


parcelRegister("44kzF", function(module, exports) {

$parcel$export(module.exports, "ThemePicker", () => $f5453100331219b3$export$75505f096a733fb9);

var $5uXOq = parcelRequire("5uXOq");

var $jgJNO = parcelRequire("jgJNO");

var $j5YhT = parcelRequire("j5YhT");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $kaHBi = parcelRequire("kaHBi");

var $pa9q9 = parcelRequire("pa9q9");

var $7VHMR = parcelRequire("7VHMR");

var $g8I5C = parcelRequire("g8I5C");

var $6jY6G = parcelRequire("6jY6G");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $ky2ui = parcelRequire("ky2ui");

var $koeKL = parcelRequire("koeKL");

var $jpH5a = parcelRequire("jpH5a");

var $ca7Zi = parcelRequire("ca7Zi");

var $lwRIP = parcelRequire("lwRIP");

var $3LH0C = parcelRequire("3LH0C");

var $gHWtm = parcelRequire("gHWtm");

var $9yzIq = parcelRequire("9yzIq");
const $f5453100331219b3$var$SOURCE_NAME = 'projectThemePicker';
const $f5453100331219b3$var$messages = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "business-theme-components.theme-picker.error-flag-title",
        "defaultMessage": "Something's gone wrong"
    },
    errorFlagDescription: {
        "id": "business-theme-components.theme-picker.error-flag-description",
        "defaultMessage": "Our team has been notified. If the problem persists, please contact Atlassian Support."
    }
});
const $f5453100331219b3$export$bb0d35c1fc48487f = {
    id: 'open-theme-picker-error',
    type: 'error',
    title: $f5453100331219b3$var$messages.errorFlagTitle,
    description: $f5453100331219b3$var$messages.errorFlagDescription,
    isAutoDismiss: true,
    messageId: 'project-theme-components.ui.theme-picker.popup-entrypoint-error-flag.error.open-theme-picker-error',
    messageType: 'transactional'
};
const $f5453100331219b3$export$75505f096a733fb9 = /*#__PURE__*/ (0, $5uXOq.memo)(({ projectId: projectId, withAdaptiveColorTheme: withAdaptiveColorTheme, shouldRenderToParent: shouldRenderToParent = true })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const projectAri = (0, $j5YhT.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(projectId)
    }).toString();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $gHWtm.backgroundPickerPopupContentEntryPoint), (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectAri: projectAri
        }), [
        cloudId,
        projectAri
    ]));
    const startExperience = (0, $kaHBi.useExperienceStart)((0, $jpH5a.VIEW_THEME_PICKER_EXPERIENCE));
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [flagShown, setFlagShown] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [isThemePickerOpen, setIsThemePickerOpen] = (0, $5uXOq.useState)(false);
    const toggleThemePicker = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (_, analyticsEvent)=>{
        // If we are about to open the theme picker, start the experience
        if (!isThemePickerOpen) startExperience();
        setIsThemePickerOpen((oldValue)=>!oldValue);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent ?? createAnalyticsEvent({}), 'button clicked', 'themePickerButton');
        setFlagShown(false);
    }, [
        isThemePickerOpen,
        startExperience,
        setIsThemePickerOpen,
        createAnalyticsEvent
    ]);
    const renderNudgeWrapper = (0, $5uXOq.useCallback)((children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ky2ui.BackgroundColourNudgeAsync), null, children), []);
    const buttonTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isThemePickerOpen);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onOpenChange: setIsThemePickerOpen,
            withAdaptiveColorTheme: withAdaptiveColorTheme
        }), [
        setIsThemePickerOpen,
        withAdaptiveColorTheme
    ]);
    const trigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3LH0C.ThemePickerButtonItem), {
            ...triggerProps,
            isSelected: isThemePickerOpen,
            testId: "project-theme-components.ui.theme-picker.trigger",
            ref: (element)=>{
                buttonTrigger(element);
                if (typeof triggerProps.ref === 'function') triggerProps.ref(element);
            },
            onClick: toggleThemePicker
        }), [
        buttonTrigger,
        isThemePickerOpen,
        toggleThemePicker
    ]);
    const errorFallback = (0, $5uXOq.useCallback)(({ error: error })=>{
        if (!flagShown) {
            showFlag($f5453100331219b3$export$bb0d35c1fc48487f);
            setFlagShown(true);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ca7Zi.ExperienceFailed), {
            experience: (0, $jpH5a.VIEW_THEME_PICKER_EXPERIENCE),
            error: error
        });
    }, [
        flagShown,
        showFlag
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "background-picker-popup-content",
            packageName: "@atlassian/jira-project-theme-components",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yzIq.ThemePickerSkeleton), null),
            errorFallback: errorFallback,
            runtimeProps: runtimeProps
        }), [
        errorFallback,
        entryPointReferenceSubject,
        runtimeProps
    ]);
    const onCloseHandler = (0, $5uXOq.useCallback)(()=>setIsThemePickerOpen(false), [
        setIsThemePickerOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8I5C.QuickstartNudge), {
        renderWrapper: renderNudgeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: $f5453100331219b3$var$SOURCE_NAME,
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isThemePickerOpen,
        onClose: onCloseHandler,
        shouldRenderToParent: route.name.includes('legacy') ? false : shouldRenderToParent,
        content: content,
        trigger: trigger,
        placement: "right-start",
        id: (0, $lwRIP.THEME_PICKER_ELEMENT_ID),
        messageId: "project-theme-components.ui.theme-picker.popup.theme-picker",
        messageType: "transactional"
    })));
});

});
parcelRegister("g8I5C", function(module, exports) {

$parcel$export(module.exports, "QuickstartNudge", () => $0174d522ba9dfb06$export$bd61ee610c74db6c);

var $5uXOq = parcelRequire("5uXOq");

var $6OJ73 = parcelRequire("6OJ73");

var $axUP7 = parcelRequire("axUP7");
const $0174d522ba9dfb06$export$bd61ee610c74db6c = (0, $axUP7.withNestingOptimisation)(({ renderWrapper: renderWrapper, children: children })=>{
    const isFullyExpanded = (0, $6OJ73.useIsFullyExpanded)();
    return isFullyExpanded ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
});

});
parcelRegister("6OJ73", function(module, exports) {

$parcel$export(module.exports, "useIsFullyExpanded", () => $c20291d4f7970c77$export$7212b6b01271f5d1);

var $5uXOq = parcelRequire("5uXOq");

var $gPQRI = parcelRequire("gPQRI");
const $c20291d4f7970c77$var$TIMEOUT = 500;
const $c20291d4f7970c77$export$7212b6b01271f5d1 = ()=>{
    const [ready, setReady] = (0, $5uXOq.useState)(false);
    const { isCollapsed: isCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setReady(!isCollapsed);
        }, $c20291d4f7970c77$var$TIMEOUT);
        return ()=>clearTimeout(timeoutId);
    }, [
        isCollapsed
    ]);
    return ready && !isCollapsed;
};

});
parcelRegister("gPQRI", function(module, exports) {

$parcel$export(module.exports, "useLeftSidebarState", () => $b19712b3cdd78134$export$610d81e163a897b3);
$parcel$export(module.exports, "useLeftSidebarController", () => $b19712b3cdd78134$export$900f29014a48fb23);

var $5uXOq = parcelRequire("5uXOq");

var $iqLcb = parcelRequire("iqLcb");

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $b19712b3cdd78134$var$useSweetStateLeftSidebarState = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>({
            ...state.content.leftSidebar,
            shouldRender: !state.isChromeless
        })
});
const $b19712b3cdd78134$export$610d81e163a897b3 = ()=>{
    const [leftSidebar] = $b19712b3cdd78134$var$useSweetStateLeftSidebarState();
    return leftSidebar;
};
const $b19712b3cdd78134$export$900f29014a48fb23 = ()=>{
    const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $iqLcb.usePageLayoutResize)();
    return (0, $5uXOq.useMemo)(()=>({
            collapseLeftSidebar: collapseLeftSidebar,
            expandLeftSidebar: expandLeftSidebar
        }), [
        collapseLeftSidebar,
        expandLeftSidebar
    ]);
};

});


parcelRegister("axUP7", function(module, exports) {

$parcel$export(module.exports, "withNestingOptimisation", () => $c861ce2b697701b9$export$ee1cb2a8280d8710);

var $5uXOq = parcelRequire("5uXOq");

var $fsi33 = parcelRequire("fsi33");

var $9sGI6 = parcelRequire("9sGI6");
const $c861ce2b697701b9$export$ee1cb2a8280d8710 = (Component)=>{
    const WithNestingOptimisation = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
        const children = // @ts-expect-error - Property 'children' does not exist on type 'Props'.ts(2339)
        typeof props === 'object' && props != null ? props.children : null;
        return (0, $fsi33.useShouldNestedElementRender)().shouldRender && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            ref: ref
        }) : children;
    });
    WithNestingOptimisation.displayName = `withNestingOptimisation(${(0, $9sGI6.getDisplayName)(Component)})`;
    return WithNestingOptimisation;
};

});
parcelRegister("9sGI6", function(module, exports) {

$parcel$export(module.exports, "getDisplayName", () => $0d4ebae82d1d47ab$export$be63e0664592e141);
$parcel$export(module.exports, "default", () => $0d4ebae82d1d47ab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $0d4ebae82d1d47ab$export$be63e0664592e141 = (WrappedComponent)=>{
    if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
    if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
    return 'Component';
};
/**
 * @deprecated Just pass the props explicitly or create a new component that provides them. Do not use HOCs.
 */ const $0d4ebae82d1d47ab$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
    const WithInjectedProps = (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...injectedProps,
            ...props
        });
    WithInjectedProps.displayName = `withInjectedProps(${$0d4ebae82d1d47ab$export$be63e0664592e141(WrappedComponent)})`;
    return WithInjectedProps;
};
var $0d4ebae82d1d47ab$export$2e2bcd8739ae039 = $0d4ebae82d1d47ab$var$withInjectedProps;

});



parcelRegister("ky2ui", function(module, exports) {

$parcel$export(module.exports, "BackgroundColourNudgeAsync", () => $cb3deafbb4dbbb82$export$a3dbb521061a599a);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cb3deafbb4dbbb82$var$BackgroundColourNudgeLazy = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("5fQMX")).then((exportedModule)=>exportedModule.BackgroundColourNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges-jwm-background-color/src/index.tsx"
});
const $cb3deafbb4dbbb82$export$a3dbb521061a599a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $d231c4839441ff18$export$eb0b199de90a7ec2),
        fallback: children,
        attributes: {
            nudgeId: (0, $d231c4839441ff18$export$eb0b199de90a7ec2)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "background-colour-onboarding-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb3deafbb4dbbb82$var$BackgroundColourNudgeLazy, null, children)));
$cb3deafbb4dbbb82$export$a3dbb521061a599a.displayName = 'BackgroundColourNudgeAsync';

});
// JWM Background Colour tour
const $d231c4839441ff18$export$eb0b199de90a7ec2 = 'backgroundColorNudge';

parcelRegister("5fQMX", function(module, exports) {

let $3d374d29dd0201c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3d374d29dd0201c0$var$load("cM9em"),
    $3d374d29dd0201c0$var$load("fr9NE"),
    $3d374d29dd0201c0$var$load("ebypf")
]).then(()=>parcelRequire('8uIuW'));

});


parcelRegister("jpH5a", function(module, exports) {

$parcel$export(module.exports, "VIEW_THEME_PICKER_EXPERIENCE", () => $34fd6f1472f32723$export$9a8c95b97c1ee885);
const $34fd6f1472f32723$export$47a1a20f3722c8ce = {
    experience: 'viewThemePicker',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $34fd6f1472f32723$export$9a8c95b97c1ee885 = {
    experience: 'viewThemePicker',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};

});

parcelRegister("ca7Zi", function(module, exports) {

$parcel$export(module.exports, "useExperienceFail", () => $99088cc1a7014505$export$606da7704d8eaf06);
$parcel$export(module.exports, "ExperienceFailed", () => $99088cc1a7014505$export$ae65a9e09c4516b3);
$parcel$export(module.exports, "ExperienceSuccess", () => $99088cc1a7014505$export$4962f3898bd5c829);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $93jKl = parcelRequire("93jKl");

var $3bQtK = parcelRequire("3bQtK");

var $jJZqs = parcelRequire("jJZqs");
const $99088cc1a7014505$export$606da7704d8eaf06 = ({ experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, teamName: teamName })=>{
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: experience
    });
    const onFail = (0, $5uXOq.useCallback)((location, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error, extraAttributes)=>{
        const relevantError = error?.networkError ?? error;
        if (relevantError instanceof (0, $jJZqs.ValidationError) && relevantError.message === '' && relevantError.errors.length) relevantError.message = relevantError.errors[0].error;
        extraAttributes !== undefined ? onExperienceFail(location, relevantError, extraAttributes) : onExperienceFail(location, relevantError);
        (0, $jcw0u.default)({
            meta: {
                id: `experience-tracker-${experienceId ?? experience}`,
                packageName: analyticsSource,
                teamName: teamName
            },
            attributes: {
                location: location
            },
            error: relevantError,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onExperienceFail,
        experienceId,
        experience,
        analyticsSource,
        teamName
    ]);
    return onFail;
};
const $99088cc1a7014505$export$ae65a9e09c4516b3 = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, error: error, attributes: attributes })=>{
    const onFail = $99088cc1a7014505$export$606da7704d8eaf06(experience);
    (0, $5uXOq.useEffect)(()=>{
        onFail(experience.experience, error, attributes);
    }, [
        attributes,
        error,
        experience,
        onFail
    ]);
    return null;
});
const $99088cc1a7014505$export$4962f3898bd5c829 = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: experience.experience,
        attributes: {
            ...experience.experienceId == null ? undefined : {
                experienceId: experience.experienceId
            },
            ...attributes
        }
    }));

});

parcelRegister("lwRIP", function(module, exports) {

$parcel$export(module.exports, "CREATE_CUSTOM_BACKGROUND_EXPERIENCE", () => $9162f72ca6991e19$export$46e0706742711dad);
$parcel$export(module.exports, "UPDATE_ALT_TEXT_EXPERIENCE", () => $9162f72ca6991e19$export$678653f2c10961c5);
$parcel$export(module.exports, "DELETE_CUSTOM_BACKGROUND_EXPERIENCE", () => $9162f72ca6991e19$export$f84f0c56982ddf9a);
$parcel$export(module.exports, "THEME_PICKER_ELEMENT_ID", () => $9162f72ca6991e19$export$8dde8522a4856b87);
const $9162f72ca6991e19$export$91a4460f34f2ee75 = {
    experience: 'createCustomBackground',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$46e0706742711dad = {
    experience: 'createCustomBackground',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$3b5b01b3ae53bee3 = {
    experience: 'updateCustomBackground',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$678653f2c10961c5 = {
    experience: 'updateCustomBackground',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$da5da525dec4b73a = {
    experience: 'deleteCustomBackground',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$f84f0c56982ddf9a = {
    experience: 'deleteCustomBackground',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$8dde8522a4856b87 = 'background-picker-popup-wrapper';

});

parcelRegister("3LH0C", function(module, exports) {

$parcel$export(module.exports, "ThemePickerButtonItem", () => $bf1403620c7d37d2$export$27d1624818d3e0be);

var $5uXOq = parcelRequire("5uXOq");

var $cwX8H = parcelRequire("cwX8H");

var $IaDcR = parcelRequire("IaDcR");

var $7H980 = parcelRequire("7H980");

var $koVbs = parcelRequire("koVbs");

var $eCaG4 = parcelRequire("eCaG4");
const $bf1403620c7d37d2$export$27d1624818d3e0be = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, testId: testId, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($IaDcR))), {
            label: "",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cwX8H))), {
            label: "",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: onClick,
        testId: testId,
        isSelected: isSelected,
        ref: ref,
        ...props
    }, formatMessage((0, $eCaG4.default).setProjectBackgroundMenuItem));
}));

});
parcelRegister("IaDcR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7b72e4cfb1948d4b5694556923ff149>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $084c5b57c86b975d$var$_react = $084c5b57c86b975d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $084c5b57c86b975d$var$_paintBucket = $084c5b57c86b975d$var$_interopRequireDefault((parcelRequire("hB9a3")));

var $084c5b57c86b975d$var$_backgroundColor = $084c5b57c86b975d$var$_interopRequireDefault((parcelRequire("17EmJ")));
function $084c5b57c86b975d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PaintBucketIcon.
 * This component is PaintBucketIcon, with `UNSAFE_fallbackIcon` set to "EditorBackgroundColorIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $084c5b57c86b975d$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $084c5b57c86b975d$var$_react.default.createElement($084c5b57c86b975d$var$_paintBucket.default, Object.assign({
        LEGACY_fallbackIcon: $084c5b57c86b975d$var$_backgroundColor.default
    }, props));
$084c5b57c86b975d$var$PaintBucketIcon.Name = 'PaintBucketIconMigration';
var $084c5b57c86b975d$var$_default = module.exports.default = $084c5b57c86b975d$var$PaintBucketIcon;

});
parcelRegister("hB9a3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83080ad07e1bfea64637edcdcb5973cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ccfcff99e8186679$var$_react = $ccfcff99e8186679$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ccfcff99e8186679$var$_baseNew = $ccfcff99e8186679$var$_interopRequireDefault((parcelRequire("enEmH")));
function $ccfcff99e8186679$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PaintBucket".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ccfcff99e8186679$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $ccfcff99e8186679$var$_react.default.createElement($ccfcff99e8186679$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.655.095 13.78 8.22a.75.75 0 0 1 0 1.06l-5.616 5.617a2 2 0 0 1-2.828 0L.604 10.164a2 2 0 0 1 0-2.828L5.689 2.25 4.595 1.155zM6.75 3.31 2.06 8h9.38zm4.69 6.19H2.06l4.336 4.335a.5.5 0 0 0 .708 0z" clip-rule="evenodd"/><path fill="currentcolor" d="M14.5 12a.75.75 0 0 0-.654.383v.002l-.003.003-.007.013-.026.046a16 16 0 0 0-.36.695 8 8 0 0 0-.283.642c-.068.176-.167.457-.167.716a1.5 1.5 0 0 0 3 0c0-.259-.1-.54-.167-.716a8 8 0 0 0-.284-.642 16 16 0 0 0-.36-.695l-.025-.046-.007-.013-.002-.004-.001-.001A.75.75 0 0 0 14.5 12"/>`
    }, props));
$ccfcff99e8186679$var$PaintBucketIcon.displayName = 'PaintBucketIcon';
var $ccfcff99e8186679$var$_default = module.exports.default = $ccfcff99e8186679$var$PaintBucketIcon;

});

parcelRegister("17EmJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d15c1aa5923f306$var$_react = $0d15c1aa5923f306$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $0d15c1aa5923f306$var$_paintBucket = $0d15c1aa5923f306$var$_interopRequireDefault((parcelRequire("hB9a3")));
function $0d15c1aa5923f306$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0d15c1aa5923f306$var$EditorBackgroundColorIcon = (props)=>/*#__PURE__*/ $0d15c1aa5923f306$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m7.818 12.56 4.243 4.243 4.242-4.242-4.242-4.243zm-1.414 1.415a1.995 1.995 0 0 1 0-2.828l4.243-4.243a1.995 1.995 0 0 1 2.828 0l4.243 4.243c.78.78.786 2.041 0 2.828l-4.243 4.243a1.996 1.996 0 0 1-2.828 0zM6.5 13h11l-5.44 5.218zm2.732-8.925a1 1 0 0 1 1.414 0l3.536 3.536-1.414 1.414L9.232 5.49a1 1 0 0 1 0-1.415M18 16s1.5 2 1.5 3.5c0 1-1 1.5-1.5 1.5s-1.5-.4-1.5-1.5C16.5 18 18 16 18 16"/></svg>`
    }, props, {
        newIcon: $0d15c1aa5923f306$var$_paintBucket.default
    }));
$0d15c1aa5923f306$var$EditorBackgroundColorIcon.displayName = 'EditorBackgroundColorIcon';
var $0d15c1aa5923f306$var$_default = module.exports.default = $0d15c1aa5923f306$var$EditorBackgroundColorIcon;

});


parcelRegister("eCaG4", function(module, exports) {

$parcel$export(module.exports, "default", () => $375a1027f7dcdae1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $375a1027f7dcdae1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    setProjectBackgroundMenuItem: {
        "id": "business-theme-components.theme-picker-button-item.set-project-background-menu-item",
        "defaultMessage": "Set project background"
    }
});

});


parcelRegister("gHWtm", function(module, exports) {

$parcel$export(module.exports, "backgroundPickerPopupContentEntryPoint", () => $52bb029027935944$export$e02fb03d7ff1aabe);

var $22q3R = parcelRequire("22q3R");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $4R6GH = parcelRequire("4R6GH");
const $52bb029027935944$var$fetchPolicy = 'network-only';

const $52bb029027935944$export$e02fb03d7ff1aabe = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("cu49C")).then((module)=>module.BackgroundPickerPopupContent), {
        moduleId: "e1737386",
        moduleName: "PopupContent"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectAri: projectAri })=>{
        const popupContentQuery = {
            parameters: (0, $22q3R.default),
            variables: {
                cloudId: cloudId,
                entityId: projectAri,
                durationInSeconds: 900,
                imageCount: 50,
                isThemingRelayMigrationEnabled: (0, $4R6GH.fg)('jira_theming_relay_migration')
            },
            options: {
                fetchPolicy: $52bb029027935944$var$fetchPolicy
            }
        };
        return {
            queries: {
                popupContentQuery: popupContentQuery
            }
        };
    }
});

});
parcelRegister("22q3R", function(module, exports) {

$parcel$export(module.exports, "default", () => $201654d4ad1f249e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4b46a02a37c9c9712faf3f1c3cdb2810>>
 * @relayHash 4b1253adfc4d15a018eec6dd37c2a1a6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 567381a90f6d2527c3bad9e3134757d855ffc2d7a4fb51a9a98728011059d85e
const $201654d4ad1f249e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "567381a90f6d2527c3bad9e3134757d855ffc2d7a4fb51a9a98728011059d85e",
        "metadata": {},
        "name": "PopupContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $201654d4ad1f249e$export$2e2bcd8739ae039 = $201654d4ad1f249e$var$node;

});

parcelRegister("cu49C", function(module, exports) {

let $916b824a4bff0433$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $916b824a4bff0433$var$load("h2MrD"),
    $916b824a4bff0433$var$load("bYT2S"),
    $916b824a4bff0433$var$load("hPzOn"),
    $916b824a4bff0433$var$load("cM9em"),
    $916b824a4bff0433$var$load("fr9NE"),
    $916b824a4bff0433$var$load("7Pwl1")
]).then(()=>parcelRequire('97vnf'));

});


parcelRegister("9yzIq", function(module, exports) {

$parcel$export(module.exports, "ThemePickerSkeleton", () => $828cc9a1e99f3131$export$c3dc17aa42c33254);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $clxo5 = parcelRequire("clxo5");
const $828cc9a1e99f3131$export$c3dc17aa42c33254 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $828cc9a1e99f3131$var$skeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
        size: "medium"
    }));
const $828cc9a1e99f3131$var$skeletonStyles = (0, $2s57o.xcss)({
    width: '346px',
    height: '240px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});


parcelRegister("buihy", function(module, exports) {

$parcel$export(module.exports, "ContainerAvatar", () => $142be09b40d164cc$export$f35a2d11bd6ae97);
/* container-avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $142be09b40d164cc$var$styles = {
    root: "_2rkoiti9 _vchhusvi _4t3igktf _1bsbgktf",
    withBorder: "_12y3e4h9 _12jimuej _1cwg1x9t _1qu2nqa1"
};
const $142be09b40d164cc$export$f35a2d11bd6ae97 = ({ src: src, appearance: appearance = 'default' })=>/*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        src: src,
        alt: "",
        className: (0, $bwpsq.default)([
            $142be09b40d164cc$var$styles.root,
            appearance === 'default' && $142be09b40d164cc$var$styles.withBorder
        ])
    });

});


parcelRegister("enCNl", function(module, exports) {

$parcel$export(module.exports, "AsyncJpdProjectMenu", () => $438c4e2b82a869b9$export$b446e65eeda5c1fb);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $438c4e2b82a869b9$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("fgXzi")).then(({ JpdProjectMenu: JpdProjectMenu })=>JpdProjectMenu), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/projects/jpd-project-menu/src/ui/index.tsx"
});
const $438c4e2b82a869b9$export$b446e65eeda5c1fb = /*#__PURE__*/ (0, $5uXOq.memo)(({ projectData: projectData, spotlight: spotlight })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.jpd-project-menu",
        packageName: "jiraNavigationAppsSidebarNav4JPDProjectMenu",
        ufoName: "nav4.sidebar.jpd-project-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.jpd-project-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($438c4e2b82a869b9$var$LazySidebarContent, {
        projectData: projectData,
        spotlight: spotlight
    }))));

});
parcelRegister("cljJ9", function(module, exports) {

$parcel$export(module.exports, "SidebarBoundary", () => $f6d5489447b9aa6b$export$1edc778464f08256);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $8dXDG = parcelRequire("8dXDG");

var $93jKl = parcelRequire("93jKl");

var $cfDZ3 = parcelRequire("cfDZ3");

var $l8ruj = parcelRequire("l8ruj");

var $cKjfv = parcelRequire("cKjfv");

var $6Jt8x = parcelRequire("6Jt8x");
const $f6d5489447b9aa6b$export$1edc778464f08256 = ({ children: children, id: id, packageName: packageName, teamName: teamName, ufoName: ufoName = '' })=>{
    const { experience: experience, attributes: attributes } = (0, $cKjfv.useSidebarExperience)();
    const onFail = (0, $93jKl.useExperienceFail)({
        experience: experience,
        attributes: attributes
    });
    const onAbort = (0, $8dXDG.useExperienceAbort)({
        experience: experience,
        attributes: attributes
    });
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isNotSSR = !false;
    const extraEventData = (0, $5uXOq.useMemo)(()=>({
            userLocation: userLocation
        }), [
        userLocation
    ]);
    const fallback = (0, $5uXOq.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Jt8x.Fallback), {
            error: error
        }), []);
    const handleError = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (location, error)=>{
        const { statusCode: statusCode } = error;
        if (statusCode >= 400 && statusCode < 500) onAbort('Sidebar failed with validation error', {
            error: error
        });
        else onFail(location, error);
    }, [
        onAbort,
        onFail
    ]);
    const UFOSegmentORFragment = ufoName ? (0, $l8ruj.default) : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(UFOSegmentORFragment, {
        name: ufoName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        extraEventData: extraEventData,
        fallback: fallback,
        teamName: teamName,
        onError: handleError
    }, isNotSSR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cKjfv.SidebarStart), null), children));
};

});
parcelRegister("6Jt8x", function(module, exports) {

$parcel$export(module.exports, "Fallback", () => $d1b1aff7b337b0d4$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bWfiu = parcelRequire("bWfiu");

var $0yZbT = parcelRequire("0yZbT");
var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");

var $kobfu = parcelRequire("kobfu");

var $7q5TP = parcelRequire("7q5TP");

var $koVbs = parcelRequire("koVbs");

var $5Ntjt = parcelRequire("5Ntjt");
const $d1b1aff7b337b0d4$var$styles = {
    wrapper: "_zulpu2gc _bfhkm7j4 _syaz1gjq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _y3gn1h6o _4cvr1h6o",
    error: "_2rkogqwt _bfhk1v33 _syaz131l _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66"
};
const $d1b1aff7b337b0d4$export$fb8d7f40caaeea67 = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        xcss: $d1b1aff7b337b0d4$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7q5TP.default), {
        width: "40px",
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "xsmall"
    }, formatMessage((0, $5Ntjt.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, formatMessage((0, $5Ntjt.default).errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d1b1aff7b337b0d4$var$styles.error
    }, "ERROR: ", (0, $kobfu.getErrorHash)(error)));
};

});
parcelRegister("7q5TP", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc8d7b09135bd30b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("8ODZY")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("b2nX8")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = jx8k5z4r4cbqfnn3t56t46v9
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/jx8k5z4r4cbqfnn3t56t46v9

var $dCLgq = parcelRequire("dCLgq");

var $b2nX8 = parcelRequire("b2nX8");

var $8ODZY = parcelRequire("8ODZY");
const $dc8d7b09135bd30b$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8ODZY)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($b2nX8))
});
var $dc8d7b09135bd30b$export$2e2bcd8739ae039 = $dc8d7b09135bd30b$var$Illustration;
// for advanced use only
const $dc8d7b09135bd30b$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    212
];

});
parcelRegister("b2nX8", function(module, exports) {
module.exports = new URL("generic-error-darkmode.3646797f.svg", import.meta.url).toString();

});

parcelRegister("8ODZY", function(module, exports) {
module.exports = new URL("generic-error.f200ded6.svg", import.meta.url).toString();

});


parcelRegister("5Ntjt", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ef9823ba7f6e404$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9ef9823ba7f6e404$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorHeading: {
        "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    }
});

});



parcelRegister("7VBev", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $af3b5ba721400353$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $2GZKW = parcelRequire("2GZKW");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");
const $af3b5ba721400353$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.200",
        xcss: $af3b5ba721400353$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $af3b5ba721400353$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $af3b5ba721400353$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2GZKW.default), {
        columnGap: "space.100",
        rowGap: "space.050",
        alignItems: "center",
        templateAreas: [
            'avatar name',
            'avatar type'
        ],
        templateColumns: "min-content 1fr",
        xcss: $af3b5ba721400353$var$projectHeading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $af3b5ba721400353$var$projectAvatar,
        style: {
            gridArea: 'avatar'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $af3b5ba721400353$var$projectName,
        style: {
            gridArea: 'name'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $af3b5ba721400353$var$projectType,
        style: {
            gridArea: 'type'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $af3b5ba721400353$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $af3b5ba721400353$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $af3b5ba721400353$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $af3b5ba721400353$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $af3b5ba721400353$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $af3b5ba721400353$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $af3b5ba721400353$var$menuItem
    })));
const $af3b5ba721400353$var$containerStyles = (0, $2s57o.xcss)({
    height: '100%',
    padding: 'space.200'
});
const $af3b5ba721400353$var$backButton = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $af3b5ba721400353$var$headingSkeleton = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $af3b5ba721400353$var$projectHeading = (0, $2s57o.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});
const $af3b5ba721400353$var$projectAvatar = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $af3b5ba721400353$var$projectName = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100'
});
const $af3b5ba721400353$var$projectType = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-100, 8px)",
    borderRadius: 'border.radius.100'
});
const $af3b5ba721400353$var$menuItem = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("fgXzi", function(module, exports) {

let $b1e68ea75717717a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b1e68ea75717717a$var$load("kWrFZ"),
    $b1e68ea75717717a$var$load("eRaYd")
]).then(()=>parcelRequire('eaE9P'));

});


parcelRegister("38b7M", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmProjectMenu", () => $044e27f3d755a1d3$export$bf0d7afec25f82d7);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $044e27f3d755a1d3$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("66b9b")).then(({ JsmProjectMenu: JsmProjectMenu })=>JsmProjectMenu), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/projects/jsm-project-menu/src/ui/project-menu/index.tsx"
});
const $044e27f3d755a1d3$export$bf0d7afec25f82d7 = /*#__PURE__*/ (0, $5uXOq.memo)(({ projectData: projectData, spotlight: spotlight })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.jsm-project-menu",
        packageName: "jiraNavigationAppsSidebarNav4JsmProjectMenu",
        teamName: "jsm-getting-started",
        ufoName: "nav4.sidebar.jsm-project-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.jsm-project-menu.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($044e27f3d755a1d3$var$LazySidebarContent, {
        projectData: projectData,
        spotlight: spotlight
    }))));

});
parcelRegister("66b9b", function(module, exports) {

let $470bf3390d1a2c68$var$load = (parcelRequire("28QjX"))(4);
module.exports = $470bf3390d1a2c68$var$load("8MFe5").then(()=>parcelRequire('22eIY'));

});


parcelRegister("5O6Px", function(module, exports) {

$parcel$export(module.exports, "AsyncJcsProjectMenu", () => $c5af8783ef1f4a9b$export$30175e6def84a269);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $c5af8783ef1f4a9b$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("7QbCX")).then(({ JcsProjectMenu: JcsProjectMenu })=>JcsProjectMenu), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/projects/jcs-project-menu/src/ui/project-menu/JcsProjectMenu.tsx"
});
const $c5af8783ef1f4a9b$export$30175e6def84a269 = /*#__PURE__*/ (0, $5uXOq.memo)(({ projectData: projectData, spotlight: spotlight })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.jcs-project-menu",
        packageName: "jiraNavigationAppsSidebarNav4JcsProjectMenu",
        teamName: "Boysenberry",
        ufoName: "nav4.sidebar.jcs-project-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.jcs-project-menu.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c5af8783ef1f4a9b$var$LazySidebarContent, {
        projectData: projectData,
        spotlight: spotlight
    }))));

});
parcelRegister("7QbCX", function(module, exports) {

let $5b5668b4d362426c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5b5668b4d362426c$var$load("cPyPT").then(()=>parcelRequire('77zn3'));

});


parcelRegister("k2PPW", function(module, exports) {

$parcel$export(module.exports, "JswProjectMenu", () => $37f44a28095ceb78$export$6bfce83b67850c4);

var $erlTu = parcelRequire("erlTu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2vSU6 = parcelRequire("2vSU6");

var $c1pSA = parcelRequire("c1pSA");

var $igsK5 = parcelRequire("igsK5");
const $37f44a28095ceb78$export$6bfce83b67850c4 = ({ projectData: projectData, spotlight: spotlight })=>{
    const project = (0, $8Uumt.useFragment)((0, $erlTu.default), projectData);
    if (project.softwareBoardCount && project.softwareBoardCount > 0 && project.projectStyle === (0, $2vSU6.COMPANY_MANAGED_PROJECT)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1pSA.JswExpandableProject), {
        projectData: project,
        spotlight: spotlight
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $igsK5.JswNonExpandableProject), {
        projectData: project,
        spotlight: spotlight
    });
};

});
parcelRegister("erlTu", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b193e92809e464$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ebd04d48d90ea3ce2f73465099d87768>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $40b193e92809e464$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JswProjectMenu",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "softwareBoardCount"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "FragmentSpread",
            "name": "JswNonExpandableProject"
        },
        {
            "kind": "FragmentSpread",
            "name": "JswExpandableProject"
        }
    ],
    "type": "JiraProject"
};
$40b193e92809e464$var$node.hash = "27f10b420257dabdaa5ad33027d9b82c";
var $40b193e92809e464$export$2e2bcd8739ae039 = $40b193e92809e464$var$node;

});

parcelRegister("c1pSA", function(module, exports) {

$parcel$export(module.exports, "JswExpandableProject", () => $fb08c4a99aac50be$export$a77599e713340697);

var $kKbGS = parcelRequire("kKbGS");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6Lyip = parcelRequire("6Lyip");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $kavsL = parcelRequire("kavsL");

var $fNJRN = parcelRequire("fNJRN");

var $jhS4y = parcelRequire("jhS4y");

var $c16H2 = parcelRequire("c16H2");

var $338xa = parcelRequire("338xa");

var $7C7jZ = parcelRequire("7C7jZ");

var $dQbFB = parcelRequire("dQbFB");

var $4zcxJ = parcelRequire("4zcxJ");

var $76MhN = parcelRequire("76MhN");

var $koeKL = parcelRequire("koeKL");

var $buihy = parcelRequire("buihy");
var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");

var $60FHh = parcelRequire("60FHh");

var $4R6GH = parcelRequire("4R6GH");

var $9n0dK = parcelRequire("9n0dK");

var $5GG0x = parcelRequire("5GG0x");


var $2Ioew = parcelRequire("2Ioew");

var $bmKPg = parcelRequire("bmKPg");


var $dwZUI = parcelRequire("dwZUI");

var $gfIrU = parcelRequire("gfIrU");

var $1kZCN = parcelRequire("1kZCN");
const $fb08c4a99aac50be$export$a77599e713340697 = ({ projectData: projectData, spotlight: spotlight })=>{
    const { sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent } = (0, $fNJRN.useProjectsAnalyticsL1)();
    const project = (0, $8Uumt.useFragment)((0, $kKbGS.default), projectData);
    const cloudId = (0, $koeKL.useCloudId)();
    const entryPointParamsOld = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectId: project.id,
            noOfBoardsToFetch: (0, $ba4e5f586c2a87d8$export$420a3ee5deb615a9)
        }), [
        cloudId,
        project.id
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            tenantContext: {
                cloudId: cloudId
            },
            context: {
                match: {
                    params: {
                        projectKey: project.projectKey
                    }
                }
            }
        }), [
        cloudId,
        project.projectKey
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const leftSidebarEPRef = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5));
    const boardsEPRef = leftSidebarEPRef?.entryPoints?.boards;
    const [projectKey] = (0, $bmKPg.usePathParam)('projectKey');
    const shouldRenderBoardsEntryPoint = project.projectKey === projectKey;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $dwZUI.nav4JSWProjectEntryPoint), entryPointParams);
    const { entryPointActions: entryPointActionsOld, entryPointReferenceSubject: entryPointReferenceSubjectOld } = (0, $4mO32.useEntryPoint)((0, $gfIrU.asyncJswExpandableProjectQuery), entryPointParamsOld);
    const actionsOnHoverEntryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectId: project.id
        }), [
        cloudId,
        project.id
    ]);
    const { entryPointActions: actionsOnHoverEntryPointActions, entryPointReferenceSubject: actionsOnHoverEntryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $1kZCN.asyncActionsOnHover), actionsOnHoverEntryPointParams);
    const triggerRef = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActions);
    const triggerRefOld = (0, $4zcxJ.useExpandableEntryPointTrigger)(entryPointActionsOld);
    const actionsOnHoverCollapsedRef = (0, $9n0dK.useHoverEntryPointTrigger)(actionsOnHoverEntryPointActions);
    const { getLinkProps: getLinkProps } = (0, $7C7jZ.useGetLinkProps)();
    // Create this component once, then keep using it FOREVER.
    // We don't want to keep switching the implementation as the user does SPA transitions.
    const [entryPointConfig] = (0, $5uXOq.useState)(()=>{
        const epContainerProps = {
            id: 'jsw-expandable-project',
            packageName: (0, $ba4e5f586c2a87d8$export$b8b9d90f9e5bd72b),
            teamName: (0, $ba4e5f586c2a87d8$export$d57b6b390e78d90f),
            errorFallback: 'flag',
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            runtimeProps: entryPointParams
        };
        return {
            Component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5GG0x.RouteEntryPointContainer), {
                    epContainerProps: epContainerProps,
                    jiraEPRef: entryPointReferenceSubject,
                    nestedEPRef: boardsEPRef,
                    placeholderEntryPoint: (0, $dwZUI.nav4JSWProjectEntryPoint),
                    shouldRenderNestedEntryPoint: shouldRenderBoardsEntryPoint
                })
        };
    });
    const content = ()=>{
        if ((0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(entryPointConfig.Component, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            // Data stream, will subscribe to load updates.
            entryPointReferenceSubject: entryPointReferenceSubjectOld,
            // Required props for error JSErrorBoundary.
            id: "jsw-expandable-project",
            packageName: (0, $ba4e5f586c2a87d8$export$b8b9d90f9e5bd72b),
            // Optional props for error JSErrorBoundary.
            errorFallback: "flag",
            teamName: (0, $ba4e5f586c2a87d8$export$d57b6b390e78d90f),
            // Fallback for `Suspense`.
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
            // Props for the root component.
            runtimeProps: entryPointParamsOld
        });
    };
    if (!project) return null;
    const popupItemAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60FHh.ProjectActions), {
            projectFragment: project
        });
    const menuId = (0, $jhS4y.ENTITY_ID).PROJECT(project.projectKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        menuId: menuId,
        onSystemToggle: (hasExpanded)=>{
            if (hasExpanded) {
                if ((0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) entryPointActions.load();
                else entryPointActionsOld.load();
                if ((0, $4R6GH.fg)('blu-6100-plan-action-menu-entrypoint')) actionsOnHoverEntryPointActions.load();
            }
        },
        collapsedRef: (0, $4R6GH.fg)('blu-6100-plan-action-menu-entrypoint') ? actionsOnHoverCollapsedRef : undefined,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) {
                if ((0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) entryPointActions.load();
                else entryPointActionsOld.load();
                if ((0, $4R6GH.fg)('blu-6100-plan-action-menu-entrypoint')) actionsOnHoverEntryPointActions.load();
                sendProjectMenuItemAnalyticsEvent({
                    starred: project.isFavourite ?? false,
                    recent: !project.isFavourite,
                    projectId: project.projectId,
                    projectType: project.projectType
                });
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lyip.OnboardingSpotlightMaybe), {
        key: project.projectKey,
        spotlight: spotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        ...getLinkProps((0, $76MhN.removeBaseUrl)(project.webUrl)),
        actionsOnHover: (0, $4R6GH.fg)('blu-6100-plan-action-menu-entrypoint') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: actionsOnHoverEntryPointReferenceSubject,
            id: "jsw-expandable-project-actions",
            packageName: (0, $ba4e5f586c2a87d8$export$b8b9d90f9e5bd72b),
            errorFallback: "flag",
            teamName: (0, $ba4e5f586c2a87d8$export$d57b6b390e78d90f),
            runtimeProps: actionsOnHoverEntryPointParams
        }) : popupItemAction(),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buihy.ContainerAvatar), {
            src: project.avatar.large
        }),
        ref: (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? triggerRef : triggerRefOld,
        onClick: (ev)=>{
            if ((0, $kavsL.isNormalClick)(ev)) ev.preventDefault();
        },
        testId: (0, $dQbFB.getTestId)(menuId)
    }, project.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, content()));
};

});
parcelRegister("kKbGS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c3bea37742d5a83$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cd53fccb802d557a4a32e350520478a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6c3bea37742d5a83$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JswExpandableProject",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "projectKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "large"
                        },
                        "action": "THROW",
                        "path": "avatar.large"
                    }
                ]
            },
            "action": "THROW",
            "path": "avatar"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "webUrl"
            },
            "action": "THROW",
            "path": "webUrl"
        },
        {
            "kind": "FragmentSpread",
            "name": "ProjectActions"
        }
    ],
    "type": "JiraProject"
};
$6c3bea37742d5a83$var$node.hash = "97fa53b11ac066ee14270d6da1ac0254";
var $6c3bea37742d5a83$export$2e2bcd8739ae039 = $6c3bea37742d5a83$var$node;

});

parcelRegister("7C7jZ", function(module, exports) {

$parcel$export(module.exports, "useGetLinkProps", () => $a1cefbecfd084e6c$export$a3307878c8496d13);

var $5uXOq = parcelRequire("5uXOq");

var $9VXkC = parcelRequire("9VXkC");

var $3TY9o = parcelRequire("3TY9o");
const $a1cefbecfd084e6c$export$a3307878c8496d13 = ()=>{
    const location = (0, $3TY9o.useLocation)();
    const getLinkProps = (0, $5uXOq.useCallback)((menuItemPath, options)=>$a1cefbecfd084e6c$var$getMenuLinkPropsFromUrlPath({
            currentPath: location.pathname,
            menuItemPath: menuItemPath,
            options: options
        }), [
        location.pathname
    ]);
    const getLinkPropsFromRoute = (0, $5uXOq.useCallback)((menuItemRoute, pathParamValues = {}, options)=>{
        const menuItemPath = (0, $9VXkC.generatePath)(menuItemRoute.path, pathParamValues);
        return getLinkProps(menuItemPath, options);
    }, [
        getLinkProps
    ]);
    return {
        getLinkPropsFromRoute: getLinkPropsFromRoute,
        getLinkProps: /**
		 * Consider using getLinkPropsFromRoute instead, to be able to reuse the page route object, rather than copying its url path around.
		 */ getLinkProps
    };
};
const $a1cefbecfd084e6c$var$defaultOptions = {
    shouldMatchExactPath: true
};
const $a1cefbecfd084e6c$var$getMenuLinkPropsFromUrlPath = ({ currentPath: currentPath, menuItemPath: menuItemPath, options: options })=>{
    const { shouldMatchExactPath: shouldMatchExactPath } = {
        ...$a1cefbecfd084e6c$var$defaultOptions,
        ...options
    };
    return {
        href: menuItemPath,
        isSelected: shouldMatchExactPath ? currentPath.replace(/\/$/, '') === menuItemPath.replace(/\/$/, '') : currentPath.includes(menuItemPath.replace(/\/$/, ''))
    };
};

});

parcelRegister("76MhN", function(module, exports) {

$parcel$export(module.exports, "removeBaseUrl", () => $710c5248ed45c131$export$d401b6140b158f69);
/**
 * Removes the base URL from the given URL string.
 *
 * @param url - The URL string from which to remove the base URL.
 * @returns The URL string with the base URL removed.
 */ const $710c5248ed45c131$export$d401b6140b158f69 = (url)=>url.replace(/https?:\/\/[^/]+/, '');

});

parcelRegister("60FHh", function(module, exports) {

$parcel$export(module.exports, "ProjectActions", () => $0230a4e09f5a8c38$export$7f68bfd3564d5c6f);

var $5jRC6 = parcelRequire("5jRC6");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $g7g8o = parcelRequire("g7g8o");

var $eWkgo = parcelRequire("eWkgo");

var $5KCCi = parcelRequire("5KCCi");

var $koVbs = parcelRequire("koVbs");

var $hUpXm = parcelRequire("hUpXm");

var $1xonH = parcelRequire("1xonH");

var $ccuaM = parcelRequire("ccuaM");

var $brwH6 = parcelRequire("brwH6");

var $44kzF = parcelRequire("44kzF");

var $lmBAt = parcelRequire("lmBAt");

var $a2e2Q = parcelRequire("a2e2Q");

var $lODMY = parcelRequire("lODMY");

var $7TnTU = parcelRequire("7TnTU");

var $jzmXi = parcelRequire("jzmXi");
const $0230a4e09f5a8c38$export$70911e2dbc8f12b6 = (0, $lODMY.createRouterSelector)((state)=>state.match);
const $0230a4e09f5a8c38$export$7f68bfd3564d5c6f = ({ projectFragment: projectFragment, isCorePremiumUserSeat: isCorePremiumUserSeat = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { sendMeatBallDropDownOnProjectsAnalyticsEvent: sendMeatBallDropDownOnProjectsAnalyticsEvent, sendCreateBoardOnBoardMenuItemAnalyticsEvent: sendCreateBoardOnBoardMenuItemAnalyticsEvent } = (0, $hUpXm.useProjectsAnalyticsL2)();
    const match = (0, $lmBAt.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    $0230a4e09f5a8c38$export$70911e2dbc8f12b6() : undefined;
    const createBoardButtonRef = (0, $5uXOq.useRef)(null);
    const { hasSoftwareTheming: hasSoftwareTheming } = (0, $lmBAt.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        hasSoftwareTheming: false
    };
    const project = (0, $8Uumt.useFragment)((0, $5jRC6.default), projectFragment);
    const projectActionMenu = (0, $5uXOq.useMemo)(()=>{
        const canEditProjectConfig = project?.editPermission?.canPerform ?? false;
        const currentProjectKey = match?.params?.projectKey || match?.params?.issueKey?.split('-')[0];
        const canChangeTheme = currentProjectKey === project.projectKey && canEditProjectConfig && hasSoftwareTheming;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ccuaM.ProjectActionMenu), {
            onClick: ()=>{
                const { isFavourite: isFavourite, projectId: projectId, projectType: projectType } = project;
                sendMeatBallDropDownOnProjectsAnalyticsEvent({
                    starred: isFavourite ?? false,
                    recent: !isFavourite,
                    projectId: projectId,
                    projectType: projectType
                });
            },
            additionalMenuItems: canChangeTheme && (0, $lmBAt.getIsSoftwareThemingEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44kzF.ThemePicker), {
                projectId: Number(project.projectId),
                withAdaptiveColorTheme: true
            }),
            projectKey: project.projectKey,
            isCorePremiumUserSeat: isCorePremiumUserSeat
        });
    }, [
        project,
        match,
        hasSoftwareTheming,
        isCorePremiumUserSeat,
        sendMeatBallDropDownOnProjectsAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        gap: "space.050",
        alignItems: "center"
    }, (0, $7TnTU.isCompanyManagedSoftwareProject)(project.projectStyle, project.projectType) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $brwH6.BoardCreate), {
        projectId: project.projectId,
        projectAvatar: project.avatar?.large || undefined,
        projectKey: project.projectKey,
        triggerRef: createBoardButtonRef,
        renderTrigger: ({ triggerRef: triggerRef, ...props })=>{
            // callback to set button element to local ref.
            // to be used as prop for setting focus back to button after modal close.
            const setRef = (buttonElement)=>{
                createBoardButtonRef.current = buttonElement;
                if (typeof triggerRef === 'function') triggerRef(buttonElement);
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
                content: formatMessage((0, $jzmXi.default).createBoard)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xonH.CommonNavMenuButton), {
                ...props,
                onClick: (event)=>{
                    const { onClick: onClick } = props;
                    onClick?.(event);
                    sendCreateBoardOnBoardMenuItemAnalyticsEvent({
                        starred: project.isFavourite ?? false,
                        recent: !project.isFavourite,
                        projectId: project.projectId,
                        projectType: project.projectType
                    });
                },
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($g7g8o))),
                label: formatMessage((0, $jzmXi.default).createBoard),
                ref: setRef
            }));
        }
    })), projectActionMenu);
};

});
parcelRegister("5jRC6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a16e1f422bc99009$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d6ce0fc39a1e0bd54f116923dd20e139>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a16e1f422bc99009$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ProjectActions",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "projectKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW",
            "path": "projectType"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        },
        {
            "alias": "editPermission",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ],
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        }
    ],
    "type": "JiraProject"
};
$a16e1f422bc99009$var$node.hash = "43003740f90660c91ece4edfce8f9142";
var $a16e1f422bc99009$export$2e2bcd8739ae039 = $a16e1f422bc99009$var$node;

});

parcelRegister("brwH6", function(module, exports) {

$parcel$export(module.exports, "BoardCreate", () => $07d90eee58b2fab1$export$c753ba73bc24874c);

var $5uXOq = parcelRequire("5uXOq");

var $6prxh = parcelRequire("6prxh");

var $1P6DN = parcelRequire("1P6DN");
const $07d90eee58b2fab1$export$c753ba73bc24874c = ({ projectId: projectId, projectAvatar: projectAvatar, projectKey: projectKey, renderTrigger: renderTrigger, triggerRef: triggerRef })=>{
    if (!projectId || !projectKey) {
        (0, $6prxh.fireBoardCreateErrorAnalytics)({
            error: new Error('Failed to load board create flyout menu: projectId or projectKey undefined'),
            attributes: {
                projectId: projectId,
                projectKey: projectKey
            },
            id: 'loadFlyoutMenu'
        });
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1P6DN.BoardCreateFlyoutMenu), {
        renderTrigger: renderTrigger,
        projectId: projectId,
        projectKey: projectKey,
        projectAvatar: projectAvatar,
        triggerRef: triggerRef
    });
};

});
parcelRegister("6prxh", function(module, exports) {

$parcel$export(module.exports, "fireBoardCreateErrorAnalytics", () => $a085e033b99a140e$export$77dbc1f87d29b068);
$parcel$export(module.exports, "descriptionMapping", () => $a085e033b99a140e$export$56900bfb74887fe8);

var $jcw0u = parcelRequire("jcw0u");

var $h3KSk = parcelRequire("h3KSk");

var $6p4sE = parcelRequire("6p4sE");
const $a085e033b99a140e$export$77dbc1f87d29b068 = ({ attributes: attributes, id: id, error: error })=>{
    (0, $jcw0u.default)({
        error: error,
        attributes: attributes,
        meta: {
            id: `jiraSoftwareBoardCreate_${id}`,
            packageName: (0, $h3KSk.BOARD_CREATE_PACKAGE_NAME),
            teamName: (0, $h3KSk.TEAM_NAME)
        }
    });
};
const $a085e033b99a140e$export$56900bfb74887fe8 = {
    [(0, $h3KSk.BOARD_TYPES).KANBAN]: (0, $6p4sE.default).kanbanBoardCreationDescription,
    [(0, $h3KSk.BOARD_TYPES).SCRUM]: (0, $6p4sE.default).scrumBoardCreationDescription
};

});
parcelRegister("h3KSk", function(module, exports) {

$parcel$export(module.exports, "FLYOUT_MENU_CONTENT_ID", () => $f576620d788b19e6$export$ff67d81ebedcc801);
$parcel$export(module.exports, "BOARD_CREATE_PACKAGE_NAME", () => $f576620d788b19e6$export$3df8123340981894);
$parcel$export(module.exports, "TEAM_NAME", () => $f576620d788b19e6$export$d57b6b390e78d90f);
$parcel$export(module.exports, "BOARD_TYPES", () => $f576620d788b19e6$export$165dc6fdd115b0c1);
$parcel$export(module.exports, "BOARD_SOURCE_FIELDS", () => $f576620d788b19e6$export$318250ad9945de5c);
$parcel$export(module.exports, "BOARD_SOURCE_FIELDS_JQLTERM", () => $f576620d788b19e6$export$9f85086c10bd31f5);
$parcel$export(module.exports, "PICKER_SEARCH_DEBOUNCE_TIME", () => $f576620d788b19e6$export$f487cf015ececc3a);
$parcel$export(module.exports, "VALIDATION_ERROR_EMPTY", () => $f576620d788b19e6$export$7b060a5763a6e199);
$parcel$export(module.exports, "BOARD_NAME_LIMIT", () => $f576620d788b19e6$export$d760e95d248dc3a3);
const $f576620d788b19e6$export$edded98b84a6f50f = 'jsw-board-create';
const $f576620d788b19e6$export$ff67d81ebedcc801 = 'jsw-board-create-flyout-menu-content';
const $f576620d788b19e6$export$3df8123340981894 = 'jiraSoftwareBoardCreate';
const $f576620d788b19e6$export$d57b6b390e78d90f = 'deliveroo';
const $f576620d788b19e6$export$165dc6fdd115b0c1 = {
    KANBAN: 'KANBAN',
    SCRUM: 'SCRUM'
};
const $f576620d788b19e6$export$318250ad9945de5c = {
    TEAM: 'team',
    ISSUE_TYPES: 'issueTypes',
    LABELS: 'labels',
    SAVED_FILTER: 'savedFilter'
};
const $f576620d788b19e6$export$9f85086c10bd31f5 = {
    [$f576620d788b19e6$export$318250ad9945de5c.ISSUE_TYPES]: 'type',
    [$f576620d788b19e6$export$318250ad9945de5c.LABELS]: 'labels'
};
const $f576620d788b19e6$export$f487cf015ececc3a = 500;
const $f576620d788b19e6$export$7b060a5763a6e199 = 'VALIDATION_ERROR_EMPTY';
const $f576620d788b19e6$export$d760e95d248dc3a3 = 155;

});

parcelRegister("6p4sE", function(module, exports) {

$parcel$export(module.exports, "default", () => $30e80f50e57185ba$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $30e80f50e57185ba$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    boardCreationTitle: {
        "id": "software-board-create.common.board-creation-title",
        "defaultMessage": "Create a board"
    },
    scrumBoardCreationHeader: {
        "id": "software-board-create.common.scrum-board-creation-header",
        "defaultMessage": "Scrum"
    },
    scrumBoardCreationDescription: {
        "id": "software-board-create.common.scrum-board-creation-description",
        "defaultMessage": "Sprint towards your team objectives with a board, backlog, and reports."
    },
    kanbanBoardCreationHeader: {
        "id": "software-board-create.common.kanban-board-creation-header",
        "defaultMessage": "Kanban"
    },
    kanbanBoardCreationDescription: {
        "id": "software-board-create.common.kanban-board-creation-description",
        "defaultMessage": "Manage a continuous delivery of work with a kanban board and reports."
    },
    loadSavedFiltersErrorTitle: {
        "id": "software-board-create.common.load-saved-filters-error-title",
        "defaultMessage": "We can\u2019t load saved filters right now"
    },
    loadSavedFiltersErrorDescription: {
        "id": "software-board-create.common.load-saved-filters-error-description",
        "defaultMessage": "Refresh the page and try again."
    },
    requiredFieldsHeader: {
        "id": "software-board-create.common.required-fields-header",
        "defaultMessage": "Required fields are marked with an asterisk *"
    }
});

});


parcelRegister("1P6DN", function(module, exports) {

$parcel$export(module.exports, "BoardCreateFlyoutMenu", () => $585e525931061bc7$export$6a893f4168172b4e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $1Seuh = parcelRequire("1Seuh");

var $j7m8K = parcelRequire("j7m8K");

var $46OkO = parcelRequire("46OkO");

var $3nfCi = parcelRequire("3nfCi");
const $585e525931061bc7$export$a27652ddcad2c9dc = ({ triggerRef: triggerRef, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
        ...props,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($46OkO))),
        label: "create board",
        ref: triggerRef,
        testId: "software-board-create.ui.flyout-menu.trigger"
    });
};
const $585e525931061bc7$export$6a893f4168172b4e = ({ renderTrigger: Trigger = $585e525931061bc7$export$a27652ddcad2c9dc, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j7m8K.default), {
        trigger: Trigger,
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3nfCi.AsyncFlyoutMenuContent), props));

});
parcelRegister("3nfCi", function(module, exports) {

$parcel$export(module.exports, "AsyncFlyoutMenuContent", () => $ec0472afe4c77c87$export$3f0e1916911c9d6a);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $h3KSk = parcelRequire("h3KSk");

var $37QrD = parcelRequire("37QrD");

var $jFvRN = parcelRequire("jFvRN");
const $ec0472afe4c77c87$var$entryPointParams = {};
const $ec0472afe4c77c87$export$3f0e1916911c9d6a = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $37QrD.flyoutMenuContentEntryPoint), $ec0472afe4c77c87$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: (0, $h3KSk.FLYOUT_MENU_CONTENT_ID),
        packageName: (0, $h3KSk.BOARD_CREATE_PACKAGE_NAME),
        teamName: (0, $h3KSk.TEAM_NAME),
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jFvRN.FlyoutMenuContentFallback), null),
        errorFallback: "flag",
        runtimeProps: props
    });
};

});
parcelRegister("37QrD", function(module, exports) {

$parcel$export(module.exports, "flyoutMenuContentEntryPoint", () => $dfaa4ef5476ceb15$export$e6b36ab0519985d7);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $dfaa4ef5476ceb15$export$e6b36ab0519985d7 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("kWGoR"))), {
        moduleId: "53a3dd04"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kWGoR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "FlyoutContentContainer", () => $1c9edbc1633491d5$export$b7a36d8992ebabdb);
$parcel$export(module.exports, "default", () => $1c9edbc1633491d5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3jAdT = parcelRequire("3jAdT");

var $bPaTh = parcelRequire("bPaTh");

var $gIm6W = parcelRequire("gIm6W");

var $c3ZaD = parcelRequire("c3ZaD");
var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $h3KSk = parcelRequire("h3KSk");

var $6p4sE = parcelRequire("6p4sE");

var $iCBgO = parcelRequire("iCBgO");
const $1c9edbc1633491d5$export$b7a36d8992ebabdb = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $1c9edbc1633491d5$var$menuContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $1c9edbc1633491d5$var$headerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $1c9edbc1633491d5$var$headerStyles
    }, formatMessage((0, $6p4sE.default).boardCreationTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c3ZaD.default), {
        block: "space.050"
    }, children));
};
const $1c9edbc1633491d5$var$BoardCreateFlyoutMenuContent = ({ props: { projectId: projectId, projectAvatar: projectAvatar, projectKey: projectKey, triggerRef: triggerRef } })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dropdownItems = (0, $5uXOq.useMemo)(()=>{
        const items = [
            {
                boardType: (0, $h3KSk.BOARD_TYPES).SCRUM,
                title: formatMessage((0, $6p4sE.default).scrumBoardCreationHeader),
                description: formatMessage((0, $6p4sE.default).scrumBoardCreationDescription),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gIm6W))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                })
            },
            {
                boardType: (0, $h3KSk.BOARD_TYPES).KANBAN,
                title: formatMessage((0, $6p4sE.default).kanbanBoardCreationHeader),
                description: formatMessage((0, $6p4sE.default).kanbanBoardCreationDescription),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bPaTh))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                })
            }
        ];
        return items.map(({ boardType: boardType, ...props }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iCBgO.DropdownItemContainer), {
                key: boardType,
                entryPointProps: {
                    boardType: boardType,
                    projectId: projectId,
                    projectAvatar: projectAvatar,
                    projectKey: projectKey,
                    triggerRef: triggerRef
                },
                index: index,
                ...props
            }));
    }, [
        formatMessage,
        projectId,
        projectAvatar,
        projectKey,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1c9edbc1633491d5$export$b7a36d8992ebabdb, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jAdT.default), null, dropdownItems));
};
var $1c9edbc1633491d5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($1c9edbc1633491d5$var$BoardCreateFlyoutMenuContent);
const $1c9edbc1633491d5$var$headerStyles = (0, $2s57o.xcss)({
    font: 'font.heading.xxsmall',
    color: 'color.text.subtlest'
});
const $1c9edbc1633491d5$var$menuContainerStyles = (0, $2s57o.xcss)({
    width: '273px',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $1c9edbc1633491d5$var$headerContainerStyles = (0, $2s57o.xcss)({
    height: 'space.200',
    padding: 'space.200',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});
parcelRegister("gIm6W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3028194b67909de4178ae7b995e8e7b7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c2b1e82b6cef4aa8$var$_react = $c2b1e82b6cef4aa8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c2b1e82b6cef4aa8$var$_baseNew = $c2b1e82b6cef4aa8$var$_interopRequireDefault((parcelRequire("enEmH")));
function $c2b1e82b6cef4aa8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sprint".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c2b1e82b6cef4aa8$var$SprintIcon = (props)=>/*#__PURE__*/ $c2b1e82b6cef4aa8$var$_react.default.createElement($c2b1e82b6cef4aa8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A4.75 4.75 0 0 0 8 11h5.44l-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H0V11h3.938A6.25 6.25 0 1 1 14.25 6.25h-1.5A4.75 4.75 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$c2b1e82b6cef4aa8$var$SprintIcon.displayName = 'SprintIcon';
var $c2b1e82b6cef4aa8$var$_default = module.exports.default = $c2b1e82b6cef4aa8$var$SprintIcon;

});

parcelRegister("c3ZaD", function(module, exports) {

$parcel$export(module.exports, "default", () => $244d33f395378365$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $2s57o = parcelRequire("2s57o");
function $244d33f395378365$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $244d33f395378365$var$baseStyles = {
    name: "1khn195",
    styles: "box-sizing:border-box"
};
const $244d33f395378365$var$blockBleedMap = {
    'space.025': {
        name: "9w2fxh",
        styles: "margin-block:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "1qhe0y6",
        styles: "margin-block:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "s0o2nz",
        styles: "margin-block:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "151e4o3",
        styles: "margin-block:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "16sn062",
        styles: "margin-block:var(--ds-space-negative-200, -1rem)"
    }
};
const $244d33f395378365$var$inlineBleedMap = {
    'space.025': {
        name: "16oxh68",
        styles: "margin-inline:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "tdc6fz",
        styles: "margin-inline:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "crujrn",
        styles: "margin-inline:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "y28d58",
        styles: "margin-inline:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "1vfkteg",
        styles: "margin-inline:var(--ds-space-negative-200, -1rem)"
    }
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ const $244d33f395378365$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    const resolvedStyles = (0, $2s57o.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $244d33f395378365$var$baseStyles,
            (inline || all) && $244d33f395378365$var$inlineBleedMap[inline || all],
            (block || all) && $244d33f395378365$var$blockBleedMap[block || all],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
});
$244d33f395378365$var$Bleed.displayName = 'Bleed';
var $244d33f395378365$export$2e2bcd8739ae039 = $244d33f395378365$var$Bleed;

});

parcelRegister("iCBgO", function(module, exports) {

$parcel$export(module.exports, "DropdownItemContainer", () => $8729a548ec5065a8$export$cfb1162696b4c012);

var $5uXOq = parcelRequire("5uXOq");

var $bWfiu = parcelRequire("bWfiu");

var $2Eqc8 = parcelRequire("2Eqc8");
var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $lXAdy = parcelRequire("lXAdy");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $h3KSk = parcelRequire("h3KSk");

var $gPHY5 = parcelRequire("gPHY5");

var $4MxwN = parcelRequire("4MxwN");

var $aDXGG = parcelRequire("aDXGG");
const $8729a548ec5065a8$export$cfb1162696b4c012 = ({ entryPointProps: entryPointProps, title: title, description: description, icon: icon, index: index })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const triggerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (index === 0 && triggerRef.current) triggerRef.current.focus();
    }, [
        index
    ]);
    const handleOnDropdownItemClick = (0, $5uXOq.useCallback)(()=>{
        const boardTypePascalCase = entryPointProps.boardType === (0, $h3KSk.BOARD_TYPES).SCRUM ? 'Scrum' : 'Kanban';
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'dropdownItem',
            action: 'clicked'
        }), `create${boardTypePascalCase}Board`);
    }, [
        createAnalyticsEvent,
        entryPointProps.boardType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXAdy.ModalEntryPointDropdownItemTrigger), {
        "aria-label": formatMessage((0, $aDXGG.default).createBoardLabel, {
            boardType: entryPointProps.boardType.toLowerCase()
        }),
        forwardedRef: triggerRef,
        entryPoint: (0, $gPHY5.boardCreateModalEntryPoint),
        testId: "software-board-create.ui.flyout-menu.flyout-menu-content.dropdown-item-container.dropdown-item-trigger",
        interactionName: "open-create-board-modal",
        entryPointProps: entryPointProps,
        Fallback: (0, $4MxwN.BoardCreateModalFallback),
        onClick: handleOnDropdownItemClick,
        useInternalModal: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $8729a548ec5065a8$var$itemIconBackgroundStyles
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "xsmall"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        size: "medium"
    }, description))));
};
const $8729a548ec5065a8$var$ICON_BACKGROUND_CONTAINER_SIZE = '32px';
const $8729a548ec5065a8$var$itemIconBackgroundStyles = (0, $2s57o.xcss)({
    backgroundColor: 'color.background.neutral',
    width: $8729a548ec5065a8$var$ICON_BACKGROUND_CONTAINER_SIZE,
    height: $8729a548ec5065a8$var$ICON_BACKGROUND_CONTAINER_SIZE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "2px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius-050, 3px)",
    padding: 'space.050',
    flexShrink: 0
});

});
parcelRegister("lXAdy", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointDropdownItemTrigger", () => $d1639b87be26e4ed$export$82b29db923c97084);

var $5uXOq = parcelRequire("5uXOq");

var $1eETS = parcelRequire("1eETS");

var $2KAtx = parcelRequire("2KAtx");
const $d1639b87be26e4ed$export$82b29db923c97084 = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, modalTitle: modalTitle, modalProps: modalProps, useInternalModal: useInternalModal, forwardedRef: forwardedRef, ...dropdownProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        forwardedRef: forwardedRef,
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        errorAttributes: errorAttributes,
        Fallback: Fallback,
        interactionName: interactionName,
        title: modalTitle,
        modalProps: modalProps,
        useInternalModal: useInternalModal
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
            ref: ref,
            ...dropdownProps
        }, children));
};

});

parcelRegister("gPHY5", function(module, exports) {

$parcel$export(module.exports, "boardCreateModalEntryPoint", () => $7eac46aad6713698$export$ae34a65266b8e906);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $7eac46aad6713698$export$ae34a65266b8e906 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("4MxwN"))), {
        moduleId: "6c073853"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4MxwN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "BoardCreateModalFallback", () => $be001cef457a59e7$export$303db58b19f6b446);
$parcel$export(module.exports, "default", () => $be001cef457a59e7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $9fuVs = parcelRequire("9fuVs");

var $koVbs = parcelRequire("koVbs");

var $7NYq5 = parcelRequire("7NYq5");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $6p4sE = parcelRequire("6p4sE");

var $6prxh = parcelRequire("6prxh");

var $2NRUh = parcelRequire("2NRUh");

var $keWq7 = parcelRequire("keWq7");

var $4K4Ab = parcelRequire("4K4Ab");
const $be001cef457a59e7$var$MODAL_WIDTH = 1000;
const $be001cef457a59e7$var$MODAL_HEIGHT = 551;
const $be001cef457a59e7$export$303db58b19f6b446 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        height: $be001cef457a59e7$var$MODAL_HEIGHT,
        width: $be001cef457a59e7$var$MODAL_WIDTH,
        label: formatMessage((0, $4K4Ab.default).loadingLabel),
        messageId: "software-board-create.ui.modal.modal.board-create-modal-fallback",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $keWq7.BoardCreateFormFallback), null));
};
const $be001cef457a59e7$var$BoardCreateModal = ({ boardType: boardType, projectId: projectId, onClose: onClose, triggerRef: triggerRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleOnClose = (_mouseEvent, _analyticEvent, didSubmit)=>{
        const event = createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'modalDialog'
        });
        (0, $8zOmE.fireUIAnalytics)(event, 'createNewBoardModal', {
            didSubmit: !!didSubmit,
            boardType: boardType.toLowerCase()
        });
        onClose?.();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        testId: "software-board-create.ui.modal",
        onClose: handleOnClose,
        width: $be001cef457a59e7$var$MODAL_WIDTH,
        height: $be001cef457a59e7$var$MODAL_HEIGHT,
        messageId: "software-board-create.ui.modal.modal.board-create-modal",
        messageType: "transactional",
        label: `${formatMessage((0, $6p4sE.default).boardCreationTitle)}. ${formatMessage((0, $6prxh.descriptionMapping)[boardType])}`,
        shouldReturnFocus: triggerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $keWq7.BoardCreateForm), {
        projectId: projectId,
        boardType: boardType,
        onClose: handleOnClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            boardType: boardType.toLowerCase()
        }
    }));
};
const $be001cef457a59e7$var$BoardCreateModalWithContext = ({ props: { projectAvatar: projectAvatar, projectKey: projectKey, ...restProps } })=>{
    const value = (0, $5uXOq.useMemo)(()=>({
            projectId: restProps.projectId,
            projectAvatar: projectAvatar,
            projectKey: projectKey
        }), [
        restProps.projectId,
        projectAvatar,
        projectKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NRUh.BoardCreateContext).Provider, {
        value: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "createNewBoard",
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($be001cef457a59e7$var$BoardCreateModal, restProps))));
};
var $be001cef457a59e7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($be001cef457a59e7$var$BoardCreateModalWithContext);

});
parcelRegister("2NRUh", function(module, exports) {

$parcel$export(module.exports, "BoardCreateContext", () => $267ce53d896f9c4d$export$5169319147995508);
$parcel$export(module.exports, "useBoardCreateContext", () => $267ce53d896f9c4d$export$768ffccd7d71d6d9);

var $5uXOq = parcelRequire("5uXOq");
const $267ce53d896f9c4d$var$initialContext = {
    projectId: undefined,
    projectAvatar: undefined,
    projectKey: undefined
};
const $267ce53d896f9c4d$export$5169319147995508 = /*#__PURE__*/ (0, $5uXOq.createContext)($267ce53d896f9c4d$var$initialContext);
const $267ce53d896f9c4d$export$768ffccd7d71d6d9 = ()=>(0, $5uXOq.useContext)($267ce53d896f9c4d$export$5169319147995508);

});

parcelRegister("keWq7", function(module, exports) {

$parcel$export(module.exports, "BoardCreateFormFallback", () => $c2504b6b008fc3bd$export$efb232229a99ba7b);
$parcel$export(module.exports, "BoardCreateForm", () => $c2504b6b008fc3bd$export$bc90d453a0e513ff);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $7folp = parcelRequire("7folp");
var $iu66X = parcelRequire("iu66X");
var $3AbYh = parcelRequire("3AbYh");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");

var $4CMbn = parcelRequire("4CMbn");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $BUgEw = parcelRequire("BUgEw");

var $hBw29 = parcelRequire("hBw29");

var $cPVty = parcelRequire("cPVty");

var $aDJ8l = parcelRequire("aDJ8l");

var $2ze4l = parcelRequire("2ze4l");

var $7GuB2 = parcelRequire("7GuB2");

var $g5ZcC = parcelRequire("g5ZcC");

var $iizLc = parcelRequire("iizLc");
const $c2504b6b008fc3bd$export$efb232229a99ba7b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        xcss: $c2504b6b008fc3bd$var$formContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        gap: "space.1000",
        xcss: $c2504b6b008fc3bd$var$formContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        xcss: $c2504b6b008fc3bd$var$columnStyles,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CMbn.default), {
        width: "150px",
        height: "20px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CMbn.default), {
        width: "100%",
        height: "12px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CMbn.default), {
        width: "20%",
        height: "12px",
        borderRadius: "3px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CMbn.default), {
        width: "100px",
        height: "12px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CMbn.default), {
        width: "100%",
        height: "30px",
        borderRadius: "3px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CMbn.default), {
        width: "200px",
        height: "12px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CMbn.default), {
        width: "100%",
        height: "30px",
        borderRadius: "3px"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CMbn.default), {
        width: "70px",
        height: "32px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CMbn.default), {
        width: "70px",
        height: "32px",
        borderRadius: "3px"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        xcss: $c2504b6b008fc3bd$var$columnStyles,
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CMbn.default), {
        width: "150px",
        height: "20px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CMbn.default), {
        width: "412px",
        height: "307px",
        borderRadius: "16px"
    }))));
};
const $c2504b6b008fc3bd$export$bc90d453a0e513ff = ({ boardType: boardType, projectId: projectId, onClose: onClose })=>{
    const { submit: submit } = (0, $BUgEw.useBoardCreateController)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const handleOnSubmit = (0, $5uXOq.useCallback)(async (data)=>{
        const errors = (0, $iizLc.validateFormData)(data);
        const hasValidationErrors = errors.boardName || errors.sourceType || errors.sourceValue;
        let sourceValueLength = 0;
        if (data.sourceValue != null) sourceValueLength = Array.isArray(data.sourceValue) ? data.sourceValue.length : 1;
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(event, 'createNewBoard', {
            sourceType: data.sourceType,
            sourceValueLength: sourceValueLength,
            errors: hasValidationErrors && errors
        });
        if (hasValidationErrors) return errors;
        await submit({
            boardType: boardType,
            formValues: data,
            locationProjectId: projectId ?? '',
            onSuccess: ()=>onClose(undefined, undefined, true)
        });
    }, [
        createAnalyticsEvent,
        submit,
        boardType,
        projectId,
        onClose
    ]);
    const resetSourceValue = (0, $5uXOq.useCallback)((setFieldValue)=>()=>setFieldValue((0, $g5ZcC.SOURCE_VALUE_FIELD_NAME), undefined), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        xcss: $c2504b6b008fc3bd$var$formContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7folp.default), {
        onSubmit: handleOnSubmit
    }, ({ formProps: formProps, submitting: submitting, setFieldValue: setFieldValue })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
            ...formProps,
            noValidate: true,
            className: (0, $bwpsq.default)([
                "_18m91wug _1bsb1osq"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
            gap: "space.1000",
            xcss: $c2504b6b008fc3bd$var$formContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
            xcss: $c2504b6b008fc3bd$var$columnStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBw29.ModalHeader), {
            type: boardType
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: $c2504b6b008fc3bd$var$formFieldsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3AbYh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ze4l.BoardNameField), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3AbYh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7GuB2.SourceTypePicker), {
            resetSourceValue: resetSourceValue(setFieldValue)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g5ZcC.SourceValuePicker), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: $c2504b6b008fc3bd$var$buttonGroupContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iu66X.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aDJ8l.FormActions), {
            submitting: submitting,
            onClose: onClose
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
            xcss: $c2504b6b008fc3bd$var$columnStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPVty.ModalIllustration), null))))));
};
const $c2504b6b008fc3bd$var$formStyles = null;
const $c2504b6b008fc3bd$var$formContentStyles = (0, $2s57o.xcss)({
    height: '100%',
    width: '100%'
});
const $c2504b6b008fc3bd$var$columnStyles = (0, $2s57o.xcss)({
    width: 'calc(50% - 40px)',
    // space.1000 is 80px, thus 40px is the space on each side
    flex: 'none',
    paddingTop: 'space.200'
});
const $c2504b6b008fc3bd$var$formFieldsContainerStyles = (0, $2s57o.xcss)({
    flexGrow: 1
});
const $c2504b6b008fc3bd$var$buttonGroupContainerStyles = (0, $2s57o.xcss)({
    alignSelf: 'end',
    justifySelf: 'end'
});
const $c2504b6b008fc3bd$var$formContainerStyles = (0, $2s57o.xcss)({
    paddingTop: 'space.600',
    paddingLeft: 'space.600',
    paddingRight: 'space.600',
    paddingBottom: 'space.500',
    height: '100%'
});

});
parcelRegister("7folp", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $989b7d35312a49bd$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $989b7d35312a49bd$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $989b7d35312a49bd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lqWDn = parcelRequire("lqWDn");

var $8tHJX = parcelRequire("8tHJX");

var $gZL7V = parcelRequire("gZL7V");
const $989b7d35312a49bd$export$c24727297075ec6a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $989b7d35312a49bd$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
function $989b7d35312a49bd$export$2e2bcd8739ae039(props) {
    const formRef = (0, $5uXOq.useRef)(null);
    const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $5uXOq.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $lqWDn.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $5uXOq.useState)({
        dirty: false,
        submitting: false
    });
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: {
                    onSubmit: handleSubmit,
                    ref: formRef,
                    onKeyDown: handleKeyDown
                },
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change
            }) : children();
            return result === undefined ? null : result;
        }
        return children;
    })();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($989b7d35312a49bd$export$c24727297075ec6a.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($989b7d35312a49bd$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
}

});
parcelRegister("lqWDn", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $f9a9822f8af64e2a$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $f9a9822f8af64e2a$export$97cd7fc25dd32915);
$parcel$export(module.exports, "ARRAY_ERROR", () => $f9a9822f8af64e2a$export$735bebc8ffabf28a);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $f9a9822f8af64e2a$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $f9a9822f8af64e2a$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $f9a9822f8af64e2a$export$f681a8129d2e9d28);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");
//      
var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
var $f9a9822f8af64e2a$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
    string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f9a9822f8af64e2a$var$keysCache = {};
var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
    }
    return $f9a9822f8af64e2a$var$keysCache[key];
};
//      
var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f9a9822f8af64e2a$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
    var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $ddEsc.default)(current, [
                key
            ].map($f9a9822f8af64e2a$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
};
var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
    var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f9a9822f8af64e2a$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                    shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values)); // clone to avoid writing
            if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                    var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $bS32t.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $bS32t.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("8tHJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c2f612c5adb35a$export$2e2bcd8739ae039);

var $lqWDn = parcelRequire("lqWDn");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lqWDn.getIn)(errors, input.name);
    });
};
//      
var $62c2f612c5adb35a$var$noop = function noop() {};
var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;

});

parcelRegister("gZL7V", function(module, exports) {

var $ajB7H = parcelRequire("ajB7H");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $c5f6e64373be0bfc$var$set(object, path, value) {
    return object == null ? object : $ajB7H(object, path, value);
}
module.exports = $c5f6e64373be0bfc$var$set;

});


parcelRegister("iu66X", function(module, exports) {

$parcel$export(module.exports, "default", () => $669828ee5d91fd62$export$2e2bcd8739ae039);
/* form-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $669828ee5d91fd62$var$formFooterWrapperStyles = null;
const $669828ee5d91fd62$var$justifyContentStyles = null;
function $669828ee5d91fd62$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("footer", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ]),
        children: children
    });
}

});

parcelRegister("3AbYh", function(module, exports) {

$parcel$export(module.exports, "default", () => $079b7f0b55c30acb$export$2e2bcd8739ae039);
/* form-section.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bWfiu = parcelRequire("bWfiu");
const $079b7f0b55c30acb$var$formSectionDescriptionStyles = null;
const $079b7f0b55c30acb$var$formSectionWrapperStyles = null;
const $079b7f0b55c30acb$var$FormSectionWrapper = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1pfh1ejb"
        ]),
        children: children
    });
};
const $079b7f0b55c30acb$var$FormSectionDescription = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1pfhu2gc"
        ]),
        children: children
    });
};
/**
 * __Form section__.
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $079b7f0b55c30acb$var$FormSection = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($079b7f0b55c30acb$var$FormSectionWrapper, {
        children: [
            title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                size: "medium",
                children: title
            }),
            description && /*#__PURE__*/ (0, $2OMIu.jsx)($079b7f0b55c30acb$var$FormSectionDescription, {
                children: description
            }),
            children
        ]
    });
};
var $079b7f0b55c30acb$export$2e2bcd8739ae039 = $079b7f0b55c30acb$var$FormSection;

});

parcelRegister("BUgEw", function(module, exports) {

$parcel$export(module.exports, "useBoardCreateController", () => $6954e7e33c19033d$export$b1247ee6c4be437f);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $j5YhT = parcelRequire("j5YhT");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $93jKl = parcelRequire("93jKl");

var $4DrQd = parcelRequire("4DrQd");

var $7Cqm7 = parcelRequire("7Cqm7");

var $koeKL = parcelRequire("koeKL");

var $lVJAU = parcelRequire("lVJAU");

var $erN97 = parcelRequire("erN97");

var $eCBf9 = parcelRequire("eCBf9");

var $6prxh = parcelRequire("6prxh");

var $h3KSk = parcelRequire("h3KSk");

var $6fAG8 = parcelRequire("6fAG8");

var $2NRUh = parcelRequire("2NRUh");

var $96pTU = parcelRequire("96pTU");

var $16xB9 = parcelRequire("16xB9");

var $3i0DH = parcelRequire("3i0DH");
const $6954e7e33c19033d$var$EXPERIENCE = 'createBoard';
const $6954e7e33c19033d$export$43cdff4ae424f89f = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    return (0, $5uXOq.useCallback)(({ id: id, projectId: projectId })=>{
        (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
            try {
                if (!id) throw new Error('Failed to add board to project, missing id');
                if (!projectId) throw new Error('Failed to add board to project, missing projectId');
                const projectRelayDataId = (0, $erN97.default)({
                    id: (0, $j5YhT.JiraProjectAri).create({
                        siteId: cloudId,
                        projectId: String(projectId)
                    })
                }, 'JiraProject');
                if (!projectRelayDataId) throw new Error(`Failed to create project relay data id, projectId: ${projectId}`);
                const project = store.get(projectRelayDataId);
                if (!project) throw new Error(`Failed to find the project, projectId: ${projectId}`);
                const projectBoardsConnection = project.getLinkedRecord('boards', {
                    first: (0, $4DrQd.NO_OF_BOARDS_TO_SHOW)
                });
                if (!projectBoardsConnection) throw new Error('Failed to find the project-boards connection');
                const newNode = store.get(id);
                if (!newNode) throw new Error(`Failed to find the new board, id: ${id}`);
                const newEdge = (0, $8Uumt.ConnectionHandler).createEdge(store, projectBoardsConnection, newNode, 'JiraBoardEdge');
                (0, $8Uumt.ConnectionHandler).insertEdgeBefore(projectBoardsConnection, newEdge);
            } catch (error) {
                (0, $6prxh.fireBoardCreateErrorAnalytics)({
                    id: 'addBoardToProject',
                    error: error instanceof Error ? error : new Error(`Failed to add board to project: ${error}`)
                });
            }
        });
    }, [
        environment,
        cloudId
    ]);
};
const $6954e7e33c19033d$export$b1247ee6c4be437f = ()=>{
    const { handleMutation: handleMutation } = (0, $6fAG8.useBoardCreateMutation)();
    const { projectKey: projectKey } = (0, $2NRUh.useBoardCreateContext)(); // remove when clean up fix_board_url_value_in_graphql_apis
    const { showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag } = (0, $96pTU.useBoardCreateFlag)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const addBoardToProject = $6954e7e33c19033d$export$43cdff4ae424f89f();
    const isBacklogRoute = (0, $7Cqm7.useIsBacklogRoute)();
    const onExperienceStart = (0, $4R6GH.fg)('simplified_board_creation_capacity_slo') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kaHBi.useExperienceStart)({
        experience: $6954e7e33c19033d$var$EXPERIENCE,
        analyticsSource: (0, $h3KSk.BOARD_CREATE_PACKAGE_NAME)
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    const onExperienceSuccess = (0, $4R6GH.fg)('simplified_board_creation_capacity_slo') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3bQtK.useExperienceSuccess)({
        experience: $6954e7e33c19033d$var$EXPERIENCE
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    const onExperienceFail = (0, $4R6GH.fg)('simplified_board_creation_capacity_slo') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $93jKl.useExperienceFail)({
        experience: $6954e7e33c19033d$var$EXPERIENCE
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    const submit = (0, $5uXOq.useCallback)(async ({ boardType: boardType, locationProjectId: locationProjectId, formValues: formValues, onSuccess: onSuccess, onError: onError })=>{
        const input = (0, $3i0DH.transformInput)({
            boardType: boardType,
            locationProjectId: locationProjectId,
            formValues: formValues
        });
        try {
            (0, $4R6GH.fg)('simplified_board_creation_capacity_slo') && onExperienceStart();
            const result = await handleMutation(input);
            if (!result?.jira?.createBoard?.success && (0, $4R6GH.fg)('dee_7246_improve_board_create_error_handling')) throw result?.jira?.createBoard?.errors?.length ? new (0, $eCBf9.MutationError)(result?.jira?.createBoard?.errors?.[0]) : new Error('Failed to create board');
            onSuccess?.(result);
            showSuccessFlag({
                title: formatMessage((0, $16xB9.default).successTitle)
            });
            addBoardToProject({
                projectId: locationProjectId,
                id: result.jira?.createBoard?.board?.__id
            });
            (0, $4R6GH.fg)('simplified_board_creation_capacity_slo') && onExperienceSuccess();
            const resultBoardId = result?.jira?.createBoard?.board?.boardId;
            const resultBoardType = result?.jira?.createBoard?.board?.boardType;
            const boardUrl = (0, $4R6GH.fg)('fix_board_url_value_in_graphql_apis') ? (0, $3i0DH.buildBoardUrl)(result?.jira?.createBoard?.board?.boardUrl, resultBoardType) : (0, $3i0DH.buildBoardUrlOld)(projectKey, resultBoardId, resultBoardType);
            if (!boardUrl) (0, $6prxh.fireBoardCreateErrorAnalytics)({
                error: new Error('Failed to generate board URL after board creation'),
                attributes: {
                    boardId: resultBoardId,
                    boardType: resultBoardType
                },
                id: 'generateUrl'
            });
            else resultBoardType === 'SCRUM' && isBacklogRoute ? (0, $3i0DH.redirectToBacklog)(boardUrl) : push(boardUrl);
        } catch (error) {
            let errMsg;
            if (error instanceof (0, $eCBf9.MutationError) && error.message && (0, $4R6GH.fg)('dee_7246_improve_board_create_error_handling')) errMsg = error.message;
            onError?.(errMsg || error);
            showErrorFlag({
                title: formatMessage((0, $16xB9.default).errorTitle),
                description: errMsg || formatMessage((0, $16xB9.default).errorDescription)
            });
            (0, $6prxh.fireBoardCreateErrorAnalytics)({
                error: new Error(`Failed to create board: ${errMsg || error}`),
                id: 'createBoard'
            });
            (0, $4R6GH.fg)('simplified_board_creation_capacity_slo') && onExperienceFail((0, $h3KSk.BOARD_CREATE_PACKAGE_NAME), errMsg || error);
        }
    }, [
        onExperienceStart,
        handleMutation,
        showSuccessFlag,
        formatMessage,
        addBoardToProject,
        onExperienceSuccess,
        projectKey,
        isBacklogRoute,
        push,
        showErrorFlag,
        onExperienceFail
    ]);
    return {
        submit: submit
    };
};

});
parcelRegister("7Cqm7", function(module, exports) {

$parcel$export(module.exports, "useIsBacklogRoute", () => $6df6a0c87d7ecf35$export$1894da4846b402db);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");
const $6df6a0c87d7ecf35$export$1894da4846b402db = ()=>{
    const { name: name } = (0, $6jY6G.useCurrentRoute)();
    return (0, $5uXOq.useMemo)(()=>name === 'rapidboard-backlog' || name === 'rapidboard-user-backlog' || name === 'rapidboard-backlog-embed', [
        name
    ]);
};

});

parcelRegister("eCBf9", function(module, exports) {

$parcel$export(module.exports, "MutationError", () => $5fe48c9a5d56428c$export$10c788363424e94e);
class $5fe48c9a5d56428c$export$10c788363424e94e extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.message = payload.message ?? '';
        this.extensions = payload.extensions;
        this.statusCode = payload.extensions?.statusCode ?? null;
        this.errorType = payload.extensions?.errorType ?? null;
    }
}

});

parcelRegister("6fAG8", function(module, exports) {

$parcel$export(module.exports, "useBoardCreateMutation", () => $1f641104976de7c6$export$99c7414664697f66);

var $h3EhD = parcelRequire("h3EhD");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koeKL = parcelRequire("koeKL");
const $1f641104976de7c6$export$99c7414664697f66 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [commit] = (0, $8Uumt.useMutation)((0, $h3EhD.default));
    const handleMutation = (0, $5uXOq.useCallback)(async (input)=>new Promise((resolve, reject)=>{
            commit({
                variables: {
                    cloudId: cloudId,
                    input: input
                },
                onCompleted: (result)=>{
                    resolve(result);
                },
                onError: (error)=>{
                    reject(error);
                }
            });
        }), [
        cloudId,
        commit
    ]);
    return {
        handleMutation: handleMutation
    };
};

});
parcelRegister("h3EhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d774c68c24dc8f2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<96b4cce51ba6e0ff7c8004e93170ae98>>
 * @relayHash f07c5fbb5fc9fda47c89b1ea4e0b6538
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 39733200dfeb8f5ca8e119e986adf5ee373acba404794290d4a84a17b45673c2
const $9d774c68c24dc8f2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "JiraBoard",
        "kind": "LinkedField",
        "name": "board",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "boardId"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "boardType"
            },
            {
                "kind": "ScalarField",
                "name": "boardUrl"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useBoardCreateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCreateBoardPayload",
                            "kind": "LinkedField",
                            "name": "createBoard",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useBoardCreateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCreateBoardPayload",
                            "kind": "LinkedField",
                            "name": "createBoard",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "39733200dfeb8f5ca8e119e986adf5ee373acba404794290d4a84a17b45673c2",
            "metadata": {},
            "name": "useBoardCreateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9d774c68c24dc8f2$var$node.hash = "6559f8aeeafe0e444aad2224af38c3cb";
var $9d774c68c24dc8f2$export$2e2bcd8739ae039 = $9d774c68c24dc8f2$var$node;

});


parcelRegister("96pTU", function(module, exports) {

$parcel$export(module.exports, "useBoardCreateFlag", () => $0104309d6559195a$export$b93e10fcc9489915);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");
const $0104309d6559195a$export$b93e10fcc9489915 = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const showSuccessFlag = (0, $5uXOq.useCallback)(({ title: title, description: description })=>{
        showFlag({
            type: 'success',
            title: title,
            description: description,
            isAutoDismiss: true,
            messageId: 'software-board-create.controllers.use-board-create-flag.show-flag.success',
            messageType: 'transactional'
        });
    }, [
        showFlag
    ]);
    const showErrorFlag = (0, $5uXOq.useCallback)(({ title: title, description: description })=>{
        showFlag({
            type: 'error',
            title: title,
            description: description,
            isAutoDismiss: true,
            messageId: 'software-board-create.controllers.use-board-create-flag.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        showFlag
    ]);
    return {
        showSuccessFlag: showSuccessFlag,
        showErrorFlag: showErrorFlag
    };
};

});

parcelRegister("16xB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $01c40c2337fb8cba$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $01c40c2337fb8cba$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    successTitle: {
        "id": "software-board-create.controllers.use-board-create-controller.success-title",
        "defaultMessage": "Board successfully created"
    },
    errorTitle: {
        "id": "software-board-create.controllers.use-board-create-controller.error-title",
        "defaultMessage": "We couldn\u2019t create the board"
    },
    errorDescription: {
        "id": "software-board-create.controllers.use-board-create-controller.error-description",
        "defaultMessage": "Refresh the page and try again."
    }
});

});

parcelRegister("3i0DH", function(module, exports) {

$parcel$export(module.exports, "transformInput", () => $e5dcc01ab0bf80c8$export$28b8f0b21b2796a2);
$parcel$export(module.exports, "buildBoardUrlOld", () => $e5dcc01ab0bf80c8$export$b5a27f317af70564);
$parcel$export(module.exports, "buildBoardUrl", () => $e5dcc01ab0bf80c8$export$d807737c3f4eaba6);
$parcel$export(module.exports, "redirectToBacklog", () => $e5dcc01ab0bf80c8$export$594b405ab77720dc);

var $h3KSk = parcelRequire("h3KSk");
const $e5dcc01ab0bf80c8$var$formatFieldInput = (input)=>{
    if (!input.sourceType || input.sourceType === (0, $h3KSk.BOARD_SOURCE_FIELDS).SAVED_FILTER || !input.sourceValue) return null;
    const { sourceType: sourceType, sourceValue: sourceValue } = input;
    switch(sourceType){
        case (0, $h3KSk.BOARD_SOURCE_FIELDS).TEAM:
            return {
                teams: [
                    {
                        teamId: sourceValue.id
                    }
                ]
            };
        case (0, $h3KSk.BOARD_SOURCE_FIELDS).ISSUE_TYPES:
            return {
                issueTypes: sourceValue.map(({ value: value })=>({
                        issueTypeId: value
                    }))
            };
        case (0, $h3KSk.BOARD_SOURCE_FIELDS).LABELS:
            return {
                labels: sourceValue.map(({ value: value })=>({
                        name: value
                    }))
            };
        default:
            {
                const _exhaustiveCheck = sourceType;
                return null;
            }
    }
};
const $e5dcc01ab0bf80c8$var$getCreateBoardSource = (formValues, locationProjectId)=>{
    if (formValues?.sourceType === (0, $h3KSk.BOARD_SOURCE_FIELDS).SAVED_FILTER) return {
        savedFilterId: formValues.sourceValue?.value ? Number(formValues.sourceValue.value) : null
    };
    return {
        fieldInput: {
            projects: [
                {
                    projectId: locationProjectId
                }
            ],
            ...formValues.sourceType && formValues.sourceValue && $e5dcc01ab0bf80c8$var$formatFieldInput(formValues)
        }
    };
};
const $e5dcc01ab0bf80c8$export$28b8f0b21b2796a2 = ({ boardType: boardType, locationProjectId: locationProjectId, formValues: formValues })=>({
        createBoardSource: $e5dcc01ab0bf80c8$var$getCreateBoardSource(formValues, locationProjectId),
        location: {
            locationId: locationProjectId,
            locationType: 'PROJECT'
        },
        name: formValues.boardName,
        preset: boardType
    });
const $e5dcc01ab0bf80c8$export$b5a27f317af70564 = (projectKey, boardId, boardType)=>{
    if (!projectKey || !boardId) return null;
    return `/jira/software/c/projects/${projectKey}/boards/${boardId}${boardType === 'SCRUM' ? '/backlog' : ''}`;
};
const $e5dcc01ab0bf80c8$export$d807737c3f4eaba6 = (boardUrl, boardType)=>{
    if (!boardUrl) return null;
    return `${boardUrl}${boardType === 'SCRUM' ? '/backlog' : ''}`;
};
const $e5dcc01ab0bf80c8$export$594b405ab77720dc = (backlogUrl)=>{
    // This is a temporary fix for the redirection issue and will be addressed in BLU-5254
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href = backlogUrl;
};

});


parcelRegister("hBw29", function(module, exports) {

$parcel$export(module.exports, "ModalHeader", () => $36f6cf40bfe43457$export$f50a68e3694789ee);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");

var $koVbs = parcelRequire("koVbs");

var $6p4sE = parcelRequire("6p4sE");

var $6prxh = parcelRequire("6prxh");
const $36f6cf40bfe43457$export$f50a68e3694789ee = ({ type: type })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $bEIgH.default), {
        space: "space.100"
    }, /*#__PURE__*/ $5uXOq.createElement("h4", {
        className: (0, $bwpsq.default)([
            "_11c8lodh _k48pmoej _syaz1fxt"
        ])
    }, formatMessage((0, $6p4sE.default).boardCreationTitle)), /*#__PURE__*/ $5uXOq.createElement((0, $6eFvr.default), {
        size: "medium",
        color: "color.text.accent.gray.bolder"
    }, (0, $6prxh.descriptionMapping)[type] && formatMessage((0, $6prxh.descriptionMapping)[type])), /*#__PURE__*/ $5uXOq.createElement((0, $6eFvr.default), {
        as: "em",
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $6p4sE.default).requiredFieldsHeader)));
};
const $36f6cf40bfe43457$var$modalHeaderStyles = null;

});

parcelRegister("cPVty", function(module, exports) {

$parcel$export(module.exports, "ModalIllustration", () => $9f435b77d548b26f$export$dc26d3e21d436b08);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $1IOOW = parcelRequire("1IOOW");

var $bEIgH = parcelRequire("bEIgH");

var $2YF0r = parcelRequire("2YF0r");

var $koVbs = parcelRequire("koVbs");

var $evWvw = parcelRequire("evWvw");
const $9f435b77d548b26f$export$dc26d3e21d436b08 = ()=>{
    const state = (0, $1IOOW.useFormState)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h5", {
        className: (0, $bwpsq.default)([
            "_11c8nbxd _1reo15vq _18m915vq _k48p1pd9 _syaz1gjq _18u01axu _1bto1l2s _o5721q9c _p12fp3fh"
        ])
    }, state?.values.boardName?.trim() || formatMessage((0, $evWvw.default).illustrationPlaceHolderHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2YF0r.default), {
        alt: formatMessage((0, $evWvw.default).illustrationAltText),
        height: "334px"
    })));
};
const $9f435b77d548b26f$var$modalIllustrationHeaderStyles = null;

});
parcelRegister("1IOOW", function(module, exports) {

$parcel$export(module.exports, "useFormState", () => $ab816d0f0b91a5da$export$606f11b2eb45ecc6);

var $5uXOq = parcelRequire("5uXOq");

var $7folp = parcelRequire("7folp");
// Constantized to avoid a new object reference built every call
const $ab816d0f0b91a5da$var$defaultSubscriptionConfig = {
    values: true
};
/**
 * Build a simple hash for a given subscription object for use in a `useMemo` dependencies array.
 * This is because `{ values: true } !== { values: true }`, but `'values:true|' === 'values:true|'`
 *
 * @example { values: true, dirty: false } => 'values:true|dirty:false|'
 */ const $ab816d0f0b91a5da$var$getSubscriptionHash = (subscriptionConfig)=>{
    let hash = '';
    for(const key in subscriptionConfig)if (subscriptionConfig.hasOwnProperty(key)) hash += `${key}:${subscriptionConfig[key]}|`;
    return hash;
};
const $ab816d0f0b91a5da$export$606f11b2eb45ecc6 = (subscriptionConfig = $ab816d0f0b91a5da$var$defaultSubscriptionConfig)=>{
    const { subscribe: subscribe } = (0, $5uXOq.useContext)((0, $7folp.FormContext));
    const [state, setState] = (0, $5uXOq.useState)();
    /**
	 * A hash for us to shallow compare the subscriptionConfig object to react to shallow changes, but avoid referential changes.
	 * We avoid computing the hash if the subscription config has referential equality altogether.
	 */ const subscriptionConfigHash = (0, $5uXOq.useMemo)(()=>$ab816d0f0b91a5da$var$getSubscriptionHash(subscriptionConfig), [
        subscriptionConfig
    ]);
    /**
	 * Return a memoized version of the subscription config to only react to shallow changes, not referential changes.
	 * Eg. calling `useFormState({ values: true })` twice will result in two different objects by reference, but not by shallow comparison.
	 * This will ensure we don't re-subscribe to the form state when the subscription config is the same.
	 */ const config = (0, $5uXOq.useMemo)(()=>subscriptionConfig, // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally controlled with a hash to have an explicit shallow comparison
    [
        subscriptionConfigHash
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subscribe((formState)=>{
            setState(formState);
        }, config);
        return ()=>unsubscribe();
    }, [
        subscribe,
        config
    ]);
    return state;
};

});

parcelRegister("2YF0r", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bda248573ba546d$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $iPiYN = parcelRequire("iPiYN");
const $1bda248573ba546d$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($iPiYN)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($iPiYN))
});
var $1bda248573ba546d$export$2e2bcd8739ae039 = $1bda248573ba546d$var$Illustration;
const $1bda248573ba546d$export$a179c88182cb9d56 = [
    0,
    0,
    448,
    334
];

});
parcelRegister("iPiYN", function(module, exports) {
module.exports = new URL("bug-and-task-cards-in-a-column.455dfa61.svg", import.meta.url).toString();

});


parcelRegister("evWvw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a855b2f67ecf66fc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a855b2f67ecf66fc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    illustrationPlaceHolderHeader: {
        "id": "software-board-create.modal.illustration.illustration-place-holder-header",
        "defaultMessage": "New board"
    },
    illustrationAltText: {
        "id": "software-board-create.modal.illustration.illustration-alt-text",
        "defaultMessage": "Bug and task cards in a board column"
    }
});

});


parcelRegister("aDJ8l", function(module, exports) {

$parcel$export(module.exports, "FormActions", () => $015f57e976cf5b77$export$9494d5a5e5299081);

var $5uXOq = parcelRequire("5uXOq");

var $jHTSg = parcelRequire("jHTSg");

var $bMFGq = parcelRequire("bMFGq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $iLQ6N = parcelRequire("iLQ6N");
const $015f57e976cf5b77$export$9494d5a5e5299081 = ({ onClose: onClose, submitting: submitting })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $015f57e976cf5b77$var$buttonGroupContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHTSg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMFGq.default), {
        appearance: "subtle",
        isDisabled: submitting,
        onClick: onClose,
        testId: "software-board-create.ui.modal.form.actions.board-create-cancel-button"
    }, formatMessage((0, $iLQ6N.default).modalCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMFGq.default), {
        appearance: "primary",
        type: "submit",
        isLoading: submitting,
        testId: "software-board-create.ui.modal.form.actions.board-create-confirm-button"
    }, formatMessage((0, $iLQ6N.default).modalConfirmButton))));
};
const $015f57e976cf5b77$var$buttonGroupContainerStyles = (0, $2s57o.xcss)({
    paddingBottom: 'space.100'
});

});
parcelRegister("iLQ6N", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ebfc75c64d3ab56$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7ebfc75c64d3ab56$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    modalConfirmButton: {
        "id": "software-board-create.modal.form.actions.modal-confirm-button",
        "defaultMessage": "Create"
    },
    modalCancelButton: {
        "id": "software-board-create.modal.form.actions.modal-cancel-button",
        "defaultMessage": "Cancel"
    }
});

});


parcelRegister("2ze4l", function(module, exports) {

$parcel$export(module.exports, "BoardNameField", () => $a633258a18403e34$export$f710d048b5529d22);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $k5Wbc = parcelRequire("k5Wbc");
var $4EHpO = parcelRequire("4EHpO");
var $1IOOW = parcelRequire("1IOOW");

var $9r7BT = parcelRequire("9r7BT");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $h3KSk = parcelRequire("h3KSk");

var $4D12X = parcelRequire("4D12X");
const $a633258a18403e34$export$f710d048b5529d22 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formState = (0, $1IOOW.useFormState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [value, setValue] = (0, $5uXOq.useState)('');
    const hasEdited = (0, $5uXOq.useRef)(false);
    const debouncedHandleOnChange = (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
        if (!hasEdited.current) {
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'input'
            }), 'boardName');
            hasEdited.current = true;
        }
    }, 300)).current;
    const handleOnChange = (0, $5uXOq.useCallback)((event)=>{
        setValue(event.currentTarget.value);
        const newValue = event.currentTarget.value;
        setValue(newValue);
        debouncedHandleOnChange();
    }, [
        debouncedHandleOnChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EHpO.default), {
        label: formatMessage((0, $4D12X.default).boardNameFieldLabel),
        name: "boardName",
        isRequired: true
    }, ({ fieldProps: { onChange: onChange, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9r7BT.default), {
            ...rest,
            placeholder: formatMessage((0, $4D12X.default).boardNameFieldPlaceholder),
            maxLength: (0, $h3KSk.BOARD_NAME_LIMIT),
            testId: "software-board-create.ui.modal.form.board-name.board-name-input",
            value: value,
            onChange: (event)=>{
                handleOnChange(event);
                onChange(event);
            }
        }), error === (0, $h3KSk.VALIDATION_ERROR_EMPTY) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k5Wbc.ErrorMessage), {
            testId: "software-board-create.ui.modal.form.board-name.board-name-error"
        }, formatMessage((0, $4D12X.default).boardNameEmptyError)), formState?.values.boardName && formState.values.boardName.length >= (0, $h3KSk.BOARD_NAME_LIMIT) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k5Wbc.HelperMessage), null, formatMessage((0, $4D12X.default).boardNameMaxChars, {
            maxLength: (0, $h3KSk.BOARD_NAME_LIMIT)
        }))));
};

});
parcelRegister("k5Wbc", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $17b56f3c99dc4004$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $17b56f3c99dc4004$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $17b56f3c99dc4004$export$5505afb209a532c8);
$parcel$export(module.exports, "MessageWrapper", () => $17b56f3c99dc4004$export$ec445f12f63100a5);
/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iZXAi = parcelRequire("iZXAi");

var $35I2R = parcelRequire("35I2R");

var $bU9TL = parcelRequire("bU9TL");
const $17b56f3c99dc4004$var$messageStyles = null;
const $17b56f3c99dc4004$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
const $17b56f3c99dc4004$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $17b56f3c99dc4004$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            $17b56f3c99dc4004$var$iconWrapperStyles.root
        ]),
        children: children
    });
const $17b56f3c99dc4004$var$messageIcons = {
    error: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iZXAi))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($35I2R))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success"
    })
};
const $17b56f3c99dc4004$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $17b56f3c99dc4004$var$messageIcons[appearance];
    const messageRef = (0, $5uXOq.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
    const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($17b56f3c99dc4004$var$MessageWrapperContext);
    (0, $5uXOq.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $bwpsq.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $17b56f3c99dc4004$var$messageAppearanceStyles[appearance]
        ]),
        children: [
            icon && /*#__PURE__*/ (0, $2OMIu.jsx)($17b56f3c99dc4004$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
};
const $17b56f3c99dc4004$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bU9TL.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($17b56f3c99dc4004$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });
const $17b56f3c99dc4004$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bU9TL.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($17b56f3c99dc4004$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    });
const $17b56f3c99dc4004$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bU9TL.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($17b56f3c99dc4004$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ const $17b56f3c99dc4004$var$MessageWrapperContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isWrapper: false
});
const $17b56f3c99dc4004$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($17b56f3c99dc4004$var$MessageWrapperContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: children
        })
    });
};

});
parcelRegister("iZXAi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98606756a92a07f2e7585c76d3cbd084>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd4c24b8075762c6$var$_react = $dd4c24b8075762c6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dd4c24b8075762c6$var$_error = $dd4c24b8075762c6$var$_interopRequireDefault((parcelRequire("65KuH")));

var $dd4c24b8075762c6$var$_error2 = $dd4c24b8075762c6$var$_interopRequireDefault((parcelRequire("hWOvD")));
function $dd4c24b8075762c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd4c24b8075762c6$var$ErrorIcon = (props)=>/*#__PURE__*/ $dd4c24b8075762c6$var$_react.default.createElement($dd4c24b8075762c6$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $dd4c24b8075762c6$var$_error2.default
    }, props));
$dd4c24b8075762c6$var$ErrorIcon.Name = 'ErrorIconMigration';
var $dd4c24b8075762c6$var$_default = module.exports.default = $dd4c24b8075762c6$var$ErrorIcon;

});
parcelRegister("65KuH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d97879d6b889ef4621929c7dd705b0ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $46f7467bbb627311$var$_react = $46f7467bbb627311$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $46f7467bbb627311$var$_baseNew = $46f7467bbb627311$var$_interopRequireDefault((parcelRequire("enEmH")));
function $46f7467bbb627311$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $46f7467bbb627311$var$ErrorIcon = (props)=>/*#__PURE__*/ $46f7467bbb627311$var$_react.default.createElement($46f7467bbb627311$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$46f7467bbb627311$var$ErrorIcon.displayName = 'ErrorIcon';
var $46f7467bbb627311$var$_default = module.exports.default = $46f7467bbb627311$var$ErrorIcon;

});


parcelRegister("35I2R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d345d1980a5e7ce7680063890c36f7e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $24040126ddf3179f$var$_react = $24040126ddf3179f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $24040126ddf3179f$var$_success = $24040126ddf3179f$var$_interopRequireDefault((parcelRequire("aZZu2")));

var $24040126ddf3179f$var$_success2 = $24040126ddf3179f$var$_interopRequireDefault((parcelRequire("8VK5X")));
function $24040126ddf3179f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $24040126ddf3179f$var$SuccessIcon = (props)=>/*#__PURE__*/ $24040126ddf3179f$var$_react.default.createElement($24040126ddf3179f$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $24040126ddf3179f$var$_success2.default
    }, props));
$24040126ddf3179f$var$SuccessIcon.Name = 'SuccessIconMigration';
var $24040126ddf3179f$var$_default = module.exports.default = $24040126ddf3179f$var$SuccessIcon;

});
parcelRegister("aZZu2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b91b2ac4848db507d9eb71a2b738b7fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $801f4b37378597d1$var$_react = $801f4b37378597d1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $801f4b37378597d1$var$_baseNew = $801f4b37378597d1$var$_interopRequireDefault((parcelRequire("enEmH")));
function $801f4b37378597d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $801f4b37378597d1$var$SuccessIcon = (props)=>/*#__PURE__*/ $801f4b37378597d1$var$_react.default.createElement($801f4b37378597d1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$801f4b37378597d1$var$SuccessIcon.displayName = 'SuccessIcon';
var $801f4b37378597d1$var$_default = module.exports.default = $801f4b37378597d1$var$SuccessIcon;

});

parcelRegister("8VK5X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6807671dacf23c57$var$_react = $6807671dacf23c57$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $6807671dacf23c57$var$_success = $6807671dacf23c57$var$_interopRequireDefault((parcelRequire("cFUJ2")));
function $6807671dacf23c57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6807671dacf23c57$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $6807671dacf23c57$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $6807671dacf23c57$var$_success.default
    }));
$6807671dacf23c57$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $6807671dacf23c57$var$_default = module.exports.default = $6807671dacf23c57$var$EditorSuccessIcon;

});


parcelRegister("bU9TL", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $fd4ca56d0899c490$export$3c4232819458a302);

var $5uXOq = parcelRequire("5uXOq");
const $fd4ca56d0899c490$export$3c4232819458a302 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});


parcelRegister("4EHpO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4338501a4bebd545$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("3joPi");

var $jJsBW = parcelRequire("jJsBW");

var $bU9TL = parcelRequire("bU9TL");

var $7folp = parcelRequire("7folp");

var $cGltd = parcelRequire("cGltd");

var $cUUCJ = parcelRequire("cUUCJ");

var $6cAn5 = parcelRequire("6cAn5");
const $4338501a4bebd545$var$fieldWrapperStyles = null;
function $4338501a4bebd545$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $4338501a4bebd545$var$isFunction(x) {
    return typeof x === 'function';
}
function $4338501a4bebd545$var$usePreviousRef(current) {
    const ref = (0, $5uXOq.useRef)(current);
    // will be updated on the next render
    (0, $5uXOq.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $4338501a4bebd545$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $4338501a4bebd545$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, $7folp.FormContext));
    const isDisabled = (0, $5uXOq.useContext)((0, $7folp.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $4338501a4bebd545$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $4338501a4bebd545$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$4338501a4bebd545$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $5uXOq.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $4338501a4bebd545$var$usePreviousRef(state);
    (0, $5uXOq.useEffect)(()=>{
        typeof $6cAn5;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $4338501a4bebd545$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($4338501a4bebd545$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const uid = (0, $jJsBW.useId)();
    const fieldId = (0, $5uXOq.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $bwpsq.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cGltd.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cUUCJ.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bU9TL.FieldId).Provider, {
                value: fieldId,
                children: props.children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("cGltd", function(module, exports) {

$parcel$export(module.exports, "Label", () => $6da09f2418b6f13e$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $6da09f2418b6f13e$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $6da09f2418b6f13e$var$fieldsetLabelStyles = null;
const $6da09f2418b6f13e$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $6da09f2418b6f13e$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("legend", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});

parcelRegister("cUUCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a7ed1e0c62cc06b$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $4a7ed1e0c62cc06b$var$requiredIndicatorStyles = null;
function $4a7ed1e0c62cc06b$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $bwpsq.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("4D12X", function(module, exports) {

$parcel$export(module.exports, "default", () => $37b6bea23dba762b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $37b6bea23dba762b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    boardNameFieldLabel: {
        "id": "software-board-create.modal.form.board-name.board-name-field-label",
        "defaultMessage": "Name this board"
    },
    boardNameFieldPlaceholder: {
        "id": "software-board-create.modal.form.board-name.board-name-field-placeholder",
        "defaultMessage": "Enter a name for this board"
    },
    boardNameEmptyError: {
        "id": "software-board-create.modal.form.board-name.board-name-empty-error",
        "defaultMessage": "Enter a board name"
    },
    boardNameMaxChars: {
        "id": "software-board-create.modal.form.board-name.board-name-max-chars",
        "defaultMessage": "Maximum {maxLength, plural, one {# character} other {# characters}}"
    }
});

});


parcelRegister("7GuB2", function(module, exports) {

$parcel$export(module.exports, "SourceTypePicker", () => $24e530c3fc1a0dce$export$879aac32ab2e56ba);

var $5uXOq = parcelRequire("5uXOq");

var $183uB = parcelRequire("183uB");

var $8Rkzz = parcelRequire("8Rkzz");

var $ew55A = parcelRequire("ew55A");

var $k5Wbc = parcelRequire("k5Wbc");
var $4EHpO = parcelRequire("4EHpO");

var $eWkgo = parcelRequire("eWkgo");
var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $b1kcy = parcelRequire("b1kcy");
var $lau8t = parcelRequire("lau8t");

var $i0vxP = parcelRequire("i0vxP");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $2NRUh = parcelRequire("2NRUh");

var $kJMdt = parcelRequire("kJMdt");

var $c6RuI = parcelRequire("c6RuI");
const $24e530c3fc1a0dce$export$7b060a5763a6e199 = 'VALIDATION_ERROR_EMPTY';
const $24e530c3fc1a0dce$var$formatOptionLabel = (option)=>{
    const { icon: Icon, title: title, description: description } = option;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        alignItems: "center",
        gap: "space.150",
        xcss: $24e530c3fc1a0dce$var$optionStyles
    }, typeof Icon === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew55A.default), {
        src: Icon,
        size: "xsmall",
        appearance: "square",
        borderColor: "transparent"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        label: "",
        name: "projectIcon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        size: "UNSAFE_small",
        color: "color.text.subtlest"
    }, description)));
};
const $24e530c3fc1a0dce$var$SingleValue = (props)=>{
    const { data: { selectedTitle: selectedTitle, icon: Icon } } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b1kcy.components).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        alignItems: "center",
        gap: "space.100"
    }, typeof Icon === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew55A.default), {
        src: Icon,
        size: "xsmall",
        appearance: "square",
        name: "avatar"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, formatMessage(selectedTitle, {
        strong: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
                as: "strong"
            }, children)
    }))));
};
const $24e530c3fc1a0dce$export$77e74af9508bfdeb = ()=>(0, $5uXOq.useState)();
const $24e530c3fc1a0dce$export$879aac32ab2e56ba = ({ resetSourceValue: resetSourceValue })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [selected, setSelected] = $24e530c3fc1a0dce$export$77e74af9508bfdeb();
    const { projectAvatar: projectAvatar } = (0, $2NRUh.useBoardCreateContext)();
    const optionGroups = (0, $5uXOq.useMemo)(()=>(0, $c6RuI.getOptionGroups)({
            formatMessage: formatMessage,
            projectAvatar: projectAvatar
        }), [
        formatMessage,
        projectAvatar
    ]);
    const flattenedOptions = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($183uB)))(optionGroups.map((group)=>group.options)), [
        optionGroups
    ]);
    const handleChange = (0, $5uXOq.useCallback)((onFieldChange)=>(value)=>{
            const option = value?.value || null;
            resetSourceValue();
            setSelected(option);
            onFieldChange(option);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'select',
                action: 'changed'
            }), 'boardSourceType', {
                sourceType: option
            });
        }, [
        createAnalyticsEvent,
        resetSourceValue,
        setSelected
    ]);
    const handleOnMenuOpen = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'select',
            action: 'opened'
        }), 'boardSourceType');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EHpO.default), {
        name: "sourceType",
        label: formatMessage((0, $kJMdt.default).sourceTypeFieldLabel),
        defaultValue: undefined,
        isRequired: true
    }, ({ fieldProps: { onChange: onFieldChange, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i0vxP.default), {
            onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lau8t.default), {
            ...rest,
            "aria-label": formatMessage((0, $kJMdt.default).sourceTypePickerAriaLabel),
            options: optionGroups,
            isSearchable: false,
            formatOptionLabel: $24e530c3fc1a0dce$var$formatOptionLabel,
            components: {
                SingleValue: $24e530c3fc1a0dce$var$SingleValue
            },
            placeholder: formatMessage((0, $kJMdt.default).selectPlaceholder),
            menuPosition: "fixed",
            classNamePrefix: "source-type-picker",
            onChange: handleChange(onFieldChange),
            value: flattenedOptions.find((option)=>option.value === selected),
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            styles: {
                control: (base, state)=>({
                        ...base,
                        borderColor: state.isFocused ? "var(--ds-border-focused, #388BFF)" : base.borderColor,
                        ':focus-within': {
                            boxShadow: state.isFocused ? `inset 0px 0px 0px 1px ${"var(--ds-border-focused, #388BFF)"}` : base.boxShadow
                        },
                        ':hover': {
                            borderColor: state.isFocused ? "var(--ds-border-focused, #388BFF)" : base.borderColor,
                            boxShadow: state.isFocused ? 'elevation.shadow.raised' : base.boxShadow
                        }
                    }),
                option: (base)=>({
                        ...base,
                        // padding inside the option so hover covers the element
                        padding: `${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-300, 24px)"}`
                    }),
                group: (base)=>({
                        ...base,
                        padding: 0,
                        ':not(:last-of-type)': {
                            borderBottomWidth: '2px',
                            borderBottomStyle: 'solid',
                            borderBottomColor: "var(--ds-border, #091E4224)"
                        }
                    }),
                groupHeading: (base)=>({
                        ...base,
                        margin: 0
                    }),
                menuList: (base)=>({
                        ...base,
                        padding: 0,
                        maxHeight: 325
                    })
            },
            onMenuOpen: handleOnMenuOpen
        })), error === $24e530c3fc1a0dce$export$7b060a5763a6e199 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k5Wbc.ErrorMessage), {
            testId: "software-board-create.ui.modal.form.source-type-picker.error"
        }, formatMessage((0, $kJMdt.default).sourceTypeEmptyError))));
};
const $24e530c3fc1a0dce$var$optionStyles = (0, $2s57o.xcss)({
    minHeight: '40px'
});

});
parcelRegister("b1kcy", function(module, exports) {

$parcel$export(module.exports, "components", () => $bf570c186c29adcc$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $bf570c186c29adcc$export$71abc632aa29e6fe);

var $cSGW3 = parcelRequire("cSGW3");

var $gGvqh = parcelRequire("gGvqh");

var $iluyz = parcelRequire("iluyz");

var $6oGQp = parcelRequire("6oGQp");

var $4S2FY = parcelRequire("4S2FY");

var $fW3un = parcelRequire("fW3un");

var $g6y65 = parcelRequire("g6y65");

var $FpaWY = parcelRequire("FpaWY");

var $41aBa = parcelRequire("41aBa");

var $aPWnT = parcelRequire("aPWnT");
const $bf570c186c29adcc$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $6oGQp.ClearIndicator),
    Control: (0, $gGvqh.default),
    DropdownIndicator: (0, $6oGQp.DropdownIndicator),
    Group: (0, $iluyz.default),
    GroupHeading: (0, $iluyz.GroupHeading),
    IndicatorsContainer: (0, $cSGW3.IndicatorsContainer),
    Input: (0, $4S2FY.default),
    LoadingIndicator: (0, $6oGQp.LoadingIndicator),
    Menu: (0, $fW3un.default),
    MenuList: (0, $fW3un.MenuList),
    MenuPortal: (0, $fW3un.MenuPortal),
    LoadingMessage: (0, $fW3un.LoadingMessage),
    NoOptionsMessage: (0, $fW3un.NoOptionsMessage),
    MultiValue: (0, $g6y65.default),
    MultiValueContainer: (0, $g6y65.MultiValueContainer),
    MultiValueLabel: (0, $g6y65.MultiValueLabel),
    MultiValueRemove: (0, $g6y65.MultiValueRemove),
    Option: (0, $FpaWY.default),
    Placeholder: (0, $41aBa.default),
    SelectContainer: (0, $cSGW3.SelectContainer),
    SingleValue: (0, $aPWnT.default),
    ValueContainer: (0, $cSGW3.ValueContainer)
};
const $bf570c186c29adcc$export$71abc632aa29e6fe = (props)=>({
        ...$bf570c186c29adcc$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("cSGW3", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $679454c07f89009f$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $679454c07f89009f$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $679454c07f89009f$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $679454c07f89009f$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $679454c07f89009f$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $679454c07f89009f$export$d0ffd7e649cab6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $fHpHg = parcelRequire("fHpHg");

var $kU1q1 = parcelRequire("kU1q1");

var $b0fMV = parcelRequire("b0fMV");
const $679454c07f89009f$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        position: 'relative',
        font: (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)" : "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        pointerEvents: 'all',
        cursor: isDisabled ? 'not-allowed' : undefined,
        [`${(0, $kU1q1.media).above.xs}`]: {
            font: (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)" : undefined
        }
    });
const $679454c07f89009f$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'container', {
            '--is-disabled': isDisabled,
            '--is-rtl': isRtl
        }),
        ...innerProps
    }, children);
};
const $679454c07f89009f$export$47aec73c7aa6b9aa = ({ isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, selectProps: { controlShouldRenderValue: controlShouldRenderValue } })=>({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden',
        padding: `${isCompact ? 0 : "var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`
    });
const $679454c07f89009f$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
    const styles = (0, $b0fMV.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles.css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: styles.className || 'value-container',
        ...innerProps
    }, children);
};
const $679454c07f89009f$export$9d74e3c8b5868ad7 = ()=>({
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0,
        paddingRight: "var(--ds-space-050, 4px)"
    });
const $679454c07f89009f$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'indicatorsContainer', {
            indicators: true
        }),
        ...innerProps
    }, children);
};

});
parcelRegister("b0fMV", function(module, exports) {

$parcel$export(module.exports, "noop", () => $edcdeb7b1e79d8a8$export$8793edee2d425525);
$parcel$export(module.exports, "classNames", () => $edcdeb7b1e79d8a8$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "cleanValue", () => $edcdeb7b1e79d8a8$export$33f062f47f21a01);
$parcel$export(module.exports, "cleanCommonProps", () => $edcdeb7b1e79d8a8$export$8e9fd4287627890c);
$parcel$export(module.exports, "getStyleProps", () => $edcdeb7b1e79d8a8$export$26417cabd806a658);
$parcel$export(module.exports, "handleInputChange", () => $edcdeb7b1e79d8a8$export$2096bae78ecda911);
$parcel$export(module.exports, "isDocumentElement", () => $edcdeb7b1e79d8a8$export$d8a62a489b442872);
$parcel$export(module.exports, "normalizedHeight", () => $edcdeb7b1e79d8a8$export$2e0654fad740d2e4);
$parcel$export(module.exports, "getScrollTop", () => $edcdeb7b1e79d8a8$export$c4a223a8ba9e4ea5);
$parcel$export(module.exports, "scrollTo", () => $edcdeb7b1e79d8a8$export$3f99968195accfaf);
$parcel$export(module.exports, "getScrollParent", () => $edcdeb7b1e79d8a8$export$cfa2225e87938781);
$parcel$export(module.exports, "animatedScrollTo", () => $edcdeb7b1e79d8a8$export$858c30343199f3af);
$parcel$export(module.exports, "scrollIntoView", () => $edcdeb7b1e79d8a8$export$53a0910f038337bd);
$parcel$export(module.exports, "getBoundingClientObj", () => $edcdeb7b1e79d8a8$export$7807c2a424c2f6d1);
$parcel$export(module.exports, "isTouchCapable", () => $edcdeb7b1e79d8a8$export$56963d77dbffdde7);
$parcel$export(module.exports, "isMobileDevice", () => $edcdeb7b1e79d8a8$export$44f917bf91becd01);
$parcel$export(module.exports, "supportsPassiveEvents", () => $edcdeb7b1e79d8a8$export$b0622a6911dbeaf5);
$parcel$export(module.exports, "notNullish", () => $edcdeb7b1e79d8a8$export$aedb69ff3e31596c);
$parcel$export(module.exports, "valueTernary", () => $edcdeb7b1e79d8a8$export$40fb9515c784cc3b);
$parcel$export(module.exports, "singleValueAsValue", () => $edcdeb7b1e79d8a8$export$dea4763e29237f4c);
$parcel$export(module.exports, "multiValueAsValue", () => $edcdeb7b1e79d8a8$export$d1ca752ec761b95b);
$parcel$export(module.exports, "removeProps", () => $edcdeb7b1e79d8a8$export$4213b25a1c4e877);
const $edcdeb7b1e79d8a8$export$8793edee2d425525 = ()=>{};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $edcdeb7b1e79d8a8$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $edcdeb7b1e79d8a8$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$edcdeb7b1e79d8a8$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
const $edcdeb7b1e79d8a8$export$33f062f47f21a01 = (value)=>{
    if ($edcdeb7b1e79d8a8$var$isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
const $edcdeb7b1e79d8a8$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};
const $edcdeb7b1e79d8a8$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
function $edcdeb7b1e79d8a8$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $edcdeb7b1e79d8a8$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $edcdeb7b1e79d8a8$export$2e0654fad740d2e4(el) {
    if ($edcdeb7b1e79d8a8$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $edcdeb7b1e79d8a8$export$c4a223a8ba9e4ea5(el) {
    if ($edcdeb7b1e79d8a8$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $edcdeb7b1e79d8a8$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($edcdeb7b1e79d8a8$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $edcdeb7b1e79d8a8$export$cfa2225e87938781(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $edcdeb7b1e79d8a8$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $edcdeb7b1e79d8a8$export$858c30343199f3af(element, to, duration = 200, callback = $edcdeb7b1e79d8a8$export$8793edee2d425525) {
    const start = $edcdeb7b1e79d8a8$export$c4a223a8ba9e4ea5(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $edcdeb7b1e79d8a8$var$easeOutCubic(currentTime, start, change, duration);
        $edcdeb7b1e79d8a8$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $edcdeb7b1e79d8a8$export$53a0910f038337bd(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $edcdeb7b1e79d8a8$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $edcdeb7b1e79d8a8$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $edcdeb7b1e79d8a8$export$7807c2a424c2f6d1(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $edcdeb7b1e79d8a8$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $edcdeb7b1e79d8a8$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $edcdeb7b1e79d8a8$var$passiveOptionAccessed = false;
const $edcdeb7b1e79d8a8$var$options = {
    get passive () {
        return $edcdeb7b1e79d8a8$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $edcdeb7b1e79d8a8$var$w = typeof window !== 'undefined' ? window : {};
if ($edcdeb7b1e79d8a8$var$w.addEventListener && $edcdeb7b1e79d8a8$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $edcdeb7b1e79d8a8$var$w.addEventListener('p', $edcdeb7b1e79d8a8$export$8793edee2d425525, $edcdeb7b1e79d8a8$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $edcdeb7b1e79d8a8$var$w.removeEventListener('p', $edcdeb7b1e79d8a8$export$8793edee2d425525, false);
}
const $edcdeb7b1e79d8a8$export$b0622a6911dbeaf5 = $edcdeb7b1e79d8a8$var$passiveOptionAccessed;
function $edcdeb7b1e79d8a8$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $edcdeb7b1e79d8a8$var$isArray(arg) {
    return Array.isArray(arg);
}
function $edcdeb7b1e79d8a8$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $edcdeb7b1e79d8a8$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $edcdeb7b1e79d8a8$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
const $edcdeb7b1e79d8a8$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};

});


parcelRegister("gGvqh", function(module, exports) {

$parcel$export(module.exports, "css", () => $fc91e92c64db0b1d$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $fc91e92c64db0b1d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $fc91e92c64db0b1d$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, isCompact: isCompact, appearance: appearance })=>{
    let borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
    let backgroundColor = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)";
    let backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
    let borderColorHover = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
    if (isDisabled) {
        backgroundColor = "var(--ds-background-disabled, #091E4208)";
        borderColor = "var(--ds-background-disabled, #091E4208)";
    }
    if (isInvalid) {
        borderColor = "var(--ds-border-danger, #E2483D)";
        borderColorHover = "var(--ds-border-danger, #E2483D)";
    }
    const transitionDuration = '200ms';
    if (appearance === 'subtle') {
        borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : 'transparent';
        backgroundColor = isFocused ? "var(--ds-surface, #FFFFFF)" : 'transparent';
        backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
    }
    if (appearance === 'none') {
        borderColor = 'transparent';
        backgroundColor = 'transparent';
        backgroundColorHover = 'transparent';
        borderColorHover = 'transparent';
    }
    return {
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        outline: '0 !important',
        position: 'relative',
        // Turn pointer events off when disabled - this makes it so hover etc don't work.
        pointerEvents: isDisabled ? 'none' : undefined,
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderStyle: 'solid',
        borderRadius: "var(--ds-border-radius-100, 3px)",
        borderWidth: "var(--ds-border-width, 1px)",
        boxShadow: isInvalid ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
        '&:focus-within': {
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
        },
        minHeight: isCompact ? 32 : 40,
        padding: 0,
        transition: `background-color ${transitionDuration} ease-in-out,
border-color ${transitionDuration} ease-in-out`,
        '::-webkit-scrollbar': {
            height: 8,
            width: 8
        },
        '::-webkit-scrollbar-corner': {
            display: 'none'
        },
        ':hover': {
            '::-webkit-scrollbar-thumb': {
                // scrollbars occur only if the user passes in a custom component with overflow: scroll
                backgroundColor: 'rgba(0,0,0,0.2)'
            },
            cursor: 'pointer',
            backgroundColor: backgroundColorHover,
            borderColor: borderColorHover
        },
        '::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'rgba(0,0,0,0.4)'
        }
    };
};
const $fc91e92c64db0b1d$var$Control = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        ...(0, $b0fMV.getStyleProps)(props, 'control', {
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen
        }),
        ...innerProps,
        "aria-disabled": isDisabled || undefined
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fc91e92c64db0b1d$export$2e2bcd8739ae039 = $fc91e92c64db0b1d$var$Control;

});

parcelRegister("iluyz", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $4652dd5e4b6c9504$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $4652dd5e4b6c9504$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $4652dd5e4b6c9504$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $4652dd5e4b6c9504$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $4652dd5e4b6c9504$export$b6794329c1460634 = ({})=>({
        paddingBottom: "var(--ds-space-100, 8px)",
        paddingTop: "var(--ds-space-100, 8px)"
    });
const $4652dd5e4b6c9504$var$Group = (props)=>{
    const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'group', {
            group: true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Heading, {
        ...headingProps,
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }, label), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", null, children));
};
const $4652dd5e4b6c9504$export$e5a7fbb542efcb7d = ({})=>({
        label: 'group',
        cursor: 'default',
        display: 'block',
        marginBottom: '0.25em',
        paddingLeft: "var(--ds-space-150, 12px)",
        paddingRight: "var(--ds-space-150, 12px)",
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        color: "var(--ds-text-subtle, #44546F)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        textTransform: 'none'
    });
const $4652dd5e4b6c9504$export$85c8b41a3cd87edc = (props)=>{
    const { data: data, ...innerProps } = (0, $b0fMV.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'groupHeading', {
            'group-heading': true
        }),
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4652dd5e4b6c9504$export$2e2bcd8739ae039 = $4652dd5e4b6c9504$var$Group;

});

parcelRegister("6oGQp", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $c9370124461878f7$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $c9370124461878f7$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $c9370124461878f7$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $c9370124461878f7$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $c9370124461878f7$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $c9370124461878f7$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $dGKFs = parcelRequire("dGKFs");

var $7K2aG = parcelRequire("7K2aG");

var $2Eqc8 = parcelRequire("2Eqc8");
var $gVM6m = parcelRequire("gVM6m");
var $2s57o = parcelRequire("2s57o");

var $clxo5 = parcelRequire("clxo5");

var $b0fMV = parcelRequire("b0fMV");
// ==============================
// Dropdown & Clear Icons
// ==============================
const $c9370124461878f7$var$iconContainerStyles = (0, $2s57o.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $c9370124461878f7$var$dropdownWrapperStyles = (0, $2s57o.xcss)({
    padding: 'space.075'
});
const $c9370124461878f7$export$e1687335805e1230 = ({ isCompact: isCompact, isDisabled: isDisabled })=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtle, #44546F)",
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
        ':hover': {
            color: "var(--ds-text-subtle, #44546F)"
        }
    });
const $c9370124461878f7$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'dropdownIndicator', {
            indicator: true,
            'dropdown-indicator': true
        }),
        ...innerProps
    }, children ? children : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2Eqc8.default), {
        as: "span",
        xcss: $c9370124461878f7$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dGKFs))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
};
const $c9370124461878f7$export$9c0419fd944c1def = ({ isCompact: isCompact })=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        color: "var(--ds-text-subtlest, #626F86)",
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
        ':hover': {
            color: "var(--ds-text-subtle, #44546F)"
        }
    });
const $c9370124461878f7$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear' } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'clearIndicator', {
            indicator: true,
            'clear-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gVM6m.default), {
        xcss: $c9370124461878f7$var$iconContainerStyles,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7K2aG))), {
        label: "",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
};
const $c9370124461878f7$export$1d3f24cde248e6b5 = ({ isCompact: isCompact })=>({
        label: 'loadingIndicator',
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`
    });
const $c9370124461878f7$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)({
            ...restProps,
            innerProps: innerProps,
            isRtl: isRtl,
            size: size
        }, 'loadingIndicator', {
            indicator: true,
            'loading-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $clxo5.default), {
        size: "small"
    }));
};

});
parcelRegister("7K2aG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7da2857c3151a92889bed61f5baa1334>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a2e8376ca30e11c$var$_react = $5a2e8376ca30e11c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5a2e8376ca30e11c$var$_crossCircle = $5a2e8376ca30e11c$var$_interopRequireDefault((parcelRequire("8wCU9")));

var $5a2e8376ca30e11c$var$_selectClear = $5a2e8376ca30e11c$var$_interopRequireDefault((parcelRequire("85kPS")));
function $5a2e8376ca30e11c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a2e8376ca30e11c$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $5a2e8376ca30e11c$var$_react.default.createElement($5a2e8376ca30e11c$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $5a2e8376ca30e11c$var$_selectClear.default
    }, props));
$5a2e8376ca30e11c$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $5a2e8376ca30e11c$var$_default = module.exports.default = $5a2e8376ca30e11c$var$CrossCircleIcon;

});
parcelRegister("8wCU9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23b3104937a360e799abf4f0ea698b9a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $634f7d853690f284$var$_react = $634f7d853690f284$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $634f7d853690f284$var$_baseNew = $634f7d853690f284$var$_interopRequireDefault((parcelRequire("enEmH")));
function $634f7d853690f284$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $634f7d853690f284$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $634f7d853690f284$var$_react.default.createElement($634f7d853690f284$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$634f7d853690f284$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $634f7d853690f284$var$_default = module.exports.default = $634f7d853690f284$var$CrossCircleIcon;

});

parcelRegister("85kPS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e2ef3e5407a9744$var$_react = $5e2ef3e5407a9744$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $5e2ef3e5407a9744$var$_crossCircle = $5e2ef3e5407a9744$var$_interopRequireDefault((parcelRequire("hvAON")));
function $5e2ef3e5407a9744$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5e2ef3e5407a9744$var$SelectClearIcon = (props)=>/*#__PURE__*/ $5e2ef3e5407a9744$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $5e2ef3e5407a9744$var$_crossCircle.default
    }));
$5e2ef3e5407a9744$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $5e2ef3e5407a9744$var$_default = module.exports.default = $5e2ef3e5407a9744$var$SelectClearIcon;

});



parcelRegister("4S2FY", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $c70f729c4b739a40$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $c70f729c4b739a40$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $c70f729c4b739a40$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value })=>({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : '',
        ...$c70f729c4b739a40$var$containerStyle,
        margin: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingTop: "var(--ds-space-025, 2px)",
        color: "var(--ds-text, #172B4D)"
    });
const $c70f729c4b739a40$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
const $c70f729c4b739a40$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': {
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre',
        ...$c70f729c4b739a40$var$spacingStyle
    }
};
const $c70f729c4b739a40$var$inputStyle = (isHidden)=>({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%',
        ...$c70f729c4b739a40$var$spacingStyle
    });
const $c70f729c4b739a40$var$Input = (props)=>{
    const { cx: cx, value: value } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $b0fMV.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'input', {
            'input-container': true
        }),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $c70f729c4b739a40$var$inputStyle(isHidden),
        disabled: isDisabled,
        "data-testid": dataId,
        ...innerProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c70f729c4b739a40$export$2e2bcd8739ae039 = $c70f729c4b739a40$var$Input;

});

parcelRegister("fW3un", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $d762f5ed921736bb$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $d762f5ed921736bb$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $d762f5ed921736bb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $d762f5ed921736bb$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $d762f5ed921736bb$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "noOptionsMessageCSS", () => $d762f5ed921736bb$export$cf0e22534d8b0074);
$parcel$export(module.exports, "loadingMessageCSS", () => $d762f5ed921736bb$export$98ec46397a8cb3cd);
$parcel$export(module.exports, "NoOptionsMessage", () => $d762f5ed921736bb$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $d762f5ed921736bb$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $d762f5ed921736bb$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $d762f5ed921736bb$export$793392f970497feb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $g9RrE = parcelRequire("g9RrE");

var $7nsd3 = parcelRequire("7nsd3");

var $hrqx3 = parcelRequire("hrqx3");

var $fHpHg = parcelRequire("fHpHg");

var $6eFvr = parcelRequire("6eFvr");

var $b0fMV = parcelRequire("b0fMV");
function $d762f5ed921736bb$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $b0fMV.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight, top: scrollParentTop } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $b0fMV.normalizedHeight)(scrollParent);
    const scrollTop = (0, $b0fMV.getScrollTop)(scrollParent);
    // use menuTop - scrollParentTop for the actual top space of menu in the scroll container
    const menuTopFromParent = (0, $fHpHg.fg)('design-system-select-fix-placement') ? menuTop - scrollParentTop : menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $b0fMV.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $b0fMV.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $b0fMV.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $b0fMV.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $b0fMV.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
function $d762f5ed921736bb$var$alignToControl(placement) {
    const placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
const $d762f5ed921736bb$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $d762f5ed921736bb$export$a228922d5ca42a79 = ({ placement: placement })=>({
        label: 'menu',
        [$d762f5ed921736bb$var$alignToControl(placement)]: '100%',
        position: 'absolute',
        width: '100%',
        zIndex: 1,
        borderRadius: "var(--ds-border-radius, 4px)",
        marginBottom: "var(--ds-space-100, 8px)",
        marginTop: "var(--ds-space-100, 8px)",
        backgroundColor: "var(--ds-surface-overlay, white)",
        boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
    });
const $d762f5ed921736bb$var$PortalPlacementContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $d762f5ed921736bb$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($d762f5ed921736bb$var$PortalPlacementContext) || {};
    const ref = (0, $5uXOq.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $5uXOq.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $hrqx3.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $d762f5ed921736bb$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $d762f5ed921736bb$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $d762f5ed921736bb$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'menu', {
            menu: true
        }),
        ref: innerRef,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d762f5ed921736bb$export$2e2bcd8739ae039 = $d762f5ed921736bb$var$Menu;
const $d762f5ed921736bb$export$abafed69cff95d5e = ({ maxHeight: maxHeight })=>({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch',
        paddingTop: "var(--ds-space-100, 8px)",
        paddingBottom: "var(--ds-space-100, 8px)"
    });
const $d762f5ed921736bb$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'menuList', {
            'menu-list': true,
            'menu-list--is-multi': isMulti
        }),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1
    }, children);
};
// ==============================
// Menu Notices
// ==============================
const $d762f5ed921736bb$var$noticeCSS = ({})=>({
        textAlign: 'center',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    });
const $d762f5ed921736bb$export$cf0e22534d8b0074 = $d762f5ed921736bb$var$noticeCSS;
const $d762f5ed921736bb$export$98ec46397a8cb3cd = $d762f5ed921736bb$var$noticeCSS;
const $d762f5ed921736bb$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'noOptionsMessage', {
            'menu-notice': true,
            'menu-notice--no-options': true
        }),
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6eFvr.default), {
        color: "color.text.subtle"
    }, children));
};
const $d762f5ed921736bb$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'loadingMessage', {
            'menu-notice': true,
            'menu-notice--loading': true
        }),
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6eFvr.default), {
        color: "color.text.subtle"
    }, children));
};
const $d762f5ed921736bb$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    });
const $d762f5ed921736bb$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
    const menuPortalRef = (0, $5uXOq.useRef)(null);
    const cleanupRef = (0, $5uXOq.useRef)(null);
    const [placement, setPortalPlacement] = (0, $5uXOq.useState)($d762f5ed921736bb$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
    const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $b0fMV.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $hrqx3.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $g9RrE.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $hrqx3.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: setMenuPortalElement,
        ...(0, $b0fMV.getStyleProps)({
            ...props,
            offset: computedPosition.offset,
            position: menuPosition,
            rect: computedPosition.rect
        }, 'menuPortal', {
            'menu-portal': true
        }),
        ...innerProps
    }, children);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($d762f5ed921736bb$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

});
parcelRegister("g9RrE", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $bc36f1aefc070984$export$deee3a793edee05f);

var $gSfPF = parcelRequire("gSfPF");
var $cVo0M = parcelRequire("cVo0M");

var $cVo0M = parcelRequire("cVo0M");

var $f8LYQ = parcelRequire("f8LYQ");
function $bc36f1aefc070984$var$getCssDimensions(element) {
    const css = (0, $f8LYQ.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $f8LYQ.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $cVo0M.round)(width) !== offsetWidth || (0, $cVo0M.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $bc36f1aefc070984$var$unwrapElement(element) {
    return !(0, $f8LYQ.isElement)(element) ? element.contextElement : element;
}
function $bc36f1aefc070984$var$getScale(element) {
    const domElement = $bc36f1aefc070984$var$unwrapElement(element);
    if (!(0, $f8LYQ.isHTMLElement)(domElement)) return (0, $cVo0M.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
    let x = ($ ? (0, $cVo0M.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $cVo0M.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $bc36f1aefc070984$var$noOffsets = /*#__PURE__*/ (0, $cVo0M.createCoords)(0);
function $bc36f1aefc070984$var$getVisualOffsets(element) {
    const win = (0, $f8LYQ.getWindow)(element);
    if (!(0, $f8LYQ.isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $f8LYQ.getWindow)(element)) return false;
    return isFixed;
}
function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $bc36f1aefc070984$var$unwrapElement(element);
    let scale = (0, $cVo0M.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $f8LYQ.isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
        } else scale = $bc36f1aefc070984$var$getScale(element);
    }
    const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, $cVo0M.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $f8LYQ.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $f8LYQ.isElement)(offsetParent) ? (0, $f8LYQ.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $f8LYQ.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $f8LYQ.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $f8LYQ.getWindow)(currentIFrame);
            currentIFrame = (0, $f8LYQ.getFrameElement)(currentWin);
        }
    }
    return (0, $cVo0M.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $f8LYQ.getNodeScroll)(element).scrollLeft;
    if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, $f8LYQ.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $f8LYQ.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $f8LYQ.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $cVo0M.createCoords)(1);
    const offsets = (0, $cVo0M.createCoords)(0);
    const isOffsetParentAnElement = (0, $f8LYQ.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f8LYQ.getNodeName)(offsetParent) !== 'body' || (0, $f8LYQ.isOverflowElement)(documentElement)) scroll = (0, $f8LYQ.getNodeScroll)(offsetParent);
        if ((0, $f8LYQ.isHTMLElement)(offsetParent)) {
            const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
            scale = $bc36f1aefc070984$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, $cVo0M.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $bc36f1aefc070984$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $bc36f1aefc070984$var$getDocumentRect(element) {
    const html = (0, $f8LYQ.getDocumentElement)(element);
    const scroll = (0, $f8LYQ.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $cVo0M.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $cVo0M.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $f8LYQ.getComputedStyle)(body).direction === 'rtl') x += (0, $cVo0M.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
    const win = (0, $f8LYQ.getWindow)(element);
    const html = (0, $f8LYQ.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $f8LYQ.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $f8LYQ.isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, $cVo0M.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, $f8LYQ.getDocumentElement)(element));
    else if ((0, $f8LYQ.isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $cVo0M.rectToClientRect)(rect);
}
function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $f8LYQ.getParentNode)(element);
    if (parentNode === stopNode || !(0, $f8LYQ.isElement)(parentNode) || (0, $f8LYQ.isLastTraversableNode)(parentNode)) return false;
    return (0, $f8LYQ.getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $f8LYQ.getOverflowAncestors)(element, [], false).filter((el)=>(0, $f8LYQ.isElement)(el) && (0, $f8LYQ.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $f8LYQ.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $f8LYQ.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $f8LYQ.isElement)(currentNode) && !(0, $f8LYQ.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $f8LYQ.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $f8LYQ.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $f8LYQ.isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $f8LYQ.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $bc36f1aefc070984$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $f8LYQ.isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $cVo0M.max)(rect.top, accRect.top);
        accRect.right = (0, $cVo0M.min)(rect.right, accRect.right);
        accRect.bottom = (0, $cVo0M.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cVo0M.max)(rect.left, accRect.left);
        return accRect;
    }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $bc36f1aefc070984$var$getDimensions(element) {
    const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $f8LYQ.isHTMLElement)(offsetParent);
    const documentElement = (0, $f8LYQ.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $cVo0M.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f8LYQ.getNodeName)(offsetParent) !== 'body' || (0, $f8LYQ.isOverflowElement)(documentElement)) scroll = (0, $f8LYQ.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, $cVo0M.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $bc36f1aefc070984$var$isStaticPositioned(element) {
    return (0, $f8LYQ.getComputedStyle)(element).position === 'static';
}
function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $f8LYQ.isHTMLElement)(element) || (0, $f8LYQ.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $f8LYQ.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
    const win = (0, $f8LYQ.getWindow)(element);
    if ((0, $f8LYQ.isTopLayer)(element)) return win;
    if (!(0, $f8LYQ.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $f8LYQ.getParentNode)(element);
        while(svgOffsetParent && !(0, $f8LYQ.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $f8LYQ.isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $f8LYQ.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $f8LYQ.isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $f8LYQ.isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, $f8LYQ.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $f8LYQ.getContainingBlock)(element) || win;
}
const $bc36f1aefc070984$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $bc36f1aefc070984$var$isRTL(element) {
    return (0, $f8LYQ.getComputedStyle)(element).direction === 'rtl';
}
const $bc36f1aefc070984$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $f8LYQ.getDocumentElement,
    getClippingRect: $bc36f1aefc070984$var$getClippingRect,
    getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
    getElementRects: $bc36f1aefc070984$var$getElementRects,
    getClientRects: $bc36f1aefc070984$var$getClientRects,
    getDimensions: $bc36f1aefc070984$var$getDimensions,
    getScale: $bc36f1aefc070984$var$getScale,
    isElement: $f8LYQ.isElement,
    isRTL: $bc36f1aefc070984$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $bc36f1aefc070984$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $f8LYQ.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $cVo0M.floor)(top);
        const insetRight = (0, $cVo0M.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $cVo0M.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $cVo0M.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $cVo0M.max)(0, (0, $cVo0M.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $f8LYQ.getOverflowAncestors)(referenceEl) : [],
        ...(0, $f8LYQ.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, $gSfPF.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $bc36f1aefc070984$export$cc800923e997bb8 = (0, $gSfPF.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, $gSfPF.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $bc36f1aefc070984$export$fba63a578e423eb = (0, $gSfPF.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, $gSfPF.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $bc36f1aefc070984$export$346677f925de839c = (0, $gSfPF.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $bc36f1aefc070984$export$fe8985bb6374093c = (0, $gSfPF.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, $gSfPF.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, $gSfPF.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, $gSfPF.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $bc36f1aefc070984$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $gSfPF.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("gSfPF", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $c48df878d8118962$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $c48df878d8118962$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $c48df878d8118962$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $c48df878d8118962$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $c48df878d8118962$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $c48df878d8118962$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $c48df878d8118962$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $c48df878d8118962$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $c48df878d8118962$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $c48df878d8118962$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $c48df878d8118962$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("cVo0M")).rectToClientRect);

var $cVo0M = parcelRequire("cVo0M");
function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $cVo0M.getSideAxis)(placement);
    const alignmentAxis = (0, $cVo0M.getAlignmentAxis)(placement);
    const alignLength = (0, $cVo0M.getAxisLength)(alignmentAxis);
    const side = (0, $cVo0M.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $cVo0M.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $cVo0M.evaluate)(options, state);
    const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $cVo0M.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $cVo0M.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $cVo0M.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $cVo0M.getAlignmentAxis)(placement);
            const length = (0, $cVo0M.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $cVo0M.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $cVo0M.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $cVo0M.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $cVo0M.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $cVo0M.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $cVo0M.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $cVo0M.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $cVo0M.getAlignment)(placement) === alignment || (autoAlignment ? (0, $cVo0M.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $cVo0M.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $cVo0M.placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $cVo0M.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $cVo0M.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $cVo0M.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $cVo0M.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $cVo0M.getSide)(placement);
            const initialSideAxis = (0, $cVo0M.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $cVo0M.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $cVo0M.getOppositePlacement)(initialPlacement)
            ] : (0, $cVo0M.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $cVo0M.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $cVo0M.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $cVo0M.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
    return (0, $cVo0M.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $c48df878d8118962$var$getBoundingRect(rects) {
    const minX = (0, $cVo0M.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $cVo0M.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $cVo0M.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $cVo0M.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $c48df878d8118962$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $cVo0M.rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $cVo0M.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $cVo0M.rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $cVo0M.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $cVo0M.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $cVo0M.getSide)(placement) === 'left';
                    const maxRight = (0, $cVo0M.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $cVo0M.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $c48df878d8118962$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $cVo0M.getSide)(placement);
    const alignment = (0, $cVo0M.getAlignment)(placement);
    const isVertical = (0, $cVo0M.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $cVo0M.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $c48df878d8118962$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $cVo0M.getSideAxis)((0, $cVo0M.getSide)(placement));
            const mainAxis = (0, $cVo0M.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $cVo0M.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $cVo0M.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $cVo0M.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $cVo0M.getSideAxis)(placement);
            const mainAxis = (0, $cVo0M.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $cVo0M.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $cVo0M.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $c48df878d8118962$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $cVo0M.getSide)(placement);
            const alignment = (0, $cVo0M.getAlignment)(placement);
            const isYAxis = (0, $cVo0M.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $cVo0M.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $cVo0M.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $cVo0M.max)(overflow.left, 0);
                const xMax = (0, $cVo0M.max)(overflow.right, 0);
                const yMin = (0, $cVo0M.max)(overflow.top, 0);
                const yMax = (0, $cVo0M.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $cVo0M.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $cVo0M.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("cVo0M", function(module, exports) {

$parcel$export(module.exports, "sides", () => $968d6f1d7e429938$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $968d6f1d7e429938$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $968d6f1d7e429938$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $968d6f1d7e429938$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $968d6f1d7e429938$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $968d6f1d7e429938$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $968d6f1d7e429938$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $968d6f1d7e429938$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $968d6f1d7e429938$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $968d6f1d7e429938$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $968d6f1d7e429938$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $968d6f1d7e429938$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $968d6f1d7e429938$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $968d6f1d7e429938$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $968d6f1d7e429938$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $968d6f1d7e429938$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $968d6f1d7e429938$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $968d6f1d7e429938$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $968d6f1d7e429938$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $968d6f1d7e429938$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $968d6f1d7e429938$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $968d6f1d7e429938$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $968d6f1d7e429938$export$803cd8101b6c182b = /*#__PURE__*/ $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $968d6f1d7e429938$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $968d6f1d7e429938$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
    return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
}
function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
    return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
}
function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
    const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
    const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
    const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
    return [
        $968d6f1d7e429938$export$2b182c584985588b(placement),
        oppositePlacement,
        $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
    ];
}
function $968d6f1d7e429938$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
}
function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
    let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
    }
    return list;
}
function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
}
function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("f8LYQ", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $b05cd24baa7455b6$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $b05cd24baa7455b6$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $b05cd24baa7455b6$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $b05cd24baa7455b6$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $b05cd24baa7455b6$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $b05cd24baa7455b6$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $b05cd24baa7455b6$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $b05cd24baa7455b6$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $b05cd24baa7455b6$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $b05cd24baa7455b6$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $b05cd24baa7455b6$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $b05cd24baa7455b6$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $b05cd24baa7455b6$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $b05cd24baa7455b6$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $b05cd24baa7455b6$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $b05cd24baa7455b6$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $b05cd24baa7455b6$export$7bf1f8740e3e34af);
function $b05cd24baa7455b6$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $b05cd24baa7455b6$export$651544f548703224(node) {
    if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $b05cd24baa7455b6$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
}
function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
}
function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
}
function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
    if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($b05cd24baa7455b6$export$651544f548703224(element));
}
function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
    const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $b05cd24baa7455b6$export$940d8225183e1404(element) {
    let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
    while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
        if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $b05cd24baa7455b6$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($b05cd24baa7455b6$export$651544f548703224(node));
}
function $b05cd24baa7455b6$export$3735103072e4a80(element) {
    return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
    if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
    if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $b05cd24baa7455b6$export$e495491855dc5418(node);
    return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
    const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
    if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
    return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
}
function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("hrqx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2989fd9beaabfa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;

});


parcelRegister("g6y65", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $81905f6290625738$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $81905f6290625738$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $81905f6290625738$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $81905f6290625738$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $81905f6290625738$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $81905f6290625738$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $81905f6290625738$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $85kPS = parcelRequire("85kPS");

var $gANiX = parcelRequire("gANiX");

var $fHpHg = parcelRequire("fHpHg");

var $2Eqc8 = parcelRequire("2Eqc8");
var $2s57o = parcelRequire("2s57o");

var $b0fMV = parcelRequire("b0fMV");
function $81905f6290625738$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $81905f6290625738$export$23c213f7717186af = ({ isDisabled: isDisabled, isFocused: isFocused })=>{
    let backgroundColor;
    let color;
    if (isDisabled) {
        // Use the basic neutral background so it is slightly separate from the
        // field's background
        backgroundColor = "var(--ds-background-neutral, #091E420F)";
        color = "var(--ds-text-disabled, #091E424F)";
    } else if (isFocused) {
        backgroundColor = "var(--ds-background-selected, #E9F2FF)";
        color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
    } else {
        backgroundColor = (0, $fHpHg.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : "var(--ds-background-neutral, #091E420F)";
        color = "var(--ds-text, hsl(0, 0%, 20%))";
    }
    return {
        label: 'multiValue',
        display: 'flex',
        minWidth: 0,
        // resolves flex/text-overflow bug
        margin: "var(--ds-space-025, 2px)",
        borderRadius: "var(--ds-border-radius-050, 2px)",
        backgroundColor: backgroundColor,
        boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
        maxWidth: '100%',
        '@media screen and (-ms-high-contrast: active)': {
            border: isFocused ? '1px solid transparent' : 'none'
        },
        color: color,
        ...(0, $fHpHg.fg)('platform-component-visual-refresh') && {
            borderRadius: "var(--ds-border-radius-100, 4px)",
            // Hardcode this color for visual refresh as there is no token color yet
            borderColor: '#B7B9BE',
            borderWidth: "var(--ds-border-width, 1px)",
            borderStyle: 'solid',
            backgroundColor: "var(--ds-background-input, #FFFFFF)"
        }
    };
};
const $81905f6290625738$export$f40612612e0af964 = ({ cropWithEllipsis: cropWithEllipsis, isDisabled: isDisabled })=>({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap',
        borderRadius: "var(--ds-border-radius-050, 2px)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '85%',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        padding: "var(--ds-space-025, 2px)",
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : 'inherit',
        paddingLeft: "var(--ds-space-075, 6px)",
        ...(0, $fHpHg.fg)('platform-component-visual-refresh') && {
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: "var(--ds-space-050, 4px)"
        }
    });
const $81905f6290625738$export$283467f6c4ac142b = ({ isFocused: isFocused })=>({
        alignItems: 'center',
        display: 'flex',
        backgroundColor: isFocused ? "var(--ds-UNSAFE-transparent, transparent)" : undefined,
        fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
        paddingLeft: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-025, 2px)",
        borderRadius: '0px 2px 2px 0px',
        // DSP-6470 we should style like Tag once we have the :has selector
        ':hover': {
            backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)",
            fill: "var(--ds-text-danger, #000)"
        },
        ':active': {
            backgroundColor: "var(--ds-background-danger-pressed, #FD9891)",
            fill: "var(--ds-text-danger, #000)"
        },
        ...(0, $fHpHg.fg)('platform-component-visual-refresh') && {
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            border: 'none',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'center',
            appearance: 'none',
            borderRadius: "var(--ds-border-radius, 4px)",
            color: "var(--ds-text, #172B4D)",
            padding: "var(--ds-space-025, 2px)",
            marginRight: "var(--ds-space-025, 2px)",
            ':focus-visible': {
                outlineOffset: "var(--ds-space-negative-025, -2px)"
            },
            ':hover': {
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
            },
            ':active': {
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
            }
        }
    });
// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $81905f6290625738$var$MultiValueGeneric = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", innerProps, children);
const $81905f6290625738$export$cf9cf2a30a59265c = $81905f6290625738$var$MultiValueGeneric;
const $81905f6290625738$export$544aeea2a5ce08ee = $81905f6290625738$var$MultiValueGeneric;
const $81905f6290625738$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $81905f6290625738$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $81905f6290625738$var$iconWrapperStyles = (0, $2s57o.xcss)({
    padding: 'space.025'
});
const $81905f6290625738$var$renderIcon = ()=>{
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $fHpHg.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gANiX))), {
        label: "",
        color: "currentColor"
    });
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $fHpHg.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2Eqc8.default), {
        xcss: $81905f6290625738$var$iconWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gANiX))), {
        label: "",
        color: "currentColor"
    }));
    return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($85kPS))), {
        label: "",
        primaryColor: "transparent",
        size: "small",
        secondaryColor: "inherit"
    }));
};
function $81905f6290625738$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, innerProps: innerProps }) {
    return(// The Remove button is intentionally excluded from the tab order, please avoid assigning a non-negative tabIndex to it. Context: https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+Options+on+an+Input+Field
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", innerProps, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: isDisabled ? $81905f6290625738$var$disabledStyles : $81905f6290625738$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, $81905f6290625738$var$renderIcon())));
}
const $81905f6290625738$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const ariaLabel = typeof children === 'string' ? children : data.label;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Container, {
        data: data,
        innerProps: {
            ...(0, $b0fMV.getStyleProps)(props, 'multiValue', {
                'multi-value': true,
                'multi-value--is-disabled': isDisabled
            }),
            ...innerProps
        },
        selectProps: selectProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Label, {
        data: data,
        innerProps: {
            ...(0, $b0fMV.getStyleProps)(props, 'multiValueLabel', {
                'multi-value__label': true
            })
        },
        selectProps: selectProps
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)(Remove, {
        data: data,
        innerProps: {
            ...(0, $b0fMV.getStyleProps)(props, 'multiValueRemove', {
                'multi-value__remove': true
            }),
            role: 'button',
            tabIndex: -1,
            'aria-label': `${ariaLabel || 'option'}, remove`,
            ...removeProps
        },
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$81905f6290625738$export$2e2bcd8739ae039 = $81905f6290625738$var$MultiValue;

});

parcelRegister("FpaWY", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $3f5146e3502d3009$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $3f5146e3502d3009$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $3f5146e3502d3009$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    let color = "var(--ds-text, #172B4D)";
    if (isDisabled) color = "var(--ds-text-disabled, #091E424F)";
    else if (isSelected) color = "var(--ds-text-selected, #0C66E4)";
    let boxShadow;
    let backgroundColor;
    if (isDisabled) backgroundColor = undefined;
    else if (isSelected && isFocused) backgroundColor = "var(--ds-background-selected-hovered, #CCE0FF)";
    else if (isSelected) backgroundColor = "var(--ds-background-selected, #E9F2FF)";
    else if (isFocused) backgroundColor = "var(--ds-background-neutral-subtle-hovered, #091E420F)";
    if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${"var(--ds-border-selected, #0C66E4)"}`;
    const cursor = isDisabled ? 'not-allowed' : 'default';
    return {
        label: 'option',
        display: 'block',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
        backgroundColor: backgroundColor,
        color: color,
        cursor: cursor,
        boxShadow: boxShadow,
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? "var(--ds-background-selected-pressed, #85B8FF)" : "var(--ds-background-neutral-subtle-pressed, #091E4224)" : undefined
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
        }
    };
};
const $3f5146e3502d3009$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'option', {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3f5146e3502d3009$export$2e2bcd8739ae039 = $3f5146e3502d3009$var$Option;

});

parcelRegister("41aBa", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $46d5944cb8b3b0b7$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $46d5944cb8b3b0b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $46d5944cb8b3b0b7$export$5f3ffacd6594d90f = ({ isDisabled: isDisabled })=>({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3',
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtlest, #626F86)"
    });
const $46d5944cb8b3b0b7$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'placeholder', {
            placeholder: true
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$46d5944cb8b3b0b7$export$2e2bcd8739ae039 = $46d5944cb8b3b0b7$var$Placeholder;

});

parcelRegister("aPWnT", function(module, exports) {

$parcel$export(module.exports, "css", () => $d266cade0fb9c8f9$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $d266cade0fb9c8f9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $d266cade0fb9c8f9$export$dbf350e5966cf602 = ({ isDisabled: isDisabled })=>({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text, #172B4D)"
    });
const $d266cade0fb9c8f9$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'singleValue', {
            'single-value': true,
            'single-value--is-disabled': isDisabled
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d266cade0fb9c8f9$export$2e2bcd8739ae039 = $d266cade0fb9c8f9$var$SingleValue;

});


parcelRegister("lau8t", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $da5b97c526f06b5a$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $da5b97c526f06b5a$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $9Iej8 = parcelRequire("9Iej8");
var $asiGE = parcelRequire("asiGE");
var $3TR0I = parcelRequire("3TR0I");

var $fdJB9 = parcelRequire("fdJB9");

var $7Qatx = parcelRequire("7Qatx");
const $da5b97c526f06b5a$var$packageName = "platform-pkg";
const $da5b97c526f06b5a$var$packageVersion = "0.0.0-use.local";
const $da5b97c526f06b5a$export$d1de3b251ccaa8a3 = (0, $7Qatx.default)((0, $fdJB9.default));
const $da5b97c526f06b5a$var$createAndFireEventOnAtlaskit = (0, $9Iej8.default)('atlaskit');
const $da5b97c526f06b5a$var$Select = (0, $asiGE.default)({
    componentName: 'select',
    packageName: $da5b97c526f06b5a$var$packageName,
    packageVersion: $da5b97c526f06b5a$var$packageVersion
})((0, $3TR0I.default)({
    onChange: $da5b97c526f06b5a$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $da5b97c526f06b5a$var$packageName,
            packageVersion: $da5b97c526f06b5a$var$packageVersion
        }
    })
})($da5b97c526f06b5a$export$d1de3b251ccaa8a3));
var $da5b97c526f06b5a$export$2e2bcd8739ae039 = $da5b97c526f06b5a$var$Select;

});
parcelRegister("fdJB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4292f0009a275a8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("2OKnX")).default);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $djBXi = parcelRequire("djBXi");

var $2OKnX = parcelRequire("2OKnX");

var $63z2N = parcelRequire("63z2N");
const $a4292f0009a275a8$var$AsyncSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $2OKnX.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $63z2N.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $djBXi.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a4292f0009a275a8$export$2e2bcd8739ae039 = $a4292f0009a275a8$var$AsyncSelect;

});
parcelRegister("djBXi", function(module, exports) {

$parcel$export(module.exports, "default", () => $17a9f59c5814b8a9$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5a34e = parcelRequire("5a34e");

var $fHpHg = parcelRequire("fHpHg");

var $jwj8k = parcelRequire("jwj8k");

var $b1kcy = parcelRequire("b1kcy");

var $2PbHi = parcelRequire("2PbHi");
var $2dBDF = parcelRequire("2dBDF");
var $hFt5x = parcelRequire("hFt5x");

var $StbfM = parcelRequire("StbfM");

var $1NMZ0 = parcelRequire("1NMZ0");

var $fW3un = parcelRequire("fW3un");

var $gInKw = parcelRequire("gInKw");

var $1BKyN = parcelRequire("1BKyN");

var $b0fMV = parcelRequire("b0fMV");
const $17a9f59c5814b8a9$export$9c21a3269931e1e6 = {
    // aria-live is by default with the live region so we don't need it
    // eslint-disable-next-line @atlaskit/platform/no-module-level-eval
    'aria-live': (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? undefined : 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $b0fMV.isTouchCapable)(),
    captureMenuScroll: !(0, $b0fMV.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $gInKw.createFilter)(),
    formatGroupLabel: (0, $jwj8k.formatGroupLabel),
    getOptionLabel: (0, $jwj8k.getOptionLabel),
    getOptionValue: (0, $jwj8k.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $jwj8k.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $b0fMV.isMobileDevice)(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true
};
function $17a9f59c5814b8a9$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $17a9f59c5814b8a9$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $17a9f59c5814b8a9$var$isOptionSelected(props, option, selectValue);
    const label = $17a9f59c5814b8a9$var$getOptionLabel(props, option);
    const value = $17a9f59c5814b8a9$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $17a9f59c5814b8a9$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$17a9f59c5814b8a9$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$17a9f59c5814b8a9$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $17a9f59c5814b8a9$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $17a9f59c5814b8a9$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $b0fMV.notNullish));
}
function $17a9f59c5814b8a9$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $17a9f59c5814b8a9$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $17a9f59c5814b8a9$var$buildFocusableOptions(props, selectValue) {
    return $17a9f59c5814b8a9$var$buildFocusableOptionsFromCategorizedOptions($17a9f59c5814b8a9$var$buildCategorizedOptions(props, selectValue));
}
function $17a9f59c5814b8a9$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$17a9f59c5814b8a9$var$shouldHideSelectedOptions(props) || !isSelected) && $17a9f59c5814b8a9$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $17a9f59c5814b8a9$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $17a9f59c5814b8a9$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $17a9f59c5814b8a9$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $17a9f59c5814b8a9$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $17a9f59c5814b8a9$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $17a9f59c5814b8a9$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $17a9f59c5814b8a9$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $17a9f59c5814b8a9$var$getOptionValue(props, option);
    return selectValue.some((i)=>$17a9f59c5814b8a9$var$getOptionValue(props, i) === candidate);
}
function $17a9f59c5814b8a9$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $17a9f59c5814b8a9$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $17a9f59c5814b8a9$var$instanceId = 1;
class $17a9f59c5814b8a9$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $17a9f59c5814b8a9$export$9c21a3269931e1e6;
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props), this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        }, // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, this.isVoiceOver = (0, $fHpHg.fg)('design_system_select-a11y-improvement') && (0, $5a34e.isAppleDevice)(), // Refs
        // ------------------------------
        this.controlRef = null, this.getControlRef = (ref)=>{
            this.controlRef = ref;
        }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        }, this.inputRef = null, this.getInputRef = (ref)=>{
            this.inputRef = ref;
        }, // aliased for consumers
        this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        }, this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        }, this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $b0fMV.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $b0fMV.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $b0fMV.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $b0fMV.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        }, this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $b0fMV.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        }, this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $b0fMV.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        }, this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $b0fMV.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }, // ==============================
        // Getters
        // ==============================
        this.getFocusedOptionId = (focusedOption)=>{
            return $17a9f59c5814b8a9$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        }, this.getFocusableOptionsWithIds = ()=>{
            return $17a9f59c5814b8a9$var$buildFocusableOptionsWithIds($17a9f59c5814b8a9$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, $b0fMV.classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
            return $17a9f59c5814b8a9$var$getOptionLabel(this.props, data);
        }, this.getOptionValue = (data)=>{
            return $17a9f59c5814b8a9$var$getOptionValue(this.props, data);
        }, this.getStyles = (key, props)=>{
            const base = (0, $1BKyN.defaultStyles)[key](props);
            base.boxSizing = 'border-box';
            const custom = this.props.styles[key];
            return custom ? custom(base, props) : base;
        }, this.getClassNames = (key, props)=>this.props.classNames[key]?.(props), this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        }, this.getComponents = ()=>{
            return (0, $b1kcy.defaultComponents)(this.props);
        }, this.buildCategorizedOptions = ()=>$17a9f59c5814b8a9$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$17a9f59c5814b8a9$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        }, // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        }, this.onMenuMouseMove = (event)=>{
            this.blockOptionHover = false;
        }, this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        }, this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        }, this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        }, this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $b0fMV.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        }, this.onCompositionStart = ()=>{
            this.isComposing = true;
        }, this.onCompositionEnd = ()=>{
            this.isComposing = false;
        }, this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        }, this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        }, this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        }, this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        }, this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        }, this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        }, // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        }, this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        }, this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        }, this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        }, this.shouldHideSelectedOptions = ()=>{
            return $17a9f59c5814b8a9$var$shouldHideSelectedOptions(this.props);
        }, // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        }, // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            if (!(0, $fHpHg.fg)('platform_dst_layer_observer_select')) return;
            this.onMenuClose();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$17a9f59c5814b8a9$var$instanceId);
        this.state.selectValue = (0, $b0fMV.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $17a9f59c5814b8a9$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $b0fMV.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $17a9f59c5814b8a9$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $17a9f59c5814b8a9$var$buildFocusableOptionsWithIds($17a9f59c5814b8a9$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $17a9f59c5814b8a9$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $17a9f59c5814b8a9$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $17a9f59c5814b8a9$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $b0fMV.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $b0fMV.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            (0, $b0fMV.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusableOptions[openAtIndex],
            focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
        }, ()=>this.onMenuOpen());
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $17a9f59c5814b8a9$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $17a9f59c5814b8a9$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $17a9f59c5814b8a9$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        } else return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription(action) {
        const descriptionProp = this.props['aria-describedby'] || this.props['descriptionId'];
        const { isMulti: isMulti } = this.props;
        const { selectValue: selectValue } = this.state;
        const defaultDescription = selectValue.length ? this.getElementId('live-region') : this.getElementId('placeholder');
        if (!isMulti && selectValue.length && action !== 'initial-input-focus') return;
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            return {
                'aria-describedby': descriptionProp ? [
                    descriptionProp,
                    defaultDescription,
                    multiMessage
                ].join(' ') : [
                    defaultDescription,
                    multiMessage
                ].join(' ')
            };
        } else return {
            'aria-describedby': descriptionProp ? [
                descriptionProp,
                defaultDescription
            ].join(' ') : defaultDescription
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            'aria-autocomplete': 'both',
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': 'listbox',
            'aria-describedby': this.props['aria-describedby'] || descriptionId,
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            // TODO: Might need to remove this
            ...!isSearchable && {
                'aria-readonly': true
            },
            ...this.calculateDescription(ariaSelection?.action)
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2PbHi.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: (0, $b0fMV.noop),
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, $5uXOq.createElement)(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, $5uXOq.createElement)(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    },
                    'data-testid': `${testId}-select--multivalue-${index}-remove`
                },
                data: opt,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}`
                    },
                    id: `${this.getElementId('selected-value')}-${index}`
                }
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, $2OMIu.jsx)(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            children: this.formatOptionLabel(singleValue, 'value')
        });
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label, testId: testId } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: 'option',
                'aria-selected': isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled && (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? undefined : isDisabled,
                'aria-describedby': (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? headingId : undefined,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, $5uXOq.createElement)(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, $5uXOq.createElement)(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $2OMIu.jsx)(LoadingMessage, {
                ...commonProps,
                children: message
            });
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $2OMIu.jsx)(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                },
                children: message
            });
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const calculateListboxLabel = ()=>{
            // First in name calculation, overwrites aria-label
            if (labelId) return {
                'aria-labelledby': labelId
            };
            // Second in name calcuation, overwrites everything else except aria-labelledby
            if (label) return {
                'aria-label': label
            };
            // Fallback if no label or labelId is provided, might catch label via <label for> otherwise
            // will most likely not have an accessible name
            return {
                'aria-labelledby': this.inputRef?.id || this.getElementId('input')
            };
        };
        const menuElement = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fW3un.MenuPlacer), {
            ...commonProps,
            ...menuPlacementProps,
            children: ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, $2OMIu.jsx)(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                        ...testId && {
                            'data-testid': `${testId}-select--listbox-container`
                        }
                    },
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hFt5x.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>/*#__PURE__*/ (0, $2OMIu.jsx)(MenuList, {
                                ...commonProps,
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: {
                                    role: 'listbox',
                                    'aria-multiselectable': (this.isVoiceOver || !commonProps.isMulti) && (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox'),
                                    ...testId && {
                                        'data-testid': `${testId}-select--listbox`
                                    },
                                    // add aditional label on listbox when ff is on
                                    ...(0, $fHpHg.fg)('design_system_select-a11y-improvement') && calculateListboxLabel()
                                },
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: menuUI
                            })
                    })
                })
        });
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, $2OMIu.jsx)(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        }) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2dBDF.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1NMZ0.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            focusedOption: focusedOption,
            focusedValue: focusedValue,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions,
            isAppleDevice: this.isVoiceOver
        });
    }
    renderMultiselectMessage() {
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: ", multiple selections available,"
        }));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $2OMIu.jsxs)(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown,
                ...testId && {
                    'data-testid': testId && `${testId}-select--container`
                }
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            children: [
                this.renderLiveRegion(),
                commonProps.isMulti && this.renderMultiselectMessage(),
                /*#__PURE__*/ (0, $2OMIu.jsxs)(Control, {
                    ...commonProps,
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd,
                        ...testId && {
                            'data-testid': `${testId}-select--control`
                        }
                    },
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsxs)(ValueContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            isCompact: isCompact,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--value-container`
                                }
                            },
                            children: [
                                this.renderPlaceholderOrValue(),
                                this.renderInput()
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)(IndicatorsContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--indicators-container`
                                }
                            },
                            children: [
                                this.renderClearIndicator(),
                                this.renderLoadingIndicator(),
                                this.renderDropdownIndicator()
                            ]
                        })
                    ]
                }),
                this.renderMenu(),
                this.renderFormField(),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $StbfM.NotifyOpenLayerObserver), {
                    isOpen: (0, $fHpHg.fg)('platform_dst_layer_observer_select') && this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
}

});
parcelRegister("5a34e", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $838c050d2f176b76$export$95df08bae54cb4df);
$parcel$export(module.exports, "isAppleDevice", () => $838c050d2f176b76$export$e1865c3bedcd822b);
function $838c050d2f176b76$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $838c050d2f176b76$var$isIPhone() {
    return $838c050d2f176b76$var$testPlatform(/^iPhone/i);
}
function $838c050d2f176b76$var$isMac() {
    return $838c050d2f176b76$var$testPlatform(/^Mac/i);
}
function $838c050d2f176b76$var$isIPad() {
    return $838c050d2f176b76$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    // eslint-disable-next-line compat/compat
    $838c050d2f176b76$var$isMac() && navigator.maxTouchPoints > 1;
}
function $838c050d2f176b76$var$isIOS() {
    return $838c050d2f176b76$var$isIPhone() || $838c050d2f176b76$var$isIPad();
}
function $838c050d2f176b76$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        const ua = window.navigator.userAgent?.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $838c050d2f176b76$export$e1865c3bedcd822b() {
    return $838c050d2f176b76$var$isMac() || $838c050d2f176b76$var$isIOS();
}

});

parcelRegister("jwj8k", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", () => $dff534f610407347$export$f4da216a6ca54656);
$parcel$export(module.exports, "getOptionLabel", () => $dff534f610407347$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $dff534f610407347$export$40be908210c5a79c);
$parcel$export(module.exports, "isOptionDisabled", () => $dff534f610407347$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $dff534f610407347$export$f4da216a6ca54656 = (group)=>group.label;
const $dff534f610407347$export$dac6ace3020563ca = (option)=>option.label;
const $dff534f610407347$export$40be908210c5a79c = (option)=>option.value;
const $dff534f610407347$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("2PbHi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ef926a855a779be$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $9ef926a855a779be$var$dummyInputStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 1,
    padding: 0,
    position: 'relative',
    background: 0,
    border: 0,
    caretColor: 'transparent',
    color: 'transparent',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'inherit',
    gridArea: '1 / 1 / 2 / 3',
    insetInlineStart: -100,
    label: 'dummyInput',
    opacity: 0,
    outline: 0,
    transform: 'scale(.01)'
});
function $9ef926a855a779be$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $b0fMV.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ref: innerRef,
        ...filteredProps,
        css: $9ef926a855a779be$var$dummyInputStyles
    });
}

});

parcelRegister("2dBDF", function(module, exports) {

$parcel$export(module.exports, "default", () => $14249926a63529ad$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $bKnKN = parcelRequire("bKnKN");
function $14249926a63529ad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $14249926a63529ad$var$styles = {
    name: "1fj9brw-requiredInput",
    styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
};
const $14249926a63529ad$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $14249926a63529ad$var$styles,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $bKnKN.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$14249926a63529ad$export$2e2bcd8739ae039 = $14249926a63529ad$var$RequiredInput;

});

parcelRegister("hFt5x", function(module, exports) {

$parcel$export(module.exports, "default", () => $86de9e85d01f60c4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $f9MvN = parcelRequire("f9MvN");

var $25zrI = parcelRequire("25zrI");
function $86de9e85d01f60c4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $86de9e85d01f60c4$var$styles = {
    name: "qzxev8",
    styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
};
const $86de9e85d01f60c4$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $86de9e85d01f60c4$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $f9MvN.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $25zrI.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, lockEnabled && // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        onClick: $86de9e85d01f60c4$var$blurSelectInput,
        css: $86de9e85d01f60c4$var$styles
    }), children(targetRef));
}

});
parcelRegister("f9MvN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c785698eb20a81e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b0fMV = parcelRequire("b0fMV");
const $6c785698eb20a81e$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $6c785698eb20a81e$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $5uXOq.useRef)(false);
    const isTop = (0, $5uXOq.useRef)(false);
    const touchStart = (0, $5uXOq.useRef)(0);
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $6c785698eb20a81e$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $5uXOq.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $b0fMV.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("25zrI", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d1383606735f058$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $4d1383606735f058$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $4d1383606735f058$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $4d1383606735f058$var$preventTouchMove(e) {
    e.preventDefault();
}
function $4d1383606735f058$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $4d1383606735f058$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $4d1383606735f058$var$isTouchDevice() {
    // eslint-disable-next-line compat/compat
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $4d1383606735f058$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $4d1383606735f058$var$activeScrollLocks = 0;
const $4d1383606735f058$var$listenerOptions = {
    capture: false,
    passive: false
};
function $4d1383606735f058$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $5uXOq.useRef)({});
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$4d1383606735f058$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $4d1383606735f058$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $4d1383606735f058$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($4d1383606735f058$var$LOCK_STYLES).forEach((key)=>{
                const val = $4d1383606735f058$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $4d1383606735f058$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $4d1383606735f058$var$preventTouchMove, $4d1383606735f058$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $4d1383606735f058$var$preventInertiaScroll, $4d1383606735f058$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $4d1383606735f058$var$allowTouchMove, $4d1383606735f058$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $4d1383606735f058$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$4d1383606735f058$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $4d1383606735f058$var$activeScrollLocks = Math.max($4d1383606735f058$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $4d1383606735f058$var$activeScrollLocks < 1) $4d1383606735f058$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $4d1383606735f058$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $4d1383606735f058$var$preventTouchMove, $4d1383606735f058$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $4d1383606735f058$var$preventInertiaScroll, $4d1383606735f058$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $4d1383606735f058$var$allowTouchMove, $4d1383606735f058$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("StbfM", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $10d04a4d3c9b7a75$export$17baa7c95b6ba1b8);

var $8Oct0 = parcelRequire("8Oct0");
function $10d04a4d3c9b7a75$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    (0, $8Oct0.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("1NMZ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $221388b1d82bde88$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ /**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $fHpHg = parcelRequire("fHpHg");

var $gER7R = parcelRequire("gER7R");

var $dZ6CW = parcelRequire("dZ6CW");
// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $221388b1d82bde88$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
    const ariaLabel = selectProps['aria-label'] || label;
    const ariaLive = selectProps['aria-live'];
    // for safari, we will use minimum support from aria-live region
    const isA11yImprovementEnabled = (0, $fHpHg.fg)('design_system_select-a11y-improvement') && !isAppleDevice;
    // Update aria live message configuration when prop changes
    const messages = (0, $5uXOq.useMemo)(()=>({
            ...(0, $gER7R.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $5uXOq.useMemo)(()=>{
        let message = '';
        if (isA11yImprovementEnabled && menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (isA11yImprovementEnabled && !label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        isA11yImprovementEnabled,
        menuIsOpen
    ]);
    const prevInputValue = (0, $5uXOq.useRef)('');
    const ariaFocused = (0, $5uXOq.useMemo)(()=>{
        let focusMsg = '';
        const focused = focusedOption || focusedValue;
        const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (inputValue === prevInputValue.current && isA11yImprovementEnabled) // only announce focus option when searching when ff is on and the input value changed
        // for safari, we will announce for all
        return '';
        if (focused && messages.onFocus) {
            const onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isMulti: isMulti
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        prevInputValue.current = inputValue;
        return focusMsg;
    }, [
        inputValue,
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isA11yImprovementEnabled,
        isMulti
    ]);
    const ariaResults = (0, $5uXOq.useMemo)(()=>{
        let resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
        if ((0, $fHpHg.fg)('design_system_select-a11y-improvement')) // don't announce guidance at all when ff is on
        return '';
        let guidanceMsg = '';
        if (messages.guidance) {
            const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    const ScreenReaderText = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-results"
    }, ariaResults), !(0, $fHpHg.fg)('design_system_select-a11y-improvement') && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance)));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dZ6CW.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dZ6CW.default), {
        "aria-live": ariaLive,
        "aria-atomic": (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? undefined : 'false',
        "aria-relevant": (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? undefined : 'additions text',
        role: (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? 'status' : 'log'
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$221388b1d82bde88$export$2e2bcd8739ae039 = $221388b1d82bde88$var$LiveRegion;

});
parcelRegister("gER7R", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", () => $f2979f887e9391fd$export$a7265767c78f9bae);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $fHpHg = parcelRequire("fHpHg");
const $f2979f887e9391fd$export$a7265767c78f9bae = {
    guidance: (props)=>{
        const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
        switch(context){
            case 'menu':
                return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
            case 'input':
                return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: (props)=>{
        const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length && (0, $fHpHg.fg)('design_system_select-a11y-improvement') || !(0, $fHpHg.fg)('design_system_select-a11y-improvement') ? `option ${label}, deselected` : ''; // TODO: this should be handled on backspace|delete if no value, but doing it here first
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return label.length && (0, $fHpHg.fg)('design_system_select-a11y-improvement') || !(0, $fHpHg.fg)('design_system_select-a11y-improvement') ? `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.` : '';
            case 'select-option':
                return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
            default:
                return '';
        }
    },
    onFocus: (props)=>{
        const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isDisabled: isDisabled, isSelected: isSelected } = props;
        const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
        if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
        // No longer needed after fg('design_system_select-a11y-improvement') is cleaned up
        if (context === 'menu' && !(0, $fHpHg.fg)('design_system_select-a11y-improvement')) {
            const disabled = isDisabled ? ' disabled' : '';
            const status = `${isSelected ? ' selected' : ' not selected'}${disabled}`;
            return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
        }
        return '';
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
    }
};

});

parcelRegister("dZ6CW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1ab6e61bd8eba4f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $d1ab6e61bd8eba4f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
const $d1ab6e61bd8eba4f$var$styles = {
    name: "jvmzbk-a11yText",
    styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;user-select:none;white-space:nowrap"
};
const $d1ab6e61bd8eba4f$var$A11yText = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $d1ab6e61bd8eba4f$var$styles,
        ...props
    });
var $d1ab6e61bd8eba4f$export$2e2bcd8739ae039 = $d1ab6e61bd8eba4f$var$A11yText;

});


parcelRegister("gInKw", function(module, exports) {

$parcel$export(module.exports, "createFilter", () => $9499cdf192fc0df5$export$5d81789ff4aeccdf);

var $8QpSo = parcelRequire("8QpSo");

var $a36ws = parcelRequire("a36ws");
const $9499cdf192fc0df5$var$memoizedStripDiacriticsForInput = (0, $8QpSo.default)((0, $a36ws.stripDiacritics));
const $9499cdf192fc0df5$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $9499cdf192fc0df5$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $9499cdf192fc0df5$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $9499cdf192fc0df5$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $9499cdf192fc0df5$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $9499cdf192fc0df5$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $9499cdf192fc0df5$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $a36ws.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("a36ws", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", () => $b90cbf4384c79b10$export$b5bee4b27048330b);
const $b90cbf4384c79b10$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $b90cbf4384c79b10$var$anyDiacritic = new RegExp('[' + $b90cbf4384c79b10$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $b90cbf4384c79b10$var$diacriticToBase = {};
for(let i = 0; i < $b90cbf4384c79b10$var$diacritics.length; i++){
    let diacritic = $b90cbf4384c79b10$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$b90cbf4384c79b10$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $b90cbf4384c79b10$export$b5bee4b27048330b = (str)=>{
    return str.replace($b90cbf4384c79b10$var$anyDiacritic, (match)=>$b90cbf4384c79b10$var$diacriticToBase[match]);
};

});


parcelRegister("1BKyN", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $a295ff46d412df78$export$214b055320e0bf32);
$parcel$export(module.exports, "mergeStyles", () => $a295ff46d412df78$export$e618dc39ac9ad607);

var $cSGW3 = parcelRequire("cSGW3");

var $gGvqh = parcelRequire("gGvqh");

var $iluyz = parcelRequire("iluyz");

var $6oGQp = parcelRequire("6oGQp");

var $4S2FY = parcelRequire("4S2FY");

var $fW3un = parcelRequire("fW3un");

var $g6y65 = parcelRequire("g6y65");

var $FpaWY = parcelRequire("FpaWY");

var $41aBa = parcelRequire("41aBa");

var $aPWnT = parcelRequire("aPWnT");
const $a295ff46d412df78$export$214b055320e0bf32 = {
    clearIndicator: (0, $6oGQp.clearIndicatorCSS),
    container: (0, $cSGW3.containerCSS),
    control: (0, $gGvqh.css),
    dropdownIndicator: (0, $6oGQp.dropdownIndicatorCSS),
    group: (0, $iluyz.groupCSS),
    groupHeading: (0, $iluyz.groupHeadingCSS),
    indicatorsContainer: (0, $cSGW3.indicatorsContainerCSS),
    input: (0, $4S2FY.inputCSS),
    loadingIndicator: (0, $6oGQp.loadingIndicatorCSS),
    loadingMessage: (0, $fW3un.loadingMessageCSS),
    menu: (0, $fW3un.menuCSS),
    menuList: (0, $fW3un.menuListCSS),
    menuPortal: (0, $fW3un.menuPortalCSS),
    multiValue: (0, $g6y65.multiValueCSS),
    multiValueLabel: (0, $g6y65.multiValueLabelCSS),
    multiValueRemove: (0, $g6y65.multiValueRemoveCSS),
    noOptionsMessage: (0, $fW3un.noOptionsMessageCSS),
    option: (0, $FpaWY.optionCSS),
    placeholder: (0, $41aBa.placeholderCSS),
    singleValue: (0, $aPWnT.css),
    valueContainer: (0, $cSGW3.valueContainerCSS)
};
function $a295ff46d412df78$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});


parcelRegister("2OKnX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2689712370970f9b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b0fMV = parcelRequire("b0fMV");
function $2689712370970f9b$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $5uXOq.useRef)(undefined);
    const mounted = (0, $5uXOq.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $5uXOq.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        const inputValue = (0, $b0fMV.handleInputChange)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("63z2N", function(module, exports) {

$parcel$export(module.exports, "default", () => $52e9513a75e7f00c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $52e9513a75e7f00c$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("7Qatx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ac7c8ad4681692a$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $5IVHm = parcelRequire("5IVHm");
function $5ac7c8ad4681692a$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages: ariaLiveMessages, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $5uXOq.useRef)(null);
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? undefined : 'assertive',
            ariaLiveMessages: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            //TO DO: Still need live region for PopupSelect because of the menu being open by default
            (0, $5IVHm.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $5IVHm.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            ...restProps,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("5IVHm", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $e1e3dc8406f8de80$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $e1e3dc8406f8de80$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $e1e3dc8406f8de80$export$8ee33f304118fce4);

var $fHpHg = parcelRequire("fHpHg");
function $e1e3dc8406f8de80$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    if (focused.label && groupData?.label && (0, $fHpHg.fg)('design_system_select-a11y-improvement')) return `${focused.label}, ${groupData?.label}`;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $e1e3dc8406f8de80$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $e1e3dc8406f8de80$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("i0vxP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e488d7f69150a6e1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fW62l = parcelRequire("fW62l");
class $e488d7f69150a6e1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onEscape: null,
            onEnter: null,
            onBlur: null,
            className: undefined
        };
    }
    componentDidMount() {
        // AK Modal uses document.addEventListener() so we also have to use addEventListener.
        // We can't rely on React Synthetic events as stopPropagation won't work
        // This is due to the way React handles events
        // https://github.com/facebook/react/issues/7094
        if (this.ref) this.ref.addEventListener('keydown', this.handleKeyDown);
    }
    componentWillUnmount() {
        if (this.ref) this.ref.removeEventListener('keydown', this.handleKeyDown);
    }
    render() {
        return(// @ts-expect-error - TS2322 - Type '(() => void) | null' is not assignable to type 'FocusEventHandler<HTMLDivElement> | undefined'.
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            onBlur: this.props.onBlur,
            ref: this.setRef,
            className: this.props.className
        }, this.props.children));
    }
    constructor(...args){
        super(...args), this.setRef = (ref)=>{
            this.ref = ref;
        }, this.handleKeyDown = (event)=>{
            switch(event.keyCode){
                case (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('escape'):
                    if (this.props.onEscape) {
                        this.props.onEscape(event);
                        event.stopPropagation();
                    }
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter'):
                    if (this.props.onEnter) {
                        this.props.onEnter(event);
                        event.stopPropagation();
                    }
                    break;
                default:
                    break;
            }
        };
    }
}

});
parcelRegister("fW62l", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});


parcelRegister("kJMdt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1d6d450ba6ea5ae$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c1d6d450ba6ea5ae$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    selectPlaceholder: {
        "id": "software-board-create.modal.form.source-type-picker.select-placeholder",
        "defaultMessage": "Select"
    },
    sourceTypeFieldLabel: {
        "id": "software-board-create.modal.form.source-type-picker.source-type-field-label",
        "defaultMessage": "Choose what to include in this board"
    },
    teamTitle: {
        "id": "software-board-create.modal.form.source-type-picker.team-title",
        "defaultMessage": "Team"
    },
    teamSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.team-selected-title",
        "defaultMessage": "Issues based on <strong>Team</strong>"
    },
    teamDescription: {
        "id": "software-board-create.modal.form.source-type-picker.team-description",
        "defaultMessage": "Show all issues assigned to a team"
    },
    issueTypesTitle: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-title",
        "defaultMessage": "Issue type"
    },
    issueTypesSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-selected-title",
        "defaultMessage": "Issues based on <strong>Issue type</strong>"
    },
    issueTypesDescription: {
        "id": "software-board-create.modal.form.source-type-picker.issue-types-description",
        "defaultMessage": "Show all issues associated with an issue type"
    },
    labelsTitle: {
        "id": "software-board-create.modal.form.source-type-picker.labels-title",
        "defaultMessage": "Label"
    },
    labelsSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.labels-selected-title",
        "defaultMessage": "Issues based on <strong>Label</strong>"
    },
    labelsDescription: {
        "id": "software-board-create.modal.form.source-type-picker.labels-description",
        "defaultMessage": "Show all issues tagged with a specific label"
    },
    allIssuesFromProjectTitle: {
        "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-title",
        "defaultMessage": "All issues from your project"
    },
    allIssuesFromProjectSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.all-issues-from-project-selected-title",
        "defaultMessage": "Issues based on <strong>All issues from your project</strong>"
    },
    savedFilterTitle: {
        "id": "software-board-create.modal.form.source-type-picker.saved-filter-title",
        "defaultMessage": "Advanced"
    },
    savedFilterSelectedTitle: {
        "id": "software-board-create.modal.form.source-type-picker.saved-filter-selected-title",
        "defaultMessage": "Issues based on a <strong>Saved filter</strong>"
    },
    savedFilterDescription: {
        "id": "software-board-create.modal.form.source-type-picker.saved-filter-description",
        "defaultMessage": "Show issues from a saved JQL filter"
    },
    sourceTypePickerAriaLabel: {
        "id": "software-board-create.modal.form.source-type-picker.source-type-picker-aria-label",
        "defaultMessage": "Select what to include in this board"
    },
    sourceTypeEmptyError: {
        "id": "software-board-create.modal.form.source-type-picker.source-type-empty-error",
        "defaultMessage": "Select what to include in this board"
    }
});

});

parcelRegister("c6RuI", function(module, exports) {

$parcel$export(module.exports, "getOptionGroups", () => $febdc73d67318f4a$export$eec1253b95a159cc);

var $8nT7B = parcelRequire("8nT7B");

var $cQJCJ = parcelRequire("cQJCJ");

var $b9mEB = parcelRequire("b9mEB");

var $7y6rd = parcelRequire("7y6rd");

var $7PkLr = parcelRequire("7PkLr");

var $h3KSk = parcelRequire("h3KSk");

var $kJMdt = parcelRequire("kJMdt");
const $febdc73d67318f4a$export$eec1253b95a159cc = ({ formatMessage: formatMessage, projectAvatar: projectAvatar })=>{
    return [
        {
            options: [
                {
                    label: formatMessage((0, $kJMdt.default).allIssuesFromProjectTitle),
                    title: formatMessage((0, $kJMdt.default).allIssuesFromProjectTitle),
                    selectedTitle: (0, $kJMdt.default).allIssuesFromProjectSelectedTitle,
                    value: null,
                    icon: projectAvatar || (0, (/*@__PURE__*/$parcel$interopDefault($7PkLr)))
                }
            ]
        },
        {
            options: [
                {
                    label: formatMessage((0, $kJMdt.default).teamTitle),
                    title: formatMessage((0, $kJMdt.default).teamTitle),
                    selectedTitle: (0, $kJMdt.default).teamSelectedTitle,
                    description: formatMessage((0, $kJMdt.default).teamDescription),
                    value: (0, $h3KSk.BOARD_SOURCE_FIELDS).TEAM,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($7y6rd)))
                },
                {
                    label: formatMessage((0, $kJMdt.default).issueTypesTitle),
                    title: formatMessage((0, $kJMdt.default).issueTypesTitle),
                    selectedTitle: (0, $kJMdt.default).issueTypesSelectedTitle,
                    description: formatMessage((0, $kJMdt.default).issueTypesDescription),
                    value: (0, $h3KSk.BOARD_SOURCE_FIELDS).ISSUE_TYPES,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($cQJCJ)))
                },
                {
                    label: formatMessage((0, $kJMdt.default).labelsTitle),
                    title: formatMessage((0, $kJMdt.default).labelsTitle),
                    selectedTitle: (0, $kJMdt.default).labelsSelectedTitle,
                    description: formatMessage((0, $kJMdt.default).labelsDescription),
                    value: (0, $h3KSk.BOARD_SOURCE_FIELDS).LABELS,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($b9mEB)))
                }
            ]
        },
        {
            options: [
                {
                    label: formatMessage((0, $kJMdt.default).savedFilterTitle),
                    title: formatMessage((0, $kJMdt.default).savedFilterTitle),
                    selectedTitle: (0, $kJMdt.default).savedFilterSelectedTitle,
                    description: formatMessage((0, $kJMdt.default).savedFilterDescription),
                    value: (0, $h3KSk.BOARD_SOURCE_FIELDS).SAVED_FILTER,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($8nT7B)))
                }
            ]
        }
    ];
};

});
parcelRegister("b9mEB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f496fbd618fe5795b7e6b61ffefa90fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81e21b89fe78137d$var$_react = $81e21b89fe78137d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $81e21b89fe78137d$var$_tag = $81e21b89fe78137d$var$_interopRequireDefault((parcelRequire("5PAnj")));

var $81e21b89fe78137d$var$_label = $81e21b89fe78137d$var$_interopRequireDefault((parcelRequire("boCwN")));
function $81e21b89fe78137d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TagIcon.
 * This component is TagIcon, with `UNSAFE_fallbackIcon` set to "LabelIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $81e21b89fe78137d$var$TagIcon = (props)=>/*#__PURE__*/ $81e21b89fe78137d$var$_react.default.createElement($81e21b89fe78137d$var$_tag.default, Object.assign({
        LEGACY_fallbackIcon: $81e21b89fe78137d$var$_label.default
    }, props));
$81e21b89fe78137d$var$TagIcon.Name = 'TagIconMigration';
var $81e21b89fe78137d$var$_default = module.exports.default = $81e21b89fe78137d$var$TagIcon;

});
parcelRegister("5PAnj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d3d269e42a209b60a9080b233bea35f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43edee7da86ffe77$var$_react = $43edee7da86ffe77$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $43edee7da86ffe77$var$_baseNew = $43edee7da86ffe77$var$_interopRequireDefault((parcelRequire("enEmH")));
function $43edee7da86ffe77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $43edee7da86ffe77$var$TagIcon = (props)=>/*#__PURE__*/ $43edee7da86ffe77$var$_react.default.createElement($43edee7da86ffe77$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.354 1.586A2 2 0 0 1 8.768 1H13a2 2 0 0 1 2 2v4.232a2 2 0 0 1-.586 1.414l-5.75 5.75a2 2 0 0 1-2.828 0l-4.232-4.232a2 2 0 0 1 0-2.828zm1.414.914a.5.5 0 0 0-.354.146l-5.75 5.75a.5.5 0 0 0 0 .708l4.232 4.232a.5.5 0 0 0 .708 0l5.75-5.75a.5.5 0 0 0 .146-.354V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M10 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0"/>`
    }, props));
$43edee7da86ffe77$var$TagIcon.displayName = 'TagIcon';
var $43edee7da86ffe77$var$_default = module.exports.default = $43edee7da86ffe77$var$TagIcon;

});

parcelRegister("boCwN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $84bfd26e5c3e00fe$var$_react = $84bfd26e5c3e00fe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $84bfd26e5c3e00fe$var$_tag = $84bfd26e5c3e00fe$var$_interopRequireDefault((parcelRequire("5PAnj")));
function $84bfd26e5c3e00fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $84bfd26e5c3e00fe$var$LabelIcon = (props)=>/*#__PURE__*/ $84bfd26e5c3e00fe$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.433 5.428-4.207.6A2 2 0 0 0 5.53 7.727l-.6 4.207a1 1 0 0 0 .281.849l6.895 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283m-.647 5.858A1.666 1.666 0 1 1 8.43 8.929a1.666 1.666 0 0 1 2.357 2.357"/></svg>`
    }, props, {
        newIcon: $84bfd26e5c3e00fe$var$_tag.default
    }));
$84bfd26e5c3e00fe$var$LabelIcon.displayName = 'LabelIcon';
var $84bfd26e5c3e00fe$var$_default = module.exports.default = $84bfd26e5c3e00fe$var$LabelIcon;

});


parcelRegister("7y6rd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e476e34ec44b4dd59a1269a5572f39d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57f0b3d92e710592$var$_react = $57f0b3d92e710592$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $57f0b3d92e710592$var$_teams = $57f0b3d92e710592$var$_interopRequireDefault((parcelRequire("3kZDu")));

var $57f0b3d92e710592$var$_teams2 = $57f0b3d92e710592$var$_interopRequireDefault((parcelRequire("kHnWg")));
function $57f0b3d92e710592$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TeamsIcon.
 * This component is TeamsIcon, with `UNSAFE_fallbackIcon` set to "TeamsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $57f0b3d92e710592$var$TeamsIcon = (props)=>/*#__PURE__*/ $57f0b3d92e710592$var$_react.default.createElement($57f0b3d92e710592$var$_teams.default, Object.assign({
        LEGACY_fallbackIcon: $57f0b3d92e710592$var$_teams2.default
    }, props));
$57f0b3d92e710592$var$TeamsIcon.Name = 'TeamsIconMigration';
var $57f0b3d92e710592$var$_default = module.exports.default = $57f0b3d92e710592$var$TeamsIcon;

});
parcelRegister("kHnWg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f11a648334286494$var$_react = $f11a648334286494$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $f11a648334286494$var$_teams = $f11a648334286494$var$_interopRequireDefault((parcelRequire("3kZDu")));
function $f11a648334286494$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f11a648334286494$var$TeamsIcon = (props)=>/*#__PURE__*/ $f11a648334286494$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9 7.2a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m7.8 0a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m1.2 9.3a4.5 4.5 0 0 0-4.5-4.5h-1.378c-.484 0-1.275.127-1.875.41l.77 1.627c.14-.066.342-.129.566-.174s.421-.063.539-.063H17.1a2.7 2.7 0 0 1 2.7 2.7V18a.6.6 0 0 1-.6.6h-3.478a2.7 2.7 0 0 1-2.538-1.777l-.676-1.86A4.5 4.5 0 0 0 8.278 12H6.9a4.5 4.5 0 0 0-4.5 4.5V18a2.4 2.4 0 0 0 2.4 2.4h4.8v-1.8H4.8a.6.6 0 0 1-.6-.6v-1.5a2.7 2.7 0 0 1 2.7-2.7h1.378a2.7 2.7 0 0 1 2.538 1.777l.676 1.86a4.5 4.5 0 0 0 4.23 2.963H19.2a2.4 2.4 0 0 0 2.4-2.4z" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $f11a648334286494$var$_teams.default
    }));
$f11a648334286494$var$TeamsIcon.displayName = 'TeamsIcon';
var $f11a648334286494$var$_default = module.exports.default = $f11a648334286494$var$TeamsIcon;

});




parcelRegister("g5ZcC", function(module, exports) {

$parcel$export(module.exports, "SOURCE_VALUE_FIELD_NAME", () => $327b54d1894940ae$export$2acdb7270c211b02);
$parcel$export(module.exports, "SourceValuePicker", () => $327b54d1894940ae$export$427e84d70337182b);

var $5uXOq = parcelRequire("5uXOq");

var $k5Wbc = parcelRequire("k5Wbc");
var $4EHpO = parcelRequire("4EHpO");
var $1IOOW = parcelRequire("1IOOW");

var $koVbs = parcelRequire("koVbs");

var $6prxh = parcelRequire("6prxh");

var $lq9tz = parcelRequire("lq9tz");

var $6r4tP = parcelRequire("6r4tP");
const $327b54d1894940ae$export$7b060a5763a6e199 = 'VALIDATION_ERROR_EMPTY';
const $327b54d1894940ae$export$2acdb7270c211b02 = 'sourceValue';
const $327b54d1894940ae$export$427e84d70337182b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formState = (0, $1IOOW.useFormState)();
    const sourceType = formState?.values.sourceType;
    if (!sourceType) return null;
    const mappedSource = (0, $6r4tP.boardSourceFieldComponentMap)[sourceType];
    if (!mappedSource) {
        (0, $6prxh.fireBoardCreateErrorAnalytics)({
            error: new Error(`No source field component found for ${sourceType}`),
            id: 'unmappedSourceType'
        });
        return null;
    }
    const { component: PickerComponent, extraProps: extraProps, label: label } = mappedSource;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EHpO.default), {
        key: `sourceValue-${sourceType}`,
        name: $327b54d1894940ae$export$2acdb7270c211b02,
        label: formatMessage(label),
        isRequired: true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PickerComponent, {
            key: `sourceValue-${sourceType}-picker`,
            label: formatMessage(label),
            ...fieldProps,
            ...extraProps
        }), error === $327b54d1894940ae$export$7b060a5763a6e199 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k5Wbc.ErrorMessage), {
            testId: "software-board-create.ui.modal.form.source-value-picker.error"
        }, formatMessage((0, $lq9tz.default).sourceValueEmptyError))));
};

});
parcelRegister("lq9tz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bce06a89957b13f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6bce06a89957b13f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueTypeFieldLabel: {
        "id": "software-board-create.modal.form.source-value-picker.issue-type-field-label",
        "defaultMessage": "Issue type"
    },
    teamFieldLabel: {
        "id": "software-board-create.modal.form.source-value-picker.team-field-label",
        "defaultMessage": "Team"
    },
    labelsFieldLabel: {
        "id": "software-board-create.modal.form.source-value-picker.labels-field-label",
        "defaultMessage": "Label"
    },
    savedFilterLabel: {
        "id": "software-board-create.modal.form.source-value-picker.saved-filter-label",
        "defaultMessage": "Select a saved filter"
    },
    sourceValueEmptyError: {
        "id": "software-board-create.modal.form.source-value-picker.source-value-empty-error",
        "defaultMessage": "Please select a value"
    }
});

});

parcelRegister("6r4tP", function(module, exports) {

$parcel$export(module.exports, "boardSourceFieldComponentMap", () => $735afc375e726c9d$export$69996e7483e1a92f);

var $h3KSk = parcelRequire("h3KSk");

var $aoE9s = parcelRequire("aoE9s");

var $lq9tz = parcelRequire("lq9tz");

var $bVi3d = parcelRequire("bVi3d");

var $d8KW7 = parcelRequire("d8KW7");
const $735afc375e726c9d$export$69996e7483e1a92f = {
    [(0, $h3KSk.BOARD_SOURCE_FIELDS).ISSUE_TYPES]: {
        component: (0, $aoE9s.GenericPicker),
        label: (0, $lq9tz.default).issueTypeFieldLabel,
        id: (0, $h3KSk.BOARD_SOURCE_FIELDS).ISSUE_TYPES,
        extraProps: {
            jqlTerm: (0, $h3KSk.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $h3KSk.BOARD_SOURCE_FIELDS).ISSUE_TYPES]
        }
    },
    [(0, $h3KSk.BOARD_SOURCE_FIELDS).TEAM]: {
        component: (0, $d8KW7.TeamPicker),
        label: (0, $lq9tz.default).teamFieldLabel,
        id: (0, $h3KSk.BOARD_SOURCE_FIELDS).TEAM
    },
    [(0, $h3KSk.BOARD_SOURCE_FIELDS).LABELS]: {
        component: (0, $aoE9s.GenericPicker),
        label: (0, $lq9tz.default).labelsFieldLabel,
        id: (0, $h3KSk.BOARD_SOURCE_FIELDS).LABELS,
        extraProps: {
            jqlTerm: (0, $h3KSk.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $h3KSk.BOARD_SOURCE_FIELDS).LABELS]
        }
    },
    [(0, $h3KSk.BOARD_SOURCE_FIELDS).SAVED_FILTER]: {
        component: (0, $bVi3d.SavedFilterPicker),
        label: (0, $lq9tz.default).savedFilterLabel,
        id: (0, $h3KSk.BOARD_SOURCE_FIELDS).SAVED_FILTER
    }
};

});
parcelRegister("aoE9s", function(module, exports) {

$parcel$export(module.exports, "GenericPicker", () => $e447e0e5a912af84$export$37d6fee5be00e6be);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $ew55A = parcelRequire("ew55A");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $2s57o = parcelRequire("2s57o");

var $ia3X2 = parcelRequire("ia3X2");

var $i0vxP = parcelRequire("i0vxP");

var $koVbs = parcelRequire("koVbs");

var $h3KSk = parcelRequire("h3KSk");

var $1eigM = parcelRequire("1eigM");

var $hp64R = parcelRequire("hp64R");
const $e447e0e5a912af84$var$formatOptionLabel = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        alignItems: "center"
    }, option.avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        xcss: $e447e0e5a912af84$var$imgStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew55A.default), {
        appearance: "square",
        size: "xsmall",
        src: option.avatar,
        borderColor: "transparent"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $e447e0e5a912af84$var$optionStyles
    }, option.label));
const $e447e0e5a912af84$export$37d6fee5be00e6be = ({ onChange: onChange, value: value, jqlTerm: jqlTerm, isInvalid: isInvalid, label: label })=>{
    const { loadOptions: loadOptions, isLoading: isLoading } = (0, $1eigM.useLoadOptionsController)();
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)();
    const [menuIsOpen, setMenuIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        loadOptions(jqlTerm)('').then((options)=>setDefaultOptions(options));
    }, [
        jqlTerm,
        loadOptions
    ]);
    const debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((searchString, callback)=>loadOptions(jqlTerm)(searchString).then((options)=>callback(options)), (0, $h3KSk.PICKER_SEARCH_DEBOUNCE_TIME));
    const handleOnKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (!menuIsOpen && (event.key === 'ArrowUp' || event.key === 'ArrowDown')) setMenuIsOpen(true);
        // close the menu when focusing on multi value to prevent enter key from propagating
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') setMenuIsOpen(false);
        // prevent form submission error
        if (event.key === 'Enter' && !menuIsOpen) event.preventDefault();
    }, [
        menuIsOpen
    ]);
    return /* Prevent ESC press on Select bubbling up to the modal */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i0vxP.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ia3X2.default), {
        "aria-label": label,
        isMulti: true,
        isLoading: isLoading,
        formatOptionLabel: $e447e0e5a912af84$var$formatOptionLabel,
        defaultOptions: defaultOptions,
        loadOptions: debouncedLoadOptions,
        onChange: onChange,
        value: value,
        placeholder: formatMessage((0, $hp64R.default).genericPickerPlaceholder),
        menuPosition: "fixed",
        classNamePrefix: "source-value-picker",
        isInvalid: isInvalid,
        onFocus: ()=>setMenuIsOpen(true),
        onBlur: ()=>setMenuIsOpen(false),
        menuIsOpen: menuIsOpen,
        blurInputOnSelect: false,
        onKeyDown: handleOnKeyDown
    }));
};
const $e447e0e5a912af84$var$imgStyles = (0, $2s57o.xcss)({
    paddingRight: 'space.100'
});
const $e447e0e5a912af84$var$optionStyles = (0, $2s57o.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});

});
parcelRegister("ia3X2", function(module, exports) {

$parcel$export(module.exports, "default", () => $85723568b4beed18$export$2e2bcd8739ae039);

var $fdJB9 = parcelRequire("fdJB9");

var $7Qatx = parcelRequire("7Qatx");
const $85723568b4beed18$var$AsyncSelect = (0, $7Qatx.default)((0, $fdJB9.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$85723568b4beed18$export$2e2bcd8739ae039 = $85723568b4beed18$var$AsyncSelect;

});

parcelRegister("1eigM", function(module, exports) {

$parcel$export(module.exports, "useLoadOptionsController", () => $7d96f2b549b45260$export$50422aa3bb02e176);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $h3KSk = parcelRequire("h3KSk");

var $6prxh = parcelRequire("6prxh");

var $hN9Wa = parcelRequire("hN9Wa");

var $2NRUh = parcelRequire("2NRUh");

var $96pTU = parcelRequire("96pTU");

var $cOgwf = parcelRequire("cOgwf");
const $7d96f2b549b45260$var$errorMessageMap = {
    [(0, $h3KSk.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $h3KSk.BOARD_SOURCE_FIELDS).ISSUE_TYPES]]: {
        title: (0, $cOgwf.default).failedToLoadIssueTypesTitle,
        description: (0, $cOgwf.default).failedToLoadIssueTypesDescription
    },
    [(0, $h3KSk.BOARD_SOURCE_FIELDS_JQLTERM)[(0, $h3KSk.BOARD_SOURCE_FIELDS).LABELS]]: {
        title: (0, $cOgwf.default).failedToLoadLabelsTitle,
        description: (0, $cOgwf.default).failedToLoadLabelsDescription
    },
    DEFAULT: {
        title: (0, $cOgwf.default).failedToLoadOptionsTitle,
        description: (0, $cOgwf.default).failedToLoadOptionsTitle
    }
};
const $7d96f2b549b45260$export$4dface15d86304a4 = ()=>(0, $5uXOq.useState)(false);
const $7d96f2b549b45260$export$50422aa3bb02e176 = ()=>{
    const { projectId: projectId } = (0, $2NRUh.useBoardCreateContext)();
    const jqlBuilderFetch = (0, $hN9Wa.useJQLBuilderFetch)({
        projectId: projectId
    });
    const [isLoading, setIsLoading] = $7d96f2b549b45260$export$4dface15d86304a4();
    const { showErrorFlag: showErrorFlag } = (0, $96pTU.useBoardCreateFlag)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const loadOptions = (0, $5uXOq.useCallback)((jqlTerm)=>async (searchString)=>{
            setIsLoading(true);
            return jqlBuilderFetch(jqlTerm, searchString).catch((error)=>{
                const errorText = $7d96f2b549b45260$var$errorMessageMap[jqlTerm] || $7d96f2b549b45260$var$errorMessageMap.DEFAULT;
                showErrorFlag({
                    title: formatMessage(errorText.title),
                    description: formatMessage(errorText.description)
                });
                (0, $6prxh.fireBoardCreateErrorAnalytics)({
                    error: new Error(`Failed to fetch picker options: ${error}`),
                    attributes: {
                        jqlTerm: jqlTerm
                    },
                    id: 'fetchPickerOptions'
                });
                return [];
            }).finally(()=>{
                setIsLoading(false);
            });
        }, [
        formatMessage,
        jqlBuilderFetch,
        setIsLoading,
        showErrorFlag
    ]);
    return {
        loadOptions: loadOptions,
        isLoading: isLoading
    };
};

});
parcelRegister("hN9Wa", function(module, exports) {

$parcel$export(module.exports, "useJQLBuilderFetch", () => $270d18388ecfb4c0$export$a8efb2384cee4751);

var $5xKik = parcelRequire("5xKik");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koeKL = parcelRequire("koeKL");
const $270d18388ecfb4c0$export$a8efb2384cee4751 = ({ projectId: projectId })=>{
    if (projectId === undefined) throw new Error('Project ID is undefined');
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useCallback)(async (jqlTerm, searchString)=>(0, $8Uumt.fetchQuery)(environment, (0, $5xKik.default), {
            cloudId: cloudId,
            jqlTerm: jqlTerm,
            jql: `project = ${projectId}`,
            searchString: searchString
        }).toPromise().then((response)=>{
            if (response?.jira?.jqlBuilder?.fieldValues?.edges) {
                const data = response.jira.jqlBuilder.fieldValues.edges.map((edge)=>{
                    if (jqlTerm === 'type') return {
                        label: edge?.node?.displayName || '',
                        value: edge?.node?.issueTypes && edge?.node?.issueTypes[0]?.issueTypeId || '',
                        avatar: edge?.node?.issueTypes && edge?.node?.issueTypes[0].avatar?.small || ''
                    };
                    return {
                        label: edge?.node?.displayName || '',
                        value: edge?.node?.displayName || ''
                    };
                }) || [];
                return data;
            }
            throw new Error('No response');
        }), [
        cloudId,
        environment,
        projectId
    ]);
};

});
parcelRegister("5xKik", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fa4b5f990b2941c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<88e6b74d9cd0f6199e352d7287cdc139>>
 * @relayHash 550be86a84988bdbd21f24b80ceb24b9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c1b5bc55b0e3a4a61ff20a7b89ec0bf355a6530849d7e75a79eb5d499feda60
const $2fa4b5f990b2941c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v8 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ 
        ],
        "type": "JiraJqlLabelFieldValue"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useJqlBuilderFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useJqlBuilderFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "id"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9c1b5bc55b0e3a4a61ff20a7b89ec0bf355a6530849d7e75a79eb5d499feda60",
            "metadata": {},
            "name": "useJqlBuilderFetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2fa4b5f990b2941c$var$node.hash = "f9c373fe0144a8b52692f108c8ed6461";
var $2fa4b5f990b2941c$export$2e2bcd8739ae039 = $2fa4b5f990b2941c$var$node;

});


parcelRegister("cOgwf", function(module, exports) {

$parcel$export(module.exports, "default", () => $df0d6f28e92c570a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $df0d6f28e92c570a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    failedToLoadIssueTypesTitle: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-issue-types-title",
        "defaultMessage": "We can\u2019t load issue types right now"
    },
    failedToLoadIssueTypesDescription: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-issue-types-description",
        "defaultMessage": "Refresh the page and try again."
    },
    failedToLoadLabelsTitle: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-labels-title",
        "defaultMessage": "We can\u2019t load labels right now"
    },
    failedToLoadLabelsDescription: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-labels-description",
        "defaultMessage": "Refresh the page and try again."
    },
    failedToLoadOptionsTitle: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-options-title",
        "defaultMessage": "Something went wrong"
    },
    failedToLoadOptionsDescription: {
        "id": "software-board-create.controllers.use-load-options-controller.failed-to-load-options-description",
        "defaultMessage": "Refresh the page and try again."
    }
});

});


parcelRegister("hp64R", function(module, exports) {

$parcel$export(module.exports, "default", () => $92cf92e0de820ada$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $92cf92e0de820ada$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    // Delete genericPickerAriaLabel when cleaning up nav4_simplified_board_create_beta
    genericPickerAriaLabel: {
        "id": "software-board-create.modal.form.source-value-picker.generic-picker.generic-picker-aria-label",
        "defaultMessage": "Select an option"
    },
    genericPickerPlaceholder: {
        "id": "software-board-create.modal.form.source-value-picker.generic-picker.generic-picker-placeholder",
        "defaultMessage": "Select"
    }
});

});


parcelRegister("bVi3d", function(module, exports) {

$parcel$export(module.exports, "SavedFilterPicker", () => $42f519acc50d59d9$export$7408ad1ebc985020);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $8nT7B = parcelRequire("8nT7B");

var $eWkgo = parcelRequire("eWkgo");

var $ia3X2 = parcelRequire("ia3X2");

var $i0vxP = parcelRequire("i0vxP");

var $koVbs = parcelRequire("koVbs");

var $h3KSk = parcelRequire("h3KSk");

var $j7OAx = parcelRequire("j7OAx");

var $jkPTf = parcelRequire("jkPTf");
const $42f519acc50d59d9$var$formatOptionLabel = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8nT7B))), {
        spacing: "spacious",
        label: option.label
    }), option.label);
const $42f519acc50d59d9$export$7408ad1ebc985020 = ({ onChange: onChange, value: value, isInvalid: isInvalid, label: label })=>{
    const { loadOptions: loadOptions, isLoading: isLoading } = (0, $j7OAx.useLoadSavedFiltersController)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((searchString, callback)=>loadOptions(searchString).then((options)=>callback(options)), (0, $h3KSk.PICKER_SEARCH_DEBOUNCE_TIME));
    return /* Prevent ESC press on Select bubbling up to the modal */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i0vxP.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ia3X2.default), {
        "aria-label": label,
        isLoading: isLoading,
        formatOptionLabel: $42f519acc50d59d9$var$formatOptionLabel,
        defaultOptions: true,
        loadOptions: debouncedLoadOptions,
        onChange: onChange,
        value: value,
        placeholder: formatMessage((0, $jkPTf.default).savedFilterPickerPlaceholder),
        menuPosition: "fixed",
        classNamePrefix: "source-value-picker",
        isInvalid: isInvalid
    }));
};

});
parcelRegister("j7OAx", function(module, exports) {

$parcel$export(module.exports, "useLoadSavedFiltersController", () => $c506adadb53c5f15$export$bb3a63b49faf836c);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $6p4sE = parcelRequire("6p4sE");

var $6prxh = parcelRequire("6prxh");

var $96S1K = parcelRequire("96S1K");

var $96pTU = parcelRequire("96pTU");
const $c506adadb53c5f15$export$4dface15d86304a4 = ()=>(0, $5uXOq.useState)(false);
const $c506adadb53c5f15$export$bb3a63b49faf836c = ()=>{
    const savedFiltersFetch = (0, $96S1K.useSavedFiltersFetch)();
    const [isLoading, setIsLoading] = $c506adadb53c5f15$export$4dface15d86304a4();
    const { showErrorFlag: showErrorFlag } = (0, $96pTU.useBoardCreateFlag)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const loadOptions = (0, $5uXOq.useCallback)(async (searchString)=>{
        setIsLoading(true);
        return savedFiltersFetch(searchString).catch((error)=>{
            showErrorFlag({
                title: formatMessage((0, $6p4sE.default).loadSavedFiltersErrorTitle),
                description: formatMessage((0, $6p4sE.default).loadSavedFiltersErrorDescription)
            });
            (0, $6prxh.fireBoardCreateErrorAnalytics)({
                error: new Error(`Failed to fetch saved filters: ${error}`),
                id: 'fetchSavedFilters'
            });
            return [];
        }).finally(()=>{
            setIsLoading(false);
        });
    }, [
        formatMessage,
        savedFiltersFetch,
        setIsLoading,
        showErrorFlag
    ]);
    return {
        loadOptions: loadOptions,
        isLoading: isLoading
    };
};

});
parcelRegister("96S1K", function(module, exports) {

$parcel$export(module.exports, "useSavedFiltersFetch", () => $c60033a932502cc6$export$919a4c273fb6b0e5);

var $hNMmP = parcelRequire("hNMmP");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koeKL = parcelRequire("koeKL");
const $c60033a932502cc6$export$919a4c273fb6b0e5 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useCallback)(async (searchString)=>(0, $8Uumt.fetchQuery)(environment, (0, $hNMmP.default), {
            cloudId: cloudId,
            searchString: searchString
        }).toPromise().then((response)=>{
            if (response?.jira?.savedFilters?.edges) {
                const data = response.jira.savedFilters.edges.map((edge)=>{
                    return {
                        label: edge?.node?.name || '',
                        value: edge?.node?.filterId || ''
                    };
                }) || [];
                return data;
            }
            throw new Error('No response');
        }), [
        cloudId,
        environment
    ]);
};

});
parcelRegister("hNMmP", function(module, exports) {

$parcel$export(module.exports, "default", () => $15727aff43405dba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7661fff4909318f923a859e991c3f990>>
 * @relayHash 6e5fec99171872e06e6faef5354994ff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c54fe404b07b4a4533c203ab6c68bf936d5a086953aa1a446da9bec5a0a67f5
const $15727aff43405dba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchString"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Variable",
            "name": "keyword",
            "variableName": "searchString"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "filterId"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ],
        "type": "JiraCustomFilter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSavedFiltersFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraFilterConnection",
                                "kind": "LinkedField",
                                "name": "savedFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.savedFilters.edges.node"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.savedFilters"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSavedFiltersFetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraFilterConnection",
                            "kind": "LinkedField",
                            "name": "savedFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1c54fe404b07b4a4533c203ab6c68bf936d5a086953aa1a446da9bec5a0a67f5",
            "metadata": {},
            "name": "useSavedFiltersFetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$15727aff43405dba$var$node.hash = "69a6cd0661c8d852b37f79d9513a1db0";
var $15727aff43405dba$export$2e2bcd8739ae039 = $15727aff43405dba$var$node;

});



parcelRegister("jkPTf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4a2c8c458ce637b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b4a2c8c458ce637b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    // Delete savedFilterPickerAriaLabel when cleaning up nav4_simplified_board_create_beta
    savedFilterPickerAriaLabel: {
        "id": "software-board-create.modal.form.source-value-picker.saved-filter-picker.saved-filter-picker-aria-label",
        "defaultMessage": "Select an option"
    },
    savedFilterPickerPlaceholder: {
        "id": "software-board-create.modal.form.source-value-picker.saved-filter-picker.saved-filter-picker-placeholder",
        "defaultMessage": "Select"
    }
});

});


parcelRegister("d8KW7", function(module, exports) {

$parcel$export(module.exports, "TeamPicker", () => $6335ae6b67167392$export$3529dc978be43e9d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $dqoiX = parcelRequire("dqoiX");

var $i0vxP = parcelRequire("i0vxP");

var $b71gk = parcelRequire("b71gk");

var $koVbs = parcelRequire("koVbs");

var $8vFwj = parcelRequire("8vFwj");

var $hgQ4J = parcelRequire("hgQ4J");

var $koeKL = parcelRequire("koeKL");

var $ghnVw = parcelRequire("ghnVw");
const $6335ae6b67167392$var$TEAM_A11Y_LABEL_ID = 'software-board-create.source-value.team';
const $6335ae6b67167392$export$3529dc978be43e9d = ({ onChange: onChange, value: value, isInvalid: isInvalid, label: label })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const handleOnCreate = (0, $5uXOq.useCallback)((team)=>{
        if (!team) return;
        // wait for the team to be created before updating the value
        setTimeout(()=>{
            onChange(team);
        }, 1000);
    }, [
        onChange
    ]);
    const [createTeamDialog, createTeamDialogTrigger] = (0, $8vFwj.useCreateTeamDialog)({
        onCreate: handleOnCreate
    });
    const handleChange = (team)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange?.(team || null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6335ae6b67167392$var$TeamPickerEditWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        id: $6335ae6b67167392$var$TEAM_A11Y_LABEL_ID
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i0vxP.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hgQ4J.TeamPickerEdit), {
        siteId: cloudId,
        isCompact: false,
        hasNoTeamOption: false,
        createTeamDialogTrigger: createTeamDialogTrigger,
        placeholder: formatMessage((0, $ghnVw.default).placeholder),
        onChange: handleChange,
        defaultValue: value,
        isDropdownMenuFixedAndLayered: true,
        isInvalid: isInvalid,
        isClearable: false,
        "aria-labelledby": $6335ae6b67167392$var$TEAM_A11Y_LABEL_ID
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "board-create-team-create-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
        tabIndex: -1,
        name: "create-team-dialog-form",
        onSubmit: (e)=>{
            e.stopPropagation();
        },
        className: (0, $bwpsq.default)([
            "_1e0cglyw"
        ])
    }, createTeamDialog)));
};
const $6335ae6b67167392$var$removeFormSpaceStyle = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $6335ae6b67167392$var$TeamPickerEditWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_b9cj1ylp _t0z71ylp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8vFwj", function(module, exports) {

$parcel$export(module.exports, "useCreateTeamDialog", () => $e708dcb0d93e7fe3$export$e8b8170429d616be);

var $5uXOq = parcelRequire("5uXOq");

var $2AtjH = parcelRequire("2AtjH");

var $pa9q9 = parcelRequire("pa9q9");

var $1wpPp = parcelRequire("1wpPp");

var $4ywcn = parcelRequire("4ywcn");

var $8igKv = parcelRequire("8igKv");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $cYlk7 = parcelRequire("cYlk7");

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");

var $goAXv = parcelRequire("goAXv");

var $b7Svb = parcelRequire("b7Svb");

const $e708dcb0d93e7fe3$export$75096afde50756fd = (0, $b7Svb.lazy)(()=>(parcelRequire("2VuRy")).then((module)=>module.TeamCreateDialog), {
    moduleId: "../platform/packages/people-and-teams/people-teams/src/index.ts"
});
const $e708dcb0d93e7fe3$export$e8b8170429d616be = (props = {})=>{
    const { locale: locale } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [inputTeamName, setInputTeamName] = (0, $5uXOq.useState)('');
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = tenantContext;
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { data: { user: user } } = (0, $cYlk7.useCurrentUser)();
    if (!atlassianAccountId && !user.accountId) throw new Error('Missing current user id');
    const addFlag = (0, $5uXOq.useCallback)(({ appearance: appearance, ...flagProps })=>{
        if (appearance === 'success' || appearance === 'normal') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ywcn.default), {
                messageId: "issue-field-create-team-dialog.ui.use-create-team-dialog.success-flag",
                messageType: "transactional",
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'warning') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8igKv.default), {
                messageId: "issue-field-create-team-dialog.ui.use-create-team-dialog.warning-flag",
                messageType: "transactional",
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'error') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wpPp.default), {
                messageId: "issue-field-create-team-dialog.ui.use-create-team-dialog.error-flag",
                messageType: "transactional",
                ...flagProps,
                ...serviceProps
            }));
    }, [
        showFlag
    ]);
    const { onCancel: onCancel } = {
        onCancel: ()=>null,
        ...props
    };
    const callback = (0, $5uXOq.useCallback)((teamName)=>{
        setInputTeamName(teamName);
        setIsOpen(true);
    }, []);
    const handleOnClose = ()=>{
        setIsOpen(false);
        onCancel();
    };
    const handleOnCreate = (team)=>{
        const formattedTeam = {
            ...team,
            name: team.displayName
        };
        props.onCreate?.(formattedTeam);
    };
    return [
        isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "team-create-dialog"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $goAXv.PeopleAndTeamsConfigurationProvider), {
            product: "jira",
            locale: (0, $2AtjH.default)(locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e708dcb0d93e7fe3$export$75096afde50756fd, {
            cloudId: cloudId,
            orgId: orgId,
            product: "jira",
            principalId: atlassianAccountId || user.accountId || '',
            onClose: handleOnClose,
            onCreateTeamSuccess: handleOnCreate,
            extraAnalyticsAttrs: props.analyticsCtx,
            enableMembershipSettingsChoice: true,
            currentUser: user.accountId ? {
                id: user.accountId,
                fullName: user.userFullname,
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
                ...user
            } : undefined,
            prepopulatedFields: {
                teamName: inputTeamName
            },
            addFlag: addFlag
        }))) : null,
        callback
    ];
};

});
parcelRegister("1wpPp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ebed3b5115fbfc5$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$2ebed3b5115fbfc5$export$2e2bcd8739ae039 = (0, $3KRpp.ErrorFlag);

});
parcelRegister("3KRpp", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $ef767762d5402ccf$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $ef767762d5402ccf$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $ef767762d5402ccf$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $ef767762d5402ccf$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $ef767762d5402ccf$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $ef767762d5402ccf$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $ef767762d5402ccf$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $ef767762d5402ccf$export$a2c3479950310d7d);

var $5uXOq = parcelRequire("5uXOq");

var $iNWLk = parcelRequire("iNWLk");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("iYvi5")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, $b7Svb.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("iYvi5")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, $b7Svb.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("ktXXH")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, $b7Svb.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("ktXXH")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));

});
parcelRegister("iNWLk", function(module, exports) {

$parcel$export(module.exports, "FlagsBoundary", () => $6377b132f88aa82c$export$8b4a0fffcddd96f4);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");
const $6377b132f88aa82c$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "flags",
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "flags-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, children));

});

parcelRegister("iYvi5", function(module, exports) {

let $dd061a425b165709$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dd061a425b165709$var$load("hPzOn"),
    $dd061a425b165709$var$load("h2MrD"),
    $dd061a425b165709$var$load("bYT2S"),
    $dd061a425b165709$var$load("cM9em"),
    $dd061a425b165709$var$load("fr9NE"),
    $dd061a425b165709$var$load("4yB9l")
]).then(()=>parcelRequire('8ZHDV'));

});

parcelRegister("ktXXH", function(module, exports) {

let $ee95073ee99eb1d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee95073ee99eb1d5$var$load("Fkef4").then(()=>parcelRequire('5pz6a'));

});



parcelRegister("4ywcn", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a612b92e24f3853$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$1a612b92e24f3853$export$2e2bcd8739ae039 = (0, $3KRpp.SuccessFlag);

});

parcelRegister("8igKv", function(module, exports) {

$parcel$export(module.exports, "default", () => $87b804070d792a00$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$87b804070d792a00$export$2e2bcd8739ae039 = (0, $3KRpp.WarningFlag);

});

parcelRegister("cYlk7", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $cdd4ab536fcf9459$export$3901076af3749fa9);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");

var $leRCk = parcelRequire("leRCk");
const $cdd4ab536fcf9459$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $lzeFL.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $cdd4ab536fcf9459$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $cdd4ab536fcf9459$var$useCurrentUserBasic();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $leRCk.useUserSubscriber)();
    (0, $5uXOq.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $cdd4ab536fcf9459$export$3901076af3749fa9 = ()=>(0, $9OXo1.useTenantContext)().isAnonymous ? $cdd4ab536fcf9459$var$useCurrentUserBasic() : $cdd4ab536fcf9459$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $cdd4ab536fcf9459$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $cdd4ab536fcf9459$export$3901076af3749fa9();
    return children(result);
};

});
parcelRegister("leRCk", function(module, exports) {

$parcel$export(module.exports, "UserContainer", () => $46a581f1f6efe569$export$7ff085589970ee0a);
$parcel$export(module.exports, "useUserSubscriber", () => $46a581f1f6efe569$export$4e61bbf568682a96);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $314C6 = parcelRequire("314C6");
const $46a581f1f6efe569$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $46a581f1f6efe569$var$Store = (0, $iXqE5.createStore)({
    name: 'user',
    initialState: $46a581f1f6efe569$var$initialState,
    actions: $314C6
});
const $46a581f1f6efe569$export$7ff085589970ee0a = (0, $gg7kZ.createContainer)($46a581f1f6efe569$var$Store);
const $46a581f1f6efe569$export$4e61bbf568682a96 = (0, $3sQ5x.createHook)($46a581f1f6efe569$var$Store);

});
parcelRegister("314C6", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $acdfee9161693eca$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iF3m5 = parcelRequire("iF3m5");
const $acdfee9161693eca$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!params || currentState.loading || currentState.data && !forceRefetch) return;
        setState({
            loading: true
        });
        try {
            const data = await (0, $iF3m5.fetchData)({
                params: params,
                header: header
            });
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err,
                loading: false
            });
        }
    };

});
parcelRegister("iF3m5", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $d22d4c6d892f61f1$export$8134c072fddab6a5);

var $ebyGx = parcelRequire("ebyGx");

var $8QpSo = parcelRequire("8QpSo");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $e5wyW = parcelRequire("e5wyW");

var $6Z846 = parcelRequire("6Z846");
const $d22d4c6d892f61f1$export$5e5a6664039ed1cc = ({ params: params, header: header })=>{
    const queryParams = {
        ...params,
        expand: Object.keys(params.expand || {}).filter((key)=>params.expand && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            params.expand[key])
    };
    const query = (0, $ebyGx.stringify)(queryParams, {
        arrayFormat: 'none'
    });
    const queryString = query ? `?${query}` : '';
    const requestUrl = `/rest/api/2/user${queryString}`;
    // @ts-expect-error - TS2345 - Argument of type '{ headers: HeaderParamForceAccountId; } | {}' is not assignable to parameter of type 'RequestInit | undefined'.
    return (0, $eusud.performGetRequest)(requestUrl, header ? {
        headers: header
    } : {});
};
const $d22d4c6d892f61f1$var$fetchDataNew = (0, $8QpSo.default)($d22d4c6d892f61f1$export$5e5a6664039ed1cc, (newArgs, lastArgs)=>// compare params and headers to see if it should be memoised.
    (0, $6Z846.isShallowEqual)(newArgs[0].params, lastArgs[0].params) && (0, $6Z846.isShallowEqual)(newArgs[0].header, lastArgs[0].header));
const $d22d4c6d892f61f1$export$8134c072fddab6a5 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('user-iv-llc-unnecessary-api'), $d22d4c6d892f61f1$var$fetchDataNew, $d22d4c6d892f61f1$export$5e5a6664039ed1cc);

});




parcelRegister("2VuRy", function(module, exports) {

let $2218d85ac47c176b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2218d85ac47c176b$var$load("cM9em"),
    $2218d85ac47c176b$var$load("fr9NE"),
    $2218d85ac47c176b$var$load("hPzOn"),
    $2218d85ac47c176b$var$load("WkrjP")
]).then(()=>parcelRequire('kgkOk'));

});


parcelRegister("hgQ4J", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "TeamPickerEdit", () => $a2ba033eb79fbb50$export$cb5f622bec189851);
$parcel$export(module.exports, "TeamPickerEditEntryPointContent", () => $a2ba033eb79fbb50$export$93a79bad2594cfb5);
$parcel$export(module.exports, "default", () => $a2ba033eb79fbb50$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iD8A5 = parcelRequire("iD8A5");

var $4qXN2 = parcelRequire("4qXN2");

var $koVbs = parcelRequire("koVbs");

var $lElIo = parcelRequire("lElIo");

var $14XJw = parcelRequire("14XJw");


var $4vyX4 = parcelRequire("4vyX4");

var $lWune = parcelRequire("lWune");

var $fAxaP = parcelRequire("fAxaP");
// FIXME: These are overrides for @atlaskit/select@15.6 -> react-select@4.3.x
//        Once @atlaskit/select@15.6 resolution has been removed from package.json
//        these should be removed as well. See PTC-6238.
const $a2ba033eb79fbb50$var$stylesOverrides = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    valueContainer: (base)=>({
            ...base,
            display: 'grid'
        }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    placeholder: (base)=>({
            ...base,
            position: undefined,
            top: undefined,
            left: undefined,
            transform: undefined
        })
};
const $a2ba033eb79fbb50$export$cb5f622bec189851 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { siteId: siteId, defaultValue: defaultValue, isClearable: isClearable = true, isDisabled: isDisabled = false, isInvalid: isInvalid = false, autoFocus: autoFocus = false, width: width = '100%', debounceTime: debounceTime = 300, onChange: onChange, placeholder: placeholder = formatMessage((0, $4vyX4.default).placeholderTeamEditSelector), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, styles: styles, noValueText: noValueText, createTeamDialogTrigger: createTeamDialogTrigger, isCompact: isCompact = true, hasNoTeamOption: hasNoTeamOption = true, ...fieldProps } = props;
    const [isCreateButtonFocused, setIsCreateButtonFocused] = (0, $5uXOq.useState)(false);
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const [hasTeams, setHasTeams] = (0, $5uXOq.useState)(true);
    const formattedNoValueText = formatMessage((0, $4vyX4.default).defaultNoValueText);
    const [updatedPlaceholder, setUpdatedPlaceholder] = (0, $5uXOq.useState)(placeholder);
    const [inputQuery, setInputQuery] = (0, $5uXOq.useState)('');
    const finalStyles = {
        ...(0, $lElIo.defaultSelectStyles),
        ...styles || {},
        ...$a2ba033eb79fbb50$var$stylesOverrides
    };
    const maybeAddNoTeamOption = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'users' implicitly has an 'any' type.
    (users, query)=>{
        setHasTeams(!(users.length === 0 && query.length === 0));
        if (query === '' && !!defaultValue && hasNoTeamOption) return [
            {
                avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($4qXN2))),
                id: (0, $7808beff4be6dc7e$export$53782b65600ab96d),
                name: noValueText ?? formattedNoValueText,
                isVerified: false
            }
        ].concat(users);
        setIsCreateButtonFocused(query.length > 0 && users.length === 0);
        return users;
    }, [
        defaultValue,
        noValueText,
        formattedNoValueText,
        hasNoTeamOption
    ]);
    const handleOnChange = (newValue, actionType)=>{
        if (Array.isArray(newValue)) return;
        if (onChange) {
            onChange(newValue?.id === (0, $7808beff4be6dc7e$export$53782b65600ab96d) ? null : newValue, actionType);
            setUpdatedPlaceholder(newValue?.id === (0, $7808beff4be6dc7e$export$53782b65600ab96d) ? formattedNoValueText : placeholder);
        }
    };
    const handleCreateTeam = (0, $5uXOq.useCallback)(()=>{
        createTeamDialogTrigger(inputQuery);
    }, [
        inputQuery,
        createTeamDialogTrigger
    ]);
    const handleOnKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (isCreateButtonFocused && event.key === 'Enter') handleCreateTeam();
    }, [
        isCreateButtonFocused,
        handleCreateTeam
    ]);
    const handleOnInputChange = (0, $5uXOq.useCallback)((query)=>{
        setInputQuery(query || '');
    }, [
        setInputQuery
    ]);
    const footer = (0, $5uXOq.useMemo)(()=>hasTeams && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lWune.CreateTeamOption), {
            isFocused: isCreateButtonFocused,
            onClick: handleCreateTeam
        }), [
        hasTeams,
        handleCreateTeam,
        isCreateButtonFocused
    ]);
    const noOptionsMessage = (0, $5uXOq.useMemo)(()=>!hasTeams ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fAxaP.TeamPickerEmptyState), {
                onActionClick: handleCreateTeam
            }) : undefined, [
        hasTeams,
        handleCreateTeam
    ]);
    const menuListStyle = (0, $5uXOq.useMemo)(()=>!hasTeams ? {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            menuList: (base)=>({
                    ...base,
                    maxHeight: '350px'
                })
        } : {}, [
        hasTeams
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iD8A5.default), {
        // Setting width=100% will allow dropdown to size correctly
        width: width,
        autoFocus: autoFocus,
        appearance: isCompact ? 'compact' : 'normal',
        debounceTime: debounceTime,
        fieldId: "team",
        filterOptions: maybeAddNoTeamOption,
        footer: footer,
        includeGroups: false,
        includeTeams: true,
        includeUsers: false,
        isClearable: isClearable,
        isMulti: false,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        productKey: "jira",
        siteId: siteId,
        value: defaultValue,
        onChange: handleOnChange,
        orgId: orgId,
        placeholder: updatedPlaceholder,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: {
            ...finalStyles,
            ...menuListStyle
        },
        onInputChange: handleOnInputChange,
        onKeyDown: handleOnKeyDown,
        noOptionsMessage: noOptionsMessage,
        ariaLabel: updatedPlaceholder,
        ariaLabelledBy: fieldProps['aria-labelledby'],
        placeholderAvatar: "team"
    });
};
const $a2ba033eb79fbb50$export$93a79bad2594cfb5 = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2ba033eb79fbb50$export$cb5f622bec189851, props);
var $a2ba033eb79fbb50$export$2e2bcd8739ae039 = $a2ba033eb79fbb50$export$cb5f622bec189851;

});
parcelRegister("iD8A5", function(module, exports) {

$parcel$export(module.exports, "default", () => $672710a0700f9a3c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8tVwp = parcelRequire("8tVwp");

var $4UD2C = parcelRequire("4UD2C");

var $NrOEV = parcelRequire("NrOEV");
const $672710a0700f9a3c$var$SmartUserPickerWithIntlProvider = (props)=>{
    const ufoId = props.inputId || props.fieldId;
    (0, $NrOEV.useUFOConcurrentExperience)((0, $NrOEV.smartUserPickerRenderedUfoExperience), ufoId);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $NrOEV.UfoErrorBoundary), {
        id: ufoId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4UD2C.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8tVwp.SmartUserPicker), {
                ...props
            })
        })
    });
};
var $672710a0700f9a3c$export$2e2bcd8739ae039 = $672710a0700f9a3c$var$SmartUserPickerWithIntlProvider;

});
parcelRegister("8tVwp", function(module, exports) {

$parcel$export(module.exports, "SmartUserPicker", () => $fb3fb986951b7cd2$export$9eedb6e5d313efdb);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $7Jxgt = parcelRequire("7Jxgt");

var $3TR0I = parcelRequire("3TR0I");

var $8QpSo = parcelRequire("8QpSo");

var $8RXs9 = parcelRequire("8RXs9");

var $e35GK = parcelRequire("e35GK");

var $4kIK6 = parcelRequire("4kIK6");
var $grXIr = parcelRequire("grXIr");

var $3rwqT = parcelRequire("3rwqT");

var $4UD2C = parcelRequire("4UD2C");

var $lWjud = parcelRequire("lWjud");
var $efnVP = parcelRequire("efnVP");

var $NrOEV = parcelRequire("NrOEV");
const $fb3fb986951b7cd2$var$DEFAULT_DEBOUNCE_TIME_MS = 150;
const $fb3fb986951b7cd2$var$ufoEndStateConfig = (fieldId)=>{
    return {
        metadata: {
            contextType: fieldId
        }
    };
};
const $fb3fb986951b7cd2$var$hasContextChanged = (oldContext, newContext)=>oldContext.siteId !== newContext.siteId || oldContext.orgId !== newContext.orgId || oldContext.productKey !== newContext.productKey || oldContext.principalId !== newContext.principalId || oldContext.containerId !== newContext.containerId || oldContext.objectId !== newContext.objectId || oldContext.childObjectId !== newContext.childObjectId;
const $fb3fb986951b7cd2$var$stringContains = (str, substr)=>{
    if (str === null || str === undefined) return false;
    if (substr === null || substr === '' || substr === undefined) return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $fb3fb986951b7cd2$var$getUsersForAnalytics = (users)=>(users || []).map(({ id: id, type: type })=>({
            id: id,
            type: type
        }));
const $fb3fb986951b7cd2$var$checkIf500Event = (statusCode)=>500 <= statusCode && statusCode < 600;
class $fb3fb986951b7cd2$export$9b9bd453d1d4e4ce extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            baseUrl: '',
            includeUsers: true,
            includeGroups: false,
            includeTeams: false,
            includeNonLicensedUsers: false,
            prefetch: false,
            principalId: 'Context',
            debounceTime: $fb3fb986951b7cd2$var$DEFAULT_DEBOUNCE_TIME_MS
        };
    }
    constructor(props){
        super(props), this.state = {
            users: [],
            loading: false,
            closed: true,
            query: '',
            defaultValue: [],
            bootstrapOptions: []
        }, this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $e35GK.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        }, this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        }, this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $3rwqT.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, ...args))(createAnalyticsEvent);
        }, this.filterOptions = (users, query, propFilterOptions)=>propFilterOptions ? propFilterOptions(users, query) : users, this.memoizedFilterOptions = (0, $8QpSo.default)(this.filterOptions), this.getUsers = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(async ()=>{
            const { query: query, sessionId: sessionId, closed: closed } = this.state;
            const { baseUrl: baseUrl, childObjectId: childObjectId, containerId: containerId, fieldId: fieldId, includeGroups: includeGroups, includeTeams: includeTeams, includeUsers: includeUsers, includeNonLicensedUsers: includeNonLicensedUsers, intl: intl, maxOptions: maxOptions, objectId: objectId, onEmpty: onEmpty, onError: onError, overrideByline: overrideByline, orgId: orgId, principalId: principalId, productAttributes: productAttributes, productKey: productKey, searchQueryFilter: searchQueryFilter, siteId: siteId } = this.props;
            const maxNumberOfResults = maxOptions || 100;
            const startTime = window.performance.now();
            const recommendationsRequest = {
                baseUrl: baseUrl,
                context: {
                    containerId: containerId,
                    contextType: fieldId,
                    objectId: objectId,
                    principalId: principalId,
                    productKey: productKey,
                    siteId: siteId,
                    organizationId: orgId,
                    childObjectId: childObjectId,
                    sessionId: sessionId,
                    productAttributes: productAttributes
                },
                includeUsers: includeUsers,
                includeGroups: includeGroups,
                includeTeams: includeTeams,
                includeNonLicensedUsers: includeNonLicensedUsers,
                maxNumberOfResults: maxNumberOfResults,
                query: query,
                searchQueryFilter: searchQueryFilter
            };
            try {
                this.fireEvent((0, $3rwqT.requestUsersEvent));
                const recommendedUsers = await (0, $lWjud.default)(recommendationsRequest, intl);
                if (overrideByline) {
                    for (let option of recommendedUsers)if ((0, $grXIr.isUser)(option) || (0, $grXIr.isExternalUser)(option) || (0, $grXIr.isTeam)(option)) option.byline = overrideByline(option);
                }
                const elapsedTimeMilli = window.performance.now() - startTime;
                const displayedUsers = recommendedUsers.length === 0 && onEmpty ? await onEmpty(query) ?? [] : recommendedUsers;
                this.setState((state)=>{
                    const applicable = state.query === query;
                    const users = applicable ? displayedUsers : state.users;
                    const loading = !applicable;
                    this.fireEvent((0, $3rwqT.successfulRequestUsersEvent), {
                        users: $fb3fb986951b7cd2$var$getUsersForAnalytics(recommendedUsers),
                        elapsedTimeMilli: elapsedTimeMilli,
                        displayedUsers: $fb3fb986951b7cd2$var$getUsersForAnalytics(displayedUsers),
                        productAttributes: productAttributes,
                        applicable: applicable
                    });
                    return {
                        users: users,
                        loading: loading
                    };
                });
            } catch (e) {
                const is5xxEvent = $fb3fb986951b7cd2$var$checkIf500Event(e.statusCode);
                if (!closed && !onError && is5xxEvent) // If the user lookup fails while the menu is open, and the consumer is not providing a
                // fallback data source via the onError prop, then send UFO failure
                this.optionsShownUfoExperienceInstance.failure($fb3fb986951b7cd2$var$ufoEndStateConfig(this.props.fieldId));
                this.setState({
                    users: []
                });
                let onErrorProducedError = false;
                let defaultUsers = [];
                try {
                    defaultUsers = onError ? await onError(e, recommendationsRequest) || [] : [];
                } catch (error) {
                    onErrorProducedError = true;
                }
                if (onErrorProducedError && is5xxEvent) // Log error from fallback data source `onError` to UFO
                this.optionsShownUfoExperienceInstance.failure($fb3fb986951b7cd2$var$ufoEndStateConfig(this.props.fieldId));
                if (!is5xxEvent && (!onError && !closed || onErrorProducedError)) this.abortOptionsShownUfoExperience();
                this.setState({
                    users: defaultUsers,
                    loading: false
                });
                const elapsedTimeMilli = window.performance.now() - startTime;
                this.fireEvent((0, $3rwqT.failedRequestUsersEvent), {
                    elapsedTimeMilli: elapsedTimeMilli,
                    productAttributes: productAttributes
                });
            }
        }, this.props.debounceTime ?? 0), this.onInputChange = (newQuery, sessionId)=>{
            const query = newQuery || '';
            const { closed: closed } = this.state;
            if (query === this.state.query) return;
            if (!closed) {
                // If the input has been typed into and the dropdown has not been closed
                // (i.e. input blurred) then start the UFO timer.
                // If there's a previous UFO timer running for the same "options shown" experience,
                // it will be aborted first.
                this.startOptionsShownUfoExperience();
                this.setState({
                    loading: true,
                    query: query,
                    sessionId: sessionId
                });
                if (this.props.onInputChange) this.props.onInputChange(query, sessionId);
            }
        }, this.filterUsers = ()=>{
            const { loading: loading, users: users, query: query } = this.state;
            const filteredUsers = this.memoizedFilterOptions(users, query, this.props.filterOptions);
            //If bootstrapOptions have been passed in and it is bootstrap
            if (this.props.bootstrapOptions && this.props.bootstrapOptions.length !== 0 && query === '') {
                const bootstrapFilteredUsers = this.memoizedFilterOptions(this.props.bootstrapOptions, query, this.props.filterOptions);
                this.fireEvent((0, $3rwqT.filterUsersEvent), {
                    filtered: $fb3fb986951b7cd2$var$getUsersForAnalytics(bootstrapFilteredUsers),
                    all: $fb3fb986951b7cd2$var$getUsersForAnalytics(this.props.bootstrapOptions)
                });
                return bootstrapFilteredUsers;
            }
            // while when not loading just return already filtered result from server.
            if (!loading) return filteredUsers;
            const queryFilteredUsers = filteredUsers.filter((user)=>$fb3fb986951b7cd2$var$stringContains(user.name, query));
            this.fireEvent((0, $3rwqT.filterUsersEvent), {
                filtered: $fb3fb986951b7cd2$var$getUsersForAnalytics(queryFilteredUsers),
                all: $fb3fb986951b7cd2$var$getUsersForAnalytics(users)
            });
            // when loading filter previous result.
            return filteredUsers;
        }, this.onFocus = (sessionId)=>{
            const state = {
                query: '',
                closed: false
            };
            this.startOptionsShownUfoExperience();
            if (this.state.users.length === 0) {
                state.sessionId = sessionId;
                state.loading = true;
            } else this.fireEvent((0, $3rwqT.preparedUsersLoadedEvent), {
                users: $fb3fb986951b7cd2$var$getUsersForAnalytics(this.state.users),
                preparedSessionId: this.state.sessionId,
                sessionId: sessionId
            });
            this.setState((currentState)=>({
                    ...currentState,
                    ...state
                }));
            if (this.props.onFocus) this.props.onFocus(sessionId);
        }, this.onBlur = (sessionId)=>{
            this.getUsers.cancel();
            this.abortOptionsShownUfoExperience();
            // clear old users if query is populated so that on refocus,
            // the old list is not shown
            const users = this.state.query.length === 0 ? this.state.users : [];
            this.setState({
                loading: false,
                closed: true,
                users: users
            });
            if (this.props.onBlur) this.props.onBlur(sessionId);
        };
        this.optionsShownUfoExperienceInstance = (0, $NrOEV.smartUserPickerOptionsShownUfoExperience).getInstance(props.inputId || props.fieldId);
    }
    async componentDidMount() {
        try {
            const value = await (0, $efnVP.default)(this.props.baseUrl, this.props.defaultValue, this.props.productKey);
            this.setState({
                defaultValue: value
            });
        } catch (e) {
            const defaultValue = await (this.props.onValueError ? this.props.onValueError(e, this.props.defaultValue) || Promise.resolve([]) : Promise.resolve([]));
            this.setState({
                defaultValue: defaultValue
            });
        }
        const { prefetch: prefetch } = this.props;
        if (prefetch) {
            const sessionId = (0, $7Jxgt.v4)();
            this.fireEvent((0, $3rwqT.mountedWithPrefetchEvent), {
                sessionId: sessionId
            });
            this.setState({
                sessionId: sessionId
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if ($fb3fb986951b7cd2$var$hasContextChanged(prevProps, this.props) || this.props.fieldId !== prevProps.fieldId) this.setState({
            users: []
        });
        if ((this.state.sessionId !== prevState.sessionId || this.state.query !== prevState.query) && (this.state.query !== '' || !this.props.bootstrapOptions)) this.getUsers();
        else if (!this.state.closed && !this.state.loading) // If the component has rendered (including its dropdown list) and it
        // is not loading anything further, send the success UFO event
        {
            if (![
                (0, $e35GK.UFOExperienceState).FAILED.id,
                (0, $e35GK.UFOExperienceState).SUCCEEDED.id,
                (0, $e35GK.UFOExperienceState).ABORTED.id
            ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success($fb3fb986951b7cd2$var$ufoEndStateConfig(this.props.fieldId));
        }
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4UD2C.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4kIK6.UserPicker), {
                ...this.props,
                onInputChange: this.onInputChange,
                onBlur: this.onBlur,
                onFocus: this.onFocus,
                defaultValue: this.state.defaultValue,
                isLoading: this.props.isLoading || this.state.loading && !this.state.closed && (!this.props.bootstrapOptions || this.state.query !== ''),
                options: this.filterUsers()
            })
        });
    }
}
const $fb3fb986951b7cd2$export$9eedb6e5d313efdb = (0, $3TR0I.default)()((0, $8RXs9.default)($fb3fb986951b7cd2$export$9b9bd453d1d4e4ce));

});
parcelRegister("e35GK", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $1f5d1c831717fc17$export$81b70111112841a0);
const $1f5d1c831717fc17$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("4kIK6", function(module, exports) {

$parcel$export(module.exports, "UserPicker", () => $66beadc127696f3d$export$83e0c73b09b3a9cd);

var $2OMIu = parcelRequire("2OMIu");

var $3TR0I = parcelRequire("3TR0I");

var $8p2Od = parcelRequire("8p2Od");
var $lau8t = parcelRequire("lau8t");

var $e35GK = parcelRequire("e35GK");

var $5uXOq = parcelRequire("5uXOq");

var $8vKcg = parcelRequire("8vKcg");

var $lor1T = parcelRequire("lor1T");

var $cnoGa = parcelRequire("cnoGa");

var $5kiFd = parcelRequire("5kiFd");

var $gqIZX = parcelRequire("gqIZX");

var $l30aB = parcelRequire("l30aB");

var $b3Vox = parcelRequire("b3Vox");

var $dhLc4 = parcelRequire("dhLc4");

var $7Jxgt = parcelRequire("7Jxgt");

var $fHpHg = parcelRequire("fHpHg");
class $66beadc127696f3d$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.ufoId = (0, $7Jxgt.v4)();
        const experienceForId = (0, $dhLc4.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        if (![
            (0, $e35GK.UFOExperienceState).IN_PROGRESS.id,
            (0, $e35GK.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.start();
    }
    static{
        this.defaultProps = {
            width: 350,
            isMulti: false
        };
    }
    componentDidMount() {
        const experienceForId = (0, $dhLc4.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $e35GK.UFOExperienceState).IN_PROGRESS.id,
            (0, $e35GK.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, required: required = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $8p2Od.default) : (0, $lau8t.default);
        const creatableProps = suggestEmailsForDomain ? (0, $gqIZX.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $5kiFd.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dhLc4.UfoErrorBoundary), {
            id: this.ufoId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l30aB.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b3Vox.ExusUserSourceProvider), {
                    fetchUserSource: loadUserSource,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8vKcg.BaseUserPickerWithoutAnalytics), {
                        ...this.props,
                        width: width,
                        SelectComponent: SelectComponent,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        styles: (0, $lor1T.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, this.props.isInvalid, // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
                        (0, $fHpHg.fg)('platform-component-visual-refresh') && (0, $fHpHg.fg)('visual-refresh-user-picker')),
                        components: (0, $cnoGa.getComponents)(isMulti, anchor),
                        pickerProps: pickerProps
                    })
                })
            })
        });
    }
}
const $66beadc127696f3d$export$83e0c73b09b3a9cd = (0, $3TR0I.default)()($66beadc127696f3d$export$164f4d95e5d7e2f5);

});
parcelRegister("8p2Od", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1f8ddcf2a6bdb8a$export$2e2bcd8739ae039);

var $793nn = parcelRequire("793nn");

var $7Qatx = parcelRequire("7Qatx");
const $e1f8ddcf2a6bdb8a$var$CreatableSelect = (0, $7Qatx.default)((0, $793nn.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e1f8ddcf2a6bdb8a$export$2e2bcd8739ae039 = $e1f8ddcf2a6bdb8a$var$CreatableSelect;

});
parcelRegister("793nn", function(module, exports) {

$parcel$export(module.exports, "default", () => $221e646eec2f5412$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("jtdsb")).default);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $djBXi = parcelRequire("djBXi");

var $jtdsb = parcelRequire("jtdsb");

var $63z2N = parcelRequire("63z2N");
const $221e646eec2f5412$var$CreatableSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const creatableProps = (0, $63z2N.default)(props);
    const selectProps = (0, $jtdsb.default)(creatableProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $djBXi.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$221e646eec2f5412$export$2e2bcd8739ae039 = $221e646eec2f5412$var$CreatableSelect;

});
parcelRegister("jtdsb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4f1728a626c2897$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jwj8k = parcelRequire("jwj8k");

var $b0fMV = parcelRequire("b0fMV");
const $b4f1728a626c2897$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $b4f1728a626c2897$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$b4f1728a626c2897$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$b4f1728a626c2897$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $b4f1728a626c2897$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $b4f1728a626c2897$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $b4f1728a626c2897$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $b4f1728a626c2897$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $jwj8k.getOptionValue), getOptionLabel: getOptionLabel = (0, $jwj8k.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $5uXOq.useMemo)(()=>isValidNewOption(inputValue, (0, $b0fMV.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $5uXOq.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $b0fMV.valueTernary)(isMulti, [
                    ...(0, $b0fMV.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});



parcelRegister("8vKcg", function(module, exports) {

$parcel$export(module.exports, "BaseUserPickerWithoutAnalytics", () => $272ffc26a690b187$export$b4ff48c8d43b18c3);

var $2OMIu = parcelRequire("2OMIu");

var $3TR0I = parcelRequire("3TR0I");

var $e35GK = parcelRequire("e35GK");

var $lFKmC = parcelRequire("lFKmC");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fHpHg = parcelRequire("fHpHg");

var $7Jxgt = parcelRequire("7Jxgt");

var $fDHET = parcelRequire("fDHET");

var $f3Ls0 = parcelRequire("f3Ls0");

var $4NWOr = parcelRequire("4NWOr");

var $grXIr = parcelRequire("grXIr");

var $dhLc4 = parcelRequire("dhLc4");
const $272ffc26a690b187$var$loadingMessage = ()=>null;
const $272ffc26a690b187$var$classNamePrefix = 'fabric-user-picker';
class $272ffc26a690b187$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isMulti: false,
            subtle: false,
            noBorder: false,
            textFieldBackgroundColor: false,
            isClearable: true,
            loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $4NWOr.messages).errorMessage
                }),
            openMenuOnClick: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $grXIr.optionToSelectableOptions)(nextProps.value);
        else if ((0, $grXIr.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $grXIr.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    constructor(props){
        super(props), this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined, this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            }, this.nextOption = this.withSelectRef((select)=>select.focusOption('down')), this.previousOption = this.withSelectRef((select)=>select.focusOption('up')), this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        }, this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        }, this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        }), // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $grXIr.callCallback)(onChange, (0, $grXIr.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $grXIr.callCallback)(onSelection, (0, $grXIr.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $fDHET.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $fDHET.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $grXIr.callCallback)(onClear);
                    this.fireEvent((0, $fDHET.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $fDHET.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $fDHET.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        }, this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        }, this.addOptions = (0, $f3Ls0.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        }), this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $fDHET.failedEvent));
        }, this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) {
                const inflightRequest = this.state.inflightRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $grXIr.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                this.setState({
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                });
            }
        }, 200), this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $e35GK.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        }, this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        }, this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        }, this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $grXIr.callCallback)(this.props.onFocus, this.getSessionId());
            if (!this.isMenuOpenOnClickForSingleSelect) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $grXIr.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        }, this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $grXIr.callCallback)(this.props.onInputChange, '', this.getSessionId());
        }, this.handleBlur = ()=>{
            (0, $grXIr.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $grXIr.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        }, this.handleOpen = ()=>{
            (0, $grXIr.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        }, this.handleClose = ()=>{
            this.resetInputState();
            (0, $grXIr.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        }, this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $grXIr.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        }, this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $fDHET.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        }, this.startSession = ()=>{
            this.session = (0, $fDHET.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $fDHET.focusEvent));
        }, this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
        }, this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        }, this.getOptions = ()=>{
            const options = (0, $grXIr.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return filteredOptions.slice(0, maxOptions);
            }
            return options;
        }, this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal', this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        };
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = (0, $dhLc4.userPickerOptionsShownUfoExperience).getInstance((0, $7Jxgt.v4)());
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(_, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $fDHET.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $fDHET.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!_.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $e35GK.UFOExperienceState).STARTED.id,
            (0, $e35GK.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: true
            }
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            "aria-labelledby": ariaLabelledBy,
            "aria-describedby": (0, $fHpHg.fg)('pass-aria-describedby-to-baseuserpicker') ? ariaDescribedBy : undefined,
            "aria-label": ariaLabel,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $272ffc26a690b187$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $4NWOr.messages).placeholder
            }),
            addMoreMessage: addMoreMessage,
            classNamePrefix: $272ffc26a690b187$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...this.ariaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
}
const $272ffc26a690b187$export$d099ade7b4f4d2a4 = (0, $3TR0I.default)()($272ffc26a690b187$export$b4ff48c8d43b18c3);

});
parcelRegister("fDHET", function(module, exports) {

$parcel$export(module.exports, "startSession", () => $23708db1428e0cef$export$c0d84948cecf78d8);
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $23708db1428e0cef$export$53eef0dcd9611650);
$parcel$export(module.exports, "focusEvent", () => $23708db1428e0cef$export$e7818c470f37c4bd);
$parcel$export(module.exports, "clearEvent", () => $23708db1428e0cef$export$7b5800e732182efb);
$parcel$export(module.exports, "deleteEvent", () => $23708db1428e0cef$export$95711ec6c6227e9a);
$parcel$export(module.exports, "cancelEvent", () => $23708db1428e0cef$export$e9caaaecfee38128);
$parcel$export(module.exports, "selectEvent", () => $23708db1428e0cef$export$48143d759475d90f);
$parcel$export(module.exports, "searchedEvent", () => $23708db1428e0cef$export$911fb7184b6037eb);
$parcel$export(module.exports, "failedEvent", () => $23708db1428e0cef$export$c2aec355fef65c9c);
$parcel$export(module.exports, "userInfoEvent", () => $23708db1428e0cef$export$f541f04954b0c11e);

var $9Iej8 = parcelRequire("9Iej8");

var $7Jxgt = parcelRequire("7Jxgt");

var $grXIr = parcelRequire("grXIr");
const $23708db1428e0cef$var$packageName = "platform-pkg";
const $23708db1428e0cef$var$packageVersion = "0.0.0-use.local";
const $23708db1428e0cef$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $23708db1428e0cef$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $23708db1428e0cef$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $23708db1428e0cef$export$c0d84948cecf78d8 = ()=>({
        id: (0, $7Jxgt.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $23708db1428e0cef$export$53eef0dcd9611650 = (0, $9Iej8.default)('fabric-elements');
const $23708db1428e0cef$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $23708db1428e0cef$var$packageName,
            packageVersion: $23708db1428e0cef$var$packageVersion,
            ...attributes
        }
    });
const $23708db1428e0cef$var$checkValidId = (id)=>{
    return $23708db1428e0cef$var$UUID_REGEXP_NEW_AAID.test(id) || $23708db1428e0cef$var$UUID_REGEXP_OLD_AAID.test(id) || $23708db1428e0cef$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $23708db1428e0cef$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $23708db1428e0cef$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $grXIr.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $grXIr.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $23708db1428e0cef$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$23708db1428e0cef$var$optionData2Analytics(data));
    }
    return [];
};
const $23708db1428e0cef$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $23708db1428e0cef$var$sessionId(session),
        pickerType: $23708db1428e0cef$var$pickerType(props),
        journeyId: journeyId
    });
const $23708db1428e0cef$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$23708db1428e0cef$var$createEvent('ui', 'focused', 'userPicker', {
        ...$23708db1428e0cef$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $23708db1428e0cef$var$buildValueForAnalytics(state.value)
    });
const $23708db1428e0cef$export$7b5800e732182efb = (props, state, session, journeyId)=>$23708db1428e0cef$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$23708db1428e0cef$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $23708db1428e0cef$var$values(state)
    });
const $23708db1428e0cef$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$23708db1428e0cef$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $23708db1428e0cef$var$sessionId(session),
        journeyId: journeyId,
        value: $23708db1428e0cef$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen
    });
const $23708db1428e0cef$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$23708db1428e0cef$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$23708db1428e0cef$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $23708db1428e0cef$var$sessionDuration(session),
        queryLength: $23708db1428e0cef$var$queryLength(args[0]),
        spaceInQuery: $23708db1428e0cef$var$spaceInQuery(args[0]),
        upKeyCount: $23708db1428e0cef$var$upKeyCount(session),
        downKeyCount: $23708db1428e0cef$var$downKeyCount(session)
    });
const $23708db1428e0cef$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $23708db1428e0cef$var$createEvent('ui', $23708db1428e0cef$var$selectEventType(session), 'userPicker', {
        ...$23708db1428e0cef$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $23708db1428e0cef$var$sessionDuration(session),
        position: $23708db1428e0cef$var$position(state, args[0]),
        queryLength: $23708db1428e0cef$var$queryLength(state),
        spaceInQuery: $23708db1428e0cef$var$spaceInQuery(state),
        upKeyCount: $23708db1428e0cef$var$upKeyCount(session),
        downKeyCount: $23708db1428e0cef$var$downKeyCount(session),
        result: $23708db1428e0cef$var$result(args[0]),
        numberOfResults: $23708db1428e0cef$var$numberOfResults(state)
    });
};
const $23708db1428e0cef$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $23708db1428e0cef$var$results(state);
    return $23708db1428e0cef$var$createEvent('operational', 'searched', 'userPicker', {
        ...$23708db1428e0cef$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $23708db1428e0cef$var$sessionDuration(session),
        durationSinceInputChange: $23708db1428e0cef$var$durationSinceInputChange(session),
        queryLength: $23708db1428e0cef$var$queryLength(state),
        isLoading: $23708db1428e0cef$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $23708db1428e0cef$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$23708db1428e0cef$var$createEvent('operational', 'failed', 'userPicker', {
        ...$23708db1428e0cef$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $23708db1428e0cef$export$f541f04954b0c11e = (sources, accountId)=>$23708db1428e0cef$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $23708db1428e0cef$var$checkValidId(accountId) ? accountId : null
    });
function $23708db1428e0cef$var$queryLength(state) {
    return state.inputValue.length;
}
function $23708db1428e0cef$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $23708db1428e0cef$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $23708db1428e0cef$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $23708db1428e0cef$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $23708db1428e0cef$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $23708db1428e0cef$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $23708db1428e0cef$var$sessionId(session) {
    return session && session.id;
}
function $23708db1428e0cef$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $23708db1428e0cef$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $23708db1428e0cef$var$result(option) {
    return option ? $23708db1428e0cef$var$optionData2Analytics(option.data) : null;
}
function $23708db1428e0cef$var$results(state) {
    return (state.options || []).map($23708db1428e0cef$var$optionData2Analytics);
}
function $23708db1428e0cef$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $23708db1428e0cef$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$23708db1428e0cef$var$optionData2Analytics(option.data)) : [
        $23708db1428e0cef$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $23708db1428e0cef$var$numberOfResults(state) {
    return (state.options || []).length;
}

});
parcelRegister("grXIr", function(module, exports) {

$parcel$export(module.exports, "isExternalUser", () => $3d4e9c0ae8c2a010$export$f6058dbcb5980cb);
$parcel$export(module.exports, "isUser", () => $3d4e9c0ae8c2a010$export$2e44165f1da65304);
$parcel$export(module.exports, "isTeam", () => $3d4e9c0ae8c2a010$export$f8c4277cb588611f);
$parcel$export(module.exports, "isGroup", () => $3d4e9c0ae8c2a010$export$d7976824e9f55785);
$parcel$export(module.exports, "isEmail", () => $3d4e9c0ae8c2a010$export$7fbbfbca30081d0);
$parcel$export(module.exports, "isCustom", () => $3d4e9c0ae8c2a010$export$d3a8f0b77e9737fc);
$parcel$export(module.exports, "isDefaultValuePopulated", () => $3d4e9c0ae8c2a010$export$d6978985a41b0c8);
$parcel$export(module.exports, "extractOptionValue", () => $3d4e9c0ae8c2a010$export$7ae97131df521bff);
$parcel$export(module.exports, "isIterable", () => $3d4e9c0ae8c2a010$export$9652023d9040757);
$parcel$export(module.exports, "getOptions", () => $3d4e9c0ae8c2a010$export$d2312e68e1f5ad00);
$parcel$export(module.exports, "optionToSelectableOptions", () => $3d4e9c0ae8c2a010$export$e6fda14a194bcbcc);
$parcel$export(module.exports, "getAvatarSize", () => $3d4e9c0ae8c2a010$export$695fb564e621339a);
$parcel$export(module.exports, "isChildInput", () => $3d4e9c0ae8c2a010$export$3c62cf9a01367f27);
$parcel$export(module.exports, "isSingleValue", () => $3d4e9c0ae8c2a010$export$203c2bd2662d1ca2);
$parcel$export(module.exports, "hasValue", () => $3d4e9c0ae8c2a010$export$96bdbc84526f3739);
$parcel$export(module.exports, "callCallback", () => $3d4e9c0ae8c2a010$export$df325aa844b03c31);
$parcel$export(module.exports, "getAvatarUrl", () => $3d4e9c0ae8c2a010$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "isPopupUserPickerByComponent", () => $3d4e9c0ae8c2a010$export$4f60a74234178416);
$parcel$export(module.exports, "isLozengeText", () => $3d4e9c0ae8c2a010$export$5419897287f5f1c7);

var $8QpSo = parcelRequire("8QpSo");


var $1JbQI = parcelRequire("1JbQI");
const $3d4e9c0ae8c2a010$export$f6058dbcb5980cb = (option)=>option.type === (0, $ffa6e54f1b79ab69$export$50042ec1d2e00e63) || Boolean(option.isExternal);
const $3d4e9c0ae8c2a010$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $ffa6e54f1b79ab69$export$8436e53e45ffe15b);
const $3d4e9c0ae8c2a010$export$f8c4277cb588611f = (option)=>option.type === (0, $ffa6e54f1b79ab69$export$26bc40b960693765);
const $3d4e9c0ae8c2a010$export$d7976824e9f55785 = (option)=>option.type === (0, $ffa6e54f1b79ab69$export$d460f747b73abb10);
const $3d4e9c0ae8c2a010$export$7fbbfbca30081d0 = (option)=>option.type === (0, $ffa6e54f1b79ab69$export$6662b3461398ef8c);
const $3d4e9c0ae8c2a010$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $ffa6e54f1b79ab69$export$eafd0979afa5b224);
const $3d4e9c0ae8c2a010$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $3d4e9c0ae8c2a010$var$isOptionData = (option)=>option.name !== undefined;
const $3d4e9c0ae8c2a010$export$3f993c492bd6c728 = (option)=>{
    if ($3d4e9c0ae8c2a010$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $3d4e9c0ae8c2a010$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $3d4e9c0ae8c2a010$export$9652023d9040757 = (a)=>typeof a[Symbol.iterator] === 'function';
const $3d4e9c0ae8c2a010$export$d2312e68e1f5ad00 = (0, $8QpSo.default)((options)=>options.map($3d4e9c0ae8c2a010$export$3f993c492bd6c728));
const $3d4e9c0ae8c2a010$export$e6fda14a194bcbcc = (0, $8QpSo.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($3d4e9c0ae8c2a010$export$3f993c492bd6c728);
    return $3d4e9c0ae8c2a010$export$3f993c492bd6c728(defaultValue);
});
const $3d4e9c0ae8c2a010$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $3d4e9c0ae8c2a010$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $3d4e9c0ae8c2a010$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $3d4e9c0ae8c2a010$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $3d4e9c0ae8c2a010$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
};
const $3d4e9c0ae8c2a010$export$b4f8f1f54acec99b = (optionData)=>{
    if ($3d4e9c0ae8c2a010$export$2e44165f1da65304(optionData) || $3d4e9c0ae8c2a010$export$f8c4277cb588611f(optionData) || $3d4e9c0ae8c2a010$export$d3a8f0b77e9737fc(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $3d4e9c0ae8c2a010$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $1JbQI.default);
const $3d4e9c0ae8c2a010$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $3d4e9c0ae8c2a010$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};

});
const $ffa6e54f1b79ab69$export$8436e53e45ffe15b = 'user';
const $ffa6e54f1b79ab69$export$50042ec1d2e00e63 = 'external_user';
const $ffa6e54f1b79ab69$export$26bc40b960693765 = 'team';
const $ffa6e54f1b79ab69$export$d460f747b73abb10 = 'group';
const $ffa6e54f1b79ab69$export$6662b3461398ef8c = 'email';
const $ffa6e54f1b79ab69$export$eafd0979afa5b224 = 'custom';

parcelRegister("1JbQI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce1428ca8599b707$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $ao4Ml = parcelRequire("ao4Ml");

var $cXw5N = parcelRequire("cXw5N");
var $dKwv2 = parcelRequire("dKwv2");
var $2HG8y = parcelRequire("2HG8y");

var $4wJSY = parcelRequire("4wJSY");

var $5a34e = parcelRequire("5a34e");

var $jJsBW = parcelRequire("jJsBW");

var $fHpHg = parcelRequire("fHpHg");

var $1BKyN = parcelRequire("1BKyN");


var $lau8t = parcelRequire("lau8t");

var $5IVHm = parcelRequire("5IVHm");

var $f2Cxi = parcelRequire("f2Cxi");

var $aztrV = parcelRequire("aztrV");
/**
 * Are we rendering on the client or server?
 */ const $ce1428ca8599b707$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $ce1428ca8599b707$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $ce1428ca8599b707$var$defaultPopperProps = {
    modifiers: $ce1428ca8599b707$var$modifiers,
    placement: 'bottom-start'
};
const $ce1428ca8599b707$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $ce1428ca8599b707$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$ce1428ca8599b707$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $4wJSY.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $f2Cxi.defaultComponents),
            ...props.components
        };
        if (!(0, $4wJSY.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$ce1428ca8599b707$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $cBeZP.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cXw5N.Manager), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jJsBW.IdProvider), {
                    postfix: "-popup-select",
                    children: ({ id: id })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2HG8y.Reference), {
                                    children: ({ ref: ref })=>target && target({
                                            isOpen: isOpen,
                                            onKeyDown: this.handleTargetKeyDown,
                                            ref: this.resolveTargetRef(ref),
                                            'aria-haspopup': 'true',
                                            'aria-expanded': isOpen,
                                            'aria-controls': isOpen ? id : undefined
                                        })
                                }),
                                this.renderSelect(id)
                            ]
                        })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aztrV.NotifyOpenLayerObserver), {
                    isOpen: (0, $fHpHg.fg)('platform_dst_layer_observer_select') && this.state.isOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.menuRef = null, this.selectRef = null, this.targetRef = null, this.unbindWindowClick = null, this.unbindWindowKeydown = null, this.defaultStyles = {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $a7f8c6b391092279$export$eaa8c8a70ac22806})`
                })
        }, this.isOpenControlled = this.props.isOpen !== undefined, this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen, this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $f2Cxi.defaultComponents),
            mergedPopperProps: $ce1428ca8599b707$var$defaultPopperProps
        }, // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        }, this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
            if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        }, this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        }, this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        }, this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        }, // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $cBeZP.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        }, /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            //@ts-ignore react-select unsupported props
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }, // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            }, this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            }, this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        }, // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        }, this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        }, // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        }, // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $ce1428ca8599b707$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $f2Cxi.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const providedAriaLabel = getLabel();
            const updateInputAriaLabel = (ariaLabelText)=>{
                // Update aria-label to get first announcement when popup opened.
                if (this.selectRef?.select?.inputRef) {
                    if (providedAriaLabel) // I might want to use a comma instead of a period here, when the feature flag is removed.
                    ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                    this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                }
            };
            const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                const { focused: focused } = onFocusProps;
                const options = props?.options || [];
                const totalLength = options?.length;
                const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                const ariaLabelText = (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? `${optionName}, (${optionIndex + 1} of ${totalLength})` : `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                // Option LABEL focused, 1 of 8. 8 results available.
                // Use Up and Down to choose options, press Enter to select the currently focused option,
                // press Escape to exit the menu.
                return ariaLabelText;
            };
            const onReactSelectFocus = (onFocusProps)=>{
                const ariaLabelSuffix = (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? '' : ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                let ariaLabelText = '';
                let ariaLiveMessage = '';
                if (props.options?.length) {
                    if ((0, $5IVHm.isOptionsGrouped)(props.options)) {
                        const totalLength = (0, $5IVHm.countAllOptions)(props.options);
                        ariaLiveMessage = (0, $5IVHm.onFocus)(onFocusProps, props.options);
                        ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                    } else {
                        ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                        ariaLiveMessage = ariaLabelText;
                    }
                    // Safari still does not announce the first option when menu is opened, so forcing a change to the input label
                    // will include the first option in the initial announcement.
                    if (!(0, $fHpHg.fg)('design_system_select-a11y-improvement') || (0, $5a34e.isSafari)() && (0, $fHpHg.fg)('design_system_select-a11y-improvement')) updateInputAriaLabel(ariaLabelText);
                    return ariaLiveMessage;
                }
                return ariaLiveMessage;
            };
            const popper = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dKwv2.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                },
                children: ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $f2Cxi.MenuDialog), {
                        // There is not a limited amount of values for the widths, so they need to remain dynamic.
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            ...style,
                            maxWidth: maxMenuWidth,
                            minWidth: minMenuWidth
                        },
                        "data-placement": placement,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref),
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ao4Ml.default), {
                            disabled: !focusLockEnabled,
                            returnFocus: true,
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lau8t.default), {
                                    label: providedAriaLabel,
                                    // TODO: Popup Select does not work well with active-descendant
                                    "aria-live": (0, $5a34e.isAppleDevice)() && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                                    (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? 'assertive' // only needed on Apple products
                                     : undefined,
                                    backspaceRemovesValue: false,
                                    controlShouldRenderValue: false,
                                    isClearable: false,
                                    tabSelectsValue: false,
                                    menuIsOpen: true,
                                    placeholder: placeholder,
                                    ref: this.getSelectRef,
                                    ...props,
                                    isSearchable: showSearchControl,
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                    styles: (0, $1BKyN.mergeStyles)(this.defaultStyles, props.styles || {}),
                                    maxMenuHeight: this.getMaxHeight(),
                                    components: selectComponents,
                                    onChange: this.handleSelectChange,
                                    testId: testId,
                                    ariaLiveMessages: {
                                        // Overwriting ariaLiveMessages builtin onFocus method to announce selected option when popup has been opened
                                        onFocus: onReactSelectFocus,
                                        ...props.ariaLiveMessages // priority to use user handlers if provided
                                    }
                                }),
                                footer
                            ]
                        })
                    })
            });
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $7nsd3.createPortal)(popper, portalDestination);
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            if (!(0, $fHpHg.fg)('platform_dst_layer_observer_select')) return;
            this.close();
        };
    }
}

});
parcelRegister("cXw5N", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $96f3e3a21854c201$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $96f3e3a21854c201$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $96f3e3a21854c201$export$d0d38e7dec7a1a61);

var $5uXOq = parcelRequire("5uXOq");
var $96f3e3a21854c201$export$3dbd3405086fec7b = $5uXOq.createContext();
var $96f3e3a21854c201$export$cbabb21c2529b130 = $5uXOq.createContext();
function $96f3e3a21854c201$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $5uXOq.useRef(false);
    $5uXOq.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $5uXOq.createElement($96f3e3a21854c201$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $5uXOq.createElement($96f3e3a21854c201$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("dKwv2", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $a028c7fdc314a3d7$export$badac9ada3a0bdf9);

var $5uXOq = parcelRequire("5uXOq");

var $cXw5N = parcelRequire("cXw5N");

var $9sasN = parcelRequire("9sasN");

var $1X8rn = parcelRequire("1X8rn");
var $a028c7fdc314a3d7$var$NOOP = function NOOP() {
    return void 0;
};
var $a028c7fdc314a3d7$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $a028c7fdc314a3d7$var$EMPTY_MODIFIERS = [];
function $a028c7fdc314a3d7$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $a028c7fdc314a3d7$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $5uXOq.useContext((0, $cXw5N.ManagerReferenceNodeContext));
    var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $5uXOq.useEffect(function() {
        (0, $9sasN.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $5uXOq.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $1X8rn.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $5uXOq.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $a028c7fdc314a3d7$var$NOOP,
            update: update || $a028c7fdc314a3d7$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $9sasN.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("9sasN", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $6e1ed863939d4e09$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $6e1ed863939d4e09$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $6e1ed863939d4e09$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $6e1ed863939d4e09$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $6e1ed863939d4e09$export$700979bc83e7db82);

var $5uXOq = parcelRequire("5uXOq");
var $6e1ed863939d4e09$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $6e1ed863939d4e09$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $6e1ed863939d4e09$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $6e1ed863939d4e09$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $6e1ed863939d4e09$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $6e1ed863939d4e09$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;

});

parcelRegister("1X8rn", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $16c1d93cabd0d15c$export$f4d5bf230a36dd6e);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $7aL90 = parcelRequire("7aL90");

var $lHrkK = parcelRequire("lHrkK");

var $9sasN = parcelRequire("9sasN");
var $16c1d93cabd0d15c$var$EMPTY_MODIFIERS = [];
var $16c1d93cabd0d15c$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $5uXOq.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $16c1d93cabd0d15c$var$EMPTY_MODIFIERS
    };
    var _React$useState = $5uXOq.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $5uXOq.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $7nsd3.flushSync(function() {
                    setState({
                        styles: (0, $9sasN.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $9sasN.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $5uXOq.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $5uXOq.useRef();
    (0, $9sasN.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $9sasN.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $7aL90.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("7aL90", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $538e096cd49574d6$export$8f7491d57c8f97a9);

var $3xOUx = parcelRequire("3xOUx");

var $5d22G = parcelRequire("5d22G");

var $erJZ3 = parcelRequire("erJZ3");

var $8AiNL = parcelRequire("8AiNL");

var $bAjmm = parcelRequire("bAjmm");

var $lcFdJ = parcelRequire("lcFdJ");

var $7KqQI = parcelRequire("7KqQI");

var $7zSEz = parcelRequire("7zSEz");

var $ek5P6 = parcelRequire("ek5P6");

var $anqoe = parcelRequire("anqoe");


var $538e096cd49574d6$export$d34966752335dd47 = [
    (0, $5d22G.default),
    (0, $erJZ3.default),
    (0, $8AiNL.default),
    (0, $bAjmm.default),
    (0, $lcFdJ.default),
    (0, $7KqQI.default),
    (0, $7zSEz.default),
    (0, $ek5P6.default),
    (0, $anqoe.default)
];
var $538e096cd49574d6$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $3xOUx.popperGenerator)({
    defaultModifiers: $538e096cd49574d6$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("3xOUx", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $294bf2077fa79917$export$ed5e13716264f202);

var $hBSZx = parcelRequire("hBSZx");

var $h7lRj = parcelRequire("h7lRj");

var $82kk0 = parcelRequire("82kk0");

var $iMJep = parcelRequire("iMJep");

var $iEr9Q = parcelRequire("iEr9Q");

var $bKdOP = parcelRequire("bKdOP");

var $650fv = parcelRequire("650fv");


var $fJ6Ac = parcelRequire("fJ6Ac");
var $294bf2077fa79917$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $294bf2077fa79917$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $294bf2077fa79917$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $294bf2077fa79917$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $294bf2077fa79917$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $fJ6Ac.isElement)(reference) ? (0, $82kk0.default)(reference) : reference.contextElement ? (0, $82kk0.default)(reference.contextElement) : [],
                    popper: (0, $82kk0.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $iEr9Q.default)((0, $650fv.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$294bf2077fa79917$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $hBSZx.default)(reference, (0, $iMJep.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $h7lRj.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $bKdOP.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$294bf2077fa79917$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $294bf2077fa79917$export$8f7491d57c8f97a9 = /*#__PURE__*/ $294bf2077fa79917$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("hBSZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd208c8e3dd9cb4f$export$2e2bcd8739ae039);

var $2aOS9 = parcelRequire("2aOS9");

var $6Kv1j = parcelRequire("6Kv1j");

var $3UmrH = parcelRequire("3UmrH");

var $fJ6Ac = parcelRequire("fJ6Ac");

var $1lDxt = parcelRequire("1lDxt");

var $8WCqw = parcelRequire("8WCqw");

var $9YuAb = parcelRequire("9YuAb");

var $dNBRj = parcelRequire("dNBRj");
function $cd208c8e3dd9cb4f$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $dNBRj.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $dNBRj.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $cd208c8e3dd9cb4f$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $fJ6Ac.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $fJ6Ac.isHTMLElement)(offsetParent) && $cd208c8e3dd9cb4f$var$isElementScaled(offsetParent);
    var documentElement = (0, $8WCqw.default)(offsetParent);
    var rect = (0, $2aOS9.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3UmrH.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9YuAb.default)(documentElement)) scroll = (0, $6Kv1j.default)(offsetParent);
        if ((0, $fJ6Ac.isHTMLElement)(offsetParent)) {
            offsets = (0, $2aOS9.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $1lDxt.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("2aOS9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1953fa21ac68a407$export$2e2bcd8739ae039);

var $fJ6Ac = parcelRequire("fJ6Ac");

var $dNBRj = parcelRequire("dNBRj");

var $iHejO = parcelRequire("iHejO");

var $duzhc = parcelRequire("duzhc");
function $1953fa21ac68a407$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $fJ6Ac.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $dNBRj.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $dNBRj.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $fJ6Ac.isElement)(element) ? (0, $iHejO.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $duzhc.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("fJ6Ac", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $b7302a2f8f3e16d5$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $b7302a2f8f3e16d5$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $b7302a2f8f3e16d5$export$af51f0f06c0f328a);

var $iHejO = parcelRequire("iHejO");
function $b7302a2f8f3e16d5$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $iHejO.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $b7302a2f8f3e16d5$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $iHejO.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $b7302a2f8f3e16d5$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $iHejO.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("iHejO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c7598303229a8b$export$2e2bcd8739ae039);
function $d9c7598303229a8b$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("dNBRj", function(module, exports) {

$parcel$export(module.exports, "max", () => $a0bd37f1ec3b8c5c$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $a0bd37f1ec3b8c5c$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $a0bd37f1ec3b8c5c$export$2077e0241d6afd3c);
var $a0bd37f1ec3b8c5c$export$8960430cfd85939f = Math.max;
var $a0bd37f1ec3b8c5c$export$96ec731ed4dcb222 = Math.min;
var $a0bd37f1ec3b8c5c$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("duzhc", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d2970d7bf044ee4$export$2e2bcd8739ae039);

var $eL5lS = parcelRequire("eL5lS");
function $9d2970d7bf044ee4$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $eL5lS.default)());
}

});
parcelRegister("eL5lS", function(module, exports) {

$parcel$export(module.exports, "default", () => $abe99b418685a06a$export$2e2bcd8739ae039);
function $abe99b418685a06a$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("6Kv1j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e9f19ecf6c383bb$export$2e2bcd8739ae039);

var $hNX0K = parcelRequire("hNX0K");

var $iHejO = parcelRequire("iHejO");

var $fJ6Ac = parcelRequire("fJ6Ac");

var $d39KE = parcelRequire("d39KE");
function $4e9f19ecf6c383bb$export$2e2bcd8739ae039(node) {
    if (node === (0, $iHejO.default)(node) || !(0, $fJ6Ac.isHTMLElement)(node)) return (0, $hNX0K.default)(node);
    else return (0, $d39KE.default)(node);
}

});
parcelRegister("hNX0K", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf64c9a95bd91d41$export$2e2bcd8739ae039);

var $iHejO = parcelRequire("iHejO");
function $cf64c9a95bd91d41$export$2e2bcd8739ae039(node) {
    var win = (0, $iHejO.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("d39KE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0273a9c8aeed2a1a$export$2e2bcd8739ae039);
function $0273a9c8aeed2a1a$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("3UmrH", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d88034c5dd05ef3$export$2e2bcd8739ae039);
function $2d88034c5dd05ef3$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("1lDxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fb66c376a9887fc$export$2e2bcd8739ae039);

var $2aOS9 = parcelRequire("2aOS9");

var $8WCqw = parcelRequire("8WCqw");

var $hNX0K = parcelRequire("hNX0K");
function $0fb66c376a9887fc$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2aOS9.default)((0, $8WCqw.default)(element)).left + (0, $hNX0K.default)(element).scrollLeft;
}

});
parcelRegister("8WCqw", function(module, exports) {

$parcel$export(module.exports, "default", () => $68318c45b50bb45b$export$2e2bcd8739ae039);

var $fJ6Ac = parcelRequire("fJ6Ac");
function $68318c45b50bb45b$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $fJ6Ac.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("9YuAb", function(module, exports) {

$parcel$export(module.exports, "default", () => $743170baa6e13398$export$2e2bcd8739ae039);

var $326U9 = parcelRequire("326U9");
function $743170baa6e13398$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $326U9.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("326U9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2356ea197825164b$export$2e2bcd8739ae039);

var $iHejO = parcelRequire("iHejO");
function $2356ea197825164b$export$2e2bcd8739ae039(element) {
    return (0, $iHejO.default)(element).getComputedStyle(element);
}

});



parcelRegister("h7lRj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7640bd28e53eae4$export$2e2bcd8739ae039);

var $2aOS9 = parcelRequire("2aOS9");
function $c7640bd28e53eae4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2aOS9.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("82kk0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d9e461cb51b14a7$export$2e2bcd8739ae039);

var $91lyT = parcelRequire("91lyT");

var $lDDlB = parcelRequire("lDDlB");

var $iHejO = parcelRequire("iHejO");

var $9YuAb = parcelRequire("9YuAb");
function $5d9e461cb51b14a7$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $91lyT.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $iHejO.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9YuAb.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($5d9e461cb51b14a7$export$2e2bcd8739ae039((0, $lDDlB.default)(target)));
}

});
parcelRegister("91lyT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6914eec2bc706a91$export$2e2bcd8739ae039);

var $lDDlB = parcelRequire("lDDlB");

var $9YuAb = parcelRequire("9YuAb");

var $3UmrH = parcelRequire("3UmrH");

var $fJ6Ac = parcelRequire("fJ6Ac");
function $6914eec2bc706a91$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $3UmrH.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $fJ6Ac.isHTMLElement)(node) && (0, $9YuAb.default)(node)) return node;
    return $6914eec2bc706a91$export$2e2bcd8739ae039((0, $lDDlB.default)(node));
}

});
parcelRegister("lDDlB", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc0bc31192c04a8d$export$2e2bcd8739ae039);

var $3UmrH = parcelRequire("3UmrH");

var $8WCqw = parcelRequire("8WCqw");

var $fJ6Ac = parcelRequire("fJ6Ac");
function $fc0bc31192c04a8d$export$2e2bcd8739ae039(element) {
    if ((0, $3UmrH.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $fJ6Ac.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $8WCqw.default)(element) // fallback
    );
}

});



parcelRegister("iMJep", function(module, exports) {

$parcel$export(module.exports, "default", () => $dacfcbb55f910cab$export$2e2bcd8739ae039);

var $iHejO = parcelRequire("iHejO");

var $3UmrH = parcelRequire("3UmrH");

var $326U9 = parcelRequire("326U9");

var $fJ6Ac = parcelRequire("fJ6Ac");

var $4hrjD = parcelRequire("4hrjD");

var $lDDlB = parcelRequire("lDDlB");

var $eL5lS = parcelRequire("eL5lS");
function $dacfcbb55f910cab$var$getTrueOffsetParent(element) {
    if (!(0, $fJ6Ac.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $326U9.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $dacfcbb55f910cab$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $eL5lS.default)());
    var isIE = /Trident/i.test((0, $eL5lS.default)());
    if (isIE && (0, $fJ6Ac.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $326U9.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $lDDlB.default)(element);
    if ((0, $fJ6Ac.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $fJ6Ac.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $3UmrH.default)(currentNode)) < 0){
        var css = (0, $326U9.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $dacfcbb55f910cab$export$2e2bcd8739ae039(element) {
    var window = (0, $iHejO.default)(element);
    var offsetParent = $dacfcbb55f910cab$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $4hrjD.default)(offsetParent) && (0, $326U9.default)(offsetParent).position === 'static')offsetParent = $dacfcbb55f910cab$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $3UmrH.default)(offsetParent) === 'html' || (0, $3UmrH.default)(offsetParent) === 'body' && (0, $326U9.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $dacfcbb55f910cab$var$getContainingBlock(element) || window;
}

});
parcelRegister("4hrjD", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ddf04ce957c4d3$export$2e2bcd8739ae039);

var $3UmrH = parcelRequire("3UmrH");
function $31ddf04ce957c4d3$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $3UmrH.default)(element)) >= 0;
}

});


parcelRegister("iEr9Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $d941075e5e06e50f$export$2e2bcd8739ae039);

var $iqJ7p = parcelRequire("iqJ7p");
function $d941075e5e06e50f$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $d941075e5e06e50f$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $d941075e5e06e50f$var$order(modifiers); // order based on phase
    return (0, $iqJ7p.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("iqJ7p", function(module, exports) {

$parcel$export(module.exports, "top", () => $d6ada747b06c007d$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $d6ada747b06c007d$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $d6ada747b06c007d$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $d6ada747b06c007d$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $d6ada747b06c007d$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $d6ada747b06c007d$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $d6ada747b06c007d$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $d6ada747b06c007d$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $d6ada747b06c007d$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $d6ada747b06c007d$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $d6ada747b06c007d$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $d6ada747b06c007d$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $d6ada747b06c007d$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $d6ada747b06c007d$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $d6ada747b06c007d$export$d087d3878fdf71d5);
var $d6ada747b06c007d$export$1e95b668f3b82d = 'top';
var $d6ada747b06c007d$export$40e543e69a8b3fbb = 'bottom';
var $d6ada747b06c007d$export$79ffe56a765070d2 = 'right';
var $d6ada747b06c007d$export$eabcd2c8791e7bf4 = 'left';
var $d6ada747b06c007d$export$dfb5619354ba860 = 'auto';
var $d6ada747b06c007d$export$aec2ce47c367b8c3 = [
    $d6ada747b06c007d$export$1e95b668f3b82d,
    $d6ada747b06c007d$export$40e543e69a8b3fbb,
    $d6ada747b06c007d$export$79ffe56a765070d2,
    $d6ada747b06c007d$export$eabcd2c8791e7bf4
];
var $d6ada747b06c007d$export$b3571188c770cc5a = 'start';
var $d6ada747b06c007d$export$bd5df0f255a350f8 = 'end';
var $d6ada747b06c007d$export$390fd549c5303b4d = 'clippingParents';
var $d6ada747b06c007d$export$d7b7311ec04a3e8f = 'viewport';
var $d6ada747b06c007d$export$ae5ab1c730825774 = 'popper';
var $d6ada747b06c007d$export$ca50aac9f3ba507f = 'reference';
var $d6ada747b06c007d$export$368f9a87e87fa4e1 = /*#__PURE__*/ $d6ada747b06c007d$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $d6ada747b06c007d$export$b3571188c770cc5a,
        placement + "-" + $d6ada747b06c007d$export$bd5df0f255a350f8
    ]);
}, []);
var $d6ada747b06c007d$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($d6ada747b06c007d$export$aec2ce47c367b8c3, [
    $d6ada747b06c007d$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $d6ada747b06c007d$export$b3571188c770cc5a,
        placement + "-" + $d6ada747b06c007d$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $d6ada747b06c007d$export$421679a7c3d56e = 'beforeRead';
var $d6ada747b06c007d$export$aafa59e2e03f2942 = 'read';
var $d6ada747b06c007d$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $d6ada747b06c007d$export$c65e99957a05207c = 'beforeMain';
var $d6ada747b06c007d$export$f22da7240b7add18 = 'main';
var $d6ada747b06c007d$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $d6ada747b06c007d$export$8d4d2d70e7d46032 = 'beforeWrite';
var $d6ada747b06c007d$export$68d8715fc104d294 = 'write';
var $d6ada747b06c007d$export$70a6e5159acce2e6 = 'afterWrite';
var $d6ada747b06c007d$export$d087d3878fdf71d5 = [
    $d6ada747b06c007d$export$421679a7c3d56e,
    $d6ada747b06c007d$export$aafa59e2e03f2942,
    $d6ada747b06c007d$export$6964f6c886723980,
    $d6ada747b06c007d$export$c65e99957a05207c,
    $d6ada747b06c007d$export$f22da7240b7add18,
    $d6ada747b06c007d$export$bab79516f2d662fe,
    $d6ada747b06c007d$export$8d4d2d70e7d46032,
    $d6ada747b06c007d$export$68d8715fc104d294,
    $d6ada747b06c007d$export$70a6e5159acce2e6
];

});


parcelRegister("bKdOP", function(module, exports) {

$parcel$export(module.exports, "default", () => $88ceb5bd2b05c557$export$2e2bcd8739ae039);
function $88ceb5bd2b05c557$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("650fv", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d367282185b78e$export$2e2bcd8739ae039);
function $46d367282185b78e$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("5d22G", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cafc035423eb95a$export$2e2bcd8739ae039);

var $iHejO = parcelRequire("iHejO");
var $3cafc035423eb95a$var$passive = {
    passive: true
};
function $3cafc035423eb95a$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $iHejO.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $3cafc035423eb95a$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $3cafc035423eb95a$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $3cafc035423eb95a$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $3cafc035423eb95a$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $3cafc035423eb95a$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $3cafc035423eb95a$var$effect,
    data: {}
};

});

parcelRegister("erJZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a84741b446df23b4$export$2e2bcd8739ae039);

var $e8ZLL = parcelRequire("e8ZLL");
function $a84741b446df23b4$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $e8ZLL.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $a84741b446df23b4$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $a84741b446df23b4$var$popperOffsets,
    data: {}
};

});
parcelRegister("e8ZLL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4c1ba21d03868aa$export$2e2bcd8739ae039);

var $lsJel = parcelRequire("lsJel");

var $jwYyR = parcelRequire("jwYyR");

var $ffRl6 = parcelRequire("ffRl6");

var $iqJ7p = parcelRequire("iqJ7p");
function $a4c1ba21d03868aa$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $lsJel.default)(placement) : null;
    var variation = placement ? (0, $jwYyR.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $iqJ7p.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $iqJ7p.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $iqJ7p.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $iqJ7p.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ffRl6.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $iqJ7p.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $iqJ7p.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("lsJel", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9ff4c508a576765$export$2e2bcd8739ae039);

function $f9ff4c508a576765$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("jwYyR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37ffbaf78a48966$export$2e2bcd8739ae039);
function $e37ffbaf78a48966$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("ffRl6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1b1a1cd84aec3a6$export$2e2bcd8739ae039);
function $b1b1a1cd84aec3a6$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("8AiNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6400452045d38e02$export$2e2bcd8739ae039);

var $iqJ7p = parcelRequire("iqJ7p");

var $iMJep = parcelRequire("iMJep");

var $iHejO = parcelRequire("iHejO");

var $8WCqw = parcelRequire("8WCqw");

var $326U9 = parcelRequire("326U9");

var $lsJel = parcelRequire("lsJel");

var $jwYyR = parcelRequire("jwYyR");

var $dNBRj = parcelRequire("dNBRj");
var $6400452045d38e02$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $6400452045d38e02$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $dNBRj.round)(x * dpr) / dpr || 0,
        y: (0, $dNBRj.round)(y * dpr) / dpr || 0
    };
}
function $6400452045d38e02$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $iqJ7p.left);
    var sideY = (0, $iqJ7p.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $iMJep.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $iHejO.default)(popper)) {
            offsetParent = (0, $8WCqw.default)(popper);
            if ((0, $326U9.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $iqJ7p.top) || (placement === (0, $iqJ7p.left) || placement === (0, $iqJ7p.right)) && variation === (0, $iqJ7p.end)) {
            sideY = (0, $iqJ7p.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $iqJ7p.left) || (placement === (0, $iqJ7p.top) || placement === (0, $iqJ7p.bottom)) && variation === (0, $iqJ7p.end)) {
            sideX = (0, $iqJ7p.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $6400452045d38e02$var$unsetSides);
    var _ref4 = roundOffsets === true ? $6400452045d38e02$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $iHejO.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $6400452045d38e02$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $lsJel.default)(state.placement),
        variation: (0, $jwYyR.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $6400452045d38e02$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $6400452045d38e02$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $6400452045d38e02$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $6400452045d38e02$var$computeStyles,
    data: {}
};

});

parcelRegister("bAjmm", function(module, exports) {

$parcel$export(module.exports, "default", () => $86f212e7a517fbb5$export$2e2bcd8739ae039);

var $3UmrH = parcelRequire("3UmrH");

var $fJ6Ac = parcelRequire("fJ6Ac");
// and applies them to the HTMLElements such as popper and arrow
function $86f212e7a517fbb5$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $fJ6Ac.isHTMLElement)(element) || !(0, $3UmrH.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $86f212e7a517fbb5$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $fJ6Ac.isHTMLElement)(element) || !(0, $3UmrH.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $86f212e7a517fbb5$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $86f212e7a517fbb5$var$applyStyles,
    effect: $86f212e7a517fbb5$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("lcFdJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6fab17b9f71b622$export$2e2bcd8739ae039);

var $lsJel = parcelRequire("lsJel");

var $iqJ7p = parcelRequire("iqJ7p");
function $f6fab17b9f71b622$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $lsJel.default)(placement);
    var invertDistance = [
        (0, $iqJ7p.left),
        (0, $iqJ7p.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $iqJ7p.left),
        (0, $iqJ7p.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $f6fab17b9f71b622$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $iqJ7p.placements).reduce(function(acc, placement) {
        acc[placement] = $f6fab17b9f71b622$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f6fab17b9f71b622$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $f6fab17b9f71b622$var$offset
};

});

parcelRegister("7KqQI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a41a7ffd8eaaed3$export$2e2bcd8739ae039);

var $kQ8ZL = parcelRequire("kQ8ZL");

var $lsJel = parcelRequire("lsJel");

var $fyd1H = parcelRequire("fyd1H");

var $czpku = parcelRequire("czpku");

var $fW5QL = parcelRequire("fW5QL");

var $iqJ7p = parcelRequire("iqJ7p");

var $jwYyR = parcelRequire("jwYyR");
function $5a41a7ffd8eaaed3$var$getExpandedFallbackPlacements(placement) {
    if ((0, $lsJel.default)(placement) === (0, $iqJ7p.auto)) return [];
    var oppositePlacement = (0, $kQ8ZL.default)(placement);
    return [
        (0, $fyd1H.default)(placement),
        oppositePlacement,
        (0, $fyd1H.default)(oppositePlacement)
    ];
}
function $5a41a7ffd8eaaed3$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $lsJel.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $kQ8ZL.default)(preferredPlacement)
    ] : $5a41a7ffd8eaaed3$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $lsJel.default)(placement) === (0, $iqJ7p.auto) ? (0, $fW5QL.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $lsJel.default)(placement);
        var isStartVariation = (0, $jwYyR.default)(placement) === (0, $iqJ7p.start);
        var isVertical = [
            (0, $iqJ7p.top),
            (0, $iqJ7p.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $czpku.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $iqJ7p.right) : (0, $iqJ7p.left) : isStartVariation ? (0, $iqJ7p.bottom) : (0, $iqJ7p.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $kQ8ZL.default)(mainVariationSide);
        var altVariationSide = (0, $kQ8ZL.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $5a41a7ffd8eaaed3$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $5a41a7ffd8eaaed3$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("kQ8ZL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2bfa43e7acf7a1f$export$2e2bcd8739ae039);
var $f2bfa43e7acf7a1f$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $f2bfa43e7acf7a1f$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $f2bfa43e7acf7a1f$var$hash[matched];
    });
}

});

parcelRegister("fyd1H", function(module, exports) {

$parcel$export(module.exports, "default", () => $b52422c6016bd931$export$2e2bcd8739ae039);
var $b52422c6016bd931$var$hash = {
    start: 'end',
    end: 'start'
};
function $b52422c6016bd931$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $b52422c6016bd931$var$hash[matched];
    });
}

});

parcelRegister("czpku", function(module, exports) {

$parcel$export(module.exports, "default", () => $926c66d41a194a34$export$2e2bcd8739ae039);

var $c62Z3 = parcelRequire("c62Z3");

var $8WCqw = parcelRequire("8WCqw");

var $2aOS9 = parcelRequire("2aOS9");

var $e8ZLL = parcelRequire("e8ZLL");

var $4SDYu = parcelRequire("4SDYu");

var $iqJ7p = parcelRequire("iqJ7p");

var $fJ6Ac = parcelRequire("fJ6Ac");

var $dmhsV = parcelRequire("dmhsV");

var $3qyWh = parcelRequire("3qyWh");
function $926c66d41a194a34$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $iqJ7p.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $iqJ7p.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $iqJ7p.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $dmhsV.default)(typeof padding !== 'number' ? padding : (0, $3qyWh.default)(padding, (0, $iqJ7p.basePlacements)));
    var altContext = elementContext === (0, $iqJ7p.popper) ? (0, $iqJ7p.reference) : (0, $iqJ7p.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $c62Z3.default)((0, $fJ6Ac.isElement)(element) ? element : element.contextElement || (0, $8WCqw.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2aOS9.default)(state.elements.reference);
    var popperOffsets = (0, $e8ZLL.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $4SDYu.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $iqJ7p.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $iqJ7p.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $iqJ7p.right),
                (0, $iqJ7p.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $iqJ7p.top),
                (0, $iqJ7p.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("c62Z3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ce85c1418d21935$export$2e2bcd8739ae039);

var $iqJ7p = parcelRequire("iqJ7p");

var $5AoPY = parcelRequire("5AoPY");

var $5d4pe = parcelRequire("5d4pe");

var $82kk0 = parcelRequire("82kk0");

var $iMJep = parcelRequire("iMJep");

var $8WCqw = parcelRequire("8WCqw");

var $326U9 = parcelRequire("326U9");

var $fJ6Ac = parcelRequire("fJ6Ac");

var $2aOS9 = parcelRequire("2aOS9");

var $lDDlB = parcelRequire("lDDlB");

var $3M1PW = parcelRequire("3M1PW");

var $3UmrH = parcelRequire("3UmrH");

var $4SDYu = parcelRequire("4SDYu");

var $dNBRj = parcelRequire("dNBRj");
function $8ce85c1418d21935$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2aOS9.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $8ce85c1418d21935$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $iqJ7p.viewport) ? (0, $4SDYu.default)((0, $5AoPY.default)(element, strategy)) : (0, $fJ6Ac.isElement)(clippingParent) ? $8ce85c1418d21935$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $4SDYu.default)((0, $5d4pe.default)((0, $8WCqw.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $8ce85c1418d21935$var$getClippingParents(element) {
    var clippingParents = (0, $82kk0.default)((0, $lDDlB.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $326U9.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $fJ6Ac.isHTMLElement)(element) ? (0, $iMJep.default)(element) : element;
    if (!(0, $fJ6Ac.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $fJ6Ac.isElement)(clippingParent) && (0, $3M1PW.default)(clippingParent, clipperElement) && (0, $3UmrH.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $8ce85c1418d21935$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $8ce85c1418d21935$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $8ce85c1418d21935$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $dNBRj.max)(rect.top, accRect.top);
        accRect.right = (0, $dNBRj.min)(rect.right, accRect.right);
        accRect.bottom = (0, $dNBRj.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $dNBRj.max)(rect.left, accRect.left);
        return accRect;
    }, $8ce85c1418d21935$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("5AoPY", function(module, exports) {

$parcel$export(module.exports, "default", () => $411394afa2383299$export$2e2bcd8739ae039);

var $iHejO = parcelRequire("iHejO");

var $8WCqw = parcelRequire("8WCqw");

var $1lDxt = parcelRequire("1lDxt");

var $duzhc = parcelRequire("duzhc");
function $411394afa2383299$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $iHejO.default)(element);
    var html = (0, $8WCqw.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $duzhc.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $1lDxt.default)(element),
        y: y
    };
}

});

parcelRegister("5d4pe", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cb195955e9900e4$export$2e2bcd8739ae039);

var $8WCqw = parcelRequire("8WCqw");

var $326U9 = parcelRequire("326U9");

var $1lDxt = parcelRequire("1lDxt");

var $hNX0K = parcelRequire("hNX0K");

var $dNBRj = parcelRequire("dNBRj");
function $3cb195955e9900e4$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $8WCqw.default)(element);
    var winScroll = (0, $hNX0K.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $dNBRj.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $dNBRj.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $1lDxt.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $326U9.default)(body || html).direction === 'rtl') x += (0, $dNBRj.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("3M1PW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bf7478da67e8745$export$2e2bcd8739ae039);

var $fJ6Ac = parcelRequire("fJ6Ac");
function $2bf7478da67e8745$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $fJ6Ac.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("4SDYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $38db36b96d02eccc$export$2e2bcd8739ae039);
function $38db36b96d02eccc$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("dmhsV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b9ae0b6550b6f37$export$2e2bcd8739ae039);

var $yT6R3 = parcelRequire("yT6R3");
function $9b9ae0b6550b6f37$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $yT6R3.default)(), paddingObject);
}

});
parcelRegister("yT6R3", function(module, exports) {

$parcel$export(module.exports, "default", () => $068decb3807e55f3$export$2e2bcd8739ae039);
function $068decb3807e55f3$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("3qyWh", function(module, exports) {

$parcel$export(module.exports, "default", () => $27eee6fc63c552c6$export$2e2bcd8739ae039);
function $27eee6fc63c552c6$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("fW5QL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9a0cf81f1fbb0d2$export$2e2bcd8739ae039);

var $jwYyR = parcelRequire("jwYyR");

var $iqJ7p = parcelRequire("iqJ7p");

var $czpku = parcelRequire("czpku");

var $lsJel = parcelRequire("lsJel");
function $b9a0cf81f1fbb0d2$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $iqJ7p.placements) : _options$allowedAutoP;
    var variation = (0, $jwYyR.default)(placement);
    var placements = variation ? flipVariations ? (0, $iqJ7p.variationPlacements) : (0, $iqJ7p.variationPlacements).filter(function(placement) {
        return (0, $jwYyR.default)(placement) === variation;
    }) : (0, $iqJ7p.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $czpku.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $lsJel.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("7zSEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5846324917bf1014$export$2e2bcd8739ae039);

var $iqJ7p = parcelRequire("iqJ7p");

var $lsJel = parcelRequire("lsJel");

var $ffRl6 = parcelRequire("ffRl6");

var $kZNfy = parcelRequire("kZNfy");

var $cEkqa = parcelRequire("cEkqa");

var $h7lRj = parcelRequire("h7lRj");

var $iMJep = parcelRequire("iMJep");

var $czpku = parcelRequire("czpku");

var $jwYyR = parcelRequire("jwYyR");

var $yT6R3 = parcelRequire("yT6R3");

var $dNBRj = parcelRequire("dNBRj");
function $5846324917bf1014$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $czpku.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $lsJel.default)(state.placement);
    var variation = (0, $jwYyR.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ffRl6.default)(basePlacement);
    var altAxis = (0, $kZNfy.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $iqJ7p.top) : (0, $iqJ7p.left);
        var altSide = mainAxis === 'y' ? (0, $iqJ7p.bottom) : (0, $iqJ7p.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $iqJ7p.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $iqJ7p.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $h7lRj.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $yT6R3.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $cEkqa.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $iMJep.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $cEkqa.within)(tether ? (0, $dNBRj.min)(min, tetherMin) : min, offset, tether ? (0, $dNBRj.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $iqJ7p.top) : (0, $iqJ7p.left);
        var _altSide = mainAxis === 'x' ? (0, $iqJ7p.bottom) : (0, $iqJ7p.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $iqJ7p.top),
            (0, $iqJ7p.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $cEkqa.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $cEkqa.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $5846324917bf1014$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $5846324917bf1014$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("kZNfy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f48fb5228a571c9a$export$2e2bcd8739ae039);
function $f48fb5228a571c9a$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("cEkqa", function(module, exports) {

$parcel$export(module.exports, "within", () => $93590faa2f1f82c6$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $93590faa2f1f82c6$export$86c8af6d3ef0b4a);

var $dNBRj = parcelRequire("dNBRj");
function $93590faa2f1f82c6$export$f28d906d67a997f3(min, value, max) {
    return (0, $dNBRj.max)(min, (0, $dNBRj.min)(value, max));
}
function $93590faa2f1f82c6$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $93590faa2f1f82c6$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("ek5P6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6d7735846c13c0b$export$2e2bcd8739ae039);

var $lsJel = parcelRequire("lsJel");

var $h7lRj = parcelRequire("h7lRj");

var $3M1PW = parcelRequire("3M1PW");

var $iMJep = parcelRequire("iMJep");

var $ffRl6 = parcelRequire("ffRl6");

var $cEkqa = parcelRequire("cEkqa");

var $dmhsV = parcelRequire("dmhsV");

var $3qyWh = parcelRequire("3qyWh");

var $iqJ7p = parcelRequire("iqJ7p");
var $a6d7735846c13c0b$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $dmhsV.default)(typeof padding !== 'number' ? padding : (0, $3qyWh.default)(padding, (0, $iqJ7p.basePlacements)));
};
function $a6d7735846c13c0b$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $lsJel.default)(state.placement);
    var axis = (0, $ffRl6.default)(basePlacement);
    var isVertical = [
        (0, $iqJ7p.left),
        (0, $iqJ7p.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $a6d7735846c13c0b$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $h7lRj.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $iqJ7p.top) : (0, $iqJ7p.left);
    var maxProp = axis === 'y' ? (0, $iqJ7p.bottom) : (0, $iqJ7p.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $iMJep.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $cEkqa.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $a6d7735846c13c0b$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $3M1PW.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $a6d7735846c13c0b$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $a6d7735846c13c0b$var$arrow,
    effect: $a6d7735846c13c0b$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("anqoe", function(module, exports) {

$parcel$export(module.exports, "default", () => $78e085d14bcc9886$export$2e2bcd8739ae039);

var $iqJ7p = parcelRequire("iqJ7p");

var $czpku = parcelRequire("czpku");
function $78e085d14bcc9886$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $78e085d14bcc9886$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $iqJ7p.top),
        (0, $iqJ7p.right),
        (0, $iqJ7p.bottom),
        (0, $iqJ7p.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $78e085d14bcc9886$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $czpku.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $czpku.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $78e085d14bcc9886$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $78e085d14bcc9886$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $78e085d14bcc9886$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $78e085d14bcc9886$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $78e085d14bcc9886$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $78e085d14bcc9886$var$hide
};

});




parcelRegister("2HG8y", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $1f8048740832c02d$export$e0be378c32fb70a7);

var $5uXOq = parcelRequire("5uXOq");

var $hBYjV = parcelRequire("hBYjV");

var $cXw5N = parcelRequire("cXw5N");

var $9sasN = parcelRequire("9sasN");
function $1f8048740832c02d$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $5uXOq.useContext((0, $cXw5N.ManagerReferenceNodeSetterContext));
    var refHandler = $5uXOq.useCallback(function(node) {
        (0, $9sasN.setRef)(innerRef, node);
        (0, $9sasN.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $5uXOq.useEffect(function() {
        return function() {
            return (0, $9sasN.setRef)(innerRef, null);
        };
    }, []);
    $5uXOq.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $9sasN.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("4wJSY", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $34bdbe885d924a05$export$3e67810a3f0e9f1c);
function $34bdbe885d924a05$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $34bdbe885d924a05$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $34bdbe885d924a05$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $34bdbe885d924a05$export$967a6b9924a689f7(a, b);
    return $34bdbe885d924a05$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("f2Cxi", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $73214f191156d056$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $73214f191156d056$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $73214f191156d056$export$71abc632aa29e6fe);
/* components.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7kQOw = parcelRequire("7kQOw");

var $b1kcy = parcelRequire("b1kcy");

var $cBCgC = parcelRequire("cBCgC");
const $73214f191156d056$var$menuDialogStyles = null;
const $73214f191156d056$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`,
        className: (0, $bwpsq.default)([
            "_2rkoiti9 _1pby16oo _bfhk1bhr _16qseva7"
        ]),
        children: children
    });
});
// ==============================
// Custom Components
// ==============================
const $73214f191156d056$var$dropdownStyles = null;
const $73214f191156d056$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1bsbzwfg _12l2v77o _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7kQOw))), {
            color: "currentColor",
            label: ""
        })
    });
const $73214f191156d056$var$controlStyles = null;
const $73214f191156d056$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: innerRef,
        className: (0, $bwpsq.default)([
            "_85i51b66 _1q51u2gc _y4tiu2gc _bozgu2gc"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).Control, {
            ...props,
            innerProps: innerProps
        })
    });
const $73214f191156d056$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).Control, {
            ...props
        })
    });
// NOTE `props` intentionally omitted from `Fragment`
const $73214f191156d056$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        children: children
    });
// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
const $73214f191156d056$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).ClearIndicator, {
        ...props
    });
const $73214f191156d056$var$MultiValueRemove = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).MultiValueRemove, {
        ...props
    });
const $73214f191156d056$export$71abc632aa29e6fe = {
    Control: $73214f191156d056$var$Control,
    DropdownIndicator: $73214f191156d056$var$DropdownIndicator,
    Menu: $73214f191156d056$var$Menu,
    ClearIndicator: $73214f191156d056$var$ClearIndicator,
    MultiValueRemove: $73214f191156d056$var$MultiValueRemove
};

});
parcelRegister("7kQOw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd994b90fa78030d2d1c292998636115>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $55735e66b3bc3e4b$var$_react = $55735e66b3bc3e4b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $55735e66b3bc3e4b$var$_search = $55735e66b3bc3e4b$var$_interopRequireDefault((parcelRequire("aWy0H")));

var $55735e66b3bc3e4b$var$_search2 = $55735e66b3bc3e4b$var$_interopRequireDefault((parcelRequire("Ltnm7")));
function $55735e66b3bc3e4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $55735e66b3bc3e4b$var$SearchIcon = (props)=>/*#__PURE__*/ $55735e66b3bc3e4b$var$_react.default.createElement($55735e66b3bc3e4b$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $55735e66b3bc3e4b$var$_search2.default
    }, props));
$55735e66b3bc3e4b$var$SearchIcon.Name = 'SearchIconMigration';
var $55735e66b3bc3e4b$var$_default = module.exports.default = $55735e66b3bc3e4b$var$SearchIcon;

});
parcelRegister("Ltnm7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08eb2d4df89f92f3$var$_react = $08eb2d4df89f92f3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $08eb2d4df89f92f3$var$_search = $08eb2d4df89f92f3$var$_interopRequireDefault((parcelRequire("aWy0H")));
function $08eb2d4df89f92f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $08eb2d4df89f92f3$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $08eb2d4df89f92f3$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $08eb2d4df89f92f3$var$_search.default
    }));
$08eb2d4df89f92f3$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $08eb2d4df89f92f3$var$_default = module.exports.default = $08eb2d4df89f92f3$var$EditorSearchIcon;

});



parcelRegister("aztrV", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $eda715fe218ca2e5$export$17baa7c95b6ba1b8);

var $8Oct0 = parcelRequire("8Oct0");
function $eda715fe218ca2e5$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    (0, $8Oct0.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});




parcelRegister("f3Ls0", function(module, exports) {

$parcel$export(module.exports, "batchByKey", () => $81fcd896751fe1de$export$da86c38211c1c0a8);
function $81fcd896751fe1de$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}

});

parcelRegister("4NWOr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e6014f1bd11e07e5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e6014f1bd11e07e5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        id: 'fabric.elements.user-picker.placeholder',
        defaultMessage: 'Enter people or teams...',
        description: 'Placeholder description for empty user/team/email select field.'
    },
    addMore: {
        id: 'fabric.elements.user-picker.placeholder.add-more',
        defaultMessage: 'add more people...',
        description: 'Placeholder for multi user picker when the field is not empty.'
    },
    remove: {
        id: 'fabric.elements.user-picker.multi.remove-item',
        defaultMessage: 'Remove',
        description: 'Tooltip for the single item remove button in a multi user select field.'
    },
    clear: {
        id: 'fabric.elements.user-picker.single.clear',
        defaultMessage: 'Clear',
        description: 'Tooltip for clear button in the single user select field.'
    },
    errorMessage: {
        id: 'fabric.elements.user-picker.error.message',
        defaultMessage: 'Something went wrong',
        description: 'Error message to display when options fail to load.'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.user-picker.team.member.count.including.you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.user-picker.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    addEmail: {
        id: 'fabric.elements.user-picker.email.add',
        defaultMessage: 'Add user',
        description: 'Byline for valid email option.'
    },
    selectToAddEmail: {
        id: 'fabric.elements.user-picker.email.select.to.add',
        defaultMessage: 'Select an email address',
        description: 'Byline for valid email option.'
    },
    continueToAddEmail: {
        id: 'fabric.elements.user-picker.email.add.potential',
        defaultMessage: 'Enter an email address',
        description: 'Byline for a potentially valid email option.'
    },
    groupByline: {
        id: 'fabric.elements.user-picker.group.byline',
        defaultMessage: 'Admin-managed group',
        description: 'Byline for admin-managed groups'
    },
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    externalUserSourcesError: {
        id: 'fabric.elements.user-picker.external.sourced.error',
        defaultMessage: "We can't connect you right now.",
        description: "Error message when we can't fetch a user's import sources"
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    jiraSource: {
        id: 'fabric.elements.user-picker.source.jira',
        defaultMessage: 'Jira',
        description: 'This external user is sourced from Jira'
    },
    confluenceSource: {
        id: 'fabric.elements.user-picker.source.confluence',
        defaultMessage: 'Confluence',
        description: 'This external user is sourced from Confluence'
    },
    otherAtlassianSource: {
        id: 'fabric.elements.user-picker.source.other-atlassian',
        defaultMessage: 'Other Atlassian products',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    }
});

});

parcelRegister("dhLc4", function(module, exports) {

$parcel$export(module.exports, "userPickerRenderedUfoExperience", () => $c4652decfc9c5e44$export$b49757166e1acfc2);
$parcel$export(module.exports, "userPickerOptionsShownUfoExperience", () => $c4652decfc9c5e44$export$135a264e0da507ae);
$parcel$export(module.exports, "UfoErrorBoundary", () => $c4652decfc9c5e44$export$5ef1c2550074a375);

var $5uXOq = parcelRequire("5uXOq");

var $766ff = parcelRequire("766ff");
var $2DPlK = parcelRequire("2DPlK");
var $e35GK = parcelRequire("e35GK");
const $c4652decfc9c5e44$export$b49757166e1acfc2 = new (0, $766ff.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $2DPlK.ExperienceTypes).Load,
    performanceType: (0, $2DPlK.ExperiencePerformanceTypes).PageSegmentLoad
});
const $c4652decfc9c5e44$export$135a264e0da507ae = new (0, $766ff.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $2DPlK.ExperienceTypes).Operation,
    performanceType: (0, $2DPlK.ExperiencePerformanceTypes).InlineResult
});
class $c4652decfc9c5e44$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch() {
        const instance = $c4652decfc9c5e44$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $e35GK.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}

});
parcelRegister("766ff", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $da9c8b3012314011$export$ac1cddfee07ba6ac);

var $2wNBQ = parcelRequire("2wNBQ");

var $88I8J = parcelRequire("88I8J");
class $da9c8b3012314011$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $88I8J.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $2wNBQ.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});
parcelRegister("2wNBQ", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $e21c0e48b85ac35f$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $e21c0e48b85ac35f$export$d53d07b6034c4560);
class $e21c0e48b85ac35f$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($e21c0e48b85ac35f$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($e21c0e48b85ac35f$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $e21c0e48b85ac35f$export$4ab84f6f04f6566d = new $e21c0e48b85ac35f$var$UFOLogger();
const $e21c0e48b85ac35f$export$b4958caff08a0960 = (...args)=>{
    $e21c0e48b85ac35f$export$4ab84f6f04f6566d.log(...args);
};
const $e21c0e48b85ac35f$export$d53d07b6034c4560 = (...args)=>{
    $e21c0e48b85ac35f$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("88I8J", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $7dc185119b1e6fd5$export$c00d22927c60484a);

var $1P3p8 = parcelRequire("1P3p8");
class $7dc185119b1e6fd5$export$c00d22927c60484a extends (0, $1P3p8.UFOAbstractExperience) {
}

});
parcelRegister("1P3p8", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $9824d3eed3202584$export$d31c89db257648c);

var $7Jxgt = parcelRequire("7Jxgt");


var $aLMb0 = parcelRequire("aLMb0");

var $2wNBQ = parcelRequire("2wNBQ");

var $cKyn4 = parcelRequire("cKyn4");

var $tygmh = parcelRequire("tygmh");

var $3kS24 = parcelRequire("3kS24");

var $XbbCG = parcelRequire("XbbCG");

var $e35GK = parcelRequire("e35GK");

var $imyh4 = parcelRequire("imyh4");

var $2DPlK = parcelRequire("2DPlK");
const $9824d3eed3202584$var$getPageVisibleState = ()=>{
    return !(0, $XbbCG.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $tygmh.PageVisibleState).VISIBLE : (0, $tygmh.PageVisibleState).HIDDEN;
};
const $9824d3eed3202584$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $3kS24.roundPerfNow)();
};
class $9824d3eed3202584$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $e35GK.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $tygmh.PageVisibleState).MIXED;
            (0, $cKyn4.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $9824d3eed3202584$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $2DPlK.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $2DPlK.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $2wNBQ.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $imyh4.canTransition)(this.state, newState)) {
            (0, $2wNBQ.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $e35GK.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $9824d3eed3202584$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $7Jxgt.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $9824d3eed3202584$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $aLMb0.getGlobalEventStream)().push((0, $aLMb0.unsubscribeEvent)((0, $tygmh.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $2wNBQ.ufolog)('this.parent', this.parent);
                (0, $aLMb0.getGlobalEventStream)().push((0, $aLMb0.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $2wNBQ.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $2wNBQ.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $e35GK.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $9824d3eed3202584$var$getPageVisibleState();
            (0, $cKyn4.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $2wNBQ.ufolog)('subscribed', this.id);
                (0, $aLMb0.getGlobalEventStream)().push((0, $aLMb0.subscribeEvent)((0, $tygmh.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $tygmh.FMP_MARK) && name !== (0, $tygmh.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $2wNBQ.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $9824d3eed3202584$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $e35GK.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $tygmh.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $tygmh.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $2wNBQ.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $cKyn4.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $e35GK.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $e35GK.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $e35GK.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $2wNBQ.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $7619d17858293199$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $7619d17858293199$export$2295b861f318254a = '0.1.5';

parcelRegister("aLMb0", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $c9650d6b88372c57$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $c9650d6b88372c57$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $c9650d6b88372c57$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $c9650d6b88372c57$export$7c957416596ca127);

var $2wNBQ = parcelRequire("2wNBQ");

var $tygmh = parcelRequire("tygmh");
const $c9650d6b88372c57$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $c9650d6b88372c57$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $c9650d6b88372c57$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $c9650d6b88372c57$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $2wNBQ.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $c9650d6b88372c57$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $tygmh.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $c9650d6b88372c57$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $tygmh.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $c9650d6b88372c57$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $tygmh.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("tygmh", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $783e3ea93c098a9f$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $783e3ea93c098a9f$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $783e3ea93c098a9f$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $783e3ea93c098a9f$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $783e3ea93c098a9f$export$837e0f79a8056912);
var $783e3ea93c098a9f$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $783e3ea93c098a9f$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $783e3ea93c098a9f$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $783e3ea93c098a9f$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $783e3ea93c098a9f$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $783e3ea93c098a9f$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $783e3ea93c098a9f$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $783e3ea93c098a9f$export$9f2bf58999404c75 = 'fmp';
const $783e3ea93c098a9f$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("cKyn4", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $2d5c4cc6715bad69$export$13e680397ec8f3eb);

var $XbbCG = parcelRequire("XbbCG");
class $2d5c4cc6715bad69$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $XbbCG.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $2d5c4cc6715bad69$export$13e680397ec8f3eb = new $2d5c4cc6715bad69$var$VisibilityChangeObserver();

});
parcelRegister("XbbCG", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $e250b8eb352b8899$export$15e172712955e18f);
const $e250b8eb352b8899$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("3kS24", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $7d396d4d77bd4c64$export$5f490af6b2b115cf);
const $7d396d4d77bd4c64$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("imyh4", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $6e629e7253e8adab$export$178881f329fdb81f);

var $e35GK = parcelRequire("e35GK");
const $6e629e7253e8adab$var$UFOStateAvailableTransitions = {
    [(0, $e35GK.UFOExperienceState).NOT_STARTED.id]: [
        (0, $e35GK.UFOExperienceState).STARTED.id
    ],
    [(0, $e35GK.UFOExperienceState).STARTED.id]: [
        (0, $e35GK.UFOExperienceState).IN_PROGRESS.id,
        (0, $e35GK.UFOExperienceState).BLOCKED.id,
        (0, $e35GK.UFOExperienceState).SUCCEEDED.id,
        (0, $e35GK.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $e35GK.UFOExperienceState).FAILED.id,
        (0, $e35GK.UFOExperienceState).ABORTED.id
    ],
    [(0, $e35GK.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $e35GK.UFOExperienceState).BLOCKED.id,
        (0, $e35GK.UFOExperienceState).SUCCEEDED.id,
        (0, $e35GK.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $e35GK.UFOExperienceState).FAILED.id,
        (0, $e35GK.UFOExperienceState).ABORTED.id
    ],
    [(0, $e35GK.UFOExperienceState).BLOCKED.id]: [
        (0, $e35GK.UFOExperienceState).RECOVERED.id,
        (0, $e35GK.UFOExperienceState).ABORTED.id
    ],
    [(0, $e35GK.UFOExperienceState).RECOVERED.id]: [
        (0, $e35GK.UFOExperienceState).STARTED.id,
        (0, $e35GK.UFOExperienceState).SUCCEEDED.id,
        (0, $e35GK.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $e35GK.UFOExperienceState).FAILED.id,
        (0, $e35GK.UFOExperienceState).ABORTED.id
    ],
    [(0, $e35GK.UFOExperienceState).SUCCEEDED.id]: [
        (0, $e35GK.UFOExperienceState).STARTED.id
    ],
    [(0, $e35GK.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $e35GK.UFOExperienceState).SUCCEEDED.id,
        (0, $e35GK.UFOExperienceState).FAILED.id,
        (0, $e35GK.UFOExperienceState).ABORTED.id
    ],
    [(0, $e35GK.UFOExperienceState).FAILED.id]: [
        (0, $e35GK.UFOExperienceState).STARTED.id
    ],
    [(0, $e35GK.UFOExperienceState).ABORTED.id]: [
        (0, $e35GK.UFOExperienceState).STARTED.id
    ]
};
const $6e629e7253e8adab$export$178881f329fdb81f = (state1, state2)=>{
    return $6e629e7253e8adab$var$UFOStateAvailableTransitions[state1.id] && $6e629e7253e8adab$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("2DPlK", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $7ec62a983b348252$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $7ec62a983b348252$export$cc26007c03242fff);
var $7ec62a983b348252$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $7ec62a983b348252$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});






parcelRegister("lor1T", function(module, exports) {

$parcel$export(module.exports, "BORDER_PADDING", () => $5137687be2312326$export$59c188914e58c94b);
$parcel$export(module.exports, "getStyles", () => $5137687be2312326$export$ffd58b7f6f099a57);
$parcel$export(module.exports, "getPopupStyles", () => $5137687be2312326$export$4e983f376ad8a3af);


var $8QpSo = parcelRequire("8QpSo");

var $1BKyN = parcelRequire("1BKyN");
const $5137687be2312326$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $5137687be2312326$export$53937c04f7dfc2ae = 6;
const $5137687be2312326$export$2c62ba763e976c54 = 39;
const $5137687be2312326$export$ffd58b7f6f099a57 = (0, $8QpSo.default)((width, isMulti, isCompact, overrideStyles, isInvalid, isVisualRefresh, isPopupStyles)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: isInvalid ? `var(--ds-border-danger, ${0, $a7f8c6b391092279$export$2010d0fb4295b346})` : state.isFocused ? `var(--ds-border-focused, ${css.borderColor})` : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : `var(--ds-border-input, ${0, $a7f8c6b391092279$export$7c87d337fb91a97d})`,
                backgroundColor: state.isFocused ? `var(--ds-background-input, ${css['backgroundColor']})` : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? `var(--ds-background-input, ${0, $a7f8c6b391092279$export$e655ef011c4aa1a2})` : `var(--ds-background-input, ${0, $a7f8c6b391092279$export$9fdfb749e33cdf97})`,
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: isInvalid ? `var(--ds-border-danger, ${0, $a7f8c6b391092279$export$2010d0fb4295b346})` : state.isFocused ? css[':hover'] ? `var(--ds-border-focused, ${css[':hover'].borderColor})` : `var(--ds-border-focused, ${0, $a7f8c6b391092279$export$ecfc1dff386a3e7a})` : state.selectProps.subtle ? 'transparent' : `var(--ds-border-input, ${0, $a7f8c6b391092279$export$7c87d337fb91a97d})`,
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? `var(--ds-background-danger, ${0, $a7f8c6b391092279$export$4b84fd0e2c617bd})` : state.isFocused ? css[':hover'] ? `var(--ds-background-input, ${css[':hover'].backgroundColor})` : `var(--ds-background-input, ${0, $a7f8c6b391092279$export$29a4f05edc054374})` : state.isDisabled ? `var(--ds-background-disabled, ${0, $a7f8c6b391092279$export$e655ef011c4aa1a2})` : `var(--ds-background-input-hovered, ${0, $a7f8c6b391092279$export$3e51e8f1440314ba})`
                },
                padding: 0,
                minHeight: isCompact ? 'none' : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: `var(--ds-icon-danger, ${0, $a7f8c6b391092279$export$2010d0fb4295b346})`
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? 0 : $5137687be2312326$export$59c188914e58c94b,
                paddingBottom: isCompact ? 0 : $5137687be2312326$export$59c188914e58c94b,
                paddingLeft: isMulti ? $5137687be2312326$export$59c188914e58c94b : 0,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$5137687be2312326$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $5137687be2312326$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>{
            if (isVisualRefresh) return {
                ...css,
                overflow: 'hidden',
                paddingLeft: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)",
                paddingRight: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)"
            };
            return {
                ...css,
                overflow: 'hidden'
            };
        },
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: state.selectProps.isMulti ? 0 : $5137687be2312326$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: `var(--ds-text-subtlest, ${0, $a7f8c6b391092279$export$d6447c357493214f})`,
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: `var(--ds-text-subtlest, ${0, $a7f8c6b391092279$export$d6447c357493214f})`
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $1BKyN.mergeStyles)(styles, overrideStyles) : styles;
});
const $5137687be2312326$export$4e983f376ad8a3af = (0, $8QpSo.default)((width, isMulti, overrideStyles, isVisualRefresh)=>({
        ...$5137687be2312326$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles, false, isVisualRefresh, true)
    }));

});

parcelRegister("cnoGa", function(module, exports) {

$parcel$export(module.exports, "getComponents", () => $9e80c7fb0ec6ec7b$export$4e811121b221213b);
$parcel$export(module.exports, "getPopupComponents", () => $9e80c7fb0ec6ec7b$export$19205fd341a6bb08);

var $8QpSo = parcelRequire("8QpSo");

var $4YoV5 = parcelRequire("4YoV5");

var $dtNVh = parcelRequire("dtNVh");

var $6CXdK = parcelRequire("6CXdK");

var $gWmUf = parcelRequire("gWmUf");

var $7EN2Y = parcelRequire("7EN2Y");

var $jUKmL = parcelRequire("jUKmL");

var $fAFbI = parcelRequire("fAFbI");

var $aK2hz = parcelRequire("aK2hz");

var $4grkH = parcelRequire("4grkH");

var $6tZmh = parcelRequire("6tZmh");
const $9e80c7fb0ec6ec7b$export$4e811121b221213b = (0, $8QpSo.default)((multi, anchor)=>{
    if (anchor) return {
        Control: anchor,
        Option: $gWmUf.Option
    };
    else return {
        MultiValue: $dtNVh.MultiValue,
        DropdownIndicator: null,
        SingleValue: $7EN2Y.SingleValue,
        ClearIndicator: multi ? null : (0, $4YoV5.ClearIndicator),
        Option: $gWmUf.Option,
        ValueContainer: multi ? (0, $6CXdK.MultiValueContainer) : (0, $fAFbI.SingleValueContainer),
        Input: $jUKmL.Input,
        Menu: $6tZmh.Menu
    };
});
const $9e80c7fb0ec6ec7b$export$19205fd341a6bb08 = (0, $8QpSo.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $7EN2Y.SingleValue,
        ClearIndicator: $4YoV5.ClearIndicator,
        Option: $gWmUf.Option,
        ValueContainer: (0, $fAFbI.SingleValueContainer),
        Input: (0, $aK2hz.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $4grkH.PopupControl)
    };
    return baseProps;
});

});
parcelRegister("4YoV5", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $df76864cb02026d8$export$ecf9cf59142dd54a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $b1kcy = parcelRequire("b1kcy");

const $df76864cb02026d8$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("4tQB9")).then((module)=>{
        return {
            default: module.default
        };
    }));
class $df76864cb02026d8$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            }
        });
        return clearValueLabel ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
            fallback: Indicator,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($df76864cb02026d8$var$AsyncTooltip, {
                content: clearValueLabel,
                children: Indicator
            })
        }) : Indicator;
    }
    constructor(...args){
        super(...args), this.handleMouseDown = (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue();
            //@ts-ignore react-select unsupported props
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        };
    }
}

});
parcelRegister("4tQB9", function(module, exports) {

let $3432abc7e67820eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3432abc7e67820eb$var$load("95awv").then(()=>parcelRequire('gGV5g'));

});


parcelRegister("dtNVh", function(module, exports) {

$parcel$export(module.exports, "MultiValue", () => $94ec0dcd8f0d6d4c$export$419cdf50db8b579);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $2s57o = parcelRequire("2s57o");

var $b1kcy = parcelRequire("b1kcy");

var $f8Sb3 = parcelRequire("f8Sb3");

var $2i4X3 = parcelRequire("2i4X3");

var $9tC62 = parcelRequire("9tC62");

var $grXIr = parcelRequire("grXIr");

var $IoPSi = parcelRequire("IoPSi");

var $5uGNN = parcelRequire("5uGNN");

var $fHpHg = parcelRequire("fHpHg");
function $94ec0dcd8f0d6d4c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $94ec0dcd8f0d6d4c$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $94ec0dcd8f0d6d4c$var$groupTagContainer = (0, $2s57o.xcss)({
    paddingLeft: 'space.025',
    marginTop: 'space.025'
});
const $94ec0dcd8f0d6d4c$var$nameWrapper = {
    name: "1ebbz80",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
};
class $94ec0dcd8f0d6d4c$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props), this.getElemBefore = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $grXIr.isEmail)(data)) // This element is a decorative icon and does not require a label
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2i4X3.AddOptionAvatar), {
                isLozenge: true
            });
            if ((0, $grXIr.isGroup)(data)) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $0yZbT.default), {
                xcss: $94ec0dcd8f0d6d4c$var$groupTagContainer
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($IoPSi))), {
                LEGACY_margin: "-2px 0 0 0",
                color: "currentColor",
                label: "" // This element is a decorative icon and does not require a label
                ,
                LEGACY_size: "small"
            }));
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9tC62.SizeableAvatar), {
                appearance: "multi",
                src: (0, $grXIr.getAvatarUrl)(data),
                type: (0, $grXIr.isTeam)(data) && (0, $fHpHg.fg)('verified-team-in-user-picker') ? 'team' : 'person'
            });
        }, this.getElemAfter = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $grXIr.isTeam)(data) && data.verified && (0, $fHpHg.fg)('verified-team-in-user-picker')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uGNN.VerifiedTeamIcon), null);
            return null;
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef();
    }
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $94ec0dcd8f0d6d4c$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: innerProps, ...rest } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $b1kcy.components).MultiValue, {
            ...rest,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2Eqc8.default), {
            alignBlock: "center"
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $94ec0dcd8f0d6d4c$var$nameWrapper
        }, children), this.getElemAfter()));
    }
}

});
parcelRegister("2i4X3", function(module, exports) {

$parcel$export(module.exports, "AddOptionAvatar", () => $e95c724b1c8bbd59$export$df396db45e491922);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bEcs6 = parcelRequire("bEcs6");


var $f8Sb3 = parcelRequire("f8Sb3");
parcelRequire("5uXOq");
const $e95c724b1c8bbd59$var$getEmailAvatarWrapperStyle = (isLozenge)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: padding,
        backgroundColor: `var(--ds-background-neutral, ${(0, $a7f8c6b391092279$export$1ce2d1575d444ceb)})`,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        marginLeft: "var(--ds-space-025, 2px)"
    });
};
const $e95c724b1c8bbd59$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $e95c724b1c8bbd59$var$getEmailAvatarWrapperStyle(isLozenge)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bEcs6))), {
        testId: "add-option-avatar-email-icon",
        label: label || '',
        LEGACY_size: isLozenge ? 'small' : 'medium',
        LEGACY_margin: "0 0 0 -2px",
        color: `var(--ds-text-subtle, ${(0, $a7f8c6b391092279$export$c39c0fe0f26207ae)})`
    })));
};

});
parcelRegister("bEcs6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2014ecb862bd114df9c4eca3bb7d0c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87ad16e679cb17a1$var$_react = $87ad16e679cb17a1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87ad16e679cb17a1$var$_email = $87ad16e679cb17a1$var$_interopRequireDefault((parcelRequire("dvv9E")));

var $87ad16e679cb17a1$var$_email2 = $87ad16e679cb17a1$var$_interopRequireDefault((parcelRequire("dTO85")));
function $87ad16e679cb17a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmailIcon.
 * This component is EmailIcon, with `UNSAFE_fallbackIcon` set to "EmailIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87ad16e679cb17a1$var$EmailIcon = (props)=>/*#__PURE__*/ $87ad16e679cb17a1$var$_react.default.createElement($87ad16e679cb17a1$var$_email.default, Object.assign({
        LEGACY_fallbackIcon: $87ad16e679cb17a1$var$_email2.default
    }, props));
$87ad16e679cb17a1$var$EmailIcon.Name = 'EmailIconMigration';
var $87ad16e679cb17a1$var$_default = module.exports.default = $87ad16e679cb17a1$var$EmailIcon;

});
parcelRegister("dTO85", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1e74c1782477aa6$var$_react = $a1e74c1782477aa6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $a1e74c1782477aa6$var$_email = $a1e74c1782477aa6$var$_interopRequireDefault((parcelRequire("dvv9E")));
function $a1e74c1782477aa6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a1e74c1782477aa6$var$EmailIcon = (props)=>/*#__PURE__*/ $a1e74c1782477aa6$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props, {
        newIcon: $a1e74c1782477aa6$var$_email.default
    }));
$a1e74c1782477aa6$var$EmailIcon.displayName = 'EmailIcon';
var $a1e74c1782477aa6$var$_default = module.exports.default = $a1e74c1782477aa6$var$EmailIcon;

});



parcelRegister("9tC62", function(module, exports) {

$parcel$export(module.exports, "SizeableAvatar", () => $4489f08f8425adec$export$44d81a88129649da);

var $2OMIu = parcelRequire("2OMIu");

var $ew55A = parcelRequire("ew55A");

var $cFwjb = parcelRequire("cFwjb");

var $5uXOq = parcelRequire("5uXOq");

var $grXIr = parcelRequire("grXIr");
class $4489f08f8425adec$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person' } = this.props;
        const props = {
            size: (0, $grXIr.getAvatarSize)(appearance),
            src: src,
            borderColor: 'transparent',
            presence: presence
        };
        return type === 'team' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFwjb.default), {
            ...props
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ew55A.default), {
            ...props
        });
    }
}

});

parcelRegister("IoPSi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff23a711b4b109cded01cd0a5945034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08576006ad7cfbb6$var$_react = $08576006ad7cfbb6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $08576006ad7cfbb6$var$_peopleGroup = $08576006ad7cfbb6$var$_interopRequireDefault((parcelRequire("gfxSS")));

var $08576006ad7cfbb6$var$_people = $08576006ad7cfbb6$var$_interopRequireDefault((parcelRequire("GLupd")));
function $08576006ad7cfbb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $08576006ad7cfbb6$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $08576006ad7cfbb6$var$_react.default.createElement($08576006ad7cfbb6$var$_peopleGroup.default, Object.assign({
        LEGACY_fallbackIcon: $08576006ad7cfbb6$var$_people.default
    }, props));
$08576006ad7cfbb6$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
var $08576006ad7cfbb6$var$_default = module.exports.default = $08576006ad7cfbb6$var$PeopleGroupIcon;

});

parcelRegister("5uGNN", function(module, exports) {

$parcel$export(module.exports, "VerifiedTeamIcon", () => $62ccb659a0f5c058$export$d7949f68d31e5edd);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $jGBbV = parcelRequire("jGBbV");

var $8PSX5 = parcelRequire("8PSX5");

var $5KCCi = parcelRequire("5KCCi");

var $cJFyP = parcelRequire("cJFyP");
const $62ccb659a0f5c058$export$d7949f68d31e5edd = ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $cJFyP.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
            tabIndex: 0,
            role: "button",
            "aria-hidden": "true",
            "data-testid": "verified-team-icon",
            children: [
                ' ',
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jGBbV))), {
                    color: "var(--ds-icon-accent-blue, #1D7AFC)",
                    LEGACY_size: "medium",
                    label: tooltipContent,
                    spacing: "spacious",
                    LEGACY_fallbackIcon: (0, $8PSX5.default)
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jGBbV))), {
        color: "var(--ds-icon-accent-blue, #1D7AFC)",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: label,
        LEGACY_fallbackIcon: (0, $8PSX5.default)
    });
};

});
parcelRegister("jGBbV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08303db08bddd05336395b40b61b967a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e54eca00b611caa6$var$_react = $e54eca00b611caa6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e54eca00b611caa6$var$_baseNew = $e54eca00b611caa6$var$_interopRequireDefault((parcelRequire("enEmH")));
function $e54eca00b611caa6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusVerified".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing verified content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e54eca00b611caa6$var$StatusVerifiedIcon = (props)=>/*#__PURE__*/ $e54eca00b611caa6$var$_react.default.createElement($e54eca00b611caa6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.15.444a1.713 1.713 0 0 0-2.3 0L5.7 1.486a.2.2 0 0 1-.15.055L4 1.481a1.713 1.713 0 0 0-1.763 1.48l-.21 1.536a.2.2 0 0 1-.08.139l-1.225.95c-.697.54-.87 1.52-.4 2.266l.827 1.312c.03.047.04.104.027.159l-.328 1.515A1.713 1.713 0 0 0 2 12.831l1.477.474a.2.2 0 0 1 .123.103l.723 1.372c.41.78 1.346 1.12 2.162.787l1.436-.586a.2.2 0 0 1 .16 0l1.436.586a1.713 1.713 0 0 0 2.162-.787l.723-1.372a.2.2 0 0 1 .123-.103l1.477-.474a1.713 1.713 0 0 0 1.15-1.993l-.328-1.515a.2.2 0 0 1 .028-.159l.827-1.312a1.71 1.71 0 0 0-.4-2.266l-1.225-.95a.2.2 0 0 1-.08-.14l-.21-1.536A1.713 1.713 0 0 0 12 1.481l-1.55.06a.2.2 0 0 1-.15-.055zm3.176 5.036-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$e54eca00b611caa6$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
var $e54eca00b611caa6$var$_default = module.exports.default = $e54eca00b611caa6$var$StatusVerifiedIcon;

});

parcelRegister("8PSX5", function(module, exports) {

$parcel$export(module.exports, "default", () => $49a04c34dba77105$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $49a04c34dba77105$var$VerifiedIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.6666 6.65507C17.7592 4.89362 15.2407 4.89362 14.3332 6.65507C13.7879 7.7135 12.5577 8.22306 11.4237 7.86022C9.53648 7.25639 7.75565 9.03721 8.35949 10.9244C8.72232 12.0584 8.21276 13.2886 7.15434 13.8339C5.39289 14.7414 5.39289 17.2599 7.15434 18.1674C8.21276 18.7127 8.72232 19.9429 8.35949 21.0769C7.75565 22.9641 9.53648 24.7449 11.4237 24.1411C12.5577 23.7783 13.7879 24.2878 14.3332 25.3462C15.2407 27.1077 17.7592 27.1077 18.6666 25.3462C19.212 24.2878 20.4421 23.7783 21.5761 24.1411C23.4634 24.7449 25.2442 22.9641 24.6404 21.0769C24.2775 19.9429 24.7871 18.7127 25.8455 18.1674C27.607 17.2599 27.607 14.7414 25.8455 13.8339C24.7871 13.2886 24.2775 12.0584 24.6404 10.9244C25.2442 9.03721 23.4634 7.25639 21.5761 7.86022C20.4421 8.22306 19.212 7.7135 18.6666 6.65507ZM20.7898 12.7002L20.8932 12.7923C21.323 13.2221 21.3537 13.8998 20.9853 14.365L20.8932 14.4684L16.1524 19.2091C15.7226 19.6389 15.0449 19.6696 14.5797 19.3012L14.4764 19.2091L12.106 16.8388C11.6431 16.3759 11.6431 15.6255 12.106 15.1627C12.5358 14.7329 13.2135 14.7022 13.6787 15.0706L13.7821 15.1627L15.3146 16.6944L19.2171 12.7923C19.6469 12.3625 20.3246 12.3318 20.7898 12.7002Z",
            fill: "currentColor"
        })
    });
/**
 * __VerifiedIcon__
 */ const $49a04c34dba77105$var$VerifiedIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ltBcH.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $49a04c34dba77105$var$VerifiedIconGlyph
    });
var $49a04c34dba77105$export$2e2bcd8739ae039 = $49a04c34dba77105$var$VerifiedIcon;

});

parcelRegister("cJFyP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5fbb80e95a063e02$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5fbb80e95a063e02$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: 'ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip',
        defaultMessage: 'Managed teams are verified because they can only be changed by an admin.',
        description: 'Tooltip text for the verified team icon'
    }
});

});



parcelRegister("6CXdK", function(module, exports) {

$parcel$export(module.exports, "MultiValueContainer", () => $3bdf0218ead7cc96$export$cf9cf2a30a59265c);

var $2OMIu = parcelRequire("2OMIu");

var $b1kcy = parcelRequire("b1kcy");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $ousew = parcelRequire("ousew");

var $4NWOr = parcelRequire("4NWOr");

var $grXIr = parcelRequire("grXIr");

var $h34oI = parcelRequire("h34oI");
class $3bdf0218ead7cc96$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    constructor(props){
        super(props), this.timeoutId = null, this.scrollToBottom = ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) {
                    const container = (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).findDOMNode(current);
                    if (container instanceof HTMLDivElement) container.scrollTop = container.scrollHeight;
                }
                this.timeoutId = null;
            });
        }, this.showPlaceholder = ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        }, this.addPlaceholder = (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(this.props.children, (child)=>(0, $grXIr.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: children
            });
        }, this.renderChildren = ()=>{
            const { //@ts-ignore react-select unsupported props
            selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props;
            // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $4NWOr.messages).addMore,
                children: (addMore)=>{
                    let addMoreMessages = addMore;
                    if (addMore && typeof addMore === 'string') addMoreMessages = [
                        addMore
                    ];
                    const placeholder = addMoreMessages?.join('') ?? '';
                    return this.addPlaceholder(placeholder);
                }
            });
            return this.addPlaceholder(addMoreMessage);
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef()
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        //@ts-ignore react-select unsupported props
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            innerProps: this.valueContainerInnerProps
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h34oI.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).ValueContainer, {
                ...props,
                children: this.renderChildren()
            })
        });
    }
}

});
parcelRegister("h34oI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f04b52c8ea4f6d06$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $f04b52c8ea4f6d06$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $f04b52c8ea4f6d06$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $f04b52c8ea4f6d06$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $f04b52c8ea4f6d06$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
var $f04b52c8ea4f6d06$export$2e2bcd8739ae039 = $f04b52c8ea4f6d06$var$ValueContainerWrapper;

});


parcelRegister("gWmUf", function(module, exports) {

$parcel$export(module.exports, "Option", () => $5ba8751fc07b7c62$export$36d18380658d5d20);

var $2OMIu = parcelRequire("2OMIu");

var $0yZbT = parcelRequire("0yZbT");

var $b1kcy = parcelRequire("b1kcy");

var $5KCCi = parcelRequire("5KCCi");

var $5uXOq = parcelRequire("5uXOq");

var $2PHGY = parcelRequire("2PHGY");

var $YPzRV = parcelRequire("YPzRV");

var $awtJw = parcelRequire("awtJw");

var $2n5eM = parcelRequire("2n5eM");

var $kCULJ = parcelRequire("kCULJ");

var $6cP61 = parcelRequire("6cP61");

var $grXIr = parcelRequire("grXIr");

var $104WL = parcelRequire("104WL");
const $5ba8751fc07b7c62$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2PHGY.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $5ba8751fc07b7c62$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $grXIr.isExternalUser)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $YPzRV.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $grXIr.isUser)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2PHGY.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $grXIr.isEmail)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kCULJ.default), {
        email: data,
        emailValidity: (0, $104WL.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $grXIr.isTeam)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $awtJw.default), {
        team: data,
        isSelected: isSelected
    });
    if ((0, $grXIr.isGroup)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2n5eM.default), {
        group: data,
        isSelected: isSelected
    });
    if ((0, $grXIr.isCustom)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6cP61.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $5ba8751fc07b7c62$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: props.data?.data?.tooltip,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                ...tooltipProps,
                children: $5ba8751fc07b7c62$var$dataOption(props)
            })
    });
    return $5ba8751fc07b7c62$var$dataOption(props);
};
const $5ba8751fc07b7c62$export$36d18380658d5d20 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
            fallback: $5ba8751fc07b7c62$var$defaultOption(props),
            children: $5ba8751fc07b7c62$var$dataOptionWithTooltip(props)
        })
    });

});
parcelRegister("2PHGY", function(module, exports) {

$parcel$export(module.exports, "UserOption", () => $0e4a443eeb5a4e0a$export$8e59f78010871662);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $fbX4N = parcelRequire("fbX4N");

var $5qCda = parcelRequire("5qCda");

var $9tC62 = parcelRequire("9tC62");

var $grXIr = parcelRequire("grXIr");

var $fHpHg = parcelRequire("fHpHg");
class $0e4a443eeb5a4e0a$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fbX4N.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args), this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                    key: "name",
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $fbX4N.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $a7f8c6b391092279$export$b3de0ae08da2ce64})` : `var(--ds-text, ${0, $a7f8c6b391092279$export$7d61b15e0da132af})`)
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5qCda.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $grXIr.hasValue)(publicName) && name.trim() !== publicName.trim()) result.push(/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                key: "publicName"
            }, ' ', /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $fbX4N.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $a7f8c6b391092279$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $a7f8c6b391092279$export$f563ee71e9ee74cd})`)
            }, "(", /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5qCda.HighlightText), {
                highlights: highlight && highlight.publicName
            }, publicName), ")")));
            return result;
        }, this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $fbX4N.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $a7f8c6b391092279$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $a7f8c6b391092279$export$f563ee71e9ee74cd})`)
            }, this.props.user.byline) : undefined, this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl }, status: status } = this.props;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9tC62.SizeableAvatar), {
                appearance: // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
                (0, $fHpHg.fg)('platform-component-visual-refresh') && (0, $fHpHg.fg)('visual-refresh-user-picker') ? 'medium' : 'big',
                src: avatarUrl,
                presence: status
            });
        }, this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}

});
parcelRegister("fbX4N", function(module, exports) {

$parcel$export(module.exports, "textWrapper", () => $2e72275a504ff5d5$export$aa6223da92b253dd);
$parcel$export(module.exports, "AvatarItemOption", () => $2e72275a504ff5d5$export$164a9d9b3b86dd0c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $eOat1 = parcelRequire("eOat1");

var $grXIr = parcelRequire("grXIr");
function $2e72275a504ff5d5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $2e72275a504ff5d5$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("4tQB9")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $2e72275a504ff5d5$var$wrapper = (isDisabled)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
const $2e72275a504ff5d5$var$optionWrapper = {
    name: "yyrqoa",
    styles: "max-width:100%;min-width:0;flex:1 1 100%;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $2e72275a504ff5d5$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    } : {};
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $2e72275a504ff5d5$var$additionalInfo = {
    name: "tjo4qw",
    styles: "float:right"
};
const $2e72275a504ff5d5$export$aa6223da92b253dd = (color)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
const $2e72275a504ff5d5$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderLozenge = ()=>{
        if ((0, $grXIr.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
                fallback: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eOat1.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)($2e72275a504ff5d5$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eOat1.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eOat1.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $2e72275a504ff5d5$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2e72275a504ff5d5$var$optionWrapper
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2e72275a504ff5d5$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2e72275a504ff5d5$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2e72275a504ff5d5$var$additionalInfo
    }, renderLozenge())));
};

});

parcelRegister("5qCda", function(module, exports) {

$parcel$export(module.exports, "HighlightText", () => $c3ed5a07c45b5b38$export$bb02e7bc6e1a7119);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
class $c3ed5a07c45b5b38$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
                children: part.value
            }, index);
            return part.value;
        });
    }
}

});


parcelRegister("YPzRV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a870202364343035$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $a870202364343035$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("e0p5Z")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $a870202364343035$export$2e2bcd8739ae039 = $a870202364343035$var$AsyncExternalUserOption;

});
parcelRegister("e0p5Z", function(module, exports) {

let $a3248839f5f9b5fc$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a3248839f5f9b5fc$var$load("h2MrD"),
    $a3248839f5f9b5fc$var$load("bYT2S"),
    $a3248839f5f9b5fc$var$load("9h9RB")
]).then(()=>parcelRequire('ktIzm'));

});


parcelRegister("awtJw", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ba679b69dd7ccb6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $7ba679b69dd7ccb6$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("1j0Lr")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $7ba679b69dd7ccb6$export$2e2bcd8739ae039 = $7ba679b69dd7ccb6$var$AsyncTeamOption;

});
parcelRegister("1j0Lr", function(module, exports) {

let $0f3828901b52ab32$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0f3828901b52ab32$var$load("fC988").then(()=>parcelRequire('lsQoH'));

});


parcelRegister("2n5eM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fbc1bb80d7a3170$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $6fbc1bb80d7a3170$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("fFM41")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $6fbc1bb80d7a3170$export$2e2bcd8739ae039 = $6fbc1bb80d7a3170$var$AsyncGroupOption;

});
parcelRegister("fFM41", function(module, exports) {

let $b68ff7cf7e321fee$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b68ff7cf7e321fee$var$load("9KU3A").then(()=>parcelRequire('j7bRg'));

});


parcelRegister("kCULJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d9d80be6c5e0939$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $4d9d80be6c5e0939$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("caJxV")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $4d9d80be6c5e0939$export$2e2bcd8739ae039 = $4d9d80be6c5e0939$var$AsyncEmailOption;

});
parcelRegister("caJxV", function(module, exports) {

let $8dc9bfbc0f78aa34$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8dc9bfbc0f78aa34$var$load("1GZuZ").then(()=>parcelRequire('jqML9'));

});


parcelRegister("6cP61", function(module, exports) {

$parcel$export(module.exports, "default", () => $00b38ebfc92215d7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $00b38ebfc92215d7$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("dKtsE")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $00b38ebfc92215d7$export$2e2bcd8739ae039 = $00b38ebfc92215d7$var$AsyncCustomOption;

});
parcelRegister("dKtsE", function(module, exports) {

let $a0266c966245cb62$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a0266c966245cb62$var$load("k0Mrq").then(()=>parcelRequire('1d4Fe'));

});


parcelRegister("104WL", function(module, exports) {

$parcel$export(module.exports, "isValidEmail", () => $609db301c001dbf3$export$371e338370561054);
const $609db301c001dbf3$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $609db301c001dbf3$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $609db301c001dbf3$export$371e338370561054 = (inputText)=>{
    if (inputText.match($609db301c001dbf3$var$validRegex)) return 'VALID';
    if (inputText.match($609db301c001dbf3$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};

});


parcelRegister("7EN2Y", function(module, exports) {

$parcel$export(module.exports, "SingleValue", () => $3ac61185f8cc9790$export$1949dac661ba6e3a);
/* SingleValue.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $b1kcy = parcelRequire("b1kcy");

var $9tC62 = parcelRequire("9tC62");

var $grXIr = parcelRequire("grXIr");

var $5uGNN = parcelRequire("5uGNN");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
var $AX5oF = parcelRequire("AX5oF");
var $5sLH0 = parcelRequire("5sLH0");
const $3ac61185f8cc9790$var$styles = {
    avatarItem: "_1reo15vq _18m915vq _4cvr1h6o _1ul953f4",
    avatarItemTextWrapper: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _bozgu2gc _vwz419ii",
    avatarItemText: "_syaz1fxt _1reo15vq _1bto1l2s _o5721q9c"
};
const $3ac61185f8cc9790$var$ElementAfter = (props)=>{
    const { data: { data: data } } = props;
    if ((0, $grXIr.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uGNN.VerifiedTeamIcon), {});
    return null;
};
const $3ac61185f8cc9790$export$1949dac661ba6e3a = (props)=>{
    const { data: { label: label, data: data }, //@ts-ignore react-select unsupported props
    selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    return !isFocused ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $AX5oF.default), {
            xcss: $3ac61185f8cc9790$var$styles.avatarItem,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9tC62.SizeableAvatar), {
                    src: (0, $grXIr.getAvatarUrl)(data),
                    appearance: appearance,
                    type: (0, $grXIr.isTeam)(data) && (0, $fHpHg.fg)('verified-team-in-user-picker') ? 'team' : 'person'
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    xcss: $3ac61185f8cc9790$var$styles.avatarItem,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            $3ac61185f8cc9790$var$styles.avatarItemTextWrapper
                        ]),
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                            xcss: $3ac61185f8cc9790$var$styles.avatarItemText,
                            children: (0, $fHpHg.fg)('verified-team-in-user-picker') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                                alignBlock: "center",
                                children: [
                                    label,
                                    /*#__PURE__*/ (0, $2OMIu.jsx)($3ac61185f8cc9790$var$ElementAfter, {
                                        ...props
                                    })
                                ]
                            }) : label
                        })
                    })
                })
            ]
        })
    }) : null;
};

});

parcelRegister("jUKmL", function(module, exports) {

$parcel$export(module.exports, "Input", () => $615c88cdee68cd15$export$f5b8910cec6cf069);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $b1kcy = parcelRequire("b1kcy");
class $615c88cdee68cd15$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    /**
	 * Overrides the default behaviour of react-select lib
	 *
	 * The getter is a workaround for original behaviour of the react-select lib.
	 * Placeholder and Input are linked not via label, aria-label or aria-labeledby, but through aria-describedby.
	 * Basically in the getter we reassign Placeholder ID from aria-describedby to aria-labelledby
	 * {@link https://github.com/JedWatson/react-select/issues/5651#issue-1731353197 GitHub}
	 */ get ariaLabelledBy() {
        return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress
        });
    }
    constructor(...args){
        super(...args), // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        this.handleKeyPress = (e)=>{
            if (e.key === 'Enter') e.preventDefault();
            //@ts-ignore react-select unsupported props
            if (this.props.selectProps?.disableInput) e.preventDefault();
        };
    }
}

});

parcelRegister("fAFbI", function(module, exports) {

$parcel$export(module.exports, "SingleValueContainer", () => $34d702fe6d808611$export$afa5f855316c6a48);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $b1kcy = parcelRequire("b1kcy");

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $9tC62 = parcelRequire("9tC62");

var $lor1T = parcelRequire("lor1T");

var $h34oI = parcelRequire("h34oI");
function $34d702fe6d808611$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $34d702fe6d808611$var$placeholderIconContainer = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingLeft: (0, $lor1T.BORDER_PADDING),
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    gridArea: '1/1/2/2'
});
const $34d702fe6d808611$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
var $34d702fe6d808611$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
class $34d702fe6d808611$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $h34oI.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $b1kcy.components).ValueContainer, valueContainerProps, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $34d702fe6d808611$var$placeholderIconContainer
        }, this.renderAvatar()), children));
    }
    constructor(...args){
        super(...args), this.renderAvatar = ()=>{
            const { hasValue: hasValue, //@ts-ignore react-select unsupported props
            selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9tC62.SizeableAvatar), {
                appearance: appearance,
                type: placeholderAvatar,
                src: $34d702fe6d808611$var$showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
            });
            return null;
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick, this.Wrapper = ({ children: children })=>{
            return this.onValueContainerClick ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                css: $34d702fe6d808611$var$_ref,
                onMouseDown: this.onValueContainerClick
            }, children) : children;
        };
    }
}

});

parcelRegister("aK2hz", function(module, exports) {

$parcel$export(module.exports, "PopupInput", () => $ffb63a5983a8f220$export$d8edbfd510a7db82);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jUKmL = parcelRequire("jUKmL");
class $ffb63a5983a8f220$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jUKmL.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args), this.ref = null, this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}

});

parcelRegister("4grkH", function(module, exports) {

$parcel$export(module.exports, "PopupControl", () => $d2f2a3eee86fa9b3$export$a0cb1b4352357fcc);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $b1kcy = parcelRequire("b1kcy");

var $f8Sb3 = parcelRequire("f8Sb3");

const $d2f2a3eee86fa9b3$var$controlWrapper = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $d2f2a3eee86fa9b3$var$labelStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    paddingBottom: "var(--ds-space-050, 4px)",
    paddingLeft: "var(--ds-space-0, 0px)",
    paddingRight: "var(--ds-space-0, 0px)",
    paddingTop: "var(--ds-space-250, 20px)"
});
class $d2f2a3eee86fa9b3$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $d2f2a3eee86fa9b3$var$controlWrapper
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $d2f2a3eee86fa9b3$var$labelStyle
        }, popupTitle), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $b1kcy.components).Control, this.props));
    }
}

});

parcelRegister("6tZmh", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $7272f57eddeb7040$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $b1kcy = parcelRequire("b1kcy");

var $f8Sb3 = parcelRequire("f8Sb3");
const $7272f57eddeb7040$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $7272f57eddeb7040$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $b1kcy.components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $7272f57eddeb7040$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}

});


parcelRegister("5kiFd", function(module, exports) {

$parcel$export(module.exports, "getCreatableProps", () => $234e99affad67fe2$export$36f97d8afa97203d);

var $8QpSo = parcelRequire("8QpSo");


var $104WL = parcelRequire("104WL");

var $grXIr = parcelRequire("grXIr");
const $234e99affad67fe2$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $234e99affad67fe2$var$isValidNewOption = (isValidEmail = (0, $104WL.isValidEmail))=>(inputValue)=>inputValue && $234e99affad67fe2$var$validOption.includes(isValidEmail(inputValue));
const $234e99affad67fe2$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $ffa6e54f1b79ab69$export$6662b3461398ef8c)
        }
    });
const $234e99affad67fe2$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $234e99affad67fe2$var$isOptionDisabled = (isValidEmail = (0, $104WL.isValidEmail))=>(option)=>{
        if ((0, $grXIr.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $234e99affad67fe2$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $234e99affad67fe2$var$isValidNewOption(isValidEmail),
        getNewOptionData: $234e99affad67fe2$var$getNewOptionData,
        formatCreateLabel: $234e99affad67fe2$var$formatCreateLabel,
        isOptionDisabled: $234e99affad67fe2$var$isOptionDisabled(isValidEmail)
    };
}
const $234e99affad67fe2$export$36f97d8afa97203d = (0, $8QpSo.default)($234e99affad67fe2$var$creatableProps);

});

parcelRegister("gqIZX", function(module, exports) {

$parcel$export(module.exports, "getCreatableSuggestedEmailProps", () => $a192baba05155357$export$34b9dd2dd6a225e5);

var $8QpSo = parcelRequire("8QpSo");


var $104WL = parcelRequire("104WL");

var $grXIr = parcelRequire("grXIr");
const $a192baba05155357$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $a192baba05155357$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $a192baba05155357$var$getNewOptionData = (isValidEmail = (0, $104WL.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $a192baba05155357$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $ffa6e54f1b79ab69$export$6662b3461398ef8c),
                suggestion: true
            }
        };
    };
const $a192baba05155357$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $a192baba05155357$var$isOptionDisabled = (isValidEmail = (0, $104WL.isValidEmail))=>(option)=>{
        if ((0, $grXIr.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $a192baba05155357$export$34b9dd2dd6a225e5 = (0, $8QpSo.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $a192baba05155357$var$isValidNewOption,
        getNewOptionData: $a192baba05155357$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $a192baba05155357$var$formatCreateLabel,
        isOptionDisabled: $a192baba05155357$var$isOptionDisabled(isValidEmail)
    }));

});

parcelRegister("l30aB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f47fc17bfe16330e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $aaKGj = parcelRequire("aaKGj");
const $f47fc17bfe16330e$var$EMPTY = {};
const $f47fc17bfe16330e$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState($f47fc17bfe16330e$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        let aborted = false;
        setMessages($f47fc17bfe16330e$var$EMPTY);
        (0, $aaKGj.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $f47fc17bfe16330e$var$MessagesIntlProvider = (props)=>{
    const intl = (0, $koVbs.default)();
    const { children: children } = props;
    const messages = $f47fc17bfe16330e$var$useI18n(intl.locale);
    const mergedMessages = (0, $5uXOq.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
var $f47fc17bfe16330e$export$2e2bcd8739ae039 = $f47fc17bfe16330e$var$MessagesIntlProvider;

});
parcelRegister("aaKGj", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $de09ea5c7692d192$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $de09ea5c7692d192$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("6AQOU")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("eUiCu")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("2NCg1")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("49YmD")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("cGSEg")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("eFhXH")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("8D5o7")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("1lVVO")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("flXH0")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("btj7K")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("kTZKK")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("3pSlv")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("51GbE")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("1ccrr")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("7DMvA")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("3pcGH")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("g5n49")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("ke65r")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("bLkBA")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("huLPG")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("3Lkhu")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("daq5Q")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("88rUw")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("gT7Js")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("g0Now")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("b8vRV")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("3Hjct")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("6KDhu")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("fxDDv")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("l5iCB")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $de09ea5c7692d192$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("49YmD")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("6AQOU", function(module, exports) {

let $4ccf13d6cd18bf96$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4ccf13d6cd18bf96$var$load("g5Cqr").then(()=>parcelRequire('bOZZh'));

});

parcelRegister("eUiCu", function(module, exports) {

let $ada4bd2a8dbcf542$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ada4bd2a8dbcf542$var$load("3nPyl").then(()=>parcelRequire('1XhGw'));

});

parcelRegister("2NCg1", function(module, exports) {

let $209dd580dc4672d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $209dd580dc4672d5$var$load("jzKXZ").then(()=>parcelRequire('hvRes'));

});

parcelRegister("49YmD", function(module, exports) {

let $3076d3b9a57003e4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3076d3b9a57003e4$var$load("6qBuq").then(()=>parcelRequire('5v8Tc'));

});

parcelRegister("cGSEg", function(module, exports) {

let $93d3cc52160351f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $93d3cc52160351f5$var$load("bghJB").then(()=>parcelRequire('iOrq6'));

});

parcelRegister("eFhXH", function(module, exports) {

let $aad2d3df09c04dcd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aad2d3df09c04dcd$var$load("cVHxt").then(()=>parcelRequire('4J30H'));

});

parcelRegister("8D5o7", function(module, exports) {

let $648625314e90ad42$var$load = (parcelRequire("28QjX"))(4);
module.exports = $648625314e90ad42$var$load("aD0sx").then(()=>parcelRequire('fB17y'));

});

parcelRegister("1lVVO", function(module, exports) {

let $0fc4b09c86c598be$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0fc4b09c86c598be$var$load("1HNA9").then(()=>parcelRequire('akYEc'));

});

parcelRegister("flXH0", function(module, exports) {

let $b2d71ee1f142e642$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b2d71ee1f142e642$var$load("15G7H").then(()=>parcelRequire('81pCG'));

});

parcelRegister("btj7K", function(module, exports) {

let $85a13cbd58375cfb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $85a13cbd58375cfb$var$load("6k2ZI").then(()=>parcelRequire('fECc8'));

});

parcelRegister("kTZKK", function(module, exports) {

let $f378d895efe76ed2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f378d895efe76ed2$var$load("hwB1b").then(()=>parcelRequire('d88YX'));

});

parcelRegister("3pSlv", function(module, exports) {

let $27cddcd88332d06f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $27cddcd88332d06f$var$load("lO82O").then(()=>parcelRequire('lOXhp'));

});

parcelRegister("51GbE", function(module, exports) {

let $3a8dc52dcb6171be$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3a8dc52dcb6171be$var$load("2kasq").then(()=>parcelRequire('w9M1e'));

});

parcelRegister("1ccrr", function(module, exports) {

let $0df0900e3c1d7535$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0df0900e3c1d7535$var$load("7Q86P").then(()=>parcelRequire('1Aw1f'));

});

parcelRegister("7DMvA", function(module, exports) {

let $5901cdb744a5fb8f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5901cdb744a5fb8f$var$load("bsLaU").then(()=>parcelRequire('6OvxG'));

});

parcelRegister("3pcGH", function(module, exports) {

let $27ad8c64a09eb1b6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $27ad8c64a09eb1b6$var$load("iTamo").then(()=>parcelRequire('6bd5D'));

});

parcelRegister("g5n49", function(module, exports) {

let $bb5f0160afe6072a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bb5f0160afe6072a$var$load("4A2F7").then(()=>parcelRequire('85aXb'));

});

parcelRegister("ke65r", function(module, exports) {

let $eb99d62511d6b6c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eb99d62511d6b6c0$var$load("koIFB").then(()=>parcelRequire('2LXP4'));

});

parcelRegister("bLkBA", function(module, exports) {

let $890411499316919e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $890411499316919e$var$load("kft0l").then(()=>parcelRequire('6LTAU'));

});

parcelRegister("huLPG", function(module, exports) {

let $cbca57981e34ac83$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cbca57981e34ac83$var$load("jmn8B").then(()=>parcelRequire('jrhuf'));

});

parcelRegister("3Lkhu", function(module, exports) {

let $2bd57e49a0f4c3a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2bd57e49a0f4c3a1$var$load("7gIwy").then(()=>parcelRequire('gZXKe'));

});

parcelRegister("daq5Q", function(module, exports) {

let $9960731a5a8c162f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9960731a5a8c162f$var$load("iMbmg").then(()=>parcelRequire('hNdNI'));

});

parcelRegister("88rUw", function(module, exports) {

let $5ec4b89236647103$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5ec4b89236647103$var$load("fva9M").then(()=>parcelRequire('honk4'));

});

parcelRegister("gT7Js", function(module, exports) {

let $c4b7c7d965a08e49$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c4b7c7d965a08e49$var$load("1YAwp").then(()=>parcelRequire('3ZrPs'));

});

parcelRegister("g0Now", function(module, exports) {

let $ba82f6294e5ffe77$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ba82f6294e5ffe77$var$load("g3Naz").then(()=>parcelRequire('5fZdl'));

});

parcelRegister("b8vRV", function(module, exports) {

let $81b9298ea947624d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $81b9298ea947624d$var$load("igYET").then(()=>parcelRequire('k6ghn'));

});

parcelRegister("3Hjct", function(module, exports) {

let $2b144801333164fb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2b144801333164fb$var$load("80bvY").then(()=>parcelRequire('iq7kq'));

});

parcelRegister("6KDhu", function(module, exports) {

let $4ea5825eabe1707f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4ea5825eabe1707f$var$load("jwQtv").then(()=>parcelRequire('bW6Sb'));

});

parcelRegister("fxDDv", function(module, exports) {

let $b508af079c5cd080$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b508af079c5cd080$var$load("4APEf").then(()=>parcelRequire('i1po0'));

});

parcelRegister("l5iCB", function(module, exports) {

let $f59882729b9ff5f3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f59882729b9ff5f3$var$load("ggFhf").then(()=>parcelRequire('9kjay'));

});



parcelRegister("b3Vox", function(module, exports) {

$parcel$export(module.exports, "ExusUserSourceProvider", () => $331e080864f7862a$export$bcd5c65b586ee3c3);
$parcel$export(module.exports, "useUserSource", () => $331e080864f7862a$export$c6c0c1a2bac363f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $331e080864f7862a$var$ExusUserSourceContext = /*#__PURE__*/ (0, $5uXOq.createContext)({});
const $331e080864f7862a$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)($331e080864f7862a$var$ExusUserSourceContext.Provider, {
        value: {
            fetchUserSource: fetchUserSource
        },
        children: children
    });
const $331e080864f7862a$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
    const { fetchUserSource: fetchUserSource } = (0, $5uXOq.useContext)($331e080864f7862a$var$ExusUserSourceContext);
    const [externalSources, setExternalSources] = (0, $5uXOq.useState)([]);
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const abortController = (0, $5uXOq.useMemo)(()=>{
        if (typeof AbortController === 'undefined') return;
        return new AbortController();
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        let isMounted = true;
        const cleanup = ()=>{
            abortController?.abort();
            isMounted = false;
        };
        if (!fetchUserSource || !shouldFetchSources) {
            setLoading(false);
            return cleanup;
        }
        fetchUserSource(accountId, abortController?.signal).then((externalSources)=>{
            if (!isMounted) return;
            setLoading(false);
            const externalSourceTypes = externalSources.map((source)=>source.sourceType);
            setExternalSources(externalSourceTypes);
        }).catch((error)=>{
            if (!isMounted) return;
            setLoading(false);
            setError(error);
        });
        return cleanup;
    }, [
        fetchUserSource,
        accountId,
        abortController,
        shouldFetchSources
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            sources: Array.from(new Set([
                ...existingSources ?? [],
                ...externalSources
            ])),
            loading: loading,
            error: error
        }), [
        error,
        existingSources,
        externalSources,
        loading
    ]);
};

});


parcelRegister("3rwqT", function(module, exports) {

$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $a1cc1d041e49f606$export$53eef0dcd9611650);
$parcel$export(module.exports, "preparedUsersLoadedEvent", () => $a1cc1d041e49f606$export$185f4c3d9b7ef9bf);
$parcel$export(module.exports, "mountedWithPrefetchEvent", () => $a1cc1d041e49f606$export$9cfb4251e50d7b91);
$parcel$export(module.exports, "filterUsersEvent", () => $a1cc1d041e49f606$export$fbba77127d7cb173);
$parcel$export(module.exports, "requestUsersEvent", () => $a1cc1d041e49f606$export$1762ed8845ff2d9b);
$parcel$export(module.exports, "successfulRequestUsersEvent", () => $a1cc1d041e49f606$export$bfc020018aa738d0);
$parcel$export(module.exports, "failedRequestUsersEvent", () => $a1cc1d041e49f606$export$738aca68b593db8e);

var $9Iej8 = parcelRequire("9Iej8");

var $7Jxgt = parcelRequire("7Jxgt");
const $a1cc1d041e49f606$var$packageName = "platform-pkg";
const $a1cc1d041e49f606$var$packageVersion = "0.0.0-use.local";
const $a1cc1d041e49f606$export$c0d84948cecf78d8 = ()=>({
        id: (0, $7Jxgt.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $a1cc1d041e49f606$export$53eef0dcd9611650 = (0, $9Iej8.default)('fabric-elements');
const $a1cc1d041e49f606$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $a1cc1d041e49f606$var$packageName,
            packageVersion: $a1cc1d041e49f606$var$packageVersion,
            ...attributes
        }
    });
const $a1cc1d041e49f606$var$createDefaultSmartPickerAttributes = (props, state)=>{
    const { fieldId: fieldId, objectId: objectId, containerId: containerId, childObjectId: childObjectId, prefetch: prefetch, maxOptions: maxOptions, includeTeams: includeTeams, productKey: productKey, principalId: principalId, siteId: siteId, orgId: orgId, filterOptions: filterOptions } = props;
    const { sessionId: sessionId, query: query } = state;
    const maxNumberOfResults = maxOptions || 100;
    return {
        context: fieldId,
        childObjectId: childObjectId,
        containerId: containerId,
        hasFilterOptions: Boolean(filterOptions),
        includeTeams: includeTeams,
        maxNumberOfResults: maxNumberOfResults,
        objectId: objectId,
        prefetch: prefetch,
        principalId: principalId,
        productKey: productKey,
        queryLength: (query || '').length,
        siteId: siteId,
        orgId: orgId,
        sessionId: sessionId
    };
};
const $a1cc1d041e49f606$var$createSmartUserPickerEvent = (action, actionSubect, attributes = {})=>({
        source: 'smart-user-picker',
        ...$a1cc1d041e49f606$var$createEvent('operational', action, actionSubect, attributes)
    });
const $a1cc1d041e49f606$export$185f4c3d9b7ef9bf = (props, state, attributes = {})=>$a1cc1d041e49f606$var$createSmartUserPickerEvent('loaded', 'preparedUsers', {
        ...$a1cc1d041e49f606$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $a1cc1d041e49f606$export$9cfb4251e50d7b91 = (props, state, attributes = {})=>$a1cc1d041e49f606$var$createSmartUserPickerEvent('mounted', 'prefetch', {
        ...$a1cc1d041e49f606$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $a1cc1d041e49f606$export$fbba77127d7cb173 = (props, state, attributes = {})=>$a1cc1d041e49f606$var$createSmartUserPickerEvent('filtered', 'users', {
        ...$a1cc1d041e49f606$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $a1cc1d041e49f606$export$1762ed8845ff2d9b = (props, state, attributes = {})=>$a1cc1d041e49f606$var$createSmartUserPickerEvent('requested', 'users', {
        ...$a1cc1d041e49f606$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $a1cc1d041e49f606$export$bfc020018aa738d0 = (props, state, attributes = {})=>$a1cc1d041e49f606$var$createSmartUserPickerEvent('successful', 'usersRequest', {
        ...$a1cc1d041e49f606$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $a1cc1d041e49f606$export$738aca68b593db8e = (props, state, attributes = {})=>$a1cc1d041e49f606$var$createSmartUserPickerEvent('failed', 'usersRequest', {
        ...$a1cc1d041e49f606$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });

});

parcelRegister("4UD2C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a45f95388b2f902c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $fi5NZ = parcelRequire("fi5NZ");
const $a45f95388b2f902c$var$EMPTY = {};
const $a45f95388b2f902c$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState($a45f95388b2f902c$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        let aborted = false;
        setMessages($a45f95388b2f902c$var$EMPTY);
        (0, $fi5NZ.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $a45f95388b2f902c$var$MessagesIntlProvider = (props)=>{
    const { intl: intl, children: children } = props;
    const messages = $a45f95388b2f902c$var$useI18n(intl.locale);
    const mergedMessages = (0, $5uXOq.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
var $a45f95388b2f902c$export$2e2bcd8739ae039 = (0, $8RXs9.default)($a45f95388b2f902c$var$MessagesIntlProvider);

});
parcelRegister("fi5NZ", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $2d193ad6a1ede9ab$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 





























const $2d193ad6a1ede9ab$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("coyVf")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("5nmH7")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("aWOPC")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("eu2dW")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("8AYAA")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("indu3")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("bR4Qj")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("8viML")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("2MBlo")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("bFXlr")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("hpl59")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("168SD")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("jUvlv")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("IjUCS")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("6OOEn")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("9A2fN")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("h6RfB")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("6mZC9")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("kID20")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("aonRT")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("7NS2I")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("e2Xma")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("gvPdN")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("b8Jlh")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("bTOkf")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("4V4R1")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("hliOz")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("e1sjx")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("9tOrE")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $2d193ad6a1ede9ab$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("eu2dW")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("coyVf", function(module, exports) {

let $9062d0cc1a2c9e7c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9062d0cc1a2c9e7c$var$load("5cjJv").then(()=>parcelRequire('75ZZM'));

});

parcelRegister("5nmH7", function(module, exports) {

let $3ea0b4626cfe54ae$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3ea0b4626cfe54ae$var$load("litJ8").then(()=>parcelRequire('gGAsm'));

});

parcelRegister("aWOPC", function(module, exports) {

let $7f86c03ebd66246a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7f86c03ebd66246a$var$load("ab2o0").then(()=>parcelRequire('cCw0u'));

});

parcelRegister("eu2dW", function(module, exports) {

let $a8b597a1932f2670$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a8b597a1932f2670$var$load("f4z1K").then(()=>parcelRequire('4oHVd'));

});

parcelRegister("8AYAA", function(module, exports) {

let $6420af4334263f6f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6420af4334263f6f$var$load("fnck0").then(()=>parcelRequire('8pCz0'));

});

parcelRegister("indu3", function(module, exports) {

let $d604d5915f27fd60$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d604d5915f27fd60$var$load("dbXQZ").then(()=>parcelRequire('j09Jl'));

});

parcelRegister("bR4Qj", function(module, exports) {

let $8a1866a3ce8fd0b7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8a1866a3ce8fd0b7$var$load("gx9QH").then(()=>parcelRequire('aBYiX'));

});

parcelRegister("8viML", function(module, exports) {

let $630fca68a2512e37$var$load = (parcelRequire("28QjX"))(4);
module.exports = $630fca68a2512e37$var$load("giive").then(()=>parcelRequire('kLWsA'));

});

parcelRegister("2MBlo", function(module, exports) {

let $206d083a581eac14$var$load = (parcelRequire("28QjX"))(4);
module.exports = $206d083a581eac14$var$load("bjkD0").then(()=>parcelRequire('bVK4x'));

});

parcelRegister("bFXlr", function(module, exports) {

let $88018eae0d9f28e4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $88018eae0d9f28e4$var$load("59sjH").then(()=>parcelRequire('le0cr'));

});

parcelRegister("hpl59", function(module, exports) {

let $cac51fea90b46418$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cac51fea90b46418$var$load("4n0mT").then(()=>parcelRequire('jxQ2s'));

});

parcelRegister("168SD", function(module, exports) {

let $0ccd3d64e65020df$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0ccd3d64e65020df$var$load("3DpJm").then(()=>parcelRequire('6aD0e'));

});

parcelRegister("jUvlv", function(module, exports) {

let $e7eb8fe72b88cc3a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e7eb8fe72b88cc3a$var$load("k8R1k").then(()=>parcelRequire('hYUU3'));

});

parcelRegister("IjUCS", function(module, exports) {

let $08538e59135d4a6d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $08538e59135d4a6d$var$load("89JNM").then(()=>parcelRequire('bYd6G'));

});

parcelRegister("6OOEn", function(module, exports) {

let $4f6eb3abc1477281$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4f6eb3abc1477281$var$load("1wnwY").then(()=>parcelRequire('dESiv'));

});

parcelRegister("9A2fN", function(module, exports) {

let $6f993966ed5d1faf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6f993966ed5d1faf$var$load("8QfF6").then(()=>parcelRequire('hFZIA'));

});

parcelRegister("h6RfB", function(module, exports) {

let $c74c4daaa4492b9e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c74c4daaa4492b9e$var$load("ivb0y").then(()=>parcelRequire('hYmku'));

});

parcelRegister("6mZC9", function(module, exports) {

let $4a349775d0f1f2ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4a349775d0f1f2ec$var$load("gQlEQ").then(()=>parcelRequire('bDUhR'));

});

parcelRegister("kID20", function(module, exports) {

let $f156318b14600618$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f156318b14600618$var$load("4KiGJ").then(()=>parcelRequire('dQIqs'));

});

parcelRegister("aonRT", function(module, exports) {

let $790ea9062a8d7387$var$load = (parcelRequire("28QjX"))(4);
module.exports = $790ea9062a8d7387$var$load("h1r9e").then(()=>parcelRequire('Y3Lzf'));

});

parcelRegister("7NS2I", function(module, exports) {

let $5ae707c5e26bca0f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5ae707c5e26bca0f$var$load("hWSI7").then(()=>parcelRequire('k8jhS'));

});

parcelRegister("e2Xma", function(module, exports) {

let $a39f4b92bb8971ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a39f4b92bb8971ca$var$load("8gUF8").then(()=>parcelRequire('iQ7Zi'));

});

parcelRegister("gvPdN", function(module, exports) {

let $c057461e2f7ce3a5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c057461e2f7ce3a5$var$load("dhpyr").then(()=>parcelRequire('9LBJH'));

});

parcelRegister("b8Jlh", function(module, exports) {

let $81c39d16d78afc8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $81c39d16d78afc8b$var$load("yyYVH").then(()=>parcelRequire('Xr4ik'));

});

parcelRegister("bTOkf", function(module, exports) {

let $8a9bde59e58e1666$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8a9bde59e58e1666$var$load("lSZlr").then(()=>parcelRequire('dBQPe'));

});

parcelRegister("4V4R1", function(module, exports) {

let $3950403ac5ffdfa9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3950403ac5ffdfa9$var$load("bZ2zV").then(()=>parcelRequire('4kw1b'));

});

parcelRegister("hliOz", function(module, exports) {

let $ca02fe07aa9090d2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ca02fe07aa9090d2$var$load("3mVzU").then(()=>parcelRequire('3iFPR'));

});

parcelRegister("e1sjx", function(module, exports) {

let $a3571f489fd5ddab$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a3571f489fd5ddab$var$load("1R71m").then(()=>parcelRequire('2S3hF'));

});

parcelRegister("9tOrE", function(module, exports) {

let $6e6df3c9b9945f38$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6e6df3c9b9945f38$var$load("1AKjA").then(()=>parcelRequire('8BA4O'));

});



parcelRegister("lWjud", function(module, exports) {

$parcel$export(module.exports, "default", () => $20d0aaf0c1746fc7$export$2e2bcd8739ae039);

var $drE1p = parcelRequire("drE1p");

var $6qnFX = parcelRequire("6qnFX");
const $20d0aaf0c1746fc7$var$getUserRecommendations = (request, intl)=>{
    const url = (0, $6qnFX.config).getRecommendationServiceUrl(request.baseUrl || '');
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            includeNonLicensedUsers: request.includeNonLicensedUsers,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                ...request.context?.productAttributes?.isEntitledConfluenceExternalCollaborator && {
                    productAccessPermissionIds: [
                        'write',
                        'external-collaborator-write'
                    ]
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`,
            statusCode: response.status
        });
    }).then((response)=>(0, $drE1p.transformUsers)(response, intl));
};
var $20d0aaf0c1746fc7$export$2e2bcd8739ae039 = $20d0aaf0c1746fc7$var$getUserRecommendations;

});
parcelRegister("drE1p", function(module, exports) {

$parcel$export(module.exports, "transformUsers", () => $58aefbb7d0e8cc6f$export$fb8c90bfc4beaa59);


var $L0Doe = parcelRequire("L0Doe");

var $bvI0A = parcelRequire("bvI0A");
const $58aefbb7d0e8cc6f$var$getLozenzeProperties = (entity, intl)=>{
    if (entity.attributes?.workspaceMember) return intl.formatMessage((0, $L0Doe.messages).memberLozengeText);
    if (entity.attributes?.isConfluenceExternalCollaborator) {
        const lozengeTooltipMessage = entity.entityType === (0, $bvI0A.EntityType).GROUP ? (0, $L0Doe.messages).guestGroupLozengeTooltip : (0, $L0Doe.messages).guestUserLozengeTooltip;
        return {
            text: intl.formatMessage((0, $L0Doe.messages).guestLozengeText),
            tooltip: intl.formatMessage(lozengeTooltipMessage),
            appearance: 'default'
        };
    }
    return undefined;
};
const $58aefbb7d0e8cc6f$var$transformUser = (item, intl)=>{
    const type = item.entityType;
    if (type === (0, $bvI0A.EntityType).USER) {
        const user = item;
        const lozenge = $58aefbb7d0e8cc6f$var$getLozenzeProperties(user, intl);
        return {
            id: user.id,
            type: user.nonLicensedUser ? (0, $ffa6e54f1b79ab69$export$50042ec1d2e00e63) : (0, $ffa6e54f1b79ab69$export$8436e53e45ffe15b),
            avatarUrl: user.avatarUrl,
            name: user.name,
            email: user.email,
            title: user.title,
            lozenge: lozenge,
            tooltip: user.name,
            isExternal: Boolean(user.nonLicensedUser),
            sources: user.nonLicensedUser ? [
                'other-atlassian'
            ] : undefined
        };
    }
    if (type === (0, $bvI0A.EntityType).TEAM) {
        const team = item;
        return {
            id: team.id,
            type: (0, $ffa6e54f1b79ab69$export$26bc40b960693765),
            description: team.description || '',
            name: team.displayName || '',
            memberCount: team.memberCount,
            members: team.members,
            includesYou: team.includesYou,
            avatarUrl: team.largeAvatarImageUrl || team.smallAvatarImageUrl,
            tooltip: team.displayName,
            verified: team.verified
        };
    }
    if (type === (0, $bvI0A.EntityType).GROUP) {
        const group = item;
        const lozenge = $58aefbb7d0e8cc6f$var$getLozenzeProperties(group, intl);
        return {
            id: group.id,
            type: (0, $ffa6e54f1b79ab69$export$d460f747b73abb10),
            name: group.name || '',
            lozenge: lozenge
        };
    }
    return;
};
const $58aefbb7d0e8cc6f$export$fb8c90bfc4beaa59 = (serverResponse, intl)=>(serverResponse.recommendedUsers || []).map((item)=>$58aefbb7d0e8cc6f$var$transformUser(item, intl)).filter((user)=>!!user).map((user)=>user);

});
parcelRegister("L0Doe", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7d3fca4cb156c5e7$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7d3fca4cb156c5e7$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    }
});

});

parcelRegister("bvI0A", function(module, exports) {

$parcel$export(module.exports, "EntityType", () => $d8da202e60b431f1$export$8eda7e02f8f033b2);
var $d8da202e60b431f1$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});

});


parcelRegister("6qnFX", function(module, exports) {

$parcel$export(module.exports, "config", () => $9a6dfddf0d4f7421$export$e506a1d27d1eaa20);
const $9a6dfddf0d4f7421$export$e506a1d27d1eaa20 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey, baseUrl = '') {
        return productKey === 'jira' ? `${baseUrl}/rest/api/3/user/bulk` : `${baseUrl}/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
    }
};

});


parcelRegister("efnVP", function(module, exports) {

$parcel$export(module.exports, "default", () => $398574e8a650bb3f$export$2e2bcd8739ae039);


var $6qnFX = parcelRequire("6qnFX");

var $1GDrf = parcelRequire("1GDrf");

var $838FA = parcelRequire("838FA");

var $30pqE = parcelRequire("30pqE");
const $398574e8a650bb3f$var$getHydratedUsersFromProducts = (request)=>{
    const url = `${(0, $6qnFX.config).getUsersServiceUrl(request.productKey, request.baseUrl)}`;
    let params = new URLSearchParams();
    request.accountIds.map((id)=>params.append('accountId', id));
    params.append('maxResults', '2000');
    return fetch(`${url}?${params}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling users service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then(request.productKey === 'jira' ? $398574e8a650bb3f$var$transformJiraUsers : $398574e8a650bb3f$var$transformConfluenceUsers);
};
const $398574e8a650bb3f$var$transformJiraUsers = (userResponse)=>userResponse.values.map($398574e8a650bb3f$var$transformJiraUser).filter((user)=>!!user).map((user)=>user);
const $398574e8a650bb3f$var$transformJiraUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $ffa6e54f1b79ab69$export$8436e53e45ffe15b),
        avatarUrl: item.avatarUrls ? item.avatarUrls['16x16'] : '',
        name: item.displayName,
        email: item.emailAddress
    };
};
const $398574e8a650bb3f$var$transformConfluenceUsers = (userResponse)=>userResponse.results.map($398574e8a650bb3f$var$transformConfluenceUser).filter((user)=>!!user).map((user)=>user);
const $398574e8a650bb3f$var$transformConfluenceUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $ffa6e54f1b79ab69$export$8436e53e45ffe15b),
        avatarUrl: item.profilePicture ? item.profilePicture.path : '',
        name: item.publicName,
        email: item.email
    };
};
const $398574e8a650bb3f$var$sortResults = (options, sortIds)=>{
    const resultsMap = new Map(options.map((option)=>[
            option && option.id,
            option
        ]));
    return sortIds.map((option)=>{
        const user = resultsMap.get(option.id);
        if (user) return user;
        return {
            id: option.id,
            type: option.type,
            name: (0, $30pqE.UNKNOWN)
        };
    });
};
const $398574e8a650bb3f$var$isOptionData = (option)=>{
    return option.name !== undefined;
};
const $398574e8a650bb3f$var$hydrateTeamIds = async (baseUrl, values)=>{
    if (values.length === 0) return [];
    const legionPromises = values.map((value)=>(0, $838FA.default)({
            baseUrl: baseUrl,
            id: value.id
        }));
    return await Promise.all(legionPromises);
};
const $398574e8a650bb3f$var$hydrateAccountIds = async (baseUrl, productKey, values)=>{
    if (values.length === 0) return [];
    const accountIds = values.map((val)=>val.id);
    //if we are not jira or confluence then use PRS platform hydration
    return productKey === 'jira' || productKey === 'confluence' ? await $398574e8a650bb3f$var$getHydratedUsersFromProducts({
        baseUrl: baseUrl,
        productKey: productKey,
        accountIds: accountIds
    }) : await (0, $1GDrf.default)(baseUrl, accountIds);
};
async function $398574e8a650bb3f$var$hydrateDefaultValues(baseUrl, value, productKey) {
    //return if no value
    if (!value || Array.isArray(value) && value.length === 0) return [];
    const values = Array.isArray(value) ? value : [
        value
    ];
    // return if all hydrated
    if (!values.some((val)=>!$398574e8a650bb3f$var$isOptionData(val))) return value;
    const [hydratedUsers, hydratedTeams] = await Promise.all([
        $398574e8a650bb3f$var$hydrateAccountIds(baseUrl, productKey, values.filter((val)=>!$398574e8a650bb3f$var$isOptionData(val) && val.type === 'user')),
        $398574e8a650bb3f$var$hydrateTeamIds(baseUrl, values.filter((val)=>!$398574e8a650bb3f$var$isOptionData(val) && val.type === 'team'))
    ]);
    const hydratedOptions = values.filter((val)=>$398574e8a650bb3f$var$isOptionData(val)).map((val)=>val).concat(hydratedUsers).concat(hydratedTeams);
    return $398574e8a650bb3f$var$sortResults(hydratedOptions, values);
}
var $398574e8a650bb3f$export$2e2bcd8739ae039 = $398574e8a650bb3f$var$hydrateDefaultValues;

});
parcelRegister("1GDrf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e96f44ad0eb11a4$export$2e2bcd8739ae039);

var $30pqE = parcelRequire("30pqE");

var $bMcW3 = parcelRequire("bMcW3");

var $6qnFX = parcelRequire("6qnFX");
/**
 * @param  {string} accountIds ids to hydrate
 * @return GraphQL Query
 */ const $1e96f44ad0eb11a4$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
      picture
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $1e96f44ad0eb11a4$var$makeRequest = async (url, accountIds)=>{
    const query = $1e96f44ad0eb11a4$var$buildUsersQuery(accountIds);
    return await (0, $bMcW3.graphqlQuery)(url, query);
};
const $1e96f44ad0eb11a4$var$modifyResponse = (users)=>users.map(({ accountId: accountId, name: name, picture: picture })=>({
            avatarUrl: picture,
            id: accountId,
            name: name,
            type: 'user'
        }));
const $1e96f44ad0eb11a4$var$getHydratedUsers = (baseUrl, userIds)=>{
    const url = (0, $6qnFX.config).getGraphQLUrl(baseUrl);
    return new Promise((resolve)=>{
        $1e96f44ad0eb11a4$var$makeRequest(url, userIds).then((data)=>{
            resolve($1e96f44ad0eb11a4$var$modifyResponse(data.users));
        }).catch(()=>{
            // on network error, return original list with label 'Unknown'
            resolve(userIds.map((id)=>({
                    ...(0, $30pqE.UNKNOWN_USER),
                    id: id
                })));
        });
    });
};
var $1e96f44ad0eb11a4$export$2e2bcd8739ae039 = $1e96f44ad0eb11a4$var$getHydratedUsers;

});
parcelRegister("30pqE", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN", () => $8962705b5a37fd08$export$78244dbb77cfa6b6);
$parcel$export(module.exports, "UNKNOWN_USER", () => $8962705b5a37fd08$export$d1f5101c0939e3fe);
$parcel$export(module.exports, "UNKNOWN_TEAM", () => $8962705b5a37fd08$export$8144dcfc9025ca57);
const $8962705b5a37fd08$export$78244dbb77cfa6b6 = 'Unknown';
const $8962705b5a37fd08$export$d1f5101c0939e3fe = {
    id: $8962705b5a37fd08$export$78244dbb77cfa6b6,
    name: $8962705b5a37fd08$export$78244dbb77cfa6b6,
    type: 'user'
};
const $8962705b5a37fd08$export$8144dcfc9025ca57 = {
    id: $8962705b5a37fd08$export$78244dbb77cfa6b6,
    name: $8962705b5a37fd08$export$78244dbb77cfa6b6,
    type: 'team'
};

});

parcelRegister("bMcW3", function(module, exports) {

$parcel$export(module.exports, "graphqlQuery", () => $48ee466895e2f537$export$74eb8d79ae3e02b5);
const $48ee466895e2f537$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
function $48ee466895e2f537$export$74eb8d79ae3e02b5(serviceUrl, query) {
    const headers = $48ee466895e2f537$var$buildHeaders();
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}

});


parcelRegister("838FA", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ced8cfc5f5e0063$export$2e2bcd8739ae039);

var $6qnFX = parcelRequire("6qnFX");

var $30pqE = parcelRequire("30pqE");
const $8ced8cfc5f5e0063$var$transformTeam = (team, id)=>{
    return {
        id: id,
        name: team.displayName,
        type: 'team',
        avatarUrl: team.smallAvatarImageUrl
    };
};
const $8ced8cfc5f5e0063$var$hydrateTeamFromLegion = (request)=>{
    const url = `${(0, $6qnFX.config).getTeamsUrl(request.baseUrl)}/${request.id}`;
    return fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling Legion, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>{
        return $8ced8cfc5f5e0063$var$transformTeam(response, request.id);
    }).catch(()=>({
            ...(0, $30pqE.UNKNOWN_TEAM),
            id: request.id
        }));
};
var $8ced8cfc5f5e0063$export$2e2bcd8739ae039 = $8ced8cfc5f5e0063$var$hydrateTeamFromLegion;

});


parcelRegister("NrOEV", function(module, exports) {

$parcel$export(module.exports, "smartUserPickerRenderedUfoExperience", () => $d7f52eb4d23b90bc$export$df77da4c0210f1c1);
$parcel$export(module.exports, "smartUserPickerOptionsShownUfoExperience", () => $d7f52eb4d23b90bc$export$a0e7cca3ab9586eb);
$parcel$export(module.exports, "useUFOConcurrentExperience", () => $d7f52eb4d23b90bc$export$e5e0512991825310);
$parcel$export(module.exports, "UfoErrorBoundary", () => $d7f52eb4d23b90bc$export$5ef1c2550074a375);

var $5uXOq = parcelRequire("5uXOq");

var $766ff = parcelRequire("766ff");
var $2DPlK = parcelRequire("2DPlK");
var $e35GK = parcelRequire("e35GK");
const $d7f52eb4d23b90bc$var$COMPONENT_NAME = 'smart-user-picker';
const $d7f52eb4d23b90bc$export$df77da4c0210f1c1 = new (0, $766ff.ConcurrentExperience)('smart-user-picker-rendered', {
    platform: {
        component: $d7f52eb4d23b90bc$var$COMPONENT_NAME
    },
    type: (0, $2DPlK.ExperienceTypes).Load,
    performanceType: (0, $2DPlK.ExperiencePerformanceTypes).PageSegmentLoad
});
const $d7f52eb4d23b90bc$export$a0e7cca3ab9586eb = new (0, $766ff.ConcurrentExperience)('smart-user-picker-options-shown', {
    platform: {
        component: $d7f52eb4d23b90bc$var$COMPONENT_NAME
    },
    type: (0, $2DPlK.ExperienceTypes).Operation,
    performanceType: (0, $2DPlK.ExperiencePerformanceTypes).InlineResult
});
const $d7f52eb4d23b90bc$export$e5e0512991825310 = (experience, id)=>{
    const experienceForId = experience.getInstance(id);
    // Equivalent to componentWillMount - replace with @atlaskit/ufo's
    // useUFOComponentExperience when it supports ConcurrentExperience.
    (0, $5uXOq.useState)(()=>{
        experienceForId.start();
    });
    // Replace with @atlaskit/ufo's <ExperienceSuccess> when it supports ConcurrentExperience
    (0, $5uXOq.useEffect)(()=>{
        if (experienceForId.state !== (0, $e35GK.UFOExperienceState)['FAILED']) experienceForId.success();
        return ()=>{
            if ([
                (0, $e35GK.UFOExperienceState)['STARTED'],
                (0, $e35GK.UFOExperienceState)['IN_PROGRESS']
            ].includes(experienceForId.state)) experienceForId.abort();
        };
    // We only want this useEffect to run once after component mount, so no deps are needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
class $d7f52eb4d23b90bc$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch() {
        $d7f52eb4d23b90bc$export$df77da4c0210f1c1.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}

});



parcelRegister("4qXN2", function(module, exports) {
module.exports = new URL("team-two-people.dd270d21.svg", import.meta.url).toString();

});

parcelRegister("lElIo", function(module, exports) {

$parcel$export(module.exports, "defaultSelectStyles", () => $f1f1a093823579de$export$b12192ea1a215e5f);
$parcel$export(module.exports, "indicatorFixSelectStyles", () => $f1f1a093823579de$export$eca30945eaf474dd);

var $gwIPs = parcelRequire("gwIPs");
const $f1f1a093823579de$export$b12192ea1a215e5f = {
    menuPortal: (base)=>({
            ...base,
            zIndex: (0, $gwIPs.layers).modal
        }),
    menu: (base)=>({
            ...base,
            zIndex: (0, $gwIPs.layers).modal
        })
};
const $f1f1a093823579de$var$inputIconPaddingLeft = "var(--ds-space-025, 2px)";
const $f1f1a093823579de$var$inputIconPaddingRight = "var(--ds-space-050, 4px)";
const $f1f1a093823579de$export$eca30945eaf474dd = {
    // need to apply same padding to both loadingIndicator and clearIndicator - not to have input query jumping between lines e.g. in multi-select
    loadingIndicator: (base)=>({
            ...base,
            paddingLeft: $f1f1a093823579de$var$inputIconPaddingLeft,
            paddingRight: $f1f1a093823579de$var$inputIconPaddingRight
        }),
    clearIndicator: (base)=>({
            ...base,
            paddingLeft: $f1f1a093823579de$var$inputIconPaddingLeft,
            paddingRight: $f1f1a093823579de$var$inputIconPaddingRight
        })
};
const $f1f1a093823579de$export$a9f371909ef7b4d6 = {
    container: (base)=>({
            ...base,
            border: `${"var(--ds-space-025, 2px)"} solid ${"var(--ds-border-danger, #E2483D)"}`,
            borderRadius: "var(--ds-space-050, 4px)"
        })
};

});

const $7808beff4be6dc7e$export$53782b65600ab96d = '__UNASSIGNED_TEAM__';
const $7808beff4be6dc7e$export$3f4352abc4ee4b48 = '__CREATE_TEAM__';

parcelRegister("4vyX4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8457da62d9869465$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8457da62d9869465$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "issue-field-team.error-title",
        "defaultMessage": "We couldn't set the team value"
    },
    errorMessage: {
        "id": "issue-field-team.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    teamErrorViewTooltip: {
        "id": "issue-field-team.team-error-view-tooltip",
        "defaultMessage": "This team may have been deleted, or you do not have access"
    },
    teamErrorViewText: {
        "id": "issue-field-team.team-error-view-text",
        "defaultMessage": "Not available"
    },
    placeholderTeamEditSelector: {
        "id": "issue-field-team.placeholder-team-edit-selector",
        "defaultMessage": "Choose a team"
    },
    defaultNoValueText: {
        "id": "issue-field-team.default-no-value-text",
        "defaultMessage": "None"
    },
    createTeamButtonText: {
        "id": "issue-field-team.create-team-button-text",
        "defaultMessage": "Create a team"
    },
    emptyStateDescription: {
        "id": "issue-field-team.empty-state-description",
        "defaultMessage": "Create a team to assign work across Jira and track it on your team\u2019s profile"
    },
    noOptionsMessage: {
        "id": "issue-field-team.no-options-message",
        "defaultMessage": "No options"
    }
});

});

parcelRegister("lWune", function(module, exports) {

$parcel$export(module.exports, "CreateTeamOption", () => $3964fd12f1894d2f$export$8920795307e75f7e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c3ZaD = parcelRequire("c3ZaD");

var $6cP61 = parcelRequire("6cP61");

var $aQLOb = parcelRequire("aQLOb");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");


var $4vyX4 = parcelRequire("4vyX4");

var $7xOrU = parcelRequire("7xOrU");
function $3964fd12f1894d2f$export$8920795307e75f7e({ onClick: onClick, isFocused: isFocused }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formattedCreateTeamText = formatMessage((0, $4vyX4.default).createTeamButtonText);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const handleCreateTeamOptionClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createTeamInline', {
            teamsFieldEmptyState: false
        });
        onClick();
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const { canCreateTeams: canCreateTeams } = (0, $7xOrU.useTeamPermissions)();
    return canCreateTeams ? // eslint-disable-next-line jira/restricted/react-suspense
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c3ZaD.default), {
        inline: "space.200",
        block: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3964fd12f1894d2f$var$CreateButtonBorder, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3964fd12f1894d2f$var$Container, {
        onClick: handleCreateTeamOptionClick,
        isFocused: isFocused,
        "data-testid": "issue-field-team.ui.edit-mode.create-team-option.create-team-inline-option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3964fd12f1894d2f$var$OptionDataWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6cP61.default), {
        isSelected: false,
        data: {
            id: (0, $7808beff4be6dc7e$export$3f4352abc4ee4b48),
            name: formattedCreateTeamText,
            type: 'custom',
            avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($aQLOb)))
        }
    }))))) : null;
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3964fd12f1894d2f$var$CreateButtonBorder = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dozgxb",
            __cmplp.className
        ])
    });
});
const $3964fd12f1894d2f$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkv77o _1bsb1osq _4t3i1osq _irr3166n _1dbzu4to",
            __cmplp.isFocused ? "_bfhk166n" : "_bfhk18uv",
            __cmplp.isFocused ? "_16qsu4to" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $3964fd12f1894d2f$var$OptionDataWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aQLOb", function(module, exports) {
module.exports = new URL("team-two-people-with-plus.5493a468.svg", import.meta.url).toString();

});

parcelRegister("7xOrU", function(module, exports) {

$parcel$export(module.exports, "useTeamPermissions", () => $dbab4d033b21c1e7$export$8cbbe0c59dd60253);

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");

var $98eWh = parcelRequire("98eWh");
const $dbab4d033b21c1e7$export$8cbbe0c59dd60253 = ()=>{
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { permissions: permissions } = (0, $98eWh.useTeamsPermissionsService)({
        orgId: orgId,
        cloudId: cloudId
    }, {
        enabled: false
    });
    return permissions;
};

});


parcelRegister("fAxaP", function(module, exports) {

$parcel$export(module.exports, "TeamPickerEmptyState", () => $93f56cb34a904dc8$export$f53d61da818dafb4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $el82k = parcelRequire("el82k");

var $ousew = parcelRequire("ousew");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $4vyX4 = parcelRequire("4vyX4");

var $7xOrU = parcelRequire("7xOrU");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $93f56cb34a904dc8$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt _otyr1ejb _19pkze3t",
            __cmplp.className
        ])
    });
});
const $93f56cb34a904dc8$var$imageWrapperStyles = (0, $2s57o.xcss)({
    marginBottom: 'space.200'
});
const $93f56cb34a904dc8$export$f53d61da818dafb4 = ({ onActionClick: onActionClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { canCreateTeams: canCreateTeams } = (0, $7xOrU.useTeamPermissions)();
    const handleCreateTeamOptionClick = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createTeamInline', {
            teamsFieldEmptyState: true
        });
        onActionClick();
    };
    return canCreateTeams ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        paddingBlock: "space.200",
        testId: "issue-field-team.ui.edit-mode.team-picker-empty-state.empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $93f56cb34a904dc8$var$imageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $el82k.default), {
        alt: "",
        width: 130,
        height: 122
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93f56cb34a904dc8$var$Description, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4vyX4.default).emptyStateDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "primary",
        onClick: handleCreateTeamOptionClick,
        testId: "issue-field-team.ui.edit-mode.team-picker-empty-state.create-team-button",
        interactionName: "auto-generated.issue-field-team.ui.edit-mode.team-picker-empty-state.create-team-button.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4vyX4.default).createTeamButtonText))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4vyX4.default).noOptionsMessage);
};

});
parcelRegister("el82k", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce20a57a3049c2d5$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $2Lts4 = parcelRequire("2Lts4");
const $ce20a57a3049c2d5$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($2Lts4)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2Lts4))
});
var $ce20a57a3049c2d5$export$2e2bcd8739ae039 = $ce20a57a3049c2d5$var$Illustration;
// for advanced use only
const $ce20a57a3049c2d5$export$a179c88182cb9d56 = [
    0,
    0,
    130,
    122
];

});
parcelRegister("2Lts4", function(module, exports) {
module.exports = new URL("people-and-tasks.dedc2456.svg", import.meta.url).toString();

});




parcelRegister("ghnVw", function(module, exports) {

$parcel$export(module.exports, "default", () => $032f58b3b8fec432$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $032f58b3b8fec432$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "software-board-create.modal.form.source-value-picker.team-picker.placeholder",
        "defaultMessage": "Select"
    }
});

});




parcelRegister("iizLc", function(module, exports) {

$parcel$export(module.exports, "validateFormData", () => $cafe185f92d40f5f$export$cc0ea38c9ab56613);

var $h3KSk = parcelRequire("h3KSk");
const $cafe185f92d40f5f$var$validateBoardName = (value)=>{
    return !value || value.trim().length === 0 ? (0, $h3KSk.VALIDATION_ERROR_EMPTY) : undefined;
};
const $cafe185f92d40f5f$var$validateSourceType = (value)=>{
    return value === undefined ? (0, $h3KSk.VALIDATION_ERROR_EMPTY) : undefined;
};
const $cafe185f92d40f5f$var$validateSourceValue = (value)=>{
    if (Array.isArray(value) && !value.length || !Array.isArray(value) && !value) return 0, $h3KSk.VALIDATION_ERROR_EMPTY;
};
const $cafe185f92d40f5f$export$cc0ea38c9ab56613 = (data)=>({
        boardName: $cafe185f92d40f5f$var$validateBoardName(data.boardName),
        sourceType: $cafe185f92d40f5f$var$validateSourceType(data.sourceType),
        sourceValue: data.sourceType ? $cafe185f92d40f5f$var$validateSourceValue(data.sourceValue) : undefined
    });

});


parcelRegister("4K4Ab", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc97b5447a838fc3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cc97b5447a838fc3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    // Delete createBoardDialogLabel when cleaning up nav4_simplified_board_create_beta
    createBoardDialogLabel: {
        "id": "software-board-create.modal.create-board-dialog-label",
        "defaultMessage": "Create board dialog, {boardDescription}"
    },
    loadingLabel: {
        "id": "software-board-create.modal.loading-label",
        "defaultMessage": "Loading"
    }
});

});



parcelRegister("aDXGG", function(module, exports) {

$parcel$export(module.exports, "default", () => $caddba559d8e417f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $caddba559d8e417f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createBoardLabel: {
        "id": "software-board-create.flyout-menu.flyout-menu-content.dropdown-item-container.create-board-label",
        "defaultMessage": "Create a {boardType} board"
    }
});

});




parcelRegister("jFvRN", function(module, exports) {

$parcel$export(module.exports, "FlyoutMenuContentFallback", () => $1f33e86f0e9f6b4d$export$aad294dc6c6989e8);

var $5uXOq = parcelRequire("5uXOq");

var $eCE62 = parcelRequire("eCE62");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $kWGoR = parcelRequire("kWGoR");

var $gzrSn = parcelRequire("gzrSn");
const $1f33e86f0e9f6b4d$export$aad294dc6c6989e8 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kWGoR.FlyoutContentContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        paddingBlockStart: "space.100",
        xcss: $1f33e86f0e9f6b4d$var$skeletonItemContainerStyles,
        role: "menuitem",
        "aria-label": formatMessage((0, $gzrSn.default).loadingLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true,
        width: "100%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        paddingBlockStart: "space.100",
        xcss: $1f33e86f0e9f6b4d$var$skeletonItemContainerStyles,
        role: "menuitem",
        "aria-label": formatMessage((0, $gzrSn.default).loadingLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true,
        width: "100%"
    })));
};
const $1f33e86f0e9f6b4d$var$skeletonItemContainerStyles = (0, $2s57o.xcss)({
    height: '56px'
});

});
parcelRegister("gzrSn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f92c872d37e78842$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f92c872d37e78842$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loadingLabel: {
        "id": "software-board-create.flyout-menu.flyout-menu-content.flyout-menu-content-fallback.loading-label",
        "defaultMessage": "Loading"
    }
});

});





parcelRegister("lmBAt", function(module, exports) {

$parcel$export(module.exports, "getIsSoftwareThemingEnabled", () => $e55c8e35955d09b8$export$a505f57c5130832f);
$parcel$export(module.exports, "getIsSoftwareThemingM2Enabled", () => $e55c8e35955d09b8$export$4fa2eaefe7d59f41);

var $3HwlS = parcelRequire("3HwlS");

var $6s1PB = parcelRequire("6s1PB");
const $e55c8e35955d09b8$export$a505f57c5130832f = ()=>(0, $3HwlS.getWillShowNav4)() && (0, $6s1PB.expVal)('jira_theming_milestone_1', 'isEnabled', false);
const $e55c8e35955d09b8$export$4fa2eaefe7d59f41 = (variant)=>{
    // being part of M1 experiment is a prerequisite to be in M2
    if (!$e55c8e35955d09b8$export$a505f57c5130832f()) return false;
    if (variant === 'blurry-background') return (0, $6s1PB.expValEquals)('jira_theming_milestone_2', 'variant', 'blurry-background', 'control');
    if (variant === 'dominant-color') return (0, $6s1PB.expValEquals)('jira_theming_milestone_2', 'variant', 'dominant-color', 'control');
    // if we're here, variant doesn't matter anymore, we just show the experiment
    return (0, $6s1PB.expVal)('jira_theming_milestone_2', 'variant', 'control') !== 'control';
};

});

parcelRegister("a2e2Q", function(module, exports) {

$parcel$export(module.exports, "useSoftwareProjectTheming", () => $376b82e4729cc4d4$export$4c26676caf6bb553);

var $5uXOq = parcelRequire("5uXOq");

var $lODMY = parcelRequire("lODMY");

var $dAfqg = parcelRequire("dAfqg");

var $2vSU6 = parcelRequire("2vSU6");

var $lmBAt = parcelRequire("lmBAt");

var $4R6GH = parcelRequire("4R6GH");

var $e5wyW = parcelRequire("e5wyW");

var $86GR9 = parcelRequire("86GR9");
const $376b82e4729cc4d4$export$30f17de515f7ff59 = (routeName, projectType)=>{
    if (!(0, $lmBAt.getIsSoftwareThemingEnabled)()) return {
        hasSoftwareTheming: false,
        isSoftwareFullTheming: false,
        isSoftwareProject: false
    };
    const isSoftwareCalendarRoute = routeName === 'software-calendar' || routeName === 'software-calendar-classic';
    const isSoftwareProject = projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const hasSoftwareTheming = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? isSoftwareProject && (0, $86GR9.SOFTWARE_THEME_ROUTES_M2).includes(routeName) && !isSoftwareCalendarRoute : isSoftwareProject && (0, $86GR9.SOFTWARE_THEME_ROUTES).includes(routeName) && !isSoftwareCalendarRoute;
    const isSoftwareFullTheming = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? hasSoftwareTheming && (0, $86GR9.SOFTWARE_FULL_THEME_ROUTES_M2).includes(routeName) : hasSoftwareTheming && (0, $86GR9.SOFTWARE_FULL_THEME_ROUTES).includes(routeName);
    return {
        hasSoftwareTheming: hasSoftwareTheming,
        isSoftwareFullTheming: isSoftwareFullTheming,
        isSoftwareProject: isSoftwareProject
    };
};
const $376b82e4729cc4d4$export$c4b7ea2942f2d0e = (0, $lODMY.createRouterSelector)((state)=>state.route.name);
const $376b82e4729cc4d4$export$52b606e2ebcbaae2 = ()=>{
    if (!(0, $lmBAt.getIsSoftwareThemingEnabled)()) return {
        hasSoftwareTheming: false,
        isSoftwareFullTheming: false,
        isSoftwareProject: false
    };
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const currentRoute = $376b82e4729cc4d4$export$c4b7ea2942f2d0e();
    const isSoftwareProject = projectData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    // temporarily disable theming for calendar
    // the logic matches with the one in src/packages/platform/project-theme/page-container/src/controllers/project-theme/index.tsx
    const isSoftwareCalendarRoute = currentRoute === 'software-calendar' || currentRoute === 'software-calendar-classic';
    const hasSoftwareTheming = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? isSoftwareProject && (0, $86GR9.SOFTWARE_THEME_ROUTES_M2).includes(currentRoute) && !isSoftwareCalendarRoute : isSoftwareProject && (0, $86GR9.SOFTWARE_THEME_ROUTES).includes(currentRoute) && !isSoftwareCalendarRoute;
    const isSoftwareFullTheming = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? hasSoftwareTheming && (0, $86GR9.SOFTWARE_FULL_THEME_ROUTES_M2).includes(currentRoute) : hasSoftwareTheming && (0, $86GR9.SOFTWARE_FULL_THEME_ROUTES).includes(currentRoute);
    return {
        hasSoftwareTheming: hasSoftwareTheming,
        isSoftwareFullTheming: isSoftwareFullTheming,
        isSoftwareProject: isSoftwareProject
    };
};
const $376b82e4729cc4d4$var$useSoftwareProjectThemingNew = ()=>{
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    const firstRouterState = (0, $5uXOq.useMemo)(()=>(0, $lODMY.getRouterState)(), []);
    const [softwareProjectThemingState, setSoftwareProjectThemingState] = (0, $5uXOq.useState)(()=>$376b82e4729cc4d4$export$30f17de515f7ff59(firstRouterState.route.name, projectData?.projectType));
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = (0, $lODMY.addRouteListener)(({ route: route })=>{
            setSoftwareProjectThemingState((prevState)=>{
                const nextState = $376b82e4729cc4d4$export$30f17de515f7ff59(route.name, projectData?.projectType);
                if (nextState.hasSoftwareTheming !== prevState.hasSoftwareTheming || nextState.isSoftwareFullTheming !== prevState.isSoftwareFullTheming || nextState.isSoftwareProject !== prevState.isSoftwareProject) return nextState;
                return prevState;
            });
        });
        return ()=>unsubscribe();
    }, [
        projectData?.projectType
    ]);
    return softwareProjectThemingState;
};
const $376b82e4729cc4d4$export$4c26676caf6bb553 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('reduce_navigation_rerenders_1'), $376b82e4729cc4d4$var$useSoftwareProjectThemingNew, $376b82e4729cc4d4$export$52b606e2ebcbaae2);

});
parcelRegister("dAfqg", function(module, exports) {

$parcel$export(module.exports, "useProjectContext", () => $0baaa0dcf730951a$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $0baaa0dcf730951a$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $0baaa0dcf730951a$export$a85f6b5857d2176);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");
const $0baaa0dcf730951a$export$8f31c2503e1efa93 = (customContext)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $324W5.useResourceWithCustomRouterContext)((0, $dxCvy.projectContextResourceWithCache), customContext);
    const updateCache = (0, $5uXOq.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $0baaa0dcf730951a$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $0baaa0dcf730951a$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return children(projectContext);
};

});

parcelRegister("86GR9", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_FULL_THEME_ROUTES", () => $ef531902bffb6540$export$891915f6cf3ec6e7);
$parcel$export(module.exports, "SOFTWARE_FULL_THEME_ROUTES_M2", () => $ef531902bffb6540$export$1c7e7f18d2f498fe);
$parcel$export(module.exports, "SOFTWARE_THEME_ROUTES", () => $ef531902bffb6540$export$4edc7739f219df7c);
$parcel$export(module.exports, "SOFTWARE_THEME_ROUTES_M2", () => $ef531902bffb6540$export$587ac1561f46cfdc);
const $ef531902bffb6540$export$671a416a5ddfe0ea = [
    'issue',
    'software-backlog',
    'rapidboard-backlog',
    'software-timeline',
    'software-timeline-classic',
    'software-issue-navigator',
    'issue-navigator-classic'
];
const $ef531902bffb6540$export$891915f6cf3ec6e7 = [
    'software-boards',
    'rapidboard-board',
    'software-calendar',
    'software-calendar-classic',
    'software-list',
    'software-list-classic',
    'software-summary',
    'software-summary-classic'
];
const $ef531902bffb6540$export$1c7e7f18d2f498fe = [
    'software-boards',
    'rapidboard-board',
    'software-calendar',
    'software-calendar-classic',
    'software-list',
    'software-list-classic',
    'software-summary',
    'software-summary-classic',
    'software-backlog',
    'rapidboard-backlog'
];
const $ef531902bffb6540$export$4edc7739f219df7c = [
    ...$ef531902bffb6540$export$671a416a5ddfe0ea,
    ...$ef531902bffb6540$export$891915f6cf3ec6e7
];
const $ef531902bffb6540$export$587ac1561f46cfdc = [
    ...$ef531902bffb6540$export$671a416a5ddfe0ea,
    ...$ef531902bffb6540$export$1c7e7f18d2f498fe
];

});


parcelRegister("7TnTU", function(module, exports) {

$parcel$export(module.exports, "isCompanyManagedSoftwareProject", () => $9eab6e02685f3c3c$export$531964df831b0883);

var $2vSU6 = parcelRequire("2vSU6");
const $9eab6e02685f3c3c$export$531964df831b0883 = (projectStyle, projectType)=>projectStyle === 'COMPANY_MANAGED_PROJECT' && projectType === (0, $2vSU6.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT);

});

parcelRegister("jzmXi", function(module, exports) {

$parcel$export(module.exports, "default", () => $af5b5398f44bbc0e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $af5b5398f44bbc0e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createBoard: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-common.project-actions.create-board",
        "defaultMessage": "Create board"
    }
});

});


const $ba4e5f586c2a87d8$export$b8b9d90f9e5bd72b = '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-projects-jsw-project-menu';
const $ba4e5f586c2a87d8$export$d57b6b390e78d90f = 'jira-cosmos';
const $ba4e5f586c2a87d8$export$420a3ee5deb615a9 = 25;
const $ba4e5f586c2a87d8$export$99240e55cc48c47e = 5;

parcelRegister("dwZUI", function(module, exports) {

$parcel$export(module.exports, "nav4JSWProjectEntryPoint", () => $a51b1482b4cc12b0$export$b1c3a10bbf92ce74);

var $gIUIa = parcelRequire("gIUIa");

var $cfawy = parcelRequire("cfawy");

var $3rdd7 = parcelRequire("3rdd7");
const $a51b1482b4cc12b0$var$NO_OF_BOARDS_TO_FETCH = 25;

const $a51b1482b4cc12b0$export$b1c3a10bbf92ce74 = (0, $3rdd7.createEntryPoint)({
    root: (0, $cfawy.JSResourceForUserVisible)(()=>(parcelRequire("cNlxa")).then(({ JswExpandableProjectQuery: JswExpandableProjectQuery })=>JswExpandableProjectQuery), {
        moduleId: "69299f40",
        moduleName: "JswExpandableProjectQuery"
    }),
    getPreloadProps: (params)=>{
        const cloudId = params.tenantContext?.cloudId ?? '';
        const projectKey = params.context?.match.params?.projectKey ?? '';
        return {
            queries: {
                projects: {
                    parameters: $gIUIa.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        noOfBoardsToFetch: $a51b1482b4cc12b0$var$NO_OF_BOARDS_TO_FETCH
                    }
                }
            }
        };
    }
});

});
parcelRegister("gIUIa", function(module, exports) {

$parcel$export(module.exports, "default", () => $b76d34c79f26c888$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e40ded01b81f7feeace8ee5b7256d3ba>>
 * @relayHash 097e9539e9354202b3e97195911da82f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6a320080b485b09015939f9500e70d6187724b59304246a0240d200bc037c971

var $eiowN = parcelRequire("eiowN");
const $b76d34c79f26c888$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "noOfBoardsToFetch"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v6 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v4 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "JswExpandableProjectQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "noOfBoardsToFetch",
                                                    "variableName": "noOfBoardsToFetch"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "JswBoards"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "JswExpandableProjectQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "projectKey",
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "first",
                                            "variableName": "noOfBoardsToFetch"
                                        }
                                    ],
                                    "concreteType": "JiraBoardConnection",
                                    "kind": "LinkedField",
                                    "name": "boards",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraBoardEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraBoard",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraFavouriteValue",
                                                            "kind": "LinkedField",
                                                            "name": "favouriteValue",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canEdit"
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "mostRecentlyViewedBoard",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6a320080b485b09015939f9500e70d6187724b59304246a0240d200bc037c971",
            "metadata": {},
            "name": "JswExpandableProjectQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b76d34c79f26c888$var$node.hash = "c86c96423726df260003e830175ef141";
(0, $eiowN.PreloadableQueryRegistry).set($b76d34c79f26c888$var$node.params.id, $b76d34c79f26c888$var$node);
var $b76d34c79f26c888$export$2e2bcd8739ae039 = $b76d34c79f26c888$var$node;

});

parcelRegister("cNlxa", function(module, exports) {

let $950ac3d3699b28a8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $950ac3d3699b28a8$var$load("01uJN").then(()=>parcelRequire('fhfEu'));

});


parcelRegister("gfIrU", function(module, exports) {

$parcel$export(module.exports, "asyncJswExpandableProjectQuery", () => $92e535ad3861e9a5$export$ae81f6dde63e63eb);

var $3PSm1 = parcelRequire("3PSm1");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $92e535ad3861e9a5$export$ae81f6dde63e63eb = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("dA1Pt")).then(({ JswExpandableProjectOldQuery: JswExpandableProjectOldQuery })=>JswExpandableProjectOldQuery), {
        moduleId: "5e8272e2",
        moduleName: "JswExpandableProjectOldQuery"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectId: projectId, noOfBoardsToFetch: noOfBoardsToFetch })=>({
            queries: {
                projects: {
                    parameters: $3PSm1.default,
                    variables: {
                        cloudId: cloudId,
                        projectId: projectId,
                        noOfBoardsToFetch: noOfBoardsToFetch
                    }
                }
            }
        })
});

});
parcelRegister("3PSm1", function(module, exports) {

$parcel$export(module.exports, "default", () => $afb0cda5798853d0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<785072f51d21d16958bb928643423d65>>
 * @relayHash 33626f82049926e0af6bb735ebc05da6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a879e0600cdbac62dfd1ca3ebcdb31a9c6c6ec5059915ec1118fc00b8b38b1c
const $afb0cda5798853d0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "noOfBoardsToFetch"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v5 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "JswExpandableProjectOldQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "noOfBoardsToFetch",
                                                    "variableName": "noOfBoardsToFetch"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "JswBoards"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProject"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "JswExpandableProjectOldQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "projectKey",
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "first",
                                            "variableName": "noOfBoardsToFetch"
                                        }
                                    ],
                                    "concreteType": "JiraBoardConnection",
                                    "kind": "LinkedField",
                                    "name": "boards",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraBoardEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraBoard",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v7 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraFavouriteValue",
                                                            "kind": "LinkedField",
                                                            "name": "favouriteValue",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canEdit"
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "mostRecentlyViewedBoard",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v7 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2a879e0600cdbac62dfd1ca3ebcdb31a9c6c6ec5059915ec1118fc00b8b38b1c",
            "metadata": {},
            "name": "JswExpandableProjectOldQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$afb0cda5798853d0$var$node.hash = "33dadadc55cb4a4fdb3886a96ace3059";
var $afb0cda5798853d0$export$2e2bcd8739ae039 = $afb0cda5798853d0$var$node;

});

parcelRegister("dA1Pt", function(module, exports) {

let $9e300e6c3e02e3a5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9e300e6c3e02e3a5$var$load("6QISm").then(()=>parcelRequire('ccqpg'));

});


parcelRegister("1kZCN", function(module, exports) {

$parcel$export(module.exports, "asyncActionsOnHover", () => $3285e20e48e12804$export$4e4f732777dcde68);

var $ccPtS = parcelRequire("ccPtS");

var $3rdd7 = parcelRequire("3rdd7");

var $aNsVT = parcelRequire("aNsVT");

const $3285e20e48e12804$export$4e4f732777dcde68 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("iMnfh")).then(({ ActionsOnHoverQuery: ActionsOnHoverQuery })=>ActionsOnHoverQuery), {
        moduleId: "3853243e",
        moduleName: "ActionsOnHoverQuery"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectId: projectId })=>({
            queries: {
                projects: {
                    parameters: $ccPtS.default,
                    variables: {
                        cloudId: cloudId,
                        projectId: projectId
                    }
                }
            }
        })
});

});
parcelRegister("ccPtS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f97f343b17868234$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2704fe19071b32f846df2b95d6fc36f3>>
 * @relayHash 6783d55693763ae8ac648e375f8c1b09
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fb267a69caa35deb5548b260cb8b77588607336beadcc53cd721caf9ac44b5e9
const $f97f343b17868234$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ActionsOnHoverQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ProjectActions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProject"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ActionsOnHoverQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "projectKey",
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "alias": "editPermission",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_PROJECT_CONFIG"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ],
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fb267a69caa35deb5548b260cb8b77588607336beadcc53cd721caf9ac44b5e9",
            "metadata": {},
            "name": "ActionsOnHoverQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f97f343b17868234$var$node.hash = "f0643500ca76c97a30caef500db5e047";
var $f97f343b17868234$export$2e2bcd8739ae039 = $f97f343b17868234$var$node;

});

parcelRegister("iMnfh", function(module, exports) {

let $dabebdbab8e33820$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dabebdbab8e33820$var$load("8V7My").then(()=>parcelRequire('l3z6A'));

});



parcelRegister("igsK5", function(module, exports) {

$parcel$export(module.exports, "JswNonExpandableProject", () => $503472fd334f467b$export$cbea0eaf70f0156d);

var $3Ycm4 = parcelRequire("3Ycm4");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6Lyip = parcelRequire("6Lyip");

var $fNJRN = parcelRequire("fNJRN");

var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $60FHh = parcelRequire("60FHh");

var $buihy = parcelRequire("buihy");
const $503472fd334f467b$export$cbea0eaf70f0156d = ({ projectData: projectData, spotlight: spotlight })=>{
    const { sendProjectMenuItemAnalyticsEvent: sendProjectMenuItemAnalyticsEvent } = (0, $fNJRN.useProjectsAnalyticsL1)();
    const project = (0, $8Uumt.useFragment)((0, $3Ycm4.default), projectData);
    const routerLinkConfig = (0, $5uXOq.useMemo)(()=>({
            to: project.defaultNavigationItem?.url ?? `/browse/${project.projectKey}`,
            prefetch: 'hover'
        }), [
        project.defaultNavigationItem?.url,
        project.projectKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lyip.OnboardingSpotlightMaybe), {
        key: project.projectKey,
        spotlight: spotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buihy.ContainerAvatar), {
            src: project.avatar.large || ''
        }),
        href: routerLinkConfig,
        menuId: (0, $jhS4y.ENTITY_ID).PROJECT(project.projectKey),
        onClick: ()=>{
            sendProjectMenuItemAnalyticsEvent({
                starred: project.isFavourite ?? false,
                recent: !project.isFavourite,
                projectId: project.projectId,
                projectType: project.projectType
            });
        },
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60FHh.ProjectActions), {
            projectFragment: project
        })
    }, project.name));
};

});
parcelRegister("3Ycm4", function(module, exports) {

$parcel$export(module.exports, "default", () => $308da0e532a359a0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ec9c647dc6ce90744c0c4748168b513d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $308da0e532a359a0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "JswNonExpandableProject",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "projectKey"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "large"
                        },
                        "action": "THROW",
                        "path": "avatar.large"
                    }
                ]
            },
            "action": "THROW",
            "path": "avatar"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        }
                    ],
                    "type": "JiraNavigationItem",
                    "abstractKey": "__isJiraNavigationItem"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ProjectActions"
        }
    ],
    "type": "JiraProject"
};
$308da0e532a359a0$var$node.hash = "1c2cfe3c81902a2ea33e2fc3b9f6c4bb";
var $308da0e532a359a0$export$2e2bcd8739ae039 = $308da0e532a359a0$var$node;

});



parcelRegister("Xn42p", function(module, exports) {

$parcel$export(module.exports, "ProjectRestoreContext", () => $992f13279a3a116d$export$bc50e4f0d149dd7c);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");
const $992f13279a3a116d$export$bc50e4f0d149dd7c = /*#__PURE__*/ (0, $5uXOq.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))));

});


parcelRegister("7RJ5F", function(module, exports) {

$parcel$export(module.exports, "useSidebarSettingsAri", () => $2c44717735ecf81e$export$c020d957682d50c);
$parcel$export(module.exports, "useOwnerAri", () => $2c44717735ecf81e$export$7eaf80e428ccd5b3);

var $5uXOq = parcelRequire("5uXOq");

var $koeKL = parcelRequire("koeKL");

var $90yGq = parcelRequire("90yGq");

var $fY39E = parcelRequire("fY39E");

var $dXz5Y = parcelRequire("dXz5Y");
const $2c44717735ecf81e$export$c020d957682d50c = (menuName, parentType, parentId)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    return (0, $5uXOq.useMemo)(()=>(0, $dXz5Y.createSidebarSettingsAri)(cloudId, activationId, menuName, parentType, parentId), [
        cloudId,
        activationId,
        menuName,
        parentType,
        parentId
    ]);
};
const $2c44717735ecf81e$export$7eaf80e428ccd5b3 = ()=>{
    const accountId = (0, $90yGq.useAccountId)() || 'unidentified';
    return (0, $5uXOq.useMemo)(()=>(0, $dXz5Y.createIdentityUserAri)(accountId), [
        accountId
    ]);
};

});
parcelRegister("dXz5Y", function(module, exports) {

$parcel$export(module.exports, "createSidebarSettingsAri", () => $a0022f7ced10bcdf$export$53e9bd7d6d946a5d);
$parcel$export(module.exports, "createIdentityUserAri", () => $a0022f7ced10bcdf$export$caf08cda0abeee7a);

var $kYHsT = parcelRequire("kYHsT");

var $k9L5z = parcelRequire("k9L5z");
const $a0022f7ced10bcdf$export$1fd3c0096c24b2bb = (menuName, parentType, parentId)=>{
    if (parentType === undefined !== (parentId === undefined)) throw new Error('Invalid Navigation Setting Scope parentType and parentId must be defined together');
    if (parentType !== undefined && parentId !== undefined) return `${parentType}/${parentId}/${menuName}`;
    return menuName;
};
const $a0022f7ced10bcdf$export$b1bae424ff62eaf3 = (scope)=>{
    const [parentTypeOrMenuName, parentId, menuName] = scope.split('/');
    if (parentTypeOrMenuName && !parentId && !menuName) return {
        menuName: parentTypeOrMenuName
    };
    if (parentTypeOrMenuName && parentId && menuName) return {
        parentType: parentTypeOrMenuName,
        parentId: parentId,
        menuName: menuName
    };
    throw new Error('Invalid Navigation Setting Scope format');
};
const $a0022f7ced10bcdf$export$53e9bd7d6d946a5d = (cloudId, activationId, menuName, parentType, parentId)=>{
    return (0, $kYHsT.JiraNavigationSettingsAri).create({
        siteId: cloudId,
        activationId: activationId,
        navigationSettingScope: $a0022f7ced10bcdf$export$1fd3c0096c24b2bb(menuName, parentType, parentId)
    }).toString();
};
const $a0022f7ced10bcdf$export$cc210794adbf70e7 = (ariLikeString)=>{
    const ari = (0, $kYHsT.JiraNavigationSettingsAri).parse(ariLikeString);
    return $a0022f7ced10bcdf$export$b1bae424ff62eaf3(ari.navigationSettingScope);
};
const $a0022f7ced10bcdf$export$caf08cda0abeee7a = (userId)=>{
    return (0, $k9L5z.IdentityUserAri).create({
        userId: userId
    }).toString();
};

});


parcelRegister("hohDO", function(module, exports) {

$parcel$export(module.exports, "default", () => $53f5333898bb26f9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $bngFq = parcelRequire("bngFq");

var $cNW3X = parcelRequire("cNW3X");
var $i95f5 = parcelRequire("i95f5");

var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");

var $9fuVs = parcelRequire("9fuVs");

var $2vSU6 = parcelRequire("2vSU6");

var $34Vv8 = parcelRequire("34Vv8");

var $az4zD = parcelRequire("az4zD");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");

var $1ppIJ = parcelRequire("1ppIJ");

var $24wrg = parcelRequire("24wrg");

var $izP7o = parcelRequire("izP7o");

var $7Cf8E = parcelRequire("7Cf8E");

var $1OpzN = parcelRequire("1OpzN");
const $53f5333898bb26f9$export$a43ae427db1e9df7 = 'restore-from-trash';
const $53f5333898bb26f9$export$ec2a19e79c04c9d2 = 'restore-from-archive';
const $53f5333898bb26f9$export$cee26a329c363b31 = (props)=>{
    const { isProjectSimplified: isProjectSimplified, projectType: projectType, projectName: projectName, baseUrl: baseUrl = '', projectId: projectId, projectKey: projectKey, projectInactiveDate: projectInactiveDate, intl: { formatMessage: formatMessage }, onClose: onClose, onProjectRestoreSuccess: onProjectRestoreSuccess, onProjectRestoreFailure: onProjectRestoreFailure, flagService: { showFlag: showFlag } } = props;
    const [isRestoring, restoreProject] = (0, $24wrg.useProjectRestoreService)({
        baseUrl: baseUrl,
        projectId: projectId
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const attributes = {
        projectType: projectType,
        isProjectSimplified: isProjectSimplified
    };
    const onSuccess = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'restored'
        });
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'project restored', projectId.toString(), {
            ...attributes,
            durationInTrash: (0, $1OpzN.getDurationInTrash)(projectInactiveDate)
        });
        onProjectRestoreSuccess();
        if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) showFlag({
            messageId: 'project-restore-modal.ui.show-flag.success.restore-service-desk-success',
            messageType: 'transactional',
            type: 'success',
            title: (0, $izP7o.default).restoreServiceDeskSuccessMessageTitle,
            description: (0, $izP7o.default).restoreServiceDeskSuccessMessageContent,
            testId: 'project-restore-modal.ui.flags.success-flag',
            actions: [
                {
                    content: (0, $izP7o.default).restoreServiceDeskSuccessMessageActionEmailSettings,
                    href: `/jira/servicedesk/projects/${projectKey}/settings/email`
                }
            ]
        });
        else showFlag({
            messageId: 'project-restore-modal.ui.show-flag.success.restore-success',
            messageType: 'transactional',
            type: 'success',
            title: (0, $izP7o.default).restoreSuccessMessageTitle,
            testId: 'project-restore-modal.ui.flags.success-flag'
        });
    };
    const onFailure = (error)=>{
        onProjectRestoreFailure(error);
        if (// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('hix-5967_show_40x_restoring_project_error_message') && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        error.statusCode?.toString().startsWith('4') && error.message) showFlag({
            messageId: 'project-restore-modal.ui.show-flag.error.restore-error',
            messageType: 'transactional',
            type: 'error',
            title: [
                (0, $izP7o.default).restoreErrorMessageTitle,
                {
                    projectName: projectName
                }
            ],
            description: [
                (0, $izP7o.default).restoreErrorMessageDescriptionRenderErrorNonFinal,
                {
                    projectName: projectName,
                    error: error.message,
                    br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null)
                }
            ],
            testId: 'project-restore-modal.ui.flags.failure-flag'
        });
        else showFlag({
            messageId: 'project-restore-modal.ui.show-flag.error.restore-error.1',
            messageType: 'transactional',
            type: 'error',
            title: [
                (0, $izP7o.default).restoreErrorMessageTitle,
                {
                    projectName: projectName
                }
            ],
            description: [
                (0, $izP7o.default).restoreErrorMessageDescription,
                {
                    projectName: projectName
                }
            ],
            testId: 'project-restore-modal.ui.flags.failure-flag'
        });
    };
    const onRestore = (e, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'restoreProjectButton');
        restoreProject({
            onSuccess: onSuccess,
            onFailure: onFailure
        });
    };
    // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const ModalDialogDescription = ()=>// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Cf8E.ModalMessageContent), {
            projectType: projectType
        }));
    const onCancelOrNoop = !isRestoring ? onClose : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "restoreProject",
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        attributes: attributes,
        containerId: `${projectId}`,
        containerType: "project"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ppIJ.ModalDialog), {
        messageId: "project-restore-modal.ui.modal-dialog",
        messageType: "transactional",
        onClose: onCancelOrNoop,
        autoFocus: false,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUaFh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Sb4G.default), null, formatMessage(projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) ? (0, $izP7o.default).jsmModalHeader : (0, $izP7o.default).modalHeader, {
        projectName: projectName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1QfP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ModalDialogDescription, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CjwE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "subtle-link",
        onClick: onCancelOrNoop,
        isDisabled: isRestoring,
        testId: "project-restore-modal.ui.close-button-wrapper"
    }, formatMessage((0, $izP7o.default).cancelRestoreButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i95f5.default), {
        appearance: "primary",
        onClick: onRestore,
        isDisabled: isRestoring,
        isLoading: isRestoring,
        testId: "project-restore-modal.ui.restore-button-wrapper"
    }, formatMessage((0, $izP7o.default).confirmRestoreButton))))));
};
const $53f5333898bb26f9$export$9c21a3269931e1e6 = {
    isRestoring: false,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $53f5333898bb26f9$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)((0, $34Vv8.default)($53f5333898bb26f9$export$cee26a329c363b31));

});
parcelRegister("34Vv8", function(module, exports) {

$parcel$export(module.exports, "default", () => $827c4d80e4d41b48$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");
const $827c4d80e4d41b48$var$withFlagService = (WrappedComponent)=>{
    return (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            flagService: (0, $pa9q9.flagService)
        });
};
var $827c4d80e4d41b48$export$2e2bcd8739ae039 = $827c4d80e4d41b48$var$withFlagService;

});

parcelRegister("24wrg", function(module, exports) {

$parcel$export(module.exports, "useProjectRestoreService", () => $45f308a92ac01734$export$3726936b35df382d);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $64c16 = parcelRequire("64c16");
const $45f308a92ac01734$export$3726936b35df382d = ({ baseUrl: baseUrl, projectId: projectId })=>{
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const restoreProject = ({ onSuccess: onSuccess, onFailure: onFailure })=>{
        const url = (0, $64c16.getProjectRestoreUrl)(baseUrl, projectId);
        setLoading(true);
        (0, $eusud.performPostRequest)(url).then(()=>{
            setLoading(false);
            onSuccess();
        }).catch((error)=>{
            if (!(error.statusCode === 409 && (0, $4R6GH.fg)('hix-6266_-_no_error_fired_for_409_project_restore'))) (0, $jcw0u.default)({
                meta: {
                    id: 'useProjectRestoreService',
                    packageName: 'jiraProjectRestoreModal'
                },
                error: error,
                attributes: {
                    projectId: projectId,
                    errorStatusCode: error.statusCode
                }
            });
            setLoading(false);
            onFailure(error);
        });
    };
    return [
        loading,
        restoreProject
    ];
};

});
parcelRegister("64c16", function(module, exports) {

$parcel$export(module.exports, "getProjectRestoreUrl", () => $d662aeed5fd2bfed$export$f120ca318b319edc);
const $d662aeed5fd2bfed$export$f120ca318b319edc = (baseUrl, projectId)=>`${baseUrl}/rest/api/2/project/${projectId}/restore`;

});


parcelRegister("izP7o", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e2e27b03d33852c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3e2e27b03d33852c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    modalHeader: {
        "id": "project-restore-modal.modal-header",
        "defaultMessage": "Restore project?"
    },
    jsmModalHeader: {
        "id": "project-restore-modal.jsm-modal-header",
        "defaultMessage": "Restore this service project?"
    },
    jsmExplainWhatProjectRestoreDoes: {
        "id": "project-restore-modal.jsm-explain-what-project-restore-does",
        "defaultMessage": "Once restored, this service project will work as normal. It will appear in directories and requests will appear in search results."
    },
    confirmRestoreButton: {
        "id": "project-restore-modal.confirm-restore-button",
        "defaultMessage": "Restore"
    },
    cancelRestoreButton: {
        "id": "project-restore-modal.cancel-restore-button",
        "defaultMessage": "Cancel"
    },
    restoreSuccessMessageTitle: {
        "id": "project-restore-modal.restore-success-message-title",
        "defaultMessage": "Project successfully restored"
    },
    restoreServiceDeskSuccessMessageTitle: {
        "id": "project-restore-modal.restore-service-desk-success-message-title",
        "defaultMessage": "Service project restored"
    },
    restoreServiceDeskSuccessMessageContent: {
        "id": "project-restore-modal.restore-service-desk-success-message-content",
        "defaultMessage": "You may need to turn on email support for your service project to work as normal."
    },
    restoreServiceDeskSuccessMessageActionEmailSettings: {
        "id": "project-restore-modal.restore-service-desk-success-message-action-email-settings",
        "defaultMessage": "Go to email settings"
    },
    restoreErrorMessageTitle: {
        "id": "project-restore-modal.restore-error-message-title",
        "defaultMessage": "Something went wrong"
    },
    restoreErrorMessageDescription: {
        "id": "project-restore-modal.restore-error-message-description",
        "defaultMessage": "We couldn\u2019t restore the \u201C{projectName}\u201D project. Try again."
    },
    restoreErrorMessageDescriptionRenderErrorNonFinal: {
        "id": "project-restore-modal.restore-error-message-description-render-error-non-final",
        "defaultMessage": "We couldn\u2019t restore the \u201C{projectName}\u201D project.{br}{error}"
    }
});

});

parcelRegister("7Cf8E", function(module, exports) {

$parcel$export(module.exports, "ModalMessageContent", () => $db408ba139d077c4$export$6c33ff8e4ab0adf4);

var $5uXOq = parcelRequire("5uXOq");

var $41j30 = parcelRequire("41j30");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");


var $h33Ak = parcelRequire("h33Ak");
const $db408ba139d077c4$var$isServiceDesk = (projectType)=>projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
const $db408ba139d077c4$export$49587436f0d2c314 = ({ projectType: projectType })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getMessage = ()=>{
        let message;
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) message = $db408ba139d077c4$var$isServiceDesk(projectType) ? (0, $h33Ak.default).jsmExplainWhatProjectRestoreDoesIssueTermRefresh : (0, $h33Ak.default).explainWhatProjectRestoreDoesPart1IssueTermRefresh;
        else message = $db408ba139d077c4$var$isServiceDesk(projectType) ? (0, $h33Ak.default).jsmExplainWhatProjectRestoreDoes : (0, $h33Ak.default).explainWhatProjectRestoreDoesPart1;
        return message;
    };
    const formattedMessage = formatMessage(getMessage());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, formattedMessage, "\xa0");
};
const $db408ba139d077c4$export$d608ae2ec728a3cf = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
        href: (0, $14d5c91aea6dd559$export$367c841df4ac5730),
        target: "_blank"
    }, formatMessage((0, $h33Ak.default).jsmLearnMoreAboutTrashAndRestore));
};
const $db408ba139d077c4$export$6c33ff8e4ab0adf4 = ({ projectType: projectType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db408ba139d077c4$export$49587436f0d2c314, {
        projectType: projectType
    }), $db408ba139d077c4$var$isServiceDesk(projectType) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db408ba139d077c4$export$d608ae2ec728a3cf, null));

});
parcelRegister("41j30", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c2f3c33a6194375$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8oe80 = parcelRequire("8oe80");

var $hjSul = parcelRequire("hjSul");
function $7c2f3c33a6194375$var$Link(props) {
    const { children: children, ...rest } = props;
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), rest, children);
}
var $7c2f3c33a6194375$export$2e2bcd8739ae039 = (0, $8oe80.default)('link', {
    onClick: 'clicked'
})($7c2f3c33a6194375$var$Link);

});
parcelRegister("8oe80", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd6b229cbb45328e$export$2e2bcd8739ae039);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $asiGE = parcelRequire("asiGE");
var $3TR0I = parcelRequire("3TR0I");
const $cd6b229cbb45328e$export$871de8747c9eaa88 = (props)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            ...result,
            [key]: {
                action: props[key]
            }
        }), {});
/**
 * Augments component's callbacks with analytics event as the last attribute, but does fires them
 * @example
 * ```tsx
 * // adds componentName into AnalyticsContext and adds pre-backed 'clicked' event to onClick arguments
 *  const componentWithAnalytics('FooComponent', { onClick: 'clicked' })(Foo)
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cd6b229cbb45328e$var$componentWithAnalytics(componentName, eventActions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(WrappedComponent) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $asiGE.default)({
            componentName: componentName
        })((0, $3TR0I.default)($cd6b229cbb45328e$export$871de8747c9eaa88(eventActions))(WrappedComponent));
    };
}
var $cd6b229cbb45328e$export$2e2bcd8739ae039 = $cd6b229cbb45328e$var$componentWithAnalytics;

});


const $14d5c91aea6dd559$export$37312a67c3e314c6 = 'PROJECT_RESTORE_MODAL_LOAD_START_MARK_KEY';
const $14d5c91aea6dd559$export$367c841df4ac5730 = 'https://support.atlassian.com/jira-service-management-cloud/docs/trash-and-restore-a-project/';

parcelRegister("h33Ak", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3c890d2f3f15262$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f3c890d2f3f15262$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    explainWhatProjectRestoreDoesPart1: {
        "id": "project-restore-modal.modal-message.explain-what-project-restore-does-part-1",
        "defaultMessage": "The project along with its issues, Jira components, attachments, and versions will be restored."
    },
    jsmExplainWhatProjectRestoreDoes: {
        "id": "project-restore-modal.modal-message.jsm-explain-what-project-restore-does",
        "defaultMessage": "Once restored, this service project will appear in directories and its issues will appear in search results. You may need to turn on email support for this service project to work as normal."
    },
    jsmLearnMoreAboutTrashAndRestore: {
        "id": "project-restore-modal.modal-message.jsm-learn-more-about-trash-and-restore",
        "defaultMessage": "Learn more about trash and restore."
    },
    explainWhatProjectRestoreDoesPart1IssueTermRefresh: {
        "id": "project-restore-modal.modal-message.explain-what-project-restore-does-part-1-issue-term-refresh",
        "defaultMessage": "The project along with its work items, Jira components, attachments, and versions will be restored"
    },
    jsmExplainWhatProjectRestoreDoesIssueTermRefresh: {
        "id": "project-restore-modal.modal-message.jsm-explain-what-project-restore-does-issue-term-refresh",
        "defaultMessage": "Once restored, this service project will appear in directories and its work items will appear in search results. You may need to turn on email support for this service project to work as normal."
    }
});

});


parcelRegister("1OpzN", function(module, exports) {

$parcel$export(module.exports, "getDurationInTrash", () => $ba4edd4ad4308bc8$export$d40938201f7514c5);

var $4mBKK = parcelRequire("4mBKK");

var $jovBr = parcelRequire("jovBr");

var $eZDAP = parcelRequire("eZDAP");
const $ba4edd4ad4308bc8$export$d40938201f7514c5 = (projectTrashedDate)=>{
    const parsedProjectTrashedDate = (0, $jovBr.default)((0, $eZDAP.default)(projectTrashedDate)) ? (0, $eZDAP.default)(projectTrashedDate) : new Date(projectTrashedDate);
    return (0, $4mBKK.default)(new Date(), parsedProjectTrashedDate);
};

});


parcelRegister("gKabe", function(module, exports) {

$parcel$export(module.exports, "Nav4Recommendations", () => $020c59a125f3184a$export$dfe7a31b75b5edeb);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");


var $5UxNF = parcelRequire("5UxNF");
const $020c59a125f3184a$export$dfe7a31b75b5edeb = /*#__PURE__*/ (0, $5uXOq.memo)($020c59a125f3184a$var$Recommendations);
function $020c59a125f3184a$var$Recommendations({ queryRef: queryRef }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "growth-recommendations",
        fallback: "flag",
        packageName: (0, $6dbca5c36e867ae8$export$b8b9d90f9e5bd72b),
        teamName: (0, $6dbca5c36e867ae8$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "recommendations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5UxNF.Nav4Recommendations), {
        queryRef: queryRef
    })));
}

});
const $6dbca5c36e867ae8$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4GrowthRecommendations';
const $6dbca5c36e867ae8$export$d57b6b390e78d90f = 'jira-cosmos';
const $6dbca5c36e867ae8$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';

parcelRegister("5UxNF", function(module, exports) {

$parcel$export(module.exports, "Nav4Recommendations", () => $2717b8c67ab052cf$export$dfe7a31b75b5edeb);

var $5qgeN = parcelRequire("5qgeN");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $btuiY = parcelRequire("btuiY");
/*
At the moment, growthRecommendations fragment in GQL returns different response each time. This results in a behaviour where recommendation component in UI sometimes appear and disappear
as user interacts with the page.

Further observations were:
1) User clicks on a page. It may causes a change in url. this results in the refetch of Nav4ProjectsContent fragment to keep projects recent section up-to-date.
As part of this refetch, growthRecommendations is also refetched as it is part of the same fragment.

2) On each refetch, backend returns different entity ids for recommendations.
3) As a result, It causes the behavior where a recommendation appears and then disappears on different user interactions.

In order to solve it, a below cache is implemented. The purpose of which is to cache the first response and then use it to render the recommendations component which will also be wrapped
in a memo to avoid further re-renders.
*/ const $2717b8c67ab052cf$var$cache = {
    growthRecommendations: []
};
function $2717b8c67ab052cf$export$dfe7a31b75b5edeb({ queryRef: queryRef }) {
    const data = (0, $8Uumt.useFragment)((0, $5qgeN.default), queryRef);
    const canCreateProject = data?.jira?.canCreateProject ?? false;
    const recommendations = (0, $5uXOq.useMemo)(()=>{
        const appRecommendations = data?.growthRecommendations?.recommendations?.data?.map((item)=>item.entityId).filter(Boolean) ?? [];
        if ($2717b8c67ab052cf$var$cache.growthRecommendations.length === 0 && appRecommendations.length > 0) $2717b8c67ab052cf$var$cache.growthRecommendations = appRecommendations;
        /*
    	if user has no permission for creating a project, then we want early return to performance benefit.
    	This is because, currently there are only one recommendations 1) JPD Recommendation
    	Which requires create project permission before user can be considered eligible
    */ return Boolean(canCreateProject) && $2717b8c67ab052cf$var$cache.growthRecommendations.length > 0 && (0, $4R6GH.fg)('blu-3929-sidebar-menu-recommended') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $btuiY.Recommendations), {
            appRecommendations: $2717b8c67ab052cf$var$cache.growthRecommendations
        }) : null;
    }, [
        canCreateProject,
        data
    ]);
    return recommendations;
}

});
parcelRegister("5qgeN", function(module, exports) {

$parcel$export(module.exports, "default", () => $54a41d5a166d88a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cec605c2ff2940bd6f5b27fc2b0a9065>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $54a41d5a166d88a9$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Recommendations",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "alias": "canCreateProject",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_PROJECT"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Literal",
                                            "name": "product",
                                            "value": "jira"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "tenantId",
                                            "variableName": "cloudId"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "useCase",
                                            "value": "jiraProjectMenuRecommendations"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "context"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 2
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "entityId"
                                                        }
                                                    ],
                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$54a41d5a166d88a9$var$node.hash = "8a95cceadfe457dafa1d3f67150d4a1b";
var $54a41d5a166d88a9$export$2e2bcd8739ae039 = $54a41d5a166d88a9$var$node;

});

parcelRegister("btuiY", function(module, exports) {

$parcel$export(module.exports, "Recommendations", () => $f6ef8ac59a42f476$export$ebd86fc7badb9a5d);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $4IIGx = parcelRequire("4IIGx");
var $4vWwj = parcelRequire("4vWwj");
var $ch7sx = parcelRequire("ch7sx");
var $l3A2e = parcelRequire("l3A2e");

var $25tyu = parcelRequire("25tyu");

var $jl3Bs = parcelRequire("jl3Bs");

var $4mmmE = parcelRequire("4mmmE");
const $f6ef8ac59a42f476$export$ebd86fc7badb9a5d = ({ appRecommendations: appRecommendations })=>{
    const [isDismissed, setIsDismissed] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const selectedRecommendationState = (0, $25tyu.useSelectedRecommendation)({
        appRecommendations: appRecommendations
    });
    const onDismissRecommendation = (0, $5uXOq.useCallback)(()=>{
        setIsDismissed(true);
    }, []);
    if (!selectedRecommendationState?.recommendationKey) return null;
    const selectedRecommendation = (0, $4mmmE.recommendationsList).find((recommendation)=>recommendation.key === selectedRecommendationState.recommendationKey);
    return selectedRecommendation && !isDismissed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4vWwj.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ch7sx.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l3A2e.MenuSectionHeading), null, formatMessage((0, $jl3Bs.default).sectionTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(selectedRecommendation.Component, {
        recommendationKey: selectedRecommendation.key,
        dismissRecommendation: onDismissRecommendation
    })))));
};

});
parcelRegister("25tyu", function(module, exports) {

$parcel$export(module.exports, "useSelectedRecommendation", () => $6b2ce5b5c74ec887$export$6a60b75e3f5ce2aa);
// import shuffle from 'lodash/shuffle';

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $4mmmE = parcelRequire("4mmmE");

var $lCqSu = parcelRequire("lCqSu");
const $6b2ce5b5c74ec887$export$6a60b75e3f5ce2aa = ({ appRecommendations: appRecommendations })=>{
    const recommendationContext = (0, $lCqSu.useRecommendationContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    // NOTE: having shufle here will cause different order of data on SSR and client resulting in a UI change after first render
    // which may not seem like a good UX
    // const shuffledRecommendations = shuffle(recommendations);
    /* 	useMemo here prevents running this code each time user navigates a different route which triggers
		re-render of projects which then re-renders Recommendations component.
		memoisation also prevents sending operational analytics on each re-render
	*/ const recommendationStatus = (0, $5uXOq.useMemo)(()=>(0, $4mmmE.recommendationsList).map((recommendation)=>{
            if (!recommendationContext) return {
                key: recommendation.key,
                isEnabled: false
            };
            const isEnabled = recommendation.shouldRender(recommendationContext, createAnalyticsEvent({}), appRecommendations);
            return {
                key: recommendation.key,
                isEnabled: isEnabled
            };
        }), [
        appRecommendations,
        createAnalyticsEvent,
        recommendationContext
    ]);
    if (!recommendationContext) return {
        recommendationKey: null
    };
    const selectedRecommendation = recommendationStatus.find((result)=>result.isEnabled);
    return {
        recommendationKey: selectedRecommendation?.key || null
    };
};

});
parcelRegister("4mmmE", function(module, exports) {

$parcel$export(module.exports, "recommendationsList", () => $2e5f5f6a93849a03$export$2ff783c2bb2ac3b1);

var $cf2Z3 = parcelRequire("cf2Z3");
const $2e5f5f6a93849a03$var$createRecommendationsList = ()=>{
    const recommendationsList = [];
    recommendationsList.push((0, $cf2Z3.jpdRecommendation));
    // Add your own templates
    return recommendationsList;
};
const $2e5f5f6a93849a03$export$2ff783c2bb2ac3b1 = $2e5f5f6a93849a03$var$createRecommendationsList();

});
parcelRegister("cf2Z3", function(module, exports) {

$parcel$export(module.exports, "jpdRecommendation", () => $08d0fa98c47a849b$export$f0837513113a320d);

var $5uXOq = parcelRequire("5uXOq");

var $3gy1Y = parcelRequire("3gy1Y");

var $Q9DHJ = parcelRequire("Q9DHJ");
var $bBrJC = parcelRequire("bBrJC");

var $cNW3X = parcelRequire("cNW3X");

var $j7leM = parcelRequire("j7leM");

var $eOat1 = parcelRequire("eOat1");

var $6eFvr = parcelRequire("6eFvr");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");







var $5FnJJ = parcelRequire("5FnJJ");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $90yGq = parcelRequire("90yGq");

var $2tT7R = parcelRequire("2tT7R");

var $aRT0u = parcelRequire("aRT0u");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $hA8GQ = parcelRequire("hA8GQ");


var $i49ho = parcelRequire("i49ho");

var $83krH = parcelRequire("83krH");

var $ZxyRh = parcelRequire("ZxyRh");

var $eVIeT = parcelRequire("eVIeT");
const $08d0fa98c47a849b$export$da956fe610b96f73 = ({ recommendationKey: recommendationKey, dismissRecommendation: dismissRecommendation })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const crossFlow = (0, $Q9DHJ.useCrossFlow)();
    const accountId = (0, $90yGq.useAccountId)();
    const environment = (0, $2tT7R.useEnvironment)();
    const jpdCloudCCPProductID = (0, $i49ho.getProductTypeCcpReferenceIdMapForEnv)(environment).PRODUCT_DISCOVERY;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $aRT0u.useFireCrossFlowAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (crossFlow.isEnabled) fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'projectsMenu'
        }, {
            recommendedProductIds: [
                jpdCloudCCPProductID
            ],
            source: 'projectsMenuSection'
        }, {
            navigationVersion: 'v4',
            jpdContentChangeInProjectsMenuCohort: (0, $6s1PB.expVal)('new_nav_project_menu_jpd_reco_content_change', 'cohort', 'not-enrolled')
        });
        else (0, $jcw0u.default)({
            error: new Error(crossFlow.reason),
            meta: {
                id: crossFlow.reason,
                packageName: 'jiraAtlassianNavigationRecommendations'
            }
        });
    }, [
        createAnalyticsEvent,
        crossFlow,
        fireViewedUIEvent,
        jpdCloudCCPProductID
    ]);
    const jpdRecommendationContent = (0, $5uXOq.useMemo)(()=>{
        return (0, $6s1PB.expValEquals)('new_nav_project_menu_jpd_reco_content_change', 'cohort', 'variation') ? {
            projectTitle: (0, $83krH.default).projectTitleProductRoadmap,
            projectKey: (0, $i49ho.JPD_ROADMAP_KEY),
            projectAvatar: (0, $eVIeT.default)
        } : {
            projectTitle: (0, $83krH.default).projectTitle,
            projectKey: (0, $i49ho.JPD_KEY),
            projectAvatar: (0, $j7leM.JiraProductDiscoveryIcon)
        };
    }, []);
    const onLearnMoreClicked = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367),
            action: 'clicked'
        }), (0, $d59b407ab907bf7b$export$8d155d2412839524), {
            level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
            componentType: (0, $1e554a683893bd46$export$56981f28056f258e),
            parentItemType: (0, $632bd8725b437a12$export$9a778ca616c24a93),
            parentItemId: (0, $496585bee7985bb9$export$de9ad1ebeca97ec1),
            itemId: (0, $496585bee7985bb9$export$ce0bea1467165424),
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'learnMore'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v4'
        });
    }, [
        createAnalyticsEvent,
        fireInteractedUIEvent,
        jpdCloudCCPProductID
    ]);
    const onDismissClicked = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367),
            action: 'clicked'
        }), (0, $d59b407ab907bf7b$export$8d155d2412839524), {
            level: (0, $951a0ed422513987$export$f9db6a58b4aabd18),
            componentType: (0, $1e554a683893bd46$export$56981f28056f258e),
            parentItemType: (0, $632bd8725b437a12$export$9a778ca616c24a93),
            parentItemId: (0, $496585bee7985bb9$export$de9ad1ebeca97ec1),
            itemId: (0, $496585bee7985bb9$export$5c09fa42f8d45ed8),
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'dismissRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v4'
        });
        dismissRecommendation();
        if (accountId) (0, $89SaW.setUserProperties)(accountId, (0, $i49ho.JPD_RECOMMENDATION_DISMISS_USER_PROPERTY), 'true').catch((error)=>{
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'dismissJpdRecommendation',
                    packageName: (0, $6dbca5c36e867ae8$export$b8b9d90f9e5bd72b),
                    teamName: 'navigation'
                }
            });
        });
    }, [
        accountId,
        createAnalyticsEvent,
        dismissRecommendation,
        fireInteractedUIEvent,
        jpdCloudCCPProductID
    ]);
    const openCrossFlow = (0, $5uXOq.useCallback)(async (templateId)=>{
        const extensions = (0, $3gy1Y.createProvisioningPageExtensions)({
            actions: {
                primary: {
                    behaviour: (0, $3gy1Y.Behaviours).LAND,
                    prompt: (0, $3gy1Y.Prompts).NEXT,
                    options: {
                        targetTab: (0, $3gy1Y.TargetTabs).SAME,
                        urlParams: {
                            templateId: templateId
                        }
                    }
                }
            }
        });
        if (crossFlow.isEnabled) crossFlow.api.open({
            journey: (0, $Q9DHJ.Journeys).GET_STARTED,
            targetProduct: (0, $bBrJC.Targets).JIRA_PRODUCT_DISCOVERY,
            sourceComponent: 'projectsMenu',
            sourceContext: 'tryThisRecommendation',
            extensions: extensions
        });
    }, [
        crossFlow
    ]);
    const onRecommendationClicked = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2),
            action: 'clicked'
        }), (0, $d59b407ab907bf7b$export$8d155d2412839524), {
            level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
            componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
            itemType: (0, $632bd8725b437a12$export$9a778ca616c24a93),
            itemId: (0, $496585bee7985bb9$export$de9ad1ebeca97ec1),
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'tryThisRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v4'
        });
        openCrossFlow(jpdRecommendationContent.projectKey);
    }, [
        createAnalyticsEvent,
        fireInteractedUIEvent,
        jpdCloudCCPProductID,
        jpdRecommendationContent.projectKey,
        openCrossFlow
    ]);
    const recommendationActionMenuClickHandler = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        }), (0, $d59b407ab907bf7b$export$8d155d2412839524), {
            level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
            componentType: (0, $1e554a683893bd46$export$9bd6c21d500ae611),
            parentItemType: (0, $632bd8725b437a12$export$9a778ca616c24a93),
            parentItemId: (0, $496585bee7985bb9$export$de9ad1ebeca97ec1),
            itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e)
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(jpdRecommendationContent.projectAvatar, {
            appearance: "brand",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
            appearance: "new",
            isBold: false
        }, formatMessage((0, $83krH.default).lozengeText)),
        href: "",
        menuId: recommendationKey,
        onClick: onRecommendationClicked,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hA8GQ.RecommendationActionMenu), {
            onClick: recommendationActionMenuClickHandler,
            onLearnMoreClicked: onLearnMoreClicked,
            onDismissClicked: onDismissClicked,
            primaryCta: formatMessage((0, $83krH.default).reasonsModalButtonOk),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $83krH.default).reasonsModalExplanation, {
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
                        as: "strong"
                    }, chunks)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $83krH.default).reasonsModalBulletOneSpork)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $83krH.default).reasonsModalBulletTwo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
                appearance: "link",
                spacing: "none",
                href: (0, $6dbca5c36e867ae8$export$aefe1c8741b24a28),
                target: "_blank"
            }, formatMessage((0, $83krH.default).privacyPolicy))),
            title: formatMessage((0, $83krH.default).reasonsModalTitle)
        })
    }, formatMessage(jpdRecommendationContent.projectTitle)));
};
const $08d0fa98c47a849b$var$checkEligibility = (recommendationContext, appRecommendations)=>{
    const { areProductSuggestionsEnabled: areProductSuggestionsEnabled, licensedProducts: licensedProducts, accountId: accountId, jpdRecommendationDismissed: jpdRecommendationDismissed } = recommendationContext;
    if ((0, $4R6GH.fg)('grw-1467_jpd_reco_eligibility_override_gate')) return {
        isEligible: true,
        reason: 'Eligibility override gate is enabled'
    };
    if (!accountId) return {
        isEligible: false,
        reason: 'Account Id is null'
    };
    if (!areProductSuggestionsEnabled) return {
        isEligible: false,
        reason: 'Product suggestions are disabled'
    };
    if ((0, $ZxyRh.hasJpdLicense)(licensedProducts)) return {
        isEligible: false,
        reason: 'Instance has JPD license'
    };
    if (jpdRecommendationDismissed) return {
        isEligible: false,
        reason: 'JPD recommendation dismissed'
    };
    if (!appRecommendations?.some((entityId)=>entityId === (0, $i49ho.JPD_ENTITY_ID))) return {
        isEligible: false,
        reason: 'JPD was not in the recommend apps'
    };
    return {
        isEligible: true,
        reason: 'Pass all checks'
    };
};
const $08d0fa98c47a849b$export$f0837513113a320d = {
    key: (0, $i49ho.JPD_RECOMMENDATION_KEY),
    shouldRender: (recommendationContext, analyticsEvent, appRecommendations)=>{
        const { isEligible: isEligible, reason: reason } = $08d0fa98c47a849b$var$checkEligibility(recommendationContext, appRecommendations);
        if ((0, $4R6GH.fg)('pm_jpd_reco_operational_event_activated')) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.loadJpdRecommendation succeeded', {
            reason: reason,
            isEligible: isEligible
        });
        return isEligible;
    },
    Component: $08d0fa98c47a849b$export$da956fe610b96f73
};

});
parcelRegister("2tT7R", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $6bd66e47d4948917$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $6bd66e47d4948917$export$b0d8f74f433a09c9);

var $9OXo1 = parcelRequire("9OXo1");
const $6bd66e47d4948917$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $6bd66e47d4948917$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext?.environment || $6bd66e47d4948917$var$ENVIRONMENT.PROD;
};
const $6bd66e47d4948917$export$b0d8f74f433a09c9 = ()=>{
    const env = $6bd66e47d4948917$export$ea7ed2425832167d();
    return env === $6bd66e47d4948917$var$ENVIRONMENT.STAGING || env === $6bd66e47d4948917$var$ENVIRONMENT.DEV || env === $6bd66e47d4948917$var$ENVIRONMENT.LOCAL;
};

});

parcelRegister("hA8GQ", function(module, exports) {

$parcel$export(module.exports, "RecommendationActionMenu", () => $8bb3d181661250df$export$ff27431731859712);

var $5uXOq = parcelRequire("5uXOq");

var $c8rIN = parcelRequire("c8rIN");

var $44qT7 = parcelRequire("44qT7");
var $aOrxC = parcelRequire("aOrxC");
var $70rf1 = parcelRequire("70rf1");

var $koVbs = parcelRequire("koVbs");

var $2KAtx = parcelRequire("2KAtx");

var $iMEh3 = parcelRequire("iMEh3");

var $7ju32 = parcelRequire("7ju32");

var $lAku7 = parcelRequire("lAku7");

var $22OQR = parcelRequire("22OQR");

var $aBLQn = parcelRequire("aBLQn");
const $8bb3d181661250df$var$MENU_TEST_ID = 'recommendations-common.ui.recommendation-popup-menu.menu-group';
const $8bb3d181661250df$var$CustomTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        ...props,
        ref: ref,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8rIN))), {
            label: formatMessage((0, $aBLQn.default).moreActions),
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "navigation-apps-sidebar-nav4-sidebars-content-growth-recommendations.common.ui.recommendation-action-menu.themed-button"
    });
});
const $8bb3d181661250df$var$LearnMoreTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onLearnMoreClicked: onLearnMoreClicked }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44qT7.default), {
        ref: ref,
        onClick: onLearnMoreClicked
    }, formatMessage((0, $aBLQn.default).whyAmISeeingThis));
});
const $8bb3d181661250df$export$ff27431731859712 = ({ onClick: onClick, onLearnMoreClicked: onLearnMoreClicked, onDismissClicked: onDismissClicked, body: body, primaryCta: primaryCta, title: title })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            body: body,
            primaryCta: primaryCta,
            title: title
        }), [
        body,
        primaryCta,
        title
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: 400,
            height: 440
        }), []);
    const MenuItems = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), {
            testId: $8bb3d181661250df$var$MENU_TEST_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
            isList: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44qT7.default), {
            onClick: ()=>onDismissClicked()
        }, formatMessage((0, $aBLQn.default).dismissButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
            entryPoint: (0, $iMEh3.GrowthRecommendationsEntrypoint),
            entryPointProps: entryPointParams,
            modalProps: modalProps,
            useInternalModal: false
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8bb3d181661250df$var$LearnMoreTrigger, {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ref: ref,
                onLearnMoreClicked: onLearnMoreClicked
            })))), [
        entryPointParams,
        formatMessage,
        modalProps,
        onDismissClicked,
        onLearnMoreClicked
    ]);
    const content = (contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lAku7.MenuContent), {
            ...contentProps,
            MenuItems: MenuItems
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ju32.MenuContainer), {
        content: content,
        onClick: onClick,
        CustomTrigger: $8bb3d181661250df$var$CustomTrigger
    });
};

});
parcelRegister("iMEh3", function(module, exports) {

$parcel$export(module.exports, "GrowthRecommendationsEntrypoint", () => $657424a8590f6b4d$export$f926c2f51211d688);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $657424a8590f6b4d$export$f926c2f51211d688 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("7bV49")).then(({ GrowthRecommendationModal: GrowthRecommendationModal })=>GrowthRecommendationModal), {
        moduleId: "356e09a2",
        moduleName: "GrowthRecommendationModal"
    }),
    getPreloadProps: (props)=>({
            queries: {},
            props: props
        })
});

});
parcelRegister("7bV49", function(module, exports) {

let $53c5d39b0686e343$var$load = (parcelRequire("28QjX"))(4);
module.exports = $53c5d39b0686e343$var$load("77vT3").then(()=>parcelRequire('jcyQJ'));

});


parcelRegister("lAku7", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $9ef97abb06f2bc76$export$479f0f2f71193efe);

var $5uXOq = parcelRequire("5uXOq");

var $aOrxC = parcelRequire("aOrxC");

var $0yZbT = parcelRequire("0yZbT");

var $4DrQd = parcelRequire("4DrQd");
const $9ef97abb06f2bc76$var$stopEventPropagation = (event)=>event.stopPropagation();
const $9ef97abb06f2bc76$export$479f0f2f71193efe = ({ MenuItems: MenuItems, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        onMouseEnter: $9ef97abb06f2bc76$var$stopEventPropagation,
        onMouseLeave: $9ef97abb06f2bc76$var$stopEventPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), {
        minWidth: (0, $4DrQd.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItems, {
        onClose: onClose
    })));

});

parcelRegister("aBLQn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd4cafb5aa64f8e3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fd4cafb5aa64f8e3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    whyAmISeeingThis: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.why-am-i-seeing-this",
        "defaultMessage": "Why am I seeing this?"
    },
    moreActions: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.more-actions",
        "defaultMessage": "More actions"
    },
    dismissButtonText: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.dismiss-button-text",
        "defaultMessage": "Not interested"
    },
    reasonsModalTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-title",
        "defaultMessage": "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-explanation",
        "defaultMessage": "We think <strong>Jira Product Discovery</strong> will improve your team's productivity. The recommendation is based on:"
    },
    reasonsModalBulletOneSpork: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-one-spork",
        "defaultMessage": "the tools you use (Jira)"
    },
    reasonsModalBulletTwo: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two",
        "defaultMessage": "the way you use your existing tools and products"
    },
    privacyPolicy: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.privacy-policy",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    reasonsModalButtonOk: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok",
        "defaultMessage": "Ok"
    }
});

});


parcelRegister("i49ho", function(module, exports) {

$parcel$export(module.exports, "JPD_RECOMMENDATION_KEY", () => $bfae2422736e9114$export$3e6ff24c4f517c4f);
$parcel$export(module.exports, "JPD_KEY", () => $bfae2422736e9114$export$a9c4e38d8a74acd2);
$parcel$export(module.exports, "JPD_ROADMAP_KEY", () => $bfae2422736e9114$export$c11145b8eb60b18b);
$parcel$export(module.exports, "JPD_RECOMMENDATION_DISMISS_USER_PROPERTY", () => $bfae2422736e9114$export$52b9dedc0088f8);
$parcel$export(module.exports, "JPD_ENTITY_ID", () => $bfae2422736e9114$export$909712ccf16883d);
$parcel$export(module.exports, "getProductTypeCcpReferenceIdMapForEnv", () => $bfae2422736e9114$export$29629758934356a6);

var $7HXPn = parcelRequire("7HXPn");
const $bfae2422736e9114$export$3e6ff24c4f517c4f = 'jpd-recommendation';
const $bfae2422736e9114$export$a9c4e38d8a74acd2 = 'jpd.product-discovery';
const $bfae2422736e9114$export$c11145b8eb60b18b = 'jpd.product-roadmap';
const $bfae2422736e9114$export$52b9dedc0088f8 = 'JpdRecommendationDismissed';
const $bfae2422736e9114$export$909712ccf16883d = 'jira.polaris:discovery';
const $bfae2422736e9114$export$29629758934356a6 = (environment)=>{
    const env = environment === 'prod' ? 'prod' : 'staging';
    return {
        BUSINESS: (0, $7HXPn.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_work_management_cloud,
        SOFTWARE: (0, $7HXPn.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_software_cloud,
        SERVICE_DESK: (0, $7HXPn.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_service_management_cloud,
        PRODUCT_DISCOVERY: (0, $7HXPn.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_product_discovery
    };
};

});

parcelRegister("83krH", function(module, exports) {

$parcel$export(module.exports, "default", () => $5045a396714061a7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5045a396714061a7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-title",
        "defaultMessage": "New discovery project"
    },
    projectTitleProductRoadmap: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-title-product-roadmap",
        "defaultMessage": "Create a roadmap"
    },
    lozengeText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.lozenge-text",
        "defaultMessage": "try"
    },
    reasonsModalTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-title",
        "defaultMessage": "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-explanation",
        "defaultMessage": "We think <strong>Jira Product Discovery</strong> will improve your team's productivity. The recommendation is based on:"
    },
    reasonsModalBulletOneSpork: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-one-spork",
        "defaultMessage": "the tools you use (Jira)"
    },
    reasonsModalBulletTwo: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two",
        "defaultMessage": "the way you use your existing tools and products"
    },
    privacyPolicy: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.privacy-policy",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    reasonsModalButtonOk: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok",
        "defaultMessage": "Ok"
    }
});

});

parcelRegister("ZxyRh", function(module, exports) {

$parcel$export(module.exports, "hasJpdLicense", () => $a544ca433acda2ae$export$2ea69a0925803655);
const $a544ca433acda2ae$export$2ea69a0925803655 = (licensedProducts)=>licensedProducts['jira-product-discovery'] === true;

});

parcelRegister("eVIeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $5323fd484856ad72$export$2e2bcd8739ae039);
/* product-roadmap-project-avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $ew55A = parcelRequire("ew55A");

var $ax1N8 = parcelRequire("ax1N8");
const $5323fd484856ad72$var$ProductRoadmapProjectAvatar = ()=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $ew55A.default), {
        appearance: "square",
        borderColor: "transparent",
        size: "small",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ax1N8)))
    });
};
var $5323fd484856ad72$export$2e2bcd8739ae039 = $5323fd484856ad72$var$ProductRoadmapProjectAvatar;

});
parcelRegister("ax1N8", function(module, exports) {
module.exports = new URL("product-roadmap-project-icon.7eb40fb0.svg", import.meta.url).toString();

});




parcelRegister("lCqSu", function(module, exports) {

$parcel$export(module.exports, "useRecommendationContext", () => $d48e361b6db9225d$export$3321c0b02f750bcc);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4dc0x = parcelRequire("4dc0x");

var $51Yl2 = parcelRequire("51Yl2");

var $lXNZG = parcelRequire("lXNZG");

var $90yGq = parcelRequire("90yGq");

var $k9JTq = parcelRequire("k9JTq");

var $DVljb = parcelRequire("DVljb");

var $9OXo1 = parcelRequire("9OXo1");

var $2YP9W = parcelRequire("2YP9W");
const $d48e361b6db9225d$export$3321c0b02f750bcc = ()=>{
    const locale = (0, $DVljb.useLocale)();
    const accountId = (0, $90yGq.useAccountId)();
    const { cloudId: cloudId, licensedProducts: licensedProducts, firstActivationDateMs: firstActivationDateMs, areProductSuggestionsEnabled: areProductSuggestionsEnabled } = (0, $9OXo1.useTenantContext)();
    const { software: edition } = (0, $k9JTq.useAppEditions)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const jpdRecommendationDismissedResourceData = (0, $2YP9W.useResource)((0, $lXNZG.jpdRecommendationDismissedResource));
    const jpdRecommendationDismissed = jpdRecommendationDismissedResourceData?.data?.hasDismissed ?? false;
    const { data: userTraitsData } = (0, $2YP9W.useResource)((0, $51Yl2.fetchUserTraitsResource));
    const { data: siteTraitsData } = (0, $2YP9W.useResource)((0, $4dc0x.fetchSiteTraitsResource));
    return (0, $5uXOq.useMemo)(()=>({
            locale: locale,
            cloudId: cloudId,
            accountId: accountId,
            licensedProducts: licensedProducts,
            edition: edition,
            firstActivationDateMs: firstActivationDateMs,
            areProductSuggestionsEnabled: areProductSuggestionsEnabled,
            environment: environment,
            jpdRecommendationDismissed: jpdRecommendationDismissed,
            userTraitsData: userTraitsData,
            siteTraitsData: siteTraitsData
        }), [
        accountId,
        areProductSuggestionsEnabled,
        cloudId,
        edition,
        environment,
        firstActivationDateMs,
        licensedProducts,
        locale,
        jpdRecommendationDismissed,
        userTraitsData,
        siteTraitsData
    ]);
};

});
parcelRegister("DVljb", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $7c760643dc748494$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $7c760643dc748494$export$31652d9c30d7d3f3);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");
const $7c760643dc748494$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $lzeFL.defaultLocale);
};
const $7c760643dc748494$export$31652d9c30d7d3f3 = ()=>{
    const locale = $7c760643dc748494$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $5uXOq.useMemo)(()=>(0, $lzeFL.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});



parcelRegister("jl3Bs", function(module, exports) {

$parcel$export(module.exports, "default", () => $17579479487d4752$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $17579479487d4752$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sectionTitle: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-growth-recommendations.section-title",
        "defaultMessage": "Recommended"
    }
});

});




parcelRegister("dLakp", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectsSections", () => $97139f6e94a9aa7c$export$f0f2073bdea7c56e);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $4IIGx = parcelRequire("4IIGx");
var $4vWwj = parcelRequire("4vWwj");
var $ch7sx = parcelRequire("ch7sx");
var $l3A2e = parcelRequire("l3A2e");

var $jhS4y = parcelRequire("jhS4y");

var $5FnJJ = parcelRequire("5FnJJ");

var $7nWhn = parcelRequire("7nWhn");
const $97139f6e94a9aa7c$var$VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';
const $97139f6e94a9aa7c$var$RenderStarredSection = ({ favoriteItems: favoriteItems })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return favoriteItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4vWwj.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ch7sx.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l3A2e.MenuSectionHeading), null, formatMessage((0, $7nWhn.default).starred)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, favoriteItems.list))), favoriteItems.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        href: $97139f6e94a9aa7c$var$VIEW_ALL_STARRED_HREF,
        menuId: (0, $jhS4y.MENU_ID_PROJECTS_VIEW_ALL_STARRED)
    }, formatMessage((0, $7nWhn.default).viewAllStarred)));
};
const $97139f6e94a9aa7c$var$RenderRecentSection = ({ recentItems: recentItems })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return recentItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4vWwj.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ch7sx.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l3A2e.MenuSectionHeading), null, formatMessage((0, $7nWhn.default).recent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, recentItems.list)));
};
const $97139f6e94a9aa7c$export$f0f2073bdea7c56e = ({ favoriteItems: favoriteItems, recentItems: recentItems })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97139f6e94a9aa7c$var$RenderStarredSection, {
        favoriteItems: favoriteItems
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97139f6e94a9aa7c$var$RenderRecentSection, {
        recentItems: recentItems
    }));

});
parcelRegister("7nWhn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2425df2f0841aa4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b2425df2f0841aa4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.starred",
        "defaultMessage": "Starred"
    },
    viewAllStarred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.view-all-starred",
        "defaultMessage": "View all starred"
    }
});

});


parcelRegister("5alFY", function(module, exports) {

$parcel$export(module.exports, "Nav4ProjectsSectionsWithDisplaySettings", () => $34081a9b213852ea$export$f5fa44865e47a204);

var $ggBBt = parcelRequire("ggBBt");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $4IIGx = parcelRequire("4IIGx");
var $4vWwj = parcelRequire("4vWwj");
var $ch7sx = parcelRequire("ch7sx");
var $l3A2e = parcelRequire("l3A2e");

var $jhS4y = parcelRequire("jhS4y");

var $80ha2 = parcelRequire("80ha2");

var $5FnJJ = parcelRequire("5FnJJ");

var $c6x3L = parcelRequire("c6x3L");

var $kytLE = parcelRequire("kytLE");

var $7nWhn = parcelRequire("7nWhn");
const $34081a9b213852ea$var$VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';
const $34081a9b213852ea$var$isDisplaySettingsKey = (value)=>{
    const keys = Object.values((0, $kytLE.DisplaySettingsPropertyKeys));
    return keys.includes(value);
};
const $34081a9b213852ea$var$getNavigationCustomisation = (nodes, viewOption, defaultValue)=>{
    return nodes?.find((node)=>node?.key && $34081a9b213852ea$var$isDisplaySettingsKey(node.key) && (0, $kytLE.DisplaySettingsPropertyKeys)[node.key] === viewOption)?.value || defaultValue;
};
const $34081a9b213852ea$export$f5fa44865e47a204 = ({ favoriteItems: favoriteItems, recentItems: recentItems, queryRef: queryRef })=>{
    const data = (0, $8Uumt.useFragment)((0, $ggBBt.default), queryRef);
    const selectedViewOption = $34081a9b213852ea$var$getNavigationCustomisation(data.settings_navigationCustomisation?.properties?.nodes, (0, $kytLE.DisplaySettingsPropertyKeys).VIEW_OPTION, (0, $80ha2.DefaultViewOption));
    const { isSelectedPath: isSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const isStarredViewOptionSelected = selectedViewOption === (0, $80ha2.ViewOptions).STARRED;
    const isStarredAndRecentViewOptionSelected = selectedViewOption === (0, $80ha2.ViewOptions).STARRED_AND_RECENT;
    // If the current project is not starred, display it under the Recent section.
    // Once navigated away from the current non-starred project, it should disappear from the sidebar,
    // along with the Recent section
    const currentRecentItem = recentItems.list.find((item)=>item.key && isSelectedPath((0, $jhS4y.ENTITY_ID).PROJECT(item.key)));
    const displayedRecentItems = isStarredViewOptionSelected ? {
        list: currentRecentItem ? [
            currentRecentItem
        ] : [],
        hasItems: Boolean(currentRecentItem)
    } : recentItems;
    const shouldShowStarredSection = isStarredAndRecentViewOptionSelected || isStarredViewOptionSelected;
    const shouldShowRecentSection = isStarredAndRecentViewOptionSelected || displayedRecentItems.hasItems;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldShowStarredSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34081a9b213852ea$var$RenderStarredSection, {
        favoriteItems: favoriteItems
    }), shouldShowRecentSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34081a9b213852ea$var$RenderRecentSection, {
        recentItems: displayedRecentItems
    }));
};
const $34081a9b213852ea$var$RenderStarredSection = ({ favoriteItems: favoriteItems })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return favoriteItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4vWwj.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ch7sx.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l3A2e.MenuSectionHeading), null, formatMessage((0, $7nWhn.default).starred)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, favoriteItems.list))), favoriteItems.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FnJJ.Nav4MenuLinkItem), {
        href: $34081a9b213852ea$var$VIEW_ALL_STARRED_HREF,
        menuId: (0, $jhS4y.MENU_ID_PROJECTS_VIEW_ALL_STARRED)
    }, formatMessage((0, $7nWhn.default).viewAllStarred)));
};
const $34081a9b213852ea$var$RenderRecentSection = ({ recentItems: recentItems })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return recentItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4vWwj.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ch7sx.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l3A2e.MenuSectionHeading), null, formatMessage((0, $7nWhn.default).recent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, recentItems.list)));
};

});
parcelRegister("ggBBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $36220f58404b9cde$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<db313e78bd4577e1f34af3f48f590ec2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $36220f58404b9cde$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entityAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ownerAri"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4ProjectsSectionsWithDisplaySettings",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAri"
                },
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                }
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsDisplayPropertyConnection",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsDisplayProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$36220f58404b9cde$var$node.hash = "e6e0f204dff7282a7c0aeb808efb30c6";
var $36220f58404b9cde$export$2e2bcd8739ae039 = $36220f58404b9cde$var$node;

});






parcelRegister("abrAF", function(module, exports) {

$parcel$export(module.exports, "Recent", () => $ca7c92fe8a3d50e4$export$1147d6e1036afec);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");


var $paz61 = parcelRequire("paz61");
const $ca7c92fe8a3d50e4$export$1147d6e1036afec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-recent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "recent",
        packageName: (0, $7ad55196d5c142dd$export$b8b9d90f9e5bd72b),
        teamName: (0, $7ad55196d5c142dd$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $paz61.RecentMenu), null)));

});
const $7ad55196d5c142dd$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Recent';
const $7ad55196d5c142dd$export$d57b6b390e78d90f = 'jira-cosmos';
const $7ad55196d5c142dd$export$56ff071570537731 = 15;
const $7ad55196d5c142dd$export$fe791c4fa892e400 = 'PROJECT';
const $7ad55196d5c142dd$export$c303e491e026ebc6 = 'PLAN';
const $7ad55196d5c142dd$export$c1c49903035a02df = 'FILTER';
const $7ad55196d5c142dd$export$4695c1a423ffe431 = 'DASHBOARD';
const $7ad55196d5c142dd$export$9b8283d5878d2491 = 'BOARD';
const $7ad55196d5c142dd$export$5828682c822c26e7 = 'QUEUE';
const $7ad55196d5c142dd$export$76a449e52fa0e1e8 = 'ISSUE';
const $7ad55196d5c142dd$export$fd6cd74eeb4b51a7 = 'searchRecentItems';
const $7ad55196d5c142dd$export$f91d73dc0ffb6584 = 'viewAllRecentItems';
const $7ad55196d5c142dd$export$ee6bbe0a973ca0e8 = 'today';
const $7ad55196d5c142dd$export$91c1c08ffbb5f1be = 'yesterday';
const $7ad55196d5c142dd$export$4bada75a9cb45bec = 'thisWeek';
const $7ad55196d5c142dd$export$1385d821597ee807 = 'thisMonth';
const $7ad55196d5c142dd$export$d64d14c448d5a065 = 'moreThanAMonth';

parcelRegister("paz61", function(module, exports) {

$parcel$export(module.exports, "RecentMenu", () => $041364aacc6e1a81$export$9051cd0d0927b696);

var $5uXOq = parcelRequire("5uXOq");

var $5purl = parcelRequire("5purl");

var $9ylRC = parcelRequire("9ylRC");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $4R6GH = parcelRequire("4R6GH");


var $jecJ3 = parcelRequire("jecJ3");

var $iszzG = parcelRequire("iszzG");

var $46Cti = parcelRequire("46Cti");

var $338xa = parcelRequire("338xa");

var $24a2m = parcelRequire("24a2m");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $koeKL = parcelRequire("koeKL");

var $3senf = parcelRequire("3senf");
var $l7Vqz = parcelRequire("l7Vqz");
var $8luXP = parcelRequire("8luXP");


var $kIiWz = parcelRequire("kIiWz");

var $jh7Sz = parcelRequire("jh7Sz");
function $041364aacc6e1a81$export$9051cd0d0927b696() {
    const cloudId = (0, $koeKL.useCloudId)();
    const { formattedMessage: formattedMessage, icon: icon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $kIiWz.default).recent, (0, (/*@__PURE__*/$parcel$interopDefault($5purl))));
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $jh7Sz.sidebarRecentMenuEntryPoint), {
        cloudId: cloudId,
        count: (0, $7ad55196d5c142dd$export$56ff071570537731)
    });
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, $iszzG.NavItemsContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const onOpenChange = (0, $5uXOq.useCallback)((isMenuOpen)=>{
        if (isMenuOpen) {
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $46Cti.L1_MENU_ID).RECENT);
            (0, $8zOmE.fireUIAnalytics)(event, (0, $jecJ3.SECTION_ITEM_RECENT), {
                isInMore: isInMore
            });
        }
    }, [
        moreMenuIds,
        createAnalyticsEvent
    ]);
    return (0, $4R6GH.fg)('jira_global_recent_menu_item') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ylRC.GlobalRecentMenuItem), {
        triggerRef: triggerRef,
        onOpenChange: onOpenChange
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3senf.FlyoutMenuItem), {
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8luXP.FlyoutMenuItemTrigger), {
        interactionName: "nav4-sidebar-recent",
        ref: triggerRef,
        elemBefore: icon
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l7Vqz.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "nav4-sidebar-recent-default",
        packageName: (0, $7ad55196d5c142dd$export$b8b9d90f9e5bd72b),
        teamName: (0, $7ad55196d5c142dd$export$d57b6b390e78d90f),
        errorFallback: "flag",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
        runtimeProps: {}
    })));
}

});
parcelRegister("9ylRC", function(module, exports) {

$parcel$export(module.exports, "GlobalRecentMenuItem", () => $b2bd6a806bfca176$export$c58a64243715c6bf);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $5purl = parcelRequire("5purl");

var $3senf = parcelRequire("3senf");
var $l7Vqz = parcelRequire("l7Vqz");
var $8luXP = parcelRequire("8luXP");

var $9FNER = parcelRequire("9FNER");

var $WXZiP = parcelRequire("WXZiP");
const $b2bd6a806bfca176$export$1a14f8e769122bb2 = (Content)=>({ onOpenChange: onOpenChange, isDefaultOpen: isDefaultOpen, triggerRef: triggerRef })=>{
        const { formatMessage: formatMessage } = (0, $koVbs.default)();
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3senf.FlyoutMenuItem), {
            onOpenChange: onOpenChange,
            isDefaultOpen: isDefaultOpen,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8luXP.FlyoutMenuItemTrigger), {
                    ref: triggerRef,
                    elemBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5purl))), {
                        label: "",
                        color: "currentColor"
                    }),
                    children: formatMessage((0, $WXZiP.messages).flyoutMenuItemTriggerTitle)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l7Vqz.FlyoutMenuItemContent), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Content, {})
                })
            ]
        });
    };
const $b2bd6a806bfca176$export$c58a64243715c6bf = $b2bd6a806bfca176$export$1a14f8e769122bb2((0, $9FNER.GlobalRecentMenuContent));

});
parcelRegister("9FNER", function(module, exports) {

$parcel$export(module.exports, "GlobalRecentMenuContent", () => $8a3b1af56cd50166$export$29802207e0d6c9fc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $koVbs = parcelRequire("koVbs");

var $bWfiu = parcelRequire("bWfiu");

var $6cJvk = parcelRequire("6cJvk");

var $0yZbT = parcelRequire("0yZbT");
var $bEIgH = parcelRequire("bEIgH");

var $ctUNb = parcelRequire("ctUNb");

var $4IIGx = parcelRequire("4IIGx");

var $gkEOT = parcelRequire("gkEOT");

var $lJBxK = parcelRequire("lJBxK");

var $cQtLH = parcelRequire("cQtLH");

var $WXZiP = parcelRequire("WXZiP");
const $8a3b1af56cd50166$var$VIEW_ALL_LINK = 'https://home.atlassian.com/recents';

const $8a3b1af56cd50166$var$LazyGlobalRecentItems = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("Spzdg")));
const $8a3b1af56cd50166$export$29802207e0d6c9fc = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bEIgH.default), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                paddingInline: "space.075",
                paddingBlock: "space.100",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                    size: "xsmall",
                    children: formatMessage((0, $WXZiP.messages).flyoutMenuItemTriggerTitle)
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
                fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJBxK.ErrorState), {}),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cQtLH.LoadingState), {}),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($8a3b1af56cd50166$var$LazyGlobalRecentItems, {})
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gkEOT.Divider), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4IIGx.MenuList), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ctUNb.MenuLinkItem), {
                    elemBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6cJvk))), {
                        label: "",
                        spacing: "spacious",
                        color: "currentColor"
                    }),
                    href: $8a3b1af56cd50166$var$VIEW_ALL_LINK,
                    children: formatMessage((0, $WXZiP.messages).viewAllRecentItems)
                })
            })
        ]
    });
};
var $8a3b1af56cd50166$export$2e2bcd8739ae039 = $8a3b1af56cd50166$export$29802207e0d6c9fc;

});
parcelRegister("lJBxK", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $9cd191c4f7878d65$export$c1ed4f415b9e7023);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bWfiu = parcelRequire("bWfiu");

var $0yZbT = parcelRequire("0yZbT");
var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $WXZiP = parcelRequire("WXZiP");
const $9cd191c4f7878d65$export$c1ed4f415b9e7023 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
        xcss: $9cd191c4f7878d65$var$styles,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bEIgH.default), {
            alignInline: "center",
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                    size: "xsmall",
                    children: formatMessage((0, $WXZiP.messages).errorStateHeading)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6eFvr.default), {
                    size: "small",
                    align: "center",
                    color: "color.text.subtle",
                    children: formatMessage((0, $WXZiP.messages).errorStateDescription)
                })
            ]
        })
    });
};
const $9cd191c4f7878d65$var$styles = (0, $2s57o.xcss)({
    paddingBlock: 'space.1000',
    paddingInline: 'space.100'
});

});
parcelRegister("WXZiP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1b837bc9d3c0876f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $1b837bc9d3c0876f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    flyoutMenuItemTriggerTitle: {
        id: 'navigation.global-recent.flyout-menu-item-trigger-title.non-final',
        description: 'Label of the control that triggers the flyout menu.',
        defaultMessage: 'Recent'
    },
    viewAllRecentItems: {
        id: 'navigation.global-recent.view-all-recent-items.non-final',
        description: 'Label of the control that links to a page with all of the recent items.',
        defaultMessage: 'View all recent items'
    },
    menuSectionHeadingToday: {
        id: 'navigation.global-recent.menu-section-heading-today.non-final',
        description: "Heading of the section rendering today's items.",
        defaultMessage: 'Today'
    },
    menuSectionHeadingYesterday: {
        id: 'navigation.global-recent.menu-section-heading-yesterday.non-final',
        description: "Heading of the section rendering yesterday's items.",
        defaultMessage: 'Yesterday'
    },
    menuSectionHeadingThisWeek: {
        id: 'navigation.global-recent.menu-section-heading-this-week.non-final',
        description: 'Heading of the section rendering items for the current week.',
        defaultMessage: 'This week'
    },
    menuSectionHeadingThisMonth: {
        id: 'navigation.global-recent.menu-section-heading-this-month.non-final',
        description: 'Heading of the section rendering items for the current month.',
        defaultMessage: 'This Month'
    },
    menuSectionHeadingMoreThanAMonthAgo: {
        id: 'navigation.global-recent.menu-section-heading-this-month.non-final',
        description: 'Heading of the section rendering items older than a month ago.',
        defaultMessage: 'More than a month ago'
    },
    errorStateHeading: {
        id: 'navigation.global-recent.error-state-heading.non-final',
        description: "Heading of the error state UI indicating we couldn't load the data.",
        defaultMessage: "Can't load items"
    },
    errorStateDescription: {
        id: 'navigation.global-recent.error-state-description.non-final',
        description: "Description of the error state UI indicating we couldn't load the data.",
        defaultMessage: "We're having trouble loading your data. Please try again later."
    },
    emptyStateHeading: {
        id: 'navigation.global-recent.empty-state-heading.non-final',
        description: "Heading of the empty state UI indicating there's no content available.",
        defaultMessage: 'Nothing to see here!'
    },
    emptyStateDescription: {
        id: 'navigation.global-recent.empty-state-description.non-final',
        description: "Description of the empty state UI indicating there's no content available.",
        defaultMessage: "Once you visit, edit, or create items, they'll show up here."
    },
    loadingStateVisuallyHiddenLabel: {
        id: 'navigation.global-recent.loading-state-visually-hidden-label.non-final',
        description: 'Label of the loading state UI only available to screen reader users.',
        defaultMessage: 'Loading recent content'
    },
    confluenceDraftDefaultTitle: {
        id: 'navigation.global-recent.confluence-item-draft-title.non-final',
        description: 'Default title for draft pages and blog posts in Confluence.',
        defaultMessage: 'Untitled'
    },
    confluenceDraftLabel: {
        id: 'navigation.global-recent.confluence-item-draft-label.non-final',
        description: 'Label of the lozenge indicating a Confluence item is a draft.',
        defaultMessage: 'Draft'
    }
});

});


parcelRegister("cQtLH", function(module, exports) {

$parcel$export(module.exports, "LoadingState", () => $e611100d38451694$export$62aa48085237e36f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eCE62 = parcelRequire("eCE62");

var $cBCgC = parcelRequire("cBCgC");

var $4IIGx = parcelRequire("4IIGx");

var $4vWwj = parcelRequire("4vWwj");

var $WXZiP = parcelRequire("WXZiP");
const $e611100d38451694$export$62aa48085237e36f = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const items = Array.from({
        length: 5
    }, (_, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4vWwj.MenuListItem), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCE62.default), {
                isShimmering: true,
                width: "100%"
            })
        }, index));
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
                children: formatMessage((0, $WXZiP.messages).loadingStateVisuallyHiddenLabel)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4IIGx.MenuList), {
                children: items
            })
        ]
    });
};

});

parcelRegister("Spzdg", function(module, exports) {

let $0a38e052fd60674e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0a38e052fd60674e$var$load("9hU7e").then(()=>parcelRequire('kr3A7'));

});



parcelRegister("kIiWz", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa748d68241ef7a4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fa748d68241ef7a4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "navigation-apps-sidebar-nav4-recent.recent",
        "defaultMessage": "Recent"
    }
});

});

parcelRegister("jh7Sz", function(module, exports) {

$parcel$export(module.exports, "sidebarRecentMenuEntryPoint", () => $59b75f87881a1c54$export$52be5f9ca0100885);

var $6sGCE = parcelRequire("6sGCE");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $59b75f87881a1c54$export$52be5f9ca0100885 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("dTS2J")), {
        moduleId: "1a0fa847"
    }),
    getPreloadProps: ({ cloudId: cloudId, count: count })=>({
            queries: {
                recentMenuData: {
                    parameters: $6sGCE.default,
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    variables: {
                        cloudId: cloudId,
                        count: count,
                        keyword: ''
                    }
                }
            }
        })
});

});
parcelRegister("6sGCE", function(module, exports) {

$parcel$export(module.exports, "default", () => $de7f5d7554961488$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b419a047cdf1d84819532a8450f2373a>>
 * @relayHash 2bf261fc9e503f19a16072abc8ff3bb0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 855172207100d7942753caadb5bb595995ca2328e35845d9cb3c8f297f5e2ce4

var $eiowN = parcelRequire("eiowN");
const $de7f5d7554961488$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v2 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "keyword"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = {
        "fields": [
            {
                "kind": "Variable",
                "name": "keyword",
                "variableName": "keyword"
            }
        ],
        "kind": "ObjectValue",
        "name": "filter"
    }, v5 = {
        "kind": "Literal",
        "name": "types",
        "value": [
            "PROJECT",
            "FILTER",
            "DASHBOARD",
            "BOARD",
            "QUEUE",
            "ISSUE",
            "PLAN"
        ]
    }, v6 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        },
        v5 /*: any*/ 
    ], v7 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v8 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        },
        v5 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "ScalarField",
        "name": "lastViewedTimestamp"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v10 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v13 = [
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "alias": "filterName",
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "filterUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "filterId"
                }
            ],
            "type": "JiraFilter",
            "abstractKey": "__isJiraFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "recentMenuQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "recent",
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v7 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.recent.pageInfo"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.recent"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "recentMenu_navigationAppsSidebarNav4SidebarsContentRecent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "recentMenuQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "recent",
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "_recentItems",
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "issueWebUrl",
                                                            "kind": "ScalarField",
                                                            "name": "webUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueId"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "title",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v12 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        }
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        {
                                                            "concreteType": "JiraScenario",
                                                            "kind": "LinkedField",
                                                            "name": "scenario",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "scenarioId"
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "alias": "planTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        }
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        }
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "dashboardTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        }
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "alias": "queueTitle",
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "_recentItems",
                            "args": v8 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "types",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "RecentMenuContent__recentItems",
                            "kind": "LinkedHandle",
                            "name": "recentItems"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "855172207100d7942753caadb5bb595995ca2328e35845d9cb3c8f297f5e2ce4",
            "metadata": {},
            "name": "recentMenuQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$de7f5d7554961488$var$node.hash = "b81d123360d86456f0af905baa34e827";
(0, $eiowN.PreloadableQueryRegistry).set($de7f5d7554961488$var$node.params.id, $de7f5d7554961488$var$node);
var $de7f5d7554961488$export$2e2bcd8739ae039 = $de7f5d7554961488$var$node;

});

parcelRegister("dTS2J", function(module, exports) {

let $a1ea554184b75236$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a1ea554184b75236$var$load("04G5Q").then(()=>parcelRequire('U4Few'));

});




parcelRegister("3J4Wg", function(module, exports) {

$parcel$export(module.exports, "Nav4Roadmaps", () => $3d2666959f2cadcc$export$257bbde911c73386);

var $cSD7y = parcelRequire("cSD7y");

var $eNDdb = parcelRequire("eNDdb");

var $852R8 = parcelRequire("852R8");
const $3d2666959f2cadcc$export$257bbde911c73386 = (0, $cSD7y.componentWithFG)('jpd-sidebar-v4-for-roadmaps', (0, $852R8.Nav4RoadmapsNext), (0, $eNDdb.Nav4RoadmapsLegacy));

});
parcelRegister("eNDdb", function(module, exports) {

$parcel$export(module.exports, "Nav4RoadmapsLegacy", () => $675a952ab7673d57$export$c15f8f1326f82149);

var $5uXOq = parcelRequire("5uXOq");

var $l8ruj = parcelRequire("l8ruj");

var $7CMCs = parcelRequire("7CMCs");

var $lPlgS = parcelRequire("lPlgS");

var $3RJbG = parcelRequire("3RJbG");
const $675a952ab7673d57$export$c15f8f1326f82149 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-roadmaps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "roadmaps-section",
        packageName: (0, $3RJbG.PACKAGE_NAME),
        teamName: (0, $3RJbG.TEAM_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lPlgS.Nav4Roadmaps), props)));

});
parcelRegister("lPlgS", function(module, exports) {

$parcel$export(module.exports, "Nav4Roadmaps", () => $40bb8fce2def596b$export$257bbde911c73386);

var $5uXOq = parcelRequire("5uXOq");

var $agzbr = parcelRequire("agzbr");

var $9OXo1 = parcelRequire("9OXo1");

var $6ZDS2 = parcelRequire("6ZDS2");

var $8VrTR = parcelRequire("8VrTR");

var $2CiQp = parcelRequire("2CiQp");
const $40bb8fce2def596b$export$28e0d36d410e4eb5 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ZDS2.AnalyticContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40bb8fce2def596b$export$257bbde911c73386, props));
};
const $40bb8fce2def596b$export$257bbde911c73386 = ({ isExpanded: isExpanded })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40bb8fce2def596b$var$EmojiDataContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CiQp.RoadmapsDefault), {
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8VrTR.ActionButtons), null),
        isExpanded: isExpanded
    }));
};
const $40bb8fce2def596b$var$EmojiDataContainer = ({ children: children })=>{
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = (0, $9OXo1.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $agzbr.EmojiContainer), {
        cloudId: cloudId,
        currentUser: atlassianAccountId || undefined
    }, children);
};

});
parcelRegister("agzbr", function(module, exports) {

$parcel$export(module.exports, "useEmoji", () => $9992f7de1dfa0390$export$482903c4ce3f5633);
$parcel$export(module.exports, "useEmojiById", () => $9992f7de1dfa0390$export$659ae98cb5b73fba);
$parcel$export(module.exports, "useEmojiProviderPromise", () => $9992f7de1dfa0390$export$d020ccccbff96c19);
$parcel$export(module.exports, "EmojiContainer", () => $9992f7de1dfa0390$export$5138cd734f185a21);

var $5uXOq = parcelRequire("5uXOq");

var $hXRXz = parcelRequire("hXRXz");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");
const $9992f7de1dfa0390$var$actions = {
    loadEmoji: (emojiId)=>async ({ getState: getState, setState: setState })=>{
            const { provider: provider } = getState();
            if (!provider) return;
            const resolvedProvider = await provider;
            const optionalDescription = await resolvedProvider.findById(emojiId);
            const emoji = optionalDescription !== undefined ? await resolvedProvider.getMediaEmojiDescriptionURLWithInlineToken(optionalDescription) : optionalDescription;
            setState({
                cachedEmojis: {
                    ...getState().cachedEmojis,
                    [emojiId]: emoji ?? null
                }
            });
        }
};
const $9992f7de1dfa0390$var$initialState = {
    provider: undefined,
    cachedEmojis: {}
};
const $9992f7de1dfa0390$var$EmojiStore = (0, $iXqE5.createStore)({
    initialState: $9992f7de1dfa0390$var$initialState,
    actions: $9992f7de1dfa0390$var$actions,
    name: 'PolarisEmojiStore'
});
const $9992f7de1dfa0390$var$useEmojis = (0, $3sQ5x.createHook)($9992f7de1dfa0390$var$EmojiStore);
const $9992f7de1dfa0390$export$482903c4ce3f5633 = (emojiId)=>{
    const [emoji, setEmoji] = (0, $5uXOq.useState)(undefined);
    const [{ provider: provider }] = $9992f7de1dfa0390$var$useEmojis();
    (0, $5uXOq.useEffect)(()=>{
        if (emojiId !== undefined && provider !== undefined) provider.then((resolvedProvider)=>{
            Promise.resolve(resolvedProvider.findById(emojiId)).then((optionalDescription)=>optionalDescription !== undefined ? resolvedProvider.getMediaEmojiDescriptionURLWithInlineToken(optionalDescription) : optionalDescription).then(setEmoji);
        });
        else setEmoji(undefined);
    }, [
        provider,
        emojiId
    ]);
    return emojiId !== undefined ? emoji : undefined;
};
const $9992f7de1dfa0390$export$659ae98cb5b73fba = (0, $3sQ5x.createHook)($9992f7de1dfa0390$var$EmojiStore, {
    selector: (0, $6dDSs.createSelector)((state, { emojiId: emojiId })=>emojiId ? state.cachedEmojis[emojiId] : undefined, (emoji)=>emoji)
});
const $9992f7de1dfa0390$export$d020ccccbff96c19 = ()=>{
    const [{ provider: provider }] = $9992f7de1dfa0390$var$useEmojis();
    return provider !== undefined ? provider : Promise.reject(new Error('emoji provider not initialized'));
};
const $9992f7de1dfa0390$export$5138cd734f185a21 = (0, $gg7kZ.createContainer)($9992f7de1dfa0390$var$EmojiStore, {
    onInit: ()=>(storeActionApi, { cloudId: cloudId, currentUser: currentUser })=>{
            storeActionApi.setState({
                provider: (0, $hXRXz.getEmojiProviderWithCustomEmoji)(cloudId, currentUser) || undefined
            });
        }
});

});
parcelRegister("hXRXz", function(module, exports) {

$parcel$export(module.exports, "getEmojiProvider", () => $8599af293a85f3b3$export$8210f5f78c0bcf27);
$parcel$export(module.exports, "getEmojiProviderWithCustomEmoji", () => $8599af293a85f3b3$export$f9c5a1e85ff0cb72);
$parcel$export(module.exports, "getEmojiProviderWithCustomEmojiUploadDisabled", () => $8599af293a85f3b3$export$7cda0fc535c2710f);
$parcel$export(module.exports, "fetchEmojiProvider", () => $8599af293a85f3b3$export$12c2b0bd175ad5c1);

var $cNjCa = parcelRequire("cNjCa");

var $9CGZY = parcelRequire("9CGZY");
const $8599af293a85f3b3$var$baseProviders = (serviceBaseUrl)=>[
        {
            url: `${serviceBaseUrl}/emoji/standard`
        },
        {
            url: `${serviceBaseUrl}/emoji/atlassian`
        }
    ];
const $8599af293a85f3b3$export$8210f5f78c0bcf27 = ()=>(0, $9CGZY.getServiceProvider)((0, $9CGZY.EMOJI_SERVICEID), (serviceBaseUrl)=>{
        const emojiResource = new (0, $cNjCa.default)({
            providers: $8599af293a85f3b3$var$baseProviders(serviceBaseUrl)
        });
        return emojiResource.getEmojiProvider();
    });
const $8599af293a85f3b3$export$f9c5a1e85ff0cb72 = (cloudId, accountId, // fetchAtStart allows you to delay emoji fetching
// however, if it is used in an editor, remember to call `fetchEmojiProvider` on mount
// because typing `:` does not trigger emoji fetching
fetchAtStart = true)=>(0, $9CGZY.getServiceProvider)((0, $9CGZY.EMOJI_WITH_CUSTOM_SERVICEID), (serviceBaseUrl)=>{
        const providers = cloudId ? [
            ...$8599af293a85f3b3$var$baseProviders(serviceBaseUrl),
            {
                url: `${serviceBaseUrl}/emoji/${cloudId}/site`
            }
        ] : $8599af293a85f3b3$var$baseProviders(serviceBaseUrl);
        const emojiResource = new (0, $cNjCa.default)({
            providers: providers,
            allowUpload: true,
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            currentUser: {
                id: accountId
            }
        });
        return emojiResource.getEmojiProvider({
            fetchAtStart: fetchAtStart
        });
    });
const $8599af293a85f3b3$export$7cda0fc535c2710f = (cloudId, accountId, // fetchAtStart allows you to delay emoji fetching
// however, if it is used in an editor, remember to call `fetchEmojiProvider` on mount
// because typing `:` does not trigger emoji fetching
fetchAtStart = true)=>(0, $9CGZY.getServiceProvider)((0, $9CGZY.EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID), (serviceBaseUrl)=>{
        const providers = cloudId ? [
            ...$8599af293a85f3b3$var$baseProviders(serviceBaseUrl),
            {
                url: `${serviceBaseUrl}/emoji/${cloudId}/site`
            }
        ] : $8599af293a85f3b3$var$baseProviders(serviceBaseUrl);
        const emojiResource = new (0, $cNjCa.default)({
            providers: providers,
            allowUpload: false,
            // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string'.
            currentUser: {
                id: accountId
            }
        });
        return emojiResource.getEmojiProvider({
            fetchAtStart: fetchAtStart
        });
    });
const $8599af293a85f3b3$export$12c2b0bd175ad5c1 = async (emojiProviderPromise)=>{
    (await emojiProviderPromise)?.fetchEmojiProvider();
};

});
parcelRegister("cNjCa", function(module, exports) {

$parcel$export(module.exports, "supportsUploadFeature", () => $00e6588e83f92f0d$export$7b697b720032fd6f);
$parcel$export(module.exports, "default", () => $00e6588e83f92f0d$export$2e2bcd8739ae039);

var $ddgvn = parcelRequire("ddgvn");

var $aGRkq = parcelRequire("aGRkq");

var $5fQjB = parcelRequire("5fQjB");

var $70f7p = parcelRequire("70f7p");

var $7r41D = parcelRequire("7r41D");

var $eyWYN = parcelRequire("eyWYN");

var $ay51d = parcelRequire("ay51d");

var $d6Z3Q = parcelRequire("d6Z3Q");

var $5LKAR = parcelRequire("5LKAR");

var $2AeLS = parcelRequire("2AeLS");

var $fSL8m = parcelRequire("fSL8m");
const $00e6588e83f92f0d$export$7b697b720032fd6f = (emojiProvider)=>{
    const emojiUploadProvider = emojiProvider;
    return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
};
class $00e6588e83f92f0d$export$b5efafc6dd611ec5 extends (0, $ddgvn.AbstractResource) {
    constructor(config){
        super(), this.activeLoaders = 0, this.initialLoaders = 0, this.retries = new Map(), this.isInitialised = false, this.fetchOnDemand = false, this.getOptimisticImageURL = (emojiId)=>{
            if (this.emojiProviderConfig.optimisticImageApi) return this.emojiProviderConfig.optimisticImageApi.getUrl(emojiId);
            return;
        }, this.isRepositoryAvailable = (repository)=>{
            return !!repository;
        }, this.isLoaded = ()=>this.initialLoaders !== 0 && this.activeLoaders === 0;
        this.emojiProviderConfig = config;
        this.recordConfig = config.recordConfig;
        this.currentUser = config.currentUser;
        if ((0, $7r41D.default)('localStorage')) this.selectedTone = this.loadStoredTone();
        if (config.providers.length === 0) throw new Error('No providers specified');
        this.fetchOnDemand = !!config.options && !!config.options.onlyFetchOnDemand;
        this.initialLoaders = this.emojiProviderConfig.providers.length;
        this.activeLoaders = this.emojiProviderConfig.providers.length;
        this.emojiResponses = [];
    }
    /**
	 * Get the emoji provider from Emoji Resource
	 * @returns Promise<EmojiProvider>
	 */ async getEmojiProvider(options = {
        fetchAtStart: !this.fetchOnDemand
    }) {
        if (options.fetchAtStart) try {
            await this.fetchEmojiProvider();
        } catch (error) {
            (0, $5fQjB.default)(error);
            return Promise.resolve(this);
        }
        return Promise.resolve(this);
    }
    async fetchIndividualProvider(provider, index) {
        const providerType = this.getProviderType(provider);
        try {
            (0, $2AeLS.sampledUfoEmojiResourceFetched)(providerType).start({
                samplingRate: (0, $aGRkq.SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP)
            });
            (0, $2AeLS.sampledUfoEmojiResourceFetched)(providerType).addMetadata({
                type: providerType
            });
            const loader = new (0, $ay51d.default)(provider);
            // fetch emoji from provider url and denormalise
            const emojiResponse = await loader.loadEmoji();
            (0, $2AeLS.sampledUfoEmojiResourceFetched)(providerType).success();
            // setup emoji repository
            this.emojiResponses[index] = emojiResponse;
            this.initEmojiRepository(this.emojiResponses);
            await this.initSiteEmojiResource(emojiResponse, provider);
            this.activeLoaders--;
            this.performRetries();
            this.refreshLastFilter();
        } catch (error) {
            this.activeLoaders--;
            this.notifyError(error);
            (0, $2AeLS.sampledUfoEmojiResourceFetched)(providerType).failure({
                metadata: {
                    reason: error,
                    source: 'EmojiProvider',
                    providerUrl: provider.url
                }
            });
            (0, $5fQjB.default)(`failed to fetch emoji provider for ${provider.url}`, error);
            throw new Error(`failed to fetch emoji from ${provider.url}`);
        }
    }
    async fetchEmojiProvider(force = false) {
        // unless (re-)fetch is being forced, fetching will only
        // happen if no emojiRepository exists
        // in case this method is called and emojiRepository has already been populated
        // the method will just return the existing emojiRepository
        if (force || !this.isRepositoryAvailable(this.emojiRepository) && !this.isInitialised) {
            this.isInitialised = true;
            this.emojiResponses = [];
            // fetch emoji providers
            await Promise.all(this.emojiProviderConfig.providers.map((provider, index)=>this.fetchIndividualProvider(provider, index)));
        }
        return Promise.resolve(this.emojiRepository);
    }
    onlyFetchOnDemand() {
        return this.fetchOnDemand;
    }
    async fetchByEmojiId(emojiId, optimistic) {
        // Check if repository exists and emoji is defined.
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) {
            const emoji = await this.findByEmojiId(emojiId);
            if (emoji) return await this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
        }
        // If optimistic is fetched
        if (this.emojiProviderConfig.singleEmojiApi && optimistic) {
            // if config has singleEmojiApi then fetch single emoji
            const provider = {
                url: this.emojiProviderConfig.singleEmojiApi.getUrl(emojiId),
                securityProvider: this.emojiProviderConfig.singleEmojiApi.securityProvider
            };
            const loader = new (0, $ay51d.default)(provider);
            try {
                const loadEmoji = await loader.loadEmoji();
                if (!loadEmoji.emojis[0]) return;
                if (!this.isRepositoryAvailable(this.siteEmojiResource)) await this.initSiteEmojiResource(loadEmoji, provider);
                return this.getMediaEmojiDescriptionURLWithInlineToken(loadEmoji.emojis[0]);
            } catch  {
                const emoji = await this.findByEmojiId(emojiId);
                if (!emoji) return;
                return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
            }
        }
        const emoji = await this.findByEmojiId(emojiId);
        if (!emoji) return;
        return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
    }
    getProviderType(provider) {
        if (provider.url.includes('/site')) return (0, $eyWYN.ProviderTypes).SITE;
        else if (provider.url.includes('/standard')) return (0, $eyWYN.ProviderTypes).STANDARD;
        else if (provider.url.includes('/atlassian')) return (0, $eyWYN.ProviderTypes).ATLASSIAN;
        return (0, $eyWYN.ProviderTypes).UNKNOWN;
    }
    initEmojiRepository(emojiResponses) {
        let emojis = [];
        emojiResponses.forEach((emojiResponse)=>{
            emojis = emojis.concat(emojiResponse.emojis);
        });
        this.emojiRepository = new (0, $d6Z3Q.default)(emojis);
    }
    initSiteEmojiResource(emojiResponse, provider) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) && emojiResponse.mediaApiToken) {
            this.siteEmojiResource = new (0, $5LKAR.default)(provider, emojiResponse.mediaApiToken);
            // Prime cache type + optimistic rendering by checking first Emoji.
            // If this is fails, it won't be primed until a good emoji is loaded later.
            const { emojis: emojis } = emojiResponse;
            if (emojis.length) {
                const done = this.siteEmojiResource.optimisticRendering(emojis[0]);
                if ((0, $70f7p.isPromise)(done)) return done.then(()=>{
                    (0, $5fQjB.default)('Primed siteEmojiResource');
                }).catch(()=>{
                    (0, $5fQjB.default)('Failed to prime siteEmojiResource');
                });
                else (0, $5fQjB.default)('Already primed siteEmojiResource');
            } else (0, $5fQjB.default)('No emoji to prime siteEmojiResource with');
        }
        return Promise.resolve();
    }
    performRetries() {
        const currentRetries = this.retries;
        this.retries = new Map();
        currentRetries.forEach((resolveReject, retry)=>{
            const result = retry();
            if ((0, $70f7p.isPromise)(result)) result.then((response)=>{
                resolveReject.resolve(response);
            }).catch((reason)=>{
                resolveReject.reject(reason);
            });
            else resolveReject.resolve(result);
        });
    }
    loadStoredTone() {
        if (typeof window === 'undefined') return undefined;
        const storedToneString = window.localStorage.getItem((0, $aGRkq.selectedToneStorageKey));
        if (storedToneString) {
            const storedTone = parseInt(storedToneString, 10);
            return !isNaN(storedTone) ? storedTone : undefined;
        }
        return undefined;
    }
    refreshLastFilter() {
        if (typeof this.lastQuery !== 'undefined') {
            const { query: query, options: options } = this.lastQuery;
            this.filter(query, options);
        }
    }
    retryIfLoading(retry, defaultResponse) {
        if (!this.isLoaded()) return new Promise((resolve, reject)=>{
            this.retries.set(retry, {
                resolve: resolve,
                reject: reject
            });
        });
        return Promise.resolve(defaultResponse);
    }
    notifyResult(result) {
        if (this.lastQuery && result.query === this.lastQuery.query) super.notifyResult(result);
    }
    /**
	 *  Returns the EmojiDescription with a valid media path that includes query token and client attributes to access the emoji media inline.
	 */ async getMediaEmojiDescriptionURLWithInlineToken(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) {
            const { representation: representation, altRepresentation: altRepresentation } = await this.siteEmojiResource.generateTokenisedMediaURLS(emoji.representation, emoji.altRepresentation);
            return {
                ...emoji,
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
        return emoji;
    }
    loadMediaEmoji(emoji, useAlt) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) || !(0, $70f7p.isMediaEmoji)(emoji)) return emoji;
        return this.siteEmojiResource.loadMediaEmoji(emoji, useAlt);
    }
    optimisticMediaRendering(emoji, useAlt) {
        if (!(0, $70f7p.isMediaEmoji)(emoji)) return true;
        if (!this.isRepositoryAvailable(this.siteEmojiResource)) // Shouldn't have a media emoji without a siteEmojiResouce, but anyway ;)
        return false;
        const optimistic = this.siteEmojiResource.optimisticRendering(emoji, useAlt);
        if ((0, $70f7p.isPromise)(optimistic)) // Not sure yet, so lets say no for now (this should normally be primed in most/all cases)
        return false;
        return optimistic;
    }
    filter(query, options) {
        (0, $2AeLS.ufoExperiences)['emoji-searched'].start();
        (0, $2AeLS.ufoExperiences)['emoji-searched'].addMetadata({
            queryLength: query?.length || 0
        });
        this.lastQuery = {
            query: query,
            options: options
        };
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            const searchResults = this.emojiRepository.search(query, options);
            this.notifyResult(searchResults);
            (0, $2AeLS.ufoExperiences)['emoji-searched'].success({
                metadata: {
                    emojisLength: searchResults.emojis.length,
                    source: options?.source || 'typeahead'
                }
            });
        } else // not ready
        this.notifyNotReady();
    }
    findByShortName(shortName) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) // Wait for all emoji to load before looking by shortName (to ensure correct priority)
        return this.emojiRepository.findByShortName(shortName);
        return this.retryIfLoading(()=>this.findByShortName(shortName), undefined);
    }
    findByEmojiId(emojiId) {
        const { id: id, shortName: shortName } = emojiId;
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            if (id) {
                const emoji = this.emojiRepository.findById(id);
                if (emoji) return emoji;
                if (this.isLoaded()) {
                    // all loaded but not found by id, try server to see if
                    // this is a newly uploaded emoji
                    if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.findEmoji(emojiId).then((emoji)=>{
                        if (!emoji) // if not, fallback to searching by shortName to
                        // at least render an alternative
                        return this.findByShortName(shortName);
                        this.addUnknownEmoji(emoji);
                        return emoji;
                    });
                    // if not, fallback to searching by shortName to
                    // at least render an alternative
                    return this.findByShortName(shortName);
                }
            } else // no id fallback to shortName
            return this.findByShortName(shortName);
        }
        return this.retryIfLoading(()=>this.findByEmojiId(emojiId), undefined);
    }
    findById(id) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return this.emojiRepository.findById(id);
        return this.retryIfLoading(()=>this.findById(id), undefined);
    }
    findInCategory(categoryId) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.findInCategory(categoryId));
        return this.retryIfLoading(()=>this.findInCategory(categoryId), []);
    }
    getAsciiMap() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getAsciiMap());
        return this.retryIfLoading(()=>this.getAsciiMap(), new Map());
    }
    getFrequentlyUsed(options) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getFrequentlyUsed(options));
        return this.retryIfLoading(()=>this.getFrequentlyUsed(options), []);
    }
    /**
	 * Record the selection of an emoji to a remote service if 'recordConfig' has been supplied.
	 * Regardless of the recordConfig, emoji selections will always be recorded on the EmojiRepository
	 * for the purposes of tracking the frequency of use.
	 *
	 * @param emoji The full description of the emoji to record usage for.
	 */ recordSelection(emoji) {
        const { recordConfig: recordConfig } = this;
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.used(emoji);
        if (recordConfig) {
            const queryParams = {
                emojiId: (0, $70f7p.toEmojiId)(emoji)
            };
            const requestInit = {
                method: 'POST'
            };
            return (0, $ddgvn.utils).requestService(recordConfig, {
                queryParams: queryParams,
                requestInit: requestInit
            });
        }
        return Promise.resolve();
    }
    deleteSiteEmoji(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource) && emoji.id) return this.siteEmojiResource.deleteEmoji(emoji).then((success)=>{
            if (success && this.isRepositoryAvailable(this.emojiRepository)) {
                this.emojiRepository.delete(emoji);
                return true;
            }
            return false;
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('failed to delete site emoji', err);
            return false;
        });
        return this.retryIfLoading(()=>this.deleteSiteEmoji(emoji), false);
    }
    getSelectedTone() {
        return this.selectedTone;
    }
    setSelectedTone(tone) {
        this.selectedTone = tone;
        if (typeof window === 'undefined') return;
        if ((0, $7r41D.default)('localStorage')) try {
            window.localStorage.setItem((0, $aGRkq.selectedToneStorageKey), tone ? tone.toString() : '');
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('failed to store selected emoji skin tone', e);
        }
    }
    calculateDynamicCategories() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getDynamicCategoryList());
        return this.retryIfLoading(()=>this.calculateDynamicCategories(), []);
    }
    getCurrentUser() {
        return this.currentUser;
    }
    addUnknownEmoji(emoji) {
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.addUnknownEmoji(emoji);
    }
}
class $00e6588e83f92f0d$export$2e2bcd8739ae039 extends $00e6588e83f92f0d$export$b5efafc6dd611ec5 {
    constructor(config){
        super(config);
        this.allowUpload = !!config.allowUpload;
    }
    isUploadSupported() {
        if (!this.allowUpload) return Promise.resolve(false);
        if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.hasUploadToken();
        return this.retryIfLoading(()=>this.isUploadSupported(), false);
    }
    uploadCustomEmoji(upload, retry = false, timeout = 12000) {
        return this.isUploadSupported().then((supported)=>{
            if (!supported || !this.isRepositoryAvailable(this.siteEmojiResource)) return Promise.reject('No media api support is configured');
            const uploadPromise = this.siteEmojiResource.uploadEmoji(upload, retry).then((emoji)=>{
                // Use file preview blob URL to temporarily fix the graybox issue after uploading,
                // Because the media service takes time to process the image.
                // Ideally should improve CachingMediaImage by using mediaClient or mediaImage,
                // But that requires more efforts in FE & BE.
                // TODO: revist this when pick up COLLAB-2294
                emoji.representation.imagePath = upload.dataURL;
                this.addUnknownEmoji(emoji);
                this.refreshLastFilter();
                return emoji;
            });
            return (0, $fSL8m.promiseWithTimeout)(uploadPromise, timeout, 'uploadCustomEmoji timed out');
        });
    }
    prepareForUpload() {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) this.siteEmojiResource.prepareForUpload();
        return this.retryIfLoading(()=>this.prepareForUpload(), undefined);
    }
}

});
parcelRegister("aGRkq", function(module, exports) {

$parcel$export(module.exports, "customCategory", () => $7c05402a19db203c$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $7c05402a19db203c$export$78ccdc4be403c468);
$parcel$export(module.exports, "searchCategory", () => $7c05402a19db203c$export$1b0258512be88334);
$parcel$export(module.exports, "yourUploadsCategory", () => $7c05402a19db203c$export$42b510423367f354);
$parcel$export(module.exports, "customTitle", () => $7c05402a19db203c$export$5d0f2d8ee50f86f5);
$parcel$export(module.exports, "userCustomTitle", () => $7c05402a19db203c$export$1debc2f10cc69389);
$parcel$export(module.exports, "dataURLPrefix", () => $7c05402a19db203c$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $7c05402a19db203c$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $7c05402a19db203c$export$1a817f1886276c6d);
$parcel$export(module.exports, "defaultEmojiHeight", () => $7c05402a19db203c$export$3f99ac31dc0406db);
$parcel$export(module.exports, "emojiPickerWidth", () => $7c05402a19db203c$export$d171dc12fee2b1da);
$parcel$export(module.exports, "sizeGap", () => $7c05402a19db203c$export$c10ac8125a260041);
$parcel$export(module.exports, "defaultEmojiPickerSize", () => $7c05402a19db203c$export$5248fb9e0cccc41f);
$parcel$export(module.exports, "emojiPickerListHeight", () => $7c05402a19db203c$export$7722b8e9522021df);
$parcel$export(module.exports, "localStoragePrefix", () => $7c05402a19db203c$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $7c05402a19db203c$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "defaultCategories", () => $7c05402a19db203c$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $7c05402a19db203c$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "KeyboardNavigationDirection", () => $7c05402a19db203c$export$1c4f2adc1f8e19d3);
$parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $7c05402a19db203c$export$99130b698ea188ae);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $7c05402a19db203c$export$84b035f8d01101cc);
$parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $7c05402a19db203c$export$e27d4e477c0cd4ec);
$parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", () => $7c05402a19db203c$export$97027974dc06eeee);
$parcel$export(module.exports, "DEFAULT_TONE", () => $7c05402a19db203c$export$4f0ee90b28d6efc5);
$parcel$export(module.exports, "EMOJI_LIST_COLUMNS", () => $7c05402a19db203c$export$2829f3ec323f8ec0);
$parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", () => $7c05402a19db203c$export$ce3a0e7d2d7d6ba2);
$parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", () => $7c05402a19db203c$export$858e8dc100a97278);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $7c05402a19db203c$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $7c05402a19db203c$export$66cabad5e268b05e);
const $7c05402a19db203c$export$5e4e3d1c3e43156a = 'CUSTOM';
const $7c05402a19db203c$export$78ccdc4be403c468 = 'FREQUENT';
const $7c05402a19db203c$export$2c4b04c3aacdf1b3 = 'SITE';
const $7c05402a19db203c$export$1b0258512be88334 = 'SEARCH';
const $7c05402a19db203c$export$42b510423367f354 = 'USER_CUSTOM';
const $7c05402a19db203c$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
const $7c05402a19db203c$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
const $7c05402a19db203c$export$8ac325bfd32359b0 = 'data:';
const $7c05402a19db203c$export$a330961542edfe6f = 'delete-emoji';
const $7c05402a19db203c$export$1a817f1886276c6d = 100000;
const $7c05402a19db203c$export$3f99ac31dc0406db = 20;
const $7c05402a19db203c$export$d171dc12fee2b1da = 350;
const $7c05402a19db203c$export$c10ac8125a260041 = 80;
const $7c05402a19db203c$export$5248fb9e0cccc41f = 'medium';
const $7c05402a19db203c$export$94f75d625e7801d3 = 260;
const $7c05402a19db203c$export$7ed599d166d65aea = 295;
const $7c05402a19db203c$export$7722b8e9522021df = $7c05402a19db203c$export$7ed599d166d65aea - 58; // picker height - actions height
const $7c05402a19db203c$export$e218e5cb105a0e22 = 54;
const $7c05402a19db203c$export$e67f617938b111f1 = $7c05402a19db203c$export$7ed599d166d65aea + $7c05402a19db203c$export$e218e5cb105a0e22;
const $7c05402a19db203c$export$e394a0c530ae5631 = 'fabric.emoji';
const $7c05402a19db203c$export$79ee4ef84c545f8f = `${$7c05402a19db203c$export$e394a0c530ae5631}.selectedTone`;
const $7c05402a19db203c$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $7c05402a19db203c$export$70f9e5bc10d7eac = /*#__PURE__*/ function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
    return KeyboardKeys;
}({});
var $7c05402a19db203c$export$1c4f2adc1f8e19d3 = /*#__PURE__*/ function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
    return KeyboardNavigationDirection;
}({});
const $7c05402a19db203c$export$99130b698ea188ae = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End"
];
const $7c05402a19db203c$export$84b035f8d01101cc = [
    "Enter",
    "Backspace",
    " "
];
const $7c05402a19db203c$export$e27d4e477c0cd4ec = [
    "Enter",
    "Tab",
    " "
];
const $7c05402a19db203c$export$97027974dc06eeee = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End",
    "ArrowUp",
    "ArrowDown",
    "PageUp",
    "PageDown"
];
const $7c05402a19db203c$export$4f0ee90b28d6efc5 = 0;
const $7c05402a19db203c$export$9f7de4293d27f3aa = 50;
const $7c05402a19db203c$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
const $7c05402a19db203c$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
const $7c05402a19db203c$export$2829f3ec323f8ec0 = 8;
const $7c05402a19db203c$export$ce3a0e7d2d7d6ba2 = 5;
const $7c05402a19db203c$export$858e8dc100a97278 = 150;
const $7c05402a19db203c$export$83aab2ae64548423 = 20;
const $7c05402a19db203c$export$66cabad5e268b05e = 100;

});

parcelRegister("5fQjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3228ee3c6e22b3a$export$2e2bcd8739ae039);
let $c3228ee3c6e22b3a$var$debugEnabled = false;
let $c3228ee3c6e22b3a$var$stacktracesEnabled = false;
function $c3228ee3c6e22b3a$export$748ada60eaf985cc(enable) {
    $c3228ee3c6e22b3a$var$debugEnabled = enable;
}
function $c3228ee3c6e22b3a$export$4f7017086af31c25(enable) {
    $c3228ee3c6e22b3a$var$stacktracesEnabled = enable;
}
function $c3228ee3c6e22b3a$export$2a858f450a2f66d() {
    if ($c3228ee3c6e22b3a$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $c3228ee3c6e22b3a$export$2e2bcd8739ae039(msg, ...args) {
    if ($c3228ee3c6e22b3a$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("70f7p", function(module, exports) {

$parcel$export(module.exports, "isSpriteServiceRepresentation", () => $bea063d0707cb4e1$export$1c52f72b88b558e8);
$parcel$export(module.exports, "isSpriteRepresentation", () => $bea063d0707cb4e1$export$a194199d673d75de);
$parcel$export(module.exports, "isImageRepresentation", () => $bea063d0707cb4e1$export$90b099a26fbd8b41);
$parcel$export(module.exports, "isMediaRepresentation", () => $bea063d0707cb4e1$export$979133dc1df141c6);
$parcel$export(module.exports, "isPromise", () => $bea063d0707cb4e1$export$4369c812aac99591);
$parcel$export(module.exports, "isEmojiDescription", () => $bea063d0707cb4e1$export$378ed2c87d03531c);
$parcel$export(module.exports, "isMediaEmoji", () => $bea063d0707cb4e1$export$a7e82c67204c73a1);
$parcel$export(module.exports, "isLoadedMediaEmoji", () => $bea063d0707cb4e1$export$d25a80b2c86d7fdf);
$parcel$export(module.exports, "isEmojiDescriptionWithVariations", () => $bea063d0707cb4e1$export$b0ed6d8df471f3cc);
$parcel$export(module.exports, "isEmojiVariationDescription", () => $bea063d0707cb4e1$export$82a0350e1f6b5c0a);
$parcel$export(module.exports, "isMessagesKey", () => $bea063d0707cb4e1$export$dddfba07c16c94d2);
$parcel$export(module.exports, "toEmojiId", () => $bea063d0707cb4e1$export$8d7d3de6b5b305d1);
$parcel$export(module.exports, "containsEmojiId", () => $bea063d0707cb4e1$export$39ed0ad389e58ef7);
$parcel$export(module.exports, "convertImageToMediaRepresentation", () => $bea063d0707cb4e1$export$20a1bd1d33069ce7);
$parcel$export(module.exports, "convertMediaToImageEmoji", () => $bea063d0707cb4e1$export$f1a89a11f425faaa);
$parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", () => $bea063d0707cb4e1$export$a48c58c688a3131);
$parcel$export(module.exports, "getCategoryId", () => $bea063d0707cb4e1$export$4bcbf61cb6832a8e);

var $hbAJx = parcelRequire("hbAJx");

var $aGRkq = parcelRequire("aGRkq");
const $bea063d0707cb4e1$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);
const $bea063d0707cb4e1$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
const $bea063d0707cb4e1$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);
const $bea063d0707cb4e1$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);
const $bea063d0707cb4e1$export$4369c812aac99591 = (p)=>!!(p && p.then);
const $bea063d0707cb4e1$export$378ed2c87d03531c = (possibleEmojiDescription)=>possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
const $bea063d0707cb4e1$export$a7e82c67204c73a1 = (emoji)=>$bea063d0707cb4e1$export$979133dc1df141c6(emoji.representation);
const $bea063d0707cb4e1$export$7720a4954d6f75f8 = (rep)=>$bea063d0707cb4e1$export$90b099a26fbd8b41(rep) && rep.imagePath.indexOf((0, $aGRkq.dataURLPrefix)) === 0;
const $bea063d0707cb4e1$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, $aGRkq.customCategory) && $bea063d0707cb4e1$export$7720a4954d6f75f8(emoji.representation);
const $bea063d0707cb4e1$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);
const $bea063d0707cb4e1$export$82a0350e1f6b5c0a = (object)=>{
    return 'baseId' in object;
};
const $bea063d0707cb4e1$export$dddfba07c16c94d2 = (key)=>key in (0, $hbAJx.messages);
const $bea063d0707cb4e1$export$8d7d3de6b5b305d1 = (emoji)=>({
        shortName: emoji.shortName,
        id: emoji.id,
        fallback: emoji.fallback
    });
const $bea063d0707cb4e1$export$2dbfa5a5d35af350 = (emoji)=>{
    if (!emoji) return undefined;
    return $bea063d0707cb4e1$export$8d7d3de6b5b305d1(emoji);
};
const $bea063d0707cb4e1$export$92ad509d7c96b723 = (l, r)=>l === r || l && r && l.id === r.id && l.shortName === r.shortName;
const $bea063d0707cb4e1$export$39ed0ad389e58ef7 = (emojis, emojiId)=>{
    if (!emojiId) return false;
    for(let i = 0; i < emojis.length; i++){
        if ($bea063d0707cb4e1$export$92ad509d7c96b723(emojis[i], emojiId)) return true;
    }
    return false;
};
const $bea063d0707cb4e1$export$20a1bd1d33069ce7 = (rep)=>({
        mediaPath: rep.imagePath,
        height: rep.height,
        width: rep.width
    });
const $bea063d0707cb4e1$export$3197405d49d2e298 = (rep, newImagePath)=>({
        imagePath: newImagePath || rep.mediaPath,
        height: rep.height,
        width: rep.width
    });
const $bea063d0707cb4e1$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
    const mediaRepresentation = emoji.representation;
    const mediaAltRepresentation = emoji.altRepresentation;
    const imgPath = !useAlt ? newImagePath : undefined;
    const altImgPath = useAlt ? newImagePath : undefined;
    if (!$bea063d0707cb4e1$export$979133dc1df141c6(mediaRepresentation) && !$bea063d0707cb4e1$export$979133dc1df141c6(mediaAltRepresentation)) return emoji;
    const representation = $bea063d0707cb4e1$export$979133dc1df141c6(mediaRepresentation) ? $bea063d0707cb4e1$export$3197405d49d2e298(mediaRepresentation, imgPath) : mediaRepresentation;
    const altRepresentation = $bea063d0707cb4e1$export$979133dc1df141c6(mediaAltRepresentation) ? $bea063d0707cb4e1$export$3197405d49d2e298(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
    const baseEmoji = {
        ...emoji,
        representation: representation
    };
    return $bea063d0707cb4e1$export$a48c58c688a3131(baseEmoji, altRepresentation);
};
const $bea063d0707cb4e1$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
    if (!altRepresentation) return emoji;
    return {
        ...emoji,
        altRepresentation: altRepresentation
    };
};
const $bea063d0707cb4e1$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;

});
parcelRegister("hbAJx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $932ede6470a85285$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $932ede6470a85285$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    deleteEmojiTooltip: {
        id: 'fabric.emoji.delete.tooltip',
        defaultMessage: 'Delete',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTooltipForScreenreader: {
        id: 'fabric.emoji.delete.screenreader.tooltip',
        defaultMessage: 'To delete {shortName} emoji, press Backspace',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Title for emoji removal dialog'
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Description for emoji removal dialog'
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Button label to remove emoji'
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Button label to add custom emoji'
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'e.g. hello',
        description: 'Placeholder for emoji that provides an example for emoji name'
    },
    emojiNameAriaLabel: {
        id: 'fabric.emoji.name.ariaLabel',
        defaultMessage: 'Enter a name for the new emoji',
        description: 'Explains to enter a name for a new emoji'
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Choose custom emoji file'
    },
    emojiChooseFileScreenReaderDescription: {
        id: 'fabric.emoji.choose.file.screenReaderDescription',
        defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
        description: 'Message indicating the purpose of choosing the file and requirements for the file'
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: 'fabric.emoji.select.skin.tone.ariaLabel',
        defaultMessage: 'Choose your skin tone, {selectedTone} selected',
        description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: 'fabric.emoji.select.skin.list.ariaLabel',
        defaultMessage: 'Skin tone selector',
        description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size'
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Emoji preview title'
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Emoji preview'
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'verb - Button label to add emoji'
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'verb - Button label to retry upload'
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'verb - button label to cancel operation'
    },
    searchPlaceholder: {
        id: 'fabric.emoji.search.placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder for search emoji field'
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Emoji name',
        description: 'verb - button label to search'
    },
    /*
	searchResultsStatus: {
		id: 'fabric.emoji.search.status',
		defaultMessage: 'Found {count} emojis',
		description: 'search results status for screenreader to read out',
	},
	 */ searchResultsStatusSeeAll: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Seeing all emojis',
        description: 'search results status when no search query for screenreader to read out'
    },
    categoriesSelectorLabel: {
        id: 'fabric.emoji.categories.label',
        defaultMessage: 'Choose an emoji category',
        description: 'Aria label for Emoji categories selector at the top of emoji picker'
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Emoji categories search results'
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Emoji frequent category'
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Emoji frequent category'
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Emoji nature category'
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Emoji Foods category'
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Emoji activity category'
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Emoji Places category'
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Emoji objects category'
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Emoji symbols category'
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Emoji flags category'
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Productivity',
        description: 'Emoji productivity category'
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'User uploads in the custom category'
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'All uploads in the custom category'
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed'
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image'
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Failed to upload emoji image'
    },
    emojiUploadTimeout: {
        id: 'fabric.emoji.error.upload.timeout',
        defaultMessage: 'Upload timed out',
        description: 'Failed to upload emoji image'
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit'
    },
    emojiPickerTitle: {
        id: 'fabric.emoji.picker',
        defaultMessage: 'Emoji picker',
        description: 'Aria label for emoji picker'
    },
    emojiPickerListPanel: {
        id: 'fabric.emoji.pickerlist.tabpanel',
        defaultMessage: 'Emojis actions and list panel',
        description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
    },
    emojiPickerGrid: {
        id: 'fabric.emoji.pickerlist.grid',
        defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
        description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
    },
    emojiButtonRoleDescription: {
        id: 'fabric.emoji.emojipicker.emoi.roledescription',
        defaultMessage: 'emoji button',
        description: `Aria roledescription for emoji button, used in emoji picker.`
    },
    error: {
        id: 'fabric.emoji.emojipicker.error',
        defaultMessage: 'Error!',
        description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
    }
});

});


parcelRegister("7r41D", function(module, exports) {

$parcel$export(module.exports, "default", () => $1db13e45618c1984$export$2e2bcd8739ae039);
function $1db13e45618c1984$export$2e2bcd8739ae039(type) {
    if (typeof window === 'undefined') return false;
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && // everything except Firefox
        (e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' || // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
    }
}

});

parcelRegister("eyWYN", function(module, exports) {

$parcel$export(module.exports, "SearchSort", () => $f70c643b418346ab$export$a15e9a4340d08b2e);
$parcel$export(module.exports, "SearchSourceTypes", () => $f70c643b418346ab$export$db41220f541db607);
$parcel$export(module.exports, "ProviderTypes", () => $f70c643b418346ab$export$bf337c9223e5c8b);
$parcel$export(module.exports, "UfoExperienceName", () => $f70c643b418346ab$export$d0d1c9cd31a11a64);
$parcel$export(module.exports, "UfoComponentName", () => $f70c643b418346ab$export$122ce5c8fda96269);
$parcel$export(module.exports, "UfoEmojiTimingsKeys", () => $f70c643b418346ab$export$265ee18146a6885e);
$parcel$export(module.exports, "UfoEmojiTimings", () => $f70c643b418346ab$export$482549d945a3723);
var $f70c643b418346ab$export$a15e9a4340d08b2e = /*#__PURE__*/ function(SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
    return SearchSort;
}({});
var $f70c643b418346ab$export$db41220f541db607 = /*#__PURE__*/ function(SearchSourceTypes) {
    SearchSourceTypes["PICKER"] = "picker";
    SearchSourceTypes["TYPEAHEAD"] = "typeahead";
    return SearchSourceTypes;
}({});
var $f70c643b418346ab$export$bf337c9223e5c8b = /*#__PURE__*/ function(ProviderTypes) {
    ProviderTypes["SITE"] = "SITE";
    ProviderTypes["STANDARD"] = "STANDARD";
    ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
    ProviderTypes["UNKNOWN"] = "UNKNOWN";
    ProviderTypes["SINGLE"] = "SINGLE";
    return ProviderTypes;
}({});
var $f70c643b418346ab$export$d0d1c9cd31a11a64 = /*#__PURE__*/ function(UfoExperienceName) {
    UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
    UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
    UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
    UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
    UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
    UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
    return UfoExperienceName;
}({});
var $f70c643b418346ab$export$122ce5c8fda96269 = /*#__PURE__*/ function(UfoComponentName) {
    UfoComponentName["EMOJI"] = "emoji";
    UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
    UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
    return UfoComponentName;
}({});
var $f70c643b418346ab$export$265ee18146a6885e = /*#__PURE__*/ function(UfoEmojiTimingsKeys) {
    UfoEmojiTimingsKeys["FMP"] = "fmp";
    UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
    UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
    UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
    UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
    return UfoEmojiTimingsKeys;
}({});
var $f70c643b418346ab$export$482549d945a3723 = /*#__PURE__*/ function(UfoEmojiTimings) {
    UfoEmojiTimings["FMP_END"] = "fmp";
    UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
    UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
    UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
    UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
    UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
    UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
    UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
    return UfoEmojiTimings;
}({});

});

parcelRegister("ay51d", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8225b0289ed811d$export$2e2bcd8739ae039);

var $2Tr6g = parcelRequire("2Tr6g");
class $d8225b0289ed811d$export$2e2bcd8739ae039 {
    constructor(config){
        this.config = config;
    }
    /**
	 * Returns a promise with an array of Emoji from all providers.
	 */ loadEmoji() {
        const emojisPromise = (0, $2Tr6g.emojiRequest)(this.config);
        return emojisPromise.then((emojiServiceResponse)=>(0, $2Tr6g.denormaliseEmojiServiceResponse)(emojiServiceResponse));
    }
}

});
parcelRegister("2Tr6g", function(module, exports) {

$parcel$export(module.exports, "emojiRequest", () => $cb76297f93cdfcd1$export$ea1accde4cc117f4);
$parcel$export(module.exports, "getAltRepresentation", () => $cb76297f93cdfcd1$export$4a0301d636367e1d);
$parcel$export(module.exports, "denormaliseEmojiServiceResponse", () => $cb76297f93cdfcd1$export$afaea97e40b5ca70);
$parcel$export(module.exports, "shouldUseAltRepresentation", () => $cb76297f93cdfcd1$export$b7e9058f156d8d19);

var $ddgvn = parcelRequire("ddgvn");

var $70f7p = parcelRequire("70f7p");

var $5fQjB = parcelRequire("5fQjB");
const $cb76297f93cdfcd1$export$ea1accde4cc117f4 = (provider, options)=>{
    const { getRatio: getRatio = $cb76297f93cdfcd1$export$d39ce20a37bba061, ...serviceConfig } = provider;
    const scaleQueryParams = $cb76297f93cdfcd1$var$calculateScale(getRatio);
    const { queryParams: queryParams = {}, ...otherOptions } = options || {};
    const requestOptions = {
        ...otherOptions,
        queryParams: {
            ...scaleQueryParams,
            ...queryParams,
            preferredRepresentation: 'IMAGE'
        }
    };
    return (0, $ddgvn.utils).requestService(serviceConfig, requestOptions);
};
const $cb76297f93cdfcd1$var$calculateScale = (getRatio)=>{
    // Retina display
    if (getRatio() > 1) return {
        scale: 'XHDPI',
        altScale: 'XXXHDPI'
    };
    // Default set used for desktop
    return {
        altScale: 'XHDPI'
    };
};
const $cb76297f93cdfcd1$export$d39ce20a37bba061 = ()=>{
    if (typeof window === 'undefined') return 0;
    return window.devicePixelRatio;
};
const $cb76297f93cdfcd1$export$4a0301d636367e1d = (reps)=>{
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[$cb76297f93cdfcd1$var$calculateScale($cb76297f93cdfcd1$export$d39ce20a37bba061).altScale];
};
const $cb76297f93cdfcd1$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
const $cb76297f93cdfcd1$export$55077db3efc820aa = (representation, meta)=>{
    if ((0, $70f7p.isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
        const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
        const spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) return {
            sprite: spriteSheet,
            height: height,
            width: width,
            x: x,
            y: y,
            xIndex: xIndex,
            yIndex: yIndex
        };
    } else if ((0, $70f7p.isImageRepresentation)(representation)) {
        const { height: height, width: width, imagePath: imagePath } = representation;
        if ($cb76297f93cdfcd1$export$db05e6ae1fd416af(imagePath, meta)) return (0, $70f7p.convertImageToMediaRepresentation)(representation);
        return {
            height: height,
            width: width,
            imagePath: imagePath
        };
    }
    (0, $5fQjB.default)('failed conversion for representation', representation, meta);
    return undefined;
};
const $cb76297f93cdfcd1$export$aa9faa01267cb2e7 = (altReps, meta)=>{
    return !altReps || Object.keys(altReps).length === 0 ? undefined : $cb76297f93cdfcd1$export$55077db3efc820aa($cb76297f93cdfcd1$export$4a0301d636367e1d(altReps), meta);
};
const $cb76297f93cdfcd1$export$e3da49c88c2e54d5 = (emoji, meta)=>{
    if (!emoji.skinVariations) return [];
    const skinEmoji = emoji.skinVariations;
    const baseId = emoji.id;
    return skinEmoji.map((skin)=>{
        const { representation: representation, altRepresentations: altRepresentations, ...other } = skin;
        return {
            baseId: baseId,
            representation: $cb76297f93cdfcd1$export$55077db3efc820aa(representation, meta),
            altRepresentation: $cb76297f93cdfcd1$export$aa9faa01267cb2e7(altRepresentations, meta),
            ...other
        };
    });
};
const $cb76297f93cdfcd1$export$afaea97e40b5ca70 = (emojiData)=>{
    const emojis = emojiData.emojis.map((emoji)=>{
        const newRepresentation = $cb76297f93cdfcd1$export$55077db3efc820aa(emoji.representation, emojiData.meta);
        const altRepresentation = $cb76297f93cdfcd1$export$aa9faa01267cb2e7(emoji.altRepresentations, emojiData.meta);
        const newSkinVariations = $cb76297f93cdfcd1$export$e3da49c88c2e54d5(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        const { representation: representation, skinVariations: skinVariations, altRepresentations: altRepresentations, ...trimmedServiceDesc } = emoji;
        const response = {
            ...trimmedServiceDesc,
            representation: newRepresentation,
            skinVariations: newSkinVariations
        };
        return (0, $70f7p.buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
    });
    const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken
    };
};
const $cb76297f93cdfcd1$var$getHeight = (fitToHeight)=>$cb76297f93cdfcd1$export$d39ce20a37bba061() > 1 ? fitToHeight * 2 : fitToHeight;
const $cb76297f93cdfcd1$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && $cb76297f93cdfcd1$var$getHeight(fitToHeight) > emoji.representation.height);

});


parcelRegister("d6Z3Q", function(module, exports) {

$parcel$export(module.exports, "getEmojiVariation", () => $4773145f9c90b36b$export$e55e46e1520c899d);
$parcel$export(module.exports, "default", () => $4773145f9c90b36b$export$2e2bcd8739ae039);

var $a6GlY = parcelRequire("a6GlY");

var $aGRkq = parcelRequire("aGRkq");

var $70f7p = parcelRequire("70f7p");

var $eyWYN = parcelRequire("eyWYN");

var $fdPb9 = parcelRequire("fdPb9");

var $cBLND = parcelRequire("cBLND");

var $1vUe1 = parcelRequire("1vUe1");

var $fHpHg = parcelRequire("fHpHg");
// FS-1097 - duplicated in mentions - extract at some point into a shared library
class $4773145f9c90b36b$var$Tokenizer {
    tokenize(text) {
        return this.tokenizeAsTokens(text).map((token)=>token.token);
    }
    tokenizeAsTokens(text) {
        let match;
        let tokens = [];
        (0, $fdPb9.tokenizerRegex).lastIndex = 0;
        while((match = (0, $fdPb9.tokenizerRegex).exec(text)) !== null)if (match[0]) tokens.push({
            token: match[0],
            start: match.index
        });
        return tokens;
    }
}
const $4773145f9c90b36b$var$addAllVariants = (emoji, fnKey, map)=>{
    const key = fnKey(emoji);
    if (!map.has(key)) map.set(key, []);
    const emojisForKey = map.get(key);
    // Unnecessary, but typescript thinks it is. :/
    if (emojisForKey) emojisForKey.push(emoji);
    if ((0, $70f7p.isEmojiDescriptionWithVariations)(emoji)) {
        // map variations too
        const variations = emoji.skinVariations;
        if (variations) variations.forEach((variation)=>$4773145f9c90b36b$var$addAllVariants(variation, fnKey, map));
    }
};
const $4773145f9c90b36b$var$findByKey = (map, key)=>{
    const emojis = map.get(key);
    if (emojis && emojis.length) // Priority is always to source from the last emoji set (last overrides first)
    return emojis[emojis.length - 1];
    return undefined;
};
const $4773145f9c90b36b$var$splitQuery = (query = '')=>{
    const isColonQuery = query.indexOf(':') === 0;
    if (isColonQuery) return {
        nameQuery: query.slice(1),
        asciiQuery: query
    };
    return {
        nameQuery: query,
        asciiQuery: ''
    };
};
const $4773145f9c90b36b$export$e55e46e1520c899d = (emoji, options)=>{
    if ((0, $70f7p.isEmojiDescriptionWithVariations)(emoji) && options) {
        const skinTone = options.skinTone;
        if (skinTone && emoji.skinVariations && emoji.skinVariations.length) {
            const skinToneEmoji = emoji.skinVariations[skinTone - 1]; // skinTone start at 1
            if (skinToneEmoji) return skinToneEmoji;
        }
    }
    return emoji;
};
const $4773145f9c90b36b$var$findEmojiIndex = (emojis, toFind)=>{
    const findId = toFind.id;
    let match = -1;
    emojis.forEach((emoji, index)=>{
        // Match if ID is defined and are equal
        // Or both have no id and shortnames match
        if (emoji.id && emoji.id === findId || !emoji.id && !findId && emoji.shortName === toFind.shortName) {
            match = index;
            return;
        }
    });
    return match;
};
class $4773145f9c90b36b$export$2e2bcd8739ae039 {
    static{
        this.defaultEmojiWeight = 1000000;
    }
    constructor(emojis, usageTracker){
        this.fullSearchReady = false;
        this.emojis = emojis;
        this.initMembers(usageTracker);
    }
    /**
	 * Returns all available (and searchable) emoji in some default order.
	 */ all() {
        const options = {
            sort: (0, $eyWYN.SearchSort).None
        };
        return this.search('', options);
    }
    /**
	 * Text search of emoji shortName and name field for suitable matches.
	 *
	 * Returns an array of all (searchable) emoji if query is empty or null, otherwise returns matching emoji.
	 *
	 * You can change how the results are sorted by specifying a custom EmojiComparator in the SearchOptions. If
	 * you don't want any sorting you can also disable via the SearchOptions (this might be a useful optimisation).
	 * If no sort is specified in SearchOptions then a default sorting it applied based on the query.
	 */ search(query, options) {
        let filteredEmoji = [];
        const { nameQuery: nameQuery, asciiQuery: asciiQuery } = $4773145f9c90b36b$var$splitQuery(query);
        if (nameQuery) {
            filteredEmoji = this.getSearchIndex().search(nameQuery);
            if (asciiQuery) filteredEmoji = this.withAsciiMatch(asciiQuery, filteredEmoji);
        } else filteredEmoji = this.getAllSearchableEmojis();
        filteredEmoji = this.applySearchOptions(filteredEmoji, query, options);
        return {
            emojis: filteredEmoji,
            query: query
        };
    }
    /**
	 * Returns all emoji with matching shortName
	 */ findAllMatchingShortName(shortName) {
        return this.shortNameMap.get(shortName) || [];
    }
    /**
	 * Returns the first matching emoji matching the shortName, or null if none found.
	 */ findByShortName(shortName) {
        return $4773145f9c90b36b$var$findByKey(this.shortNameMap, shortName);
    }
    /**
	 * Returns the first matching emoji matching the id, or null if none found.
	 */ findById(id) {
        return $4773145f9c90b36b$var$findByKey(this.idMap, id);
    }
    findByAsciiRepresentation(asciiEmoji) {
        return this.asciiMap.get(asciiEmoji);
    }
    findInCategory(categoryId) {
        if (categoryId === (0, $aGRkq.frequentCategory)) return this.getFrequentlyUsed();
        else return this.all().emojis.filter((emoji)=>emoji.category === categoryId);
    }
    addUnknownEmoji(emoji) {
        this.emojis = [
            ...this.emojis,
            emoji
        ];
        this.getSearchIndex().addDocuments([
            emoji
        ]);
        this.addToMaps(emoji);
        this.addToDynamicCategories(emoji);
    }
    getAsciiMap() {
        return this.asciiMap;
    }
    /**
	 * Return the most frequently used emoji, ordered from most frequent to least frequent. Return an empty array if
	 * there are none.
	 *
	 * @param options optional settings to be applied to the set of frequently used emoji
	 */ getFrequentlyUsed(options) {
        const emojiIds = this.usageTracker.getOrder();
        let emojiResult = emojiIds.map((id)=>this.findById(id)).filter((e)=>e !== undefined);
        if (options) emojiResult = this.applySearchOptions(emojiResult, '', options);
        return emojiResult;
    }
    getDynamicCategoryList() {
        return this.dynamicCategoryList.slice();
    }
    /**
	 * Call this on emoji usage to allow the EmojiRepository to track the usage of emoji (which could be useful
	 * in sorting, etc).
	 *
	 * @param emoji the emoji that was just used
	 */ used(emoji) {
        this.usageTracker.recordUsage(emoji);
        // If this is the first usage ensure that we update the dynamic categories.
        // This is done in a 'timeout' since the usageTracker call previously also happens in a timeout. This ensures that
        // the frequent category will not appear until the usage has been tracked (avoiding the possibility of an empty
        // frequent category being shown in the picker).
        if (this.dynamicCategoryList.indexOf((0, $aGRkq.frequentCategory)) === -1) {
            if (typeof window === 'undefined') return;
            window.setTimeout(()=>{
                this.dynamicCategoryList.push((0, $aGRkq.frequentCategory));
            });
        }
    }
    delete(emoji) {
        const deletedIndex = $4773145f9c90b36b$var$findEmojiIndex(this.emojis, emoji);
        if (deletedIndex !== -1) {
            // Remove the deleted emojis from the internal list
            this.emojis.splice(deletedIndex, 1);
            // Reconstruct repository member variables
            this.initMembers(this.usageTracker);
        }
    }
    withAsciiMatch(ascii, emojis) {
        let result = emojis;
        const asciiEmoji = this.findByAsciiRepresentation(ascii);
        if (asciiEmoji) {
            // Ensures that the same emoji isn't already in the list
            // If it is, we give precedence to the ascii match
            result = emojis.filter((e)=>e.id !== asciiEmoji.id);
            result = [
                asciiEmoji,
                ...result
            ];
        }
        return result;
    }
    applySearchOptions(emojis, query, options) {
        if (!options) options = {};
        if (options.sort === undefined) options.sort = (0, $eyWYN.SearchSort).Default;
        let comparator;
        if (options.sort === (0, $eyWYN.SearchSort).Default) comparator = (0, $cBLND.createSearchEmojiComparator)(query, this.usageTracker.getOrder());
        else if (options.sort === (0, $eyWYN.SearchSort).UsageFrequency) comparator = (0, $cBLND.createUsageOnlyEmojiComparator)(this.usageTracker.getOrder());
        if (comparator) {
            comparator.compare = comparator.compare.bind(comparator); // TODO bind at a better place
            emojis = emojis.sort(comparator.compare);
        }
        if (options.limit && options.limit > 0) emojis = emojis.slice(0, options.limit);
        if (options.skinTone) return emojis.map((emoji)=>{
            return $4773145f9c90b36b$export$e55e46e1520c899d(emoji, options);
        });
        return emojis;
    }
    initMembers(usageTracker) {
        this.usageTracker = usageTracker || new (0, $1vUe1.UsageFrequencyTracker)();
        this.initRepositoryMetadata();
        if (!(0, $fHpHg.fg)('platform_index_emoji_just_in_time')) this.initSearchIndex();
    }
    /**
	 * Optimisation to initialise all map member variables in single loop over emojis
	 */ initRepositoryMetadata() {
        this.shortNameMap = new Map();
        this.idMap = new Map();
        this.asciiMap = new Map();
        const categorySet = new Set();
        this.emojis.forEach((emoji)=>{
            categorySet.add(emoji.category);
            this.addToMaps(emoji);
        });
        if (this.usageTracker.getOrder().length) categorySet.add((0, $aGRkq.frequentCategory));
        this.dynamicCategoryList = Array.from(categorySet).filter((category)=>(0, $aGRkq.defaultCategories).indexOf(category) === -1);
    }
    initSearchIndex() {
        this.fullSearch = new (0, $a6GlY.Search)('id');
        this.fullSearch.tokenizer = new $4773145f9c90b36b$var$Tokenizer();
        this.fullSearch.searchIndex = new (0, $a6GlY.UnorderedSearchIndex)();
        this.fullSearch.addIndex('name');
        this.fullSearch.addIndex('shortName');
        this.fullSearch.addDocuments(this.getAllSearchableEmojis());
        this.fullSearchReady = true;
    }
    getSearchIndex() {
        if (!this.fullSearchReady) this.initSearchIndex();
        return this.fullSearch;
    }
    getAllSearchableEmojis() {
        return this.emojis.filter((emojiDescription)=>emojiDescription.searchable);
    }
    addToMaps(emoji) {
        // Give default value and assign higher weight to Atlassian emojis for logical order when sorting
        if (typeof emoji.order === 'undefined' || emoji.order === -1) emoji.order = $4773145f9c90b36b$export$2e2bcd8739ae039.defaultEmojiWeight;
        if (typeof emoji.id === 'undefined') emoji.id = $4773145f9c90b36b$export$2e2bcd8739ae039.defaultEmojiWeight.toString();
        $4773145f9c90b36b$var$addAllVariants(emoji, (e)=>e.shortName, this.shortNameMap);
        $4773145f9c90b36b$var$addAllVariants(emoji, (e)=>e.id, this.idMap);
        if (emoji.ascii) emoji.ascii.forEach((a)=>this.asciiMap.set(a, emoji));
    }
    addToDynamicCategories(emoji) {
        const category = (0, $70f7p.getCategoryId)(emoji);
        if ((0, $aGRkq.defaultCategories).indexOf(category) === -1 && this.dynamicCategoryList.indexOf(category) === -1) this.dynamicCategoryList.push(category);
    }
}

});
parcelRegister("a6GlY", function(module, exports) {

$parcel$export(module.exports, "UnorderedSearchIndex", () => $75bb5169d514d385$export$5e70dbef3f0d47db);
$parcel$export(module.exports, "Search", () => $75bb5169d514d385$export$4b85d3515bd863a5);
/**
 * Indexes for all substring searches (e.g. the term "cat" is indexed as "c", "ca", "cat", "a", "at", and "t").
 */ var $75bb5169d514d385$export$58ac23006833dfe0 = /*#__PURE__*/ function() {
    function AllSubstringsIndexStrategy() {}
    var _proto = AllSubstringsIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string;
        for(var i = 0, length = token.length; i < length; ++i){
            string = '';
            for(var j = i; j < length; ++j){
                string += token.charAt(j);
                expandedTokens.push(string);
            }
        }
        return expandedTokens;
    };
    return AllSubstringsIndexStrategy;
}();
/**
 * Indexes for exact word matches.
 */ var $75bb5169d514d385$export$1dcc2d6a64836c8f = /*#__PURE__*/ function() {
    function ExactWordIndexStrategy() {}
    var _proto = ExactWordIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        return token ? [
            token
        ] : [];
    };
    return ExactWordIndexStrategy;
}();
/**
 * Indexes for prefix searches (e.g. the term "cat" is indexed as "c", "ca", and "cat" allowing prefix search lookups).
 */ var $75bb5169d514d385$export$eb7fc80cfe9abfe6 = /*#__PURE__*/ function() {
    function PrefixIndexStrategy() {}
    var _proto = PrefixIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string = '';
        for(var i = 0, length = token.length; i < length; ++i){
            string += token.charAt(i);
            expandedTokens.push(string);
        }
        return expandedTokens;
    };
    return PrefixIndexStrategy;
}();
/**
 * Enforces case-sensitive text matches.
 */ var $75bb5169d514d385$export$b88ffe9b5486f99a = /*#__PURE__*/ function() {
    function CaseSensitiveSanitizer() {}
    var _proto = CaseSensitiveSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.trim() : '';
    };
    return CaseSensitiveSanitizer;
}();
/**
 * Sanitizes text by converting to a locale-friendly lower-case version and triming leading and trailing whitespace.
 */ var $75bb5169d514d385$export$147e8ac43c84713a = /*#__PURE__*/ function() {
    function LowerCaseSanitizer() {}
    var _proto = LowerCaseSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.toLocaleLowerCase().trim() : '';
    };
    return LowerCaseSanitizer;
}();
/**
 * Find and return a nested object value.
 *
 * @param object to crawl
 * @param path Property path
 * @returns {any}
 */ function $75bb5169d514d385$var$getNestedFieldValue(object, path) {
    path = path || [];
    object = object || {};
    var value = object; // walk down the property path
    for(var i = 0; i < path.length; i++){
        value = value[path[i]];
        if (value == null) return null;
    }
    return value;
}
/**
 * Search index capable of returning results matching a set of tokens and ranked according to TF-IDF.
 */ var $75bb5169d514d385$export$a1138c79781169cc = /*#__PURE__*/ function() {
    function TfIdfSearchIndex(uidFieldName) {
        this._uidFieldName = uidFieldName;
        this._tokenToIdfCache = {};
        this._tokenMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = TfIdfSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        this._tokenToIdfCache = {}; // New index invalidates previous IDF caches
        var tokenMap = this._tokenMap;
        var tokenDatum;
        if (typeof tokenMap[token] !== 'object') tokenMap[token] = tokenDatum = {
            $numDocumentOccurrences: 0,
            $totalNumOccurrences: 1,
            $uidMap: {}
        };
        else {
            tokenDatum = tokenMap[token];
            tokenDatum.$totalNumOccurrences++;
        }
        var uidMap = tokenDatum.$uidMap;
        if (typeof uidMap[uid] !== 'object') {
            tokenDatum.$numDocumentOccurrences++;
            uidMap[uid] = {
                $document: doc,
                $numTokenOccurrences: 1
            };
        } else uidMap[uid].$numTokenOccurrences++;
    } /**
   * @inheritDocs
   */ ;
    _proto.search = function search(tokens, corpus) {
        var uidToDocumentMap = {};
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var tokenMetadata = this._tokenMap[token]; // Short circuit if no matches were found for any given token.
            if (!tokenMetadata) return [];
            if (i === 0) {
                var keys = Object.keys(tokenMetadata.$uidMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    uidToDocumentMap[uid] = tokenMetadata.$uidMap[uid].$document;
                }
            } else {
                var keys = Object.keys(uidToDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof tokenMetadata.$uidMap[uid] !== 'object') delete uidToDocumentMap[uid];
                }
            }
        }
        var documents = [];
        for(var uid in uidToDocumentMap)documents.push(uidToDocumentMap[uid]);
        var calculateTfIdf = this._createCalculateTfIdf(); // Return documents sorted by TF-IDF
        return documents.sort(function(documentA, documentB) {
            return calculateTfIdf(tokens, documentB, corpus) - calculateTfIdf(tokens, documentA, corpus);
        });
    };
    _proto._createCalculateIdf = function _createCalculateIdf() {
        var tokenMap = this._tokenMap;
        var tokenToIdfCache = this._tokenToIdfCache;
        return function calculateIdf(token, documents) {
            if (!tokenToIdfCache[token]) {
                var numDocumentsWithToken = typeof tokenMap[token] !== 'undefined' ? tokenMap[token].$numDocumentOccurrences : 0;
                tokenToIdfCache[token] = 1 + Math.log(documents.length / (1 + numDocumentsWithToken));
            }
            return tokenToIdfCache[token];
        };
    };
    _proto._createCalculateTfIdf = function _createCalculateTfIdf() {
        var tokenMap = this._tokenMap;
        var uidFieldName = this._uidFieldName;
        var calculateIdf = this._createCalculateIdf();
        return function calculateTfIdf(tokens, document, documents) {
            var score = 0;
            for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
                var token = tokens[i];
                var inverseDocumentFrequency = calculateIdf(token, documents);
                if (inverseDocumentFrequency === Infinity) inverseDocumentFrequency = 0;
                var uid;
                if (uidFieldName instanceof Array) uid = document && $75bb5169d514d385$var$getNestedFieldValue(document, uidFieldName);
                else uid = document && document[uidFieldName];
                var termFrequency = typeof tokenMap[token] !== 'undefined' && typeof tokenMap[token].$uidMap[uid] !== 'undefined' ? tokenMap[token].$uidMap[uid].$numTokenOccurrences : 0;
                score += termFrequency * inverseDocumentFrequency;
            }
            return score;
        };
    };
    return TfIdfSearchIndex;
}();
/**
 * Search index capable of returning results matching a set of tokens but without any meaningful rank or order.
 */ var $75bb5169d514d385$export$5e70dbef3f0d47db = /*#__PURE__*/ function() {
    function UnorderedSearchIndex() {
        this._tokenToUidToDocumentMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = UnorderedSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        if (typeof this._tokenToUidToDocumentMap[token] !== 'object') this._tokenToUidToDocumentMap[token] = {};
        this._tokenToUidToDocumentMap[token][uid] = doc;
    } /**
   * @inheritDocs
   */ ;
    _proto.search = function search(tokens, corpus) {
        var intersectingDocumentMap = {};
        var tokenToUidToDocumentMap = this._tokenToUidToDocumentMap;
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var documentMap = tokenToUidToDocumentMap[token]; // Short circuit if no matches were found for any given token.
            if (!documentMap) return [];
            if (i === 0) {
                var keys = Object.keys(documentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    intersectingDocumentMap[uid] = documentMap[uid];
                }
            } else {
                var keys = Object.keys(intersectingDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof documentMap[uid] !== 'object') delete intersectingDocumentMap[uid];
                }
            }
        }
        var keys = Object.keys(intersectingDocumentMap);
        var documents = [];
        for(var i = 0, numKeys = keys.length; i < numKeys; i++){
            var uid = keys[i];
            documents.push(intersectingDocumentMap[uid]);
        }
        return documents;
    };
    return UnorderedSearchIndex;
}();
var $75bb5169d514d385$var$REGEX = /[^a-zа-яё0-9\-']+/i;
/**
 * Simple tokenizer that splits strings on whitespace characters and returns an array of all non-empty substrings.
 */ var $75bb5169d514d385$export$f5ac5ec3cb556ad6 = /*#__PURE__*/ function() {
    function SimpleTokenizer() {}
    var _proto = SimpleTokenizer.prototype;
    /**
   * @inheritDocs
   */ _proto.tokenize = function tokenize(text) {
        return text.split($75bb5169d514d385$var$REGEX).filter(function(text) {
            return text;
        } // Filter empty tokens
        );
    };
    return SimpleTokenizer;
}();
/**
 * Stemming is the process of reducing search tokens to their root (or stem) so that searches for different forms of a
 * word will match. For example "search", "searching" and "searched" are all reduced to the stem "search".
 *
 * <p>This stemming tokenizer converts tokens (words) to their stem forms before returning them. It requires an
 * external stemming function to be provided; for this purpose I recommend the NPM 'porter-stemmer' library.
 *
 * <p>For more information see http : //tartarus.org/~martin/PorterStemmer/
 */ var $75bb5169d514d385$export$d2c689c98d4dcb27 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param stemmingFunction Function capable of accepting a word and returning its stem.
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StemmingTokenizer(stemmingFunction, decoratedTokenizer) {
        this._stemmingFunction = stemmingFunction;
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StemmingTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).map(this._stemmingFunction);
    };
    return StemmingTokenizer;
}();
/**
 * Stop words list copied from Lunr JS.
 */ var $75bb5169d514d385$export$eeaf491a400e882a = {
    a: true,
    able: true,
    about: true,
    across: true,
    after: true,
    all: true,
    almost: true,
    also: true,
    am: true,
    among: true,
    an: true,
    and: true,
    any: true,
    are: true,
    as: true,
    at: true,
    be: true,
    because: true,
    been: true,
    but: true,
    by: true,
    can: true,
    cannot: true,
    could: true,
    dear: true,
    did: true,
    'do': true,
    does: true,
    either: true,
    'else': true,
    ever: true,
    every: true,
    'for': true,
    from: true,
    'get': true,
    got: true,
    had: true,
    has: true,
    have: true,
    he: true,
    her: true,
    hers: true,
    him: true,
    his: true,
    how: true,
    however: true,
    i: true,
    'if': true,
    'in': true,
    into: true,
    is: true,
    it: true,
    its: true,
    just: true,
    least: true,
    "let": true,
    like: true,
    likely: true,
    may: true,
    me: true,
    might: true,
    most: true,
    must: true,
    my: true,
    neither: true,
    no: true,
    nor: true,
    not: true,
    of: true,
    off: true,
    often: true,
    on: true,
    only: true,
    or: true,
    other: true,
    our: true,
    own: true,
    rather: true,
    said: true,
    say: true,
    says: true,
    she: true,
    should: true,
    since: true,
    so: true,
    some: true,
    than: true,
    that: true,
    the: true,
    their: true,
    them: true,
    then: true,
    there: true,
    these: true,
    they: true,
    'this': true,
    tis: true,
    to: true,
    too: true,
    twas: true,
    us: true,
    wants: true,
    was: true,
    we: true,
    were: true,
    what: true,
    when: true,
    where: true,
    which: true,
    'while': true,
    who: true,
    whom: true,
    why: true,
    will: true,
    'with': true,
    would: true,
    yet: true,
    you: true,
    your: true
}; // Prevent false positives for inherited properties
$75bb5169d514d385$export$eeaf491a400e882a.constructor = false;
$75bb5169d514d385$export$eeaf491a400e882a.hasOwnProperty = false;
$75bb5169d514d385$export$eeaf491a400e882a.isPrototypeOf = false;
$75bb5169d514d385$export$eeaf491a400e882a.propertyIsEnumerable = false;
$75bb5169d514d385$export$eeaf491a400e882a.toLocaleString = false;
$75bb5169d514d385$export$eeaf491a400e882a.toString = false;
$75bb5169d514d385$export$eeaf491a400e882a.valueOf = false;
/**
 * Stop words are very common (e.g. "a", "and", "the") and are often not semantically meaningful in the context of a
 * search. This tokenizer removes stop words from a set of tokens before passing the remaining tokens along for
 * indexing or searching purposes.
 */ var $75bb5169d514d385$export$59d4dfff8ed0ca89 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StopWordsTokenizer(decoratedTokenizer) {
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StopWordsTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).filter(function(token) {
            return !$75bb5169d514d385$export$eeaf491a400e882a[token];
        });
    };
    return StopWordsTokenizer;
}();
function $75bb5169d514d385$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $75bb5169d514d385$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $75bb5169d514d385$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $75bb5169d514d385$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Simple client-side searching within a set of documents.
 *
 * <p>Documents can be searched by any number of fields. Indexing and search strategies are highly customizable.
 */ var $75bb5169d514d385$export$4b85d3515bd863a5 = /*#__PURE__*/ function() {
    /**
   * Array containing either a property name or a path (list of property names) to a nested value
   */ /**
   * Constructor.
   * @param uidFieldName Field containing values that uniquely identify search documents; this field's values are used
   *                     to ensure that a search result set does not contain duplicate objects.
   */ function Search(uidFieldName) {
        if (!uidFieldName) throw Error('js-search requires a uid field name constructor parameter');
        this._uidFieldName = uidFieldName; // Set default/recommended strategies
        this._indexStrategy = new $75bb5169d514d385$export$eb7fc80cfe9abfe6();
        this._searchIndex = new $75bb5169d514d385$export$a1138c79781169cc(uidFieldName);
        this._sanitizer = new $75bb5169d514d385$export$147e8ac43c84713a();
        this._tokenizer = new $75bb5169d514d385$export$f5ac5ec3cb556ad6();
        this._documents = [];
        this._searchableFields = [];
    }
    /**
   * Override the default index strategy.
   * @param value Custom index strategy
   * @throws Error if documents have already been indexed by this search instance
   */ var _proto = Search.prototype;
    /**
   * Add a searchable document to the index. Document will automatically be indexed for search.
   * @param document
   */ _proto.addDocument = function addDocument(document) {
        this.addDocuments([
            document
        ]);
    } /**
   * Adds searchable documents to the index. Documents will automatically be indexed for search.
   * @param document
   */ ;
    _proto.addDocuments = function addDocuments(documents) {
        this._documents = this._documents.concat(documents);
        this.indexDocuments_(documents, this._searchableFields);
    } /**
   * Add a new searchable field to the index. Existing documents will automatically be indexed using this new field.
   *
   * @param field Searchable field or field path. Pass a string to index a top-level field and an array of strings for nested fields.
   */ ;
    _proto.addIndex = function addIndex(field) {
        this._searchableFields.push(field);
        this.indexDocuments_(this._documents, [
            field
        ]);
    } /**
   * Search all documents for ones matching the specified query text.
   * @param query
   * @returns {Array<Object>}
   */ ;
    _proto.search = function search(query) {
        var tokens = this._tokenizer.tokenize(this._sanitizer.sanitize(query));
        return this._searchIndex.search(tokens, this._documents);
    } /**
   * @param documents
   * @param _searchableFields Array containing property names and paths (lists of property names) to nested values
   * @private
   */ ;
    _proto.indexDocuments_ = function indexDocuments_(documents, _searchableFields) {
        this._initialized = true;
        var indexStrategy = this._indexStrategy;
        var sanitizer = this._sanitizer;
        var searchIndex = this._searchIndex;
        var tokenizer = this._tokenizer;
        var uidFieldName = this._uidFieldName;
        for(var di = 0, numDocuments = documents.length; di < numDocuments; di++){
            var doc = documents[di];
            var uid;
            if (uidFieldName instanceof Array) uid = $75bb5169d514d385$var$getNestedFieldValue(doc, uidFieldName);
            else uid = doc[uidFieldName];
            for(var sfi = 0, numSearchableFields = _searchableFields.length; sfi < numSearchableFields; sfi++){
                var fieldValue;
                var searchableField = _searchableFields[sfi];
                if (searchableField instanceof Array) fieldValue = $75bb5169d514d385$var$getNestedFieldValue(doc, searchableField);
                else fieldValue = doc[searchableField];
                if (fieldValue != null && typeof fieldValue !== 'string' && fieldValue.toString) fieldValue = fieldValue.toString();
                if (typeof fieldValue === 'string') {
                    var fieldTokens = tokenizer.tokenize(sanitizer.sanitize(fieldValue));
                    for(var fti = 0, numFieldValues = fieldTokens.length; fti < numFieldValues; fti++){
                        var fieldToken = fieldTokens[fti];
                        var expandedTokens = indexStrategy.expandToken(fieldToken);
                        for(var eti = 0, nummExpandedTokens = expandedTokens.length; eti < nummExpandedTokens; eti++){
                            var expandedToken = expandedTokens[eti];
                            searchIndex.indexDocument(expandedToken, uid, doc);
                        }
                    }
                }
            }
        }
    };
    $75bb5169d514d385$var$_createClass(Search, [
        {
            key: "indexStrategy",
            set: function set(value) {
                if (this._initialized) throw Error('IIndexStrategy cannot be set after initialization');
                this._indexStrategy = value;
            },
            get: function get() {
                return this._indexStrategy;
            }
        },
        {
            key: "sanitizer",
            set: function set(value) {
                if (this._initialized) throw Error('ISanitizer cannot be set after initialization');
                this._sanitizer = value;
            },
            get: function get() {
                return this._sanitizer;
            }
        },
        {
            key: "searchIndex",
            set: function set(value) {
                if (this._initialized) throw Error('ISearchIndex cannot be set after initialization');
                this._searchIndex = value;
            },
            get: function get() {
                return this._searchIndex;
            }
        },
        {
            key: "tokenizer",
            set: function set(value) {
                if (this._initialized) throw Error('ITokenizer cannot be set after initialization');
                this._tokenizer = value;
            },
            get: function get() {
                return this._tokenizer;
            }
        }
    ]);
    return Search;
}();
/**
 * This utility highlights the occurrences of tokens within a string of text. It can be used to give visual indicators
 * of match criteria within searchable fields.
 *
 * <p>For performance purposes this highlighter only works with full-word or prefix token indexes.
 */ var $75bb5169d514d385$export$11e693a7f8ce1bcc = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param opt_indexStrategy Index strategy used by Search
   * @param opt_sanitizer Sanitizer used by Search
   * @param opt_wrapperTagName Optional wrapper tag name; defaults to 'mark' (e.g. <mark>)
   */ function TokenHighlighter(opt_indexStrategy, opt_sanitizer, opt_wrapperTagName) {
        this._indexStrategy = opt_indexStrategy || new $75bb5169d514d385$export$eb7fc80cfe9abfe6();
        this._sanitizer = opt_sanitizer || new $75bb5169d514d385$export$147e8ac43c84713a();
        this._wrapperTagName = opt_wrapperTagName || 'mark';
    }
    /**
   * Highlights token occurrences within a string by wrapping them with a DOM element.
   *
   * @param text e.g. "john wayne"
   * @param tokens e.g. ["wa"]
   * @returns {string} e.g. "john <mark>wa</mark>yne"
   */ var _proto = TokenHighlighter.prototype;
    _proto.highlight = function highlight(text, tokens) {
        var tagsLength = this._wrapText('').length;
        var tokenDictionary = Object.create(null); // Create a token map for easier lookup below.
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = this._sanitizer.sanitize(tokens[i]);
            var expandedTokens = this._indexStrategy.expandToken(token);
            for(var j = 0, numExpandedTokens = expandedTokens.length; j < numExpandedTokens; j++){
                var expandedToken = expandedTokens[j];
                if (!tokenDictionary[expandedToken]) tokenDictionary[expandedToken] = [
                    token
                ];
                else tokenDictionary[expandedToken].push(token);
            }
        } // Track actualCurrentWord and sanitizedCurrentWord separately in case we encounter nested tags.
        var actualCurrentWord = '';
        var sanitizedCurrentWord = '';
        var currentWordStartIndex = 0; // Note this assumes either prefix or full word matching.
        for(var i = 0, textLength = text.length; i < textLength; i++){
            var character = text.charAt(i);
            if (character === ' ') {
                actualCurrentWord = '';
                sanitizedCurrentWord = '';
                currentWordStartIndex = i + 1;
            } else {
                actualCurrentWord += character;
                sanitizedCurrentWord += this._sanitizer.sanitize(character);
            }
            if (tokenDictionary[sanitizedCurrentWord] && tokenDictionary[sanitizedCurrentWord].indexOf(sanitizedCurrentWord) >= 0) {
                actualCurrentWord = this._wrapText(actualCurrentWord);
                text = text.substring(0, currentWordStartIndex) + actualCurrentWord + text.substring(i + 1);
                i += tagsLength;
                textLength += tagsLength;
            }
        }
        return text;
    } /**
   * @param text to wrap
   * @returns Text wrapped by wrapper tag (e.g. "foo" becomes "<mark>foo</mark>")
   * @private
   */ ;
    _proto._wrapText = function _wrapText(text) {
        var tagName = this._wrapperTagName;
        return "<" + tagName + ">" + text + "</" + tagName + ">";
    };
    return TokenHighlighter;
}();

});

parcelRegister("fdPb9", function(module, exports) {

$parcel$export(module.exports, "tokenizerRegex", () => $b5383bd30a4c2f63$export$6558e5d0f0e834f8);
// \p{Han} => each chinese character is a separate token
// \p{L}+[\p{Mn}|']*\p{L} => consecutive letters, including non spacing mark and apostrophe are a single token
// const tokenizerRegex = new XRegExp("\\p{Han}|[\\p{L}|\\p{N}]+[\\p{Mn}|']*\\p{L}*", 'gi');
// Note: Regex compiled to unicode charsets using xregexp-transformer, refer to it if you need to compile it again.
//       @atlaskit/xregexp-transformer (https://bitbucket.org/atlassian/xregexp-transformer)
// eslint-disable-next-line no-misleading-character-class
const $b5383bd30a4c2f63$export$6558e5d0f0e834f8 = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC|0-9\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi');

});

parcelRegister("cBLND", function(module, exports) {

$parcel$export(module.exports, "createSearchEmojiComparator", () => $a81966a518795e7b$export$e6097b005751df7);
$parcel$export(module.exports, "createUsageOnlyEmojiComparator", () => $a81966a518795e7b$export$1bd055808eeccb4e);

var $aGRkq = parcelRequire("aGRkq");

var $70f7p = parcelRequire("70f7p");
function $a81966a518795e7b$export$e6097b005751df7(query, orderedIds) {
    const textQuery = query ? query.replace(/:/g, '').toLowerCase().trim() : undefined;
    const comparators = [];
    if (query) comparators.push(new $a81966a518795e7b$export$ff92575cd1bbad0e(query));
    // Add the comparators to the 'chain'. The order of adding each comparator is important to the sort that is applied by the
    // ChainedEmojiComparator. (Which is why you may see the same 'if' a few times.)
    if (textQuery) comparators.push(new $a81966a518795e7b$export$3026b08b79541139(textQuery));
    if (orderedIds && orderedIds.length) comparators.push(new $a81966a518795e7b$export$55e24837a4bf653(orderedIds));
    if (textQuery) comparators.push(new $a81966a518795e7b$export$587c775915dc4869(textQuery, 'shortName'), new $a81966a518795e7b$export$587c775915dc4869(textQuery, 'name'));
    comparators.push($a81966a518795e7b$export$165e96ceead77edd.Instance, $a81966a518795e7b$export$30ce221e1adf48c1.Instance);
    const comparator = new $a81966a518795e7b$export$a8052d0852821684(...comparators);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
function $a81966a518795e7b$export$1bd055808eeccb4e(orderedIds) {
    const comparator = new $a81966a518795e7b$export$a8052d0852821684(new $a81966a518795e7b$export$55e24837a4bf653(orderedIds), new $a81966a518795e7b$export$a7f7a0b04013a8a8(), $a81966a518795e7b$export$165e96ceead77edd.Instance);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
class $a81966a518795e7b$export$a8052d0852821684 {
    constructor(...comparators){
        this.chain = comparators;
    }
    compare(e1, e2) {
        for(let i = 0; i < this.chain.length; i++){
            const result = this.chain[i].compare(e1, e2);
            if (result !== 0) return result;
        }
        return 0;
    }
}
class $a81966a518795e7b$export$ff92575cd1bbad0e {
    constructor(query){
        this.query = query;
    }
    compare(e1, e2) {
        const e1HasAscii = e1.ascii && e1.ascii.indexOf(this.query) !== -1;
        const e2HasAscii = e2.ascii && e2.ascii.indexOf(this.query) !== -1;
        if (e1HasAscii && !e2HasAscii) return -1;
        else if (!e1HasAscii && e2HasAscii) return 1;
        return 0;
    }
}
class $a81966a518795e7b$export$3026b08b79541139 {
    constructor(query){
        this.colonQuery = `:${query}:`;
        this.typeComparator = new $a81966a518795e7b$export$a7f7a0b04013a8a8(true);
    }
    compare(e1, e2) {
        if (e1.shortName === this.colonQuery && e2.shortName === this.colonQuery) return this.typeComparator.compare(e1, e2);
        else if (e1.shortName === this.colonQuery) return -1;
        else if (e2.shortName === this.colonQuery) return 1;
        return 0;
    }
}
class $a81966a518795e7b$export$a7f7a0b04013a8a8 {
    constructor(reverse){
        if (reverse) this.typeToNumber = new Map([
            [
                'SITE',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'STANDARD',
                2
            ]
        ]);
        else this.typeToNumber = new Map([
            [
                'STANDARD',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'SITE',
                2
            ]
        ]);
    }
    compare(e1, e2) {
        return this.emojiTypeToOrdinal(e1) - this.emojiTypeToOrdinal(e2);
    }
    emojiTypeToOrdinal(emoji) {
        let ordinal = this.typeToNumber.get(emoji.type);
        if (ordinal === undefined) ordinal = 10;
        return ordinal;
    }
}
class $a81966a518795e7b$export$55e24837a4bf653 {
    constructor(orderedIds){
        this.positionLookup = new Map();
        // Make ordering start from 1 to avoid having zero in the map (which is falsey)
        orderedIds.map((id, index)=>this.positionLookup.set(id, index + 1));
    }
    compare(e1, e2) {
        if (!e1.id || !e2.id) return 0; // this shouldn't occur. Leave position unchanged if there is any missing id.
        let i1 = this.getPositionInOrder(e1);
        let i2 = this.getPositionInOrder(e2);
        return i1 - i2;
    }
    /**
	 * Get the ordinal representing the position of this emoji.
	 *
	 * @param id the id of the emoji
	 */ getPositionInOrder(emoji) {
        let id = emoji.id ? emoji.id : '0';
        if ((0, $70f7p.isEmojiVariationDescription)(emoji)) id = emoji.baseId;
        const position = this.positionLookup.get(id);
        if (position) return position;
        else return 0, $aGRkq.MAX_ORDINAL;
    }
}
class $a81966a518795e7b$export$587c775915dc4869 {
    /**
	 * @param query the query to match
	 * @param propertyToCompare the property of EmojiDescription to check for query within
	 */ constructor(query, propertyToCompare){
        this.query = query;
        if (!propertyToCompare) throw new Error('propertyToCompare is required');
        this.propertyName = propertyToCompare;
    }
    getScore(emoji) {
        // It is fine to do override the null check here because we are checking
        // it on the constructor.
        const propertyValue = emoji[this.propertyName];
        const score = propertyValue ? propertyValue.indexOf(this.query) : (0, $aGRkq.MAX_ORDINAL);
        return score === -1 ? (0, $aGRkq.MAX_ORDINAL) : score;
    }
    compare(e1, e2) {
        return this.getScore(e1) - this.getScore(e2);
    }
}
class $a81966a518795e7b$export$165e96ceead77edd {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        let o1 = e1.order ? e1.order : (0, $aGRkq.MAX_ORDINAL);
        let o2 = e2.order ? e2.order : (0, $aGRkq.MAX_ORDINAL);
        return o1 - o2;
    }
}
class $a81966a518795e7b$export$30ce221e1adf48c1 {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        return e1.shortName.localeCompare(e2.shortName);
    }
}

});

parcelRegister("1vUe1", function(module, exports) {

$parcel$export(module.exports, "UsageFrequencyTracker", () => $0c748c2e42101a45$export$3f86810331c44209);

var $70f7p = parcelRequire("70f7p");

var $aGRkq = parcelRequire("aGRkq");

var $8feb1 = parcelRequire("8feb1");

var $kMsgN = parcelRequire("kMsgN");

var $7r41D = parcelRequire("7r41D");
class $0c748c2e42101a45$export$3f86810331c44209 {
    static{
        this.queueOptions = {
            storage: (0, $7r41D.default)('localStorage') ? window.localStorage : undefined,
            storagePrefix: (0, $aGRkq.localStoragePrefix),
            maxDuplicates: 25,
            minUniqueItems: 5
        };
    }
    constructor(useStorageIfPossible = true){
        const options = $0c748c2e42101a45$export$3f86810331c44209.queueOptions;
        if (useStorageIfPossible && options.storage) {
            const queueOptions = {
                ...options,
                storage: options.storage
            };
            this.queue = new (0, $kMsgN.default)(queueOptions);
        } else this.queue = new (0, $8feb1.default)(options);
        this.gateway = new $0c748c2e42101a45$export$a0e1fa6601cae894(10);
    }
    /**
	 * Record the fact that the supplied emoji was used. You should note that usage is updated asynchronously so you can not
	 * count on getOrder() reflecting this usage immediately.
	 *
	 * @param emoji the emoji who's usage is to be recorded. If the emoji has no id then no usage will be recorded
	 */ recordUsage(emoji) {
        let emojiId = emoji.id;
        if (emojiId) {
            if ((0, $70f7p.isEmojiVariationDescription)(emoji)) emojiId = emoji.baseId;
            this.gateway.submit(()=>{
                if (emojiId) this.queue.enqueue(emojiId);
            });
        }
    }
    /**
	 * Returns an array of emoji id (without skin tone variations) sorted by most used to least used. If there
	 * are no usages then an empty array will be returned.
	 */ getOrder() {
        return this.queue.getItemsOrderedByDuplicateCount();
    }
    /**
	 * Exposed for testing only. Clear any recorded usage.
	 */ clear() {
        this.queue.clear();
    }
}
class $0c748c2e42101a45$export$a0e1fa6601cae894 {
    constructor(maximumPermitted){
        if (maximumPermitted < 1) throw new RangeError('The maximumPermitted parameter must be 1 or more.');
        this.maximumPermitted = maximumPermitted;
        this.count = 0;
    }
    /**
	 * Run the supplied function if the count of already submitted work allows it. Drop the work
	 * if it's not allowed to run.
	 *
	 * Will return true if the function has been submitted or false if it was not submitted.
	 */ submit(f) {
        if (this.count >= this.maximumPermitted) return false;
        this.count++;
        const wrappedFunc = ()=>{
            try {
                f();
            } finally{
                this.completed();
            }
        };
        if (typeof window !== 'undefined') window.setTimeout(wrappedFunc);
        return true;
    }
    completed() {
        this.count--;
    }
}

});
parcelRegister("8feb1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e76144f5f85408ec$export$2e2bcd8739ae039);
/**
 * The options used to configure a newly constructed queue.
 */ class $e76144f5f85408ec$export$2e2bcd8739ae039 {
    /**
	 * Construct a new DuplicateLimitedQueue.
	 *
	 * @param options the options for this queue.
	 */ constructor(options){
        if (options.maxDuplicates < 1) throw new RangeError('The maxDuplicates option must be at least 1');
        if (options.minUniqueItems < 1) throw new RangeError('The minUniqueItems option must be at least 1');
        this.maximumSize = options.maxDuplicates * options.minUniqueItems;
        this.perItemSize = options.maxDuplicates;
        this.createEmptyState();
    }
    /**
	 * @param item the item to add to the queue.
	 */ enqueue(item) {
        this.enqueueWithoutOrdering(item);
        // enqueues are less time sensitive (and may happen less frequently) than queries against the queue
        // so do the ordering work on each enqueue.
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
	 * Return the items in the queue, ordered by how often they are duplicated. The items with the
	 * most duplicates come first in the returned Array.
	 *
	 * If there are no items in the queue then an empty Array will be returned.
	 */ getItemsOrderedByDuplicateCount() {
        return this.itemsOrderedByFrequency;
    }
    /**
	 * Exposed for storybook/testing purposes only. Clear the contents of the queue.
	 */ clear() {
        this.createEmptyState();
    }
    /**
	 * A more efficient mechanism for adding multiple items. Ordering is only performed once all
	 * the items have been added.
	 *
	 * @param items the items to be enqueued, which happens in their presented order.
	 */ bulkEnqueue(items) {
        items.map((item)=>this.enqueueWithoutOrdering(item));
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
	 * Return the items currently stored in the queue.
	 */ getItems() {
        return this.items;
    }
    createEmptyState() {
        this.items = new Array();
        this.itemCountMap = new Map();
        this.itemsOrderedByFrequency = new Array();
    }
    /**
	 * Enqueue the supplied item, keeping consistency with the limits configured. However no ordering is
	 * performed by this enqueuing. You must trigger that manually if required.
	 *
	 * @param item the item to be queued
	 */ enqueueWithoutOrdering(item) {
        const count = this.itemCountMap.get(item);
        if (count && count >= this.perItemSize) // find the first item with that key in the array and remove it
        this.removeFirstOccurrence(item);
        else if (this.items.length >= this.maximumSize) this.remove();
        this.add(item);
    }
    /**
	 * Get an array of items from the queue ordered by how often they are duplicated in the queue.
	 */ orderItemsByFrequency() {
        const orderedEntries = Array.from(this.itemCountMap.entries()).sort((a, b)=>{
            return b[1] - a[1];
        });
        return orderedEntries.map((value)=>value[0]);
    }
    decrementCount(item) {
        let count = this.itemCountMap.get(item);
        if (count) {
            count--;
            if (count > 0) this.itemCountMap.set(item, count);
            else this.itemCountMap.delete(item);
        }
    }
    /**
	 * Walk the list of items and remove the first occurrence of the matching item.
	 *
	 * @param item the item to be removed.
	 */ removeFirstOccurrence(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) {
            this.items.splice(index, 1);
            this.decrementCount(item);
        }
    }
    /**
	 * Remove the first item from the queue and update the itemCountMap accordingly.
	 * @return the item add the front of the queue or undefined if the queue is empty
	 */ remove() {
        const removed = this.items.shift();
        if (removed !== undefined) this.decrementCount(removed);
        return removed;
    }
    /**
	 * Add the supplied item to the end of the queue and update the itemCountMap accordingly.
	 * @param item the item to be added to the queue
	 */ add(item) {
        this.items.push(item);
        const count = this.itemCountMap.get(item);
        if (count) this.itemCountMap.set(item, count + 1);
        else this.itemCountMap.set(item, 1);
    }
}

});

parcelRegister("kMsgN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b46c5d453636eca$export$2e2bcd8739ae039);

var $8feb1 = parcelRequire("8feb1");

var $5fQjB = parcelRequire("5fQjB");
class $4b46c5d453636eca$export$2e2bcd8739ae039 extends (0, $8feb1.default) {
    static{
        this.storageKey = 'lastUsed';
    }
    constructor(options){
        super(options);
        this.storage = options.storage;
        this.prefixedStorageKey = `${options.storagePrefix}.${$4b46c5d453636eca$export$2e2bcd8739ae039.storageKey}`;
        this.load();
    }
    /**
	 * Enqueue the supplied item and also persist the new contents of the queue to storage.
	 *
	 * @param item the item to be enqueued
	 */ enqueue(item) {
        super.enqueue(item);
        this.save();
    }
    /**
	 * Exposed for storybook/testing purposes only. Clear the contents of the queue, and localStorage.
	 */ clear() {
        super.clear();
        this.storage.removeItem(this.prefixedStorageKey);
    }
    /**
	 * Initialise the queue contents from the configured Storage. If there is no data found in
	 * storage then the queue will have no items added. Likewise, a failure to read or parse stored
	 * data will be swallowed and no items are added to the queue.
	 */ load() {
        const itemsJson = this.storage.getItem(this.prefixedStorageKey);
        if (itemsJson) try {
            const items = JSON.parse(itemsJson);
            this.bulkEnqueue(items);
        } catch (e) {
            (0, $5fQjB.default)(`Error parsing the queue stored as ${this.prefixedStorageKey} key from storage`, e);
        }
    }
    /**
	 * Save the current items in the queue, overwriting any previously stored queue.
	 * Any failure in saving will be silently ignored with the likely outcome that any previous
	 * saved items will remain unchanged in storage.
	 */ save() {
        const itemsJson = JSON.stringify(this.getItems());
        try {
            this.storage.setItem(this.prefixedStorageKey, itemsJson);
        } catch (e) {
            (0, $5fQjB.default)(`Error saving the queued items as ${this.prefixedStorageKey}`, e);
        }
    }
}

});



parcelRegister("5LKAR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d06d5c4231f6564c$export$2e2bcd8739ae039);

var $ddgvn = parcelRequire("ddgvn");

var $afuOi = parcelRequire("afuOi");

var $70f7p = parcelRequire("70f7p");

var $7Sl8R = parcelRequire("7Sl8R");

var $2Tr6g = parcelRequire("2Tr6g");

var $9c6C2 = parcelRequire("9c6C2");

var $5fQjB = parcelRequire("5fQjB");
const $d06d5c4231f6564c$export$6f3a08dea02a7b2b = 0.95;
class $d06d5c4231f6564c$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig, mediaApiToken){
        this.postToEmojiService = (upload, fileId)=>{
            const { shortName: shortName, name: name } = upload;
            const { width: width, height: height } = upload;
            const requestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    shortName: shortName,
                    name: name,
                    width: width,
                    height: height,
                    fileId: fileId
                })
            };
            return (0, $ddgvn.utils).requestService(this.siteServiceConfig, {
                requestInit: requestInit
            }).then((response)=>{
                const { emojis: emojis } = response;
                if (emojis.length) {
                    const { altRepresentations: altRepresentations, ...emoji } = emojis[0];
                    const response = {
                        ...emoji,
                        representation: (0, $70f7p.convertImageToMediaRepresentation)(emoji.representation)
                    };
                    const altRepresentation = (0, $2Tr6g.getAltRepresentation)(altRepresentations || {});
                    const imgAltRepresentation = altRepresentation ? (0, $70f7p.convertImageToMediaRepresentation)(altRepresentation) : undefined;
                    return (0, $70f7p.buildEmojiDescriptionWithAltRepresentation)(response, imgAltRepresentation);
                }
                throw new Error('No emoji returns from upload. Upload failed.');
            });
        };
        this.siteServiceConfig = siteServiceConfig;
        this.mediaApiToken = mediaApiToken;
        this.tokenManager = new (0, $9c6C2.default)(siteServiceConfig);
        this.tokenManager.addToken('read', mediaApiToken);
        this.mediaEmojiCache = new (0, $7Sl8R.default)(this.tokenManager);
    }
    /**
	 * Will generate an emoji media path that is inclusive of client and token within the query parameter for media representation and altRepresentation
	 */ async generateTokenisedMediaURLS(representation, altRepresentation) {
        if (!(0, $70f7p.isMediaRepresentation)(representation)) return {
            representation: representation,
            altRepresentation: altRepresentation
        };
        try {
            const readToken = await this.tokenManager.getToken('read');
            return Object.entries({
                representation: representation,
                altRepresentation: altRepresentation
            }).reduce((acc, [key, value])=>{
                if (value && (0, $70f7p.isMediaRepresentation)(value)) {
                    const path = new URL(value.mediaPath);
                    const params = path.searchParams;
                    if (params.get('token') !== readToken.jwt) params.set('token', readToken.jwt);
                    if (params.get('client') !== readToken.clientId) params.set('client', readToken.clientId);
                    acc[key] = {
                        ...value,
                        mediaPath: path.toString()
                    };
                }
                return acc;
            }, {
                representation: representation,
                altRepresentation: altRepresentation
            });
        } catch (error) {
            return {
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
    }
    /**
	 * Will load media emoji, returning a new EmojiDescription if, for example,
	 * the URL has changed.
	 */ loadMediaEmoji(emoji, useAlt) {
        if (!(0, $70f7p.isMediaEmoji)(emoji)) throw new Error('Only supported for media emoji');
        return this.mediaEmojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(emoji, useAlt) {
        const representation = useAlt ? emoji.altRepresentation : emoji.representation;
        if (!(0, $70f7p.isMediaRepresentation)(representation)) throw new Error('Only supported for media emoji');
        const { mediaPath: mediaPath } = representation;
        return this.mediaEmojiCache.optimisticRendering(mediaPath);
    }
    uploadEmoji(upload, retry = false, progressCallback) {
        const startTime = Date.now();
        return this.tokenManager.getToken('upload', retry).then((uploadToken)=>{
            const tokenLoadTime = Date.now() - startTime;
            (0, $5fQjB.default)('upload token load time', tokenLoadTime);
            return new Promise((resolve, reject)=>{
                const { url: url, clientId: clientId, collectionName: collectionName } = uploadToken;
                const mediaClient = (0, $afuOi.getMediaClient)({
                    authProvider: ()=>Promise.resolve({
                            clientId: clientId,
                            token: uploadToken.jwt,
                            baseUrl: url
                        }),
                    useSha256ForUploads: true
                });
                const subscription = mediaClient.file.upload({
                    content: upload.dataURL,
                    name: upload.filename,
                    collection: collectionName
                }).subscribe({
                    next: (state)=>{
                        if (state.status === 'uploading' && progressCallback) progressCallback({
                            percent: state.progress * $d06d5c4231f6564c$export$6f3a08dea02a7b2b
                        });
                        else if (state.status === 'processing' || state.status === 'processed') {
                            subscription.unsubscribe();
                            const totalUploadTime = Date.now() - startTime;
                            const mediaUploadTime = totalUploadTime - tokenLoadTime;
                            (0, $5fQjB.default)('total upload / media upload times', totalUploadTime, mediaUploadTime);
                            this.postToEmojiService(upload, state.id).then((emoji)=>{
                                resolve(emoji);
                            }).catch((httpError)=>{
                                reject(httpError.reason || httpError);
                            });
                        }
                    },
                    error (error) {
                        reject(error);
                    }
                });
            });
        });
    }
    /**
	 * Check if the MediaEmojiResource has been able to initialise an uploadToken. Retrieving an upload token
	 * is asynchronous so the Promise will need to resolve before the state is known. If the token retrieval
	 * completes with failure then the Promise will resolve to false.
	 */ hasUploadToken() {
        const tokenPromise = this.tokenManager.getToken('upload');
        return tokenPromise.then((token)=>{
            return token !== undefined;
        }, ()=>{
            return false;
        });
    }
    prepareForUpload() {
        // make sure a token is loaded from the emoji service if we don't have one
        // as future request to uploadEmoji will use this, this to preload it, as it
        // usually takes 1-2 seconds to generate
        this.tokenManager.getToken('upload');
    }
    findEmoji(emojiId) {
        if (!emojiId.id) return Promise.reject(false);
        const path = `../${encodeURIComponent(emojiId.id)}`;
        return (0, $2Tr6g.emojiRequest)(this.siteServiceConfig, {
            path: path
        }).then((serviceResponse)=>{
            const response = (0, $2Tr6g.denormaliseEmojiServiceResponse)(serviceResponse);
            return response.emojis[0];
        }).catch((error)=>{
            (0, $5fQjB.default)('failed to load emoji', emojiId, error);
            return undefined;
        });
    }
    /**
	 * Calls to site-scoped EmojiResource to delete emoji
	 * @param emoji media emoji to delete
	 * @returns Promise.resolve() if success and Promise.reject() for failure
	 */ deleteEmoji(emoji) {
        if (!(0, $70f7p.isMediaEmoji)(emoji) && !(0, $70f7p.isLoadedMediaEmoji)(emoji)) return Promise.reject(false);
        if (!emoji.id) return Promise.reject(false);
        const path = `${encodeURIComponent(emoji.id)}`;
        const requestInit = {
            method: 'DELETE'
        };
        return (0, $ddgvn.utils).requestService(this.siteServiceConfig, {
            path: path,
            requestInit: requestInit
        })// Successful delete on Promise.resolve
        .then(()=>true)// Unsuccessful delete on Promise.reject
        .catch(()=>false);
    }
}

});
parcelRegister("afuOi", function(module, exports) {

$parcel$export(module.exports, "MediaClientContext", () => $db0673a01cdc0e60$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "getMediaClient", () => $db0673a01cdc0e60$export$c9ecbc1b719fd417);
$parcel$export(module.exports, "MediaClientProvider", () => $db0673a01cdc0e60$export$5bff351c86f56d97);
$parcel$export(module.exports, "useMediaClient", () => $db0673a01cdc0e60$export$8b3e87ea56c3a345);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4Rxps = parcelRequire("4Rxps");
const $db0673a01cdc0e60$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $db0673a01cdc0e60$export$f92e83e86b03c398 = new Map();
const $db0673a01cdc0e60$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $4Rxps.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $db0673a01cdc0e60$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $4Rxps.MediaClient)(mediaClientConfig);
        $db0673a01cdc0e60$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};
const $db0673a01cdc0e60$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $5uXOq.useMemo)(()=>$db0673a01cdc0e60$export$c9ecbc1b719fd417(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($db0673a01cdc0e60$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient,
        children: children
    });
};
const $db0673a01cdc0e60$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($db0673a01cdc0e60$export$ba5d7212f2b4619f);
    if (!mediaClient) throw new Error('No MediaClient set, use MediaClientProvider to set one');
    return mediaClient;
};

});
parcelRegister("4Rxps", function(module, exports) {

$parcel$export(module.exports, "MediaClient", () => $bcb0c8c2197dacc0$export$fba8b4ca6d386aec);

var $7n9mn = parcelRequire("7n9mn");
parcelRequire("lixMv");
var $il6yz = parcelRequire("il6yz");

var $j7yhV = parcelRequire("j7yhV");

var $bgrr3 = parcelRequire("bgrr3");

var $3vsCy = parcelRequire("3vsCy");
parcelRequire("9RtOq");
var $5f1nm = parcelRequire("5f1nm");

class $bcb0c8c2197dacc0$export$fba8b4ca6d386aec {
    constructor(mediaClientConfig, store = (0, $5f1nm.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi ?? new (0, $j7yhV.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: mediaClientConfig.useSha256ForUploads ? (0, $il6yz.ChunkHashAlgorithm).Sha256 : (0, $il6yz.ChunkHashAlgorithm).Sha1,
            authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
        });
        this.config = mediaClientConfig;
        this.file = new (0, $bgrr3.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
        this.stargate = new (0, $3vsCy.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
	 * @internal
	 */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params) {
        return this.mediaStore.getFileImageURLSync(id, params);
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("dXv4B"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("lixMv", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => (parcelRequire("j40QZ")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("7rnCq")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("7rnCq")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("il6yz")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $j40QZ = parcelRequire("j40QZ");

var $7rnCq = parcelRequire("7rnCq");

var $il6yz = parcelRequire("il6yz");

});
parcelRegister("j40QZ", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => $cf1254aba95e0a22$export$8cef61637918b288);

var $7n9mn = parcelRequire("7n9mn");

var $iwKVT = parcelRequire("iwKVT");
const $cf1254aba95e0a22$export$8cef61637918b288 = {
    streams: new (0, $iwKVT.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $7n9mn.EventEmitter2)()
};

});
parcelRegister("iwKVT", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("7rnCq", function(module, exports) {

$parcel$export(module.exports, "isClientBasedAuth", () => $cd634e885722184b$export$6ba49fcac9c46e54);
$parcel$export(module.exports, "authToOwner", () => $cd634e885722184b$export$17f6055767a8d96a);
function $cd634e885722184b$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $cd634e885722184b$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
const $cd634e885722184b$export$17f6055767a8d96a = (auth)=>{
    if ($cd634e885722184b$export$af1ab14f2246ef72(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});

parcelRegister("il6yz", function(module, exports) {

$parcel$export(module.exports, "ChunkHashAlgorithm", () => $2a49684ccf405aa8$export$d3e73a50cc549c2e);
var $2a49684ccf405aa8$export$d3e73a50cc549c2e = /*#__PURE__*/ function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha1"] = "sha1";
    ChunkHashAlgorithm["Sha256"] = "sha256";
    return ChunkHashAlgorithm;
}({});

});


parcelRegister("j7yhV", function(module, exports) {

$parcel$export(module.exports, "MediaStore", () => $e22b34955bac5a6a$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $e22b34955bac5a6a$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $e22b34955bac5a6a$export$20f9315304dd6726);
parcelRequire("lixMv");
var $il6yz = parcelRequire("il6yz");
var $7rnCq = parcelRequire("7rnCq");

var $dC3bt = parcelRequire("dC3bt");

var $btiB9 = parcelRequire("btiB9");

var $3sO2v = parcelRequire("3sO2v");
var $2kZmt = parcelRequire("2kZmt");

var $k9Ibc = parcelRequire("k9Ibc");

var $bfOXs = parcelRequire("bfOXs");

var $haS1j = parcelRequire("haS1j");

var $fHpHg = parcelRequire("fHpHg");

var $5hRRN = parcelRequire("5hRRN");
const $e22b34955bac5a6a$var$MEDIA_API_REGION = 'media-api-region';
const $e22b34955bac5a6a$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $e22b34955bac5a6a$var$extendImageParams = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': params?.['max-age'] ?? (0, $dC3bt.FILE_CACHE_MAX_AGE),
        allowAnimated: params?.allowAnimated ?? true,
        mode: params?.mode ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $dC3bt.MAX_RESOLUTION),
            height: (0, $dC3bt.MAX_RESOLUTION)
        } : {}
    };
};
const $e22b34955bac5a6a$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
const $e22b34955bac5a6a$var$cdnFeatureFlag = (endpoint)=>{
    let result = endpoint;
    if ((0, $fHpHg.fg)('platform_media_cdn_delivery')) {
        if ((0, $5hRRN.isCommercial)()) result += '/cdn';
    }
    return result;
};
class $e22b34955bac5a6a$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.resolveAuth = (authContext)=>(0, $haS1j.resolveAuth)(this.config.authProvider, authContext, this.config.authProviderTimeout);
        this.resolveInitialAuth = ()=>(0, $haS1j.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $il6yz.ChunkHashAlgorithm).Sha1;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $k9Ibc.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $e22b34955bac5a6a$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', options).then((0, $k9Ibc.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: $e22b34955bac5a6a$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', options).then((0, $k9Ibc.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $k9Ibc.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const options = {
            params: $e22b34955bac5a6a$var$extendImageParams(params),
            auth: auth
        };
        const imageEndpoint = $e22b34955bac5a6a$var$cdnFeatureFlag('image');
        return (0, $bfOXs.mapToMediaCdnUrl)((0, $k9Ibc.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
    }
    async getFileBinary(id, collectionName, abortController, maxAge = (0, $dC3bt.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = $e22b34955bac5a6a$var$cdnFeatureFlag('binary');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, abortController, true).then((0, $k9Ibc.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $dC3bt.FILE_CACHE_MAX_AGE)) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const binaryEndpoint = $e22b34955bac5a6a$var$cdnFeatureFlag('binary');
        return (0, $bfOXs.mapToMediaCdnUrl)((0, $k9Ibc.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
    }
    async getArtifactURL(artifacts, artifactName, collectionName) {
        const artifactUrl = (0, $btiB9.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': (0, $dC3bt.FILE_CACHE_MAX_AGE)
            },
            auth: auth
        };
        return (0, $k9Ibc.createUrl)((0, $bfOXs.mapToMediaCdnUrl)(artifactUrl, auth.token), options);
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = $e22b34955bac5a6a$var$cdnFeatureFlag('image');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: $e22b34955bac5a6a$var$extendImageParams(params, fetchMaxRes),
            headers: headers,
            traceContext: traceContext,
            addMediaClientParam: true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $k9Ibc.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext, includeHashForDuplicateFiles) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $e22b34955bac5a6a$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors,
                includeHashForDuplicateFiles: includeHashForDuplicateFiles
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $k9Ibc.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $k9Ibc.createMapResponseToJson)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $e22b34955bac5a6a$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, options);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $e22b34955bac5a6a$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $k9Ibc.createMapResponseToJson)(metadata));
    }
    copyFile(id, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/v2/file/copy'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $e22b34955bac5a6a$var$jsonHeaders,
            body: JSON.stringify({
                id: id
            }),
            traceContext: traceContext,
            clientOptions: {
                retryOptions: {
                    shouldRetryError: (err)=>(0, $k9Ibc.defaultShouldRetryError)(err) || (0, $3sO2v.isRequestError)(err) && err?.metadata?.statusCode === 401
                }
            }
        };
        return this.request('/v2/file/copy', options).then((0, $k9Ibc.createMapResponseToJson)(metadata));
    }
    async registerCopyIntents(files, traceContext, resolvedAuth) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/intents'
        };
        const options = {
            ...metadata,
            headers: $e22b34955bac5a6a$var$jsonHeaders,
            body: JSON.stringify({
                files: files
            }),
            traceContext: traceContext,
            resolvedAuth: resolvedAuth
        };
        await this.request('/file/copy/intents', options);
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam, resolvedAuth: resolvedAuth } = options;
        const auth = resolvedAuth ?? await this.resolveAuth(authContext);
        const clientId = (0, $7rnCq.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = (0, $k9Ibc.extendTraceContext)(traceContext);
        const extendedParams = addMediaClientParam ? {
            ...params,
            clientId: clientId
        } : params;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $bfOXs.mapToMediaCdnUrl)(url, auth.token);
        const response = await (0, $2kZmt.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: extendedParams,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $e22b34955bac5a6a$var$setKeyValueInSessionStorage($e22b34955bac5a6a$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $e22b34955bac5a6a$var$setKeyValueInSessionStorage($e22b34955bac5a6a$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    async testUrl(url, options = {}) {
        const { traceContext: traceContext } = options;
        await (0, $2kZmt.request)(url, {
            method: 'HEAD',
            traceContext: (0, $k9Ibc.extendTraceContext)(traceContext),
            clientOptions: {
                retryOptions: {
                    maxAttempts: 1
                }
            }
        });
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}
const $e22b34955bac5a6a$var$getValueFromSessionStorage = (key)=>{
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $e22b34955bac5a6a$var$setKeyValueInSessionStorage = (key, value)=>{
    if (!value || !(window && window.sessionStorage)) return;
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
const $e22b34955bac5a6a$export$c8b741e18397852a = ()=>{
    return $e22b34955bac5a6a$var$getValueFromSessionStorage($e22b34955bac5a6a$var$MEDIA_API_ENVIRONMENT);
};
const $e22b34955bac5a6a$export$20f9315304dd6726 = ()=>{
    return $e22b34955bac5a6a$var$getValueFromSessionStorage($e22b34955bac5a6a$var$MEDIA_API_REGION);
};

});
parcelRegister("dC3bt", function(module, exports) {

$parcel$export(module.exports, "RECENTS_COLLECTION", () => $f412d18b95de4cf8$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $f412d18b95de4cf8$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $f412d18b95de4cf8$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $f412d18b95de4cf8$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $f412d18b95de4cf8$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $f412d18b95de4cf8$export$f14f521f3d306044);

var $fDJ6P = parcelRequire("fDJ6P");
const $f412d18b95de4cf8$export$860a16125e30000b = 'recents';
const $f412d18b95de4cf8$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $f412d18b95de4cf8$export$6e70f30e392bc53f = 4096;
const $f412d18b95de4cf8$export$c1abb8bab1e615cd = 5 * (0, $fDJ6P.DATA_UNIT).MB;
const $f412d18b95de4cf8$export$3d5157f0def70e54 = 1000;
const $f412d18b95de4cf8$export$f14f521f3d306044 = 2 * (0, $fDJ6P.DATA_UNIT).TB;

});
parcelRegister("fDJ6P", function(module, exports) {

$parcel$export(module.exports, "isNotFoundMediaItemDetails", () => $e74ee2bc30e98368$export$fd27d7abbc4a746d);
$parcel$export(module.exports, "DATA_UNIT", () => $e74ee2bc30e98368$export$76cfea4c354af843);
const $e74ee2bc30e98368$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
const $e74ee2bc30e98368$export$fd27d7abbc4a746d = (itemDetails)=>{
    return 'type' in itemDetails && itemDetails.type === 'not-found';
};
var $e74ee2bc30e98368$export$76cfea4c354af843 = /*#__PURE__*/ function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    return DATA_UNIT;
}({});

});


parcelRegister("btiB9", function(module, exports) {

$parcel$export(module.exports, "getArtifactUrl", () => $6fa5f4d6160ed523$export$1cc24defa44e7f84);

var $fHpHg = parcelRequire("fHpHg");

var $5hRRN = parcelRequire("5hRRN");
const $6fa5f4d6160ed523$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $5hRRN.isCommercial)() && (0, $fHpHg.fg)('platform_media_cdn_delivery') && artifacts[prop]?.url) return `${artifacts[prop]?.url}/cdn`;
    return artifacts[prop]?.url;
};

});
parcelRegister("5hRRN", function(module, exports) {

$parcel$export(module.exports, "isCommercial", () => $0d143a815088d6de$export$df69ff6733e73e50);
function $0d143a815088d6de$export$df69ff6733e73e50() {
    const global = globalThis;
    const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (perimeter) // Note: reference to MICROS_PERIMETER can be found in: https://hello.atlassian.net/wiki/spaces/MICROS/pages/167212650/Runtime+configuration+environment+variables+and+adding+secrets#Micros-provided-variables
    return perimeter === 'commercial';
    // Return true if the current hostname does NOT match any of the forbidden patterns.
    return !global.location?.hostname?.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/);
}

});


parcelRegister("3sO2v", function(module, exports) {

$parcel$export(module.exports, "RequestError", () => $b8779887466a6817$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $b8779887466a6817$export$3717b1ffef4428ea);

var $8CwRc = parcelRequire("8CwRc");
class $b8779887466a6817$export$43ee7d0e4f429743 extends (0, $8CwRc.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode, traceContext: traceContext } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            metadata: {
                traceContext: traceContext
            },
            innerError: innerError
        };
    }
}
function $b8779887466a6817$export$3717b1ffef4428ea(err) {
    return err instanceof $b8779887466a6817$export$43ee7d0e4f429743;
}

});
parcelRegister("8CwRc", function(module, exports) {

$parcel$export(module.exports, "BaseMediaClientError", () => $4a8faaca41e54473$export$2b0aca14d61c3190);
$parcel$export(module.exports, "CommonMediaClientError", () => $4a8faaca41e54473$export$e574d1724215079f);
$parcel$export(module.exports, "isCommonMediaClientError", () => $4a8faaca41e54473$export$881f0f9bc813e1f3);
$parcel$export(module.exports, "toCommonMediaClientError", () => $4a8faaca41e54473$export$a5db89cfc88eff9);
$parcel$export(module.exports, "fromCommonMediaClientError", () => $4a8faaca41e54473$export$c2b89b9a32286816);

var $9qxAT = parcelRequire("9qxAT");
class $4a8faaca41e54473$export$2b0aca14d61c3190 extends Error {
    constructor(reason, metadata, innerError){
        super(reason), this.reason = reason, this.metadata = metadata, this.innerError = innerError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $4a8faaca41e54473$export$e574d1724215079f extends $4a8faaca41e54473$export$2b0aca14d61c3190 {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    get attributes() {
        return {
            reason: this.reason
        };
    }
}
function $4a8faaca41e54473$export$881f0f9bc813e1f3(error) {
    if (!error) return false;
    // Check if the error is an instance of Error
    if (error instanceof $4a8faaca41e54473$export$e574d1724215079f) return true;
    return typeof error.reason === 'string' && ('metadata' in error || error.metadata === undefined) && ('innerError' in error || error.innerError === undefined);
}
const $4a8faaca41e54473$export$a5db89cfc88eff9 = (errorFileState)=>{
    const error = errorFileState.details?.error;
    return new $4a8faaca41e54473$export$e574d1724215079f(error?.reason || 'unknown-reason', error.metadata, error.innerError);
};
const $4a8faaca41e54473$export$c2b89b9a32286816 = (id, occurrenceKey, error)=>{
    return {
        status: 'error',
        id: id,
        occurrenceKey: occurrenceKey,
        reason: error.reason,
        details: {
            /** Use this attr to translate back into CommonMediaClientError (toCommonMediaClientError) */ error: {
                reason: error?.reason,
                metadata: error?.metadata,
                innerError: error?.innerError
            },
            // Legacy details
            ...error?.attributes
        },
        message: error?.message
    };
};

});
parcelRegister("9qxAT", function(module, exports) {

$parcel$export(module.exports, "getMediaClientErrorReason", () => $a0df198fa6b64edf$export$c15d72765ee2baa4);
function $a0df198fa6b64edf$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $a0df198fa6b64edf$export$c15d72765ee2baa4(err) {
    return $a0df198fa6b64edf$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}

});



parcelRegister("2kZmt", function(module, exports) {

$parcel$export(module.exports, "request", () => $1c542c75ee81c633$export$b5fe3f66a567bec0);

var $3sO2v = parcelRequire("3sO2v");

var $k9Ibc = parcelRequire("k9Ibc");
async function $1c542c75ee81c633$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $k9Ibc.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $k9Ibc.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $k9Ibc.createProcessFetchResponse)(metadata));
    return (0, $k9Ibc.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("k9Ibc", function(module, exports) {

$parcel$export(module.exports, "extendTraceContext", () => $e664893e28e94056$export$ee24a95986dfd173);
$parcel$export(module.exports, "createUrl", () => $e664893e28e94056$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $e664893e28e94056$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $e664893e28e94056$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $e664893e28e94056$export$5cc7b0795397da86);
$parcel$export(module.exports, "defaultShouldRetryError", () => $e664893e28e94056$export$fee2242cbb339663);
$parcel$export(module.exports, "fetchRetry", () => $e664893e28e94056$export$782df2acbe10b22c);
$parcel$export(module.exports, "createRequestErrorReason", () => $e664893e28e94056$export$6397609af718d008);
$parcel$export(module.exports, "createProcessFetchResponse", () => $e664893e28e94056$export$6e2e477edb7d6032);
parcelRequire("lixMv");
var $7rnCq = parcelRequire("7rnCq");

var $5dnAb = parcelRequire("5dnAb");

var $7MBC8 = parcelRequire("7MBC8");

var $3sO2v = parcelRequire("3sO2v");
const $e664893e28e94056$var$getStatusCode = (error)=>(0, $3sO2v.isRequestError)(error) && error.metadata?.statusCode && error.metadata.statusCode;
function $e664893e28e94056$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $e664893e28e94056$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $e664893e28e94056$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $e664893e28e94056$export$bc96a6a479480590(error) {
    const statusCode = error && $e664893e28e94056$var$getStatusCode(error);
    return statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $e664893e28e94056$export$ee24a95986dfd173 = (traceContext)=>traceContext ? {
        ...traceContext,
        spanId: traceContext?.spanId || (0, $5dnAb.getRandomHex)(8)
    } : undefined;
const $e664893e28e94056$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $e664893e28e94056$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$e664893e28e94056$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$e664893e28e94056$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $e664893e28e94056$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $7rnCq.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $e664893e28e94056$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth?.baseUrl);
    const authParams = auth && (0, $7MBC8.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.append(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $e664893e28e94056$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...$e664893e28e94056$export$eaf4479116d2f925(auth),
        ...$e664893e28e94056$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $e664893e28e94056$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $3sO2v.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$e664893e28e94056$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $e664893e28e94056$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $3sO2v.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$e664893e28e94056$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $e664893e28e94056$export$fee2242cbb339663 = (err)=>{
    const statusCode = $e664893e28e94056$var$getStatusCode(err);
    return $e664893e28e94056$export$ad8c5cf7dd4c3caf(err) || (statusCode ? statusCode >= 500 : false);
};
const $e664893e28e94056$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    maxAttempts: 5,
    factor: 2
};
function $e664893e28e94056$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $3sO2v.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $e664893e28e94056$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$e664893e28e94056$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor, shouldRetryError: shouldRetryError = $e664893e28e94056$export$fee2242cbb339663 } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $e664893e28e94056$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($e664893e28e94056$export$de0b576cf7ce4a53(err)) throw new (0, $3sO2v.RequestError)('clientAbortedRequest', metadata, err);
        if (!shouldRetryError(err)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $3sO2v.isRequestError)(lastError)) throw $e664893e28e94056$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $3sO2v.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $e664893e28e94056$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $e664893e28e94056$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $e664893e28e94056$export$6397609af718d008(statusCode);
    return new (0, $3sO2v.RequestError)(reason, {
        ...metadata,
        ...$e664893e28e94056$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $e664893e28e94056$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $e664893e28e94056$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $e664893e28e94056$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("5dnAb", function(module, exports) {

$parcel$export(module.exports, "isUndefined", () => $dff36c30c7a04cdc$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $dff36c30c7a04cdc$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $dff36c30c7a04cdc$export$456b25e3a9b4a843);
const $dff36c30c7a04cdc$export$fce6876652108ab = (value)=>value === undefined;
const $dff36c30c7a04cdc$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $dff36c30c7a04cdc$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $dff36c30c7a04cdc$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $dff36c30c7a04cdc$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $dff36c30c7a04cdc$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $dff36c30c7a04cdc$export$456b25e3a9b4a843(byte) {
    let randomHex;
    if (window?.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $dff36c30c7a04cdc$var$getRandomHexValues(byte);
    }
    else randomHex = $dff36c30c7a04cdc$var$getRandomHexValues(byte);
    return randomHex;
}

});

parcelRegister("7MBC8", function(module, exports) {

$parcel$export(module.exports, "mapAuthToQueryParameters", () => $7c8cac7e10bc1186$export$6833b130611df767);
parcelRequire("lixMv");
var $7rnCq = parcelRequire("7rnCq");
function $7c8cac7e10bc1186$export$6833b130611df767(auth) {
    if ((0, $7rnCq.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});



parcelRegister("bfOXs", function(module, exports) {

$parcel$export(module.exports, "mapToMediaCdnUrl", () => $74caf9558a39318b$export$fb88a576cf28364d);

var $fHpHg = parcelRequire("fHpHg");

var $5hRRN = parcelRequire("5hRRN");
const $74caf9558a39318b$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
// Cloudfront has a hard limit of 8,192 bytes
// https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/cloudfront-limits.html
// Assuming other parts of the URL make up a max of ~1000 (in reality it's lower), the token can be ~7000
const $74caf9558a39318b$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
function $74caf9558a39318b$export$fb88a576cf28364d(url, token) {
    const tokenLength = token?.length ?? 0;
    if (!(0, $5hRRN.isCommercial)() || tokenLength > $74caf9558a39318b$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $fHpHg.fg)('platform_media_cdn_delivery') && (0, $fHpHg.fg)('platform_media_cdn_single_host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = $74caf9558a39318b$export$8a9b6ab3569a543a[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});

parcelRegister("haS1j", function(module, exports) {

$parcel$export(module.exports, "resolveAuth", () => $717dcc756d5f22ec$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $717dcc756d5f22ec$export$5211e1371264aec3);

var $lk3RE = parcelRequire("lk3RE");

var $d0ds0 = parcelRequire("d0ds0");
const $717dcc756d5f22ec$export$560085fe411c0660 = 10000;
const $717dcc756d5f22ec$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $717dcc756d5f22ec$export$560085fe411c0660)=>{
    let auth;
    try {
        auth = await Promise.race([
            authProvider(authContext),
            (0, $d0ds0.rejectTimeout)(authProviderTimeout, new (0, $lk3RE.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        if (err instanceof (0, $lk3RE.MediaStoreError)) throw err;
        throw new (0, $lk3RE.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $lk3RE.MediaStoreError)('emptyAuth');
    /*
    We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
    Token expiration check in the frontend is a bad idea. Don't do it!
    More info:
    https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
    https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
  */ return auth;
};
const $717dcc756d5f22ec$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $lk3RE.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("lk3RE", function(module, exports) {

$parcel$export(module.exports, "MediaStoreError", () => $c2642d98ed8444bc$export$b78480bd311630bc);

var $8CwRc = parcelRequire("8CwRc");
class $c2642d98ed8444bc$export$b78480bd311630bc extends (0, $8CwRc.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason, undefined, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}
function $c2642d98ed8444bc$export$8d2a9b675b2ce37a(err) {
    return err instanceof $c2642d98ed8444bc$export$b78480bd311630bc;
}

});

parcelRegister("d0ds0", function(module, exports) {

$parcel$export(module.exports, "rejectTimeout", () => $7c0ef5bdd4062cfe$export$cf2d2a1124beacb2);
const $7c0ef5bdd4062cfe$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $7c0ef5bdd4062cfe$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});



parcelRegister("bgrr3", function(module, exports) {

$parcel$export(module.exports, "FileFetcherImpl", () => $578e4c6252c43057$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("gTWcW")).FileFetcherError);

var $aZdZn = parcelRequire("aZdZn");

var $cVFxd = parcelRequire("cVFxd");

var $bXrHm = parcelRequire("bXrHm");
parcelRequire("lixMv");
var $7rnCq = parcelRequire("7rnCq");

var $gATYO = parcelRequire("gATYO");

var $j7yhV = parcelRequire("j7yhV");

var $aTfy3 = parcelRequire("aTfy3");

var $fDJ6P = parcelRequire("fDJ6P");

var $gTWcW = parcelRequire("gTWcW");

var $jWohE = parcelRequire("jWohE");

var $eG8k2 = parcelRequire("eG8k2");

var $eXASx = parcelRequire("eXASx");

var $dC3bt = parcelRequire("dC3bt");

var $6CZ6k = parcelRequire("6CZ6k");

var $e91tu = parcelRequire("e91tu");

var $fiRQb = parcelRequire("fiRQb");

var $b2BVS = parcelRequire("b2BVS");

var $8Fm1W = parcelRequire("8Fm1W");

var $5cxf1 = parcelRequire("5cxf1");
var $fmdNs = parcelRequire("fmdNs");

var $c6i0Y = parcelRequire("c6i0Y");

var $j8fT1 = parcelRequire("j8fT1");

var $9hbur = parcelRequire("9hbur");

var $hZuIa = parcelRequire("hZuIa");

var $9sRH8 = parcelRequire("9sRH8");

var $6jRc4 = parcelRequire("6jRc4");
parcelRequire("9RtOq");
var $5f1nm = parcelRequire("5f1nm");

var $2oNs1 = parcelRequire("2oNs1");

var $k9Ibc = parcelRequire("k9Ibc");

var $8CwRc = parcelRequire("8CwRc");
const $578e4c6252c43057$var$isCopySourceFileWithToken = (token)=>!!token.authProvider;
const $578e4c6252c43057$var$isCopyDestinationWithToken = (token)=>!!token.authProvider;
class $578e4c6252c43057$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $5f1nm.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.getErrorFileState = (error, id, occurrenceKey)=>{
            if ((0, $8CwRc.isCommonMediaClientError)(error)) return (0, $8CwRc.fromCommonMediaClientError)(id, occurrenceKey, error);
            // ________________________________________________
            // Legacy serializers
            // We need to revisit all the incoming error types and ensure all the "reason" values are known
            // We need to change the input error: any for a known type.
            if (typeof error === 'string') {
                const err = new (0, $8CwRc.CommonMediaClientError)(error);
                return (0, $8CwRc.fromCommonMediaClientError)(id, occurrenceKey, err);
            } else {
                const err = new (0, $8CwRc.CommonMediaClientError)(error?.reason || 'unknown', error?.metadata, error?.innerError);
                return (0, $8CwRc.fromCommonMediaClientError)(id, occurrenceKey, err);
            }
        };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        this.createDownloadFileStream = (id, collectionName, occurrenceKey, includeHashForDuplicateFiles, forceRefresh)=>{
            const subject = (0, $j8fT1.createMediaSubject)();
            const poll = new (0, $9sRH8.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                if (forceRefresh) this.dataloader.clear({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                if ((0, $fDJ6P.isNotFoundMediaItemDetails)(response)) throw new (0, $gTWcW.FileFetcherError)('emptyItems', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                if ((0, $6jRc4.isEmptyFile)(response)) throw new (0, $gTWcW.FileFetcherError)('zeroVersionFile', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                const fileState = (0, $aTfy3.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $8Fm1W.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $fiRQb.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.dataloader = (0, $e91tu.createFileDataloader)(mediaApi);
        this.copyIntentRegisterationBatcher = (0, $2oNs1.createCopyIntentRegisterationBatcher)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey, includeHashForDuplicateFiles: includeHashForDuplicateFiles, forceRefresh: forceRefresh } = options;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6CZ6k)))(id)) {
            const subject = (0, $j8fT1.createMediaSubject)();
            const err = new (0, $gTWcW.FileFetcherError)('invalidFileId', {
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $5cxf1.fromObservable)(subject);
        }
        if (forceRefresh) (0, $eG8k2.getFileStreamsCache)().remove(id);
        return (0, $5cxf1.fromObservable)((0, $eG8k2.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName, undefined, includeHashForDuplicateFiles, forceRefresh);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $fmdNs.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
    }
    touchFiles(descriptors, collection, traceContext) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext) {
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
        const occurrenceKey = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $j8fT1.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const name = url.split('/').pop() || '';
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: name,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $eG8k2.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $9hbur.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $c6i0Y.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                mimeType: type,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $j8fT1.createMediaSubject)();
        (0, $eG8k2.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $aZdZn.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $cVFxd.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $b2BVS.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $jWohE.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller?.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $5cxf1.fromObservable)(subject);
    }
    async downloadBinary(id, name = 'download', collectionName, traceContext) {
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
        (0, $gATYO.downloadUrl)(url, {
            name: name
        });
        (0, $eXASx.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $dC3bt.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
        // Test the download after initiated the Browser process to catch any potential errors.
        await this.mediaApi.testUrl(url, {
            traceContext: traceContext
        });
    }
    async registerCopyIntent(id, collectionName) {
        // pre-resolving auth to add it to the key
        const auth = await this.mediaApi.resolveAuth({
            collectionName: collectionName
        });
        const key = {
            id: id,
            collectionName: collectionName,
            resolvedAuth: auth
        };
        const error = await this.copyIntentRegisterationBatcher.load(key);
        if (error) {
            // if the error is retryable then it should not be cached
            if ((0, $k9Ibc.defaultShouldRetryError)(error)) this.copyIntentRegisterationBatcher.clear(key);
            throw error;
        }
    }
    async copyFileWithToken(source, destination, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const mediaStore = destination.mediaStore || new (0, $j7yhV.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $7rnCq.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const { data: data } = await mediaStore.copyFileWithToken(body, params, traceContext);
        return data;
    }
    async copyFileWithIntent(source, destination, traceContext) {
        const res = await this.mediaApi.copyFile(source.id, {
            sourceCollection: source.collection,
            collection: destination.collection,
            replaceFileId: destination.replaceFileId
        }, traceContext);
        const { data: data } = res;
        return data;
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { id: id } = source;
        const { collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const cache = (0, $eG8k2.getFileStreamsCache)();
        let processingSubscription;
        try {
            let copiedFile;
            if ($578e4c6252c43057$var$isCopySourceFileWithToken(source) && $578e4c6252c43057$var$isCopyDestinationWithToken(destination)) copiedFile = await this.copyFileWithToken(source, destination, traceContext);
            else copiedFile = await this.copyFileWithIntent(source, destination, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $9hbur.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $aTfy3.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $j8fT1.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $aTfy3.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $aTfy3.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $hZuIa.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $b2BVS.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $b2BVS.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $aTfy3.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $aTfy3.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $aTfy3.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $eG8k2.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $j8fT1.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("gATYO", function(module, exports) {

$parcel$export(module.exports, "downloadUrl", () => $670edbe6d64c7d59$export$8a96edb1c96563f4);
const $670edbe6d64c7d59$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("aTfy3", function(module, exports) {

$parcel$export(module.exports, "isUploadingFileState", () => $f5b08f78cad697e1$export$70eb3481b487c668);
$parcel$export(module.exports, "isProcessingFileState", () => $f5b08f78cad697e1$export$5c30e6dd75278e66);
$parcel$export(module.exports, "isProcessedFileState", () => $f5b08f78cad697e1$export$1d17291aafa5f231);
$parcel$export(module.exports, "isErrorFileState", () => $f5b08f78cad697e1$export$f863e1e09c8a926);
$parcel$export(module.exports, "isPreviewableFileState", () => $f5b08f78cad697e1$export$92dd692b31e42e64);
$parcel$export(module.exports, "isFinalFileState", () => $f5b08f78cad697e1$export$270b3fc27120edd0);
$parcel$export(module.exports, "isNonErrorFinalFileState", () => $f5b08f78cad697e1$export$8f33148a37b0c72f);
$parcel$export(module.exports, "isImageRepresentationReady", () => $f5b08f78cad697e1$export$4e33ccde53b4f0bf);
$parcel$export(module.exports, "mapMediaFileToFileState", () => $f5b08f78cad697e1$export$ddfd67d20657322f);
$parcel$export(module.exports, "mapMediaItemToFileState", () => $f5b08f78cad697e1$export$ea3730792e8bebfb);
const $f5b08f78cad697e1$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
const $f5b08f78cad697e1$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
const $f5b08f78cad697e1$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
const $f5b08f78cad697e1$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
const $f5b08f78cad697e1$export$92dd692b31e42e64 = (fileState)=>!$f5b08f78cad697e1$export$f863e1e09c8a926(fileState) && !!fileState.preview;
const $f5b08f78cad697e1$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
const $f5b08f78cad697e1$export$8f33148a37b0c72f = (fileState)=>[
        'processed',
        'failed-processing'
    ].includes(fileState.status);
const $f5b08f78cad697e1$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
const $f5b08f78cad697e1$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext, hash: hash, abuseClassification: abuseClassification } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        hash: hash,
        metadataTraceContext: metadataTraceContext,
        abuseClassification: abuseClassification
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing'
            };
    }
};
const $f5b08f78cad697e1$export$ea3730792e8bebfb = (id, item)=>{
    return $f5b08f78cad697e1$export$ddfd67d20657322f({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("gTWcW", function(module, exports) {

$parcel$export(module.exports, "FileFetcherError", () => $2fea15270da0f754$export$e3e60f0dab8641de);

var $8CwRc = parcelRequire("8CwRc");
class $2fea15270da0f754$export$e3e60f0dab8641de extends (0, $8CwRc.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey, traceContext: traceContext } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            ...traceContext && {
                metadata: {
                    traceContext: traceContext
                }
            }
        };
    }
}
function $2fea15270da0f754$export$5c3435f75ce0ce70(err) {
    return err instanceof $2fea15270da0f754$export$e3e60f0dab8641de;
}

});

parcelRegister("jWohE", function(module, exports) {

$parcel$export(module.exports, "uploadFile", () => $8025203f57f70ed9$export$a5575dbeeffdad98);

var $dfvkB = parcelRequire("dfvkB");

var $gI62y = parcelRequire("gI62y");

var $ib0Rz = parcelRequire("ib0Rz");

var $gFHqJ = parcelRequire("gFHqJ");

var $jPWWR = parcelRequire("jPWWR");

var $dC3bt = parcelRequire("dC3bt");

var $wfpNn = parcelRequire("wfpNn");
const $8025203f57f70ed9$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $gFHqJ.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $8025203f57f70ed9$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $8025203f57f70ed9$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $8025203f57f70ed9$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext);
        offset += chunks.length;
    };
};
const $8025203f57f70ed9$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    const body = file.size ? {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    } : {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType
    };
    return store.createFileFromUpload(body, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext);
};
const $8025203f57f70ed9$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $dC3bt.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $wfpNn.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $wfpNn.fileSizeError)) callbacks?.onUploadFinish(new (0, $jPWWR.UploaderError)(err.message, {
            id: id,
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks?.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $dfvkB.chunkinator)(content, {
        hashingFunction: (blob)=>$8025203f57f70ed9$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $8025203f57f70ed9$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $dC3bt.PROCESSING_BATCH_SIZE),
        processingFunction: $8025203f57f70ed9$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $gI62y.from)(deferredUploadId).pipe((0, $ib0Rz.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $ib0Rz.concatMap)(()=>(0, $gI62y.from)($8025203f57f70ed9$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $8025203f57f70ed9$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("dfvkB", function(module, exports) {

$parcel$export(module.exports, "chunkinator", () => $3f181ebe34ae165c$export$9ab6bef3838698f8);

var $j7Dz8 = parcelRequire("j7Dz8");

var $ib0Rz = parcelRequire("ib0Rz");

var $9RLLl = parcelRequire("9RLLl");

var $bXPjr = parcelRequire("bXPjr");

var $cIQm8 = parcelRequire("cIQm8");

var $hRlE4 = parcelRequire("hRlE4");

var $4nuRZ = parcelRequire("4nuRZ");

var $9KSRm = parcelRequire("9KSRm");

var $ibj0Y = parcelRequire("ibj0Y");

var $gI62y = parcelRequire("gI62y");
const $3f181ebe34ae165c$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $bXPjr.fromPromise)((0, $ibj0Y.fetchBlob)(file)).pipe((0, $ib0Rz.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $cIQm8.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $hRlE4.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $4nuRZ.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $j7Dz8.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $9KSRm.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $ib0Rz.concatMap)((batchedChunks)=>{
            return (0, $gI62y.from)(batchedChunks);
        }), (0, $9RLLl.bufferCount)(totalChunks));
    }));
const $3f181ebe34ae165c$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return $3f181ebe34ae165c$export$88e80b3a0bb31f63(file, options, callbacks);
};

});
parcelRegister("cIQm8", function(module, exports) {

$parcel$export(module.exports, "slicenator", () => $87e02b59a110a9ff$export$5b92d769f2f57509);

var $eTa7E = parcelRequire("eTa7E");

var $cVFxd = parcelRequire("cVFxd");
const $87e02b59a110a9ff$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $eTa7E.range)(0, totalChunks).pipe((0, $cVFxd.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});

parcelRegister("hRlE4", function(module, exports) {

$parcel$export(module.exports, "hashinator", () => $14efb9a24ae15a94$export$d5f5a550a38ec367);

var $ibj0Y = parcelRequire("ibj0Y");
const $14efb9a24ae15a94$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));
const $14efb9a24ae15a94$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $ibj0Y.asyncMap)($14efb9a24ae15a94$export$28a452a485721473(hasher), concurrency)(blobs$);

});
parcelRegister("ibj0Y", function(module, exports) {

$parcel$export(module.exports, "fetchBlob", () => $937a05d9880ff6a9$export$14e9cfd4a872cc1e);
$parcel$export(module.exports, "asyncMap", () => $937a05d9880ff6a9$export$707ee4c4c95d39e3);

var $kVLXA = parcelRequire("kVLXA");

var $80gxR = parcelRequire("80gxR");
async function $937a05d9880ff6a9$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}
const $937a05d9880ff6a9$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $937a05d9880ff6a9$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $kVLXA.Observable)((sub)=>{
            notifiers.push($937a05d9880ff6a9$var$notify(project(value), sub, onReady));
        });
};
const $937a05d9880ff6a9$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $80gxR.mergeMap)($937a05d9880ff6a9$var$mapper(project), concurrent);

});


parcelRegister("4nuRZ", function(module, exports) {

$parcel$export(module.exports, "uploadinator", () => $7cc4263ab077041b$export$94ce0f3fcf999415);

var $ibj0Y = parcelRequire("ibj0Y");
const $7cc4263ab077041b$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $ibj0Y.asyncMap)(upload, options.concurrency));
};

});

parcelRegister("9KSRm", function(module, exports) {

$parcel$export(module.exports, "processinator", () => $bd694f19746972da$export$2f21790600302ed);

var $9RLLl = parcelRequire("9RLLl");

var $ib0Rz = parcelRequire("ib0Rz");
const $bd694f19746972da$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $9RLLl.bufferCount)(options.batchSize)).pipe((0, $ib0Rz.concatMap)(process));
};

});


parcelRegister("gFHqJ", function(module, exports) {

$parcel$export(module.exports, "createHasher", () => $a69756ed3211b563$export$14b114effbc08b6b);
parcelRequire("lixMv");
var $il6yz = parcelRequire("il6yz");
let $a69756ed3211b563$var$hasher = null;
let $a69756ed3211b563$var$sha256Hasher = null;
const $a69756ed3211b563$export$b7d263e6bc26b29a = ()=>$a69756ed3211b563$var$hasher = null;



const $a69756ed3211b563$export$14b114effbc08b6b = async (algorithm)=>{
    const numWorkers = 3;
    if (algorithm === (0, $il6yz.ChunkHashAlgorithm).Sha256) {
        if (!$a69756ed3211b563$var$sha256Hasher) {
            // TODO this needs to support worker sha256 hasher as well
            const { SimpleHasher: SimpleHasher } = await (parcelRequire("4D6hf"));
            $a69756ed3211b563$var$sha256Hasher = new SimpleHasher();
        }
        return $a69756ed3211b563$var$sha256Hasher;
    } else if (!$a69756ed3211b563$var$hasher) try {
        const { WorkerHasher: WorkerHasher } = await (parcelRequire("bQY8h"));
        $a69756ed3211b563$var$hasher = new WorkerHasher(numWorkers);
    } catch (error) {
        const { SimpleHasher: SimpleHasher } = await (parcelRequire("ci17I"));
        $a69756ed3211b563$var$hasher = new SimpleHasher();
    }
    return $a69756ed3211b563$var$hasher;
};

});
parcelRegister("4D6hf", function(module, exports) {

let $35efac79c6cbffee$var$load = (parcelRequire("28QjX"))(4);
module.exports = $35efac79c6cbffee$var$load("ZAfE6").then(()=>parcelRequire('hOYJZ'));

});

parcelRegister("bQY8h", function(module, exports) {

let $8a133217d270c381$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8a133217d270c381$var$load("cM9em"),
    $8a133217d270c381$var$load("fr9NE"),
    $8a133217d270c381$var$load("1p0DY")
]).then(()=>parcelRequire('cHsZj'));

});

parcelRegister("ci17I", function(module, exports) {

let $8f280994333ddeae$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8f280994333ddeae$var$load("cM9em"),
    $8f280994333ddeae$var$load("fr9NE"),
    $8f280994333ddeae$var$load("44U4q")
]).then(()=>parcelRequire('4zprW'));

});


parcelRegister("jPWWR", function(module, exports) {

$parcel$export(module.exports, "UploaderError", () => $38c7509f4dac2a8c$export$515240c3f059c807);

var $8CwRc = parcelRequire("8CwRc");
class $38c7509f4dac2a8c$export$515240c3f059c807 extends (0, $8CwRc.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $38c7509f4dac2a8c$export$80ee180172bc336(err) {
    return err instanceof $38c7509f4dac2a8c$export$515240c3f059c807;
}

});

parcelRegister("wfpNn", function(module, exports) {

$parcel$export(module.exports, "fileSizeError", () => $17e66662ada854c5$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $17e66662ada854c5$export$71f452e02035c1e2);

var $fDJ6P = parcelRequire("fDJ6P");

var $dC3bt = parcelRequire("dC3bt");
const $17e66662ada854c5$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $17e66662ada854c5$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $dC3bt.MAX_UPLOAD_FILE_SIZE)) throw new Error($17e66662ada854c5$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $fDJ6P.DATA_UNIT).GB) return 5 * (0, $fDJ6P.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $fDJ6P.DATA_UNIT).GB && fileSize <= 50 * (0, $fDJ6P.DATA_UNIT).GB) return 50 * (0, $fDJ6P.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $fDJ6P.DATA_UNIT).GB && fileSize <= 0.95 * (0, $fDJ6P.DATA_UNIT).TB) return 100 * (0, $fDJ6P.DATA_UNIT).MB;
    return 210 * (0, $fDJ6P.DATA_UNIT).MB;
};

});


parcelRegister("eG8k2", function(module, exports) {

$parcel$export(module.exports, "getFileStreamsCache", () => $2761b19fd9fa0a28$export$f2f061938c1e6810);
class $2761b19fd9fa0a28$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}
let $2761b19fd9fa0a28$var$streamCache;

const $2761b19fd9fa0a28$export$f2f061938c1e6810 = ()=>{
    if (!$2761b19fd9fa0a28$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("j40QZ")).mediaState;
        $2761b19fd9fa0a28$var$streamCache = new $2761b19fd9fa0a28$export$4293896e79732236(mediaState.streams);
    }
    return $2761b19fd9fa0a28$var$streamCache;
};

});

parcelRegister("eXASx", function(module, exports) {

$parcel$export(module.exports, "globalMediaEventEmitter", () => $8a8d11e2a47449ce$export$68d003d3105952ad);
parcelRequire("lixMv");
var $j40QZ = parcelRequire("j40QZ");
const $8a8d11e2a47449ce$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $j40QZ.mediaState).eventEmitter) (0, $j40QZ.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $j40QZ.mediaState).eventEmitter) (0, $j40QZ.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $j40QZ.mediaState).eventEmitter) return (0, $j40QZ.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});

parcelRegister("6CZ6k", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $5k7LC = parcelRequire("5k7LC");
var $4d35b0145f276bfe$require$Buffer = $5k7LC.Buffer;
var $4d35b0145f276bfe$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $4d35b0145f276bfe$var$_byteToHex = [];
for(var $4d35b0145f276bfe$var$i = 0; $4d35b0145f276bfe$var$i < 256; $4d35b0145f276bfe$var$i++)$4d35b0145f276bfe$var$_byteToHex[$4d35b0145f276bfe$var$i] = ($4d35b0145f276bfe$var$i + 0x100).toString(16).substr(1);
function $4d35b0145f276bfe$var$unparse(buf, offset) {
    var i = offset || 0, bth = $4d35b0145f276bfe$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($4d35b0145f276bfe$require$Buffer.isBuffer(uuid)) parsedUuid = $4d35b0145f276bfe$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$4d35b0145f276bfe$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $4d35b0145f276bfe$var$extractVersion(parsedUuid);
    else if ($4d35b0145f276bfe$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $4d35b0145f276bfe$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("e91tu", function(module, exports) {

$parcel$export(module.exports, "createFileDataloader", () => $d245fe7d46af0b80$export$ae188fee39529b82);

var $hhZW9 = parcelRequire("hhZW9");

var $5dnAb = parcelRequire("5dnAb");
const $d245fe7d46af0b80$export$b79d95ee17a87a = 100;
const $d245fe7d46af0b80$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $d245fe7d46af0b80$var$isResponseFileItem = (fileItem)=>{
    return 'details' in fileItem;
};
const $d245fe7d46af0b80$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $d245fe7d46af0b80$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $d245fe7d46af0b80$var$makeCacheKey(id, collection);
        if ($d245fe7d46af0b80$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
        else if ($d245fe7d46af0b80$var$isResponseFileItem(fileItem)) prev[key] = {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        else prev[key] = {
            id: id,
            collection: collection,
            type: 'not-found',
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $d245fe7d46af0b80$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || {
            id: id,
            type: 'not-found'
        };
    });
};
function $d245fe7d46af0b80$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const includeHashByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            if (key.includeHashForDuplicateFiles) acc[collectionName] = key.includeHashForDuplicateFiles;
            return acc;
        }, {});
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $5dnAb.getRandomHex)(8),
                spanId: (0, $5dnAb.getRandomHex)(8)
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const includeHashForDuplicateFiles = includeHashByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext, includeHashForDuplicateFiles);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
                // add EmptyResponseFileItem for each file ID not included in /items response
                const itemsIds = itemsWithMetadataTraceContext.map((item)=>item.id);
                const fileIdsNotFound = fileIds.filter((id)=>!itemsIds.includes(id));
                fileIdsNotFound.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        type: 'not-found',
                        metadataTraceContext: metadataTraceContext
                    });
                });
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return $d245fe7d46af0b80$export$71cd2e8f8162d47b(keys, items);
    };
}
function $d245fe7d46af0b80$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($hhZW9)))($d245fe7d46af0b80$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $d245fe7d46af0b80$export$b79d95ee17a87a
    });
}

});
parcelRegister("hhZW9", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $c964119340a5ebe3$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $c964119340a5ebe3$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $c964119340a5ebe3$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $c964119340a5ebe3$var$getValidCacheKeyFn(options);
        this._cacheMap = $c964119340a5ebe3$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $c964119340a5ebe3$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $c964119340a5ebe3$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$c964119340a5ebe3$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $c964119340a5ebe3$var$enqueuePostPromiseJob = typeof $6cAn5 === 'object' && typeof $6cAn5.nextTick === 'function' ? function(fn) {
    if (!$c964119340a5ebe3$var$resolvedPromise) $c964119340a5ebe3$var$resolvedPromise = Promise.resolve();
    $c964119340a5ebe3$var$resolvedPromise.then(function() {
        $6cAn5.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $c964119340a5ebe3$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $c964119340a5ebe3$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $c964119340a5ebe3$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $c964119340a5ebe3$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $c964119340a5ebe3$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$c964119340a5ebe3$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $c964119340a5ebe3$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $c964119340a5ebe3$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $c964119340a5ebe3$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $c964119340a5ebe3$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $c964119340a5ebe3$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $c964119340a5ebe3$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $c964119340a5ebe3$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $c964119340a5ebe3$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $c964119340a5ebe3$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $c964119340a5ebe3$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $c964119340a5ebe3$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $c964119340a5ebe3$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $c964119340a5ebe3$var$DataLoader;

});


parcelRegister("fiRQb", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $d1419b18890fd36a$export$ac3214931ffd82af);

var $9hbur = parcelRequire("9hbur");
const $d1419b18890fd36a$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $9hbur.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});
parcelRegister("9hbur", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $827b23322392c274$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("4xFVv")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("4xFVv")).isVideoMimeTypeSupportedByBrowser);

var $7mTpN = parcelRequire("7mTpN");

var $4xFVv = parcelRequire("4xFVv");

var $fHB7k = parcelRequire("fHB7k");
const $827b23322392c274$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $7mTpN.isArchive)(mimeType)) return 'archive';
    if ((0, $4xFVv.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $fHB7k.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $4xFVv.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $fHB7k.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $4xFVv.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $fHB7k.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $4xFVv.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $fHB7k.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("7mTpN", function(module, exports) {

$parcel$export(module.exports, "isArchive", () => $ccb681eff88bedb7$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $ccb681eff88bedb7$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("4xFVv", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $c5f4af24a6c95b53$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $c5f4af24a6c95b53$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $c5f4af24a6c95b53$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $c5f4af24a6c95b53$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $c5f4af24a6c95b53$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $c5f4af24a6c95b53$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $c5f4af24a6c95b53$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $c5f4af24a6c95b53$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $c5f4af24a6c95b53$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $c5f4af24a6c95b53$export$55ca6cdaf6093034 = (mimeType)=>$c5f4af24a6c95b53$export$74325e3c843a9555(mimeType) || $c5f4af24a6c95b53$export$c021f2623a75015f(mimeType) || $c5f4af24a6c95b53$export$ff36075ea755a717(mimeType) || $c5f4af24a6c95b53$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("fHB7k", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $040879c03538fb68$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $040879c03538fb68$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $040879c03538fb68$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $040879c03538fb68$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $040879c03538fb68$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $040879c03538fb68$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $040879c03538fb68$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $040879c03538fb68$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $040879c03538fb68$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $040879c03538fb68$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $040879c03538fb68$export$548d9148a80556a3 = (mimeType)=>$040879c03538fb68$export$e9a065a80f76311e(mimeType) || $040879c03538fb68$export$86baad7a89d908e9(mimeType) || $040879c03538fb68$export$8cba23825d020bbb(mimeType) || $040879c03538fb68$export$9c2b4de5fdca2ce3(mimeType) || $040879c03538fb68$export$94e1479e01d2af53(mimeType);

});



parcelRegister("b2BVS", function(module, exports) {

$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $b40ed82d81b7f4ab$export$89097c0ec1e0dee1);

var $aTfy3 = parcelRequire("aTfy3");
const $b40ed82d81b7f4ab$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $aTfy3.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("8Fm1W", function(module, exports) {

$parcel$export(module.exports, "convertBase64ToBlob", () => $516baad7e61964ca$export$ed17558b11b88056);
const $516baad7e61964ca$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("5cxf1", function(module, exports) {

$parcel$export(module.exports, "fromObservable", () => $480dbf9794850b3f$export$4b2432e2d8723823);

var $j8fT1 = parcelRequire("j8fT1");
function $480dbf9794850b3f$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $480dbf9794850b3f$export$8659d1f07d151381(item) {
    return $480dbf9794850b3f$export$4b2432e2d8723823((0, $j8fT1.createMediaSubject)(item));
}

});
parcelRegister("j8fT1", function(module, exports) {

$parcel$export(module.exports, "createMediaSubject", () => $124b9b206ca5946b$export$bc76d51553fa5e35);

var $dZ0DN = parcelRequire("dZ0DN");
function $124b9b206ca5946b$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $dZ0DN.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});


parcelRegister("fmdNs", function(module, exports) {

$parcel$export(module.exports, "toPromise", () => $53f96470a65c3e76$export$4dbaaf6c79705e6c);

var $aZdZn = parcelRequire("aZdZn");
const $53f96470a65c3e76$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $aZdZn.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("c6i0Y", function(module, exports) {

$parcel$export(module.exports, "getDimensionsFromBlob", () => $cf16107acc24324b$export$71797c284d89a3e1);

var $9XUyc = parcelRequire("9XUyc");

var $krxAH = parcelRequire("krxAH");
const $cf16107acc24324b$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $9XUyc.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $krxAH.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("9XUyc", function(module, exports) {

$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $aa42516e483a510f$export$a1c3205f28a20414);
const $aa42516e483a510f$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("krxAH", function(module, exports) {

$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $73275891a7e5756a$export$62aabd5ff85d0451);
const $73275891a7e5756a$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("hZuIa", function(module, exports) {

$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $4e1d699a2ab47cd5$export$2ccdd6f9a9eba6a);

var $4xFVv = parcelRequire("4xFVv");
var $fHB7k = parcelRequire("fHB7k");

var $krxAH = parcelRequire("krxAH");
async function $4e1d699a2ab47cd5$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $4xFVv.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $fHB7k.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $krxAH.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("9sRH8", function(module, exports) {

$parcel$export(module.exports, "PollingFunction", () => $33e32384923a466a$export$4c54d536f8e37dc2);

var $kTuzC = parcelRequire("kTuzC");
const $33e32384923a466a$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $33e32384923a466a$export$4c54d536f8e37dc2 {
    constructor(options){
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.timeoutId = 0;
        this.options = {
            ...$33e32384923a466a$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $kTuzC.PollingError)('pollingMaxAttemptsExceeded', {
            attempts: this.attempt
        }));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $kTuzC.PollingError)('pollingMaxAttemptsExceeded', {
                attempts: this.attempt
            }));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("kTuzC", function(module, exports) {

$parcel$export(module.exports, "PollingError", () => $b42da6633560df2f$export$c3748c310e92340a);

var $8CwRc = parcelRequire("8CwRc");
class $b42da6633560df2f$export$c3748c310e92340a extends (0, $8CwRc.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { attempts: attempts } } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}
function $b42da6633560df2f$export$541e3e52eea6fece(err) {
    return err instanceof $b42da6633560df2f$export$c3748c310e92340a;
}

});


parcelRegister("6jRc4", function(module, exports) {

$parcel$export(module.exports, "isEmptyFile", () => $69b5c79a27d02e27$export$728192ce8dd94659);
const $69b5c79a27d02e27$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $69b5c79a27d02e27$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $69b5c79a27d02e27$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("9RtOq", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => (parcelRequire("5f1nm")).mediaStore);

var $5f1nm = parcelRequire("5f1nm");

});
parcelRegister("5f1nm", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => $54d094b720f6ef10$export$5785580dea19518d);

var $bIv98 = parcelRequire("bIv98");

var $70n8Q = parcelRequire("70n8Q");

var $ee7sp = parcelRequire("ee7sp");
const $54d094b720f6ef10$var$mediaStoreWithoutDevtools = (0, $ee7sp.createStore)()((0, $bIv98.subscribeWithSelector)((0, $70n8Q.immer)(()=>({
        files: {}
    }))));
const $54d094b720f6ef10$var$mediaStoreWithDevtools = (0, $ee7sp.createStore)()((0, $bIv98.devtools)((0, $bIv98.subscribeWithSelector)((0, $70n8Q.immer)(()=>({
        files: {}
    })))));
const $54d094b720f6ef10$export$5785580dea19518d = $54d094b720f6ef10$var$mediaStoreWithoutDevtools;
const $54d094b720f6ef10$export$503459913a0dc356 = (initialStore)=>{
    return (0, $ee7sp.createStore)()((0, $bIv98.subscribeWithSelector)((0, $70n8Q.immer)(()=>({
            files: {},
            ...initialStore
        }))));
};

});
parcelRegister("bIv98", function(module, exports) {

$parcel$export(module.exports, "devtools", () => $887bf6c78f4461c3$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $887bf6c78f4461c3$export$5c593627aef9f076);
var $887bf6c78f4461c3$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $887bf6c78f4461c3$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $887bf6c78f4461c3$export$4feba8a1bc8e9afd = $887bf6c78f4461c3$var$reduxImpl;
const $887bf6c78f4461c3$var$trackedConnections = /* @__PURE__ */ new Map();
const $887bf6c78f4461c3$var$getTrackedConnectionState = (name)=>{
    const api = $887bf6c78f4461c3$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $887bf6c78f4461c3$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $887bf6c78f4461c3$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $887bf6c78f4461c3$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $887bf6c78f4461c3$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) {
            if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $887bf6c78f4461c3$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$887bf6c78f4461c3$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $887bf6c78f4461c3$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $887bf6c78f4461c3$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $887bf6c78f4461c3$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $887bf6c78f4461c3$export$6922d3b3a607469e = $887bf6c78f4461c3$var$devtoolsImpl;
const $887bf6c78f4461c3$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $887bf6c78f4461c3$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $887bf6c78f4461c3$export$5c593627aef9f076 = $887bf6c78f4461c3$var$subscribeWithSelectorImpl;
const $887bf6c78f4461c3$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $887bf6c78f4461c3$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $887bf6c78f4461c3$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $887bf6c78f4461c3$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $887bf6c78f4461c3$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $887bf6c78f4461c3$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $887bf6c78f4461c3$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $887bf6c78f4461c3$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $887bf6c78f4461c3$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $887bf6c78f4461c3$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $887bf6c78f4461c3$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $887bf6c78f4461c3$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $887bf6c78f4461c3$var$oldImpl(config, baseOptions);
    }
    return $887bf6c78f4461c3$var$newImpl(config, baseOptions);
};
const $887bf6c78f4461c3$export$9a6132153fba2e0 = $887bf6c78f4461c3$var$persistImpl;

});

parcelRegister("70n8Q", function(module, exports) {

$parcel$export(module.exports, "immer", () => $519a7bf2c276fd5a$export$428de7ec69ac95c);

var $86xFr = parcelRequire("86xFr");
const $519a7bf2c276fd5a$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $86xFr.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $519a7bf2c276fd5a$export$428de7ec69ac95c = $519a7bf2c276fd5a$var$immerImpl;

});
parcelRegister("86xFr", function(module, exports) {

$parcel$export(module.exports, "produce", () => fn);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $5e68ffea5fb572cb$export$2e2bcd8739ae039 = fn;

});


parcelRegister("ee7sp", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $a5b82856cfbd137f$export$f51a9068ac82ea43);
var $a5b82856cfbd137f$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $a5b82856cfbd137f$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($a5b82856cfbd137f$import_meta.env ? $a5b82856cfbd137f$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $a5b82856cfbd137f$export$f51a9068ac82ea43 = (createState)=>createState ? $a5b82856cfbd137f$var$createStoreImpl(createState) : $a5b82856cfbd137f$var$createStoreImpl;
var $a5b82856cfbd137f$export$2e2bcd8739ae039 = (createState)=>{
    if (($a5b82856cfbd137f$import_meta.env ? $a5b82856cfbd137f$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $a5b82856cfbd137f$export$f51a9068ac82ea43(createState);
};

});



parcelRegister("2oNs1", function(module, exports) {

$parcel$export(module.exports, "createCopyIntentRegisterationBatcher", () => $46a86f78d899a40c$export$57945b6819e39246);

var $hhZW9 = parcelRequire("hhZW9");

var $5dnAb = parcelRequire("5dnAb");
const $46a86f78d899a40c$export$b79d95ee17a87a = 100;
/**
 * Returns a function that, given Array<DataloaderKey>, resolves to an array of same length containing either DataloaderResult or Error.
 * Such contract is formalised by Dataloader 1.0, @see https://github.com/graphql/dataloader
 *
 * If an Error is resolved in the results, it must be at same position then their corresponding key:
 * - Dataloader will re-throw that Error when accessing/loading that particular key
 *
 * @param mediaStore instance of MediaStore
 */ function $46a86f78d899a40c$var$createBatchCopyIntentRegisterationFunc(mediaStore) {
    return async (keys)=>{
        const keysByToken = keys.reduce((acc, key)=>{
            const token = key.resolvedAuth.token;
            acc[token] = acc[token] || [];
            // de-duplicate ids in collection
            const hasDuplicates = acc[token].some(({ id: id, collectionName: collectionName })=>key.id === id && collectionName === key.collectionName);
            if (!hasDuplicates) acc[token].push(key);
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(keysByToken).map(async (batchKey)=>{
            const metadataTraceContext = {
                traceId: (0, $5dnAb.getRandomHex)(8),
                spanId: (0, $5dnAb.getRandomHex)(8)
            };
            const files = keysByToken[batchKey].map((key)=>({
                    id: key.id,
                    collection: key.collectionName
                }));
            // given these are batched by the token the assumption is that they have the same details.
            const resolvedAuth = keysByToken[batchKey][0].resolvedAuth;
            try {
                await mediaStore.registerCopyIntents(files, metadataTraceContext, resolvedAuth);
            } catch (error) {
                files.forEach(({ id: id, collection: collection })=>{
                    items.push({
                        id: id,
                        collection: collection,
                        error: error
                    });
                });
            }
        }));
        return keys.map(({ id: id, collectionName: collectionName })=>{
            return items.find((item)=>item.id === id && item.collection === collectionName)?.error;
        });
    };
}
function $46a86f78d899a40c$export$57945b6819e39246(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($hhZW9)))($46a86f78d899a40c$var$createBatchCopyIntentRegisterationFunc(mediaStore), {
        maxBatchSize: $46a86f78d899a40c$export$b79d95ee17a87a,
        cacheKeyFn: ({ id: id, collectionName: collectionName = 'default', resolvedAuth: resolvedAuth })=>`${id}-${collectionName}-${resolvedAuth.token}`
    });
}

});


parcelRegister("3vsCy", function(module, exports) {

$parcel$export(module.exports, "StargateClient", () => $df109b0905f1c0e2$export$c66ca190f89caaac);
class $df109b0905f1c0e2$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("dXv4B", function(module, exports) {

let $a298e390956fe039$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a298e390956fe039$var$load("ifbX2").then(()=>parcelRequire('lcNvE'));

});



parcelRegister("7Sl8R", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2e2e33a7ecbd93a$export$2e2bcd8739ae039);

var $70f7p = parcelRequire("70f7p");

var $lteuh = parcelRequire("lteuh");

var $5fQjB = parcelRequire("5fQjB");

var $iwKVT = parcelRequire("iwKVT");
const $c2e2e33a7ecbd93a$var$getRequiredRepresentation = (emoji, useAlt)=>useAlt ? emoji.altRepresentation : emoji.representation;
const $c2e2e33a7ecbd93a$var$isUnsupportedBrowser = ()=>{
    const isIE = !!document.documentMode; // Internet Explorer 6-11
    const isEdge = !isIE && !!window.StyleMedia; // Edge 20+
    return isIE || isEdge;
};
class $c2e2e33a7ecbd93a$export$3850f566ce8d817a {
    constructor(mediaImageLoader){
        this.cachedImageUrls = new Set();
        (0, $5fQjB.default)('BrowserCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
    }
    loadEmoji(emoji, useAlt) {
        const representation = $c2e2e33a7ecbd93a$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $70f7p.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        if (this.cachedImageUrls.has(mediaPath)) // Already cached
        return emoji;
        return this.mediaImageLoader.loadMediaImage(mediaPath).then(()=>{
            // Media is loaded, can use original URL now, so just return original emoji
            this.cachedImageUrls.add(mediaPath);
            return emoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return true;
    }
    static supported(mediaPath, mediaImageLoader) {
        // IE/Edge uses memory cache strategy else images can fail to load
        // from a clean cache/if they are downloaded from the service
        // TODO: fix as a part of FS-1592
        if ($c2e2e33a7ecbd93a$var$isUnsupportedBrowser()) return Promise.resolve(false);
        return mediaImageLoader.loadMediaImage(mediaPath).then(()=>// Image should be cached in browser, if supported it should be accessible from the cache by an <img/>
            // Try to load without via image to confirm this support (this fails in Firefox)
            new Promise((resolve)=>{
                const img = new Image();
                img.addEventListener('load', ()=>{
                    resolve(true);
                });
                img.addEventListener('error', ()=>{
                    resolve(false);
                });
                img.src = mediaPath;
            })).catch(()=>false);
    }
}
const $c2e2e33a7ecbd93a$var$maxImageCached = 1000;
// Don't cache images large than this - dataUrl size in characters
const $c2e2e33a7ecbd93a$var$maxImageSize = 10000;
class $c2e2e33a7ecbd93a$export$b522858a3709f4c {
    constructor(mediaImageLoader){
        (0, $5fQjB.default)('MemoryCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
        this.dataURLCache = new (0, $iwKVT.LRUMap)($c2e2e33a7ecbd93a$var$maxImageCached);
    }
    loadEmoji(emoji, useAlt) {
        const representation = $c2e2e33a7ecbd93a$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $70f7p.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const dataURL = this.dataURLCache.get(mediaPath);
        if (dataURL) // Already cached
        return (0, $70f7p.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
        // Not cached, load
        return this.mediaImageLoader.loadMediaImage(mediaPath).then((dataURL)=>{
            const loadedEmoji = (0, $70f7p.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
            if (dataURL.length <= $c2e2e33a7ecbd93a$var$maxImageSize) // Only cache if not large than max size
            this.dataURLCache.set(mediaPath, dataURL);
            else (0, $5fQjB.default)('No caching as image is too large', dataURL.length, dataURL.slice(0, 15), emoji.shortName);
            return loadedEmoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return false;
    }
}
class $c2e2e33a7ecbd93a$export$2e2bcd8739ae039 {
    constructor(tokenManager){
        this.waitingInitUrls = [];
        (0, $5fQjB.default)('MediaEmojiCache');
        this.mediaImageLoader = new (0, $lteuh.default)(tokenManager);
    }
    loadEmoji(emoji, useAlt) {
        const representation = $c2e2e33a7ecbd93a$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $70f7p.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const emojiCache = this.getCache(mediaPath);
        if ((0, $70f7p.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.loadEmoji(emoji, useAlt)).catch(()=>undefined);
        return emojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(url) {
        const emojiCache = this.getCache(url);
        if ((0, $70f7p.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.optimisticRendering()).catch(()=>false);
        return emojiCache.optimisticRendering();
    }
    getCache(url) {
        if (this.cache) return this.cache;
        this.waitingInitUrls.push(url);
        if (!this.cacheLoading) this.cacheLoading = this.initCache().then((cache)=>{
            this.cache = cache;
            this.cacheLoading = undefined;
            return cache;
        }).catch((err)=>{
            this.cacheLoading = undefined;
            throw err;
        });
        return this.cacheLoading;
    }
    initCache() {
        const url = this.waitingInitUrls.pop();
        if (!url) return Promise.reject('Unable to initialise cache based on provided url(s)');
        return $c2e2e33a7ecbd93a$export$3850f566ce8d817a.supported(url, this.mediaImageLoader).then((supported)=>{
            this.waitingInitUrls = []; // clear
            this.cacheLoading = undefined;
            if (supported) return new $c2e2e33a7ecbd93a$export$3850f566ce8d817a(this.mediaImageLoader);
            return new $c2e2e33a7ecbd93a$export$b522858a3709f4c(this.mediaImageLoader);
        }).catch(()=>{
            return this.initCache();
        });
    }
}

});
parcelRegister("lteuh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7408497b400d6413$export$2e2bcd8739ae039);

var $iAy3i = parcelRequire("iAy3i");
const $7408497b400d6413$var$defaultConcurrentDownloadLimit = 16;
const $7408497b400d6413$var$backoffMaxDelayInMillis = 600;
const $7408497b400d6413$var$defaultMaxRetriesOnNotFound = 2;
class $7408497b400d6413$export$2e2bcd8739ae039 {
    constructor(tokenManager, options){
        this.mediaImageQueue = [];
        this.activeProcessing = 0;
        this.pendingRequests = new Map();
        this.concurrentDownloadLimit = options && options.concurrentDownloadLimit || $7408497b400d6413$var$defaultConcurrentDownloadLimit;
        this.tokenManager = tokenManager;
    }
    loadMediaImage(url) {
        const maybePending = this.pendingRequests.get(url);
        if (maybePending !== undefined) return maybePending;
        const pending = new Promise((resolve, reject)=>{
            this.mediaImageQueue.push({
                url: url,
                resolve: resolve,
                reject: reject
            });
            this.processFromQueue();
        }).then((result)=>{
            this.pendingRequests.delete(url);
            return result;
        }).catch((error)=>{
            this.pendingRequests.delete(url);
            throw error;
        });
        this.pendingRequests.set(url, pending);
        return pending;
    }
    getQueueSize() {
        return this.mediaImageQueue.length;
    }
    getActiveDownloads() {
        return this.activeProcessing;
    }
    processFromQueue() {
        while(this.activeProcessing < this.concurrentDownloadLimit && this.mediaImageQueue.length > 0){
            this.activeProcessing++;
            const item = this.mediaImageQueue.shift();
            const { url: url, resolve: resolve, reject: reject } = item;
            this.tokenManager.getToken('read', false).then((token)=>{
                this.requestMediaEmoji(url, token, true).then((dataURL)=>{
                    resolve(dataURL);
                    this.completedItem();
                }).catch((error)=>{
                    reject(error);
                    this.completedItem();
                });
            }).catch((error)=>{
                // Failed to load, just resolve to original emoji
                reject(error);
                this.completedItem();
            });
        }
    }
    completedItem() {
        this.activeProcessing--;
        this.processFromQueue();
    }
    delay(durationInMillis) {
        return new Promise((resolve)=>setTimeout(resolve, durationInMillis));
    }
    requestMediaEmoji(url, token, retryOnAuthError, retriesOnNotFound = $7408497b400d6413$var$defaultMaxRetriesOnNotFound) {
        return (0, $iAy3i.imageAcceptHeader)().then((acceptHeader)=>{
            // Media REST API: https://media-api-internal.atlassian.io/api.html#file__fileId__image_get
            const options = {
                headers: {
                    Authorization: `Bearer ${token.jwt}`,
                    'X-Client-Id': token.clientId,
                    Accept: acceptHeader
                }
            };
            return fetch(url, options).then((response)=>{
                // retry if 404
                if (response.status === 404 && retriesOnNotFound > 0) return this.delay($7408497b400d6413$var$backoffMaxDelayInMillis / retriesOnNotFound) // backoff strategy
                .then(()=>this.requestMediaEmoji(url, token, false, retriesOnNotFound - 1));
                else if (response.status === 403 && retryOnAuthError) // retry once if 403
                return this.tokenManager.getToken('read', true).then((newToken)=>this.requestMediaEmoji(url, newToken, false));
                else if (response.ok) return response.blob().then((blob)=>this.readBlob(blob));
                throw new Error(`Unable to load media image. Status=${response.status} ${response.statusText}`);
            });
        });
    }
    readBlob(blob) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            // TODO: [ts30] Add proper handling for null and ArrayBuffer
            reader.addEventListener('load', ()=>resolve(reader.result));
            reader.addEventListener('error', ()=>reject(reader.error));
            reader.readAsDataURL(blob);
        });
    }
}

});
parcelRegister("iAy3i", function(module, exports) {

$parcel$export(module.exports, "getNaturalImageSize", () => $dbae7acf0d60ecaf$export$90153ab95f408dfa);
$parcel$export(module.exports, "parseImage", () => $dbae7acf0d60ecaf$export$37bbb051492a18a7);
$parcel$export(module.exports, "hasFileExceededSize", () => $dbae7acf0d60ecaf$export$a115ddd5941792f1);
$parcel$export(module.exports, "imageAcceptHeader", () => $dbae7acf0d60ecaf$export$f8e7886bc155c2e6);
const $dbae7acf0d60ecaf$var$maxEmojiSizeInBytes = 1048576;
const $dbae7acf0d60ecaf$export$90153ab95f408dfa = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.addEventListener('load', ()=>{
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
        });
        img.addEventListener('error', reject);
        img.src = dataURL;
    });
};
const $dbae7acf0d60ecaf$export$37bbb051492a18a7 = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        let img = new Image();
        img.onload = ()=>resolve({
                src: img.src
            });
        img.onerror = ()=>reject();
        img.src = dataURL;
    });
};
const $dbae7acf0d60ecaf$export$a115ddd5941792f1 = (file)=>{
    return file && file.size > $dbae7acf0d60ecaf$var$maxEmojiSizeInBytes;
};
// Duplicates https://bitbucket.org/atlassian/atlaskit/src/0e843df6df8bcd33fa7fc16cc63f11a0f6094957/packages/media-core/src/utils/checkWebpSupport.ts?at=master&fileviewer=file-view-default
// Didn't want to depend on the whole of media-core just for this util
/**
 * Checks if Webp support is enabled in the browser.
 * We know that creating a new image in memory and checking its height,
 * later on we cache this value forever.
 */ let $dbae7acf0d60ecaf$var$isWebpSupported;
const $dbae7acf0d60ecaf$export$c5a964eb84c7fca8 = ()=>{
    if ($dbae7acf0d60ecaf$var$isWebpSupported !== undefined) return Promise.resolve($dbae7acf0d60ecaf$var$isWebpSupported);
    return new Promise((resolve)=>{
        const img = new Image();
        const checkSupport = ()=>{
            $dbae7acf0d60ecaf$var$isWebpSupported = img.height === 2;
            resolve($dbae7acf0d60ecaf$var$isWebpSupported);
        };
        img.addEventListener('load', checkSupport);
        img.addEventListener('error', checkSupport);
        img.src = 'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
    });
};
const $dbae7acf0d60ecaf$export$f8e7886bc155c2e6 = ()=>$dbae7acf0d60ecaf$export$c5a964eb84c7fca8().then((isWebpSupported)=>{
        // q=0.8 stands for 'quality factor' => http://stackoverflow.com/a/10496722
        const noWebpAcceptHeader = 'image/*,*/*;q=0.8';
        const webpAcceptHeader = 'image/webp,image/*,*/*;q=0.8';
        return isWebpSupported ? webpAcceptHeader : noWebpAcceptHeader;
    });

});



parcelRegister("9c6C2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d702c06ec4350e9e$export$2e2bcd8739ae039);

var $ddgvn = parcelRequire("ddgvn");
const $d702c06ec4350e9e$export$866c20c059277b6 = 30;
class $d702c06ec4350e9e$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig){
        this.siteServiceConfig = siteServiceConfig;
        this.tokens = new Map();
    }
    isValidToken(mediaApiToken) {
        const nowInSeconds = Date.now() / 1000;
        const expiresAt = mediaApiToken.expiresAt - $d702c06ec4350e9e$export$866c20c059277b6;
        if (nowInSeconds < expiresAt) return true;
        return false;
    }
    fetchNewToken(type) {
        return (0, $ddgvn.utils).requestService(this.siteServiceConfig, {
            path: `token/${type}`
        });
    }
    addToken(type, mediaApiToken) {
        this.tokens.set(type, {
            mediaApiToken: mediaApiToken
        });
    }
    getToken(type, forceRefresh) {
        let tokenDetail = this.tokens.get(type);
        if (!tokenDetail) {
            tokenDetail = {};
            this.tokens.set(type, tokenDetail);
        }
        const { mediaApiToken: mediaApiToken, activeTokenRefresh: activeTokenRefresh } = tokenDetail;
        if (mediaApiToken) {
            if (this.isValidToken(mediaApiToken) && !forceRefresh) // still valid
            return Promise.resolve(mediaApiToken);
        }
        if (activeTokenRefresh) // refresh token promise already active, return that
        return activeTokenRefresh;
        // request a new token and track the promise for future requests until completed
        tokenDetail.activeTokenRefresh = this.fetchNewToken(type).then((token)=>{
            tokenDetail.mediaApiToken = token;
            tokenDetail.activeTokenRefresh = undefined;
            return token;
        });
        return tokenDetail.activeTokenRefresh;
    }
}

});


parcelRegister("2AeLS", function(module, exports) {

$parcel$export(module.exports, "ufoExperiences", () => $8ef0511a56530f67$export$615f888019c45765);
$parcel$export(module.exports, "sampledUfoRenderedEmoji", () => $8ef0511a56530f67$export$71c8cba6f1251ea9);
$parcel$export(module.exports, "hasUfoMarked", () => $8ef0511a56530f67$export$a9be054d2a5cedc0);
$parcel$export(module.exports, "sampledUfoEmojiResourceFetched", () => $8ef0511a56530f67$export$1466212a1606133);

var $eyWYN = parcelRequire("eyWYN");

var $766ff = parcelRequire("766ff");
var $2DPlK = parcelRequire("2DPlK");
var $88I8J = parcelRequire("88I8J");

var $30bPV = parcelRequire("30bPV");
const $8ef0511a56530f67$var$createRenderExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $2DPlK.ExperienceTypes).Load,
        performanceType: (0, $2DPlK.ExperiencePerformanceTypes).PageSegmentLoad
    };
};
const $8ef0511a56530f67$var$createInlineExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $2DPlK.ExperienceTypes).Experience,
        performanceType: (0, $2DPlK.ExperiencePerformanceTypes).InlineResult
    };
};
const $8ef0511a56530f67$var$customEmojiTimings = [
    {
        key: (0, $eyWYN.UfoEmojiTimingsKeys).FMP,
        endMark: (0, $eyWYN.UfoEmojiTimings).FMP_END
    },
    {
        key: (0, $eyWYN.UfoEmojiTimingsKeys).METADATA,
        component: 'resourced-emoji',
        startMark: (0, $eyWYN.UfoEmojiTimings).METADATA_START,
        endMark: (0, $eyWYN.UfoEmojiTimings).METADATA_END
    },
    {
        key: (0, $eyWYN.UfoEmojiTimingsKeys).MEDIADATA,
        component: 'caching-emoji',
        startMark: (0, $eyWYN.UfoEmojiTimings).MEDIA_START,
        endMark: (0, $eyWYN.UfoEmojiTimings).MEDIA_END
    },
    {
        key: (0, $eyWYN.UfoEmojiTimingsKeys).MOUNTED,
        component: 'emoji',
        endMark: (0, $eyWYN.UfoEmojiTimings).MOUNTED_END
    },
    {
        key: (0, $eyWYN.UfoEmojiTimingsKeys).ONLOAD,
        startMark: (0, $eyWYN.UfoEmojiTimings).ONLOAD_START,
        endMark: (0, $eyWYN.UfoEmojiTimings).ONLOAD_END
    }
];
const $8ef0511a56530f67$export$615f888019c45765 = {
    'emoji-rendered': new (0, $766ff.ConcurrentExperience)((0, $eyWYN.UfoExperienceName).EMOJI_RENDERED, {
        platform: {
            component: (0, $eyWYN.UfoComponentName).EMOJI
        },
        type: (0, $2DPlK.ExperienceTypes).Operation,
        performanceType: (0, $2DPlK.ExperiencePerformanceTypes).Custom,
        timings: $8ef0511a56530f67$var$customEmojiTimings
    }),
    'emoji-resource-fetched': new (0, $766ff.ConcurrentExperience)((0, $eyWYN.UfoExperienceName).EMOJI_RESOURCE_FETCHED, $8ef0511a56530f67$var$createRenderExperience((0, $eyWYN.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-picker-opened': new (0, $88I8J.UFOExperience)((0, $eyWYN.UfoExperienceName).EMOJI_PICKER_OPENED, $8ef0511a56530f67$var$createRenderExperience((0, $eyWYN.UfoComponentName).EMOJI_PICKER)),
    'emoji-selection-recorded': new (0, $88I8J.UFOExperience)((0, $eyWYN.UfoExperienceName).EMOJI_SELECTION_RECORDED, $8ef0511a56530f67$var$createInlineExperience((0, $eyWYN.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-uploaded': new (0, $88I8J.UFOExperience)((0, $eyWYN.UfoExperienceName).EMOJI_UPLOADED, $8ef0511a56530f67$var$createInlineExperience((0, $eyWYN.UfoComponentName).EMOJI_PICKER)),
    'emoji-searched': new (0, $88I8J.UFOExperience)((0, $eyWYN.UfoExperienceName).EMOJI_SEARCHED, $8ef0511a56530f67$var$createInlineExperience((0, $eyWYN.UfoComponentName).EMOJI_PICKER))
};
const $8ef0511a56530f67$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $30bPV.withSampling)($8ef0511a56530f67$export$615f888019c45765['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};
const $8ef0511a56530f67$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};
const $8ef0511a56530f67$export$1466212a1606133 = (providerType)=>{
    return (0, $30bPV.withSampling)($8ef0511a56530f67$export$615f888019c45765['emoji-resource-fetched'].getInstance(providerType));
};

});
parcelRegister("30bPV", function(module, exports) {

$parcel$export(module.exports, "withSampling", () => $d4447dd127bc04b1$export$dc2f0946255b3f89);
const $d4447dd127bc04b1$export$c7c4959fece2f3ec = {};
const $d4447dd127bc04b1$export$cdff9a865136ae27 = ()=>{
    for (const prop of Object.getOwnPropertyNames($d4447dd127bc04b1$export$c7c4959fece2f3ec))delete $d4447dd127bc04b1$export$c7c4959fece2f3ec[prop];
};
const $d4447dd127bc04b1$export$1c967630b3ea2d58 = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $d4447dd127bc04b1$var$hasSampledFromStart = (experience)=>{
    if (!$d4447dd127bc04b1$export$c7c4959fece2f3ec[experience.id]) return false;
    if (experience.instanceId) // if the instance of concurrent exp has been sampled from start, allow it.
    return $d4447dd127bc04b1$export$c7c4959fece2f3ec[experience.id].sampledInstance[experience.instanceId];
    return $d4447dd127bc04b1$export$c7c4959fece2f3ec[experience.id].sampled;
};
const $d4447dd127bc04b1$export$dc2f0946255b3f89 = (ufoExperience)=>{
    const init = ()=>{
        if (!$d4447dd127bc04b1$export$c7c4959fece2f3ec[ufoExperience.id]) $d4447dd127bc04b1$export$c7c4959fece2f3ec[ufoExperience.id] = {
            sampled: false,
            sampledInstance: {}
        };
    };
    const start = async (options)=>{
        // check if the experience has already sampled before
        if ($d4447dd127bc04b1$var$hasSampledFromStart(ufoExperience)) return;
        const isSampled = options.samplingFunc || $d4447dd127bc04b1$export$1c967630b3ea2d58;
        if (!isSampled(options.samplingRate)) {
            if (ufoExperience.instanceId) $d4447dd127bc04b1$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
            $d4447dd127bc04b1$export$c7c4959fece2f3ec[ufoExperience.id].sampled = false;
            return;
        }
        // update sampled records
        if (ufoExperience.instanceId) {
            $d4447dd127bc04b1$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
            $d4447dd127bc04b1$export$c7c4959fece2f3ec[ufoExperience.id].sampled = true;
        }
        return ufoExperience.start(options.startTime);
    };
    const success = async (config)=>{
        if (!$d4447dd127bc04b1$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.success(config);
    };
    const failure = async (config)=>{
        if (!$d4447dd127bc04b1$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.failure(config);
    };
    const abort = async (config)=>{
        if (!$d4447dd127bc04b1$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.abort(config);
    };
    const addMetadata = (data)=>{
        if (!$d4447dd127bc04b1$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.addMetadata(data);
    };
    const mark = (name, timestamp)=>{
        if (!$d4447dd127bc04b1$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.mark(name, timestamp);
    };
    const markFMP = (timestamp)=>{
        if (!$d4447dd127bc04b1$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markFMP(timestamp);
    };
    const markInlineResponse = (timestamp)=>{
        if (!$d4447dd127bc04b1$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markInlineResponse(timestamp);
    };
    init();
    return {
        ...ufoExperience,
        start: start,
        addMetadata: addMetadata,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};

});


parcelRegister("fSL8m", function(module, exports) {

$parcel$export(module.exports, "promiseWithTimeout", () => $5ed19972db44b82d$export$a9cd205a244d9f54);
function $5ed19972db44b82d$export$a9cd205a244d9f54(promise, timeout, errorMessage = 'Timed out') {
    // Create a promise that rejects after the specified timeout
    const timeoutPromise = new Promise((_, reject)=>setTimeout(()=>reject(new Error(errorMessage)), timeout));
    // Use Promise.race to race the provided promise against the timeout promise
    return Promise.race([
        promise,
        timeoutPromise
    ]);
}

});


parcelRegister("9CGZY", function(module, exports) {

$parcel$export(module.exports, "EMOJI_SERVICEID", () => $2d9090d159781c68$export$f3c4ed49c0fff3de);
$parcel$export(module.exports, "EMOJI_WITH_CUSTOM_SERVICEID", () => $2d9090d159781c68$export$f8b39b441e3e8eb2);
$parcel$export(module.exports, "EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID", () => $2d9090d159781c68$export$2cdcb9248b6d4704);
$parcel$export(module.exports, "getServiceProvider", () => $2d9090d159781c68$export$a4c27db78169052e);
$parcel$export(module.exports, "default", () => $2d9090d159781c68$export$2e2bcd8739ae039);

var $j8DrX = parcelRequire("j8DrX");
const $2d9090d159781c68$var$providersRepository = {};
const $2d9090d159781c68$export$f3c4ed49c0fff3de = 'emoji';
const $2d9090d159781c68$export$f8b39b441e3e8eb2 = 'emoji-with-custom';
const $2d9090d159781c68$export$2cdcb9248b6d4704 = 'emoji-with-custom-upload-disabled';
const $2d9090d159781c68$var$getServiceBaseUrl = (serviceId)=>{
    if (serviceId === $2d9090d159781c68$export$f8b39b441e3e8eb2 || serviceId === $2d9090d159781c68$export$2cdcb9248b6d4704) return (0, $j8DrX.default)('ajs-fabric-emoji-url');
    return (0, $j8DrX.default)(`ajs-fabric-${serviceId}-url`);
};
const $2d9090d159781c68$export$a4c27db78169052e = (serviceId, serviceProviderGenerator)=>{
    try {
        let serviceProvider = $2d9090d159781c68$var$providersRepository[serviceId];
        if (serviceProvider === undefined) {
            const serviceBaseUrl = $2d9090d159781c68$var$getServiceBaseUrl(serviceId);
            if (serviceBaseUrl) {
                serviceProvider = Promise.resolve(serviceProviderGenerator(serviceBaseUrl));
                $2d9090d159781c68$var$providersRepository[serviceId] = serviceProvider;
            }
        }
        return serviceProvider;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
};
const $2d9090d159781c68$export$59790759c19337ec = ()=>{
    Object.keys($2d9090d159781c68$var$providersRepository).forEach((key)=>{
        delete $2d9090d159781c68$var$providersRepository[key];
    });
};
var $2d9090d159781c68$export$2e2bcd8739ae039 = $2d9090d159781c68$var$getServiceBaseUrl;

});



parcelRegister("6ZDS2", function(module, exports) {

$parcel$export(module.exports, "AnalyticContext", () => $c529cbf8cbd12a6e$export$da0556bf821b3494);
$parcel$export(module.exports, "AnalyticContextProvider", () => $c529cbf8cbd12a6e$export$aea8e3edcdec81e3);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");




var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $3RJbG = parcelRequire("3RJbG");
const $c529cbf8cbd12a6e$export$da0556bf821b3494 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    fireUIAnalyticForFixMenuItem: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    fireUIAnalyticForFixButton: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    fireUIAnalyticForFavouriteToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    fireUIAnalyticForRoadmapsItems: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});
const $c529cbf8cbd12a6e$export$aea8e3edcdec81e3 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireUIAnalyticForFixMenuItem = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
                itemId: (0, $3RJbG.VIEW_ALL_ROADMAPS)
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFixButton = (0, $5uXOq.useCallback)(({ itemId: itemId })=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                itemId: itemId
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForFavouriteToggle = (0, $5uXOq.useCallback)(({ starType: starType, parentItemId: parentItemId })=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                componentType: (0, $1e554a683893bd46$export$74712b62056d422e),
                parentItemId: parentItemId,
                parentItemType: 'roadmap',
                itemId: starType
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireUIAnalyticForRoadmapsItems = (0, $5uXOq.useCallback)(({ itemId: itemId, section: section })=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_ROADMAPS],
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$3ac911b122986477),
                itemType: (0, $632bd8725b437a12$export$bb8a37ab8d9ba82b).toLowerCase(),
                itemId: itemId,
                section: section
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const value = (0, $5uXOq.useMemo)(()=>({
            fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem,
            fireUIAnalyticForFixButton: fireUIAnalyticForFixButton,
            fireUIAnalyticForFavouriteToggle: fireUIAnalyticForFavouriteToggle,
            fireUIAnalyticForRoadmapsItems: fireUIAnalyticForRoadmapsItems
        }), [
        fireUIAnalyticForFavouriteToggle,
        fireUIAnalyticForFixButton,
        fireUIAnalyticForFixMenuItem,
        fireUIAnalyticForRoadmapsItems
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c529cbf8cbd12a6e$export$da0556bf821b3494.Provider, {
        value: value
    }, children);
};

});
parcelRegister("3RJbG", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $071bfededeb4df80$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $071bfededeb4df80$export$d57b6b390e78d90f);
$parcel$export(module.exports, "VIEW_ALL_ROADMAPS", () => $071bfededeb4df80$export$3fc15b6d7f7757ac);
$parcel$export(module.exports, "CREATE_ROADMAP", () => $071bfededeb4df80$export$862abc666c31a61a);
$parcel$export(module.exports, "MEATBALL_DROPDOWN", () => $071bfededeb4df80$export$f06dfcec5ff912e);
$parcel$export(module.exports, "PERMISSIONS_CACHE_TTL", () => $071bfededeb4df80$export$5448370085586a5f);
const $071bfededeb4df80$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Roadmaps';
const $071bfededeb4df80$export$d57b6b390e78d90f = 'jpd-aurora';
const $071bfededeb4df80$export$3fc15b6d7f7757ac = 'viewAllRoadmaps';
const $071bfededeb4df80$export$862abc666c31a61a = 'createRoadmaps';
const $071bfededeb4df80$export$f06dfcec5ff912e = 'meatballDropdown';
const $071bfededeb4df80$export$5448370085586a5f = 600000; // 10 minutes

});


parcelRegister("8VrTR", function(module, exports) {

$parcel$export(module.exports, "ActionButtons", () => $08de0fe365426435$export$88c65d2d98aab183);

var $5uXOq = parcelRequire("5uXOq");

var $g7g8o = parcelRequire("g7g8o");

var $aOrxC = parcelRequire("aOrxC");

var $5KCCi = parcelRequire("5KCCi");

var $koVbs = parcelRequire("koVbs");

var $46Cti = parcelRequire("46Cti");

var $1xonH = parcelRequire("1xonH");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $kG753 = parcelRequire("kG753");

var $95bJk = parcelRequire("95bJk");

var $6jadJ = parcelRequire("6jadJ");

var $6ZDS2 = parcelRequire("6ZDS2");

var $3RJbG = parcelRequire("3RJbG");

var $1poXk = parcelRequire("1poXk");
const $08de0fe365426435$export$88c65d2d98aab183 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [IsCreateCollectionOpen, setIsCreateCollectionOpen] = (0, $5uXOq.useState)(false);
    const isReadOnly = (0, $6jadJ.useIsReadOnly)();
    const { addCollection: addCollection } = (0, $95bJk.useNavigationCollectionsActions)();
    const { fireUIAnalyticForFixButton: fireUIAnalyticForFixButton } = (0, $5uXOq.useContext)((0, $6ZDS2.AnalyticContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, IsCreateCollectionOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kG753.CollectionCreate), {
        isOpen: IsCreateCollectionOpen,
        onSuccess: (collection)=>{
            addCollection({
                ...collection,
                isExpanded: true
            });
        },
        onClose: ()=>setIsCreateCollectionOpen(false)
    }), !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: formatMessage((0, $1poXk.default).createRoadmap)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xonH.CommonNavMenuButton), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g7g8o))),
        label: formatMessage((0, $1poXk.default).createRoadmap),
        onClick: ()=>{
            fireUIAnalyticForFixButton({
                itemId: (0, $3RJbG.CREATE_ROADMAP)
            });
            setIsCreateCollectionOpen(true);
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        onOpen: ()=>fireUIAnalyticForFixButton({
                itemId: (0, $3RJbG.MEATBALL_DROPDOWN)
            }),
        MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
                menuId: (0, $46Cti.L1_MENU_ID).ROADMAPS,
                hasSeparator: false
            }))
    }));
});

});
parcelRegister("kG753", function(module, exports) {

$parcel$export(module.exports, "CollectionCreate", () => $ea1a9a9ad6a5b7f5$export$e31c3ec1e288349f);

var $5uXOq = parcelRequire("5uXOq");

var $5g2iQ = parcelRequire("5g2iQ");

var $0yZbT = parcelRequire("0yZbT");
var $2GZKW = parcelRequire("2GZKW");
var $2Eqc8 = parcelRequire("2Eqc8");
var $2s57o = parcelRequire("2s57o");

var $4R6GH = parcelRequire("4R6GH");

var $iXVV6 = parcelRequire("iXVV6");

var $eOMZh = parcelRequire("eOMZh");

var $3FQk4 = parcelRequire("3FQk4");

var $dnM4Q = parcelRequire("dnM4Q");

var $6Gni9 = parcelRequire("6Gni9");
const $ea1a9a9ad6a5b7f5$export$e31c3ec1e288349f = ({ isOpen: isOpen, onSuccess: onSuccess, onClose: onClose })=>{
    const handleSuccess = (0, $5uXOq.useCallback)((collection)=>{
        onClose();
        onSuccess?.(collection);
    }, [
        onClose,
        onSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
        sourceName: "collectionCreate"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5g2iQ.default), {
        zIndex: (0, $eOMZh.DRAWER_Z_INDEX)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dnM4Q.Drawer), {
        isOpen: isOpen,
        onClose: onClose
    }, (0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        spread: "space-between",
        xcss: $ea1a9a9ad6a5b7f5$var$innerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $ea1a9a9ad6a5b7f5$var$backgroundLeftStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3FQk4.BackgroundLeft), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $ea1a9a9ad6a5b7f5$var$backgroundRightStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3FQk4.BackgroundRight), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $ea1a9a9ad6a5b7f5$var$formStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Gni9.Form), {
        onSuccess: handleSuccess
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2GZKW.default), {
        templateColumns: "minmax(550px, 1fr) minmax(0, 1fr)",
        alignItems: "center",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $2s57o.xcss)({
            height: '100%'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Gni9.Form), {
        onSuccess: handleSuccess
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3FQk4.Background), null)))));
};
const $ea1a9a9ad6a5b7f5$var$innerWrapperStyles = (0, $2s57o.xcss)({
    height: '100%'
});
const $ea1a9a9ad6a5b7f5$var$backgroundLeftStyles = (0, $2s57o.xcss)({
    alignSelf: 'flex-start',
    transform: 'translateY(150px)',
    order: 1
});
const $ea1a9a9ad6a5b7f5$var$formStyles = (0, $2s57o.xcss)({
    height: '100%',
    flex: 1,
    maxWidth: '420px',
    order: 2
});
const $ea1a9a9ad6a5b7f5$var$backgroundRightStyles = (0, $2s57o.xcss)({
    alignSelf: 'flex-end',
    transform: 'translateX(-60px) translateY(-40px)',
    order: 3
});

});
parcelRegister("eOMZh", function(module, exports) {

$parcel$export(module.exports, "DRAWER_Z_INDEX", () => $fa757a7b31bbf91b$export$66cb31822cec84b0);

var $gwIPs = parcelRequire("gwIPs");
const $fa757a7b31bbf91b$export$66cb31822cec84b0 = (0, $gwIPs.layers).navigation - 1;

});

parcelRegister("3FQk4", function(module, exports) {

$parcel$export(module.exports, "BackgroundRight", () => $936ceae5a4a545da$export$db8dbd68737e686a);
$parcel$export(module.exports, "BackgroundLeft", () => $936ceae5a4a545da$export$91862e78ed08ce2b);
$parcel$export(module.exports, "Background", () => $936ceae5a4a545da$export$668799e4797757a8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $936ceae5a4a545da$export$db8dbd68737e686a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "198",
        height: "206",
        viewBox: "0 0 198 206",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M99.0774 0.0321045C156.491 0.0321045 197.203 33.417 197.203 90.797C197.203 148.177 156.491 180.518 99.0774 180.518C41.6639 180.518 0.952148 148.177 0.952148 90.797C0.952148 33.417 41.6639 0.0321045 99.0774 0.0321045Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M157.964 158.788C154.33 158.315 148.912 160.281 145.992 158.838C146.88 158.921 147.369 147.145 144.44 149.268C143.594 149.972 143.196 151.283 144.482 151.623C142.092 152.734 145.793 158.78 140.234 161.301C140.151 158.108 125.772 163.076 134.152 163.225C134.351 161.956 134.401 165.24 136.757 162.827C145.22 163.689 141.901 167.745 144.83 174.105C144.415 182.846 150.688 176.046 147.452 171.725C149.709 166.127 141.653 161.765 151.302 164.17C152.273 162.13 163.407 161.997 157.956 158.788H157.964Z",
        fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M189.965 177.962C187.667 176.884 184.78 178.725 183.411 176.452C185.161 177.166 184.929 167.993 182.042 170.166C181.693 171.593 180.855 171.418 182.332 171.908C179.851 171.924 182.158 173.5 182.075 173.724C180.723 173.757 182.49 174.52 181.204 174.255C180.457 174.404 182.639 176.295 181.162 175.789C180.689 177.846 178.383 177.829 178.897 179.081C178.872 178.227 171.206 178.028 173.33 181.295C174.674 181.229 174.5 182.738 174.699 180.773C175.106 183.211 176.01 180.773 176.226 180.831C176.425 182.199 176.823 180.309 176.765 181.644C176.964 182.365 178.258 180.06 178.001 181.569C182.473 182.738 178.806 183.999 181.386 186.537C181.643 187.714 181.013 191.537 183.776 191.181C187.41 190.136 183.17 183.609 185.327 182.473C186.29 181.611 187.659 180.524 189.476 181.262C190.372 181.279 191.525 177.622 189.974 177.953L189.965 177.962Z",
        fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M172.525 138.793C173.363 139.689 180.225 139.755 180.225 139.755C180.225 139.755 181.66 141.298 181.137 142.467C182.407 143.305 182.448 145.378 182.166 147.501C182.257 148.588 186.19 149.118 185.518 147.402C186.356 145.818 183.685 140.883 185.676 141.281C185.659 139.092 189.401 140.013 188.264 137.027C187.933 135.095 186.406 136.214 186.257 135.791C181.561 139.764 185.908 125.135 181.005 127.523C180.772 128.983 181.104 132.126 180.582 133.229C179.71 134.282 179.76 135.534 180.001 136.845C178.507 136.438 172.21 136.82 172.517 138.785L172.525 138.793Z",
        fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M130.892 130.293C128.178 129.613 127.374 132.723 126.95 127.457C126.552 125.035 124.76 125.707 124.146 126.511C123.773 126.992 124.934 129.281 124.478 129.497C124.478 129.497 124.528 131.388 124.652 132.416C124.52 131.321 120.354 131.918 118.43 132.731C118.43 132.731 117.061 134.398 119.002 135.418C119.118 135.385 122.852 134.912 123.914 135.319C125.656 136.546 124.312 136.861 124.627 138.188C124.943 139.507 124.909 145.337 128.66 141.937C128.801 139.283 128.776 138.769 128.295 135.12C128.892 134.116 129.805 133.395 131.182 133.627C131.912 133.411 132.053 129.704 130.9 130.293H130.892Z",
        fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M145.154 192.806C142.441 192.126 141.636 195.236 141.213 189.97C140.815 187.548 139.022 188.22 138.408 189.025C138.035 189.506 139.197 191.795 138.74 192.01C138.74 192.01 138.79 193.901 138.915 194.929C138.782 193.835 134.617 194.432 132.692 195.244C132.692 195.244 131.323 196.911 133.264 197.931C133.381 197.898 137.114 197.426 138.176 197.832C139.919 199.059 138.574 199.374 138.89 200.701C139.205 202.02 139.172 207.85 142.922 204.45C143.063 201.796 143.038 201.282 142.557 197.633C143.154 196.629 144.067 195.908 145.444 196.14C146.174 195.925 146.315 192.218 145.162 192.806H145.154Z",
        fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M146.631 115.598C146.73 115.614 151.584 114.644 151.061 116.037C152.082 117.472 151.202 120.822 152.903 121.212C157.4 121.461 154.455 118.674 155.201 116.775C156.944 117.397 158.993 114.379 157.085 113.068C156.703 113.657 155.766 112.446 155.857 113.159L155.849 112.853C155.177 113.383 154.778 113.508 153.998 112.43C153.301 113.989 155.649 107.363 151.949 108.673C151.277 109.22 152.463 112.33 150.97 112.173C149.784 112.869 148.124 112.363 146.996 112.844C146.067 113.242 145.519 114.196 146.647 115.598H146.631Z",
        fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M99.6953 164.411C99.7949 164.427 104.649 163.457 104.126 164.85C105.146 166.285 104.267 169.635 105.968 170.025C110.465 170.274 107.519 167.487 108.266 165.588C110.008 166.21 112.058 163.192 110.149 161.881C109.768 162.47 108.83 161.259 108.921 161.973L108.913 161.666C108.241 162.196 107.843 162.321 107.063 161.243C106.366 162.802 108.714 156.176 105.014 157.486C104.342 158.033 105.528 161.143 104.035 160.986C102.848 161.682 101.189 161.176 100.06 161.657C99.1311 162.055 98.5835 163.009 99.7119 164.411H99.6953Z",
        fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M175.072 182.158C177.371 183.236 180.258 181.395 181.627 183.667C179.876 182.954 180.109 192.126 182.996 189.954C183.344 188.527 184.182 188.701 182.705 188.212C185.186 188.195 182.88 186.62 182.963 186.396C184.315 186.363 182.548 185.6 183.834 185.865C184.581 185.716 182.398 183.825 183.875 184.331C184.348 182.274 186.655 182.291 186.14 181.039C186.165 181.893 193.832 182.092 191.708 178.824C190.363 178.891 190.538 177.381 190.339 179.347C189.932 176.909 189.028 179.347 188.812 179.289C188.613 177.92 188.215 179.811 188.273 178.476C188.074 177.754 186.779 180.06 187.036 178.551C182.564 177.381 186.232 176.121 183.651 173.583C183.394 172.405 184.025 168.582 181.262 168.939C177.628 169.984 181.867 176.51 179.71 177.647C178.748 178.509 177.379 179.595 175.562 178.857C174.666 178.841 173.513 182.498 175.064 182.166L175.072 182.158Z",
        fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
    }));
const $936ceae5a4a545da$export$91862e78ed08ce2b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "229",
        height: "348",
        viewBox: "0 0 229 348",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M-17.712 223.275C25.1866 219.079 43.3717 192.967 43.3717 157.529C43.3717 124.889 26.5855 99.7089 -17.712 93.6471L-17.712 0.389389C91.8659 3.65341 156.68 62.4058 156.68 159.86C156.68 253.118 96.0624 317.932 -15.8469 317.932L-17.712 317.932L-17.712 223.275Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M-53.0385 204.302C-55.7656 201.702 -58.2371 198.874 -60.4691 195.838C-61.9722 194.501 -63.4991 193.184 -64.9488 191.79C-68.3729 187.463 -71.1376 182.829 -74.5539 178.482C-76.0293 176.194 -77.2453 173.75 -78.9148 171.594C-80.7764 169.09 -82.0795 166.235 -83.4797 163.46C-84.3114 161.804 -85.0303 160.095 -85.6462 158.347C-86.381 156.344 -86.9969 154.302 -87.5673 152.247C-88.1812 150.94 -88.7832 149.629 -89.3239 148.288C-89.916 144.689 -90.3201 141.065 -90.9855 137.481C-91.4509 135.292 -91.1875 133.056 -91.3419 130.842C-91.3677 128.04 -91.7499 125.131 -90.8746 122.426C-90.3557 120.52 -89.6071 118.69 -88.7813 116.902C-88.6248 115.617 -88.7892 114.185 -88.2545 112.993C-87.6762 111.943 -87.0424 110.929 -86.3849 109.927C-85.9334 108.806 -85.4957 107.675 -84.9333 106.606C-83.5252 104.584 -82.0359 102.619 -80.507 100.686C-79.6535 99.516 -78.8395 98.298 -77.8216 97.2603C-73.6765 92.9845 -68.88 89.4356 -63.7447 86.4352C-57.4549 82.5536 -50.6442 79.5493 -43.3978 78.0065C-40.6747 76.8084 -37.8665 75.9885 -34.9335 75.5033C-26.4354 73.7863 -17.7533 72.8158 -9.07898 72.8515C-2.17917 72.8753 4.69687 73.4931 11.561 74.1388C13.1196 74.4616 14.6584 74.923 16.2012 75.3211C18.3262 75.6518 20.473 75.8895 22.5504 76.4618C24.9883 77.1847 27.4777 77.6421 29.9731 78.1135C32.4545 78.6462 34.8924 79.377 37.3462 80.0246C41.3466 81.0386 45.1253 82.7576 48.9812 84.2132C56.487 86.7798 63.7809 89.9307 70.7164 93.7885C73.9762 95.3887 77.428 96.678 80.4601 98.6881C83.5258 100.831 86.7875 102.667 90.1384 104.322C91.5307 105.089 92.5823 106.228 93.8359 107.184C94.7726 107.677 95.7034 108.172 96.6362 108.673C98.076 109.337 99.0642 110.638 100.239 111.67C101.371 112.712 102.698 113.531 103.881 114.52C105.005 115.138 106.124 115.761 107.239 116.397C108.2 117.227 109.079 118.162 109.996 119.047C112.111 120.71 114.171 122.449 116.068 124.362C119.033 127.303 121.607 130.591 124.348 133.732C125.323 135.261 126.384 136.734 127.41 138.223C128.147 139.657 128.86 141.095 129.622 142.515C129.995 143.331 130.549 144.064 130.917 144.88C131.201 145.903 131.393 146.947 131.757 147.949C132.155 149.306 132.589 150.686 132.589 152.112C132.529 153.205 132.809 154.269 132.84 155.358C132.729 156.079 132.577 156.794 132.389 157.497C132.393 158.047 132.351 158.667 132.102 159.143C131.529 160.27 131.034 161.43 130.454 162.549C130.042 163.234 129.49 163.83 129.307 164.626C129.143 165.1 128.571 165.28 128.188 165.551C127.818 166.183 127.355 166.726 126.804 167.205C126.446 167.884 125.921 168.393 125.236 168.734C125.2 168.892 125.168 169.043 125.057 169.17C124.901 169.35 124.675 169.417 124.455 169.486C124.364 169.605 124.251 169.754 124.132 169.837C124.004 169.926 123.833 169.962 123.681 169.991C123.552 170.492 123.029 170.778 122.556 170.906C122.243 171.421 121.732 171.794 121.168 171.962C120.885 172.023 120.629 171.819 120.799 171.53C121.14 171.067 121.677 170.74 122.223 170.562C122.459 170.132 122.877 169.746 123.38 169.702C123.421 169.585 123.467 169.461 123.544 169.368C123.645 169.251 123.831 169.152 123.982 169.073C124.049 168.914 124.115 168.754 124.243 168.637C124.404 168.492 124.604 168.447 124.81 168.403C125.16 167.744 125.723 167.304 126.345 166.912C126.798 166.363 127.287 165.854 127.808 165.369C127.921 165.062 127.957 164.718 128.109 164.426C128.339 164.102 128.761 163.902 129.044 163.626C129.636 162.713 130.038 161.804 130.565 160.877C130.907 159.917 130.939 158.804 131.377 157.895C131.656 157.136 131.498 156.293 131.525 155.497C131.64 154.788 131.723 154.083 131.785 153.368C131.349 150.639 131.159 147.83 129.783 145.385C129.341 143.668 128.729 141.974 127.751 140.481C126.826 139.188 125.939 137.778 125.111 136.451C123.968 135.067 122.897 133.631 121.849 132.171C119.621 129.579 117.078 127.258 114.581 124.923C111.852 122.317 109.21 119.599 105.988 117.593C105.166 116.692 104.332 115.751 103.502 114.87C102.534 114.139 101.556 113.419 100.599 112.727C99.286 111.826 97.7967 111.204 96.4005 110.434C95.337 109.565 94.3092 108.644 93.2378 107.778C91.9802 107.131 90.7147 106.495 89.4492 105.867C86.1003 103.18 82.4405 101.021 78.5014 99.3357C75.6417 97.8227 72.9147 96.0423 70.045 94.5352C65.9277 92.6478 61.7946 90.7961 57.6059 89.0712C51.6053 86.354 45.4501 83.9854 39.0434 82.415C34.4726 80.8267 29.8008 79.5334 25.2042 78.0897C22.0157 77.5431 18.8965 76.9549 15.7516 76.2578C14.1217 76.1331 12.4918 76.032 10.86 75.9489C8.02003 75.4142 5.30882 75.0121 2.45304 74.8181C-9.58003 73.8556 -21.9775 74.3705 -33.7828 76.7529C-35.6108 77.1233 -37.407 77.6164 -39.2132 78.0759C-40.5737 78.2759 -41.9323 78.4937 -43.2869 78.7512C-45.8119 79.6562 -48.2954 80.6544 -50.5986 81.6981C-56.0349 83.9973 -61.5643 86.1996 -66.3113 89.7624C-69.9514 92.531 -73.3874 95.3927 -76.3343 98.8862C-78.7128 101.142 -80.7605 103.851 -82.1924 106.78C-82.8241 108.01 -83.7292 109.081 -84.3946 110.297C-84.6659 111.195 -84.9194 112.098 -85.1373 113.013C-85.1987 113.522 -85.4462 113.971 -85.7532 114.373C-86.3117 115.221 -86.8503 116.084 -87.3593 116.962C-87.6465 119.067 -87.8841 121.182 -88.0307 123.301C-88.203 125.038 -88.7238 126.525 -88.8664 128.216C-89.1773 130.385 -89.1952 132.565 -88.9456 134.74C-88.7971 136.39 -88.9357 138.069 -88.6763 139.711C-88.3436 142.151 -87.694 144.484 -86.7988 146.769C-86.2958 148.31 -86.28 149.997 -85.8859 151.579C-84.4303 155.404 -82.6419 159.026 -80.9071 162.717C-79.9129 164.844 -78.6969 166.856 -77.6374 168.946C-76.564 171.409 -75.2965 173.75 -73.6508 175.883C-72.2288 177.784 -71.0386 179.846 -69.6543 181.777C-67.2619 184.561 -64.8181 187.302 -62.3802 190.045C-61.3266 191.689 -60.2809 193.297 -59.1759 194.893C-57.3321 196.725 -55.1497 198.508 -53.4247 200.419C-51.1155 202.649 -49.0717 205.108 -46.9566 207.521C-45.5169 208.727 -44.0612 209.917 -42.5918 211.089C-39.4944 213.798 -36.4465 216.573 -33.2125 219.13C-30.8261 221.009 -28.2911 222.685 -25.9067 224.558C-23.1796 226.671 -20.3219 228.598 -17.4443 230.493C-14.2895 232.777 -11.0455 234.908 -7.60158 236.732C-5.39736 237.946 -3.65063 239.851 -1.61673 241.326C3.69873 244.392 9.21423 247.012 14.6644 249.721C18.6906 251.712 22.7623 253.597 26.9291 255.284C31.9951 257.705 36.758 260.756 41.9467 262.923C44.5747 264.145 47.3216 265.066 50.0486 266.034C55.1383 268.066 60.1865 270.243 65.4445 271.813C73.8098 274.582 82.4385 276.354 90.9781 278.465C96.1926 279.743 101.49 280.731 106.855 281.078C111.313 281.539 115.779 282.004 120.259 282.171C122.631 282.139 124.954 281.86 127.289 281.6C133.227 281.485 139.186 280.806 144.913 279.19C146.387 278.794 147.876 278.453 149.333 278.002C150.658 277.358 151.914 276.582 153.217 275.905C155.819 275.049 158.356 273.982 160.756 272.651C162.701 271.165 164.81 269.421 166.737 268.032C169.601 265.454 171.932 262.335 174.312 259.321C175.352 257.897 176.519 256.568 177.525 255.118C179.091 252.106 180.648 249.024 181.434 245.703C182.098 242.659 183.197 239.73 183.749 236.659C184.468 233.151 184.72 229.561 184.547 225.986C184.569 224.015 185.227 222.079 185.379 220.108C185.003 219.173 184.611 218.247 184.211 217.324C183.866 216.476 183.339 215.751 183.43 214.797C183.395 213.085 183.51 211.351 183.282 209.653C183.044 208.053 182.735 206.548 182.426 204.976C182.216 203.098 182.074 201.205 181.799 199.329C180.925 196.721 179.911 194.17 179.006 191.574C176.479 184.9 174.917 177.84 171.649 171.467C168.876 165.557 165.012 160.256 161.972 154.499C161.368 153.348 160.753 152.205 160.121 151.066C158.871 149.369 157.562 147.716 156.299 146.032C155.217 144.238 154.12 142.456 152.979 140.701C151.985 139.501 150.981 138.307 149.965 137.124C146.804 133.445 143.762 129.666 140.614 125.978C139.047 124.491 137.455 123.03 135.859 121.572C134.421 119.893 133.056 118.128 131.589 116.462C130.078 114.951 128.551 113.456 127.004 111.977C123.917 108.85 120.631 105.944 117.136 103.277C115.496 101.823 113.844 100.385 112.163 98.9773C110.382 97.7237 108.588 96.4998 106.782 95.2877C102.726 91.6041 98.381 88.2493 93.7666 85.2945C89.1878 82.3318 84.7121 79.2027 80.0541 76.3628C78.1331 75.4755 76.2002 74.616 74.2594 73.7763C71.061 72.0316 67.7933 70.3007 64.5553 68.7144C62.0817 67.4449 59.4042 66.6329 56.8395 65.5853C53.5184 63.8881 50.1655 62.3453 46.7275 60.9154C44.8401 60.4421 42.9488 60.0005 41.0555 59.5569C39.2494 58.8756 37.469 58.129 35.6549 57.4636C32.8902 56.6952 30.0998 56.0198 27.3034 55.3821C18.0489 52.6987 8.52702 51.1658 -0.901798 49.2309C-1.3771 49.1359 -1.5692 48.6388 -1.37512 48.2189C-1.13549 47.702 -0.513629 47.4129 0.0369304 47.5238C12.272 50.1697 24.8002 51.7738 36.6926 55.796C39.3365 56.5149 42.1012 56.9189 44.545 58.2141C48.8604 60.4223 53.655 61.3947 58.1783 63.09C60.3231 63.9277 62.3174 65.1298 64.379 66.1576C67.411 67.5023 70.4233 68.8946 73.3939 70.368C76.1804 71.6177 78.6559 73.4159 81.1711 75.127C83.7793 76.4955 86.3697 77.9016 88.9165 79.3869C93.8517 82.2031 98.4622 85.5381 103.146 88.7444C105.318 90.2674 107.725 91.4774 109.796 93.133C111.157 94.3352 112.497 95.561 113.83 96.7988C115.486 98.2524 117.286 99.5496 118.968 100.978C120.772 102.52 122.423 104.235 124.129 105.881C125.75 107.337 127.392 108.776 128.981 110.27C130.719 111.87 132.308 113.628 134.041 115.231C135.591 116.615 137.158 117.983 138.657 119.419C140.15 121.237 141.457 123.206 142.966 125.004C146.64 129.026 150.12 133.235 153.138 137.774C154.714 140.301 156.823 142.426 158.604 144.808C159.675 146.553 160.711 148.318 161.731 150.094C162.994 151.785 164.294 153.457 165.494 155.192C168.528 160.095 170.88 165.363 173.356 170.56C175.691 175.651 178.452 180.555 180.434 185.801C182.05 189.924 182.88 194.315 183.624 198.668C184.316 200.742 185.246 202.762 185.621 204.926C186.049 207.659 186.494 210.374 187.211 213.048C187.306 213.495 187.425 213.939 187.496 214.391C187.488 215.143 187.213 215.874 187.086 216.611C186.849 217.712 186.585 218.803 186.312 219.896C186.68 221.944 187.54 223.968 187.274 226.063C186.874 230.222 186.377 234.375 185.769 238.508C185.524 240.033 185.237 241.548 184.9 243.053C184.528 244.598 183.795 246.032 183.177 247.493C182.008 250.266 180.723 252.993 179.107 255.536C177.069 260.342 173.647 264.39 169.678 267.733C168.13 268.973 166.779 270.431 165.228 271.668C164.068 272.453 162.87 273.18 161.652 273.867C159.214 275.604 156.683 277.235 154.017 278.598C152.619 279.046 151.185 279.37 149.749 279.689C148.616 280.145 147.476 280.584 146.327 280.996C139.861 283.003 133.05 283.801 126.329 284.371C122.594 284.284 118.866 284.062 115.125 284.088C108.556 284.038 101.855 282.894 95.444 281.767C91.493 281.103 87.5342 280.444 83.6307 279.547C77.834 278.004 72.3839 276.265 66.7813 274.421C58.9447 271.615 50.8646 269.405 43.3726 265.715C39.9524 264.331 36.5461 262.901 33.1596 261.432C29.878 259.956 26.4598 258.752 23.3248 256.976C20.2769 255.247 17.0943 253.775 13.9375 252.258C9.24195 249.69 4.75232 246.777 0.191408 243.982C-0.71563 243.42 -1.61871 242.853 -2.5218 242.283C-5.27855 240.976 -8.24721 240.035 -10.6316 238.082C-13.0557 236.245 -15.5946 234.589 -18.1454 232.937C-21.2329 230.86 -24.1461 228.549 -27.1761 226.39C-31.7034 223.023 -35.9197 219.262 -40.3242 215.741C-43.1166 213.539 -45.6377 211.03 -48.0518 208.426C-49.7134 207.057 -51.47 205.78 -53.0405 204.308L-53.0385 204.302Z",
        fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M21.4958 155.939C21.8541 154.991 23.0616 155.369 23.7123 155.757C24.6372 156.182 25.5454 156.643 26.5067 156.988C29.3333 152.853 30.9243 147.991 33.6697 143.811C34.158 143.236 35.0857 143.573 35.6189 143.903C36.562 144.549 36.5214 145.893 36.3815 146.871C36.3339 148.146 36.3815 149.401 36.7201 150.637C36.979 151.916 37.6058 153.1 37.8465 154.381C38.3461 156.915 38.4706 159.49 38.7197 162.055C39.5383 162.25 40.3708 162.377 41.1754 162.626C41.9464 161.758 42.4362 160.685 43.175 159.798C44.3644 158.34 45.8784 157.376 47.5534 156.559C48.8841 155.923 50.2302 155.312 51.5763 154.714C52.9252 153.858 54.7317 153.879 55.9421 154.982C57.645 156.658 55.9169 159.43 54.7975 160.985C53.5871 162.56 51.9975 163.905 50.0735 164.494C52.7895 165.662 54.8996 167.806 57.3092 169.468C58.7869 170.496 60.154 171.695 61.7128 172.597C62.7972 173.226 62.3732 174.423 61.1531 174.383C60.424 174.386 59.8335 173.936 59.2738 173.529C58.1292 173.2 56.986 172.866 55.8666 172.459C53.9075 171.752 52.0003 170.925 49.9644 170.454C48.5986 169.985 47.2371 169.524 45.7959 169.351C46.5025 169.906 47.2092 170.462 47.9144 171.019C49.6635 171.986 51.5232 172.831 52.9896 174.213C53.6613 174.714 54.0741 175.589 54.8829 175.874C55.2369 175.977 55.6609 176.171 55.7014 176.588C55.735 177.019 55.2816 177.204 54.915 177.194C54.568 177.219 54.1944 177.081 53.9873 176.808C53.5479 176.571 53.1323 176.287 52.6692 176.088C50.6654 175.053 48.5259 174.275 46.6033 173.088C46.045 172.755 45.4838 172.424 44.9255 172.094C44.3798 171.94 43.8033 171.825 43.3485 171.464C42.821 171.089 43.2967 170.498 43.8383 170.698C44.3924 170.83 44.8332 171.199 45.2851 171.528C46.9559 172.169 48.6336 172.774 50.184 173.678C49.2409 172.989 48.3888 172.2 47.503 171.443C46.3514 170.84 45.1998 170.237 44.051 169.631C43.0715 168.923 41.9087 168.965 40.7528 168.858C41.3308 170.35 42.0822 171.774 42.5873 173.293C43.3079 175.534 43.8411 177.833 44.5547 180.075C45.1088 181.635 45.6434 183.148 46.1569 184.581C46.4228 185.322 46.5949 185.805 46.8439 186.494C46.9265 186.723 46.9531 186.947 46.8327 187.172C46.2884 188.016 44.8374 187.642 44.5505 186.751C43.7361 184.466 42.9315 182.18 42.1213 179.893C40.8032 176.785 39.4109 173.683 38.8554 170.33C37.8899 171.22 36.7271 171.868 35.6762 172.657C34.5022 174.149 33.3674 175.674 32.1822 177.158C31.7988 177.643 31.4574 178.196 30.8795 178.467C30.1253 178.88 28.7679 178.337 28.9722 177.351C29.0464 176.501 29.8244 176.045 30.4275 175.555C31.3482 174.419 32.2844 173.314 32.9882 172.024C33.5381 171.078 34.235 170.224 34.8646 169.331C35.1599 168.903 35.4719 168.496 35.8889 168.178C32.5124 167.456 29.1332 166.726 25.7287 166.152C24.5687 165.902 22.8741 166.012 22.3186 164.74C22.0234 163.587 22.4264 162.219 23.098 161.263C23.7585 160.282 24.3896 159.282 25.2222 158.434C24.3546 158.012 23.5304 157.489 22.6041 157.204C22.0178 157.132 21.3181 156.588 21.4986 155.937L21.4958 155.939ZM24.1909 164.642C28.8281 165.325 33.5157 165.685 38.1684 166.168C38.153 166.102 38.139 166.037 38.1236 165.972C34.5428 164.102 31.4854 161.381 27.8066 159.689C27.3365 161.042 26.4171 162.143 25.6349 163.326C25.1844 163.8 24.5967 164.127 24.1895 164.644L24.1909 164.642ZM33.1785 149.713C31.7918 152.524 30.0525 155.144 28.5776 157.908C30.261 158.772 31.9247 159.668 33.5815 160.583C34.6771 160.913 35.7686 161.257 36.867 161.576C36.3689 160.022 35.7252 158.509 35.2508 156.949C35.1151 156.105 34.9962 155.257 34.866 154.412C34.6575 151.954 35.1893 149.439 34.4672 147.028C34.0433 147.926 33.6249 148.829 33.1771 149.715L33.1785 149.713ZM31.4364 160.831C33.5409 161.896 35.6958 162.883 37.7024 164.127C37.6772 164.018 37.652 163.91 37.6282 163.801C37.5835 163.607 37.5107 163.414 37.4393 163.223C35.4509 162.387 33.5395 161.355 31.4364 160.831ZM39.7859 164.172C39.5005 164.069 39.2178 163.961 38.9352 163.849C39.0583 164.225 39.1814 164.602 39.3032 164.978C39.5089 164.726 39.7118 164.472 39.9147 164.216C39.8713 164.202 39.8279 164.188 39.7845 164.172L39.7859 164.172ZM42.3298 167.004C46.5963 168.606 51.2769 168.753 55.6147 170.186C53.748 168.73 51.7373 167.522 49.7307 166.299C48.8687 165.749 47.9536 165.279 46.9699 164.994C46.3304 165.008 45.6937 165.047 45.0515 165.029C43.967 165.384 43.1302 166.226 42.3298 167.006L42.3298 167.004ZM43.4283 163.128C46.4927 163.72 51.1663 163.356 53.047 160.528C53.7718 159.136 54.2084 157.276 53.3996 155.839C52.6468 155.497 51.6883 155.844 50.9858 156.178C49.5684 157.198 48.4405 158.54 47.3799 159.911C46.1485 161.085 44.7688 162.084 43.4283 163.128Z",
        fill: "var(--ds-background-neutral-bold-pressed, #172B4D)"
    }));
const $936ceae5a4a545da$export$668799e4797757a8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        fill: "none",
        viewBox: "0 0 708 668",
        className: (0, $bwpsq.default)([
            "_p12ft3m1 _1ul91pna"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#BF63F3",
        d: "m4.069 90.41 590.332-41.28 33.37 477.195-590.333 41.28z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#1868DB",
        d: "M351.104 188h421.728v458.717H351.104z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#1228D1",
        fillRule: "evenodd",
        d: "m604.112 188 23.658 338.325-276.666 19.346V188h253.008Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#FCA700",
        fillRule: "evenodd",
        d: "M222.378 554.723c-24.674-74.653-85.271-135.819-166.89-157.689a243.661 243.661 0 0 0-30.343-6.104L32.38 494.4c37.444 10.839 67.076 35.898 84.576 67.694l105.422-7.371Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-neutral-bold-pressed, #172B4D)",
        d: "M43.894 585.588c.355-.056 3.156 8.9 3.127 12.736 1.357.554 2.753 2.283 3.061 4.271 5.853 3.055.847-6.33-.779-9.234-.483 2.205-.754-3.129-1.567-3.824.123.437-2.432-8.271-3.66-5.551-.264-.239-.568 1.923-.189 1.599l.007.003ZM25.547 598.159c.7 1.901.146 3.691-.95 5.484 2.085 6.623 5.445-4.93 6.223-7.742 0 0 1.471-4.908 1.6-4.353.826-.489 4.652-7.588 1.377-6.909-.764 1.133-1.192 3.693-2.22 3.829-2.197.857-3.66 7.484-6.026 9.701l-.004-.01ZM6.053 583.065c-.322 4.42 7.291-.05 10.474-.712 0 0 3.337-.507 4.148-1.227-.485.073 11.23-2.412 4.615-3.693-.157.082-4.215.936-4.215.936-5.59-.444-10.942 2.067-15.025 4.703l.003-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-lime-subtle, #94C748)",
        d: "M326.048 626.989a100.386 100.386 0 0 1-17.178 3.843c-2.96 1.059-5.911 2.165-8.91 3.108-8.501 1.45-16.928 1.767-25.451 3.192-4.243.308-8.505.143-12.714.815-4.829.676-9.722.322-14.576.161a68.394 68.394 0 0 1-8.637-.863c-3.296-.494-6.558-1.18-9.804-1.939-2.253-.138-4.502-.296-6.746-.56-5.378-1.886-10.65-4.049-16.065-5.824-3.349-1.003-6.218-3.041-9.37-4.489-3.862-2.066-8.138-3.723-11.191-6.952-2.223-2.14-4.171-4.538-6.004-7.012-1.645-1.178-3.732-2.026-4.966-3.653-1.006-1.58-1.921-3.209-2.802-4.862-1.198-1.46-2.421-2.908-3.466-4.481-1.716-3.447-3.294-6.962-4.798-10.508-.965-2.048-2.025-4.077-2.684-6.251-2.756-8.89-4.026-18.128-4.289-27.419-.607-11.535.38-23.127 3.698-34.22.399-4.633 1.38-9.098 2.914-13.484 4.017-12.94 9.196-25.573 15.749-37.441 5.206-9.443 11.209-18.409 17.241-27.337 1.611-1.895 3.397-3.659 5.1-5.476 2.047-2.666 3.982-5.432 6.325-7.851 2.819-2.801 5.313-5.872 7.83-8.94 2.591-3.003 5.421-5.798 8.149-8.677 4.39-4.726 9.58-8.618 14.467-12.814 9.147-8.368 18.937-16.007 29.427-22.625 4.638-3.27 8.994-7.037 14.024-9.687 5.237-2.597 10.2-5.693 14.983-9.047 2.095-1.334 4.445-1.922 6.696-2.924 1.379-.915 2.756-1.82 4.142-2.723 1.989-1.477 4.514-1.857 6.81-2.694 2.278-.772 4.397-1.977 6.638-2.857a377.842 377.842 0 0 1 5.093-3.198c1.858-.695 3.799-1.2 5.701-1.793 3.867-1.653 7.795-3.174 11.841-4.341 6.256-1.86 12.694-2.925 19.056-4.329 2.827-.19 5.644-.54 8.455-.831 2.518.065 5.025.166 7.543.185 1.398.101 2.819-.11 4.214-.003 1.616.379 3.191.898 4.839 1.15 2.158.471 4.376.912 6.332 1.981 1.454.901 3.122 1.315 4.639 2.089a31.065 31.065 0 0 1 2.594 2.222c.758.408 1.577.93 2.042 1.628 1.116 1.63 2.336 3.179 3.435 4.814.631 1.078 1.034 2.283 1.989 3.13.526.58.344 1.5.43 2.227a10.34 10.34 0 0 1 1.229 3.139 5.45 5.45 0 0 1 .921 3.297c.19.167.373.324.463.571.13.349.053.709-.017 1.063.095.214.214.48.239.705.026.244-.053.504-.127.735.591.553.59 1.483.412 2.229.471.815.598 1.795.406 2.695-.128.434-.599.632-.868.181-.38-.814-.426-1.795-.26-2.678-.413-.646-.629-1.508-.312-2.231-.129-.144-.266-.3-.336-.476-.084-.226-.08-.556-.076-.821-.167-.212-.338-.421-.401-.686-.078-.328.009-.636.104-.951-.642-.976-.823-2.077-.894-3.223a25.397 25.397 0 0 1-1.018-3.164c-.337-.385-.782-.692-1.067-1.119-.273-.559-.231-1.287-.397-1.882-.808-1.497-1.753-2.729-2.629-4.147-1.06-1.19-2.562-2.068-3.48-3.349-.831-.952-2.107-1.367-3.178-2.002a44.557 44.557 0 0 0-2.724-1.952c-4.069-1.449-8.063-3.294-12.448-3.24-2.686-.682-5.467-1.113-8.248-.891-2.467.299-5.065.458-7.506.598-2.755.529-5.527.922-8.314 1.264-5.225 1.111-10.314 2.858-15.388 4.532-5.62 1.788-11.327 3.373-16.494 6.287-1.852.452-3.767.89-5.598 1.367-1.728.78-3.45 1.581-5.115 2.374-2.22 1.125-4.189 2.701-6.292 4.038-1.99.806-4.023 1.525-6.013 2.345a451.134 451.134 0 0 0-5.462 3.762c-6.196 2.578-11.9 5.978-17.164 10.115-4.219 2.787-8.705 5.192-12.924 7.997-5.675 4.23-11.313 8.509-16.819 12.96-8.225 6.191-16.088 12.855-23.045 20.463-5.605 5.076-10.881 10.513-16.307 15.733-3.14 3.963-6.286 7.799-9.6 11.589a300.024 300.024 0 0 0-4.091 6.476c-2.863 3.493-5.447 6.909-7.854 10.68-10.342 15.778-18.931 33.164-24.516 51.138-.863 2.784-1.533 5.617-2.258 8.438a156.1 156.1 0 0 0-2.128 6.093 152.853 152.853 0 0 0-1.441 12.235c-.924 9.179-2.05 18.412-.724 27.593 1.068 7.067 2.415 13.924 4.996 20.585 1.31 4.952 3.49 9.792 6.432 13.951 1.213 1.789 2.004 3.833 3.172 5.657a72.49 72.49 0 0 0 3.167 3.054c.651.466 1.082 1.143 1.403 1.865a84.73 84.73 0 0 0 2.345 4.143c2.672 1.972 5.394 3.884 8.19 5.674 2.252 1.538 3.901 3.368 6.113 4.831a39.697 39.697 0 0 0 8.886 5c2.374 1.034 4.573 2.483 7.018 3.358 3.596 1.373 7.282 2.232 11.087 2.718 2.49.465 4.815 1.709 7.28 2.355 6.336.871 12.644 1.135 19.006 1.524 3.662.231 7.333.073 10.992.186 4.184.376 8.344.393 12.502-.265 3.674-.524 7.393-.61 11.079-1.061 5.612-1.192 11.202-2.488 16.792-3.775 3.043-.212 6.033-.44 9.05-.759 3.894-1.154 7.975-2.811 11.889-3.743 4.789-1.494 9.694-2.453 14.588-3.544a370.752 370.752 0 0 0 8.166-3.31c6.037-2.216 12.127-4.315 18.058-6.832 4.366-1.864 8.564-4.083 12.921-5.948 4.943-2.155 9.728-4.629 14.484-7.154 5.497-2.614 10.851-5.464 15.934-8.819 3.318-2.112 7.24-3.079 10.788-4.762 8.189-4.99 15.917-10.589 23.719-16.031 5.748-4.028 11.386-8.198 16.824-12.646 7.117-5.133 14.873-9.375 21.734-14.866 3.646-2.687 6.968-5.763 10.341-8.777 6.603-5.455 13.372-10.746 19.468-16.778 10.069-9.395 18.969-19.898 28.267-30.025 5.661-6.193 10.988-12.716 15.486-19.813 3.975-5.767 7.962-11.541 11.549-17.559 1.735-3.277 3.094-6.672 4.489-10.069 4.294-8.227 7.831-16.908 9.909-25.973.562-2.318 1.211-4.615 1.685-6.952.111-2.3-.012-4.603.036-6.898.778-4.21 1.217-8.489 1.191-12.778-.578-3.781-1.389-7.981-1.848-11.664-1.389-5.86-3.918-11.395-6.266-16.92-1.173-2.493-2.121-5.089-3.354-7.555-2.956-4.407-6.015-8.852-9.979-12.42-3.677-3.192-6.869-6.896-10.667-9.956-4.27-3.616-9.005-6.653-14.036-9.097-2.686-1.507-4.849-3.861-7.436-5.548a176.89 176.89 0 0 0-4.695-.485c-1.42-.163-2.809.016-4.05-.825-2.373-1.234-4.666-2.692-7.164-3.653-2.372-.874-4.668-1.578-7.055-2.334-2.732-1.12-5.435-2.344-8.213-3.372-4.232-.758-8.49-1.281-12.729-1.986-11.046-1.539-21.899-4.69-33.088-4.988-10.182-.629-20.349.694-30.523.546-2.03-.034-4.059-.047-6.094-.034-3.264.441-6.513.996-9.769 1.467-3.271.137-6.538.305-9.799.554-2.391.463-4.782.944-7.165 1.451-7.415 1.575-14.878 2.913-22.295 4.466a522.826 522.826 0 0 0-9.608 3.217c-3.38.712-6.823 1.26-10.207 2.023-3.205.939-6.4 1.912-9.589 2.924a146.917 146.917 0 0 0-19.329 7.009 361.298 361.298 0 0 0-9.624 3.595 450.444 450.444 0 0 0-9.094 4.612c-8.092 2.8-15.95 6.242-23.462 10.354-7.495 4.057-15.142 7.849-22.529 12.106a410.8 410.8 0 0 0-7.891 6.007c-4.791 3.078-9.614 6.261-14.217 9.511-3.595 2.44-6.716 5.503-10.076 8.234a221.902 221.902 0 0 0-13.985 10.365c-2.064 2.233-4.088 4.495-6.116 6.759-2.288 1.966-4.647 3.847-6.92 5.836-3.126 3.215-6.145 6.535-9.116 9.891-10.618 10.678-19.86 22.586-29.582 34.064-.487.58-1.313.471-1.743-.11-.529-.716-.459-1.785.106-2.457 12.801-14.794 24.394-30.77 38.827-44.061 2.968-3.087 5.595-6.575 9.203-8.955 6.264-4.262 11.192-10.107 16.908-15.039 2.757-2.312 5.901-4.146 8.856-6.202 4.117-3.149 8.285-6.236 12.533-9.205 3.802-2.884 8.124-4.93 12.356-7.096 3.833-2.55 7.703-5.048 11.649-7.427 7.562-4.655 15.592-8.477 23.501-12.495 3.717-1.837 7.18-4.23 11.004-5.829a345.74 345.74 0 0 1 8.051-2.783c3.235-1.18 6.363-2.676 9.582-3.911 3.468-1.317 7.058-2.296 10.593-3.401 3.213-1.132 6.418-2.304 9.656-3.362 3.498-1.185 7.101-2.044 10.597-3.219 3.061-1.089 6.112-2.211 9.205-3.19 3.612-.684 7.292-1 10.889-1.722 8.27-2.021 16.65-3.637 25.137-4.372 4.647-.267 9.142-1.566 13.744-2.221 3.196-.161 6.392-.258 9.593-.325 3.266-.464 6.532-.993 9.811-1.338 8.999-.483 17.987.24 26.968.742 8.733.616 17.527.507 26.207 1.722 6.866.876 13.508 3.03 20.036 5.273 3.361.607 6.829.845 10.078 1.955 4.068 1.462 8.125 2.887 12.329 3.909.685.205 1.382.375 2.055.615 1.026.576 1.822 1.501 2.737 2.227a165.76 165.76 0 0 1 3.925 3.525c3.084 1.031 6.504 1.37 9.178 3.305a389.078 389.078 0 0 1 15.936 11.395 119.388 119.388 0 0 1 5.581 4.6c1.839 1.668 3.255 3.748 4.796 5.691 2.926 3.681 5.702 7.489 7.977 11.611 5.063 6.398 8.048 14.126 9.656 22.075.539 3.053 1.525 5.998 2.059 9.052a81.1 81.1 0 0 1 .333 6.553c.554 4.645.894 9.339.763 14.016-.434 2.253-1.064 4.463-1.703 6.671a150.288 150.288 0 0 1-.774 5.672c-2.097 10.371-6.109 20.308-10.367 29.953-2.92 5.056-6.019 10.001-8.788 15.15-4.994 8.971-11.588 17.302-17.94 25.248-3.872 4.92-7.745 9.854-11.902 14.534-6.461 6.792-12.932 12.961-19.661 19.261-9.724 8.642-18.813 18.065-29.49 25.572a696.524 696.524 0 0 1-13.531 10.792c-4.484 3.394-8.698 7.178-13.484 10.145-4.656 2.883-9.06 6.144-13.507 9.335-7.043 4.513-14.404 8.485-21.656 12.644a580.174 580.174 0 0 1-4.364 2.446c-3.859 2.8-7.375 6.166-11.841 7.971-4.337 1.946-8.511 4.186-12.689 6.446-5.163 2.676-10.517 4.938-15.749 7.474-8.011 3.684-16.329 6.645-24.46 10.045-5.113 2.178-10.444 3.753-15.825 5.111-3.123 1.252-6.191 2.703-9.387 3.753l-.006-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface-overlay, #FFFFFF)",
        d: "M58.5 126.242h426v221h-426z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        d: "M82.5 150.242h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M137.403 165.089c-.376.089-.371-.674-.424-.817.048.143.048.906.424.812v.005Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M194.807 162.553c-.605.158-1.561.478-3.03.965-.044-.019-.171-.02-.2-.059-1.546.571-3.21.734-4.869.749-1.664.019-3.337-.089-5.064-.094.039.148-.078.256-.181.177l.044-.177c-2.327.281-3.717-.419-5.888-.039l.273-.212a58.17 58.17 0 0 1-2.81-.345 1.469 1.469 0 0 1-.249-.044 1.485 1.485 0 0 1-.542-.256 1.443 1.443 0 0 1-.488-.64l-.136-.37-.171-.418a8.98 8.98 0 0 0-.429-.872c-.342-.586-.844-1.236-1.615-1.674-.776-.453-1.698-.517-2.425-.413-.376.049-.707.142-1.044.236l-.498.182c-.107.054-.248.069-.346.158l-.302.216-.635.453-.317.227-.327.202-.653.404c-.22.128-.449.231-.669.349-.444.251-.907.394-1.356.591-.464.128-.917.286-1.376.345a7.71 7.71 0 0 1-2.727-.01c-.898-.158-1.771-.488-2.62-.872l.024.04-.024.014c.268.242 1.127.769 1.971 1.094.215.073.419.147.61.216.195.049.375.094.532.128.307.089.512.099.512.099-.625.187-1.303.157-1.966.01a7.072 7.072 0 0 1-1.913-.828c-1.22-.724-2.303-1.718-3.542-2.457l.137-.187c1.058.665 2.015 1.152 2.429 1.266-.883-.601-1.966-1.423-3.346-2.255a12.005 12.005 0 0 0-2.367-1.123c-.439-.163-.927-.261-1.414-.35l-.757-.059c-.253-.024-.512.015-.766.02-1.014.093-2.015.384-2.829.847a8.651 8.651 0 0 0-1.015.62 5.132 5.132 0 0 0-1.083-.335c-1.303-.256-2.542-.098-3.645.187-2.215.601-3.995 1.675-5.474 2.679a28.06 28.06 0 0 0-3.429 2.802c-1.596 1.58-1.874 2.211.009 1.093l-.044.29c1.742-1.359 3.259-2.452 5.391-3.299.259-.187.308-.177.215-.344.059-.069.156-.187.088-.242-.259-.394.468-.586.746-.733.171.758 1.698-.099 3.494-.591a6.914 6.914 0 0 1 2.234-.271c-.166.167-.327.33-.493.492-.131.133-.263.261-.414.454a4.3 4.3 0 0 0-.391.536 4.87 4.87 0 0 0-.736 2.196c.102-.059.117-.512.278-.98.17-.458.473-.911.829-.906-.727 1.094-.868 2.472-.6 3.644-.376.089-.376-.67-.424-.812-.015.069-.02.182-.015.334 0 .153.015.35.058.577.079.453.254 1.068.674 1.703.112.153.229.31.361.473.141.148.283.31.453.448.337.281.708.561 1.264.763.268.104.629.172.966.177.346 0 .693-.069 1.03-.206a3.07 3.07 0 0 0 .907-.626c.239-.241.429-.507.585-.778.601-1.088.757-2.245.688-3.427-.087-1.177-.444-2.412-1.239-3.496-.019-.029-.049-.054-.068-.083.2-.099.4-.188.605-.266a4.307 4.307 0 0 1 2.103-.271c1.453.153 3 1.034 4.581 1.999 1.595.96 3.278 2.043 5.244 2.654.976.295 2.001.492 3.03.492 1.02-.014 2.039-.123 2.971-.418 1.888-.532 3.508-1.458 4.933-2.413l.268-.177.054-.035-.005.005c.01 0 .019-.009.029-.009h.039l.108-.04c.078-.02.156-.054.229-.064.293-.059.58-.103.785-.064.43.064.517.217.717.552l.035-.089c.009.054.141.157.083.256.156.103.356.335.556.65.102.158.2.34.297.527.127.276.303.586.488.832.381.512.839.862 1.191 1.068.351.207.59.291.59.291.337.123.693.197 1.034.226l.796.035c.531.029 1.063.034 1.59.049 0 0 1.351.256 2.996.389 1.639.138 3.571.163 4.669-.128 2.741.108 5.508.01 8.269-.438 0 0 .215-.044.547-.148.331-.103.785-.221 1.258-.409.952-.349 1.971-.896 2.371-1.27.488-.497.718-.911.674-1.162-.044-.251-.366-.345-.976-.197Zm-54.594 4.54c-.19-.084-.288-.168-.263-.212.019-.044.175-.039.415-.069a2.533 2.533 0 0 1-.596-.492 2.672 2.672 0 0 1-.468-.67c-.132-.241-.205-.512-.263-.783a3.051 3.051 0 0 1 .619-2.437c.083-.123.195-.207.303-.33.146-.128.292-.256.439-.389.146-.128.292-.266.439-.389l.356-.271c.078.094.166.192.259.301.331.379.639.886.585 1.201a2.866 2.866 0 0 0-.303-.226c-.053.152.161.689.274 1.467.122.763.102 1.807-.274 2.575-.185.384-.439.64-.746.748a1.071 1.071 0 0 1-.776-.029v.005Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M82.5 187.242h378v40h-378z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: "var(--ds-border, #091E4224)",
        d: "M83 187.742h377v39H83z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        d: "M90.5 199.242h16v16h-16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-gray-subtler-hovered, #B3B9C4)",
        d: "M202.95 206.951c-13.865 2.577-24.095-4.017-38.098 1.392-.654-2.317-2.344-5.218-4.873-5.261 2.11.053 5.484 6.106 2.094 2.052-1.993-3.088-10.703.685-4.028-1.999-4.608.569-8.833 4.326-11.947 7.669-5.181 4.761-1.249-4.453-4.995-9.087-5.309-6.441-21.422 10.309-18.175 10.32 2.067-2.099 4.841-3.407 5.989-5.734 20.21-13.78 5.628 11.723 17.665 7.45 19.662-17.712 9.725-1.679 21.267-2.774 6.728-6.419 35.334 3.646 35.106-4.028h-.005Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "55.941",
        height: "24",
        x: "324.618",
        y: "195.242",
        fill: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#77B255",
        d: "M342.801 205.642a7.76 7.76 0 0 0-1.28 1.076c-.056-1.887-.51-4.327-3.01-5.521-.494-2.691-6.263-1.324-5.747-1.063 1.029.52 1.576 1.844 2.237 2.54 1.18 1.241 2.491 1.317 3.143.346 1.541 1.002 1.643 2.902 1.596 4.933-.006.224-.011.433-.011.623v6.222c0 .491 1.778.491 1.778 0v-5.107c.241-.424.943-1.557 1.969-2.352.705.619 1.841.421 2.873-.665.661-.696 1.019-2.019 2.047-2.54.543-.275-5.689-1.775-5.595 1.508Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-lime-subtle, #94C748)",
        d: "M371.685 205.685c-.008-.045-1.459-.543-2.196-.424.008.216-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.075c.156.275-.29.625-.878.684v-.35a.678.678 0 0 0 .573-.305s-3.796.313-3.773.209c-.365-.618-7.8-1.206-6.021 1.191 0 0 3.751 1.146 3.743 1.183.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.342.216-.737.238-1.109.038-.752-.201-1.369-.885-1.101l.015.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "55.941",
        height: "24",
        x: "396.559",
        y: "195.242",
        fill: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#c)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#DD2E44",
        d: "M420.508 204.502a4.385 4.385 0 0 0-4.385-4.386 4.38 4.38 0 0 0-3.564 1.835 4.378 4.378 0 0 0-3.563-1.835 4.386 4.386 0 0 0-4.386 4.386c0 .343.044.675.119.996.608 3.783 4.815 7.775 7.83 8.871 3.015-1.096 7.222-5.088 7.83-8.871.076-.32.119-.653.119-.996Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-red-subtle, #F87168)",
        d: "M443.626 205.685c-.008-.045-1.459-.543-2.196-.424.008.216-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.075c.156.275-.29.625-.878.684v-.35a.68.68 0 0 0 .573-.305s-3.796.313-3.774.209c-.364-.618-7.799-1.206-6.02 1.191 0 0 3.751 1.146 3.743 1.183.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.342.216-.737.238-1.109.038-.752-.201-1.369-.885-1.101l.015.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M82.5 235.242h378v40h-378z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: "var(--ds-border, #091E4224)",
        d: "M83 235.742h377v39H83z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        d: "M90.5 247.242h16v16h-16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-gray-subtler-hovered, #B3B9C4)",
        d: "M122.775 256.709c.74.458 1.533.659 2.347.787.82.128 1.674.162 2.662.162.242-.115.29-.074.216-.33.053-.06.141-.168.08-.262-.208-.599.39-.525.619-.632.181 1.008 1.593.551 2.905-.289 1.311-.834 2.622-1.937 3.012-2.044.498.806 1.426-.539 2.004-.27-.02.048-.148.296-.162.343.283.249 1.816-.598 3.127-.376.646.101 1.224.41 1.439.686.242.255.175.349-.329.275l.161.283c.047.101.094.208.141.316l.141.309.121.343.128.343.101.37c.007.04.06.168.101.282l.134.343c.094.222.215.437.357.639.578.8 1.607 1.311 2.683 1.251a3.314 3.314 0 0 0 1.566-.471c.343-.222.686-.437 1.029-.666.504-.356 1.069-.612 1.614-.941.282-.141.571-.262.86-.404l.438-.208.45-.168c1.197-.498 2.495-.814 3.833-1.036 2.676-.437 5.534-.275 8.176.195 2.656.485 5.11 1.251 7.161 2.192l-.04-.127c.06.053.282.047.302.195.942-.168 3.268.08 3.268.08.834.047 1.675.081 2.515.108 0 0 1.029.329 2.313.558 1.278.249 2.818.336 3.712.02 2.152.289 4.364.404 6.583.155 0 0 .679-.182 1.439-.451.746-.316 1.566-.712 1.862-1.109.377-.457.538-.901.478-1.231-.061-.336-.35-.564-.875-.585-.517-.006-1.277.155-2.393.518-.034-.034-.135-.054-.162-.114-1.156.511-2.434.497-3.671.41-1.251-.128-2.488-.37-3.799-.471.013.202-.094.343-.161.236l.053-.242c-1.815.275-2.777-.706-4.552-.195l.256-.283c-2.784-.471-6.052-1.372-9.481-2.158-3.429-.773-7.094-1.392-10.443-1.143l.034.033-.013.034c.309.128 1.196.269 1.976.45.397.081.767.155 1.036.229.269.067.45.108.45.108a4.863 4.863 0 0 1-1.681.37 11.412 11.412 0 0 1-1.707-.108c-1.15-.162-2.367-.35-3.524-.162l-.033-.316c.504-.06.975-.148 1.371-.248.39-.095.706-.168.881-.249-1.829-.121-4.727.148-7.343 1.325-.652.295-1.297.591-1.876.968-.295.181-.591.349-.867.538-.269.201-.531.397-.787.591l-.188.148c-.06.047.014 0-.013.027l-.047.061a.427.427 0 0 1-.135.107c-.101.061-.235.081-.363.061-.067.114.047.107.128.134.087.027.148.101.208.518a1.067 1.067 0 0 1-.639-.121c-.201-.101-.322-.309-.403-.518.457-.228.377.007.471-.013a.822.822 0 0 0 .006-.229c.014 0-.027-.101-.06-.188a6.818 6.818 0 0 1-.101-.282c-.067-.195-.195-.417-.309-.653a4.798 4.798 0 0 0-.458-.759c-.094-.135-.195-.269-.295-.417a17.177 17.177 0 0 0-.384-.417c-.248-.296-.612-.545-.975-.814-.396-.228-.82-.464-1.304-.598-.948-.303-1.97-.323-2.905-.195-.935.134-1.788.403-2.609.699-1.64.605-3.113 1.378-4.505 2.024-1.385.652-2.663 1.177-3.732 1.425-1.069.249-1.896.249-2.521.155-.619-.101-1.063-.249-1.271-.134-.195.087-.161.43.424 1.035l-.269.168.013.02Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "55.941",
        height: "24",
        x: "324.618",
        y: "243.242",
        fill: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#d)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#BF6952",
        d: "m345.39 260.028-9.537.034-.733 2.148a.56.56 0 0 0-.032.259.906.906 0 0 0 .896.773h9.286a.908.908 0 0 0 .897-.773.561.561 0 0 0-.033-.259l-.744-2.182Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#854836",
        d: "m345.39 260.028-.085-.247a.65.65 0 0 0-.617-.445h-8.122a.65.65 0 0 0-.617.445l-.096.28a7.565 7.565 0 0 0 4.746 1.669 7.57 7.57 0 0 0 4.791-1.702Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#AA8DD8",
        d: "M340.598 260.921a6.795 6.795 0 1 0 0-13.59 6.795 6.795 0 0 0 0 13.59Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#744EAA",
        d: "M342.959 254.605a1.865 1.865 0 1 0-.002-3.73 1.865 1.865 0 0 0 .002 3.73ZM339.229 256.935a1.398 1.398 0 1 0 0-2.796 1.398 1.398 0 0 0 0 2.796ZM339.696 250.41a.933.933 0 1 0-.001-1.865.933.933 0 0 0 .001 1.865Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        d: "M371.685 253.685c-.008-.045-1.459-.543-2.196-.424.008.216-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.075c.156.275-.29.625-.878.684v-.35a.678.678 0 0 0 .573-.305s-3.796.313-3.773.209c-.365-.618-7.8-1.206-6.021 1.191 0 0 3.751 1.146 3.743 1.183.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.342.216-.737.238-1.109.038-.752-.201-1.369-.885-1.101l.015.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "55.941",
        height: "24",
        x: "396.559",
        y: "243.242",
        fill: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#e)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#5DADEC",
        d: "M420.508 252.502a4.385 4.385 0 0 0-4.385-4.386 4.38 4.38 0 0 0-3.564 1.835 4.378 4.378 0 0 0-3.563-1.835 4.386 4.386 0 0 0-4.386 4.386c0 .343.044.675.119.996.608 3.783 4.815 7.775 7.83 8.871 3.015-1.096 7.222-5.088 7.83-8.871.076-.32.119-.653.119-.996Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-blue-subtle, #579DFF)",
        d: "M443.626 253.685c-.008-.045-1.459-.543-2.196-.424.008.216-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.075c.156.275-.29.625-.878.684v-.35a.68.68 0 0 0 .573-.305s-3.796.313-3.774.209c-.364-.618-7.799-1.206-6.02 1.191 0 0 3.751 1.146 3.743 1.183.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.342.216-.737.238-1.109.038-.752-.201-1.369-.885-1.101l.015.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M82.5 283.242h378v40h-378z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: "var(--ds-border, #091E4224)",
        d: "M83 283.742h377v39H83z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        d: "M90.5 295.242h16v16h-16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-gray-subtler-hovered, #B3B9C4)",
        d: "M122.775 304.709c.74.458 1.533.659 2.347.787.82.128 1.674.162 2.662.162.242-.115.29-.074.216-.33.053-.06.141-.168.08-.262-.208-.599.39-.525.619-.632.181 1.008 1.593.551 2.905-.289 1.311-.834 2.622-1.937 3.012-2.044.498.806 1.426-.539 2.004-.27-.02.048-.148.296-.162.343.283.249 1.816-.598 3.127-.376.646.101 1.224.41 1.439.686.242.255.175.349-.329.275l.161.283c.047.101.094.208.141.316l.141.309.121.343.128.343.101.37c.007.04.06.168.101.282l.134.343c.094.222.215.437.357.639.578.8 1.607 1.311 2.683 1.251a3.314 3.314 0 0 0 1.566-.471c.343-.222.686-.437 1.029-.666.504-.356 1.069-.612 1.614-.941.282-.141.571-.262.86-.404l.438-.208.45-.168c1.197-.498 2.495-.814 3.833-1.036 2.676-.437 5.534-.275 8.176.195 2.656.485 5.11 1.251 7.161 2.192l-.04-.127c.06.053.282.047.302.195.942-.168 3.268.08 3.268.08.834.047 1.675.081 2.515.108 0 0 1.029.329 2.313.558 1.278.249 2.818.336 3.712.02 2.152.289 4.364.404 6.583.155 0 0 .679-.182 1.439-.451.746-.316 1.566-.712 1.862-1.109.377-.457.538-.901.478-1.231-.061-.336-.35-.564-.875-.585-.517-.006-1.277.155-2.393.518-.034-.034-.135-.054-.162-.114-1.156.511-2.434.497-3.671.41-1.251-.128-2.488-.37-3.799-.471.013.202-.094.343-.161.236l.053-.242c-1.815.275-2.777-.706-4.552-.195l.256-.283c-2.784-.471-6.052-1.372-9.481-2.158-3.429-.773-7.094-1.392-10.443-1.143l.034.033-.013.034c.309.128 1.196.269 1.976.45.397.081.767.155 1.036.229.269.067.45.108.45.108a4.863 4.863 0 0 1-1.681.37 11.412 11.412 0 0 1-1.707-.108c-1.15-.162-2.367-.35-3.524-.162l-.033-.316c.504-.06.975-.148 1.371-.248.39-.095.706-.168.881-.249-1.829-.121-4.727.148-7.343 1.325-.652.295-1.297.591-1.876.968-.295.181-.591.349-.867.538-.269.201-.531.397-.787.591l-.188.148c-.06.047.014 0-.013.027l-.047.061a.427.427 0 0 1-.135.107c-.101.061-.235.081-.363.061-.067.114.047.107.128.134.087.027.148.101.208.518a1.067 1.067 0 0 1-.639-.121c-.201-.101-.322-.309-.403-.518.457-.228.377.007.471-.013a.822.822 0 0 0 .006-.229c.014 0-.027-.101-.06-.188a6.818 6.818 0 0 1-.101-.282c-.067-.195-.195-.417-.309-.653a4.798 4.798 0 0 0-.458-.759c-.094-.135-.195-.269-.295-.417a17.177 17.177 0 0 0-.384-.417c-.248-.296-.612-.545-.975-.814-.396-.228-.82-.464-1.304-.598-.948-.303-1.97-.323-2.905-.195-.935.134-1.788.403-2.609.699-1.64.605-3.113 1.378-4.505 2.024-1.385.652-2.663 1.177-3.732 1.425-1.069.249-1.896.249-2.521.155-.619-.101-1.063-.249-1.271-.134-.195.087-.161.43.424 1.035l-.269.168.013.02Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "55.941",
        height: "24",
        x: "324.618",
        y: "291.242",
        fill: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#f)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#FFAC33",
        d: "m347.883 302.75-3.955-1.464-1.477-4.84a.443.443 0 0 0-.849 0l-1.477 4.84-3.955 1.464a.445.445 0 0 0 0 .834l3.953 1.464 1.477 4.988a.446.446 0 0 0 .853-.001l1.477-4.988 3.954-1.463a.444.444 0 0 0-.001-.834Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#FFCC4D",
        d: "m338.994 307.64-1.028-.381-.4-1.466a.443.443 0 0 0-.857-.001l-.4 1.467-1.028.38a.445.445 0 0 0 0 .834l1.022.379.404 1.61a.444.444 0 0 0 .862-.001l.403-1.609 1.022-.379a.444.444 0 0 0 0-.833Zm-1.928-9.628-1.05-.389-.39-1.051a.443.443 0 0 0-.833 0l-.389 1.051-1.051.389a.445.445 0 0 0 0 .833l1.051.389.389 1.051a.445.445 0 0 0 .833 0l.389-1.051 1.051-.389a.444.444 0 0 0 0-.833Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
        d: "M371.685 301.685c-.008-.045-1.459-.543-2.196-.424.008.216-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.075c.156.275-.29.625-.878.684v-.35a.678.678 0 0 0 .573-.305s-3.796.313-3.773.209c-.365-.618-7.8-1.206-6.021 1.191 0 0 3.751 1.146 3.743 1.183.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.342.216-.737.238-1.109.038-.752-.201-1.369-.885-1.101l.015.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "55.941",
        height: "24",
        x: "396.559",
        y: "291.242",
        fill: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#g)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F4900C",
        d: "M420.115 303.687c0-.917-.164-1.796-.463-2.608-.204 2.395-1.481 3.625-2.815 3.052-1.25-.537-.408-2.63-.346-3.628.105-1.693-.005-3.631-3.08-5.242 1.278 2.444.148 3.963-1.037 4.055-1.315.103-2.519-1.129-2.074-3.129-1.439 1.06-1.481 2.845-1.037 4 .463 1.203-.019 2.203-1.148 2.314-1.262.125-1.964-1.351-1.317-3.703a7.556 7.556 0 1 0 13.317 4.889Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#FFCC4D",
        d: "M417.178 305.908c.066 1.371-1.138 1.908-1.786 1.649-.936-.375-.685-1.018-.926-2.352-.24-1.333-1.166-2.259-2.536-2.666 1 2.814-.555 3.852-1.369 4.037-.832.189-1.668-.001-1.764-1.781a5.315 5.315 0 0 0-1.547 4.265 7.53 7.53 0 0 0 5.309 2.182c2.07 0 3.944-.834 5.309-2.182a5.298 5.298 0 0 0-.69-3.152Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-orange-subtle, #FEA362)",
        d: "M443.626 301.685c-.008-.045-1.459-.544-2.196-.424.008.215-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.074c.156.276-.29.626-.878.685v-.35a.68.68 0 0 0 .573-.305s-3.796.313-3.774.208c-.364-.617-7.799-1.205-6.02 1.191 0 0 3.751 1.146 3.743 1.184.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.343.216-.737.238-1.109.038-.752-.201-1.37-.885-1.102l.015.008Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface-overlay, #FFFFFF)",
        d: "M247.5 366.242h426v221h-426z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        d: "M271.5 390.242h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#h)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-blue-subtle, #579DFF)",
        d: "M312.616 403.953c.483.182 1.005.163 1.498.094.995-.153 1.961-.483 3.04-.817.268-.173.317-.153.229-.325.058-.064.156-.178.088-.237-.239-.404.453-.556.717-.704.083.374.512.355 1.103.177.17-.049.234-.073.395-.088.175-.025.361-.054.556-.084.38-.039.805-.098 1.195-.054.395.034.771.147 1.064.404.297.251.512.625.678.984.166.365.288.704.42.98.121.276.248.458.312.566-.083.148-.064.375.122.532.078.099.21.138.341.192.142.035.298.05.454.045.322-.025.629-.133.893-.217.234-.099.454-.158.619-.153-.019.05-.229.286-.253.325.18.064.824-.197 1.556-.655a23.664 23.664 0 0 0 2.317-1.708c1.488-1.207 2.64-2.216 1.913-1.133a30.234 30.234 0 0 0 1.742-1.009c.146-.094.297-.187.449-.281l.102-.064.049-.024c.029-.015.063-.035.092-.04h.103s.024.01.054.01l.122-.01c.161-.019.312 0 .473 0 .619.03 1.18.148 1.576.443.409.276.741.749 1.146 1.458.205.349.429.753.766 1.187.332.428.854.915 1.522 1.157.166.049.332.108.498.142.161.025.327.045.493.06.302 0 .624-.001.893-.06.136-.024.282-.044.414-.078l.381-.109c.263-.069.483-.167.722-.256 1.82-.768 3.327-1.822 4.82-2.9l.932-.694.473-.182c.181-.074.342-.089.512-.138a.684.684 0 0 1 .235-.035l.219-.019c.073-.01.117.014.181.014.058.005.122 0 .161.03.19.034.361.182.595.428.458.488.98 1.487 1.99 2.147.259.153.513.31.796.399.136.049.278.103.414.143l.43.079.273.044c.093.01.18.049.268.015l.508-.109.6-.123c3.19-.669 6.327-.605 8.977-.246l-.078-.084c.083.03.346-.01.409.094.527-.143 1.493-.222 2.328-.276.834-.059 1.536-.064 1.536-.064l3.011-.148s1.293.158 2.859.247c1.566.083 3.405.083 4.454-.212 2.62.079 5.274.074 7.908-.301 0 0 .205-.039.527-.103.317-.084.752-.212 1.21-.354.459-.153.947-.286 1.361-.478.415-.197.771-.384.981-.542.527-.394.81-.758.81-1.014s-.293-.404-.932-.359a6.927 6.927 0 0 0-1.224.226c-.498.138-1.123.241-1.85.453-.039-.02-.165-.025-.19-.064-1.532.483-3.127.596-4.722.601-.796.014-1.606-.054-2.411-.059-.809-.02-1.629-.074-2.458-.055.039.143-.074.257-.171.183l.039-.178c-2.24.296-3.606-.359-5.699.138l.254-.226c-1.766-.069-3.688-.197-5.728-.276-2.034-.094-4.181-.123-6.366-.01l-1.645.118c-.546.05-1.097.143-1.644.217l-.819.118-.815.177-.81.183-.351.078c.039 0-.02.01-.025 0-.014 0 0 0-.034-.009l-.122-.015c-.088 0-.141-.049-.214-.064-.147-.03-.254-.123-.386-.182-.239-.168-.493-.444-.785-.818-.298-.364-.615-.861-1.196-1.334-.122-.118-.312-.217-.468-.32a2.226 2.226 0 0 0-.532-.241c-.375-.158-.741-.163-1.098-.192.015.004.035.019.054.029l-.024.025.551.142c.224.05.503.207.776.345.546.345.951.872 1.224 1.3.283.443.478.788.649 1.029.171.222.283.36.283.35-.541-.177-.99-.68-1.459-1.211-.248-.261-.492-.547-.834-.759-.322-.236-.722-.359-1.117-.423a4.168 4.168 0 0 0-1.166.019c-.4.035-.717.143-1.122.247l-.171.049c-.054.025-.102.059-.156.093l-.259.158-.434.271c-.288.187-.566.374-.844.566l-.117-.202c.478-.32.903-.674 1.249-.965l.063-.054.113-.089c.073-.054.131-.123.209-.157a7.407 7.407 0 0 0 .801-.404c-.147.044-.293.084-.449.128l-.278.089-.176.059c-.059.029-.107.069-.161.103l-.839.552c-.527.344-1.098.709-1.698 1.068-.595.36-1.225.734-1.859 1.044-.624.315-1.288.61-1.839.719-.259.044-.508.079-.639.044a.65.65 0 0 1-.342-.167c-.132-.109-.302-.325-.488-.606-.185-.276-.375-.596-.61-.935-.443-.67-1.117-1.394-1.907-1.793a4.361 4.361 0 0 0-2.181-.468c.029.045.146.065.312.069.166.015.391.045.62.084.229.054.468.143.649.261.18.133.307.286.327.458-.571-.315-1.205-.423-1.786-.453l-.434-.01-.415.035c-.136.01-.278.014-.405.039-.156.025-.312.044-.463.069-.025-.094.014-.158.092-.212a.818.818 0 0 1 .142-.069c.044-.019.078-.029.122-.044.166-.054.361-.049.419-.084-.058-.005-.161-.024-.287-.015-.064 0-.137.005-.215.01-.117.01-.244.025-.381.035-.073.005-.146.015-.229.024l-.122.01c-.039.015-.068.045-.102.064l-.439.315c-.186.129-.396.271-.62.429-.883.615-2.059 1.443-3.42 2.339-.678.453-1.41.896-2.161 1.319-.186.099-.376.192-.566.291l-.561.251-.264.088-.132.05-.048.01a.286.286 0 0 1-.132.014c-.073 0-.117-.069-.137-.133l-.146-.492a9.047 9.047 0 0 0-.273-.832 4.607 4.607 0 0 0-.513-.96c-.131-.158-.258-.32-.409-.463-.161-.133-.317-.286-.498-.384-.717-.448-1.478-.566-2.088-.566-.644-.015-1.171.073-1.737.182-.088.024-.2.02-.302.069l-.279.118-.361.167c-.229.113-.448.222-.653.335-.83.443-1.571.862-2.259 1.197-.683.334-1.317.59-1.805.699-.239.054-.439.064-.557.054a.618.618 0 0 1-.263-.064c-.137-.069-.302-.325-.4-.551-.112-.222-.176-.409-.259-.468-.078-.064-.146-.015-.209.172-.064.192-.122.522-.03.995a1.609 1.609 0 0 1-.253-.109c.146.503.497.951.985 1.123l-.01-.02Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M271.5 427.242h378v40h-378z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: "var(--ds-border, #091E4224)",
        d: "M272 427.742h377v39H272z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        d: "M279.5 439.242h16v16h-16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-gray-subtler-hovered, #B3B9C4)",
        d: "M391.95 446.951c-13.865 2.577-24.095-4.018-38.098 1.392-.654-2.317-2.344-5.218-4.873-5.261 2.11.053 5.484 6.106 2.094 2.051-1.993-3.087-10.703.686-4.028-1.998-4.608.569-8.833 4.326-11.947 7.669-5.181 4.761-1.249-4.454-4.995-9.088-5.309-6.44-21.422 10.31-18.175 10.321 2.067-2.1 4.841-3.407 5.989-5.735 20.21-13.779 5.628 11.724 17.665 7.451 19.662-17.712 9.725-1.679 21.267-2.774 6.728-6.42 35.334 3.646 35.106-4.028h-.005Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "55.941",
        height: "24",
        x: "513.618",
        y: "435.242",
        fill: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#i)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#FFAC33",
        d: "m536.883 446.75-3.955-1.464-1.477-4.84a.443.443 0 0 0-.849 0l-1.477 4.84-3.955 1.464a.445.445 0 0 0 0 .834l3.953 1.464 1.477 4.988a.445.445 0 0 0 .853-.001l1.477-4.988 3.954-1.463a.445.445 0 0 0-.001-.834Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#FFCC4D",
        d: "m527.994 451.639-1.028-.38-.4-1.467a.444.444 0 0 0-.857 0l-.4 1.467-1.028.38a.444.444 0 0 0 0 .834l1.022.379.404 1.61a.444.444 0 0 0 .862-.001l.403-1.61 1.022-.379a.443.443 0 0 0 0-.833Zm-1.928-9.628-1.05-.388-.39-1.052a.443.443 0 0 0-.833 0l-.389 1.052-1.051.388a.444.444 0 0 0 0 .834l1.051.389.389 1.051a.444.444 0 0 0 .833 0l.389-1.051 1.051-.389a.445.445 0 0 0 0-.834Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
        d: "M560.685 445.685c-.008-.045-1.459-.544-2.196-.424.008.215-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.074c.156.276-.29.626-.878.685v-.35a.678.678 0 0 0 .573-.305s-3.796.313-3.773.208c-.365-.617-7.8-1.205-6.021 1.191 0 0 3.751 1.146 3.743 1.184.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.343.216-.737.238-1.109.038-.752-.201-1.37-.885-1.102l.015.008Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "55.941",
        height: "24",
        x: "585.559",
        y: "435.242",
        fill: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#j)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#77B255",
        d: "M603.742 445.641c-.481.32-.91.693-1.28 1.077-.057-1.887-.51-4.327-3.01-5.521-.495-2.692-6.263-1.324-5.747-1.063 1.028.52 1.576 1.843 2.237 2.54 1.179 1.241 2.491 1.317 3.143.346 1.541 1.001 1.643 2.901 1.596 4.933-.006.224-.011.433-.011.623v6.222c0 .491 1.778.491 1.778 0v-5.107c.241-.424.943-1.558 1.969-2.353.705.619 1.841.422 2.872-.664.662-.697 1.02-2.02 2.048-2.54.543-.275-5.689-1.775-5.595 1.507Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-lime-subtle, #94C748)",
        d: "M632.626 445.685c-.008-.045-1.459-.544-2.196-.424.008.215-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.074c.156.276-.29.626-.878.685v-.35a.68.68 0 0 0 .573-.305s-3.796.313-3.774.208c-.364-.617-7.799-1.205-6.02 1.191 0 0 3.751 1.146 3.743 1.184.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.343.216-.737.238-1.109.038-.752-.201-1.37-.885-1.102l.015.008Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M271.5 475.242h378v40h-378z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M271.5 475.242h378v40h-378z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: "var(--ds-border, #091E4224)",
        d: "M272 475.742h377v39H272z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        d: "M279.5 487.242h16v16h-16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-gray-subtler-hovered, #B3B9C4)",
        d: "M311.775 496.709c.74.457 1.533.659 2.347.787.82.128 1.674.161 2.662.161.242-.114.29-.074.216-.329.053-.061.141-.168.08-.263-.208-.598.39-.524.619-.632.181 1.009 1.593.552 2.905-.289 1.311-.833 2.622-1.936 3.012-2.044.498.807 1.426-.538 2.004-.269-.02.047-.148.296-.162.343.283.249 1.816-.598 3.127-.376.646.101 1.224.41 1.439.685.242.256.175.35-.329.276l.161.283c.047.1.094.208.141.316l.141.309.121.343.128.343.101.37c.007.04.06.168.101.282l.134.343c.094.222.215.437.357.639.578.8 1.607 1.311 2.683 1.25a3.313 3.313 0 0 0 1.566-.47c.343-.222.686-.437 1.029-.666.504-.356 1.069-.612 1.614-.941.282-.141.571-.263.86-.404l.438-.208.45-.168c1.197-.498 2.495-.814 3.833-1.036 2.676-.437 5.534-.276 8.176.195 2.656.484 5.11 1.251 7.161 2.192l-.04-.128c.06.054.282.048.302.195.942-.168 3.268.081 3.268.081.834.047 1.675.081 2.515.108 0 0 1.029.329 2.313.558 1.278.249 2.818.336 3.712.02 2.152.289 4.364.403 6.583.155 0 0 .679-.182 1.439-.451.746-.316 1.566-.713 1.862-1.109.377-.458.538-.901.478-1.231-.061-.336-.35-.565-.875-.585-.517-.007-1.277.155-2.393.518-.034-.034-.135-.054-.162-.114-1.156.511-2.434.497-3.671.41-1.251-.128-2.488-.37-3.799-.471.013.202-.094.343-.161.235l.053-.242c-1.815.276-2.777-.706-4.552-.195l.256-.282c-2.784-.471-6.052-1.372-9.481-2.158-3.429-.774-7.094-1.392-10.443-1.144l.034.034-.013.034c.309.127 1.196.269 1.976.45.397.081.767.155 1.036.229.269.067.45.107.45.107a4.84 4.84 0 0 1-1.681.37 11.278 11.278 0 0 1-1.707-.107c-1.15-.162-2.367-.35-3.524-.162l-.033-.316c.504-.06.975-.148 1.371-.249.39-.094.706-.168.881-.248-1.829-.121-4.727.148-7.343 1.324-.652.296-1.297.592-1.876.969-.295.181-.591.349-.867.537-.269.202-.531.397-.787.592l-.188.148c-.06.047.014 0-.013.027l-.047.06a.43.43 0 0 1-.135.108c-.101.061-.235.081-.363.061-.067.114.047.107.128.134.087.027.148.101.208.518a1.067 1.067 0 0 1-.639-.121c-.201-.101-.322-.309-.403-.518.457-.229.377.007.471-.013a.822.822 0 0 0 .006-.229c.014 0-.027-.101-.06-.188a6.882 6.882 0 0 1-.101-.283c-.067-.195-.195-.417-.309-.652a4.85 4.85 0 0 0-.458-.76c-.094-.134-.195-.269-.295-.417a19.281 19.281 0 0 0-.384-.416c-.248-.296-.612-.545-.975-.814-.396-.229-.82-.464-1.304-.599-.948-.302-1.97-.322-2.905-.195-.935.135-1.788.404-2.609.7-1.64.605-3.113 1.378-4.505 2.024-1.385.652-2.663 1.176-3.732 1.425-1.069.249-1.896.249-2.521.155-.619-.101-1.063-.249-1.271-.135-.195.088-.161.431.424 1.036l-.269.168.013.02Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "55.941",
        height: "24",
        x: "513.5",
        y: "483.242",
        fill: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#k)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#BF6952",
        d: "m534.272 500.028-9.537.033-.733 2.149a.573.573 0 0 0-.033.259.908.908 0 0 0 .897.773h9.286a.908.908 0 0 0 .897-.773.573.573 0 0 0-.033-.259l-.744-2.182Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#854836",
        d: "m534.272 500.027-.085-.247a.65.65 0 0 0-.617-.445h-8.122a.65.65 0 0 0-.617.445l-.096.281a7.565 7.565 0 0 0 4.746 1.669 7.564 7.564 0 0 0 4.791-1.703Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#AA8DD8",
        d: "M529.48 500.92a6.794 6.794 0 1 0 .001-13.589 6.794 6.794 0 0 0-.001 13.589Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#744EAA",
        d: "M531.841 494.604a1.864 1.864 0 1 0 0-3.728 1.864 1.864 0 0 0 0 3.728ZM528.111 496.935a1.398 1.398 0 1 0 0-2.797 1.398 1.398 0 0 0 0 2.797ZM528.577 490.409a.933.933 0 1 0 .001-1.865.933.933 0 0 0-.001 1.865Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        d: "M560.566 493.685c-.007-.045-1.458-.544-2.195-.424.007.215-.03 0-.03 0-.491.55-1.191.245-1.191.245-1.533.186-3.617-.171-5.276.283v.074c.156.276-.29.626-.878.685v-.35a.68.68 0 0 0 .573-.305s-3.796.313-3.774.208c-.364-.617-7.799-1.205-6.021 1.191 0 0 3.751 1.146 3.744 1.184.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.343.216-.737.238-1.109.037-.752-.201-1.37-.885-1.102l.014.008Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "55.941",
        height: "24",
        x: "585.441",
        y: "483.242",
        fill: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#l)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#DD2E44",
        d: "M609.39 492.501a4.386 4.386 0 0 0-4.385-4.386 4.376 4.376 0 0 0-3.564 1.836 4.376 4.376 0 0 0-3.563-1.836 4.386 4.386 0 0 0-4.386 4.386c0 .343.044.676.118.996.609 3.784 4.816 7.775 7.831 8.871 3.015-1.096 7.222-5.087 7.83-8.87.075-.321.119-.653.119-.997Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-red-subtle, #F87168)",
        d: "M632.507 493.685c-.007-.045-1.458-.544-2.195-.424.007.215-.03 0-.03 0-.491.55-1.191.245-1.191.245-1.533.186-3.617-.171-5.276.283v.074c.156.276-.291.626-.878.685v-.35a.68.68 0 0 0 .573-.305s-3.796.313-3.774.208c-.364-.617-7.799-1.205-6.021 1.191 0 0 3.751 1.146 3.744 1.184.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.343.216-.737.238-1.109.037-.752-.201-1.37-.885-1.102l.014.008Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M271.5 523.242h378v40h-378z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: "var(--ds-border, #091E4224)",
        d: "M272 523.742h377v39H272z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        d: "M279.5 535.242h16v16h-16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-gray-subtler-hovered, #B3B9C4)",
        d: "M311.775 544.709c.74.457 1.533.659 2.347.787.82.128 1.674.161 2.662.161.242-.114.29-.074.216-.329.053-.061.141-.168.08-.263-.208-.598.39-.524.619-.632.181 1.009 1.593.552 2.905-.289 1.311-.833 2.622-1.936 3.012-2.044.498.807 1.426-.538 2.004-.269-.02.047-.148.296-.162.343.283.249 1.816-.598 3.127-.376.646.101 1.224.41 1.439.685.242.256.175.35-.329.276l.161.283c.047.1.094.208.141.316l.141.309.121.343.128.343.101.37c.007.04.06.168.101.282l.134.343c.094.222.215.437.357.639.578.8 1.607 1.311 2.683 1.25a3.313 3.313 0 0 0 1.566-.47c.343-.222.686-.437 1.029-.666.504-.356 1.069-.612 1.614-.941.282-.141.571-.263.86-.404l.438-.208.45-.168c1.197-.498 2.495-.814 3.833-1.036 2.676-.437 5.534-.276 8.176.195 2.656.484 5.11 1.251 7.161 2.192l-.04-.128c.06.054.282.048.302.195.942-.168 3.268.081 3.268.081.834.047 1.675.081 2.515.108 0 0 1.029.329 2.313.558 1.278.249 2.818.336 3.712.02 2.152.289 4.364.403 6.583.155 0 0 .679-.182 1.439-.451.746-.316 1.566-.713 1.862-1.109.377-.458.538-.901.478-1.231-.061-.336-.35-.565-.875-.585-.517-.007-1.277.155-2.393.518-.034-.034-.135-.054-.162-.114-1.156.511-2.434.497-3.671.41-1.251-.128-2.488-.37-3.799-.471.013.202-.094.343-.161.235l.053-.242c-1.815.276-2.777-.706-4.552-.195l.256-.282c-2.784-.471-6.052-1.372-9.481-2.158-3.429-.774-7.094-1.392-10.443-1.144l.034.034-.013.034c.309.127 1.196.269 1.976.45.397.081.767.155 1.036.229.269.067.45.107.45.107a4.84 4.84 0 0 1-1.681.37 11.278 11.278 0 0 1-1.707-.107c-1.15-.162-2.367-.35-3.524-.162l-.033-.316c.504-.06.975-.148 1.371-.249.39-.094.706-.168.881-.248-1.829-.121-4.727.148-7.343 1.324-.652.296-1.297.592-1.876.969-.295.181-.591.349-.867.537-.269.202-.531.397-.787.592l-.188.148c-.06.047.014 0-.013.027l-.047.06a.43.43 0 0 1-.135.108c-.101.061-.235.081-.363.061-.067.114.047.107.128.134.087.027.148.101.208.518a1.067 1.067 0 0 1-.639-.121c-.201-.101-.322-.309-.403-.518.457-.229.377.007.471-.013a.822.822 0 0 0 .006-.229c.014 0-.027-.101-.06-.188a6.882 6.882 0 0 1-.101-.283c-.067-.195-.195-.417-.309-.652a4.85 4.85 0 0 0-.458-.76c-.094-.134-.195-.269-.295-.417a19.281 19.281 0 0 0-.384-.416c-.248-.296-.612-.545-.975-.814-.396-.229-.82-.464-1.304-.599-.948-.302-1.97-.322-2.905-.195-.935.135-1.788.404-2.609.7-1.64.605-3.113 1.378-4.505 2.024-1.385.652-2.663 1.176-3.732 1.425-1.069.249-1.896.249-2.521.155-.619-.101-1.063-.249-1.271-.135-.195.088-.161.431.424 1.036l-.269.168.013.02Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "55.941",
        height: "24",
        x: "513.618",
        y: "531.242",
        fill: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#m)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#5DADEC",
        d: "M537.567 540.501a4.386 4.386 0 0 0-4.385-4.386c-1.47 0-2.768.726-3.564 1.836a4.376 4.376 0 0 0-3.563-1.836 4.386 4.386 0 0 0-4.386 4.386c0 .343.044.676.119.996.609 3.784 4.815 7.775 7.83 8.871 3.015-1.096 7.222-5.087 7.83-8.87.076-.321.119-.653.119-.997Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-blue-subtle, #579DFF)",
        d: "M560.685 541.685c-.008-.045-1.459-.544-2.196-.424.008.215-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.074c.156.276-.29.626-.878.685v-.35a.678.678 0 0 0 .573-.305s-3.796.313-3.773.208c-.365-.617-7.8-1.205-6.021 1.191 0 0 3.751 1.146 3.743 1.184.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.343.216-.737.238-1.109.038-.752-.201-1.37-.885-1.102l.015.008Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "55.941",
        height: "24",
        x: "585.559",
        y: "531.242",
        fill: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#n)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F4900C",
        d: "M609.115 543.687c0-.917-.164-1.796-.463-2.608-.204 2.395-1.481 3.625-2.815 3.052-1.25-.537-.408-2.63-.346-3.628.105-1.693-.005-3.631-3.08-5.242 1.278 2.444.148 3.963-1.037 4.055-1.315.103-2.519-1.129-2.074-3.129-1.439 1.06-1.481 2.845-1.037 4 .463 1.203-.019 2.203-1.148 2.314-1.262.125-1.964-1.351-1.317-3.703a7.556 7.556 0 1 0 13.317 4.889Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#FFCC4D",
        d: "M606.178 545.908c.066 1.371-1.138 1.908-1.786 1.649-.936-.375-.685-1.018-.926-2.352-.24-1.333-1.166-2.259-2.536-2.666 1 2.814-.555 3.852-1.369 4.037-.832.189-1.668-.001-1.764-1.781a5.315 5.315 0 0 0-1.547 4.265 7.53 7.53 0 0 0 5.309 2.182c2.07 0 3.944-.834 5.309-2.182a5.298 5.298 0 0 0-.69-3.152Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-orange-subtle, #FEA362)",
        d: "M632.626 541.685c-.008-.045-1.459-.544-2.196-.424.008.215-.03 0-.03 0-.491.55-1.19.245-1.19.245-1.534.186-3.617-.171-5.277.283v.074c.156.276-.29.626-.878.685v-.35a.68.68 0 0 0 .573-.305s-3.796.313-3.774.208c-.364-.617-7.799-1.205-6.02 1.191 0 0 3.751 1.146 3.743 1.184.112.677 10.836.766 10.836.766l3.922-.565s.707-.246.923-.789c.134-.343.216-.737.238-1.109.038-.752-.201-1.37-.885-1.102l.015.008Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-neutral-bold-pressed, #172B4D)",
        d: "M518.264 99.905c6.529-18.04 30.147 5.868 36.898 13.189 9.072.279 19.086-2.55 22.525-11.771 3.449-6.28-.888-13.645-3.862-19.293-6.057-11.315-7.009-9.148-18.45-12.63-9.205-3.08-41.917-17.443-33.248-30.676 6.673-5.714 17.773 4.284 23.344 8.145 6.799 5.45 13.008 11.605 18.629 18.107 3.196 4.15 5.149 7.188 11.002 7.04 16.192 2.166 53.875 1.082 50.314-23.069-5.728-17.442-23.877-27.113-37.972-36.859-.587-.484.988.243 5.302 2.64l-.758-.678c8.902 5.679 17.552 10.706 24.742 18.413.261.303.69.815.514.74-.081.688 2.432 2.912 2.835 3.636 15.806 15.374 4.683 31.406-14.91 35.623.199-.013 1.44-.2 1.605-.213-7.51 2.758-24.344 2.496-32.123 1.098-2.221-.316-2.603-.297.28.323a98.624 98.624 0 0 1-4.397-.593c5.118 7.42 10.918 15.553 10.613 24.93-2.261 11.778-12.57 17.487-23.877 17.642 10.789 12.269 13.413 31.492-6.844 33.752 11.05-4.578 17.221-10.514 11.333-23.381-6.66-13.48-6.629-9.118-19.631-11.979-8.957-2.442-21.577-5.579-23.874-14.137h.01Zm38.794-40.612a145.906 145.906 0 0 0-15.036-12.95l-.05.221c4.494 3.339 8.105 6.804 9.507 8.221-5.662-4.935-14.531-12.837-23.118-15.248-6.361-2.118-6.58 6.516-2.901 9.523 8.167 7.848 18.091 13.71 28.435 17.727-1.898-.493-5.88-2.57-7.479-2.792 4.461 2.112 9.071 3.918 13.553 5.244.102-.333-2.506-.981-2.984-1.238.523.164 5.931 1.785 9.909 2.594-2.852-3.909-6.22-7.698-9.842-11.304l.006.002Zm-36.34 42.291c.257.436.542.888.919 1.318-.112-.148-.459-.824-.5-.913 7.915 7.969 20.564 10.112 31.575 11.049-2.915-3.235-10.083-9.685-14.571-12.508.25.012-.144-.38-.589-.585.012-.005.055.227.061.229-3.891-2.435-7.402-5.349-11.999-4.638-2.73.46-6.779 2.905-4.894 6.052l-.002-.004Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "m529.558 103.599.002.004-.007-.006.005.002Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M121.5 151.742h339v21h-339z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M332.618 199.242h16v16h-16z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "c"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M404.559 199.242h16v16h-16z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "d"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M332.618 247.242h16v16h-16z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "e"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M404.559 247.242h16v16h-16z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "f"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M332.618 295.242h16v16h-16z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "g"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M404.559 295.242h16v16h-16z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "h"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M310.5 398.242h186v8h-186z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "i"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M521.618 439.242h16v16h-16z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "j"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M593.559 439.242h16v16h-16z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "k"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M521.5 487.242h16v16h-16z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "l"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M593.441 487.242h16v16h-16z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "m"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M521.618 535.242h16v16h-16z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "n"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        d: "M593.559 535.242h16v16h-16z"
    }))));
const $936ceae5a4a545da$var$svgStyles = null;

});

parcelRegister("dnM4Q", function(module, exports) {

$parcel$export(module.exports, "Drawer", () => $a9cf9b1218f39ca6$export$4071300121a182f5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $1Seuh = parcelRequire("1Seuh");

var $kweMg = parcelRequire("kweMg");

var $7xhdA = parcelRequire("7xhdA");
var $3aB43 = parcelRequire("3aB43");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $9IUNr = parcelRequire("9IUNr");
const $a9cf9b1218f39ca6$export$4071300121a182f5 = ({ isOpen: isOpen, onClose: onClose, children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [cookieBannerHeight, setCookieBannerHeight] = (0, $5uXOq.useState)(undefined);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Escape' && isOpen) onClose();
    }, [
        isOpen,
        onClose
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keydown', handleKeyDown);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('keydown', handleKeyDown);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        isOpen,
        handleKeyDown
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $4R6GH.fg)('polaris_roadmap_cookie_overlap_fix')) return;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const banner = document.querySelector('[role="banner"]');
        const updateBannerHeight = ()=>{
            setCookieBannerHeight(banner ? banner.getBoundingClientRect().height : undefined);
        };
        updateBannerHeight();
        const observer = new MutationObserver(()=>updateBannerHeight());
        const cookieBannerParent = banner?.parentNode;
        if (cookieBannerParent) // so that we can adjust the drawer height when the cookie banner is dismissed
        observer.observe(cookieBannerParent, {
            childList: true
        });
        return ()=>{
            if (cookieBannerParent) observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7xhdA.default), {
        appear: true
    }, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3aB43.default), {
        duration: "medium",
        enterFrom: "left",
        exitTo: "left"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9cf9b1218f39ca6$var$Container, {
            ...props,
            bannerHeight: (0, $4R6GH.fg)('polaris_roadmap_cookie_overlap_fix') ? cookieBannerHeight : undefined
        }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: $a9cf9b1218f39ca6$var$closeButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
            shape: "circle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kweMg))),
            label: formatMessage((0, $9IUNr.default).closeButtonLabel),
            appearance: "subtle",
            onClick: onClose
        })))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a9cf9b1218f39ca6$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { bannerHeight: bannerHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1kn4d69": (0, $lD23V.default)(__cmplp.bannerHeight, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bsbauwl _kqsw1n9t _1ltvze3t _1pbyfjpv _bfhk1bhr",
            __cmplp.bannerHeight ? "_4t3i2ld4" : "_4t3ip97y",
            __cmplp.bannerHeight ? "_154i1d1h" : "_154ieaa0",
            __cmplp.className
        ])
    });
});
const $a9cf9b1218f39ca6$var$closeButtonStyles = (0, $2s57o.xcss)({
    position: 'absolute',
    top: 'space.250',
    left: 'space.250'
});

});
parcelRegister("9IUNr", function(module, exports) {

$parcel$export(module.exports, "default", () => $83b6fecaa440afb3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $83b6fecaa440afb3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    closeButtonLabel: {
        "id": "polaris-component-collection-create.drawer.close-button-label",
        "defaultMessage": "Close"
    }
});

});


parcelRegister("6Gni9", function(module, exports) {

$parcel$export(module.exports, "Form", () => $a988e489098890b8$export$a7fed597f4b8afd8);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $7folp = parcelRequire("7folp");
var $4EHpO = parcelRequire("4EHpO");
var $cGltd = parcelRequire("cGltd");

var $bWfiu = parcelRequire("bWfiu");

var $jcX1N = parcelRequire("jcX1N");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $9r7BT = parcelRequire("9r7BT");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $aOD49 = parcelRequire("aOD49");

var $dpYV0 = parcelRequire("dpYV0");

var $1qdF0 = parcelRequire("1qdF0");

var $g1VWt = parcelRequire("g1VWt");



var $1X3JP = parcelRequire("1X3JP");

var $jdnWL = parcelRequire("jdnWL");

var $eW55R = parcelRequire("eW55R");

var $90yGq = parcelRequire("90yGq");

var $lVJAU = parcelRequire("lVJAU");

var $lqcJn = parcelRequire("lqcJn");

var $eOMZh = parcelRequire("eOMZh");

var $9iiI8 = parcelRequire("9iiI8");

var $4329T = parcelRequire("4329T");

var $gE10J = parcelRequire("gE10J");

var $17h70 = parcelRequire("17h70");

var $v0rRn = parcelRequire("v0rRn");

var $9xjQI = parcelRequire("9xjQI");

var $4AjLa = parcelRequire("4AjLa");

var $FzDIO = parcelRequire("FzDIO");
const $a988e489098890b8$var$MAX_COLLECTION_NAME_LENGTH = 100;
const $a988e489098890b8$export$a7fed597f4b8afd8 = ({ onSuccess: onSuccess })=>{
    const [projectKeys, setProjectKeys] = (0, $5uXOq.useState)([]);
    const [filtersJql, setFiltersJql] = (0, $5uXOq.useState)('');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [selectedEmojiId, setSelectedEmojiId] = (0, $5uXOq.useState)();
    const [ideasCountOLD, setIdeasCountOLD] = (0, $5uXOq.useState)(0);
    const { createCollection: createCollection, createView: createView } = (0, $1qdF0.useCollectionsActions)();
    const { errorWithRefresh: errorWithRefresh } = (0, $eW55R.useNotifications)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const ownerId = (0, $90yGq.useAccountId)() ?? '';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [ideasCount, isIdeasCountLoading, _ideasCountError, ideasCountRequest] = (0, $4AjLa.useCollectionIdeasCount)(projectKeys, filtersJql);
    const validateNameField = (0, $5uXOq.useCallback)((value)=>{
        if (value === undefined || value.trim().length === 0) return formatMessage((0, $v0rRn.default).emptyNameError);
        if (value.length > $a988e489098890b8$var$MAX_COLLECTION_NAME_LENGTH) return formatMessage((0, $v0rRn.default).nameTooLongError);
        return undefined;
    }, [
        formatMessage
    ]);
    const validateProjectsField = (0, $5uXOq.useCallback)((value)=>{
        if (value === undefined || value.length === 0) return formatMessage((0, $v0rRn.default).emptyProjectsError);
        return undefined;
    }, [
        formatMessage
    ]);
    const handleSubmit = (0, $5uXOq.useCallback)(async (formData)=>{
        try {
            const projectKeysOLD = formData[(0, $gE10J.FormFieldKeys).PROJECTS];
            const jql = (0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering') ? (0, $dpYV0.getJQLForCollection)(projectKeys, filtersJql) : (0, $dpYV0.getJQLForCollection)(projectKeysOLD, undefined);
            if ((0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering')) {
                let newIdeasCount = ideasCount;
                if (ideasCountRequest) newIdeasCount = await ideasCountRequest;
                if (newIdeasCount && newIdeasCount > (0, $gE10J.IDEAS_COUNT_LIMIT)) return;
            } else {
                const newIdeasCount = await (0, $9iiI8.getIdeasCountForCollection)(jql);
                setIdeasCountOLD(newIdeasCount);
                if (newIdeasCount > (0, $gE10J.IDEAS_COUNT_LIMIT)) return;
            }
            const collection = await createCollection({
                name: formData[(0, $gE10J.FormFieldKeys).COLLECTION_NAME],
                jql: jql,
                emoji: selectedEmojiId,
                ownerId: ownerId,
                createAnalyticsEvent: createAnalyticsEvent
            });
            if (!collection) return;
            const fieldsInJQL = await ((0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering') ? (0, $4329T.getFieldsKeysWithJql)(jql) : Promise.resolve({}));
            const fields = [
                (0, $7d87475f2d1b3049$export$469f8bf472cb9ca),
                (0, $7d87475f2d1b3049$export$1fd24e9c03ef9b18),
                ...(0, $dpYV0.getFieldsFromJql)(filtersJql, fieldsInJQL)
            ];
            await createView(collection.uuid, {
                visualizationType: (0, $739ce7f4993d045e$export$76e8cbc60f99881d),
                name: formatMessage((0, $v0rRn.default).listViewName),
                fields: fields
            });
            await createView(collection.uuid, {
                visualizationType: (0, $739ce7f4993d045e$export$b536e56a69266159),
                name: formatMessage((0, $v0rRn.default).timelineViewName),
                fields: fields
            });
            await createView(collection.uuid, {
                visualizationType: (0, $739ce7f4993d045e$export$1ad049af934b4509),
                name: formatMessage((0, $v0rRn.default).boardViewName),
                fields: fields
            });
            await createView(collection.uuid, {
                visualizationType: (0, $739ce7f4993d045e$export$2b0330ebc4df6bb5),
                name: formatMessage((0, $v0rRn.default).matrixViewName),
                fields: fields
            });
            push((0, $aOD49.getCollectionDetailsPageUrl)(collection.uuid));
            onSuccess?.({
                ...collection
            });
        } catch (err) {
            errorWithRefresh({
                title: formatMessage((0, $v0rRn.default).errorTitle),
                description: formatMessage((0, $v0rRn.default).errorDescription)
            });
        }
    }, [
        projectKeys,
        filtersJql,
        createCollection,
        selectedEmojiId,
        ownerId,
        createAnalyticsEvent,
        createView,
        formatMessage,
        push,
        onSuccess,
        ideasCount,
        errorWithRefresh,
        ideasCountRequest
    ]);
    const exceedsIdeasLimitOLD = ideasCountOLD > (0, $gE10J.IDEAS_COUNT_LIMIT_OLD);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: (0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering') ? $a988e489098890b8$var$mainContainerStyles : undefined,
        paddingBlock: (0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering') ? undefined : 'space.1000',
        paddingInline: (0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering') ? undefined : 'space.400'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7folp.default), {
        onSubmit: handleSubmit
    }, ({ formProps: formProps, submitting: submitting, setFieldValue: setFieldValue, getValues: getValues })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            as: "form",
            ...formProps,
            name: "collection-create-form",
            xcss: [
                $a988e489098890b8$var$formStyles,
                (0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering') ? $a988e489098890b8$var$innerContainerStyles : $a988e489098890b8$var$containerStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
            xcss: (0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering') ? $a988e489098890b8$var$scrollableContainerStyles : $a988e489098890b8$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
            size: "xxlarge"
        }, formatMessage((0, $v0rRn.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            paddingBlockStart: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
            as: "p"
        }, formatMessage((0, $v0rRn.default).description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EHpO.default), {
            label: formatMessage((0, $v0rRn.default).roadmapNameFieldLabel),
            name: (0, $gE10J.FormFieldKeys).COLLECTION_NAME,
            isRequired: true,
            validate: validateNameField
        }, ({ fieldProps: fieldProps, error: error, meta: meta })=>{
            const isInvalid = fieldProps.isInvalid && !!error && (meta.submitFailed || meta.dirty);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9r7BT.default), {
                ...fieldProps,
                isInvalid: isInvalid,
                isRequired: false,
                testId: "polaris-component-collection-create.ui.form.collection-name",
                autoFocus: true,
                placeholder: formatMessage((0, $v0rRn.default).roadmapNameFieldPlaceholder),
                elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                    paddingInlineStart: "space.025"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1X3JP.EmojiPicker), {
                    onEmojiSelected: (emoji)=>{
                        setSelectedEmojiId(emoji?.id);
                    },
                    readonly: submitting,
                    selectedEmojiId: selectedEmojiId,
                    emojiAddIcon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jcX1N))), {
                            ...iconProps,
                            color: "var(--ds-icon, #44546F)",
                            LEGACY_primaryColor: "var(--ds-icon, #44546F)"
                        }),
                    zIndex: (0, $eOMZh.DRAWER_Z_INDEX) + 1
                }))
            }), isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdnWL.ErrorContainer), {
                "data-testid": "polaris-component-collection-create.ui.form.name-field-error"
            }, error));
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EHpO.default), {
            label: formatMessage((0, $v0rRn.default).projectsSelectFieldLabel),
            name: (0, $gE10J.FormFieldKeys).PROJECTS,
            isRequired: true,
            validate: validateProjectsField
        }, ({ fieldProps: { onChange: onChange, ...restFieldProps }, error: error, meta: meta })=>{
            const isInvalid = restFieldProps.isInvalid && !!error && (meta.submitFailed || meta.dirty);
            const { id: id, isRequired: isRequired, value: value, ...selectProps } = restFieldProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $4R6GH.fg)('jpd_project_select_component') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lqcJn.ProjectSelect), {
                ...selectProps,
                isInvalid: isInvalid,
                onChange: (newValue)=>{
                    const values = newValue.map((v)=>v.value);
                    if ((0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering')) {
                        if (Array.isArray(values)) setProjectKeys(values);
                    } else setIdeasCountOLD(0);
                    onChange(values);
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9xjQI.ProjectSelect), {
                ...restFieldProps,
                isInvalid: isInvalid,
                onChange: (values)=>{
                    if ((0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering')) {
                        if (Array.isArray(values)) setProjectKeys(values);
                    } else setIdeasCountOLD(0);
                    onChange(values);
                }
            }), isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdnWL.ErrorContainer), {
                "data-testid": "polaris-component-collection-create.ui.form.projects-field-error"
            }, error));
        }), (0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
            xcss: $a988e489098890b8$var$filtersContainerStyles,
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
            space: "space.025",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
            color: "color.text.subtle",
            weight: "semibold",
            size: "small"
        }, formatMessage((0, $v0rRn.default).filtersLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $FzDIO.FilterExplanation), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
            size: "small"
        }, formatMessage((0, $v0rRn.default).filtersDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1VWt.CollectionAdvancedFilters), {
            value: getValues()[(0, $gE10J.FormFieldKeys).FILTERS],
            projectKeys: projectKeys,
            onChange: (value)=>{
                setFiltersJql(value);
                setFieldValue((0, $gE10J.FormFieldKeys).FILTERS, value);
            }
        })), exceedsIdeasLimitOLD && !(0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            paddingBlockStart: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cGltd.Label), {
            htmlFor: ""
        }, formatMessage((0, $v0rRn.default).filtersLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            padding: "space.100",
            backgroundColor: "color.background.warning",
            xcss: $a988e489098890b8$var$ideasLimitStyles
        }, formatMessage((0, $v0rRn.default).limitExceededError, {
            ideasCount: ideasCountOLD,
            b: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, text)
        }), ' ', formatMessage((0, $v0rRn.default).limitExceededErrorAction, {
            ideasCount: ideasCountOLD,
            maxIdeas: (0, $gE10J.IDEAS_COUNT_LIMIT_OLD)
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17h70.Footer), {
            submitting: submitting,
            ideasCount: (0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering') ? ideasCount : ideasCountOLD,
            isIdeasCountLoading: isIdeasCountLoading
        }))));
};
const $a988e489098890b8$var$mainContainerStyles = (0, $2s57o.xcss)({
    height: '100%'
});
const $a988e489098890b8$var$innerContainerStyles = (0, $2s57o.xcss)({
    height: '100%',
    paddingInline: 'space.400',
    overflow: 'auto'
});
// scrollable when we want to make footer sticky, we just need to add "overflow: auto" on it
const $a988e489098890b8$var$scrollableContainerStyles = (0, $2s57o.xcss)({
    paddingBlockStart: 'space.1000'
});
const $a988e489098890b8$var$containerStyles = (0, $2s57o.xcss)({
    margin: '0 auto',
    maxWidth: '410px',
    height: '100%'
});
const $a988e489098890b8$var$formStyles = (0, $2s57o.xcss)({
    display: 'flex',
    gap: 'space.150',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    minHeight: '0'
});
const $a988e489098890b8$var$ideasLimitStyles = (0, $2s57o.xcss)({
    borderRadius: 'border.radius.100'
});
const $a988e489098890b8$var$filtersContainerStyles = (0, $2s57o.xcss)({
    paddingBlockStart: 'space.100',
    minHeight: '0'
});

});
parcelRegister("jcX1N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73bb0e29c7f7a728c3573234fe0b4d23>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dfbced04b7aaa70e$var$_react = $dfbced04b7aaa70e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dfbced04b7aaa70e$var$_emojiAdd = $dfbced04b7aaa70e$var$_interopRequireDefault((parcelRequire("9XxNN")));

var $dfbced04b7aaa70e$var$_emojiAdd2 = $dfbced04b7aaa70e$var$_interopRequireDefault((parcelRequire("4gc8e")));
function $dfbced04b7aaa70e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmojiAddIcon.
 * This component is EmojiAddIcon, with `UNSAFE_fallbackIcon` set to "EmojiAddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding an emoji reaction.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dfbced04b7aaa70e$var$EmojiAddIcon = (props)=>/*#__PURE__*/ $dfbced04b7aaa70e$var$_react.default.createElement($dfbced04b7aaa70e$var$_emojiAdd.default, Object.assign({
        LEGACY_fallbackIcon: $dfbced04b7aaa70e$var$_emojiAdd2.default
    }, props));
$dfbced04b7aaa70e$var$EmojiAddIcon.Name = 'EmojiAddIconMigration';
var $dfbced04b7aaa70e$var$_default = module.exports.default = $dfbced04b7aaa70e$var$EmojiAddIcon;

});
parcelRegister("9XxNN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd679256a7ffba837ffea22e1b814e43>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7403d82b350ee361$var$_react = $7403d82b350ee361$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7403d82b350ee361$var$_baseNew = $7403d82b350ee361$var$_interopRequireDefault((parcelRequire("enEmH")));
function $7403d82b350ee361$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding an emoji reaction.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7403d82b350ee361$var$EmojiAddIcon = (props)=>/*#__PURE__*/ $7403d82b350ee361$var$_react.default.createElement($7403d82b350ee361$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 8a6.5 6.5 0 1 0 13 0H16a8 8 0 1 1-8-8v1.5A6.5 6.5 0 0 0 1.5 8m4.585 2.033c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513M5.75 7.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m4.5 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m2.25-4h-2V2h2V0H14v2h2v1.5h-2v2h-1.5z" clip-rule="evenodd"/>`
    }, props));
$7403d82b350ee361$var$EmojiAddIcon.displayName = 'EmojiAddIcon';
var $7403d82b350ee361$var$_default = module.exports.default = $7403d82b350ee361$var$EmojiAddIcon;

});

parcelRegister("4gc8e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $31a21129fb022c0c$var$_react = $31a21129fb022c0c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $31a21129fb022c0c$var$_emojiAdd = $31a21129fb022c0c$var$_interopRequireDefault((parcelRequire("9XxNN")));
function $31a21129fb022c0c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $31a21129fb022c0c$var$EmojiAddIcon = (props)=>/*#__PURE__*/ $31a21129fb022c0c$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.049 14.197c-.166-.476.103-.991.602-1.15.5-.159 1.039.098 1.205.575.06.174.225.487.495.796.426.488.955.764 1.649.764.693 0 1.223-.276 1.65-.764.27-.31.433-.622.494-.796.166-.476.706-.734 1.204-.575.5.159.77.673.603 1.15-.13.371-.395.876-.839 1.385C14.348 16.458 13.306 17 12 17s-2.348-.542-3.112-1.418a4.4 4.4 0 0 1-.839-1.385M9.5 11a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M19 5h1a1 1 0 0 1 0 2h-1v1a1 1 0 0 1-2 0V7h-1a1 1 0 0 1 0-2h1V4a1 1 0 0 1 2 0zm-5-1.777V5.29A7 7 0 1 0 18.71 10h2.067A9 9 0 1 1 14 3.223"/></svg>`
    }, props, {
        newIcon: $31a21129fb022c0c$var$_emojiAdd.default
    }));
$31a21129fb022c0c$var$EmojiAddIcon.displayName = 'EmojiAddIcon';
var $31a21129fb022c0c$var$_default = module.exports.default = $31a21129fb022c0c$var$EmojiAddIcon;

});


parcelRegister("aOD49", function(module, exports) {

$parcel$export(module.exports, "getCollectionDetailsPageUrl", () => $a92ae6c7b428c3ad$export$6d4e7a90e74e9b12);
$parcel$export(module.exports, "getCollectionViewPageUrl", () => $a92ae6c7b428c3ad$export$32ac8841347e1f79);
$parcel$export(module.exports, "getCollectionsPageUrl", () => $a92ae6c7b428c3ad$export$d15219b9c6a3e2f7);
const $a92ae6c7b428c3ad$var$withQueryParams = (path, queryParams)=>{
    if (queryParams) {
        const searchParams = new URLSearchParams();
        Object.keys(queryParams).forEach((key)=>{
            if (queryParams[key]) searchParams.set(key, queryParams[key]);
        });
        if (searchParams.size > 0) return `${path}?${searchParams.toString()}`;
    }
    return path;
};
const $a92ae6c7b428c3ad$export$6d4e7a90e74e9b12 = (collectionUUID)=>`/jira/polaris/roadmaps/${collectionUUID}/view`;
const $a92ae6c7b428c3ad$export$32ac8841347e1f79 = (collectionUUID, viewUUID, queryParams)=>$a92ae6c7b428c3ad$var$withQueryParams(`/jira/polaris/roadmaps/${collectionUUID}/view/${viewUUID}`, queryParams);
const $a92ae6c7b428c3ad$export$d15219b9c6a3e2f7 = (queryParams)=>$a92ae6c7b428c3ad$var$withQueryParams('/jira/polaris/roadmaps', queryParams);

});

parcelRegister("dpYV0", function(module, exports) {

$parcel$export(module.exports, "getJQLForCollection", () => $982aeb25f1017157$export$8d4a8272ec8d3589);
$parcel$export(module.exports, "extractProjectKeysFromJql", () => $982aeb25f1017157$export$35840c54e03d7673);
$parcel$export(module.exports, "extractFiltersJqlFromJql", () => $982aeb25f1017157$export$bcd3615366d8d128);
$parcel$export(module.exports, "getFieldsFromJql", () => $982aeb25f1017157$export$54e99094db1a28af);

var $gjjVy = parcelRequire("gjjVy");
var $3KEIl = parcelRequire("3KEIl");
var $3jFAr = parcelRequire("3jFAr");
var $9Dyrx = parcelRequire("9Dyrx");

var $4R6GH = parcelRequire("4R6GH");
const $982aeb25f1017157$var$quoteProjectKey = (projectKey)=>`"${projectKey}"`;
const $982aeb25f1017157$var$PROJECT_FIELD_KEY = 'project';
const $982aeb25f1017157$export$8d4a8272ec8d3589 = (projectsKeys = [], filtersJql = '')=>{
    if ((0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering')) {
        const jast = new (0, $3KEIl.JastBuilder)().build(filtersJql);
        projectsKeys.length && jast.query?.appendClause((0, $gjjVy.default).terminalClause((0, $gjjVy.default).field($982aeb25f1017157$var$PROJECT_FIELD_KEY), (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_IN)), (0, $gjjVy.default).listOperand(projectsKeys.map($982aeb25f1017157$var$quoteProjectKey).map((0, $gjjVy.default).byText.valueOperand))), (0, $ed890f3e326c0985$export$6d6d48d210d3ca97));
        if (jast.query?.orderBy) jast.query.removeOrderBy();
        return (0, $9Dyrx.print)(jast);
    }
    if (!projectsKeys.length) return '';
    const jast = (0, $gjjVy.default).jast((0, $gjjVy.default).query((0, $gjjVy.default).terminalClause((0, $gjjVy.default).field($982aeb25f1017157$var$PROJECT_FIELD_KEY), (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_IN)), (0, $gjjVy.default).listOperand(projectsKeys.map($982aeb25f1017157$var$quoteProjectKey).map((0, $gjjVy.default).byText.valueOperand)))));
    return (0, $9Dyrx.print)(jast);
};
const $982aeb25f1017157$var$projectInRegex = /project\s+in\s+\((.*?)\)/;
const $982aeb25f1017157$var$projectKeyRegex = /"(.*?)"/g;
const $982aeb25f1017157$export$35840c54e03d7673 = (jql)=>{
    // Extract the part of the JQL related to `project in (...)`
    const projectInMatch = $982aeb25f1017157$var$projectInRegex.exec(jql);
    const projectKeys = [];
    if (projectInMatch) {
        const projectInClause = projectInMatch[1];
        let match;
        // Extract all project keys inside the quotes within the `project in (...)` clause
        // eslint-disable-next-line no-cond-assign
        while((match = $982aeb25f1017157$var$projectKeyRegex.exec(projectInClause)) !== null)projectKeys.push(match[1]);
    }
    return projectKeys;
};
const $982aeb25f1017157$export$bcd3615366d8d128 = (jql)=>{
    if (!(0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering')) return '';
    const jast = new (0, $3KEIl.JastBuilder)().build(jql);
    const { where: where } = jast.query ?? {};
    if (!where) return '';
    const clauses = where.clauseType === (0, $64e15c988a7f27d3$export$7a58b23488ea076b) ? where.clauses : [
        where
    ];
    const projectKeysClause = clauses.find((c)=>c.clauseType === (0, $64e15c988a7f27d3$export$ae56b4ef248a2b6a) && c.field.value === $982aeb25f1017157$var$PROJECT_FIELD_KEY);
    if (projectKeysClause) projectKeysClause.remove();
    return (0, $9Dyrx.print)(jast);
};
const $982aeb25f1017157$var$getFieldsFromClauses = ([clause, ...rest])=>{
    if (!clause) return [];
    if (clause.clauseType === (0, $64e15c988a7f27d3$export$ae56b4ef248a2b6a)) return [
        clause.field.value,
        ...$982aeb25f1017157$var$getFieldsFromClauses(rest)
    ];
    if (clause.clauseType === (0, $64e15c988a7f27d3$export$e356b89f8c8d2fcb)) return $982aeb25f1017157$var$getFieldsFromClauses([
        clause.clause,
        ...rest
    ]);
    return $982aeb25f1017157$var$getFieldsFromClauses([
        ...clause.clauses,
        ...rest
    ]);
};
const $982aeb25f1017157$var$getFieldKeyFromFieldName = (fieldKeys)=>(fieldName)=>fieldKeys[fieldName.replace(/\[.+\]$/, '').toLowerCase()];
const $982aeb25f1017157$export$54e99094db1a28af = (jql, fieldKeys)=>{
    if (!(0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering')) return [];
    const jast = new (0, $3KEIl.JastBuilder)().build(jql);
    const { where: where } = jast.query ?? {};
    if (!where) return [];
    const clauses = where.clauseType === (0, $64e15c988a7f27d3$export$7a58b23488ea076b) ? where.clauses : [
        where
    ];
    return $982aeb25f1017157$var$getFieldsFromClauses(clauses).map($982aeb25f1017157$var$getFieldKeyFromFieldName(fieldKeys)).filter((field)=>!!field);
};

});
const $64e15c988a7f27d3$export$7a58b23488ea076b = 'compound';
const $64e15c988a7f27d3$export$ae56b4ef248a2b6a = 'terminal';
const $64e15c988a7f27d3$export$e356b89f8c8d2fcb = 'not';

const $ed890f3e326c0985$export$6d6d48d210d3ca97 = 'and';
const $ed890f3e326c0985$export$7b8f0a728d79a753 = 'or';

parcelRegister("gjjVy", function(module, exports) {

$parcel$export(module.exports, "internalCreators", () => $eb2b35f28a3812f3$export$64d991963cfb5532);
$parcel$export(module.exports, "default", () => $eb2b35f28a3812f3$export$2e2bcd8739ae039);

var $ko4HR = parcelRequire("ko4HR");

var $7YEwf = parcelRequire("7YEwf");

var $MKhaL = parcelRequire("MKhaL");

var $8WhE5 = parcelRequire("8WhE5");

var $brZCc = parcelRequire("brZCc");

var $luQo9 = parcelRequire("luQo9");

var $iQuQ1 = parcelRequire("iQuQ1");

var $2JCCY = parcelRequire("2JCCY");

var $5zajP = parcelRequire("5zajP");

var $5sUyi = parcelRequire("5sUyi");

var $3l0pH = parcelRequire("3l0pH");

var $jlTcB = parcelRequire("jlTcB");

var $btuOD = parcelRequire("btuOD");

var $5r1xx = parcelRequire("5r1xx");

var $lpnwE = parcelRequire("lpnwE");

var $dqDkv = parcelRequire("dqDkv");

var $l4ARm = parcelRequire("l4ARm");

var $bl6uf = parcelRequire("bl6uf");

var $gF3Zx = parcelRequire("gF3Zx");

var $dglO1 = parcelRequire("dglO1");

var $6YF5f = parcelRequire("6YF5f");

var $4AWFE = parcelRequire("4AWFE");
const $eb2b35f28a3812f3$export$64d991963cfb5532 = {
    query: (0, $dglO1.queryInternal),
    compoundClause: (0, $7YEwf.compoundClauseInternal),
    compoundOperator: (0, $MKhaL.compoundOperatorInternal),
    terminalClause: (0, $6YF5f.terminalClauseInternal),
    notClause: (0, $5sUyi.notClauseInternal),
    notClauseOperator: (0, $3l0pH.notClauseOperatorInternal),
    predicate: (0, $l4ARm.predicateInternal),
    predicateOperator: (0, $bl6uf.predicateOperatorInternal),
    field: (0, $8WhE5.fieldInternal),
    property: (0, $gF3Zx.propertyInternal),
    operator: (0, $jlTcB.operatorInternal),
    valueOperand: (0, $4AWFE.valueOperandInternal),
    keywordOperand: (0, $2JCCY.keywordOperandInternal),
    functionOperand: (0, $brZCc.functionOperandInternal),
    functionString: (0, $luQo9.functionStringInternal),
    argument: (0, $ko4HR.argumentInternal),
    listOperand: (0, $5zajP.listOperandInternal),
    orderBy: (0, $btuOD.orderByInternal),
    orderByOperator: (0, $dqDkv.orderByOperatorInternal),
    orderByField: (0, $lpnwE.orderByFieldInternal),
    orderByDirection: (0, $5r1xx.orderByDirectionInternal)
};
var $eb2b35f28a3812f3$export$2e2bcd8739ae039 = {
    jast: $iQuQ1.jast,
    query: $dglO1.query,
    compoundClause: $7YEwf.compoundClause,
    compoundOperator: $MKhaL.compoundOperator,
    terminalClause: $6YF5f.terminalClause,
    notClause: $5sUyi.notClause,
    notClauseOperator: $3l0pH.notClauseOperator,
    predicate: $l4ARm.predicate,
    predicateOperator: $bl6uf.predicateOperator,
    field: $8WhE5.field,
    property: $gF3Zx.property,
    operator: $jlTcB.operator,
    valueOperand: $4AWFE.valueOperand,
    keywordOperand: $2JCCY.keywordOperand,
    functionOperand: $brZCc.functionOperand,
    functionString: $luQo9.functionString,
    argument: $ko4HR.argument,
    listOperand: $5zajP.listOperand,
    orderBy: $btuOD.orderBy,
    orderByOperator: $dqDkv.orderByOperator,
    orderByField: $lpnwE.orderByField,
    orderByDirection: $5r1xx.orderByDirection,
    byText: {
        argument: (0, $ko4HR.argumentByText),
        valueOperand: (0, $4AWFE.valueOperandByText)
    }
};

});
parcelRegister("ko4HR", function(module, exports) {

$parcel$export(module.exports, "argument", () => $7b23464c119435bb$export$6ea29ee575e3f5ff);
$parcel$export(module.exports, "argumentInternal", () => $7b23464c119435bb$export$5b341d50fa5bcdd5);
$parcel$export(module.exports, "argumentByText", () => $7b23464c119435bb$export$84c43d23f51170cb);

var $2QsWS = parcelRequire("2QsWS");
var $l8THn = parcelRequire("l8THn");

var $9xy4P = parcelRequire("9xy4P");
function $7b23464c119435bb$var$acceptArgument(visitor) {
    return visitor.visitArgument ? visitor.visitArgument(this) : visitor.visitChildren(this);
}
function $7b23464c119435bb$var$enterNode(listener) {
    listener.enterArgument && listener.enterArgument(this);
}
function $7b23464c119435bb$var$exitNode(listener) {
    listener.exitArgument && listener.exitArgument(this);
}
const $7b23464c119435bb$export$6ea29ee575e3f5ff = (value)=>$7b23464c119435bb$export$5b341d50fa5bcdd5(value, (0, $l8THn.sanitiseJqlString)(value));
const $7b23464c119435bb$export$84c43d23f51170cb = (text)=>$7b23464c119435bb$export$5b341d50fa5bcdd5((0, $2QsWS.normaliseJqlString)(text), text);
const $7b23464c119435bb$export$5b341d50fa5bcdd5 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $7b23464c119435bb$var$acceptArgument,
        enterNode: $7b23464c119435bb$var$enterNode,
        exitNode: $7b23464c119435bb$var$exitNode,
        getChildren: (0, $9xy4P.noChildren),
        parent: null
    });

});
parcelRegister("2QsWS", function(module, exports) {

$parcel$export(module.exports, "normaliseJqlString", () => $9324116c68e17681$export$cecf78a779acc0ff);
const $9324116c68e17681$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $9324116c68e17681$export$d5efd6512db694fd = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $9324116c68e17681$export$b86601123607fee5 = (maybeQuotedString)=>$9324116c68e17681$export$7a0b99b892e0dda8(maybeQuotedString) || $9324116c68e17681$export$d5efd6512db694fd(maybeQuotedString);
const $9324116c68e17681$export$cecf78a779acc0ff = (maybeQuotedString)=>{
    if ($9324116c68e17681$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
    if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
    return maybeQuotedString;
};

});

parcelRegister("l8THn", function(module, exports) {

$parcel$export(module.exports, "sanitiseJqlString", () => $f17d3fd8243c836f$export$3eb9033c48208278);

var $8QDwl = parcelRequire("8QDwl");
// Derived from JQLLexer#VALID_UNQUOTED_CHARS
const $f17d3fd8243c836f$var$CHARS_TO_QUOTE = new RegExp(`[\\s${(0, (/*@__PURE__*/$parcel$interopDefault($8QDwl)))(`"'=!<>()~,[]|&{}*/%+^$#@?;`)}]`);
const $f17d3fd8243c836f$export$3eb9033c48208278 = (jqlString)=>{
    if ($f17d3fd8243c836f$var$CHARS_TO_QUOTE.test(jqlString)) return `"${jqlString.replace(/"/g, '\\"')}"`;
    return jqlString;
};

});
parcelRegister("8QDwl", function(module, exports) {

var $jJVtR = parcelRequire("jJVtR");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $6711d60dd8e02df4$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $6711d60dd8e02df4$var$reHasRegExpChar = RegExp($6711d60dd8e02df4$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $6711d60dd8e02df4$var$escapeRegExp(string) {
    string = $jJVtR(string);
    return string && $6711d60dd8e02df4$var$reHasRegExpChar.test(string) ? string.replace($6711d60dd8e02df4$var$reRegExpChar, '\\$&') : string;
}
module.exports = $6711d60dd8e02df4$var$escapeRegExp;

});


parcelRegister("9xy4P", function(module, exports) {

$parcel$export(module.exports, "noChildren", () => $4971af2f49996b33$export$470bef71e654b804);
$parcel$export(module.exports, "assignParent", () => $4971af2f49996b33$export$a4685923af2913a);
const $4971af2f49996b33$export$470bef71e654b804 = ()=>[];
const $4971af2f49996b33$export$a4685923af2913a = (node)=>{
    node.getChildren().forEach((child)=>{
        child.parent = node;
    });
};

});


parcelRegister("7YEwf", function(module, exports) {

$parcel$export(module.exports, "compoundClause", () => $fe75dbe971d0ea05$export$ab714e56a32c25f2);
$parcel$export(module.exports, "compoundClauseInternal", () => $fe75dbe971d0ea05$export$cd65eed8c10b0911);


var $3u1v6 = parcelRequire("3u1v6");

var $9xy4P = parcelRequire("9xy4P");
function $fe75dbe971d0ea05$var$acceptCompoundClause(visitor) {
    return visitor.visitCompoundClause ? visitor.visitCompoundClause(this) : visitor.visitChildren(this);
}
function $fe75dbe971d0ea05$var$enterNode(listener) {
    listener.enterCompoundClause && listener.enterCompoundClause(this);
}
function $fe75dbe971d0ea05$var$exitNode(listener) {
    listener.exitCompoundClause && listener.exitCompoundClause(this);
}
function $fe75dbe971d0ea05$var$getChildren() {
    return [
        this.operator,
        ...this.clauses
    ];
}
const $fe75dbe971d0ea05$export$ab714e56a32c25f2 = (operator, clauses)=>{
    return $fe75dbe971d0ea05$export$cd65eed8c10b0911(operator, clauses);
};
const $fe75dbe971d0ea05$export$cd65eed8c10b0911 = (operator, clauses, position = null)=>{
    const node = {
        type: (0, $438a1d15528702a3$export$2d205682cc545947),
        clauseType: (0, $64e15c988a7f27d3$export$7a58b23488ea076b),
        operator: operator,
        clauses: clauses,
        position: position,
        accept: $fe75dbe971d0ea05$var$acceptCompoundClause,
        enterNode: $fe75dbe971d0ea05$var$enterNode,
        exitNode: $fe75dbe971d0ea05$var$exitNode,
        getChildren: $fe75dbe971d0ea05$var$getChildren,
        parent: null,
        appendClause: $3u1v6.appendClause,
        remove: $3u1v6.remove,
        removeClause: $3u1v6.removeClause,
        replace: $3u1v6.replace,
        replaceClause: $3u1v6.replaceClause
    };
    (0, $9xy4P.assignParent)(node);
    return node;
};

});
const $438a1d15528702a3$export$98dda21ec825792 = 'query';
const $438a1d15528702a3$export$2d205682cc545947 = 'clause';
const $438a1d15528702a3$export$d2f212d8ddbc8d1d = 'operand';
const $438a1d15528702a3$export$da0f73edded4a63d = 'order_by';

parcelRegister("3u1v6", function(module, exports) {

$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);


var $9xy4P = parcelRequire("9xy4P");
function appendClause(clause) {
    let clausesToAppend = [
        clause
    ];
    // If the clause to append is compound with a matching operator then we flatten it into the current clause
    if (clause.clauseType === (0, $64e15c988a7f27d3$export$7a58b23488ea076b) && clause.operator.value === this.operator.value) clausesToAppend = clause.clauses;
    this.clauses.push(...clausesToAppend);
    (0, $9xy4P.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    this.clauses = this.clauses.filter((val)=>val !== clause);
    if (this.clauses.length === 1) this.replace(this.clauses[0]);
    else if (this.clauses.length === 0) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    this.clauses = this.clauses.map((child)=>{
        return child === clause ? nextClause : child;
    });
    (0, $9xy4P.assignParent)(this);
}

});


parcelRegister("MKhaL", function(module, exports) {

$parcel$export(module.exports, "compoundOperator", () => $948d4797a4468e0f$export$84bb3ebbba491aee);
$parcel$export(module.exports, "compoundOperatorInternal", () => $948d4797a4468e0f$export$63c33bc3fe74fee6);

var $9xy4P = parcelRequire("9xy4P");
function $948d4797a4468e0f$var$acceptCompoundOperator(visitor) {
    return visitor.visitCompoundOperator ? visitor.visitCompoundOperator(this) : visitor.visitChildren(this);
}
function $948d4797a4468e0f$var$enterNode(listener) {
    listener.enterCompoundOperator && listener.enterCompoundOperator(this);
}
function $948d4797a4468e0f$var$exitNode(listener) {
    listener.exitCompoundOperator && listener.exitCompoundOperator(this);
}
const $948d4797a4468e0f$export$84bb3ebbba491aee = (value)=>$948d4797a4468e0f$export$63c33bc3fe74fee6(value, []);
const $948d4797a4468e0f$export$63c33bc3fe74fee6 = (value, operatorPositions)=>({
        value: value,
        positions: operatorPositions,
        position: null,
        accept: $948d4797a4468e0f$var$acceptCompoundOperator,
        enterNode: $948d4797a4468e0f$var$enterNode,
        exitNode: $948d4797a4468e0f$var$exitNode,
        getChildren: (0, $9xy4P.noChildren),
        parent: null
    });

});

parcelRegister("8WhE5", function(module, exports) {

$parcel$export(module.exports, "field", () => $de1bcdbe235f9902$export$e0f35d825088c098);
$parcel$export(module.exports, "fieldInternal", () => $de1bcdbe235f9902$export$2193f8c541622b6);

var $l8THn = parcelRequire("l8THn");

var $9xy4P = parcelRequire("9xy4P");
function $de1bcdbe235f9902$var$acceptField(visitor) {
    return visitor.visitField ? visitor.visitField(this) : visitor.visitChildren(this);
}
function $de1bcdbe235f9902$var$enterNode(listener) {
    listener.enterField && listener.enterField(this);
}
function $de1bcdbe235f9902$var$exitNode(listener) {
    listener.exitField && listener.exitField(this);
}
function $de1bcdbe235f9902$var$getChildren() {
    return this.properties ? [
        ...this.properties
    ] : [];
}
const $de1bcdbe235f9902$export$e0f35d825088c098 = (value, properties)=>{
    return $de1bcdbe235f9902$export$2193f8c541622b6(value, (0, $l8THn.sanitiseJqlString)(value), properties);
};
const $de1bcdbe235f9902$export$2193f8c541622b6 = (value, text, properties, position = null)=>{
    const node = {
        text: text,
        value: value,
        properties: properties,
        position: position,
        accept: $de1bcdbe235f9902$var$acceptField,
        enterNode: $de1bcdbe235f9902$var$enterNode,
        exitNode: $de1bcdbe235f9902$var$exitNode,
        getChildren: $de1bcdbe235f9902$var$getChildren,
        parent: null
    };
    (0, $9xy4P.assignParent)(node);
    return node;
};

});

parcelRegister("brZCc", function(module, exports) {

$parcel$export(module.exports, "functionOperand", () => $46b188972f678f7b$export$4f981b0e83488ce);
$parcel$export(module.exports, "functionOperandInternal", () => $46b188972f678f7b$export$c1f2ce91dc05872a);


var $9xy4P = parcelRequire("9xy4P");
function $46b188972f678f7b$var$acceptFunctionOperand(visitor) {
    return visitor.visitFunctionOperand ? visitor.visitFunctionOperand(this) : visitor.visitChildren(this);
}
function $46b188972f678f7b$var$enterNode(listener) {
    listener.enterFunctionOperand && listener.enterFunctionOperand(this);
}
function $46b188972f678f7b$var$exitNode(listener) {
    listener.exitFunctionOperand && listener.exitFunctionOperand(this);
}
function $46b188972f678f7b$var$getChildren() {
    return [
        this.function,
        ...this.arguments
    ];
}
const $46b188972f678f7b$export$4f981b0e83488ce = (functionString, args = [])=>$46b188972f678f7b$export$c1f2ce91dc05872a(functionString, args);
const $46b188972f678f7b$export$c1f2ce91dc05872a = (functionString, args, position = null)=>{
    const node = {
        type: (0, $438a1d15528702a3$export$d2f212d8ddbc8d1d),
        operandType: (0, $96a349542da5e08d$export$19c7c729db381f9d),
        function: functionString,
        arguments: args,
        position: position,
        accept: $46b188972f678f7b$var$acceptFunctionOperand,
        enterNode: $46b188972f678f7b$var$enterNode,
        exitNode: $46b188972f678f7b$var$exitNode,
        getChildren: $46b188972f678f7b$var$getChildren,
        parent: null
    };
    (0, $9xy4P.assignParent)(node);
    return node;
};

});
const $96a349542da5e08d$export$38accfc5a5d1c113 = 'value';
const $96a349542da5e08d$export$f6049126fd97001f = 'keyword';
const $96a349542da5e08d$export$19c7c729db381f9d = 'function';
const $96a349542da5e08d$export$fabec4aebba3f4df = 'list';
const $96a349542da5e08d$export$1c46dca02aac24dd = 'empty';


parcelRegister("luQo9", function(module, exports) {

$parcel$export(module.exports, "functionString", () => $edfcdceefc370b73$export$4e1bb9a7ff8d0ef9);
$parcel$export(module.exports, "functionStringInternal", () => $edfcdceefc370b73$export$7aa9944588b7a69f);

var $l8THn = parcelRequire("l8THn");

var $9xy4P = parcelRequire("9xy4P");
function $edfcdceefc370b73$var$acceptFunctionString(visitor) {
    return visitor.visitFunction ? visitor.visitFunction(this) : visitor.visitChildren(this);
}
function $edfcdceefc370b73$var$enterNode(listener) {
    listener.enterFunction && listener.enterFunction(this);
}
function $edfcdceefc370b73$var$exitNode(listener) {
    listener.exitFunction && listener.exitFunction(this);
}
const $edfcdceefc370b73$export$4e1bb9a7ff8d0ef9 = (value)=>$edfcdceefc370b73$export$7aa9944588b7a69f(value, (0, $l8THn.sanitiseJqlString)(value));
const $edfcdceefc370b73$export$7aa9944588b7a69f = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $edfcdceefc370b73$var$acceptFunctionString,
        enterNode: $edfcdceefc370b73$var$enterNode,
        exitNode: $edfcdceefc370b73$var$exitNode,
        getChildren: (0, $9xy4P.noChildren),
        parent: null
    });

});

parcelRegister("iQuQ1", function(module, exports) {

$parcel$export(module.exports, "jast", () => $e0aef80aebc1f78b$export$b9e70a00f479ff43);
const $e0aef80aebc1f78b$export$b9e70a00f479ff43 = (query, represents = '', errors = [])=>({
        query: query,
        represents: represents,
        errors: errors
    });

});

parcelRegister("2JCCY", function(module, exports) {

$parcel$export(module.exports, "keywordOperand", () => $be686bb15d0cb8cf$export$2edd4971ed69f2ce);
$parcel$export(module.exports, "keywordOperandInternal", () => $be686bb15d0cb8cf$export$7cc55480b054047b);


var $9xy4P = parcelRequire("9xy4P");
function $be686bb15d0cb8cf$var$acceptKeywordOperand(visitor) {
    return visitor.visitKeywordOperand ? visitor.visitKeywordOperand(this) : visitor.visitChildren(this);
}
function $be686bb15d0cb8cf$var$enterNode(listener) {
    listener.enterKeywordOperand && listener.enterKeywordOperand(this);
}
function $be686bb15d0cb8cf$var$exitNode(listener) {
    listener.exitKeywordOperand && listener.exitKeywordOperand(this);
}
const $be686bb15d0cb8cf$export$2edd4971ed69f2ce = ()=>$be686bb15d0cb8cf$export$7cc55480b054047b((0, $96a349542da5e08d$export$1c46dca02aac24dd));
const $be686bb15d0cb8cf$export$7cc55480b054047b = (value, position = null)=>({
        type: (0, $438a1d15528702a3$export$d2f212d8ddbc8d1d),
        operandType: (0, $96a349542da5e08d$export$f6049126fd97001f),
        value: value,
        position: position,
        accept: $be686bb15d0cb8cf$var$acceptKeywordOperand,
        enterNode: $be686bb15d0cb8cf$var$enterNode,
        exitNode: $be686bb15d0cb8cf$var$exitNode,
        getChildren: (0, $9xy4P.noChildren),
        parent: null
    });

});

parcelRegister("5zajP", function(module, exports) {

$parcel$export(module.exports, "listOperand", () => $0f2adad16b610eff$export$769866c3e9d41d50);
$parcel$export(module.exports, "listOperandInternal", () => $0f2adad16b610eff$export$663c7831528c984b);


var $8vkxP = parcelRequire("8vkxP");

var $9xy4P = parcelRequire("9xy4P");
function $0f2adad16b610eff$var$acceptListOperand(visitor) {
    return visitor.visitListOperand ? visitor.visitListOperand(this) : visitor.visitChildren(this);
}
function $0f2adad16b610eff$var$enterNode(listener) {
    listener.enterListOperand && listener.enterListOperand(this);
}
function $0f2adad16b610eff$var$exitNode(listener) {
    listener.exitListOperand && listener.exitListOperand(this);
}
function $0f2adad16b610eff$var$getChildren() {
    return [
        ...this.values
    ];
}
const $0f2adad16b610eff$export$769866c3e9d41d50 = (values)=>$0f2adad16b610eff$export$663c7831528c984b(values);
const $0f2adad16b610eff$export$663c7831528c984b = (values, position = null)=>{
    const node = {
        type: (0, $438a1d15528702a3$export$d2f212d8ddbc8d1d),
        operandType: (0, $96a349542da5e08d$export$fabec4aebba3f4df),
        values: values,
        position: position,
        accept: $0f2adad16b610eff$var$acceptListOperand,
        enterNode: $0f2adad16b610eff$var$enterNode,
        exitNode: $0f2adad16b610eff$var$exitNode,
        getChildren: $0f2adad16b610eff$var$getChildren,
        parent: null,
        appendOperand: $8vkxP.appendOperand
    };
    (0, $9xy4P.assignParent)(node);
    return node;
};

});
parcelRegister("8vkxP", function(module, exports) {

$parcel$export(module.exports, "appendOperand", () => $69c91aff87600ef2$export$d94c54f1aee177c4);


var $9xy4P = parcelRequire("9xy4P");
function $69c91aff87600ef2$export$d94c54f1aee177c4(operand) {
    this.values.push(...operand.operandType === (0, $96a349542da5e08d$export$fabec4aebba3f4df) ? operand.values : [
        operand
    ]);
    (0, $9xy4P.assignParent)(this);
}

});


parcelRegister("5sUyi", function(module, exports) {

$parcel$export(module.exports, "notClause", () => $d17c8a5d4df58b60$export$b4734a9fedb4d44e);
$parcel$export(module.exports, "notClauseInternal", () => $d17c8a5d4df58b60$export$b25621824fea4548);


var $2351O = parcelRequire("2351O");

var $9xy4P = parcelRequire("9xy4P");

var $3l0pH = parcelRequire("3l0pH");
function $d17c8a5d4df58b60$var$acceptNotClause(visitor) {
    return visitor.visitNotClause ? visitor.visitNotClause(this) : visitor.visitChildren(this);
}
function $d17c8a5d4df58b60$var$enterNode(listener) {
    listener.enterNotClause && listener.enterNotClause(this);
}
function $d17c8a5d4df58b60$var$exitNode(listener) {
    listener.exitNotClause && listener.exitNotClause(this);
}
function $d17c8a5d4df58b60$var$getChildren() {
    return [
        this.operator,
        this.clause
    ];
}
const $d17c8a5d4df58b60$export$b4734a9fedb4d44e = (clause)=>{
    return $d17c8a5d4df58b60$export$b25621824fea4548(clause, (0, $3l0pH.notClauseOperator)());
};
const $d17c8a5d4df58b60$export$b25621824fea4548 = (clause, operator, position = null)=>{
    const node = {
        type: (0, $438a1d15528702a3$export$2d205682cc545947),
        clauseType: (0, $64e15c988a7f27d3$export$e356b89f8c8d2fcb),
        clause: clause,
        operator: operator,
        position: position,
        accept: $d17c8a5d4df58b60$var$acceptNotClause,
        enterNode: $d17c8a5d4df58b60$var$enterNode,
        exitNode: $d17c8a5d4df58b60$var$exitNode,
        getChildren: $d17c8a5d4df58b60$var$getChildren,
        parent: null,
        remove: $2351O.remove,
        removeClause: $2351O.removeClause,
        replace: $2351O.replace,
        replaceClause: $2351O.replaceClause
    };
    (0, $9xy4P.assignParent)(node);
    return node;
};

});
parcelRegister("2351O", function(module, exports) {

$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);

var $9xy4P = parcelRequire("9xy4P");
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    if (this.clause === clause) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    if (this.clause === clause) {
        this.clause = nextClause;
        (0, $9xy4P.assignParent)(this);
    }
}

});

parcelRegister("3l0pH", function(module, exports) {

$parcel$export(module.exports, "notClauseOperator", () => $5be8e58e229fd920$export$d2cd8239f99c13d3);
$parcel$export(module.exports, "notClauseOperatorInternal", () => $5be8e58e229fd920$export$1b15a32bb57b9020);

var $3jFAr = parcelRequire("3jFAr");

var $9xy4P = parcelRequire("9xy4P");
function $5be8e58e229fd920$var$acceptNotClauseOperator(visitor) {
    return visitor.visitNotClauseOperator ? visitor.visitNotClauseOperator(this) : visitor.visitChildren(this);
}
function $5be8e58e229fd920$var$enterNode(listener) {
    listener.enterNotClauseOperator && listener.enterNotClauseOperator(this);
}
function $5be8e58e229fd920$var$exitNode(listener) {
    listener.exitNotClauseOperator && listener.exitNotClauseOperator(this);
}
const $5be8e58e229fd920$export$d2cd8239f99c13d3 = ()=>$5be8e58e229fd920$export$1b15a32bb57b9020();
const $5be8e58e229fd920$export$1b15a32bb57b9020 = (position = null)=>({
        value: (0, $3jFAr.CLAUSE_OPERATOR_NOT),
        position: position,
        accept: $5be8e58e229fd920$var$acceptNotClauseOperator,
        enterNode: $5be8e58e229fd920$var$enterNode,
        exitNode: $5be8e58e229fd920$var$exitNode,
        getChildren: (0, $9xy4P.noChildren),
        parent: null
    });

});
parcelRegister("3jFAr", function(module, exports) {

$parcel$export(module.exports, "CLAUSE_OPERATOR_NOT", () => $6bd2d6355d112275$export$c6c71ceedb15cda9);
$parcel$export(module.exports, "OPERATOR_EQUALS", () => $6bd2d6355d112275$export$466517a888d00195);
$parcel$export(module.exports, "OPERATOR_NOT_EQUALS", () => $6bd2d6355d112275$export$6d0d8810623974a5);
$parcel$export(module.exports, "OPERATOR_GT", () => $6bd2d6355d112275$export$bcbb090ab3c498b3);
$parcel$export(module.exports, "OPERATOR_LT", () => $6bd2d6355d112275$export$4bf1a4aa659c6ea4);
$parcel$export(module.exports, "OPERATOR_GT_EQUALS", () => $6bd2d6355d112275$export$83ce674214a54b2a);
$parcel$export(module.exports, "OPERATOR_LT_EQUALS", () => $6bd2d6355d112275$export$9629fd1727ef62ee);
$parcel$export(module.exports, "OPERATOR_IN", () => $6bd2d6355d112275$export$c4e3fb55e320e979);
$parcel$export(module.exports, "OPERATOR_NOT_IN", () => $6bd2d6355d112275$export$f9857532eaa24ddc);
$parcel$export(module.exports, "OPERATOR_LIKE", () => $6bd2d6355d112275$export$221595834b8766ab);
$parcel$export(module.exports, "OPERATOR_NOT_LIKE", () => $6bd2d6355d112275$export$fcefabf94a9bffbf);
$parcel$export(module.exports, "OPERATOR_IS", () => $6bd2d6355d112275$export$4feeb3f4ff56bcef);
$parcel$export(module.exports, "OPERATOR_IS_NOT", () => $6bd2d6355d112275$export$d08d969a0da27188);
$parcel$export(module.exports, "OPERATOR_WAS", () => $6bd2d6355d112275$export$8f907e179985256d);
$parcel$export(module.exports, "OPERATOR_WAS_IN", () => $6bd2d6355d112275$export$cc7b9d0b3ee23193);
$parcel$export(module.exports, "OPERATOR_WAS_NOT_IN", () => $6bd2d6355d112275$export$585d3c004af078bb);
$parcel$export(module.exports, "OPERATOR_WAS_NOT", () => $6bd2d6355d112275$export$123eaa9ccc2d9445);
$parcel$export(module.exports, "OPERATOR_CHANGED", () => $6bd2d6355d112275$export$15f5b446ba8c941e);
$parcel$export(module.exports, "EQUALS_OPERATORS", () => $6bd2d6355d112275$export$643c6101f3fc8547);
$parcel$export(module.exports, "LIKE_OPERATORS", () => $6bd2d6355d112275$export$329664c9cf18cca6);
$parcel$export(module.exports, "COMPARISON_OPERATORS", () => $6bd2d6355d112275$export$1b167a3705885a8b);
$parcel$export(module.exports, "IN_OPERATORS", () => $6bd2d6355d112275$export$f25cf16c2270312f);
$parcel$export(module.exports, "IS_OPERATORS", () => $6bd2d6355d112275$export$eb58cfffe4a6b805);
$parcel$export(module.exports, "WAS_OPERATORS", () => $6bd2d6355d112275$export$c22a981f581de218);
$parcel$export(module.exports, "WAS_IN_OPERATORS", () => $6bd2d6355d112275$export$6d08c4699bb75284);
$parcel$export(module.exports, "CHANGED_OPERATORS", () => $6bd2d6355d112275$export$b7dc214eef214c1c);
$parcel$export(module.exports, "OPERATORS", () => $6bd2d6355d112275$export$184799fc79ccac89);
$parcel$export(module.exports, "LIST_OPERATORS", () => $6bd2d6355d112275$export$77c793736847e030);
const $6bd2d6355d112275$export$c6c71ceedb15cda9 = 'not';
const $6bd2d6355d112275$export$466517a888d00195 = '=';
const $6bd2d6355d112275$export$6d0d8810623974a5 = '!=';
const $6bd2d6355d112275$export$bcbb090ab3c498b3 = '>';
const $6bd2d6355d112275$export$4bf1a4aa659c6ea4 = '<';
const $6bd2d6355d112275$export$83ce674214a54b2a = '>=';
const $6bd2d6355d112275$export$9629fd1727ef62ee = '<=';
const $6bd2d6355d112275$export$c4e3fb55e320e979 = 'in';
const $6bd2d6355d112275$export$f9857532eaa24ddc = 'not in';
const $6bd2d6355d112275$export$221595834b8766ab = '~';
const $6bd2d6355d112275$export$fcefabf94a9bffbf = '!~';
const $6bd2d6355d112275$export$4feeb3f4ff56bcef = 'is';
const $6bd2d6355d112275$export$d08d969a0da27188 = 'is not';
const $6bd2d6355d112275$export$8f907e179985256d = 'was';
const $6bd2d6355d112275$export$cc7b9d0b3ee23193 = 'was in';
const $6bd2d6355d112275$export$585d3c004af078bb = 'was not in';
const $6bd2d6355d112275$export$123eaa9ccc2d9445 = 'was not';
const $6bd2d6355d112275$export$15f5b446ba8c941e = 'changed';
const $6bd2d6355d112275$export$643c6101f3fc8547 = [
    $6bd2d6355d112275$export$466517a888d00195,
    $6bd2d6355d112275$export$6d0d8810623974a5
];
const $6bd2d6355d112275$export$329664c9cf18cca6 = [
    $6bd2d6355d112275$export$221595834b8766ab,
    $6bd2d6355d112275$export$fcefabf94a9bffbf
];
const $6bd2d6355d112275$export$1b167a3705885a8b = [
    $6bd2d6355d112275$export$4bf1a4aa659c6ea4,
    $6bd2d6355d112275$export$bcbb090ab3c498b3,
    $6bd2d6355d112275$export$9629fd1727ef62ee,
    $6bd2d6355d112275$export$83ce674214a54b2a
];
const $6bd2d6355d112275$export$f25cf16c2270312f = [
    $6bd2d6355d112275$export$c4e3fb55e320e979,
    $6bd2d6355d112275$export$f9857532eaa24ddc
];
const $6bd2d6355d112275$export$eb58cfffe4a6b805 = [
    $6bd2d6355d112275$export$4feeb3f4ff56bcef,
    $6bd2d6355d112275$export$d08d969a0da27188
];
const $6bd2d6355d112275$export$c22a981f581de218 = [
    $6bd2d6355d112275$export$8f907e179985256d,
    $6bd2d6355d112275$export$123eaa9ccc2d9445
];
const $6bd2d6355d112275$export$6d08c4699bb75284 = [
    $6bd2d6355d112275$export$cc7b9d0b3ee23193,
    $6bd2d6355d112275$export$585d3c004af078bb
];
const $6bd2d6355d112275$export$b7dc214eef214c1c = [
    $6bd2d6355d112275$export$15f5b446ba8c941e
];
const $6bd2d6355d112275$export$184799fc79ccac89 = [
    ...$6bd2d6355d112275$export$643c6101f3fc8547,
    ...$6bd2d6355d112275$export$329664c9cf18cca6,
    ...$6bd2d6355d112275$export$1b167a3705885a8b,
    ...$6bd2d6355d112275$export$f25cf16c2270312f,
    ...$6bd2d6355d112275$export$eb58cfffe4a6b805,
    ...$6bd2d6355d112275$export$c22a981f581de218,
    ...$6bd2d6355d112275$export$6d08c4699bb75284,
    ...$6bd2d6355d112275$export$b7dc214eef214c1c
];
const $6bd2d6355d112275$export$77c793736847e030 = [
    $6bd2d6355d112275$export$c4e3fb55e320e979,
    $6bd2d6355d112275$export$f9857532eaa24ddc,
    $6bd2d6355d112275$export$cc7b9d0b3ee23193,
    $6bd2d6355d112275$export$585d3c004af078bb
];

});



parcelRegister("jlTcB", function(module, exports) {

$parcel$export(module.exports, "operator", () => $8c9f1fc409d7deac$export$dbd72860f701d4f3);
$parcel$export(module.exports, "operatorInternal", () => $8c9f1fc409d7deac$export$649025bc60ab9c3b);

var $9xy4P = parcelRequire("9xy4P");
function $8c9f1fc409d7deac$var$acceptOperator(visitor) {
    return visitor.visitOperator ? visitor.visitOperator(this) : visitor.visitChildren(this);
}
function $8c9f1fc409d7deac$var$enterNode(listener) {
    listener.enterOperator && listener.enterOperator(this);
}
function $8c9f1fc409d7deac$var$exitNode(listener) {
    listener.exitOperator && listener.exitOperator(this);
}
const $8c9f1fc409d7deac$export$dbd72860f701d4f3 = (value)=>$8c9f1fc409d7deac$export$649025bc60ab9c3b(value, value);
const $8c9f1fc409d7deac$export$649025bc60ab9c3b = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $8c9f1fc409d7deac$var$acceptOperator,
        enterNode: $8c9f1fc409d7deac$var$enterNode,
        exitNode: $8c9f1fc409d7deac$var$exitNode,
        getChildren: (0, $9xy4P.noChildren),
        parent: null
    });

});

parcelRegister("btuOD", function(module, exports) {

$parcel$export(module.exports, "orderBy", () => $f5fc6a592aabf5fb$export$f18af21d6f4dafd8);
$parcel$export(module.exports, "orderByInternal", () => $f5fc6a592aabf5fb$export$e4eb1fa6bc8465c1);


var $i0sTI = parcelRequire("i0sTI");

var $9xy4P = parcelRequire("9xy4P");

var $dqDkv = parcelRequire("dqDkv");
function $f5fc6a592aabf5fb$var$acceptOrderBy(visitor) {
    return visitor.visitOrderBy ? visitor.visitOrderBy(this) : visitor.visitChildren(this);
}
function $f5fc6a592aabf5fb$var$enterNode(listener) {
    listener.enterOrderBy && listener.enterOrderBy(this);
}
function $f5fc6a592aabf5fb$var$exitNode(listener) {
    listener.exitOrderBy && listener.exitOrderBy(this);
}
function $f5fc6a592aabf5fb$var$getChildren() {
    return [
        this.operator,
        ...this.fields
    ];
}
const $f5fc6a592aabf5fb$export$f18af21d6f4dafd8 = (fields)=>{
    return $f5fc6a592aabf5fb$export$e4eb1fa6bc8465c1(fields, (0, $dqDkv.orderByOperator)());
};
const $f5fc6a592aabf5fb$export$e4eb1fa6bc8465c1 = (fields, operator, position = null)=>{
    const node = {
        type: (0, $438a1d15528702a3$export$da0f73edded4a63d),
        operator: operator,
        fields: fields,
        position: position,
        accept: $f5fc6a592aabf5fb$var$acceptOrderBy,
        enterNode: $f5fc6a592aabf5fb$var$enterNode,
        exitNode: $f5fc6a592aabf5fb$var$exitNode,
        getChildren: $f5fc6a592aabf5fb$var$getChildren,
        parent: null,
        prependOrderField: $i0sTI.prependOrderField,
        setOrderDirection: $i0sTI.setOrderDirection,
        replace: $i0sTI.replace,
        replaceOrderField: $i0sTI.replaceOrderField,
        remove: $i0sTI.remove,
        removeOrderField: $i0sTI.removeOrderField
    };
    (0, $9xy4P.assignParent)(node);
    return node;
};

});
parcelRegister("i0sTI", function(module, exports) {

$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceOrderField", () => replaceOrderField);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeOrderField", () => removeOrderField);

var $9xy4P = parcelRequire("9xy4P");
function prependOrderField(orderField) {
    this.fields.unshift(orderField);
    (0, $9xy4P.assignParent)(this);
}
function setOrderDirection(orderDirection) {
    if (this.fields.length > 0) this.fields[0].setOrderDirection(orderDirection);
}
function replace(nextOrderBy) {
    if (this.parent) this.parent.replaceOrderBy(nextOrderBy);
}
function replaceOrderField(orderByField, nextOrderByField) {
    this.fields = this.fields.map((child)=>{
        return child === orderByField ? nextOrderByField : child;
    });
    (0, $9xy4P.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeOrderBy();
}
function removeOrderField(orderByField) {
    this.fields = this.fields.filter((field)=>field !== orderByField);
    if (this.fields.length === 0) this.remove();
}

});

parcelRegister("dqDkv", function(module, exports) {

$parcel$export(module.exports, "orderByOperator", () => $e3b3adbbe1712c72$export$c7307b67924c61ea);
$parcel$export(module.exports, "orderByOperatorInternal", () => $e3b3adbbe1712c72$export$739e30af23a08da0);


var $9xy4P = parcelRequire("9xy4P");
function $e3b3adbbe1712c72$var$acceptOrderByOperator(visitor) {
    return visitor.visitOrderByOperator ? visitor.visitOrderByOperator(this) : visitor.visitChildren(this);
}
function $e3b3adbbe1712c72$var$enterNode(listener) {
    listener.enterOrderByOperator && listener.enterOrderByOperator(this);
}
function $e3b3adbbe1712c72$var$exitNode(listener) {
    listener.exitOrderByOperator && listener.exitOrderByOperator(this);
}
const $e3b3adbbe1712c72$export$c7307b67924c61ea = ()=>$e3b3adbbe1712c72$export$739e30af23a08da0();
const $e3b3adbbe1712c72$export$739e30af23a08da0 = (position = null)=>({
        value: (0, $6aad11c3985b8e7f$export$ca51f5fd60a74517),
        position: position,
        accept: $e3b3adbbe1712c72$var$acceptOrderByOperator,
        enterNode: $e3b3adbbe1712c72$var$enterNode,
        exitNode: $e3b3adbbe1712c72$var$exitNode,
        getChildren: (0, $9xy4P.noChildren),
        parent: null
    });

});
const $6aad11c3985b8e7f$export$ca51f5fd60a74517 = 'ORDER BY';
const $6aad11c3985b8e7f$export$6d60017b9e092e73 = 'ASC';
const $6aad11c3985b8e7f$export$2ea27ea5f2121899 = 'DESC';



parcelRegister("5r1xx", function(module, exports) {

$parcel$export(module.exports, "orderByDirection", () => $e3d5cb32cf64ea59$export$864d934efed3ccaa);
$parcel$export(module.exports, "orderByDirectionInternal", () => $e3d5cb32cf64ea59$export$8c65cac1a7852d1f);

var $9xy4P = parcelRequire("9xy4P");
function $e3d5cb32cf64ea59$var$acceptOrderByDirection(visitor) {
    return visitor.visitOrderByDirection ? visitor.visitOrderByDirection(this) : visitor.visitChildren(this);
}
function $e3d5cb32cf64ea59$var$enterNode(listener) {
    listener.enterOrderByDirection && listener.enterOrderByDirection(this);
}
function $e3d5cb32cf64ea59$var$exitNode(listener) {
    listener.exitOrderByDirection && listener.exitOrderByDirection(this);
}
const $e3d5cb32cf64ea59$export$864d934efed3ccaa = (value)=>$e3d5cb32cf64ea59$export$8c65cac1a7852d1f(value);
const $e3d5cb32cf64ea59$export$8c65cac1a7852d1f = (value, position = null)=>({
        value: value,
        position: position,
        accept: $e3d5cb32cf64ea59$var$acceptOrderByDirection,
        enterNode: $e3d5cb32cf64ea59$var$enterNode,
        exitNode: $e3d5cb32cf64ea59$var$exitNode,
        getChildren: (0, $9xy4P.noChildren),
        parent: null
    });

});

parcelRegister("lpnwE", function(module, exports) {

$parcel$export(module.exports, "orderByField", () => $f9b6acafae5b6f88$export$942df63e5e3d3899);
$parcel$export(module.exports, "orderByFieldInternal", () => $f9b6acafae5b6f88$export$661a7786e3d15926);

var $jXG5w = parcelRequire("jXG5w");

var $9xy4P = parcelRequire("9xy4P");
function $f9b6acafae5b6f88$var$acceptOrderByField(visitor) {
    return visitor.visitOrderByField ? visitor.visitOrderByField(this) : visitor.visitChildren(this);
}
function $f9b6acafae5b6f88$var$enterNode(listener) {
    listener.enterOrderByField && listener.enterOrderByField(this);
}
function $f9b6acafae5b6f88$var$exitNode(listener) {
    listener.exitOrderByField && listener.exitOrderByField(this);
}
function $f9b6acafae5b6f88$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.direction) children.push(this.direction);
    return children;
}
const $f9b6acafae5b6f88$export$942df63e5e3d3899 = (field, direction)=>$f9b6acafae5b6f88$export$661a7786e3d15926(field, direction);
const $f9b6acafae5b6f88$export$661a7786e3d15926 = (field, direction, position = null)=>{
    const node = {
        field: field,
        direction: direction,
        position: position,
        accept: $f9b6acafae5b6f88$var$acceptOrderByField,
        enterNode: $f9b6acafae5b6f88$var$enterNode,
        exitNode: $f9b6acafae5b6f88$var$exitNode,
        getChildren: $f9b6acafae5b6f88$var$getChildren,
        parent: null,
        setOrderDirection: $jXG5w.setOrderDirection,
        replace: $jXG5w.replace,
        remove: $jXG5w.remove
    };
    (0, $9xy4P.assignParent)(node);
    return node;
};

});
parcelRegister("jXG5w", function(module, exports) {

$parcel$export(module.exports, "setOrderDirection", () => $c7353a16e99c46eb$export$b596730931a09703);
$parcel$export(module.exports, "replace", () => $c7353a16e99c46eb$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "remove", () => $c7353a16e99c46eb$export$cd7f480d6b8286c3);

var $9xy4P = parcelRequire("9xy4P");
function $c7353a16e99c46eb$export$b596730931a09703(orderDirection) {
    this.direction = orderDirection;
    (0, $9xy4P.assignParent)(this);
}
function $c7353a16e99c46eb$export$77ad94ebf1c2b9ed(orderByField) {
    if (this.parent) this.parent.replaceOrderField(this, orderByField);
}
function $c7353a16e99c46eb$export$cd7f480d6b8286c3() {
    if (this.parent) this.parent.removeOrderField(this);
}

});


parcelRegister("l4ARm", function(module, exports) {

$parcel$export(module.exports, "predicate", () => $1a708388f2314736$export$5fc51e445ce24faf);
$parcel$export(module.exports, "predicateInternal", () => $1a708388f2314736$export$a767a27ad05a38a2);

var $9xy4P = parcelRequire("9xy4P");
function $1a708388f2314736$var$acceptPredicate(visitor) {
    return visitor.visitPredicate ? visitor.visitPredicate(this) : visitor.visitChildren(this);
}
function $1a708388f2314736$var$enterNode(listener) {
    listener.enterPredicate && listener.enterPredicate(this);
}
function $1a708388f2314736$var$exitNode(listener) {
    listener.exitPredicate && listener.exitPredicate(this);
}
function $1a708388f2314736$var$getChildren() {
    const children = [
        this.operator
    ];
    if (this.operand) children.push(this.operand);
    return children;
}
const $1a708388f2314736$export$5fc51e445ce24faf = (operator, operand)=>$1a708388f2314736$export$a767a27ad05a38a2(operator, operand);
const $1a708388f2314736$export$a767a27ad05a38a2 = (operator, operand, position = null)=>{
    const node = {
        operator: operator,
        operand: operand,
        position: position,
        accept: $1a708388f2314736$var$acceptPredicate,
        enterNode: $1a708388f2314736$var$enterNode,
        exitNode: $1a708388f2314736$var$exitNode,
        getChildren: $1a708388f2314736$var$getChildren,
        parent: null
    };
    (0, $9xy4P.assignParent)(node);
    return node;
};

});

parcelRegister("bl6uf", function(module, exports) {

$parcel$export(module.exports, "predicateOperator", () => $c0ef43b5a7961e38$export$5419b7f16910ea62);
$parcel$export(module.exports, "predicateOperatorInternal", () => $c0ef43b5a7961e38$export$c69d893689716768);

var $9xy4P = parcelRequire("9xy4P");
function $c0ef43b5a7961e38$var$acceptPredicateOperator(visitor) {
    return visitor.visitPredicateOperator ? visitor.visitPredicateOperator(this) : visitor.visitChildren(this);
}
function $c0ef43b5a7961e38$var$enterNode(listener) {
    listener.enterPredicateOperator && listener.enterPredicateOperator(this);
}
function $c0ef43b5a7961e38$var$exitNode(listener) {
    listener.exitPredicateOperator && listener.exitPredicateOperator(this);
}
const $c0ef43b5a7961e38$export$5419b7f16910ea62 = (value)=>$c0ef43b5a7961e38$export$c69d893689716768(value, value);
const $c0ef43b5a7961e38$export$c69d893689716768 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $c0ef43b5a7961e38$var$acceptPredicateOperator,
        enterNode: $c0ef43b5a7961e38$var$enterNode,
        exitNode: $c0ef43b5a7961e38$var$exitNode,
        getChildren: (0, $9xy4P.noChildren),
        parent: null
    });

});

parcelRegister("gF3Zx", function(module, exports) {

$parcel$export(module.exports, "property", () => $fd04cf83571c3fa9$export$d541bacb2bda4494);
$parcel$export(module.exports, "propertyInternal", () => $fd04cf83571c3fa9$export$1cbd90994fef1fad);

var $9xy4P = parcelRequire("9xy4P");
function $fd04cf83571c3fa9$var$acceptProperty(visitor) {
    return visitor.visitProperty ? visitor.visitProperty(this) : visitor.visitChildren(this);
}
function $fd04cf83571c3fa9$var$enterNode(listener) {
    listener.enterProperty && listener.enterProperty(this);
}
function $fd04cf83571c3fa9$var$exitNode(listener) {
    listener.exitProperty && listener.exitProperty(this);
}
function $fd04cf83571c3fa9$var$getChildren() {
    const children = [];
    if (this.key) children.push(this.key);
    if (this.path) return children.concat(this.path);
    return children;
}
const $fd04cf83571c3fa9$export$d541bacb2bda4494 = (key, path = [])=>$fd04cf83571c3fa9$export$1cbd90994fef1fad(key, path);
const $fd04cf83571c3fa9$export$1cbd90994fef1fad = (key, path, position = null)=>{
    const node = {
        key: key,
        path: path,
        position: position,
        accept: $fd04cf83571c3fa9$var$acceptProperty,
        enterNode: $fd04cf83571c3fa9$var$enterNode,
        exitNode: $fd04cf83571c3fa9$var$exitNode,
        getChildren: $fd04cf83571c3fa9$var$getChildren,
        parent: null
    };
    (0, $9xy4P.assignParent)(node);
    return node;
};

});

parcelRegister("dglO1", function(module, exports) {

$parcel$export(module.exports, "query", () => $e080076087cc88e7$export$2fa187e846a241c4);
$parcel$export(module.exports, "queryInternal", () => $e080076087cc88e7$export$bc2d6e2e1fd9014);


var $fLjE1 = parcelRequire("fLjE1");

var $9xy4P = parcelRequire("9xy4P");
/**
 * AstNode accept functions. We define them outside of the creator function so the same function reference is returned
 * when a creator is invoked multiple times (which is helpful when testing for equality of AST objects).
 */ function $e080076087cc88e7$var$acceptQuery(visitor) {
    return visitor.visitQuery ? visitor.visitQuery(this) : visitor.visitChildren(this);
}
function $e080076087cc88e7$var$enterNode(listener) {
    listener.enterQuery && listener.enterQuery(this);
}
function $e080076087cc88e7$var$exitNode(listener) {
    listener.exitQuery && listener.exitQuery(this);
}
function $e080076087cc88e7$var$getChildren() {
    const children = [];
    if (this.where) children.push(this.where);
    if (this.orderBy) children.push(this.orderBy);
    return children;
}
const $e080076087cc88e7$export$2fa187e846a241c4 = (where, orderBy)=>$e080076087cc88e7$export$bc2d6e2e1fd9014(where, orderBy);
const $e080076087cc88e7$export$bc2d6e2e1fd9014 = (where, orderBy, position = null)=>{
    const node = {
        type: (0, $438a1d15528702a3$export$98dda21ec825792),
        where: where,
        orderBy: orderBy,
        position: position,
        accept: $e080076087cc88e7$var$acceptQuery,
        enterNode: $e080076087cc88e7$var$enterNode,
        exitNode: $e080076087cc88e7$var$exitNode,
        getChildren: $e080076087cc88e7$var$getChildren,
        parent: null,
        appendClause: $fLjE1.appendClause,
        prependOrderField: $fLjE1.prependOrderField,
        setOrderDirection: $fLjE1.setOrderDirection,
        removeClause: $fLjE1.removeClause,
        replaceClause: $fLjE1.replaceClause,
        replaceOrderBy: $fLjE1.replaceOrderBy,
        removeOrderBy: $fLjE1.removeOrderBy
    };
    (0, $9xy4P.assignParent)(node);
    return node;
};

});
parcelRegister("fLjE1", function(module, exports) {

$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replaceOrderBy", () => replaceOrderBy);
$parcel$export(module.exports, "replaceClause", () => replaceClause);
$parcel$export(module.exports, "removeOrderBy", () => removeOrderBy);

var $gjjVy = parcelRequire("gjjVy");

var $9xy4P = parcelRequire("9xy4P");
function appendClause(clause, compoundOperatorValue) {
    if (!this.where) this.where = clause;
    else {
        const nextCompoundOperator = (0, $gjjVy.default).compoundOperator(compoundOperatorValue);
        const nextClause = (0, $gjjVy.default).compoundClause(nextCompoundOperator, []);
        // Append previous and new clause which will flatten compound clauses with matching operators.
        nextClause.appendClause(this.where);
        nextClause.appendClause(clause);
        this.where = nextClause;
    }
    (0, $9xy4P.assignParent)(this);
}
function prependOrderField(orderField) {
    if (!this.orderBy) {
        this.orderBy = (0, $gjjVy.default).orderBy([
            orderField
        ]);
        (0, $9xy4P.assignParent)(this);
    } else this.orderBy.prependOrderField(orderField);
}
function setOrderDirection(orderDirection) {
    if (this.orderBy) this.orderBy.setOrderDirection(orderDirection);
}
function removeClause(clause) {
    if (this.where === clause) this.where = undefined;
}
function replaceOrderBy(orderBy) {
    if (orderBy && orderBy.fields.length === 0) this.removeOrderBy();
    else {
        this.orderBy = orderBy;
        (0, $9xy4P.assignParent)(this);
    }
}
function replaceClause(clause, nextClause) {
    if (this.where === clause) {
        this.where = nextClause;
        (0, $9xy4P.assignParent)(this);
    }
}
function removeOrderBy() {
    this.orderBy = undefined;
}

});


parcelRegister("6YF5f", function(module, exports) {

$parcel$export(module.exports, "terminalClause", () => $ec55d1fce1db1ad3$export$2627cbe08dd86b00);
$parcel$export(module.exports, "terminalClauseInternal", () => $ec55d1fce1db1ad3$export$cc08e43598d091fc);


var $dmom1 = parcelRequire("dmom1");

var $9xy4P = parcelRequire("9xy4P");
function $ec55d1fce1db1ad3$var$acceptTerminalClause(visitor) {
    return visitor.visitTerminalClause ? visitor.visitTerminalClause(this) : visitor.visitChildren(this);
}
function $ec55d1fce1db1ad3$var$enterNode(listener) {
    listener.enterTerminalClause && listener.enterTerminalClause(this);
}
function $ec55d1fce1db1ad3$var$exitNode(listener) {
    listener.exitTerminalClause && listener.exitTerminalClause(this);
}
function $ec55d1fce1db1ad3$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.operator) children.push(this.operator);
    if (this.operand) children.push(this.operand);
    return children.concat(this.predicates);
}
const $ec55d1fce1db1ad3$export$2627cbe08dd86b00 = (field, operator, operand, predicates = [])=>{
    return $ec55d1fce1db1ad3$export$cc08e43598d091fc(field, operator, operand, predicates);
};
const $ec55d1fce1db1ad3$export$cc08e43598d091fc = (field, operator, operand, predicates, position = null)=>{
    const node = {
        type: (0, $438a1d15528702a3$export$2d205682cc545947),
        clauseType: (0, $64e15c988a7f27d3$export$ae56b4ef248a2b6a),
        field: field,
        operator: operator,
        operand: operand,
        predicates: predicates,
        position: position,
        accept: $ec55d1fce1db1ad3$var$acceptTerminalClause,
        enterNode: $ec55d1fce1db1ad3$var$enterNode,
        exitNode: $ec55d1fce1db1ad3$var$exitNode,
        getChildren: $ec55d1fce1db1ad3$var$getChildren,
        parent: null,
        setOperator: $dmom1.setOperator,
        setOperand: $dmom1.setOperand,
        appendOperand: $dmom1.appendOperand,
        remove: $dmom1.remove,
        replace: $dmom1.replace
    };
    (0, $9xy4P.assignParent)(node);
    return node;
};

});
parcelRegister("dmom1", function(module, exports) {

$parcel$export(module.exports, "setOperator", () => setOperator);
$parcel$export(module.exports, "setOperand", () => setOperand);
$parcel$export(module.exports, "appendOperand", () => appendOperand);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "replace", () => replace);


var $gjjVy = parcelRequire("gjjVy");

var $9xy4P = parcelRequire("9xy4P");
function setOperator(operator) {
    this.operator = operator;
    (0, $9xy4P.assignParent)(this);
}
function setOperand(operand) {
    this.operand = operand;
    (0, $9xy4P.assignParent)(this);
}
function appendOperand(operand) {
    if (this.operand) {
        if (this.operand.operandType === (0, $96a349542da5e08d$export$fabec4aebba3f4df)) this.operand.appendOperand(operand);
        else this.setOperand((0, $gjjVy.default).listOperand([
            this.operand,
            ...operand.operandType === (0, $96a349542da5e08d$export$fabec4aebba3f4df) ? operand.values : [
                operand
            ]
        ]));
    } else this.setOperand(operand);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}

});


parcelRegister("4AWFE", function(module, exports) {

$parcel$export(module.exports, "valueOperand", () => $a95fd3b1416ec5e7$export$2b6e4d2ed8d53bf3);
$parcel$export(module.exports, "valueOperandInternal", () => $a95fd3b1416ec5e7$export$79c37d97caac8627);
$parcel$export(module.exports, "valueOperandByText", () => $a95fd3b1416ec5e7$export$3ac9155bde56a45f);


var $2QsWS = parcelRequire("2QsWS");
var $l8THn = parcelRequire("l8THn");

var $9xy4P = parcelRequire("9xy4P");
function $a95fd3b1416ec5e7$var$acceptValueOperand(visitor) {
    return visitor.visitValueOperand ? visitor.visitValueOperand(this) : visitor.visitChildren(this);
}
function $a95fd3b1416ec5e7$var$enterNode(listener) {
    listener.enterValueOperand && listener.enterValueOperand(this);
}
function $a95fd3b1416ec5e7$var$exitNode(listener) {
    listener.exitValueOperand && listener.exitValueOperand(this);
}
const $a95fd3b1416ec5e7$export$2b6e4d2ed8d53bf3 = (value)=>$a95fd3b1416ec5e7$export$79c37d97caac8627(value, (0, $l8THn.sanitiseJqlString)(value));
const $a95fd3b1416ec5e7$export$3ac9155bde56a45f = (text)=>$a95fd3b1416ec5e7$export$79c37d97caac8627((0, $2QsWS.normaliseJqlString)(text), text);
const $a95fd3b1416ec5e7$export$79c37d97caac8627 = (value, text, position = null)=>({
        type: (0, $438a1d15528702a3$export$d2f212d8ddbc8d1d),
        operandType: (0, $96a349542da5e08d$export$38accfc5a5d1c113),
        text: text,
        value: value,
        position: position,
        accept: $a95fd3b1416ec5e7$var$acceptValueOperand,
        enterNode: $a95fd3b1416ec5e7$var$enterNode,
        exitNode: $a95fd3b1416ec5e7$var$exitNode,
        getChildren: (0, $9xy4P.noChildren),
        parent: null
    });

});


parcelRegister("3KEIl", function(module, exports) {

$parcel$export(module.exports, "JastBuilder", () => $8cd6f80424fd1a2f$export$99cae18a5a6ba8cf);

var $hCaMj = parcelRequire("hCaMj");

var $8QpSo = parcelRequire("8QpSo");

var $b0Pfd = parcelRequire("b0Pfd");
var $7EDzN = parcelRequire("7EDzN");

var $gjjVy = parcelRequire("gjjVy");

var $l6Oi0 = parcelRequire("l6Oi0");
var $2e1By = parcelRequire("2e1By");

var $4b2kA = parcelRequire("4b2kA");
class $8cd6f80424fd1a2f$export$99cae18a5a6ba8cf {
    setErrorHandler(errorHandler) {
        this.errorHandler = errorHandler;
        return this;
    }
    setErrorListeners(errorListeners) {
        this.errorListeners = this.errorListeners.concat(errorListeners);
        return this;
    }
    build(value) {
        const tokens = this.getTokens(value);
        const parser = this.getParser(tokens);
        const astErrorListener = new (0, $l6Oi0.JastBuilderErrorListener)();
        parser.removeErrorListeners();
        parser.addErrorListener(astErrorListener);
        this.errorListeners.forEach((errorListener)=>parser.addErrorListener(errorListener));
        if (this.errorHandler) {
            parser.errorHandler = this.errorHandler;
            this.errorHandler.reset(parser);
        }
        const visitor = new (0, $4b2kA.QueryVisitor)(tokens);
        try {
            const parseTree = parser.jqlQuery();
            const query = parseTree.accept(visitor);
            return (0, $gjjVy.default).jast(query, value, astErrorListener.errors);
        } catch (error) {
            return (0, $gjjVy.default).jast(undefined, value, [
                new (0, $2e1By.JQLParseError)(error.message, error)
            ]);
        }
    }
    constructor(){
        this.errorListeners = [];
        this.errorHandler = undefined;
        this.getTokens = (0, $8QpSo.default)((value)=>{
            const chars = (0, $hCaMj.CharStreams).fromString(value);
            const lexer = new (0, $b0Pfd.JQLLexer)(chars);
            return new (0, $hCaMj.CommonTokenStream)(lexer);
        });
        this.getParser = (0, $8QpSo.default)((tokens)=>new (0, $7EDzN.JQLParser)(tokens));
    }
}

});
parcelRegister("hCaMj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cd2e58a1d1fa972f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cd2e58a1d1fa972f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cd2e58a1d1fa972f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("fJ9SA")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1lYFk")), module.exports);

// export * from "./ANTLRFileStream";
$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("g8XSE")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("b0kN8")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1UkCC")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("QidO0")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("9NnFz")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1Olk0")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("7ufNj")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("j53rr")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("gWaB3")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("a0nC0")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("e5mHr")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("4CCJj")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("4a3G0")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5Poq6")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("ea0YW")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("iLUMi")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5FrZ8")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("ceaEj")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("igNLf")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("gMbxO")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("fOEQQ")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("drCaH")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("hKCjP")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("jIG0W")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("2pQQd")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("dReoi")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("6bmaO")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("65iNZ")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5xwgp")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("fLdDn")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("kBaAZ")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("c8jEe")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("77rdV")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5IgvW")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1ivK9")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("2DVsz")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("eftJA")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("9rAj4")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5jPdD")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("dIykH")), module.exports);

// export * from "./UnbufferedCharStream";
// export * from "./UnbufferedTokenStream";
$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1MVGg")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("3n2FE")), module.exports);

$cd2e58a1d1fa972f$var$__exportStar((parcelRequire("6UcB4")), module.exports);

});
parcelRegister("fJ9SA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1lYFk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("g8XSE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ // ConvertTo-TS run at 2016-10-04T11:26:49.0828748-07:00
var $bc0bd7b6659a2632$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ANTLRInputStream = void 0;

var $bbHFU = parcelRequire("bbHFU");

var $d6D31 = parcelRequire("d6D31");

var $ceaEj = parcelRequire("ceaEj");
const $bc0bd7b6659a2632$var$READ_BUFFER_SIZE = 1024;
const $bc0bd7b6659a2632$var$INITIAL_BUFFER_SIZE = 1024;
/**
 * Vacuum all input from a {@link Reader}/{@link InputStream} and then treat it
 * like a `char[]` buffer. Can also pass in a {@link String} or
 * `char[]` to use.
 *
 * If you need encoding, pass in stream/reader with correct encoding.
 *
 * @deprecated as of 4.7, please use `CharStreams` interface.
 */ class $bc0bd7b6659a2632$var$ANTLRInputStream {
    /** Copy data in string to a local char array */ constructor(input){
        /** 0..n-1 index into string of next char */ this.p = 0;
        this.data = input;
        this.n = input.length;
    }
    /** Reset the stream so that it's in the same state it was
     *  when the object was created *except* the data array is not
     *  touched.
     */ reset() {
        this.p = 0;
    }
    consume() {
        if (this.p >= this.n) {
            $bbHFU(this.LA(1) === $ceaEj.IntStream.EOF);
            throw new Error("cannot consume EOF");
        }
        //System.out.println("prev p="+p+", c="+(char)data[p]);
        if (this.p < this.n) this.p++;
    }
    LA(i) {
        if (i === 0) return 0; // undefined
        if (i < 0) {
            i++; // e.g., translate LA(-1) to use offset i=0; then data[p+0-1]
            if (this.p + i - 1 < 0) return $ceaEj.IntStream.EOF; // invalid; no char before first char
        }
        if (this.p + i - 1 >= this.n) //System.out.println("char LA("+i+")=EOF; p="+p);
        return $ceaEj.IntStream.EOF;
        //System.out.println("char LA("+i+")="+(char)data[p+i-1]+"; p="+p);
        //System.out.println("LA("+i+"); p="+p+" n="+n+" data.length="+data.length);
        return this.data.charCodeAt(this.p + i - 1);
    }
    LT(i) {
        return this.LA(i);
    }
    /** Return the current input symbol index 0..n where n indicates the
     *  last symbol has been read.  The index is the index of char to
     *  be returned from LA(1).
     */ get index() {
        return this.p;
    }
    get size() {
        return this.n;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    /** consume() ahead until p==index; can't just set p=index as we must
     *  update line and charPositionInLine. If we seek backwards, just set p
     */ seek(index) {
        if (index <= this.p) {
            this.p = index; // just jump; don't update stream state (line, ...)
            return;
        }
        // seek forward, consume until p hits index or n (whichever comes first)
        index = Math.min(index, this.n);
        while(this.p < index)this.consume();
    }
    getText(interval) {
        let start = interval.a;
        let stop = interval.b;
        if (stop >= this.n) stop = this.n - 1;
        let count = stop - start + 1;
        if (start >= this.n) return "";
        // System.err.println("data: "+Arrays.toString(data)+", n="+n+
        // 				   ", start="+start+
        // 				   ", stop="+stop);
        return this.data.substr(start, count);
    }
    get sourceName() {
        if (!this.name) return $ceaEj.IntStream.UNKNOWN_SOURCE_NAME;
        return this.name;
    }
    toString() {
        return this.data;
    }
}
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "consume", null);
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "LA", null);
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "index", null);
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "size", null);
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "mark", null);
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "release", null);
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "seek", null);
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "getText", null);
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "sourceName", null);
$bc0bd7b6659a2632$var$__decorate([
    $d6D31.Override
], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "toString", null);
module.exports.ANTLRInputStream = $bc0bd7b6659a2632$var$ANTLRInputStream;

});
parcelRegister("bbHFU", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $6cAn5 = parcelRequire("6cAn5");
'use strict';
function $825299b5d0c0a9a5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $825299b5d0c0a9a5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $825299b5d0c0a9a5$var$_typeof(o);
}
function $825299b5d0c0a9a5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $825299b5d0c0a9a5$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $825299b5d0c0a9a5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $825299b5d0c0a9a5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $825299b5d0c0a9a5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $825299b5d0c0a9a5$var$_toPropertyKey(arg) {
    var key = $825299b5d0c0a9a5$var$_toPrimitive(arg, "string");
    return $825299b5d0c0a9a5$var$_typeof(key) === "symbol" ? key : String(key);
}
function $825299b5d0c0a9a5$var$_toPrimitive(input, hint) {
    if ($825299b5d0c0a9a5$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($825299b5d0c0a9a5$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $825299b5d0c0a9a5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $8JAro = parcelRequire("8JAro");
var $825299b5d0c0a9a5$var$_require$codes = $8JAro.codes, $825299b5d0c0a9a5$var$ERR_AMBIGUOUS_ARGUMENT = $825299b5d0c0a9a5$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE = $825299b5d0c0a9a5$var$_require$codes.ERR_INVALID_ARG_TYPE, $825299b5d0c0a9a5$var$ERR_INVALID_ARG_VALUE = $825299b5d0c0a9a5$var$_require$codes.ERR_INVALID_ARG_VALUE, $825299b5d0c0a9a5$var$ERR_INVALID_RETURN_VALUE = $825299b5d0c0a9a5$var$_require$codes.ERR_INVALID_RETURN_VALUE, $825299b5d0c0a9a5$var$ERR_MISSING_ARGS = $825299b5d0c0a9a5$var$_require$codes.ERR_MISSING_ARGS;

var $3ZLjA = parcelRequire("3ZLjA");

var $9kAQu = parcelRequire("9kAQu");
var $825299b5d0c0a9a5$var$inspect = $9kAQu.inspect;

var $9kAQu = parcelRequire("9kAQu");
var $825299b5d0c0a9a5$require$_require$types = $9kAQu.types;
var $825299b5d0c0a9a5$var$isPromise = $825299b5d0c0a9a5$require$_require$types.isPromise, $825299b5d0c0a9a5$var$isRegExp = $825299b5d0c0a9a5$require$_require$types.isRegExp;

var $825299b5d0c0a9a5$var$objectAssign = (parcelRequire("8s5ew"))();

var $825299b5d0c0a9a5$var$objectIs = (parcelRequire("eJazH"))();

var $825299b5d0c0a9a5$var$RegExpPrototypeTest = (parcelRequire("53KqO"))('RegExp.prototype.test');
var $825299b5d0c0a9a5$var$errorCache = new Map();
var $825299b5d0c0a9a5$var$isDeepEqual;
var $825299b5d0c0a9a5$var$isDeepStrictEqual;
var $825299b5d0c0a9a5$var$parseExpressionAt;
var $825299b5d0c0a9a5$var$findNodeAround;
var $825299b5d0c0a9a5$var$decoder;

function $825299b5d0c0a9a5$var$lazyLoadComparison() {
    var comparison = (parcelRequire("dztjv"));
    $825299b5d0c0a9a5$var$isDeepEqual = comparison.isDeepEqual;
    $825299b5d0c0a9a5$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $825299b5d0c0a9a5$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $825299b5d0c0a9a5$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $825299b5d0c0a9a5$var$escapeFn = function escapeFn(str) {
    return $825299b5d0c0a9a5$var$meta[str.charCodeAt(0)];
};
var $825299b5d0c0a9a5$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $825299b5d0c0a9a5$var$assert = module.exports = $825299b5d0c0a9a5$var$ok;
var $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $825299b5d0c0a9a5$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $3ZLjA(obj);
}
function $825299b5d0c0a9a5$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($825299b5d0c0a9a5$var$warned === false) {
            $825299b5d0c0a9a5$var$warned = true;
            var warn = $6cAn5.emitWarning ? $6cAn5.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $825299b5d0c0a9a5$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $3ZLjA(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$825299b5d0c0a9a5$var$assert.fail = $825299b5d0c0a9a5$var$fail;
// The AssertionError is defined in internal/error.
$825299b5d0c0a9a5$var$assert.AssertionError = $3ZLjA;
function $825299b5d0c0a9a5$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $3ZLjA({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $825299b5d0c0a9a5$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $825299b5d0c0a9a5$var$innerOk.apply(void 0, [
        $825299b5d0c0a9a5$var$ok,
        args.length
    ].concat(args));
}
$825299b5d0c0a9a5$var$assert.ok = $825299b5d0c0a9a5$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $825299b5d0c0a9a5$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $825299b5d0c0a9a5$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$825299b5d0c0a9a5$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $825299b5d0c0a9a5$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$825299b5d0c0a9a5$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
    if (!$825299b5d0c0a9a5$var$isDeepEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$825299b5d0c0a9a5$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
    if ($825299b5d0c0a9a5$var$isDeepEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $825299b5d0c0a9a5$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
    if (!$825299b5d0c0a9a5$var$isDeepStrictEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$825299b5d0c0a9a5$var$assert.notDeepStrictEqual = $825299b5d0c0a9a5$var$notDeepStrictEqual;
function $825299b5d0c0a9a5$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
    if ($825299b5d0c0a9a5$var$isDeepStrictEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $825299b5d0c0a9a5$var$notDeepStrictEqual
    });
}
$825299b5d0c0a9a5$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$825299b5d0c0a9a5$var$objectIs(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$825299b5d0c0a9a5$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($825299b5d0c0a9a5$var$objectIs(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $825299b5d0c0a9a5$var$Comparison = /*#__PURE__*/ $825299b5d0c0a9a5$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $825299b5d0c0a9a5$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $825299b5d0c0a9a5$var$isRegExp(obj[key]) && $825299b5d0c0a9a5$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $825299b5d0c0a9a5$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$825299b5d0c0a9a5$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $825299b5d0c0a9a5$var$Comparison(actual, keys);
            var b = new $825299b5d0c0a9a5$var$Comparison(expected, keys, actual);
            var err = new $3ZLjA({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $825299b5d0c0a9a5$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($825299b5d0c0a9a5$var$isRegExp(expected)) return $825299b5d0c0a9a5$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($825299b5d0c0a9a5$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $3ZLjA({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $825299b5d0c0a9a5$var$isRegExp(expected[key]) && $825299b5d0c0a9a5$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $825299b5d0c0a9a5$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $825299b5d0c0a9a5$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL;
}
function $825299b5d0c0a9a5$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $825299b5d0c0a9a5$var$isPromise(obj) || obj !== null && $825299b5d0c0a9a5$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $825299b5d0c0a9a5$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$825299b5d0c0a9a5$var$checkIsPromise(resultPromise)) throw new $825299b5d0c0a9a5$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($825299b5d0c0a9a5$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $825299b5d0c0a9a5$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($825299b5d0c0a9a5$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $825299b5d0c0a9a5$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $825299b5d0c0a9a5$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $825299b5d0c0a9a5$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $825299b5d0c0a9a5$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$825299b5d0c0a9a5$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $825299b5d0c0a9a5$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $825299b5d0c0a9a5$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$825299b5d0c0a9a5$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $825299b5d0c0a9a5$var$expectsError.apply(void 0, [
        throws,
        $825299b5d0c0a9a5$var$getActual(promiseFn)
    ].concat(args));
};
$825299b5d0c0a9a5$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $825299b5d0c0a9a5$var$waitForActual(promiseFn).then(function(result) {
        return $825299b5d0c0a9a5$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$825299b5d0c0a9a5$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $825299b5d0c0a9a5$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $825299b5d0c0a9a5$var$getActual(fn)
    ].concat(args));
};
$825299b5d0c0a9a5$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $825299b5d0c0a9a5$var$waitForActual(fn).then(function(result) {
        return $825299b5d0c0a9a5$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$825299b5d0c0a9a5$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($825299b5d0c0a9a5$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $825299b5d0c0a9a5$var$inspect(err);
        var newErr = new $3ZLjA({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $825299b5d0c0a9a5$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$825299b5d0c0a9a5$var$isRegExp(regexp)) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $825299b5d0c0a9a5$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($825299b5d0c0a9a5$var$_typeof(string), " (").concat($825299b5d0c0a9a5$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($825299b5d0c0a9a5$var$inspect(regexp), ". Input:\n\n").concat($825299b5d0c0a9a5$var$inspect(string), "\n"));
        var err = new $3ZLjA({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$825299b5d0c0a9a5$var$assert.match = function match(string, regexp, message) {
    $825299b5d0c0a9a5$var$internalMatch(string, regexp, message, match, 'match');
};
$825299b5d0c0a9a5$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $825299b5d0c0a9a5$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $825299b5d0c0a9a5$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $825299b5d0c0a9a5$var$innerOk.apply(void 0, [
        $825299b5d0c0a9a5$var$strict,
        args.length
    ].concat(args));
}
$825299b5d0c0a9a5$var$assert.strict = $825299b5d0c0a9a5$var$objectAssign($825299b5d0c0a9a5$var$strict, $825299b5d0c0a9a5$var$assert, {
    equal: $825299b5d0c0a9a5$var$assert.strictEqual,
    deepEqual: $825299b5d0c0a9a5$var$assert.deepStrictEqual,
    notEqual: $825299b5d0c0a9a5$var$assert.notStrictEqual,
    notDeepEqual: $825299b5d0c0a9a5$var$assert.notDeepStrictEqual
});
$825299b5d0c0a9a5$var$assert.strict.strict = $825299b5d0c0a9a5$var$assert.strict;

});
parcelRegister("8JAro", function(module, exports) {

$parcel$export(module.exports, "codes", () => $65becb1820e5a079$export$e45cb6485273080e, (v) => $65becb1820e5a079$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $65becb1820e5a079$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $65becb1820e5a079$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $65becb1820e5a079$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $65becb1820e5a079$var$_typeof(o);
}
function $65becb1820e5a079$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $65becb1820e5a079$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $65becb1820e5a079$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $65becb1820e5a079$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $65becb1820e5a079$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $65becb1820e5a079$var$_toPropertyKey(arg) {
    var key = $65becb1820e5a079$var$_toPrimitive(arg, "string");
    return $65becb1820e5a079$var$_typeof(key) === "symbol" ? key : String(key);
}
function $65becb1820e5a079$var$_toPrimitive(input, hint) {
    if ($65becb1820e5a079$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($65becb1820e5a079$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $65becb1820e5a079$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $65becb1820e5a079$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $65becb1820e5a079$var$_setPrototypeOf(subClass, superClass);
}
function $65becb1820e5a079$var$_setPrototypeOf(o, p) {
    $65becb1820e5a079$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $65becb1820e5a079$var$_setPrototypeOf(o, p);
}
function $65becb1820e5a079$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $65becb1820e5a079$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $65becb1820e5a079$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $65becb1820e5a079$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $65becb1820e5a079$var$_possibleConstructorReturn(this, result);
    };
}
function $65becb1820e5a079$var$_possibleConstructorReturn(self, call) {
    if (call && ($65becb1820e5a079$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $65becb1820e5a079$var$_assertThisInitialized(self);
}
function $65becb1820e5a079$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $65becb1820e5a079$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $65becb1820e5a079$var$_getPrototypeOf(o) {
    $65becb1820e5a079$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $65becb1820e5a079$var$_getPrototypeOf(o);
}
var $65becb1820e5a079$var$codes = {};
// Lazy loaded
var $65becb1820e5a079$var$assert;
var $65becb1820e5a079$var$util;
function $65becb1820e5a079$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $65becb1820e5a079$var$_inherits(NodeError, _Base);
        var _super = $65becb1820e5a079$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $65becb1820e5a079$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $65becb1820e5a079$var$_createClass(NodeError);
    }(Base);
    $65becb1820e5a079$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $65becb1820e5a079$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $65becb1820e5a079$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $65becb1820e5a079$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $65becb1820e5a079$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$65becb1820e5a079$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$65becb1820e5a079$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($65becb1820e5a079$var$assert === undefined) $65becb1820e5a079$var$assert = (parcelRequire("bbHFU"));
    $65becb1820e5a079$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $65becb1820e5a079$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($65becb1820e5a079$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($65becb1820e5a079$var$oneOf(expected, 'type'));
    else {
        var type = $65becb1820e5a079$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($65becb1820e5a079$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($65becb1820e5a079$var$_typeof(actual));
    return msg;
}, TypeError);

$65becb1820e5a079$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($65becb1820e5a079$var$util === undefined) $65becb1820e5a079$var$util = (parcelRequire("9kAQu"));
    var inspected = $65becb1820e5a079$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$65becb1820e5a079$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($65becb1820e5a079$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$65becb1820e5a079$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($65becb1820e5a079$var$assert === undefined) $65becb1820e5a079$var$assert = (parcelRequire("bbHFU"));
    $65becb1820e5a079$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$65becb1820e5a079$export$e45cb6485273080e = $65becb1820e5a079$var$codes;

});
parcelRegister("9kAQu", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $6cAn5 = parcelRequire("6cAn5");
var $6cb29018fbdc8fcc$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $6cb29018fbdc8fcc$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$6cb29018fbdc8fcc$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($6cb29018fbdc8fcc$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($6cb29018fbdc8fcc$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($6cb29018fbdc8fcc$var$isNull(x) || !$6cb29018fbdc8fcc$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $6cb29018fbdc8fcc$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $6cAn5 !== 'undefined' && $6cAn5.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $6cAn5 === 'undefined') return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($6cAn5.throwDeprecation) throw new Error(msg);
            else if ($6cAn5.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $6cb29018fbdc8fcc$var$debugs = {};
var $6cb29018fbdc8fcc$var$debugEnvRegex = /^$/;
var $6cb29018fbdc8fcc$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$6cb29018fbdc8fcc$var$debugs[set]) {
        if ($6cb29018fbdc8fcc$var$debugEnvRegex.test(set)) {
            var pid = $6cAn5.pid;
            $6cb29018fbdc8fcc$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $6cb29018fbdc8fcc$var$debugs[set] = function() {};
    }
    return $6cb29018fbdc8fcc$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $6cb29018fbdc8fcc$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $6cb29018fbdc8fcc$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($6cb29018fbdc8fcc$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($6cb29018fbdc8fcc$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($6cb29018fbdc8fcc$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($6cb29018fbdc8fcc$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($6cb29018fbdc8fcc$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $6cb29018fbdc8fcc$var$stylizeWithColor;
    return $6cb29018fbdc8fcc$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $6cb29018fbdc8fcc$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$6cb29018fbdc8fcc$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$6cb29018fbdc8fcc$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $6cb29018fbdc8fcc$var$stylizeWithColor(str, styleType) {
    var style = $6cb29018fbdc8fcc$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $6cb29018fbdc8fcc$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $6cb29018fbdc8fcc$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $6cb29018fbdc8fcc$var$stylizeNoColor(str, styleType) {
    return str;
}
function $6cb29018fbdc8fcc$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $6cb29018fbdc8fcc$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $6cb29018fbdc8fcc$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$6cb29018fbdc8fcc$var$isString(ret)) ret = $6cb29018fbdc8fcc$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $6cb29018fbdc8fcc$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $6cb29018fbdc8fcc$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($6cb29018fbdc8fcc$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $6cb29018fbdc8fcc$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($6cb29018fbdc8fcc$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($6cb29018fbdc8fcc$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($6cb29018fbdc8fcc$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($6cb29018fbdc8fcc$var$isError(value)) return $6cb29018fbdc8fcc$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($6cb29018fbdc8fcc$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($6cb29018fbdc8fcc$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($6cb29018fbdc8fcc$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($6cb29018fbdc8fcc$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($6cb29018fbdc8fcc$var$isError(value)) base = ' ' + $6cb29018fbdc8fcc$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($6cb29018fbdc8fcc$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $6cb29018fbdc8fcc$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $6cb29018fbdc8fcc$var$reduceToSingleString(output, base, braces);
}
function $6cb29018fbdc8fcc$var$formatPrimitive(ctx, value) {
    if ($6cb29018fbdc8fcc$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($6cb29018fbdc8fcc$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($6cb29018fbdc8fcc$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($6cb29018fbdc8fcc$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($6cb29018fbdc8fcc$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $6cb29018fbdc8fcc$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $6cb29018fbdc8fcc$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($6cb29018fbdc8fcc$var$hasOwnProperty(value, String(i))) output.push($6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$6cb29018fbdc8fcc$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($6cb29018fbdc8fcc$var$isNull(recurseTimes)) str = $6cb29018fbdc8fcc$var$formatValue(ctx, desc.value, null);
            else str = $6cb29018fbdc8fcc$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($6cb29018fbdc8fcc$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $6cb29018fbdc8fcc$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("jGyMi"));
function $6cb29018fbdc8fcc$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $6cb29018fbdc8fcc$var$isArray;
function $6cb29018fbdc8fcc$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $6cb29018fbdc8fcc$var$isBoolean;
function $6cb29018fbdc8fcc$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $6cb29018fbdc8fcc$var$isNull;
function $6cb29018fbdc8fcc$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $6cb29018fbdc8fcc$var$isNullOrUndefined;
function $6cb29018fbdc8fcc$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $6cb29018fbdc8fcc$var$isNumber;
function $6cb29018fbdc8fcc$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $6cb29018fbdc8fcc$var$isString;
function $6cb29018fbdc8fcc$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $6cb29018fbdc8fcc$var$isSymbol;
function $6cb29018fbdc8fcc$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $6cb29018fbdc8fcc$var$isUndefined;
function $6cb29018fbdc8fcc$var$isRegExp(re) {
    return $6cb29018fbdc8fcc$var$isObject(re) && $6cb29018fbdc8fcc$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $6cb29018fbdc8fcc$var$isRegExp;
module.exports.types.isRegExp = $6cb29018fbdc8fcc$var$isRegExp;
function $6cb29018fbdc8fcc$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $6cb29018fbdc8fcc$var$isObject;
function $6cb29018fbdc8fcc$var$isDate(d) {
    return $6cb29018fbdc8fcc$var$isObject(d) && $6cb29018fbdc8fcc$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $6cb29018fbdc8fcc$var$isDate;
module.exports.types.isDate = $6cb29018fbdc8fcc$var$isDate;
function $6cb29018fbdc8fcc$var$isError(e) {
    return $6cb29018fbdc8fcc$var$isObject(e) && ($6cb29018fbdc8fcc$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $6cb29018fbdc8fcc$var$isError;
module.exports.types.isNativeError = $6cb29018fbdc8fcc$var$isError;
function $6cb29018fbdc8fcc$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $6cb29018fbdc8fcc$var$isFunction;
function $6cb29018fbdc8fcc$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $6cb29018fbdc8fcc$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("kEU0N"));
function $6cb29018fbdc8fcc$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $6cb29018fbdc8fcc$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $6cb29018fbdc8fcc$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $6cb29018fbdc8fcc$var$timestamp() {
    var d = new Date();
    var time = [
        $6cb29018fbdc8fcc$var$pad(d.getHours()),
        $6cb29018fbdc8fcc$var$pad(d.getMinutes()),
        $6cb29018fbdc8fcc$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $6cb29018fbdc8fcc$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $6cb29018fbdc8fcc$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("v3bBu"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$6cb29018fbdc8fcc$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $6cb29018fbdc8fcc$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol && original[$6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol]) {
        var fn = original[$6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $6cb29018fbdc8fcc$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol;
function $6cb29018fbdc8fcc$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $6cb29018fbdc8fcc$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $6cAn5.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $6cAn5.nextTick($6cb29018fbdc8fcc$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $6cb29018fbdc8fcc$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $6cb29018fbdc8fcc$var$callbackify;

});
parcelRegister("jGyMi", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $eyPxb = parcelRequire("eyPxb");

var $kF7vh = parcelRequire("kF7vh");

var $hdl59 = parcelRequire("hdl59");

var $dFTgY = parcelRequire("dFTgY");
function $e54ceaba9c647d57$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $e54ceaba9c647d57$var$BigIntSupported = typeof BigInt !== 'undefined';
var $e54ceaba9c647d57$var$SymbolSupported = typeof Symbol !== 'undefined';
var $e54ceaba9c647d57$var$ObjectToString = $e54ceaba9c647d57$var$uncurryThis(Object.prototype.toString);
var $e54ceaba9c647d57$var$numberValue = $e54ceaba9c647d57$var$uncurryThis(Number.prototype.valueOf);
var $e54ceaba9c647d57$var$stringValue = $e54ceaba9c647d57$var$uncurryThis(String.prototype.valueOf);
var $e54ceaba9c647d57$var$booleanValue = $e54ceaba9c647d57$var$uncurryThis(Boolean.prototype.valueOf);
if ($e54ceaba9c647d57$var$BigIntSupported) var $e54ceaba9c647d57$var$bigIntValue = $e54ceaba9c647d57$var$uncurryThis(BigInt.prototype.valueOf);
if ($e54ceaba9c647d57$var$SymbolSupported) var $e54ceaba9c647d57$var$symbolValue = $e54ceaba9c647d57$var$uncurryThis(Symbol.prototype.valueOf);
function $e54ceaba9c647d57$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $eyPxb;
module.exports.isGeneratorFunction = $kF7vh;
module.exports.isTypedArray = $dFTgY;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $e54ceaba9c647d57$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $e54ceaba9c647d57$var$isPromise;
function $e54ceaba9c647d57$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $dFTgY(value) || $e54ceaba9c647d57$var$isDataView(value);
}
module.exports.isArrayBufferView = $e54ceaba9c647d57$var$isArrayBufferView;
function $e54ceaba9c647d57$var$isUint8Array(value) {
    return $hdl59(value) === 'Uint8Array';
}
module.exports.isUint8Array = $e54ceaba9c647d57$var$isUint8Array;
function $e54ceaba9c647d57$var$isUint8ClampedArray(value) {
    return $hdl59(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $e54ceaba9c647d57$var$isUint8ClampedArray;
function $e54ceaba9c647d57$var$isUint16Array(value) {
    return $hdl59(value) === 'Uint16Array';
}
module.exports.isUint16Array = $e54ceaba9c647d57$var$isUint16Array;
function $e54ceaba9c647d57$var$isUint32Array(value) {
    return $hdl59(value) === 'Uint32Array';
}
module.exports.isUint32Array = $e54ceaba9c647d57$var$isUint32Array;
function $e54ceaba9c647d57$var$isInt8Array(value) {
    return $hdl59(value) === 'Int8Array';
}
module.exports.isInt8Array = $e54ceaba9c647d57$var$isInt8Array;
function $e54ceaba9c647d57$var$isInt16Array(value) {
    return $hdl59(value) === 'Int16Array';
}
module.exports.isInt16Array = $e54ceaba9c647d57$var$isInt16Array;
function $e54ceaba9c647d57$var$isInt32Array(value) {
    return $hdl59(value) === 'Int32Array';
}
module.exports.isInt32Array = $e54ceaba9c647d57$var$isInt32Array;
function $e54ceaba9c647d57$var$isFloat32Array(value) {
    return $hdl59(value) === 'Float32Array';
}
module.exports.isFloat32Array = $e54ceaba9c647d57$var$isFloat32Array;
function $e54ceaba9c647d57$var$isFloat64Array(value) {
    return $hdl59(value) === 'Float64Array';
}
module.exports.isFloat64Array = $e54ceaba9c647d57$var$isFloat64Array;
function $e54ceaba9c647d57$var$isBigInt64Array(value) {
    return $hdl59(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $e54ceaba9c647d57$var$isBigInt64Array;
function $e54ceaba9c647d57$var$isBigUint64Array(value) {
    return $hdl59(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $e54ceaba9c647d57$var$isBigUint64Array;
function $e54ceaba9c647d57$var$isMapToString(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Map]';
}
$e54ceaba9c647d57$var$isMapToString.working = typeof Map !== 'undefined' && $e54ceaba9c647d57$var$isMapToString(new Map());
function $e54ceaba9c647d57$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $e54ceaba9c647d57$var$isMapToString.working ? $e54ceaba9c647d57$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $e54ceaba9c647d57$var$isMap;
function $e54ceaba9c647d57$var$isSetToString(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Set]';
}
$e54ceaba9c647d57$var$isSetToString.working = typeof Set !== 'undefined' && $e54ceaba9c647d57$var$isSetToString(new Set());
function $e54ceaba9c647d57$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $e54ceaba9c647d57$var$isSetToString.working ? $e54ceaba9c647d57$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $e54ceaba9c647d57$var$isSet;
function $e54ceaba9c647d57$var$isWeakMapToString(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object WeakMap]';
}
$e54ceaba9c647d57$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $e54ceaba9c647d57$var$isWeakMapToString(new WeakMap());
function $e54ceaba9c647d57$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $e54ceaba9c647d57$var$isWeakMapToString.working ? $e54ceaba9c647d57$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $e54ceaba9c647d57$var$isWeakMap;
function $e54ceaba9c647d57$var$isWeakSetToString(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object WeakSet]';
}
$e54ceaba9c647d57$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $e54ceaba9c647d57$var$isWeakSetToString(new WeakSet());
function $e54ceaba9c647d57$var$isWeakSet(value) {
    return $e54ceaba9c647d57$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $e54ceaba9c647d57$var$isWeakSet;
function $e54ceaba9c647d57$var$isArrayBufferToString(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$e54ceaba9c647d57$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $e54ceaba9c647d57$var$isArrayBufferToString(new ArrayBuffer());
function $e54ceaba9c647d57$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $e54ceaba9c647d57$var$isArrayBufferToString.working ? $e54ceaba9c647d57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $e54ceaba9c647d57$var$isArrayBuffer;
function $e54ceaba9c647d57$var$isDataViewToString(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object DataView]';
}
$e54ceaba9c647d57$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $e54ceaba9c647d57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $e54ceaba9c647d57$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $e54ceaba9c647d57$var$isDataViewToString.working ? $e54ceaba9c647d57$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $e54ceaba9c647d57$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $e54ceaba9c647d57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $e54ceaba9c647d57$var$isSharedArrayBufferToString(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $e54ceaba9c647d57$var$isSharedArrayBuffer(value) {
    if (typeof $e54ceaba9c647d57$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $e54ceaba9c647d57$var$isSharedArrayBufferToString.working === 'undefined') $e54ceaba9c647d57$var$isSharedArrayBufferToString.working = $e54ceaba9c647d57$var$isSharedArrayBufferToString(new $e54ceaba9c647d57$var$SharedArrayBufferCopy());
    return $e54ceaba9c647d57$var$isSharedArrayBufferToString.working ? $e54ceaba9c647d57$var$isSharedArrayBufferToString(value) : value instanceof $e54ceaba9c647d57$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $e54ceaba9c647d57$var$isSharedArrayBuffer;
function $e54ceaba9c647d57$var$isAsyncFunction(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $e54ceaba9c647d57$var$isAsyncFunction;
function $e54ceaba9c647d57$var$isMapIterator(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $e54ceaba9c647d57$var$isMapIterator;
function $e54ceaba9c647d57$var$isSetIterator(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $e54ceaba9c647d57$var$isSetIterator;
function $e54ceaba9c647d57$var$isGeneratorObject(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $e54ceaba9c647d57$var$isGeneratorObject;
function $e54ceaba9c647d57$var$isWebAssemblyCompiledModule(value) {
    return $e54ceaba9c647d57$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $e54ceaba9c647d57$var$isWebAssemblyCompiledModule;
function $e54ceaba9c647d57$var$isNumberObject(value) {
    return $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$numberValue);
}
module.exports.isNumberObject = $e54ceaba9c647d57$var$isNumberObject;
function $e54ceaba9c647d57$var$isStringObject(value) {
    return $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$stringValue);
}
module.exports.isStringObject = $e54ceaba9c647d57$var$isStringObject;
function $e54ceaba9c647d57$var$isBooleanObject(value) {
    return $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$booleanValue);
}
module.exports.isBooleanObject = $e54ceaba9c647d57$var$isBooleanObject;
function $e54ceaba9c647d57$var$isBigIntObject(value) {
    return $e54ceaba9c647d57$var$BigIntSupported && $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$bigIntValue);
}
module.exports.isBigIntObject = $e54ceaba9c647d57$var$isBigIntObject;
function $e54ceaba9c647d57$var$isSymbolObject(value) {
    return $e54ceaba9c647d57$var$SymbolSupported && $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$symbolValue);
}
module.exports.isSymbolObject = $e54ceaba9c647d57$var$isSymbolObject;
function $e54ceaba9c647d57$var$isBoxedPrimitive(value) {
    return $e54ceaba9c647d57$var$isNumberObject(value) || $e54ceaba9c647d57$var$isStringObject(value) || $e54ceaba9c647d57$var$isBooleanObject(value) || $e54ceaba9c647d57$var$isBigIntObject(value) || $e54ceaba9c647d57$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $e54ceaba9c647d57$var$isBoxedPrimitive;
function $e54ceaba9c647d57$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($e54ceaba9c647d57$var$isArrayBuffer(value) || $e54ceaba9c647d57$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $e54ceaba9c647d57$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("eyPxb", function(module, exports) {
'use strict';

var $a99c3747cd09063d$var$hasToStringTag = (parcelRequire("fmBzB"))();

var $53KqO = parcelRequire("53KqO");
var $a99c3747cd09063d$var$$toString = $53KqO('Object.prototype.toString');
var $a99c3747cd09063d$var$isStandardArguments = function isArguments(value) {
    if ($a99c3747cd09063d$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $a99c3747cd09063d$var$$toString(value) === '[object Arguments]';
};
var $a99c3747cd09063d$var$isLegacyArguments = function isArguments(value) {
    if ($a99c3747cd09063d$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $a99c3747cd09063d$var$$toString(value) !== '[object Array]' && $a99c3747cd09063d$var$$toString(value.callee) === '[object Function]';
};
var $a99c3747cd09063d$var$supportsStandardArguments = function() {
    return $a99c3747cd09063d$var$isStandardArguments(arguments);
}();
$a99c3747cd09063d$var$isStandardArguments.isLegacyArguments = $a99c3747cd09063d$var$isLegacyArguments; // for tests
module.exports = $a99c3747cd09063d$var$supportsStandardArguments ? $a99c3747cd09063d$var$isStandardArguments : $a99c3747cd09063d$var$isLegacyArguments;

});
parcelRegister("fmBzB", function(module, exports) {
'use strict';

var $9T9x9 = parcelRequire("9T9x9");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $9T9x9() && !!Symbol.toStringTag;
};

});

parcelRegister("53KqO", function(module, exports) {
'use strict';

var $iPtqy = parcelRequire("iPtqy");

var $h05ZS = parcelRequire("h05ZS");
var $3af13fe1c3fdd190$var$$indexOf = $h05ZS($iPtqy('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $iPtqy(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $3af13fe1c3fdd190$var$$indexOf(name, '.prototype.') > -1) return $h05ZS(intrinsic);
    return intrinsic;
};

});
parcelRegister("h05ZS", function(module, exports) {
'use strict';

var $6ElEw = parcelRequire("6ElEw");

var $7Th0d = parcelRequire("7Th0d");

var $h08zB = parcelRequire("h08zB");

var $ghZDY = parcelRequire("ghZDY");
module.exports = function callBind(originalFunction) {
    var func = $h08zB(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $6ElEw(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($7Th0d) $7Th0d(module.exports, 'apply', {
    value: $ghZDY
});
else module.exports.apply = $ghZDY;

});
parcelRegister("6ElEw", function(module, exports) {
'use strict';

var $iPtqy = parcelRequire("iPtqy");

var $le88V = parcelRequire("le88V");

var $4d77463b7ea9d419$var$hasDescriptors = (parcelRequire("9lmlE"))();

var $lBvcQ = parcelRequire("lBvcQ");

var $kQfBa = parcelRequire("kQfBa");
var $4d77463b7ea9d419$var$$floor = $iPtqy('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $kQfBa('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $4d77463b7ea9d419$var$$floor(length) !== length) throw new $kQfBa('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $lBvcQ) {
        var desc = $lBvcQ(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($4d77463b7ea9d419$var$hasDescriptors) $le88V(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $le88V(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("le88V", function(module, exports) {
'use strict';

var $7Th0d = parcelRequire("7Th0d");

var $6ZTEL = parcelRequire("6ZTEL");

var $kQfBa = parcelRequire("kQfBa");

var $lBvcQ = parcelRequire("lBvcQ");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $kQfBa('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $kQfBa('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $kQfBa('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $kQfBa('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $kQfBa('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $kQfBa('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$lBvcQ && $lBvcQ(obj, property);
    if ($7Th0d) $7Th0d(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $6ZTEL('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("9lmlE", function(module, exports) {
'use strict';

var $7Th0d = parcelRequire("7Th0d");
var $6cd7691e5358e89c$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$7Th0d;
};
$6cd7691e5358e89c$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$7Th0d) return null;
    try {
        return $7Th0d([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $6cd7691e5358e89c$var$hasPropertyDescriptors;

});


parcelRegister("ghZDY", function(module, exports) {
'use strict';

var $g2Z6Y = parcelRequire("g2Z6Y");

var $iJCdB = parcelRequire("iJCdB");

var $4XlJF = parcelRequire("4XlJF");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $4XlJF($g2Z6Y, $iJCdB, arguments);
};

});




parcelRegister("kF7vh", function(module, exports) {
'use strict';
var $f0ad750370f41c64$var$toStr = Object.prototype.toString;
var $f0ad750370f41c64$var$fnToStr = Function.prototype.toString;
var $f0ad750370f41c64$var$isFnRegex = /^\s*(?:function)?\*/;

var $f0ad750370f41c64$var$hasToStringTag = (parcelRequire("fmBzB"))();
var $f0ad750370f41c64$var$getProto = Object.getPrototypeOf;
var $f0ad750370f41c64$var$getGeneratorFunc = function() {
    if (!$f0ad750370f41c64$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
var $f0ad750370f41c64$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($f0ad750370f41c64$var$isFnRegex.test($f0ad750370f41c64$var$fnToStr.call(fn))) return true;
    if (!$f0ad750370f41c64$var$hasToStringTag) {
        var str = $f0ad750370f41c64$var$toStr.call(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$f0ad750370f41c64$var$getProto) return false;
    if (typeof $f0ad750370f41c64$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $f0ad750370f41c64$var$getGeneratorFunc();
        $f0ad750370f41c64$var$GeneratorFunction = generatorFunc ? $f0ad750370f41c64$var$getProto(generatorFunc) : false;
    }
    return $f0ad750370f41c64$var$getProto(fn) === $f0ad750370f41c64$var$GeneratorFunction;
};

});

parcelRegister("hdl59", function(module, exports) {
'use strict';

var $258uT = parcelRequire("258uT");

var $9ME5O = parcelRequire("9ME5O");

var $h05ZS = parcelRequire("h05ZS");

var $3T2jo = parcelRequire("3T2jo");

var $lBvcQ = parcelRequire("lBvcQ");

var $863dK = parcelRequire("863dK");
var $c884010d01443113$var$$toString = $3T2jo('Object.prototype.toString');

var $c884010d01443113$var$hasToStringTag = (parcelRequire("fmBzB"))();
var $c884010d01443113$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $c884010d01443113$var$typedArrays = $9ME5O();
var $c884010d01443113$var$$slice = $3T2jo('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $c884010d01443113$var$$indexOf = $3T2jo('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $c884010d01443113$var$cache = {
    __proto__: null
};
if ($c884010d01443113$var$hasToStringTag && $lBvcQ && $863dK) $258uT($c884010d01443113$var$typedArrays, function(typedArray) {
    var arr = new $c884010d01443113$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $863dK) {
        var proto = $863dK(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $lBvcQ(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $863dK(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $lBvcQ(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $c884010d01443113$var$cache['$' + typedArray] = $h05ZS(descriptor.get);
    }
});
else $258uT($c884010d01443113$var$typedArrays, function(typedArray) {
    var arr = new $c884010d01443113$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $c884010d01443113$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $h05ZS(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c884010d01443113$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $258uT(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $c884010d01443113$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $c884010d01443113$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c884010d01443113$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $258uT(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $c884010d01443113$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $c884010d01443113$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$c884010d01443113$var$hasToStringTag) {
        /** @type {string} */ var tag = $c884010d01443113$var$$slice($c884010d01443113$var$$toString(value), 8, -1);
        if ($c884010d01443113$var$$indexOf($c884010d01443113$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $c884010d01443113$var$trySlices(value);
    }
    if (!$lBvcQ) return null;
     // unknown engine
    return $c884010d01443113$var$tryTypedArrays(value);
};

});
parcelRegister("258uT", function(module, exports) {
'use strict';

var $f0Tdg = parcelRequire("f0Tdg");
var $1842a3cb7df292b5$var$toStr = Object.prototype.toString;
var $1842a3cb7df292b5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $1842a3cb7df292b5$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($1842a3cb7df292b5$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $1842a3cb7df292b5$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $1842a3cb7df292b5$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($1842a3cb7df292b5$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $1842a3cb7df292b5$var$isArray(x) {
    return $1842a3cb7df292b5$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$f0Tdg(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($1842a3cb7df292b5$var$isArray(list)) $1842a3cb7df292b5$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $1842a3cb7df292b5$var$forEachString(list, iterator, receiver);
    else $1842a3cb7df292b5$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("f0Tdg", function(module, exports) {
'use strict';
var $02d21778b0eebae4$var$fnToStr = Function.prototype.toString;
var $02d21778b0eebae4$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $02d21778b0eebae4$var$badArrayLike;
var $02d21778b0eebae4$var$isCallableMarker;
if (typeof $02d21778b0eebae4$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $02d21778b0eebae4$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $02d21778b0eebae4$var$isCallableMarker;
        }
    });
    $02d21778b0eebae4$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $02d21778b0eebae4$var$reflectApply(function() {
        throw 42;
    }, null, $02d21778b0eebae4$var$badArrayLike);
} catch (_) {
    if (_ !== $02d21778b0eebae4$var$isCallableMarker) $02d21778b0eebae4$var$reflectApply = null;
}
else $02d21778b0eebae4$var$reflectApply = null;
var $02d21778b0eebae4$var$constructorRegex = /^\s*class\b/;
var $02d21778b0eebae4$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $02d21778b0eebae4$var$fnToStr.call(value);
        return $02d21778b0eebae4$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $02d21778b0eebae4$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($02d21778b0eebae4$var$isES6ClassFn(value)) return false;
        $02d21778b0eebae4$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $02d21778b0eebae4$var$toStr = Object.prototype.toString;
var $02d21778b0eebae4$var$objectClass = '[object Object]';
var $02d21778b0eebae4$var$fnClass = '[object Function]';
var $02d21778b0eebae4$var$genClass = '[object GeneratorFunction]';
var $02d21778b0eebae4$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $02d21778b0eebae4$var$ddaClass2 = '[object HTML document.all class]';
var $02d21778b0eebae4$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $02d21778b0eebae4$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $02d21778b0eebae4$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $02d21778b0eebae4$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $02d21778b0eebae4$var$all = document.all;
    if ($02d21778b0eebae4$var$toStr.call($02d21778b0eebae4$var$all) === $02d21778b0eebae4$var$toStr.call(document.all)) $02d21778b0eebae4$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($02d21778b0eebae4$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $02d21778b0eebae4$var$toStr.call(value);
            return (str === $02d21778b0eebae4$var$ddaClass || str === $02d21778b0eebae4$var$ddaClass2 || str === $02d21778b0eebae4$var$ddaClass3 // opera 12.16
             || str === $02d21778b0eebae4$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $02d21778b0eebae4$var$reflectApply ? function isCallable(value) {
    if ($02d21778b0eebae4$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $02d21778b0eebae4$var$reflectApply(value, null, $02d21778b0eebae4$var$badArrayLike);
    } catch (e) {
        if (e !== $02d21778b0eebae4$var$isCallableMarker) return false;
    }
    return !$02d21778b0eebae4$var$isES6ClassFn(value) && $02d21778b0eebae4$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($02d21778b0eebae4$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($02d21778b0eebae4$var$hasToStringTag) return $02d21778b0eebae4$var$tryFunctionObject(value);
    if ($02d21778b0eebae4$var$isES6ClassFn(value)) return false;
    var strClass = $02d21778b0eebae4$var$toStr.call(value);
    if (strClass !== $02d21778b0eebae4$var$fnClass && strClass !== $02d21778b0eebae4$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $02d21778b0eebae4$var$tryFunctionObject(value);
};

});


parcelRegister("9ME5O", function(module, exports) {
'use strict';

var $8a51N = parcelRequire("8a51N");
var $71f7b254c38edcde$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $8a51N.length; i++)if (typeof $71f7b254c38edcde$var$g[$8a51N[i]] === 'function') // @ts-expect-error
    out[out.length] = $8a51N[i];
    return out;
};

});
parcelRegister("8a51N", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});



parcelRegister("dFTgY", function(module, exports) {
'use strict';

var $hdl59 = parcelRequire("hdl59");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$hdl59(value);
};

});


parcelRegister("kEU0N", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("v3bBu", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});



parcelRegister("3ZLjA", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $6cAn5 = parcelRequire("6cAn5");
'use strict';
function $2e8bc5606025d797$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2e8bc5606025d797$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2e8bc5606025d797$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2e8bc5606025d797$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2e8bc5606025d797$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2e8bc5606025d797$var$_defineProperty(obj, key, value) {
    key = $2e8bc5606025d797$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2e8bc5606025d797$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2e8bc5606025d797$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $2e8bc5606025d797$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $2e8bc5606025d797$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2e8bc5606025d797$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2e8bc5606025d797$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $2e8bc5606025d797$var$_toPropertyKey(arg) {
    var key = $2e8bc5606025d797$var$_toPrimitive(arg, "string");
    return $2e8bc5606025d797$var$_typeof(key) === "symbol" ? key : String(key);
}
function $2e8bc5606025d797$var$_toPrimitive(input, hint) {
    if ($2e8bc5606025d797$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($2e8bc5606025d797$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $2e8bc5606025d797$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $2e8bc5606025d797$var$_setPrototypeOf(subClass, superClass);
}
function $2e8bc5606025d797$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2e8bc5606025d797$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $2e8bc5606025d797$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $2e8bc5606025d797$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $2e8bc5606025d797$var$_possibleConstructorReturn(this, result);
    };
}
function $2e8bc5606025d797$var$_possibleConstructorReturn(self, call) {
    if (call && ($2e8bc5606025d797$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $2e8bc5606025d797$var$_assertThisInitialized(self);
}
function $2e8bc5606025d797$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2e8bc5606025d797$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $2e8bc5606025d797$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$2e8bc5606025d797$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $2e8bc5606025d797$var$_construct(Class, arguments, $2e8bc5606025d797$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $2e8bc5606025d797$var$_setPrototypeOf(Wrapper, Class);
    };
    return $2e8bc5606025d797$var$_wrapNativeSuper(Class);
}
function $2e8bc5606025d797$var$_construct(Parent, args, Class) {
    if ($2e8bc5606025d797$var$_isNativeReflectConstruct()) $2e8bc5606025d797$var$_construct = Reflect.construct.bind();
    else $2e8bc5606025d797$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $2e8bc5606025d797$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $2e8bc5606025d797$var$_construct.apply(null, arguments);
}
function $2e8bc5606025d797$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $2e8bc5606025d797$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $2e8bc5606025d797$var$_setPrototypeOf(o, p) {
    $2e8bc5606025d797$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2e8bc5606025d797$var$_setPrototypeOf(o, p);
}
function $2e8bc5606025d797$var$_getPrototypeOf(o) {
    $2e8bc5606025d797$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2e8bc5606025d797$var$_getPrototypeOf(o);
}
function $2e8bc5606025d797$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2e8bc5606025d797$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2e8bc5606025d797$var$_typeof(o);
}

var $9kAQu = parcelRequire("9kAQu");
var $2e8bc5606025d797$var$inspect = $9kAQu.inspect;

var $8JAro = parcelRequire("8JAro");
var $2e8bc5606025d797$var$ERR_INVALID_ARG_TYPE = $8JAro.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $2e8bc5606025d797$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $2e8bc5606025d797$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $2e8bc5606025d797$var$blue = '';
var $2e8bc5606025d797$var$green = '';
var $2e8bc5606025d797$var$red = '';
var $2e8bc5606025d797$var$white = '';
var $2e8bc5606025d797$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $2e8bc5606025d797$var$kMaxShortLength = 10;
function $2e8bc5606025d797$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $2e8bc5606025d797$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $2e8bc5606025d797$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $2e8bc5606025d797$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $2e8bc5606025d797$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $2e8bc5606025d797$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $2e8bc5606025d797$var$_typeof(actual) === 'object' && $2e8bc5606025d797$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $2e8bc5606025d797$var$kMaxShortLength) {
            if (($2e8bc5606025d797$var$_typeof(actual) !== 'object' || actual === null) && ($2e8bc5606025d797$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($2e8bc5606025d797$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $6cAn5.stderr && $6cAn5.stderr.isTTY ? $6cAn5.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($2e8bc5606025d797$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($2e8bc5606025d797$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $2e8bc5606025d797$var$kReadableOperator[operator] + "\n".concat($2e8bc5606025d797$var$green, "+ actual").concat($2e8bc5606025d797$var$white, " ").concat($2e8bc5606025d797$var$red, "- expected").concat($2e8bc5606025d797$var$white);
    var skippedMsg = " ".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($2e8bc5606025d797$var$red, "-").concat($2e8bc5606025d797$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($2e8bc5606025d797$var$green, "+").concat($2e8bc5606025d797$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$2e8bc5606025d797$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $2e8bc5606025d797$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($2e8bc5606025d797$var$green, "+").concat($2e8bc5606025d797$var$white, " ").concat(actualLine);
                other += "\n".concat($2e8bc5606025d797$var$red, "-").concat($2e8bc5606025d797$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white).concat(other, "\n") + "".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $2e8bc5606025d797$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $2e8bc5606025d797$var$_inherits(AssertionError, _Error);
    var _super = $2e8bc5606025d797$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $2e8bc5606025d797$var$_classCallCheck(this, AssertionError);
        if ($2e8bc5606025d797$var$_typeof(options) !== 'object' || options === null) throw new $2e8bc5606025d797$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($6cAn5.stderr && $6cAn5.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($6cAn5.stderr && $6cAn5.stderr.getColorDepth && $6cAn5.stderr.getColorDepth() !== 1) {
                    $2e8bc5606025d797$var$blue = "\x1B[34m";
                    $2e8bc5606025d797$var$green = "\x1B[32m";
                    $2e8bc5606025d797$var$white = "\x1B[39m";
                    $2e8bc5606025d797$var$red = "\x1B[31m";
                } else {
                    $2e8bc5606025d797$var$blue = '';
                    $2e8bc5606025d797$var$green = '';
                    $2e8bc5606025d797$var$white = '';
                    $2e8bc5606025d797$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($2e8bc5606025d797$var$_typeof(actual) === 'object' && actual !== null && $2e8bc5606025d797$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $2e8bc5606025d797$var$copyError(actual);
                expected = $2e8bc5606025d797$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $2e8bc5606025d797$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $2e8bc5606025d797$var$kReadableOperator[operator];
                var res = $2e8bc5606025d797$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $2e8bc5606025d797$var$_typeof(actual) === 'object' && actual !== null) base = $2e8bc5606025d797$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $2e8bc5606025d797$var$inspectValue(actual);
                var other = '';
                var knownOperators = $2e8bc5606025d797$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($2e8bc5606025d797$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($2e8bc5606025d797$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($2e8bc5606025d797$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($2e8bc5606025d797$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $2e8bc5606025d797$var$_possibleConstructorReturn(_this);
    }
    $2e8bc5606025d797$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $2e8bc5606025d797$var$inspect(this, $2e8bc5606025d797$var$_objectSpread($2e8bc5606025d797$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $2e8bc5606025d797$var$_wrapNativeSuper(Error), $2e8bc5606025d797$var$inspect.custom);
module.exports = $2e8bc5606025d797$var$AssertionError;

});

parcelRegister("8s5ew", function(module, exports) {
'use strict';

var $3WQC3 = parcelRequire("3WQC3");
var $0196883fce51d67b$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $0196883fce51d67b$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $3WQC3;
    if ($0196883fce51d67b$var$lacksProperEnumerationOrder()) return $3WQC3;
    if ($0196883fce51d67b$var$assignHasPendingExceptions()) return $3WQC3;
    return Object.assign;
};

});
parcelRegister("3WQC3", function(module, exports) {
'use strict';

var $dZMWQ = parcelRequire("dZMWQ");

var $2dff99ad8985d37e$var$hasSymbols = (parcelRequire("9T9x9"))();

var $3T2jo = parcelRequire("3T2jo");

var $hVuCj = parcelRequire("hVuCj");
var $2dff99ad8985d37e$var$$push = $3T2jo('Array.prototype.push');
var $2dff99ad8985d37e$var$$propIsEnumerable = $3T2jo('Object.prototype.propertyIsEnumerable');
var $2dff99ad8985d37e$var$originalGetSymbols = $2dff99ad8985d37e$var$hasSymbols ? $hVuCj.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $hVuCj(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $hVuCj(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $dZMWQ(from);
        var getSymbols = $2dff99ad8985d37e$var$hasSymbols && ($hVuCj.getOwnPropertySymbols || $2dff99ad8985d37e$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($2dff99ad8985d37e$var$$propIsEnumerable(from, key)) $2dff99ad8985d37e$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($2dff99ad8985d37e$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("dZMWQ", function(module, exports) {
'use strict';
var $a306f0f1bb5f232a$var$slice = Array.prototype.slice;

var $1Houy = parcelRequire("1Houy");
var $a306f0f1bb5f232a$var$origKeys = Object.keys;

var $a306f0f1bb5f232a$var$keysShim = $a306f0f1bb5f232a$var$origKeys ? function keys(o) {
    return $a306f0f1bb5f232a$var$origKeys(o);
} : (parcelRequire("eQVXL"));
var $a306f0f1bb5f232a$var$originalKeys = Object.keys;
$a306f0f1bb5f232a$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($1Houy(object)) return $a306f0f1bb5f232a$var$originalKeys($a306f0f1bb5f232a$var$slice.call(object));
            return $a306f0f1bb5f232a$var$originalKeys(object);
        };
    } else Object.keys = $a306f0f1bb5f232a$var$keysShim;
    return Object.keys || $a306f0f1bb5f232a$var$keysShim;
};
module.exports = $a306f0f1bb5f232a$var$keysShim;

});
parcelRegister("1Houy", function(module, exports) {
'use strict';
var $13ccce2fa6936c75$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $13ccce2fa6936c75$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $13ccce2fa6936c75$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("eQVXL", function(module, exports) {
'use strict';
var $ad02e23a59d3730f$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $ad02e23a59d3730f$var$has = Object.prototype.hasOwnProperty;
    var $ad02e23a59d3730f$var$toStr = Object.prototype.toString;
    var $ad02e23a59d3730f$var$isArgs = (parcelRequire("1Houy")); // eslint-disable-line global-require
    var $ad02e23a59d3730f$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $ad02e23a59d3730f$var$hasDontEnumBug = !$ad02e23a59d3730f$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $ad02e23a59d3730f$var$hasProtoEnumBug = $ad02e23a59d3730f$var$isEnumerable.call(function() {}, 'prototype');
    var $ad02e23a59d3730f$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $ad02e23a59d3730f$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $ad02e23a59d3730f$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $ad02e23a59d3730f$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$ad02e23a59d3730f$var$excludedKeys['$' + k] && $ad02e23a59d3730f$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $ad02e23a59d3730f$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $ad02e23a59d3730f$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$ad02e23a59d3730f$var$hasAutomationEqualityBug) return $ad02e23a59d3730f$var$equalsConstructorPrototype(o);
        try {
            return $ad02e23a59d3730f$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $ad02e23a59d3730f$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $ad02e23a59d3730f$var$toStr.call(object) === '[object Function]';
        var isArguments = $ad02e23a59d3730f$var$isArgs(object);
        var isString = isObject && $ad02e23a59d3730f$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $ad02e23a59d3730f$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$ad02e23a59d3730f$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $ad02e23a59d3730f$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($ad02e23a59d3730f$var$hasDontEnumBug) {
            var skipConstructor = $ad02e23a59d3730f$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $ad02e23a59d3730f$var$dontEnums.length; ++k)if (!(skipConstructor && $ad02e23a59d3730f$var$dontEnums[k] === 'constructor') && $ad02e23a59d3730f$var$has.call(object, $ad02e23a59d3730f$var$dontEnums[k])) theKeys.push($ad02e23a59d3730f$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $ad02e23a59d3730f$var$keysShim;

});




parcelRegister("eJazH", function(module, exports) {
'use strict';

var $iwNFM = parcelRequire("iwNFM");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $iwNFM;
};

});
parcelRegister("iwNFM", function(module, exports) {
'use strict';
var $d7d1bf25ec690182$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($d7d1bf25ec690182$var$numberIsNaN(a) && $d7d1bf25ec690182$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("dztjv", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $9e15485748de85e6$var$_slicedToArray(arr, i) {
    return $9e15485748de85e6$var$_arrayWithHoles(arr) || $9e15485748de85e6$var$_iterableToArrayLimit(arr, i) || $9e15485748de85e6$var$_unsupportedIterableToArray(arr, i) || $9e15485748de85e6$var$_nonIterableRest();
}
function $9e15485748de85e6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9e15485748de85e6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9e15485748de85e6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9e15485748de85e6$var$_arrayLikeToArray(o, minLen);
}
function $9e15485748de85e6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9e15485748de85e6$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $9e15485748de85e6$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9e15485748de85e6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9e15485748de85e6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9e15485748de85e6$var$_typeof(o);
}
var $9e15485748de85e6$var$regexFlagsSupported = /a/g.flags !== undefined;
var $9e15485748de85e6$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $9e15485748de85e6$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $9e15485748de85e6$var$objectIs = Object.is ? Object.is : (parcelRequire("joK88"));
var $9e15485748de85e6$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $9e15485748de85e6$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("laO4W"));
function $9e15485748de85e6$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $9e15485748de85e6$var$hasOwnProperty = $9e15485748de85e6$var$uncurryThis(Object.prototype.hasOwnProperty);
var $9e15485748de85e6$var$propertyIsEnumerable = $9e15485748de85e6$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $9e15485748de85e6$var$objectToString = $9e15485748de85e6$var$uncurryThis(Object.prototype.toString);

var $9kAQu = parcelRequire("9kAQu");
var $9e15485748de85e6$require$_require$types = $9kAQu.types;
var $9e15485748de85e6$var$isAnyArrayBuffer = $9e15485748de85e6$require$_require$types.isAnyArrayBuffer, $9e15485748de85e6$var$isArrayBufferView = $9e15485748de85e6$require$_require$types.isArrayBufferView, $9e15485748de85e6$var$isDate = $9e15485748de85e6$require$_require$types.isDate, $9e15485748de85e6$var$isMap = $9e15485748de85e6$require$_require$types.isMap, $9e15485748de85e6$var$isRegExp = $9e15485748de85e6$require$_require$types.isRegExp, $9e15485748de85e6$var$isSet = $9e15485748de85e6$require$_require$types.isSet, $9e15485748de85e6$var$isNativeError = $9e15485748de85e6$require$_require$types.isNativeError, $9e15485748de85e6$var$isBoxedPrimitive = $9e15485748de85e6$require$_require$types.isBoxedPrimitive, $9e15485748de85e6$var$isNumberObject = $9e15485748de85e6$require$_require$types.isNumberObject, $9e15485748de85e6$var$isStringObject = $9e15485748de85e6$require$_require$types.isStringObject, $9e15485748de85e6$var$isBooleanObject = $9e15485748de85e6$require$_require$types.isBooleanObject, $9e15485748de85e6$var$isBigIntObject = $9e15485748de85e6$require$_require$types.isBigIntObject, $9e15485748de85e6$var$isSymbolObject = $9e15485748de85e6$require$_require$types.isSymbolObject, $9e15485748de85e6$var$isFloat32Array = $9e15485748de85e6$require$_require$types.isFloat32Array, $9e15485748de85e6$var$isFloat64Array = $9e15485748de85e6$require$_require$types.isFloat64Array;
function $9e15485748de85e6$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $9e15485748de85e6$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($9e15485748de85e6$var$isNonIndex).concat($9e15485748de85e6$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $9e15485748de85e6$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $9e15485748de85e6$var$ONLY_ENUMERABLE = undefined;
var $9e15485748de85e6$var$kStrict = true;
var $9e15485748de85e6$var$kLoose = false;
var $9e15485748de85e6$var$kNoIterator = 0;
var $9e15485748de85e6$var$kIsArray = 1;
var $9e15485748de85e6$var$kIsSet = 2;
var $9e15485748de85e6$var$kIsMap = 3;
// Check if they have the same source and flags
function $9e15485748de85e6$var$areSimilarRegExps(a, b) {
    return $9e15485748de85e6$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $9e15485748de85e6$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $9e15485748de85e6$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $9e15485748de85e6$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $9e15485748de85e6$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $9e15485748de85e6$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $9e15485748de85e6$var$isEqualBoxedPrimitive(val1, val2) {
    if ($9e15485748de85e6$var$isNumberObject(val1)) return $9e15485748de85e6$var$isNumberObject(val2) && $9e15485748de85e6$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($9e15485748de85e6$var$isStringObject(val1)) return $9e15485748de85e6$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($9e15485748de85e6$var$isBooleanObject(val1)) return $9e15485748de85e6$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($9e15485748de85e6$var$isBigIntObject(val1)) return $9e15485748de85e6$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $9e15485748de85e6$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $9e15485748de85e6$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $9e15485748de85e6$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($9e15485748de85e6$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $9e15485748de85e6$var$numberIsNaN(val1) && $9e15485748de85e6$var$numberIsNaN(val2);
        if ($9e15485748de85e6$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $9e15485748de85e6$var$_typeof(val1) !== 'object') {
            if (val2 === null || $9e15485748de85e6$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $9e15485748de85e6$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $9e15485748de85e6$var$objectToString(val1);
    var val2Tag = $9e15485748de85e6$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $9e15485748de85e6$var$getOwnNonIndexProperties(val1, $9e15485748de85e6$var$ONLY_ENUMERABLE);
        var keys2 = $9e15485748de85e6$var$getOwnNonIndexProperties(val2, $9e15485748de85e6$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$9e15485748de85e6$var$isMap(val1) && $9e15485748de85e6$var$isMap(val2) || !$9e15485748de85e6$var$isSet(val1) && $9e15485748de85e6$var$isSet(val2)) return false;
    }
    if ($9e15485748de85e6$var$isDate(val1)) {
        if (!$9e15485748de85e6$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($9e15485748de85e6$var$isRegExp(val1)) {
        if (!$9e15485748de85e6$var$isRegExp(val2) || !$9e15485748de85e6$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($9e15485748de85e6$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($9e15485748de85e6$var$isArrayBufferView(val1)) {
        if (!strict && ($9e15485748de85e6$var$isFloat32Array(val1) || $9e15485748de85e6$var$isFloat64Array(val1))) {
            if (!$9e15485748de85e6$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$9e15485748de85e6$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $9e15485748de85e6$var$getOwnNonIndexProperties(val1, $9e15485748de85e6$var$ONLY_ENUMERABLE);
        var _keys2 = $9e15485748de85e6$var$getOwnNonIndexProperties(val2, $9e15485748de85e6$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kNoIterator, _keys);
    } else if ($9e15485748de85e6$var$isSet(val1)) {
        if (!$9e15485748de85e6$var$isSet(val2) || val1.size !== val2.size) return false;
        return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kIsSet);
    } else if ($9e15485748de85e6$var$isMap(val1)) {
        if (!$9e15485748de85e6$var$isMap(val2) || val1.size !== val2.size) return false;
        return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kIsMap);
    } else if ($9e15485748de85e6$var$isAnyArrayBuffer(val1)) {
        if (!$9e15485748de85e6$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($9e15485748de85e6$var$isBoxedPrimitive(val1) && !$9e15485748de85e6$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kNoIterator);
}
function $9e15485748de85e6$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $9e15485748de85e6$var$propertyIsEnumerable(val, k);
    });
}
function $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$9e15485748de85e6$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $9e15485748de85e6$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($9e15485748de85e6$var$propertyIsEnumerable(val1, key)) {
                    if (!$9e15485748de85e6$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($9e15485748de85e6$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $9e15485748de85e6$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $9e15485748de85e6$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $9e15485748de85e6$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $9e15485748de85e6$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $9e15485748de85e6$var$kNoIterator || iterationType === $9e15485748de85e6$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $9e15485748de85e6$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $9e15485748de85e6$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $9e15485748de85e6$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($9e15485748de85e6$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $9e15485748de85e6$var$findLooseMatchingPrimitives(prim) {
    switch($9e15485748de85e6$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($9e15485748de85e6$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $9e15485748de85e6$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $9e15485748de85e6$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $9e15485748de85e6$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $9e15485748de85e6$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$9e15485748de85e6$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $9e15485748de85e6$var$innerDeepEqual(item, curB, false, memo);
}
function $9e15485748de85e6$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $9e15485748de85e6$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($9e15485748de85e6$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$9e15485748de85e6$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $9e15485748de85e6$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($9e15485748de85e6$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$9e15485748de85e6$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$9e15485748de85e6$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $9e15485748de85e6$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $9e15485748de85e6$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($9e15485748de85e6$var$innerDeepEqual(key1, key2, strict, memo) && $9e15485748de85e6$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $9e15485748de85e6$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $9e15485748de85e6$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $9e15485748de85e6$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($9e15485748de85e6$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$9e15485748de85e6$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$9e15485748de85e6$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $9e15485748de85e6$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $9e15485748de85e6$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($9e15485748de85e6$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$9e15485748de85e6$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$9e15485748de85e6$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$9e15485748de85e6$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $9e15485748de85e6$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $9e15485748de85e6$var$kIsSet) {
        if (!$9e15485748de85e6$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $9e15485748de85e6$var$kIsMap) {
        if (!$9e15485748de85e6$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $9e15485748de85e6$var$kIsArray) for(; i < a.length; i++){
        if ($9e15485748de85e6$var$hasOwnProperty(a, i)) {
            if (!$9e15485748de85e6$var$hasOwnProperty(b, i) || !$9e15485748de85e6$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($9e15485748de85e6$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$9e15485748de85e6$var$hasOwnProperty(b, key) || !$9e15485748de85e6$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$9e15485748de85e6$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $9e15485748de85e6$var$isDeepEqual(val1, val2) {
    return $9e15485748de85e6$var$innerDeepEqual(val1, val2, $9e15485748de85e6$var$kLoose);
}
function $9e15485748de85e6$var$isDeepStrictEqual(val1, val2) {
    return $9e15485748de85e6$var$innerDeepEqual(val1, val2, $9e15485748de85e6$var$kStrict);
}
module.exports = {
    isDeepEqual: $9e15485748de85e6$var$isDeepEqual,
    isDeepStrictEqual: $9e15485748de85e6$var$isDeepStrictEqual
};

});
parcelRegister("joK88", function(module, exports) {
'use strict';

var $d94D2 = parcelRequire("d94D2");

var $h05ZS = parcelRequire("h05ZS");

var $iwNFM = parcelRequire("iwNFM");

var $eJazH = parcelRequire("eJazH");

var $90RaO = parcelRequire("90RaO");
var $e1f40ab7009ea590$var$polyfill = $h05ZS($eJazH(), Object);
$d94D2($e1f40ab7009ea590$var$polyfill, {
    getPolyfill: $eJazH,
    implementation: $iwNFM,
    shim: $90RaO
});
module.exports = $e1f40ab7009ea590$var$polyfill;

});
parcelRegister("d94D2", function(module, exports) {
'use strict';

var $dZMWQ = parcelRequire("dZMWQ");
var $991fb4ca00f3da54$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $991fb4ca00f3da54$var$toStr = Object.prototype.toString;
var $991fb4ca00f3da54$var$concat = Array.prototype.concat;

var $le88V = parcelRequire("le88V");
var $991fb4ca00f3da54$var$isFunction = function(fn) {
    return typeof fn === 'function' && $991fb4ca00f3da54$var$toStr.call(fn) === '[object Function]';
};

var $991fb4ca00f3da54$var$supportsDescriptors = (parcelRequire("9lmlE"))();
var $991fb4ca00f3da54$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$991fb4ca00f3da54$var$isFunction(predicate) || !predicate()) return;
    }
    if ($991fb4ca00f3da54$var$supportsDescriptors) $le88V(object, name, value, true);
    else $le88V(object, name, value);
};
var $991fb4ca00f3da54$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $dZMWQ(map);
    if ($991fb4ca00f3da54$var$hasSymbols) props = $991fb4ca00f3da54$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$991fb4ca00f3da54$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$991fb4ca00f3da54$var$defineProperties.supportsDescriptors = !!$991fb4ca00f3da54$var$supportsDescriptors;
module.exports = $991fb4ca00f3da54$var$defineProperties;

});

parcelRegister("90RaO", function(module, exports) {
'use strict';

var $eJazH = parcelRequire("eJazH");

var $d94D2 = parcelRequire("d94D2");
module.exports = function shimObjectIs() {
    var polyfill = $eJazH();
    $d94D2(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("laO4W", function(module, exports) {
'use strict';

var $h05ZS = parcelRequire("h05ZS");

var $d94D2 = parcelRequire("d94D2");

var $hdPWo = parcelRequire("hdPWo");

var $gmOnv = parcelRequire("gmOnv");

var $hXuHX = parcelRequire("hXuHX");
var $f6a160b687432d3b$var$polyfill = $h05ZS($gmOnv(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $d94D2($f6a160b687432d3b$var$polyfill, {
    getPolyfill: $gmOnv,
    implementation: $hdPWo,
    shim: $hXuHX
});
module.exports = $f6a160b687432d3b$var$polyfill;

});
parcelRegister("hdPWo", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("gmOnv", function(module, exports) {
'use strict';

var $hdPWo = parcelRequire("hdPWo");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $hdPWo;
};

});

parcelRegister("hXuHX", function(module, exports) {
'use strict';

var $d94D2 = parcelRequire("d94D2");

var $gmOnv = parcelRequire("gmOnv");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $gmOnv();
    $d94D2(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("d6D31", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SuppressWarnings = module.exports.Override = module.exports.Nullable = module.exports.NotNull = void 0;
function $98aa1ff32ce30be5$var$NotNull(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.NotNull = $98aa1ff32ce30be5$var$NotNull;
function $98aa1ff32ce30be5$var$Nullable(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.Nullable = $98aa1ff32ce30be5$var$Nullable;
function $98aa1ff32ce30be5$var$Override(target, propertyKey, propertyDescriptor) {
// do something with 'target' ...
}
module.exports.Override = $98aa1ff32ce30be5$var$Override;
function $98aa1ff32ce30be5$var$SuppressWarnings(options) {
    return (target, propertyKey, descriptor)=>{
    // intentionally empty
    };
}
module.exports.SuppressWarnings = $98aa1ff32ce30be5$var$SuppressWarnings;

});

parcelRegister("ceaEj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntStream = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.6934376-07:00
var $8e6f0d8930cd60b2$var$IntStream;
(function(IntStream) {
    /**
     * The value returned by {@link #LA LA()} when the end of the stream is
     * reached.
     */ IntStream.EOF = -1;
    /**
     * The value returned by {@link #getSourceName} when the actual name of the
     * underlying source is not known.
     */ IntStream.UNKNOWN_SOURCE_NAME = "<unknown>";
})($8e6f0d8930cd60b2$var$IntStream = module.exports.IntStream || (module.exports.IntStream = {}));

});


parcelRegister("b0kN8", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $802fd28fa76a2f4f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BailErrorStrategy = void 0;

var $4CCJj = parcelRequire("4CCJj");

var $iLUMi = parcelRequire("iLUMi");

var $d6D31 = parcelRequire("d6D31");

var $3kXUy = parcelRequire("3kXUy");
/**
 * This implementation of {@link ANTLRErrorStrategy} responds to syntax errors
 * by immediately canceling the parse operation with a
 * {@link ParseCancellationException}. The implementation ensures that the
 * {@link ParserRuleContext#exception} field is set for all parse tree nodes
 * that were not completed prior to encountering the error.
 *
 * This error strategy is useful in the following scenarios.
 *
 * * **Two-stage parsing:** This error strategy allows the first
 *   stage of two-stage parsing to immediately terminate if an error is
 *   encountered, and immediately fall back to the second stage. In addition to
 *   avoiding wasted work by attempting to recover from errors here, the empty
 *   implementation of {@link BailErrorStrategy#sync} improves the performance of
 *   the first stage.
 * * **Silent validation:** When syntax errors are not being
 *   reported or logged, and the parse result is simply ignored if errors occur,
 *   the {@link BailErrorStrategy} avoids wasting work on recovering from errors
 *   when the result will be ignored either way.
 *
 * ```
 * myparser.errorHandler = new BailErrorStrategy();
 * ```
 *
 * @see Parser.errorHandler
 */ class $802fd28fa76a2f4f$var$BailErrorStrategy extends $4CCJj.DefaultErrorStrategy {
    /** Instead of recovering from exception `e`, re-throw it wrapped
     *  in a {@link ParseCancellationException} so it is not caught by the
     *  rule function catches.  Use {@link Exception#getCause()} to get the
     *  original {@link RecognitionException}.
     */ recover(recognizer, e) {
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $3kXUy.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover inline; if the parser
     *  successfully recovers, it won't throw an exception.
     */ recoverInline(recognizer) {
        let e = new $iLUMi.InputMismatchException(recognizer);
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $3kXUy.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover from problems in subrules. */ sync(recognizer) {
    // intentionally empty
    }
}
$802fd28fa76a2f4f$var$__decorate([
    $d6D31.Override
], $802fd28fa76a2f4f$var$BailErrorStrategy.prototype, "recover", null);
$802fd28fa76a2f4f$var$__decorate([
    $d6D31.Override
], $802fd28fa76a2f4f$var$BailErrorStrategy.prototype, "recoverInline", null);
$802fd28fa76a2f4f$var$__decorate([
    $d6D31.Override
], $802fd28fa76a2f4f$var$BailErrorStrategy.prototype, "sync", null);
module.exports.BailErrorStrategy = $802fd28fa76a2f4f$var$BailErrorStrategy;

});
parcelRegister("4CCJj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $35d8c0fbab48edc4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $35d8c0fbab48edc4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultErrorStrategy = void 0;

var $7j0Pc = parcelRequire("7j0Pc");

var $1bs3X = parcelRequire("1bs3X");

var $ea0YW = parcelRequire("ea0YW");

var $iLUMi = parcelRequire("iLUMi");

var $hGRod = parcelRequire("hGRod");

var $hKCjP = parcelRequire("hKCjP");

var $8DTT0 = parcelRequire("8DTT0");

var $2DVsz = parcelRequire("2DVsz");

var $d6D31 = parcelRequire("d6D31");
/**
 * This is the default implementation of {@link ANTLRErrorStrategy} used for
 * error reporting and recovery in ANTLR parsers.
 */ class $35d8c0fbab48edc4$var$DefaultErrorStrategy {
    constructor(){
        /**
         * Indicates whether the error strategy is currently "recovering from an
         * error". This is used to suppress reporting multiple error messages while
         * attempting to recover from a detected syntax error.
         *
         * @see #inErrorRecoveryMode
         */ this.errorRecoveryMode = false;
        /** The index into the input stream where the last error occurred.
         * 	This is used to prevent infinite loops where an error is found
         *  but no token is consumed during recovery...another error is found,
         *  ad nauseum.  This is a failsafe mechanism to guarantee that at least
         *  one token/tree node is consumed for two errors.
         */ this.lastErrorIndex = -1;
        /**
         * @see #nextTokensContext
         */ this.nextTokensState = $7j0Pc.ATNState.INVALID_STATE_NUMBER;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition} to
     * ensure that the handler is not in error recovery mode.
     */ reset(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * This method is called to enter error recovery mode when a recognition
     * exception is reported.
     *
     * @param recognizer the parser instance
     */ beginErrorCondition(recognizer) {
        this.errorRecoveryMode = true;
    }
    /**
     * {@inheritDoc}
     */ inErrorRecoveryMode(recognizer) {
        return this.errorRecoveryMode;
    }
    /**
     * This method is called to leave error recovery mode after recovering from
     * a recognition exception.
     *
     * @param recognizer
     */ endErrorCondition(recognizer) {
        this.errorRecoveryMode = false;
        this.lastErrorStates = undefined;
        this.lastErrorIndex = -1;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition}.
     */ reportMatch(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation returns immediately if the handler is already
     * in error recovery mode. Otherwise, it calls {@link #beginErrorCondition}
     * and dispatches the reporting task based on the runtime type of `e`
     * according to the following table.
     *
     * * {@link NoViableAltException}: Dispatches the call to
     *   {@link #reportNoViableAlternative}
     * * {@link InputMismatchException}: Dispatches the call to
     *   {@link #reportInputMismatch}
     * * {@link FailedPredicateException}: Dispatches the call to
     *   {@link #reportFailedPredicate}
     * * All other types: calls {@link Parser#notifyErrorListeners} to report
     *   the exception
     */ reportError(recognizer, e) {
        // if we've already reported an error and have not matched a token
        // yet successfully, don't report any errors.
        if (this.inErrorRecoveryMode(recognizer)) //			System.err.print("[SPURIOUS] ");
        return; // don't report spurious errors
        this.beginErrorCondition(recognizer);
        if (e instanceof $hKCjP.NoViableAltException) this.reportNoViableAlternative(recognizer, e);
        else if (e instanceof $iLUMi.InputMismatchException) this.reportInputMismatch(recognizer, e);
        else if (e instanceof $ea0YW.FailedPredicateException) this.reportFailedPredicate(recognizer, e);
        else {
            console.error(`unknown recognition error type: ${e}`);
            this.notifyErrorListeners(recognizer, e.toString(), e);
        }
    }
    notifyErrorListeners(recognizer, message, e) {
        let offendingToken = e.getOffendingToken(recognizer);
        if (offendingToken === undefined) // Pass null to notifyErrorListeners so it in turn calls the error listeners with undefined as the offending
        // token. If we passed undefined, it would instead call the listeners with currentToken from the parser.
        offendingToken = null;
        recognizer.notifyErrorListeners(message, offendingToken, e);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation resynchronizes the parser by consuming tokens
     * until we find one in the resynchronization set--loosely the set of tokens
     * that can follow the current rule.
     */ recover(recognizer, e) {
        //		System.out.println("recover in "+recognizer.getRuleInvocationStack()+
        //						   " index="+recognizer.inputStream.index+
        //						   ", lastErrorIndex="+
        //						   lastErrorIndex+
        //						   ", states="+lastErrorStates);
        if (this.lastErrorIndex === recognizer.inputStream.index && this.lastErrorStates && this.lastErrorStates.contains(recognizer.state)) // uh oh, another error at same token index and previously-visited
        // state in ATN; must be a case where LT(1) is in the recovery
        // token set so nothing got consumed. Consume a single token
        // at least to prevent an infinite loop; this is a failsafe.
        //			System.err.println("seen error condition before index="+
        //							   lastErrorIndex+", states="+lastErrorStates);
        //			System.err.println("FAILSAFE consumes "+recognizer.getTokenNames()[recognizer.inputStream.LA(1)]);
        recognizer.consume();
        this.lastErrorIndex = recognizer.inputStream.index;
        if (!this.lastErrorStates) this.lastErrorStates = new $hGRod.IntervalSet();
        this.lastErrorStates.add(recognizer.state);
        let followSet = this.getErrorRecoverySet(recognizer);
        this.consumeUntil(recognizer, followSet);
    }
    /**
     * The default implementation of {@link ANTLRErrorStrategy#sync} makes sure
     * that the current lookahead symbol is consistent with what were expecting
     * at this point in the ATN. You can call this anytime but ANTLR only
     * generates code to check before subrules/loops and each iteration.
     *
     * Implements Jim Idle's magic sync mechanism in closures and optional
     * subrules. E.g.,
     *
     * ```antlr
     * a : sync ( stuff sync )* ;
     * sync : {consume to what can follow sync} ;
     * ```
     *
     * At the start of a sub rule upon error, {@link #sync} performs single
     * token deletion, if possible. If it can't do that, it bails on the current
     * rule and uses the default error recovery, which consumes until the
     * resynchronization set of the current rule.
     *
     * If the sub rule is optional (`(...)?`, `(...)*`, or block
     * with an empty alternative), then the expected set includes what follows
     * the subrule.
     *
     * During loop iteration, it consumes until it sees a token that can start a
     * sub rule or what follows loop. Yes, that is pretty aggressive. We opt to
     * stay in the loop as long as possible.
     *
     * **ORIGINS**
     *
     * Previous versions of ANTLR did a poor job of their recovery within loops.
     * A single mismatch token or missing token would force the parser to bail
     * out of the entire rules surrounding the loop. So, for rule
     *
     * ```antlr
     * classDef : 'class' ID '{' member* '}'
     * ```
     *
     * input with an extra token between members would force the parser to
     * consume until it found the next class definition rather than the next
     * member definition of the current class.
     *
     * This functionality cost a little bit of effort because the parser has to
     * compare token set at the start of the loop and at each iteration. If for
     * some reason speed is suffering for you, you can turn off this
     * functionality by simply overriding this method as a blank { }.
     */ sync(recognizer) {
        let s = recognizer.interpreter.atn.states[recognizer.state];
        //		System.err.println("sync @ "+s.stateNumber+"="+s.getClass().getSimpleName());
        // If already recovering, don't try to sync
        if (this.inErrorRecoveryMode(recognizer)) return;
        let tokens = recognizer.inputStream;
        let la = tokens.LA(1);
        // try cheaper subset first; might get lucky. seems to shave a wee bit off
        let nextTokens = recognizer.atn.nextTokens(s);
        if (nextTokens.contains(la)) {
            // We are sure the token matches
            this.nextTokensContext = undefined;
            this.nextTokensState = $7j0Pc.ATNState.INVALID_STATE_NUMBER;
            return;
        }
        if (nextTokens.contains($2DVsz.Token.EPSILON)) {
            if (this.nextTokensContext === undefined) {
                // It's possible the next token won't match; information tracked
                // by sync is restricted for performance.
                this.nextTokensContext = recognizer.context;
                this.nextTokensState = recognizer.state;
            }
            return;
        }
        switch(s.stateType){
            case $1bs3X.ATNStateType.BLOCK_START:
            case $1bs3X.ATNStateType.STAR_BLOCK_START:
            case $1bs3X.ATNStateType.PLUS_BLOCK_START:
            case $1bs3X.ATNStateType.STAR_LOOP_ENTRY:
                // report error and recover if possible
                if (this.singleTokenDeletion(recognizer)) return;
                throw new $iLUMi.InputMismatchException(recognizer);
            case $1bs3X.ATNStateType.PLUS_LOOP_BACK:
            case $1bs3X.ATNStateType.STAR_LOOP_BACK:
                //			System.err.println("at loop back: "+s.getClass().getSimpleName());
                this.reportUnwantedToken(recognizer);
                let expecting = recognizer.getExpectedTokens();
                let whatFollowsLoopIterationOrRule = expecting.or(this.getErrorRecoverySet(recognizer));
                this.consumeUntil(recognizer, whatFollowsLoopIterationOrRule);
                break;
            default:
                break;
        }
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link NoViableAltException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportNoViableAlternative(recognizer, e) {
        let tokens = recognizer.inputStream;
        let input;
        if (tokens) {
            if (e.startToken.type === $2DVsz.Token.EOF) input = "<EOF>";
            else input = tokens.getTextFromRange(e.startToken, e.getOffendingToken());
        } else input = "<unknown input>";
        let msg = "no viable alternative at input " + this.escapeWSAndQuote(input);
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is an
     * {@link InputMismatchException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportInputMismatch(recognizer, e) {
        let expected = e.expectedTokens;
        let expectedString = expected ? expected.toStringVocabulary(recognizer.vocabulary) : "";
        let msg = "mismatched input " + this.getTokenErrorDisplay(e.getOffendingToken(recognizer)) + " expecting " + expectedString;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link FailedPredicateException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportFailedPredicate(recognizer, e) {
        let ruleName = recognizer.ruleNames[recognizer.context.ruleIndex];
        let msg = "rule " + ruleName + " " + e.message;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This method is called to report a syntax error which requires the removal
     * of a token from the input stream. At the time this method is called, the
     * erroneous symbol is current `LT(1)` symbol and has not yet been
     * removed from the input stream. When this method returns,
     * `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenDeletion} identifies
     * single-token deletion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportUnwantedToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let tokenName = this.getTokenErrorDisplay(t);
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "extraneous input " + tokenName + " expecting " + expecting.toStringVocabulary(recognizer.vocabulary);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * This method is called to report a syntax error which requires the
     * insertion of a missing token into the input stream. At the time this
     * method is called, the missing token has not yet been inserted. When this
     * method returns, `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenInsertion} identifies
     * single-token insertion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportMissingToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "missing " + expecting.toStringVocabulary(recognizer.vocabulary) + " at " + this.getTokenErrorDisplay(t);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation attempts to recover from the mismatched input
     * by using single token insertion and deletion as described below. If the
     * recovery attempt fails, this method
     * {@link InputMismatchException}.
     *
     * **EXTRA TOKEN** (single token deletion)
     *
     * `LA(1)` is not what we are looking for. If `LA(2)` has the
     * right token, however, then assume `LA(1)` is some extra spurious
     * token and delete it. Then consume and return the next token (which was
     * the `LA(2)` token) as the successful result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenDeletion}.
     *
     * **MISSING TOKEN** (single token insertion)
     *
     * If current token (at `LA(1)`) is consistent with what could come
     * after the expected `LA(1)` token, then assume the token is missing
     * and use the parser's {@link TokenFactory} to create it on the fly. The
     * "insertion" is performed by returning the created token as the successful
     * result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenInsertion}.
     *
     * **EXAMPLE**
     *
     * For example, Input `i=(3;` is clearly missing the `')'`. When
     * the parser returns from the nested call to `expr`, it will have
     * call chain:
     *
     * ```
     * stat → expr → atom
     * ```
     *
     * and it will be trying to match the `')'` at this point in the
     * derivation:
     *
     * ```
     * => ID '=' '(' INT ')' ('+' atom)* ';'
     *                    ^
     * ```
     *
     * The attempt to match `')'` will fail when it sees `';'` and
     * call {@link #recoverInline}. To recover, it sees that `LA(1)==';'`
     * is in the set of tokens that can follow the `')'` token reference
     * in rule `atom`. It can assume that you forgot the `')'`.
     */ recoverInline(recognizer) {
        // SINGLE TOKEN DELETION
        let matchedSymbol = this.singleTokenDeletion(recognizer);
        if (matchedSymbol) {
            // we have deleted the extra token.
            // now, move past ttype token as if all were ok
            recognizer.consume();
            return matchedSymbol;
        }
        // SINGLE TOKEN INSERTION
        if (this.singleTokenInsertion(recognizer)) return this.getMissingSymbol(recognizer);
        // even that didn't work; must throw the exception
        if (this.nextTokensContext === undefined) throw new $iLUMi.InputMismatchException(recognizer);
        else throw new $iLUMi.InputMismatchException(recognizer, this.nextTokensState, this.nextTokensContext);
    }
    /**
     * This method implements the single-token insertion inline error recovery
     * strategy. It is called by {@link #recoverInline} if the single-token
     * deletion strategy fails to recover from the mismatched input. If this
     * method returns `true`, `recognizer` will be in error recovery
     * mode.
     *
     * This method determines whether or not single-token insertion is viable by
     * checking if the `LA(1)` input symbol could be successfully matched
     * if it were instead the `LA(2)` symbol. If this method returns
     * `true`, the caller is responsible for creating and inserting a
     * token with the correct type to produce this behavior.
     *
     * @param recognizer the parser instance
     * @returns `true` if single-token insertion is a viable recovery
     * strategy for the current mismatched input, otherwise `false`
     */ singleTokenInsertion(recognizer) {
        let currentSymbolType = recognizer.inputStream.LA(1);
        // if current token is consistent with what could come after current
        // ATN state, then we know we're missing a token; error recovery
        // is free to conjure up and insert the missing token
        let currentState = recognizer.interpreter.atn.states[recognizer.state];
        let next = currentState.transition(0).target;
        let atn = recognizer.interpreter.atn;
        let expectingAtLL2 = atn.nextTokens(next, $8DTT0.PredictionContext.fromRuleContext(atn, recognizer.context));
        //		console.warn("LT(2) set="+expectingAtLL2.toString(recognizer.getTokenNames()));
        if (expectingAtLL2.contains(currentSymbolType)) {
            this.reportMissingToken(recognizer);
            return true;
        }
        return false;
    }
    /**
     * This method implements the single-token deletion inline error recovery
     * strategy. It is called by {@link #recoverInline} to attempt to recover
     * from mismatched input. If this method returns `undefined`, the parser and error
     * handler state will not have changed. If this method returns non-`undefined`,
     * `recognizer` will *not* be in error recovery mode since the
     * returned token was a successful match.
     *
     * If the single-token deletion is successful, this method calls
     * {@link #reportUnwantedToken} to report the error, followed by
     * {@link Parser#consume} to actually "delete" the extraneous token. Then,
     * before returning {@link #reportMatch} is called to signal a successful
     * match.
     *
     * @param recognizer the parser instance
     * @returns the successfully matched {@link Token} instance if single-token
     * deletion successfully recovers from the mismatched input, otherwise
     * `undefined`
     */ singleTokenDeletion(recognizer) {
        let nextTokenType = recognizer.inputStream.LA(2);
        let expecting = this.getExpectedTokens(recognizer);
        if (expecting.contains(nextTokenType)) {
            this.reportUnwantedToken(recognizer);
            /*
            System.err.println("recoverFromMismatchedToken deleting "+
                               ((TokenStream)recognizer.inputStream).LT(1)+
                               " since "+((TokenStream)recognizer.inputStream).LT(2)+
                               " is what we want");
            */ recognizer.consume(); // simply delete extra token
            // we want to return the token we're actually matching
            let matchedSymbol = recognizer.currentToken;
            this.reportMatch(recognizer); // we know current token is correct
            return matchedSymbol;
        }
        return undefined;
    }
    /** Conjure up a missing token during error recovery.
     *
     *  The recognizer attempts to recover from single missing
     *  symbols. But, actions might refer to that missing symbol.
     *  For example, x=ID {f($x);}. The action clearly assumes
     *  that there has been an identifier matched previously and that
     *  $x points at that token. If that token is missing, but
     *  the next token in the stream is what we want we assume that
     *  this token is missing and we keep going. Because we
     *  have to return some token to replace the missing token,
     *  we have to conjure one up. This method gives the user control
     *  over the tokens returned for missing tokens. Mostly,
     *  you will want to create something special for identifier
     *  tokens. For literals such as '{' and ',', the default
     *  action in the parser or tree parser works. It simply creates
     *  a CommonToken of the appropriate type. The text will be the token.
     *  If you change what tokens must be created by the lexer,
     *  override this method to create the appropriate tokens.
     */ getMissingSymbol(recognizer) {
        let currentSymbol = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let expectedTokenType = $2DVsz.Token.INVALID_TYPE;
        if (!expecting.isNil) // get any element
        expectedTokenType = expecting.minElement;
        let tokenText;
        if (expectedTokenType === $2DVsz.Token.EOF) tokenText = "<missing EOF>";
        else tokenText = "<missing " + recognizer.vocabulary.getDisplayName(expectedTokenType) + ">";
        let current = currentSymbol;
        let lookback = recognizer.inputStream.tryLT(-1);
        if (current.type === $2DVsz.Token.EOF && lookback != null) current = lookback;
        return this.constructToken(recognizer.inputStream.tokenSource, expectedTokenType, tokenText, current);
    }
    constructToken(tokenSource, expectedTokenType, tokenText, current) {
        let factory = tokenSource.tokenFactory;
        let x = current.tokenSource;
        let stream = x ? x.inputStream : undefined;
        return factory.create({
            source: tokenSource,
            stream: stream
        }, expectedTokenType, tokenText, $2DVsz.Token.DEFAULT_CHANNEL, -1, -1, current.line, current.charPositionInLine);
    }
    getExpectedTokens(recognizer) {
        return recognizer.getExpectedTokens();
    }
    /** How should a token be displayed in an error message? The default
     *  is to display just the text, but during development you might
     *  want to have a lot of information spit out.  Override in that case
     *  to use t.toString() (which, for CommonToken, dumps everything about
     *  the token). This is better than forcing you to override a method in
     *  your token objects because you don't have to go modify your lexer
     *  so that it creates a new Java type.
     */ getTokenErrorDisplay(t) {
        if (!t) return "<no token>";
        let s = this.getSymbolText(t);
        if (!s) {
            if (this.getSymbolType(t) === $2DVsz.Token.EOF) s = "<EOF>";
            else s = `<${this.getSymbolType(t)}>`;
        }
        return this.escapeWSAndQuote(s);
    }
    getSymbolText(symbol) {
        return symbol.text;
    }
    getSymbolType(symbol) {
        return symbol.type;
    }
    escapeWSAndQuote(s) {
        //		if ( s==null ) return s;
        s = s.replace("\n", "\\n");
        s = s.replace("\r", "\\r");
        s = s.replace("\t", "\\t");
        return "'" + s + "'";
    }
    /*  Compute the error recovery set for the current rule.  During
     *  rule invocation, the parser pushes the set of tokens that can
     *  follow that rule reference on the stack; this amounts to
     *  computing FIRST of what follows the rule reference in the
     *  enclosing rule. See LinearApproximator.FIRST().
     *  This local follow set only includes tokens
     *  from within the rule; i.e., the FIRST computation done by
     *  ANTLR stops at the end of a rule.
     *
     *  EXAMPLE
     *
     *  When you find a "no viable alt exception", the input is not
     *  consistent with any of the alternatives for rule r.  The best
     *  thing to do is to consume tokens until you see something that
     *  can legally follow a call to r *or* any rule that called r.
     *  You don't want the exact set of viable next tokens because the
     *  input might just be missing a token--you might consume the
     *  rest of the input looking for one of the missing tokens.
     *
     *  Consider grammar:
     *
     *  a : '[' b ']'
     *    | '(' b ')'
     *    ;
     *  b : c '^' INT ;
     *  c : ID
     *    | INT
     *    ;
     *
     *  At each rule invocation, the set of tokens that could follow
     *  that rule is pushed on a stack.  Here are the various
     *  context-sensitive follow sets:
     *
     *  FOLLOW(b1_in_a) = FIRST(']') = ']'
     *  FOLLOW(b2_in_a) = FIRST(')') = ')'
     *  FOLLOW(c_in_b) = FIRST('^') = '^'
     *
     *  Upon erroneous input "[]", the call chain is
     *
     *  a -> b -> c
     *
     *  and, hence, the follow context stack is:
     *
     *  depth     follow set       start of rule execution
     *    0         <EOF>                    a (from main())
     *    1          ']'                     b
     *    2          '^'                     c
     *
     *  Notice that ')' is not included, because b would have to have
     *  been called from a different context in rule a for ')' to be
     *  included.
     *
     *  For error recovery, we cannot consider FOLLOW(c)
     *  (context-sensitive or otherwise).  We need the combined set of
     *  all context-sensitive FOLLOW sets--the set of all tokens that
     *  could follow any reference in the call chain.  We need to
     *  resync to one of those tokens.  Note that FOLLOW(c)='^' and if
     *  we resync'd to that token, we'd consume until EOF.  We need to
     *  sync to context-sensitive FOLLOWs for a, b, and c: {']','^'}.
     *  In this case, for input "[]", LA(1) is ']' and in the set, so we would
     *  not consume anything. After printing an error, rule c would
     *  return normally.  Rule b would not find the required '^' though.
     *  At this point, it gets a mismatched token error and
     *  exception (since LA(1) is not in the viable following token
     *  set).  The rule exception handler tries to recover, but finds
     *  the same recovery set and doesn't consume anything.  Rule b
     *  exits normally returning to rule a.  Now it finds the ']' (and
     *  with the successful match exits errorRecovery mode).
     *
     *  So, you can see that the parser walks up the call chain looking
     *  for the token that was a member of the recovery set.
     *
     *  Errors are not generated in errorRecovery mode.
     *
     *  ANTLR's error recovery mechanism is based upon original ideas:
     *
     *  "Algorithms + Data Structures = Programs" by Niklaus Wirth
     *
     *  and
     *
     *  "A note on error recovery in recursive descent parsers":
     *  http://portal.acm.org/citation.cfm?id=947902.947905
     *
     *  Later, Josef Grosch had some good ideas:
     *
     *  "Efficient and Comfortable Error Recovery in Recursive Descent
     *  Parsers":
     *  ftp://www.cocolab.com/products/cocktail/doca4.ps/ell.ps.zip
     *
     *  Like Grosch I implement context-sensitive FOLLOW sets that are combined
     *  at run-time upon error to avoid overhead during parsing.
     */ getErrorRecoverySet(recognizer) {
        let atn = recognizer.interpreter.atn;
        let ctx = recognizer.context;
        let recoverSet = new $hGRod.IntervalSet();
        while(ctx && ctx.invokingState >= 0){
            // compute what follows who invoked us
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            let follow = atn.nextTokens(rt.followState);
            recoverSet.addAll(follow);
            ctx = ctx._parent;
        }
        recoverSet.remove($2DVsz.Token.EPSILON);
        //		System.out.println("recover set "+recoverSet.toString(recognizer.getTokenNames()));
        return recoverSet;
    }
    /** Consume tokens until one matches the given token set. */ consumeUntil(recognizer, set) {
        //		System.err.println("consumeUntil("+set.toString(recognizer.getTokenNames())+")");
        let ttype = recognizer.inputStream.LA(1);
        while(ttype !== $2DVsz.Token.EOF && !set.contains(ttype)){
            //System.out.println("consume during recover LA(1)="+getTokenNames()[input.LA(1)]);
            //			recognizer.inputStream.consume();
            recognizer.consume();
            ttype = recognizer.inputStream.LA(1);
        }
    }
}
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.Override
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reset", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "beginErrorCondition", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.Override
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "inErrorRecoveryMode", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "endErrorCondition", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.Override
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportMatch", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.Override
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportError", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "notifyErrorListeners", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.Override
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "recover", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.Override
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "sync", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
    $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportNoViableAlternative", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
    $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportInputMismatch", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
    $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportFailedPredicate", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportUnwantedToken", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportMissingToken", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.Override
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "recoverInline", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "singleTokenInsertion", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "singleTokenDeletion", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.NotNull,
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getMissingSymbol", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.NotNull,
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getExpectedTokens", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getSymbolText", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getSymbolType", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.NotNull,
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "escapeWSAndQuote", null);
$35d8c0fbab48edc4$var$__decorate([
    $d6D31.NotNull,
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getErrorRecoverySet", null);
$35d8c0fbab48edc4$var$__decorate([
    $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
    $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "consumeUntil", null);
module.exports.DefaultErrorStrategy = $35d8c0fbab48edc4$var$DefaultErrorStrategy;

});
parcelRegister("7j0Pc", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $551af28bc8fe1b8c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNState = void 0;

var $d6D31 = parcelRequire("d6D31");
const $551af28bc8fe1b8c$var$INITIAL_NUM_TRANSITIONS = 4;
/**
 * The following images show the relation of states and
 * {@link ATNState#transitions} for various grammar constructs.
 *
 * * Solid edges marked with an &#0949; indicate a required
 *   {@link EpsilonTransition}.
 *
 * * Dashed edges indicate locations where any transition derived from
 *   {@link Transition} might appear.
 *
 * * Dashed nodes are place holders for either a sequence of linked
 *   {@link BasicState} states or the inclusion of a block representing a nested
 *   construct in one of the forms below.
 *
 * * Nodes showing multiple outgoing alternatives with a `...` support
 *   any number of alternatives (one or more). Nodes without the `...` only
 *   support the exact number of alternatives shown in the diagram.
 *
 * <h2>Basic Blocks</h2>
 *
 * <h3>Rule</h3>
 *
 * <embed src="images/Rule.svg" type="image/svg+xml"/>
 *
 * <h3>Block of 1 or more alternatives</h3>
 *
 * <embed src="images/Block.svg" type="image/svg+xml"/>
 *
 * <h2>Greedy Loops</h2>
 *
 * <h3>Greedy Closure: `(...)*`</h3>
 *
 * <embed src="images/ClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Positive Closure: `(...)+`</h3>
 *
 * <embed src="images/PositiveClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Optional: `(...)?`</h3>
 *
 * <embed src="images/OptionalGreedy.svg" type="image/svg+xml"/>
 *
 * <h2>Non-Greedy Loops</h2>
 *
 * <h3>Non-Greedy Closure: `(...)*?`</h3>
 *
 * <embed src="images/ClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Positive Closure: `(...)+?`</h3>
 *
 * <embed src="images/PositiveClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Optional: `(...)??`</h3>
 *
 * <embed src="images/OptionalNonGreedy.svg" type="image/svg+xml"/>
 */ class $551af28bc8fe1b8c$var$ATNState {
    constructor(){
        this.stateNumber = $551af28bc8fe1b8c$var$ATNState.INVALID_STATE_NUMBER;
        this.ruleIndex = 0; // at runtime, we don't have Rule objects
        this.epsilonOnlyTransitions = false;
        /** Track the transitions emanating from this ATN state. */ this.transitions = [];
        this.optimizedTransitions = this.transitions;
    }
    /**
     * Gets the state number.
     *
     * @returns the state number
     */ getStateNumber() {
        return this.stateNumber;
    }
    /**
     * For all states except {@link RuleStopState}, this returns the state
     * number. Returns -1 for stop states.
     *
     * @returns -1 for {@link RuleStopState}, otherwise the state number
     */ get nonStopStateNumber() {
        return this.getStateNumber();
    }
    hashCode() {
        return this.stateNumber;
    }
    equals(o) {
        // are these states same object?
        if (o instanceof $551af28bc8fe1b8c$var$ATNState) return this.stateNumber === o.stateNumber;
        return false;
    }
    get isNonGreedyExitState() {
        return false;
    }
    toString() {
        return String(this.stateNumber);
    }
    getTransitions() {
        return this.transitions.slice(0);
    }
    get numberOfTransitions() {
        return this.transitions.length;
    }
    addTransition(e, index) {
        if (this.transitions.length === 0) this.epsilonOnlyTransitions = e.isEpsilon;
        else if (this.epsilonOnlyTransitions !== e.isEpsilon) {
            this.epsilonOnlyTransitions = false;
            throw new Error("ATN state " + this.stateNumber + " has both epsilon and non-epsilon transitions.");
        }
        this.transitions.splice(index !== undefined ? index : this.transitions.length, 0, e);
    }
    transition(i) {
        return this.transitions[i];
    }
    setTransition(i, e) {
        this.transitions[i] = e;
    }
    removeTransition(index) {
        return this.transitions.splice(index, 1)[0];
    }
    get onlyHasEpsilonTransitions() {
        return this.epsilonOnlyTransitions;
    }
    setRuleIndex(ruleIndex) {
        this.ruleIndex = ruleIndex;
    }
    get isOptimized() {
        return this.optimizedTransitions !== this.transitions;
    }
    get numberOfOptimizedTransitions() {
        return this.optimizedTransitions.length;
    }
    getOptimizedTransition(i) {
        return this.optimizedTransitions[i];
    }
    addOptimizedTransition(e) {
        if (!this.isOptimized) this.optimizedTransitions = new Array();
        this.optimizedTransitions.push(e);
    }
    setOptimizedTransition(i, e) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions[i] = e;
    }
    removeOptimizedTransition(i) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions.splice(i, 1);
    }
}
$551af28bc8fe1b8c$var$__decorate([
    $d6D31.Override
], $551af28bc8fe1b8c$var$ATNState.prototype, "hashCode", null);
$551af28bc8fe1b8c$var$__decorate([
    $d6D31.Override
], $551af28bc8fe1b8c$var$ATNState.prototype, "equals", null);
$551af28bc8fe1b8c$var$__decorate([
    $d6D31.Override
], $551af28bc8fe1b8c$var$ATNState.prototype, "toString", null);
module.exports.ATNState = $551af28bc8fe1b8c$var$ATNState;
(function(ATNState) {
    ATNState.INVALID_STATE_NUMBER = -1;
})($551af28bc8fe1b8c$var$ATNState = module.exports.ATNState || (module.exports.ATNState = {}));

});

parcelRegister("1bs3X", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNStateType = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:27.4734328-07:00
var $0dcc96396a04e502$var$ATNStateType;
(function(ATNStateType) {
    ATNStateType[ATNStateType["INVALID_TYPE"] = 0] = "INVALID_TYPE";
    ATNStateType[ATNStateType["BASIC"] = 1] = "BASIC";
    ATNStateType[ATNStateType["RULE_START"] = 2] = "RULE_START";
    ATNStateType[ATNStateType["BLOCK_START"] = 3] = "BLOCK_START";
    ATNStateType[ATNStateType["PLUS_BLOCK_START"] = 4] = "PLUS_BLOCK_START";
    ATNStateType[ATNStateType["STAR_BLOCK_START"] = 5] = "STAR_BLOCK_START";
    ATNStateType[ATNStateType["TOKEN_START"] = 6] = "TOKEN_START";
    ATNStateType[ATNStateType["RULE_STOP"] = 7] = "RULE_STOP";
    ATNStateType[ATNStateType["BLOCK_END"] = 8] = "BLOCK_END";
    ATNStateType[ATNStateType["STAR_LOOP_BACK"] = 9] = "STAR_LOOP_BACK";
    ATNStateType[ATNStateType["STAR_LOOP_ENTRY"] = 10] = "STAR_LOOP_ENTRY";
    ATNStateType[ATNStateType["PLUS_LOOP_BACK"] = 11] = "PLUS_LOOP_BACK";
    ATNStateType[ATNStateType["LOOP_END"] = 12] = "LOOP_END";
})($0dcc96396a04e502$var$ATNStateType = module.exports.ATNStateType || (module.exports.ATNStateType = {}));

});

parcelRegister("ea0YW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a4f2c2ded442ae18$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a4f2c2ded442ae18$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FailedPredicateException = void 0;

var $fLdDn = parcelRequire("fLdDn");

var $d6D31 = parcelRequire("d6D31");

var $hnaRv = parcelRequire("hnaRv");
/** A semantic predicate failed during validation.  Validation of predicates
 *  occurs when normally parsing the alternative just like matching a token.
 *  Disambiguating predicate evaluation occurs when we test a predicate during
 *  prediction.
 */ let $a4f2c2ded442ae18$var$FailedPredicateException = class FailedPredicateException extends $fLdDn.RecognitionException {
    constructor(recognizer, predicate, message){
        super(recognizer, recognizer.inputStream, recognizer.context, FailedPredicateException.formatMessage(predicate, message));
        let s = recognizer.interpreter.atn.states[recognizer.state];
        let trans = s.transition(0);
        if (trans instanceof $hnaRv.PredicateTransition) {
            this._ruleIndex = trans.ruleIndex;
            this._predicateIndex = trans.predIndex;
        } else {
            this._ruleIndex = 0;
            this._predicateIndex = 0;
        }
        this._predicate = predicate;
        super.setOffendingToken(recognizer, recognizer.currentToken);
    }
    get ruleIndex() {
        return this._ruleIndex;
    }
    get predicateIndex() {
        return this._predicateIndex;
    }
    get predicate() {
        return this._predicate;
    }
    static formatMessage(predicate, message) {
        if (message) return message;
        return `failed predicate: {${predicate}}?`;
    }
};
$a4f2c2ded442ae18$var$__decorate([
    $d6D31.NotNull
], $a4f2c2ded442ae18$var$FailedPredicateException, "formatMessage", null);
$a4f2c2ded442ae18$var$FailedPredicateException = $a4f2c2ded442ae18$var$__decorate([
    $a4f2c2ded442ae18$var$__param(0, $d6D31.NotNull)
], $a4f2c2ded442ae18$var$FailedPredicateException);
module.exports.FailedPredicateException = $a4f2c2ded442ae18$var$FailedPredicateException;

});
parcelRegister("fLdDn", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionException = void 0;
/** The root of the ANTLR exception hierarchy. In general, ANTLR tracks just
 *  3 kinds of errors: prediction errors, failed predicate errors, and
 *  mismatched input errors. In each case, the parser knows where it is
 *  in the input, where it is in the ATN, the rule invocation stack,
 *  and what kind of problem occurred.
 */ class $b795d243382c1d9c$var$RecognitionException extends Error {
    constructor(recognizer, input, ctx, message){
        super(message);
        this._offendingState = -1;
        this._recognizer = recognizer;
        this.input = input;
        this.ctx = ctx;
        if (recognizer) this._offendingState = recognizer.state;
    }
    /**
     * Get the ATN state number the parser was in at the time the error
     * occurred. For {@link NoViableAltException} and
     * {@link LexerNoViableAltException} exceptions, this is the
     * {@link DecisionState} number. For others, it is the state whose outgoing
     * edge we couldn't match.
     *
     * If the state number is not known, this method returns -1.
     */ get offendingState() {
        return this._offendingState;
    }
    setOffendingState(offendingState) {
        this._offendingState = offendingState;
    }
    /**
     * Gets the set of input symbols which could potentially follow the
     * previously matched symbol at the time this exception was thrown.
     *
     * If the set of expected tokens is not known and could not be computed,
     * this method returns `undefined`.
     *
     * @returns The set of token types that could potentially follow the current
     * state in the ATN, or `undefined` if the information is not available.
     */ get expectedTokens() {
        if (this._recognizer) return this._recognizer.atn.getExpectedTokens(this._offendingState, this.ctx);
        return undefined;
    }
    /**
     * Gets the {@link RuleContext} at the time this exception was thrown.
     *
     * If the context is not available, this method returns `undefined`.
     *
     * @returns The {@link RuleContext} at the time this exception was thrown.
     * If the context is not available, this method returns `undefined`.
     */ get context() {
        return this.ctx;
    }
    /**
     * Gets the input stream which is the symbol source for the recognizer where
     * this exception was thrown.
     *
     * If the input stream is not available, this method returns `undefined`.
     *
     * @returns The input stream which is the symbol source for the recognizer
     * where this exception was thrown, or `undefined` if the stream is not
     * available.
     */ get inputStream() {
        return this.input;
    }
    getOffendingToken(recognizer) {
        if (recognizer && recognizer !== this._recognizer) return undefined;
        return this.offendingToken;
    }
    setOffendingToken(recognizer, offendingToken) {
        if (recognizer === this._recognizer) this.offendingToken = offendingToken;
    }
    /**
     * Gets the {@link Recognizer} where this exception occurred.
     *
     * If the recognizer is not available, this method returns `undefined`.
     *
     * @returns The recognizer where this exception occurred, or `undefined` if
     * the recognizer is not available.
     */ get recognizer() {
        return this._recognizer;
    }
}
module.exports.RecognitionException = $b795d243382c1d9c$var$RecognitionException;

});

parcelRegister("hnaRv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ca5d02a3d9cef56c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ca5d02a3d9cef56c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredicateTransition = void 0;

var $fMVaR = parcelRequire("fMVaR");

var $d6D31 = parcelRequire("d6D31");

var $eHMgW = parcelRequire("eHMgW");
/** TODO: this is old comment:
 *  A tree of semantic predicates from the grammar AST if label==SEMPRED.
 *  In the ATN, labels will always be exactly one predicate, but the DFA
 *  may have to combine a bunch of them as it collects predicates from
 *  multiple ATN configurations into a single DFA state.
 */ let $ca5d02a3d9cef56c$var$PredicateTransition = class PredicateTransition extends $fMVaR.AbstractPredicateTransition {
    constructor(target, ruleIndex, predIndex, isCtxDependent){
        super(target);
        this.ruleIndex = ruleIndex;
        this.predIndex = predIndex;
        this.isCtxDependent = isCtxDependent;
    }
    get serializationType() {
        return 4 /* PREDICATE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $eHMgW.SemanticContext.Predicate(this.ruleIndex, this.predIndex, this.isCtxDependent);
    }
    toString() {
        return "pred_" + this.ruleIndex + ":" + this.predIndex;
    }
};
$ca5d02a3d9cef56c$var$__decorate([
    $d6D31.Override
], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "serializationType", null);
$ca5d02a3d9cef56c$var$__decorate([
    $d6D31.Override
], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "isEpsilon", null);
$ca5d02a3d9cef56c$var$__decorate([
    $d6D31.Override
], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "matches", null);
$ca5d02a3d9cef56c$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "toString", null);
$ca5d02a3d9cef56c$var$PredicateTransition = $ca5d02a3d9cef56c$var$__decorate([
    $ca5d02a3d9cef56c$var$__param(0, $d6D31.NotNull)
], $ca5d02a3d9cef56c$var$PredicateTransition);
module.exports.PredicateTransition = $ca5d02a3d9cef56c$var$PredicateTransition;

});
parcelRegister("fMVaR", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AbstractPredicateTransition = void 0;

var $5tcOQ = parcelRequire("5tcOQ");
/**
 *
 * @author Sam Harwell
 */ class $b7e7b04ea6d15f5c$var$AbstractPredicateTransition extends $5tcOQ.Transition {
    constructor(target){
        super(target);
    }
}
module.exports.AbstractPredicateTransition = $b7e7b04ea6d15f5c$var$AbstractPredicateTransition;

});
parcelRegister("5tcOQ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3fb99acb0a3a1848$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3fb99acb0a3a1848$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transition = void 0;

var $d6D31 = parcelRequire("d6D31");
/** An ATN transition between any two ATN states.  Subclasses define
 *  atom, set, epsilon, action, predicate, rule transitions.
 *
 *  This is a one way link.  It emanates from a state (usually via a list of
 *  transitions) and has a target state.
 *
 *  Since we never have to change the ATN transitions once we construct it,
 *  we can fix these transitions as specific classes. The DFA transitions
 *  on the other hand need to update the labels as it adds transitions to
 *  the states. We'll use the term Edge for the DFA to distinguish them from
 *  ATN transitions.
 */ let $3fb99acb0a3a1848$var$Transition = class Transition {
    constructor(target){
        if (target == null) throw new Error("target cannot be null.");
        this.target = target;
    }
    /**
     * Determines if the transition is an "epsilon" transition.
     *
     * The default implementation returns `false`.
     *
     * @returns `true` if traversing this transition in the ATN does not
     * consume an input symbol; otherwise, `false` if traversing this
     * transition consumes (matches) an input symbol.
     */ get isEpsilon() {
        return false;
    }
    get label() {
        return undefined;
    }
};
$3fb99acb0a3a1848$var$Transition.serializationNames = [
    "INVALID",
    "EPSILON",
    "RANGE",
    "RULE",
    "PREDICATE",
    "ATOM",
    "ACTION",
    "SET",
    "NOT_SET",
    "WILDCARD",
    "PRECEDENCE"
];
$3fb99acb0a3a1848$var$__decorate([
    $d6D31.NotNull
], $3fb99acb0a3a1848$var$Transition.prototype, "target", void 0);
$3fb99acb0a3a1848$var$Transition = $3fb99acb0a3a1848$var$__decorate([
    $3fb99acb0a3a1848$var$__param(0, $d6D31.NotNull)
], $3fb99acb0a3a1848$var$Transition);
module.exports.Transition = $3fb99acb0a3a1848$var$Transition;

});


parcelRegister("eHMgW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ab4a86b5def51fe2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ab4a86b5def51fe2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SemanticContext = void 0;

var $7Veax = parcelRequire("7Veax");

var $3sNxf = parcelRequire("3sNxf");

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");

var $a4Flx = parcelRequire("a4Flx");

var $2IEP9 = parcelRequire("2IEP9");
function $ab4a86b5def51fe2$var$max(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison < 0) result = current;
    }
    return result;
}
function $ab4a86b5def51fe2$var$min(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison > 0) result = current;
    }
    return result;
}
/** A tree structure used to record the semantic context in which
 *  an ATN configuration is valid.  It's either a single predicate,
 *  a conjunction `p1&&p2`, or a sum of products `p1||p2`.
 *
 *  I have scoped the {@link AND}, {@link OR}, and {@link Predicate} subclasses of
 *  {@link SemanticContext} within the scope of this outer class.
 */ class $ab4a86b5def51fe2$var$SemanticContext {
    /**
     * The default {@link SemanticContext}, which is semantically equivalent to
     * a predicate of the form `{true}?`.
     */ static get NONE() {
        if ($ab4a86b5def51fe2$var$SemanticContext._NONE === undefined) $ab4a86b5def51fe2$var$SemanticContext._NONE = new $ab4a86b5def51fe2$var$SemanticContext.Predicate();
        return $ab4a86b5def51fe2$var$SemanticContext._NONE;
    }
    /**
     * Evaluate the precedence predicates for the context and reduce the result.
     *
     * @param parser The parser instance.
     * @param parserCallStack
     * @returns The simplified semantic context after precedence predicates are
     * evaluated, which will be one of the following values.
     *
     * * {@link #NONE}: if the predicate simplifies to `true` after
     *   precedence predicates are evaluated.
     * * `undefined`: if the predicate simplifies to `false` after
     *   precedence predicates are evaluated.
     * * `this`: if the semantic context is not changed as a result of
     *   precedence predicate evaluation.
     * * A non-`undefined` {@link SemanticContext}: the new simplified
     *   semantic context after precedence predicates are evaluated.
     */ evalPrecedence(parser, parserCallStack) {
        return this;
    }
    static and(a, b) {
        if (!a || a === $ab4a86b5def51fe2$var$SemanticContext.NONE) return b;
        if (b === $ab4a86b5def51fe2$var$SemanticContext.NONE) return a;
        let result = new $ab4a86b5def51fe2$var$SemanticContext.AND(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
    /**
     *
     *  @see ParserATNSimulator#getPredsForAmbigAlts
     */ static or(a, b) {
        if (!a) return b;
        if (a === $ab4a86b5def51fe2$var$SemanticContext.NONE || b === $ab4a86b5def51fe2$var$SemanticContext.NONE) return $ab4a86b5def51fe2$var$SemanticContext.NONE;
        let result = new $ab4a86b5def51fe2$var$SemanticContext.OR(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
}
module.exports.SemanticContext = $ab4a86b5def51fe2$var$SemanticContext;
(function(SemanticContext) {
    /**
     * This random 30-bit prime represents the value of `AND.class.hashCode()`.
     */ const AND_HASHCODE = 40363613;
    /**
     * This random 30-bit prime represents the value of `OR.class.hashCode()`.
     */ const OR_HASHCODE = 486279973;
    function filterPrecedencePredicates(collection) {
        let result = [];
        for(let i = 0; i < collection.length; i++){
            let context = collection[i];
            if (context instanceof SemanticContext.PrecedencePredicate) {
                result.push(context);
                // Remove the item from 'collection' and move i back so we look at the same index again
                collection.splice(i, 1);
                i--;
            }
        }
        return result;
    }
    class Predicate extends SemanticContext {
        constructor(ruleIndex = -1, predIndex = -1, isCtxDependent = false){
            super();
            this.ruleIndex = ruleIndex;
            this.predIndex = predIndex;
            this.isCtxDependent = isCtxDependent;
        }
        eval(parser, parserCallStack) {
            let localctx = this.isCtxDependent ? parserCallStack : undefined;
            return parser.sempred(localctx, this.ruleIndex, this.predIndex);
        }
        hashCode() {
            let hashCode = $iXFjm.MurmurHash.initialize();
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.ruleIndex);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.predIndex);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.isCtxDependent ? 1 : 0);
            hashCode = $iXFjm.MurmurHash.finish(hashCode, 3);
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof Predicate)) return false;
            if (this === obj) return true;
            return this.ruleIndex === obj.ruleIndex && this.predIndex === obj.predIndex && this.isCtxDependent === obj.isCtxDependent;
        }
        toString() {
            return "{" + this.ruleIndex + ":" + this.predIndex + "}?";
        }
    }
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], Predicate.prototype, "eval", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], Predicate.prototype, "hashCode", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], Predicate.prototype, "equals", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], Predicate.prototype, "toString", null);
    SemanticContext.Predicate = Predicate;
    class PrecedencePredicate extends SemanticContext {
        constructor(precedence){
            super();
            this.precedence = precedence;
        }
        eval(parser, parserCallStack) {
            return parser.precpred(parserCallStack, this.precedence);
        }
        evalPrecedence(parser, parserCallStack) {
            if (parser.precpred(parserCallStack, this.precedence)) return SemanticContext.NONE;
            else return undefined;
        }
        compareTo(o) {
            return this.precedence - o.precedence;
        }
        hashCode() {
            let hashCode = 1;
            hashCode = 31 * hashCode + this.precedence;
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof PrecedencePredicate)) return false;
            if (this === obj) return true;
            return this.precedence === obj.precedence;
        }
        toString() {
            return "{" + this.precedence + ">=prec}?";
        }
    }
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], PrecedencePredicate.prototype, "eval", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], PrecedencePredicate.prototype, "evalPrecedence", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], PrecedencePredicate.prototype, "compareTo", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], PrecedencePredicate.prototype, "hashCode", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], PrecedencePredicate.prototype, "equals", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], PrecedencePredicate.prototype, "toString", null);
    SemanticContext.PrecedencePredicate = PrecedencePredicate;
    /**
     * This is the base class for semantic context "operators", which operate on
     * a collection of semantic context "operands".
     *
     * @since 4.3
     */ class Operator extends SemanticContext {
    }
    SemanticContext.Operator = Operator;
    /**
     * A semantic context which is true whenever none of the contained contexts
     * is false.
     */ let AND = class AND extends Operator {
        constructor(a, b){
            super();
            let operands = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
            if (a instanceof AND) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof AND) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the lowest precedence
            let reduced = $ab4a86b5def51fe2$var$min(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof AND)) return false;
            return $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $iXFjm.MurmurHash.hashCode(this.opnds, AND_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (!opnd.eval(parser, parserCallStack)) return false;
            }
            return true;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated == null) // The AND context is false if any element is false
                return undefined;
                else if (evaluated !== SemanticContext.NONE) // Reduce the result by skipping true elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were true, so the AND context is true
            return SemanticContext.NONE;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.and(result, operands[i]);
            return result;
        }
        toString() {
            return $2IEP9.join(this.opnds, "&&");
        }
    };
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], AND.prototype, "operands", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], AND.prototype, "equals", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], AND.prototype, "hashCode", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], AND.prototype, "eval", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], AND.prototype, "evalPrecedence", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], AND.prototype, "toString", null);
    AND = $ab4a86b5def51fe2$var$__decorate([
        $ab4a86b5def51fe2$var$__param(0, $d6D31.NotNull),
        $ab4a86b5def51fe2$var$__param(1, $d6D31.NotNull)
    ], AND);
    SemanticContext.AND = AND;
    /**
     * A semantic context which is true whenever at least one of the contained
     * contexts is true.
     */ let OR = class OR extends Operator {
        constructor(a, b){
            super();
            let operands = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
            if (a instanceof OR) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof OR) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the highest precedence
            let reduced = $ab4a86b5def51fe2$var$max(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof OR)) return false;
            return $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $iXFjm.MurmurHash.hashCode(this.opnds, OR_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (opnd.eval(parser, parserCallStack)) return true;
            }
            return false;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated === SemanticContext.NONE) // The OR context is true if any element is true
                return SemanticContext.NONE;
                else if (evaluated) // Reduce the result by skipping false elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were false, so the OR context is false
            return undefined;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.or(result, operands[i]);
            return result;
        }
        toString() {
            return $2IEP9.join(this.opnds, "||");
        }
    };
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], OR.prototype, "operands", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], OR.prototype, "equals", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], OR.prototype, "hashCode", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], OR.prototype, "eval", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], OR.prototype, "evalPrecedence", null);
    $ab4a86b5def51fe2$var$__decorate([
        $d6D31.Override
    ], OR.prototype, "toString", null);
    OR = $ab4a86b5def51fe2$var$__decorate([
        $ab4a86b5def51fe2$var$__param(0, $d6D31.NotNull),
        $ab4a86b5def51fe2$var$__param(1, $d6D31.NotNull)
    ], OR);
    SemanticContext.OR = OR;
})($ab4a86b5def51fe2$var$SemanticContext = module.exports.SemanticContext || (module.exports.SemanticContext = {}));

});
parcelRegister("7Veax", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $5c48d8f2b0160dc3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5c48d8f2b0160dc3$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashSet = void 0;

var $bbHFU = parcelRequire("bbHFU");

var $1EUnG = parcelRequire("1EUnG");

var $d6D31 = parcelRequire("d6D31");

var $iXFjm = parcelRequire("iXFjm");
/** {@link Set} implementation with closed hashing (open addressing). */ // NOTE:  JavaScript's Set interface has on significant different diffrence from Java's:
// 		  e.g. the return type of add() differs!
//        For this reason I've commented tweaked the implements clause
const $5c48d8f2b0160dc3$var$INITAL_CAPACITY = 16; // must be power of 2
const $5c48d8f2b0160dc3$var$LOAD_FACTOR = 0.75;
class $5c48d8f2b0160dc3$var$Array2DHashSet {
    constructor(comparatorOrSet, initialCapacity = $5c48d8f2b0160dc3$var$INITAL_CAPACITY){
        /** How many elements in set */ this.n = 0;
        this.threshold = Math.floor($5c48d8f2b0160dc3$var$INITAL_CAPACITY * $5c48d8f2b0160dc3$var$LOAD_FACTOR); // when to expand
        if (comparatorOrSet instanceof $5c48d8f2b0160dc3$var$Array2DHashSet) {
            this.comparator = comparatorOrSet.comparator;
            this.buckets = comparatorOrSet.buckets.slice(0);
            for(let i = 0; i < this.buckets.length; i++){
                let bucket = this.buckets[i];
                if (bucket) this.buckets[i] = bucket.slice(0);
            }
            this.n = comparatorOrSet.n;
            this.threshold = comparatorOrSet.threshold;
        } else {
            this.comparator = comparatorOrSet || $1EUnG.DefaultEqualityComparator.INSTANCE;
            this.buckets = this.createBuckets(initialCapacity);
        }
    }
    /**
     * Add `o` to set if not there; return existing value if already
     * there. This method performs the same operation as {@link #add} aside from
     * the return value.
     */ getOrAdd(o) {
        if (this.n > this.threshold) this.expand();
        return this.getOrAddImpl(o);
    }
    getOrAddImpl(o) {
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        // NEW BUCKET
        if (!bucket) {
            bucket = [
                o
            ];
            this.buckets[b] = bucket;
            this.n++;
            return o;
        }
        // LOOK FOR IT IN BUCKET
        for (let existing of bucket){
            if (this.comparator.equals(existing, o)) return existing; // found existing, quit
        }
        // FULL BUCKET, expand and add to end
        bucket.push(o);
        this.n++;
        return o;
    }
    get(o) {
        if (o == null) return o;
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        if (!bucket) // no bucket
        return undefined;
        for (let e of bucket){
            if (this.comparator.equals(e, o)) return e;
        }
        return undefined;
    }
    getBucket(o) {
        let hash = this.comparator.hashCode(o);
        let b = hash & this.buckets.length - 1; // assumes len is power of 2
        return b;
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                hash = $iXFjm.MurmurHash.update(hash, this.comparator.hashCode(o));
            }
        }
        hash = $iXFjm.MurmurHash.finish(hash, this.size);
        return hash;
    }
    equals(o) {
        if (o === this) return true;
        if (!(o instanceof $5c48d8f2b0160dc3$var$Array2DHashSet)) return false;
        if (o.size !== this.size) return false;
        let same = this.containsAll(o);
        return same;
    }
    expand() {
        let old = this.buckets;
        let newCapacity = this.buckets.length * 2;
        let newTable = this.createBuckets(newCapacity);
        this.buckets = newTable;
        this.threshold = Math.floor(newCapacity * $5c48d8f2b0160dc3$var$LOAD_FACTOR);
        //		System.out.println("new size="+newCapacity+", thres="+threshold);
        // rehash all existing entries
        let oldSize = this.size;
        for (let bucket of old){
            if (!bucket) continue;
            for (let o of bucket){
                let b = this.getBucket(o);
                let newBucket = this.buckets[b];
                if (!newBucket) {
                    newBucket = [];
                    this.buckets[b] = newBucket;
                }
                newBucket.push(o);
            }
        }
        $bbHFU(this.n === oldSize);
    }
    add(t) {
        let existing = this.getOrAdd(t);
        return existing === t;
    }
    get size() {
        return this.n;
    }
    get isEmpty() {
        return this.n === 0;
    }
    contains(o) {
        return this.containsFast(this.asElementType(o));
    }
    containsFast(obj) {
        if (obj == null) return false;
        return this.get(obj) != null;
    }
    *[Symbol.iterator]() {
        yield* this.toArray();
    }
    toArray() {
        const a = new Array(this.size);
        // Copy elements from the nested arrays into the destination array
        let i = 0; // Position within destination array
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                a[i++] = o;
            }
        }
        return a;
    }
    containsAll(collection) {
        if (collection instanceof $5c48d8f2b0160dc3$var$Array2DHashSet) {
            let s = collection;
            for (let bucket of s.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    if (!this.containsFast(this.asElementType(o))) return false;
                }
            }
        } else for (let o of collection){
            if (!this.containsFast(this.asElementType(o))) return false;
        }
        return true;
    }
    addAll(c) {
        let changed = false;
        for (let o of c){
            let existing = this.getOrAdd(o);
            if (existing !== o) changed = true;
        }
        return changed;
    }
    clear() {
        this.buckets = this.createBuckets($5c48d8f2b0160dc3$var$INITAL_CAPACITY);
        this.n = 0;
        this.threshold = Math.floor($5c48d8f2b0160dc3$var$INITAL_CAPACITY * $5c48d8f2b0160dc3$var$LOAD_FACTOR);
    }
    toString() {
        if (this.size === 0) return "{}";
        let buf = "{";
        let first = true;
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                if (first) first = false;
                else buf += ", ";
                buf += o.toString();
            }
        }
        buf += "}";
        return buf;
    }
    toTableString() {
        let buf = "";
        for (let bucket of this.buckets){
            if (bucket == null) {
                buf += "null\n";
                continue;
            }
            buf += "[";
            let first = true;
            for (let o of bucket){
                if (first) first = false;
                else buf += " ";
                if (o == null) buf += "_";
                else buf += o.toString();
            }
            buf += "]\n";
        }
        return buf;
    }
    /**
     * Return `o` as an instance of the element type `T`. If
     * `o` is non-undefined but known to not be an instance of `T`, this
     * method returns `undefined`. The base implementation does not perform any
     * type checks; override this method to provide strong type checks for the
     * {@link #contains} and {@link #remove} methods to ensure the arguments to
     * the {@link EqualityComparator} for the set always have the expected
     * types.
     *
     * @param o the object to try and cast to the element type of the set
     * @returns `o` if it could be an instance of `T`, otherwise
     * `undefined`.
     */ asElementType(o) {
        return o;
    }
    /**
     * Return an array of `T[]` with length `capacity`.
     *
     * @param capacity the length of the array to return
     * @returns the newly constructed array
     */ createBuckets(capacity) {
        return new Array(capacity);
    }
}
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.NotNull
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "comparator", void 0);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "hashCode", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "equals", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "add", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "size", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "isEmpty", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "contains", null);
$5c48d8f2b0160dc3$var$__decorate([
    $5c48d8f2b0160dc3$var$__param(0, $d6D31.Nullable)
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "containsFast", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, Symbol.iterator, null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "toArray", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "containsAll", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "addAll", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "clear", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.Override
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "toString", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.SuppressWarnings("unchecked")
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "asElementType", null);
$5c48d8f2b0160dc3$var$__decorate([
    $d6D31.SuppressWarnings("unchecked")
], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "createBuckets", null);
module.exports.Array2DHashSet = $5c48d8f2b0160dc3$var$Array2DHashSet;

});
parcelRegister("1EUnG", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $135542f8f0124ec7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultEqualityComparator = void 0;

var $d6D31 = parcelRequire("d6D31");

var $iXFjm = parcelRequire("iXFjm");

var $a4Flx = parcelRequire("a4Flx");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $135542f8f0124ec7$var$DefaultEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        else if (typeof obj === "string" || typeof obj === "number") return $iXFjm.MurmurHash.hashCode([
            obj
        ]);
        else return $a4Flx.ObjectEqualityComparator.INSTANCE.hashCode(obj);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (typeof a === "string" || typeof a === "number") return a === b;
        else return $a4Flx.ObjectEqualityComparator.INSTANCE.equals(a, b);
    }
}
$135542f8f0124ec7$var$DefaultEqualityComparator.INSTANCE = new $135542f8f0124ec7$var$DefaultEqualityComparator();
$135542f8f0124ec7$var$__decorate([
    $d6D31.Override
], $135542f8f0124ec7$var$DefaultEqualityComparator.prototype, "hashCode", null);
$135542f8f0124ec7$var$__decorate([
    $d6D31.Override
], $135542f8f0124ec7$var$DefaultEqualityComparator.prototype, "equals", null);
module.exports.DefaultEqualityComparator = $135542f8f0124ec7$var$DefaultEqualityComparator;

});
parcelRegister("iXFjm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MurmurHash = void 0;
/**
 *
 * @author Sam Harwell
 */ var $dcddc83c17bb111f$var$MurmurHash;
(function(MurmurHash) {
    const DEFAULT_SEED = 0;
    /**
     * Initialize the hash using the specified `seed`.
     *
     * @param seed the seed (optional)
     * @returns the intermediate hash value
     */ function initialize(seed = DEFAULT_SEED) {
        return seed;
    }
    MurmurHash.initialize = initialize;
    /**
     * Update the intermediate hash value for the next input `value`.
     *
     * @param hash the intermediate hash value
     * @param value the value to add to the current hash
     * @returns the updated intermediate hash value
     */ function update(hash, value) {
        const c1 = 0xCC9E2D51;
        const c2 = 0x1B873593;
        const r1 = 15;
        const r2 = 13;
        const m = 5;
        const n = 0xE6546B64;
        if (value == null) value = 0;
        else if (typeof value === "string") value = hashString(value);
        else if (typeof value === "object") value = value.hashCode();
        let k = value;
        k = Math.imul(k, c1);
        k = k << r1 | k >>> 32 - r1;
        k = Math.imul(k, c2);
        hash = hash ^ k;
        hash = hash << r2 | hash >>> 32 - r2;
        hash = Math.imul(hash, m) + n;
        return hash & 0xFFFFFFFF;
    }
    MurmurHash.update = update;
    /**
     * Apply the final computation steps to the intermediate value `hash`
     * to form the final result of the MurmurHash 3 hash function.
     *
     * @param hash the intermediate hash value
     * @param numberOfWords the number of integer values added to the hash
     * @returns the final hash result
     */ function finish(hash, numberOfWords) {
        hash = hash ^ numberOfWords * 4;
        hash = hash ^ hash >>> 16;
        hash = Math.imul(hash, 0x85EBCA6B);
        hash = hash ^ hash >>> 13;
        hash = Math.imul(hash, 0xC2B2AE35);
        hash = hash ^ hash >>> 16;
        return hash;
    }
    MurmurHash.finish = finish;
    /**
     * Utility function to compute the hash code of an array using the
     * MurmurHash algorithm.
     *
     * @param <T> the array element type
     * @param data the array data
     * @param seed the seed for the MurmurHash algorithm
     * @returns the hash code of the data
     */ function hashCode(data, seed = DEFAULT_SEED) {
        let hash = initialize(seed);
        let length = 0;
        for (let value of data){
            hash = update(hash, value);
            length++;
        }
        hash = finish(hash, length);
        return hash;
    }
    MurmurHash.hashCode = hashCode;
    /**
     * Function to hash a string. Based on the implementation found here:
     * http://stackoverflow.com/a/7616484
     */ function hashString(str) {
        let len = str.length;
        if (len === 0) return 0;
        let hash = 0;
        for(let i = 0; i < len; i++){
            let c = str.charCodeAt(i);
            hash = (hash << 5 >>> 0) - hash + c;
            hash |= 0;
        }
        return hash;
    }
})($dcddc83c17bb111f$var$MurmurHash = module.exports.MurmurHash || (module.exports.MurmurHash = {}));

});

parcelRegister("a4Flx", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $755a59a5b7943f39$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ObjectEqualityComparator = void 0;

var $d6D31 = parcelRequire("d6D31");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $755a59a5b7943f39$var$ObjectEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return obj.hashCode();
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        return a.equals(b);
    }
}
$755a59a5b7943f39$var$ObjectEqualityComparator.INSTANCE = new $755a59a5b7943f39$var$ObjectEqualityComparator();
$755a59a5b7943f39$var$__decorate([
    $d6D31.Override
], $755a59a5b7943f39$var$ObjectEqualityComparator.prototype, "hashCode", null);
$755a59a5b7943f39$var$__decorate([
    $d6D31.Override
], $755a59a5b7943f39$var$ObjectEqualityComparator.prototype, "equals", null);
module.exports.ObjectEqualityComparator = $755a59a5b7943f39$var$ObjectEqualityComparator;

});



parcelRegister("3sNxf", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $285a6946513e4d3e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArrayEqualityComparator = void 0;

var $d6D31 = parcelRequire("d6D31");

var $iXFjm = parcelRequire("iXFjm");

var $a4Flx = parcelRequire("a4Flx");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $285a6946513e4d3e$var$ArrayEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return $iXFjm.MurmurHash.hashCode(obj, 0);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined`, this method returns `true`. Otherwise if only
     * `a` is `undefined`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (b == null) return false;
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$a4Flx.ObjectEqualityComparator.INSTANCE.equals(a[i], b[i])) return false;
        }
        return true;
    }
}
$285a6946513e4d3e$var$ArrayEqualityComparator.INSTANCE = new $285a6946513e4d3e$var$ArrayEqualityComparator();
$285a6946513e4d3e$var$__decorate([
    $d6D31.Override
], $285a6946513e4d3e$var$ArrayEqualityComparator.prototype, "hashCode", null);
$285a6946513e4d3e$var$__decorate([
    $d6D31.Override
], $285a6946513e4d3e$var$ArrayEqualityComparator.prototype, "equals", null);
module.exports.ArrayEqualityComparator = $285a6946513e4d3e$var$ArrayEqualityComparator;

});

parcelRegister("2IEP9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toCharArray = module.exports.toMap = module.exports.equals = module.exports.join = module.exports.escapeWhitespace = void 0;
function $1faf5ba696168af5$var$escapeWhitespace(s, escapeSpaces) {
    return escapeSpaces ? s.replace(/ /, "\u00B7") : s.replace(/\t/, "\\t").replace(/\n/, "\\n").replace(/\r/, "\\r");
}
module.exports.escapeWhitespace = $1faf5ba696168af5$var$escapeWhitespace;
// Seriously: why isn't this built in to java? ugh!
function $1faf5ba696168af5$var$join(collection, separator) {
    let buf = "";
    let first = true;
    for (let current of collection){
        if (first) first = false;
        else buf += separator;
        buf += current;
    }
    return buf;
}
module.exports.join = $1faf5ba696168af5$var$join;
function $1faf5ba696168af5$var$equals(x, y) {
    if (x === y) return true;
    if (x === undefined || y === undefined) return false;
    return x.equals(y);
}
module.exports.equals = $1faf5ba696168af5$var$equals;
// export function numNonnull(data: any[]): number {
// 	let n: number =  0;
// 	if ( data == null ) return n;
// 	for (let o of data) {
// 		if ( o!=null ) n++;
// 	}
// 	return n;
// }
// export function removeAllElements<T>(data: Collection<T>, value: T): void {
// 	if ( data==null ) return;
// 	while ( data.contains(value) ) data.remove(value);
// }
// export function writeFile(@NotNull file: File, @NotNull content: Uint8Array): void {
// 	let fos: FileOutputStream = new FileOutputStream(file);
// 	try {
// 		fos.write(content);
// 	} finally {
// 		fos.close();
// 	}
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string): void {
// 	writeFile(fileName, content, null);
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string, @Nullable encoding: string): void {
// 	let f: File =  new File(fileName);
// 	let fos: FileOutputStream =  new FileOutputStream(f);
// 	let osw: OutputStreamWriter;
// 	if (encoding != null) {
// 		osw = new OutputStreamWriter(fos, encoding);
// 	}
// 	else {
// 		osw = new OutputStreamWriter(fos);
// 	}
// 	try {
// 		osw.write(content);
// 	}
// 	finally {
// 		osw.close();
// 	}
// }
// @NotNull
// export function readFile(@NotNull fileName: string): char[] {
// 	return readFile(fileName, null);
// }
// @NotNull
// export function readFile(@NotNull fileName: string, @Nullable encoding: string): char[] {
// 	let f: File =  new File(fileName);
// 	let size: number =  (int)f.length();
// 	let isr: InputStreamReader;
// 	let fis: FileInputStream =  new FileInputStream(fileName);
// 	if ( encoding!=null ) {
// 		isr = new InputStreamReader(fis, encoding);
// 	}
// 	else {
// 		isr = new InputStreamReader(fis);
// 	}
// 	let data: char[] =  null;
// 	try {
// 		data = new char[size];
// 		let n: number =  isr.read(data);
// 		if (n < data.length) {
// 			data = Arrays.copyOf(data, n);
// 		}
// 	}
// 	finally {
// 		isr.close();
// 	}
// 	return data;
// }
// export function removeAll<T>(@NotNull predicate: List<T> list,@NotNull Predicate<? super T>): void {
// 	let j: number =  0;
// 	for (let i = 0; i < list.size; i++) {
// 		let item: T =  list.get(i);
// 		if (!predicate.eval(item)) {
// 			if (j != i) {
// 				list.set(j, item);
// 			}
// 			j++;
// 		}
// 	}
// 	if (j < list.size) {
// 		list.subList(j, list.size).clear();
// 	}
// }
// export function removeAll<T>(@NotNull predicate: Iterable<T> iterable,@NotNull Predicate<? super T>): void {
// 	if (iterable instanceof List<?>) {
// 		removeAll((List<T>)iterable, predicate);
// 		return;
// 	}
// 	for (Iterator<T> iterator = iterable.iterator(); iterator.hasNext(); ) {
// 		let item: T =  iterator.next();
// 		if (predicate.eval(item)) {
// 			iterator.remove();
// 		}
// 	}
// }
/** Convert array of strings to string&rarr;index map. Useful for
 *  converting rulenames to name&rarr;ruleindex map.
 */ function $1faf5ba696168af5$var$toMap(keys) {
    let m = new Map();
    for(let i = 0; i < keys.length; i++)m.set(keys[i], i);
    return m;
}
module.exports.toMap = $1faf5ba696168af5$var$toMap;
function $1faf5ba696168af5$var$toCharArray(str) {
    if (typeof str === "string") {
        let result = new Uint16Array(str.length);
        for(let i = 0; i < str.length; i++)result[i] = str.charCodeAt(i);
        return result;
    } else return str.toCharArray();
}
module.exports.toCharArray = $1faf5ba696168af5$var$toCharArray; // /**
 // 	* @since 4.5
 // 	*/
 // @NotNull
 // export function toSet(@NotNull bits: BitSet): IntervalSet {
 // 	let s: IntervalSet =  new IntervalSet();
 // 	let i: number =  bits.nextSetBit(0);
 // 	while ( i >= 0 ) {
 // 		s.add(i);
 // 		i = bits.nextSetBit(i+1);
 // 	}
 // 	return s;
 // }

});




parcelRegister("iLUMi", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $daa8a8b6b270e309$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $daa8a8b6b270e309$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InputMismatchException = void 0;

var $fLdDn = parcelRequire("fLdDn");

var $d6D31 = parcelRequire("d6D31");
/** This signifies any kind of mismatched input exceptions such as
 *  when the current input does not match the expected token.
 */ let $daa8a8b6b270e309$var$InputMismatchException = class InputMismatchException extends $fLdDn.RecognitionException {
    constructor(recognizer, state, context){
        if (context === undefined) context = recognizer.context;
        super(recognizer, recognizer.inputStream, context);
        if (state !== undefined) this.setOffendingState(state);
        this.setOffendingToken(recognizer, recognizer.currentToken);
    }
};
$daa8a8b6b270e309$var$InputMismatchException = $daa8a8b6b270e309$var$__decorate([
    $daa8a8b6b270e309$var$__param(0, $d6D31.NotNull)
], $daa8a8b6b270e309$var$InputMismatchException);
module.exports.InputMismatchException = $daa8a8b6b270e309$var$InputMismatchException;

});

parcelRegister("hGRod", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ce0fc5f35b4fec79$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ce0fc5f35b4fec79$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntervalSet = void 0;

var $3sNxf = parcelRequire("3sNxf");

var $37SGk = parcelRequire("37SGk");

var $gcfUE = parcelRequire("gcfUE");

var $igNLf = parcelRequire("igNLf");

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");
/**
 * This class implements the {@link IntSet} backed by a sorted array of
 * non-overlapping intervals. It is particularly efficient for representing
 * large collections of numbers, where the majority of elements appear as part
 * of a sequential range of numbers that are all part of the set. For example,
 * the set { 1, 2, 3, 4, 7, 8 } may be represented as { [1, 4], [7, 8] }.
 *
 * This class is able to represent sets containing any combination of values in
 * the range {@link Integer#MIN_VALUE} to {@link Integer#MAX_VALUE}
 * (inclusive).
 */ class $ce0fc5f35b4fec79$var$IntervalSet {
    constructor(intervals){
        this.readonly = false;
        if (intervals != null) this._intervals = intervals.slice(0);
        else this._intervals = [];
    }
    static get COMPLETE_CHAR_SET() {
        if ($ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET === undefined) {
            $ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET = $ce0fc5f35b4fec79$var$IntervalSet.of($igNLf.Lexer.MIN_CHAR_VALUE, $igNLf.Lexer.MAX_CHAR_VALUE);
            $ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET.setReadonly(true);
        }
        return $ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET;
    }
    static get EMPTY_SET() {
        if ($ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET == null) {
            $ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET = new $ce0fc5f35b4fec79$var$IntervalSet();
            $ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET.setReadonly(true);
        }
        return $ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET;
    }
    /**
     * Create a set with all ints within range [a..b] (inclusive). If b is omitted, the set contains the single element
     * a.
     */ static of(a, b = a) {
        let s = new $ce0fc5f35b4fec79$var$IntervalSet();
        s.add(a, b);
        return s;
    }
    clear() {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        this._intervals.length = 0;
    }
    /** Add interval; i.e., add all integers from a to b to set.
     *  If b&lt;a, do nothing.
     *  Keep list in sorted order (by left range value).
     *  If overlap, combine ranges.  For example,
     *  If this is {1..5, 10..20}, adding 6..7 yields
     *  {1..5, 6..7, 10..20}.  Adding 4..8 yields {1..8, 10..20}.
     */ add(a, b = a) {
        this.addRange($gcfUE.Interval.of(a, b));
    }
    // copy on write so we can cache a..a intervals and sets of that
    addRange(addition) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        //System.out.println("add "+addition+" to "+intervals.toString());
        if (addition.b < addition.a) return;
        // find position in list
        // Use iterators as we modify list in place
        for(let i = 0; i < this._intervals.length; i++){
            let r = this._intervals[i];
            if (addition.equals(r)) return;
            if (addition.adjacent(r) || !addition.disjoint(r)) {
                // next to each other, make a single larger interval
                let bigger = addition.union(r);
                this._intervals[i] = bigger;
                // make sure we didn't just create an interval that
                // should be merged with next interval in list
                while(i < this._intervals.length - 1){
                    i++;
                    let next = this._intervals[i];
                    if (!bigger.adjacent(next) && bigger.disjoint(next)) break;
                    // if we bump up against or overlap next, merge
                    // remove this one
                    this._intervals.splice(i, 1);
                    i--;
                    // move backwards to what we just set
                    this._intervals[i] = bigger.union(next);
                // set to 3 merged ones
                }
                // first call to next after previous duplicates the result
                return;
            }
            if (addition.startsBeforeDisjoint(r)) {
                // insert before r
                this._intervals.splice(i, 0, addition);
                return;
            }
        // if disjoint and after r, a future iteration will handle it
        }
        // ok, must be after last interval (and disjoint from last interval)
        // just add it
        this._intervals.push(addition);
    }
    /** combine all sets in the array returned the or'd value */ static or(sets) {
        let r = new $ce0fc5f35b4fec79$var$IntervalSet();
        for (let s of sets)r.addAll(s);
        return r;
    }
    addAll(set) {
        if (set == null) return this;
        if (set instanceof $ce0fc5f35b4fec79$var$IntervalSet) {
            let other = set;
            // walk set and add each interval
            let n = other._intervals.length;
            for(let i = 0; i < n; i++){
                let I = other._intervals[i];
                this.add(I.a, I.b);
            }
        } else for (let value of set.toArray())this.add(value);
        return this;
    }
    complementRange(minElement, maxElement) {
        return this.complement($ce0fc5f35b4fec79$var$IntervalSet.of(minElement, maxElement));
    }
    /** {@inheritDoc} */ complement(vocabulary) {
        if (vocabulary.isNil) // nothing in common with null set
        return $ce0fc5f35b4fec79$var$IntervalSet.EMPTY_SET;
        let vocabularyIS;
        if (vocabulary instanceof $ce0fc5f35b4fec79$var$IntervalSet) vocabularyIS = vocabulary;
        else {
            vocabularyIS = new $ce0fc5f35b4fec79$var$IntervalSet();
            vocabularyIS.addAll(vocabulary);
        }
        return vocabularyIS.subtract(this);
    }
    subtract(a) {
        if (a == null || a.isNil) return new $ce0fc5f35b4fec79$var$IntervalSet(this._intervals);
        if (a instanceof $ce0fc5f35b4fec79$var$IntervalSet) return $ce0fc5f35b4fec79$var$IntervalSet.subtract(this, a);
        let other = new $ce0fc5f35b4fec79$var$IntervalSet();
        other.addAll(a);
        return $ce0fc5f35b4fec79$var$IntervalSet.subtract(this, other);
    }
    /**
     * Compute the set difference between two interval sets. The specific
     * operation is `left - right`.
     */ static subtract(left, right) {
        if (left.isNil) return new $ce0fc5f35b4fec79$var$IntervalSet();
        let result = new $ce0fc5f35b4fec79$var$IntervalSet(left._intervals);
        if (right.isNil) // right set has no elements; just return the copy of the current set
        return result;
        let resultI = 0;
        let rightI = 0;
        while(resultI < result._intervals.length && rightI < right._intervals.length){
            let resultInterval = result._intervals[resultI];
            let rightInterval = right._intervals[rightI];
            // operation: (resultInterval - rightInterval) and update indexes
            if (rightInterval.b < resultInterval.a) {
                rightI++;
                continue;
            }
            if (rightInterval.a > resultInterval.b) {
                resultI++;
                continue;
            }
            let beforeCurrent;
            let afterCurrent;
            if (rightInterval.a > resultInterval.a) beforeCurrent = new $gcfUE.Interval(resultInterval.a, rightInterval.a - 1);
            if (rightInterval.b < resultInterval.b) afterCurrent = new $gcfUE.Interval(rightInterval.b + 1, resultInterval.b);
            if (beforeCurrent) {
                if (afterCurrent) {
                    // split the current interval into two
                    result._intervals[resultI] = beforeCurrent;
                    result._intervals.splice(resultI + 1, 0, afterCurrent);
                    resultI++;
                    rightI++;
                    continue;
                } else {
                    // replace the current interval
                    result._intervals[resultI] = beforeCurrent;
                    resultI++;
                    continue;
                }
            } else if (afterCurrent) {
                // replace the current interval
                result._intervals[resultI] = afterCurrent;
                rightI++;
                continue;
            } else {
                // remove the current interval (thus no need to increment resultI)
                result._intervals.splice(resultI, 1);
                continue;
            }
        }
        // If rightI reached right.intervals.size, no more intervals to subtract from result.
        // If resultI reached result.intervals.size, we would be subtracting from an empty set.
        // Either way, we are done.
        return result;
    }
    or(a) {
        let o = new $ce0fc5f35b4fec79$var$IntervalSet();
        o.addAll(this);
        o.addAll(a);
        return o;
    }
    /** {@inheritDoc} */ and(other) {
        if (other.isNil) // nothing in common with null set
        return new $ce0fc5f35b4fec79$var$IntervalSet();
        let myIntervals = this._intervals;
        let theirIntervals = other._intervals;
        let intersection;
        let mySize = myIntervals.length;
        let theirSize = theirIntervals.length;
        let i = 0;
        let j = 0;
        // iterate down both interval lists looking for nondisjoint intervals
        while(i < mySize && j < theirSize){
            let mine = myIntervals[i];
            let theirs = theirIntervals[j];
            //System.out.println("mine="+mine+" and theirs="+theirs);
            if (mine.startsBeforeDisjoint(theirs)) // move this iterator looking for interval that might overlap
            i++;
            else if (theirs.startsBeforeDisjoint(mine)) // move other iterator looking for interval that might overlap
            j++;
            else if (mine.properlyContains(theirs)) {
                // overlap, add intersection, get next theirs
                if (!intersection) intersection = new $ce0fc5f35b4fec79$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                j++;
            } else if (theirs.properlyContains(mine)) {
                // overlap, add intersection, get next mine
                if (!intersection) intersection = new $ce0fc5f35b4fec79$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                i++;
            } else if (!mine.disjoint(theirs)) {
                // overlap, add intersection
                if (!intersection) intersection = new $ce0fc5f35b4fec79$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                // Move the iterator of lower range [a..b], but not
                // the upper range as it may contain elements that will collide
                // with the next iterator. So, if mine=[0..115] and
                // theirs=[115..200], then intersection is 115 and move mine
                // but not theirs as theirs may collide with the next range
                // in thisIter.
                // move both iterators to next ranges
                if (mine.startsAfterNonDisjoint(theirs)) j++;
                else if (theirs.startsAfterNonDisjoint(mine)) i++;
            }
        }
        if (!intersection) return new $ce0fc5f35b4fec79$var$IntervalSet();
        return intersection;
    }
    /** {@inheritDoc} */ contains(el) {
        let n = this._intervals.length;
        let l = 0;
        let r = n - 1;
        // Binary search for the element in the (sorted, disjoint) array of intervals.
        while(l <= r){
            let m = l + r >> 1;
            let I = this._intervals[m];
            let a = I.a;
            let b = I.b;
            if (b < el) l = m + 1;
            else if (a > el) r = m - 1;
            else // el >= a && el <= b
            return true;
        }
        return false;
    }
    /** {@inheritDoc} */ get isNil() {
        return this._intervals == null || this._intervals.length === 0;
    }
    /**
     * Returns the maximum value contained in the set if not isNil.
     *
     * @return the maximum value contained in the set.
     * @throws RangeError if set is empty
     */ get maxElement() {
        if (this.isNil) throw new RangeError("set is empty");
        let last = this._intervals[this._intervals.length - 1];
        return last.b;
    }
    /**
     * Returns the minimum value contained in the set if not isNil.
     *
     * @return the minimum value contained in the set.
     * @throws RangeError if set is empty
     */ get minElement() {
        if (this.isNil) throw new RangeError("set is empty");
        return this._intervals[0].a;
    }
    /** Return a list of Interval objects. */ get intervals() {
        return this._intervals;
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        for (let I of this._intervals){
            hash = $iXFjm.MurmurHash.update(hash, I.a);
            hash = $iXFjm.MurmurHash.update(hash, I.b);
        }
        hash = $iXFjm.MurmurHash.finish(hash, this._intervals.length * 2);
        return hash;
    }
    /** Are two IntervalSets equal?  Because all intervals are sorted
     *  and disjoint, equals is a simple linear walk over both lists
     *  to make sure they are the same.  Interval.equals() is used
     *  by the List.equals() method to check the ranges.
     */ equals(o) {
        if (o == null || !(o instanceof $ce0fc5f35b4fec79$var$IntervalSet)) return false;
        return $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this._intervals, o._intervals);
    }
    toString(elemAreChar = false) {
        let buf = "";
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) {
                if (a === $2DVsz.Token.EOF) buf += "<EOF>";
                else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'";
                else buf += a;
            } else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'..'" + String.fromCodePoint(b) + "'";
            else buf += a + ".." + b;
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    toStringVocabulary(vocabulary) {
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        let buf = "";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) buf += this.elementName(vocabulary, a);
            else for(let i = a; i <= b; i++){
                if (i > a) buf += ", ";
                buf += this.elementName(vocabulary, i);
            }
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    elementName(vocabulary, a) {
        if (a === $2DVsz.Token.EOF) return "<EOF>";
        else if (a === $2DVsz.Token.EPSILON) return "<EPSILON>";
        else return vocabulary.getDisplayName(a);
    }
    get size() {
        let n = 0;
        let numIntervals = this._intervals.length;
        if (numIntervals === 1) {
            let firstInterval = this._intervals[0];
            return firstInterval.b - firstInterval.a + 1;
        }
        for(let i = 0; i < numIntervals; i++){
            let I = this._intervals[i];
            n += I.b - I.a + 1;
        }
        return n;
    }
    toIntegerList() {
        let values = new $37SGk.IntegerList(this.size);
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.add(v);
        }
        return values;
    }
    toSet() {
        let s = new Set();
        for (let I of this._intervals){
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)s.add(v);
        }
        return s;
    }
    toArray() {
        let values = new Array();
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.push(v);
        }
        return values;
    }
    remove(el) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            if (el < a) break; // list is sorted and el is before this interval; not here
            // if whole interval x..x, rm
            if (el === a && el === b) {
                this._intervals.splice(i, 1);
                break;
            }
            // if on left edge x..b, adjust left
            if (el === a) {
                this._intervals[i] = $gcfUE.Interval.of(I.a + 1, I.b);
                break;
            }
            // if on right edge a..x, adjust right
            if (el === b) {
                this._intervals[i] = $gcfUE.Interval.of(I.a, I.b - 1);
                break;
            }
            // if in middle a..x..b, split interval
            if (el > a && el < b) {
                let oldb = I.b;
                this._intervals[i] = $gcfUE.Interval.of(I.a, el - 1); // [a..x-1]
                this.add(el + 1, oldb); // add [x+1..b]
            }
        }
    }
    get isReadonly() {
        return this.readonly;
    }
    setReadonly(readonly) {
        if (this.readonly && !readonly) throw new Error("can't alter readonly IntervalSet");
        this.readonly = readonly;
    }
}
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "addAll", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "complement", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "subtract", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "or", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "and", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "contains", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "isNil", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "hashCode", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "equals", null);
$ce0fc5f35b4fec79$var$__decorate([
    $ce0fc5f35b4fec79$var$__param(0, $d6D31.NotNull)
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "toStringVocabulary", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.NotNull,
    $ce0fc5f35b4fec79$var$__param(0, $d6D31.NotNull)
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "elementName", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "size", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.Override
], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "remove", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.NotNull
], $ce0fc5f35b4fec79$var$IntervalSet, "of", null);
$ce0fc5f35b4fec79$var$__decorate([
    $d6D31.NotNull
], $ce0fc5f35b4fec79$var$IntervalSet, "subtract", null);
module.exports.IntervalSet = $ce0fc5f35b4fec79$var$IntervalSet;

});
parcelRegister("37SGk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $246c712c5583aa9c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerList = void 0;

var $9yG1X = parcelRequire("9yG1X");

var $d6D31 = parcelRequire("d6D31");
const $246c712c5583aa9c$var$EMPTY_DATA = new Int32Array(0);
const $246c712c5583aa9c$var$INITIAL_SIZE = 4;
const $246c712c5583aa9c$var$MAX_ARRAY_SIZE = 2147483639;
/**
 *
 * @author Sam Harwell
 */ class $246c712c5583aa9c$var$IntegerList {
    constructor(arg){
        if (!arg) {
            this._data = $246c712c5583aa9c$var$EMPTY_DATA;
            this._size = 0;
        } else if (arg instanceof $246c712c5583aa9c$var$IntegerList) {
            this._data = arg._data.slice(0);
            this._size = arg._size;
        } else if (typeof arg === "number") {
            if (arg === 0) {
                this._data = $246c712c5583aa9c$var$EMPTY_DATA;
                this._size = 0;
            } else {
                this._data = new Int32Array(arg);
                this._size = 0;
            }
        } else {
            // arg is Iterable<number>
            this._data = $246c712c5583aa9c$var$EMPTY_DATA;
            this._size = 0;
            for (let value of arg)this.add(value);
        }
    }
    add(value) {
        if (this._data.length === this._size) this.ensureCapacity(this._size + 1);
        this._data[this._size] = value;
        this._size++;
    }
    addAll(list) {
        if (Array.isArray(list)) {
            this.ensureCapacity(this._size + list.length);
            this._data.subarray(this._size, this._size + list.length).set(list);
            this._size += list.length;
        } else if (list instanceof $246c712c5583aa9c$var$IntegerList) {
            this.ensureCapacity(this._size + list._size);
            this._data.subarray(this._size, this._size + list.size).set(list._data);
            this._size += list._size;
        } else {
            // list is JavaCollection<number>
            this.ensureCapacity(this._size + list.size);
            let current = 0;
            for (let xi of list){
                this._data[this._size + current] = xi;
                current++;
            }
            this._size += list.size;
        }
    }
    get(index) {
        if (index < 0 || index >= this._size) throw RangeError();
        return this._data[index];
    }
    contains(value) {
        for(let i = 0; i < this._size; i++){
            if (this._data[i] === value) return true;
        }
        return false;
    }
    set(index, value) {
        if (index < 0 || index >= this._size) throw RangeError();
        let previous = this._data[index];
        this._data[index] = value;
        return previous;
    }
    removeAt(index) {
        let value = this.get(index);
        this._data.copyWithin(index, index + 1, this._size);
        this._data[this._size - 1] = 0;
        this._size--;
        return value;
    }
    removeRange(fromIndex, toIndex) {
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw RangeError();
        if (fromIndex > toIndex) throw RangeError();
        this._data.copyWithin(toIndex, fromIndex, this._size);
        this._data.fill(0, this._size - (toIndex - fromIndex), this._size);
        this._size -= toIndex - fromIndex;
    }
    get isEmpty() {
        return this._size === 0;
    }
    get size() {
        return this._size;
    }
    trimToSize() {
        if (this._data.length === this._size) return;
        this._data = this._data.slice(0, this._size);
    }
    clear() {
        this._data.fill(0, 0, this._size);
        this._size = 0;
    }
    toArray() {
        if (this._size === 0) return [];
        return Array.from(this._data.subarray(0, this._size));
    }
    sort() {
        this._data.subarray(0, this._size).sort();
    }
    /**
     * Compares the specified object with this list for equality.  Returns
     * `true` if and only if the specified object is also an {@link IntegerList},
     * both lists have the same size, and all corresponding pairs of elements in
     * the two lists are equal.  In other words, two lists are defined to be
     * equal if they contain the same elements in the same order.
     *
     * This implementation first checks if the specified object is this
     * list. If so, it returns `true`; if not, it checks if the
     * specified object is an {@link IntegerList}. If not, it returns `false`;
     * if so, it checks the size of both lists. If the lists are not the same size,
     * it returns `false`; otherwise it iterates over both lists, comparing
     * corresponding pairs of elements.  If any comparison returns `false`,
     * this method returns `false`.
     *
     * @param o the object to be compared for equality with this list
     * @returns `true` if the specified object is equal to this list
     */ equals(o) {
        if (o === this) return true;
        if (!(o instanceof $246c712c5583aa9c$var$IntegerList)) return false;
        if (this._size !== o._size) return false;
        for(let i = 0; i < this._size; i++){
            if (this._data[i] !== o._data[i]) return false;
        }
        return true;
    }
    /**
     * Returns the hash code value for this list.
     *
     * This implementation uses exactly the code that is used to define the
     * list hash function in the documentation for the {@link List#hashCode}
     * method.
     *
     * @returns the hash code value for this list
     */ hashCode() {
        let hashCode = 1;
        for(let i = 0; i < this._size; i++)hashCode = 31 * hashCode + this._data[i];
        return hashCode;
    }
    /**
     * Returns a string representation of this list.
     */ toString() {
        return this._data.toString();
    }
    binarySearch(key, fromIndex, toIndex) {
        if (fromIndex === undefined) fromIndex = 0;
        if (toIndex === undefined) toIndex = this._size;
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw new RangeError();
        if (fromIndex > toIndex) throw new RangeError();
        return $9yG1X.Arrays.binarySearch(this._data, key, fromIndex, toIndex);
    }
    ensureCapacity(capacity) {
        if (capacity < 0 || capacity > $246c712c5583aa9c$var$MAX_ARRAY_SIZE) throw new RangeError();
        let newLength;
        if (this._data.length === 0) newLength = $246c712c5583aa9c$var$INITIAL_SIZE;
        else newLength = this._data.length;
        while(newLength < capacity){
            newLength = newLength * 2;
            if (newLength < 0 || newLength > $246c712c5583aa9c$var$MAX_ARRAY_SIZE) newLength = $246c712c5583aa9c$var$MAX_ARRAY_SIZE;
        }
        let tmp = new Int32Array(newLength);
        tmp.set(this._data);
        this._data = tmp;
    }
    /** Convert the list to a UTF-16 encoded char array. If all values are less
     *  than the 0xFFFF 16-bit code point limit then this is just a char array
     *  of 16-bit char as usual. For values in the supplementary range, encode
     * them as two UTF-16 code units.
     */ toCharArray() {
        // Optimize for the common case (all data values are < 0xFFFF) to avoid an extra scan
        let resultArray = new Uint16Array(this._size);
        let resultIdx = 0;
        let calculatedPreciseResultSize = false;
        for(let i = 0; i < this._size; i++){
            let codePoint = this._data[i];
            if (codePoint >= 0 && codePoint < 0x10000) {
                resultArray[resultIdx] = codePoint;
                resultIdx++;
                continue;
            }
            // Calculate the precise result size if we encounter a code point > 0xFFFF
            if (!calculatedPreciseResultSize) {
                let newResultArray = new Uint16Array(this.charArraySize());
                newResultArray.set(resultArray, 0);
                resultArray = newResultArray;
                calculatedPreciseResultSize = true;
            }
            // This will throw RangeError if the code point is not a valid Unicode code point
            let pair = String.fromCodePoint(codePoint);
            resultArray[resultIdx] = pair.charCodeAt(0);
            resultArray[resultIdx + 1] = pair.charCodeAt(1);
            resultIdx += 2;
        }
        return resultArray;
    }
    charArraySize() {
        let result = 0;
        for(let i = 0; i < this._size; i++)result += this._data[i] >= 0x10000 ? 2 : 1;
        return result;
    }
}
$246c712c5583aa9c$var$__decorate([
    $d6D31.NotNull
], $246c712c5583aa9c$var$IntegerList.prototype, "_data", void 0);
$246c712c5583aa9c$var$__decorate([
    $d6D31.Override
], $246c712c5583aa9c$var$IntegerList.prototype, "equals", null);
$246c712c5583aa9c$var$__decorate([
    $d6D31.Override
], $246c712c5583aa9c$var$IntegerList.prototype, "hashCode", null);
$246c712c5583aa9c$var$__decorate([
    $d6D31.Override
], $246c712c5583aa9c$var$IntegerList.prototype, "toString", null);
module.exports.IntegerList = $246c712c5583aa9c$var$IntegerList;

});
parcelRegister("9yG1X", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Arrays = void 0;
var $6f57e46e4dc9d39b$var$Arrays;
(function(Arrays) {
    /**
     * Searches the specified array of numbers for the specified value using the binary search algorithm. The array must
     * be sorted prior to making this call. If it is not sorted, the results are unspecified. If the array contains
     * multiple elements with the specified value, there is no guarantee which one will be found.
     *
     * @returns index of the search key, if it is contained in the array; otherwise, (-(insertion point) - 1). The
     * insertion point is defined as the point at which the key would be inserted into the array: the index of the first
     * element greater than the key, or array.length if all elements in the array are less than the specified key. Note
     * that this guarantees that the return value will be >= 0 if and only if the key is found.
     */ function binarySearch(array, key, fromIndex, toIndex) {
        return binarySearch0(array, fromIndex !== undefined ? fromIndex : 0, toIndex !== undefined ? toIndex : array.length, key);
    }
    Arrays.binarySearch = binarySearch;
    function binarySearch0(array, fromIndex, toIndex, key) {
        let low = fromIndex;
        let high = toIndex - 1;
        while(low <= high){
            let mid = low + high >>> 1;
            let midVal = array[mid];
            if (midVal < key) low = mid + 1;
            else if (midVal > key) high = mid - 1;
            else // key found
            return mid;
        }
        // key not found.
        return -(low + 1);
    }
    function toString(array) {
        let result = "[";
        let first = true;
        for (let element of array){
            if (first) first = false;
            else result += ", ";
            if (element === null) result += "null";
            else if (element === undefined) result += "undefined";
            else result += element;
        }
        result += "]";
        return result;
    }
    Arrays.toString = toString;
})($6f57e46e4dc9d39b$var$Arrays = module.exports.Arrays || (module.exports.Arrays = {}));

});


parcelRegister("gcfUE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bcaa1c4749d34439$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Interval = void 0;

var $d6D31 = parcelRequire("d6D31");
const $bcaa1c4749d34439$var$INTERVAL_POOL_MAX_VALUE = 1000;
/** An immutable inclusive interval a..b */ class $bcaa1c4749d34439$var$Interval {
    /**
     * @param a The start of the interval
     * @param b The end of the interval (inclusive)
     */ constructor(a, b){
        this.a = a;
        this.b = b;
    }
    static get INVALID() {
        return $bcaa1c4749d34439$var$Interval._INVALID;
    }
    /** Interval objects are used readonly so share all with the
     *  same single value a==b up to some max size.  Use an array as a perfect hash.
     *  Return shared object for 0..INTERVAL_POOL_MAX_VALUE or a new
     *  Interval object with a..a in it.  On Java.g4, 218623 IntervalSets
     *  have a..a (set with 1 element).
     */ static of(a, b) {
        // cache just a..a
        if (a !== b || a < 0 || a > $bcaa1c4749d34439$var$INTERVAL_POOL_MAX_VALUE) return new $bcaa1c4749d34439$var$Interval(a, b);
        if ($bcaa1c4749d34439$var$Interval.cache[a] == null) $bcaa1c4749d34439$var$Interval.cache[a] = new $bcaa1c4749d34439$var$Interval(a, a);
        return $bcaa1c4749d34439$var$Interval.cache[a];
    }
    /** return number of elements between a and b inclusively. x..x is length 1.
     *  if b &lt; a, then length is 0.  9..10 has length 2.
     */ get length() {
        if (this.b < this.a) return 0;
        return this.b - this.a + 1;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof $bcaa1c4749d34439$var$Interval)) return false;
        return this.a === o.a && this.b === o.b;
    }
    hashCode() {
        let hash = 23;
        hash = hash * 31 + this.a;
        hash = hash * 31 + this.b;
        return hash;
    }
    /** Does this start completely before other? Disjoint */ startsBeforeDisjoint(other) {
        return this.a < other.a && this.b < other.a;
    }
    /** Does this start at or before other? Nondisjoint */ startsBeforeNonDisjoint(other) {
        return this.a <= other.a && this.b >= other.a;
    }
    /** Does this.a start after other.b? May or may not be disjoint */ startsAfter(other) {
        return this.a > other.a;
    }
    /** Does this start completely after other? Disjoint */ startsAfterDisjoint(other) {
        return this.a > other.b;
    }
    /** Does this start after other? NonDisjoint */ startsAfterNonDisjoint(other) {
        return this.a > other.a && this.a <= other.b; // this.b>=other.b implied
    }
    /** Are both ranges disjoint? I.e., no overlap? */ disjoint(other) {
        return this.startsBeforeDisjoint(other) || this.startsAfterDisjoint(other);
    }
    /** Are two intervals adjacent such as 0..41 and 42..42? */ adjacent(other) {
        return this.a === other.b + 1 || this.b === other.a - 1;
    }
    properlyContains(other) {
        return other.a >= this.a && other.b <= this.b;
    }
    /** Return the interval computed from combining this and other */ union(other) {
        return $bcaa1c4749d34439$var$Interval.of(Math.min(this.a, other.a), Math.max(this.b, other.b));
    }
    /** Return the interval in common between this and o */ intersection(other) {
        return $bcaa1c4749d34439$var$Interval.of(Math.max(this.a, other.a), Math.min(this.b, other.b));
    }
    /** Return the interval with elements from `this` not in `other`;
     *  `other` must not be totally enclosed (properly contained)
     *  within `this`, which would result in two disjoint intervals
     *  instead of the single one returned by this method.
     */ differenceNotProperlyContained(other) {
        let diff;
        if (other.startsBeforeNonDisjoint(this)) // other.a to left of this.a (or same)
        diff = $bcaa1c4749d34439$var$Interval.of(Math.max(this.a, other.b + 1), this.b);
        else if (other.startsAfterNonDisjoint(this)) // other.a to right of this.a
        diff = $bcaa1c4749d34439$var$Interval.of(this.a, other.a - 1);
        return diff;
    }
    toString() {
        return this.a + ".." + this.b;
    }
}
$bcaa1c4749d34439$var$Interval._INVALID = new $bcaa1c4749d34439$var$Interval(-1, -2);
$bcaa1c4749d34439$var$Interval.cache = new Array($bcaa1c4749d34439$var$INTERVAL_POOL_MAX_VALUE + 1);
$bcaa1c4749d34439$var$__decorate([
    $d6D31.Override
], $bcaa1c4749d34439$var$Interval.prototype, "equals", null);
$bcaa1c4749d34439$var$__decorate([
    $d6D31.Override
], $bcaa1c4749d34439$var$Interval.prototype, "hashCode", null);
$bcaa1c4749d34439$var$__decorate([
    $d6D31.Override
], $bcaa1c4749d34439$var$Interval.prototype, "toString", null);
module.exports.Interval = $bcaa1c4749d34439$var$Interval;

});

parcelRegister("igNLf", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d4d0521f20d9c4ac$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Lexer = void 0;

var $gWaB3 = parcelRequire("gWaB3");

var $6Kebn = parcelRequire("6Kebn");

var $gcfUE = parcelRequire("gcfUE");

var $ceaEj = parcelRequire("ceaEj");

var $lQecE = parcelRequire("lQecE");

var $fOEQQ = parcelRequire("fOEQQ");

var $d6D31 = parcelRequire("d6D31");

var $kBaAZ = parcelRequire("kBaAZ");

var $2DVsz = parcelRequire("2DVsz");
/** A lexer is recognizer that draws input symbols from a character stream.
 *  lexer grammars result in a subclass of this object. A Lexer object
 *  uses simplified match() and error recovery mechanisms in the interest
 *  of speed.
 */ class $d4d0521f20d9c4ac$var$Lexer extends $kBaAZ.Recognizer {
    constructor(input){
        super();
        /** How to create token objects */ this._factory = $gWaB3.CommonTokenFactory.DEFAULT;
        /** What character index in the stream did the current token start at?
         *  Needed, for example, to get the text for current token.  Set at
         *  the start of nextToken.
         */ this._tokenStartCharIndex = -1;
        /** The line on which the first character of the token resides */ this._tokenStartLine = 0;
        /** The character position of first character within the line */ this._tokenStartCharPositionInLine = 0;
        /** Once we see EOF on char stream, next token will be EOF.
         *  If you have DONE : EOF ; then you see DONE EOF.
         */ this._hitEOF = false;
        /** The channel number for the current token */ this._channel = 0;
        /** The token type for the current token */ this._type = 0;
        this._modeStack = new $6Kebn.IntegerStack();
        this._mode = $d4d0521f20d9c4ac$var$Lexer.DEFAULT_MODE;
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: input
        };
    }
    static get DEFAULT_TOKEN_CHANNEL() {
        return $2DVsz.Token.DEFAULT_CHANNEL;
    }
    static get HIDDEN() {
        return $2DVsz.Token.HIDDEN_CHANNEL;
    }
    reset(resetInput) {
        // wack Lexer state variables
        if (resetInput === undefined || resetInput) this._input.seek(0); // rewind the input
        this._token = undefined;
        this._type = $2DVsz.Token.INVALID_TYPE;
        this._channel = $2DVsz.Token.DEFAULT_CHANNEL;
        this._tokenStartCharIndex = -1;
        this._tokenStartCharPositionInLine = -1;
        this._tokenStartLine = -1;
        this._text = undefined;
        this._hitEOF = false;
        this._mode = $d4d0521f20d9c4ac$var$Lexer.DEFAULT_MODE;
        this._modeStack.clear();
        this.interpreter.reset();
    }
    /** Return a token from this source; i.e., match a token on the char
     *  stream.
     */ nextToken() {
        if (this._input == null) throw new Error("nextToken requires a non-null input stream.");
        // Mark start location in char stream so unbuffered streams are
        // guaranteed at least have text of current token
        let tokenStartMarker = this._input.mark();
        try {
            outer: while(true){
                if (this._hitEOF) return this.emitEOF();
                this._token = undefined;
                this._channel = $2DVsz.Token.DEFAULT_CHANNEL;
                this._tokenStartCharIndex = this._input.index;
                this._tokenStartCharPositionInLine = this.interpreter.charPositionInLine;
                this._tokenStartLine = this.interpreter.line;
                this._text = undefined;
                do {
                    this._type = $2DVsz.Token.INVALID_TYPE;
                    //				System.out.println("nextToken line "+tokenStartLine+" at "+((char)input.LA(1))+
                    //								   " in mode "+mode+
                    //								   " at index "+input.index);
                    let ttype;
                    try {
                        ttype = this.interpreter.match(this._input, this._mode);
                    } catch (e) {
                        if (e instanceof $fOEQQ.LexerNoViableAltException) {
                            this.notifyListeners(e); // report error
                            this.recover(e);
                            ttype = $d4d0521f20d9c4ac$var$Lexer.SKIP;
                        } else throw e;
                    }
                    if (this._input.LA(1) === $ceaEj.IntStream.EOF) this._hitEOF = true;
                    if (this._type === $2DVsz.Token.INVALID_TYPE) this._type = ttype;
                    if (this._type === $d4d0521f20d9c4ac$var$Lexer.SKIP) continue outer;
                }while (this._type === $d4d0521f20d9c4ac$var$Lexer.MORE);
                if (this._token == null) return this.emit();
                return this._token;
            }
        } finally{
            // make sure we release marker after match or
            // unbuffered char stream will keep buffering
            this._input.release(tokenStartMarker);
        }
    }
    /** Instruct the lexer to skip creating a token for current lexer rule
     *  and look for another token.  nextToken() knows to keep looking when
     *  a lexer rule finishes with token set to SKIP_TOKEN.  Recall that
     *  if token==undefined at end of any token rule, it creates one for you
     *  and emits it.
     */ skip() {
        this._type = $d4d0521f20d9c4ac$var$Lexer.SKIP;
    }
    more() {
        this._type = $d4d0521f20d9c4ac$var$Lexer.MORE;
    }
    mode(m) {
        this._mode = m;
    }
    pushMode(m) {
        if ($lQecE.LexerATNSimulator.debug) console.log("pushMode " + m);
        this._modeStack.push(this._mode);
        this.mode(m);
    }
    popMode() {
        if (this._modeStack.isEmpty) throw new Error("EmptyStackException");
        if ($lQecE.LexerATNSimulator.debug) console.log("popMode back to " + this._modeStack.peek());
        this.mode(this._modeStack.pop());
        return this._mode;
    }
    get tokenFactory() {
        return this._factory;
    }
    // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the char stream and reset the lexer */ set inputStream(input) {
        this.reset(false);
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: this._input
        };
    }
    get sourceName() {
        return this._input.sourceName;
    }
    emit(token) {
        if (!token) token = this._factory.create(this._tokenFactorySourcePair, this._type, this._text, this._channel, this._tokenStartCharIndex, this.charIndex - 1, this._tokenStartLine, this._tokenStartCharPositionInLine);
        this._token = token;
        return token;
    }
    emitEOF() {
        let cpos = this.charPositionInLine;
        let line = this.line;
        let eof = this._factory.create(this._tokenFactorySourcePair, $2DVsz.Token.EOF, undefined, $2DVsz.Token.DEFAULT_CHANNEL, this._input.index, this._input.index - 1, line, cpos);
        this.emit(eof);
        return eof;
    }
    get line() {
        return this.interpreter.line;
    }
    set line(line) {
        this.interpreter.line = line;
    }
    get charPositionInLine() {
        return this.interpreter.charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this.interpreter.charPositionInLine = charPositionInLine;
    }
    /** What is the index of the current character of lookahead? */ get charIndex() {
        return this._input.index;
    }
    /** Return the text matched so far for the current token or any
     *  text override.
     */ get text() {
        if (this._text != null) return this._text;
        return this.interpreter.getText(this._input);
    }
    /** Set the complete text of this token; it wipes any previous
     *  changes to the text.
     */ set text(text) {
        this._text = text;
    }
    /** Override if emitting multiple tokens. */ get token() {
        return this._token;
    }
    set token(_token) {
        this._token = _token;
    }
    set type(ttype) {
        this._type = ttype;
    }
    get type() {
        return this._type;
    }
    set channel(channel) {
        this._channel = channel;
    }
    get channel() {
        return this._channel;
    }
    /** Return a list of all Token objects in input char stream.
     *  Forces load of all tokens. Does not include EOF token.
     */ getAllTokens() {
        let tokens = [];
        let t = this.nextToken();
        while(t.type !== $2DVsz.Token.EOF){
            tokens.push(t);
            t = this.nextToken();
        }
        return tokens;
    }
    notifyListeners(e) {
        let text = this._input.getText($gcfUE.Interval.of(this._tokenStartCharIndex, this._input.index));
        let msg = "token recognition error at: '" + this.getErrorDisplay(text) + "'";
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, undefined, this._tokenStartLine, this._tokenStartCharPositionInLine, msg, e);
    }
    getErrorDisplay(s) {
        if (typeof s === "number") {
            switch(s){
                case $2DVsz.Token.EOF:
                    return "<EOF>";
                case 0x0a:
                    return "\\n";
                case 0x09:
                    return "\\t";
                case 0x0d:
                    return "\\r";
            }
            return String.fromCharCode(s);
        }
        return s.replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r");
    }
    getCharErrorDisplay(c) {
        let s = this.getErrorDisplay(c);
        return "'" + s + "'";
    }
    recover(re) {
        if (re instanceof $fOEQQ.LexerNoViableAltException) {
            if (this._input.LA(1) !== $ceaEj.IntStream.EOF) // skip a char and try again
            this.interpreter.consume(this._input);
        } else //System.out.println("consuming char "+(char)input.LA(1)+" during recovery");
        //re.printStackTrace();
        // TODO: Do we lose character or line position information?
        this._input.consume();
    }
}
$d4d0521f20d9c4ac$var$Lexer.DEFAULT_MODE = 0;
$d4d0521f20d9c4ac$var$Lexer.MORE = -2;
$d4d0521f20d9c4ac$var$Lexer.SKIP = -3;
$d4d0521f20d9c4ac$var$Lexer.MIN_CHAR_VALUE = 0x0000;
$d4d0521f20d9c4ac$var$Lexer.MAX_CHAR_VALUE = 0x10FFFF;
$d4d0521f20d9c4ac$var$__decorate([
    $d6D31.Override
], $d4d0521f20d9c4ac$var$Lexer.prototype, "nextToken", null);
$d4d0521f20d9c4ac$var$__decorate([
    $d6D31.Override
], $d4d0521f20d9c4ac$var$Lexer.prototype, "tokenFactory", null);
$d4d0521f20d9c4ac$var$__decorate([
    $d6D31.Override
], $d4d0521f20d9c4ac$var$Lexer.prototype, "inputStream", null);
$d4d0521f20d9c4ac$var$__decorate([
    $d6D31.Override
], $d4d0521f20d9c4ac$var$Lexer.prototype, "sourceName", null);
$d4d0521f20d9c4ac$var$__decorate([
    $d6D31.Override
], $d4d0521f20d9c4ac$var$Lexer.prototype, "line", null);
$d4d0521f20d9c4ac$var$__decorate([
    $d6D31.Override
], $d4d0521f20d9c4ac$var$Lexer.prototype, "charPositionInLine", null);
module.exports.Lexer = $d4d0521f20d9c4ac$var$Lexer;

});
parcelRegister("gWaB3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c54a4863b793dbc8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenFactory = void 0;

var $j53rr = parcelRequire("j53rr");

var $gcfUE = parcelRequire("gcfUE");

var $d6D31 = parcelRequire("d6D31");
/**
 * This default implementation of {@link TokenFactory} creates
 * {@link CommonToken} objects.
 */ class $c54a4863b793dbc8$var$CommonTokenFactory {
    /**
     * Constructs a {@link CommonTokenFactory} with the specified value for
     * {@link #copyText}.
     *
     * When `copyText` is `false`, the {@link #DEFAULT} instance
     * should be used instead of constructing a new instance.
     *
     * @param copyText The value for {@link #copyText}.
     */ constructor(copyText = false){
        this.copyText = copyText;
    }
    create(source, type, text, channel, start, stop, line, charPositionInLine) {
        let t = new $j53rr.CommonToken(type, text, source, channel, start, stop);
        t.line = line;
        t.charPositionInLine = charPositionInLine;
        if (text == null && this.copyText && source.stream != null) t.text = source.stream.getText($gcfUE.Interval.of(start, stop));
        return t;
    }
    createSimple(type, text) {
        return new $j53rr.CommonToken(type, text);
    }
}
$c54a4863b793dbc8$var$__decorate([
    $d6D31.Override
], $c54a4863b793dbc8$var$CommonTokenFactory.prototype, "create", null);
$c54a4863b793dbc8$var$__decorate([
    $d6D31.Override
], $c54a4863b793dbc8$var$CommonTokenFactory.prototype, "createSimple", null);
module.exports.CommonTokenFactory = $c54a4863b793dbc8$var$CommonTokenFactory;
(function(CommonTokenFactory) {
    /**
     * The default {@link CommonTokenFactory} instance.
     *
     * This token factory does not explicitly copy token text when constructing
     * tokens.
     */ CommonTokenFactory.DEFAULT = new CommonTokenFactory();
})($c54a4863b793dbc8$var$CommonTokenFactory = module.exports.CommonTokenFactory || (module.exports.CommonTokenFactory = {}));

});
parcelRegister("j53rr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $de41275c931ca469$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $de41275c931ca469$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonToken = void 0;

var $gcfUE = parcelRequire("gcfUE");

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");
let $de41275c931ca469$var$CommonToken = class CommonToken {
    constructor(type, text, source = CommonToken.EMPTY_SOURCE, channel = $2DVsz.Token.DEFAULT_CHANNEL, start = 0, stop = 0){
        /**
         * This is the backing field for {@link #getLine} and {@link #setLine}.
         */ this._line = 0;
        /**
         * This is the backing field for {@link #getCharPositionInLine} and
         * {@link #setCharPositionInLine}.
         */ this._charPositionInLine = -1; // set to invalid position
        /**
         * This is the backing field for {@link #getChannel} and
         * {@link #setChannel}.
         */ this._channel = $2DVsz.Token.DEFAULT_CHANNEL;
        /**
         * This is the backing field for `tokenIndex`.
         */ this.index = -1;
        this._text = text;
        this._type = type;
        this.source = source;
        this._channel = channel;
        this.start = start;
        this.stop = stop;
        if (source.source != null) {
            this._line = source.source.line;
            this._charPositionInLine = source.source.charPositionInLine;
        }
    }
    /**
     * Constructs a new {@link CommonToken} as a copy of another {@link Token}.
     *
     * If `oldToken` is also a {@link CommonToken} instance, the newly
     * constructed token will share a reference to the {@link #text} field and
     * the {@link Tuple2} stored in {@link #source}. Otherwise, {@link #text} will
     * be assigned the result of calling {@link #getText}, and {@link #source}
     * will be constructed from the result of {@link Token#getTokenSource} and
     * {@link Token#getInputStream}.
     *
     * @param oldToken The token to copy.
     */ static fromToken(oldToken) {
        let result = new CommonToken(oldToken.type, undefined, CommonToken.EMPTY_SOURCE, oldToken.channel, oldToken.startIndex, oldToken.stopIndex);
        result._line = oldToken.line;
        result.index = oldToken.tokenIndex;
        result._charPositionInLine = oldToken.charPositionInLine;
        if (oldToken instanceof CommonToken) {
            result._text = oldToken._text;
            result.source = oldToken.source;
        } else {
            result._text = oldToken.text;
            result.source = {
                source: oldToken.tokenSource,
                stream: oldToken.inputStream
            };
        }
        return result;
    }
    get type() {
        return this._type;
    }
    // @Override
    set type(type) {
        this._type = type;
    }
    get line() {
        return this._line;
    }
    // @Override
    set line(line) {
        this._line = line;
    }
    get text() {
        if (this._text != null) return this._text;
        let input = this.inputStream;
        if (input == null) return undefined;
        let n = input.size;
        if (this.start < n && this.stop < n) return input.getText($gcfUE.Interval.of(this.start, this.stop));
        else return "<EOF>";
    }
    /**
     * Explicitly set the text for this token. If {code text} is not
     * `undefined`, then {@link #getText} will return this value rather than
     * extracting the text from the input.
     *
     * @param text The explicit text of the token, or `undefined` if the text
     * should be obtained from the input along with the start and stop indexes
     * of the token.
     */ // @Override
    set text(text) {
        this._text = text;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    // @Override
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    get channel() {
        return this._channel;
    }
    // @Override
    set channel(channel) {
        this._channel = channel;
    }
    get startIndex() {
        return this.start;
    }
    set startIndex(start) {
        this.start = start;
    }
    get stopIndex() {
        return this.stop;
    }
    set stopIndex(stop) {
        this.stop = stop;
    }
    get tokenIndex() {
        return this.index;
    }
    // @Override
    set tokenIndex(index) {
        this.index = index;
    }
    get tokenSource() {
        return this.source.source;
    }
    get inputStream() {
        return this.source.stream;
    }
    toString(recognizer) {
        let channelStr = "";
        if (this._channel > 0) channelStr = ",channel=" + this._channel;
        let txt = this.text;
        if (txt != null) {
            txt = txt.replace(/\n/g, "\\n");
            txt = txt.replace(/\r/g, "\\r");
            txt = txt.replace(/\t/g, "\\t");
        } else txt = "<no text>";
        let typeString = String(this._type);
        if (recognizer) typeString = recognizer.vocabulary.getDisplayName(this._type);
        return "[@" + this.tokenIndex + "," + this.start + ":" + this.stop + "='" + txt + "',<" + typeString + ">" + channelStr + "," + this._line + ":" + this.charPositionInLine + "]";
    }
};
/**
 * An empty {@link Tuple2} which is used as the default value of
 * {@link #source} for tokens that do not have a source.
 */ $de41275c931ca469$var$CommonToken.EMPTY_SOURCE = {
    source: undefined,
    stream: undefined
};
$de41275c931ca469$var$__decorate([
    $d6D31.NotNull
], $de41275c931ca469$var$CommonToken.prototype, "source", void 0);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "type", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "line", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "text", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "charPositionInLine", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "channel", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "startIndex", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "stopIndex", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "tokenIndex", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "tokenSource", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "inputStream", null);
$de41275c931ca469$var$__decorate([
    $d6D31.Override
], $de41275c931ca469$var$CommonToken.prototype, "toString", null);
$de41275c931ca469$var$__decorate([
    $de41275c931ca469$var$__param(0, $d6D31.NotNull)
], $de41275c931ca469$var$CommonToken, "fromToken", null);
$de41275c931ca469$var$CommonToken = $de41275c931ca469$var$__decorate([
    $de41275c931ca469$var$__param(2, $d6D31.NotNull)
], $de41275c931ca469$var$CommonToken);
module.exports.CommonToken = $de41275c931ca469$var$CommonToken;

});
parcelRegister("2DVsz", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Token = void 0;

var $ceaEj = parcelRequire("ceaEj");
var $1ecbcb9fde4eac7e$var$Token;
(function(Token) {
    Token.INVALID_TYPE = 0;
    /** During lookahead operations, this "token" signifies we hit rule end ATN state
     *  and did not follow it despite needing to.
     */ Token.EPSILON = -2;
    Token.MIN_USER_TOKEN_TYPE = 1;
    Token.EOF = $ceaEj.IntStream.EOF;
    /** All tokens go to the parser (unless skip() is called in that rule)
     *  on a particular "channel".  The parser tunes to a particular channel
     *  so that whitespace etc... can go to the parser on a "hidden" channel.
     */ Token.DEFAULT_CHANNEL = 0;
    /** Anything on different channel than DEFAULT_CHANNEL is not parsed
     *  by parser.
     */ Token.HIDDEN_CHANNEL = 1;
    /**
     * This is the minimum constant value which can be assigned to a
     * user-defined token channel.
     *
     * The non-negative numbers less than {@link #MIN_USER_CHANNEL_VALUE} are
     * assigned to the predefined channels {@link #DEFAULT_CHANNEL} and
     * {@link #HIDDEN_CHANNEL}.
     *
     * @see `Token.channel`
     */ Token.MIN_USER_CHANNEL_VALUE = 2;
})($1ecbcb9fde4eac7e$var$Token = module.exports.Token || (module.exports.Token = {}));

});



parcelRegister("6Kebn", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerStack = void 0;

var $37SGk = parcelRequire("37SGk");
/**
 *
 * @author Sam Harwell
 */ class $4e920a4df7f4a425$var$IntegerStack extends $37SGk.IntegerList {
    constructor(arg){
        super(arg);
    }
    push(value) {
        this.add(value);
    }
    pop() {
        return this.removeAt(this.size - 1);
    }
    peek() {
        return this.get(this.size - 1);
    }
}
module.exports.IntegerStack = $4e920a4df7f4a425$var$IntegerStack;

});

parcelRegister("lQecE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $fe6978bd928c111b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $fe6978bd928c111b$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerATNSimulator = void 0;

var $41NTU = parcelRequire("41NTU");

var $bcnvE = parcelRequire("bcnvE");

var $gcX0f = parcelRequire("gcX0f");

var $c1ClW = parcelRequire("c1ClW");

var $kr9A1 = parcelRequire("kr9A1");

var $2jevZ = parcelRequire("2jevZ");

var $gcfUE = parcelRequire("gcfUE");

var $ceaEj = parcelRequire("ceaEj");

var $igNLf = parcelRequire("igNLf");

var $3AYVu = parcelRequire("3AYVu");

var $fOEQQ = parcelRequire("fOEQQ");

var $d6D31 = parcelRequire("d6D31");

var $9tIYC = parcelRequire("9tIYC");

var $8DTT0 = parcelRequire("8DTT0");

var $4kGBm = parcelRequire("4kGBm");

var $2DVsz = parcelRequire("2DVsz");

var $bbHFU = parcelRequire("bbHFU");
/** "dup" of ParserInterpreter */ let $fe6978bd928c111b$var$LexerATNSimulator = class LexerATNSimulator extends $kr9A1.ATNSimulator {
    constructor(atn, recog){
        super(atn);
        this.optimize_tail_calls = true;
        /** The current token's starting index into the character stream.
         *  Shared across DFA to ATN simulation in case the ATN fails and the
         *  DFA did not have a previous accept state. In this case, we use the
         *  ATN-generated exception object.
         */ this.startIndex = -1;
        /** line number 1..n within the input */ this._line = 1;
        /** The index of the character relative to the beginning of the line 0..n-1 */ this._charPositionInLine = 0;
        this.mode = $igNLf.Lexer.DEFAULT_MODE;
        /** Used during DFA/ATN exec to record the most recent accept configuration info */ this.prevAccept = new LexerATNSimulator.SimState();
        this.recog = recog;
    }
    copyState(simulator) {
        this._charPositionInLine = simulator.charPositionInLine;
        this._line = simulator._line;
        this.mode = simulator.mode;
        this.startIndex = simulator.startIndex;
    }
    match(input, mode) {
        this.mode = mode;
        let mark = input.mark();
        try {
            this.startIndex = input.index;
            this.prevAccept.reset();
            let s0 = this.atn.modeToDFA[mode].s0;
            if (s0 == null) return this.matchATN(input);
            else return this.execATN(input, s0);
        } finally{
            input.release(mark);
        }
    }
    reset() {
        this.prevAccept.reset();
        this.startIndex = -1;
        this._line = 1;
        this._charPositionInLine = 0;
        this.mode = $igNLf.Lexer.DEFAULT_MODE;
    }
    matchATN(input) {
        let startState = this.atn.modeToStartState[this.mode];
        if (LexerATNSimulator.debug) console.log(`matchATN mode ${this.mode} start: ${startState}`);
        let old_mode = this.mode;
        let s0_closure = this.computeStartState(input, startState);
        let suppressEdge = s0_closure.hasSemanticContext;
        if (suppressEdge) s0_closure.hasSemanticContext = false;
        let next = this.addDFAState(s0_closure);
        if (!suppressEdge) {
            let dfa = this.atn.modeToDFA[this.mode];
            if (!dfa.s0) dfa.s0 = next;
            else next = dfa.s0;
        }
        let predict = this.execATN(input, next);
        if (LexerATNSimulator.debug) console.log(`DFA after matchATN: ${this.atn.modeToDFA[old_mode].toLexerString()}`);
        return predict;
    }
    execATN(input, ds0) {
        // console.log("enter exec index "+input.index+" from "+ds0.configs);
        if (LexerATNSimulator.debug) console.log(`start state closure=${ds0.configs}`);
        if (ds0.isAcceptState) // allow zero-length tokens
        this.captureSimState(this.prevAccept, input, ds0);
        let t = input.LA(1);
        // @NotNull
        let s = ds0; // s is current/from DFA state
        while(true){
            if (LexerATNSimulator.debug) console.log(`execATN loop starting closure: ${s.configs}`);
            // As we move src->trg, src->trg, we keep track of the previous trg to
            // avoid looking up the DFA state again, which is expensive.
            // If the previous target was already part of the DFA, we might
            // be able to avoid doing a reach operation upon t. If s!=null,
            // it means that semantic predicates didn't prevent us from
            // creating a DFA state. Once we know s!=null, we check to see if
            // the DFA state has an edge already for t. If so, we can just reuse
            // it's configuration set; there's no point in re-computing it.
            // This is kind of like doing DFA simulation within the ATN
            // simulation because DFA simulation is really just a way to avoid
            // computing reach/closure sets. Technically, once we know that
            // we have a previously added DFA state, we could jump over to
            // the DFA simulator. But, that would mean popping back and forth
            // a lot and making things more complicated algorithmically.
            // This optimization makes a lot of sense for loops within DFA.
            // A character will take us back to an existing DFA state
            // that already has lots of edges out of it. e.g., .* in comments.
            let target = this.getExistingTargetState(s, t);
            if (target == null) target = this.computeTargetState(input, s, t);
            if (target === $kr9A1.ATNSimulator.ERROR) break;
            // If this is a consumable input element, make sure to consume before
            // capturing the accept state so the input index, line, and char
            // position accurately reflect the state of the interpreter at the
            // end of the token.
            if (t !== $ceaEj.IntStream.EOF) this.consume(input);
            if (target.isAcceptState) {
                this.captureSimState(this.prevAccept, input, target);
                if (t === $ceaEj.IntStream.EOF) break;
            }
            t = input.LA(1);
            s = target; // flip; current DFA target becomes new src/from state
        }
        return this.failOrAccept(this.prevAccept, input, s.configs, t);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        let target = s.getTarget(t);
        if (LexerATNSimulator.debug && target != null) console.log("reuse state " + s.stateNumber + " edge to " + target.stateNumber);
        return target;
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param input The input stream
     * @param s The current DFA state
     * @param t The next input symbol
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(input, s, t) {
        let reach = new $9tIYC.OrderedATNConfigSet();
        // if we don't find an existing DFA state
        // Fill reach starting from closure, following t transitions
        this.getReachableConfigSet(input, s.configs, reach, t);
        if (reach.isEmpty) {
            if (!reach.hasSemanticContext) // we got nowhere on t, don't throw out this knowledge; it'd
            // cause a failover from DFA later.
            this.addDFAEdge(s, t, $kr9A1.ATNSimulator.ERROR);
            // stop when we can't match any more char
            return $kr9A1.ATNSimulator.ERROR;
        }
        // Add an edge from s to target DFA found/created for reach
        return this.addDFAEdge(s, t, reach);
    }
    failOrAccept(prevAccept, input, reach, t) {
        if (prevAccept.dfaState != null) {
            let lexerActionExecutor = prevAccept.dfaState.lexerActionExecutor;
            this.accept(input, lexerActionExecutor, this.startIndex, prevAccept.index, prevAccept.line, prevAccept.charPos);
            return prevAccept.dfaState.prediction;
        } else {
            // if no accept and EOF is first char, return EOF
            if (t === $ceaEj.IntStream.EOF && input.index === this.startIndex) return $2DVsz.Token.EOF;
            throw new $fOEQQ.LexerNoViableAltException(this.recog, input, this.startIndex, reach);
        }
    }
    /** Given a starting configuration set, figure out all ATN configurations
     *  we can reach upon input `t`. Parameter `reach` is a return
     *  parameter.
     */ getReachableConfigSet(input, closure, reach, t) {
        // this is used to skip processing for configs which have a lower priority
        // than a config that already reached an accept state for the same rule
        let skipAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
        for (let c of closure){
            let currentAltReachedAcceptState = c.alt === skipAlt;
            if (currentAltReachedAcceptState && c.hasPassedThroughNonGreedyDecision) continue;
            if (LexerATNSimulator.debug) console.log(`testing ${this.getTokenName(t)} at ${c.toString(this.recog, true)}`);
            let n = c.state.numberOfOptimizedTransitions;
            for(let ti = 0; ti < n; ti++){
                let trans = c.state.getOptimizedTransition(ti);
                let target = this.getReachableTarget(trans, t);
                if (target != null) {
                    let lexerActionExecutor = c.lexerActionExecutor;
                    let config;
                    if (lexerActionExecutor != null) {
                        lexerActionExecutor = lexerActionExecutor.fixOffsetBeforeMatch(input.index - this.startIndex);
                        config = c.transform(target, true, lexerActionExecutor);
                    } else {
                        $bbHFU(c.lexerActionExecutor == null);
                        config = c.transform(target, true);
                    }
                    let treatEofAsEpsilon = t === $ceaEj.IntStream.EOF;
                    if (this.closure(input, config, reach, currentAltReachedAcceptState, true, treatEofAsEpsilon)) {
                        // any remaining configs for this alt have a lower priority than
                        // the one that just reached an accept state.
                        skipAlt = c.alt;
                        break;
                    }
                }
            }
        }
    }
    accept(input, lexerActionExecutor, startIndex, index, line, charPos) {
        if (LexerATNSimulator.debug) console.log(`ACTION ${lexerActionExecutor}`);
        // seek to after last char in token
        input.seek(index);
        this._line = line;
        this._charPositionInLine = charPos;
        if (lexerActionExecutor != null && this.recog != null) lexerActionExecutor.execute(this.recog, input, startIndex);
    }
    getReachableTarget(trans, t) {
        if (trans.matches(t, $igNLf.Lexer.MIN_CHAR_VALUE, $igNLf.Lexer.MAX_CHAR_VALUE)) return trans.target;
        return undefined;
    }
    computeStartState(input, p) {
        let initialContext = $8DTT0.PredictionContext.EMPTY_FULL;
        let configs = new $9tIYC.OrderedATNConfigSet();
        for(let i = 0; i < p.numberOfTransitions; i++){
            let target = p.transition(i).target;
            let c = $gcX0f.ATNConfig.create(target, i + 1, initialContext);
            this.closure(input, c, configs, false, false, false);
        }
        return configs;
    }
    /**
     * Since the alternatives within any lexer decision are ordered by
     * preference, this method stops pursuing the closure as soon as an accept
     * state is reached. After the first accept state is reached by depth-first
     * search from `config`, all other (potentially reachable) states for
     * this rule would have a lower priority.
     *
     * @returns `true` if an accept state is reached, otherwise
     * `false`.
     */ closure(input, config, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon) {
        if (LexerATNSimulator.debug) console.log("closure(" + config.toString(this.recog, true) + ")");
        if (config.state instanceof $4kGBm.RuleStopState) {
            if (LexerATNSimulator.debug) {
                if (this.recog != null) console.log(`closure at ${this.recog.ruleNames[config.state.ruleIndex]} rule stop ${config}`);
                else console.log(`closure at rule stop ${config}`);
            }
            let context = config.context;
            if (context.isEmpty) {
                configs.add(config);
                return true;
            } else if (context.hasEmpty) {
                configs.add(config.transform(config.state, true, $8DTT0.PredictionContext.EMPTY_FULL));
                currentAltReachedAcceptState = true;
            }
            for(let i = 0; i < context.size; i++){
                let returnStateNumber = context.getReturnState(i);
                if (returnStateNumber === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                let newContext = context.getParent(i); // "pop" return state
                let returnState = this.atn.states[returnStateNumber];
                let c = config.transform(returnState, false, newContext);
                currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
            }
            return currentAltReachedAcceptState;
        }
        // optimization
        if (!config.state.onlyHasEpsilonTransitions) {
            if (!currentAltReachedAcceptState || !config.hasPassedThroughNonGreedyDecision) configs.add(config);
        }
        let p = config.state;
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            let t = p.getOptimizedTransition(i);
            let c = this.getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon);
            if (c != null) currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
        }
        return currentAltReachedAcceptState;
    }
    // side-effect: can alter configs.hasSemanticContext
    getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon) {
        let c;
        switch(t.serializationType){
            case 3 /* RULE */ :
                let ruleTransition = t;
                if (this.optimize_tail_calls && ruleTransition.optimizedTailCall && !config.context.hasEmpty) c = config.transform(t.target, true);
                else {
                    let newContext = config.context.getChild(ruleTransition.followState.stateNumber);
                    c = config.transform(t.target, true, newContext);
                }
                break;
            case 10 /* PRECEDENCE */ :
                throw new Error("Precedence predicates are not supported in lexers.");
            case 4 /* PREDICATE */ :
                /*  Track traversing semantic predicates. If we traverse,
                    we cannot add a DFA state for this "reach" computation
                    because the DFA would not test the predicate again in the
                    future. Rather than creating collections of semantic predicates
                    like v3 and testing them on prediction, v4 will test them on the
                    fly all the time using the ATN not the DFA. This is slower but
                    semantically it's not used that often. One of the key elements to
                    this predicate mechanism is not adding DFA states that see
                    predicates immediately afterwards in the ATN. For example,
    
                    a : ID {p1}? | ID {p2}? ;
    
                    should create the start state for rule 'a' (to save start state
                    competition), but should not create target of ID state. The
                    collection of ATN states the following ID references includes
                    states reached by traversing predicates. Since this is when we
                    test them, we cannot cash the DFA state target of ID.
                */ let pt = t;
                if (LexerATNSimulator.debug) console.log("EVAL rule " + pt.ruleIndex + ":" + pt.predIndex);
                configs.hasSemanticContext = true;
                if (this.evaluatePredicate(input, pt.ruleIndex, pt.predIndex, speculative)) c = config.transform(t.target, true);
                else c = undefined;
                break;
            case 6 /* ACTION */ :
                if (config.context.hasEmpty) {
                    // execute actions anywhere in the start rule for a token.
                    //
                    // TODO: if the entry rule is invoked recursively, some
                    // actions may be executed during the recursive call. The
                    // problem can appear when hasEmpty is true but
                    // isEmpty is false. In this case, the config needs to be
                    // split into two contexts - one with just the empty path
                    // and another with everything but the empty path.
                    // Unfortunately, the current algorithm does not allow
                    // getEpsilonTarget to return two configurations, so
                    // additional modifications are needed before we can support
                    // the split operation.
                    let lexerActionExecutor = $3AYVu.LexerActionExecutor.append(config.lexerActionExecutor, this.atn.lexerActions[t.actionIndex]);
                    c = config.transform(t.target, true, lexerActionExecutor);
                    break;
                } else {
                    // ignore actions in referenced rules
                    c = config.transform(t.target, true);
                    break;
                }
            case 1 /* EPSILON */ :
                c = config.transform(t.target, true);
                break;
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                if (treatEofAsEpsilon) {
                    if (t.matches($ceaEj.IntStream.EOF, $igNLf.Lexer.MIN_CHAR_VALUE, $igNLf.Lexer.MAX_CHAR_VALUE)) {
                        c = config.transform(t.target, false);
                        break;
                    }
                }
                c = undefined;
                break;
            default:
                c = undefined;
                break;
        }
        return c;
    }
    /**
     * Evaluate a predicate specified in the lexer.
     *
     * If `speculative` is `true`, this method was called before
     * {@link #consume} for the matched character. This method should call
     * {@link #consume} before evaluating the predicate to ensure position
     * sensitive values, including {@link Lexer#getText}, {@link Lexer#getLine},
     * and {@link Lexer#getCharPositionInLine}, properly reflect the current
     * lexer state. This method should restore `input` and the simulator
     * to the original state before returning (i.e. undo the actions made by the
     * call to {@link #consume}.
     *
     * @param input The input stream.
     * @param ruleIndex The rule containing the predicate.
     * @param predIndex The index of the predicate within the rule.
     * @param speculative `true` if the current index in `input` is
     * one character before the predicate's location.
     *
     * @returns `true` if the specified predicate evaluates to
     * `true`.
     */ evaluatePredicate(input, ruleIndex, predIndex, speculative) {
        // assume true if no recognizer was provided
        if (this.recog == null) return true;
        if (!speculative) return this.recog.sempred(undefined, ruleIndex, predIndex);
        let savedCharPositionInLine = this._charPositionInLine;
        let savedLine = this._line;
        let index = input.index;
        let marker = input.mark();
        try {
            this.consume(input);
            return this.recog.sempred(undefined, ruleIndex, predIndex);
        } finally{
            this._charPositionInLine = savedCharPositionInLine;
            this._line = savedLine;
            input.seek(index);
            input.release(marker);
        }
    }
    captureSimState(settings, input, dfaState) {
        settings.index = input.index;
        settings.line = this._line;
        settings.charPos = this._charPositionInLine;
        settings.dfaState = dfaState;
    }
    addDFAEdge(p, t, q) {
        if (q instanceof $c1ClW.ATNConfigSet) {
            /* leading to this call, ATNConfigSet.hasSemanticContext is used as a
            * marker indicating dynamic predicate evaluation makes this edge
            * dependent on the specific input sequence, so the static edge in the
            * DFA should be omitted. The target DFAState is still created since
            * execATN has the ability to resynchronize with the DFA state cache
            * following the predicate evaluation step.
            *
            * TJP notes: next time through the DFA, we see a pred again and eval.
            * If that gets us to a previously created (but dangling) DFA
            * state, we can continue in pure DFA mode from there.
            */ let suppressEdge = q.hasSemanticContext;
            if (suppressEdge) q.hasSemanticContext = false;
            // @NotNull
            let to = this.addDFAState(q);
            if (suppressEdge) return to;
            this.addDFAEdge(p, t, to);
            return to;
        } else {
            if (LexerATNSimulator.debug) console.log("EDGE " + p + " -> " + q + " upon " + String.fromCharCode(t));
            if (p != null) p.setTarget(t, q);
        }
    }
    /** Add a new DFA state if there isn't one with this set of
     * 	configurations already. This method also detects the first
     * 	configuration containing an ATN rule stop state. Later, when
     * 	traversing the DFA, we will know which rule to accept.
     */ addDFAState(configs) {
        /* the lexer evaluates predicates on-the-fly; by this point configs
         * should not contain any configurations with unevaluated predicates.
         */ $bbHFU(!configs.hasSemanticContext);
        let proposed = new $2jevZ.DFAState(configs);
        let existing = this.atn.modeToDFA[this.mode].states.get(proposed);
        if (existing != null) return existing;
        configs.optimizeConfigs(this);
        let newState = new $2jevZ.DFAState(configs.clone(true));
        let firstConfigWithRuleStopState;
        for (let c of configs)if (c.state instanceof $4kGBm.RuleStopState) {
            firstConfigWithRuleStopState = c;
            break;
        }
        if (firstConfigWithRuleStopState != null) {
            let prediction = this.atn.ruleToTokenType[firstConfigWithRuleStopState.state.ruleIndex];
            let lexerActionExecutor = firstConfigWithRuleStopState.lexerActionExecutor;
            newState.acceptStateInfo = new $41NTU.AcceptStateInfo(prediction, lexerActionExecutor);
        }
        return this.atn.modeToDFA[this.mode].addState(newState);
    }
    getDFA(mode) {
        return this.atn.modeToDFA[mode];
    }
    /** Get the text matched so far for the current token.
     */ getText(input) {
        // index is first lookahead char, don't include.
        return input.getText($gcfUE.Interval.of(this.startIndex, input.index - 1));
    }
    get line() {
        return this._line;
    }
    set line(line) {
        this._line = line;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    consume(input) {
        let curChar = input.LA(1);
        if (curChar === "\n".charCodeAt(0)) {
            this._line++;
            this._charPositionInLine = 0;
        } else this._charPositionInLine++;
        input.consume();
    }
    getTokenName(t) {
        if (t === -1) return "EOF";
        //if ( atn.g!=null ) return atn.g.getTokenDisplayName(t);
        return "'" + String.fromCharCode(t) + "'";
    }
};
$fe6978bd928c111b$var$__decorate([
    $d6D31.NotNull
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "prevAccept", void 0);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "copyState", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "match", null);
$fe6978bd928c111b$var$__decorate([
    $d6D31.Override
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "reset", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "matchATN", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(1, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "execATN", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getExistingTargetState", null);
$fe6978bd928c111b$var$__decorate([
    $d6D31.NotNull,
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(1, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "computeTargetState", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(2, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getReachableConfigSet", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "accept", null);
$fe6978bd928c111b$var$__decorate([
    $d6D31.NotNull,
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(1, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "computeStartState", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(2, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "closure", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(2, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(3, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getEpsilonTarget", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "evaluatePredicate", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
    $fe6978bd928c111b$var$__param(2, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "captureSimState", null);
$fe6978bd928c111b$var$__decorate([
    $d6D31.NotNull,
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "addDFAState", null);
$fe6978bd928c111b$var$__decorate([
    $d6D31.NotNull
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getDFA", null);
$fe6978bd928c111b$var$__decorate([
    $d6D31.NotNull,
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getText", null);
$fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "consume", null);
$fe6978bd928c111b$var$__decorate([
    $d6D31.NotNull
], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getTokenName", null);
$fe6978bd928c111b$var$LexerATNSimulator = $fe6978bd928c111b$var$__decorate([
    $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
], $fe6978bd928c111b$var$LexerATNSimulator);
module.exports.LexerATNSimulator = $fe6978bd928c111b$var$LexerATNSimulator;
(function(LexerATNSimulator) {
    LexerATNSimulator.debug = false;
    LexerATNSimulator.dfa_debug = false;
    /** When we hit an accept state in either the DFA or the ATN, we
     *  have to notify the character stream to start buffering characters
     *  via {@link IntStream#mark} and record the current state. The current sim state
     *  includes the current index into the input, the current line,
     *  and current character position in that line. Note that the Lexer is
     *  tracking the starting line and characterization of the token. These
     *  variables track the "state" of the simulator when it hits an accept state.
     *
     *  We track these variables separately for the DFA and ATN simulation
     *  because the DFA simulation often has to fail over to the ATN
     *  simulation. If the ATN simulation fails, we need the DFA to fall
     *  back to its previously accepted state, if any. If the ATN succeeds,
     *  then the ATN does the accept and the DFA simulator that invoked it
     *  can simply return the predicted token type.
     */ class SimState {
        constructor(){
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
        }
        reset() {
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
            this.dfaState = undefined;
        }
    }
    LexerATNSimulator.SimState = SimState;
})($fe6978bd928c111b$var$LexerATNSimulator = module.exports.LexerATNSimulator || (module.exports.LexerATNSimulator = {}));
module.exports.LexerATNSimulator = $fe6978bd928c111b$var$LexerATNSimulator;

});
parcelRegister("41NTU", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AcceptStateInfo = void 0;
/**
 * Stores information about a {@link DFAState} which is an accept state under
 * some condition. Certain settings, such as
 * {@link ParserATNSimulator#getPredictionMode()}, may be used in addition to
 * this information to determine whether or not a particular state is an accept
 * state.
 *
 * @author Sam Harwell
 */ class $2eedf6a56837c02c$var$AcceptStateInfo {
    constructor(prediction, lexerActionExecutor){
        this._prediction = prediction;
        this._lexerActionExecutor = lexerActionExecutor;
    }
    /**
     * Gets the prediction made by this accept state. Note that this value
     * assumes the predicates, if any, in the {@link DFAState} evaluate to
     * `true`. If predicate evaluation is enabled, the final prediction of
     * the accept state will be determined by the result of predicate
     * evaluation.
     */ get prediction() {
        return this._prediction;
    }
    /**
     * Gets the {@link LexerActionExecutor} which can be used to execute actions
     * and/or commands after the lexer matches a token.
     */ get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
}
module.exports.AcceptStateInfo = $2eedf6a56837c02c$var$AcceptStateInfo;

});

parcelRegister("bcnvE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $82730d2c6766359c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $82730d2c6766359c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATN = void 0;

var $fP17P = parcelRequire("fP17P");

var $jJRyp = parcelRequire("jJRyp");

var $hGRod = parcelRequire("hGRod");

var $l4Nh1 = parcelRequire("l4Nh1");

var $iiE1V = parcelRequire("iiE1V");

var $d6D31 = parcelRequire("d6D31");

var $a4Flx = parcelRequire("a4Flx");

var $8DTT0 = parcelRequire("8DTT0");

var $2DVsz = parcelRequire("2DVsz");

var $bbHFU = parcelRequire("bbHFU");
/** */ let $82730d2c6766359c$var$ATN = class ATN {
    /** Used for runtime deserialization of ATNs from strings */ constructor(grammarType, maxTokenType){
        this.states = [];
        /** Each subrule/rule is a decision point and we must track them so we
         *  can go back later and build DFA predictors for them.  This includes
         *  all the rules, subrules, optional blocks, ()+, ()* etc...
         */ this.decisionToState = [];
        this.modeNameToStartState = new Map();
        this.modeToStartState = [];
        this.contextCache = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
        this.decisionToDFA = [];
        this.modeToDFA = [];
        this.LL1Table = new Map();
        this.grammarType = grammarType;
        this.maxTokenType = maxTokenType;
    }
    clearDFA() {
        this.decisionToDFA = new Array(this.decisionToState.length);
        for(let i = 0; i < this.decisionToDFA.length; i++)this.decisionToDFA[i] = new $jJRyp.DFA(this.decisionToState[i], i);
        this.modeToDFA = new Array(this.modeToStartState.length);
        for(let i = 0; i < this.modeToDFA.length; i++)this.modeToDFA[i] = new $jJRyp.DFA(this.modeToStartState[i]);
        this.contextCache.clear();
        this.LL1Table.clear();
    }
    get contextCacheSize() {
        return this.contextCache.size;
    }
    getCachedContext(context) {
        return $8DTT0.PredictionContext.getCachedContext(context, this.contextCache, new $8DTT0.PredictionContext.IdentityHashMap());
    }
    getDecisionToDFA() {
        $bbHFU(this.decisionToDFA != null && this.decisionToDFA.length === this.decisionToState.length);
        return this.decisionToDFA;
    }
    nextTokens(s, ctx) {
        if (ctx) {
            let anal = new $iiE1V.LL1Analyzer(this);
            let next = anal.LOOK(s, ctx);
            return next;
        } else {
            if (s.nextTokenWithinRule) return s.nextTokenWithinRule;
            s.nextTokenWithinRule = this.nextTokens(s, $8DTT0.PredictionContext.EMPTY_LOCAL);
            s.nextTokenWithinRule.setReadonly(true);
            return s.nextTokenWithinRule;
        }
    }
    addState(state) {
        state.atn = this;
        state.stateNumber = this.states.length;
        this.states.push(state);
    }
    removeState(state) {
        // just replace the state, don't shift states in list
        let invalidState = new $l4Nh1.InvalidState();
        invalidState.atn = this;
        invalidState.stateNumber = state.stateNumber;
        this.states[state.stateNumber] = invalidState;
    }
    defineMode(name, s) {
        this.modeNameToStartState.set(name, s);
        this.modeToStartState.push(s);
        this.modeToDFA.push(new $jJRyp.DFA(s));
        this.defineDecisionState(s);
    }
    defineDecisionState(s) {
        this.decisionToState.push(s);
        s.decision = this.decisionToState.length - 1;
        this.decisionToDFA.push(new $jJRyp.DFA(s, s.decision));
        return s.decision;
    }
    getDecisionState(decision) {
        if (this.decisionToState.length > 0) return this.decisionToState[decision];
        return undefined;
    }
    get numberOfDecisions() {
        return this.decisionToState.length;
    }
    /**
     * Computes the set of input symbols which could follow ATN state number
     * `stateNumber` in the specified full `context`. This method
     * considers the complete parser context, but does not evaluate semantic
     * predicates (i.e. all predicates encountered during the calculation are
     * assumed true). If a path in the ATN exists from the starting state to the
     * {@link RuleStopState} of the outermost context without matching any
     * symbols, {@link Token#EOF} is added to the returned set.
     *
     * If `context` is `undefined`, it is treated as
     * {@link ParserRuleContext#EMPTY}.
     *
     * Note that this does NOT give you the set of all tokens that could
     * appear at a given token position in the input phrase.  In other words, it
     * does not answer:
     *
     * > Given a specific partial input phrase, return the set of all
     * > tokens that can follow the last token in the input phrase.
     *
     * The big difference is that with just the input, the parser could land
     * right in the middle of a lookahead decision. Getting all
     * *possible* tokens given a partial input stream is a separate
     * computation. See https://github.com/antlr/antlr4/issues/1428
     *
     * For this function, we are specifying an ATN state and call stack to
     * compute what token(s) can come next and specifically: outside of a
     * lookahead decision. That is what you want for error reporting and
     * recovery upon parse error.
     *
     * @param stateNumber the ATN state number
     * @param context the full parse context
     * @returns The set of potentially valid input symbols which could follow the
     * specified state in the specified context.
     * @ if the ATN does not contain a state with
     * number `stateNumber`
     */ getExpectedTokens(stateNumber, context) {
        if (stateNumber < 0 || stateNumber >= this.states.length) throw new RangeError("Invalid state number.");
        let ctx = context;
        let s = this.states[stateNumber];
        let following = this.nextTokens(s);
        if (!following.contains($2DVsz.Token.EPSILON)) return following;
        let expected = new $hGRod.IntervalSet();
        expected.addAll(following);
        expected.remove($2DVsz.Token.EPSILON);
        while(ctx != null && ctx.invokingState >= 0 && following.contains($2DVsz.Token.EPSILON)){
            let invokingState = this.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = this.nextTokens(rt.followState);
            expected.addAll(following);
            expected.remove($2DVsz.Token.EPSILON);
            ctx = ctx._parent;
        }
        if (following.contains($2DVsz.Token.EPSILON)) expected.add($2DVsz.Token.EOF);
        return expected;
    }
};
$82730d2c6766359c$var$__decorate([
    $d6D31.NotNull
], $82730d2c6766359c$var$ATN.prototype, "states", void 0);
$82730d2c6766359c$var$__decorate([
    $d6D31.NotNull
], $82730d2c6766359c$var$ATN.prototype, "decisionToState", void 0);
$82730d2c6766359c$var$__decorate([
    $d6D31.NotNull
], $82730d2c6766359c$var$ATN.prototype, "modeNameToStartState", void 0);
$82730d2c6766359c$var$__decorate([
    $d6D31.NotNull
], $82730d2c6766359c$var$ATN.prototype, "modeToStartState", void 0);
$82730d2c6766359c$var$__decorate([
    $d6D31.NotNull
], $82730d2c6766359c$var$ATN.prototype, "decisionToDFA", void 0);
$82730d2c6766359c$var$__decorate([
    $d6D31.NotNull
], $82730d2c6766359c$var$ATN.prototype, "modeToDFA", void 0);
$82730d2c6766359c$var$__decorate([
    $d6D31.NotNull
], $82730d2c6766359c$var$ATN.prototype, "nextTokens", null);
$82730d2c6766359c$var$__decorate([
    $82730d2c6766359c$var$__param(0, $d6D31.NotNull)
], $82730d2c6766359c$var$ATN.prototype, "removeState", null);
$82730d2c6766359c$var$__decorate([
    $82730d2c6766359c$var$__param(0, $d6D31.NotNull),
    $82730d2c6766359c$var$__param(1, $d6D31.NotNull)
], $82730d2c6766359c$var$ATN.prototype, "defineMode", null);
$82730d2c6766359c$var$__decorate([
    $82730d2c6766359c$var$__param(0, $d6D31.NotNull)
], $82730d2c6766359c$var$ATN.prototype, "defineDecisionState", null);
$82730d2c6766359c$var$__decorate([
    $d6D31.NotNull
], $82730d2c6766359c$var$ATN.prototype, "getExpectedTokens", null);
$82730d2c6766359c$var$ATN = $82730d2c6766359c$var$__decorate([
    $82730d2c6766359c$var$__param(0, $d6D31.NotNull)
], $82730d2c6766359c$var$ATN);
module.exports.ATN = $82730d2c6766359c$var$ATN;
(function(ATN) {
    ATN.INVALID_ALT_NUMBER = 0;
})($82730d2c6766359c$var$ATN = module.exports.ATN || (module.exports.ATN = {}));
module.exports.ATN = $82730d2c6766359c$var$ATN;

});
parcelRegister("fP17P", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashMap = void 0;

var $7Veax = parcelRequire("7Veax");
class $b84c7de35a10478c$var$MapKeyEqualityComparator {
    constructor(keyComparator){
        this.keyComparator = keyComparator;
    }
    hashCode(obj) {
        return this.keyComparator.hashCode(obj.key);
    }
    equals(a, b) {
        return this.keyComparator.equals(a.key, b.key);
    }
}
class $b84c7de35a10478c$var$Array2DHashMap {
    constructor(keyComparer){
        if (keyComparer instanceof $b84c7de35a10478c$var$Array2DHashMap) this.backingStore = new $7Veax.Array2DHashSet(keyComparer.backingStore);
        else this.backingStore = new $7Veax.Array2DHashSet(new $b84c7de35a10478c$var$MapKeyEqualityComparator(keyComparer));
    }
    clear() {
        this.backingStore.clear();
    }
    containsKey(key) {
        return this.backingStore.contains({
            key: key
        });
    }
    get(key) {
        let bucket = this.backingStore.get({
            key: key
        });
        if (!bucket) return undefined;
        return bucket.value;
    }
    get isEmpty() {
        return this.backingStore.isEmpty;
    }
    put(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else {
            result = element.value;
            element.value = value;
        }
        return result;
    }
    putIfAbsent(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else result = element.value;
        return result;
    }
    get size() {
        return this.backingStore.size;
    }
    hashCode() {
        return this.backingStore.hashCode();
    }
    equals(o) {
        if (!(o instanceof $b84c7de35a10478c$var$Array2DHashMap)) return false;
        return this.backingStore.equals(o.backingStore);
    }
}
module.exports.Array2DHashMap = $b84c7de35a10478c$var$Array2DHashMap;

});

parcelRegister("jJRyp", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e5ebc30517b3d229$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e5ebc30517b3d229$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFA = void 0;

var $7Veax = parcelRequire("7Veax");

var $c1ClW = parcelRequire("c1ClW");

var $yhTtv = parcelRequire("yhTtv");

var $2jevZ = parcelRequire("2jevZ");

var $aeRGo = parcelRequire("aeRGo");

var $d6D31 = parcelRequire("d6D31");

var $a4Flx = parcelRequire("a4Flx");

var $f9raX = parcelRequire("f9raX");

var $3n2FE = parcelRequire("3n2FE");
let $e5ebc30517b3d229$var$DFA = class DFA {
    constructor(atnStartState, decision = 0){
        /**
         * A set of all states in the `DFA`.
         *
         * Note that this collection of states holds the DFA states for both SLL and LL prediction. Only the start state
         * needs to be differentiated for these cases, which is tracked by the `s0` and `s0full` fields.
         */ this.states = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
        this.nextStateNumber = 0;
        if (!atnStartState.atn) throw new Error("The ATNState must be associated with an ATN");
        this.atnStartState = atnStartState;
        this.atn = atnStartState.atn;
        this.decision = decision;
        // Precedence DFAs are associated with the special precedence decision created for left-recursive rules which
        // evaluate their alternatives using a precedence hierarchy. When such a decision is encountered, we mark this
        // DFA instance as a precedence DFA and initialize the initial states s0 and s0full to special DFAState
        // instances which use outgoing edges to link to the actual start state used for each precedence level.
        let isPrecedenceDfa = false;
        if (atnStartState instanceof $f9raX.StarLoopEntryState) {
            if (atnStartState.precedenceRuleDecision) {
                isPrecedenceDfa = true;
                this.s0 = new $2jevZ.DFAState(new $c1ClW.ATNConfigSet());
                this.s0full = new $2jevZ.DFAState(new $c1ClW.ATNConfigSet());
            }
        }
        this.precedenceDfa = isPrecedenceDfa;
    }
    /**
     * Gets whether this DFA is a precedence DFA. Precedence DFAs use a special
     * start state {@link #s0} which is not stored in {@link #states}. The
     * {@link DFAState#edges} array for this start state contains outgoing edges
     * supplying individual start states corresponding to specific precedence
     * values.
     *
     * @returns `true` if this is a precedence DFA; otherwise,
     * `false`.
     * @see Parser.precedence
     */ get isPrecedenceDfa() {
        return this.precedenceDfa;
    }
    /**
     * Get the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @returns The start state corresponding to the specified precedence, or
     * `undefined` if no start state exists for the specified precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ getPrecedenceStartState(precedence, fullContext) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        // s0 and s0full are never null for a precedence DFA
        if (fullContext) return this.s0full.getTarget(precedence);
        else return this.s0.getTarget(precedence);
    }
    /**
     * Set the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @param startState The start state corresponding to the specified
     * precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ setPrecedenceStartState(precedence, fullContext, startState) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        if (precedence < 0) return;
        if (fullContext) // s0full is never null for a precedence DFA
        this.s0full.setTarget(precedence, startState);
        else // s0 is never null for a precedence DFA
        this.s0.setTarget(precedence, startState);
    }
    get isEmpty() {
        if (this.isPrecedenceDfa) // s0 and s0full are never null for a precedence DFA
        return this.s0.getEdgeMap().size === 0 && this.s0full.getEdgeMap().size === 0;
        return this.s0 == null && this.s0full == null;
    }
    get isContextSensitive() {
        if (this.isPrecedenceDfa) // s0full is never null for a precedence DFA
        return this.s0full.getEdgeMap().size > 0;
        return this.s0full != null;
    }
    addState(state) {
        state.stateNumber = this.nextStateNumber++;
        return this.states.getOrAdd(state);
    }
    toString(vocabulary, ruleNames) {
        if (!vocabulary) vocabulary = $3n2FE.VocabularyImpl.EMPTY_VOCABULARY;
        if (!this.s0) return "";
        let serializer;
        if (ruleNames) serializer = new $yhTtv.DFASerializer(this, vocabulary, ruleNames, this.atnStartState.atn);
        else serializer = new $yhTtv.DFASerializer(this, vocabulary);
        return serializer.toString();
    }
    toLexerString() {
        if (!this.s0) return "";
        let serializer = new $aeRGo.LexerDFASerializer(this);
        return serializer.toString();
    }
};
$e5ebc30517b3d229$var$__decorate([
    $d6D31.NotNull
], $e5ebc30517b3d229$var$DFA.prototype, "states", void 0);
$e5ebc30517b3d229$var$__decorate([
    $d6D31.NotNull
], $e5ebc30517b3d229$var$DFA.prototype, "atnStartState", void 0);
$e5ebc30517b3d229$var$__decorate([
    $d6D31.NotNull
], $e5ebc30517b3d229$var$DFA.prototype, "atn", void 0);
$e5ebc30517b3d229$var$DFA = $e5ebc30517b3d229$var$__decorate([
    $e5ebc30517b3d229$var$__param(0, $d6D31.NotNull)
], $e5ebc30517b3d229$var$DFA);
module.exports.DFA = $e5ebc30517b3d229$var$DFA;

});
parcelRegister("c1ClW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8c13542112ebfd78$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfigSet = void 0;

var $fP17P = parcelRequire("fP17P");

var $7Veax = parcelRequire("7Veax");

var $3sNxf = parcelRequire("3sNxf");

var $bcnvE = parcelRequire("bcnvE");

var $gcX0f = parcelRequire("gcX0f");

var $5BPMp = parcelRequire("5BPMp");

var $d6D31 = parcelRequire("d6D31");

var $a4Flx = parcelRequire("a4Flx");

var $8DTT0 = parcelRequire("8DTT0");

var $6vF7J = parcelRequire("6vF7J");

var $eHMgW = parcelRequire("eHMgW");

var $bbHFU = parcelRequire("bbHFU");

var $2IEP9 = parcelRequire("2IEP9");
class $8c13542112ebfd78$var$KeyTypeEqualityComparer {
    hashCode(key) {
        return key.state ^ key.alt;
    }
    equals(a, b) {
        return a.state === b.state && a.alt === b.alt;
    }
}
$8c13542112ebfd78$var$KeyTypeEqualityComparer.INSTANCE = new $8c13542112ebfd78$var$KeyTypeEqualityComparer();
function $8c13542112ebfd78$var$NewKeyedConfigMap(map) {
    if (map) return new $fP17P.Array2DHashMap(map);
    else return new $fP17P.Array2DHashMap($8c13542112ebfd78$var$KeyTypeEqualityComparer.INSTANCE);
}
/**
 * Represents a set of ATN configurations (see `ATNConfig`). As configurations are added to the set, they are merged
 * with other `ATNConfig` instances already in the set when possible using the graph-structured stack.
 *
 * An instance of this class represents the complete set of positions (with context) in an ATN which would be associated
 * with a single DFA state. Its internal representation is more complex than traditional state used for NFA to DFA
 * conversion due to performance requirements (both improving speed and reducing memory overhead) as well as supporting
 * features such as semantic predicates and non-greedy operators in a form to support ANTLR's prediction algorithm.
 *
 * @author Sam Harwell
 */ class $8c13542112ebfd78$var$ATNConfigSet {
    constructor(set, readonly){
        this._uniqueAlt = 0;
        // Used in parser and lexer. In lexer, it indicates we hit a pred
        // while computing a closure operation.  Don't make a DFA state from this.
        this._hasSemanticContext = false;
        this._dipsIntoOuterContext = false;
        /**
         * When `true`, this config set represents configurations where the entire
         * outer context has been consumed by the ATN interpreter. This prevents the
         * {@link ParserATNSimulator#closure} from pursuing the global FOLLOW when a
         * rule stop state is reached with an empty prediction context.
         *
         * Note: `outermostConfigSet` and {@link #dipsIntoOuterContext} should never
         * be true at the same time.
         */ this.outermostConfigSet = false;
        this.cachedHashCode = -1;
        if (!set) {
            this.mergedConfigs = $8c13542112ebfd78$var$NewKeyedConfigMap();
            this.unmerged = [];
            this.configs = [];
            this._uniqueAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
        } else {
            if (readonly) {
                this.mergedConfigs = undefined;
                this.unmerged = undefined;
            } else if (!set.isReadOnly) {
                this.mergedConfigs = $8c13542112ebfd78$var$NewKeyedConfigMap(set.mergedConfigs);
                this.unmerged = set.unmerged.slice(0);
            } else {
                this.mergedConfigs = $8c13542112ebfd78$var$NewKeyedConfigMap();
                this.unmerged = [];
            }
            this.configs = set.configs.slice(0);
            this._dipsIntoOuterContext = set._dipsIntoOuterContext;
            this._hasSemanticContext = set._hasSemanticContext;
            this.outermostConfigSet = set.outermostConfigSet;
            if (readonly || !set.isReadOnly) {
                this._uniqueAlt = set._uniqueAlt;
                this._conflictInfo = set._conflictInfo;
            }
        // if (!readonly && set.isReadOnly) -> addAll is called from clone()
        }
    }
    /**
     * Get the set of all alternatives represented by configurations in this
     * set.
     */ getRepresentedAlternatives() {
        if (this._conflictInfo != null) return this._conflictInfo.conflictedAlts.clone();
        let alts = new $5BPMp.BitSet();
        for (let config of this)alts.set(config.alt);
        return alts;
    }
    get isReadOnly() {
        return this.mergedConfigs == null;
    }
    get isOutermostConfigSet() {
        return this.outermostConfigSet;
    }
    set isOutermostConfigSet(outermostConfigSet) {
        if (this.outermostConfigSet && !outermostConfigSet) throw new Error("IllegalStateException");
        $bbHFU(!outermostConfigSet || !this._dipsIntoOuterContext);
        this.outermostConfigSet = outermostConfigSet;
    }
    getStates() {
        let states = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
        for (let c of this.configs)states.add(c.state);
        return states;
    }
    optimizeConfigs(interpreter) {
        if (this.configs.length === 0) return;
        for (let config of this.configs)config.context = interpreter.atn.getCachedContext(config.context);
    }
    clone(readonly) {
        let copy = new $8c13542112ebfd78$var$ATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this.configs);
        return copy;
    }
    get size() {
        return this.configs.length;
    }
    get isEmpty() {
        return this.configs.length === 0;
    }
    contains(o) {
        if (!(o instanceof $gcX0f.ATNConfig)) return false;
        if (this.mergedConfigs && this.unmerged) {
            let config = o;
            let configKey = this.getKey(config);
            let mergedConfig = this.mergedConfigs.get(configKey);
            if (mergedConfig != null && this.canMerge(config, configKey, mergedConfig)) return mergedConfig.contains(config);
            for (let c of this.unmerged){
                if (c.contains(o)) return true;
            }
        } else for (let c of this.configs){
            if (c.contains(o)) return true;
        }
        return false;
    }
    *[Symbol.iterator]() {
        yield* this.configs;
    }
    toArray() {
        return this.configs;
    }
    add(e, contextCache) {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        $bbHFU(!this.outermostConfigSet || !e.reachesIntoOuterContext);
        if (contextCache == null) contextCache = $6vF7J.PredictionContextCache.UNCACHED;
        let addKey;
        let key = this.getKey(e);
        let mergedConfig = this.mergedConfigs.get(key);
        addKey = mergedConfig == null;
        if (mergedConfig != null && this.canMerge(e, key, mergedConfig)) {
            mergedConfig.outerContextDepth = Math.max(mergedConfig.outerContextDepth, e.outerContextDepth);
            if (e.isPrecedenceFilterSuppressed) mergedConfig.isPrecedenceFilterSuppressed = true;
            let joined = $8DTT0.PredictionContext.join(mergedConfig.context, e.context, contextCache);
            this.updatePropertiesForMergedConfig(e);
            if (mergedConfig.context === joined) return false;
            mergedConfig.context = joined;
            return true;
        }
        for(let i = 0; i < this.unmerged.length; i++){
            let unmergedConfig = this.unmerged[i];
            if (this.canMerge(e, key, unmergedConfig)) {
                unmergedConfig.outerContextDepth = Math.max(unmergedConfig.outerContextDepth, e.outerContextDepth);
                if (e.isPrecedenceFilterSuppressed) unmergedConfig.isPrecedenceFilterSuppressed = true;
                let joined = $8DTT0.PredictionContext.join(unmergedConfig.context, e.context, contextCache);
                this.updatePropertiesForMergedConfig(e);
                if (unmergedConfig.context === joined) return false;
                unmergedConfig.context = joined;
                if (addKey) {
                    this.mergedConfigs.put(key, unmergedConfig);
                    this.unmerged.splice(i, 1);
                }
                return true;
            }
        }
        this.configs.push(e);
        if (addKey) this.mergedConfigs.put(key, e);
        else this.unmerged.push(e);
        this.updatePropertiesForAddedConfig(e);
        return true;
    }
    updatePropertiesForMergedConfig(config) {
        // merged configs can't change the alt or semantic context
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $bbHFU(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    updatePropertiesForAddedConfig(config) {
        if (this.configs.length === 1) this._uniqueAlt = config.alt;
        else if (this._uniqueAlt !== config.alt) this._uniqueAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
        this._hasSemanticContext = this._hasSemanticContext || !$eHMgW.SemanticContext.NONE.equals(config.semanticContext);
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $bbHFU(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    canMerge(left, leftKey, right) {
        if (left.state.stateNumber !== right.state.stateNumber) return false;
        if (leftKey.alt !== right.alt) return false;
        return left.semanticContext.equals(right.semanticContext);
    }
    getKey(e) {
        return {
            state: e.state.stateNumber,
            alt: e.alt
        };
    }
    containsAll(c) {
        for (let o of c){
            if (!(o instanceof $gcX0f.ATNConfig)) return false;
            if (!this.contains(o)) return false;
        }
        return true;
    }
    addAll(c, contextCache) {
        this.ensureWritable();
        let changed = false;
        for (let group of c)if (this.add(group, contextCache)) changed = true;
        return changed;
    }
    clear() {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        this.mergedConfigs.clear();
        this.unmerged.length = 0;
        this.configs.length = 0;
        this._dipsIntoOuterContext = false;
        this._hasSemanticContext = false;
        this._uniqueAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
        this._conflictInfo = undefined;
    }
    equals(obj) {
        if (this === obj) return true;
        if (!(obj instanceof $8c13542112ebfd78$var$ATNConfigSet)) return false;
        return this.outermostConfigSet === obj.outermostConfigSet && $2IEP9.equals(this._conflictInfo, obj._conflictInfo) && $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this.configs, obj.configs);
    }
    hashCode() {
        if (this.isReadOnly && this.cachedHashCode !== -1) return this.cachedHashCode;
        let hashCode = 1;
        hashCode = 5 * hashCode ^ (this.outermostConfigSet ? 1 : 0);
        hashCode = 5 * hashCode ^ $3sNxf.ArrayEqualityComparator.INSTANCE.hashCode(this.configs);
        if (this.isReadOnly) this.cachedHashCode = hashCode;
        return hashCode;
    }
    toString(showContext) {
        if (showContext == null) showContext = false;
        let buf = "";
        let sortedConfigs = this.configs.slice(0);
        sortedConfigs.sort((o1, o2)=>{
            if (o1.alt !== o2.alt) return o1.alt - o2.alt;
            else if (o1.state.stateNumber !== o2.state.stateNumber) return o1.state.stateNumber - o2.state.stateNumber;
            else return o1.semanticContext.toString().localeCompare(o2.semanticContext.toString());
        });
        buf += "[";
        for(let i = 0; i < sortedConfigs.length; i++){
            if (i > 0) buf += ", ";
            buf += sortedConfigs[i].toString(undefined, true, showContext);
        }
        buf += "]";
        if (this._hasSemanticContext) buf += ",hasSemanticContext=" + this._hasSemanticContext;
        if (this._uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) buf += ",uniqueAlt=" + this._uniqueAlt;
        if (this._conflictInfo != null) {
            buf += ",conflictingAlts=" + this._conflictInfo.conflictedAlts;
            if (!this._conflictInfo.isExact) buf += "*";
        }
        if (this._dipsIntoOuterContext) buf += ",dipsIntoOuterContext";
        return buf.toString();
    }
    get uniqueAlt() {
        return this._uniqueAlt;
    }
    get hasSemanticContext() {
        return this._hasSemanticContext;
    }
    set hasSemanticContext(value) {
        this.ensureWritable();
        this._hasSemanticContext = value;
    }
    get conflictInfo() {
        return this._conflictInfo;
    }
    set conflictInfo(conflictInfo) {
        this.ensureWritable();
        this._conflictInfo = conflictInfo;
    }
    get conflictingAlts() {
        if (this._conflictInfo == null) return undefined;
        return this._conflictInfo.conflictedAlts;
    }
    get isExactConflict() {
        if (this._conflictInfo == null) return false;
        return this._conflictInfo.isExact;
    }
    get dipsIntoOuterContext() {
        return this._dipsIntoOuterContext;
    }
    get(index) {
        return this.configs[index];
    }
    ensureWritable() {
        if (this.isReadOnly) throw new Error("This ATNConfigSet is read only.");
    }
}
$8c13542112ebfd78$var$__decorate([
    $d6D31.NotNull
], $8c13542112ebfd78$var$ATNConfigSet.prototype, "getRepresentedAlternatives", null);
$8c13542112ebfd78$var$__decorate([
    $d6D31.Override
], $8c13542112ebfd78$var$ATNConfigSet.prototype, "size", null);
$8c13542112ebfd78$var$__decorate([
    $d6D31.Override
], $8c13542112ebfd78$var$ATNConfigSet.prototype, "isEmpty", null);
$8c13542112ebfd78$var$__decorate([
    $d6D31.Override
], $8c13542112ebfd78$var$ATNConfigSet.prototype, "contains", null);
$8c13542112ebfd78$var$__decorate([
    $d6D31.Override
], $8c13542112ebfd78$var$ATNConfigSet.prototype, Symbol.iterator, null);
$8c13542112ebfd78$var$__decorate([
    $d6D31.Override
], $8c13542112ebfd78$var$ATNConfigSet.prototype, "toArray", null);
$8c13542112ebfd78$var$__decorate([
    $d6D31.Override
], $8c13542112ebfd78$var$ATNConfigSet.prototype, "containsAll", null);
$8c13542112ebfd78$var$__decorate([
    $d6D31.Override
], $8c13542112ebfd78$var$ATNConfigSet.prototype, "clear", null);
$8c13542112ebfd78$var$__decorate([
    $d6D31.Override
], $8c13542112ebfd78$var$ATNConfigSet.prototype, "equals", null);
$8c13542112ebfd78$var$__decorate([
    $d6D31.Override
], $8c13542112ebfd78$var$ATNConfigSet.prototype, "hashCode", null);
module.exports.ATNConfigSet = $8c13542112ebfd78$var$ATNConfigSet;

});
parcelRegister("gcX0f", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bccb89124e8dfda2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $bccb89124e8dfda2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfig = void 0;

var $fP17P = parcelRequire("fP17P");

var $dPYn6 = parcelRequire("dPYn6");

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");

var $a4Flx = parcelRequire("a4Flx");

var $8DTT0 = parcelRequire("8DTT0");

var $eHMgW = parcelRequire("eHMgW");

var $bbHFU = parcelRequire("bbHFU");
/**
 * This field stores the bit mask for implementing the
 * {@link #isPrecedenceFilterSuppressed} property as a bit within the
 * existing {@link #altAndOuterContextDepth} field.
 */ const $bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER = 0x80000000;
/**
 * Represents a location with context in an ATN. The location is identified by the following values:
 *
 * * The current ATN state
 * * The predicted alternative
 * * The semantic context which must be true for this configuration to be enabled
 * * The syntactic context, which is represented as a graph-structured stack whose path(s) lead to the root of the rule
 *   invocations leading to this state
 *
 * In addition to these values, `ATNConfig` stores several properties about paths taken to get to the location which
 * were added over time to help with performance, correctness, and/or debugging.
 *
 * * `reachesIntoOuterContext`:: Used to ensure semantic predicates are not evaluated in the wrong context.
 * * `hasPassedThroughNonGreedyDecision`: Used for enabling first-match-wins instead of longest-match-wins after
 *   crossing a non-greedy decision.
 * * `lexerActionExecutor`: Used for tracking the lexer action(s) to execute should this instance be selected during
 *   lexing.
 * * `isPrecedenceFilterSuppressed`: A state variable for one of the dynamic disambiguation strategies employed by
 *   `ParserATNSimulator.applyPrecedenceFilter`.
 *
 * Due to the use of a graph-structured stack, a single `ATNConfig` is capable of representing many individual ATN
 * configurations which reached the same location in an ATN by following different paths.
 *
 * PERF: To conserve memory, `ATNConfig` is split into several different concrete types. `ATNConfig` itself stores the
 * minimum amount of information typically used to define an `ATNConfig` instance. Various derived types provide
 * additional storage space for cases where a non-default value is used for some of the object properties. The
 * `ATNConfig.create` and `ATNConfig.transform` methods automatically select the smallest concrete type capable of
 * representing the unique information for any given `ATNConfig`.
 */ let $bccb89124e8dfda2$var$ATNConfig = class ATNConfig {
    constructor(state, altOrConfig, context){
        if (typeof altOrConfig === "number") {
            $bbHFU((altOrConfig & 0xFFFFFF) === altOrConfig);
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig;
            this._context = context;
        } else {
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig.altAndOuterContextDepth;
            this._context = context;
        }
    }
    static create(state, alt, context, semanticContext = $eHMgW.SemanticContext.NONE, lexerActionExecutor) {
        if (semanticContext !== $eHMgW.SemanticContext.NONE) {
            if (lexerActionExecutor != null) return new $bccb89124e8dfda2$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, alt, context, false);
            else return new $bccb89124e8dfda2$var$SemanticContextATNConfig(semanticContext, state, alt, context);
        } else if (lexerActionExecutor != null) return new $bccb89124e8dfda2$var$ActionATNConfig(lexerActionExecutor, state, alt, context, false);
        else return new ATNConfig(state, alt, context);
    }
    /** Gets the ATN state associated with this configuration */ get state() {
        return this._state;
    }
    /** What alt (or lexer rule) is predicted by this configuration */ get alt() {
        return this.altAndOuterContextDepth & 0x00FFFFFF;
    }
    get context() {
        return this._context;
    }
    set context(context) {
        this._context = context;
    }
    get reachesIntoOuterContext() {
        return this.outerContextDepth !== 0;
    }
    /**
     * We cannot execute predicates dependent upon local context unless
     * we know for sure we are in the correct context. Because there is
     * no way to do this efficiently, we simply cannot evaluate
     * dependent predicates unless we are in the rule that initially
     * invokes the ATN simulator.
     *
     * closure() tracks the depth of how far we dip into the outer context:
     * depth &gt; 0.  Note that it may not be totally accurate depth since I
     * don't ever decrement. TODO: make it a boolean then
     */ get outerContextDepth() {
        return this.altAndOuterContextDepth >>> 24 & 0x7F;
    }
    set outerContextDepth(outerContextDepth) {
        $bbHFU(outerContextDepth >= 0);
        // saturate at 0x7F - everything but zero/positive is only used for debug information anyway
        outerContextDepth = Math.min(outerContextDepth, 0x7F);
        this.altAndOuterContextDepth = outerContextDepth << 24 | (this.altAndOuterContextDepth & -2130706433) >>> 0;
    }
    get lexerActionExecutor() {
        return undefined;
    }
    get semanticContext() {
        return $eHMgW.SemanticContext.NONE;
    }
    get hasPassedThroughNonGreedyDecision() {
        return false;
    }
    clone() {
        return this.transform(this.state, false);
    }
    transform(/*@NotNull*/ state, checkNonGreedy, arg2) {
        if (arg2 == null) return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $8DTT0.PredictionContext) return this.transformImpl(state, arg2, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $eHMgW.SemanticContext) return this.transformImpl(state, this._context, arg2, checkNonGreedy, this.lexerActionExecutor);
        else return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, arg2);
    }
    transformImpl(state, context, semanticContext, checkNonGreedy, lexerActionExecutor) {
        let passedThroughNonGreedy = checkNonGreedy && ATNConfig.checkNonGreedyDecision(this, state);
        if (semanticContext !== $eHMgW.SemanticContext.NONE) {
            if (lexerActionExecutor != null || passedThroughNonGreedy) return new $bccb89124e8dfda2$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, this, context, passedThroughNonGreedy);
            else return new $bccb89124e8dfda2$var$SemanticContextATNConfig(semanticContext, state, this, context);
        } else if (lexerActionExecutor != null || passedThroughNonGreedy) return new $bccb89124e8dfda2$var$ActionATNConfig(lexerActionExecutor, state, this, context, passedThroughNonGreedy);
        else return new ATNConfig(state, this, context);
    }
    static checkNonGreedyDecision(source, target) {
        return source.hasPassedThroughNonGreedyDecision || target instanceof $dPYn6.DecisionState && target.nonGreedy;
    }
    appendContext(context, contextCache) {
        if (typeof context === "number") {
            let appendedContext = this.context.appendSingleContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        } else {
            let appendedContext = this.context.appendContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        }
    }
    /**
     * Determines if this `ATNConfig` fully contains another `ATNConfig`.
     *
     * An ATN configuration represents a position (including context) in an ATN during parsing. Since `ATNConfig` stores
     * the context as a graph, a single `ATNConfig` instance is capable of representing many ATN configurations which
     * are all in the same "location" but have different contexts. These `ATNConfig` instances are again merged when
     * they are added to an `ATNConfigSet`. This method supports `ATNConfigSet.contains` by evaluating whether a
     * particular `ATNConfig` contains all of the ATN configurations represented by another `ATNConfig`.
     *
     * An `ATNConfig` _a_ contains another `ATNConfig` _b_ if all of the following conditions are met:
     *
     * * The configurations are in the same state (`state`)
     * * The configurations predict the same alternative (`alt`)
     * * The semantic context of _a_ implies the semantic context of _b_ (this method performs a weaker equality check)
     * * Joining the prediction contexts of _a_ and _b_ results in the prediction context of _a_
     *
     * This method implements a conservative approximation of containment. As a result, when this method returns `true`
     * it is known that parsing from `subconfig` can only recognize a subset of the inputs which can be recognized
     * starting at the current `ATNConfig`. However, due to the imprecise evaluation of implication for the semantic
     * contexts, no assumptions can be made about the relationship between the configurations when this method returns
     * `false`.
     *
     * @param subconfig The sub configuration.
     * @returns `true` if this configuration contains `subconfig`; otherwise, `false`.
     */ contains(subconfig) {
        if (this.state.stateNumber !== subconfig.state.stateNumber || this.alt !== subconfig.alt || !this.semanticContext.equals(subconfig.semanticContext)) return false;
        let leftWorkList = [];
        let rightWorkList = [];
        leftWorkList.push(this.context);
        rightWorkList.push(subconfig.context);
        while(true){
            let left = leftWorkList.pop();
            let right = rightWorkList.pop();
            if (!left || !right) break;
            if (left === right) return true;
            if (left.size < right.size) return false;
            if (right.isEmpty) return left.hasEmpty;
            else for(let i = 0; i < right.size; i++){
                let index = left.findReturnState(right.getReturnState(i));
                if (index < 0) // assumes invokingStates has no duplicate entries
                return false;
                leftWorkList.push(left.getParent(index));
                rightWorkList.push(right.getParent(i));
            }
        }
        return false;
    }
    get isPrecedenceFilterSuppressed() {
        return (this.altAndOuterContextDepth & $bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER) !== 0;
    }
    set isPrecedenceFilterSuppressed(value) {
        if (value) this.altAndOuterContextDepth |= $bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER;
        else this.altAndOuterContextDepth &= ~$bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER;
    }
    /** An ATN configuration is equal to another if both have
     *  the same state, they predict the same alternative, and
     *  syntactic/semantic contexts are the same.
     */ equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ATNConfig)) return false;
        return this.state.stateNumber === o.state.stateNumber && this.alt === o.alt && this.reachesIntoOuterContext === o.reachesIntoOuterContext && this.context.equals(o.context) && this.semanticContext.equals(o.semanticContext) && this.isPrecedenceFilterSuppressed === o.isPrecedenceFilterSuppressed && this.hasPassedThroughNonGreedyDecision === o.hasPassedThroughNonGreedyDecision && $a4Flx.ObjectEqualityComparator.INSTANCE.equals(this.lexerActionExecutor, o.lexerActionExecutor);
    }
    hashCode() {
        let hashCode = $iXFjm.MurmurHash.initialize(7);
        hashCode = $iXFjm.MurmurHash.update(hashCode, this.state.stateNumber);
        hashCode = $iXFjm.MurmurHash.update(hashCode, this.alt);
        hashCode = $iXFjm.MurmurHash.update(hashCode, this.reachesIntoOuterContext ? 1 : 0);
        hashCode = $iXFjm.MurmurHash.update(hashCode, this.context);
        hashCode = $iXFjm.MurmurHash.update(hashCode, this.semanticContext);
        hashCode = $iXFjm.MurmurHash.update(hashCode, this.hasPassedThroughNonGreedyDecision ? 1 : 0);
        hashCode = $iXFjm.MurmurHash.update(hashCode, this.lexerActionExecutor);
        hashCode = $iXFjm.MurmurHash.finish(hashCode, 7);
        return hashCode;
    }
    /**
     * Returns a graphical representation of the current `ATNConfig` in Graphviz format. The graph can be stored to a
     * **.dot** file and then rendered to an image using Graphviz.
     *
     * @returns A Graphviz graph representing the current `ATNConfig`.
     *
     * @see http://www.graphviz.org/
     */ toDotString() {
        let builder = "";
        builder += "digraph G {\n";
        builder += "rankdir=LR;\n";
        let visited = new $fP17P.Array2DHashMap($8DTT0.PredictionContext.IdentityEqualityComparator.INSTANCE);
        let workList = [];
        function getOrAddContext(context) {
            let newNumber = visited.size;
            let result = visited.putIfAbsent(context, newNumber);
            if (result != null) // Already saw this context
            return result;
            workList.push(context);
            return newNumber;
        }
        workList.push(this.context);
        visited.put(this.context, 0);
        while(true){
            let current = workList.pop();
            if (!current) break;
            for(let i = 0; i < current.size; i++){
                builder += "  s" + getOrAddContext(current);
                builder += "->";
                builder += "s" + getOrAddContext(current.getParent(i));
                builder += "[label=\"" + current.getReturnState(i) + "\"];\n";
            }
        }
        builder += "}\n";
        return builder.toString();
    }
    toString(recog, showAlt, showContext) {
        // Must check showContext before showAlt to preserve original overload behavior
        if (showContext == null) showContext = showAlt != null;
        if (showAlt == null) showAlt = true;
        let buf = "";
        // if (this.state.ruleIndex >= 0) {
        // 	if (recog != null) {
        // 		buf += (recog.ruleNames[this.state.ruleIndex] + ":");
        // 	} else {
        // 		buf += (this.state.ruleIndex + ":");
        // 	}
        // }
        let contexts;
        if (showContext) contexts = this.context.toStrings(recog, this.state.stateNumber);
        else contexts = [
            "?"
        ];
        let first = true;
        for (let contextDesc of contexts){
            if (first) first = false;
            else buf += ", ";
            buf += "(";
            buf += this.state;
            if (showAlt) {
                buf += ",";
                buf += this.alt;
            }
            if (this.context) {
                buf += ",";
                buf += contextDesc;
            }
            if (this.semanticContext !== $eHMgW.SemanticContext.NONE) {
                buf += ",";
                buf += this.semanticContext;
            }
            if (this.reachesIntoOuterContext) buf += ",up=" + this.outerContextDepth;
            buf += ")";
        }
        return buf.toString();
    }
};
$bccb89124e8dfda2$var$__decorate([
    $d6D31.NotNull
], $bccb89124e8dfda2$var$ATNConfig.prototype, "_state", void 0);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.NotNull
], $bccb89124e8dfda2$var$ATNConfig.prototype, "_context", void 0);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.NotNull
], $bccb89124e8dfda2$var$ATNConfig.prototype, "state", null);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.NotNull,
    $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull)
], $bccb89124e8dfda2$var$ATNConfig.prototype, "context", null);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.NotNull
], $bccb89124e8dfda2$var$ATNConfig.prototype, "semanticContext", null);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.Override
], $bccb89124e8dfda2$var$ATNConfig.prototype, "clone", null);
$bccb89124e8dfda2$var$__decorate([
    $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull),
    $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
], $bccb89124e8dfda2$var$ATNConfig.prototype, "transformImpl", null);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.Override
], $bccb89124e8dfda2$var$ATNConfig.prototype, "equals", null);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.Override
], $bccb89124e8dfda2$var$ATNConfig.prototype, "hashCode", null);
$bccb89124e8dfda2$var$__decorate([
    $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull),
    $bccb89124e8dfda2$var$__param(3, $d6D31.NotNull)
], $bccb89124e8dfda2$var$ATNConfig, "create", null);
$bccb89124e8dfda2$var$ATNConfig = $bccb89124e8dfda2$var$__decorate([
    $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull),
    $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
], $bccb89124e8dfda2$var$ATNConfig);
module.exports.ATNConfig = $bccb89124e8dfda2$var$ATNConfig;
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $bccb89124e8dfda2$var$SemanticContextATNConfig = class SemanticContextATNConfig extends $bccb89124e8dfda2$var$ATNConfig {
    constructor(semanticContext, state, altOrConfig, context){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else super(state, altOrConfig, context);
        this._semanticContext = semanticContext;
    }
    get semanticContext() {
        return this._semanticContext;
    }
};
$bccb89124e8dfda2$var$__decorate([
    $d6D31.NotNull
], $bccb89124e8dfda2$var$SemanticContextATNConfig.prototype, "_semanticContext", void 0);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.Override
], $bccb89124e8dfda2$var$SemanticContextATNConfig.prototype, "semanticContext", null);
$bccb89124e8dfda2$var$SemanticContextATNConfig = $bccb89124e8dfda2$var$__decorate([
    $bccb89124e8dfda2$var$__param(1, $d6D31.NotNull),
    $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
], $bccb89124e8dfda2$var$SemanticContextATNConfig);
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a lexer action.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $bccb89124e8dfda2$var$ActionATNConfig = class ActionATNConfig extends $bccb89124e8dfda2$var$ATNConfig {
    constructor(lexerActionExecutor, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else {
            super(state, altOrConfig, context);
            if (altOrConfig.semanticContext !== $eHMgW.SemanticContext.NONE) throw new Error("Not supported");
        }
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
};
$bccb89124e8dfda2$var$__decorate([
    $d6D31.Override
], $bccb89124e8dfda2$var$ActionATNConfig.prototype, "lexerActionExecutor", null);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.Override
], $bccb89124e8dfda2$var$ActionATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$bccb89124e8dfda2$var$ActionATNConfig = $bccb89124e8dfda2$var$__decorate([
    $bccb89124e8dfda2$var$__param(1, $d6D31.NotNull),
    $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
], $bccb89124e8dfda2$var$ActionATNConfig);
/**
 * This class was derived from `SemanticContextATNConfig` purely as a memory optimization. It allows for the creation of
 * an `ATNConfig` with both a lexer action and a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $bccb89124e8dfda2$var$ActionSemanticContextATNConfig = class ActionSemanticContextATNConfig extends $bccb89124e8dfda2$var$SemanticContextATNConfig {
    constructor(lexerActionExecutor, semanticContext, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(semanticContext, state, altOrConfig, context);
        else super(semanticContext, state, altOrConfig, context);
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
};
$bccb89124e8dfda2$var$__decorate([
    $d6D31.Override
], $bccb89124e8dfda2$var$ActionSemanticContextATNConfig.prototype, "lexerActionExecutor", null);
$bccb89124e8dfda2$var$__decorate([
    $d6D31.Override
], $bccb89124e8dfda2$var$ActionSemanticContextATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$bccb89124e8dfda2$var$ActionSemanticContextATNConfig = $bccb89124e8dfda2$var$__decorate([
    $bccb89124e8dfda2$var$__param(1, $d6D31.NotNull),
    $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
], $bccb89124e8dfda2$var$ActionSemanticContextATNConfig);

});
parcelRegister("dPYn6", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecisionState = void 0;

var $7j0Pc = parcelRequire("7j0Pc");
class $a12ede58b33ddcba$var$DecisionState extends $7j0Pc.ATNState {
    constructor(){
        super(...arguments);
        this.decision = -1;
        this.nonGreedy = false;
        this.sll = false;
    }
}
module.exports.DecisionState = $a12ede58b33ddcba$var$DecisionState;

});

parcelRegister("8DTT0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $64ad510fde44ff92$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $64ad510fde44ff92$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SingletonPredictionContext = module.exports.PredictionContext = void 0;

var $fP17P = parcelRequire("fP17P");

var $7Veax = parcelRequire("7Veax");

var $9yG1X = parcelRequire("9yG1X");

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");

var $6vF7J = parcelRequire("6vF7J");

var $bbHFU = parcelRequire("bbHFU");
const $64ad510fde44ff92$var$INITIAL_HASH = 1;
class $64ad510fde44ff92$var$PredictionContext {
    constructor(cachedHashCode){
        this.cachedHashCode = cachedHashCode;
    }
    static calculateEmptyHashCode() {
        let hash = $iXFjm.MurmurHash.initialize($64ad510fde44ff92$var$INITIAL_HASH);
        hash = $iXFjm.MurmurHash.finish(hash, 0);
        return hash;
    }
    static calculateSingleHashCode(parent, returnState) {
        let hash = $iXFjm.MurmurHash.initialize($64ad510fde44ff92$var$INITIAL_HASH);
        hash = $iXFjm.MurmurHash.update(hash, parent);
        hash = $iXFjm.MurmurHash.update(hash, returnState);
        hash = $iXFjm.MurmurHash.finish(hash, 2);
        return hash;
    }
    static calculateHashCode(parents, returnStates) {
        let hash = $iXFjm.MurmurHash.initialize($64ad510fde44ff92$var$INITIAL_HASH);
        for (let parent of parents)hash = $iXFjm.MurmurHash.update(hash, parent);
        for (let returnState of returnStates)hash = $iXFjm.MurmurHash.update(hash, returnState);
        hash = $iXFjm.MurmurHash.finish(hash, 2 * parents.length);
        return hash;
    }
    static fromRuleContext(atn, outerContext, fullContext = true) {
        if (outerContext.isEmpty) return fullContext ? $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL : $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
        let parent;
        if (outerContext._parent) parent = $64ad510fde44ff92$var$PredictionContext.fromRuleContext(atn, outerContext._parent, fullContext);
        else parent = fullContext ? $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL : $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
        let state = atn.states[outerContext.invokingState];
        let transition = state.transition(0);
        return parent.getChild(transition.followState.stateNumber);
    }
    static addEmptyContext(context) {
        return context.addEmptyContext();
    }
    static removeEmptyContext(context) {
        return context.removeEmptyContext();
    }
    static join(context0, context1, contextCache = $6vF7J.PredictionContextCache.UNCACHED) {
        if (context0 === context1) return context0;
        if (context0.isEmpty) return $64ad510fde44ff92$var$PredictionContext.isEmptyLocal(context0) ? context0 : $64ad510fde44ff92$var$PredictionContext.addEmptyContext(context1);
        else if (context1.isEmpty) return $64ad510fde44ff92$var$PredictionContext.isEmptyLocal(context1) ? context1 : $64ad510fde44ff92$var$PredictionContext.addEmptyContext(context0);
        let context0size = context0.size;
        let context1size = context1.size;
        if (context0size === 1 && context1size === 1 && context0.getReturnState(0) === context1.getReturnState(0)) {
            let merged = contextCache.join(context0.getParent(0), context1.getParent(0));
            if (merged === context0.getParent(0)) return context0;
            else if (merged === context1.getParent(0)) return context1;
            else return merged.getChild(context0.getReturnState(0));
        }
        let count = 0;
        let parentsList = new Array(context0size + context1size);
        let returnStatesList = new Array(parentsList.length);
        let leftIndex = 0;
        let rightIndex = 0;
        let canReturnLeft = true;
        let canReturnRight = true;
        while(leftIndex < context0size && rightIndex < context1size){
            if (context0.getReturnState(leftIndex) === context1.getReturnState(rightIndex)) {
                parentsList[count] = contextCache.join(context0.getParent(leftIndex), context1.getParent(rightIndex));
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnLeft = canReturnLeft && parentsList[count] === context0.getParent(leftIndex);
                canReturnRight = canReturnRight && parentsList[count] === context1.getParent(rightIndex);
                leftIndex++;
                rightIndex++;
            } else if (context0.getReturnState(leftIndex) < context1.getReturnState(rightIndex)) {
                parentsList[count] = context0.getParent(leftIndex);
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnRight = false;
                leftIndex++;
            } else {
                $bbHFU(context1.getReturnState(rightIndex) < context0.getReturnState(leftIndex));
                parentsList[count] = context1.getParent(rightIndex);
                returnStatesList[count] = context1.getReturnState(rightIndex);
                canReturnLeft = false;
                rightIndex++;
            }
            count++;
        }
        while(leftIndex < context0size){
            parentsList[count] = context0.getParent(leftIndex);
            returnStatesList[count] = context0.getReturnState(leftIndex);
            leftIndex++;
            canReturnRight = false;
            count++;
        }
        while(rightIndex < context1size){
            parentsList[count] = context1.getParent(rightIndex);
            returnStatesList[count] = context1.getReturnState(rightIndex);
            rightIndex++;
            canReturnLeft = false;
            count++;
        }
        if (canReturnLeft) return context0;
        else if (canReturnRight) return context1;
        if (count < parentsList.length) {
            parentsList = parentsList.slice(0, count);
            returnStatesList = returnStatesList.slice(0, count);
        }
        if (parentsList.length === 0) // if one of them was EMPTY_LOCAL, it would be empty and handled at the beginning of the method
        return $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL;
        else if (parentsList.length === 1) return new $64ad510fde44ff92$var$SingletonPredictionContext(parentsList[0], returnStatesList[0]);
        else return new $64ad510fde44ff92$var$ArrayPredictionContext(parentsList, returnStatesList);
    }
    static isEmptyLocal(context) {
        return context === $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
    }
    static getCachedContext(context, contextCache, visited) {
        if (context.isEmpty) return context;
        let existing = visited.get(context);
        if (existing) return existing;
        existing = contextCache.get(context);
        if (existing) {
            visited.put(context, existing);
            return existing;
        }
        let changed = false;
        let parents = new Array(context.size);
        for(let i = 0; i < parents.length; i++){
            let parent = $64ad510fde44ff92$var$PredictionContext.getCachedContext(context.getParent(i), contextCache, visited);
            if (changed || parent !== context.getParent(i)) {
                if (!changed) {
                    parents = new Array(context.size);
                    for(let j = 0; j < context.size; j++)parents[j] = context.getParent(j);
                    changed = true;
                }
                parents[i] = parent;
            }
        }
        if (!changed) {
            existing = contextCache.putIfAbsent(context, context);
            visited.put(context, existing != null ? existing : context);
            return context;
        }
        // We know parents.length>0 because context.isEmpty is checked at the beginning of the method.
        let updated;
        if (parents.length === 1) updated = new $64ad510fde44ff92$var$SingletonPredictionContext(parents[0], context.getReturnState(0));
        else {
            let returnStates = new Array(context.size);
            for(let i = 0; i < context.size; i++)returnStates[i] = context.getReturnState(i);
            updated = new $64ad510fde44ff92$var$ArrayPredictionContext(parents, returnStates, context.hashCode());
        }
        existing = contextCache.putIfAbsent(updated, updated);
        visited.put(updated, existing || updated);
        visited.put(context, existing || updated);
        return updated;
    }
    appendSingleContext(returnContext, contextCache) {
        return this.appendContext($64ad510fde44ff92$var$PredictionContext.EMPTY_FULL.getChild(returnContext), contextCache);
    }
    getChild(returnState) {
        return new $64ad510fde44ff92$var$SingletonPredictionContext(this, returnState);
    }
    hashCode() {
        return this.cachedHashCode;
    }
    toStrings(recognizer, currentState, stop = $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL) {
        let result = [];
        outer: for(let perm = 0;; perm++){
            let offset = 0;
            let last = true;
            let p = this;
            let stateNumber = currentState;
            let localBuffer = "";
            localBuffer += "[";
            while(!p.isEmpty && p !== stop){
                let index = 0;
                if (p.size > 0) {
                    let bits = 1;
                    while(1 << bits >>> 0 < p.size)bits++;
                    let mask = (1 << bits >>> 0) - 1;
                    index = perm >> offset & mask;
                    last = last && index >= p.size - 1;
                    if (index >= p.size) continue outer;
                    offset += bits;
                }
                if (recognizer) {
                    if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                    localBuffer += " ";
                    let atn = recognizer.atn;
                    let s = atn.states[stateNumber];
                    let ruleName = recognizer.ruleNames[s.ruleIndex];
                    localBuffer += ruleName;
                } else if (p.getReturnState(index) !== $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY) {
                    if (!p.isEmpty) {
                        if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                        localBuffer += " ";
                        localBuffer += p.getReturnState(index);
                    }
                }
                stateNumber = p.getReturnState(index);
                p = p.getParent(index);
            }
            localBuffer += "]";
            result.push(localBuffer);
            if (last) break;
        }
        return result;
    }
}
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$PredictionContext.prototype, "hashCode", null);
$64ad510fde44ff92$var$__decorate([
    $64ad510fde44ff92$var$__param(0, $d6D31.NotNull),
    $64ad510fde44ff92$var$__param(1, $d6D31.NotNull),
    $64ad510fde44ff92$var$__param(2, $d6D31.NotNull)
], $64ad510fde44ff92$var$PredictionContext, "join", null);
$64ad510fde44ff92$var$__decorate([
    $64ad510fde44ff92$var$__param(0, $d6D31.NotNull),
    $64ad510fde44ff92$var$__param(1, $d6D31.NotNull),
    $64ad510fde44ff92$var$__param(2, $d6D31.NotNull)
], $64ad510fde44ff92$var$PredictionContext, "getCachedContext", null);
module.exports.PredictionContext = $64ad510fde44ff92$var$PredictionContext;
class $64ad510fde44ff92$var$EmptyPredictionContext extends $64ad510fde44ff92$var$PredictionContext {
    constructor(fullContext){
        super($64ad510fde44ff92$var$PredictionContext.calculateEmptyHashCode());
        this.fullContext = fullContext;
    }
    get isFullContext() {
        return this.fullContext;
    }
    addEmptyContext() {
        return this;
    }
    removeEmptyContext() {
        throw new Error("Cannot remove the empty context from itself.");
    }
    getParent(index) {
        throw new Error("index out of bounds");
    }
    getReturnState(index) {
        throw new Error("index out of bounds");
    }
    findReturnState(returnState) {
        return -1;
    }
    get size() {
        return 0;
    }
    appendSingleContext(returnContext, contextCache) {
        return contextCache.getChild(this, returnContext);
    }
    appendContext(suffix, contextCache) {
        return suffix;
    }
    get isEmpty() {
        return true;
    }
    get hasEmpty() {
        return true;
    }
    equals(o) {
        return this === o;
    }
    toStrings(recognizer, currentState, stop) {
        return [
            "[]"
        ];
    }
}
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "addEmptyContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "removeEmptyContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "getParent", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "getReturnState", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "findReturnState", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "size", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "appendSingleContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "appendContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "isEmpty", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "hasEmpty", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "equals", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "toStrings", null);
let $64ad510fde44ff92$var$ArrayPredictionContext = class ArrayPredictionContext extends $64ad510fde44ff92$var$PredictionContext {
    constructor(parents, returnStates, hashCode){
        super(hashCode || $64ad510fde44ff92$var$PredictionContext.calculateHashCode(parents, returnStates));
        $bbHFU(parents.length === returnStates.length);
        $bbHFU(returnStates.length > 1 || returnStates[0] !== $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY, "Should be using PredictionContext.EMPTY instead.");
        this.parents = parents;
        this.returnStates = returnStates;
    }
    getParent(index) {
        return this.parents[index];
    }
    getReturnState(index) {
        return this.returnStates[index];
    }
    findReturnState(returnState) {
        return $9yG1X.Arrays.binarySearch(this.returnStates, returnState);
    }
    get size() {
        return this.returnStates.length;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return this.returnStates[this.returnStates.length - 1] === $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY;
    }
    addEmptyContext() {
        if (this.hasEmpty) return this;
        let parents2 = this.parents.slice(0);
        let returnStates2 = this.returnStates.slice(0);
        parents2.push($64ad510fde44ff92$var$PredictionContext.EMPTY_FULL);
        returnStates2.push($64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY);
        return new ArrayPredictionContext(parents2, returnStates2);
    }
    removeEmptyContext() {
        if (!this.hasEmpty) return this;
        if (this.returnStates.length === 2) return new $64ad510fde44ff92$var$SingletonPredictionContext(this.parents[0], this.returnStates[0]);
        else {
            let parents2 = this.parents.slice(0, this.parents.length - 1);
            let returnStates2 = this.returnStates.slice(0, this.returnStates.length - 1);
            return new ArrayPredictionContext(parents2, returnStates2);
        }
    }
    appendContext(suffix, contextCache) {
        return ArrayPredictionContext.appendContextImpl(this, suffix, new $64ad510fde44ff92$var$PredictionContext.IdentityHashMap());
    }
    static appendContextImpl(context, suffix, visited) {
        if (suffix.isEmpty) {
            if ($64ad510fde44ff92$var$PredictionContext.isEmptyLocal(suffix)) {
                if (context.hasEmpty) return $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
                throw new Error("what to do here?");
            }
            return context;
        }
        if (suffix.size !== 1) throw new Error("Appending a tree suffix is not yet supported.");
        let result = visited.get(context);
        if (!result) {
            if (context.isEmpty) result = suffix;
            else {
                let parentCount = context.size;
                if (context.hasEmpty) parentCount--;
                let updatedParents = new Array(parentCount);
                let updatedReturnStates = new Array(parentCount);
                for(let i = 0; i < parentCount; i++)updatedReturnStates[i] = context.getReturnState(i);
                for(let i = 0; i < parentCount; i++)updatedParents[i] = ArrayPredictionContext.appendContextImpl(context.getParent(i), suffix, visited);
                if (updatedParents.length === 1) result = new $64ad510fde44ff92$var$SingletonPredictionContext(updatedParents[0], updatedReturnStates[0]);
                else {
                    $bbHFU(updatedParents.length > 1);
                    result = new ArrayPredictionContext(updatedParents, updatedReturnStates);
                }
                if (context.hasEmpty) result = $64ad510fde44ff92$var$PredictionContext.join(result, suffix);
            }
            visited.put(context, result);
        }
        return result;
    }
    equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ArrayPredictionContext)) return false;
        if (this.hashCode() !== o.hashCode()) // can't be same if hash is different
        return false;
        let other = o;
        return this.equalsImpl(other, new $7Veax.Array2DHashSet());
    }
    equalsImpl(other, visited) {
        let selfWorkList = [];
        let otherWorkList = [];
        selfWorkList.push(this);
        otherWorkList.push(other);
        while(true){
            let currentSelf = selfWorkList.pop();
            let currentOther = otherWorkList.pop();
            if (!currentSelf || !currentOther) break;
            let operands = new $6vF7J.PredictionContextCache.IdentityCommutativePredictionContextOperands(currentSelf, currentOther);
            if (!visited.add(operands)) continue;
            let selfSize = operands.x.size;
            if (selfSize === 0) {
                if (!operands.x.equals(operands.y)) return false;
                continue;
            }
            let otherSize = operands.y.size;
            if (selfSize !== otherSize) return false;
            for(let i = 0; i < selfSize; i++){
                if (operands.x.getReturnState(i) !== operands.y.getReturnState(i)) return false;
                let selfParent = operands.x.getParent(i);
                let otherParent = operands.y.getParent(i);
                if (selfParent.hashCode() !== otherParent.hashCode()) return false;
                if (selfParent !== otherParent) {
                    selfWorkList.push(selfParent);
                    otherWorkList.push(otherParent);
                }
            }
        }
        return true;
    }
};
$64ad510fde44ff92$var$__decorate([
    $d6D31.NotNull
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "parents", void 0);
$64ad510fde44ff92$var$__decorate([
    $d6D31.NotNull
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "returnStates", void 0);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "getParent", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "getReturnState", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "findReturnState", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "size", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "isEmpty", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "hasEmpty", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "addEmptyContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "removeEmptyContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "appendContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "equals", null);
$64ad510fde44ff92$var$ArrayPredictionContext = $64ad510fde44ff92$var$__decorate([
    $64ad510fde44ff92$var$__param(0, $d6D31.NotNull)
], $64ad510fde44ff92$var$ArrayPredictionContext);
let $64ad510fde44ff92$var$SingletonPredictionContext = class SingletonPredictionContext extends $64ad510fde44ff92$var$PredictionContext {
    constructor(parent, returnState){
        super($64ad510fde44ff92$var$PredictionContext.calculateSingleHashCode(parent, returnState));
        // assert(returnState != PredictionContext.EMPTY_FULL_STATE_KEY && returnState != PredictionContext.EMPTY_LOCAL_STATE_KEY);
        this.parent = parent;
        this.returnState = returnState;
    }
    getParent(index) {
        // assert(index == 0);
        return this.parent;
    }
    getReturnState(index) {
        // assert(index == 0);
        return this.returnState;
    }
    findReturnState(returnState) {
        return this.returnState === returnState ? 0 : -1;
    }
    get size() {
        return 1;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return false;
    }
    appendContext(suffix, contextCache) {
        return contextCache.getChild(this.parent.appendContext(suffix, contextCache), this.returnState);
    }
    addEmptyContext() {
        let parents = [
            this.parent,
            $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL
        ];
        let returnStates = [
            this.returnState,
            $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY
        ];
        return new $64ad510fde44ff92$var$ArrayPredictionContext(parents, returnStates);
    }
    removeEmptyContext() {
        return this;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof SingletonPredictionContext)) return false;
        let other = o;
        if (this.hashCode() !== other.hashCode()) return false;
        return this.returnState === other.returnState && this.parent.equals(other.parent);
    }
};
$64ad510fde44ff92$var$__decorate([
    $d6D31.NotNull
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "parent", void 0);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "getParent", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "getReturnState", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "findReturnState", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "size", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "isEmpty", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "hasEmpty", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "appendContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "addEmptyContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "removeEmptyContext", null);
$64ad510fde44ff92$var$__decorate([
    $d6D31.Override
], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "equals", null);
$64ad510fde44ff92$var$SingletonPredictionContext = $64ad510fde44ff92$var$__decorate([
    $64ad510fde44ff92$var$__param(0, $d6D31.NotNull)
], $64ad510fde44ff92$var$SingletonPredictionContext);
module.exports.SingletonPredictionContext = $64ad510fde44ff92$var$SingletonPredictionContext;
(function(PredictionContext) {
    PredictionContext.EMPTY_LOCAL = new $64ad510fde44ff92$var$EmptyPredictionContext(false);
    PredictionContext.EMPTY_FULL = new $64ad510fde44ff92$var$EmptyPredictionContext(true);
    PredictionContext.EMPTY_LOCAL_STATE_KEY = -2147483648;
    PredictionContext.EMPTY_FULL_STATE_KEY = 2147483647;
    class IdentityHashMap extends $fP17P.Array2DHashMap {
        constructor(){
            super(IdentityEqualityComparator.INSTANCE);
        }
    }
    PredictionContext.IdentityHashMap = IdentityHashMap;
    class IdentityEqualityComparator {
        IdentityEqualityComparator() {
        // intentionally empty
        }
        hashCode(obj) {
            return obj.hashCode();
        }
        equals(a, b) {
            return a === b;
        }
    }
    IdentityEqualityComparator.INSTANCE = new IdentityEqualityComparator();
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], IdentityEqualityComparator.prototype, "hashCode", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], IdentityEqualityComparator.prototype, "equals", null);
    PredictionContext.IdentityEqualityComparator = IdentityEqualityComparator;
})($64ad510fde44ff92$var$PredictionContext = module.exports.PredictionContext || (module.exports.PredictionContext = {}));

});
parcelRegister("6vF7J", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4bd589a149816580$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionContextCache = void 0;

var $fP17P = parcelRequire("fP17P");

var $d6D31 = parcelRequire("d6D31");

var $a4Flx = parcelRequire("a4Flx");

var $8DTT0 = parcelRequire("8DTT0");

var $bbHFU = parcelRequire("bbHFU");
/** Used to cache {@link PredictionContext} objects. Its used for the shared
 *  context cash associated with contexts in DFA states. This cache
 *  can be used for both lexers and parsers.
 *
 * @author Sam Harwell
 */ class $4bd589a149816580$var$PredictionContextCache {
    constructor(enableCache = true){
        this.contexts = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
        this.childContexts = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
        this.joinContexts = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
        this.enableCache = enableCache;
    }
    getAsCached(context) {
        if (!this.enableCache) return context;
        let result = this.contexts.get(context);
        if (!result) {
            result = context;
            this.contexts.put(context, context);
        }
        return result;
    }
    getChild(context, invokingState) {
        if (!this.enableCache) return context.getChild(invokingState);
        let operands = new $4bd589a149816580$var$PredictionContextCache.PredictionContextAndInt(context, invokingState);
        let result = this.childContexts.get(operands);
        if (!result) {
            result = context.getChild(invokingState);
            result = this.getAsCached(result);
            this.childContexts.put(operands, result);
        }
        return result;
    }
    join(x, y) {
        if (!this.enableCache) return $8DTT0.PredictionContext.join(x, y, this);
        let operands = new $4bd589a149816580$var$PredictionContextCache.IdentityCommutativePredictionContextOperands(x, y);
        let result = this.joinContexts.get(operands);
        if (result) return result;
        result = $8DTT0.PredictionContext.join(x, y, this);
        result = this.getAsCached(result);
        this.joinContexts.put(operands, result);
        return result;
    }
}
module.exports.PredictionContextCache = $4bd589a149816580$var$PredictionContextCache;
$4bd589a149816580$var$PredictionContextCache.UNCACHED = new $4bd589a149816580$var$PredictionContextCache(false);
(function(PredictionContextCache) {
    class PredictionContextAndInt {
        constructor(obj, value){
            this.obj = obj;
            this.value = value;
        }
        equals(obj) {
            if (!(obj instanceof PredictionContextAndInt)) return false;
            else if (obj === this) return true;
            let other = obj;
            return this.value === other.value && (this.obj === other.obj || this.obj != null && this.obj.equals(other.obj));
        }
        hashCode() {
            let hashCode = 5;
            hashCode = 7 * hashCode + (this.obj != null ? this.obj.hashCode() : 0);
            hashCode = 7 * hashCode + this.value;
            return hashCode;
        }
    }
    $4bd589a149816580$var$__decorate([
        $d6D31.Override
    ], PredictionContextAndInt.prototype, "equals", null);
    $4bd589a149816580$var$__decorate([
        $d6D31.Override
    ], PredictionContextAndInt.prototype, "hashCode", null);
    PredictionContextCache.PredictionContextAndInt = PredictionContextAndInt;
    class IdentityCommutativePredictionContextOperands {
        constructor(x, y){
            $bbHFU(x != null);
            $bbHFU(y != null);
            this._x = x;
            this._y = y;
        }
        get x() {
            return this._x;
        }
        get y() {
            return this._y;
        }
        equals(o) {
            if (!(o instanceof IdentityCommutativePredictionContextOperands)) return false;
            else if (this === o) return true;
            let other = o;
            return this._x === other._x && this._y === other._y || this._x === other._y && this._y === other._x;
        }
        hashCode() {
            return this._x.hashCode() ^ this._y.hashCode();
        }
    }
    $4bd589a149816580$var$__decorate([
        $d6D31.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "equals", null);
    $4bd589a149816580$var$__decorate([
        $d6D31.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "hashCode", null);
    PredictionContextCache.IdentityCommutativePredictionContextOperands = IdentityCommutativePredictionContextOperands;
})($4bd589a149816580$var$PredictionContextCache = module.exports.PredictionContextCache || (module.exports.PredictionContextCache = {}));

});



parcelRegister("5BPMp", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BitSet = void 0;

var $9kAQu = parcelRequire("9kAQu");

var $iXFjm = parcelRequire("iXFjm");
/**
 * Private empty array used to construct empty BitSets
 */ const $415892d73e8925a4$var$EMPTY_DATA = new Uint16Array(0);
/**
 * Gets the word index of the `UInt16` element in `BitSet.data` containing the bit with the specified index.
 */ function $415892d73e8925a4$var$getIndex(bitNumber) {
    return bitNumber >>> 4;
}
/**
 * Convert a word index into the bit index of the LSB of that word
 */ function $415892d73e8925a4$var$unIndex(n) {
    return n * 16;
}
/**
 * Get's the bit number of the least signficant bit set LSB which is set in a word non-zero word;
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $415892d73e8925a4$var$findLSBSet(word) {
    let bit = 1;
    for(let i = 0; i < 16; i++){
        if ((word & bit) !== 0) return i;
        bit = bit << 1 >>> 0;
    }
    throw new RangeError("No specified bit found");
}
function $415892d73e8925a4$var$findMSBSet(word) {
    let bit = 32768;
    for(let i = 15; i >= 0; i--){
        if ((word & bit) !== 0) return i;
        bit = bit >>> 1;
    }
    throw new RangeError("No specified bit found");
}
/**
 * Gets a 16-bit mask with bit numbers fromBit to toBit (inclusive) set.
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $415892d73e8925a4$var$bitsFor(fromBit, toBit) {
    fromBit &= 0xF;
    toBit &= 0xF;
    if (fromBit === toBit) return 1 << fromBit >>> 0;
    return 0xFFFF >>> 15 - toBit ^ 0xFFFF >>> 16 - fromBit;
}
/**
 * A lookup table for number of set bits in a 16-bit integer.   This is used to quickly count the cardinality (number of unique elements) of a BitSet.
 */ const $415892d73e8925a4$var$POP_CNT = new Uint8Array(65536);
for(let i = 0; i < 16; i++){
    const stride = 1 << i >>> 0;
    let index = 0;
    while(index < $415892d73e8925a4$var$POP_CNT.length){
        // skip the numbers where the bit isn't set
        index += stride;
        // increment the ones where the bit is set
        for(let j = 0; j < stride; j++){
            $415892d73e8925a4$var$POP_CNT[index]++;
            index++;
        }
    }
}
class $415892d73e8925a4$var$BitSet {
    /*
    ** constructor implementation
    */ constructor(arg){
        if (!arg) // covering the case of unspecified and nbits===0
        this.data = $415892d73e8925a4$var$EMPTY_DATA;
        else if (typeof arg === "number") {
            if (arg < 0) throw new RangeError("nbits cannot be negative");
            else this.data = new Uint16Array($415892d73e8925a4$var$getIndex(arg - 1) + 1);
        } else if (arg instanceof $415892d73e8925a4$var$BitSet) this.data = arg.data.slice(0); // Clone the data
        else {
            let max = -1;
            for (let v of arg)if (max < v) max = v;
            this.data = new Uint16Array($415892d73e8925a4$var$getIndex(max - 1) + 1);
            for (let v of arg)this.set(v);
        }
    }
    /**
     * Performs a logical **AND** of this target bit set with the argument bit set. This bit set is modified so that
     * each bit in it has the value `true` if and only if it both initially had the value `true` and the corresponding
     * bit in the bit set argument also had the value `true`.
     */ and(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Clears all of the bits in this `BitSet` whose corresponding bit is set in the specified `BitSet`.
     */ andNot(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i] ^ 0xFFFF;
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Returns the number of bits set to `true` in this `BitSet`.
     */ cardinality() {
        if (this.isEmpty) return 0;
        const data = this.data;
        const length = data.length;
        let result = 0;
        for(let i = 0; i < length; i++)result += $415892d73e8925a4$var$POP_CNT[data[i]];
        return result;
    }
    clear(fromIndex, toIndex) {
        if (fromIndex == null) this.data.fill(0);
        else if (toIndex == null) this.set(fromIndex, false);
        else this.set(fromIndex, toIndex, false);
    }
    flip(fromIndex, toIndex) {
        if (toIndex == null) toIndex = fromIndex;
        if (fromIndex < 0 || toIndex < fromIndex) throw new RangeError();
        let word = $415892d73e8925a4$var$getIndex(fromIndex);
        const lastWord = $415892d73e8925a4$var$getIndex(toIndex);
        if (word === lastWord) this.data[word] ^= $415892d73e8925a4$var$bitsFor(fromIndex, toIndex);
        else {
            this.data[word++] ^= $415892d73e8925a4$var$bitsFor(fromIndex, 15);
            while(word < lastWord)this.data[word++] ^= 0xFFFF;
            this.data[word++] ^= $415892d73e8925a4$var$bitsFor(0, toIndex);
        }
    }
    get(fromIndex, toIndex) {
        if (toIndex === undefined) return !!(this.data[$415892d73e8925a4$var$getIndex(fromIndex)] & $415892d73e8925a4$var$bitsFor(fromIndex, fromIndex));
        else {
            // return a BitSet
            let result = new $415892d73e8925a4$var$BitSet(toIndex + 1);
            for(let i = fromIndex; i <= toIndex; i++)result.set(i, this.get(i));
            return result;
        }
    }
    /**
     * Returns true if the specified `BitSet` has any bits set to `true` that are also set to `true` in this `BitSet`.
     *
     * @param set `BitSet` to intersect with
     */ intersects(set) {
        let smallerLength = Math.min(this.length(), set.length());
        if (smallerLength === 0) return false;
        let bound = $415892d73e8925a4$var$getIndex(smallerLength - 1);
        for(let i = 0; i <= bound; i++){
            if ((this.data[i] & set.data[i]) !== 0) return true;
        }
        return false;
    }
    /**
     * Returns true if this `BitSet` contains no bits that are set to `true`.
     */ get isEmpty() {
        return this.length() === 0;
    }
    /**
     * Returns the "logical size" of this `BitSet`: the index of the highest set bit in the `BitSet` plus one. Returns
     * zero if the `BitSet` contains no set bits.
     */ length() {
        if (!this.data.length) return 0;
        return this.previousSetBit($415892d73e8925a4$var$unIndex(this.data.length) - 1) + 1;
    }
    /**
     * Returns the index of the first bit that is set to `false` that occurs on or after the specified starting index,
     * If no such bit exists then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $415892d73e8925a4$var$getIndex(fromIndex);
        if (word > length) return -1;
        let ignore = 0xFFFF ^ $415892d73e8925a4$var$bitsFor(fromIndex, 15);
        if ((data[word] | ignore) === 0xFFFF) {
            word++;
            ignore = 0;
            for(; word < length; word++){
                if (data[word] !== 0xFFFF) break;
            }
            if (word === length) // Hit the end
            return -1;
        }
        return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findLSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the first bit that is set to `true` that occurs on or after the specified starting index.
     * If no such bit exists then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.nextSetBit(0); i >= 0; i = bs.nextSetBit(i + 1)) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $415892d73e8925a4$var$getIndex(fromIndex);
        if (word > length) return -1;
        let mask = $415892d73e8925a4$var$bitsFor(fromIndex, 15);
        if ((data[word] & mask) === 0) {
            word++;
            mask = 0xFFFF;
            for(; word < length; word++){
                if (data[word] !== 0) break;
            }
            if (word >= length) return -1;
        }
        return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findLSBSet(data[word] & mask);
    }
    /**
     * Performs a logical **OR** of this bit set with the bit set argument. This bit set is modified so that a bit in it
     * has the value `true` if and only if it either already had the value `true` or the corresponding bit in the bit
     * set argument has the value `true`.
     */ or(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Or those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] | other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord);
    }
    /**
     * Returns the index of the nearest bit that is set to `false` that occurs on or before the specified starting
     * index. If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $415892d73e8925a4$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let ignore = 0xFFFF ^ $415892d73e8925a4$var$bitsFor(0, fromIndex);
        if ((data[word] | ignore) === 0xFFFF) {
            ignore = 0;
            word--;
            for(; word >= 0; word--){
                if (data[word] !== 0xFFFF) break;
            }
            if (word < 0) // Hit the end
            return -1;
        }
        return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findMSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the nearest bit that is set to `true` that occurs on or before the specified starting index.
     * If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.length(); (i = bs.previousSetBit(i-1)) >= 0; ) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $415892d73e8925a4$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let mask = $415892d73e8925a4$var$bitsFor(0, fromIndex);
        if ((data[word] & mask) === 0) {
            word--;
            mask = 0xFFFF;
            for(; word >= 0; word--){
                if (data[word] !== 0) break;
            }
            if (word < 0) return -1;
        }
        return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findMSBSet(data[word] & mask);
    }
    set(fromIndex, toIndex, value) {
        if (toIndex === undefined) {
            toIndex = fromIndex;
            value = true;
        } else if (typeof toIndex === "boolean") {
            value = toIndex;
            toIndex = fromIndex;
        }
        if (value === undefined) value = true;
        if (fromIndex < 0 || fromIndex > toIndex) throw new RangeError();
        let word = $415892d73e8925a4$var$getIndex(fromIndex);
        let lastWord = $415892d73e8925a4$var$getIndex(toIndex);
        if (value && lastWord >= this.data.length) {
            // Grow array "just enough" for bits we need to set
            let temp = new Uint16Array(lastWord + 1);
            this.data.forEach((value, index)=>temp[index] = value);
            this.data = temp;
        } else if (!value) {
            // But there is no need to grow array to clear bits.
            if (word >= this.data.length) // Early exit
            return;
            if (lastWord >= this.data.length) {
                // Adjust work to fit array
                lastWord = this.data.length - 1;
                toIndex = this.data.length * 16 - 1;
            }
        }
        if (word === lastWord) this._setBits(word, value, $415892d73e8925a4$var$bitsFor(fromIndex, toIndex));
        else {
            this._setBits(word++, value, $415892d73e8925a4$var$bitsFor(fromIndex, 15));
            while(word < lastWord)this.data[word++] = value ? 0xFFFF : 0;
            this._setBits(word, value, $415892d73e8925a4$var$bitsFor(0, toIndex));
        }
    }
    _setBits(word, value, mask) {
        if (value) this.data[word] |= mask;
        else this.data[word] &= 0xFFFF ^ mask;
    }
    /**
     * Returns the number of bits of space actually in use by this `BitSet` to represent bit values. The maximum element
     * in the set is the size - 1st element.
     */ get size() {
        return this.data.byteLength * 8;
    }
    /**
     * Returns a new byte array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let bytes = s.toByteArray();`
     * then `bytes.length === (s.length()+7)/8` and `s.get(n) === ((bytes[n/8] & (1<<(n%8))) != 0)` for all
     * `n < 8 * bytes.length`.
     */ // toByteArray(): Int8Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Returns a new integer array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let integers = s.toIntegerArray();`
     * then `integers.length === (s.length()+31)/32` and `s.get(n) === ((integers[n/32] & (1<<(n%32))) != 0)` for all
     * `n < 32 * integers.length`.
     */ // toIntegerArray(): Int32Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    hashCode() {
        return $iXFjm.MurmurHash.hashCode(this.data, 22);
    }
    /**
     * Compares this object against the specified object. The result is `true` if and only if the argument is not
     * `undefined` and is a `Bitset` object that has exactly the same set of bits set to `true` as this bit set. That
     * is, for every nonnegative index `k`,
     *
     * ```
     * ((BitSet)obj).get(k) == this.get(k)
     * ```
     *
     * must be true. The current sizes of the two bit sets are not compared.
     */ equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $415892d73e8925a4$var$BitSet)) return false;
        const len = this.length();
        if (len !== obj.length()) return false;
        if (len === 0) return true;
        let bound = $415892d73e8925a4$var$getIndex(len - 1);
        for(let i = 0; i <= bound; i++){
            if (this.data[i] !== obj.data[i]) return false;
        }
        return true;
    }
    /**
     * Returns a string representation of this bit set. For every index for which this `BitSet` contains a bit in the
     * set state, the decimal representation of that index is included in the result. Such indices are listed in order
     * from lowest to highest, separated by ", " (a comma and a space) and surrounded by braces, resulting in the usual
     * mathematical notation for a set of integers.
     *
     * Example:
     *
     *     BitSet drPepper = new BitSet();
     *
     * Now `drPepper.toString()` returns `"{}"`.
     *
     *     drPepper.set(2);
     *
     * Now `drPepper.toString()` returns `"{2}"`.
     *
     *     drPepper.set(4);
     *     drPepper.set(10);
     *
     * Now `drPepper.toString()` returns `"{2, 4, 10}"`.
     */ toString() {
        let result = "{";
        let first = true;
        for(let i = this.nextSetBit(0); i >= 0; i = this.nextSetBit(i + 1)){
            if (first) first = false;
            else result += ", ";
            result += i;
        }
        result += "}";
        return result;
    }
    // static valueOf(bytes: Int8Array): BitSet;
    // static valueOf(buffer: ArrayBuffer): BitSet;
    // static valueOf(integers: Int32Array): BitSet;
    // static valueOf(data: Int8Array | Int32Array | ArrayBuffer): BitSet {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Performs a logical **XOR** of this bit set with the bit set argument. This bit set is modified so that a bit in
     * it has the value `true` if and only if one of the following statements holds:
     *
     * * The bit initially has the value `true`, and the corresponding bit in the argument has the value `false`.
     * * The bit initially has the value `false`, and the corresponding bit in the argument has the value `true`.
     */ xor(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Xor those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] ^ other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord + 1);
    }
    clone() {
        return new $415892d73e8925a4$var$BitSet(this);
    }
    [Symbol.iterator]() {
        return new $415892d73e8925a4$var$BitSetIterator(this.data);
    }
    // Overrides formatting for nodejs assert etc.
    [$9kAQu.inspect.custom]() {
        return "BitSet " + this.toString();
    }
}
module.exports.BitSet = $415892d73e8925a4$var$BitSet;
class $415892d73e8925a4$var$BitSetIterator {
    constructor(data){
        this.data = data;
        this.index = 0;
        this.mask = 0xFFFF;
    }
    next() {
        while(this.index < this.data.length){
            const bits = this.data[this.index] & this.mask;
            if (bits !== 0) {
                const bitNumber = $415892d73e8925a4$var$unIndex(this.index) + $415892d73e8925a4$var$findLSBSet(bits);
                this.mask = $415892d73e8925a4$var$bitsFor(bitNumber + 1, 15);
                return {
                    done: false,
                    value: bitNumber
                };
            }
            this.index++;
            this.mask = 0xFFFF;
        }
        return {
            done: true,
            value: -1
        };
    }
    [Symbol.iterator]() {
        return this;
    }
}

});


parcelRegister("yhTtv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $06710e6ae1da410a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFASerializer = void 0;

var $kr9A1 = parcelRequire("kr9A1");

var $d6D31 = parcelRequire("d6D31");

var $8DTT0 = parcelRequire("8DTT0");

var $kBaAZ = parcelRequire("kBaAZ");

var $3n2FE = parcelRequire("3n2FE");
/** A DFA walker that knows how to dump them to serialized strings. */ class $06710e6ae1da410a$var$DFASerializer {
    constructor(dfa, vocabulary, ruleNames, atn){
        if (vocabulary instanceof $kBaAZ.Recognizer) {
            ruleNames = vocabulary.ruleNames;
            atn = vocabulary.atn;
            vocabulary = vocabulary.vocabulary;
        } else if (!vocabulary) vocabulary = $3n2FE.VocabularyImpl.EMPTY_VOCABULARY;
        this.dfa = dfa;
        this.vocabulary = vocabulary;
        this.ruleNames = ruleNames;
        this.atn = atn;
    }
    toString() {
        if (!this.dfa.s0) return "";
        let buf = "";
        if (this.dfa.states) {
            let states = new Array(...this.dfa.states.toArray());
            states.sort((o1, o2)=>o1.stateNumber - o2.stateNumber);
            for (let s of states){
                let edges = s.getEdgeMap();
                let edgeKeys = [
                    ...edges.keys()
                ].sort((a, b)=>a - b);
                let contextEdges = s.getContextEdgeMap();
                let contextEdgeKeys = [
                    ...contextEdges.keys()
                ].sort((a, b)=>a - b);
                for (let entry of edgeKeys){
                    let value = edges.get(entry);
                    if ((value == null || value === $kr9A1.ATNSimulator.ERROR) && !s.isContextSymbol(entry)) continue;
                    let contextSymbol = false;
                    buf += this.getStateString(s) + "-" + this.getEdgeLabel(entry) + "->";
                    if (s.isContextSymbol(entry)) {
                        buf += "!";
                        contextSymbol = true;
                    }
                    let t = value;
                    if (t && t.stateNumber !== $kr9A1.ATNSimulator.ERROR.stateNumber) buf += this.getStateString(t) + "\n";
                    else if (contextSymbol) buf += "ctx\n";
                }
                if (s.isContextSensitive) for (let entry of contextEdgeKeys)buf += this.getStateString(s) + "-" + this.getContextLabel(entry) + "->" + this.getStateString(contextEdges.get(entry)) + "\n";
            }
        }
        let output = buf;
        if (output.length === 0) return "";
        //return Utils.sortLinesInString(output);
        return output;
    }
    getContextLabel(i) {
        if (i === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) return "ctx:EMPTY_FULL";
        else if (i === $8DTT0.PredictionContext.EMPTY_LOCAL_STATE_KEY) return "ctx:EMPTY_LOCAL";
        if (this.atn && i > 0 && i <= this.atn.states.length) {
            let state = this.atn.states[i];
            let ruleIndex = state.ruleIndex;
            if (this.ruleNames && ruleIndex >= 0 && ruleIndex < this.ruleNames.length) return "ctx:" + String(i) + "(" + this.ruleNames[ruleIndex] + ")";
        }
        return "ctx:" + String(i);
    }
    getEdgeLabel(i) {
        return this.vocabulary.getDisplayName(i);
    }
    getStateString(s) {
        if (s === $kr9A1.ATNSimulator.ERROR) return "ERROR";
        let n = s.stateNumber;
        let stateStr = "s" + n;
        if (s.isAcceptState) {
            if (s.predicates) stateStr = ":s" + n + "=>" + s.predicates;
            else stateStr = ":s" + n + "=>" + s.prediction;
        }
        if (s.isContextSensitive) {
            stateStr += "*";
            for (let config of s.configs)if (config.reachesIntoOuterContext) {
                stateStr += "*";
                break;
            }
        }
        return stateStr;
    }
}
$06710e6ae1da410a$var$__decorate([
    $d6D31.NotNull
], $06710e6ae1da410a$var$DFASerializer.prototype, "dfa", void 0);
$06710e6ae1da410a$var$__decorate([
    $d6D31.NotNull
], $06710e6ae1da410a$var$DFASerializer.prototype, "vocabulary", void 0);
$06710e6ae1da410a$var$__decorate([
    $d6D31.Override
], $06710e6ae1da410a$var$DFASerializer.prototype, "toString", null);
module.exports.DFASerializer = $06710e6ae1da410a$var$DFASerializer;

});
parcelRegister("kr9A1", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ee0dc2a763a7368a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ee0dc2a763a7368a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNSimulator = void 0;

var $c1ClW = parcelRequire("c1ClW");

var $2jevZ = parcelRequire("2jevZ");

var $d6D31 = parcelRequire("d6D31");

var $8DTT0 = parcelRequire("8DTT0");
let $ee0dc2a763a7368a$var$ATNSimulator = class ATNSimulator {
    constructor(atn){
        this.atn = atn;
    }
    static get ERROR() {
        if (!ATNSimulator._ERROR) {
            ATNSimulator._ERROR = new $2jevZ.DFAState(new $c1ClW.ATNConfigSet());
            ATNSimulator._ERROR.stateNumber = $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
        }
        return ATNSimulator._ERROR;
    }
    /**
     * Clear the DFA cache used by the current instance. Since the DFA cache may
     * be shared by multiple ATN simulators, this method may affect the
     * performance (but not accuracy) of other parsers which are being used
     * concurrently.
     *
     * @ if the current instance does not
     * support clearing the DFA.
     *
     * @since 4.3
     */ clearDFA() {
        this.atn.clearDFA();
    }
};
$ee0dc2a763a7368a$var$__decorate([
    $d6D31.NotNull
], $ee0dc2a763a7368a$var$ATNSimulator.prototype, "atn", void 0);
$ee0dc2a763a7368a$var$__decorate([
    $d6D31.NotNull
], $ee0dc2a763a7368a$var$ATNSimulator, "ERROR", null);
$ee0dc2a763a7368a$var$ATNSimulator = $ee0dc2a763a7368a$var$__decorate([
    $ee0dc2a763a7368a$var$__param(0, $d6D31.NotNull)
], $ee0dc2a763a7368a$var$ATNSimulator);
module.exports.ATNSimulator = $ee0dc2a763a7368a$var$ATNSimulator;
(function(ATNSimulator) {
    const RULE_VARIANT_DELIMITER = "$";
    const RULE_LF_VARIANT_MARKER = "$lf$";
    const RULE_NOLF_VARIANT_MARKER = "$nolf$";
})($ee0dc2a763a7368a$var$ATNSimulator = module.exports.ATNSimulator || (module.exports.ATNSimulator = {}));
module.exports.ATNSimulator = $ee0dc2a763a7368a$var$ATNSimulator;

});
parcelRegister("2jevZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1ae89d7ac78d8bff$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1ae89d7ac78d8bff$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFAState = void 0;

var $bcnvE = parcelRequire("bcnvE");

var $5BPMp = parcelRequire("5BPMp");

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");

var $8DTT0 = parcelRequire("8DTT0");

var $bbHFU = parcelRequire("bbHFU");
/** A DFA state represents a set of possible ATN configurations.
 *  As Aho, Sethi, Ullman p. 117 says "The DFA uses its state
 *  to keep track of all possible states the ATN can be in after
 *  reading each input symbol.  That is to say, after reading
 *  input a1a2..an, the DFA is in a state that represents the
 *  subset T of the states of the ATN that are reachable from the
 *  ATN's start state along some path labeled a1a2..an."
 *  In conventional NFA&rarr;DFA conversion, therefore, the subset T
 *  would be a bitset representing the set of states the
 *  ATN could be in.  We need to track the alt predicted by each
 *  state as well, however.  More importantly, we need to maintain
 *  a stack of states, tracking the closure operations as they
 *  jump from rule to rule, emulating rule invocations (method calls).
 *  I have to add a stack to simulate the proper lookahead sequences for
 *  the underlying LL grammar from which the ATN was derived.
 *
 *  I use a set of ATNConfig objects not simple states.  An ATNConfig
 *  is both a state (ala normal conversion) and a RuleContext describing
 *  the chain of rules (if any) followed to arrive at that state.
 *
 *  A DFA state may have multiple references to a particular state,
 *  but with different ATN contexts (with same or different alts)
 *  meaning that state was reached via a different set of rule invocations.
 */ class $1ae89d7ac78d8bff$var$DFAState {
    /**
     * Constructs a new `DFAState`.
     *
     * @param configs The set of ATN configurations defining this state.
     */ constructor(configs){
        this.stateNumber = -1;
        this.configs = configs;
        this.edges = new Map();
        this.contextEdges = new Map();
    }
    get isContextSensitive() {
        return !!this.contextSymbols;
    }
    isContextSymbol(symbol) {
        if (!this.isContextSensitive) return false;
        return this.contextSymbols.get(symbol);
    }
    setContextSymbol(symbol) {
        $bbHFU(this.isContextSensitive);
        this.contextSymbols.set(symbol);
    }
    setContextSensitive(atn) {
        $bbHFU(!this.configs.isOutermostConfigSet);
        if (this.isContextSensitive) return;
        if (!this.contextSymbols) this.contextSymbols = new $5BPMp.BitSet();
    }
    get acceptStateInfo() {
        return this._acceptStateInfo;
    }
    set acceptStateInfo(acceptStateInfo) {
        this._acceptStateInfo = acceptStateInfo;
    }
    get isAcceptState() {
        return !!this._acceptStateInfo;
    }
    get prediction() {
        if (!this._acceptStateInfo) return $bcnvE.ATN.INVALID_ALT_NUMBER;
        return this._acceptStateInfo.prediction;
    }
    get lexerActionExecutor() {
        if (!this._acceptStateInfo) return undefined;
        return this._acceptStateInfo.lexerActionExecutor;
    }
    getTarget(symbol) {
        return this.edges.get(symbol);
    }
    setTarget(symbol, target) {
        this.edges.set(symbol, target);
    }
    getEdgeMap() {
        return this.edges;
    }
    getContextTarget(invokingState) {
        if (invokingState === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        return this.contextEdges.get(invokingState);
    }
    setContextTarget(invokingState, target) {
        if (!this.isContextSensitive) throw new Error("The state is not context sensitive.");
        if (invokingState === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        this.contextEdges.set(invokingState, target);
    }
    getContextEdgeMap() {
        let map = new Map(this.contextEdges);
        let existing = map.get(-1);
        if (existing !== undefined) {
            if (map.size === 1) {
                let result = new Map();
                result.set($8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
                return result;
            } else {
                map.delete(-1);
                map.set($8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
            }
        }
        return map;
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize(7);
        hash = $iXFjm.MurmurHash.update(hash, this.configs.hashCode());
        hash = $iXFjm.MurmurHash.finish(hash, 1);
        return hash;
    }
    /**
     * Two {@link DFAState} instances are equal if their ATN configuration sets
     * are the same. This method is used to see if a state already exists.
     *
     * Because the number of alternatives and number of ATN configurations are
     * finite, there is a finite number of DFA states that can be processed.
     * This is necessary to show that the algorithm terminates.
     *
     * Cannot test the DFA state numbers here because in
     * {@link ParserATNSimulator#addDFAState} we need to know if any other state
     * exists that has this exact set of ATN configurations. The
     * {@link #stateNumber} is irrelevant.
     */ equals(o) {
        // compare set of ATN configurations in this set with other
        if (this === o) return true;
        if (!(o instanceof $1ae89d7ac78d8bff$var$DFAState)) return false;
        let other = o;
        let sameSet = this.configs.equals(other.configs);
        //		System.out.println("DFAState.equals: "+configs+(sameSet?"==":"!=")+other.configs);
        return sameSet;
    }
    toString() {
        let buf = "";
        buf += this.stateNumber + ":" + this.configs;
        if (this.isAcceptState) {
            buf += "=>";
            if (this.predicates) buf += this.predicates;
            else buf += this.prediction;
        }
        return buf.toString();
    }
}
$1ae89d7ac78d8bff$var$__decorate([
    $d6D31.NotNull
], $1ae89d7ac78d8bff$var$DFAState.prototype, "configs", void 0);
$1ae89d7ac78d8bff$var$__decorate([
    $d6D31.NotNull
], $1ae89d7ac78d8bff$var$DFAState.prototype, "edges", void 0);
$1ae89d7ac78d8bff$var$__decorate([
    $d6D31.NotNull
], $1ae89d7ac78d8bff$var$DFAState.prototype, "contextEdges", void 0);
$1ae89d7ac78d8bff$var$__decorate([
    $d6D31.Override
], $1ae89d7ac78d8bff$var$DFAState.prototype, "hashCode", null);
$1ae89d7ac78d8bff$var$__decorate([
    $d6D31.Override
], $1ae89d7ac78d8bff$var$DFAState.prototype, "equals", null);
$1ae89d7ac78d8bff$var$__decorate([
    $d6D31.Override
], $1ae89d7ac78d8bff$var$DFAState.prototype, "toString", null);
module.exports.DFAState = $1ae89d7ac78d8bff$var$DFAState;
(function(DFAState) {
    /** Map a predicate to a predicted alternative. */ let PredPrediction = class PredPrediction {
        constructor(pred, alt){
            this.alt = alt;
            this.pred = pred;
        }
        toString() {
            return "(" + this.pred + ", " + this.alt + ")";
        }
    };
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.NotNull
    ], PredPrediction.prototype, "pred", void 0);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.Override
    ], PredPrediction.prototype, "toString", null);
    PredPrediction = $1ae89d7ac78d8bff$var$__decorate([
        $1ae89d7ac78d8bff$var$__param(0, $d6D31.NotNull)
    ], PredPrediction);
    DFAState.PredPrediction = PredPrediction;
})($1ae89d7ac78d8bff$var$DFAState = module.exports.DFAState || (module.exports.DFAState = {}));

});


parcelRegister("kBaAZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $efef7b6bec20bc2a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $efef7b6bec20bc2a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Recognizer = void 0;

var $e5mHr = parcelRequire("e5mHr");

var $65iNZ = parcelRequire("65iNZ");

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");

var $2IEP9 = parcelRequire("2IEP9");
class $efef7b6bec20bc2a$var$Recognizer {
    constructor(){
        this._listeners = [
            $e5mHr.ConsoleErrorListener.INSTANCE
        ];
        this._stateNumber = -1;
    }
    /**
     * Get a map from token names to token types.
     *
     * Used for XPath and tree pattern compilation.
     */ getTokenTypeMap() {
        let vocabulary = this.vocabulary;
        let result = $efef7b6bec20bc2a$var$Recognizer.tokenTypeMapCache.get(vocabulary);
        if (result == null) {
            let intermediateResult = new Map();
            for(let i = 0; i <= this.atn.maxTokenType; i++){
                let literalName = vocabulary.getLiteralName(i);
                if (literalName != null) intermediateResult.set(literalName, i);
                let symbolicName = vocabulary.getSymbolicName(i);
                if (symbolicName != null) intermediateResult.set(symbolicName, i);
            }
            intermediateResult.set("EOF", $2DVsz.Token.EOF);
            result = intermediateResult;
            $efef7b6bec20bc2a$var$Recognizer.tokenTypeMapCache.set(vocabulary, result);
        }
        return result;
    }
    /**
     * Get a map from rule names to rule indexes.
     *
     * Used for XPath and tree pattern compilation.
     */ getRuleIndexMap() {
        let ruleNames = this.ruleNames;
        if (ruleNames == null) throw new Error("The current recognizer does not provide a list of rule names.");
        let result = $efef7b6bec20bc2a$var$Recognizer.ruleIndexMapCache.get(ruleNames);
        if (result == null) {
            result = $2IEP9.toMap(ruleNames);
            $efef7b6bec20bc2a$var$Recognizer.ruleIndexMapCache.set(ruleNames, result);
        }
        return result;
    }
    getTokenType(tokenName) {
        let ttype = this.getTokenTypeMap().get(tokenName);
        if (ttype != null) return ttype;
        return $2DVsz.Token.INVALID_TYPE;
    }
    /**
     * If this recognizer was generated, it will have a serialized ATN
     * representation of the grammar.
     *
     * For interpreters, we don't know their serialized ATN despite having
     * created the interpreter from it.
     */ get serializedATN() {
        throw new Error("there is no serialized ATN");
    }
    /**
     * Get the {@link ATN} used by the recognizer for prediction.
     *
     * @returns The {@link ATN} used by the recognizer for prediction.
     */ get atn() {
        return this._interp.atn;
    }
    /**
     * Get the ATN interpreter used by the recognizer for prediction.
     *
     * @returns The ATN interpreter used by the recognizer for prediction.
     */ get interpreter() {
        return this._interp;
    }
    /**
     * Set the ATN interpreter used by the recognizer for prediction.
     *
     * @param interpreter The ATN interpreter used by the recognizer for
     * prediction.
     */ set interpreter(interpreter) {
        this._interp = interpreter;
    }
    /** If profiling during the parse/lex, this will return DecisionInfo records
     *  for each decision in recognizer in a ParseInfo object.
     *
     * @since 4.3
     */ get parseInfo() {
        return Promise.resolve(undefined);
    }
    /** What is the error header, normally line/character position information? */ getErrorHeader(e) {
        let token = e.getOffendingToken();
        if (!token) return "";
        let line = token.line;
        let charPositionInLine = token.charPositionInLine;
        return "line " + line + ":" + charPositionInLine;
    }
    /**
     * @exception NullPointerException if `listener` is `undefined`.
     */ addErrorListener(listener) {
        if (!listener) throw new TypeError("listener must not be null");
        this._listeners.push(listener);
    }
    removeErrorListener(listener) {
        let position = this._listeners.indexOf(listener);
        if (position !== -1) this._listeners.splice(position, 1);
    }
    removeErrorListeners() {
        this._listeners.length = 0;
    }
    getErrorListeners() {
        return this._listeners.slice(0);
    }
    getErrorListenerDispatch() {
        return new $65iNZ.ProxyErrorListener(this.getErrorListeners());
    }
    // subclass needs to override these if there are sempreds or actions
    // that the ATN interp needs to execute
    sempred(_localctx, ruleIndex, actionIndex) {
        return true;
    }
    precpred(localctx, precedence) {
        return true;
    }
    action(_localctx, ruleIndex, actionIndex) {
    // intentionally empty
    }
    get state() {
        return this._stateNumber;
    }
    /** Indicate that the recognizer has changed internal state that is
     *  consistent with the ATN state passed in.  This way we always know
     *  where we are in the ATN as the parser goes along. The rule
     *  context objects form a stack that lets us see the stack of
     *  invoking rules. Combine this and we have complete ATN
     *  configuration information.
     */ set state(atnState) {
        //		System.err.println("setState "+atnState);
        this._stateNumber = atnState;
    //		if ( traceATNStates ) _ctx.trace(atnState);
    }
}
$efef7b6bec20bc2a$var$Recognizer.EOF = -1;
$efef7b6bec20bc2a$var$Recognizer.tokenTypeMapCache = new WeakMap();
$efef7b6bec20bc2a$var$Recognizer.ruleIndexMapCache = new WeakMap();
$efef7b6bec20bc2a$var$__decorate([
    $d6D31.SuppressWarnings("serial"),
    $d6D31.NotNull
], $efef7b6bec20bc2a$var$Recognizer.prototype, "_listeners", void 0);
$efef7b6bec20bc2a$var$__decorate([
    $d6D31.NotNull
], $efef7b6bec20bc2a$var$Recognizer.prototype, "getTokenTypeMap", null);
$efef7b6bec20bc2a$var$__decorate([
    $d6D31.NotNull
], $efef7b6bec20bc2a$var$Recognizer.prototype, "getRuleIndexMap", null);
$efef7b6bec20bc2a$var$__decorate([
    $d6D31.NotNull
], $efef7b6bec20bc2a$var$Recognizer.prototype, "serializedATN", null);
$efef7b6bec20bc2a$var$__decorate([
    $d6D31.NotNull
], $efef7b6bec20bc2a$var$Recognizer.prototype, "atn", null);
$efef7b6bec20bc2a$var$__decorate([
    $d6D31.NotNull,
    $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
], $efef7b6bec20bc2a$var$Recognizer.prototype, "interpreter", null);
$efef7b6bec20bc2a$var$__decorate([
    $d6D31.NotNull,
    $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
], $efef7b6bec20bc2a$var$Recognizer.prototype, "getErrorHeader", null);
$efef7b6bec20bc2a$var$__decorate([
    $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
], $efef7b6bec20bc2a$var$Recognizer.prototype, "addErrorListener", null);
$efef7b6bec20bc2a$var$__decorate([
    $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
], $efef7b6bec20bc2a$var$Recognizer.prototype, "removeErrorListener", null);
$efef7b6bec20bc2a$var$__decorate([
    $d6D31.NotNull
], $efef7b6bec20bc2a$var$Recognizer.prototype, "getErrorListeners", null);
module.exports.Recognizer = $efef7b6bec20bc2a$var$Recognizer;

});
parcelRegister("e5mHr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConsoleErrorListener = void 0;
/**
 *
 * @author Sam Harwell
 */ class $a413240156cc2e50$var$ConsoleErrorListener {
    /**
     * {@inheritDoc}
     *
     * This implementation prints messages to {@link System#err} containing the
     * values of `line`, `charPositionInLine`, and `msg` using
     * the following format.
     *
     * <pre>
     * line *line*:*charPositionInLine* *msg*
     * </pre>
     */ syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        console.error(`line ${line}:${charPositionInLine} ${msg}`);
    }
}
module.exports.ConsoleErrorListener = $a413240156cc2e50$var$ConsoleErrorListener;
/**
 * Provides a default instance of {@link ConsoleErrorListener}.
 */ $a413240156cc2e50$var$ConsoleErrorListener.INSTANCE = new $a413240156cc2e50$var$ConsoleErrorListener();

});

parcelRegister("65iNZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $46e1cc07c7f5b3d6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $46e1cc07c7f5b3d6$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyErrorListener = void 0;

var $d6D31 = parcelRequire("d6D31");
/**
 * This implementation of {@link ANTLRErrorListener} dispatches all calls to a
 * collection of delegate listeners. This reduces the effort required to support multiple
 * listeners.
 *
 * @author Sam Harwell
 */ class $46e1cc07c7f5b3d6$var$ProxyErrorListener {
    constructor(delegates){
        this.delegates = delegates;
        if (!delegates) throw new Error("Invalid delegates");
    }
    getDelegates() {
        return this.delegates;
    }
    syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        this.delegates.forEach((listener)=>{
            if (listener.syntaxError) listener.syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e);
        });
    }
}
$46e1cc07c7f5b3d6$var$__decorate([
    $d6D31.Override,
    $46e1cc07c7f5b3d6$var$__param(0, $d6D31.NotNull),
    $46e1cc07c7f5b3d6$var$__param(4, $d6D31.NotNull)
], $46e1cc07c7f5b3d6$var$ProxyErrorListener.prototype, "syntaxError", null);
module.exports.ProxyErrorListener = $46e1cc07c7f5b3d6$var$ProxyErrorListener;

});


parcelRegister("3n2FE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $27459777e7d4e735$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VocabularyImpl = void 0;

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");
/**
 * This class provides a default implementation of the {@link Vocabulary}
 * interface.
 *
 * @author Sam Harwell
 */ class $27459777e7d4e735$var$VocabularyImpl {
    /**
     * Constructs a new instance of {@link VocabularyImpl} from the specified
     * literal, symbolic, and display token names.
     *
     * @param literalNames The literal names assigned to tokens, or an empty array
     * if no literal names are assigned.
     * @param symbolicNames The symbolic names assigned to tokens, or
     * an empty array if no symbolic names are assigned.
     * @param displayNames The display names assigned to tokens, or an empty array
     * to use the values in `literalNames` and `symbolicNames` as
     * the source of display names, as described in
     * {@link #getDisplayName(int)}.
     *
     * @see #getLiteralName(int)
     * @see #getSymbolicName(int)
     * @see #getDisplayName(int)
     */ constructor(literalNames, symbolicNames, displayNames){
        this.literalNames = literalNames;
        this.symbolicNames = symbolicNames;
        this.displayNames = displayNames;
        // See note here on -1 part: https://github.com/antlr/antlr4/pull/1146
        this._maxTokenType = Math.max(this.displayNames.length, Math.max(this.literalNames.length, this.symbolicNames.length)) - 1;
    }
    get maxTokenType() {
        return this._maxTokenType;
    }
    getLiteralName(tokenType) {
        if (tokenType >= 0 && tokenType < this.literalNames.length) return this.literalNames[tokenType];
        return undefined;
    }
    getSymbolicName(tokenType) {
        if (tokenType >= 0 && tokenType < this.symbolicNames.length) return this.symbolicNames[tokenType];
        if (tokenType === $2DVsz.Token.EOF) return "EOF";
        return undefined;
    }
    getDisplayName(tokenType) {
        if (tokenType >= 0 && tokenType < this.displayNames.length) {
            let displayName = this.displayNames[tokenType];
            if (displayName) return displayName;
        }
        let literalName = this.getLiteralName(tokenType);
        if (literalName) return literalName;
        let symbolicName = this.getSymbolicName(tokenType);
        if (symbolicName) return symbolicName;
        return String(tokenType);
    }
}
/**
 * Gets an empty {@link Vocabulary} instance.
 *
 * No literal or symbol names are assigned to token types, so
 * {@link #getDisplayName(int)} returns the numeric value for all tokens
 * except {@link Token#EOF}.
 */ $27459777e7d4e735$var$VocabularyImpl.EMPTY_VOCABULARY = new $27459777e7d4e735$var$VocabularyImpl([], [], []);
$27459777e7d4e735$var$__decorate([
    $d6D31.NotNull
], $27459777e7d4e735$var$VocabularyImpl.prototype, "literalNames", void 0);
$27459777e7d4e735$var$__decorate([
    $d6D31.NotNull
], $27459777e7d4e735$var$VocabularyImpl.prototype, "symbolicNames", void 0);
$27459777e7d4e735$var$__decorate([
    $d6D31.NotNull
], $27459777e7d4e735$var$VocabularyImpl.prototype, "displayNames", void 0);
$27459777e7d4e735$var$__decorate([
    $d6D31.Override
], $27459777e7d4e735$var$VocabularyImpl.prototype, "maxTokenType", null);
$27459777e7d4e735$var$__decorate([
    $d6D31.Override
], $27459777e7d4e735$var$VocabularyImpl.prototype, "getLiteralName", null);
$27459777e7d4e735$var$__decorate([
    $d6D31.Override
], $27459777e7d4e735$var$VocabularyImpl.prototype, "getSymbolicName", null);
$27459777e7d4e735$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $27459777e7d4e735$var$VocabularyImpl.prototype, "getDisplayName", null);
$27459777e7d4e735$var$__decorate([
    $d6D31.NotNull
], $27459777e7d4e735$var$VocabularyImpl, "EMPTY_VOCABULARY", void 0);
module.exports.VocabularyImpl = $27459777e7d4e735$var$VocabularyImpl;

});


parcelRegister("aeRGo", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7744da7bed4bb192$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7744da7bed4bb192$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerDFASerializer = void 0;

var $yhTtv = parcelRequire("yhTtv");

var $d6D31 = parcelRequire("d6D31");

var $3n2FE = parcelRequire("3n2FE");
let $7744da7bed4bb192$var$LexerDFASerializer = class LexerDFASerializer extends $yhTtv.DFASerializer {
    constructor(dfa){
        super(dfa, $3n2FE.VocabularyImpl.EMPTY_VOCABULARY);
    }
    getEdgeLabel(i) {
        return "'" + String.fromCodePoint(i) + "'";
    }
};
$7744da7bed4bb192$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $7744da7bed4bb192$var$LexerDFASerializer.prototype, "getEdgeLabel", null);
$7744da7bed4bb192$var$LexerDFASerializer = $7744da7bed4bb192$var$__decorate([
    $7744da7bed4bb192$var$__param(0, $d6D31.NotNull)
], $7744da7bed4bb192$var$LexerDFASerializer);
module.exports.LexerDFASerializer = $7744da7bed4bb192$var$LexerDFASerializer;

});

parcelRegister("f9raX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b07cc6cfd56668a7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopEntryState = void 0;

var $1bs3X = parcelRequire("1bs3X");

var $5BPMp = parcelRequire("5BPMp");

var $dPYn6 = parcelRequire("dPYn6");

var $d6D31 = parcelRequire("d6D31");
class $b07cc6cfd56668a7$var$StarLoopEntryState extends $dPYn6.DecisionState {
    constructor(){
        super(...arguments);
        /**
         * Indicates whether this state can benefit from a precedence DFA during SLL
         * decision making.
         *
         * This is a computed property that is calculated during ATN deserialization
         * and stored for use in {@link ParserATNSimulator} and
         * {@link ParserInterpreter}.
         *
         * @see `DFA.isPrecedenceDfa`
         */ this.precedenceRuleDecision = false;
        /**
         * For precedence decisions, this set marks states *S* which have all
         * of the following characteristics:
         *
         * * One or more invocation sites of the current rule returns to
         *   *S*.
         * * The closure from *S* includes the current decision without
         *   passing through any rule invocations or stepping out of the current
         *   rule.
         *
         * This field is not used when {@link #precedenceRuleDecision} is
         * `false`.
         */ this.precedenceLoopbackStates = new $5BPMp.BitSet();
    }
    get stateType() {
        return $1bs3X.ATNStateType.STAR_LOOP_ENTRY;
    }
}
$b07cc6cfd56668a7$var$__decorate([
    $d6D31.Override
], $b07cc6cfd56668a7$var$StarLoopEntryState.prototype, "stateType", null);
module.exports.StarLoopEntryState = $b07cc6cfd56668a7$var$StarLoopEntryState;

});


parcelRegister("l4Nh1", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f580316b3d8851ef$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidState = void 0;

var $1bs3X = parcelRequire("1bs3X");

var $4yiuQ = parcelRequire("4yiuQ");

var $d6D31 = parcelRequire("d6D31");
/**
 *
 * @author Sam Harwell
 */ class $f580316b3d8851ef$var$InvalidState extends $4yiuQ.BasicState {
    get stateType() {
        return $1bs3X.ATNStateType.INVALID_TYPE;
    }
}
$f580316b3d8851ef$var$__decorate([
    $d6D31.Override
], $f580316b3d8851ef$var$InvalidState.prototype, "stateType", null);
module.exports.InvalidState = $f580316b3d8851ef$var$InvalidState;

});
parcelRegister("4yiuQ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3508af691e74fe3f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicState = void 0;

var $7j0Pc = parcelRequire("7j0Pc");

var $1bs3X = parcelRequire("1bs3X");

var $d6D31 = parcelRequire("d6D31");
/**
 *
 * @author Sam Harwell
 */ class $3508af691e74fe3f$var$BasicState extends $7j0Pc.ATNState {
    get stateType() {
        return $1bs3X.ATNStateType.BASIC;
    }
}
$3508af691e74fe3f$var$__decorate([
    $d6D31.Override
], $3508af691e74fe3f$var$BasicState.prototype, "stateType", null);
module.exports.BasicState = $3508af691e74fe3f$var$BasicState;

});


parcelRegister("iiE1V", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d528f592a4fe7f4e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d528f592a4fe7f4e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LL1Analyzer = void 0;

var $fMVaR = parcelRequire("fMVaR");

var $7Veax = parcelRequire("7Veax");

var $gcX0f = parcelRequire("gcX0f");

var $5BPMp = parcelRequire("5BPMp");

var $hGRod = parcelRequire("hGRod");

var $d6D31 = parcelRequire("d6D31");

var $FLEKS = parcelRequire("FLEKS");

var $a4Flx = parcelRequire("a4Flx");

var $8DTT0 = parcelRequire("8DTT0");

var $4kGBm = parcelRequire("4kGBm");

var $aybFP = parcelRequire("aybFP");

var $2DVsz = parcelRequire("2DVsz");

var $aPmi9 = parcelRequire("aPmi9");
let $d528f592a4fe7f4e$var$LL1Analyzer = class LL1Analyzer {
    constructor(atn){
        this.atn = atn;
    }
    /**
     * Calculates the SLL(1) expected lookahead set for each outgoing transition
     * of an {@link ATNState}. The returned array has one element for each
     * outgoing transition in `s`. If the closure from transition
     * *i* leads to a semantic predicate before matching a symbol, the
     * element at index *i* of the result will be `undefined`.
     *
     * @param s the ATN state
     * @returns the expected symbols for each outgoing transition of `s`.
     */ getDecisionLookahead(s) {
        //		System.out.println("LOOK("+s.stateNumber+")");
        if (s == null) return undefined;
        let look = new Array(s.numberOfTransitions);
        for(let alt = 0; alt < s.numberOfTransitions; alt++){
            let current = new $hGRod.IntervalSet();
            look[alt] = current;
            let lookBusy = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
            let seeThruPreds = false; // fail to get lookahead upon pred
            this._LOOK(s.transition(alt).target, undefined, $8DTT0.PredictionContext.EMPTY_LOCAL, current, lookBusy, new $5BPMp.BitSet(), seeThruPreds, false);
            // Wipe out lookahead for this alternative if we found nothing
            // or we had a predicate when we !seeThruPreds
            if (current.size === 0 || current.contains(LL1Analyzer.HIT_PRED)) {
                current = undefined;
                look[alt] = current;
            }
        }
        return look;
    }
    LOOK(s, ctx, stopState) {
        if (stopState === undefined) {
            if (s.atn == null) throw new Error("Illegal state");
            stopState = s.atn.ruleToStopState[s.ruleIndex];
        } else if (stopState === null) // This is an explicit request to pass undefined as the stopState to _LOOK. Used to distinguish an overload
        // from the method which simply omits the stopState parameter.
        stopState = undefined;
        let r = new $hGRod.IntervalSet();
        let seeThruPreds = true; // ignore preds; get all lookahead
        let addEOF = true;
        this._LOOK(s, stopState, ctx, r, new $7Veax.Array2DHashSet(), new $5BPMp.BitSet(), seeThruPreds, addEOF);
        return r;
    }
    /**
     * Compute set of tokens that can follow `s` in the ATN in the
     * specified `ctx`.
     * <p/>
     * If `ctx` is {@link PredictionContext#EMPTY_LOCAL} and
     * `stopState` or the end of the rule containing `s` is reached,
     * {@link Token#EPSILON} is added to the result set. If `ctx` is not
     * {@link PredictionContext#EMPTY_LOCAL} and `addEOF` is `true`
     * and `stopState` or the end of the outermost rule is reached,
     * {@link Token#EOF} is added to the result set.
     *
     * @param s the ATN state.
     * @param stopState the ATN state to stop at. This can be a
     * {@link BlockEndState} to detect epsilon paths through a closure.
     * @param ctx The outer context, or {@link PredictionContext#EMPTY_LOCAL} if
     * the outer context should not be used.
     * @param look The result lookahead set.
     * @param lookBusy A set used for preventing epsilon closures in the ATN
     * from causing a stack overflow. Outside code should pass
     * `new HashSet<ATNConfig>` for this argument.
     * @param calledRuleStack A set used for preventing left recursion in the
     * ATN from causing a stack overflow. Outside code should pass
     * `new BitSet()` for this argument.
     * @param seeThruPreds `true` to true semantic predicates as
     * implicitly `true` and "see through them", otherwise `false`
     * to treat semantic predicates as opaque and add {@link #HIT_PRED} to the
     * result if one is encountered.
     * @param addEOF Add {@link Token#EOF} to the result if the end of the
     * outermost context is reached. This parameter has no effect if `ctx`
     * is {@link PredictionContext#EMPTY_LOCAL}.
     */ _LOOK(s, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF) {
        //		System.out.println("_LOOK("+s.stateNumber+", ctx="+ctx);
        let c = $gcX0f.ATNConfig.create(s, 0, ctx);
        if (!lookBusy.add(c)) return;
        if (s === stopState) {
            if ($8DTT0.PredictionContext.isEmptyLocal(ctx)) {
                look.add($2DVsz.Token.EPSILON);
                return;
            } else if (ctx.isEmpty) {
                if (addEOF) look.add($2DVsz.Token.EOF);
                return;
            }
        }
        if (s instanceof $4kGBm.RuleStopState) {
            if (ctx.isEmpty && !$8DTT0.PredictionContext.isEmptyLocal(ctx)) {
                if (addEOF) look.add($2DVsz.Token.EOF);
                return;
            }
            let removed = calledRuleStack.get(s.ruleIndex);
            try {
                calledRuleStack.clear(s.ruleIndex);
                for(let i = 0; i < ctx.size; i++){
                    if (ctx.getReturnState(i) === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                    let returnState = this.atn.states[ctx.getReturnState(i)];
                    //					System.out.println("popping back to "+retState);
                    this._LOOK(returnState, stopState, ctx.getParent(i), look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                }
            } finally{
                if (removed) calledRuleStack.set(s.ruleIndex);
            }
        }
        let n = s.numberOfTransitions;
        for(let i = 0; i < n; i++){
            let t = s.transition(i);
            if (t instanceof $aybFP.RuleTransition) {
                if (calledRuleStack.get(t.ruleIndex)) continue;
                let newContext = ctx.getChild(t.followState.stateNumber);
                try {
                    calledRuleStack.set(t.ruleIndex);
                    this._LOOK(t.target, stopState, newContext, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                } finally{
                    calledRuleStack.clear(t.ruleIndex);
                }
            } else if (t instanceof $fMVaR.AbstractPredicateTransition) {
                if (seeThruPreds) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                else look.add(LL1Analyzer.HIT_PRED);
            } else if (t.isEpsilon) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
            else if (t instanceof $aPmi9.WildcardTransition) look.addAll($hGRod.IntervalSet.of($2DVsz.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
            else {
                //				System.out.println("adding "+ t);
                let set = t.label;
                if (set != null) {
                    if (t instanceof $FLEKS.NotSetTransition) set = set.complement($hGRod.IntervalSet.of($2DVsz.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                    look.addAll(set);
                }
            }
        }
    }
};
/** Special value added to the lookahead sets to indicate that we hit
 *  a predicate during analysis if `seeThruPreds==false`.
 */ $d528f592a4fe7f4e$var$LL1Analyzer.HIT_PRED = $2DVsz.Token.INVALID_TYPE;
$d528f592a4fe7f4e$var$__decorate([
    $d6D31.NotNull
], $d528f592a4fe7f4e$var$LL1Analyzer.prototype, "atn", void 0);
$d528f592a4fe7f4e$var$__decorate([
    $d6D31.NotNull,
    $d528f592a4fe7f4e$var$__param(0, $d6D31.NotNull),
    $d528f592a4fe7f4e$var$__param(1, $d6D31.NotNull)
], $d528f592a4fe7f4e$var$LL1Analyzer.prototype, "LOOK", null);
$d528f592a4fe7f4e$var$__decorate([
    $d528f592a4fe7f4e$var$__param(0, $d6D31.NotNull),
    $d528f592a4fe7f4e$var$__param(2, $d6D31.NotNull),
    $d528f592a4fe7f4e$var$__param(3, $d6D31.NotNull),
    $d528f592a4fe7f4e$var$__param(4, $d6D31.NotNull),
    $d528f592a4fe7f4e$var$__param(5, $d6D31.NotNull)
], $d528f592a4fe7f4e$var$LL1Analyzer.prototype, "_LOOK", null);
$d528f592a4fe7f4e$var$LL1Analyzer = $d528f592a4fe7f4e$var$__decorate([
    $d528f592a4fe7f4e$var$__param(0, $d6D31.NotNull)
], $d528f592a4fe7f4e$var$LL1Analyzer);
module.exports.LL1Analyzer = $d528f592a4fe7f4e$var$LL1Analyzer;

});
parcelRegister("FLEKS", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $07d8cc01972b24a7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $07d8cc01972b24a7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NotSetTransition = void 0;

var $d6D31 = parcelRequire("d6D31");

var $Np2R3 = parcelRequire("Np2R3");
let $07d8cc01972b24a7$var$NotSetTransition = class NotSetTransition extends $Np2R3.SetTransition {
    constructor(target, set){
        super(target, set);
    }
    get serializationType() {
        return 8 /* NOT_SET */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol && !super.matches(symbol, minVocabSymbol, maxVocabSymbol);
    }
    toString() {
        return "~" + super.toString();
    }
};
$07d8cc01972b24a7$var$__decorate([
    $d6D31.Override
], $07d8cc01972b24a7$var$NotSetTransition.prototype, "serializationType", null);
$07d8cc01972b24a7$var$__decorate([
    $d6D31.Override
], $07d8cc01972b24a7$var$NotSetTransition.prototype, "matches", null);
$07d8cc01972b24a7$var$__decorate([
    $d6D31.Override
], $07d8cc01972b24a7$var$NotSetTransition.prototype, "toString", null);
$07d8cc01972b24a7$var$NotSetTransition = $07d8cc01972b24a7$var$__decorate([
    $07d8cc01972b24a7$var$__param(0, $d6D31.NotNull),
    $07d8cc01972b24a7$var$__param(1, $d6D31.Nullable)
], $07d8cc01972b24a7$var$NotSetTransition);
module.exports.NotSetTransition = $07d8cc01972b24a7$var$NotSetTransition;

});
parcelRegister("Np2R3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $094801244c2d1a04$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $094801244c2d1a04$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetTransition = void 0;

var $hGRod = parcelRequire("hGRod");

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");

var $5tcOQ = parcelRequire("5tcOQ");
/** A transition containing a set of values. */ let $094801244c2d1a04$var$SetTransition = class SetTransition extends $5tcOQ.Transition {
    // TODO (sam): should we really allow undefined here?
    constructor(target, set){
        super(target);
        if (set == null) set = $hGRod.IntervalSet.of($2DVsz.Token.INVALID_TYPE);
        this.set = set;
    }
    get serializationType() {
        return 7 /* SET */ ;
    }
    get label() {
        return this.set;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this.set.contains(symbol);
    }
    toString() {
        return this.set.toString();
    }
};
$094801244c2d1a04$var$__decorate([
    $d6D31.NotNull
], $094801244c2d1a04$var$SetTransition.prototype, "set", void 0);
$094801244c2d1a04$var$__decorate([
    $d6D31.Override
], $094801244c2d1a04$var$SetTransition.prototype, "serializationType", null);
$094801244c2d1a04$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $094801244c2d1a04$var$SetTransition.prototype, "label", null);
$094801244c2d1a04$var$__decorate([
    $d6D31.Override
], $094801244c2d1a04$var$SetTransition.prototype, "matches", null);
$094801244c2d1a04$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $094801244c2d1a04$var$SetTransition.prototype, "toString", null);
$094801244c2d1a04$var$SetTransition = $094801244c2d1a04$var$__decorate([
    $094801244c2d1a04$var$__param(0, $d6D31.NotNull),
    $094801244c2d1a04$var$__param(1, $d6D31.Nullable)
], $094801244c2d1a04$var$SetTransition);
module.exports.SetTransition = $094801244c2d1a04$var$SetTransition;

});


parcelRegister("4kGBm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $327a1377d5873c46$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStopState = void 0;

var $7j0Pc = parcelRequire("7j0Pc");

var $1bs3X = parcelRequire("1bs3X");

var $d6D31 = parcelRequire("d6D31");
/** The last node in the ATN for a rule, unless that rule is the start symbol.
 *  In that case, there is one transition to EOF. Later, we might encode
 *  references to all calls to this rule to compute FOLLOW sets for
 *  error handling.
 */ class $327a1377d5873c46$var$RuleStopState extends $7j0Pc.ATNState {
    get nonStopStateNumber() {
        return -1;
    }
    get stateType() {
        return $1bs3X.ATNStateType.RULE_STOP;
    }
}
$327a1377d5873c46$var$__decorate([
    $d6D31.Override
], $327a1377d5873c46$var$RuleStopState.prototype, "nonStopStateNumber", null);
$327a1377d5873c46$var$__decorate([
    $d6D31.Override
], $327a1377d5873c46$var$RuleStopState.prototype, "stateType", null);
module.exports.RuleStopState = $327a1377d5873c46$var$RuleStopState;

});

parcelRegister("aybFP", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7ae622834621fa3c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7ae622834621fa3c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleTransition = void 0;

var $d6D31 = parcelRequire("d6D31");

var $5tcOQ = parcelRequire("5tcOQ");
/** */ let $7ae622834621fa3c$var$RuleTransition = class RuleTransition extends $5tcOQ.Transition {
    constructor(ruleStart, ruleIndex, precedence, followState){
        super(ruleStart);
        this.tailCall = false;
        this.optimizedTailCall = false;
        this.ruleIndex = ruleIndex;
        this.precedence = precedence;
        this.followState = followState;
    }
    get serializationType() {
        return 3 /* RULE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
};
$7ae622834621fa3c$var$__decorate([
    $d6D31.NotNull
], $7ae622834621fa3c$var$RuleTransition.prototype, "followState", void 0);
$7ae622834621fa3c$var$__decorate([
    $d6D31.Override
], $7ae622834621fa3c$var$RuleTransition.prototype, "serializationType", null);
$7ae622834621fa3c$var$__decorate([
    $d6D31.Override
], $7ae622834621fa3c$var$RuleTransition.prototype, "isEpsilon", null);
$7ae622834621fa3c$var$__decorate([
    $d6D31.Override
], $7ae622834621fa3c$var$RuleTransition.prototype, "matches", null);
$7ae622834621fa3c$var$RuleTransition = $7ae622834621fa3c$var$__decorate([
    $7ae622834621fa3c$var$__param(0, $d6D31.NotNull),
    $7ae622834621fa3c$var$__param(3, $d6D31.NotNull)
], $7ae622834621fa3c$var$RuleTransition);
module.exports.RuleTransition = $7ae622834621fa3c$var$RuleTransition;

});

parcelRegister("aPmi9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7e1ff581bbf7382f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7e1ff581bbf7382f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WildcardTransition = void 0;

var $d6D31 = parcelRequire("d6D31");

var $5tcOQ = parcelRequire("5tcOQ");
let $7e1ff581bbf7382f$var$WildcardTransition = class WildcardTransition extends $5tcOQ.Transition {
    constructor(target){
        super(target);
    }
    get serializationType() {
        return 9 /* WILDCARD */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol;
    }
    toString() {
        return ".";
    }
};
$7e1ff581bbf7382f$var$__decorate([
    $d6D31.Override
], $7e1ff581bbf7382f$var$WildcardTransition.prototype, "serializationType", null);
$7e1ff581bbf7382f$var$__decorate([
    $d6D31.Override
], $7e1ff581bbf7382f$var$WildcardTransition.prototype, "matches", null);
$7e1ff581bbf7382f$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $7e1ff581bbf7382f$var$WildcardTransition.prototype, "toString", null);
$7e1ff581bbf7382f$var$WildcardTransition = $7e1ff581bbf7382f$var$__decorate([
    $7e1ff581bbf7382f$var$__param(0, $d6D31.NotNull)
], $7e1ff581bbf7382f$var$WildcardTransition);
module.exports.WildcardTransition = $7e1ff581bbf7382f$var$WildcardTransition;

});



parcelRegister("3AYVu", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $29e3fe8db7459e78$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $29e3fe8db7459e78$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerActionExecutor = void 0;

var $3sNxf = parcelRequire("3sNxf");

var $4LVXs = parcelRequire("4LVXs");

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * Represents an executor for a sequence of lexer actions which traversed during
 * the matching operation of a lexer rule (token).
 *
 * The executor tracks position information for position-dependent lexer actions
 * efficiently, ensuring that actions appearing only at the end of the rule do
 * not cause bloating of the {@link DFA} created for the lexer.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $29e3fe8db7459e78$var$LexerActionExecutor = class LexerActionExecutor {
    /**
     * Constructs an executor for a sequence of {@link LexerAction} actions.
     * @param lexerActions The lexer actions to execute.
     */ constructor(lexerActions){
        this._lexerActions = lexerActions;
        let hash = $iXFjm.MurmurHash.initialize();
        for (let lexerAction of lexerActions)hash = $iXFjm.MurmurHash.update(hash, lexerAction);
        this.cachedHashCode = $iXFjm.MurmurHash.finish(hash, lexerActions.length);
    }
    /**
     * Creates a {@link LexerActionExecutor} which executes the actions for
     * the input `lexerActionExecutor` followed by a specified
     * `lexerAction`.
     *
     * @param lexerActionExecutor The executor for actions already traversed by
     * the lexer while matching a token within a particular
     * {@link ATNConfig}. If this is `undefined`, the method behaves as though
     * it were an empty executor.
     * @param lexerAction The lexer action to execute after the actions
     * specified in `lexerActionExecutor`.
     *
     * @returns A {@link LexerActionExecutor} for executing the combine actions
     * of `lexerActionExecutor` and `lexerAction`.
     */ static append(lexerActionExecutor, lexerAction) {
        if (!lexerActionExecutor) return new LexerActionExecutor([
            lexerAction
        ]);
        let lexerActions = lexerActionExecutor._lexerActions.slice(0);
        lexerActions.push(lexerAction);
        return new LexerActionExecutor(lexerActions);
    }
    /**
     * Creates a {@link LexerActionExecutor} which encodes the current offset
     * for position-dependent lexer actions.
     *
     * Normally, when the executor encounters lexer actions where
     * {@link LexerAction#isPositionDependent} returns `true`, it calls
     * {@link IntStream#seek} on the input {@link CharStream} to set the input
     * position to the *end* of the current token. This behavior provides
     * for efficient DFA representation of lexer actions which appear at the end
     * of a lexer rule, even when the lexer rule matches a variable number of
     * characters.
     *
     * Prior to traversing a match transition in the ATN, the current offset
     * from the token start index is assigned to all position-dependent lexer
     * actions which have not already been assigned a fixed offset. By storing
     * the offsets relative to the token start index, the DFA representation of
     * lexer actions which appear in the middle of tokens remains efficient due
     * to sharing among tokens of the same length, regardless of their absolute
     * position in the input stream.
     *
     * If the current executor already has offsets assigned to all
     * position-dependent lexer actions, the method returns `this`.
     *
     * @param offset The current offset to assign to all position-dependent
     * lexer actions which do not already have offsets assigned.
     *
     * @returns A {@link LexerActionExecutor} which stores input stream offsets
     * for all position-dependent lexer actions.
     */ fixOffsetBeforeMatch(offset) {
        let updatedLexerActions;
        for(let i = 0; i < this._lexerActions.length; i++)if (this._lexerActions[i].isPositionDependent && !(this._lexerActions[i] instanceof $4LVXs.LexerIndexedCustomAction)) {
            if (!updatedLexerActions) updatedLexerActions = this._lexerActions.slice(0);
            updatedLexerActions[i] = new $4LVXs.LexerIndexedCustomAction(offset, this._lexerActions[i]);
        }
        if (!updatedLexerActions) return this;
        return new LexerActionExecutor(updatedLexerActions);
    }
    /**
     * Gets the lexer actions to be executed by this executor.
     * @returns The lexer actions to be executed by this executor.
     */ get lexerActions() {
        return this._lexerActions;
    }
    /**
     * Execute the actions encapsulated by this executor within the context of a
     * particular {@link Lexer}.
     *
     * This method calls {@link IntStream#seek} to set the position of the
     * `input` {@link CharStream} prior to calling
     * {@link LexerAction#execute} on a position-dependent action. Before the
     * method returns, the input position will be restored to the same position
     * it was in when the method was invoked.
     *
     * @param lexer The lexer instance.
     * @param input The input stream which is the source for the current token.
     * When this method is called, the current {@link IntStream#index} for
     * `input` should be the start of the following token, i.e. 1
     * character past the end of the current token.
     * @param startIndex The token start index. This value may be passed to
     * {@link IntStream#seek} to set the `input` position to the beginning
     * of the token.
     */ execute(lexer, input, startIndex) {
        let requiresSeek = false;
        let stopIndex = input.index;
        try {
            for (let lexerAction of this._lexerActions){
                if (lexerAction instanceof $4LVXs.LexerIndexedCustomAction) {
                    let offset = lexerAction.offset;
                    input.seek(startIndex + offset);
                    lexerAction = lexerAction.action;
                    requiresSeek = startIndex + offset !== stopIndex;
                } else if (lexerAction.isPositionDependent) {
                    input.seek(stopIndex);
                    requiresSeek = false;
                }
                lexerAction.execute(lexer);
            }
        } finally{
            if (requiresSeek) input.seek(stopIndex);
        }
    }
    hashCode() {
        return this.cachedHashCode;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerActionExecutor)) return false;
        return this.cachedHashCode === obj.cachedHashCode && $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this._lexerActions, obj._lexerActions);
    }
};
$29e3fe8db7459e78$var$__decorate([
    $d6D31.NotNull
], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "_lexerActions", void 0);
$29e3fe8db7459e78$var$__decorate([
    $d6D31.NotNull
], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "lexerActions", null);
$29e3fe8db7459e78$var$__decorate([
    $29e3fe8db7459e78$var$__param(0, $d6D31.NotNull)
], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "execute", null);
$29e3fe8db7459e78$var$__decorate([
    $d6D31.Override
], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "hashCode", null);
$29e3fe8db7459e78$var$__decorate([
    $d6D31.Override
], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "equals", null);
$29e3fe8db7459e78$var$__decorate([
    $d6D31.NotNull,
    $29e3fe8db7459e78$var$__param(1, $d6D31.NotNull)
], $29e3fe8db7459e78$var$LexerActionExecutor, "append", null);
$29e3fe8db7459e78$var$LexerActionExecutor = $29e3fe8db7459e78$var$__decorate([
    $29e3fe8db7459e78$var$__param(0, $d6D31.NotNull)
], $29e3fe8db7459e78$var$LexerActionExecutor);
module.exports.LexerActionExecutor = $29e3fe8db7459e78$var$LexerActionExecutor;

});
parcelRegister("4LVXs", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3798827adeb28bf0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3798827adeb28bf0$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerIndexedCustomAction = void 0;

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * This implementation of {@link LexerAction} is used for tracking input offsets
 * for position-dependent actions within a {@link LexerActionExecutor}.
 *
 * This action is not serialized as part of the ATN, and is only required for
 * position-dependent lexer actions which appear at a location other than the
 * end of a rule. For more information about DFA optimizations employed for
 * lexer actions, see {@link LexerActionExecutor#append} and
 * {@link LexerActionExecutor#fixOffsetBeforeMatch}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $3798827adeb28bf0$var$LexerIndexedCustomAction = class LexerIndexedCustomAction {
    /**
     * Constructs a new indexed custom action by associating a character offset
     * with a {@link LexerAction}.
     *
     * Note: This class is only required for lexer actions for which
     * {@link LexerAction#isPositionDependent} returns `true`.
     *
     * @param offset The offset into the input {@link CharStream}, relative to
     * the token start index, at which the specified lexer action should be
     * executed.
     * @param action The lexer action to execute at a particular offset in the
     * input {@link CharStream}.
     */ constructor(offset, action){
        this._offset = offset;
        this._action = action;
    }
    /**
     * Gets the location in the input {@link CharStream} at which the lexer
     * action should be executed. The value is interpreted as an offset relative
     * to the token start index.
     *
     * @returns The location in the input {@link CharStream} at which the lexer
     * action should be executed.
     */ get offset() {
        return this._offset;
    }
    /**
     * Gets the lexer action to execute.
     *
     * @returns A {@link LexerAction} object which executes the lexer action.
     */ get action() {
        return this._action;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns the result of calling {@link #getActionType}
     * on the {@link LexerAction} returned by {@link #getAction}.
     */ get actionType() {
        return this._action.actionType;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * This method calls {@link #execute} on the result of {@link #getAction}
     * using the provided `lexer`.
     */ execute(lexer) {
        // assume the input stream position was properly set by the calling code
        this._action.execute(lexer);
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        hash = $iXFjm.MurmurHash.update(hash, this._offset);
        hash = $iXFjm.MurmurHash.update(hash, this._action);
        return $iXFjm.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerIndexedCustomAction)) return false;
        return this._offset === obj._offset && this._action.equals(obj._action);
    }
};
$3798827adeb28bf0$var$__decorate([
    $d6D31.NotNull
], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "action", null);
$3798827adeb28bf0$var$__decorate([
    $d6D31.Override
], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "actionType", null);
$3798827adeb28bf0$var$__decorate([
    $d6D31.Override
], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "isPositionDependent", null);
$3798827adeb28bf0$var$__decorate([
    $d6D31.Override
], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "execute", null);
$3798827adeb28bf0$var$__decorate([
    $d6D31.Override
], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "hashCode", null);
$3798827adeb28bf0$var$__decorate([
    $d6D31.Override
], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "equals", null);
$3798827adeb28bf0$var$LexerIndexedCustomAction = $3798827adeb28bf0$var$__decorate([
    $3798827adeb28bf0$var$__param(1, $d6D31.NotNull)
], $3798827adeb28bf0$var$LexerIndexedCustomAction);
module.exports.LexerIndexedCustomAction = $3798827adeb28bf0$var$LexerIndexedCustomAction;

});


parcelRegister("fOEQQ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b83b36c534666cfd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b83b36c534666cfd$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerNoViableAltException = void 0;

var $fLdDn = parcelRequire("fLdDn");

var $d6D31 = parcelRequire("d6D31");

var $gcfUE = parcelRequire("gcfUE");

var $2IEP9 = parcelRequire("2IEP9");
let $b83b36c534666cfd$var$LexerNoViableAltException = class LexerNoViableAltException extends $fLdDn.RecognitionException {
    constructor(lexer, input, startIndex, deadEndConfigs){
        super(lexer, input);
        this._startIndex = startIndex;
        this._deadEndConfigs = deadEndConfigs;
    }
    get startIndex() {
        return this._startIndex;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
    get inputStream() {
        return super.inputStream;
    }
    toString() {
        let symbol = "";
        if (this._startIndex >= 0 && this._startIndex < this.inputStream.size) {
            symbol = this.inputStream.getText($gcfUE.Interval.of(this._startIndex, this._startIndex));
            symbol = $2IEP9.escapeWhitespace(symbol, false);
        }
        // return String.format(Locale.getDefault(), "%s('%s')", LexerNoViableAltException.class.getSimpleName(), symbol);
        return `LexerNoViableAltException('${symbol}')`;
    }
};
$b83b36c534666cfd$var$__decorate([
    $d6D31.Override
], $b83b36c534666cfd$var$LexerNoViableAltException.prototype, "inputStream", null);
$b83b36c534666cfd$var$__decorate([
    $d6D31.Override
], $b83b36c534666cfd$var$LexerNoViableAltException.prototype, "toString", null);
$b83b36c534666cfd$var$LexerNoViableAltException = $b83b36c534666cfd$var$__decorate([
    $b83b36c534666cfd$var$__param(1, $d6D31.NotNull)
], $b83b36c534666cfd$var$LexerNoViableAltException);
module.exports.LexerNoViableAltException = $b83b36c534666cfd$var$LexerNoViableAltException;

});

parcelRegister("9tIYC", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6e69b5e962f238b8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OrderedATNConfigSet = void 0;

var $c1ClW = parcelRequire("c1ClW");

var $d6D31 = parcelRequire("d6D31");
/**
 *
 * @author Sam Harwell
 */ class $6e69b5e962f238b8$var$OrderedATNConfigSet extends $c1ClW.ATNConfigSet {
    constructor(set, readonly){
        if (set != null && readonly != null) super(set, readonly);
        else super();
    }
    clone(readonly) {
        let copy = new $6e69b5e962f238b8$var$OrderedATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this);
        return copy;
    }
    getKey(e) {
        // This is a specially crafted key to ensure configurations are only merged if they are equal
        return {
            state: 0,
            alt: e.hashCode()
        };
    }
    canMerge(left, leftKey, right) {
        return left.equals(right);
    }
}
$6e69b5e962f238b8$var$__decorate([
    $d6D31.Override
], $6e69b5e962f238b8$var$OrderedATNConfigSet.prototype, "clone", null);
$6e69b5e962f238b8$var$__decorate([
    $d6D31.Override
], $6e69b5e962f238b8$var$OrderedATNConfigSet.prototype, "getKey", null);
$6e69b5e962f238b8$var$__decorate([
    $d6D31.Override
], $6e69b5e962f238b8$var$OrderedATNConfigSet.prototype, "canMerge", null);
module.exports.OrderedATNConfigSet = $6e69b5e962f238b8$var$OrderedATNConfigSet;

});




parcelRegister("hKCjP", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cec474d99a10f341$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoViableAltException = void 0;

var $jIG0W = parcelRequire("jIG0W");

var $fLdDn = parcelRequire("fLdDn");

var $d6D31 = parcelRequire("d6D31");
/** Indicates that the parser could not decide which of two or more paths
 *  to take based upon the remaining input. It tracks the starting token
 *  of the offending input and also knows where the parser was
 *  in the various paths when the error. Reported by reportNoViableAlternative()
 */ class $cec474d99a10f341$var$NoViableAltException extends $fLdDn.RecognitionException {
    constructor(recognizer, input, startToken, offendingToken, deadEndConfigs, ctx){
        if (recognizer instanceof $jIG0W.Parser) {
            if (input === undefined) input = recognizer.inputStream;
            if (startToken === undefined) startToken = recognizer.currentToken;
            if (offendingToken === undefined) offendingToken = recognizer.currentToken;
            if (ctx === undefined) ctx = recognizer.context;
        }
        super(recognizer, input, ctx);
        this._deadEndConfigs = deadEndConfigs;
        this._startToken = startToken;
        this.setOffendingToken(recognizer, offendingToken);
    }
    get startToken() {
        return this._startToken;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
}
$cec474d99a10f341$var$__decorate([
    $d6D31.NotNull
], $cec474d99a10f341$var$NoViableAltException.prototype, "_startToken", void 0);
module.exports.NoViableAltException = $cec474d99a10f341$var$NoViableAltException;

});
parcelRegister("jIG0W", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e5b2b780657df507$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e5b2b780657df507$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var $e5b2b780657df507$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Parser = void 0;

var $2IEP9 = parcelRequire("2IEP9");

var $2M2qJ = parcelRequire("2M2qJ");

var $dvgsl = parcelRequire("dvgsl");

var $4CCJj = parcelRequire("4CCJj");

var $cdCft = parcelRequire("cdCft");

var $6Kebn = parcelRequire("6Kebn");

var $igNLf = parcelRequire("igNLf");

var $d6D31 = parcelRequire("d6D31");

var $3iOjI = parcelRequire("3iOjI");

var $kzbnL = parcelRequire("kzbnL");

var $5xwgp = parcelRequire("5xwgp");

var $kBaAZ = parcelRequire("kBaAZ");

var $kYC92 = parcelRequire("kYC92");

var $2DVsz = parcelRequire("2DVsz");
class $e5b2b780657df507$var$TraceListener {
    constructor(ruleNames, tokenStream){
        this.ruleNames = ruleNames;
        this.tokenStream = tokenStream;
    }
    enterEveryRule(ctx) {
        console.log("enter   " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    exitEveryRule(ctx) {
        console.log("exit    " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    visitErrorNode(node) {
    // intentionally empty
    }
    visitTerminal(node) {
        let parent = node.parent.ruleContext;
        let token = node.symbol;
        console.log("consume " + token + " rule " + this.ruleNames[parent.ruleIndex]);
    }
}
$e5b2b780657df507$var$__decorate([
    $d6D31.Override
], $e5b2b780657df507$var$TraceListener.prototype, "enterEveryRule", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.Override
], $e5b2b780657df507$var$TraceListener.prototype, "exitEveryRule", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.Override
], $e5b2b780657df507$var$TraceListener.prototype, "visitErrorNode", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.Override
], $e5b2b780657df507$var$TraceListener.prototype, "visitTerminal", null);



/** This is all the parsing support code essentially; most of it is error recovery stuff. */ class $e5b2b780657df507$var$Parser extends $kBaAZ.Recognizer {
    constructor(input){
        super();
        /**
         * The error handling strategy for the parser. The default value is a new
         * instance of {@link DefaultErrorStrategy}.
         *
         * @see #getErrorHandler
         * @see #setErrorHandler
         */ this._errHandler = new $4CCJj.DefaultErrorStrategy();
        this._precedenceStack = new $6Kebn.IntegerStack();
        /**
         * Specifies whether or not the parser should construct a parse tree during
         * the parsing process. The default value is `true`.
         *
         * @see `buildParseTree`
         */ this._buildParseTrees = true;
        /**
         * The list of {@link ParseTreeListener} listeners registered to receive
         * events during the parse.
         *
         * @see #addParseListener
         */ this._parseListeners = [];
        /**
         * The number of syntax errors reported during parsing. This value is
         * incremented each time {@link #notifyErrorListeners} is called.
         */ this._syntaxErrors = 0;
        /** Indicates parser has match()ed EOF token. See {@link #exitRule()}. */ this.matchedEOF = false;
        this._precedenceStack.push(0);
        this.inputStream = input;
    }
    reset(resetInput) {
        // Note: this method executes when not parsing, so _ctx can be undefined
        if (resetInput === undefined || resetInput) this.inputStream.seek(0);
        this._errHandler.reset(this);
        this._ctx = undefined;
        this._syntaxErrors = 0;
        this.matchedEOF = false;
        this.isTrace = false;
        this._precedenceStack.clear();
        this._precedenceStack.push(0);
        let interpreter = this.interpreter;
        if (interpreter != null) interpreter.reset();
    }
    /**
     * Match current input symbol against `ttype`. If the symbol type
     * matches, {@link ANTLRErrorStrategy#reportMatch} and {@link #consume} are
     * called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @param ttype the token type to match
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * `ttype` and the error strategy could not recover from the
     * mismatched symbol
     */ match(ttype) {
        let t = this.currentToken;
        if (t.type === ttype) {
            if (ttype === $2DVsz.Token.EOF) this.matchedEOF = true;
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Match current input symbol as a wildcard. If the symbol type matches
     * (i.e. has a value greater than 0), {@link ANTLRErrorStrategy#reportMatch}
     * and {@link #consume} are called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link Parser#createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * a wildcard and the error strategy could not recover from the mismatched
     * symbol
     */ matchWildcard() {
        let t = this.currentToken;
        if (t.type > 0) {
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Track the {@link ParserRuleContext} objects during the parse and hook
     * them up using the {@link ParserRuleContext#children} list so that it
     * forms a parse tree. The {@link ParserRuleContext} returned from the start
     * rule represents the root of the parse tree.
     *
     * Note that if we are not building parse trees, rule contexts only point
     * upwards. When a rule exits, it returns the context but that gets garbage
     * collected if nobody holds a reference. It points upwards but nobody
     * points at it.
     *
     * When we build parse trees, we are adding all of these contexts to
     * {@link ParserRuleContext#children} list. Contexts are then not candidates
     * for garbage collection.
     */ set buildParseTree(buildParseTrees) {
        this._buildParseTrees = buildParseTrees;
    }
    /**
     * Gets whether or not a complete parse tree will be constructed while
     * parsing. This property is `true` for a newly constructed parser.
     *
     * @returns `true` if a complete parse tree will be constructed while
     * parsing, otherwise `false`
     */ get buildParseTree() {
        return this._buildParseTrees;
    }
    getParseListeners() {
        return this._parseListeners;
    }
    /**
     * Registers `listener` to receive events during the parsing process.
     *
     * To support output-preserving grammar transformations (including but not
     * limited to left-recursion removal, automated left-factoring, and
     * optimized code generation), calls to listener methods during the parse
     * may differ substantially from calls made by
     * {@link ParseTreeWalker#DEFAULT} used after the parse is complete. In
     * particular, rule entry and exit events may occur in a different order
     * during the parse than after the parser. In addition, calls to certain
     * rule entry methods may be omitted.
     *
     * With the following specific exceptions, calls to listener events are
     * *deterministic*, i.e. for identical input the calls to listener
     * methods will be the same.
     *
     * * Alterations to the grammar used to generate code may change the
     *   behavior of the listener calls.
     * * Alterations to the command line options passed to ANTLR 4 when
     *   generating the parser may change the behavior of the listener calls.
     * * Changing the version of the ANTLR Tool used to generate the parser
     *   may change the behavior of the listener calls.
     *
     * @param listener the listener to add
     *
     * @throws {@link TypeError} if `listener` is `undefined`
     */ addParseListener(listener) {
        if (listener == null) throw new TypeError("listener cannot be null");
        this._parseListeners.push(listener);
    }
    /**
     * Remove `listener` from the list of parse listeners.
     *
     * If `listener` is `undefined` or has not been added as a parse
     * listener, this method does nothing.
     *
     * @see #addParseListener
     *
     * @param listener the listener to remove
     */ removeParseListener(listener) {
        let index = this._parseListeners.findIndex((l)=>l === listener);
        if (index !== -1) this._parseListeners.splice(index, 1);
    }
    /**
     * Remove all parse listeners.
     *
     * @see #addParseListener
     */ removeParseListeners() {
        this._parseListeners.length = 0;
    }
    /**
     * Notify any parse listeners of an enter rule event.
     *
     * @see #addParseListener
     */ triggerEnterRuleEvent() {
        for (let listener of this._parseListeners){
            if (listener.enterEveryRule) listener.enterEveryRule(this._ctx);
            this._ctx.enterRule(listener);
        }
    }
    /**
     * Notify any parse listeners of an exit rule event.
     *
     * @see #addParseListener
     */ triggerExitRuleEvent() {
        // reverse order walk of listeners
        for(let i = this._parseListeners.length - 1; i >= 0; i--){
            let listener = this._parseListeners[i];
            this._ctx.exitRule(listener);
            if (listener.exitEveryRule) listener.exitEveryRule(this._ctx);
        }
    }
    /**
     * Gets the number of syntax errors reported during parsing. This value is
     * incremented each time {@link #notifyErrorListeners} is called.
     *
     * @see #notifyErrorListeners
     */ get numberOfSyntaxErrors() {
        return this._syntaxErrors;
    }
    get tokenFactory() {
        return this._input.tokenSource.tokenFactory;
    }
    /**
     * The ATN with bypass alternatives is expensive to create so we create it
     * lazily.
     *
     * @ if the current parser does not
     * implement the `serializedATN` property.
     */ getATNWithBypassAlts() {
        let serializedAtn = this.serializedATN;
        if (serializedAtn == null) throw new Error("The current parser does not support an ATN with bypass alternatives.");
        let result = $e5b2b780657df507$var$Parser.bypassAltsAtnCache.get(serializedAtn);
        if (result == null) {
            let deserializationOptions = new $2M2qJ.ATNDeserializationOptions();
            deserializationOptions.isGenerateRuleBypassTransitions = true;
            result = new $dvgsl.ATNDeserializer(deserializationOptions).deserialize($2IEP9.toCharArray(serializedAtn));
            $e5b2b780657df507$var$Parser.bypassAltsAtnCache.set(serializedAtn, result);
        }
        return result;
    }
    compileParseTreePattern(pattern, patternRuleIndex, lexer) {
        return $e5b2b780657df507$var$__awaiter(this, void 0, void 0, function*() {
            if (!lexer) {
                if (this.inputStream) {
                    let tokenSource = this.inputStream.tokenSource;
                    if (tokenSource instanceof $igNLf.Lexer) lexer = tokenSource;
                }
                if (!lexer) throw new Error("Parser can't discover a lexer to use");
            }
            let currentLexer = lexer;
            let m = yield Promise.resolve().then(()=>(parcelRequire("gRsTM")));
            let matcher = new m.ParseTreePatternMatcher(currentLexer, this);
            return matcher.compile(pattern, patternRuleIndex);
        });
    }
    get errorHandler() {
        return this._errHandler;
    }
    set errorHandler(handler) {
        this._errHandler = handler;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the token stream and reset the parser. */ set inputStream(input) {
        this.reset(false);
        this._input = input;
    }
    /** Match needs to return the current input symbol, which gets put
     *  into the label for the associated token ref; e.g., x=ID.
     */ get currentToken() {
        return this._input.LT(1);
    }
    notifyErrorListeners(msg, offendingToken, e) {
        if (offendingToken === undefined) offendingToken = this.currentToken;
        else if (offendingToken === null) offendingToken = undefined;
        this._syntaxErrors++;
        let line = -1;
        let charPositionInLine = -1;
        if (offendingToken != null) {
            line = offendingToken.line;
            charPositionInLine = offendingToken.charPositionInLine;
        }
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, offendingToken, line, charPositionInLine, msg, e);
    }
    /**
     * Consume and return the [current symbol](`currentToken`).
     *
     * E.g., given the following input with `A` being the current
     * lookahead symbol, this function moves the cursor to `B` and returns
     * `A`.
     *
     * ```
     * A B
     * ^
     * ```
     *
     * If the parser is not in error recovery mode, the consumed symbol is added
     * to the parse tree using {@link ParserRuleContext#addChild(TerminalNode)}, and
     * {@link ParseTreeListener#visitTerminal} is called on any parse listeners.
     * If the parser *is* in error recovery mode, the consumed symbol is
     * added to the parse tree using {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)} and
     * {@link ParseTreeListener#visitErrorNode} is called on any parse
     * listeners.
     */ consume() {
        let o = this.currentToken;
        if (o.type !== $e5b2b780657df507$var$Parser.EOF) this.inputStream.consume();
        let hasListener = this._parseListeners.length !== 0;
        if (this._buildParseTrees || hasListener) {
            if (this._errHandler.inErrorRecoveryMode(this)) {
                let node = this._ctx.addErrorNode(this.createErrorNode(this._ctx, o));
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitErrorNode) listener.visitErrorNode(node);
                }
            } else {
                let node = this.createTerminalNode(this._ctx, o);
                this._ctx.addChild(node);
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitTerminal) listener.visitTerminal(node);
                }
            }
        }
        return o;
    }
    /**
     * How to create a token leaf node associated with a parent.
     * Typically, the terminal node to create is not a function of the parent.
     *
     * @since 4.7
     */ createTerminalNode(parent, t) {
        return new $kYC92.TerminalNode(t);
    }
    /**
     * How to create an error node, given a token, associated with a parent.
     * Typically, the error node to create is not a function of the parent.
     *
     * @since 4.7
     */ createErrorNode(parent, t) {
        return new $cdCft.ErrorNode(t);
    }
    addContextToParseTree() {
        let parent = this._ctx._parent;
        // add current context to parent if we have a parent
        if (parent != null) parent.addChild(this._ctx);
    }
    /**
     * Always called by generated parsers upon entry to a rule. Access field
     * {@link #_ctx} get the current context.
     */ enterRule(localctx, state, ruleIndex) {
        this.state = state;
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    enterLeftFactoredRule(localctx, state, ruleIndex) {
        this.state = state;
        if (this._buildParseTrees) {
            let factoredContext = this._ctx.getChild(this._ctx.childCount - 1);
            this._ctx.removeLastChild();
            factoredContext._parent = localctx;
            localctx.addChild(factoredContext);
        }
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    exitRule() {
        if (this.matchedEOF) // if we have matched EOF, it cannot consume past EOF so we use LT(1) here
        this._ctx._stop = this._input.LT(1); // LT(1) will be end of file
        else this._ctx._stop = this._input.tryLT(-1); // stop node is what we just matched
        // trigger event on _ctx, before it reverts to parent
        this.triggerExitRuleEvent();
        this.state = this._ctx.invokingState;
        this._ctx = this._ctx._parent;
    }
    enterOuterAlt(localctx, altNum) {
        localctx.altNumber = altNum;
        // if we have new localctx, make sure we replace existing ctx
        // that is previous child of parse tree
        if (this._buildParseTrees && this._ctx !== localctx) {
            let parent = this._ctx._parent;
            if (parent != null) {
                parent.removeLastChild();
                parent.addChild(localctx);
            }
        }
        this._ctx = localctx;
    }
    /**
     * Get the precedence level for the top-most precedence rule.
     *
     * @returns The precedence level for the top-most precedence rule, or -1 if
     * the parser context is not nested within a precedence rule.
     */ get precedence() {
        if (this._precedenceStack.isEmpty) return -1;
        return this._precedenceStack.peek();
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this.state = state;
        this._precedenceStack.push(precedence);
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    /** Like {@link #enterRule} but for recursive rules.
     *  Make the current context the child of the incoming localctx.
     */ pushNewRecursionContext(localctx, state, ruleIndex) {
        let previous = this._ctx;
        previous._parent = localctx;
        previous.invokingState = state;
        previous._stop = this._input.tryLT(-1);
        this._ctx = localctx;
        this._ctx._start = previous._start;
        if (this._buildParseTrees) this._ctx.addChild(previous);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    unrollRecursionContexts(_parentctx) {
        this._precedenceStack.pop();
        this._ctx._stop = this._input.tryLT(-1);
        let retctx = this._ctx; // save current ctx (return value)
        // unroll so _ctx is as it was before call to recursive method
        if (this._parseListeners.length > 0) while(this._ctx !== _parentctx){
            this.triggerExitRuleEvent();
            this._ctx = this._ctx._parent;
        }
        else this._ctx = _parentctx;
        // hook into tree
        retctx._parent = _parentctx;
        if (this._buildParseTrees && _parentctx != null) // add return ctx into invoking rule's tree
        _parentctx.addChild(retctx);
    }
    getInvokingContext(ruleIndex) {
        let p = this._ctx;
        while(p && p.ruleIndex !== ruleIndex)p = p._parent;
        return p;
    }
    get context() {
        return this._ctx;
    }
    set context(ctx) {
        this._ctx = ctx;
    }
    precpred(localctx, precedence) {
        return precedence >= this._precedenceStack.peek();
    }
    getErrorListenerDispatch() {
        return new $5xwgp.ProxyParserErrorListener(this.getErrorListeners());
    }
    inContext(context) {
        // TODO: useful in parser?
        return false;
    }
    /**
     * Checks whether or not `symbol` can follow the current state in the
     * ATN. The behavior of this method is equivalent to the following, but is
     * implemented such that the complete context-sensitive follow set does not
     * need to be explicitly constructed.
     *
     * ```
     * return getExpectedTokens().contains(symbol);
     * ```
     *
     * @param symbol the symbol type to check
     * @returns `true` if `symbol` can follow the current state in
     * the ATN, otherwise `false`.
     */ isExpectedToken(symbol) {
        //   		return interpreter.atn.nextTokens(_ctx);
        let atn = this.interpreter.atn;
        let ctx = this._ctx;
        let s = atn.states[this.state];
        let following = atn.nextTokens(s);
        if (following.contains(symbol)) return true;
        //        System.out.println("following "+s+"="+following);
        if (!following.contains($2DVsz.Token.EPSILON)) return false;
        while(ctx != null && ctx.invokingState >= 0 && following.contains($2DVsz.Token.EPSILON)){
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = atn.nextTokens(rt.followState);
            if (following.contains(symbol)) return true;
            ctx = ctx._parent;
        }
        if (following.contains($2DVsz.Token.EPSILON) && symbol === $2DVsz.Token.EOF) return true;
        return false;
    }
    get isMatchedEOF() {
        return this.matchedEOF;
    }
    /**
     * Computes the set of input symbols which could follow the current parser
     * state and context, as given by {@link #getState} and {@link #getContext},
     * respectively.
     *
     * @see ATN#getExpectedTokens(int, RuleContext)
     */ getExpectedTokens() {
        return this.atn.getExpectedTokens(this.state, this.context);
    }
    getExpectedTokensWithinCurrentRule() {
        let atn = this.interpreter.atn;
        let s = atn.states[this.state];
        return atn.nextTokens(s);
    }
    /** Get a rule's index (i.e., `RULE_ruleName` field) or -1 if not found. */ getRuleIndex(ruleName) {
        let ruleIndex = this.getRuleIndexMap().get(ruleName);
        if (ruleIndex != null) return ruleIndex;
        return -1;
    }
    get ruleContext() {
        return this._ctx;
    }
    /** Return List&lt;String&gt; of the rule names in your parser instance
     *  leading up to a call to the current rule.  You could override if
     *  you want more details such as the file/line info of where
     *  in the ATN a rule is invoked.
     *
     *  This is very useful for error messages.
     */ getRuleInvocationStack(ctx = this._ctx) {
        let p = ctx; // Workaround for Microsoft/TypeScript#14487
        let ruleNames = this.ruleNames;
        let stack = [];
        while(p != null){
            // compute what follows who invoked us
            let ruleIndex = p.ruleIndex;
            if (ruleIndex < 0) stack.push("n/a");
            else stack.push(ruleNames[ruleIndex]);
            p = p._parent;
        }
        return stack;
    }
    /** For debugging and other purposes. */ getDFAStrings() {
        let s = [];
        for (let dfa of this._interp.atn.decisionToDFA)s.push(dfa.toString(this.vocabulary, this.ruleNames));
        return s;
    }
    /** For debugging and other purposes. */ dumpDFA() {
        let seenOne = false;
        for (let dfa of this._interp.atn.decisionToDFA)if (!dfa.isEmpty) {
            if (seenOne) console.log();
            console.log("Decision " + dfa.decision + ":");
            $6cAn5.stdout.write(dfa.toString(this.vocabulary, this.ruleNames));
            seenOne = true;
        }
    }
    get sourceName() {
        return this._input.sourceName;
    }
    get parseInfo() {
        return Promise.resolve().then(()=>(parcelRequire("Px7pN"))).then((m)=>{
            let interp = this.interpreter;
            if (interp instanceof m.ProfilingATNSimulator) return new $3iOjI.ParseInfo(interp);
            return undefined;
        });
    }
    /**
     * @since 4.3
     */ setProfile(profile) {
        return $e5b2b780657df507$var$__awaiter(this, void 0, void 0, function*() {
            let m = yield Promise.resolve().then(()=>(parcelRequire("Px7pN")));
            let interp = this.interpreter;
            if (profile) {
                if (!(interp instanceof m.ProfilingATNSimulator)) this.interpreter = new m.ProfilingATNSimulator(this);
            } else if (interp instanceof m.ProfilingATNSimulator) this.interpreter = new $kzbnL.ParserATNSimulator(this.atn, this);
            this.interpreter.setPredictionMode(interp.getPredictionMode());
        });
    }
    /** During a parse is sometimes useful to listen in on the rule entry and exit
     *  events as well as token matches. This is for quick and dirty debugging.
     */ set isTrace(trace) {
        if (!trace) {
            if (this._tracer) {
                this.removeParseListener(this._tracer);
                this._tracer = undefined;
            }
        } else {
            if (this._tracer) this.removeParseListener(this._tracer);
            else this._tracer = new $e5b2b780657df507$var$TraceListener(this.ruleNames, this._input);
            this.addParseListener(this._tracer);
        }
    }
    /**
     * Gets whether a {@link TraceListener} is registered as a parse listener
     * for the parser.
     */ get isTrace() {
        return this._tracer != null;
    }
}
/**
 * This field maps from the serialized ATN string to the deserialized {@link ATN} with
 * bypass alternatives.
 *
 * @see ATNDeserializationOptions.isGenerateRuleBypassTransitions
 */ $e5b2b780657df507$var$Parser.bypassAltsAtnCache = new Map();
$e5b2b780657df507$var$__decorate([
    $d6D31.NotNull
], $e5b2b780657df507$var$Parser.prototype, "_errHandler", void 0);
$e5b2b780657df507$var$__decorate([
    $d6D31.NotNull
], $e5b2b780657df507$var$Parser.prototype, "match", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.NotNull
], $e5b2b780657df507$var$Parser.prototype, "matchWildcard", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.NotNull
], $e5b2b780657df507$var$Parser.prototype, "getParseListeners", null);
$e5b2b780657df507$var$__decorate([
    $e5b2b780657df507$var$__param(0, $d6D31.NotNull)
], $e5b2b780657df507$var$Parser.prototype, "addParseListener", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.NotNull
], $e5b2b780657df507$var$Parser.prototype, "getATNWithBypassAlts", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.NotNull,
    $e5b2b780657df507$var$__param(0, $d6D31.NotNull)
], $e5b2b780657df507$var$Parser.prototype, "errorHandler", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.Override
], $e5b2b780657df507$var$Parser.prototype, "inputStream", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.NotNull
], $e5b2b780657df507$var$Parser.prototype, "currentToken", null);
$e5b2b780657df507$var$__decorate([
    $e5b2b780657df507$var$__param(0, $d6D31.NotNull)
], $e5b2b780657df507$var$Parser.prototype, "enterRule", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.Override,
    $e5b2b780657df507$var$__param(0, $d6D31.Nullable)
], $e5b2b780657df507$var$Parser.prototype, "precpred", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.Override
], $e5b2b780657df507$var$Parser.prototype, "getErrorListenerDispatch", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.NotNull
], $e5b2b780657df507$var$Parser.prototype, "getExpectedTokens", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.NotNull
], $e5b2b780657df507$var$Parser.prototype, "getExpectedTokensWithinCurrentRule", null);
$e5b2b780657df507$var$__decorate([
    $d6D31.Override
], $e5b2b780657df507$var$Parser.prototype, "parseInfo", null);
module.exports.Parser = $e5b2b780657df507$var$Parser;

});
parcelRegister("2M2qJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2051f30d0c577226$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializationOptions = void 0;

var $d6D31 = parcelRequire("d6D31");
/**
 *
 * @author Sam Harwell
 */ class $2051f30d0c577226$var$ATNDeserializationOptions {
    constructor(options){
        this.readOnly = false;
        if (options) {
            this.verifyATN = options.verifyATN;
            this.generateRuleBypassTransitions = options.generateRuleBypassTransitions;
            this.optimize = options.optimize;
        } else {
            this.verifyATN = true;
            this.generateRuleBypassTransitions = false;
            this.optimize = true;
        }
    }
    static get defaultOptions() {
        if ($2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions == null) {
            $2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions = new $2051f30d0c577226$var$ATNDeserializationOptions();
            $2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions.makeReadOnly();
        }
        return $2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions;
    }
    get isReadOnly() {
        return this.readOnly;
    }
    makeReadOnly() {
        this.readOnly = true;
    }
    get isVerifyATN() {
        return this.verifyATN;
    }
    set isVerifyATN(verifyATN) {
        this.throwIfReadOnly();
        this.verifyATN = verifyATN;
    }
    get isGenerateRuleBypassTransitions() {
        return this.generateRuleBypassTransitions;
    }
    set isGenerateRuleBypassTransitions(generateRuleBypassTransitions) {
        this.throwIfReadOnly();
        this.generateRuleBypassTransitions = generateRuleBypassTransitions;
    }
    get isOptimize() {
        return this.optimize;
    }
    set isOptimize(optimize) {
        this.throwIfReadOnly();
        this.optimize = optimize;
    }
    throwIfReadOnly() {
        if (this.isReadOnly) throw new Error("The object is read only.");
    }
}
$2051f30d0c577226$var$__decorate([
    $d6D31.NotNull
], $2051f30d0c577226$var$ATNDeserializationOptions, "defaultOptions", null);
module.exports.ATNDeserializationOptions = $2051f30d0c577226$var$ATNDeserializationOptions;

});

parcelRegister("dvgsl", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9d4aef733dce84f9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9d4aef733dce84f9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializer = void 0;

var $gxlfY = parcelRequire("gxlfY");

var $7Veax = parcelRequire("7Veax");

var $bcnvE = parcelRequire("bcnvE");

var $2M2qJ = parcelRequire("2M2qJ");

var $1bs3X = parcelRequire("1bs3X");

var $5r7n7 = parcelRequire("5r7n7");

var $gAm9p = parcelRequire("gAm9p");

var $4yiuQ = parcelRequire("4yiuQ");

var $5BPMp = parcelRequire("5BPMp");

var $loKp0 = parcelRequire("loKp0");

var $65vNG = parcelRequire("65vNG");

var $dPYn6 = parcelRequire("dPYn6");

var $jJRyp = parcelRequire("jJRyp");

var $bpnRH = parcelRequire("bpnRH");

var $hGRod = parcelRequire("hGRod");

var $l4Nh1 = parcelRequire("l4Nh1");

var $iw4Ko = parcelRequire("iw4Ko");

var $RgRAX = parcelRequire("RgRAX");

var $jgJtt = parcelRequire("jgJtt");

var $l606e = parcelRequire("l606e");

var $6hIs4 = parcelRequire("6hIs4");

var $a9nIX = parcelRequire("a9nIX");

var $2Gb96 = parcelRequire("2Gb96");

var $ayRdK = parcelRequire("ayRdK");

var $kfqEk = parcelRequire("kfqEk");

var $d6D31 = parcelRequire("d6D31");

var $FLEKS = parcelRequire("FLEKS");

var $kzbnL = parcelRequire("kzbnL");

var $d1V7w = parcelRequire("d1V7w");

var $7qlbM = parcelRequire("7qlbM");

var $7KGEQ = parcelRequire("7KGEQ");

var $hnaRv = parcelRequire("hnaRv");

var $aISkF = parcelRequire("aISkF");

var $j2zc8 = parcelRequire("j2zc8");

var $4kGBm = parcelRequire("4kGBm");

var $aybFP = parcelRequire("aybFP");

var $Np2R3 = parcelRequire("Np2R3");

var $jEsaF = parcelRequire("jEsaF");

var $bjwd1 = parcelRequire("bjwd1");

var $f9raX = parcelRequire("f9raX");

var $2DVsz = parcelRequire("2DVsz");

var $WS4d7 = parcelRequire("WS4d7");

var $kWxOc = parcelRequire("kWxOc");

var $aPmi9 = parcelRequire("aPmi9");
var $9d4aef733dce84f9$var$UnicodeDeserializingMode;
(function(UnicodeDeserializingMode) {
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_BMP"] = 0] = "UNICODE_BMP";
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_SMP"] = 1] = "UNICODE_SMP";
})($9d4aef733dce84f9$var$UnicodeDeserializingMode || ($9d4aef733dce84f9$var$UnicodeDeserializingMode = {}));
/**
 *
 * @author Sam Harwell
 */ class $9d4aef733dce84f9$var$ATNDeserializer {
    constructor(deserializationOptions){
        if (deserializationOptions === undefined) deserializationOptions = $2M2qJ.ATNDeserializationOptions.defaultOptions;
        this.deserializationOptions = deserializationOptions;
    }
    static get SERIALIZED_VERSION() {
        /* This value should never change. Updates following this version are
         * reflected as change in the unique ID SERIALIZED_UUID.
         */ return 3;
    }
    /**
     * Determines if a particular serialized representation of an ATN supports
     * a particular feature, identified by the {@link UUID} used for serializing
     * the ATN at the time the feature was first introduced.
     *
     * @param feature The {@link UUID} marking the first time the feature was
     * supported in the serialized ATN.
     * @param actualUuid The {@link UUID} of the actual serialized ATN which is
     * currently being deserialized.
     * @returns `true` if the `actualUuid` value represents a
     * serialized ATN at or after the feature identified by `feature` was
     * introduced; otherwise, `false`.
     */ static isFeatureSupported(feature, actualUuid) {
        let featureIndex = $9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(feature));
        if (featureIndex < 0) return false;
        return $9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(actualUuid)) >= featureIndex;
    }
    static getUnicodeDeserializer(mode) {
        if (mode === 0 /* UNICODE_BMP */ ) return {
            readUnicode: (data, p)=>{
                return $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p]);
            },
            size: 1
        };
        else return {
            readUnicode: (data, p)=>{
                return $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, p);
            },
            size: 2
        };
    }
    deserialize(data) {
        data = data.slice(0);
        // Each Uint16 value in data is shifted by +2 at the entry to this method. This is an encoding optimization
        // targeting the serialized values 0 and -1 (serialized to 0xFFFF), each of which are very common in the
        // serialized form of the ATN. In the modified UTF-8 that Java uses for compiled string literals, these two
        // character values have multi-byte forms. By shifting each value by +2, they become characters 2 and 1 prior to
        // writing the string, each of which have single-byte representations. Since the shift occurs in the tool during
        // ATN serialization, each target is responsible for adjusting the values during deserialization.
        //
        // As a special case, note that the first element of data is not adjusted because it contains the major version
        // number of the serialized ATN, which was fixed at 3 at the time the value shifting was implemented.
        for(let i = 1; i < data.length; i++)data[i] = data[i] - 2 & 0xFFFF;
        let p = 0;
        let version = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        if (version !== $9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_VERSION) {
            let reason = `Could not deserialize ATN with version ${version} (expected ${$9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_VERSION}).`;
            throw new Error(reason);
        }
        let uuid = $9d4aef733dce84f9$var$ATNDeserializer.toUUID(data, p);
        p += 8;
        if ($9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(uuid)) < 0) {
            let reason = `Could not deserialize ATN with UUID ${uuid} (expected ${$9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_UUID} or a legacy UUID).`;
            throw new Error(reason);
        }
        let supportsLexerActions = $9d4aef733dce84f9$var$ATNDeserializer.isFeatureSupported($9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid);
        let grammarType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        let maxTokenType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        let atn = new $bcnvE.ATN(grammarType, maxTokenType);
        //
        // STATES
        //
        let loopBackStateNumbers = [];
        let endStateNumbers = [];
        let nstates = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nstates; i++){
            let stype = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            // ignore bad type of states
            if (stype === $1bs3X.ATNStateType.INVALID_TYPE) {
                atn.addState(new $l4Nh1.InvalidState());
                continue;
            }
            let ruleIndex = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            if (ruleIndex === 0xFFFF) ruleIndex = -1;
            let s = this.stateFactory(stype, ruleIndex);
            if (stype === $1bs3X.ATNStateType.LOOP_END) {
                let loopBackStateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                loopBackStateNumbers.push([
                    s,
                    loopBackStateNumber
                ]);
            } else if (s instanceof $65vNG.BlockStartState) {
                let endStateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                endStateNumbers.push([
                    s,
                    endStateNumber
                ]);
            }
            atn.addState(s);
        }
        // delay the assignment of loop back and end states until we know all the state instances have been initialized
        for (let pair of loopBackStateNumbers)pair[0].loopBackState = atn.states[pair[1]];
        for (let pair of endStateNumbers)pair[0].endState = atn.states[pair[1]];
        let numNonGreedyStates = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numNonGreedyStates; i++){
            let stateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].nonGreedy = true;
        }
        let numSllDecisions = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numSllDecisions; i++){
            let stateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].sll = true;
        }
        let numPrecedenceStates = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numPrecedenceStates; i++){
            let stateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].isPrecedenceRule = true;
        }
        //
        // RULES
        //
        let nrules = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        if (atn.grammarType === 0 /* LEXER */ ) atn.ruleToTokenType = new Int32Array(nrules);
        atn.ruleToStartState = new Array(nrules);
        for(let i = 0; i < nrules; i++){
            let s = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            let startState = atn.states[s];
            startState.leftFactored = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]) !== 0;
            atn.ruleToStartState[i] = startState;
            if (atn.grammarType === 0 /* LEXER */ ) {
                let tokenType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                if (tokenType === 0xFFFF) tokenType = $2DVsz.Token.EOF;
                atn.ruleToTokenType[i] = tokenType;
                if (!$9d4aef733dce84f9$var$ATNDeserializer.isFeatureSupported($9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid)) {
                    // this piece of unused metadata was serialized prior to the
                    // addition of LexerAction
                    let actionIndexIgnored = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    if (actionIndexIgnored === 0xFFFF) actionIndexIgnored = -1;
                }
            }
        }
        atn.ruleToStopState = new Array(nrules);
        for (let state of atn.states){
            if (!(state instanceof $4kGBm.RuleStopState)) continue;
            atn.ruleToStopState[state.ruleIndex] = state;
            atn.ruleToStartState[state.ruleIndex].stopState = state;
        }
        //
        // MODES
        //
        let nmodes = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nmodes; i++){
            let s = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            atn.modeToStartState.push(atn.states[s]);
        }
        atn.modeToDFA = new Array(nmodes);
        for(let i = 0; i < nmodes; i++)atn.modeToDFA[i] = new $jJRyp.DFA(atn.modeToStartState[i]);
        //
        // SETS
        //
        let sets = [];
        // First, read all sets with 16-bit Unicode code points <= U+FFFF.
        p = this.deserializeSets(data, p, sets, $9d4aef733dce84f9$var$ATNDeserializer.getUnicodeDeserializer(0 /* UNICODE_BMP */ ));
        // Next, if the ATN was serialized with the Unicode SMP feature,
        // deserialize sets with 32-bit arguments <= U+10FFFF.
        if ($9d4aef733dce84f9$var$ATNDeserializer.isFeatureSupported($9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP, uuid)) p = this.deserializeSets(data, p, sets, $9d4aef733dce84f9$var$ATNDeserializer.getUnicodeDeserializer(1 /* UNICODE_SMP */ ));
        //
        // EDGES
        //
        let nedges = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nedges; i++){
            let src = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p]);
            let trg = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 1]);
            let ttype = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 2]);
            let arg1 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 3]);
            let arg2 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 4]);
            let arg3 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 5]);
            let trans = this.edgeFactory(atn, ttype, src, trg, arg1, arg2, arg3, sets);
            // console.log(`EDGE ${trans.constructor.name} ${src}->${trg} ${Transition.serializationNames[ttype]} ${arg1},${arg2},${arg3}`);
            let srcState = atn.states[src];
            srcState.addTransition(trans);
            p += 6;
        }
        let returnTransitionsSet = new $7Veax.Array2DHashSet({
            hashCode: (o)=>o.stopState ^ o.returnState ^ o.outermostPrecedenceReturn,
            equals: (a, b)=>{
                return a.stopState === b.stopState && a.returnState === b.returnState && a.outermostPrecedenceReturn === b.outermostPrecedenceReturn;
            }
        });
        let returnTransitions = [];
        for (let state of atn.states){
            let returningToLeftFactored = state.ruleIndex >= 0 && atn.ruleToStartState[state.ruleIndex].leftFactored;
            for(let i = 0; i < state.numberOfTransitions; i++){
                let t = state.transition(i);
                if (!(t instanceof $aybFP.RuleTransition)) continue;
                let ruleTransition = t;
                let returningFromLeftFactored = atn.ruleToStartState[ruleTransition.target.ruleIndex].leftFactored;
                if (!returningFromLeftFactored && returningToLeftFactored) continue;
                let outermostPrecedenceReturn = -1;
                if (atn.ruleToStartState[ruleTransition.target.ruleIndex].isPrecedenceRule) {
                    if (ruleTransition.precedence === 0) outermostPrecedenceReturn = ruleTransition.target.ruleIndex;
                }
                let current = {
                    stopState: ruleTransition.target.ruleIndex,
                    returnState: ruleTransition.followState.stateNumber,
                    outermostPrecedenceReturn: outermostPrecedenceReturn
                };
                if (returnTransitionsSet.add(current)) returnTransitions.push(current);
            }
        }
        // Add all elements from returnTransitions to the ATN
        for (let returnTransition of returnTransitions){
            let transition = new $bpnRH.EpsilonTransition(atn.states[returnTransition.returnState], returnTransition.outermostPrecedenceReturn);
            atn.ruleToStopState[returnTransition.stopState].addTransition(transition);
        }
        for (let state of atn.states){
            if (state instanceof $65vNG.BlockStartState) {
                // we need to know the end state to set its start state
                if (state.endState === undefined) throw new Error("IllegalStateException");
                // block end states can only be associated to a single block start state
                if (state.endState.startState !== undefined) throw new Error("IllegalStateException");
                state.endState.startState = state;
            }
            if (state instanceof $7qlbM.PlusLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $d1V7w.PlusBlockStartState) target.loopBackState = loopbackState;
                }
            } else if (state instanceof $bjwd1.StarLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $f9raX.StarLoopEntryState) target.loopBackState = loopbackState;
                }
            }
        }
        //
        // DECISIONS
        //
        let ndecisions = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 1; i <= ndecisions; i++){
            let s = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            let decState = atn.states[s];
            atn.decisionToState.push(decState);
            decState.decision = i - 1;
        }
        //
        // LEXER ACTIONS
        //
        if (atn.grammarType === 0 /* LEXER */ ) {
            if (supportsLexerActions) {
                atn.lexerActions = new Array($9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]));
                for(let i = 0; i < atn.lexerActions.length; i++){
                    let actionType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    let data1 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    if (data1 === 0xFFFF) data1 = -1;
                    let data2 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    if (data2 === 0xFFFF) data2 = -1;
                    let lexerAction = this.lexerActionFactory(actionType, data1, data2);
                    atn.lexerActions[i] = lexerAction;
                }
            } else {
                // for compatibility with older serialized ATNs, convert the old
                // serialized action index for action transitions to the new
                // form, which is the index of a LexerCustomAction
                let legacyLexerActions = [];
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (!(transition instanceof $gxlfY.ActionTransition)) continue;
                    let ruleIndex = transition.ruleIndex;
                    let actionIndex = transition.actionIndex;
                    let lexerAction = new $RgRAX.LexerCustomAction(ruleIndex, actionIndex);
                    state.setTransition(i, new $gxlfY.ActionTransition(transition.target, ruleIndex, legacyLexerActions.length, false));
                    legacyLexerActions.push(lexerAction);
                }
                atn.lexerActions = legacyLexerActions;
            }
        }
        this.markPrecedenceDecisions(atn);
        atn.decisionToDFA = new Array(ndecisions);
        for(let i = 0; i < ndecisions; i++)atn.decisionToDFA[i] = new $jJRyp.DFA(atn.decisionToState[i], i);
        if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
        if (this.deserializationOptions.isGenerateRuleBypassTransitions && atn.grammarType === 1 /* PARSER */ ) {
            atn.ruleToTokenType = new Int32Array(atn.ruleToStartState.length);
            for(let i = 0; i < atn.ruleToStartState.length; i++)atn.ruleToTokenType[i] = atn.maxTokenType + i + 1;
            for(let i = 0; i < atn.ruleToStartState.length; i++){
                let bypassStart = new $gAm9p.BasicBlockStartState();
                bypassStart.ruleIndex = i;
                atn.addState(bypassStart);
                let bypassStop = new $loKp0.BlockEndState();
                bypassStop.ruleIndex = i;
                atn.addState(bypassStop);
                bypassStart.endState = bypassStop;
                atn.defineDecisionState(bypassStart);
                bypassStop.startState = bypassStart;
                let endState;
                let excludeTransition;
                if (atn.ruleToStartState[i].isPrecedenceRule) {
                    // wrap from the beginning of the rule to the StarLoopEntryState
                    endState = undefined;
                    for (let state of atn.states){
                        if (state.ruleIndex !== i) continue;
                        if (!(state instanceof $f9raX.StarLoopEntryState)) continue;
                        let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                        if (!(maybeLoopEndState instanceof $kfqEk.LoopEndState)) continue;
                        if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $4kGBm.RuleStopState) {
                            endState = state;
                            break;
                        }
                    }
                    if (!endState) throw new Error("Couldn't identify final state of the precedence rule prefix section.");
                    excludeTransition = endState.loopBackState.transition(0);
                } else endState = atn.ruleToStopState[i];
                // all non-excluded transitions that currently target end state need to target blockEnd instead
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (transition === excludeTransition) continue;
                    if (transition.target === endState) transition.target = bypassStop;
                }
                // all transitions leaving the rule start state need to leave blockStart instead
                while(atn.ruleToStartState[i].numberOfTransitions > 0){
                    let transition = atn.ruleToStartState[i].removeTransition(atn.ruleToStartState[i].numberOfTransitions - 1);
                    bypassStart.addTransition(transition);
                }
                // link the new states
                atn.ruleToStartState[i].addTransition(new $bpnRH.EpsilonTransition(bypassStart));
                bypassStop.addTransition(new $bpnRH.EpsilonTransition(endState));
                let matchState = new $4yiuQ.BasicState();
                atn.addState(matchState);
                matchState.addTransition(new $5r7n7.AtomTransition(bypassStop, atn.ruleToTokenType[i]));
                bypassStart.addTransition(new $bpnRH.EpsilonTransition(matchState));
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        if (this.deserializationOptions.isOptimize) {
            while(true){
                let optimizationCount = 0;
                optimizationCount += $9d4aef733dce84f9$var$ATNDeserializer.inlineSetRules(atn);
                optimizationCount += $9d4aef733dce84f9$var$ATNDeserializer.combineChainedEpsilons(atn);
                let preserveOrder = atn.grammarType === 0 /* LEXER */ ;
                optimizationCount += $9d4aef733dce84f9$var$ATNDeserializer.optimizeSets(atn, preserveOrder);
                if (optimizationCount === 0) break;
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        $9d4aef733dce84f9$var$ATNDeserializer.identifyTailCalls(atn);
        return atn;
    }
    deserializeSets(data, p, sets, unicodeDeserializer) {
        let nsets = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nsets; i++){
            let nintervals = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p]);
            p++;
            let set = new $hGRod.IntervalSet();
            sets.push(set);
            let containsEof = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]) !== 0;
            if (containsEof) set.add(-1);
            for(let j = 0; j < nintervals; j++){
                let a = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                let b = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                set.add(a, b);
            }
        }
        return p;
    }
    /**
     * Analyze the {@link StarLoopEntryState} states in the specified ATN to set
     * the {@link StarLoopEntryState#precedenceRuleDecision} field to the
     * correct value.
     *
     * @param atn The ATN.
     */ markPrecedenceDecisions(atn) {
        // Map rule index -> precedence decision for that rule
        let rulePrecedenceDecisions = new Map();
        for (let state of atn.states){
            if (!(state instanceof $f9raX.StarLoopEntryState)) continue;
            /* We analyze the ATN to determine if this ATN decision state is the
             * decision for the closure block that determines whether a
             * precedence rule should continue or complete.
             */ if (atn.ruleToStartState[state.ruleIndex].isPrecedenceRule) {
                let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                if (maybeLoopEndState instanceof $kfqEk.LoopEndState) {
                    if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $4kGBm.RuleStopState) {
                        rulePrecedenceDecisions.set(state.ruleIndex, state);
                        state.precedenceRuleDecision = true;
                        state.precedenceLoopbackStates = new $5BPMp.BitSet(atn.states.length);
                    }
                }
            }
        }
        // After marking precedence decisions, we go back through and fill in
        // StarLoopEntryState.precedenceLoopbackStates.
        for (let precedenceDecision of rulePrecedenceDecisions)for (let transition of atn.ruleToStopState[precedenceDecision[0]].getTransitions()){
            if (transition.serializationType !== 1 /* EPSILON */ ) continue;
            let epsilonTransition = transition;
            if (epsilonTransition.outermostPrecedenceReturn !== -1) continue;
            precedenceDecision[1].precedenceLoopbackStates.set(transition.target.stateNumber);
        }
    }
    verifyATN(atn) {
        // verify assumptions
        for (let state of atn.states){
            this.checkCondition(state !== undefined, "ATN states should not be undefined.");
            if (state.stateType === $1bs3X.ATNStateType.INVALID_TYPE) continue;
            this.checkCondition(state.onlyHasEpsilonTransitions || state.numberOfTransitions <= 1);
            if (state instanceof $d1V7w.PlusBlockStartState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $f9raX.StarLoopEntryState) {
                let starLoopEntryState = state;
                this.checkCondition(starLoopEntryState.loopBackState !== undefined);
                this.checkCondition(starLoopEntryState.numberOfTransitions === 2);
                if (starLoopEntryState.transition(0).target instanceof $jEsaF.StarBlockStartState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $kfqEk.LoopEndState);
                    this.checkCondition(!starLoopEntryState.nonGreedy);
                } else if (starLoopEntryState.transition(0).target instanceof $kfqEk.LoopEndState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $jEsaF.StarBlockStartState);
                    this.checkCondition(starLoopEntryState.nonGreedy);
                } else throw new Error("IllegalStateException");
            }
            if (state instanceof $bjwd1.StarLoopbackState) {
                this.checkCondition(state.numberOfTransitions === 1);
                this.checkCondition(state.transition(0).target instanceof $f9raX.StarLoopEntryState);
            }
            if (state instanceof $kfqEk.LoopEndState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $j2zc8.RuleStartState) this.checkCondition(state.stopState !== undefined);
            if (state instanceof $65vNG.BlockStartState) this.checkCondition(state.endState !== undefined);
            if (state instanceof $loKp0.BlockEndState) this.checkCondition(state.startState !== undefined);
            if (state instanceof $dPYn6.DecisionState) {
                let decisionState = state;
                this.checkCondition(decisionState.numberOfTransitions <= 1 || decisionState.decision >= 0);
            } else this.checkCondition(state.numberOfTransitions <= 1 || state instanceof $4kGBm.RuleStopState);
        }
    }
    checkCondition(condition, message) {
        if (!condition) throw new Error("IllegalStateException: " + message);
    }
    static inlineSetRules(atn) {
        let inlinedCalls = 0;
        let ruleToInlineTransition = new Array(atn.ruleToStartState.length);
        for(let i = 0; i < atn.ruleToStartState.length; i++){
            let startState = atn.ruleToStartState[i];
            let middleState = startState;
            while(middleState.onlyHasEpsilonTransitions && middleState.numberOfOptimizedTransitions === 1 && middleState.getOptimizedTransition(0).serializationType === 1 /* EPSILON */ )middleState = middleState.getOptimizedTransition(0).target;
            if (middleState.numberOfOptimizedTransitions !== 1) continue;
            let matchTransition = middleState.getOptimizedTransition(0);
            let matchTarget = matchTransition.target;
            if (matchTransition.isEpsilon || !matchTarget.onlyHasEpsilonTransitions || matchTarget.numberOfOptimizedTransitions !== 1 || !(matchTarget.getOptimizedTransition(0).target instanceof $4kGBm.RuleStopState)) continue;
            switch(matchTransition.serializationType){
                case 5 /* ATOM */ :
                case 2 /* RANGE */ :
                case 7 /* SET */ :
                    ruleToInlineTransition[i] = matchTransition;
                    break;
                case 8 /* NOT_SET */ :
                case 9 /* WILDCARD */ :
                    continue;
                default:
                    continue;
            }
        }
        for (let state of atn.states){
            if (state.ruleIndex < 0) continue;
            let optimizedTransitions;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $aybFP.RuleTransition)) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                let ruleTransition = transition;
                let effective = ruleToInlineTransition[ruleTransition.target.ruleIndex];
                if (effective === undefined) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(i));
                }
                inlinedCalls++;
                let target = ruleTransition.followState;
                let intermediateState = new $4yiuQ.BasicState();
                intermediateState.setRuleIndex(target.ruleIndex);
                atn.addState(intermediateState);
                optimizedTransitions.push(new $bpnRH.EpsilonTransition(intermediateState));
                switch(effective.serializationType){
                    case 5 /* ATOM */ :
                        intermediateState.addTransition(new $5r7n7.AtomTransition(target, effective._label));
                        break;
                    case 2 /* RANGE */ :
                        intermediateState.addTransition(new $aISkF.RangeTransition(target, effective.from, effective.to));
                        break;
                    case 7 /* SET */ :
                        intermediateState.addTransition(new $Np2R3.SetTransition(target, effective.label));
                        break;
                    default:
                        throw new Error("UnsupportedOperationException");
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($kzbnL.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + inlinedCalls + " rule invocations by inlining sets.");
        return inlinedCalls;
    }
    static combineChainedEpsilons(atn) {
        let removedEdges = 0;
        for (let state of atn.states){
            if (!state.onlyHasEpsilonTransitions || state instanceof $4kGBm.RuleStopState) continue;
            let optimizedTransitions;
            nextTransition: for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                let intermediate = transition.target;
                if (transition.serializationType !== 1 /* EPSILON */  || transition.outermostPrecedenceReturn !== -1 || intermediate.stateType !== $1bs3X.ATNStateType.BASIC || !intermediate.onlyHasEpsilonTransitions) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++)if (intermediate.getOptimizedTransition(j).serializationType !== 1 /* EPSILON */  || intermediate.getOptimizedTransition(j).outermostPrecedenceReturn !== -1) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                removedEdges++;
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(j));
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++){
                    let target = intermediate.getOptimizedTransition(j).target;
                    optimizedTransitions.push(new $bpnRH.EpsilonTransition(target));
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($kzbnL.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedEdges + " transitions by combining chained epsilon transitions.");
        return removedEdges;
    }
    static optimizeSets(atn, preserveOrder) {
        if (preserveOrder) // this optimization currently doesn't preserve edge order.
        return 0;
        let removedPaths = 0;
        let decisions = atn.decisionToState;
        for (let decision of decisions){
            let setTransitions = new $hGRod.IntervalSet();
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++){
                let epsTransition = decision.getOptimizedTransition(i);
                if (!(epsTransition instanceof $bpnRH.EpsilonTransition)) continue;
                if (epsTransition.target.numberOfOptimizedTransitions !== 1) continue;
                let transition = epsTransition.target.getOptimizedTransition(0);
                if (!(transition.target instanceof $loKp0.BlockEndState)) continue;
                if (transition instanceof $FLEKS.NotSetTransition) continue;
                if (transition instanceof $5r7n7.AtomTransition || transition instanceof $aISkF.RangeTransition || transition instanceof $Np2R3.SetTransition) setTransitions.add(i);
            }
            if (setTransitions.size <= 1) continue;
            let optimizedTransitions = [];
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++)if (!setTransitions.contains(i)) optimizedTransitions.push(decision.getOptimizedTransition(i));
            let blockEndState = decision.getOptimizedTransition(setTransitions.minElement).target.getOptimizedTransition(0).target;
            let matchSet = new $hGRod.IntervalSet();
            for (let interval of setTransitions.intervals)for(let j = interval.a; j <= interval.b; j++){
                let matchTransition = decision.getOptimizedTransition(j).target.getOptimizedTransition(0);
                if (matchTransition instanceof $FLEKS.NotSetTransition) throw new Error("Not yet implemented.");
                else matchSet.addAll(matchTransition.label);
            }
            let newTransition;
            if (matchSet.intervals.length === 1) {
                if (matchSet.size === 1) newTransition = new $5r7n7.AtomTransition(blockEndState, matchSet.minElement);
                else {
                    let matchInterval = matchSet.intervals[0];
                    newTransition = new $aISkF.RangeTransition(blockEndState, matchInterval.a, matchInterval.b);
                }
            } else newTransition = new $Np2R3.SetTransition(blockEndState, matchSet);
            let setOptimizedState = new $4yiuQ.BasicState();
            setOptimizedState.setRuleIndex(decision.ruleIndex);
            atn.addState(setOptimizedState);
            setOptimizedState.addTransition(newTransition);
            optimizedTransitions.push(new $bpnRH.EpsilonTransition(setOptimizedState));
            removedPaths += decision.numberOfOptimizedTransitions - optimizedTransitions.length;
            if (decision.isOptimized) while(decision.numberOfOptimizedTransitions > 0)decision.removeOptimizedTransition(decision.numberOfOptimizedTransitions - 1);
            for (let transition of optimizedTransitions)decision.addOptimizedTransition(transition);
        }
        if ($kzbnL.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedPaths + " paths by collapsing sets.");
        return removedPaths;
    }
    static identifyTailCalls(atn) {
        for (let state of atn.states){
            for(let i = 0; i < state.numberOfTransitions; i++){
                let transition = state.transition(i);
                if (!(transition instanceof $aybFP.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
            if (!state.isOptimized) continue;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $aybFP.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
        }
    }
    static testTailCall(atn, transition, optimizedPath) {
        if (!optimizedPath && transition.tailCall) return true;
        if (optimizedPath && transition.optimizedTailCall) return true;
        let reachable = new $5BPMp.BitSet(atn.states.length);
        let worklist = [];
        worklist.push(transition.followState);
        while(true){
            let state = worklist.pop();
            if (!state) break;
            if (reachable.get(state.stateNumber)) continue;
            if (state instanceof $4kGBm.RuleStopState) continue;
            if (!state.onlyHasEpsilonTransitions) return false;
            let transitionCount = optimizedPath ? state.numberOfOptimizedTransitions : state.numberOfTransitions;
            for(let i = 0; i < transitionCount; i++){
                let t = optimizedPath ? state.getOptimizedTransition(i) : state.transition(i);
                if (t.serializationType !== 1 /* EPSILON */ ) return false;
                worklist.push(t.target);
            }
        }
        return true;
    }
    static toInt(c) {
        return c;
    }
    static toInt32(data, offset) {
        return (data[offset] | data[offset + 1] << 16) >>> 0;
    }
    static toUUID(data, offset) {
        let leastSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset);
        let lessSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset + 2);
        let moreSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset + 4);
        let mostSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset + 6);
        return new $kWxOc.UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    edgeFactory(atn, type, src, trg, arg1, arg2, arg3, sets) {
        let target = atn.states[trg];
        switch(type){
            case 1 /* EPSILON */ :
                return new $bpnRH.EpsilonTransition(target);
            case 2 /* RANGE */ :
                if (arg3 !== 0) return new $aISkF.RangeTransition(target, $2DVsz.Token.EOF, arg2);
                else return new $aISkF.RangeTransition(target, arg1, arg2);
            case 3 /* RULE */ :
                let rt = new $aybFP.RuleTransition(atn.states[arg1], arg2, arg3, target);
                return rt;
            case 4 /* PREDICATE */ :
                let pt = new $hnaRv.PredicateTransition(target, arg1, arg2, arg3 !== 0);
                return pt;
            case 10 /* PRECEDENCE */ :
                return new $7KGEQ.PrecedencePredicateTransition(target, arg1);
            case 5 /* ATOM */ :
                if (arg3 !== 0) return new $5r7n7.AtomTransition(target, $2DVsz.Token.EOF);
                else return new $5r7n7.AtomTransition(target, arg1);
            case 6 /* ACTION */ :
                let a = new $gxlfY.ActionTransition(target, arg1, arg2, arg3 !== 0);
                return a;
            case 7 /* SET */ :
                return new $Np2R3.SetTransition(target, sets[arg1]);
            case 8 /* NOT_SET */ :
                return new $FLEKS.NotSetTransition(target, sets[arg1]);
            case 9 /* WILDCARD */ :
                return new $aPmi9.WildcardTransition(target);
        }
        throw new Error("The specified transition type is not valid.");
    }
    stateFactory(type, ruleIndex) {
        let s;
        switch(type){
            case $1bs3X.ATNStateType.INVALID_TYPE:
                return new $l4Nh1.InvalidState();
            case $1bs3X.ATNStateType.BASIC:
                s = new $4yiuQ.BasicState();
                break;
            case $1bs3X.ATNStateType.RULE_START:
                s = new $j2zc8.RuleStartState();
                break;
            case $1bs3X.ATNStateType.BLOCK_START:
                s = new $gAm9p.BasicBlockStartState();
                break;
            case $1bs3X.ATNStateType.PLUS_BLOCK_START:
                s = new $d1V7w.PlusBlockStartState();
                break;
            case $1bs3X.ATNStateType.STAR_BLOCK_START:
                s = new $jEsaF.StarBlockStartState();
                break;
            case $1bs3X.ATNStateType.TOKEN_START:
                s = new $WS4d7.TokensStartState();
                break;
            case $1bs3X.ATNStateType.RULE_STOP:
                s = new $4kGBm.RuleStopState();
                break;
            case $1bs3X.ATNStateType.BLOCK_END:
                s = new $loKp0.BlockEndState();
                break;
            case $1bs3X.ATNStateType.STAR_LOOP_BACK:
                s = new $bjwd1.StarLoopbackState();
                break;
            case $1bs3X.ATNStateType.STAR_LOOP_ENTRY:
                s = new $f9raX.StarLoopEntryState();
                break;
            case $1bs3X.ATNStateType.PLUS_LOOP_BACK:
                s = new $7qlbM.PlusLoopbackState();
                break;
            case $1bs3X.ATNStateType.LOOP_END:
                s = new $kfqEk.LoopEndState();
                break;
            default:
                let message = `The specified state type ${type} is not valid.`;
                throw new Error(message);
        }
        s.ruleIndex = ruleIndex;
        return s;
    }
    lexerActionFactory(type, data1, data2) {
        switch(type){
            case 0 /* CHANNEL */ :
                return new $iw4Ko.LexerChannelAction(data1);
            case 1 /* CUSTOM */ :
                return new $RgRAX.LexerCustomAction(data1, data2);
            case 2 /* MODE */ :
                return new $jgJtt.LexerModeAction(data1);
            case 3 /* MORE */ :
                return $l606e.LexerMoreAction.INSTANCE;
            case 4 /* POP_MODE */ :
                return $6hIs4.LexerPopModeAction.INSTANCE;
            case 5 /* PUSH_MODE */ :
                return new $a9nIX.LexerPushModeAction(data1);
            case 6 /* SKIP */ :
                return $2Gb96.LexerSkipAction.INSTANCE;
            case 7 /* TYPE */ :
                return new $ayRdK.LexerTypeAction(data1);
            default:
                let message = `The specified lexer action type ${type} is not valid.`;
                throw new Error(message);
        }
    }
}
/* WARNING: DO NOT MERGE THESE LINES. If UUIDs differ during a merge,
 * resolve the conflict by generating a new ID!
 */ /**
 * This is the earliest supported serialized UUID.
 */ $9d4aef733dce84f9$var$ATNDeserializer.BASE_SERIALIZED_UUID = $kWxOc.UUID.fromString("E4178468-DF95-44D0-AD87-F22A5D5FB6D3");
/**
 * This UUID indicates an extension of {@link #ADDED_PRECEDENCE_TRANSITIONS}
 * for the addition of lexer actions encoded as a sequence of
 * {@link LexerAction} instances.
 */ $9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS = $kWxOc.UUID.fromString("AB35191A-1603-487E-B75A-479B831EAF6D");
/**
 * This UUID indicates the serialized ATN contains two sets of
 * IntervalSets, where the second set's values are encoded as
 * 32-bit integers to support the full Unicode SMP range up to U+10FFFF.
 */ $9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP = $kWxOc.UUID.fromString("C23FEA89-0605-4f51-AFB8-058BCAB8C91B");
/**
 * This list contains all of the currently supported UUIDs, ordered by when
 * the feature first appeared in this branch.
 */ $9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS = [
    $9d4aef733dce84f9$var$ATNDeserializer.BASE_SERIALIZED_UUID,
    $9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS,
    $9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP
];
/**
 * This is the current serialized UUID.
 */ $9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_UUID = $9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP;
$9d4aef733dce84f9$var$__decorate([
    $d6D31.NotNull
], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "deserializationOptions", void 0);
$9d4aef733dce84f9$var$__decorate([
    $9d4aef733dce84f9$var$__param(0, $d6D31.NotNull)
], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "deserialize", null);
$9d4aef733dce84f9$var$__decorate([
    $9d4aef733dce84f9$var$__param(0, $d6D31.NotNull)
], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "markPrecedenceDecisions", null);
$9d4aef733dce84f9$var$__decorate([
    $d6D31.NotNull,
    $9d4aef733dce84f9$var$__param(0, $d6D31.NotNull)
], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "edgeFactory", null);
module.exports.ATNDeserializer = $9d4aef733dce84f9$var$ATNDeserializer;

});
parcelRegister("gxlfY", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c0a0378a1b984eee$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c0a0378a1b984eee$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionTransition = void 0;

var $d6D31 = parcelRequire("d6D31");

var $5tcOQ = parcelRequire("5tcOQ");
let $c0a0378a1b984eee$var$ActionTransition = class ActionTransition extends $5tcOQ.Transition {
    constructor(target, ruleIndex, actionIndex = -1, isCtxDependent = false){
        super(target);
        this.ruleIndex = ruleIndex;
        this.actionIndex = actionIndex;
        this.isCtxDependent = isCtxDependent;
    }
    get serializationType() {
        return 6 /* ACTION */ ;
    }
    get isEpsilon() {
        return true; // we are to be ignored by analysis 'cept for predicates
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "action_" + this.ruleIndex + ":" + this.actionIndex;
    }
};
$c0a0378a1b984eee$var$__decorate([
    $d6D31.Override
], $c0a0378a1b984eee$var$ActionTransition.prototype, "serializationType", null);
$c0a0378a1b984eee$var$__decorate([
    $d6D31.Override
], $c0a0378a1b984eee$var$ActionTransition.prototype, "isEpsilon", null);
$c0a0378a1b984eee$var$__decorate([
    $d6D31.Override
], $c0a0378a1b984eee$var$ActionTransition.prototype, "matches", null);
$c0a0378a1b984eee$var$__decorate([
    $d6D31.Override
], $c0a0378a1b984eee$var$ActionTransition.prototype, "toString", null);
$c0a0378a1b984eee$var$ActionTransition = $c0a0378a1b984eee$var$__decorate([
    $c0a0378a1b984eee$var$__param(0, $d6D31.NotNull)
], $c0a0378a1b984eee$var$ActionTransition);
module.exports.ActionTransition = $c0a0378a1b984eee$var$ActionTransition;

});

parcelRegister("5r7n7", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $010580cb6b5878c3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $010580cb6b5878c3$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AtomTransition = void 0;

var $hGRod = parcelRequire("hGRod");

var $d6D31 = parcelRequire("d6D31");

var $5tcOQ = parcelRequire("5tcOQ");
/** TODO: make all transitions sets? no, should remove set edges */ let $010580cb6b5878c3$var$AtomTransition = class AtomTransition extends $5tcOQ.Transition {
    constructor(target, label){
        super(target);
        this._label = label;
    }
    get serializationType() {
        return 5 /* ATOM */ ;
    }
    get label() {
        return $hGRod.IntervalSet.of(this._label);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this._label === symbol;
    }
    toString() {
        return String(this.label);
    }
};
$010580cb6b5878c3$var$__decorate([
    $d6D31.Override
], $010580cb6b5878c3$var$AtomTransition.prototype, "serializationType", null);
$010580cb6b5878c3$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $010580cb6b5878c3$var$AtomTransition.prototype, "label", null);
$010580cb6b5878c3$var$__decorate([
    $d6D31.Override
], $010580cb6b5878c3$var$AtomTransition.prototype, "matches", null);
$010580cb6b5878c3$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $010580cb6b5878c3$var$AtomTransition.prototype, "toString", null);
$010580cb6b5878c3$var$AtomTransition = $010580cb6b5878c3$var$__decorate([
    $010580cb6b5878c3$var$__param(0, $d6D31.NotNull)
], $010580cb6b5878c3$var$AtomTransition);
module.exports.AtomTransition = $010580cb6b5878c3$var$AtomTransition;

});

parcelRegister("gAm9p", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c13130ce46eb4f6a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicBlockStartState = void 0;

var $1bs3X = parcelRequire("1bs3X");

var $65vNG = parcelRequire("65vNG");

var $d6D31 = parcelRequire("d6D31");
/**
 *
 * @author Sam Harwell
 */ class $c13130ce46eb4f6a$var$BasicBlockStartState extends $65vNG.BlockStartState {
    get stateType() {
        return $1bs3X.ATNStateType.BLOCK_START;
    }
}
$c13130ce46eb4f6a$var$__decorate([
    $d6D31.Override
], $c13130ce46eb4f6a$var$BasicBlockStartState.prototype, "stateType", null);
module.exports.BasicBlockStartState = $c13130ce46eb4f6a$var$BasicBlockStartState;

});
parcelRegister("65vNG", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockStartState = void 0;

var $dPYn6 = parcelRequire("dPYn6");
/**  The start of a regular `(...)` block. */ class $46ebe09d19265106$var$BlockStartState extends $dPYn6.DecisionState {
}
module.exports.BlockStartState = $46ebe09d19265106$var$BlockStartState;

});


parcelRegister("loKp0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f93fd5601d243552$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockEndState = void 0;

var $7j0Pc = parcelRequire("7j0Pc");

var $1bs3X = parcelRequire("1bs3X");

var $d6D31 = parcelRequire("d6D31");
/** Terminal node of a simple `(a|b|c)` block. */ class $f93fd5601d243552$var$BlockEndState extends $7j0Pc.ATNState {
    get stateType() {
        return $1bs3X.ATNStateType.BLOCK_END;
    }
}
$f93fd5601d243552$var$__decorate([
    $d6D31.Override
], $f93fd5601d243552$var$BlockEndState.prototype, "stateType", null);
module.exports.BlockEndState = $f93fd5601d243552$var$BlockEndState;

});

parcelRegister("bpnRH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $84e48a9cb4812173$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $84e48a9cb4812173$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EpsilonTransition = void 0;

var $d6D31 = parcelRequire("d6D31");

var $5tcOQ = parcelRequire("5tcOQ");
let $84e48a9cb4812173$var$EpsilonTransition = class EpsilonTransition extends $5tcOQ.Transition {
    constructor(target, outermostPrecedenceReturn = -1){
        super(target);
        this._outermostPrecedenceReturn = outermostPrecedenceReturn;
    }
    /**
     * @returns the rule index of a precedence rule for which this transition is
     * returning from, where the precedence value is 0; otherwise, -1.
     *
     * @see ATNConfig.isPrecedenceFilterSuppressed
     * @see ParserATNSimulator#applyPrecedenceFilter(ATNConfigSet, ParserRuleContext, PredictionContextCache)
     * @since 4.4.1
     */ get outermostPrecedenceReturn() {
        return this._outermostPrecedenceReturn;
    }
    get serializationType() {
        return 1 /* EPSILON */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "epsilon";
    }
};
$84e48a9cb4812173$var$__decorate([
    $d6D31.Override
], $84e48a9cb4812173$var$EpsilonTransition.prototype, "serializationType", null);
$84e48a9cb4812173$var$__decorate([
    $d6D31.Override
], $84e48a9cb4812173$var$EpsilonTransition.prototype, "isEpsilon", null);
$84e48a9cb4812173$var$__decorate([
    $d6D31.Override
], $84e48a9cb4812173$var$EpsilonTransition.prototype, "matches", null);
$84e48a9cb4812173$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $84e48a9cb4812173$var$EpsilonTransition.prototype, "toString", null);
$84e48a9cb4812173$var$EpsilonTransition = $84e48a9cb4812173$var$__decorate([
    $84e48a9cb4812173$var$__param(0, $d6D31.NotNull)
], $84e48a9cb4812173$var$EpsilonTransition);
module.exports.EpsilonTransition = $84e48a9cb4812173$var$EpsilonTransition;

});

parcelRegister("iw4Ko", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d7aee5df2113a2bc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d7aee5df2113a2bc$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerChannelAction = void 0;

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * Implements the `channel` lexer action by calling
 * {@link Lexer#setChannel} with the assigned channel.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $d7aee5df2113a2bc$var$LexerChannelAction {
    /**
     * Constructs a new `channel` action with the specified channel value.
     * @param channel The channel value to pass to {@link Lexer#setChannel}.
     */ constructor(channel){
        this._channel = channel;
    }
    /**
     * Gets the channel to use for the {@link Token} created by the lexer.
     *
     * @returns The channel to use for the {@link Token} created by the lexer.
     */ get channel() {
        return this._channel;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#CHANNEL}.
     */ get actionType() {
        return 0 /* CHANNEL */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#setChannel} with the
     * value provided by {@link #getChannel}.
     */ execute(lexer) {
        lexer.channel = this._channel;
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        hash = $iXFjm.MurmurHash.update(hash, this.actionType);
        hash = $iXFjm.MurmurHash.update(hash, this._channel);
        return $iXFjm.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $d7aee5df2113a2bc$var$LexerChannelAction)) return false;
        return this._channel === obj._channel;
    }
    toString() {
        return `channel(${this._channel})`;
    }
}
$d7aee5df2113a2bc$var$__decorate([
    $d6D31.Override
], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "actionType", null);
$d7aee5df2113a2bc$var$__decorate([
    $d6D31.Override
], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "isPositionDependent", null);
$d7aee5df2113a2bc$var$__decorate([
    $d6D31.Override,
    $d7aee5df2113a2bc$var$__param(0, $d6D31.NotNull)
], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "execute", null);
$d7aee5df2113a2bc$var$__decorate([
    $d6D31.Override
], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "hashCode", null);
$d7aee5df2113a2bc$var$__decorate([
    $d6D31.Override
], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "equals", null);
$d7aee5df2113a2bc$var$__decorate([
    $d6D31.Override
], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "toString", null);
module.exports.LexerChannelAction = $d7aee5df2113a2bc$var$LexerChannelAction;

});

parcelRegister("RgRAX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0a0208144418eb04$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0a0208144418eb04$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerCustomAction = void 0;

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * Executes a custom lexer action by calling {@link Recognizer#action} with the
 * rule and action indexes assigned to the custom action. The implementation of
 * a custom action is added to the generated code for the lexer in an override
 * of {@link Recognizer#action} when the grammar is compiled.
 *
 * This class may represent embedded actions created with the `{...}`
 * syntax in ANTLR 4, as well as actions created for lexer commands where the
 * command argument could not be evaluated when the grammar was compiled.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $0a0208144418eb04$var$LexerCustomAction {
    /**
     * Constructs a custom lexer action with the specified rule and action
     * indexes.
     *
     * @param ruleIndex The rule index to use for calls to
     * {@link Recognizer#action}.
     * @param actionIndex The action index to use for calls to
     * {@link Recognizer#action}.
     */ constructor(ruleIndex, actionIndex){
        this._ruleIndex = ruleIndex;
        this._actionIndex = actionIndex;
    }
    /**
     * Gets the rule index to use for calls to {@link Recognizer#action}.
     *
     * @returns The rule index for the custom action.
     */ get ruleIndex() {
        return this._ruleIndex;
    }
    /**
     * Gets the action index to use for calls to {@link Recognizer#action}.
     *
     * @returns The action index for the custom action.
     */ get actionIndex() {
        return this._actionIndex;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns {@link LexerActionType#CUSTOM}.
     */ get actionType() {
        return 1 /* CUSTOM */ ;
    }
    /**
     * Gets whether the lexer action is position-dependent. Position-dependent
     * actions may have different semantics depending on the {@link CharStream}
     * index at the time the action is executed.
     *
     * Custom actions are position-dependent since they may represent a
     * user-defined embedded action which makes calls to methods like
     * {@link Lexer#getText}.
     *
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * Custom actions are implemented by calling {@link Lexer#action} with the
     * appropriate rule and action indexes.
     */ execute(lexer) {
        lexer.action(undefined, this._ruleIndex, this._actionIndex);
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        hash = $iXFjm.MurmurHash.update(hash, this.actionType);
        hash = $iXFjm.MurmurHash.update(hash, this._ruleIndex);
        hash = $iXFjm.MurmurHash.update(hash, this._actionIndex);
        return $iXFjm.MurmurHash.finish(hash, 3);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $0a0208144418eb04$var$LexerCustomAction)) return false;
        return this._ruleIndex === obj._ruleIndex && this._actionIndex === obj._actionIndex;
    }
}
$0a0208144418eb04$var$__decorate([
    $d6D31.Override
], $0a0208144418eb04$var$LexerCustomAction.prototype, "actionType", null);
$0a0208144418eb04$var$__decorate([
    $d6D31.Override
], $0a0208144418eb04$var$LexerCustomAction.prototype, "isPositionDependent", null);
$0a0208144418eb04$var$__decorate([
    $d6D31.Override,
    $0a0208144418eb04$var$__param(0, $d6D31.NotNull)
], $0a0208144418eb04$var$LexerCustomAction.prototype, "execute", null);
$0a0208144418eb04$var$__decorate([
    $d6D31.Override
], $0a0208144418eb04$var$LexerCustomAction.prototype, "hashCode", null);
$0a0208144418eb04$var$__decorate([
    $d6D31.Override
], $0a0208144418eb04$var$LexerCustomAction.prototype, "equals", null);
module.exports.LexerCustomAction = $0a0208144418eb04$var$LexerCustomAction;

});

parcelRegister("jgJtt", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e072c93b157fdb6e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e072c93b157fdb6e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerModeAction = void 0;

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * Implements the `mode` lexer action by calling {@link Lexer#mode} with
 * the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $e072c93b157fdb6e$var$LexerModeAction {
    /**
     * Constructs a new `mode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#mode}.
     */ constructor(mode){
        this._mode = mode;
    }
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `mode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MODE}.
     */ get actionType() {
        return 2 /* MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#mode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.mode(this._mode);
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        hash = $iXFjm.MurmurHash.update(hash, this.actionType);
        hash = $iXFjm.MurmurHash.update(hash, this._mode);
        return $iXFjm.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $e072c93b157fdb6e$var$LexerModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `mode(${this._mode})`;
    }
}
$e072c93b157fdb6e$var$__decorate([
    $d6D31.Override
], $e072c93b157fdb6e$var$LexerModeAction.prototype, "actionType", null);
$e072c93b157fdb6e$var$__decorate([
    $d6D31.Override
], $e072c93b157fdb6e$var$LexerModeAction.prototype, "isPositionDependent", null);
$e072c93b157fdb6e$var$__decorate([
    $d6D31.Override,
    $e072c93b157fdb6e$var$__param(0, $d6D31.NotNull)
], $e072c93b157fdb6e$var$LexerModeAction.prototype, "execute", null);
$e072c93b157fdb6e$var$__decorate([
    $d6D31.Override
], $e072c93b157fdb6e$var$LexerModeAction.prototype, "hashCode", null);
$e072c93b157fdb6e$var$__decorate([
    $d6D31.Override
], $e072c93b157fdb6e$var$LexerModeAction.prototype, "equals", null);
$e072c93b157fdb6e$var$__decorate([
    $d6D31.Override
], $e072c93b157fdb6e$var$LexerModeAction.prototype, "toString", null);
module.exports.LexerModeAction = $e072c93b157fdb6e$var$LexerModeAction;

});

parcelRegister("l606e", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f5ba3c4a18e49934$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f5ba3c4a18e49934$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerMoreAction = void 0;

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * Implements the `more` lexer action by calling {@link Lexer#more}.
 *
 * The `more` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $f5ba3c4a18e49934$var$LexerMoreAction {
    /**
     * Constructs the singleton instance of the lexer `more` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MORE}.
     */ get actionType() {
        return 3 /* MORE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#more}.
     */ execute(lexer) {
        lexer.more();
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        hash = $iXFjm.MurmurHash.update(hash, this.actionType);
        return $iXFjm.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "more";
    }
}
$f5ba3c4a18e49934$var$__decorate([
    $d6D31.Override
], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "actionType", null);
$f5ba3c4a18e49934$var$__decorate([
    $d6D31.Override
], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "isPositionDependent", null);
$f5ba3c4a18e49934$var$__decorate([
    $d6D31.Override,
    $f5ba3c4a18e49934$var$__param(0, $d6D31.NotNull)
], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "execute", null);
$f5ba3c4a18e49934$var$__decorate([
    $d6D31.Override
], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "hashCode", null);
$f5ba3c4a18e49934$var$__decorate([
    $d6D31.Override
], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "equals", null);
$f5ba3c4a18e49934$var$__decorate([
    $d6D31.Override
], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "toString", null);
module.exports.LexerMoreAction = $f5ba3c4a18e49934$var$LexerMoreAction;
(function(LexerMoreAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerMoreAction.INSTANCE = new LexerMoreAction();
})($f5ba3c4a18e49934$var$LexerMoreAction = module.exports.LexerMoreAction || (module.exports.LexerMoreAction = {}));

});

parcelRegister("6hIs4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4936cfc70a1820aa$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4936cfc70a1820aa$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPopModeAction = void 0;

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * Implements the `popMode` lexer action by calling {@link Lexer#popMode}.
 *
 * The `popMode` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $4936cfc70a1820aa$var$LexerPopModeAction {
    /**
     * Constructs the singleton instance of the lexer `popMode` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#POP_MODE}.
     */ get actionType() {
        return 4 /* POP_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#popMode}.
     */ execute(lexer) {
        lexer.popMode();
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        hash = $iXFjm.MurmurHash.update(hash, this.actionType);
        return $iXFjm.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "popMode";
    }
}
$4936cfc70a1820aa$var$__decorate([
    $d6D31.Override
], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "actionType", null);
$4936cfc70a1820aa$var$__decorate([
    $d6D31.Override
], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "isPositionDependent", null);
$4936cfc70a1820aa$var$__decorate([
    $d6D31.Override,
    $4936cfc70a1820aa$var$__param(0, $d6D31.NotNull)
], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "execute", null);
$4936cfc70a1820aa$var$__decorate([
    $d6D31.Override
], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "hashCode", null);
$4936cfc70a1820aa$var$__decorate([
    $d6D31.Override
], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "equals", null);
$4936cfc70a1820aa$var$__decorate([
    $d6D31.Override
], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "toString", null);
module.exports.LexerPopModeAction = $4936cfc70a1820aa$var$LexerPopModeAction;
(function(LexerPopModeAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerPopModeAction.INSTANCE = new LexerPopModeAction();
})($4936cfc70a1820aa$var$LexerPopModeAction = module.exports.LexerPopModeAction || (module.exports.LexerPopModeAction = {}));

});

parcelRegister("a9nIX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $763d25c4cd7cf3b5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $763d25c4cd7cf3b5$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPushModeAction = void 0;

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * Implements the `pushMode` lexer action by calling
 * {@link Lexer#pushMode} with the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $763d25c4cd7cf3b5$var$LexerPushModeAction {
    /**
     * Constructs a new `pushMode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#pushMode}.
     */ constructor(mode){
        this._mode = mode;
    }
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `pushMode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#PUSH_MODE}.
     */ get actionType() {
        return 5 /* PUSH_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#pushMode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.pushMode(this._mode);
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        hash = $iXFjm.MurmurHash.update(hash, this.actionType);
        hash = $iXFjm.MurmurHash.update(hash, this._mode);
        return $iXFjm.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $763d25c4cd7cf3b5$var$LexerPushModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `pushMode(${this._mode})`;
    }
}
$763d25c4cd7cf3b5$var$__decorate([
    $d6D31.Override
], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "actionType", null);
$763d25c4cd7cf3b5$var$__decorate([
    $d6D31.Override
], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "isPositionDependent", null);
$763d25c4cd7cf3b5$var$__decorate([
    $d6D31.Override,
    $763d25c4cd7cf3b5$var$__param(0, $d6D31.NotNull)
], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "execute", null);
$763d25c4cd7cf3b5$var$__decorate([
    $d6D31.Override
], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "hashCode", null);
$763d25c4cd7cf3b5$var$__decorate([
    $d6D31.Override
], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "equals", null);
$763d25c4cd7cf3b5$var$__decorate([
    $d6D31.Override
], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "toString", null);
module.exports.LexerPushModeAction = $763d25c4cd7cf3b5$var$LexerPushModeAction;

});

parcelRegister("2Gb96", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1f3826579173f858$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1f3826579173f858$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerSkipAction = void 0;

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * Implements the `skip` lexer action by calling {@link Lexer#skip}.
 *
 * The `skip` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $1f3826579173f858$var$LexerSkipAction {
    /**
     * Constructs the singleton instance of the lexer `skip` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#SKIP}.
     */ get actionType() {
        return 6 /* SKIP */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#skip}.
     */ execute(lexer) {
        lexer.skip();
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        hash = $iXFjm.MurmurHash.update(hash, this.actionType);
        return $iXFjm.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "skip";
    }
}
$1f3826579173f858$var$__decorate([
    $d6D31.Override
], $1f3826579173f858$var$LexerSkipAction.prototype, "actionType", null);
$1f3826579173f858$var$__decorate([
    $d6D31.Override
], $1f3826579173f858$var$LexerSkipAction.prototype, "isPositionDependent", null);
$1f3826579173f858$var$__decorate([
    $d6D31.Override,
    $1f3826579173f858$var$__param(0, $d6D31.NotNull)
], $1f3826579173f858$var$LexerSkipAction.prototype, "execute", null);
$1f3826579173f858$var$__decorate([
    $d6D31.Override
], $1f3826579173f858$var$LexerSkipAction.prototype, "hashCode", null);
$1f3826579173f858$var$__decorate([
    $d6D31.Override
], $1f3826579173f858$var$LexerSkipAction.prototype, "equals", null);
$1f3826579173f858$var$__decorate([
    $d6D31.Override
], $1f3826579173f858$var$LexerSkipAction.prototype, "toString", null);
module.exports.LexerSkipAction = $1f3826579173f858$var$LexerSkipAction;
(function(LexerSkipAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerSkipAction.INSTANCE = new LexerSkipAction();
})($1f3826579173f858$var$LexerSkipAction = module.exports.LexerSkipAction || (module.exports.LexerSkipAction = {}));

});

parcelRegister("ayRdK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7b065cdfc5f207e7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7b065cdfc5f207e7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerTypeAction = void 0;

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");
/**
 * Implements the `type` lexer action by setting `Lexer.type`
 * with the assigned type.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $7b065cdfc5f207e7$var$LexerTypeAction {
    /**
     * Constructs a new `type` action with the specified token type value.
     * @param type The type to assign to the token using `Lexer.type`.
     */ constructor(type){
        this._type = type;
    }
    /**
     * Gets the type to assign to a token created by the lexer.
     * @returns The type to assign to a token created by the lexer.
     */ get type() {
        return this._type;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#TYPE}.
     */ get actionType() {
        return 7 /* TYPE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by setting `Lexer.type` with the
     * value provided by `type`.
     */ execute(lexer) {
        lexer.type = this._type;
    }
    hashCode() {
        let hash = $iXFjm.MurmurHash.initialize();
        hash = $iXFjm.MurmurHash.update(hash, this.actionType);
        hash = $iXFjm.MurmurHash.update(hash, this._type);
        return $iXFjm.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $7b065cdfc5f207e7$var$LexerTypeAction)) return false;
        return this._type === obj._type;
    }
    toString() {
        return `type(${this._type})`;
    }
}
$7b065cdfc5f207e7$var$__decorate([
    $d6D31.Override
], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "actionType", null);
$7b065cdfc5f207e7$var$__decorate([
    $d6D31.Override
], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "isPositionDependent", null);
$7b065cdfc5f207e7$var$__decorate([
    $d6D31.Override,
    $7b065cdfc5f207e7$var$__param(0, $d6D31.NotNull)
], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "execute", null);
$7b065cdfc5f207e7$var$__decorate([
    $d6D31.Override
], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "hashCode", null);
$7b065cdfc5f207e7$var$__decorate([
    $d6D31.Override
], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "equals", null);
$7b065cdfc5f207e7$var$__decorate([
    $d6D31.Override
], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "toString", null);
module.exports.LexerTypeAction = $7b065cdfc5f207e7$var$LexerTypeAction;

});

parcelRegister("kfqEk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ebd9e16490628daf$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoopEndState = void 0;

var $7j0Pc = parcelRequire("7j0Pc");

var $1bs3X = parcelRequire("1bs3X");

var $d6D31 = parcelRequire("d6D31");
/** Mark the end of a * or + loop. */ class $ebd9e16490628daf$var$LoopEndState extends $7j0Pc.ATNState {
    get stateType() {
        return $1bs3X.ATNStateType.LOOP_END;
    }
}
$ebd9e16490628daf$var$__decorate([
    $d6D31.Override
], $ebd9e16490628daf$var$LoopEndState.prototype, "stateType", null);
module.exports.LoopEndState = $ebd9e16490628daf$var$LoopEndState;

});

parcelRegister("kzbnL", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ef8fe7d2bd819f1c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ef8fe7d2bd819f1c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserATNSimulator = void 0;

var $41NTU = parcelRequire("41NTU");

var $gxlfY = parcelRequire("gxlfY");

var $7Veax = parcelRequire("7Veax");

var $9yG1X = parcelRequire("9yG1X");

var $bcnvE = parcelRequire("bcnvE");

var $gcX0f = parcelRequire("gcX0f");

var $c1ClW = parcelRequire("c1ClW");

var $kr9A1 = parcelRequire("kr9A1");

var $1bs3X = parcelRequire("1bs3X");

var $5r7n7 = parcelRequire("5r7n7");

var $5BPMp = parcelRequire("5BPMp");

var $gsRaX = parcelRequire("gsRaX");

var $dPYn6 = parcelRequire("dPYn6");

var $2jevZ = parcelRequire("2jevZ");

var $37SGk = parcelRequire("37SGk");

var $gcfUE = parcelRequire("gcfUE");

var $ceaEj = parcelRequire("ceaEj");

var $d6D31 = parcelRequire("d6D31");

var $FLEKS = parcelRequire("FLEKS");

var $hKCjP = parcelRequire("hKCjP");

var $a4Flx = parcelRequire("a4Flx");

var $6bmaO = parcelRequire("6bmaO");

var $8DTT0 = parcelRequire("8DTT0");

var $6vF7J = parcelRequire("6vF7J");

var $gDZVV = parcelRequire("gDZVV");

var $4kGBm = parcelRequire("4kGBm");

var $aybFP = parcelRequire("aybFP");

var $eHMgW = parcelRequire("eHMgW");

var $Np2R3 = parcelRequire("Np2R3");

var $g7SCF = parcelRequire("g7SCF");

var $2DVsz = parcelRequire("2DVsz");

var $3n2FE = parcelRequire("3n2FE");

var $bbHFU = parcelRequire("bbHFU");
const $ef8fe7d2bd819f1c$var$MAX_SHORT_VALUE = 0xFFFF;
const $ef8fe7d2bd819f1c$var$MIN_INTEGER_VALUE = -2147483648;
/**
 * The embodiment of the adaptive LL(*), ALL(*), parsing strategy.
 *
 * The basic complexity of the adaptive strategy makes it harder to understand.
 * We begin with ATN simulation to build paths in a DFA. Subsequent prediction
 * requests go through the DFA first. If they reach a state without an edge for
 * the current symbol, the algorithm fails over to the ATN simulation to
 * complete the DFA path for the current input (until it finds a conflict state
 * or uniquely predicting state).
 *
 * All of that is done without using the outer context because we want to create
 * a DFA that is not dependent upon the rule invocation stack when we do a
 * prediction. One DFA works in all contexts. We avoid using context not
 * necessarily because it's slower, although it can be, but because of the DFA
 * caching problem. The closure routine only considers the rule invocation stack
 * created during prediction beginning in the decision rule. For example, if
 * prediction occurs without invoking another rule's ATN, there are no context
 * stacks in the configurations. When lack of context leads to a conflict, we
 * don't know if it's an ambiguity or a weakness in the strong LL(*) parsing
 * strategy (versus full LL(*)).
 *
 * When SLL yields a configuration set with conflict, we rewind the input and
 * retry the ATN simulation, this time using full outer context without adding
 * to the DFA. Configuration context stacks will be the full invocation stacks
 * from the start rule. If we get a conflict using full context, then we can
 * definitively say we have a true ambiguity for that input sequence. If we
 * don't get a conflict, it implies that the decision is sensitive to the outer
 * context. (It is not context-sensitive in the sense of context-sensitive
 * grammars.)
 *
 * The next time we reach this DFA state with an SLL conflict, through DFA
 * simulation, we will again retry the ATN simulation using full context mode.
 * This is slow because we can't save the results and have to "interpret" the
 * ATN each time we get that input.
 *
 * **CACHING FULL CONTEXT PREDICTIONS**
 *
 * We could cache results from full context to predicted alternative easily and
 * that saves a lot of time but doesn't work in presence of predicates. The set
 * of visible predicates from the ATN start state changes depending on the
 * context, because closure can fall off the end of a rule. I tried to cache
 * tuples (stack context, semantic context, predicted alt) but it was slower
 * than interpreting and much more complicated. Also required a huge amount of
 * memory. The goal is not to create the world's fastest parser anyway. I'd like
 * to keep this algorithm simple. By launching multiple threads, we can improve
 * the speed of parsing across a large number of files.
 *
 * There is no strict ordering between the amount of input used by SLL vs LL,
 * which makes it really hard to build a cache for full context. Let's say that
 * we have input A B C that leads to an SLL conflict with full context X. That
 * implies that using X we might only use A B but we could also use A B C D to
 * resolve conflict. Input A B C D could predict alternative 1 in one position
 * in the input and A B C E could predict alternative 2 in another position in
 * input. The conflicting SLL configurations could still be non-unique in the
 * full context prediction, which would lead us to requiring more input than the
 * original A B C.	To make a	prediction cache work, we have to track	the exact
 * input	used during the previous prediction. That amounts to a cache that maps
 * X to a specific DFA for that context.
 *
 * Something should be done for left-recursive expression predictions. They are
 * likely LL(1) + pred eval. Easier to do the whole SLL unless error and retry
 * with full LL thing Sam does.
 *
 * **AVOIDING FULL CONTEXT PREDICTION**
 *
 * We avoid doing full context retry when the outer context is empty, we did not
 * dip into the outer context by falling off the end of the decision state rule,
 * or when we force SLL mode.
 *
 * As an example of the not dip into outer context case, consider as super
 * constructor calls versus function calls. One grammar might look like
 * this:
 *
 * ```antlr
 * ctorBody
 *   : '{' superCall? stat* '}'
 *   ;
 * ```
 *
 * Or, you might see something like
 *
 * ```antlr
 * stat
 *   : superCall ';'
 *   | expression ';'
 *   | ...
 *   ;
 * ```
 *
 * In both cases I believe that no closure operations will dip into the outer
 * context. In the first case ctorBody in the worst case will stop at the '}'.
 * In the 2nd case it should stop at the ';'. Both cases should stay within the
 * entry rule and not dip into the outer context.
 *
 * **PREDICATES**
 *
 * Predicates are always evaluated if present in either SLL or LL both. SLL and
 * LL simulation deals with predicates differently. SLL collects predicates as
 * it performs closure operations like ANTLR v3 did. It delays predicate
 * evaluation until it reaches and accept state. This allows us to cache the SLL
 * ATN simulation whereas, if we had evaluated predicates on-the-fly during
 * closure, the DFA state configuration sets would be different and we couldn't
 * build up a suitable DFA.
 *
 * When building a DFA accept state during ATN simulation, we evaluate any
 * predicates and return the sole semantically valid alternative. If there is
 * more than 1 alternative, we report an ambiguity. If there are 0 alternatives,
 * we throw an exception. Alternatives without predicates act like they have
 * true predicates. The simple way to think about it is to strip away all
 * alternatives with false predicates and choose the minimum alternative that
 * remains.
 *
 * When we start in the DFA and reach an accept state that's predicated, we test
 * those and return the minimum semantically viable alternative. If no
 * alternatives are viable, we throw an exception.
 *
 * During full LL ATN simulation, closure always evaluates predicates and
 * on-the-fly. This is crucial to reducing the configuration set size during
 * closure. It hits a landmine when parsing with the Java grammar, for example,
 * without this on-the-fly evaluation.
 *
 * **SHARING DFA**
 *
 * All instances of the same parser share the same decision DFAs through a
 * static field. Each instance gets its own ATN simulator but they share the
 * same {@link ATN#decisionToDFA} field. They also share a
 * {@link PredictionContextCache} object that makes sure that all
 * {@link PredictionContext} objects are shared among the DFA states. This makes
 * a big size difference.
 *
 * **THREAD SAFETY**
 *
 * The {@link ParserATNSimulator} locks on the {@link ATN#decisionToDFA} field when
 * it adds a new DFA object to that array. {@link #addDFAEdge}
 * locks on the DFA for the current decision when setting the
 * {@link DFAState#edges} field. {@link #addDFAState} locks on
 * the DFA for the current decision when looking up a DFA state to see if it
 * already exists. We must make sure that all requests to add DFA states that
 * are equivalent result in the same shared DFA object. This is because lots of
 * threads will be trying to update the DFA at once. The
 * {@link #addDFAState} method also locks inside the DFA lock
 * but this time on the shared context cache when it rebuilds the
 * configurations' {@link PredictionContext} objects using cached
 * subgraphs/nodes. No other locking occurs, even during DFA simulation. This is
 * safe as long as we can guarantee that all threads referencing
 * `s.edge[t]` get the same physical target {@link DFAState}, or
 * `undefined`. Once into the DFA, the DFA simulation does not reference the
 * {@link DFA#states} map. It follows the {@link DFAState#edges} field to new
 * targets. The DFA simulator will either find {@link DFAState#edges} to be
 * `undefined`, to be non-`undefined` and `dfa.edges[t]` undefined, or
 * `dfa.edges[t]` to be non-undefined. The
 * {@link #addDFAEdge} method could be racing to set the field
 * but in either case the DFA simulator works; if `undefined`, and requests ATN
 * simulation. It could also race trying to get `dfa.edges[t]`, but either
 * way it will work because it's not doing a test and set operation.
 *
 * **Starting with SLL then failing to combined SLL/LL (Two-Stage
 * Parsing)**
 *
 * Sam pointed out that if SLL does not give a syntax error, then there is no
 * point in doing full LL, which is slower. We only have to try LL if we get a
 * syntax error. For maximum speed, Sam starts the parser set to pure SLL
 * mode with the {@link BailErrorStrategy}:
 *
 * ```
 * parser.interpreter.{@link #setPredictionMode setPredictionMode}`(`{@link PredictionMode#SLL}`)`;
 * parser.{@link Parser#setErrorHandler setErrorHandler}(new {@link BailErrorStrategy}());
 * ```
 *
 * If it does not get a syntax error, then we're done. If it does get a syntax
 * error, we need to retry with the combined SLL/LL strategy.
 *
 * The reason this works is as follows. If there are no SLL conflicts, then the
 * grammar is SLL (at least for that input set). If there is an SLL conflict,
 * the full LL analysis must yield a set of viable alternatives which is a
 * subset of the alternatives reported by SLL. If the LL set is a singleton,
 * then the grammar is LL but not SLL. If the LL set is the same size as the SLL
 * set, the decision is SLL. If the LL set has size &gt; 1, then that decision
 * is truly ambiguous on the current input. If the LL set is smaller, then the
 * SLL conflict resolution might choose an alternative that the full LL would
 * rule out as a possibility based upon better context information. If that's
 * the case, then the SLL parse will definitely get an error because the full LL
 * analysis says it's not viable. If SLL conflict resolution chooses an
 * alternative within the LL set, them both SLL and LL would choose the same
 * alternative because they both choose the minimum of multiple conflicting
 * alternatives.
 *
 * Let's say we have a set of SLL conflicting alternatives `{1, 2, 3}` and
 * a smaller LL set called *s*. If *s* is `{2, 3}`, then SLL
 * parsing will get an error because SLL will pursue alternative 1. If
 * *s* is `{1, 2}` or `{1, 3}` then both SLL and LL will
 * choose the same alternative because alternative one is the minimum of either
 * set. If *s* is `{2}` or `{3}` then SLL will get a syntax
 * error. If *s* is `{1}` then SLL will succeed.
 *
 * Of course, if the input is invalid, then we will get an error for sure in
 * both SLL and LL parsing. Erroneous input will therefore require 2 passes over
 * the input.
 */ let $ef8fe7d2bd819f1c$var$ParserATNSimulator = class ParserATNSimulator extends $kr9A1.ATNSimulator {
    constructor(atn, parser){
        super(atn);
        this.predictionMode = $gDZVV.PredictionMode.LL;
        this.force_global_context = false;
        this.always_try_local_context = true;
        /**
         * Determines whether the DFA is used for full-context predictions. When
         * `true`, the DFA stores transition information for both full-context
         * and SLL parsing; otherwise, the DFA only stores SLL transition
         * information.
         *
         * For some grammars, enabling the full-context DFA can result in a
         * substantial performance improvement. However, this improvement typically
         * comes at the expense of memory used for storing the cached DFA states,
         * configuration sets, and prediction contexts.
         *
         * The default value is `false`.
         */ this.enable_global_context_dfa = false;
        this.optimize_unique_closure = true;
        this.optimize_ll1 = true;
        this.optimize_tail_calls = true;
        this.tail_call_preserves_sll = true;
        this.treat_sllk1_conflict_as_ambiguity = false;
        /**
         * When `true`, ambiguous alternatives are reported when they are
         * encountered within {@link #execATN}. When `false`, these messages
         * are suppressed. The default is `false`.
         *
         * When messages about ambiguous alternatives are not required, setting this
         * to `false` enables additional internal optimizations which may lose
         * this information.
         */ this.reportAmbiguities = false;
        /** By default we do full context-sensitive LL(*) parsing not
         *  Strong LL(*) parsing. If we fail with Strong LL(*) we
         *  try full LL(*). That means we rewind and use context information
         *  when closure operations fall off the end of the rule that
         *  holds the decision were evaluating.
         */ this.userWantsCtxSensitive = true;
        this._parser = parser;
    }
    getPredictionMode() {
        return this.predictionMode;
    }
    setPredictionMode(predictionMode) {
        this.predictionMode = predictionMode;
    }
    reset() {
    // intentionally empty
    }
    adaptivePredict(input, decision, outerContext, useContext) {
        if (useContext === undefined) useContext = false;
        let dfa = this.atn.decisionToDFA[decision];
        $bbHFU(dfa != null);
        if (this.optimize_ll1 && !dfa.isPrecedenceDfa && !dfa.isEmpty) {
            let ll_1 = input.LA(1);
            if (ll_1 >= 0 && ll_1 <= 0xFFFF) {
                let key = (decision << 16 >>> 0) + ll_1;
                let alt = this.atn.LL1Table.get(key);
                if (alt != null) return alt;
            }
        }
        this.dfa = dfa;
        if (this.force_global_context) useContext = true;
        else if (!this.always_try_local_context) useContext = useContext || dfa.isContextSensitive;
        this.userWantsCtxSensitive = useContext || this.predictionMode !== $gDZVV.PredictionMode.SLL && outerContext != null && !this.atn.decisionToState[decision].sll;
        if (outerContext == null) outerContext = $6bmaO.ParserRuleContext.emptyContext();
        let state;
        if (!dfa.isEmpty) state = this.getStartState(dfa, input, outerContext, useContext);
        if (state == null) {
            if (outerContext == null) outerContext = $6bmaO.ParserRuleContext.emptyContext();
            if (ParserATNSimulator.debug) console.log("ATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
            state = this.computeStartState(dfa, outerContext, useContext);
        }
        let m = input.mark();
        let index = input.index;
        try {
            let alt = this.execDFA(dfa, input, index, state);
            if (ParserATNSimulator.debug) console.log("DFA after predictATN: " + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
            return alt;
        } finally{
            this.dfa = undefined;
            input.seek(index);
            input.release(m);
        }
    }
    getStartState(dfa, input, outerContext, useContext) {
        if (!useContext) {
            if (dfa.isPrecedenceDfa) {
                // the start state for a precedence DFA depends on the current
                // parser precedence, and is provided by a DFA method.
                let state = dfa.getPrecedenceStartState(this._parser.precedence, false);
                if (state == null) return undefined;
                return new $g7SCF.SimulatorState(outerContext, state, false, outerContext);
            } else {
                if (dfa.s0 == null) return undefined;
                return new $g7SCF.SimulatorState(outerContext, dfa.s0, false, outerContext);
            }
        }
        if (!this.enable_global_context_dfa) return undefined;
        let remainingContext = outerContext;
        $bbHFU(outerContext != null);
        let s0;
        if (dfa.isPrecedenceDfa) s0 = dfa.getPrecedenceStartState(this._parser.precedence, true);
        else s0 = dfa.s0full;
        while(remainingContext != null && s0 != null && s0.isContextSensitive){
            remainingContext = this.skipTailCalls(remainingContext);
            s0 = s0.getContextTarget(this.getReturnState(remainingContext));
            if (remainingContext.isEmpty) $bbHFU(s0 == null || !s0.isContextSensitive);
            else remainingContext = remainingContext.parent;
        }
        if (s0 == null) return undefined;
        return new $g7SCF.SimulatorState(outerContext, s0, useContext, remainingContext);
    }
    execDFA(dfa, input, startIndex, state) {
        let outerContext = state.outerContext;
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
        if (ParserATNSimulator.dfa_debug) console.log(dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
        let s = state.s0;
        let t = input.LA(1);
        let remainingOuterContext = state.remainingOuterContext;
        while(true){
            if (ParserATNSimulator.dfa_debug) console.log("DFA state " + s.stateNumber + " LA(1)==" + this.getLookaheadName(input));
            if (state.useContext) while(s.isContextSymbol(t)){
                let next;
                if (remainingOuterContext != null) {
                    remainingOuterContext = this.skipTailCalls(remainingOuterContext);
                    next = s.getContextTarget(this.getReturnState(remainingOuterContext));
                }
                if (next == null) {
                    // fail over to ATN
                    let initialState = new $g7SCF.SimulatorState(state.outerContext, s, state.useContext, remainingOuterContext);
                    return this.execATN(dfa, input, startIndex, initialState);
                }
                $bbHFU(remainingOuterContext != null);
                remainingOuterContext = remainingOuterContext.parent;
                s = next;
            }
            if (this.isAcceptState(s, state.useContext)) {
                if (s.predicates != null) {
                    if (ParserATNSimulator.dfa_debug) console.log("accept " + s);
                } else if (ParserATNSimulator.dfa_debug) console.log("accept; predict " + s.prediction + " in state " + s.stateNumber);
                break;
            }
            // t is not updated if one of these states is reached
            $bbHFU(!this.isAcceptState(s, state.useContext));
            // if no edge, pop over to ATN interpreter, update DFA and return
            let target = this.getExistingTargetState(s, t);
            if (target == null) {
                if (ParserATNSimulator.dfa_debug && t >= 0) console.log("no edge for " + this._parser.vocabulary.getDisplayName(t));
                let alt;
                if (ParserATNSimulator.dfa_debug) {
                    let interval = $gcfUE.Interval.of(startIndex, this._parser.inputStream.index);
                    console.log("ATN exec upon " + this._parser.inputStream.getText(interval) + " at DFA state " + s.stateNumber);
                }
                let initialState = new $g7SCF.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                alt = this.execATN(dfa, input, startIndex, initialState);
                if (ParserATNSimulator.dfa_debug) console.log("back from DFA update, alt=" + alt + ", dfa=\n" + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
                // action already executed
                if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + alt);
                return alt; // we've updated DFA, exec'd action, and have our deepest answer
            } else if (target === $kr9A1.ATNSimulator.ERROR) {
                let errorState = new $g7SCF.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                return this.handleNoViableAlt(input, startIndex, errorState);
            }
            s = target;
            if (!this.isAcceptState(s, state.useContext) && t !== $ceaEj.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
        //		if ( acceptState==null ) {
        //			if ( debug ) System.out.println("!!! no viable alt in dfa");
        //			return -1;
        //		}
        if (!state.useContext && s.configs.conflictInfo != null) {
            if (dfa.atnStartState instanceof $dPYn6.DecisionState) {
                if (!this.userWantsCtxSensitive || !s.configs.dipsIntoOuterContext && s.configs.isExactConflict || this.treat_sllk1_conflict_as_ambiguity && input.index === startIndex) ;
                else {
                    $bbHFU(!state.useContext);
                    // Before attempting full context prediction, check to see if there are
                    // disambiguating or validating predicates to evaluate which allow an
                    // immediate decision
                    let conflictingAlts;
                    let predicates = s.predicates;
                    if (predicates != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        conflictingAlts = this.evalSemanticContext(predicates, outerContext, true);
                        if (conflictingAlts.cardinality() === 1) return conflictingAlts.nextSetBit(0);
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                    if (this.reportAmbiguities) {
                        let conflictState = new $g7SCF.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                        this.reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, input.index);
                    }
                    input.seek(startIndex);
                    return this.adaptivePredict(input, dfa.decision, outerContext, true);
                }
            }
        }
        // Before jumping to prediction, check to see if there are
        // disambiguating or validating predicates to evaluate
        let predicates = s.predicates;
        if (predicates != null) {
            let stopIndex = input.index;
            if (startIndex !== stopIndex) input.seek(startIndex);
            let alts = this.evalSemanticContext(predicates, outerContext, this.reportAmbiguities && this.predictionMode === $gDZVV.PredictionMode.LL_EXACT_AMBIG_DETECTION);
            switch(alts.cardinality()){
                case 0:
                    throw this.noViableAlt(input, outerContext, s.configs, startIndex);
                case 1:
                    return alts.nextSetBit(0);
                default:
                    // report ambiguity after predicate evaluation to make sure the correct
                    // set of ambig alts is reported.
                    if (startIndex !== stopIndex) input.seek(stopIndex);
                    this.reportAmbiguity(dfa, s, startIndex, stopIndex, s.configs.isExactConflict, alts, s.configs);
                    return alts.nextSetBit(0);
            }
        }
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + s.prediction);
        return s.prediction;
    }
    /**
     * Determines if a particular DFA state should be treated as an accept state
     * for the current prediction mode. In addition to the `useContext`
     * parameter, the {@link #getPredictionMode()} method provides the
     * prediction mode controlling the prediction algorithm as a whole.
     *
     * The default implementation simply returns the value of
     * `DFAState.isAcceptState` except for conflict states when
     * `useContext` is `true` and {@link #getPredictionMode()} is
     * {@link PredictionMode#LL_EXACT_AMBIG_DETECTION}. In that case, only
     * conflict states where {@link ATNConfigSet#isExactConflict} is
     * `true` are considered accept states.
     *
     * @param state The DFA state to check.
     * @param useContext `true` if the prediction algorithm is currently
     * considering the full parser context; otherwise, `false` if the
     * algorithm is currently performing a local context prediction.
     *
     * @returns `true` if the specified `state` is an accept state;
     * otherwise, `false`.
     */ isAcceptState(state, useContext) {
        if (!state.isAcceptState) return false;
        if (state.configs.conflictingAlts == null) // unambiguous
        return true;
        // More picky when we need exact conflicts
        if (useContext && this.predictionMode === $gDZVV.PredictionMode.LL_EXACT_AMBIG_DETECTION) return state.configs.isExactConflict;
        return true;
    }
    /** Performs ATN simulation to compute a predicted alternative based
     *  upon the remaining input, but also updates the DFA cache to avoid
     *  having to traverse the ATN again for the same input sequence.
     *
     * There are some key conditions we're looking for after computing a new
     * set of ATN configs (proposed DFA state):
     *
     * * if the set is empty, there is no viable alternative for current symbol
     * * does the state uniquely predict an alternative?
     * * does the state have a conflict that would prevent us from
     *   putting it on the work list?
     * * if in non-greedy decision is there a config at a rule stop state?
     *
     * We also have some key operations to do:
     *
     * * add an edge from previous DFA state to potentially new DFA state, D,
     *   upon current symbol but only if adding to work list, which means in all
     *   cases except no viable alternative (and possibly non-greedy decisions?)
     * * collecting predicates and adding semantic context to DFA accept states
     * * adding rule context to context-sensitive DFA accept states
     * * consuming an input symbol
     * * reporting a conflict
     * * reporting an ambiguity
     * * reporting a context sensitivity
     * * reporting insufficient predicates
     *
     * We should isolate those operations, which are side-effecting, to the
     * main work loop. We can isolate lots of code into other functions, but
     * they should be side effect free. They can return package that
     * indicates whether we should report something, whether we need to add a
     * DFA edge, whether we need to augment accept state with semantic
     * context or rule invocation context. Actually, it seems like we always
     * add predicates if they exist, so that can simply be done in the main
     * loop for any accept state creation or modification request.
     *
     * cover these cases:
     *   dead end
     *   single alt
     *   single alt + preds
     *   conflict
     *   conflict + preds
     *
     * TODO: greedy + those
     */ execATN(dfa, input, startIndex, initialState) {
        if (ParserATNSimulator.debug) console.log("execATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input));
        let outerContext = initialState.outerContext;
        let useContext = initialState.useContext;
        let t = input.LA(1);
        let previous = initialState;
        let contextCache = new $6vF7J.PredictionContextCache();
        while(true){
            let nextState = this.computeReachSet(dfa, previous, t, contextCache);
            if (nextState == null) {
                this.setDFAEdge(previous.s0, input.LA(1), $kr9A1.ATNSimulator.ERROR);
                return this.handleNoViableAlt(input, startIndex, previous);
            }
            let D = nextState.s0;
            // predicted alt => accept state
            $bbHFU(D.isAcceptState || D.prediction === $bcnvE.ATN.INVALID_ALT_NUMBER);
            // conflicted => accept state
            $bbHFU(D.isAcceptState || D.configs.conflictInfo == null);
            if (this.isAcceptState(D, useContext)) {
                let conflictingAlts = D.configs.conflictingAlts;
                let predictedAlt = conflictingAlts == null ? D.prediction : $bcnvE.ATN.INVALID_ALT_NUMBER;
                if (predictedAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) {
                    if (this.optimize_ll1 && input.index === startIndex && !dfa.isPrecedenceDfa && nextState.outerContext === nextState.remainingOuterContext && dfa.decision >= 0 && !D.configs.hasSemanticContext) {
                        if (t >= 0 && t <= $ef8fe7d2bd819f1c$var$MAX_SHORT_VALUE) {
                            let key = (dfa.decision << 16 >>> 0) + t;
                            this.atn.LL1Table.set(key, predictedAlt);
                        }
                    }
                    if (useContext && this.always_try_local_context) this.reportContextSensitivity(dfa, predictedAlt, nextState, startIndex, input.index);
                }
                predictedAlt = D.prediction;
                //				int k = input.index - startIndex + 1; // how much input we used
                //				System.out.println("used k="+k);
                let attemptFullContext = conflictingAlts != null && this.userWantsCtxSensitive;
                if (attemptFullContext) // Only exact conflicts are known to be ambiguous when local
                // prediction does not step out of the decision rule.
                attemptFullContext = !useContext && (D.configs.dipsIntoOuterContext || !D.configs.isExactConflict) && (!this.treat_sllk1_conflict_as_ambiguity || input.index !== startIndex);
                if (D.configs.hasSemanticContext) {
                    let predPredictions = D.predicates;
                    if (predPredictions != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        // use complete evaluation here if we'll want to retry with full context if still ambiguous
                        conflictingAlts = this.evalSemanticContext(predPredictions, outerContext, attemptFullContext || this.reportAmbiguities);
                        switch(conflictingAlts.cardinality()){
                            case 0:
                                throw this.noViableAlt(input, outerContext, D.configs, startIndex);
                            case 1:
                                return conflictingAlts.nextSetBit(0);
                            default:
                                break;
                        }
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                }
                if (!attemptFullContext) {
                    if (conflictingAlts != null) {
                        if (this.reportAmbiguities && conflictingAlts.cardinality() > 1) this.reportAmbiguity(dfa, D, startIndex, input.index, D.configs.isExactConflict, conflictingAlts, D.configs);
                        predictedAlt = conflictingAlts.nextSetBit(0);
                    }
                    return predictedAlt;
                } else {
                    $bbHFU(!useContext);
                    $bbHFU(this.isAcceptState(D, false));
                    if (ParserATNSimulator.debug) console.log("RETRY with outerContext=" + outerContext);
                    let fullContextState = this.computeStartState(dfa, outerContext, true);
                    if (this.reportAmbiguities) this.reportAttemptingFullContext(dfa, conflictingAlts, nextState, startIndex, input.index);
                    input.seek(startIndex);
                    return this.execATN(dfa, input, startIndex, fullContextState);
                }
            }
            previous = nextState;
            if (t !== $ceaEj.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
    }
    /**
     * This method is used to improve the localization of error messages by
     * choosing an alternative rather than throwing a
     * {@link NoViableAltException} in particular prediction scenarios where the
     * {@link #ERROR} state was reached during ATN simulation.
     *
     * The default implementation of this method uses the following
     * algorithm to identify an ATN configuration which successfully parsed the
     * decision entry rule. Choosing such an alternative ensures that the
     * {@link ParserRuleContext} returned by the calling rule will be complete
     * and valid, and the syntax error will be reported later at a more
     * localized location.
     *
     * * If no configuration in `configs` reached the end of the
     *   decision rule, return {@link ATN#INVALID_ALT_NUMBER}.
     * * If all configurations in `configs` which reached the end of the
     *   decision rule predict the same alternative, return that alternative.
     * * If the configurations in `configs` which reached the end of the
     *   decision rule predict multiple alternatives (call this *S*),
     *   choose an alternative in the following order.
     *
     *     1. Filter the configurations in `configs` to only those
     *        configurations which remain viable after evaluating semantic predicates.
     *        If the set of these filtered configurations which also reached the end of
     *        the decision rule is not empty, return the minimum alternative
     *        represented in this set.
     *     1. Otherwise, choose the minimum alternative in *S*.
     *
     * In some scenarios, the algorithm described above could predict an
     * alternative which will result in a {@link FailedPredicateException} in
     * parser. Specifically, this could occur if the *only* configuration
     * capable of successfully parsing to the end of the decision rule is
     * blocked by a semantic predicate. By choosing this alternative within
     * {@link #adaptivePredict} instead of throwing a
     * {@link NoViableAltException}, the resulting
     * {@link FailedPredicateException} in the parser will identify the specific
     * predicate which is preventing the parser from successfully parsing the
     * decision rule, which helps developers identify and correct logic errors
     * in semantic predicates.
     *
     * @param input The input {@link TokenStream}
     * @param startIndex The start index for the current prediction, which is
     * the input index where any semantic context in `configs` should be
     * evaluated
     * @param previous The ATN simulation state immediately before the
     * {@link #ERROR} state was reached
     *
     * @returns The value to return from {@link #adaptivePredict}, or
     * {@link ATN#INVALID_ALT_NUMBER} if a suitable alternative was not
     * identified and {@link #adaptivePredict} should report an error instead.
     */ handleNoViableAlt(input, startIndex, previous) {
        if (previous.s0 != null) {
            let alts = new $5BPMp.BitSet();
            let maxAlt = 0;
            for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $4kGBm.RuleStopState) {
                alts.set(config.alt);
                maxAlt = Math.max(maxAlt, config.alt);
            }
            switch(alts.cardinality()){
                case 0:
                    break;
                case 1:
                    return alts.nextSetBit(0);
                default:
                    if (!previous.s0.configs.hasSemanticContext) // configs doesn't contain any predicates, so the predicate
                    // filtering code below would be pointless
                    return alts.nextSetBit(0);
                    /*
                     * Try to find a configuration set that not only dipped into the outer
                     * context, but also isn't eliminated by a predicate.
                     */ let filteredConfigs = new $c1ClW.ATNConfigSet();
                    for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $4kGBm.RuleStopState) filteredConfigs.add(config);
                    /* The following code blocks are adapted from predicateDFAState with
                     * the following key changes.
                     *
                     *  1. The code operates on an ATNConfigSet rather than a DFAState.
                     *  2. Predicates are collected for all alternatives represented in
                     *     filteredConfigs, rather than restricting the evaluation to
                     *     conflicting and/or unique configurations.
                     */ let altToPred = this.getPredsForAmbigAlts(alts, filteredConfigs, maxAlt);
                    if (altToPred != null) {
                        let predicates = this.getPredicatePredictions(alts, altToPred);
                        if (predicates != null) {
                            let stopIndex = input.index;
                            try {
                                input.seek(startIndex);
                                let filteredAlts = this.evalSemanticContext(predicates, previous.outerContext, false);
                                if (!filteredAlts.isEmpty) return filteredAlts.nextSetBit(0);
                            } finally{
                                input.seek(stopIndex);
                            }
                        }
                    }
                    return alts.nextSetBit(0);
            }
        }
        throw this.noViableAlt(input, previous.outerContext, previous.s0.configs, startIndex);
    }
    computeReachSet(dfa, previous, t, contextCache) {
        let useContext = previous.useContext;
        let remainingGlobalContext = previous.remainingOuterContext;
        let s = previous.s0;
        if (useContext) while(s.isContextSymbol(t)){
            let next;
            if (remainingGlobalContext != null) {
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                next = s.getContextTarget(this.getReturnState(remainingGlobalContext));
            }
            if (next == null) break;
            $bbHFU(remainingGlobalContext != null);
            remainingGlobalContext = remainingGlobalContext.parent;
            s = next;
        }
        $bbHFU(!this.isAcceptState(s, useContext));
        if (this.isAcceptState(s, useContext)) return new $g7SCF.SimulatorState(previous.outerContext, s, useContext, remainingGlobalContext);
        let s0 = s;
        let target = this.getExistingTargetState(s0, t);
        if (target == null) {
            let result = this.computeTargetState(dfa, s0, remainingGlobalContext, t, useContext, contextCache);
            target = result[0];
            remainingGlobalContext = result[1];
        }
        if (target === $kr9A1.ATNSimulator.ERROR) return undefined;
        $bbHFU(!useContext || !target.configs.dipsIntoOuterContext);
        return new $g7SCF.SimulatorState(previous.outerContext, target, useContext, remainingGlobalContext);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        return s.getTarget(t);
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param dfa
     * @param s The current DFA state
     * @param remainingGlobalContext
     * @param t The next input symbol
     * @param useContext
     * @param contextCache
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(dfa, s, remainingGlobalContext, t, useContext, contextCache) {
        let closureConfigs = s.configs.toArray();
        let contextElements;
        let reach = new $c1ClW.ATNConfigSet();
        let stepIntoGlobal;
        do {
            let hasMoreContext = !useContext || remainingGlobalContext != null;
            if (!hasMoreContext) reach.isOutermostConfigSet = true;
            let reachIntermediate = new $c1ClW.ATNConfigSet();
            /* Configurations already in a rule stop state indicate reaching the end
             * of the decision rule (local context) or end of the start rule (full
             * context). Once reached, these configurations are never updated by a
             * closure operation, so they are handled separately for the performance
             * advantage of having a smaller intermediate set when calling closure.
             *
             * For full-context reach operations, separate handling is required to
             * ensure that the alternative matching the longest overall sequence is
             * chosen when multiple such configurations can match the input.
             */ let skippedStopStates;
            for (let c of closureConfigs){
                if (ParserATNSimulator.debug) console.log("testing " + this.getTokenName(t) + " at " + c.toString());
                if (c.state instanceof $4kGBm.RuleStopState) {
                    $bbHFU(c.context.isEmpty);
                    if (useContext && !c.reachesIntoOuterContext || t === $ceaEj.IntStream.EOF) {
                        if (skippedStopStates == null) skippedStopStates = [];
                        skippedStopStates.push(c);
                    }
                    continue;
                }
                let n = c.state.numberOfOptimizedTransitions;
                for(let ti = 0; ti < n; ti++){
                    let trans = c.state.getOptimizedTransition(ti);
                    let target = this.getReachableTarget(c, trans, t);
                    if (target != null) reachIntermediate.add(c.transform(target, false), contextCache);
                }
            }
            /* This block optimizes the reach operation for intermediate sets which
             * trivially indicate a termination state for the overall
             * adaptivePredict operation.
             *
             * The conditions assume that intermediate
             * contains all configurations relevant to the reach set, but this
             * condition is not true when one or more configurations have been
             * withheld in skippedStopStates, or when the current symbol is EOF.
             */ if (this.optimize_unique_closure && skippedStopStates == null && t !== $2DVsz.Token.EOF && reachIntermediate.uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) {
                reachIntermediate.isOutermostConfigSet = reach.isOutermostConfigSet;
                reach = reachIntermediate;
                break;
            }
            /* If the reach set could not be trivially determined, perform a closure
             * operation on the intermediate set to compute its initial value.
             */ let collectPredicates = false;
            let treatEofAsEpsilon = t === $2DVsz.Token.EOF;
            this.closure(reachIntermediate, reach, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon);
            stepIntoGlobal = reach.dipsIntoOuterContext;
            if (t === $ceaEj.IntStream.EOF) /* After consuming EOF no additional input is possible, so we are
                 * only interested in configurations which reached the end of the
                 * decision rule (local context) or end of the start rule (full
                 * context). Update reach to contain only these configurations. This
                 * handles both explicit EOF transitions in the grammar and implicit
                 * EOF transitions following the end of the decision or start rule.
                 *
                 * This is handled before the configurations in skippedStopStates,
                 * because any configurations potentially added from that list are
                 * already guaranteed to meet this condition whether or not it's
                 * required.
                 */ reach = this.removeAllConfigsNotInRuleStopState(reach, contextCache);
            /* If skippedStopStates is not undefined, then it contains at least one
             * configuration. For full-context reach operations, these
             * configurations reached the end of the start rule, in which case we
             * only add them back to reach if no configuration during the current
             * closure operation reached such a state. This ensures adaptivePredict
             * chooses an alternative matching the longest overall sequence when
             * multiple alternatives are viable.
             */ if (skippedStopStates != null && (!useContext || !$gDZVV.PredictionMode.hasConfigInRuleStopState(reach))) {
                $bbHFU(skippedStopStates.length > 0);
                for (let c of skippedStopStates)reach.add(c, contextCache);
            }
            if (useContext && stepIntoGlobal) {
                reach.clear();
                // We know remainingGlobalContext is not undefined at this point (why?)
                remainingGlobalContext;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                let nextContextElement = this.getReturnState(remainingGlobalContext);
                if (contextElements == null) contextElements = new $37SGk.IntegerList();
                if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
                else remainingGlobalContext = remainingGlobalContext.parent;
                contextElements.add(nextContextElement);
                if (nextContextElement !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) for(let i = 0; i < closureConfigs.length; i++)closureConfigs[i] = closureConfigs[i].appendContext(nextContextElement, contextCache);
            }
        }while (useContext && stepIntoGlobal);
        if (reach.isEmpty) {
            this.setDFAEdge(s, t, $kr9A1.ATNSimulator.ERROR);
            return [
                $kr9A1.ATNSimulator.ERROR,
                remainingGlobalContext
            ];
        }
        let result = this.addDFAEdge(dfa, s, t, contextElements, reach, contextCache);
        return [
            result,
            remainingGlobalContext
        ];
    }
    /**
     * Return a configuration set containing only the configurations from
     * `configs` which are in a {@link RuleStopState}. If all
     * configurations in `configs` are already in a rule stop state, this
     * method simply returns `configs`.
     *
     * @param configs the configuration set to update
     * @param contextCache the {@link PredictionContext} cache
     *
     * @returns `configs` if all configurations in `configs` are in a
     * rule stop state, otherwise return a new configuration set containing only
     * the configurations from `configs` which are in a rule stop state
     */ removeAllConfigsNotInRuleStopState(configs, contextCache) {
        if ($gDZVV.PredictionMode.allConfigsInRuleStopStates(configs)) return configs;
        let result = new $c1ClW.ATNConfigSet();
        for (let config of configs){
            if (!(config.state instanceof $4kGBm.RuleStopState)) continue;
            result.add(config, contextCache);
        }
        return result;
    }
    computeStartState(dfa, globalContext, useContext) {
        let s0 = dfa.isPrecedenceDfa ? dfa.getPrecedenceStartState(this._parser.precedence, useContext) : useContext ? dfa.s0full : dfa.s0;
        if (s0 != null) {
            if (!useContext) return new $g7SCF.SimulatorState(globalContext, s0, useContext, globalContext);
            s0.setContextSensitive(this.atn);
        }
        let decision = dfa.decision;
        // @NotNull
        let p = dfa.atnStartState;
        let previousContext = 0;
        let remainingGlobalContext = globalContext;
        let initialContext = useContext ? $8DTT0.PredictionContext.EMPTY_FULL : $8DTT0.PredictionContext.EMPTY_LOCAL; // always at least the implicit call to start rule
        let contextCache = new $6vF7J.PredictionContextCache();
        if (useContext) {
            if (!this.enable_global_context_dfa) {
                while(remainingGlobalContext != null)if (remainingGlobalContext.isEmpty) {
                    previousContext = $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
            }
            while(s0 != null && s0.isContextSensitive && remainingGlobalContext != null){
                let next;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                if (remainingGlobalContext.isEmpty) {
                    next = s0.getContextTarget($8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY);
                    previousContext = $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    next = s0.getContextTarget(previousContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
                if (next == null) break;
                s0 = next;
            }
        }
        if (s0 != null && !s0.isContextSensitive) return new $g7SCF.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
        let configs = new $c1ClW.ATNConfigSet();
        while(true){
            let reachIntermediate = new $c1ClW.ATNConfigSet();
            let n = p.numberOfTransitions;
            for(let ti = 0; ti < n; ti++){
                // for each transition
                let target = p.transition(ti).target;
                reachIntermediate.add($gcX0f.ATNConfig.create(target, ti + 1, initialContext));
            }
            let hasMoreContext = remainingGlobalContext != null;
            if (!hasMoreContext) configs.isOutermostConfigSet = true;
            let collectPredicates = true;
            this.closure(reachIntermediate, configs, collectPredicates, hasMoreContext, contextCache, false);
            let stepIntoGlobal = configs.dipsIntoOuterContext;
            let next;
            if (useContext && !this.enable_global_context_dfa) {
                s0 = this.addDFAState(dfa, configs, contextCache);
                break;
            } else if (s0 == null) {
                if (!dfa.isPrecedenceDfa) {
                    next = this.addDFAState(dfa, configs, contextCache);
                    if (useContext) {
                        if (!dfa.s0full) dfa.s0full = next;
                        else next = dfa.s0full;
                    } else if (!dfa.s0) dfa.s0 = next;
                    else next = dfa.s0;
                } else {
                    /* If this is a precedence DFA, we use applyPrecedenceFilter
                     * to convert the computed start state to a precedence start
                     * state. We then use DFA.setPrecedenceStartState to set the
                     * appropriate start state for the precedence level rather
                     * than simply setting DFA.s0.
                     */ configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                    next = this.addDFAState(dfa, configs, contextCache);
                    dfa.setPrecedenceStartState(this._parser.precedence, useContext, next);
                }
            } else {
                if (dfa.isPrecedenceDfa) configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                next = this.addDFAState(dfa, configs, contextCache);
                s0.setContextTarget(previousContext, next);
            }
            s0 = next;
            if (!useContext || !stepIntoGlobal) break;
            // TODO: make sure it distinguishes empty stack states
            next.setContextSensitive(this.atn);
            // We know remainingGlobalContext is not undefined at this point (why?)
            remainingGlobalContext;
            configs.clear();
            remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
            let nextContextElement = this.getReturnState(remainingGlobalContext);
            if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
            else remainingGlobalContext = remainingGlobalContext.parent;
            if (nextContextElement !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) initialContext = initialContext.appendSingleContext(nextContextElement, contextCache);
            previousContext = nextContextElement;
        }
        return new $g7SCF.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
    }
    /**
     * This method transforms the start state computed by
     * {@link #computeStartState} to the special start state used by a
     * precedence DFA for a particular precedence value. The transformation
     * process applies the following changes to the start state's configuration
     * set.
     *
     * 1. Evaluate the precedence predicates for each configuration using
     *    {@link SemanticContext#evalPrecedence}.
     * 1. When {@link ATNConfig#isPrecedenceFilterSuppressed} is `false`,
     *    remove all configurations which predict an alternative greater than 1,
     *    for which another configuration that predicts alternative 1 is in the
     *    same ATN state with the same prediction context. This transformation is
     *    valid for the following reasons:
     *
     *     * The closure block cannot contain any epsilon transitions which bypass
     *       the body of the closure, so all states reachable via alternative 1 are
     *       part of the precedence alternatives of the transformed left-recursive
     *       rule.
     *     * The "primary" portion of a left recursive rule cannot contain an
     *       epsilon transition, so the only way an alternative other than 1 can exist
     *       in a state that is also reachable via alternative 1 is by nesting calls
     *       to the left-recursive rule, with the outer calls not being at the
     *       preferred precedence level. The
     *       {@link ATNConfig#isPrecedenceFilterSuppressed} property marks ATN
     *       configurations which do not meet this condition, and therefore are not
     *       eligible for elimination during the filtering process.
     *
     * The prediction context must be considered by this filter to address
     * situations like the following.
     *
     * ```antlr
     * grammar TA;
     * prog: statement* EOF;
     * statement: letterA | statement letterA 'b' ;
     * letterA: 'a';
     * ```
     *
     * If the above grammar, the ATN state immediately before the token
     * reference `'a'` in `letterA` is reachable from the left edge
     * of both the primary and closure blocks of the left-recursive rule
     * `statement`. The prediction context associated with each of these
     * configurations distinguishes between them, and prevents the alternative
     * which stepped out to `prog` (and then back in to `statement`
     * from being eliminated by the filter.
     *
     * @param configs The configuration set computed by
     * {@link #computeStartState} as the start state for the DFA.
     * @returns The transformed configuration set representing the start state
     * for a precedence DFA at a particular precedence level (determined by
     * calling {@link Parser#getPrecedence}).
     */ applyPrecedenceFilter(configs, globalContext, contextCache) {
        let statesFromAlt1 = new Map();
        let configSet = new $c1ClW.ATNConfigSet();
        for (let config of configs){
            // handle alt 1 first
            if (config.alt !== 1) continue;
            let updatedContext = config.semanticContext.evalPrecedence(this._parser, globalContext);
            if (updatedContext == null) continue;
            statesFromAlt1.set(config.state.stateNumber, config.context);
            if (updatedContext !== config.semanticContext) configSet.add(config.transform(config.state, false, updatedContext), contextCache);
            else configSet.add(config, contextCache);
        }
        for (let config of configs){
            if (config.alt === 1) continue;
            if (!config.isPrecedenceFilterSuppressed) {
                /* In the future, this elimination step could be updated to also
                 * filter the prediction context for alternatives predicting alt>1
                 * (basically a graph subtraction algorithm).
                 */ let context = statesFromAlt1.get(config.state.stateNumber);
                if (context != null && context.equals(config.context)) continue;
            }
            configSet.add(config, contextCache);
        }
        return configSet;
    }
    getReachableTarget(source, trans, ttype) {
        if (trans.matches(ttype, 0, this.atn.maxTokenType)) return trans.target;
        return undefined;
    }
    /** collect and set D's semantic context */ predicateDFAState(D, configs, nalts) {
        let conflictingAlts = this.getConflictingAltsFromConfigSet(configs);
        if (!conflictingAlts) throw new Error("This unhandled scenario is intended to be unreachable, but I'm currently not sure of why we know that's the case.");
        if (ParserATNSimulator.debug) console.log("predicateDFAState " + D);
        let altToPred = this.getPredsForAmbigAlts(conflictingAlts, configs, nalts);
        // altToPred[uniqueAlt] is now our validating predicate (if any)
        let predPredictions;
        if (altToPred != null) {
            // we have a validating predicate; test it
            // Update DFA so reach becomes accept state with predicate
            predPredictions = this.getPredicatePredictions(conflictingAlts, altToPred);
            D.predicates = predPredictions;
        }
        return predPredictions;
    }
    getPredsForAmbigAlts(ambigAlts, configs, nalts) {
        // REACH=[1|1|[]|0:0, 1|2|[]|0:1]
        /* altToPred starts as an array of all undefined contexts. The entry at index i
         * corresponds to alternative i. altToPred[i] may have one of three values:
         *   1. undefined: no ATNConfig c is found such that c.alt===i
         *   2. SemanticContext.NONE: At least one ATNConfig c exists such that
         *      c.alt===i and c.semanticContext===SemanticContext.NONE. In other words,
         *      alt i has at least one unpredicated config.
         *   3. Non-NONE Semantic Context: There exists at least one, and for all
         *      ATNConfig c such that c.alt===i, c.semanticContext!==SemanticContext.NONE.
         *
         * From this, it is clear that NONE||anything==NONE.
         */ let altToPred = new Array(nalts + 1);
        let n = altToPred.length;
        for (let c of configs)if (ambigAlts.get(c.alt)) altToPred[c.alt] = $eHMgW.SemanticContext.or(altToPred[c.alt], c.semanticContext);
        let nPredAlts = 0;
        for(let i = 0; i < n; i++){
            if (altToPred[i] == null) altToPred[i] = $eHMgW.SemanticContext.NONE;
            else if (altToPred[i] !== $eHMgW.SemanticContext.NONE) nPredAlts++;
        }
        // At this point we know `altToPred` doesn't contain any undefined entries
        let result = altToPred;
        // nonambig alts are undefined in result
        if (nPredAlts === 0) result = undefined;
        if (ParserATNSimulator.debug) console.log("getPredsForAmbigAlts result " + (result ? $9yG1X.Arrays.toString(result) : "undefined"));
        return result;
    }
    getPredicatePredictions(ambigAlts, altToPred) {
        let pairs = [];
        let containsPredicate = false;
        for(let i = 1; i < altToPred.length; i++){
            let pred = altToPred[i];
            // unpredicated is indicated by SemanticContext.NONE
            $bbHFU(pred != null);
            // find first unpredicated but ambig alternative, if any.
            // Only ambiguous alternatives will have SemanticContext.NONE.
            // Any unambig alts or ambig naked alts after first ambig naked are ignored
            // (undefined, i) means alt i is the default prediction
            // if no (undefined, i), then no default prediction.
            if (ambigAlts != null && ambigAlts.get(i) && pred === $eHMgW.SemanticContext.NONE) pairs.push(new $2jevZ.DFAState.PredPrediction(pred, i));
            else if (pred !== $eHMgW.SemanticContext.NONE) {
                containsPredicate = true;
                pairs.push(new $2jevZ.DFAState.PredPrediction(pred, i));
            }
        }
        if (!containsPredicate) return undefined;
        //		System.out.println(Arrays.toString(altToPred)+"->"+pairs);
        return pairs;
    }
    /** Look through a list of predicate/alt pairs, returning alts for the
     *  pairs that win. An `undefined` predicate indicates an alt containing an
     *  unpredicated config which behaves as "always true."
     */ evalSemanticContext(predPredictions, outerContext, complete) {
        let predictions = new $5BPMp.BitSet();
        for (let pair of predPredictions){
            if (pair.pred === $eHMgW.SemanticContext.NONE) {
                predictions.set(pair.alt);
                if (!complete) break;
                continue;
            }
            let evaluatedResult = this.evalSemanticContextImpl(pair.pred, outerContext, pair.alt);
            if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("eval pred " + pair + "=" + evaluatedResult);
            if (evaluatedResult) {
                if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("PREDICT " + pair.alt);
                predictions.set(pair.alt);
                if (!complete) break;
            }
        }
        return predictions;
    }
    /**
     * Evaluate a semantic context within a specific parser context.
     *
     * This method might not be called for every semantic context evaluated
     * during the prediction process. In particular, we currently do not
     * evaluate the following but it may change in the future:
     *
     * * Precedence predicates (represented by
     *   {@link SemanticContext.PrecedencePredicate}) are not currently evaluated
     *   through this method.
     * * Operator predicates (represented by {@link SemanticContext.AND} and
     *   {@link SemanticContext.OR}) are evaluated as a single semantic
     *   context, rather than evaluating the operands individually.
     *   Implementations which require evaluation results from individual
     *   predicates should override this method to explicitly handle evaluation of
     *   the operands within operator predicates.
     *
     * @param pred The semantic context to evaluate
     * @param parserCallStack The parser context in which to evaluate the
     * semantic context
     * @param alt The alternative which is guarded by `pred`
     *
     * @since 4.3
     */ evalSemanticContextImpl(pred, parserCallStack, alt) {
        return pred.eval(this._parser, parserCallStack);
    }
    /* TODO: If we are doing predicates, there is no point in pursuing
         closure operations if we reach a DFA state that uniquely predicts
         alternative. We will not be caching that DFA state and it is a
         waste to pursue the closure. Might have to advance when we do
         ambig detection thought :(
          */ closure(sourceConfigs, configs, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon) {
        if (contextCache == null) contextCache = $6vF7J.PredictionContextCache.UNCACHED;
        let currentConfigs = sourceConfigs;
        let closureBusy = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
        while(currentConfigs.size > 0){
            let intermediate = new $c1ClW.ATNConfigSet();
            for (let config of currentConfigs)this.closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContext, contextCache, 0, treatEofAsEpsilon);
            currentConfigs = intermediate;
        }
    }
    closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth, treatEofAsEpsilon) {
        if (ParserATNSimulator.debug) console.log("closure(" + config.toString(this._parser, true) + ")");
        if (config.state instanceof $4kGBm.RuleStopState) {
            // We hit rule end. If we have context info, use it
            if (!config.context.isEmpty) {
                let hasEmpty = config.context.hasEmpty;
                let nonEmptySize = config.context.size - (hasEmpty ? 1 : 0);
                for(let i = 0; i < nonEmptySize; i++){
                    let newContext = config.context.getParent(i); // "pop" return state
                    let returnState = this.atn.states[config.context.getReturnState(i)];
                    let c = $gcX0f.ATNConfig.create(returnState, config.alt, newContext, config.semanticContext);
                    // While we have context to pop back from, we may have
                    // gotten that context AFTER having fallen off a rule.
                    // Make sure we track that we are now out of context.
                    c.outerContextDepth = config.outerContextDepth;
                    c.isPrecedenceFilterSuppressed = config.isPrecedenceFilterSuppressed;
                    $bbHFU(depth > $ef8fe7d2bd819f1c$var$MIN_INTEGER_VALUE);
                    this.closureImpl(c, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth - 1, treatEofAsEpsilon);
                }
                if (!hasEmpty || !hasMoreContexts) return;
                config = config.transform(config.state, false, $8DTT0.PredictionContext.EMPTY_LOCAL);
            } else if (!hasMoreContexts) {
                configs.add(config, contextCache);
                return;
            } else {
                // else if we have no context info, just chase follow links (if greedy)
                if (ParserATNSimulator.debug) console.log("FALLING off rule " + this.getRuleName(config.state.ruleIndex));
                if (config.context === $8DTT0.PredictionContext.EMPTY_FULL) // no need to keep full context overhead when we step out
                config = config.transform(config.state, false, $8DTT0.PredictionContext.EMPTY_LOCAL);
                else if (!config.reachesIntoOuterContext && $8DTT0.PredictionContext.isEmptyLocal(config.context)) // add stop state when leaving decision rule for the first time
                configs.add(config, contextCache);
            }
        }
        let p = config.state;
        // optimization
        if (!p.onlyHasEpsilonTransitions) {
            configs.add(config, contextCache);
            // make sure to not return here, because EOF transitions can act as
            // both epsilon transitions and non-epsilon transitions.
            if (ParserATNSimulator.debug) console.log("added config " + configs);
        }
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            // This block implements first-edge elimination of ambiguous LR
            // alternatives as part of dynamic disambiguation during prediction.
            // See antlr/antlr4#1398.
            if (i === 0 && p.stateType === $1bs3X.ATNStateType.STAR_LOOP_ENTRY && p.precedenceRuleDecision && !config.context.hasEmpty) {
                let precedenceDecision = p;
                // When suppress is true, it means the outgoing edge i==0 is
                // ambiguous with the outgoing edge i==1, and thus the closure
                // operation can dynamically disambiguate by suppressing this
                // edge during the closure operation.
                let suppress = true;
                for(let j = 0; j < config.context.size; j++)if (!precedenceDecision.precedenceLoopbackStates.get(config.context.getReturnState(j))) {
                    suppress = false;
                    break;
                }
                if (suppress) continue;
            }
            let t = p.getOptimizedTransition(i);
            let continueCollecting = !(t instanceof $gxlfY.ActionTransition) && collectPredicates;
            let c = this.getEpsilonTarget(config, t, continueCollecting, depth === 0, contextCache, treatEofAsEpsilon);
            if (c != null) {
                if (t instanceof $aybFP.RuleTransition) {
                    if (intermediate != null && !collectPredicates) {
                        intermediate.add(c, contextCache);
                        continue;
                    }
                }
                let newDepth = depth;
                if (config.state instanceof $4kGBm.RuleStopState) {
                    // target fell off end of rule; mark resulting c as having dipped into outer context
                    // We can't get here if incoming config was rule stop and we had context
                    // track how far we dip into outer context.  Might
                    // come in handy and we avoid evaluating context dependent
                    // preds if this is > 0.
                    if (this.dfa != null && this.dfa.isPrecedenceDfa) {
                        let outermostPrecedenceReturn = t.outermostPrecedenceReturn;
                        if (outermostPrecedenceReturn === this.dfa.atnStartState.ruleIndex) c.isPrecedenceFilterSuppressed = true;
                    }
                    c.outerContextDepth = c.outerContextDepth + 1;
                    if (!closureBusy.add(c)) continue;
                    $bbHFU(newDepth > $ef8fe7d2bd819f1c$var$MIN_INTEGER_VALUE);
                    newDepth--;
                    if (ParserATNSimulator.debug) console.log("dips into outer ctx: " + c);
                } else if (t instanceof $aybFP.RuleTransition) {
                    if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$8DTT0.PredictionContext.isEmptyLocal(config.context))) {
                        $bbHFU(c.context === config.context);
                        if (newDepth === 0) {
                            // the pop/push of a tail call would keep the depth
                            // constant, except we latch if it goes negative
                            newDepth--;
                            if (!this.tail_call_preserves_sll && $8DTT0.PredictionContext.isEmptyLocal(config.context)) // make sure the SLL config "dips into the outer context" or prediction may not fall back to LL on conflict
                            c.outerContextDepth = c.outerContextDepth + 1;
                        }
                    } else // latch when newDepth goes negative - once we step out of the entry context we can't return
                    if (newDepth >= 0) newDepth++;
                } else {
                    if (!t.isEpsilon && !closureBusy.add(c)) continue;
                }
                this.closureImpl(c, configs, intermediate, closureBusy, continueCollecting, hasMoreContexts, contextCache, newDepth, treatEofAsEpsilon);
            }
        }
    }
    getRuleName(index) {
        if (this._parser != null && index >= 0) return this._parser.ruleNames[index];
        return "<rule " + index + ">";
    }
    getEpsilonTarget(config, t, collectPredicates, inContext, contextCache, treatEofAsEpsilon) {
        switch(t.serializationType){
            case 3 /* RULE */ :
                return this.ruleTransition(config, t, contextCache);
            case 10 /* PRECEDENCE */ :
                return this.precedenceTransition(config, t, collectPredicates, inContext);
            case 4 /* PREDICATE */ :
                return this.predTransition(config, t, collectPredicates, inContext);
            case 6 /* ACTION */ :
                return this.actionTransition(config, t);
            case 1 /* EPSILON */ :
                return config.transform(t.target, false);
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                // EOF transitions act like epsilon transitions after the first EOF
                // transition is traversed
                if (treatEofAsEpsilon) {
                    if (t.matches($2DVsz.Token.EOF, 0, 1)) return config.transform(t.target, false);
                }
                return undefined;
            default:
                return undefined;
        }
    }
    actionTransition(config, t) {
        if (ParserATNSimulator.debug) console.log("ACTION edge " + t.ruleIndex + ":" + t.actionIndex);
        return config.transform(t.target, false);
    }
    precedenceTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.precedence + ">=_p" + ", ctx dependent=true");
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && inContext) {
            let newSemCtx = $eHMgW.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    predTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.ruleIndex + ":" + pt.predIndex + ", ctx dependent=" + pt.isCtxDependent);
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && (!pt.isCtxDependent || pt.isCtxDependent && inContext)) {
            let newSemCtx = $eHMgW.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    ruleTransition(config, t, contextCache) {
        if (ParserATNSimulator.debug) console.log("CALL rule " + this.getRuleName(t.target.ruleIndex) + ", ctx=" + config.context);
        let returnState = t.followState;
        let newContext;
        if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$8DTT0.PredictionContext.isEmptyLocal(config.context))) newContext = config.context;
        else if (contextCache != null) newContext = contextCache.getChild(config.context, returnState.stateNumber);
        else newContext = config.context.getChild(returnState.stateNumber);
        return config.transform(t.target, false, newContext);
    }
    isConflicted(configset, contextCache) {
        if (configset.uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER || configset.size <= 1) return undefined;
        let configs = configset.toArray();
        configs.sort(ParserATNSimulator.STATE_ALT_SORT_COMPARATOR);
        let exact = !configset.dipsIntoOuterContext;
        let alts = new $5BPMp.BitSet();
        let minAlt = configs[0].alt;
        alts.set(minAlt);
        /* Quick checks come first (single pass, no context joining):
         *  1. Make sure first config in the sorted list predicts the minimum
         *     represented alternative.
         *  2. Make sure every represented state has at least one configuration
         *     which predicts the minimum represented alternative.
         *  3. (exact only) make sure every represented state has at least one
         *     configuration which predicts each represented alternative.
         */ // quick check 1 & 2 => if we assume #1 holds and check #2 against the
        // minAlt from the first state, #2 will fail if the assumption was
        // incorrect
        let currentState = configs[0].state.nonStopStateNumber;
        for (let config of configs){
            let stateNumber = config.state.nonStopStateNumber;
            if (stateNumber !== currentState) {
                if (config.alt !== minAlt) return undefined;
                currentState = stateNumber;
            }
        }
        let representedAlts;
        if (exact) {
            currentState = configs[0].state.nonStopStateNumber;
            // get the represented alternatives of the first state
            representedAlts = new $5BPMp.BitSet();
            let maxAlt = minAlt;
            for (let config of configs){
                if (config.state.nonStopStateNumber !== currentState) break;
                let alt = config.alt;
                representedAlts.set(alt);
                maxAlt = alt;
            }
            // quick check #3:
            currentState = configs[0].state.nonStopStateNumber;
            let currentAlt = minAlt;
            for (let config of configs){
                let stateNumber = config.state.nonStopStateNumber;
                let alt = config.alt;
                if (stateNumber !== currentState) {
                    if (currentAlt !== maxAlt) {
                        exact = false;
                        break;
                    }
                    currentState = stateNumber;
                    currentAlt = minAlt;
                } else if (alt !== currentAlt) {
                    if (alt !== representedAlts.nextSetBit(currentAlt + 1)) {
                        exact = false;
                        break;
                    }
                    currentAlt = alt;
                }
            }
        }
        currentState = configs[0].state.nonStopStateNumber;
        let firstIndexCurrentState = 0;
        let lastIndexCurrentStateMinAlt = 0;
        let joinedCheckContext = configs[0].context;
        for(let i = 1; i < configs.length; i++){
            let config = configs[i];
            if (config.alt !== minAlt) break;
            if (config.state.nonStopStateNumber !== currentState) break;
            lastIndexCurrentStateMinAlt = i;
            joinedCheckContext = contextCache.join(joinedCheckContext, configs[i].context);
        }
        for(let i = lastIndexCurrentStateMinAlt + 1; i < configs.length; i++){
            let config = configs[i];
            let state = config.state;
            alts.set(config.alt);
            if (state.nonStopStateNumber !== currentState) {
                currentState = state.nonStopStateNumber;
                firstIndexCurrentState = i;
                lastIndexCurrentStateMinAlt = i;
                joinedCheckContext = config.context;
                for(let j = firstIndexCurrentState + 1; j < configs.length; j++){
                    let config2 = configs[j];
                    if (config2.alt !== minAlt) break;
                    if (config2.state.nonStopStateNumber !== currentState) break;
                    lastIndexCurrentStateMinAlt = j;
                    joinedCheckContext = contextCache.join(joinedCheckContext, config2.context);
                }
                i = lastIndexCurrentStateMinAlt;
                continue;
            }
            let joinedCheckContext2 = config.context;
            let currentAlt = config.alt;
            let lastIndexCurrentStateCurrentAlt = i;
            for(let j = lastIndexCurrentStateCurrentAlt + 1; j < configs.length; j++){
                let config2 = configs[j];
                if (config2.alt !== currentAlt) break;
                if (config2.state.nonStopStateNumber !== currentState) break;
                lastIndexCurrentStateCurrentAlt = j;
                joinedCheckContext2 = contextCache.join(joinedCheckContext2, config2.context);
            }
            i = lastIndexCurrentStateCurrentAlt;
            let check = contextCache.join(joinedCheckContext, joinedCheckContext2);
            if (!joinedCheckContext.equals(check)) return undefined;
            // update exact if necessary
            exact = exact && joinedCheckContext.equals(joinedCheckContext2);
        }
        return new $gsRaX.ConflictInfo(alts, exact);
    }
    getConflictingAltsFromConfigSet(configs) {
        let conflictingAlts = configs.conflictingAlts;
        if (conflictingAlts == null && configs.uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) {
            conflictingAlts = new $5BPMp.BitSet();
            conflictingAlts.set(configs.uniqueAlt);
        }
        return conflictingAlts;
    }
    getTokenName(t) {
        if (t === $2DVsz.Token.EOF) return "EOF";
        let vocabulary = this._parser != null ? this._parser.vocabulary : $3n2FE.VocabularyImpl.EMPTY_VOCABULARY;
        let displayName = vocabulary.getDisplayName(t);
        if (displayName === String(t)) return displayName;
        return displayName + "<" + t + ">";
    }
    getLookaheadName(input) {
        return this.getTokenName(input.LA(1));
    }
    dumpDeadEndConfigs(nvae) {
        console.log("dead end configs: ");
        let deadEndConfigs = nvae.deadEndConfigs;
        if (!deadEndConfigs) return;
        for (let c of deadEndConfigs){
            let trans = "no edges";
            if (c.state.numberOfOptimizedTransitions > 0) {
                let t = c.state.getOptimizedTransition(0);
                if (t instanceof $5r7n7.AtomTransition) trans = "Atom " + this.getTokenName(t._label);
                else if (t instanceof $Np2R3.SetTransition) {
                    let not = t instanceof $FLEKS.NotSetTransition;
                    trans = (not ? "~" : "") + "Set " + t.set.toString();
                }
            }
            console.log(c.toString(this._parser, true) + ":" + trans);
        }
    }
    noViableAlt(input, outerContext, configs, startIndex) {
        return new $hKCjP.NoViableAltException(this._parser, input, input.get(startIndex), input.LT(1), configs, outerContext);
    }
    getUniqueAlt(configs) {
        let alt = $bcnvE.ATN.INVALID_ALT_NUMBER;
        for (let c of configs){
            if (alt === $bcnvE.ATN.INVALID_ALT_NUMBER) alt = c.alt; // found first alt
            else if (c.alt !== alt) return $bcnvE.ATN.INVALID_ALT_NUMBER;
        }
        return alt;
    }
    configWithAltAtStopState(configs, alt) {
        for (let c of configs)if (c.alt === alt) {
            if (c.state instanceof $4kGBm.RuleStopState) return true;
        }
        return false;
    }
    addDFAEdge(dfa, fromState, t, contextTransitions, toConfigs, contextCache) {
        $bbHFU(contextTransitions == null || contextTransitions.isEmpty || dfa.isContextSensitive);
        let from = fromState;
        let to = this.addDFAState(dfa, toConfigs, contextCache);
        if (contextTransitions != null) for (let context of contextTransitions.toArray()){
            if (context === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) {
                if (from.configs.isOutermostConfigSet) continue;
            }
            from.setContextSensitive(this.atn);
            from.setContextSymbol(t);
            let next = from.getContextTarget(context);
            if (next != null) {
                from = next;
                continue;
            }
            next = this.addDFAContextState(dfa, from.configs, context, contextCache);
            $bbHFU(context !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY || next.configs.isOutermostConfigSet);
            from.setContextTarget(context, next);
            from = next;
        }
        if (ParserATNSimulator.debug) console.log("EDGE " + from + " -> " + to + " upon " + this.getTokenName(t));
        this.setDFAEdge(from, t, to);
        if (ParserATNSimulator.debug) console.log("DFA=\n" + dfa.toString(this._parser != null ? this._parser.vocabulary : $3n2FE.VocabularyImpl.EMPTY_VOCABULARY, this._parser != null ? this._parser.ruleNames : undefined));
        return to;
    }
    setDFAEdge(p, t, q) {
        if (p != null) p.setTarget(t, q);
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAContextState(dfa, configs, returnContext, contextCache) {
        if (returnContext !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) {
            let contextConfigs = new $c1ClW.ATNConfigSet();
            for (let config of configs)contextConfigs.add(config.appendContext(returnContext, contextCache));
            return this.addDFAState(dfa, contextConfigs, contextCache);
        } else {
            $bbHFU(!configs.isOutermostConfigSet, "Shouldn't be adding a duplicate edge.");
            configs = configs.clone(true);
            configs.isOutermostConfigSet = true;
            return this.addDFAState(dfa, configs, contextCache);
        }
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAState(dfa, configs, contextCache) {
        let enableDfa = this.enable_global_context_dfa || !configs.isOutermostConfigSet;
        if (enableDfa) {
            if (!configs.isReadOnly) configs.optimizeConfigs(this);
            let proposed = this.createDFAState(dfa, configs);
            let existing = dfa.states.get(proposed);
            if (existing != null) return existing;
        }
        if (!configs.isReadOnly) {
            if (configs.conflictInfo == null) configs.conflictInfo = this.isConflicted(configs, contextCache);
        }
        let newState = this.createDFAState(dfa, configs.clone(true));
        // getDecisionState won't return undefined when we request a known valid decision
        let decisionState = this.atn.getDecisionState(dfa.decision);
        let predictedAlt = this.getUniqueAlt(configs);
        if (predictedAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) newState.acceptStateInfo = new $41NTU.AcceptStateInfo(predictedAlt);
        else if (configs.conflictingAlts != null) {
            let conflictingAlts = configs.conflictingAlts;
            if (conflictingAlts) newState.acceptStateInfo = new $41NTU.AcceptStateInfo(conflictingAlts.nextSetBit(0));
        }
        if (newState.isAcceptState && configs.hasSemanticContext) this.predicateDFAState(newState, configs, decisionState.numberOfTransitions);
        if (!enableDfa) return newState;
        let added = dfa.addState(newState);
        if (ParserATNSimulator.debug && added === newState) console.log("adding new DFA state: " + newState);
        return added;
    }
    createDFAState(dfa, configs) {
        return new $2jevZ.DFAState(configs);
    }
    reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $gcfUE.Interval.of(startIndex, stopIndex);
            console.log("reportAttemptingFullContext decision=" + dfa.decision + ":" + conflictState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(this._parser, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        }
    }
    reportContextSensitivity(dfa, prediction, acceptState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $gcfUE.Interval.of(startIndex, stopIndex);
            console.log("reportContextSensitivity decision=" + dfa.decision + ":" + acceptState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(this._parser, dfa, startIndex, stopIndex, prediction, acceptState);
        }
    }
    /** If context sensitive parsing, we know it's ambiguity not conflict */ reportAmbiguity(dfa, D, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $gcfUE.Interval.of(startIndex, stopIndex);
            console.log("reportAmbiguity " + ambigAlts + ":" + configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAmbiguity) listener.reportAmbiguity(this._parser, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        }
    }
    getReturnState(context) {
        if (context.isEmpty) return $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
        let state = this.atn.states[context.invokingState];
        let transition = state.transition(0);
        return transition.followState.stateNumber;
    }
    skipTailCalls(context) {
        if (!this.optimize_tail_calls) return context;
        while(!context.isEmpty){
            let state = this.atn.states[context.invokingState];
            $bbHFU(state.numberOfTransitions === 1 && state.transition(0).serializationType === 3 /* RULE */ );
            let transition = state.transition(0);
            if (!transition.tailCall) break;
            // This method requires that the root ancestor of the ParserRuleContext be empty. If we make it to this
            // line, we know the current node is not empty, which means it does have a parent.
            context = context.parent;
        }
        return context;
    }
    /**
     * @since 4.3
     */ get parser() {
        return this._parser;
    }
};
$ef8fe7d2bd819f1c$var$ParserATNSimulator.debug = false;
$ef8fe7d2bd819f1c$var$ParserATNSimulator.dfa_debug = false;
$ef8fe7d2bd819f1c$var$ParserATNSimulator.retry_debug = false;
$ef8fe7d2bd819f1c$var$ParserATNSimulator.STATE_ALT_SORT_COMPARATOR = (o1, o2)=>{
    let diff = o1.state.nonStopStateNumber - o2.state.nonStopStateNumber;
    if (diff !== 0) return diff;
    diff = o1.alt - o2.alt;
    if (diff !== 0) return diff;
    return 0;
};
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "predictionMode", void 0);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getPredictionMode", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "setPredictionMode", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.Override
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reset", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "adaptivePredict", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getStartState", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(3, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "execDFA", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(3, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "execATN", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "handleNoViableAlt", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getExistingTargetState", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "computeTargetState", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "removeAllConfigsNotInRuleStopState", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "computeStartState", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "applyPrecedenceFilter", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getReachableTarget", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getPredsForAmbigAlts", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "evalSemanticContext", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "evalSemanticContextImpl", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(4, $d6D31.Nullable)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "closure", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(2, $d6D31.Nullable),
    $ef8fe7d2bd819f1c$var$__param(3, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(6, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "closureImpl", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getRuleName", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getEpsilonTarget", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "actionTransition", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.Nullable,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "precedenceTransition", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.Nullable,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "predTransition", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(2, $d6D31.Nullable)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "ruleTransition", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "isConflicted", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getTokenName", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "dumpDeadEndConfigs", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "noViableAlt", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getUniqueAlt", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "configWithAltAtStopState", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(4, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "addDFAEdge", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.Nullable),
    $ef8fe7d2bd819f1c$var$__param(2, $d6D31.Nullable)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "setDFAEdge", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "addDFAContextState", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "addDFAState", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $d6D31.NotNull,
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "createDFAState", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reportAttemptingFullContext", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reportContextSensitivity", null);
$ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(5, $d6D31.NotNull),
    $ef8fe7d2bd819f1c$var$__param(6, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reportAmbiguity", null);
$ef8fe7d2bd819f1c$var$ParserATNSimulator = $ef8fe7d2bd819f1c$var$__decorate([
    $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
], $ef8fe7d2bd819f1c$var$ParserATNSimulator);
module.exports.ParserATNSimulator = $ef8fe7d2bd819f1c$var$ParserATNSimulator;

});
parcelRegister("gsRaX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bfc8827830a146f2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConflictInfo = void 0;

var $d6D31 = parcelRequire("d6D31");

var $2IEP9 = parcelRequire("2IEP9");
/**
 * This class stores information about a configuration conflict.
 *
 * @author Sam Harwell
 */ class $bfc8827830a146f2$var$ConflictInfo {
    constructor(conflictedAlts, exact){
        this._conflictedAlts = conflictedAlts;
        this.exact = exact;
    }
    /**
     * Gets the set of conflicting alternatives for the configuration set.
     */ get conflictedAlts() {
        return this._conflictedAlts;
    }
    /**
     * Gets whether or not the configuration conflict is an exact conflict.
     * An exact conflict occurs when the prediction algorithm determines that
     * the represented alternatives for a particular configuration set cannot be
     * further reduced by consuming additional input. After reaching an exact
     * conflict during an SLL prediction, only switch to full-context prediction
     * could reduce the set of viable alternatives. In LL prediction, an exact
     * conflict indicates a true ambiguity in the input.
     *
     * For the {@link PredictionMode#LL_EXACT_AMBIG_DETECTION} prediction mode,
     * accept states are conflicting but not exact are treated as non-accept
     * states.
     */ get isExact() {
        return this.exact;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $bfc8827830a146f2$var$ConflictInfo)) return false;
        return this.isExact === obj.isExact && $2IEP9.equals(this.conflictedAlts, obj.conflictedAlts);
    }
    hashCode() {
        return this.conflictedAlts.hashCode();
    }
}
$bfc8827830a146f2$var$__decorate([
    $d6D31.Override
], $bfc8827830a146f2$var$ConflictInfo.prototype, "equals", null);
$bfc8827830a146f2$var$__decorate([
    $d6D31.Override
], $bfc8827830a146f2$var$ConflictInfo.prototype, "hashCode", null);
module.exports.ConflictInfo = $bfc8827830a146f2$var$ConflictInfo;

});

parcelRegister("6bmaO", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4804f857ecc73c01$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserRuleContext = void 0;

var $cdCft = parcelRequire("cdCft");

var $gcfUE = parcelRequire("gcfUE");

var $d6D31 = parcelRequire("d6D31");

var $c8jEe = parcelRequire("c8jEe");

var $kYC92 = parcelRequire("kYC92");
/** A rule invocation record for parsing.
 *
 *  Contains all of the information about the current rule not stored in the
 *  RuleContext. It handles parse tree children list, Any ATN state
 *  tracing, and the default values available for rule invocations:
 *  start, stop, rule index, current alt number.
 *
 *  Subclasses made for each rule and grammar track the parameters,
 *  return values, locals, and labels specific to that rule. These
 *  are the objects that are returned from rules.
 *
 *  Note text is not an actual field of a rule return value; it is computed
 *  from start and stop using the input stream's toString() method.  I
 *  could add a ctor to this so that we can pass in and store the input
 *  stream, but I'm not sure we want to do that.  It would seem to be undefined
 *  to get the .text property anyway if the rule matches tokens from multiple
 *  input streams.
 *
 *  I do not use getters for fields of objects that are used simply to
 *  group values such as this aggregate.  The getters/setters are there to
 *  satisfy the superclass interface.
 */ class $4804f857ecc73c01$var$ParserRuleContext extends $c8jEe.RuleContext {
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber == null) super();
        else super(parent, invokingStateNumber);
    }
    static emptyContext() {
        return $4804f857ecc73c01$var$ParserRuleContext.EMPTY;
    }
    /**
     * COPY a ctx (I'm deliberately not using copy constructor) to avoid
     * confusion with creating node with parent. Does not copy children
     * (except error leaves).
     *
     * This is used in the generated parser code to flip a generic XContext
     * node for rule X to a YContext for alt label Y. In that sense, it is not
     * really a generic copy function.
     *
     * If we do an error sync() at start of a rule, we might add error nodes
     * to the generic XContext so this function must copy those nodes to the
     * YContext as well else they are lost!
     */ copyFrom(ctx) {
        this._parent = ctx._parent;
        this.invokingState = ctx.invokingState;
        this._start = ctx._start;
        this._stop = ctx._stop;
        // copy any error nodes to alt label node
        if (ctx.children) {
            this.children = [];
            // reset parent pointer for any error nodes
            for (let child of ctx.children)if (child instanceof $cdCft.ErrorNode) this.addChild(child);
        }
    }
    // Double dispatch methods for listeners
    enterRule(listener) {
    // intentionally empty
    }
    exitRule(listener) {
    // intentionally empty
    }
    /** Add a parse tree node to this as a child.  Works for
     *  internal and leaf nodes. Does not set parent link;
     *  other add methods must do that. Other addChild methods
     *  call this.
     *
     *  We cannot set the parent pointer of the incoming node
     *  because the existing interfaces do not have a setParent()
     *  method and I don't want to break backward compatibility for this.
     *
     *  @since 4.7
     */ addAnyChild(t) {
        if (!this.children) this.children = [
            t
        ];
        else this.children.push(t);
        return t;
    }
    addChild(t) {
        let result;
        if (t instanceof $kYC92.TerminalNode) {
            t.setParent(this);
            this.addAnyChild(t);
            return;
        } else if (t instanceof $c8jEe.RuleContext) {
            // Does not set parent link
            this.addAnyChild(t);
            return;
        } else {
            // Deprecated code path
            t = new $kYC92.TerminalNode(t);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    addErrorNode(node) {
        if (node instanceof $cdCft.ErrorNode) {
            const errorNode = node;
            errorNode.setParent(this);
            return this.addAnyChild(errorNode);
        } else {
            // deprecated path
            const badToken = node;
            let t = new $cdCft.ErrorNode(badToken);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    //	public void trace(int s) {
    //		if ( states==null ) states = new ArrayList<Integer>();
    //		states.add(s);
    //	}
    /** Used by enterOuterAlt to toss out a RuleContext previously added as
     *  we entered a rule. If we have # label, we will need to remove
     *  generic ruleContext object.
     */ removeLastChild() {
        if (this.children) this.children.pop();
    }
    get parent() {
        let parent = super.parent;
        if (parent === undefined || parent instanceof $4804f857ecc73c01$var$ParserRuleContext) return parent;
        throw new TypeError("Invalid parent type for ParserRuleContext");
    }
    // Note: in TypeScript, order or arguments reversed
    getChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) throw new RangeError("index parameter must be between >= 0 and <= number of children.");
        if (ctxType == null) return this.children[i];
        let result = this.tryGetChild(i, ctxType);
        if (result === undefined) throw new Error("The specified node does not exist");
        return result;
    }
    tryGetChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what node with ctxType have we found?
        for (let o of this.children)if (o instanceof ctxType) {
            j++;
            if (j === i) return o;
        }
        return undefined;
    }
    getToken(ttype, i) {
        let result = this.tryGetToken(ttype, i);
        if (result === undefined) throw new Error("The specified token does not exist");
        return result;
    }
    tryGetToken(ttype, i) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what token with ttype have we found?
        for (let o of this.children)if (o instanceof $kYC92.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) {
                j++;
                if (j === i) return o;
            }
        }
        return undefined;
    }
    getTokens(ttype) {
        let tokens = [];
        if (!this.children) return tokens;
        for (let o of this.children)if (o instanceof $kYC92.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) tokens.push(o);
        }
        return tokens;
    }
    get ruleContext() {
        return this;
    }
    // NOTE: argument order change from Java version
    getRuleContext(i, ctxType) {
        return this.getChild(i, ctxType);
    }
    tryGetRuleContext(i, ctxType) {
        return this.tryGetChild(i, ctxType);
    }
    getRuleContexts(ctxType) {
        let contexts = [];
        if (!this.children) return contexts;
        for (let o of this.children)if (o instanceof ctxType) contexts.push(o);
        return contexts;
    }
    get childCount() {
        return this.children ? this.children.length : 0;
    }
    get sourceInterval() {
        if (!this._start) return $gcfUE.Interval.INVALID;
        if (!this._stop || this._stop.tokenIndex < this._start.tokenIndex) return $gcfUE.Interval.of(this._start.tokenIndex, this._start.tokenIndex - 1); // empty
        return $gcfUE.Interval.of(this._start.tokenIndex, this._stop.tokenIndex);
    }
    /**
     * Get the initial token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may exceed stop.
     */ get start() {
        return this._start;
    }
    /**
     * Get the final token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may precede start.
     */ get stop() {
        return this._stop;
    }
    /** Used for rule context info debugging during parse-time, not so much for ATN debugging */ toInfoString(recognizer) {
        let rules = recognizer.getRuleInvocationStack(this).reverse();
        return "ParserRuleContext" + rules + "{" + "start=" + this._start + ", stop=" + this._stop + "}";
    }
}
$4804f857ecc73c01$var$ParserRuleContext.EMPTY = new $4804f857ecc73c01$var$ParserRuleContext();
$4804f857ecc73c01$var$__decorate([
    $d6D31.Override
], $4804f857ecc73c01$var$ParserRuleContext.prototype, "parent", null);
$4804f857ecc73c01$var$__decorate([
    $d6D31.Override
], $4804f857ecc73c01$var$ParserRuleContext.prototype, "childCount", null);
$4804f857ecc73c01$var$__decorate([
    $d6D31.Override
], $4804f857ecc73c01$var$ParserRuleContext.prototype, "sourceInterval", null);
module.exports.ParserRuleContext = $4804f857ecc73c01$var$ParserRuleContext;

});
parcelRegister("cdCft", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8e545e4dd69efabc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorNode = void 0;

var $d6D31 = parcelRequire("d6D31");

var $kYC92 = parcelRequire("kYC92");
/** Represents a token that was consumed during resynchronization
 *  rather than during a valid match operation. For example,
 *  we will create this kind of a node during single token insertion
 *  and deletion as well as during "consume until error recovery set"
 *  upon no viable alternative exceptions.
 */ class $8e545e4dd69efabc$var$ErrorNode extends $kYC92.TerminalNode {
    constructor(token){
        super(token);
    }
    accept(visitor) {
        return visitor.visitErrorNode(this);
    }
}
$8e545e4dd69efabc$var$__decorate([
    $d6D31.Override
], $8e545e4dd69efabc$var$ErrorNode.prototype, "accept", null);
module.exports.ErrorNode = $8e545e4dd69efabc$var$ErrorNode;

});
parcelRegister("kYC92", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f4570001c9e8b34c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TerminalNode = void 0;

var $gcfUE = parcelRequire("gcfUE");

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");
class $f4570001c9e8b34c$var$TerminalNode {
    constructor(symbol){
        this._symbol = symbol;
    }
    getChild(i) {
        throw new RangeError("Terminal Node has no children.");
    }
    get symbol() {
        return this._symbol;
    }
    get parent() {
        return this._parent;
    }
    setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this._symbol;
    }
    get sourceInterval() {
        let tokenIndex = this._symbol.tokenIndex;
        return new $gcfUE.Interval(tokenIndex, tokenIndex);
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitTerminal(this);
    }
    get text() {
        return this._symbol.text || "";
    }
    toStringTree(parser) {
        return this.toString();
    }
    toString() {
        if (this._symbol.type === $2DVsz.Token.EOF) return "<EOF>";
        return this._symbol.text || "";
    }
}
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "getChild", null);
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "parent", null);
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "setParent", null);
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "payload", null);
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "sourceInterval", null);
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "childCount", null);
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "accept", null);
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "text", null);
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "toStringTree", null);
$f4570001c9e8b34c$var$__decorate([
    $d6D31.Override
], $f4570001c9e8b34c$var$TerminalNode.prototype, "toString", null);
module.exports.TerminalNode = $f4570001c9e8b34c$var$TerminalNode;

});


parcelRegister("c8jEe", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8d557908ece2e6d0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContext = void 0;

var $bcnvE = parcelRequire("bcnvE");

var $kBaAZ = parcelRequire("kBaAZ");

var $2WQcE = parcelRequire("2WQcE");

var $gcfUE = parcelRequire("gcfUE");

var $d6D31 = parcelRequire("d6D31");

var $axprj = parcelRequire("axprj");

var $6bmaO = parcelRequire("6bmaO");
/** A rule context is a record of a single rule invocation.
 *
 *  We form a stack of these context objects using the parent
 *  pointer. A parent pointer of `undefined` indicates that the current
 *  context is the bottom of the stack. The ParserRuleContext subclass
 *  as a children list so that we can turn this data structure into a
 *  tree.
 *
 *  The root node always has a `undefined` pointer and invokingState of -1.
 *
 *  Upon entry to parsing, the first invoked rule function creates a
 *  context object (a subclass specialized for that rule such as
 *  SContext) and makes it the root of a parse tree, recorded by field
 *  Parser._ctx.
 *
 *  public final SContext s() throws RecognitionException {
 *      SContext _localctx = new SContext(_ctx, state); <-- create new node
 *      enterRule(_localctx, 0, RULE_s);                     <-- push it
 *      ...
 *      exitRule();                                          <-- pop back to _localctx
 *      return _localctx;
 *  }
 *
 *  A subsequent rule invocation of r from the start rule s pushes a
 *  new context object for r whose parent points at s and use invoking
 *  state is the state with r emanating as edge label.
 *
 *  The invokingState fields from a context object to the root
 *  together form a stack of rule indication states where the root
 *  (bottom of the stack) has a -1 sentinel value. If we invoke start
 *  symbol s then call r1, which calls r2, the  would look like
 *  this:
 *
 *     SContext[-1]   <- root node (bottom of the stack)
 *     R1Context[p]   <- p in rule s called r1
 *     R2Context[q]   <- q in rule r1 called r2
 *
 *  So the top of the stack, _ctx, represents a call to the current
 *  rule and it holds the return address from another rule that invoke
 *  to this rule. To invoke a rule, we must always have a current context.
 *
 *  The parent contexts are useful for computing lookahead sets and
 *  getting error information.
 *
 *  These objects are used during parsing and prediction.
 *  For the special case of parsers, we use the subclass
 *  ParserRuleContext.
 *
 *  @see ParserRuleContext
 */ class $8d557908ece2e6d0$var$RuleContext extends $2WQcE.RuleNode {
    constructor(parent, invokingState){
        super();
        this._parent = parent;
        this.invokingState = invokingState != null ? invokingState : -1;
    }
    static getChildContext(parent, invokingState) {
        return new $8d557908ece2e6d0$var$RuleContext(parent, invokingState);
    }
    depth() {
        let n = 0;
        let p = this;
        while(p){
            p = p._parent;
            n++;
        }
        return n;
    }
    /** A context is empty if there is no invoking state; meaning nobody called
     *  current context.
     */ get isEmpty() {
        return this.invokingState === -1;
    }
    // satisfy the ParseTree / SyntaxTree interface
    get sourceInterval() {
        return $gcfUE.Interval.INVALID;
    }
    get ruleContext() {
        return this;
    }
    get parent() {
        return this._parent;
    }
    /** @since 4.7. {@see ParseTree#setParent} comment */ setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this;
    }
    /** Return the combined text of all child nodes. This method only considers
     *  tokens which have been added to the parse tree.
     *
     *  Since tokens on hidden channels (e.g. whitespace or comments) are not
     *  added to the parse trees, they will not appear in the output of this
     *  method.
     */ get text() {
        if (this.childCount === 0) return "";
        let builder = "";
        for(let i = 0; i < this.childCount; i++)builder += this.getChild(i).text;
        return builder.toString();
    }
    get ruleIndex() {
        return -1;
    }
    /** For rule associated with this parse tree internal node, return
     *  the outer alternative number used to match the input. Default
     *  implementation does not compute nor store this alt num. Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *  to set it.
     *
     *  @since 4.5.3
     */ get altNumber() {
        return $bcnvE.ATN.INVALID_ALT_NUMBER;
    }
    /** Set the outer alternative number for this context node. Default
     *  implementation does nothing to avoid backing field overhead for
     *  trees that don't need it.  Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *
     *  @since 4.5.3
     */ set altNumber(altNumber) {
    // intentionally ignored by the base implementation
    }
    getChild(i) {
        throw new RangeError("i must be greater than or equal to 0 and less than childCount");
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitChildren(this);
    }
    toStringTree(recog) {
        return $axprj.Trees.toStringTree(this, recog);
    }
    toString(arg1, stop) {
        const ruleNames = arg1 instanceof $kBaAZ.Recognizer ? arg1.ruleNames : arg1;
        stop = stop || $6bmaO.ParserRuleContext.emptyContext();
        let buf = "";
        let p = this;
        buf += "[";
        while(p && p !== stop){
            if (!ruleNames) {
                if (!p.isEmpty) buf += p.invokingState;
            } else {
                let ruleIndex = p.ruleIndex;
                let ruleName = ruleIndex >= 0 && ruleIndex < ruleNames.length ? ruleNames[ruleIndex] : ruleIndex.toString();
                buf += ruleName;
            }
            if (p._parent && (ruleNames || !p._parent.isEmpty)) buf += " ";
            p = p._parent;
        }
        buf += "]";
        return buf.toString();
    }
}
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "sourceInterval", null);
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "ruleContext", null);
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "parent", null);
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "setParent", null);
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "payload", null);
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "text", null);
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "getChild", null);
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "childCount", null);
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "accept", null);
$8d557908ece2e6d0$var$__decorate([
    $d6D31.Override
], $8d557908ece2e6d0$var$RuleContext.prototype, "toStringTree", null);
module.exports.RuleContext = $8d557908ece2e6d0$var$RuleContext;

});
parcelRegister("2WQcE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleNode = void 0;
class $22597dffc9942eb7$var$RuleNode {
}
module.exports.RuleNode = $22597dffc9942eb7$var$RuleNode;

});

parcelRegister("axprj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7ac0b835c35ad12a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7ac0b835c35ad12a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Trees = void 0;

var $bcnvE = parcelRequire("bcnvE");

var $j53rr = parcelRequire("j53rr");

var $cdCft = parcelRequire("cdCft");

var $d6D31 = parcelRequire("d6D31");

var $jIG0W = parcelRequire("jIG0W");

var $6bmaO = parcelRequire("6bmaO");

var $2WQcE = parcelRequire("2WQcE");

var $kYC92 = parcelRequire("kYC92");

var $2DVsz = parcelRequire("2DVsz");

var $2IEP9 = parcelRequire("2IEP9");
/** A set of utility routines useful for all kinds of ANTLR trees. */ class $7ac0b835c35ad12a$var$Trees {
    static toStringTree(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $jIG0W.Parser) ruleNames = arg2.ruleNames;
        else ruleNames = arg2;
        let s = $2IEP9.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        if (t.childCount === 0) return s;
        let buf = "";
        buf += "(";
        s = $2IEP9.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        buf += s;
        buf += " ";
        for(let i = 0; i < t.childCount; i++){
            if (i > 0) buf += " ";
            buf += this.toStringTree(t.getChild(i), ruleNames);
        }
        buf += ")";
        return buf;
    }
    static getNodeText(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $jIG0W.Parser) ruleNames = arg2.ruleNames;
        else if (arg2) ruleNames = arg2;
        else {
            // no recog or rule names
            let payload = t.payload;
            if (typeof payload.text === "string") return payload.text;
            return t.payload.toString();
        }
        if (t instanceof $2WQcE.RuleNode) {
            let ruleContext = t.ruleContext;
            let ruleIndex = ruleContext.ruleIndex;
            let ruleName = ruleNames[ruleIndex];
            let altNumber = ruleContext.altNumber;
            if (altNumber !== $bcnvE.ATN.INVALID_ALT_NUMBER) return ruleName + ":" + altNumber;
            return ruleName;
        } else if (t instanceof $cdCft.ErrorNode) return t.toString();
        else if (t instanceof $kYC92.TerminalNode) {
            let symbol = t.symbol;
            return symbol.text || "";
        }
        throw new TypeError("Unexpected node type");
    }
    static getChildren(t) {
        let kids = [];
        for(let i = 0; i < t.childCount; i++)kids.push(t.getChild(i));
        return kids;
    }
    static getAncestors(t) {
        let ancestors = [];
        let p = t.parent;
        while(p){
            ancestors.unshift(p); // insert at start
            p = p.parent;
        }
        return ancestors;
    }
    /** Return true if t is u's parent or a node on path to root from u.
     *  Use === not equals().
     *
     *  @since 4.5.1
     */ static isAncestorOf(t, u) {
        if (!t || !u || !t.parent) return false;
        let p = u.parent;
        while(p){
            if (t === p) return true;
            p = p.parent;
        }
        return false;
    }
    static findAllTokenNodes(t, ttype) {
        return $7ac0b835c35ad12a$var$Trees.findAllNodes(t, ttype, true);
    }
    static findAllRuleNodes(t, ruleIndex) {
        return $7ac0b835c35ad12a$var$Trees.findAllNodes(t, ruleIndex, false);
    }
    static findAllNodes(t, index, findTokens) {
        let nodes = [];
        $7ac0b835c35ad12a$var$Trees._findAllNodes(t, index, findTokens, nodes);
        return nodes;
    }
    static _findAllNodes(t, index, findTokens, nodes) {
        // check this node (the root) first
        if (findTokens && t instanceof $kYC92.TerminalNode) {
            if (t.symbol.type === index) nodes.push(t);
        } else if (!findTokens && t instanceof $6bmaO.ParserRuleContext) {
            if (t.ruleIndex === index) nodes.push(t);
        }
        // check children
        for(let i = 0; i < t.childCount; i++)$7ac0b835c35ad12a$var$Trees._findAllNodes(t.getChild(i), index, findTokens, nodes);
    }
    /** Get all descendents; includes t itself.
     *
     * @since 4.5.1
     */ static getDescendants(t) {
        let nodes = [];
        function recurse(e) {
            nodes.push(e);
            const n = e.childCount;
            for(let i = 0; i < n; i++)recurse(e.getChild(i));
        }
        recurse(t);
        return nodes;
    }
    /** Find smallest subtree of t enclosing range startTokenIndex..stopTokenIndex
     *  inclusively using postorder traversal.  Recursive depth-first-search.
     *
     *  @since 4.5
     */ static getRootOfSubtreeEnclosingRegion(t, startTokenIndex, stopTokenIndex) {
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let child = t.getChild(i);
            let r = $7ac0b835c35ad12a$var$Trees.getRootOfSubtreeEnclosingRegion(child, startTokenIndex, stopTokenIndex);
            if (r) return r;
        }
        if (t instanceof $6bmaO.ParserRuleContext) {
            let stopToken = t.stop;
            if (startTokenIndex >= t.start.tokenIndex && // is range fully contained in t?
            (stopToken == null || stopTokenIndex <= stopToken.tokenIndex)) // note: r.stop==null likely implies that we bailed out of parser and there's nothing to the right
            return t;
        }
        return undefined;
    }
    /** Replace any subtree siblings of root that are completely to left
     *  or right of lookahead range with a CommonToken(Token.INVALID_TYPE,"...")
     *  node. The source interval for t is not altered to suit smaller range!
     *
     *  WARNING: destructive to t.
     *
     *  @since 4.5.1
     */ static stripChildrenOutOfRange(t, root, startIndex, stopIndex) {
        if (!t) return;
        let count = t.childCount;
        for(let i = 0; i < count; i++){
            let child = t.getChild(i);
            let range = child.sourceInterval;
            if (child instanceof $6bmaO.ParserRuleContext && (range.b < startIndex || range.a > stopIndex)) {
                if ($7ac0b835c35ad12a$var$Trees.isAncestorOf(child, root)) {
                    let abbrev = new $j53rr.CommonToken($2DVsz.Token.INVALID_TYPE, "...");
                    t.children[i] = new $kYC92.TerminalNode(abbrev); // HACK access to private
                }
            }
        }
    }
    static findNodeSuchThat(t, pred) {
        // No type check needed as long as users only use one of the available overloads
        if (pred(t)) return t;
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let u = $7ac0b835c35ad12a$var$Trees.findNodeSuchThat(t.getChild(i), pred);
            if (u !== undefined) return u;
        }
        return undefined;
    }
}
$7ac0b835c35ad12a$var$__decorate([
    $7ac0b835c35ad12a$var$__param(0, $d6D31.NotNull)
], $7ac0b835c35ad12a$var$Trees, "toStringTree", null);
$7ac0b835c35ad12a$var$__decorate([
    $d6D31.NotNull,
    $7ac0b835c35ad12a$var$__param(0, $d6D31.NotNull)
], $7ac0b835c35ad12a$var$Trees, "getAncestors", null);
$7ac0b835c35ad12a$var$__decorate([
    $7ac0b835c35ad12a$var$__param(0, $d6D31.NotNull)
], $7ac0b835c35ad12a$var$Trees, "getRootOfSubtreeEnclosingRegion", null);
module.exports.Trees = $7ac0b835c35ad12a$var$Trees;

});



parcelRegister("gDZVV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c1e05489d1cdbc78$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionMode = void 0;

var $fP17P = parcelRequire("fP17P");

var $iXFjm = parcelRequire("iXFjm");

var $d6D31 = parcelRequire("d6D31");

var $4kGBm = parcelRequire("4kGBm");
/**
 * This enumeration defines the prediction modes available in ANTLR 4 along with
 * utility methods for analyzing configuration sets for conflicts and/or
 * ambiguities.
 */ var $c1e05489d1cdbc78$var$PredictionMode;
(function(PredictionMode) {
    /**
     * The SLL(*) prediction mode. This prediction mode ignores the current
     * parser context when making predictions. This is the fastest prediction
     * mode, and provides correct results for many grammars. This prediction
     * mode is more powerful than the prediction mode provided by ANTLR 3, but
     * may result in syntax errors for grammar and input combinations which are
     * not SLL.
     *
     * When using this prediction mode, the parser will either return a correct
     * parse tree (i.e. the same parse tree that would be returned with the
     * {@link #LL} prediction mode), or it will report a syntax error. If a
     * syntax error is encountered when using the {@link #SLL} prediction mode,
     * it may be due to either an actual syntax error in the input or indicate
     * that the particular combination of grammar and input requires the more
     * powerful {@link #LL} prediction abilities to complete successfully.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["SLL"] = 0] = "SLL";
    /**
     * The LL(*) prediction mode. This prediction mode allows the current parser
     * context to be used for resolving SLL conflicts that occur during
     * prediction. This is the fastest prediction mode that guarantees correct
     * parse results for all combinations of grammars with syntactically correct
     * inputs.
     *
     * When using this prediction mode, the parser will make correct decisions
     * for all syntactically-correct grammar and input combinations. However, in
     * cases where the grammar is truly ambiguous this prediction mode might not
     * report a precise answer for *exactly which* alternatives are
     * ambiguous.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL"] = 1] = "LL";
    /**
     * The LL(*) prediction mode with exact ambiguity detection. In addition to
     * the correctness guarantees provided by the {@link #LL} prediction mode,
     * this prediction mode instructs the prediction algorithm to determine the
     * complete and exact set of ambiguous alternatives for every ambiguous
     * decision encountered while parsing.
     *
     * This prediction mode may be used for diagnosing ambiguities during
     * grammar development. Due to the performance overhead of calculating sets
     * of ambiguous alternatives, this prediction mode should be avoided when
     * the exact results are not necessary.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL_EXACT_AMBIG_DETECTION"] = 2] = "LL_EXACT_AMBIG_DETECTION";
})($c1e05489d1cdbc78$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));
(function(PredictionMode) {
    /** A Map that uses just the state and the stack context as the key. */ // NOTE: Base type used to be FlexibleHashMap<ATNConfig, BitSet>
    class AltAndContextMap extends $fP17P.Array2DHashMap {
        constructor(){
            super(AltAndContextConfigEqualityComparator.INSTANCE);
        }
    }
    class AltAndContextConfigEqualityComparator {
        AltAndContextConfigEqualityComparator() {
        // intentionally empty
        }
        /**
         * The hash code is only a function of the {@link ATNState#stateNumber}
         * and {@link ATNConfig#context}.
         */ hashCode(o) {
            let hashCode = $iXFjm.MurmurHash.initialize(7);
            hashCode = $iXFjm.MurmurHash.update(hashCode, o.state.stateNumber);
            hashCode = $iXFjm.MurmurHash.update(hashCode, o.context);
            hashCode = $iXFjm.MurmurHash.finish(hashCode, 2);
            return hashCode;
        }
        equals(a, b) {
            if (a === b) return true;
            if (a == null || b == null) return false;
            return a.state.stateNumber === b.state.stateNumber && a.context.equals(b.context);
        }
    }
    AltAndContextConfigEqualityComparator.INSTANCE = new AltAndContextConfigEqualityComparator();
    $c1e05489d1cdbc78$var$__decorate([
        $d6D31.Override
    ], AltAndContextConfigEqualityComparator.prototype, "hashCode", null);
    $c1e05489d1cdbc78$var$__decorate([
        $d6D31.Override
    ], AltAndContextConfigEqualityComparator.prototype, "equals", null);
    /**
     * Checks if any configuration in `configs` is in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if any configuration in `configs` is in a
     * {@link RuleStopState}, otherwise `false`
     */ function hasConfigInRuleStopState(configs) {
        for (let c of configs){
            if (c.state instanceof $4kGBm.RuleStopState) return true;
        }
        return false;
    }
    PredictionMode.hasConfigInRuleStopState = hasConfigInRuleStopState;
    /**
     * Checks if all configurations in `configs` are in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if all configurations in `configs` are in a
     * {@link RuleStopState}, otherwise `false`
     */ function allConfigsInRuleStopStates(/*@NotNull*/ configs) {
        for (let config of configs){
            if (!(config.state instanceof $4kGBm.RuleStopState)) return false;
        }
        return true;
    }
    PredictionMode.allConfigsInRuleStopStates = allConfigsInRuleStopStates;
})($c1e05489d1cdbc78$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));

});

parcelRegister("g7SCF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bbd7abb561fe52b9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $bbd7abb561fe52b9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimulatorState = void 0;

var $d6D31 = parcelRequire("d6D31");

var $6bmaO = parcelRequire("6bmaO");
/**
 *
 * @author Sam Harwell
 */ let $bbd7abb561fe52b9$var$SimulatorState = class SimulatorState {
    constructor(outerContext, s0, useContext, remainingOuterContext){
        this.outerContext = outerContext != null ? outerContext : $6bmaO.ParserRuleContext.emptyContext();
        this.s0 = s0;
        this.useContext = useContext;
        this.remainingOuterContext = remainingOuterContext;
    }
};
$bbd7abb561fe52b9$var$SimulatorState = $bbd7abb561fe52b9$var$__decorate([
    $bbd7abb561fe52b9$var$__param(1, $d6D31.NotNull)
], $bbd7abb561fe52b9$var$SimulatorState);
module.exports.SimulatorState = $bbd7abb561fe52b9$var$SimulatorState;

});


parcelRegister("d1V7w", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $97c7ad4039a43616$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusBlockStartState = void 0;

var $1bs3X = parcelRequire("1bs3X");

var $65vNG = parcelRequire("65vNG");

var $d6D31 = parcelRequire("d6D31");
/** Start of `(A|B|...)+` loop. Technically a decision state, but
 *  we don't use for code generation; somebody might need it, so I'm defining
 *  it for completeness. In reality, the {@link PlusLoopbackState} node is the
 *  real decision-making note for `A+`.
 */ class $97c7ad4039a43616$var$PlusBlockStartState extends $65vNG.BlockStartState {
    get stateType() {
        return $1bs3X.ATNStateType.PLUS_BLOCK_START;
    }
}
$97c7ad4039a43616$var$__decorate([
    $d6D31.Override
], $97c7ad4039a43616$var$PlusBlockStartState.prototype, "stateType", null);
module.exports.PlusBlockStartState = $97c7ad4039a43616$var$PlusBlockStartState;

});

parcelRegister("7qlbM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $567b65d0d9bb1bcd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusLoopbackState = void 0;

var $1bs3X = parcelRequire("1bs3X");

var $dPYn6 = parcelRequire("dPYn6");

var $d6D31 = parcelRequire("d6D31");
/** Decision state for `A+` and `(A|B)+`.  It has two transitions:
 *  one to the loop back to start of the block and one to exit.
 */ class $567b65d0d9bb1bcd$var$PlusLoopbackState extends $dPYn6.DecisionState {
    get stateType() {
        return $1bs3X.ATNStateType.PLUS_LOOP_BACK;
    }
}
$567b65d0d9bb1bcd$var$__decorate([
    $d6D31.Override
], $567b65d0d9bb1bcd$var$PlusLoopbackState.prototype, "stateType", null);
module.exports.PlusLoopbackState = $567b65d0d9bb1bcd$var$PlusLoopbackState;

});

parcelRegister("7KGEQ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $5a4deb3ba0fdbe62$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5a4deb3ba0fdbe62$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrecedencePredicateTransition = void 0;

var $fMVaR = parcelRequire("fMVaR");

var $d6D31 = parcelRequire("d6D31");

var $eHMgW = parcelRequire("eHMgW");
/**
 *
 * @author Sam Harwell
 */ let $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition = class PrecedencePredicateTransition extends $fMVaR.AbstractPredicateTransition {
    constructor(target, precedence){
        super(target);
        this.precedence = precedence;
    }
    get serializationType() {
        return 10 /* PRECEDENCE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $eHMgW.SemanticContext.PrecedencePredicate(this.precedence);
    }
    toString() {
        return this.precedence + " >= _p";
    }
};
$5a4deb3ba0fdbe62$var$__decorate([
    $d6D31.Override
], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "serializationType", null);
$5a4deb3ba0fdbe62$var$__decorate([
    $d6D31.Override
], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "isEpsilon", null);
$5a4deb3ba0fdbe62$var$__decorate([
    $d6D31.Override
], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "matches", null);
$5a4deb3ba0fdbe62$var$__decorate([
    $d6D31.Override
], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "toString", null);
$5a4deb3ba0fdbe62$var$PrecedencePredicateTransition = $5a4deb3ba0fdbe62$var$__decorate([
    $5a4deb3ba0fdbe62$var$__param(0, $d6D31.NotNull)
], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition);
module.exports.PrecedencePredicateTransition = $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition;

});

parcelRegister("aISkF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7ce828b1bf424f49$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7ce828b1bf424f49$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RangeTransition = void 0;

var $hGRod = parcelRequire("hGRod");

var $d6D31 = parcelRequire("d6D31");

var $5tcOQ = parcelRequire("5tcOQ");
let $7ce828b1bf424f49$var$RangeTransition = class RangeTransition extends $5tcOQ.Transition {
    constructor(target, from, to){
        super(target);
        this.from = from;
        this.to = to;
    }
    get serializationType() {
        return 2 /* RANGE */ ;
    }
    get label() {
        return $hGRod.IntervalSet.of(this.from, this.to);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= this.from && symbol <= this.to;
    }
    toString() {
        return "'" + String.fromCodePoint(this.from) + "'..'" + String.fromCodePoint(this.to) + "'";
    }
};
$7ce828b1bf424f49$var$__decorate([
    $d6D31.Override
], $7ce828b1bf424f49$var$RangeTransition.prototype, "serializationType", null);
$7ce828b1bf424f49$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $7ce828b1bf424f49$var$RangeTransition.prototype, "label", null);
$7ce828b1bf424f49$var$__decorate([
    $d6D31.Override
], $7ce828b1bf424f49$var$RangeTransition.prototype, "matches", null);
$7ce828b1bf424f49$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull
], $7ce828b1bf424f49$var$RangeTransition.prototype, "toString", null);
$7ce828b1bf424f49$var$RangeTransition = $7ce828b1bf424f49$var$__decorate([
    $7ce828b1bf424f49$var$__param(0, $d6D31.NotNull)
], $7ce828b1bf424f49$var$RangeTransition);
module.exports.RangeTransition = $7ce828b1bf424f49$var$RangeTransition;

});

parcelRegister("j2zc8", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ddc981289e81a506$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStartState = void 0;

var $7j0Pc = parcelRequire("7j0Pc");

var $1bs3X = parcelRequire("1bs3X");

var $d6D31 = parcelRequire("d6D31");
class $ddc981289e81a506$var$RuleStartState extends $7j0Pc.ATNState {
    constructor(){
        super(...arguments);
        this.isPrecedenceRule = false;
        this.leftFactored = false;
    }
    get stateType() {
        return $1bs3X.ATNStateType.RULE_START;
    }
}
$ddc981289e81a506$var$__decorate([
    $d6D31.Override
], $ddc981289e81a506$var$RuleStartState.prototype, "stateType", null);
module.exports.RuleStartState = $ddc981289e81a506$var$RuleStartState;

});

parcelRegister("jEsaF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e4e79af439480b0e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarBlockStartState = void 0;

var $1bs3X = parcelRequire("1bs3X");

var $65vNG = parcelRequire("65vNG");

var $d6D31 = parcelRequire("d6D31");
/** The block that begins a closure loop. */ class $e4e79af439480b0e$var$StarBlockStartState extends $65vNG.BlockStartState {
    get stateType() {
        return $1bs3X.ATNStateType.STAR_BLOCK_START;
    }
}
$e4e79af439480b0e$var$__decorate([
    $d6D31.Override
], $e4e79af439480b0e$var$StarBlockStartState.prototype, "stateType", null);
module.exports.StarBlockStartState = $e4e79af439480b0e$var$StarBlockStartState;

});

parcelRegister("bjwd1", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $83ca741f127bc1b0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopbackState = void 0;

var $7j0Pc = parcelRequire("7j0Pc");

var $1bs3X = parcelRequire("1bs3X");

var $d6D31 = parcelRequire("d6D31");
class $83ca741f127bc1b0$var$StarLoopbackState extends $7j0Pc.ATNState {
    get loopEntryState() {
        return this.transition(0).target;
    }
    get stateType() {
        return $1bs3X.ATNStateType.STAR_LOOP_BACK;
    }
}
$83ca741f127bc1b0$var$__decorate([
    $d6D31.Override
], $83ca741f127bc1b0$var$StarLoopbackState.prototype, "stateType", null);
module.exports.StarLoopbackState = $83ca741f127bc1b0$var$StarLoopbackState;

});

parcelRegister("WS4d7", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0b0f5b750847d473$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokensStartState = void 0;

var $1bs3X = parcelRequire("1bs3X");

var $dPYn6 = parcelRequire("dPYn6");

var $d6D31 = parcelRequire("d6D31");
/** The Tokens rule start state linking to each lexer rule start state */ class $0b0f5b750847d473$var$TokensStartState extends $dPYn6.DecisionState {
    get stateType() {
        return $1bs3X.ATNStateType.TOKEN_START;
    }
}
$0b0f5b750847d473$var$__decorate([
    $d6D31.Override
], $0b0f5b750847d473$var$TokensStartState.prototype, "stateType", null);
module.exports.TokensStartState = $0b0f5b750847d473$var$TokensStartState;

});

parcelRegister("kWxOc", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UUID = void 0;

var $iXFjm = parcelRequire("iXFjm");
class $f3f3731a7838b7f9$var$UUID {
    constructor(mostSigBits, moreSigBits, lessSigBits, leastSigBits){
        this.data = new Uint32Array(4);
        this.data[0] = mostSigBits;
        this.data[1] = moreSigBits;
        this.data[2] = lessSigBits;
        this.data[3] = leastSigBits;
    }
    static fromString(data) {
        if (!/^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(data)) throw new Error("Incorrectly formatted UUID");
        let segments = data.split("-");
        let mostSigBits = parseInt(segments[0], 16);
        let moreSigBits = (parseInt(segments[1], 16) << 16 >>> 0) + parseInt(segments[2], 16);
        let lessSigBits = (parseInt(segments[3], 16) << 16 >>> 0) + parseInt(segments[4].substr(0, 4), 16);
        let leastSigBits = parseInt(segments[4].substr(-8), 16);
        return new $f3f3731a7838b7f9$var$UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    hashCode() {
        return $iXFjm.MurmurHash.hashCode([
            this.data[0],
            this.data[1],
            this.data[2],
            this.data[3]
        ]);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $f3f3731a7838b7f9$var$UUID)) return false;
        return this.data[0] === obj.data[0] && this.data[1] === obj.data[1] && this.data[2] === obj.data[2] && this.data[3] === obj.data[3];
    }
    toString() {
        return ("00000000" + this.data[0].toString(16)).substr(-8) + "-" + ("0000" + (this.data[1] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[1].toString(16)).substr(-4) + "-" + ("0000" + (this.data[2] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[2].toString(16)).substr(-4) + ("00000000" + this.data[3].toString(16)).substr(-8);
    }
}
module.exports.UUID = $f3f3731a7838b7f9$var$UUID;

});


parcelRegister("3iOjI", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $267a15775466fb93$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $267a15775466fb93$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseInfo = void 0;

var $d6D31 = parcelRequire("d6D31");
/**
 * This class provides access to specific and aggregate statistics gathered
 * during profiling of a parser.
 *
 * @since 4.3
 */ let $267a15775466fb93$var$ParseInfo = class ParseInfo {
    constructor(atnSimulator){
        this.atnSimulator = atnSimulator;
    }
    /**
     * Gets an array of {@link DecisionInfo} instances containing the profiling
     * information gathered for each decision in the ATN.
     *
     * @returns An array of {@link DecisionInfo} instances, indexed by decision
     * number.
     */ getDecisionInfo() {
        return this.atnSimulator.getDecisionInfo();
    }
    /**
     * Gets the decision numbers for decisions that required one or more
     * full-context predictions during parsing. These are decisions for which
     * {@link DecisionInfo#LL_Fallback} is non-zero.
     *
     * @returns A list of decision numbers which required one or more
     * full-context predictions during parsing.
     */ getLLDecisions() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let LL = [];
        for(let i = 0; i < decisions.length; i++){
            let fallBack = decisions[i].LL_Fallback;
            if (fallBack > 0) LL.push(i);
        }
        return LL;
    }
    /**
     * Gets the total time spent during prediction across all decisions made
     * during parsing. This value is the sum of
     * {@link DecisionInfo#timeInPrediction} for all decisions.
     */ getTotalTimeInPrediction() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let t = 0;
        for (let decision of decisions)t += decision.timeInPrediction;
        return t;
    }
    /**
     * Gets the total number of SLL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#SLL_TotalLook} for all decisions.
     */ getTotalSLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of LL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#LL_TotalLook} for all decisions.
     */ getTotalLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL prediction
     * across all decisions made during parsing.
     */ getTotalSLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for LL prediction
     * across all decisions made during parsing.
     */ getTotalLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL and LL
     * prediction across all decisions made during parsing.
     *
     * This value is the sum of {@link #getTotalSLLATNLookaheadOps} and
     * {@link #getTotalLLATNLookaheadOps}.
     */ getTotalATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions){
            k += decision.SLL_ATNTransitions;
            k += decision.LL_ATNTransitions;
        }
        return k;
    }
    getDFASize(decision) {
        if (decision) {
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA[decision];
            return decisionToDFA.states.size;
        } else {
            let n = 0;
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA;
            for(let i = 0; i < decisionToDFA.length; i++)n += this.getDFASize(i);
            return n;
        }
    }
};
$267a15775466fb93$var$__decorate([
    $d6D31.NotNull
], $267a15775466fb93$var$ParseInfo.prototype, "getDecisionInfo", null);
$267a15775466fb93$var$__decorate([
    $d6D31.NotNull
], $267a15775466fb93$var$ParseInfo.prototype, "getLLDecisions", null);
$267a15775466fb93$var$ParseInfo = $267a15775466fb93$var$__decorate([
    $267a15775466fb93$var$__param(0, $d6D31.NotNull)
], $267a15775466fb93$var$ParseInfo);
module.exports.ParseInfo = $267a15775466fb93$var$ParseInfo;

});

parcelRegister("5xwgp", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $40890fafca7801d5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyParserErrorListener = void 0;

var $65iNZ = parcelRequire("65iNZ");

var $d6D31 = parcelRequire("d6D31");
/**
 * @author Sam Harwell
 */ class $40890fafca7801d5$var$ProxyParserErrorListener extends $65iNZ.ProxyErrorListener {
    constructor(delegates){
        super(delegates);
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAmbiguity) listener.reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        });
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        });
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState);
        });
    }
}
$40890fafca7801d5$var$__decorate([
    $d6D31.Override
], $40890fafca7801d5$var$ProxyParserErrorListener.prototype, "reportAmbiguity", null);
$40890fafca7801d5$var$__decorate([
    $d6D31.Override
], $40890fafca7801d5$var$ProxyParserErrorListener.prototype, "reportAttemptingFullContext", null);
$40890fafca7801d5$var$__decorate([
    $d6D31.Override
], $40890fafca7801d5$var$ProxyParserErrorListener.prototype, "reportContextSensitivity", null);
module.exports.ProxyParserErrorListener = $40890fafca7801d5$var$ProxyParserErrorListener;

});

parcelRegister("gRsTM", function(module, exports) {

let $c468033ce6b7a86f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c468033ce6b7a86f$var$load("1rIkv").then(()=>parcelRequire('gpWGO'));

});

parcelRegister("Px7pN", function(module, exports) {

let $09ae7432c204fde3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $09ae7432c204fde3$var$load("d6qIW").then(()=>parcelRequire('cJzXV'));

});




parcelRegister("3kXUy", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseCancellationException = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:42.5447085-07:00
/**
 * This exception is thrown to cancel a parsing operation. This exception does
 * not extend {@link RecognitionException}, allowing it to bypass the standard
 * error recovery mechanisms. {@link BailErrorStrategy} throws this exception in
 * response to a parse error.
 *
 * @author Sam Harwell
 */ class $26e1b6704997a3f4$var$ParseCancellationException extends Error {
    constructor(cause){
        super(cause.message);
        this.cause = cause;
        this.stack = cause.stack;
    }
    getCause() {
        return this.cause;
    }
}
module.exports.ParseCancellationException = $26e1b6704997a3f4$var$ParseCancellationException;

});


parcelRegister("1UkCC", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $163b0480402006d6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $163b0480402006d6$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BufferedTokenStream = void 0;

var $bbHFU = parcelRequire("bbHFU");

var $j53rr = parcelRequire("j53rr");

var $gcfUE = parcelRequire("gcfUE");

var $igNLf = parcelRequire("igNLf");

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");
/**
 * This implementation of {@link TokenStream} loads tokens from a
 * {@link TokenSource} on-demand, and places the tokens in a buffer to provide
 * access to any previous token by index.
 *
 * This token stream ignores the value of {@link Token#getChannel}. If your
 * parser requires the token stream filter tokens to only those on a particular
 * channel, such as {@link Token#DEFAULT_CHANNEL} or
 * {@link Token#HIDDEN_CHANNEL}, use a filtering token stream such a
 * {@link CommonTokenStream}.
 */ let $163b0480402006d6$var$BufferedTokenStream = class BufferedTokenStream {
    constructor(tokenSource){
        /**
         * A collection of all tokens fetched from the token source. The list is
         * considered a complete view of the input once {@link #fetchedEOF} is set
         * to `true`.
         */ this.tokens = [];
        /**
         * The index into {@link #tokens} of the current token (next token to
         * {@link #consume}). {@link #tokens}`[`{@link #p}`]` should be
         * {@link #LT LT(1)}.
         *
         * This field is set to -1 when the stream is first constructed or when
         * {@link #setTokenSource} is called, indicating that the first token has
         * not yet been fetched from the token source. For additional information,
         * see the documentation of {@link IntStream} for a description of
         * Initializing Methods.
         */ this.p = -1;
        /**
         * Indicates whether the {@link Token#EOF} token has been fetched from
         * {@link #tokenSource} and added to {@link #tokens}. This field improves
         * performance for the following cases:
         *
         * * {@link #consume}: The lookahead check in {@link #consume} to prevent
         *   consuming the EOF symbol is optimized by checking the values of
         *   {@link #fetchedEOF} and {@link #p} instead of calling {@link #LA}.
         * * {@link #fetch}: The check to prevent adding multiple EOF symbols into
         *   {@link #tokens} is trivial with this field.
         */ this.fetchedEOF = false;
        if (tokenSource == null) throw new Error("tokenSource cannot be null");
        this._tokenSource = tokenSource;
    }
    get tokenSource() {
        return this._tokenSource;
    }
    /** Reset this token stream by setting its token source. */ set tokenSource(tokenSource) {
        this._tokenSource = tokenSource;
        this.tokens.length = 0;
        this.p = -1;
        this.fetchedEOF = false;
    }
    get index() {
        return this.p;
    }
    mark() {
        return 0;
    }
    release(marker) {
    // no resources to release
    }
    seek(index) {
        this.lazyInit();
        this.p = this.adjustSeekIndex(index);
    }
    get size() {
        return this.tokens.length;
    }
    consume() {
        let skipEofCheck;
        if (this.p >= 0) {
            if (this.fetchedEOF) // the last token in tokens is EOF. skip check if p indexes any
            // fetched token except the last.
            skipEofCheck = this.p < this.tokens.length - 1;
            else // no EOF token in tokens. skip check if p indexes a fetched token.
            skipEofCheck = this.p < this.tokens.length;
        } else // not yet initialized
        skipEofCheck = false;
        if (!skipEofCheck && this.LA(1) === $2DVsz.Token.EOF) throw new Error("cannot consume EOF");
        if (this.sync(this.p + 1)) this.p = this.adjustSeekIndex(this.p + 1);
    }
    /** Make sure index `i` in tokens has a token.
     *
     * @returns `true` if a token is located at index `i`, otherwise
     *    `false`.
     * @see #get(int i)
     */ sync(i) {
        $bbHFU(i >= 0);
        let n = i - this.tokens.length + 1; // how many more elements we need?
        //System.out.println("sync("+i+") needs "+n);
        if (n > 0) {
            let fetched = this.fetch(n);
            return fetched >= n;
        }
        return true;
    }
    /** Add `n` elements to buffer.
     *
     * @returns The actual number of elements added to the buffer.
     */ fetch(n) {
        if (this.fetchedEOF) return 0;
        for(let i = 0; i < n; i++){
            let t = this.tokenSource.nextToken();
            if (this.isWritableToken(t)) t.tokenIndex = this.tokens.length;
            this.tokens.push(t);
            if (t.type === $2DVsz.Token.EOF) {
                this.fetchedEOF = true;
                return i + 1;
            }
        }
        return n;
    }
    get(i) {
        if (i < 0 || i >= this.tokens.length) throw new RangeError("token index " + i + " out of range 0.." + (this.tokens.length - 1));
        return this.tokens[i];
    }
    /** Get all tokens from start..stop inclusively. */ getRange(start, stop) {
        if (start < 0 || stop < 0) return [];
        this.lazyInit();
        let subset = new Array();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $2DVsz.Token.EOF) break;
            subset.push(t);
        }
        return subset;
    }
    LA(i) {
        let token = this.LT(i);
        if (!token) return $2DVsz.Token.INVALID_TYPE;
        return token.type;
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        return this.tokens[this.p - k];
    }
    LT(k) {
        let result = this.tryLT(k);
        if (result === undefined) throw new RangeError("requested lookback index out of range");
        return result;
    }
    tryLT(k) {
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p + k - 1;
        this.sync(i);
        if (i >= this.tokens.length) // return EOF token
        // EOF must be last token
        return this.tokens[this.tokens.length - 1];
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /**
     * Allowed derived classes to modify the behavior of operations which change
     * the current stream position by adjusting the target token index of a seek
     * operation. The default implementation simply returns `i`. If an
     * exception is thrown in this method, the current stream index should not be
     * changed.
     *
     * For example, {@link CommonTokenStream} overrides this method to ensure that
     * the seek target is always an on-channel token.
     *
     * @param i The target token index.
     * @returns The adjusted target token index.
     */ adjustSeekIndex(i) {
        return i;
    }
    lazyInit() {
        if (this.p === -1) this.setup();
    }
    setup() {
        this.sync(0);
        this.p = this.adjustSeekIndex(0);
    }
    /** Given a start and stop index, return a `List` of all tokens in
     *  the token type `BitSet`.  Return an empty array if no tokens were found.  This
     *  method looks at both on and off channel tokens.
     */ getTokens(start, stop, types) {
        this.lazyInit();
        if (start === undefined) {
            $bbHFU(stop === undefined && types === undefined);
            return this.tokens;
        } else if (stop === undefined) stop = this.tokens.length - 1;
        if (start < 0 || stop >= this.tokens.length || stop < 0 || start >= this.tokens.length) throw new RangeError("start " + start + " or stop " + stop + " not in 0.." + (this.tokens.length - 1));
        if (start > stop) return [];
        if (types === undefined) return this.tokens.slice(start, stop + 1);
        else if (typeof types === "number") types = new Set().add(types);
        let typesSet = types;
        // list = tokens[start:stop]:{T t, t.type in types}
        let filteredTokens = this.tokens.slice(start, stop + 1);
        filteredTokens = filteredTokens.filter((value)=>typesSet.has(value.type));
        return filteredTokens;
    }
    /**
     * Given a starting index, return the index of the next token on channel.
     * Return `i` if `tokens[i]` is on channel. Return the index of
     * the EOF token if there are no tokens on channel between `i` and
     * EOF.
     */ nextTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) return this.size - 1;
        let token = this.tokens[i];
        while(token.channel !== channel){
            if (token.type === $2DVsz.Token.EOF) return i;
            i++;
            this.sync(i);
            token = this.tokens[i];
        }
        return i;
    }
    /**
     * Given a starting index, return the index of the previous token on
     * channel. Return `i` if `tokens[i]` is on channel. Return -1
     * if there are no tokens on channel between `i` and 0.
     *
     * If `i` specifies an index at or after the EOF token, the EOF token
     * index is returned. This is due to the fact that the EOF token is treated
     * as though it were on every channel.
     */ previousTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) // the EOF token is on every channel
        return this.size - 1;
        while(i >= 0){
            let token = this.tokens[i];
            if (token.type === $2DVsz.Token.EOF || token.channel === channel) return i;
            i--;
        }
        return i;
    }
    /** Collect all tokens on specified channel to the right of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL} or
     *  EOF. If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToRight(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        let nextOnChannel = this.nextTokenOnChannel(tokenIndex + 1, $igNLf.Lexer.DEFAULT_TOKEN_CHANNEL);
        let to;
        let from = tokenIndex + 1;
        // if none onchannel to right, nextOnChannel=-1 so set to = last token
        if (nextOnChannel === -1) to = this.size - 1;
        else to = nextOnChannel;
        return this.filterForChannel(from, to, channel);
    }
    /** Collect all tokens on specified channel to the left of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL}.
     *  If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToLeft(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        if (tokenIndex === 0) // obviously no tokens can appear before the first token
        return [];
        let prevOnChannel = this.previousTokenOnChannel(tokenIndex - 1, $igNLf.Lexer.DEFAULT_TOKEN_CHANNEL);
        if (prevOnChannel === tokenIndex - 1) return [];
        // if none onchannel to left, prevOnChannel=-1 then from=0
        let from = prevOnChannel + 1;
        let to = tokenIndex - 1;
        return this.filterForChannel(from, to, channel);
    }
    filterForChannel(from, to, channel) {
        let hidden = new Array();
        for(let i = from; i <= to; i++){
            let t = this.tokens[i];
            if (channel === -1) {
                if (t.channel !== $igNLf.Lexer.DEFAULT_TOKEN_CHANNEL) hidden.push(t);
            } else if (t.channel === channel) hidden.push(t);
        }
        return hidden;
    }
    get sourceName() {
        return this.tokenSource.sourceName;
    }
    getText(interval) {
        if (interval === undefined) interval = $gcfUE.Interval.of(0, this.size - 1);
        else if (!(interval instanceof $gcfUE.Interval)) // Note: the more obvious check for 'instanceof RuleContext' results in a circular dependency problem
        interval = interval.sourceInterval;
        let start = interval.a;
        let stop = interval.b;
        if (start < 0 || stop < 0) return "";
        this.fill();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        let buf = "";
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $2DVsz.Token.EOF) break;
            buf += t.text;
        }
        return buf.toString();
    }
    getTextFromRange(start, stop) {
        if (this.isToken(start) && this.isToken(stop)) return this.getText($gcfUE.Interval.of(start.tokenIndex, stop.tokenIndex));
        return "";
    }
    /** Get all tokens from lexer until EOF. */ fill() {
        this.lazyInit();
        const blockSize = 1000;
        while(true){
            let fetched = this.fetch(blockSize);
            if (fetched < blockSize) return;
        }
    }
    // TODO: Figure out a way to make this more flexible?
    isWritableToken(t) {
        return t instanceof $j53rr.CommonToken;
    }
    // TODO: Figure out a way to make this more flexible?
    isToken(t) {
        return t instanceof $j53rr.CommonToken;
    }
};
$163b0480402006d6$var$__decorate([
    $d6D31.NotNull
], $163b0480402006d6$var$BufferedTokenStream.prototype, "_tokenSource", void 0);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "tokenSource", null);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "index", null);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "mark", null);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "release", null);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "seek", null);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "size", null);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "consume", null);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "get", null);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "LA", null);
$163b0480402006d6$var$__decorate([
    $d6D31.NotNull,
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "LT", null);
$163b0480402006d6$var$__decorate([
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "sourceName", null);
$163b0480402006d6$var$__decorate([
    $d6D31.NotNull,
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "getText", null);
$163b0480402006d6$var$__decorate([
    $d6D31.NotNull,
    $d6D31.Override
], $163b0480402006d6$var$BufferedTokenStream.prototype, "getTextFromRange", null);
$163b0480402006d6$var$BufferedTokenStream = $163b0480402006d6$var$__decorate([
    $163b0480402006d6$var$__param(0, $d6D31.NotNull)
], $163b0480402006d6$var$BufferedTokenStream);
module.exports.BufferedTokenStream = $163b0480402006d6$var$BufferedTokenStream;

});

parcelRegister("QidO0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9NnFz", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CharStreams = void 0;

var $1Olk0 = parcelRequire("1Olk0");

var $7ufNj = parcelRequire("7ufNj");

var $ceaEj = parcelRequire("ceaEj");
// const DEFAULT_BUFFER_SIZE: number = 4096;
/** This class represents the primary interface for creating {@link CharStream}s
 *  from a variety of sources as of 4.7.  The motivation was to support
 *  Unicode code points > U+FFFF.  {@link ANTLRInputStream} and
 *  {@link ANTLRFileStream} are now deprecated in favor of the streams created
 *  by this interface.
 *
 *  DEPRECATED: {@code new ANTLRFileStream("myinputfile")}
 *  NEW:        {@code CharStreams.fromFileName("myinputfile")}
 *
 *  WARNING: If you use both the deprecated and the new streams, you will see
 *  a nontrivial performance degradation. This speed hit is because the
 *  {@link Lexer}'s internal code goes from a monomorphic to megamorphic
 *  dynamic dispatch to get characters from the input stream. Java's
 *  on-the-fly compiler (JIT) is unable to perform the same optimizations
 *  so stick with either the old or the new streams, if performance is
 *  a primary concern. See the extreme debugging and spelunking
 *  needed to identify this issue in our timing rig:
 *
 *      https://github.com/antlr/antlr4/pull/1781
 *
 *  The ANTLR character streams still buffer all the input when you create
 *  the stream, as they have done for ~20 years. If you need unbuffered
 *  access, please note that it becomes challenging to create
 *  parse trees. The parse tree has to point to tokens which will either
 *  point into a stale location in an unbuffered stream or you have to copy
 *  the characters out of the buffer into the token. That defeats the purpose
 *  of unbuffered input. Per the ANTLR book, unbuffered streams are primarily
 *  useful for processing infinite streams *during the parse.*
 *
 *  The new streams also use 8-bit buffers when possible so this new
 *  interface supports character streams that use half as much memory
 *  as the old {@link ANTLRFileStream}, which assumed 16-bit characters.
 *
 *  A big shout out to Ben Hamilton (github bhamiltoncx) for his superhuman
 *  efforts across all targets to get true Unicode 3.1 support for U+10FFFF.
 *
 *  @since 4.7
 */ var $721b0cebe5798117$var$CharStreams;
(function(CharStreams) {
    // /**
    //  * Creates a {@link CharStream} given a path to a UTF-8
    //  * encoded file on disk.
    //  *
    //  * Reads the entire contents of the file into the result before returning.
    //  */
    // export function fromFile(file: File): CharStream;
    // export function fromFile(file: File, charset: Charset): CharStream;
    // export function fromFile(file: File, charset?: Charset): CharStream {
    // 	if (charset === undefined) {
    // 		charset = Charset.forName("UTF-8");
    // 	}
    function fromString(s, sourceName) {
        if (sourceName === undefined || sourceName.length === 0) sourceName = $ceaEj.IntStream.UNKNOWN_SOURCE_NAME;
        // Initial guess assumes no code points > U+FFFF: one code
        // point for each code unit in the string
        let codePointBufferBuilder = $1Olk0.CodePointBuffer.builder(s.length);
        // TODO: CharBuffer.wrap(String) rightfully returns a read-only buffer
        // which doesn't expose its array, so we make a copy.
        let cb = new Uint16Array(s.length);
        for(let i = 0; i < s.length; i++)cb[i] = s.charCodeAt(i);
        codePointBufferBuilder.append(cb);
        return $7ufNj.CodePointCharStream.fromBuffer(codePointBufferBuilder.build(), sourceName);
    }
    CharStreams.fromString = fromString;
// export function bufferFromChannel(
// 	channel: ReadableByteChannel,
// 	charset: Charset,
// 	bufferSize: number,
// 	decodingErrorAction: CodingErrorAction,
// 	inputSize: number): CodePointBuffer {
// 	try {
// 		let utf8BytesIn: Uint8Array = new Uint8Array(bufferSize);
// 		let utf16CodeUnitsOut: Uint16Array = new Uint16Array(bufferSize);
// 		if (inputSize === -1) {
// 			inputSize = bufferSize;
// 		} else if (inputSize > Integer.MAX_VALUE) {
// 			// ByteBuffer et al don't support long sizes
// 			throw new RangeError(`inputSize ${inputSize} larger than max ${Integer.MAX_VALUE}`);
// 		}
// 		let codePointBufferBuilder: CodePointBuffer.Builder = CodePointBuffer.builder(inputSize);
// 		let decoder: CharsetDecoder = charset
// 				.newDecoder()
// 				.onMalformedInput(decodingErrorAction)
// 				.onUnmappableCharacter(decodingErrorAction);
// 		let endOfInput: boolean = false;
// 		while (!endOfInput) {
// 			let bytesRead: number = channel.read(utf8BytesIn);
// 			endOfInput = (bytesRead === -1);
// 			utf8BytesIn.flip();
// 			let result: CoderResult = decoder.decode(
// 				utf8BytesIn,
// 				utf16CodeUnitsOut,
// 				endOfInput);
// 			if (result.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 				result.throwException();
// 			}
// 			utf16CodeUnitsOut.flip();
// 			codePointBufferBuilder.append(utf16CodeUnitsOut);
// 			utf8BytesIn.compact();
// 			utf16CodeUnitsOut.compact();
// 		}
// 		// Handle any bytes at the end of the file which need to
// 		// be represented as errors or substitution characters.
// 		let flushResult: CoderResult = decoder.flush(utf16CodeUnitsOut);
// 		if (flushResult.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 			flushResult.throwException();
// 		}
// 		utf16CodeUnitsOut.flip();
// 		codePointBufferBuilder.append(utf16CodeUnitsOut);
// 		return codePointBufferBuilder.build();
// 	}
// 	finally {
// 		channel.close();
// 	}
// }
})($721b0cebe5798117$var$CharStreams = module.exports.CharStreams || (module.exports.CharStreams = {}));

});
parcelRegister("1Olk0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointBuffer = void 0;

var $bbHFU = parcelRequire("bbHFU");

var $gIRNa = parcelRequire("gIRNa");
/**
 * Wrapper for `Uint8Array` / `Uint16Array` / `Int32Array`.
 */ class $151b0001e5dcadf1$var$CodePointBuffer {
    constructor(buffer, size){
        this.buffer = buffer;
        this._position = 0;
        this._size = size;
    }
    static withArray(buffer) {
        return new $151b0001e5dcadf1$var$CodePointBuffer(buffer, buffer.length);
    }
    get position() {
        return this._position;
    }
    set position(newPosition) {
        if (newPosition < 0 || newPosition > this._size) throw new RangeError();
        this._position = newPosition;
    }
    get remaining() {
        return this._size - this.position;
    }
    get(offset) {
        return this.buffer[offset];
    }
    array() {
        return this.buffer.slice(0, this._size);
    }
    static builder(initialBufferSize) {
        return new $151b0001e5dcadf1$var$CodePointBuffer.Builder(initialBufferSize);
    }
}
module.exports.CodePointBuffer = $151b0001e5dcadf1$var$CodePointBuffer;
(function(CodePointBuffer) {
    let Type;
    (function(Type) {
        Type[Type["BYTE"] = 0] = "BYTE";
        Type[Type["CHAR"] = 1] = "CHAR";
        Type[Type["INT"] = 2] = "INT";
    })(Type || (Type = {}));
    class Builder {
        constructor(initialBufferSize){
            this.type = 0 /* BYTE */ ;
            this.buffer = new Uint8Array(initialBufferSize);
            this.prevHighSurrogate = -1;
            this.position = 0;
        }
        build() {
            return new CodePointBuffer(this.buffer, this.position);
        }
        static roundUpToNextPowerOfTwo(i) {
            let nextPowerOfTwo = 32 - Math.clz32(i - 1);
            return Math.pow(2, nextPowerOfTwo);
        }
        ensureRemaining(remainingNeeded) {
            switch(this.type){
                case 0 /* BYTE */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint8Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 1 /* CHAR */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint16Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 2 /* INT */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Int32Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
            }
        }
        append(utf16In) {
            this.ensureRemaining(utf16In.length);
            this.appendArray(utf16In);
        }
        appendArray(utf16In) {
            switch(this.type){
                case 0 /* BYTE */ :
                    this.appendArrayByte(utf16In);
                    break;
                case 1 /* CHAR */ :
                    this.appendArrayChar(utf16In);
                    break;
                case 2 /* INT */ :
                    this.appendArrayInt(utf16In);
                    break;
            }
        }
        appendArrayByte(utf16In) {
            $bbHFU(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outByte = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (c <= 0xFF) outByte[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    if (!$gIRNa.isHighSurrogate(c)) {
                        this.byteToCharBuffer(utf16In.length);
                        this.appendArrayChar(utf16In);
                        return;
                    } else {
                        this.byteToIntBuffer(utf16In.length);
                        this.appendArrayInt(utf16In);
                        return;
                    }
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayChar(utf16In) {
            $bbHFU(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outChar = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (!$gIRNa.isHighSurrogate(c)) outChar[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    this.charToIntBuffer(utf16In.length);
                    this.appendArrayInt(utf16In);
                    return;
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayInt(utf16In) {
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outInt = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                inOffset++;
                if (this.prevHighSurrogate !== -1) {
                    if ($gIRNa.isLowSurrogate(c)) {
                        outInt[outOffset] = String.fromCharCode(this.prevHighSurrogate, c).codePointAt(0);
                        outOffset++;
                        this.prevHighSurrogate = -1;
                    } else {
                        // Dangling high surrogate
                        outInt[outOffset] = this.prevHighSurrogate;
                        outOffset++;
                        if ($gIRNa.isHighSurrogate(c)) this.prevHighSurrogate = c;
                        else {
                            outInt[outOffset] = c;
                            outOffset++;
                            this.prevHighSurrogate = -1;
                        }
                    }
                } else if ($gIRNa.isHighSurrogate(c)) this.prevHighSurrogate = c;
                else {
                    outInt[outOffset] = c;
                    outOffset++;
                }
            }
            if (this.prevHighSurrogate !== -1) {
                // Dangling high surrogate
                outInt[outOffset] = this.prevHighSurrogate;
                outOffset++;
            }
            this.position = outOffset;
        }
        byteToCharBuffer(toAppend) {
            // CharBuffers hold twice as much per unit as ByteBuffers, so start with half the capacity.
            let newBuffer = new Uint16Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 1 /* CHAR */ ;
            this.buffer = newBuffer;
        }
        byteToIntBuffer(toAppend) {
            // IntBuffers hold four times as much per unit as ByteBuffers, so start with one quarter the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 2));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
        charToIntBuffer(toAppend) {
            // IntBuffers hold two times as much per unit as ByteBuffers, so start with one half the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
    }
    CodePointBuffer.Builder = Builder;
})($151b0001e5dcadf1$var$CodePointBuffer = module.exports.CodePointBuffer || (module.exports.CodePointBuffer = {}));

});
parcelRegister("gIRNa", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSupplementaryCodePoint = module.exports.isLowSurrogate = module.exports.isHighSurrogate = void 0;
function $c2ca7b5ca2fc06e2$var$isHighSurrogate(ch) {
    return ch >= 0xD800 && ch <= 0xDBFF;
}
module.exports.isHighSurrogate = $c2ca7b5ca2fc06e2$var$isHighSurrogate;
function $c2ca7b5ca2fc06e2$var$isLowSurrogate(ch) {
    return ch >= 0xDC00 && ch <= 0xDFFF;
}
module.exports.isLowSurrogate = $c2ca7b5ca2fc06e2$var$isLowSurrogate;
function $c2ca7b5ca2fc06e2$var$isSupplementaryCodePoint(ch) {
    return ch >= 0x10000;
}
module.exports.isSupplementaryCodePoint = $c2ca7b5ca2fc06e2$var$isSupplementaryCodePoint;

});


parcelRegister("7ufNj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $57379632ac21bb89$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointCharStream = void 0;

var $bbHFU = parcelRequire("bbHFU");

var $ceaEj = parcelRequire("ceaEj");

var $gcfUE = parcelRequire("gcfUE");

var $d6D31 = parcelRequire("d6D31");
/**
 * Alternative to {@link ANTLRInputStream} which treats the input
 * as a series of Unicode code points, instead of a series of UTF-16
 * code units.
 *
 * Use this if you need to parse input which potentially contains
 * Unicode values > U+FFFF.
 */ class $57379632ac21bb89$var$CodePointCharStream {
    // Use the factory method {@link #fromBuffer(CodePointBuffer)} to
    // construct instances of this type.
    constructor(array, position, remaining, name){
        // TODO
        $bbHFU(position === 0);
        this._array = array;
        this._size = remaining;
        this._name = name;
        this._position = 0;
    }
    get internalStorage() {
        return this._array;
    }
    static fromBuffer(codePointBuffer, name) {
        if (name === undefined || name.length === 0) name = $ceaEj.IntStream.UNKNOWN_SOURCE_NAME;
        // Java lacks generics on primitive types.
        //
        // To avoid lots of calls to virtual methods in the
        // very hot codepath of LA() below, we construct one
        // of three concrete subclasses.
        //
        // The concrete subclasses directly access the code
        // points stored in the underlying array (byte[],
        // char[], or int[]), so we can avoid lots of virtual
        // method calls to ByteBuffer.get(offset).
        return new $57379632ac21bb89$var$CodePointCharStream(codePointBuffer.array(), codePointBuffer.position, codePointBuffer.remaining, name);
    }
    consume() {
        if (this._size - this._position === 0) {
            $bbHFU(this.LA(1) === $ceaEj.IntStream.EOF);
            throw new RangeError("cannot consume EOF");
        }
        this._position++;
    }
    get index() {
        return this._position;
    }
    get size() {
        return this._size;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    seek(index) {
        this._position = index;
    }
    get sourceName() {
        return this._name;
    }
    toString() {
        return this.getText($gcfUE.Interval.of(0, this.size - 1));
    }
    LA(i) {
        let offset;
        switch(Math.sign(i)){
            case -1:
                offset = this.index + i;
                if (offset < 0) return $ceaEj.IntStream.EOF;
                return this._array[offset];
            case 0:
                // Undefined
                return 0;
            case 1:
                offset = this.index + i - 1;
                if (offset >= this.size) return $ceaEj.IntStream.EOF;
                return this._array[offset];
        }
        throw new RangeError("Not reached");
    }
    /** Return the UTF-16 encoded string for the given interval */ getText(interval) {
        const startIdx = Math.min(interval.a, this.size);
        const len = Math.min(interval.b - interval.a + 1, this.size - startIdx);
        if (this._array instanceof Int32Array) return String.fromCodePoint(...Array.from(this._array.subarray(startIdx, startIdx + len)));
        else return String.fromCharCode(...Array.from(this._array.subarray(startIdx, startIdx + len)));
    }
}
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "consume", null);
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "index", null);
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "size", null);
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "mark", null);
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "release", null);
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "seek", null);
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "sourceName", null);
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "toString", null);
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "LA", null);
$57379632ac21bb89$var$__decorate([
    $d6D31.Override
], $57379632ac21bb89$var$CodePointCharStream.prototype, "getText", null);
module.exports.CodePointCharStream = $57379632ac21bb89$var$CodePointCharStream;

});


parcelRegister("a0nC0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $748c38524e2afd86$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $748c38524e2afd86$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenStream = void 0;

var $1UkCC = parcelRequire("1UkCC");

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");
/**
 * This class extends {@link BufferedTokenStream} with functionality to filter
 * token streams to tokens on a particular channel (tokens where
 * {@link Token#getChannel} returns a particular value).
 *
 * This token stream provides access to all tokens by index or when calling
 * methods like {@link #getText}. The channel filtering is only used for code
 * accessing tokens via the lookahead methods {@link #LA}, {@link #LT}, and
 * {@link #LB}.
 *
 * By default, tokens are placed on the default channel
 * ({@link Token#DEFAULT_CHANNEL}), but may be reassigned by using the
 * `->channel(HIDDEN)` lexer command, or by using an embedded action to
 * call {@link Lexer#setChannel}.
 *
 * Note: lexer rules which use the `->skip` lexer command or call
 * {@link Lexer#skip} do not produce tokens at all, so input text matched by
 * such a rule will not be available as part of the token stream, regardless of
 * channel.
 */ let $748c38524e2afd86$var$CommonTokenStream = class CommonTokenStream extends $1UkCC.BufferedTokenStream {
    /**
     * Constructs a new {@link CommonTokenStream} using the specified token
     * source and filtering tokens to the specified channel. Only tokens whose
     * {@link Token#getChannel} matches `channel` or have the
     * `Token.type` equal to {@link Token#EOF} will be returned by the
     * token stream lookahead methods.
     *
     * @param tokenSource The token source.
     * @param channel The channel to use for filtering tokens.
     */ constructor(tokenSource, channel = $2DVsz.Token.DEFAULT_CHANNEL){
        super(tokenSource);
        this.channel = channel;
    }
    adjustSeekIndex(i) {
        return this.nextTokenOnChannel(i, this.channel);
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        let i = this.p;
        let n = 1;
        // find k good tokens looking backwards
        while(n <= k && i > 0){
            // skip off-channel tokens
            i = this.previousTokenOnChannel(i - 1, this.channel);
            n++;
        }
        if (i < 0) return undefined;
        return this.tokens[i];
    }
    tryLT(k) {
        //System.out.println("enter LT("+k+")");
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p;
        let n = 1; // we know tokens[p] is a good one
        // find k good tokens
        while(n < k){
            // skip off-channel tokens, but make sure to not look past EOF
            if (this.sync(i + 1)) i = this.nextTokenOnChannel(i + 1, this.channel);
            n++;
        }
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /** Count EOF just once. */ getNumberOfOnChannelTokens() {
        let n = 0;
        this.fill();
        for (let t of this.tokens){
            if (t.channel === this.channel) n++;
            if (t.type === $2DVsz.Token.EOF) break;
        }
        return n;
    }
};
$748c38524e2afd86$var$__decorate([
    $d6D31.Override
], $748c38524e2afd86$var$CommonTokenStream.prototype, "adjustSeekIndex", null);
$748c38524e2afd86$var$__decorate([
    $d6D31.Override
], $748c38524e2afd86$var$CommonTokenStream.prototype, "tryLB", null);
$748c38524e2afd86$var$__decorate([
    $d6D31.Override
], $748c38524e2afd86$var$CommonTokenStream.prototype, "tryLT", null);
$748c38524e2afd86$var$CommonTokenStream = $748c38524e2afd86$var$__decorate([
    $748c38524e2afd86$var$__param(0, $d6D31.NotNull)
], $748c38524e2afd86$var$CommonTokenStream);
module.exports.CommonTokenStream = $748c38524e2afd86$var$CommonTokenStream;

});

parcelRegister("4a3G0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dependents = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.1349829-07:00
/**
 *
 * @author Sam Harwell
 */ var $307af2a6cd217eb5$var$Dependents;
(function(Dependents) {
    /**
     * The element is dependent upon the specified rule.
     */ Dependents[Dependents["SELF"] = 0] = "SELF";
    /**
     * The element is dependent upon the set of the specified rule's parents
     * (rules which directly reference it).
     */ Dependents[Dependents["PARENTS"] = 1] = "PARENTS";
    /**
     * The element is dependent upon the set of the specified rule's children
     * (rules which it directly references).
     */ Dependents[Dependents["CHILDREN"] = 2] = "CHILDREN";
    /**
     * The element is dependent upon the set of the specified rule's ancestors
     * (the transitive closure of `PARENTS` rules).
     */ Dependents[Dependents["ANCESTORS"] = 3] = "ANCESTORS";
    /**
     * The element is dependent upon the set of the specified rule's descendants
     * (the transitive closure of `CHILDREN` rules).
     */ Dependents[Dependents["DESCENDANTS"] = 4] = "DESCENDANTS";
    /**
     * The element is dependent upon the set of the specified rule's siblings
     * (the union of `CHILDREN` of its `PARENTS`).
     */ Dependents[Dependents["SIBLINGS"] = 5] = "SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear before a reference to the rule).
     */ Dependents[Dependents["PRECEEDING_SIBLINGS"] = 6] = "PRECEEDING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's following
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear after a reference to the rule).
     */ Dependents[Dependents["FOLLOWING_SIBLINGS"] = 7] = "FOLLOWING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * elements (rules which might end before the start of the specified rule
     * while parsing). This is calculated by taking the
     * `PRECEEDING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["PRECEEDING"] = 8] = "PRECEEDING";
    /**
     * The element is dependent upon the set of the specified rule's following
     * elements (rules which might start after the end of the specified rule
     * while parsing). This is calculated by taking the
     * `FOLLOWING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["FOLLOWING"] = 9] = "FOLLOWING";
})($307af2a6cd217eb5$var$Dependents = module.exports.Dependents || (module.exports.Dependents = {}));

});

parcelRegister("5Poq6", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $43e4a87e035cc726$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $43e4a87e035cc726$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiagnosticErrorListener = void 0;

var $5BPMp = parcelRequire("5BPMp");

var $d6D31 = parcelRequire("d6D31");

var $gcfUE = parcelRequire("gcfUE");
/**
 * This implementation of {@link ANTLRErrorListener} can be used to identify
 * certain potential correctness and performance problems in grammars. "Reports"
 * are made by calling {@link Parser#notifyErrorListeners} with the appropriate
 * message.
 *
 * * **Ambiguities**: These are cases where more than one path through the
 *   grammar can match the input.
 * * **Weak context sensitivity**: These are cases where full-context
 *   prediction resolved an SLL conflict to a unique alternative which equaled the
 *   minimum alternative of the SLL conflict.
 * * **Strong (forced) context sensitivity**: These are cases where the
 *   full-context prediction resolved an SLL conflict to a unique alternative,
 *   *and* the minimum alternative of the SLL conflict was found to not be
 *   a truly viable alternative. Two-stage parsing cannot be used for inputs where
 *   this situation occurs.
 *
 * @author Sam Harwell
 */ class $43e4a87e035cc726$var$DiagnosticErrorListener {
    /**
     * Initializes a new instance of {@link DiagnosticErrorListener}, specifying
     * whether all ambiguities or only exact ambiguities are reported.
     *
     * @param exactOnly `true` to report only exact ambiguities, otherwise
     * `false` to report all ambiguities.  Defaults to true.
     */ constructor(exactOnly = true){
        this.exactOnly = exactOnly;
        this.exactOnly = exactOnly;
    }
    syntaxError(/*@NotNull*/ recognizer, offendingSymbol, line, charPositionInLine, /*@NotNull*/ msg, e) {
    // intentionally empty
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (this.exactOnly && !exact) return;
        let decision = this.getDecisionDescription(recognizer, dfa);
        let conflictingAlts = this.getConflictingAlts(ambigAlts, configs);
        let text = recognizer.inputStream.getText($gcfUE.Interval.of(startIndex, stopIndex));
        let message = `reportAmbiguity d=${decision}: ambigAlts=${conflictingAlts}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        let format = "reportAttemptingFullContext d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($gcfUE.Interval.of(startIndex, stopIndex));
        let message = `reportAttemptingFullContext d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        let format = "reportContextSensitivity d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($gcfUE.Interval.of(startIndex, stopIndex));
        let message = `reportContextSensitivity d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    getDecisionDescription(recognizer, dfa) {
        let decision = dfa.decision;
        let ruleIndex = dfa.atnStartState.ruleIndex;
        let ruleNames = recognizer.ruleNames;
        if (ruleIndex < 0 || ruleIndex >= ruleNames.length) return decision.toString();
        let ruleName = ruleNames[ruleIndex];
        if (!ruleName) return decision.toString();
        return `${decision} (${ruleName})`;
    }
    /**
     * Computes the set of conflicting or ambiguous alternatives from a
     * configuration set, if that information was not already provided by the
     * parser.
     *
     * @param reportedAlts The set of conflicting or ambiguous alternatives, as
     * reported by the parser.
     * @param configs The conflicting or ambiguous configuration set.
     * @returns Returns `reportedAlts` if it is not `undefined`, otherwise
     * returns the set of alternatives represented in `configs`.
     */ getConflictingAlts(reportedAlts, configs) {
        if (reportedAlts != null) return reportedAlts;
        let result = new $5BPMp.BitSet();
        for (let config of configs)result.set(config.alt);
        return result;
    }
}
$43e4a87e035cc726$var$__decorate([
    $d6D31.Override
], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "syntaxError", null);
$43e4a87e035cc726$var$__decorate([
    $d6D31.Override,
    $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
    $43e4a87e035cc726$var$__param(1, $d6D31.NotNull),
    $43e4a87e035cc726$var$__param(6, $d6D31.NotNull)
], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "reportAmbiguity", null);
$43e4a87e035cc726$var$__decorate([
    $d6D31.Override,
    $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
    $43e4a87e035cc726$var$__param(1, $d6D31.NotNull),
    $43e4a87e035cc726$var$__param(5, $d6D31.NotNull)
], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "reportAttemptingFullContext", null);
$43e4a87e035cc726$var$__decorate([
    $d6D31.Override,
    $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
    $43e4a87e035cc726$var$__param(1, $d6D31.NotNull),
    $43e4a87e035cc726$var$__param(5, $d6D31.NotNull)
], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "reportContextSensitivity", null);
$43e4a87e035cc726$var$__decorate([
    $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
    $43e4a87e035cc726$var$__param(1, $d6D31.NotNull)
], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "getDecisionDescription", null);
$43e4a87e035cc726$var$__decorate([
    $d6D31.NotNull,
    $43e4a87e035cc726$var$__param(1, $d6D31.NotNull)
], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "getConflictingAlts", null);
module.exports.DiagnosticErrorListener = $43e4a87e035cc726$var$DiagnosticErrorListener;

});

parcelRegister("5FrZ8", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $42067d58e54221f4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InterpreterRuleContext = void 0;

var $d6D31 = parcelRequire("d6D31");

var $6bmaO = parcelRequire("6bmaO");
/**
 * This class extends {@link ParserRuleContext} by allowing the value of
 * {@link #getRuleIndex} to be explicitly set for the context.
 *
 * {@link ParserRuleContext} does not include field storage for the rule index
 * since the context classes created by the code generator override the
 * {@link #getRuleIndex} method to return the correct value for that context.
 * Since the parser interpreter does not use the context classes generated for a
 * parser, this class (with slightly more memory overhead per node) is used to
 * provide equivalent functionality.
 */ class $42067d58e54221f4$var$InterpreterRuleContext extends $6bmaO.ParserRuleContext {
    constructor(ruleIndex, parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._ruleIndex = ruleIndex;
    }
    get ruleIndex() {
        return this._ruleIndex;
    }
}
$42067d58e54221f4$var$__decorate([
    $d6D31.Override
], $42067d58e54221f4$var$InterpreterRuleContext.prototype, "ruleIndex", null);
module.exports.InterpreterRuleContext = $42067d58e54221f4$var$InterpreterRuleContext;

});

parcelRegister("gMbxO", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c36a1586c540a239$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c36a1586c540a239$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerInterpreter = void 0;

var $igNLf = parcelRequire("igNLf");

var $lQecE = parcelRequire("lQecE");

var $d6D31 = parcelRequire("d6D31");

var $d6D31 = parcelRequire("d6D31");
let $c36a1586c540a239$var$LexerInterpreter = class LexerInterpreter extends $igNLf.Lexer {
    constructor(grammarFileName, vocabulary, ruleNames, channelNames, modeNames, atn, input){
        super(input);
        if (atn.grammarType !== 0 /* LEXER */ ) throw new Error("IllegalArgumentException: The ATN must be a lexer ATN.");
        this._grammarFileName = grammarFileName;
        this._atn = atn;
        this._ruleNames = ruleNames.slice(0);
        this._channelNames = channelNames.slice(0);
        this._modeNames = modeNames.slice(0);
        this._vocabulary = vocabulary;
        this._interp = new $lQecE.LexerATNSimulator(atn, this);
    }
    get atn() {
        return this._atn;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get channelNames() {
        return this._channelNames;
    }
    get modeNames() {
        return this._modeNames;
    }
    get vocabulary() {
        return this._vocabulary;
    }
};
$c36a1586c540a239$var$__decorate([
    $d6D31.NotNull
], $c36a1586c540a239$var$LexerInterpreter.prototype, "_vocabulary", void 0);
$c36a1586c540a239$var$__decorate([
    $d6D31.Override
], $c36a1586c540a239$var$LexerInterpreter.prototype, "atn", null);
$c36a1586c540a239$var$__decorate([
    $d6D31.Override
], $c36a1586c540a239$var$LexerInterpreter.prototype, "grammarFileName", null);
$c36a1586c540a239$var$__decorate([
    $d6D31.Override
], $c36a1586c540a239$var$LexerInterpreter.prototype, "ruleNames", null);
$c36a1586c540a239$var$__decorate([
    $d6D31.Override
], $c36a1586c540a239$var$LexerInterpreter.prototype, "channelNames", null);
$c36a1586c540a239$var$__decorate([
    $d6D31.Override
], $c36a1586c540a239$var$LexerInterpreter.prototype, "modeNames", null);
$c36a1586c540a239$var$__decorate([
    $d6D31.Override
], $c36a1586c540a239$var$LexerInterpreter.prototype, "vocabulary", null);
$c36a1586c540a239$var$LexerInterpreter = $c36a1586c540a239$var$__decorate([
    $c36a1586c540a239$var$__param(1, $d6D31.NotNull)
], $c36a1586c540a239$var$LexerInterpreter);
module.exports.LexerInterpreter = $c36a1586c540a239$var$LexerInterpreter;

});

parcelRegister("drCaH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9c9b68135c38f0cc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9c9b68135c38f0cc$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ListTokenSource = void 0;

var $gWaB3 = parcelRequire("gWaB3");

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");
/**
 * Provides an implementation of {@link TokenSource} as a wrapper around a list
 * of {@link Token} objects.
 *
 * If the final token in the list is an {@link Token#EOF} token, it will be used
 * as the EOF token for every call to {@link #nextToken} after the end of the
 * list is reached. Otherwise, an EOF token will be created.
 */ let $9c9b68135c38f0cc$var$ListTokenSource = class ListTokenSource {
    /**
     * Constructs a new {@link ListTokenSource} instance from the specified
     * collection of {@link Token} objects and source name.
     *
     * @param tokens The collection of {@link Token} objects to provide as a
     * {@link TokenSource}.
     * @param sourceName The name of the {@link TokenSource}. If this value is
     * `undefined`, {@link #getSourceName} will attempt to infer the name from
     * the next {@link Token} (or the previous token if the end of the input has
     * been reached).
     *
     * @exception NullPointerException if `tokens` is `undefined`
     */ constructor(tokens, sourceName){
        /**
         * The index into {@link #tokens} of token to return by the next call to
         * {@link #nextToken}. The end of the input is indicated by this value
         * being greater than or equal to the number of items in {@link #tokens}.
         */ this.i = 0;
        /**
         * This is the backing field for {@link #getTokenFactory} and
         * {@link setTokenFactory}.
         */ this._factory = $gWaB3.CommonTokenFactory.DEFAULT;
        if (tokens == null) throw new Error("tokens cannot be null");
        this.tokens = tokens;
        this._sourceName = sourceName;
    }
    /**
     * {@inheritDoc}
     */ get charPositionInLine() {
        if (this.i < this.tokens.length) return this.tokens[this.i].charPositionInLine;
        else if (this.eofToken != null) return this.eofToken.charPositionInLine;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let tokenText = lastToken.text;
            if (tokenText != null) {
                let lastNewLine = tokenText.lastIndexOf("\n");
                if (lastNewLine >= 0) return tokenText.length - lastNewLine - 1;
            }
            return lastToken.charPositionInLine + lastToken.stopIndex - lastToken.startIndex + 1;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 0;
    }
    /**
     * {@inheritDoc}
     */ nextToken() {
        if (this.i >= this.tokens.length) {
            if (this.eofToken == null) {
                let start = -1;
                if (this.tokens.length > 0) {
                    let previousStop = this.tokens[this.tokens.length - 1].stopIndex;
                    if (previousStop !== -1) start = previousStop + 1;
                }
                let stop = Math.max(-1, start - 1);
                this.eofToken = this._factory.create({
                    source: this,
                    stream: this.inputStream
                }, $2DVsz.Token.EOF, "EOF", $2DVsz.Token.DEFAULT_CHANNEL, start, stop, this.line, this.charPositionInLine);
            }
            return this.eofToken;
        }
        let t = this.tokens[this.i];
        if (this.i === this.tokens.length - 1 && t.type === $2DVsz.Token.EOF) this.eofToken = t;
        this.i++;
        return t;
    }
    /**
     * {@inheritDoc}
     */ get line() {
        if (this.i < this.tokens.length) return this.tokens[this.i].line;
        else if (this.eofToken != null) return this.eofToken.line;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let line = lastToken.line;
            let tokenText = lastToken.text;
            if (tokenText != null) {
                for(let i = 0; i < tokenText.length; i++)if (tokenText.charAt(i) === "\n") line++;
            }
            // if no text is available, assume the token did not contain any newline characters.
            return line;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 1;
    }
    /**
     * {@inheritDoc}
     */ get inputStream() {
        if (this.i < this.tokens.length) return this.tokens[this.i].inputStream;
        else if (this.eofToken != null) return this.eofToken.inputStream;
        else if (this.tokens.length > 0) return this.tokens[this.tokens.length - 1].inputStream;
        // no input stream information is available
        return undefined;
    }
    /**
     * {@inheritDoc}
     */ get sourceName() {
        if (this._sourceName) return this._sourceName;
        let inputStream = this.inputStream;
        if (inputStream != null) return inputStream.sourceName;
        return "List";
    }
    /**
     * {@inheritDoc}
     */ // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    /**
     * {@inheritDoc}
     */ get tokenFactory() {
        return this._factory;
    }
};
$9c9b68135c38f0cc$var$__decorate([
    $d6D31.Override
], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "charPositionInLine", null);
$9c9b68135c38f0cc$var$__decorate([
    $d6D31.Override
], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "nextToken", null);
$9c9b68135c38f0cc$var$__decorate([
    $d6D31.Override
], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "line", null);
$9c9b68135c38f0cc$var$__decorate([
    $d6D31.Override
], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "inputStream", null);
$9c9b68135c38f0cc$var$__decorate([
    $d6D31.Override
], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "sourceName", null);
$9c9b68135c38f0cc$var$__decorate([
    $d6D31.Override,
    $d6D31.NotNull,
    $9c9b68135c38f0cc$var$__param(0, $d6D31.NotNull)
], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "tokenFactory", null);
$9c9b68135c38f0cc$var$ListTokenSource = $9c9b68135c38f0cc$var$__decorate([
    $9c9b68135c38f0cc$var$__param(0, $d6D31.NotNull)
], $9c9b68135c38f0cc$var$ListTokenSource);
module.exports.ListTokenSource = $9c9b68135c38f0cc$var$ListTokenSource;

});

parcelRegister("2pQQd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dReoi", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a16b634f90dd81f4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a16b634f90dd81f4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserInterpreter = void 0;

var $7j0Pc = parcelRequire("7j0Pc");

var $1bs3X = parcelRequire("1bs3X");

var $5BPMp = parcelRequire("5BPMp");

var $ea0YW = parcelRequire("ea0YW");

var $iLUMi = parcelRequire("iLUMi");

var $5FrZ8 = parcelRequire("5FrZ8");

var $kfqEk = parcelRequire("kfqEk");

var $d6D31 = parcelRequire("d6D31");

var $d6D31 = parcelRequire("d6D31");

var $jIG0W = parcelRequire("jIG0W");

var $kzbnL = parcelRequire("kzbnL");

var $fLdDn = parcelRequire("fLdDn");

var $f9raX = parcelRequire("f9raX");

var $2DVsz = parcelRequire("2DVsz");
/** A parser simulator that mimics what ANTLR's generated
 *  parser code does. A ParserATNSimulator is used to make
 *  predictions via adaptivePredict but this class moves a pointer through the
 *  ATN to simulate parsing. ParserATNSimulator just
 *  makes us efficient rather than having to backtrack, for example.
 *
 *  This properly creates parse trees even for left recursive rules.
 *
 *  We rely on the left recursive rule invocation and special predicate
 *  transitions to make left recursive rules work.
 *
 *  See TestParserInterpreter for examples.
 */ let $a16b634f90dd81f4$var$ParserInterpreter = class ParserInterpreter extends $jIG0W.Parser {
    constructor(grammarFileName, vocabulary, ruleNames, atn, input){
        super(grammarFileName instanceof ParserInterpreter ? grammarFileName.inputStream : input);
        /** This stack corresponds to the _parentctx, _parentState pair of locals
         *  that would exist on call stack frames with a recursive descent parser;
         *  in the generated function for a left-recursive rule you'd see:
         *
         *  private EContext e(int _p) {
         *      ParserRuleContext _parentctx = _ctx;    // Pair.a
         *      int _parentState = state;          // Pair.b
         *      ...
         *  }
         *
         *  Those values are used to create new recursive rule invocation contexts
         *  associated with left operand of an alt like "expr '*' expr".
         */ this._parentContextStack = [];
        /** We need a map from (decision,inputIndex)->forced alt for computing ambiguous
         *  parse trees. For now, we allow exactly one override.
         */ this.overrideDecision = -1;
        this.overrideDecisionInputIndex = -1;
        this.overrideDecisionAlt = -1;
        this.overrideDecisionReached = false; // latch and only override once; error might trigger infinite loop
        /** What is the current context when we override a decisions?  This tells
         *  us what the root of the parse tree is when using override
         *  for an ambiguity/lookahead check.
         */ this._overrideDecisionRoot = undefined;
        if (grammarFileName instanceof ParserInterpreter) {
            let old = grammarFileName;
            this._grammarFileName = old._grammarFileName;
            this._atn = old._atn;
            this.pushRecursionContextStates = old.pushRecursionContextStates;
            this._ruleNames = old._ruleNames;
            this._vocabulary = old._vocabulary;
            this.interpreter = new $kzbnL.ParserATNSimulator(this._atn, this);
        } else {
            // The second constructor requires non-null arguments
            vocabulary;
            ruleNames;
            atn;
            this._grammarFileName = grammarFileName;
            this._atn = atn;
            this._ruleNames = ruleNames.slice(0);
            this._vocabulary = vocabulary;
            // identify the ATN states where pushNewRecursionContext() must be called
            this.pushRecursionContextStates = new $5BPMp.BitSet(atn.states.length);
            for (let state of atn.states){
                if (!(state instanceof $f9raX.StarLoopEntryState)) continue;
                if (state.precedenceRuleDecision) this.pushRecursionContextStates.set(state.stateNumber);
            }
            // get atn simulator that knows how to do predictions
            this.interpreter = new $kzbnL.ParserATNSimulator(atn, this);
        }
    }
    reset(resetInput) {
        if (resetInput === undefined) super.reset();
        else super.reset(resetInput);
        this.overrideDecisionReached = false;
        this._overrideDecisionRoot = undefined;
    }
    get atn() {
        return this._atn;
    }
    get vocabulary() {
        return this._vocabulary;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    /** Begin parsing at startRuleIndex */ parse(startRuleIndex) {
        let startRuleStartState = this._atn.ruleToStartState[startRuleIndex];
        this._rootContext = this.createInterpreterRuleContext(undefined, $7j0Pc.ATNState.INVALID_STATE_NUMBER, startRuleIndex);
        if (startRuleStartState.isPrecedenceRule) this.enterRecursionRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex, 0);
        else this.enterRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex);
        while(true){
            let p = this.atnState;
            switch(p.stateType){
                case $1bs3X.ATNStateType.RULE_STOP:
                    // pop; return from rule
                    if (this._ctx.isEmpty) {
                        if (startRuleStartState.isPrecedenceRule) {
                            let result = this._ctx;
                            let parentContext = this._parentContextStack.pop();
                            this.unrollRecursionContexts(parentContext[0]);
                            return result;
                        } else {
                            this.exitRule();
                            return this._rootContext;
                        }
                    }
                    this.visitRuleStopState(p);
                    break;
                default:
                    try {
                        this.visitState(p);
                    } catch (e) {
                        if (e instanceof $fLdDn.RecognitionException) {
                            this.state = this._atn.ruleToStopState[p.ruleIndex].stateNumber;
                            this.context.exception = e;
                            this.errorHandler.reportError(this, e);
                            this.recover(e);
                        } else throw e;
                    }
                    break;
            }
        }
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this._parentContextStack.push([
            this._ctx,
            localctx.invokingState
        ]);
        super.enterRecursionRule(localctx, state, ruleIndex, precedence);
    }
    get atnState() {
        return this._atn.states[this.state];
    }
    visitState(p) {
        let predictedAlt = 1;
        if (p.numberOfTransitions > 1) predictedAlt = this.visitDecisionState(p);
        let transition = p.transition(predictedAlt - 1);
        switch(transition.serializationType){
            case 1 /* EPSILON */ :
                if (this.pushRecursionContextStates.get(p.stateNumber) && !(transition.target instanceof $kfqEk.LoopEndState)) {
                    // We are at the start of a left recursive rule's (...)* loop
                    // and we're not taking the exit branch of loop.
                    let parentContext = this._parentContextStack[this._parentContextStack.length - 1];
                    let localctx = this.createInterpreterRuleContext(parentContext[0], parentContext[1], this._ctx.ruleIndex);
                    this.pushNewRecursionContext(localctx, this._atn.ruleToStartState[p.ruleIndex].stateNumber, this._ctx.ruleIndex);
                }
                break;
            case 5 /* ATOM */ :
                this.match(transition._label);
                break;
            case 2 /* RANGE */ :
            case 7 /* SET */ :
            case 8 /* NOT_SET */ :
                if (!transition.matches(this._input.LA(1), $2DVsz.Token.MIN_USER_TOKEN_TYPE, 65535)) this.recoverInline();
                this.matchWildcard();
                break;
            case 9 /* WILDCARD */ :
                this.matchWildcard();
                break;
            case 3 /* RULE */ :
                let ruleStartState = transition.target;
                let ruleIndex = ruleStartState.ruleIndex;
                let newctx = this.createInterpreterRuleContext(this._ctx, p.stateNumber, ruleIndex);
                if (ruleStartState.isPrecedenceRule) this.enterRecursionRule(newctx, ruleStartState.stateNumber, ruleIndex, transition.precedence);
                else this.enterRule(newctx, transition.target.stateNumber, ruleIndex);
                break;
            case 4 /* PREDICATE */ :
                let predicateTransition = transition;
                if (!this.sempred(this._ctx, predicateTransition.ruleIndex, predicateTransition.predIndex)) throw new $ea0YW.FailedPredicateException(this);
                break;
            case 6 /* ACTION */ :
                let actionTransition = transition;
                this.action(this._ctx, actionTransition.ruleIndex, actionTransition.actionIndex);
                break;
            case 10 /* PRECEDENCE */ :
                if (!this.precpred(this._ctx, transition.precedence)) {
                    let precedence = transition.precedence;
                    throw new $ea0YW.FailedPredicateException(this, `precpred(_ctx, ${precedence})`);
                }
                break;
            default:
                throw new Error("UnsupportedOperationException: Unrecognized ATN transition type.");
        }
        this.state = transition.target.stateNumber;
    }
    /** Method visitDecisionState() is called when the interpreter reaches
     *  a decision state (instance of DecisionState). It gives an opportunity
     *  for subclasses to track interesting things.
     */ visitDecisionState(p) {
        let predictedAlt;
        this.errorHandler.sync(this);
        let decision = p.decision;
        if (decision === this.overrideDecision && this._input.index === this.overrideDecisionInputIndex && !this.overrideDecisionReached) {
            predictedAlt = this.overrideDecisionAlt;
            this.overrideDecisionReached = true;
        } else predictedAlt = this.interpreter.adaptivePredict(this._input, decision, this._ctx);
        return predictedAlt;
    }
    /** Provide simple "factory" for InterpreterRuleContext's.
     *  @since 4.5.1
     */ createInterpreterRuleContext(parent, invokingStateNumber, ruleIndex) {
        return new $5FrZ8.InterpreterRuleContext(ruleIndex, parent, invokingStateNumber);
    }
    visitRuleStopState(p) {
        let ruleStartState = this._atn.ruleToStartState[p.ruleIndex];
        if (ruleStartState.isPrecedenceRule) {
            let parentContext = this._parentContextStack.pop();
            this.unrollRecursionContexts(parentContext[0]);
            this.state = parentContext[1];
        } else this.exitRule();
        let ruleTransition = this._atn.states[this.state].transition(0);
        this.state = ruleTransition.followState.stateNumber;
    }
    /** Override this parser interpreters normal decision-making process
     *  at a particular decision and input token index. Instead of
     *  allowing the adaptive prediction mechanism to choose the
     *  first alternative within a block that leads to a successful parse,
     *  force it to take the alternative, 1..n for n alternatives.
     *
     *  As an implementation limitation right now, you can only specify one
     *  override. This is sufficient to allow construction of different
     *  parse trees for ambiguous input. It means re-parsing the entire input
     *  in general because you're never sure where an ambiguous sequence would
     *  live in the various parse trees. For example, in one interpretation,
     *  an ambiguous input sequence would be matched completely in expression
     *  but in another it could match all the way back to the root.
     *
     *  s : e '!'? ;
     *  e : ID
     *    | ID '!'
     *    ;
     *
     *  Here, x! can be matched as (s (e ID) !) or (s (e ID !)). In the first
     *  case, the ambiguous sequence is fully contained only by the root.
     *  In the second case, the ambiguous sequences fully contained within just
     *  e, as in: (e ID !).
     *
     *  Rather than trying to optimize this and make
     *  some intelligent decisions for optimization purposes, I settled on
     *  just re-parsing the whole input and then using
     *  {link Trees#getRootOfSubtreeEnclosingRegion} to find the minimal
     *  subtree that contains the ambiguous sequence. I originally tried to
     *  record the call stack at the point the parser detected and ambiguity but
     *  left recursive rules create a parse tree stack that does not reflect
     *  the actual call stack. That impedance mismatch was enough to make
     *  it it challenging to restart the parser at a deeply nested rule
     *  invocation.
     *
     *  Only parser interpreters can override decisions so as to avoid inserting
     *  override checking code in the critical ALL(*) prediction execution path.
     *
     *  @since 4.5
     */ addDecisionOverride(decision, tokenIndex, forcedAlt) {
        this.overrideDecision = decision;
        this.overrideDecisionInputIndex = tokenIndex;
        this.overrideDecisionAlt = forcedAlt;
    }
    get overrideDecisionRoot() {
        return this._overrideDecisionRoot;
    }
    /** Rely on the error handler for this parser but, if no tokens are consumed
     *  to recover, add an error node. Otherwise, nothing is seen in the parse
     *  tree.
     */ recover(e) {
        let i = this._input.index;
        this.errorHandler.recover(this, e);
        if (this._input.index === i) {
            // no input consumed, better add an error node
            let tok = e.getOffendingToken();
            if (!tok) throw new Error("Expected exception to have an offending token");
            let source = tok.tokenSource;
            let stream = source !== undefined ? source.inputStream : undefined;
            let sourcePair = {
                source: source,
                stream: stream
            };
            if (e instanceof $iLUMi.InputMismatchException) {
                let expectedTokens = e.expectedTokens;
                if (expectedTokens === undefined) throw new Error("Expected the exception to provide expected tokens");
                let expectedTokenType = $2DVsz.Token.INVALID_TYPE;
                if (!expectedTokens.isNil) // get any element
                expectedTokenType = expectedTokens.minElement;
                let errToken = this.tokenFactory.create(sourcePair, expectedTokenType, tok.text, $2DVsz.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            } else {
                let source = tok.tokenSource;
                let errToken = this.tokenFactory.create(sourcePair, $2DVsz.Token.INVALID_TYPE, tok.text, $2DVsz.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            }
        }
    }
    recoverInline() {
        return this._errHandler.recoverInline(this);
    }
    /** Return the root of the parse, which can be useful if the parser
     *  bails out. You still can access the top node. Note that,
     *  because of the way left recursive rules add children, it's possible
     *  that the root will not have any children if the start rule immediately
     *  called and left recursive rule that fails.
     *
     * @since 4.5.1
     */ get rootContext() {
        return this._rootContext;
    }
};
$a16b634f90dd81f4$var$__decorate([
    $d6D31.NotNull
], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "_vocabulary", void 0);
$a16b634f90dd81f4$var$__decorate([
    $d6D31.Override
], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "reset", null);
$a16b634f90dd81f4$var$__decorate([
    $d6D31.Override
], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "atn", null);
$a16b634f90dd81f4$var$__decorate([
    $d6D31.Override
], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "vocabulary", null);
$a16b634f90dd81f4$var$__decorate([
    $d6D31.Override
], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "ruleNames", null);
$a16b634f90dd81f4$var$__decorate([
    $d6D31.Override
], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "grammarFileName", null);
$a16b634f90dd81f4$var$__decorate([
    $d6D31.Override
], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "enterRecursionRule", null);
$a16b634f90dd81f4$var$ParserInterpreter = $a16b634f90dd81f4$var$__decorate([
    $a16b634f90dd81f4$var$__param(1, $d6D31.NotNull)
], $a16b634f90dd81f4$var$ParserInterpreter);
module.exports.ParserInterpreter = $a16b634f90dd81f4$var$ParserInterpreter;

});

parcelRegister("77rdV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $52ee4de454858848$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContextWithAltNum = void 0;

var $bcnvE = parcelRequire("bcnvE");

var $d6D31 = parcelRequire("d6D31");

var $6bmaO = parcelRequire("6bmaO");
/** A handy class for use with
 *
 *  options {contextSuperClass=org.antlr.v4.runtime.RuleContextWithAltNum;}
 *
 *  that provides a backing field / impl for the outer alternative number
 *  matched for an internal parse tree node.
 *
 *  I'm only putting into Java runtime as I'm certain I'm the only one that
 *  will really every use this.
 */ class $52ee4de454858848$var$RuleContextWithAltNum extends $6bmaO.ParserRuleContext {
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._altNumber = $bcnvE.ATN.INVALID_ALT_NUMBER;
    }
    get altNumber() {
        return this._altNumber;
    }
    // @Override
    set altNumber(altNum) {
        this._altNumber = altNum;
    }
}
$52ee4de454858848$var$__decorate([
    $d6D31.Override
], $52ee4de454858848$var$RuleContextWithAltNum.prototype, "altNumber", null);
module.exports.RuleContextWithAltNum = $52ee4de454858848$var$RuleContextWithAltNum;

});

parcelRegister("5IgvW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleDependency = void 0;
/**
 * Declares a dependency upon a grammar rule, along with a set of zero or more dependent rules.
 *
 * Version numbers within a grammar should be assigned on a monotonically increasing basis to allow for accurate
 * tracking of dependent rules.
 *
 * @author Sam Harwell
 */ function $428ddf2e82bfc6fb$var$RuleDependency(dependency) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleDependency = $428ddf2e82bfc6fb$var$RuleDependency;

});

parcelRegister("1ivK9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleVersion = void 0;
/**
 *
 * @author Sam Harwell
 */ function $0f201872a8ca959f$var$RuleVersion(version) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleVersion = $0f201872a8ca959f$var$RuleVersion;

});

parcelRegister("eftJA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9rAj4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5jPdD", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dIykH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9fca043c2d5f0853$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RewriteOperation = module.exports.TokenStreamRewriter = void 0;

var $gcfUE = parcelRequire("gcfUE");

var $d6D31 = parcelRequire("d6D31");

var $2DVsz = parcelRequire("2DVsz");
/**
 * Useful for rewriting out a buffered input token stream after doing some
 * augmentation or other manipulations on it.
 *
 * You can insert stuff, replace, and delete chunks. Note that the operations
 * are done lazily--only if you convert the buffer to a {@link String} with
 * {@link TokenStream#getText()}. This is very efficient because you are not
 * moving data around all the time. As the buffer of tokens is converted to
 * strings, the {@link #getText()} method(s) scan the input token stream and
 * check to see if there is an operation at the current index. If so, the
 * operation is done and then normal {@link String} rendering continues on the
 * buffer. This is like having multiple Turing machine instruction streams
 * (programs) operating on a single input tape. :)
 *
 * This rewriter makes no modifications to the token stream. It does not ask the
 * stream to fill itself up nor does it advance the input cursor. The token
 * stream `TokenStream.index` will return the same value before and
 * after any {@link #getText()} call.
 *
 * The rewriter only works on tokens that you have in the buffer and ignores the
 * current input cursor. If you are buffering tokens on-demand, calling
 * {@link #getText()} halfway through the input will only do rewrites for those
 * tokens in the first half of the file.
 *
 * Since the operations are done lazily at {@link #getText}-time, operations do
 * not screw up the token index values. That is, an insert operation at token
 * index `i` does not change the index values for tokens
 * `i`+1..n-1.
 *
 * Because operations never actually alter the buffer, you may always get the
 * original token stream back without undoing anything. Since the instructions
 * are queued up, you can easily simulate transactions and roll back any changes
 * if there is an error just by removing instructions. For example,
 *
 * ```
 * CharStream input = new ANTLRFileStream("input");
 * TLexer lex = new TLexer(input);
 * CommonTokenStream tokens = new CommonTokenStream(lex);
 * T parser = new T(tokens);
 * TokenStreamRewriter rewriter = new TokenStreamRewriter(tokens);
 * parser.startRule();
 * ```
 *
 * Then in the rules, you can execute (assuming rewriter is visible):
 *
 * ```
 * Token t,u;
 * ...
 * rewriter.insertAfter(t, "text to put after t");}
 * rewriter.insertAfter(u, "text after u");}
 * System.out.println(rewriter.getText());
 * ```
 *
 * You can also have multiple "instruction streams" and get multiple rewrites
 * from a single pass over the input. Just name the instruction streams and use
 * that name again when printing the buffer. This could be useful for generating
 * a C file and also its header file--all from the same buffer:
 *
 * ```
 * rewriter.insertAfter("pass1", t, "text to put after t");}
 * rewriter.insertAfter("pass2", u, "text after u");}
 * System.out.println(rewriter.getText("pass1"));
 * System.out.println(rewriter.getText("pass2"));
 * ```
 *
 * If you don't use named rewrite streams, a "default" stream is used as the
 * first example shows.
 */ class $9fca043c2d5f0853$var$TokenStreamRewriter {
    constructor(tokens){
        this.tokens = tokens;
        this.programs = new Map();
        this.programs.set($9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME, []);
        this.lastRewriteTokenIndexes = new Map();
    }
    getTokenStream() {
        return this.tokens;
    }
    rollback(instructionIndex, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let is = this.programs.get(programName);
        if (is != null) this.programs.set(programName, is.slice($9fca043c2d5f0853$var$TokenStreamRewriter.MIN_TOKEN_INDEX, instructionIndex));
    }
    deleteProgram(programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        this.rollback($9fca043c2d5f0853$var$TokenStreamRewriter.MIN_TOKEN_INDEX, programName);
    }
    insertAfter(tokenOrIndex, text, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        // to insert after, just insert before next index (even if past end)
        let rewrites = this.getProgram(programName);
        let op = new $9fca043c2d5f0853$var$InsertAfterOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    insertBefore(tokenOrIndex, text, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        let rewrites = this.getProgram(programName);
        let op = new $9fca043c2d5f0853$var$InsertBeforeOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    replaceSingle(index, text) {
        if (typeof index === "number") this.replace(index, index, text);
        else this.replace(index, index, text);
    }
    replace(from, to, text, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (typeof from !== "number") from = from.tokenIndex;
        if (typeof to !== "number") to = to.tokenIndex;
        if (from > to || from < 0 || to < 0 || to >= this.tokens.size) throw new RangeError(`replace: range invalid: ${from}..${to}(size=${this.tokens.size})`);
        let rewrites = this.getProgram(programName);
        let op = new $9fca043c2d5f0853$var$ReplaceOp(this.tokens, from, to, rewrites.length, text);
        rewrites.push(op);
    }
    delete(from, to, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (to === undefined) to = from;
        if (typeof from === "number") this.replace(from, to, "", programName);
        else this.replace(from, to, "", programName);
    }
    getLastRewriteTokenIndex(programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let I = this.lastRewriteTokenIndexes.get(programName);
        if (I == null) return -1;
        return I;
    }
    setLastRewriteTokenIndex(programName, i) {
        this.lastRewriteTokenIndexes.set(programName, i);
    }
    getProgram(name) {
        let is = this.programs.get(name);
        if (is == null) is = this.initializeProgram(name);
        return is;
    }
    initializeProgram(name) {
        let is = [];
        this.programs.set(name, is);
        return is;
    }
    getText(intervalOrProgram, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let interval;
        if (intervalOrProgram instanceof $gcfUE.Interval) interval = intervalOrProgram;
        else interval = $gcfUE.Interval.of(0, this.tokens.size - 1);
        if (typeof intervalOrProgram === "string") programName = intervalOrProgram;
        let rewrites = this.programs.get(programName);
        let start = interval.a;
        let stop = interval.b;
        // ensure start/end are in range
        if (stop > this.tokens.size - 1) stop = this.tokens.size - 1;
        if (start < 0) start = 0;
        if (rewrites == null || rewrites.length === 0) return this.tokens.getText(interval); // no instructions to execute
        let buf = [];
        // First, optimize instruction stream
        let indexToOp = this.reduceToSingleOperationPerIndex(rewrites);
        // Walk buffer, executing instructions and emitting tokens
        let i = start;
        while(i <= stop && i < this.tokens.size){
            let op = indexToOp.get(i);
            indexToOp.delete(i); // remove so any left have index size-1
            let t = this.tokens.get(i);
            if (op == null) {
                // no operation at that index, just dump token
                if (t.type !== $2DVsz.Token.EOF) buf.push(String(t.text));
                i++; // move to next token
            } else i = op.execute(buf); // execute operation and skip
        }
        // include stuff after end if it's last index in buffer
        // So, if they did an insertAfter(lastValidIndex, "foo"), include
        // foo if end==lastValidIndex.
        if (stop === this.tokens.size - 1) {
            // Scan any remaining operations after last token
            // should be included (they will be inserts).
            for (let op of indexToOp.values())if (op.index >= this.tokens.size - 1) buf.push(op.text.toString());
        }
        return buf.join("");
    }
    /** We need to combine operations and report invalid operations (like
     *  overlapping replaces that are not completed nested). Inserts to
     *  same index need to be combined etc...  Here are the cases:
     *
     *  I.i.u I.j.v								leave alone, nonoverlapping
     *  I.i.u I.i.v								combine: Iivu
     *
     *  R.i-j.u R.x-y.v	| i-j in x-y			delete first R
     *  R.i-j.u R.i-j.v							delete first R
     *  R.i-j.u R.x-y.v	| x-y in i-j			ERROR
     *  R.i-j.u R.x-y.v	| boundaries overlap	ERROR
     *
     *  Delete special case of replace (text==undefined):
     *  D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
     *
     *  I.i.u R.x-y.v | i in (x+1)-y			delete I (since insert before
     * 											we're not deleting i)
     *  I.i.u R.x-y.v | i not in (x+1)-y		leave alone, nonoverlapping
     *  R.x-y.v I.i.u | i in x-y				ERROR
     *  R.x-y.v I.x.u 							R.x-y.uv (combine, delete I)
     *  R.x-y.v I.i.u | i not in x-y			leave alone, nonoverlapping
     *
     *  I.i.u = insert u before op @ index i
     *  R.x-y.u = replace x-y indexed tokens with u
     *
     *  First we need to examine replaces. For any replace op:
     *
     * 		1. wipe out any insertions before op within that range.
     * 		2. Drop any replace op before that is contained completely within
     * 	 that range.
     * 		3. Throw exception upon boundary overlap with any previous replace.
     *
     *  Then we can deal with inserts:
     *
     * 		1. for any inserts to same index, combine even if not adjacent.
     * 		2. for any prior replace with same left boundary, combine this
     * 	 insert with replace and delete this replace.
     * 		3. throw exception if index in same range as previous replace
     *
     *  Don't actually delete; make op undefined in list. Easier to walk list.
     *  Later we can throw as we add to index &rarr; op map.
     *
     *  Note that I.2 R.2-2 will wipe out I.2 even though, technically, the
     *  inserted stuff would be before the replace range. But, if you
     *  add tokens in front of a method body '{' and then delete the method
     *  body, I think the stuff before the '{' you added should disappear too.
     *
     *  Return a map from token index to operation.
     */ reduceToSingleOperationPerIndex(rewrites) {
        // console.log(`rewrites=[${Utils.join(rewrites, ", ")}]`);
        // WALK REPLACES
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $9fca043c2d5f0853$var$ReplaceOp)) continue;
            let rop = op;
            // Wipe prior inserts within range
            let inserts = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$InsertBeforeOp, i);
            for (let iop of inserts){
                if (iop.index === rop.index) {
                    // E.g., insert before 2, delete 2..2; update replace
                    // text to include insert before, kill insert
                    rewrites[iop.instructionIndex] = undefined;
                    rop.text = iop.text.toString() + (rop.text != null ? rop.text.toString() : "");
                } else if (iop.index > rop.index && iop.index <= rop.lastIndex) // delete insert as it's a no-op.
                rewrites[iop.instructionIndex] = undefined;
            }
            // Drop any prior replaces contained within
            let prevReplaces = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$ReplaceOp, i);
            for (let prevRop of prevReplaces){
                if (prevRop.index >= rop.index && prevRop.lastIndex <= rop.lastIndex) {
                    // delete replace as it's a no-op.
                    rewrites[prevRop.instructionIndex] = undefined;
                    continue;
                }
                // throw exception unless disjoint or identical
                let disjoint = prevRop.lastIndex < rop.index || prevRop.index > rop.lastIndex;
                // Delete special case of replace (text==null):
                // D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
                if (prevRop.text == null && rop.text == null && !disjoint) {
                    // console.log(`overlapping deletes: ${prevRop}, ${rop}`);
                    rewrites[prevRop.instructionIndex] = undefined; // kill first delete
                    rop.index = Math.min(prevRop.index, rop.index);
                    rop.lastIndex = Math.max(prevRop.lastIndex, rop.lastIndex);
                // console.log(`new rop ${rop}`);
                } else if (!disjoint) throw new Error(`replace op boundaries of ${rop} overlap with previous ${prevRop}`);
            }
        }
        // WALK INSERTS
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $9fca043c2d5f0853$var$InsertBeforeOp)) continue;
            let iop = op;
            // combine current insert with prior if any at same index
            let prevInserts = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$InsertBeforeOp, i);
            for (let prevIop of prevInserts)if (prevIop.index === iop.index) {
                if (prevIop instanceof $9fca043c2d5f0853$var$InsertAfterOp) {
                    iop.text = this.catOpText(prevIop.text, iop.text);
                    rewrites[prevIop.instructionIndex] = undefined;
                } else if (prevIop instanceof $9fca043c2d5f0853$var$InsertBeforeOp) {
                    // convert to strings...we're in process of toString'ing
                    // whole token buffer so no lazy eval issue with any templates
                    iop.text = this.catOpText(iop.text, prevIop.text);
                    // delete redundant prior insert
                    rewrites[prevIop.instructionIndex] = undefined;
                }
            }
            // look for replaces where iop.index is in range; error
            let prevReplaces = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$ReplaceOp, i);
            for (let rop of prevReplaces){
                if (iop.index === rop.index) {
                    rop.text = this.catOpText(iop.text, rop.text);
                    rewrites[i] = undefined; // delete current insert
                    continue;
                }
                if (iop.index >= rop.index && iop.index <= rop.lastIndex) throw new Error(`insert op ${iop} within boundaries of previous ${rop}`);
            }
        }
        // console.log(`rewrites after=[${Utils.join(rewrites, ", ")}]`);
        let m = new Map();
        for (let op of rewrites){
            if (op == null) continue;
            if (m.get(op.index) != null) throw new Error("should only be one op per index");
            m.set(op.index, op);
        }
        // console.log(`index to op: ${m}`);
        return m;
    }
    catOpText(a, b) {
        let x = "";
        let y = "";
        if (a != null) x = a.toString();
        if (b != null) y = b.toString();
        return x + y;
    }
    /** Get all operations before an index of a particular kind */ getKindOfOps(rewrites, kind, before) {
        let ops = [];
        for(let i = 0; i < before && i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (op instanceof kind) ops.push(op);
        }
        return ops;
    }
}
module.exports.TokenStreamRewriter = $9fca043c2d5f0853$var$TokenStreamRewriter;
$9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME = "default";
$9fca043c2d5f0853$var$TokenStreamRewriter.PROGRAM_INIT_SIZE = 100;
$9fca043c2d5f0853$var$TokenStreamRewriter.MIN_TOKEN_INDEX = 0;
// Define the rewrite operation hierarchy
class $9fca043c2d5f0853$var$RewriteOperation {
    constructor(tokens, index, instructionIndex, text){
        this.tokens = tokens;
        this.instructionIndex = instructionIndex;
        this.index = index;
        this.text = text === undefined ? "" : text;
    }
    /** Execute the rewrite operation by possibly adding to the buffer.
     *  Return the index of the next token to operate on.
     */ execute(buf) {
        return this.index;
    }
    toString() {
        let opName = this.constructor.name;
        let $index = opName.indexOf("$");
        opName = opName.substring($index + 1, opName.length);
        return "<" + opName + "@" + this.tokens.get(this.index) + ":\"" + this.text + "\">";
    }
}
$9fca043c2d5f0853$var$__decorate([
    $d6D31.Override
], $9fca043c2d5f0853$var$RewriteOperation.prototype, "toString", null);
module.exports.RewriteOperation = $9fca043c2d5f0853$var$RewriteOperation;
class $9fca043c2d5f0853$var$InsertBeforeOp extends $9fca043c2d5f0853$var$RewriteOperation {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index, instructionIndex, text);
    }
    execute(buf) {
        buf.push(this.text.toString());
        if (this.tokens.get(this.index).type !== $2DVsz.Token.EOF) buf.push(String(this.tokens.get(this.index).text));
        return this.index + 1;
    }
}
$9fca043c2d5f0853$var$__decorate([
    $d6D31.Override
], $9fca043c2d5f0853$var$InsertBeforeOp.prototype, "execute", null);
/** Distinguish between insert after/before to do the "insert afters"
 *  first and then the "insert befores" at same index. Implementation
 *  of "insert after" is "insert before index+1".
 */ class $9fca043c2d5f0853$var$InsertAfterOp extends $9fca043c2d5f0853$var$InsertBeforeOp {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index + 1, instructionIndex, text); // insert after is insert before index+1
    }
}
/** I'm going to try replacing range from x..y with (y-x)+1 ReplaceOp
 *  instructions.
 */ class $9fca043c2d5f0853$var$ReplaceOp extends $9fca043c2d5f0853$var$RewriteOperation {
    constructor(tokens, from, to, instructionIndex, text){
        super(tokens, from, instructionIndex, text);
        this.lastIndex = to;
    }
    execute(buf) {
        if (this.text != null) buf.push(this.text.toString());
        return this.lastIndex + 1;
    }
    toString() {
        if (this.text == null) return "<DeleteOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ">";
        return "<ReplaceOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ":\"" + this.text + "\">";
    }
}
$9fca043c2d5f0853$var$__decorate([
    $d6D31.Override
], $9fca043c2d5f0853$var$ReplaceOp.prototype, "execute", null);
$9fca043c2d5f0853$var$__decorate([
    $d6D31.Override
], $9fca043c2d5f0853$var$ReplaceOp.prototype, "toString", null);

});

parcelRegister("1MVGg", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6UcB4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("b0Pfd", function(module, exports) {

$parcel$export(module.exports, "JQLLexer", () => $e8c2106cf53953f8$export$375c79404cc64c7f);
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Generated from JQLLexer.g4 by ANTLR 4.7.3-SNAPSHOT

var $dvgsl = parcelRequire("dvgsl");

var $igNLf = parcelRequire("igNLf");

var $lQecE = parcelRequire("lQecE");

var $3n2FE = parcelRequire("3n2FE");

var $2IEP9 = parcelRequire("2IEP9");
class $e8c2106cf53953f8$export$375c79404cc64c7f extends (0, $igNLf.Lexer) {
    static{
        this.LPAREN = 1;
    }
    static{
        this.RPAREN = 2;
    }
    static{
        this.COMMA = 3;
    }
    static{
        this.LBRACKET = 4;
    }
    static{
        this.RBRACKET = 5;
    }
    static{
        this.BANG = 6;
    }
    static{
        this.LT = 7;
    }
    static{
        this.GT = 8;
    }
    static{
        this.GTEQ = 9;
    }
    static{
        this.LTEQ = 10;
    }
    static{
        this.EQUALS = 11;
    }
    static{
        this.NOT_EQUALS = 12;
    }
    static{
        this.LIKE = 13;
    }
    static{
        this.NOT_LIKE = 14;
    }
    static{
        this.IN = 15;
    }
    static{
        this.IS = 16;
    }
    static{
        this.AND = 17;
    }
    static{
        this.OR = 18;
    }
    static{
        this.NOT = 19;
    }
    static{
        this.EMPTY = 20;
    }
    static{
        this.WAS = 21;
    }
    static{
        this.CHANGED = 22;
    }
    static{
        this.BEFORE = 23;
    }
    static{
        this.AFTER = 24;
    }
    static{
        this.FROM = 25;
    }
    static{
        this.TO = 26;
    }
    static{
        this.ON = 27;
    }
    static{
        this.DURING = 28;
    }
    static{
        this.ORDER = 29;
    }
    static{
        this.BY = 30;
    }
    static{
        this.ASC = 31;
    }
    static{
        this.DESC = 32;
    }
    static{
        this.POSNUMBER = 33;
    }
    static{
        this.NEGNUMBER = 34;
    }
    static{
        this.CUSTOMFIELD = 35;
    }
    static{
        this.RESERVED_WORD = 36;
    }
    static{
        this.STRING = 37;
    }
    static{
        this.MATCHWS = 38;
    }
    static{
        this.ERROR_RESERVED = 39;
    }
    static{
        this.ERRORCHAR = 40;
    }
    static{
        this.QUOTE_STRING = 41;
    }
    static{
        this.UNCLOSED_QUOTE_STRING = 42;
    }
    static{
        this.INVALID_QUOTE_STRING = 43;
    }
    static{
        this.SQUOTE_STRING = 44;
    }
    static{
        this.UNCLOSED_SQUOTE_STRING = 45;
    }
    static{
        this.INVALID_SQUOTE_STRING = 46;
    }
    static{
        this.QUOTED_STR = 1;
    }
    static{
        this.SQUOTED_STR = 2;
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.channelNames = [
            'DEFAULT_TOKEN_CHANNEL',
            'HIDDEN'
        ];
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.modeNames = [
            'DEFAULT_MODE',
            'QUOTED_STR',
            'SQUOTED_STR'
        ];
    }
    static{
        this.ruleNames = [
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'LQUOTE',
            'LSQUOTE',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'QUOTED_CONTENT',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'SQUOTED_CONTENT',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING',
            'VALID_UNQUOTED_CHARS',
            'VALID_QUOTED_CHARS',
            'VALID_SQUOTED_CHARS',
            'RESERVED_CHARS',
            'QUOTE',
            'SQUOTE',
            'BSLASH',
            'NL',
            'CR',
            'SPACE',
            'AMPER',
            'AMPER_AMPER',
            'PIPE',
            'PIPE_PIPE',
            'ESCAPE',
            'NEWLINE',
            'HEXDIGIT',
            'WS',
            'MINUS',
            'DIGIT',
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z'
        ];
    }
    static{
        this._LITERAL_NAMES = [
            undefined,
            "'('",
            "')'",
            "','",
            "'['",
            "']'",
            "'!'",
            "'<'",
            "'>'",
            "'>='",
            "'<='",
            "'='",
            "'!='",
            "'~'",
            "'!~'"
        ];
    }
    static{
        this._SYMBOLIC_NAMES = [
            undefined,
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING'
        ];
    }
    static{
        this.VOCABULARY = new (0, $3n2FE.VocabularyImpl)($e8c2106cf53953f8$export$375c79404cc64c7f._LITERAL_NAMES, $e8c2106cf53953f8$export$375c79404cc64c7f._SYMBOLIC_NAMES, []);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return $e8c2106cf53953f8$export$375c79404cc64c7f.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    constructor(input){
        super(input);
        this._interp = new (0, $lQecE.LexerATNSimulator)($e8c2106cf53953f8$export$375c79404cc64c7f._ATN, this);
    }
    // @Override
    get grammarFileName() {
        return 'JQLLexer.g4';
    }
    // @Override
    get ruleNames() {
        return $e8c2106cf53953f8$export$375c79404cc64c7f.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $e8c2106cf53953f8$export$375c79404cc64c7f._serializedATN;
    }
    // @Override
    get channelNames() {
        return $e8c2106cf53953f8$export$375c79404cc64c7f.channelNames;
    }
    // @Override
    get modeNames() {
        return $e8c2106cf53953f8$export$375c79404cc64c7f.modeNames;
    }
    static{
        this._serializedATNSegments = 3;
    }
    static{
        this._serializedATNSegment0 = "\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x020\u062E\b\x01\b\x01\b\x01\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04\"	\"\x04#	#\x04$	$\x04%	%\x04&	&\x04'	'\x04(	(\x04)	)\x04*	*\x04+	+\x04,	,\x04-	-\x04.	.\x04/	/\x040	0\x041	1\x042	2\x043	3\x044	4\x045	5\x046	6\x047	7\x048	8\x049	9\x04:	:\x04;	;\x04<	<\x04=	=\x04>	>\x04?	?\x04@	@\x04A	A\x04B	B\x04C	C\x04D	D\x04E	E\x04F	F\x04G	G\x04H	H\x04I	I\x04J	J\x04K	K\x04L	L\x04M	M\x04N	N\x04O	O\x04P	P\x04Q	Q\x04R	R\x04S	S\x04T	T\x04U	U\x04V	V\x04W	W\x04X	X\x04Y	Y\x04Z	Z\x04[	[\x04\\	\\\x04]	]\x04^	^\x04_	_\x04`	`\x04a	a\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x05\x03\x05\x03\x06\x03\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03\b\x03\b\x03	\x03	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\f\x03\r\x03\r\x03\r\x03\x0e\x03\x0e\x03\x0f\x03\x0f\x03\x0f\x03\x10\x03\x10\x03\x11\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x03\x13\x03\x13\x03\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x05\x14\xfc\n\x14\x03\x15\x03\x15\x03\x15\x03\x15\x03\x15\x05\x15\u0103\n\x15\x03\x16\x03\x16\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\u0114\n\x17\x03\x18\x03\x18\x03\x18\x03\x18\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03 \x03 \x03 \x03 \x03 \x03 \x03!\x03!\x03!\x03\"\x03\"\x03\"\x03\"\x03#\x03#\x03#\x03#\x03#\x03$\x06$\u0154\n$\r$\x0e$\u0155\x03%\x03%\x06%\u015A\n%\r%\x0e%\u015B\x03&\x03&\x03&\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x05'\u0582\n'\x03(\x03(\x06(\u0586\n(\r(\x0e(\u0587\x03)\x06)\u058B\n)\r)\x0e)\u058C\x03)\x03)\x03*\x03*\x03+\x03+\x03,\x03,\x03,\x03,\x03-\x03-\x05-\u059B\n-\x03-\x03-\x03.\x03.\x03.\x03.\x03/\x03/\x03/\x03/\x030\x030\x030\x030\x031\x031\x051\u05AD\n1\x031\x031\x032\x032\x032\x032\x033\x033\x033\x033\x034\x034\x035\x035\x036\x036\x037\x037\x038\x038\x039\x039\x03:\x03:\x03;\x03;\x03<\x03<\x03=\x03=\x03>\x03>\x03?\x03?\x03?\x03@\x03@\x03A\x03A\x03A\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x05B\u05E3\nB\x03C\x03C\x05C\u05E7\nC\x03D\x03D\x03D\x03D\x03D\x03D\x03D\x05D\u05F0\nD\x03E\x03E\x03E\x05E\u05F5\nE\x03F\x03F\x03G\x03G\x03H\x03H\x03I\x03I\x03J\x03J\x03K\x03K\x03L\x03L\x03M\x03M\x03N\x03N\x03O\x03O\x03P\x03P\x03Q\x03Q\x03R\x03R\x03S\x03S\x03T\x03T\x03U\x03U\x03V\x03V\x03W\x03W\x03X\x03X\x03Y\x03Y\x03Z\x03Z\x03[\x03[\x03\\\x03\\\x03]\x03]\x03^\x03^\x03_\x03_\x03`\x03`\x03a\x03a\x02\x02\x02b\x05\x02\x03\x07\x02\x04	\x02\x05\v\x02\x06\r\x02\x07\x0f\x02\x02\x11\x02\x02\x13\x02\b\x15\x02	\x17\x02\n\x19\x02\v\x1b\x02\f\x1d\x02\r\x1f\x02\x0e!\x02\x0f#\x02\x10%\x02\x11'\x02\x12)\x02\x13+\x02\x14-\x02\x15/\x02\x161\x02\x173\x02\x185\x02\x197\x02\x1a9\x02\x1b;\x02\x1c=\x02\x1d?\x02\x1eA\x02\x1fC\x02 E\x02!G\x02\"I\x02#K\x02$M\x02%O\x02&Q\x02'S\x02(U\x02)W\x02*Y\x02+[\x02\x02]\x02,_\x02-a\x02.c\x02\x02e\x02/g\x020i\x02\x02k\x02\x02m\x02\x02o\x02\x02q\x02\x02s\x02\x02u\x02\x02w\x02\x02y\x02\x02{\x02\x02}\x02\x02\x7f\x02\x02\x81\x02\x02\x83\x02\x02\x85\x02\x02\x87\x02\x02\x89\x02\x02\x8b\x02\x02\x8d\x02\x02\x8f\x02\x02\x91\x02\x02\x93\x02\x02\x95\x02\x02\x97\x02\x02\x99\x02\x02\x9b\x02\x02\x9d\x02\x02\x9f\x02\x02\xa1\x02\x02\xa3\x02\x02\xa5\x02\x02\xa7\x02\x02\xa9\x02\x02\xab\x02\x02\xad\x02\x02\xaf\x02\x02\xb1\x02\x02\xb3\x02\x02\xb5\x02\x02\xb7\x02\x02\xb9\x02\x02\xbb\x02\x02\xbd\x02\x02\xbf\x02\x02\xc1\x02\x02\xc3\x02\x02\x05\x02\x03\x04\"	\x02\x02.11=B]`}\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!$$^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!))^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02%',-11==AB``}}\x7f\x7f\x05\x02ppttvv\x03\x022;\x04\x02CCcc\x04\x02DDdd\x04\x02EEee\x04\x02FFff\x04\x02GGgg\x04\x02HHhh\x04\x02IIii\x04\x02JJjj\x04\x02KKkk\x04\x02LLll\x04\x02MMmm\x04\x02NNnn\x04\x02OOoo\x04\x02PPpp\x04\x02QQqq\x04\x02RRrr\x04\x02SSss\x04\x02TTtt\x04\x02UUuu\x04\x02VVvv\x04\x02WWww\x04\x02XXxx\x04\x02YYyy\x04\x02ZZzz\x04\x02[[{{\x04\x02\\\\||\x02\u06B5\x02\x05\x03\x02\x02\x02\x02\x07\x03\x02\x02\x02\x02	\x03\x02\x02\x02\x02\v\x03\x02\x02\x02\x02\r\x03\x02\x02\x02\x02\x0f\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02\x02\x13\x03\x02\x02\x02\x02\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02\x02\x19\x03\x02\x02\x02\x02\x1b\x03\x02\x02\x02\x02\x1d\x03\x02\x02\x02\x02\x1f\x03\x02\x02\x02\x02!\x03\x02\x02\x02\x02#\x03\x02\x02\x02\x02%\x03\x02\x02\x02\x02'\x03\x02\x02\x02\x02)\x03\x02\x02\x02\x02+\x03\x02\x02\x02\x02-\x03\x02\x02\x02\x02/\x03\x02\x02\x02\x021\x03\x02\x02\x02\x023\x03\x02\x02\x02\x025\x03\x02\x02\x02\x027\x03\x02\x02\x02\x029\x03\x02\x02\x02\x02;\x03\x02\x02\x02\x02=\x03\x02\x02\x02\x02?\x03\x02\x02\x02\x02A\x03\x02\x02\x02\x02C\x03\x02\x02\x02\x02E\x03\x02\x02\x02\x02G\x03\x02\x02\x02\x02I\x03\x02\x02\x02\x02K\x03\x02\x02\x02\x02M\x03\x02\x02\x02\x02O\x03\x02\x02\x02\x02Q\x03\x02\x02\x02\x02S\x03\x02\x02\x02\x02U\x03\x02\x02\x02\x02W\x03\x02\x02\x02\x03Y\x03\x02\x02\x02\x03[\x03\x02\x02\x02\x03]\x03\x02\x02\x02\x03_\x03\x02\x02\x02\x04a\x03\x02\x02\x02\x04c\x03\x02\x02\x02\x04e\x03\x02\x02\x02\x04g\x03\x02\x02\x02\x05\xc5\x03\x02\x02\x02\x07\xc7\x03\x02\x02\x02	\xc9\x03\x02\x02\x02\v\xcb\x03\x02\x02\x02\r\xcd\x03\x02\x02\x02\x0f\xcf\x03\x02\x02\x02\x11\xd4\x03\x02\x02\x02\x13\xd9\x03\x02\x02\x02\x15\xdb\x03\x02\x02\x02\x17\xdd\x03\x02\x02\x02\x19\xdf\x03\x02\x02\x02\x1b\xe2\x03\x02\x02\x02\x1d\xe5\x03\x02\x02\x02\x1f\xe7\x03\x02\x02\x02!\xea\x03\x02\x02\x02#\xec\x03\x02\x02\x02%\xef\x03\x02\x02\x02'\xf2\x03\x02\x02\x02)\xfb\x03\x02\x02\x02+\u0102\x03\x02\x02\x02-\u0104\x03\x02\x02\x02/\u0113\x03\x02\x02\x021\u0115\x03\x02\x02\x023\u0119\x03\x02\x02\x025\u0121\x03\x02\x02\x027\u0128\x03\x02\x02\x029\u012E\x03\x02\x02\x02;\u0133\x03\x02\x02\x02=\u0136\x03\x02\x02\x02?\u0139\x03\x02\x02\x02A\u0140\x03\x02\x02\x02C\u0146\x03\x02\x02\x02E\u0149\x03\x02\x02\x02G\u014D\x03\x02\x02\x02I\u0153\x03\x02\x02\x02K\u0157\x03\x02\x02\x02M\u015D\x03\x02\x02\x02O\u0581\x03\x02\x02\x02Q\u0585\x03\x02\x02\x02S\u058A\x03\x02\x02\x02U\u0590\x03\x02\x02\x02W\u0592\x03\x02\x02\x02Y\u0594\x03\x02\x02\x02[\u059A\x03\x02\x02\x02]\u059E\x03\x02\x02\x02_\u05A2\x03\x02\x02\x02a\u05A6\x03\x02\x02\x02c\u05AC\x03\x02\x02\x02e\u05B0\x03\x02\x02\x02g\u05B4\x03\x02\x02\x02i\u05B8\x03\x02\x02\x02k\u05BA\x03\x02\x02\x02m\u05BC\x03\x02\x02\x02o\u05BE\x03\x02\x02\x02q\u05C0\x03\x02\x02\x02s\u05C2\x03\x02\x02\x02u\u05C4\x03\x02\x02\x02w\u05C6\x03\x02\x02\x02y\u05C8\x03\x02\x02\x02{\u05CA\x03\x02\x02\x02}\u05CC\x03\x02\x02\x02\x7f\u05CE\x03\x02\x02\x02\x81\u05D1\x03\x02\x02\x02\x83\u05D3\x03\x02\x02\x02\x85\u05D6\x03\x02\x02\x02\x87\u05E6\x03\x02\x02\x02\x89\u05EF\x03\x02\x02\x02\x8b\u05F4\x03\x02\x02\x02\x8d\u05F6\x03\x02\x02\x02\x8f\u05F8\x03\x02\x02\x02\x91\u05FA\x03\x02\x02\x02\x93\u05FC\x03\x02\x02\x02\x95\u05FE\x03\x02\x02\x02\x97\u0600\x03\x02\x02\x02\x99\u0602\x03\x02\x02\x02\x9b\u0604\x03\x02\x02\x02\x9d\u0606\x03\x02\x02\x02\x9f\u0608\x03\x02\x02\x02\xa1\u060A\x03\x02\x02\x02\xa3\u060C\x03\x02\x02\x02\xa5\u060E\x03\x02\x02\x02\xa7\u0610\x03\x02\x02\x02\xa9\u0612\x03\x02\x02\x02\xab\u0614\x03\x02\x02\x02\xad\u0616\x03\x02\x02\x02\xaf\u0618\x03\x02\x02\x02\xb1\u061A\x03\x02\x02\x02\xb3\u061C\x03\x02\x02\x02\xb5\u061E\x03\x02\x02\x02\xb7\u0620\x03\x02\x02\x02\xb9\u0622\x03\x02\x02\x02\xbb\u0624\x03\x02\x02\x02\xbd\u0626\x03\x02\x02\x02\xbf\u0628\x03\x02\x02\x02\xc1\u062A\x03\x02\x02\x02\xc3\u062C\x03\x02\x02\x02\xc5\xc6\x07*\x02\x02\xc6\x06\x03\x02\x02\x02\xc7\xc8\x07+\x02\x02\xc8\b\x03\x02\x02\x02\xc9\xca\x07.\x02\x02\xca\n\x03\x02\x02\x02\xcb\xcc\x07]\x02\x02\xcc\f\x03\x02\x02\x02\xcd\xce\x07_\x02\x02\xce\x0e\x03\x02\x02\x02\xcf\xd0\x05q8\x02\xd0\xd1\x03\x02\x02\x02\xd1\xd2\b\x07\x02\x02\xd2\xd3\b\x07\x03\x02\xd3\x10\x03\x02\x02\x02\xd4\xd5\x05s9\x02\xd5\xd6\x03\x02\x02\x02\xd6\xd7\b\b\x02\x02\xd7\xd8\b\b\x04\x02\xd8\x12\x03\x02\x02\x02\xd9\xda\x07#\x02\x02\xda\x14\x03\x02\x02\x02\xdb\xdc\x07>\x02\x02\xdc\x16\x03\x02\x02\x02\xdd\xde\x07@\x02\x02\xde\x18\x03\x02\x02\x02\xdf\xe0\x07@\x02\x02\xe0\xe1\x07?\x02\x02\xe1\x1a\x03\x02\x02\x02\xe2\xe3\x07>\x02\x02\xe3\xe4\x07?\x02\x02\xe4\x1c\x03\x02\x02\x02\xe5\xe6\x07?\x02\x02\xe6\x1e\x03\x02\x02\x02\xe7\xe8\x07#\x02\x02\xe8\xe9\x07?\x02\x02\xe9 \x03\x02\x02\x02\xea\xeb\x07\x80\x02\x02\xeb\"\x03\x02\x02\x02\xec\xed\x07#\x02\x02\xed\xee\x07\x80\x02\x02\xee$\x03\x02\x02\x02\xef\xf0\x05\xa1P\x02\xf0\xf1\x05\xabU\x02\xf1&\x03\x02\x02\x02\xf2\xf3\x05\xa1P\x02\xf3\xf4\x05\xb5Z\x02\xf4(\x03\x02\x02\x02\xf5\xf6\x05\x91H\x02\xf6\xf7\x05\xabU\x02\xf7\xf8\x05\x97K\x02\xf8\xfc\x03\x02\x02\x02\xf9\xfc\x05}>\x02\xfa\xfc\x05\x7f?\x02\xfb\xf5\x03\x02\x02\x02\xfb\xf9\x03\x02\x02\x02\xfb\xfa\x03\x02\x02\x02\xfc*\x03\x02\x02\x02\xfd\xfe\x05\xadV\x02\xfe\xff\x05\xb3Y\x02\xff\u0103\x03\x02\x02\x02\u0100\u0103\x05\x81@\x02\u0101\u0103\x05\x83A\x02\u0102\xfd\x03\x02\x02\x02\u0102\u0100\x03\x02\x02\x02\u0102\u0101\x03\x02\x02\x02\u0103";
    }
    static{
        this._serializedATNSegment1 = ",\x03\x02\x02\x02\u0104\u0105\x05\xabU\x02\u0105\u0106\x05\xadV\x02\u0106\u0107\x05\xb7[\x02\u0107.\x03\x02\x02\x02\u0108\u0109\x05\x99L\x02\u0109\u010A\x05\xa9T\x02\u010A\u010B\x05\xafW\x02\u010B\u010C\x05\xb7[\x02\u010C\u010D\x05\xc1`\x02\u010D\u0114\x03\x02\x02\x02\u010E\u010F\x05\xabU\x02\u010F\u0110\x05\xb9\\\x02\u0110\u0111\x05\xa7S\x02\u0111\u0112\x05\xa7S\x02\u0112\u0114\x03\x02\x02\x02\u0113\u0108\x03\x02\x02\x02\u0113\u010E\x03\x02\x02\x02\u01140\x03\x02\x02\x02\u0115\u0116\x05\xbd^\x02\u0116\u0117\x05\x91H\x02\u0117\u0118\x05\xb5Z\x02\u01182\x03\x02\x02\x02\u0119\u011A\x05\x95J\x02\u011A\u011B\x05\x9fO\x02\u011B\u011C\x05\x91H\x02\u011C\u011D\x05\xabU\x02\u011D\u011E\x05\x9dN\x02\u011E\u011F\x05\x99L\x02\u011F\u0120\x05\x97K\x02\u01204\x03\x02\x02\x02\u0121\u0122\x05\x93I\x02\u0122\u0123\x05\x99L\x02\u0123\u0124\x05\x9bM\x02\u0124\u0125\x05\xadV\x02\u0125\u0126\x05\xb3Y\x02\u0126\u0127\x05\x99L\x02\u01276\x03\x02\x02\x02\u0128\u0129\x05\x91H\x02\u0129\u012A\x05\x9bM\x02\u012A\u012B\x05\xb7[\x02\u012B\u012C\x05\x99L\x02\u012C\u012D\x05\xb3Y\x02\u012D8\x03\x02\x02\x02\u012E\u012F\x05\x9bM\x02\u012F\u0130\x05\xb3Y\x02\u0130\u0131\x05\xadV\x02\u0131\u0132\x05\xa9T\x02\u0132:\x03\x02\x02\x02\u0133\u0134\x05\xb7[\x02\u0134\u0135\x05\xadV\x02\u0135<\x03\x02\x02\x02\u0136\u0137\x05\xadV\x02\u0137\u0138\x05\xabU\x02\u0138>\x03\x02\x02\x02\u0139\u013A\x05\x97K\x02\u013A\u013B\x05\xb9\\\x02\u013B\u013C\x05\xb3Y\x02\u013C\u013D\x05\xa1P\x02\u013D\u013E\x05\xabU\x02\u013E\u013F\x05\x9dN\x02\u013F@\x03\x02\x02\x02\u0140\u0141\x05\xadV\x02\u0141\u0142\x05\xb3Y\x02\u0142\u0143\x05\x97K\x02\u0143\u0144\x05\x99L\x02\u0144\u0145\x05\xb3Y\x02\u0145B\x03\x02\x02\x02\u0146\u0147\x05\x93I\x02\u0147\u0148\x05\xc1`\x02\u0148D\x03\x02\x02\x02\u0149\u014A\x05\x91H\x02\u014A\u014B\x05\xb5Z\x02\u014B\u014C\x05\x95J\x02\u014CF\x03\x02\x02\x02\u014D\u014E\x05\x97K\x02\u014E\u014F\x05\x99L\x02\u014F\u0150\x05\xb5Z\x02\u0150\u0151\x05\x95J\x02\u0151H\x03\x02\x02\x02\u0152\u0154\x05\x8fG\x02\u0153\u0152\x03\x02\x02\x02\u0154\u0155\x03\x02\x02\x02\u0155\u0153\x03\x02\x02\x02\u0155\u0156\x03\x02\x02\x02\u0156J\x03\x02\x02\x02\u0157\u0159\x05\x8dF\x02\u0158\u015A\x05\x8fG\x02\u0159\u0158\x03\x02\x02\x02\u015A\u015B\x03\x02\x02\x02\u015B\u0159\x03\x02\x02\x02\u015B\u015C\x03\x02\x02\x02\u015CL\x03\x02\x02\x02\u015D\u015E\x05\x95J\x02\u015E\u015F\x05\x9bM\x02\u015FN\x03\x02\x02\x02\u0160\u0161\x05\x91H\x02\u0161\u0162\x05\x93I\x02\u0162\u0163\x05\xadV\x02\u0163\u0164\x05\xb3Y\x02\u0164\u0165\x05\xb7[\x02\u0165\u0582\x03\x02\x02\x02\u0166\u0167\x05\x91H\x02\u0167\u0168\x05\x95J\x02\u0168\u0169\x05\x95J\x02\u0169\u016A\x05\x99L\x02\u016A\u016B\x05\xb5Z\x02\u016B\u016C\x05\xb5Z\x02\u016C\u0582\x03\x02\x02\x02\u016D\u016E\x05\x91H\x02\u016E\u016F\x05\x97K\x02\u016F\u0170\x05\x97K\x02\u0170\u0582\x03\x02\x02\x02\u0171\u0172\x05\x91H\x02\u0172\u0173\x05\xa7S\x02\u0173\u0174\x05\xa1P\x02\u0174\u0175\x05\x91H\x02\u0175\u0176\x05\xb5Z\x02\u0176\u0582\x03\x02\x02\x02\u0177\u0178\x05\x91H\x02\u0178\u0179\x05\xa7S\x02\u0179\u017A\x05\xb7[\x02\u017A\u017B\x05\x99L\x02\u017B\u017C\x05\xb3Y\x02\u017C\u0582\x03\x02\x02\x02\u017D\u017E\x05\x91H\x02\u017E\u017F\x05\xabU\x02\u017F\u0180\x05\xc1`\x02\u0180\u0582\x03\x02\x02\x02\u0181\u0182\x05\x91H\x02\u0182\u0183\x05\xb5Z\x02\u0183\u0582\x03\x02\x02\x02\u0184\u0185\x05\x91H\x02\u0185\u0186\x05\xb9\\\x02\u0186\u0187\x05\x97K\x02\u0187\u0188\x05\xa1P\x02\u0188\u0189\x05\xb7[\x02\u0189\u0582\x03\x02\x02\x02\u018A\u018B\x05\x91H\x02\u018B\u018C\x05\xbb]\x02\u018C\u018D\x05\x9dN\x02\u018D\u0582\x03\x02\x02\x02\u018E\u018F\x05\x93I\x02\u018F\u0190\x05\x99L\x02\u0190\u0191\x05\x9dN\x02\u0191\u0192\x05\xa1P\x02\u0192\u0193\x05\xabU\x02\u0193\u0582\x03\x02\x02\x02\u0194\u0195\x05\x93I\x02\u0195\u0196\x05\x99L\x02\u0196\u0197\x05\xb7[\x02\u0197\u0198\x05\xbd^\x02\u0198\u0199\x05\x99L\x02\u0199\u019A\x05\x99L\x02\u019A\u019B\x05\xabU\x02\u019B\u0582\x03\x02\x02\x02\u019C\u019D\x05\x93I\x02\u019D\u019E\x05\xadV\x02\u019E\u019F\x05\xadV\x02\u019F\u01A0\x05\xa7S\x02\u01A0\u01A1\x05\x99L\x02\u01A1\u01A2\x05\x91H\x02\u01A2\u01A3\x05\xabU\x02\u01A3\u0582\x03\x02\x02\x02\u01A4\u01A5\x05\x93I\x02\u01A5\u01A6\x05\xb3Y\x02\u01A6\u01A7\x05\x99L\x02\u01A7\u01A8\x05\x91H\x02\u01A8\u01A9\x05\xa5R\x02\u01A9\u0582\x03\x02\x02\x02\u01AA\u01AB\x05\x93I\x02\u01AB\u01AC\x05\xc1`\x02\u01AC\u01AD\x05\xb7[\x02\u01AD\u01AE\x05\x99L\x02\u01AE\u0582\x03\x02\x02\x02\u01AF\u01B0\x05\x95J\x02\u01B0\u01B1\x05\x91H\x02\u01B1\u01B2\x05\xb7[\x02\u01B2\u01B3\x05\x95J\x02\u01B3\u01B4\x05\x9fO\x02\u01B4\u0582\x03\x02\x02\x02\u01B5\u01B6\x05\x95J\x02\u01B6\u01B7\x05\x9fO\x02\u01B7\u01B8\x05\x91H\x02\u01B8\u01B9\x05\xb3Y\x02\u01B9\u0582\x03\x02\x02\x02\u01BA\u01BB\x05\x95J\x02\u01BB\u01BC\x05\x9fO\x02\u01BC\u01BD\x05\x91H\x02\u01BD\u01BE\x05\xb3Y\x02\u01BE\u01BF\x05\x91H\x02\u01BF\u01C0\x05\x95J\x02\u01C0\u01C1\x05\xb7[\x02\u01C1\u01C2\x05\x99L\x02\u01C2\u01C3\x05\xb3Y\x02\u01C3\u0582\x03\x02\x02\x02\u01C4\u01C5\x05\x95J\x02\u01C5\u01C6\x05\x9fO\x02\u01C6\u01C7\x05\x99L\x02\u01C7\u01C8\x05\x95J\x02\u01C8\u01C9\x05\xa5R\x02\u01C9\u0582\x03\x02\x02\x02\u01CA\u01CB\x05\x95J\x02\u01CB\u01CC\x05\x9fO\x02\u01CC\u01CD\x05\x99L\x02\u01CD\u01CE\x05\x95J\x02\u01CE\u01CF\x05\xa5R\x02\u01CF\u01D0\x05\xafW\x02\u01D0\u01D1\x05\xadV\x02\u01D1\u01D2\x05\xa1P\x02\u01D2\u01D3\x05\xabU\x02\u01D3\u01D4\x05\xb7[\x02\u01D4\u0582\x03\x02\x02\x02\u01D5\u01D6\x05\x95J\x02\u01D6\u01D7\x05\xadV\x02\u01D7\u01D8\x05\xa7S\x02\u01D8\u01D9\x05\xa7S\x02\u01D9\u01DA\x05\x91H\x02\u01DA\u01DB\x05\xb7[\x02\u01DB\u01DC\x05\x99L\x02\u01DC\u0582\x03\x02\x02\x02\u01DD\u01DE\x05\x95J\x02\u01DE\u01DF\x05\xadV\x02\u01DF\u01E0\x05\xa7S\x02\u01E0\u01E1\x05\xa7S\x02\u01E1\u01E2\x05\x91H\x02\u01E2\u01E3\x05\xb7[\x02\u01E3\u01E4\x05\xa1P\x02\u01E4\u01E5\x05\xadV\x02\u01E5\u01E6\x05\xabU\x02\u01E6\u0582\x03\x02\x02\x02\u01E7\u01E8\x05\x95J\x02\u01E8\u01E9\x05\xadV\x02\u01E9\u01EA\x05\xa7S\x02\u01EA\u01EB\x05\xb9\\\x02\u01EB\u01EC\x05\xa9T\x02\u01EC\u01ED\x05\xabU\x02\u01ED\u0582\x03\x02\x02\x02\u01EE\u01EF\x05\x95J\x02\u01EF\u01F0\x05\xadV\x02\u01F0\u01F1\x05\xa9T\x02\u01F1\u01F2\x05\xa9T\x02\u01F2\u01F3\x05\xa1P\x02\u01F3\u01F4\x05\xb7[\x02\u01F4\u0582\x03\x02\x02\x02\u01F5\u01F6\x05\x95J\x02\u01F6\u01F7\x05\xadV\x02\u01F7\u01F8\x05\xabU\x02\u01F8\u01F9\x05\xabU\x02\u01F9\u01FA\x05\x99L\x02\u01FA\u01FB\x05\x95J\x02\u01FB\u01FC\x05\xb7[\x02\u01FC\u0582\x03\x02\x02\x02\u01FD\u01FE\x05\x95J\x02\u01FE\u01FF\x05\xadV\x02\u01FF\u0200\x05\xabU\x02\u0200\u0201\x05\xb7[\x02\u0201\u0202\x05\xa1P\x02\u0202\u0203\x05\xabU\x02\u0203\u0204\x05\xb9\\\x02\u0204\u0205\x05\x99L\x02\u0205\u0582\x03\x02\x02\x02\u0206\u0207\x05\x95J\x02\u0207\u0208\x05\xadV\x02\u0208\u0209\x05\xb9\\\x02\u0209\u020A\x05\xabU\x02\u020A\u020B\x05\xb7[\x02\u020B\u0582\x03\x02\x02\x02\u020C\u020D\x05\x95J\x02\u020D\u020E\x05\xb3Y\x02\u020E\u020F\x05\x99L\x02\u020F\u0210\x05\x91H\x02\u0210\u0211\x05\xb7[\x02\u0211\u0212\x05\x99L\x02\u0212\u0582\x03\x02\x02\x02\u0213\u0214\x05\x95J\x02\u0214\u0215\x05\xb9\\\x02\u0215\u0216\x05\xb3Y\x02\u0216\u0217\x05\xb3Y\x02\u0217\u0218\x05\x99L\x02\u0218\u0219\x05\xabU\x02\u0219\u021A\x05\xb7[\x02\u021A\u0582\x03\x02\x02\x02\u021B\u021C\x05\x97K\x02\u021C\u021D\x05\x91H\x02\u021D\u021E\x05\xb7[\x02\u021E\u021F\x05\x99L\x02\u021F\u0582\x03\x02\x02\x02\u0220\u0221\x05\x97K\x02\u0221\u0222\x05\x99L\x02\u0222\u0223\x05\x95J\x02\u0223\u0224\x05\xa1P\x02\u0224\u0225\x05\xa9T\x02\u0225\u0226\x05\x91H\x02\u0226\u0227\x05\xa7S\x02\u0227\u0582\x03\x02\x02\x02\u0228\u0229\x05\x97K\x02\u0229\u022A\x05\x99L\x02\u022A\u022B\x05\x95J\x02\u022B\u022C\x05\xa7S\x02\u022C\u022D\x05\x91H\x02\u022D\u022E\x05\xb3Y\x02\u022E\u022F\x05\x99L\x02\u022F\u0582\x03\x02\x02\x02\u0230\u0231\x05\x97K\x02\u0231\u0232\x05\x99L\x02\u0232\u0233\x05\x95J\x02\u0233\u0234\x05\xb3Y\x02\u0234\u0235\x05\x99L\x02\u0235\u0236\x05\xa9T\x02\u0236\u0237\x05\x99L\x02\u0237\u0238\x05\xabU\x02\u0238\u0239\x05\xb7[\x02\u0239\u0582\x03\x02\x02\x02\u023A\u023B\x05\x97K\x02\u023B\u023C\x05\x99L\x02\u023C\u023D\x05\x9bM\x02\u023D\u023E\x05\x91H\x02\u023E\u023F\x05\xb9\\\x02\u023F\u0240\x05\xa7S\x02\u0240\u0241\x05\xb7[\x02\u0241\u0582\x03\x02\x02\x02\u0242\u0243\x05\x97K\x02\u0243\u0244\x05\x99L\x02\u0244\u0245\x05\x9bM\x02\u0245\u0246\x05\x91H\x02\u0246\u0247\x05\xb9\\\x02\u0247\u0248\x05\xa7S\x02\u0248\u0249\x05\xb7[\x02\u0249\u024A\x05\xb5Z\x02\u024A\u0582\x03\x02\x02\x02\u024B\u024C\x05\x97K\x02\u024C\u024D\x05\x99L\x02\u024D\u024E\x05\x9bM\x02\u024E\u024F\x05\xa1P\x02\u024F\u0250\x05\xabU\x02\u0250\u0251\x05\x99L\x02\u0251\u0582\x03\x02\x02\x02\u0252\u0253\x05\x97K\x02\u0253\u0254\x05\x99L\x02\u0254\u0255\x05\xa7S\x02\u0255\u0256\x05\x99L\x02\u0256\u0257\x05\xb7[\x02\u0257\u0258\x05\x99L\x02\u0258\u0582\x03\x02\x02\x02\u0259\u025A\x05\x97K\x02\u025A\u025B\x05\x99L\x02\u025B\u025C\x05\xa7S\x02\u025C\u025D\x05\xa1P\x02\u025D\u025E\x05\xa9T\x02\u025E\u025F\x05\xa1P\x02\u025F\u0260\x05\xb7[\x02\u0260\u0261\x05\x99L\x02\u0261\u0262\x05\xb3Y\x02\u0262\u0582\x03\x02\x02\x02\u0263\u0264\x05\x97K\x02\u0264\u0265\x05\xa1P\x02\u0265\u0266\x05\x9bM\x02\u0266\u0267\x05\x9bM\x02\u0267\u0268\x05\x99L\x02\u0268\u0269\x05\xb3Y\x02\u0269\u026A\x05\x99L\x02\u026A\u026B\x05\xabU\x02\u026B\u026C\x05\x95J\x02\u026C\u026D\x05\x99L\x02\u026D\u0582\x03\x02\x02\x02\u026E\u026F\x05\x97K\x02\u026F\u0270\x05\xa1P\x02\u0270\u0271\x05\xb5Z\x02\u0271\u0272\x05\xb7[\x02\u0272\u0273\x05\xa1P\x02\u0273\u0274\x05\xabU\x02\u0274\u0275\x05\x95J\x02\u0275\u0276\x05\xb7[\x02\u0276\u0582\x03\x02\x02\x02\u0277\u0278\x05\x97K\x02\u0278\u0279\x05\xa1P\x02\u0279\u027A\x05\xbb]\x02\u027A\u027B\x05\xa1P\x02\u027B\u027C\x05\x97K\x02\u027C\u027D\x05\x99L\x02\u027D\u0582\x03\x02\x02\x02\u027E\u027F\x05\x97K\x02\u027F\u0280\x05\xadV\x02\u0280\u0582\x03\x02\x02\x02\u0281\u0282\x05\x97K\x02\u0282\u0283\x05\xadV\x02\u0283\u0284\x05\xb9\\\x02\u0284\u0285\x05\x93I\x02\u0285\u0286\x05\xa7S\x02\u0286\u0287\x05\x99L\x02\u0287\u0582\x03\x02\x02\x02\u0288\u0289\x05\x97K\x02\u0289\u028A\x05\xb3Y\x02\u028A\u028B\x05\xadV\x02\u028B\u028C\x05\xafW\x02\u028C\u0582\x03\x02\x02\x02\u028D\u028E\x05\x99L\x02\u028E\u028F\x05\xa7S\x02\u028F\u0290\x05\xb5Z\x02\u0290\u0291\x05\x99L\x02\u0291\u0582\x03\x02\x02\x02\u0292\u0293\x05\x99L\x02\u0293\u0294\x05\xabU\x02\u0294\u0295\x05\x95J\x02\u0295\u0296\x05\xadV\x02\u0296\u0297\x05\x97K\x02\u0297\u0298\x05\xa1P\x02\u0298\u0299\x05\xabU\x02\u0299\u029A\x05\x9dN\x02\u029A\u0582\x03\x02\x02\x02\u029B\u029C\x05\x99L\x02\u029C\u029D\x05\xabU\x02\u029D\u029E\x05\x97K\x02\u029E\u0582\x03\x02\x02\x02\u029F\u02A0\x05\x99L\x02\u02A0\u02A1\x05\xb1X\x02\u02A1\u02A2\x05\xb9\\\x02\u02A2\u02A3\x05\x91H\x02\u02A3\u02A4\x05\xa7S\x02\u02A4\u02A5\x05\xb5Z\x02\u02A5\u0582\x03\x02\x02\x02\u02A6\u02A7\x05\x99L\x02\u02A7\u02A8\x05\xb5Z\x02\u02A8\u02A9\x05\x95J\x02\u02A9\u02AA\x05\x91H\x02\u02AA\u02AB\x05\xafW\x02\u02AB\u02AC\x05\x99L\x02\u02AC\u0582\x03\x02\x02\x02\u02AD\u02AE\x05\x99L\x02\u02AE\u02AF\x05\xbf_\x02\u02AF\u02B0\x05\x95J\x02\u02B0\u02B1\x05\xa7S\x02\u02B1\u02B2\x05\xb9\\\x02\u02B2\u02B3\x05\xb5Z\x02\u02B3\u02B4\x05\xa1P\x02\u02B4\u02B5\x05\xbb]\x02\u02B5\u02B6\x05\x99L\x02\u02B6\u0582\x03\x02\x02\x02\u02B7\u02B8\x05\x99L\x02\u02B8\u02B9\x05\xbf_\x02\u02B9\u02BA\x05\x99L\x02\u02BA\u02BB\x05\x95J\x02\u02BB\u0582\x03\x02\x02\x02\u02BC\u02BD\x05\x99L\x02\u02BD\u02BE\x05\xbf_\x02\u02BE\u02BF\x05\x99L\x02\u02BF\u02C0\x05\x95J\x02\u02C0\u02C1\x05\xb9\\\x02\u02C1\u02C2\x05\xb7[\x02\u02C2\u02C3\x05\x99L\x02\u02C3\u0582\x03\x02\x02\x02\u02C4\u02C5\x05\x99L\x02\u02C5\u02C6\x05\xbf_\x02\u02C6\u02C7\x05\xa1P\x02\u02C7\u02C8\x05\xb5Z\x02\u02C8\u02C9\x05\xb7[\x02\u02C9\u02CA\x05\xb5Z\x02\u02CA\u0582\x03\x02\x02\x02\u02CB\u02CC\x05\x99L\x02\u02CC\u02CD\x05\xbf_\x02\u02CD\u02CE\x05\xafW\x02\u02CE\u02CF\x05\xa7S\x02\u02CF\u02D0\x05\x91H\x02\u02D0\u02D1\x05\xa1P\x02\u02D1\u02D2\x05\xabU\x02\u02D2\u0582\x03\x02\x02\x02\u02D3\u02D4\x05\x9bM\x02\u02D4\u02D5\x05\x91H\x02\u02D5\u02D6\x05\xa7S\x02\u02D6\u02D7\x05\xb5Z\x02\u02D7\u02D8\x05\x99L\x02\u02D8\u0582\x03\x02\x02\x02\u02D9\u02DA\x05\x9bM\x02\u02DA\u02DB\x05\x99L\x02\u02DB\u02DC\x05\xb7[\x02\u02DC\u02DD\x05\x95J\x02\u02DD\u02DE\x05\x9fO\x02\u02DE\u0582\x03\x02\x02\x02\u02DF\u02E0\x05\x9bM\x02\u02E0\u02E1\x05\xa1P\x02\u02E1\u02E2\x05\xa7S\x02\u02E2\u02E3\x05\x99L\x02\u02E3\u0582\x03\x02\x02\x02\u02E4\u02E5\x05\x9bM\x02\u02E5\u02E6\x05\xa1P\x02\u02E6\u02E7\x05\x99L\x02\u02E7\u02E8\x05\xa7S\x02\u02E8\u02E9\x05\x97K\x02\u02E9\u0582\x03\x02\x02\x02\u02EA\u02EB\x05\x9bM\x02\u02EB\u02EC\x05\xa1P\x02\u02EC\u02ED\x05\xb3Y\x02\u02ED\u02EE\x05\xb5Z\x02\u02EE\u02EF\x05\xb7[\x02\u02EF\u0582\x03\x02\x02\x02\u02F0\u02F1\x05\x9bM\x02\u02F1\u02F2\x05\xa7S\x02\u02F2\u02F3\x05\xadV\x02\u02F3\u02F4\x05\x91H\x02\u02F4\u02F5\x05\xb7[\x02\u02F5\u0582\x03\x02\x02\x02\u02F6\u02F7\x05\x9bM\x02\u02F7\u02F8\x05\xadV\x02\u02F8\u02F9\x05\xb3Y\x02\u02F9\u0582\x03\x02\x02\x02\u02FA\u02FB\x05\x9bM\x02\u02FB\u02FC\x05\xb9\\\x02\u02FC\u02FD\x05\xabU\x02\u02FD\u02FE\x05\x95J\x02\u02FE\u02FF\x05\xb7[\x02\u02FF\u0300\x05\xa1P\x02\u0300\u0301\x05\xadV\x02\u0301\u0302\x05\xabU\x02\u0302\u0582\x03\x02\x02\x02\u0303\u0304\x05\x9dN\x02\u0304\u0305\x05\xadV\x02\u0305\u0582\x03\x02\x02\x02\u0306\u0307\x05\x9dN\x02\u0307\u0308\x05\xadV\x02\u0308\u0309\x05\xb7[\x02\u0309\u030A\x05\xadV\x02\u030A\u0582\x03\x02\x02\x02\u030B\u030C\x05\x9dN\x02\u030C\u030D\x05\xb3Y\x02\u030D\u030E\x05\x91H\x02\u030E\u030F\x05\xabU\x02\u030F\u0310\x05\xb7[\x02\u0310\u0582\x03\x02\x02\x02\u0311\u0312\x05\x9dN\x02\u0312\u0313\x05\xb3Y\x02\u0313\u0314\x05\x99L\x02\u0314\u0315\x05\x91H\x02\u0315\u0316\x05\xb7[\x02\u0316\u0317\x05\x99L\x02\u0317\u0318\x05\xb3Y\x02\u0318\u0582\x03\x02\x02\x02\u0319\u031A\x05\x9dN\x02\u031A\u031B\x05\xb3Y\x02\u031B\u031C\x05\xadV\x02\u031C\u031D\x05\xb9\\\x02\u031D\u031E\x05\xafW\x02\u031E\u0582\x03\x02\x02\x02\u031F\u0320\x05\x9fO\x02\u0320\u0321\x05\x91H\x02\u0321\u0322\x05\xbb]\x02\u0322\u0323\x05\xa1P\x02\u0323\u0324\x05\xabU\x02\u0324\u0325\x05\x9dN\x02\u0325\u0582\x03\x02\x02\x02\u0326\u0327\x05\xa1P\x02\u0327\u0328\x05\x97K\x02\u0328\u0329\x05\x99L\x02\u0329\u032A\x05\xabU\x02\u032A\u032B\x05\xb7[\x02\u032B\u032C\x05\xa1P\x02\u032C\u032D\x05\x9bM\x02\u032D\u032E\x05\xa1P\x02\u032E\u032F\x05\x99L\x02\u032F\u0330\x05\x97K\x02\u0330\u0582\x03\x02\x02\x02\u0331\u0332\x05\xa1P\x02\u0332\u0333\x05\x9bM\x02\u0333\u0582\x03\x02\x02\x02\u0334\u0335\x05\xa1P\x02\u0335\u0336\x05\xa9T\x02\u0336\u0337\x05\xa9T\x02\u0337\u0338\x05\x99L\x02\u0338\u0339\x05\x97K\x02\u0339\u033A\x05\xa1P\x02\u033A\u033B\x05\x91H\x02\u033B\u033C\x05\xb7[\x02\u033C\u033D\x05\x99L\x02\u033D\u0582\x03\x02\x02\x02\u033E\u033F\x05\xa1P\x02\u033F\u0340\x05\xabU\x02\u0340\u0341\x05\x95J\x02\u0341\u0342\x05\xb3Y\x02\u0342\u0343\x05\x99L\x02\u0343\u0344\x05\xa9T\x02\u0344\u0345\x05\x99L\x02\u0345\u0346\x05\xabU\x02\u0346\u0347\x05\xb7[\x02\u0347\u0582\x03\x02\x02\x02\u0348\u0349\x05\xa1P\x02\u0349\u034A\x05\xabU\x02\u034A\u034B\x05\x97K\x02\u034B\u034C\x05\x99L\x02\u034C\u034D\x05\xbf_\x02\u034D\u0582\x03\x02\x02\x02\u034E\u034F\x05\xa1P\x02\u034F\u0350\x05\xabU\x02\u0350\u0351\x05\xa1P\x02\u0351\u0352\x05\xb7[\x02\u0352\u0353\x05\xa1P\x02\u0353\u0354\x05\x91H\x02\u0354\u0355\x05\xa7S\x02\u0355\u0582\x03\x02\x02\x02\u0356\u0357\x05\xa1P\x02\u0357\u0358\x05\xabU\x02\u0358\u0359\x05\xabU\x02\u0359\u035A\x05\x99L\x02\u035A\u035B\x05\xb3Y\x02\u035B\u0582\x03\x02\x02\x02\u035C\u035D\x05\xa1P\x02\u035D\u035E\x05\xabU\x02\u035E\u035F\x05\xadV\x02\u035F\u0360\x05\xb9\\\x02\u0360\u0361\x05\xb7[\x02\u0361\u0582\x03\x02\x02\x02\u0362\u0363\x05\xa1P\x02\u0363\u0364\x05\xabU\x02\u0364\u0365\x05\xafW\x02\u0365\u0366\x05\xb9\\\x02\u0366\u0367\x05\xb7[\x02\u0367\u0582\x03\x02\x02\x02\u0368\u0369\x05\xa1P\x02\u0369\u036A\x05\xabU\x02\u036A\u036B\x05\xb5Z\x02\u036B\u036C\x05\x99L\x02\u036C\u036D\x05\xb3Y\x02\u036D\u036E\x05\xb7[\x02\u036E\u0582\x03\x02\x02\x02\u036F\u0370\x05\xa1P\x02\u0370\u0371\x05\xabU\x02\u0371\u0372\x05\xb7[\x02\u0372\u0582\x03\x02\x02\x02\u0373\u0374\x05\xa1P\x02\u0374\u0375\x05\xabU\x02\u0375\u0376\x05\xb7[\x02\u0376\u0377\x05\x99L\x02\u0377\u0378\x05\x9dN\x02\u0378\u0379\x05\x99L\x02\u0379\u037A\x05\xb3Y\x02\u037A\u0582\x03\x02\x02\x02\u037B\u037C\x05\xa1P\x02\u037C\u037D\x05\xabU\x02\u037D\u037E\x05\xb7[\x02\u037E\u037F\x05\x99L\x02\u037F\u0380\x05\xb3Y\x02\u0380\u0381\x05\xb5Z\x02\u0381\u0382\x05\x99L\x02\u0382\u0383\x05\x95J\x02\u0383\u0384\x05\xb7[\x02\u0384\u0582\x03\x02\x02\x02\u0385\u0386\x05\xa1P\x02\u0386\u0387\x05\xabU\x02\u0387\u0388\x05\xb7[\x02\u0388\u0389\x05\x99L\x02\u0389\u038A\x05\xb3Y\x02\u038A\u038B\x05\xb5Z\x02\u038B\u038C\x05\x99L\x02\u038C\u038D\x05\x95J\x02\u038D\u038E\x05\xb7[\x02\u038E\u038F\x05\xa1P\x02\u038F\u0390\x05\xadV\x02\u0390\u0391\x05\xabU\x02\u0391\u0582\x03\x02\x02\x02\u0392\u0393\x05\xa1P\x02\u0393\u0394\x05\xabU\x02\u0394\u0395\x05\xb7[\x02\u0395\u0396\x05\xadV\x02\u0396\u0582\x03\x02\x02\x02\u0397\u0398\x05\xa1P\x02\u0398\u0399\x05\xb5Z\x02\u0399\u039A\x05\x99L\x02\u039A\u039B\x05\xa9T\x02\u039B\u039C\x05\xafW\x02\u039C\u039D\x05\xb7[\x02\u039D\u039E\x05\xc1`\x02\u039E\u0582\x03\x02\x02\x02\u039F\u03A0\x05\xa1P\x02\u03A0\u03A1\x05\xb5Z\x02\u03A1\u03A2\x05\xabU\x02\u03A2\u03A3\x05\xb9\\\x02\u03A3\u03A4\x05\xa7S\x02\u03A4\u03A5\x05\xa7S\x02\u03A5\u0582\x03\x02\x02\x02\u03A6\u03A7\x05\xa3Q\x02\u03A7\u03A8\x05\xadV\x02\u03A8\u03A9\x05\xa1P\x02\u03A9\u03AA\x05\xabU\x02\u03AA\u0582\x03\x02\x02\x02\u03AB\u03AC\x05\xa7S\x02\u03AC\u03AD\x05\x91H\x02\u03AD\u03AE\x05\xb5Z\x02\u03AE\u03AF\x05\xb7[\x02\u03AF\u0582\x03\x02\x02\x02\u03B0\u03B1\x05\xa7S\x02\u03B1\u03B2\x05\x99L\x02\u03B2\u03B3\x05\x9bM\x02\u03B3\u03B4\x05\xb7[\x02\u03B4\u0582\x03\x02\x02\x02\u03B5\u03B6\x05\xa7S\x02\u03B6\u03B7\x05\x99L\x02\u03B7\u03B8\x05\xb5Z\x02\u03B8\u03B9\x05\xb5Z\x02\u03B9\u0582\x03\x02\x02\x02\u03BA\u03BB\x05\xa7S\x02\u03BB\u03BC\x05\xa1P\x02\u03BC\u03BD\x05\xa5R\x02\u03BD\u03BE\x05\x99L\x02\u03BE\u0582\x03\x02\x02\x02\u03BF\u03C0\x05\xa7S\x02\u03C0\u03C1\x05\xa1P\x02\u03C1\u03C2\x05\xa9T\x02\u03C2\u03C3\x05\xa1P\x02\u03C3\u03C4\x05\xb7[\x02\u03C4\u0582\x03\x02\x02\x02\u03C5\u03C6\x05\xa7S\x02\u03C6\u03C7\x05\xadV\x02\u03C7\u03C8\x05\x95J\x02\u03C8\u03C9\x05\xa5R\x02\u03C9\u0582\x03\x02\x02\x02\u03CA\u03CB\x05\xa7S\x02\u03CB\u03CC\x05\xadV\x02\u03CC\u03CD\x05\xabU\x02\u03CD\u03CE\x05\x9dN\x02\u03CE\u0582\x03\x02\x02\x02\u03CF\u03D0\x05\xa9T\x02\u03D0\u03D1\x05\x91H\x02\u03D1\u03D2\x05\xbf_\x02\u03D2\u0582\x03\x02\x02\x02\u03D3\u03D4\x05\xa9T\x02\u03D4\u03D5\x05\xa1P\x02\u03D5\u03D6\x05\xabU\x02\u03D6\u0582\x03\x02\x02\x02\u03D7\u03D8\x05\xa9T\x02\u03D8\u03D9\x05\xa1P\x02\u03D9\u03DA\x05\xabU\x02\u03DA\u03DB\x05\xb9\\\x02\u03DB\u03DC\x05\xb5Z\x02\u03DC\u0582\x03\x02\x02\x02\u03DD\u03DE\x05\xa9T\x02\u03DE\u03DF\x05\xadV\x02\u03DF\u03E0\x05\x97K\x02\u03E0\u03E1\x05\x99L\x02\u03E1\u0582\x03\x02\x02\x02\u03E2\u03E3\x05\xa9T\x02\u03E3\u03E4\x05\xadV\x02\u03E4\u03E5\x05\x97K\x02\u03E5\u03E6\x05\xa1P\x02\u03E6\u03E7\x05\x9bM\x02\u03E7\u03E8\x05\xc1`\x02\u03E8\u0582\x03\x02\x02\x02\u03E9\u03EA\x05\xa9T\x02\u03EA\u03EB\x05\xadV\x02\u03EB\u03EC\x05\x97K\x02\u03EC\u03ED\x05\xb9\\\x02\u03ED\u03EE\x05\xa7S\x02\u03EE\u03EF\x05\xadV\x02\u03EF\u0582\x03\x02\x02\x02\u03F0\u03F1\x05\xa9T\x02\u03F1\u03F2\x05\xadV\x02\u03F2\u03F3\x05\xb3Y\x02\u03F3\u03F4\x05\x99L\x02\u03F4\u0582\x03\x02\x02\x02\u03F5\u03F6\x05\xa9T\x02\u03F6\u03F7\x05\xb9\\\x02\u03F7\u03F8\x05\xa7S\x02\u03F8\u03F9\x05\xb7[\x02\u03F9\u03FA\x05\xa1P\x02\u03FA\u03FB\x05\xafW\x02\u03FB\u03FC\x05\xa7S\x02\u03FC\u03FD\x05\xc1`\x02\u03FD\u0582\x03\x02\x02\x02\u03FE\u03FF\x05\xabU\x02\u03FF\u0400\x05\x99L\x02\u0400\u0401\x05\xbf_\x02\u0401\u0402\x05\xb7[\x02\u0402\u0582\x03\x02\x02\x02\u0403\u0404\x05\xabU\x02\u0404\u0405\x05\xadV\x02\u0405\u0406\x05\x91H\x02\u0406\u0407\x05\xb9\\\x02\u0407\u0408\x05\x97K\x02\u0408\u0409\x05\xa1P\x02\u0409\u040A\x05\xb7[\x02\u040A\u0582\x03\x02\x02\x02\u040B\u040C\x05\xabU\x02\u040C\u040D\x05\xadV\x02\u040D\u040E\x05\xb7[\x02\u040E\u040F\x05\xa1P\x02\u040F\u0410\x05\xabU\x02\u0410\u0582\x03\x02\x02\x02\u0411\u0412\x05\xabU\x02\u0412\u0413\x05\xadV\x02\u0413\u0414\x05\xbd^\x02\u0414\u0415\x05\x91H\x02\u0415\u0416\x05\xa1P\x02\u0416\u0417\x05\xb7[\x02\u0417\u0582\x03\x02\x02\x02\u0418\u0419\x05\xabU\x02\u0419\u041A\x05\xb9\\\x02\u041A\u041B\x05\xa9T\x02\u041B\u041C\x05\x93I\x02\u041C\u041D\x05\x99L\x02\u041D\u041E\x05\xb3Y\x02\u041E\u0582\x03\x02\x02\x02\u041F\u0420\x05\xadV\x02\u0420\u0421\x05\x93I\x02\u0421\u0422\x05\xa3Q\x02\u0422\u0423\x05\x99L\x02\u0423\u0424\x05\x95J\x02\u0424\u0425\x05\xb7[\x02\u0425\u0582\x03\x02\x02\x02\u0426\u0427\x05\xadV\x02\u0427\u0428\x05\x9bM\x02\u0428\u0582\x03\x02\x02\x02\u0429\u042A\x05\xadV\x02\u042A\u042B\x05\xafW\x02\u042B\u042C\x05\xb7[\x02\u042C\u042D\x05\xa1P\x02\u042D\u042E\x05\xadV\x02\u042E\u042F\x05\xabU\x02\u042F\u0582\x03\x02\x02\x02\u0430\u0431\x05\xadV\x02\u0431\u0432\x05\xb9\\\x02\u0432\u0433\x05\xb7[\x02\u0433\u0434\x05\x99L\x02\u0434\u0435\x05\xb3Y\x02\u0435\u0582\x03\x02\x02\x02\u0436\u0437\x05\xadV\x02\u0437\u0438\x05\xb9\\\x02\u0438\u0439\x05\xb7[\x02\u0439\u043A\x05\xafW\x02\u043A\u043B\x05\xb9\\\x02\u043B\u043C\x05\xb7[\x02\u043C\u0582\x03\x02\x02\x02\u043D\u043E\x05\xafW\x02\u043E\u043F\x05\xadV\x02\u043F\u0440\x05\xbd^\x02\u0440\u0441\x05\x99L\x02\u0441\u0442\x05";
    }
    static{
        this._serializedATNSegment2 = '\xb3Y\x02\u0442\u0582\x03\x02\x02\x02\u0443\u0444\x05\xafW\x02\u0444\u0445\x05\xb3Y\x02\u0445\u0446\x05\x99L\x02\u0446\u0447\x05\xbb]\x02\u0447\u0448\x05\xa1P\x02\u0448\u0449\x05\xadV\x02\u0449\u044A\x05\xb9\\\x02\u044A\u044B\x05\xb5Z\x02\u044B\u0582\x03\x02\x02\x02\u044C\u044D\x05\xafW\x02\u044D\u044E\x05\xb3Y\x02\u044E\u044F\x05\xa1P\x02\u044F\u0450\x05\xadV\x02\u0450\u0451\x05\xb3Y\x02\u0451\u0582\x03\x02\x02\x02\u0452\u0453\x05\xafW\x02\u0453\u0454\x05\xb3Y\x02\u0454\u0455\x05\xa1P\x02\u0455\u0456\x05\xbb]\x02\u0456\u0457\x05\xa1P\x02\u0457\u0458\x05\xa7S\x02\u0458\u0459\x05\x99L\x02\u0459\u045A\x05\x9dN\x02\u045A\u045B\x05\x99L\x02\u045B\u045C\x05\xb5Z\x02\u045C\u0582\x03\x02\x02\x02\u045D\u045E\x05\xafW\x02\u045E\u045F\x05\xb9\\\x02\u045F\u0460\x05\x93I\x02\u0460\u0461\x05\xa7S\x02\u0461\u0462\x05\xa1P\x02\u0462\u0463\x05\x95J\x02\u0463\u0582\x03\x02\x02\x02\u0464\u0465\x05\xb3Y\x02\u0465\u0466\x05\x91H\x02\u0466\u0467\x05\xa1P\x02\u0467\u0468\x05\xb5Z\x02\u0468\u0469\x05\x99L\x02\u0469\u0582\x03\x02\x02\x02\u046A\u046B\x05\xb3Y\x02\u046B\u046C\x05\x91H\x02\u046C\u046D\x05\xbd^\x02\u046D\u0582\x03\x02\x02\x02\u046E\u046F\x05\xb3Y\x02\u046F\u0470\x05\x99L\x02\u0470\u0471\x05\xa9T\x02\u0471\u0472\x05\x91H\x02\u0472\u0473\x05\xa1P\x02\u0473\u0474\x05\xabU\x02\u0474\u0475\x05\x97K\x02\u0475\u0476\x05\x99L\x02\u0476\u0477\x05\xb3Y\x02\u0477\u0582\x03\x02\x02\x02\u0478\u0479\x05\xb3Y\x02\u0479\u047A\x05\x99L\x02\u047A\u047B\x05\xabU\x02\u047B\u047C\x05\x91H\x02\u047C\u047D\x05\xa9T\x02\u047D\u047E\x05\x99L\x02\u047E\u0582\x03\x02\x02\x02\u047F\u0480\x05\xb3Y\x02\u0480\u0481\x05\x99L\x02\u0481\u0482\x05\xb5Z\x02\u0482\u0483\x05\xadV\x02\u0483\u0484\x05\xb9\\\x02\u0484\u0485\x05\xb3Y\x02\u0485\u0486\x05\x95J\x02\u0486\u0487\x05\x99L\x02\u0487\u0582\x03\x02\x02\x02\u0488\u0489\x05\xb3Y\x02\u0489\u048A\x05\x99L\x02\u048A\u048B\x05\xb7[\x02\u048B\u048C\x05\xb9\\\x02\u048C\u048D\x05\xb3Y\x02\u048D\u048E\x05\xabU\x02\u048E\u0582\x03\x02\x02\x02\u048F\u0490\x05\xb3Y\x02\u0490\u0491\x05\x99L\x02\u0491\u0492\x05\xb7[\x02\u0492\u0493\x05\xb9\\\x02\u0493\u0494\x05\xb3Y\x02\u0494\u0495\x05\xabU\x02\u0495\u0496\x05\xb5Z\x02\u0496\u0582\x03\x02\x02\x02\u0497\u0498\x05\xb3Y\x02\u0498\u0499\x05\x99L\x02\u0499\u049A\x05\xbb]\x02\u049A\u049B\x05\xadV\x02\u049B\u049C\x05\xa5R\x02\u049C\u049D\x05\x99L\x02\u049D\u0582\x03\x02\x02\x02\u049E\u049F\x05\xb3Y\x02\u049F\u04A0\x05\xa1P\x02\u04A0\u04A1\x05\x9dN\x02\u04A1\u04A2\x05\x9fO\x02\u04A2\u04A3\x05\xb7[\x02\u04A3\u0582\x03\x02\x02\x02\u04A4\u04A5\x05\xb3Y\x02\u04A5\u04A6\x05\xadV\x02\u04A6\u04A7\x05\xbd^\x02\u04A7\u0582\x03\x02\x02\x02\u04A8\u04A9\x05\xb3Y\x02\u04A9\u04AA\x05\xadV\x02\u04AA\u04AB\x05\xbd^\x02\u04AB\u04AC\x05\xa1P\x02\u04AC\u04AD\x05\x97K\x02\u04AD\u0582\x03\x02\x02\x02\u04AE\u04AF\x05\xb3Y\x02\u04AF\u04B0\x05\xadV\x02\u04B0\u04B1\x05\xbd^\x02\u04B1\u04B2\x05\xabU\x02\u04B2\u04B3\x05\xb9\\\x02\u04B3\u04B4\x05\xa9T\x02\u04B4\u0582\x03\x02\x02\x02\u04B5\u04B6\x05\xb3Y\x02\u04B6\u04B7\x05\xadV\x02\u04B7\u04B8\x05\xbd^\x02\u04B8\u04B9\x05\xb5Z\x02\u04B9\u0582\x03\x02\x02\x02\u04BA\u04BB\x05\xb5Z\x02\u04BB\u04BC\x05\x99L\x02\u04BC\u04BD\x05\xa7S\x02\u04BD\u04BE\x05\x99L\x02\u04BE\u04BF\x05\x95J\x02\u04BF\u04C0\x05\xb7[\x02\u04C0\u0582\x03\x02\x02\x02\u04C1\u04C2\x05\xb5Z\x02\u04C2\u04C3\x05\x99L\x02\u04C3\u04C4\x05\xb5Z\x02\u04C4\u04C5\x05\xb5Z\x02\u04C5\u04C6\x05\xa1P\x02\u04C6\u04C7\x05\xadV\x02\u04C7\u04C8\x05\xabU\x02\u04C8\u0582\x03\x02\x02\x02\u04C9\u04CA\x05\xb5Z\x02\u04CA\u04CB\x05\x99L\x02\u04CB\u04CC\x05\xb7[\x02\u04CC\u0582\x03\x02\x02\x02\u04CD\u04CE\x05\xb5Z\x02\u04CE\u04CF\x05\x9fO\x02\u04CF\u04D0\x05\x91H\x02\u04D0\u04D1\x05\xb3Y\x02\u04D1\u04D2\x05\x99L\x02\u04D2\u0582\x03\x02\x02\x02\u04D3\u04D4\x05\xb5Z\x02\u04D4\u04D5\x05\xa1P\x02\u04D5\u04D6\x05\xc3a\x02\u04D6\u04D7\x05\x99L\x02\u04D7\u0582\x03\x02\x02\x02\u04D8\u04D9\x05\xb5Z\x02\u04D9\u04DA\x05\xb1X\x02\u04DA\u04DB\x05\xb3Y\x02\u04DB\u04DC\x05\xb7[\x02\u04DC\u0582\x03\x02\x02\x02\u04DD\u04DE\x05\xb5Z\x02\u04DE\u04DF\x05\xb7[\x02\u04DF\u04E0\x05\x91H\x02\u04E0\u04E1\x05\xb3Y\x02\u04E1\u04E2\x05\xb7[\x02\u04E2\u0582\x03\x02\x02\x02\u04E3\u04E4\x05\xb5Z\x02\u04E4\u04E5\x05\xb7[\x02\u04E5\u04E6\x05\xb3Y\x02\u04E6\u04E7\x05\xa1P\x02\u04E7\u04E8\x05\x95J\x02\u04E8\u04E9\x05\xb7[\x02\u04E9\u0582\x03\x02\x02\x02\u04EA\u04EB\x05\xb5Z\x02\u04EB\u04EC\x05\xb7[\x02\u04EC\u04ED\x05\xb3Y\x02\u04ED\u04EE\x05\xa1P\x02\u04EE\u04EF\x05\xabU\x02\u04EF\u04F0\x05\x9dN\x02\u04F0\u0582\x03\x02\x02\x02\u04F1\u04F2\x05\xb5Z\x02\u04F2\u04F3\x05\xb9\\\x02\u04F3\u04F4\x05\x93I\x02\u04F4\u04F5\x05\xb7[\x02\u04F5\u04F6\x05\xb3Y\x02\u04F6\u04F7\x05\x91H\x02\u04F7\u04F8\x05\x95J\x02\u04F8\u04F9\x05\xb7[\x02\u04F9\u0582\x03\x02\x02\x02\u04FA\u04FB\x05\xb5Z\x02\u04FB\u04FC\x05\xb9\\\x02\u04FC\u04FD\x05\xa9T\x02\u04FD\u0582\x03\x02\x02\x02\u04FE\u04FF\x05\xb5Z\x02\u04FF\u0500\x05\xc1`\x02\u0500\u0501\x05\xabU\x02\u0501\u0502\x05\xadV\x02\u0502\u0503\x05\xabU\x02\u0503\u0504\x05\xc1`\x02\u0504\u0505\x05\xa9T\x02\u0505\u0582\x03\x02\x02\x02\u0506\u0507\x05\xb7[\x02\u0507\u0508\x05\x91H\x02\u0508\u0509\x05\x93I\x02\u0509\u050A\x05\xa7S\x02\u050A\u050B\x05\x99L\x02\u050B\u0582\x03\x02\x02\x02\u050C\u050D\x05\xb7[\x02\u050D\u050E\x05\x9fO\x02\u050E\u050F\x05\x99L\x02\u050F\u0510\x05\xabU\x02\u0510\u0582\x03\x02\x02\x02\u0511\u0512\x05\xb7[\x02\u0512\u0513\x05\xb3Y\x02\u0513\u0514\x05\x91H\x02\u0514\u0515\x05\xabU\x02\u0515\u0516\x05\xb5Z\x02\u0516\u0582\x03\x02\x02\x02\u0517\u0518\x05\xb7[\x02\u0518\u0519\x05\xb3Y\x02\u0519\u051A\x05\x91H\x02\u051A\u051B\x05\xabU\x02\u051B\u051C\x05\xb5Z\x02\u051C\u051D\x05\x91H\x02\u051D\u051E\x05\x95J\x02\u051E\u051F\x05\xb7[\x02\u051F\u0520\x05\xa1P\x02\u0520\u0521\x05\xadV\x02\u0521\u0522\x05\xabU\x02\u0522\u0582\x03\x02\x02\x02\u0523\u0524\x05\xb7[\x02\u0524\u0525\x05\xb3Y\x02\u0525\u0526\x05\xa1P\x02\u0526\u0527\x05\x9dN\x02\u0527\u0528\x05\x9dN\x02\u0528\u0529\x05\x99L\x02\u0529\u052A\x05\xb3Y\x02\u052A\u0582\x03\x02\x02\x02\u052B\u052C\x05\xb7[\x02\u052C\u052D\x05\xb3Y\x02\u052D\u052E\x05\xb9\\\x02\u052E\u052F\x05\x99L\x02\u052F\u0582\x03\x02\x02\x02\u0530\u0531\x05\xb9\\\x02\u0531\u0532\x05\xa1P\x02\u0532\u0533\x05\x97K\x02\u0533\u0582\x03\x02\x02\x02\u0534\u0535\x05\xb9\\\x02\u0535\u0536\x05\xabU\x02\u0536\u0537\x05\xa1P\x02\u0537\u0538\x05\xadV\x02\u0538\u0539\x05\xabU\x02\u0539\u0582\x03\x02\x02\x02\u053A\u053B\x05\xb9\\\x02\u053B\u053C\x05\xabU\x02\u053C\u053D\x05\xa1P\x02\u053D\u053E\x05\xb1X\x02\u053E\u053F\x05\xb9\\\x02\u053F\u0540\x05\x99L\x02\u0540\u0582\x03\x02\x02\x02\u0541\u0542\x05\xb9\\\x02\u0542\u0543\x05\xafW\x02\u0543\u0544\x05\x97K\x02\u0544\u0545\x05\x91H\x02\u0545\u0546\x05\xb7[\x02\u0546\u0547\x05\x99L\x02\u0547\u0582\x03\x02\x02\x02\u0548\u0549\x05\xb9\\\x02\u0549\u054A\x05\xb5Z\x02\u054A\u054B\x05\x99L\x02\u054B\u054C\x05\xb3Y\x02\u054C\u0582\x03\x02\x02\x02\u054D\u054E\x05\xbb]\x02\u054E\u054F\x05\x91H\x02\u054F\u0550\x05\xa7S\x02\u0550\u0551\x05\xa1P\x02\u0551\u0552\x05\x97K\x02\u0552\u0553\x05\x91H\x02\u0553\u0554\x05\xb7[\x02\u0554\u0555\x05\x99L\x02\u0555\u0582\x03\x02\x02\x02\u0556\u0557\x05\xbb]\x02\u0557\u0558\x05\x91H\x02\u0558\u0559\x05\xa7S\x02\u0559\u055A\x05\xb9\\\x02\u055A\u055B\x05\x99L\x02\u055B\u055C\x05\xb5Z\x02\u055C\u0582\x03\x02\x02\x02\u055D\u055E\x05\xbb]\x02\u055E\u055F\x05\xa1P\x02\u055F\u0560\x05\x99L\x02\u0560\u0561\x05\xbd^\x02\u0561\u0582\x03\x02\x02\x02\u0562\u0563\x05\xbd^\x02\u0563\u0564\x05\x9fO\x02\u0564\u0565\x05\x99L\x02\u0565\u0566\x05\xabU\x02\u0566\u0582\x03\x02\x02\x02\u0567\u0568\x05\xbd^\x02\u0568\u0569\x05\x9fO\x02\u0569\u056A\x05\x99L\x02\u056A\u056B\x05\xabU\x02\u056B\u056C\x05\x99L\x02\u056C\u056D\x05\xbb]\x02\u056D\u056E\x05\x99L\x02\u056E\u056F\x05\xb3Y\x02\u056F\u0582\x03\x02\x02\x02\u0570\u0571\x05\xbd^\x02\u0571\u0572\x05\x9fO\x02\u0572\u0573\x05\x99L\x02\u0573\u0574\x05\xb3Y\x02\u0574\u0575\x05\x99L\x02\u0575\u0582\x03\x02\x02\x02\u0576\u0577\x05\xbd^\x02\u0577\u0578\x05\x9fO\x02\u0578\u0579\x05\xa1P\x02\u0579\u057A\x05\xa7S\x02\u057A\u057B\x05\x99L\x02\u057B\u0582\x03\x02\x02\x02\u057C\u057D\x05\xbd^\x02\u057D\u057E\x05\xa1P\x02\u057E\u057F\x05\xb7[\x02\u057F\u0580\x05\x9fO\x02\u0580\u0582\x03\x02\x02\x02\u0581\u0160\x03\x02\x02\x02\u0581\u0166\x03\x02\x02\x02\u0581\u016D\x03\x02\x02\x02\u0581\u0171\x03\x02\x02\x02\u0581\u0177\x03\x02\x02\x02\u0581\u017D\x03\x02\x02\x02\u0581\u0181\x03\x02\x02\x02\u0581\u0184\x03\x02\x02\x02\u0581\u018A\x03\x02\x02\x02\u0581\u018E\x03\x02\x02\x02\u0581\u0194\x03\x02\x02\x02\u0581\u019C\x03\x02\x02\x02\u0581\u01A4\x03\x02\x02\x02\u0581\u01AA\x03\x02\x02\x02\u0581\u01AF\x03\x02\x02\x02\u0581\u01B5\x03\x02\x02\x02\u0581\u01BA\x03\x02\x02\x02\u0581\u01C4\x03\x02\x02\x02\u0581\u01CA\x03\x02\x02\x02\u0581\u01D5\x03\x02\x02\x02\u0581\u01DD\x03\x02\x02\x02\u0581\u01E7\x03\x02\x02\x02\u0581\u01EE\x03\x02\x02\x02\u0581\u01F5\x03\x02\x02\x02\u0581\u01FD\x03\x02\x02\x02\u0581\u0206\x03\x02\x02\x02\u0581\u020C\x03\x02\x02\x02\u0581\u0213\x03\x02\x02\x02\u0581\u021B\x03\x02\x02\x02\u0581\u0220\x03\x02\x02\x02\u0581\u0228\x03\x02\x02\x02\u0581\u0230\x03\x02\x02\x02\u0581\u023A\x03\x02\x02\x02\u0581\u0242\x03\x02\x02\x02\u0581\u024B\x03\x02\x02\x02\u0581\u0252\x03\x02\x02\x02\u0581\u0259\x03\x02\x02\x02\u0581\u0263\x03\x02\x02\x02\u0581\u026E\x03\x02\x02\x02\u0581\u0277\x03\x02\x02\x02\u0581\u027E\x03\x02\x02\x02\u0581\u0281\x03\x02\x02\x02\u0581\u0288\x03\x02\x02\x02\u0581\u028D\x03\x02\x02\x02\u0581\u0292\x03\x02\x02\x02\u0581\u029B\x03\x02\x02\x02\u0581\u029F\x03\x02\x02\x02\u0581\u02A6\x03\x02\x02\x02\u0581\u02AD\x03\x02\x02\x02\u0581\u02B7\x03\x02\x02\x02\u0581\u02BC\x03\x02\x02\x02\u0581\u02C4\x03\x02\x02\x02\u0581\u02CB\x03\x02\x02\x02\u0581\u02D3\x03\x02\x02\x02\u0581\u02D9\x03\x02\x02\x02\u0581\u02DF\x03\x02\x02\x02\u0581\u02E4\x03\x02\x02\x02\u0581\u02EA\x03\x02\x02\x02\u0581\u02F0\x03\x02\x02\x02\u0581\u02F6\x03\x02\x02\x02\u0581\u02FA\x03\x02\x02\x02\u0581\u0303\x03\x02\x02\x02\u0581\u0306\x03\x02\x02\x02\u0581\u030B\x03\x02\x02\x02\u0581\u0311\x03\x02\x02\x02\u0581\u0319\x03\x02\x02\x02\u0581\u031F\x03\x02\x02\x02\u0581\u0326\x03\x02\x02\x02\u0581\u0331\x03\x02\x02\x02\u0581\u0334\x03\x02\x02\x02\u0581\u033E\x03\x02\x02\x02\u0581\u0348\x03\x02\x02\x02\u0581\u034E\x03\x02\x02\x02\u0581\u0356\x03\x02\x02\x02\u0581\u035C\x03\x02\x02\x02\u0581\u0362\x03\x02\x02\x02\u0581\u0368\x03\x02\x02\x02\u0581\u036F\x03\x02\x02\x02\u0581\u0373\x03\x02\x02\x02\u0581\u037B\x03\x02\x02\x02\u0581\u0385\x03\x02\x02\x02\u0581\u0392\x03\x02\x02\x02\u0581\u0397\x03\x02\x02\x02\u0581\u039F\x03\x02\x02\x02\u0581\u03A6\x03\x02\x02\x02\u0581\u03AB\x03\x02\x02\x02\u0581\u03B0\x03\x02\x02\x02\u0581\u03B5\x03\x02\x02\x02\u0581\u03BA\x03\x02\x02\x02\u0581\u03BF\x03\x02\x02\x02\u0581\u03C5\x03\x02\x02\x02\u0581\u03CA\x03\x02\x02\x02\u0581\u03CF\x03\x02\x02\x02\u0581\u03D3\x03\x02\x02\x02\u0581\u03D7\x03\x02\x02\x02\u0581\u03DD\x03\x02\x02\x02\u0581\u03E2\x03\x02\x02\x02\u0581\u03E9\x03\x02\x02\x02\u0581\u03F0\x03\x02\x02\x02\u0581\u03F5\x03\x02\x02\x02\u0581\u03FE\x03\x02\x02\x02\u0581\u0403\x03\x02\x02\x02\u0581\u040B\x03\x02\x02\x02\u0581\u0411\x03\x02\x02\x02\u0581\u0418\x03\x02\x02\x02\u0581\u041F\x03\x02\x02\x02\u0581\u0426\x03\x02\x02\x02\u0581\u0429\x03\x02\x02\x02\u0581\u0430\x03\x02\x02\x02\u0581\u0436\x03\x02\x02\x02\u0581\u043D\x03\x02\x02\x02\u0581\u0443\x03\x02\x02\x02\u0581\u044C\x03\x02\x02\x02\u0581\u0452\x03\x02\x02\x02\u0581\u045D\x03\x02\x02\x02\u0581\u0464\x03\x02\x02\x02\u0581\u046A\x03\x02\x02\x02\u0581\u046E\x03\x02\x02\x02\u0581\u0478\x03\x02\x02\x02\u0581\u047F\x03\x02\x02\x02\u0581\u0488\x03\x02\x02\x02\u0581\u048F\x03\x02\x02\x02\u0581\u0497\x03\x02\x02\x02\u0581\u049E\x03\x02\x02\x02\u0581\u04A4\x03\x02\x02\x02\u0581\u04A8\x03\x02\x02\x02\u0581\u04AE\x03\x02\x02\x02\u0581\u04B5\x03\x02\x02\x02\u0581\u04BA\x03\x02\x02\x02\u0581\u04C1\x03\x02\x02\x02\u0581\u04C9\x03\x02\x02\x02\u0581\u04CD\x03\x02\x02\x02\u0581\u04D3\x03\x02\x02\x02\u0581\u04D8\x03\x02\x02\x02\u0581\u04DD\x03\x02\x02\x02\u0581\u04E3\x03\x02\x02\x02\u0581\u04EA\x03\x02\x02\x02\u0581\u04F1\x03\x02\x02\x02\u0581\u04FA\x03\x02\x02\x02\u0581\u04FE\x03\x02\x02\x02\u0581\u0506\x03\x02\x02\x02\u0581\u050C\x03\x02\x02\x02\u0581\u0511\x03\x02\x02\x02\u0581\u0517\x03\x02\x02\x02\u0581\u0523\x03\x02\x02\x02\u0581\u052B\x03\x02\x02\x02\u0581\u0530\x03\x02\x02\x02\u0581\u0534\x03\x02\x02\x02\u0581\u053A\x03\x02\x02\x02\u0581\u0541\x03\x02\x02\x02\u0581\u0548\x03\x02\x02\x02\u0581\u054D\x03\x02\x02\x02\u0581\u0556\x03\x02\x02\x02\u0581\u055D\x03\x02\x02\x02\u0581\u0562\x03\x02\x02\x02\u0581\u0567\x03\x02\x02\x02\u0581\u0570\x03\x02\x02\x02\u0581\u0576\x03\x02\x02\x02\u0581\u057C\x03\x02\x02\x02\u0582P\x03\x02\x02\x02\u0583\u0586\x05\x85B\x02\u0584\u0586\x05i4\x02\u0585\u0583\x03\x02\x02\x02\u0585\u0584\x03\x02\x02\x02\u0586\u0587\x03\x02\x02\x02\u0587\u0585\x03\x02\x02\x02\u0587\u0588\x03\x02\x02\x02\u0588R\x03\x02\x02\x02\u0589\u058B\x05\x8bE\x02\u058A\u0589\x03\x02\x02\x02\u058B\u058C\x03\x02\x02\x02\u058C\u058A\x03\x02\x02\x02\u058C\u058D\x03\x02\x02\x02\u058D\u058E\x03\x02\x02\x02\u058E\u058F\b)\x05\x02\u058FT\x03\x02\x02\x02\u0590\u0591\x05o7\x02\u0591V\x03\x02\x02\x02\u0592\u0593\v\x02\x02\x02\u0593X\x03\x02\x02\x02\u0594\u0595\x05q8\x02\u0595\u0596\x03\x02\x02\x02\u0596\u0597\b,\x06\x02\u0597Z\x03\x02\x02\x02\u0598\u059B\x05\x85B\x02\u0599\u059B\x05k5\x02\u059A\u0598\x03\x02\x02\x02\u059A\u0599\x03\x02\x02\x02\u059B\u059C\x03\x02\x02\x02\u059C\u059D\b-\x02\x02\u059D\\\x03\x02\x02\x02\u059E\u059F\x07\x02\x02\x03\u059F\u05A0\x03\x02\x02\x02\u05A0\u05A1\b.\x06\x02\u05A1^\x03\x02\x02\x02\u05A2\u05A3\v\x02\x02\x02\u05A3\u05A4\x03\x02\x02\x02\u05A4\u05A5\b/\x06\x02\u05A5`\x03\x02\x02\x02\u05A6\u05A7\x05s9\x02\u05A7\u05A8\x03\x02\x02\x02\u05A8\u05A9\b0\x06\x02\u05A9b\x03\x02\x02\x02\u05AA\u05AD\x05\x85B\x02\u05AB\u05AD\x05m6\x02\u05AC\u05AA\x03\x02\x02\x02\u05AC\u05AB\x03\x02\x02\x02\u05AD\u05AE\x03\x02\x02\x02\u05AE\u05AF\b1\x02\x02\u05AFd\x03\x02\x02\x02\u05B0\u05B1\x07\x02\x02\x03\u05B1\u05B2\x03\x02\x02\x02\u05B2\u05B3\b2\x06\x02\u05B3f\x03\x02\x02\x02\u05B4\u05B5\v\x02\x02\x02\u05B5\u05B6\x03\x02\x02\x02\u05B6\u05B7\b3\x06\x02\u05B7h\x03\x02\x02\x02\u05B8\u05B9\n\x02\x02\x02\u05B9j\x03\x02\x02\x02\u05BA\u05BB\n\x03\x02\x02\u05BBl\x03\x02\x02\x02\u05BC\u05BD\n\x04\x02\x02\u05BDn\x03\x02\x02\x02\u05BE\u05BF	\x05\x02\x02\u05BFp\x03\x02\x02\x02\u05C0\u05C1\x07$\x02\x02\u05C1r\x03\x02\x02\x02\u05C2\u05C3\x07)\x02\x02\u05C3t\x03\x02\x02\x02\u05C4\u05C5\x07^\x02\x02\u05C5v\x03\x02\x02\x02\u05C6\u05C7\x07\x0f\x02\x02\u05C7x\x03\x02\x02\x02\u05C8\u05C9\x07\f\x02\x02\u05C9z\x03\x02\x02\x02\u05CA\u05CB\x07"\x02\x02\u05CB|\x03\x02\x02\x02\u05CC\u05CD\x07(\x02\x02\u05CD~\x03\x02\x02\x02\u05CE\u05CF\x07(\x02\x02\u05CF\u05D0\x07(\x02\x02\u05D0\x80\x03\x02\x02\x02\u05D1\u05D2\x07~\x02\x02\u05D2\x82\x03\x02\x02\x02\u05D3\u05D4\x07~\x02\x02\u05D4\u05D5\x07~\x02\x02\u05D5\x84\x03\x02\x02\x02\u05D6\u05E2\x05u:\x02\u05D7\u05E3	\x06\x02\x02\u05D8\u05E3\x05q8\x02\u05D9\u05E3\x05s9\x02\u05DA\u05E3\x05u:\x02\u05DB\u05E3\x05{=\x02\u05DC\u05DD\x07w\x02\x02\u05DD\u05DE\x05\x89D\x02\u05DE\u05DF\x05\x89D\x02\u05DF\u05E0\x05\x89D\x02\u05E0\u05E1\x05\x89D\x02\u05E1\u05E3\x03\x02\x02\x02\u05E2\u05D7\x03\x02\x02\x02\u05E2\u05D8\x03\x02\x02\x02\u05E2\u05D9\x03\x02\x02\x02\u05E2\u05DA\x03\x02\x02\x02\u05E2\u05DB\x03\x02\x02\x02\u05E2\u05DC\x03\x02\x02\x02\u05E3\x86\x03\x02\x02\x02\u05E4\u05E7\x05w;\x02\u05E5\u05E7\x05y<\x02\u05E6\u05E4\x03\x02\x02\x02\u05E6\u05E5\x03\x02\x02\x02\u05E7\x88\x03\x02\x02\x02\u05E8\u05F0\x05\x8fG\x02\u05E9\u05F0\x05\x91H\x02\u05EA\u05F0\x05\x93I\x02\u05EB\u05F0\x05\x95J\x02\u05EC\u05F0\x05\x97K\x02\u05ED\u05F0\x05\x99L\x02\u05EE\u05F0\x05\x9bM\x02\u05EF\u05E8\x03\x02\x02\x02\u05EF\u05E9\x03\x02\x02\x02\u05EF\u05EA\x03\x02\x02\x02\u05EF\u05EB\x03\x02\x02\x02\u05EF\u05EC\x03\x02\x02\x02\u05EF\u05ED\x03\x02\x02\x02\u05EF\u05EE\x03\x02\x02\x02\u05F0\x8a\x03\x02\x02\x02\u05F1\u05F5\x05{=\x02\u05F2\u05F5\x07\v\x02\x02\u05F3\u05F5\x05\x87C\x02\u05F4\u05F1\x03\x02\x02\x02\u05F4\u05F2\x03\x02\x02\x02\u05F4\u05F3\x03\x02\x02\x02\u05F5\x8c\x03\x02\x02\x02\u05F6\u05F7\x07/\x02\x02\u05F7\x8e\x03\x02\x02\x02\u05F8\u05F9	\x07\x02\x02\u05F9\x90\x03\x02\x02\x02\u05FA\u05FB	\b\x02\x02\u05FB\x92\x03\x02\x02\x02\u05FC\u05FD		\x02\x02\u05FD\x94\x03\x02\x02\x02\u05FE\u05FF	\n\x02\x02\u05FF\x96\x03\x02\x02\x02\u0600\u0601	\v\x02\x02\u0601\x98\x03\x02\x02\x02\u0602\u0603	\f\x02\x02\u0603\x9a\x03\x02\x02\x02\u0604\u0605	\r\x02\x02\u0605\x9c\x03\x02\x02\x02\u0606\u0607	\x0e\x02\x02\u0607\x9e\x03\x02\x02\x02\u0608\u0609	\x0f\x02\x02\u0609\xa0\x03\x02\x02\x02\u060A\u060B	\x10\x02\x02\u060B\xa2\x03\x02\x02\x02\u060C\u060D	\x11\x02\x02\u060D\xa4\x03\x02\x02\x02\u060E\u060F	\x12\x02\x02\u060F\xa6\x03\x02\x02\x02\u0610\u0611	\x13\x02\x02\u0611\xa8\x03\x02\x02\x02\u0612\u0613	\x14\x02\x02\u0613\xaa\x03\x02\x02\x02\u0614\u0615	\x15\x02\x02\u0615\xac\x03\x02\x02\x02\u0616\u0617	\x16\x02\x02\u0617\xae\x03\x02\x02\x02\u0618\u0619	\x17\x02\x02\u0619\xb0\x03\x02\x02\x02\u061A\u061B	\x18\x02\x02\u061B\xb2\x03\x02\x02\x02\u061C\u061D	\x19\x02\x02\u061D\xb4\x03\x02\x02\x02\u061E\u061F	\x1a\x02\x02\u061F\xb6\x03\x02\x02\x02\u0620\u0621	\x1b\x02\x02\u0621\xb8\x03\x02\x02\x02\u0622\u0623	\x1c\x02\x02\u0623\xba\x03\x02\x02\x02\u0624\u0625	\x1d\x02\x02\u0625\xbc\x03\x02\x02\x02\u0626\u0627	\x1e\x02\x02\u0627\xbe\x03\x02\x02\x02\u0628\u0629	\x1f\x02\x02\u0629\xc0\x03\x02\x02\x02\u062A\u062B	 \x02\x02\u062B\xc2\x03\x02\x02\x02\u062C\u062D	!\x02\x02\u062D\xc4\x03\x02\x02\x02\x14\x02\x03\x04\xfb\u0102\u0113\u0155\u015B\u0581\u0585\u0587\u058C\u059A\u05AC\u05E2\u05E6\u05EF\u05F4\x07\x05\x02\x02\x04\x03\x02\x04\x04\x02\x02\x03\x02\x04\x02\x02';
    }
    static{
        this._serializedATN = $2IEP9.join([
            $e8c2106cf53953f8$export$375c79404cc64c7f._serializedATNSegment0,
            $e8c2106cf53953f8$export$375c79404cc64c7f._serializedATNSegment1,
            $e8c2106cf53953f8$export$375c79404cc64c7f._serializedATNSegment2
        ], '');
    }
    static get _ATN() {
        if (!$e8c2106cf53953f8$export$375c79404cc64c7f.__ATN) $e8c2106cf53953f8$export$375c79404cc64c7f.__ATN = new (0, $dvgsl.ATNDeserializer)().deserialize($2IEP9.toCharArray($e8c2106cf53953f8$export$375c79404cc64c7f._serializedATN));
        return $e8c2106cf53953f8$export$375c79404cc64c7f.__ATN;
    }
}

});

parcelRegister("7EDzN", function(module, exports) {

$parcel$export(module.exports, "JQLParser", () => $372495859d486e54$export$9c4772e191bdb810);
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Generated from JQLParser.g4 by ANTLR 4.7.3-SNAPSHOT

var $dvgsl = parcelRequire("dvgsl");

var $hKCjP = parcelRequire("hKCjP");

var $jIG0W = parcelRequire("jIG0W");

var $6bmaO = parcelRequire("6bmaO");

var $kzbnL = parcelRequire("kzbnL");

var $fLdDn = parcelRequire("fLdDn");

var $2DVsz = parcelRequire("2DVsz");

var $3n2FE = parcelRequire("3n2FE");

var $2IEP9 = parcelRequire("2IEP9");
class $372495859d486e54$export$9c4772e191bdb810 extends (0, $jIG0W.Parser) {
    static{
        this.LPAREN = 1;
    }
    static{
        this.RPAREN = 2;
    }
    static{
        this.COMMA = 3;
    }
    static{
        this.LBRACKET = 4;
    }
    static{
        this.RBRACKET = 5;
    }
    static{
        this.BANG = 6;
    }
    static{
        this.LT = 7;
    }
    static{
        this.GT = 8;
    }
    static{
        this.GTEQ = 9;
    }
    static{
        this.LTEQ = 10;
    }
    static{
        this.EQUALS = 11;
    }
    static{
        this.NOT_EQUALS = 12;
    }
    static{
        this.LIKE = 13;
    }
    static{
        this.NOT_LIKE = 14;
    }
    static{
        this.IN = 15;
    }
    static{
        this.IS = 16;
    }
    static{
        this.AND = 17;
    }
    static{
        this.OR = 18;
    }
    static{
        this.NOT = 19;
    }
    static{
        this.EMPTY = 20;
    }
    static{
        this.WAS = 21;
    }
    static{
        this.CHANGED = 22;
    }
    static{
        this.BEFORE = 23;
    }
    static{
        this.AFTER = 24;
    }
    static{
        this.FROM = 25;
    }
    static{
        this.TO = 26;
    }
    static{
        this.ON = 27;
    }
    static{
        this.DURING = 28;
    }
    static{
        this.ORDER = 29;
    }
    static{
        this.BY = 30;
    }
    static{
        this.ASC = 31;
    }
    static{
        this.DESC = 32;
    }
    static{
        this.POSNUMBER = 33;
    }
    static{
        this.NEGNUMBER = 34;
    }
    static{
        this.CUSTOMFIELD = 35;
    }
    static{
        this.RESERVED_WORD = 36;
    }
    static{
        this.STRING = 37;
    }
    static{
        this.MATCHWS = 38;
    }
    static{
        this.ERROR_RESERVED = 39;
    }
    static{
        this.ERRORCHAR = 40;
    }
    static{
        this.QUOTE_STRING = 41;
    }
    static{
        this.UNCLOSED_QUOTE_STRING = 42;
    }
    static{
        this.INVALID_QUOTE_STRING = 43;
    }
    static{
        this.SQUOTE_STRING = 44;
    }
    static{
        this.UNCLOSED_SQUOTE_STRING = 45;
    }
    static{
        this.INVALID_SQUOTE_STRING = 46;
    }
    static{
        this.RULE_jqlQuery = 0;
    }
    static{
        this.RULE_jqlWhere = 1;
    }
    static{
        this.RULE_jqlOrClause = 2;
    }
    static{
        this.RULE_jqlAndClause = 3;
    }
    static{
        this.RULE_jqlNotClause = 4;
    }
    static{
        this.RULE_jqlSubClause = 5;
    }
    static{
        this.RULE_jqlTerminalClause = 6;
    }
    static{
        this.RULE_jqlTerminalClauseRhs = 7;
    }
    static{
        this.RULE_jqlEqualsOperator = 8;
    }
    static{
        this.RULE_jqlLikeOperator = 9;
    }
    static{
        this.RULE_jqlComparisonOperator = 10;
    }
    static{
        this.RULE_jqlInOperator = 11;
    }
    static{
        this.RULE_jqlIsOperator = 12;
    }
    static{
        this.RULE_jqlWasOperator = 13;
    }
    static{
        this.RULE_jqlWasInOperator = 14;
    }
    static{
        this.RULE_jqlChangedOperator = 15;
    }
    static{
        this.RULE_jqlField = 16;
    }
    static{
        this.RULE_jqlFieldProperty = 17;
    }
    static{
        this.RULE_jqlCustomField = 18;
    }
    static{
        this.RULE_jqlString = 19;
    }
    static{
        this.RULE_jqlNumber = 20;
    }
    static{
        this.RULE_jqlOperand = 21;
    }
    static{
        this.RULE_jqlEmpty = 22;
    }
    static{
        this.RULE_jqlValue = 23;
    }
    static{
        this.RULE_jqlFunction = 24;
    }
    static{
        this.RULE_jqlFunctionName = 25;
    }
    static{
        this.RULE_jqlArgumentList = 26;
    }
    static{
        this.RULE_jqlList = 27;
    }
    static{
        this.RULE_jqlListStart = 28;
    }
    static{
        this.RULE_jqlListEnd = 29;
    }
    static{
        this.RULE_jqlPropertyArgument = 30;
    }
    static{
        this.RULE_jqlArgument = 31;
    }
    static{
        this.RULE_jqlWasPredicate = 32;
    }
    static{
        this.RULE_jqlChangedPredicate = 33;
    }
    static{
        this.RULE_jqlDatePredicateOperator = 34;
    }
    static{
        this.RULE_jqlDateRangePredicateOperator = 35;
    }
    static{
        this.RULE_jqlUserPredicateOperator = 36;
    }
    static{
        this.RULE_jqlValuePredicateOperator = 37;
    }
    static{
        this.RULE_jqlPredicateOperand = 38;
    }
    static{
        this.RULE_jqlOrderBy = 39;
    }
    static{
        this.RULE_jqlSearchSort = 40;
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.ruleNames = [
            'jqlQuery',
            'jqlWhere',
            'jqlOrClause',
            'jqlAndClause',
            'jqlNotClause',
            'jqlSubClause',
            'jqlTerminalClause',
            'jqlTerminalClauseRhs',
            'jqlEqualsOperator',
            'jqlLikeOperator',
            'jqlComparisonOperator',
            'jqlInOperator',
            'jqlIsOperator',
            'jqlWasOperator',
            'jqlWasInOperator',
            'jqlChangedOperator',
            'jqlField',
            'jqlFieldProperty',
            'jqlCustomField',
            'jqlString',
            'jqlNumber',
            'jqlOperand',
            'jqlEmpty',
            'jqlValue',
            'jqlFunction',
            'jqlFunctionName',
            'jqlArgumentList',
            'jqlList',
            'jqlListStart',
            'jqlListEnd',
            'jqlPropertyArgument',
            'jqlArgument',
            'jqlWasPredicate',
            'jqlChangedPredicate',
            'jqlDatePredicateOperator',
            'jqlDateRangePredicateOperator',
            'jqlUserPredicateOperator',
            'jqlValuePredicateOperator',
            'jqlPredicateOperand',
            'jqlOrderBy',
            'jqlSearchSort'
        ];
    }
    static{
        this._LITERAL_NAMES = [
            undefined,
            "'('",
            "')'",
            "','",
            "'['",
            "']'",
            "'!'",
            "'<'",
            "'>'",
            "'>='",
            "'<='",
            "'='",
            "'!='",
            "'~'",
            "'!~'"
        ];
    }
    static{
        this._SYMBOLIC_NAMES = [
            undefined,
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING'
        ];
    }
    static{
        this.VOCABULARY = new (0, $3n2FE.VocabularyImpl)($372495859d486e54$export$9c4772e191bdb810._LITERAL_NAMES, $372495859d486e54$export$9c4772e191bdb810._SYMBOLIC_NAMES, []);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return $372495859d486e54$export$9c4772e191bdb810.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    // @Override
    get grammarFileName() {
        return 'JQLParser.g4';
    }
    // @Override
    get ruleNames() {
        return $372495859d486e54$export$9c4772e191bdb810.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $372495859d486e54$export$9c4772e191bdb810._serializedATN;
    }
    constructor(input){
        super(input);
        this._interp = new (0, $kzbnL.ParserATNSimulator)($372495859d486e54$export$9c4772e191bdb810._ATN, this);
    }
    // @RuleVersion(0)
    jqlQuery() {
        let _localctx = new $372495859d486e54$export$ff413535b9575c8(this._ctx, this.state);
        this.enterRule(_localctx, 0, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlQuery);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 83;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la & -32) === 0 && (1 << _la & (1 << $372495859d486e54$export$9c4772e191bdb810.LPAREN | 1 << $372495859d486e54$export$9c4772e191bdb810.BANG | 1 << $372495859d486e54$export$9c4772e191bdb810.NOT)) !== 0 || (_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $372495859d486e54$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $372495859d486e54$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $372495859d486e54$export$9c4772e191bdb810.CUSTOMFIELD - 33 | 1 << $372495859d486e54$export$9c4772e191bdb810.STRING - 33 | 1 << $372495859d486e54$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $372495859d486e54$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 82;
                this.jqlWhere();
            }
            this.state = 86;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $372495859d486e54$export$9c4772e191bdb810.ORDER) {
                this.state = 85;
                this.jqlOrderBy();
            }
            this.state = 88;
            this.match($372495859d486e54$export$9c4772e191bdb810.EOF);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWhere() {
        let _localctx = new $372495859d486e54$export$4148a879cab28017(this._ctx, this.state);
        this.enterRule(_localctx, 2, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlWhere);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 90;
            this.jqlOrClause();
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrClause() {
        let _localctx = new $372495859d486e54$export$d69831d387793480(this._ctx, this.state);
        this.enterRule(_localctx, 4, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlOrClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 92;
            this.jqlAndClause();
            this.state = 97;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $372495859d486e54$export$9c4772e191bdb810.OR){
                this.state = 93;
                this.match($372495859d486e54$export$9c4772e191bdb810.OR);
                this.state = 94;
                this.jqlAndClause();
                this.state = 99;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlAndClause() {
        let _localctx = new $372495859d486e54$export$f16819001158b9e(this._ctx, this.state);
        this.enterRule(_localctx, 6, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlAndClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 100;
            this.jqlNotClause();
            this.state = 105;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $372495859d486e54$export$9c4772e191bdb810.AND){
                this.state = 101;
                this.match($372495859d486e54$export$9c4772e191bdb810.AND);
                this.state = 102;
                this.jqlNotClause();
                this.state = 107;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNotClause() {
        let _localctx = new $372495859d486e54$export$5e9146f8d5cf1330(this._ctx, this.state);
        this.enterRule(_localctx, 8, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlNotClause);
        let _la;
        try {
            this.state = 112;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $372495859d486e54$export$9c4772e191bdb810.BANG:
                case $372495859d486e54$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 108;
                    _la = this._input.LA(1);
                    if (!(_la === $372495859d486e54$export$9c4772e191bdb810.BANG || _la === $372495859d486e54$export$9c4772e191bdb810.NOT)) this._errHandler.recoverInline(this);
                    else {
                        if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                        this._errHandler.reportMatch(this);
                        this.consume();
                    }
                    this.state = 109;
                    this.jqlNotClause();
                    break;
                case $372495859d486e54$export$9c4772e191bdb810.LPAREN:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 110;
                    this.jqlSubClause();
                    break;
                case $372495859d486e54$export$9c4772e191bdb810.POSNUMBER:
                case $372495859d486e54$export$9c4772e191bdb810.NEGNUMBER:
                case $372495859d486e54$export$9c4772e191bdb810.CUSTOMFIELD:
                case $372495859d486e54$export$9c4772e191bdb810.STRING:
                case $372495859d486e54$export$9c4772e191bdb810.QUOTE_STRING:
                case $372495859d486e54$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 111;
                    this.jqlTerminalClause();
                    break;
                default:
                    throw new (0, $hKCjP.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSubClause() {
        let _localctx = new $372495859d486e54$export$a136a0e9655bfb04(this._ctx, this.state);
        this.enterRule(_localctx, 10, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlSubClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 114;
            this.match($372495859d486e54$export$9c4772e191bdb810.LPAREN);
            this.state = 115;
            this.jqlOrClause();
            this.state = 116;
            this.match($372495859d486e54$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClause() {
        let _localctx = new $372495859d486e54$export$23486a2f2ddd5bcd(this._ctx, this.state);
        this.enterRule(_localctx, 12, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlTerminalClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 118;
            this.jqlField();
            this.state = 119;
            this.jqlTerminalClauseRhs();
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClauseRhs() {
        let _localctx = new $372495859d486e54$export$93924a205c12d32c(this._ctx, this.state);
        this.enterRule(_localctx, 14, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs);
        let _la;
        try {
            this.state = 176;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 14, this._ctx)){
                case 1:
                    _localctx = new $372495859d486e54$export$c428f709a58396e5(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 121;
                    this.jqlEqualsOperator();
                    this.state = 125;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 5, this._ctx)){
                        case 1:
                            this.state = 122;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 123;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 124;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 2:
                    _localctx = new $372495859d486e54$export$1b131204ef9fa33d(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 127;
                    this.jqlLikeOperator();
                    this.state = 131;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 6, this._ctx)){
                        case 1:
                            this.state = 128;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 129;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 130;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 3:
                    _localctx = new $372495859d486e54$export$d83706ee80a9852a(_localctx);
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 133;
                    this.jqlComparisonOperator();
                    this.state = 136;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 7, this._ctx)){
                        case 1:
                            this.state = 134;
                            this.jqlValue();
                            break;
                        case 2:
                            this.state = 135;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 4:
                    _localctx = new $372495859d486e54$export$2934b8ff22fddd2d(_localctx);
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 138;
                    this.jqlInOperator();
                    this.state = 141;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $372495859d486e54$export$9c4772e191bdb810.LPAREN:
                            this.state = 139;
                            this.jqlList();
                            break;
                        case $372495859d486e54$export$9c4772e191bdb810.POSNUMBER:
                        case $372495859d486e54$export$9c4772e191bdb810.NEGNUMBER:
                        case $372495859d486e54$export$9c4772e191bdb810.STRING:
                        case $372495859d486e54$export$9c4772e191bdb810.QUOTE_STRING:
                        case $372495859d486e54$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 140;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $hKCjP.NoViableAltException)(this);
                    }
                    break;
                case 5:
                    _localctx = new $372495859d486e54$export$8b84310182afcf93(_localctx);
                    this.enterOuterAlt(_localctx, 5);
                    this.state = 143;
                    this.jqlIsOperator();
                    this.state = 144;
                    this.jqlEmpty();
                    break;
                case 6:
                    _localctx = new $372495859d486e54$export$5df295dc7a2cac7c(_localctx);
                    this.enterOuterAlt(_localctx, 6);
                    this.state = 146;
                    this.jqlWasOperator();
                    this.state = 150;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 9, this._ctx)){
                        case 1:
                            this.state = 147;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 148;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 149;
                            this.jqlFunction();
                            break;
                    }
                    this.state = 155;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $372495859d486e54$export$9c4772e191bdb810.BEFORE | 1 << $372495859d486e54$export$9c4772e191bdb810.AFTER | 1 << $372495859d486e54$export$9c4772e191bdb810.ON | 1 << $372495859d486e54$export$9c4772e191bdb810.DURING | 1 << $372495859d486e54$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 152;
                        this.jqlWasPredicate();
                        this.state = 157;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 7:
                    _localctx = new $372495859d486e54$export$9ac3367aee261b32(_localctx);
                    this.enterOuterAlt(_localctx, 7);
                    this.state = 158;
                    this.jqlWasInOperator();
                    this.state = 161;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $372495859d486e54$export$9c4772e191bdb810.LPAREN:
                            this.state = 159;
                            this.jqlList();
                            break;
                        case $372495859d486e54$export$9c4772e191bdb810.POSNUMBER:
                        case $372495859d486e54$export$9c4772e191bdb810.NEGNUMBER:
                        case $372495859d486e54$export$9c4772e191bdb810.STRING:
                        case $372495859d486e54$export$9c4772e191bdb810.QUOTE_STRING:
                        case $372495859d486e54$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 160;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $hKCjP.NoViableAltException)(this);
                    }
                    this.state = 166;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $372495859d486e54$export$9c4772e191bdb810.BEFORE | 1 << $372495859d486e54$export$9c4772e191bdb810.AFTER | 1 << $372495859d486e54$export$9c4772e191bdb810.ON | 1 << $372495859d486e54$export$9c4772e191bdb810.DURING | 1 << $372495859d486e54$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 163;
                        this.jqlWasPredicate();
                        this.state = 168;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 8:
                    _localctx = new $372495859d486e54$export$7a7defca8628a13c(_localctx);
                    this.enterOuterAlt(_localctx, 8);
                    this.state = 169;
                    this.jqlChangedOperator();
                    this.state = 173;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $372495859d486e54$export$9c4772e191bdb810.BEFORE | 1 << $372495859d486e54$export$9c4772e191bdb810.AFTER | 1 << $372495859d486e54$export$9c4772e191bdb810.FROM | 1 << $372495859d486e54$export$9c4772e191bdb810.TO | 1 << $372495859d486e54$export$9c4772e191bdb810.ON | 1 << $372495859d486e54$export$9c4772e191bdb810.DURING | 1 << $372495859d486e54$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 170;
                        this.jqlChangedPredicate();
                        this.state = 175;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEqualsOperator() {
        let _localctx = new $372495859d486e54$export$41e475fc1988e413(this._ctx, this.state);
        this.enterRule(_localctx, 16, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlEqualsOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 178;
            _la = this._input.LA(1);
            if (!(_la === $372495859d486e54$export$9c4772e191bdb810.EQUALS || _la === $372495859d486e54$export$9c4772e191bdb810.NOT_EQUALS)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlLikeOperator() {
        let _localctx = new $372495859d486e54$export$b76fe5387fdd7efd(this._ctx, this.state);
        this.enterRule(_localctx, 18, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlLikeOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 180;
            _la = this._input.LA(1);
            if (!(_la === $372495859d486e54$export$9c4772e191bdb810.LIKE || _la === $372495859d486e54$export$9c4772e191bdb810.NOT_LIKE)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlComparisonOperator() {
        let _localctx = new $372495859d486e54$export$d821da0716b3ec95(this._ctx, this.state);
        this.enterRule(_localctx, 20, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlComparisonOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 182;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $372495859d486e54$export$9c4772e191bdb810.LT | 1 << $372495859d486e54$export$9c4772e191bdb810.GT | 1 << $372495859d486e54$export$9c4772e191bdb810.GTEQ | 1 << $372495859d486e54$export$9c4772e191bdb810.LTEQ)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlInOperator() {
        let _localctx = new $372495859d486e54$export$178478bfa8292f72(this._ctx, this.state);
        this.enterRule(_localctx, 22, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlInOperator);
        try {
            this.state = 187;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $372495859d486e54$export$9c4772e191bdb810.IN:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 184;
                    this.match($372495859d486e54$export$9c4772e191bdb810.IN);
                    break;
                case $372495859d486e54$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 185;
                    this.match($372495859d486e54$export$9c4772e191bdb810.NOT);
                    this.state = 186;
                    this.match($372495859d486e54$export$9c4772e191bdb810.IN);
                    break;
                default:
                    throw new (0, $hKCjP.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlIsOperator() {
        let _localctx = new $372495859d486e54$export$e64c31d2830b66e4(this._ctx, this.state);
        this.enterRule(_localctx, 24, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlIsOperator);
        try {
            this.state = 192;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 16, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 189;
                    this.match($372495859d486e54$export$9c4772e191bdb810.IS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 190;
                    this.match($372495859d486e54$export$9c4772e191bdb810.IS);
                    this.state = 191;
                    this.match($372495859d486e54$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasOperator() {
        let _localctx = new $372495859d486e54$export$7e283636700e4a6c(this._ctx, this.state);
        this.enterRule(_localctx, 26, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlWasOperator);
        try {
            this.state = 197;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 17, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 194;
                    this.match($372495859d486e54$export$9c4772e191bdb810.WAS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 195;
                    this.match($372495859d486e54$export$9c4772e191bdb810.WAS);
                    this.state = 196;
                    this.match($372495859d486e54$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasInOperator() {
        let _localctx = new $372495859d486e54$export$b9118b1ed9a78d66(this._ctx, this.state);
        this.enterRule(_localctx, 28, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlWasInOperator);
        try {
            this.state = 204;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 18, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 199;
                    this.match($372495859d486e54$export$9c4772e191bdb810.WAS);
                    this.state = 200;
                    this.match($372495859d486e54$export$9c4772e191bdb810.IN);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 201;
                    this.match($372495859d486e54$export$9c4772e191bdb810.WAS);
                    this.state = 202;
                    this.match($372495859d486e54$export$9c4772e191bdb810.NOT);
                    this.state = 203;
                    this.match($372495859d486e54$export$9c4772e191bdb810.IN);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedOperator() {
        let _localctx = new $372495859d486e54$export$493d626ed78ca66(this._ctx, this.state);
        this.enterRule(_localctx, 30, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlChangedOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 206;
            this.match($372495859d486e54$export$9c4772e191bdb810.CHANGED);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlField() {
        let _localctx = new $372495859d486e54$export$b33300c3d916229a(this._ctx, this.state);
        this.enterRule(_localctx, 32, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlField);
        let _la;
        try {
            this.state = 219;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $372495859d486e54$export$9c4772e191bdb810.POSNUMBER:
                case $372495859d486e54$export$9c4772e191bdb810.NEGNUMBER:
                    _localctx = new $372495859d486e54$export$11fec15307d2e17b(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 208;
                    this.jqlNumber();
                    break;
                case $372495859d486e54$export$9c4772e191bdb810.CUSTOMFIELD:
                case $372495859d486e54$export$9c4772e191bdb810.STRING:
                case $372495859d486e54$export$9c4772e191bdb810.QUOTE_STRING:
                case $372495859d486e54$export$9c4772e191bdb810.SQUOTE_STRING:
                    _localctx = new $372495859d486e54$export$b8b24f99f985ebb3(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 211;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $372495859d486e54$export$9c4772e191bdb810.STRING:
                        case $372495859d486e54$export$9c4772e191bdb810.QUOTE_STRING:
                        case $372495859d486e54$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 209;
                            this.jqlString();
                            break;
                        case $372495859d486e54$export$9c4772e191bdb810.CUSTOMFIELD:
                            this.state = 210;
                            this.jqlCustomField();
                            break;
                        default:
                            throw new (0, $hKCjP.NoViableAltException)(this);
                    }
                    this.state = 216;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la === $372495859d486e54$export$9c4772e191bdb810.LBRACKET){
                        this.state = 213;
                        this.jqlFieldProperty();
                        this.state = 218;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                default:
                    throw new (0, $hKCjP.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFieldProperty() {
        let _localctx = new $372495859d486e54$export$b02d0b6637ce0593(this._ctx, this.state);
        this.enterRule(_localctx, 34, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlFieldProperty);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 221;
            this.match($372495859d486e54$export$9c4772e191bdb810.LBRACKET);
            this.state = 222;
            this.jqlArgument();
            this.state = 223;
            this.match($372495859d486e54$export$9c4772e191bdb810.RBRACKET);
            this.state = 228;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $372495859d486e54$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $372495859d486e54$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $372495859d486e54$export$9c4772e191bdb810.STRING - 33 | 1 << $372495859d486e54$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $372495859d486e54$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0){
                this.state = 225;
                this.jqlPropertyArgument();
                this.state = 230;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlCustomField() {
        let _localctx = new $372495859d486e54$export$401a038855cc5b15(this._ctx, this.state);
        this.enterRule(_localctx, 36, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlCustomField);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 231;
            this.match($372495859d486e54$export$9c4772e191bdb810.CUSTOMFIELD);
            this.state = 232;
            this.match($372495859d486e54$export$9c4772e191bdb810.LBRACKET);
            this.state = 233;
            this.match($372495859d486e54$export$9c4772e191bdb810.POSNUMBER);
            this.state = 234;
            this.match($372495859d486e54$export$9c4772e191bdb810.RBRACKET);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlString() {
        let _localctx = new $372495859d486e54$export$bde73d8ad7c8b71e(this._ctx, this.state);
        this.enterRule(_localctx, 38, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlString);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 236;
            _la = this._input.LA(1);
            if (!((_la - 37 & -32) === 0 && (1 << _la - 37 & (1 << $372495859d486e54$export$9c4772e191bdb810.STRING - 37 | 1 << $372495859d486e54$export$9c4772e191bdb810.QUOTE_STRING - 37 | 1 << $372495859d486e54$export$9c4772e191bdb810.SQUOTE_STRING - 37)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNumber() {
        let _localctx = new $372495859d486e54$export$8737d94a1880e8b3(this._ctx, this.state);
        this.enterRule(_localctx, 40, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlNumber);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 238;
            _localctx._jqlNum = this._input.LT(1);
            _la = this._input.LA(1);
            if (!(_la === $372495859d486e54$export$9c4772e191bdb810.POSNUMBER || _la === $372495859d486e54$export$9c4772e191bdb810.NEGNUMBER)) _localctx._jqlNum = this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOperand() {
        let _localctx = new $372495859d486e54$export$2eaac5a9828bf647(this._ctx, this.state);
        this.enterRule(_localctx, 42, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlOperand);
        try {
            this.state = 244;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 23, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 240;
                    this.jqlEmpty();
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 241;
                    this.jqlValue();
                    break;
                case 3:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 242;
                    this.jqlFunction();
                    break;
                case 4:
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 243;
                    this.jqlList();
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEmpty() {
        let _localctx = new $372495859d486e54$export$d85a062f90025e5c(this._ctx, this.state);
        this.enterRule(_localctx, 44, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlEmpty);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 246;
            this.match($372495859d486e54$export$9c4772e191bdb810.EMPTY);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValue() {
        let _localctx = new $372495859d486e54$export$2e17d457b0933bec(this._ctx, this.state);
        this.enterRule(_localctx, 46, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlValue);
        try {
            this.state = 250;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $372495859d486e54$export$9c4772e191bdb810.STRING:
                case $372495859d486e54$export$9c4772e191bdb810.QUOTE_STRING:
                case $372495859d486e54$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 248;
                    this.jqlString();
                    break;
                case $372495859d486e54$export$9c4772e191bdb810.POSNUMBER:
                case $372495859d486e54$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 249;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $hKCjP.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunction() {
        let _localctx = new $372495859d486e54$export$ebf0cc785e9ee41a(this._ctx, this.state);
        this.enterRule(_localctx, 48, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlFunction);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 252;
            this.jqlFunctionName();
            this.state = 253;
            this.match($372495859d486e54$export$9c4772e191bdb810.LPAREN);
            this.state = 255;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $372495859d486e54$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $372495859d486e54$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $372495859d486e54$export$9c4772e191bdb810.STRING - 33 | 1 << $372495859d486e54$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $372495859d486e54$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 254;
                this.jqlArgumentList();
            }
            this.state = 257;
            this.match($372495859d486e54$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunctionName() {
        let _localctx = new $372495859d486e54$export$1f5f7ac816788f44(this._ctx, this.state);
        this.enterRule(_localctx, 50, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlFunctionName);
        try {
            this.state = 261;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $372495859d486e54$export$9c4772e191bdb810.STRING:
                case $372495859d486e54$export$9c4772e191bdb810.QUOTE_STRING:
                case $372495859d486e54$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 259;
                    this.jqlString();
                    break;
                case $372495859d486e54$export$9c4772e191bdb810.POSNUMBER:
                case $372495859d486e54$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 260;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $hKCjP.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgumentList() {
        let _localctx = new $372495859d486e54$export$83d7c13849b931c3(this._ctx, this.state);
        this.enterRule(_localctx, 52, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlArgumentList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 263;
            this.jqlArgument();
            this.state = 268;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $372495859d486e54$export$9c4772e191bdb810.COMMA){
                this.state = 264;
                this.match($372495859d486e54$export$9c4772e191bdb810.COMMA);
                this.state = 265;
                this.jqlArgument();
                this.state = 270;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlList() {
        let _localctx = new $372495859d486e54$export$9cb97a63f2be4864(this._ctx, this.state);
        this.enterRule(_localctx, 54, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 271;
            this.jqlListStart();
            this.state = 272;
            this.jqlOperand();
            this.state = 277;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $372495859d486e54$export$9c4772e191bdb810.COMMA){
                this.state = 273;
                this.match($372495859d486e54$export$9c4772e191bdb810.COMMA);
                this.state = 274;
                this.jqlOperand();
                this.state = 279;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 280;
            this.jqlListEnd();
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListStart() {
        let _localctx = new $372495859d486e54$export$c419f717bfc46a5d(this._ctx, this.state);
        this.enterRule(_localctx, 56, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlListStart);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 282;
            this.match($372495859d486e54$export$9c4772e191bdb810.LPAREN);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListEnd() {
        let _localctx = new $372495859d486e54$export$f6cd3e372f5ab120(this._ctx, this.state);
        this.enterRule(_localctx, 58, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlListEnd);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 284;
            this.match($372495859d486e54$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPropertyArgument() {
        let _localctx = new $372495859d486e54$export$e20ce4a2ed16372c(this._ctx, this.state);
        this.enterRule(_localctx, 60, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlPropertyArgument);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 286;
            this.jqlArgument();
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgument() {
        let _localctx = new $372495859d486e54$export$a95583953c237f88(this._ctx, this.state);
        this.enterRule(_localctx, 62, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlArgument);
        try {
            this.state = 290;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $372495859d486e54$export$9c4772e191bdb810.STRING:
                case $372495859d486e54$export$9c4772e191bdb810.QUOTE_STRING:
                case $372495859d486e54$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 288;
                    this.jqlString();
                    break;
                case $372495859d486e54$export$9c4772e191bdb810.POSNUMBER:
                case $372495859d486e54$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 289;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $hKCjP.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasPredicate() {
        let _localctx = new $372495859d486e54$export$9fa1e4d63f31b911(this._ctx, this.state);
        this.enterRule(_localctx, 64, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlWasPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 295;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $372495859d486e54$export$9c4772e191bdb810.BEFORE:
                case $372495859d486e54$export$9c4772e191bdb810.AFTER:
                case $372495859d486e54$export$9c4772e191bdb810.ON:
                    this.state = 292;
                    this.jqlDatePredicateOperator();
                    break;
                case $372495859d486e54$export$9c4772e191bdb810.DURING:
                    this.state = 293;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $372495859d486e54$export$9c4772e191bdb810.BY:
                    this.state = 294;
                    this.jqlUserPredicateOperator();
                    break;
                default:
                    throw new (0, $hKCjP.NoViableAltException)(this);
            }
            this.state = 297;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedPredicate() {
        let _localctx = new $372495859d486e54$export$e77e479a48133015(this._ctx, this.state);
        this.enterRule(_localctx, 66, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlChangedPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 303;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $372495859d486e54$export$9c4772e191bdb810.BEFORE:
                case $372495859d486e54$export$9c4772e191bdb810.AFTER:
                case $372495859d486e54$export$9c4772e191bdb810.ON:
                    this.state = 299;
                    this.jqlDatePredicateOperator();
                    break;
                case $372495859d486e54$export$9c4772e191bdb810.DURING:
                    this.state = 300;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $372495859d486e54$export$9c4772e191bdb810.BY:
                    this.state = 301;
                    this.jqlUserPredicateOperator();
                    break;
                case $372495859d486e54$export$9c4772e191bdb810.FROM:
                case $372495859d486e54$export$9c4772e191bdb810.TO:
                    this.state = 302;
                    this.jqlValuePredicateOperator();
                    break;
                default:
                    throw new (0, $hKCjP.NoViableAltException)(this);
            }
            this.state = 305;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDatePredicateOperator() {
        let _localctx = new $372495859d486e54$export$dc01290aee731418(this._ctx, this.state);
        this.enterRule(_localctx, 68, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 307;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $372495859d486e54$export$9c4772e191bdb810.BEFORE | 1 << $372495859d486e54$export$9c4772e191bdb810.AFTER | 1 << $372495859d486e54$export$9c4772e191bdb810.ON)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDateRangePredicateOperator() {
        let _localctx = new $372495859d486e54$export$75412b8b6a6442e1(this._ctx, this.state);
        this.enterRule(_localctx, 70, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 309;
            this.match($372495859d486e54$export$9c4772e191bdb810.DURING);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlUserPredicateOperator() {
        let _localctx = new $372495859d486e54$export$ad402332075c8656(this._ctx, this.state);
        this.enterRule(_localctx, 72, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 311;
            this.match($372495859d486e54$export$9c4772e191bdb810.BY);
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValuePredicateOperator() {
        let _localctx = new $372495859d486e54$export$4239d7c0fbafd3f1(this._ctx, this.state);
        this.enterRule(_localctx, 74, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 313;
            _la = this._input.LA(1);
            if (!(_la === $372495859d486e54$export$9c4772e191bdb810.FROM || _la === $372495859d486e54$export$9c4772e191bdb810.TO)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPredicateOperand() {
        let _localctx = new $372495859d486e54$export$6b796c5a4b8c18e(this._ctx, this.state);
        this.enterRule(_localctx, 76, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlPredicateOperand);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 315;
            this.jqlOperand();
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrderBy() {
        let _localctx = new $372495859d486e54$export$534469b9c8f44139(this._ctx, this.state);
        this.enterRule(_localctx, 78, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlOrderBy);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 317;
            this.match($372495859d486e54$export$9c4772e191bdb810.ORDER);
            this.state = 318;
            this.match($372495859d486e54$export$9c4772e191bdb810.BY);
            this.state = 319;
            this.jqlSearchSort();
            this.state = 324;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $372495859d486e54$export$9c4772e191bdb810.COMMA){
                this.state = 320;
                this.match($372495859d486e54$export$9c4772e191bdb810.COMMA);
                this.state = 321;
                this.jqlSearchSort();
                this.state = 326;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSearchSort() {
        let _localctx = new $372495859d486e54$export$c7d8f03f36952a46(this._ctx, this.state);
        this.enterRule(_localctx, 80, $372495859d486e54$export$9c4772e191bdb810.RULE_jqlSearchSort);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 327;
            this.jqlField();
            this.state = 329;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $372495859d486e54$export$9c4772e191bdb810.ASC || _la === $372495859d486e54$export$9c4772e191bdb810.DESC) {
                this.state = 328;
                _la = this._input.LA(1);
                if (!(_la === $372495859d486e54$export$9c4772e191bdb810.ASC || _la === $372495859d486e54$export$9c4772e191bdb810.DESC)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        } catch (re) {
            if (re instanceof (0, $fLdDn.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    static{
        this._serializedATN = '\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x030\u014E\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04"	"\x04#	#\x04$	$\x04%	%\x04&	&\x04\'	\'\x04(	(\x04)	)\x04*	*\x03\x02\x05\x02V\n\x02\x03\x02\x05\x02Y\n\x02\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x04\x07\x04b\n\x04\f\x04\x0e\x04e\v\x04\x03\x05\x03\x05\x03\x05\x07\x05j\n\x05\f\x05\x0e\x05m\v\x05\x03\x06\x03\x06\x03\x06\x03\x06\x05\x06s\n\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03	\x03	\x03	\x03	\x05	\x80\n	\x03	\x03	\x03	\x03	\x05	\x86\n	\x03	\x03	\x03	\x05	\x8b\n	\x03	\x03	\x03	\x05	\x90\n	\x03	\x03	\x03	\x03	\x03	\x03	\x03	\x05	\x99\n	\x03	\x07	\x9c\n	\f	\x0e	\x9f\v	\x03	\x03	\x03	\x05	\xa4\n	\x03	\x07	\xa7\n	\f	\x0e	\xaa\v	\x03	\x03	\x07	\xae\n	\f	\x0e	\xb1\v	\x05	\xb3\n	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\r\x03\r\x03\r\x05\r\xbe\n\r\x03\x0e\x03\x0e\x03\x0e\x05\x0e\xc3\n\x0e\x03\x0f\x03\x0f\x03\x0f\x05\x0f\xc8\n\x0f\x03\x10\x03\x10\x03\x10\x03\x10\x03\x10\x05\x10\xcf\n\x10\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x05\x12\xd6\n\x12\x03\x12\x07\x12\xd9\n\x12\f\x12\x0e\x12\xdc\v\x12\x05\x12\xde\n\x12\x03\x13\x03\x13\x03\x13\x03\x13\x03\x13\x07\x13\xe5\n\x13\f\x13\x0e\x13\xe8\v\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x15\x03\x15\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\xf7\n\x17\x03\x18\x03\x18\x03\x19\x03\x19\x05\x19\xfd\n\x19\x03\x1a\x03\x1a\x03\x1a\x05\x1a\u0102\n\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x05\x1b\u0108\n\x1b\x03\x1c\x03\x1c\x03\x1c\x07\x1c\u010D\n\x1c\f\x1c\x0e\x1c\u0110\v\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1d\x07\x1d\u0116\n\x1d\f\x1d\x0e\x1d\u0119\v\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03 \x03 \x03!\x03!\x05!\u0125\n!\x03"\x03"\x03"\x05"\u012A\n"\x03"\x03"\x03#\x03#\x03#\x03#\x05#\u0132\n#\x03#\x03#\x03$\x03$\x03%\x03%\x03&\x03&\x03\'\x03\'\x03(\x03(\x03)\x03)\x03)\x03)\x03)\x07)\u0145\n)\f)\x0e)\u0148\v)\x03*\x03*\x05*\u014C\n*\x03*\x02\x02\x02+\x02\x02\x04\x02\x06\x02\b\x02\n\x02\f\x02\x0e\x02\x10\x02\x12\x02\x14\x02\x16\x02\x18\x02\x1a\x02\x1c\x02\x1e\x02 \x02"\x02$\x02&\x02(\x02*\x02,\x02.\x020\x022\x024\x026\x028\x02:\x02<\x02>\x02@\x02B\x02D\x02F\x02H\x02J\x02L\x02N\x02P\x02R\x02\x02\v\x04\x02\b\b\x15\x15\x03\x02\r\x0e\x03\x02\x0f\x10\x03\x02	\f\x05\x02\'\'++..\x03\x02#$\x04\x02\x19\x1a\x1d\x1d\x03\x02\x1b\x1c\x03\x02!"\x02\u0155\x02U\x03\x02\x02\x02\x04\\\x03\x02\x02\x02\x06^\x03\x02\x02\x02\bf\x03\x02\x02\x02\nr\x03\x02\x02\x02\ft\x03\x02\x02\x02\x0ex\x03\x02\x02\x02\x10\xb2\x03\x02\x02\x02\x12\xb4\x03\x02\x02\x02\x14\xb6\x03\x02\x02\x02\x16\xb8\x03\x02\x02\x02\x18\xbd\x03\x02\x02\x02\x1a\xc2\x03\x02\x02\x02\x1c\xc7\x03\x02\x02\x02\x1e\xce\x03\x02\x02\x02 \xd0\x03\x02\x02\x02"\xdd\x03\x02\x02\x02$\xdf\x03\x02\x02\x02&\xe9\x03\x02\x02\x02(\xee\x03\x02\x02\x02*\xf0\x03\x02\x02\x02,\xf6\x03\x02\x02\x02.\xf8\x03\x02\x02\x020\xfc\x03\x02\x02\x022\xfe\x03\x02\x02\x024\u0107\x03\x02\x02\x026\u0109\x03\x02\x02\x028\u0111\x03\x02\x02\x02:\u011C\x03\x02\x02\x02<\u011E\x03\x02\x02\x02>\u0120\x03\x02\x02\x02@\u0124\x03\x02\x02\x02B\u0129\x03\x02\x02\x02D\u0131\x03\x02\x02\x02F\u0135\x03\x02\x02\x02H\u0137\x03\x02\x02\x02J\u0139\x03\x02\x02\x02L\u013B\x03\x02\x02\x02N\u013D\x03\x02\x02\x02P\u013F\x03\x02\x02\x02R\u0149\x03\x02\x02\x02TV\x05\x04\x03\x02UT\x03\x02\x02\x02UV\x03\x02\x02\x02VX\x03\x02\x02\x02WY\x05P)\x02XW\x03\x02\x02\x02XY\x03\x02\x02\x02YZ\x03\x02\x02\x02Z[\x07\x02\x02\x03[\x03\x03\x02\x02\x02\\]\x05\x06\x04\x02]\x05\x03\x02\x02\x02^c\x05\b\x05\x02_`\x07\x14\x02\x02`b\x05\b\x05\x02a_\x03\x02\x02\x02be\x03\x02\x02\x02ca\x03\x02\x02\x02cd\x03\x02\x02\x02d\x07\x03\x02\x02\x02ec\x03\x02\x02\x02fk\x05\n\x06\x02gh\x07\x13\x02\x02hj\x05\n\x06\x02ig\x03\x02\x02\x02jm\x03\x02\x02\x02ki\x03\x02\x02\x02kl\x03\x02\x02\x02l	\x03\x02\x02\x02mk\x03\x02\x02\x02no	\x02\x02\x02os\x05\n\x06\x02ps\x05\f\x07\x02qs\x05\x0e\b\x02rn\x03\x02\x02\x02rp\x03\x02\x02\x02rq\x03\x02\x02\x02s\v\x03\x02\x02\x02tu\x07\x03\x02\x02uv\x05\x06\x04\x02vw\x07\x04\x02\x02w\r\x03\x02\x02\x02xy\x05"\x12\x02yz\x05\x10	\x02z\x0f\x03\x02\x02\x02{\x7f\x05\x12\n\x02|\x80\x05.\x18\x02}\x80\x050\x19\x02~\x80\x052\x1a\x02\x7f|\x03\x02\x02\x02\x7f}\x03\x02\x02\x02\x7f~\x03\x02\x02\x02\x80\xb3\x03\x02\x02\x02\x81\x85\x05\x14\v\x02\x82\x86\x05.\x18\x02\x83\x86\x050\x19\x02\x84\x86\x052\x1a\x02\x85\x82\x03\x02\x02\x02\x85\x83\x03\x02\x02\x02\x85\x84\x03\x02\x02\x02\x86\xb3\x03\x02\x02\x02\x87\x8a\x05\x16\f\x02\x88\x8b\x050\x19\x02\x89\x8b\x052\x1a\x02\x8a\x88\x03\x02\x02\x02\x8a\x89\x03\x02\x02\x02\x8b\xb3\x03\x02\x02\x02\x8c\x8f\x05\x18\r\x02\x8d\x90\x058\x1d\x02\x8e\x90\x052\x1a\x02\x8f\x8d\x03\x02\x02\x02\x8f\x8e\x03\x02\x02\x02\x90\xb3\x03\x02\x02\x02\x91\x92\x05\x1a\x0e\x02\x92\x93\x05.\x18\x02\x93\xb3\x03\x02\x02\x02\x94\x98\x05\x1c\x0f\x02\x95\x99\x05.\x18\x02\x96\x99\x050\x19\x02\x97\x99\x052\x1a\x02\x98\x95\x03\x02\x02\x02\x98\x96\x03\x02\x02\x02\x98\x97\x03\x02\x02\x02\x99\x9d\x03\x02\x02\x02\x9a\x9c\x05B"\x02\x9b\x9a\x03\x02\x02\x02\x9c\x9f\x03\x02\x02\x02\x9d\x9b\x03\x02\x02\x02\x9d\x9e\x03\x02\x02\x02\x9e\xb3\x03\x02\x02\x02\x9f\x9d\x03\x02\x02\x02\xa0\xa3\x05\x1e\x10\x02\xa1\xa4\x058\x1d\x02\xa2\xa4\x052\x1a\x02\xa3\xa1\x03\x02\x02\x02\xa3\xa2\x03\x02\x02\x02\xa4\xa8\x03\x02\x02\x02\xa5\xa7\x05B"\x02\xa6\xa5\x03\x02\x02\x02\xa7\xaa\x03\x02\x02\x02\xa8\xa6\x03\x02\x02\x02\xa8\xa9\x03\x02\x02\x02\xa9\xb3\x03\x02\x02\x02\xaa\xa8\x03\x02\x02\x02\xab\xaf\x05 \x11\x02\xac\xae\x05D#\x02\xad\xac\x03\x02\x02\x02\xae\xb1\x03\x02\x02\x02\xaf\xad\x03\x02\x02\x02\xaf\xb0\x03\x02\x02\x02\xb0\xb3\x03\x02\x02\x02\xb1\xaf\x03\x02\x02\x02\xb2{\x03\x02\x02\x02\xb2\x81\x03\x02\x02\x02\xb2\x87\x03\x02\x02\x02\xb2\x8c\x03\x02\x02\x02\xb2\x91\x03\x02\x02\x02\xb2\x94\x03\x02\x02\x02\xb2\xa0\x03\x02\x02\x02\xb2\xab\x03\x02\x02\x02\xb3\x11\x03\x02\x02\x02\xb4\xb5	\x03\x02\x02\xb5\x13\x03\x02\x02\x02\xb6\xb7	\x04\x02\x02\xb7\x15\x03\x02\x02\x02\xb8\xb9	\x05\x02\x02\xb9\x17\x03\x02\x02\x02\xba\xbe\x07\x11\x02\x02\xbb\xbc\x07\x15\x02\x02\xbc\xbe\x07\x11\x02\x02\xbd\xba\x03\x02\x02\x02\xbd\xbb\x03\x02\x02\x02\xbe\x19\x03\x02\x02\x02\xbf\xc3\x07\x12\x02\x02\xc0\xc1\x07\x12\x02\x02\xc1\xc3\x07\x15\x02\x02\xc2\xbf\x03\x02\x02\x02\xc2\xc0\x03\x02\x02\x02\xc3\x1b\x03\x02\x02\x02\xc4\xc8\x07\x17\x02\x02\xc5\xc6\x07\x17\x02\x02\xc6\xc8\x07\x15\x02\x02\xc7\xc4\x03\x02\x02\x02\xc7\xc5\x03\x02\x02\x02\xc8\x1d\x03\x02\x02\x02\xc9\xca\x07\x17\x02\x02\xca\xcf\x07\x11\x02\x02\xcb\xcc\x07\x17\x02\x02\xcc\xcd\x07\x15\x02\x02\xcd\xcf\x07\x11\x02\x02\xce\xc9\x03\x02\x02\x02\xce\xcb\x03\x02\x02\x02\xcf\x1f\x03\x02\x02\x02\xd0\xd1\x07\x18\x02\x02\xd1!\x03\x02\x02\x02\xd2\xde\x05*\x16\x02\xd3\xd6\x05(\x15\x02\xd4\xd6\x05&\x14\x02\xd5\xd3\x03\x02\x02\x02\xd5\xd4\x03\x02\x02\x02\xd6\xda\x03\x02\x02\x02\xd7\xd9\x05$\x13\x02\xd8\xd7\x03\x02\x02\x02\xd9\xdc\x03\x02\x02\x02\xda\xd8\x03\x02\x02\x02\xda\xdb\x03\x02\x02\x02\xdb\xde\x03\x02\x02\x02\xdc\xda\x03\x02\x02\x02\xdd\xd2\x03\x02\x02\x02\xdd\xd5\x03\x02\x02\x02\xde#\x03\x02\x02\x02\xdf\xe0\x07\x06\x02\x02\xe0\xe1\x05@!\x02\xe1\xe2\x07\x07\x02\x02\xe2\xe6\x03\x02\x02\x02\xe3\xe5\x05> \x02\xe4\xe3\x03\x02\x02\x02\xe5\xe8\x03\x02\x02\x02\xe6\xe4\x03\x02\x02\x02\xe6\xe7\x03\x02\x02\x02\xe7%\x03\x02\x02\x02\xe8\xe6\x03\x02\x02\x02\xe9\xea\x07%\x02\x02\xea\xeb\x07\x06\x02\x02\xeb\xec\x07#\x02\x02\xec\xed\x07\x07\x02\x02\xed\'\x03\x02\x02\x02\xee\xef	\x06\x02\x02\xef)\x03\x02\x02\x02\xf0\xf1	\x07\x02\x02\xf1+\x03\x02\x02\x02\xf2\xf7\x05.\x18\x02\xf3\xf7\x050\x19\x02\xf4\xf7\x052\x1a\x02\xf5\xf7\x058\x1d\x02\xf6\xf2\x03\x02\x02\x02\xf6\xf3\x03\x02\x02\x02\xf6\xf4\x03\x02\x02\x02\xf6\xf5\x03\x02\x02\x02\xf7-\x03\x02\x02\x02\xf8\xf9\x07\x16\x02\x02\xf9/\x03\x02\x02\x02\xfa\xfd\x05(\x15\x02\xfb\xfd\x05*\x16\x02\xfc\xfa\x03\x02\x02\x02\xfc\xfb\x03\x02\x02\x02\xfd1\x03\x02\x02\x02\xfe\xff\x054\x1b\x02\xff\u0101\x07\x03\x02\x02\u0100\u0102\x056\x1c\x02\u0101\u0100\x03\x02\x02\x02\u0101\u0102\x03\x02\x02\x02\u0102\u0103\x03\x02\x02\x02\u0103\u0104\x07\x04\x02\x02\u01043\x03\x02\x02\x02\u0105\u0108\x05(\x15\x02\u0106\u0108\x05*\x16\x02\u0107\u0105\x03\x02\x02\x02\u0107\u0106\x03\x02\x02\x02\u01085\x03\x02\x02\x02\u0109\u010E\x05@!\x02\u010A\u010B\x07\x05\x02\x02\u010B\u010D\x05@!\x02\u010C\u010A\x03\x02\x02\x02\u010D\u0110\x03\x02\x02\x02\u010E\u010C\x03\x02\x02\x02\u010E\u010F\x03\x02\x02\x02\u010F7\x03\x02\x02\x02\u0110\u010E\x03\x02\x02\x02\u0111\u0112\x05:\x1e\x02\u0112\u0117\x05,\x17\x02\u0113\u0114\x07\x05\x02\x02\u0114\u0116\x05,\x17\x02\u0115\u0113\x03\x02\x02\x02\u0116\u0119\x03\x02\x02\x02\u0117\u0115\x03\x02\x02\x02\u0117\u0118\x03\x02\x02\x02\u0118\u011A\x03\x02\x02\x02\u0119\u0117\x03\x02\x02\x02\u011A\u011B\x05<\x1f\x02\u011B9\x03\x02\x02\x02\u011C\u011D\x07\x03\x02\x02\u011D;\x03\x02\x02\x02\u011E\u011F\x07\x04\x02\x02\u011F=\x03\x02\x02\x02\u0120\u0121\x05@!\x02\u0121?\x03\x02\x02\x02\u0122\u0125\x05(\x15\x02\u0123\u0125\x05*\x16\x02\u0124\u0122\x03\x02\x02\x02\u0124\u0123\x03\x02\x02\x02\u0125A\x03\x02\x02\x02\u0126\u012A\x05F$\x02\u0127\u012A\x05H%\x02\u0128\u012A\x05J&\x02\u0129\u0126\x03\x02\x02\x02\u0129\u0127\x03\x02\x02\x02\u0129\u0128\x03\x02\x02\x02\u012A\u012B\x03\x02\x02\x02\u012B\u012C\x05N(\x02\u012CC\x03\x02\x02\x02\u012D\u0132\x05F$\x02\u012E\u0132\x05H%\x02\u012F\u0132\x05J&\x02\u0130\u0132\x05L\'\x02\u0131\u012D\x03\x02\x02\x02\u0131\u012E\x03\x02\x02\x02\u0131\u012F\x03\x02\x02\x02\u0131\u0130\x03\x02\x02\x02\u0132\u0133\x03\x02\x02\x02\u0133\u0134\x05N(\x02\u0134E\x03\x02\x02\x02\u0135\u0136	\b\x02\x02\u0136G\x03\x02\x02\x02\u0137\u0138\x07\x1e\x02\x02\u0138I\x03\x02\x02\x02\u0139\u013A\x07 \x02\x02\u013AK\x03\x02\x02\x02\u013B\u013C		\x02\x02\u013CM\x03\x02\x02\x02\u013D\u013E\x05,\x17\x02\u013EO\x03\x02\x02\x02\u013F\u0140\x07\x1f\x02\x02\u0140\u0141\x07 \x02\x02\u0141\u0146\x05R*\x02\u0142\u0143\x07\x05\x02\x02\u0143\u0145\x05R*\x02\u0144\u0142\x03\x02\x02\x02\u0145\u0148\x03\x02\x02\x02\u0146\u0144\x03\x02\x02\x02\u0146\u0147\x03\x02\x02\x02\u0147Q\x03\x02\x02\x02\u0148\u0146\x03\x02\x02\x02\u0149\u014B\x05"\x12\x02\u014A\u014C	\n\x02\x02\u014B\u014A\x03\x02\x02\x02\u014B\u014C\x03\x02\x02\x02\u014CS\x03\x02\x02\x02$UXckr\x7f\x85\x8a\x8f\x98\x9d\xa3\xa8\xaf\xb2\xbd\xc2\xc7\xce\xd5\xda\xdd\xe6\xf6\xfc\u0101\u0107\u010E\u0117\u0124\u0129\u0131\u0146\u014B';
    }
    static get _ATN() {
        if (!$372495859d486e54$export$9c4772e191bdb810.__ATN) $372495859d486e54$export$9c4772e191bdb810.__ATN = new (0, $dvgsl.ATNDeserializer)().deserialize($2IEP9.toCharArray($372495859d486e54$export$9c4772e191bdb810._serializedATN));
        return $372495859d486e54$export$9c4772e191bdb810.__ATN;
    }
}
class $372495859d486e54$export$ff413535b9575c8 extends (0, $6bmaO.ParserRuleContext) {
    EOF() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.EOF, 0);
    }
    jqlWhere() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$4148a879cab28017);
    }
    jqlOrderBy() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$534469b9c8f44139);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlQuery;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlQuery) listener.enterJqlQuery(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlQuery) listener.exitJqlQuery(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlQuery) return visitor.visitJqlQuery(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$4148a879cab28017 extends (0, $6bmaO.ParserRuleContext) {
    jqlOrClause() {
        return this.getRuleContext(0, $372495859d486e54$export$d69831d387793480);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlWhere;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWhere) listener.enterJqlWhere(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWhere) listener.exitJqlWhere(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWhere) return visitor.visitJqlWhere(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$d69831d387793480 extends (0, $6bmaO.ParserRuleContext) {
    jqlAndClause(i) {
        if (i === undefined) return this.getRuleContexts($372495859d486e54$export$f16819001158b9e);
        else return this.getRuleContext(i, $372495859d486e54$export$f16819001158b9e);
    }
    OR(i) {
        if (i === undefined) return this.getTokens($372495859d486e54$export$9c4772e191bdb810.OR);
        else return this.getToken($372495859d486e54$export$9c4772e191bdb810.OR, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlOrClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrClause) listener.enterJqlOrClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrClause) listener.exitJqlOrClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrClause) return visitor.visitJqlOrClause(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$f16819001158b9e extends (0, $6bmaO.ParserRuleContext) {
    jqlNotClause(i) {
        if (i === undefined) return this.getRuleContexts($372495859d486e54$export$5e9146f8d5cf1330);
        else return this.getRuleContext(i, $372495859d486e54$export$5e9146f8d5cf1330);
    }
    AND(i) {
        if (i === undefined) return this.getTokens($372495859d486e54$export$9c4772e191bdb810.AND);
        else return this.getToken($372495859d486e54$export$9c4772e191bdb810.AND, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlAndClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlAndClause) listener.enterJqlAndClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlAndClause) listener.exitJqlAndClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlAndClause) return visitor.visitJqlAndClause(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$5e9146f8d5cf1330 extends (0, $6bmaO.ParserRuleContext) {
    jqlNotClause() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$5e9146f8d5cf1330);
    }
    NOT() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.NOT, 0);
    }
    BANG() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.BANG, 0);
    }
    jqlSubClause() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$a136a0e9655bfb04);
    }
    jqlTerminalClause() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$23486a2f2ddd5bcd);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlNotClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNotClause) listener.enterJqlNotClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNotClause) listener.exitJqlNotClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNotClause) return visitor.visitJqlNotClause(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$a136a0e9655bfb04 extends (0, $6bmaO.ParserRuleContext) {
    LPAREN() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.LPAREN, 0);
    }
    jqlOrClause() {
        return this.getRuleContext(0, $372495859d486e54$export$d69831d387793480);
    }
    RPAREN() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.RPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlSubClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSubClause) listener.enterJqlSubClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSubClause) listener.exitJqlSubClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSubClause) return visitor.visitJqlSubClause(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$23486a2f2ddd5bcd extends (0, $6bmaO.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $372495859d486e54$export$b33300c3d916229a);
    }
    jqlTerminalClauseRhs() {
        return this.getRuleContext(0, $372495859d486e54$export$93924a205c12d32c);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlTerminalClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlTerminalClause) listener.enterJqlTerminalClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlTerminalClause) listener.exitJqlTerminalClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlTerminalClause) return visitor.visitJqlTerminalClause(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$93924a205c12d32c extends (0, $6bmaO.ParserRuleContext) {
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
class $372495859d486e54$export$c428f709a58396e5 extends $372495859d486e54$export$93924a205c12d32c {
    jqlEqualsOperator() {
        return this.getRuleContext(0, $372495859d486e54$export$41e475fc1988e413);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsClause) listener.enterJqlEqualsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsClause) listener.exitJqlEqualsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsClause) return visitor.visitJqlEqualsClause(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$1b131204ef9fa33d extends $372495859d486e54$export$93924a205c12d32c {
    jqlLikeOperator() {
        return this.getRuleContext(0, $372495859d486e54$export$b76fe5387fdd7efd);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeClause) listener.enterJqlLikeClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeClause) listener.exitJqlLikeClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeClause) return visitor.visitJqlLikeClause(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$d83706ee80a9852a extends $372495859d486e54$export$93924a205c12d32c {
    jqlComparisonOperator() {
        return this.getRuleContext(0, $372495859d486e54$export$d821da0716b3ec95);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonClause) listener.enterJqlComparisonClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonClause) listener.exitJqlComparisonClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonClause) return visitor.visitJqlComparisonClause(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$2934b8ff22fddd2d extends $372495859d486e54$export$93924a205c12d32c {
    jqlInOperator() {
        return this.getRuleContext(0, $372495859d486e54$export$178478bfa8292f72);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInClause) listener.enterJqlInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInClause) listener.exitJqlInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInClause) return visitor.visitJqlInClause(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$8b84310182afcf93 extends $372495859d486e54$export$93924a205c12d32c {
    jqlIsOperator() {
        return this.getRuleContext(0, $372495859d486e54$export$e64c31d2830b66e4);
    }
    jqlEmpty() {
        return this.getRuleContext(0, $372495859d486e54$export$d85a062f90025e5c);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsClause) listener.enterJqlIsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsClause) listener.exitJqlIsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsClause) return visitor.visitJqlIsClause(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$5df295dc7a2cac7c extends $372495859d486e54$export$93924a205c12d32c {
    jqlWasOperator() {
        return this.getRuleContext(0, $372495859d486e54$export$7e283636700e4a6c);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($372495859d486e54$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $372495859d486e54$export$9fa1e4d63f31b911);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasClause) listener.enterJqlWasClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasClause) listener.exitJqlWasClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasClause) return visitor.visitJqlWasClause(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$9ac3367aee261b32 extends $372495859d486e54$export$93924a205c12d32c {
    jqlWasInOperator() {
        return this.getRuleContext(0, $372495859d486e54$export$b9118b1ed9a78d66);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($372495859d486e54$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $372495859d486e54$export$9fa1e4d63f31b911);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInClause) listener.enterJqlWasInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInClause) listener.exitJqlWasInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInClause) return visitor.visitJqlWasInClause(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$7a7defca8628a13c extends $372495859d486e54$export$93924a205c12d32c {
    jqlChangedOperator() {
        return this.getRuleContext(0, $372495859d486e54$export$493d626ed78ca66);
    }
    jqlChangedPredicate(i) {
        if (i === undefined) return this.getRuleContexts($372495859d486e54$export$e77e479a48133015);
        else return this.getRuleContext(i, $372495859d486e54$export$e77e479a48133015);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedClause) listener.enterJqlChangedClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedClause) listener.exitJqlChangedClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedClause) return visitor.visitJqlChangedClause(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$41e475fc1988e413 extends (0, $6bmaO.ParserRuleContext) {
    EQUALS() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.EQUALS, 0);
    }
    NOT_EQUALS() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.NOT_EQUALS, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlEqualsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsOperator) listener.enterJqlEqualsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsOperator) listener.exitJqlEqualsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsOperator) return visitor.visitJqlEqualsOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$b76fe5387fdd7efd extends (0, $6bmaO.ParserRuleContext) {
    LIKE() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.LIKE, 0);
    }
    NOT_LIKE() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.NOT_LIKE, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlLikeOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeOperator) listener.enterJqlLikeOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeOperator) listener.exitJqlLikeOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeOperator) return visitor.visitJqlLikeOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$d821da0716b3ec95 extends (0, $6bmaO.ParserRuleContext) {
    LT() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.LT, 0);
    }
    GT() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.GT, 0);
    }
    LTEQ() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.LTEQ, 0);
    }
    GTEQ() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.GTEQ, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlComparisonOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonOperator) listener.enterJqlComparisonOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonOperator) listener.exitJqlComparisonOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonOperator) return visitor.visitJqlComparisonOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$178478bfa8292f72 extends (0, $6bmaO.ParserRuleContext) {
    IN() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInOperator) listener.enterJqlInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInOperator) listener.exitJqlInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInOperator) return visitor.visitJqlInOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$e64c31d2830b66e4 extends (0, $6bmaO.ParserRuleContext) {
    IS() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.IS, 0);
    }
    NOT() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlIsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsOperator) listener.enterJqlIsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsOperator) listener.exitJqlIsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsOperator) return visitor.visitJqlIsOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$7e283636700e4a6c extends (0, $6bmaO.ParserRuleContext) {
    WAS() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.WAS, 0);
    }
    NOT() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlWasOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasOperator) listener.enterJqlWasOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasOperator) listener.exitJqlWasOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasOperator) return visitor.visitJqlWasOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$b9118b1ed9a78d66 extends (0, $6bmaO.ParserRuleContext) {
    WAS() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.WAS, 0);
    }
    IN() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlWasInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInOperator) listener.enterJqlWasInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInOperator) listener.exitJqlWasInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInOperator) return visitor.visitJqlWasInOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$493d626ed78ca66 extends (0, $6bmaO.ParserRuleContext) {
    CHANGED() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.CHANGED, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlChangedOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedOperator) listener.enterJqlChangedOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedOperator) listener.exitJqlChangedOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedOperator) return visitor.visitJqlChangedOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$b33300c3d916229a extends (0, $6bmaO.ParserRuleContext) {
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlField;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
class $372495859d486e54$export$11fec15307d2e17b extends $372495859d486e54$export$b33300c3d916229a {
    jqlNumber() {
        return this.getRuleContext(0, $372495859d486e54$export$8737d94a1880e8b3);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumberField) listener.enterJqlNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumberField) listener.exitJqlNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumberField) return visitor.visitJqlNumberField(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$b8b24f99f985ebb3 extends $372495859d486e54$export$b33300c3d916229a {
    jqlString() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$bde73d8ad7c8b71e);
    }
    jqlCustomField() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$401a038855cc5b15);
    }
    jqlFieldProperty(i) {
        if (i === undefined) return this.getRuleContexts($372495859d486e54$export$b02d0b6637ce0593);
        else return this.getRuleContext(i, $372495859d486e54$export$b02d0b6637ce0593);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNonNumberField) listener.enterJqlNonNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNonNumberField) listener.exitJqlNonNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNonNumberField) return visitor.visitJqlNonNumberField(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$b02d0b6637ce0593 extends (0, $6bmaO.ParserRuleContext) {
    LBRACKET() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.LBRACKET, 0);
    }
    RBRACKET() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.RBRACKET, 0);
    }
    jqlPropertyArgument(i) {
        if (i === undefined) return this.getRuleContexts($372495859d486e54$export$e20ce4a2ed16372c);
        else return this.getRuleContext(i, $372495859d486e54$export$e20ce4a2ed16372c);
    }
    jqlArgument() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$a95583953c237f88);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlFieldProperty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFieldProperty) listener.enterJqlFieldProperty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFieldProperty) listener.exitJqlFieldProperty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFieldProperty) return visitor.visitJqlFieldProperty(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$401a038855cc5b15 extends (0, $6bmaO.ParserRuleContext) {
    CUSTOMFIELD() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.CUSTOMFIELD, 0);
    }
    LBRACKET() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.LBRACKET, 0);
    }
    POSNUMBER() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    RBRACKET() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.RBRACKET, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlCustomField;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlCustomField) listener.enterJqlCustomField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlCustomField) listener.exitJqlCustomField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlCustomField) return visitor.visitJqlCustomField(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$bde73d8ad7c8b71e extends (0, $6bmaO.ParserRuleContext) {
    STRING() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.STRING, 0);
    }
    QUOTE_STRING() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.QUOTE_STRING, 0);
    }
    SQUOTE_STRING() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.SQUOTE_STRING, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlString;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlString) listener.enterJqlString(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlString) listener.exitJqlString(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlString) return visitor.visitJqlString(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$8737d94a1880e8b3 extends (0, $6bmaO.ParserRuleContext) {
    POSNUMBER() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    NEGNUMBER() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.NEGNUMBER, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlNumber;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumber) listener.enterJqlNumber(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumber) listener.exitJqlNumber(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumber) return visitor.visitJqlNumber(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$2eaac5a9828bf647 extends (0, $6bmaO.ParserRuleContext) {
    jqlEmpty() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$ebf0cc785e9ee41a);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$9cb97a63f2be4864);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOperand) listener.enterJqlOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOperand) listener.exitJqlOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOperand) return visitor.visitJqlOperand(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$d85a062f90025e5c extends (0, $6bmaO.ParserRuleContext) {
    EMPTY() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.EMPTY, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlEmpty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEmpty) listener.enterJqlEmpty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEmpty) listener.exitJqlEmpty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEmpty) return visitor.visitJqlEmpty(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$2e17d457b0933bec extends (0, $6bmaO.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlValue;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValue) listener.enterJqlValue(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValue) listener.exitJqlValue(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValue) return visitor.visitJqlValue(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$ebf0cc785e9ee41a extends (0, $6bmaO.ParserRuleContext) {
    jqlFunctionName() {
        return this.getRuleContext(0, $372495859d486e54$export$1f5f7ac816788f44);
    }
    LPAREN() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.RPAREN, 0);
    }
    jqlArgumentList() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$83d7c13849b931c3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlFunction;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunction) listener.enterJqlFunction(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunction) listener.exitJqlFunction(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunction) return visitor.visitJqlFunction(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$1f5f7ac816788f44 extends (0, $6bmaO.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlFunctionName;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunctionName) listener.enterJqlFunctionName(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunctionName) listener.exitJqlFunctionName(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunctionName) return visitor.visitJqlFunctionName(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$83d7c13849b931c3 extends (0, $6bmaO.ParserRuleContext) {
    jqlArgument(i) {
        if (i === undefined) return this.getRuleContexts($372495859d486e54$export$a95583953c237f88);
        else return this.getRuleContext(i, $372495859d486e54$export$a95583953c237f88);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($372495859d486e54$export$9c4772e191bdb810.COMMA);
        else return this.getToken($372495859d486e54$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlArgumentList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgumentList) listener.enterJqlArgumentList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgumentList) listener.exitJqlArgumentList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgumentList) return visitor.visitJqlArgumentList(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$9cb97a63f2be4864 extends (0, $6bmaO.ParserRuleContext) {
    jqlListStart() {
        return this.getRuleContext(0, $372495859d486e54$export$c419f717bfc46a5d);
    }
    jqlOperand(i) {
        if (i === undefined) return this.getRuleContexts($372495859d486e54$export$2eaac5a9828bf647);
        else return this.getRuleContext(i, $372495859d486e54$export$2eaac5a9828bf647);
    }
    jqlListEnd() {
        return this.getRuleContext(0, $372495859d486e54$export$f6cd3e372f5ab120);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($372495859d486e54$export$9c4772e191bdb810.COMMA);
        else return this.getToken($372495859d486e54$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlList) listener.enterJqlList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlList) listener.exitJqlList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlList) return visitor.visitJqlList(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$c419f717bfc46a5d extends (0, $6bmaO.ParserRuleContext) {
    LPAREN() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.LPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlListStart;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListStart) listener.enterJqlListStart(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListStart) listener.exitJqlListStart(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListStart) return visitor.visitJqlListStart(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$f6cd3e372f5ab120 extends (0, $6bmaO.ParserRuleContext) {
    RPAREN() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.RPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlListEnd;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListEnd) listener.enterJqlListEnd(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListEnd) listener.exitJqlListEnd(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListEnd) return visitor.visitJqlListEnd(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$e20ce4a2ed16372c extends (0, $6bmaO.ParserRuleContext) {
    jqlArgument() {
        return this.getRuleContext(0, $372495859d486e54$export$a95583953c237f88);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlPropertyArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPropertyArgument) listener.enterJqlPropertyArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPropertyArgument) listener.exitJqlPropertyArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPropertyArgument) return visitor.visitJqlPropertyArgument(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$a95583953c237f88 extends (0, $6bmaO.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgument) listener.enterJqlArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgument) listener.exitJqlArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgument) return visitor.visitJqlArgument(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$9fa1e4d63f31b911 extends (0, $6bmaO.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $372495859d486e54$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$ad402332075c8656);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlWasPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasPredicate) listener.enterJqlWasPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasPredicate) listener.exitJqlWasPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasPredicate) return visitor.visitJqlWasPredicate(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$e77e479a48133015 extends (0, $6bmaO.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $372495859d486e54$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$ad402332075c8656);
    }
    jqlValuePredicateOperator() {
        return this.tryGetRuleContext(0, $372495859d486e54$export$4239d7c0fbafd3f1);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlChangedPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedPredicate) listener.enterJqlChangedPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedPredicate) listener.exitJqlChangedPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedPredicate) return visitor.visitJqlChangedPredicate(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$dc01290aee731418 extends (0, $6bmaO.ParserRuleContext) {
    AFTER() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.AFTER, 0);
    }
    BEFORE() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.BEFORE, 0);
    }
    ON() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.ON, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDatePredicateOperator) listener.enterJqlDatePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDatePredicateOperator) listener.exitJqlDatePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDatePredicateOperator) return visitor.visitJqlDatePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$75412b8b6a6442e1 extends (0, $6bmaO.ParserRuleContext) {
    DURING() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.DURING, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDateRangePredicateOperator) listener.enterJqlDateRangePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDateRangePredicateOperator) listener.exitJqlDateRangePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDateRangePredicateOperator) return visitor.visitJqlDateRangePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$ad402332075c8656 extends (0, $6bmaO.ParserRuleContext) {
    BY() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.BY, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlUserPredicateOperator) listener.enterJqlUserPredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlUserPredicateOperator) listener.exitJqlUserPredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlUserPredicateOperator) return visitor.visitJqlUserPredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$4239d7c0fbafd3f1 extends (0, $6bmaO.ParserRuleContext) {
    FROM() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.FROM, 0);
    }
    TO() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.TO, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValuePredicateOperator) listener.enterJqlValuePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValuePredicateOperator) listener.exitJqlValuePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValuePredicateOperator) return visitor.visitJqlValuePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$6b796c5a4b8c18e extends (0, $6bmaO.ParserRuleContext) {
    jqlOperand() {
        return this.getRuleContext(0, $372495859d486e54$export$2eaac5a9828bf647);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlPredicateOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPredicateOperand) listener.enterJqlPredicateOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPredicateOperand) listener.exitJqlPredicateOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPredicateOperand) return visitor.visitJqlPredicateOperand(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$534469b9c8f44139 extends (0, $6bmaO.ParserRuleContext) {
    ORDER() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.ORDER, 0);
    }
    BY() {
        return this.getToken($372495859d486e54$export$9c4772e191bdb810.BY, 0);
    }
    jqlSearchSort(i) {
        if (i === undefined) return this.getRuleContexts($372495859d486e54$export$c7d8f03f36952a46);
        else return this.getRuleContext(i, $372495859d486e54$export$c7d8f03f36952a46);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($372495859d486e54$export$9c4772e191bdb810.COMMA);
        else return this.getToken($372495859d486e54$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlOrderBy;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrderBy) listener.enterJqlOrderBy(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrderBy) listener.exitJqlOrderBy(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrderBy) return visitor.visitJqlOrderBy(this);
        else return visitor.visitChildren(this);
    }
}
class $372495859d486e54$export$c7d8f03f36952a46 extends (0, $6bmaO.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $372495859d486e54$export$b33300c3d916229a);
    }
    DESC() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.DESC, 0);
    }
    ASC() {
        return this.tryGetToken($372495859d486e54$export$9c4772e191bdb810.ASC, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $372495859d486e54$export$9c4772e191bdb810.RULE_jqlSearchSort;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSearchSort) listener.enterJqlSearchSort(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSearchSort) listener.exitJqlSearchSort(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSearchSort) return visitor.visitJqlSearchSort(this);
        else return visitor.visitChildren(this);
    }
}

});

parcelRegister("l6Oi0", function(module, exports) {

$parcel$export(module.exports, "JastBuilderErrorListener", () => $a4fa8f24e21abeb6$export$d0857f60ff1f385);

var $2e1By = parcelRequire("2e1By");

var $esDZ4 = parcelRequire("esDZ4");
class $a4fa8f24e21abeb6$export$d0857f60ff1f385 {
    constructor(){
        this.errors = [];
        this.syntaxError = (recognizer, offendingSymbol, line, charPositionInLine, msg)=>{
            if (offendingSymbol === undefined) this.errors.push(new (0, $2e1By.JQLParseError)(msg));
            else this.errors.push(new (0, $esDZ4.JQLSyntaxError)(msg, offendingSymbol.startIndex, offendingSymbol.stopIndex + 1, line, charPositionInLine));
        };
    }
}

});
parcelRegister("2e1By", function(module, exports) {

$parcel$export(module.exports, "JQLParseError", () => $c90b94c21c198761$export$e8cfe2b2c93fbd4b);
/**
 * Represents a error occurring when trying to parse JQL into a Jast.
 */ class $c90b94c21c198761$export$e8cfe2b2c93fbd4b extends Error {
    constructor(message, cause){
        super(message);
        this.name = 'JQLParseError';
        this.cause = cause;
        this.description = message;
    }
}

});

parcelRegister("esDZ4", function(module, exports) {

$parcel$export(module.exports, "JQLSyntaxError", () => $a4f5967aecc68ebc$export$3276184116160c41);

var $2e1By = parcelRequire("2e1By");
class $a4f5967aecc68ebc$export$3276184116160c41 extends (0, $2e1By.JQLParseError) {
    constructor(message, start, stop, line, charPositionInLine){
        super(message);
        this.name = 'JQLSyntaxError';
        this.start = start;
        this.stop = stop;
        this.line = line;
        this.charPositionInLine = charPositionInLine;
    }
}

});


parcelRegister("4b2kA", function(module, exports) {

$parcel$export(module.exports, "QueryVisitor", () => $17118715ea7c807e$export$418003b930734805);

var $gjjVy = parcelRequire("gjjVy");

var $4ETjI = parcelRequire("4ETjI");

var $5VlwN = parcelRequire("5VlwN");

var $8gP7A = parcelRequire("8gP7A");
class $17118715ea7c807e$export$418003b930734805 extends (0, $4ETjI.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.whereVisitor = new (0, $8gP7A.WhereVisitor)(this.tokens), this.orderByVisitor = new (0, $5VlwN.OrderByVisitor)(this.tokens), this.visitJqlQuery = (ctx)=>{
            const whereContext = ctx.jqlWhere();
            const orderByContext = ctx.jqlOrderBy();
            return (0, $gjjVy.internalCreators).query(whereContext && whereContext.accept(this.whereVisitor), orderByContext && orderByContext.accept(this.orderByVisitor), (0, $4ETjI.getPositionFromContext)(ctx));
        };
    }
}

});
parcelRegister("4ETjI", function(module, exports) {

$parcel$export(module.exports, "JastBuildingVisitor", () => $8d180dde7fd85200$export$d3c14d7188b09387);
$parcel$export(module.exports, "getPositionFromToken", () => $8d180dde7fd85200$export$85a4e6d858dbc6fb);
$parcel$export(module.exports, "getPositionFromContext", () => $8d180dde7fd85200$export$264629d4cd3cad3f);
$parcel$export(module.exports, "getPositionsFromTerminalNodes", () => $8d180dde7fd85200$export$30d51184879cbaa8);
$parcel$export(module.exports, "normalizeText", () => $8d180dde7fd85200$export$7c2714a5250b9239);
class $8d180dde7fd85200$export$d3c14d7188b09387 {
    constructor(tokens){
        this.tokens = tokens;
    }
    visit(tree) {
        throw new Error('Unsupported operation visit(ParseTree)');
    }
    visitChildren(node) {
        throw new Error('Unsupported operation visitChildren(RuleNode)');
    }
    visitErrorNode(node) {
        throw new Error('Unsupported operation visitErrorNode(ErrorNode)');
    }
    visitTerminal(node) {
        throw new Error('Unsupported operation visitTerminal(TerminalNode)');
    }
}
const $8d180dde7fd85200$export$85a4e6d858dbc6fb = (startToken, stopToken)=>[
        startToken.startIndex,
        (stopToken || startToken).stopIndex + 1
    ];
const $8d180dde7fd85200$export$264629d4cd3cad3f = (ctx)=>[
        ctx.start.startIndex,
        ctx.stop ? ctx.stop.stopIndex + 1 : ctx.start.stopIndex
    ];
const $8d180dde7fd85200$export$30d51184879cbaa8 = (terminalNodes)=>terminalNodes.map((node)=>$8d180dde7fd85200$export$85a4e6d858dbc6fb(node.payload));
const $8d180dde7fd85200$export$7c2714a5250b9239 = (text)=>text.toLowerCase().replace(/\s+/g, ' ');

});

parcelRegister("5VlwN", function(module, exports) {

$parcel$export(module.exports, "OrderByVisitor", () => $f10ffc45b6d3a19a$export$2774b71b99734811);


var $gjjVy = parcelRequire("gjjVy");

var $17jdd = parcelRequire("17jdd");

var $4ETjI = parcelRequire("4ETjI");

var $bJ0YI = parcelRequire("bJ0YI");
class $f10ffc45b6d3a19a$export$2774b71b99734811 extends (0, $4ETjI.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.searchSortVisitor = new $f10ffc45b6d3a19a$var$SearchSortVisitor(this.tokens), this.visitJqlOrderBy = (ctx)=>{
            // If this rule returned due to an exception then the order by operator is incomplete so we should exit early,
            // e.g. 'order '.
            if (ctx.exception) return undefined;
            const operator = (0, $gjjVy.internalCreators).orderByOperator((0, $4ETjI.getPositionFromToken)(ctx.ORDER().payload, ctx.BY().payload));
            const fields = ctx.jqlSearchSort().map((searchSortCtx)=>searchSortCtx.accept(this.searchSortVisitor)).filter((0, $17jdd.notUndefined));
            return (0, $gjjVy.internalCreators).orderBy(fields, operator, (0, $4ETjI.getPositionFromContext)(ctx));
        };
    }
}
class $f10ffc45b6d3a19a$var$SearchSortVisitor extends (0, $4ETjI.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.fieldVisitor = new (0, $bJ0YI.FieldVisitor)(this.tokens), this.visitJqlSearchSort = (ctx)=>{
            const fieldCtx = ctx.jqlField();
            // If the field rule is returned due to an exception then we should ignore this search search rule. This happens
            // when there are no fields following and order by clause, e.g. 'order by '
            if (fieldCtx.exception) return undefined;
            let direction;
            const desc = ctx.DESC();
            const asc = ctx.ASC();
            if (desc !== undefined) direction = (0, $gjjVy.internalCreators).orderByDirection((0, $6aad11c3985b8e7f$export$2ea27ea5f2121899), (0, $4ETjI.getPositionFromToken)(desc.payload));
            else if (asc !== undefined) direction = (0, $gjjVy.internalCreators).orderByDirection((0, $6aad11c3985b8e7f$export$6d60017b9e092e73), (0, $4ETjI.getPositionFromToken)(asc.payload));
            return (0, $gjjVy.internalCreators).orderByField(ctx.jqlField().accept(this.fieldVisitor), direction, (0, $4ETjI.getPositionFromContext)(ctx));
        };
    }
}

});
parcelRegister("17jdd", function(module, exports) {

$parcel$export(module.exports, "notUndefined", () => $e4f9af28a3287abb$export$9a1adf421b69c6a);
/**
 * Type predicate to assert an argument is not undefined.
 */ function $e4f9af28a3287abb$export$9a1adf421b69c6a(x) {
    return x !== undefined;
}

});

parcelRegister("bJ0YI", function(module, exports) {

$parcel$export(module.exports, "FieldVisitor", () => $6fbb4726ef86b159$export$c6a85c4c3bf2317d);

var $gjjVy = parcelRequire("gjjVy");

var $dnVu2 = parcelRequire("dnVu2");

var $4ETjI = parcelRequire("4ETjI");

var $4dxxp = parcelRequire("4dxxp");
class $6fbb4726ef86b159$export$c6a85c4c3bf2317d extends (0, $4ETjI.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $4dxxp.StringVisitor)(this.tokens), this.fieldPropertyVisitor = new $6fbb4726ef86b159$var$FieldPropertyVisitor(this.tokens), this.visitJqlNumberField = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $gjjVy.internalCreators).field(text, text, undefined, (0, $4ETjI.getPositionFromContext)(ctx));
        }, this.visitJqlNonNumberField = (ctx)=>{
            const stringContext = ctx.jqlString();
            const properties = ctx.jqlFieldProperty().map((context)=>context.accept(this.fieldPropertyVisitor));
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $gjjVy.internalCreators).field(stringValue.value, stringValue.text, properties, (0, $4ETjI.getPositionFromContext)(ctx));
            }
            const text = this.tokens.getText(ctx);
            return (0, $gjjVy.internalCreators).field(text, text, properties, (0, $4ETjI.getPositionFromContext)(ctx));
        };
    }
}
class $6fbb4726ef86b159$var$FieldPropertyVisitor extends (0, $4ETjI.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.argumentVisitor = new (0, $dnVu2.ArgumentVisitor)(this.tokens), this.propertyArgumentVisitor = new $6fbb4726ef86b159$var$PropertyArgumentVisitor(this.tokens), this.visitJqlFieldProperty = (ctx)=>{
            const argumentContext = ctx.jqlArgument();
            const propertyArgumentContext = ctx.jqlPropertyArgument();
            const path = propertyArgumentContext.map((context)=>context.accept(this.propertyArgumentVisitor));
            return (0, $gjjVy.internalCreators).property(argumentContext && argumentContext.accept(this.argumentVisitor), path, (0, $4ETjI.getPositionFromContext)(ctx));
        };
    }
}
class $6fbb4726ef86b159$var$PropertyArgumentVisitor extends (0, $4ETjI.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.argumentVisitor = new (0, $dnVu2.ArgumentVisitor)(this.tokens), this.visitJqlPropertyArgument = (ctx)=>{
            return ctx.jqlArgument().accept(this.argumentVisitor);
        };
    }
}

});
parcelRegister("dnVu2", function(module, exports) {

$parcel$export(module.exports, "ArgumentVisitor", () => $e565ecd397426c18$export$46b5a1f6d962d533);

var $gjjVy = parcelRequire("gjjVy");

var $4ETjI = parcelRequire("4ETjI");

var $4dxxp = parcelRequire("4dxxp");
class $e565ecd397426c18$export$46b5a1f6d962d533 extends (0, $4ETjI.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $4dxxp.StringVisitor)(this.tokens), this.visitJqlArgument = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $gjjVy.internalCreators).argument(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $gjjVy.internalCreators).argument(text, text, (0, $4ETjI.getPositionFromContext)(ctx));
            }
        };
    }
}

});
parcelRegister("4dxxp", function(module, exports) {

$parcel$export(module.exports, "StringVisitor", () => $cb02aaa9f2edffcf$export$617850cb96304515);

var $4ETjI = parcelRequire("4ETjI");
class $cb02aaa9f2edffcf$export$617850cb96304515 extends (0, $4ETjI.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.visitJqlString = (ctx)=>{
            const text = this.tokens.getText(ctx);
            const position = (0, $4ETjI.getPositionFromContext)(ctx);
            let value;
            if (ctx.QUOTE_STRING()) value = text.replace(/^"|"$/g, '').replace(/(?:\\(.))/g, '$1');
            else if (ctx.SQUOTE_STRING()) value = text.replace(/^'|'$/g, '').replace(/(?:\\(.))/g, '$1');
            else // unquoted string
            value = text;
            return {
                text: text,
                value: value,
                position: position
            };
        };
    }
}

});




parcelRegister("8gP7A", function(module, exports) {

$parcel$export(module.exports, "WhereVisitor", () => $02e7f75b3bf11062$export$c573472f1d20e15d);


var $gjjVy = parcelRequire("gjjVy");

var $17jdd = parcelRequire("17jdd");

var $4ETjI = parcelRequire("4ETjI");

var $1Nk6n = parcelRequire("1Nk6n");
class $02e7f75b3bf11062$export$c573472f1d20e15d extends (0, $4ETjI.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.terminalClauseVisitor = new (0, $1Nk6n.TerminalClauseVisitor)(this.tokens), this.visitJqlWhere = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        }, this.visitJqlOrClause = (ctx)=>{
            const clauses = ctx.jqlAndClause().map((andClauseContext)=>andClauseContext.accept(this)).filter((0, $17jdd.notUndefined));
            if (clauses.length > 1) {
                const operator = (0, $gjjVy.internalCreators).compoundOperator((0, $ed890f3e326c0985$export$7b8f0a728d79a753), (0, $4ETjI.getPositionsFromTerminalNodes)(ctx.OR()));
                return (0, $gjjVy.internalCreators).compoundClause(operator, clauses, (0, $4ETjI.getPositionFromContext)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        }, this.visitJqlAndClause = (ctx)=>{
            const clauses = ctx.jqlNotClause().map((notClauseContext)=>notClauseContext.accept(this)).filter((0, $17jdd.notUndefined));
            if (clauses.length > 1) {
                const operator = (0, $gjjVy.internalCreators).compoundOperator((0, $ed890f3e326c0985$export$6d6d48d210d3ca97), (0, $4ETjI.getPositionsFromTerminalNodes)(ctx.AND()));
                return (0, $gjjVy.internalCreators).compoundClause(operator, clauses, (0, $4ETjI.getPositionFromContext)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        }, this.visitJqlNotClause = (ctx)=>{
            const notClauseContext = ctx.jqlNotClause();
            const subClauseContext = ctx.jqlSubClause();
            const terminalClauseContext = ctx.jqlTerminalClause();
            let clause;
            if (notClauseContext !== undefined) clause = notClauseContext.accept(this) || undefined;
            else if (subClauseContext !== undefined) clause = subClauseContext.accept(this) || undefined;
            else if (terminalClauseContext !== undefined) clause = terminalClauseContext.accept(this.terminalClauseVisitor);
            // Our token can be either NOT or !
            let notToken = ctx.NOT();
            notToken = notToken === undefined ? ctx.BANG() : notToken;
            if (notToken && clause) return (0, $gjjVy.internalCreators).notClause(clause, (0, $gjjVy.internalCreators).notClauseOperator((0, $4ETjI.getPositionFromToken)(notToken.payload)), (0, $4ETjI.getPositionFromContext)(ctx));
            return clause;
        }, this.visitJqlSubClause = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        };
    }
}

});
parcelRegister("1Nk6n", function(module, exports) {

$parcel$export(module.exports, "TerminalClauseVisitor", () => $72a0a5c962228563$export$14576ae5bd1874a9);

var $gjjVy = parcelRequire("gjjVy");

var $17jdd = parcelRequire("17jdd");

var $4ETjI = parcelRequire("4ETjI");

var $bJ0YI = parcelRequire("bJ0YI");

var $2abjw = parcelRequire("2abjw");

var $5v11K = parcelRequire("5v11K");

var $2Br6l = parcelRequire("2Br6l");
class $72a0a5c962228563$export$14576ae5bd1874a9 extends (0, $4ETjI.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.fieldVisitor = new (0, $bJ0YI.FieldVisitor)(this.tokens), this.terminalClauseRhsVisitor = new $72a0a5c962228563$var$TerminalClauseRhsVisitor(this.tokens), this.visitJqlTerminalClause = (ctx)=>{
            const field = ctx.jqlField().accept(this.fieldVisitor);
            const { operator: operator, operand: operand, predicates: predicates } = ctx.jqlTerminalClauseRhs().accept(this.terminalClauseRhsVisitor);
            const position = (0, $4ETjI.getPositionFromContext)(ctx);
            return (0, $gjjVy.internalCreators).terminalClause(field, operator, operand, predicates, position);
        };
    }
}
class $72a0a5c962228563$var$TerminalClauseRhsVisitor extends (0, $4ETjI.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.operatorVisitor = new (0, $5v11K.OperatorVisitor)(this.tokens), this.terminalClauseOperandVisitor = new $72a0a5c962228563$var$TerminalClauseOperandVisitor(this.tokens), this.predicateVisitor = new (0, $2Br6l.PredicateVisitor)(this.tokens), this.visitJqlEqualsClause = (ctx)=>{
            const operator = ctx.jqlEqualsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlLikeClause = (ctx)=>{
            const operator = ctx.jqlLikeOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlComparisonClause = (ctx)=>{
            const operator = ctx.jqlComparisonOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlInClause = (ctx)=>{
            const operator = ctx.jqlInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlIsClause = (ctx)=>{
            const operator = ctx.jqlIsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        }, this.visitJqlWasClause = (ctx)=>{
            const operator = ctx.jqlWasOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $17jdd.notUndefined));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        }, this.visitJqlWasInClause = (ctx)=>{
            const operator = ctx.jqlWasInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $17jdd.notUndefined));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        }, this.visitJqlChangedClause = (ctx)=>{
            const operator = ctx.jqlChangedOperator().accept(this.operatorVisitor);
            const predicates = ctx.jqlChangedPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $17jdd.notUndefined));
            return {
                operator: operator,
                operand: undefined,
                predicates: predicates
            };
        }, // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const operator = node.accept(this.operatorVisitor);
            return {
                operator: operator,
                operand: undefined,
                predicates: []
            };
        };
    }
}
class $72a0a5c962228563$var$TerminalClauseOperandVisitor extends (0, $4ETjI.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.operandVisitor = new (0, $2abjw.OperandVisitor)(this.tokens), this.visitJqlEqualsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlLikeClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlComparisonClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlIsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty()
            ]);
        }, this.visitJqlWasClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        }, this.visitJqlWasInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        }, this.getOperandForContexts = (contexts)=>{
            const operandContext = contexts.find((0, $17jdd.notUndefined));
            return operandContext?.accept(this.operandVisitor);
        };
    }
}

});
parcelRegister("2abjw", function(module, exports) {

$parcel$export(module.exports, "OperandVisitor", () => $ba3ab2a4b971fbe9$export$ef8ae1aa15d9c9af);


var $gjjVy = parcelRequire("gjjVy");

var $17jdd = parcelRequire("17jdd");

var $dnVu2 = parcelRequire("dnVu2");

var $4ETjI = parcelRequire("4ETjI");

var $dVu3O = parcelRequire("dVu3O");

var $4dxxp = parcelRequire("4dxxp");
class $ba3ab2a4b971fbe9$export$ef8ae1aa15d9c9af extends (0, $4ETjI.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $4dxxp.StringVisitor)(this.tokens), this.numberVisitor = new (0, $dVu3O.NumberVisitor)(this.tokens), this.functionNameVisitor = new $ba3ab2a4b971fbe9$var$FunctionNameVisitor(this.tokens), this.argumentListVisitor = new $ba3ab2a4b971fbe9$var$ArgumentListVisitor(this.tokens), this.visitJqlOperand = (ctx)=>{
            const operandContext = [
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlList(),
                ctx.jqlFunction()
            ].find((0, $17jdd.notUndefined));
            return operandContext?.accept(this);
        }, this.visitJqlEmpty = (ctx)=>{
            // ANTLR will optimistically create a jqlEmpty node in some situations where user input doesn't match the EMPTY
            // token, e.g. when using value operands in IS clauses ("field is value"), where EMPTY is the only valid operand.
            if (ctx.exception) return undefined;
            return (0, $gjjVy.internalCreators).keywordOperand((0, $96a349542da5e08d$export$1c46dca02aac24dd), (0, $4ETjI.getPositionFromToken)(ctx.EMPTY().payload));
        }, this.visitJqlValue = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $gjjVy.internalCreators).valueOperand(stringValue.value, stringValue.text, stringValue.position);
            }
            const numberContext = ctx.jqlNumber();
            if (numberContext !== undefined) return numberContext.accept(this.numberVisitor);
        }, this.visitJqlList = (ctx)=>{
            const values = ctx.jqlOperand().map((operandCtx)=>operandCtx.accept(this)).filter((0, $17jdd.notUndefined));
            return (0, $gjjVy.internalCreators).listOperand(values, (0, $4ETjI.getPositionFromContext)(ctx));
        }, this.visitJqlFunction = (ctx)=>{
            const argumentListContext = ctx.jqlArgumentList();
            return (0, $gjjVy.internalCreators).functionOperand(ctx.jqlFunctionName().accept(this.functionNameVisitor), argumentListContext === undefined ? [] : argumentListContext.accept(this.argumentListVisitor), (0, $4ETjI.getPositionFromContext)(ctx));
        };
    }
}
class $ba3ab2a4b971fbe9$var$FunctionNameVisitor extends (0, $4ETjI.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.stringVisitor = new (0, $4dxxp.StringVisitor)(this.tokens), this.visitJqlFunctionName = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $gjjVy.internalCreators).functionString(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $gjjVy.internalCreators).functionString(text, text, (0, $4ETjI.getPositionFromContext)(ctx));
            }
        };
    }
}
class $ba3ab2a4b971fbe9$var$ArgumentListVisitor extends (0, $4ETjI.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.argumentVisitor = new (0, $dnVu2.ArgumentVisitor)(this.tokens), this.visitJqlArgumentList = (ctx)=>{
            return ctx.jqlArgument().map((argumentCtx)=>argumentCtx.accept(this.argumentVisitor));
        };
    }
}

});
parcelRegister("dVu3O", function(module, exports) {

$parcel$export(module.exports, "NumberVisitor", () => $7103e65efb427cf6$export$a55432f0884633e4);

var $gjjVy = parcelRequire("gjjVy");

var $4ETjI = parcelRequire("4ETjI");
class $7103e65efb427cf6$export$a55432f0884633e4 extends (0, $4ETjI.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.visitJqlNumber = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $gjjVy.internalCreators).valueOperand(text, text, (0, $4ETjI.getPositionFromContext)(ctx));
        };
    }
}

});


parcelRegister("5v11K", function(module, exports) {

$parcel$export(module.exports, "OperatorVisitor", () => $414532546edc8272$export$e56f89ba95b51d2a);

var $gjjVy = parcelRequire("gjjVy");

var $hBeYS = parcelRequire("hBeYS");

var $4ETjI = parcelRequire("4ETjI");
class $414532546edc8272$export$e56f89ba95b51d2a extends (0, $4ETjI.JastBuildingVisitor) {
    visitJqlEqualsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $hBeYS.isEqualsOperator)(text)) throw new Error(`'${text}' does not match any of the recognised equals operators`);
        return (0, $gjjVy.internalCreators).operator(text, text, (0, $4ETjI.getPositionFromContext)(ctx));
    }
    visitJqlLikeOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $hBeYS.isLikeOperator)(text)) throw new Error(`'${text}' does not match any of the recognised like operators`);
        return (0, $gjjVy.internalCreators).operator(text, text, (0, $4ETjI.getPositionFromContext)(ctx));
    }
    visitJqlComparisonOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $hBeYS.isComparisonOperator)(text)) throw new Error(`'${text}' does not match any of the recognised comparison operators`);
        return (0, $gjjVy.internalCreators).operator(text, text, (0, $4ETjI.getPositionFromContext)(ctx));
    }
    visitJqlInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $4ETjI.normalizeText)(text);
        if (!(0, $hBeYS.isInOperator)(value)) // This can happen if an incomplete operator is used, e.g. `status not open`.
        return undefined;
        return (0, $gjjVy.internalCreators).operator(value, text, (0, $4ETjI.getPositionFromContext)(ctx));
    }
    visitJqlIsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $4ETjI.normalizeText)(text);
        if (!(0, $hBeYS.isIsOperator)(value)) throw new Error(`'${text}' does not match any of the recognised is operators`);
        return (0, $gjjVy.internalCreators).operator(value, text, (0, $4ETjI.getPositionFromContext)(ctx));
    }
    visitJqlWasOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $4ETjI.normalizeText)(text);
        if (!(0, $hBeYS.isWasOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was operators`);
        return (0, $gjjVy.internalCreators).operator(value, text, (0, $4ETjI.getPositionFromContext)(ctx));
    }
    visitJqlWasInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $4ETjI.normalizeText)(text);
        if (!(0, $hBeYS.isWasInOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was in operators`);
        return (0, $gjjVy.internalCreators).operator(value, text, (0, $4ETjI.getPositionFromContext)(ctx));
    }
    visitJqlChangedOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $4ETjI.normalizeText)(text);
        if (!(0, $hBeYS.isChangedOperator)(value)) throw new Error(`'${text}' does not match any of the recognised changed operators`);
        return (0, $gjjVy.internalCreators).operator(value, text, (0, $4ETjI.getPositionFromContext)(ctx));
    }
    constructor(...args){
        super(...args), // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const { sourceInterval: sourceInterval } = node;
            const text = this.tokens.getText(sourceInterval);
            if (text) {
                const value = (0, $4ETjI.normalizeText)(text);
                const { a: startIndex, b: stopIndex } = sourceInterval;
                const startToken = this.tokens.get(startIndex);
                const stopToken = this.tokens.get(stopIndex);
                const position = (0, $4ETjI.getPositionFromToken)(startToken, stopToken);
                if ((0, $hBeYS.isOperator)(value)) return (0, $gjjVy.internalCreators).operator(value, text, position);
            }
        };
    }
}

});
parcelRegister("hBeYS", function(module, exports) {

$parcel$export(module.exports, "isOperator", () => $14f688be1248e09a$export$4e40859592ee7ac2);
$parcel$export(module.exports, "isEqualsOperator", () => $14f688be1248e09a$export$6d0fc196fa8a1673);
$parcel$export(module.exports, "isLikeOperator", () => $14f688be1248e09a$export$ad91b6d6a89cb64e);
$parcel$export(module.exports, "isComparisonOperator", () => $14f688be1248e09a$export$4477c442bd5c2a6d);
$parcel$export(module.exports, "isInOperator", () => $14f688be1248e09a$export$c5e1cdef30e30bff);
$parcel$export(module.exports, "isIsOperator", () => $14f688be1248e09a$export$ccc3334744e395c7);
$parcel$export(module.exports, "isWasOperator", () => $14f688be1248e09a$export$2b1c5d7e7856f91d);
$parcel$export(module.exports, "isWasInOperator", () => $14f688be1248e09a$export$55d8c9b20d99509f);
$parcel$export(module.exports, "isChangedOperator", () => $14f688be1248e09a$export$b65d23d23ade534b);
$parcel$export(module.exports, "isListOperator", () => $14f688be1248e09a$export$b09522e4061bbdd6);

var $3jFAr = parcelRequire("3jFAr");
const $14f688be1248e09a$export$4e40859592ee7ac2 = (operator)=>(0, $3jFAr.OPERATORS).includes(operator);
const $14f688be1248e09a$export$6d0fc196fa8a1673 = (operator)=>(0, $3jFAr.EQUALS_OPERATORS).includes(operator);
const $14f688be1248e09a$export$ad91b6d6a89cb64e = (operator)=>(0, $3jFAr.LIKE_OPERATORS).includes(operator);
const $14f688be1248e09a$export$4477c442bd5c2a6d = (operator)=>(0, $3jFAr.COMPARISON_OPERATORS).includes(operator);
const $14f688be1248e09a$export$c5e1cdef30e30bff = (operator)=>(0, $3jFAr.IN_OPERATORS).includes(operator);
const $14f688be1248e09a$export$ccc3334744e395c7 = (operator)=>(0, $3jFAr.IS_OPERATORS).includes(operator);
const $14f688be1248e09a$export$2b1c5d7e7856f91d = (operator)=>(0, $3jFAr.WAS_OPERATORS).includes(operator);
const $14f688be1248e09a$export$55d8c9b20d99509f = (operator)=>(0, $3jFAr.WAS_IN_OPERATORS).includes(operator);
const $14f688be1248e09a$export$b65d23d23ade534b = (operator)=>(0, $3jFAr.CHANGED_OPERATORS).includes(operator);
const $14f688be1248e09a$export$b09522e4061bbdd6 = (operator)=>(0, $3jFAr.LIST_OPERATORS).includes(operator);

});


parcelRegister("2Br6l", function(module, exports) {

$parcel$export(module.exports, "PredicateVisitor", () => $d63eedf5681b9215$export$33bb52a35c693109);

var $gjjVy = parcelRequire("gjjVy");

var $lejmH = parcelRequire("lejmH");

var $17jdd = parcelRequire("17jdd");

var $4ETjI = parcelRequire("4ETjI");

var $2abjw = parcelRequire("2abjw");
class $d63eedf5681b9215$export$33bb52a35c693109 extends (0, $4ETjI.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.predicateOperatorVisitor = new $d63eedf5681b9215$var$PredicateOperatorVisitor(this.tokens), this.predicateOperandVisitor = new $d63eedf5681b9215$var$PredicateOperandVisitor(this.tokens), this.visitJqlWasPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $4ETjI.getPositionFromContext)(ctx);
            return (0, $gjjVy.internalCreators).predicate(operator, operand, position);
        }, this.visitJqlChangedPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator(),
                ctx.jqlValuePredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $4ETjI.getPositionFromContext)(ctx);
            return (0, $gjjVy.internalCreators).predicate(operator, operand, position);
        }, this.getOperatorForContexts = (contexts)=>{
            const operatorContext = contexts.find((0, $17jdd.notUndefined));
            if (operatorContext !== undefined) return operatorContext.accept(this.predicateOperatorVisitor);
            else throw new Error('Undefined predicate operator context');
        };
    }
}
class $d63eedf5681b9215$var$PredicateOperatorVisitor extends (0, $4ETjI.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.visitJqlDatePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.visitJqlDateRangePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.visitJqlUserPredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.visitJqlValuePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        }, this.getPredicateOperator = (ctx)=>{
            const text = this.tokens.getText(ctx);
            // Replace consecutive whitespace chars with single space
            const value = text.toLowerCase().replace(/\s+/g, ' ');
            if (!(0, $lejmH.isPredicateOperator)(value)) throw new Error(`Found a history predicate operator which does not map to a changed time predicate operator in the ast: ${text}`);
            return (0, $gjjVy.internalCreators).predicateOperator(value, text, (0, $4ETjI.getPositionFromContext)(ctx));
        };
    }
}
class $d63eedf5681b9215$var$PredicateOperandVisitor extends (0, $4ETjI.JastBuildingVisitor) {
    constructor(...args){
        super(...args), this.operandVisitor = new (0, $2abjw.OperandVisitor)(this.tokens), this.visitJqlPredicateOperand = (ctx)=>{
            return ctx.jqlOperand().accept(this.operandVisitor);
        };
    }
}

});
parcelRegister("lejmH", function(module, exports) {

$parcel$export(module.exports, "isPredicateOperator", () => $c9bdbec99653f162$export$188978ad94919403);

var $5jQ2v = parcelRequire("5jQ2v");
const $c9bdbec99653f162$export$188978ad94919403 = (operator)=>(0, $5jQ2v.PREDICATE_OPERATORS).includes(operator);

});
parcelRegister("5jQ2v", function(module, exports) {

$parcel$export(module.exports, "PREDICATE_OPERATORS", () => $23876d25dd0afa1a$export$e200440af9f1d9f);
const $23876d25dd0afa1a$export$3d56e2ae1b4bbbf9 = 'after';
const $23876d25dd0afa1a$export$f0a816341603bb63 = 'before';
const $23876d25dd0afa1a$export$cdc81c84f768d513 = 'by';
const $23876d25dd0afa1a$export$8a5280c65e704c3d = 'during';
const $23876d25dd0afa1a$export$71f882dcac65f97a = 'from';
const $23876d25dd0afa1a$export$5685a35c6b0a7ee8 = 'on';
const $23876d25dd0afa1a$export$5a83c4789e531a = 'to';
const $23876d25dd0afa1a$export$e200440af9f1d9f = [
    $23876d25dd0afa1a$export$3d56e2ae1b4bbbf9,
    $23876d25dd0afa1a$export$f0a816341603bb63,
    $23876d25dd0afa1a$export$cdc81c84f768d513,
    $23876d25dd0afa1a$export$8a5280c65e704c3d,
    $23876d25dd0afa1a$export$71f882dcac65f97a,
    $23876d25dd0afa1a$export$5685a35c6b0a7ee8,
    $23876d25dd0afa1a$export$5a83c4789e531a
];

});







parcelRegister("9Dyrx", function(module, exports) {

$parcel$export(module.exports, "print", () => $4358ff2e217faf99$export$c2d084dc44961371);

var $3NMrl = parcelRequire("3NMrl");

var $cnmJ6 = parcelRequire("cnmJ6");

var $4vJ58 = parcelRequire("4vJ58");
const $4358ff2e217faf99$export$c2d084dc44961371 = (jast, options = {})=>{
    return (0, $4vJ58.printDocToString)((0, $cnmJ6.printAstToDoc)(jast, (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(options, [
        'operatorCase'
    ])), (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(options, [
        'printWidth'
    ]));
};

});
parcelRegister("cnmJ6", function(module, exports) {

$parcel$export(module.exports, "printAstToDoc", () => $21d061f8a030d176$export$f0ef38932978952);


var $92zfQ = parcelRequire("92zfQ");

var $iR1in = parcelRequire("iR1in");
const $21d061f8a030d176$var$formatOperator = (operator, operatorCase)=>{
    switch(operatorCase){
        case 'lower':
            return operator.toLowerCase();
        case 'upper':
            return operator.toUpperCase();
        case 'preserve':
            return operator;
    }
};
class $21d061f8a030d176$export$27a275559a5c8102 extends (0, $92zfQ.AbstractJastVisitor) {
    constructor({ operatorCase: operatorCase } = {}){
        super();
        this.operatorCase = operatorCase || 'preserve';
    }
    visitArgument(argument) {
        return argument.text;
    }
    /**
	 * Visit each of the provided nodes and form a new array with each `Doc` joined by the provided separator.
	 */ joinNodes(nodes, separator) {
        const docs = [];
        nodes.forEach((node)=>{
            if (separator !== undefined && docs.length > 0) docs.push(separator);
            docs.push(node.accept(this));
        });
        return docs;
    }
    visitCompoundClause(compoundClause) {
        const operatorDoc = compoundClause.operator.accept(this);
        const clauseDocs = [];
        compoundClause.clauses.forEach((clause)=>{
            if (clauseDocs.length > 0) clauseDocs.push((0, $iR1in.ifBreak)((0, $iR1in.newLine)(), ' '), operatorDoc, ' ');
            // Wrap nested compound clauses in parentheses
            if (clause.clauseType === (0, $64e15c988a7f27d3$export$7a58b23488ea076b)) clauseDocs.push('(', clause.accept(this), ')');
            else clauseDocs.push(clause.accept(this));
        });
        return (0, $iR1in.group)(clauseDocs);
    }
    visitCompoundOperator(compoundOperator) {
        return $21d061f8a030d176$var$formatOperator(compoundOperator.value, this.operatorCase);
    }
    visitField(field) {
        const propertyDocs = field.properties ? this.joinNodes(field.properties) : [];
        return (0, $iR1in.group)([
            field.text,
            ...propertyDocs
        ]);
    }
    visitFunction(functionString) {
        return functionString.text;
    }
    visitFunctionOperand(functionOperand) {
        const argumentDocs = this.joinNodes(functionOperand.arguments, ', ');
        return (0, $iR1in.group)([
            functionOperand.function.accept(this),
            '(',
            ...argumentDocs,
            ')'
        ]);
    }
    visitKeywordOperand(keywordOperand) {
        return keywordOperand.value;
    }
    visitListOperand(listOperand) {
        const operandDocs = this.joinNodes(listOperand.values, ', ');
        return (0, $iR1in.group)([
            '(',
            ...operandDocs,
            ')'
        ]);
    }
    visitOperator(operator) {
        return $21d061f8a030d176$var$formatOperator(operator.text, this.operatorCase);
    }
    visitOrderBy(orderBy) {
        const fieldDocs = this.joinNodes(orderBy.fields, ', ');
        return (0, $iR1in.group)([
            orderBy.operator.accept(this),
            ' ',
            ...fieldDocs
        ]);
    }
    visitOrderByDirection(orderByDirection) {
        return orderByDirection.value;
    }
    visitOrderByField(orderByField) {
        const docs = [
            orderByField.field.accept(this)
        ];
        if (orderByField.direction) docs.push(' ', orderByField.direction.accept(this));
        return (0, $iR1in.group)(docs);
    }
    visitOrderByOperator(orderByOperator) {
        return $21d061f8a030d176$var$formatOperator(orderByOperator.value, this.operatorCase);
    }
    visitPredicate(predicate) {
        const docs = [
            predicate.operator.accept(this)
        ];
        if (predicate.operand) docs.push(' ', predicate.operand.accept(this));
        return (0, $iR1in.group)(docs);
    }
    visitPredicateOperator(predicateOperator) {
        return $21d061f8a030d176$var$formatOperator(predicateOperator.text, this.operatorCase);
    }
    visitProperty(property) {
        const docs = [];
        if (property.key) docs.push('[', property.key.accept(this), ']');
        if (property.path) {
            const pathDocs = this.joinNodes(property.path, ' ');
            docs.push(...pathDocs);
        }
        return (0, $iR1in.group)(docs);
    }
    visitQuery(query) {
        if (query.where && query.orderBy) return (0, $iR1in.group)([
            query.where.accept(this),
            (0, $iR1in.ifBreak)((0, $iR1in.newLine)(), ' '),
            query.orderBy.accept(this)
        ]);
        else if (query.where) return query.where.accept(this);
        else if (query.orderBy) return query.orderBy.accept(this);
        return '';
    }
    visitTerminalClause(terminalClause) {
        const docs = [
            terminalClause.field.accept(this)
        ];
        if (terminalClause.operator) docs.push(' ', terminalClause.operator.accept(this));
        if (terminalClause.operand) docs.push(' ', terminalClause.operand.accept(this));
        terminalClause.predicates.forEach((predicate)=>{
            docs.push(' ', predicate.accept(this));
        });
        return (0, $iR1in.group)(docs);
    }
    visitValueOperand(valueOperand) {
        return valueOperand.text;
    }
    visitNotClause(notClause) {
        const clauseDocs = [];
        // Wrap nested compound clauses in parentheses
        if (notClause.clause.clauseType === (0, $64e15c988a7f27d3$export$7a58b23488ea076b)) clauseDocs.push('(', notClause.clause.accept(this), ')');
        else clauseDocs.push(notClause.clause.accept(this));
        return (0, $iR1in.group)([
            notClause.operator.accept(this),
            ' ',
            ...clauseDocs
        ]);
    }
    visitNotClauseOperator(notClauseOperator) {
        return notClauseOperator.value;
    }
    visitChildren() {
        throw new Error('Required visit method not implemented for node');
    }
    defaultResult() {
        return '';
    }
}
const $21d061f8a030d176$export$f0ef38932978952 = (jast, options)=>{
    const astToDocVisitor = new $21d061f8a030d176$export$27a275559a5c8102(options);
    return jast.query ? jast.query.accept(astToDocVisitor) : '';
};

});
parcelRegister("92zfQ", function(module, exports) {

$parcel$export(module.exports, "AbstractJastVisitor", () => $2d6b6d4029465c4b$export$51be62b46ee668fd);
class $2d6b6d4029465c4b$export$51be62b46ee668fd {
    /**
	 * The default implementation calls AstNode#accept on the specified node.
	 * @param node
	 */ visit(node) {
        return node.accept(this);
    }
    /**
	 * The default implementation initializes the aggregate result to defaultResult(). Before visiting each child, it
	 * calls shouldVisitNextChild; if the result is false no more children are visited and the current aggregate result is
	 * returned. After visiting a child, the aggregate result is updated by calling aggregateResult with the previous
	 * aggregate result and the result of visiting the child.
	 */ visitChildren(node) {
        let result = this.defaultResult();
        const children = node.getChildren();
        for(let i = 0; i < children.length; i++){
            if (!this.shouldVisitNextChild(node, result)) break;
            const childResult = children[i].accept(this);
            result = this.aggregateResult(result, childResult);
        }
        return result;
    }
    /**
	 * Aggregates the results of visiting multiple children of a node.
	 *
	 * The default implementation returns `nextResult`, meaning
	 * {@link #visitChildren} will return the result of the last child visited
	 * (or return the initial value if the node has no children).
	 *
	 * @param aggregate The previous aggregate value. In the default
	 * implementation, the aggregate value is initialized to
	 * {@link #defaultResult}, which is passed as the `aggregate` argument
	 * to this method after the first child node is visited.
	 * @param nextResult The result of the immediately preceeding call to visit
	 * a child node.
	 *
	 * @returns The updated aggregate result.
	 */ aggregateResult(aggregate, nextResult) {
        return nextResult;
    }
    /**
	 * This method is called before visiting each child in
	 * {@link #visitChildren}. When the method is first called\ `currentResult`
	 * will be the initial value (in the default implementation, the initial value
	 * is returned by a call to {@link #defaultResult}).
	 *
	 * The default implementation always returns `true`, indicating that
	 * `visitChildren` should only return after all children are visited.
	 * One reason to override this method is to provide a "short circuit"
	 * evaluation option for situations where the result of visiting a single
	 * child has the potential to determine the result of the visit operation as
	 * a whole.
	 *
	 * @param node The {@link AstNode} whose children are currently being
	 * visited.
	 * @param currentResult The current aggregate result of the children visited
	 * to the current point.
	 *
	 * @returns `true` to continue visiting children. Otherwise return
	 * `false` to stop visiting children and immediately return the
	 * current aggregate result from {@link #visitChildren}.
	 */ shouldVisitNextChild(node, currentResult) {
        return true;
    }
}

});

parcelRegister("iR1in", function(module, exports) {

$parcel$export(module.exports, "group", () => $87d1df8c2f1b7626$export$e5e25fbcc1f7affe);
$parcel$export(module.exports, "ifBreak", () => $87d1df8c2f1b7626$export$1db8e61901dcb0fa);
$parcel$export(module.exports, "newLine", () => $87d1df8c2f1b7626$export$dc84f6841f96b7da);
const $87d1df8c2f1b7626$export$e5e25fbcc1f7affe = (contents)=>{
    return {
        type: 'group',
        contents: contents
    };
};
const $87d1df8c2f1b7626$export$1db8e61901dcb0fa = (breakContents, flatContents)=>{
    return {
        type: 'if-break',
        breakContents: breakContents,
        flatContents: flatContents
    };
};
const $87d1df8c2f1b7626$export$dc84f6841f96b7da = ()=>{
    return {
        type: 'new-line'
    };
};

});


parcelRegister("4vJ58", function(module, exports) {

$parcel$export(module.exports, "printDocToString", () => $23448d3ac2dbc739$export$316fc7e94b95b118);
const $23448d3ac2dbc739$var$computeFlatWidth = (doc)=>{
    if (typeof doc === 'string') return doc.length;
    if (Array.isArray(doc)) return doc.reduce((result, innerDoc)=>result + $23448d3ac2dbc739$var$computeFlatWidth(innerDoc), 0);
    switch(doc.type){
        case 'group':
            return $23448d3ac2dbc739$var$computeFlatWidth(doc.contents);
        case 'if-break':
            return $23448d3ac2dbc739$var$computeFlatWidth(doc.flatContents);
        case 'new-line':
            // TODO This probably represents a bug as we don't expect new lines in the flat path
            return 0;
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $23448d3ac2dbc739$var$printDoc = (doc, context)=>{
    if (typeof doc === 'string') return {
        result: doc,
        endIndex: context.startIndex + doc.length
    };
    switch(doc.type){
        case 'group':
            return $23448d3ac2dbc739$var$printGroup(doc, context);
        case 'if-break':
            return $23448d3ac2dbc739$var$printIfBreak(doc, context);
        case 'new-line':
            return $23448d3ac2dbc739$var$printNewLine();
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $23448d3ac2dbc739$var$printGroup = (doc, context)=>{
    const docWidth = context.startIndex + $23448d3ac2dbc739$var$computeFlatWidth(doc);
    const breakContents = context.printWidth !== null && docWidth > context.printWidth;
    return doc.contents.reduce((agg, innerDoc)=>{
        const innerContext = {
            ...context,
            startIndex: agg.endIndex,
            breakContents: breakContents
        };
        const output = $23448d3ac2dbc739$var$printDoc(innerDoc, innerContext);
        return {
            result: agg.result + output.result,
            endIndex: output.endIndex
        };
    }, {
        result: '',
        endIndex: context.startIndex
    });
};
const $23448d3ac2dbc739$var$printIfBreak = (doc, context)=>{
    if (context.breakContents) return $23448d3ac2dbc739$var$printDoc(doc.breakContents, context);
    return $23448d3ac2dbc739$var$printDoc(doc.flatContents, context);
};
const $23448d3ac2dbc739$var$printNewLine = ()=>{
    return {
        result: '\n',
        // Reset our end index as a new line is being output.
        endIndex: 0
    };
};
// TODO Tweak this number with design
const $23448d3ac2dbc739$var$defaultPrintWidth = 100;
const $23448d3ac2dbc739$export$316fc7e94b95b118 = (doc, options = {})=>{
    const { printWidth: printWidth = $23448d3ac2dbc739$var$defaultPrintWidth } = options;
    const output = $23448d3ac2dbc739$var$printDoc(doc, {
        printWidth: printWidth,
        startIndex: 0,
        breakContents: false
    });
    return output.result;
};

});



parcelRegister("1qdF0", function(module, exports) {

$parcel$export(module.exports, "CollectionsContainer", () => $1eef7de227d1974d$export$80cb348e37947c6a);
$parcel$export(module.exports, "useCollectionsActions", () => $1eef7de227d1974d$export$ba61932a631ba139);
$parcel$export(module.exports, "useCollectionsOwnersIds", () => $1eef7de227d1974d$export$47ee56d816ebfe18);
$parcel$export(module.exports, "useFilteredCollections", () => $1eef7de227d1974d$export$a4dbccbfbbac764d);
$parcel$export(module.exports, "useCollectionsLoading", () => $1eef7de227d1974d$export$c4791ba8ac9a58e5);
$parcel$export(module.exports, "useCollectionsHasError", () => $1eef7de227d1974d$export$1b07b501c3f8f216);
$parcel$export(module.exports, "useCollectionsCount", () => $1eef7de227d1974d$export$41be1fea11eb73ec);
$parcel$export(module.exports, "useCollectionName", () => $1eef7de227d1974d$export$71661e51ce252508);
$parcel$export(module.exports, "useCollectionEmoji", () => $1eef7de227d1974d$export$c35637e36ec6f8fd);
$parcel$export(module.exports, "useCollectionJql", () => $1eef7de227d1974d$export$3ddba651313f7cb0);
$parcel$export(module.exports, "useCollectionViews", () => $1eef7de227d1974d$export$4d3e73040770b6);
$parcel$export(module.exports, "useCollectionLoading", () => $1eef7de227d1974d$export$6073e01a27128de4);
$parcel$export(module.exports, "useCollectionError", () => $1eef7de227d1974d$export$5a7fad0d58c5f5e2);
$parcel$export(module.exports, "useCollectionHasError", () => $1eef7de227d1974d$export$a864c959274a94b8);
$parcel$export(module.exports, "useCollectionViewsCount", () => $1eef7de227d1974d$export$1a42c92187206222);
$parcel$export(module.exports, "useHasFetchedCollectionViews", () => $1eef7de227d1974d$export$32becd83126d3e5b);
$parcel$export(module.exports, "useCollectionOwnerId", () => $1eef7de227d1974d$export$333713f4878fc62d);
$parcel$export(module.exports, "useCollectionDescription", () => $1eef7de227d1974d$export$31549a29278f29ca);
$parcel$export(module.exports, "useCollectionProjectKeys", () => $1eef7de227d1974d$export$627b89d60c64164a);
$parcel$export(module.exports, "useCollectionFiltersJql", () => $1eef7de227d1974d$export$6a559aa025c2caf0);
$parcel$export(module.exports, "useProjectCollectionsCount", () => $1eef7de227d1974d$export$e785641239dc5c88);
$parcel$export(module.exports, "useIsCollectionDescriptionLoading", () => $1eef7de227d1974d$export$d01e52f887fd0aef);
$parcel$export(module.exports, "useCollectionDescriptionHasError", () => $1eef7de227d1974d$export$d8d51044786d761);

var $kGsr8 = parcelRequire("kGsr8");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $74N90 = parcelRequire("74N90");

var $emOwp = parcelRequire("emOwp");
const $1eef7de227d1974d$var$initialState = {
    collections: {},
    isLoading: true,
    error: undefined,
    descriptions: {}
};
const $1eef7de227d1974d$var$Store = (0, $iXqE5.createStore)({
    initialState: $1eef7de227d1974d$var$initialState,
    actions: $74N90,
    name: 'PolarisCollections'
});
const $1eef7de227d1974d$export$80cb348e37947c6a = (0, $gg7kZ.createContainer)($1eef7de227d1974d$var$Store);
const $1eef7de227d1974d$export$ba61932a631ba139 = (0, $3sQ5x.createActionsHook)($1eef7de227d1974d$var$Store);
const $1eef7de227d1974d$var$getCollections = (state)=>state.collections;
const $1eef7de227d1974d$var$getCollectionsList = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollections, (collections)=>Object.values(collections).map((c)=>c?.data).filter(Boolean));
const $1eef7de227d1974d$var$getCollectionIds = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollections, (collections)=>Object.keys(collections));
const $1eef7de227d1974d$var$getCollectionsLoading = (state)=>state.isLoading;
const $1eef7de227d1974d$var$getCollectionsError = (state)=>state.error;
const $1eef7de227d1974d$var$getCollectionsHasError = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollectionsError, (error)=>!!error);
const $1eef7de227d1974d$var$getCollectionsOwnersIds = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollectionsList, (collections)=>(0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(collections.map(({ ownerId: ownerId })=>ownerId).filter(Boolean)));
const $1eef7de227d1974d$var$getFilteredCollections = (0, $6dDSs.createSelector)((state)=>$1eef7de227d1974d$var$getCollectionsList(state), (_, { text: text })=>text, (_, { ownerIds: ownerIds })=>ownerIds, (_, { projects: projects })=>projects, (collections, text, ownerIds, projects)=>collections ? collections.filter((collection)=>(0, $emOwp.filterCollectionByText)(text)(collection) && (0, $emOwp.filterCollectionByOwnerIds)(ownerIds)(collection) && (0, $emOwp.filterCollectionByProjectKeys)(projects)(collection)) : []);
const $1eef7de227d1974d$var$getCollectionsCount = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollectionsList, (collections)=>collections.length);
const $1eef7de227d1974d$export$47ee56d816ebfe18 = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollectionsOwnersIds
});
const $1eef7de227d1974d$export$a4dbccbfbbac764d = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getFilteredCollections
});
const $1eef7de227d1974d$export$2b5787016ed09c4d = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollections
});
const $1eef7de227d1974d$export$c4791ba8ac9a58e5 = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollectionsLoading
});
const $1eef7de227d1974d$export$1b07b501c3f8f216 = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollectionsHasError
});
const $1eef7de227d1974d$export$41be1fea11eb73ec = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollectionsCount
});
const $1eef7de227d1974d$export$e9fd0b8259ad0113 = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollectionIds
});
const $1eef7de227d1974d$var$getCollectionWithMeta = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollections, (_, { collectionUUID: collectionUUID })=>collectionUUID, (collections, collectionUUID)=>collectionUUID ? collections[collectionUUID] : undefined);
const $1eef7de227d1974d$var$getCollection = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollectionWithMeta, (collection)=>collection?.data);
const $1eef7de227d1974d$var$getCollectionName = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollection, (collection)=>collection?.name);
const $1eef7de227d1974d$var$getCollectionEmoji = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollection, (collection)=>collection?.emoji);
const $1eef7de227d1974d$var$getCollectionJql = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollection, (collection)=>collection?.jql);
const $1eef7de227d1974d$var$getCollectionViews = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollection, (collection)=>collection?.views || []);
const $1eef7de227d1974d$var$hasFetchedCollectionViews = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollection, (collection)=>Array.isArray(collection?.views));
const $1eef7de227d1974d$var$getIsCollectionLoading = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollectionWithMeta, (collection)=>!!collection?.isLoading && !collection?.data?.views);
const $1eef7de227d1974d$var$getCollectionProjectKeys = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollection, (collection)=>collection?.projectKeys);
const $1eef7de227d1974d$var$getCollectionFiltersJql = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollection, (collection)=>collection?.filtersJql);
const $1eef7de227d1974d$var$getProjectCollectionsCount = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollections, (collections)=>Object.values(collections).flatMap((collection)=>collection?.data?.projectKeys).filter((key)=>!!key).reduce((acc, projectKey)=>{
        acc[projectKey] = (acc[projectKey] ?? 0) + 1;
        return acc;
    }, {}));
const $1eef7de227d1974d$var$getError = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollectionWithMeta, (collection)=>collection?.error);
const $1eef7de227d1974d$var$hasError = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getError, (error)=>!!error);
const $1eef7de227d1974d$var$getCollectionViewsOwnersIds = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollectionViews, (views)=>(0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(views.map(({ ownerId: ownerId })=>ownerId).filter(Boolean)));
const $1eef7de227d1974d$var$getCollectionView = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollectionViews, (_, { viewUUID: viewUUID })=>viewUUID, (views, viewUUID)=>viewUUID ? views.find((view)=>view.uuid === viewUUID) : undefined);
const $1eef7de227d1974d$var$getCollectionViewTitle = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollectionView, (view)=>view?.title);
const $1eef7de227d1974d$var$getCollectionViewsCount = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollection, (collection)=>collection?.views?.length || collection?.viewsCount);
const $1eef7de227d1974d$var$getCollectionOwnerId = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollection, (collection)=>collection?.ownerId);
const $1eef7de227d1974d$var$getDescriptions = (state)=>state.descriptions;
const $1eef7de227d1974d$var$getCollectionDescriptionWithMeta = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getDescriptions, (_, { collectionUUID: collectionUUID })=>collectionUUID, (descriptions, collectionUUID)=>collectionUUID ? descriptions[collectionUUID] : undefined);
const $1eef7de227d1974d$var$getCollectionDescription = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollectionDescriptionWithMeta, (descriptionWithMeta)=>descriptionWithMeta?.description);
const $1eef7de227d1974d$var$getIsCollectionDescriptionLoading = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollectionDescriptionWithMeta, (descriptionWithMeta)=>!!descriptionWithMeta?.isLoading);
const $1eef7de227d1974d$var$getCollectionDescriptionHasError = (0, $6dDSs.createSelector)($1eef7de227d1974d$var$getCollectionDescriptionWithMeta, (descriptionWithMeta)=>!!descriptionWithMeta?.error);
const $1eef7de227d1974d$export$6cd28814d92fa9c9 = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollection
});
const $1eef7de227d1974d$export$71661e51ce252508 = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollectionName
});
const $1eef7de227d1974d$export$c35637e36ec6f8fd = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollectionEmoji
});
const $1eef7de227d1974d$export$3ddba651313f7cb0 = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollectionJql
});
const $1eef7de227d1974d$export$4d3e73040770b6 = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollectionViews
});
const $1eef7de227d1974d$export$6073e01a27128de4 = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getIsCollectionLoading
});
const $1eef7de227d1974d$export$5a7fad0d58c5f5e2 = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getError
});
const $1eef7de227d1974d$export$a864c959274a94b8 = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$hasError
});
const $1eef7de227d1974d$export$794fd3b80c093caa = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollectionViewsOwnersIds
});
const $1eef7de227d1974d$export$61588707ea3d7293 = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollectionView
});
const $1eef7de227d1974d$export$652691088e3ed5ff = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollectionViewTitle
});
const $1eef7de227d1974d$export$1a42c92187206222 = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollectionViewsCount
});
const $1eef7de227d1974d$export$32becd83126d3e5b = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$hasFetchedCollectionViews
});
const $1eef7de227d1974d$export$333713f4878fc62d = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollectionOwnerId
});
const $1eef7de227d1974d$export$31549a29278f29ca = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollectionDescription
});
const $1eef7de227d1974d$export$627b89d60c64164a = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollectionProjectKeys
});
const $1eef7de227d1974d$export$6a559aa025c2caf0 = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollectionFiltersJql
});
const $1eef7de227d1974d$export$e785641239dc5c88 = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getProjectCollectionsCount
});
const $1eef7de227d1974d$export$d01e52f887fd0aef = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getIsCollectionDescriptionLoading
});
const $1eef7de227d1974d$export$d8d51044786d761 = (0, $3sQ5x.createStateHook)($1eef7de227d1974d$var$Store, {
    selector: $1eef7de227d1974d$var$getCollectionDescriptionHasError
});

});
parcelRegister("74N90", function(module, exports) {

$parcel$export(module.exports, "initialize", () => (parcelRequire("iKoRi")).initialize);
$parcel$export(module.exports, "createCollection", () => (parcelRequire("iKoRi")).createCollection);
$parcel$export(module.exports, "deleteCollection", () => (parcelRequire("iKoRi")).deleteCollection);
$parcel$export(module.exports, "updateCollection", () => (parcelRequire("iKoRi")).updateCollection);
$parcel$export(module.exports, "loadCollection", () => (parcelRequire("iKoRi")).loadCollection);
$parcel$export(module.exports, "loadCollections", () => (parcelRequire("iKoRi")).loadCollections);
$parcel$export(module.exports, "copyCollection", () => (parcelRequire("iKoRi")).copyCollection);
$parcel$export(module.exports, "getCollectionData", () => (parcelRequire("iKoRi")).getCollectionData);
$parcel$export(module.exports, "syncStateWithCollectionStoreAfterViewDelete", () => (parcelRequire("iKoRi")).syncStateWithCollectionStoreAfterViewDelete);
$parcel$export(module.exports, "createView", () => (parcelRequire("2ejmj")).createView);
$parcel$export(module.exports, "deleteView", () => (parcelRequire("2ejmj")).deleteView);
$parcel$export(module.exports, "fetchCollectionsViewsCounts", () => (parcelRequire("2ejmj")).fetchCollectionsViewsCounts);
$parcel$export(module.exports, "loadCollectionDescription", () => (parcelRequire("3WCAK")).loadCollectionDescription);
$parcel$export(module.exports, "updateCollectionDescription", () => (parcelRequire("3WCAK")).updateCollectionDescription);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $iKoRi = parcelRequire("iKoRi");

var $2ejmj = parcelRequire("2ejmj");

var $3WCAK = parcelRequire("3WCAK");

});
parcelRegister("iKoRi", function(module, exports) {

$parcel$export(module.exports, "createCollection", () => $329c76ef83bcd303$export$c74125a8e3af6bb2);
$parcel$export(module.exports, "initialize", () => $329c76ef83bcd303$export$2a47f398eeff8b01);
$parcel$export(module.exports, "loadCollection", () => $329c76ef83bcd303$export$1f19ddbd9e78c2f5);
$parcel$export(module.exports, "loadCollections", () => $329c76ef83bcd303$export$569b2ddb07e9ef58);
$parcel$export(module.exports, "deleteCollection", () => $329c76ef83bcd303$export$3d16e031f6551662);
$parcel$export(module.exports, "updateCollection", () => $329c76ef83bcd303$export$c0683150b517c317);
$parcel$export(module.exports, "copyCollection", () => $329c76ef83bcd303$export$36928e43600c4b00);
$parcel$export(module.exports, "getCollectionData", () => $329c76ef83bcd303$export$d071b5a3ecbd2134);
$parcel$export(module.exports, "syncStateWithCollectionStoreAfterViewDelete", () => $329c76ef83bcd303$export$64e824699282d339);

var $jcw0u = parcelRequire("jcw0u");

var $eiARp = parcelRequire("eiARp");

var $jDD5V = parcelRequire("jDD5V");

var $1BW2P = parcelRequire("1BW2P");

var $1As78 = parcelRequire("1As78");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");

var $dpYV0 = parcelRequire("dpYV0");

var $8EJ2P = parcelRequire("8EJ2P");
const $329c76ef83bcd303$export$c74125a8e3af6bb2 = ({ name: name, color: color, emoji: emoji, jql: jql, ownerId: ownerId, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState }, { onCollectionCreate: onCollectionCreate })=>{
        try {
            return await (0, $jDD5V.wrapWithExperience)((0, $eiARp.experience).collections.createCollection, async ()=>{
                const newCollection = await (0, $8EJ2P.createCollection)({
                    name: name,
                    color: color,
                    emoji: emoji,
                    jql: jql
                });
                const state = getState();
                setState({
                    collections: {
                        ...state.collections,
                        [newCollection.uuid]: {
                            data: {
                                ...newCollection,
                                ownerId: ownerId
                            }
                        }
                    }
                });
                const actionSubjectAndAction = 'collection created';
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction);
                (0, $1BW2P.sendPendoTrackEvent)({
                    actionSubjectAndAction: actionSubjectAndAction
                });
                // Ensure that onCollectionCreate always receives
                // a fresh reference
                onCollectionCreate?.({
                    ...newCollection
                });
                return newCollection;
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.error.createCollectionFailed', error));
                throw error;
            }
        }
    };
const $329c76ef83bcd303$export$2a47f398eeff8b01 = (collections)=>({ setState: setState })=>{
        setState({
            collections: collections.reduce((acc, collection)=>{
                acc[collection.uuid] = {
                    data: collection
                };
                return acc;
            }, {}),
            isLoading: false,
            error: undefined
        });
    };
const $329c76ef83bcd303$export$1f19ddbd9e78c2f5 = (collectionUUID, shouldIncludeViews)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const existingCollection = state.collections[collectionUUID] || {
            data: undefined
        };
        if (existingCollection.isLoading || existingCollection.data?.views !== undefined) return;
        const loadExperience = shouldIncludeViews ? (0, $eiARp.experience).collections.loadCollectionViews : (0, $eiARp.experience).collections.loadCollection;
        try {
            await (0, $jDD5V.wrapWithExperience)(loadExperience, async ()=>{
                setState({
                    collections: {
                        ...state.collections,
                        [collectionUUID]: {
                            ...existingCollection,
                            isLoading: true,
                            error: undefined
                        }
                    }
                });
                const newCollection = await (0, $8EJ2P.fetchCollection)(collectionUUID, shouldIncludeViews);
                setState({
                    collections: {
                        ...state.collections,
                        [collectionUUID]: {
                            data: {
                                ...existingCollection.data,
                                ...newCollection
                            },
                            isLoading: false
                        }
                    }
                });
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.error.collectionLoadingFailed', error));
                setState({
                    collections: {
                        ...state.collections,
                        [collectionUUID]: {
                            ...existingCollection,
                            isLoading: false,
                            error: error
                        }
                    }
                });
            }
        }
    };
const $329c76ef83bcd303$export$569b2ddb07e9ef58 = ()=>async ({ setState: setState, dispatch: dispatch })=>{
        try {
            return await (0, $jDD5V.wrapWithExperience)((0, $eiARp.experience).collections.loadCollections, async ()=>{
                setState({
                    collections: {},
                    isLoading: true
                });
                const collections = await (0, $8EJ2P.fetchAllCollections)();
                dispatch($329c76ef83bcd303$export$2a47f398eeff8b01(collections));
                return collections;
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.error.allCollectionsLoadingFailed', error));
                setState({
                    isLoading: false,
                    error: error
                });
            }
        }
        return undefined;
    };
const $329c76ef83bcd303$export$3d16e031f6551662 = (collectionUUID, { deleteOnlyOnClientSide: deleteOnlyOnClientSide } = {
    deleteOnlyOnClientSide: false
})=>async ({ setState: setState, getState: getState }, { onCollectionDelete: onCollectionDelete })=>{
        const state = getState();
        try {
            await (0, $jDD5V.wrapWithExperience)((0, $eiARp.experience).collections.deleteCollection, async ()=>{
                const { [collectionUUID]: _, ...collections } = state.collections;
                if (!deleteOnlyOnClientSide) await (0, $8EJ2P.deleteCollection)(collectionUUID);
                setState({
                    collections: collections
                });
                onCollectionDelete?.(collectionUUID);
            });
        } catch (error) {
            if (error instanceof Error) (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.error.collectionDeletionFailed', error));
            throw error;
        }
    };
const $329c76ef83bcd303$export$c0683150b517c317 = (collectionUUID, collection)=>async ({ setState: setState, getState: getState }, { onCollectionUpdate: onCollectionUpdate })=>{
        const state = getState();
        const existingCollection = state.collections[collectionUUID];
        const data = existingCollection?.data;
        if (!data) return;
        try {
            await (0, $jDD5V.wrapWithExperience)((0, $eiARp.experience).collections.updateCollection, async ()=>{
                const { name: name, color: color, emoji: emoji, projectKeys: projectKeys, filtersJql: filtersJql } = collection;
                let jql;
                if ((0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering')) jql = projectKeys !== undefined || filtersJql !== undefined ? (0, $dpYV0.getJQLForCollection)(projectKeys ?? data.projectKeys, filtersJql ?? data.filtersJql) : data.jql;
                else jql = projectKeys ? (0, $dpYV0.getJQLForCollection)(projectKeys) : data.jql;
                const updatedCollection = {
                    name: name || data.name,
                    color: 'color' in collection ? color : data.color,
                    emoji: 'emoji' in collection ? emoji : data.emoji,
                    jql: jql
                };
                await (0, $8EJ2P.updateCollection)(collectionUUID, updatedCollection);
                const updatedCollectionData = {
                    ...data,
                    ...updatedCollection,
                    ...(0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering') ? {
                        projectKeys: projectKeys ?? data.projectKeys,
                        filtersJql: filtersJql ?? data.filtersJql
                    } : {}
                };
                setState({
                    collections: {
                        ...state.collections,
                        [collectionUUID]: {
                            ...existingCollection,
                            data: updatedCollectionData
                        }
                    }
                });
                // Ensure that onCollectionUpdate always receives
                // a fresh reference
                onCollectionUpdate?.({
                    ...updatedCollectionData
                });
            });
        } catch (error) {
            if (error instanceof Error) (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.error.collectionUpdateFailed', error));
            throw error;
        }
    };
const $329c76ef83bcd303$export$36928e43600c4b00 = (collectionUUID, newCollectionName, newCollectionOwnerId, collectionTemporaryData)=>async ({ setState: setState, getState: getState })=>{
        try {
            const state = getState();
            const collectionToCopy = state.collections[collectionUUID]?.data || ((0, $4R6GH.fg)('jpd-sidebar-v4-for-roadmaps') ? collectionTemporaryData : undefined);
            if (!collectionToCopy || !newCollectionOwnerId) return;
            return await (0, $jDD5V.wrapWithExperience)((0, $eiARp.experience).collections.copyCollection, async ()=>{
                const { uuid: uuid } = await (0, $8EJ2P.cloneCollection)(collectionUUID, newCollectionName);
                setState({
                    collections: {
                        ...state.collections,
                        [uuid]: {
                            isLoading: false,
                            error: undefined,
                            data: {
                                ...collectionToCopy,
                                name: newCollectionName,
                                ownerId: newCollectionOwnerId,
                                uuid: uuid
                            }
                        }
                    }
                });
                return uuid;
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.error.copyCollectionFailed', error));
                throw error;
            }
        }
    };
const $329c76ef83bcd303$export$d071b5a3ecbd2134 = (collectionUUID)=>async ({ getState: getState })=>{
        const state = getState();
        const existingCollection = state.collections[collectionUUID] || {
            data: undefined
        };
        if (existingCollection.data?.views !== undefined) return existingCollection.data;
        try {
            return await (0, $jDD5V.wrapWithExperience)((0, $eiARp.experience).collections.loadCollection, async ()=>{
                const collection = await (0, $8EJ2P.fetchCollection)(collectionUUID, true);
                return collection;
            });
        } catch (error) {
            if (error instanceof Error) (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.error.collectionLoadingFailed', error));
        }
    };
const $329c76ef83bcd303$export$64e824699282d339 = (collectionUUID, viewUUID)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const collection = state.collections && state.collections[collectionUUID];
        if (!collection || !collection.data) return;
        const currentViewsCount = collection.data.viewsCount ?? 0;
        const viewsCount = currentViewsCount > 0 ? currentViewsCount - 1 : 0;
        const views = collection.data.views?.filter((view)=>view.uuid !== viewUUID);
        setState({
            collections: {
                ...state.collections,
                [collectionUUID]: {
                    data: {
                        ...collection.data,
                        views: views,
                        viewsCount: viewsCount
                    }
                }
            }
        });
    };

});
parcelRegister("eiARp", function(module, exports) {

$parcel$export(module.exports, "experience", () => $197962e595787fdc$export$45794d16c9d83fe2);

var $j7O7S = parcelRequire("j7O7S");

var $g4YUd = parcelRequire("g4YUd");

var $5aZmE = parcelRequire("5aZmE");

var $1vklt = parcelRequire("1vklt");

var $hsleu = parcelRequire("hsleu");

var $a6HzE = parcelRequire("a6HzE");

var $fL5Br = parcelRequire("fL5Br");

var $7fAfw = parcelRequire("7fAfw");

var $3BB7g = parcelRequire("3BB7g");

var $hZFBk = parcelRequire("hZFBk");

var $7OYCX = parcelRequire("7OYCX");

var $aLKMx = parcelRequire("aLKMx");

var $kKtJE = parcelRequire("kKtJE");

var $izXrc = parcelRequire("izXrc");

var $fziiF = parcelRequire("fziiF");

var $5vb9d = parcelRequire("5vb9d");

var $eP0jx = parcelRequire("eP0jx");

var $5jGaO = parcelRequire("5jGaO");

var $2fH9t = parcelRequire("2fH9t");

var $kCQpt = parcelRequire("kCQpt");

var $brO00 = parcelRequire("brO00");
const $197962e595787fdc$export$45794d16c9d83fe2 = {
    listView: $7OYCX.default,
    formulaField: $hsleu.default,
    headerView: $fL5Br.default,
    boardView: $j7O7S.default,
    ideaView: $3BB7g.default,
    ideaViewBentoSidebar: $7fAfw.default,
    matrixView: $aLKMx.default,
    navBar: $kKtJE.default,
    project: $eP0jx.default,
    timelineView: $2fH9t.default,
    fieldsSidebar: $1vklt.default,
    issues: $hZFBk.default,
    deliveryItems: $5aZmE.default,
    sharing: $5jGaO.default,
    productAccess: $5vb9d.default,
    globalFieldsAdministration: $a6HzE.default,
    playSidepanel: $fziiF.default,
    noViewsScreen: $izXrc.default,
    view: $brO00.default,
    viewPermissions: $kCQpt.default,
    collections: $g4YUd.default
};

});
parcelRegister("j7O7S", function(module, exports) {

$parcel$export(module.exports, "default", () => $713aabc44094d1be$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $713aabc44094d1be$var$pageSegmentLoad = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.board-view', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
}));
// measure list scroll performance
const $713aabc44094d1be$var$scrollPerformance = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.board-view.scroll-performance', {
    type: (0, $lrUJ4.ExperienceTypes).Operation,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom
}));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$713aabc44094d1be$export$2e2bcd8739ae039 = {
    scrollPerformance: $713aabc44094d1be$var$scrollPerformance,
    pageSegmentLoad: $713aabc44094d1be$var$pageSegmentLoad
};

});
parcelRegister("jDD5V", function(module, exports) {

$parcel$export(module.exports, "createMarkedJpdExperience", () => $d337991d320bf50a$export$bffa5dc83c7b8f85);
$parcel$export(module.exports, "createJpdExperience", () => $d337991d320bf50a$export$2510480a5584184);
$parcel$export(module.exports, "wrapPromiseWithExperience", () => $d337991d320bf50a$export$745ef3600a4acb32);
$parcel$export(module.exports, "wrapWithExperience", () => $d337991d320bf50a$export$9527dfc663dbb238);
$parcel$export(module.exports, "createExperienceWithMetaType", () => $d337991d320bf50a$export$e3ba910cdcb797bc);

var $agVdz = parcelRequire("agVdz");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $4R6GH = parcelRequire("4R6GH");
const $d337991d320bf50a$export$bffa5dc83c7b8f85 = (ufoExperience, marks)=>({
        ...$d337991d320bf50a$export$2510480a5584184(ufoExperience),
        marks: marks
    });
const $d337991d320bf50a$var$handleReason = (handler, error)=>{
    if (error === undefined) {
        handler();
        return;
    }
    if (typeof error === 'object' && 'statusCode' in error && 'message' in error) {
        handler({
            metadata: {
                error: `status: ${error.statusCode} message: ${error.message} name: ${error.name}`,
                errors: 'errors' in error && Array.isArray(error.errors) ? error.errors.map((err)=>{
                    if (typeof err === 'string') return err;
                    if (typeof err === 'object' && err !== null && 'error' in err) return err.error;
                    return '';
                }).join(', ') : undefined
            }
        });
        return;
    }
    if (error instanceof Error) {
        handler({
            metadata: {
                error: error.message
            }
        });
        return;
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($agVdz)))(error)) {
        handler({
            metadata: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: error
            }
        });
        return;
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    handler(error);
};
function $d337991d320bf50a$var$handleReasonNew(handler, error) {
    if (error === undefined) {
        handler();
        return;
    }
    const traceId = typeof error === 'object' && 'traceId' in error ? error.traceId : undefined;
    if (typeof error === 'object' && 'statusCode' in error && 'message' in error) {
        handler({
            metadata: {
                error: `status: ${error.statusCode} message: ${error.message} name: ${error.name}`,
                errors: 'errors' in error && Array.isArray(error.errors) ? error.errors.map((err)=>{
                    if (typeof err === 'string') return err;
                    if (typeof err === 'object' && err !== null && 'error' in err) return err.error;
                    return '';
                }).join(', ') : undefined,
                traceId: traceId
            }
        });
        return;
    }
    if (error instanceof Error) {
        handler({
            metadata: {
                error: error.message,
                traceId: traceId
            }
        });
        return;
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($agVdz)))(error)) {
        handler({
            metadata: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: error
            }
        });
        return;
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    handler(error);
}
const $d337991d320bf50a$export$2510480a5584184 = (ufoExperience)=>({
        ufoExperience: ufoExperience,
        start: (startTime)=>{
            ufoExperience.start();
            // hack to set custom start time
            if (startTime !== undefined) Object.assign(ufoExperience.metrics, {
                ...ufoExperience.metrics,
                startTime: startTime
            });
        },
        mark: (mark)=>{
            ufoExperience.mark(mark);
        },
        success: (meta, endTime)=>{
            ufoExperience.success(meta);
            // hack to set custom end time
            if (endTime !== undefined) Object.assign(ufoExperience.metrics, {
                ...ufoExperience.metrics,
                endTime: endTime
            });
        },
        successWithReason: (reason)=>{
            if ((0, $4R6GH.fg)('jpd_improved_experience_tracking')) $d337991d320bf50a$var$handleReasonNew((meta)=>ufoExperience.success(meta), reason);
            else $d337991d320bf50a$var$handleReason((meta)=>ufoExperience.success(meta), reason);
        },
        failure: (reason)=>{
            if ((0, $4R6GH.fg)('jpd_improved_experience_tracking')) $d337991d320bf50a$var$handleReasonNew((meta)=>ufoExperience.failure(meta), reason);
            else $d337991d320bf50a$var$handleReason((meta)=>ufoExperience.failure(meta), reason);
        },
        abort: (reason)=>{
            if ((0, $4R6GH.fg)('jpd_improved_experience_tracking')) $d337991d320bf50a$var$handleReasonNew((meta)=>ufoExperience.abort(meta), reason);
            else $d337991d320bf50a$var$handleReason((meta)=>ufoExperience.abort(meta), reason);
        }
    });
const $d337991d320bf50a$export$745ef3600a4acb32 = (promise, experience, errorAnalyticsId)=>{
    experience.start();
    return promise.then((response)=>{
        experience.success();
        return response;
    }).catch((error)=>{
        if (errorAnalyticsId) (0, $jcw0u.default)({
            meta: {
                id: errorAnalyticsId,
                teamName: 'polaris'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        if ((0, $fZneA.isClientFetchError)(error)) {
            experience.abort(error);
            throw error;
        }
        if ((0, $jJZqs.isValidationError)(error)) {
            experience.abort(error);
            throw error;
        }
        experience.failure(error);
        throw error;
    });
};
const $d337991d320bf50a$export$9527dfc663dbb238 = (experience, callback)=>{
    experience.start();
    return callback().then((result)=>{
        experience.success();
        return result;
    }).catch((error)=>{
        if ((0, $fZneA.isClientFetchError)(error)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            experience.abort(error);
            throw error;
        }
        if (error instanceof Error) experience.failure(error);
        throw error;
    });
};
const $d337991d320bf50a$export$e3ba910cdcb797bc = (experience, metaType, parseMetadataError)=>({
        ufoExperience: experience.ufoExperience,
        start: experience.start,
        mark: experience.mark,
        success: (meta, endTime)=>{
            experience.success({
                metadata: {
                    type: metaType
                },
                ...meta
            }, endTime);
        },
        successWithReason: (error)=>{
            experience.successWithReason({
                metadata: {
                    error: parseMetadataError(error),
                    type: metaType
                }
            });
        },
        failure: (error)=>{
            if (error && (0, $fZneA.isClientFetchError)(error)) experience.abort({
                metadata: {
                    error: parseMetadataError(error),
                    type: metaType
                }
            });
            else experience.failure({
                metadata: {
                    error: parseMetadataError(error),
                    type: metaType
                }
            });
        },
        abort: (error)=>{
            experience.abort({
                metadata: {
                    error: parseMetadataError(error),
                    type: metaType
                }
            });
        }
    });

});
parcelRegister("agVdz", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $8LQ84 = parcelRequire("8LQ84");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $77a7c84c5ee0b808$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $77a7c84c5ee0b808$var$isString(value) {
    return typeof value == 'string' || !$8LQ84(value) && $fC1Kz(value) && $beQoo(value) == $77a7c84c5ee0b808$var$stringTag;
}
module.exports = $77a7c84c5ee0b808$var$isString;

});



parcelRegister("g4YUd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f47dfcedb9a9cd64$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $f47dfcedb9a9cd64$var$pageLoad = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.collections', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageLoad
}));
const $f47dfcedb9a9cd64$var$create = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.collections.create', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $f47dfcedb9a9cd64$var$loadCollections = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.collections.load-collections', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $f47dfcedb9a9cd64$var$loadViewCount = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.collections.load-view-count', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $f47dfcedb9a9cd64$var$loadUsers = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.collections.load-users', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $f47dfcedb9a9cd64$var$loadProjects = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.collections.load-projects', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $f47dfcedb9a9cd64$var$createCollection = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.collections.create-collection', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $f47dfcedb9a9cd64$var$copyCollection = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.collections.copy-collection', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $f47dfcedb9a9cd64$var$deleteCollection = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.collections.delete-collection', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $f47dfcedb9a9cd64$var$updateCollection = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.collections.update-collection', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $f47dfcedb9a9cd64$var$loadCollection = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.collections.load-collection', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $f47dfcedb9a9cd64$var$loadCollectionViews = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.collections.load-collection-views', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $f47dfcedb9a9cd64$var$loadCollectionDescription = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.collections.load-collection-description', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $f47dfcedb9a9cd64$var$updateCollectionDescription = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.collections.update-collection-description', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $f47dfcedb9a9cd64$var$createView = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.collections.create-view', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $f47dfcedb9a9cd64$var$deleteView = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.collections.delete-view', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f47dfcedb9a9cd64$export$2e2bcd8739ae039 = {
    pageLoad: $f47dfcedb9a9cd64$var$pageLoad,
    create: $f47dfcedb9a9cd64$var$create,
    loadCollections: $f47dfcedb9a9cd64$var$loadCollections,
    loadViewCount: $f47dfcedb9a9cd64$var$loadViewCount,
    loadUsers: $f47dfcedb9a9cd64$var$loadUsers,
    loadProjects: $f47dfcedb9a9cd64$var$loadProjects,
    createCollection: $f47dfcedb9a9cd64$var$createCollection,
    copyCollection: $f47dfcedb9a9cd64$var$copyCollection,
    loadCollection: $f47dfcedb9a9cd64$var$loadCollection,
    loadCollectionViews: $f47dfcedb9a9cd64$var$loadCollectionViews,
    deleteCollection: $f47dfcedb9a9cd64$var$deleteCollection,
    updateCollection: $f47dfcedb9a9cd64$var$updateCollection,
    loadCollectionDescription: $f47dfcedb9a9cd64$var$loadCollectionDescription,
    updateCollectionDescription: $f47dfcedb9a9cd64$var$updateCollectionDescription,
    createView: $f47dfcedb9a9cd64$var$createView,
    deleteView: $f47dfcedb9a9cd64$var$deleteView
};

});

parcelRegister("5aZmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8039a4f9b6c69dfe$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $8039a4f9b6c69dfe$var$loadChildIssues = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.delivery-items.load.childIssues', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $8039a4f9b6c69dfe$var$loadAggregatedDeliveryProgressBasedOnProjectId = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.delivery-items.load.aggregatedDeliveryProgressBasedOnProjectId', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $8039a4f9b6c69dfe$var$loadAggregatedDeliveryProgress = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.delivery-items.load.aggregatedDeliveryProgress', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $8039a4f9b6c69dfe$var$loadLinkedDeliveryTickets = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.delivery-items.load.linkedDeliveryTickets', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $8039a4f9b6c69dfe$var$loadTransitiveChildrenArjHierarchy = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.delivery-items.load.transitiveChildrenArjHierarchy', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $8039a4f9b6c69dfe$var$loadTransitiveChildrenInTwoLevelCoreHierarchy = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.delivery-items.load.transitiveChildrenInTwoLevelCoreHierarchy', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8039a4f9b6c69dfe$export$2e2bcd8739ae039 = {
    loadChildIssues: $8039a4f9b6c69dfe$var$loadChildIssues,
    loadAggregatedDeliveryProgressBasedOnProjectId: $8039a4f9b6c69dfe$var$loadAggregatedDeliveryProgressBasedOnProjectId,
    loadAggregatedDeliveryProgress: $8039a4f9b6c69dfe$var$loadAggregatedDeliveryProgress,
    loadLinkedDeliveryTickets: $8039a4f9b6c69dfe$var$loadLinkedDeliveryTickets,
    loadTransitiveChildrenArjHierarchy: $8039a4f9b6c69dfe$var$loadTransitiveChildrenArjHierarchy,
    loadTransitiveChildrenInTwoLevelCoreHierarchy: $8039a4f9b6c69dfe$var$loadTransitiveChildrenInTwoLevelCoreHierarchy
};

});

parcelRegister("1vklt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dea1a79ad34e84c$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $5dea1a79ad34e84c$var$pageSegmentLoad = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.fields-sidebar.load', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $5dea1a79ad34e84c$var$fieldToggle = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.fields-sidebar.field-toggle', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $5dea1a79ad34e84c$var$fieldHide = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.fields-sidebar.field-hide', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $5dea1a79ad34e84c$var$fieldDelete = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.fields-sidebar.field-delete', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $5dea1a79ad34e84c$var$fieldRegularCreate = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.fields-sidebar.field-regular-create', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $5dea1a79ad34e84c$var$fieldFormulaCreate = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.fields-sidebar.field-formula-create', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $5dea1a79ad34e84c$var$fieldPlayCreate = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.fields-sidebar.field-play-create', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $5dea1a79ad34e84c$var$fieldConfigurationUpdate = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.fields-sidebar.field-configuration-update', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
// create, delete and remove field option
const $5dea1a79ad34e84c$var$fieldOptionUpdate = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.fields-sidebar.field-option-update', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5dea1a79ad34e84c$export$2e2bcd8739ae039 = {
    fieldToggle: $5dea1a79ad34e84c$var$fieldToggle,
    fieldHide: $5dea1a79ad34e84c$var$fieldHide,
    fieldDelete: $5dea1a79ad34e84c$var$fieldDelete,
    fieldRegularCreate: $5dea1a79ad34e84c$var$fieldRegularCreate,
    fieldFormulaCreate: $5dea1a79ad34e84c$var$fieldFormulaCreate,
    fieldPlayCreate: $5dea1a79ad34e84c$var$fieldPlayCreate,
    fieldConfigurationUpdate: $5dea1a79ad34e84c$var$fieldConfigurationUpdate,
    fieldOptionUpdate: $5dea1a79ad34e84c$var$fieldOptionUpdate,
    pageSegmentLoad: $5dea1a79ad34e84c$var$pageSegmentLoad
};

});

parcelRegister("hsleu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ada778994f5f2fe$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $6ada778994f5f2fe$var$precalculateFormulaFieldAllValuesSelector = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.formula-field.precalculate-all-values-selector', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6ada778994f5f2fe$export$2e2bcd8739ae039 = {
    precalculateFormulaFieldAllValuesSelector: $6ada778994f5f2fe$var$precalculateFormulaFieldAllValuesSelector
};

});

parcelRegister("a6HzE", function(module, exports) {

$parcel$export(module.exports, "default", () => $43bb153204899b03$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $43bb153204899b03$var$globalFieldCreate = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.global-fields-administration.field-create', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $43bb153204899b03$var$globalFieldDelete = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.global-fields-administration.field-delete', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $43bb153204899b03$var$globalFieldAssociate = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.global-fields-administration.field-associate', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $43bb153204899b03$var$globalFieldUnassociate = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.global-fields-administration.field-unassociate', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $43bb153204899b03$var$globalFieldCheckViewsUsage = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.global-fields-administration.field-check-views-usage', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $43bb153204899b03$var$globalFieldUpdate = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.global-fields-administration.field-update', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $43bb153204899b03$var$globalFieldUpdateConfig = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.global-fields-administration.field-update-config', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $43bb153204899b03$var$globalFieldCheckProjectUsage = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.global-fields-administration.field-check-project-usage', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $43bb153204899b03$var$loadGlobalFields = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.global-fields-administration.load-fields', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $43bb153204899b03$var$loadGlobalLabels = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.global-fields-administration.load-global-labels', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $43bb153204899b03$var$loadJpdProjects = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.global-fields-administration.load-jpd-projects', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $43bb153204899b03$var$loadProjectsWithField = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.global-fields-administration.load-projects-with-field', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $43bb153204899b03$var$fieldAddOptions = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.global-fields-administration.field-add-options', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $43bb153204899b03$var$fieldDeleteOption = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.global-fields-administration.field-delete-option', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $43bb153204899b03$var$fieldRenameOption = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.global-fields-administration.field-rename-option', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $43bb153204899b03$var$fieldMoveOptions = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.global-fields-administration.field-move-options', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $43bb153204899b03$var$copyValues = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.global-fields-administration.copy-values', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$43bb153204899b03$export$2e2bcd8739ae039 = {
    globalFieldCreate: $43bb153204899b03$var$globalFieldCreate,
    globalFieldDelete: $43bb153204899b03$var$globalFieldDelete,
    globalFieldAssociate: $43bb153204899b03$var$globalFieldAssociate,
    globalFieldUnassociate: $43bb153204899b03$var$globalFieldUnassociate,
    globalFieldCheckViewsUsage: $43bb153204899b03$var$globalFieldCheckViewsUsage,
    globalFieldUpdate: $43bb153204899b03$var$globalFieldUpdate,
    globalFieldUpdateConfig: $43bb153204899b03$var$globalFieldUpdateConfig,
    globalFieldCheckProjectUsage: $43bb153204899b03$var$globalFieldCheckProjectUsage,
    loadGlobalFields: $43bb153204899b03$var$loadGlobalFields,
    loadGlobalLabels: $43bb153204899b03$var$loadGlobalLabels,
    loadJpdProjects: $43bb153204899b03$var$loadJpdProjects,
    loadProjectsWithField: $43bb153204899b03$var$loadProjectsWithField,
    fieldAddOptions: $43bb153204899b03$var$fieldAddOptions,
    fieldDeleteOption: $43bb153204899b03$var$fieldDeleteOption,
    fieldRenameOption: $43bb153204899b03$var$fieldRenameOption,
    fieldMoveOptions: $43bb153204899b03$var$fieldMoveOptions,
    copyValues: $43bb153204899b03$var$copyValues
};

});

parcelRegister("fL5Br", function(module, exports) {

$parcel$export(module.exports, "default", () => $db9a3be9cda48e16$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $db9a3be9cda48e16$var$updateViewDescription = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.header-view.update-view-description', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $db9a3be9cda48e16$var$viewGroupBy = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.header-view.view-group-by', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $db9a3be9cda48e16$var$viewSort = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.header-view.view-sort', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $db9a3be9cda48e16$var$viewFilter = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.header-view.view-filter', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$db9a3be9cda48e16$export$2e2bcd8739ae039 = {
    updateViewDescription: $db9a3be9cda48e16$var$updateViewDescription,
    viewGroupBy: $db9a3be9cda48e16$var$viewGroupBy,
    viewSort: $db9a3be9cda48e16$var$viewSort,
    viewFilter: $db9a3be9cda48e16$var$viewFilter
};

});

parcelRegister("7fAfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed8cbb8d1e75d594$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $ed8cbb8d1e75d594$var$pageSegmentLoad = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.idea-view-bento-sidebar', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
}));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ed8cbb8d1e75d594$export$2e2bcd8739ae039 = {
    pageSegmentLoad: $ed8cbb8d1e75d594$var$pageSegmentLoad
};

});

parcelRegister("3BB7g", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa811d79693859dc$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $aa811d79693859dc$var$pageSegmentLoad = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.idea-view', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
}));
// separate metric for loading fullscreen Idea View on start
const $aa811d79693859dc$var$directPageSegmentLoad = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.idea-view-direct', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $aa811d79693859dc$var$summaryUpdate = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.idea-view.summary-update', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $aa811d79693859dc$var$descriptionUpdate = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.idea-view.description-update', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $aa811d79693859dc$var$deliveryTicketCreate = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.idea-view.delivery-ticket-create', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $aa811d79693859dc$var$commentCreate = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.idea-view.comment-create', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $aa811d79693859dc$var$insightCreate = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.idea-view.insight-create', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $aa811d79693859dc$var$insightUpdate = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.idea-view.insight-update', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $aa811d79693859dc$var$insightDelete = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.idea-view.insight-delete', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $aa811d79693859dc$var$issueLinkCreate = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.idea-view.issue-link-create', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $aa811d79693859dc$var$commentsSegmentLoad = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.idea-view.comments', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $aa811d79693859dc$var$insightsSegmentLoad = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.idea-view.insights', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $aa811d79693859dc$var$fileAttach = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.idea-view.attach-file', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
/**
 * Since field updates can be frequent, makeFieldUpdate is a factory
 * to avoid conccurency problems as JPDExperience objects are singletons.
 */ const $aa811d79693859dc$var$makeFieldUpdate = ()=>(0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.idea-view.field-update', {
        type: (0, $lrUJ4.ExperienceTypes).Experience,
        performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
    }));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$aa811d79693859dc$export$2e2bcd8739ae039 = {
    pageSegmentLoad: $aa811d79693859dc$var$pageSegmentLoad,
    directPageSegmentLoad: $aa811d79693859dc$var$directPageSegmentLoad,
    summaryUpdate: $aa811d79693859dc$var$summaryUpdate,
    descriptionUpdate: $aa811d79693859dc$var$descriptionUpdate,
    deliveryTicketCreate: $aa811d79693859dc$var$deliveryTicketCreate,
    commentCreate: $aa811d79693859dc$var$commentCreate,
    insightCreate: $aa811d79693859dc$var$insightCreate,
    insightUpdate: $aa811d79693859dc$var$insightUpdate,
    insightDelete: $aa811d79693859dc$var$insightDelete,
    issueLinkCreate: $aa811d79693859dc$var$issueLinkCreate,
    commentsSegmentLoad: $aa811d79693859dc$var$commentsSegmentLoad,
    insightsSegmentLoad: $aa811d79693859dc$var$insightsSegmentLoad,
    fileAttach: $aa811d79693859dc$var$fileAttach,
    makeFieldUpdate: $aa811d79693859dc$var$makeFieldUpdate
};

});

parcelRegister("hZFBk", function(module, exports) {

$parcel$export(module.exports, "default", () => $93f260704cbd9bf2$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $93f260704cbd9bf2$var$loadIssuesRestBatched = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.issues.load.rest-batched', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $93f260704cbd9bf2$var$loadIssueRest = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.issue.load.rest', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $93f260704cbd9bf2$var$loadIssuesJpdApi = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.issues.load.jpd-api', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $93f260704cbd9bf2$var$loadIssueJpdApi = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.issue.load.jpd-api', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $93f260704cbd9bf2$var$loadIssuesRanksRestBatched = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.issues.ranks.load.rest-batched', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $93f260704cbd9bf2$var$loadIssuesRanksJpdApi = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.issues.ranks.load.jpd-api', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $93f260704cbd9bf2$var$rankIssue = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.issue.rank', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $93f260704cbd9bf2$var$loadIssuePickerIssuesRest = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.issue-picker.load', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $93f260704cbd9bf2$var$globalJpdIssueCreate = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.global.jpd.create-issue', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$93f260704cbd9bf2$export$2e2bcd8739ae039 = {
    loadIssuesRanksRestBatched: $93f260704cbd9bf2$var$loadIssuesRanksRestBatched,
    loadIssuesRanksJpdApi: $93f260704cbd9bf2$var$loadIssuesRanksJpdApi,
    loadIssuesRestBatched: $93f260704cbd9bf2$var$loadIssuesRestBatched,
    loadIssuesJpdApi: $93f260704cbd9bf2$var$loadIssuesJpdApi,
    loadIssueJpdApi: $93f260704cbd9bf2$var$loadIssueJpdApi,
    loadIssueRest: $93f260704cbd9bf2$var$loadIssueRest,
    rankIssue: $93f260704cbd9bf2$var$rankIssue,
    loadIssuePickerIssuesRest: $93f260704cbd9bf2$var$loadIssuePickerIssuesRest,
    globalJpdIssueCreate: $93f260704cbd9bf2$var$globalJpdIssueCreate
};

});

parcelRegister("7OYCX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b79ce5313c591e2$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $9b79ce5313c591e2$var$pageSegmentLoad = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.list-view', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $9b79ce5313c591e2$var$createIdeaInline = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.list-view.create-idea-inline', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
// this metric is meant to measure the time between clicking to add an idea inline and the input row appearing
const $9b79ce5313c591e2$var$createIdeaInlineClickResponse = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.list-view.create-idea-inline-button-click', {
    type: (0, $lrUJ4.ExperienceTypes).Operation,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom
}));
const $9b79ce5313c591e2$var$changeViewName = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.list-view.change-view-name', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
// measure list scroll performance
const $9b79ce5313c591e2$var$listScrollPerformance = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.list-view.scroll-performance', {
    type: (0, $lrUJ4.ExperienceTypes).Operation,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom
}));
/**
 * Since field updates can be frequent, makeFieldUpdate is a factory
 * to avoid conccurency problems as JPDExperience objects are singletons.
 */ const $9b79ce5313c591e2$var$makeFieldUpdate = ()=>(0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.list-view.field-update', {
        type: (0, $lrUJ4.ExperienceTypes).Experience,
        performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult,
        timings: [
            {
                key: 'internal_state',
                endMark: 'backend_request_start'
            },
            {
                key: 'backend_request',
                startMark: 'backend_request_start'
            }
        ]
    }));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9b79ce5313c591e2$export$2e2bcd8739ae039 = {
    changeViewName: $9b79ce5313c591e2$var$changeViewName,
    createIdeaInline: $9b79ce5313c591e2$var$createIdeaInline,
    createIdeaInlineClickResponse: $9b79ce5313c591e2$var$createIdeaInlineClickResponse,
    listScrollPerformance: $9b79ce5313c591e2$var$listScrollPerformance,
    pageSegmentLoad: $9b79ce5313c591e2$var$pageSegmentLoad,
    makeFieldUpdate: $9b79ce5313c591e2$var$makeFieldUpdate
};

});

parcelRegister("aLKMx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3e34426082afc38$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $c3e34426082afc38$var$pageSegmentLoad = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.matrix-view', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
}));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c3e34426082afc38$export$2e2bcd8739ae039 = {
    pageSegmentLoad: $c3e34426082afc38$var$pageSegmentLoad
};

});

parcelRegister("kKtJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $30ef3794d6f0e57e$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $30ef3794d6f0e57e$var$changeViewName = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.nav-bar.change-view-name', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $30ef3794d6f0e57e$var$changeViewRank = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.nav-bar.change-view-rank', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $30ef3794d6f0e57e$var$createView = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.nav-bar.create-view', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$30ef3794d6f0e57e$export$2e2bcd8739ae039 = {
    changeViewName: $30ef3794d6f0e57e$var$changeViewName,
    changeViewRank: $30ef3794d6f0e57e$var$changeViewRank,
    createView: $30ef3794d6f0e57e$var$createView
};

});

parcelRegister("izXrc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2aec2d2eb41963e$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $c2aec2d2eb41963e$var$createView = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.no-views-screen.create-view', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c2aec2d2eb41963e$export$2e2bcd8739ae039 = {
    createView: $c2aec2d2eb41963e$var$createView
};

});

parcelRegister("fziiF", function(module, exports) {

$parcel$export(module.exports, "default", () => $971b7c6c0f6a6248$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $971b7c6c0f6a6248$var$updatePlayField = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.play-sidepanel.field-update', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$971b7c6c0f6a6248$export$2e2bcd8739ae039 = {
    updatePlayField: $971b7c6c0f6a6248$var$updatePlayField
};

});

parcelRegister("5vb9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $54872f75c13964ef$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $54872f75c13964ef$var$loadSharingConfig = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.product-access.load-publish-config', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $54872f75c13964ef$var$updateSharingConfig = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.product-access.update-publish-config', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$54872f75c13964ef$export$2e2bcd8739ae039 = {
    loadSharingConfig: $54872f75c13964ef$var$loadSharingConfig,
    updateSharingConfig: $54872f75c13964ef$var$updateSharingConfig
};

});

parcelRegister("eP0jx", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9663d0cc0faff39$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $f9663d0cc0faff39$var$applyTemplateMarks = {
    APPLY_TEMPLATE_POLLING_START_MARK: 'apply_template_polling_start',
    APPLY_TEMPLATE_POLLING_STOP_MARK: 'apply_template_polling_stop'
};
const $f9663d0cc0faff39$var$pageLoad = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.project', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageLoad
}));
// Separate experience for rate limit errors
const $f9663d0cc0faff39$var$pageLoadWithRateLimit = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.project.rate-limit', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageLoad
}));
const $f9663d0cc0faff39$var$applyTemplate = (0, $jDD5V.createMarkedJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.project.apply-template', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'apply_template_polling',
            startMark: $f9663d0cc0faff39$var$applyTemplateMarks.APPLY_TEMPLATE_POLLING_START_MARK,
            endMark: $f9663d0cc0faff39$var$applyTemplateMarks.APPLY_TEMPLATE_POLLING_STOP_MARK
        }
    ]
}), $f9663d0cc0faff39$var$applyTemplateMarks);
const $f9663d0cc0faff39$var$create = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.project.create', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f9663d0cc0faff39$export$2e2bcd8739ae039 = {
    pageLoad: $f9663d0cc0faff39$var$pageLoad,
    pageLoadWithRateLimit: $f9663d0cc0faff39$var$pageLoadWithRateLimit,
    applyTemplate: $f9663d0cc0faff39$var$applyTemplate,
    create: $f9663d0cc0faff39$var$create
};

});

parcelRegister("5jGaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $8256c1be52a9ff31$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $8256c1be52a9ff31$var$dialogLoad = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.shared.control-dialog-load', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $8256c1be52a9ff31$var$loadStakeholders = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.shared.load-stakeholders', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $8256c1be52a9ff31$var$addStakeholders = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.shared.add-stakeholders', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $8256c1be52a9ff31$var$removeStakeholders = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.shared.remove-stakeholders', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $8256c1be52a9ff31$var$loadSettings = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.shared.load-settings', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $8256c1be52a9ff31$var$updateSettings = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.shared.update-settings', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $8256c1be52a9ff31$var$loadSiteConfig = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.shared.load-site-config', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $8256c1be52a9ff31$var$loadSitePublicSharingConfig = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.shared.load-site-public-sharing-config', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8256c1be52a9ff31$export$2e2bcd8739ae039 = {
    dialogLoad: $8256c1be52a9ff31$var$dialogLoad,
    loadStakeholders: $8256c1be52a9ff31$var$loadStakeholders,
    addStakeholders: $8256c1be52a9ff31$var$addStakeholders,
    removeStakeholders: $8256c1be52a9ff31$var$removeStakeholders,
    loadSettings: $8256c1be52a9ff31$var$loadSettings,
    updateSettings: $8256c1be52a9ff31$var$updateSettings,
    loadSiteConfig: $8256c1be52a9ff31$var$loadSiteConfig,
    loadSitePublicSharingConfig: $8256c1be52a9ff31$var$loadSitePublicSharingConfig
};

});

parcelRegister("2fH9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $4089a9b61ccedd94$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $4089a9b61ccedd94$var$pageSegmentLoad = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.timeline-view', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
}));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4089a9b61ccedd94$export$2e2bcd8739ae039 = {
    pageSegmentLoad: $4089a9b61ccedd94$var$pageSegmentLoad
};

});

parcelRegister("kCQpt", function(module, exports) {

$parcel$export(module.exports, "default", () => $28eb3963187c0ff9$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $28eb3963187c0ff9$var$openDialog = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.view-permissions.open-dialog', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $28eb3963187c0ff9$var$loadViewAccess = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.view-permissions.load-view-access', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $28eb3963187c0ff9$var$updateViewAccess = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.view-permissions.update-view-access', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $28eb3963187c0ff9$var$updatePrincipals = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.view-permissions.update-principals', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $28eb3963187c0ff9$var$loadCurrentUserViewPermissions = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.view-permissions.load-current-user-view-permissions', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$28eb3963187c0ff9$export$2e2bcd8739ae039 = {
    openDialog: $28eb3963187c0ff9$var$openDialog,
    loadViewAccess: $28eb3963187c0ff9$var$loadViewAccess,
    updateViewAccess: $28eb3963187c0ff9$var$updateViewAccess,
    updatePrincipals: $28eb3963187c0ff9$var$updatePrincipals,
    loadCurrentUserViewPermissions: $28eb3963187c0ff9$var$loadCurrentUserViewPermissions
};

});

parcelRegister("brO00", function(module, exports) {

$parcel$export(module.exports, "default", () => $b36fcf167fca27fa$export$2e2bcd8739ae039);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $jDD5V = parcelRequire("jDD5V");
const $b36fcf167fca27fa$var$getView = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.view.get-view', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $b36fcf167fca27fa$var$updateView = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.view.update-view', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
const $b36fcf167fca27fa$var$deleteView = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.view.delete-view', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
}));
/**
 * Since field updates can be frequent, makeGenericIssueFieldUpdate is a factory
 * to avoid conccurency problems as JPDExperience objects are singletons.
 */ const $b36fcf167fca27fa$var$makeGenericIssueFieldUpdate = ()=>(0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.issue-update.field', {
        type: (0, $lrUJ4.ExperienceTypes).Experience,
        performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult,
        timings: [
            {
                key: 'internal_state',
                endMark: 'backend_request_start'
            },
            {
                key: 'backend_request',
                startMark: 'backend_request_start'
            }
        ]
    }));
const $b36fcf167fca27fa$var$updateIssueFields = (0, $jDD5V.createJpdExperience)(new (0, $kkzI0.UFOExperience)('jpd.issue-update.fields', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult,
    timings: [
        {
            key: 'internal_state',
            endMark: 'backend_request_start'
        },
        {
            key: 'backend_request',
            startMark: 'backend_request_start'
        }
    ]
}));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b36fcf167fca27fa$export$2e2bcd8739ae039 = {
    getView: $b36fcf167fca27fa$var$getView,
    updateView: $b36fcf167fca27fa$var$updateView,
    deleteView: $b36fcf167fca27fa$var$deleteView,
    makeGenericIssueFieldUpdate: $b36fcf167fca27fa$var$makeGenericIssueFieldUpdate,
    updateIssueFields: $b36fcf167fca27fa$var$updateIssueFields
};

});


parcelRegister("1BW2P", function(module, exports) {

$parcel$export(module.exports, "sendPendoTrackEvent", () => $76c604c1de726c59$export$c6da4636619f7369);
$parcel$export(module.exports, "updatePendoVisitorOptions", () => $76c604c1de726c59$export$862313c5bc1d6788);

var $4Jd69 = parcelRequire("4Jd69");
const $76c604c1de726c59$var$QUEUE_LIMIT = 50;
let $76c604c1de726c59$var$queue = [];
const $76c604c1de726c59$var$waitForPendoReadiness = ()=>{
    // This code should not execute on the server.
    if (false) return;
    const interval = setInterval(()=>{
        if ((0, $4Jd69.isPendoReady)()) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            $76c604c1de726c59$var$queue.forEach(([event, attributes])=>window?.pendo?.track(event, attributes));
            $76c604c1de726c59$var$queue = [];
            clearInterval(interval);
        }
    }, 1000);
};
function $76c604c1de726c59$export$c6da4636619f7369(event, properties) {
    let pendoEvent;
    let attributes;
    if (typeof event === 'string') {
        pendoEvent = event;
        attributes = properties;
    } else {
        const fullEvent = [
            event.source,
            event.actionSubjectAndAction,
            event.actionSubjectId
        ].filter((part)=>part !== undefined).join(' - ');
        pendoEvent = fullEvent;
        attributes = event.attributes;
    }
    try {
        if ((0, $4Jd69.isPendoReady)()) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.pendo.track(pendoEvent, attributes);
        else {
            $76c604c1de726c59$var$queue.length < $76c604c1de726c59$var$QUEUE_LIMIT && $76c604c1de726c59$var$queue.push([
                pendoEvent,
                attributes
            ]);
            $76c604c1de726c59$var$waitForPendoReadiness();
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $4Jd69.logError)('pendoTrackEvent', err);
    }
}
const $76c604c1de726c59$export$862313c5bc1d6788 = (metadata)=>{
    try {
        if ((0, $4Jd69.isPendoReady)()) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.pendo.updateOptions(metadata);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $4Jd69.logError)('pendoUpdateOptions', err);
    }
};

});
parcelRegister("4Jd69", function(module, exports) {

$parcel$export(module.exports, "logError", () => $a4ab8bc78cddcb09$export$58da9968c3170cb1);
$parcel$export(module.exports, "isPendoReady", () => $a4ab8bc78cddcb09$export$3f386d356f8c718f);

var $jcw0u = parcelRequire("jcw0u");

var $8U9Op = parcelRequire("8U9Op");
const $a4ab8bc78cddcb09$export$58da9968c3170cb1 = (errorSubject, error)=>{
    const ERROR_ID = 'polaris-error';
    (0, $jcw0u.default)({
        meta: {
            id: ERROR_ID,
            teamName: 'polaris'
        },
        attributes: {
            subject: errorSubject
        },
        error: error
    });
    (0, $8U9Op.logSafeErrorWithoutCustomerDataWrapper)(`${ERROR_ID}.${errorSubject}`, error.message, error);
};
const $a4ab8bc78cddcb09$export$3f386d356f8c718f = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window?.pendo?.isReady && typeof window.pendo.isReady === 'function' && window.pendo.isReady();

});
parcelRegister("8U9Op", function(module, exports) {

$parcel$export(module.exports, "logSafeErrorWithoutCustomerDataWrapper", () => $5cb445ae48fef3c4$export$ebd6466ba18b2f3a);

var $dJl1T = parcelRequire("dJl1T");

var $jJZqs = parcelRequire("jJZqs");




const $5cb445ae48fef3c4$export$ebd6466ba18b2f3a = async (location, message, event)=>{
    const modifiedEvent = event;
    if (modifiedEvent instanceof (0, $jJZqs.default) && modifiedEvent.originalResponse) {
        const originalResponseText = await modifiedEvent.originalResponse.text();
        modifiedEvent.message = `${modifiedEvent.message} - ${originalResponseText}`;
        delete modifiedEvent.originalResponse;
    }
    (0, $dJl1T.default).safeErrorWithoutCustomerData(location, message, modifiedEvent);
};

});



parcelRegister("1As78", function(module, exports) {

$parcel$export(module.exports, "createErrorAnalytics", () => $7cf658edd2cdbf14$export$9841879b4fea885b);
$parcel$export(module.exports, "useErrorHandlers", () => $7cf658edd2cdbf14$export$e0b4869c7401cacb);
$parcel$export(module.exports, "useOnCyclicFormulaFieldError", () => $7cf658edd2cdbf14$export$4e01d30cacaf82b8);

var $5uXOq = parcelRequire("5uXOq");

var $5E93O = parcelRequire("5E93O");

var $eOat1 = parcelRequire("eOat1");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $eW55R = parcelRequire("eW55R");

var $lH8Ty = parcelRequire("lH8Ty");

var $l6caf = parcelRequire("l6caf");

var $aiePb = parcelRequire("aiePb");
const $7cf658edd2cdbf14$export$9841879b4fea885b = (id, error, options)=>({
        meta: {
            id: id
        },
        error: error,
        sendToPrivacyUnsafeSplunk: options?.sendToPrivacyUnsafeSplunk ?? true,
        skipSentry: options?.skipSentry ?? false
    });
const $7cf658edd2cdbf14$var$handleCallback = (errorObject, callback)=>{
    callback && callback((0, $aiePb.getMetadata)(errorObject));
};
const $7cf658edd2cdbf14$var$useGeneralDataLoadingFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((errorObject, callback)=>{
        $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).serverLoadFailedDescription)
        });
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalDataLoadingFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $7cf658edd2cdbf14$var$useGeneralDataUpdateFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { error: error, errorWithRefresh: errorWithRefresh, customFlag: customFlag } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((errorObject, callback)=>{
        $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalDataUpdateFailed', errorObject));
        const entityLimitError = (0, $lH8Ty.getEntityLimitError)(errorObject);
        if (entityLimitError) {
            const errorMessage = (0, $lH8Ty.getErrorMessageDescriptor)(entityLimitError);
            return errorMessage ? customFlag({
                title: formatMessage((0, $l6caf.default).entityLimitErrorTitle),
                description: formatMessage(errorMessage, {
                    item: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), null, chunks)
                }),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
                    spacing: "spacious",
                    label: "Error",
                    color: "var(--ds-icon-danger, #C9372C)"
                })
            }) : null;
        }
        if ((0, $aiePb.isPermissionError)(errorObject)) return error({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).permissionErrorDescription)
        });
        if ((0, $aiePb.isConfigError)(errorObject)) return error({
            title: formatMessage((0, $l6caf.default).configErrorTitle),
            description: formatMessage((0, $l6caf.default).configErrorDescription)
        });
        errorWithRefresh({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).serverUpdateFailedDescription)
        });
    }, [
        customFlag,
        error,
        errorWithRefresh,
        formatMessage
    ]);
};
const $7cf658edd2cdbf14$var$useGeneralActionFailedHandling = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((errorObject, callback)=>{
        $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).errorDescription)
        });
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $7cf658edd2cdbf14$var$usePossibleAccessLossError = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { errorWithRefresh: errorWithRefresh } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((errorObject, callback)=>{
        $7cf658edd2cdbf14$var$handleCallback(errorObject, callback);
        errorWithRefresh({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).errorPossibleAccessLoss)
        });
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.generalActionFailed', errorObject));
    }, [
        errorWithRefresh,
        formatMessage
    ]);
};
const $7cf658edd2cdbf14$export$e0b4869c7401cacb = ()=>{
    const possibleAccessLossError = $7cf658edd2cdbf14$var$usePossibleAccessLossError();
    const generalActionFailedError = $7cf658edd2cdbf14$var$useGeneralActionFailedHandling();
    const generalDataUpdateFailedError = $7cf658edd2cdbf14$var$useGeneralDataUpdateFailedHandling();
    const generalDataLoadingFailedError = $7cf658edd2cdbf14$var$useGeneralDataLoadingFailedHandling();
    return (0, $5uXOq.useMemo)(()=>({
            possibleAccessLossError: possibleAccessLossError,
            generalActionFailedError: generalActionFailedError,
            generalDataUpdateFailedError: generalDataUpdateFailedError,
            generalDataLoadingFailedError: generalDataLoadingFailedError
        }), [
        possibleAccessLossError,
        generalActionFailedError,
        generalDataUpdateFailedError,
        generalDataLoadingFailedError
    ]);
};
const $7cf658edd2cdbf14$export$4e01d30cacaf82b8 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { error: error } = (0, $eW55R.useNotifications)();
    return (0, $5uXOq.useCallback)((fieldLabels)=>{
        error({
            title: formatMessage((0, $l6caf.default).errorTitle),
            description: formatMessage((0, $l6caf.default).cyclicFormulaFieldDescription, {
                fieldLabels: fieldLabels.join(', ')
            })
        });
        (0, $jcw0u.default)($7cf658edd2cdbf14$export$9841879b4fea885b('polaris.error.cyclicFormula', new Error('Cyclic formula field')));
    }, [
        error,
        formatMessage
    ]);
};

});
parcelRegister("eW55R", function(module, exports) {

$parcel$export(module.exports, "useNotifications", () => $3e7591c0992d0e62$export$53d5ca6c3f53e109);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $bMdrA = parcelRequire("bMdrA");

var $5E93O = parcelRequire("5E93O");

var $7R4eB = parcelRequire("7R4eB");
var $d4xRU = parcelRequire("d4xRU");
var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");
const $3e7591c0992d0e62$var$customFlagCommon = (notification, onDismiss, AkFlagComponent)=>{
    const id = (0, $7Jxgt.v4)();
    return {
        id: id,
        render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkFlagComponent, {
                id: id,
                ...notification,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                onDismissed: (flagId)=>onDismiss(flagId),
                ...props,
                messageId: notification.messageId ?? `polaris-lib-notifications.controllers.ak-flag-component.${id}`,
                messageType: notification.messageType ?? 'transactional'
            })
    };
};
const $3e7591c0992d0e62$var$customFlag = (notification, onDismiss)=>$3e7591c0992d0e62$var$customFlagCommon(notification, onDismiss, (0, $d4xRU.default));
const $3e7591c0992d0e62$var$customAutoDismissFlag = (notification, onDismiss)=>$3e7591c0992d0e62$var$customFlagCommon(notification, onDismiss, (0, $7R4eB.default));
const $3e7591c0992d0e62$var$success = (notification, onDismiss)=>$3e7591c0992d0e62$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.success.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))), {
            spacing: "spacious",
            label: "Success icon",
            color: "var(--ds-icon-success, #22A06B)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.success',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.success',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e7591c0992d0e62$var$errorWithRefresh = (notification, onDismiss)=>$3e7591c0992d0e62$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: [
            ...notification.actions || [],
            {
                content: 'Refresh',
                testId: 'refresh',
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.reload()
            }
        ].map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error-refresh.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error-refresh',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.errorWithRefresh',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e7591c0992d0e62$var$error = (notification, onDismiss)=>$3e7591c0992d0e62$var$customAutoDismissFlag({
        title: notification.title,
        description: notification.description,
        actions: notification.actions?.map((action, index)=>({
                ...action,
                testId: `polaris.nofitication.error.action.${action.testId !== undefined ? action.testId : `action-${index + 1}`}`
            })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        appearance: 'normal',
        testId: 'polaris-lib-notifications.controllers.notification.error',
        messageId: notification.messageId ?? 'polaris-lib-notifications.controllers.customAutoDismissFlag.error',
        messageType: notification.messageType ?? 'transactional'
    }, onDismiss);
const $3e7591c0992d0e62$export$53d5ca6c3f53e109 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    return (0, $5uXOq.useMemo)(()=>({
            customFlag: (notification)=>{
                const flagId = showFlag($3e7591c0992d0e62$var$customFlag(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            success: (notification)=>{
                const flagId = showFlag($3e7591c0992d0e62$var$success(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            errorWithRefresh: (notification)=>{
                const flagId = showFlag($3e7591c0992d0e62$var$errorWithRefresh(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            error: (notification)=>{
                const flagId = showFlag($3e7591c0992d0e62$var$error(notification, dismissFlag));
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $7HGHK.toFlagId)((0, $7Jxgt.v4)());
                const flagId = showFlag({
                    ...flag,
                    id: id,
                    key: id,
                    messageId: flag.messageId ?? `polaris-lib-notifications.controllers.showFlag.${id}`,
                    messageType: flag.messageType ?? 'transactional'
                });
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            showCustomFlag: (flag)=>{
                const id = flag.id !== undefined ? flag.id : (0, $7HGHK.toFlagId)((0, $7Jxgt.v4)());
                const flagId = showFlag({
                    messageId: `polaris-lib-notifications.controllers.showCustomFlag.${id}`,
                    messageType: 'transactional',
                    ...flag,
                    id: id
                });
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return ()=>dismissFlag(flagId);
            },
            dismissFlag: dismissFlag
        }), [
        showFlag,
        dismissFlag
    ]);
};

});
parcelRegister("7R4eB", function(module, exports) {

$parcel$export(module.exports, "default", () => $435170f9f2349b2e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iNWLk = parcelRequire("iNWLk");

var $3KRpp = parcelRequire("3KRpp");
const $435170f9f2349b2e$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.CommonFlag), {
        isAutoDismiss: true,
        ...props,
        flagType: "info"
    }));
var $435170f9f2349b2e$export$2e2bcd8739ae039 = $435170f9f2349b2e$var$AkAutoDismissFlag;

});

parcelRegister("d4xRU", function(module, exports) {

$parcel$export(module.exports, "default", () => $61381db0e069bc03$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iNWLk = parcelRequire("iNWLk");

var $3KRpp = parcelRequire("3KRpp");
const $61381db0e069bc03$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.CommonFlag), {
        flagType: "info",
        ...props
    }));
var $61381db0e069bc03$export$2e2bcd8739ae039 = $61381db0e069bc03$var$AkFlag;

});


parcelRegister("lH8Ty", function(module, exports) {

$parcel$export(module.exports, "EntityLimitError", () => $bbaa521f44d79b10$export$c4e01b2c2ba95919);
$parcel$export(module.exports, "getEntityLimitError", () => $bbaa521f44d79b10$export$13f6f9a6b905ebbd);
$parcel$export(module.exports, "getErrorMessageDescriptor", () => $bbaa521f44d79b10$export$cf58cbb2768ea4f);

var $e3a3O = parcelRequire("e3a3O");

var $ht021 = parcelRequire("ht021");

var $j7a90 = parcelRequire("j7a90");

var $lTDxG = parcelRequire("lTDxG");
class $bbaa521f44d79b10$export$c4e01b2c2ba95919 extends (0, $ht021.default) {
    constructor(message, errors = [], statusCode = null, type){
        super(message, {
            cause: errors[0]
        }), this.name = 'EntityLimitError';
        this.errors = errors;
        this.statusCode = statusCode;
        this.type = type;
    }
}
const $bbaa521f44d79b10$export$13f6f9a6b905ebbd = (error)=>{
    // If already an EntityLimitError, return it
    if (error instanceof $bbaa521f44d79b10$export$c4e01b2c2ba95919) return error;
    // If not an ApolloError, return null as we can't handle it
    if (!(error instanceof (0, $e3a3O.ApolloError))) return null;
    // Get first entity limit error
    const entityLimitError = error.graphQLErrors?.filter((err)=>err.extensions?.limitType)[0];
    // If no entity limit error or no extensions, return null
    if (!entityLimitError?.extensions) return null;
    const { statusCode: statusCode, limitType: limitType } = entityLimitError.extensions;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const entityLimitErrorType = (0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE)[limitType];
    return new $bbaa521f44d79b10$export$c4e01b2c2ba95919(entityLimitError.message, [
        {
            error: entityLimitError.message
        }
    ], statusCode, entityLimitErrorType);
};
const $bbaa521f44d79b10$export$cf58cbb2768ea4f = (error)=>(0, $j7a90.default)[error.type] || null;

});
parcelRegister("j7a90", function(module, exports) {

$parcel$export(module.exports, "default", () => $6233b95581c40425$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");

var $lTDxG = parcelRequire("lTDxG");
var $6233b95581c40425$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    /* eslint-disable jira/i18n/id-named-by-package */ [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).COMMENTS_PER_VIEW]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.comments-per-view",
        "defaultMessage": "We couldn\u2019t create a new <item>comment</item> because this <item>view</item> has reached its limit for <item>comments</item>. Remove <item>comment</item> to create a new <item>comment</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_VIEW]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.fields-per-view",
        "defaultMessage": "We couldn\u2019t create a new <item>field</item> because this <item>view</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).FIELDS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.fields-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>field</item> because this <item>project</item> has reached its limit for <item>fields</item>. Remove <item>field</item> to create a new <item>field</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_IDEA]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.insights-per-idea",
        "defaultMessage": "We couldn\u2019t create a new <item>insight</item> because this <item>idea</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).INSIGHTS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.insights-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>insight</item> because this <item>project</item> has reached its limit for <item>insights</item>. Remove <item>insight</item> to create a new <item>insight</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).LABELS_PER_SNIPPET]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.labels-per-snippet",
        "defaultMessage": "We couldn\u2019t create a new <item>label</item> because this <item>snippet</item> has reached its limit for <item>labels</item>. Remove <item>label</item> to create a new <item>label</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).OPTIONS_PER_FIELD]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.options-per-field",
        "defaultMessage": "We couldn\u2019t create a new <item>option</item> because this <item>field</item> has reached its limit for <item>options</item>. Remove <item>option</item> to create a new <item>option</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PLAY]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-play",
        "defaultMessage": "We couldn\u2019t create a new <item>vote contribution</item> because this <item>vote</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).PLAY_CONTRIBUTIONS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.play-contributions-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>vote contribution</item> because this <item>project</item> has reached its limit for <item>vote contributions</item>. Remove <item>vote contribution</item> to create a new <item>vote contribution</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).PLAYS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.plays-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>vote</item> because this <item>project</item> has reached its limit for <item>votes</item>. Remove <item>vote</item> to create a new <item>vote</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).SNIPPETS_PER_INSIGHT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.snippets-per-insight",
        "defaultMessage": "We couldn\u2019t create a new <item>snippet</item> because this <item>insight</item> has reached its limit for <item>snippets</item>. Remove <item>snippet</item> to create a new <item>snippet</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).VIEWS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.views-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>view</item> because this <item>project</item> has reached its limit for <item>views</item>. Remove <item>view</item> to create a new <item>view</item>"
    },
    [(0, $lTDxG.ENTITY_LIMIT_ERROR_TYPE).VIEWSETS_PER_PROJECT]: {
        "id": "polaris-lib-errors.controllers.entity-limit-error.viewsets-per-project",
        "defaultMessage": "We couldn\u2019t create a new <item>section</item> because this <item>project</item> has reached its limit for <item>sections</item>. Remove <item>section</item> to create a new <item>section</item>"
    }
});

});
parcelRegister("lTDxG", function(module, exports) {

$parcel$export(module.exports, "ENTITY_LIMIT_ERROR_TYPE", () => $557259e823a7e117$export$a197d88688faa32c);
const $557259e823a7e117$export$a197d88688faa32c = {
    COMMENTS_PER_VIEW: 'commentsPerView',
    FIELDS_PER_VIEW: 'fieldsPerView',
    FIELDS_PER_PROJECT: 'fieldsPerProject',
    INSIGHTS_PER_IDEA: 'insightsPerIdea',
    INSIGHTS_PER_PROJECT: 'insightsPerProject',
    LABELS_PER_SNIPPET: 'labelsPerSnippet',
    OPTIONS_PER_FIELD: 'optionsPerField',
    PLAY_CONTRIBUTIONS_PER_PLAY: 'playContributionsPerPlay',
    PLAY_CONTRIBUTIONS_PER_PROJECT: 'playContributionsPerProject',
    PLAYS_PER_PROJECT: 'playsPerProject',
    SNIPPETS_PER_INSIGHT: 'snippetsPerInsight',
    VIEWS_PER_PROJECT: 'viewsPerProject',
    VIEWSETS_PER_PROJECT: 'viewsetsPerProject'
};

});



parcelRegister("l6caf", function(module, exports) {

$parcel$export(module.exports, "default", () => $891c8f37fb7de7f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $891c8f37fb7de7f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "polaris-lib-errors.controllers.error-title",
        "defaultMessage": "Something went wrong."
    },
    permissionErrorDescription: {
        "id": "polaris-lib-errors.controllers.permission-error-description",
        "defaultMessage": "You may not have the permissions required to perform this operation."
    },
    configErrorTitle: {
        "id": "polaris-lib-errors.controllers.config-error-title",
        "defaultMessage": "We couldn't save that."
    },
    configErrorDescription: {
        "id": "polaris-lib-errors.controllers.config-error-description",
        "defaultMessage": "This usually happens because the configuration data on this field is too big. Contact support for more details"
    },
    serverLoadFailedDescription: {
        "id": "polaris-lib-errors.controllers.server-load-failed-description",
        "defaultMessage": "We had difficulties to fetch some data from the server. Please refresh the page."
    },
    serverUpdateFailedDescription: {
        "id": "polaris-lib-errors.controllers.server-update-failed-description",
        "defaultMessage": "We had some difficulties to save some data to the server. Please try again or refresh the page."
    },
    errorDescription: {
        "id": "polaris-lib-errors.controllers.error-description",
        "defaultMessage": "We failed to execute your last operation. Our team has been notified. Please refresh the page to try again."
    },
    workflowLoadingFailedDescription: {
        "id": "polaris-lib-errors.controllers.workflow-loading-failed-description",
        "defaultMessage": "We had some difficulties to load some workflow data from the server. Please refresh the page."
    },
    errorPossibleAccessLoss: {
        "id": "polaris-lib-errors.controllers.error-possible-access-loss",
        "defaultMessage": "You may have lost access to the project or site. Please refresh the page."
    },
    cyclicFormulaFieldDescription: {
        "id": "polaris-lib-errors.controllers.cyclic-formula-field-description",
        "defaultMessage": "We cannot calculate the value of some fields because they contain a cyclic formula. Please edit the field configurations and refresh: {fieldLabels}"
    },
    entityLimitErrorTitle: {
        "id": "polaris-lib-errors.controllers.entity-limit-error-title",
        "defaultMessage": "You\u2019ve hit a limit"
    }
});

});

parcelRegister("aiePb", function(module, exports) {

$parcel$export(module.exports, "isPermissionError", () => $b7e19fcceac7c31b$export$e11674744930cd15);
$parcel$export(module.exports, "isRateLimitError", () => $b7e19fcceac7c31b$export$a8908c3867f6f20b);
$parcel$export(module.exports, "isAccessForbiddenError", () => $b7e19fcceac7c31b$export$443ae86cf12ba84);
$parcel$export(module.exports, "isNotFoundError", () => $b7e19fcceac7c31b$export$6ccdb59d3479f4f1);
$parcel$export(module.exports, "isClientClosedError", () => $b7e19fcceac7c31b$export$ce14333297f1d017);
$parcel$export(module.exports, "isBadRequest", () => $b7e19fcceac7c31b$export$9ec5d1f0bf2939c);
$parcel$export(module.exports, "isConfigError", () => $b7e19fcceac7c31b$export$5e48c9e1c3c8f299);
$parcel$export(module.exports, "getMetadata", () => $b7e19fcceac7c31b$export$8548546c0aa631e6);

var $561FV = parcelRequire("561FV");

var $8LQ84 = parcelRequire("8LQ84");

var $icGZu = parcelRequire("icGZu");
const $b7e19fcceac7c31b$export$e11674744930cd15 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 401 || errorObject.statusCode === 403;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'graphQLErrors') && (0, (/*@__PURE__*/$parcel$interopDefault($8LQ84)))(errorObject.graphQLErrors)) // graphql response error, check polaris-specific payload
    return (0, (/*@__PURE__*/$parcel$interopDefault($icGZu)))(errorObject.graphQLErrors, (error)=>{
        const safeMessage = error.message || '';
        return error.extensions?.statusCode === 403 || error.extensions?.statusCode === 401 || safeMessage.includes('JIRA_ACCESS_NOT_PERMITTED') || safeMessage.includes('RequestStatus: 401') || safeMessage.includes('RequestStatus: 403') || safeMessage.includes('status code 401') || // that's probably obsolete
        safeMessage.includes('status code 403') // that's probably obsolete
        ;
    });
    return false;
};
const $b7e19fcceac7c31b$var$checkRateLimitErrorMatch = (error)=>{
    const safeMessage = error?.message || '';
    return error && 'statusCode' in error && error?.statusCode === 429 || error && 'extensions' in error && error.extensions?.statusCode === 429 || safeMessage.includes('RequestStatus: 429') || safeMessage.includes('status code 429');
};
const $b7e19fcceac7c31b$export$a8908c3867f6f20b = (errorObject)=>{
    return $b7e19fcceac7c31b$var$checkRateLimitErrorMatch(errorObject) || errorObject.networkError && $b7e19fcceac7c31b$var$checkRateLimitErrorMatch(errorObject.networkError) || errorObject?.graphQLErrors?.some((error)=>$b7e19fcceac7c31b$var$checkRateLimitErrorMatch(error)) || false;
};
const $b7e19fcceac7c31b$export$443ae86cf12ba84 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 403;
    return false;
};
const $b7e19fcceac7c31b$export$6ccdb59d3479f4f1 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 404;
    return false;
};
const $b7e19fcceac7c31b$export$ce14333297f1d017 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode')) // http response error, check status code
    return errorObject.statusCode === 499;
    return false;
};
const $b7e19fcceac7c31b$export$9ec5d1f0bf2939c = (errorObject)=>{
    if (errorObject?.statusCode) // http response error, check status code
    return errorObject?.statusCode >= 400 && errorObject?.statusCode < 500;
    return false;
};
const $b7e19fcceac7c31b$export$5e48c9e1c3c8f299 = (errorObject)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'statusCode') && (0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(errorObject, 'message')) return errorObject.statusCode === 500 && errorObject.message === 'Property is too long';
    return false;
};
const $b7e19fcceac7c31b$export$8548546c0aa631e6 = (errorObject)=>({
        metadata: {
            error: errorObject.message
        }
    });

});
parcelRegister("icGZu", function(module, exports) {

var $2k3l6 = parcelRequire("2k3l6");

var $bxDef = parcelRequire("bxDef");

var $6kYP8 = parcelRequire("6kYP8");

var $8LQ84 = parcelRequire("8LQ84");

var $4rDUz = parcelRequire("4rDUz");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $d40ab2104a331ebd$var$some(collection, predicate, guard) {
    var func = $8LQ84(collection) ? $2k3l6 : $6kYP8;
    if (guard && $4rDUz(collection, predicate, guard)) predicate = undefined;
    return func(collection, $bxDef(predicate, 3));
}
module.exports = $d40ab2104a331ebd$var$some;

});
parcelRegister("6kYP8", function(module, exports) {

var $e7pfQ = parcelRequire("e7pfQ");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $49d3cab0435826ab$var$baseSome(collection, predicate) {
    var result;
    $e7pfQ(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $49d3cab0435826ab$var$baseSome;

});




parcelRegister("8EJ2P", function(module, exports) {

$parcel$export(module.exports, "createCollection", () => $18031dc7a5aa6b32$export$c74125a8e3af6bb2);
$parcel$export(module.exports, "fetchCollection", () => $18031dc7a5aa6b32$export$efeb96fc7f2aeaf9);
$parcel$export(module.exports, "fetchAllCollections", () => $18031dc7a5aa6b32$export$fb62ec897a9d1e05);
$parcel$export(module.exports, "deleteCollection", () => $18031dc7a5aa6b32$export$3d16e031f6551662);
$parcel$export(module.exports, "updateCollection", () => $18031dc7a5aa6b32$export$c0683150b517c317);
$parcel$export(module.exports, "fetchCollectionsViewsCounts", () => $18031dc7a5aa6b32$export$4ead91e2f6058f41);
$parcel$export(module.exports, "fetchCollectionDescription", () => $18031dc7a5aa6b32$export$8cd86b5346d1e786);
$parcel$export(module.exports, "cloneCollection", () => $18031dc7a5aa6b32$export$d753eba18153f51e);

var $7f4tk = parcelRequire("7f4tk");

var $eusud = parcelRequire("eusud");

var $b2npD = parcelRequire("b2npD");

var $dpYV0 = parcelRequire("dpYV0");

var $cPshp = parcelRequire("cPshp");
const $18031dc7a5aa6b32$var$generateProjectKeys = (jql)=>{
    return (0, $dpYV0.extractProjectKeysFromJql)(jql);
};
const $18031dc7a5aa6b32$export$c74125a8e3af6bb2 = (collectionToCreate)=>(0, $eusud.performPostRequest)(`${(0, $b2npD.getJpdViewsServicePathPrefix)()}/v1/collections`, {
        body: JSON.stringify(collectionToCreate)
    }).then((response)=>({
            uuid: response.uuid,
            name: response.name,
            emoji: response.emoji,
            color: response.color,
            jql: response.jql,
            ownerId: response.owner,
            projectKeys: $18031dc7a5aa6b32$var$generateProjectKeys(response.jql),
            filtersJql: (0, $dpYV0.extractFiltersJqlFromJql)(response.jql)
        }));
const $18031dc7a5aa6b32$export$efeb96fc7f2aeaf9 = (collectionUUID, shouldIncludeViews = false)=>(0, $7f4tk.default)(`${(0, $b2npD.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}${shouldIncludeViews ? '?expand=views' : ''}`).then((response)=>({
            uuid: response.uuid,
            name: response.name,
            emoji: response.emoji,
            color: response.color,
            jql: response.jql,
            ownerId: response.owner,
            views: response.views?.map((0, $cPshp.transformView)),
            projectKeys: $18031dc7a5aa6b32$var$generateProjectKeys(response.jql),
            filtersJql: (0, $dpYV0.extractFiltersJqlFromJql)(response.jql)
        }));
const $18031dc7a5aa6b32$export$fb62ec897a9d1e05 = ()=>(0, $7f4tk.default)(`${(0, $b2npD.getJpdViewsServicePathPrefix)()}/v1/collections`).then(({ collections: collections })=>collections.map((collection)=>({
                uuid: collection.uuid,
                name: collection.name,
                emoji: collection.emoji,
                color: collection.color,
                jql: collection.jql,
                ownerId: collection.owner,
                projectKeys: $18031dc7a5aa6b32$var$generateProjectKeys(collection.jql),
                filtersJql: (0, $dpYV0.extractFiltersJqlFromJql)(collection.jql)
            })));
const $18031dc7a5aa6b32$export$3d16e031f6551662 = async (collectionUUID)=>{
    await (0, $eusud.performDeleteRequest)(`${(0, $b2npD.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}`);
};
const $18031dc7a5aa6b32$export$c0683150b517c317 = async (collectionUUID, collectionToUpdate)=>{
    await (0, $eusud.performPutRequest)(`${(0, $b2npD.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}`, {
        body: JSON.stringify(collectionToUpdate)
    });
};
const $18031dc7a5aa6b32$export$4ead91e2f6058f41 = (collectionsUUIDs)=>(0, $eusud.performPostRequest)(`${(0, $b2npD.getJpdViewsServicePathPrefix)()}/v1/collections/views-count`, {
        body: JSON.stringify({
            uuids: collectionsUUIDs
        })
    });
const $18031dc7a5aa6b32$export$8cd86b5346d1e786 = (collectionUUID)=>(0, $7f4tk.default)(`${(0, $b2npD.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/description`);
const $18031dc7a5aa6b32$export$d753eba18153f51e = (collectionUUID, newCollectionName)=>(0, $eusud.performPostRequest)(`${(0, $b2npD.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/clone`, {
        body: JSON.stringify({
            name: newCollectionName
        })
    });

});
parcelRegister("b2npD", function(module, exports) {

$parcel$export(module.exports, "getJpdViewsServicePathPrefix", () => $234049bfb6060538$export$1d2754f769c8a3c6);
const $234049bfb6060538$export$1d2754f769c8a3c6 = ()=>{
    return '/gateway/api/jpd';
};

});

parcelRegister("cPshp", function(module, exports) {

$parcel$export(module.exports, "transformView", () => $173999f9e481de31$export$601ea8be46c5c28c);
const $173999f9e481de31$export$601ea8be46c5c28c = (view)=>({
        uuid: view.uuid,
        ownerId: view.owner,
        kind: view.visualizationType,
        title: view.name,
        emoji: view.emoji,
        description: view.description,
        apiResponse: view
    });

});



parcelRegister("2ejmj", function(module, exports) {

$parcel$export(module.exports, "createView", () => $b949e30510085a07$export$d7febe7b891e79f0);
$parcel$export(module.exports, "fetchCollectionsViewsCounts", () => $b949e30510085a07$export$4ead91e2f6058f41);
$parcel$export(module.exports, "deleteView", () => $b949e30510085a07$export$443d89549b135c95);

var $dPSWJ = parcelRequire("dPSWJ");

var $jcw0u = parcelRequire("jcw0u");

var $eiARp = parcelRequire("eiARp");

var $jDD5V = parcelRequire("jDD5V");

var $1As78 = parcelRequire("1As78");

var $8EJ2P = parcelRequire("8EJ2P");

var $gtfOZ = parcelRequire("gtfOZ");
const $b949e30510085a07$export$d7febe7b891e79f0 = (collectionUUID, view)=>async ({ setState: setState, getState: getState })=>{
        try {
            const state = getState();
            const existingCollection = state.collections[collectionUUID];
            const data = existingCollection?.data;
            if (!data) return;
            return await (0, $jDD5V.wrapWithExperience)((0, $eiARp.experience).collections.createView, async ()=>{
                const newView = await (0, $gtfOZ.createView)(collectionUUID, view);
                setState({
                    collections: {
                        ...state.collections,
                        [collectionUUID]: {
                            ...existingCollection,
                            data: {
                                ...data,
                                views: [
                                    ...data?.views || [],
                                    newView
                                ]
                            }
                        }
                    }
                });
                return newView;
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.error.collectionViewCreationFailed', error));
                throw error;
            }
        }
    };
const $b949e30510085a07$export$4ead91e2f6058f41 = ()=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const collectionsUUIDs = Object.keys(state.collections);
        if (collectionsUUIDs.length === 0) return;
        try {
            await (0, $jDD5V.wrapWithExperience)((0, $eiARp.experience).collections.loadViewCount, async ()=>{
                const collectionsViewsCountMap = await (0, $8EJ2P.fetchCollectionsViewsCounts)(collectionsUUIDs);
                setState({
                    collections: (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(state.collections, (collection)=>{
                        if (collection?.data) return {
                            ...collection,
                            data: {
                                ...collection.data,
                                viewsCount: collectionsViewsCountMap[collection.data.uuid] || 0
                            }
                        };
                        return collection;
                    })
                });
            });
        } catch (error) {
            if (error instanceof Error) (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.error.collectionsViewsCountLoadingFailed', error));
            throw error;
        }
    };
const $b949e30510085a07$export$443d89549b135c95 = (collectionUUID, viewUUID)=>async ({ setState: setState, getState: getState })=>{
        try {
            const state = getState();
            const existingCollection = state.collections[collectionUUID];
            const data = existingCollection?.data;
            if (!data) return;
            await (0, $jDD5V.wrapWithExperience)((0, $eiARp.experience).collections.deleteView, async ()=>{
                await (0, $gtfOZ.deleteView)(collectionUUID, viewUUID);
                setState({
                    collections: {
                        ...state.collections,
                        [collectionUUID]: {
                            ...existingCollection,
                            data: {
                                ...data,
                                viewsCount: data.viewsCount ? data.viewsCount - 1 : undefined,
                                views: data?.views?.filter((view)=>view.uuid !== viewUUID)
                            }
                        }
                    }
                });
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.error.collectionViewDeletionFailed', error));
                throw error;
            }
        }
    };

});
parcelRegister("dPSWJ", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $hDnyx = parcelRequire("hDnyx");

var $bxDef = parcelRequire("bxDef");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $a12aa8fd8ab9a7da$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $bxDef(iteratee, 3);
    $hDnyx(object, function(value, key, object) {
        $1m3dq(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $a12aa8fd8ab9a7da$var$mapValues;

});

parcelRegister("gtfOZ", function(module, exports) {

$parcel$export(module.exports, "createView", () => $9832d7839d9f46b2$export$d7febe7b891e79f0);
$parcel$export(module.exports, "deleteView", () => $9832d7839d9f46b2$export$443d89549b135c95);

var $eusud = parcelRequire("eusud");

var $b2npD = parcelRequire("b2npD");

var $cPshp = parcelRequire("cPshp");
const $9832d7839d9f46b2$export$d7febe7b891e79f0 = (collectionUUID, viewToCreate)=>(0, $eusud.performPostRequest)(`${(0, $b2npD.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/views`, {
        body: JSON.stringify(viewToCreate)
    }).then((0, $cPshp.transformView));
const $9832d7839d9f46b2$export$443d89549b135c95 = async (collectionUUID, viewUUID)=>{
    await (0, $eusud.performDeleteRequest)(`${(0, $b2npD.getJpdViewsServicePathPrefix)()}/v1/collections/${collectionUUID}/views/${viewUUID}`);
};

});


parcelRegister("3WCAK", function(module, exports) {

$parcel$export(module.exports, "loadCollectionDescription", () => $c0c970158da04e57$export$da25d48c64ab9a24);
$parcel$export(module.exports, "updateCollectionDescription", () => $c0c970158da04e57$export$95146d83152efba8);

var $jcw0u = parcelRequire("jcw0u");

var $eiARp = parcelRequire("eiARp");

var $jDD5V = parcelRequire("jDD5V");

var $1As78 = parcelRequire("1As78");

var $8EJ2P = parcelRequire("8EJ2P");
const $c0c970158da04e57$export$da25d48c64ab9a24 = (collectionUUID)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const existingDescription = state.descriptions[collectionUUID];
        if (existingDescription?.isLoading || existingDescription && !existingDescription.error) return;
        try {
            await (0, $jDD5V.wrapWithExperience)((0, $eiARp.experience).collections.loadCollectionDescription, async ()=>{
                setState({
                    descriptions: {
                        ...state.descriptions,
                        [collectionUUID]: {
                            description: undefined,
                            isLoading: true,
                            error: undefined
                        }
                    }
                });
                const newDescription = await (0, $8EJ2P.fetchCollectionDescription)(collectionUUID);
                setState({
                    descriptions: {
                        ...state.descriptions,
                        [collectionUUID]: {
                            description: newDescription ?? undefined,
                            isLoading: false
                        }
                    }
                });
            });
        } catch (error) {
            if (error instanceof Error) {
                (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.error.collectionDescriptionLoadingFailed', error));
                setState({
                    descriptions: {
                        ...state.descriptions,
                        [collectionUUID]: {
                            description: undefined,
                            isLoading: false,
                            error: error
                        }
                    }
                });
            }
            throw error;
        }
    };
const $c0c970158da04e57$export$95146d83152efba8 = (collectionUUID, description)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        const existingCollection = state.collections[collectionUUID];
        const data = existingCollection?.data;
        if (!data) return;
        try {
            await (0, $jDD5V.wrapWithExperience)((0, $eiARp.experience).collections.updateCollectionDescription, async ()=>{
                await (0, $8EJ2P.updateCollection)(collectionUUID, {
                    ...data,
                    description: description
                });
                setState({
                    descriptions: {
                        ...state.descriptions,
                        [collectionUUID]: {
                            isLoading: false,
                            error: undefined,
                            description: description
                        }
                    }
                });
            });
        } catch (error) {
            if (error instanceof Error) (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.error.collectionDescriptionUpdateFailed', error));
            throw error;
        }
    };

});


parcelRegister("emOwp", function(module, exports) {

$parcel$export(module.exports, "filterCollectionByOwnerIds", () => $fb72f39750296f26$export$a5af2fa2fc5a6608);
$parcel$export(module.exports, "filterCollectionByProjectKeys", () => $fb72f39750296f26$export$197fb91166111e5e);
$parcel$export(module.exports, "filterCollectionByText", () => $fb72f39750296f26$export$29aabb123440d65b);
const $fb72f39750296f26$export$a5af2fa2fc5a6608 = (ownerIds)=>(collection)=>!ownerIds?.length || ownerIds.some((accountId)=>accountId === collection.ownerId);
const $fb72f39750296f26$export$197fb91166111e5e = (projectKeys)=>(collection)=>!projectKeys?.length || projectKeys.some((projectKey)=>collection.projectKeys.includes(projectKey));
const $fb72f39750296f26$export$29aabb123440d65b = (search = '')=>{
    const searchLower = search.toLocaleLowerCase();
    return ({ name: name })=>!search || name?.toLocaleLowerCase().includes(searchLower);
};

});


parcelRegister("g1VWt", function(module, exports) {

$parcel$export(module.exports, "CollectionAdvancedFilters", () => $fd998ecd9eb9d2a2$export$781edcfd58dd3c44);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $0yZbT = parcelRequire("0yZbT");
var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $5KCCi = parcelRequire("5KCCi");

var $cNW3X = parcelRequire("cNW3X");

var $jlx1P = parcelRequire("jlx1P");

var $3KEIl = parcelRequire("3KEIl");

var $koVbs = parcelRequire("koVbs");

var $ifQ0j = parcelRequire("ifQ0j");

var $1aUn4 = parcelRequire("1aUn4");

var $1As78 = parcelRequire("1As78");

var $6mNgE = parcelRequire("6mNgE");

var $gd9Sf = parcelRequire("gd9Sf");

var $2Be3a = parcelRequire("2Be3a");
const $fd998ecd9eb9d2a2$var$AddFilterButtonComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        ref: ref,
        ...props,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jlx1P))), {
            label: formatMessage((0, $gd9Sf.default).addFilterLabel)
        })
    }, formatMessage((0, $gd9Sf.default).addFilterLabel));
});
const $fd998ecd9eb9d2a2$var$SearchModeSwitcher = ({ isBasicModeDisabled: isBasicModeDisabled, onUpdateSearchMode: onUpdateSearchMode, searchMode: searchMode })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const options = [
        {
            id: 'basic',
            label: isBasicModeDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
                content: formatMessage((0, $gd9Sf.default).basicModeDisabledTooltip),
                tag: "span"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                as: "span"
            }, formatMessage((0, $gd9Sf.default).basicMode))) : formatMessage((0, $gd9Sf.default).basicMode),
            isDisabled: isBasicModeDisabled,
            testId: ''
        },
        {
            id: 'advanced',
            label: formatMessage((0, $gd9Sf.default).advancedMode),
            testId: ''
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        paddingBlockEnd: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1aUn4.default), {
        label: formatMessage((0, $gd9Sf.default).label),
        options: options,
        selectedOption: searchMode,
        onChange: (value)=>onUpdateSearchMode(value)
    }));
};
const $fd998ecd9eb9d2a2$var$EditorContainer = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        xcss: $fd998ecd9eb9d2a2$var$editorContainerStyles
    }, children);
const $fd998ecd9eb9d2a2$var$excludedFieldTypes = [
    'project',
    'jira.polaris:interval',
    'jira.polaris:formula',
    'jira.polaris:delivery-status',
    'jira.polaris:delivery-progress',
    'jira.polaris:count-issue-comments',
    'jira.polaris:count-insights',
    'jira.polaris:atlassian-project',
    'jira.polaris:atlassian-project-status',
    'com.atlassian.jira.plugin.system.customfieldtypes:goals',
    'jira.polaris:count-linked-issues',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf'
];
const $fd998ecd9eb9d2a2$export$781edcfd58dd3c44 = ({ projectKeys: projectKeys, onChange: onChange, value: value, checkDelay: checkDelay = 500 })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [errors, setErrors] = (0, $5uXOq.useState)([]);
    const [searchMode, setSearchMode] = (0, $5uXOq.useState)('basic');
    const { generalDataLoadingFailedError: generalDataLoadingFailedError } = (0, $1As78.useErrorHandlers)();
    const [availableFields, setAvailableFields] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $6mNgE.getSystemAndGlobalFieldKeys)().then((fields)=>setAvailableFields(fields)).catch(generalDataLoadingFailedError);
    }, [
        generalDataLoadingFailedError
    ]);
    const debouncedCheck = (0, $5uXOq.useMemo)(()=>{
        // Update our errors after a "checkDelay" debounce
        return (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((jql)=>{
            const jast = new (0, $3KEIl.JastBuilder)().build(jql); // Format JQL parse errors to be shown as custom error messages in the editor
            const errorMessages = jast.errors.map(({ description: description })=>({
                    message: description,
                    type: 'error'
                }));
            if (jast.query?.orderBy) errorMessages.push({
                message: formatMessage((0, $gd9Sf.default).orderByError),
                type: 'error'
            });
            setErrors(errorMessages);
            if (errorMessages.length === 0) onChange?.(jql);
        }, checkDelay);
    }, [
        checkDelay,
        formatMessage,
        onChange
    ]);
    const isFieldIncludedInAutocomplete = (0, $5uXOq.useCallback)((fieldValue)=>!!(availableFields && fieldValue && !!availableFields[fieldValue] && !$fd998ecd9eb9d2a2$var$excludedFieldTypes.includes(availableFields[fieldValue].type)), [
        availableFields
    ]);
    if (!projectKeys.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        paddingBlockStart: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text.subtlest"
    }, formatMessage((0, $gd9Sf.default).selectProjectsFirst)));
    if (!availableFields) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Be3a.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fd998ecd9eb9d2a2$var$JQLBuilderVerticalLayoutFixer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifQ0j.default), {
        query: value ?? '',
        analyticsSource: "jpdRoadmapFilters",
        components: {
            SearchModeSwitcher: $fd998ecd9eb9d2a2$var$SearchModeSwitcher,
            EditorContainer: $fd998ecd9eb9d2a2$var$EditorContainer,
            AddFilterButtonComponent: $fd998ecd9eb9d2a2$var$AddFilterButtonComponent
        },
        jqlMessages: errors,
        userPreferencesData: null,
        onUpdate: searchMode === 'basic' ? onChange : debouncedCheck,
        projectKeys: projectKeys,
        excludedFields: [
            'project'
        ],
        basicModeVisibleFields: [],
        onUpdateSearchMode: setSearchMode,
        hideTextSearchInput: true,
        isFieldIncludedInAutocomplete: isFieldIncludedInAutocomplete,
        viewContext: "JPD_ROADMAPS"
    }));
};
const $fd998ecd9eb9d2a2$var$editorContainerStyles = (0, $2s57o.xcss)({
    flex: 1
}); // Should be fixed properly by implementing vertical layout in JQLBuilder: https://pi-dev-sandbox.atlassian.net/browse/POL-13293
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $fd998ecd9eb9d2a2$var$JQLBuilderVerticalLayoutFixer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_qd1v1sxn _1is8idpf _h0jhidpf _xjm81bp4 _r2zgidpf _1ohkidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jlx1P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::739edc58ca910533dbcf168239dfad1b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e159993c6ff790f5$var$_react = $e159993c6ff790f5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e159993c6ff790f5$var$_add = $e159993c6ff790f5$var$_interopRequireDefault((parcelRequire("46OkO")));

var $e159993c6ff790f5$var$_add2 = $e159993c6ff790f5$var$_interopRequireDefault((parcelRequire("69UIa")));
function $e159993c6ff790f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e159993c6ff790f5$var$AddIcon = (props)=>/*#__PURE__*/ $e159993c6ff790f5$var$_react.default.createElement($e159993c6ff790f5$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $e159993c6ff790f5$var$_add2.default
    }, props));
$e159993c6ff790f5$var$AddIcon.Name = 'AddIconMigration';
var $e159993c6ff790f5$var$_default = module.exports.default = $e159993c6ff790f5$var$AddIcon;

});
parcelRegister("69UIa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47bf93089677178f$var$_react = $47bf93089677178f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $47bf93089677178f$var$_add = $47bf93089677178f$var$_interopRequireDefault((parcelRequire("46OkO")));
function $47bf93089677178f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $47bf93089677178f$var$AddIcon = (props)=>/*#__PURE__*/ $47bf93089677178f$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
    }, props, {
        newIcon: $47bf93089677178f$var$_add.default
    }));
$47bf93089677178f$var$AddIcon.displayName = 'AddIcon';
var $47bf93089677178f$var$_default = module.exports.default = $47bf93089677178f$var$AddIcon;

});


parcelRegister("ifQ0j", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d0241969d25b90c$export$2e2bcd8739ae039);

var $3qgE9 = parcelRequire("3qgE9");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $kGsr8 = parcelRequire("kGsr8");

var $8Uumt = parcelRequire("8Uumt");

var $gcl1l = parcelRequire("gcl1l");

var $7iJwP = parcelRequire("7iJwP");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $7ckRQ = parcelRequire("7ckRQ");

var $OomEm = parcelRequire("OomEm");

var $caSpf = parcelRequire("caSpf");

var $lfTZh = parcelRequire("lfTZh");

var $iXVV6 = parcelRequire("iXVV6");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $032ey = parcelRequire("032ey");

var $atxn1 = parcelRequire("atxn1");

var $55ttp = parcelRequire("55ttp");

var $aRep0 = parcelRequire("aRep0");

var $2G1VO = parcelRequire("2G1VO");
// Inline query when cleaning up nin_migrate_jql_builder_to_refetchable_query
/* eslint-disable @atlassian/relay/graphql-naming */ const $9d0241969d25b90c$var$JQLBUILDER_FRAGMENT = (0, $3qgE9.default);
const $9d0241969d25b90c$var$JQLBuilderOld = ({ onPerformanceMark: onPerformanceMark, ...props })=>{
    const userPreferencesRef = (0, $8Uumt.useFragment)($9d0241969d25b90c$var$JQLBUILDER_FRAGMENT, props.userPreferencesData);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "unhandled",
        packageName: "jiraJqlBuilder",
        teamName: "empanada",
        sendToPrivacyUnsafeSplunk: true,
        attributes: (0, $gcl1l.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "jqlBuilder",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $caSpf.PerformanceContext).Provider, {
        value: onPerformanceMark || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRep0.JQLBuilderUIOld), {
        ...props,
        userPreferences: userPreferencesRef
    }))));
};
const $9d0241969d25b90c$var$JQLBuilder = ({ query: query, viewContext: viewContext = null, projectKeys: projectKeys, searchModes: searchModes = [
    (0, $032ey.SEARCH_MODE_ADVANCED),
    (0, $032ey.SEARCH_MODE_BASIC)
], searchModeSwitcherLocation: searchModeSwitcherLocation = (0, $032ey.SEARCH_MODE_SWITCHER_LEFT_LOCATION), showOrderByPicker: showOrderByPicker, hideTextSearchInput: hideTextSearchInput = false, onPerformanceMark: onPerformanceMark, maybeHydrationQueryReference: maybeHydrationQueryReference, ...props })=>{
    const { onLoad: onLoad } = props;
    // Persist mode used in loading state to send in analytics
    const loadingModeRef = (0, $5uXOq.useRef)();
    const onLoadingMode = (0, $5uXOq.useCallback)((mode)=>{
        loadingModeRef.current = mode;
        onLoad?.(mode);
    }, [
        onLoad
    ]);
    const userPreferencesRef = (0, $8Uumt.useFragment)($9d0241969d25b90c$var$JQLBUILDER_FRAGMENT, props.userPreferencesData);
    const searchModeResponse = userPreferencesRef?.jqlBuilderSearchMode;
    const selectedSearchMode = (0, $atxn1.toSearchModeWithBasicModeFallback)(searchModeResponse);
    if (searchModes.length === 0) throw new Error('Search mode should be non empty');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const uniqueSearchModes = (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(searchModes);
    const isSearchModeToggleEnabled = uniqueSearchModes ? uniqueSearchModes.length > 1 : true;
    const irremovableFields = (0, $7ckRQ.useIrremovableFields)(props.basicModeVisibleFields ?? (0, $7ckRQ.DEFAULT_IRREMOVABLE_FIELDS)());
    const accountId = (0, $90yGq.useAccountId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const initialJql = (0, $5uXOq.useRef)(query);
    const initialContextJql = (0, $55ttp.useContextJql)({
        jql: initialJql.current,
        projectKeys: projectKeys
    });
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2G1VO.JQLBuilderFallback), {
        query: query,
        searchModes: searchModes,
        onLoad: onLoadingMode,
        selectedSearchMode: selectedSearchMode,
        isSearchModeToggleEnabled: isSearchModeToggleEnabled,
        beforeControls: props.beforeControls,
        renderExtraControls: props.renderExtraControls,
        excludedFields: props.excludedFields,
        components: props.components,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: props.searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        showOrderByPicker: showOrderByPicker
    });
    const [initialQueryRef, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $OomEm.HYDRATION_QUERY), (0, $4R6GH.fg)('nin_request_hydrate_query_earlier') ? maybeHydrationQueryReference : undefined);
    (0, $5uXOq.useEffect)(()=>{
        if (!initialQueryRef) loadQuery({
            accountId: accountId ?? '',
            cloudId: cloudId,
            includeUser: initialJql.current.length > 0 && !!accountId,
            includeJira: initialJql.current.length > 0,
            jql: initialContextJql,
            isFilter: false,
            filterAri: '',
            viewContext: viewContext
        }, {
            fetchPolicy: 'store-or-network',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
    /* Here we only need to initialise the query reference so we fire for the client on mount.
       We allow useRefetchableFragment in JQLBuilderUI to handle the refetching. */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "unhandled",
        packageName: "jiraJqlBuilder",
        teamName: "empanada",
        sendToPrivacyUnsafeSplunk: true,
        attributes: (0, $gcl1l.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "jqlBuilder",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $caSpf.PerformanceContext).Provider, {
        value: onPerformanceMark || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jql-builder-main",
        fallback: fallback
    }, initialQueryRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRep0.default), {
        query: query,
        searchModes: searchModes,
        selectedSearchMode: selectedSearchMode,
        isSearchModeToggleEnabled: isSearchModeToggleEnabled,
        beforeControls: props.beforeControls,
        renderExtraControls: props.renderExtraControls,
        excludedFields: props.excludedFields,
        components: props.components,
        irremovableFields: irremovableFields,
        uniqueSearchModes: uniqueSearchModes,
        hideTextSearchInput: hideTextSearchInput,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        showOrderByPicker: showOrderByPicker,
        viewContext: viewContext,
        projectKeys: projectKeys,
        userPreferences: userPreferencesRef,
        initialQueryRef: initialQueryRef,
        onLoadingMode: onLoadingMode,
        loadingModeRef: loadingModeRef,
        ...props
    }) : fallback))));
};
var $9d0241969d25b90c$export$2e2bcd8739ae039 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('nin_migrate_jql_builder_to_refetchable_query'), /*#__PURE__*/ (0, $5uXOq.memo)($9d0241969d25b90c$var$JQLBuilder), /*#__PURE__*/ (0, $5uXOq.memo)($9d0241969d25b90c$var$JQLBuilderOld));

});
parcelRegister("3qgE9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2e59103f695f715$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab8189a4d60e37ca33c72cc50edbd6c7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d2e59103f695f715$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_jqlBuilder_JQLBuilder",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_jqlBuilder_JQLBuilderUI"
        },
        {
            "kind": "ScalarField",
            "name": "jqlBuilderSearchMode"
        }
    ],
    "type": "JiraUserPreferences"
};
$d2e59103f695f715$var$node.hash = "939f009c6569621eae121104d8e94579";
var $d2e59103f695f715$export$2e2bcd8739ae039 = $d2e59103f695f715$var$node;

});

parcelRegister("gcl1l", function(module, exports) {

$parcel$export(module.exports, "isLoaderErrorAttributes", () => $ecfe970d67067a10$export$c7209ce2e0d060ea);

var $3vs13 = parcelRequire("3vs13");
const $ecfe970d67067a10$export$c7209ce2e0d060ea = (error)=>({
        isLoaderError: (0, $3vs13.isLoaderError)(error)
    });

});

parcelRegister("7ckRQ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_IRREMOVABLE_FIELDS", () => $015fe2e823c5f467$export$10049973e0522c22);
$parcel$export(module.exports, "useIrremovableFields", () => $015fe2e823c5f467$export$28001ca0e14d9f37);
$parcel$export(module.exports, "useIrremovableFieldsAnalyticsAttributes", () => $015fe2e823c5f467$export$1b10c62780608464);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $bngFq = parcelRequire("bngFq");

var $dCm1o = parcelRequire("dCm1o");

var $5Dsab = parcelRequire("5Dsab");

var $i4OXX = parcelRequire("i4OXX");
const $015fe2e823c5f467$export$10049973e0522c22 = ()=>(0, $dCm1o.isVisualRefreshEnabled)() ? [
        'project',
        'assignee',
        'type',
        'status'
    ] : [
        'project',
        'type',
        'status',
        'assignee'
    ];
/**
 * These are the built-in irremovable fields that, for convenience, can be referenced by key when
 * setting the `basicModeVisibleFields` prop. E.g.
 * ```
 * <JQLBuilder basicModeVisibleFields={['assignee']} />
 * ```
 *
 * **Any fields added here must have a unique jqlTerm across the Jira instance, usually system fields**
 *
 * TODO - Note Text is not considered an irremovable field, this will be addressed in:
 * https://jplat.jira.atlassian.cloud/browse/EM-7497
 */ const $015fe2e823c5f467$var$getBuiltInIrremovableFields = (formatMessage)=>(0, $dCm1o.isVisualRefreshEnabled)() ? {
        [(0, $5Dsab.PROJECT_FIELD_JQL_TERM)]: {
            ...(0, $5Dsab.PROJECT),
            displayName: formatMessage((0, $i4OXX.default).refinementProject)
        },
        [(0, $5Dsab.ASSIGNEE_FIELD_JQL_TERM)]: {
            ...(0, $5Dsab.ASSIGNEE),
            displayName: formatMessage((0, $i4OXX.default).refinementAssignee)
        },
        [(0, $5Dsab.TYPE_FIELD_JQL_TERM)]: {
            ...(0, $5Dsab.TYPE),
            displayName: formatMessage((0, $i4OXX.default).refinementType)
        },
        [(0, $5Dsab.STATUS_FIELD_JQL_TERM)]: {
            ...(0, $5Dsab.STATUS),
            displayName: formatMessage((0, $i4OXX.default).refinementStatus)
        },
        [(0, $5Dsab.RESOLUTION_FIELD_JQL_TERM)]: {
            ...(0, $5Dsab.RESOLUTION),
            displayName: formatMessage((0, $i4OXX.default).refinementResolution)
        },
        [(0, $5Dsab.LABELS_FIELD_JQL_TERM)]: {
            ...(0, $5Dsab.LABELS),
            displayName: formatMessage((0, $i4OXX.default).refinementLabels)
        }
    } : {
        [(0, $5Dsab.PROJECT_FIELD_JQL_TERM)]: {
            ...(0, $5Dsab.PROJECT),
            displayName: formatMessage((0, $i4OXX.default).refinementProject)
        },
        [(0, $5Dsab.TYPE_FIELD_JQL_TERM)]: {
            ...(0, $5Dsab.TYPE),
            displayName: formatMessage((0, $i4OXX.default).refinementType)
        },
        [(0, $5Dsab.STATUS_FIELD_JQL_TERM)]: {
            ...(0, $5Dsab.STATUS),
            displayName: formatMessage((0, $i4OXX.default).refinementStatus)
        },
        [(0, $5Dsab.ASSIGNEE_FIELD_JQL_TERM)]: {
            ...(0, $5Dsab.ASSIGNEE),
            displayName: formatMessage((0, $i4OXX.default).refinementAssignee)
        },
        [(0, $5Dsab.RESOLUTION_FIELD_JQL_TERM)]: {
            ...(0, $5Dsab.RESOLUTION),
            displayName: formatMessage((0, $i4OXX.default).refinementResolution)
        },
        [(0, $5Dsab.LABELS_FIELD_JQL_TERM)]: {
            ...(0, $5Dsab.LABELS),
            displayName: formatMessage((0, $i4OXX.default).refinementLabels)
        }
    };
const $015fe2e823c5f467$var$getInvalidCustomFieldProperties = ({ displayName: displayName, jqlTerm: jqlTerm, fieldType: fieldType, searchTemplate: searchTemplate, operators: operators })=>{
    const invalidFieldProps = [];
    if (!displayName) invalidFieldProps.push('displayName');
    if (!jqlTerm) invalidFieldProps.push('jqlTerm');
    if (!fieldType) invalidFieldProps.push('fieldType');
    if (!searchTemplate) invalidFieldProps.push('searchTemplate');
    if (!operators || operators.length === 0) invalidFieldProps.push('operators');
    return invalidFieldProps;
};
const $015fe2e823c5f467$export$28001ca0e14d9f37 = (irremovableFieldsConfig)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const irremovableFields = (0, $5uXOq.useMemo)(()=>{
        const builtInFields = $015fe2e823c5f467$var$getBuiltInIrremovableFields(formatMessage);
        const entries = irremovableFieldsConfig.map((keyOrField)=>{
            /*
       * keyOrField is a string, map it to a built-in system field
       */ if (typeof keyOrField === 'string') {
                const builtInField = builtInFields[keyOrField];
                if (!builtInField) throw new Error(`useIrremovableFields hook received an unsupported key: ${keyOrField}`);
                return [
                    keyOrField,
                    builtInField
                ];
            }
            /*
       * keyOrField is an IrremovableField, perform some basic validaiton and add it to the Map
       */ const invalidFieldProps = $015fe2e823c5f467$var$getInvalidCustomFieldProperties(keyOrField);
            if (invalidFieldProps.length > 0) {
                (0, $jcw0u.default)({
                    event: createAnalyticsEvent({}),
                    // forces contextual attributes be included
                    meta: {
                        id: 'useIrremovableFields',
                        packageName: (0, $5Dsab.PACKAGE_NAME),
                        teamName: (0, $5Dsab.TEAM_NAME)
                    },
                    attributes: {
                        fieldType: keyOrField.fieldType,
                        searchTemplate: keyOrField.searchTemplate,
                        invalidFieldProps: invalidFieldProps.join(',')
                    }
                });
                throw new Error('useIrremovableFields hook received an unsupported field');
            }
            /*
       * everything in JQL Builder relies on jqlTerm being lower case, otherwise weird behaviour
       * will occur when comparing the JQL query with these fields while generating pickers
       */ const jqlTerm = keyOrField.jqlTerm.toLowerCase();
            const field = {
                ...keyOrField,
                jqlTerm: jqlTerm
            };
            return [
                jqlTerm,
                field
            ];
        });
        return new Map(entries);
    }, [
        createAnalyticsEvent,
        formatMessage,
        irremovableFieldsConfig
    ]);
    return irremovableFields;
};
const $015fe2e823c5f467$export$1b10c62780608464 = (irremovableFields)=>(0, $5uXOq.useMemo)(()=>{
        const irremovableFieldTypes = [
            ...irremovableFields.values()
        ].map(({ fieldType: fieldType })=>fieldType);
        const irremovableFieldCount = irremovableFields.size;
        const isDefaultIrremovableFields = (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(Array.from(irremovableFields.keys()), $015fe2e823c5f467$export$10049973e0522c22());
        return {
            irremovableFieldTypes: irremovableFieldTypes,
            irremovableFieldCount: irremovableFieldCount,
            isDefaultIrremovableFields: isDefaultIrremovableFields
        };
    }, [
        irremovableFields
    ]);

});
parcelRegister("5Dsab", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $f231a8145cfae881$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $f231a8145cfae881$export$d57b6b390e78d90f);
$parcel$export(module.exports, "jqlAnonymizerVisitor", () => $f231a8145cfae881$export$8b46ceeb1d0f7a0f);
$parcel$export(module.exports, "PROJECT_FIELD_JQL_TERM", () => $f231a8145cfae881$export$a94927c1053f515e);
$parcel$export(module.exports, "TYPE_FIELD_JQL_TERM", () => $f231a8145cfae881$export$92a0328342946939);
$parcel$export(module.exports, "STATUS_FIELD_JQL_TERM", () => $f231a8145cfae881$export$b9f8115d86beaf2e);
$parcel$export(module.exports, "ASSIGNEE_FIELD_JQL_TERM", () => $f231a8145cfae881$export$fe13eb78c06cd416);
$parcel$export(module.exports, "RESOLUTION_FIELD_JQL_TERM", () => $f231a8145cfae881$export$45a7314200effcd0);
$parcel$export(module.exports, "LABELS_FIELD_JQL_TERM", () => $f231a8145cfae881$export$952c102639c1ed96);
$parcel$export(module.exports, "TEXT", () => $f231a8145cfae881$export$d597759d33be802e);
$parcel$export(module.exports, "PROJECT", () => $f231a8145cfae881$export$fe791c4fa892e400);
$parcel$export(module.exports, "TYPE", () => $f231a8145cfae881$export$b87f371cbc396fcf);
$parcel$export(module.exports, "STATUS", () => $f231a8145cfae881$export$e50006273435e7d4);
$parcel$export(module.exports, "ASSIGNEE", () => $f231a8145cfae881$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "RESOLUTION", () => $f231a8145cfae881$export$f1a6ce22cbb7eb32);
$parcel$export(module.exports, "LABELS", () => $f231a8145cfae881$export$79b91d4669dcadcb);
$parcel$export(module.exports, "SPRINT", () => $f231a8145cfae881$export$a316570a0dbfd2b0);
$parcel$export(module.exports, "AFFECTED_VERSION", () => $f231a8145cfae881$export$d02178e10ccc3ea);
$parcel$export(module.exports, "FIX_VERSION", () => $f231a8145cfae881$export$4c55d92eb3c27f18);
$parcel$export(module.exports, "PARENT", () => $f231a8145cfae881$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "COMPONENT", () => $f231a8145cfae881$export$af1e30ebbae9df3b);
$parcel$export(module.exports, "CREATOR", () => $f231a8145cfae881$export$39a35fc5bd7af053);
$parcel$export(module.exports, "REPORTER", () => $f231a8145cfae881$export$6d7021166edc895c);
$parcel$export(module.exports, "dateSearchTemplates", () => $f231a8145cfae881$export$ffcdf2c6c4831acc);
$parcel$export(module.exports, "userFieldSearchTemplates", () => $f231a8145cfae881$export$6616be37c70ab33f);
$parcel$export(module.exports, "EPIC_LINK", () => $f231a8145cfae881$export$19f652d3d336f069);
$parcel$export(module.exports, "appearanceMap", () => $f231a8145cfae881$export$c743cc8f0e853412);
$parcel$export(module.exports, "FunctionName", () => $f231a8145cfae881$export$4b826ede0e88b93);
$parcel$export(module.exports, "KeywordName", () => $f231a8145cfae881$export$84606816405f7142);
$parcel$export(module.exports, "OperandValues", () => $f231a8145cfae881$export$1ab4f98e21fe0811);
$parcel$export(module.exports, "CASCADE_SELECT_FIELD_SEARCH_TEMPLATE", () => $f231a8145cfae881$export$3e3df380922ad777);
$parcel$export(module.exports, "CASCADE_OPTION_FUNCTION_NAME", () => $f231a8145cfae881$export$cd361098212837ad);
$parcel$export(module.exports, "NUMBER_RANGE_FIELD_SEARCH_TEMPLATE", () => $f231a8145cfae881$export$4e0f2021e5a6dd20);
$parcel$export(module.exports, "NUMBER_RANGE_PICKER_ALLOWED_OPERATORS", () => $f231a8145cfae881$export$787eee4b393220a3);
$parcel$export(module.exports, "CMDB_FIELD_SEARCH_TEMPLATE", () => $f231a8145cfae881$export$51829c816d2b6247);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_SEARCH_TEMPLATE", () => $f231a8145cfae881$export$33aa1485e40ffbb7);
$parcel$export(module.exports, "JSM_ORGANIZATIONS_SEARCH_TEMPLATE", () => $f231a8145cfae881$export$b7429d5dab3b6ce5);
$parcel$export(module.exports, "JSM_WORK_CATEGORY_SEARCH_TEMPLATE", () => $f231a8145cfae881$export$6f9d9c0166c7b52d);
$parcel$export(module.exports, "AQL_FUNCTION_NAME", () => $f231a8145cfae881$export$ee8b282423818e0d);
$parcel$export(module.exports, "IQL_FUNCTION_NAME", () => $f231a8145cfae881$export$c91c40035dea81da);
$parcel$export(module.exports, "ADD_FILTER_DROPDOWN", () => $f231a8145cfae881$export$65639c30130233cb);
$parcel$export(module.exports, "ISSUE_KEY", () => $f231a8145cfae881$export$5daa28d10e23592);
$parcel$export(module.exports, "getTextSearchInputField", () => $f231a8145cfae881$export$3274f6964f86ac9b);
$parcel$export(module.exports, "getTextSearchInputFieldData", () => $f231a8145cfae881$export$4129f168e11a8dd0);

var $7Yg6F = parcelRequire("7Yg6F");
var $3jFAr = parcelRequire("3jFAr");

var $4R6GH = parcelRequire("4R6GH");
const $f231a8145cfae881$export$b8b9d90f9e5bd72b = 'jiraJqlBuilderBasic';
const $f231a8145cfae881$export$d57b6b390e78d90f = 'empanada';
const $f231a8145cfae881$export$8b46ceeb1d0f7a0f = new (0, $7Yg6F.JqlAnonymizerVisitor)();
const $f231a8145cfae881$var$TEXT_FIELD_JQL_TERM = 'text';
const $f231a8145cfae881$var$TEXT_FIELDS_FIELD_JQL_TERM = 'textfields';
const $f231a8145cfae881$export$a94927c1053f515e = 'project';
const $f231a8145cfae881$export$92a0328342946939 = 'type';
const $f231a8145cfae881$export$b9f8115d86beaf2e = 'status';
const $f231a8145cfae881$export$fe13eb78c06cd416 = 'assignee';
const $f231a8145cfae881$export$45a7314200effcd0 = 'resolution';
const $f231a8145cfae881$export$952c102639c1ed96 = 'labels';
const $f231a8145cfae881$var$TEXT_FIELDS = {
    jqlTerm: $f231a8145cfae881$var$TEXT_FIELDS_FIELD_JQL_TERM,
    searchTemplate: 'textFields',
    fieldType: 'textFields',
    operators: [
        (0, $3jFAr.OPERATOR_LIKE)
    ]
};
const $f231a8145cfae881$export$d597759d33be802e = {
    jqlTerm: $f231a8145cfae881$var$TEXT_FIELD_JQL_TERM,
    searchTemplate: 'text',
    fieldType: 'text',
    operators: [
        (0, $3jFAr.OPERATOR_LIKE)
    ]
};
const $f231a8145cfae881$export$fe791c4fa892e400 = {
    jqlTerm: $f231a8145cfae881$export$a94927c1053f515e,
    searchTemplate: 'project',
    fieldType: 'project',
    operators: [
        (0, $3jFAr.OPERATOR_IN),
        (0, $3jFAr.OPERATOR_IS),
        (0, $3jFAr.OPERATOR_EQUALS),
        (0, $3jFAr.OPERATOR_IS_NOT),
        (0, $3jFAr.OPERATOR_NOT_IN),
        (0, $3jFAr.OPERATOR_NOT_EQUALS)
    ]
};
const $f231a8145cfae881$export$b87f371cbc396fcf = {
    jqlTerm: $f231a8145cfae881$export$92a0328342946939,
    searchTemplate: 'issuetype',
    fieldType: 'issuetype',
    operators: [
        (0, $3jFAr.OPERATOR_IN),
        (0, $3jFAr.OPERATOR_IS),
        (0, $3jFAr.OPERATOR_EQUALS),
        (0, $3jFAr.OPERATOR_IS_NOT),
        (0, $3jFAr.OPERATOR_NOT_IN),
        (0, $3jFAr.OPERATOR_NOT_EQUALS)
    ]
};
const $f231a8145cfae881$export$e50006273435e7d4 = {
    jqlTerm: $f231a8145cfae881$export$b9f8115d86beaf2e,
    searchTemplate: 'status',
    fieldType: 'status',
    operators: [
        (0, $3jFAr.OPERATOR_WAS_NOT_IN),
        (0, $3jFAr.OPERATOR_IS),
        (0, $3jFAr.OPERATOR_WAS_NOT),
        (0, $3jFAr.OPERATOR_IN),
        (0, $3jFAr.OPERATOR_NOT_EQUALS),
        (0, $3jFAr.OPERATOR_IS_NOT),
        (0, $3jFAr.OPERATOR_NOT_IN),
        (0, $3jFAr.OPERATOR_WAS_IN),
        (0, $3jFAr.OPERATOR_EQUALS),
        (0, $3jFAr.OPERATOR_WAS),
        (0, $3jFAr.OPERATOR_CHANGED)
    ]
};
const $f231a8145cfae881$export$f8f7545d2bb78afb = {
    jqlTerm: $f231a8145cfae881$export$fe13eb78c06cd416,
    searchTemplate: 'assignee',
    fieldType: 'assignee',
    operators: [
        (0, $3jFAr.OPERATOR_CHANGED),
        (0, $3jFAr.OPERATOR_EQUALS),
        (0, $3jFAr.OPERATOR_NOT_EQUALS),
        (0, $3jFAr.OPERATOR_WAS_NOT),
        (0, $3jFAr.OPERATOR_IS_NOT),
        (0, $3jFAr.OPERATOR_WAS),
        (0, $3jFAr.OPERATOR_WAS_NOT_IN),
        (0, $3jFAr.OPERATOR_IS),
        (0, $3jFAr.OPERATOR_IN),
        (0, $3jFAr.OPERATOR_WAS_IN),
        (0, $3jFAr.OPERATOR_NOT_IN)
    ]
};
const $f231a8145cfae881$export$f1a6ce22cbb7eb32 = {
    jqlTerm: $f231a8145cfae881$export$45a7314200effcd0,
    searchTemplate: 'resolution',
    fieldType: 'resolution',
    operators: [
        (0, $3jFAr.OPERATOR_WAS_NOT),
        (0, $3jFAr.OPERATOR_IS),
        (0, $3jFAr.OPERATOR_LT_EQUALS),
        (0, $3jFAr.OPERATOR_IN),
        (0, $3jFAr.OPERATOR_GT),
        (0, $3jFAr.OPERATOR_NOT_EQUALS),
        (0, $3jFAr.OPERATOR_GT_EQUALS),
        (0, $3jFAr.OPERATOR_WAS_NOT_IN),
        (0, $3jFAr.OPERATOR_NOT_IN),
        (0, $3jFAr.OPERATOR_WAS_IN),
        (0, $3jFAr.OPERATOR_WAS),
        (0, $3jFAr.OPERATOR_LT),
        (0, $3jFAr.OPERATOR_IS_NOT),
        (0, $3jFAr.OPERATOR_EQUALS),
        (0, $3jFAr.OPERATOR_CHANGED)
    ]
};
const $f231a8145cfae881$export$79b91d4669dcadcb = {
    jqlTerm: $f231a8145cfae881$export$952c102639c1ed96,
    searchTemplate: 'labels',
    fieldType: 'labels',
    operators: [
        (0, $3jFAr.OPERATOR_IS_NOT),
        (0, $3jFAr.OPERATOR_IS),
        (0, $3jFAr.OPERATOR_NOT_EQUALS),
        (0, $3jFAr.OPERATOR_IN),
        (0, $3jFAr.OPERATOR_NOT_IN),
        (0, $3jFAr.OPERATOR_EQUALS)
    ]
};
const $f231a8145cfae881$export$a316570a0dbfd2b0 = {
    jqlTerm: 'sprint',
    searchTemplate: 'com.pyxis.greenhopper.jira:gh-sprint-searcher',
    fieldType: 'com.pyxis.greenhopper.jira:gh-sprint',
    operators: [
        (0, $3jFAr.OPERATOR_NOT_IN),
        (0, $3jFAr.OPERATOR_IS_NOT),
        (0, $3jFAr.OPERATOR_IS),
        (0, $3jFAr.OPERATOR_IN),
        (0, $3jFAr.OPERATOR_EQUALS),
        (0, $3jFAr.OPERATOR_NOT_EQUALS)
    ]
};
const $f231a8145cfae881$export$d02178e10ccc3ea = {
    jqlTerm: 'affectedversion',
    searchTemplate: 'versions',
    fieldType: 'versions',
    operators: [
        (0, $3jFAr.OPERATOR_LT_EQUALS),
        (0, $3jFAr.OPERATOR_IS_NOT),
        (0, $3jFAr.OPERATOR_NOT_IN),
        (0, $3jFAr.OPERATOR_LT),
        (0, $3jFAr.OPERATOR_EQUALS),
        (0, $3jFAr.OPERATOR_GT_EQUALS),
        (0, $3jFAr.OPERATOR_NOT_EQUALS),
        (0, $3jFAr.OPERATOR_GT),
        (0, $3jFAr.OPERATOR_IS),
        (0, $3jFAr.OPERATOR_IN)
    ]
};
const $f231a8145cfae881$export$4c55d92eb3c27f18 = {
    jqlTerm: 'fixversion',
    searchTemplate: 'fixVersions',
    fieldType: 'fixVersions',
    operators: [
        (0, $3jFAr.OPERATOR_LT_EQUALS),
        (0, $3jFAr.OPERATOR_IS_NOT),
        (0, $3jFAr.OPERATOR_NOT_IN),
        (0, $3jFAr.OPERATOR_LT),
        (0, $3jFAr.OPERATOR_EQUALS),
        (0, $3jFAr.OPERATOR_GT_EQUALS),
        (0, $3jFAr.OPERATOR_NOT_EQUALS),
        (0, $3jFAr.OPERATOR_GT),
        (0, $3jFAr.OPERATOR_IS),
        (0, $3jFAr.OPERATOR_IN)
    ]
};
const $f231a8145cfae881$export$e0dfb65d1047c53c = {
    jqlTerm: 'parent',
    searchTemplate: 'parent',
    fieldType: 'parent',
    operators: [
        (0, $3jFAr.OPERATOR_NOT_IN),
        (0, $3jFAr.OPERATOR_EQUALS),
        (0, $3jFAr.OPERATOR_IN),
        (0, $3jFAr.OPERATOR_NOT_EQUALS),
        (0, $3jFAr.OPERATOR_IS),
        (0, $3jFAr.OPERATOR_IS_NOT)
    ]
};
const $f231a8145cfae881$export$af1e30ebbae9df3b = {
    jqlTerm: 'component',
    searchTemplate: 'components',
    fieldType: 'components',
    operators: [
        (0, $3jFAr.OPERATOR_NOT_IN),
        (0, $3jFAr.OPERATOR_EQUALS),
        (0, $3jFAr.OPERATOR_IN),
        (0, $3jFAr.OPERATOR_NOT_EQUALS),
        (0, $3jFAr.OPERATOR_IS),
        (0, $3jFAr.OPERATOR_IS_NOT)
    ]
};
const $f231a8145cfae881$export$39a35fc5bd7af053 = {
    jqlTerm: 'creator',
    searchTemplate: 'creator',
    fieldType: 'creator',
    operators: [
        (0, $3jFAr.OPERATOR_NOT_IN),
        (0, $3jFAr.OPERATOR_EQUALS),
        (0, $3jFAr.OPERATOR_IN),
        (0, $3jFAr.OPERATOR_NOT_EQUALS),
        (0, $3jFAr.OPERATOR_IS),
        (0, $3jFAr.OPERATOR_IS_NOT)
    ]
};
const $f231a8145cfae881$export$6d7021166edc895c = {
    jqlTerm: 'reporter',
    searchTemplate: 'reporter',
    fieldType: 'reporter',
    operators: [
        (0, $3jFAr.OPERATOR_CHANGED),
        (0, $3jFAr.OPERATOR_EQUALS),
        (0, $3jFAr.OPERATOR_NOT_EQUALS),
        (0, $3jFAr.OPERATOR_WAS_NOT),
        (0, $3jFAr.OPERATOR_IS_NOT),
        (0, $3jFAr.OPERATOR_WAS),
        (0, $3jFAr.OPERATOR_WAS_NOT_IN),
        (0, $3jFAr.OPERATOR_IS),
        (0, $3jFAr.OPERATOR_IN),
        (0, $3jFAr.OPERATOR_WAS_IN),
        (0, $3jFAr.OPERATOR_NOT_IN)
    ]
};
const $f231a8145cfae881$export$ffcdf2c6c4831acc = new Set([
    'updated',
    'created',
    'duedate',
    'resolutiondate',
    'com.atlassian.jira.plugin.system.customfieldtypes:datetimerange',
    'com.atlassian.jira.plugin.system.customfieldtypes:daterange',
    'statuscategorychangedate',
    'com.atlassian.jira.toolkit:LastCommentDateSearcher',
    'com.atlassian.jira.ext.charting:firstreponsedatesearcher',
    'com.atlassian.jpo:jpo-custom-field-baseline-start-searcher',
    'com.atlassian.jpo:jpo-custom-field-baseline-end-searcher',
    'com.atlassian.servicedesk:sd-request-feedback-date-searcher'
]);
const $f231a8145cfae881$export$6616be37c70ab33f = new Set([
    'assignee',
    'reporter',
    'creator',
    'com.atlassian.jira.plugin.system.customfieldtypes:userpickergroupsearcher',
    'com.atlassian.jira.plugin.system.customfieldtypes:next-gen-people-searcher',
    'com.atlassian.jira.toolkit:participantsearcher',
    'com.atlassian.jira.toolkit:lastparticipantsearcher',
    'com.atlassian.servicedesk:sd-request-participants-searcher'
]);
const $f231a8145cfae881$export$19f652d3d336f069 = {
    jqlTerm: 'epic link',
    searchTemplate: 'com.pyxis.greenhopper.jira:gh-epic-link-searcher'
};
const $f231a8145cfae881$export$c743cc8f0e853412 = {
    BLUE_GRAY: 'default',
    MEDIUM_GRAY: 'default',
    BROWN: 'default',
    GREEN: 'success',
    YELLOW: 'inprogress',
    WARM_RED: 'removed'
};
const $f231a8145cfae881$export$4b826ede0e88b93 = {
    currentUser: 'currentUser',
    standardIssueTypes: 'standardIssueTypes',
    subTaskIssueTypes: 'subTaskIssueTypes',
    membersOf: 'membersOf',
    releasedVersions: 'releasedVersions',
    unreleasedVersions: 'unreleasedVersions'
};
const $f231a8145cfae881$export$84606816405f7142 = {
    empty: 'empty'
};
const $f231a8145cfae881$export$1ab4f98e21fe0811 = {
    currentUser: {
        value: 'currentUser()',
        type: (0, $96a349542da5e08d$export$19c7c729db381f9d)
    },
    empty: {
        value: 'EMPTY',
        type: (0, $96a349542da5e08d$export$f6049126fd97001f)
    },
    standardIssueTypes: {
        value: 'standardIssueTypes()',
        isList: true,
        type: (0, $96a349542da5e08d$export$19c7c729db381f9d)
    },
    subTaskIssueTypes: {
        value: 'subTaskIssueTypes()',
        isList: true,
        type: (0, $96a349542da5e08d$export$19c7c729db381f9d)
    },
    membersOf: {
        value: 'membersOf',
        isList: true,
        hasArgs: true,
        template: 'membersOf("$1")',
        type: (0, $96a349542da5e08d$export$19c7c729db381f9d)
    },
    releasedVersions: {
        value: 'releasedVersions()',
        isList: true,
        type: (0, $96a349542da5e08d$export$19c7c729db381f9d)
    },
    unreleasedVersions: {
        value: 'unreleasedVersions()',
        isList: true,
        type: (0, $96a349542da5e08d$export$19c7c729db381f9d)
    }
};
const $f231a8145cfae881$export$3e3df380922ad777 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselectsearcher';
const $f231a8145cfae881$export$cd361098212837ad = 'cascadeOption';
const $f231a8145cfae881$export$4e0f2021e5a6dd20 = 'com.atlassian.jira.plugin.system.customfieldtypes:numberrange';
const $f231a8145cfae881$export$3e72793810b8a135 = 'jql-builder-basic-textarea.ui.text-area';
const $f231a8145cfae881$export$796f418f6ff91516 = 'jql-builder-basic-textarea.ui.update-button';
const $f231a8145cfae881$export$787eee4b393220a3 = [
    (0, $3jFAr.OPERATOR_LT_EQUALS),
    (0, $3jFAr.OPERATOR_GT_EQUALS)
];
const $f231a8145cfae881$export$51829c816d2b6247 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-searcher';
const $f231a8145cfae881$export$33aa1485e40ffbb7 = 'com.atlassian.servicedesk:vp-origin-searcher';
const $f231a8145cfae881$export$b7429d5dab3b6ce5 = 'com.atlassian.servicedesk:sd-customer-organizations-searcher';
const $f231a8145cfae881$export$6f9d9c0166c7b52d = 'com.atlassian.jira.plugins.work-category-field:work-category-field-searcher';
const $f231a8145cfae881$export$ee8b282423818e0d = 'aqlFunction';
const $f231a8145cfae881$export$c91c40035dea81da = 'iqlFunction';
const $f231a8145cfae881$export$65639c30130233cb = 'ADD_FILTER_DROPDOWN';
const $f231a8145cfae881$export$5daa28d10e23592 = 'issuekey';
const $f231a8145cfae881$export$3274f6964f86ac9b = ()=>(0, $4R6GH.fg)('nin-text-fields-new-text-search-field') ? $f231a8145cfae881$var$TEXT_FIELDS_FIELD_JQL_TERM : $f231a8145cfae881$var$TEXT_FIELD_JQL_TERM;
const $f231a8145cfae881$export$4129f168e11a8dd0 = ()=>(0, $4R6GH.fg)('nin-text-fields-new-text-search-field') ? $f231a8145cfae881$var$TEXT_FIELDS : $f231a8145cfae881$export$d597759d33be802e;

});
parcelRegister("7Yg6F", function(module, exports) {

$parcel$export(module.exports, "JqlAnonymizerVisitor", () => $c45403918bedbb0f$export$17681d1ffeaac612);

var $hYM2X = parcelRequire("hYM2X");
var $5pWAg = parcelRequire("5pWAg");

var $17jdd = parcelRequire("17jdd");

var $92zfQ = parcelRequire("92zfQ");
const $c45403918bedbb0f$var$ANONYMIZED_FIELD = '"?"';
const $c45403918bedbb0f$var$ANONYMIZED_VALUE = '"?"';
const $c45403918bedbb0f$var$CUSTOM_FIELD_PATTERN = /^cf\[\d+]$/i;
const $c45403918bedbb0f$var$privacySafeFields = new Set((0, $5pWAg.PRIVACY_SAFE_FIELDS));
const $c45403918bedbb0f$var$getPrivacySafeFieldName = (field)=>{
    // Privacy safe field name (Jira field)
    if ($c45403918bedbb0f$var$privacySafeFields.has(field.value.toLowerCase())) return field.text;
    // Custom field identifier, e.g. cf[10001]
    if ($c45403918bedbb0f$var$CUSTOM_FIELD_PATTERN.test(field.value)) return field.text;
    // Collapsed custom field
    const match = field.text.match((0, $hYM2X.COLLAPSED_CUSTOM_FIELD_PATTERN));
    if (match) return `"?[${match[1]}]"`;
    // Other field names that can potentially contain UGC
    return $c45403918bedbb0f$var$ANONYMIZED_FIELD;
};
class $c45403918bedbb0f$export$17681d1ffeaac612 extends (0, $92zfQ.AbstractJastVisitor) {
    defaultResult() {
        return '';
    }
    constructor(...args){
        super(...args), this.visitQuery = (query)=>{
            const where = query.where ? query.where.accept(this) : undefined;
            const orderBy = query.orderBy ? query.orderBy.accept(this) : undefined;
            return [
                where,
                orderBy
            ].filter((0, $17jdd.notUndefined)).join(' ');
        }, this.visitField = (field)=>{
            const name = $c45403918bedbb0f$var$getPrivacySafeFieldName(field);
            if (field.properties && field.properties.length) {
                const properties = field.properties.map((property)=>{
                    const key = property.key ? property.key.text : '';
                    const path = property.path ? property.path.map((arg)=>arg.text).join('') : '';
                    return `[${key}]${path}`;
                }).join('');
                return `${name}${properties}`;
            }
            return name;
        }, this.visitTerminalClause = (terminalClause)=>{
            const field = terminalClause.field.accept(this);
            const operator = terminalClause.operator ? terminalClause.operator.text : undefined;
            const operand = terminalClause.operand ? terminalClause.operand.accept(this) : undefined;
            const predicates = terminalClause.predicates.map((predicate)=>predicate.accept(this));
            return [
                field,
                operator,
                operand,
                ...predicates
            ].filter((0, $17jdd.notUndefined)).join(' ');
        }, this.visitCompoundClause = (compoundClause)=>{
            const operator = compoundClause.operator.value;
            return compoundClause.clauses.map((clause)=>{
                // Nested compound clauses should be wrapped in parentheses
                return clause.clauseType === (0, $64e15c988a7f27d3$export$7a58b23488ea076b) ? `(${clause.accept(this)})` : clause.accept(this);
            }).join(` ${operator} `);
        }, this.visitNotClause = (notClause)=>{
            // Nested compound clauses should be wrapped in parentheses
            const nestedClause = notClause.clause.clauseType === (0, $64e15c988a7f27d3$export$7a58b23488ea076b) ? `(${notClause.clause.accept(this)})` : notClause.clause.accept(this);
            return `${notClause.operator.value} ${nestedClause}`;
        }, this.visitValueOperand = ()=>{
            return $c45403918bedbb0f$var$ANONYMIZED_VALUE;
        }, this.visitListOperand = (listOperand)=>{
            return `(${listOperand.values.map((value)=>value.accept(this)).join(', ')})`;
        }, this.visitFunctionOperand = (functionOperand)=>{
            const functionName = functionOperand.function.text;
            const functionArguments = functionOperand.arguments.map(()=>$c45403918bedbb0f$var$ANONYMIZED_VALUE).join(', ');
            return `${functionName}(${functionArguments})`;
        }, this.visitKeywordOperand = (keywordOperand)=>{
            return keywordOperand.value;
        }, this.visitPredicate = (predicate)=>{
            const operator = predicate.operator.text;
            const operand = predicate.operand ? predicate.operand.accept(this) : undefined;
            return [
                operator,
                operand
            ].filter((0, $17jdd.notUndefined)).join(' ');
        }, this.visitOrderBy = (orderBy)=>{
            const orderByFields = orderBy.fields.map((orderByField)=>{
                const field = orderByField.field.accept(this);
                const direction = orderByField.direction ? orderByField.direction.value : undefined;
                return [
                    field,
                    direction
                ].filter((0, $17jdd.notUndefined)).join(' ');
            });
            return `${0, $6aad11c3985b8e7f$export$ca51f5fd60a74517} ${orderByFields.join(', ')}`;
        };
    }
}

});
parcelRegister("hYM2X", function(module, exports) {

$parcel$export(module.exports, "TEAM_CUSTOM_FIELD_TYPE", () => $40214039dc0a4794$export$7db5aa892c7d5359);
$parcel$export(module.exports, "COLLAPSED_CUSTOM_FIELD_PATTERN", () => $40214039dc0a4794$export$72fbd4b3f260d743);
$parcel$export(module.exports, "COLLAPSED_CUSTOM_FIELD_PATTERN_NO_QUOTES", () => $40214039dc0a4794$export$4b8ecf135de492a1);
// This is a list of field types expected as collapsed fields, e.g. of the form
// name[fieldtype]. The square brackets are retained to allow us to more easily
// differentiate these from regular fields.
// Currently these are being used in `jql-insights-listener.ts` to allow us to
// collect data about the usage of some custom field types.
// All field type names here must be in lower case
const $40214039dc0a4794$export$7db5aa892c7d5359 = '[team]';
const $40214039dc0a4794$export$72fbd4b3f260d743 = /^['"].+\[(\D+)]['"]$/i;
const $40214039dc0a4794$export$4b8ecf135de492a1 = /^.+\[(\D+)]$/i;

});

parcelRegister("5pWAg", function(module, exports) {

$parcel$export(module.exports, "ASSIGNEE_FIELD", () => $26668a43ed285bc2$export$f7a08bf17a7ac661);
$parcel$export(module.exports, "CREATED_FIELD", () => $26668a43ed285bc2$export$9063bfeedbc1236f);
$parcel$export(module.exports, "DUE_DATE_FIELD", () => $26668a43ed285bc2$export$f4a47f55547a932c);
$parcel$export(module.exports, "ISSUE_TYPE_FIELD", () => $26668a43ed285bc2$export$2d5a62a3515ad4c6);
$parcel$export(module.exports, "LAST_VIEWED_FIELD", () => $26668a43ed285bc2$export$eac61537b9fdb3be);
$parcel$export(module.exports, "PRIORITY_FIELD", () => $26668a43ed285bc2$export$de14210faa5f2099);
$parcel$export(module.exports, "PROJECT_FIELD", () => $26668a43ed285bc2$export$aa5680ad8f8be9fc);
$parcel$export(module.exports, "REPORTER_FIELD", () => $26668a43ed285bc2$export$d64150fd9c66969c);
$parcel$export(module.exports, "RESOLUTION_DATE_FIELD", () => $26668a43ed285bc2$export$f603d3cf4c8489e8);
$parcel$export(module.exports, "STATUS_FIELD", () => $26668a43ed285bc2$export$3068d6fae4de53c8);
$parcel$export(module.exports, "SUMMARY_FIELD", () => $26668a43ed285bc2$export$9b9fe8882c3e0da3);
$parcel$export(module.exports, "TYPE_FIELD", () => $26668a43ed285bc2$export$e53b76a613c435e0);
$parcel$export(module.exports, "UPDATED_FIELD", () => $26668a43ed285bc2$export$7101642b50bf10bc);
$parcel$export(module.exports, "RESOLUTION_FIELD", () => $26668a43ed285bc2$export$252fb981af0e2e4e);
$parcel$export(module.exports, "PRIVACY_SAFE_FIELDS", () => $26668a43ed285bc2$export$49017cdca0837b83);
const $26668a43ed285bc2$export$f7a08bf17a7ac661 = 'assignee';
const $26668a43ed285bc2$export$9063bfeedbc1236f = 'created';
const $26668a43ed285bc2$export$f4a47f55547a932c = 'duedate';
const $26668a43ed285bc2$export$28d0e5e03b779eff = 'issuekey';
const $26668a43ed285bc2$export$2d5a62a3515ad4c6 = 'issuetype';
const $26668a43ed285bc2$export$eac61537b9fdb3be = 'lastviewed';
const $26668a43ed285bc2$export$de14210faa5f2099 = 'priority';
const $26668a43ed285bc2$export$aa5680ad8f8be9fc = 'project';
const $26668a43ed285bc2$export$d64150fd9c66969c = 'reporter';
const $26668a43ed285bc2$export$ad2fb2fa5ecb427a = 'resolved';
const $26668a43ed285bc2$export$f603d3cf4c8489e8 = 'resolutiondate';
const $26668a43ed285bc2$export$3068d6fae4de53c8 = 'status';
const $26668a43ed285bc2$export$f4d2dc00d9b9c983 = 'statuscategory';
const $26668a43ed285bc2$export$9b9fe8882c3e0da3 = 'summary';
const $26668a43ed285bc2$export$23ca38ad884e35f1 = 'text';
const $26668a43ed285bc2$export$b3e1b98671aae084 = 'textfields';
const $26668a43ed285bc2$export$e53b76a613c435e0 = 'type';
const $26668a43ed285bc2$export$7101642b50bf10bc = 'updated';
const $26668a43ed285bc2$export$c7761054d987f9ab = 'affectedversion';
const $26668a43ed285bc2$export$9ae86b690ef8ceed = 'approvals';
const $26668a43ed285bc2$export$4b5a561405c5f211 = 'category';
const $26668a43ed285bc2$export$a3ff506aee89f5de = 'component';
const $26668a43ed285bc2$export$6a045eda3865d703 = 'description';
const $26668a43ed285bc2$export$b6b1af0981f1891e = 'development';
const $26668a43ed285bc2$export$39df30b837789c3 = 'environment';
const $26668a43ed285bc2$export$8723b724f0b3ac65 = 'epic link';
const $26668a43ed285bc2$export$4b5030dff66bb705 = 'filter';
const $26668a43ed285bc2$export$3ec395376855802f = 'fixversion';
const $26668a43ed285bc2$export$a8945db82fc2e785 = 'labels';
const $26668a43ed285bc2$export$bf9df74e065af482 = 'parent';
const $26668a43ed285bc2$export$252fb981af0e2e4e = 'resolution';
const $26668a43ed285bc2$export$64238d76a1dc0703 = 'sprint';
const $26668a43ed285bc2$export$62edbfa1bb10b91 = 'assignee.property';
const $26668a43ed285bc2$export$5afd9733860db123 = 'creator.property';
const $26668a43ed285bc2$export$3ccfe20fd4420801 = 'issue.property';
const $26668a43ed285bc2$export$d955a5d923cc59e6 = 'project.property';
const $26668a43ed285bc2$export$ed42e707855fc6a4 = 'reporter.property';
const $26668a43ed285bc2$export$3b63269c1c533321 = 'voter.property';
const $26668a43ed285bc2$export$bd7061bb445305dd = 'watcher.property';
const $26668a43ed285bc2$export$49017cdca0837b83 = [
    $26668a43ed285bc2$export$f7a08bf17a7ac661,
    $26668a43ed285bc2$export$9063bfeedbc1236f,
    $26668a43ed285bc2$export$f4a47f55547a932c,
    $26668a43ed285bc2$export$28d0e5e03b779eff,
    $26668a43ed285bc2$export$2d5a62a3515ad4c6,
    $26668a43ed285bc2$export$eac61537b9fdb3be,
    $26668a43ed285bc2$export$de14210faa5f2099,
    $26668a43ed285bc2$export$aa5680ad8f8be9fc,
    $26668a43ed285bc2$export$d64150fd9c66969c,
    $26668a43ed285bc2$export$ad2fb2fa5ecb427a,
    $26668a43ed285bc2$export$f603d3cf4c8489e8,
    $26668a43ed285bc2$export$3068d6fae4de53c8,
    $26668a43ed285bc2$export$f4d2dc00d9b9c983,
    $26668a43ed285bc2$export$9b9fe8882c3e0da3,
    $26668a43ed285bc2$export$23ca38ad884e35f1,
    $26668a43ed285bc2$export$b3e1b98671aae084,
    $26668a43ed285bc2$export$e53b76a613c435e0,
    $26668a43ed285bc2$export$7101642b50bf10bc,
    $26668a43ed285bc2$export$c7761054d987f9ab,
    $26668a43ed285bc2$export$9ae86b690ef8ceed,
    $26668a43ed285bc2$export$4b5a561405c5f211,
    $26668a43ed285bc2$export$a3ff506aee89f5de,
    $26668a43ed285bc2$export$6a045eda3865d703,
    $26668a43ed285bc2$export$b6b1af0981f1891e,
    $26668a43ed285bc2$export$39df30b837789c3,
    $26668a43ed285bc2$export$8723b724f0b3ac65,
    $26668a43ed285bc2$export$4b5030dff66bb705,
    $26668a43ed285bc2$export$3ec395376855802f,
    $26668a43ed285bc2$export$a8945db82fc2e785,
    $26668a43ed285bc2$export$bf9df74e065af482,
    $26668a43ed285bc2$export$252fb981af0e2e4e,
    $26668a43ed285bc2$export$64238d76a1dc0703,
    // entity properties
    $26668a43ed285bc2$export$62edbfa1bb10b91,
    $26668a43ed285bc2$export$5afd9733860db123,
    $26668a43ed285bc2$export$3ccfe20fd4420801,
    $26668a43ed285bc2$export$d955a5d923cc59e6,
    $26668a43ed285bc2$export$ed42e707855fc6a4,
    $26668a43ed285bc2$export$3b63269c1c533321,
    $26668a43ed285bc2$export$bd7061bb445305dd
];

});



parcelRegister("i4OXX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2054e533ca4e44d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a2054e533ca4e44d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    refinementProject: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-project",
        "defaultMessage": "Project"
    },
    refinementStatus: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-status",
        "defaultMessage": "Status"
    },
    refinementStatusCategory: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-status-category",
        "defaultMessage": "Status category"
    },
    refinementSummary: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-summary",
        "defaultMessage": "Summary"
    },
    refinementAssignee: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-assignee",
        "defaultMessage": "Assignee"
    },
    refinementReporter: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-reporter",
        "defaultMessage": "Reporter"
    },
    refinementType: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-type",
        "defaultMessage": "Type"
    },
    refinementPriority: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-priority",
        "defaultMessage": "Priority"
    },
    refinementResolution: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-resolution",
        "defaultMessage": "Resolution"
    },
    refinementUpdated: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-updated",
        "defaultMessage": "Updated date"
    },
    refinementCreated: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-created",
        "defaultMessage": "Created date"
    },
    refinementDueDate: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-due-date",
        "defaultMessage": "Due date"
    },
    refinementResolutionDate: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-resolution-date",
        "defaultMessage": "Resolution date"
    },
    refinementComponent: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-component",
        "defaultMessage": "Component"
    },
    refinementParent: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-parent",
        "defaultMessage": "Parent"
    },
    refinementFixVersion: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-fix-version",
        "defaultMessage": "Fix version"
    },
    refinementAffectedVersion: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-affected-version",
        "defaultMessage": "Affects version"
    },
    refinementLabel: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-label",
        "defaultMessage": "Label"
    },
    refinementLabels: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-labels",
        "defaultMessage": "Labels"
    },
    refinementEpicLink: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-epic-link",
        "defaultMessage": "Epic link"
    },
    refinementSprint: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-sprint",
        "defaultMessage": "Sprint"
    },
    refinementCreator: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-creator",
        "defaultMessage": "Creator"
    },
    refinementDescription: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-description",
        "defaultMessage": "Description"
    },
    refinementEnvironment: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-environment",
        "defaultMessage": "Environment"
    },
    refinementNotFound: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-not-found",
        "defaultMessage": "Unknown Field"
    }
});

});


parcelRegister("OomEm", function(module, exports) {

$parcel$export(module.exports, "HYDRATION_QUERY", () => $e1f1ad0dadb1a1b8$export$988ee43373cb9bb2);
$parcel$export(module.exports, "useHydrationQueryLoader", () => $e1f1ad0dadb1a1b8$export$b318e912f6cbc59b);

var $16Yit = parcelRequire("16Yit");

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");
const $e1f1ad0dadb1a1b8$export$988ee43373cb9bb2 = (0, $16Yit.default);
const $e1f1ad0dadb1a1b8$export$9562d1ce91742cb1 = (variables)=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const [isFetching, setIsFetching] = (0, $5uXOq.useState)(false);
    // Variables for last completed prefetch (i.e. fetchQuery) operation
    const [prefetchedVariables, setPrefetchedVariables] = (0, $5uXOq.useState)(variables);
    const [fetchPolicy, setFetchPolicy] = (0, $5uXOq.useState)('store-or-network');
    // Variables used by in-flight request, used to deduplicate requests
    const inFlightRequest = (0, $5uXOq.useRef)();
    const inFlightVariables = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(variables, prefetchedVariables) && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(variables, inFlightVariables.current)) {
            // Cancel previous in-flight request to stop further processing (and prevent race conditions) if a new one comes in
            inFlightRequest.current?.unsubscribe();
            inFlightVariables.current = variables;
            setIsFetching(true);
            // Prefetch data, then update returned variables on complete
            inFlightRequest.current = (0, $8Uumt.fetchQuery)(environment, $e1f1ad0dadb1a1b8$export$988ee43373cb9bb2, variables, {
                fetchPolicy: 'store-or-network',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            }).subscribe({
                complete: ()=>{
                    setPrefetchedVariables(variables);
                    setFetchPolicy('store-only');
                    setIsFetching(false);
                    inFlightVariables.current = undefined;
                },
                error: (error)=>{
                    setIsFetching(false);
                    (0, $jcw0u.default)({
                        meta: {
                            id: 'hydrateJqlBuilderQuery',
                            packageName: 'jiraJqlBuilderCommon',
                            teamName: 'empanada'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            });
        }
    }, [
        environment,
        prefetchedVariables,
        variables
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            variables: prefetchedVariables,
            fetchPolicy: fetchPolicy,
            isFetching: isFetching
        }), [
        prefetchedVariables,
        fetchPolicy,
        isFetching
    ]);
};
const $e1f1ad0dadb1a1b8$export$b318e912f6cbc59b = (query, viewContext)=>{
    const accountId = (0, $90yGq.useAccountId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { variables: variables, fetchPolicy: fetchPolicy, isFetching: isFetching } = $e1f1ad0dadb1a1b8$export$9562d1ce91742cb1({
        accountId: accountId ?? '',
        cloudId: cloudId,
        includeUser: query.length > 0 && !!accountId,
        includeJira: query.length > 0,
        jql: query,
        isFilter: false,
        filterAri: '',
        viewContext: viewContext
    });
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)($e1f1ad0dadb1a1b8$export$988ee43373cb9bb2);
    // @see https://hello.atlassian.net/wiki/spaces/~104598762/pages/2206935637/Why+do+we+need+to+re-hydrate+the+refinement+bar+on+every+change
    // Tl;DR – We refetch hydration data on every query change (instead of just fetching it on mount) for two reasons:
    // 1. There are external JQL changes that don't unmount the basic mode component and require hydration
    //    (e.g. changing filters in the sidebar, or clicking on the Reset button)
    // 2. We also rely on hydration API to render the invalid state when a particular field value is out of scope for
    //    the current query (e.g. if a selected status doesn't belong to one of the selected projects) – we could
    //    technically avoid rehydrating in this case if there isn't a change to scoping fields (like project or issue
    //    type), but it's probably not worth the extra complexity
    (0, $5uXOq.useEffect)(()=>{
        loadQuery(variables, {
            fetchPolicy: fetchPolicy,
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
    }, [
        fetchPolicy,
        loadQuery,
        variables
    ]);
    return [
        queryReference,
        isFetching
    ];
};

});
parcelRegister("16Yit", function(module, exports) {

$parcel$export(module.exports, "default", () => $296a6f030570708c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8b35258409fd95feac3a7c2d1b173e38>>
 * @relayHash 2e1cdbc7b09ec37e9cc0993464d7aadd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 28ba20c081cda028e2d1967769b33eb171517e2ac4ff9ff74300564656ea5d9c
const $296a6f030570708c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeJira"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeUser"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isFilter"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v9 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v10 = [
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "jql"
        },
        v9 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v13 = [
        v11 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v12 /*: any*/ 
            ],
            "type": "JiraJqlHydratedQuery"
        }
    ], v14 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "filterAri"
        },
        v9 /*: any*/ 
    ], v15 = {
        "kind": "ScalarField",
        "name": "id"
    }, v16 = [
        v11 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        v15 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v18 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v19 = {
        "kind": "ScalarField",
        "name": "key"
    }, v20 = [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorName"
                },
                v15 /*: any*/ 
            ]
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v22 = [
        v11 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v12 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        v11 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "concreteType": "JiraJqlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlSearchTemplate",
                                            "kind": "LinkedField",
                                            "name": "searchTemplate",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldShowInContext"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "operators"
                                        },
                                        {
                                            "concreteType": "JiraFieldType",
                                            "kind": "LinkedField",
                                            "name": "fieldType",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": true,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "values",
                                                    "plural": true,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "project",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v19 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "small"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v15 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlProjectFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v20 /*: any*/ ,
                                                            "type": "JiraJqlStatusFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v20 /*: any*/ ,
                                                            "type": "JiraJqlStatusCategoryFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "xsmall"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v15 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": v16 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        },
                                                                        v15 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlPriorityFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v11 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "text"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                v15 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v15 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "sprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "state"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "boardName"
                                                                        },
                                                                        v15 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlSprintFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v18 /*: any*/ ,
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlCascadingOptionFieldValue"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedValue"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v17 /*: any*/ ,
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "error",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedError"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ],
            "type": "QueryError"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hydrateJqlBuilderQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_jqlBuilder_JQLBuilderUI_hydrationQueryData"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "useHydratedValues"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "jqlEditor_jqlBuilderBasic_JQLEditorUI"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "useQuery"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "useHydratedValues_cascadeSelectPicker"
                },
                {
                    "condition": "includeJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "args": v10 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQuery",
                                                    "plural": false,
                                                    "selections": v13 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v14 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQueryForFilter",
                                                    "plural": false,
                                                    "selections": v13 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "hydrateJqlBuilderQuery",
            "selections": [
                {
                    "condition": "includeUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "accountId",
                                    "variableName": "accountId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": v16 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "args": v10 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQuery",
                                                    "plural": false,
                                                    "selections": v22 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v14 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQueryForFilter",
                                                    "plural": false,
                                                    "selections": v22 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "28ba20c081cda028e2d1967769b33eb171517e2ac4ff9ff74300564656ea5d9c",
            "metadata": {},
            "name": "hydrateJqlBuilderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$296a6f030570708c$var$node.hash = "1a3b28367e690225d2874708340ba3ff";
var $296a6f030570708c$export$2e2bcd8739ae039 = $296a6f030570708c$var$node;

});


parcelRegister("caSpf", function(module, exports) {

$parcel$export(module.exports, "PerformanceContext", () => $24fa6d2cc4aafb68$export$39bcde15aa963086);
$parcel$export(module.exports, "usePerformanceContext", () => $24fa6d2cc4aafb68$export$851a2d8ae957dc96);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

const $24fa6d2cc4aafb68$export$39bcde15aa963086 = /*#__PURE__*/ (0, $5uXOq.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))));
const $24fa6d2cc4aafb68$export$851a2d8ae957dc96 = ()=>(0, $5uXOq.useContext)($24fa6d2cc4aafb68$export$39bcde15aa963086);

});

parcelRegister("032ey", function(module, exports) {

$parcel$export(module.exports, "SEARCH_MODE_BASIC", () => $e090bb7ab54db3ef$export$f963d14b266e4d2e);
$parcel$export(module.exports, "SEARCH_MODE_ADVANCED", () => $e090bb7ab54db3ef$export$aad1d9eb9b751555);
$parcel$export(module.exports, "SERVER_SEARCH_MODE_BASIC", () => $e090bb7ab54db3ef$export$87c41a6b3123c00f);
$parcel$export(module.exports, "SERVER_SEARCH_MODE_ADVANCED", () => $e090bb7ab54db3ef$export$a7a000706ebc3ba8);
$parcel$export(module.exports, "DEFAULT_SEARCH_MODE", () => $e090bb7ab54db3ef$export$e1eb2ddab803c5ec);
$parcel$export(module.exports, "mapSearchModeToAnalyticAtribute", () => $e090bb7ab54db3ef$export$70c8f980e4a50682);
$parcel$export(module.exports, "SEARCH_MODE_SWITCHER_LEFT_LOCATION", () => $e090bb7ab54db3ef$export$4dab29e715a4e6fb);
$parcel$export(module.exports, "SEARCH_MODE_SWITCHER_RIGHT_LOCATION", () => $e090bb7ab54db3ef$export$59848395da0b4bcb);
$parcel$export(module.exports, "PACKAGE_NAME", () => $e090bb7ab54db3ef$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $e090bb7ab54db3ef$export$d57b6b390e78d90f);
const $e090bb7ab54db3ef$export$f963d14b266e4d2e = 'basic';
const $e090bb7ab54db3ef$export$aad1d9eb9b751555 = 'advanced';
const $e090bb7ab54db3ef$export$87c41a6b3123c00f = 'BASIC';
const $e090bb7ab54db3ef$export$a7a000706ebc3ba8 = 'ADVANCED';
const $e090bb7ab54db3ef$export$e1eb2ddab803c5ec = $e090bb7ab54db3ef$export$f963d14b266e4d2e;
const $e090bb7ab54db3ef$export$70c8f980e4a50682 = {
    [$e090bb7ab54db3ef$export$f963d14b266e4d2e]: $e090bb7ab54db3ef$export$f963d14b266e4d2e,
    [$e090bb7ab54db3ef$export$aad1d9eb9b751555]: 'JQL'
};
const $e090bb7ab54db3ef$export$4dab29e715a4e6fb = 'Left';
const $e090bb7ab54db3ef$export$59848395da0b4bcb = 'Right';
const $e090bb7ab54db3ef$export$b8b9d90f9e5bd72b = 'jiraJqlBuilder';
const $e090bb7ab54db3ef$export$d57b6b390e78d90f = 'empanada';

});

parcelRegister("atxn1", function(module, exports) {

$parcel$export(module.exports, "toSearchModeWithBasicModeFallback", () => $b0ab4dfe8728dd0f$export$7c0f55a4bd3730ea);
$parcel$export(module.exports, "toServerSearchMode", () => $b0ab4dfe8728dd0f$export$32a166cc1b3e6927);

var $032ey = parcelRequire("032ey");
function $b0ab4dfe8728dd0f$export$7c0f55a4bd3730ea(value) {
    switch(value){
        case 0, $032ey.SERVER_SEARCH_MODE_ADVANCED:
            return 0, $032ey.SEARCH_MODE_ADVANCED;
        default:
            return 0, $032ey.DEFAULT_SEARCH_MODE;
    }
}
function $b0ab4dfe8728dd0f$export$32a166cc1b3e6927(mode) {
    switch(mode){
        case 0, $032ey.SEARCH_MODE_ADVANCED:
            return 0, $032ey.SERVER_SEARCH_MODE_ADVANCED;
        default:
            return 0, $032ey.SERVER_SEARCH_MODE_BASIC;
    }
}

});

parcelRegister("55ttp", function(module, exports) {

$parcel$export(module.exports, "useContextJql", () => $290b1179285f772f$export$68b4e7df5f221bf);

var $5uXOq = parcelRequire("5uXOq");

var $gjjVy = parcelRequire("gjjVy");
var $3KEIl = parcelRequire("3KEIl");
var $3jFAr = parcelRequire("3jFAr");
var $9Dyrx = parcelRequire("9Dyrx");

var $5Dsab = parcelRequire("5Dsab");
const $290b1179285f772f$var$isProjectKey = (projectKey)=>Boolean(projectKey);
const $290b1179285f772f$export$68b4e7df5f221bf = ({ jql: jql, projectKeys: projectKeys })=>{
    return (0, $5uXOq.useMemo)(()=>{
        /**
		 * context jql based on projectKeys
		 */ const sanitizedProjectKeys = projectKeys?.filter($290b1179285f772f$var$isProjectKey) ?? [];
        if (sanitizedProjectKeys.length === 0) return jql;
        const jast = new (0, $3KEIl.JastBuilder)().build(jql);
        jast.query?.appendClause((0, $gjjVy.default).terminalClause((0, $gjjVy.default).field((0, $5Dsab.PROJECT_FIELD_JQL_TERM)), (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_IN)), (0, $gjjVy.default).listOperand(sanitizedProjectKeys.map((0, $gjjVy.default).valueOperand))), (0, $ed890f3e326c0985$export$6d6d48d210d3ca97));
        return (0, $9Dyrx.print)(jast, {
            operatorCase: 'upper'
        });
    }, [
        jql,
        projectKeys
    ]);
};

});

parcelRegister("aRep0", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderUIOld", () => $c957fe2570b7a195$export$328ac4451491d9e0);
$parcel$export(module.exports, "default", () => $c957fe2570b7a195$export$2e2bcd8739ae039);

var $8Q5yU = parcelRequire("8Q5yU");

var $562DD = parcelRequire("562DD");

var $5uXOq = parcelRequire("5uXOq");

var $kGsr8 = parcelRequire("kGsr8");

var $8Uumt = parcelRequire("8Uumt");

var $7ckRQ = parcelRequire("7ckRQ");

var $OomEm = parcelRequire("OomEm");

var $lfTZh = parcelRequire("lfTZh");

var $5Pkdl = parcelRequire("5Pkdl");

var $4R6GH = parcelRequire("4R6GH");

var $032ey = parcelRequire("032ey");

var $atxn1 = parcelRequire("atxn1");

var $1PKzp = parcelRequire("1PKzp");

var $55ttp = parcelRequire("55ttp");

var $kcuJ8 = parcelRequire("kcuJ8");

var $k3Vq9 = parcelRequire("k3Vq9");

var $e6DTX = parcelRequire("e6DTX");

var $2G1VO = parcelRequire("2G1VO");

var $gFE9c = parcelRequire("gFE9c");
const $c957fe2570b7a195$export$66ac472152813d8b = (0, $562DD.default);
/* eslint-enable @atlassian/relay/graphql-naming */ const $c957fe2570b7a195$var$JQLBuilderUI = ({ userPreferences: userPreferences, searchModes: searchModes = [
    (0, $032ey.SEARCH_MODE_ADVANCED),
    (0, $032ey.SEARCH_MODE_BASIC)
], onUpdateSearchMode: onUpdateSearchMode, selectedSearchMode: selectedSearchMode, isSearchModeToggleEnabled: isSearchModeToggleEnabled, irremovableFields: irremovableFields, uniqueSearchModes: uniqueSearchModes, hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode = false, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, searchModeSwitcherLocation: searchModeSwitcherLocation, projectKeys: projectKeys, showOrderByPicker: showOrderByPicker, viewContext: viewContext = null, initialQueryRef: initialQueryRef, onLoadingMode: onLoadingMode, loadingModeRef: loadingModeRef, ...props })=>{
    const userPreferencesData = (0, $8Uumt.useFragment)($c957fe2570b7a195$export$66ac472152813d8b, userPreferences);
    const saveSearchModePreference = (0, $e6DTX.useSearchModeMutation)(userPreferencesData);
    const contextJql = (0, $55ttp.useContextJql)({
        jql: props.query,
        projectKeys: projectKeys
    });
    // eslint-disable-next-line @atlassian/relay/query-restriction
    const hydrationQueryData = (0, $8Uumt.usePreloadedQuery)((0, $OomEm.HYDRATION_QUERY), initialQueryRef);
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const [hydrationData, hydrationRefetch] = (0, $8Uumt.useRefetchableFragment)((0, $8Q5yU.default), hydrationQueryData);
    /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ const hydratedJql = (0, $5uXOq.useMemo)(()=>{
        const hydrationResult = hydrationData?.jira?.jqlBuilder?.hydrateJqlQuery ?? hydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter;
        if (hydrationResult?.__typename === 'JiraJqlHydratedQuery') return hydrationResult.jql ?? undefined;
    }, [
        hydrationData?.jira?.jqlBuilder?.hydrateJqlQuery,
        hydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter
    ]);
    const onSearchModeChange = (0, $5uXOq.useCallback)((searchMode, reason)=>{
        // Update the search mode preference when the reason is matching the allowed list
        // Note: The reasons currently used below were chosen to match previous behaviour when the new reason "QueryUnsupported" was introduced
        if (reason === 'UserTriggered' || reason === 'ExternalTriggered') saveSearchModePreference(searchMode);
        onUpdateSearchMode?.(searchMode, reason);
    }, [
        onUpdateSearchMode,
        saveSearchModePreference
    ]);
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2G1VO.JQLBuilderFallback), {
        query: props.query,
        searchModes: searchModes,
        onLoad: onLoadingMode,
        selectedSearchMode: selectedSearchMode,
        isSearchModeToggleEnabled: isSearchModeToggleEnabled,
        beforeControls: props.beforeControls,
        renderExtraControls: props.renderExtraControls,
        excludedFields: props.excludedFields,
        components: props.components,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        showOrderByPicker: showOrderByPicker
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jql-builder-ui",
        fallback: fallback
    }, hydrationData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3Vq9.HydrationQueryProvider), {
        query: (0, $5Pkdl.default),
        refetch: hydrationRefetch,
        contextJql: contextJql,
        hydratedJql: hydratedJql,
        ...(0, $4R6GH.fg)('jql_builder_add_view_context_to_hydration_query') && {
            viewContext: viewContext
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kcuJ8.QuerySupportedContainer), {
        query: props.query,
        excludedFields: props.excludedFields,
        jqlMessages: props.jqlMessages,
        hydrationData: hydrationData,
        simplifiedOperators: hideOperatorDropdownBasicMode,
        hideTextSearchInput: hideTextSearchInput,
        contextJql: contextJql
    }, uniqueSearchModes.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PKzp.SingleSearchModeContainer), {
        searchMode: uniqueSearchModes[0]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFE9c.JQLBuilderUIImpl), {
        searchModes: uniqueSearchModes,
        hydrationData: hydrationData,
        selectedSearchMode: selectedSearchMode,
        onUpdateSearchMode: onUpdateSearchMode,
        hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        contextJql: contextJql,
        showOrderByPicker: showOrderByPicker,
        loadingModeRef: loadingModeRef,
        viewContext: viewContext,
        ...props
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PKzp.SelectedSearchModeContainer), {
        searchMode: selectedSearchMode,
        onSearchModeChange: onSearchModeChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFE9c.JQLBuilderUIImpl), {
        searchModes: uniqueSearchModes,
        hydrationData: hydrationData,
        selectedSearchMode: selectedSearchMode,
        onUpdateSearchMode: onUpdateSearchMode,
        hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        contextJql: contextJql,
        showOrderByPicker: showOrderByPicker,
        loadingModeRef: loadingModeRef,
        viewContext: viewContext,
        ...props
    })))) : fallback);
};
const $c957fe2570b7a195$export$328ac4451491d9e0 = ({ userPreferences: userPreferences, searchModes: searchModes = [
    (0, $032ey.SEARCH_MODE_ADVANCED),
    (0, $032ey.SEARCH_MODE_BASIC)
], onUpdateSearchMode: onUpdateSearchMode, hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode = false, hideTextSearchInput: hideTextSearchInput = false, searchPlaceholder: searchPlaceholder, searchModeSwitcherLocation: searchModeSwitcherLocation = (0, $032ey.SEARCH_MODE_SWITCHER_LEFT_LOCATION), projectKeys: projectKeys, showOrderByPicker: showOrderByPicker, viewContext: viewContext = null, ...props })=>{
    const { onLoad: onLoad } = props;
    // Persist mode used in loading state to send in analytics
    const loadingModeRef = (0, $5uXOq.useRef)();
    const onLoadingMode = (0, $5uXOq.useCallback)((mode)=>{
        loadingModeRef.current = mode;
        onLoad?.(mode);
    }, [
        onLoad
    ]);
    const userPreferencesData = (0, $8Uumt.useFragment)($c957fe2570b7a195$export$66ac472152813d8b, userPreferences);
    const searchModeResponse = userPreferencesData?.jqlBuilderSearchMode;
    const selectedSearchMode = (0, $atxn1.toSearchModeWithBasicModeFallback)(searchModeResponse);
    const saveSearchModePreference = (0, $e6DTX.useSearchModeMutation)(userPreferencesData);
    if (searchModes.length === 0) throw new Error('Search mode should be non empty');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const uniqueSearchModes = (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(searchModes);
    const contextJql = (0, $55ttp.useContextJql)({
        jql: props.query,
        projectKeys: projectKeys
    });
    const [hydrationQueryRef, isHydrating] = (0, $OomEm.useHydrationQueryLoader)(contextJql, viewContext);
    const isSearchModeToggleEnabled = uniqueSearchModes ? uniqueSearchModes.length > 1 : true;
    const onSearchModeChange = (0, $5uXOq.useCallback)((searchMode, reason)=>{
        // Update the search mode preference when the reason is matching the allowed list
        // Note: The reasons currently used below were chosen to match previous behaviour when the new reason "QueryUnsupported" was introduced
        if (reason === 'UserTriggered' || reason === 'ExternalTriggered') saveSearchModePreference(searchMode);
        onUpdateSearchMode?.(searchMode, reason);
    }, [
        onUpdateSearchMode,
        saveSearchModePreference
    ]);
    const irremovableFields = (0, $7ckRQ.useIrremovableFields)(props.basicModeVisibleFields ?? (0, $7ckRQ.DEFAULT_IRREMOVABLE_FIELDS)());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jql-builder-ui",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2G1VO.JQLBuilderFallback), {
            query: props.query,
            searchModes: searchModes,
            selectedSearchMode: selectedSearchMode,
            isSearchModeToggleEnabled: isSearchModeToggleEnabled,
            beforeControls: props.beforeControls,
            renderExtraControls: props.renderExtraControls,
            excludedFields: props.excludedFields,
            components: props.components,
            irremovableFields: irremovableFields,
            hideTextSearchInput: hideTextSearchInput,
            searchPlaceholder: searchPlaceholder,
            searchModeSwitcherLocation: searchModeSwitcherLocation,
            showOrderByPicker: showOrderByPicker
        })
    }, hydrationQueryRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kcuJ8.QuerySupportedContainerOld), {
        query: props.query,
        excludedFields: props.excludedFields,
        jqlMessages: props.jqlMessages,
        hydrationQueryRef: hydrationQueryRef,
        isHydrating: isHydrating,
        simplifiedOperators: hideOperatorDropdownBasicMode,
        hideTextSearchInput: hideTextSearchInput,
        contextJql: contextJql
    }, uniqueSearchModes.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PKzp.SingleSearchModeContainer), {
        searchMode: uniqueSearchModes[0]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFE9c.JQLBuilderUIImplOld), {
        searchModes: uniqueSearchModes,
        hydrationQueryRef: hydrationQueryRef,
        selectedSearchMode: selectedSearchMode,
        isHydrating: isHydrating,
        onUpdateSearchMode: onUpdateSearchMode,
        hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        contextJql: contextJql,
        showOrderByPicker: showOrderByPicker,
        loadingModeRef: loadingModeRef,
        viewContext: viewContext,
        ...props
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PKzp.SelectedSearchModeContainer), {
        searchMode: selectedSearchMode,
        onSearchModeChange: onSearchModeChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFE9c.JQLBuilderUIImplOld), {
        searchModes: uniqueSearchModes,
        hydrationQueryRef: hydrationQueryRef,
        selectedSearchMode: selectedSearchMode,
        isHydrating: isHydrating,
        onUpdateSearchMode: onUpdateSearchMode,
        hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        contextJql: contextJql,
        showOrderByPicker: showOrderByPicker,
        loadingModeRef: loadingModeRef,
        viewContext: viewContext,
        ...props
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2G1VO.JQLBuilderFallback), {
        query: props.query,
        onLoad: onLoadingMode,
        searchModes: searchModes,
        selectedSearchMode: selectedSearchMode,
        isSearchModeToggleEnabled: isSearchModeToggleEnabled,
        beforeControls: props.beforeControls,
        renderExtraControls: props.renderExtraControls,
        excludedFields: props.excludedFields,
        components: props.components,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        showOrderByPicker: showOrderByPicker
    }));
};
var $c957fe2570b7a195$export$2e2bcd8739ae039 = $c957fe2570b7a195$var$JQLBuilderUI;

});
parcelRegister("8Q5yU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba4d3d6d29eb2038$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b11d5f22228dc9211f8c5e00e7ff8b20>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $5Pkdl = parcelRequire("5Pkdl");
const $ba4d3d6d29eb2038$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v1 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jql"
                }
            ],
            "type": "JiraJqlHydratedQuery"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "accountId"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "filterAri"
            },
            {
                "kind": "RootArgument",
                "name": "includeJira"
            },
            {
                "kind": "RootArgument",
                "name": "includeUser"
            },
            {
                "kind": "RootArgument",
                "name": "isFilter"
            },
            {
                "kind": "RootArgument",
                "name": "jql"
            },
            {
                "kind": "RootArgument",
                "name": "viewContext"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $5Pkdl.default)
            }
        },
        "name": "ui_jqlBuilder_JQLBuilderUI_hydrationQueryData",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "useHydratedValues"
            },
            {
                "kind": "FragmentSpread",
                "name": "jqlEditor_jqlBuilderBasic_JQLEditorUI"
            },
            {
                "kind": "FragmentSpread",
                "name": "useQuery"
            },
            {
                "kind": "FragmentSpread",
                "name": "useHydratedValues_cascadeSelectPicker"
            },
            {
                "condition": "includeJira",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "query",
                                                        "variableName": "jql"
                                                    },
                                                    v0 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQuery",
                                                "plural": false,
                                                "selections": v1 /*: any*/ 
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "id",
                                                        "variableName": "filterAri"
                                                    },
                                                    v0 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQueryForFilter",
                                                "plural": false,
                                                "selections": v1 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$ba4d3d6d29eb2038$var$node.hash = "560710f99a045f83f5c29aa4233e060f";
var $ba4d3d6d29eb2038$export$2e2bcd8739ae039 = $ba4d3d6d29eb2038$var$node;

});
parcelRegister("5Pkdl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8f5bd4c6fab98c4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1be30e03b71b70c19cc0e758400ccddb>>
 * @relayHash c7e40f6c6eb74890450a26112b741050
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aabe614c2cdd93412084db33e73afeaf1cfa63f5a534d2db76bb92e7f3000029
const $a8f5bd4c6fab98c4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeJira"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeUser"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isFilter"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewContext"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        v1 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        v2 /*: any*/ 
    ], v4 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v5 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorName"
                },
                v2 /*: any*/ 
            ]
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v10 = [
        v1 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jql"
                },
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "JiraJqlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlSearchTemplate",
                                            "kind": "LinkedField",
                                            "name": "searchTemplate",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldShowInContext"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "operators"
                                        },
                                        {
                                            "concreteType": "JiraFieldType",
                                            "kind": "LinkedField",
                                            "name": "fieldType",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "values",
                                                    "plural": true,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "project",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "small"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlProjectFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v8 /*: any*/ ,
                                                            "type": "JiraJqlStatusFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v8 /*: any*/ ,
                                                            "type": "JiraJqlStatusCategoryFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "xsmall"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": v3 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        },
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlPriorityFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v1 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "text"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                v2 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "sprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "state"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "boardName"
                                                                        },
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlSprintFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        v9 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlCascadingOptionFieldValue"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedValue"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "error",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedError"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ],
            "type": "QueryError"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "HydrationRefetchQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_jqlBuilder_JQLBuilderUI_hydrationQueryData"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "HydrationRefetchQuery",
            "selections": [
                {
                    "condition": "includeUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "accountId",
                                    "variableName": "accountId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": v3 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "query",
                                                            "variableName": "jql"
                                                        },
                                                        v4 /*: any*/ 
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQuery",
                                                    "plural": false,
                                                    "selections": v10 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "id",
                                                            "variableName": "filterAri"
                                                        },
                                                        v4 /*: any*/ 
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQueryForFilter",
                                                    "plural": false,
                                                    "selections": v10 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "aabe614c2cdd93412084db33e73afeaf1cfa63f5a534d2db76bb92e7f3000029",
            "metadata": {},
            "name": "HydrationRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a8f5bd4c6fab98c4$var$node.hash = "560710f99a045f83f5c29aa4233e060f";
var $a8f5bd4c6fab98c4$export$2e2bcd8739ae039 = $a8f5bd4c6fab98c4$var$node;

});


parcelRegister("562DD", function(module, exports) {

$parcel$export(module.exports, "default", () => $414d5d545801f7be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2b5dbf7906b653869505f67a354896a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $414d5d545801f7be$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_jqlBuilder_JQLBuilderUI",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "searchMode_useSearchMode_JQLBuilder"
        },
        {
            "kind": "ScalarField",
            "name": "jqlBuilderSearchMode"
        }
    ],
    "type": "JiraUserPreferences"
};
$414d5d545801f7be$var$node.hash = "9fbe210abfde6a98b4eff53d65746395";
var $414d5d545801f7be$export$2e2bcd8739ae039 = $414d5d545801f7be$var$node;

});

parcelRegister("1PKzp", function(module, exports) {

$parcel$export(module.exports, "SelectedSearchModeContainer", () => $ed4a31a78e0b03e2$export$d19caa48d475b9e3);
$parcel$export(module.exports, "SingleSearchModeContainer", () => $ed4a31a78e0b03e2$export$a70c1ee31d8bd058);
$parcel$export(module.exports, "useSelectedSearchMode", () => $ed4a31a78e0b03e2$export$af5effaed2abb303);

var $5uXOq = parcelRequire("5uXOq");

var $gdJXC = parcelRequire("gdJXC");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $032ey = parcelRequire("032ey");

var $kcuJ8 = parcelRequire("kcuJ8");
const $ed4a31a78e0b03e2$var$getSafeSearchMode = (mode)=>{
    switch(mode){
        case 0, $032ey.SEARCH_MODE_BASIC:
            return 0, $032ey.SEARCH_MODE_BASIC;
        case 0, $032ey.SEARCH_MODE_ADVANCED:
            return 0, $032ey.SEARCH_MODE_ADVANCED;
        default:
            return undefined;
    }
};
const $ed4a31a78e0b03e2$var$SelectedSearchModeContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    searchMode: (0, $032ey.DEFAULT_SEARCH_MODE),
    setSelectedSearchMode: ()=>null
});
const $ed4a31a78e0b03e2$var$getValidSelectedSearchMode = (searchMode, querySupported)=>{
    if (searchMode === (0, $032ey.SEARCH_MODE_ADVANCED)) return 0, $032ey.SEARCH_MODE_ADVANCED;
    if (searchMode === (0, $032ey.SEARCH_MODE_BASIC) && querySupported) return 0, $032ey.SEARCH_MODE_BASIC;
    return 0, $032ey.SEARCH_MODE_ADVANCED;
};
const $ed4a31a78e0b03e2$export$d19caa48d475b9e3 = ({ children: children, searchMode: searchMode, onSearchModeChange: onSearchModeChange })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { querySupported: querySupported } = (0, $kcuJ8.useIsQuerySupported)();
    (0, $gdJXC.useRunOnce)(()=>{
        // Send analytics on inital load (like when you open a url with a query too complex)
        if (!querySupported && searchMode !== (0, $032ey.SEARCH_MODE_ADVANCED)) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'queryTooComplex triggered', {
            searchMode: searchMode
        });
    });
    const [searchModeInternal, setSearchModeInternal] = (0, $5uXOq.useState)($ed4a31a78e0b03e2$var$getValidSelectedSearchMode(searchMode, querySupported));
    if (!querySupported && searchModeInternal !== (0, $032ey.SEARCH_MODE_ADVANCED)) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'queryTooComplex triggered', {
            searchMode: searchModeInternal
        });
        setSearchModeInternal((0, $032ey.SEARCH_MODE_ADVANCED));
    }
    (0, $5uXOq.useEffect)(()=>{
        if (!querySupported && searchMode === (0, $032ey.SEARCH_MODE_BASIC) && searchModeInternal === (0, $032ey.SEARCH_MODE_ADVANCED)) onSearchModeChange?.((0, $032ey.SEARCH_MODE_ADVANCED), 'QueryUnsupported');
    }, [
        onSearchModeChange,
        querySupported,
        searchMode,
        searchModeInternal
    ]);
    const setSelectedSearchMode = (0, $5uXOq.useCallback)((newSearchMode, userTriggered)=>{
        const safeSearchMode = $ed4a31a78e0b03e2$var$getSafeSearchMode(newSearchMode);
        if (!safeSearchMode) return;
        setSearchModeInternal(safeSearchMode);
        onSearchModeChange?.(safeSearchMode, userTriggered ? 'UserTriggered' : 'ExternalTriggered');
        if (userTriggered) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'switchJQLEditor', {
            switchToEditor: (0, $032ey.mapSearchModeToAnalyticAtribute)[safeSearchMode]
        });
    }, [
        createAnalyticsEvent,
        onSearchModeChange
    ]);
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            searchMode: searchModeInternal,
            setSelectedSearchMode: setSelectedSearchMode
        }), [
        searchModeInternal,
        setSelectedSearchMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed4a31a78e0b03e2$var$SelectedSearchModeContext.Provider, {
        value: contextValue
    }, children);
};
const $ed4a31a78e0b03e2$export$a70c1ee31d8bd058 = ({ children: children, searchMode: searchMode })=>{
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            searchMode: searchMode,
            setSelectedSearchMode: ()=>null
        }), [
        searchMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed4a31a78e0b03e2$var$SelectedSearchModeContext.Provider, {
        value: contextValue
    }, children);
};
const $ed4a31a78e0b03e2$export$af5effaed2abb303 = ()=>(0, $5uXOq.useContext)($ed4a31a78e0b03e2$var$SelectedSearchModeContext);

});
parcelRegister("gdJXC", function(module, exports) {

$parcel$export(module.exports, "useRunOnce", () => $0c4640a50ed5ee95$export$a3576ea6e6df583c);

var $5uXOq = parcelRequire("5uXOq");
const $0c4640a50ed5ee95$export$a3576ea6e6df583c = (cb, identifier)=>{
    const ref = (0, $5uXOq.useRef)(true);
    const identifierRef = (0, $5uXOq.useRef)(identifier);
    if (identifierRef.current !== identifier) {
        ref.current = true;
        identifierRef.current = identifier;
    }
    if (ref.current) cb();
    ref.current = false;
};

});

parcelRegister("kcuJ8", function(module, exports) {

$parcel$export(module.exports, "QuerySupportedContainerOld", () => $07b5dc85de1a70b9$export$f94eb234c660c8a5);
$parcel$export(module.exports, "QuerySupportedContainer", () => $07b5dc85de1a70b9$export$34660422c2aeae3d);
$parcel$export(module.exports, "useIsQuerySupported", () => $07b5dc85de1a70b9$export$8ce0898530622ab2);

var $1QEdi = parcelRequire("1QEdi");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6H2U3 = parcelRequire("6H2U3");

var $89g1C = parcelRequire("89g1C");

var $OomEm = parcelRequire("OomEm");

var $8vNru = parcelRequire("8vNru");

var $caSpf = parcelRequire("caSpf");

var $4R6GH = parcelRequire("4R6GH");

var $k3Vq9 = parcelRequire("k3Vq9");
const $07b5dc85de1a70b9$export$7b6dd859fbd6fe77 = (0, $1QEdi.default);
/* eslint-enable @atlassian/relay/graphql-naming,  @atlassian/relay/unused-fields */ const $07b5dc85de1a70b9$var$useQuerySupportedOld = ({ currentJql: currentJql, excludedFields: excludedFields = [], jqlErrors: jqlErrors, hydrationQueryRef: hydrationQueryRef, isHydrating: isHydrating, simplifiedOperators: simplifiedOperators, hideTextSearchInput: hideTextSearchInput, contextJql: contextJql })=>{
    const onPerformanceMark = (0, $caSpf.usePerformanceContext)();
    onPerformanceMark({
        mark: (0, $8vNru.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_HYDRATE_START
    });
    /* eslint-disable @atlassian/relay/query-restriction */ const hydratedData = (0, $8Uumt.usePreloadedQuery)((0, $OomEm.HYDRATION_QUERY), hydrationQueryRef);
    onPerformanceMark({
        mark: (0, $8vNru.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_HYDRATE_END
    });
    const fieldsHydrationData = (0, $8Uumt.useFragment)($07b5dc85de1a70b9$export$7b6dd859fbd6fe77, hydratedData);
    /* eslint-enable @atlassian/relay/query-restriction */ return (0, $5uXOq.useMemo)(()=>{
        const fieldsData = {};
        if (fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQuery?.fields) fieldsHydrationData.jira.jqlBuilder.hydrateJqlQuery.fields.forEach((field)=>{
            if (field?.jqlTerm && field?.field?.searchTemplate?.key && field?.field.type) fieldsData[field.jqlTerm] = {
                jqlTerm: field.jqlTerm,
                searchTemplate: field.field.searchTemplate.key,
                operators: field.field.operators.map((0, $89g1C.mapOperators)),
                fieldType: field.field.type,
                hydratedValues: field.values
            };
        });
        else if (fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter?.fields) fieldsHydrationData.jira.jqlBuilder.hydrateJqlQueryForFilter.fields.forEach((field)=>{
            if (field?.jqlTerm && field?.field?.searchTemplate?.key && field?.field.type) fieldsData[field.jqlTerm] = {
                jqlTerm: field.jqlTerm,
                searchTemplate: field.field.searchTemplate.key,
                operators: field.field.operators.map((0, $89g1C.mapOperators)),
                fieldType: field.field.type,
                hydratedValues: field.values
            };
        });
        const isLastHydrationQuery = contextJql !== hydrationQueryRef?.variables.jql;
        let querySupported = true;
        if ((0, $4R6GH.fg)('nin_shortcut_jql_complexity_check_on_error')) querySupported = !jqlErrors?.length && /**
       * Relay run one render iteration with isHydrating false but with the old data,
       * so we check if the jql matches the current hydration query.
       */ (isHydrating || isLastHydrationQuery ? /**
      * If we are hydrating, we run a complexity check without checking operators.
      * This allow us to show advanced mode loading state if we already know the query is too complex.
      * For Example, when we have multiple compound clauses or have unsupported nodes
      */ !(0, $6H2U3.isQueryTooComplex)({
            jql: currentJql,
            excludedFields: excludedFields,
            shouldValidateOperators: false,
            hideTextSearchInput: hideTextSearchInput
        }) : /**
      * Complete complexity check using hydrated data.
      */ !(0, $6H2U3.isQueryTooComplex)({
            jql: currentJql,
            excludedFields: excludedFields,
            fieldsData: fieldsData,
            simplifiedOperators: simplifiedOperators,
            hideTextSearchInput: hideTextSearchInput
        }));
        else querySupported = /**
       * Relay run one render iteration with isHydrating false but with the old data,
       * so we check if the jql matches the current hydration query.
       */ isHydrating || isLastHydrationQuery ? /**
      * If we are hydrating, we run a complexity check without checking operators.
      * This allow us to show advanced mode loading state if we already know the query is too complex.
      * For Example, when we have multiple compound clauses or have unsupported nodes
      */ !(0, $6H2U3.isQueryTooComplex)({
            jql: currentJql,
            excludedFields: excludedFields,
            shouldValidateOperators: false,
            hideTextSearchInput: hideTextSearchInput
        }) : /**
      * Complete complexity check using hydrated data.
      */ !(0, $6H2U3.isQueryTooComplex)({
            jql: currentJql,
            excludedFields: excludedFields,
            fieldsData: fieldsData,
            simplifiedOperators: simplifiedOperators,
            hideTextSearchInput: hideTextSearchInput
        }) && !jqlErrors?.length;
        return {
            querySupported: querySupported
        };
    }, [
        fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQuery?.fields,
        fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter?.fields,
        contextJql,
        hydrationQueryRef?.variables.jql,
        currentJql,
        isHydrating,
        excludedFields,
        hideTextSearchInput,
        simplifiedOperators,
        jqlErrors?.length
    ]);
};
const $07b5dc85de1a70b9$export$f94eb234c660c8a5 = ({ query: query, excludedFields: excludedFields = [], jqlMessages: jqlMessages, children: children, hydrationQueryRef: hydrationQueryRef, isHydrating: isHydrating = false, simplifiedOperators: simplifiedOperators = false, hideTextSearchInput: hideTextSearchInput = false, contextJql: contextJql })=>{
    const jqlErrors = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>(jqlMessages || []).filter((e)=>e.type === 'error'), [
        jqlMessages
    ]);
    const { querySupported: querySupported } = $07b5dc85de1a70b9$var$useQuerySupportedOld({
        currentJql: query,
        excludedFields: excludedFields,
        jqlErrors: jqlErrors,
        hydrationQueryRef: hydrationQueryRef,
        isHydrating: isHydrating,
        simplifiedOperators: simplifiedOperators,
        hideTextSearchInput: hideTextSearchInput,
        contextJql: contextJql
    });
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            querySupported: querySupported
        }), [
        querySupported
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($07b5dc85de1a70b9$var$QuerySupportedContext.Provider, {
        value: contextValue
    }, children);
};
const $07b5dc85de1a70b9$var$useQuerySupported = ({ currentJql: currentJql, excludedFields: excludedFields = [], jqlErrors: jqlErrors, hydrationData: hydrationData, simplifiedOperators: simplifiedOperators, hideTextSearchInput: hideTextSearchInput, contextJql: contextJql })=>{
    /* eslint-disable @atlassian/relay/query-restriction */ const fieldsHydrationData = (0, $8Uumt.useFragment)($07b5dc85de1a70b9$export$7b6dd859fbd6fe77, hydrationData);
    /* eslint-enable @atlassian/relay/query-restriction */ const { hydrationQueryIsFetching: hydrationQueryIsFetching, hydrationQueryContextJql: hydrationQueryContextJql } = (0, $k3Vq9.useHydrationQuery)();
    return (0, $5uXOq.useMemo)(()=>{
        const fieldsData = {};
        if (fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQuery?.fields) fieldsHydrationData.jira.jqlBuilder.hydrateJqlQuery.fields.forEach((field)=>{
            if (field?.jqlTerm && field?.field?.searchTemplate?.key && field?.field.type) fieldsData[field.jqlTerm] = {
                jqlTerm: field.jqlTerm,
                searchTemplate: field.field.searchTemplate.key,
                operators: field.field.operators.map((0, $89g1C.mapOperators)),
                fieldType: field.field.type,
                hydratedValues: field.values
            };
        });
        else if (fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter?.fields) fieldsHydrationData.jira.jqlBuilder.hydrateJqlQueryForFilter.fields.forEach((field)=>{
            if (field?.jqlTerm && field?.field?.searchTemplate?.key && field?.field.type) fieldsData[field.jqlTerm] = {
                jqlTerm: field.jqlTerm,
                searchTemplate: field.field.searchTemplate.key,
                operators: field.field.operators.map((0, $89g1C.mapOperators)),
                fieldType: field.field.type,
                hydratedValues: field.values
            };
        });
        const isLastHydrationQuery = contextJql !== hydrationQueryContextJql;
        let querySupported = true;
        if ((0, $4R6GH.fg)('nin_shortcut_jql_complexity_check_on_error')) querySupported = !jqlErrors?.length && /**
       * Relay run one render iteration with isHydrating false but with the old data,
       * so we check if the jql matches the current hydration query.
       */ (hydrationQueryIsFetching || isLastHydrationQuery ? /**
      * If we are hydrating, we run a complexity check without checking operators.
      * This allow us to show advanced mode loading state if we already know the query is too complex.
      * For Example, when we have multiple compound clauses or have unsupported nodes
      */ !(0, $6H2U3.isQueryTooComplex)({
            jql: currentJql,
            excludedFields: excludedFields,
            shouldValidateOperators: false,
            hideTextSearchInput: hideTextSearchInput
        }) : /**
      * Complete complexity check using hydrated data.
      */ !(0, $6H2U3.isQueryTooComplex)({
            jql: currentJql,
            excludedFields: excludedFields,
            fieldsData: fieldsData,
            simplifiedOperators: simplifiedOperators,
            hideTextSearchInput: hideTextSearchInput
        }));
        else querySupported = /**
       * Relay run one render iteration with isHydrating false but with the old data,
       * so we check if the jql matches the current hydration query.
       */ hydrationQueryIsFetching || isLastHydrationQuery ? /**
      * If we are hydrating, we run a complexity check without checking operators.
      * This allow us to show advanced mode loading state if we already know the query is too complex.
      * For Example, when we have multiple compound clauses or have unsupported nodes
      */ !(0, $6H2U3.isQueryTooComplex)({
            jql: currentJql,
            excludedFields: excludedFields,
            shouldValidateOperators: false,
            hideTextSearchInput: hideTextSearchInput
        }) : /**
      * Complete complexity check using hydrated data.
      */ !(0, $6H2U3.isQueryTooComplex)({
            jql: currentJql,
            excludedFields: excludedFields,
            fieldsData: fieldsData,
            simplifiedOperators: simplifiedOperators,
            hideTextSearchInput: hideTextSearchInput
        }) && !jqlErrors?.length;
        return {
            querySupported: querySupported
        };
    }, [
        fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQuery?.fields,
        fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter?.fields,
        contextJql,
        hydrationQueryContextJql,
        hydrationQueryIsFetching,
        currentJql,
        excludedFields,
        hideTextSearchInput,
        simplifiedOperators,
        jqlErrors?.length
    ]);
};
const $07b5dc85de1a70b9$var$QuerySupportedContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    querySupported: true
});
const $07b5dc85de1a70b9$export$34660422c2aeae3d = ({ query: query, excludedFields: excludedFields = [], jqlMessages: jqlMessages, children: children, hydrationData: hydrationData, simplifiedOperators: simplifiedOperators = false, hideTextSearchInput: hideTextSearchInput = false, contextJql: contextJql })=>{
    const jqlErrors = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>(jqlMessages || []).filter((e)=>e.type === 'error'), [
        jqlMessages
    ]);
    const { querySupported: querySupported } = $07b5dc85de1a70b9$var$useQuerySupported({
        currentJql: query,
        excludedFields: excludedFields,
        jqlErrors: jqlErrors,
        hydrationData: hydrationData,
        simplifiedOperators: simplifiedOperators,
        hideTextSearchInput: hideTextSearchInput,
        contextJql: contextJql
    });
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            querySupported: querySupported
        }), [
        querySupported
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($07b5dc85de1a70b9$var$QuerySupportedContext.Provider, {
        value: contextValue
    }, children);
};
const $07b5dc85de1a70b9$export$8ce0898530622ab2 = ()=>(0, $5uXOq.useContext)($07b5dc85de1a70b9$var$QuerySupportedContext);

});
parcelRegister("1QEdi", function(module, exports) {

$parcel$export(module.exports, "default", () => $01f9bf733604f8cd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cf67fe5b58f692aebfb1ba734cbd9edd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $01f9bf733604f8cd$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v1 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v5 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "concreteType": "JiraJqlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "operators"
                                        },
                                        {
                                            "concreteType": "JiraJqlSearchTemplate",
                                            "kind": "LinkedField",
                                            "name": "searchTemplate",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "values",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                v1 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        v1 /*: any*/ ,
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlCascadingOptionFieldValue"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedValue"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v1 /*: any*/ 
                                            ],
                                            "type": "JiraJqlQueryHydratedError"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "filterAri"
            },
            {
                "kind": "RootArgument",
                "name": "includeJira"
            },
            {
                "kind": "RootArgument",
                "name": "isFilter"
            },
            {
                "kind": "RootArgument",
                "name": "jql"
            },
            {
                "kind": "RootArgument",
                "name": "viewContext"
            }
        ],
        "kind": "Fragment",
        "name": "useQuery",
        "selections": [
            {
                "condition": "includeJira",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "query",
                                                        "variableName": "jql"
                                                    },
                                                    v0 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQuery",
                                                "plural": false,
                                                "selections": v5 /*: any*/ 
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "id",
                                                        "variableName": "filterAri"
                                                    },
                                                    v0 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQueryForFilter",
                                                "plural": false,
                                                "selections": v5 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$01f9bf733604f8cd$var$node.hash = "2f363277414286c5c850b5c424d00b46";
var $01f9bf733604f8cd$export$2e2bcd8739ae039 = $01f9bf733604f8cd$var$node;

});

parcelRegister("6H2U3", function(module, exports) {

$parcel$export(module.exports, "isQueryTooComplex", () => $6a273a05a18a6f17$export$4a510b220f67686c);

var $3KEIl = parcelRequire("3KEIl");

var $5Dsab = parcelRequire("5Dsab");

var $8RcVP = parcelRequire("8RcVP");

var $i00hv = parcelRequire("i00hv");

var $eftWU = parcelRequire("eftWU");

var $6jt9j = parcelRequire("6jt9j");

var $4uLp9 = parcelRequire("4uLp9");
const $6a273a05a18a6f17$var$haveKnownUnsupportedOperators = (clauses)=>clauses.some((clause)=>clause.clauseType === (0, $64e15c988a7f27d3$export$ae56b4ef248a2b6a) && clause.operator && (0, $4uLp9.getUnsupportedOperators)().includes(clause.operator.value));
const $6a273a05a18a6f17$var$isClauseTooComplex = ({ clauses: clauses, searchTemplate: searchTemplate, hydratedValues: hydratedValues })=>{
    // Date
    // Or if we don't know the value while not hydrated and can show basic picker
    if (!searchTemplate || (0, $5Dsab.dateSearchTemplates).has(searchTemplate)) return clauses.length > 2 || $6a273a05a18a6f17$var$haveKnownUnsupportedOperators(clauses);
    // Cascading Select
    if (searchTemplate === (0, $5Dsab.CASCADE_SELECT_FIELD_SEARCH_TEMPLATE)) {
        const unambiguousCascadeFieldValue = (0, $i00hv.findUnambiguousCascadeFieldValue)({
            clause: clauses[0],
            hydratedValues: hydratedValues
        });
        return clauses.length !== 1 || unambiguousCascadeFieldValue === undefined;
    }
    // Number Range & Work Ratio
    if (searchTemplate === (0, $5Dsab.NUMBER_RANGE_FIELD_SEARCH_TEMPLATE) || searchTemplate === 'workratio') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const operatorValues = clauses.map((clause)=>clause?.operator?.value.toString());
        return clauses.length > 2 || clauses.length === 2 && !(0, $5Dsab.NUMBER_RANGE_PICKER_ALLOWED_OPERATORS).every((op)=>operatorValues.includes(op));
    }
    // CMDB/AQL
    if (searchTemplate === (0, $5Dsab.CMDB_FIELD_SEARCH_TEMPLATE)) return clauses.length !== 1 || (0, $eftWU.isCmdbClauseTooComplexForBasicMode)(clauses[0]);
    // Default
    return clauses.length > 1;
};
const $6a273a05a18a6f17$export$4a510b220f67686c = ({ jql: jql, excludedFields: excludedFields = [], fieldsData: fieldsData, shouldValidateOperators: shouldValidateOperators = true, simplifiedOperators: simplifiedOperators = false, hideTextSearchInput: hideTextSearchInput = false })=>{
    const jast = new (0, $3KEIl.JastBuilder)().build(jql);
    if (jast.errors.length) return true;
    try {
        const jqlClauseCollectingVisitor = new (0, $6jt9j.JqlClauseCollectingVisitor)(shouldValidateOperators, excludedFields, fieldsData, simplifiedOperators);
        const result = jast.query && jast.query.accept(jqlClauseCollectingVisitor);
        if (!result) return false;
        return(// Check if text search input clause is hidden
        result.textSearchInputClause && hideTextSearchInput || // Check if text search input clause is invalid
        !(0, $8RcVP.default).validate(result.textSearchInputClause) || // Check if any clause is too complex
        Object.keys(result.clauseMap).some((key)=>{
            const clauses = result.clauseMap[key];
            const searchTemplate = fieldsData?.[key]?.searchTemplate;
            return $6a273a05a18a6f17$var$isClauseTooComplex({
                clauses: clauses,
                searchTemplate: searchTemplate,
                hydratedValues: fieldsData?.[key]?.hydratedValues
            });
        }));
    } catch (error) {
        return true;
    }
};

});
parcelRegister("8RcVP", function(module, exports) {

$parcel$export(module.exports, "default", () => $805845a75e8bdf1e$export$2e2bcd8739ae039);

var $gjjVy = parcelRequire("gjjVy");
var $3jFAr = parcelRequire("3jFAr");
var $9Dyrx = parcelRequire("9Dyrx");

var $4R6GH = parcelRequire("4R6GH");

var $5Dsab = parcelRequire("5Dsab");

var $1dTaH = parcelRequire("1dTaH");

var $k3hd7 = parcelRequire("k3hd7");
/**
 * Check if search input clause is valid
 */ const $805845a75e8bdf1e$var$validate = (compoundClause)=>{
    // eslint-disable-next-line jira/ff/inline-usage
    const isTextFieldsEnabled = (0, $4R6GH.fg)('nin-text-fields-new-text-search-field');
    if (!compoundClause) return true;
    try {
        compoundClause.accept(new (0, $k3hd7.TextSearchInputVisitor)({
            isTextFieldsEnabled: isTextFieldsEnabled
        }));
        return true;
    } catch (e) {
        return false;
    }
};
/**
 * Return value of search input clause or undefined if it's invalid or empty
 */ const $805845a75e8bdf1e$var$value = (textSearchClause)=>{
    // eslint-disable-next-line jira/ff/inline-usage
    const isTextFieldsEnabled = (0, $4R6GH.fg)('nin-text-fields-new-text-search-field');
    if (!textSearchClause) return undefined;
    try {
        return textSearchClause.accept(new (0, $k3hd7.TextSearchInputVisitor)({
            isTextFieldsEnabled: isTextFieldsEnabled
        }));
    } catch (e) {
        return undefined;
    }
};
const $805845a75e8bdf1e$var$createTextSearchInputClause = ({ quotedKeyword: quotedKeyword, isIssueKey: isIssueKey })=>{
    const textSearchInputClause = (0, $gjjVy.default).terminalClause((0, $gjjVy.default).field((0, $5Dsab.getTextSearchInputField)()), (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_LIKE)), (0, $gjjVy.default).byText.valueOperand(quotedKeyword));
    if (isIssueKey) {
        const issueKeyClause = (0, $gjjVy.default).terminalClause((0, $gjjVy.default).field((0, $5Dsab.ISSUE_KEY)), (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_EQUALS)), (0, $gjjVy.default).byText.valueOperand(quotedKeyword));
        return (0, $gjjVy.default).compoundClause((0, $gjjVy.default).compoundOperator((0, $ed890f3e326c0985$export$7b8f0a728d79a753)), [
            textSearchInputClause,
            issueKeyClause
        ]);
    }
    return textSearchInputClause;
};
/**
 * Update search input clause with new value
 */ const $805845a75e8bdf1e$var$update = (ast, textSearchInputClause, val)=>{
    if (!$805845a75e8bdf1e$var$validate(textSearchInputClause)) return ast.represents;
    if (val === undefined || val === null || val === '') {
        if (textSearchInputClause) textSearchInputClause.remove();
        else return ast.represents;
    } else {
        const isIssueKey = (0, $k3hd7.isIssueKeyValue)(val);
        const quotedKeyword = (0, $1dTaH.wrapWithQuotes)((0, $1dTaH.escapeBackslashes)(val));
        const newTextSearchInputClause = $805845a75e8bdf1e$var$createTextSearchInputClause({
            quotedKeyword: quotedKeyword,
            isIssueKey: isIssueKey
        });
        if (textSearchInputClause) textSearchInputClause.replace(newTextSearchInputClause);
        else ast.query?.appendClause(newTextSearchInputClause, (0, $ed890f3e326c0985$export$6d6d48d210d3ca97));
    }
    return (0, $9Dyrx.print)(ast, {
        operatorCase: 'upper'
    });
};
const $805845a75e8bdf1e$var$TextFieldType = {
    validate: $805845a75e8bdf1e$var$validate,
    value: $805845a75e8bdf1e$var$value,
    update: $805845a75e8bdf1e$var$update
};
var $805845a75e8bdf1e$export$2e2bcd8739ae039 = $805845a75e8bdf1e$var$TextFieldType;

});
parcelRegister("1dTaH", function(module, exports) {

$parcel$export(module.exports, "generateOptions", () => $7ba5746e0a05ea50$export$c21133b4499f5374);
$parcel$export(module.exports, "generateErrorOptions", () => $7ba5746e0a05ea50$export$b1b163cf4487fb60);
$parcel$export(module.exports, "fireJqlBuilderBasicErrorAnalytics", () => $7ba5746e0a05ea50$export$2704bef70095c059);
$parcel$export(module.exports, "wrapWithQuotes", () => $7ba5746e0a05ea50$export$125e49598117a72);
$parcel$export(module.exports, "escapeBackslashes", () => $7ba5746e0a05ea50$export$fbd15c27bb7e257c);
$parcel$export(module.exports, "isPickerPropType", () => $7ba5746e0a05ea50$export$353a391606dc3779);
$parcel$export(module.exports, "isTextAreaPropType", () => $7ba5746e0a05ea50$export$96188d366777c3f5);

var $jcw0u = parcelRequire("jcw0u");

var $5Dsab = parcelRequire("5Dsab");

var $8OILN = parcelRequire("8OILN");
const $7ba5746e0a05ea50$export$c21133b4499f5374 = (options, totalCount, endCursor)=>({
        options: options,
        totalCount: totalCount === undefined ? null : totalCount,
        endCursor: endCursor
    });
const $7ba5746e0a05ea50$export$b1b163cf4487fb60 = (error)=>$7ba5746e0a05ea50$export$c21133b4499f5374([
        {
            optionType: 'error',
            error: error,
            onRetry: ()=>undefined
        }
    ]);
const $7ba5746e0a05ea50$export$2704bef70095c059 = (id, searchTemplate, error)=>(0, $jcw0u.default)({
        meta: {
            id: id,
            packageName: (0, $5Dsab.PACKAGE_NAME),
            teamName: (0, $5Dsab.TEAM_NAME)
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        attributes: {
            searchTemplate: searchTemplate
        }
    });
const $7ba5746e0a05ea50$export$125e49598117a72 = (text)=>`"${text.replace(/"/g, '\\"')}"`;
const $7ba5746e0a05ea50$export$fbd15c27bb7e257c = (text)=>text.replace(/\\/g, '\\\\');
const $7ba5746e0a05ea50$export$353a391606dc3779 = (propType)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.values((0, $8OILN.PickerPropTypes)).includes(propType);
const $7ba5746e0a05ea50$export$96188d366777c3f5 = (propType)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.values((0, $8OILN.TextAreaPropTypes)).includes(propType);

});
parcelRegister("8OILN", function(module, exports) {

$parcel$export(module.exports, "PickerTypes", () => $7fe736d8adf76ba6$export$823060bb41f9b9ce);
$parcel$export(module.exports, "PickerPropTypes", () => $7fe736d8adf76ba6$export$8673a3795efdab32);
$parcel$export(module.exports, "TextAreaPropTypes", () => $7fe736d8adf76ba6$export$84f313a0fe939ad2);
$parcel$export(module.exports, "GenericPropTypes", () => $7fe736d8adf76ba6$export$39db718405e40735);
const $7fe736d8adf76ba6$export$823060bb41f9b9ce = {
    CascadeSelect: 'CascadeSelect',
    DateTime: 'DateTime',
    DueDate: 'DueDate',
    DateTimeRange: 'DateTimeRange',
    NumberRange: 'NumberRange',
    Picker: 'Picker',
    Text: 'Text',
    TextArea: 'TextArea',
    BooleanType: 'BooleanType',
    Unsupported: 'Unsupported'
};
const $7fe736d8adf76ba6$export$8673a3795efdab32 = {
    CommonWithEmpty: 'CommonWithEmpty',
    Common: 'Common',
    IssueType: 'IssueType',
    Project: 'Project',
    Sprint: 'Sprint',
    Version: 'Version',
    User: 'User',
    Group: 'Group'
};
const $7fe736d8adf76ba6$export$84f313a0fe939ad2 = {
    Text: 'Text',
    Number: 'Number',
    Aql: 'Aql',
    ExactText: 'ExactText'
};
const $7fe736d8adf76ba6$export$39db718405e40735 = {
    NoProp: 'NoProp'
};

});


parcelRegister("k3hd7", function(module, exports) {

$parcel$export(module.exports, "isIssueKeyValue", () => $c01848c35007a5b6$export$ac7a009e7c9d6434);
$parcel$export(module.exports, "TextSearchInputVisitor", () => $c01848c35007a5b6$export$d5784d52b31adc66);

var $92zfQ = parcelRequire("92zfQ");
var $3jFAr = parcelRequire("3jFAr");

var $5Dsab = parcelRequire("5Dsab");

var $kznWD = parcelRequire("kznWD");
const $c01848c35007a5b6$var$areTerminalClauses = (clauses)=>{
    for (const clause of clauses){
        if (clause.clauseType !== (0, $64e15c988a7f27d3$export$ae56b4ef248a2b6a)) return false;
    }
    return true;
};
const $c01848c35007a5b6$var$ISSUE_KEY_REGEXP = new RegExp('^[A-Z][A-Z0-9]+-[0-9]+$', 'i');
const $c01848c35007a5b6$export$ac7a009e7c9d6434 = (value)=>value !== undefined && value !== null && $c01848c35007a5b6$var$ISSUE_KEY_REGEXP.test(value);
class $c01848c35007a5b6$export$d5784d52b31adc66 extends (0, $92zfQ.AbstractJastVisitor) {
    constructor({ isTextFieldsEnabled: isTextFieldsEnabled }){
        super(), this.visitCompoundClause = (compoundClause)=>{
            // Only allow one compound clause with 1 or 2 terminal clauses using OR operator
            if (compoundClause.clauses.length > 2 || compoundClause.clauses.length < 1 || compoundClause.operator.value !== (0, $ed890f3e326c0985$export$7b8f0a728d79a753) || !$c01848c35007a5b6$var$areTerminalClauses(compoundClause.clauses)) throw new (0, $kznWD.InvalidTextSearchInputError)('Invalid search input clause');
            const valueMap = {};
            const value = compoundClause.clauses.reduce((result, terminalClause)=>{
                const clauseFieldName = terminalClause.field.value.toLowerCase();
                // Use same fieldName for key and issuekey (they are aliases)
                const fieldName = clauseFieldName === 'key' ? 'issuekey' : clauseFieldName;
                // Check if there are duplicated fields
                if (valueMap[fieldName]) throw new (0, $kznWD.InvalidTextSearchInputError)(`Duplicated field ${fieldName}`);
                else valueMap[fieldName] = true;
                return this.aggregateResult(terminalClause.accept(this), result);
            }, undefined);
            // Check if all required fields are present
            if (!valueMap[(0, $5Dsab.getTextSearchInputField)()] || valueMap.issuekey !== undefined && !valueMap.issuekey) throw new (0, $kznWD.InvalidTextSearchInputError)('Missing required field in search input');
            return value;
        }, this.visitTerminalClause = (terminalClause)=>{
            const fieldName = terminalClause.field.value.toLowerCase();
            // Only allow terminal clause with value operand
            if (terminalClause.operand?.operandType !== (0, $96a349542da5e08d$export$38accfc5a5d1c113)) throw new (0, $kznWD.InvalidTextSearchInputError)(`Invalid operandType ${terminalClause.operand?.operandType}`);
            if (fieldName === (0, $5Dsab.getTextSearchInputField)()) {
                if (terminalClause.operator?.value !== (0, $3jFAr.OPERATOR_LIKE)) throw new (0, $kznWD.InvalidTextSearchInputError)(`Invalid operator in ${fieldName}`);
                return terminalClause.operand.value;
            }
            // Issue key check
            if (fieldName === 'issuekey' || fieldName === 'key') {
                if (terminalClause.operator?.value !== (0, $3jFAr.OPERATOR_EQUALS)) throw new (0, $kznWD.InvalidTextSearchInputError)(`Invalid operator in ${fieldName}`);
                if (!$c01848c35007a5b6$export$ac7a009e7c9d6434(terminalClause.operand.value)) throw new (0, $kznWD.InvalidTextSearchInputError)(`Invalid value in ${fieldName}`);
                return terminalClause.operand.value;
            }
            throw new (0, $kznWD.InvalidTextSearchInputError)(`Invalid field ${fieldName}`);
        }, this.aggregateResult = (aggregate, nextResult)=>{
            // We only allow using same value in all terminal clauses
            if (nextResult !== undefined && aggregate !== nextResult) throw new (0, $kznWD.InvalidTextSearchInputError)('Mismatched values in search input');
            return aggregate;
        };
        this.isTextFieldsEnabled = isTextFieldsEnabled;
    }
    defaultResult() {
        throw new (0, $kznWD.InvalidTextSearchInputError)('Invalid search input clause');
    }
}

});
parcelRegister("kznWD", function(module, exports) {

$parcel$export(module.exports, "InvalidTextSearchInputError", () => $dc80ec1a6ef3f97f$export$d6efcb4541a8aae7);
class $dc80ec1a6ef3f97f$export$d6efcb4541a8aae7 extends Error {
}

});



parcelRegister("i00hv", function(module, exports) {

$parcel$export(module.exports, "findUnambiguousCascadeFieldValue", () => $fc1c10b0cc689c7e$export$b146240c7e4a7cf6);


var $5Dsab = parcelRequire("5Dsab");
const $fc1c10b0cc689c7e$export$d6b4e2aa5cb86d59 = 'JiraJqlCascadingOptionFieldValue';
const $fc1c10b0cc689c7e$var$isHydrationJqlValueOrError = (value)=>value?.__typename === 'JiraJqlQueryHydratedValue' || value?.__typename === 'JiraJqlQueryHydratedError';
const $fc1c10b0cc689c7e$var$matchValueToClause = (hydratedValues, clauseValue)=>clauseValue ? hydratedValues?.find((fieldValue)=>$fc1c10b0cc689c7e$var$isHydrationJqlValueOrError(fieldValue) && fieldValue?.jqlTerm?.toLowerCase() === clauseValue?.toLowerCase()) : undefined;
const $fc1c10b0cc689c7e$var$isCascadingOptionFieldValue = (value)=>value?.__typename === 'JiraJqlCascadingOptionFieldValue';
/**
 * Returns the hydrated select option state (both parent and child) that the
 * cascading select picker accepts
 */ const $fc1c10b0cc689c7e$var$getCascadingSelectStateFromFieldValue = (value)=>{
    if (!value?.optionId || !value?.displayName) return undefined;
    if (value.parentOption?.optionId && value.parentOption?.displayName) return {
        childOption: {
            label: value.displayName,
            value: value.optionId
        },
        parentOption: {
            label: value.parentOption.displayName,
            value: value.parentOption.optionId
        }
    };
    return {
        parentOption: {
            label: value.displayName,
            value: value.optionId
        }
    };
};
const $fc1c10b0cc689c7e$var$getInvalidCascadingSelectOption = (valueOrError)=>({
        label: valueOrError.jqlTerm,
        value: valueOrError.jqlTerm,
        isInvalid: true
    });
/**
 * Handles determining the correct hydration to use for values from the `cascadeOption` function
 *
 * @param parent The JqlHydrationValue containing the possible parent options (or hydration error)
 * @param child  The JqlHydrationValue containing the possible child options (or hydration error)
 */ const $fc1c10b0cc689c7e$var$getCascadingSelectStateForFunction = (parent, child)=>{
    // If there is no parent, then there cannot be a child either
    if (!parent) return undefined;
    // If the parent is invalid, then we can assume that the child is also invalid
    if (parent?.__typename === 'JiraJqlQueryHydratedError') return {
        parentOption: $fc1c10b0cc689c7e$var$getInvalidCascadingSelectOption(parent),
        childOption: child ? $fc1c10b0cc689c7e$var$getInvalidCascadingSelectOption(child) : undefined
    };
    // Find the parent option values. Parent options have parentOption set to null
    const parentValues = parent?.values?.filter($fc1c10b0cc689c7e$var$isCascadingOptionFieldValue).filter((parentValue)=>!parentValue?.parentOption);
    // If there is no child, then we can return the parent option.
    if (!child && parentValues?.length === 1) return $fc1c10b0cc689c7e$var$getCascadingSelectStateFromFieldValue(parentValues[0]);
    // If there were multiple possible parents and no children, then it is ambiguous and we will return none
    if (!child) return undefined;
    if (child?.__typename === 'JiraJqlQueryHydratedError') // If the child is invalid, we can at least attempt to salvage the parent
    return parentValues?.length === 1 ? {
        ...$fc1c10b0cc689c7e$var$getCascadingSelectStateFromFieldValue(parentValues[0]),
        childOption: $fc1c10b0cc689c7e$var$getInvalidCascadingSelectOption(child)
    } : {
        parentOption: $fc1c10b0cc689c7e$var$getInvalidCascadingSelectOption(parent),
        childOption: $fc1c10b0cc689c7e$var$getInvalidCascadingSelectOption(child)
    };
    // Find the child option values. Child options have parentOption set to a parent option. We can
    // use that to find the children that match a parent option found above
    const childValues = child?.values?.filter($fc1c10b0cc689c7e$var$isCascadingOptionFieldValue).filter((childValue)=>parentValues?.some((parentValue)=>childValue?.parentOption && parentValue?.optionId === childValue?.parentOption.optionId));
    // If there is only one child value, we can return the parent and child option, otherwise the
    // clause is ambiguous
    if (childValues?.length === 1) return $fc1c10b0cc689c7e$var$getCascadingSelectStateFromFieldValue(childValues[0]);
};
const $fc1c10b0cc689c7e$export$b146240c7e4a7cf6 = ({ hydratedValues: hydratedValues, clause: clause })=>{
    if (clause?.clauseType !== (0, $64e15c988a7f27d3$export$ae56b4ef248a2b6a)) return;
    // Handle the case where clause is a list with mupltiple values
    if (clause?.operand?.operandType === (0, $96a349542da5e08d$export$fabec4aebba3f4df) && clause?.operand?.values?.length > 1) return;
    // Handle the case where clause is a cascadeOption function (with at most two arguments)
    if (clause?.operand?.operandType === (0, $96a349542da5e08d$export$19c7c729db381f9d) && clause?.operand?.function.value === (0, $5Dsab.CASCADE_OPTION_FUNCTION_NAME) && clause?.operand?.arguments && clause?.operand?.arguments.length <= 2) {
        const { operand: operand } = clause;
        return $fc1c10b0cc689c7e$var$getCascadingSelectStateForFunction(// Find the field value that matches the first argument of the cascadeOption function (parent)
        $fc1c10b0cc689c7e$var$matchValueToClause(hydratedValues, operand?.arguments[0]?.value), // Find the field value that matches the second argument of the cascadeOption function (child)
        $fc1c10b0cc689c7e$var$matchValueToClause(hydratedValues, operand?.arguments[1]?.value));
    }
    // Handle the case where clause is a single value or a list with one value
    if (clause?.operand?.operandType !== (0, $96a349542da5e08d$export$f6049126fd97001f)) {
        let clauseValue = '';
        // Get the value of the clause depending on the operand type
        switch(clause?.operand?.operandType){
            case 0, $96a349542da5e08d$export$fabec4aebba3f4df:
                if (clause?.operand?.values?.[0]?.operandType !== (0, $96a349542da5e08d$export$38accfc5a5d1c113)) return;
                clauseValue = clause?.operand?.values?.[0]?.value;
                break;
            case 0, $96a349542da5e08d$export$38accfc5a5d1c113:
                clauseValue = clause?.operand?.value;
                break;
            default:
                return;
        }
        // Match the clause value to a field value
        const matchedValue = $fc1c10b0cc689c7e$var$matchValueToClause(hydratedValues, clauseValue);
        if (matchedValue?.__typename === 'JiraJqlQueryHydratedError') // If there's a hydration error, the best we can do is assume it's the parent
        // This assumption resulsts in a better UX than kicking the user to advanced mode
        // with no further information.
        return {
            parentOption: $fc1c10b0cc689c7e$var$getInvalidCascadingSelectOption(matchedValue)
        };
        // If there is more than one matched value, the clause is ambiguous, otherwise we can get
        // the parent and child option
        if (matchedValue?.values && matchedValue.values.length === 1 && $fc1c10b0cc689c7e$var$isCascadingOptionFieldValue(matchedValue.values[0])) return $fc1c10b0cc689c7e$var$getCascadingSelectStateFromFieldValue(matchedValue.values[0]);
    }
    return undefined;
};

});

parcelRegister("eftWU", function(module, exports) {

$parcel$export(module.exports, "isCmdbClauseTooComplexForBasicMode", () => $65337d97e1daaca1$export$eed7916f3400f094);


var $5Dsab = parcelRequire("5Dsab");
const $65337d97e1daaca1$export$eed7916f3400f094 = (clause)=>clause.clauseType !== (0, $64e15c988a7f27d3$export$ae56b4ef248a2b6a) || clause.operand?.operandType !== (0, $96a349542da5e08d$export$19c7c729db381f9d) || ![
        (0, $5Dsab.AQL_FUNCTION_NAME).toLowerCase(),
        (0, $5Dsab.IQL_FUNCTION_NAME).toLowerCase()
    ].includes(clause.operand?.function.value.toLowerCase()) || clause.operand?.arguments.length !== 1;

});

parcelRegister("6jt9j", function(module, exports) {

$parcel$export(module.exports, "JqlClauseCollectingVisitor", () => $ed1a767d3d234642$export$566c7abb4018442d);

var $3dHKF = parcelRequire("3dHKF");

var $92zfQ = parcelRequire("92zfQ");

var $5Dsab = parcelRequire("5Dsab");

var $8OILN = parcelRequire("8OILN");

var $i0Cp4 = parcelRequire("i0Cp4");

var $j200s = parcelRequire("j200s");
class $ed1a767d3d234642$export$566c7abb4018442d extends (0, $92zfQ.AbstractJastVisitor) {
    /**
	 *
	 * @param shouldValidateOperators {boolean} - When true, when visiting a terminal clause, will
	 * compare the clause's operator to the allowed operators for the matching field in the
	 * `fieldsData` arg
	 * @param excludedFields
	 * @param fieldsData {FieldDataMap} - This is data transformed from the hydration query. We
	 * assume all of the fields are 1:1 with those in the AST since the same JQL query was used when
	 * calling hydration query
	 * @param simplifiedOperators
	 */ constructor(shouldValidateOperators = true, excludedFields = [], fieldsData, simplifiedOperators = false){
        super(), this.visitCompoundClause = (compoundClause)=>{
            const operator = compoundClause.operator.value;
            if (operator === (0, $ed890f3e326c0985$export$6d6d48d210d3ca97)) return compoundClause.clauses.reduce((result, clause)=>this.aggregateResult(clause.accept(this), result), {
                clauseMap: {}
            });
            if (operator === (0, $ed890f3e326c0985$export$7b8f0a728d79a753)) // The only supported OR clause is for the text search refinement. Downstream validators are responsible for
            // checking if the compound clause is valid for text search.
            // If future refinements emerge that also use OR clauses then this logic would need to change to perform some
            // type of shape matching against the clause to find the correct refinement key.
            return {
                clauseMap: {},
                textSearchInputClause: compoundClause
            };
            throw new (0, $j200s.UnsupportedRefinementError)(`Compound clauses using the operator '${operator}' is not supported`);
        }, this.visitTerminalClause = (terminalClause)=>{
            const fieldName = terminalClause.field.value.toLowerCase();
            if (this.shouldValidateOperators) {
                if (this.excludedFields.includes(fieldName)) throw new (0, $j200s.UnsupportedRefinementError)(`Field with name '${fieldName}' of type ${terminalClause.clauseType} is not supported`);
                const operator = terminalClause.operator?.value ?? '';
                if (this.fieldsData) {
                    // handling text is an edge case when nin-text-fields-new-text-search-field is off
                    // we used to fallback to consts for text, project, status, type, assignee but that
                    // is no longer the case since making irremovable fields configurable. Instead we
                    // expect each field has hydration data instead.
                    // the `text` field is known to not have hydration data when nin-text-fields-new-text-search-field
                    // is disabled and so for this specific case we fall back to the TEXT const.
                    // This is just temporary until nin-text-fields-new-text-search-field is cleaned up
                    const textSearchInputData = (0, $5Dsab.getTextSearchInputFieldData)();
                    const fieldData = fieldName === textSearchInputData.jqlTerm ? textSearchInputData : this.fieldsData[fieldName];
                    const { allowedOperators: allowedOperators, pickerType: pickerType } = (0, $i0Cp4.getPickerType)({
                        searchTemplate: fieldData.searchTemplate,
                        fieldType: fieldData.fieldType,
                        operators: fieldData.operators,
                        simplifiedOperators: this.simplifiedOperators
                    });
                    if (pickerType !== (0, $8OILN.PickerTypes).Unsupported && allowedOperators) {
                        const isAllowedOperator = allowedOperators.map((allowedOperator)=>allowedOperator.value.toLowerCase()).includes(operator.toLowerCase());
                        if (!isAllowedOperator) throw new (0, $j200s.UnsupportedRefinementError)(`Field with value '${fieldName}' and searchTemplate '${fieldData.searchTemplate}' of type ${terminalClause.clauseType} is using an unsupported operator [${operator}]`);
                    }
                } else throw new (0, $j200s.UnsupportedRefinementError)('Field data should be defined to validate operators');
            }
            if (fieldName === (0, $5Dsab.getTextSearchInputField)()) return {
                clauseMap: {},
                textSearchInputClause: terminalClause
            };
            return {
                clauseMap: {
                    [terminalClause.field.value.toLowerCase()]: [
                        terminalClause
                    ]
                }
            };
        };
        this.shouldValidateOperators = shouldValidateOperators;
        this.excludedFields = excludedFields;
        this.fieldsData = fieldsData;
        this.simplifiedOperators = simplifiedOperators;
    }
    visitNotClause() {
        throw new (0, $j200s.UnsupportedRefinementError)('JqlClauseCollectingVisitor visited an unsupported node while traversing the AST');
    }
    defaultResult() {
        return {
            clauseMap: {}
        };
    }
    /**
	 * @param aggregate new ClauseMap to add into nextResult
	 * @param nextResult ClauseMap with previous results
	 * @returns ClauseMap with the merged results adding the aggregate at the end
	 */ aggregateResult(aggregate, nextResult) {
        if (nextResult.textSearchInputClause && aggregate.textSearchInputClause) throw new (0, $j200s.UnsupportedRefinementError)('Too many text search input clause clauses');
        // First parameter is the object where we want to add the values and the second the new values to merge into the first object.
        return {
            clauseMap: (0, (/*@__PURE__*/$parcel$interopDefault($3dHKF)))(nextResult.clauseMap, aggregate.clauseMap, (destValue, srcValue)=>srcValue.concat(destValue ?? [])),
            textSearchInputClause: aggregate.textSearchInputClause === undefined ? nextResult.textSearchInputClause : aggregate.textSearchInputClause
        };
    }
}

});
parcelRegister("3dHKF", function(module, exports) {

var $1m1GH = parcelRequire("1m1GH");

var $9MM2g = parcelRequire("9MM2g");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $2584862af7fb4983$var$mergeWith = $9MM2g(function(object, source, srcIndex, customizer) {
    $1m1GH(object, source, srcIndex, customizer);
});
module.exports = $2584862af7fb4983$var$mergeWith;

});

parcelRegister("i0Cp4", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedPickerType", () => $02d8cf8959551cab$export$fb7c01070886ad20);
$parcel$export(module.exports, "getPickerType", () => $02d8cf8959551cab$export$42840c00d43e8a94);

var $4R6GH = parcelRequire("4R6GH");

var $5Dsab = parcelRequire("5Dsab");

var $8OILN = parcelRequire("8OILN");

var $8OqfS = parcelRequire("8OqfS");
const $02d8cf8959551cab$export$fb7c01070886ad20 = ({ searchTemplate: searchTemplate, fieldType: fieldType })=>({
        searchTemplate: searchTemplate,
        fieldType: fieldType,
        pickerType: (0, $8OILN.PickerTypes).Unsupported,
        propType: (0, $8OILN.GenericPropTypes).NoProp
    });
const $02d8cf8959551cab$var$getPickerData = ({ searchTemplate: searchTemplate, fieldType: fieldType, pickerType: pickerType, propType: propType, fieldOperators: fieldOperators, simplifiedOperators: simplifiedOperators = false })=>({
        searchTemplate: searchTemplate,
        fieldType: fieldType,
        pickerType: pickerType,
        propType: propType,
        allowedOperators: (0, $8OqfS.getAllowedOperators)({
            pickerType: pickerType,
            fieldOperators: fieldOperators,
            propType: propType,
            simplifiedOperators: simplifiedOperators
        })
    });
const $02d8cf8959551cab$export$42840c00d43e8a94 = ({ searchTemplate: searchTemplate, fieldType: fieldType, operators: fieldOperators, simplifiedOperators: simplifiedOperators })=>{
    const commonAttributes = {
        searchTemplate: searchTemplate,
        fieldType: fieldType,
        fieldOperators: fieldOperators,
        simplifiedOperators: simplifiedOperators
    };
    switch(searchTemplate){
        // move text case next to summary when cleanup nin-text-fields-new-text-search-field
        case 'text':
            if ((0, $4R6GH.fg)('nin-text-fields-new-text-search-field')) return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).TextArea,
                propType: (0, $8OILN.TextAreaPropTypes).Text
            });
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).Text,
                propType: (0, $8OILN.GenericPropTypes).NoProp
            });
        case 'textFields':
            if ((0, $4R6GH.fg)('nin-text-fields-new-text-search-field')) return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).Text,
                propType: (0, $8OILN.GenericPropTypes).NoProp
            });
            return $02d8cf8959551cab$export$fb7c01070886ad20({
                searchTemplate: searchTemplate,
                fieldType: fieldType
            });
        case 'summary':
        case 'description':
        case 'environment':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:textsearcher':
        case 'comment':
        case 'com.pyxis.greenhopper.jira:gh-epic-label-searcher':
        case 'jira.polaris:textsearcher':
        case 'com.atlassian.jira.ext.charting:textsearcher':
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).TextArea,
                propType: (0, $8OILN.TextAreaPropTypes).Text
            });
        case 'com.atlassian.jira.plugin.system.customfieldtypes:exacttextsearcher':
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).TextArea,
                propType: (0, $8OILN.TextAreaPropTypes).ExactText
            });
        case 'created':
        case 'updated':
        case 'resolutiondate':
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).DateTime,
                propType: (0, $8OILN.GenericPropTypes).NoProp
            });
        case 'com.atlassian.jira.plugin.system.customfieldtypes:daterange':
        case 'statuscategorychangedate':
        case 'com.atlassian.jpo:jpo-custom-field-baseline-start-searcher':
        case 'com.atlassian.jpo:jpo-custom-field-baseline-end-searcher':
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).DateTime,
                propType: (0, $8OILN.GenericPropTypes).NoProp
            });
        case 'com.atlassian.jira.toolkit:LastCommentDateSearcher':
        case 'com.atlassian.jira.ext.charting:firstreponsedatesearcher':
        case 'com.atlassian.servicedesk:sd-request-feedback-date-searcher':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:datetimerange':
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).DateTimeRange,
                propType: (0, $8OILN.GenericPropTypes).NoProp
            });
        case 'duedate':
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).DueDate,
                propType: (0, $8OILN.GenericPropTypes).NoProp
            });
        case 'labels':
        case 'priority':
        case 'resolution':
        case 'status':
        case 'statusCategory':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:labelsearcher':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:multiselectsearcher':
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).Picker,
                propType: (0, $8OILN.PickerPropTypes).Common
            });
        case 'components':
        case 'parent':
        case 'com.pyxis.greenhopper.jira:gh-epic-link-searcher':
        case 'ticketCategory':
        case 'com.pyxis.greenhopper.jira:gh-epic-status-searcher':
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).Picker,
                propType: (0, $8OILN.PickerPropTypes).CommonWithEmpty
            });
        case 'versions':
        case 'fixVersions':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:versionsearcher':
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).Picker,
                propType: (0, $8OILN.PickerPropTypes).Version
            });
        case 'assignee':
        case 'creator':
        case 'reporter':
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).Picker,
                propType: (0, $8OILN.PickerPropTypes).User
            });
        case 'com.atlassian.jira.plugin.system.customfieldtypes:userpickergroupsearcher':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:next-gen-people-searcher':
        case 'com.atlassian.jira.toolkit:participantsearcher':
        case 'com.atlassian.jira.toolkit:lastparticipantsearcher':
        case 'com.atlassian.servicedesk:sd-request-participants-searcher':
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).Picker,
                propType: (0, $8OILN.PickerPropTypes).User
            });
        case 'issuetype':
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).Picker,
                propType: (0, $8OILN.PickerPropTypes).IssueType
            });
        case 'project':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:projectsearcher':
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).Picker,
                propType: (0, $8OILN.PickerPropTypes).Project
            });
        case 'com.pyxis.greenhopper.jira:gh-sprint-searcher':
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).Picker,
                propType: (0, $8OILN.PickerPropTypes).Sprint
            });
        case 'com.atlassian.jira.plugin.system.customfieldtypes:grouppickersearcher':
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).Picker,
                propType: (0, $8OILN.PickerPropTypes).Group
            });
        case 0, $5Dsab.CASCADE_SELECT_FIELD_SEARCH_TEMPLATE:
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).CascadeSelect,
                propType: (0, $8OILN.GenericPropTypes).NoProp
            });
        case 'com.atlassian.jira.plugin.system.customfieldtypes:exactnumber':
        case 'com.pyxis.greenhopper.jira:jsw-story-points-searcher':
        case 'jira.polaris:exact-number-searcher':
        case 'com.atlassian.servicedesk:sd-request-feedback-searcher':
        case 'com.atlassian.jira.toolkit:commentcountsearcher':
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).TextArea,
                propType: (0, $8OILN.TextAreaPropTypes).Number
            });
        case 'com.atlassian.jira.toolkit:lastcommentersearcher':
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).BooleanType,
                propType: (0, $8OILN.GenericPropTypes).NoProp
            });
        case 'workratio':
        case 0, $5Dsab.NUMBER_RANGE_FIELD_SEARCH_TEMPLATE:
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).NumberRange,
                propType: (0, $8OILN.GenericPropTypes).NoProp
            });
        case 0, $5Dsab.CMDB_FIELD_SEARCH_TEMPLATE:
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).TextArea,
                propType: (0, $8OILN.TextAreaPropTypes).Aql
            });
        case 0, $5Dsab.JSM_REQUEST_TYPE_SEARCH_TEMPLATE:
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).Picker,
                propType: (0, $8OILN.PickerPropTypes).CommonWithEmpty
            });
        case 0, $5Dsab.JSM_ORGANIZATIONS_SEARCH_TEMPLATE:
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).Picker,
                propType: (0, $8OILN.PickerPropTypes).CommonWithEmpty
            });
        case 0, $5Dsab.JSM_WORK_CATEGORY_SEARCH_TEMPLATE:
            return $02d8cf8959551cab$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $8OILN.PickerTypes).Picker,
                propType: (0, $8OILN.PickerPropTypes).CommonWithEmpty
            });
        default:
            return $02d8cf8959551cab$export$fb7c01070886ad20({
                searchTemplate: searchTemplate,
                fieldType: fieldType
            });
    }
};

});
parcelRegister("8OqfS", function(module, exports) {

$parcel$export(module.exports, "getAllowedOperators", () => $4bd50ae926c39c04$export$e56c61b51c1beb84);

var $gjjVy = parcelRequire("gjjVy");
var $3jFAr = parcelRequire("3jFAr");

var $5Dsab = parcelRequire("5Dsab");

var $8OILN = parcelRequire("8OILN");

var $1dTaH = parcelRequire("1dTaH");
const $4bd50ae926c39c04$var$SIMPLIFIED_PICKER_ALLOWED_OPERATORS = [
    (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_EQUALS)),
    (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_IN))
];
const $4bd50ae926c39c04$var$PICKER_ALLOWED_OPERATORS = [
    (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_EQUALS)),
    (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_NOT_EQUALS)),
    (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_IN)),
    (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_NOT_IN)),
    (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_IS)),
    (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_IS_NOT))
];
const $4bd50ae926c39c04$var$TEXT_PICKER_ALLOWED_OPERATORS = [
    (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_LIKE))
];
const $4bd50ae926c39c04$export$362ce0c36f9a70b6 = (propType)=>{
    if (!(0, $1dTaH.isTextAreaPropType)(propType)) throw new Error(`Unsupported TextAreaPropType: ${propType}`);
    switch(propType){
        case (0, $8OILN.TextAreaPropTypes).Number:
        case (0, $8OILN.TextAreaPropTypes).ExactText:
            return [
                (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_EQUALS))
            ];
        case (0, $8OILN.TextAreaPropTypes).Text:
            return [
                (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_LIKE))
            ];
        case (0, $8OILN.TextAreaPropTypes).Aql:
            return [
                (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_IN))
            ];
        default:
            throw new Error(`Unsupported TextAreaPropType: ${propType}`);
    }
};
const $4bd50ae926c39c04$var$DATE_PICKER_ALLOWED_OPERATORS = [
    (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_LT_EQUALS)),
    (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_GT_EQUALS))
];
const $4bd50ae926c39c04$var$CASCADE_SELECT_PICKER_ALLOWED_OPERATORS = [
    (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_IN)),
    (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_EQUALS))
];
const $4bd50ae926c39c04$var$BOOLEAN_PICKER_ALLOWED_OPERATORS = [
    (0, $gjjVy.default).operator((0, $3jFAr.OPERATOR_EQUALS))
];
const $4bd50ae926c39c04$var$getPickerOperators = (fieldOperators)=>$4bd50ae926c39c04$var$PICKER_ALLOWED_OPERATORS.filter((allowedOperator)=>fieldOperators.findIndex((fieldOperator)=>allowedOperator.value === fieldOperator) >= 0);
const $4bd50ae926c39c04$export$e56c61b51c1beb84 = ({ pickerType: pickerType, fieldOperators: fieldOperators = [], propType: propType = (0, $8OILN.GenericPropTypes).NoProp, simplifiedOperators: simplifiedOperators })=>{
    switch(pickerType){
        case (0, $8OILN.PickerTypes).Text:
            return $4bd50ae926c39c04$var$TEXT_PICKER_ALLOWED_OPERATORS;
        case (0, $8OILN.PickerTypes).TextArea:
            return $4bd50ae926c39c04$export$362ce0c36f9a70b6(propType);
        case (0, $8OILN.PickerTypes).DateTime:
        case (0, $8OILN.PickerTypes).DueDate:
        case (0, $8OILN.PickerTypes).DateTimeRange:
            return $4bd50ae926c39c04$var$DATE_PICKER_ALLOWED_OPERATORS;
        case (0, $8OILN.PickerTypes).Picker:
            return !simplifiedOperators ? $4bd50ae926c39c04$var$getPickerOperators(fieldOperators) : $4bd50ae926c39c04$var$SIMPLIFIED_PICKER_ALLOWED_OPERATORS;
        case (0, $8OILN.PickerTypes).CascadeSelect:
            return $4bd50ae926c39c04$var$CASCADE_SELECT_PICKER_ALLOWED_OPERATORS;
        case (0, $8OILN.PickerTypes).NumberRange:
            return (0, $5Dsab.NUMBER_RANGE_PICKER_ALLOWED_OPERATORS).map((op)=>(0, $gjjVy.default).operator(op));
        case (0, $8OILN.PickerTypes).BooleanType:
            return $4bd50ae926c39c04$var$BOOLEAN_PICKER_ALLOWED_OPERATORS;
        default:
            return [];
    }
};

});


parcelRegister("j200s", function(module, exports) {

$parcel$export(module.exports, "UnsupportedRefinementError", () => $53b8b25bbeadef10$export$251a1c8599975384);
/**
 * This represents an error when trying to map a JQL AST to a collection of refinements supported by NIN. If the JAST
 * contains syntax or fields not supported by the refinement bar then this error will be thrown.
 */ class $53b8b25bbeadef10$export$251a1c8599975384 extends Error {
}

});


parcelRegister("4uLp9", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedOperators", () => $53eaf9d83eedc533$export$4b9252b112620e15);

var $3jFAr = parcelRequire("3jFAr");
const $53eaf9d83eedc533$var$UNSUPPORTED_OPERATORS = [
    ...(0, $3jFAr.CHANGED_OPERATORS),
    ...(0, $3jFAr.WAS_OPERATORS),
    ...(0, $3jFAr.WAS_IN_OPERATORS)
];
const $53eaf9d83eedc533$export$4b9252b112620e15 = ()=>$53eaf9d83eedc533$var$UNSUPPORTED_OPERATORS;

});


parcelRegister("89g1C", function(module, exports) {

$parcel$export(module.exports, "mapOperators", () => $c5bd6006021452d1$export$ad17522432f44705);

var $3jFAr = parcelRequire("3jFAr");
const $c5bd6006021452d1$export$ad17522432f44705 = (jiraJqlOpeartor)=>{
    switch(jiraJqlOpeartor){
        case 'EQUALS':
            return 0, $3jFAr.OPERATOR_EQUALS;
        case 'NOT_EQUALS':
            return 0, $3jFAr.OPERATOR_NOT_EQUALS;
        case 'IS':
            return 0, $3jFAr.OPERATOR_IS;
        case 'IN':
            return 0, $3jFAr.OPERATOR_IN;
        case 'IS_NOT':
            return 0, $3jFAr.OPERATOR_IS_NOT;
        case 'NOT_IN':
            return 0, $3jFAr.OPERATOR_NOT_IN;
        case 'CONTAINS':
            return 0, $3jFAr.OPERATOR_LIKE;
        case 'DOES_NOT_CONTAIN':
            return 0, $3jFAr.OPERATOR_NOT_LIKE;
        case 'WAS_NOT_IN':
            return 0, $3jFAr.OPERATOR_WAS_NOT_IN;
        case 'WAS_NOT':
            return 0, $3jFAr.OPERATOR_WAS_NOT;
        case 'WAS_IN':
            return 0, $3jFAr.OPERATOR_WAS_IN;
        case 'WAS':
            return 0, $3jFAr.OPERATOR_WAS;
        case 'CHANGED':
            return 0, $3jFAr.OPERATOR_CHANGED;
        case 'GREATER_THAN':
            return 0, $3jFAr.OPERATOR_GT;
        case 'GREATER_THAN_OR_EQUAL':
            return 0, $3jFAr.OPERATOR_GT_EQUALS;
        case 'LESS_THAN':
            return 0, $3jFAr.OPERATOR_LT;
        case 'LESS_THAN_OR_EQUAL':
            return 0, $3jFAr.OPERATOR_LT_EQUALS;
        default:
            throw new Error(`Operator ${jiraJqlOpeartor} not supported`);
    }
};

});

parcelRegister("8vNru", function(module, exports) {

$parcel$export(module.exports, "JQL_BUILDER_PERFORMANCE_MARKS", () => $491ce87882605bf7$export$5fd6d8ece357700d);
// Performance marks
const $491ce87882605bf7$var$JQL_BUILDER_START = 'JQL_BUILDER_START';
const $491ce87882605bf7$var$JQL_BUILDER_END = 'JQL_BUILDER_END';
const $491ce87882605bf7$var$JQL_BUILDER_HYDRATE_START = 'JQL_BUILDER_HYDRATE_START';
const $491ce87882605bf7$var$JQL_BUILDER_HYDRATE_END = 'JQL_BUILDER_HYDRATE_END';
const $491ce87882605bf7$var$JQL_BUILDER_BASIC_START = 'JQL_BUILDER_BASIC_START';
const $491ce87882605bf7$var$JQL_BUILDER_BASIC_END = 'JQL_BUILDER_BASIC_END';
const $491ce87882605bf7$var$JQL_BUILDER_BASIC_JS_START = 'JQL_BUILDER_BASIC_JS_START';
const $491ce87882605bf7$var$JQL_BUILDER_BASIC_JS_END = 'JQL_BUILDER_BASIC_JS_END';
const $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_START = 'JQL_BUILDER_ADVANCED_START';
const $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_END = 'JQL_BUILDER_ADVANCED_END';
const $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_JS_START = 'JQL_BUILDER_ADVANCED_JS_START';
const $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_JS_END = 'JQL_BUILDER_ADVANCED_JS_END';
const $491ce87882605bf7$export$5fd6d8ece357700d = {
    JQL_BUILDER_START: /**
	 * JQL_BUILDER
	 * Count how long it takes to load the JQL Builder,
	 * from first render of async component to ready to use
	 */ $491ce87882605bf7$var$JQL_BUILDER_START,
    JQL_BUILDER_END: $491ce87882605bf7$var$JQL_BUILDER_END,
    JQL_BUILDER_HYDRATE_START: /**
	 * JQL_BUILDER_HYDRATE
	 * Count how long it takes from first try to use hydrated data
	 * to the momento is actually ready to use
	 */ $491ce87882605bf7$var$JQL_BUILDER_HYDRATE_START,
    JQL_BUILDER_HYDRATE_END: $491ce87882605bf7$var$JQL_BUILDER_HYDRATE_END,
    JQL_BUILDER_BASIC_JS_START: /**
	 * JQL_BUILDER_BASIC_JS
	 * Count how long it takes from FE perspective to load the basic JQL Builder Basic js package
	 */ $491ce87882605bf7$var$JQL_BUILDER_BASIC_JS_START,
    JQL_BUILDER_BASIC_JS_END: $491ce87882605bf7$var$JQL_BUILDER_BASIC_JS_END,
    JQL_BUILDER_BASIC_START: /**
	 * JQL_BUILDER_BASIC
	 * Count how long it takes to load the JQL Builder Basic,
	 * from first render of async basic component to ready to use
	 */ $491ce87882605bf7$var$JQL_BUILDER_BASIC_START,
    JQL_BUILDER_BASIC_END: $491ce87882605bf7$var$JQL_BUILDER_BASIC_END,
    JQL_BUILDER_ADVANCED_JS_START: /**
	 * JQL_BUILDER_ADVANCED_JS
	 * Count how long it takes from FE perspective to load the basic JQL Builder Advanced js package
	 */ $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_JS_START,
    JQL_BUILDER_ADVANCED_JS_END: $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_JS_END,
    JQL_BUILDER_ADVANCED_START: /**
	 * JQL_BUILDER_BASIC
	 * Count how long it takes to load the JQL Builder Advnaced,
	 * from first render of async advanced component to ready to use
	 */ $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_START,
    JQL_BUILDER_ADVANCED_END: $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_END
};

});

parcelRegister("k3Vq9", function(module, exports) {

$parcel$export(module.exports, "useHydrationQuery", () => $e0d752ab8ed72d46$export$9992ca387dbb4d57);
$parcel$export(module.exports, "HydrationQueryProvider", () => $e0d752ab8ed72d46$export$bb83aa31c9e87b59);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");
const $e0d752ab8ed72d46$var$HydrationQueryContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    hydrationQueryIsFetching: false,
    hydrationQueryContextJql: ''
});
$e0d752ab8ed72d46$var$HydrationQueryContext.displayName = 'HydrationQueryContext';
const $e0d752ab8ed72d46$export$9992ca387dbb4d57 = ()=>(0, $5uXOq.useContext)($e0d752ab8ed72d46$var$HydrationQueryContext);
const $e0d752ab8ed72d46$export$bb83aa31c9e87b59 = ({ refetch: refetch, query: query, contextJql: contextJql, hydratedJql: hydratedJql, children: children, viewContext: viewContext })=>{
    const [hydrationQueryIsFetching, setHydrationQueryIsFetching] = (0, $5uXOq.useState)(false);
    const cloudId = (0, $koeKL.useCloudId)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const inFlightRequest = (0, $5uXOq.useRef)();
    const inFlightContextJql = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        const shouldRefetch = contextJql !== hydratedJql && contextJql !== inFlightContextJql.current;
        if (shouldRefetch) {
            // Prevent race condition from multiple requests in progress
            // (ex. if user clicks quickly on different filters)
            inFlightRequest.current?.unsubscribe();
            inFlightContextJql.current = contextJql;
            const variables = {
                filterAri: '',
                includeFilter: false,
                jql: contextJql,
                accountId: atlassianAccountId ?? '',
                includeJira: true,
                includeUser: true,
                cloudId: cloudId,
                isFilter: false,
                ...(0, $4R6GH.fg)('jql_builder_add_view_context_to_hydration_query') && {
                    viewContext: viewContext
                }
            };
            setHydrationQueryIsFetching(true);
            // Prefetch data, then update returned variables on complete
            inFlightRequest.current = (0, $8Uumt.fetchQuery)(environment, query, variables, {
                fetchPolicy: 'store-or-network',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            }).subscribe({
                complete: ()=>{
                    refetch(variables, {
                        fetchPolicy: 'store-only',
                        onComplete: ()=>{
                            setHydrationQueryIsFetching(false);
                            inFlightContextJql.current = undefined;
                        }
                    });
                },
                error: (error)=>{
                    setHydrationQueryIsFetching(false);
                    (0, $jcw0u.default)({
                        meta: {
                            id: 'hydrateJqlBuilderQuery',
                            packageName: 'jiraJqlBuilder',
                            teamName: 'empanada'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            });
        }
    }, [
        atlassianAccountId,
        cloudId,
        contextJql,
        environment,
        hydratedJql,
        query,
        refetch,
        setHydrationQueryIsFetching,
        viewContext
    ]);
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            hydrationQueryIsFetching: hydrationQueryIsFetching,
            hydrationQueryContextJql: hydratedJql
        }), [
        hydrationQueryIsFetching,
        hydratedJql
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e0d752ab8ed72d46$var$HydrationQueryContext.Provider, {
        value: contextValue
    }, children);
};

});



parcelRegister("e6DTX", function(module, exports) {

$parcel$export(module.exports, "useSearchModeMutation", () => $2f4765bfe1d2c101$export$f4f7ced39b30a5ad);

var $RsPlF = parcelRequire("RsPlF");

var $1MwyQ = parcelRequire("1MwyQ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $koeKL = parcelRequire("koeKL");

var $cZpsT = parcelRequire("cZpsT");

var $032ey = parcelRequire("032ey");

var $atxn1 = parcelRequire("atxn1");
const $2f4765bfe1d2c101$var$SEARCH_MODE_KEY_IN_RELAY_STORE = 'jqlBuilderSearchMode';
/**
 * Simple updater util function for setting the user's preferred JQL Search mode
 * in the Relay store when a mutation was either successful or failed - we update the
 * store regardless so that the search mode does not spontaneously change when
 * switching between the AI container search modes.
 */ const $2f4765bfe1d2c101$var$relayStoreUpdater = (store, userPreferencesData, searchMode)=>{
    if (typeof userPreferencesData?.__id === 'string') {
        const record = store.get(userPreferencesData.__id);
        record?.setValue(searchMode, $2f4765bfe1d2c101$var$SEARCH_MODE_KEY_IN_RELAY_STORE);
    }
};
const $2f4765bfe1d2c101$export$f4f7ced39b30a5ad = (userPreferences)=>{
    /*
   * TODO
   * Why is there a relay fragment in a hook?!
   * Right now, we manually update the `jqlBuilderSearchMode` record in relay store.
   * We update it manually because the field is not a Node type and hence Relay cannot
   * automatically manage the store state for us.
   * Instead, we need to manually grab the __id, find the record and update it with the
   * mutation value so that the two are kept in sync.
   * This is a temporary measure until the graphQL schema is updated.
   * The fragment is in the hook for convenience, this hook is only called from
   * one component: `src/packages/jql-builder/src/ui/index.tsx`
   * In fact we can probably move this hook back into a UI component potentially.
   */ const userPreferencesData = (0, $8Uumt.useFragment)((0, $1MwyQ.default), userPreferences || null);
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $RsPlF.default));
    return (0, $5uXOq.useCallback)((mode)=>{
        if (!isAnonymous) {
            const serverSearchMode = (0, $atxn1.toServerSearchMode)(mode);
            commitMutation({
                variables: {
                    cloudId: cloudId,
                    searchMode: (0, $atxn1.toServerSearchMode)(mode)
                },
                onError: (error)=>{
                    (0, $jcw0u.default)({
                        sendToPrivacyUnsafeSplunk: true,
                        error: error,
                        meta: {
                            id: 'mainSelectedJqlBuilderModeMutation',
                            packageName: (0, $032ey.PACKAGE_NAME),
                            teamName: (0, $032ey.TEAM_NAME)
                        }
                    });
                    (0, $8Uumt.commitLocalUpdate)(environment, (store)=>$2f4765bfe1d2c101$var$relayStoreUpdater(store, userPreferencesData, serverSearchMode));
                },
                updater: (store)=>$2f4765bfe1d2c101$var$relayStoreUpdater(store, userPreferencesData, serverSearchMode)
            });
        }
    }, [
        cloudId,
        commitMutation,
        environment,
        isAnonymous,
        userPreferencesData
    ]);
};

});
parcelRegister("RsPlF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d1e5ceeb3c9b59e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e7a4f9b2c7ea46621cd664591e142a2b>>
 * @relayHash 5d62b62066d2e4341b25445f5710faf6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ea28f854d9d34cb357f7b0a2d32ddcfaabb301d65019ccde74b53cf76b1aeb39
const $4d1e5ceeb3c9b59e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchMode"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraUserPreferencesMutation",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "searchMode",
                                    "variableName": "searchMode"
                                }
                            ],
                            "concreteType": "JiraJQLBuilderSearchModeMutationPayload",
                            "kind": "LinkedField",
                            "name": "setJQLBuilderSearchMode",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "userSearchMode"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "searchModeJqlBuilder_updateJQLBuilderSearchModeMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "searchModeJqlBuilder_updateJQLBuilderSearchModeMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "ea28f854d9d34cb357f7b0a2d32ddcfaabb301d65019ccde74b53cf76b1aeb39",
            "metadata": {},
            "name": "searchModeJqlBuilder_updateJQLBuilderSearchModeMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$4d1e5ceeb3c9b59e$var$node.hash = "92ba3afb837dca41d4ee89012d43ffd1";
var $4d1e5ceeb3c9b59e$export$2e2bcd8739ae039 = $4d1e5ceeb3c9b59e$var$node;

});

parcelRegister("1MwyQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e8dfe38cbeb25f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c834bed95690edeb5b5d9f5778b02b05>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c5e8dfe38cbeb25f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchMode_useSearchMode_JQLBuilder",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraUserPreferences"
};
$c5e8dfe38cbeb25f$var$node.hash = "b610d5310493b4f35efc509255a102c4";
var $c5e8dfe38cbeb25f$export$2e2bcd8739ae039 = $c5e8dfe38cbeb25f$var$node;

});


parcelRegister("2G1VO", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderFallback", () => $9e8a9ae0035ed442$export$61e39bbfd9e09552);

var $5uXOq = parcelRequire("5uXOq");

var $8Pv5c = parcelRequire("8Pv5c");
var $6E7Jp = parcelRequire("6E7Jp");

var $4R6GH = parcelRequire("4R6GH");

var $imju0 = parcelRequire("imju0");

var $jDMe3 = parcelRequire("jDMe3");

var $6H2U3 = parcelRequire("6H2U3");

var $3HwlS = parcelRequire("3HwlS");

var $dCm1o = parcelRequire("dCm1o");

var $032ey = parcelRequire("032ey");

var $5UgV1 = parcelRequire("5UgV1");

var $3fufq = parcelRequire("3fufq");

var $kdzZz = parcelRequire("kdzZz");

var $8xRQz = parcelRequire("8xRQz");

var $jX4vm = parcelRequire("jX4vm");

var $g9ghO = parcelRequire("g9ghO");
const $9e8a9ae0035ed442$export$61e39bbfd9e09552 = ({ selectedSearchMode: selectedSearchMode, searchModes: searchModes, query: query, onLoad: onLoad, isSearchModeToggleEnabled: isSearchModeToggleEnabled, renderExtraControls: renderExtraControls, beforeControls: beforeControls, excludedFields: excludedFields, components: components, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, searchModeSwitcherLocation: searchModeSwitcherLocation = (0, $032ey.SEARCH_MODE_SWITCHER_LEFT_LOCATION), showOrderByPicker: showOrderByPicker })=>{
    const onJqlBuilderBasicLoad = (0, $5uXOq.useCallback)(()=>{
        onLoad && onLoad((0, $032ey.SEARCH_MODE_BASIC));
    }, [
        onLoad
    ]);
    const searchModeCandidate = (0, $5uXOq.useMemo)(()=>{
        if (selectedSearchMode === (0, $032ey.SEARCH_MODE_ADVANCED)) return 0, $032ey.SEARCH_MODE_ADVANCED;
        return (0, $6H2U3.isQueryTooComplex)({
            jql: query,
            excludedFields: excludedFields,
            shouldValidateOperators: false,
            hideTextSearchInput: hideTextSearchInput
        }) ? (0, $032ey.SEARCH_MODE_ADVANCED) : (0, $032ey.SEARCH_MODE_BASIC);
    }, [
        excludedFields,
        hideTextSearchInput,
        query,
        selectedSearchMode
    ]);
    /**
	 * ⚠️ This code contains architectural problems that now occur since JQL Builder being used in pages
	 * other than NIN. Since the introduction of `searchModes`, situations can arise where the
	 * computed searchMode may not exist in the available options set in `searchModes[]`. For example
	 * when `searchModes === ['basic']` but the computed search mode is set to `advanced` due to
	 * a query being too complex - LDR to do: https://hello.atlassian.net/l/cp/YrdVZ0fa
	 */ const searchMode = (0, $5uXOq.useMemo)(()=>{
        let resolvedSearchMode = searchModeCandidate;
        if (!searchModes?.length) resolvedSearchMode = searchModeCandidate;
        else resolvedSearchMode = searchModes.includes(searchModeCandidate) ? searchModeCandidate : searchModes[0];
        // Preload package depending on the resolved search mode
        if (resolvedSearchMode === (0, $032ey.SEARCH_MODE_ADVANCED)) (0, $6E7Jp.preloadJQLEditor)();
        else (0, $imju0.preloadJqlBuilderBasic)();
        return resolvedSearchMode;
    }, [
        searchModes,
        searchModeCandidate
    ]);
    (0, $5uXOq.useEffect)(()=>{
        searchMode === (0, $032ey.SEARCH_MODE_ADVANCED) && onLoad && onLoad((0, $032ey.SEARCH_MODE_ADVANCED));
    }, [
        onLoad,
        searchMode
    ]);
    const BeforeJqlBuilderContainerComponent = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $5UgV1.BeforeJqlBuilderContainer) : (0, $jX4vm.BeforeJqlBuilderContainerOld);
    const BeforeJqlBuilderListItemContainerComponent = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $5UgV1.BeforeJqlBuilderListItemContainer) : (0, $jX4vm.BeforeJqlBuilderListItemContainerOld);
    const AdvancedEditorWrapperComponent = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $5UgV1.AdvancedEditorWrapper) : (0, $jX4vm.AdvancedEditorWrapperOld);
    const jqlBuilderFallbackComponent = searchMode === (0, $032ey.SEARCH_MODE_ADVANCED) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AdvancedEditorWrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Pv5c.JQLEditorReadOnly), {
        isCompact: true,
        isSearch: true,
        query: query
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDMe3.JQLBuilderBasicFallback), {
        query: query,
        excludedFields: excludedFields,
        onLoad: onJqlBuilderBasicLoad,
        shouldUseListMarkup: true,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        showOrderByPicker: showOrderByPicker
    });
    const { SearchModeSwitcher: SearchModeSwitcher = (0, $3fufq.SearchModeSwitcher) } = components ?? {};
    const BeforeJqlBuilderWrapper = searchMode === (0, $032ey.SEARCH_MODE_BASIC) ? BeforeJqlBuilderListItemContainerComponent : BeforeJqlBuilderContainerComponent;
    const isSearchModeSwitcherOnLeft = searchModeSwitcherLocation === (0, $032ey.SEARCH_MODE_SWITCHER_LEFT_LOCATION) && (0, $3HwlS.getWillShowNav4)();
    const searchModeSwitcherComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xRQz.SearchModeSwitcherContainer), {
        testId: "jql-builder.ui.jql-builder-fallback.toggle-container",
        isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SearchModeSwitcher, {
        searchMode: searchMode,
        isBasicModeDisabled: false,
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onUpdateSearchMode: ()=>{}
    }));
    const editorContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, beforeControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BeforeJqlBuilderWrapper, null, beforeControls), isSearchModeToggleEnabled && isSearchModeSwitcherOnLeft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BeforeJqlBuilderWrapper, null, searchModeSwitcherComponent), jqlBuilderFallbackComponent, renderExtraControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g9ghO.default), {
        searchMode: searchMode,
        renderExtraControls: renderExtraControls,
        shouldUseListMarkup: searchMode === (0, $032ey.SEARCH_MODE_BASIC)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jX4vm.Container), {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "jql-builder",
        "data-vc": `jql-builder-fallback${false ? '-ssr' : ''}`,
        ...false && (0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nin_and_nav') && {
            'data-ssr-placeholder': 'jql-builder-fallback-placeholder'
        },
        ...!false && (0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nin_and_nav') && {
            'data-ssr-placeholder-replace': 'jql-builder-fallback-placeholder'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kdzZz.DefaultJqlBuilderContainer), {
        showAdvancedEditor: searchMode === (0, $032ey.SEARCH_MODE_ADVANCED)
    }, searchMode === (0, $032ey.SEARCH_MODE_BASIC) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jX4vm.BasicEditorListContainer), {
        "data-testid": "jql-builder.ui.jql-builder-fallback.basic-editor-list-container"
    }, editorContent) : editorContent), isSearchModeToggleEnabled && !isSearchModeSwitcherOnLeft && searchModeSwitcherComponent);
};

});
parcelRegister("8Pv5c", function(module, exports) {

$parcel$export(module.exports, "JQLEditorReadOnly", () => $21e8f003446aa8f2$export$96157d0351f40cdc);
$parcel$export(module.exports, "default", () => $21e8f003446aa8f2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $0yZbT = parcelRequire("0yZbT");

var $gktr3 = parcelRequire("gktr3");

var $jzydL = parcelRequire("jzydL");

var $jVZlQ = parcelRequire("jVZlQ");

var $graSN = parcelRequire("graSN");
const $21e8f003446aa8f2$var$JQLEditorLayout = (props)=>{
    const { defaultMaxRows: defaultMaxRows, expandedRows: expandedRows, isSearch: isSearch, isCompact: isCompact } = (0, $gktr3.useEditorThemeContext)();
    const { editorViewHasFocus: editorViewHasFocus, EditorControlsContent: EditorControlsContent, EditorFooterContent: EditorFooterContent, editorViewIsInvalid: editorViewIsInvalid, lineNumbersVisible: lineNumbersVisible, mainId: mainId, onEditorMainRef: onEditorMainRef, onEditorViewContainerRef: onEditorViewContainerRef, onEditorViewContainerScroll: onEditorViewContainerScroll, onEditorViewRef: onEditorViewRef, onEditorViewBlur: onEditorViewBlur, onEditorViewFocus: onEditorViewFocus, onEditorViewTransitionEnd: onEditorViewTransitionEnd } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $graSN.EditorMain), {
        id: mainId,
        ref: onEditorMainRef,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $graSN.EditorViewContainer), {
                editorViewHasFocus: editorViewHasFocus,
                editorViewIsInvalid: editorViewIsInvalid,
                ref: onEditorViewContainerRef,
                onScroll: onEditorViewContainerScroll,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $graSN.LineNumberToolbar), {
                        lineNumbersVisible: lineNumbersVisible
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $graSN.EditorView), {
                        defaultMaxRows: defaultMaxRows,
                        expandedRows: expandedRows,
                        isCompact: isCompact,
                        lineNumbersVisible: lineNumbersVisible,
                        ref: onEditorViewRef,
                        onBlur: onEditorViewBlur,
                        onFocus: onEditorViewFocus,
                        onTransitionEnd: onEditorViewTransitionEnd
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $graSN.EditorControls), {
                        isSearch: isSearch,
                        isCompact: isCompact,
                        isVisualRefresh: (0, $fHpHg.fg)('platform-component-visual-refresh'),
                        children: EditorControlsContent
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $graSN.EditorFooter), {
                children: EditorFooterContent
            })
        ]
    });
};
/**
 * A read only version of the JQL Editor which mimics the layout of the complete component, suitable as an intermediary
 * state when rendering the editor asynchronously.
 * In order to minimise bundle size impact on consumers, it is critical that this component (and any child component)
 * only imports the bare minimum dependencies required to replicate the editor layout.
 */ const $21e8f003446aa8f2$var$JQLEditorReadOnlyWithoutTheme = ({ query: query })=>{
    const { defaultMaxRows: defaultMaxRows, expandedRows: expandedRows, isSearch: isSearch, isCompact: isCompact } = (0, $gktr3.useEditorThemeContext)();
    const blocks = (0, $jzydL.splitTextByNewLine)(query);
    const lineNumbersVisible = blocks.length > 1;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $graSN.EditorMain), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $graSN.ReadOnlyEditorViewContainer), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $graSN.LineNumberToolbar), {
                        lineNumbersVisible: lineNumbersVisible
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $graSN.ReadOnlyEditorView), {
                        "data-testid": "jql-editor-read-only",
                        role: "combobox",
                        "aria-readonly": true,
                        defaultMaxRows: defaultMaxRows,
                        expandedRows: expandedRows,
                        lineNumbersVisible: lineNumbersVisible,
                        isCompact: isCompact,
                        // aria-expanded and aria-controls here are placeholders only. This is to avoid a11y violations.
                        // This component JQLEditorReadOnlyWithoutTheme is only a loading state
                        // Therefore the autocomplete combobox is never shown to the users
                        "aria-expanded": false,
                        "aria-controls": "dummy-jql-editor-auto-complete-id",
                        "aria-label": "JQL query",
                        children: blocks.map((block, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                                as: "p",
                                children: block
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $graSN.EditorControls), {
                        isSearch: isSearch,
                        isCompact: isCompact,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jVZlQ.ReadOnlyControlsContent), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $graSN.EditorFooter), {})
        ]
    });
};
const $21e8f003446aa8f2$export$96157d0351f40cdc = ({ isSearch: isSearch, isCompact: isCompact, ...props })=>{
    const editorTheme = (0, $gktr3.useEditorTheme)({
        isSearch: isSearch,
        isCompact: isCompact
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gktr3.EditorThemeContext).Provider, {
        value: editorTheme,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($21e8f003446aa8f2$var$JQLEditorReadOnlyWithoutTheme, {
            ...props
        })
    });
};
var $21e8f003446aa8f2$export$2e2bcd8739ae039 = $21e8f003446aa8f2$var$JQLEditorLayout;

});
parcelRegister("gktr3", function(module, exports) {

$parcel$export(module.exports, "EditorThemeContext", () => $88960757561deb65$export$fc25b324c910bbf4);
$parcel$export(module.exports, "useEditorTheme", () => $88960757561deb65$export$c119185e316114b3);
$parcel$export(module.exports, "useEditorThemeContext", () => $88960757561deb65$export$cf804716df5ed454);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");
const $88960757561deb65$var$defaultMaxRows = 3;
const $88960757561deb65$var$expandedRows = 15;
const $88960757561deb65$var$defaultEditorTheme = {
    defaultMaxRows: $88960757561deb65$var$defaultMaxRows,
    expanded: false,
    expandedRows: $88960757561deb65$var$expandedRows,
    toggleExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    isSearch: false,
    isCompact: false
};
const $88960757561deb65$export$fc25b324c910bbf4 = (0, $5uXOq.createContext)($88960757561deb65$var$defaultEditorTheme);
const $88960757561deb65$export$c119185e316114b3 = ({ isSearch: isSearch = false, isCompact: isCompact = false })=>{
    const [expanded, setExpanded] = (0, $5uXOq.useState)(false);
    const toggleExpanded = (0, $5uXOq.useCallback)(()=>setExpanded((prevState)=>!prevState), []);
    return (0, $5uXOq.useMemo)(()=>({
            defaultMaxRows: $88960757561deb65$var$defaultMaxRows,
            expanded: expanded,
            expandedRows: $88960757561deb65$var$expandedRows,
            toggleExpanded: toggleExpanded,
            isSearch: isSearch,
            isCompact: isCompact
        }), [
        expanded,
        toggleExpanded,
        isSearch,
        isCompact
    ]);
};
const $88960757561deb65$export$cf804716df5ed454 = ()=>(0, $5uXOq.useContext)($88960757561deb65$export$fc25b324c910bbf4);

});

parcelRegister("jzydL", function(module, exports) {

$parcel$export(module.exports, "splitTextByNewLine", () => $63eb8d2db8cb8f5d$export$ccd327fb940bd525);
/**
 * Splits the provided text by new line characters.
 */ const $63eb8d2db8cb8f5d$export$ccd327fb940bd525 = (text)=>text.split(/(?:\r\n?|\n)/);

});

parcelRegister("jVZlQ", function(module, exports) {

$parcel$export(module.exports, "ReadOnlyControlsContent", () => $bd578599a7084917$export$26cf64f30d6cc7f3);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $gktr3 = parcelRequire("gktr3");

var $lgfW5 = parcelRequire("lgfW5");

var $jOUwO = parcelRequire("jOUwO");

var $8yjrw = parcelRequire("8yjrw");
const $bd578599a7084917$export$26cf64f30d6cc7f3 = ()=>{
    const { isSearch: isSearch } = (0, $gktr3.useEditorThemeContext)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lgfW5.BaseExpandToggle), {
                // The label here is for avoiding a11y violations only
                // This component ReadOnlyControlsContent is only used as a fallback for a loading state
                label: 'Editor',
                editorId: '',
                expanded: false,
                onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                isDisabled: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8yjrw.BaseSyntaxHelp), {
                label: '',
                onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                isDisabled: true
            }),
            isSearch && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jOUwO.BaseSearch), {
                // The label here is for avoiding a11y violations only
                // This component ReadOnlyControlsContent is only used as a fallback for a loading state
                label: 'Search',
                onSearch: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                isDisabled: true
            })
        ]
    });
};

});
parcelRegister("lgfW5", function(module, exports) {

$parcel$export(module.exports, "BaseExpandToggle", () => $d10e5d3d35e697b5$export$651ea466a727285d);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $1Seuh = parcelRequire("1Seuh");

var $34MjD = parcelRequire("34MjD");

var $jmSR7 = parcelRequire("jmSR7");

var $ejYdG = parcelRequire("ejYdG");

var $jJCZj = parcelRequire("jJCZj");

var $fHpHg = parcelRequire("fHpHg");


var $iTdto = parcelRequire("iTdto");
// Atlaskit doesn't provide a circle variation of the expand/collapse icons so we have to implement our own
const $d10e5d3d35e697b5$var$ExpandCircleIcon = ({ isDisabled: isDisabled })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($34MjD))), {
        label: '',
        LEGACY_size: 'small',
        color: isDisabled ? `var(--ds-icon-disabled, ${0, $a7f8c6b391092279$export$8754fc7e6d8b3000})` : `var(--ds-icon, ${0, $a7f8c6b391092279$export$c39c0fe0f26207ae})`,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ejYdG)))
    });
const $d10e5d3d35e697b5$var$CollapseCircleIcon = ({ isDisabled: isDisabled })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jmSR7))), {
        label: '',
        LEGACY_size: 'small',
        color: isDisabled ? `var(--ds-icon-disabled, ${0, $a7f8c6b391092279$export$8754fc7e6d8b3000})` : `var(--ds-icon, ${0, $a7f8c6b391092279$export$c39c0fe0f26207ae})`,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jJCZj)))
    });
const $d10e5d3d35e697b5$export$651ea466a727285d = ({ expanded: expanded, editorId: editorId, isDisabled: isDisabled, label: label, onClick: onClick })=>{
    let Icon;
    if (expanded) Icon = $d10e5d3d35e697b5$var$CollapseCircleIcon;
    else Icon = $d10e5d3d35e697b5$var$ExpandCircleIcon;
    return (0, $fHpHg.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
        appearance: 'subtle',
        spacing: "compact",
        "aria-expanded": expanded,
        "aria-controls": editorId,
        label: label,
        isDisabled: isDisabled,
        onClick: onClick,
        icon: expanded ? (0, (/*@__PURE__*/$parcel$interopDefault($jmSR7))) : (0, (/*@__PURE__*/$parcel$interopDefault($34MjD)))
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iTdto.ExpandToggleContainer), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
            appearance: 'subtle',
            "aria-expanded": expanded,
            "aria-controls": editorId,
            "aria-label": label,
            isDisabled: isDisabled,
            spacing: 'none',
            onClick: onClick,
            iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                isDisabled: isDisabled
            })
        })
    });
};

});
parcelRegister("34MjD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fa3a459488ae98c9a4dea821f09e885>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23d73952c4f37c38$var$_react = $23d73952c4f37c38$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $23d73952c4f37c38$var$_baseNew = $23d73952c4f37c38$var$_interopRequireDefault((parcelRequire("enEmH")));
function $23d73952c4f37c38$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23d73952c4f37c38$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $23d73952c4f37c38$var$_react.default.createElement($23d73952c4f37c38$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 2.28 9.53 7.53 8.47 6.47l5.25-5.25zM1.22 13.72l5.25-5.25 1.06 1.06-5.25 5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9.5 1h4.75a.75.75 0 0 1 .75.75V6.5h-1.5v-4h-4zm-7 12.5v-4H1v4.75c0 .414.336.75.75.75H6.5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$23d73952c4f37c38$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $23d73952c4f37c38$var$_default = module.exports.default = $23d73952c4f37c38$var$GrowDiagonalIcon;

});

parcelRegister("jmSR7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5830a86fa64b71ea84cc4eb2a6e1075>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e19a9f9f106e471c$var$_react = $e19a9f9f106e471c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e19a9f9f106e471c$var$_baseNew = $e19a9f9f106e471c$var$_interopRequireDefault((parcelRequire("enEmH")));
function $e19a9f9f106e471c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e19a9f9f106e471c$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $e19a9f9f106e471c$var$_react.default.createElement($e19a9f9f106e471c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.72 6.22 13.97.97l1.06 1.06-5.25 5.25zM7.28 9.78l-5.25 5.25-1.06-1.06 5.25-5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M10 6V2H8.5v4.75c0 .414.336.75.75.75H14V6zM2 8.5h4.75a.75.75 0 0 1 .75.75V14H6v-4H2z" clip-rule="evenodd"/>`
    }, props));
$e19a9f9f106e471c$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
var $e19a9f9f106e471c$var$_default = module.exports.default = $e19a9f9f106e471c$var$ShrinkDiagonalIcon;

});

parcelRegister("ejYdG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6d18d6d0979a5a8$var$_react = $a6d18d6d0979a5a8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $a6d18d6d0979a5a8$var$_growDiagonal = $a6d18d6d0979a5a8$var$_interopRequireDefault((parcelRequire("34MjD")));
function $a6d18d6d0979a5a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a6d18d6d0979a5a8$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $a6d18d6d0979a5a8$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props, {
        newIcon: $a6d18d6d0979a5a8$var$_growDiagonal.default
    }));
$a6d18d6d0979a5a8$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $a6d18d6d0979a5a8$var$_default = module.exports.default = $a6d18d6d0979a5a8$var$MediaServicesActualSizeIcon;

});

parcelRegister("jJCZj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e5e0767f85f7fe84$var$_react = $e5e0767f85f7fe84$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $e5e0767f85f7fe84$var$_shrinkDiagonal = $e5e0767f85f7fe84$var$_interopRequireDefault((parcelRequire("jmSR7")));
function $e5e0767f85f7fe84$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e5e0767f85f7fe84$var$MediaServicesFitToPageIcon = (props)=>/*#__PURE__*/ $e5e0767f85f7fe84$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.413 8.997H18A1 1 0 0 1 18 11h-3.9l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 13 9.946V6.002a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374zm-8.826 6.006H6A1 1 0 0 1 6 13h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0v-1.587l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374z"/></svg>`
    }, props, {
        newIcon: $e5e0767f85f7fe84$var$_shrinkDiagonal.default
    }));
$e5e0767f85f7fe84$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
var $e5e0767f85f7fe84$var$_default = module.exports.default = $e5e0767f85f7fe84$var$MediaServicesFitToPageIcon;

});

parcelRegister("iTdto", function(module, exports) {

$parcel$export(module.exports, "ExpandToggleContainer", () => $206ef761642c28cd$export$e6d67f4f78864edc);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $206ef761642c28cd$export$e6d67f4f78864edc = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1cnrddf0"
})({
    /* Override background styles for our button to match designs */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> button': {
        borderRadius: '100%',
        /* Fill the remaining vertical space for a single line in our editor and space between buttons */ margin: `${"var(--ds-space-050, 4px)"} 0`,
        '&:hover': {
            background: `var(--ds-background-neutral-subtle-hovered, ${(0, $a7f8c6b391092279$export$1ce2d1575d444ceb)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&:active, &[data-firefox-is-active='true']": {
            background: `var(--ds-background-neutral-subtle-pressed, ${(0, $a7f8c6b391092279$export$8754fc7e6d8b3000)})`
        }
    }
});

});


parcelRegister("jOUwO", function(module, exports) {

$parcel$export(module.exports, "BaseSearch", () => $eee7e3ef41d46cd1$export$c3a2772f8bfd85f4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i95f5 = parcelRequire("i95f5");

var $1Seuh = parcelRequire("1Seuh");

var $7kQOw = parcelRequire("7kQOw");

var $fHpHg = parcelRequire("fHpHg");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");
const $eee7e3ef41d46cd1$var$style = {
    // Fixes an issue where loading button makes the editor flicker with a scrollbar
    overflow: 'hidden'
};
// Fixes icon margin issus after new icon migration
const $eee7e3ef41d46cd1$var$iconStyle = (0, $2s57o.xcss)({
    margin: 'space.050',
    display: 'flex'
});
// Fixes an issue where loading button makes the editor flicker with a scrollbar
const $eee7e3ef41d46cd1$var$buttonContainerStyle = (0, $2s57o.xcss)({
    overflow: 'hidden'
});
const $eee7e3ef41d46cd1$export$c3a2772f8bfd85f4 = ({ isDisabled: isDisabled, isSearching: isSearching, label: label, onSearch: onSearch })=>{
    // Prevent click events being repeatedly fired if the Enter key is held down.
    const preventRepeatClick = (0, $5uXOq.useCallback)((e)=>{
        if (e.key === 'Enter' && e.repeat) e.preventDefault();
    }, []);
    return (0, $fHpHg.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
            xcss: $eee7e3ef41d46cd1$var$buttonContainerStyle,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                label: label,
                isDisabled: isDisabled,
                testId: "jql-editor-search",
                appearance: "default",
                spacing: "compact",
                onClick: onSearch,
                onKeyDown: preventRepeatClick,
                isLoading: isSearching,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($7kQOw))),
                ...(0, $fHpHg.fg)('add_nin_press_interactions') && {
                    interactionName: 'jql-editor-base-search-button'
                }
            })
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i95f5.default), {
            "aria-label": label,
            isDisabled: isDisabled,
            testId: "jql-editor-search",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $eee7e3ef41d46cd1$var$style,
            appearance: 'primary',
            spacing: 'none',
            onClick: onSearch,
            onKeyDown: preventRepeatClick,
            isLoading: isSearching,
            iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                xcss: $eee7e3ef41d46cd1$var$iconStyle,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7kQOw))), {
                    color: "currentColor",
                    label: '',
                    LEGACY_size: 'medium',
                    LEGACY_margin: "-4px"
                })
            }),
            ...(0, $fHpHg.fg)('add_nin_press_interactions') && {
                interactionName: 'jql-editor-base-search-button'
            }
        })
    });
};

});

parcelRegister("8yjrw", function(module, exports) {

$parcel$export(module.exports, "BaseSyntaxHelp", () => $9e12a758577be9fd$export$7267128805e130a);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $620fp = parcelRequire("620fp");

var $4vF4i = parcelRequire("4vF4i");

var $9XF6F = parcelRequire("9XF6F");

var $fHpHg = parcelRequire("fHpHg");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");


var $hZpMn = parcelRequire("hZpMn");
// Fixes icon margin issus after new icon migration
const $9e12a758577be9fd$var$iconStyle = (0, $2s57o.xcss)({
    margin: 'space.025',
    display: 'inline-flex'
});
const $9e12a758577be9fd$export$7267128805e130a = ({ describedby: describedby, isDisabled: isDisabled, label: label, onClick: onClick })=>{
    return (0, $fHpHg.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $620fp.default), {
        "aria-describedby": describedby,
        label: label,
        isDisabled: isDisabled,
        appearance: "subtle",
        spacing: "compact",
        onClick: onClick,
        target: "blank",
        href: "https://confluence.atlassian.com/display/SERVICEDESKCLOUD/Advanced+searching",
        icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4vF4i))), {
                ...iconProps,
                color: "var(--ds-icon-subtle, #626F86)"
            })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hZpMn.SyntaxHelpContainer), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
            "aria-describedby": describedby,
            "aria-label": label,
            isDisabled: isDisabled,
            appearance: 'subtle',
            spacing: 'none',
            target: 'blank',
            href: "https://confluence.atlassian.com/display/SERVICEDESKCLOUD/Advanced+searching",
            iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                xcss: $9e12a758577be9fd$var$iconStyle,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4vF4i))), {
                    label: '',
                    color: isDisabled ? `var(--ds-icon-disabled, ${0, $a7f8c6b391092279$export$29a4f05edc054374})` : `var(--ds-icon-inverse, ${0, $a7f8c6b391092279$export$29a4f05edc054374})`,
                    LEGACY_size: 'small',
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9XF6F))),
                    LEGACY_margin: "-2px"
                })
            }),
            onClick: onClick
        })
    });
};

});
parcelRegister("9XF6F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $740982ac05e14d0f$var$_react = $740982ac05e14d0f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $740982ac05e14d0f$var$_questionCircle = $740982ac05e14d0f$var$_interopRequireDefault((parcelRequire("4vF4i")));
function $740982ac05e14d0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $740982ac05e14d0f$var$QuestionIcon = (props)=>/*#__PURE__*/ $740982ac05e14d0f$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18a1 1 0 0 1 0-2 1 1 0 0 1 0 2m-2-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path d="M15.89 8.048a3.97 3.97 0 0 0-2.951-2.94A4.005 4.005 0 0 0 8 9.087l.009.008 1.878.022.112-.116A2 2 0 0 1 12 7c1.103 0 2 .897 2 2s-.897 2-2 2h.008a1 1 0 0 0-.998.987v2.014a1 1 0 1 0 2 0v-.782c0-.217.145-.399.349-.472a3.99 3.99 0 0 0 2.53-4.699"/></g></svg>`
    }, props, {
        newIcon: $740982ac05e14d0f$var$_questionCircle.default
    }));
$740982ac05e14d0f$var$QuestionIcon.displayName = 'QuestionIcon';
var $740982ac05e14d0f$var$_default = module.exports.default = $740982ac05e14d0f$var$QuestionIcon;

});

parcelRegister("hZpMn", function(module, exports) {

$parcel$export(module.exports, "SyntaxHelpContainer", () => $b02a85c4eab29af1$export$4e1b8f789d662a1c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $b02a85c4eab29af1$export$4e1b8f789d662a1c = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1rcevfp0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> a': {
        background: `var(--ds-background-neutral-bold, ${(0, $a7f8c6b391092279$export$5f71e19f3a7ad9de)})`,
        borderRadius: '100%',
        margin: "var(--ds-space-050, 4px)",
        '&:hover': {
            background: `var(--ds-background-neutral-bold-hovered, ${(0, $a7f8c6b391092279$export$c39c0fe0f26207ae)})`
        },
        '&:focus': {
            background: `var(--ds-background-neutral-bold, ${(0, $a7f8c6b391092279$export$5f71e19f3a7ad9de)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&:active, &[data-firefox-is-active='true']": {
            background: `var(--ds-background-neutral-bold-pressed, ${(0, $a7f8c6b391092279$export$7090862dc3038a9f)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[disabled]': {
            background: `var(--ds-background-disabled, ${(0, $a7f8c6b391092279$export$8754fc7e6d8b3000)})`
        }
    }
});

});



parcelRegister("graSN", function(module, exports) {

$parcel$export(module.exports, "EditorMain", () => $876d57518e6cf6d6$export$4a1fe064357e4803);
$parcel$export(module.exports, "EditorFooter", () => $876d57518e6cf6d6$export$6b199f86fb39c56e);
$parcel$export(module.exports, "EditorViewContainer", () => $876d57518e6cf6d6$export$e1a59ec983b6e626);
$parcel$export(module.exports, "ReadOnlyEditorViewContainer", () => $876d57518e6cf6d6$export$92dc95fac89d1410);
$parcel$export(module.exports, "LineNumberToolbar", () => $876d57518e6cf6d6$export$c7f458a6447d7077);
$parcel$export(module.exports, "EditorView", () => $876d57518e6cf6d6$export$eece2fccabbb77c5);
$parcel$export(module.exports, "ReadOnlyEditorView", () => $876d57518e6cf6d6$export$1eeaf339fa9196a5);
$parcel$export(module.exports, "EditorControls", () => $876d57518e6cf6d6$export$3ebfd5942f1290ac);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $b4a3S = parcelRequire("b4a3S");

var $gR0pi = parcelRequire("gR0pi");

var $bWGt6 = parcelRequire("bWGt6");
function $876d57518e6cf6d6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $876d57518e6cf6d6$var$fadeIn = (0, $f8Sb3.keyframes)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
const $876d57518e6cf6d6$var$fadeOut = (0, $f8Sb3.keyframes)({
    from: {
        visibility: 'visible',
        opacity: 1
    },
    to: {
        opacity: 0
    }
});
const $876d57518e6cf6d6$export$4a1fe064357e4803 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ezls2j67"
})("font-family:var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-size:14px;flex-grow:1;/* These styles and animations are derived from @atlaskit/tooltip */.", (0, $gR0pi.TOOLTIP_CLASSNAME), "{background-color:", `var(--ds-background-neutral-bold, ${(0, $a7f8c6b391092279$export$7d61b15e0da132af)})`, ";color:", `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`, ";border-radius:var(--ds-border-radius-100, 3px);box-sizing:border-box;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);line-height:1.3;max-width:240px;padding:var(--ds-space-025, 2px) var(--ds-space-075, 6px);word-wrap:break-word;overflow-wrap:break-word;z-index:", (0, $b4a3S.layers).tooltip(), ";pointer-events:none;position:absolute;visibility:hidden;transform:translate(-50%, calc(-100% - var(--ds-space-200, 16px)));&.", (0, $gR0pi.TOOLTIP_ENTER_CLASSNAME), "{animation:", $876d57518e6cf6d6$var$fadeIn, " 350ms cubic-bezier(0.15, 1, 0.3, 1);visibility:visible;}&.", (0, $gR0pi.TOOLTIP_EXIT_CLASSNAME), "{animation:", $876d57518e6cf6d6$var$fadeOut, " 350ms cubic-bezier(0.15, 1, 0.3, 1);}}");
const $876d57518e6cf6d6$export$6b199f86fb39c56e = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ezls2j66"
})({
    name: "y524xc",
    styles: "display:flex;justify-content:space-between;min-height:20px"
});
// Height (in px) for a single row in the editor
const $876d57518e6cf6d6$var$rowHeight = 22;
// Vertical padding for the editor input
const $876d57518e6cf6d6$var$getEditorInputVerticalPadding = (isCompact)=>isCompact ? 3 : 7;
const $876d57518e6cf6d6$var$editorInputHorizontalPadding = 6;
const $876d57518e6cf6d6$export$e1a59ec983b6e626 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ezls2j65"
})({
    backgroundColor: `var(--ds-background-input, ${(0, $a7f8c6b391092279$export$e655ef011c4aa1a2)})`,
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    borderColor: `var(--ds-border-input, ${(0, $a7f8c6b391092279$export$d6447c357493214f)})`,
    borderRadius: "var(--ds-border-radius-100, 3px)",
    padding: "var(--ds-border-width, 1px)",
    boxSizing: 'border-box',
    color: `var(--ds-text, ${(0, $a7f8c6b391092279$export$fbda843f0a27fe96)})`,
    display: 'flex',
    overflow: 'auto',
    transition: 'background-color 0.2s ease-in-out, border-color 0.2s ease-in-out'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.editorViewIsInvalid && /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $f8Sb3.css)({
        borderColor: `var(--ds-border-danger, ${(0, $a7f8c6b391092279$export$2010d0fb4295b346)})`,
        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${(0, $a7f8c6b391092279$export$2010d0fb4295b346)})`}`
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.editorViewHasFocus ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $f8Sb3.css)({
        backgroundColor: `var(--ds-surface, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
        borderColor: `var(--ds-border-focused, ${(0, $a7f8c6b391092279$export$215b7063051591f1)})`,
        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${(0, $a7f8c6b391092279$export$215b7063051591f1)})`}`
    }) : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $f8Sb3.css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-input-hovered, ${(0, $a7f8c6b391092279$export$3e51e8f1440314ba)})`
        }
    }));
const $876d57518e6cf6d6$export$92dc95fac89d1410 = /*#__PURE__*/ (0, $bWGt6.default)($876d57518e6cf6d6$export$e1a59ec983b6e626, {
    target: "ezls2j64"
})({
    backgroundColor: `var(--ds-background-disabled, ${(0, $a7f8c6b391092279$export$3e51e8f1440314ba)})`,
    color: `var(--ds-text-disabled, ${(0, $a7f8c6b391092279$export$d6447c357493214f)})`,
    pointerEvents: 'none'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $876d57518e6cf6d6$var$_ref2 = {
    name: "eivff4",
    styles: "display:none"
};
const $876d57518e6cf6d6$export$c7f458a6447d7077 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ezls2j63"
})({
    backgroundColor: `var(--ds-background-neutral, ${(0, $a7f8c6b391092279$export$3e51e8f1440314ba)})`,
    flexShrink: 0,
    width: '30px',
    position: 'sticky',
    top: 0
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>!props.lineNumbersVisible && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    $876d57518e6cf6d6$var$_ref2);
/**
 * The main div which the Prosemirror editor will be rendered into.
 */ // eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $876d57518e6cf6d6$var$_ref = {
    name: "eivff4",
    styles: "display:none"
};
const $876d57518e6cf6d6$export$eece2fccabbb77c5 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ezls2j62"
})("counter-reset:lineNumber;flex-grow:1;transition:height 250ms cubic-bezier(0.15, 1, 0.3, 1),max-height 250ms cubic-bezier(0.15, 1, 0.3, 1);max-height:", (props)=>$876d57518e6cf6d6$var$rowHeight * props.defaultMaxRows + $876d57518e6cf6d6$var$getEditorInputVerticalPadding(props.isCompact) * 2, "px;line-height:", $876d57518e6cf6d6$var$rowHeight / 14, ";font-family:var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace);word-break:break-word;overflow-wrap:anywhere;white-space:pre-wrap;&[data-expanded]{height:", (props)=>$876d57518e6cf6d6$var$rowHeight * props.expandedRows + $876d57518e6cf6d6$var$getEditorInputVerticalPadding(props.isCompact) * 2, "px;max-height:", (props)=>$876d57518e6cf6d6$var$rowHeight * props.expandedRows + $876d57518e6cf6d6$var$getEditorInputVerticalPadding(props.isCompact) * 2, "px;}.ProseMirror{color:", `var(--ds-text, ${(0, $a7f8c6b391092279$export$ad0bacf983b7ddaa)})`, ";padding:", (props)=>$876d57518e6cf6d6$var$getEditorInputVerticalPadding(props.isCompact), "px ", $876d57518e6cf6d6$var$editorInputHorizontalPadding, "px;&:focus{outline:none;}.mark-token-keyword{color:", `var(--ds-text-accent-purple, ${(0, $a7f8c6b391092279$export$c71e4279dd54a18d)})`, ";}.mark-token-field{color:", `var(--ds-text-accent-blue, ${(0, $a7f8c6b391092279$export$e62e8919cca44969)})`, ";}.mark-token-operator{color:", `var(--ds-text-accent-green, ${(0, $a7f8c6b391092279$export$6fa04827ac68a4fb)})`, ";}.mark-token-error{color:", `var(--ds-text-danger, ${(0, $a7f8c6b391092279$export$2010d0fb4295b346)})`, ";text-decoration:wavy underline;text-decoration-thickness:1px;text-decoration-skip-ink:none;}}p{margin:0;counter-increment:lineNumber;position:relative;&::before{content:counter(lineNumber);color:", `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$d6447c357493214f)})`, ";font-size:10px;line-height:", $876d57518e6cf6d6$var$rowHeight / 10, ";padding:0 var(--ds-space-100, 8px) 0 var(--ds-space-025, 2px);position:absolute;box-sizing:border-box;transform:translateX(calc(-100% - var(--ds-space-100, 8px)));max-width:30px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;", (props)=>!props.lineNumbersVisible && // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    $876d57518e6cf6d6$var$_ref, ";}}");
const $876d57518e6cf6d6$export$1eeaf339fa9196a5 = /*#__PURE__*/ (0, $bWGt6.default)($876d57518e6cf6d6$export$eece2fccabbb77c5, {
    target: "ezls2j61"
})("padding:", (props)=>$876d57518e6cf6d6$var$getEditorInputVerticalPadding(props.isCompact), "px ", $876d57518e6cf6d6$var$editorInputHorizontalPadding, "px;max-height:", (props)=>$876d57518e6cf6d6$var$rowHeight * props.defaultMaxRows, "px;>p{min-height:", $876d57518e6cf6d6$var$rowHeight, "px;}");
const $876d57518e6cf6d6$export$3ebfd5942f1290ac = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ezls2j60"
})((props)=>({
        alignItems: 'center',
        display: 'flex',
        flexShrink: 0,
        marginLeft: 'auto',
        marginRight: `${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        props.isSearch ? $876d57518e6cf6d6$var$getEditorInputVerticalPadding(props.isCompact) - 1 // the search button needs the same vertical & horizontal spacing
         : $876d57518e6cf6d6$var$editorInputHorizontalPadding - 3}px`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 'normal',
        position: 'sticky',
        top: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$876d57518e6cf6d6$var$rowHeight + 2 * $876d57518e6cf6d6$var$getEditorInputVerticalPadding(props.isCompact)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gap: props.isVisualRefresh ? "var(--ds-space-025, 2px)" : 'unset'
    }));

});
parcelRegister("gR0pi", function(module, exports) {

$parcel$export(module.exports, "JQLValidationTooltipPluginKey", () => $d9762c1bb7a2ca5a$export$9c08c6e09c037890);
$parcel$export(module.exports, "TOOLTIP_CLASSNAME", () => $d9762c1bb7a2ca5a$export$a6e3ebd2348b0a1);
$parcel$export(module.exports, "TOOLTIP_ENTER_CLASSNAME", () => $d9762c1bb7a2ca5a$export$c58b4cecb88a4d51);
$parcel$export(module.exports, "TOOLTIP_EXIT_CLASSNAME", () => $d9762c1bb7a2ca5a$export$22dac80660f4fba2);

var $gZGBX = parcelRequire("gZGBX");
const $d9762c1bb7a2ca5a$export$9c08c6e09c037890 = new (0, $gZGBX.PluginKey)('jql-validation-tooltip-plugin');
const $d9762c1bb7a2ca5a$export$a6e3ebd2348b0a1 = 'jql-validation-tooltip';
const $d9762c1bb7a2ca5a$export$c58b4cecb88a4d51 = 'jql-validation-tooltip-enter';
const $d9762c1bb7a2ca5a$export$22dac80660f4fba2 = 'jql-validation-tooltip-exit';

});
parcelRegister("gZGBX", function(module, exports) {

$parcel$export(module.exports, "Selection", () => $c5f36586ce432e9f$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $c5f36586ce432e9f$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $c5f36586ce432e9f$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $c5f36586ce432e9f$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $c5f36586ce432e9f$export$e2940151ac854c0b);
$parcel$export(module.exports, "Transaction", () => $c5f36586ce432e9f$export$febc5573c75cefb0);
$parcel$export(module.exports, "EditorState", () => $c5f36586ce432e9f$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $c5f36586ce432e9f$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $c5f36586ce432e9f$export$1692d8b0e89cecc3);

var $kCV8T = parcelRequire("kCV8T");

var $eS2Dn = parcelRequire("eS2Dn");
const $c5f36586ce432e9f$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $c5f36586ce432e9f$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $c5f36586ce432e9f$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $kCV8T.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $kCV8T.Slice).empty : content);
            if (i == 0) $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $c5f36586ce432e9f$export$c2b25f346d19bcbb($pos) : $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $c5f36586ce432e9f$var$findSelectionIn(doc, doc, 0, 0, 1) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $c5f36586ce432e9f$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $c5f36586ce432e9f$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $c5f36586ce432e9f$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $c5f36586ce432e9f$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $c5f36586ce432e9f$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$c5f36586ce432e9f$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $c5f36586ce432e9f$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $c5f36586ce432e9f$var$warnedAboutTextSelection = false;
function $c5f36586ce432e9f$var$checkTextSelection($pos) {
    if (!$c5f36586ce432e9f$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $c5f36586ce432e9f$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $c5f36586ce432e9f$export$c2b25f346d19bcbb extends $c5f36586ce432e9f$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $c5f36586ce432e9f$var$checkTextSelection($anchor);
        $c5f36586ce432e9f$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $c5f36586ce432e9f$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $c5f36586ce432e9f$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $kCV8T.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $kCV8T.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $c5f36586ce432e9f$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $c5f36586ce432e9f$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $c5f36586ce432e9f$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($head, bias, true) || $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $c5f36586ce432e9f$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($c5f36586ce432e9f$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $c5f36586ce432e9f$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$c5f36586ce432e9f$export$52baac22726c72bf.jsonID("text", $c5f36586ce432e9f$export$c2b25f346d19bcbb);
class $c5f36586ce432e9f$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $c5f36586ce432e9f$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $c5f36586ce432e9f$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $c5f36586ce432e9f$export$e2940151ac854c0b extends $c5f36586ce432e9f$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $c5f36586ce432e9f$export$52baac22726c72bf.near($pos);
        return new $c5f36586ce432e9f$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $c5f36586ce432e9f$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $c5f36586ce432e9f$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $c5f36586ce432e9f$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $c5f36586ce432e9f$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$c5f36586ce432e9f$export$e2940151ac854c0b.prototype.visible = false;
$c5f36586ce432e9f$export$52baac22726c72bf.jsonID("node", $c5f36586ce432e9f$export$e2940151ac854c0b);
class $c5f36586ce432e9f$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $c5f36586ce432e9f$var$TextBookmark(pos, pos) : new $c5f36586ce432e9f$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $c5f36586ce432e9f$export$e2940151ac854c0b.isSelectable(node)) return new $c5f36586ce432e9f$export$e2940151ac854c0b($pos);
        return $c5f36586ce432e9f$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $c5f36586ce432e9f$export$c15d9ba76bdbcd95 extends $c5f36586ce432e9f$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $kCV8T.Slice).empty) {
        if (content == (0, $kCV8T.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $c5f36586ce432e9f$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $c5f36586ce432e9f$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $c5f36586ce432e9f$var$AllBookmark;
    }
}
$c5f36586ce432e9f$export$52baac22726c72bf.jsonID("all", $c5f36586ce432e9f$export$c15d9ba76bdbcd95);
const $c5f36586ce432e9f$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $c5f36586ce432e9f$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $c5f36586ce432e9f$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $c5f36586ce432e9f$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $c5f36586ce432e9f$export$e2940151ac854c0b.isSelectable(child)) return $c5f36586ce432e9f$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $eS2Dn.ReplaceStep) || step instanceof (0, $eS2Dn.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($c5f36586ce432e9f$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $c5f36586ce432e9f$var$UPDATED_SEL = 1, $c5f36586ce432e9f$var$UPDATED_MARKS = 2, $c5f36586ce432e9f$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $c5f36586ce432e9f$export$febc5573c75cefb0 extends (0, $eS2Dn.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $c5f36586ce432e9f$var$UPDATED_SEL) & ~$c5f36586ce432e9f$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $c5f36586ce432e9f$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $c5f36586ce432e9f$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $kCV8T.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $c5f36586ce432e9f$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$c5f36586ce432e9f$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $kCV8T.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($c5f36586ce432e9f$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $c5f36586ce432e9f$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $c5f36586ce432e9f$var$UPDATED_SCROLL) > 0;
    }
}
function $c5f36586ce432e9f$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $c5f36586ce432e9f$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $c5f36586ce432e9f$var$bind(desc.init, self);
        this.apply = $c5f36586ce432e9f$var$bind(desc.apply, self);
    }
}
const $c5f36586ce432e9f$var$baseFields = [
    new $c5f36586ce432e9f$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $c5f36586ce432e9f$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $c5f36586ce432e9f$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $c5f36586ce432e9f$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $c5f36586ce432e9f$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $c5f36586ce432e9f$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $c5f36586ce432e9f$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $c5f36586ce432e9f$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $c5f36586ce432e9f$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $c5f36586ce432e9f$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $c5f36586ce432e9f$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $c5f36586ce432e9f$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $c5f36586ce432e9f$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $c5f36586ce432e9f$var$Configuration(config.schema, config.plugins);
        let instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $kCV8T.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $c5f36586ce432e9f$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $c5f36586ce432e9f$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $c5f36586ce432e9f$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $c5f36586ce432e9f$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $c5f36586ce432e9f$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $c5f36586ce432e9f$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $c5f36586ce432e9f$var$keys = Object.create(null);
function $c5f36586ce432e9f$var$createKey(name) {
    if (name in $c5f36586ce432e9f$var$keys) return name + "$" + ++$c5f36586ce432e9f$var$keys[name];
    $c5f36586ce432e9f$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $c5f36586ce432e9f$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $c5f36586ce432e9f$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("kCV8T", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $f043ae92c0a873f0$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $f043ae92c0a873f0$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $f043ae92c0a873f0$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $f043ae92c0a873f0$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $f043ae92c0a873f0$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $f043ae92c0a873f0$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $f043ae92c0a873f0$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $f043ae92c0a873f0$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $f043ae92c0a873f0$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $f043ae92c0a873f0$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $f043ae92c0a873f0$export$3476b78f8f5a8b72);

var $dHeNB = parcelRequire("dHeNB");
function $f043ae92c0a873f0$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $f043ae92c0a873f0$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $f043ae92c0a873f0$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $f043ae92c0a873f0$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $f043ae92c0a873f0$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $f043ae92c0a873f0$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $f043ae92c0a873f0$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $f043ae92c0a873f0$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $f043ae92c0a873f0$var$retIndex(0, pos);
        if (pos == this.size) return $f043ae92c0a873f0$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $f043ae92c0a873f0$var$retIndex(i + 1, end);
                return $f043ae92c0a873f0$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (nodes instanceof $f043ae92c0a873f0$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $f043ae92c0a873f0$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $f043ae92c0a873f0$export$ffb0004e005737fa.empty = new $f043ae92c0a873f0$export$ffb0004e005737fa([], 0);
const $f043ae92c0a873f0$var$found = {
    index: 0,
    offset: 0
};
function $f043ae92c0a873f0$var$retIndex(index, offset) {
    $f043ae92c0a873f0$var$found.index = index;
    $f043ae92c0a873f0$var$found.offset = offset;
    return $f043ae92c0a873f0$var$found;
}
function $f043ae92c0a873f0$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$f043ae92c0a873f0$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$f043ae92c0a873f0$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $f043ae92c0a873f0$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $f043ae92c0a873f0$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        if (marks instanceof $f043ae92c0a873f0$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $f043ae92c0a873f0$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $f043ae92c0a873f0$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $f043ae92c0a873f0$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $f043ae92c0a873f0$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty = new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.empty, 0, 0);
function $f043ae92c0a873f0$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($f043ae92c0a873f0$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $f043ae92c0a873f0$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $f043ae92c0a873f0$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $f043ae92c0a873f0$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inconsistent open depths");
    return $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, 0);
}
function $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $f043ae92c0a873f0$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $from);
        return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $f043ae92c0a873f0$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $f043ae92c0a873f0$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $f043ae92c0a873f0$var$checkJoin(node, $after.node(depth));
    return node;
}
function $f043ae92c0a873f0$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $f043ae92c0a873f0$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $f043ae92c0a873f0$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$f043ae92c0a873f0$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $f043ae92c0a873f0$var$addNode($end.nodeBefore, target);
}
function $f043ae92c0a873f0$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $f043ae92c0a873f0$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $f043ae92c0a873f0$var$joinable($end, $to, depth + 1);
    let content = [];
    $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $f043ae92c0a873f0$var$checkJoin(openStart, openEnd);
        $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceTwoWay($from, $start, depth + 1)), content);
        $f043ae92c0a873f0$var$addRange($start, $end, depth, content);
        if (openEnd) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openEnd, $f043ae92c0a873f0$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $f043ae92c0a873f0$var$addRange($to, null, depth, content);
    return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
}
function $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $f043ae92c0a873f0$var$joinable($from, $to, depth + 1);
        $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(type, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $f043ae92c0a873f0$var$addRange($to, null, depth, content);
    return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
}
function $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $f043ae92c0a873f0$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $f043ae92c0a873f0$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $f043ae92c0a873f0$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $f043ae92c0a873f0$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $f043ae92c0a873f0$var$resolveCache.set(doc, cache = new $f043ae92c0a873f0$var$ResolveCache);
        let result = cache.elts[cache.i] = $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $f043ae92c0a873f0$var$resolveCacheSize;
        return result;
    }
}
class $f043ae92c0a873f0$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $f043ae92c0a873f0$var$resolveCacheSize = 12, $f043ae92c0a873f0$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $f043ae92c0a873f0$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $f043ae92c0a873f0$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $f043ae92c0a873f0$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $f043ae92c0a873f0$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $f043ae92c0a873f0$var$emptyAttrs) && $f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $f043ae92c0a873f0$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $f043ae92c0a873f0$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $f043ae92c0a873f0$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $f043ae92c0a873f0$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$f043ae92c0a873f0$export$85c928794f8d04d4.prototype.text = undefined;
class $f043ae92c0a873f0$var$TextNode extends $f043ae92c0a873f0$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $f043ae92c0a873f0$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $f043ae92c0a873f0$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $f043ae92c0a873f0$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $f043ae92c0a873f0$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
        let expr = $f043ae92c0a873f0$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $f043ae92c0a873f0$var$dfa($f043ae92c0a873f0$var$nfa(expr));
        $f043ae92c0a873f0$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $f043ae92c0a873f0$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $f043ae92c0a873f0$export$364ed450558d7ec4.empty = new $f043ae92c0a873f0$export$364ed450558d7ec4(true);
class $f043ae92c0a873f0$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $f043ae92c0a873f0$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($f043ae92c0a873f0$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $f043ae92c0a873f0$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($f043ae92c0a873f0$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $f043ae92c0a873f0$var$parseExprSubscript(stream) {
    let expr = $f043ae92c0a873f0$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $f043ae92c0a873f0$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $f043ae92c0a873f0$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $f043ae92c0a873f0$var$parseExprRange(stream, expr) {
    let min = $f043ae92c0a873f0$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $f043ae92c0a873f0$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $f043ae92c0a873f0$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $f043ae92c0a873f0$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $f043ae92c0a873f0$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $f043ae92c0a873f0$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $f043ae92c0a873f0$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $f043ae92c0a873f0$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $f043ae92c0a873f0$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($f043ae92c0a873f0$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $f043ae92c0a873f0$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($f043ae92c0a873f0$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $f043ae92c0a873f0$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $f043ae92c0a873f0$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($f043ae92c0a873f0$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $f043ae92c0a873f0$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $f043ae92c0a873f0$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $f043ae92c0a873f0$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $f043ae92c0a873f0$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $f043ae92c0a873f0$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $f043ae92c0a873f0$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $f043ae92c0a873f0$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $f043ae92c0a873f0$export$ffb0004e005737fa.from(content), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, attrs, content.append(after), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $f043ae92c0a873f0$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $f043ae92c0a873f0$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $f043ae92c0a873f0$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $f043ae92c0a873f0$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $f043ae92c0a873f0$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $dHeNB.default).from(spec.nodes), instanceSpec.marks = (0, $dHeNB.default).from(spec.marks || {}), this.nodes = $f043ae92c0a873f0$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $f043ae92c0a873f0$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $f043ae92c0a873f0$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $f043ae92c0a873f0$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $f043ae92c0a873f0$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $f043ae92c0a873f0$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $f043ae92c0a873f0$var$TextNode(type, type.defaultAttrs, text, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $f043ae92c0a873f0$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $f043ae92c0a873f0$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $f043ae92c0a873f0$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $f043ae92c0a873f0$var$isTagRule(rule) {
    return rule.tag != null;
}
function $f043ae92c0a873f0$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $f043ae92c0a873f0$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($f043ae92c0a873f0$var$isTagRule(rule)) this.tags.push(rule);
            else if ($f043ae92c0a873f0$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $f043ae92c0a873f0$var$ParseContext(this, options, false);
        context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $f043ae92c0a873f0$var$ParseContext(this, options, true);
        context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($f043ae92c0a873f0$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $f043ae92c0a873f0$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $f043ae92c0a873f0$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $f043ae92c0a873f0$export$1059c6e7d2ce5669(schema, $f043ae92c0a873f0$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $f043ae92c0a873f0$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $f043ae92c0a873f0$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $f043ae92c0a873f0$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $f043ae92c0a873f0$var$OPT_PRESERVE_WS = 1, $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL = 2, $f043ae92c0a873f0$var$OPT_OPEN_LEFT = 4;
function $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS | $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : base & ~$f043ae92c0a873f0$var$OPT_OPEN_LEFT;
}
class $f043ae92c0a873f0$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$f043ae92c0a873f0$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $f043ae92c0a873f0$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $f043ae92c0a873f0$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $f043ae92c0a873f0$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $f043ae92c0a873f0$var$NodeContext(topNode.type, topNode.attrs, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $f043ae92c0a873f0$var$NodeContext(null, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $f043ae92c0a873f0$var$NodeContext(parser.schema.topNodeType, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $f043ae92c0a873f0$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $f043ae92c0a873f0$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($f043ae92c0a873f0$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $f043ae92c0a873f0$var$OPT_OPEN_LEFT;
        let applyMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $f043ae92c0a873f0$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $f043ae92c0a873f0$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $f043ae92c0a873f0$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $f043ae92c0a873f0$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $f043ae92c0a873f0$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $f043ae92c0a873f0$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $f043ae92c0a873f0$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $f043ae92c0a873f0$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $f043ae92c0a873f0$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $f043ae92c0a873f0$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $f043ae92c0a873f0$var$gatherToDOM(schema.marks);
    }
}
function $f043ae92c0a873f0$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $f043ae92c0a873f0$var$doc(options) {
    return options.document || window.document;
}
const $f043ae92c0a873f0$var$suspiciousAttributeCache = new WeakMap();
function $f043ae92c0a873f0$var$suspiciousAttributes(attrs) {
    let value = $f043ae92c0a873f0$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $f043ae92c0a873f0$var$suspiciousAttributeCache.set(attrs, value = $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs));
    return value;
}
function $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $f043ae92c0a873f0$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $f043ae92c0a873f0$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("dHeNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f8ac547b0b2e1f8$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $9f8ac547b0b2e1f8$var$OrderedMap(content) {
    this.content = content;
}
$9f8ac547b0b2e1f8$var$OrderedMap.prototype = {
    constructor: $9f8ac547b0b2e1f8$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $9f8ac547b0b2e1f8$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $9f8ac547b0b2e1f8$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $9f8ac547b0b2e1f8$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$9f8ac547b0b2e1f8$var$OrderedMap.from = function(value) {
    if (value instanceof $9f8ac547b0b2e1f8$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
};
var $9f8ac547b0b2e1f8$export$2e2bcd8739ae039 = $9f8ac547b0b2e1f8$var$OrderedMap;

});


parcelRegister("eS2Dn", function(module, exports) {

$parcel$export(module.exports, "StepMap", () => $ad3826e817ebec37$export$c53d01c3ab9721b3);
$parcel$export(module.exports, "Mapping", () => $ad3826e817ebec37$export$f5f785078011b62);
$parcel$export(module.exports, "Step", () => $ad3826e817ebec37$export$fd55ce593607084a);
$parcel$export(module.exports, "StepResult", () => $ad3826e817ebec37$export$8ebf1578a4199c09);
$parcel$export(module.exports, "AddMarkStep", () => $ad3826e817ebec37$export$d24ba56b0e3464a9);
$parcel$export(module.exports, "RemoveMarkStep", () => $ad3826e817ebec37$export$94150db1311f67a9);
$parcel$export(module.exports, "AddNodeMarkStep", () => $ad3826e817ebec37$export$adefd16c402fee4e);
$parcel$export(module.exports, "RemoveNodeMarkStep", () => $ad3826e817ebec37$export$fdf7d1dc10724da2);
$parcel$export(module.exports, "ReplaceStep", () => $ad3826e817ebec37$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $ad3826e817ebec37$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $ad3826e817ebec37$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $ad3826e817ebec37$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $ad3826e817ebec37$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $ad3826e817ebec37$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $ad3826e817ebec37$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "insertPoint", () => $ad3826e817ebec37$export$64cb316d02de1dd1);
$parcel$export(module.exports, "dropPoint", () => $ad3826e817ebec37$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $ad3826e817ebec37$export$ed6ac67359824afd);
$parcel$export(module.exports, "AttrStep", () => $ad3826e817ebec37$export$626399c38172f669);
$parcel$export(module.exports, "DocAttrStep", () => $ad3826e817ebec37$export$f50707b396300ac9);
$parcel$export(module.exports, "Transform", () => $ad3826e817ebec37$export$563a914cafbdc389);

var $kCV8T = parcelRequire("kCV8T");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $ad3826e817ebec37$var$lower16 = 0xffff;
const $ad3826e817ebec37$var$factor16 = Math.pow(2, 16);
function $ad3826e817ebec37$var$makeRecover(index, offset) {
    return index + offset * $ad3826e817ebec37$var$factor16;
}
function $ad3826e817ebec37$var$recoverIndex(value) {
    return value & $ad3826e817ebec37$var$lower16;
}
function $ad3826e817ebec37$var$recoverOffset(value) {
    return (value - (value & $ad3826e817ebec37$var$lower16)) / $ad3826e817ebec37$var$factor16;
}
const $ad3826e817ebec37$var$DEL_BEFORE = 1, $ad3826e817ebec37$var$DEL_AFTER = 2, $ad3826e817ebec37$var$DEL_ACROSS = 4, $ad3826e817ebec37$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $ad3826e817ebec37$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $ad3826e817ebec37$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($ad3826e817ebec37$var$DEL_BEFORE | $ad3826e817ebec37$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($ad3826e817ebec37$var$DEL_AFTER | $ad3826e817ebec37$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $ad3826e817ebec37$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $ad3826e817ebec37$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $ad3826e817ebec37$export$c53d01c3ab9721b3.empty) return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $ad3826e817ebec37$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $ad3826e817ebec37$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $ad3826e817ebec37$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $ad3826e817ebec37$var$DEL_AFTER : pos == end ? $ad3826e817ebec37$var$DEL_BEFORE : $ad3826e817ebec37$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $ad3826e817ebec37$var$DEL_SIDE;
                return new $ad3826e817ebec37$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $ad3826e817ebec37$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $ad3826e817ebec37$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $ad3826e817ebec37$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $ad3826e817ebec37$export$c53d01c3ab9721b3.empty : new $ad3826e817ebec37$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $ad3826e817ebec37$export$c53d01c3ab9721b3.empty = new $ad3826e817ebec37$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $ad3826e817ebec37$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $ad3826e817ebec37$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $ad3826e817ebec37$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $ad3826e817ebec37$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $ad3826e817ebec37$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $ad3826e817ebec37$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $ad3826e817ebec37$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $ad3826e817ebec37$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $ad3826e817ebec37$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $ad3826e817ebec37$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $ad3826e817ebec37$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $ad3826e817ebec37$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $ad3826e817ebec37$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $kCV8T.ReplaceError)) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $ad3826e817ebec37$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($ad3826e817ebec37$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $kCV8T.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $ad3826e817ebec37$export$d24ba56b0e3464a9 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $kCV8T.Slice)($ad3826e817ebec37$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $ad3826e817ebec37$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $ad3826e817ebec37$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $ad3826e817ebec37$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $ad3826e817ebec37$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $ad3826e817ebec37$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("addMark", $ad3826e817ebec37$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $ad3826e817ebec37$export$94150db1311f67a9 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $kCV8T.Slice)($ad3826e817ebec37$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $ad3826e817ebec37$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $ad3826e817ebec37$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $ad3826e817ebec37$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $ad3826e817ebec37$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $ad3826e817ebec37$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("removeMark", $ad3826e817ebec37$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $ad3826e817ebec37$export$adefd16c402fee4e extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $ad3826e817ebec37$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $ad3826e817ebec37$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $ad3826e817ebec37$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("addNodeMark", $ad3826e817ebec37$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $ad3826e817ebec37$export$fdf7d1dc10724da2 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $ad3826e817ebec37$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $ad3826e817ebec37$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("removeNodeMark", $ad3826e817ebec37$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $ad3826e817ebec37$export$5c860b2e74034756 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $ad3826e817ebec37$var$contentBetween(doc, this.from, this.to)) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $ad3826e817ebec37$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $ad3826e817ebec37$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $ad3826e817ebec37$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $ad3826e817ebec37$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $kCV8T.Slice).empty : new (0, $kCV8T.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $ad3826e817ebec37$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $kCV8T.Slice).empty : new (0, $kCV8T.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $ad3826e817ebec37$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $ad3826e817ebec37$export$5c860b2e74034756(json.from, json.to, (0, $kCV8T.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("replace", $ad3826e817ebec37$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $ad3826e817ebec37$export$444ba800d6024a98 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($ad3826e817ebec37$var$contentBetween(doc, this.from, this.gapFrom) || $ad3826e817ebec37$var$contentBetween(doc, this.gapTo, this.to))) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $ad3826e817ebec37$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $ad3826e817ebec37$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $ad3826e817ebec37$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $ad3826e817ebec37$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $kCV8T.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("replaceAround", $ad3826e817ebec37$export$444ba800d6024a98);
function $ad3826e817ebec37$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $ad3826e817ebec37$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $ad3826e817ebec37$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $ad3826e817ebec37$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $ad3826e817ebec37$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $kCV8T.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $ad3826e817ebec37$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $ad3826e817ebec37$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $ad3826e817ebec37$export$5c860b2e74034756(cur, end, (0, $kCV8T.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $ad3826e817ebec37$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $ad3826e817ebec37$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $kCV8T.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $kCV8T.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $ad3826e817ebec37$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $ad3826e817ebec37$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$ad3826e817ebec37$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $ad3826e817ebec37$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $kCV8T.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $kCV8T.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $kCV8T.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $kCV8T.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $kCV8T.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $ad3826e817ebec37$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $ad3826e817ebec37$var$findWrappingOutside(range, nodeType);
    let inner = around && $ad3826e817ebec37$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($ad3826e817ebec37$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($ad3826e817ebec37$var$withAttrs));
}
function $ad3826e817ebec37$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $ad3826e817ebec37$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $ad3826e817ebec37$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $ad3826e817ebec37$var$wrap(tr, range, wrappers) {
    let content = (0, $kCV8T.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $kCV8T.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(start, end, start, end, new (0, $kCV8T.Slice)(content, 0, 0), wrappers.length, true));
}
function $ad3826e817ebec37$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $ad3826e817ebec37$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $ad3826e817ebec37$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $ad3826e817ebec37$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $ad3826e817ebec37$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $ad3826e817ebec37$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $ad3826e817ebec37$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $ad3826e817ebec37$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $ad3826e817ebec37$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $ad3826e817ebec37$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $ad3826e817ebec37$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $kCV8T.Fragment).empty, after = (0, $kCV8T.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $kCV8T.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $kCV8T.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $ad3826e817ebec37$export$5c860b2e74034756(pos, pos, new (0, $kCV8T.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $ad3826e817ebec37$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $ad3826e817ebec37$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $ad3826e817ebec37$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $ad3826e817ebec37$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $ad3826e817ebec37$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $ad3826e817ebec37$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $ad3826e817ebec37$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $ad3826e817ebec37$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $ad3826e817ebec37$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $ad3826e817ebec37$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $ad3826e817ebec37$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $kCV8T.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $ad3826e817ebec37$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $ad3826e817ebec37$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $ad3826e817ebec37$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $ad3826e817ebec37$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $kCV8T.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($ad3826e817ebec37$var$fitsTrivially($from, $to, slice)) return new $ad3826e817ebec37$export$5c860b2e74034756(from, to, slice);
    return new $ad3826e817ebec37$var$Fitter($from, $to, slice).fit();
}
function $ad3826e817ebec37$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $ad3826e817ebec37$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $kCV8T.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $kCV8T.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $kCV8T.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $ad3826e817ebec37$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $ad3826e817ebec37$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $ad3826e817ebec37$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $kCV8T.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $ad3826e817ebec37$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $kCV8T.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $ad3826e817ebec37$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $kCV8T.Slice)($ad3826e817ebec37$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $kCV8T.Slice)($ad3826e817ebec37$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($ad3826e817ebec37$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, frontierDepth, (0, $kCV8T.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $kCV8T.Slice)($ad3826e817ebec37$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $kCV8T.Slice).empty : new (0, $kCV8T.Slice)($ad3826e817ebec37$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$ad3826e817ebec37$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $ad3826e817ebec37$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $ad3826e817ebec37$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, this.depth, (0, $kCV8T.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $kCV8T.Fragment).empty, true);
        if (add.childCount) this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $ad3826e817ebec37$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($ad3826e817ebec37$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $ad3826e817ebec37$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($ad3826e817ebec37$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $ad3826e817ebec37$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $ad3826e817ebec37$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $ad3826e817ebec37$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $kCV8T.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $ad3826e817ebec37$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$ad3826e817ebec37$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $ad3826e817ebec37$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $ad3826e817ebec37$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $ad3826e817ebec37$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($ad3826e817ebec37$var$fitsTrivially($from, $to, slice)) return tr.step(new $ad3826e817ebec37$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $ad3826e817ebec37$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $ad3826e817ebec37$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $kCV8T.Slice)($ad3826e817ebec37$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $ad3826e817ebec37$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($ad3826e817ebec37$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $kCV8T.Fragment).empty, true));
    }
    return fragment;
}
function $ad3826e817ebec37$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $ad3826e817ebec37$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(node), 0, 0));
}
function $ad3826e817ebec37$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $ad3826e817ebec37$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $ad3826e817ebec37$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $ad3826e817ebec37$export$626399c38172f669 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $ad3826e817ebec37$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $ad3826e817ebec37$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $ad3826e817ebec37$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("attr", $ad3826e817ebec37$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $ad3826e817ebec37$export$f50707b396300ac9 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $ad3826e817ebec37$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $ad3826e817ebec37$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $ad3826e817ebec37$export$f50707b396300ac9(json.attr, json.value);
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("docAttr", $ad3826e817ebec37$export$f50707b396300ac9);
/**
@internal
*/ let $ad3826e817ebec37$export$88cc3a1dfce48dd3 = class extends Error {
};
$ad3826e817ebec37$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype.constructor = $ad3826e817ebec37$export$88cc3a1dfce48dd3;
$ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $ad3826e817ebec37$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $ad3826e817ebec37$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $ad3826e817ebec37$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $kCV8T.Slice).empty) {
        let step = $ad3826e817ebec37$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $kCV8T.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $ad3826e817ebec37$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $ad3826e817ebec37$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $ad3826e817ebec37$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $ad3826e817ebec37$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $ad3826e817ebec37$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $ad3826e817ebec37$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $ad3826e817ebec37$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $ad3826e817ebec37$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $ad3826e817ebec37$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $ad3826e817ebec37$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $ad3826e817ebec37$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $kCV8T.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $ad3826e817ebec37$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $ad3826e817ebec37$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $ad3826e817ebec37$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $ad3826e817ebec37$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $ad3826e817ebec37$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});





parcelRegister("6E7Jp", function(module, exports) {

$parcel$export(module.exports, "preloadJQLEditor", () => $05230aa2d8931f4c$export$d5d5e8328005e2ec);
$parcel$export(module.exports, "JQLEditorAsync", () => $05230aa2d8931f4c$export$ecdc147409ce705b);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kc9vJ = parcelRequire("kc9vJ");

var $twBcA = parcelRequire("twBcA");

var $yZXEy = parcelRequire("yZXEy");

var $8Pv5c = parcelRequire("8Pv5c");

const $05230aa2d8931f4c$var$JQLEditor = (0, $kc9vJ.lazyForPaint)(()=>(parcelRequire("7vqDL")).then(({ default: JQLEditorUI })=>JQLEditorUI), {
    ssr: false
});
const $05230aa2d8931f4c$export$d5d5e8328005e2ec = ()=>$05230aa2d8931f4c$var$JQLEditor.preload();
const $05230aa2d8931f4c$export$ecdc147409ce705b = (0, $yZXEy.withIntlProvider)((0, $twBcA.withErrorBoundary)((props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kc9vJ.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Pv5c.JQLEditorReadOnly), {
            query: props.query,
            isSearch: !!props.onSearch,
            isCompact: props.isCompact
        }),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($05230aa2d8931f4c$var$JQLEditor, {
            ...props
        })
    });
}));

});
parcelRegister("twBcA", function(module, exports) {

$parcel$export(module.exports, "withErrorBoundary", () => $1feebc737a27bfa7$export$f0c7a449e0cfaec7);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Pv5c = parcelRequire("8Pv5c");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $1feebc737a27bfa7$var$ErrorBoundary extends (0, $5uXOq.Component) {
    componentDidCatch(error) {
        this.setState({
            error: error
        });
        this.props.onError && this.props.onError(error);
    }
    render() {
        const { children: children, render: renderFallback } = this.props;
        const { error: error } = this.state;
        if (error === null) return children;
        return renderFallback({
            error: error
        });
    }
    constructor(...args){
        super(...args), this.state = {
            error: null
        };
    }
}
const $1feebc737a27bfa7$export$f0c7a449e0cfaec7 = (WrappedComponent)=>{
    return (props)=>{
        const { query: query, onRenderError: onRenderError, onSearch: onSearch, isCompact: isCompact } = props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)($1feebc737a27bfa7$var$ErrorBoundary, {
            onError: onRenderError,
            render: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Pv5c.JQLEditorReadOnly), {
                    query: query,
                    isSearch: !!onSearch,
                    isCompact: isCompact
                }),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                ...props
            })
        });
    };
};

});

parcelRegister("yZXEy", function(module, exports) {

$parcel$export(module.exports, "withIntlProvider", () => $3b384942d43b0717$export$a5d940130f33be3f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
const $3b384942d43b0717$export$a5d940130f33be3f = (WrappedComponent)=>{
    return (props)=>{
        const { locale: locale, ...rest } = props;
        if (locale) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
            locale: locale,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                ...rest
            })
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            ...rest
        });
    };
};

});

parcelRegister("7vqDL", function(module, exports) {

let $577017e2c92a9002$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $577017e2c92a9002$var$load("h2MrD"),
    $577017e2c92a9002$var$load("bYT2S"),
    $577017e2c92a9002$var$load("9GTHD")
]).then(()=>parcelRequire('8l5do'));

});


parcelRegister("imju0", function(module, exports) {

$parcel$export(module.exports, "preloadJqlBuilderBasic", () => $d68345fea548f228$export$680bac3b2d4b8db0);
$parcel$export(module.exports, "JQLBuilderBasicOldAsync", () => $d68345fea548f228$export$50e4159fe4baf68e);
$parcel$export(module.exports, "default", () => $d68345fea548f228$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8vNru = parcelRequire("8vNru");

var $caSpf = parcelRequire("caSpf");

var $b7Svb = parcelRequire("b7Svb");

var $jDMe3 = parcelRequire("jDMe3");




// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d68345fea548f228$var$AsyncJQLEditorUIOld = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("kbf73")).then((module)=>module.JQLEditorUIWithErrorBoundaryOld), {
    ssr: false,
    moduleId: "./src/packages/jql-builder/basic/src/ui/jql-editor/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d68345fea548f228$var$AsyncJQLEditorUI = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("kbf73")), {
    ssr: false,
    moduleId: "./src/packages/jql-builder/basic/src/ui/jql-editor/index.tsx"
});
const $d68345fea548f228$export$680bac3b2d4b8db0 = ()=>$d68345fea548f228$var$AsyncJQLEditorUI.preload();
const $d68345fea548f228$export$50e4159fe4baf68e = (props)=>{
    const onPerformanceMark = (0, $caSpf.usePerformanceContext)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        onPerformanceMark({
            mark: (0, $8vNru.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_BASIC_JS_START
        });
    }, [
        onPerformanceMark
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDMe3.JQLBuilderBasicUIWithAnalyticsOld), {
        ...props,
        JQLEditor: $d68345fea548f228$var$AsyncJQLEditorUIOld
    });
};
const $d68345fea548f228$var$JQLBuilderBasicAsync = (props)=>{
    const onPerformanceMark = (0, $caSpf.usePerformanceContext)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        onPerformanceMark({
            mark: (0, $8vNru.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_BASIC_JS_START
        });
    }, [
        onPerformanceMark
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDMe3.default), {
        ...props,
        JQLEditor: $d68345fea548f228$var$AsyncJQLEditorUI
    });
};
var $d68345fea548f228$export$2e2bcd8739ae039 = $d68345fea548f228$var$JQLBuilderBasicAsync;

});
parcelRegister("jDMe3", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderBasicFallback", () => $681286dd03941848$export$c5a574f152d930c7);
$parcel$export(module.exports, "JQLBuilderBasicUIWithAnalyticsOld", () => $681286dd03941848$export$64a4e59c434c7d2d);
$parcel$export(module.exports, "default", () => $681286dd03941848$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $iXVV6 = parcelRequire("iXVV6");

var $kG16F = parcelRequire("kG16F");

var $lW1IZ = parcelRequire("lW1IZ");

var $lzKFP = parcelRequire("lzKFP");
const $681286dd03941848$var$debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((onSearch, newJql)=>onSearch(newJql), 1000, {
    leading: false,
    trailing: true
});
const $681286dd03941848$var$JQLBuilderBasicUIOld = (props)=>{
    const { query: query, JQLEditor: JQLEditor, onSearch: triggerSearch, onSwitchToJql: onSwitchToJql, excludedFields: excludedFields, onReady: onReady, onLoad: onLoad, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, projectOptions: projectOptions, singleSelectFields: singleSelectFields, hydrationQueryRef: hydrationQueryRef, isHydrating: isHydrating, shouldUseListMarkup: shouldUseListMarkup, hideOperatorDropdown: hideOperatorDropdown, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, showOrderByPicker: showOrderByPicker, contextJql: contextJql, viewContext: viewContext = null, suggestedUsersCount: suggestedUsersCount } = props;
    const [jql, setJql] = (0, $5uXOq.useState)(query);
    const onSearch = (0, $5uXOq.useCallback)((newJql)=>{
        setJql(newJql);
        triggerSearch && $681286dd03941848$var$debouncedSearch(triggerSearch, newJql);
    }, [
        triggerSearch
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setJql(query);
    }, [
        query,
        setJql
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kG16F.ASTContainer), {
        jql: jql,
        onSwitchToJql: onSwitchToJql
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lW1IZ.SearchStateContainer), {
        excludedFields: excludedFields,
        irremovableFields: irremovableFields
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JQLEditor, {
        NoOptionComponent: NoOptionComponent,
        query: jql,
        onSearch: onSearch,
        onSwitchToJql: onSwitchToJql,
        excludedFields: excludedFields,
        onReady: onReady,
        onLoad: onLoad,
        onJourneyStart: onJourneyStart,
        hydrationQueryRef: hydrationQueryRef,
        isHydrating: isHydrating,
        projectOptions: projectOptions,
        singleSelectFields: singleSelectFields,
        shouldUseListMarkup: shouldUseListMarkup,
        hideOperatorDropdown: hideOperatorDropdown,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        showOrderByPicker: showOrderByPicker,
        contextJql: contextJql,
        viewContext: viewContext,
        suggestedUsersCount: suggestedUsersCount
    })));
};
const $681286dd03941848$var$JQLBuilderBasicUI = (props)=>{
    const { query: query, JQLEditor: JQLEditor, onSearch: triggerSearch, onSwitchToJql: onSwitchToJql, excludedFields: excludedFields, onReady: onReady, onLoad: onLoad, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, AddFilterButtonComponent: AddFilterButtonComponent, projectOptions: projectOptions, singleSelectFields: singleSelectFields, hydrationData: hydrationData, isHydrating: isHydrating, shouldUseListMarkup: shouldUseListMarkup, hideOperatorDropdown: hideOperatorDropdown, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, showOrderByPicker: showOrderByPicker, contextJql: contextJql, viewContext: viewContext = null, suggestedUsersCount: suggestedUsersCount } = props;
    const [jql, setJql] = (0, $5uXOq.useState)(query);
    const onSearch = (0, $5uXOq.useCallback)((newJql)=>{
        setJql(newJql);
        triggerSearch && $681286dd03941848$var$debouncedSearch(triggerSearch, newJql);
    }, [
        triggerSearch
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setJql(query);
    }, [
        query,
        setJql
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kG16F.ASTContainer), {
        jql: jql,
        onSwitchToJql: onSwitchToJql
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lW1IZ.SearchStateContainer), {
        excludedFields: excludedFields,
        irremovableFields: irremovableFields
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JQLEditor, {
        NoOptionComponent: NoOptionComponent,
        AddFilterButtonComponent: AddFilterButtonComponent,
        query: jql,
        onSearch: onSearch,
        onSwitchToJql: onSwitchToJql,
        excludedFields: excludedFields,
        onReady: onReady,
        onLoad: onLoad,
        onJourneyStart: onJourneyStart,
        hydrationData: hydrationData,
        isHydrating: isHydrating,
        projectOptions: projectOptions,
        singleSelectFields: singleSelectFields,
        shouldUseListMarkup: shouldUseListMarkup,
        hideOperatorDropdown: hideOperatorDropdown,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        showOrderByPicker: showOrderByPicker,
        contextJql: contextJql,
        viewContext: viewContext,
        suggestedUsersCount: suggestedUsersCount
    })));
};
const $681286dd03941848$export$c5a574f152d930c7 = ({ query: jql, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kG16F.ASTContainer), {
        jql: jql
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lW1IZ.SearchStateContainer), {
        excludedFields: props.excludedFields,
        irremovableFields: props.irremovableFields
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lzKFP.default), props)));
const $681286dd03941848$export$64a4e59c434c7d2d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "jqlBuilderBasic",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($681286dd03941848$var$JQLBuilderBasicUIOld, props));
const $681286dd03941848$var$JQLBuilderBasicUIWithAnalytics = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "jqlBuilderBasic",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($681286dd03941848$var$JQLBuilderBasicUI, props));
var $681286dd03941848$export$2e2bcd8739ae039 = $681286dd03941848$var$JQLBuilderBasicUIWithAnalytics;

});
parcelRegister("kG16F", function(module, exports) {

$parcel$export(module.exports, "ASTContainer", () => $e3071c28735d4f8b$export$9046b5020ab1c824);
$parcel$export(module.exports, "useAST", () => $e3071c28735d4f8b$export$2d94ebd7e6bbb03c);
$parcel$export(module.exports, "useClauseMap", () => $e3071c28735d4f8b$export$32019dca04f1bace);
$parcel$export(module.exports, "useTextSearchInputClause", () => $e3071c28735d4f8b$export$53c45c55dec81810);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $bngFq = parcelRequire("bngFq");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $c5AV2 = parcelRequire("c5AV2");
const $e3071c28735d4f8b$var$actions = Object.freeze({});
const $e3071c28735d4f8b$var$ASTContainerInternal = (0, $gg7kZ.createContainer)();
const $e3071c28735d4f8b$var$store = (0, $iXqE5.createStore)({
    containedBy: $e3071c28735d4f8b$var$ASTContainerInternal,
    initialState: {
        ast: {
            query: undefined,
            represents: '',
            errors: []
        },
        clauseMap: {},
        textSearchInputClause: undefined
    },
    actions: $e3071c28735d4f8b$var$actions,
    name: 'JQLBasic-ASTService',
    handlers: {
        onInit: ()=>({ setState: setState }, props)=>{
                setState((0, $c5AV2.getASTAndClausesFromJQL)(props));
            },
        onContainerUpdate: (nextProps, prevProps)=>({ setState: setState })=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(nextProps, prevProps)) setState((0, $c5AV2.getASTAndClausesFromJQL)(nextProps));
            }
    }
});
const $e3071c28735d4f8b$export$9046b5020ab1c824 = ({ jql: jql, children: children, onSwitchToJql: onSwitchToJql })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e3071c28735d4f8b$var$ASTContainerInternal, {
        jql: jql,
        createAnalyticsEvent: createAnalyticsEvent,
        onSwitchToJql: onSwitchToJql
    }, children);
};
const $e3071c28735d4f8b$export$2d94ebd7e6bbb03c = (0, $3sQ5x.createHook)($e3071c28735d4f8b$var$store, {
    selector: ({ ast: ast })=>ast
});
const $e3071c28735d4f8b$export$32019dca04f1bace = (0, $3sQ5x.createHook)($e3071c28735d4f8b$var$store, {
    selector: ({ clauseMap: clauseMap })=>clauseMap
});
const $e3071c28735d4f8b$export$53c45c55dec81810 = (0, $3sQ5x.createHook)($e3071c28735d4f8b$var$store, {
    selector: ({ textSearchInputClause: textSearchInputClause })=>textSearchInputClause
});

});
parcelRegister("c5AV2", function(module, exports) {

$parcel$export(module.exports, "getASTAndClausesFromJQL", () => $f51f2f52962d8ecb$export$1029f331f2d8b0fd);

var $3KEIl = parcelRequire("3KEIl");

var $jcw0u = parcelRequire("jcw0u");

var $5Dsab = parcelRequire("5Dsab");

var $6jt9j = parcelRequire("6jt9j");

var $j200s = parcelRequire("j200s");
const $f51f2f52962d8ecb$export$1029f331f2d8b0fd = ({ jql: jql, createAnalyticsEvent: createAnalyticsEvent, onSwitchToJql: onSwitchToJql })=>{
    const ast = new (0, $3KEIl.JastBuilder)().build(jql);
    let clauseMap = {};
    let textSearchInputClause;
    if (ast.query) try {
        ({ clauseMap: clauseMap, textSearchInputClause: textSearchInputClause } = new (0, $6jt9j.JqlClauseCollectingVisitor)(false).visit(ast.query));
    } catch (error) {
        if (error instanceof (0, $j200s.UnsupportedRefinementError)) {
            (0, $jcw0u.default)({
                event: createAnalyticsEvent({}),
                error: error,
                meta: {
                    id: 'queryTooComplexInBasicMode',
                    packageName: (0, $5Dsab.PACKAGE_NAME),
                    teamName: (0, $5Dsab.TEAM_NAME)
                },
                attributes: {
                    anonymizedJql: ast.query ? ast.query.accept((0, $5Dsab.jqlAnonymizerVisitor)) : undefined
                }
            });
            onSwitchToJql && onSwitchToJql();
        } else throw error;
    }
    return {
        ast: ast,
        clauseMap: clauseMap,
        textSearchInputClause: textSearchInputClause
    };
};

});


parcelRegister("lW1IZ", function(module, exports) {

$parcel$export(module.exports, "SearchStateContainer", () => $3e7055e4c82a9c84$export$f57da8b87ed90917);
$parcel$export(module.exports, "useSearchState", () => $3e7055e4c82a9c84$export$5fd14fa624074d55);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $kG16F = parcelRequire("kG16F");

var $47om7 = parcelRequire("47om7");
const $3e7055e4c82a9c84$var$actions = Object.freeze({});
const $3e7055e4c82a9c84$var$SearchStateContainerInternal = (0, $gg7kZ.createContainer)();
const $3e7055e4c82a9c84$var$store = (0, $iXqE5.createStore)({
    containedBy: $3e7055e4c82a9c84$var$SearchStateContainerInternal,
    initialState: {
        astClauseOrder: [],
        clausesByFieldId: {},
        secondaryClausesByFieldId: {}
    },
    actions: $3e7055e4c82a9c84$var$actions,
    name: 'JQLBasic-SearchStateService',
    handlers: {
        onInit: ()=>({ setState: setState }, props)=>{
                setState((0, $47om7.getClausesData)(props));
            },
        onContainerUpdate: (nextProps, prevProps)=>({ setState: setState })=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(nextProps, prevProps)) setState((0, $47om7.getClausesData)(nextProps));
            }
    }
});
const $3e7055e4c82a9c84$var$DEFAULT_EXCLUDED_FIELDS = [];
const $3e7055e4c82a9c84$export$f57da8b87ed90917 = ({ excludedFields: excludedFields = $3e7055e4c82a9c84$var$DEFAULT_EXCLUDED_FIELDS, irremovableFields: irremovableFields, children: children })=>{
    const [clauseMap] = (0, $kG16F.useClauseMap)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3e7055e4c82a9c84$var$SearchStateContainerInternal, {
        clauseMap: clauseMap,
        excludedFields: excludedFields,
        irremovableFields: irremovableFields
    }, children);
};
const $3e7055e4c82a9c84$export$5fd14fa624074d55 = (0, $3sQ5x.createHook)($3e7055e4c82a9c84$var$store);

});
parcelRegister("47om7", function(module, exports) {

$parcel$export(module.exports, "getClausesData", () => $650b3b1ce62a0d18$export$27e1563385d8bc4e);
const $650b3b1ce62a0d18$export$27e1563385d8bc4e = ({ clauseMap: clauseMap, excludedFields: excludedFields, irremovableFields: irremovableFields })=>{
    const clausesByFieldId = {};
    const secondaryClausesByFieldId = {};
    const astClauseOrder = [];
    Object.keys(clauseMap).forEach((fieldId)=>{
        const fieldIsNotIrremovable = !irremovableFields.has(fieldId);
        const fieldIsNotYetIncluded = !astClauseOrder.includes(fieldId);
        const isNotExcludedField = !excludedFields.includes(fieldId);
        if (fieldIsNotIrremovable && fieldIsNotYetIncluded && isNotExcludedField) astClauseOrder.push(fieldId);
        if (isNotExcludedField) {
            const clauses = clauseMap[fieldId];
            clausesByFieldId[fieldId] = clauses && clauses[0] ? clauses[0] : undefined;
            secondaryClausesByFieldId[fieldId] = clauses && clauses[1] ? clauses[1] : undefined;
        }
    });
    return {
        astClauseOrder: astClauseOrder,
        clausesByFieldId: clausesByFieldId,
        secondaryClausesByFieldId: secondaryClausesByFieldId
    };
};

});


parcelRegister("lzKFP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7872117bccdccde$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $izCUH = parcelRequire("izCUH");

var $kG16F = parcelRequire("kG16F");

var $lW1IZ = parcelRequire("lW1IZ");

var $b1PJk = parcelRequire("b1PJk");

var $f1i4L = parcelRequire("f1i4L");
const $d7872117bccdccde$export$407dcaf889e68e30 = ({ onLoad: onLoad, excludedFields: excludedFields, shouldUseListMarkup: shouldUseListMarkup, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, showOrderByPicker: showOrderByPicker })=>{
    const intl = (0, $koVbs.default)();
    const [ast] = (0, $kG16F.useAST)();
    const [{ astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId }] = (0, $lW1IZ.useSearchState)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        onLoad && onLoad();
    }, [
        onLoad
    ]);
    const { fieldsToRender: fieldsToRender, optionalFieldsCount: optionalFieldsCount } = (0, $5uXOq.useMemo)(()=>(0, $b1PJk.gatherIrremovableFields)({
            excludedFields: excludedFields,
            intl: intl,
            irremovableFields: irremovableFields,
            astClauseOrder: astClauseOrder,
            clausesByFieldId: clausesByFieldId,
            secondaryClausesByFieldId: secondaryClausesByFieldId
        }), [
        astClauseOrder,
        clausesByFieldId,
        excludedFields,
        intl,
        irremovableFields,
        secondaryClausesByFieldId
    ]);
    const orderByFieldCount = (0, $5uXOq.useMemo)(()=>showOrderByPicker ? (0, $f1i4L.getAstSortFields)(ast).length : undefined, [
        ast,
        showOrderByPicker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $izCUH.JQLEditorLoading), {
        fieldsToRender: fieldsToRender,
        optionalFieldsCount: optionalFieldsCount,
        shouldUseListMarkup: shouldUseListMarkup,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        showOrderByPicker: showOrderByPicker,
        orderByFieldsCount: orderByFieldCount
    });
};
var $d7872117bccdccde$export$2e2bcd8739ae039 = $d7872117bccdccde$export$407dcaf889e68e30;

});
parcelRegister("izCUH", function(module, exports) {

$parcel$export(module.exports, "JQLEditorLoading", () => $dd8f44802117d048$export$30c56a653ec47247);

var $5uXOq = parcelRequire("5uXOq");

var $8iquX = parcelRequire("8iquX");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $5Dsab = parcelRequire("5Dsab");

var $8OILN = parcelRequire("8OILN");

var $dnfgF = parcelRequire("dnfgF");

var $hJajZ = parcelRequire("hJajZ");

var $b1ym7 = parcelRequire("b1ym7");

var $aFqsz = parcelRequire("aFqsz");

var $8DDZN = parcelRequire("8DDZN");

var $17Whx = parcelRequire("17Whx");
const $dd8f44802117d048$export$30c56a653ec47247 = ({ fieldsToRender: fieldsToRender, optionalFieldsCount: optionalFieldsCount, orderByFieldsCount: orderByFieldsCount, shouldUseListMarkup: shouldUseListMarkup, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, showOrderByPicker: showOrderByPicker })=>{
    const StyledListItemChildComponent = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $hJajZ.default) : (0, $aFqsz.StyledListItemChild);
    const FieldWrapper = shouldUseListMarkup ? StyledListItemChildComponent : (0, $aFqsz.StyledChild);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $4R6GH.fg)('add_nin_press_interactions') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iquX.default), {
        name: "jql-builder-basic-loading"
    }), !hideTextSearchInput && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FieldWrapper, {
        key: (0, $5Dsab.getTextSearchInputField)(),
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "jql-builder-basic-refinement-fallback"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17Whx.TextSearchInputLoading), {
        placeholder: searchPlaceholder
    })), fieldsToRender.map((fieldToRender)=>{
        const { clause: clause, picker: picker, fieldId: fieldId, fieldLabel: fieldLabel, isIrremovable: isIrremovable } = fieldToRender;
        if (!isIrremovable) // Optional fields are not rendered in the loading state, instead the number of
        // optional fields is displayed as a badge on the More Dropdown button.
        // Only irremovable field picker trigger is rendered in the loading state.
        return null;
        switch(picker.pickerType){
            case (0, $8OILN.PickerTypes).Picker:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FieldWrapper, {
                    key: fieldId,
                    // eslint-disable-next-line jira/integration/test-id-by-folder-structure
                    "data-testid": "jql-builder-basic-refinement-fallback"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b1ym7.default), {
                    clause: clause,
                    fieldId: fieldId,
                    fieldDisplayName: fieldLabel,
                    fieldDescription: null,
                    isIrremovable: isIrremovable
                }));
            default:
                return null;
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dnfgF.default), {
        optionalFieldsCount: optionalFieldsCount
    })), showOrderByPicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8DDZN.default), {
        orderByFieldsCount: orderByFieldsCount ?? 0
    })));
};

});
parcelRegister("dnfgF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c758ade4ad924bf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2esxr = parcelRequire("2esxr");

var $cNW3X = parcelRequire("cNW3X");

var $jlx1P = parcelRequire("jlx1P");

var $jVpd1 = parcelRequire("jVpd1");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $6fhxU = parcelRequire("6fhxU");

var $k6gg6 = parcelRequire("k6gg6");

var $3AuGJ = parcelRequire("3AuGJ");
const $6c758ade4ad924bf$var$AddFilterFallback = ({ optionalFieldsCount: optionalFieldsCount })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const moreLabel = (0, $dCm1o.isVisualRefreshEnabled)() ? formatMessage((0, $6fhxU.default).moreButton) : formatMessage((0, $6fhxU.default).moreButtonOld);
    /**
   * We only show `More` button with loading state when there's more than 1
   * optional field with selected values underneath.
   * Otherwise we display the default `More` button
   */ if (optionalFieldsCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6gg6.LoadingStateAnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "default",
        isSelected: true,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        label: "addButton",
        testId: "jql-builder-basic.common.ui.add-filter-fallback.loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3AuGJ.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3AuGJ.StyledLabel), null, moreLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3AuGJ.StyledBadge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2esxr.default), {
        appearance: "primary"
    }, `+${optionalFieldsCount}`)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "default",
        iconAfter: (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jVpd1))), {
            label: "",
            color: "currentColor"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jlx1P))), {
            label: "addIcon",
            LEGACY_size: "small"
        }),
        isSelected: false,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        label: "addButton",
        testId: "jql-builder-basic.common.ui.add-filter-fallback.loading"
    }, moreLabel);
};
var $6c758ade4ad924bf$export$2e2bcd8739ae039 = $6c758ade4ad924bf$var$AddFilterFallback;

});
parcelRegister("6fhxU", function(module, exports) {

$parcel$export(module.exports, "default", () => $919c599fa052caed$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $919c599fa052caed$var$messages = (0, $7VHMR.defineMessages)({
    moreButtonOld: {
        "id": "jql-builder-basic.common.more-button-old",
        "defaultMessage": "More"
    },
    moreButton: {
        "id": "jql-builder-basic.common.more-button",
        "defaultMessage": "More filters"
    },
    refinementSearch: {
        "id": "jql-builder-basic.jql-editor.refinement-search",
        "defaultMessage": "Search issues"
    },
    searchCurrentPage: {
        "id": "jql-builder-basic.common.search-current-page",
        "defaultMessage": "Search on current page"
    },
    refinementSearchIssueTermRefresh: {
        "id": "jql-builder-basic.common.refinement-search-issue-term-refresh",
        "defaultMessage": "Search work"
    },
    moreButtonLabel: {
        "id": "jql-builder-basic.common.more-button-label",
        "defaultMessage": "More filter options"
    },
    searchMoreFiltersPlaceholder: {
        "id": "jql-builder-basic-picker.common.search-more-filters-placeholder",
        "defaultMessage": "Search more filters"
    }
});
var $919c599fa052caed$export$2e2bcd8739ae039 = $919c599fa052caed$var$messages;

});

parcelRegister("k6gg6", function(module, exports) {

$parcel$export(module.exports, "LoadingStateAnimationWrapper", () => $01a163aee5b9ae9b$export$c7a90a9f6120efb7);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $01a163aee5b9ae9b$export$c7a90a9f6120efb7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y44vkmg5 _kqswh2mm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3AuGJ", function(module, exports) {

$parcel$export(module.exports, "TriggerComponentNoOperator", () => $5921bcde41c9c2f7$export$2d8feb52cd4e66ea);
$parcel$export(module.exports, "Container", () => $5921bcde41c9c2f7$export$42a852a2b6b56249);
$parcel$export(module.exports, "LabelContainer", () => $5921bcde41c9c2f7$export$f5ae33f1b01a6402);
$parcel$export(module.exports, "StyledLabel", () => $5921bcde41c9c2f7$export$eea83358d9434634);
$parcel$export(module.exports, "StyledBadge", () => $5921bcde41c9c2f7$export$1eb8c4092e3d2863);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2esxr = parcelRequire("2esxr");

var $0yZbT = parcelRequire("0yZbT");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $gwIPs = parcelRequire("gwIPs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

const $5921bcde41c9c2f7$export$96bdbc84526f3739 = (value)=>Array.isArray(value) ? value.length > 0 : typeof value === 'object' && value !== null;
const $5921bcde41c9c2f7$export$2d8feb52cd4e66ea = ({ isInvalid: isInvalid = false, label: label = '', value: value, isSelected: isSelected })=>{
    if (!value || !$5921bcde41c9c2f7$export$96bdbc84526f3739(value)) return (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $5921bcde41c9c2f7$var$triggerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $5921bcde41c9c2f7$var$triggerStyles,
        testId: (0, $227fa8a1aa91f085$export$743be55d5cf4a20d)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        weight: "medium",
        color: !isSelected ? 'color.text.subtle' : 'inherit'
    }, label))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5921bcde41c9c2f7$export$42a852a2b6b56249, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5921bcde41c9c2f7$export$f5ae33f1b01a6402, {
        "data-testid": (0, $227fa8a1aa91f085$export$743be55d5cf4a20d)
    }, label));
    const valueMap = value.map((v)=>v.optionType !== 'error' && v.label !== undefined ? v.label : '');
    const valueLength = valueMap.length;
    const [firstValue, ...rest] = valueMap;
    const badgeAppearance = isInvalid ? 'important' : 'primary';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5921bcde41c9c2f7$export$42a852a2b6b56249, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5921bcde41c9c2f7$export$f5ae33f1b01a6402, {
        "data-testid": (0, $227fa8a1aa91f085$export$743be55d5cf4a20d)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5921bcde41c9c2f7$export$eea83358d9434634, null, label, ":"), firstValue), valueLength > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5921bcde41c9c2f7$export$1eb8c4092e3d2863, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2esxr.default), {
        testId: (0, $227fa8a1aa91f085$export$fca2db27fe6c1305),
        appearance: badgeAppearance
    }, `+${rest.length}`)) : null);
};
const $5921bcde41c9c2f7$var$triggerContainerStyles = (0, $2s57o.xcss)({
    display: 'inline-flex',
    alignItems: 'center'
});
const $5921bcde41c9c2f7$var$triggerStyles = (0, $2s57o.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${36 * (0, $gwIPs.gridSize)}px`,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $5921bcde41c9c2f7$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $5921bcde41c9c2f7$export$f5ae33f1b01a6402 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _p12fo812 _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $5921bcde41c9c2f7$export$eea83358d9434634 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48pmoej _2hwx1b66",
            __cmplp.className
        ])
    });
});
const $5921bcde41c9c2f7$export$1eb8c4092e3d2863 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _18u01b66",
            __cmplp.className
        ])
    });
});

});
const $227fa8a1aa91f085$export$743be55d5cf4a20d = 'jql-builder-basic.common.ui.format-label.label-container';
const $227fa8a1aa91f085$export$fca2db27fe6c1305 = 'jql-builder-basic.common.ui.format-label.badge';



parcelRegister("hJajZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $97e39a81572e2382$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");
const $97e39a81572e2382$var$ListItemChild = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "li",
        xcss: $97e39a81572e2382$var$listItemStyles,
        "data-vc": "jql-builder-basic-list-item-child",
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "jql-builder-basic-refinement-fallback"
    }, children);
var $97e39a81572e2382$export$2e2bcd8739ae039 = $97e39a81572e2382$var$ListItemChild;
const $97e39a81572e2382$var$listItemStyles = (0, $2s57o.xcss)({
    margin: 'space.050',
    minWidth: 'space.0',
    listStyle: 'none'
});

});

parcelRegister("b1ym7", function(module, exports) {

$parcel$export(module.exports, "default", () => $7da778154ab24786$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $4Hz9T = parcelRequire("4Hz9T");
const $7da778154ab24786$export$15138d86eb9e97c3 = ({ label: label = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7da778154ab24786$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7da778154ab24786$var$LabelContainer, null, label));
const $7da778154ab24786$var$PickerFallback = ({ clause: clause, fieldId: fieldId, fieldDisplayName: fieldDisplayName, fieldDescription: fieldDescription, isIrremovable: isIrremovable })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Hz9T.default), {
        isInvalid: false,
        isSelected: false,
        hasValues: !!clause,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        testId: `jql-builder-basic.ui.jql-editor.picker.filter-button.${fieldId}`,
        isLoading: !!clause,
        fieldDescription: fieldDescription,
        isIrremovable: isIrremovable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7da778154ab24786$export$15138d86eb9e97c3, {
        label: fieldDisplayName
    }));
var $7da778154ab24786$export$2e2bcd8739ae039 = $7da778154ab24786$var$PickerFallback;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7da778154ab24786$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $7da778154ab24786$var$LabelContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c116y _4cvr1h6o _p12fo812 _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4Hz9T", function(module, exports) {

$parcel$export(module.exports, "default", () => $58abe43cfea5235b$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $85eFT = parcelRequire("85eFT");

var $dGKFs = parcelRequire("dGKFs");

var $6eFvr = parcelRequire("6eFvr");

var $5KCCi = parcelRequire("5KCCi");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $dCm1o = parcelRequire("dCm1o");

var $5Dsab = parcelRequire("5Dsab");

var $90Iri = parcelRequire("90Iri");

var $kyiZW = parcelRequire("kyiZW");

var $k6gg6 = parcelRequire("k6gg6");

var $izo0U = parcelRequire("izo0U");
const $58abe43cfea5235b$var$Button = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $cNW3X.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _ju3gewfl _mt1tewfl",
            __cmplp.className
        ])
    });
});
const $58abe43cfea5235b$var$isKeyboardEvent = (event)=>event.key !== undefined;
const $58abe43cfea5235b$var$PickerTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isInvalid: isInvalid, isSelected: isSelected, isLoading: isLoading, hasValues: hasValues, onClick: onClick, onClear: onClear, testId: testId, searchTemplate: searchTemplate, fieldDescription: fieldDescription, isIrremovable: isIrremovable = false }, ref)=>{
    const intl = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const handleOnClear = (0, $5uXOq.useCallback)((e)=>{
        e.stopPropagation();
        const isKeyboard = $58abe43cfea5235b$var$isKeyboardEvent(e); // only clear on click, enter key or space key
        const shouldClear = isKeyboard && (e.key === 'Enter' || e.key === ' ') || !isKeyboard;
        onClear && shouldClear && onClear();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'removeFilter', {
            keyboard: isKeyboard
        });
    }, [
        createAnalyticsEvent,
        onClear
    ]);
    if (isLoading === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6gg6.LoadingStateAnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        isSelected: true,
        testId: `${testId}.loading`,
        ...(0, $4R6GH.fg)('add_nin_press_interactions') && {
            interactionName: 'jql-builder-basic-picker-trigger'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58abe43cfea5235b$var$ButtonContent, null, children)));
    const Content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58abe43cfea5235b$var$ButtonContent, null, searchTemplate === (0, $5Dsab.EPIC_LINK).searchTemplate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $izo0U.default).deprecatedEpicLinkMessage,
            values: {
                // @ts-expect-error - Type '(chunks: string) => JSX.Element' is not assignable to type 'ReactNode'.
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
                        as: "strong",
                        color: "inherit",
                        size: "UNSAFE_small"
                    }, chunks)
            }
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58abe43cfea5235b$var$IconWrapperLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($85eFT))), {
        label: "",
        color: "var(--ds-icon-warning, #E56910)",
        LEGACY_size: "small"
    }))), children);
    const IconAfterContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58abe43cfea5235b$var$IconWrapper, {
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, fieldDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kyiZW.FieldDescriptionPopup), {
        fieldDescription: fieldDescription,
        isParentPickerActive: hasValues || isSelected
    }), !isIrremovable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $90Iri.ClearButton), {
        onClick: handleOnClear,
        label: intl.formatMessage((0, $izo0U.default).removeField)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dGKFs))), {
        label: "",
        color: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') && !(isSelected || hasValues) ? "var(--ds-icon-subtle, #626F86)" : 'currentColor'
    }));
    return isInvalid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58abe43cfea5235b$export$332fba2134818c97, {
        isSelected: isSelected || hasValues,
        onClick: onClick,
        ref: ref,
        testId: testId,
        iconAfter: IconAfterContent
    }, Content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58abe43cfea5235b$var$Button, {
        isSelected: isSelected || hasValues,
        "aria-expanded": isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        iconAfter: IconAfterContent
    }, Content);
});
var $58abe43cfea5235b$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $58abe43cfea5235b$var$PickerTrigger;
const $58abe43cfea5235b$var$ButtonContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- To migrate as part of go/ui-styling-standard
const $58abe43cfea5235b$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_gg26t5": (0, $lD23V.default)(__cmplp.visualRefresh ? "var(--ds-space-0, 0px)" : "var(--ds-space-negative-075, -6px)")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _2hwxyz14",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58abe43cfea5235b$var$IconWrapperLeft = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwx1b66 _18u01i6y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $58abe43cfea5235b$export$332fba2134818c97 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58abe43cfea5235b$var$Button, {
        ...props,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_1w905u61 _16hgvb0f _zelm5u61 _1fh15u61 _18y1vb0f _u1mbvb0f"
        ])
    }));
const $58abe43cfea5235b$var$styles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $58abe43cfea5235b$export$27305c69e65286e6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz14q2 _30l316c2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("90Iri", function(module, exports) {

$parcel$export(module.exports, "ClearButton", () => $7764ff8b7abaa99a$export$13ec83e50bf04290);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9ojbB = parcelRequire("9ojbB");
const $7764ff8b7abaa99a$export$13ec83e50bf04290 = ({ label: label, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7764ff8b7abaa99a$var$StyledClearButton, {
        // @ts-expect-error ts(2322) Type 'string' is not assignable to type 'number'.
        tabIndex: "0",
        role: "button",
        onClick: onClick,
        onKeyPress: onClick,
        "data-testid": "jql-editor-basic.common.ui.clear-button" // eslint-disable-line jira/integration/test-id-by-folder-structure
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ojbB))), {
        color: "currentColor",
        label: label
    }));
var $7764ff8b7abaa99a$export$2e2bcd8739ae039 = $7764ff8b7abaa99a$export$13ec83e50bf04290;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7764ff8b7abaa99a$var$StyledClearButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _syaz131l _nt751r31 _49pcglyw _1hvw1o36 _vn891l7b _f8pj1fxt _7ehi1vm4 _30l31fxt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9ojbB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c13696afcc546e8bf0fe91a6c236c8d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d653cee5ee628ba$var$_react = $6d653cee5ee628ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6d653cee5ee628ba$var$_cross = $6d653cee5ee628ba$var$_interopRequireDefault((parcelRequire("gANiX")));

var $6d653cee5ee628ba$var$_close = $6d653cee5ee628ba$var$_interopRequireDefault((parcelRequire("gKTT6")));
function $6d653cee5ee628ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6d653cee5ee628ba$var$CrossIcon = (props)=>/*#__PURE__*/ $6d653cee5ee628ba$var$_react.default.createElement($6d653cee5ee628ba$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $6d653cee5ee628ba$var$_close.default
    }, props));
$6d653cee5ee628ba$var$CrossIcon.Name = 'CrossIconMigration';
var $6d653cee5ee628ba$var$_default = module.exports.default = $6d653cee5ee628ba$var$CrossIcon;

});
parcelRegister("gKTT6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c32c4b58a13c4296$var$_react = $c32c4b58a13c4296$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $c32c4b58a13c4296$var$_close = $c32c4b58a13c4296$var$_interopRequireDefault((parcelRequire("eh9vz")));
function $c32c4b58a13c4296$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c32c4b58a13c4296$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $c32c4b58a13c4296$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $c32c4b58a13c4296$var$_close.default
    }));
$c32c4b58a13c4296$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $c32c4b58a13c4296$var$_default = module.exports.default = $c32c4b58a13c4296$var$EditorCloseIcon;

});



parcelRegister("kyiZW", function(module, exports) {

$parcel$export(module.exports, "FieldDescriptionPopup", () => $0e776a0cc6b017ab$export$8adaffb2a3e09bc3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c6Cwb = parcelRequire("c6Cwb");

var $5KCCi = parcelRequire("5KCCi");

var $9fuVs = parcelRequire("9fuVs");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $5Dsab = parcelRequire("5Dsab");


var $6Srtb = parcelRequire("6Srtb");

var $aD513 = parcelRequire("aD513");

var $7UbtS = parcelRequire("7UbtS");
const $0e776a0cc6b017ab$var$entryPointParams = {}; /**
                              * Render a Jira custom field description as rich text, within a popup
                              */ 
const $0e776a0cc6b017ab$export$8adaffb2a3e09bc3 = ({ fieldDescription: fieldDescription, shouldOpenOnFirstRender: shouldOpenOnFirstRender = false, isParentPickerActive: isParentPickerActive })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(shouldOpenOnFirstRender);
    const toggleOpenCloseState = (0, $5uXOq.useCallback)(()=>{
        setIsOpen((currentIsOpenValue)=>!currentIsOpenValue);
    }, []);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $aD513.default), $0e776a0cc6b017ab$var$entryPointParams);
    const buttonTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions); /**
                                                                        * lazily render the field description popup content (using entrypoints).
                                                                        * The content is a rich text description that is configured in the 'custom
                                                                        * fields' Jira settings.
                                                                        */ 
    const renderContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: (0, $b0f3fc705d61334f$export$723ee4d7411b97b4),
            packageName: (0, $5Dsab.PACKAGE_NAME),
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Srtb.ContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Srtb.ContentError), null)),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Srtb.ContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Srtb.ContentLoading), null)),
            runtimeProps: {
                fieldDescription: fieldDescription
            }
        }), [
        entryPointReferenceSubject,
        fieldDescription
    ]);
    /**
   * renders the icon that, when clicked, toggles open/close state of the
   * field description popup
   */ const renderTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
            content: formatMessage((0, $7UbtS.default).showDescription),
            position: "top"
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0e776a0cc6b017ab$var$Trigger, {
                ...tooltipProps,
                ...triggerProps,
                ref: (element)=>{
                    /*
       * make sure the Trigger's ref is passed to all things
       * that need it, otherwise bugs will appear such as
       * tooltip/popup appearing in weird places
       */ buttonTrigger(element); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    tooltipProps.ref(element); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                },
                isOpen: isOpen,
                isParentPickerActive: isParentPickerActive,
                onClick: (e)=>{
                    e.stopPropagation();
                    toggleOpenCloseState();
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c6Cwb))), {
                spacing: "spacious",
                label: isOpen ? formatMessage((0, $7UbtS.default).hideDescription) : formatMessage((0, $7UbtS.default).showDescription)
            }))), [
        buttonTrigger,
        formatMessage,
        isOpen,
        isParentPickerActive,
        toggleOpenCloseState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        messageId: "jql-builder-basic.common.ui.field-description-popup.popup",
        messageType: "transactional",
        content: renderContent,
        trigger: renderTrigger
    }), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null));
};
/**
 * Clickable element that will toggle the open / close state of the popup
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0e776a0cc6b017ab$var$Trigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOpen: isOpen, isParentPickerActive: isParentPickerActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk18uv _80omtlke _nt751r31 _49pcglyw _1hvw1o36 _vn891l7b _f8pj1fxt _7ehi1vm4 _30l31fxt",
            __cmplp.isOpen || __cmplp.isParentPickerActive ? "_syaz1qo3" : "_syaz131l",
            __cmplp.className
        ])
    });
});

});
const $b0f3fc705d61334f$export$723ee4d7411b97b4 = 'field-description-popup-content';

parcelRegister("6Srtb", function(module, exports) {

$parcel$export(module.exports, "ContentBox", () => $7e60d592ad923b2d$export$2966b8ec97c144ae);
$parcel$export(module.exports, "ContentError", () => $7e60d592ad923b2d$export$f2a1a543c1677898);
$parcel$export(module.exports, "ContentLoading", () => $7e60d592ad923b2d$export$199be3e6e7e83c08);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c0tV6 = parcelRequire("c0tV6");

var $jFRXz = parcelRequire("jFRXz");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $2s57o = parcelRequire("2s57o");

var $clxo5 = parcelRequire("clxo5");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $iiJVH = parcelRequire("iiJVH");
const $7e60d592ad923b2d$export$2966b8ec97c144ae = ({ children: children })=>{
    /**
   * Because the field description button is nested within the picker button,
   * any click events in the field description popup would bubble up and trigger
   * the picker. This is an intrim solution to prevent that from happening. Wrap
   * the entire field description popup in a div that listens for clicks and traps
   * them so that they don't bubble further up to the picker button.
   *
   * TODO remove this when completing the followup ticket:
   * https://jplat.jira.atlassian.cloud/browse/EM-6510
   */ const propagationTrap = (e)=>e.stopPropagation();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        padding: "space.150",
        xcss: $7e60d592ad923b2d$var$contentBoxStyles,
        onClick: propagationTrap,
        tabIndex: 0
    }, children);
};
const $7e60d592ad923b2d$export$f2a1a543c1677898 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        direction: "column",
        justifyContent: "center",
        alignItems: "center"
    }, !(0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e60d592ad923b2d$var$FlexRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c0tV6))), {
        label: "",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jFRXz))),
        LEGACY_size: "xlarge",
        LEGACY_primaryColor: "color.text",
        color: "var(--ds-icon-warning, #E56910)",
        testId: "jql-builder-basic.common.ui.field-description-popup-common.editor-warning-icon"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e60d592ad923b2d$var$FlexRow, null, (0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $7e60d592ad923b2d$var$warningIconStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c0tV6))), {
        label: "",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jFRXz))),
        LEGACY_size: "xlarge",
        LEGACY_primaryColor: "color.text",
        color: "var(--ds-icon-warning, #E56910)",
        testId: "jql-builder-basic.common.ui.field-description-popup-common.editor-warning-icon"
    })), formatMessage((0, $iiJVH.default).error)));
};
const $7e60d592ad923b2d$export$199be3e6e7e83c08 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
        testId: "jql-builder-basic.common.ui.field-description-popup-common.spinner",
        size: "small"
    });
const $7e60d592ad923b2d$var$contentBoxStyles = (0, $2s57o.xcss)({
    maxWidth: '300px',
    maxHeight: '300px',
    overflow: 'auto',
    outline: 'none'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e60d592ad923b2d$var$FlexRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _y3gn1h6o _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $7e60d592ad923b2d$var$warningIconStyle = (0, $2s57o.xcss)({
    marginRight: 'space.100',
    display: 'inline'
});

});
parcelRegister("jFRXz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e52bb3ecf1fcfe04$var$_react = $e52bb3ecf1fcfe04$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $e52bb3ecf1fcfe04$var$_warning = $e52bb3ecf1fcfe04$var$_interopRequireDefault((parcelRequire("c0tV6")));
function $e52bb3ecf1fcfe04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e52bb3ecf1fcfe04$var$EditorWarningIcon = (props)=>/*#__PURE__*/ $e52bb3ecf1fcfe04$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
    }, props, {
        newIcon: $e52bb3ecf1fcfe04$var$_warning.default
    }));
$e52bb3ecf1fcfe04$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
var $e52bb3ecf1fcfe04$var$_default = module.exports.default = $e52bb3ecf1fcfe04$var$EditorWarningIcon;

});

parcelRegister("iiJVH", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc850f0f20c3659$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $8bc850f0f20c3659$var$messages = (0, $7VHMR.defineMessages)({
    error: {
        "id": "jql-builder-basic.common.field-description-popup-common.error",
        "defaultMessage": "We cannot show the field description at this time. Please refresh to try again."
    }
});
var $8bc850f0f20c3659$export$2e2bcd8739ae039 = $8bc850f0f20c3659$var$messages;

});


parcelRegister("aD513", function(module, exports) {

$parcel$export(module.exports, "default", () => $c439a020623e24f3$export$2e2bcd8739ae039);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $c439a020623e24f3$var$FieldDescriptionContentEntryPoint = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("71r6J")), {
        moduleId: "91602efd"
    }),
    getPreloadProps: ()=>({})
});
var $c439a020623e24f3$export$2e2bcd8739ae039 = $c439a020623e24f3$var$FieldDescriptionContentEntryPoint;

});
parcelRegister("71r6J", function(module, exports) {

let $51cda762c8b221b6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $51cda762c8b221b6$var$load("cM9em"),
    $51cda762c8b221b6$var$load("fr9NE"),
    $51cda762c8b221b6$var$load("h2MrD"),
    $51cda762c8b221b6$var$load("bYT2S"),
    $51cda762c8b221b6$var$load("gHy5x")
]).then(()=>parcelRequire('5mAw8'));

});


parcelRegister("7UbtS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ca72366f29682d4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $6ca72366f29682d4$var$messages = (0, $7VHMR.defineMessages)({
    showDescription: {
        "id": "jql-builder-basic.common.field-description-popup.show-description",
        "defaultMessage": "Show the description for this field"
    },
    hideDescription: {
        "id": "jql-builder-basic.common.field-description-popup.hide-description",
        "defaultMessage": "Hide the description for this field"
    }
});
var $6ca72366f29682d4$export$2e2bcd8739ae039 = $6ca72366f29682d4$var$messages;

});


parcelRegister("izo0U", function(module, exports) {

$parcel$export(module.exports, "default", () => $b80dd7b4460f7661$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $b80dd7b4460f7661$var$messages = (0, $7VHMR.defineMessages)({
    removeField: {
        "id": "jql-builder-basic.common.picker-trigger.remove-field",
        "defaultMessage": "Remove field"
    },
    deprecatedEpicLinkMessage: {
        "id": "jql-builder-basic.common.picker-trigger.deprecated-epic-link-message",
        "defaultMessage": "<strong>Epic Link</strong> is replaced by <strong>Parent</strong>."
    }
});
var $b80dd7b4460f7661$export$2e2bcd8739ae039 = $b80dd7b4460f7661$var$messages;

});



parcelRegister("aFqsz", function(module, exports) {

$parcel$export(module.exports, "StyledChild", () => $9d12758baec1c265$export$8133811dea85f484);
$parcel$export(module.exports, "StyledListItemChild", () => $9d12758baec1c265$export$b24abe39371fec57);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $9d12758baec1c265$export$8133811dea85f484 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkv77o _2hwx1b66 _otyrv77o _18u01b66 _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $9d12758baec1c265$export$b24abe39371fec57 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_qtt8glyw _19pk1b66 _2hwxv77o _otyr1b66 _18u0v77o _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $9d12758baec1c265$export$999ca5bf223f627 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1mjv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8DDZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb19a4d5cffc2857$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $k6gg6 = parcelRequire("k6gg6");

var $bRlQB = parcelRequire("bRlQB");
const $fb19a4d5cffc2857$var$ORDER_BY_LOADING_BUTTON_ID = 'jql-builder-basic-order-by-trigger-loading';
const $fb19a4d5cffc2857$var$OrderByPickerLoading = ({ orderByFieldsCount: orderByFieldsCount })=>orderByFieldsCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6gg6.LoadingStateAnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bRlQB.default), {
        numberOfFields: orderByFieldsCount,
        buttonId: $fb19a4d5cffc2857$var$ORDER_BY_LOADING_BUTTON_ID,
        isSelected: true
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bRlQB.default), {
        numberOfFields: orderByFieldsCount,
        buttonId: $fb19a4d5cffc2857$var$ORDER_BY_LOADING_BUTTON_ID,
        isSelected: false
    });
var $fb19a4d5cffc2857$export$2e2bcd8739ae039 = $fb19a4d5cffc2857$var$OrderByPickerLoading;

});
parcelRegister("bRlQB", function(module, exports) {

$parcel$export(module.exports, "default", () => $256a08af8fc686a4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2esxr = parcelRequire("2esxr");

var $bMFGq = parcelRequire("bMFGq");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $b7WzA = parcelRequire("b7WzA");

var $bbrNS = parcelRequire("bbrNS");
/**
 * Renders the button that triggers open/close of the Order By Picker. Also rendered in the basic mode
 * loading screen when the Order By Picker is enabled.
 */ const $256a08af8fc686a4$var$OrderByButton = ({ onClick: onClick, numberOfFields: numberOfFields, triggerProps: triggerProps, buttonId: buttonId, isSelected: isSelected })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const label = numberOfFields ? formatMessage((0, $b7WzA.default).labelNameWithBadge, {
        fieldCount: numberOfFields
    }) : formatMessage((0, $b7WzA.default).name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMFGq.default), {
        ...triggerProps,
        id: buttonId,
        isSelected: Boolean(numberOfFields) || isSelected,
        onClick: onClick,
        iconAfter: (...iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                xcss: $256a08af8fc686a4$var$iconContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bbrNS.default), {
                ...iconProps,
                size: "small",
                label: ""
            })),
        "aria-label": label,
        testId: "jql-builder-basic.common.ui.order-by-trigger-button.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, formatMessage((0, $b7WzA.default).name)), Boolean(numberOfFields) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2esxr.default), {
        appearance: "primary"
    }, numberOfFields))));
};
var $256a08af8fc686a4$export$2e2bcd8739ae039 = $256a08af8fc686a4$var$OrderByButton;
const $256a08af8fc686a4$var$iconContainerStyles = (0, $2s57o.xcss)({
    paddingRight: 'space.050',
    paddingTop: 'space.025'
});

});
parcelRegister("b7WzA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ffa5089e7ddea1c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
'src/packages/jql-builder/basic/src/ui/jql-editor/order-by-picker/trigger-button/messages.tsx';
const $5ffa5089e7ddea1c$var$messages = (0, $7VHMR.defineMessages)({
    name: {
        "id": "jql-builder-basic.common.order-by-trigger-button.name",
        "defaultMessage": "Order"
    },
    labelNameWithBadge: {
        "id": "jql-builder-basic.common.order-by-trigger-button.label-name-with-badge",
        "defaultMessage": "Order, currently {fieldCount, plural, other {# fields} one {# field}} selected"
    }
});
var $5ffa5089e7ddea1c$export$2e2bcd8739ae039 = $5ffa5089e7ddea1c$var$messages;

});

parcelRegister("bbrNS", function(module, exports) {

$parcel$export(module.exports, "default", () => $19e6120943fc1adf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $19e6120943fc1adf$var$sortOrderGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 16 16",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "none",
        d: "M1.7749 3.25001L4.24978 0.775132L6.72465 3.25001M14.2251 10.75L11.7502 13.2249L9.27535 10.75M11.75 12.5V0.75M4.25 13.25L4.25 1.50001",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "square",
        strokeLinejoin: "round"
    }));
const $19e6120943fc1adf$var$SortIcon = ({ label: label, size: size = 'medium' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ltBcH.default), {
        glyph: $19e6120943fc1adf$var$sortOrderGlyph,
        label: label,
        size: size
    });
var $19e6120943fc1adf$export$2e2bcd8739ae039 = $19e6120943fc1adf$var$SortIcon;

});



parcelRegister("17Whx", function(module, exports) {

$parcel$export(module.exports, "TextSearchInputLoading", () => $0e5aab6ab62a608c$export$d8de07f8c0b1e278);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $kG16F = parcelRequire("kG16F");

var $8RcVP = parcelRequire("8RcVP");

var $ibQjx = parcelRequire("ibQjx");

var $6fhxU = parcelRequire("6fhxU");

var $4TUUg = parcelRequire("4TUUg");
const $0e5aab6ab62a608c$export$d8de07f8c0b1e278 = ({ placeholder: placeholder })=>{
    const intl = (0, $koVbs.default)();
    const [textSearchInputClause] = (0, $kG16F.useTextSearchInputClause)();
    const value = (0, $5uXOq.useMemo)(()=>(0, $ibQjx.removeSurroundingQuotes)((0, $8RcVP.default).value(textSearchInputClause) || ''), [
        textSearchInputClause
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4TUUg.default), {
        label: placeholder !== undefined && (0, $dCm1o.isVisualRefreshEnabled)() ? placeholder : intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6fhxU.default).refinementSearchIssueTermRefresh : (0, $6fhxU.default).refinementSearch),
        value: value,
        onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        isDisabled: true
    });
};

});
parcelRegister("ibQjx", function(module, exports) {

$parcel$export(module.exports, "removeSurroundingQuotes", () => $ee9ecbb7ad59ed78$export$8de447c869ac6d85);
const $ee9ecbb7ad59ed78$export$8de447c869ac6d85 = (maybeQuotedString)=>maybeQuotedString.replace(/^["']|["']$/g, '');

});

parcelRegister("4TUUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdc5b4c13c9152e8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $2xSAL = parcelRequire("2xSAL");

var $dCm1o = parcelRequire("dCm1o");
const $cdc5b4c13c9152e8$var$debounceOnChange = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(({ onSendOptionAnalytics: onSendOptionAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChange: onChange, targetValue: targetValue })=>{
    onChange(targetValue);
    onSendOptionAnalytics({
        searchStringLength: targetValue ? targetValue.length : 0
    });
}, 500, {
    leading: false,
    trailing: true
});
const $cdc5b4c13c9152e8$var$TextField = ({ inputRef: inputRef, label: label, value: value, isDisabled: isDisabled = false, onChange: onChange, onFocus: onFocus, onSendOptionAnalytics: onSendOptionAnalytics })=>{
    const handleChange = (0, $5uXOq.useCallback)((targetValue)=>{
        $cdc5b4c13c9152e8$var$debounceOnChange({
            onChange: onChange,
            targetValue: targetValue,
            onSendOptionAnalytics: onSendOptionAnalytics
        });
    }, [
        onChange,
        onSendOptionAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cdc5b4c13c9152e8$var$StyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
        onChange: handleChange,
        onFocus: onFocus,
        value: value,
        placeholder: label,
        placeholderAlwaysVisible: true,
        isCompact: true,
        isResponsive: true,
        inputRef: inputRef,
        testId: "jql-builder-basic.common.ui.text-field.search-field",
        isDisabled: isDisabled,
        showIconBeforeInput: (0, $dCm1o.isVisualRefreshEnabled)()
    }));
};
var $cdc5b4c13c9152e8$export$2e2bcd8739ae039 = $cdc5b4c13c9152e8$var$TextField;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cdc5b4c13c9152e8$var$StyledContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2xSAL", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $f115db1c327fbbaa$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fW62l = parcelRequire("fW62l");

var $bngFq = parcelRequire("bngFq");

var $9r7BT = parcelRequire("9r7BT");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $cBssJ = parcelRequire("cBssJ");

var $hJBhl = parcelRequire("hJBhl");

var $5yLnO = parcelRequire("5yLnO");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $f115db1c327fbbaa$var$className = 'ajs-dirty-warning-exempt';
const $f115db1c327fbbaa$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, reducedHeight: reducedHeight = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const [value, setValue] = (0, $5uXOq.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const textInput = (0, $5uXOq.useRef)(null);
    const previousValueRef = (0, $5uXOq.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $5uXOq.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $5uXOq.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $5uXOq.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder || formatMessage((0, $cBssJ.messages).search),
        'aria-describedby': describedById,
        type: 'text',
        // @ts-expect-error - TS2322 - Type '{ 'aria-label': string; 'aria-describedby': string; type: string; 'data-test-id': string; name: string; className: string; placeholder: string; onFocus: (event: React.SyntheticEvent<HTMLInputElement, Event>) => void; ... 9 more ...; maxLength: number | undefined; }' is not assignable to type 'TextfieldProps'.
        'data-test-id': 'searchfield',
        testId: testId ?? 'searchfield',
        name: 'search',
        className: $f115db1c327fbbaa$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5yLnO.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $cBssJ.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5yLnO.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJBhl.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $cBssJ.messages).clear)
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? {
            reducedHeight: reducedHeight
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9r7BT.default), {
        ...textFieldProps,
        elemBeforeInput: searchIcon,
        elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$f115db1c327fbbaa$var$SearchFieldUnmemoized.displayName = 'Search';
$f115db1c327fbbaa$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $f115db1c327fbbaa$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $5uXOq.memo)($f115db1c327fbbaa$var$SearchFieldUnmemoized);
$f115db1c327fbbaa$export$b94867ecbd698f21.displayName = 'Search'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f115db1c327fbbaa$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.reducedHeight && "_4t3izwfg",
            __cmplp.className
        ])
    });
});
const $f115db1c327fbbaa$var$InputWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $lD23V.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $lD23V.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $lD23V.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $lD23V.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $lD23V.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $lD23V.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $lD23V.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $lD23V.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564zpk5 _1e0c1txw _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cBssJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $08273d4fc2a6d6da$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $08273d4fc2a6d6da$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("hJBhl", function(module, exports) {

$parcel$export(module.exports, "ClearFieldIcon", () => $99940a7c159b00c0$export$84038b503874befa);

var $5uXOq = parcelRequire("5uXOq");

var $1Seuh = parcelRequire("1Seuh");

var $eh9vz = parcelRequire("eh9vz");

var $0yZbT = parcelRequire("0yZbT");
var $kU1q1 = parcelRequire("kU1q1");
var $2s57o = parcelRequire("2s57o");
const $99940a7c159b00c0$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            $99940a7c159b00c0$var$wrapperStylesCloseIcon
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eh9vz)))
    }));
const $99940a7c159b00c0$var$wrapperStylesCloseIcon = (0, $2s57o.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $kU1q1.media).above.md]: {
        marginRight: 'space.050'
    }
});

});

parcelRegister("5yLnO", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIconDynamic", () => $71cc18983db63a0d$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $71cc18983db63a0d$export$8a82bff895521bd9);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $kweMg = parcelRequire("kweMg");

var $4QlcP = parcelRequire("4QlcP");

var $aWy0H = parcelRequire("aWy0H");

var $0yZbT = parcelRequire("0yZbT");
var $kU1q1 = parcelRequire("kU1q1");
var $2s57o = parcelRequire("2s57o");
const $71cc18983db63a0d$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4QlcP))), {
        LEGACY_size: "small",
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            $71cc18983db63a0d$var$wrapperStyles,
            onlyIconSpacing && $71cc18983db63a0d$var$spacingStyles
        ]
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "subtle",
        spacing: "none",
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kweMg))), {
            LEGACY_size: "small",
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $71cc18983db63a0d$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            $71cc18983db63a0d$var$wrapperStylesBefore,
            onlyIconSpacing && $71cc18983db63a0d$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWy0H))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null));
const $71cc18983db63a0d$var$wrapperStyles = (0, $2s57o.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex'
});
const $71cc18983db63a0d$var$spacingStyles = (0, $2s57o.xcss)({
    marginRight: 'space.075',
    [(0, $kU1q1.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $71cc18983db63a0d$var$wrapperStylesBefore = (0, $2s57o.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $kU1q1.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $71cc18983db63a0d$var$spacingStylesBefore = (0, $2s57o.xcss)({
    marginLeft: 'space.075',
    [(0, $kU1q1.media).above.md]: {
        marginLeft: 'space.100'
    }
});

});





parcelRegister("b1PJk", function(module, exports) {

$parcel$export(module.exports, "gatherFields", () => $c6d9a58efc4e5979$export$af0604ea1b6b60ec);
$parcel$export(module.exports, "gatherIrremovableFields", () => $c6d9a58efc4e5979$export$2965c0f6ab2d5c39);

var $ifg6x = parcelRequire("ifg6x");

var $7qDUb = parcelRequire("7qDUb");

var $i0Cp4 = parcelRequire("i0Cp4");

var $89g1C = parcelRequire("89g1C");
/**
 * getDataFromHydratedData read the fieldsHydratedData to the data hashed by fieldId/jqlTerm
 */ const $c6d9a58efc4e5979$var$getDataFromHydratedData = ({ fieldsHydratedData: fieldsHydratedData })=>{
    const fieldsData = {};
    (fieldsHydratedData?.jira?.jqlBuilder?.hydrateJqlQuery ?? fieldsHydratedData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter)?.fields?.forEach((hydratedField)=>{
        if (hydratedField.field && hydratedField.jqlTerm) {
            const { field: { displayName: displayName, searchTemplate: searchTemplate, type: type, description: description, operators: operators, fieldType: fieldType, shouldShowInContext: shouldShowInContext }, jqlTerm: jqlTerm } = hydratedField;
            // Searchable fields should always have a type & search template
            if (searchTemplate?.key == null || type == null) return;
            if (!fieldsData[jqlTerm.toLowerCase()]) fieldsData[jqlTerm.toLowerCase()] = {
                displayName: // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                displayName,
                searchTemplate: searchTemplate.key,
                fieldType: type,
                fieldDescription: description ?? null,
                fieldTypeDisplayName: fieldType?.displayName ?? null,
                operators: operators.map((0, $89g1C.mapOperators)),
                isDuplicated: false,
                shouldShowInContext: shouldShowInContext ?? true
            };
            else fieldsData[jqlTerm.toLowerCase()].isDuplicated = true;
        }
    });
    return fieldsData;
};
/**
 * getOptionalFieldsToRender takes data from the AST, selectedFields and hydrated data and generates Optional fields to render array
 */ const $c6d9a58efc4e5979$var$getOptionalFieldsToRender = ({ astClauseOrder: astClauseOrder, selectedFields: selectedFields, fieldsData: fieldsData, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId, excludedFields: excludedFields })=>{
    // First get an array of unique fields we want to add
    const allFields = [
        ...new Set([
            ...astClauseOrder,
            ...selectedFields.map((sf)=>sf.value.toLowerCase())
        ])
    ];
    // Create hash map with data of selected fields
    const selectedFieldsData = selectedFields.reduce((map, selectedField)=>{
        // eslint-disable-next-line no-param-reassign
        map[selectedField.value.toLowerCase()] = {
            displayName: selectedField.label,
            searchTemplate: selectedField.searchTemplate,
            fieldType: selectedField.fieldType,
            fieldDescription: selectedField.fieldDescription,
            operators: selectedField.operators,
            fieldTypeDisplayName: selectedField.fieldTypeDisplayName,
            isDuplicated: false,
            shouldShowInContext: true
        };
        return map;
    }, {});
    const [fieldsWithHydration, fieldsMissingHydration] = (0, (/*@__PURE__*/$parcel$interopDefault($ifg6x)))(allFields, (fieldId)=>fieldsData[fieldId] ?? selectedFieldsData[fieldId]);
    // Generate fields to render
    const optionalFieldsToRender = fieldsWithHydration.filter((fieldId)=>!excludedFields.includes(fieldId)).map((fieldId)=>{
        const fieldData = fieldsData[fieldId] ?? selectedFieldsData[fieldId];
        const { isDuplicated: isDuplicated, searchTemplate: searchTemplate, fieldType: fieldType, displayName: displayName, fieldDescription: fieldDescription, operators: operators, fieldTypeDisplayName: fieldTypeDisplayName, shouldShowInContext: shouldShowInContext } = fieldData;
        const fieldToRender = {
            fieldId: fieldId,
            fieldLabel: displayName ?? undefined,
            fieldDescription: fieldDescription,
            fieldTypeDisplayName: fieldTypeDisplayName,
            shouldShowInContext: shouldShowInContext,
            // We want only to show non-duplicated fieldIds/jqlTerms
            ...isDuplicated ? {
                picker: (0, $i0Cp4.getUnsupportedPickerType)({
                    searchTemplate: searchTemplate,
                    fieldType: fieldType
                }),
                clause: undefined,
                secondaryClause: undefined
            } : {
                picker: (0, $i0Cp4.getPickerType)({
                    searchTemplate: searchTemplate,
                    fieldType: fieldType,
                    operators: operators
                }),
                clause: clausesByFieldId[fieldId],
                secondaryClause: secondaryClausesByFieldId[fieldId]
            }
        };
        return fieldToRender;
    });
    return {
        optionalFieldsToRender: optionalFieldsToRender,
        fieldsMissingHydration: fieldsMissingHydration
    };
};
/**
 * getIrremovableFieldsToRender
 */ const $c6d9a58efc4e5979$var$getIrremovableFieldsToRender = ({ clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId, excludedFields: excludedFields, irremovableFields: irremovableFields })=>{
    const irremovableFieldsToRender = [];
    irremovableFields.forEach((irremovableField)=>{
        const isIrremovableFieldConfiguredAsExcludedField = excludedFields.includes(irremovableField.jqlTerm);
        if (!isIrremovableFieldConfiguredAsExcludedField) irremovableFieldsToRender.push({
            isIrremovable: true,
            fieldId: irremovableField.jqlTerm,
            fieldLabel: irremovableField.displayName,
            picker: (0, $i0Cp4.getPickerType)({
                searchTemplate: irremovableField.searchTemplate,
                fieldType: irremovableField.fieldType,
                operators: irremovableField.operators
            }),
            fieldDescription: null,
            fieldTypeDisplayName: null,
            clause: clausesByFieldId[irremovableField.jqlTerm],
            secondaryClause: secondaryClausesByFieldId[irremovableField.jqlTerm]
        });
    });
    return irremovableFieldsToRender;
};
const $c6d9a58efc4e5979$export$af0604ea1b6b60ec = ({ selectedFields: selectedFields, excludedFields: excludedFields = [], intl: intl, fieldsHydratedData: fieldsHydratedData, previousFieldToRender: previousFieldToRender = [], irremovableFields: irremovableFields, astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId })=>{
    const { optionalFieldsToRender: optionalFieldsToRender, fieldsMissingHydration: fieldsMissingHydration } = $c6d9a58efc4e5979$var$getOptionalFieldsToRender({
        astClauseOrder: astClauseOrder,
        clausesByFieldId: clausesByFieldId,
        fieldsData: $c6d9a58efc4e5979$var$getDataFromHydratedData({
            fieldsHydratedData: fieldsHydratedData
        }),
        secondaryClausesByFieldId: secondaryClausesByFieldId,
        selectedFields: selectedFields,
        excludedFields: excludedFields
    });
    const fieldsToRender = $c6d9a58efc4e5979$var$getIrremovableFieldsToRender({
        clausesByFieldId: clausesByFieldId,
        secondaryClausesByFieldId: secondaryClausesByFieldId,
        excludedFields: excludedFields,
        intl: intl,
        irremovableFields: irremovableFields
    }).concat(optionalFieldsToRender);
    const missingHydration = fieldsMissingHydration.length > 0;
    /**
   * Keep order of fields in the more dropdown if order is provided
   * We use the order array to sort the fieldsToRender adding any new fields at the end
   * and then remove all the fields that doesn't exist anymore in the new fieldsToRender
   */ let sortedFieldsToRender = fieldsToRender;
    if (previousFieldToRender.length > 0) {
        const previousFieldToRendeFieldIds = previousFieldToRender.map((field)=>field.fieldId);
        sortedFieldsToRender = (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(fieldsToRender, (fieldToRender)=>{
            const index = previousFieldToRendeFieldIds.indexOf(fieldToRender.fieldId);
            return index === -1 ? previousFieldToRendeFieldIds.length : index;
        });
    }
    return {
        fieldsToRender: sortedFieldsToRender,
        optionalFieldsCount: astClauseOrder.length,
        missingHydration: missingHydration
    };
};
const $c6d9a58efc4e5979$export$2965c0f6ab2d5c39 = ({ excludedFields: excludedFields = [], intl: intl, irremovableFields: irremovableFields, astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId })=>{
    const fieldsToRender = $c6d9a58efc4e5979$var$getIrremovableFieldsToRender({
        clausesByFieldId: clausesByFieldId,
        secondaryClausesByFieldId: secondaryClausesByFieldId,
        excludedFields: excludedFields,
        intl: intl,
        irremovableFields: irremovableFields
    });
    return {
        fieldsToRender: fieldsToRender,
        optionalFieldsCount: astClauseOrder.length,
        missingHydration: true
    };
};

});
parcelRegister("7qDUb", function(module, exports) {

var $ekcP3 = parcelRequire("ekcP3");

var $kE90z = parcelRequire("kE90z");

var $g7i7g = parcelRequire("g7i7g");

var $4rDUz = parcelRequire("4rDUz");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $5689ea6dce44e1ca$var$sortBy = $g7i7g(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $4rDUz(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $4rDUz(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $kE90z(collection, $ekcP3(iteratees, 1), []);
});
module.exports = $5689ea6dce44e1ca$var$sortBy;

});
parcelRegister("kE90z", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $fTwLR = parcelRequire("fTwLR");

var $bxDef = parcelRequire("bxDef");

var $jXnVG = parcelRequire("jXnVG");

var $iWpGN = parcelRequire("iWpGN");

var $cW28x = parcelRequire("cW28x");

var $4pePQ = parcelRequire("4pePQ");

var $etyzk = parcelRequire("etyzk");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $f07e87ec0cad1451$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $1nIHN(iteratees, function(iteratee) {
        if ($8LQ84(iteratee)) return function(value) {
            return $fTwLR(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $etyzk
    ];
    var index = -1;
    iteratees = $1nIHN(iteratees, $cW28x($bxDef));
    var result = $jXnVG(collection, function(value, key, collection) {
        var criteria = $1nIHN(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $iWpGN(result, function(object, other) {
        return $4pePQ(object, other, orders);
    });
}
module.exports = $f07e87ec0cad1451$var$baseOrderBy;

});
parcelRegister("jXnVG", function(module, exports) {

var $e7pfQ = parcelRequire("e7pfQ");

var $hTJwX = parcelRequire("hTJwX");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e87616de80329acf$var$baseMap(collection, iteratee) {
    var index = -1, result = $hTJwX(collection) ? Array(collection.length) : [];
    $e7pfQ(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $e87616de80329acf$var$baseMap;

});

parcelRegister("iWpGN", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $dca1921d42c9de26$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $dca1921d42c9de26$var$baseSortBy;

});

parcelRegister("4pePQ", function(module, exports) {

var $7JssJ = parcelRequire("7JssJ");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $3355012d40661daa$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $7JssJ(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $3355012d40661daa$var$compareMultiple;

});
parcelRegister("7JssJ", function(module, exports) {

var $4faK3 = parcelRequire("4faK3");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $5a12d0703028d451$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $4faK3(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $4faK3(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $5a12d0703028d451$var$compareAscending;

});





parcelRegister("f1i4L", function(module, exports) {

$parcel$export(module.exports, "getAstSortFields", () => $3c27ae72e6f3583d$export$dcd0fae6e8b9823a);
const $3c27ae72e6f3583d$export$dcd0fae6e8b9823a = (ast)=>{
    if (ast && ast.query && ast.query.orderBy) return ast.query.orderBy.fields.map((orderByFieldFromAst)=>({
            jqlTerm: orderByFieldFromAst.field.value,
            direction: orderByFieldFromAst.direction ? orderByFieldFromAst.direction.value : undefined
        }));
    return [];
};

});



parcelRegister("kbf73", function(module, exports) {

let $eb108ecaf3ff02aa$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $eb108ecaf3ff02aa$var$load("kfXhT"),
    $eb108ecaf3ff02aa$var$load("2Lfdl"),
    $eb108ecaf3ff02aa$var$load("h2MrD"),
    $eb108ecaf3ff02aa$var$load("bYT2S"),
    $eb108ecaf3ff02aa$var$load("3ZBUM")
]).then(()=>parcelRequire('kWbha'));

});


parcelRegister("5UgV1", function(module, exports) {

$parcel$export(module.exports, "AdvancedEditorWrapper", () => $9c2110d772356245$export$500c96524dd0cfc7);
$parcel$export(module.exports, "BeforeJqlBuilderContainer", () => $9c2110d772356245$export$c139d55dec6a3c8a);
$parcel$export(module.exports, "BeforeJqlBuilderListItemContainer", () => $9c2110d772356245$export$4245b33623eb8df4);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $2s57o = parcelRequire("2s57o");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");
const $9c2110d772356245$export$500c96524dd0cfc7 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        xcss: [
            $9c2110d772356245$var$negativeMarginOffsetStyles,
            $9c2110d772356245$var$advancedEditorWrapperStyles
        ]
    }, children);
const $9c2110d772356245$export$c139d55dec6a3c8a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $9c2110d772356245$var$negativeMarginOffsetStyles
    }, children);
const $9c2110d772356245$export$4245b33623eb8df4 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "li",
        xcss: [
            $9c2110d772356245$var$negativeMarginOffsetStyles,
            (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_4') ? $9c2110d772356245$var$beforeJqlBuilderListItemContainer : $9c2110d772356245$var$beforeJqlBuilderListItemContainerOld
        ]
    }, children);
const $9c2110d772356245$var$negativeMarginOffsetStyles = (0, $2s57o.xcss)({
    marginBlock: 'space.050',
    marginLeft: 'space.0',
    marginRight: 'space.100'
});
const $9c2110d772356245$var$advancedEditorWrapperStyles = (0, $2s57o.xcss)({
    flexGrow: 1
});
const $9c2110d772356245$var$beforeJqlBuilderListItemContainerOld = (0, $2s57o.xcss)({
    listStyle: 'none',
    marginRight: 'space.050'
});
const $9c2110d772356245$var$beforeJqlBuilderListItemContainer = (0, $2s57o.xcss)({
    listStyle: 'none',
    marginRight: 'space.050',
    marginLeft: 'space.050'
});

});

parcelRegister("3fufq", function(module, exports) {

$parcel$export(module.exports, "SearchModeSwitcher", () => $f745ad211a5a5809$export$639730063e548c7);
$parcel$export(module.exports, "SearchModeSwitcherWithTarget", () => $f745ad211a5a5809$export$ed9a97307608e2d9);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $5KCCi = parcelRequire("5KCCi");

var $koVbs = parcelRequire("koVbs");

var $5Czte = parcelRequire("5Czte");

var $1aUn4 = parcelRequire("1aUn4");

var $dCm1o = parcelRequire("dCm1o");

var $032ey = parcelRequire("032ey");

var $16gY8 = parcelRequire("16gY8");
const $f745ad211a5a5809$export$639730063e548c7 = ({ isBasicModeDisabled: isBasicModeDisabled, onUpdateSearchMode: onUpdateSearchMode, searchMode: searchMode })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const testIdPrefix = 'issue-navigator.ui.refinement-bar.search-mode-switcher.toggle-button.';
    const basicModeLabel = (0, $5uXOq.useMemo)(()=>{
        if ((0, $dCm1o.isVisualRefreshEnabled)()) return isBasicModeDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
            content: formatMessage((0, $16gY8.messages).basicModeDisabledTooltip),
            tag: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            as: "span",
            xcss: $f745ad211a5a5809$var$labelStyles,
            color: "inherit"
        }, formatMessage((0, $16gY8.messages).basicMode))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            as: "span",
            xcss: $f745ad211a5a5809$var$labelStyles,
            color: "inherit"
        }, formatMessage((0, $16gY8.messages).basicMode));
        return isBasicModeDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
            content: formatMessage((0, $16gY8.messages).basicModeDisabledTooltip),
            tag: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
            size: "UNSAFE_small",
            weight: "semibold",
            color: "inherit"
        }, formatMessage((0, $16gY8.messages).basicMode))) : formatMessage((0, $16gY8.messages).basicMode);
    }, [
        formatMessage,
        isBasicModeDisabled
    ]);
    const options = [
        {
            id: (0, $032ey.SEARCH_MODE_BASIC),
            label: basicModeLabel,
            isDisabled: isBasicModeDisabled,
            testId: `${testIdPrefix}${(0, $032ey.SEARCH_MODE_BASIC)}`
        },
        {
            id: (0, $032ey.SEARCH_MODE_ADVANCED),
            label: (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                as: "span",
                xcss: $f745ad211a5a5809$var$labelStyles,
                color: "inherit"
            }, formatMessage((0, $16gY8.messages).advancedMode)) : formatMessage((0, $16gY8.messages).advancedMode),
            testId: `${testIdPrefix}${(0, $032ey.SEARCH_MODE_ADVANCED)}`
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1aUn4.default), {
        label: formatMessage((0, $16gY8.messages).label),
        options: options,
        selectedOption: searchMode,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange: (value)=>onUpdateSearchMode(value)
    });
};
const $f745ad211a5a5809$export$ed9a97307608e2d9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Czte.NinChangeboardingTourTarget), {
        engagementId: "nin.jql-builder.searchmode-switcher"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f745ad211a5a5809$export$639730063e548c7, props));
const $f745ad211a5a5809$var$labelStyles = (0, $2s57o.xcss)({
    font: 'font.body'
});

});
parcelRegister("5Czte", function(module, exports) {

$parcel$export(module.exports, "NinChangeboardingContext", () => $56f2750f0b6ae1db$export$b349f970aff316d8);
$parcel$export(module.exports, "EnableNinChangeboardingProvider", () => $56f2750f0b6ae1db$export$dd1deacfc61c978a);
$parcel$export(module.exports, "NinChangeboardingTourTarget", () => $56f2750f0b6ae1db$export$eb95770b90ecc1f3);
$parcel$export(module.exports, "NinChangeboardingTourCard", () => $56f2750f0b6ae1db$export$7c27d65549066b5);
$parcel$export(module.exports, "useGlobalScopeOptInFlag", () => $56f2750f0b6ae1db$export$9e9f507adee88e58);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $5Zxxp = parcelRequire("5Zxxp");

var $eNf8a = parcelRequire("eNf8a");

var $4R6GH = parcelRequire("4R6GH");

var $1oOi0 = parcelRequire("1oOi0");

var $fB2N8 = parcelRequire("fB2N8");

var $6s4Eg = parcelRequire("6s4Eg");

var $eiUE8 = parcelRequire("eiUE8");
// TODO: JFP-2237 Add prefix for session storage provider
const $56f2750f0b6ae1db$var$sessionStorageProvider = (0, $eNf8a.createSessionStorageProvider)('');
const $56f2750f0b6ae1db$export$b349f970aff316d8 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const $56f2750f0b6ae1db$export$dd1deacfc61c978a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($56f2750f0b6ae1db$export$b349f970aff316d8.Provider, {
        value: true
    }, children);
const $56f2750f0b6ae1db$export$eb95770b90ecc1f3 = ({ children: children, engagementId: engagementId })=>{
    const isTourEnabled = (0, $5uXOq.useContext)($56f2750f0b6ae1db$export$b349f970aff316d8);
    if (!isTourEnabled) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6s4Eg.default), {
        engagementId: engagementId
    }, children);
};
const $56f2750f0b6ae1db$export$7c27d65549066b5 = ({ mode: mode, view: view, hasIssueResults: hasIssueResults, isAiEnabled: isAiEnabled })=>{
    const isTourEnabled = (0, $5uXOq.useContext)($56f2750f0b6ae1db$export$b349f970aff316d8);
    if (!isTourEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fB2N8.AsyncSpotlightCard), {
        mode: mode,
        view: view,
        hasIssueResults: hasIssueResults,
        isAiEnabled: isAiEnabled
    });
};
const $56f2750f0b6ae1db$export$9e9f507adee88e58 = ()=>{
    const isFlagEnabled = (0, $5uXOq.useContext)($56f2750f0b6ae1db$export$b349f970aff316d8);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const onOpenInProductHelpArticle = (0, $5Zxxp.useHelpPanelLink)();
    const onLearnMore = (0, $5uXOq.useCallback)(()=>{
        onOpenInProductHelpArticle((0, $1oOi0.LEARN_MORE_IPH_ARTICLE_ID));
    }, [
        onOpenInProductHelpArticle
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const shouldShowOptInFlag = (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $56f2750f0b6ae1db$var$sessionStorageProvider.get('showNinOptInFlag') : sessionStorage.getItem('showNinOptInFlag');
        if (isFlagEnabled && shouldShowOptInFlag === 'true') {
            showFlag({
                type: 'success',
                title: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eiUE8.default).successOptInTitleIssueTermRefresh : (0, $eiUE8.default).successOptInTitle,
                description: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eiUE8.default).successOptInDescIssueTermRefresh : (0, $eiUE8.default).successOptInDesc,
                messageId: 'issue-navigator-changeboarding.controllers.enable-nin-changeboarding.show-flag.success',
                messageType: 'transactional',
                actions: [
                    {
                        content: (0, $eiUE8.default).successActionLearnMoreLink,
                        onClick: onLearnMore
                    }
                ],
                isAutoDismiss: false,
                testId: 'issue-navigator-changeboarding.optin-success-flag'
            });
            (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $56f2750f0b6ae1db$var$sessionStorageProvider.remove('showNinOptInFlag') : sessionStorage.removeItem('showNinOptInFlag');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});
parcelRegister("1oOi0", function(module, exports) {

$parcel$export(module.exports, "FALLBACK_SUPPORT_ARTICLE", () => $43fa307c6841ead5$export$ff66aa7a4971d979);
$parcel$export(module.exports, "LEARN_MORE_IPH_ARTICLE_ID", () => $43fa307c6841ead5$export$88d16e35389ab3c6);
$parcel$export(module.exports, "getEngagementPlatformlMessageId", () => $43fa307c6841ead5$export$91074f0ada4f4533);
$parcel$export(module.exports, "TOUR_MESSAGE_ID", () => $43fa307c6841ead5$export$4ac775bda929f47);
$parcel$export(module.exports, "views", () => $43fa307c6841ead5$export$d0079916fe6800ac);
const $43fa307c6841ead5$export$ff66aa7a4971d979 = 'https://support.atlassian.com/jira-software-cloud/docs/search-for-issues-in-jira/';
const $43fa307c6841ead5$export$88d16e35389ab3c6 = '3FGQv6n7fB93yWWTYqY0hq';
const $43fa307c6841ead5$export$91074f0ada4f4533 = (id)=>`${id}-march2024`;
const $43fa307c6841ead5$export$4ac775bda929f47 = 'nin-changeboarding-start';
const $43fa307c6841ead5$export$6c69c3d1b5f6fe55 = {
    basic: 'basic',
    advanced: 'advanced'
};
const $43fa307c6841ead5$export$d0079916fe6800ac = {
    list: 'list-view',
    detail: 'split-view'
};

});

parcelRegister("fB2N8", function(module, exports) {

$parcel$export(module.exports, "AsyncSpotlightCard", () => $a20090c0d2e5eb6a$export$40e85aa59c198f98);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a20090c0d2e5eb6a$var$SpotlightCard = (0, $b7Svb.lazy)(// we want both these types of spotlights to be within the same webpack chunk
()=>(parcelRequire("bLMke")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/common/ui/spotlight/spotlight-card/index.tsx"
});
const $a20090c0d2e5eb6a$export$40e85aa59c198f98 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-spotlight-card",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-spotlight-card",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a20090c0d2e5eb6a$var$SpotlightCard, props)));

});
parcelRegister("bLMke", function(module, exports) {

let $891991ea709cf5b1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $891991ea709cf5b1$var$load("epMgw").then(()=>parcelRequire('dqR1S'));

});


parcelRegister("6s4Eg", function(module, exports) {

$parcel$export(module.exports, "default", () => $60c5b26aae55f177$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $Pxnvj = parcelRequire("Pxnvj");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $60c5b26aae55f177$var$EngagementSpotlightAsync = (0, $b7Svb.lazy)(()=>(parcelRequire("k6TGR")).then(({ EngagementSpotlight: EngagementSpotlight })=>EngagementSpotlight), {
    ssr: false,
    moduleId: "../platform/packages/personalization/engagekit-ts/src/index.ts"
});
const $60c5b26aae55f177$var$SpotlightTourTarget = ({ children: children, engagementId: engagementId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
        name: engagementId
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-engagement-spotlight",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-engagement-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60c5b26aae55f177$var$EngagementSpotlightAsync, {
        engagementId: engagementId
    }))));
var $60c5b26aae55f177$export$2e2bcd8739ae039 = $60c5b26aae55f177$var$SpotlightTourTarget;

});
parcelRegister("k6TGR", function(module, exports) {

let $ea3f91245a7f28ef$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ea3f91245a7f28ef$var$load("h2MrD"),
    $ea3f91245a7f28ef$var$load("bYT2S"),
    $ea3f91245a7f28ef$var$load("cM9em"),
    $ea3f91245a7f28ef$var$load("fr9NE"),
    $ea3f91245a7f28ef$var$load("gD37G")
]).then(()=>parcelRequire('5I0u5'));

});


parcelRegister("eiUE8", function(module, exports) {

$parcel$export(module.exports, "default", () => $172614e7cfb99d43$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $172614e7cfb99d43$var$messages = (0, $7VHMR.defineMessages)({
    successOptInTitle: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title",
        "defaultMessage": "You've switched to the new issue search"
    },
    successOptInDesc: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc",
        "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for issues across Jira."
    },
    successActionLearnMoreLink: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-action-learn-more-link",
        "defaultMessage": "Learn more"
    },
    successOptInTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title-issue-term-refresh",
        "defaultMessage": "You've switched to the new search"
    },
    successOptInDescIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc-issue-term-refresh",
        "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for work across Jira."
    }
});
var $172614e7cfb99d43$export$2e2bcd8739ae039 = $172614e7cfb99d43$var$messages;

});


parcelRegister("1aUn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3938a8ce9ce3c5ba$export$2e2bcd8739ae039);

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $gxBa7 = parcelRequire("gxBa7");

var $1AOfx = parcelRequire("1AOfx");
var $3938a8ce9ce3c5ba$export$2e2bcd8739ae039 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), (0, $gxBa7.ToggleButtons), (0, $1AOfx.default));

});
parcelRegister("gxBa7", function(module, exports) {

$parcel$export(module.exports, "ToggleButtons", () => $37715556557e12b9$export$34301fadafd0cd9d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $gVM6m = parcelRequire("gVM6m");
var $2s57o = parcelRequire("2s57o");
const $37715556557e12b9$export$34301fadafd0cd9d = ({ options: options, selectedOption: selectedOption, onChange: onChange, label: label, isCompact: isCompact })=>{
    const getButtonWithContext = (0, $5uXOq.useCallback)(({ option: option, isSelected: isSelected })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $gVM6m.default), {
            role: "radio",
            "aria-checked": isSelected,
            xcss: [
                $37715556557e12b9$var$baseStyles,
                !isCompact && $37715556557e12b9$var$wideStyles,
                isSelected && $37715556557e12b9$var$selectedStyles
            ],
            onClick: (event, analyticsEvent)=>!isSelected && onChange(option.id, event, analyticsEvent),
            isDisabled: option.isDisabled,
            testId: option.testId,
            interactionName: option.interactionName,
            children: option.label
        }, option.id), [
        onChange,
        isCompact
    ]);
    return(// eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
        role: "radiogroup",
        xcss: $37715556557e12b9$var$containerStyles,
        "aria-label": label,
        as: "fieldset",
        children: options.map((option)=>getButtonWithContext({
                option: option,
                isSelected: option.id === selectedOption
            }))
    }));
};
const $37715556557e12b9$var$containerStyles = (0, $2s57o.xcss)({
    borderColor: 'color.border',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: "var(--ds-border-radius-100, 4px)",
    paddingInline: 'space.025',
    gap: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    height: '2rem'
});
const $37715556557e12b9$var$baseStyles = (0, $2s57o.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    border: '1px solid transparent',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    color: 'color.text.subtle',
    height: '26px',
    fontWeight: 'font.weight.medium',
    padding: 'space.0',
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: 'color.text.subtle'
    },
    ':focus': {
        outlineOffset: 'space.0'
    },
    ':disabled': {
        background: "var(--ds-background-disabled, #091E4208)",
        color: 'color.text.disabled'
    }
});
const $37715556557e12b9$var$selectedStyles = (0, $2s57o.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    border: `1px solid ${"var(--ds-border-selected, #0C66E4)"}`,
    color: 'color.text.selected',
    cursor: 'default',
    ':hover': {
        background: "var(--ds-background-selected, #E9F2FF)",
        color: 'color.text.selected'
    }
});
const $37715556557e12b9$var$wideStyles = (0, $2s57o.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.150'
});

});

parcelRegister("1AOfx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3d0d9bc4668d1db$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");

var $iR4uK = parcelRequire("iR4uK");

var $gmQXa = parcelRequire("gmQXa");
let $b3d0d9bc4668d1db$var$uniqueId = 0;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3d0d9bc4668d1db$export$2e2bcd8739ae039 = ({ label: label, options: options, selectedOption: selectedOption, onChange: onChange })=>{
    (0, $gmQXa.assertPrecondition)(()=>({
            precondition: options.length > 0,
            message: `ToggleButtons requires at least one option, but received ${options.length}`
        }));
    (0, $gmQXa.assertPrecondition)(()=>({
            precondition: (0, $gmQXa.findDuplicateIds)(options) === null,
            message: `ToggleButtons requires that every option has a unique ID, but received "${(0, $gmQXa.findDuplicateIds)(options)}" multiple times`
        }));
    (0, $gmQXa.assertPrecondition)(()=>({
            precondition: options.findIndex((option)=>option.id === selectedOption) !== -1,
            message: `ToggleButtons requires that the selectedOption matches the ID of one of the passed options, but "${selectedOption}" did not`
        }));
    const [id] = (0, $5uXOq.useState)(()=>`toggle-buttons-${$b3d0d9bc4668d1db$var$uniqueId++}`);
    const fieldsetRef = (0, $5uXOq.useRef)(null);
    const selectedOptionRef = (0, $5uXOq.useRef)();
    const [selectedOptionPosition, setSelectedOptionPosition] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        const fieldset = fieldsetRef.current;
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function, jira/jira-ssr/no-unchecked-globals-usage
        if (!fieldset || !window.ResizeObserver) return ()=>{};
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resizeObserver = new window.ResizeObserver(()=>{
            const element = selectedOptionRef.current;
            if (element) setSelectedOptionPosition({
                left: element.offsetLeft,
                top: element.offsetTop,
                width: element.offsetWidth,
                height: element.offsetHeight
            });
        });
        resizeObserver.observe(fieldset);
        return ()=>{
            resizeObserver.unobserve(fieldset);
        };
    }, [
        selectedOption
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3d0d9bc4668d1db$var$Fieldset, {
        ref: fieldsetRef,
        selectedOptionPosition: selectedOptionPosition
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("legend", null, label), options.map((option)=>{
        const isChecked = selectedOption === option.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iR4uK.default), {
            key: option.id,
            name: id,
            value: option.id,
            isChecked: isChecked,
            isDisabled: !!option.isDisabled,
            onChange: onChange,
            // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown> | undefined' is not assignable to type 'Ref<OptionProps> | undefined'.
            ref: isChecked ? selectedOptionRef : undefined,
            testId: option.testId
        }, option.label);
    }));
};
// The !important rules are required so that we can use this mixin on selectors
// with arbitrary specificity
const $b3d0d9bc4668d1db$var$selectedOptionIndicator = {
    backgroundColor: `${"var(--ds-background-accent-gray-subtler, #DCDFE4)"} !important`,
    borderRadius: `${(0, $gwIPs.borderRadius)}px !important`
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3d0d9bc4668d1db$var$Fieldset = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "fieldset", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedOptionPosition: selectedOptionPosition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ozn9do": (0, $lD23V.default)(__cmplp.selectedOptionPosition?.left, "px"),
            "--_1ibdxcf": (0, $lD23V.default)(__cmplp.selectedOptionPosition?.top, "px"),
            "--_1ggrzjo": (0, $lD23V.default)(__cmplp.selectedOptionPosition?.width, "px"),
            "--_1797z6d": (0, $lD23V.default)(__cmplp.selectedOptionPosition?.height, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _11c8dcr7 _1e0c1txw _1n261g80 _1bsb1ris _p12f1osq _kqswh2mm _bfhkm7j4 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _k48p1pd9 _1p1dangw _syaz1fxt _1jdg1n1a _z71v1n1a _1o5t1n1a _irrs1n1a _p8t715vq _b4u715vq _1qiiidpf _12o6idpf _19mbidpf _1ob8idpf _1r9t7mnp _ho6m1wmp _soiet94y _1se6t94y _1jhnstnw _10bvh2mm _1nvfze3t _1nei1b66 _rt2pze3t _bmksze3t _fhioidpf _1kt9b3bt _1cs8stnw _rfx31wa3 _1rusksj1 _qs2z1l1k _1cg61yx9 _mlfedkwg",
            __cmplp.selectedOptionPosition ? "_cfu11ule" : "_cfu1glyw",
            __cmplp.selectedOptionPosition?.left ? "_qnecejz7" : "_qnecidpf",
            __cmplp.selectedOptionPosition?.top ? "_1auk1nuc" : "_1aukidpf",
            __cmplp.selectedOptionPosition?.width ? "_1mp412nj" : "_1mp4idpf",
            __cmplp.selectedOptionPosition?.height ? "_kfgt1d85" : "_kfgtidpf",
            !__cmplp.selectedOptionPosition && "_1ph31wa3 _15e9ksj1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iR4uK", function(module, exports) {

$parcel$export(module.exports, "default", () => $e56adc76929ce8ab$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
var $e56adc76929ce8ab$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ name: name, value: value, isChecked: isChecked, isDisabled: isDisabled, onChange: onChange, children: children, testId: testId }, ref)=>{
    const id = `${name}-${value}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e56adc76929ce8ab$var$Container, {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        type: "radio",
        id: id,
        name: name,
        value: value,
        checked: isChecked,
        disabled: isDisabled,
        "data-testid": testId,
        onChange: (event)=>onChange(value, event)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        htmlFor: id
    }, children));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e56adc76929ce8ab$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2x4g1n1a _12hv1n1a _x5bd1n1a _1rgf1n1a _1yzy15vq _bgrh15vq _v69yidpf _ogxmidpf _1qtqidpf _n9z4idpf _11127mnp _1q091wmp _pytkt94y _5hv9t94y _khufstnw _1ioh1l7b _15pj1ule _d7ff1b66 _1j8612x7 _1qrc1b66 _4yng12x7 _1vzltlke _1hhy73ad _1emz73ad _1efl1lh4 _7el91vm4 _15pqglyw _vrjh166n _c2fy18uv _ynfu18uv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gmQXa", function(module, exports) {

$parcel$export(module.exports, "findDuplicateIds", () => $1d35542953a1be7d$export$e5f5e25214715ca1);
$parcel$export(module.exports, "assertPrecondition", () => $1d35542953a1be7d$export$5565eefbe4b468a0);
const $1d35542953a1be7d$export$e5f5e25214715ca1 = (options)=>{
    for(let i = 0; i < options.length - 1; ++i)for(let j = i + 1; j < options.length; ++j){
        if (options[i].id === options[j].id) return options[i].id;
    }
    return null;
};
const $1d35542953a1be7d$export$5565eefbe4b468a0 = (evaluatePrecondition)=>{};

});



parcelRegister("16gY8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fab52cd589ab817a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $fab52cd589ab817a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    label: {
        "id": "jql-builder.search-mode-switcher.label",
        "defaultMessage": "Select search mode"
    },
    basicModeDisabledTooltip: {
        "id": "jql-builder.search-mode-switcher.basic-mode-disabled-tooltip",
        "defaultMessage": "You can't switch to basic as the query is too complex or is invalid"
    },
    basicMode: {
        "id": "jql-builder.search-mode-switcher.basic-mode",
        "defaultMessage": "Basic"
    },
    advancedMode: {
        "id": "jql-builder.search-mode-switcher.advanced-mode",
        "defaultMessage": "JQL"
    }
});

});


parcelRegister("kdzZz", function(module, exports) {

$parcel$export(module.exports, "DefaultJqlBuilderContainer", () => $5d734fc2527ab532$export$ef9307b2d2a6d612);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");
const $5d734fc2527ab532$export$ef9307b2d2a6d612 = ({ showAdvancedEditor: showAdvancedEditor, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            $5d734fc2527ab532$var$jqlBuilderContainerStyles,
            // eslint-disable-next-line no-nested-ternary
            showAdvancedEditor ? $5d734fc2527ab532$var$jqlBuilderContainerAdvancedStyles : (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_4') ? $5d734fc2527ab532$var$jqlBuilderContainerBasicStyles : $5d734fc2527ab532$var$jqlBuilderContainerBasicStyleOld
        ]
    }, children);
const $5d734fc2527ab532$var$jqlBuilderContainerStyles = (0, $2s57o.xcss)({
    display: 'flex',
    flexGrow: 1
});
const $5d734fc2527ab532$var$jqlBuilderContainerBasicStyleOld = (0, $2s57o.xcss)({
    /* ExtraControls should wrap with refinements when we are NOT in advanced mode */ flexWrap: 'wrap',
    /* Advanced mode has a footer element with a min-height of 20px. When in basic mode, we need to
	  replicate this spacing (20px - negative margin from above) to ensure there is no layout jumping
	  when switching between search modes. */ marginTop: 'space.negative.025',
    marginRight: 'space.negative.050',
    marginBottom: 'space.200',
    marginLeft: 'space.negative.025'
});
const $5d734fc2527ab532$var$jqlBuilderContainerBasicStyles = (0, $2s57o.xcss)({
    /* ExtraControls should wrap with refinements when we are NOT in advanced mode */ flexWrap: 'wrap',
    /* Advanced mode has a footer element with a min-height of 20px. When in basic mode, we need to
      replicate this spacing (20px - negative margin from above) to ensure there is no layout jumping
      when switching between search modes. */ marginTop: 'space.negative.025',
    marginRight: 'space.negative.050',
    marginBottom: 'space.200',
    marginLeft: 'space.negative.050'
});
const $5d734fc2527ab532$var$jqlBuilderContainerAdvancedStyles = (0, $2s57o.xcss)({
    marginTop: 'space.negative.025',
    marginRight: 'space.negative.050',
    marginBottom: 'space.negative.050',
    marginLeft: 'space.negative.025'
});

});

parcelRegister("8xRQz", function(module, exports) {

$parcel$export(module.exports, "SearchModeSwitcherContainer", () => $b50f5561c6df80cb$export$c9785cf59aeeda5f);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $3HwlS = parcelRequire("3HwlS");
const $b50f5561c6df80cb$export$c9785cf59aeeda5f = ({ testId: testId, children: children, isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $b50f5561c6df80cb$var$getContainerXcss(isSearchModeSwitcherOnLeft),
        testId: testId
    }, children);
const $b50f5561c6df80cb$var$getContainerXcss = (isSearchModeSwitcherOnLeft)=>{
    if ((0, $3HwlS.getWillShowNav4)()) {
        if (isSearchModeSwitcherOnLeft) return [
            $b50f5561c6df80cb$var$searchModeSwitcherBaseContainerStyle
        ];
        return [
            $b50f5561c6df80cb$var$searchModeSwitcherBaseContainerStyle,
            $b50f5561c6df80cb$var$searchModeSwitcherRightAlignedContainerStyle
        ];
    }
    return [
        $b50f5561c6df80cb$var$searchModeSwitcherContainerStyle
    ];
};
const $b50f5561c6df80cb$var$searchModeSwitcherBaseContainerStyle = (0, $2s57o.xcss)({
    alignSelf: 'start',
    // The toggle container is inline aligned with the JQL editor, and needs to match the height to avoid any misalignment along the horizontal axis
    // However, prior to this change, it only matched the height because some of the content coincidentally matched the height of the left side elements
    // The following two styles will fix that height to match the JQL editor, and align the items to the vertical center
    minHeight: "var(--ds-space-400, 32px)",
    display: 'flex'
});
const $b50f5561c6df80cb$var$searchModeSwitcherRightAlignedContainerStyle = (0, $2s57o.xcss)({
    marginTop: 'space.025',
    marginLeft: 'space.100'
});
const $b50f5561c6df80cb$var$searchModeSwitcherContainerStyle = (0, $2s57o.xcss)({
    marginLeft: 'space.100',
    alignSelf: 'start',
    marginTop: 'space.025',
    // The toggle container is inline aligned with the JQL editor, and needs to match the height to avoid any misalignment along the horizontal axis
    // However, prior to this change, it only matched the height because some of the content coincidentally matched the height of the left side elements
    // The following two styles will fix that height to match the JQL editor, and align the items to the vertical center
    minHeight: "var(--ds-space-400, 32px)",
    display: 'flex'
});

});

parcelRegister("jX4vm", function(module, exports) {

$parcel$export(module.exports, "Container", () => $3048b7aecf50a50c$export$42a852a2b6b56249);
$parcel$export(module.exports, "BasicEditorListContainer", () => $3048b7aecf50a50c$export$5937a18186f4570f);
$parcel$export(module.exports, "AdvancedEditorWrapperOld", () => $3048b7aecf50a50c$export$806411edd2f9cae);
$parcel$export(module.exports, "Divider", () => $3048b7aecf50a50c$export$2e0a83ec2e27ecbb);
$parcel$export(module.exports, "BeforeJqlBuilderContainerOld", () => $3048b7aecf50a50c$export$73fdb9b5d8c2be74);
$parcel$export(module.exports, "BeforeJqlBuilderListItemContainerOld", () => $3048b7aecf50a50c$export$8f3efeb4a3e584ee);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $3048b7aecf50a50c$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $3048b7aecf50a50c$export$5937a18186f4570f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _16jlkb7n _1n261g80 _rcujidpf _o81cidpf _1l6uidpf _149midpf",
            __cmplp.className
        ])
    });
});
const $3048b7aecf50a50c$var$negativeMarginOffsetStyles = {
    /* Parent EditorContainer has a negative margin to offset the margin of refinement bar controls. So now we need to
     offset the parent container negative margin to ensure UI controls are aligned properly. */ margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
};
const $3048b7aecf50a50c$export$806411edd2f9cae = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s89ng6 _1e0c1txw _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $3048b7aecf50a50c$export$2e0a83ec2e27ecbb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1kl7zgxb _1e0c1txw _4cvr1h6o _4t3izwfg _19pk1b66 _18u01b66 _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _vchhusvi",
            __cmplp.className
        ])
    });
});
const $3048b7aecf50a50c$export$73fdb9b5d8c2be74 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s89ng6",
            __cmplp.className
        ])
    });
});
const $3048b7aecf50a50c$export$8f3efeb4a3e584ee = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s89ng6 _qtt8glyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("g9ghO", function(module, exports) {

$parcel$export(module.exports, "default", () => $88f954ca0498c9f0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dCm1o = parcelRequire("dCm1o");

var $jX4vm = parcelRequire("jX4vm");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $88f954ca0498c9f0$var$StyledChild = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $88f954ca0498c9f0$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jlidpf _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $88f954ca0498c9f0$var$ExtraControls = ({ searchMode: searchMode, renderExtraControls: renderExtraControls, shouldUseListMarkup: shouldUseListMarkup })=>{
    const extraControls = (0, $5uXOq.useMemo)(()=>renderExtraControls(), [
        renderExtraControls
    ]);
    const shouldApplyVisualRefreshChanges = (0, $dCm1o.isVisualRefreshEnabled)();
    const content = shouldUseListMarkup ? extraControls.map((Component, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88f954ca0498c9f0$var$StyledChild, {
            key: index
        }, index === 0 && !shouldApplyVisualRefreshChanges && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jX4vm.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            searchMode: searchMode
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88f954ca0498c9f0$var$Container, null, !shouldApplyVisualRefreshChanges && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jX4vm.Divider), null), extraControls.map((Component, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            key: index,
            searchMode: searchMode
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, extraControls.length > 0 && content);
};
var $88f954ca0498c9f0$export$2e2bcd8739ae039 = $88f954ca0498c9f0$var$ExtraControls;

});


parcelRegister("gFE9c", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderUIImplOld", () => $6173244194fe7b03$export$8d394b0b8f88059a);
$parcel$export(module.exports, "JQLBuilderUIImpl", () => $6173244194fe7b03$export$d33754885f040153);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $3KEIl = parcelRequire("3KEIl");
var $7Yg6F = parcelRequire("7Yg6F");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $5Czte = parcelRequire("5Czte");

var $isD5C = parcelRequire("isD5C");

var $imju0 = parcelRequire("imju0");

var $7ckRQ = parcelRequire("7ckRQ");

var $8vNru = parcelRequire("8vNru");

var $caSpf = parcelRequire("caSpf");

var $8q1vb = parcelRequire("8q1vb");

var $bpjJS = parcelRequire("bpjJS");

var $512eM = parcelRequire("512eM");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $bngFq = parcelRequire("bngFq");

var $imS60 = parcelRequire("imS60");

var $dCm1o = parcelRequire("dCm1o");

var $6s1PB = parcelRequire("6s1PB");

var $dJl1T = parcelRequire("dJl1T");

var $032ey = parcelRequire("032ey");

var $5UgV1 = parcelRequire("5UgV1");

var $kdzZz = parcelRequire("kdzZz");

var $1PKzp = parcelRequire("1PKzp");

var $k3Vq9 = parcelRequire("k3Vq9");

var $jX4vm = parcelRequire("jX4vm");

var $g9ghO = parcelRequire("g9ghO");

var $ixr8x = parcelRequire("ixr8x");
const $6173244194fe7b03$export$8d394b0b8f88059a = ({ analyticsSource: analyticsSource, query: query, onSearch: onSearchProp, onUpdate: onUpdate, beforeControls: beforeControls, renderExtraControls: renderExtraControls, isSearching: isSearching, onLoad: onLoad, onReady: onReady, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, jqlMessages: jqlMessages, excludedFields: excludedFields, searchModes: searchModes, selectedSearchMode: selectedSearchMode, hydrationQueryRef: hydrationQueryRef, isHydrating: isHydrating, components: components, hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, searchModeSwitcherLocation: searchModeSwitcherLocation, showOrderByPicker: showOrderByPicker, contextJql: contextJql, loadingModeRef: loadingModeRef, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const jqlDebuggerStoreActions = (0, $6s1PB.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? (0, $512eM.useJqlDebuggerStoreActions)() : undefined;
    const irremovableFieldsAnalyticsAttributes = (0, $7ckRQ.useIrremovableFieldsAnalyticsAttributes)(irremovableFields);
    const { searchMode: searchMode, setSelectedSearchMode: setSelectedSearchMode } = (0, $1PKzp.useSelectedSearchMode)();
    const onPerformanceMark = (0, $caSpf.usePerformanceContext)();
    const onSwitchToJql = (0, $5uXOq.useCallback)(()=>{
        setSelectedSearchMode((0, $032ey.SEARCH_MODE_ADVANCED), true);
    }, [
        setSelectedSearchMode
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const jqlErrors = (jqlMessages || []).filter((e)=>e.type === 'error');
        if (jqlErrors?.length) {
            const errorAnalyticsEvent = createAnalyticsEvent({});
            (0, $jcw0u.default)({
                event: errorAnalyticsEvent,
                meta: {
                    id: 'jqlBuilderJqlInvalid',
                    packageName: 'jiraJqlBuilder',
                    teamName: 'empanada'
                },
                attributes: {
                    queryMode: searchMode
                }
            });
            if (searchMode === (0, $032ey.SEARCH_MODE_BASIC) && (0, $4R6GH.fg)('nin-jql-basic-error-debug-logging-2025-03')) {
                const anonymizedJql = new (0, $3KEIl.JastBuilder)().build(query).query?.accept(new (0, $7Yg6F.JqlAnonymizerVisitor)());
                jqlErrors.forEach((jqlError)=>{
                    const error = new Error(`${jqlError.message}`);
                    // @ts-expect-error - Adding field for additional error logging, the logger still accepts additional fields
                    error.jql = anonymizedJql;
                    (0, $dJl1T.default).unsafeErrorWithCustomerData('jiraJqlBuilderBasic.onDebugUnsafeMessage', `Unexpected JQL error in JQL Builder Basic mode (OLD): ${jqlError.type} - ${jqlError.errorType}.`, error);
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onJqlBuilderAdvancedReady = (0, $5uXOq.useCallback)(()=>{
        onPerformanceMark({
            mark: (0, $8vNru.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_ADVANCED_JS_END
        });
        onReady && onReady((0, $032ey.SEARCH_MODE_ADVANCED));
    }, [
        onPerformanceMark,
        onReady
    ]);
    const onJqlBuilderBasicReady = (0, $5uXOq.useCallback)(()=>{
        onReady && onReady((0, $032ey.SEARCH_MODE_BASIC));
    }, [
        onReady
    ]);
    let onSearch = onSearchProp;
    // Keep onSearch undefined if onSearchProp is not provided, as a defined onSearch
    // will alter the behavior of the advanced JQL editor (e.g. rendering search button)
    if (onSearchProp) onSearch = (jql)=>{
        if ((0, $6s1PB.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false)) jqlDebuggerStoreActions?.resetStatus('ON_NEW_JQL_SEARCH');
        onSearchProp(jql);
        const event = createAnalyticsEvent({
            action: 'submitted',
            actionSubject: 'search'
        });
        (0, $8zOmE.fireUIAnalytics)(event, 'jqlBuilder', {
            searchMode: searchMode
        });
    };
    const { SearchModeSwitcher: SearchModeSwitcher, EditorContainer: CustomEditorContainer } = components ?? {};
    const isSearchModeToggleEnabled = searchModes ? searchModes.length > 1 : true;
    const isSearchModeSwitcherOnLeft = searchModeSwitcherLocation === (0, $032ey.SEARCH_MODE_SWITCHER_LEFT_LOCATION) && (0, $3HwlS.getWillShowNav4)();
    const SearchModeSwitcherComponent = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ixr8x.SearchModeSwitcherRenderer), {
            isSearchModeToggleEnabled: isSearchModeToggleEnabled,
            SearchModeSwitcher: SearchModeSwitcher,
            isHydrating: isHydrating,
            isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft
        }), [
        SearchModeSwitcher,
        isHydrating,
        isSearchModeSwitcherOnLeft,
        isSearchModeToggleEnabled
    ]);
    const BeforeJqlBuilderContainerComponent = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $5UgV1.BeforeJqlBuilderContainer) : (0, $jX4vm.BeforeJqlBuilderContainerOld);
    const BeforeJqlBuilderListItemContainerComponent = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $5UgV1.BeforeJqlBuilderListItemContainer) : (0, $jX4vm.BeforeJqlBuilderListItemContainerOld);
    const AdvancedEditorWrapperComponent = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $5UgV1.AdvancedEditorWrapper) : (0, $jX4vm.AdvancedEditorWrapperOld);
    const Editor = (0, $5uXOq.useMemo)(()=>{
        let jqlBuilderComponent;
        switch(searchMode){
            case 0, $032ey.SEARCH_MODE_BASIC:
                jqlBuilderComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
                    name: "jql-builder-basic"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imju0.JQLBuilderBasicOldAsync), {
                    query: query,
                    // consumers can hide search feature from advanced jql editor by not passing onSearch Handler
                    // if no onSearch handler is passed, Basic JQL editor would fallback to onUpdate handler
                    onSearch: onSearch || onUpdate || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                    onSwitchToJql: onSwitchToJql,
                    excludedFields: excludedFields,
                    onReady: onJqlBuilderBasicReady,
                    onJourneyStart: onJourneyStart,
                    NoOptionComponent: NoOptionComponent,
                    hydrationQueryRef: hydrationQueryRef,
                    isHydrating: isHydrating,
                    shouldUseListMarkup: true,
                    hideOperatorDropdown: hideOperatorDropdownBasicMode,
                    irremovableFields: irremovableFields,
                    hideTextSearchInput: hideTextSearchInput,
                    searchPlaceholder: searchPlaceholder,
                    showOrderByPicker: showOrderByPicker,
                    contextJql: contextJql,
                    ...props
                }));
                break;
            default:
                jqlBuilderComponent = (0, $6s1PB.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
                    name: "jql-builder-advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Czte.NinChangeboardingTourTarget), {
                    engagementId: "nin.jql-builder.advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AdvancedEditorWrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bpjJS.JqlDebuggerJqlBuilderContextProvider), {
                    jqlMessages: jqlMessages,
                    query: query,
                    onSearch: onSearch
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isD5C.default), {
                    analyticsSource: analyticsSource,
                    onSearch: onSearch,
                    onUpdate: onUpdate,
                    query: query,
                    jqlMessages: jqlMessages,
                    isSearching: isSearching,
                    isCompact: true,
                    excludedAutocompleteFields: excludedFields,
                    onReady: onJqlBuilderAdvancedReady,
                    onJourneyStart: onJourneyStart,
                    customComponents: {
                        ErrorMessage: (0, $8q1vb.JQLDebuggerTriggerButton)
                    },
                    ...props
                }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
                    name: "jql-builder-advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Czte.NinChangeboardingTourTarget), {
                    engagementId: "nin.jql-builder.advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AdvancedEditorWrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isD5C.default), {
                    analyticsSource: analyticsSource,
                    onSearch: onSearch,
                    onUpdate: onUpdate,
                    query: query,
                    jqlMessages: jqlMessages,
                    isSearching: isSearching,
                    isCompact: true,
                    excludedAutocompleteFields: excludedFields,
                    onReady: onJqlBuilderAdvancedReady,
                    onJourneyStart: onJourneyStart,
                    ...props
                }))));
        }
        const BeforeJqlBuilderWrapper = searchMode === (0, $032ey.SEARCH_MODE_BASIC) ? BeforeJqlBuilderListItemContainerComponent : BeforeJqlBuilderContainerComponent;
        const showSearchModeSwitcher = (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_4') ? isSearchModeToggleEnabled && isSearchModeSwitcherOnLeft : isSearchModeSwitcherOnLeft;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, beforeControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BeforeJqlBuilderWrapper, null, beforeControls), showSearchModeSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BeforeJqlBuilderWrapper, null, SearchModeSwitcherComponent), jqlBuilderComponent, renderExtraControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g9ghO.default), {
            searchMode: searchMode,
            renderExtraControls: renderExtraControls,
            shouldUseListMarkup: searchMode === (0, $032ey.SEARCH_MODE_BASIC)
        }));
    }, [
        searchMode,
        BeforeJqlBuilderListItemContainerComponent,
        BeforeJqlBuilderContainerComponent,
        beforeControls,
        isSearchModeToggleEnabled,
        isSearchModeSwitcherOnLeft,
        SearchModeSwitcherComponent,
        renderExtraControls,
        query,
        onSearch,
        onUpdate,
        onSwitchToJql,
        excludedFields,
        onJqlBuilderBasicReady,
        onJourneyStart,
        NoOptionComponent,
        hydrationQueryRef,
        isHydrating,
        hideOperatorDropdownBasicMode,
        irremovableFields,
        hideTextSearchInput,
        searchPlaceholder,
        showOrderByPicker,
        contextJql,
        props,
        AdvancedEditorWrapperComponent,
        analyticsSource,
        jqlMessages,
        isSearching,
        onJqlBuilderAdvancedReady
    ]);
    const EffectiveJqlBuilderContainer = CustomEditorContainer ?? (0, $kdzZz.DefaultJqlBuilderContainer);
    return(// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jX4vm.Container), {
        "data-testid": "jql-builder",
        "data-vc": "jql-builder-ui-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EffectiveJqlBuilderContainer, {
        showAdvancedEditor: searchMode === (0, $032ey.SEARCH_MODE_ADVANCED),
        "data-testid": "jql-builder.ui.effective-jql-builder-container"
    }, searchMode === (0, $032ey.SEARCH_MODE_BASIC) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jX4vm.BasicEditorListContainer), {
        "data-vc": "jql-builder-basic-editor-container"
    }, Editor) : Editor), !isSearchModeSwitcherOnLeft && SearchModeSwitcherComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "jqlBuilder",
        attributes: {
            selectedSearchMode: selectedSearchMode,
            queryMode: (0, $032ey.mapSearchModeToAnalyticAtribute)[searchMode],
            ...irremovableFieldsAnalyticsAttributes,
            loadingMode: loadingModeRef.current
        }
    })));
};
const $6173244194fe7b03$export$d33754885f040153 = ({ analyticsSource: analyticsSource, query: query, onSearch: onSearchProp, onUpdate: onUpdate, beforeControls: beforeControls, renderExtraControls: renderExtraControls, isSearching: isSearching, onLoad: onLoad, onReady: onReady, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, jqlMessages: jqlMessages, excludedFields: excludedFields, searchModes: searchModes, selectedSearchMode: selectedSearchMode, hydrationData: hydrationData, components: components, hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, searchModeSwitcherLocation: searchModeSwitcherLocation, showOrderByPicker: showOrderByPicker, contextJql: contextJql, loadingModeRef: loadingModeRef, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const jqlDebuggerStoreActions = (0, $6s1PB.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? (0, $512eM.useJqlDebuggerStoreActions)() : undefined;
    const irremovableFieldsAnalyticsAttributes = (0, $7ckRQ.useIrremovableFieldsAnalyticsAttributes)(irremovableFields);
    const { searchMode: searchMode, setSelectedSearchMode: setSelectedSearchMode } = (0, $1PKzp.useSelectedSearchMode)();
    const { hydrationQueryIsFetching: hydrationQueryIsFetching } = (0, $k3Vq9.useHydrationQuery)();
    const onPerformanceMark = (0, $caSpf.usePerformanceContext)();
    const onSwitchToJql = (0, $5uXOq.useCallback)(()=>{
        setSelectedSearchMode((0, $032ey.SEARCH_MODE_ADVANCED), true);
    }, [
        setSelectedSearchMode
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const jqlErrors = (jqlMessages || []).filter((e)=>e.type === 'error');
        if (jqlErrors?.length) {
            const errorAnalyticsEvent = createAnalyticsEvent({});
            (0, $jcw0u.default)({
                event: errorAnalyticsEvent,
                meta: {
                    id: 'jqlBuilderJqlInvalid',
                    packageName: 'jiraJqlBuilder',
                    teamName: 'empanada'
                },
                attributes: {
                    queryMode: searchMode
                }
            });
            if (searchMode === (0, $032ey.SEARCH_MODE_BASIC) && (0, $4R6GH.fg)('nin-jql-basic-error-debug-logging-2025-03')) {
                const anonymizedJql = new (0, $3KEIl.JastBuilder)().build(query).query?.accept(new (0, $7Yg6F.JqlAnonymizerVisitor)());
                jqlErrors.forEach((jqlError)=>{
                    const error = new Error(`${jqlError.message}`);
                    // @ts-expect-error - Adding field for additional error logging, the logger still accepts additional fields
                    error.jql = anonymizedJql;
                    (0, $dJl1T.default).unsafeErrorWithCustomerData('jiraJqlBuilderBasic.onDebugUnsafeMessage', `Unexpected JQL error in JQL Builder Basic mode: ${jqlError.type} - ${jqlError.errorType}.`, error);
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onJqlBuilderAdvancedReady = (0, $5uXOq.useCallback)(()=>{
        onPerformanceMark({
            mark: (0, $8vNru.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_ADVANCED_JS_END
        });
        onReady && onReady((0, $032ey.SEARCH_MODE_ADVANCED));
    }, [
        onPerformanceMark,
        onReady
    ]);
    const onJqlBuilderBasicReady = (0, $5uXOq.useCallback)(()=>{
        onReady && onReady((0, $032ey.SEARCH_MODE_BASIC));
    }, [
        onReady
    ]);
    let onSearch = onSearchProp;
    // Keep onSearch undefined if onSearchProp is not provided, as a defined onSearch
    // will alter the behavior of the advanced JQL editor (e.g. rendering search button)
    if (onSearchProp) onSearch = (jql)=>{
        if ((0, $6s1PB.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false)) jqlDebuggerStoreActions?.resetStatus('ON_NEW_JQL_SEARCH');
        onSearchProp(jql);
        const event = createAnalyticsEvent({
            action: 'submitted',
            actionSubject: 'search'
        });
        (0, $8zOmE.fireUIAnalytics)(event, 'jqlBuilder', {
            searchMode: searchMode
        });
    };
    const { SearchModeSwitcher: SearchModeSwitcher, EditorContainer: CustomEditorContainer } = components ?? {};
    const isSearchModeToggleEnabled = searchModes ? searchModes.length > 1 : true;
    const isSearchModeSwitcherOnLeft = searchModeSwitcherLocation === (0, $032ey.SEARCH_MODE_SWITCHER_LEFT_LOCATION) && (0, $3HwlS.getWillShowNav4)();
    const BeforeJqlBuilderContainerComponent = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $5UgV1.BeforeJqlBuilderContainer) : (0, $jX4vm.BeforeJqlBuilderContainerOld);
    const BeforeJqlBuilderListItemContainerComponent = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $5UgV1.BeforeJqlBuilderListItemContainer) : (0, $jX4vm.BeforeJqlBuilderListItemContainerOld);
    const AdvancedEditorWrapperComponent = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $5UgV1.AdvancedEditorWrapper) : (0, $jX4vm.AdvancedEditorWrapperOld);
    const SearchModeSwitcherComponent = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ixr8x.SearchModeSwitcherRenderer), {
            isSearchModeToggleEnabled: isSearchModeToggleEnabled,
            SearchModeSwitcher: SearchModeSwitcher,
            isHydrating: hydrationQueryIsFetching,
            isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft
        }), [
        SearchModeSwitcher,
        hydrationQueryIsFetching,
        isSearchModeSwitcherOnLeft,
        isSearchModeToggleEnabled
    ]);
    const Editor = (0, $5uXOq.useMemo)(()=>{
        let jqlBuilderComponent;
        switch(searchMode){
            case 0, $032ey.SEARCH_MODE_BASIC:
                jqlBuilderComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
                    name: "jql-builder-basic"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imju0.default), {
                    query: query,
                    // consumers can hide search feature from advanced jql editor by not passing onSearch Handler
                    // if no onSearch handler is passed, Basic JQL editor would fallback to onUpdate handler
                    onSearch: onSearch || onUpdate || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                    onSwitchToJql: onSwitchToJql,
                    excludedFields: excludedFields,
                    onReady: onJqlBuilderBasicReady,
                    onJourneyStart: onJourneyStart,
                    NoOptionComponent: NoOptionComponent,
                    AddFilterButtonComponent: components?.AddFilterButtonComponent,
                    hydrationData: hydrationData,
                    isHydrating: hydrationQueryIsFetching,
                    shouldUseListMarkup: true,
                    hideOperatorDropdown: hideOperatorDropdownBasicMode,
                    irremovableFields: irremovableFields,
                    hideTextSearchInput: hideTextSearchInput,
                    searchPlaceholder: searchPlaceholder,
                    showOrderByPicker: showOrderByPicker,
                    contextJql: contextJql,
                    ...props
                }));
                break;
            default:
                jqlBuilderComponent = (0, $6s1PB.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
                    name: "jql-builder-advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Czte.NinChangeboardingTourTarget), {
                    engagementId: "nin.jql-builder.advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AdvancedEditorWrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bpjJS.JqlDebuggerJqlBuilderContextProvider), {
                    jqlMessages: jqlMessages,
                    query: query,
                    onSearch: onSearch
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isD5C.default), {
                    analyticsSource: analyticsSource,
                    onSearch: onSearch,
                    onUpdate: onUpdate,
                    query: query,
                    jqlMessages: jqlMessages,
                    isSearching: isSearching,
                    isCompact: true,
                    excludedAutocompleteFields: excludedFields,
                    onReady: onJqlBuilderAdvancedReady,
                    onJourneyStart: onJourneyStart,
                    customComponents: {
                        ErrorMessage: (0, $8q1vb.JQLDebuggerTriggerButton)
                    },
                    ...props
                }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
                    name: "jql-builder-advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Czte.NinChangeboardingTourTarget), {
                    engagementId: "nin.jql-builder.advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AdvancedEditorWrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isD5C.default), {
                    analyticsSource: analyticsSource,
                    onSearch: onSearch,
                    onUpdate: onUpdate,
                    query: query,
                    jqlMessages: jqlMessages,
                    isSearching: isSearching,
                    isCompact: true,
                    excludedAutocompleteFields: excludedFields,
                    onReady: onJqlBuilderAdvancedReady,
                    onJourneyStart: onJourneyStart,
                    ...props
                }))));
        }
        const BeforeJqlBuilderWrapper = searchMode === (0, $032ey.SEARCH_MODE_BASIC) ? BeforeJqlBuilderListItemContainerComponent : BeforeJqlBuilderContainerComponent;
        const showSearchModeSwitcher = (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_4') ? isSearchModeToggleEnabled && isSearchModeSwitcherOnLeft : isSearchModeSwitcherOnLeft;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, beforeControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BeforeJqlBuilderWrapper, null, beforeControls), showSearchModeSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BeforeJqlBuilderWrapper, null, SearchModeSwitcherComponent), jqlBuilderComponent, renderExtraControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g9ghO.default), {
            searchMode: searchMode,
            renderExtraControls: renderExtraControls,
            shouldUseListMarkup: searchMode === (0, $032ey.SEARCH_MODE_BASIC)
        }));
    }, [
        searchMode,
        BeforeJqlBuilderListItemContainerComponent,
        BeforeJqlBuilderContainerComponent,
        beforeControls,
        isSearchModeToggleEnabled,
        isSearchModeSwitcherOnLeft,
        SearchModeSwitcherComponent,
        renderExtraControls,
        query,
        onSearch,
        onUpdate,
        onSwitchToJql,
        excludedFields,
        onJqlBuilderBasicReady,
        onJourneyStart,
        NoOptionComponent,
        components?.AddFilterButtonComponent,
        hydrationData,
        hydrationQueryIsFetching,
        hideOperatorDropdownBasicMode,
        irremovableFields,
        hideTextSearchInput,
        searchPlaceholder,
        showOrderByPicker,
        contextJql,
        props,
        AdvancedEditorWrapperComponent,
        analyticsSource,
        jqlMessages,
        isSearching,
        onJqlBuilderAdvancedReady
    ]);
    const EffectiveJqlBuilderContainer = CustomEditorContainer ?? (0, $kdzZz.DefaultJqlBuilderContainer);
    return(// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jX4vm.Container), {
        "data-testid": "jql-builder",
        "data-vc": "jql-builder-ui-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EffectiveJqlBuilderContainer, {
        showAdvancedEditor: searchMode === (0, $032ey.SEARCH_MODE_ADVANCED),
        "data-testid": "jql-builder.ui.effective-jql-builder-container"
    }, searchMode === (0, $032ey.SEARCH_MODE_BASIC) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jX4vm.BasicEditorListContainer), {
        "data-vc": "jql-builder-basic-editor-container"
    }, Editor) : Editor), !isSearchModeSwitcherOnLeft && SearchModeSwitcherComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "jqlBuilder",
        attributes: {
            selectedSearchMode: selectedSearchMode,
            queryMode: (0, $032ey.mapSearchModeToAnalyticAtribute)[searchMode],
            ...irremovableFieldsAnalyticsAttributes,
            loadingMode: loadingModeRef.current
        }
    })));
};

});
parcelRegister("isD5C", function(module, exports) {

$parcel$export(module.exports, "default", () => $62b418d1d2bd976d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6E7Jp = parcelRequire("6E7Jp");

var $iK2TS = parcelRequire("iK2TS");
const $62b418d1d2bd976d$var$JQLBuilderAdvancedAsync = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iK2TS.default), {
        ...props,
        JQLEditor: (0, $6E7Jp.JQLEditorAsync)
    });
var $62b418d1d2bd976d$export$2e2bcd8739ae039 = $62b418d1d2bd976d$var$JQLBuilderAdvancedAsync;

});
parcelRegister("iK2TS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3427075489fb9d2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $f0PnG = parcelRequire("f0PnG");

var $2xsCE = parcelRequire("2xsCE");

var $kwkEq = parcelRequire("kwkEq");

var $5p1kJ = parcelRequire("5p1kJ");

var $5rVQI = parcelRequire("5rVQI");

var $eG9rp = parcelRequire("eG9rp");

var $879xD = parcelRequire("879xD");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $pa9q9 = parcelRequire("pa9q9");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8vNru = parcelRequire("8vNru");

var $caSpf = parcelRequire("caSpf");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $g9E9n = parcelRequire("g9E9n");


var $apc2O = parcelRequire("apc2O");

var $b3ogM = parcelRequire("b3ogM");

var $3pImq = parcelRequire("3pImq");

var $8BS0n = parcelRequire("8BS0n");
const $d3427075489fb9d2$var$JQLBuilderAdvancedUI = (props)=>{
    (0, $gKZoD.di)(requestAnimationFrame);
    const { analyticsSource: analyticsSource, JQLEditor: JQLEditor, query: query, jqlMessages: jqlMessages, isCompact: isCompact, isSearching: isSearching, onUpdate: onUpdate, onReady: onReady, onSearch: onSearch, excludedAutocompleteFields: excludedAutocompleteFields, onJourneyStart: onJourneyStart, autoFocus: autoFocus, viewContext: viewContext = null, customComponents: customComponents, isFieldIncludedInAutocomplete: isFieldIncludedInAutocomplete } = props;
    const onPerformanceMark = (0, $caSpf.usePerformanceContext)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        onPerformanceMark({
            mark: (0, $8vNru.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_ADVANCED_JS_START
        });
    }, [
        onPerformanceMark
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onHydrate = (0, $8BS0n.useOnHydrate)(viewContext);
    const getInitialData = (0, $b3ogM.useAutocompleteInitialData)(excludedAutocompleteFields, isFieldIncludedInAutocomplete);
    const getSuggestions = (0, $3pImq.useAutocompleteSuggestions)();
    const autocompleteProvider = (0, $kwkEq.useAutocompleteProvider)(analyticsSource, getInitialData, getSuggestions);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const onExperienceStart = (0, $kaHBi.useExperienceStart)({
        experienceId: undefined,
        experience: (0, $d791d5657a673291$export$abc61f74b6bec12c),
        analyticsSource: analyticsSource
    });
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $d791d5657a673291$export$abc61f74b6bec12c)
    });
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $d791d5657a673291$export$abc61f74b6bec12c)
    });
    const onError = (0, $5uXOq.useCallback)((error)=>{
        showFlag({
            type: 'error',
            title: (0, $apc2O.default).errorFlagTitle,
            description: (0, $apc2O.default).errorFlagDescription,
            messageId: 'jql-builder-advanced.ui.show-flag.error.error-flag',
            messageType: 'transactional'
        });
        // A success event may have already been fired on initial render. We need to start a new experience so we
        // can mark it as failed.
        onExperienceStart();
        onExperienceFail(analyticsSource, error);
        (0, $jcw0u.default)({
            meta: {
                id: (0, $d791d5657a673291$export$abc61f74b6bec12c),
                packageName: (0, $d791d5657a673291$export$b8b9d90f9e5bd72b),
                teamName: (0, $d791d5657a673291$export$d57b6b390e78d90f)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        showFlag,
        onExperienceStart,
        onExperienceFail,
        analyticsSource
    ]);
    // Additional logging to debug unexpected (non-fatal) behaviour in the editor.
    const onDebugUnsafeMessage = (0, $5uXOq.useCallback)((message, event)=>{
        (0, $dJl1T.default).unsafeErrorWithCustomerData('jiraJqlBuilderAdvanced.onDebugUnsafeMessage', message, event);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // Start the view experience on mount. This experience will be marked as successful by the JQLBuilderAdvancedUI
        // component upon render.
        onExperienceStart();
    }, [
        onExperienceStart
    ]);
    const searchInputRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const focusSearchInput = (0, $5uXOq.useCallback)(()=>{
        // This is the same way the global search input prevents
        // the shortcut from being fed into the input
        // See: src/packages/navigation-apps/atlassian-navigation/src/ui/integrations/keyboard-shortcuts/index.tsx
        requestAnimationFrame(()=>{
            searchInputRef?.current?.focus();
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'pressed',
            actionSubject: 'keyboardShortcut'
        }), 'jqlEditorAdvancedSearchInputKeyboardShortcut', {
            keyPressed: 'f',
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent
    ]);
    const onEditorMounted = (0, $5uXOq.useCallback)(()=>{
        onExperienceSuccess();
        if (autoFocus) focusSearchInput();
        onReady && onReady();
    }, [
        onExperienceSuccess,
        onReady,
        autoFocus,
        focusSearchInput
    ]);
    const { getKeywords: getKeywords } = (0, $eG9rp.useCommandKeywords)();
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        if (!onJourneyStart) return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'focused',
            actionSubject: 'input'
        });
        const attributes = onJourneyStart();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'jqlEditorAdvancedSearchInput', attributes);
    }, [
        createAnalyticsEvent,
        onJourneyStart
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $879xD.CommandShortcuts), {
        keyMap: {
            f: {
                callback: focusSearchInput,
                registerInCommandPalette: {
                    id: 'jql-builder-advanced-focus-search-input',
                    name: formatMessage((0, $apc2O.default).searchCurrentPage),
                    keywords: getKeywords('pageSearchSynonyms'),
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0PnG))), {
                                spacing: "spacious",
                                label: formatMessage((0, $apc2O.default).searchCurrentPage)
                            })
                    },
                    priority: (0, $5rVQI.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).searchOnCurrentPage,
                    section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).quickActions,
                    analytics: {
                        action: 'searchCurrentPage'
                    }
                }
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JQLEditor, {
        inputRef: searchInputRef,
        analyticsSource: analyticsSource,
        query: query,
        messages: jqlMessages,
        isCompact: isCompact,
        isSearching: isSearching,
        onEditorMounted: onEditorMounted,
        onUpdate: onUpdate,
        onSearch: onSearch,
        onHydrate: onHydrate,
        onFocus: onJourneyStart ? onFocus : undefined,
        autocompleteProvider: autocompleteProvider,
        onRenderError: onError,
        onDebugUnsafeMessage: onDebugUnsafeMessage,
        enableRichInlineNodes: true,
        customComponents: (0, $6s1PB.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? customComponents : undefined
    }));
};
const $d3427075489fb9d2$var$JQLBuilderAdvancedUIWithAnalytics = (props)=>{
    const clientWrapper = (0, $5uXOq.useRef)((0, $g9E9n.getAnalyticsWebClient)());
    return /* @ts-expect-error - Property 'analyticsClient' does not exist on type 'AnalyticsWebClient'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xsCE.default), {
        client: clientWrapper.current?.analyticsClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "jqlBuilderAdvanced",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d3427075489fb9d2$var$JQLBuilderAdvancedUI, props)));
};
var $d3427075489fb9d2$export$2e2bcd8739ae039 = $d3427075489fb9d2$var$JQLBuilderAdvancedUIWithAnalytics;

});
parcelRegister("2xsCE", function(module, exports) {

$parcel$export(module.exports, "default", () => $696101a6ac864fbf$export$2e2bcd8739ae039);
/**
 * Adapted from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/fabric/FabricEditorListener.tsx
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jblqj = parcelRequire("jblqj");

var $eUIv7 = parcelRequire("eUIv7");

var $kGvml = parcelRequire("kGvml");

var $6orNi = parcelRequire("6orNi");
class $696101a6ac864fbf$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props), this.handleEventWrapper = (event)=>{
            (0, $kGvml.handleEvent)(event, this.logger, this.props.client);
        };
        this.logger = new (0, $6orNi.default)({
            logLevel: props.logLevel
        });
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jblqj.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $eUIv7.ANALYTICS_CHANNEL),
            children: this.props.children
        });
    }
}

});
parcelRegister("eUIv7", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $64aebb4ba7e4a5d5$export$85183a312807388d);
$parcel$export(module.exports, "EventType", () => $64aebb4ba7e4a5d5$export$3d7865934588d77e);
const $64aebb4ba7e4a5d5$export$85183a312807388d = 'jql-editor';
var $64aebb4ba7e4a5d5$export$3d7865934588d77e = /*#__PURE__*/ function(EventType) {
    EventType["OPERATIONAL"] = "operational";
    EventType["SCREEN"] = "screen";
    EventType["TRACK"] = "track";
    EventType["UI"] = "ui";
    return EventType;
}({});

});

parcelRegister("kGvml", function(module, exports) {

$parcel$export(module.exports, "handleEvent", () => $803e2134b13183df$export$d6e5ca10785815df);
/**
 * Adapted from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/fabric/handle-event.tsx
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ 
var $4yasm = parcelRequire("4yasm");

var $6NEbQ = parcelRequire("6NEbQ");
const $803e2134b13183df$export$d6e5ca10785815df = (event, logger, client)=>{
    if (!event.payload) return;
    const payload = (0, $6NEbQ.processEventPayload)(event);
    (0, $4yasm.sendEvent)(logger, client)(payload);
};

});
parcelRegister("4yasm", function(module, exports) {

$parcel$export(module.exports, "sendEvent", () => $c0e97d0c893af428$export$7329bcdc3edcd90e);
/**
 * Copied from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/analytics-web-client-wrapper.ts
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ const $c0e97d0c893af428$var$isPromise = (c)=>{
    return typeof c.then === 'function';
};
const $c0e97d0c893af428$export$7329bcdc3edcd90e = (logger, client)=>(event)=>{
        if (client) {
            const gasEvent = {
                ...event
            };
            /*
      Merging this ts-ignore is not going to affect the type definitions of the package
      there's a whole lot more wrong going on here than just this delete.
      All the send methods on the client take a GasPurePayload object which requires actionSubject
      actionSubject is missing on GasPayload | GasScreenEventPayload
    */ // @ts-ignore mergeable @fixme TypeScript 4.2.4 upgrade
            delete gasEvent.eventType;
            const withClient = (cb)=>{
                if ($c0e97d0c893af428$var$isPromise(client)) client.then(cb).catch((e)=>logger.warn('There was an error sending the event', e));
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient((client)=>client.sendUIEvent(gasEvent));
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient((client)=>client.sendOperationalEvent(gasEvent));
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient((client)=>client.sendTrackEvent(gasEvent));
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient((client)=>client.sendScreenEvent(gasEvent));
                    break;
                default:
                    logger.error(`cannot map eventType ${event.eventType} to an analytics-web-client function`);
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };

});

parcelRegister("6NEbQ", function(module, exports) {

$parcel$export(module.exports, "processEventPayload", () => $0c8d5aab5811915a$export$c37d638b7f2ca192);
/**
 * Adapted from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/fabric/process-event-payload.tsx
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ 
var $1UikQ = parcelRequire("1UikQ");

const $0c8d5aab5811915a$var$extractFieldsFromContext = (fieldsToPick)=>(contexts)=>contexts.map((ctx)=>fieldsToPick.reduce((result, key)=>ctx[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(result, {
                    [key]: ctx[key]
                }) : result, {})).reduce((result, item)=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(result, item), {});
const $0c8d5aab5811915a$var$fieldExtractor = ()=>$0c8d5aab5811915a$var$extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId'
    ]);
const $0c8d5aab5811915a$var$updatePayloadWithContext = (event)=>{
    if (event.context.length === 0) return {
        source: (0, $4e2819b72987a07d$export$b055de0e665cb20c),
        ...event.payload
    };
    const fields = $0c8d5aab5811915a$var$fieldExtractor()(event.context);
    return {
        source: (0, $4e2819b72987a07d$export$b055de0e665cb20c),
        ...fields,
        ...event.payload
    };
};
const $0c8d5aab5811915a$export$c37d638b7f2ca192 = (event)=>{
    return $0c8d5aab5811915a$var$updatePayloadWithContext(event);
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $4e2819b72987a07d$export$a1562d08625f5d7e = 'ui';
const $4e2819b72987a07d$export$947dac6c72b26f81 = 'track';
const $4e2819b72987a07d$export$f1d537d508d2945a = 'screen';
const $4e2819b72987a07d$export$12346a674644c156 = 'operational';
const $4e2819b72987a07d$export$b055de0e665cb20c = 'unknown';



parcelRegister("6orNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $526a7c366f6137ef$export$2e2bcd8739ae039);
/**
 * Copied from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/helpers/logger.ts
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ const $526a7c366f6137ef$export$ffe0c436e29512cf = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
class $526a7c366f6137ef$export$2e2bcd8739ae039 {
    constructor({ logLevel: logLevel } = {}){
        this.logLevel = $526a7c366f6137ef$export$ffe0c436e29512cf.OFF;
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
    setLogLevel(logLevel) {
        if (logLevel >= $526a7c366f6137ef$export$ffe0c436e29512cf.DEBUG && logLevel <= $526a7c366f6137ef$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
        else this.logLevel = $526a7c366f6137ef$export$ffe0c436e29512cf.OFF;
    }
    logMessage(level, type, ...args) {
        if (level >= this.logLevel) // eslint-disable-next-line no-console
        console[type](...args);
    }
    debug(...args) {
        this.logMessage($526a7c366f6137ef$export$ffe0c436e29512cf.DEBUG, 'log', ...args);
    }
    info(...args) {
        this.logMessage($526a7c366f6137ef$export$ffe0c436e29512cf.INFO, 'info', ...args);
    }
    warn(...args) {
        this.logMessage($526a7c366f6137ef$export$ffe0c436e29512cf.WARN, 'warn', ...args);
    }
    error(...args) {
        this.logMessage($526a7c366f6137ef$export$ffe0c436e29512cf.ERROR, 'error', ...args);
    }
}

});


parcelRegister("kwkEq", function(module, exports) {

$parcel$export(module.exports, "useAutocompleteProvider", () => $65effe722db8ca36$export$2ae605545144a62d);

var $5uXOq = parcelRequire("5uXOq");

var $cJwPt = parcelRequire("cJwPt");

var $iWix6 = parcelRequire("iWix6");

var $bNSw9 = parcelRequire("bNSw9");

var $cIruy = parcelRequire("cIruy");

var $ctM7h = parcelRequire("ctM7h");

var $cxFtB = parcelRequire("cxFtB");
const $65effe722db8ca36$export$2ae605545144a62d = (/**
	 * Page/experience where the hook is being rendered. Used to correlate JQL analytics events to a given consumer.
	 */ analyticsSource, /**
	 * Fetch initial autocomplete data for fields and functions using the [Get field reference data API](https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-jql/#api-rest-api-3-jql-autocompletedata-post).
	 * Consumers can implement this method to configure which JS API will be used to make the request, e.g. Connect apps may
	 * wish to use the [AP.request API](https://developer.atlassian.com/cloud/jira/software/jsapi/request/).
	 */ getInitialData, /**
	 * Fetch autocomplete suggestions for field values using the [Get field autocomplete suggestions API](https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-jql/#api-rest-api-3-jql-autocompletedata-suggestions-get).
	 * Consumers can implement this method to configure which JS API will be used to make the request, e.g. Connect apps may
	 * wish to use the [AP.request API](https://developer.atlassian.com/cloud/jira/software/jsapi/request/).
	 */ getSuggestions)=>{
    const { createAndFireAnalyticsEvent: createAndFireAnalyticsEvent } = (0, $cJwPt.useJqlEditorAutocompleteAnalytics)(analyticsSource);
    const [, { load: load }] = (0, $iWix6.useJqlAutocompleteActions)();
    const [jqlSearchableFields$] = (0, $iWix6.useJqlSearchableFieldsObservable)();
    const [jqlOrderableFields$] = (0, $iWix6.useJqlOrderableFieldsObservable)();
    const [jqlFunctions$] = (0, $iWix6.useJqlFunctionsObservable)();
    const onFields = (0, $bNSw9.default)(jqlSearchableFields$, jqlOrderableFields$);
    const onOperators = (0, $ctM7h.default)(jqlSearchableFields$);
    const onFunctions = (0, $cIruy.default)(jqlSearchableFields$, jqlFunctions$);
    const onValues = (0, $cxFtB.default)(jqlSearchableFields$, getSuggestions, createAndFireAnalyticsEvent);
    (0, $5uXOq.useEffect)(()=>{
        // Load autocomplete data on mount
        load(getInitialData, createAndFireAnalyticsEvent);
    }, [
        createAndFireAnalyticsEvent,
        getInitialData,
        load
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            onFields: onFields,
            onOperators: onOperators,
            onFunctions: onFunctions,
            onValues: onValues
        }), [
        onFields,
        onOperators,
        onFunctions,
        onValues
    ]);
};

});
parcelRegister("cJwPt", function(module, exports) {

$parcel$export(module.exports, "useJqlEditorAutocompleteAnalytics", () => $e6584e0b010637d1$export$67ceee19d6563eac);

var $eUIv7 = parcelRequire("eUIv7");
var $jz1Wm = parcelRequire("jz1Wm");

var $hKT84 = parcelRequire("hKT84");
const $e6584e0b010637d1$export$67ceee19d6563eac = (analyticsSource)=>{
    return (0, $jz1Wm.useJqlPackageAnalytics)(analyticsSource, "platform-pkg", "0.0.0-use.local", (0, $eUIv7.ANALYTICS_CHANNEL));
};

});
parcelRegister("jz1Wm", function(module, exports) {

$parcel$export(module.exports, "useJqlPackageAnalytics", () => $b066dbc4a5d795fe$export$62edc016e6670a97);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");
const $b066dbc4a5d795fe$export$62edc016e6670a97 = (analyticsSource, packageName, packageVersion, analyticsChannel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const createAndFireAnalyticsEvent = (0, $5uXOq.useCallback)((payload)=>{
        const event = createAnalyticsEvent({
            ...payload,
            attributes: {
                ...payload.attributes,
                analyticsSource: analyticsSource,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        event.fire(analyticsChannel);
    }, [
        createAnalyticsEvent,
        analyticsSource,
        packageName,
        packageVersion,
        analyticsChannel
    ]);
    return {
        createAndFireAnalyticsEvent: createAndFireAnalyticsEvent
    };
};

});

parcelRegister("hKT84", function(module, exports) {

$parcel$export(module.exports, "Action", () => $a207f69996f1ba3f$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "ActionSubject", () => $a207f69996f1ba3f$export$7f97440769de1377);
var $a207f69996f1ba3f$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    Action["FAILED"] = "failed";
    Action["SUCCESS"] = "success";
    return Action;
}({});
var $a207f69996f1ba3f$export$7f97440769de1377 = /*#__PURE__*/ function(ActionSubject) {
    ActionSubject["AUTOCOMPLETE_INITIAL_DATA"] = "autocompleteInitialData";
    ActionSubject["AUTOCOMPLETE_SUGGESTIONS"] = "autocompleteSuggestions";
    return ActionSubject;
}({});
var $a207f69996f1ba3f$export$cb7d54f314e067cb = /*#__PURE__*/ function(ActionSubjectId) {
    return ActionSubjectId;
}({});

});


parcelRegister("iWix6", function(module, exports) {

$parcel$export(module.exports, "useJqlAutocompleteActions", () => $e568120e5dfcd7c7$export$dfe74b189a0a3dd);
$parcel$export(module.exports, "useJqlSearchableFieldsObservable", () => $e568120e5dfcd7c7$export$e00ad85496518b08);
$parcel$export(module.exports, "useJqlOrderableFieldsObservable", () => $e568120e5dfcd7c7$export$ddac70d4fccb6121);
$parcel$export(module.exports, "useJqlFunctionsObservable", () => $e568120e5dfcd7c7$export$20ce426c77c6c794);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $gI62y = parcelRequire("gI62y");

var $ib0Rz = parcelRequire("ib0Rz");

var $eUIv7 = parcelRequire("eUIv7");

var $hKT84 = parcelRequire("hKT84");
const $e568120e5dfcd7c7$var$initialData = {
    jqlSearchableFields: [],
    jqlOrderableFields: [],
    jqlFunctions: []
};
const $e568120e5dfcd7c7$var$initialState = {
    initialDataFetched: false,
    jqlSearchableFields$: (0, $gI62y.from)($e568120e5dfcd7c7$var$initialData.jqlSearchableFields),
    jqlOrderableFields$: (0, $gI62y.from)($e568120e5dfcd7c7$var$initialData.jqlOrderableFields),
    jqlFunctions$: (0, $gI62y.from)($e568120e5dfcd7c7$var$initialData.jqlFunctions)
};
const $e568120e5dfcd7c7$export$e324594224ef24da = {
    load: (getInitialData, createAndFireAnalyticsEvent)=>({ getState: getState, setState: setState })=>{
            const { initialDataFetched: initialDataFetched } = getState();
            if (initialDataFetched) return;
            const promise = getInitialData(`/rest/api/latest/jql/autocompletedata`).then((res)=>{
                const initialValue = {
                    jqlSearchableFields: [],
                    jqlOrderableFields: [],
                    jqlFunctions: res.jqlFunctions
                };
                const data = res.jqlFields.reduce((result, field)=>{
                    if (field.searchable === 'true') result.jqlSearchableFields.push(field);
                    if (field.orderable === 'true') result.jqlOrderableFields.push(field);
                    return result;
                }, initialValue);
                // Minor optimisation so consumers don't have to wait for the promise `then` function to be called
                // whenever we subscribe to the observable. (`then` runs async in the current thread loop)
                setState({
                    jqlSearchableFields$: (0, $gI62y.from)(data.jqlSearchableFields),
                    jqlOrderableFields$: (0, $gI62y.from)(data.jqlOrderableFields),
                    jqlFunctions$: (0, $gI62y.from)(data.jqlFunctions)
                });
                createAndFireAnalyticsEvent({
                    action: (0, $hKT84.Action).SUCCESS,
                    actionSubject: (0, $hKT84.ActionSubject).AUTOCOMPLETE_INITIAL_DATA,
                    eventType: (0, $eUIv7.EventType).OPERATIONAL
                });
                return data;
            }).catch(()=>{
                setState({
                    jqlSearchableFields$: $e568120e5dfcd7c7$var$initialState.jqlSearchableFields$,
                    jqlOrderableFields$: $e568120e5dfcd7c7$var$initialState.jqlOrderableFields$,
                    jqlFunctions$: $e568120e5dfcd7c7$var$initialState.jqlFunctions$
                });
                createAndFireAnalyticsEvent({
                    action: (0, $hKT84.Action).FAILED,
                    actionSubject: (0, $hKT84.ActionSubject).AUTOCOMPLETE_INITIAL_DATA,
                    eventType: (0, $eUIv7.EventType).OPERATIONAL
                });
                return $e568120e5dfcd7c7$var$initialData;
            });
            // Set the in-flight promise in state as an observable. This allows consumers to subscribe to our initial data
            // without worrying about race conditions with the API call.
            setState({
                initialDataFetched: true,
                jqlSearchableFields$: (0, $gI62y.from)(promise).pipe((0, $ib0Rz.concatMap)(({ jqlSearchableFields: jqlSearchableFields })=>jqlSearchableFields)),
                jqlOrderableFields$: (0, $gI62y.from)(promise).pipe((0, $ib0Rz.concatMap)(({ jqlOrderableFields: jqlOrderableFields })=>jqlOrderableFields)),
                jqlFunctions$: (0, $gI62y.from)(promise).pipe((0, $ib0Rz.concatMap)(({ jqlFunctions: jqlFunctions })=>jqlFunctions))
            });
        }
};
const $e568120e5dfcd7c7$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    initialState: $e568120e5dfcd7c7$var$initialState,
    actions: $e568120e5dfcd7c7$export$e324594224ef24da
});
const $e568120e5dfcd7c7$export$96c8f4ecc88d96a5 = (0, $gg7kZ.createContainer)($e568120e5dfcd7c7$export$6f57813fe9f31bf9);
const $e568120e5dfcd7c7$export$dfe74b189a0a3dd = (0, $3sQ5x.createHook)($e568120e5dfcd7c7$export$6f57813fe9f31bf9, {
    selector: null
});
const $e568120e5dfcd7c7$export$e00ad85496518b08 = (0, $3sQ5x.createHook)($e568120e5dfcd7c7$export$6f57813fe9f31bf9, {
    selector: ({ jqlSearchableFields$: jqlSearchableFields$ })=>jqlSearchableFields$
});
const $e568120e5dfcd7c7$export$ddac70d4fccb6121 = (0, $3sQ5x.createHook)($e568120e5dfcd7c7$export$6f57813fe9f31bf9, {
    selector: ({ jqlOrderableFields$: jqlOrderableFields$ })=>jqlOrderableFields$
});
const $e568120e5dfcd7c7$export$20ce426c77c6c794 = (0, $3sQ5x.createHook)($e568120e5dfcd7c7$export$6f57813fe9f31bf9, {
    selector: ({ jqlFunctions$: jqlFunctions$ })=>jqlFunctions$
});

});

parcelRegister("bNSw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $eecc699710c9609e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aN8zr = parcelRequire("aN8zr");

var $8B7Oi = parcelRequire("8B7Oi");

var $4cJXk = parcelRequire("4cJXk");

var $cVFxd = parcelRequire("cVFxd");

var $cQZy3 = parcelRequire("cQZy3");

var $iQUbM = parcelRequire("iQUbM");

var $8fSs0 = parcelRequire("8fSs0");

var $i9YDx = parcelRequire("i9YDx");
const $eecc699710c9609e$export$df27029b4333540b = 20;
const $eecc699710c9609e$var$CF_ID_PATTERN = /^"?cf\[\d+]"?$/;
const $eecc699710c9609e$var$COLLAPSED_FIELD_PATTERN = /^"?.+\[(.+)]"?$/;
const $eecc699710c9609e$var$isCollapsedField = ({ value: value })=>$eecc699710c9609e$var$COLLAPSED_FIELD_PATTERN.test(value) && !$eecc699710c9609e$var$CF_ID_PATTERN.test(value);
const $eecc699710c9609e$export$b9089a6e41ed43aa = (field)=>{
    if (!$eecc699710c9609e$var$isCollapsedField(field)) return null;
    const matches = $eecc699710c9609e$var$COLLAPSED_FIELD_PATTERN.exec(field.value);
    if (!matches || matches.length < 2) return null;
    return matches[1];
};
const $eecc699710c9609e$var$useOnFields = (jqlSearchableFields$, jqlOrderableFields$)=>{
    // Returns an Observable of the fields to render for the provided query string
    return (0, $5uXOq.useCallback)((query, clause)=>{
        if (clause === undefined) return (0, $8B7Oi.empty)();
        const jqlFields$ = clause === 'orderBy' ? jqlOrderableFields$ : jqlSearchableFields$;
        return jqlFields$.pipe((0, $4cJXk.filter)((field)=>(0, $8fSs0.filterJqlValue)(field, query)), // Limit the result to MAX_VISIBLE_OPTIONS
        (0, $cQZy3.take)($eecc699710c9609e$export$df27029b4333540b), (0, $cVFxd.map)((field)=>{
            const fieldType = $eecc699710c9609e$export$b9089a6e41ed43aa(field);
            if (fieldType !== null) {
                const name = (0, (/*@__PURE__*/$parcel$interopDefault($aN8zr)))(field.displayName).replace(` - ${(0, $i9YDx.normalize)(field.value)}`, '');
                return {
                    name: name,
                    value: field.value,
                    fieldType: fieldType,
                    isDeprecated: field.deprecated === 'true',
                    deprecatedSearcherKey: field.deprecatedSearcherKey
                };
            }
            return {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($aN8zr)))(field.displayName),
                value: field.value,
                isDeprecated: field.deprecated === 'true',
                deprecatedSearcherKey: field.deprecatedSearcherKey
            };
        }), (0, $iQUbM.toArray)(), // We can filter out empty arrays as there is nothing to consume
        (0, $4cJXk.filter)((fields)=>fields.length > 0));
    }, [
        jqlSearchableFields$,
        jqlOrderableFields$
    ]);
};
var $eecc699710c9609e$export$2e2bcd8739ae039 = $eecc699710c9609e$var$useOnFields;

});
parcelRegister("aN8zr", function(module, exports) {

var $jJVtR = parcelRequire("jJVtR");

var $04YKD = parcelRequire("04YKD");
/** Used to match HTML entities and HTML characters. */ var $7db520ee7c182c99$var$reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, $7db520ee7c182c99$var$reHasEscapedHtml = RegExp($7db520ee7c182c99$var$reEscapedHtml.source);
/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */ function $7db520ee7c182c99$var$unescape(string) {
    string = $jJVtR(string);
    return string && $7db520ee7c182c99$var$reHasEscapedHtml.test(string) ? string.replace($7db520ee7c182c99$var$reEscapedHtml, $04YKD) : string;
}
module.exports = $7db520ee7c182c99$var$unescape;

});
parcelRegister("04YKD", function(module, exports) {

var $h2dNA = parcelRequire("h2dNA");
/** Used to map HTML entities to characters. */ var $00ef7fc28f2140e4$var$htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
};
/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */ var $00ef7fc28f2140e4$var$unescapeHtmlChar = $h2dNA($00ef7fc28f2140e4$var$htmlUnescapes);
module.exports = $00ef7fc28f2140e4$var$unescapeHtmlChar;

});


parcelRegister("8fSs0", function(module, exports) {

$parcel$export(module.exports, "filterJqlValue", () => $214d690cc5386fb1$export$7a9ba8200d77b3fe);

var $i9YDx = parcelRequire("i9YDx");
const $214d690cc5386fb1$export$7a9ba8200d77b3fe = ({ displayName: displayName, value: value }, query)=>{
    if (typeof query !== 'string' || query === '') return true;
    const normalizedQuery = (0, $i9YDx.normalize)(query);
    const normalizedDisplayName = (0, $i9YDx.normalize)(displayName);
    const normalizedValue = (0, $i9YDx.normalize)(value);
    // If query is quoted, then we only return exact matches with the JQL value
    if ((0, $i9YDx.isQuoted)(query)) return (0, $i9YDx.areStringsEquivalent)(normalizedQuery, normalizedValue);
    return (0, $i9YDx.areStringsEquivalent)(normalizedQuery, normalizedDisplayName.substring(0, normalizedQuery.length)) || (0, $i9YDx.areStringsEquivalent)(normalizedQuery, normalizedValue.substring(0, normalizedQuery.length));
};

});
parcelRegister("i9YDx", function(module, exports) {

$parcel$export(module.exports, "isQuoted", () => $0d4bba8c9e9f7d0b$export$b86601123607fee5);
$parcel$export(module.exports, "normalize", () => $0d4bba8c9e9f7d0b$export$a3295358bff77e);
$parcel$export(module.exports, "areStringsEquivalent", () => $0d4bba8c9e9f7d0b$export$cef6d95c2df8ec7f);
const $0d4bba8c9e9f7d0b$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $0d4bba8c9e9f7d0b$export$d5efd6512db694fd = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $0d4bba8c9e9f7d0b$export$b86601123607fee5 = (maybeQuotedString)=>$0d4bba8c9e9f7d0b$export$7a0b99b892e0dda8(maybeQuotedString) || $0d4bba8c9e9f7d0b$export$d5efd6512db694fd(maybeQuotedString);
const $0d4bba8c9e9f7d0b$export$a3295358bff77e = (maybeQuotedString)=>{
    if ($0d4bba8c9e9f7d0b$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
    if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
    return maybeQuotedString;
};
const $0d4bba8c9e9f7d0b$var$collator = new Intl.Collator(undefined, {
    sensitivity: 'base'
});
const $0d4bba8c9e9f7d0b$export$cef6d95c2df8ec7f = (a, b)=>$0d4bba8c9e9f7d0b$var$collator.compare(a, b) === 0;

});



parcelRegister("cIruy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c1b911ccc21fe32$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QDwl = parcelRequire("8QDwl");

var $8B7Oi = parcelRequire("8B7Oi");

var $ib0Rz = parcelRequire("ib0Rz");

var $4cJXk = parcelRequire("4cJXk");

var $cVFxd = parcelRequire("cVFxd");

var $iQUbM = parcelRequire("iQUbM");

var $2g1Vf = parcelRequire("2g1Vf");
const $8c1b911ccc21fe32$var$useOnFunctions = (jqlSearchableFields$, jqlFunctions$)=>{
    return (0, $5uXOq.useCallback)((query, field, isListOperator)=>{
        if (typeof field !== 'string' || field === '') return (0, $8B7Oi.empty)();
        const filterRegex = typeof query === 'string' && query !== '' ? new RegExp(`^${(0, (/*@__PURE__*/$parcel$interopDefault($8QDwl)))(query)}[^$]`, 'i') : undefined;
        const field$ = (0, $2g1Vf.default)(jqlSearchableFields$, field);
        // Find all functions that match our query with a type that intersects our field types
        return field$.pipe((0, $ib0Rz.concatMap)((matchingField)=>jqlFunctions$.pipe((0, $4cJXk.filter)((func)=>!filterRegex || func.displayName.match(filterRegex) !== null), (0, $4cJXk.filter)((func)=>// Do not include functions that return a list unless we are using a list operator
                !!isListOperator || func.isList !== 'true'), (0, $4cJXk.filter)((func)=>// Include functions with a type that intersects our field types
                func.types.filter((type)=>matchingField.types.includes(type)).length > 0), (0, $cVFxd.map)((func)=>({
                    name: func.displayName,
                    value: func.value,
                    isListFunction: func.isList === 'true' || func.supportsListAndSingleValueOperators === 'true'
                })), (0, $iQUbM.toArray)())), // We can filter out empty arrays as there is nothing to consume
        (0, $4cJXk.filter)((operands)=>operands.length > 0));
    }, [
        jqlSearchableFields$,
        jqlFunctions$
    ]);
};
var $8c1b911ccc21fe32$export$2e2bcd8739ae039 = $8c1b911ccc21fe32$var$useOnFunctions;

});
parcelRegister("2g1Vf", function(module, exports) {

$parcel$export(module.exports, "default", () => $08c7851292c24a45$export$2e2bcd8739ae039);

var $4cJXk = parcelRequire("4cJXk");

var $cQZy3 = parcelRequire("cQZy3");

var $i9YDx = parcelRequire("i9YDx");
/**
 * Returns an Observable of the first field matching the provided string, or an empty Observable if no matching field
 * could be found.
 */ const $08c7851292c24a45$var$findField$ = (jqlFields$, field)=>{
    return jqlFields$.pipe((0, $4cJXk.filter)(({ value: value })=>{
        const normalizedField = (0, $i9YDx.normalize)(field);
        const normalizedValue = (0, $i9YDx.normalize)(value);
        return (0, $i9YDx.areStringsEquivalent)(normalizedField, normalizedValue);
    }), (0, $cQZy3.take)(1));
};
var $08c7851292c24a45$export$2e2bcd8739ae039 = $08c7851292c24a45$var$findField$;

});


parcelRegister("ctM7h", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab2c51e4c16554bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QDwl = parcelRequire("8QDwl");

var $8B7Oi = parcelRequire("8B7Oi");

var $ib0Rz = parcelRequire("ib0Rz");

var $4cJXk = parcelRequire("4cJXk");

var $cVFxd = parcelRequire("cVFxd");

var $iQUbM = parcelRequire("iQUbM");

var $2g1Vf = parcelRequire("2g1Vf");
const $ab2c51e4c16554bd$var$useOnOperators = (jqlSearchableFields$)=>{
    return (0, $5uXOq.useCallback)((query, field)=>{
        if (typeof field !== 'string' || field === '') return (0, $8B7Oi.empty)();
        const filterRegex = typeof query === 'string' && query !== '' ? new RegExp(`^${(0, (/*@__PURE__*/$parcel$interopDefault($8QDwl)))(query)}[^$]`, 'i') : undefined;
        // Find operators for matching field
        return (0, $2g1Vf.default)(jqlSearchableFields$, field).pipe((0, $ib0Rz.concatMap)(({ operators: operators })=>operators), // Filter operators that match query
        (0, $4cJXk.filter)((operator)=>!filterRegex || operator.match(filterRegex) !== null), (0, $cVFxd.map)((operator)=>{
            const value = operator.toUpperCase();
            return {
                name: value,
                value: value
            };
        }), (0, $iQUbM.toArray)(), // We can filter out empty arrays as there is nothing to consume
        (0, $4cJXk.filter)((operators)=>operators.length > 0));
    }, [
        jqlSearchableFields$
    ]);
};
var $ab2c51e4c16554bd$export$2e2bcd8739ae039 = $ab2c51e4c16554bd$var$useOnOperators;

});

parcelRegister("cxFtB", function(module, exports) {

$parcel$export(module.exports, "default", () => $db1f823c4e87751b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $8B7Oi = parcelRequire("8B7Oi");

var $aq199 = parcelRequire("aq199");

var $ib0Rz = parcelRequire("ib0Rz");

var $8EnuM = parcelRequire("8EnuM");

var $4cJXk = parcelRequire("4cJXk");

var $2g1Vf = parcelRequire("2g1Vf");

var $i9YDx = parcelRequire("i9YDx");


var $ckLgG = parcelRequire("ckLgG");
const $db1f823c4e87751b$var$getValueType = (field)=>{
    if (field.types.includes((0, $a1fbc76977c0dfbd$export$7cba791a20c35c0c))) return 'user';
    return undefined;
};
const $db1f823c4e87751b$var$fieldValuesReducer = (state, action)=>{
    const { cacheKey: cacheKey, values: values } = action.payload;
    return {
        ...state,
        [cacheKey]: values
    };
};
const $db1f823c4e87751b$var$initialState = {};
// Hard coded delay before making a fetch call for operands.
const $db1f823c4e87751b$var$OPERANDS_DELAY_MS = 650;
// Used to remove emails from user display names in autocomplete values, which come in format: "Name - email".
// Pattern below is specific enough for this purpose and we should avoid writing a more complex email matcher.
const $db1f823c4e87751b$var$BASIC_REMOVE_EMAIL_REGEX = /\s-\s\S+@\S+\.\S+$/;
const $db1f823c4e87751b$var$useOnValues = (jqlSearchableFields$, getSuggestions, createAndFireAnalyticsEvent)=>{
    (0, $gKZoD.di)((0, $5uXOq.useReducer));
    const fetchFieldValues = (0, $ckLgG.useFetchFieldValues)(getSuggestions, createAndFireAnalyticsEvent);
    const [fieldValuesCache, dispatch] = (0, $5uXOq.useReducer)($db1f823c4e87751b$var$fieldValuesReducer, $db1f823c4e87751b$var$initialState);
    return (0, $5uXOq.useCallback)((query, field)=>{
        if (typeof field !== 'string' || field === '') return (0, $8B7Oi.empty)();
        const field$ = (0, $2g1Vf.default)(jqlSearchableFields$, field);
        // API expects unquoted and unescaped values
        const normalizedField = (0, $i9YDx.normalize)(field);
        const normalizedQuery = query !== undefined ? (0, $i9YDx.normalize)(query) : '';
        // Cache values by field + query
        const cacheKey = `${normalizedField}:${normalizedQuery}`;
        const isCacheHit = Object.prototype.hasOwnProperty.call(fieldValuesCache, cacheKey);
        return field$.pipe((0, $4cJXk.filter)((matchingField)=>matchingField.auto === 'true'), (0, $ib0Rz.concatMap)((matchingField)=>{
            if (isCacheHit) return (0, $aq199.of)(fieldValuesCache[cacheKey]);
            // If we have a cfid then use it to fetch autocomplete suggestions as results will always be unique.
            // Otherwise it's possible `normalizedField` will match against multiple fields in the API and thus
            // return no data.
            const fieldNameForFetch = matchingField.cfid ?? normalizedField;
            // We emit a single value using Observable.of(null) and delay that event before fetching field values so we
            // can mimic debounce behaviour.
            return (0, $aq199.of)(null).pipe((0, $8EnuM.delay)($db1f823c4e87751b$var$OPERANDS_DELAY_MS), (0, $ib0Rz.concatMap)(()=>fetchFieldValues(fieldNameForFetch, normalizedQuery).then((values)=>{
                    const valueType = $db1f823c4e87751b$var$getValueType(matchingField);
                    if (valueType === 'user') values.forEach((value)=>{
                        value.valueType = valueType;
                        // REST autocomplete API returns user display names with this format: "Name - email". To be
                        // consistent with hydration API, we want to remove email from this name for rich inline nodes.
                        value.nameOnRichInlineNode = value.name.replace($db1f823c4e87751b$var$BASIC_REMOVE_EMAIL_REGEX, '');
                    });
                    // Save response to in-memory cache
                    dispatch({
                        type: 'update-cache',
                        payload: {
                            cacheKey: cacheKey,
                            values: values
                        }
                    });
                    return values;
                }).catch(()=>[])));
        }), // We can filter out empty arrays as there is nothing to consume
        (0, $4cJXk.filter)((operands)=>operands.length > 0));
    }, [
        jqlSearchableFields$,
        fieldValuesCache,
        fetchFieldValues
    ]);
};
var $db1f823c4e87751b$export$2e2bcd8739ae039 = $db1f823c4e87751b$var$useOnValues;

});
const $a1fbc76977c0dfbd$export$7cba791a20c35c0c = 'com.atlassian.jira.user.ApplicationUser';

parcelRegister("ckLgG", function(module, exports) {

$parcel$export(module.exports, "useFetchFieldValues", () => $22a9fb607a8727e7$export$6cb851ed13e3949e);

var $5uXOq = parcelRequire("5uXOq");

var $eUIv7 = parcelRequire("eUIv7");

var $hKT84 = parcelRequire("hKT84");
const $22a9fb607a8727e7$export$7bf3f44bca0a7a65 = (field, query)=>`/rest/api/latest/jql/autocompletedata/suggestions?fieldName=${field}&fieldValue=${query ?? ''}`;
const $22a9fb607a8727e7$export$6cb851ed13e3949e = (getSuggestions, createAndFireAnalyticsEvent)=>{
    return (0, $5uXOq.useCallback)(async (field, query)=>{
        try {
            const data = await getSuggestions($22a9fb607a8727e7$export$7bf3f44bca0a7a65(field, query));
            const div = document.createElement('div');
            const results = data.results.map((operand)=>{
                // The displayName from the API includes HTML tags to bold matching text e.g. `<b>o</b>pen`
                // We set this as innerHTML so we can get the raw textContent
                div.innerHTML = operand.displayName;
                return {
                    name: div.textContent ?? '',
                    value: operand.value
                };
            });
            createAndFireAnalyticsEvent({
                action: (0, $hKT84.Action).SUCCESS,
                actionSubject: (0, $hKT84.ActionSubject).AUTOCOMPLETE_SUGGESTIONS,
                eventType: (0, $eUIv7.EventType).OPERATIONAL
            });
            return results;
        } catch (error) {
            createAndFireAnalyticsEvent({
                action: (0, $hKT84.Action).FAILED,
                actionSubject: (0, $hKT84.ActionSubject).AUTOCOMPLETE_SUGGESTIONS,
                eventType: (0, $eUIv7.EventType).OPERATIONAL
            });
            throw error;
        }
    }, [
        createAndFireAnalyticsEvent,
        getSuggestions
    ]);
};

});



parcelRegister("5p1kJ", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $7691773a5eed3db6$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $7691773a5eed3db6$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $7691773a5eed3db6$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $7691773a5eed3db6$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $7691773a5eed3db6$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $7691773a5eed3db6$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $7691773a5eed3db6$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $7691773a5eed3db6$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $7691773a5eed3db6$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $7691773a5eed3db6$export$5e5a87aac5d9771f);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $7691773a5eed3db6$export$16b06d29ef8f802b = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["containerNavigation"] = "container-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
    COMMAND_PALETTE_SECTIONS["forge"] = "forge";
    return COMMAND_PALETTE_SECTIONS;
}({});
const $7691773a5eed3db6$export$156ebd2354e25466 = 'issueActions';
const $7691773a5eed3db6$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $7691773a5eed3db6$export$9f646ab88e1d2b14 = 'commandPalette';
var $7691773a5eed3db6$export$abf26cc5daebd2c8 = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["containerNavigation"] = 2] = "containerNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["forge"] = 9] = "forge";
    return COMMAND_PALETTE_SECTIONS_PRIORITY;
}({});
var $7691773a5eed3db6$export$12514ca8899b0521 = /*#__PURE__*/ function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
    return COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY;
}({});
var $7691773a5eed3db6$export$5fa0bcf59f933c21 = /*#__PURE__*/ function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
    return COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY;
}({});
var $7691773a5eed3db6$export$7d9743be0b7d862f = /*#__PURE__*/ function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
    return COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY;
}({});
var $7691773a5eed3db6$export$b4e1633c86db2b70 = /*#__PURE__*/ function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
    return COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY;
}({});
var $7691773a5eed3db6$export$5e5a87aac5d9771f = /*#__PURE__*/ function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
    return COMMAND_PALETTE_HELP_PRIORITY;
}({});

});

parcelRegister("5rVQI", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY", () => $c7aab549acec9d6e$export$5ea2dca0a260365d);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $c7aab549acec9d6e$export$5ea2dca0a260365d = /*#__PURE__*/ function(COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY) {
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["createIssue"] = 0] = "createIssue";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["searchOnCurrentPage"] = 1] = "searchOnCurrentPage";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openQuickSearch"] = 2] = "openQuickSearch";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["copyUrl"] = 3] = "copyUrl";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["checkNotifications"] = 4] = "checkNotifications";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openFilterPopup"] = 5] = "openFilterPopup";
    return COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY;
}({});

});

parcelRegister("eG9rp", function(module, exports) {

$parcel$export(module.exports, "useCommandKeywords", () => $61ebfb9239c4f8e5$export$4d8fe3ef6385358);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dYWZb = parcelRequire("dYWZb");
const $61ebfb9239c4f8e5$export$4d8fe3ef6385358 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getKeywords = (0, $5uXOq.useCallback)((keywordGroup)=>(0, $dYWZb.messages)[keywordGroup] ? formatMessage((0, $dYWZb.messages)[keywordGroup]) : undefined, [
        formatMessage
    ]);
    return {
        getKeywords: getKeywords
    };
};

});
parcelRegister("dYWZb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $df7d7dd7b88156b7$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $df7d7dd7b88156b7$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    searchYourIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
        "defaultMessage": "Find my ideas tickets requests tasks work"
    },
    changeStatusSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
        "defaultMessage": "Move through workflow  Progress Done Complete transition"
    },
    assignToMeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
        "defaultMessage": "self"
    },
    assignIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
        "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
    },
    startWatchingIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
        "defaultMessage": "Follow work Track Unwatch Unfollow"
    },
    backlogSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
        "defaultMessage": "Inventory Go"
    },
    boardSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
        "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
    },
    reportsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
        "defaultMessage": "Summary Insights Burndown Go"
    },
    timelineSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
        "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
    },
    // TODO cleanup isCommandPaletteQuickSearchEnabled
    quickSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
        "defaultMessage": "Search products across Atlassian Go to"
    },
    pageSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
        "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
    },
    createIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
        "defaultMessage": "work Start idea New ticket task"
    },
    switchDarkThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
        "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    matchSystemThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
        "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    copyCurrentPageUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
        "defaultMessage": "link website address"
    },
    getHelpSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
        "defaultMessage": "In-product Support Documentation Questions Answers"
    },
    viewKeyboardShortcutsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
        "defaultMessage": "Hotkeys Show See"
    },
    editDescriptionSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
        "defaultMessage": "Completion criteria Info Information Details Add Write"
    },
    addAttachmentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
        "defaultMessage": "Attach Upload Document Media"
    },
    addCommentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
        "defaultMessage": "Write Message"
    },
    logWorkSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
        "defaultMessage": "Track Record hours Time spent"
    },
    addRemoveFlagSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
        "defaultMessage": "Unflag Mark Unmark Star Unstar"
    },
    cloneIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
        "defaultMessage": "Copy Duplicate Task Idea Request"
    },
    linkConfluencePageSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
        "defaultMessage": "Relate Add Connect"
    },
    addAUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
        "defaultMessage": "Connect Weblink Link Website Domain"
    },
    goToIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
        "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
    },
    goToPersonalSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
        "defaultMessage": "Preferences Notifications Theme Jira labs"
    },
    goToAccountSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
        "defaultMessage": "Preferences Privacy Profile Your details Personal information"
    },
    viewAllIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
        "defaultMessage": "Site issues JQL View all"
    },
    viewAllProjectsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllPlansSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllBoardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllFiltersSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllDashboardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
        "defaultMessage": "List Go"
    },
    checkNotificationsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
        "defaultMessage": "window See Updates"
    },
    goToUserManagementSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
        "defaultMessage": "Permissions"
    },
    goToIssuesSynonymsIssueTermRefresh: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms-issue-term-refresh",
        "defaultMessage": "Advanced work item search Project Filter JQL search list View all"
    },
    viewAllIssuesSynonymsIssueTermRefresh: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms-issue-term-refresh",
        "defaultMessage": "Site work items JQL View all"
    }
});

});


parcelRegister("879xD", function(module, exports) {

$parcel$export(module.exports, "CommandShortcuts", () => $6700f9962d7215c2$export$7ff7e4fe85a5960a);

var $5uXOq = parcelRequire("5uXOq");

var $1Kt4o = parcelRequire("1Kt4o");

var $556k7 = parcelRequire("556k7");

var $jh7L9 = parcelRequire("jh7L9");

var $3Tty1 = parcelRequire("3Tty1");
const $6700f9962d7215c2$export$7ff7e4fe85a5960a = (props)=>{
    const { keyMap: keyMap } = props;
    const mappedCommands = (0, $5uXOq.useMemo)(()=>{
        const commands = [];
        Object.entries(keyMap).forEach(([key, mapItem])=>{
            if (!mapItem.registerInCommandPalette) return;
            const { primaryAction: primaryAction, ...command } = mapItem.registerInCommandPalette;
            let shortcutPrimaryAction;
            if (primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST || primaryAction?.type === (0, $jh7L9.CommandActionType).PERFORM) shortcutPrimaryAction = primaryAction;
            else if (mapItem.callback) shortcutPrimaryAction = {
                type: (0, $jh7L9.CommandActionType).PERFORM,
                perform: ()=>mapItem.callback()
            };
            /**
			 * loadChildren function has the preference over the other actions
			 * followed by perform and then, if none set, the KeyMap callback
			 */ commands.push({
                id: `command-shortcut-${key}`,
                shortcut: key,
                ...command,
                primaryAction: shortcutPrimaryAction
            });
        });
        return commands;
    }, [
        keyMap
    ]);
    /**
	 * As mappedCommands is an object, it changes at every render.
	 * To memoise the commands properly in the command palette
	 * the ids are stringified and add as a dependency of the effect
	 */ const shortcutIds = (0, $5uXOq.useMemo)(()=>mappedCommands.map(({ id: id })=>id).toString(), [
        mappedCommands
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), props), !!mappedCommands.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $556k7.RegisterCommands), {
        registrationId: (0, $1Kt4o.COMMAND_PALETTE_REGISTRY_IDS).SHORTCUTS,
        commands: mappedCommands,
        deps: [
            shortcutIds
        ]
    }));
};

});
parcelRegister("1Kt4o", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $3add01bee0e3b846$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $3add01bee0e3b846$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $3add01bee0e3b846$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE',
    FORGE: 'FORGE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $3add01bee0e3b846$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $3add01bee0e3b846$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.COPY_URL,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.DESCRIPTION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.LOG_WORK,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.PARENT,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_ADD,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_SEARCH,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.SHORTCUTS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.STATUS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.STORY_POINTS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.THEME_MODE,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    }
};

});

parcelRegister("556k7", function(module, exports) {

$parcel$export(module.exports, "RegisterCommands", () => $ba0d6dd9c2ef02f6$export$cd555833c78729f1);

var $5uXOq = parcelRequire("5uXOq");

var $buHQa = parcelRequire("buHQa");
const $ba0d6dd9c2ef02f6$export$cd555833c78729f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buHQa.RegisterCommandsWithRegistry), props);

});
parcelRegister("buHQa", function(module, exports) {

$parcel$export(module.exports, "RegisterCommandsWithRegistry", () => $3f4c8625aa6e8942$export$b8955a01360d2876);

var $6QoIp = parcelRequire("6QoIp");
function $3f4c8625aa6e8942$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
    (0, $6QoIp.useRegisterCommandsWithRegistry)(registrationId, commands, deps);
    return null;
}

});
parcelRegister("6QoIp", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandsWithRegistry", () => $9d04f6fb396fa7c9$export$8a824ae164ff968d);

var $5uXOq = parcelRequire("5uXOq");

var $fIZf0 = parcelRequire("fIZf0");
function $9d04f6fb396fa7c9$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
    const subscribe = (0, $fIZf0.useSubscribeCommandsWithRegistry)();
    const commandCache = (0, $5uXOq.useRef)(commands);
    (0, $5uXOq.useEffect)(()=>{
        commandCache.current = commands;
    }, [
        commands
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>subscribe(registrationId, commandCache.current), [
        ...dependencies,
        subscribe
    ]);
}

});
parcelRegister("fIZf0", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $72118e9f2599bc72$export$880fc01e31710b27);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");
function $72118e9f2599bc72$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $d8lE2.useActionsCommandPalette)();
    const subscribe = (0, $5uXOq.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});
parcelRegister("d8lE2", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $f75514d959bfcca8$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $f75514d959bfcca8$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $f75514d959bfcca8$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $f75514d959bfcca8$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteHasChildPopup", () => $f75514d959bfcca8$export$a18633b655403b12);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $f75514d959bfcca8$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $f75514d959bfcca8$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $f75514d959bfcca8$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $f75514d959bfcca8$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $f75514d959bfcca8$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $f75514d959bfcca8$export$bbc05723eb144e03);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $gM5ou = parcelRequire("gM5ou");

var $2sRNe = parcelRequire("2sRNe");
const $f75514d959bfcca8$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $f75514d959bfcca8$var$store = (0, $iXqE5.createStore)({
    initialState: $f75514d959bfcca8$var$initialState,
    actions: $2sRNe.actions,
    name: 'commandPalette'
});
const $f75514d959bfcca8$export$6b58f9610017fbb7 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store);
const $f75514d959bfcca8$export$72aa7bc7c6a83c36 = (0, $3sQ5x.createActionsHook)($f75514d959bfcca8$var$store);
const $f75514d959bfcca8$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $f75514d959bfcca8$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $f75514d959bfcca8$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $gM5ou.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $gM5ou.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $gM5ou.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        relevancyModel: 'v2-string-similarity'
    });
const $f75514d959bfcca8$export$1f90c8f89f98110e = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: $f75514d959bfcca8$export$56f06313122d0aac
});
const $f75514d959bfcca8$export$cc979be9b69236df = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $f75514d959bfcca8$export$a18633b655403b12 = (0, $3sQ5x.createStateHook)($f75514d959bfcca8$var$store, {
    selector: (state)=>state.hasPopupOverlay
});
const $f75514d959bfcca8$export$af8fd8cd4b048315 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $f75514d959bfcca8$export$4372697329bd9cbe = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $f75514d959bfcca8$export$7422170a403e909 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $f75514d959bfcca8$export$282aa48e4a3afada = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $f75514d959bfcca8$export$96819dfb22ad05d3 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $f75514d959bfcca8$export$a40e8ae3e53feab0 = (0, $6dDSs.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $gM5ou.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $f75514d959bfcca8$export$f893891deedab3c6 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: $f75514d959bfcca8$export$a40e8ae3e53feab0
});
const $f75514d959bfcca8$export$bbc05723eb144e03 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("gM5ou", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $cf289af0c139712c$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $cf289af0c139712c$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $cf289af0c139712c$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $cf289af0c139712c$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $cf289af0c139712c$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $cf289af0c139712c$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $cf289af0c139712c$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $cf289af0c139712c$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $cf289af0c139712c$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $cf289af0c139712c$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $cf289af0c139712c$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $cf289af0c139712c$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $cf289af0c139712c$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $cf289af0c139712c$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $cf289af0c139712c$export$c3d20e8c1e93a572);

var $5uXOq = parcelRequire("5uXOq");

var $bdDiz = parcelRequire("bdDiz");

var $2f2jJ = parcelRequire("2f2jJ");

var $bcTvL = parcelRequire("bcTvL");

var $jh7L9 = parcelRequire("jh7L9");
const $cf289af0c139712c$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $cf289af0c139712c$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $cf289af0c139712c$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $cf289af0c139712c$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $cf289af0c139712c$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $cf289af0c139712c$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $cf289af0c139712c$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $cf289af0c139712c$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $cf289af0c139712c$export$389b0273703d5c48(sections)
    };
};
const $cf289af0c139712c$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $cf289af0c139712c$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...$cf289af0c139712c$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
        ...$cf289af0c139712c$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$cf289af0c139712c$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $cf289af0c139712c$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $cf289af0c139712c$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $cf289af0c139712c$export$daa5beabdf8d9fc3 = (event)=>(0, $2f2jJ.isMacOs)() ? event.metaKey : event.ctrlKey;
const $cf289af0c139712c$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $cf289af0c139712c$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $cf289af0c139712c$export$fa1c95a5ffa92036 = (str)=>(0, $bdDiz.createHash)().update(str).digest('hex');
const $cf289af0c139712c$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $cf289af0c139712c$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $cf289af0c139712c$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $cf289af0c139712c$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("2f2jJ", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $6846128323867ebd$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $6846128323867ebd$export$fe66dae91c68619b);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6846128323867ebd$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $6846128323867ebd$export$fe66dae91c68619b = ()=>$6846128323867ebd$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("bcTvL", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $3996a4302dca83b1$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $3996a4302dca83b1$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $3996a4302dca83b1$export$1ee9d153576afd13);
$parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", () => $3996a4302dca83b1$export$894e19fc96687503);
// EVENT TYPES
const $3996a4302dca83b1$export$a1562d08625f5d7e = 'UI';
const $3996a4302dca83b1$export$947dac6c72b26f81 = 'TRACK';
const $3996a4302dca83b1$export$f1d537d508d2945a = 'SCREEN';
const $3996a4302dca83b1$export$12346a674644c156 = 'OPERATIONAL';
var $3996a4302dca83b1$export$1ee9d153576afd13 = /*#__PURE__*/ function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
    return SHORTCUT_ELEMENT_TYPES;
}({});
const $3996a4302dca83b1$export$894e19fc96687503 = 250;

});

parcelRegister("jh7L9", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3);
var $b1e48ebd4c8d5e4e$export$f041b1b117ab382f = /*#__PURE__*/ function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
    return CommandActionType;
}({});
const $b1e48ebd4c8d5e4e$export$3e448fd53031e13c = Object.values($b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
const $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3 = [
    "command-list"
];

});


parcelRegister("2sRNe", function(module, exports) {

$parcel$export(module.exports, "actions", () => $4f4c9e92d50d4f24$export$e324594224ef24da);

var $kGsr8 = parcelRequire("kGsr8");

var $7Jxgt = parcelRequire("7Jxgt");

var $izip4 = parcelRequire("izip4");

var $8yVxK = parcelRequire("8yVxK");

var $2f2jJ = parcelRequire("2f2jJ");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $bcTvL = parcelRequire("bcTvL");

var $jh7L9 = parcelRequire("jh7L9");

var $gM5ou = parcelRequire("gM5ou");

var $4DwnT = parcelRequire("4DwnT");

var $h3eZO = parcelRequire("h3eZO");

var $feUec = parcelRequire("feUec");
const $4f4c9e92d50d4f24$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $4f4c9e92d50d4f24$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        setState({
            commandPaletteSessionId: (0, $7Jxgt.v4)(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $4f4c9e92d50d4f24$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$4f4c9e92d50d4f24$var$rootCommands
        });
    };
const $4f4c9e92d50d4f24$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, $7Jxgt.v4)() : '',
            ...!isOpen ? $4f4c9e92d50d4f24$var$rootCommands : {}
        });
    };
const $4f4c9e92d50d4f24$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $4f4c9e92d50d4f24$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $4f4c9e92d50d4f24$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $4f4c9e92d50d4f24$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $4f4c9e92d50d4f24$var$forceSearchValue = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            shouldForceSearchValue: true
        });
    };
const $4f4c9e92d50d4f24$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
        setState({
            shouldForceSearchValue: false
        });
    };
const $4f4c9e92d50d4f24$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $bcTvL.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $4f4c9e92d50d4f24$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $4f4c9e92d50d4f24$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $4f4c9e92d50d4f24$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $gM5ou.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $4f4c9e92d50d4f24$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $8yVxK.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                    if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                        const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        onAnalytics(performAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                            attributes: onClosePendingCommandAction?.analyticsArgs
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $jcw0u.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $izip4.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $4f4c9e92d50d4f24$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $4DwnT.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $gM5ou.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $feUec.setEventAttribute)(analyticsAttributes);
        const currentCommandAction = (0, $gM5ou.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $gM5ou.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $jh7L9.CommandActionType).PERFORM;
        if (command.mode) newState.shouldForceSearchValue = true;
        if (shouldLoadChildren) {
            (0, $8yVxK.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $h3eZO.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if (currentCommandAction.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $bcTvL.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $2f2jJ.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $8yVxK.default)('command-palette-executed');
                currentCommandAction.perform();
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const performAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'taskSucceeded',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(performAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $izip4.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analyticsAttributes,
                    createAnalyticsEvent: analytics?.createAnalyticsEvent
                }
            });
        }
    };
const $4f4c9e92d50d4f24$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $4f4c9e92d50d4f24$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $4f4c9e92d50d4f24$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $4f4c9e92d50d4f24$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $4f4c9e92d50d4f24$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $4f4c9e92d50d4f24$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $4f4c9e92d50d4f24$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $4f4c9e92d50d4f24$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $4f4c9e92d50d4f24$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $4f4c9e92d50d4f24$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $4f4c9e92d50d4f24$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $4f4c9e92d50d4f24$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $4f4c9e92d50d4f24$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
        setState({
            hasPopupOverlay: hasPopupOverlay
        });
    };
const $4f4c9e92d50d4f24$export$e324594224ef24da = {
    open: $4f4c9e92d50d4f24$var$open,
    toggle: $4f4c9e92d50d4f24$var$toggle,
    close: $4f4c9e92d50d4f24$var$close,
    addCommands: $4f4c9e92d50d4f24$var$addCommands,
    removeCommands: $4f4c9e92d50d4f24$var$removeCommands,
    handleSearch: $4f4c9e92d50d4f24$var$handleSearch,
    forceFocusSearch: $4f4c9e92d50d4f24$var$forceFocusSearch,
    setActiveIndex: $4f4c9e92d50d4f24$var$setActiveIndex,
    executeCommand: $4f4c9e92d50d4f24$var$executeCommand,
    goBackLevel: $4f4c9e92d50d4f24$var$goBackLevel,
    setChildCommands: $4f4c9e92d50d4f24$var$setChildCommands,
    setLoadingList: $4f4c9e92d50d4f24$var$setLoadingList,
    setFocusInput: $4f4c9e92d50d4f24$var$setFocusInput,
    registerSections: $4f4c9e92d50d4f24$var$registerSections,
    unregisterSections: $4f4c9e92d50d4f24$var$unregisterSections,
    markAsLoaded: $4f4c9e92d50d4f24$var$markAsLoaded,
    getAnalyticsAttributes: $4f4c9e92d50d4f24$var$getAnalyticsAttributes,
    setIsDisabled: $4f4c9e92d50d4f24$var$setIsDisabled,
    setRegistry: $4f4c9e92d50d4f24$var$setRegistry,
    updateActiveRegistry: $4f4c9e92d50d4f24$var$updateActiveRegistry,
    removeCommandsById: $4f4c9e92d50d4f24$var$removeCommandsById,
    removeFromActiveRegistry: $4f4c9e92d50d4f24$var$removeFromActiveRegistry,
    performDialogCloseCommand: $4f4c9e92d50d4f24$var$performDialogCloseCommand,
    setAnalytics: $4f4c9e92d50d4f24$var$setAnalytics,
    setFallbackOverride: $4f4c9e92d50d4f24$var$setFallbackOverride,
    setHasPopupOverlay: $4f4c9e92d50d4f24$var$setHasPopupOverlay,
    forceSearchValue: $4f4c9e92d50d4f24$var$forceSearchValue,
    resetShouldForceSearchValue: $4f4c9e92d50d4f24$var$resetShouldForceSearchValue
};

});
parcelRegister("4DwnT", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $b4088022dc3f5c54$export$639b7f41b0b47a01);

var $jh7L9 = parcelRequire("jh7L9");
const $b4088022dc3f5c54$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("h3eZO", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $dd5db8363c7eeda7$export$d75616d77443fe4e);

var $jh7L9 = parcelRequire("jh7L9");
const $dd5db8363c7eeda7$export$d75616d77443fe4e = (action)=>action?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});

parcelRegister("feUec", function(module, exports) {

$parcel$export(module.exports, "setEventAttribute", () => $dd73b01c41e7185b$export$7c0a9f4caaf7cfce);

var $5fc53 = parcelRequire("5fc53");

var $ctrpc = parcelRequire("ctrpc");
const $dd73b01c41e7185b$var$ACTIONS_TO_WATCH = [
    'unassign',
    'assignToMe'
];
const $dd73b01c41e7185b$export$7c0a9f4caaf7cfce = (attributes)=>{
    if (attributes.actionCategory === 'issueActions' && typeof attributes.action === 'string' && $dd73b01c41e7185b$var$ACTIONS_TO_WATCH.includes(attributes.action)) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().setAttributes((0, $5fc53.ASSIGNEE_TYPE), {
        isCommandPaletteEditing: true
    });
};

});
parcelRegister("5fc53", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $81f079589240b9b7$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $81f079589240b9b7$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $81f079589240b9b7$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $81f079589240b9b7$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $81f079589240b9b7$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $81f079589240b9b7$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $81f079589240b9b7$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $81f079589240b9b7$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $81f079589240b9b7$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $81f079589240b9b7$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $81f079589240b9b7$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $81f079589240b9b7$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $81f079589240b9b7$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $81f079589240b9b7$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $81f079589240b9b7$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $81f079589240b9b7$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $81f079589240b9b7$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $81f079589240b9b7$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $81f079589240b9b7$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $81f079589240b9b7$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $81f079589240b9b7$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $81f079589240b9b7$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $81f079589240b9b7$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $81f079589240b9b7$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $81f079589240b9b7$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $81f079589240b9b7$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $81f079589240b9b7$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $81f079589240b9b7$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $81f079589240b9b7$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$31aea7548807c6b5);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $81f079589240b9b7$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $81f079589240b9b7$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $81f079589240b9b7$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $81f079589240b9b7$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $81f079589240b9b7$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $81f079589240b9b7$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $81f079589240b9b7$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $81f079589240b9b7$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $81f079589240b9b7$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $81f079589240b9b7$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $81f079589240b9b7$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $81f079589240b9b7$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $81f079589240b9b7$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $81f079589240b9b7$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $81f079589240b9b7$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $81f079589240b9b7$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $81f079589240b9b7$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $81f079589240b9b7$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $81f079589240b9b7$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $81f079589240b9b7$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $81f079589240b9b7$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $81f079589240b9b7$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $81f079589240b9b7$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $81f079589240b9b7$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $81f079589240b9b7$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $81f079589240b9b7$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $81f079589240b9b7$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $81f079589240b9b7$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $81f079589240b9b7$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $81f079589240b9b7$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $81f079589240b9b7$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $81f079589240b9b7$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $81f079589240b9b7$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", () => $81f079589240b9b7$export$699805cbca2c41d);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $81f079589240b9b7$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $81f079589240b9b7$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $81f079589240b9b7$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $81f079589240b9b7$export$bfcb1a91094f113a);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $81f079589240b9b7$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "JCS_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$7fe9e7bac5a59952);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $81f079589240b9b7$export$798d2f5814884447);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $81f079589240b9b7$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $81f079589240b9b7$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $81f079589240b9b7$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $81f079589240b9b7$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $81f079589240b9b7$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $81f079589240b9b7$export$492b0fa4fe201a22);
$parcel$export(module.exports, "URL_CF_TYPE", () => $81f079589240b9b7$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $81f079589240b9b7$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $81f079589240b9b7$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $81f079589240b9b7$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $81f079589240b9b7$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $81f079589240b9b7$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $81f079589240b9b7$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $81f079589240b9b7$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $81f079589240b9b7$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $81f079589240b9b7$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $81f079589240b9b7$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $81f079589240b9b7$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $81f079589240b9b7$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $81f079589240b9b7$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $81f079589240b9b7$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $81f079589240b9b7$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $81f079589240b9b7$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $81f079589240b9b7$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $81f079589240b9b7$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $81f079589240b9b7$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $81f079589240b9b7$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $81f079589240b9b7$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $81f079589240b9b7$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $81f079589240b9b7$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $81f079589240b9b7$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $81f079589240b9b7$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $81f079589240b9b7$export$34317c2d84a93553);
$parcel$export(module.exports, "ORGANIZATION_CF_TYPE", () => $81f079589240b9b7$export$c1e26582406f77ec);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $81f079589240b9b7$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $81f079589240b9b7$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $81f079589240b9b7$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $81f079589240b9b7$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $81f079589240b9b7$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $81f079589240b9b7$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $81f079589240b9b7$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $81f079589240b9b7$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $81f079589240b9b7$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $81f079589240b9b7$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $81f079589240b9b7$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $81f079589240b9b7$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $81f079589240b9b7$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $81f079589240b9b7$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $81f079589240b9b7$export$2d75b47d12efc812);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $81f079589240b9b7$export$7b79405842547ccb);
$parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", () => $81f079589240b9b7$export$96201d0ae03ca323);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $81f079589240b9b7$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $81f079589240b9b7$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $81f079589240b9b7$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $81f079589240b9b7$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $81f079589240b9b7$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $81f079589240b9b7$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $81f079589240b9b7$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $81f079589240b9b7$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $81f079589240b9b7$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $81f079589240b9b7$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $81f079589240b9b7$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $81f079589240b9b7$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $81f079589240b9b7$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $81f079589240b9b7$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $81f079589240b9b7$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $81f079589240b9b7$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $81f079589240b9b7$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $81f079589240b9b7$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $81f079589240b9b7$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $81f079589240b9b7$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $81f079589240b9b7$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $81f079589240b9b7$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $81f079589240b9b7$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $81f079589240b9b7$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $81f079589240b9b7$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $81f079589240b9b7$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $81f079589240b9b7$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $81f079589240b9b7$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $81f079589240b9b7$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $81f079589240b9b7$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $81f079589240b9b7$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $81f079589240b9b7$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $81f079589240b9b7$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $81f079589240b9b7$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $81f079589240b9b7$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $81f079589240b9b7$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $81f079589240b9b7$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $81f079589240b9b7$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $81f079589240b9b7$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $81f079589240b9b7$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $81f079589240b9b7$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $81f079589240b9b7$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $81f079589240b9b7$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $81f079589240b9b7$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $81f079589240b9b7$export$b5358afda8ff335e);
$parcel$export(module.exports, "JOURNEY_PANEL_TYPE", () => $81f079589240b9b7$export$d2a475ff30e5bf97);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $81f079589240b9b7$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $81f079589240b9b7$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $81f079589240b9b7$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $81f079589240b9b7$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $81f079589240b9b7$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $81f079589240b9b7$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $81f079589240b9b7$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $81f079589240b9b7$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $81f079589240b9b7$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $81f079589240b9b7$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $81f079589240b9b7$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $81f079589240b9b7$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $81f079589240b9b7$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $81f079589240b9b7$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $81f079589240b9b7$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $81f079589240b9b7$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $81f079589240b9b7$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $81f079589240b9b7$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $81f079589240b9b7$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $81f079589240b9b7$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $81f079589240b9b7$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $81f079589240b9b7$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $81f079589240b9b7$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $81f079589240b9b7$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $81f079589240b9b7$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $81f079589240b9b7$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $81f079589240b9b7$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $81f079589240b9b7$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $81f079589240b9b7$export$3c3e26aadbfa2c32);

var $8QpSo = parcelRequire("8QpSo");

var $4R6GH = parcelRequire("4R6GH");
const $81f079589240b9b7$export$b144116dae474c88 = 'issue-link-search';
const $81f079589240b9b7$export$bc917bc699b25f75 = 'number';
const $81f079589240b9b7$export$5f26ca419fdffbe7 = 'string';
const $81f079589240b9b7$export$ce9bfd823c7e1a6d = 'datetime';
const $81f079589240b9b7$export$346b72b1f7cd6d5a = 'date';
const $81f079589240b9b7$export$b20fbcacd7942c2a = 'option2';
const $81f079589240b9b7$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $81f079589240b9b7$export$a2e8554bffc61ece = 'any';
const $81f079589240b9b7$export$f25cd4907cbb25b9 = 'array';
const $81f079589240b9b7$export$5600354b43577e17 = 'user';
const $81f079589240b9b7$export$5dbc9917f72d0d2a = 'group';
const $81f079589240b9b7$export$253649f07fb55948 = 'object';
const $81f079589240b9b7$export$eb39592ba5247ee7 = 'group-list';
const $81f079589240b9b7$export$f48a9be226105736 = 'array-string';
const $81f079589240b9b7$export$42e2e93fc721df5d = 'version';
const $81f079589240b9b7$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$7773375e72c953ed = 'approval-panel';
const $81f079589240b9b7$export$80ad0037098f3919 = 'project';
const $81f079589240b9b7$export$82db8a26de491dd2 = 'array';
const $81f079589240b9b7$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $81f079589240b9b7$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $81f079589240b9b7$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $81f079589240b9b7$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $81f079589240b9b7$export$c979d9c548c05133 = 'JiraBooleanField';
const $81f079589240b9b7$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $81f079589240b9b7$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $81f079589240b9b7$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $81f079589240b9b7$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $81f079589240b9b7$export$b0deb225eed90fbd = 'JiraCMDBField';
const $81f079589240b9b7$export$add3775cfea8fde3 = 'JiraColorField';
const $81f079589240b9b7$export$9631d4098abab3eb = 'JiraComponentsField';
const $81f079589240b9b7$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $81f079589240b9b7$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $81f079589240b9b7$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $81f079589240b9b7$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $81f079589240b9b7$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $81f079589240b9b7$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $81f079589240b9b7$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $81f079589240b9b7$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $81f079589240b9b7$export$6d8da4497234455 = 'JiraEpicLinkField';
const $81f079589240b9b7$export$9bcfac568e4fa59c = 'JiraFlagField';
const $81f079589240b9b7$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $81f079589240b9b7$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $81f079589240b9b7$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $81f079589240b9b7$export$810709f0c5c2e9db = 'JiraLabelsField';
const $81f079589240b9b7$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $81f079589240b9b7$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $81f079589240b9b7$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $81f079589240b9b7$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $81f079589240b9b7$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $81f079589240b9b7$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $81f079589240b9b7$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $81f079589240b9b7$export$31aea7548807c6b5 = 'JiraPeopleField';
const $81f079589240b9b7$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $81f079589240b9b7$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $81f079589240b9b7$export$12f54499c6252188 = 'JiraProjectField';
const $81f079589240b9b7$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $81f079589240b9b7$export$c69486dd643dfb69 = 'JiraReporterField';
const $81f079589240b9b7$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $81f079589240b9b7$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $81f079589240b9b7$export$37f4daaa7b409554 = 'JiraRichTextField';
const $81f079589240b9b7$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $81f079589240b9b7$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $81f079589240b9b7$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $81f079589240b9b7$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $81f079589240b9b7$export$e40f819979b3881d = 'JiraStatusField';
const $81f079589240b9b7$export$6c243704a22baffe = 'JiraTeamField';
const $81f079589240b9b7$export$6c32429bac235203 = 'JiraTeamViewField';
const $81f079589240b9b7$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $81f079589240b9b7$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $81f079589240b9b7$export$37ccd11f08a93ccb = 'JiraUrlField';
const $81f079589240b9b7$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $81f079589240b9b7$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $81f079589240b9b7$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $81f079589240b9b7$export$aa815aaa741ae18 = 'JiraWatchesField';
const $81f079589240b9b7$export$e805f89b15d2abf4 = 'JiraAssetField';
const $81f079589240b9b7$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $81f079589240b9b7$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $81f079589240b9b7$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $81f079589240b9b7$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $81f079589240b9b7$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $81f079589240b9b7$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $81f079589240b9b7$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $81f079589240b9b7$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $81f079589240b9b7$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $81f079589240b9b7$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $81f079589240b9b7$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $81f079589240b9b7$export$c48132adab502d6b = 'JiraForgeUsersField';
const $81f079589240b9b7$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $81f079589240b9b7$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $81f079589240b9b7$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $81f079589240b9b7$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $81f079589240b9b7$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $81f079589240b9b7$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $81f079589240b9b7$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $81f079589240b9b7$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $81f079589240b9b7$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $81f079589240b9b7$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
const $81f079589240b9b7$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $81f079589240b9b7$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $81f079589240b9b7$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $81f079589240b9b7$export$bfcb1a91094f113a = 'JiraGoalsField';
const $81f079589240b9b7$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $81f079589240b9b7$export$7fe9e7bac5a59952 = 'JiraCustomerServiceOrganizationField';
const $81f079589240b9b7$export$798d2f5814884447 = 'forgeCustomField';
const $81f079589240b9b7$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $81f079589240b9b7$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $81f079589240b9b7$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $81f079589240b9b7$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $81f079589240b9b7$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $81f079589240b9b7$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $81f079589240b9b7$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $81f079589240b9b7$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $81f079589240b9b7$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $81f079589240b9b7$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $81f079589240b9b7$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $81f079589240b9b7$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $81f079589240b9b7$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $81f079589240b9b7$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $81f079589240b9b7$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $81f079589240b9b7$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $81f079589240b9b7$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $81f079589240b9b7$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $81f079589240b9b7$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $81f079589240b9b7$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $81f079589240b9b7$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $81f079589240b9b7$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $81f079589240b9b7$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $81f079589240b9b7$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $81f079589240b9b7$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $81f079589240b9b7$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $81f079589240b9b7$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $81f079589240b9b7$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $81f079589240b9b7$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $81f079589240b9b7$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $81f079589240b9b7$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $81f079589240b9b7$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $81f079589240b9b7$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $81f079589240b9b7$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $81f079589240b9b7$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $81f079589240b9b7$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $81f079589240b9b7$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
const $81f079589240b9b7$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $81f079589240b9b7$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $81f079589240b9b7$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $81f079589240b9b7$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $81f079589240b9b7$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $81f079589240b9b7$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $81f079589240b9b7$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $81f079589240b9b7$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $81f079589240b9b7$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $81f079589240b9b7$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $81f079589240b9b7$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $81f079589240b9b7$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $81f079589240b9b7$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $81f079589240b9b7$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $81f079589240b9b7$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $81f079589240b9b7$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $81f079589240b9b7$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $81f079589240b9b7$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $81f079589240b9b7$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $81f079589240b9b7$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $81f079589240b9b7$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $81f079589240b9b7$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $81f079589240b9b7$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $81f079589240b9b7$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $81f079589240b9b7$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $81f079589240b9b7$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $81f079589240b9b7$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $81f079589240b9b7$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $81f079589240b9b7$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $81f079589240b9b7$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $81f079589240b9b7$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $81f079589240b9b7$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $81f079589240b9b7$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $81f079589240b9b7$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $81f079589240b9b7$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $81f079589240b9b7$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $81f079589240b9b7$export$fba8634fd401ba8b = 'assignee';
const $81f079589240b9b7$export$a91aea2438afcce8 = 'reporter';
const $81f079589240b9b7$export$b159f8b8f27aae4c = 'duedate';
const $81f079589240b9b7$export$34740f8d07d23ac0 = 'priority';
const $81f079589240b9b7$export$43b6e33ec70f2272 = 'labels';
const $81f079589240b9b7$export$ff39ebd4bb12b718 = 'created';
const $81f079589240b9b7$export$cd8e68094cb5c3cb = 'updated';
const $81f079589240b9b7$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $81f079589240b9b7$export$37abf56f13f61ec5 = 'components';
const $81f079589240b9b7$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $81f079589240b9b7$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $81f079589240b9b7$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $81f079589240b9b7$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $81f079589240b9b7$export$791007408faf42f4 = 'servicedesk-incident-management';
const $81f079589240b9b7$export$827a1c600bac12a3 = 'devSummary';
const $81f079589240b9b7$export$e9ba671d077969f8 = 'releases';
const $81f079589240b9b7$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $81f079589240b9b7$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $81f079589240b9b7$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $81f079589240b9b7$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $81f079589240b9b7$export$a5c9f63aadcb220 = 'fixVersions';
const $81f079589240b9b7$export$94009605902e4fe5 = 'versions';
const $81f079589240b9b7$export$5e7324042f1d6b31 = 'description';
const $81f079589240b9b7$export$113281d03e6830ef = 'environment';
const $81f079589240b9b7$export$5ff798870a3dffbf = 'watches';
const $81f079589240b9b7$export$907219511d14ba3d = 'summary';
const $81f079589240b9b7$export$d09aa6a4f3538063 = 'proforma-forms';
const $81f079589240b9b7$export$3aca8c91b58a42e2 = 'resolution';
const $81f079589240b9b7$export$ccb5ffefbf8b987c = 'timetracking';
const $81f079589240b9b7$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $81f079589240b9b7$export$358267065be1e = 'status';
const $81f079589240b9b7$export$dcaa788c7ada56de = 'statusCategory';
const $81f079589240b9b7$export$ebb48b08205007c5 = 'issuetype';
const $81f079589240b9b7$export$5e91047fe9955d0e = 'issuekey';
const $81f079589240b9b7$export$3b3d0889022c85b3 = 'children-issues';
const $81f079589240b9b7$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $81f079589240b9b7$export$8fe3d5be8cb17459 = 'epic-issues';
const $81f079589240b9b7$export$335851d83a79891 = 'hierarchy-level-below';
const $81f079589240b9b7$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $81f079589240b9b7$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $81f079589240b9b7$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $81f079589240b9b7$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $81f079589240b9b7$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $81f079589240b9b7$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $81f079589240b9b7$export$7b3d247435a784fa = 'SLA_PANEL';
const $81f079589240b9b7$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $81f079589240b9b7$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $81f079589240b9b7$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $81f079589240b9b7$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $81f079589240b9b7$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $81f079589240b9b7$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $81f079589240b9b7$export$d2a475ff30e5bf97 = 'JOURNEY_PANEL';
const $81f079589240b9b7$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $81f079589240b9b7$export$22f61ccc2730431f = 'similar-issues';
const $81f079589240b9b7$export$8bbb446f57294715 = 'subtasks';
const $81f079589240b9b7$export$34fcd7cb291a1e4d = 'votes';
const $81f079589240b9b7$export$5e93f2a57cc4ca3a = 'parent';
const $81f079589240b9b7$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$91a9dba2d38d9a6f = 'project';
const $81f079589240b9b7$export$df36fc05622c402 = 'worklog';
const $81f079589240b9b7$export$ede0a4c20124ec85 = 'timespent';
const $81f079589240b9b7$export$3eeb79d48fb5f667 = 'dataclassification';
const $81f079589240b9b7$export$45e72c9a63ab61ab = 'SENTIMENT';
const $81f079589240b9b7$export$99ad62164189f781 = 'ecosystemGlance';
const $81f079589240b9b7$export$7719ef6e9283671 = 'forgeGlance';
const $81f079589240b9b7$export$bfebea5ce2e1887a = 'ecosystemContext';
const $81f079589240b9b7$export$be8e68fb1aed253e = 'forgeContext';
const $81f079589240b9b7$export$84e5674890d55030 = 'issuerestriction';
const $81f079589240b9b7$export$326a5522a485e43d = 'security';
const $81f079589240b9b7$export$c9f3f01e2c535302 = 'securitylevel';
const $81f079589240b9b7$export$35e5652f764785bd = 'creator';
const $81f079589240b9b7$export$66519f3bbff1796a = 'team';
const $81f079589240b9b7$export$a4ee0bca77cc8463 = 'estimate';
const $81f079589240b9b7$export$fed53408e89e0497 = 'dueDate';
const $81f079589240b9b7$export$d53c26f9ce31f56b = 'targetStart';
const $81f079589240b9b7$export$48f82d653f85e459 = 'targetEnd';
const $81f079589240b9b7$export$ea5a888f39f722c7 = 'startDate';
const $81f079589240b9b7$export$f245bbec12cc0e40 = 'color';
const $81f079589240b9b7$export$aed630b4b7114a59 = 'attachment';
const $81f079589240b9b7$export$b50c1a8fef07104 = 'issuelinks';
const $81f079589240b9b7$export$ea3d72f4bb7738ba = 'timeestimate';
const $81f079589240b9b7$export$a4cab0124760d860 = 'comment';
const $81f079589240b9b7$export$734929aef118d7e2 = 'worklog';
const $81f079589240b9b7$export$ffbacacb07c1d46d = 'parent';
const $81f079589240b9b7$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $81f079589240b9b7$export$278c072e2f9176ab = 'aggregatetimespent';
const $81f079589240b9b7$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $81f079589240b9b7$export$fbc5ebe2e580bf8b = 'progress';
const $81f079589240b9b7$export$aa3b37e271efd578 = 'aggregateprogress';
const $81f079589240b9b7$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $81f079589240b9b7$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $81f079589240b9b7$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $81f079589240b9b7$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $81f079589240b9b7$export$34740f8d07d23ac0,
        REPORTER_TYPE: $81f079589240b9b7$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $81f079589240b9b7$export$5e7324042f1d6b31,
        LABELS_TYPE: $81f079589240b9b7$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $81f079589240b9b7$export$37abf56f13f61ec5,
        SPRINT_TYPE: $81f079589240b9b7$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $81f079589240b9b7$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $81f079589240b9b7$export$269d70c1b1c9fb80,
        FIX_VERSIONS_TYPE: $81f079589240b9b7$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $81f079589240b9b7$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $81f079589240b9b7$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $81f079589240b9b7$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $81f079589240b9b7$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $81f079589240b9b7$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $81f079589240b9b7$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $81f079589240b9b7$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $81f079589240b9b7$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $81f079589240b9b7$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $81f079589240b9b7$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $81f079589240b9b7$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $81f079589240b9b7$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $81f079589240b9b7$export$c7ae0622b0bd5d56,
        ASSETS_CF_TYPE: $81f079589240b9b7$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $81f079589240b9b7$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $81f079589240b9b7$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $81f079589240b9b7$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $81f079589240b9b7$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $81f079589240b9b7$export$e9ba671d077969f8,
        BASELINE_START_CF_TYPE: $81f079589240b9b7$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $81f079589240b9b7$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $81f079589240b9b7$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $81f079589240b9b7$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $81f079589240b9b7$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $81f079589240b9b7$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $81f079589240b9b7$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $81f079589240b9b7$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $81f079589240b9b7$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $81f079589240b9b7$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $81f079589240b9b7$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $81f079589240b9b7$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $81f079589240b9b7$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $81f079589240b9b7$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $81f079589240b9b7$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $81f079589240b9b7$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $81f079589240b9b7$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $81f079589240b9b7$export$39866626496bbfc8,
        VERSION_CF_TYPE: $81f079589240b9b7$export$24382b4e8c58336b,
        DATE_CF_TYPE: $81f079589240b9b7$export$ff745f432984005d,
        GROUP_CF_TYPE: $81f079589240b9b7$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $81f079589240b9b7$export$b600addfa3355c57,
        USER_CF_TYPE: $81f079589240b9b7$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $81f079589240b9b7$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $81f079589240b9b7$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $81f079589240b9b7$export$65524be5675e57e6,
        TEAM_CF_TYPE: $81f079589240b9b7$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $81f079589240b9b7$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $81f079589240b9b7$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $81f079589240b9b7$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $81f079589240b9b7$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $81f079589240b9b7$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $81f079589240b9b7$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $81f079589240b9b7$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $81f079589240b9b7$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $81f079589240b9b7$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $81f079589240b9b7$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $81f079589240b9b7$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $81f079589240b9b7$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $81f079589240b9b7$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $81f079589240b9b7$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $81f079589240b9b7$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $81f079589240b9b7$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $81f079589240b9b7$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $81f079589240b9b7$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $81f079589240b9b7$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $81f079589240b9b7$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $81f079589240b9b7$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $81f079589240b9b7$export$c23f6b40da18371a,
        GOALS_CF_TYPE: $81f079589240b9b7$export$2bbb7f69c97ea279,
        PARENT_TYPE: $81f079589240b9b7$export$5e93f2a57cc4ca3a,
        FORGE_CONTEXT_TYPE: $81f079589240b9b7$export$be8e68fb1aed253e,
        SENTIMENT_CF_TYPE: $81f079589240b9b7$export$c23cfbdf83daa90d
    };
    Object.assign(types, {
        SENTIMENT_TYPE: $81f079589240b9b7$export$45e72c9a63ab61ab
    });
    if ((0, $4R6GH.fg)('jsm-journey-builder-in-issue-view')) Object.assign(types, {
        JOURNEY_PANEL_TYPE: $81f079589240b9b7$export$d2a475ff30e5bf97
    });
    return types;
};
const $81f079589240b9b7$export$3c3e26aadbfa2c32 = (0, $8QpSo.default)($81f079589240b9b7$var$getLayoutFieldTypesNonMemoized);

});

parcelRegister("ctrpc", function(module, exports) {

$parcel$export(module.exports, "eventFlowManager", () => $a32e213c0a4381f7$export$87846400a9b428fc);
$parcel$export(module.exports, "getUpdateAnalyticsFlowHelper", () => $a32e213c0a4381f7$export$f3b2b77402b2631f);

var $7Jxgt = parcelRequire("7Jxgt");

var $dJl1T = parcelRequire("dJl1T");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");

var $8ikZj = parcelRequire("8ikZj");

var $bximr = parcelRequire("bximr");
/**
 * A singleton class to provide a sessionId to track update of fields
 */ class $a32e213c0a4381f7$var$EventFlowManager {
    reset() {
        this.ids.clear();
        this.extraAttributes.clear();
    }
    push(key) {
        const id = (0, $7Jxgt.v4)();
        this.ids.set(key, id);
        return id;
    }
    pull(key, shouldDelete = true) {
        const value = this.ids.get(key);
        if (shouldDelete) this.ids.delete(key);
        return value;
    }
    constructor(){
        this.ids = new Map();
        this.extraAttributes = new Map();
    }
}
const $a32e213c0a4381f7$export$87846400a9b428fc = new $a32e213c0a4381f7$var$EventFlowManager();
/**
 * Concatenates updateSessionId, default attributes and the attributes sent through
 *  the event and/or setAttributes
 */ const $a32e213c0a4381f7$var$concatAttributes = (fieldKey, updateSessionId, attributes)=>{
    let fieldTypeValue = attributes.fieldType;
    const extraAttributes = $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.get(fieldKey);
    if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) fieldTypeValue = extraAttributes?.fieldType ?? fieldTypeValue;
    const FIELD_TYPE_MAP = (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? (0, $8ikZj.FIELD_TYPE_MAP) : (0, $8ikZj.FIELD_TYPE_MAP_OLD);
    const fieldType = fieldTypeValue && FIELD_TYPE_MAP[fieldTypeValue] ? FIELD_TYPE_MAP[fieldTypeValue] : fieldTypeValue;
    return {
        updateSessionId: updateSessionId,
        ...(0, $8ikZj.DEFAULT_ATTRIBUTES),
        ...attributes,
        ...extraAttributes,
        fieldKey: fieldKey,
        fieldType: fieldType
    };
};
const $a32e213c0a4381f7$var$hasError = (e)=>e instanceof Error;
/**
 * Provides three events START {@link fireAnalyticsStart},
 * END {@link fireAnalyticsEnd} to track the user flow when updating
 * a field and setAttributes{@link setAttributes} to set specific
 * fields attributes
 */ const $a32e213c0a4381f7$var$updateAnalyticsFlowHelper = {
    fireAnalyticsStart (fieldKey, params) {
        try {
            if ((0, $4R6GH.fg)('remove_jsm_events_from_1_event')) {
                const { assigneeId: assigneeId, product: product } = (0, $bximr.getContextAssigneeIdAndProduct)(params.analytics.context);
                if (product === 'serviceDesk') return;
                $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                    ...params.attributes
                });
                assigneeId && $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                    assigneeId: assigneeId
                });
            } else if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) {
                const assigneeId = (0, $bximr.getContextAssigneeId)(params.analytics.context);
                $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                    ...params.attributes
                });
                assigneeId && $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                    assigneeId: assigneeId
                });
            }
            const sessionid = $a32e213c0a4381f7$export$87846400a9b428fc.push(fieldKey);
            const attributes = $a32e213c0a4381f7$var$concatAttributes(fieldKey, sessionid, params.attributes);
            if ((0, $4R6GH.fg)('one_event_fast_follow_fg')) attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $8zOmE.fireUIAnalytics)(params.analytics, `${(0, $8ikZj.START_ACTION_SUBJECT)} ${(0, $8ikZj.START_ACTION)}`, (0, $8ikZj.START_ACTION_SUBJECT_ID), attributes);
        } catch (e) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsStart', $a32e213c0a4381f7$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    fireAnalyticsEnd (fieldKey, params, isEndOfSession = true) {
        try {
            if ((0, $4R6GH.fg)('remove_jsm_events_from_1_event')) {
                if ((0, $bximr.getContextProduct)(params.analytics.context) === 'serviceDesk') return;
            }
            const sessionid = $a32e213c0a4381f7$export$87846400a9b428fc.pull(fieldKey, isEndOfSession);
            const isFieldKeyUnknown = (0, $8ikZj.UNKNOWN_FIELD_IDS).includes(fieldKey) && (0, $4R6GH.fg)('one_event_rules_them_all_fg');
            const actualFieldKey = isFieldKeyUnknown && params.attributes.fieldKey && typeof params.attributes.fieldKey === 'string' ? params.attributes.fieldKey : fieldKey;
            const attributes = $a32e213c0a4381f7$var$concatAttributes(actualFieldKey, sessionid, params.attributes);
            if (isEndOfSession) {
                if (isFieldKeyUnknown) $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
                $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(actualFieldKey);
            }
            if ((0, $4R6GH.fg)('one_event_fast_follow_fg')) attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $8zOmE.fireTrackAnalytics)(params.analytics, `${(0, $8ikZj.END_ACTION_SUBJECT)} ${(0, $8ikZj.END_ACTION)}`, (0, $8ikZj.END_ACTION_SUBJECT_ID), {
                ...attributes,
                ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
                    is_new_1event: true
                }
            });
        } catch (e) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsEnd', $a32e213c0a4381f7$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    setAttributes (fieldKey, attributes) {
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) {
            const currentAttributes = $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.get(fieldKey);
            $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                ...currentAttributes,
                ...attributes
            });
        } else $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, attributes);
    },
    setActionTakenAttributes (fieldKey, oldValId, newValId) {
        if (oldValId !== newValId) this.setAttributes(fieldKey, {
            oldValId: oldValId,
            newValId: newValId,
            actionTaken: (0, $bximr.getActionTaken)(oldValId, newValId)
        });
    },
    // Use this to clean up session without firing analytics event. This happens for entity fields when
    // multiple end events can be fired after a start event
    endSession (fieldKey) {
        $a32e213c0a4381f7$export$87846400a9b428fc.pull(fieldKey);
        $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
    },
    reset () {
        $a32e213c0a4381f7$export$87846400a9b428fc.reset();
    }
};
const $a32e213c0a4381f7$export$f3b2b77402b2631f = ()=>$a32e213c0a4381f7$var$updateAnalyticsFlowHelper;

});
parcelRegister("8ikZj", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ATTRIBUTES", () => $ba1d12fd09beb370$export$69665899d8392309);
$parcel$export(module.exports, "START_ACTION", () => $ba1d12fd09beb370$export$c0a4673e0c78e972);
$parcel$export(module.exports, "START_ACTION_SUBJECT", () => $ba1d12fd09beb370$export$34a5ae354a38cc7e);
$parcel$export(module.exports, "START_ACTION_SUBJECT_ID", () => $ba1d12fd09beb370$export$bc373f59492dc6e2);
$parcel$export(module.exports, "END_ACTION", () => $ba1d12fd09beb370$export$b19686c1fe99f85a);
$parcel$export(module.exports, "END_ACTION_SUBJECT", () => $ba1d12fd09beb370$export$4ce67e80878d47ed);
$parcel$export(module.exports, "END_ACTION_SUBJECT_ID", () => $ba1d12fd09beb370$export$e3d957ccc2d46469);
$parcel$export(module.exports, "ACTION_TAKEN_ADD", () => $ba1d12fd09beb370$export$3b3e3ac6d7f6e219);
$parcel$export(module.exports, "ACTION_TAKEN_REMOVE", () => $ba1d12fd09beb370$export$6137e1b2fcde2333);
$parcel$export(module.exports, "DRAG_DROP_UNKNOWN_FIELD_ID", () => $ba1d12fd09beb370$export$6d8c364f9d389764);
$parcel$export(module.exports, "UNKNOWN_FIELD_IDS", () => $ba1d12fd09beb370$export$7d1d20ff891eeb26);
$parcel$export(module.exports, "FIELD_TYPE_MAP_OLD", () => $ba1d12fd09beb370$export$403ea87111529de);
$parcel$export(module.exports, "FIELD_TYPE_MAP", () => $ba1d12fd09beb370$export$d8ccf495ccc97a69);
$parcel$export(module.exports, "ENTITY_FIELD_KEYS", () => $ba1d12fd09beb370$export$7d9dd31e187cb2db);

var $5fc53 = parcelRequire("5fc53");
const $ba1d12fd09beb370$export$69665899d8392309 = {
    isInlineEditing: false,
    isCommandPaletteEditing: false,
    isDragEditing: false,
    isContextMenuEditing: false,
    isIssueViewEditing: false
};
const $ba1d12fd09beb370$export$c0a4673e0c78e972 = 'clicked';
const $ba1d12fd09beb370$export$34a5ae354a38cc7e = 'item';
const $ba1d12fd09beb370$export$bc373f59492dc6e2 = 'issue';
const $ba1d12fd09beb370$export$b19686c1fe99f85a = 'updated';
const $ba1d12fd09beb370$export$4ce67e80878d47ed = 'issue';
const $ba1d12fd09beb370$export$e3d957ccc2d46469 = 'ended';
const $ba1d12fd09beb370$export$3b3e3ac6d7f6e219 = 'add';
const $ba1d12fd09beb370$export$6137e1b2fcde2333 = 'remove';
const $ba1d12fd09beb370$export$6d8c364f9d389764 = 'unknown';
const $ba1d12fd09beb370$export$7d1d20ff891eeb26 = [
    $ba1d12fd09beb370$export$6d8c364f9d389764
];
const $ba1d12fd09beb370$export$403ea87111529de = {
    [(0, $5fc53.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: 'versions',
    [(0, $5fc53.VERSION_CF_TYPE)]: 'versions',
    [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $5fc53.SPRINT_TYPE)]: 'link',
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $5fc53.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $5fc53.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $5fc53.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $5fc53.USER_CF_TYPE)]: 'singleUser',
    [(0, $5fc53.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $5fc53.URL_CF_TYPE)]: 'url',
    [(0, $5fc53.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: 'multiGroup'
};
const $ba1d12fd09beb370$export$d8ccf495ccc97a69 = {
    [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: 'affectsVersions',
    [(0, $5fc53.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $5fc53.ATTACHMENT_TYPE)]: 'attachment',
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: 'cascadingSelect',
    [(0, $5fc53.COMPONENTS_TYPE)]: 'components',
    [(0, $5fc53.DATE_CF_TYPE)]: 'date',
    [(0, $5fc53.DATETIME_CF_TYPE)]: 'dateTime',
    [(0, $5fc53.DESCRIPTION_TYPE)]: 'richText',
    [(0, $5fc53.DUE_DATE_TYPE)]: 'date',
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: 'fixVersions',
    [(0, $5fc53.FLAGGED_CF_TYPE)]: 'flag',
    [(0, $5fc53.GOALS_CF_TYPE)]: 'goals',
    [(0, $5fc53.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $5fc53.ISSUE_TYPE)]: 'issuetype',
    [(0, $5fc53.LABELS_CF_TYPE)]: 'labels',
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: 'multiGroup',
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $5fc53.MULTI_USER_CF_TYPE)]: 'multiUser',
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $5fc53.NUMBER_CF_TYPE)]: 'float',
    [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $5fc53.PARENT_TYPE)]: 'parent',
    [(0, $5fc53.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $5fc53.PRIORITY_TYPE)]: 'priority',
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: 'project',
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $5fc53.RANK_CF_TYPE)]: 'rank',
    [(0, $5fc53.START_DATE_TYPE)]: 'date',
    [(0, $5fc53.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $5fc53.SPRINT_TYPE)]: 'sprint',
    [(0, $5fc53.STATUS_TYPE)]: 'status',
    [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: 'storyPointEstimate',
    [(0, $5fc53.STORY_POINTS_TYPE)]: 'storyPointEstimate',
    [(0, $5fc53.SUMMARY_TYPE)]: 'singleLineText',
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: 'team',
    [(0, $5fc53.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $5fc53.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $5fc53.TIME_ESTIMATE_TYPE)]: 'originalTimeEstimate',
    [(0, $5fc53.TIME_TRACKING_TYPE)]: 'timeTracking',
    [(0, $5fc53.URL_CF_TYPE)]: 'url',
    [(0, $5fc53.USER_CF_TYPE)]: 'singleUser',
    [(0, $5fc53.VERSION_CF_TYPE)]: 'version',
    [(0, $5fc53.VOTES_TYPE)]: 'votes',
    [(0, $5fc53.WATCHES_TYPE)]: 'watchers'
};
const $ba1d12fd09beb370$export$7d9dd31e187cb2db = {
    WEB_LINK: 'weblink',
    ATTACHMENT: 'attachment',
    ISSUE_LINKS: 'linkIssue',
    PARENT: 'parent'
};

});

parcelRegister("bximr", function(module, exports) {

$parcel$export(module.exports, "getActionTaken", () => $440267fcdb63291a$export$9d814e3464362b48);
$parcel$export(module.exports, "getContextAssigneeId", () => $440267fcdb63291a$export$29cb0bd9f4b2c85c);
$parcel$export(module.exports, "getContextAssigneeIdAndProduct", () => $440267fcdb63291a$export$e6dd41ec8f1794f6);
$parcel$export(module.exports, "getContextProduct", () => $440267fcdb63291a$export$4cb0aa9574634a48);

var $8ikZj = parcelRequire("8ikZj");
const $440267fcdb63291a$export$9d814e3464362b48 = (oldValId, newValId)=>{
    if (oldValId !== newValId) {
        if (newValId === null) return 0, $8ikZj.ACTION_TAKEN_REMOVE;
        if (oldValId === null || oldValId === undefined) return 0, $8ikZj.ACTION_TAKEN_ADD;
    }
    return undefined;
};
const $440267fcdb63291a$export$29cb0bd9f4b2c85c = (context)=>{
    for (const item of context){
        if (item?.attributes?.assigneeId) return item.attributes.assigneeId;
    }
};
const $440267fcdb63291a$export$e6dd41ec8f1794f6 = (context)=>{
    let assigneeId;
    let product;
    for (const item of context){
        if (item?.attributes?.assigneeId) assigneeId = item.attributes.assigneeId;
        if (item?.attributes?.previousSubProduct) product = item.attributes.previousSubProduct;
        if (assigneeId && product) break;
    }
    return {
        assigneeId: assigneeId,
        product: product
    };
};
const $440267fcdb63291a$export$4cb0aa9574634a48 = (context)=>{
    for (const item of context){
        if (item?.attributes?.previousSubProduct) return item.attributes.previousSubProduct;
    }
};

});









parcelRegister("3Tty1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ba57d5dc6c0de0a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9IeM0 = parcelRequire("9IeM0");

var $4lkOX = parcelRequire("4lkOX");

var $h0GOb = parcelRequire("h0GOb");

var $k4r7E = parcelRequire("k4r7E");

var $9fuVs = parcelRequire("9fuVs");

var $kspvB = parcelRequire("kspvB");
let $6ba57d5dc6c0de0a$var$shortcutsCount = 0;
let $6ba57d5dc6c0de0a$var$subscription = null;
const $6ba57d5dc6c0de0a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $5uXOq.useContext)((0, $9fuVs.ShortcutRegistryContext)) || (0, $k4r7E.rootRegistry);
    const addKeyMap = (0, $5uXOq.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $kspvB.bindKeyMapWithErrorHandling)(keyMap, location),
                label: label
            })), [
        label,
        parentRegistry,
        keyMap,
        location
    ]);
    (0, $5uXOq.useEffect)(()=>{
        $6ba57d5dc6c0de0a$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $6ba57d5dc6c0de0a$var$shortcutsCount -= 1;
            if ($6ba57d5dc6c0de0a$var$subscription && $6ba57d5dc6c0de0a$var$shortcutsCount === 0) {
                $6ba57d5dc6c0de0a$var$subscription.unsubscribe();
                $6ba57d5dc6c0de0a$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $5uXOq.useEffect)(()=>{
        $6ba57d5dc6c0de0a$var$subscription = $6ba57d5dc6c0de0a$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $h0GOb.default)().subscribe((0, $4lkOX.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6ba57d5dc6c0de0a$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $9IeM0.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ba57d5dc6c0de0a$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("9IeM0", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $dc712fc9bec05022$export$a33a81f1fc5458ad);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $dc712fc9bec05022$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $dc712fc9bec05022$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$dc712fc9bec05022$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $eusud.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $dc712fc9bec05022$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $j8DrX.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $dc712fc9bec05022$export$b62f67be35e65859
    }
});
const $dc712fc9bec05022$export$a33a81f1fc5458ad = (0, $3sQ5x.createHook)($dc712fc9bec05022$var$Store);

});

parcelRegister("4lkOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f11d50ddafbb6f85$export$2e2bcd8739ae039);

var $h0GOb = parcelRequire("h0GOb");

var $k4r7E = parcelRequire("k4r7E");
const $f11d50ddafbb6f85$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f11d50ddafbb6f85$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $k4r7E.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $h0GOb.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f11d50ddafbb6f85$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $h0GOb.flush)();
    }
};

});
parcelRegister("h0GOb", function(module, exports) {

$parcel$export(module.exports, "default", () => $849cd54ac4017470$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $849cd54ac4017470$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $kVLXA = parcelRequire("kVLXA");

var $cab1K = parcelRequire("cab1K");
parcelRequire("jG6Un");
parcelRequire("eSGL3");
parcelRequire("1oQta");
parcelRequire("4kRRr");
parcelRequire("d0pqD");
parcelRequire("iQCJJ");
parcelRequire("fjPtF");
parcelRequire("2R2to");

var $lIZQG = parcelRequire("lIZQG");
const $849cd54ac4017470$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $849cd54ac4017470$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $849cd54ac4017470$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$849cd54ac4017470$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $849cd54ac4017470$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$849cd54ac4017470$var$isEditable(e.target) && !$849cd54ac4017470$var$ignoredKeys[e.key]);
const $849cd54ac4017470$export$25d1b8252b4c49b7 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $849cd54ac4017470$var$key$;
const $849cd54ac4017470$var$flush$ = new (0, $cab1K.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$849cd54ac4017470$export$2e2bcd8739ae039 = ()=>{
    if (!$849cd54ac4017470$var$key$) {
        $849cd54ac4017470$var$key$ = false ? new (0, $cab1K.Subject)() : (0, $kVLXA.Observable).fromEvent(document, 'keydown').filter($849cd54ac4017470$var$isRelevantKeyEvent).filter($849cd54ac4017470$export$25d1b8252b4c49b7).map((0, $lIZQG.toKeyWithModifiers));
        const sequence$ = $849cd54ac4017470$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $849cd54ac4017470$var$key$ = $849cd54ac4017470$var$key$.debounceTime(1000).startWith(null).merge($849cd54ac4017470$var$flush$).switchMapTo(sequence$);
    }
    return $849cd54ac4017470$var$key$;
};
const $849cd54ac4017470$export$4909b86c8034bf73 = ()=>{
    $849cd54ac4017470$var$flush$.next();
};

});


parcelRegister("kspvB", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $f9e30ab2465f6f16$export$77477772a9b904da);

var $dJl1T = parcelRequire("dJl1T");
const $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
        try {
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $f9e30ab2465f6f16$export$77477772a9b904da = (keyMap, location)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
            }
        }), {});

});



const $d791d5657a673291$export$abc61f74b6bec12c = 'viewJqlBuilderAdvanced';
const $d791d5657a673291$export$b8b9d90f9e5bd72b = 'jiraJqlBuilderAdvanced';
const $d791d5657a673291$export$d57b6b390e78d90f = 'empanada';

parcelRegister("apc2O", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb8e67980bca7270$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cb8e67980bca7270$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "jql-builder-advanced.error-flag-title",
        "defaultMessage": "We couldn't edit the query"
    },
    errorFlagDescription: {
        "id": "jql-builder-advanced.error-flag-description",
        "defaultMessage": "The JQL builder is unresponsive. Refresh the page to try again."
    },
    searchCurrentPage: {
        "id": "jql-builder-advanced.search-current-page",
        "defaultMessage": "Search on current page"
    }
});

});

parcelRegister("b3ogM", function(module, exports) {

$parcel$export(module.exports, "useAutocompleteInitialData", () => $dc220e745e296d72$export$21e39afbf909ee71);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $4R6GH = parcelRequire("4R6GH");


var $aYrMA = parcelRequire("aYrMA");
const $dc220e745e296d72$export$21e39afbf909ee71 = (excludedAutocompleteFields = [], fieldsFilter)=>(0, $5uXOq.useCallback)((url)=>{
        const options = {
            method: 'POST',
            body: JSON.stringify({
                includeCollapsedFields: true
            })
        };
        return (0, $aYrMA.fetchWithRetry)(()=>(0, $7f4tk.default)(url, options), 1).then((res)=>({
                jqlFields: excludedAutocompleteFields.length === 0 && !fieldsFilter ? res.visibleFieldNames : res.visibleFieldNames.filter((field)=>(0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering') ? fieldsFilter?.(field.cfid || field.value) !== false && !excludedAutocompleteFields.includes(field.value) : !excludedAutocompleteFields.includes(field.value)),
                jqlFunctions: res.visibleFunctionNames
            })).catch((error)=>{
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'getAutocompleteInitialData',
                    packageName: (0, $d791d5657a673291$export$b8b9d90f9e5bd72b),
                    teamName: (0, $d791d5657a673291$export$d57b6b390e78d90f)
                }
            });
            throw error;
        });
    }, [
        excludedAutocompleteFields,
        fieldsFilter
    ]);

});
parcelRegister("aYrMA", function(module, exports) {

$parcel$export(module.exports, "fetchWithRetry", () => $cd66ab16f42aa45f$export$cffaac380b94df26);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cd66ab16f42aa45f$export$cffaac380b94df26 = async (fetchCall, retryAttempts)=>{
    try {
        return await fetchCall();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (retryAttempts > 0) return $cd66ab16f42aa45f$export$cffaac380b94df26(fetchCall, retryAttempts - 1);
        throw error;
    }
};

});


parcelRegister("3pImq", function(module, exports) {

$parcel$export(module.exports, "useAutocompleteSuggestions", () => $016ed0d8dff873d2$export$b39a9f86c7843060);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

const $016ed0d8dff873d2$export$b39a9f86c7843060 = ()=>{
    const baseUrl = '';
    return (0, $5uXOq.useCallback)((url)=>(0, $7f4tk.default)(baseUrl + url).catch((error)=>{
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'getAutocompleteSuggestions',
                    packageName: (0, $d791d5657a673291$export$b8b9d90f9e5bd72b),
                    teamName: (0, $d791d5657a673291$export$d57b6b390e78d90f)
                }
            });
            throw error;
        }), [
        baseUrl
    ]);
};

});

parcelRegister("8BS0n", function(module, exports) {

$parcel$export(module.exports, "useOnHydrate", () => $9b35be75c4b6069c$export$6d016355519acd77);

var $46LbS = parcelRequire("46LbS");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $9OXo1 = parcelRequire("9OXo1");


const $9b35be75c4b6069c$export$f2e498f301ac7cdf = (response)=>{
    if (!response?.jira?.jqlBuilder?.hydrateJqlQuery?.fields) return {};
    const hydratedValues = {};
    response.jira.jqlBuilder.hydrateJqlQuery.fields.forEach((field)=>{
        if (field.values) {
            const fieldValues = [];
            field.values.forEach((valueResult)=>{
                if (valueResult?.values) valueResult.values.forEach((value)=>{
                    if (value?.__typename === 'JiraJqlUserFieldValue') fieldValues.push({
                        type: 'user',
                        id: value.jqlTerm,
                        name: value.displayName,
                        avatarUrl: value.user?.picture ?? ''
                    });
                });
            });
            if (field.field && field.field.searchTemplate) {
                const fieldName = field.field.jqlTerm;
                if ((0, $37ea070a15b5378a$export$3df7f6b39477220a) === field.field.searchTemplate.key) fieldValues.push({
                    type: 'deprecated-field',
                    id: fieldName,
                    deprecatedSearcherKey: field.field.searchTemplate.key
                });
            }
            if (field.field && field.field.searchTemplate) {
                const fieldName = field.field.jqlTerm;
                if ((0, $37ea070a15b5378a$export$f8cba5bda41a61a0) === field.field.searchTemplate.key) fieldValues.push({
                    type: 'deprecated-field',
                    id: fieldName,
                    deprecatedSearcherKey: field.field.searchTemplate.key
                });
            }
            if (fieldValues.length > 0 && field.field) {
                const fieldName = field.field.jqlTerm;
                hydratedValues[fieldName] = fieldValues;
            }
        }
    });
    return hydratedValues;
};
const $9b35be75c4b6069c$export$6d016355519acd77 = (viewContext)=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    return (0, $5uXOq.useCallback)(async (jql)=>{
        try {
            const data = await (0, $8Uumt.fetchQuery)(environment, (0, $46LbS.default), {
                jql: jql,
                cloudId: cloudId,
                viewContext: viewContext
            }, {
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            }).toPromise();
            return $9b35be75c4b6069c$export$f2e498f301ac7cdf(data);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'useOnHydrateRelay',
                    packageName: (0, $d791d5657a673291$export$b8b9d90f9e5bd72b),
                    teamName: (0, $d791d5657a673291$export$d57b6b390e78d90f)
                }
            });
            throw error;
        }
    }, [
        cloudId,
        environment,
        viewContext
    ]);
};

});
parcelRegister("46LbS", function(module, exports) {

$parcel$export(module.exports, "default", () => $332dbdaedb96ffcc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<65fa00f34dc5637de1e582d5969e7a21>>
 * @relayHash 3135d365d88950050d150a9e9c118a61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ba4fcfcd09e227177aa23416dd3fdedaf9a469a4454cbd34e0ea60cb63a5bf4e
const $332dbdaedb96ffcc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v6 = {
        "concreteType": "JiraJqlField",
        "kind": "LinkedField",
        "name": "field",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "concreteType": "JiraJqlSearchTemplate",
                "kind": "LinkedField",
                "name": "searchTemplate",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    }
                ]
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hydrationRelayJqlBuilderAdvancedQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "hydrateJqlQuery",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "values",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "values",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v5 /*: any*/ ,
                                                                                        v7 /*: any*/ ,
                                                                                        v8 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v9 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlUserFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraJqlQueryHydratedValue"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlQueryHydratedField"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlHydratedQuery"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "hydrationRelayJqlBuilderAdvancedQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "hydrateJqlQuery",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": true,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "values",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "values",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v5 /*: any*/ ,
                                                                                        v7 /*: any*/ ,
                                                                                        v8 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v8 /*: any*/ ,
                                                                                                        v9 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "id"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlUserFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraJqlQueryHydratedValue"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlQueryHydratedField"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlHydratedQuery"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ba4fcfcd09e227177aa23416dd3fdedaf9a469a4454cbd34e0ea60cb63a5bf4e",
            "metadata": {},
            "name": "hydrationRelayJqlBuilderAdvancedQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$332dbdaedb96ffcc$var$node.hash = "b26239c922b8627fea8a8e88766856e6";
var $332dbdaedb96ffcc$export$2e2bcd8739ae039 = $332dbdaedb96ffcc$var$node;

});

const $37ea070a15b5378a$export$3df7f6b39477220a = 'com.pyxis.greenhopper.jira:gh-epic-link-searcher';
const $37ea070a15b5378a$export$f8cba5bda41a61a0 = 'com.atlassian.jpo:jpo-custom-field-parent-searcher';




parcelRegister("8q1vb", function(module, exports) {

$parcel$export(module.exports, "JQLDebuggerTriggerButton", () => $5a3801d1d0c4d13d$export$a74ff97760ab288d);

var $5uXOq = parcelRequire("5uXOq");

var $bMFGq = parcelRequire("bMFGq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $5E93O = parcelRequire("5E93O");

var $l5jpf = parcelRequire("l5jpf");

var $b7Svb = parcelRequire("b7Svb");
var $d7642 = parcelRequire("d7642");

var $koVbs = parcelRequire("koVbs");

var $7CMCs = parcelRequire("7CMCs");

var $cSD7y = parcelRequire("cSD7y");

var $512eM = parcelRequire("512eM");

var $6eDsT = parcelRequire("6eDsT");

var $hVgdp = parcelRequire("hVgdp");

var $6OxoL = parcelRequire("6OxoL");

var $eQeXx = parcelRequire("eQeXx");

var $bpjJS = parcelRequire("bpjJS");

const $5a3801d1d0c4d13d$var$TriggerButtonWithLogic = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("7QYaD")), {
    moduleId: "./src/packages/jql-builder/jql-debugger/src/ui/trigger-button/trigger-button-content.tsx"
});
function $5a3801d1d0c4d13d$export$9504934576e2ed55(props) {
    const { children: children, testId: testId } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { jqlMessages: jqlMessages, onSearch: onSearch } = (0, $bpjJS.useJqlDebuggerAdditionalContext)();
    const [debuggerState] = (0, $512eM.useDebuggerStatus)();
    const [isAiEnabled] = (0, $512eM.useIsAiEnabled)();
    // A jqlMessage can be error, warning or info
    // We only case about the error scenario
    // Here we map the jqlMessages object list to a list of plain strings
    const errors = (0, $5uXOq.useMemo)(()=>{
        return (0, $hVgdp.jqlMessagesToErrors)(jqlMessages);
    }, [
        jqlMessages
    ]);
    // Do not render the trigger button when:
    // 1. AI is not enabled
    // 2. onSearch callback is not available - i.e. we cannot apply the corrected jql to the editor
    // 3. No validation errors coming from the jql-editor - duuh
    //
    // Special note: Default render is `children` (and not `null`) coz we wanto keep showing the errors
    // For example when AI is not available, we still want to show the errors
    if (!isAiEnabled || !onSearch || !errors?.length) return children;
    if (debuggerState === 'JS_ERROR') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $5a3801d1d0c4d13d$var$errorBannerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l5jpf.JiraBanner), {
        messageId: "jql-debugger.ui.trigger-button.banner.error",
        messageType: "transactional",
        appearance: "error",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
            spacing: "spacious",
            label: formatMessage((0, $eQeXx.default).errorIconLabelNonFinal),
            LEGACY_secondaryColor: "inherit"
        })
    }, formatMessage((0, $eQeXx.default).jsErrorNonFinal))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $5a3801d1d0c4d13d$var$errorComponentStyles
    }, debuggerState === 'INIT' && children, debuggerState === 'INIT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7642.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMFGq.default), null, formatMessage((0, $eQeXx.default).fixErrorWithAiNonFinal))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5a3801d1d0c4d13d$var$TriggerButtonWithLogic, {
        testId: testId
    })));
}
const $5a3801d1d0c4d13d$var$JQLDebuggerTriggerButtonOld = (props)=>{
    const ChildrenFallback = (0, $5uXOq.useCallback)(()=>props.children, [
        props.children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: (0, $6eDsT.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $6eDsT.ERROR_BOUNDARY_IDS).TRIGGER_BUTTON,
        teamName: (0, $6eDsT.TEAM_NAME),
        fallback: ChildrenFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5a3801d1d0c4d13d$export$9504934576e2ed55, props));
};
const $5a3801d1d0c4d13d$export$a74ff97760ab288d = (0, $cSD7y.componentWithFG)('gravityai-2283-jql-debugger-rll-to-entrypoints', (0, $6OxoL.JQLPanelRenderSlotForJQLEditor), $5a3801d1d0c4d13d$var$JQLDebuggerTriggerButtonOld);
const $5a3801d1d0c4d13d$var$errorComponentStyles = (0, $2s57o.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    rowGap: 'space.025',
    marginBottom: 'space.050'
});
const $5a3801d1d0c4d13d$var$errorBannerStyle = (0, $2s57o.xcss)({
    marginTop: 'space.025',
    marginBottom: 'space.050'
});

});
parcelRegister("l5jpf", function(module, exports) {

$parcel$export(module.exports, "JiraBanner", () => $3840750ff328d8cb$export$23eaf79dd14ebe6e);

var $5uXOq = parcelRequire("5uXOq");

var $9eEJv = parcelRequire("9eEJv");

var $10xFf = parcelRequire("10xFf");

var $lAEmg = parcelRequire("lAEmg");
const $3840750ff328d8cb$export$23eaf79dd14ebe6e = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lAEmg.ChoreographerBanner), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9eEJv.default), rest);
};

});
parcelRegister("lAEmg", function(module, exports) {

$parcel$export(module.exports, "ChoreographerBanner", () => $f0c8589fc9ef9b7d$export$d77caaec2153a90b);

var $9eEJv = parcelRequire("9eEJv");

var $cSWNW = parcelRequire("cSWNW");
const $f0c8589fc9ef9b7d$export$d77caaec2153a90b = (0, $cSWNW.withChoreographedRender)((0, $9eEJv.default));

});


parcelRegister("512eM", function(module, exports) {

$parcel$export(module.exports, "useJqlDebuggerStoreActions", () => $0785fbdbf1edc211$export$661ee98a2d30a450);
$parcel$export(module.exports, "useStoreData", () => $0785fbdbf1edc211$export$544efe5ac05fc17);
$parcel$export(module.exports, "useDebuggerStatus", () => $0785fbdbf1edc211$export$e4c2322c66a3dea5);
$parcel$export(module.exports, "useJqlErrors", () => $0785fbdbf1edc211$export$d959fd60596bfa67);
$parcel$export(module.exports, "useJqlEditorOnSearch", () => $0785fbdbf1edc211$export$ba3a4678e5df092c);
$parcel$export(module.exports, "useJqlQuery", () => $0785fbdbf1edc211$export$ec027c329b94fe67);
$parcel$export(module.exports, "useIsAiEnabled", () => $0785fbdbf1edc211$export$742ce7b41314d513);
$parcel$export(module.exports, "useErrorComponentTestId", () => $0785fbdbf1edc211$export$afd1b99522ddeae9);
$parcel$export(module.exports, "useErrorComponentValidationId", () => $0785fbdbf1edc211$export$9c84149290836e7);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $0785fbdbf1edc211$var$initialState = {
    jqlQuery: '',
    userQueryError: [],
    onSearch: ()=>undefined,
    status: 'INIT',
    jqlDiffTokens: [],
    isAiEnabled: false,
    syntaxCorrectionAttemptErrors: [],
    singleInstrumentationID: '',
    errorSectionTestId: '',
    onAiInteractionDismissed () {
    // do nothing
    },
    exitNaturalLanguageMode () {
    // do nothing
    },
    onJsError () {
    // do nothing
    },
    jqlErrors: [],
    errorComponentValidationId: '',
    errorComponentTestId: ''
};
const $0785fbdbf1edc211$var$Store = (0, $iXqE5.createStore)({
    initialState: $0785fbdbf1edc211$var$initialState,
    // actions that trigger store mutation
    actions: {
        setJqlQuery: (jqlQuery)=>({ setState: setState })=>{
                setState({
                    jqlQuery: jqlQuery
                });
            },
        setOnSearch: (onSearch)=>({ setState: setState })=>{
                setState({
                    onSearch: onSearch
                });
            },
        setStatus: (status)=>({ setState: setState, getState: getState })=>{
                if (status === 'JS_ERROR') getState().onJsError();
                setState({
                    status: status
                });
            },
        resetStatus: (source)=>({ setState: setState, getState: getState })=>{
                if (getState().status !== 'INIT') {
                    // AI modal gets dismissed when we accept a suggestion
                    // However, we don't want to fire the `aiInteraction Dismissed` event in that case
                    if (source !== 'ACCEPT_FIX') getState().onAiInteractionDismissed(source);
                    setState({
                        status: 'INIT',
                        // Reset the aiInteractionDismissed handler so that duplicate events won't be fired
                        onAiInteractionDismissed: $0785fbdbf1edc211$var$initialState.onAiInteractionDismissed
                    });
                }
            },
        setStateOnFeatureInvoke: (initialDataOnInvoke)=>({ setState: setState })=>{
                setState({
                    ...initialDataOnInvoke,
                    status: 'LOADING_RESULT'
                });
            },
        setJqlErorCorrectionData: (data)=>({ setState: setState })=>{
                setState({
                    ...data,
                    status: 'VIEW_RESULT'
                });
            },
        setIsAiEnabled: (isAiEnabled)=>({ setState: setState })=>{
                setState({
                    isAiEnabled: isAiEnabled
                });
            },
        setOnAiInteractionDismissed: (onAiInteractionDismissed)=>({ setState: setState })=>{
                setState({
                    onAiInteractionDismissed: onAiInteractionDismissed
                });
            },
        setOnJsError: (onJsError)=>({ setState: setState })=>{
                setState({
                    onJsError: onJsError
                });
            },
        exitNaturalLanguageMode: ()=>({ getState: getState })=>{
                getState().exitNaturalLanguageMode?.();
            },
        setExitNaturalLanguageMode: (exitNaturalLanguageMode)=>({ setState: setState })=>{
                setState({
                    exitNaturalLanguageMode: exitNaturalLanguageMode
                });
            },
        setJqlErrors: (jqlErrors)=>({ setState: setState })=>setState({
                    jqlErrors: jqlErrors
                }),
        setErrorComponentValidationId: (errorComponentValidationId)=>({ setState: setState })=>setState({
                    errorComponentValidationId: errorComponentValidationId
                }),
        setErrorComponentTestId: (errorComponentValidationId)=>({ setState: setState })=>setState({
                    errorComponentValidationId: errorComponentValidationId
                })
    }
});
const $0785fbdbf1edc211$export$661ee98a2d30a450 = (0, $3sQ5x.createActionsHook)($0785fbdbf1edc211$var$Store);
const $0785fbdbf1edc211$export$544efe5ac05fc17 = (0, $3sQ5x.createHook)($0785fbdbf1edc211$var$Store);
const $0785fbdbf1edc211$export$e4c2322c66a3dea5 = (0, $3sQ5x.createHook)($0785fbdbf1edc211$var$Store, {
    selector: (state)=>state.status
});
const $0785fbdbf1edc211$export$d959fd60596bfa67 = (0, $3sQ5x.createHook)($0785fbdbf1edc211$var$Store, {
    selector: (state)=>state.jqlErrors
});
const $0785fbdbf1edc211$export$ba3a4678e5df092c = (0, $3sQ5x.createHook)($0785fbdbf1edc211$var$Store, {
    selector: (state)=>state.onSearch
});
const $0785fbdbf1edc211$export$ec027c329b94fe67 = (0, $3sQ5x.createHook)($0785fbdbf1edc211$var$Store, {
    selector: (state)=>state.jqlQuery
});
const $0785fbdbf1edc211$export$742ce7b41314d513 = (0, $3sQ5x.createHook)($0785fbdbf1edc211$var$Store, {
    selector: (state)=>state.isAiEnabled
});
const $0785fbdbf1edc211$export$afd1b99522ddeae9 = (0, $3sQ5x.createHook)($0785fbdbf1edc211$var$Store, {
    selector: (state)=>state.errorComponentTestId
});
const $0785fbdbf1edc211$export$9c84149290836e7 = (0, $3sQ5x.createHook)($0785fbdbf1edc211$var$Store, {
    selector: (state)=>state.errorComponentValidationId
});

});

parcelRegister("6eDsT", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME_JQL_DEBUGGER", () => $1f38f116a0aa50f1$export$efcb4634ee5c0cb9);
$parcel$export(module.exports, "TEAM_NAME", () => $1f38f116a0aa50f1$export$d57b6b390e78d90f);
$parcel$export(module.exports, "ERROR_BOUNDARY_IDS", () => $1f38f116a0aa50f1$export$2d2d5df8a192a41a);
$parcel$export(module.exports, "CLOSED_AI_MODAL_ABORT_REASON_MESSAGE", () => $1f38f116a0aa50f1$export$8714ae84b437fe97);
$parcel$export(module.exports, "CLOSED_AI_MODAL_ABORT_REASON_NAME", () => $1f38f116a0aa50f1$export$1e71032fcb7b8730);
$parcel$export(module.exports, "JS_ERROR_ABORT_REASON_NAME", () => $1f38f116a0aa50f1$export$64c672172b01336);
$parcel$export(module.exports, "AI_RESULT_ERROR_CATEGORIES", () => $1f38f116a0aa50f1$export$ad3b2223714b1ed9);
const $1f38f116a0aa50f1$export$efcb4634ee5c0cb9 = 'jira-jql-debugger';
const $1f38f116a0aa50f1$export$d57b6b390e78d90f = 'jira-ai-gravity';
const $1f38f116a0aa50f1$export$2d2d5df8a192a41a = {
    TRIGGER_BUTTON: 'jira-jql-debugger-trigger-button',
    FIX_WITH_AI_MODAL: 'jira-jql-debugger-fix-with-ai-modal',
    COMMON_ENTRY_JQL_BUILDER: 'jira-jql-debugger-common-entry-jql-builder',
    COMMON_ENTRY_ISSUE_VIEW: 'jira-jql-debugger-common-entry-issue-view'
};
const $1f38f116a0aa50f1$export$8714ae84b437fe97 = 'AI Modal was closed before the fetch completed';
const $1f38f116a0aa50f1$export$1e71032fcb7b8730 = 'AI_MODAL_CLOSED';
const $1f38f116a0aa50f1$export$64c672172b01336 = 'JS_ERROR';
const $1f38f116a0aa50f1$export$ad3b2223714b1ed9 = {
    FIXED_JQL_HAS_ERRORS: 'fixed-jql-has-errors',
    SERVER_ERROR: 'server-error'
};

});

parcelRegister("hVgdp", function(module, exports) {

$parcel$export(module.exports, "jqlMessagesToErrors", () => $9ab029369281a72b$export$c96be9b8b5cbea61);
function $9ab029369281a72b$export$c96be9b8b5cbea61(jqlMessages) {
    return jqlMessages?.filter((message)=>message.type === 'error').map((message)=>message.message?.toString()).filter(Boolean);
}

});

parcelRegister("6OxoL", function(module, exports) {

$parcel$export(module.exports, "JQLPanelRenderSlotForJQLEditor", () => $ed9cf04088525714$export$79179285687e80ca);
$parcel$export(module.exports, "JQLPanelRenderSlotForIssueView", () => $ed9cf04088525714$export$1efeb13e93a829bf);

var $5uXOq = parcelRequire("5uXOq");

var $2s57o = parcelRequire("2s57o");

var $gg2il = parcelRequire("gg2il");

var $cNgF9 = parcelRequire("cNgF9");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $512eM = parcelRequire("512eM");

var $5XPwp = parcelRequire("5XPwp");

var $7E33q = parcelRequire("7E33q");

var $6eDsT = parcelRequire("6eDsT");

var $90soo = parcelRequire("90soo");
function $ed9cf04088525714$var$JqlDebuggerLayoutSwitcher(props) {
    const layoutQuery = props.fullWidthLayout ? 'below.lg' : 'above.lg';
    const showProp = (0, $5uXOq.useMemo)(()=>props.fullWidthLayout ? {
            below: 'lg'
        } : {
            above: 'lg'
        }, [
        props.fullWidthLayout
    ]);
    const [matches, setMatches] = (0, $5uXOq.useState)(null);
    const mq = (0, $cNgF9.UNSAFE_useMediaQuery)(layoutQuery, (e)=>{
        setMatches(e.matches);
    });
    return matches ?? mq?.matches ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gg2il.Show), {
        ...showProp,
        xcss: props.xcss ? [
            $ed9cf04088525714$var$showContainerStyles,
            props.xcss
        ] : $ed9cf04088525714$var$showContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7E33q.JQLDebuggerCommonEntry), null)) : null;
}
const $ed9cf04088525714$export$793a24421ebe4e74 = (props)=>{
    const { errorMessages: errorMessages, testId: testId, validationId: validationId } = props;
    const jqlDebuggerStoreActions = (0, $512eM.useJqlDebuggerStoreActions)();
    const [isReady] = (0, $5XPwp.useIsContextReady)();
    const renderSyncActions = (0, $5XPwp.useRenderSynchronizerStoreActions)();
    const [isAiEnabled] = (0, $512eM.useIsAiEnabled)();
    const [status] = (0, $512eM.useDebuggerStatus)();
    /**
	 * When the JQL Editor unmounts for whatever reason, we want to mark jql editor as not ready
	 * So that JQLPanelRenderSlotForIssueView doesn't try to accidentally render any error messages
	 *
	 * For example, this happens when we enter NL-to-JQL AI mode while the regular JQL editor has an error
	 */ (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            renderSyncActions.setJqlEditorReady(false);
        };
    }, [
        renderSyncActions
    ]);
    if ((0, $4R6GH.fg)('gravityai-2553-fix-jql-debugger-flicker')) {
        if (!errorMessages?.length || !isReady || !isAiEnabled || status === 'UNRECOVERABLE_ERROR') {
            renderSyncActions.setJqlEditorReady(false);
            return props.children;
        }
        jqlDebuggerStoreActions.setJqlErrors(errorMessages.map((0, $90soo.extractTextFromReactElement)));
        jqlDebuggerStoreActions.setErrorComponentTestId(testId);
        jqlDebuggerStoreActions.setErrorComponentValidationId(validationId);
    } else if (!isReady || !isAiEnabled || status === 'UNRECOVERABLE_ERROR') {
        renderSyncActions.setJqlEditorReady(false);
        return props.children;
    }
    renderSyncActions.setJqlEditorReady(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed9cf04088525714$var$JqlDebuggerLayoutSwitcher, {
        fullWidthLayout: false,
        xcss: $ed9cf04088525714$var$jqlBuilderContainerStyles
    });
};
const $ed9cf04088525714$export$79179285687e80ca = (props)=>{
    const { children: children } = props;
    const ChildrenFallback = (0, $5uXOq.useCallback)(()=>children, [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: (0, $6eDsT.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $6eDsT.ERROR_BOUNDARY_IDS).COMMON_ENTRY_JQL_BUILDER,
        teamName: (0, $6eDsT.TEAM_NAME),
        fallback: ChildrenFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed9cf04088525714$export$793a24421ebe4e74, props));
};
const $ed9cf04088525714$export$1efeb13e93a829bf = ()=>{
    const [isReady] = (0, $5XPwp.useIsContextReady)();
    const [isJqlEditorReady] = (0, $5XPwp.useIsJqlEditorReady)();
    const storeActions = (0, $512eM.useJqlDebuggerStoreActions)();
    if (!isReady || !isJqlEditorReady) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: (0, $6eDsT.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $6eDsT.ERROR_BOUNDARY_IDS).COMMON_ENTRY_ISSUE_VIEW,
        teamName: (0, $6eDsT.TEAM_NAME),
        fallback: ()=>null,
        onError: ()=>{
            storeActions.setStatus('UNRECOVERABLE_ERROR');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed9cf04088525714$var$JqlDebuggerLayoutSwitcher, {
        fullWidthLayout: true,
        xcss: $ed9cf04088525714$var$issueViewContainerStyles
    }));
};
const $ed9cf04088525714$var$jqlBuilderContainerStyles = (0, $2s57o.xcss)({
    // When we are rendering in JQL builder, we want to add the space between the editor and panel
    // This space is already present in the issue view
    marginTop: 'space.100'
});
const $ed9cf04088525714$var$issueViewContainerStyles = (0, $2s57o.xcss)({
    // When we are rendering in JQL builder, we want to add the space between the editor and panel
    // This space is already present in the issue view
    marginTop: 'space.negative.100'
});
const $ed9cf04088525714$var$showContainerStyles = (0, $2s57o.xcss)({
    width: '100%',
    marginBottom: 'space.100'
});

});
parcelRegister("gg2il", function(module, exports) {

$parcel$export(module.exports, "Show", () => $59aef86717cff2da$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $2s57o = parcelRequire("2s57o");

var $5PAUh = parcelRequire("5PAUh");
function $59aef86717cff2da$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $59aef86717cff2da$var$showAboveQueries = (0, $5PAUh.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $59aef86717cff2da$var$showBelowQueries = (0, $5PAUh.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $59aef86717cff2da$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $59aef86717cff2da$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $2s57o.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $59aef86717cff2da$var$defaultHiddenStyles,
            above && $59aef86717cff2da$var$showAboveQueries[above],
            below && $59aef86717cff2da$var$showBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});
parcelRegister("5PAUh", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $afacb554ac9e0a7f$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $afacb554ac9e0a7f$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $g1DCj = parcelRequire("g1DCj");

var $kU1q1 = parcelRequire("kU1q1");
const $afacb554ac9e0a7f$export$918f8818cfbbeb2c = (input)=>{
    return (0, $g1DCj.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $kU1q1.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $afacb554ac9e0a7f$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $g1DCj.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $kU1q1.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("g1DCj", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $0fcd7daf0a562012$export$2d293d9871c38e91);
const $0fcd7daf0a562012$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $0fcd7daf0a562012$export$2d293d9871c38e91 = Object.keys($0fcd7daf0a562012$export$e5ee4fe8b989fd09);
const $0fcd7daf0a562012$export$b7ed752a57b4177b = $0fcd7daf0a562012$export$2d293d9871c38e91[0];

});



parcelRegister("5XPwp", function(module, exports) {

$parcel$export(module.exports, "useRenderSynchronizerStoreActions", () => $83997a3e2fc09962$export$60f8cec0dff6824c);
$parcel$export(module.exports, "useIsContextReady", () => $83997a3e2fc09962$export$7668b8e8d8c22896);
$parcel$export(module.exports, "useIsJqlEditorReady", () => $83997a3e2fc09962$export$7f34a2b12380537d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $83997a3e2fc09962$var$initialState = {
    isContextReady: false,
    isJqlEditorReady: false
};
const $83997a3e2fc09962$var$Store = (0, $iXqE5.createStore)({
    initialState: $83997a3e2fc09962$var$initialState,
    actions: {
        setIsContextReady: (isContextReady)=>({ setState: setState })=>{
                setState({
                    isContextReady: isContextReady
                });
            },
        setJqlEditorReady: (isJqlEditorReady)=>({ setState: setState })=>{
                setState({
                    isJqlEditorReady: isJqlEditorReady
                });
            }
    }
});
const $83997a3e2fc09962$export$60f8cec0dff6824c = (0, $3sQ5x.createActionsHook)($83997a3e2fc09962$var$Store);
const $83997a3e2fc09962$export$7668b8e8d8c22896 = (0, $3sQ5x.createHook)($83997a3e2fc09962$var$Store, {
    selector: (state)=>state.isContextReady
});
const $83997a3e2fc09962$export$7f34a2b12380537d = (0, $3sQ5x.createHook)($83997a3e2fc09962$var$Store, {
    selector: (state)=>state.isJqlEditorReady
});

});

parcelRegister("7E33q", function(module, exports) {

$parcel$export(module.exports, "JQLDebuggerCommonEntry", () => $184151cc31dcaed7$export$61b6653f41aa971b);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");

var $94cfG = parcelRequire("94cfG");

var $4mO32 = parcelRequire("4mO32");

var $7XluA = parcelRequire("7XluA");

var $512eM = parcelRequire("512eM");

var $cPrGR = parcelRequire("cPrGR");

var $7CEWb = parcelRequire("7CEWb");

var $6eDsT = parcelRequire("6eDsT");
function $184151cc31dcaed7$var$OnError() {
    const debuggerActions = (0, $512eM.useJqlDebuggerStoreActions)();
    (0, $5uXOq.useEffect)(()=>{
        // On error, set the feature state to be JS_ERROR, so that such scenarios can be handled without
        // interfering with the feature initial state nor with the AI event instrumentation
        debuggerActions.setStatus('JS_ERROR');
    }, [
        debuggerActions
    ]);
    return null;
}
const $184151cc31dcaed7$export$61b6653f41aa971b = ()=>{
    const [status] = (0, $512eM.useDebuggerStatus)();
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $4mO32.useEntryPoint)((0, $7CEWb.SuggestedFixContentEntrypoint), {});
    /*
		We load the entrypoint conditionally here as the JQL debugger panel is rendered underneath the JQL builder for large screen sizes,
		and across the issue view for smaller screen sizes - their visibilty is controlled by a <Show>, but they are two separately
		rendered components. As a result, if we are switching from one screen size or issue view to another, the newly rendered version of the
		JQL debugger will not have a loaded entry point, so we load it here to ensure the content is still visible across different views.

		Example of behaviour without this conditional:
		https://www.loom.com/share/725438e2ea16481591bbe510815e9ca3?sid=b3dc286e-9c37-4cf9-a2c9-f55d3561a166
	*/ if (status !== 'INIT') entryPointActions?.load();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $94cfG.default), {
        spacing: "none",
        hasNewBorderExperience: true,
        shouldFitContainer: true,
        isLoading: status === 'LOADING_RESULT'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        padding: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPrGR.ErrorSection), {
        entryPointActions: entryPointActions
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {},
        packageName: (0, $6eDsT.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $6eDsT.ERROR_BOUNDARY_IDS).FIX_WITH_AI_MODAL,
        teamName: (0, $6eDsT.TEAM_NAME),
        fallback: null,
        errorFallback: $184151cc31dcaed7$var$OnError
    }));
};

});
parcelRegister("94cfG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1249caed30269ff$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $6s1PB = parcelRequire("6s1PB");
let $d1249caed30269ff$var$namespaceUUID = 0;
const $d1249caed30269ff$var$newPalette = {
    dark: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    },
    light: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    }
};
const $d1249caed30269ff$var$AFTER_LOAD_DURATION = 3000;
const $d1249caed30269ff$var$AnimatedSvgContainer = ({ isLoading: isLoading, isBlurred: isBlurred, isShadow: isShadow, isBorderGrey: isBorderGrey, hasNewBorderExperience: hasNewBorderExperience })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    const svgRef = (0, $5uXOq.useRef)(null);
    const namespaceId = (0, $5uXOq.useRef)();
    const [showRainbowBorder, setShowRainbowBorder] = (0, $5uXOq.useState)(false);
    const paletteForTheme = colorMode === 'dark' ? $d1249caed30269ff$var$newPalette.dark : $d1249caed30269ff$var$newPalette.light;
    if (namespaceId.current === undefined) {
        namespaceId.current = $d1249caed30269ff$var$namespaceUUID;
        $d1249caed30269ff$var$namespaceUUID += 1;
    }
    (0, $5uXOq.useEffect)(()=>{
        if (isLoading) {
            const svg = svgRef.current;
            hasNewBorderExperience && setShowRainbowBorder(true); // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isLoading,
        hasNewBorderExperience
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // we keep the rainbow border without animations for at 3 seconds after load. After that we show the grey border
        if (hasNewBorderExperience && !isLoading && showRainbowBorder) {
            const timeoutId = setTimeout(()=>setShowRainbowBorder(false), $d1249caed30269ff$var$AFTER_LOAD_DURATION);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        hasNewBorderExperience,
        showRainbowBorder,
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d1249caed30269ff$var$SvgContainer, {
        isBlurred: isBlurred,
        isShadow: isShadow,
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg1`,
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg2`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg3`,
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg4`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), isBorderGrey || hasNewBorderExperience && !showRainbowBorder && !isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        d: "M0 0h24v24H0Z",
        vectorEffect: "non-scaling-stroke"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg1)`,
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg2)`,
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg3)`,
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg4)`,
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    }))));
};
const $d1249caed30269ff$var$AIContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isLoading: isLoading, isShadow: isShadow = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', testId: testId, isBorderGrey: isBorderGrey, components: { ContainerComponent: ContainerComponent = $d1249caed30269ff$var$Container, ContentComponent: ContentComponent = $d1249caed30269ff$var$Content } = {}, hasNewBorderExperience: hasNewBorderExperience = false }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ContainerComponent, {
        ref: (0, $6s1PB.expVal)('proactive-jira-ai-similar-issues', 'isEnabled', false) ? undefined : ref,
        "data-testid": testId,
        shouldFitContainer: shouldFitContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d1249caed30269ff$var$AnimatedSvgContainer, {
        isShadow: isShadow,
        isLoading: isLoading,
        isBorderGrey: isBorderGrey,
        hasNewBorderExperience: hasNewBorderExperience
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d1249caed30269ff$var$AnimatedSvgContainer, {
        isLoading: isLoading,
        isBlurred: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ContentComponent, {
        ref: (0, $6s1PB.expVal)('proactive-jira-ai-similar-issues', 'isEnabled', false) ? ref : undefined,
        spacing: spacing
    }, children));
});
var $d1249caed30269ff$export$2e2bcd8739ae039 = $d1249caed30269ff$var$AIContainer;
$d1249caed30269ff$var$AIContainer.displayName = 'AIContainer'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d1249caed30269ff$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainer: shouldFitContainer, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1pbyb4wl",
            __cmplp.shouldFitContainer ? "_1bsb1wug" : "_1bsb1ns9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d1249caed30269ff$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoi2wt _bfhkvuon _16jlkb7n _1pbyb4wl _1bsb1osq",
            __cmplp.spacing === 'default' && "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $d1249caed30269ff$export$71abc632aa29e6fe = {
    ContainerComponent: $d1249caed30269ff$var$Container,
    ContentComponent: $d1249caed30269ff$var$Content
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d1249caed30269ff$var$SvgContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isShadow: isShadow, isBlurred: isBlurred, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoftgi _kqswstnw",
            __cmplp.isShadow ? "_16qs9g9j" : "_16qsglyw",
            __cmplp.isBlurred ? "_1bsb5cnj _4t3i5cnj _154iu2gc _1ltvu2gc _kdam7b89" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cPrGR", function(module, exports) {

$parcel$export(module.exports, "ErrorSection", () => $75b2c572f25d51cd$export$b0bceea2ea86179a);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $ijSqY = parcelRequire("ijSqY");

var $eOat1 = parcelRequire("eOat1");

var $bMFGq = parcelRequire("bMFGq");

var $koVbs = parcelRequire("koVbs");

var $azxjR = parcelRequire("azxjR");

var $512eM = parcelRequire("512eM");

var $6XQU0 = parcelRequire("6XQU0");

var $cCZdl = parcelRequire("cCZdl");
function $75b2c572f25d51cd$export$b0bceea2ea86179a(props) {
    const { entryPointActions: entryPointActions } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [query] = (0, $512eM.useJqlQuery)();
    const [status] = (0, $512eM.useDebuggerStatus)();
    const [jqlErrors] = (0, $512eM.useJqlErrors)();
    const [onSearch] = (0, $512eM.useJqlEditorOnSearch)();
    const [errorComponentTestId] = (0, $512eM.useErrorComponentTestId)();
    const [errorComponentValidationId] = (0, $512eM.useErrorComponentValidationId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        alignBlock: "start",
        spread: "space-between",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "h5",
        xcss: $75b2c572f25d51cd$var$jqlErrorHeadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ijSqY))), {
        color: "var(--ds-icon, #44546F)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        weight: "bold"
    }, formatMessage(jqlErrors?.length > 1 ? (0, $cCZdl.default).jqlDebuggerHeadingPluralNonFinal : (0, $cCZdl.default).jqlDebuggerHeadingNonFinal))), status === 'LOADING_RESULT' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6XQU0.GeneratingAnimation), {
        alt: formatMessage((0, $cCZdl.default).jqlDebuggerLoadingNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, formatMessage((0, $cCZdl.default).jqlDebuggerLoadingNonFinal))) : // The wrappers around the ul element try to closely resemble the same structure as the default error message in the platform package
    // See: platform/packages/jql/jql-editor/src/ui/jql-editor-footer-content/jql-messages/errors/index.tsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        testId: errorComponentTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        role: "alert",
        id: errorComponentValidationId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "ul",
        xcss: $75b2c572f25d51cd$var$errorBoxStyles,
        testId: "jql-debugger.ui.error-section.error-list"
    }, jqlErrors.map((error)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            as: "li",
            key: error,
            xcss: $75b2c572f25d51cd$var$listItemStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
            color: "color.text.accent.red"
        }, error))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $75b2c572f25d51cd$var$headerEndStyles
    }, status === 'VIEW_RESULT' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: "new"
    }, formatMessage((0, $cCZdl.default).betaLozenge)) : null, status === 'INIT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azxjR.FixErrorButton), {
        testId: "jql-debugger.ui.error-section.trigger-button",
        jqlErrors: jqlErrors,
        onSearch: onSearch,
        query: query,
        entryPointActions: entryPointActions
    }), status === 'LOADING_RESULT' ? // Render a placeholder button when loading, so that the height of the panel stays the same most of the time
    // This way, the transitions are smoother with less layout shifts
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $75b2c572f25d51cd$var$placeholderButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMFGq.default), {
        isDisabled: true,
        appearance: "subtle"
    }, null)) : null));
}
const $75b2c572f25d51cd$var$errorBoxStyles = (0, $2s57o.xcss)({
    flex: 1,
    marginBlockStart: '0',
    paddingInlineStart: 'space.025'
});
const $75b2c572f25d51cd$var$headerEndStyles = (0, $2s57o.xcss)({
    alignSelf: 'flex-start'
});
const $75b2c572f25d51cd$var$listItemStyle = (0, $2s57o.xcss)({
    listStyle: 'none'
});
const $75b2c572f25d51cd$var$placeholderButtonStyle = (0, $2s57o.xcss)({
    opacity: 0,
    width: '0'
});
const $75b2c572f25d51cd$var$jqlErrorHeadingStyles = (0, $2s57o.xcss)({
    display: 'flex',
    whiteSpace: 'nowrap',
    alignItems: 'center',
    gap: 'space.075'
});

});
parcelRegister("azxjR", function(module, exports) {

$parcel$export(module.exports, "FixErrorButton", () => $eae5972d05fa16fa$export$94f98890cd333316);

var $5uXOq = parcelRequire("5uXOq");

var $bMFGq = parcelRequire("bMFGq");

var $kDE7H = parcelRequire("kDE7H");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $512eM = parcelRequire("512eM");

var $eA4t7 = parcelRequire("eA4t7");

function $eae5972d05fa16fa$var$useImportOnClickHandler() {
    const importer = (0, $5uXOq.useCallback)(()=>{
        return (parcelRequire("98Cs3"));
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        importer();
    }, [
        importer
    ]);
    return importer;
}
function $eae5972d05fa16fa$export$94f98890cd333316(props) {
    const { testId: testId, jqlErrors: jqlErrors, onSearch: onSearch, query: query, entryPointActions: entryPointActions } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const debuggerStoreActions = (0, $512eM.useJqlDebuggerStoreActions)();
    const importer = $eae5972d05fa16fa$var$useImportOnClickHandler();
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fixWithAiButton viewed', {
            debuggerPanel: true
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMFGq.default), {
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($kDE7H))),
        onMouseOver: ()=>{
            entryPointActions?.preload();
        },
        testId: "jql-debugger.ui.fix-error-button.button",
        onClick: async ()=>{
            entryPointActions?.load();
            const { onClick: onClick } = await importer();
            onClick({
                testId: testId,
                query: query || '',
                jqlErrors: jqlErrors,
                onSearch: onSearch,
                createAnalyticsEvent: createAnalyticsEvent,
                debuggerStoreActions: debuggerStoreActions
            });
        }
    }, formatMessage((0, $eA4t7.default).fixErrorWithAiNonFinal));
}

});
parcelRegister("eA4t7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3227887775647894$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3227887775647894$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    fixErrorWithAiNonFinal: {
        "id": "jql-debugger.trigger-button.fix-error-with-ai-non-final",
        "defaultMessage": "Fix error"
    },
    jsErrorNonFinal: {
        "id": "jql-debugger.trigger-button.js-error-non-final",
        "defaultMessage": "Something went wrong"
    },
    errorIconLabelNonFinal: {
        "id": "jql-debugger.trigger-button.error-icon-label-non-final",
        "defaultMessage": "Error Icon"
    }
});

});

parcelRegister("98Cs3", function(module, exports) {

let $6a72b00de1c4b89b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6a72b00de1c4b89b$var$load("1bWrJ").then(()=>parcelRequire('a2znj'));

});


parcelRegister("6XQU0", function(module, exports) {

$parcel$export(module.exports, "GeneratingAnimation", () => $2a8a6a1f71ee5df7$export$483f53d5a0354a30);

var $5uXOq = parcelRequire("5uXOq");
const $2a8a6a1f71ee5df7$export$483f53d5a0354a30 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "20",
        viewBox: "0 2 24 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("title", null, props.alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));

});

parcelRegister("cCZdl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d9705e8c7e7fe3d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7d9705e8c7e7fe3d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    jqlDebuggerHeadingNonFinal: {
        "id": "jql-debugger-panel.header.text-non-final",
        "defaultMessage": "JQL error"
    },
    jqlDebuggerHeadingPluralNonFinal: {
        "id": "jql-debugger-panel.header.plural-text-non-final",
        "defaultMessage": "JQL errors"
    },
    jqlDebuggerLoadingNonFinal: {
        "id": "jql-debugger-panel.header.loading-non-final",
        "defaultMessage": "Generating query fixes"
    },
    betaLozenge: {
        "id": "jql-debugger-panel.header.beta-lozenge",
        "defaultMessage": "Beta"
    }
});

});


parcelRegister("7CEWb", function(module, exports) {

$parcel$export(module.exports, "SuggestedFixContentEntrypoint", () => $2277cf36e1c1c6d6$export$9b2c3d0b37e41ae9);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $2277cf36e1c1c6d6$export$9b2c3d0b37e41ae9 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("dTXbp")), {
        moduleId: "2d263a55"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("dTXbp", function(module, exports) {

let $a1ee51f09ea5a202$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a1ee51f09ea5a202$var$load("es3L5").then(()=>parcelRequire('jH0B9'));

});



parcelRegister("90soo", function(module, exports) {

$parcel$export(module.exports, "extractTextFromReactElement", () => $49febd27912ae309$export$98ee087174ba8894);

var $5uXOq = parcelRequire("5uXOq");
function $49febd27912ae309$export$98ee087174ba8894(element) {
    let result = '';
    function traverse(node) {
        if (typeof node === 'string' || typeof node === 'number') result += node.toString();
        else if (/*#__PURE__*/ (0, $5uXOq.isValidElement)(node)) (0, $5uXOq.Children).forEach(node.props.children, (child)=>{
            traverse(child);
        });
    }
    traverse(element);
    return result;
}

});


parcelRegister("eQeXx", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dad7cc0b116a009$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1dad7cc0b116a009$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    fixErrorWithAiNonFinal: {
        "id": "jql-debugger.trigger-button.fix-error-with-ai-non-final",
        "defaultMessage": "Fix with AI"
    },
    jsErrorNonFinal: {
        "id": "jql-debugger.trigger-button.js-error-non-final",
        "defaultMessage": "Something went wrong"
    },
    errorIconLabelNonFinal: {
        "id": "jql-debugger.trigger-button.error-icon-label-non-final",
        "defaultMessage": "Error Icon"
    }
});

});

parcelRegister("bpjJS", function(module, exports) {

$parcel$export(module.exports, "JqlDebuggerJqlBuilderContextProvider", () => $c5834966ef6dcda7$export$c2426bb4c28cc626);
$parcel$export(module.exports, "useJqlDebuggerAdditionalContext", () => $c5834966ef6dcda7$export$3b2021865598576e);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $1bypF = parcelRequire("1bypF");
const $c5834966ef6dcda7$var$jqlDebuggerContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    onSearch: ()=>undefined,
    query: '',
    jqlMessages: []
});
/**
 * Provide additional context about the JQL Builder context to the JQL Debugger
 *
 * This additional context exists primarily because we need to pass some props from JQL builder to the customComponent override of ErrorMessage
 * Since ErrorMessage component (jql-debugger trigger-button) is passed as a component, we cannot pass the additional props as regular props
 * Hence we wrap the parent with this provider and pass the props as context
 */ const $c5834966ef6dcda7$var$JqlDebuggerJqlBuilderContextProviderOld = (props)=>{
    const { jqlMessages: jqlMessages, query: query, onSearch: onSearch } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c5834966ef6dcda7$var$jqlDebuggerContext.Provider, {
        value: {
            query: query,
            jqlMessages: jqlMessages,
            onSearch: onSearch
        }
    }, props.children);
};
const $c5834966ef6dcda7$export$c2426bb4c28cc626 = (0, $cSD7y.componentWithFG)('gravityai-2283-jql-debugger-rll-to-entrypoints', (0, $1bypF.JqlDebuggerJqlBuilderContextProvider), $c5834966ef6dcda7$var$JqlDebuggerJqlBuilderContextProviderOld);
const $c5834966ef6dcda7$export$3b2021865598576e = ()=>(0, $5uXOq.useContext)($c5834966ef6dcda7$var$jqlDebuggerContext);

});
parcelRegister("1bypF", function(module, exports) {

$parcel$export(module.exports, "JqlDebuggerJqlBuilderContextProvider", () => $741d035beb1704b1$export$c2426bb4c28cc626);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $512eM = parcelRequire("512eM");

var $5XPwp = parcelRequire("5XPwp");

var $hVgdp = parcelRequire("hVgdp");
const $741d035beb1704b1$export$c2426bb4c28cc626 = (props)=>{
    const { jqlMessages: jqlMessages, query: query, onSearch: onSearch, children: children } = props;
    const jqlDebuggerStoreActions = (0, $512eM.useJqlDebuggerStoreActions)();
    const renderSyncActions = (0, $5XPwp.useRenderSynchronizerStoreActions)();
    // A jqlMessage can be error, warning or info
    // We only case about the error scenario
    // Here we map the jqlMessages object list to a list of plain strings
    const jqlErrors = (0, $5uXOq.useMemo)(()=>(0, $hVgdp.jqlMessagesToErrors)(jqlMessages), [
        jqlMessages
    ]);
    if ((0, $4R6GH.fg)('gravityai-2553-fix-jql-debugger-flicker')) {
        // JQL Debugger is not ready when:
        // 1. AI is not enabled
        // 2. onSearch callback is not available - i.e. we cannot apply the corrected jql to the editor
        //
        // In such cases, we want to keep the default error layout
        if (onSearch && query) {
            jqlDebuggerStoreActions.setOnSearch(onSearch);
            jqlDebuggerStoreActions.setJqlQuery(query);
            renderSyncActions.setIsContextReady(true);
        } else renderSyncActions.setIsContextReady(false);
        return children;
    }
    if (jqlErrors?.length && onSearch && query) {
        jqlDebuggerStoreActions.setJqlErrors(jqlErrors);
        jqlDebuggerStoreActions.setOnSearch(onSearch);
        jqlDebuggerStoreActions.setJqlQuery(query);
        renderSyncActions.setIsContextReady(true);
    } else renderSyncActions.setIsContextReady(false);
    return children;
};

});


parcelRegister("7QYaD", function(module, exports) {

let $5b7c105e422070b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5b7c105e422070b4$var$load("8F5wz").then(()=>parcelRequire('7IFni'));

});


parcelRegister("imS60", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6b7686623a2955e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $aatTc = parcelRequire("aatTc");

var $dLznx = parcelRequire("dLznx");

var $5i16O = parcelRequire("5i16O");
const $b6b7686623a2955e$var$newContextWithUfoContext = (context, interactionContext)=>context && interactionContext && {
        ...context,
        getInteractionContext: ()=>interactionContext
    };
const $b6b7686623a2955e$var$flowRight = (functionList)=>(arg)=>functionList.reduceRight((acc, fn)=>fn(acc), arg);
const $b6b7686623a2955e$var$renderContextProviderIfNonNull = (Context, contextValue)=>(node)=>contextValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Context.Provider, {
            value: contextValue
        }, node) : node;
function $b6b7686623a2955e$var$JiraUFOLabelWrapper({ children: children }) {
    const context = (0, $aatTc.useInteractionContext)();
    const rllProfilerContext = (0, $5uXOq.useContext)((0, $5i16O.ProfilerContext));
    const relayProfilerContext = (0, $5uXOq.useContext)((0, $8Uumt.ProfilerContext));
    const newRllProfilerContext = (0, $5uXOq.useMemo)(()=>({
            current: $b6b7686623a2955e$var$newContextWithUfoContext(rllProfilerContext?.current, context)
        }), [
        context,
        rllProfilerContext
    ]);
    const newRelayProfilerContext = (0, $5uXOq.useMemo)(()=>$b6b7686623a2955e$var$newContextWithUfoContext(relayProfilerContext, context), [
        context,
        relayProfilerContext
    ]);
    // Produces the following but only renders a provider if its context is not null
    // <RelayProfilerContext.Provider ...>
    //   <RLLProfilerContext.Provider ...>
    //     {children}
    //   </...etc
    return $b6b7686623a2955e$var$flowRight([
        $b6b7686623a2955e$var$renderContextProviderIfNonNull((0, $8Uumt.ProfilerContext), newRelayProfilerContext),
        $b6b7686623a2955e$var$renderContextProviderIfNonNull((0, $5i16O.ProfilerContext), newRllProfilerContext)
    ])(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children));
}
function $b6b7686623a2955e$export$2e2bcd8739ae039({ name: name, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dLznx.default), {
        name: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6b7686623a2955e$var$JiraUFOLabelWrapper, null, children));
}

});
parcelRegister("dLznx", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e8b7d52352024ee$export$2e2bcd8739ae039);

var $b4xzp = parcelRequire("b4xzp");
var $7e8b7d52352024ee$export$2e2bcd8739ae039 = (0, $b4xzp.default);

});
parcelRegister("b4xzp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7574229cc4cef751$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $aatTc = parcelRequire("aatTc");
function $7574229cc4cef751$export$2e2bcd8739ae039({ name: name, children: children }) {
    const context = (0, $aatTc.useInteractionContext)();
    const newContext = (0, $5uXOq.useMemo)(()=>{
        if (context) return {
            ...context,
            labelStack: context.labelStack == null ? [
                {
                    name: name
                }
            ] : [
                ...context.labelStack,
                {
                    name: name
                }
            ]
        };
        else return context;
    }, [
        context,
        name
    ]);
    return context ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aatTc.default).Provider, {
        value: newContext,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
}

});



parcelRegister("ixr8x", function(module, exports) {

$parcel$export(module.exports, "SearchModeSwitcherRenderer", () => $7c3e0f295f843416$export$f054999725e0d47f);

var $5uXOq = parcelRequire("5uXOq");

var $032ey = parcelRequire("032ey");

var $3fufq = parcelRequire("3fufq");

var $8xRQz = parcelRequire("8xRQz");

var $1PKzp = parcelRequire("1PKzp");

var $kcuJ8 = parcelRequire("kcuJ8");
const $7c3e0f295f843416$export$f054999725e0d47f = ({ isSearchModeToggleEnabled: isSearchModeToggleEnabled, SearchModeSwitcher: SearchModeSwitcher = (0, $3fufq.SearchModeSwitcherWithTarget), isHydrating: isHydrating, isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft })=>{
    const { searchMode: selectedSearchMode, setSelectedSearchMode: setSelectedSearchMode } = (0, $1PKzp.useSelectedSearchMode)();
    const { querySupported: querySupported } = (0, $kcuJ8.useIsQuerySupported)();
    const onUpdateSearchMode = (0, $5uXOq.useCallback)((searchMode)=>{
        setSelectedSearchMode(searchMode, true);
    }, [
        setSelectedSearchMode
    ]);
    const isBasicModeDisabled = (0, $5uXOq.useMemo)(()=>// We disable basic mode if:
        // If query is not supported
        !querySupported || // Or if is supported but is also hydrating and we are not in basic mode
        isHydrating && selectedSearchMode !== (0, $032ey.SEARCH_MODE_BASIC), [
        isHydrating,
        querySupported,
        selectedSearchMode
    ]);
    return isSearchModeToggleEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xRQz.SearchModeSwitcherContainer), {
        testId: "jql-builder.ui.search-mode-switcher-renderer.toggle-container",
        isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SearchModeSwitcher, {
        searchMode: selectedSearchMode,
        isBasicModeDisabled: isBasicModeDisabled,
        onUpdateSearchMode: onUpdateSearchMode
    })) : null;
};

});




parcelRegister("6mNgE", function(module, exports) {

$parcel$export(module.exports, "getSystemAndGlobalFieldKeys", () => $38906a0c8382fa0d$export$e90f02ed40a835ea);

var $7f4tk = parcelRequire("7f4tk");
const $38906a0c8382fa0d$var$SYSTEM_AND_GLOBAL_FIELDS_URL = '/rest/polaris/global-fields/searchable?includeSystemFields=true';
const $38906a0c8382fa0d$export$e90f02ed40a835ea = ()=>(0, $7f4tk.default)($38906a0c8382fa0d$var$SYSTEM_AND_GLOBAL_FIELDS_URL).then((res)=>{
        const fields = {};
        res.forEach((field)=>{
            if (field.custom) {
                fields[`cf[${field.key.replace('customfield_', '')}]`] = field;
                fields[field.clauseNames.slice(-1)[0]] = field;
                fields[`"${field.clauseNames.slice(-1)[0]}"`] = field;
            } else fields[field.key] = field;
        });
        return fields;
    });

});

parcelRegister("gd9Sf", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc50c0dd0b246f4a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cc50c0dd0b246f4a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "polaris-component-collection-advanced-filters.filters.label",
        "defaultMessage": "Select search mode"
    },
    basicModeDisabledTooltip: {
        "id": "polaris-component-collection-advanced-filters.filters.basic-mode-disabled-tooltip",
        "defaultMessage": "You can't switch to basic as the query is too complex or is invalid"
    },
    basicMode: {
        "id": "polaris-component-collection-advanced-filters.filters.basic-mode",
        "defaultMessage": "Basic"
    },
    advancedMode: {
        "id": "polaris-component-collection-advanced-filters.filters.advanced-mode",
        "defaultMessage": "Advanced"
    },
    addFilterLabel: {
        "id": "polaris-component-collection-advanced-filters.add-filter-label",
        "defaultMessage": "Add a filter"
    },
    orderByError: {
        "id": "polaris-component-collection-advanced-filters.order-by-removed-title",
        "defaultMessage": "\"ORDER BY\" not allowed. Use view sorting."
    },
    selectProjectsFirst: {
        "id": "polaris-component-collection-advanced-filters.select-projects-first",
        "defaultMessage": "Select projects to filter the ideas."
    }
});

});

parcelRegister("2Be3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $656a48c77e43695b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");

var $1wbtX = parcelRequire("1wbtX");
const $656a48c77e43695b$var$LoadingState = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.200",
        xcss: $656a48c77e43695b$var$loadingStateStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SkeletonCompiled), {
        height: "32px",
        width: "160px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SkeletonCompiled), {
        height: "32px",
        width: "120px"
    }));
var $656a48c77e43695b$export$2e2bcd8739ae039 = $656a48c77e43695b$var$LoadingState;
const $656a48c77e43695b$var$loadingStateStyles = (0, $2s57o.xcss)({
    marginBlockStart: 'space.050'
});

});
parcelRegister("1wbtX", function(module, exports) {

$parcel$export(module.exports, "getKeyframes", () => $39c21c8edc6f2616$export$b2b5e866b2fbf2ec);
$parcel$export(module.exports, "SkeletonCompiled", () => $39c21c8edc6f2616$export$dc84d515085190e);
$parcel$export(module.exports, "SpacerCompiled", () => $39c21c8edc6f2616$export$e477bb7d17087f28);
$parcel$export(module.exports, "Skeleton", () => $39c21c8edc6f2616$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "Spacer", () => $39c21c8edc6f2616$export$d7a54cba636a8cd6);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");
const $39c21c8edc6f2616$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
    const fromPositionX = -Math.abs(offsetX) - 300;
    const toPositionX = fromPositionX + 2000;
    return (0, $47bDC.keyframes)({
        '0%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${fromPositionX}px 0`
        },
        '100%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${toPositionX}px 0`
        }
    });
};
const $39c21c8edc6f2616$var$shimmer = $39c21c8edc6f2616$export$b2b5e866b2fbf2ec();
const $39c21c8edc6f2616$export$1d2144641222f3bd = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "ieqbub-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationDelay: props.theme.animationDelay || '0s',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationName: props.theme.animationName || $39c21c8edc6f2616$var$shimmer,
        animationTimingFunction: 'linear',
        backgroundColor: "var(--ds-skeleton, #091E420F)",
        backgroundImage: `linear-gradient( to right, ${"var(--ds-skeleton, #091E420F)"} 10%, ${"var(--ds-skeleton-subtle, #091E4208)"} 30%, ${"var(--ds-skeleton, #091E420F)"} 50% )`,
        backgroundRepeat: 'no-repeat',
        borderRadius: '2px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width
    }));
const $39c21c8edc6f2616$export$b1deee0d21f1be36 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "ieqbub-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height
    }));
const $39c21c8edc6f2616$export$dc84d515085190e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height),
            "--_1gljcou": (0, $lD23V.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkn82g _1itk1kpv _12vemgnk _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $39c21c8edc6f2616$export$e477bb7d17087f28 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1474",
            __cmplp.className
        ])
    });
});
const $39c21c8edc6f2616$export$8f31e4c4a37b8e9c = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('enghealth-4756-migrate-complex-styled-component'), $39c21c8edc6f2616$export$dc84d515085190e, $39c21c8edc6f2616$export$1d2144641222f3bd);
const $39c21c8edc6f2616$export$d7a54cba636a8cd6 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('enghealth-4756-migrate-complex-styled-component'), $39c21c8edc6f2616$export$e477bb7d17087f28, $39c21c8edc6f2616$export$b1deee0d21f1be36);

});



const $7d87475f2d1b3049$export$3aafeb2daa00df8b = 'key';
const $7d87475f2d1b3049$export$48927a8f78b0130e = 'issueid';
const $7d87475f2d1b3049$export$469f8bf472cb9ca = 'summary';
const $7d87475f2d1b3049$export$29157f6cae91bb2f = 'status';
const $7d87475f2d1b3049$export$dd03acb09519222 = 'issuetype';
const $7d87475f2d1b3049$export$ed9d952d27dea151 = 'labels';
const $7d87475f2d1b3049$export$1f3d7d17213e853b = 'votes';
const $7d87475f2d1b3049$export$cb59b69c70ea9e18 = 'reporter';
const $7d87475f2d1b3049$export$d6749ecf5a14d5b = 'description';
const $7d87475f2d1b3049$export$7e67ea07bd31e757 = 'assignee';
const $7d87475f2d1b3049$export$4b6f00f5eeabd293 = 'creator';
const $7d87475f2d1b3049$export$16313363fca8abe5 = 'created';
const $7d87475f2d1b3049$export$77c57adf6bed37b8 = 'updated';
const $7d87475f2d1b3049$export$1fd24e9c03ef9b18 = 'project';

const $739ce7f4993d045e$export$76e8cbc60f99881d = 'TABLE';
const $739ce7f4993d045e$export$1ad049af934b4509 = 'BOARD';
const $739ce7f4993d045e$export$2b0330ebc4df6bb5 = 'MATRIX';
const $739ce7f4993d045e$export$b536e56a69266159 = 'TIMELINE';
const $739ce7f4993d045e$export$4f6053f7f1423a0c = 'SECTION';
const $739ce7f4993d045e$export$84ce1bdcbd34dd0c = 'TWOXTWO';

parcelRegister("1X3JP", function(module, exports) {

$parcel$export(module.exports, "EmojiPicker", () => $277af980fb64cf62$export$6335145236247192);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $1Seuh = parcelRequire("1Seuh");

var $4VARR = parcelRequire("4VARR");
var $1lHCF = parcelRequire("1lHCF");

var $jcX1N = parcelRequire("jcX1N");

var $7H980 = parcelRequire("7H980");
var $aOrxC = parcelRequire("aOrxC");
var $70rf1 = parcelRequire("70rf1");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $agzbr = parcelRequire("agzbr");

var $a8fLF = parcelRequire("a8fLF");
const $277af980fb64cf62$export$6335145236247192 = ({ onEmojiSelected: onEmojiSelected, selectedEmojiId: selectedEmojiId, readonly: readonly = false, placement: placement = 'bottom-start', noPadding: noPadding = false, color: color, offset: offset, zIndex: zIndex, emojiAddIcon: emojiAddIcon, shouldRenderToParent: shouldRenderToParent = false, onOpenChange: onOpenChange, onEmojiLoaded: onEmojiLoaded })=>{
    const [isPickerOpen, setIsPickerOpen] = (0, $5uXOq.useState)(false);
    const [isMenuOpen, setIsMenuOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const selectedEmoji = (0, $agzbr.useEmoji)(selectedEmojiId);
    const emojiProviderPromise = (0, $agzbr.useEmojiProviderPromise)();
    const onSelection = (0, $5uXOq.useCallback)((_emoji, emojiDescription)=>{
        setIsPickerOpen(false);
        onEmojiSelected?.(emojiDescription);
    }, [
        onEmojiSelected
    ]);
    const handleEmojiClick = ()=>{
        setIsMenuOpen(true);
        setIsPickerOpen(false);
    };
    const handleEditEmoji = ()=>{
        setIsMenuOpen(false);
        setIsPickerOpen(true);
    };
    const toggleEmojiPicker = ()=>{
        setIsPickerOpen((prev)=>!prev);
    };
    const handleDeleteEmoji = ()=>{
        setIsMenuOpen(false);
        onEmojiSelected?.(undefined);
    };
    (0, $5uXOq.useEffect)(()=>{
        onOpenChange?.(isPickerOpen);
    }, [
        isPickerOpen,
        onOpenChange
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (selectedEmoji === undefined) onEmojiLoaded?.(null);
    }, [
        selectedEmoji,
        onEmojiLoaded
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        direction: "column",
        xcss: $277af980fb64cf62$var$emojiPickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isPickerOpen,
        onClose: ()=>setIsPickerOpen(false),
        messageId: "polaris-lib-emoji-picker.ui.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4VARR.default), {
                emojiProvider: emojiProviderPromise,
                onSelection: onSelection
            })),
        shouldRenderToParent: shouldRenderToParent,
        trigger: (emojiPickerTriggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
                messageId: "polaris-lib-emoji-picker.ui.popup.1",
                messageType: "transactional",
                isOpen: isMenuOpen,
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), {
                        onClick: (e)=>e.stopPropagation()
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
                        onClick: handleEditEmoji,
                        testId: "polaris-lib-emoji-picker.ui.edit-button"
                    }, formatMessage((0, $a8fLF.default).editEmoji)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
                        onClick: handleDeleteEmoji,
                        testId: "polaris-lib-emoji-picker.ui.remove-button"
                    }, formatMessage((0, $a8fLF.default).removeEmoji)))),
                placement: "bottom-start",
                onClose: ()=>setIsMenuOpen(false),
                trigger: (popupTriggerProps)=>selectedEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($277af980fb64cf62$var$EmojiButton, {
                        "data-testid": "polaris-lib-emoji-picker.ui.emoji-button",
                        ...isMenuOpen ? popupTriggerProps : emojiPickerTriggerProps,
                        disabled: readonly,
                        color: color,
                        onClick: handleEmojiClick,
                        noPadding: noPadding,
                        type: "button"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1lHCF.default), {
                        emoji: selectedEmoji,
                        fitToHeight: 24,
                        showTooltip: true,
                        onLoadSuccess: onEmojiLoaded
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
                        testId: "polaris-lib-emoji-picker.ui.add-button",
                        ...emojiPickerTriggerProps,
                        isDisabled: readonly,
                        icon: emojiAddIcon ?? (0, (/*@__PURE__*/$parcel$interopDefault($jcX1N))),
                        appearance: "subtle",
                        label: formatMessage((0, $a8fLF.default).emojiButtonCaption),
                        onClick: toggleEmojiPicker,
                        spacing: noPadding ? 'compact' : 'default',
                        type: "button"
                    }),
                zIndex: zIndex
            }),
        placement: placement,
        offset: offset,
        zIndex: zIndex
    }));
};
const $277af980fb64cf62$var$emojiPickerContainerStyles = (0, $2s57o.xcss)({
    maxWidth: '192px'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $277af980fb64cf62$var$EmojiButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { noPadding: noPadding, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_rmkr0o": (0, $lD23V.default)(__cmplp.noPadding ? 24 : 32, "px"),
            "--_1cy9snk": (0, $lD23V.default)(__cmplp.color || 'transparent')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itglyw _2rkosqtm _v5641yx9 _1e0c1txw _80omtlke _1bsbifu1 _4t3iifu1 _1bah1h6o _4cvr1h6o _bfhk1dst _tv5ym7j4 _cun918uv _j5dh13gf _1j55clii _1di615ej",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4VARR", function(module, exports) {

$parcel$export(module.exports, "default", () => $79539fbed1ea2929$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EmojiPicker", () => (parcelRequire("44xT4")).default);

var $ddgvn = parcelRequire("ddgvn");

var $1lHCF = parcelRequire("1lHCF");

var $gDljz = parcelRequire("gDljz");

var $fgZWY = parcelRequire("fgZWY");

var $44xT4 = parcelRequire("44xT4");



var $7lVNo = parcelRequire("7lVNo");


var $cNjCa = parcelRequire("cNjCa");





var $eekPL = parcelRequire("eekPL");
var $30bPV = parcelRequire("30bPV");

var $aGRkq = parcelRequire("aGRkq");






var $eyWYN = parcelRequire("eyWYN");
var $79539fbed1ea2929$export$2e2bcd8739ae039 = (0, $44xT4.default);

});
parcelRegister("1lHCF", function(module, exports) {

$parcel$export(module.exports, "EmojiNodeWrapper", () => $5ed81e8b5d498fa3$export$ce5eef59d8e46687);
$parcel$export(module.exports, "default", () => $5ed81e8b5d498fa3$export$2e2bcd8739ae039);
/* Emoji.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $5KCCi = parcelRequire("5KCCi");

var $2Tr6g = parcelRequire("2Tr6g");

var $aGRkq = parcelRequire("aGRkq");

var $70f7p = parcelRequire("70f7p");

var $eyWYN = parcelRequire("eyWYN");

var $dLQFy = parcelRequire("dLQFy");

var $6FGIp = parcelRequire("6FGIp");


var $2AeLS = parcelRequire("2AeLS");
var $fScLw = parcelRequire("fScLw");

var $2DB0m = parcelRequire("2DB0m");

var $5clt2 = parcelRequire("5clt2");

var $2AeLS = parcelRequire("2AeLS");

var $i76dL = parcelRequire("i76dL");

var $fXR4p = parcelRequire("fXR4p");
const $5ed81e8b5d498fa3$var$emojiSpriteContainer = null;
const $5ed81e8b5d498fa3$var$emojiImageContainer = null;
const $5ed81e8b5d498fa3$var$handleMouseDown = (props, event)=>{
    // Clicked emoji delete button
    if (event.target instanceof Element && event.target.getAttribute('aria-label') === (0, $aGRkq.deleteEmojiLabel)) return;
    const { emoji: emoji, onSelected: onSelected } = props;
    if (onSelected && (0, $dLQFy.leftClick)(event)) onSelected((0, $70f7p.toEmojiId)(emoji), emoji, event);
};
const $5ed81e8b5d498fa3$var$handleKeyDown = (props, event)=>{
    if (!(0, $aGRkq.EMOJI_KEYBOARD_KEYS_SUPPORTED).includes(event.key)) return;
    event.preventDefault();
    event.stopPropagation();
    const { emoji: emoji, onSelected: onSelected, showDelete: showDelete } = props;
    if (onSelected && (event.key === (0, $aGRkq.KeyboardKeys).Enter || event.key === (0, $aGRkq.KeyboardKeys).Space)) onSelected((0, $70f7p.toEmojiId)(emoji), emoji, event);
    if (showDelete && event.key === (0, $aGRkq.KeyboardKeys).Backspace) $5ed81e8b5d498fa3$var$handleDelete(props, event);
};
const $5ed81e8b5d498fa3$var$handleMouseMove = (props, event)=>{
    const { emoji: emoji, onMouseMove: onMouseMove } = props;
    if (onMouseMove) onMouseMove((0, $70f7p.toEmojiId)(emoji), emoji, event);
};
const $5ed81e8b5d498fa3$var$handleFocus = (props, event)=>{
    const { emoji: emoji, onFocus: onFocus } = props;
    if (onFocus) onFocus((0, $70f7p.toEmojiId)(emoji), emoji, event);
};
const $5ed81e8b5d498fa3$var$handleDelete = (props, event)=>{
    const { emoji: emoji, onDelete: onDelete } = props;
    if (onDelete) onDelete((0, $70f7p.toEmojiId)(emoji), emoji, event);
};
const $5ed81e8b5d498fa3$var$handleImageError = (props, event)=>{
    const { emoji: emoji, onLoadError: onLoadError } = props;
    // Hide error state (but keep space for it)
    if (event.target) {
        const target = event.target;
        target.style.visibility = 'hidden';
    }
    if (onLoadError) onLoadError((0, $70f7p.toEmojiId)(emoji), emoji, event);
};
const $5ed81e8b5d498fa3$export$ef49ddbb198ce334 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const representation = emoji.representation;
    const sprite = representation.sprite;
    const classes = `${(0, $f7dab96e234b935f$export$b06c4aab1d012063)} ${selected ? (0, $f7dab96e234b935f$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $f7dab96e234b935f$export$860109dfd198259b) : ''} ${className ? className : ''}`;
    let sizing = {};
    if (fitToHeight) sizing = {
        width: `${fitToHeight}px`,
        height: `${fitToHeight}px`,
        minHeight: `${fitToHeight}px`,
        minWidth: `${fitToHeight}px`
    };
    const xPositionInPercent = 100 / (sprite.column - 1) * (representation.xIndex - 0);
    const yPositionInPercent = 100 / (sprite.row - 1) * (representation.yIndex - 0);
    const style = {
        backgroundImage: `url(${sprite.url})`,
        backgroundPosition: `${xPositionInPercent}% ${yPositionInPercent}%`,
        backgroundSize: `${sprite.column * 100}% ${sprite.row * 100}%`,
        ...sizing
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)($5ed81e8b5d498fa3$export$ce5eef59d8e46687, {
        ...props,
        type: "sprite",
        className: classes,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            className: (0, $f7dab96e234b935f$export$1c10634420a08d8a),
            style: style
        })
    }));
};
const $5ed81e8b5d498fa3$export$99dfeb9d71c11788 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showDelete: showDelete, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth } = props;
    const [ref, inView] = (0, $5clt2.useInView)({
        triggerOnce: true
    });
    const ufoExp = (0, $2AeLS.sampledUfoRenderedEmoji)(emoji);
    const classes = `${(0, $f7dab96e234b935f$export$11462c0756c24ab6)} ${(0, $f7dab96e234b935f$export$b06c4aab1d012063)} ${selected ? (0, $f7dab96e234b935f$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $f7dab96e234b935f$export$860109dfd198259b) : ''} ${(0, $f7dab96e234b935f$export$da61cef1c8919f7c)} ${className ? className : ''} ${showDelete ? (0, $f7dab96e234b935f$export$22b19c311e9caa4) : ''}`;
    let width;
    let height;
    let src;
    const representation = (0, $2Tr6g.shouldUseAltRepresentation)(emoji, fitToHeight) ? emoji.altRepresentation : emoji.representation;
    if ((0, $70f7p.isImageRepresentation)(representation)) {
        src = representation.imagePath;
        width = representation.width;
        height = representation.height;
    } else if ((0, $70f7p.isMediaRepresentation)(representation)) {
        src = representation.mediaPath;
        width = representation.width;
        height = representation.height;
    }
    let sizing = {};
    if (fitToHeight && width && height) // Presize image, to prevent reflow due to size changes after loading
    sizing = {
        // Size of <img> needs to be deterministic when rendered on server-side. Auto will cause width to be 0 before image is loaded.
        width: autoWidth && !(0, $fXR4p.isSSR)() ? 'auto' : fitToHeight / height * width,
        height: fitToHeight
    };
    const onError = (0, $5uXOq.useCallback)((event)=>{
        $5ed81e8b5d498fa3$var$handleImageError(props, event);
    }, [
        props
    ]);
    const onLoad = (0, $5uXOq.useCallback)(()=>{
        const mountedMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $eyWYN.UfoEmojiTimings).MOUNTED_END);
        // onload could trigger before onBeforeLoad when emojis in viewport at start, so we need to mark onload start manually.
        if (!(0, $2AeLS.hasUfoMarked)(ufoExp, (0, $eyWYN.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $eyWYN.UfoEmojiTimings).ONLOAD_START, mountedMark?.time);
        const loadedStartMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $eyWYN.UfoEmojiTimings).ONLOAD_START);
        if (mountedMark && loadedStartMark) ufoExp.addMetadata({
            lazyLoad: loadedStartMark.time > mountedMark.time
        });
        // onload_start
        if (!(0, $2AeLS.hasUfoMarked)(ufoExp, (0, $eyWYN.UfoEmojiTimings).ONLOAD_END)) ufoExp.mark((0, $eyWYN.UfoEmojiTimings).ONLOAD_END);
        ufoExp.success({
            metadata: {
                IBSupported: (0, $2DB0m.default).supportsIntersectionObserver
            }
        });
        if (onLoadSuccess) onLoadSuccess(emoji);
    }, [
        emoji,
        onLoadSuccess,
        ufoExp
    ]);
    const onBeforeLoad = (0, $5uXOq.useCallback)(()=>{
        if (!(0, $2AeLS.hasUfoMarked)(ufoExp, (0, $eyWYN.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $eyWYN.UfoEmojiTimings).ONLOAD_START);
    }, [
        ufoExp
    ]);
    const onMouseOver = (0, $5uXOq.useCallback)((e)=>{
        // only disable tooltip when not on focus
        if (!document.activeElement?.contains(e.target)) e.stopPropagation();
    }, []);
    // because of the lack of browser support of on before load natively, used IntersectionObserver helper hook to mimic the before load time mark for UFO.
    (0, $5uXOq.useEffect)(()=>{
        if (inView) onBeforeLoad();
    }, [
        inView,
        onBeforeLoad
    ]);
    const emojiNode = /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        //@ts-ignore
        loading: disableLazyLoad ? 'eager' : 'lazy',
        src: src,
        alt: emoji.name || emoji.shortName,
        "data-emoji-short-name": emoji.shortName,
        "data-emoji-id": emoji.id,
        "data-emoji-text": emoji.fallback || emoji.shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "emoji",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            visibility: 'visible'
        },
        onError: onError,
        onLoad: onLoad,
        ...sizing,
        "data-vc": "emoji"
    }, src);
    // show a tooltip for deletable emoji only on focus
    if (showDelete) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i76dL.DeletableEmojiTooltipContent), {}),
        position: "right-start",
        tag: "span",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)($5ed81e8b5d498fa3$export$ce5eef59d8e46687, {
            ...props,
            "aria-labelledby": `screenreader-emoji-${emoji.id}`,
            type: "image",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: classes,
            ref: ref,
            showTooltip: false,
            onMouseOver: onMouseOver,
            children: [
                emojiNode,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6FGIp.default), {
                    onClick: (event)=>$5ed81e8b5d498fa3$var$handleDelete(props, event)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i76dL.DeletableEmojiTooltipContentForScreenReader), {
                    emoji: emoji
                })
            ]
        })
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)($5ed81e8b5d498fa3$export$ce5eef59d8e46687, {
        ...props,
        type: "image",
        className: classes,
        ref: ref,
        children: emojiNode
    }));
};
const $5ed81e8b5d498fa3$export$ce5eef59d8e46687 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showTooltip: showTooltip, showDelete: showDelete, shouldBeInteractive: shouldBeInteractive = false, tabIndex: tabIndex, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, onDelete: onDelete, onLoadError: onLoadError, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, children: children, type: type, editorEmoji: editorEmoji, ...other } = props;
    let accessibilityProps;
    if (editorEmoji) accessibilityProps = {
        role: undefined
    };
    else if (shouldBeInteractive) accessibilityProps = {
        role: 'button',
        'aria-label': emoji.shortName
    };
    else accessibilityProps = {
        role: 'img',
        'aria-label': emoji.shortName
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...accessibilityProps,
        ref: ref,
        "data-testid": `${type}-emoji-${emoji.shortName}`,
        "data-emoji-type": type,
        tabIndex: shouldBeInteractive ? tabIndex || 0 : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            type === 'sprite' ? "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _1e0c1o8l _jr50scvx _ylp71o8l _pkaxgktf _1hdcgktf _109tnkob _tn8j14ae _3naf14ae _nt751r31 _49pcglyw _1hvw1o36 _7ehi1n2i _491113zc" : "_2rkosqtm _19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _bfhk18uv _1e0c1o8l _s7n4nkob _v4pn1ule _tn8j14ae _3naf14ae _160jewfl _1theewfl _1kogh2mm _qyp0ewfl _nt751r31 _49pcglyw _1hvw1o36 _7ehi1n2i _491113zc",
            className
        ]),
        onKeyDown: (event)=>$5ed81e8b5d498fa3$var$handleKeyDown(props, event),
        onMouseDown: (event)=>{
            $5ed81e8b5d498fa3$var$handleMouseDown(props, event);
        },
        onMouseEnter: (event)=>{
            $5ed81e8b5d498fa3$var$handleMouseMove(props, event);
        },
        onFocus: (event)=>{
            $5ed81e8b5d498fa3$var$handleFocus(props, event);
        },
        title: showTooltip ? emoji.shortName : undefined,
        ...other,
        children: children
    });
});
const $5ed81e8b5d498fa3$export$56cc48506ff790a = (props)=>{
    const { emoji: emoji } = props;
    // start emoji rendered experience, it may have already started earlier in ResourcedEmoji or CachingEmoji
    (0, $fScLw.useSampledUFOComponentExperience)((0, $2AeLS.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $aGRkq.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'Emoji',
        emojiId: emoji.id
    });
    (0, $5uXOq.useEffect)(()=>{
        const ufoExp = (0, $2AeLS.sampledUfoRenderedEmoji)(emoji);
        if (!(0, $2AeLS.hasUfoMarked)(ufoExp, 'fmp')) ufoExp.markFMP();
        if (!(0, $2AeLS.hasUfoMarked)(ufoExp, (0, $eyWYN.UfoEmojiTimings).MOUNTED_END)) ufoExp.mark((0, $eyWYN.UfoEmojiTimings).MOUNTED_END);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // TODO: We always prefer render as image as having accessibility issues with sprite representation
    if ((0, $70f7p.isSpriteRepresentation)(emoji.representation)) return /*#__PURE__*/ (0, $2OMIu.jsx)($5ed81e8b5d498fa3$export$ef49ddbb198ce334, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5ed81e8b5d498fa3$export$99dfeb9d71c11788, {
        ...props
    });
};
var $5ed81e8b5d498fa3$export$2e2bcd8739ae039 = $5ed81e8b5d498fa3$export$56cc48506ff790a;

});
parcelRegister("dLQFy", function(module, exports) {

$parcel$export(module.exports, "leftClick", () => $744507bb8e14d818$export$34ebdaf2c517ae75);
function $744507bb8e14d818$export$fd3cd03f8ac42187(event) {
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $744507bb8e14d818$export$de744e30016241b0(oldPosition, newPosition) {
    if (!oldPosition || oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y) return true;
    return false;
}
function $744507bb8e14d818$export$34ebdaf2c517ae75(reactEvent) {
    return reactEvent.button === 0 && !reactEvent.altKey && !reactEvent.ctrlKey && !reactEvent.metaKey && !reactEvent.shiftKey;
}

});

parcelRegister("6FGIp", function(module, exports) {

$parcel$export(module.exports, "default", () => $fac334eb040ef2b3$export$2e2bcd8739ae039);
/* DeleteButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $1dsdR = parcelRequire("1dsdR");


var $aGRkq = parcelRequire("aGRkq");


var $5sRpy = parcelRequire("5sRpy");
const $fac334eb040ef2b3$var$styles = {
    boxWrapperStyle: "_1bsbf6fq _4t3if6fq"
};
const $fac334eb040ef2b3$var$deleteButton = null;
const $fac334eb040ef2b3$export$28fc7374cf1206d4 = 'render-emoji-delete-button';
const $fac334eb040ef2b3$var$DeleteButton = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_3um015vq _1e0c1txw _kqswstnw _154ix0bf _1xi2x0bf _1pbykb7n _13t3idpf",
            (0, $f7dab96e234b935f$export$b11fa39b56a371f6)
        ]),
        "data-testid": $fac334eb040ef2b3$export$28fc7374cf1206d4,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
            iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                xcss: $fac334eb040ef2b3$var$styles.boxWrapperStyle,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1dsdR))), {
                    label: (0, $aGRkq.deleteEmojiLabel),
                    color: `var(--ds-text-subtle, ${(0, $a7f8c6b391092279$export$c39c0fe0f26207ae)})`,
                    LEGACY_size: "small"
                })
            }),
            onClick: props.onClick,
            // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
            appearance: "subtle-link",
            spacing: "none",
            testId: "emoji-delete-button",
            tabIndex: -1
        })
    });
var $fac334eb040ef2b3$export$2e2bcd8739ae039 = $fac334eb040ef2b3$var$DeleteButton;

});
parcelRegister("1dsdR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23abdef56045225c72ffa19368031ad5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e2ce5c3d621afa2$var$_react = $0e2ce5c3d621afa2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e2ce5c3d621afa2$var$_crossCircle = $0e2ce5c3d621afa2$var$_interopRequireDefault((parcelRequire("8wCU9")));

var $0e2ce5c3d621afa2$var$_crossCircle2 = $0e2ce5c3d621afa2$var$_interopRequireDefault((parcelRequire("4y6Pt")));
function $0e2ce5c3d621afa2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "CrossCircleIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e2ce5c3d621afa2$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $0e2ce5c3d621afa2$var$_react.default.createElement($0e2ce5c3d621afa2$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $0e2ce5c3d621afa2$var$_crossCircle2.default
    }, props));
$0e2ce5c3d621afa2$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $0e2ce5c3d621afa2$var$_default = module.exports.default = $0e2ce5c3d621afa2$var$CrossCircleIcon;

});

const $f7dab96e234b935f$export$8633a0edef8e95dd = 'emoji-common-selected';
const $f7dab96e234b935f$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $f7dab96e234b935f$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $f7dab96e234b935f$export$b06c4aab1d012063 = 'emoji-common-node';
const $f7dab96e234b935f$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $f7dab96e234b935f$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $f7dab96e234b935f$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $f7dab96e234b935f$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $f7dab96e234b935f$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $f7dab96e234b935f$export$b0fe756d87022806 = 'emoji-picker-add-emoji';


parcelRegister("fScLw", function(module, exports) {

$parcel$export(module.exports, "useSampledUFOComponentExperience", () => $7f956e0ea7aa5bbc$export$f959821a7419dee1);

var $5uXOq = parcelRequire("5uXOq");

var $30bPV = parcelRequire("30bPV");
const $7f956e0ea7aa5bbc$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $5uXOq.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $7f956e0ea7aa5bbc$export$f959821a7419dee1 = (experience, samplingRate, metadata)=>{
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            (0, $30bPV.withSampling)(experience).abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $7f956e0ea7aa5bbc$var$useConstructor(()=>{
        (0, $30bPV.withSampling)(experience).start({
            samplingRate: samplingRate
        });
        const isMetadataEmpty = Object.keys(experience.metadata).length === 0;
        if (metadata && isMetadataEmpty) experience.addMetadata(metadata);
    });
    return null;
};

});

parcelRegister("2DB0m", function(module, exports) {

$parcel$export(module.exports, "default", () => $15d5f08e13ef5329$export$2e2bcd8739ae039);
const $15d5f08e13ef5329$var$result = {
    mac: false,
    supportsIntersectionObserver: false
};
if (typeof navigator !== 'undefined') {
    $15d5f08e13ef5329$var$result.mac = /Mac/.test(navigator.platform);
    $15d5f08e13ef5329$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
}
var $15d5f08e13ef5329$export$2e2bcd8739ae039 = $15d5f08e13ef5329$var$result;

});

parcelRegister("5clt2", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $0a8712b35bbe133f$export$2f62ee6831462844);

var $6ggyj = parcelRequire("6ggyj");

var $2DB0m = parcelRequire("2DB0m");
const $0a8712b35bbe133f$export$2f62ee6831462844 = (options)=>{
    const hookResult = (0, $6ggyj.useInView)(options);
    if (!(0, $2DB0m.default).supportsIntersectionObserver) // Unsupported, return no `ref` and default `inView` true value
    return [
        undefined,
        true
    ];
    return hookResult;
};

});
parcelRegister("6ggyj", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $48f113a7cf9419a6$export$2f62ee6831462844);

var $5uXOq = parcelRequire("5uXOq");
function $48f113a7cf9419a6$var$_extends() {
    $48f113a7cf9419a6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $48f113a7cf9419a6$var$_extends.apply(this, arguments);
}
function $48f113a7cf9419a6$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $48f113a7cf9419a6$var$_setPrototypeOf(subClass, superClass);
}
function $48f113a7cf9419a6$var$_setPrototypeOf(o, p) {
    $48f113a7cf9419a6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $48f113a7cf9419a6$var$_setPrototypeOf(o, p);
}
function $48f113a7cf9419a6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $48f113a7cf9419a6$var$observerMap = new Map();
var $48f113a7cf9419a6$var$RootIds = new WeakMap();
var $48f113a7cf9419a6$var$rootId = 0;
var $48f113a7cf9419a6$var$unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/ function $48f113a7cf9419a6$export$2ef3a60ee1f37bec(inView) {
    $48f113a7cf9419a6$var$unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */ function $48f113a7cf9419a6$var$getRootId(root) {
    if (!root) return '0';
    if ($48f113a7cf9419a6$var$RootIds.has(root)) return $48f113a7cf9419a6$var$RootIds.get(root);
    $48f113a7cf9419a6$var$rootId += 1;
    $48f113a7cf9419a6$var$RootIds.set(root, $48f113a7cf9419a6$var$rootId.toString());
    return $48f113a7cf9419a6$var$RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */ function $48f113a7cf9419a6$var$optionsToId(options) {
    return Object.keys(options).sort().filter(function(key) {
        return options[key] !== undefined;
    }).map(function(key) {
        return key + "_" + (key === 'root' ? $48f113a7cf9419a6$var$getRootId(options.root) : options[key]);
    }).toString();
}
function $48f113a7cf9419a6$var$createObserver(options) {
    // Create a unique ID for this observer instance, based on the root, root margin and threshold.
    var id = $48f113a7cf9419a6$var$optionsToId(options);
    var instance = $48f113a7cf9419a6$var$observerMap.get(id);
    if (!instance) {
        // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
        var elements = new Map();
        var thresholds;
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var _elements$get;
                // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
                // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
                var inView = entry.isIntersecting && thresholds.some(function(threshold) {
                    return entry.intersectionRatio >= threshold;
                }); // @ts-ignore support IntersectionObserver v2
                if (options.trackVisibility && typeof entry.isVisible === 'undefined') // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
                // @ts-ignore
                entry.isVisible = inView;
                (_elements$get = elements.get(entry.target)) == null || _elements$get.forEach(function(callback) {
                    callback(inView, entry);
                });
            });
        }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $48f113a7cf9419a6$var$observerMap.set(id, instance);
    }
    return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */ function $48f113a7cf9419a6$export$d1203567a167490e(element, callback, options, fallbackInView) {
    if (options === void 0) options = {};
    if (fallbackInView === void 0) fallbackInView = $48f113a7cf9419a6$var$unsupportedValue;
    if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
        var bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return function() {};
    } // An observer with the same options can be reused, so lets use this fact
    var _createObserver = $48f113a7cf9419a6$var$createObserver(options), id = _createObserver.id, observer = _createObserver.observer, elements = _createObserver.elements; // Register the callback listener for this element
    var callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        // Remove the callback from the callback list
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            // No more callback exists for element, so destroy it
            elements["delete"](element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            // No more elements are being observer by this instance, so destroy it
            observer.disconnect();
            $48f113a7cf9419a6$var$observerMap["delete"](id);
        }
    };
}
var $48f113a7cf9419a6$var$_excluded = [
    "children",
    "as",
    "triggerOnce",
    "threshold",
    "root",
    "rootMargin",
    "onChange",
    "skip",
    "trackVisibility",
    "delay",
    "initialInView",
    "fallbackInView"
];
function $48f113a7cf9419a6$var$isPlainChildren(props) {
    return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */ var $48f113a7cf9419a6$export$a62107ca74432f44 = /*#__PURE__*/ function(_React$Component) {
    $48f113a7cf9419a6$var$_inheritsLoose(InView, _React$Component);
    function InView(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.node = null;
        _this._unobserveCb = null;
        _this.handleNode = function(node) {
            if (_this.node) {
                // Clear the old observer, before we start observing a new element
                _this.unobserve();
                if (!node && !_this.props.triggerOnce && !_this.props.skip) // Reset the state if we get a new node, and we aren't ignoring updates
                _this.setState({
                    inView: !!_this.props.initialInView,
                    entry: undefined
                });
            }
            _this.node = node ? node : null;
            _this.observeNode();
        };
        _this.handleChange = function(inView, entry) {
            if (inView && _this.props.triggerOnce) // If `triggerOnce` is true, we should stop observing the element.
            _this.unobserve();
            if (!$48f113a7cf9419a6$var$isPlainChildren(_this.props)) // Store the current State, so we can pass it to the children in the next render update
            // There's no reason to update the state for plain children, since it's not used in the rendering.
            _this.setState({
                inView: inView,
                entry: entry
            });
            if (_this.props.onChange) // If the user is actively listening for onChange, always trigger it
            _this.props.onChange(inView, entry);
        };
        _this.state = {
            inView: !!props.initialInView,
            entry: undefined
        };
        return _this;
    }
    var _proto = InView.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        // If a IntersectionObserver option changed, reinit the observer
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unobserve();
        this.node = null;
    };
    _proto.observeNode = function observeNode() {
        if (!this.node || this.props.skip) return;
        var _this$props = this.props, threshold = _this$props.threshold, root = _this$props.root, rootMargin = _this$props.rootMargin, trackVisibility = _this$props.trackVisibility, delay = _this$props.delay, fallbackInView = _this$props.fallbackInView;
        this._unobserveCb = $48f113a7cf9419a6$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    };
    _proto.unobserve = function unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    };
    _proto.render = function render() {
        if (!$48f113a7cf9419a6$var$isPlainChildren(this.props)) {
            var _this$state = this.state, inView = _this$state.inView, entry = _this$state.entry;
            return this.props.children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        var _this$props2 = this.props, children = _this$props2.children, as = _this$props2.as, props = $48f113a7cf9419a6$var$_objectWithoutPropertiesLoose(_this$props2, $48f113a7cf9419a6$var$_excluded);
        return /*#__PURE__*/ $5uXOq.createElement(as || 'div', $48f113a7cf9419a6$var$_extends({
            ref: this.handleNode
        }, props), children);
    };
    return InView;
}($5uXOq.Component);
$48f113a7cf9419a6$export$a62107ca74432f44.displayName = 'InView';
$48f113a7cf9419a6$export$a62107ca74432f44.defaultProps = {
    threshold: 0,
    triggerOnce: false,
    initialInView: false
};
/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */ function $48f113a7cf9419a6$export$2f62ee6831462844(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, threshold = _ref.threshold, delay = _ref.delay, trackVisibility = _ref.trackVisibility, rootMargin = _ref.rootMargin, root = _ref.root, triggerOnce = _ref.triggerOnce, skip = _ref.skip, initialInView = _ref.initialInView, fallbackInView = _ref.fallbackInView;
    var unobserve = $5uXOq.useRef();
    var _React$useState = $5uXOq.useState({
        inView: !!initialInView
    }), state = _React$useState[0], setState = _React$useState[1];
    var setRef = $5uXOq.useCallback(function(node) {
        if (unobserve.current !== undefined) {
            unobserve.current();
            unobserve.current = undefined;
        } // Skip creating the observer
        if (skip) return;
        if (node) unobserve.current = $48f113a7cf9419a6$export$d1203567a167490e(node, function(inView, entry) {
            setState({
                inView: inView,
                entry: entry
            });
            if (entry.isIntersecting && triggerOnce && unobserve.current) {
                // If it should only trigger once, unobserve the element after it's inView
                unobserve.current();
                unobserve.current = undefined;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        Array.isArray(threshold) ? threshold.toString() : threshold,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    /* eslint-disable-next-line */ (0, $5uXOq.useEffect)(function() {
        if (!unobserve.current && state.entry && !triggerOnce && !skip) // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
        // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
        setState({
            inView: !!initialInView
        });
    });
    var result = [
        setRef,
        state.inView,
        state.entry
    ]; // Support object destructuring, by adding the specific values.
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

});


parcelRegister("i76dL", function(module, exports) {

$parcel$export(module.exports, "DeletableEmojiTooltipContent", () => $c46494ee3e3a54ab$export$4727956877b6f612);
$parcel$export(module.exports, "DeletableEmojiTooltipContentForScreenReader", () => $c46494ee3e3a54ab$export$d151e4941072147c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $hbAJx = parcelRequire("hbAJx");

var $frUdK = parcelRequire("frUdK");

var $fGKVg = parcelRequire("fGKVg");

var $cBCgC = parcelRequire("cBCgC");
const $c46494ee3e3a54ab$export$4727956877b6f612 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $frUdK.ToolTipContentWithKeymap), {
        description: formatMessage((0, $hbAJx.messages).deleteEmojiTooltip),
        keymap: (0, $fGKVg.backspace)
    });
};
const $c46494ee3e3a54ab$export$d151e4941072147c = ({ emoji: emoji })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
        id: `screenreader-emoji-${emoji.id}`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $hbAJx.messages).deleteEmojiTooltipForScreenreader,
            values: {
                shortName: emoji.shortName
            }
        })
    });
};

});
parcelRegister("frUdK", function(module, exports) {

$parcel$export(module.exports, "ToolTipContentWithKeymap", () => $66a01f220e1ab8cd$export$c7308f5f9ed494ac);
/* ToolTipContentWithKeymap.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fGKVg = parcelRequire("fGKVg");
const $66a01f220e1ab8cd$var$tooltipShortcutStyle = null;
const $66a01f220e1ab8cd$export$c7308f5f9ed494ac = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && (0, $fGKVg.formatShortcut)(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            description,
            shortcut && description && '\u00A0',
            shortcut && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_2rko1l7b _bfhk17rn _ca0qidpf _n3tdidpf _19bvv77o _u5f3v77o _jqf61teg"
                ]),
                children: shortcut
            })
        ]
    }) : null;
});

});
parcelRegister("fGKVg", function(module, exports) {

$parcel$export(module.exports, "backspace", () => $c1777725e0091543$export$1ea584ca7009bcc1);
$parcel$export(module.exports, "formatShortcut", () => $c1777725e0091543$export$384a290f8c265cc5);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $2DB0m = parcelRequire("2DB0m");
const $c1777725e0091543$export$1ea584ca7009bcc1 = $c1777725e0091543$export$7e6b588cc98b34f1('Backspace', 'Backspace');
function $c1777725e0091543$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace(/Mod/i, 'Ctrl'),
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}
function $c1777725e0091543$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace(/Mod/i, 'Ctrl');
    const mac = common.replace(/Mod/i, 'Cmd');
    return $c1777725e0091543$export$d8a7f422d8d42038(description, windows, mac, common);
}
const $c1777725e0091543$export$8d734690d3a46118 = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
function $c1777725e0091543$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $2DB0m.default).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace(/Cmd/i, '\u2318').replace(/Shift/i, '\u21E7').replace(/Ctrl/i, '\u2303').replace(/Alt/i, '\u2325').replace(/Backspace/i, '\u232B').replace(/Enter/i, '\u23CE');
    else shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = $c1777725e0091543$export$8d734690d3a46118[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $2DB0m.default).mac ? '' : '+');
}

});



parcelRegister("fXR4p", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $b9d33ec995e8620b$export$48d7c418edadb60c);

var $6cAn5 = parcelRequire("6cAn5");
function $b9d33ec995e8620b$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $6cAn5 !== 'undefined' && $6cAn5?.env?.REACT_SSR);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});


parcelRegister("gDljz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a48f78cba7df1611$export$2e2bcd8739ae039);
/* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aGRkq = parcelRequire("aGRkq");

const $a48f78cba7df1611$var$placeholderContainer = null;
const $a48f78cba7df1611$var$easeSweep = null;
const $a48f78cba7df1611$var$placeholderContainerAnimated = null;
const $a48f78cba7df1611$export$73987987fac5266b = (shortName)=>`emoji-placeholder-${shortName}`;
const $a48f78cba7df1611$var$EmojiPlaceholder = (props)=>{
    const { shortName: shortName, size: size = (0, $aGRkq.defaultEmojiHeight), showTooltip: showTooltip, representation: representation, loading: loading = false } = props;
    let scaledWidth;
    let scaledHeight;
    if (representation && size) {
        const width = representation.width;
        const height = representation.height;
        if (width && height) {
            scaledWidth = size / height * width;
            scaledHeight = size;
        }
    }
    const width = scaledWidth || size;
    const height = scaledHeight || size;
    const style = {
        fill: 'f7f7f7',
        minWidth: `${width}px`,
        width: `${width}px`,
        height: `${height}px`
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": $a48f78cba7df1611$export$73987987fac5266b(shortName),
        "aria-busy": loading,
        role: "status",
        "aria-label": shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _2rkosqtm _1reo15vq _18m915vq _kqswh2mm _1e0c1o8l _bfhkttw1 _s7n4nkob _o5721q9c _y3gn1h6o",
            loading && "",
            loading && "_16qq1t1r _1kt9b3bt _cfu11ule _1cs8stnw _1rusiw92 _kfgt1osq _1mp41osq",
            (0, $f7dab96e234b935f$export$c7187bbd1a7a9244)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        title: showTooltip ? shortName : ''
    });
};
var $a48f78cba7df1611$export$2e2bcd8739ae039 = $a48f78cba7df1611$var$EmojiPlaceholder;

});

parcelRegister("fgZWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c863e94b91fe7d9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8JIlu = parcelRequire("8JIlu");

var $952rW = parcelRequire("952rW");

var $2AeLS = parcelRequire("2AeLS");

var $aGRkq = parcelRequire("aGRkq");
const $1c863e94b91fe7d9$var$ResourcedEmoji = (props)=>{
    const { emojiId: emojiId, optimisticImageURL: optimisticImageURL } = props;
    (0, $5uXOq.useEffect)(()=>{
        if (!emojiId) return;
        (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).start({
            samplingRate: (0, $aGRkq.SAMPLING_RATE_EMOJI_RENDERED_EXP)
        });
        (0, $2AeLS.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName).addMetadata({
            source: 'ResourcedEmoji',
            emojiId: emojiId.id,
            isOptimisticImageURL: !!optimisticImageURL
        });
        return ()=>{
            (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).abort({
                metadata: {
                    source: 'ResourcedEmoji',
                    reason: 'unmount'
                }
            });
        };
    }, [
        emojiId,
        optimisticImageURL
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $952rW.UfoErrorBoundary), {
        experiences: [
            (0, $2AeLS.ufoExperiences)['emoji-rendered'].getInstance(props.emojiId.id || props.emojiId.shortName)
        ],
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8JIlu.ResourcedEmojiComponent), {
            ...props
        })
    });
};
var $1c863e94b91fe7d9$export$2e2bcd8739ae039 = $1c863e94b91fe7d9$var$ResourcedEmoji;

});
parcelRegister("8JIlu", function(module, exports) {

$parcel$export(module.exports, "ResourcedEmojiComponent", () => $c236a432f620563b$export$7bfde52eceb3e2f6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $aGRkq = parcelRequire("aGRkq");

var $70f7p = parcelRequire("70f7p");

var $eyWYN = parcelRequire("eyWYN");

var $1lHCF = parcelRequire("1lHCF");

var $gDljz = parcelRequire("gDljz");

var $2AeLS = parcelRequire("2AeLS");

var $jn7Qb = parcelRequire("jn7Qb");

var $2AeLS = parcelRequire("2AeLS");
var $c236a432f620563b$var$ResourcedEmojiComponentRenderStatesEnum = /*#__PURE__*/ function(ResourcedEmojiComponentRenderStatesEnum) {
    ResourcedEmojiComponentRenderStatesEnum["INITIAL"] = "INITIAL";
    ResourcedEmojiComponentRenderStatesEnum["FALLBACK"] = "FALLBACK";
    ResourcedEmojiComponentRenderStatesEnum["EMOJI"] = "EMOJI";
    return ResourcedEmojiComponentRenderStatesEnum;
}($c236a432f620563b$var$ResourcedEmojiComponentRenderStatesEnum || {});
const $c236a432f620563b$export$7bfde52eceb3e2f6 = (props)=>{
    const { emojiProvider: emojiProvider, emojiId: emojiId, showTooltip: showTooltip = false, customFallback: customFallback, fitToHeight: fitToHeight = (0, $aGRkq.defaultEmojiHeight), optimistic: optimistic = false, optimisticImageURL: optimisticImageURL, editorEmoji: editorEmoji } = props;
    const { shortName: shortName, id: id, fallback: fallback } = emojiId;
    const [emoji, setEmoji] = (0, $5uXOq.useState)();
    const [loaded, setLoaded] = (0, $5uXOq.useState)(false);
    const [imageLoadError, setImageLoadError] = (0, $5uXOq.useState)(false);
    const [resolvedEmojiProvider, setResolvedEmojiProvider] = (0, $5uXOq.useState)();
    const fetchOrGetEmoji = (0, $5uXOq.useCallback)(async (_emojiProvider, emojiId, optimisticFetch = false)=>{
        if (!_emojiProvider.fetchByEmojiId) {
            setEmoji(undefined);
            (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).failure({
                metadata: {
                    reason: 'missing fetchByEmojiId interface',
                    source: 'ResourcedEmojiComponent'
                }
            });
        }
        const foundEmoji = _emojiProvider.fetchByEmojiId(emojiId, optimisticFetch);
        (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).mark((0, $eyWYN.UfoEmojiTimings).METADATA_START);
        if ((0, $70f7p.isPromise)(foundEmoji)) {
            setLoaded(false);
            foundEmoji.then((emoji)=>{
                setEmoji(emoji);
                if (!emoji) // emoji is undefined
                (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).failure({
                    metadata: {
                        reason: 'failed to find',
                        source: 'ResourcedEmojiComponent',
                        data: {
                            emoji: {
                                id: emojiId.id,
                                shortName: emojiId.shortName
                            }
                        }
                    }
                });
            }).catch(()=>{
                setEmoji(undefined);
                (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).failure({
                    metadata: {
                        reason: 'failed to load',
                        source: 'ResourcedEmojiComponent',
                        data: {
                            emoji: {
                                id: emojiId.id,
                                shortName: emojiId.shortName
                            }
                        }
                    }
                });
            }).finally(()=>{
                setLoaded(true);
                (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).mark((0, $eyWYN.UfoEmojiTimings).METADATA_END);
            });
        } else {
            setEmoji(foundEmoji);
            setLoaded(true);
            (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).mark((0, $eyWYN.UfoEmojiTimings).METADATA_END);
        }
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!emojiId) return;
        if (!(0, $2AeLS.hasUfoMarked)((0, $2AeLS.sampledUfoRenderedEmoji)(emojiId), (0, $eyWYN.UfoEmojiTimings).FMP_END)) (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).markFMP();
    }, [
        emojiId
    ]);
    (0, $5uXOq.useMemo)(()=>{
        if (!resolvedEmojiProvider || !emojiId) return;
        fetchOrGetEmoji(resolvedEmojiProvider, emojiId, optimistic);
    }, [
        resolvedEmojiProvider,
        emojiId,
        optimistic,
        fetchOrGetEmoji
    ]);
    /**
	 * Setting resolved emoji provider for optimistic rendering
	 */ (0, $5uXOq.useEffect)(()=>{
        Promise.resolve(emojiProvider).then((emojiProvider)=>{
            setResolvedEmojiProvider(emojiProvider);
        });
    }, [
        emojiProvider
    ]);
    const emojiRenderState = (0, $5uXOq.useMemo)(()=>{
        if (!emoji && !loaded && !optimisticImageURL) return "INITIAL";
        else if (!emoji && loaded || imageLoadError) return "FALLBACK";
        return "EMOJI";
    }, [
        emoji,
        loaded,
        optimisticImageURL,
        imageLoadError
    ]);
    const optimisticEmojiDescription = (0, $5uXOq.useMemo)(()=>{
        if (optimisticImageURL) {
            if (emoji && ((0, $70f7p.isImageRepresentation)(emoji.representation) || (0, $70f7p.isMediaRepresentation)(emoji?.representation))) {
                const { width: width, height: height } = emoji.representation;
                return {
                    ...emoji,
                    representation: {
                        width: width,
                        height: height,
                        imagePath: optimisticImageURL
                    }
                };
            } else return {
                id: id,
                shortName: shortName,
                fallback: fallback,
                type: '',
                category: '',
                representation: {
                    height: fitToHeight || (0, $aGRkq.defaultEmojiHeight),
                    width: fitToHeight || (0, $aGRkq.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true
            };
        }
        return emoji;
    }, [
        emoji,
        optimisticImageURL,
        fallback,
        fitToHeight,
        id,
        shortName
    ]);
    const handleOnLoadError = (0, $5uXOq.useCallback)((emojiId)=>{
        setImageLoadError(true);
        (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).failure({
            metadata: {
                reason: 'load error',
                source: 'ResourcedEmojiComponent',
                emojiId: emojiId.id
            }
        });
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jn7Qb.EmojiCommonProvider), {
        emojiProvider: resolvedEmojiProvider,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
            "data-emoji-id": id,
            "data-emoji-short-name": shortName,
            "data-emoji-text": fallback || shortName,
            children: [
                emojiRenderState === "INITIAL" && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gDljz.default), {
                    shortName: shortName,
                    showTooltip: showTooltip,
                    size: fitToHeight || (0, $aGRkq.defaultEmojiHeight),
                    loading: true
                }),
                emojiRenderState === "FALLBACK" && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: customFallback || fallback || shortName
                }),
                emojiRenderState === "EMOJI" && optimisticEmojiDescription && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1lHCF.default), {
                    emoji: optimisticEmojiDescription,
                    onLoadError: handleOnLoadError,
                    showTooltip: showTooltip,
                    fitToHeight: fitToHeight,
                    autoWidth: !!emoji ? false : true,
                    editorEmoji: editorEmoji
                })
            ]
        })
    });
};
var $c236a432f620563b$export$2e2bcd8739ae039 = $c236a432f620563b$export$7bfde52eceb3e2f6;

});
parcelRegister("jn7Qb", function(module, exports) {

$parcel$export(module.exports, "EmojiCommonProvider", () => $e65ab9e7f7a2e270$export$1120e666998e21b5);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $axar6 = parcelRequire("axar6");
const $e65ab9e7f7a2e270$export$1120e666998e21b5 = (props)=>{
    if (props.emojiProvider) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $axar6.EmojiContextProvider), {
        emojiContextValue: {
            emoji: {
                emojiProvider: props.emojiProvider
            }
        },
        children: props.children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: props.children
    });
};

});
parcelRegister("axar6", function(module, exports) {

$parcel$export(module.exports, "EmojiContextProvider", () => $8fa724f441f756f4$export$f4a09143833145ed);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hWKsk = parcelRequire("hWKsk");

var $5fQjB = parcelRequire("5fQjB");
const $8fa724f441f756f4$export$f4a09143833145ed = ({ children: children, emojiContextValue: emojiContextValue })=>{
    const memoizedEmojiContextValue = (0, $5uXOq.useMemo)(()=>emojiContextValue, [
        emojiContextValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // trigger emoji fetching
        async function fetchEmojiProvider() {
            try {
                await memoizedEmojiContextValue?.emoji.emojiProvider.fetchEmojiProvider();
            } catch (error) {
                (0, $5fQjB.default)('fetchEmojiProvider error catched from outside', error);
            }
        }
        if (memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand) {
            const isFetchingOnDemand = memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand();
            if (!isFetchingOnDemand) fetchEmojiProvider();
        } else fetchEmojiProvider();
    }, [
        memoizedEmojiContextValue
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hWKsk.EmojiContext).Provider, {
        value: memoizedEmojiContextValue,
        children: children
    });
};

});
parcelRegister("hWKsk", function(module, exports) {

$parcel$export(module.exports, "EmojiContext", () => $38cd28d688d1bf94$export$9fab6c37a453c65e);

var $5uXOq = parcelRequire("5uXOq");
const $38cd28d688d1bf94$export$9fab6c37a453c65e = (0, $5uXOq.createContext)(null);

});




parcelRegister("952rW", function(module, exports) {

$parcel$export(module.exports, "UfoErrorBoundary", () => $3873fecdeb7a570c$export$5ef1c2550074a375);

var $5uXOq = parcelRequire("5uXOq");
class $3873fecdeb7a570c$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch(error, errorInfo) {
        for (const exp of this.props.experiences){
            const { name: name, message: message } = error;
            const infoStack = errorInfo.componentStack && typeof errorInfo.componentStack !== 'undefined' ? errorInfo.componentStack : undefined;
            exp.failure({
                metadata: {
                    source: 'UfoErrorBoundary',
                    reason: 'error',
                    error: {
                        name: name,
                        message: message,
                        infoStack: infoStack
                    }
                }
            });
        }
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("44xT4", function(module, exports) {

$parcel$export(module.exports, "preloadEmojiPicker", () => $251bdded7596ca54$export$6b47bb4986b03271);
$parcel$export(module.exports, "default", () => $251bdded7596ca54$export$2e2bcd8739ae039);
/* EmojiPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $3TR0I = parcelRequire("3TR0I");

var $2AeLS = parcelRequire("2AeLS");

var $7Zi0i = parcelRequire("7Zi0i");

var $lLwwq = parcelRequire("lLwwq");

var $952rW = parcelRequire("952rW");

var $aGRkq = parcelRequire("aGRkq");

var $jn7Qb = parcelRequire("jn7Qb");
const $251bdded7596ca54$var$emojiPicker = null;

const $251bdded7596ca54$var$emojiPickerModuleLoader = ()=>(parcelRequire("cfS64"));
const $251bdded7596ca54$var$emojiPickerLoader = ()=>$251bdded7596ca54$var$emojiPickerModuleLoader().then((module)=>module.default);
const $251bdded7596ca54$export$6b47bb4986b03271 = ()=>{
    $251bdded7596ca54$var$emojiPickerLoader().then((component)=>{
        $251bdded7596ca54$export$bcf219a275f21b24.AsyncLoadedComponent = component;
    });
};
class $251bdded7596ca54$export$bcf219a275f21b24 extends (0, $7Zi0i.default) {
    static{
        this.defaultProps = {
            size: (0, $aGRkq.defaultEmojiPickerSize)
        };
    }
    constructor(props){
        super(props, {}), this.state = {
            asyncLoadedComponent: $251bdded7596ca54$export$bcf219a275f21b24.AsyncLoadedComponent
        };
        (0, $2AeLS.ufoExperiences)['emoji-picker-opened'].start();
    }
    asyncLoadComponent() {
        $251bdded7596ca54$var$emojiPickerLoader().then((component)=>{
            $251bdded7596ca54$export$bcf219a275f21b24.AsyncLoadedComponent = component;
            this.setAsyncState(component);
        });
    }
    renderLoading() {
        const item = new (0, $lLwwq.LoadingItem)();
        const handlePickerRef = (ref)=>{
            if (this.props.onPickerRef) this.props.onPickerRef(ref);
        };
        (0, $2AeLS.ufoExperiences)['emoji-picker-opened'].markFMP();
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: handlePickerRef,
            className: (0, $bwpsq.default)([
                "_19itcyqh _2rkosqtm _1e0c1txw _2lx21bp4 _1bah1yb4 _bfhk1bhr _16qs1gxp _4t3iixjv _1bsb1edt _1ul91edt _1tke5x59 _c71l1y6z"
            ]),
            children: item.renderItem()
        });
    }
    renderLoaded(loadedEmojiProvider, EmojiPickerComponent) {
        const { emojiProvider: emojiProvider, ...otherProps } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $952rW.UfoErrorBoundary), {
            experiences: [
                (0, $2AeLS.ufoExperiences)['emoji-picker-opened']
            ],
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jn7Qb.EmojiCommonProvider), {
                emojiProvider: loadedEmojiProvider,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(EmojiPickerComponent, {
                    ...otherProps
                })
            })
        });
    }
}
const $251bdded7596ca54$var$EmojiPicker = (0, $3TR0I.default)()($251bdded7596ca54$export$bcf219a275f21b24);
var $251bdded7596ca54$export$2e2bcd8739ae039 = $251bdded7596ca54$var$EmojiPicker;

});
parcelRegister("7Zi0i", function(module, exports) {

$parcel$export(module.exports, "default", () => $346c5a3e6ee4484e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");
class $346c5a3e6ee4484e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    constructor(props, state){
        super(props), this.isUnmounted = false, this.loaded = (state)=>!!state.asyncLoadedComponent && !!state.loadedEmojiProvider;
        this.state = state;
        // initializing here instead of componentDidMount to avoid needless
        // rerendering if emojiProvider resolves immediately.
        this.loadEmojiProvider(this.props.emojiProvider);
    }
    componentDidMount() {
        // check for the module has not yet been loaded
        // state.asyncLoadedComponent should be initialised
        // with static field to prevent unnecessary rerender
        if (!this.state.asyncLoadedComponent) this.asyncLoadComponent();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!(0, $fHpHg.fg)('platform_editor_react18_elements_emoji') || !(0, $fHpHg.fg)('platform_editor_react18_elements_emoji_jira_bb')) this.loadEmojiProvider(nextProps.emojiProvider);
    }
    componentDidUpdate(prevProps) {
        if ((0, $fHpHg.fg)('platform_editor_react18_elements_emoji') || (0, $fHpHg.fg)('platform_editor_react18_elements_emoji_jira_bb')) {
            if (this.props !== prevProps) this.loadEmojiProvider(this.props.emojiProvider);
        }
    }
    componentWillUnmount() {
        this.isUnmounted = true;
    }
    loadEmojiProvider(futureEmojiProvider) {
        futureEmojiProvider.then((loadedEmojiProvider)=>{
            if (!this.isUnmounted) this.setState({
                loadedEmojiProvider: loadedEmojiProvider
            });
        }).catch(()=>{
            if (!this.isUnmounted) this.setState({
                loadedEmojiProvider: undefined
            });
        });
    }
    setAsyncState(asyncLoadedComponent) {
        if (!this.isUnmounted) this.setState({
            asyncLoadedComponent: asyncLoadedComponent
        });
    }
    renderLoading() {
        return null;
    }
    render() {
        if (this.loaded(this.state)) {
            const { loadedEmojiProvider: loadedEmojiProvider, asyncLoadedComponent: asyncLoadedComponent } = this.state;
            return this.renderLoaded(loadedEmojiProvider, asyncLoadedComponent);
        }
        return this.renderLoading();
    }
}

});

parcelRegister("lLwwq", function(module, exports) {

$parcel$export(module.exports, "EmojisRowItem", () => $a72fc770af8503f6$export$99598b6ddae6b40f);
$parcel$export(module.exports, "LoadingItem", () => $a72fc770af8503f6$export$a16bfd7fb92e211d);
$parcel$export(module.exports, "CategoryHeadingItem", () => $a72fc770af8503f6$export$7fb68de373aba588);
$parcel$export(module.exports, "virtualItemRenderer", () => $a72fc770af8503f6$export$1786779f88a71e20);
/* EmojiPickerVirtualItems.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $clxo5 = parcelRequire("clxo5");

var $8eckl = parcelRequire("8eckl");

var $e4FfU = parcelRequire("e4FfU");

var $jpnfS = parcelRequire("jpnfS");
const $a72fc770af8503f6$var$emojiPickerSpinner = null;
class $a72fc770af8503f6$export$8faa7b3aa4960e00 {
    constructor(props, height){
        this.props = props;
        this.height = height;
    }
}
class $a72fc770af8503f6$export$99598b6ddae6b40f extends $a72fc770af8503f6$export$8faa7b3aa4960e00 {
    constructor(props){
        super(props, (0, $jpnfS.sizes).emojiRowHeight), this.renderItem = (context)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4FfU.default), {
                ...this.props,
                virtualItemContext: context
            });
    }
}
class $a72fc770af8503f6$export$a16bfd7fb92e211d extends $a72fc770af8503f6$export$8faa7b3aa4960e00 {
    constructor(){
        super({}, (0, $jpnfS.sizes).loadingRowHeight), this.renderItem = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_1e0c1txw _1bsb1osq _4t3i1w81 _1bah1h6o _4cvr1h6o _nphsidpf _t1edidpf _1t3b1wug"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {
                        size: "medium"
                    })
                })
            });
    }
}
class $a72fc770af8503f6$export$7fb68de373aba588 extends $a72fc770af8503f6$export$8faa7b3aa4960e00 {
    constructor(props){
        super(props, (0, $jpnfS.sizes).categoryHeadingHeight), this.renderItem = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8eckl.default), {
                ...this.props
            });
    }
}
const $a72fc770af8503f6$export$1786779f88a71e20 = (rows, context)=>{
    const { index: index, key: key } = context;
    const row = rows[index];
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        children: row && row.renderItem(context)
    }, key);
};

});
parcelRegister("8eckl", function(module, exports) {

$parcel$export(module.exports, "default", () => $588cfe424a0217eb$export$2e2bcd8739ae039);
/* EmojiPickerCategoryHeading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $70f7p = parcelRequire("70f7p");

var $hbAJx = parcelRequire("hbAJx");
const $588cfe424a0217eb$var$emojiCategoryTitle = null;
const $588cfe424a0217eb$export$354d69a9ad71a0a0 = 'render-emoji-picker-categorty-heading';
const $588cfe424a0217eb$var$EmojiPickerCategoryHeading = ({ id: id, title: title, className: className })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        id: id,
        "data-category-id": id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": $588cfe424a0217eb$export$354d69a9ad71a0a0,
        role: "rowheader",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_11c82smr _vchhusvi _syazj3m3 _ca0q12x7 _n3td12x7 _19bvu2gc _u5f3u2gc _1p1d1qyh _299mangw"
            ]),
            children: (0, $70f7p.isMessagesKey)(title) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $hbAJx.messages)[title]
            }) : title
        })
    });
var $588cfe424a0217eb$export$2e2bcd8739ae039 = $588cfe424a0217eb$var$EmojiPickerCategoryHeading;

});

parcelRegister("e4FfU", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc9292f86adfa8e6$export$2e2bcd8739ae039);
/* EmojiPickerEmojiRow.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $1vhUy = parcelRequire("1vhUy");

var $69pth = parcelRequire("69pth");

var $hbAJx = parcelRequire("hbAJx");
const $bc9292f86adfa8e6$var$emojiItem = null;
const $bc9292f86adfa8e6$var$emojiPickerRow = null;
const $bc9292f86adfa8e6$var$EmojiPickerEmojiRow = ({ emojis: emojis, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, title: title, showDelete: showDelete, onDelete: onDelete, virtualItemContext: virtualItemContext })=>{
    const { currentEmojisFocus: currentEmojisFocus, setEmojisFocus: setEmojisFocus } = (0, $69pth.useEmojiPickerListContext)();
    const rowIndex = virtualItemContext?.index || 0;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleFocus = (index)=>(emojiId, emoji, event)=>{
            setEmojisFocus({
                rowIndex: rowIndex,
                columnIndex: index
            });
            onFocus && onFocus(emojiId, emoji, event);
        };
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "presentation",
        className: (0, $bwpsq.default)([
            "_18u0u2gc"
        ]),
        children: emojis.map((emoji, index)=>{
            const { shortName: shortName, id: id } = emoji;
            const key = id ? `${id}-${title}` : `${shortName}-${title}`;
            const focus = currentEmojisFocus.rowIndex === rowIndex && currentEmojisFocus.columnIndex === index;
            return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                role: "gridcell",
                "aria-colindex": index + 1,
                className: (0, $bwpsq.default)([
                    "_1e0c1o8l _y3gn1h6o _1bsb1ylp _1wcg14y2 _1678tlke _7b50u2gc _1rf4u2gc _b4kiu2gc _bm9mu2gc _1lvc1tcg _1cf71tcg _8vlfze3t _1909ze3t _1tcfze3t _n7xcze3t _4ubfu2gc _18x3u2gc _fw9su2gc _29jju2gc _qpkw1tcg _elsp1tcg _vtzrze3t _w2q0ze3t _o5kcze3t _1mc3ze3t _115ch2mm _yrst1ssb _85ft1ssb _5mfndbra _1k8z1tcg _17dz1tcg _zdyf1ule _1mn81tcg _u5ah1tcg"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1vhUy.default), {
                    emoji: emoji,
                    selectOnHover: true,
                    onSelected: onSelected,
                    onMouseMove: onMouseMove,
                    onFocus: handleFocus(index),
                    showDelete: showDelete,
                    onDelete: onDelete,
                    placeholderSize: 24,
                    "data-focus-index": `${rowIndex}-${index}`,
                    tabIndex: focus ? 0 : -1,
                    "aria-roledescription": formatMessage((0, $hbAJx.messages).emojiButtonRoleDescription),
                    shouldBeInteractive: true
                })
            }, key);
        })
    });
};
var $bc9292f86adfa8e6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($bc9292f86adfa8e6$var$EmojiPickerEmojiRow);

});
parcelRegister("1vhUy", function(module, exports) {

$parcel$export(module.exports, "default", () => $53dec6472d9018c9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $70f7p = parcelRequire("70f7p");

var $eyWYN = parcelRequire("eyWYN");

var $5fQjB = parcelRequire("5fQjB");

var $1lHCF = parcelRequire("1lHCF");

var $gDljz = parcelRequire("gDljz");

var $7R3Zx = parcelRequire("7R3Zx");

var $952rW = parcelRequire("952rW");

var $2AeLS = parcelRequire("2AeLS");
var $fScLw = parcelRequire("fScLw");

var $aGRkq = parcelRequire("aGRkq");

var $2AeLS = parcelRequire("2AeLS");

var $PgC6h = parcelRequire("PgC6h");

var $eekPL = parcelRequire("eekPL");
const $53dec6472d9018c9$export$e81207f376d36133 = (props)=>{
    // Optimisation to only render CachingMediaEmoji if necessary
    // slight performance hit, which accumulates for a large number of emoji.
    const { emoji: emoji, placeholderSize: placeholderSize, ...restProps } = props;
    // start emoji rendered experience, it may have already started earlier in `ResourcedEmoji`.
    (0, $fScLw.useSampledUFOComponentExperience)((0, $2AeLS.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $aGRkq.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'CachingEmoji',
        emojiId: emoji.id
    });
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $2AeLS.hasUfoMarked)((0, $2AeLS.sampledUfoRenderedEmoji)(emoji), 'fmp')) (0, $2AeLS.sampledUfoRenderedEmoji)(emoji).markFMP();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const emojiNode = ()=>{
        if ((0, $70f7p.isMediaEmoji)(emoji)) return /*#__PURE__*/ (0, $2OMIu.jsx)($53dec6472d9018c9$export$aa961da7639f7a98, {
            emoji: emoji,
            placeholderSize: placeholderSize,
            ...restProps
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)($53dec6472d9018c9$var$StandardEmoji, {
            emoji: emoji,
            ...restProps
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $952rW.UfoErrorBoundary), {
        experiences: [
            (0, $2AeLS.ufoExperiences)['emoji-rendered'].getInstance(props.emoji.id || props.emoji.shortName)
        ],
        children: emojiNode()
    });
};
const $53dec6472d9018c9$var$StandardEmoji = (props)=>{
    const { emoji: emoji, ...restProps } = props;
    const [imageLoadError, setImageLoadError] = (0, $5uXOq.useState)(false);
    const handleLoadError = (_emojiId)=>{
        setImageLoadError(true);
    };
    if (imageLoadError) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7R3Zx.default), {
        emoji: emoji,
        ...restProps
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1lHCF.default), {
        emoji: emoji,
        onLoadError: handleLoadError,
        ...restProps
    });
};
const $53dec6472d9018c9$export$aa961da7639f7a98 = (props)=>{
    const { emoji: emoji, placeholderSize: placeholderSize, showTooltip: showTooltip, fitToHeight: fitToHeight, children: children, ...restProps } = props;
    const { shortName: shortName, representation: representation } = emoji;
    const [cachedEmoji, setCachedEmoji] = (0, $5uXOq.useState)();
    const [inValidImage, setInvalidImage] = (0, $5uXOq.useState)(false);
    const { emojiProvider: emojiProvider } = (0, $PgC6h.useEmoji)();
    const loadEmoji = (0, $5uXOq.useCallback)((emojiProvider)=>{
        (0, $5fQjB.default)('Loading image via media cache', emoji.shortName);
        (0, $2AeLS.sampledUfoRenderedEmoji)(emoji).mark((0, $eyWYN.UfoEmojiTimings).MEDIA_START);
        emojiProvider.getMediaEmojiDescriptionURLWithInlineToken(emoji).then((cachedEmoji)=>{
            setCachedEmoji(cachedEmoji);
            setInvalidImage(false);
            (0, $2AeLS.sampledUfoRenderedEmoji)(emoji).mark((0, $eyWYN.UfoEmojiTimings).MEDIA_END);
        }).catch((error)=>{
            setCachedEmoji(undefined);
            setInvalidImage(true);
            (0, $2AeLS.sampledUfoRenderedEmoji)(emoji).failure({
                metadata: {
                    error: (0, $eekPL.extractErrorInfo)(error),
                    reason: 'failed to load media emoji',
                    source: 'CachingMediaEmoji',
                    emojiId: emoji.id
                }
            });
        });
    }, [
        emoji
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (emojiProvider) loadEmoji(emojiProvider);
    }, [
        emojiProvider,
        loadEmoji
    ]);
    const handleLoadError = (_emojiId)=>{
        (0, $2AeLS.sampledUfoRenderedEmoji)(_emojiId).failure({
            metadata: {
                reason: 'load error',
                source: 'CachingMediaEmoji',
                emojiId: _emojiId.id
            }
        });
        setInvalidImage(true);
    };
    if (cachedEmoji && !inValidImage) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1lHCF.default), {
        ...restProps,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        emoji: cachedEmoji,
        onLoadError: handleLoadError
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gDljz.default), {
        size: fitToHeight || placeholderSize,
        shortName: shortName,
        showTooltip: showTooltip,
        representation: representation
    });
};
var $53dec6472d9018c9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($53dec6472d9018c9$export$e81207f376d36133);

});
parcelRegister("7R3Zx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3fda5e8d410619c$export$2e2bcd8739ae039);
/* EmojiFallback.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $1lHCF = parcelRequire("1lHCF");

const $c3fda5e8d410619c$var$emojiFallbackStyles = null;
const $c3fda5e8d410619c$export$e3a226c1c0d61870 = (props)=>{
    const { emoji: emoji, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const { fallback: fallback, shortName: shortName } = emoji;
    const classes = `${(0, $f7dab96e234b935f$export$b06c4aab1d012063)} ${selected ? (0, $f7dab96e234b935f$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $f7dab96e234b935f$export$860109dfd198259b) : ''} ${className ? className : ''}`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1lHCF.EmojiNodeWrapper), {
        type: "image",
        ...props,
        className: classes,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            className: (0, $bwpsq.default)([
                "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _4t3i1osq _1bah1h6o _4cvr1h6o"
            ]),
            children: fallback || shortName
        })
    }));
};
var $c3fda5e8d410619c$export$2e2bcd8739ae039 = $c3fda5e8d410619c$export$e3a226c1c0d61870;

});

parcelRegister("PgC6h", function(module, exports) {

$parcel$export(module.exports, "useEmoji", () => $5a15af6b255c0084$export$482903c4ce3f5633);

var $5uXOq = parcelRequire("5uXOq");

var $hWKsk = parcelRequire("hWKsk");
const $5a15af6b255c0084$var$supportsUploadFeature = (emojiProvider)=>{
    const emojiUploadProvider = emojiProvider;
    return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
};
const $5a15af6b255c0084$export$482903c4ce3f5633 = ()=>{
    const context = (0, $5uXOq.useContext)((0, $hWKsk.EmojiContext));
    // Hooks API
    const [isUploadSupported, setIsUploadSupported] = (0, $5uXOq.useState)(false);
    if (!context) throw new Error('useEmoji must be used within EmojiContext');
    const { emojiProvider: emojiProvider } = context.emoji;
    (0, $5uXOq.useEffect)(()=>{
        if ($5a15af6b255c0084$var$supportsUploadFeature(emojiProvider)) {
            const checkIfUploadIsSupported = async ()=>{
                try {
                    const supported = await emojiProvider.isUploadSupported();
                    setIsUploadSupported(supported);
                } catch (error) {
                    return false;
                }
            };
            checkIfUploadIsSupported();
        }
    }, [
        emojiProvider
    ]);
    return {
        emojiProvider: emojiProvider,
        isUploadSupported: isUploadSupported
    };
};

});

parcelRegister("eekPL", function(module, exports) {

$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $f9e92de151a00d76$export$53eef0dcd9611650);
$parcel$export(module.exports, "recordSucceededEmoji", () => $f9e92de151a00d76$export$3125c3f60f61a0a9);
$parcel$export(module.exports, "recordFailedEmoji", () => $f9e92de151a00d76$export$ccd0c8bcbda28b7a);
$parcel$export(module.exports, "openedPickerEvent", () => $f9e92de151a00d76$export$956acef77052d363);
$parcel$export(module.exports, "closedPickerEvent", () => $f9e92de151a00d76$export$151c59c3f6a1ff5f);
$parcel$export(module.exports, "pickerClickedEvent", () => $f9e92de151a00d76$export$d69b5cd43769bb6b);
$parcel$export(module.exports, "categoryClickedEvent", () => $f9e92de151a00d76$export$8e021f755a07e0d2);
$parcel$export(module.exports, "pickerSearchedEvent", () => $f9e92de151a00d76$export$d800a6d814034c48);
$parcel$export(module.exports, "toneSelectedEvent", () => $f9e92de151a00d76$export$e559e98af3da9d17);
$parcel$export(module.exports, "toneSelectorOpenedEvent", () => $f9e92de151a00d76$export$7274b855c80879c4);
$parcel$export(module.exports, "toneSelectorClosedEvent", () => $f9e92de151a00d76$export$301f0d0181307f7);
$parcel$export(module.exports, "uploadBeginButton", () => $f9e92de151a00d76$export$be48de448ed1f64f);
$parcel$export(module.exports, "uploadConfirmButton", () => $f9e92de151a00d76$export$b82a2393560e5893);
$parcel$export(module.exports, "uploadCancelButton", () => $f9e92de151a00d76$export$47ef032c3ec0a60a);
$parcel$export(module.exports, "uploadSucceededEvent", () => $f9e92de151a00d76$export$6aed2b90719a7d39);
$parcel$export(module.exports, "uploadFailedEvent", () => $f9e92de151a00d76$export$18cfbd0c8c6d2297);
$parcel$export(module.exports, "deleteBeginEvent", () => $f9e92de151a00d76$export$d74d89c79fff5a67);
$parcel$export(module.exports, "deleteConfirmEvent", () => $f9e92de151a00d76$export$87a8007f9e978b47);
$parcel$export(module.exports, "deleteCancelEvent", () => $f9e92de151a00d76$export$9877255e5a8f0cde);
$parcel$export(module.exports, "selectedFileEvent", () => $f9e92de151a00d76$export$fc14407a1d009938);
$parcel$export(module.exports, "recordSelectionSucceededSli", () => $f9e92de151a00d76$export$524400435f62e003);
$parcel$export(module.exports, "recordSelectionFailedSli", () => $f9e92de151a00d76$export$d1176b797f0912b8);
$parcel$export(module.exports, "extractErrorInfo", () => $f9e92de151a00d76$export$74aaf4784c2edb2c);

var $9Iej8 = parcelRequire("9Iej8");

var $eyWYN = parcelRequire("eyWYN");
const $f9e92de151a00d76$export$53eef0dcd9611650 = (0, $9Iej8.default)('fabric-elements');
const $f9e92de151a00d76$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes
        }
    });
const $f9e92de151a00d76$export$3125c3f60f61a0a9 = (emoji)=>(source)=>{
        return $f9e92de151a00d76$var$createEvent('operational', 'succeeded', 'recordEmojiSelection', undefined, {
            source: source,
            emojiId: emoji?.id,
            emojiType: emoji?.type,
            emojiCategory: emoji?.category
        });
    };
const $f9e92de151a00d76$export$4e713a2b020a4dca = (source)=>{
    return $f9e92de151a00d76$var$createEvent('operational', 'succeeded', 'recordEmojiSelection', undefined, {
        source: source
    });
};
const $f9e92de151a00d76$export$ccd0c8bcbda28b7a = (emoji)=>(source)=>{
        return $f9e92de151a00d76$var$createEvent('operational', 'failed', 'recordEmojiSelection', undefined, {
            source: source,
            emojiId: emoji?.id,
            emojiType: emoji?.type,
            emojiCategory: emoji?.category
        });
    };
const $f9e92de151a00d76$export$5bd025a43378005c = (source)=>{
    return $f9e92de151a00d76$var$createEvent('operational', 'failed', 'recordEmojiSelection', undefined, {
        source: source
    });
};
const $f9e92de151a00d76$var$emojiPickerEvent = (action, attributes = {}, actionSubjectId)=>$f9e92de151a00d76$var$createEvent('ui', action, 'emojiPicker', actionSubjectId, attributes);
const $f9e92de151a00d76$export$956acef77052d363 = ()=>$f9e92de151a00d76$var$emojiPickerEvent('opened');
const $f9e92de151a00d76$export$151c59c3f6a1ff5f = (attributes)=>$f9e92de151a00d76$var$emojiPickerEvent('closed', attributes);
const $f9e92de151a00d76$var$skinTones = [
    {
        id: '-1f3fb',
        skinToneModifier: 'light'
    },
    {
        id: '-1f3fc',
        skinToneModifier: 'mediumLight'
    },
    {
        id: '-1f3fd',
        skinToneModifier: 'medium'
    },
    {
        id: '-1f3fe',
        skinToneModifier: 'mediumDark'
    },
    {
        id: '-1f3ff',
        skinToneModifier: 'dark'
    }
];
const $f9e92de151a00d76$var$getSkinTone = (emojiId)=>{
    if (!emojiId) return {};
    for (const { id: id, skinToneModifier: skinToneModifier } of $f9e92de151a00d76$var$skinTones){
        if (emojiId.indexOf(id) !== -1) return {
            skinToneModifier: skinToneModifier,
            baseEmojiId: emojiId.replace(id, '')
        };
    }
    return {};
};
const $f9e92de151a00d76$export$d69b5cd43769bb6b = (attributes)=>$f9e92de151a00d76$var$emojiPickerEvent('clicked', {
        ...$f9e92de151a00d76$var$getSkinTone(attributes.emojiId),
        ...attributes
    }, 'emoji');
const $f9e92de151a00d76$export$8e021f755a07e0d2 = (attributes)=>$f9e92de151a00d76$var$emojiPickerEvent('clicked', attributes, 'category');
const $f9e92de151a00d76$export$d800a6d814034c48 = (attributes)=>$f9e92de151a00d76$var$emojiPickerEvent('searched', attributes, 'query');
const $f9e92de151a00d76$var$skintoneSelectorEvent = (action, attributes = {})=>$f9e92de151a00d76$var$createEvent('ui', action, 'emojiSkintoneSelector', undefined, attributes);
const $f9e92de151a00d76$export$e559e98af3da9d17 = (attributes)=>$f9e92de151a00d76$var$skintoneSelectorEvent('clicked', attributes);
const $f9e92de151a00d76$export$7274b855c80879c4 = (attributes)=>$f9e92de151a00d76$var$skintoneSelectorEvent('opened', attributes);
const $f9e92de151a00d76$export$301f0d0181307f7 = ()=>$f9e92de151a00d76$var$skintoneSelectorEvent('cancelled');
const $f9e92de151a00d76$var$emojiUploaderEvent = (action, actionSubjectId, attributes)=>$f9e92de151a00d76$var$createEvent('ui', action, 'emojiUploader', actionSubjectId, attributes);
const $f9e92de151a00d76$export$be48de448ed1f64f = ()=>$f9e92de151a00d76$var$emojiUploaderEvent('clicked', 'addButton');
const $f9e92de151a00d76$export$b82a2393560e5893 = (attributes)=>$f9e92de151a00d76$var$emojiUploaderEvent('clicked', 'confirmButton', attributes);
const $f9e92de151a00d76$export$47ef032c3ec0a60a = ()=>$f9e92de151a00d76$var$emojiUploaderEvent('clicked', 'cancelButton');
const $f9e92de151a00d76$export$6aed2b90719a7d39 = (attributes)=>$f9e92de151a00d76$var$createEvent('operational', 'finished', 'emojiUploader', undefined, attributes);
const $f9e92de151a00d76$export$18cfbd0c8c6d2297 = (attributes)=>$f9e92de151a00d76$var$createEvent('operational', 'failed', 'emojiUploader', undefined, attributes);
const $f9e92de151a00d76$export$d74d89c79fff5a67 = (attributes)=>$f9e92de151a00d76$var$createEvent('ui', 'clicked', 'emojiPicker', 'deleteEmojiTrigger', attributes);
const $f9e92de151a00d76$export$87a8007f9e978b47 = (attributes)=>$f9e92de151a00d76$var$createEvent('ui', 'clicked', 'emojiPicker', 'deleteEmojiConfirm', attributes);
const $f9e92de151a00d76$export$9877255e5a8f0cde = (attributes)=>$f9e92de151a00d76$var$createEvent('ui', 'clicked', 'emojiPicker', 'deleteEmojiCancel', attributes);
const $f9e92de151a00d76$export$fc14407a1d009938 = ()=>$f9e92de151a00d76$var$createEvent('ui', 'clicked', 'emojiUploader', 'selectFile');
const $f9e92de151a00d76$var$extractCommonAttributes = (query, emojiList)=>{
    return {
        queryLength: query ? query.length : 0,
        spaceInQuery: query ? query.indexOf(' ') !== -1 : false,
        emojiIds: emojiList ? emojiList.map((emoji)=>emoji.id).filter(Boolean).slice(0, 20) : []
    };
};
const $f9e92de151a00d76$export$89566522a5321393 = (duration, query, emojiList)=>$f9e92de151a00d76$var$createEvent('ui', 'cancelled', 'emojiTypeahead', undefined, {
        duration: duration,
        ...$f9e92de151a00d76$var$extractCommonAttributes(query, emojiList)
    });
const $f9e92de151a00d76$var$getPosition = (emojiList, selectedEmoji)=>{
    if (emojiList) {
        const index = emojiList.findIndex((emoji)=>emoji.id === selectedEmoji.id);
        return index === -1 ? undefined : index;
    }
    return;
};
const $f9e92de151a00d76$export$475603c082d8a174 = (pressed, duration, emoji, emojiList, query, exactMatch)=>$f9e92de151a00d76$var$createEvent('ui', pressed ? 'pressed' : 'clicked', 'emojiTypeahead', undefined, {
        duration: duration,
        position: $f9e92de151a00d76$var$getPosition(emojiList, emoji),
        ...$f9e92de151a00d76$var$extractCommonAttributes(query, emojiList),
        ...$f9e92de151a00d76$var$getSkinTone(emoji.id),
        emojiType: emoji.type,
        exactMatch: exactMatch || false
    });
const $f9e92de151a00d76$export$bbbb081930a4e19d = (duration, query, emojiList)=>$f9e92de151a00d76$var$createEvent('operational', 'rendered', 'emojiTypeahead', undefined, {
        duration: duration,
        ...$f9e92de151a00d76$var$extractCommonAttributes(query, emojiList)
    });
const $f9e92de151a00d76$export$524400435f62e003 = (emoji, options)=>()=>{
        if (options && options.createAnalyticsEvent) (0, $9Iej8.default)('editor')($f9e92de151a00d76$export$3125c3f60f61a0a9(emoji)((0, $eyWYN.SearchSourceTypes).TYPEAHEAD))(options.createAnalyticsEvent);
    };
const $f9e92de151a00d76$export$d1176b797f0912b8 = (emoji, options)=>(err)=>{
        if (options && options.createAnalyticsEvent) (0, $9Iej8.default)('editor')($f9e92de151a00d76$export$ccd0c8bcbda28b7a(emoji)((0, $eyWYN.SearchSourceTypes).TYPEAHEAD))(options.createAnalyticsEvent);
        return Promise.reject(err);
    };
const $f9e92de151a00d76$export$74aaf4784c2edb2c = (error)=>{
    if (error instanceof Error) return {
        name: error.name,
        message: error.message
    };
    return error;
};

});


parcelRegister("69pth", function(module, exports) {

$parcel$export(module.exports, "useEmojiPickerListContext", () => $273348eb71b8c0d9$export$1d569b16c0178739);

var $5uXOq = parcelRequire("5uXOq");

var $66bx8 = parcelRequire("66bx8");
const $273348eb71b8c0d9$export$1d569b16c0178739 = ()=>(0, $5uXOq.useContext)((0, $66bx8.EmojiPickerListContext));

});
parcelRegister("66bx8", function(module, exports) {

$parcel$export(module.exports, "EmojiPickerListContext", () => $1e0b13663a751ebb$export$968c8d71e683bcd1);
$parcel$export(module.exports, "EmojiPickerListContextProvider", () => $1e0b13663a751ebb$export$6f4d9357992f0254);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $1e0b13663a751ebb$export$968c8d71e683bcd1 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    currentEmojisFocus: {
        rowIndex: 0,
        columnIndex: 0
    },
    setEmojisFocus: ()=>{}
});
const $1e0b13663a751ebb$export$6f4d9357992f0254 = (props)=>{
    const [currentEmojisFocus, setEmojisFocus] = (0, $5uXOq.useState)(props.initialEmojisFocus);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($1e0b13663a751ebb$export$968c8d71e683bcd1.Provider, {
        value: {
            currentEmojisFocus: currentEmojisFocus,
            setEmojisFocus: setEmojisFocus
        },
        children: props.children
    });
};

});



parcelRegister("jpnfS", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $7b451b5b6479edfa$export$c647cb0ee6e282fe);

var $aGRkq = parcelRequire("aGRkq");
const $7b451b5b6479edfa$export$c647cb0ee6e282fe = {
    listHeight: (0, $aGRkq.emojiPickerListHeight),
    listWidth: (0, $aGRkq.emojiPickerWidth),
    searchHeight: 52,
    categoryHeadingHeight: 30,
    emojiRowHeight: 40,
    addEmojiHeight: 32,
    loadingRowHeight: 150,
    uploadActionHeight: 40,
    emojiPerRow: 8
};

});


parcelRegister("cfS64", function(module, exports) {

let $8ec0d9414442127a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8ec0d9414442127a$var$load("h2MrD"),
    $8ec0d9414442127a$var$load("bYT2S"),
    $8ec0d9414442127a$var$load("dFimN")
]).then(()=>parcelRequire('24Pgg'));

});


parcelRegister("7lVNo", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a6c4b5a0d46eda4$export$2e2bcd8739ae039);
/* EmojiTypeAheadItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $jn7Qb = parcelRequire("jn7Qb");

var $dLQFy = parcelRequire("dLQFy");

var $70f7p = parcelRequire("70f7p");

var $in0Te = parcelRequire("in0Te");

const $5a6c4b5a0d46eda4$var$typeAheadWidth = 350;
const $5a6c4b5a0d46eda4$var$typeAheadItem = null;
const $5a6c4b5a0d46eda4$var$selectedStyles = null;
const $5a6c4b5a0d46eda4$var$typeAheadItemRow = null;
function $5a6c4b5a0d46eda4$export$616ca81e9448d046(props) {
    const { emoji: emoji, onSelection: onSelection, onMouseMove: onMouseMove, selected: selected, emojiProvider: emojiProvider, forwardedRef: forwardedRef } = props;
    const onEmojiSelected = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        if ((0, $dLQFy.leftClick)(event) && onSelection) {
            event.preventDefault();
            onSelection((0, $70f7p.toEmojiId)(emoji), emoji, event);
        }
    }, [
        emoji,
        onSelection
    ]);
    const onEmojiMenuItemMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        if (onMouseMove) onMouseMove((0, $70f7p.toEmojiId)(emoji), emoji, event);
    }, [
        emoji,
        onMouseMove
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jn7Qb.EmojiCommonProvider), {
        emojiProvider: emojiProvider,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $bwpsq.default)([
                "_1reo15vq _18m915vq _80omtlke _1e0c1ule _2mzuglyw _1bsb1edt",
                selected && "_bfhk1yrq",
                `ak-emoji-typeahead-item ${selected ? (0, $1ca11c713a63481f$export$214089244105a739) : ''}`
            ]),
            onMouseDown: onEmojiSelected,
            onMouseMove: onEmojiMenuItemMouseMove,
            "data-emoji-id": emoji.shortName,
            ref: forwardedRef,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_1e0c1txw _2lx2vrvc _1n261g80 _s7n4nkob"
                ]),
                children: emoji && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $in0Te.EmojiPreviewComponent), {
                    emoji: emoji
                })
            })
        })
    });
}
const $5a6c4b5a0d46eda4$var$EmojiTypeAheadItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5a6c4b5a0d46eda4$export$616ca81e9448d046, {
        ...props,
        forwardedRef: ref
    }));
var $5a6c4b5a0d46eda4$export$2e2bcd8739ae039 = $5a6c4b5a0d46eda4$var$EmojiTypeAheadItem;

});
parcelRegister("in0Te", function(module, exports) {

$parcel$export(module.exports, "EmojiPreviewComponent", () => $e4eb3ca0ad6c0428$export$222c91bd2db2d158);
/* EmojiPreviewComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1vhUy = parcelRequire("1vhUy");
const $e4eb3ca0ad6c0428$var$emojiName = null;
const $e4eb3ca0ad6c0428$var$emojiShortName = null;
const $e4eb3ca0ad6c0428$var$preview = null;
const $e4eb3ca0ad6c0428$var$previewImg = null;
const $e4eb3ca0ad6c0428$var$previewText = null;
const $e4eb3ca0ad6c0428$export$222c91bd2db2d158 = ({ emoji: emoji })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            "_ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1e0c1txw _2lx2vrvc _1n261q9c _4t3izwfg _4cvr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_1e0c1o8l _1bsbzwfg _12s6idpf _1e4didpf _1dvqidpf _vwlxidpf _1gdiidpf _1f45idpf _pdfdidpf _mwo3idpf _5ilezwfg _boltzwfg _1pc7zwfg _u5wqzwfg _w7981kw7 _1vqe1kw7 _1l4xidpf _1l79idpf _118didpf _1pa4idpf _1pglh2mm _1vjf1ssb _1h6o1ssb _8fp6dbra _1os4zwfg _1e7azwfg _7mh21ule"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1vhUy.default), {
                    emoji: emoji
                }, emoji.id || emoji.shortName)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $bwpsq.default)([
                    "_1e0c1txw _2lx21bp4 _1wpz1h6o _19pk1i6y _18u019bv _p12f3sup _1bsb3sup _16jlkb7n _1o9zkb7n"
                ]),
                children: [
                    emoji.name && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_1reo15vq _18m915vq _1e0c1ule _syazj3m3 _1bto1l2s _o5721q9c _299mangw"
                        ]),
                        children: emoji.name
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_11c8dcr7 _1reo15vq _18m915vq _1e0c1ule _syaz1thw _vwz4kb7n _otyr1i6y _n3tdv77o _1bto1l2s _o5721q9c _10hw2smr _pnmbj3m3"
                        ]),
                        children: emoji.shortName
                    })
                ]
            })
        ]
    });
};

});

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $1ca11c713a63481f$export$dca0df2a2f0ab6cf = 'emoji-typeahead-element';
const $1ca11c713a63481f$export$9b2d029b494a863e = 'emoji-typeahead-list-container';
const $1ca11c713a63481f$export$214089244105a739 = 'emoji-typeahead-selected';



parcelRegister("a8fLF", function(module, exports) {

$parcel$export(module.exports, "default", () => $82e371cc00e3cdc3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $82e371cc00e3cdc3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emojiButtonCaption: {
        "id": "polaris-lib-emoji-picker.emoji-button-caption",
        "defaultMessage": "Pick an emoji"
    },
    removeEmoji: {
        "id": "polaris-lib-emoji-picker.remove-emoji",
        "defaultMessage": "Remove emoji"
    },
    editEmoji: {
        "id": "polaris-lib-emoji-picker.edit-emoji",
        "defaultMessage": "Edit emoji"
    },
    readOnlyField: {
        "id": "polaris-lib-emoji-picker.read-only-field",
        "defaultMessage": "This is a default field and it cannot be edited or deleted"
    }
});

});


parcelRegister("jdnWL", function(module, exports) {

$parcel$export(module.exports, "ErrorContainer", () => $8c8571e764ada196$export$97bdf39f6b82bb0);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $8c8571e764ada196$export$97bdf39f6b82bb0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkosqtm _1e0c1ule _vchhusvi _19pk14y2 _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc _bfhks4qr _syaz15cr _16qs1cd0 _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lqcJn", function(module, exports) {

$parcel$export(module.exports, "ProjectSelect", () => $9d8a1d73860524aa$export$a1f52e0b0bd99ab8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gERmC = parcelRequire("gERmC");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");

var $3Alw1 = parcelRequire("3Alw1");
var $b1kcy = parcelRequire("b1kcy");
var $lau8t = parcelRequire("lau8t");parcelRequire("fdJB9");
var $2OKnX = parcelRequire("2OKnX");

var $koVbs = parcelRequire("koVbs");

var $ajUqT = parcelRequire("ajUqT");

var $qaqt2 = parcelRequire("qaqt2");
const $9d8a1d73860524aa$export$a1f52e0b0bd99ab8 = ({ components: customComponents, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { options: options, ...selectProps } = (0, $2OKnX.default)({
        loadOptions: (inputValue)=>(0, $qaqt2.loadProjectsOptions)({
                query: inputValue
            }),
        cacheOptions: true,
        defaultOptions: true
    });
    const finalOptions = (0, $5uXOq.useMemo)(()=>{
        const allOptions = [];
        const currentValue = Array.isArray(props.value) ? props.value : [];
        if (currentValue.length > 0) allOptions.push({
            options: currentValue
        });
        if (Array.isArray(options) && options.length > 0) allOptions.push({
            options: (0, (/*@__PURE__*/$parcel$interopDefault($gERmC)))(options, currentValue, 'value')
        });
        return allOptions;
    }, [
        props.value,
        options
    ]);
    return /*#__PURE__*/ $5uXOq.createElement((0, $lau8t.default), {
        ...selectProps,
        options: finalOptions,
        placeholder: formatMessage((0, $ajUqT.default).selectFieldPlaceholder),
        components: {
            Option: ({ children: children, ...rest })=>/*#__PURE__*/ $5uXOq.createElement((0, $3Alw1.CheckboxOption), rest, /*#__PURE__*/ $5uXOq.createElement((0, $0yZbT.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ $5uXOq.createElement((0, $2Eqc8.default), {
                    space: "space.100",
                    alignBlock: "center"
                }, /*#__PURE__*/ $5uXOq.createElement("img", {
                    alt: rest.data.label,
                    src: rest.data.imageUrl,
                    className: (0, $bwpsq.default)([
                        "_2rkogqwt _1bsbpxbi _4t3ipxbi"
                    ])
                }), children))),
            MultiValueLabel: ({ children: children, ...rest })=>/*#__PURE__*/ $5uXOq.createElement((0, $b1kcy.components).MultiValueLabel, rest, /*#__PURE__*/ $5uXOq.createElement((0, $2Eqc8.default), {
                    space: "space.050",
                    alignBlock: "center"
                }, /*#__PURE__*/ $5uXOq.createElement("img", {
                    alt: rest.data.label,
                    src: rest.data.imageUrl,
                    className: (0, $bwpsq.default)([
                        "_2rkogqwt _1bsbpxbi _4t3ipxbi"
                    ])
                }), children)),
            ...customComponents
        },
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        styles: $9d8a1d73860524aa$var$stylesConfig,
        ...props
    });
};
const $9d8a1d73860524aa$var$projectAvatarStyles = null;
const $9d8a1d73860524aa$var$stylesConfig = {
    menuList: (styles)=>({
            ...styles,
            padding: 0
        }),
    group: (styles)=>({
            ...styles,
            padding: `${"var(--ds-space-075, 6px)"} 0 ${"var(--ds-space-075, 6px)"} 0`,
            ':not(:first-of-type)': {
                borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`
            }
        })
};

});
parcelRegister("gERmC", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $ekcP3 = parcelRequire("ekcP3");

var $bxDef = parcelRequire("bxDef");

var $g7i7g = parcelRequire("g7i7g");

var $f3SOL = parcelRequire("f3SOL");

var $hYfgW = parcelRequire("hYfgW");
/**
 * This method is like `_.difference` except that it accepts `iteratee` which
 * is invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */ var $c209c6b79c5021c7$var$differenceBy = $g7i7g(function(array, values) {
    var iteratee = $hYfgW(values);
    if ($f3SOL(iteratee)) iteratee = undefined;
    return $f3SOL(array) ? $55pzo(array, $ekcP3(values, 1, $f3SOL, true), $bxDef(iteratee, 2)) : [];
});
module.exports = $c209c6b79c5021c7$var$differenceBy;

});

parcelRegister("3Alw1", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $d0ede4c272661616$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $d0ede4c272661616$export$82ab7168879267a7);
/* input-options.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3WlF6 = parcelRequire("3WlF6");

var $aOu3z = parcelRequire("aOu3z");

var $2SY35 = parcelRequire("2SY35");

var $fHpHg = parcelRequire("fHpHg");
const $d0ede4c272661616$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk18uv _16qs1kw7 _syaz1kw7 _1di61dty",
    focused: "_bfhk166n _16qsn8hf _112ej1ic",
    disabled: "_syaz15gi"
};
// the primary color represents the outer or background element
const $d0ede4c272661616$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #091E4208)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #09326C)";
    else if (isActive) return "var(--ds-background-selected-pressed, #85B8FF)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #0055CC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #0C66E4)";
    return "var(--ds-background-neutral, #091E420F)";
};
// the secondary color represents the radio dot or checkmark
const $d0ede4c272661616$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #091E424F)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $d0ede4c272661616$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1elr _1gqp1elr"
};
const $d0ede4c272661616$var$baseIconStyles = null;
const $d0ede4c272661616$var$baseOptionStyles = null;
// eslint-disable-next-line @repo/internal/react/no-class-components
const $d0ede4c272661616$var$ControlOption = (props)=>{
    const [isActive, setIsActive] = (0, $5uXOq.useState)(false);
    const onMouseDown = (0, $5uXOq.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $5uXOq.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $5uXOq.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $d0ede4c272661616$var$optionStyles.default,
            isFocused && $d0ede4c272661616$var$optionStyles.focused,
            isDisabled && $d0ede4c272661616$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $d0ede4c272661616$var$iconStyles.inherit : $d0ede4c272661616$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                    label: "",
                    primaryColor: $d0ede4c272661616$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $d0ede4c272661616$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
const $d0ede4c272661616$var$NewCheckboxIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2SY35.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
const $d0ede4c272661616$var$NewRadioIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2SY35.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
const $d0ede4c272661616$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($d0ede4c272661616$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix, @atlaskit/platform/no-preconditioning
        (0, $fHpHg.fg)('platform-visual-refresh-icons') && (0, $fHpHg.fg)('platform-icon-control-migration') ? $d0ede4c272661616$var$NewCheckboxIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($3WlF6))),
        ...props
    });
const $d0ede4c272661616$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons, @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)($d0ede4c272661616$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix, @atlaskit/platform/no-preconditioning
        (0, $fHpHg.fg)('platform-visual-refresh-icons') && (0, $fHpHg.fg)('platform-icon-control-migration') ? $d0ede4c272661616$var$NewRadioIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($aOu3z))),
        ...props
    });

});
parcelRegister("3WlF6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2de7977aa9cb00bc$var$_react = $2de7977aa9cb00bc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $2de7977aa9cb00bc$var$_checkboxChecked = $2de7977aa9cb00bc$var$_interopRequireDefault((parcelRequire("cZpzV")));
function $2de7977aa9cb00bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2de7977aa9cb00bc$var$CheckboxIcon = (props)=>/*#__PURE__*/ $2de7977aa9cb00bc$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $2de7977aa9cb00bc$var$_checkboxChecked.default
    }));
$2de7977aa9cb00bc$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $2de7977aa9cb00bc$var$_default = module.exports.default = $2de7977aa9cb00bc$var$CheckboxIcon;

});
parcelRegister("cZpzV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3359cfcb124b9edec9402a579fa9711>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $974f05e630cecc25$var$_react = $974f05e630cecc25$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $974f05e630cecc25$var$_baseNew = $974f05e630cecc25$var$_interopRequireDefault((parcelRequire("enEmH")));
function $974f05e630cecc25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $974f05e630cecc25$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $974f05e630cecc25$var$_react.default.createElement($974f05e630cecc25$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$974f05e630cecc25$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $974f05e630cecc25$var$_default = module.exports.default = $974f05e630cecc25$var$CheckboxCheckedIcon;

});


parcelRegister("aOu3z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7df5e37c6b7a20c4$var$_react = $7df5e37c6b7a20c4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $7df5e37c6b7a20c4$var$_radioChecked = $7df5e37c6b7a20c4$var$_interopRequireDefault((parcelRequire("6Ozz1")));
function $7df5e37c6b7a20c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7df5e37c6b7a20c4$var$RadioIcon = (props)=>/*#__PURE__*/ $7df5e37c6b7a20c4$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $7df5e37c6b7a20c4$var$_radioChecked.default
    }));
$7df5e37c6b7a20c4$var$RadioIcon.displayName = 'RadioIcon';
var $7df5e37c6b7a20c4$var$_default = module.exports.default = $7df5e37c6b7a20c4$var$RadioIcon;

});
parcelRegister("6Ozz1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f37934c6709a990262261073c8d0052>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f62ffd3e1262340$var$_react = $4f62ffd3e1262340$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4f62ffd3e1262340$var$_baseNew = $4f62ffd3e1262340$var$_interopRequireDefault((parcelRequire("enEmH")));
function $4f62ffd3e1262340$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RadioChecked".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for the selected state of radio controls.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4f62ffd3e1262340$var$RadioCheckedIcon = (props)=>/*#__PURE__*/ $4f62ffd3e1262340$var$_react.default.createElement($4f62ffd3e1262340$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
    }, props));
$4f62ffd3e1262340$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
var $4f62ffd3e1262340$var$_default = module.exports.default = $4f62ffd3e1262340$var$RadioCheckedIcon;

});



parcelRegister("ajUqT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae79cf2602af184a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ae79cf2602af184a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    selectFieldPlaceholder: {
        "id": "polaris-component-project-select.select-field-placeholder",
        "defaultMessage": "Select projects"
    }
});

});

parcelRegister("qaqt2", function(module, exports) {

$parcel$export(module.exports, "loadProjectsOptions", () => $6197d5df9b80c496$export$93f98588ddc2c5);

var $jcw0u = parcelRequire("jcw0u");

var $1As78 = parcelRequire("1As78");

var $933Zv = parcelRequire("933Zv");
const $6197d5df9b80c496$export$93f98588ddc2c5 = async (options)=>(0, $933Zv.getJpdProjects)(options).then((projects)=>projects.map((project)=>({
                id: project.id,
                label: project.name,
                imageUrl: project.avatarUrls['16x16'],
                value: project.key,
                issueTypes: project.issueTypes
            }))).catch((error)=>{
        (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.error.availableProjectsLoadingFailed', error));
        throw error;
    });

});
parcelRegister("933Zv", function(module, exports) {

$parcel$export(module.exports, "getJpdProjects", () => $f49b4671dac01334$export$e47ac985e655d4a9);

var $2vSU6 = parcelRequire("2vSU6");

var $7f4tk = parcelRequire("7f4tk");
const $f49b4671dac01334$export$e47ac985e655d4a9 = async ({ query: query = '', projectIds: projectIds = [] })=>{
    const queryParams = new URLSearchParams({
        typeKey: (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT),
        query: query,
        expand: 'issueTypes'
    });
    projectIds.forEach((id)=>queryParams.append('id', id));
    const { values: values } = await (0, $7f4tk.default)(`/rest/api/3/project/search?${queryParams.toString()}`);
    return values;
};

});



parcelRegister("9iiI8", function(module, exports) {

$parcel$export(module.exports, "getIdeasCountForCollection", () => $42668e2cd1ae7607$export$d355ccab36abee74);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $1As78 = parcelRequire("1As78");
const $42668e2cd1ae7607$export$d355ccab36abee74 = async (jql)=>(0, $eusud.performPostRequest)('/rest/polaris/issues/searchCountForJql', {
        body: JSON.stringify({
            jql: jql,
            archived: 'ACTIVE_ONLY'
        })
    }).then((response)=>response.count).catch((error)=>{
        (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.error.getIdeasCountForCollectionFailed', error));
        throw error;
    });

});

parcelRegister("4329T", function(module, exports) {

$parcel$export(module.exports, "getFieldsKeysWithJql", () => $5b7132b623d593fa$export$9809803a4a02519c);

var $dPSWJ = parcelRequire("dPSWJ");

var $4Xk2W = parcelRequire("4Xk2W");

var $eusud = parcelRequire("eusud");
const $5b7132b623d593fa$var$JQL_FIELDS_URL = '/rest/polaris/fields/associations/jql';
const $5b7132b623d593fa$export$9809803a4a02519c = (jql)=>(0, $eusud.performPostRequest)($5b7132b623d593fa$var$JQL_FIELDS_URL, {
        body: JSON.stringify({
            jql: jql,
            globalOnly: true
        })
    }).then((res)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))((0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(res.fields, (field)=>field.name.toLowerCase()), (field)=>field.key));

});
parcelRegister("4Xk2W", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $39bc38f0156cacc0$var$keyBy = $4CZTG(function(result, value, key) {
    $1m3dq(result, key, value);
});
module.exports = $39bc38f0156cacc0$var$keyBy;

});


parcelRegister("gE10J", function(module, exports) {

$parcel$export(module.exports, "FormFieldKeys", () => $7969c7aeb7af51e3$export$77563030951a87d8);
$parcel$export(module.exports, "IDEAS_COUNT_LIMIT", () => $7969c7aeb7af51e3$export$651fede5bf66f749);
$parcel$export(module.exports, "IDEAS_COUNT_LIMIT_OLD", () => $7969c7aeb7af51e3$export$8a6d767d1e657b50);
const $7969c7aeb7af51e3$export$77563030951a87d8 = {
    COLLECTION_NAME: 'collectionName',
    PROJECTS: 'projects',
    FILTERS: 'filters'
};
const $7969c7aeb7af51e3$export$651fede5bf66f749 = 2000;
const $7969c7aeb7af51e3$export$8a6d767d1e657b50 = 5000;

});

parcelRegister("17h70", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $c23f03eba55d136e$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $bMFGq = parcelRequire("bMFGq");

var $iu66X = parcelRequire("iu66X");

var $85eFT = parcelRequire("85eFT");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $gVM6m = parcelRequire("gVM6m");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $gE10J = parcelRequire("gE10J");

var $5eNy4 = parcelRequire("5eNy4");
const $c23f03eba55d136e$export$a06f1c675e846f6f = ({ submitting: submitting, ideasCount: ideasCount, isIdeasCountLoading: isIdeasCountLoading })=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $koVbs.default)();
    const [isLimitWarningPopupOpen, setIsLimitWarningPopupOpen] = (0, $5uXOq.useState)(false);
    const limitWarningMessage = formatMessage((0, $5eNy4.default).ideasCountLimitMessage, {
        ideasCountLimit: formatNumber((0, $gE10J.IDEAS_COUNT_LIMIT))
    });
    const openWarningPopup = (e)=>{
        e.stopPropagation();
        setIsLimitWarningPopupOpen(true);
    };
    if ((0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering')) {
        const exceedsIdeasLimit = !isIdeasCountLoading && !!ideasCount && ideasCount > (0, $gE10J.IDEAS_COUNT_LIMIT);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
            xcss: $c23f03eba55d136e$var$footerStyles,
            alignInline: "end",
            space: "space.300",
            alignBlock: "start"
        }, ideasCount !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
            alignBlock: "start",
            space: "space.050",
            xcss: $c23f03eba55d136e$var$ideasCountWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: $c23f03eba55d136e$var$issuesCountStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
            color: "color.text.subtle"
        }, ideasCount !== undefined && formatMessage((0, $5eNy4.default).ideasCount)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
            color: "color.text.subtle",
            weight: "bold"
        }, ' ', isIdeasCountLoading ? '' : formatNumber(ideasCount))), exceedsIdeasLimit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
            isOpen: isLimitWarningPopupOpen,
            onClose: ()=>setIsLimitWarningPopupOpen(false),
            placement: "bottom",
            messageId: "polaris-component-collection-create.ui.form.footer.popup",
            messageType: "transactional",
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                    xcss: $c23f03eba55d136e$var$limitWarningPopupStyles
                }, limitWarningMessage),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gVM6m.default), {
                    ...triggerProps,
                    onClick: openWarningPopup,
                    xcss: $c23f03eba55d136e$var$ideasCountWarningIconButtonStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($85eFT))), {
                    spacing: "spacious",
                    label: limitWarningMessage,
                    color: "var(--ds-icon-warning, #E56910)"
                }))
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMFGq.default), {
            testId: "polaris-component-collection-create.ui.form.footer.button",
            type: exceedsIdeasLimit ? 'button' : 'submit',
            appearance: "primary",
            isLoading: submitting,
            onClick: exceedsIdeasLimit ? openWarningPopup : undefined
        }, formatMessage((0, $5eNy4.default).createButtonLabel)));
    }
    const exceedsIdeasLimit = !!ideasCount && ideasCount > (0, $gE10J.IDEAS_COUNT_LIMIT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iu66X.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMFGq.default), {
        testId: "polaris-component-collection-create.ui.form.footer.button",
        type: "submit",
        appearance: "primary",
        isLoading: submitting,
        isDisabled: exceedsIdeasLimit
    }, formatMessage((0, $5eNy4.default).createButtonLabel)));
};
const $c23f03eba55d136e$var$footerStyles = (0, $2s57o.xcss)({
    marginBlock: 'space.200'
});
const $c23f03eba55d136e$var$ideasCountWrapperStyles = (0, $2s57o.xcss)({
    flex: 1
});
const $c23f03eba55d136e$var$ideasCountWarningIconButtonStyles = (0, $2s57o.xcss)({
    background: 'transparent',
    flexShrink: 0,
    marginTop: 'space.050'
});
const $c23f03eba55d136e$var$issuesCountStyles = (0, $2s57o.xcss)({
    marginTop: 'space.075'
});
const $c23f03eba55d136e$var$limitWarningPopupStyles = (0, $2s57o.xcss)({
    padding: 'space.200',
    maxWidth: '410px'
});

});
parcelRegister("5eNy4", function(module, exports) {

$parcel$export(module.exports, "default", () => $80a485c0ecae9ade$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $80a485c0ecae9ade$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createButtonLabel: {
        "id": "polaris-component-collection-create.form.create-button-label",
        "defaultMessage": "Create roadmap"
    },
    ideasCount: {
        "id": "polaris-component-collection-create.form.ideas-count",
        "defaultMessage": "Ideas in roadmap:"
    },
    ideasCountLimitMessage: {
        "id": "polaris-component-collection-create.form.footer.ideas-count-limit-message",
        "defaultMessage": "The roadmap views have a limit of {ideasCountLimit} ideas. To display the views correctly, filter ideas out."
    }
});

});


parcelRegister("v0rRn", function(module, exports) {

$parcel$export(module.exports, "default", () => $29f3cce106e8c8c5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $29f3cce106e8c8c5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "polaris-component-collection-create.form.heading",
        "defaultMessage": "Create new roadmap"
    },
    description: {
        "id": "polaris-component-collection-create.form.description",
        "defaultMessage": "Curate your discovery projects ideas in a roadmap."
    },
    roadmapNameFieldLabel: {
        "id": "polaris-component-collection-create.form.roadmap-name-field-label",
        "defaultMessage": "Name your roadmap"
    },
    roadmapNameFieldPlaceholder: {
        "id": "polaris-component-collection-create.form.roadmap-name-field-placeholder",
        "defaultMessage": "Roadmap name"
    },
    projectsSelectFieldLabel: {
        "id": "polaris-component-collection-create.form.projects-select-field-label",
        "defaultMessage": "Select the discovery projects you want to pull ideas from"
    },
    filtersLabel: {
        "id": "polaris-component-collection-create.form.filters-label",
        "defaultMessage": "Filter your roadmap ideas"
    },
    filtersDescription: {
        "id": "polaris-component-collection-create.form.filters-description",
        "defaultMessage": "Use global fields to display only certain ideas in your roadmap."
    },
    limitExceededError: {
        "id": "polaris-component-collection-create.form.limit-exceeded-error",
        "defaultMessage": "You have <b>{ideasCount, plural, one {# idea} other {# ideas}}</b> in your roadmap."
    },
    limitExceededErrorAction: {
        "id": "polaris-component-collection-create.form.limit-exceeded-error-action",
        "defaultMessage": "Apply filters to have {maxIdeas, plural, one {# idea} other {# ideas}} maximum."
    },
    errorTitle: {
        "id": "polaris-component-collection-create.form.error-title",
        "defaultMessage": "We couldn\u2019t create the roadmap"
    },
    errorDescription: {
        "id": "polaris-component-collection-create.form.error-description",
        "defaultMessage": "Please try again or refresh the page."
    },
    listViewName: {
        "id": "polaris-component-collection-create.form.list-view-name",
        "defaultMessage": "List view"
    },
    timelineViewName: {
        "id": "polaris-component-collection-create.form.timeline-view-name",
        "defaultMessage": "Timeline view"
    },
    boardViewName: {
        "id": "polaris-component-collection-create.form.board-view-name",
        "defaultMessage": "Board view"
    },
    matrixViewName: {
        "id": "polaris-component-collection-create.form.matrix-view-name",
        "defaultMessage": "Matrix view"
    },
    emptyNameError: {
        "id": "polaris-component-collection-create.form.empty-name-error",
        "defaultMessage": "Provide a name for your roadmap."
    },
    emptyProjectsError: {
        "id": "polaris-component-collection-create.form.empty-projects-error",
        "defaultMessage": "Select at least one project."
    },
    nameTooLongError: {
        "id": "polaris-component-collection-create.form.name-too-long-error",
        "defaultMessage": "Roadmap name is too long."
    }
});

});

parcelRegister("9xjQI", function(module, exports) {

$parcel$export(module.exports, "ProjectSelect", () => $25c99bb80dd0985e$export$a1f52e0b0bd99ab8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");

var $ia3X2 = parcelRequire("ia3X2");
var $3Alw1 = parcelRequire("3Alw1");
var $b1kcy = parcelRequire("b1kcy");

var $koVbs = parcelRequire("koVbs");

var $9Xe2s = parcelRequire("9Xe2s");

var $ahip4 = parcelRequire("ahip4");
const $25c99bb80dd0985e$export$a1f52e0b0bd99ab8 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { onChange: onChange, value: value, id: id, isRequired: isRequired, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ia3X2.default), {
        ...restProps,
        cacheOptions: true,
        defaultOptions: true,
        loadOptions: (0, $ahip4.loadProjectsOptions),
        placeholder: formatMessage((0, $9Xe2s.default).projectsSelectFieldPlaceholder),
        onChange: (values)=>{
            onChange(values.map((v)=>v.value));
        },
        components: {
            Option: ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Alw1.CheckboxOption), rest, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
                    space: "space.100",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
                    alt: rest.data.label,
                    src: rest.data.imageUrl,
                    className: (0, $bwpsq.default)([
                        "_2rkogqwt _1bsbpxbi _4t3ipxbi"
                    ])
                }), children))),
            MultiValueLabel: ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b1kcy.components).MultiValueLabel, rest, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
                    space: "space.050",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
                    alt: rest.data.label,
                    src: rest.data.imageUrl,
                    className: (0, $bwpsq.default)([
                        "_2rkogqwt _1bsbpxbi _4t3ipxbi"
                    ])
                }), children))
        },
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true
    });
};
const $25c99bb80dd0985e$var$projectAvatarStyles = null;

});
parcelRegister("9Xe2s", function(module, exports) {

$parcel$export(module.exports, "default", () => $024dda0f50435df8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $024dda0f50435df8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectsSelectFieldPlaceholder: {
        "id": "polaris-component-collection-create.form.project-select.projects-select-field-placeholder",
        "defaultMessage": "Select projects"
    }
});

});

parcelRegister("ahip4", function(module, exports) {

$parcel$export(module.exports, "loadProjectsOptions", () => $fcba6568b7400bba$export$93f98588ddc2c5);

var $jcw0u = parcelRequire("jcw0u");

var $1As78 = parcelRequire("1As78");

var $joxHT = parcelRequire("joxHT");
const $fcba6568b7400bba$export$93f98588ddc2c5 = async (searchQuery)=>(0, $joxHT.getJpdProjects)(searchQuery).then((projects)=>projects.map((project)=>({
                id: project.id,
                label: project.name,
                imageUrl: project.avatarUrls['16x16'],
                value: project.key
            }))).catch((error)=>{
        (0, $jcw0u.default)((0, $1As78.createErrorAnalytics)('polaris.error.availableProjectsLoadingFailed', error));
        throw error;
    });

});
parcelRegister("joxHT", function(module, exports) {

$parcel$export(module.exports, "getJpdProjects", () => $17c2776772b8d30c$export$e47ac985e655d4a9);

var $2vSU6 = parcelRequire("2vSU6");

var $7f4tk = parcelRequire("7f4tk");
const $17c2776772b8d30c$export$e47ac985e655d4a9 = async (searchQuery = '')=>{
    const queryParams = new URLSearchParams({
        typeKey: (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT),
        query: searchQuery
    });
    const projects = await (0, $7f4tk.default)(`/rest/api/3/project/search?${queryParams.toString()}`);
    return projects.values.map(({ id: id, key: key, name: name, avatarUrls: avatarUrls })=>({
            id: id,
            key: key,
            name: name,
            avatarUrls: avatarUrls
        }));
};

});



parcelRegister("4AjLa", function(module, exports) {

$parcel$export(module.exports, "useCollectionIdeasCount", () => $9fbcca376ebc2df6$export$28cc502c982e0868);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $4R6GH = parcelRequire("4R6GH");

var $dpYV0 = parcelRequire("dpYV0");

var $9iiI8 = parcelRequire("9iiI8");
const $9fbcca376ebc2df6$var$debouncedGetIdeasCountWithJQL = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((jql, setRequest, res, rej)=>{
    const request = (0, $9iiI8.getIdeasCountForCollection)(jql);
    setRequest(request);
    request.then(res, rej).finally(()=>setRequest(undefined));
}, 500);
const $9fbcca376ebc2df6$export$28cc502c982e0868 = (projectKeys, filtersJql)=>{
    const jql = (0, $dpYV0.getJQLForCollection)(projectKeys, filtersJql);
    const [ideasCount, setIdeasCount] = (0, $5uXOq.useState)(undefined);
    const [isLoading, setLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [request, setRequest] = (0, $5uXOq.useState)(undefined);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('jpd-aurora-roadmap-advanced-filtering')) {
            if (jql) {
                setLoading(true);
                $9fbcca376ebc2df6$var$debouncedGetIdeasCountWithJQL(jql, setRequest, (newCount)=>{
                    setIdeasCount(newCount);
                    setLoading(false);
                    setError(null);
                }, (err)=>{
                    setIdeasCount(undefined);
                    setLoading(false);
                    setError(err);
                });
            } else setIdeasCount(undefined);
        }
    }, [
        jql
    ]);
    return [
        ideasCount,
        isLoading,
        error,
        request
    ];
};

});

parcelRegister("FzDIO", function(module, exports) {

$parcel$export(module.exports, "FilterExplanation", () => $7d5da9df7eb07648$export$5d0376228f53282d);

var $5uXOq = parcelRequire("5uXOq");

var $vCqQa = parcelRequire("vCqQa");

var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $9a675 = parcelRequire("9a675");

var $5FmWx = parcelRequire("5FmWx");

var $8zIDr = parcelRequire("8zIDr");

var $1Seuh = parcelRequire("1Seuh");

var $koVbs = parcelRequire("koVbs");

var $1CSZP = parcelRequire("1CSZP");

var $dejEY = parcelRequire("dejEY");

var $602mt = parcelRequire("602mt");
const $7d5da9df7eb07648$var$HELP_ARTICLE_URL = 'https://support.atlassian.com/jira-product-discovery/docs/create-and-configure-roadmaps/#Add-details-and-modify-your-roadmap';
const $7d5da9df7eb07648$export$5d0376228f53282d = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $vCqQa.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "right-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
                xcss: $7d5da9df7eb07648$var$popupStyles,
                space: "space.300"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5FmWx.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($1CSZP))),
                srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($dejEY))),
                alt: formatMessage((0, $602mt.default).information)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
                space: "space.100",
                xcss: $7d5da9df7eb07648$var$explanationStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, formatMessage((0, $602mt.default).explanation)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zIDr.default), {
                href: $7d5da9df7eb07648$var$HELP_ARTICLE_URL,
                target: "_blank"
            }, formatMessage((0, $602mt.default).explore)))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9a675))),
                color: "color.icon",
                onClick: ()=>setIsOpen(!isOpen),
                label: formatMessage((0, $602mt.default).filterImageAlt)
            })
    });
};
const $7d5da9df7eb07648$var$popupStyles = (0, $2s57o.xcss)({
    width: '320px'
});
const $7d5da9df7eb07648$var$explanationStyles = (0, $2s57o.xcss)({
    paddingInline: 'space.250',
    paddingBlockEnd: 'space.250'
});

});
parcelRegister("1CSZP", function(module, exports) {
module.exports = new URL("filter.76d6858b.svg", import.meta.url).toString();

});

parcelRegister("dejEY", function(module, exports) {
module.exports = new URL("filter-dark.b5e43eff.svg", import.meta.url).toString();

});

parcelRegister("602mt", function(module, exports) {

$parcel$export(module.exports, "default", () => $69431b9ce7d036c6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $69431b9ce7d036c6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    information: {
        "id": "polaris-component-collection-create.form.filter-explanation.icon-label",
        "defaultMessage": "Information"
    },
    filterImageAlt: {
        "id": "polaris-component-collection-create.form.filter-explanation.filter-image",
        "defaultMessage": "Image depicting the filter feature"
    },
    explanation: {
        "id": "polaris-component-collection-create.form.filter-explanation.explanation",
        "defaultMessage": "Use global and system fields to display ideas that matter in your roadmap."
    },
    explore: {
        "id": "polaris-component-collection-create.form.filter-explanation.explore",
        "defaultMessage": "Explore how the filtering works"
    }
});

});




parcelRegister("95bJk", function(module, exports) {

$parcel$export(module.exports, "NavigationCollectionsStore", () => $661a30be3b53d964$export$d1d31f5824439428);
$parcel$export(module.exports, "NavigationCollectionsContainer", () => $661a30be3b53d964$export$706091b9dcc1c93c);
$parcel$export(module.exports, "useNavigationCollectionsActions", () => $661a30be3b53d964$export$f352a6870c4cf8e4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $inl3N = parcelRequire("inl3N");

var $8wdQW = parcelRequire("8wdQW");

var $j8AWY = parcelRequire("j8AWY");

var $kIl2x = parcelRequire("kIl2x");

var $7KE0z = parcelRequire("7KE0z");

var $7DN9k = parcelRequire("7DN9k");
const $661a30be3b53d964$var$actions = {
    addCollection: $inl3N.addCollection,
    loadCollections: $8wdQW.loadCollections,
    expandSectionForSelectedCollection: $7KE0z.expandSectionForSelectedCollection,
    updateCollection: $7DN9k.updateCollection,
    deleteCollection: $j8AWY.deleteCollection,
    copyCollection: $kIl2x.copyCollection
};
const $661a30be3b53d964$var$initialState = {
    collections: {
        data: [],
        error: null,
        initialized: false,
        isLoading: false
    },
    activeCollectionUUID: undefined
};
const $661a30be3b53d964$export$d1d31f5824439428 = (0, $iXqE5.createStore)({
    initialState: $661a30be3b53d964$var$initialState,
    actions: $661a30be3b53d964$var$actions,
    name: 'PolarisNavigationCollectionsStore'
});
const $661a30be3b53d964$var$onPropsChange = ({ setState: setState }, props)=>{
    setState({
        activeCollectionUUID: props.activeCollectionUUID
    });
};
const $661a30be3b53d964$export$706091b9dcc1c93c = (0, $gg7kZ.createContainer)($661a30be3b53d964$export$d1d31f5824439428, {
    onInit: ()=>$661a30be3b53d964$var$onPropsChange,
    onUpdate: ()=>$661a30be3b53d964$var$onPropsChange
});
const $661a30be3b53d964$export$f352a6870c4cf8e4 = (0, $3sQ5x.createActionsHook)($661a30be3b53d964$export$d1d31f5824439428);

});
parcelRegister("inl3N", function(module, exports) {

$parcel$export(module.exports, "addCollection", () => $12ed4d510d47743b$export$933f273b2a11730f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $h9Xin = parcelRequire("h9Xin");
const $12ed4d510d47743b$export$933f273b2a11730f = (collection)=>async ({ setState: setState, getState: getState }, { cloudId: cloudId, onSuccess: onSuccess })=>{
        const state = getState();
        if (!cloudId || getState().collections?.isLoading || !getState().collections?.initialized) return;
        const isCollectionAlreadyAdded = state.collections.data.some((currentCollection)=>currentCollection.uuid === collection.uuid);
        if (isCollectionAlreadyAdded) return;
        setState({
            collections: {
                ...state.collections,
                data: (0, $h9Xin.sortedInsertCollection)(state.collections.data, collection)
            }
        });
        onSuccess?.('addCollection');
    };

});
parcelRegister("h9Xin", function(module, exports) {

$parcel$export(module.exports, "updateCollectionsState", () => $180847439a8dbf4e$export$8df89fb7c4993dc);
$parcel$export(module.exports, "transformRemoteNavigationCollection", () => $180847439a8dbf4e$export$7a2bbd8e91947e59);
$parcel$export(module.exports, "sortCollectionsComparator", () => $180847439a8dbf4e$export$2cd1058da15f4128);
$parcel$export(module.exports, "sortedInsertCollection", () => $180847439a8dbf4e$export$c3b09a1eb31c40b9);
$parcel$export(module.exports, "normalizeError", () => $180847439a8dbf4e$export$e7bd538fb0c5db1a);
const $180847439a8dbf4e$export$8df89fb7c4993dc = (state, collectionUUID, update)=>{
    let hasFoundCollection = false;
    const nextCollections = state.collections.data.map((navigationCollection)=>{
        if (navigationCollection.uuid === collectionUUID) {
            hasFoundCollection = true;
            return update(navigationCollection);
        }
        return navigationCollection;
    });
    if (!hasFoundCollection) // There is nothing to update, bail out
    return undefined;
    return {
        ...state,
        collections: {
            ...state.collections,
            data: nextCollections
        }
    };
};
const $180847439a8dbf4e$export$7a2bbd8e91947e59 = (remoteNavigationCollection)=>({
        ...remoteNavigationCollection,
        isExpanded: false
    });
function $180847439a8dbf4e$export$29b1844f9b066c27(arr, element, comparator) {
    const result = [];
    let inserted = false;
    for(let i = 0; i < arr.length; i += 1){
        if (!inserted && comparator(arr[i], element)) {
            inserted = true;
            result.push(element);
        }
        result.push(arr[i]);
    }
    if (!inserted) result.push(element);
    return result;
}
const $180847439a8dbf4e$export$2cd1058da15f4128 = (a, b)=>{
    return a.name.localeCompare(b.name, undefined, {
        numeric: true
    });
};
const $180847439a8dbf4e$export$c3b09a1eb31c40b9 = (collections, collection)=>{
    return $180847439a8dbf4e$export$29b1844f9b066c27(collections, collection, (a, b)=>$180847439a8dbf4e$export$2cd1058da15f4128(a, b) === 1);
};
const $180847439a8dbf4e$export$e7bd538fb0c5db1a = (error)=>{
    if (error instanceof Error) return error;
    return new Error('Unexpected error - catched value is not an instance of an Error class');
};

});


parcelRegister("8wdQW", function(module, exports) {

$parcel$export(module.exports, "loadCollections", () => $b1c697731f83ef7c$export$569b2ddb07e9ef58);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7KE0z = parcelRequire("7KE0z");

var $h9Xin = parcelRequire("h9Xin");
const $b1c697731f83ef7c$export$569b2ddb07e9ef58 = (options)=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { navigationCollectionsRemote: navigationCollectionsRemote, cloudId: cloudId, onFailure: onFailure, onSuccess: onSuccess })=>{
        if (!cloudId || !navigationCollectionsRemote || !navigationCollectionsRemote.fetch || getState().collections.isLoading || getState().collections.initialized && !options?.refresh) return getState().collections.data;
        setState({
            collections: {
                ...getState().collections,
                isLoading: true,
                initialized: true,
                error: null,
                data: []
            }
        });
        try {
            const collectionsRemote = await navigationCollectionsRemote.fetch();
            const data = collectionsRemote.map((0, $h9Xin.transformRemoteNavigationCollection)).sort((0, $h9Xin.sortCollectionsComparator));
            setState({
                collections: {
                    ...getState().collections,
                    isLoading: false,
                    initialized: true,
                    error: null,
                    data: data
                }
            });
            dispatch((0, $7KE0z.expandSectionForSelectedCollection)());
            onSuccess?.('loadCollections');
            return data;
        } catch (maybeError) {
            const error = (0, $h9Xin.normalizeError)(maybeError);
            setState({
                collections: {
                    isLoading: false,
                    initialized: true,
                    error: error,
                    data: []
                }
            });
            onFailure?.(error, 'loadCollections');
            throw maybeError;
        }
    };

});
parcelRegister("7KE0z", function(module, exports) {

$parcel$export(module.exports, "expandSectionForSelectedCollection", () => $69124275231fd44d$export$fe12972b084f1fb8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7DN9k = parcelRequire("7DN9k");
const $69124275231fd44d$export$fe12972b084f1fb8 = ()=>async ({ dispatch: dispatch }, { activeCollectionUUID: activeCollectionUUID, onSuccess: onSuccess })=>{
        if (activeCollectionUUID) {
            dispatch((0, $7DN9k.updateCollection)(activeCollectionUUID, {
                isExpanded: true
            }));
            onSuccess?.('expandSectionForSelectedCollection');
        }
    };

});
parcelRegister("7DN9k", function(module, exports) {

$parcel$export(module.exports, "updateCollection", () => $8776dcdb83b67ca4$export$c0683150b517c317);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $h9Xin = parcelRequire("h9Xin");
const $8776dcdb83b67ca4$export$c0683150b517c317 = (collectionUUID, patch)=>async ({ setState: setState, getState: getState }, { cloudId: cloudId, onSuccess: onSuccess })=>{
        const state = getState();
        if (!cloudId || state.collections.isLoading || !state.collections.initialized) return;
        if (!collectionUUID) return;
        const nextState = (0, $h9Xin.updateCollectionsState)(state, collectionUUID, (prevNavigationCollection)=>({
                ...prevNavigationCollection,
                ...patch
            }));
        if (nextState) {
            setState(nextState);
            onSuccess?.('updateCollection');
        }
    };

});



parcelRegister("j8AWY", function(module, exports) {

$parcel$export(module.exports, "deleteCollection", () => $e14b27360c8829fd$export$3d16e031f6551662);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e14b27360c8829fd$export$3d16e031f6551662 = (collectionUUID)=>async ({ setState: setState, getState: getState }, { onSuccess: onSuccess })=>{
        const state = getState();
        let removed = false;
        const filteredCollections = state.collections.data.filter((collection)=>{
            const shouldRemove = collection.uuid === collectionUUID;
            if (shouldRemove) removed = true;
            return !shouldRemove;
        });
        if (!removed) return;
        setState({
            collections: {
                ...state.collections,
                data: filteredCollections
            }
        });
        onSuccess?.('deleteCollection');
    };

});

parcelRegister("kIl2x", function(module, exports) {

$parcel$export(module.exports, "copyCollection", () => $278215a901158072$export$36928e43600c4b00);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $h9Xin = parcelRequire("h9Xin");
const $278215a901158072$export$36928e43600c4b00 = (collectionUUID, patch)=>async ({ setState: setState, getState: getState }, { onSuccess: onSuccess })=>{
        const state = getState();
        if (!patch.uuid) return;
        const originalCollection = state.collections.data.find((collection)=>collection.uuid === collectionUUID);
        if (originalCollection) {
            const clonedCollection = {
                ...originalCollection,
                uuid: patch.uuid,
                name: patch.name,
                ownerId: patch.ownerId || ''
            };
            setState({
                collections: {
                    ...state.collections,
                    data: (0, $h9Xin.sortedInsertCollection)(state.collections.data, clonedCollection)
                }
            });
            onSuccess?.('copyCollection');
        }
    };

});


parcelRegister("6jadJ", function(module, exports) {

$parcel$export(module.exports, "useIsReadOnly", () => $838d466bf6d7a620$export$692360c94a69c4f6);

var $daoB1 = parcelRequire("daoB1");
const $838d466bf6d7a620$export$692360c94a69c4f6 = ()=>{
    const { hasProductDiscoveryAccess: hasProductDiscoveryAccess } = (0, $daoB1.useApplicationPermissions)();
    return !hasProductDiscoveryAccess;
};

});

parcelRegister("1poXk", function(module, exports) {

$parcel$export(module.exports, "default", () => $0be62508276a2865$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0be62508276a2865$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createRoadmap: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.action-buttons.create-roadmap",
        "defaultMessage": "Create roadmap"
    },
    errorTitle: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.action-buttons.error-title",
        "defaultMessage": "We couldn\u2019t create roadmap"
    },
    errorDescription: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.action-buttons.error-description",
        "defaultMessage": "Please try again or refresh the page."
    },
    errorRefresh: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.action-buttons.error-refresh",
        "defaultMessage": "Try again"
    },
    infoTitleLimit: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.action-buttons.info-title-limit",
        "defaultMessage": "Reached limit"
    }
});

});


parcelRegister("2CiQp", function(module, exports) {

$parcel$export(module.exports, "RoadmapsDefault", () => $c0650f59ffeb69c1$export$2ebfa8774d2594c8);

var $5uXOq = parcelRequire("5uXOq");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");

var $8tJaf = parcelRequire("8tJaf");
const $c0650f59ffeb69c1$export$2ebfa8774d2594c8 = (props)=>{
    const { actionsOnHover: actionsOnHover, isExpanded: isExpanded } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).ROADMAPS);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const menuId = (0, $jhS4y.MENU_ID_ROADMAPS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: menuId,
        onExpansionToggle: (hasExpanded)=>{
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).ROADMAPS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_ROADMAPS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-roadmaps-default",
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        testId: (0, $dQbFB.getTestId)(menuId)
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8tJaf.Footer), null)));
};

});
parcelRegister("8tJaf", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $cb38e1a17d55c084$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $jhS4y = parcelRequire("jhS4y");

var $34PKs = parcelRequire("34PKs");

var $4IIGx = parcelRequire("4IIGx");
var $4vWwj = parcelRequire("4vWwj");
var $ch7sx = parcelRequire("ch7sx");

var $aOD49 = parcelRequire("aOD49");

var $6ZDS2 = parcelRequire("6ZDS2");

var $fZq5p = parcelRequire("fZq5p");
const $cb38e1a17d55c084$export$a06f1c675e846f6f = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireUIAnalyticForFixMenuItem: fireUIAnalyticForFixMenuItem } = (0, $5uXOq.useContext)((0, $6ZDS2.AnalyticContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4vWwj.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ch7sx.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34PKs.ViewAllEntityMenuItem), {
        href: (0, $aOD49.getCollectionsPageUrl)(),
        menuId: (0, $jhS4y.MENU_ID_ROADMAPS_VIEW_ALL),
        onClick: (e)=>{
            fireUIAnalyticForFixMenuItem();
            onClose?.(e);
        }
    }, formatMessage((0, $fZq5p.default).viewAllRoadmaps)))));
};

});
parcelRegister("fZq5p", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e15b7e182815cf6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6e15b7e182815cf6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAllRoadmaps: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.footer.view-all-roadmaps",
        "defaultMessage": "View all roadmaps"
    }
});

});





parcelRegister("852R8", function(module, exports) {

$parcel$export(module.exports, "Nav4RoadmapsNext", () => $5d68bf7990cd9c40$export$8cad8fc03a0326fa);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $338xa = parcelRequire("338xa");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $3RJbG = parcelRequire("3RJbG");

var $9pfec = parcelRequire("9pfec");

var $lvWgl = parcelRequire("lvWgl");

var $kyQ0U = parcelRequire("kyQ0U");

const $5d68bf7990cd9c40$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("epm61")).then(({ Nav4RoadmapsContainer: Nav4RoadmapsContainer })=>Nav4RoadmapsContainer), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/roadmaps/src/ui/roadmaps/index.next.tsx"
});
const $5d68bf7990cd9c40$export$8cad8fc03a0326fa = /*#__PURE__*/ (0, $5uXOq.memo)(({ isExpanded: isExpanded })=>{
    const isCollectionSelected = (0, $kyQ0U.useIsCollectionSelected)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.roadmaps",
        packageName: (0, $3RJbG.PACKAGE_NAME),
        teamName: (0, $3RJbG.TEAM_NAME),
        ufoName: "nav4-sidebar-roadmaps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4-sidebar-roadmaps",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9pfec.RoadmapsStatic), {
            isExpanded: isExpanded,
            actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lvWgl.ActionButtonsStatic), null)
        }, isCollectionSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5d68bf7990cd9c40$var$LazySidebarContent, {
        isExpanded: isExpanded
    })));
});

});
parcelRegister("9pfec", function(module, exports) {

$parcel$export(module.exports, "RoadmapsStatic", () => $0df8f3e780fb12fe$export$4c4071eb62c5e1cf);

var $5uXOq = parcelRequire("5uXOq");

var $jecJ3 = parcelRequire("jecJ3");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $c16H2 = parcelRequire("c16H2");

var $dQbFB = parcelRequire("dQbFB");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $a9Ndx = parcelRequire("a9Ndx");
var $4bjXD = parcelRequire("4bjXD");

var $8tJaf = parcelRequire("8tJaf");
const $0df8f3e780fb12fe$export$4c4071eb62c5e1cf = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { isExpanded: isExpanded, onExpansionToggle: onExpansionToggle, actionsOnHover: actionsOnHover, children: children } = props;
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).ROADMAPS);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c16H2.Nav4ExpandableMenuItem), {
        isExpanded: isExpanded,
        menuId: (0, $jhS4y.MENU_ID_ROADMAPS),
        onExpansionToggle: (hasExpanded)=>{
            onExpansionToggle?.(hasExpanded);
            if (hasExpanded) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).ROADMAPS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_ROADMAPS)
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bjXD.ExpandableMenuItemTrigger), {
        interactionName: "nav4-sidebar-roadmaps-default",
        actionsOnHover: actionsOnHover,
        "aria-label": formattedMessage,
        elemBefore: icon,
        testId: (0, $dQbFB.getTestId)((0, $jhS4y.MENU_ID_ROADMAPS))
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9Ndx.ExpandableMenuItemContent), null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8tJaf.Footer), null)));
});

});

parcelRegister("lvWgl", function(module, exports) {

$parcel$export(module.exports, "ActionButtonsStatic", () => $98f2849f4093958c$export$d29fef02bcf1ee7);

var $5uXOq = parcelRequire("5uXOq");

var $g7g8o = parcelRequire("g7g8o");

var $aOrxC = parcelRequire("aOrxC");

var $5KCCi = parcelRequire("5KCCi");

var $koVbs = parcelRequire("koVbs");

var $46Cti = parcelRequire("46Cti");

var $1xonH = parcelRequire("1xonH");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $6ZDS2 = parcelRequire("6ZDS2");

var $3RJbG = parcelRequire("3RJbG");

var $j9kwa = parcelRequire("j9kwa");
const $98f2849f4093958c$export$d29fef02bcf1ee7 = /*#__PURE__*/ (0, $5uXOq.memo)(({ isReadOnly: isReadOnly, isCreadRoadmapLoading: isCreadRoadmapLoading, isCreateRoadmapDisabled: isCreateRoadmapDisabled, createRoadmapTooltipContent: createRoadmapTooltipContent, onCreateRoadmapClick: onCreateRoadmapClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireUIAnalyticForFixButton: fireUIAnalyticForFixButton } = (0, $5uXOq.useContext)((0, $6ZDS2.AnalyticContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: createRoadmapTooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xonH.CommonNavMenuButton), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g7g8o))),
        label: formatMessage((0, $j9kwa.messages).createRoadmap),
        isLoading: isCreadRoadmapLoading,
        isDisabled: isCreateRoadmapDisabled,
        onClick: onCreateRoadmapClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        onOpen: ()=>fireUIAnalyticForFixButton({
                itemId: (0, $3RJbG.MEATBALL_DROPDOWN)
            }),
        MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
                menuId: (0, $46Cti.L1_MENU_ID).ROADMAPS,
                hasSeparator: false
            }))
    }));
});

});
parcelRegister("j9kwa", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5d207ce31c37069f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5d207ce31c37069f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    createRoadmap: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.action-buttons-static.create-roadmap",
        "defaultMessage": "Create roadmap"
    }
});

});


parcelRegister("kyQ0U", function(module, exports) {

$parcel$export(module.exports, "useCollectionSelectedMatch", () => $1ac5450e6fdb6a66$export$f8678ffe77a81702);
$parcel$export(module.exports, "useIsCollectionsSelected", () => $1ac5450e6fdb6a66$export$bff956e91a23208e);
$parcel$export(module.exports, "useIsCollectionSelected", () => $1ac5450e6fdb6a66$export$d1d2d8dc13ec1cf);
$parcel$export(module.exports, "getViewUrl", () => $1ac5450e6fdb6a66$export$bdccd6a672e4a607);

var $lODMY = parcelRequire("lODMY");

var $aOD49 = parcelRequire("aOD49");
const $1ac5450e6fdb6a66$export$f8678ffe77a81702 = (0, $lODMY.createRouterSelector)(({ route: route, match: match })=>{
    const viewUUID = match.params?.resource || undefined;
    const collectionUUID = match.params?.collectionUUID || undefined;
    const isCollectionSelected = route.name === 'polaris-collections' && collectionUUID !== undefined && viewUUID !== undefined;
    return isCollectionSelected ? {
        collectionUUID: collectionUUID,
        viewUUID: viewUUID
    } : undefined;
});
const $1ac5450e6fdb6a66$export$bff956e91a23208e = (0, $lODMY.createRouterSelector)(({ route: route, match: match })=>{
    const viewUUID = match.params?.resource || undefined;
    const collectionUUID = match.params?.collectionUUID || undefined;
    return route.name === 'polaris-collections' && viewUUID === undefined && collectionUUID === undefined;
});
const $1ac5450e6fdb6a66$export$d1d2d8dc13ec1cf = (options)=>{
    const collectionMatched = $1ac5450e6fdb6a66$export$f8678ffe77a81702();
    if (options?.collectionUUID) return collectionMatched && collectionMatched.collectionUUID === options.collectionUUID;
    return Boolean(collectionMatched);
};
const $1ac5450e6fdb6a66$export$bdccd6a672e4a607 = ({ container: container, view: view })=>{
    // In collections we don't use `view.polarisId` like we do in jpd-project-menu
    // but instead we use `view.id` that contains UUID
    return (0, $aOD49.getCollectionViewPageUrl)(container.collectionUUID, view.id);
};

});

parcelRegister("epm61", function(module, exports) {

let $a7d48a4dc73f8951$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a7d48a4dc73f8951$var$load("i9aho").then(()=>parcelRequire('67zLr'));

});



parcelRegister("cq1bX", function(module, exports) {

$parcel$export(module.exports, "Starred", () => $75f7926d6c4a87ae$export$8cd2a0520fb55072);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");

var $2lF9G = parcelRequire("2lF9G");

var $xP1Je = parcelRequire("xP1Je");
const $75f7926d6c4a87ae$export$8cd2a0520fb55072 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-starred"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "starred",
        packageName: (0, $2lF9G.PACKAGE_NAME),
        teamName: (0, $2lF9G.TEAM_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xP1Je.StarredFlyoutMenuItem), null)));

});
parcelRegister("2lF9G", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $ebc2aa74f4359e69$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $ebc2aa74f4359e69$export$d57b6b390e78d90f);
$parcel$export(module.exports, "FAVOURITE_QUERY_LIMIT", () => $ebc2aa74f4359e69$export$77881eca52f4f5a6);
$parcel$export(module.exports, "FAVORITE_TYPE_MAP", () => $ebc2aa74f4359e69$export$c2849e00cccc2078);
$parcel$export(module.exports, "FAVORITE_TYPE_FILTER_MAP", () => $ebc2aa74f4359e69$export$531e43cc63c1e036);
$parcel$export(module.exports, "VALID_FAVORITE_TYPES", () => $ebc2aa74f4359e69$export$336e25f77ad481a9);
$parcel$export(module.exports, "FAVORITE_TYPE_FILTER_MESSAGE", () => $ebc2aa74f4359e69$export$de9a288dad6f35f1);
$parcel$export(module.exports, "SEARCH_STARRED_ITEMS", () => $ebc2aa74f4359e69$export$6b181848cd9c8308);
$parcel$export(module.exports, "FILTER", () => $ebc2aa74f4359e69$export$c1c49903035a02df);

var $hWFET = parcelRequire("hWFET");
const $ebc2aa74f4359e69$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Starred';
const $ebc2aa74f4359e69$export$d57b6b390e78d90f = 'jira-cosmos';
const $ebc2aa74f4359e69$export$77881eca52f4f5a6 = 15;
const $ebc2aa74f4359e69$export$c2849e00cccc2078 = {
    PROJECT: 'PROJECT',
    FILTER: 'FILTER',
    DASHBOARD: 'DASHBOARD',
    PLAN: 'PLAN',
    BOARD: 'BOARD',
    QUEUE: 'QUEUE'
};
const $ebc2aa74f4359e69$export$531e43cc63c1e036 = {
    ...$ebc2aa74f4359e69$export$c2849e00cccc2078,
    ALL: 'ALL'
};
const $ebc2aa74f4359e69$export$336e25f77ad481a9 = Object.values($ebc2aa74f4359e69$export$c2849e00cccc2078);
const $ebc2aa74f4359e69$export$de9a288dad6f35f1 = {
    [$ebc2aa74f4359e69$export$531e43cc63c1e036.PROJECT]: (0, $hWFET.messages).projects,
    [$ebc2aa74f4359e69$export$531e43cc63c1e036.FILTER]: (0, $hWFET.messages).filters,
    [$ebc2aa74f4359e69$export$531e43cc63c1e036.DASHBOARD]: (0, $hWFET.messages).dashboards,
    [$ebc2aa74f4359e69$export$531e43cc63c1e036.PLAN]: (0, $hWFET.messages).plans,
    [$ebc2aa74f4359e69$export$531e43cc63c1e036.BOARD]: (0, $hWFET.messages).boards,
    [$ebc2aa74f4359e69$export$531e43cc63c1e036.QUEUE]: (0, $hWFET.messages).queues,
    [$ebc2aa74f4359e69$export$531e43cc63c1e036.ALL]: (0, $hWFET.messages).all
};
const $ebc2aa74f4359e69$export$6b181848cd9c8308 = 'searchStarredItems';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $ebc2aa74f4359e69$var$VIEW_ALL_STARRED_ITEMS = 'viewAllStarredItems';
const $ebc2aa74f4359e69$export$c1c49903035a02df = 'filter';

});
parcelRegister("hWFET", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ef19a8d714970feb$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ef19a8d714970feb$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    projects: {
        "id": "navigation-apps-sidebar-nav4-starred.common.projects",
        "defaultMessage": "Projects"
    },
    filters: {
        "id": "navigation-apps-sidebar-nav4-starred.common.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "navigation-apps-sidebar-nav4-starred.common.dashboards",
        "defaultMessage": "Dashboards"
    },
    plans: {
        "id": "navigation-apps-sidebar-nav4-starred.common.plans",
        "defaultMessage": "Plans"
    },
    boards: {
        "id": "navigation-apps-sidebar-nav4-starred.common.boards",
        "defaultMessage": "Boards"
    },
    queues: {
        "id": "navigation-apps-sidebar-nav4-starred.common.queues",
        "defaultMessage": "Queues"
    },
    all: {
        "id": "navigation-apps-sidebar-nav4-starred.common.all",
        "defaultMessage": "All"
    }
});

});


parcelRegister("xP1Je", function(module, exports) {

$parcel$export(module.exports, "StarredFlyoutMenuItem", () => $4533cea19a1bfb96$export$b5a36b539503145d);

var $5uXOq = parcelRequire("5uXOq");

var $fkyxu = parcelRequire("fkyxu");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");


var $jecJ3 = parcelRequire("jecJ3");

var $iszzG = parcelRequire("iszzG");

var $46Cti = parcelRequire("46Cti");

var $338xa = parcelRequire("338xa");

var $24a2m = parcelRequire("24a2m");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $koeKL = parcelRequire("koeKL");

var $3senf = parcelRequire("3senf");
var $l7Vqz = parcelRequire("l7Vqz");
var $8luXP = parcelRequire("8luXP");

var $2lF9G = parcelRequire("2lF9G");

var $64Fry = parcelRequire("64Fry");

var $aOVaR = parcelRequire("aOVaR");
function $4533cea19a1bfb96$export$b5a36b539503145d() {
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, $iszzG.NavItemsContext));
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $aOVaR.sidebarStarredMenuEntryPoint), {
        cloudId: cloudId,
        filter: {
            types: (0, $2lF9G.VALID_FAVORITE_TYPES),
            sort: {
                order: 'DESC'
            }
        },
        count: (0, $2lF9G.FAVOURITE_QUERY_LIMIT)
    });
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $64Fry.default).starred, (0, (/*@__PURE__*/$parcel$interopDefault($fkyxu))));
    const onOpenChangeHandler = async (isOpen)=>{
        if (isOpen) {
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$6dd9406e478a1fe2)
            });
            const isInMore = moreMenuIds.includes((0, $46Cti.L1_MENU_ID).STARRED);
            (0, $8zOmE.fireUIAnalytics)(event, (0, $jecJ3.SECTION_ITEM_STARRED), {
                isInMore: isInMore
            });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3senf.FlyoutMenuItem), {
        onOpenChange: onOpenChangeHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8luXP.FlyoutMenuItemTrigger), {
        interactionName: "nav4-sidebar-starred",
        ref: triggerRef,
        elemBefore: icon
    }, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l7Vqz.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        // Data stream, will subscribe to load updates.
        entryPointReferenceSubject: entryPointReferenceSubject,
        // Required props for error JSErrorBoundary.
        id: "nav4-sidebar-starred-default",
        packageName: (0, $2lF9G.PACKAGE_NAME),
        teamName: (0, $2lF9G.TEAM_NAME),
        // Optional props for error JSErrorBoundary.
        errorFallback: "flag",
        // Fallback for `Suspense`.
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $338xa.SkeletonNavMenuItems), null),
        // Props for the root component.
        runtimeProps: {}
    })));
}

});
parcelRegister("64Fry", function(module, exports) {

$parcel$export(module.exports, "default", () => $d29101a3b8ab7b9b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d29101a3b8ab7b9b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    starred: {
        "id": "navigation-apps-sidebar-nav4-starred.starred",
        "defaultMessage": "Starred"
    }
});

});

parcelRegister("aOVaR", function(module, exports) {

$parcel$export(module.exports, "sidebarStarredMenuEntryPoint", () => $ee124e0d33917030$export$72aec40208131d);

var $jFWWh = parcelRequire("jFWWh");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $ee124e0d33917030$export$72aec40208131d = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("3BaYx")), {
        moduleId: "ab25fe7d"
    }),
    getPreloadProps: ({ cloudId: cloudId, filter: filter, count: count })=>({
            queries: {
                starredMenuData: {
                    parameters: $jFWWh.default,
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    variables: {
                        cloudId: cloudId,
                        count: count,
                        filter: filter
                    }
                }
            }
        })
});

});
parcelRegister("jFWWh", function(module, exports) {

$parcel$export(module.exports, "default", () => $346d8a8aa569881a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7bb03542a269252c90a2aa73c01c6062>>
 * @relayHash f34979afb8cd27df9f4da6c1a31a9ee6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 31e047825e1403b4e5982d0a07da0a9f90eee8f2086996cd6caf739c1a5196dd

var $eiowN = parcelRequire("eiowN");
const $346d8a8aa569881a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v5 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v6 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v7 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v12 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isNode"
    }, v13 = [
        v9 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v10 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "filterUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "filterId"
                },
                v12 /*: any*/ 
            ],
            "type": "JiraFilter",
            "abstractKey": "__isJiraFilter"
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "title"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "starredMenuQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "allFavourites",
                                "args": v5 /*: any*/ ,
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v6 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira.allFavourites.pageInfo"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "starredMenu_navigationAppsSidebarNav4SidebarsContentStarred"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "starredMenuQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "allFavourites",
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "starredItems",
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "defaultNavigationItem",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraNavigationItem",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                v11 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "large"
                                                                }
                                                            ]
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraSystemFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dashboardId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "planId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "alias": "title",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "queueId"
                                                        },
                                                        v12 /*: any*/ 
                                                    ],
                                                    "type": "JiraServiceManagementQueue"
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "starredItems",
                            "args": v7 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "StarredMenuListContent_starredItems",
                            "kind": "LinkedHandle",
                            "name": "favourites"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "31e047825e1403b4e5982d0a07da0a9f90eee8f2086996cd6caf739c1a5196dd",
            "metadata": {},
            "name": "starredMenuQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$346d8a8aa569881a$var$node.hash = "a986e516464a8c05df425dc6bf3d574d";
(0, $eiowN.PreloadableQueryRegistry).set($346d8a8aa569881a$var$node.params.id, $346d8a8aa569881a$var$node);
var $346d8a8aa569881a$export$2e2bcd8739ae039 = $346d8a8aa569881a$var$node;

});

parcelRegister("3BaYx", function(module, exports) {

let $29ed574d1be6294b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $29ed574d1be6294b$var$load("bbPMV").then(()=>parcelRequire('1K2XC'));

});




parcelRegister("96poX", function(module, exports) {

$parcel$export(module.exports, "Teams", () => $b8d06ffc4011b778$export$b3a34d915d8dd11e);

var $5uXOq = parcelRequire("5uXOq");

var $eRJ8t = parcelRequire("eRJ8t");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");


var $9SHwc = parcelRequire("9SHwc");
const $b8d06ffc4011b778$export$b3a34d915d8dd11e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-sidebar-teams"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "teams",
        packageName: (0, $2cdcf2b7084757bc$export$b8b9d90f9e5bd72b),
        teamName: (0, $2cdcf2b7084757bc$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRJ8t.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9SHwc.TeamsMenu), null))));

});
const $2cdcf2b7084757bc$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Teams';
const $2cdcf2b7084757bc$export$d57b6b390e78d90f = 'People and Teams Collective';
const $2cdcf2b7084757bc$export$f17fc93a893ec45c = 'add';
const $2cdcf2b7084757bc$export$6ee8a54637c51e7d = 'createATeam';
const $2cdcf2b7084757bc$export$b3dcfa0224e0289c = 'invitePeople';
const $2cdcf2b7084757bc$export$f06dfcec5ff912e = 'meatballDropdown';
const $2cdcf2b7084757bc$export$1245c8aac7dab260 = '/jira/people/search';

parcelRegister("9SHwc", function(module, exports) {

$parcel$export(module.exports, "TeamsMenu", () => $00a1aa44690d74d1$export$deb84fb5c6bff4b0);

var $5uXOq = parcelRequire("5uXOq");

var $2Xf08 = parcelRequire("2Xf08");

var $1Seuh = parcelRequire("1Seuh");

var $g7g8o = parcelRequire("g7g8o");

var $7H980 = parcelRequire("7H980");
var $aOrxC = parcelRequire("aOrxC");

var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");

var $jgJNO = parcelRequire("jgJNO");

var $koVbs = parcelRequire("koVbs");




var $jecJ3 = parcelRequire("jecJ3");

var $ivGSs = parcelRequire("ivGSs");

var $jhS4y = parcelRequire("jhS4y");

var $46Cti = parcelRequire("46Cti");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $ctUNb = parcelRequire("ctUNb");

var $3TY9o = parcelRequire("3TY9o");


var $jOXuX = parcelRequire("jOXuX");

var $at1Nr = parcelRequire("at1Nr");

var $4R6GH = parcelRequire("4R6GH");


var $eXCTi = parcelRequire("eXCTi");

var $eA0nk = parcelRequire("eA0nk");

var $fxSv8 = parcelRequire("fxSv8");
function $00a1aa44690d74d1$export$deb84fb5c6bff4b0() {
    const [isOpenTeamsPopup, openTeamsPopup] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)((0, $46Cti.L1_MENU_ID).TEAMS);
    const location = (0, $3TY9o.useLocation)();
    const path = location.pathname + location.search;
    const isSelected = path === (0, $2cdcf2b7084757bc$export$1245c8aac7dab260);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const actionSubjectId = (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[0, $jhS4y.MENU_ID_TEAMS];
    const label = formatMessage((0, $eXCTi.default).addButton);
    const [createTeamModal, createTeamModalTrigger] = (0, $eA0nk.useCreateTeamModal)();
    const invitePeopleModalTrigger = (0, $fxSv8.useInvitePeopleModal)();
    const onLinkClick = ()=>{
        sendSectionItemAnalyticsEvent({
            menuId: (0, $46Cti.L1_MENU_ID).TEAMS,
            sectionItem: (0, $jecJ3.SECTION_ITEM_TEAMS)
        });
    };
    const onPlusButtonClick = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                parentItemId: (0, $jecJ3.SECTION_ITEM_TEAMS),
                itemId: (0, $2cdcf2b7084757bc$export$f17fc93a893ec45c)
            }
        });
        openTeamsPopup(true);
    };
    const isTailoredOnboarding = (0, $jOXuX.isTailoredOnboardingEnabled)();
    const peopleMenuWrapperRef = (0, $2Xf08.useRegisterNudgeTarget)((0, $6784cbc7d62e5d7c$export$77bc79debbf5c069), isTailoredOnboarding || (0, $4R6GH.fg)('tailored_onboarding_m2p5_gate')).ref;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, createTeamModal, (isTailoredOnboarding || (0, $4R6GH.fg)('tailored_onboarding_m2p5_gate')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $at1Nr.InviteTeamNudgeAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctUNb.MenuLinkItem), {
        ref: isTailoredOnboarding || (0, $4R6GH.fg)('tailored_onboarding_m2p5_gate') ? peopleMenuWrapperRef : undefined,
        testId: "navigation-apps-sidebar-nav4-sidebars-content-teams.ui.sidenav-teams",
        href: (0, $2cdcf2b7084757bc$export$1245c8aac7dab260),
        isSelected: isSelected,
        elemBefore: icon,
        onClick: onLinkClick,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
            shouldRenderToParent: true,
            placement: "bottom-start",
            messageId: "navigation-apps-sidebar-nav4-sidebars-content-teams.ui.popup",
            messageType: "transactional",
            onClose: ()=>openTeamsPopup(false),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
                    ...triggerProps,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($g7g8o))),
                    appearance: "subtle",
                    spacing: "compact",
                    testId: "navigation-apps-sidebar-nav4-sidebars-content-teams.ui.sidenav-teams-popup-trigger",
                    isSelected: isOpenTeamsPopup,
                    label: label,
                    tooltip: {
                        content: label
                    },
                    isTooltipDisabled: false,
                    onClick: onPlusButtonClick
                }),
            isOpen: isOpenTeamsPopup,
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
                    xcss: $00a1aa44690d74d1$var$teamsMenuStyle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
                    onClick: ()=>{
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                            action: 'clicked',
                            actionSubject: 'dropdownItem',
                            actionSubjectId: actionSubjectId,
                            attributes: {
                                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                                componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
                                parentItemId: (0, $jecJ3.SECTION_ITEM_TEAMS),
                                itemId: (0, $2cdcf2b7084757bc$export$b3dcfa0224e0289c)
                            }
                        });
                        invitePeopleModalTrigger();
                        openTeamsPopup(false);
                    }
                }, formatMessage((0, $eXCTi.default).invitePeople)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
                    onClick: ()=>{
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                            action: 'clicked',
                            actionSubject: 'dropdownItem',
                            actionSubjectId: actionSubjectId,
                            attributes: {
                                level: (0, $951a0ed422513987$export$fe3b012b0224e4e1),
                                componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
                                parentItemId: (0, $jecJ3.SECTION_ITEM_TEAMS),
                                itemId: (0, $2cdcf2b7084757bc$export$6ee8a54637c51e7d)
                            }
                        });
                        createTeamModalTrigger();
                        openTeamsPopup(false);
                    }
                }, formatMessage((0, $eXCTi.default).createTeam)))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
            onOpen: ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                    action: 'clicked',
                    actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6),
                    actionSubjectId: actionSubjectId,
                    attributes: {
                        level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                        componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                        itemId: (0, $2cdcf2b7084757bc$export$f06dfcec5ff912e)
                    }
                });
            },
            MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
                    menuId: (0, $jhS4y.MENU_ID_TEAMS),
                    hasSeparator: false
                }))
        }))
    }, formattedMessage));
}
const $00a1aa44690d74d1$var$teamsMenuStyle = (0, $2s57o.xcss)({
    minWidth: '260px',
    paddingBlock: 'space.100'
});

});
parcelRegister("jOXuX", function(module, exports) {

$parcel$export(module.exports, "isTailoredOnboardingScrumAndSoftwareKanbanEnabled", () => $4b94b4e85c1e2fc8$export$5dd90adc2e8ee137);
$parcel$export(module.exports, "isTailoredOnboardingEnabled", () => $4b94b4e85c1e2fc8$export$8eec918bc6d2ab67);
$parcel$export(module.exports, "isEligibleForTailoredOnboardingScrumAndSoftwareKanban", () => $4b94b4e85c1e2fc8$export$713219ba4b63fe78);
$parcel$export(module.exports, "useIsTailoredOnboardingEnabledAndEligible", () => $4b94b4e85c1e2fc8$export$46047e5fecf4cae5);
$parcel$export(module.exports, "isTailoredOnboardingEnabledWithExposure", () => $4b94b4e85c1e2fc8$export$142e2425d224298f);
$parcel$export(module.exports, "useIsTailoredOnboardingM2p5EligibleWithExposure", () => $4b94b4e85c1e2fc8$export$fd0589feb622f26b);
$parcel$export(module.exports, "useIsScrumProject", () => $4b94b4e85c1e2fc8$export$f9373c9ef51fa1f4);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $bNm1d = parcelRequire("bNm1d");

var $gQEFa = parcelRequire("gQEFa");

var $dAfqg = parcelRequire("dAfqg");

var $e5wyW = parcelRequire("e5wyW");

var $58GFP = parcelRequire("58GFP");


var $cNd4s = parcelRequire("cNd4s");

var $8zOmE = parcelRequire("8zOmE");

var $bngFq = parcelRequire("bngFq");

var $43qGj = parcelRequire("43qGj");
const $4b94b4e85c1e2fc8$export$7889b94f54c2d416 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('tailored_onboarding_m3');
    return (0, $4R6GH.fg)('tailored_onboarding_m3_gate') && expConfig.get('isEnabled', false);
};
const $4b94b4e85c1e2fc8$export$5dd90adc2e8ee137 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('tailored_onboarding_scrum_and_software_kanban');
    return expConfig.get('isEnabled', false);
};
const $4b94b4e85c1e2fc8$export$f9b7a643200046ae = ()=>{
    return $4b94b4e85c1e2fc8$export$7889b94f54c2d416() || $4b94b4e85c1e2fc8$export$5dd90adc2e8ee137();
};
const $4b94b4e85c1e2fc8$export$8eec918bc6d2ab67 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jira_tailored_onboarding_shared_experiment_check'), $4b94b4e85c1e2fc8$export$f9b7a643200046ae, $4b94b4e85c1e2fc8$export$7889b94f54c2d416);
const $4b94b4e85c1e2fc8$export$54c132e77bb6d105 = ({ teamType: teamType, templateKey: templateKey, isSiteAdmin: isSiteAdmin })=>{
    if (!isSiteAdmin) return false;
    const isSoftwareTeamType = teamType === (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b);
    const isKanbanTemplate = templateKey?.startsWith((0, $58GFP.KANBAN_TEAM_MANAGED_KEY));
    if (isKanbanTemplate && !isSoftwareTeamType && $4b94b4e85c1e2fc8$export$7889b94f54c2d416()) return true;
    return false;
};
const $4b94b4e85c1e2fc8$export$713219ba4b63fe78 = ({ teamType: teamType, templateKey: templateKey, isSiteAdmin: isSiteAdmin })=>{
    if (!isSiteAdmin) return false;
    const isSoftwareTeamType = teamType === (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b);
    const isScrumTemplate = templateKey?.startsWith((0, $58GFP.SCRUM_TEAM_MANAGED_KEY));
    const isKanbanTemplate = templateKey?.startsWith((0, $58GFP.KANBAN_TEAM_MANAGED_KEY));
    if (isKanbanTemplate && isSoftwareTeamType && $4b94b4e85c1e2fc8$export$5dd90adc2e8ee137()) return true;
    if (isScrumTemplate && $4b94b4e85c1e2fc8$export$5dd90adc2e8ee137()) return true;
    return false;
};
const $4b94b4e85c1e2fc8$export$5188e1ffa34f6a91 = ({ teamType: teamType, templateKey: templateKey, isSiteAdmin: isSiteAdmin })=>{
    return $4b94b4e85c1e2fc8$export$54c132e77bb6d105({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    }) || $4b94b4e85c1e2fc8$export$713219ba4b63fe78({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    });
};
const $4b94b4e85c1e2fc8$export$68df71de32509eb9 = ()=>{
    const isEnabled = $4b94b4e85c1e2fc8$export$7889b94f54c2d416();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    const projectType = projectData?.projectType;
    const isSoftwareProject = projectType === 'software';
    const shouldFetch = isEnabled && isSiteAdmin && isSoftwareProject;
    const { isReady: teamTypeIsReady, teamType: teamType } = (0, $bNm1d.useTeamTypeShortHand)({
        shouldFetch: shouldFetch
    });
    const { loading: projectContextLoading, data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { isReady: templateKeyIsReady, data: templateKey } = (0, $gQEFa.useFetchInitialProjectTemplateName)({
        shouldFetch: shouldFetch,
        projectId: projectContext?.projectId
    });
    if (!isEnabled) return {
        isReady: true,
        isTailoredOnboardingM3EnabledAndEligible: false,
        isTailoredOnboardingScrumAndSoftwareKanbanEnabled: false
    };
    const isSoftwareTeamType = teamType === (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b);
    const isTmpKanban = !!templateKey?.startsWith((0, $58GFP.KANBAN_TEAM_MANAGED_KEY));
    const isEligible = isSiteAdmin && isTmpKanban && !isSoftwareTeamType && isSoftwareProject;
    return {
        isReady: teamTypeIsReady && templateKeyIsReady && !projectContextLoading,
        isTailoredOnboardingM3EnabledAndEligible: isEnabled && isEligible,
        isTailoredOnboardingScrumAndSoftwareKanbanEnabled: false,
        teamType: teamType
    };
};
const $4b94b4e85c1e2fc8$var$useIsTailoredOnboardingM3EnabledWithScrumAndSoftwareKanbanSupport = ()=>{
    const isEnabled = $4b94b4e85c1e2fc8$export$8eec918bc6d2ab67();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    const projectType = projectData?.projectType;
    const isSoftwareProject = projectType === 'software';
    const shouldFetch = isEnabled && isSiteAdmin && isSoftwareProject;
    const { isReady: teamTypeIsReady, teamType: teamType } = (0, $bNm1d.useTeamTypeShortHand)({
        shouldFetch: shouldFetch
    });
    const { loading: projectContextLoading, data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { isReady: templateKeyIsReady, data: templateKey } = (0, $gQEFa.useFetchInitialProjectTemplateName)({
        shouldFetch: shouldFetch,
        projectId: projectContext?.projectId
    });
    if (!isEnabled) return {
        isReady: true,
        isTailoredOnboardingM3EnabledAndEligible: false,
        isTailoredOnboardingScrumAndSoftwareKanbanEnabled: false
    };
    const isTailoredOnboardingM3EnabledAndEligible = $4b94b4e85c1e2fc8$export$54c132e77bb6d105({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    });
    const IsTailoredOnboardingEnabledWithScrumAndSoftware = $4b94b4e85c1e2fc8$export$713219ba4b63fe78({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    });
    return {
        isReady: teamTypeIsReady && templateKeyIsReady && !projectContextLoading,
        isTailoredOnboardingM3EnabledAndEligible: isEnabled && isTailoredOnboardingM3EnabledAndEligible,
        isTailoredOnboardingScrumAndSoftwareKanbanEnabled: isEnabled && IsTailoredOnboardingEnabledWithScrumAndSoftware,
        teamType: teamType
    };
};
const $4b94b4e85c1e2fc8$export$46047e5fecf4cae5 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jira_tailored_onboarding_shared_experiment_check'), $4b94b4e85c1e2fc8$var$useIsTailoredOnboardingM3EnabledWithScrumAndSoftwareKanbanSupport, $4b94b4e85c1e2fc8$export$68df71de32509eb9);
const $4b94b4e85c1e2fc8$export$7be3a325d4c5384 = ({ isTmpKanban: isTmpKanban, isSoftwareTeamType: isSoftwareTeamType, isSiteAdmin: isSiteAdmin, analyticEvent: analyticEvent, teamType: teamType })=>{
    if (isSiteAdmin && isTmpKanban && !isSoftwareTeamType && (0, $4R6GH.fg)('tailored_onboarding_m3_gate')) {
        (0, $8zOmE.fireTrackAnalytics)(analyticEvent, 'tailoredM3Redirect personalised', {
            teamType: teamType,
            isEnabled: (0, $6s1PB.expVal)('tailored_onboarding_m3', 'isEnabled', false)
        });
        return (0, $6s1PB.expVal)('tailored_onboarding_m3', 'isEnabled', false);
    }
    return false;
};
const $4b94b4e85c1e2fc8$export$469220ca30dc2e8 = ({ isTmpKanban: // eslint-disable-next-line @typescript-eslint/no-unused-vars
isTmpKanban, isSoftwareTeamType: // eslint-disable-next-line @typescript-eslint/no-unused-vars
isSoftwareTeamType, isSiteAdmin: isSiteAdmin, analyticEvent: analyticEvent, teamType: teamType, templateKey: templateKey })=>{
    if ($4b94b4e85c1e2fc8$export$54c132e77bb6d105({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    })) {
        (0, $8zOmE.fireTrackAnalytics)(analyticEvent, 'tailoredM3Redirect personalised', {
            teamType: teamType,
            templateKey: templateKey,
            isEnabled: (0, $6s1PB.expVal)('tailored_onboarding_m3', 'isEnabled', false)
        });
        return (0, $6s1PB.expVal)('tailored_onboarding_m3', 'isEnabled', false);
    }
    if ($4b94b4e85c1e2fc8$export$713219ba4b63fe78({
        teamType: teamType,
        templateKey: templateKey,
        isSiteAdmin: isSiteAdmin
    })) {
        (0, $8zOmE.fireTrackAnalytics)(analyticEvent, 'tailoredOnboardingeWithScrumAndSoftwareKanban personalised', {
            teamType: teamType,
            templateKey: templateKey,
            isEnabled: (0, $6s1PB.expVal)('tailored_onboarding_scrum_and_software_kanban', 'isEnabled', false)
        });
        return (0, $6s1PB.expVal)('tailored_onboarding_scrum_and_software_kanban', 'isEnabled', false);
    }
    return false;
};
const $4b94b4e85c1e2fc8$export$142e2425d224298f = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jira_tailored_onboarding_shared_experiment_check'), $4b94b4e85c1e2fc8$export$469220ca30dc2e8, $4b94b4e85c1e2fc8$export$7be3a325d4c5384);
const $4b94b4e85c1e2fc8$export$fd0589feb622f26b = ({ isBusinessProject: isBusinessProject, isTrelloCrossflow: isTrelloCrossflow, isOnboarding: isOnboarding })=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isBasicEligible = isSiteAdmin && isBusinessProject && !isTrelloCrossflow;
    const { isReady: teamTypeIsReady, teamType: teamType } = (0, $bNm1d.useTeamTypeShortHand)({
        shouldFetch: isBasicEligible
    });
    const isTargettedTeamType = ![
        (0, $6784cbc7d62e5d7c$export$4f3cb0844009af52),
        (0, $6784cbc7d62e5d7c$export$e4824f74b9879164)
    ].includes(teamType ?? '');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireOnce = (0, $5uXOq.useRef)(false);
    if (!isBasicEligible) return {
        isEligible: false,
        isReady: true
    };
    if (!teamTypeIsReady) return {
        isEligible: undefined,
        isReady: false
    };
    if (isBusinessProject && isSiteAdmin && isTargettedTeamType) {
        if (!fireOnce.current) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'tailoredM2p5 exposed', {
                teamType: teamType,
                isOnboarding: isOnboarding,
                isEnabled: (0, $6s1PB.expVal)('tailored_onboarding_m2p5', 'isEnabled', false)
            });
            fireOnce.current = true;
        }
        return {
            isEligible: (0, $6s1PB.expVal)('tailored_onboarding_m2p5', 'isEnabled', false),
            isReady: true,
            teamType: teamType
        };
    }
    return {
        isEligible: false,
        isReady: true,
        teamType: teamType
    };
};
const $4b94b4e85c1e2fc8$export$f9373c9ef51fa1f4 = ()=>{
    if (!$4b94b4e85c1e2fc8$export$5dd90adc2e8ee137()) return false;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data: data } = (0, $43qGj.useFeatures)();
    return (data?.hasSprint && data?.hasBacklog) ?? false;
};

});
parcelRegister("bNm1d", function(module, exports) {

$parcel$export(module.exports, "useUserEmailDomain", () => $e92819165abac823$export$f95c1c6f997ec47f);
$parcel$export(module.exports, "useAtlassianAccount", () => $e92819165abac823$export$19d38f479bd18098);
$parcel$export(module.exports, "useTeamTypeShortHand", () => $e92819165abac823$export$1a086dfae472ccfe);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $9yQlD = parcelRequire("9yQlD");


var $asmQK = parcelRequire("asmQK");

var $2LmB4 = parcelRequire("2LmB4");
const $e92819165abac823$export$d4c72bab9d6cc13a = {
    isFetching: false,
    wasFetchedOnce: false,
    fetchError: null
};
const $e92819165abac823$var$Store = (0, $iXqE5.createStore)({
    initialState: $e92819165abac823$export$d4c72bab9d6cc13a,
    actions: $2LmB4.actions,
    name: 'atlassian-account'
});
const $e92819165abac823$var$loggedInEmailDomainSelector = (0, $6dDSs.createSelector)((state)=>state.data, (accountInfo)=>{
    if (!accountInfo) return null;
    const [, loggedInEmailDomain] = accountInfo.email?.split('@') ?? [];
    return loggedInEmailDomain;
});
const $e92819165abac823$export$2a9b22328f7b68fa = (0, $3sQ5x.createHook)($e92819165abac823$var$Store, {
    selector: $e92819165abac823$var$loggedInEmailDomainSelector
});
const $e92819165abac823$export$f95c1c6f997ec47f = (isEligibleToCall = true)=>{
    const [loggedInEmailDomain, { fetchAtlassianAccountData: fetchAtlassianAccountData }] = $e92819165abac823$export$2a9b22328f7b68fa();
    (0, $5uXOq.useEffect)(()=>{
        if (isEligibleToCall && !loggedInEmailDomain) fetchAtlassianAccountData();
    }, [
        fetchAtlassianAccountData,
        isEligibleToCall,
        loggedInEmailDomain
    ]);
    return {
        data: loggedInEmailDomain
    };
};
const $e92819165abac823$export$19d38f479bd18098 = (0, $3sQ5x.createHook)($e92819165abac823$var$Store);
const $e92819165abac823$export$1a086dfae472ccfe = ({ shouldFetch: shouldFetch })=>{
    const [{ data: atlassianAccountData, isFetching: isFetching, wasFetchedOnce: wasFetchedOnce }, { fetchAtlassianAccountData: fetchAtlassianAccountData }] = $e92819165abac823$export$19d38f479bd18098();
    const localStorageTeamTypeShorthand = (0, $9yQlD.localStorageProvider).get((0, $6784cbc7d62e5d7c$export$c06666264cd35603));
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFetch && !localStorageTeamTypeShorthand && !isFetching && !wasFetchedOnce) fetchAtlassianAccountData({
            source: 'useTeamTypeShortHand'
        });
    }, [
        fetchAtlassianAccountData,
        isFetching,
        localStorageTeamTypeShorthand,
        shouldFetch,
        wasFetchedOnce
    ]);
    if (localStorageTeamTypeShorthand) return {
        isReady: true,
        teamType: localStorageTeamTypeShorthand
    };
    if (!shouldFetch) return {
        isReady: true,
        teamType: (0, $asmQK.mapUserSegmentationFullToShorthand)(atlassianAccountData?.extendedProfile.teamType)
    };
    if (atlassianAccountData?.extendedProfile.teamType && !localStorageTeamTypeShorthand) (0, $9yQlD.localStorageProvider).set((0, $6784cbc7d62e5d7c$export$c06666264cd35603), (0, $asmQK.mapUserSegmentationFullToShorthand)(atlassianAccountData.extendedProfile.teamType));
    return {
        isReady: !isFetching && wasFetchedOnce,
        teamType: (0, $asmQK.mapUserSegmentationFullToShorthand)(atlassianAccountData?.extendedProfile.teamType)
    };
};

});
parcelRegister("9yQlD", function(module, exports) {

$parcel$export(module.exports, "sessionStorage", () => $816fbeb16311dd64$export$f119d83aa936d634);
$parcel$export(module.exports, "sessionStorageProvider", () => $816fbeb16311dd64$export$5a24cb3021127ff7);
$parcel$export(module.exports, "localStorageProvider", () => $816fbeb16311dd64$export$aa821bfb3308a1f5);

var $bSSG7 = parcelRequire("bSSG7");

var $eNf8a = parcelRequire("eNf8a");




const $816fbeb16311dd64$export$f119d83aa936d634 = (0, $eNf8a.createSessionExpirableStorageProvider)('onboarding-core');
const $816fbeb16311dd64$export$5a24cb3021127ff7 = (0, $eNf8a.createSessionExpirableStorageProvider)('onboarding-core');
const $816fbeb16311dd64$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalExpirableStorageProvider)('onboarding-core');
const $816fbeb16311dd64$export$aa821bfb3308a1f5 = (0, $bSSG7.createLocalExpirableStorageProvider)('onboarding-core');

});

parcelRegister("asmQK", function(module, exports) {

$parcel$export(module.exports, "mapUserSegmentationFullToShorthand", () => $2244820289929c87$export$8897f7082e20c8df);

const $2244820289929c87$export$8897f7082e20c8df = (teamTypeFromMe)=>{
    switch(teamTypeFromMe){
        case 0, $6784cbc7d62e5d7c$export$e07d1fa2da8ed874:
            return 0, $6784cbc7d62e5d7c$export$572242e58bd07594;
        case 0, $6784cbc7d62e5d7c$export$76dcec3f438d9e56:
            return 0, $6784cbc7d62e5d7c$export$d7de553940261eba;
        case 0, $6784cbc7d62e5d7c$export$9a574c301f67ba30:
            return 0, $6784cbc7d62e5d7c$export$4c29d0d04c15e55d;
        case 0, $6784cbc7d62e5d7c$export$363ec144a94029c8:
            return 0, $6784cbc7d62e5d7c$export$3950f7f841bf94b6;
        case 0, $6784cbc7d62e5d7c$export$df0fb32d68ae1e78:
            return 0, $6784cbc7d62e5d7c$export$881249b988b6030f;
        case 0, $6784cbc7d62e5d7c$export$d9c0e3e59442fb4:
            return 0, $6784cbc7d62e5d7c$export$e4824f74b9879164;
        case 0, $6784cbc7d62e5d7c$export$27dbc7d7ce66e6e3:
            return 0, $6784cbc7d62e5d7c$export$4f3cb0844009af52;
        case 0, $6784cbc7d62e5d7c$export$a5dce388adf922bd:
            return 0, $6784cbc7d62e5d7c$export$1a65d50c4a641bb4;
        case 0, $6784cbc7d62e5d7c$export$e1473b31a257caff:
            return 0, $6784cbc7d62e5d7c$export$9ee64e8fbd8b03a2;
        case 0, $6784cbc7d62e5d7c$export$699265ec8ad9a740:
            return 0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b;
        case 0, $6784cbc7d62e5d7c$export$85657457db93c2c2:
            return 0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74;
        case 0, $6784cbc7d62e5d7c$export$c0c2d1dfaeba89dd:
            return 0, $6784cbc7d62e5d7c$export$79685802e8ff1098;
        case 0, $6784cbc7d62e5d7c$export$2e6a7ad3ab9c82a3:
            return 0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24;
        case 0, $6784cbc7d62e5d7c$export$7b60378c3b4372e9:
            return 0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d;
        default:
            return teamTypeFromMe;
    }
};

});

parcelRegister("2LmB4", function(module, exports) {

$parcel$export(module.exports, "actions", () => $263b01c2e713c075$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $fBogR = parcelRequire("fBogR");
const $263b01c2e713c075$export$e324594224ef24da = {
    fetchAtlassianAccountData: ({ source: source } = {})=>async ({ setState: setState, getState: getState })=>{
            const { isFetching: isFetching, wasFetchedOnce: wasFetchedOnce } = getState();
            if (isFetching || wasFetchedOnce) return;
            setState({
                isFetching: true
            });
            try {
                const data = await (0, $fBogR.getAtlassianAccountWithRethrow)({
                    source: source
                });
                if (data !== null) setState({
                    data: data
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    fetchError: error
                });
            } finally{
                setState({
                    isFetching: false,
                    wasFetchedOnce: true
                });
            }
        }
};

});
parcelRegister("fBogR", function(module, exports) {

$parcel$export(module.exports, "getAtlassianAccountWithRethrow", () => $284b5d88f7e7a408$export$1f20b0741dc598bc);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

const $284b5d88f7e7a408$export$1f20b0741dc598bc = async ({ source: source } = {})=>{
    try {
        const { extended_profile: { job_title: jobTitle, team_type: teamType }, email: email, account_id: accountId } = await (0, $eusud.performGetRequestWithRetry)((0, $53b7c6a1de61c1d4$export$80945eb3738bcee8));
        return {
            extendedProfile: {
                jobTitle: jobTitle,
                teamType: teamType
            },
            email: email,
            accountId: accountId
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'getAtlassianAccountWithRethrow',
                packageName: 'jiraAtlassianAccount',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                source: source
            },
            error: error
        });
        throw error;
    }
};

});
const $53b7c6a1de61c1d4$export$80945eb3738bcee8 = '/gateway/api/me';




parcelRegister("gQEFa", function(module, exports) {

$parcel$export(module.exports, "useFetchInitialProjectTemplateName", () => $be0087b09b981e14$export$b11629f839f2f12a);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $ggwAD = parcelRequire("ggwAD");
const $be0087b09b981e14$export$d4c72bab9d6cc13a = {};
const $be0087b09b981e14$var$store = (0, $iXqE5.createStore)({
    name: 'jira-initial-project-template-name',
    initialState: $be0087b09b981e14$export$d4c72bab9d6cc13a,
    actions: $ggwAD.actions
});
const $be0087b09b981e14$export$ee6e247e51917971 = (0, $3sQ5x.createHook)($be0087b09b981e14$var$store);
const $be0087b09b981e14$export$b11629f839f2f12a = ({ shouldFetch: shouldFetch, projectId: projectId })=>{
    const [state, { fetchInitialProjectTemplateName: fetchInitialProjectTemplateName }] = $be0087b09b981e14$export$ee6e247e51917971();
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFetch && projectId) fetchInitialProjectTemplateName(`${projectId}`);
    }, [
        fetchInitialProjectTemplateName,
        projectId,
        shouldFetch
    ]);
    if (!projectId) return {
        data: undefined,
        isReady: true
    };
    if (!shouldFetch) return {
        // Still return the data if it's already fetched
        // leave it to consumer to decide what to do with it
        data: state[`${projectId}`]?.templateKey,
        isReady: true
    };
    return {
        data: state[`${projectId}`]?.templateKey,
        isReady: state[`${projectId}`]?.fetchStatus === 'fetched'
    };
};

});
parcelRegister("ggwAD", function(module, exports) {

$parcel$export(module.exports, "actions", () => $7361e67f73cde4dc$export$e324594224ef24da);

var $2y6my = parcelRequire("2y6my");
const $7361e67f73cde4dc$export$e324594224ef24da = {
    fetchInitialProjectTemplateName: (0, $2y6my.fetchInitialProjectTemplateNameWithRethrow)
};

});
parcelRegister("2y6my", function(module, exports) {

$parcel$export(module.exports, "fetchInitialProjectTemplateNameWithRethrow", () => $a69f9ed7a08e4d60$export$c837cab65def4654);

var $1sYcL = parcelRequire("1sYcL");

var $jcw0u = parcelRequire("jcw0u");

var $5fQRY = parcelRequire("5fQRY");
const $a69f9ed7a08e4d60$export$c837cab65def4654 = (projectId)=>async ({ getState: getState, setState: setState })=>{
        try {
            const currentState = getState();
            const currentStateForProjectId = currentState[projectId];
            if (currentStateForProjectId?.fetchStatus === 'fetched' || currentStateForProjectId?.fetchStatus === 'fetching') return;
            const localStorageInitialProjectTemplateName = (0, $5fQRY.getLocalStorageInitialProjectTemplateName)({
                projectId: projectId
            });
            if (localStorageInitialProjectTemplateName) {
                setState({
                    [projectId]: {
                        fetchStatus: 'fetched',
                        templateKey: localStorageInitialProjectTemplateName
                    }
                });
                return;
            }
            setState({
                [projectId]: {
                    ...currentStateForProjectId,
                    fetchStatus: 'fetching'
                }
            });
            const response = await (0, $1sYcL.get)('', {
                consumerMeta: {
                    id: 'fetchInitialProjectTemplateNameWithRethrow',
                    packageName: '@atlassian/jira-onboarding-core',
                    teamName: 'Jlove-Makkuro'
                },
                projectId: projectId,
                projectProperties: [
                    'initial.project.template.name'
                ]
            });
            const templateKey = response?.project?.['initial.project.template.name'];
            if (templateKey) {
                (0, $5fQRY.setLocalStorageInitialProjectTemplateName)({
                    projectId: projectId,
                    templateKey: templateKey
                });
                setState({
                    [projectId]: {
                        fetchStatus: 'fetched',
                        templateKey: templateKey
                    }
                });
            } else setState({
                [projectId]: {
                    fetchStatus: 'fetched',
                    templateKey: ''
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'fetchInitialProjectTemplateNameWithRethrow',
                    packageName: 'jiraOnboardingCore',
                    teamName: 'jlove-makkuro'
                }
            });
            setState({
                [projectId]: {
                    fetchStatus: 'fetched',
                    templateKey: ''
                }
            });
        }
    };

});
parcelRegister("5fQRY", function(module, exports) {

$parcel$export(module.exports, "getLocalStorageInitialProjectTemplateName", () => $fa50145683a10f14$export$82cce58d3eca5268);
$parcel$export(module.exports, "setLocalStorageInitialProjectTemplateName", () => $fa50145683a10f14$export$8767e71370b25cc2);

var $bSSG7 = parcelRequire("bSSG7");

var $jcw0u = parcelRequire("jcw0u");
const $fa50145683a10f14$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('jira-initial-project-template-name');
const $fa50145683a10f14$export$82cce58d3eca5268 = ({ projectId: projectId })=>{
    try {
        return $fa50145683a10f14$var$localStorageProvider.get(projectId);
    } catch (error) {
        const typeGuardedError = error instanceof Error ? error : new Error('getLocalStorageInitialProjectTemplateName');
        (0, $jcw0u.default)({
            error: typeGuardedError,
            meta: {
                id: 'getLocalStorageInitialProjectTemplateName',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            }
        });
        return undefined;
    }
};
const $fa50145683a10f14$export$8767e71370b25cc2 = ({ projectId: projectId, templateKey: templateKey })=>{
    try {
        $fa50145683a10f14$var$localStorageProvider.set(projectId, templateKey);
    } catch (error) {
        const typeGuardedError = error instanceof Error ? error : new Error('localStorageSetOnboardingPersonalisationResponse');
        (0, $jcw0u.default)({
            error: typeGuardedError,
            meta: {
                id: 'localStorageSetOnboardingPersonalisationResponse',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            }
        });
    }
};

});




parcelRegister("43qGj", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $64d4caaed133b77d$export$4a39035bacc4ed76);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $4bPSV = parcelRequire("4bPSV");

var $hDSPU = parcelRequire("hDSPU");

var $iHqA4 = parcelRequire("iHqA4");

var $j8sa8 = parcelRequire("j8sa8");
const $64d4caaed133b77d$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const isEligibleForFeatureToggle = (0, $j8sa8.useShouldApplyFeatureToggle)();
    const [sidebarFeatureToggled] = (0, $hDSPU.useSidebarFeatureToggled)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $4bPSV.extractData)(data), [
        data
    ]);
    // merged feature status before navigation resource gets refreshed
    // if and only if there are features toggled and they are eligible for the feature
    const features = (0, $5uXOq.useMemo)(()=>{
        if (!extractedData || !isEligibleForFeatureToggle || !sidebarFeatureToggled) return extractedData;
        return {
            ...extractedData,
            ...sidebarFeatureToggled
        };
    }, [
        extractedData,
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    (0, $iHqA4.useClearSidebarToggled)();
    return {
        data: features,
        loading: loading,
        error: error
    };
};

});
parcelRegister("4bPSV", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $4795c1c4367ea315$export$9df5fa0a366163d2);

var $6s1PB = parcelRequire("6s1PB");
const $4795c1c4367ea315$export$9df5fa0a366163d2 = (navData)=>{
    const { permissionInfo: permissionInfo, hasBacklog: hasBacklog, hasBoard: hasBoard, hasCode: hasCode, hasGoals: hasGoals, hasGetStarted: hasGetStarted, hasSecurity: hasSecurity, hasDeployments: hasDeployments, hasDevelopment: hasDevelopment, hasList: hasList, hasOpsgenieSchedule: hasOpsgenieSchedule, hasPages: hasPages, hasReleases: hasReleases, hasRoadmap: hasRoadmap, hasReports: hasReports, hasRequests: hasRequests, hasIssues: hasIssues, hasSprint: hasSprint, hasIncidents: hasIncidents, hasCalendar: hasCalendar, hasForms: hasForms, hasSummaryPage: hasSummaryPage, aiInfo: aiInfo, hasArchivedIssues: hasArchivedIssues = false } = navData;
    const isProjectOrJiraAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    return {
        hasArchivedIssues: hasArchivedIssues,
        hasBacklog: hasBacklog,
        hasBoard: hasBoard,
        hasRoadmap: hasRoadmap,
        hasCode: hasCode,
        hasGoals: hasGoals,
        hasGetStarted: isProjectOrJiraAdmin && hasGetStarted,
        hasSecurity: hasSecurity,
        hasDeployments: hasDeployments,
        hasDevelopment: hasDevelopment,
        hasList: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation') ? hasList : false,
        hasReleases: hasReleases,
        hasSIN: hasIssues,
        hasReports: hasReports,
        hasRequests: hasRequests,
        hasPages: hasPages,
        hasOpsgenie: hasOpsgenieSchedule,
        hasShortcutsAdd: isProjectOrJiraAdmin,
        hasSettings: isProjectOrJiraAdmin,
        hasSprint: hasSprint,
        hasIncidents: hasIncidents,
        hasCalendar: hasCalendar,
        hasForms: (0, $6s1PB.expValEquals)('forms_for_jsw_experiment', 'isEnabled', true) && hasForms,
        hasSummaryPage: hasSummaryPage,
        hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true
    };
};

});

parcelRegister("hDSPU", function(module, exports) {

$parcel$export(module.exports, "useFeature", () => $605ea180d8f833cc$export$fc97652867e5867e);
$parcel$export(module.exports, "useEnablingFeature", () => $605ea180d8f833cc$export$207b461610a7fca6);
$parcel$export(module.exports, "useSidebarFeatureToggled", () => $605ea180d8f833cc$export$9eef668f94562feb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $6wyfe = parcelRequire("6wyfe");
const $605ea180d8f833cc$var$initialState = {
    features: [],
    isLoading: false,
    enablingFeatures: [],
    isFetchError: false,
    sidebarFeatureToggled: null
};
const $605ea180d8f833cc$var$store = (0, $iXqE5.createStore)({
    name: 'feature-toggle',
    initialState: $605ea180d8f833cc$var$initialState,
    actions: $6wyfe.actions
});
const $605ea180d8f833cc$export$fc97652867e5867e = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store);
const $605ea180d8f833cc$export$207b461610a7fca6 = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store, {
    selector: (state, { feature: feature })=>state.enablingFeatures.some((f)=>f === feature)
});
const $605ea180d8f833cc$export$e7699ed698eeb9ec = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store, {
    selector: (state, { feature: feature })=>state.features.find((f)=>f.feature === feature)?.state
});
const $605ea180d8f833cc$export$9eef668f94562feb = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store, {
    selector: (state)=>state.sidebarFeatureToggled
});

});
parcelRegister("6wyfe", function(module, exports) {

$parcel$export(module.exports, "actions", () => $158a47dbcbb0832b$export$e324594224ef24da);

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $8zOmE = parcelRequire("8zOmE");

var $3Jf4N = parcelRequire("3Jf4N");

var $czzsL = parcelRequire("czzsL");

var $iZZTd = parcelRequire("iZZTd");

var $ke207 = parcelRequire("ke207");
const $158a47dbcbb0832b$var$clearSiderbarFeatureToggled = ()=>({ setState: setState })=>{
        setState({
            sidebarFeatureToggled: null
        });
    };
const $158a47dbcbb0832b$var$fetchFeatures = (boardId)=>async ({ getState: getState, setState: setState })=>{
        const { features: features, isLoading: isLoading } = getState();
        if (isLoading) return;
        setState({
            isFetchError: false
        });
        try {
            if (features.length === 0) {
                setState({
                    isLoading: true
                });
                const data = await (0, $iZZTd.getBoardFeatures)(boardId);
                const filteredFeatures = (0, $czzsL.filterAndSort)(data);
                (0, $czzsL.fireErrorAnalyticsOnUnmatchFeatureKey)(filteredFeatures);
                setState({
                    isLoading: false,
                    features: filteredFeatures
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isFetchError: true,
                isLoading: false
            });
            (0, $jcw0u.default)({
                meta: {
                    ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                    id: 'fetchFeatures'
                },
                error: error
            });
        }
    };
const $158a47dbcbb0832b$var$syncFeatures = (sidebarFeatureStatus)=>({ getState: getState, setState: setState })=>{
        const { features: features } = getState();
        const featureMap = (0, $3Jf4N.getFeatureMap)({
            isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
        });
        const synced = features.map((f)=>{
            const id = f.feature;
            if (featureMap[id]) {
                const { statusKey: statusKey } = featureMap[id];
                return {
                    ...f,
                    state: sidebarFeatureStatus[statusKey] ? 'ENABLED' : 'DISABLED'
                };
            }
            return f;
        });
        setState({
            features: synced
        });
    };
const $158a47dbcbb0832b$var$updateFeature = ({ boardId: boardId, feature: feature, dependentFeature: dependentFeature, analyticsEvent: analyticsEvent, onError: onError, onAfterUpdate: onAfterUpdate })=>async ({ getState: getState, setState: setState })=>{
        const { features: features, enablingFeatures: enablingFeatures, sidebarFeatureToggled: sidebarFeatureToggled } = getState();
        let featureMap = (0, $3Jf4N.getFeatureMap)();
        if ((0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')) featureMap = {
            ...featureMap,
            ...(0, $3Jf4N.listFeature)
        };
        const currentStatus = features.find((f)=>f.feature === feature)?.state;
        const isEnabling = currentStatus === 'DISABLED';
        if (!boardId || feature.length === 0 || !currentStatus) return;
        try {
            // Optimistically update the toggle status before the API call finishes
            // and add feature to the enabling states
            setState({
                features: features.map((0, $czzsL.updateFeatureState)(feature, dependentFeature)),
                sidebarFeatureToggled: {
                    ...sidebarFeatureToggled ?? {},
                    [featureMap[feature].statusKey]: isEnabling,
                    ...dependentFeature && {
                        [featureMap[dependentFeature].statusKey]: isEnabling
                    }
                },
                ...isEnabling && {
                    enablingFeatures: [
                        ...enablingFeatures,
                        feature
                    ]
                }
            });
            await (0, $ke207.updateBoardFeature)({
                boardId: boardId,
                feature: feature,
                enabling: isEnabling
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'featureStatus updated', {
                featureId: feature,
                newStatus: currentStatus
            });
            onAfterUpdate?.(feature, isEnabling);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onError?.();
            setState({
                features: features,
                sidebarFeatureToggled: sidebarFeatureToggled
            });
            (0, $jcw0u.default)({
                meta: {
                    ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                    id: 'updateFeature'
                },
                error: error
            });
        }
        if (isEnabling) setState({
            // feature has been enabled, remove from enabling state
            enablingFeatures: getState().enablingFeatures.filter((f)=>f !== feature)
        });
    };
const $158a47dbcbb0832b$export$e324594224ef24da = {
    fetchFeatures: $158a47dbcbb0832b$var$fetchFeatures,
    updateFeature: $158a47dbcbb0832b$var$updateFeature,
    syncFeatures: $158a47dbcbb0832b$var$syncFeatures,
    clearSiderbarFeatureToggled: $158a47dbcbb0832b$var$clearSiderbarFeatureToggled
};

});
parcelRegister("3Jf4N", function(module, exports) {

$parcel$export(module.exports, "commonErrorAnalyticsMeta", () => $d07f845012e39eac$export$47825241dc3c472c);
$parcel$export(module.exports, "MANAGE_FEATURE_MENU_ITEM_TEST_ID", () => $d07f845012e39eac$export$143e1d685830adbe);
$parcel$export(module.exports, "listFeature", () => $d07f845012e39eac$export$4ddfd7a9f5527982);
$parcel$export(module.exports, "getFeatureMap", () => $d07f845012e39eac$export$6ac50cf33852adb5);
$parcel$export(module.exports, "ERROR_FLAG_ID", () => $d07f845012e39eac$export$f5e4c120ac01b615);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8QpSo = parcelRequire("8QpSo");

var $lKJPg = parcelRequire("lKJPg");

var $aqJO7 = parcelRequire("aqJO7");

var $044lR = parcelRequire("044lR");

var $cQJCJ = parcelRequire("cQJCJ");

var $f0PnG = parcelRequire("f0PnG");

var $fVgSt = parcelRequire("fVgSt");
const $d07f845012e39eac$export$47825241dc3c472c = {
    packageName: 'jiraTmpFeatureToggle',
    teamName: 'jlove-makkuro'
};
const $d07f845012e39eac$export$143e1d685830adbe = 'manage-feature-menu-item';
const $d07f845012e39eac$export$4ddfd7a9f5527982 = {
    'jsw.agility.list_view': {
        descriptionKey: 'listDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($044lR))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasList',
        order: 35,
        redirectOn: [
            'software-list'
        ]
    }
};
const $d07f845012e39eac$export$a712b1e96d47b856 = {
    'jsw.agility.simple-roadmap': {
        descriptionKey: 'timelineDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fVgSt))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasRoadmap',
        order: 10,
        redirectOn: [
            'software-timeline',
            'software-roadmap'
        ]
    },
    'jsw.agility.backlog': {
        descriptionKey: 'backlogDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lKJPg))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBacklog',
        order: 20,
        redirectOn: [
            'software-backlog'
        ]
    },
    'jsw.agility.board': {
        descriptionKey: 'boardDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqJO7))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBoard',
        order: 30
    },
    'jsw.agility.issue_navigator': {
        descriptionKey: 'issueNavigatorDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQJCJ))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasSIN',
        order: 40,
        redirectOn: [
            'software-issue-navigator',
            'issue'
        ]
    },
    'jsw.agility.sprints': {
        descriptionKey: 'releasesDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        statusKey: 'hasSprint',
        order: 50,
        isHidden: true
    }
}; // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>
const $d07f845012e39eac$export$6ac50cf33852adb5 = (0, $8QpSo.default)(({ isSimplifyNavExperimentEnabled: isSimplifyNavExperimentEnabled, isListViewEnabled: isListViewEnabled } = {})=>({
        'jsw.agility.simple-roadmap': {
            descriptionKey: 'timelineDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fVgSt))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasRoadmap',
            order: 10,
            redirectOn: [
                'software-timeline',
                'software-roadmap'
            ]
        },
        'jsw.agility.backlog': {
            descriptionKey: 'backlogDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lKJPg))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBacklog',
            order: 20,
            redirectOn: [
                'software-backlog'
            ]
        },
        'jsw.agility.board': {
            descriptionKey: 'boardDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqJO7))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBoard',
            order: 30
        },
        ...!isSimplifyNavExperimentEnabled && {
            'jsw.agility.issue_navigator': {
                descriptionKey: 'issueNavigatorDescription',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQJCJ))), {
                    spacing: "spacious",
                    label: ""
                }),
                statusKey: 'hasSIN',
                order: 40,
                redirectOn: [
                    'software-issue-navigator',
                    'issue'
                ]
            }
        },
        'jsw.agility.sprints': {
            descriptionKey: 'releasesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
            statusKey: 'hasSprint',
            order: 50,
            isHidden: true
        },
        'jsw.agility.pages': {
            descriptionKey: 'projectPagesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0PnG))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasPages',
            order: 60,
            redirectOn: [
                'project-pages'
            ]
        },
        ...isListViewEnabled && $d07f845012e39eac$export$4ddfd7a9f5527982
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))); // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>;
const $d07f845012e39eac$export$f5e4c120ac01b615 = 'feature-toggle-error-flag';

});

parcelRegister("czzsL", function(module, exports) {

$parcel$export(module.exports, "filterAndSort", () => $0a04151ee5a00965$export$d0e0de50c701304c);
$parcel$export(module.exports, "findDependentFeature", () => $0a04151ee5a00965$export$4c8205136225a4e2);
$parcel$export(module.exports, "updateFeatureState", () => $0a04151ee5a00965$export$2bdeae30201d513c);
$parcel$export(module.exports, "fireErrorAnalyticsOnUnmatchFeatureKey", () => $0a04151ee5a00965$export$5da1e8c5ba5c0dc2);

var $hqTkp = parcelRequire("hqTkp");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $3Jf4N = parcelRequire("3Jf4N");
const $0a04151ee5a00965$export$b70265791d2079d4 = (hasFeature)=>hasFeature ? 'ENABLED' : 'DISABLED';
const $0a04151ee5a00965$export$d0e0de50c701304c = (features)=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    const featureMap = (0, $3Jf4N.getFeatureMap)({
        isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
        isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
    });
    return features.filter((f)=>Object.keys(featureMap).includes(f.feature)).sort((a, b)=>featureMap[a.feature].order - featureMap[b.feature].order);
};
const $0a04151ee5a00965$export$4c8205136225a4e2 = (features, featureId)=>{
    const featureToDisable = features.find((f)=>f.feature === featureId);
    // Will only show the modal when the current status is enabled for both the feature to disable and the dependent feature
    if (featureToDisable?.state !== 'ENABLED') return undefined;
    // For the scope of the feature toggle, we assume there is only one dependency for now
    return features.find((f)=>f.prerequisites.includes(featureId) && f.state === 'ENABLED');
};
const $0a04151ee5a00965$export$2bdeae30201d513c = (featureId, dependentFeatureId)=>(feature)=>feature.feature === featureId || dependentFeatureId && feature.feature === dependentFeatureId ? {
            ...feature,
            state: feature.state === 'ENABLED' ? 'DISABLED' : 'ENABLED'
        } : feature;
const $0a04151ee5a00965$export$5da1e8c5ba5c0dc2 = (filteredFeatures)=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    const featureMap = (0, $3Jf4N.getFeatureMap)({
        isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
        isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
    });
    if (filteredFeatures.length < Object.keys(featureMap).length) {
        const unmatchedFeatureKeys = (0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(Object.keys(featureMap), ...filteredFeatures.map((f)=>f.feature));
        (0, $jcw0u.default)({
            error: new Error("Some feature keys don't match . Please check API response"),
            meta: {
                ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                id: 'unmatchFeatureKey'
            },
            attributes: {
                unmatchedFeatureKeys: unmatchedFeatureKeys.toString()
            }
        });
    }
};

});

parcelRegister("iZZTd", function(module, exports) {

$parcel$export(module.exports, "getBoardFeatures", () => $140b4a0769fd2090$export$c20100b185d41ab0);

var $eusud = parcelRequire("eusud");

var $8djOx = parcelRequire("8djOx");
const $140b4a0769fd2090$export$c20100b185d41ab0 = async (boardId)=>{
    const data = await (0, $eusud.performGetRequest)((0, $8djOx.getBoardFeaturesUrl)(boardId));
    return data.features;
};

});
parcelRegister("8djOx", function(module, exports) {

$parcel$export(module.exports, "getBoardFeaturesUrl", () => $45a3789113fa4e8b$export$3f9939d302766b52);
const $45a3789113fa4e8b$export$3f9939d302766b52 = (boardId)=>`/rest/agile/latest/board/${boardId}/features`;

});


parcelRegister("ke207", function(module, exports) {

$parcel$export(module.exports, "updateBoardFeature", () => $1ce9149bd154bcf9$export$61f6bbb745b3a3);

var $eusud = parcelRequire("eusud");

var $8djOx = parcelRequire("8djOx");
const $1ce9149bd154bcf9$export$61f6bbb745b3a3 = async (request)=>{
    // it returns the board features array, but we don't use it for optimistic update
    // feature state is used instead to indicate if the updates successful or not
    const data = await (0, $eusud.performPutRequest)((0, $8djOx.getBoardFeaturesUrl)(request.boardId), {
        body: JSON.stringify(request)
    });
    const newState = data.features.find((f)=>f.feature === request.feature)?.state;
    return newState ?? (request.enabling ? 'ENABLED' : 'DISABLED');
};

});



parcelRegister("iHqA4", function(module, exports) {

$parcel$export(module.exports, "useClearSidebarToggled", () => $b80f211a69d994c6$export$2946f555c6f48127);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $1J3t1 = parcelRequire("1J3t1");

var $1XJ20 = parcelRequire("1XJ20");

var $hDSPU = parcelRequire("hDSPU");

var $j8sa8 = parcelRequire("j8sa8");
const $b80f211a69d994c6$export$2946f555c6f48127 = ()=>{
    const { data: data, refresh: refresh } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const [sidebarFeatureToggled, { clearSiderbarFeatureToggled: clearSiderbarFeatureToggled }] = (0, $hDSPU.useSidebarFeatureToggled)();
    const isEligibleForFeatureToggle = (0, $j8sa8.useShouldApplyFeatureToggle)();
    const sidebarHasChanged = (0, $5uXOq.useRef)(false);
    const previousData = (0, $1XJ20.usePreviousWithInitial)(data);
    // if resource data has changed since the last refresh then remove the sidebar toggled data.
    // i.e. whatever that has been toggled is reflected on the latest resource
    const shouldClear = (0, $5uXOq.useMemo)(()=>isEligibleForFeatureToggle && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(previousData, data), [
        isEligibleForFeatureToggle,
        previousData,
        data
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldClear) clearSiderbarFeatureToggled();
    }, [
        shouldClear,
        clearSiderbarFeatureToggled
    ]);
    (0, $5uXOq.useEffect)(()=>{
        sidebarHasChanged.current = isEligibleForFeatureToggle && !!sidebarFeatureToggled;
    }, [
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    // refresh the navigation resource if sidebar has changed
    (0, $5uXOq.useEffect)(()=>()=>{
            if (sidebarHasChanged.current) refresh();
        }, [
        refresh
    ]);
};

});
parcelRegister("1XJ20", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $011794d66b906d20$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousWithInitial", () => $011794d66b906d20$export$23fbbb2e62c4a911);

var $5uXOq = parcelRequire("5uXOq");
const $011794d66b906d20$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $011794d66b906d20$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $5uXOq.useRef)(value);
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});

parcelRegister("j8sa8", function(module, exports) {

$parcel$export(module.exports, "useShouldApplyFeatureToggle", () => $d568e02a383436d9$export$7deca16ba2d9eb74);

var $2vSU6 = parcelRequire("2vSU6");

var $dAfqg = parcelRequire("dAfqg");

var $dkqym = parcelRequire("dkqym");
const $d568e02a383436d9$export$7deca16ba2d9eb74 = ()=>{
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const firstActivationDateMs = (0, $dkqym.useFirstActivationDateMs)() || 0;
    const isJSW = project?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const isTMP = !!project?.simplified;
    const isProjectAdmin = !!project?.isProjectAdmin;
    const isNewInstance = new Date(firstActivationDateMs) >= new Date('2023-09-25T15:00:00');
    return isJSW && isTMP && isProjectAdmin && isNewInstance;
};

});
parcelRegister("dkqym", function(module, exports) {

$parcel$export(module.exports, "useFirstActivationDateMs", () => $61794ef454831b86$export$9df3a539e50a284b);

var $9OXo1 = parcelRequire("9OXo1");
const $61794ef454831b86$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});





parcelRegister("at1Nr", function(module, exports) {

$parcel$export(module.exports, "InviteTeamNudgeAsync", () => $8b5bfc2ae277a997$export$a4b4061b22dbc897);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");


var $cE2Qr = parcelRequire("cE2Qr");


var $ahfXN = parcelRequire("ahfXN");
const $8b5bfc2ae277a997$var$runtimeProps = {};
const $8b5bfc2ae277a997$var$entryPointParams = {};
const $8b5bfc2ae277a997$export$a4b4061b22dbc897 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $ahfXN.inviteTeamNudgeEntryPoint), $8b5bfc2ae277a997$var$entryPointParams);
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const [hasNudgeActive] = (0, $cE2Qr.useHasNudgeActive)();
    const firstLoadRef = (0, $5uXOq.useRef)(true);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (firstLoadRef.current && hasNudgeActive && nudgeStep === (0, $6784cbc7d62e5d7c$export$77bc79debbf5c069)) {
            entryPointActions.load();
            firstLoadRef.current = false;
        }
    }, [
        entryPointActions,
        hasNudgeActive,
        nudgeStep
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: (0, $dbbf68c32d8c4308$export$3bc551fe07069f89),
        packageName: "jiraInviteTeamOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: $8b5bfc2ae277a997$var$runtimeProps
    });
};

});
const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$2ef41782ca91324c = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';
const $dbbf68c32d8c4308$export$fb4f98ca3ff0420 = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$b7fd448c62b5fb97 = 'listview';
const $dbbf68c32d8c4308$export$10c63dc5c09466d2 = 'boardview';
const $dbbf68c32d8c4308$export$6b4730ba54660efa = 'nonSoftwareKanbanSampleDataBoardNudge';
const $dbbf68c32d8c4308$export$d6dc8780b646536f = 'nonSoftwareKanbanSampleDataNudge';

parcelRegister("ahfXN", function(module, exports) {

$parcel$export(module.exports, "inviteTeamNudgeEntryPoint", () => $140395164e9a1c0c$export$ff76bc343b4103b1);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $140395164e9a1c0c$export$ff76bc343b4103b1 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("jDSj4")), {
        moduleId: "4ca4d8af"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jDSj4", function(module, exports) {

let $e4cbc901cec8406b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e4cbc901cec8406b$var$load("il1NS").then(()=>parcelRequire('guBtq'));

});



parcelRegister("eXCTi", function(module, exports) {

$parcel$export(module.exports, "default", () => $93106a52315d7964$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $93106a52315d7964$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addButton: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-teams.common.action-buttons.add-button",
        "defaultMessage": "Create or invite"
    },
    createTeam: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-teams.common.action-buttons.create-team",
        "defaultMessage": "Create a team"
    },
    invitePeople: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-teams.common.action-buttons.invite-people",
        "defaultMessage": "Invite people"
    }
});

});

parcelRegister("eA0nk", function(module, exports) {

$parcel$export(module.exports, "useCreateTeamModal", () => $7ef2ce65db55ab3d$export$5458b68a653f4bfe);

var $5uXOq = parcelRequire("5uXOq");

var $2AtjH = parcelRequire("2AtjH");

var $pa9q9 = parcelRequire("pa9q9");

var $1wpPp = parcelRequire("1wpPp");

var $4ywcn = parcelRequire("4ywcn");

var $8igKv = parcelRequire("8igKv");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $cYlk7 = parcelRequire("cYlk7");

var $14XJw = parcelRequire("14XJw");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $goAXv = parcelRequire("goAXv");

var $b7Svb = parcelRequire("b7Svb");

var $lVJAU = parcelRequire("lVJAU");

// Relay entry point is not applicable here because this component does not live in jira frontend.
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7ef2ce65db55ab3d$var$LazyTeamCreateDialog = (0, $b7Svb.lazy)(()=>(parcelRequire("2VuRy")).then(({ TeamCreateDialog: TeamCreateDialog })=>TeamCreateDialog), {
    moduleId: "../platform/packages/people-and-teams/people-teams/src/index.ts"
});
const $7ef2ce65db55ab3d$export$5458b68a653f4bfe = ()=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { locale: locale } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { data: { user: user } } = (0, $cYlk7.useCurrentUser)();
    const atlassianAccountId = (0, $90yGq.useAccountId)() || user.accountId;
    const pushRoute = (0, $5uXOq.useCallback)((url)=>push(url), [
        push
    ]);
    const addFlag = (0, $5uXOq.useCallback)(({ appearance: appearance, ...flagProps })=>{
        const Flag = $7ef2ce65db55ab3d$var$getFlagComponent(appearance);
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Flag, {
                ...flagProps,
                ...serviceProps,
                messageId: `navigation-apps-sidebar-nav4-sidebars-content-teams.ui.use-create-team-modal.flag.showFlag.${appearance}.${flagProps.id}`,
                messageType: "engagement"
            }));
    }, [
        showFlag
    ]);
    const callback = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    if (!atlassianAccountId) throw new Error('Missing current user id');
    return [
        isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "team-create-dialog"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $goAXv.PeopleAndTeamsConfigurationProvider), {
            product: "jira",
            locale: (0, $2AtjH.default)(locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7ef2ce65db55ab3d$var$LazyTeamCreateDialog, {
            pushRoute: pushRoute,
            cloudId: cloudId,
            orgId: orgId,
            product: "jira",
            principalId: atlassianAccountId,
            onClose: ()=>setIsOpen(false),
            enableMembershipSettingsChoice: true,
            currentUser: user.accountId ? {
                id: user.accountId,
                fullName: user.userFullname,
                // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                email: user.emailAddress !== undefined ? user.emailAddress : '',
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
                nickname: user.userFullname
            } : undefined,
            addFlag: addFlag
        }))) : null,
        callback
    ];
};
const $7ef2ce65db55ab3d$var$getFlagComponent = (appearance)=>{
    switch(appearance){
        case 'warning':
            return 0, $8igKv.default;
        case 'error':
            return 0, $1wpPp.default;
        case 'success':
        case 'normal':
        default:
            return 0, $4ywcn.default;
    }
};

});

parcelRegister("fxSv8", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleModal", () => $bef8b2441fc0fca4$export$b9ec44715ae5ad99);

var $5uXOq = parcelRequire("5uXOq");

var $lhDyE = parcelRequire("lhDyE");

var $pa9q9 = parcelRequire("pa9q9");

var $1wpPp = parcelRequire("1wpPp");

var $4ywcn = parcelRequire("4ywcn");

var $8igKv = parcelRequire("8igKv");

var $eIokK = parcelRequire("eIokK");

var $1J3t1 = parcelRequire("1J3t1");

var $14XJw = parcelRequire("14XJw");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");

var $6s1PB = parcelRequire("6s1PB");

var $cYlk7 = parcelRequire("cYlk7");
const $bef8b2441fc0fca4$var$isNthUserOnBoardingProjectRecommendationEnabled = ()=>{
    const [config] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_nth_user_onboarding_proj_recommendation');
    return config.get('isEnabled', false);
};
const $bef8b2441fc0fca4$export$b9ec44715ae5ad99 = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { data: projectSidebarNavigationData } = (0, $1J3t1.useProjectSidebarNavigation)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { software: software } = (0, $k9JTq.useAppEditions)();
    const { data: currentUser } = (0, $cYlk7.useCurrentUser)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let continueUrl = window.location.href;
    if ($bef8b2441fc0fca4$var$isNthUserOnBoardingProjectRecommendationEnabled() && currentUser?.user?.accountId) {
        const queryParams = new URLSearchParams({
            inviterId: currentUser.user.accountId
        });
        continueUrl += `?${queryParams.toString()}`;
    }
    const subProduct = (0, $eIokK.projectTypeToSubProduct)(projectSidebarNavigationData?.projectType);
    const addFlag = (0, $5uXOq.useCallback)(({ appearance: appearance, ...flagProps })=>{
        const Flag = $bef8b2441fc0fca4$var$getFlagComponent(appearance);
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Flag, {
                ...flagProps,
                ...serviceProps,
                messageId: `navigation-apps-sidebar-nav4-sidebars-content-teams.ui.flag.showFlag.${appearance}.${flagProps.id}`,
                messageType: "transactional"
            }));
    }, [
        showFlag
    ]);
    const { openModal: invitePeopleModalTrigger } = (0, $lhDyE.useInvitePeopleModal)({
        continueUrl: continueUrl,
        enableThirdParty: true,
        displayInfiSpotlight: true,
        orgId: orgId,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        showFlag: addFlag,
        source: 'peopleMenu',
        subProduct: subProduct,
        experimental_applicationEdition: software,
        navigation: {
            directoryContextEntryPoint: '/jira'
        },
        onSubmit: async (data)=>{
            await data.defaultOnSubmit();
        }
    });
    return invitePeopleModalTrigger;
};
const $bef8b2441fc0fca4$var$getFlagComponent = (appearance)=>{
    switch(appearance){
        case 'warning':
            return 0, $8igKv.default;
        case 'error':
            return 0, $1wpPp.default;
        case 'success':
        case 'normal':
        default:
            return 0, $4ywcn.default;
    }
};

});
parcelRegister("eIokK", function(module, exports) {

$parcel$export(module.exports, "stripUrlToIssueKey", () => $2ca77bef45d99b5b$export$1f3c6284caef177b);
$parcel$export(module.exports, "useInvitePeopleFlags", () => $2ca77bef45d99b5b$export$ab5fb7206b83c9ad);
$parcel$export(module.exports, "projectTypeToSubProduct", () => $2ca77bef45d99b5b$export$3500077858760067);
$parcel$export(module.exports, "jiraProjectTypeToSubProduct", () => $2ca77bef45d99b5b$export$9ce9c3ad0c2c5c71);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $1wpPp = parcelRequire("1wpPp");

var $g9eN3 = parcelRequire("g9eN3");

var $4ywcn = parcelRequire("4ywcn");

var $8igKv = parcelRequire("8igKv");
const $2ca77bef45d99b5b$var$ISSUE_KEY_REGEXP = /(([A-Z][A-Z0-9]+)-([0-9]+))($|\?.*)/;
const $2ca77bef45d99b5b$export$1f3c6284caef177b = (candidateUrl)=>{
    const match = candidateUrl.match($2ca77bef45d99b5b$var$ISSUE_KEY_REGEXP);
    return match && match[1];
};
const $2ca77bef45d99b5b$export$ab5fb7206b83c9ad = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const addFlag = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'appearance' implicitly has an 'any' type.
    ({ appearance: appearance, ...flagProps })=>{
        let FlagComponent = (0, $g9eN3.default);
        // eslint-disable-next-line default-case
        switch(appearance){
            case 'success':
            case 'normal':
                FlagComponent = (0, $4ywcn.default);
                break;
            case 'warning':
                FlagComponent = (0, $8igKv.default);
                break;
            case 'error':
                FlagComponent = (0, $1wpPp.default);
                break;
        }
        showFlag((serviceProps)=>{
            const props = {
                ...flagProps,
                ...serviceProps,
                messageId: `invite-people-drawer.ui.content.flag-component.${appearance}.${flagProps.id}`,
                messageType: 'transactional'
            };
            // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FlagComponent, props);
        });
    }, [
        showFlag
    ]);
    return {
        addFlag: addFlag
    };
};
const $2ca77bef45d99b5b$export$3500077858760067 = (projectType)=>{
    switch(projectType){
        case 'jira_software':
            return 'software';
        case 'jira_service_management':
            return 'servicedesk';
        case 'jira_work_management':
            return 'core';
        case 'jira_product_discovery':
            return 'product-discovery';
        default:
            return undefined;
    }
};
const $2ca77bef45d99b5b$export$9ce9c3ad0c2c5c71 = (projectType)=>{
    switch(projectType){
        case 'software':
            return 'software';
        case 'service_desk':
            return 'servicedesk';
        case 'business':
            return 'core';
        case 'product_discovery':
            return 'product-discovery';
        default:
            return undefined;
    }
};

});
parcelRegister("g9eN3", function(module, exports) {

$parcel$export(module.exports, "default", () => $100aabc6f0d895d9$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$100aabc6f0d895d9$export$2e2bcd8739ae039 = (0, $3KRpp.InfoFlag);

});





parcelRegister("3cFRo", function(module, exports) {

$parcel$export(module.exports, "Stub", () => $39abac17a0bf23b3$export$1ab0b9ce3cf276f8);

var $5uXOq = parcelRequire("5uXOq");

var $aOrxC = parcelRequire("aOrxC");




var $jecJ3 = parcelRequire("jecJ3");

var $ivGSs = parcelRequire("ivGSs");

var $46Cti = parcelRequire("46Cti");

var $eQV8d = parcelRequire("eQV8d");

var $dUyqZ = parcelRequire("dUyqZ");

var $eaKdt = parcelRequire("eaKdt");

var $aCS3f = parcelRequire("aCS3f");


var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $ctUNb = parcelRequire("ctUNb");

var $3TY9o = parcelRequire("3TY9o");
const $39abac17a0bf23b3$export$1ab0b9ce3cf276f8 = ({ menuId: menuId, href: href })=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)(menuId);
    const location = (0, $3TY9o.useLocation)();
    const path = location.pathname + location.search;
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctUNb.MenuLinkItem), {
        elemBefore: icon,
        href: href,
        isSelected: path === href,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($39abac17a0bf23b3$var$ActionButtons, {
            menuId: menuId
        }),
        onClick: ()=>{
            if (menuId === (0, $46Cti.L1_MENU_ID).TEAMS) sendSectionItemAnalyticsEvent({
                menuId: (0, $46Cti.L1_MENU_ID).TEAMS,
                sectionItem: (0, $jecJ3.SECTION_ITEM_TEAMS)
            });
        }
    }, formattedMessage);
};
function $39abac17a0bf23b3$var$ActionButtons({ menuId: menuId }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCS3f.MoreNavMenuButton), {
        onOpen: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6),
                actionSubjectId: (0, $ivGSs.MENU_ID_ANALYTIC_EVENT_IDS)[menuId],
                attributes: {
                    level: (0, $951a0ed422513987$export$265c523d1a8f25cf),
                    componentType: (0, $1e554a683893bd46$export$95b0c331af13d819),
                    itemId: (0, $ddbe4b334e21c7a1$export$f06dfcec5ff912e)
                }
            });
        },
        MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaKdt.HideL1MenuItemSection), {
                menuId: menuId,
                hasSeparator: false
            }))
    });
}

});


parcelRegister("cam2y", function(module, exports) {

$parcel$export(module.exports, "useFilterL1MenuItemsByEditionAndLicense", () => $7076df34d12ead42$export$bf04108d78a3abbe);

var $5uXOq = parcelRequire("5uXOq");

var $8J6rn = parcelRequire("8J6rn");

var $4R6GH = parcelRequire("4R6GH");

var $46Cti = parcelRequire("46Cti");

var $jYFkU = parcelRequire("jYFkU");

var $iKHgp = parcelRequire("iKHgp");

var $h9iZl = parcelRequire("h9iZl");

var $dWQF5 = parcelRequire("dWQF5");

var $a6FNA = parcelRequire("a6FNA");

var $crxHy = parcelRequire("crxHy");

var $eUfQ2 = parcelRequire("eUfQ2");
const $7076df34d12ead42$export$bf04108d78a3abbe = (navItems)=>{
    const showAssets = (0, $jYFkU.useShowAssets)();
    const { shouldUseJSM: shouldUseJSM } = (0, $8J6rn.useOgTenantInfo)();
    const shouldShowRoadmaps = (0, $dWQF5.useIsCrossProjectViewsEnabled)();
    const shouldRenderOverviews = (0, $iKHgp.useShouldRenderOverviews)();
    const [shouldRenderPlans] = (0, $h9iZl.useNavigationPlansVisibility)();
    const showCustomerService = (0, $a6FNA.useShowCustomerService)();
    const showCustomerServiceAnalytics = (0, $crxHy.useShowCustomerServiceAnalytics)();
    const { goals: goals, assets: assets } = (0, $eUfQ2.useGlobalApps)();
    return (0, $5uXOq.useMemo)(()=>navItems.filter(({ menuId: menuId })=>{
            if (menuId === (0, $46Cti.L1_MENU_ID).OPERATIONS) return shouldUseJSM;
            if (menuId === (0, $46Cti.L1_MENU_ID).ASSETS) /* remove this on
					 * blu-6313_sidebar_global_app_shortcuts cleanup &&
					 * assets_as_an_app_v2 cleanup &&
					 * blu-6576_migrate_to_platform_customisation cleanup
					 *
					 * Should hide the L1 Assets menu item when the asset shortcut is present
					 */ return showAssets && !assets;
            if (menuId === (0, $46Cti.L1_MENU_ID).ROADMAPS) return shouldShowRoadmaps;
            if (menuId === (0, $46Cti.L1_MENU_ID).OVERVIEWS) return (0, $4R6GH.fg)('blu-2858-sidebar-menu-overviews') && shouldRenderOverviews;
            if (menuId === (0, $46Cti.L1_MENU_ID).PLANS) return shouldRenderPlans;
            if (menuId === (0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS) return showCustomerServiceAnalytics;
            // See https://jplat.jira.atlassian.cloud/browse/BLU-3307
            // For the Dogfooding phase of Nav4 we are going to intentionally hide the Goals menu item.
            // This if block should be removed when we work on https://jplat.jira.atlassian.cloud/browse/BLU-3261
            // as we will know the correct URL for the Goals menu item at that point.
            if (menuId === (0, $46Cti.L1_MENU_ID).GOALS) return false;
            if (menuId === (0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE) return showCustomerService;
            if (menuId === (0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS) return assets;
            if (menuId === (0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS) return goals;
            return true;
        }), [
        navItems,
        shouldUseJSM,
        showAssets,
        shouldShowRoadmaps,
        shouldRenderOverviews,
        shouldRenderPlans,
        showCustomerService,
        showCustomerServiceAnalytics,
        goals,
        assets
    ]);
};

});
parcelRegister("jYFkU", function(module, exports) {

$parcel$export(module.exports, "useShowAssets", () => $e8ba161523dca261$export$6d1797fe1bb33b7a);

var $ktP1V = parcelRequire("ktP1V");

var $9OXo1 = parcelRequire("9OXo1");
function $e8ba161523dca261$export$6d1797fe1bb33b7a() {
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    const isJSMUser = appPermissions.hasServiceDeskAccess;
    if ((0, $ktP1V.isCMDBEnabledInEnvironment)() && isJSMUser) return true;
    return false;
}

});

parcelRegister("dWQF5", function(module, exports) {

$parcel$export(module.exports, "useIsPremiumEdition", () => $901349e77566565e$export$8aa8a7878fd61770);
$parcel$export(module.exports, "useIsViewPermissionsEnabled", () => $901349e77566565e$export$a94405ffcb20c356);
$parcel$export(module.exports, "useIsCrossProjectViewsEnabled", () => $901349e77566565e$export$34d097b1cd6f89c1);
$parcel$export(module.exports, "useIsConnectionsEnabled", () => $901349e77566565e$export$304793dd2c5f4db0);

var $4R6GH = parcelRequire("4R6GH");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");
const $901349e77566565e$export$8aa8a7878fd61770 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    if ((0, $4R6GH.fg)('polaris_force-premium')) return true;
    const jpdEdition = (0, $ldyPw.getEdition)((0, $efvDm.JIRA_PRODUCT_DISCOVERY), appEditions);
    // TODO: POL-10089 use entitlements instead of the edition when it will be available
    return jpdEdition === (0, $ldyPw.toEdition)((0, $ldyPw.PREMIUM_EDITION));
};
const $901349e77566565e$export$a94405ffcb20c356 = ()=>{
    const isPremium = $901349e77566565e$export$8aa8a7878fd61770();
    return isPremium;
};
const $901349e77566565e$export$34d097b1cd6f89c1 = ()=>{
    const isPremium = $901349e77566565e$export$8aa8a7878fd61770();
    return isPremium;
};
const $901349e77566565e$export$304793dd2c5f4db0 = ()=>{
    const isPremium = $901349e77566565e$export$8aa8a7878fd61770();
    if (!(0, $4R6GH.fg)('jpd_issues_relationships')) return false;
    if ((0, $4R6GH.fg)('jpd_issues_relationships_eap_lighthouse_customer')) return true;
    return isPremium;
};

});

parcelRegister("a6FNA", function(module, exports) {

$parcel$export(module.exports, "useShowCustomerService", () => $022d7dbb7d3dace6$export$e760a809f2958bc7);

var $4R6GH = parcelRequire("4R6GH");

var $itmJb = parcelRequire("itmJb");

var $daoB1 = parcelRequire("daoB1");
const $022d7dbb7d3dace6$export$e760a809f2958bc7 = ()=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $daoB1.useApplicationPermissions)();
    return (0, $4R6GH.fg)('jcs_master_flag') && (isAdmin || hasServiceDeskAccess);
};

});

parcelRegister("crxHy", function(module, exports) {

$parcel$export(module.exports, "useShowCustomerServiceAnalytics", () => $aaa491f1440cfff7$export$4aaa66e80d627346);

var $4R6GH = parcelRequire("4R6GH");

var $itmJb = parcelRequire("itmJb");

var $daoB1 = parcelRequire("daoB1");
const $aaa491f1440cfff7$export$4aaa66e80d627346 = ()=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $daoB1.useApplicationPermissions)();
    return (0, $4R6GH.fg)('jcs-analytics-page') && (isAdmin || hasServiceDeskAccess);
};

});


parcelRegister("jM4TX", function(module, exports) {

$parcel$export(module.exports, "useRefreshL1MenuItems", () => $c458e653f6eae5e5$export$6f30ce19c2e3e4c0);

var $5uXOq = parcelRequire("5uXOq");

var $k8IPx = parcelRequire("k8IPx");

var $1zjdl = parcelRequire("1zjdl");
const $c458e653f6eae5e5$export$6f30ce19c2e3e4c0 = (navItems = [])=>(0, $5uXOq.useMemo)(()=>{
        const missingMenuIds = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))((0, $1zjdl.USER_NAVIGATION_CONFIGURATION_DEFAULT_MENU_IDS), navItems.map(({ menuId: menuId })=>menuId));
        return [
            ...navItems,
            ...missingMenuIds.map((menuId)=>({
                    menuId: menuId,
                    isVisible: true
                }))
        ];
    }, [
        navItems
    ]);

});
parcelRegister("k8IPx", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $ekcP3 = parcelRequire("ekcP3");

var $g7i7g = parcelRequire("g7i7g");

var $f3SOL = parcelRequire("f3SOL");
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var $ea975459f1938a58$var$difference = $g7i7g(function(array, values) {
    return $f3SOL(array) ? $55pzo(array, $ekcP3(values, 1, $f3SOL, true)) : [];
});
module.exports = $ea975459f1938a58$var$difference;

});


parcelRegister("i98eP", function(module, exports) {

$parcel$export(module.exports, "MoreMenuIsOpenContextProvider", () => $b1de343b331e2d66$export$d11e004ed91611ce);

var $5uXOq = parcelRequire("5uXOq");

var $5xBN5 = parcelRequire("5xBN5");
const $b1de343b331e2d66$export$d11e004ed91611ce = ({ children: children })=>{
    const [moreMenuIsOpen, setMoreMenuIsOpen] = (0, $5uXOq.useState)(false);
    const moreMenuIsOpenContext = (0, $5uXOq.useMemo)(()=>({
            moreMenuIsOpen: moreMenuIsOpen,
            setMoreMenuIsOpen: setMoreMenuIsOpen
        }), [
        moreMenuIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5xBN5.MoreMenuIsOpenContext).Provider, {
        value: moreMenuIsOpenContext
    }, children);
};

});
parcelRegister("5xBN5", function(module, exports) {

$parcel$export(module.exports, "MoreMenuIsOpenContext", () => $5118c303d0e915f1$export$8888ac4b19e27f70);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");
const $5118c303d0e915f1$export$8888ac4b19e27f70 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    moreMenuIsOpen: false,
    setMoreMenuIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});

});


parcelRegister("1tKM7", function(module, exports) {

$parcel$export(module.exports, "SidebarCustomization", () => $93b4a8f63ccc708d$export$64f537f23c5bcad6);

var $5uXOq = parcelRequire("5uXOq");

var $jecJ3 = parcelRequire("jecJ3");

var $iszzG = parcelRequire("iszzG");

var $eQV8d = parcelRequire("eQV8d");

var $bdN0K = parcelRequire("bdN0K");

var $71X8q = parcelRequire("71X8q");

var $cSD7y = parcelRequire("cSD7y");

var $koVbs = parcelRequire("koVbs");

var $5xBN5 = parcelRequire("5xBN5");

var $cscSc = parcelRequire("cscSc");

var $hFGs5 = parcelRequire("hFGs5");

var $9Qut3 = parcelRequire("9Qut3");

var $hBVbZ = parcelRequire("hBVbZ");

var $h3Slk = parcelRequire("h3Slk");
function $93b4a8f63ccc708d$export$81bc85d21ba7b277({ navItems: navItems, menuData: menuData }) {
    const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, $iszzG.NavItemsContext));
    const { peekMenuId: peekMenuId, setPeekMenuId: setPeekMenuId } = (0, $5uXOq.useContext)((0, $iszzG.PeekMenuIdContext));
    const { moreMenuIsOpen: moreMenuIsOpen, setMoreMenuIsOpen: setMoreMenuIsOpen } = (0, $5uXOq.useContext)((0, $5xBN5.MoreMenuIsOpenContext));
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const handleMenuClose = (0, $5uXOq.useCallback)(()=>setMoreMenuIsOpen(false), [
        setMoreMenuIsOpen
    ]);
    const handleMenuToggle = (0, $5uXOq.useCallback)(()=>{
        setMoreMenuIsOpen((value)=>!value);
        sendSectionItemAnalyticsEvent({
            sectionItem: (0, $jecJ3.SECTION_ITEM_MORE)
        });
    }, [
        sendSectionItemAnalyticsEvent,
        setMoreMenuIsOpen
    ]);
    const MenuItems = [
        ({ onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, moreMenuIds.filter((menuId)=>menuId !== peekMenuId).map((menuId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hFGs5.MenuItem), {
                    key: menuId,
                    menuId: menuId,
                    onClick: (e)=>{
                        setPeekMenuId(menuId);
                        onClose?.(e);
                        sendSectionItemAnalyticsEvent({
                            menuId: menuId,
                            sectionItem: (0, $jecJ3.SECTION_ITEM_MAP)[menuId]
                        });
                    }
                }))),
        ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cscSc.CustomiseSidebar), {
                navItems: navItems
            })
    ];
    return moreMenuIds.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cscSc.CustomiseSidebar), {
        navItems: navItems
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Qut3.PeekMenuItem), {
        menuData: menuData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bdN0K.L1MoreNavMenuItem), {
        MenuItems: MenuItems,
        isOpen: moreMenuIsOpen,
        onClose: handleMenuClose,
        onToggle: handleMenuToggle
    }));
}
function $93b4a8f63ccc708d$export$3aa279c25b4c1532({ menuData: menuData, productItemsData: productItemsData, appItemsData: appItemsData }) {
    const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, $iszzG.NavItemsContext));
    const { peekMenuId: peekMenuId } = (0, $5uXOq.useContext)((0, $iszzG.PeekMenuIdContext));
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return moreMenuIds.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h3Slk.CustomizeSidebar), {
        productItemsData: productItemsData,
        appItemsData: appItemsData
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Qut3.PeekMenuItem), {
        menuData: menuData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $71X8q.GlobalMoreMenu), {
        productItemsData: productItemsData,
        appItemsData: appItemsData,
        menuItemComponent: (0, $hFGs5.MoreMenuItem),
        customizeSidebarMenuItem: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h3Slk.CustomizeSidebar), {
            productItemsData: productItemsData,
            appItemsData: appItemsData
        }),
        moreMenuItemLabel: formatMessage((0, $hBVbZ.default).more),
        peekingMenuIds: peekMenuId ? [
            peekMenuId
        ] : undefined,
        onClickMoreMenuTrigger: ()=>sendSectionItemAnalyticsEvent({
                sectionItem: (0, $jecJ3.SECTION_ITEM_MORE)
            })
    }));
}
const $93b4a8f63ccc708d$export$64f537f23c5bcad6 = (0, $cSD7y.componentWithFG)('blu-6576_migrate_to_platform_customisation', $93b4a8f63ccc708d$export$3aa279c25b4c1532, $93b4a8f63ccc708d$export$81bc85d21ba7b277);

});
parcelRegister("bdN0K", function(module, exports) {

$parcel$export(module.exports, "L1MoreNavMenuItem", () => $37dcbc182b0ae871$export$4c0f8320eb6cf210);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $54SNu = parcelRequire("54SNu");
// The output for the submenu when in sidenav-expanded mode vs flyout mode is slightly different.
// They're here together as isolated components for clarity, so if this changes in the future
// we can easily see that they're now the same and maybe we can adjust what's passed down from the MoreMenu component;
// e.g. we may not need to pass an array if we can just pass one identical component for both use cases.
const $37dcbc182b0ae871$var$L1MoreNavMenuItemSubmenu = ({ MenuItems: MenuItems, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $37dcbc182b0ae871$var$menuGroupWrapperStyles
    }, MenuItems.map((GroupedMenuItems, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            key: index,
            as: "ul",
            xcss: [
                $37dcbc182b0ae871$var$menuSectionStyles,
                index > 0 && $37dcbc182b0ae871$var$menuSectionDividerStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(GroupedMenuItems, {
            onClose: onClose
        }))));
const $37dcbc182b0ae871$export$4c0f8320eb6cf210 = (props)=>{
    const { MenuItems: MenuItems, isOpen: isOpen, onClose: onClose, onToggle: onToggle } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $54SNu.MoreNavMenuItem), {
        MenuItems: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37dcbc182b0ae871$var$L1MoreNavMenuItemSubmenu, {
                MenuItems: MenuItems,
                onClose: onClose
            }),
        isOpen: isOpen,
        onToggle: onToggle,
        onClose: onClose
    });
};
const $37dcbc182b0ae871$var$menuGroupWrapperStyles = (0, $2s57o.xcss)({
    paddingTop: 'space.050',
    paddingInline: 'space.050'
});
const $37dcbc182b0ae871$var$menuSectionStyles = (0, $2s57o.xcss)({
    // Override default <ul> padding
    padding: 'space.0',
    paddingBottom: 'space.050'
});
const $37dcbc182b0ae871$var$menuSectionDividerStyles = (0, $2s57o.xcss)({
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
    paddingTop: 'space.050',
    marginTop: 'space.0'
});

});
parcelRegister("54SNu", function(module, exports) {

$parcel$export(module.exports, "MoreNavMenuItem", () => $6cf41ab7bb0f4a0b$export$69b3a144536c53ed);

var $5uXOq = parcelRequire("5uXOq");

var $bH54c = parcelRequire("bH54c");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $3yFuy = parcelRequire("3yFuy");

var $7vqau = parcelRequire("7vqau");
const $6cf41ab7bb0f4a0b$export$69b3a144536c53ed = ({ isOpen: isOpen, onClose: onClose, onToggle: onToggle, MenuItems: // Submenu props
MenuItems })=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $7vqau.useMoreFormattedMessageAndIcon)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bH54c.Popup), {
        isOpen: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bH54c.PopupTrigger), null, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3yFuy.MenuButtonItem), {
            ...triggerProps,
            elemBefore: icon,
            onClick: onToggle
        }, formattedMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $6cf41ab7bb0f4a0b$var$popupContentContainerStyles,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bH54c.PopupContent), {
        shouldFitContainer: true,
        placement: "bottom-start",
        // Offset the top margin of the menu section.
        // This will keep an even spacing of menu items between those inside the dropdown and those above,
        // and keep the icons aligned
        offset: [
            -4,
            4
        ],
        onClose: onClose,
        shouldRenderToParent: true,
        strategy: "absolute"
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItems, {
            onClose: onClose
        }))));
};
const $6cf41ab7bb0f4a0b$var$popupContentContainerStyles = (0, $2s57o.xcss)({
    position: 'relative',
    marginInline: 'space.negative.050'
});

});
parcelRegister("7vqau", function(module, exports) {

$parcel$export(module.exports, "useMoreFormattedMessageAndIcon", () => $e4dffbd6e272b91b$export$cb3aaead45d9e574);

var $c8rIN = parcelRequire("c8rIN");

var $24a2m = parcelRequire("24a2m");

var $lkmKZ = parcelRequire("lkmKZ");
const $e4dffbd6e272b91b$export$cb3aaead45d9e574 = ()=>(0, $24a2m.useFormattedMessageAndIcon)((0, $lkmKZ.default).more, (0, (/*@__PURE__*/$parcel$interopDefault($c8rIN))));

});
parcelRegister("lkmKZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $50a2a914e860682e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50a2a914e860682e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    more: {
        "id": "navigation-apps-sidebar-nav4-common.common.more-nav-menu-item.more",
        "defaultMessage": "More"
    }
});

});




parcelRegister("71X8q", function(module, exports) {

$parcel$export(module.exports, "GlobalMoreMenu", () => $14e61bf6b716abd8$export$6741e824c68e9927);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gJxXX = parcelRequire("gJxXX");
function $14e61bf6b716abd8$export$6741e824c68e9927({ productItemsData: productItemsData, appItemsData: appItemsData = [], menuItemComponent: menuItemComponent, customizeSidebarMenuItem: customizeSidebarMenuItem, moreMenuItemLabel: moreMenuItemLabel, peekingMenuIds: peekingMenuIds = [], onClickMoreMenuTrigger: onClickMoreMenuTrigger }) {
    const checkIsHiddenMenuItem = ({ menuId: menuId, visible: visible })=>!visible && !peekingMenuIds.includes(menuId);
    const hiddenProductItemsData = productItemsData.filter(checkIsHiddenMenuItem);
    const hiddenAppItemsData = appItemsData.filter(checkIsHiddenMenuItem);
    if (hiddenProductItemsData.length === 0 && hiddenAppItemsData.length === 0) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: customizeSidebarMenuItem
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gJxXX.MoreMenuPopup), {
        productItemsData: hiddenProductItemsData,
        appItemsData: hiddenAppItemsData,
        moreMenuItemComponent: menuItemComponent,
        customizeSidebarMenuItem: customizeSidebarMenuItem,
        moreMenuItemLabel: moreMenuItemLabel,
        onClickMoreMenuTrigger: onClickMoreMenuTrigger
    });
}

});
parcelRegister("gJxXX", function(module, exports) {

$parcel$export(module.exports, "MoreMenuPopup", () => $93eb573212583c4b$export$b426d2e536b00785);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $c8rIN = parcelRequire("c8rIN");

var $bH54c = parcelRequire("bH54c");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $4IIGx = parcelRequire("4IIGx");

var $3yFuy = parcelRequire("3yFuy");

var $gsL1P = parcelRequire("gsL1P");
const $93eb573212583c4b$var$popupContentContainerStyles = (0, $2s57o.xcss)({
    position: 'relative',
    marginInline: 'space.negative.050'
});
const $93eb573212583c4b$var$popupContentStyles = (0, $2s57o.xcss)({
    padding: 'space.050'
});
function $93eb573212583c4b$export$b426d2e536b00785({ productItemsData: productItemsData, appItemsData: appItemsData, moreMenuItemComponent: moreMenuItemComponent, customizeSidebarMenuItem: customizeSidebarMenuItem, moreMenuItemLabel: moreMenuItemLabel, onClickMoreMenuTrigger: onClickMoreMenuTrigger }) {
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const closeMenu = ()=>setIsOpen(false);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(true), onClickMoreMenuTrigger && onClickMoreMenuTrigger();
    }, [
        onClickMoreMenuTrigger
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bH54c.Popup), {
        isOpen: isOpen,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bH54c.PopupTrigger), {
                children: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3yFuy.MenuButtonItem), {
                        ...triggerProps,
                        elemBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8rIN))), {
                            label: "",
                            color: "currentColor",
                            spacing: "spacious"
                        }),
                        onClick: onClick,
                        children: moreMenuItemLabel
                    })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                xcss: $93eb573212583c4b$var$popupContentContainerStyles,
                role: "listitem",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bH54c.PopupContent), {
                    shouldFitContainer: true,
                    placement: "bottom-start",
                    // Offset the top margin of the menu section.
                    // This will keep an even spacing of menu items between those inside the dropdown and those above,
                    // and keep the icons aligned
                    offset: [
                        -4,
                        4
                    ],
                    onClose: ()=>setIsOpen(false),
                    shouldRenderToParent: true,
                    strategy: "absolute",
                    children: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                            xcss: $93eb573212583c4b$var$popupContentStyles,
                            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4IIGx.MenuList), {
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gsL1P.MoreMenuSection), {
                                        itemsData: productItemsData,
                                        moreMenuItemComponent: moreMenuItemComponent,
                                        closeMenu: closeMenu
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gsL1P.MoreMenuSection), {
                                        itemsData: appItemsData,
                                        moreMenuItemComponent: moreMenuItemComponent,
                                        closeMenu: closeMenu
                                    }),
                                    customizeSidebarMenuItem
                                ]
                            })
                        })
                })
            })
        ]
    });
}

});
parcelRegister("gsL1P", function(module, exports) {

$parcel$export(module.exports, "MoreMenuSection", () => $1d386af59a51e8e9$export$e69b6dd1756fb519);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4IIGx = parcelRequire("4IIGx");

var $gkEOT = parcelRequire("gkEOT");
var $ch7sx = parcelRequire("ch7sx");
function $1d386af59a51e8e9$export$e69b6dd1756fb519({ itemsData: itemsData, moreMenuItemComponent: moreMenuItemComponent, closeMenu: closeMenu }) {
    if (itemsData.length === 0) return null;
    const MenuItemComponent = moreMenuItemComponent;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ch7sx.MenuSection), {
        isMenuListItem: true,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4IIGx.MenuList), {
                children: itemsData.map(({ menuId: menuId })=>/*#__PURE__*/ (0, $2OMIu.jsx)(MenuItemComponent, {
                        menuId: menuId,
                        closeMenu: closeMenu
                    }, menuId))
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gkEOT.Divider), {})
        ]
    });
}

});



parcelRegister("cscSc", function(module, exports) {

$parcel$export(module.exports, "CustomiseSidebar", () => $7234c1f5a7f27917$export$8ef5220def5f00e1);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2KAtx = parcelRequire("2KAtx");

var $8Dpzr = parcelRequire("8Dpzr");

var $5xBN5 = parcelRequire("5xBN5");

var $dKXJF = parcelRequire("dKXJF");

var $jvPG3 = parcelRequire("jvPG3");
function $7234c1f5a7f27917$export$8ef5220def5f00e1({ navItems: navItems }) {
    const { setMoreMenuIsOpen: setMoreMenuIsOpen } = (0, $5uXOq.useContext)((0, $5xBN5.MoreMenuIsOpenContext));
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setMoreMenuIsOpen(false);
    }, [
        setMoreMenuIsOpen
    ]);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            navItems: navItems,
            onClose: onClose
        }), [
        navItems,
        onClose
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: 400,
            height: 440
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $8Dpzr.CustomisableSidebarModalEntrypoint),
        entryPointProps: entryPointParams,
        title: formatMessage((0, $dKXJF.default).header),
        modalProps: modalProps,
        useInternalModal: false
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jvPG3.CustomiseSidebarTrigger), {
            ref: ref
        }));
}

});
parcelRegister("8Dpzr", function(module, exports) {

$parcel$export(module.exports, "CustomisableSidebarModalEntrypoint", () => $3ac09ae106e0999d$export$420f0b14c9bb574e);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $3ac09ae106e0999d$export$420f0b14c9bb574e = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("au8k1")).then(({ CustomisableSidebarModal: CustomisableSidebarModal })=>CustomisableSidebarModal), {
        moduleId: "5506b7c0"
    }),
    getPreloadProps: (props)=>({
            queries: {},
            props: props
        })
});

});
parcelRegister("au8k1", function(module, exports) {

let $7a2329484f0dde9b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7a2329484f0dde9b$var$load("aHD9Z").then(()=>parcelRequire('537Fw'));

});


parcelRegister("dKXJF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1cefac76ecdf582$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a1cefac76ecdf582$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "navigation-apps-sidebar-nav4-customise-sidebar.header",
        "defaultMessage": "Customize sidebar"
    },
    reorder: {
        "id": "navigation-apps-sidebar-nav4-sidebar-content.configurable-menu.customise-sidebar.reorder",
        "defaultMessage": "Reorder {itemLabel}"
    },
    separator: {
        "id": "navigation-apps-sidebar-nav4-sidebar-content.configurable-menu.customise-sidebar.separator",
        "defaultMessage": "Separator"
    }
});

});

parcelRegister("jvPG3", function(module, exports) {

$parcel$export(module.exports, "CustomiseSidebarTrigger", () => $346f128683b8c378$export$923dc28f372c1f3f);

var $5uXOq = parcelRequire("5uXOq");

var $dy2DR = parcelRequire("dy2DR");

var $jecJ3 = parcelRequire("jecJ3");

var $24a2m = parcelRequire("24a2m");

var $eQV8d = parcelRequire("eQV8d");

var $3yFuy = parcelRequire("3yFuy");

var $8d31d = parcelRequire("8d31d");
const $346f128683b8c378$export$923dc28f372c1f3f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick }, ref)=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $8d31d.default).customiseSidebar, (0, (/*@__PURE__*/$parcel$interopDefault($dy2DR))));
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const onClickHandler = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        sendSectionItemAnalyticsEvent({
            sectionItem: (0, $jecJ3.SECTION_ITEM_CUSTOMIZE_SIDEBAR)
        });
        onClick?.(event, analyticsEvent);
    }, [
        onClick,
        sendSectionItemAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3yFuy.MenuButtonItem), {
        interactionName: "nav4-sidebar-customise-modal",
        elemBefore: icon,
        onClick: onClickHandler,
        ref: ref
    }, formattedMessage);
});

});
parcelRegister("dy2DR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8bb9804f9ea7eaa10f227008c94bcff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9dd07ff7de09bd06$var$_react = $9dd07ff7de09bd06$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9dd07ff7de09bd06$var$_baseNew = $9dd07ff7de09bd06$var$_interopRequireDefault((parcelRequire("enEmH")));
function $9dd07ff7de09bd06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9dd07ff7de09bd06$var$CustomizeIcon = (props)=>/*#__PURE__*/ $9dd07ff7de09bd06$var$_react.default.createElement($9dd07ff7de09bd06$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.375C3 1.615 3.616 1 4.375 1h1.75c.76 0 1.375.616 1.375 1.375v4.25C7.5 7.385 6.884 8 6.125 8h-1.75C3.615 8 3 7.384 3 6.625V5.25H0v-1.5h3zm1.5.125v4H6v-4zM16 5.25H8.5v-1.5H16zM8.5 9.375C8.5 8.615 9.116 8 9.875 8h1.75C12.385 8 13 8.616 13 9.375v1.375h3v1.5h-3v1.375c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zM10 9.5v4h1.5v-4zM0 12.25v-1.5h7.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$9dd07ff7de09bd06$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $9dd07ff7de09bd06$var$_default = module.exports.default = $9dd07ff7de09bd06$var$CustomizeIcon;

});

parcelRegister("8d31d", function(module, exports) {

$parcel$export(module.exports, "default", () => $215517791c29e77e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $215517791c29e77e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    customiseSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebar-content.configurable-menu.customise-sidebar.trigger.customise-sidebar",
        "defaultMessage": "Customize sidebar"
    }
});

});



parcelRegister("hFGs5", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $020667c43ce85a92$export$2ce376c2cc3355c8);
$parcel$export(module.exports, "MoreMenuItem", () => $020667c43ce85a92$export$e967513bbeba0537);

var $5uXOq = parcelRequire("5uXOq");

var $dUyqZ = parcelRequire("dUyqZ");

var $ctUNb = parcelRequire("ctUNb");

var $3yFuy = parcelRequire("3yFuy");

var $iszzG = parcelRequire("iszzG");

var $6kDpL = parcelRequire("6kDpL");

var $eQV8d = parcelRequire("eQV8d");

var $jecJ3 = parcelRequire("jecJ3");

var $eUfQ2 = parcelRequire("eUfQ2");

var $1zjdl = parcelRequire("1zjdl");
const $020667c43ce85a92$export$2ce376c2cc3355c8 = ({ menuId: menuId, ...props })=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)(menuId);
    // This is part of an intermediate state workaround where links are accounted for;
    // we don't expect links to be in the More menu at the end state,
    // at which point this and the MenuLinkItem below can be removed.
    const url = (0, $1zjdl.USER_NAVIGATION_ITEM_LINKS)[menuId];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctUNb.MenuLinkItem), {
        ...props,
        elemBefore: icon,
        href: url
    }, formattedMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3yFuy.MenuButtonItem), {
        ...props,
        elemBefore: icon
    }, formattedMessage));
};
function $020667c43ce85a92$export$e967513bbeba0537({ menuId: menuId, closeMenu: closeMenu, key: key }) {
    const { setPeekMenuId: setPeekMenuId } = (0, $5uXOq.useContext)((0, $iszzG.PeekMenuIdContext));
    const configurableId = (0, $6kDpL.convertToConfigurableMenuId)(menuId);
    const isGlobalApp = (0, $eUfQ2.isGlobalAppMenuId)(menuId);
    const { formattedMessage: formattedMessage, icon: icon } = (0, $dUyqZ.useConfigurableMessageAndIconMap)(configurableId);
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    // This is part of an intermediate state workaround where links are accounted for;
    // we don't expect links to be in the More menu at the end state,
    // at which point this and the MenuLinkItem below can be removed.
    const url = (0, $1zjdl.USER_NAVIGATION_ITEM_LINKS)[menuId];
    const onClick = (0, $5uXOq.useCallback)(()=>{
        closeMenu();
        if (!isGlobalApp) // Global apps open in a new tab onClick so they don't need to be a peek-item
        setPeekMenuId(configurableId);
        sendSectionItemAnalyticsEvent({
            menuId: configurableId,
            sectionItem: (0, $jecJ3.SECTION_ITEM_MAP)[configurableId]
        });
    }, [
        closeMenu,
        configurableId,
        isGlobalApp,
        sendSectionItemAnalyticsEvent,
        setPeekMenuId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctUNb.MenuLinkItem), {
        elemBefore: icon,
        href: url,
        onClick: onClick,
        key: key,
        target: isGlobalApp ? '_blank' : undefined
    }, formattedMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3yFuy.MenuButtonItem), {
        elemBefore: icon,
        onClick: onClick,
        key: key
    }, formattedMessage));
}

});
parcelRegister("6kDpL", function(module, exports) {

$parcel$export(module.exports, "convertToConfigurableMenuId", () => $6a544b997005f6ad$export$c54090f9034b2d83);

var $jhS4y = parcelRequire("jhS4y");
const $6a544b997005f6ad$export$c54090f9034b2d83 = (menuId)=>{
    switch(menuId){
        case 'jira.sidebar.apps':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).APPS;
        case 'jira.sidebar.assets':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).ASSETS;
        case 'jira.sidebar.dashboards':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).DASHBOARDS;
        case 'jira.sidebar.filters':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).FILTERS;
        case 'jira.sidebar.goals':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).GOALS;
        case 'jira.sidebar.operations':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).OPERATIONS;
        case 'jira.sidebar.overviews':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).OVERVIEWS;
        case 'jira.sidebar.plans':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).PLANS;
        case 'jira.sidebar.projects':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).PROJECTS;
        case 'jira.sidebar.recent':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).RECENT;
        case 'jira.sidebar.starred':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).STARRED;
        case 'jira.sidebar.teams':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).TEAMS;
        case 'jira.sidebar.roadmaps':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).ROADMAPS;
        case 'jira.sidebar.customerService':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE;
        case 'jira.sidebar.customerHubs':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_HUBS;
        case 'jira.sidebar.customerServiceAnalytics':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE_ANALYTICS;
        case 'jira.sidebar.globalApp.assets':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_ASSETS;
        case 'jira.sidebar.globalApp.goals':
            return (0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_GOALS;
        default:
            throw new Error(`Invalid menuId: ${menuId}`);
    }
};

});


parcelRegister("9Qut3", function(module, exports) {

$parcel$export(module.exports, "PeekMenuItem", () => $53741d978b583623$export$4287f527b7969caa);

var $5uXOq = parcelRequire("5uXOq");

var $iszzG = parcelRequire("iszzG");

var $3muxY = parcelRequire("3muxY");
const $53741d978b583623$export$4287f527b7969caa = ({ menuData: menuData })=>{
    const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, $iszzG.NavItemsContext));
    const { peekMenuId: peekMenuId } = (0, $5uXOq.useContext)((0, $iszzG.PeekMenuIdContext));
    return !!peekMenuId && moreMenuIds.includes(peekMenuId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3muxY.ConfigurableMenuItem), {
        isDefaultOpen: true,
        menuData: menuData,
        menuId: peekMenuId
    });
};

});

parcelRegister("hBVbZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $972efabdcaff5f8b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $972efabdcaff5f8b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    more: {
        "id": "navigation-apps-sidebar-nav4-sidebar-content.configurable-menu-items.sidebar-customization.more",
        "defaultMessage": "More"
    }
});

});

parcelRegister("h3Slk", function(module, exports) {

$parcel$export(module.exports, "CustomizeSidebar", () => $476b63d94ba584a9$export$bfa967364825ce72);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2KAtx = parcelRequire("2KAtx");

var $6sQAR = parcelRequire("6sQAR");

var $7yQiQ = parcelRequire("7yQiQ");

var $k327m = parcelRequire("k327m");
function $476b63d94ba584a9$export$bfa967364825ce72({ productItemsData: productItemsData, appItemsData: appItemsData }) {
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            productItemsData: productItemsData,
            appItemsData: appItemsData
        }), [
        productItemsData,
        appItemsData
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $6sQAR.CustomisableSidebarModalEntrypoint),
        entryPointProps: entryPointParams,
        title: formatMessage((0, $k327m.default).customizeSidebar),
        useInternalModal: false
    }, ({ ref: ref })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7yQiQ.CustomizeSidebarMenuItem), {
            ref: ref
        }));
}

});
parcelRegister("6sQAR", function(module, exports) {

$parcel$export(module.exports, "CustomisableSidebarModalEntrypoint", () => $70c42c9468d82fee$export$420f0b14c9bb574e);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $70c42c9468d82fee$export$420f0b14c9bb574e = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("aIUQE")).then(({ JiraCustomizationModal: JiraCustomizationModal })=>JiraCustomizationModal), {
        moduleId: "fd0bd96d"
    }),
    getPreloadProps: (props)=>({
            queries: {},
            props: props
        })
});

});
parcelRegister("aIUQE", function(module, exports) {

let $7cea1c4fba498e89$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7cea1c4fba498e89$var$load("5FD4o").then(()=>parcelRequire('9XBkh'));

});


parcelRegister("7yQiQ", function(module, exports) {

$parcel$export(module.exports, "CustomizeSidebarMenuItem", () => $3bf3d8658fdf9651$export$b7fa0daee00ba08b);

var $5uXOq = parcelRequire("5uXOq");

var $dy2DR = parcelRequire("dy2DR");

var $3yFuy = parcelRequire("3yFuy");

var $24a2m = parcelRequire("24a2m");

var $eQV8d = parcelRequire("eQV8d");

var $jecJ3 = parcelRequire("jecJ3");

var $k327m = parcelRequire("k327m");
const $3bf3d8658fdf9651$export$b7fa0daee00ba08b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick }, ref)=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $24a2m.useFormattedMessageAndIcon)((0, $k327m.default).customizeSidebar, (0, (/*@__PURE__*/$parcel$interopDefault($dy2DR))));
    const sendSectionItemAnalyticsEvent = (0, $eQV8d.useSectionItemAnalytics)();
    const onClickHandler = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        sendSectionItemAnalyticsEvent({
            sectionItem: (0, $jecJ3.SECTION_ITEM_CUSTOMIZE_SIDEBAR)
        });
        onClick?.(event, analyticsEvent);
    }, [
        onClick,
        sendSectionItemAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3yFuy.MenuButtonItem), {
        interactionName: "nav4-sidebar-customise-modal",
        elemBefore: icon,
        onClick: onClickHandler,
        ref: ref
    }, formattedMessage);
});

});
parcelRegister("k327m", function(module, exports) {

$parcel$export(module.exports, "default", () => $488968c72ecfab5f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $488968c72ecfab5f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    customizeSidebar: {
        "id": "navigation-apps-sidebar-nav4-sidebar-content.configurable-menu-items.sidebar-customization.customize-sidebar-menu-item.customize-sidebar",
        "defaultMessage": "Customize sidebar"
    }
});

});




parcelRegister("8FnIk", function(module, exports) {

$parcel$export(module.exports, "PeekMenuIdContextProvider", () => $e1d6abe2c6ea1ed4$export$b7d1a20f5a877f18);

var $5uXOq = parcelRequire("5uXOq");

var $jhS4y = parcelRequire("jhS4y");

var $c6x3L = parcelRequire("c6x3L");

var $lJ5jf = parcelRequire("lJ5jf");

var $iszzG = parcelRequire("iszzG");
// Eventually this will be all configurable menu ids and can be removed at that point.
// TODO: Adam, I think we've reached that point.
const $e1d6abe2c6ea1ed4$var$CONFIGURABLE_MENU_IDS_USING_SIDEBAR_CONTEXT = [
    (0, $jhS4y.CONFIGURABLE_MENU_ID).ASSETS,
    (0, $jhS4y.CONFIGURABLE_MENU_ID).APPS,
    (0, $jhS4y.CONFIGURABLE_MENU_ID).DASHBOARDS,
    (0, $jhS4y.CONFIGURABLE_MENU_ID).FILTERS,
    (0, $jhS4y.CONFIGURABLE_MENU_ID).OPERATIONS,
    (0, $jhS4y.CONFIGURABLE_MENU_ID).PLANS,
    (0, $jhS4y.CONFIGURABLE_MENU_ID).PROJECTS
];
const $e1d6abe2c6ea1ed4$export$b7d1a20f5a877f18 = ({ children: children })=>{
    const { isSelectedPath: isSelectedPath } = (0, $c6x3L.useSidebarNav4)();
    const { isControlledNav: isControlledNav, isControlledPath: isControlledPath } = (0, $lJ5jf.useSidebarNav4Controller)();
    const { moreMenuIds: moreMenuIds } = (0, $5uXOq.useContext)((0, $iszzG.NavItemsContext));
    const [peekMenuId, setPeekMenuId] = (0, $5uXOq.useState)(()=>$e1d6abe2c6ea1ed4$var$getAutoPeekMenuId(isSelectedPath, isControlledNav, isControlledPath, moreMenuIds));
    // This effect automatically overrides the manual value of peek menu id (set when clicking in the more menu item).
    // This effect is only triggered when controlled, selected, or more menu ids change.
    // Use layout effect so peek menu id is set before render.
    // An alternative to any effect would be to set peek menu id when setting selected path.
    // However, that may require elevating this context.
    (0, $5uXOq.useLayoutEffect)(()=>setPeekMenuId((currentPeekMenuId)=>$e1d6abe2c6ea1ed4$var$getAutoPeekMenuId(isSelectedPath, isControlledNav, isControlledPath, moreMenuIds, currentPeekMenuId)), [
        isControlledNav,
        isControlledPath,
        isSelectedPath,
        moreMenuIds
    ]);
    const peekMenuIdContext = (0, $5uXOq.useMemo)(()=>({
            peekMenuId: peekMenuId,
            setPeekMenuId: setPeekMenuId
        }), [
        peekMenuId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iszzG.PeekMenuIdContext).Provider, {
        value: peekMenuIdContext
    }, children);
};
const $e1d6abe2c6ea1ed4$var$getAutoPeekMenuId = (isSelectedPath, isControlledNav, isControlledPath, moreMenuIds, peekMenuId)=>{
    // When controlled...
    if (isControlledNav) return moreMenuIds.find(isControlledPath);
    // Otherwise selected...
    const autoPeekMenuId = moreMenuIds.find(isSelectedPath);
    // Once all configurable menu ids are using sidebar context we can just return `autoPeekMenuId`.
    if (autoPeekMenuId) return autoPeekMenuId;
    // Unpeek if peek menu id is no longer selected.
    // Only do this for menu ids using the sidebar context for now.
    // Legacy menu ids set peek menu id manually.
    if (peekMenuId && $e1d6abe2c6ea1ed4$var$CONFIGURABLE_MENU_IDS_USING_SIDEBAR_CONTEXT.includes(peekMenuId)) return undefined;
    // Otherwise unchanged.
    return peekMenuId;
};

});

parcelRegister("ef14J", function(module, exports) {

$parcel$export(module.exports, "GlobalShortcuts", () => $d56ea5e2a8fc5255$export$bae2da217bf9db6);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $hlyyn = parcelRequire("hlyyn");

var $11ALy = parcelRequire("11ALy");

var $l0mZw = parcelRequire("l0mZw");

var $7lnZ9 = parcelRequire("7lnZ9");

var $btL7W = parcelRequire("btL7W");

var $jzdqS = parcelRequire("jzdqS");

var $35Bd0 = parcelRequire("35Bd0");

var $14XJw = parcelRequire("14XJw");

var $31niQ = parcelRequire("31niQ");
function $d56ea5e2a8fc5255$export$bae2da217bf9db6() {
    const intl = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    // ShortcutItems needs to me memoized as intl triggers re-renders
    const shortcutItems = (0, $5uXOq.useMemo)(()=>{
        return [
            (0, $l0mZw.default)(()=>''),
            (0, $7lnZ9.default)(()=>''),
            (0, $btL7W.default)(intl.formatMessage((0, $31niQ.default).goalsShortcutText), ()=>''),
            (0, $jzdqS.default)(intl.formatMessage((0, $31niQ.default).projectsShortcutText), ()=>''),
            (0, $35Bd0.default)(intl.formatMessage((0, $31niQ.default).teamsShortcutText), ()=>'')
        ];
    }, [
        intl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $11ALy.TopLevelSpacer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hlyyn.default), {
        cloudId: cloudId,
        orgId: orgId,
        useSkeleton: true,
        shortcutItems: shortcutItems
    }));
}

});
parcelRegister("hlyyn", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbdaf8bfee66b04f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gOkqF = parcelRequire("gOkqF");

var $bM50S = parcelRequire("bM50S");
var $hxfgo = parcelRequire("hxfgo");
var $h470O = parcelRequire("h470O");

var $4IIGx = parcelRequire("4IIGx");

var $16zmR = parcelRequire("16zmR");

var $4Fmp4 = parcelRequire("4Fmp4");

var $h03gi = parcelRequire("h03gi");

var $cEXCo = parcelRequire("cEXCo");

var $1sla0 = parcelRequire("1sla0");
function $cbdaf8bfee66b04f$var$Menu({ testId: testId, shortcutItems: shortcutItems = [], forceStatic: forceStatic, cloudId: cloudId, orgId: orgId, useSkeleton: useSkeleton }) {
    const { buildURLAndFetchData: buildURLAndFetchData, status: status, productLinks: productLinks } = (0, $h470O.useBFFDataProvider)({
        request: {},
        cloudId: cloudId,
        orgId: orgId
    });
    const mappedShortcutItems = (0, $5uXOq.useMemo)(()=>{
        return shortcutItems.map((item, index)=>{
            return {
                ...item,
                key: item.apsKey || `shortcut-${index}`
            };
        });
    }, [
        shortcutItems
    ]);
    const apsKeys = (0, $5uXOq.useMemo)(()=>{
        return shortcutItems.map((item)=>item.apsKey || '').filter((item)=>!!item);
    }, [
        shortcutItems
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!forceStatic) buildURLAndFetchData(apsKeys);
    }, [
        apsKeys,
        buildURLAndFetchData,
        forceStatic
    ]);
    const createLinkItem = (0, $5uXOq.useCallback)((shortcut)=>{
        // Render nested items if the dynamic data is available
        if (!forceStatic && status === (0, $bM50S.RequestStatus).COMPLETE && shortcut?.apsKey && productLinks?.[shortcut.apsKey]) {
            const items = productLinks[shortcut.apsKey].map((item)=>{
                return {
                    icon: item.avatar ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4Fmp4.ImageFromUrl), {
                        src: item.avatar
                    }) : shortcut.icon,
                    label: item.displayName,
                    url: item.url
                };
            }).sort((a, b)=>(0, $16zmR.sortAlphabetically)('asc')(a.label, b.label));
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h03gi.MenuExpandItem), {
                icon: shortcut.icon,
                label: shortcut.label,
                items: items
            });
        }
        // Show skeleton while BFF is loading
        if (useSkeleton && status === (0, $bM50S.RequestStatus).LOADING) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1sla0.MenuSkeletonItem), {});
        // We only want to allow static menu expand item if we are forcing static,
        // otherwise it should be showing the singular item as a disabled link until the
        // data is loaded.
        if (forceStatic && shortcut.items) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h03gi.MenuExpandItem), {
            icon: shortcut.icon,
            label: shortcut.label,
            items: shortcut.items
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEXCo.MenuLinkItem), {
            apsKey: shortcut.apsKey,
            icon: shortcut.icon,
            url: shortcut?.fallbackUrl?.(),
            label: shortcut.label
        }, shortcut.key);
    }, [
        forceStatic,
        productLinks,
        status,
        useSkeleton
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gOkqF.default), {
        testId: testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4IIGx.MenuList), {
            children: mappedShortcutItems?.map(createLinkItem)
        })
    });
}
function $cbdaf8bfee66b04f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hxfgo.BFFProvider), {
        consumer: (0, $bM50S.BFFConsumerEnum).GLOBAL_SHORTCUTS,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($cbdaf8bfee66b04f$var$Menu, {
            ...props
        })
    });
}

});
parcelRegister("bM50S", function(module, exports) {

$parcel$export(module.exports, "BFFConsumerEnum", () => $f2b24f54dfbeb220$export$9a146e025690327e);
$parcel$export(module.exports, "ASSETS_APP_KEY", () => $f2b24f54dfbeb220$export$45e63649edff1e2a);
$parcel$export(module.exports, "MAX_ATTEMPTS_DEFAULT", () => $f2b24f54dfbeb220$export$45c80c6b98d65f36);
$parcel$export(module.exports, "RETRY_INTERVAL_DEFAULT", () => $f2b24f54dfbeb220$export$7b4183e5f0de390a);
$parcel$export(module.exports, "DAYS_AUTO_PROVISIONED_ITEM_CONSIDERED_NEW", () => $f2b24f54dfbeb220$export$891dc7068a3d5e65);
$parcel$export(module.exports, "DAYS_END_USER_ACTIVE_PRODUCT_CONSIDERED_NEW", () => $f2b24f54dfbeb220$export$6e594fe130dbe3b);
$parcel$export(module.exports, "RequestStatus", () => $f2b24f54dfbeb220$export$600e7c1f9e0414e1);
$parcel$export(module.exports, "BFF_REQUEST_STATUS_KEY", () => $f2b24f54dfbeb220$export$c889532d47d74e9c);
$parcel$export(module.exports, "FLIGHTDECK_REQUEST_STATUS_KEY", () => $f2b24f54dfbeb220$export$123b1b8742c0ac6a);
var $f2b24f54dfbeb220$export$9a146e025690327e = /*#__PURE__*/ function(BFFConsumerEnum) {
    BFFConsumerEnum["ATLASSIAN_SWITCHER"] = "ATLASSIAN_SWITCHER";
    BFFConsumerEnum["GLOBAL_SHORTCUTS"] = "GLOBAL_SHORTCUTS";
    return BFFConsumerEnum;
}({});
const $f2b24f54dfbeb220$export$45e63649edff1e2a = 'ASSETS';
const $f2b24f54dfbeb220$export$45c80c6b98d65f36 = 3;
const $f2b24f54dfbeb220$export$7b4183e5f0de390a = 1000;
const $f2b24f54dfbeb220$export$891dc7068a3d5e65 = 14;
const $f2b24f54dfbeb220$export$6e594fe130dbe3b = 14;
var $f2b24f54dfbeb220$export$600e7c1f9e0414e1 = /*#__PURE__*/ function(RequestStatus) {
    RequestStatus["LOADING"] = "loading";
    RequestStatus["COMPLETE"] = "complete";
    RequestStatus["ERROR"] = "error";
    return RequestStatus;
}({});
const $f2b24f54dfbeb220$export$c889532d47d74e9c = 'bff';
const $f2b24f54dfbeb220$export$123b1b8742c0ac6a = 'flightdeck';

});

parcelRegister("hxfgo", function(module, exports) {

$parcel$export(module.exports, "BFFContext", () => $44f29da791914c80$export$873dcaf380a86d6b);
$parcel$export(module.exports, "BFFProvider", () => $44f29da791914c80$export$71a938590b6955cc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bM50S = parcelRequire("bM50S");
const $44f29da791914c80$export$b2445cd6f2d7fd5 = {
    cache: {},
    cacheKey: '',
    status: null,
    consumer: null
};
const $44f29da791914c80$export$873dcaf380a86d6b = /*#__PURE__*/ (0, $5uXOq.createContext)({
    value: $44f29da791914c80$export$b2445cd6f2d7fd5,
    currentLoadingRequests: [],
    setValue: ()=>{},
    updateCurrentLoadingRequests: (name, status)=>{}
});
function $44f29da791914c80$export$71a938590b6955cc({ consumer: consumer, children: children }) {
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState({
        cache: {},
        cacheKey: consumer,
        consumer: consumer,
        status: null
    });
    const [currentLoadingRequests, setCurrentLoadingRequests] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState([]);
    const updateCurrentLoadingRequests = (0, $5uXOq.useCallback)((name, status)=>{
        switch(status){
            case (0, $bM50S.RequestStatus).LOADING:
                setCurrentLoadingRequests((prev)=>[
                        ...prev,
                        name
                    ]);
                break;
            case (0, $bM50S.RequestStatus).COMPLETE:
                setCurrentLoadingRequests((prev)=>prev.filter((request)=>request !== name));
                break;
            case (0, $bM50S.RequestStatus).ERROR:
                setCurrentLoadingRequests([]);
                break;
        }
    }, [
        setCurrentLoadingRequests
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($44f29da791914c80$export$873dcaf380a86d6b.Provider, {
        value: {
            value: value,
            setValue: setValue,
            currentLoadingRequests: currentLoadingRequests,
            updateCurrentLoadingRequests: updateCurrentLoadingRequests
        },
        children: children
    });
}

});

parcelRegister("h470O", function(module, exports) {

$parcel$export(module.exports, "useBFFDataProvider", () => $87bda4ab70370c67$export$a00b492c9c3c66db);

var $5uXOq = parcelRequire("5uXOq");

var $bM50S = parcelRequire("bM50S");

var $2d2UJ = parcelRequire("2d2UJ");

var $5y96Z = parcelRequire("5y96Z");

var $5LQgO = parcelRequire("5LQgO");

var $kLYkC = parcelRequire("kLYkC");

var $aZK2d = parcelRequire("aZK2d");
async function $87bda4ab70370c67$var$wait(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $87bda4ab70370c67$export$a00b492c9c3c66db({ request: request, cloudId: cloudId, orgId: orgId }) {
    const { items: cachedItems, addItemsToCache: addItemsToCache, clearCache: clearCache, cacheKey: cacheKey, updateCacheKey: updateCacheKey } = (0, $5y96Z.useCache)();
    const { setStatus: setStatus, status: status } = (0, $kLYkC.useStatus)();
    const { productLinks: productLinks } = (0, $5LQgO.useProductLinks)({
        cloudId: cloudId,
        orgId: orgId
    });
    const { buildURL: buildURL } = (0, $aZK2d.useURLBuilder)();
    const currentRequest = (0, $5uXOq.useRef)(null);
    const fetchData = (0, $5uXOq.useCallback)(async (url, data, attemptCount = 1)=>{
        if (url === '') throw new Error('URL is empty');
        setStatus((0, $bM50S.RequestStatus).LOADING, (0, $bM50S.BFF_REQUEST_STATUS_KEY));
        try {
            const response = await (0, $2d2UJ.fetchJSON)(url, {});
            switch(response.status){
                case (0, $bM50S.RequestStatus).ERROR:
                    throw response.error;
                case (0, $bM50S.RequestStatus).COMPLETE:
                    setStatus((0, $bM50S.RequestStatus).COMPLETE, (0, $bM50S.BFF_REQUEST_STATUS_KEY));
                    currentRequest.current = null;
                    return response.data;
            }
        } catch (e) {
            const maxAttempts = request?.maxAttempts ?? (0, $bM50S.MAX_ATTEMPTS_DEFAULT);
            if (request?.shouldRetryOnException && attemptCount < maxAttempts) {
                await $87bda4ab70370c67$var$wait(request?.attemptInterval ?? (0, $bM50S.RETRY_INTERVAL_DEFAULT));
                return await fetchData(url, data, attemptCount + 1);
            } else {
                currentRequest.current = null;
                setStatus((0, $bM50S.RequestStatus).ERROR);
                throw new Error('Max attempts reached');
            }
        }
    }, [
        request?.attemptInterval,
        request?.maxAttempts,
        request?.shouldRetryOnException,
        setStatus
    ]);
    /**
	 * Helper function to build a URL and fetch data.
	 */ const buildURLAndFetchData = (0, $5uXOq.useCallback)(async (requestedAPSKeys)=>{
        // Wait for the current request to end before firing another
        if (currentRequest.current) return currentRequest.current;
        const builtUrl = buildURL({
            requestedAPSKeys: requestedAPSKeys
        });
        if (builtUrl !== '') {
            currentRequest.current = fetchData(builtUrl);
            const fetchedData = await currentRequest.current;
            if (fetchedData.sites && fetchedData.sites.length) addItemsToCache(fetchedData.sites);
        }
    }, [
        addItemsToCache,
        buildURL,
        fetchData
    ]);
    return {
        status: status,
        cachedItems: cachedItems,
        cacheKey: cacheKey,
        updateCacheKey: updateCacheKey,
        addItemsToCache: addItemsToCache,
        clearCache: clearCache,
        buildURL: buildURL,
        fetchData: fetchData,
        buildURLAndFetchData: buildURLAndFetchData,
        productLinks: productLinks
    };
}

});
parcelRegister("2d2UJ", function(module, exports) {

$parcel$export(module.exports, "isLocalHost", () => $d3f95523730f0dd1$export$f931afb2c5ecf7c7);
$parcel$export(module.exports, "fetchJSON", () => $d3f95523730f0dd1$export$81bec6e38e8b706b);

var $bM50S = parcelRequire("bM50S");

var $fzsQr = parcelRequire("fzsQr");
function $d3f95523730f0dd1$export$23da1d24a38b0bde() {
    const host = window.location.host;
    return host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('jira-dev.com');
}
function $d3f95523730f0dd1$export$f931afb2c5ecf7c7() {
    const host = window.location.host;
    return host.includes('localhost');
}
async function $d3f95523730f0dd1$export$81bec6e38e8b706b(url, init) {
    try {
        const response = await fetch(url, {
            ...init,
            credentials: 'include',
            headers: {
                'Atl-BFF-Payload-Version': (0, $fzsQr.default).packageVersion,
                ...init?.headers
            }
        });
        const jsonResponse = await response.json();
        return {
            status: (0, $bM50S.RequestStatus).COMPLETE,
            data: jsonResponse
        };
    } catch (e) {
        return {
            status: (0, $bM50S.RequestStatus).ERROR,
            error: e,
            data: null
        };
    }
}

});
parcelRegister("fzsQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $92b6a64bf98c5bb1$export$2e2bcd8739ae039);
const $92b6a64bf98c5bb1$var$packageName = "platform-pkg";
const $92b6a64bf98c5bb1$var$packageVersion = "0.0.0-use.local";
var $92b6a64bf98c5bb1$export$2e2bcd8739ae039 = {
    packageName: $92b6a64bf98c5bb1$var$packageName,
    packageVersion: $92b6a64bf98c5bb1$var$packageVersion
};

});


parcelRegister("5y96Z", function(module, exports) {

$parcel$export(module.exports, "useCache", () => $dcd79de671365630$export$c6e89b6bb9436bc0);

var $5uXOq = parcelRequire("5uXOq");

var $hxfgo = parcelRequire("hxfgo");
function $dcd79de671365630$export$c6e89b6bb9436bc0() {
    const { value: { consumer: consumer, cache: cache, cacheKey: cacheKey }, setValue: setValue } = (0, $5uXOq.useContext)((0, $hxfgo.BFFContext));
    if (!consumer) throw new Error('BFFContext Consumer is not set');
    const items = (0, $5uXOq.useMemo)(()=>{
        return cache[cacheKey] ?? [];
    }, [
        cache,
        cacheKey
    ]);
    const updateCacheKey = (0, $5uXOq.useCallback)((updatedCacheKey)=>{
        setValue((prev)=>({
                ...prev,
                cacheKey: `${consumer}-${updatedCacheKey}`
            }));
    }, [
        setValue,
        consumer
    ]);
    const addItemsToCache = (0, $5uXOq.useCallback)((items, compareKey = 'cloudId')=>{
        setValue((prev)=>{
            const itemData = prev.cache[cacheKey] ?? [];
            // Overwrite values with matched key if a new value is present
            // This shouldn't be necessary, but it helps act as a safeguard
            // for duplication.
            for (let item of items){
                const replacedItemIndex = itemData.findIndex((i)=>i[compareKey] === item[compareKey]);
                if (replacedItemIndex !== -1) itemData[replacedItemIndex] = item;
                else itemData.push(item);
            }
            return {
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: itemData
                }
            };
        });
    }, [
        cacheKey,
        setValue
    ]);
    const clearCache = (0, $5uXOq.useCallback)(()=>{
        setValue((prev)=>({
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: []
                }
            }));
    }, [
        cacheKey,
        setValue
    ]);
    return {
        addItemsToCache: addItemsToCache,
        clearCache: clearCache,
        updateCacheKey: updateCacheKey,
        cacheKey: cacheKey,
        items: items
    };
}

});

parcelRegister("5LQgO", function(module, exports) {

$parcel$export(module.exports, "useProductLinks", () => $7273ff5b0609561b$export$79322ba781a26ce1);

var $5uXOq = parcelRequire("5uXOq");

var $6HV40 = parcelRequire("6HV40");

var $b4PzF = parcelRequire("b4PzF");

var $bM50S = parcelRequire("bM50S");

var $jG8LP = parcelRequire("jG8LP");

var $gP0m2 = parcelRequire("gP0m2");

var $5y96Z = parcelRequire("5y96Z");

var $kLYkC = parcelRequire("kLYkC");
function $7273ff5b0609561b$var$checkIsRecentEndUserActivatedProduct(productType, endUserActivationDate) {
    const parsedEndUserActivationDate = Date.parse(endUserActivationDate || '');
    if (!endUserActivationDate || isNaN(parsedEndUserActivationDate) || ![
        'CONFLUENCE',
        'JIRA_SERVICE_DESK',
        'JIRA_PRODUCT_DISCOVERY'
    ].includes(productType)) return false;
    const days = (0, $jG8LP.daysBetween)(new Date(parsedEndUserActivationDate), new Date());
    return days >= 0 && days <= (0, $bM50S.DAYS_END_USER_ACTIVE_PRODUCT_CONSIDERED_NEW);
}
function $7273ff5b0609561b$var$checkIsNewlyAutoProvisioned(autoProvisionDate) {
    let isConsideredNew = false;
    if (autoProvisionDate) {
        const days = (0, $jG8LP.daysBetween)(new Date(autoProvisionDate), new Date());
        isConsideredNew = days >= 0 && days <= (0, $bM50S.DAYS_AUTO_PROVISIONED_ITEM_CONSIDERED_NEW);
    }
    return isConsideredNew;
}
function $7273ff5b0609561b$var$checkShouldRemoveJWM(productType) {
    return [
        'JIRA_SOFTWARE',
        'JIRA_PRODUCT_DISCOVERY',
        'JIRA_SERVICE_DESK'
    ].includes(productType);
}
const $7273ff5b0609561b$var$flightdeckClient = new (0, $6HV40.default)('atlassian-navigagtion-bff-data-provider');
function $7273ff5b0609561b$export$79322ba781a26ce1({ cloudId: cloudId, orgId: orgId }) {
    const { items: items } = (0, $5y96Z.useCache)();
    const { setStatus: setStatus } = (0, $kLYkC.useStatus)();
    const [fdResponse, setFdResponse] = (0, $5uXOq.useState)(null);
    const [productConfig, setProductConfig] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        const getFlightdeckData = async ()=>{
            try {
                setStatus((0, $bM50S.RequestStatus).LOADING, (0, $bM50S.FLIGHTDECK_REQUEST_STATUS_KEY));
                const fdResponse = await $7273ff5b0609561b$var$flightdeckClient.fetchConfigFromFlightDeck({
                    // app-switcher-fe is currently the only valid name that is configured
                    // in Flightdeck
                    name: 'app-switcher-fe',
                    // This should get updated to be based on the supplied consumer
                    // name: `app-global-shortcuts-${consumer}-fe`,
                    dimensions: {
                        environmentType: 'prod',
                        perimeter: (0, $b4PzF.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
                    }
                });
                setFdResponse(fdResponse);
                setStatus((0, $bM50S.RequestStatus).COMPLETE, (0, $bM50S.FLIGHTDECK_REQUEST_STATUS_KEY));
            } catch (e) {
                setStatus((0, $bM50S.RequestStatus).ERROR, (0, $bM50S.FLIGHTDECK_REQUEST_STATUS_KEY));
            }
        };
        if (!fdResponse) getFlightdeckData();
    }, [
        fdResponse,
        setStatus
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!fdResponse) return;
        const config = {};
        for (const product of fdResponse.products){
            const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, rebrandedDisplayName: rebrandedDisplayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey, rebrandedIconKey: rebrandedIconKey } = product;
            config[apsKey] = {
                key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
                siteUrlSuffix: siteUrlSuffix,
                ordinal: ordinal,
                label: (0, $gP0m2.formatText)(displayName),
                rebrandedLabel: rebrandedDisplayName && (0, $gP0m2.formatText)(rebrandedDisplayName),
                description: (0, $gP0m2.formatText)(subtitle),
                iconKey: iconKey,
                rebrandedIconKey: rebrandedIconKey
            };
            // TODO: remove this once Asset app becomes standalone app
            if (apsKey === 'JIRA_SERVICE_DESK' && !config[0, $bM50S.ASSETS_APP_KEY]) config[0, $bM50S.ASSETS_APP_KEY] = {
                key: (0, $bM50S.ASSETS_APP_KEY),
                siteUrlSuffix: '/jira/assets',
                ordinal: ordinal + 0.1,
                label: (0, $gP0m2.formatText)('Assets'),
                iconKey: 'assets'
            };
        }
        setProductConfig(config);
    }, [
        fdResponse
    ]);
    const getProductLinkForItem = (0, $5uXOq.useCallback)((productType, siteUrl, productUrl)=>{
        if (productUrl) return productUrl;
        const siteSuffix = productConfig?.[productType]?.siteUrlSuffix;
        return `${siteUrl}${siteSuffix}`;
    }, [
        productConfig
    ]);
    const productLinks = (0, $5uXOq.useMemo)(()=>{
        const products = {};
        const shouldRemoveJWM = items.some((item)=>{
            return (item.availableProducts || []).some(({ productType: productType })=>$7273ff5b0609561b$var$checkShouldRemoveJWM(productType));
        });
        items.forEach((item)=>{
            const { availableProducts: availableProducts = [], cloudId: cachedItemCloudId, avatar: avatar, url: siteUrl, displayName: displayName, org: org } = item;
            // only apply org level filtering if org data is available
            if (org && orgId && org.id !== orgId) return;
            availableProducts.forEach((product)=>{
                const { autoProvisionDate: autoProvisionDate, companyHubName: companyHubName, isCompanyHubPublishedAndPremium: isCompanyHubPublishedAndPremium, endUserActivationDate: endUserActivationDate, url: productUrl } = product;
                let { productType: productType } = product;
                const isExcludeJiraBusiness = productType === 'JIRA_BUSINESS' && !shouldRemoveJWM;
                // if a site has JWM only and no other Jiras, JWM needs to appear under "Jira"
                // to ensure that this happens, we set JSM's productType to 'JIRA_SOFTWARE'
                // this will ensure that JWM is not removed, even if another site has JSW/JPD/JSM
                if (isExcludeJiraBusiness) productType = 'JIRA_SOFTWARE';
                if (!products[productType]) products[productType] = [];
                if (!isExcludeJiraBusiness) products[productType].push({
                    product: product,
                    isCurrentSite: Boolean(cachedItemCloudId) && cloudId?.toLowerCase() === cachedItemCloudId?.toLowerCase(),
                    isCompanyHubPublishedAndPremium: isCompanyHubPublishedAndPremium,
                    companyHubName: companyHubName,
                    shouldShowNewLozenge: $7273ff5b0609561b$var$checkIsRecentEndUserActivatedProduct(productType, endUserActivationDate) || productType !== 'CONFLUENCE' && $7273ff5b0609561b$var$checkIsNewlyAutoProvisioned(autoProvisionDate),
                    shouldShowTryLozenge: productType === 'CONFLUENCE' && $7273ff5b0609561b$var$checkIsNewlyAutoProvisioned(autoProvisionDate),
                    autoProvisionDate: autoProvisionDate,
                    displayName: displayName,
                    url: getProductLinkForItem(productType, siteUrl, productUrl),
                    avatar: avatar
                });
            });
        });
        return products;
    }, [
        items,
        orgId,
        cloudId,
        getProductLinkForItem
    ]);
    return {
        productLinks: productLinks
    };
}

});
parcelRegister("jG8LP", function(module, exports) {

$parcel$export(module.exports, "daysBetween", () => $ccf0991c06e4182a$export$416492d1a5f46c79);
const $ccf0991c06e4182a$var$MILLISECONDS_IN_A_DAY = 86400000;
function $ccf0991c06e4182a$export$416492d1a5f46c79(firstDate, secondDate) {
    if (!$ccf0991c06e4182a$var$isValidDate(firstDate) || !$ccf0991c06e4182a$var$isValidDate(secondDate)) return -1;
    const first = firstDate.getTime();
    const second = secondDate.getTime();
    const millisecondsBetween = Math.abs(second - first);
    return Math.round(millisecondsBetween / $ccf0991c06e4182a$var$MILLISECONDS_IN_A_DAY);
}
// https://stackoverflow.com/questions/643782/how-to-check-whether-an-object-is-a-date/44198641#44198641
function $ccf0991c06e4182a$var$isValidDate(date) {
    return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date);
}

});

parcelRegister("gP0m2", function(module, exports) {

$parcel$export(module.exports, "formatText", () => $a38f0ff0b301a276$export$905fe28a7c283e1d);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
const $a38f0ff0b301a276$export$905fe28a7c283e1d = (text)=>{
    return typeof text === 'string' ? text : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...text
    });
};

});

parcelRegister("kLYkC", function(module, exports) {

$parcel$export(module.exports, "useStatus", () => $c8680920ef3a3530$export$53cc6abb6942ce72);

var $5uXOq = parcelRequire("5uXOq");

var $bM50S = parcelRequire("bM50S");

var $hxfgo = parcelRequire("hxfgo");
function $c8680920ef3a3530$export$53cc6abb6942ce72() {
    const { setValue: setValue, value: { status: status }, currentLoadingRequests: currentLoadingRequests, updateCurrentLoadingRequests: updateCurrentLoadingRequests } = (0, $5uXOq.useContext)((0, $hxfgo.BFFContext));
    const isComplete = (0, $5uXOq.useMemo)(()=>status === (0, $bM50S.RequestStatus).COMPLETE, [
        status
    ]);
    const isError = (0, $5uXOq.useMemo)(()=>status === (0, $bM50S.RequestStatus).ERROR, [
        status
    ]);
    const isLoading = (0, $5uXOq.useMemo)(()=>status === (0, $bM50S.RequestStatus).LOADING, [
        status
    ]);
    const isLoaded = (0, $5uXOq.useMemo)(()=>status !== (0, $bM50S.RequestStatus).LOADING, [
        status
    ]);
    // Globally update the status based on the request queue for the BFF
    (0, $5uXOq.useEffect)(()=>{
        if (!currentLoadingRequests.length && status === (0, $bM50S.RequestStatus).LOADING) // Ensure that the error state remains if it was previously set
        setValue((prev)=>{
            if (prev.status === (0, $bM50S.RequestStatus).ERROR) return prev;
            return {
                ...prev,
                status: (0, $bM50S.RequestStatus).COMPLETE
            };
        });
    }, [
        currentLoadingRequests,
        setValue,
        status
    ]);
    // Globally manage the request queue of any calls to the BFF
    const setStatus = (0, $5uXOq.useCallback)((newStatus, integratingComponent)=>{
        if (newStatus === (0, $bM50S.RequestStatus).LOADING && integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $bM50S.RequestStatus).LOADING);
        if (newStatus === (0, $bM50S.RequestStatus).COMPLETE) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $bM50S.RequestStatus).COMPLETE);
        }
        if (newStatus === (0, $bM50S.RequestStatus).ERROR) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $bM50S.RequestStatus).ERROR);
        }
        // Don't allow the status to be marked as anything other than ERROR
        // if an error is pre-existing
        setValue((prev)=>{
            if (prev.status === (0, $bM50S.RequestStatus).ERROR) return prev;
            return {
                ...prev,
                status: newStatus === (0, $bM50S.RequestStatus).ERROR ? (0, $bM50S.RequestStatus).ERROR : (0, $bM50S.RequestStatus).LOADING
            };
        });
    }, [
        updateCurrentLoadingRequests,
        setValue
    ]);
    return {
        status: status,
        isComplete: isComplete,
        isError: isError,
        isLoading: isLoading,
        isLoaded: isLoaded,
        setStatus: setStatus
    };
}

});


parcelRegister("aZK2d", function(module, exports) {

$parcel$export(module.exports, "useURLBuilder", () => $4a9e4c2e72148c77$export$3748aab334e7d372);

var $5uXOq = parcelRequire("5uXOq");

var $bM50S = parcelRequire("bM50S");

var $2d2UJ = parcelRequire("2d2UJ");

var $5y96Z = parcelRequire("5y96Z");

var $fitJh = parcelRequire("fitJh");
var $4a9e4c2e72148c77$var$BFFEndpointsEnum = /*#__PURE__*/ function(BFFEndpointsEnum) {
    BFFEndpointsEnum["AVAILABLE_PRODUCTS"] = "/gateway/api/app-switcher/api/available-products";
    return BFFEndpointsEnum;
}($4a9e4c2e72148c77$var$BFFEndpointsEnum || {});
function $4a9e4c2e72148c77$export$3748aab334e7d372() {
    const { consumer: consumer } = (0, $fitJh.useConsumer)();
    const { items: cachedItems } = (0, $5y96Z.useCache)();
    const buildProductShortcutURL = (0, $5uXOq.useCallback)(({ requestedAPSKeys: requestedAPSKeys, baseUrl: baseUrl })=>{
        baseUrl = baseUrl ?? "/gateway/api/app-switcher/api/available-products";
        const availableKVPairs = requestedAPSKeys.filter((itemKey)=>!cachedItems.some((cachedItem)=>cachedItem.availableProducts.some((cap)=>cap.productType === itemKey))).map((itemKey)=>[
                'products',
                itemKey
            ]);
        // No point in building a URL if there are no items to fetch and the cache is already populated
        if (!availableKVPairs.length && cachedItems.length > 0) return '';
        // Exclude items that have already been cached
        // and convert to URL query string
        const queryValues = new URLSearchParams(availableKVPairs);
        return `${getHomeUrl()}${baseUrl}?${queryValues}`;
    }, [
        cachedItems
    ]);
    const buildURL = (0, $5uXOq.useCallback)(({ requestedAPSKeys: requestedAPSKeys, baseUrl: baseUrl })=>{
        let url = '';
        if (baseUrl) url = `${getHomeUrl()}${baseUrl}`;
        // Consumer specific URL building implementations happen here
        switch(consumer){
            case (0, $bM50S.BFFConsumerEnum).GLOBAL_SHORTCUTS:
                url = buildProductShortcutURL({
                    requestedAPSKeys: requestedAPSKeys
                });
                break;
        }
        if (!url) return url;
        // Append the consumer to the URL
        const formattedUrl = new URL(url);
        const updatedParams = new URLSearchParams(formattedUrl.search);
        if (consumer) updatedParams.append('consumer', consumer);
        return `${formattedUrl.origin}${formattedUrl.pathname}?${updatedParams}`;
    }, [
        buildProductShortcutURL,
        consumer
    ]);
    const getHomeUrl = ()=>{
        if ((0, $2d2UJ.isLocalHost)()) return 'https://home.stg.atlassian.com';
        return new URL(window.location.href).origin;
    };
    return {
        buildURL: buildURL,
        buildProductShortcutURL: buildProductShortcutURL
    };
}

});
parcelRegister("fitJh", function(module, exports) {

$parcel$export(module.exports, "useConsumer", () => $ecceea5d151877c3$export$33062d550933de6f);

var $5uXOq = parcelRequire("5uXOq");

var $hxfgo = parcelRequire("hxfgo");
function $ecceea5d151877c3$export$33062d550933de6f() {
    const { value: { consumer: consumer } } = (0, $5uXOq.useContext)((0, $hxfgo.BFFContext));
    return {
        consumer: consumer
    };
}

});



parcelRegister("16zmR", function(module, exports) {

$parcel$export(module.exports, "sortAlphabetically", () => $746c5d58d07b7130$export$60f5d4abb43a14b3);
const $746c5d58d07b7130$export$bc8c852df998b819 = (item)=>{
    return item.fallbackUrl !== undefined;
};
const $746c5d58d07b7130$export$60f5d4abb43a14b3 = (direction)=>(a, b)=>{
        const aLower = a.toLowerCase();
        const bLower = b.toLowerCase();
        if (direction === 'asc') return aLower.localeCompare(bLower);
        return bLower.localeCompare(aLower);
    };

});

parcelRegister("4Fmp4", function(module, exports) {

$parcel$export(module.exports, "ImageFromUrl", () => $37a56c96900f0504$export$8ce0ddc4c9a614d4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5FmWx = parcelRequire("5FmWx");
const $37a56c96900f0504$export$8ce0ddc4c9a614d4 = ({ src: src, alt: alt })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5FmWx.default), {
        src: src,
        alt: alt
    });
};

});

parcelRegister("h03gi", function(module, exports) {

$parcel$export(module.exports, "MenuExpandItem", () => $0a7781e7392bc123$export$3b6395e687b929ba);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $LD2gx = parcelRequire("LD2gx");

var $3senf = parcelRequire("3senf");
var $l7Vqz = parcelRequire("l7Vqz");
var $8luXP = parcelRequire("8luXP");

var $3yFuy = parcelRequire("3yFuy");

var $4IIGx = parcelRequire("4IIGx");

var $a5ChN = parcelRequire("a5ChN");

var $cEXCo = parcelRequire("cEXCo");
const $0a7781e7392bc123$export$3b6395e687b929ba = ({ icon: icon, label: label, items: items, disabled: disabled })=>{
    const createLinkItem = (0, $5uXOq.useCallback)((shortcut)=>{
        return shortcut.items ? /*#__PURE__*/ (0, $2OMIu.jsx)($0a7781e7392bc123$export$3b6395e687b929ba, {
            icon: shortcut.icon,
            label: shortcut.label,
            items: shortcut.items,
            disabled: disabled
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEXCo.MenuLinkItem), {
            apsKey: shortcut.apsKey,
            icon: shortcut.icon,
            url: shortcut.url || shortcut?.fallbackUrl?.(),
            label: shortcut.label,
            disabled: disabled
        });
    }, [
        disabled
    ]);
    if (disabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3yFuy.MenuButtonItem), {
        elemBefore: icon,
        elemAfter: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($LD2gx))), {
            label: "open menu"
        }),
        isDisabled: disabled,
        children: label
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3senf.FlyoutMenuItem), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8luXP.FlyoutMenuItemTrigger), {
                elemBefore: icon,
                children: label
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l7Vqz.FlyoutMenuItemContent), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a5ChN.MenuContent), {
                    title: label,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4IIGx.MenuList), {
                        children: items?.map(createLinkItem)
                    })
                })
            })
        ]
    });
};

});
parcelRegister("a5ChN", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $179ca09a2b97b4ef$export$479f0f2f71193efe);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");
const $179ca09a2b97b4ef$export$479f0f2f71193efe = ({ children: children, title: title })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $0yZbT.default), {
        xcss: $179ca09a2b97b4ef$var$menuContentContainerStyle,
        children: [
            title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                xcss: $179ca09a2b97b4ef$var$menuContentHeadingStyle,
                children: title
            }),
            children
        ]
    });
};
const $179ca09a2b97b4ef$var$menuContentContainerStyle = (0, $2s57o.xcss)({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxHeight: 'min(calc(100vh - 26px), 760px)'
});
const $179ca09a2b97b4ef$var$menuContentHeadingStyle = (0, $2s57o.xcss)({
    height: 'size.300',
    paddingBlock: 'space.075',
    paddingLeft: 'space.075',
    color: 'color.text.subtle',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    display: 'flex',
    alignItems: 'center'
});

});

parcelRegister("cEXCo", function(module, exports) {

$parcel$export(module.exports, "MenuLinkItem", () => $8b608ae1bc832127$export$68ef190193a37bc2);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $lNrAz = parcelRequire("lNrAz");

var $3yFuy = parcelRequire("3yFuy");

var $ctUNb = parcelRequire("ctUNb");

var $9cIbh = parcelRequire("9cIbh");
const $8b608ae1bc832127$export$68ef190193a37bc2 = ({ url: url, label: label, icon: icon, disabled: disabled })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // Don't render anything if url is undefined and disbaled is not explcitly set to true
    if (!url && !disabled) return null;
    // Render disabled items if no url and disabled is true
    if (!url || disabled) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3yFuy.MenuButtonItem), {
        elemBefore: icon,
        elemAfter: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lNrAz))), {
            label: ""
        }),
        isDisabled: true,
        children: [
            label,
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "aria-label": formatMessage((0, $9cIbh.messages).disabledItemAriaLabel)
            })
        ]
    });
    // Only render link item if url is defined
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ctUNb.MenuLinkItem), {
        elemBefore: icon,
        elemAfter: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lNrAz))), {
            label: "open external link"
        }),
        href: url,
        target: "_blank",
        children: label
    });
};

});
parcelRegister("9cIbh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9849bf20f1eecdad$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9849bf20f1eecdad$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    disabledItemAriaLabel: {
        id: 'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label',
        description: 'Additional context after the label text for screen reader users when an item is disabled',
        defaultMessage: '(currently unavailable)'
    }
});

});



parcelRegister("1sla0", function(module, exports) {

$parcel$export(module.exports, "MenuSkeletonItem", () => $26cad9decfa4e00a$export$cde35cc9e1359709);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");

var $4CMbn = parcelRequire("4CMbn");
const $26cad9decfa4e00a$var$DEFAULT_MENU_SKELETON_HEIGHT = 32;
const $26cad9decfa4e00a$var$DEFAULT_AVATAR_HEIGHT = 20;
const $26cad9decfa4e00a$var$DEFAULT_CONTENT_HEIGHT = 12;
const $26cad9decfa4e00a$var$DEFAULT_BORDER_RADIUS = 4;
const $26cad9decfa4e00a$var$menuSkeletonItemWrapperStyle = (0, $2s57o.xcss)({
    height: `${$26cad9decfa4e00a$var$DEFAULT_MENU_SKELETON_HEIGHT}px`,
    width: '100%',
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});
const $26cad9decfa4e00a$var$menuSkeletonItemAvatarStyle = (0, $2s57o.xcss)({
    paddingLeft: 'space.025'
});
const $26cad9decfa4e00a$export$cde35cc9e1359709 = ({ avatarHeight: avatarHeight = $26cad9decfa4e00a$var$DEFAULT_AVATAR_HEIGHT, contentHeight: contentHeight = $26cad9decfa4e00a$var$DEFAULT_CONTENT_HEIGHT })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bEIgH.default), {
        xcss: $26cad9decfa4e00a$var$menuSkeletonItemWrapperStyle,
        alignBlock: "center",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eWkgo.default), {
            alignItems: "center",
            gap: "space.050",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                    xcss: $26cad9decfa4e00a$var$menuSkeletonItemAvatarStyle,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4CMbn.default), {
                        width: avatarHeight,
                        height: avatarHeight,
                        borderRadius: $26cad9decfa4e00a$var$DEFAULT_BORDER_RADIUS
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4CMbn.default), {
                    width: "100%",
                    height: contentHeight,
                    borderRadius: "0"
                })
            ]
        })
    });
};

});


parcelRegister("l0mZw", function(module, exports) {

$parcel$export(module.exports, "default", () => $533db9df6909eb26$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kO0Ce = parcelRequire("kO0Ce");

var $6OEtC = parcelRequire("6OEtC");
function $533db9df6909eb26$export$2e2bcd8739ae039(fallbackUrl) {
    return {
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kO0Ce.ConfluenceIcon), {
            size: "20"
        }),
        label: 'Confluence',
        apsKey: (0, $6OEtC.Products).CONFLUENCE,
        fallbackUrl: fallbackUrl
    };
}

});
parcelRegister("kO0Ce", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $e5634192252b131f$export$68f3db7f6af48bcb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b19d10c2700941b3957759bbed4262ff>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eTliY = parcelRequire("eTliY");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $e5634192252b131f$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M17.495 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.697 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.257 6.361c-.25-.123-.52-.061-.645.227L6.447 9.14c-.125.288-.041.473.25.617"/>
</svg>
`;
const $e5634192252b131f$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" fill-rule="evenodd" d="M6 0a6 6 0 0 0-6 6v12a6 6 0 0 0 6 6h12a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6zm5.15 12.207c1.56 0 2.641.267 6.345 2.058.291.144.374.33.25.617l-1.166 2.553c-.125.288-.395.35-.645.226L13.48 16.51c-.853-.412-1.54-.577-2.122-.577-.665 0-1.186.288-1.768 1.173l-.375.577c-.125.185-.208.247-.333.247-.104 0-.208-.041-.332-.124l-2.351-1.461c-.23-.144-.292-.247-.292-.37 0-.124.042-.227.23-.515l.228-.35c1.394-2.14 2.954-2.902 4.785-2.902m1.893-.391c-1.56 0-2.643-.268-6.346-2.059-.291-.144-.375-.329-.25-.617l1.165-2.552c.125-.288.396-.35.645-.227l2.455 1.153c.853.412 1.54.576 2.122.576.666 0 1.186-.288 1.769-1.173l.374-.576c.125-.186.208-.247.333-.247.104 0 .208.04.333.123l2.351 1.462c.229.144.291.247.291.37 0 .124-.041.227-.229.515l-.228.35c-1.394 2.14-2.955 2.902-4.785 2.902" clip-rule="evenodd"/>
</svg>
`;
function $e5634192252b131f$export$68f3db7f6af48bcb({ size: size, appearance: appearance = 'brand', iconColor: iconColor, label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eTliY.IconWrapper), {
        svg: $e5634192252b131f$var$svg,
        customThemeSvg: $e5634192252b131f$var$customThemeSvg,
        size: size,
        appearance: appearance,
        iconColor: iconColor,
        label: label || 'Confluence',
        testId: testId
    });
}

});

parcelRegister("6OEtC", function(module, exports) {

$parcel$export(module.exports, "Products", () => $3b69a2e78d3bbf43$export$92e44ea1079b9ec6);
/**
 * Product keys as defined in flight-deck.
 * https://bitbucket.org/atlassian/flight-deck/src/master/packages/integrations/twp-switch-to-products/contrib/
 */ var $3b69a2e78d3bbf43$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    // ATLAS_* - Need to be standalone apps to sit in this space
    Products["ATLAS_HOME"] = "ATLAS_HOME";
    Products["ATLAS_GOALS"] = "ATLAS_GOALS";
    Products["ATLAS_TEAMS"] = "TEAMS";
    Products["ATLAS_HUB"] = "ATLAS_HUB";
    Products["ASSETS"] = "ASSETS";
    Products["BITBUCKET"] = "BITBUCKET";
    Products["COMPASS"] = "COMPASS";
    Products["FOCUS"] = "mercury";
    Products["STUDIO"] = "STUDIO";
    Products["JIRA_SERVICE_MANAGEMENT"] = "JIRA_SERVICE_MANAGEMENT";
    Products["JIRA_PRODUCT_DISCOVERY"] = "JIRA_PRODUCT_DISCOVERY";
    Products["JIRA_SOFTWARE"] = "JIRA_SOFTWARE";
    Products["CONFLUENCE"] = "CONFLUENCE";
    Products["LOOM"] = "LOOM";
    Products["PROJECTS"] = "PROJECTS";
    return Products;
}({});

});


parcelRegister("7lnZ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d34c335314748d5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3a51w = parcelRequire("3a51w");

var $6OEtC = parcelRequire("6OEtC");
function $3d34c335314748d5$export$2e2bcd8739ae039(fallbackUrl) {
    return {
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3a51w.LoomIcon), {
            size: "20"
        }),
        label: 'Loom',
        apsKey: (0, $6OEtC.Products).LOOM,
        fallbackUrl: fallbackUrl
    };
}

});
parcelRegister("3a51w", function(module, exports) {

$parcel$export(module.exports, "LoomIcon", () => $641817b18e17da46$export$8d789f76fde3e05);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::de5c69473813aa0b9cc332ff54c82b56>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eTliY = parcelRequire("eTliY");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $641817b18e17da46$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.438 11.173h-4.35l3.767-2.175-.827-1.433L14.26 9.74l2.174-3.767-1.433-.828-2.175 3.767v-4.35h-1.654v4.35L8.997 5.145l-1.432.827L9.739 9.74 5.972 7.565l-.827 1.433 3.767 2.175h-4.35v1.654h4.35l-3.767 2.175.827 1.433 3.767-2.174-2.175 3.767 1.433.827 2.175-3.767v4.35h1.655v-4.35L15 18.855l1.434-.828-2.175-3.767 3.767 2.175.827-1.433-3.767-2.174h4.35v-1.655M12 14.25a2.259 2.259 0 1 1 0-4.517 2.259 2.259 0 0 1 0 4.517"/>
</svg>
`;
function $641817b18e17da46$export$8d789f76fde3e05({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eTliY.IconWrapper), {
        svg: $641817b18e17da46$var$svg,
        size: size,
        appearance: appearance,
        label: label || 'Loom',
        testId: testId
    });
}

});


parcelRegister("btL7W", function(module, exports) {

$parcel$export(module.exports, "default", () => $97d966b528b702ed$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ab1Yt = parcelRequire("ab1Yt");

var $6OEtC = parcelRequire("6OEtC");
function $97d966b528b702ed$export$2e2bcd8739ae039(localizedName, fallbackUrl) {
    return {
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ab1Yt.GoalsIcon), {
            size: "20"
        }),
        label: localizedName,
        apsKey: (0, $6OEtC.Products).ATLAS_GOALS,
        fallbackUrl: fallbackUrl
    };
}

});

parcelRegister("jzdqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $5404b6b96516125a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $TnUYe = parcelRequire("TnUYe");
function $5404b6b96516125a$export$2e2bcd8739ae039(localizedName, fallbackUrl) {
    return {
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $TnUYe.ProjectsIcon), {
            size: "20"
        }),
        label: localizedName,
        fallbackUrl: fallbackUrl
    };
}

});
parcelRegister("TnUYe", function(module, exports) {

$parcel$export(module.exports, "ProjectsIcon", () => $f6d2bf7aee0f72f4$export$5ed3e1bb3b04fc02);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ad1525336cede63c7438ea96296ea57>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eTliY = parcelRequire("eTliY");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $f6d2bf7aee0f72f4$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="#dddee1" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="#101214" fill-rule="evenodd" d="m4.614 14.614 1.989-1.988-1.99-1.99L6.272 8.98h3.978l2.983-2.984h4.64v4.64L14.89 13.62v3.977l-1.657 1.658-1.99-1.99-1.988 1.99-1.821-1.822 2.983-2.983-.995-.994-2.983 2.983zm10.938-4.64a1.172 1.172 0 1 1-1.657-1.657 1.172 1.172 0 0 1 1.657 1.657" clip-rule="evenodd"/>
</svg>
`;
function $f6d2bf7aee0f72f4$export$5ed3e1bb3b04fc02({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eTliY.IconWrapper), {
        svg: $f6d2bf7aee0f72f4$var$svg,
        size: size,
        appearance: appearance,
        label: label || 'Projects',
        testId: testId
    });
}

});


parcelRegister("35Bd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5111e0e1c3495236$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1uGdm = parcelRequire("1uGdm");

var $6OEtC = parcelRequire("6OEtC");
function $5111e0e1c3495236$export$2e2bcd8739ae039(localizedName, fallbackUrl) {
    return {
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1uGdm.TeamsIcon), {
            size: "20"
        }),
        label: localizedName,
        apsKey: (0, $6OEtC.Products).ATLAS_TEAMS,
        fallbackUrl: fallbackUrl
    };
}

});
parcelRegister("1uGdm", function(module, exports) {

$parcel$export(module.exports, "TeamsIcon", () => $fa66b72a1d5deaeb$export$1bcbc9c337da86da);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd9106694d7b58995aa8188c7ae50b4e>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eTliY = parcelRequire("eTliY");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $fa66b72a1d5deaeb$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="#dddee1" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="#101214" d="M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63"/>
</svg>
`;
function $fa66b72a1d5deaeb$export$1bcbc9c337da86da({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eTliY.IconWrapper), {
        svg: $fa66b72a1d5deaeb$var$svg,
        size: size,
        appearance: appearance,
        label: label || 'Teams',
        testId: testId
    });
}

});


parcelRegister("31niQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fea74c19428fd5f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9fea74c19428fd5f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    atlasShortcutText: {
        "id": "jira.global-shortcuts.shortcut-text.atlas",
        "defaultMessage": "Atlas"
    },
    goalsShortcutText: {
        "id": "jira.global-shortcuts.shortcut-text.goals",
        "defaultMessage": "Goals"
    },
    projectsShortcutText: {
        "id": "jira.global-shortcuts.shortcut-text.projects",
        "defaultMessage": "Projects"
    },
    teamsShortcutText: {
        "id": "jira.global-shortcuts.shortcut-text.teams",
        "defaultMessage": "Teams"
    }
});

});






parcelRegister("ernoj", function(module, exports) {

$parcel$export(module.exports, "dashboardResources", () => $92d1f2722b27ff5d$export$50d95db618f58349);
$parcel$export(module.exports, "LazyDashboardView", () => $92d1f2722b27ff5d$export$c3bf98706b62de2b);
$parcel$export(module.exports, "LazyDashboardViewEmbed", () => $92d1f2722b27ff5d$export$94d85118d282a15);
$parcel$export(module.exports, "LazySystemDashboardEdit", () => $92d1f2722b27ff5d$export$c8d59d34c3e8f345);
$parcel$export(module.exports, "DashboardViewEmbedPage", () => $92d1f2722b27ff5d$export$86d9f777f9d4e312);
$parcel$export(module.exports, "SystemDashboardEditPage", () => $92d1f2722b27ff5d$export$dcd19a888f8c85c);

var $5uXOq = parcelRequire("5uXOq");

var $gh1hi = parcelRequire("gh1hi");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");
const $92d1f2722b27ff5d$export$50d95db618f58349 = ()=>[
        (0, $gh1hi.dashboardConfigAndWRMResource),
        (0, $gh1hi.dashboardAMDModulesResource),
        (0, $gh1hi.dashboardReactGadgetsResource),
        (0, $gh1hi.dashboardForgeResource)
    ];

const $92d1f2722b27ff5d$export$c3bf98706b62de2b = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9pTUp"))), {
    moduleId: "./src/packages/global-pages/dashboard/view/src/index.tsx"
});

const $92d1f2722b27ff5d$export$94d85118d282a15 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4ixqo"))), {
    moduleId: "./src/packages/global-pages/dashboard/view-embed/src/index.tsx"
});

const $92d1f2722b27ff5d$export$c8d59d34c3e8f345 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gRAYK"))), {
    moduleId: "./src/packages/spa-apps/dashboard/system-dashboard-edit/src/index.tsx"
});
const $92d1f2722b27ff5d$export$86d9f777f9d4e312 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $92d1f2722b27ff5d$export$94d85118d282a15,
        pageId: "dashboard",
        shouldShowSpinner: true
    });
const $92d1f2722b27ff5d$export$dcd19a888f8c85c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $92d1f2722b27ff5d$export$c8d59d34c3e8f345,
        pageId: "system-dashboard-edit",
        shouldShowSpinner: false
    });

});
parcelRegister("9pTUp", function(module, exports) {

let $6db1d12dbaac75aa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6db1d12dbaac75aa$var$load("gsMi3").then(()=>parcelRequire('iqENN'));

});

parcelRegister("4ixqo", function(module, exports) {

let $3212c54e0ebfe74b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3212c54e0ebfe74b$var$load("hXx3W").then(()=>parcelRequire('9aF4A'));

});

parcelRegister("gRAYK", function(module, exports) {

let $c46e47d274005d3b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c46e47d274005d3b$var$load("8AY7a").then(()=>parcelRequire('3VYlm'));

});



parcelRegister("56moC", function(module, exports) {

$parcel$export(module.exports, "dashboardRouteEntry", () => $1603466baea9815f$export$9fbbaafb58999ac3);

var $ffza4 = parcelRequire("ffza4");


var $e2ctp = parcelRequire("e2ctp");

var $gmpjq = parcelRequire("gmpjq");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fP8Ju = parcelRequire("fP8Ju");

var $4n0Oi = parcelRequire("4n0Oi");

var $ernoj = parcelRequire("ernoj");
const $1603466baea9815f$export$9fbbaafb58999ac3 = (0, $7NszV.createEntry)((0, $fP8Ju.dashboardRoute), ()=>({
        group: 'dashboard',
        component: (0, $4n0Oi.DashboardRedirect),
        layout: (0, $gmpjq.homepageLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ernoj.dashboardResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ernoj.LazyDashboardView)
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
        },
        isRedirect: true,
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("gmpjq", function(module, exports) {

$parcel$export(module.exports, "homepageLayout", () => $226ab3e64821f6b2$export$5b7fb151d60504c);

var $iqZds = parcelRequire("iqZds");

var $2BrOV = parcelRequire("2BrOV");

var $aPfsS = parcelRequire("aPfsS");
const $226ab3e64821f6b2$export$5b7fb151d60504c = (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), {
    // both of the components are wrapped with componentWithCondition
    globalComponents: [
        (0, $iqZds.AsyncTransitionHomeRenderer),
        (0, $iqZds.AsyncWelcomeModalRenderer)
    ]
});

});
parcelRegister("iqZds", function(module, exports) {

$parcel$export(module.exports, "AsyncTransitionHomeRenderer", () => $d1122e3218429f7d$export$cb38f5a820347580);
$parcel$export(module.exports, "AsyncWelcomeModalRenderer", () => $d1122e3218429f7d$export$9cda67d6c86d7b98);
$parcel$export(module.exports, "eocChangeboardingLayout", () => $d1122e3218429f7d$export$b8fa7ac7019001bb);

var $aPfsS = parcelRequire("aPfsS");

var $b7Svb = parcelRequire("b7Svb");

var $cSD7y = parcelRequire("cSD7y");

const $d1122e3218429f7d$export$cb38f5a820347580 = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("8MK9c")).then((module)=>module.TransitionHomeRenderer), {
    ssr: false,
    moduleId: "./src/packages/eoc/changeboarding/src/ui/transition-home/main.tsx"
});
$d1122e3218429f7d$export$cb38f5a820347580.displayName = 'AsyncTransitionHomeRenderer';

const $d1122e3218429f7d$export$9cda67d6c86d7b98 = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("tVM5l")).then((module)=>module.WelcomeModalRenderer), {
    ssr: false,
    moduleId: "./src/packages/eoc/changeboarding/src/ui/wizard/main.tsx"
});
$d1122e3218429f7d$export$9cda67d6c86d7b98.displayName = 'AsyncWelcomeModalRenderer';

const $d1122e3218429f7d$export$913f5a2340406083 = (0, $cSD7y.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("jfbqs")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/right-sidebars/index.tsx"
}), ()=>null);
$d1122e3218429f7d$export$913f5a2340406083.displayName = 'MigrationHubRightSidebar';

const $d1122e3218429f7d$export$6d7715b12d3ad17b = (0, $cSD7y.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("fSnIJ")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/onboarding/index.tsx"
}), ()=>null);
$d1122e3218429f7d$export$6d7715b12d3ad17b.displayName = 'MigrationHubOnboarding';
const $d1122e3218429f7d$export$b8fa7ac7019001bb = (0, $aPfsS.createLayout)({
    get globalComponents () {
        return [
            $d1122e3218429f7d$export$cb38f5a820347580,
            $d1122e3218429f7d$export$9cda67d6c86d7b98,
            $d1122e3218429f7d$export$6d7715b12d3ad17b
        ];
    },
    rightSidebars: [
        $d1122e3218429f7d$export$913f5a2340406083
    ]
});

});
parcelRegister("8MK9c", function(module, exports) {

let $66569a56359c381f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $66569a56359c381f$var$load("b3iUB").then(()=>parcelRequire('dsKht'));

});

parcelRegister("tVM5l", function(module, exports) {

let $059f865fb2ad8497$var$load = (parcelRequire("28QjX"))(4);
module.exports = $059f865fb2ad8497$var$load("9RY0k").then(()=>parcelRequire('cKcai'));

});

parcelRegister("jfbqs", function(module, exports) {

let $e02847f892fc5504$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e02847f892fc5504$var$load("7ctJN").then(()=>parcelRequire('eb0cf'));

});

parcelRegister("fSnIJ", function(module, exports) {

let $b8ee4c8f9ef54e60$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b8ee4c8f9ef54e60$var$load("jcgkF").then(()=>parcelRequire('kdZEd'));

});



parcelRegister("fP8Ju", function(module, exports) {

$parcel$export(module.exports, "dashboardRoute", () => $91c4527accb41ff2$export$3bf0ecb39349b6ef);
const $91c4527accb41ff2$export$3bf0ecb39349b6ef = {
    name: 'dashboard',
    path: '/secure/Dashboard.jspa'
};

});

parcelRegister("4n0Oi", function(module, exports) {

$parcel$export(module.exports, "DashboardRedirect", () => $55d04275d2bcfadf$export$da833ddcffcc38ba);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $ds5qV = parcelRequire("ds5qV");

var $9VXkC = parcelRequire("9VXkC");
var $doZTA = parcelRequire("doZTA");
const $55d04275d2bcfadf$export$da833ddcffcc38ba = ()=>{
    const [{ query: query, location: { hash: hash } }] = (0, $doZTA.useRouter)();
    const { path: path } = (0, $6jY6G.useRouteByName)('dashboard-view') ?? {};
    if (path == null) throw new Error('Dashboard view route not found');
    const { selectPageId: id } = query;
    const idParam = /^\d+$/.test(id) ? id : 'last-visited';
    const generatedPath = (0, $9VXkC.generatePath)(path, {
        dashboardId: idParam
    });
    const maximizedId = hash.match(/.*\/(?<id>\d+)/)?.groups?.id ?? null;
    const pathWithQuery = maximizedId !== null ? `${generatedPath}?maximized=${maximizedId}` : generatedPath;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: pathWithQuery,
        persistSearchParams: false
    });
};

});


parcelRegister("hfMX7", function(module, exports) {

$parcel$export(module.exports, "dashboardViewEmbedRouteEntry", () => $67a8397fa114200d$export$73a377380ff671af);

var $Xtn30 = parcelRequire("Xtn30");


var $e2ctp = parcelRequire("e2ctp");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $2Ql51 = parcelRequire("2Ql51");

var $joJjt = parcelRequire("joJjt");

var $ernoj = parcelRequire("ernoj");
const $67a8397fa114200d$export$73a377380ff671af = (0, $7NszV.createEntry)((0, $joJjt.dashboardViewEmbedRoute), ()=>({
        group: 'dashboard',
        component: (0, $ernoj.DashboardViewEmbedPage),
        layout: (0, $aPfsS.createLayout)({
            globalComponents: [
                (0, $Xtn30.DashboardBackgroundScripts)
            ],
            isChromeless: true
        }),
        resources: [
            (0, $2Ql51.themePreferenceResource),
            ...(0, $ernoj.dashboardResources)()
        ],
        forPaint: [
            (0, $ernoj.LazyDashboardViewEmbed)
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("joJjt", function(module, exports) {

$parcel$export(module.exports, "dashboardViewEmbedRoute", () => $47f4f3f379b59c3e$export$258b5e3f294617d2);
const $47f4f3f379b59c3e$export$258b5e3f294617d2 = {
    name: 'dashboard-view-embed',
    path: '/jira/dashboards/:dashboardId(\\d+)/embed',
    query: [],
    exact: true
};

});


parcelRegister("1zhx7", function(module, exports) {

$parcel$export(module.exports, "dashboardViewRouteEntry", () => $c891244b3388b2f7$export$18226b6422149926);

var $j6woB = parcelRequire("j6woB");


var $e2ctp = parcelRequire("e2ctp");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $5gOBf = parcelRequire("5gOBf");

var $7NAzY = parcelRequire("7NAzY");

var $lkFvK = parcelRequire("lkFvK");

var $fT58V = parcelRequire("fT58V");

var $h4rc7 = parcelRequire("h4rc7");

var $ernoj = parcelRequire("ernoj");
const $c891244b3388b2f7$export$18226b6422149926 = (0, $7NszV.createEntry)((0, $5gOBf.dashboardViewRoute), ()=>({
        group: 'dashboard',
        entryPoint: ()=>$c891244b3388b2f7$var$pageEntryPoint,
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $j6woB.dashboardBackgroundScriptsLayout)),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ernoj.dashboardResources)()
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY),
        ufoName: 'dashboard'
    }));
const $c891244b3388b2f7$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7NAzY.dashboardViewEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).DASHBOARDS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $h4rc7.nav4DashboardsContentEntryPoint)
            }
        }
    }
});

});
parcelRegister("5gOBf", function(module, exports) {

$parcel$export(module.exports, "dashboardViewRoute", () => $1aac2fbaf8a5979b$export$24f1b2ff97b9d3e6);
const $1aac2fbaf8a5979b$export$24f1b2ff97b9d3e6 = {
    name: 'dashboard-view',
    path: '/jira/dashboards/:dashboardId(\\d+|last-visited)',
    query: [
        'maximized?'
    ],
    exact: true
};

});

parcelRegister("7NAzY", function(module, exports) {

$parcel$export(module.exports, "dashboardViewEntryPoint", () => $eb6de38ddcb43951$export$acd33fbfe610d0e6);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $eb6de38ddcb43951$export$acd33fbfe610d0e6 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("9pTUp")), {
        moduleId: "2821e152"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});


parcelRegister("dxMNj", function(module, exports) {

$parcel$export(module.exports, "dashboardWallboardRouteEntry", () => $ae18a94b5423e69e$export$6009dd8e88f1a7de);

var $Xtn30 = parcelRequire("Xtn30");


var $e2ctp = parcelRequire("e2ctp");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $2Ql51 = parcelRequire("2Ql51");

var $TJQd9 = parcelRequire("TJQd9");

var $lkFvK = parcelRequire("lkFvK");

var $8RtQf = parcelRequire("8RtQf");

var $ernoj = parcelRequire("ernoj");
const $ae18a94b5423e69e$export$6009dd8e88f1a7de = (0, $7NszV.createEntry)((0, $TJQd9.dashboardWallboardRoute), ()=>({
        group: 'dashboard',
        entryPoint: ()=>$ae18a94b5423e69e$var$dashboardWallboardPageEntryPoint,
        layout: (0, $aPfsS.createLayout)({
            globalComponents: [
                (0, $Xtn30.DashboardBackgroundScripts)
            ],
            // we don't want nav bar and right panel etc to appear in wallboard, so we use chromeless mode
            isChromeless: true
        }),
        resources: [
            (0, $2Ql51.themePreferenceResource),
            ...(0, $ernoj.dashboardResources)()
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));
const $ae18a94b5423e69e$var$dashboardWallboardPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $8RtQf.dashboardWallboardEntryPoint)
});

});
parcelRegister("TJQd9", function(module, exports) {

$parcel$export(module.exports, "dashboardWallboardRoute", () => $59e2472cc6b14119$export$eaa33c953ab9ca63);
const $59e2472cc6b14119$export$eaa33c953ab9ca63 = {
    name: 'dashboard-wallboard',
    path: '/jira/dashboards/wallboard',
    query: [
        'dashboardId',
        'cyclePeriod?',
        'transitionFx?',
        'random?'
    ],
    exact: true
};

});

parcelRegister("8RtQf", function(module, exports) {

$parcel$export(module.exports, "dashboardWallboardEntryPoint", () => $a0f9d35bbcc604c1$export$99f21964c00b61ef);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $a0f9d35bbcc604c1$export$99f21964c00b61ef = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("eunv2")), {
        moduleId: "b10917db"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("eunv2", function(module, exports) {

let $a8c618927f16fff8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a8c618927f16fff8$var$load("luD3r").then(()=>parcelRequire('7ykDM'));

});



parcelRegister("eTL4x", function(module, exports) {

$parcel$export(module.exports, "selectedDashboardRouteEntry", () => $4fedf6a5f46c9101$export$ac09a8d3ecbafc5);

var $ffza4 = parcelRequire("ffza4");


var $e2ctp = parcelRequire("e2ctp");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $a1i1S = parcelRequire("a1i1S");

var $4n0Oi = parcelRequire("4n0Oi");

var $ernoj = parcelRequire("ernoj");
const $4fedf6a5f46c9101$export$ac09a8d3ecbafc5 = (0, $7NszV.createEntry)((0, $a1i1S.selectedDashboardRoute), ()=>({
        group: 'dashboard',
        component: (0, $4n0Oi.DashboardRedirect),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ernoj.dashboardResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ernoj.LazyDashboardView)
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
        },
        isRedirect: true,
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("a1i1S", function(module, exports) {

$parcel$export(module.exports, "selectedDashboardRoute", () => $f6e234b8f82fcbbd$export$b32070ee9554c3fb);
const $f6e234b8f82fcbbd$export$b32070ee9554c3fb = {
    name: 'dashboard-selected',
    path: '/secure/Dashboard.jspa',
    query: [
        'selectPageId'
    ]
};

});


parcelRegister("3av4N", function(module, exports) {

$parcel$export(module.exports, "systemDashboardEditRouteEntry", () => $29daafdf917937bc$export$15f76f1b0d2d671);

var $ffza4 = parcelRequire("ffza4");

var $j6woB = parcelRequire("j6woB");

var $e2ctp = parcelRequire("e2ctp");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $gh1hi = parcelRequire("gh1hi");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $3Zw20 = parcelRequire("3Zw20");

var $ernoj = parcelRequire("ernoj");
const $29daafdf917937bc$export$15f76f1b0d2d671 = (0, $7NszV.createEntry)((0, $3Zw20.systemDashboardEditRoute), ()=>({
        group: 'dashboard',
        component: (0, $ernoj.SystemDashboardEditPage),
        layout: (0, $aPfsS.composeLayouts)((0, $ibkIl.globalSettingsLayout), (0, $j6woB.dashboardBackgroundScriptsLayout)),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            // IMPORTANT - SSR requires wrm resource must come first
            ...(0, $ernoj.dashboardResources)(),
            (0, $gh1hi.gadgetDirectoryResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ernoj.LazySystemDashboardEdit)
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("3Zw20", function(module, exports) {

$parcel$export(module.exports, "systemDashboardEditRoute", () => $81fa712f0fcff9b5$export$7367fb465296c7dd);
const $81fa712f0fcff9b5$export$7367fb465296c7dd = {
    name: 'system-dashboard-edit',
    path: '/secure/admin/EditDefaultDashboard(!default)?.jspa',
    query: [
        'maximized?'
    ]
};

});


parcelRegister("hwgIz", function(module, exports) {

$parcel$export(module.exports, "devopsConnectedProjectRouteEntry", () => $b6b724158556afe3$export$ae258fb8ec2c1f86);

var $ffza4 = parcelRequire("ffza4");

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $cK8ht = parcelRequire("cK8ht");

var $6IcGP = parcelRequire("6IcGP");
const $b6b724158556afe3$export$ae258fb8ec2c1f86 = (0, $7NszV.createEntry)((0, $cK8ht.devopsConnectedProjectRoute), ()=>({
        group: 'devops',
        ufoName: 'devops.connected-project',
        component: (0, $6IcGP.default),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6IcGP.LazyDevopsConnectedProject)
        ]
    }));

});
parcelRegister("cK8ht", function(module, exports) {

$parcel$export(module.exports, "devopsConnectedProjectRoute", () => $52511ff99217f467$export$91257312631802bc);
const $52511ff99217f467$export$91257312631802bc = {
    name: 'devops-connected-project',
    path: '/jira/devops/connected-project'
};

});

parcelRegister("6IcGP", function(module, exports) {

$parcel$export(module.exports, "LazyDevopsConnectedProject", () => $31d281e7968db385$export$dcd3d20b0038b35c);
$parcel$export(module.exports, "default", () => $31d281e7968db385$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $31d281e7968db385$export$dcd3d20b0038b35c = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5zP8l"))), {
    moduleId: "./src/packages/spa-apps/devops-connected-project/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$31d281e7968db385$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $31d281e7968db385$export$dcd3d20b0038b35c,
        pageId: "devops-connected-project",
        shouldShowSpinner: true
    });

});
parcelRegister("5zP8l", function(module, exports) {

let $40f7e2ae0a129830$var$load = (parcelRequire("28QjX"))(4);
module.exports = $40f7e2ae0a129830$var$load("aS4l7").then(()=>parcelRequire('kGKHk'));

});



parcelRegister("3ss0y", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRedirectRouteEntry", () => $819db157557bdd41$export$2a34d21ecf479c40);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bPjHb = parcelRequire("bPjHb");

var $3RJkv = parcelRequire("3RJkv");

var $6tsdD = parcelRequire("6tsdD");

var $ds5qV = parcelRequire("ds5qV");

var $cFtGt = parcelRequire("cFtGt");

var $6Ja6c = parcelRequire("6Ja6c");
const $819db157557bdd41$var$BoardsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/boards"
    });
const $819db157557bdd41$export$2a34d21ecf479c40 = (0, $7NszV.createEntry)((0, $6tsdD.boardsDirectoryRedirectRoute), ()=>({
        group: 'directories',
        component: $819db157557bdd41$var$BoardsDirectoryRedirect,
        skeleton: (0, $cFtGt.BoardsDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bPjHb.boardsDirectoryResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6Ja6c.LazyBoardsDirectory)
        ],
        isRedirect: true
    }));

});
parcelRegister("bPjHb", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryResource", () => $817f387e86427323$export$2646f173fa2c14f2);

var $kbVA4 = parcelRequire("kbVA4");

var $2M1hQ = parcelRequire("2M1hQ");


const $817f387e86427323$export$2646f173fa2c14f2 = (0, $2M1hQ.createResource)({
    type: (0, $ee6731a28d0b2341$export$87526c4bd9c78abc),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("cPGFj")),
    maxAge: (0, $kbVA4.MIN_MAX_AGE)
});

});
const $ee6731a28d0b2341$export$87526c4bd9c78abc = 'BOARDS_DIRECTORY';

parcelRegister("cPGFj", function(module, exports) {

let $957b57e18cc16a08$var$load = (parcelRequire("28QjX"))(4);
module.exports = $957b57e18cc16a08$var$load("5815h").then(()=>parcelRequire('goVIR'));

});


parcelRegister("6tsdD", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRedirectRoute", () => $de45f7ff4b8bd3d7$export$a4fba1ebd6ba91ee);
const $de45f7ff4b8bd3d7$export$a4fba1ebd6ba91ee = {
    name: 'boards-directory-redirect',
    path: '/secure/ManageRapidViews.jspa'
};

});

parcelRegister("cFtGt", function(module, exports) {

$parcel$export(module.exports, "BoardsDirectorySkeleton", () => $4855316d4f3a3ac5$export$8194d6e87709f042);
$parcel$export(module.exports, "DashboardsDirectorySkeleton", () => $4855316d4f3a3ac5$export$75ef2bfed3801fb1);
$parcel$export(module.exports, "FiltersDirectorySkeleton", () => $4855316d4f3a3ac5$export$e76f94817327da1);
$parcel$export(module.exports, "ProjectsDirectorySkeleton", () => $4855316d4f3a3ac5$export$d94befb0e231760c);
$parcel$export(module.exports, "PlansDirectorySkeleton", () => $4855316d4f3a3ac5$export$6cd26a09efd6d158);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $5SWcj = parcelRequire("5SWcj");

var $8Ta6q = parcelRequire("8Ta6q");

var $4vyYK = parcelRequire("4vyYK");

var $4653I = parcelRequire("4653I");
const $4855316d4f3a3ac5$export$8194d6e87709f042 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5SWcj)))
    });
const $4855316d4f3a3ac5$export$75ef2bfed3801fb1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8Ta6q)))
    });
const $4855316d4f3a3ac5$export$e76f94817327da1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4vyYK)))
    });
const $4855316d4f3a3ac5$export$d94befb0e231760c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4653I)))
    });
const $4855316d4f3a3ac5$export$6cd26a09efd6d158 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4653I)))
    });

});
parcelRegister("5SWcj", function(module, exports) {
module.exports = new URL("boards-directory-app-skeleton.tpl.e4de30a4.svg", import.meta.url).toString();

});

parcelRegister("8Ta6q", function(module, exports) {
module.exports = new URL("dashboards-directory-app-skeleton.tpl.eb730072.svg", import.meta.url).toString();

});

parcelRegister("4vyYK", function(module, exports) {
module.exports = new URL("filters-directory-app-skeleton.tpl.6583ea61.svg", import.meta.url).toString();

});

parcelRegister("4653I", function(module, exports) {
module.exports = new URL("projects-directory-app-skeleton.tpl.a21368f6.svg", import.meta.url).toString();

});


parcelRegister("6Ja6c", function(module, exports) {

$parcel$export(module.exports, "LazyBoardsDirectory", () => $63ac430661b12a63$export$2826049ae45f4cd);

var $7yO8g = parcelRequire("7yO8g");

var $b7Svb = parcelRequire("b7Svb");

const $63ac430661b12a63$export$2826049ae45f4cd = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9wkEe"))), {
    moduleId: "./src/packages/spa-apps/directories/boards/src/index.tsx"
});

});
parcelRegister("9wkEe", function(module, exports) {

let $6ee71e7755de01ae$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6ee71e7755de01ae$var$load("as2Yi").then(()=>parcelRequire('3geiu'));

});



parcelRegister("bNtXI", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRouteEntry", () => $bb811a13740c7cf1$export$e78b34c999194638);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bPjHb = parcelRequire("bPjHb");

var $3RJkv = parcelRequire("3RJkv");

var $jP33S = parcelRequire("jP33S");

var $cFtGt = parcelRequire("cFtGt");

var $5j7Th = parcelRequire("5j7Th");

var $6Ja6c = parcelRequire("6Ja6c");
const $bb811a13740c7cf1$var$BoardsDirectoryComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $6Ja6c.LazyBoardsDirectory),
        pageId: "boards-directory",
        shouldShowSpinner: false
    });
const $bb811a13740c7cf1$export$e78b34c999194638 = (0, $7NszV.createEntry)((0, $jP33S.boardsDirectoryRoute), ()=>({
        group: 'directories',
        component: $bb811a13740c7cf1$var$BoardsDirectoryComponent,
        skeleton: (0, $cFtGt.BoardsDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bPjHb.boardsDirectoryResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6Ja6c.LazyBoardsDirectory)
        ]
    }));

});
parcelRegister("jP33S", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRoute", () => $3c2c0ea0e55873e8$export$f0fc6f4e8be87e85);
const $3c2c0ea0e55873e8$export$f0fc6f4e8be87e85 = {
    name: 'boards-directory',
    path: '/jira/boards'
};

});


parcelRegister("aNsRz", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRedirectRouteEntry", () => $3848740eee1bab7b$export$8dae8091f8e43b97);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $4yCf0 = parcelRequire("4yCf0");

var $3RJkv = parcelRequire("3RJkv");

var $2XHRw = parcelRequire("2XHRw");

var $ds5qV = parcelRequire("ds5qV");

var $cFtGt = parcelRequire("cFtGt");

var $aZoVa = parcelRequire("aZoVa");
const $3848740eee1bab7b$var$DashboardsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/dashboards"
    });
const $3848740eee1bab7b$export$8dae8091f8e43b97 = (0, $7NszV.createEntry)((0, $2XHRw.dashboardsDirectoryRedirectRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $4yCf0.dashboardsDirectoryResource)
        ],
        component: !false ? $3848740eee1bab7b$var$DashboardsDirectoryRedirect : (0, $aZoVa.DashboardsDirectoryComponent),
        skeleton: (0, $cFtGt.DashboardsDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aZoVa.LazyDashboardsDirectory)
        ],
        isRedirect: true
    }));

});
parcelRegister("4yCf0", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryResource", () => $c9ec3cc3b6c0608d$export$1cf6c7815471c2a2);

var $kbVA4 = parcelRequire("kbVA4");

var $2M1hQ = parcelRequire("2M1hQ");
const $c9ec3cc3b6c0608d$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY = 'DASHBOARDS_DIRECTORY';

const $c9ec3cc3b6c0608d$export$1cf6c7815471c2a2 = (0, $2M1hQ.createResource)({
    type: $c9ec3cc3b6c0608d$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("fajZZ")),
    maxAge: (0, $kbVA4.MIN_MAX_AGE)
});

});
parcelRegister("fajZZ", function(module, exports) {

let $b0a74d8e4c5e4f81$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b0a74d8e4c5e4f81$var$load("yne3O").then(()=>parcelRequire('ciD6c'));

});


parcelRegister("2XHRw", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRedirectRoute", () => $55fec75e9850e3c3$export$b96f6fb3c35a6fe5);
const $55fec75e9850e3c3$export$b96f6fb3c35a6fe5 = {
    name: 'dashboards-directory-secure',
    path: '/secure/ConfigurePortalPages(!default.jspa|.jspa)'
};

});

parcelRegister("aZoVa", function(module, exports) {

$parcel$export(module.exports, "LazyDashboardsDirectory", () => $cd7e3d13d091ccad$export$f2f3fd22cd37e121);
$parcel$export(module.exports, "DashboardsDirectoryComponent", () => $cd7e3d13d091ccad$export$1cc6cc01050e1215);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $cd7e3d13d091ccad$export$f2f3fd22cd37e121 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8MwO1"))), {
    moduleId: "./src/packages/spa-apps/directories/dashboards/src/index.tsx"
});
const $cd7e3d13d091ccad$export$1cc6cc01050e1215 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cd7e3d13d091ccad$export$f2f3fd22cd37e121,
        pageId: "dashboards-directory",
        shouldShowSpinner: false
    });

});
parcelRegister("8MwO1", function(module, exports) {

let $664c40f642496098$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $664c40f642496098$var$load("h2MrD"),
    $664c40f642496098$var$load("bYT2S"),
    $664c40f642496098$var$load("e9jXk")
]).then(()=>parcelRequire('76rrf'));

});



parcelRegister("cmvi5", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRouteEntry", () => $bc6135fca4882261$export$748e329bd0c282a);

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $4yCf0 = parcelRequire("4yCf0");

var $3RJkv = parcelRequire("3RJkv");

var $dDmlh = parcelRequire("dDmlh");

var $cFtGt = parcelRequire("cFtGt");

var $lkFvK = parcelRequire("lkFvK");

var $fT58V = parcelRequire("fT58V");

var $h4rc7 = parcelRequire("h4rc7");

var $keYV7 = parcelRequire("keYV7");
const $bc6135fca4882261$export$748e329bd0c282a = (0, $7NszV.createEntry)((0, $dDmlh.dashboardsDirectoryRoute), ()=>({
        group: 'directories',
        entryPoint: ()=>$bc6135fca4882261$var$pageEntryPoint,
        skeleton: (0, $cFtGt.DashboardsDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $4yCf0.dashboardsDirectoryResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).CONTENT
        }
    }));
// Page entrypoint, referred to above...
const $bc6135fca4882261$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $keYV7.dashboardDirectoryEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).DASHBOARDS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $h4rc7.nav4DashboardsContentEntryPoint)
            }
        }
    }
});

});
parcelRegister("keYV7", function(module, exports) {

$parcel$export(module.exports, "dashboardDirectoryEntryPoint", () => $483e18a450676181$export$3325d832741ebeb3);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $483e18a450676181$export$3325d832741ebeb3 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("8MwO1")), {
        moduleId: "933882c8"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});


parcelRegister("8fgeg", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRedirectRouteEntry", () => $03e59a293d347a10$export$41fb3f2a3e68c7c3);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $dRl24 = parcelRequire("dRl24");

var $3RJkv = parcelRequire("3RJkv");

var $hCC3D = parcelRequire("hCC3D");

var $cFtGt = parcelRequire("cFtGt");

var $7RZwy = parcelRequire("7RZwy");
const $03e59a293d347a10$export$41fb3f2a3e68c7c3 = (0, $7NszV.createEntry)((0, $hCC3D.filtersDirectoryRedirectRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $dRl24.filtersDirectoryResource)
        ],
        component: !false ? (0, $7RZwy.FiltersDirectoryRedirect) : (0, $7RZwy.FiltersDirectoryComponent),
        skeleton: (0, $cFtGt.FiltersDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).FILTERS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7RZwy.LazyFiltersDirectory)
        ],
        isRedirect: true
    }));

});
parcelRegister("dRl24", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryResource", () => $8b127055fac893b8$export$53f99086c62225b6);

var $kbVA4 = parcelRequire("kbVA4");

var $2M1hQ = parcelRequire("2M1hQ");


const $8b127055fac893b8$export$53f99086c62225b6 = (0, $2M1hQ.createResource)({
    type: (0, $6d3ffd6df613c846$export$79e191bf6cb15284),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("fFbEp")),
    maxAge: (0, $kbVA4.MIN_MAX_AGE)
});

});
const $6d3ffd6df613c846$export$79e191bf6cb15284 = 'FILTERS_DIRECTORY';

parcelRegister("fFbEp", function(module, exports) {

let $b673b8f965701ce5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b673b8f965701ce5$var$load("8fxmU").then(()=>parcelRequire('cK9UE'));

});


parcelRegister("hCC3D", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRedirectRoute", () => $2881371d3e73fb66$export$f4f86e1ddc30a625);
const $2881371d3e73fb66$export$f4f86e1ddc30a625 = {
    name: 'filters-directory-redirect',
    path: '/ManageFilters.jspa'
};

});

parcelRegister("7RZwy", function(module, exports) {

$parcel$export(module.exports, "FiltersDirectoryRedirect", () => $37b0d6d8034450f5$export$c56e739d3bb1fe19);
$parcel$export(module.exports, "LazyFiltersDirectory", () => $37b0d6d8034450f5$export$cc133cd5c6f1b69d);
$parcel$export(module.exports, "FiltersDirectoryComponent", () => $37b0d6d8034450f5$export$e5d735e83dacb7c7);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");
const $37b0d6d8034450f5$export$c56e739d3bb1fe19 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/filters"
    });

const $37b0d6d8034450f5$export$cc133cd5c6f1b69d = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7T7Xp"))), {
    moduleId: "./src/packages/spa-apps/directories/filters/src/index.tsx"
});
const $37b0d6d8034450f5$export$e5d735e83dacb7c7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $37b0d6d8034450f5$export$cc133cd5c6f1b69d,
        pageId: "filters-directory",
        shouldShowSpinner: false
    });

});
parcelRegister("7T7Xp", function(module, exports) {

let $5be3d7930eb0134a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5be3d7930eb0134a$var$load("hPzOn"),
    $5be3d7930eb0134a$var$load("cM9em"),
    $5be3d7930eb0134a$var$load("fr9NE"),
    $5be3d7930eb0134a$var$load("h2MrD"),
    $5be3d7930eb0134a$var$load("bYT2S"),
    $5be3d7930eb0134a$var$load("7rph3")
]).then(()=>parcelRequire('3Zqmb'));

});



parcelRegister("f7gaE", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRouteEntry", () => $3947322b61fcc480$export$ca77bc660994f51f);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $dRl24 = parcelRequire("dRl24");

var $3RJkv = parcelRequire("3RJkv");

var $b6S3k = parcelRequire("b6S3k");

var $cFtGt = parcelRequire("cFtGt");

var $7RZwy = parcelRequire("7RZwy");
const $3947322b61fcc480$export$ca77bc660994f51f = (0, $7NszV.createEntry)((0, $b6S3k.filtersDirectoryRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $dRl24.filtersDirectoryResource)
        ],
        component: (0, $7RZwy.FiltersDirectoryComponent),
        skeleton: (0, $cFtGt.FiltersDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).FILTERS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7RZwy.LazyFiltersDirectory)
        ]
    }));

});

parcelRegister("pRrpu", function(module, exports) {

$parcel$export(module.exports, "manageProjectsDirectoryRouteEntry", () => $e28e6d3f170e3052$export$d5b1a46987369ee4);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $4jMkc = parcelRequire("4jMkc");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fsqMg = parcelRequire("fsqMg");

var $cFtGt = parcelRequire("cFtGt");

var $5j7Th = parcelRequire("5j7Th");

var $fbnvY = parcelRequire("fbnvY");

var $fhRbA = parcelRequire("fhRbA");

var $jL5x9 = parcelRequire("jL5x9");
const $e28e6d3f170e3052$var$LazyAdminProjectsDirectory = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhRbA.LazyProjectsDirectory), {
        isAdminProjectDirectoryRoute: true
    });
const $e28e6d3f170e3052$var$ProjectsDirectoryManageComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e28e6d3f170e3052$var$LazyAdminProjectsDirectory,
        pageId: "projects-directory-manage-v3",
        shouldShowSpinner: false
    });
const $e28e6d3f170e3052$export$d5b1a46987369ee4 = (0, $7NszV.createEntry)((0, $fsqMg.manageProjectsDirectoryRoute), ()=>({
        group: 'directories',
        component: $e28e6d3f170e3052$var$ProjectsDirectoryManageComponent,
        skeleton: (0, $cFtGt.ProjectsDirectorySkeleton),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $fbnvY.adminProjectDirectoryResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fhRbA.LazyProjectsDirectory)
        ],
        ufoName: 'projects-directory-v3-manage',
        entryPoint () {
            return 0, $jL5x9.ProjectsDirectoryPageEntryPoint;
        }
    }));

});
parcelRegister("fsqMg", function(module, exports) {

$parcel$export(module.exports, "manageProjectsDirectoryRoute", () => $3dd7670289805d41$export$281a4490a0f8fb4c);
const $3dd7670289805d41$export$281a4490a0f8fb4c = {
    name: 'projects-directory-manage',
    path: '/jira/settings/projects/manage'
};

});

parcelRegister("fbnvY", function(module, exports) {

$parcel$export(module.exports, "adminProjectDirectoryResources", () => $9521a93df7bbe3a1$export$1b29db6307155621);

var $atU1t = parcelRequire("atU1t");

var $hW253 = parcelRequire("hW253");
const $9521a93df7bbe3a1$export$1b29db6307155621 = ()=>[
        (0, $atU1t.navigationSidebarGlobalResource),
        (0, $hW253.projectsDirectoryPageResource)
    ];

});
parcelRegister("hW253", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryPageResource", () => $4c805bc331263d5b$export$aabb201a7f7100c5);
/* eslint-disable jira/import-whitelist */ 
var $8Uumt = parcelRequire("8Uumt");

var $gkT9B = parcelRequire("gkT9B");

var $8pIiT = parcelRequire("8pIiT");

var $5yJb9 = parcelRequire("5yJb9");

var $kipqU = parcelRequire("kipqU");

var $ao2h1 = parcelRequire("ao2h1");

var $lVQ0r = parcelRequire("lVQ0r");

var $2M1hQ = parcelRequire("2M1hQ");

const $4c805bc331263d5b$export$aabb201a7f7100c5 = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${(0, $ce818d5819645fe8$export$2150caade62dc875)}`,
    getKey: ()=>'projects-directory-relay',
    // @ts-expect-error - might return null
    getData: async ({ query: query, route: route }, { tenantContext: tenantContext })=>{
        const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should temporally disable anonymous SSR until
        // the underlying auth issues have been fixed. Duplo team will push the real fix later.
        if (false && isAnonymous) return null;
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $lVQ0r.default), {
            cloudId: tenantContext.cloudId,
            filter: (0, $8pIiT.mapQueryToFilter)((0, $gkT9B.filterInitialState), {
                cloudId: cloudId,
                query: (0, $8pIiT.sanitizeLegacyQuery)(query),
                aliases: (0, $gkT9B.filterAliasMap)
            }),
            first: query?.page ? (0, $gkT9B.DEFAULT_LIMIT) * (parseInt(query.page, 10) || 1) : (0, $gkT9B.DEFAULT_LIMIT),
            last: (0, $gkT9B.DEFAULT_LIMIT),
            isAdminSettingsContext: route.name === 'projects-directory-manage',
            isAnonymous: isAnonymous
        }, {
            fetchPolicy: 'network-only'
        });
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    }
});

});
parcelRegister("gkT9B", function(module, exports) {

$parcel$export(module.exports, "TableColumns", () => $4e4ac97bc1b1894b$export$b0e68791ad9c52df);
$parcel$export(module.exports, "SortableColumns", () => $4e4ac97bc1b1894b$export$f9e740ef44a4c43a);
$parcel$export(module.exports, "FilterFields", () => $4e4ac97bc1b1894b$export$e38c2fbdcbc20613);
$parcel$export(module.exports, "filterAliasMap", () => $4e4ac97bc1b1894b$export$5bc0ad9873e5cd89);
$parcel$export(module.exports, "filterInitialState", () => $4e4ac97bc1b1894b$export$fcb7b3e474e67781);
$parcel$export(module.exports, "DEFAULT_LIMIT", () => $4e4ac97bc1b1894b$export$ebc5ec3267fbcf57);
$parcel$export(module.exports, "PROJECTS_DIRECTORY_EXPERIENCE", () => $4e4ac97bc1b1894b$export$7c1bd7128901e2c4);
$parcel$export(module.exports, "MANAGE_PROJECTS_DIRECTORY_EXPERIENCE", () => $4e4ac97bc1b1894b$export$72fb94bf1b8ec849);
// eslint-disable-next-line jira/import-whitelist

var $7OwSg = parcelRequire("7OwSg");
const $4e4ac97bc1b1894b$export$b0e68791ad9c52df = {
    Favourites: 'favourite',
    Key: 'key',
    Name: 'name',
    Type: 'type',
    Lead: 'lead',
    Category: 'category',
    LastIssueUpdate: 'last_issue_updated_time',
    Url: 'url',
    Action: 'actions'
};
const $4e4ac97bc1b1894b$export$f9e740ef44a4c43a = [
    $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Favourites,
    $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Key,
    $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Name,
    $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Lead,
    $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Category,
    $4e4ac97bc1b1894b$export$b0e68791ad9c52df.LastIssueUpdate
];
const $4e4ac97bc1b1894b$export$e38c2fbdcbc20613 = {
    Keyword: 'keyword',
    ProjectType: 'types',
    ProjectTypeLabel: 'ProjectTypeLabel',
    ProjectCategoryId: 'projectCategoryId',
    ProjectCategoryLabel: 'projectCategoryLabel',
    ...(0, $7OwSg.DefaultFilterFields)
};
const $4e4ac97bc1b1894b$export$5bc0ad9873e5cd89 = {
    contains: $4e4ac97bc1b1894b$export$e38c2fbdcbc20613.Keyword,
    selectedProjectType: $4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectType,
    selectedCategory: $4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectCategoryId
};
const $4e4ac97bc1b1894b$export$fcb7b3e474e67781 = {
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.Keyword]: '',
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectType]: '',
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectTypeLabel]: '',
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectCategoryId]: '',
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectCategoryLabel]: '',
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.SortOrder]: 'ASC',
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.SortKey]: $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Name,
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.Page]: '1'
};
const $4e4ac97bc1b1894b$export$ebc5ec3267fbcf57 = 25;
const $4e4ac97bc1b1894b$export$7c1bd7128901e2c4 = 'viewProjectsDirectoryV3';
const $4e4ac97bc1b1894b$export$72fb94bf1b8ec849 = 'viewManageProjectsDirectoryV3';

});
parcelRegister("7OwSg", function(module, exports) {

$parcel$export(module.exports, "DefaultFilterFields", () => $30cd11272c627f6b$export$7ecdd4b6ae40e139);
$parcel$export(module.exports, "createUseFilter", () => $30cd11272c627f6b$export$ef79d9c1dcb09f8f);

var $ebyGx = parcelRequire("ebyGx");

var $jcw0u = parcelRequire("jcw0u");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $30cd11272c627f6b$export$7ecdd4b6ae40e139 = {
    // sorting
    SortOrder: 'sortOrder',
    SortKey: 'sortKey',
    // pagination
    Page: 'page'
};
const $30cd11272c627f6b$export$ef79d9c1dcb09f8f = (storeName, { getInitialState: getInitialState })=>{
    const actions = {
        updateFilter: (nameOrFilter, value)=>({ setState: setState, getState: getState }, { onUpdate: onUpdate })=>{
                const newFilter = typeof nameOrFilter === 'object' ? nameOrFilter : {
                    [nameOrFilter]: value
                };
                setState({
                    ...getState(),
                    [$30cd11272c627f6b$export$7ecdd4b6ae40e139.Page]: 1,
                    ...newFilter
                });
                onUpdate(getState());
            },
        forceUpdate: ()=>({ getState: getState }, { onUpdate: onUpdate })=>onUpdate(getState())
    };
    const Store = (0, $iXqE5.createStore)({
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        initialState: {},
        actions: actions,
        name: storeName
    });
    const useFilter = (0, $3sQ5x.createHook)(Store);
    const useScopedFilter = (0, $3sQ5x.createHook)(Store, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        selector: (state, name)=>state[name]
    });
    const FilterContainer = (0, $gg7kZ.createContainer)(Store, {
        onInit: ()=>({ setState: setState })=>{
                try {
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    const routeQuery = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(window.location.search);
                    setState(getInitialState({
                        routeQuery: routeQuery
                    }));
                } catch (error) {
                    (0, $jcw0u.default)({
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        error: error,
                        meta: {
                            id: 'createUseFilter',
                            packageName: 'jiraDirectoryBaseV3',
                            teamName: 'jira-cosmos'
                        }
                    });
                }
            },
        // reset initial state on unmount
        onCleanup: ()=>({ setState: setState })=>setState(getInitialState({
                    routeQuery: {}
                }))
    });
    return {
        useFilter: useFilter,
        useScopedFilter: useScopedFilter,
        FilterContainer: FilterContainer
    };
};

});


parcelRegister("8pIiT", function(module, exports) {

$parcel$export(module.exports, "sanitizeLegacyQuery", () => $ddc7efe5cefc2e09$export$b6d5141c3209bd35);
$parcel$export(module.exports, "mapQueryToFilter", () => $ddc7efe5cefc2e09$export$2274cd5f35844a96);

var $4R6GH = parcelRequire("4R6GH");

var $1Jl81 = parcelRequire("1Jl81");

var $kVKQx = parcelRequire("kVKQx");

var $2vSU6 = parcelRequire("2vSU6");

var $dZhZb = parcelRequire("dZhZb");

var $dXq4S = parcelRequire("dXq4S");

var $gkT9B = parcelRequire("gkT9B");
const $ddc7efe5cefc2e09$var$LEGACY_ALL_VALUE = 'all';
const $ddc7efe5cefc2e09$export$b6d5141c3209bd35 = (query)=>({
        ...query,
        selectedProjectType: query.selectedProjectType === $ddc7efe5cefc2e09$var$LEGACY_ALL_VALUE ? (0, $gkT9B.filterInitialState)[(0, $gkT9B.FilterFields).ProjectType] : query.selectedProjectType,
        selectedCategory: query.selectedCategory === $ddc7efe5cefc2e09$var$LEGACY_ALL_VALUE ? (0, $gkT9B.filterInitialState)[(0, $gkT9B.FilterFields).ProjectCategoryId] : query.selectedCategory
    });
const $ddc7efe5cefc2e09$export$2274cd5f35844a96 = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
    const variables = {};
    const { [(0, $gkT9B.FilterFields).Keyword]: keyword, [(0, $gkT9B.FilterFields).ProjectCategoryId]: projectCategoryId, [(0, $gkT9B.FilterFields).ProjectType]: types, [(0, $gkT9B.FilterFields).SortOrder]: sortOrder, [(0, $gkT9B.FilterFields).SortKey]: sortKey } = aliases && query ? (0, $dZhZb.matchAliases)(filter, query, aliases) : filter; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    if (keyword) variables.keyword = keyword;
    if (projectCategoryId) {
        const isAlreadyAri = (0, $4R6GH.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $1Jl81.AnyAri).check(projectCategoryId) : (0, $dXq4S.isAri)(projectCategoryId);
        if (isAlreadyAri) variables.projectCategoryId = projectCategoryId;
        else variables.projectCategoryId = (0, $4R6GH.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $kVKQx.JiraProjectCategoryAri).create({
            projectCategoryId: projectCategoryId,
            siteId: cloudId
        }).toString() : (0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project-category',
            resourceId: projectCategoryId
        });
    }
    if (sortKey || sortOrder) {
        const sortByValue = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        sortKey && (0, $gkT9B.SortableColumns).includes(sortKey) ? sortKey : (0, $gkT9B.filterInitialState)[(0, $gkT9B.FilterFields).SortKey];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        variables.sortBy = {
            order: [
                'ASC',
                'DESC'
            ].includes(sortOrder) ? sortOrder : (0, $gkT9B.filterInitialState)[(0, $gkT9B.FilterFields).SortOrder],
            sortBy: sortByValue.toUpperCase()
        };
    }
    if (types && typeof types === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    variables.types = types.split(',') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .filter((type)=>(0, $2vSU6.PROJECT_TYPES).includes(type)).map((type)=>type.toUpperCase());
    return variables;
};

});
parcelRegister("kVKQx", function(module, exports) {

$parcel$export(module.exports, "JiraProjectCategoryAri", () => $f3cd7835c441b268$export$da484aad24207e3d);

var $g0RIi = parcelRequire("g0RIi");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/project-category/manifest.ts
var $f3cd7835c441b268$var$jiraProjectCategoryAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $g0RIi.JiraProjectCategoryAriResourceOwner),
    resourceType: (0, $g0RIi.JiraProjectCategoryAriResourceType),
    resourceIdSlug: "{projectCategoryId}",
    resourceIdSegmentFormats: {
        projectCategoryId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/project-category/index.ts
var $f3cd7835c441b268$export$da484aad24207e3d = class _JiraProjectCategoryAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._projectCategoryId = opts.resourceIdSegmentValues.projectCategoryId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectCategoryId() {
        return this._projectCategoryId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f3cd7835c441b268$var$jiraProjectCategoryAriStaticOpts.qualifier,
            platformQualifier: $f3cd7835c441b268$var$jiraProjectCategoryAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f3cd7835c441b268$var$jiraProjectCategoryAriStaticOpts.resourceOwner,
            resourceType: $f3cd7835c441b268$var$jiraProjectCategoryAriStaticOpts.resourceType,
            resourceId: `${opts.projectCategoryId}`,
            resourceIdSegmentValues: {
                projectCategoryId: opts.projectCategoryId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $f3cd7835c441b268$var$jiraProjectCategoryAriStaticOpts);
        return new _JiraProjectCategoryAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $f3cd7835c441b268$var$jiraProjectCategoryAriStaticOpts);
        return new _JiraProjectCategoryAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectCategoryId: this.projectCategoryId
        };
    }
};

});
parcelRegister("g0RIi", function(module, exports) {

$parcel$export(module.exports, "JiraProjectCategoryAriResourceOwner", () => $ba864fca2e893f55$export$b4df372413a623f1);
$parcel$export(module.exports, "JiraProjectCategoryAriResourceType", () => $ba864fca2e893f55$export$51b6f2a645c9e23a);
// src/jira/project-category/types.ts
var $ba864fca2e893f55$export$b4df372413a623f1 = "jira", $ba864fca2e893f55$export$51b6f2a645c9e23a = "project-category";

});


parcelRegister("dZhZb", function(module, exports) {

$parcel$export(module.exports, "matchAliases", () => $e41b5d91b7cfd8ce$export$55f686d7a3507dbe);
$parcel$export(module.exports, "serializeSelectOptions", () => $e41b5d91b7cfd8ce$export$74a705e0bee1565b);
$parcel$export(module.exports, "serializeSelectOptionsLabel", () => $e41b5d91b7cfd8ce$export$eed751fcc55ddadd);
$parcel$export(module.exports, "matchValueToSelectOptions", () => $e41b5d91b7cfd8ce$export$17e142fa55464467);

var $ggSx2 = parcelRequire("ggSx2");

var $cuHs1 = parcelRequire("cuHs1");
const $e41b5d91b7cfd8ce$export$55f686d7a3507dbe = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const alias = aliases[key];
        const queryValue = query[key];
        const hasInitialValue = filter[key] !== undefined;
        // override default filter value with query params
        if (hasInitialValue && queryValue) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            filter[key] = queryValue;
            return filter;
        }
        // if there's no alias and no query param for it return default filter
        if (!alias || !queryValue) return filter;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
        filter[alias] = queryValue;
        return filter;
    }, {
        ...filterState
    });
const $e41b5d91b7cfd8ce$export$40bf1812f0f07002 = (data, aliases)=>{
    const invertedAliases = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))(aliases);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cuHs1)))(data, (_, key)=>invertedAliases[key] || key);
};
const $e41b5d91b7cfd8ce$export$74a705e0bee1565b = (options)=>options.map((v)=>v.value).join(',');
const $e41b5d91b7cfd8ce$export$eed751fcc55ddadd = (options)=>options.map((v)=>v.label).join(',');
const $e41b5d91b7cfd8ce$export$17e142fa55464467 = (value, options)=>value ? value.split(',').map((val)=>options.find((option)=>option.value === val)).filter(Boolean) : [];

});
parcelRegister("ggSx2", function(module, exports) {

var $cxSdl = parcelRequire("cxSdl");

var $fxKlj = parcelRequire("fxKlj");

var $etyzk = parcelRequire("etyzk");
/** Used for built-in method references. */ var $bd8870e21c3833a0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $bd8870e21c3833a0$var$nativeObjectToString = $bd8870e21c3833a0$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $bd8870e21c3833a0$var$invert = $fxKlj(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $bd8870e21c3833a0$var$nativeObjectToString.call(value);
    result[value] = key;
}, $cxSdl($etyzk));
module.exports = $bd8870e21c3833a0$var$invert;

});
parcelRegister("fxKlj", function(module, exports) {

var $d1nCg = parcelRequire("d1nCg");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $b50de2cb57eb155c$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $d1nCg(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = $b50de2cb57eb155c$var$createInverter;

});
parcelRegister("d1nCg", function(module, exports) {

var $hDnyx = parcelRequire("hDnyx");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $97adb007e27dc709$var$baseInverter(object, setter, iteratee, accumulator) {
    $hDnyx(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = $97adb007e27dc709$var$baseInverter;

});



parcelRegister("cuHs1", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $hDnyx = parcelRequire("hDnyx");

var $bxDef = parcelRequire("bxDef");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $0258ef72e36fbfcb$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $bxDef(iteratee, 3);
    $hDnyx(object, function(value, key, object) {
        $1m3dq(result, iteratee(value, key, object), value);
    });
    return result;
}
module.exports = $0258ef72e36fbfcb$var$mapKeys;

});



parcelRegister("lVQ0r", function(module, exports) {

$parcel$export(module.exports, "default", () => $0264f0fee7e7a1be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4f241df3a6ea0e25359d8080940f5802>>
 * @relayHash 9748961340a0877dad06569907936559
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da04654402c040cfb1a5731e6742c8a699abdddac45bfc2bc9c768547f13bcf3

var $eiowN = parcelRequire("eiowN");
const $0264f0fee7e7a1be$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAdminSettingsContext"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "isAnonymous",
            "variableName": "isAnonymous"
        }
    ], v7 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v8 = {
        "alias": "canBrowseProjects",
        "args": [
            v7 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "type",
                "value": "BROWSE_PROJECTS"
            }
        ],
        "concreteType": "JiraPermission",
        "kind": "LinkedField",
        "name": "permission",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasPermission"
            }
        ]
    }, v9 = [
        v7 /*: any*/ 
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "key"
    }, v16 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v17 = {
        "kind": "ScalarField",
        "name": "totalCount"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "header_projectsDirectoryV3"
                },
                {
                    "args": v6 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "refinementBar_projectsDirectoryV3_Filters"
                },
                {
                    "args": v6 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "projectsList_projectsDirectoryV3_rootQueryRef"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isAdminSettingsContext",
                            "variableName": "isAdminSettingsContext"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "pageLayout_projectsDirectoryV3_ProjectDirectoryLayout"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "emptyView_projectsDirectoryV3"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "noPermissionViews_projectsDirectoryV3"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "args": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "filter",
                                    "variableName": "filter"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "last",
                                    "variableName": "last"
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "canViewIssue",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "VIEW_ISSUES"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v10 /*: any*/ ,
                                                    "storageKey": "action(type:\"VIEW_ISSUES\")"
                                                },
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteValue",
                                                    "kind": "LinkedField",
                                                    "name": "favouriteValue",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                v15 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "medium"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "navigationMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardId"
                                                                },
                                                                v11 /*: any*/ 
                                                            ],
                                                            "type": "JiraSoftwareProjectNavigationMetadata"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "queueId"
                                                                }
                                                            ],
                                                            "type": "JiraServiceManagementProjectNavigationMetadata"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "concreteType": "JiraProjectCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lead",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isUser"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "accountId"
                                                        },
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "isAdminSettingsContext",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "alias": "lastUpdatedToolTipDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "COMPLETE_DATETIME_FORMAT"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"COMPLETE_DATETIME_FORMAT\")"
                                                        },
                                                        {
                                                            "alias": "lastUpdatedDisplayDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "RELATIVE"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"RELATIVE\")"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectUrl"
                                                },
                                                {
                                                    "alias": "canViewProjectConfig",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "VIEW_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v10 /*: any*/ ,
                                                    "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "alias": "jiraProjectType",
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "alias": "jiraProjectName",
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v17 /*: any*/ ,
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHasTotal"
                                }
                            ]
                        },
                        {
                            "alias": "canContactAdmin",
                            "args": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": "jira.show.contact.administrators.form"
                                }
                            ],
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": [
                                v15 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                v11 /*: any*/ 
                            ]
                        },
                        v8 /*: any*/ ,
                        {
                            "condition": "isAnonymous",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraUserPreferences",
                                    "kind": "LinkedField",
                                    "name": "userPreferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectListRightPanelState"
                                        },
                                        v14 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "sidebarExperimentTemplates",
                                    "args": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "experimentKey",
                                            "value": "sidebarExperiment"
                                        }
                                    ],
                                    "concreteType": "JiraProjectListViewTemplateConnection",
                                    "kind": "LinkedField",
                                    "name": "projectListViewTemplates",
                                    "plural": false,
                                    "selections": [
                                        v17 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraProjectCategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjectCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectCategoryEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v16 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isAnonymous",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraProjectCategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjectCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectCategoryEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProjectCategory",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraProjectTypeDetailsConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjectTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectTypeDetailsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectTypeDetails",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "da04654402c040cfb1a5731e6742c8a699abdddac45bfc2bc9c768547f13bcf3",
            "metadata": {},
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0264f0fee7e7a1be$var$node.hash = "0383d6b00b0ae0222d704297e4fe4e64";
(0, $eiowN.PreloadableQueryRegistry).set($0264f0fee7e7a1be$var$node.params.id, $0264f0fee7e7a1be$var$node);
var $0264f0fee7e7a1be$export$2e2bcd8739ae039 = $0264f0fee7e7a1be$var$node;

});

const $ce818d5819645fe8$export$2150caade62dc875 = 'PROJECTS_DIRECTORY_RELAY';



parcelRegister("fhRbA", function(module, exports) {

$parcel$export(module.exports, "LazyProjectsDirectory", () => $a4d64259d3b4962d$export$f9ee24127b8e4a7f);

var $7yO8g = parcelRequire("7yO8g");

var $b7Svb = parcelRequire("b7Svb");

const $a4d64259d3b4962d$export$f9ee24127b8e4a7f = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("96iY1"))), {
    moduleId: "./src/packages/spa-apps/directories/projects-v3/src/index.tsx"
});

});
parcelRegister("96iY1", function(module, exports) {

let $6a0363152dcb73bf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6a0363152dcb73bf$var$load("fFisX").then(()=>parcelRequire('eBOH6'));

});


parcelRegister("jL5x9", function(module, exports) {

$parcel$export(module.exports, "ProjectsDirectoryPageEntryPoint", () => $46b7b7dce12367bc$export$f4985310f86f98fc);

var $lkFvK = parcelRequire("lkFvK");

var $3obFW = parcelRequire("3obFW");

var $lmyls = parcelRequire("lmyls");

var $7wpGh = parcelRequire("7wpGh");

var $6raju = parcelRequire("6raju");
const $46b7b7dce12367bc$export$f4985310f86f98fc = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7wpGh.projectsDirectoryEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    rightSidebar: (0, $3obFW.RecommendationsInProjectListEntryPoint),
    rightSidebarFallback: (0, $6raju.ProjectListSidebarSkeleton)
});

});
parcelRegister("3obFW", function(module, exports) {

$parcel$export(module.exports, "RecommendationsInProjectListEntryPoint", () => $64f90d2bc5407ac6$export$8baad7954c0e6b8c);

var $5uP7K = parcelRequire("5uP7K");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $64f90d2bc5407ac6$export$8baad7954c0e6b8c = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("4MUXY")), {
        moduleId: "3a12ca77"
    }),
    getPreloadProps: (extraProps)=>({
            extraProps: extraProps,
            queries: {
                templatesQueryRef: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $5uP7K.default,
                    variables: {
                        cloudId: extraProps.tenantContext.cloudId,
                        isAnonymous: extraProps.tenantContext.isAnonymous
                    }
                }
            }
        })
});

});
parcelRegister("5uP7K", function(module, exports) {

$parcel$export(module.exports, "default", () => $73a724a7681d68cc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f3ba4e44c8e9245beb75073cf01b9608>>
 * @relayHash 53ebcedfde32e6f696cc7d8a2593a5b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f205f5060df8334465ed389c690fad308d9c1c3556c874884043528322963b4f
const $73a724a7681d68cc$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f205f5060df8334465ed389c690fad308d9c1c3556c874884043528322963b4f",
        "metadata": {},
        "name": "src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $73a724a7681d68cc$export$2e2bcd8739ae039 = $73a724a7681d68cc$var$node;

});

parcelRegister("4MUXY", function(module, exports) {

let $37c7d56d166e3173$var$load = (parcelRequire("28QjX"))(4);
module.exports = $37c7d56d166e3173$var$load("hiq8F").then(()=>parcelRequire('hT4Zj'));

});


parcelRegister("7wpGh", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryEntryPoint", () => $94d9041756c0d8ee$export$80225215a10b2688);

var $4R6GH = parcelRequire("4R6GH");

var $1Jl81 = parcelRequire("1Jl81");

var $kVKQx = parcelRequire("kVKQx");

var $dXq4S = parcelRequire("dXq4S");

var $9M2wg = parcelRequire("9M2wg");

var $cfawy = parcelRequire("cfawy");

var $3rdd7 = parcelRequire("3rdd7");
const $94d9041756c0d8ee$var$DEFAULT_LIMIT = 25;
const $94d9041756c0d8ee$var$PROJECTS_DIRECTORY_MANAGE = 'projects-directory-manage';
const $94d9041756c0d8ee$var$DefaultFilterFields = {
    // sorting
    SortOrder: 'sortOrder',
    SortKey: 'sortKey',
    // pagination
    Page: 'page'
};
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $94d9041756c0d8ee$var$TableColumns = /*#__PURE__*/ function(TableColumns) {
    TableColumns["Favourites"] = "favourites";
    TableColumns["Key"] = "key";
    TableColumns["Name"] = "name";
    TableColumns["Type"] = "type";
    TableColumns["Lead"] = "lead";
    TableColumns["Category"] = "category";
    TableColumns["LastIssueUpdate"] = "last_issue_updated_time";
    TableColumns["Url"] = "url";
    TableColumns["Action"] = "actions";
    return TableColumns;
}($94d9041756c0d8ee$var$TableColumns || {});
const $94d9041756c0d8ee$var$SortableColumns = [
    "key",
    "name",
    "lead",
    "category",
    "last_issue_updated_time"
];
const $94d9041756c0d8ee$var$FilterFields = {
    Keyword: 'keyword',
    ProjectType: 'types',
    ProjectCategoryId: 'projectCategoryId',
    ...$94d9041756c0d8ee$var$DefaultFilterFields
};
const $94d9041756c0d8ee$var$filterAliasMap = {
    contains: $94d9041756c0d8ee$var$FilterFields.Keyword,
    selectedProjectType: $94d9041756c0d8ee$var$FilterFields.ProjectType,
    selectedCategory: $94d9041756c0d8ee$var$FilterFields.ProjectCategoryId
};
const $94d9041756c0d8ee$var$filterInitialState = {
    [$94d9041756c0d8ee$var$FilterFields.Keyword]: '',
    [$94d9041756c0d8ee$var$FilterFields.ProjectType]: '',
    [$94d9041756c0d8ee$var$FilterFields.ProjectCategoryId]: '',
    [$94d9041756c0d8ee$var$FilterFields.SortOrder]: 'ASC',
    [$94d9041756c0d8ee$var$FilterFields.SortKey]: "name",
    [$94d9041756c0d8ee$var$FilterFields.Page]: '1'
};
const $94d9041756c0d8ee$var$LEGACY_ALL_VALUE = 'all';
const $94d9041756c0d8ee$var$sanitizeLegacyQuery = (query = {})=>({
        ...query,
        selectedProjectType: query.selectedProjectType === $94d9041756c0d8ee$var$LEGACY_ALL_VALUE ? $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.ProjectType] : query.selectedProjectType,
        selectedCategory: query.selectedCategory === $94d9041756c0d8ee$var$LEGACY_ALL_VALUE ? $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.ProjectCategoryId] : query.selectedCategory
    });
const $94d9041756c0d8ee$var$matchAliases = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const alias = aliases[key];
        const queryValue = query[key];
        const hasInitialValue = filter[key] !== undefined;
        // override default filter value with query params
        if (hasInitialValue && queryValue) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            filter[key] = queryValue;
            return filter;
        }
        // if there's no alias and no query param for it return default filter
        if (!alias || !queryValue) return filter;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
        filter[alias] = queryValue;
        return filter;
    }, {
        ...filterState
    });
const $94d9041756c0d8ee$var$CORE_PROJECT = 'business';
const $94d9041756c0d8ee$var$SOFTWARE_PROJECT = 'software';
const $94d9041756c0d8ee$var$SERVICE_DESK_PROJECT = 'service_desk';
const $94d9041756c0d8ee$var$PRODUCT_DISCOVERY_PROJECT = 'product_discovery';
const $94d9041756c0d8ee$var$PROJECT_TYPES = [
    $94d9041756c0d8ee$var$CORE_PROJECT,
    $94d9041756c0d8ee$var$SOFTWARE_PROJECT,
    $94d9041756c0d8ee$var$SERVICE_DESK_PROJECT,
    $94d9041756c0d8ee$var$PRODUCT_DISCOVERY_PROJECT
];
const $94d9041756c0d8ee$var$mapQueryToFilter = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
    const variables = {};
    const { [$94d9041756c0d8ee$var$FilterFields.Keyword]: keyword, [$94d9041756c0d8ee$var$FilterFields.ProjectCategoryId]: projectCategoryId, [$94d9041756c0d8ee$var$FilterFields.ProjectType]: types, [$94d9041756c0d8ee$var$FilterFields.SortOrder]: sortOrder, [$94d9041756c0d8ee$var$FilterFields.SortKey]: sortKey } = aliases && query ? $94d9041756c0d8ee$var$matchAliases(filter, query, aliases) : filter;
    if (keyword) variables.keyword = keyword;
    if (projectCategoryId) {
        const isAlreadyAri = (0, $4R6GH.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $1Jl81.AnyAri).check(projectCategoryId) : (0, $dXq4S.isAri)(projectCategoryId);
        if (isAlreadyAri) variables.projectCategoryId = projectCategoryId;
        else variables.projectCategoryId = (0, $4R6GH.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $kVKQx.JiraProjectCategoryAri).create({
            projectCategoryId: projectCategoryId,
            siteId: cloudId
        }).toString() : (0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project-category',
            resourceId: projectCategoryId
        });
    }
    if (sortKey || sortOrder) {
        const sortByValue = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        sortKey && $94d9041756c0d8ee$var$SortableColumns.includes(sortKey) ? sortKey : $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.SortKey];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        variables.sortBy = {
            order: [
                'ASC',
                'DESC'
            ].includes(sortOrder) ? sortOrder : $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.SortOrder],
            sortBy: sortByValue.toUpperCase()
        };
    }
    if (types && typeof types === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    variables.types = types.split(',') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .filter((type)=>$94d9041756c0d8ee$var$PROJECT_TYPES.includes(type)).map((type)=>type.toUpperCase());
    return variables;
};

const $94d9041756c0d8ee$export$80225215a10b2688 = (0, $3rdd7.createEntryPoint)({
    root: (0, $cfawy.JSResourceForUserVisible)(()=>(parcelRequire("c1xMx")), {
        moduleId: "b77224b3"
    }),
    getPreloadProps ({ context: { query: query, route: route }, tenantContext: tenantContext }) {
        const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
        const extraProps = {
            isAdminProjectDirectoryRoute: route.name === $94d9041756c0d8ee$var$PROJECTS_DIRECTORY_MANAGE
        };
        if (false && isAnonymous) return {
            extraProps: extraProps
        };
        return {
            queries: {
                projectsDirectoryPage: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: (0, $9M2wg.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        filter: $94d9041756c0d8ee$var$mapQueryToFilter($94d9041756c0d8ee$var$filterInitialState, {
                            cloudId: cloudId,
                            query: $94d9041756c0d8ee$var$sanitizeLegacyQuery(query),
                            aliases: $94d9041756c0d8ee$var$filterAliasMap
                        }),
                        first: query?.page ? $94d9041756c0d8ee$var$DEFAULT_LIMIT * (parseInt(query.page, 10) || 1) : $94d9041756c0d8ee$var$DEFAULT_LIMIT,
                        last: $94d9041756c0d8ee$var$DEFAULT_LIMIT,
                        isAdminSettingsContext: route.name === $94d9041756c0d8ee$var$PROJECTS_DIRECTORY_MANAGE,
                        isAnonymous: isAnonymous
                    }
                }
            },
            extraProps: extraProps
        };
    }
});

});
parcelRegister("9M2wg", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2863fb0305ba6a4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<23a6e9e3efd53029f1bd2f15dafcc83f>>
 * @relayHash 9748961340a0877dad06569907936559
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da04654402c040cfb1a5731e6742c8a699abdddac45bfc2bc9c768547f13bcf3
const $a2863fb0305ba6a4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "da04654402c040cfb1a5731e6742c8a699abdddac45bfc2bc9c768547f13bcf3",
        "metadata": {},
        "name": "pageLayout_projectsDirectoryLayout_RootQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a2863fb0305ba6a4$export$2e2bcd8739ae039 = $a2863fb0305ba6a4$var$node;

});

parcelRegister("c1xMx", function(module, exports) {

let $8c0fc862b36dbf9a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8c0fc862b36dbf9a$var$load("5jhjf").then(()=>parcelRequire('j3Lmi'));

});


parcelRegister("6raju", function(module, exports) {

$parcel$export(module.exports, "ProjectListSidebarSkeleton", () => $be14de1be79b27e3$export$808c25bcc6102427);
/* ProjectListSidebarSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $d8ped = parcelRequire("d8ped");
const $be14de1be79b27e3$var$customCssStyles = null;
const $be14de1be79b27e3$var$sidebarCssStyles = null;
const $be14de1be79b27e3$export$808c25bcc6102427 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1bsb1gwv _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _t6vdt94y _1p3lnqa1 _5wramuej _bfhkvuon _vchhusvi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d8ped))),
        className: (0, $bwpsq.default)([
            "_t6vdidpf _hr4jidpf"
        ])
    }));

});
parcelRegister("d8ped", function(module, exports) {
module.exports = new URL("project-list-sidebar-app-skeleton.tpl.35da4e26.svg", import.meta.url).toString();

});




parcelRegister("cmIyb", function(module, exports) {

$parcel$export(module.exports, "plansDirectoryRouteEntry", () => $d1aaabcb7e27c9a6$export$4f9df77811fbdc1f);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $8jQu6 = parcelRequire("8jQu6");

var $cFtGt = parcelRequire("cFtGt");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $d1aaabcb7e27c9a6$var$LazyPlansDirectory = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eDJcZ"))), {
    moduleId: "./src/packages/spa-apps/directories/plans/src/index.tsx"
});
const $d1aaabcb7e27c9a6$var$PlansDirectoryComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d1aaabcb7e27c9a6$var$LazyPlansDirectory,
        pageId: "plans-directory",
        shouldShowSpinner: false
    });
const $d1aaabcb7e27c9a6$export$4f9df77811fbdc1f = (0, $7NszV.createEntry)((0, $8jQu6.plansDirectoryRoute), ()=>({
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental'),
        group: 'directories',
        component: $d1aaabcb7e27c9a6$var$PlansDirectoryComponent,
        skeleton: (0, $cFtGt.PlansDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $d1aaabcb7e27c9a6$var$LazyPlansDirectory
        ]
    }));

});
parcelRegister("eDJcZ", function(module, exports) {

let $aa87c6aafb61a330$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aa87c6aafb61a330$var$load("5XLCy").then(()=>parcelRequire('flZBd'));

});


parcelRegister("fQyGL", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryLegacyPathRedirectRouteEntry", () => $8f20c76692c396ce$export$78ff5b5f42b9de4);

var $ffza4 = parcelRequire("ffza4");

var $gmpjq = parcelRequire("gmpjq");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $hW253 = parcelRequire("hW253");

var $gUy1M = parcelRequire("gUy1M");

var $cFtGt = parcelRequire("cFtGt");

var $1ryl1 = parcelRequire("1ryl1");

var $fhRbA = parcelRequire("fhRbA");
const $8f20c76692c396ce$export$78ff5b5f42b9de4 = (0, $7NszV.createEntry)((0, $gUy1M.projectsDirectoryLegacyPathRedirectRoute), ()=>({
        group: 'directories',
        component: (0, $1ryl1.ProjectsDirectoryRedirect),
        skeleton: (0, $cFtGt.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $gmpjq.homepageLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $hW253.projectsDirectoryPageResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fhRbA.LazyProjectsDirectory)
        ]
    }));

});
parcelRegister("gUy1M", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryLegacyPathRedirectRoute", () => $6002c1f8d9c23c57$export$c713f57300a82898);
const $6002c1f8d9c23c57$export$c713f57300a82898 = {
    name: 'projects-directory-legacy-path-spa-redirect',
    path: '/secure/BrowseProjects.jspa'
};

});

parcelRegister("1ryl1", function(module, exports) {

$parcel$export(module.exports, "ProjectsDirectoryRedirect", () => $3ba92fb58534b205$export$b68dd6112a931c10);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");
const $3ba92fb58534b205$export$b68dd6112a931c10 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/projects"
    });

});


parcelRegister("ifEj3", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryManageRedirectRouteEntry", () => $b468f39f7a3e39f4$export$c3c347e60b82f074);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $4jMkc = parcelRequire("4jMkc");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $jQdhH = parcelRequire("jQdhH");

var $cFtGt = parcelRequire("cFtGt");

var $k3MnQ = parcelRequire("k3MnQ");

var $fbnvY = parcelRequire("fbnvY");

var $fhRbA = parcelRequire("fhRbA");
const $b468f39f7a3e39f4$export$c3c347e60b82f074 = (0, $7NszV.createEntry)((0, $jQdhH.projectsDirectoryManageRedirectRoute), ()=>({
        component: (0, $k3MnQ.ProjectsDirectoryManageRedirect),
        skeleton: (0, $cFtGt.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $fbnvY.adminProjectDirectoryResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fhRbA.LazyProjectsDirectory)
        ]
    }));

});
parcelRegister("jQdhH", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryManageRedirectRoute", () => $9ef5b86eaaaceda7$export$dbd3b6c012e8b6dc);
const $9ef5b86eaaaceda7$export$dbd3b6c012e8b6dc = {
    name: 'projects-directory-manage-redirect',
    path: '/secure/project/ViewProjects.jspa'
};

});

parcelRegister("k3MnQ", function(module, exports) {

$parcel$export(module.exports, "ProjectsDirectoryManageRedirect", () => $0582a6018d790f50$export$74316a0a4963952b);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");
const $0582a6018d790f50$export$74316a0a4963952b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/settings/projects/manage"
    });

});


parcelRegister("4CGuj", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryManageRootRedirectRouteEntry", () => $e677bebc1d8715eb$export$3f6ec3224d4c9da);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $4jMkc = parcelRequire("4jMkc");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $g8syc = parcelRequire("g8syc");

var $cFtGt = parcelRequire("cFtGt");

var $k3MnQ = parcelRequire("k3MnQ");

var $fbnvY = parcelRequire("fbnvY");

var $fhRbA = parcelRequire("fhRbA");
const $e677bebc1d8715eb$export$3f6ec3224d4c9da = (0, $7NszV.createEntry)((0, $g8syc.projectsDirectoryManageRootRedirectRoute), ()=>({
        component: (0, $k3MnQ.ProjectsDirectoryManageRedirect),
        skeleton: (0, $cFtGt.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $fbnvY.adminProjectDirectoryResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fhRbA.LazyProjectsDirectory)
        ]
    }));

});
parcelRegister("g8syc", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryManageRootRedirectRoute", () => $45b46e5e0a379e06$export$4531e3b2e25fad23);
const $45b46e5e0a379e06$export$4531e3b2e25fad23 = {
    name: 'projects-directory-manage-root-redirect',
    path: '/jira/settings/projects',
    exact: true
};

});


parcelRegister("6VvYi", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRedirectRouteEntry", () => $66b2e7de35cd3e39$export$8d9d65bb59f2354e);

var $ffza4 = parcelRequire("ffza4");

var $gmpjq = parcelRequire("gmpjq");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $hW253 = parcelRequire("hW253");

var $1k12N = parcelRequire("1k12N");

var $cFtGt = parcelRequire("cFtGt");

var $1ryl1 = parcelRequire("1ryl1");

var $fhRbA = parcelRequire("fhRbA");
const $66b2e7de35cd3e39$export$8d9d65bb59f2354e = (0, $7NszV.createEntry)((0, $1k12N.projectsDirectoryRedirectRoute), ()=>({
        group: 'directories',
        component: (0, $1ryl1.ProjectsDirectoryRedirect),
        skeleton: (0, $cFtGt.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $gmpjq.homepageLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $hW253.projectsDirectoryPageResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fhRbA.LazyProjectsDirectory)
        ]
    }));

});
parcelRegister("1k12N", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRedirectRoute", () => $529d55d6a6980bfb$export$d44f1be3782f0fde);
const $529d55d6a6980bfb$export$d44f1be3782f0fde = {
    name: 'projects-directory-redirect',
    path: '/projects',
    exact: true
};

});


parcelRegister("dSrOC", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRouteEntry", () => $00e4719282b1ae8b$export$79292a834772288c);

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $foR3E = parcelRequire("foR3E");

var $cFtGt = parcelRequire("cFtGt");

var $jL5x9 = parcelRequire("jL5x9");
const $00e4719282b1ae8b$export$79292a834772288c = (0, $7NszV.createEntry)((0, $foR3E.projectsDirectoryRoute), ()=>({
        group: 'directories',
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-projects'),
        entryPoint () {
            return 0, $jL5x9.ProjectsDirectoryPageEntryPoint;
        },
        skeleton: (0, $cFtGt.ProjectsDirectorySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        ufoName: 'projects-directory-v3'
    }));

});

parcelRegister("dTkCg", function(module, exports) {

$parcel$export(module.exports, "secureFiltersDirectoryRedirectRouteEntry", () => $d55bc420bfc42a32$export$c2ec350ee9e78717);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $dRl24 = parcelRequire("dRl24");

var $3RJkv = parcelRequire("3RJkv");

var $ba16k = parcelRequire("ba16k");

var $cFtGt = parcelRequire("cFtGt");

var $7RZwy = parcelRequire("7RZwy");
const $d55bc420bfc42a32$export$c2ec350ee9e78717 = (0, $7NszV.createEntry)((0, $ba16k.secureFiltersDirectoryRedirectRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $dRl24.filtersDirectoryResource)
        ],
        component: !false ? (0, $7RZwy.FiltersDirectoryRedirect) : (0, $7RZwy.FiltersDirectoryComponent),
        skeleton: (0, $cFtGt.FiltersDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).FILTERS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7RZwy.LazyFiltersDirectory)
        ],
        isRedirect: true
    }));

});
parcelRegister("ba16k", function(module, exports) {

$parcel$export(module.exports, "secureFiltersDirectoryRedirectRoute", () => $6cb8f0f1ec2e6905$export$50796f2aecd63181);
const $6cb8f0f1ec2e6905$export$50796f2aecd63181 = {
    name: 'filters-directory-secure-redirect',
    path: '/secure/ManageFilters.jspa'
};

});


parcelRegister("hs0Ni", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingCreateRouteEntry", () => $1afcecac57b51b7c$export$92f4b6644eb6cb88);

var $fHhvb = parcelRequire("fHhvb");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $1GLKn = parcelRequire("1GLKn");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $jh1uq = parcelRequire("jh1uq");

var $3dgEU = parcelRequire("3dgEU");

var $a5NQf = parcelRequire("a5NQf");
const $1afcecac57b51b7c$var$getNavigationSpecifications = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $1afcecac57b51b7c$export$92f4b6644eb6cb88 = (0, $7NszV.createEntry)((0, $1GLKn.eocAlertIssueSyncingCreateRoute), ()=>({
        group: 'eoc',
        component: (0, $jh1uq.AlertIssueSync),
        slot: (0, $3dgEU.AlertIssueSyncCreate),
        basePath: '/jira/settings/products/ops',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $fHhvb.resources).configuredSyncsResource,
            (0, $fHhvb.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$1afcecac57b51b7c$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync)
        ]
    }));

});
parcelRegister("fHhvb", function(module, exports) {

$parcel$export(module.exports, "resources", () => $343756931c1b153e$export$bc99aaabaf7b70a7);

var $fxTyv = parcelRequire("fxTyv");

var $eEseD = parcelRequire("eEseD");

var $3ZaAV = parcelRequire("3ZaAV");

var $aGCl6 = parcelRequire("aGCl6");
const $343756931c1b153e$export$bc99aaabaf7b70a7 = {
    configuredSyncsResource: $fxTyv.configuredSyncsResource,
    userAccessRightsResource: $aGCl6.userAccessRightsResource,
    getTeamResource: $3ZaAV.getTeamResource,
    isCurrentSiteSyncEnabledResource: $eEseD.isCurrentSiteSyncEnabledResource
};

});
parcelRegister("fxTyv", function(module, exports) {

$parcel$export(module.exports, "configuredSyncsResource", () => $9dc1f07bc008d76a$export$333c290f4a1ec41c);

var $2M1hQ = parcelRequire("2M1hQ");

var $bdpMQ = parcelRequire("bdpMQ");

var $4vGic = parcelRequire("4vGic");
const $9dc1f07bc008d76a$export$333c290f4a1ec41c = (0, $2M1hQ.createResource)({
    type: 'configuredSyncsResource',
    getKey: ({ query: query, match: match })=>{
        const teamId = match.params.teamId ?? query['teamId'];
        const keyword = query['keyword'];
        const type = query['type'];
        const page = query['page'] || '1';
        const status = query['status'];
        return (0, $bdpMQ.UrlHelper)('configuredSyncsResource', {
            page: page,
            keyword: keyword,
            type: type,
            status: status,
            teamId: teamId
        });
    },
    getData: (routerContext)=>(0, $4vGic.default).getSyncs(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("bdpMQ", function(module, exports) {

$parcel$export(module.exports, "UrlHelper", () => $0060aaad5a1bf68f$export$bacbc496e850c0a4);
const $0060aaad5a1bf68f$export$bacbc496e850c0a4 = (path, params = {})=>{
    // https://github.com/microsoft/TypeScript/issues/16655
    const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
            k,
            v.toString()
        ] : undefined).filter((v)=>!!v);
    const qs = new URLSearchParams(q).toString();
    return `${path}${qs ? `?${qs}` : ''}`;
};

});

parcelRegister("4vGic", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fc56829313a1c3c$export$2e2bcd8739ae039);

var $d9Cgl = parcelRequire("d9Cgl");

var $bdpMQ = parcelRequire("bdpMQ");

const $8fc56829313a1c3c$var$getSyncs = async (query, pathParamTeamId)=>{
    const page = parseInt(query['page']) || 1;
    const offset = (page - 1) * (0, $c09abd9d39c634bf$export$31ecae7225aecec6);
    const queryParams = query ? {
        teamId: pathParamTeamId ?? query.teamId,
        type: query.type,
        keyword: query.keyword,
        status: query.status
    } : {};
    return (0, $d9Cgl.eocFetch)((0, $bdpMQ.UrlHelper)('/v1/entity-sync/unified', {
        ...queryParams,
        offset: offset.toString(),
        limit: (0, $c09abd9d39c634bf$export$31ecae7225aecec6)
    })).then((response)=>({
            data: response.data.integrations,
            pageCount: Math.ceil(response.data.count / (0, $c09abd9d39c634bf$export$31ecae7225aecec6)),
            itemCount: response.data.count
        }));
};
const $8fc56829313a1c3c$var$patchSync = async (syncId, syncType, body, teamId)=>(0, $d9Cgl.eocFetch)((0, $bdpMQ.UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
        type: syncType,
        teamId: teamId
    }), {
        method: 'PATCH',
        body: body
    }).then((response)=>response.data);
const $8fc56829313a1c3c$var$deleteSync = async (syncId, syncType, teamId)=>(0, $d9Cgl.eocFetch)((0, $bdpMQ.UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
        type: syncType,
        teamId: teamId
    }), {
        method: 'DELETE',
        responseType: 'headers'
    });
var $8fc56829313a1c3c$export$2e2bcd8739ae039 = {
    getSyncs: $8fc56829313a1c3c$var$getSyncs,
    patchSync: $8fc56829313a1c3c$var$patchSync,
    deleteSync: $8fc56829313a1c3c$var$deleteSync
};

});
const $c09abd9d39c634bf$export$31ecae7225aecec6 = 20;



parcelRegister("eEseD", function(module, exports) {

$parcel$export(module.exports, "isCurrentSiteSyncEnabledResource", () => $fa699c040d63a3c4$export$94465df791bf80);

var $2M1hQ = parcelRequire("2M1hQ");

var $2fizM = parcelRequire("2fizM");
const $fa699c040d63a3c4$export$94465df791bf80 = (0, $2M1hQ.createResource)({
    type: 'isCurrentSiteSyncEnabledResource',
    getKey: ()=>`isCurrentSiteSyncEnabledResource`,
    getData: (0, $2fizM.getIsCurrentSiteSyncEnabled),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("2fizM", function(module, exports) {

$parcel$export(module.exports, "getIsCurrentSiteSyncEnabled", () => $3cb48e2272101f2d$export$93fc09e39edf63d0);

var $d9Cgl = parcelRequire("d9Cgl");
const $3cb48e2272101f2d$export$93fc09e39edf63d0 = ()=>(0, $d9Cgl.eocFetch)(`/v1/entity-sync/is-current-site-enabled`).then((response)=>response.data.enabled);

});


parcelRegister("3ZaAV", function(module, exports) {

$parcel$export(module.exports, "getTeamResource", () => $c0383847568b7dc4$export$50271c9e7f21f10e);

var $2M1hQ = parcelRequire("2M1hQ");

var $gtuj9 = parcelRequire("gtuj9");
var $9dX4l = parcelRequire("9dX4l");

var $eJOKe = parcelRequire("eJOKe");
const $c0383847568b7dc4$export$50271c9e7f21f10e = (0, $2M1hQ.createResource)({
    type: 'getSyncTeamResource',
    getKey: (routerContext)=>`getSyncTeamResource#${routerContext.match.params?.teamId}`,
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $gtuj9.assert)(!!teamId, new (0, $9dX4l.AssertionError)('getTeamResource', 'teamId should be set to fetch the team'));
        const result = await (0, $eJOKe.getTeam)(teamId);
        return result ?? null;
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("eJOKe", function(module, exports) {

$parcel$export(module.exports, "getTeam", () => $ba1dd5963ee55197$export$491fe77f22ab2b51);

var $d9Cgl = parcelRequire("d9Cgl");
const $ba1dd5963ee55197$export$491fe77f22ab2b51 = (teamId)=>(0, $d9Cgl.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    }).then((response)=>response.values.filter((responder)=>!responder.deleted).at(0));

});


parcelRegister("aGCl6", function(module, exports) {

$parcel$export(module.exports, "userAccessRightsResource", () => $4330fd94d1d30af1$export$69ddc7cc64ae9a02);

var $2M1hQ = parcelRequire("2M1hQ");

var $hE1iD = parcelRequire("hE1iD");
const $4330fd94d1d30af1$export$69ddc7cc64ae9a02 = (0, $2M1hQ.createResource)({
    type: 'userAccessRightsResource',
    getKey: ()=>'userAccessRightsResource',
    getData: (routerContext)=>(0, $hE1iD.getUserRights)(routerContext.match.params.teamId),
    maxAge: 600000,
    isBrowserOnly: true
});

});
parcelRegister("hE1iD", function(module, exports) {

$parcel$export(module.exports, "getUserRights", () => $294fae9a76ccf6f4$export$84e2ed279bc4e64e);

var $d9Cgl = parcelRequire("d9Cgl");

var $bdpMQ = parcelRequire("bdpMQ");
const $294fae9a76ccf6f4$export$84e2ed279bc4e64e = (teamId)=>{
    return (0, $d9Cgl.eocFetch)((0, $bdpMQ.UrlHelper)(`/v1/entity-sync/unified/rights`, {
        teamId: teamId
    })).then((response)=>response.data.userAccessRights);
};

});



parcelRegister("1GLKn", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingCreateRoute", () => $cfb9010ddff8a27d$export$f271eef5f9ec6602);
const $cfb9010ddff8a27d$export$f271eef5f9ec6602 = {
    name: 'eoc-alert-issue-syncing-create',
    path: '/jira/settings/products/ops/syncs/create',
    exact: true
};

});

parcelRegister("hUyS9", function(module, exports) {

$parcel$export(module.exports, "LazyHorizontalOperationsConfigurationNav", () => $3b531790406897bf$export$aea682543f08e131);
$parcel$export(module.exports, "AsyncHorizontalOperationsConfigurationNav", () => $3b531790406897bf$export$1f7a0efe3746ea0d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $3b531790406897bf$export$aea682543f08e131 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("4YRAX")).then(({ HorizontalOperationsConfiguration: HorizontalOperationsConfiguration })=>HorizontalOperationsConfiguration), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/horizontal-nav-operations-configuration/src/ui/index.tsx"
});
const $3b531790406897bf$export$1f7a0efe3746ea0d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-operations-configurations-horizontal-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncHorizontalOperationsConfigurationNav",
        packageName: "jiraOperationsConfigurationsHorizontalNav",
        fallback: "flag",
        teamName: "50cent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b531790406897bf$export$aea682543f08e131, null)));

});
parcelRegister("4YRAX", function(module, exports) {

let $3a0656e165fbd6c4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3a0656e165fbd6c4$var$load("lvSxi").then(()=>parcelRequire('8WIBW'));

});


parcelRegister("7s8Fa", function(module, exports) {

$parcel$export(module.exports, "LazySidebarContent", () => $0ac1c74f5a7f2a66$export$5cb783b45e692ee9);
$parcel$export(module.exports, "default", () => $0ac1c74f5a7f2a66$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $cnlm7 = parcelRequire("cnlm7");

var $i8077 = parcelRequire("i8077");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $aUDLa = parcelRequire("aUDLa");

var $9OXo1 = parcelRequire("9OXo1");

var $gJkov = parcelRequire("gJkov");

const $0ac1c74f5a7f2a66$export$5cb783b45e692ee9 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("32CLg")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/operations/src/ui/main.tsx"
});
const $0ac1c74f5a7f2a66$var$AsyncSidebar = ()=>{
    const { data: data } = (0, $aUDLa.useNavigationGlobalResource)();
    const { isDevMode: isDevMode, isAdmin: isAdmin } = (0, $9OXo1.useTenantContext)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $gJkov.extractData)(data, isDevMode, isAdmin), [
        data,
        isDevMode,
        isAdmin
    ]);
    if (!extractedData) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.operations-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsOperationsSettings",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnlm7.SidebarContent), {
        currentPageName: "operations",
        hasGeneralConfiguration: extractedData?.hasGeneralConfiguration,
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-operations.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.operations-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8077.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ac1c74f5a7f2a66$export$5cb783b45e692ee9, null))));
};
var $0ac1c74f5a7f2a66$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($0ac1c74f5a7f2a66$var$AsyncSidebar);

});
parcelRegister("cnlm7", function(module, exports) {

$parcel$export(module.exports, "SidebarContent", () => $eb45bd1b3d8207f6$export$49e8f7b58a4df4ea);

var $5uXOq = parcelRequire("5uXOq");

var $bWfiu = parcelRequire("bWfiu");

var $2Eqc8 = parcelRequire("2Eqc8");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $iI75Y = parcelRequire("iI75Y");

var $4IIGx = parcelRequire("4IIGx");
var $g9c75 = parcelRequire("g9c75");
var $2EpMB = parcelRequire("2EpMB");

var $9GB5z = parcelRequire("9GB5z");

var $jDuwy = parcelRequire("jDuwy");
const $eb45bd1b3d8207f6$export$49e8f7b58a4df4ea = ({ children: children, currentPageName: currentPageName, hasGeneralConfiguration: hasGeneralConfiguration, testId: testId = 'navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EpMB.SideNavHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.200",
        xcss: $eb45bd1b3d8207f6$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        alignBlock: "center",
        grow: "hug",
        space: "space.100",
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content.header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iI75Y.BackButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $jDuwy.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9GB5z.AsyncPageSwitcher), {
        currentPageName: currentPageName,
        hasOperationsGeneralConfiguration: hasGeneralConfiguration
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g9c75.SideNavContent), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IIGx.MenuList), null, children)));
};
const $eb45bd1b3d8207f6$var$headingStyles = (0, $2s57o.xcss)({
    // 4px of left padding is added to align the back icon with the side nav toggle button
    paddingInlineStart: 'space.050'
});

});
parcelRegister("iI75Y", function(module, exports) {

$parcel$export(module.exports, "BackButton", () => $8c6efbfad9d4699a$export$e0d897ee21382f67);

var $5uXOq = parcelRequire("5uXOq");

var $1Seuh = parcelRequire("1Seuh");
var $620fp = parcelRequire("620fp");

var $kmtfL = parcelRequire("kmtfL");

var $5KCCi = parcelRequire("5KCCi");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $cSD7y = parcelRequire("cSD7y");

var $jKa0E = parcelRequire("jKa0E");

var $dJXtD = parcelRequire("dJXtD");
const $8c6efbfad9d4699a$export$e0d897ee21382f67 = (0, $cSD7y.componentWithFG)('blu-5799-jira-software-board-entrypoint-route', $8c6efbfad9d4699a$var$BackButtonNew, $8c6efbfad9d4699a$var$BackButtonOld);
function $8c6efbfad9d4699a$var$BackButtonOld() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { goBack: goBack } = (0, $jKa0E.useNavigateBack)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: formatMessage((0, $dJXtD.default).tooltip),
        hideTooltipOnMouseDown: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kmtfL))),
        label: formatMessage((0, $dJXtD.default).label),
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'sidebarBackButton');
            goBack();
        }
    }));
}
function $8c6efbfad9d4699a$var$BackButtonNew() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { previousUrl: previousUrl } = (0, $jKa0E.useNavigateBack)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: formatMessage((0, $dJXtD.default).tooltip),
        hideTooltipOnMouseDown: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $620fp.default), {
        href: previousUrl || '',
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kmtfL))),
        label: formatMessage((0, $dJXtD.default).label),
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'sidebarBackButton');
        }
    }));
}

});
parcelRegister("jKa0E", function(module, exports) {

$parcel$export(module.exports, "useNavigateBack", () => $e131d9d1fc634955$export$7ce1f551d78f9130);
$parcel$export(module.exports, "NavigateBackProvider", () => $e131d9d1fc634955$export$e1e76f4ee7f8174d);

var $5uXOq = parcelRequire("5uXOq");

var $dIHnK = parcelRequire("dIHnK");

var $bmKPg = parcelRequire("bmKPg");
var $lVJAU = parcelRequire("lVJAU");

var $bOr6i = parcelRequire("bOr6i");
const $e131d9d1fc634955$var$STORAGE_KEY = 'back-button-url';
const $e131d9d1fc634955$var$NavigateBackContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $e131d9d1fc634955$export$7ce1f551d78f9130 = ()=>{
    const context = (0, $5uXOq.useContext)($e131d9d1fc634955$var$NavigateBackContext);
    if (!context) throw new Error('useNavigateBack must be used within a NavigateBackProvider');
    return context;
};
function $e131d9d1fc634955$export$e1e76f4ee7f8174d({ children: children }) {
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const [projectKey] = (0, $bmKPg.usePathParam)('projectKey');
    const defaultInitialUrl = projectKey ? `/projects/${projectKey}` : (0, $dIHnK.jiraHomeRoute).path;
    const [previousUrl, setPreviousUrl] = (0, $5uXOq.useState)(()=>(0, $bOr6i.storageProvider).get($e131d9d1fc634955$var$STORAGE_KEY) ?? defaultInitialUrl);
    const saveCurrentRoute = (0, $5uXOq.useCallback)((currentUrl)=>{
        setPreviousUrl(currentUrl);
        (0, $bOr6i.storageProvider).set($e131d9d1fc634955$var$STORAGE_KEY, currentUrl);
    }, []);
    // Remove this method when cleaning up blu-5799-jira-software-board-entrypoint-route
    const goBack = (0, $5uXOq.useCallback)(()=>push(previousUrl ?? defaultInitialUrl), [
        defaultInitialUrl,
        previousUrl,
        push
    ]);
    const value = (0, $5uXOq.useMemo)(()=>({
            saveCurrentRoute: saveCurrentRoute,
            goBack: goBack,
            previousUrl: previousUrl
        }), [
        saveCurrentRoute,
        goBack,
        previousUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e131d9d1fc634955$var$NavigateBackContext.Provider, {
        value: value
    }, children);
}

});
parcelRegister("bOr6i", function(module, exports) {

$parcel$export(module.exports, "storageProvider", () => $36fbcced1b17c587$export$ce7751641b93537d);

var $eNf8a = parcelRequire("eNf8a");
const $36fbcced1b17c587$export$ce7751641b93537d = (0, $eNf8a.createSessionStorageProvider)('sidebar-navigation');

});


parcelRegister("dJXtD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b400b92991a2960$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0b400b92991a2960$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.tooltip",
        "defaultMessage": "Go back"
    },
    label: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.label",
        "defaultMessage": "Navigate back to the previous page"
    }
});

});


parcelRegister("2EpMB", function(module, exports) {

$parcel$export(module.exports, "SideNavHeader", () => $dc6f15a59fc1acf9$export$9d28ff3a0d89869c);
/* side-nav-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $dc6f15a59fc1acf9$var$styles = {
    root: "_18zrutpp _1q51utpp _85i51b66"
};
const $dc6f15a59fc1acf9$export$9d28ff3a0d89869c = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $dc6f15a59fc1acf9$var$styles.root
        ]),
        children: children
    });
};

});

parcelRegister("9GB5z", function(module, exports) {

$parcel$export(module.exports, "AsyncPageSwitcher", () => $8f72ed6ff9af1bd8$export$3130bd98029942c);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");
const $8f72ed6ff9af1bd8$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $8f72ed6ff9af1bd8$var$headingSkeleton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $8f72ed6ff9af1bd8$var$dropdownSkeleton
    }));

const $8f72ed6ff9af1bd8$var$LazyPageSwitcher = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("h6s52")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/common/src/common/ui/page-switcher/main.tsx"
});
const $8f72ed6ff9af1bd8$export$3130bd98029942c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.page-switcher",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f72ed6ff9af1bd8$export$8f31e4c4a37b8e9c, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f72ed6ff9af1bd8$var$LazyPageSwitcher, props));
const $8f72ed6ff9af1bd8$var$headingSkeleton = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    width: '50%',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100'
});
const $8f72ed6ff9af1bd8$var$dropdownSkeleton = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});
parcelRegister("h6s52", function(module, exports) {

let $c738c75dbbe297d2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c738c75dbbe297d2$var$load("6XfVR").then(()=>parcelRequire('8dyHT'));

});


parcelRegister("jDuwy", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfdc401436033e3a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dfdc401436033e3a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-common.sidebar-content.heading",
        "defaultMessage": "Jira admin settings"
    }
});

});


parcelRegister("i8077", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $8a8cf6e18096ea33$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");
const $8a8cf6e18096ea33$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $8a8cf6e18096ea33$var$sectionHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $8a8cf6e18096ea33$var$sectionHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $8a8cf6e18096ea33$var$menuItem
    }));
const $8a8cf6e18096ea33$var$sectionHeading = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    width: '50%',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100',
    marginTop: 'space.100'
});
const $8a8cf6e18096ea33$var$menuItem = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("32CLg", function(module, exports) {

let $236fa03785b6827a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $236fa03785b6827a$var$load("9Yhj0").then(()=>parcelRequire('8wx8h'));

});


parcelRegister("jh1uq", function(module, exports) {

$parcel$export(module.exports, "AlertIssueSync", () => $7deb342e59ce2af6$export$5a4922ba79d730f4);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $a5NQf = parcelRequire("a5NQf");
const $7deb342e59ce2af6$export$5a4922ba79d730f4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $a5NQf.LazyAlertIssueSync),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });

});
parcelRegister("a5NQf", function(module, exports) {

$parcel$export(module.exports, "LazyAlertIssueSync", () => $d2634f336818750c$export$dbbcce89c7be1e71);
$parcel$export(module.exports, "LazyAlertIssueSyncCreate", () => $d2634f336818750c$export$ff3e9ed7471eebce);
$parcel$export(module.exports, "LazyAlertIssueSyncDetail", () => $d2634f336818750c$export$75137a2a583918e2);

var $b7Svb = parcelRequire("b7Svb");

const $d2634f336818750c$export$dbbcce89c7be1e71 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("2w3gK")).then((module)=>module.AlertIssueSync), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

const $d2634f336818750c$export$ff3e9ed7471eebce = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("2w3gK")).then((module)=>module.AlertIssueSyncCreate), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

const $d2634f336818750c$export$75137a2a583918e2 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("2w3gK")).then((module)=>module.AlertIssueSyncDetail), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

});
parcelRegister("2w3gK", function(module, exports) {

let $1d511b1e8ccae309$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1d511b1e8ccae309$var$load("h2MrD"),
    $1d511b1e8ccae309$var$load("bYT2S"),
    $1d511b1e8ccae309$var$load("fBjqh")
]).then(()=>parcelRequire('gAySz'));

});



parcelRegister("3dgEU", function(module, exports) {

$parcel$export(module.exports, "AlertIssueSyncCreate", () => $8b1bb3d27124393c$export$a26f24c49385cf3a);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $a5NQf = parcelRequire("a5NQf");
const $8b1bb3d27124393c$export$a26f24c49385cf3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $a5NQf.LazyAlertIssueSyncCreate),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });

});


parcelRegister("8m0RN", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingDetailRouteEntry", () => $ea4b5ca423fc7b5e$export$7e604b22ae6e7c1e);

var $fHhvb = parcelRequire("fHhvb");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $8cx1L = parcelRequire("8cx1L");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $jh1uq = parcelRequire("jh1uq");

var $fzxhM = parcelRequire("fzxhM");

var $a5NQf = parcelRequire("a5NQf");
const $ea4b5ca423fc7b5e$var$getNavigationSpecifications = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $ea4b5ca423fc7b5e$export$7e604b22ae6e7c1e = (0, $7NszV.createEntry)((0, $8cx1L.eocAlertIssueSyncingDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $jh1uq.AlertIssueSync),
        slot: (0, $fzxhM.AlertIssueSyncDetail),
        basePath: '/jira/settings/products/ops',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $fHhvb.resources).configuredSyncsResource,
            (0, $fHhvb.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$ea4b5ca423fc7b5e$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync)
        ]
    }));

});
parcelRegister("8cx1L", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingDetailRoute", () => $2a3279be22ec7e63$export$f1b4093ef603b98d);
const $2a3279be22ec7e63$export$f1b4093ef603b98d = {
    name: 'eoc-alert-issue-syncing-detail',
    path: '/jira/settings/products/ops/syncs/:syncId',
    exact: true
};

});

parcelRegister("fzxhM", function(module, exports) {

$parcel$export(module.exports, "AlertIssueSyncDetail", () => $f855872703199c2e$export$c21f2a7e1aa801a7);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $a5NQf = parcelRequire("a5NQf");
const $f855872703199c2e$export$c21f2a7e1aa801a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $a5NQf.LazyAlertIssueSyncDetail),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });

});


parcelRegister("dt3ZS", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingRouteEntry", () => $4abc338af93c95e0$export$c63d0942ec0f93c);

var $fHhvb = parcelRequire("fHhvb");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $eZXFU = parcelRequire("eZXFU");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $hIYBE = parcelRequire("hIYBE");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $a5NQf = parcelRequire("a5NQf");

var $jh1uq = parcelRequire("jh1uq");
const $4abc338af93c95e0$var$getNavigationSpecifications = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $4abc338af93c95e0$export$c63d0942ec0f93c = (0, $7NszV.createEntry)((0, $hIYBE.eocAlertIssueSyncingRoute), ()=>({
        group: 'eoc',
        component: (0, $jh1uq.AlertIssueSync),
        slot: null,
        basePath: '/jira/settings/products/ops',
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $fHhvb.resources).configuredSyncsResource,
            (0, $fHhvb.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$4abc338af93c95e0$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync)
        ]
    }));

});
parcelRegister("eZXFU", function(module, exports) {

$parcel$export(module.exports, "opsSettingsLayout", () => $bb0ecde8d2515afe$export$96d5e7da242cacf9);
$parcel$export(module.exports, "opsMigrationHubLayout", () => $bb0ecde8d2515afe$export$d4e92309ebd00b0f);
$parcel$export(module.exports, "opsNotificationsLayout", () => $bb0ecde8d2515afe$export$5714bc9520dbc6cf);

var $aPfsS = parcelRequire("aPfsS");

var $b7Svb = parcelRequire("b7Svb");

var $cSD7y = parcelRequire("cSD7y");

var $ibkIl = parcelRequire("ibkIl");

var $2BrOV = parcelRequire("2BrOV");

const $bb0ecde8d2515afe$export$f61c80ac3b95bc7d = (0, $cSD7y.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("jfbqs")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/right-sidebars/index.tsx"
}), ()=>null);
$bb0ecde8d2515afe$export$f61c80ac3b95bc7d.displayName = 'RightSidebars';

const $bb0ecde8d2515afe$export$70238cd3868b67c9 = (0, $cSD7y.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("fSnIJ")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/onboarding/index.tsx"
}), ()=>null);
$bb0ecde8d2515afe$export$70238cd3868b67c9.displayName = 'Onboarding';
const $bb0ecde8d2515afe$export$96d5e7da242cacf9 = (0, $aPfsS.composeLayouts)((0, $ibkIl.globalSettingsLayout), {
    get globalComponents () {
        return [
            $bb0ecde8d2515afe$export$70238cd3868b67c9
        ];
    },
    rightSidebars: [
        $bb0ecde8d2515afe$export$f61c80ac3b95bc7d
    ]
});
const $bb0ecde8d2515afe$export$d4e92309ebd00b0f = (0, $aPfsS.createLayout)({
    get globalComponents () {
        return [
            $bb0ecde8d2515afe$export$70238cd3868b67c9
        ];
    },
    rightSidebars: [
        $bb0ecde8d2515afe$export$f61c80ac3b95bc7d
    ]
});
const $bb0ecde8d2515afe$export$5714bc9520dbc6cf = (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), {
    get globalComponents () {
        return [
            $bb0ecde8d2515afe$export$70238cd3868b67c9
        ];
    },
    rightSidebars: [
        $bb0ecde8d2515afe$export$f61c80ac3b95bc7d
    ]
});

});

parcelRegister("hIYBE", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingRoute", () => $8f63b88635f620d8$export$73d6a0dc298aae15);
const $8f63b88635f620d8$export$73d6a0dc298aae15 = {
    name: 'eoc-alert-issue-syncing',
    path: '/jira/settings/products/ops/syncs',
    exact: true
};

});


parcelRegister("i27Sx", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingCreateRouteEntry", () => $529c88752df4ac9c$export$8c07dc381591dc69);

var $fHhvb = parcelRequire("fHhvb");

var $ba5IO = parcelRequire("ba5IO");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $4rSQD = parcelRequire("4rSQD");

var $jh1uq = parcelRequire("jh1uq");

var $3dgEU = parcelRequire("3dgEU");

var $a5NQf = parcelRequire("a5NQf");
const $529c88752df4ac9c$export$8c07dc381591dc69 = (0, $7NszV.createEntry)((0, $4rSQD.eocTeamAlertIssueSyncingCreateRoute), ()=>({
        group: 'eoc',
        component: (0, $jh1uq.AlertIssueSync),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: (0, $3dgEU.AlertIssueSyncCreate),
        basePath: '/jira/ops/teams',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ba5IO.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $fHhvb.resources).configuredSyncsResource,
            (0, $fHhvb.resources).userAccessRightsResource,
            (0, $fHhvb.resources).getTeamResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("ba5IO", function(module, exports) {

$parcel$export(module.exports, "teamResource", () => $532e33a6a5257162$export$87453d709b90ccdf);
$parcel$export(module.exports, "sidebarRightsResource", () => $532e33a6a5257162$export$3b3b9a5b0eddde66);
$parcel$export(module.exports, "resources", () => $532e33a6a5257162$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $gtuj9 = parcelRequire("gtuj9");
var $9dX4l = parcelRequire("9dX4l");

var $2cfbK = parcelRequire("2cfbK");
const $532e33a6a5257162$export$87453d709b90ccdf = (0, $2M1hQ.createResource)({
    type: 'teamResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-dashboard/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $gtuj9.assert)(!!teamId, new (0, $9dX4l.AssertionError)('teamSidebarResource', 'teamId should be set to fetch team-dashboard'));
        return (0, $2cfbK.getTeamByIdEndpoint)(teamId).catch((e)=>{
            e.skipSentry = true;
            throw e;
        });
    },
    maxAge: 300000,
    isBrowserOnly: true
});
const $532e33a6a5257162$export$3b3b9a5b0eddde66 = (0, $2M1hQ.createResource)({
    type: 'sidebarRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-dashboard/${teamId ?? ''}/sidebar-rights`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $gtuj9.assert)(!!teamId, new (0, $9dX4l.AssertionError)('teamSidebarResource', 'teamId should be set to fetch sidebar rights'));
        return (0, $2cfbK.getSidebarRightsEndpoint)(teamId).catch((e)=>{
            e.skipSentry = true;
            throw e;
        });
    },
    isBrowserOnly: true,
    maxAge: Infinity
});
const $532e33a6a5257162$export$bc99aaabaf7b70a7 = ()=>[
        $532e33a6a5257162$export$87453d709b90ccdf,
        $532e33a6a5257162$export$3b3b9a5b0eddde66
    ];

});
parcelRegister("2cfbK", function(module, exports) {

$parcel$export(module.exports, "getTeamByIdEndpoint", () => $ff3f69e5cdd5b7a6$export$bcb25b347f39b3f3);
$parcel$export(module.exports, "getSidebarRightsEndpoint", () => $ff3f69e5cdd5b7a6$export$6f1f62156c62eb91);

var $d9Cgl = parcelRequire("d9Cgl");
const $ff3f69e5cdd5b7a6$export$bcb25b347f39b3f3 = (teamId)=>(0, $d9Cgl.eocFetch)(`/v1/teams/${teamId}?includeImageUrls=true`);
const $ff3f69e5cdd5b7a6$export$6f1f62156c62eb91 = (teamId)=>{
    return (0, $d9Cgl.eocFetch)(`/v1/teams/${teamId}/menu-rights`);
};

});


parcelRegister("3Dk1Z", function(module, exports) {

$parcel$export(module.exports, "LazyTeamDashboardSidebar", () => $d15151561c6a9349$export$a1b7c53ff39475a6);
$parcel$export(module.exports, "default", () => $d15151561c6a9349$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

const $d15151561c6a9349$export$a1b7c53ff39475a6 = (0, $b7Svb.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("lxSIB")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/eoc-team-dashboard/src/index.tsx"
});
const $d15151561c6a9349$var$TeamDashboardSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "eocTeamDashboard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d15151561c6a9349$export$a1b7c53ff39475a6, null));
$d15151561c6a9349$var$TeamDashboardSidebar.displayName = 'TeamDashboardSidebar';
var $d15151561c6a9349$export$2e2bcd8739ae039 = $d15151561c6a9349$var$TeamDashboardSidebar;

});
parcelRegister("lxSIB", function(module, exports) {

let $faf71ffc5a29cb35$var$load = (parcelRequire("28QjX"))(4);
module.exports = $faf71ffc5a29cb35$var$load("dXWqK").then(()=>parcelRequire('hMnGK'));

});


parcelRegister("bh0Pj", function(module, exports) {

$parcel$export(module.exports, "LazyHorizontalOperationsNav", () => $79488f04c14a3737$export$409c821653bbc63b);
$parcel$export(module.exports, "LazyHorizontalOperationsOverviewNav", () => $79488f04c14a3737$export$82108adf6887e32e);
$parcel$export(module.exports, "AsyncHorizontalOperationsNav", () => $79488f04c14a3737$export$1eb785f071697cc5);
$parcel$export(module.exports, "AsyncHorizontalOperationsOverviewNav", () => $79488f04c14a3737$export$27e50c09ebb514f);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $79488f04c14a3737$export$409c821653bbc63b = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("a851b")).then(({ HorizontalOperationsNav: HorizontalOperationsNav })=>HorizontalOperationsNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/horizontal-nav-operations/src/ui/index.tsx"
});

const $79488f04c14a3737$export$82108adf6887e32e = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("a851b")).then(({ OverviewNav: OverviewNav })=>OverviewNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/horizontal-nav-operations/src/ui/index.tsx"
});
const $79488f04c14a3737$export$1eb785f071697cc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-operations-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncHorizontalOperationsNav",
        packageName: "jiraOperationsHorizontalNav",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($79488f04c14a3737$export$409c821653bbc63b, null)));
const $79488f04c14a3737$export$27e50c09ebb514f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-operations-overview-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncHorizontalOperationsOverviewNav",
        packageName: "jiraOperationsHorizontalNav",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($79488f04c14a3737$export$82108adf6887e32e, null)));

});
parcelRegister("a851b", function(module, exports) {

let $75fe8b3ad9634466$var$load = (parcelRequire("28QjX"))(4);
module.exports = $75fe8b3ad9634466$var$load("9F7Gy").then(()=>parcelRequire('kQ8Dl'));

});


parcelRegister("h3Ix2", function(module, exports) {

$parcel$export(module.exports, "opsTeamLayout", () => $687f5bad65d17575$export$53dd27149810df73);

var $aPfsS = parcelRequire("aPfsS");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $687f5bad65d17575$var$RightSidebars = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("emrhD")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/right-sidebars/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $687f5bad65d17575$var$Onboarding = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("gNrcs")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/onboarding/index.tsx"
});
const $687f5bad65d17575$export$53dd27149810df73 = (0, $aPfsS.createLayout)({
    get globalComponents () {
        return [
            $687f5bad65d17575$var$Onboarding
        ];
    },
    rightSidebars: [
        $687f5bad65d17575$var$RightSidebars
    ]
});

});
parcelRegister("emrhD", function(module, exports) {

let $a74848abf5e67182$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a74848abf5e67182$var$load("iRSLc").then(()=>parcelRequire('c3FF8'));

});

parcelRegister("gNrcs", function(module, exports) {

let $c3a6524529def01d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c3a6524529def01d$var$load("g3ZhW").then(()=>parcelRequire('dSHkM'));

});


parcelRegister("4rSQD", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingCreateRoute", () => $daedb7d5520453e5$export$915ef1948fe4650a);
const $daedb7d5520453e5$export$915ef1948fe4650a = {
    name: 'eoc-team-alert-issue-syncing-create',
    path: '/jira/ops/teams/:teamId/syncs/create',
    exact: true
};

});


parcelRegister("qjJTn", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingDetailRouteEntry", () => $a162d438dc34f2e2$export$6298ff494c460e75);

var $fHhvb = parcelRequire("fHhvb");

var $ba5IO = parcelRequire("ba5IO");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $6DLNJ = parcelRequire("6DLNJ");

var $fzxhM = parcelRequire("fzxhM");

var $jh1uq = parcelRequire("jh1uq");

var $a5NQf = parcelRequire("a5NQf");
const $a162d438dc34f2e2$export$6298ff494c460e75 = (0, $7NszV.createEntry)((0, $6DLNJ.eocTeamAlertIssueSyncingDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $jh1uq.AlertIssueSync),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: (0, $fzxhM.AlertIssueSyncDetail),
        basePath: '/jira/ops/teams',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ba5IO.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $fHhvb.resources).configuredSyncsResource,
            (0, $fHhvb.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("6DLNJ", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingDetailRoute", () => $19f7daafdc2ca993$export$e91535fc2137c3b);
const $19f7daafdc2ca993$export$e91535fc2137c3b = {
    name: 'eoc-team-alert-issue-syncing-detail',
    path: '/jira/ops/teams/:teamId/syncs/:syncId',
    exact: true
};

});


parcelRegister("5xt55", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingRouteEntry", () => $4357b8f4ed10df63$export$be342a3401146aae);

var $fHhvb = parcelRequire("fHhvb");

var $ba5IO = parcelRequire("ba5IO");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $f8agQ = parcelRequire("f8agQ");

var $jh1uq = parcelRequire("jh1uq");

var $a5NQf = parcelRequire("a5NQf");
const $4357b8f4ed10df63$export$be342a3401146aae = (0, $7NszV.createEntry)((0, $f8agQ.eocTeamAlertIssueSyncingRoute), ()=>({
        group: 'eoc',
        component: (0, $jh1uq.AlertIssueSync),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: null,
        basePath: '/jira/ops/teams',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ba5IO.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $fHhvb.resources).configuredSyncsResource,
            (0, $fHhvb.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("f8agQ", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingRoute", () => $4b9c202f143c618b$export$37ea7624561cbb89);
const $4b9c202f143c618b$export$37ea7624561cbb89 = {
    name: 'eoc-team-alert-issue-syncing',
    path: '/jira/ops/teams/:teamId/syncs',
    exact: true
};

});


parcelRegister("GJOha", function(module, exports) {

$parcel$export(module.exports, "eocApiKeyManagementRouteEntry", () => $e19c93c774607b0f$export$e18a6be3d2ffad71);

var $fiofQ = parcelRequire("fiofQ");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $eum5y = parcelRequire("eum5y");

var $gZxlv = parcelRequire("gZxlv");
const $e19c93c774607b0f$export$e18a6be3d2ffad71 = (0, $7NszV.createEntry)((0, $eum5y.eocApiKeyManagementRoute), ()=>({
        group: 'eoc',
        component: (0, $gZxlv.default),
        layout: (0, $eZXFU.opsSettingsLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default),
            horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $fiofQ.resources)()
        ],
        forPaint: [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gZxlv.LazyApiKeyManagement)
        ]
    }));

});
parcelRegister("fiofQ", function(module, exports) {

$parcel$export(module.exports, "apiKeysResource", () => $d43ebca3fae16a1b$export$a98d5421eda11f29);
$parcel$export(module.exports, "resources", () => $d43ebca3fae16a1b$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");
parcelRequire("6luO8");
var $dvEFY = parcelRequire("dvEFY");

var $2eq2H = parcelRequire("2eq2H");
const $d43ebca3fae16a1b$export$a98d5421eda11f29 = (0, $2M1hQ.createResource)({
    type: 'api-key-management',
    getKey: ()=>'api-key-management',
    getData: async ({ dependencies: dependencies })=>{
        const data = await dependencies[(0, $dvEFY.eocUserResource).type]?.promise;
        return (0, $2eq2H.fetchKeys)(data.accountId);
    },
    isBrowserOnly: true,
    maxCache: 0,
    maxAge: 0,
    depends: [
        (0, $dvEFY.eocUserResource).type
    ]
});
const $d43ebca3fae16a1b$export$bc99aaabaf7b70a7 = ()=>[
        (0, $dvEFY.eocUserResource),
        $d43ebca3fae16a1b$export$a98d5421eda11f29
    ];

});
parcelRegister("6luO8", function(module, exports) {

$parcel$export(module.exports, "eocCommonResources", () => $d8c73d8a527a41c9$export$8977bbbf2f7167d2);
$parcel$export(module.exports, "eocUserResource", () => (parcelRequire("dvEFY")).eocUserResource);

var $dvEFY = parcelRequire("dvEFY");
const $d8c73d8a527a41c9$export$8977bbbf2f7167d2 = ()=>[
        (0, $dvEFY.eocUserResource)
    ];

});
parcelRegister("dvEFY", function(module, exports) {

$parcel$export(module.exports, "eocUserResource", () => $a5107a742a76dc38$export$3a08a0bdeef86956);

var $2M1hQ = parcelRequire("2M1hQ");

var $9Isaq = parcelRequire("9Isaq");
const $a5107a742a76dc38$export$3a08a0bdeef86956 = (0, $2M1hQ.createResource)({
    type: 'create-user-resource',
    getKey: ()=>'create-user-resource',
    getData: async ()=>(0, $9Isaq.fetchJsmUserInfo)(),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("9Isaq", function(module, exports) {

$parcel$export(module.exports, "fetchJsmUserInfo", () => $21d5c0b4e1df50d7$export$7d750310098b5a7);

var $d9Cgl = parcelRequire("d9Cgl");
var $he0mL = parcelRequire("he0mL");
const $21d5c0b4e1df50d7$var$JSM_BASE_URL = '/rest/api/3/myself';
const $21d5c0b4e1df50d7$export$7d750310098b5a7 = ()=>{
    return (0, $d9Cgl.eocFetch)($21d5c0b4e1df50d7$var$JSM_BASE_URL, {
        exactUrl: true,
        errorTransformer: (0, $he0mL.jsmErrorTransformer)
    });
};

});



parcelRegister("2eq2H", function(module, exports) {

$parcel$export(module.exports, "fetchKeys", () => $dab8b5675b3abbf1$export$a0d93e1b78b8e70b);
$parcel$export(module.exports, "deleteApiKey", () => $dab8b5675b3abbf1$export$d2f8649a375a4113);

var $d9Cgl = parcelRequire("d9Cgl");
const $dab8b5675b3abbf1$export$a0d93e1b78b8e70b = async (accountId)=>{
    return (0, $d9Cgl.eocFetch)('/api-keys/web?accountId=' + accountId);
};
const $dab8b5675b3abbf1$export$d2f8649a375a4113 = async (key, accountId)=>{
    return (0, $d9Cgl.eocFetch)(`/api-keys/web?apiKey=${key}&accountId=${accountId}`, {
        method: 'DELETE'
    });
};

});


parcelRegister("eum5y", function(module, exports) {

$parcel$export(module.exports, "eocApiKeyManagementRoute", () => $3dba976dd77ba6a7$export$84985159d5695f4d);
const $3dba976dd77ba6a7$export$84985159d5695f4d = {
    name: 'eoc-api-key-management',
    path: '/jira/settings/products/ops/api-key-management',
    exact: true
};

});

parcelRegister("gZxlv", function(module, exports) {

$parcel$export(module.exports, "LazyApiKeyManagement", () => $eddc6a8c98318a70$export$6ae4b26c31b1b0d2);
$parcel$export(module.exports, "default", () => $eddc6a8c98318a70$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $eddc6a8c98318a70$export$6ae4b26c31b1b0d2 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("aqjHJ")), {
    moduleId: "./src/packages/eoc/api-key-management/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eddc6a8c98318a70$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $eddc6a8c98318a70$export$6ae4b26c31b1b0d2,
        pageId: "async-jira-eoc-api-key-management",
        shouldShowSpinner: false
    });

});
parcelRegister("aqjHJ", function(module, exports) {

let $796b9df76a31deed$var$load = (parcelRequire("28QjX"))(4);
module.exports = $796b9df76a31deed$var$load("e41T5").then(()=>parcelRequire('95iLR'));

});



parcelRegister("hDU7Y", function(module, exports) {

$parcel$export(module.exports, "eocAssignCustomRolesRouteEntry", () => $34e2a1a3b5a525df$export$c51a4ee3e3f1b270);

var $dGmqV = parcelRequire("dGmqV");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $2ClIR = parcelRequire("2ClIR");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $9Zb2K = parcelRequire("9Zb2K");
const $34e2a1a3b5a525df$var$getNavigationSpecifications = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $34e2a1a3b5a525df$export$c51a4ee3e3f1b270 = (0, $7NszV.createEntry)((0, $2ClIR.eocAssignCustomRolesRoute), ()=>({
        group: 'eoc',
        component: (0, $9Zb2K.default),
        layout: (0, $eZXFU.opsSettingsLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$34e2a1a3b5a525df$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $dGmqV.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9Zb2K.LazyAssignCustomRoles)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9Zb2K.LazyAssignCustomRoles)
        ]
    }));

});
parcelRegister("dGmqV", function(module, exports) {

$parcel$export(module.exports, "rolesResource", () => $2f625d90d0aab723$export$52e29d5915d5f674);
$parcel$export(module.exports, "resources", () => $2f625d90d0aab723$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $kKthc = parcelRequire("kKthc");
const $2f625d90d0aab723$export$52e29d5915d5f674 = (0, $2M1hQ.createResource)({
    type: 'rolesResource',
    getKey: ()=>'rolesResource',
    getData: (0, $kKthc.getRolesEndpoint),
    isBrowserOnly: true
});
const $2f625d90d0aab723$export$bc99aaabaf7b70a7 = ()=>[
        $2f625d90d0aab723$export$52e29d5915d5f674
    ];

});
parcelRegister("kKthc", function(module, exports) {

$parcel$export(module.exports, "getUsersEndpoint", () => $d934131412294eb3$export$d372f7d69e481dba);
$parcel$export(module.exports, "getFilteredUsersEndpoint", () => $d934131412294eb3$export$d8f86d9603f031c0);
$parcel$export(module.exports, "getRolesEndpoint", () => $d934131412294eb3$export$7d0bc1a3c689fc74);
$parcel$export(module.exports, "updateRoleOfUserEndpoint", () => $d934131412294eb3$export$a0b296dc0259976f);

var $d9Cgl = parcelRequire("d9Cgl");

var $490k9 = parcelRequire("490k9");
const $d934131412294eb3$export$d372f7d69e481dba = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
    const [_, query] = queryKey;
    let url = new (0, $490k9.URLBuilder)(`/v1/users/search`).withQueryParam('limit', limit).withQueryParam('query', query).withQueryParam('cursor', lastEvaluatedToken).build();
    return (0, $d9Cgl.eocFetch)(url);
};
const $d934131412294eb3$export$d8f86d9603f031c0 = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
    const [_, ...filters] = queryKey;
    if (filters.length === 0) return Promise.resolve({
        lastEvaluatedToken: '',
        values: []
    });
    return (0, $d9Cgl.eocFetch)('/v1/users/roles/filter', {
        method: 'POST',
        body: {
            limit: limit,
            roles: filters,
            offset: lastEvaluatedToken || 0
        }
    });
};
const $d934131412294eb3$export$7d0bc1a3c689fc74 = ()=>{
    return (0, $d9Cgl.eocFetch)('/v1/users/roles');
};
const $d934131412294eb3$export$a0b296dc0259976f = ({ roleId: roleId, accountId: accountId })=>{
    return (0, $d9Cgl.eocFetch)(`/v1/users/roles/assign`, {
        method: 'PATCH',
        body: {
            accountId: accountId,
            roleId: roleId
        }
    });
};

});
parcelRegister("490k9", function(module, exports) {

$parcel$export(module.exports, "URLBuilder", () => $323256fd3c3be3ef$export$61d2e8db329a11f8);
class $323256fd3c3be3ef$export$61d2e8db329a11f8 {
    constructor(url){
        this.url = url;
        this.params = {};
    }
    withQueryParam(key, value) {
        this.params[key] = value;
        return this;
    }
    build() {
        const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '').map(([key, value])=>[
                key,
                value && value.toString()
            ]);
        const queryInstance = new URLSearchParams(filteredParams);
        const queryParams = queryInstance.toString();
        if (queryParams === '') return `${this.url}`;
        if (queryParams) return `${this.url}?${queryParams}`;
        return this.url;
    }
}

});



parcelRegister("2ClIR", function(module, exports) {

$parcel$export(module.exports, "eocAssignCustomRolesRoute", () => $fee4692ea74fc971$export$79c37191a61ac94b);
const $fee4692ea74fc971$export$79c37191a61ac94b = {
    name: 'eoc-assign-custom-roles',
    path: '/jira/settings/products/ops/role-assignment',
    exact: true
};

});

parcelRegister("9Zb2K", function(module, exports) {

$parcel$export(module.exports, "LazyAssignCustomRoles", () => $cbc95c821be59e53$export$fb6bafef9453a357);
$parcel$export(module.exports, "default", () => $cbc95c821be59e53$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $cbc95c821be59e53$export$fb6bafef9453a357 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("w8Kg8")), {
    moduleId: "./src/packages/eoc/assign-custom-roles/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cbc95c821be59e53$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cbc95c821be59e53$export$fb6bafef9453a357,
        pageId: "async-eoc-assign-custom-roles",
        shouldShowSpinner: false
    });

});
parcelRegister("w8Kg8", function(module, exports) {

let $0609c5df35184313$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0609c5df35184313$var$load("ligT4").then(()=>parcelRequire('i3AK8'));

});



parcelRegister("dHqTd", function(module, exports) {

$parcel$export(module.exports, "eocAutomationsRouteEntry", () => $dd0ff3cccea414a4$export$6ff606556e19e12);

var $ba5IO = parcelRequire("ba5IO");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $cIZ9i = parcelRequire("cIZ9i");

var $12Bno = parcelRequire("12Bno");
const $dd0ff3cccea414a4$export$6ff606556e19e12 = (0, $7NszV.createEntry)((0, $cIZ9i.eocAutomationsRoute), ()=>({
        group: 'eoc',
        component: (0, $12Bno.default),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ba5IO.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $12Bno.LazyOpsTeamAutomation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("cIZ9i", function(module, exports) {

$parcel$export(module.exports, "eocAutomationsRoute", () => $0aa16b205f7e3033$export$4a84eb4d8d37c9d4);
const $0aa16b205f7e3033$export$4a84eb4d8d37c9d4 = {
    name: 'eoc-automations',
    path: '/jira/ops/teams/:teamId/automations',
    exact: true
};

});

parcelRegister("12Bno", function(module, exports) {

$parcel$export(module.exports, "LazyOpsTeamAutomation", () => $1cf116b0539aa5be$export$903a0a44cc0933c5);
$parcel$export(module.exports, "default", () => $1cf116b0539aa5be$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $1cf116b0539aa5be$export$903a0a44cc0933c5 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("5OGnD")), {
    moduleId: "./src/packages/spa-apps/ops-team-scope-automation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1cf116b0539aa5be$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1cf116b0539aa5be$export$903a0a44cc0933c5,
        pageId: "ops-team-automation",
        shouldShowSpinner: true
    });

});
parcelRegister("5OGnD", function(module, exports) {

let $43c27f1380633e85$var$load = (parcelRequire("28QjX"))(4);
module.exports = $43c27f1380633e85$var$load("9mAAJ").then(()=>parcelRequire('j6Qxa'));

});



parcelRegister("9KhdI", function(module, exports) {

$parcel$export(module.exports, "eocCustomRolesRouteEntry", () => $98b5efb8026932b2$export$9c9bab95d425eb6f);

var $8F9cY = parcelRequire("8F9cY");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $7WUUX = parcelRequire("7WUUX");

var $4R6GH = parcelRequire("4R6GH");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $7s8Fa = parcelRequire("7s8Fa");

var $7vwGd = parcelRequire("7vwGd");
const $98b5efb8026932b2$var$getNavigationSpecifications = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $98b5efb8026932b2$export$9c9bab95d425eb6f = (0, $7NszV.createEntry)((0, $7WUUX.eocCustomRolesRoute), ()=>({
        group: 'eoc',
        component: (0, $7vwGd.default),
        layout: (0, $eZXFU.opsSettingsLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$98b5efb8026932b2$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $8F9cY.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7vwGd.LazyCustomRoles)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7vwGd.LazyCustomRoles)
        ]
    }));

});
parcelRegister("8F9cY", function(module, exports) {

$parcel$export(module.exports, "customRolesResource", () => $8e4cf4a7c377c25c$export$7140716a1b1b8e7a);
$parcel$export(module.exports, "resources", () => $8e4cf4a7c377c25c$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $lEgQV = parcelRequire("lEgQV");
const $8e4cf4a7c377c25c$export$7140716a1b1b8e7a = (0, $2M1hQ.createResource)({
    type: 'rolesResource',
    getKey: ()=>'rolesResource',
    getData: (0, $lEgQV.getCustomRolesListEndpoint),
    isBrowserOnly: true
});
const $8e4cf4a7c377c25c$export$bc99aaabaf7b70a7 = ()=>[
        $8e4cf4a7c377c25c$export$7140716a1b1b8e7a
    ];

});
parcelRegister("lEgQV", function(module, exports) {

$parcel$export(module.exports, "getPermissionsEndpoint", () => $6f5fbe2cde8361e2$export$f97b589720c51ce1);
$parcel$export(module.exports, "createCustomRoleEndpoint", () => $6f5fbe2cde8361e2$export$5a7187e04c844900);
$parcel$export(module.exports, "editCustomRoleEndpoint", () => $6f5fbe2cde8361e2$export$304735a80b86192e);
$parcel$export(module.exports, "deleteCustomRoleEndpoint", () => $6f5fbe2cde8361e2$export$e12995ccad013f65);
$parcel$export(module.exports, "getCustomRolesListEndpoint", () => $6f5fbe2cde8361e2$export$3619edac53aa59fd);

var $d9Cgl = parcelRequire("d9Cgl");
const $6f5fbe2cde8361e2$export$f97b589720c51ce1 = ()=>(0, $d9Cgl.eocFetch)(`/v1/users/permissions`);
const $6f5fbe2cde8361e2$export$5a7187e04c844900 = (newCustomRole)=>(0, $d9Cgl.eocFetch)(`/v1/users/roles`, {
        method: 'POST',
        body: newCustomRole
    });
const $6f5fbe2cde8361e2$export$304735a80b86192e = (updatedCustomRole)=>{
    const { id: id } = updatedCustomRole;
    return (0, $d9Cgl.eocFetch)(`/v1/users/roles/${id}`, {
        method: 'PATCH',
        body: updatedCustomRole
    });
};
const $6f5fbe2cde8361e2$export$e12995ccad013f65 = (id)=>{
    return (0, $d9Cgl.eocFetch)(`/v1/users/roles/${id}`, {
        method: 'DELETE'
    });
};
const $6f5fbe2cde8361e2$export$3619edac53aa59fd = ()=>(0, $d9Cgl.eocFetch)(`/v1/users/roles`);

});


parcelRegister("7WUUX", function(module, exports) {

$parcel$export(module.exports, "eocCustomRolesRoute", () => $550a6202cdc3f9f3$export$3213a7325ca9911);
const $550a6202cdc3f9f3$export$3213a7325ca9911 = {
    name: 'eoc-custom-roles',
    path: '/jira/settings/products/ops/roles',
    exact: true
};

});

parcelRegister("7vwGd", function(module, exports) {

$parcel$export(module.exports, "LazyCustomRoles", () => $ae4b2d4dc59e70bc$export$78ed54710f55f948);
$parcel$export(module.exports, "default", () => $ae4b2d4dc59e70bc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $ae4b2d4dc59e70bc$export$78ed54710f55f948 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("fPwHB")), {
    moduleId: "./src/packages/eoc/custom-roles/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ae4b2d4dc59e70bc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ae4b2d4dc59e70bc$export$78ed54710f55f948,
        pageId: "async-eoc-custom-roles",
        shouldShowSpinner: false
    });

});
parcelRegister("fPwHB", function(module, exports) {

let $b864fc72975b3318$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b864fc72975b3318$var$load("47IHZ").then(()=>parcelRequire('WACar'));

});



parcelRegister("7LUIt", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertListRouteEntry", () => $0edb022327e9a2a9$export$851a659e50436cff);

var $ivQlE = parcelRequire("ivQlE");

var $ffza4 = parcelRequire("ffza4");

var $iqZds = parcelRequire("iqZds");

var $lmyls = parcelRequire("lmyls");

var $gLQQv = parcelRequire("gLQQv");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $lUaB2 = parcelRequire("lUaB2");

var $lFFGs = parcelRequire("lFFGs");
const $0edb022327e9a2a9$export$851a659e50436cff = (0, $7NszV.createEntry)((0, $lUaB2.eocGlobalAlertListRoute), ()=>({
        group: 'eoc',
        component: (0, $lFFGs.AlertListComponent),
        layout: (0, $iqZds.eocChangeboardingLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ivQlE.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME,
            sidebar: (0, $gLQQv.AsyncSidebarEocGlobalAlerts)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lFFGs.LazyAlertList),
            (0, $gLQQv.LazyGlobalAlertsSidebar)
        ]
    }));

});
parcelRegister("ivQlE", function(module, exports) {

$parcel$export(module.exports, "resources", () => $c6ba2076e01ef430$export$bc99aaabaf7b70a7);

var $jZJFB = parcelRequire("jZJFB");

var $6luO8 = parcelRequire("6luO8");

var $4HRAl = parcelRequire("4HRAl");

var $3AkS5 = parcelRequire("3AkS5");

var $6M8JF = parcelRequire("6M8JF");
const $c6ba2076e01ef430$export$bc99aaabaf7b70a7 = ()=>[
        (0, $6M8JF.uiPreferencesResource),
        (0, $3AkS5.savedSearchesResource),
        (0, $4HRAl.compressionRatioResource),
        (0, $jZJFB.alertGroupingStateResource),
        ...(0, $6luO8.eocCommonResources)()
    ];

});
parcelRegister("jZJFB", function(module, exports) {

$parcel$export(module.exports, "alertGroupingStateResource", () => $4f1c129df390d957$export$722cc8285202ce44);

var $2M1hQ = parcelRequire("2M1hQ");

var $bcnSZ = parcelRequire("bcnSZ");
const $4f1c129df390d957$var$emptyAlertGroupingState = {
    isEnabled: false,
    reason: null
};
const $4f1c129df390d957$export$722cc8285202ce44 = (0, $2M1hQ.createResource)({
    type: 'alertGroupingStateResource',
    getKey: ()=>'alertGroupingStateResource',
    getData: async ()=>{
        try {
            const response = await (0, $bcnSZ.getGroupFeatureStatus)();
            return response;
        } catch (e) {
            // Exception handling and to return emptyState
            return $4f1c129df390d957$var$emptyAlertGroupingState;
        }
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("bcnSZ", function(module, exports) {

$parcel$export(module.exports, "getGroupFeatureStatus", () => $272b7df63ecd0660$export$48deee62d9dfb365);

var $gxN8D = parcelRequire("gxN8D");

var $ibUNQ = parcelRequire("ibUNQ");

var $d9Cgl = parcelRequire("d9Cgl");
const $272b7df63ecd0660$export$48deee62d9dfb365 = ()=>{
    const url = new (0, $ibUNQ.URLBuilder)((0, $gxN8D.withAIOpsDomainPrefix)('/v1/aiops/feature-state')).withQueryParam('featureName', 'alert-grouping').build();
    return (0, $d9Cgl.eocFetch)(url, {
        exactUrl: true
    });
};

});
parcelRegister("gxN8D", function(module, exports) {

$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $f8589c0494593e17$export$81c70e0016508593);

var $he0mL = parcelRequire("he0mL");
const $f8589c0494593e17$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $he0mL.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};

});

parcelRegister("ibUNQ", function(module, exports) {

$parcel$export(module.exports, "URLBuilder", () => $1162dd1f5ccbd37c$export$61d2e8db329a11f8);
class $1162dd1f5ccbd37c$export$61d2e8db329a11f8 {
    constructor(url){
        this.url = url;
        this.params = {};
    }
    withQueryParam(key, value) {
        this.params[key] = value;
        return this;
    }
    build() {
        const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '');
        const queryInstance = new URLSearchParams(filteredParams);
        const queryParams = queryInstance.toString();
        if (queryParams) return `${this.url}?${queryParams}`;
        return this.url;
    }
}

});



parcelRegister("4HRAl", function(module, exports) {

$parcel$export(module.exports, "compressionRatioResource", () => $cf77f4cef40ff92c$export$8c912e73f758af2);

var $2M1hQ = parcelRequire("2M1hQ");

var $3IvDB = parcelRequire("3IvDB");
const $cf77f4cef40ff92c$var$emptyCompressionBanner = {
    compressionRatio: 0,
    uniqueGroupCount: 0,
    rollingWindow: 0
};
const $cf77f4cef40ff92c$export$8c912e73f758af2 = (0, $2M1hQ.createResource)({
    type: 'compressionRatioResource',
    getKey: ()=>'compressionRatioResource',
    getData: async ()=>{
        try {
            const response = await (0, $3IvDB.getCompressionRatio)();
            return response;
        } catch (e) {
            return $cf77f4cef40ff92c$var$emptyCompressionBanner;
        }
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("3IvDB", function(module, exports) {

$parcel$export(module.exports, "getCompressionRatio", () => $8573cfcbcd86f177$export$4991457f359db4f7);

var $d9Cgl = parcelRequire("d9Cgl");

var $4KhXr = parcelRequire("4KhXr");
const $8573cfcbcd86f177$export$4991457f359db4f7 = ()=>{
    return (0, $d9Cgl.eocFetch)((0, $4KhXr.withAIOpsDomainPrefix)('/v1/alert-insights/compression-ratio'), {
        exactUrl: true
    });
};

});


parcelRegister("3AkS5", function(module, exports) {

$parcel$export(module.exports, "savedSearchesResource", () => $514eff728e124a67$export$d915b849e6dd786b);

var $2M1hQ = parcelRequire("2M1hQ");

var $fwwof = parcelRequire("fwwof");
const $514eff728e124a67$export$d915b849e6dd786b = (0, $2M1hQ.createResource)({
    type: 'savedSearchesResource',
    getKey: ()=>'savedSearchesResource',
    getData: ()=>(0, $fwwof.getSavedSearchesEndpoint)(),
    maxAge: 300000,
    isBrowserOnly: true
});

});

parcelRegister("6M8JF", function(module, exports) {

$parcel$export(module.exports, "uiPreferencesResource", () => $776bc5e2a2dcf500$export$4e143f0fe4b2e025);

var $2M1hQ = parcelRequire("2M1hQ");

var $dtT9z = parcelRequire("dtT9z");
const $776bc5e2a2dcf500$export$4e143f0fe4b2e025 = (0, $2M1hQ.createResource)({
    type: 'uiPreferencesResource',
    getKey: ()=>'uiPreferencesResource',
    getData: ()=>(0, $dtT9z.getUiPreferencesEndpoint)(),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("dtT9z", function(module, exports) {

$parcel$export(module.exports, "getUiPreferencesEndpoint", () => $38ca6f3e79a4b44a$export$afa4854419ed2fc8);
$parcel$export(module.exports, "updateUiPreferencesEndpoint", () => $38ca6f3e79a4b44a$export$4990793476d8f783);

var $d9Cgl = parcelRequire("d9Cgl");
const $38ca6f3e79a4b44a$export$afa4854419ed2fc8 = ()=>{
    return (0, $d9Cgl.eocFetch)('/v1/alerts/ui-preferences');
};
const $38ca6f3e79a4b44a$export$4990793476d8f783 = (data)=>{
    return (0, $d9Cgl.eocFetch)('/v1/alerts/ui-preferences', {
        method: 'PATCH',
        body: data
    });
};

});



parcelRegister("gLQQv", function(module, exports) {

$parcel$export(module.exports, "LazyGlobalAlertsSidebar", () => $423d186a1838bb07$export$674fd99c08c90491);
$parcel$export(module.exports, "AsyncSidebarEocGlobalAlerts", () => $423d186a1838bb07$export$a1c034c1031e8711);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $b7Svb = parcelRequire("b7Svb");

const $423d186a1838bb07$export$674fd99c08c90491 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("hccgJ")).then((bundle)=>bundle), {
    moduleId: "./src/packages/navigation-apps/sidebar/eoc-global-alerts/src/index.tsx"
});
const $423d186a1838bb07$export$a1c034c1031e8711 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "eocGlobalAlerts"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($423d186a1838bb07$export$674fd99c08c90491, null));

});
parcelRegister("hccgJ", function(module, exports) {

let $c84d12fb9c376d36$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c84d12fb9c376d36$var$load("39Zx1").then(()=>parcelRequire('2kjD7'));

});


parcelRegister("lFFGs", function(module, exports) {

$parcel$export(module.exports, "LazyAlertList", () => $a8d77694d1ebf81f$export$f4aafff31d950b6c);
$parcel$export(module.exports, "AlertListComponent", () => $a8d77694d1ebf81f$export$9333bfa567c9c31);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $a8d77694d1ebf81f$export$f4aafff31d950b6c = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("lTHKb")), {
    moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
});
const $a8d77694d1ebf81f$export$9333bfa567c9c31 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a8d77694d1ebf81f$export$f4aafff31d950b6c,
        pageId: "async-jira-eoc-alert-list",
        shouldShowSpinner: false
    });

});
parcelRegister("lTHKb", function(module, exports) {

let $ff10aaaa6ea6a1ff$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ff10aaaa6ea6a1ff$var$load("h2MrD"),
    $ff10aaaa6ea6a1ff$var$load("bYT2S"),
    $ff10aaaa6ea6a1ff$var$load("dsiAd"),
    $ff10aaaa6ea6a1ff$var$load("1Z4yj")
]).then(()=>parcelRequire('cHlJB'));

});



parcelRegister("3EMmS", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertsDetailRouteEntry", () => $ffa726838ac9512f$export$bcb93d8198d511b9);

var $iSEF2 = parcelRequire("iSEF2");

var $ivQlE = parcelRequire("ivQlE");

var $i5qMw = parcelRequire("i5qMw");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $gLQQv = parcelRequire("gLQQv");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $lOzKo = parcelRequire("lOzKo");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $lFFGs = parcelRequire("lFFGs");
const $ffa726838ac9512f$export$bcb93d8198d511b9 = (0, $7NszV.createEntry)((0, $lOzKo.eocGlobalAlertsDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $lFFGs.AlertListComponent),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ivQlE.resources)(),
            ...(0, $iSEF2.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('automation_discoverability_in_jsm'), (0, $i5qMw.getAutomationDiscoveryDismissResource))
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME,
            sidebar: (0, $gLQQv.AsyncSidebarEocGlobalAlerts)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lFFGs.LazyAlertList),
            (0, $gLQQv.LazyGlobalAlertsSidebar)
        ]
    }));

});
parcelRegister("iSEF2", function(module, exports) {

$parcel$export(module.exports, "alertDetailResource", () => $c0947c675bb0ae0c$export$f918335771807ac4);
$parcel$export(module.exports, "logTypesResource", () => $c0947c675bb0ae0c$export$f9c57ab4d5f63686);
$parcel$export(module.exports, "entityRelationTypesResource", () => $c0947c675bb0ae0c$export$a5515392cb45b9f8);
$parcel$export(module.exports, "responderStatesResource", () => $c0947c675bb0ae0c$export$c3b70747662e5932);
$parcel$export(module.exports, "resources", () => $c0947c675bb0ae0c$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $6CZ6k = parcelRequire("6CZ6k");

var $fHpHg = parcelRequire("fHpHg");

var $cakSK = parcelRequire("cakSK");

var $gtuj9 = parcelRequire("gtuj9");
var $9dX4l = parcelRequire("9dX4l");

var $6luO8 = parcelRequire("6luO8");

var $5IxLA = parcelRequire("5IxLA");

var $ddGmO = parcelRequire("ddGmO");
const $c0947c675bb0ae0c$var$ALERT_DETAIL_RESOURCE_TYPE = 'alertDetailResource';
const $c0947c675bb0ae0c$export$f918335771807ac4 = (0, $2M1hQ.createResource)({
    type: $c0947c675bb0ae0c$var$ALERT_DETAIL_RESOURCE_TYPE,
    getKey: (routerContext)=>`alertDetailResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        (0, $gtuj9.assert)(!!alertId, new (0, $9dX4l.AssertionError)('alertDetailResource', 'alertId should be set to fetch alert-detail'));
        return (0, $ddGmO.getAlertDetail)(alertId);
    },
    isBrowserOnly: true
});
const $c0947c675bb0ae0c$export$f9c57ab4d5f63686 = (0, $2M1hQ.createResource)({
    type: 'logTypesResource',
    getKey: (routerContext)=>`logTypesResource#${routerContext.match.params.id}`,
    getData: async ()=>{
        return (0, $ddGmO.getAlertLogTypesEndpoint)();
    },
    isBrowserOnly: true
});
const $c0947c675bb0ae0c$export$a5515392cb45b9f8 = (0, $2M1hQ.createResource)({
    type: 'entityRelationTypesResource',
    getKey: (routerContext)=>`entityRelationTypesResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        const dependencies = routerContext.dependencies;
        (0, $gtuj9.assert)(!!alertId, new (0, $9dX4l.AssertionError)('alertDetaentityRelationTypesResourceilResource', 'alertId should be set to fetch alert-detail'));
        // if id on the url is not a valid uuid and flag is on then wait for alertDetailResource to resolve for getting id of the alert instead of tinyId
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6CZ6k)))(alertId) && (0, $fHpHg.fg)('alert_detail_convert_tiny_id_to_alert_id')) {
            const { id: id } = await (0, $5IxLA.consumeDependency)(dependencies, $c0947c675bb0ae0c$var$ALERT_DETAIL_RESOURCE_TYPE);
            return (0, $ddGmO.getEntityRelationTypesEndpoint)(id);
        }
        return (0, $ddGmO.getEntityRelationTypesEndpoint)(alertId);
    },
    depends: [
        $c0947c675bb0ae0c$var$ALERT_DETAIL_RESOURCE_TYPE
    ],
    isBrowserOnly: true
});
const $c0947c675bb0ae0c$export$c3b70747662e5932 = (0, $2M1hQ.createResource)({
    type: 'responderStatesResource',
    getKey: (routerContext)=>`responderStatesResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        const dependencies = routerContext.dependencies;
        (0, $gtuj9.assert)(!!alertId, new (0, $9dX4l.AssertionError)('alertDetaentityRelationTypesResourceilResource', 'alertId should be set to fetch alert-detail'));
        // if id on the url is not a valid uuid and flag is on then wait for alertDetailResource to resolve for getting id of the alert instead of tinyId
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6CZ6k)))(alertId) && (0, $fHpHg.fg)('alert_detail_convert_tiny_id_to_alert_id')) {
            const { id: id } = await (0, $5IxLA.consumeDependency)(dependencies, $c0947c675bb0ae0c$var$ALERT_DETAIL_RESOURCE_TYPE);
            return (0, $ddGmO.getResponderStatesEndpoint)(id);
        }
        return (0, $ddGmO.getResponderStatesEndpoint)(alertId);
    },
    depends: [
        $c0947c675bb0ae0c$var$ALERT_DETAIL_RESOURCE_TYPE
    ],
    isBrowserOnly: true
});
const $c0947c675bb0ae0c$export$bc99aaabaf7b70a7 = ()=>[
        $c0947c675bb0ae0c$export$f918335771807ac4,
        $c0947c675bb0ae0c$export$f9c57ab4d5f63686,
        $c0947c675bb0ae0c$export$c3b70747662e5932,
        $c0947c675bb0ae0c$export$a5515392cb45b9f8,
        (0, $cakSK.relatedAlertGroupResource),
        ...(0, $6luO8.eocCommonResources)()
    ];

});
parcelRegister("cakSK", function(module, exports) {

$parcel$export(module.exports, "relatedAlertGroupResource", () => $6def4abcd2a3e63a$export$35df14c9f0cfb113);

var $2M1hQ = parcelRequire("2M1hQ");

var $gtuj9 = parcelRequire("gtuj9");
var $9dX4l = parcelRequire("9dX4l");

var $dVGYb = parcelRequire("dVGYb");
const $6def4abcd2a3e63a$export$35df14c9f0cfb113 = (0, $2M1hQ.createResource)({
    type: 'relatedAlertGroupResource',
    getKey: (routerContext)=>`relatedAlertGroupResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        (0, $gtuj9.assert)(!!alertId, new (0, $9dX4l.AssertionError)('relatedAlertGroupResource', 'alertId should be set to fetch related alert-groups'));
        return (0, $dVGYb.getRelatedAlertGroup)(alertId);
    },
    isBrowserOnly: true
});

});
parcelRegister("dVGYb", function(module, exports) {

$parcel$export(module.exports, "getRelatedAlertGroup", () => $cc1d87830f6fc1fa$export$665e34f20aad273a);

var $d9Cgl = parcelRequire("d9Cgl");

var $7NPlO = parcelRequire("7NPlO");
const $cc1d87830f6fc1fa$export$665e34f20aad273a = (alertId)=>(0, $d9Cgl.eocFetch)((0, $7NPlO.withAIOpsDomainPrefix)(`/v1/group-insights/get-group-of-alert?alertId=${alertId}`), {
        exactUrl: true
    });

});
parcelRegister("7NPlO", function(module, exports) {

$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $0c134de8b8279145$export$81c70e0016508593);

var $he0mL = parcelRequire("he0mL");
const $0c134de8b8279145$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $he0mL.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};

});



parcelRegister("5IxLA", function(module, exports) {

$parcel$export(module.exports, "consumeDependency", () => $73bca9d178f11c72$export$a973ef9e17a326f);
async function $73bca9d178f11c72$export$a973ef9e17a326f(dependencies, key) {
    // There is an inflight request, the response is source of truth
    if (dependencies[key]?.loading) return dependencies[key]?.promise;
    if (dependencies[key]?.error) // Our dependency errored out the last time it ran, we don't have the data
    throw dependencies[key]?.error;
    // Last response is what we want
    return dependencies[key]?.data;
}

});

parcelRegister("ddGmO", function(module, exports) {

$parcel$export(module.exports, "getAlertDetail", () => $8826a69b82c2b9e3$export$436b6d88c1865c54);
$parcel$export(module.exports, "getAlertLogTypesEndpoint", () => $8826a69b82c2b9e3$export$97200f7e7a7d1479);
$parcel$export(module.exports, "getResponderStatesEndpoint", () => $8826a69b82c2b9e3$export$498d1a9ea659d430);
$parcel$export(module.exports, "getEntityRelationTypesEndpoint", () => $8826a69b82c2b9e3$export$8f96130abdd7549d);

var $d9Cgl = parcelRequire("d9Cgl");
const $8826a69b82c2b9e3$export$436b6d88c1865c54 = (alertId)=>(0, $d9Cgl.eocFetch)(`/v1/alerts/${alertId}`);
const $8826a69b82c2b9e3$export$97200f7e7a7d1479 = ()=>(0, $d9Cgl.eocFetch)(`/v1/alerts/logs/types`);
const $8826a69b82c2b9e3$export$498d1a9ea659d430 = (alertId)=>(0, $d9Cgl.eocFetch)(`/v1/alerts/${alertId}/responder-states`);
const $8826a69b82c2b9e3$export$8f96130abdd7549d = (alertId)=>(0, $d9Cgl.eocFetch)(`/v1/alerts/${alertId}/entity-relations/relation-types`).then((res)=>({
            relationTypes: res.relationTypes.sort((a, b)=>a.label.localeCompare(b.label))
        }));

});


parcelRegister("i5qMw", function(module, exports) {

$parcel$export(module.exports, "getAutomationDiscoveryDismissResource", () => $e60dab4293b0384b$export$3e9b930ef3c80543);

var $2M1hQ = parcelRequire("2M1hQ");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

const $e60dab4293b0384b$var$PROPERTY_KEY = 'jira.user.issue.automation-discoverability.panel.state';
const $e60dab4293b0384b$export$3e9b930ef3c80543 = (0, $2M1hQ.createResource)({
    type: 'getAutomationDiscoveryDismiss',
    getKey: ()=>'getAutomationDiscoveryDismiss',
    getData: async ()=>{
        try {
            const res = await (0, $eusud.performGetRequest)(`/rest/api/3/mypreferences?key=${$e60dab4293b0384b$var$PROPERTY_KEY}`);
            return res;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef)) return null;
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'getDismissData',
                    teamName: 'ITOps Phantom',
                    packageName: 'jiraEocAutomationDiscovery'
                }
            });
            throw error;
        }
    },
    maxAge: 300000
});

});

parcelRegister("lOzKo", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertsDetailRoute", () => $e176fbe640598c13$export$d87948ea641004e2);
const $e176fbe640598c13$export$d87948ea641004e2 = {
    name: 'eoc-global-alert-detail',
    path: '/jira/ops/alerts/:id',
    exact: true
};

});


parcelRegister("q3duL", function(module, exports) {

$parcel$export(module.exports, "globalEscalationsRouteEntry", () => $ef2506bfe64688a1$export$adde4536d8e5f94c);

var $5uXOq = parcelRequire("5uXOq");

var $lJwjj = parcelRequire("lJwjj");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $6yAvP = parcelRequire("6yAvP");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ef2506bfe64688a1$var$LazyGlobalEscalations = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("5cOrb")).then((module)=>module.GlobalEscalationsPage), {
    moduleId: "./src/packages/eoc/global-escalations/src/index.tsx"
});
const $ef2506bfe64688a1$var$GlobalEscalationsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ef2506bfe64688a1$var$LazyGlobalEscalations,
        pageId: "async-jira-eoc-global-escalations",
        shouldShowSpinner: false
    });
const $ef2506bfe64688a1$var$getNavigationSpecifications = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $ef2506bfe64688a1$export$adde4536d8e5f94c = (0, $7NszV.createEntry)((0, $6yAvP.globalEscalationsRoute), ()=>({
        group: 'eoc',
        component: $ef2506bfe64688a1$var$GlobalEscalationsComponent,
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $lJwjj.globalEscalationsListInfoResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$ef2506bfe64688a1$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            $ef2506bfe64688a1$var$LazyGlobalEscalations
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            $ef2506bfe64688a1$var$LazyGlobalEscalations
        ]
    }));

});
parcelRegister("lJwjj", function(module, exports) {

$parcel$export(module.exports, "globalEscalationsListInfoResource", () => $ee0fb39d5a898e4d$export$bffddc002dadaf3a);

var $2M1hQ = parcelRequire("2M1hQ");

var $7FoFl = parcelRequire("7FoFl");
const $ee0fb39d5a898e4d$export$bffddc002dadaf3a = (0, $2M1hQ.createResource)({
    type: 'globalEscalationsListInfoResource',
    getKey: ()=>'globalEscalationsListInfoResource',
    getData: (0, $7FoFl.getListInfo),
    isBrowserOnly: true
});

});
parcelRegister("7FoFl", function(module, exports) {

$parcel$export(module.exports, "getEscalations", () => $8c5a5281a080031d$export$300727380b60aeb4);
$parcel$export(module.exports, "getListInfo", () => $8c5a5281a080031d$export$bdc8fe7d9cd263b);

var $d9Cgl = parcelRequire("d9Cgl");
const $8c5a5281a080031d$export$300727380b60aeb4 = ({ lastEvaluatedToken: lastEvaluatedToken, queryKey: queryKey })=>{
    const [, filtersString] = queryKey;
    const filters = JSON.parse(filtersString);
    const params = new URLSearchParams({
        ...filters,
        lastEvaluatedToken: lastEvaluatedToken
    });
    return (0, $d9Cgl.eocFetch)(`/v1/escalations/search?${params.toString()}`);
};
const $8c5a5281a080031d$export$bdc8fe7d9cd263b = ()=>{
    return (0, $d9Cgl.eocFetch)('/v1/escalations/list-info');
};

});


parcelRegister("6yAvP", function(module, exports) {

$parcel$export(module.exports, "globalEscalationsRoute", () => $b256c068fa7916da$export$9ed12f6fa845edfb);
const $b256c068fa7916da$export$9ed12f6fa845edfb = {
    name: 'eoc-global-escalations',
    path: '/jira/settings/products/ops/escalation-policies',
    exact: true
};

});

parcelRegister("5cOrb", function(module, exports) {

let $3ca532902c1f45d8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3ca532902c1f45d8$var$load("h2MrD"),
    $3ca532902c1f45d8$var$load("bYT2S"),
    $3ca532902c1f45d8$var$load("fUucv")
]).then(()=>parcelRequire('dLkuj'));

});


parcelRegister("4Ykyz", function(module, exports) {

$parcel$export(module.exports, "eocGlobalGroupDetailRouteEntry", () => $08aebbbf84aea52e$export$66928ab349190059);

var $ivQlE = parcelRequire("ivQlE");

var $dvNmg = parcelRequire("dvNmg");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $gLQQv = parcelRequire("gLQQv");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $7eLbt = parcelRequire("7eLbt");

var $lgLgL = parcelRequire("lgLgL");
const $08aebbbf84aea52e$export$66928ab349190059 = (0, $7NszV.createEntry)((0, $7eLbt.eocGlobalGroupDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $lgLgL.default),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $dvNmg.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $ivQlE.resources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME,
            sidebar: (0, $gLQQv.AsyncSidebarEocGlobalAlerts)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lgLgL.LazyGroupDetail),
            (0, $gLQQv.LazyGlobalAlertsSidebar)
        ]
    }));

});
parcelRegister("dvNmg", function(module, exports) {

$parcel$export(module.exports, "groupHeaderResource", () => $a77dcb0de2ca5484$export$e6ba56f6b67069c8);
$parcel$export(module.exports, "aiSuggestionsResource", () => $a77dcb0de2ca5484$export$94675faef1d4568b);
$parcel$export(module.exports, "resources", () => $a77dcb0de2ca5484$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $gtuj9 = parcelRequire("gtuj9");
var $9dX4l = parcelRequire("9dX4l");

var $9vxEo = parcelRequire("9vxEo");
const $a77dcb0de2ca5484$export$e6ba56f6b67069c8 = (0, $2M1hQ.createResource)({
    type: 'groupHeaderResource',
    getKey: (routerContext)=>`groupHeaderResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const groupId = routerContext.match.params?.id;
        (0, $gtuj9.assert)(!!groupId, new (0, $9dX4l.AssertionError)('groupHeaderResource', 'groupId should be set to fetch group-detail-header'));
        return (0, $9vxEo.getHeaderDetails)(groupId);
    },
    isBrowserOnly: true
});
const $a77dcb0de2ca5484$export$94675faef1d4568b = (0, $2M1hQ.createResource)({
    type: 'aiSuggestionsResource',
    getKey: (routerContext)=>`aiSuggestionsResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const groupId = routerContext.match.params?.id;
        (0, $gtuj9.assert)(!!groupId, new (0, $9dX4l.AssertionError)('aiSuggestionsResource', 'groupId should be set to fetch ai-suggestions for any group'));
        return (0, $9vxEo.getAISuggestions)(groupId);
    },
    isBrowserOnly: true
});
const $a77dcb0de2ca5484$export$bc99aaabaf7b70a7 = ()=>[
        $a77dcb0de2ca5484$export$e6ba56f6b67069c8,
        $a77dcb0de2ca5484$export$94675faef1d4568b
    ];

});
parcelRegister("9vxEo", function(module, exports) {

$parcel$export(module.exports, "getHeaderDetails", () => $ec8589277a6387ab$export$c0f2e4bfcbff05d1);
$parcel$export(module.exports, "getAISuggestions", () => $ec8589277a6387ab$export$34bb7a15a54039a5);
$parcel$export(module.exports, "addGroupAssignee", () => $ec8589277a6387ab$export$bd5bdebdb6d9abb);
$parcel$export(module.exports, "actionOnGroup", () => $ec8589277a6387ab$export$5353a5d2604523c0);
$parcel$export(module.exports, "getAlertCountForGroupAction", () => $ec8589277a6387ab$export$b47efb0a9602f0c8);

var $d9Cgl = parcelRequire("d9Cgl");

var $1HSJh = parcelRequire("1HSJh");
const $ec8589277a6387ab$export$c0f2e4bfcbff05d1 = (groupId)=>(0, $d9Cgl.eocFetch)((0, $1HSJh.withAIOpsPrefix)(`/v1/group-insights/${groupId}`), {
        exactUrl: true
    });
const $ec8589277a6387ab$export$34bb7a15a54039a5 = (groupId)=>(0, $d9Cgl.eocFetch)((0, $1HSJh.withAIOpsPrefix)(`/v1/group-insights/getSimilar/${groupId}`), {
        exactUrl: true
    });
const $ec8589277a6387ab$export$bd5bdebdb6d9abb = (groupId, assigneeId)=>(0, $d9Cgl.eocFetch)((0, $1HSJh.withAIOpsPrefix)(`/v1/group-insights/${groupId}/add-assignee/${assigneeId}`), {
        method: 'PUT',
        exactUrl: true
    });
const $ec8589277a6387ab$export$5353a5d2604523c0 = (groupId, action, payload = {})=>{
    return (0, $d9Cgl.eocFetch)((0, $1HSJh.withAIOpsPrefix)(`/v1/alert-insights/bulk-action`), {
        method: 'PUT',
        exactUrl: true,
        body: {
            groupId: groupId,
            actionType: action,
            ...payload
        }
    });
};
const $ec8589277a6387ab$export$b47efb0a9602f0c8 = (groupId, action)=>{
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.set('actionType', action);
    urlSearchParams.set('groupId', groupId);
    return (0, $d9Cgl.eocFetch)((0, $1HSJh.withAIOpsPrefix)(`/v1/alert-insights/check-all-action?${urlSearchParams}`), {
        exactUrl: true
    });
};

});
parcelRegister("1HSJh", function(module, exports) {

$parcel$export(module.exports, "withAIOpsPrefix", () => $8fb5ee0735be133f$export$5ad74397753c99a2);
$parcel$export(module.exports, "formatTimezone", () => $8fb5ee0735be133f$export$26da7aa151b6684c);

var $k0bGk = parcelRequire("k0bGk");

var $lX5WW = parcelRequire("lX5WW");

var $he0mL = parcelRequire("he0mL");
const $8fb5ee0735be133f$export$5ad74397753c99a2 = (input)=>{
    const cloudId = (0, $he0mL.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};
function $8fb5ee0735be133f$export$9e555a50010549c1(timezone) {
    const splittedTz = timezone.split('/');
    // EST || EST5EDT
    if (splittedTz.length === 0) return splittedTz;
    // Europe/Amsterdam || Europe/Isle_of_Man || America/North_Dakota/New_Salem
    if (splittedTz.length > 0) {
        const areaName = splittedTz[splittedTz.length - 1];
        return areaName.replace(/_/g, ' ');
    }
    return timezone;
}
function $8fb5ee0735be133f$export$26da7aa151b6684c(timezone) {
    const timeZone = timezone ?? (0, $lX5WW.guessUserTimeZone)();
    return (0, $k0bGk.default)(new Date(), timeZone, `z '${$8fb5ee0735be133f$export$9e555a50010549c1(timeZone)}'`);
}

});
parcelRegister("k0bGk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8fcde810fea8cbb$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $hJ0vY = parcelRequire("hJ0vY");

var $cvpZ4 = parcelRequire("cvpZ4");
function $e8fcde810fea8cbb$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $hJ0vY.default)((0, $cvpZ4.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("hJ0vY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce7709d28f9c023c$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $jxy7u = parcelRequire("jxy7u");

var $iVuht = parcelRequire("iVuht");
var $ce7709d28f9c023c$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $ce7709d28f9c023c$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($ce7709d28f9c023c$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $iVuht.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $jxy7u.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("jxy7u", function(module, exports) {

$parcel$export(module.exports, "default", () => $e39b90db41725d79$export$2e2bcd8739ae039);

var $6vr6Z = parcelRequire("6vr6Z");

var $gdaOy = parcelRequire("gdaOy");
var $e39b90db41725d79$var$MILLISECONDS_IN_MINUTE = 60000;
var $e39b90db41725d79$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $e39b90db41725d79$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $e39b90db41725d79$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $e39b90db41725d79$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $e39b90db41725d79$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $e39b90db41725d79$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $e39b90db41725d79$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $e39b90db41725d79$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $e39b90db41725d79$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $e39b90db41725d79$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $e39b90db41725d79$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $e39b90db41725d79$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $6vr6Z.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $6vr6Z.default)('long', date, options);
        }
    }
};
function $e39b90db41725d79$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $gdaOy.default)(timeZone, originalDate, true) / $e39b90db41725d79$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $e39b90db41725d79$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $e39b90db41725d79$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $e39b90db41725d79$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $e39b90db41725d79$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $e39b90db41725d79$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $e39b90db41725d79$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $e39b90db41725d79$var$formatTimezone(offset, dirtyDelimeter);
}
function $e39b90db41725d79$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $e39b90db41725d79$var$addLeadingZeros(minutes, 2);
}
var $e39b90db41725d79$export$2e2bcd8739ae039 = $e39b90db41725d79$var$formatters;

});
parcelRegister("6vr6Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bcaab250c2d5eef$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $4bcaab250c2d5eef$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $4bcaab250c2d5eef$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $4bcaab250c2d5eef$var$partsTimeZone(dtf, date) : $4bcaab250c2d5eef$var$hackyTimeZone(dtf, date);
}
function $4bcaab250c2d5eef$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $4bcaab250c2d5eef$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $4bcaab250c2d5eef$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("gdaOy", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd63fbccee66212$export$2e2bcd8739ae039);

var $4yszs = parcelRequire("4yszs");

var $dEVom = parcelRequire("dEVom");
var $bcd63fbccee66212$var$MILLISECONDS_IN_HOUR = 3600000;
var $bcd63fbccee66212$var$MILLISECONDS_IN_MINUTE = 60000;
var $bcd63fbccee66212$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $bcd63fbccee66212$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $bcd63fbccee66212$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $bcd63fbccee66212$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$bcd63fbccee66212$var$validateTimezone(hours)) return NaN;
        return -(hours * $bcd63fbccee66212$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $bcd63fbccee66212$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$bcd63fbccee66212$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $bcd63fbccee66212$var$MILLISECONDS_IN_HOUR + minutes * $bcd63fbccee66212$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($bcd63fbccee66212$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $bcd63fbccee66212$var$toUtcDate(date);
        var offset = $bcd63fbccee66212$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $bcd63fbccee66212$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $bcd63fbccee66212$var$toUtcDate(date) {
    return (0, $dEVom.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $bcd63fbccee66212$var$calcOffset(date, timezoneString) {
    var tokens = (0, $4yszs.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $dEVom.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $bcd63fbccee66212$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $bcd63fbccee66212$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $bcd63fbccee66212$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $bcd63fbccee66212$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $bcd63fbccee66212$var$validIANATimezoneCache = {};
function $bcd63fbccee66212$var$isValidTimezoneIANAString(timeZoneString) {
    if ($bcd63fbccee66212$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $bcd63fbccee66212$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("4yszs", function(module, exports) {

$parcel$export(module.exports, "default", () => $35107ffee444cee0$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $35107ffee444cee0$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $35107ffee444cee0$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $35107ffee444cee0$var$partsOffset(dtf, date) : $35107ffee444cee0$var$hackyOffset(dtf, date);
}
var $35107ffee444cee0$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $35107ffee444cee0$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $35107ffee444cee0$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $35107ffee444cee0$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $35107ffee444cee0$var$dtfCache = {};
function $35107ffee444cee0$var$getDateTimeFormat(timeZone) {
    if (!$35107ffee444cee0$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $35107ffee444cee0$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $35107ffee444cee0$var$dtfCache[timeZone];
}

});

parcelRegister("dEVom", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f1b87a5396f80c2$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $9f1b87a5396f80c2$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("iVuht", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc750a03a43e6165$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $gdaOy = parcelRequire("gdaOy");

var $ao0wc = parcelRequire("ao0wc");
var $dc750a03a43e6165$var$MILLISECONDS_IN_HOUR = 3600000;
var $dc750a03a43e6165$var$MILLISECONDS_IN_MINUTE = 60000;
var $dc750a03a43e6165$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $dc750a03a43e6165$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $ao0wc.default)
};
function $dc750a03a43e6165$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $dc750a03a43e6165$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $dc750a03a43e6165$var$splitDateString(argument);
    var parseYearResult = $dc750a03a43e6165$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $dc750a03a43e6165$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $dc750a03a43e6165$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $gdaOy.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $dc750a03a43e6165$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $dc750a03a43e6165$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $dc750a03a43e6165$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $dc750a03a43e6165$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $dc750a03a43e6165$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $dc750a03a43e6165$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $dc750a03a43e6165$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $dc750a03a43e6165$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $dc750a03a43e6165$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $dc750a03a43e6165$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $dc750a03a43e6165$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$dc750a03a43e6165$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $dc750a03a43e6165$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$dc750a03a43e6165$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $dc750a03a43e6165$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$dc750a03a43e6165$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $dc750a03a43e6165$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$dc750a03a43e6165$var$validateWeekDate(year, week)) return new Date(NaN);
        return $dc750a03a43e6165$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $dc750a03a43e6165$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$dc750a03a43e6165$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $dc750a03a43e6165$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $dc750a03a43e6165$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $dc750a03a43e6165$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$dc750a03a43e6165$var$validateTime(hours)) return NaN;
        return hours % 24 * $dc750a03a43e6165$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $dc750a03a43e6165$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$dc750a03a43e6165$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $dc750a03a43e6165$var$MILLISECONDS_IN_HOUR + minutes * $dc750a03a43e6165$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $dc750a03a43e6165$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$dc750a03a43e6165$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $dc750a03a43e6165$var$MILLISECONDS_IN_HOUR + minutes * $dc750a03a43e6165$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $dc750a03a43e6165$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $dc750a03a43e6165$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $dc750a03a43e6165$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $dc750a03a43e6165$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $dc750a03a43e6165$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $dc750a03a43e6165$var$isLeapYearIndex(year);
        if (isLeapYear && date > $dc750a03a43e6165$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $dc750a03a43e6165$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $dc750a03a43e6165$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $dc750a03a43e6165$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $dc750a03a43e6165$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $dc750a03a43e6165$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("ao0wc", function(module, exports) {

$parcel$export(module.exports, "default", () => $78fc8c398a761cb5$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $78fc8c398a761cb5$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $78fc8c398a761cb5$export$2e2bcd8739ae039 = $78fc8c398a761cb5$var$tzPattern;

});



parcelRegister("cvpZ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $91ac8928df141e1e$export$2e2bcd8739ae039);

var $gdaOy = parcelRequire("gdaOy");

var $iVuht = parcelRequire("iVuht");
function $91ac8928df141e1e$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $iVuht.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $gdaOy.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});


parcelRegister("lX5WW", function(module, exports) {

$parcel$export(module.exports, "guessUserTimeZone", () => $69044c22922f0a6b$export$6fd096fe0456f5b);
$parcel$export(module.exports, "formatDate", () => $69044c22922f0a6b$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getDefaultTimes", () => $69044c22922f0a6b$export$951e947e785c998d);

var $jhDhS = parcelRequire("jhDhS");
function $69044c22922f0a6b$export$6fd096fe0456f5b() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function $69044c22922f0a6b$export$3ae94a2503e890a1(date, timezone = $69044c22922f0a6b$export$6fd096fe0456f5b(), format = 'PP p') {
    return (0, $jhDhS.default)(new Date(date), timezone, format);
}
const $69044c22922f0a6b$export$951e947e785c998d = ()=>{
    return [
        ...Array(24).keys()
    ].map((time)=>{
        let newTime = time.toString();
        if (newTime.length === 1) newTime = `0${time}`;
        return [
            `${newTime}:00`,
            `${newTime}:30`
        ];
    }).flatMap((time)=>time);
};

});
parcelRegister("jhDhS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e09e1480402ca701$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $bva6s = parcelRequire("bva6s");

var $eBSLA = parcelRequire("eBSLA");
function $e09e1480402ca701$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $bva6s.default)((0, $eBSLA.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("bva6s", function(module, exports) {

$parcel$export(module.exports, "default", () => $85fa6d3c99cbf335$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $8vknN = parcelRequire("8vknN");

var $3B1xr = parcelRequire("3B1xr");
var $85fa6d3c99cbf335$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $85fa6d3c99cbf335$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($85fa6d3c99cbf335$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $3B1xr.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $8vknN.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("8vknN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6311079174e85856$export$2e2bcd8739ae039);

var $1zJj6 = parcelRequire("1zJj6");

var $d3COz = parcelRequire("d3COz");
var $6311079174e85856$var$MILLISECONDS_IN_MINUTE = 60000;
var $6311079174e85856$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $6311079174e85856$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $6311079174e85856$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $6311079174e85856$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $6311079174e85856$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $6311079174e85856$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $6311079174e85856$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $6311079174e85856$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $6311079174e85856$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $6311079174e85856$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $6311079174e85856$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $6311079174e85856$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $1zJj6.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $1zJj6.default)('long', date, options);
        }
    }
};
function $6311079174e85856$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $d3COz.default)(timeZone, originalDate, true) / $6311079174e85856$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $6311079174e85856$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $6311079174e85856$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $6311079174e85856$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $6311079174e85856$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $6311079174e85856$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $6311079174e85856$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $6311079174e85856$var$formatTimezone(offset, dirtyDelimeter);
}
function $6311079174e85856$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $6311079174e85856$var$addLeadingZeros(minutes, 2);
}
var $6311079174e85856$export$2e2bcd8739ae039 = $6311079174e85856$var$formatters;

});
parcelRegister("1zJj6", function(module, exports) {

$parcel$export(module.exports, "default", () => $125c345f34c192f3$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $125c345f34c192f3$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $125c345f34c192f3$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $125c345f34c192f3$var$partsTimeZone(dtf, date) : $125c345f34c192f3$var$hackyTimeZone(dtf, date);
}
function $125c345f34c192f3$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $125c345f34c192f3$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $125c345f34c192f3$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("d3COz", function(module, exports) {

$parcel$export(module.exports, "default", () => $9819a9fa20a5ccb9$export$2e2bcd8739ae039);

var $5Cqdv = parcelRequire("5Cqdv");

var $bVYWO = parcelRequire("bVYWO");
var $9819a9fa20a5ccb9$var$MILLISECONDS_IN_HOUR = 3600000;
var $9819a9fa20a5ccb9$var$MILLISECONDS_IN_MINUTE = 60000;
var $9819a9fa20a5ccb9$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $9819a9fa20a5ccb9$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $9819a9fa20a5ccb9$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $9819a9fa20a5ccb9$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$9819a9fa20a5ccb9$var$validateTimezone(hours)) return NaN;
        return -(hours * $9819a9fa20a5ccb9$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $9819a9fa20a5ccb9$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$9819a9fa20a5ccb9$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $9819a9fa20a5ccb9$var$MILLISECONDS_IN_HOUR + minutes * $9819a9fa20a5ccb9$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($9819a9fa20a5ccb9$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $9819a9fa20a5ccb9$var$toUtcDate(date);
        var offset = $9819a9fa20a5ccb9$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $9819a9fa20a5ccb9$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $9819a9fa20a5ccb9$var$toUtcDate(date) {
    return (0, $bVYWO.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $9819a9fa20a5ccb9$var$calcOffset(date, timezoneString) {
    var tokens = (0, $5Cqdv.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $bVYWO.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $9819a9fa20a5ccb9$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $9819a9fa20a5ccb9$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $9819a9fa20a5ccb9$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $9819a9fa20a5ccb9$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $9819a9fa20a5ccb9$var$validIANATimezoneCache = {};
function $9819a9fa20a5ccb9$var$isValidTimezoneIANAString(timeZoneString) {
    if ($9819a9fa20a5ccb9$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $9819a9fa20a5ccb9$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("5Cqdv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4174d67ef05db18d$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $4174d67ef05db18d$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $4174d67ef05db18d$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $4174d67ef05db18d$var$partsOffset(dtf, date) : $4174d67ef05db18d$var$hackyOffset(dtf, date);
}
var $4174d67ef05db18d$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $4174d67ef05db18d$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $4174d67ef05db18d$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $4174d67ef05db18d$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $4174d67ef05db18d$var$dtfCache = {};
function $4174d67ef05db18d$var$getDateTimeFormat(timeZone) {
    if (!$4174d67ef05db18d$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $4174d67ef05db18d$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $4174d67ef05db18d$var$dtfCache[timeZone];
}

});

parcelRegister("bVYWO", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b044b85b7aa92cf$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $8b044b85b7aa92cf$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("3B1xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $29e60546f955beff$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $d3COz = parcelRequire("d3COz");

var $lHaE4 = parcelRequire("lHaE4");
var $29e60546f955beff$var$MILLISECONDS_IN_HOUR = 3600000;
var $29e60546f955beff$var$MILLISECONDS_IN_MINUTE = 60000;
var $29e60546f955beff$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $29e60546f955beff$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $lHaE4.default)
};
function $29e60546f955beff$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $29e60546f955beff$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $29e60546f955beff$var$splitDateString(argument);
    var parseYearResult = $29e60546f955beff$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $29e60546f955beff$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $29e60546f955beff$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $d3COz.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $29e60546f955beff$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $29e60546f955beff$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $29e60546f955beff$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $29e60546f955beff$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $29e60546f955beff$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $29e60546f955beff$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $29e60546f955beff$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $29e60546f955beff$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $29e60546f955beff$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $29e60546f955beff$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $29e60546f955beff$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$29e60546f955beff$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $29e60546f955beff$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$29e60546f955beff$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $29e60546f955beff$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$29e60546f955beff$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $29e60546f955beff$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$29e60546f955beff$var$validateWeekDate(year, week)) return new Date(NaN);
        return $29e60546f955beff$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $29e60546f955beff$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$29e60546f955beff$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $29e60546f955beff$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $29e60546f955beff$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $29e60546f955beff$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$29e60546f955beff$var$validateTime(hours)) return NaN;
        return hours % 24 * $29e60546f955beff$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $29e60546f955beff$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$29e60546f955beff$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $29e60546f955beff$var$MILLISECONDS_IN_HOUR + minutes * $29e60546f955beff$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $29e60546f955beff$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$29e60546f955beff$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $29e60546f955beff$var$MILLISECONDS_IN_HOUR + minutes * $29e60546f955beff$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $29e60546f955beff$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $29e60546f955beff$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $29e60546f955beff$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $29e60546f955beff$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $29e60546f955beff$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $29e60546f955beff$var$isLeapYearIndex(year);
        if (isLeapYear && date > $29e60546f955beff$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $29e60546f955beff$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $29e60546f955beff$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $29e60546f955beff$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $29e60546f955beff$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $29e60546f955beff$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("lHaE4", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcb5df0a24442caf$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $fcb5df0a24442caf$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $fcb5df0a24442caf$export$2e2bcd8739ae039 = $fcb5df0a24442caf$var$tzPattern;

});



parcelRegister("eBSLA", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa2f00db54059c80$export$2e2bcd8739ae039);

var $d3COz = parcelRequire("d3COz");

var $3B1xr = parcelRequire("3B1xr");
function $aa2f00db54059c80$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $3B1xr.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $d3COz.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});






parcelRegister("7eLbt", function(module, exports) {

$parcel$export(module.exports, "eocGlobalGroupDetailRoute", () => $c40ab0d9ba386fc6$export$e6569aff8dfd4c1d);
const $c40ab0d9ba386fc6$export$e6569aff8dfd4c1d = {
    name: 'eoc-global-group-detail',
    path: '/jira/ops/group-detail/:id',
    exact: true
};

});

parcelRegister("lgLgL", function(module, exports) {

$parcel$export(module.exports, "LazyGroupDetail", () => $009be0886fa71d74$export$8d4b3992eb19d436);
$parcel$export(module.exports, "default", () => $009be0886fa71d74$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $009be0886fa71d74$export$8d4b3992eb19d436 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("iVtF6")), {
    moduleId: "./src/packages/eoc/group-detail/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$009be0886fa71d74$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $009be0886fa71d74$export$8d4b3992eb19d436,
        pageId: "async-jira-eoc-group-detail",
        shouldShowSpinner: false
    });

});
parcelRegister("iVtF6", function(module, exports) {

let $dc748f213d6b95be$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dc748f213d6b95be$var$load("h2MrD"),
    $dc748f213d6b95be$var$load("bYT2S"),
    $dc748f213d6b95be$var$load("dsiAd"),
    $dc748f213d6b95be$var$load("dTpji")
]).then(()=>parcelRequire('9kpiP'));

});



parcelRegister("dYoht", function(module, exports) {

$parcel$export(module.exports, "eocTeamGroupDetailRouteEntry", () => $7742cad3c3e8631c$export$2b25520e20820251);

var $ivQlE = parcelRequire("ivQlE");

var $dvNmg = parcelRequire("dvNmg");

var $ba5IO = parcelRequire("ba5IO");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $81IxY = parcelRequire("81IxY");

var $lgLgL = parcelRequire("lgLgL");
const $7742cad3c3e8631c$export$2b25520e20820251 = (0, $7NszV.createEntry)((0, $81IxY.eocTeamGroupDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $lgLgL.default),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ba5IO.resources)(),
            ...(0, $dvNmg.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $ivQlE.resources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lgLgL.LazyGroupDetail),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("81IxY", function(module, exports) {

$parcel$export(module.exports, "eocTeamGroupDetailRoute", () => $c70e4aa8d21accf9$export$aa8cf61e94739f21);
const $c70e4aa8d21accf9$export$aa8cf61e94739f21 = {
    name: 'eoc-team-group-detail',
    path: '/jira/ops/teams/:teamId/group-detail/:id',
    exact: true
};

});


parcelRegister("75Ues", function(module, exports) {

$parcel$export(module.exports, "eocHeartbeatsRouteEntry", () => $b7a7f1ceb2ac2c2a$export$2c2d6115c4280a08);

var $dJmOs = parcelRequire("dJmOs");

var $ba5IO = parcelRequire("ba5IO");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $6tmb0 = parcelRequire("6tmb0");

var $jxkxr = parcelRequire("jxkxr");
const $b7a7f1ceb2ac2c2a$export$2c2d6115c4280a08 = (0, $7NszV.createEntry)((0, $6tmb0.eocHeartbeatsRoute), ()=>({
        group: 'eoc',
        component: (0, $jxkxr.HeartbeatsComponent),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $dJmOs.resources)(),
            ...(0, $ba5IO.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jxkxr.LazyHeartbeats),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("dJmOs", function(module, exports) {

$parcel$export(module.exports, "heartbeatsResource", () => $2eeba4f55287b6ca$export$dd38e2aa5cfda9c9);
$parcel$export(module.exports, "heartbeatsUserRightsResource", () => $2eeba4f55287b6ca$export$b5d9a0bcdfa848ce);
$parcel$export(module.exports, "resources", () => $2eeba4f55287b6ca$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $enoyV = parcelRequire("enoyV");
const $2eeba4f55287b6ca$export$dd38e2aa5cfda9c9 = (0, $2M1hQ.createResource)({
    type: 'heartbeatsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `heartbeats/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $enoyV.getHeartbeatsEndpoint)(teamId);
    },
    isBrowserOnly: true
});
const $2eeba4f55287b6ca$export$b5d9a0bcdfa848ce = (0, $2M1hQ.createResource)({
    type: 'heartbeatsUserRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `heartbeats-user-rights/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $enoyV.getHeartbeatsUserRights)(teamId);
    },
    isBrowserOnly: true
});
const $2eeba4f55287b6ca$export$bc99aaabaf7b70a7 = ()=>[
        $2eeba4f55287b6ca$export$dd38e2aa5cfda9c9,
        $2eeba4f55287b6ca$export$b5d9a0bcdfa848ce
    ];

});
parcelRegister("enoyV", function(module, exports) {

$parcel$export(module.exports, "getHeartbeatsEndpoint", () => $c64eca0026a4ab05$export$c322dad372dcb08b);
$parcel$export(module.exports, "validateHeartbeatNameEndpoint", () => $c64eca0026a4ab05$export$676f6aee59f124b0);
$parcel$export(module.exports, "createHeartbeatEndpoint", () => $c64eca0026a4ab05$export$891ea85cc6973b32);
$parcel$export(module.exports, "updateHeartbeatEndpoint", () => $c64eca0026a4ab05$export$7311481b59e02e06);
$parcel$export(module.exports, "switchHeartbeatEndpoint", () => $c64eca0026a4ab05$export$5df993f1c74d7e8e);
$parcel$export(module.exports, "deleteHeartbeatEndpoint", () => $c64eca0026a4ab05$export$716e365975fc2cd1);
$parcel$export(module.exports, "getHeartbeatsUserRights", () => $c64eca0026a4ab05$export$26eaca11f3b4e506);
$parcel$export(module.exports, "updateAutoCreationEndpoint", () => $c64eca0026a4ab05$export$38097aade6a3b234);

var $d9Cgl = parcelRequire("d9Cgl");

var $IULRM = parcelRequire("IULRM");
const $c64eca0026a4ab05$export$c322dad372dcb08b = (teamId)=>(0, $d9Cgl.eocFetch)((0, $IULRM.generateBaseUrl)(teamId), {
        method: 'GET'
    });
const $c64eca0026a4ab05$export$676f6aee59f124b0 = (heartbeatName, teamId)=>(0, $d9Cgl.eocFetch)(`${(0, $IULRM.generateBaseUrl)(teamId)}/validateEmail?heartbeatName=${encodeURIComponent(heartbeatName)}`, {
        method: 'GET',
        responseType: 'headers'
    });
const $c64eca0026a4ab05$export$891ea85cc6973b32 = (heartbeat, teamId)=>(0, $d9Cgl.eocFetch)((0, $IULRM.generateBaseUrl)(teamId), {
        method: 'POST',
        body: heartbeat
    });
const $c64eca0026a4ab05$export$7311481b59e02e06 = (heartbeat, teamId)=>(0, $d9Cgl.eocFetch)((0, $IULRM.generateBaseUrl)(teamId), {
        method: 'PUT',
        body: heartbeat
    });
const $c64eca0026a4ab05$export$5df993f1c74d7e8e = (enable, name, teamId)=>(0, $d9Cgl.eocFetch)(`${(0, $IULRM.generateBaseUrl)(teamId)}/enable?enabled=${enable}&name=${encodeURIComponent(name)}`, {
        method: 'PATCH'
    });
const $c64eca0026a4ab05$export$716e365975fc2cd1 = (name, teamId)=>(0, $d9Cgl.eocFetch)(`${(0, $IULRM.generateBaseUrl)(teamId)}?name=${encodeURIComponent(name)}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
const $c64eca0026a4ab05$export$26eaca11f3b4e506 = (teamId)=>{
    return (0, $d9Cgl.eocFetch)(`${(0, $IULRM.generateBaseUrl)(teamId)}/rights`);
};
const $c64eca0026a4ab05$export$38097aade6a3b234 = (teamId, autoCreateEnabled)=>(0, $d9Cgl.eocFetch)(`${(0, $IULRM.generateBaseUrl)(teamId)}/updateHeartbeatAutoCreation?autoCreateEnabled=${autoCreateEnabled}`, {
        method: 'POST',
        responseType: 'headers'
    });

});
parcelRegister("IULRM", function(module, exports) {

$parcel$export(module.exports, "getMaxAvailableEpoch", () => $37b67addeccb786c$export$1eaa8fc6df8a5dac);
$parcel$export(module.exports, "generateBaseUrl", () => $37b67addeccb786c$export$25e86c63685d7e40);

var $cKyl9 = parcelRequire("cKyl9");
const $37b67addeccb786c$export$1eaa8fc6df8a5dac = ()=>{
    const today = new Date();
    const futureDate = new Date();
    futureDate.setFullYear(today.getFullYear() * (0, $cKyl9.MAX_INTERVAL_TIME_YEARS));
    const epochTime = futureDate.getTime();
    return epochTime;
};
const $37b67addeccb786c$export$25e86c63685d7e40 = (teamId)=>{
    return teamId ? `/v1/teams/${teamId}/heartbeats` : '/v1/heartbeats';
};

});
parcelRegister("cKyl9", function(module, exports) {

$parcel$export(module.exports, "MAX_INTERVAL_TIME_YEARS", () => $7cd6ecb5acf9846e$export$c3f9ae43b3ab397c);
$parcel$export(module.exports, "MIN_DATE_SHOWN_EPOCH", () => $7cd6ecb5acf9846e$export$f081f690fcb957ce);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $7cd6ecb5acf9846e$export$a7c923252528b255);
const $7cd6ecb5acf9846e$export$c3f9ae43b3ab397c = 5;
const $7cd6ecb5acf9846e$export$f081f690fcb957ce = 946677600;
const $7cd6ecb5acf9846e$export$a7c923252528b255 = {
    actions: 'eoc-heartbeats_actions'
};

});




parcelRegister("6tmb0", function(module, exports) {

$parcel$export(module.exports, "eocHeartbeatsRoute", () => $99f0aed6abda0a94$export$71bd833dcb7bd1e9);
const $99f0aed6abda0a94$export$71bd833dcb7bd1e9 = {
    name: 'eoc-heartbeats',
    path: '/jira/ops/teams/:teamId/heartbeats',
    exact: true
};

});

parcelRegister("jxkxr", function(module, exports) {

$parcel$export(module.exports, "LazyHeartbeats", () => $e4872049cbc66669$export$93c9586b023b5aa3);
$parcel$export(module.exports, "HeartbeatsComponent", () => $e4872049cbc66669$export$43c2d87bd51ba6ac);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $e4872049cbc66669$export$93c9586b023b5aa3 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("3Epou")), {
    moduleId: "./src/packages/eoc/heartbeats/src/index.tsx"
});
const $e4872049cbc66669$export$43c2d87bd51ba6ac = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e4872049cbc66669$export$93c9586b023b5aa3,
        pageId: "async-jira-eoc-heartbeats",
        shouldShowSpinner: false
    });

});
parcelRegister("3Epou", function(module, exports) {

let $2a88ce37f489e97f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2a88ce37f489e97f$var$load("h2MrD"),
    $2a88ce37f489e97f$var$load("bYT2S"),
    $2a88ce37f489e97f$var$load("5jEdq")
]).then(()=>parcelRequire('4uAlQ'));

});



parcelRegister("4Yh3B", function(module, exports) {

$parcel$export(module.exports, "eocGlobalHeartbeatsRouteEntry", () => $17d1dcee95d05254$export$2d7875aa465a7757);

var $dJmOs = parcelRequire("dJmOs");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $70VNh = parcelRequire("70VNh");

var $eZXFU = parcelRequire("eZXFU");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $jxkxr = parcelRequire("jxkxr");
const $17d1dcee95d05254$var$getNavigationSpecifications = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $17d1dcee95d05254$export$2d7875aa465a7757 = (0, $7NszV.createEntry)((0, $70VNh.eocGlobalHeartbeatsRoute), ()=>({
        group: 'eoc',
        component: (0, $jxkxr.HeartbeatsComponent),
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $dJmOs.resources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$17d1dcee95d05254$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jxkxr.LazyHeartbeats)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jxkxr.LazyHeartbeats)
        ]
    }));

});
parcelRegister("70VNh", function(module, exports) {

$parcel$export(module.exports, "eocGlobalHeartbeatsRoute", () => $efe21b9fcd2adca8$export$48568054c59facbb);
const $efe21b9fcd2adca8$export$48568054c59facbb = {
    name: 'eoc-global-heartbeats',
    path: '/jira/settings/products/ops/heartbeats',
    exact: true
};

});


parcelRegister("4iFpq", function(module, exports) {

$parcel$export(module.exports, "globalIncomingCallDetailRouteEntry", () => $91ad9944e0af1355$export$39f40714591c98c0);

var $5uXOq = parcelRequire("5uXOq");

var $kMAZ6 = parcelRequire("kMAZ6");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $1oUsV = parcelRequire("1oUsV");

var $5j7Th = parcelRequire("5j7Th");

var $hHoID = parcelRequire("hHoID");
const $91ad9944e0af1355$var$IncomingCallDetail = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $hHoID.LazyIncomingCallDetail),
        pageId: "async-jira-eoc-incoming-call-detail",
        shouldShowSpinner: false
    });
const $91ad9944e0af1355$export$39f40714591c98c0 = (0, $7NszV.createEntry)((0, $1oUsV.globalIncomingCallDetailRoute), ()=>({
        group: 'eoc',
        component: $91ad9944e0af1355$var$IncomingCallDetail,
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $kMAZ6.detailResources)()
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hHoID.LazyIncomingCall)
        ]
    }));

});
parcelRegister("kMAZ6", function(module, exports) {

$parcel$export(module.exports, "listResources", () => $73aa198e9a5d7594$export$c83d9fd41123ab31);
$parcel$export(module.exports, "detailResources", () => $73aa198e9a5d7594$export$63630293105c0f4e);

var $7SYk0 = parcelRequire("7SYk0");

var $8imtr = parcelRequire("8imtr");
const $73aa198e9a5d7594$export$c83d9fd41123ab31 = ()=>[
        (0, $8imtr.listResource)
    ];
const $73aa198e9a5d7594$export$63630293105c0f4e = ()=>[
        (0, $7SYk0.detailResource)
    ];

});
parcelRegister("7SYk0", function(module, exports) {

$parcel$export(module.exports, "detailResource", () => $b8499b544c918434$export$13d78d45f8054f1e);

var $2M1hQ = parcelRequire("2M1hQ");

var $gtuj9 = parcelRequire("gtuj9");
var $9dX4l = parcelRequire("9dX4l");

var $i96lr = parcelRequire("i96lr");
const $b8499b544c918434$export$13d78d45f8054f1e = (0, $2M1hQ.createResource)({
    type: 'getDetailResource',
    getKey: ()=>'getDetailResource',
    getData: async (routerContext)=>{
        const id = routerContext.match.params?.id;
        (0, $gtuj9.assert)(!!id, new (0, $9dX4l.AssertionError)('detailResource', 'id should be set to fetch incoming call detail'));
        return (0, $i96lr.getDetail)(id);
    },
    isBrowserOnly: true
});

});
parcelRegister("i96lr", function(module, exports) {

$parcel$export(module.exports, "getDetail", () => $8f3200145f91bb54$export$d6c3faeb2ce9d297);

var $d9Cgl = parcelRequire("d9Cgl");

var $jW60d = parcelRequire("jW60d");
const $8f3200145f91bb54$export$d6c3faeb2ce9d297 = (id)=>{
    const endpoint = `${(0, $jW60d.urls).incomingCall.detail.url(id)}`;
    return (0, $d9Cgl.eocFetch)(endpoint);
};

});
parcelRegister("jW60d", function(module, exports) {

$parcel$export(module.exports, "urls", () => $09435413cdfd9533$export$bcae9ba627f604b6);
const $09435413cdfd9533$export$bcae9ba627f604b6 = Object.freeze({
    incomingCall: {
        url: ()=>`/v1/incoming-call`,
        detail: {
            url: (incomingCallId = ':incomingCallId')=>`${$09435413cdfd9533$export$bcae9ba627f604b6.incomingCall.url()}/${incomingCallId}`
        }
    }
});

});



parcelRegister("8imtr", function(module, exports) {

$parcel$export(module.exports, "listResource", () => $61a8cd00d382c638$export$5ee018e9baf9d633);

var $fqZeH = parcelRequire("fqZeH");

var $4h0SN = parcelRequire("4h0SN");
const $61a8cd00d382c638$export$5ee018e9baf9d633 = (0, $fqZeH.createPaginatedResource)({
    type: 'getListResource',
    getKey: ()=>'getListResource',
    getData: ()=>(0, $4h0SN.getList),
    isBrowserOnly: true
});

});
parcelRegister("fqZeH", function(module, exports) {

$parcel$export(module.exports, "createPaginatedResource", () => $175be248ed343875$export$561b032e4d26d1e8);

var $2M1hQ = parcelRequire("2M1hQ");
const $175be248ed343875$export$561b032e4d26d1e8 = ({ getData: getData, getKey: getKey, ...arg })=>{
    return (0, $2M1hQ.createResource)({
        ...arg,
        getKey: (routerContext, customContext)=>{
            const { query: query } = routerContext;
            const page = query['page'] || '1';
            const key = `${getKey(routerContext, customContext)}#${page}`;
            return key;
        },
        getData: (routerContext, customContext)=>{
            const { query: query } = routerContext;
            const page = parseInt(query['page']) || 1;
            return getData(routerContext, customContext)({
                page: page
            });
        }
    });
};

});

parcelRegister("4h0SN", function(module, exports) {

$parcel$export(module.exports, "getList", () => $6aa71ba0f1fe4a77$export$73fffd6dda5144e);
$parcel$export(module.exports, "addIncomingCall", () => $6aa71ba0f1fe4a77$export$cdae09ff00c893b2);

var $d9Cgl = parcelRequire("d9Cgl");

var $jW60d = parcelRequire("jW60d");
const $6aa71ba0f1fe4a77$export$73fffd6dda5144e = ({ page: page })=>{
    const limit = 20;
    const offset = (page - 1) * limit;
    const params = new URLSearchParams({
        offset: `${offset}`,
        limit: `${limit}`,
        sortBy: 'name',
        sort: 'asc'
    });
    const endpoint = `${(0, $jW60d.urls).incomingCall.url()}?${params.toString()}`;
    return (0, $d9Cgl.eocFetch)(endpoint).then(({ data: data, count: count })=>{
        return {
            data: data,
            count: Math.ceil(count / limit)
        };
    });
};
const $6aa71ba0f1fe4a77$export$cdae09ff00c893b2 = (params)=>{
    return (0, $d9Cgl.eocFetch)((0, $jW60d.urls).incomingCall.url(), {
        method: 'POST',
        body: params
    });
};

});



parcelRegister("1oUsV", function(module, exports) {

$parcel$export(module.exports, "globalIncomingCallDetailRoute", () => $f3c8c21142f35b35$export$10f19333da6ac52c);
const $f3c8c21142f35b35$export$10f19333da6ac52c = {
    name: 'eoc-incoming-call-detail',
    path: '/jira/settings/products/ops/incoming-call/:id',
    exact: true
};

});

parcelRegister("hHoID", function(module, exports) {

$parcel$export(module.exports, "LazyIncomingCall", () => $304419cc9d82ded9$export$d76e6607b7e88a7b);
$parcel$export(module.exports, "LazyIncomingCallDetail", () => $304419cc9d82ded9$export$1c56f2b1fdd5d724);

var $b7Svb = parcelRequire("b7Svb");

const $304419cc9d82ded9$export$d76e6607b7e88a7b = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("XZJoS")).then((module)=>module.IncomingCallPage), {
    moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
});

const $304419cc9d82ded9$export$1c56f2b1fdd5d724 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("XZJoS")).then((module)=>module.IncomingCallDetailPage), {
    moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
});

});
parcelRegister("XZJoS", function(module, exports) {

let $0b4565588d0ba4f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0b4565588d0ba4f7$var$load("h2MrD"),
    $0b4565588d0ba4f7$var$load("bYT2S"),
    $0b4565588d0ba4f7$var$load("dXV8c")
]).then(()=>parcelRequire('8oycJ'));

});



parcelRegister("kvJxs", function(module, exports) {

$parcel$export(module.exports, "globalIncomingCallRouteEntry", () => $06d17d7f82b9f72c$export$bf8ccc758901febd);

var $5uXOq = parcelRequire("5uXOq");

var $kMAZ6 = parcelRequire("kMAZ6");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $eZXFU = parcelRequire("eZXFU");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $jWsFA = parcelRequire("jWsFA");

var $5j7Th = parcelRequire("5j7Th");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $hHoID = parcelRequire("hHoID");
const $06d17d7f82b9f72c$var$IncomingCall = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $hHoID.LazyIncomingCall),
        pageId: "async-jira-eoc-incoming-call",
        shouldShowSpinner: false
    });
const $06d17d7f82b9f72c$var$getNavigationSpecifications = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $06d17d7f82b9f72c$export$bf8ccc758901febd = (0, $7NszV.createEntry)((0, $jWsFA.globalIncomingCallRoute), ()=>({
        group: 'eoc',
        component: $06d17d7f82b9f72c$var$IncomingCall,
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $kMAZ6.listResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$06d17d7f82b9f72c$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hHoID.LazyIncomingCall)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hHoID.LazyIncomingCall)
        ]
    }));

});
parcelRegister("jWsFA", function(module, exports) {

$parcel$export(module.exports, "globalIncomingCallRoute", () => $6e436edec71d75e1$export$8dd2e8adca05d8a3);
const $6e436edec71d75e1$export$8dd2e8adca05d8a3 = {
    name: 'eoc-incoming-call',
    path: '/jira/settings/products/ops/incoming-call',
    exact: true
};

});


parcelRegister("kxvlX", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationCreateRouteEntry", () => $675ac2c2cf4991e7$export$62eef9a2917f041f);

var $911Mi = parcelRequire("911Mi");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $iojZc = parcelRequire("iojZc");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $jNNfq = parcelRequire("jNNfq");

var $2PI2S = parcelRequire("2PI2S");

var $kEMby = parcelRequire("kEMby");
const $675ac2c2cf4991e7$var$getNavigationSpecifications = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $675ac2c2cf4991e7$export$62eef9a2917f041f = (0, $7NszV.createEntry)((0, $iojZc.globalIntegrationCreateRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $jNNfq.IntegrationAutomation),
        slot: (0, $2PI2S.IntegrationCreate),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $911Mi.resources).configuredIntegrationsResource,
            (0, $911Mi.resources).integrationListResource,
            (0, $911Mi.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$675ac2c2cf4991e7$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("911Mi", function(module, exports) {

$parcel$export(module.exports, "resources", () => $e8e1cea537ef538e$export$bc99aaabaf7b70a7);

var $5L0jV = parcelRequire("5L0jV");

var $2uaz9 = parcelRequire("2uaz9");

var $cRvow = parcelRequire("cRvow");
const $e8e1cea537ef538e$export$bc99aaabaf7b70a7 = {
    configuredIntegrationsResource: $5L0jV.configuredIntegrationsResource,
    integrationListResource: $2uaz9.integrationListResource,
    userAccessRightsResource: $cRvow.userAccessRightsResource
};

});
parcelRegister("5L0jV", function(module, exports) {

$parcel$export(module.exports, "configuredIntegrationsResource", () => $6b2e1a7b76cf1eb1$export$4136019b80be5917);

var $2M1hQ = parcelRequire("2M1hQ");

var $adnsm = parcelRequire("adnsm");

var $90v5C = parcelRequire("90v5C");

const $6b2e1a7b76cf1eb1$export$4136019b80be5917 = (0, $2M1hQ.createResource)({
    type: 'configuredIntegrationsResource',
    getKey: ({ query: query, match: match })=>{
        const teamId = match.params.teamId ?? query['teamId'];
        const group = query['group'];
        const keyword = query['keyword'];
        const status = query['status'];
        const page = query['page'] || '1';
        return (0, $adnsm.UrlHelper)((0, $78e1173a1b2abca3$export$bc7daa294a7c75e4), {
            [(0, $78e1173a1b2abca3$export$d26137cf824a9e53)]: page,
            [(0, $78e1173a1b2abca3$export$299579ccbdd63cbc)]: keyword,
            [(0, $78e1173a1b2abca3$export$d7415cfdee4bffc8)]: group,
            [(0, $78e1173a1b2abca3$export$ce2c93e90dda8613)]: status,
            [(0, $78e1173a1b2abca3$export$4e0ddb4dc97eb573)]: teamId
        });
    },
    getData: (routerContext)=>(0, $90v5C.default).getIntegrations(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("adnsm", function(module, exports) {

$parcel$export(module.exports, "UrlHelper", () => $1d9542e9a4e31f3c$export$bacbc496e850c0a4);
const $1d9542e9a4e31f3c$export$bacbc496e850c0a4 = (path, params = {})=>{
    // https://github.com/microsoft/TypeScript/issues/16655
    const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
            k,
            v.toString()
        ] : undefined).filter((v)=>!!v);
    // Using %2C in URLs causes bugs in AngularJS, so we need to replace it with comma
    const qs = new URLSearchParams(q).toString().replace(/%2C/g, ',');
    return `${path}${qs ? `?${qs}` : ''}`;
};

});

parcelRegister("90v5C", function(module, exports) {

$parcel$export(module.exports, "default", () => $647f9b43ff395882$export$2e2bcd8739ae039);

var $d9Cgl = parcelRequire("d9Cgl");

var $adnsm = parcelRequire("adnsm");

const $647f9b43ff395882$var$getIntegrations = async (query, pathParamTeamId)=>{
    const page = parseInt(query['page']) || 1;
    const offset = (page - 1) * (0, $1696446105a58292$export$31ecae7225aecec6);
    const queryParams = query ? {
        teamId: pathParamTeamId ?? query.teamId,
        group: query.group,
        keyword: query.keyword,
        status: query.status
    } : {};
    return (0, $d9Cgl.eocFetch)((0, $adnsm.UrlHelper)('/v3/integrations/unified', {
        ...queryParams,
        offset: offset.toString(),
        limit: (0, $1696446105a58292$export$31ecae7225aecec6)
    })).then((response)=>({
            data: response.data.integrations,
            pageCount: Math.ceil(response.data.count / (0, $1696446105a58292$export$31ecae7225aecec6)),
            itemCount: response.data.count,
            platformTeamId: response.data.platformTeamId
        }));
};
const $647f9b43ff395882$var$patchIntegration = async (integrationId, integrationType, body, teamId)=>(0, $d9Cgl.eocFetch)((0, $adnsm.UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
        type: integrationType,
        teamId: teamId
    }), {
        method: 'PATCH',
        body: body
    }).then((response)=>response.data);
const $647f9b43ff395882$var$deleteIntegration = async (integrationId, integrationType, teamId)=>(0, $d9Cgl.eocFetch)((0, $adnsm.UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
        type: integrationType,
        teamId: teamId
    }), {
        method: 'DELETE',
        responseType: 'headers'
    });
var $647f9b43ff395882$export$2e2bcd8739ae039 = {
    getIntegrations: $647f9b43ff395882$var$getIntegrations,
    patchIntegration: $647f9b43ff395882$var$patchIntegration,
    deleteIntegration: $647f9b43ff395882$var$deleteIntegration
};

});
const $1696446105a58292$export$31ecae7225aecec6 = 20;


const $78e1173a1b2abca3$export$bc7daa294a7c75e4 = 'configuredIntegrationsResource';
const $78e1173a1b2abca3$export$d26137cf824a9e53 = 'page';
const $78e1173a1b2abca3$export$299579ccbdd63cbc = 'keyword';
const $78e1173a1b2abca3$export$d7415cfdee4bffc8 = 'group';
const $78e1173a1b2abca3$export$ce2c93e90dda8613 = 'status';
const $78e1173a1b2abca3$export$4e0ddb4dc97eb573 = 'teamId';


parcelRegister("2uaz9", function(module, exports) {

$parcel$export(module.exports, "integrationListResource", () => $0501f2c3c7f445f0$export$f60a40a11a6e0ee4);

var $2M1hQ = parcelRequire("2M1hQ");

var $kJIOK = parcelRequire("kJIOK");
const $0501f2c3c7f445f0$export$f60a40a11a6e0ee4 = (0, $2M1hQ.createResource)({
    type: 'integrationListResource',
    getKey: ({ query: query })=>{
        const group = query['group'];
        const keyword = query['keyword'];
        return `integrationListResource?group=${group}&keyword=${keyword}`;
    },
    getData: async (routerContext)=>await (0, $kJIOK.default).getIntegrationList(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("kJIOK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc9d174ffe89894$export$2e2bcd8739ae039);

var $d9Cgl = parcelRequire("d9Cgl");

var $adnsm = parcelRequire("adnsm");
const $ddc9d174ffe89894$var$getIntegrationList = (query, teamId)=>{
    const { keyword: keyword, group: group } = query ?? {};
    return (0, $d9Cgl.eocFetch)((0, $adnsm.UrlHelper)(`/v3/integrations/unified/supported-integrations`, {
        keyword: keyword,
        group: group,
        teamId: teamId
    })).then((response)=>{
        const { labels: labels, availableGroups: availableGroups, allTypes: allTypes, platformTeamId: platformTeamId } = response.data;
        return {
            labels: labels,
            availableGroups: availableGroups,
            allTypes: allTypes,
            platformTeamId: platformTeamId
        };
    });
};
const $ddc9d174ffe89894$var$getIntegrationTypes = (integrationType, teamId)=>(0, $d9Cgl.eocFetch)((0, $adnsm.UrlHelper)(`/v3/integrations/unified/${integrationType}/types`, {
        teamId: teamId
    })).then((response)=>response.data.map((integrationType)=>({
                ...integrationType,
                value: integrationType.type,
                label: integrationType.displayName
            })));
var $ddc9d174ffe89894$export$2e2bcd8739ae039 = {
    getIntegrationList: $ddc9d174ffe89894$var$getIntegrationList,
    getIntegrationTypes: $ddc9d174ffe89894$var$getIntegrationTypes
};

});


parcelRegister("cRvow", function(module, exports) {

$parcel$export(module.exports, "userAccessRightsResource", () => $14bdee09edec23cc$export$69ddc7cc64ae9a02);

var $2M1hQ = parcelRequire("2M1hQ");

var $bJHsH = parcelRequire("bJHsH");
const $14bdee09edec23cc$export$69ddc7cc64ae9a02 = (0, $2M1hQ.createResource)({
    type: 'userAccessRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params.teamId;
        return `userAccessRightsResource#${!!teamId ? teamId : ''}`;
    },
    getData: (routerContext)=>(0, $bJHsH.getUserRights)(routerContext.match.params.teamId),
    maxAge: 3600000,
    isBrowserOnly: true
});

});
parcelRegister("bJHsH", function(module, exports) {

$parcel$export(module.exports, "getUserRights", () => $e0adb600baced003$export$84e2ed279bc4e64e);

var $d9Cgl = parcelRequire("d9Cgl");

var $adnsm = parcelRequire("adnsm");
const $e0adb600baced003$export$84e2ed279bc4e64e = (teamId)=>{
    return (0, $d9Cgl.eocFetch)((0, $adnsm.UrlHelper)(`/v3/integrations/unified/rights`, {
        teamId: teamId
    })).then((response)=>response.data);
};

});



parcelRegister("iojZc", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationCreateRoute", () => $9976afa23f08aee0$export$bb272d36e3c3b7c1);
const $9976afa23f08aee0$export$bb272d36e3c3b7c1 = {
    name: 'eoc-integration-create',
    path: '/jira/settings/products/ops/integrations/create/:type',
    exact: true
};

});

parcelRegister("jNNfq", function(module, exports) {

$parcel$export(module.exports, "IntegrationAutomation", () => $3543a714bb5eb15f$export$434c3e2269913ac0);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kEMby = parcelRequire("kEMby");
const $3543a714bb5eb15f$export$434c3e2269913ac0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $kEMby.LazyIntegrationAutomation),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});
parcelRegister("kEMby", function(module, exports) {

$parcel$export(module.exports, "LazyIntegrationAutomation", () => $bd50af419902000e$export$68c40afda0287b61);
$parcel$export(module.exports, "LazyIntegrationDetail", () => $bd50af419902000e$export$fd7f60e3df94c902);
$parcel$export(module.exports, "LazyIntegrationCreate", () => $bd50af419902000e$export$aa9358ade7cb53ee);
$parcel$export(module.exports, "LazyIntegrationList", () => $bd50af419902000e$export$993132b847f26efa);
$parcel$export(module.exports, "LazyIntegrationLog", () => $bd50af419902000e$export$b02ef932401d95fc);

var $b7Svb = parcelRequire("b7Svb");

const $bd50af419902000e$export$68c40afda0287b61 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("jmFws")).then((module)=>module.IntegrationAutomation), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $bd50af419902000e$export$fd7f60e3df94c902 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("jmFws")).then((module)=>module.IntegrationDetail), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $bd50af419902000e$export$aa9358ade7cb53ee = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("jmFws")).then((module)=>module.IntegrationCreate), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $bd50af419902000e$export$993132b847f26efa = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("jmFws")).then((module)=>module.IntegrationList), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $bd50af419902000e$export$b02ef932401d95fc = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("jmFws")).then((module)=>module.IntegrationLog), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

});
parcelRegister("jmFws", function(module, exports) {

let $e19047e41a7b1b23$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e19047e41a7b1b23$var$load("h2MrD"),
    $e19047e41a7b1b23$var$load("bYT2S"),
    $e19047e41a7b1b23$var$load("4EsQl")
]).then(()=>parcelRequire('5QWfc'));

});



parcelRegister("2PI2S", function(module, exports) {

$parcel$export(module.exports, "IntegrationCreate", () => $1b0aeecb6549cd04$export$5cb14595364f02c);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kEMby = parcelRequire("kEMby");
const $1b0aeecb6549cd04$export$5cb14595364f02c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $kEMby.LazyIntegrationCreate),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("0e4yJ", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationDetailRouteEntry", () => $127c0a8b66d1f657$export$b66abbccbf93e9ad);

var $911Mi = parcelRequire("911Mi");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $80hVz = parcelRequire("80hVz");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $jNNfq = parcelRequire("jNNfq");

var $7ifqF = parcelRequire("7ifqF");

var $kEMby = parcelRequire("kEMby");
const $127c0a8b66d1f657$var$getNavigationSpecifications = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $127c0a8b66d1f657$export$b66abbccbf93e9ad = (0, $7NszV.createEntry)((0, $80hVz.globalIntegrationDetailRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $jNNfq.IntegrationAutomation),
        slot: (0, $7ifqF.IntegrationDetail),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $911Mi.resources).configuredIntegrationsResource,
            (0, $911Mi.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$127c0a8b66d1f657$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("80hVz", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationDetailRoute", () => $5333a62eb0093759$export$f826f15073eda98);
const $5333a62eb0093759$export$f826f15073eda98 = {
    name: 'eoc-integration-detail',
    path: '/jira/settings/products/ops/integrations/:type/:integrationId',
    exact: true
};

});

parcelRegister("7ifqF", function(module, exports) {

$parcel$export(module.exports, "IntegrationDetail", () => $73ab5160c11e08af$export$8bb99f196e0be5b6);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kEMby = parcelRequire("kEMby");
const $73ab5160c11e08af$export$8bb99f196e0be5b6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $kEMby.LazyIntegrationDetail),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("4mhUQ", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationListRouteEntry", () => $ed52be46c53ae197$export$790602da39f8af00);

var $911Mi = parcelRequire("911Mi");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $hNbjv = parcelRequire("hNbjv");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $jNNfq = parcelRequire("jNNfq");

var $3cv8c = parcelRequire("3cv8c");

var $kEMby = parcelRequire("kEMby");
const $ed52be46c53ae197$var$getNavigationSpecifications = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $ed52be46c53ae197$export$790602da39f8af00 = (0, $7NszV.createEntry)((0, $hNbjv.globalIntegrationListRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $jNNfq.IntegrationAutomation),
        slot: (0, $3cv8c.IntegrationList),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $911Mi.resources).integrationListResource,
            (0, $911Mi.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$ed52be46c53ae197$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("hNbjv", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationListRoute", () => $acf744aa66a83413$export$270e16f240db883b);
const $acf744aa66a83413$export$270e16f240db883b = {
    name: 'eoc-integration-list',
    path: '/jira/settings/products/ops/integrations/list',
    exact: true
};

});

parcelRegister("3cv8c", function(module, exports) {

$parcel$export(module.exports, "IntegrationList", () => $e524b7820b9b172f$export$955768269b79c203);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kEMby = parcelRequire("kEMby");
const $e524b7820b9b172f$export$955768269b79c203 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $kEMby.LazyIntegrationList),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("lcAQi", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationLogRouteEntry", () => $6535404a8c018f23$export$d30f51d0f351bd8a);

var $4qQmy = parcelRequire("4qQmy");

var $911Mi = parcelRequire("911Mi");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $7GYMz = parcelRequire("7GYMz");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $jNNfq = parcelRequire("jNNfq");

var $5pZel = parcelRequire("5pZel");

var $kEMby = parcelRequire("kEMby");
const $6535404a8c018f23$var$getNavigationSpecifications = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $6535404a8c018f23$export$d30f51d0f351bd8a = (0, $7NszV.createEntry)((0, $7GYMz.globalIntegrationLogRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $jNNfq.IntegrationAutomation),
        slot: (0, $5pZel.IntegrationLog),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $4qQmy.resources)(),
            (0, $911Mi.resources).configuredIntegrationsResource,
            (0, $911Mi.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$6535404a8c018f23$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("4qQmy", function(module, exports) {

$parcel$export(module.exports, "resources", () => $0bf86556fe4b274a$export$bc99aaabaf7b70a7);
$parcel$export(module.exports, "downloadResources", () => $0bf86556fe4b274a$export$8571305c82629fe4);

var $6luO8 = parcelRequire("6luO8");

var $hW50Q = parcelRequire("hW50Q");

var $4KbZa = parcelRequire("4KbZa");

var $8l0h0 = parcelRequire("8l0h0");
const $0bf86556fe4b274a$export$bc99aaabaf7b70a7 = ()=>[
        (0, $8l0h0.uiSettingsResource),
        (0, $4KbZa.logsResource),
        ...(0, $6luO8.eocCommonResources)()
    ];
const $0bf86556fe4b274a$export$8571305c82629fe4 = ()=>[
        (0, $hW50Q.downloadAuditLogsResource),
        ...(0, $6luO8.eocCommonResources)()
    ];

});
parcelRegister("hW50Q", function(module, exports) {

$parcel$export(module.exports, "downloadAuditLogsResource", () => $c96bbc15272cdc86$export$304da75014b88b78);

var $2M1hQ = parcelRequire("2M1hQ");

var $gtuj9 = parcelRequire("gtuj9");
var $9dX4l = parcelRequire("9dX4l");

var $7OMuD = parcelRequire("7OMuD");
const $c96bbc15272cdc86$export$304da75014b88b78 = (0, $2M1hQ.createResource)({
    type: 'download-audit-logs-resource',
    getKey: ()=>'download-audit-logs-resource',
    getData: async (routerContext)=>{
        const uniqueKey = routerContext.match.params.exportUniqueKey;
        (0, $gtuj9.assert)(!!uniqueKey, new (0, $9dX4l.AssertionError)('downloadAuditLogs resource', 'uniqueKey must be defined'));
        return (0, $7OMuD.fetchDownloadLinkEndpoint)(uniqueKey);
    },
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("7OMuD", function(module, exports) {

$parcel$export(module.exports, "fetchDownloadLinkEndpoint", () => $3b6b791b0a8aa37a$export$c8df7e5942ba1d96);

var $d9Cgl = parcelRequire("d9Cgl");
const $3b6b791b0a8aa37a$export$c8df7e5942ba1d96 = async (exportUniqueKey)=>{
    return (0, $d9Cgl.eocFetch)(`/v1/logs/export/${exportUniqueKey}/download`, {
        responseType: 'text'
    });
};

});


parcelRegister("4KbZa", function(module, exports) {

$parcel$export(module.exports, "logsResource", () => $d206e45054a4cdd3$export$fd88b4310d3f52ff);

var $2M1hQ = parcelRequire("2M1hQ");

var $iyXZB = parcelRequire("iyXZB");
const $d206e45054a4cdd3$export$fd88b4310d3f52ff = (0, $2M1hQ.createResource)({
    type: 'ui-get-logs',
    getKey: (routerContext)=>{
        const integrationId = routerContext.match.params.integrationId;
        const urlParam = new URLSearchParams();
        Object.entries(routerContext.query).forEach(([key, value])=>{
            if (value) urlParam.set(key, value);
        });
        return !!integrationId ? `integration-${integrationId}-logs#${urlParam.toString()}` : `ui-get-logs#${urlParam.toString()}`;
    },
    getData: async (routerContext)=>{
        return (0, $iyXZB.fetchLogs)({
            fromUnit: routerContext.query?.fromUnit,
            fromValue: routerContext.query?.fromValue,
            startTimestamp: routerContext.query?.startTimestamp,
            endTimestamp: routerContext.query?.endTimestamp,
            eventCategories: routerContext.query?.eventCategories,
            levels: routerContext.query?.levels,
            size: routerContext.query?.size ?? 30,
            insertedAt: routerContext.query?.insertedAt,
            searchString: routerContext.query?.searchString,
            pageDirection: routerContext.query?.pageDirection ?? 'NEXT',
            integrationId: routerContext.match.params.integrationId
        });
    },
    maxAge: 60000,
    isBrowserOnly: true
});

});
parcelRegister("iyXZB", function(module, exports) {

$parcel$export(module.exports, "fetchLogs", () => $70cb926a05923771$export$b9fcc8145a518db4);

var $d9Cgl = parcelRequire("d9Cgl");

var $3DGHK = parcelRequire("3DGHK");
const $70cb926a05923771$export$b9fcc8145a518db4 = async (params)=>{
    const urlParams = (0, $3DGHK.generateLogParams)(params);
    return (0, $d9Cgl.eocFetch)('/v1/logs/search?' + urlParams.toString()).then((response)=>(0, $3DGHK.postProcessLogsSearch)(urlParams, response));
};

});
parcelRegister("3DGHK", function(module, exports) {

$parcel$export(module.exports, "isValidTimePeriodFormat", () => $47f0963d5381450f$export$2214112898027187);
$parcel$export(module.exports, "getBetweenErrorMessage", () => $47f0963d5381450f$export$b29a6f1d6d345720);
$parcel$export(module.exports, "isValidBetweenInput", () => $47f0963d5381450f$export$7b619dd534dac336);
$parcel$export(module.exports, "isInvalidDateValue", () => $47f0963d5381450f$export$f18cd4bc58b99a27);
$parcel$export(module.exports, "checkQueryIncludesValue", () => $47f0963d5381450f$export$792d5c0a6d15a15e);
$parcel$export(module.exports, "parseGroupOptionQuery", () => $47f0963d5381450f$export$f344cca10df5ca13);
$parcel$export(module.exports, "parseOptionQuery", () => $47f0963d5381450f$export$100c2d7fc380fbfa);
$parcel$export(module.exports, "collectQueryParamsFromOptions", () => $47f0963d5381450f$export$4db9080fab1bce85);
$parcel$export(module.exports, "calculateTimeBetween", () => $47f0963d5381450f$export$42dac873831f0e2);
$parcel$export(module.exports, "generateLogParams", () => $47f0963d5381450f$export$85293a2f3995ddcc);
$parcel$export(module.exports, "fromUnitConverter", () => $47f0963d5381450f$export$ae02811946c03a4b);
$parcel$export(module.exports, "createBaseQuery", () => $47f0963d5381450f$export$9a8301702bf003c4);
$parcel$export(module.exports, "calculateNewStartAndEndTimestamp", () => $47f0963d5381450f$export$b06db0f8b326b929);
$parcel$export(module.exports, "isDetailsSectionEmpty", () => $47f0963d5381450f$export$74cb10c4b9924e49);
$parcel$export(module.exports, "generateParamsForOneMonthInterval", () => $47f0963d5381450f$export$130612b33e678a37);
$parcel$export(module.exports, "calculateWidthAccordingToLevel", () => $47f0963d5381450f$export$e083dc64e00e053b);
$parcel$export(module.exports, "getSourceStringFromUrl", () => $47f0963d5381450f$export$c6631e198cf7c0f4);
$parcel$export(module.exports, "makeMarkup", () => $47f0963d5381450f$export$59302306c6f78677);
$parcel$export(module.exports, "postProcessLogsSearch", () => $47f0963d5381450f$export$9a858fe3837c0be0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $grR0x = parcelRequire("grR0x");

var $jj52j = parcelRequire("jj52j");

var $jovBr = parcelRequire("jovBr");

var $eZDAP = parcelRequire("eZDAP");

var $gn1v9 = parcelRequire("gn1v9");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $k9nuy = parcelRequire("k9nuy");

var $gtuj9 = parcelRequire("gtuj9");
var $9dX4l = parcelRequire("9dX4l");

var $88d4R = parcelRequire("88d4R");

var $6CTed = parcelRequire("6CTed");

var $hoWxw = parcelRequire("hoWxw");

var $gywwL = parcelRequire("gywwL");
// jira-frontend/src/packages/jql-builder-basic-datetime/src/ui/utils/time-functions.tsx
const $47f0963d5381450f$var$isNumeric = (value)=>/^\d+$/.test(value);
const $47f0963d5381450f$export$2214112898027187 = (timeDigits, timeUnit)=>{
    return timeDigits === '' || timeDigits !== undefined && $47f0963d5381450f$var$isNumeric(timeDigits) && parseInt(timeDigits, 10) > -1 && (0, $6CTed.RANGE_OPTIONS).includes(timeUnit);
};
const $47f0963d5381450f$export$b29a6f1d6d345720 = (intl, value)=>{
    if (!value?.startDate && !value?.endDate) return intl.formatMessage((0, $gywwL.default).validationMessageAtLeastOneValue);
    if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return intl.formatMessage((0, $gywwL.default).validationMessageBeforeGreaterThanAfter);
    if (value && (value?.startDate !== '' && !(0, $jovBr.default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, $jovBr.default)(new Date(value?.endDate)))) return intl.formatMessage((0, $gywwL.default).validationMessageInvalidDateFormat);
    return undefined;
};
const $47f0963d5381450f$export$7b619dd534dac336 = (value)=>{
    if (!value?.startDate && !value?.endDate) return false;
    if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return false;
    if (value && (value?.startDate !== '' && !(0, $jovBr.default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, $jovBr.default)(new Date(value?.endDate)))) return false;
    return true;
};
const $47f0963d5381450f$export$f18cd4bc58b99a27 = (value)=>{
    return !(0, $jovBr.default)((0, $eZDAP.default)(value)) && value !== '';
};
const $47f0963d5381450f$export$760bb1b75585fb94 = (value)=>{
    return value.map((event)=>event.value).join(',');
};
const $47f0963d5381450f$export$792d5c0a6d15a15e = (query, value)=>{
    return query?.includes(value.toString()) ?? false;
};
const $47f0963d5381450f$export$f344cca10df5ca13 = (query, options)=>{
    if (!query) return [];
    const labels = [];
    options.map((option)=>{
        option.options.map((item)=>labels.push(item));
    });
    return labels.filter(({ value: value })=>$47f0963d5381450f$export$792d5c0a6d15a15e(query, value));
};
const $47f0963d5381450f$export$100c2d7fc380fbfa = (query, options)=>{
    if (!query) return [];
    return options.filter((label)=>query.includes(label.value.toString()));
};
const $47f0963d5381450f$export$422789958d8174dd = (unit)=>(0, $6CTed.RANGE_OPTIONS).includes(unit);
const $47f0963d5381450f$export$4db9080fab1bce85 = (options)=>{
    return options.map((option)=>option.value).join(',');
};
const $47f0963d5381450f$var$isTimeQueryParamsValid = (params)=>{
    if (params.has('startTimestamp') && params.has('endTimestamp')) return true;
    else if (params.has('fromUnit') && params.has('fromValue')) return true;
    return false;
};
const $47f0963d5381450f$export$42dac873831f0e2 = (params)=>{
    const now = new Date();
    if (!params.get('startTimestamp') && !params.get('endTimestamp') && params.get('fromUnit') && params.get('fromValue')) {
        const parsedFromValue = parseInt(params.get('fromValue') ?? '1');
        switch(params.get('fromUnit')){
            case 'HOUR':
                params.set('endTimestamp', (now.getTime() * (0, $hoWxw.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $gn1v9.default)(now, {
                    hours: parsedFromValue
                }).getTime() * (0, $hoWxw.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'DAY':
                params.set('endTimestamp', (now.getTime() * (0, $hoWxw.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $gn1v9.default)(now, {
                    days: parsedFromValue
                }).getTime() * (0, $hoWxw.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'WEEK':
                params.set('endTimestamp', (now.getTime() * (0, $hoWxw.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $gn1v9.default)(now, {
                    weeks: parsedFromValue
                }).getTime() * (0, $hoWxw.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'MONTH':
                params.set('endTimestamp', (now.getTime() * (0, $hoWxw.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $gn1v9.default)(now, {
                    months: parsedFromValue
                }).getTime() * (0, $hoWxw.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
        }
        params.delete('fromUnit');
        params.delete('fromValue');
    }
    return params;
};
const $47f0963d5381450f$export$85293a2f3995ddcc = (params)=>{
    const urlParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value])=>{
        if (value) urlParams.append(key, decodeURI(value));
    });
    if (!$47f0963d5381450f$var$isTimeQueryParamsValid(urlParams)) {
        // Remove time parameters if exists since they were not matched.
        urlParams.delete('fromUnit');
        urlParams.delete('fromValue');
        urlParams.delete('startTimestamp');
        urlParams.delete('endTimestamp');
        urlParams.append('fromUnit', 'DAY');
        urlParams.append('fromValue', '1');
    }
    return $47f0963d5381450f$export$42dac873831f0e2(urlParams);
};
const $47f0963d5381450f$var$calculateTimeDifference = (startDate, endDate)=>{
    const minutesDiff = (0, $grR0x.default)(endDate, startDate);
    if (minutesDiff < 60) return {
        hours: 1,
        days: 0,
        weeks: 0,
        months: 0,
        years: 0
    };
    const hoursDiff = minutesDiff / 60;
    const daysDiff = minutesDiff / 60 / 24;
    const weeksDiff = minutesDiff / 60 / 24 / 7;
    const monthsDiff = minutesDiff / 60 / 24 / 7 / 4;
    return {
        hours: hoursDiff > 0 ? Math.floor(hoursDiff) : 0,
        days: daysDiff > 0 ? Math.floor(daysDiff) : 0,
        weeks: weeksDiff > 0 ? Math.floor(weeksDiff) : 0,
        months: monthsDiff > 0 ? Math.floor(monthsDiff) : 0
    };
};
const $47f0963d5381450f$export$ae02811946c03a4b = (startDate, endDate)=>{
    const parsedStartDate = (0, $eZDAP.default)(startDate);
    const parsedEndDate = (0, $eZDAP.default)(endDate);
    const timeDifference = $47f0963d5381450f$var$calculateTimeDifference(parsedStartDate, parsedEndDate);
    if (timeDifference.months > 0) return {
        timeUnit: 'MONTH',
        timeDigits: timeDifference.months.toString()
    };
    else if (timeDifference.weeks > 0) return {
        timeUnit: 'WEEK',
        timeDigits: timeDifference.weeks.toString()
    };
    else if (timeDifference.days > 0) return {
        timeUnit: 'DAY',
        timeDigits: timeDifference.days.toString()
    };
    else return {
        timeUnit: 'HOUR',
        timeDigits: timeDifference.hours.toString()
    };
};
const $47f0963d5381450f$export$9a8301702bf003c4 = (query)=>{
    let searchQuery = {};
    if (query.searchString) searchQuery = {
        ...searchQuery,
        searchString: query.searchString
    };
    if (query.startTimestamp && query.endTimestamp) searchQuery = {
        ...searchQuery,
        startTimestamp: query.startTimestamp,
        endTimestamp: query.endTimestamp
    };
    if (query.timeType) searchQuery = {
        ...searchQuery,
        timeType: query.timeType
    };
    if (query.eventCategories) searchQuery = {
        ...searchQuery,
        eventCategories: query.eventCategories
    };
    if (query.levels) searchQuery = {
        ...searchQuery,
        levels: query.levels
    };
    if (query.size) searchQuery = {
        ...searchQuery,
        size: query.size
    };
    return searchQuery;
};
function $47f0963d5381450f$export$b06db0f8b326b929(startTimestamp, endTimestamp) {
    const startDateIntValue = parseInt(startTimestamp) / (0, $hoWxw.NANOSECONDS_IN_MILLISECOND);
    const endDateIntValue = parseInt(endTimestamp) / (0, $hoWxw.NANOSECONDS_IN_MILLISECOND);
    const { timeDigits: fromValue, timeUnit: fromUnit } = $47f0963d5381450f$export$ae02811946c03a4b((0, $jj52j.default)(startDateIntValue), (0, $jj52j.default)(endDateIntValue));
    const params = $47f0963d5381450f$export$42dac873831f0e2(new URLSearchParams({
        fromValue: fromValue,
        fromUnit: fromUnit
    }));
    const startTimestampParams = params.get('startTimestamp');
    const endTimestampParams = params.get('endTimestamp');
    (0, $gtuj9.assert)(!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(startTimestampParams) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(endTimestampParams), new (0, $9dX4l.AssertionError)('calculateNewStartAndEndTimestamp', 'startTimestamp and endTimestamp should not be null'));
    return {
        startTimestamp: startTimestampParams,
        endTimestamp: endTimestampParams
    };
}
const $47f0963d5381450f$export$74cb10c4b9924e49 = (importantField, raw, isImportantFieldEmpty)=>{
    if (!importantField || !raw) return true;
    const parsedImportantField = JSON.parse(importantField);
    const parsedRaw = JSON.parse(raw);
    return ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(parsedImportantField) || isImportantFieldEmpty === true) && (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(parsedRaw);
};
const $47f0963d5381450f$export$130612b33e678a37 = ()=>{
    const params = $47f0963d5381450f$export$42dac873831f0e2(new URLSearchParams({
        fromUnit: 'MONTH',
        fromValue: '1'
    }));
    const startDate = params.get('startTimestamp');
    const endDate = params.get('endTimestamp');
    (0, $gtuj9.assert)(!!startDate && !!endDate, new (0, $9dX4l.AssertionError)('generateParamsForOneMonthInterval', 'startTimestamp and endDate should not be null'));
    return {
        dateTimeValue: {
            startDate: startDate,
            endDate: endDate
        },
        timeType: (0, $88d4R.TimeRadioOptions).WITHIN_THE_LAST
    };
};
const $47f0963d5381450f$export$e083dc64e00e053b = (level)=>{
    const BASE_OFFSET = 18;
    return `${(0, $hoWxw.DETAIL_ITEM_BASE_WIDTH) - level * BASE_OFFSET}px`;
};
const $47f0963d5381450f$export$c6631e198cf7c0f4 = (search)=>{
    const splittedSearch = search.split(/source=/i);
    if (splittedSearch.length > 1) return decodeURIComponent(splittedSearch[1]);
    return '';
};
function $47f0963d5381450f$export$59302306c6f78677(fragment, key) {
    const { nodeName: nodeName, nodeType: nodeType, childNodes: childNodes, textContent: textContent } = fragment;
    if (nodeType === Node.TEXT_NODE) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: textContent
    }, key);
    const children = [];
    childNodes.forEach((childNode, i)=>{
        const markup = $47f0963d5381450f$export$59302306c6f78677(childNode, String(i));
        if (markup) children.push(markup);
    });
    switch(nodeName){
        case 'B':
            return /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
                children: children
            }, key);
        case 'I':
            return /*#__PURE__*/ (0, $2OMIu.jsx)("i", {
                children: children
            }, key);
        case 'STRONG':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                weight: "bold",
                children: children
            }, key);
        case 'EM':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                as: "em",
                children: children
            }, key);
        case 'CODE':
            return /*#__PURE__*/ (0, $2OMIu.jsx)("code", {
                children: children
            }, key);
    }
    if (children.length === 1) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: children[0]
    }, key);
    if (children.length) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        children: children
    }, key);
    return null;
}
const $47f0963d5381450f$export$9a858fe3837c0be0 = (urlParams, response)=>{
    if (urlParams.get('startTimestamp') && urlParams.get('endTimestamp')) return {
        ...response,
        data: {
            ...response.data,
            pagination: {
                ...response.data.pagination,
                calcStartDate: urlParams.get('startTimestamp'),
                calcEndDate: urlParams.get('endTimestamp')
            }
        }
    };
    return response;
};

});
parcelRegister("88d4R", function(module, exports) {

$parcel$export(module.exports, "TimeRadioOptions", () => $95cff0dab6b0443a$export$ff1338756af30600);
var $95cff0dab6b0443a$export$ff1338756af30600 = /*#__PURE__*/ function(TimeRadioOptions) {
    TimeRadioOptions["WITHIN_THE_LAST"] = "withinTheLast";
    TimeRadioOptions["BETWEEN"] = "between";
    return TimeRadioOptions;
}({});

});

parcelRegister("6CTed", function(module, exports) {

$parcel$export(module.exports, "RANGE_OPTIONS", () => $ffe58d2e2c34662b$export$a0f3448347834e6b);
const $ffe58d2e2c34662b$export$a0f3448347834e6b = [
    'HOUR',
    'DAY',
    'WEEK',
    'MONTH'
];

});

parcelRegister("hoWxw", function(module, exports) {

$parcel$export(module.exports, "PAGE_SIZE_QUERY_PARAM", () => $ad2c3c545317952a$export$4b254bc84a71033a);
$parcel$export(module.exports, "NANOSECONDS_IN_MILLISECOND", () => $ad2c3c545317952a$export$753f41e31eccb6d7);
$parcel$export(module.exports, "getHeaderWidths", () => $ad2c3c545317952a$export$8aa6dbdb947f7df1);
$parcel$export(module.exports, "DETAIL_ITEM_BASE_WIDTH", () => $ad2c3c545317952a$export$1220f90483bde21);
const $ad2c3c545317952a$export$4b254bc84a71033a = 'size';
const $ad2c3c545317952a$export$753f41e31eccb6d7 = 1000000;
const $ad2c3c545317952a$export$8aa6dbdb947f7df1 = (params)=>{
    const { DATE_HEADER_WIDTH: DATE_HEADER_WIDTH, CATEGORY_HEADER_WIDTH: CATEGORY_HEADER_WIDTH, TYPE_HEADER_WIDTH: TYPE_HEADER_WIDTH } = params.showEventCategoryField ? {
        // Widths for audit logs page
        DATE_HEADER_WIDTH: 16,
        CATEGORY_HEADER_WIDTH: 16,
        TYPE_HEADER_WIDTH: 10
    } : {
        // Widths for integration-specific log page
        DATE_HEADER_WIDTH: 14,
        CATEGORY_HEADER_WIDTH: 0,
        TYPE_HEADER_WIDTH: 12
    };
    const columnsToShow = [
        DATE_HEADER_WIDTH,
        CATEGORY_HEADER_WIDTH,
        TYPE_HEADER_WIDTH
    ];
    let sum = 0;
    columnsToShow.forEach((width)=>{
        sum += width;
    });
    return {
        DATE_HEADER_WIDTH: `${DATE_HEADER_WIDTH}%`,
        CATEGORY_HEADER_WIDTH: `${CATEGORY_HEADER_WIDTH}%`,
        TYPE_HEADER_WIDTH: `${TYPE_HEADER_WIDTH}%`,
        CHANGE_SUMMARY_HEADER_WIDTH: `${100 - sum}%`
    };
};
const $ad2c3c545317952a$export$1220f90483bde21 = 250;

});

parcelRegister("gywwL", function(module, exports) {

$parcel$export(module.exports, "default", () => $766f43a00778fae6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $766f43a00778fae6$var$messages = (0, $7VHMR.defineMessages)({
    validationMessageBeforeGreaterThanAfter: {
        id: `eoc.customer-logs.common.utils.validation-message-before-greater-than-after.no-translate`,
        defaultMessage: 'Specify a valid time range.',
        description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
    },
    validationMessageInvalidDateFormat: {
        id: `eoc.customer-logs.common.utils.validation-message-invalid-date-format.no-translate`,
        defaultMessage: 'Invalid date format.',
        description: 'Invalid date format.'
    },
    validationMessageAtLeastOneValue: {
        id: `eoc.customer-logs.common.utils.validation-message-at-least-one-value.no-translate`,
        defaultMessage: 'Select at least one value.',
        description: 'Message displayed to the user when there is no selected before and end date together'
    }
});
var $766f43a00778fae6$export$2e2bcd8739ae039 = $766f43a00778fae6$var$messages;

});




parcelRegister("8l0h0", function(module, exports) {

$parcel$export(module.exports, "uiSettingsResource", () => $b91ccfc35e10b0e5$export$f2b33518cf31cd40);

var $2M1hQ = parcelRequire("2M1hQ");

var $9OTQp = parcelRequire("9OTQp");
const $b91ccfc35e10b0e5$export$f2b33518cf31cd40 = (0, $2M1hQ.createResource)({
    type: 'ui-settings-resource',
    getKey: ()=>'ui-settings-resource',
    getData: async ()=>(0, $9OTQp.fetchUiSettingsEndpoint)(),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("9OTQp", function(module, exports) {

$parcel$export(module.exports, "fetchUiSettingsEndpoint", () => $8c3d13c0e66c5f6a$export$ea2f12bcbdce2020);

var $d9Cgl = parcelRequire("d9Cgl");
const $8c3d13c0e66c5f6a$export$ea2f12bcbdce2020 = async ()=>{
    return (0, $d9Cgl.eocFetch)('/v1/logs');
};

});



parcelRegister("7GYMz", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationLogRoute", () => $69ab4fb51e1e7924$export$71884dc820e415fc);
const $69ab4fb51e1e7924$export$71884dc820e415fc = {
    name: 'eoc-integration-log',
    path: '/jira/settings/products/ops/integrations/:type/:integrationId/logs',
    exact: true
};

});

parcelRegister("5pZel", function(module, exports) {

$parcel$export(module.exports, "IntegrationLog", () => $62766cc40b0fef68$export$b545b4a4c4cee016);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kEMby = parcelRequire("kEMby");
const $62766cc40b0fef68$export$b545b4a4c4cee016 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $kEMby.LazyIntegrationLog),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("68ycU", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationsRouteEntry", () => $42b9c62ef769e46b$export$6e5cd6656076550f);

var $911Mi = parcelRequire("911Mi");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $eZXFU = parcelRequire("eZXFU");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $aVb3A = parcelRequire("aVb3A");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $kEMby = parcelRequire("kEMby");

var $jNNfq = parcelRequire("jNNfq");
const $42b9c62ef769e46b$var$getNavigationSpecifications = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $42b9c62ef769e46b$export$6e5cd6656076550f = (0, $7NszV.createEntry)((0, $aVb3A.globalIntegrationsRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $jNNfq.IntegrationAutomation),
        slot: null,
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $911Mi.resources).configuredIntegrationsResource,
            (0, $911Mi.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$42b9c62ef769e46b$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("aVb3A", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationsRoute", () => $0fed354e3cd747e8$export$e196ff2390a1ec56);
const $0fed354e3cd747e8$export$e196ff2390a1ec56 = {
    name: 'eoc-integrations',
    path: '/jira/settings/products/ops/integrations',
    exact: true
};

});


parcelRegister("4BuRo", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationCreateRouteEntry", () => $46e74e6464e445dd$export$83aea99d18750f08);

var $911Mi = parcelRequire("911Mi");

var $ba5IO = parcelRequire("ba5IO");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $lxIQB = parcelRequire("lxIQB");

var $jNNfq = parcelRequire("jNNfq");

var $2PI2S = parcelRequire("2PI2S");

var $kEMby = parcelRequire("kEMby");
const $46e74e6464e445dd$export$83aea99d18750f08 = (0, $7NszV.createEntry)((0, $lxIQB.teamIntegrationCreateRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $jNNfq.IntegrationAutomation),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: (0, $2PI2S.IntegrationCreate),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ba5IO.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $911Mi.resources).configuredIntegrationsResource,
            (0, $911Mi.resources).integrationListResource,
            (0, $911Mi.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("lxIQB", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationCreateRoute", () => $ae27079a91acfd42$export$a2ec7da6c43acbbf);
const $ae27079a91acfd42$export$a2ec7da6c43acbbf = {
    name: 'eoc-team-integration-create',
    path: '/jira/ops/teams/:teamId/integrations/create/:type',
    exact: true
};

});


parcelRegister("6SWMv", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationDetailRouteEntry", () => $cd5c132b5b5151e0$export$7e0b6b79953422c1);

var $911Mi = parcelRequire("911Mi");

var $ba5IO = parcelRequire("ba5IO");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $8C1ee = parcelRequire("8C1ee");

var $jNNfq = parcelRequire("jNNfq");

var $7ifqF = parcelRequire("7ifqF");

var $kEMby = parcelRequire("kEMby");
const $cd5c132b5b5151e0$export$7e0b6b79953422c1 = (0, $7NszV.createEntry)((0, $8C1ee.teamIntegrationDetailRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $jNNfq.IntegrationAutomation),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: (0, $7ifqF.IntegrationDetail),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ba5IO.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $911Mi.resources).configuredIntegrationsResource,
            (0, $911Mi.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("8C1ee", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationDetailRoute", () => $de1d1f48c94d5c8d$export$72169399df792b7c);
const $de1d1f48c94d5c8d$export$72169399df792b7c = {
    name: 'eoc-team-integration-detail',
    path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId',
    exact: true
};

});


parcelRegister("jFY66", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationListRouteEntry", () => $d817aeb7fccbfd68$export$52ee366e7b51f38d);

var $911Mi = parcelRequire("911Mi");

var $ba5IO = parcelRequire("ba5IO");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $2EBRZ = parcelRequire("2EBRZ");

var $jNNfq = parcelRequire("jNNfq");

var $3cv8c = parcelRequire("3cv8c");

var $kEMby = parcelRequire("kEMby");
const $d817aeb7fccbfd68$export$52ee366e7b51f38d = (0, $7NszV.createEntry)((0, $2EBRZ.teamIntegrationListRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $jNNfq.IntegrationAutomation),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: (0, $3cv8c.IntegrationList),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ba5IO.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $911Mi.resources).integrationListResource,
            (0, $911Mi.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("2EBRZ", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationListRoute", () => $8e217314970bb735$export$b8218f375778e6d7);
const $8e217314970bb735$export$b8218f375778e6d7 = {
    name: 'eoc-team-integration-list',
    path: '/jira/ops/teams/:teamId/integrations/list',
    exact: true
};

});


parcelRegister("jPXYO", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationLogRouteEntry", () => $77c62c16bb189e65$export$d5e169223d2a5d1d);

var $4qQmy = parcelRequire("4qQmy");

var $911Mi = parcelRequire("911Mi");

var $ba5IO = parcelRequire("ba5IO");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $80ouD = parcelRequire("80ouD");

var $jNNfq = parcelRequire("jNNfq");

var $5pZel = parcelRequire("5pZel");

var $kEMby = parcelRequire("kEMby");
const $77c62c16bb189e65$export$d5e169223d2a5d1d = (0, $7NszV.createEntry)((0, $80ouD.teamIntegrationLogRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $jNNfq.IntegrationAutomation),
        slot: (0, $5pZel.IntegrationLog),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ba5IO.resources)(),
            ...(0, $4qQmy.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $911Mi.resources).configuredIntegrationsResource,
            (0, $911Mi.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("80ouD", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationLogRoute", () => $d7b8bbfd81270213$export$ca02d7b2c7df3d60);
const $d7b8bbfd81270213$export$ca02d7b2c7df3d60 = {
    name: 'eoc-team-integration-log',
    path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId/logs',
    exact: true
};

});


parcelRegister("ktYro", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationsRouteEntry", () => $97fc56f25f58996b$export$ded9494f81dd2a4d);

var $911Mi = parcelRequire("911Mi");

var $ba5IO = parcelRequire("ba5IO");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $1ZFOA = parcelRequire("1ZFOA");

var $jNNfq = parcelRequire("jNNfq");

var $kEMby = parcelRequire("kEMby");
const $97fc56f25f58996b$export$ded9494f81dd2a4d = (0, $7NszV.createEntry)((0, $1ZFOA.teamIntegrationsRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $jNNfq.IntegrationAutomation),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: null,
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ba5IO.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $911Mi.resources).configuredIntegrationsResource,
            (0, $911Mi.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("1ZFOA", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationsRoute", () => $78efd1de67032a37$export$400ead354c81dee3);
const $78efd1de67032a37$export$400ead354c81dee3 = {
    name: 'eoc-team-integrations',
    path: '/jira/ops/teams/:teamId/integrations',
    exact: true
};

});


parcelRegister("5H5Rm", function(module, exports) {

$parcel$export(module.exports, "eocGlobalMaintenanceRouteEntry", () => $e5934255c94fc385$export$ce2a5648c28a5b48);

var $fNKyi = parcelRequire("fNKyi");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $eZXFU = parcelRequire("eZXFU");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fGpPl = parcelRequire("fGpPl");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $bEKnP = parcelRequire("bEKnP");
const $e5934255c94fc385$var$getNavigationSpecifications = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $e5934255c94fc385$export$ce2a5648c28a5b48 = (0, $7NszV.createEntry)((0, $fGpPl.eocGlobalMaintenanceRoute), ()=>({
        group: 'eoc',
        component: (0, $bEKnP.MaintenanceComponent),
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $fNKyi.resources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$e5934255c94fc385$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bEKnP.LazyMaintenance)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bEKnP.LazyMaintenance)
        ]
    }));

});
parcelRegister("fNKyi", function(module, exports) {

$parcel$export(module.exports, "maintenanceResource", () => $8a21708974c23c03$export$5486c78261efb2c3);
$parcel$export(module.exports, "maintenanceUserRightsResource", () => $8a21708974c23c03$export$e4c92d8948e3625);
$parcel$export(module.exports, "resources", () => $8a21708974c23c03$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $6luO8 = parcelRequire("6luO8");

var $k1RJS = parcelRequire("k1RJS");
const $8a21708974c23c03$export$5486c78261efb2c3 = (0, $2M1hQ.createResource)({
    type: 'maintenanceResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `maintenance/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $k1RJS.getMaintenance)(teamId);
    },
    isBrowserOnly: true
});
const $8a21708974c23c03$export$e4c92d8948e3625 = (0, $2M1hQ.createResource)({
    type: 'maintenanceUserRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `maintenance-user-rights/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $k1RJS.getMaintenanceUserRights)(teamId);
    },
    isBrowserOnly: true
});
const $8a21708974c23c03$export$bc99aaabaf7b70a7 = ()=>[
        ...(0, $6luO8.eocCommonResources)(),
        $8a21708974c23c03$export$5486c78261efb2c3,
        $8a21708974c23c03$export$e4c92d8948e3625
    ];

});
parcelRegister("k1RJS", function(module, exports) {

$parcel$export(module.exports, "getMaintenance", () => $48f0c28354e78624$export$9cc878e1852c5ee1);
$parcel$export(module.exports, "deleteMaintenance", () => $48f0c28354e78624$export$f64242288df38e86);
$parcel$export(module.exports, "cancelMaintenance", () => $48f0c28354e78624$export$2d4a5362bda1b3c1);
$parcel$export(module.exports, "changeDateAndTime", () => $48f0c28354e78624$export$2162fcbd04e23a3d);
$parcel$export(module.exports, "getMaintenanceUserRights", () => $48f0c28354e78624$export$60048f3b7e7bf9b9);
$parcel$export(module.exports, "createMaintenance", () => $48f0c28354e78624$export$602dd976bd963418);
$parcel$export(module.exports, "updateMaintenance", () => $48f0c28354e78624$export$fa55cd063e1b15c2);

var $d9Cgl = parcelRequire("d9Cgl");
const $48f0c28354e78624$export$9cc878e1852c5ee1 = (teamId)=>{
    return (0, $d9Cgl.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances`);
};
const $48f0c28354e78624$export$f64242288df38e86 = (teamId, id)=>{
    return (0, $d9Cgl.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};
const $48f0c28354e78624$export$2d4a5362bda1b3c1 = (teamId, id)=>{
    return (0, $d9Cgl.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/cancel`, {
        method: 'PATCH'
    });
};
const $48f0c28354e78624$export$2162fcbd04e23a3d = (teamId, id, endDate)=>{
    return (0, $d9Cgl.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/updateEndDate`, {
        method: 'PATCH',
        body: {
            endDate: endDate
        }
    });
};
const $48f0c28354e78624$export$60048f3b7e7bf9b9 = (teamId)=>{
    return (0, $d9Cgl.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/rights`);
};
const $48f0c28354e78624$export$602dd976bd963418 = (payload, teamId)=>{
    const url = teamId ? `/v1/teams/${teamId}/maintenances` : '/v1/maintenances';
    return (0, $d9Cgl.eocFetch)(url, {
        method: 'POST',
        body: payload
    });
};
const $48f0c28354e78624$export$fa55cd063e1b15c2 = (payload, id, teamId)=>{
    const url = teamId ? `/v1/teams/${teamId}/maintenances/${id}` : `/v1/maintenances/${id}`;
    return (0, $d9Cgl.eocFetch)(url, {
        method: 'PUT',
        body: payload
    });
};

});


parcelRegister("fGpPl", function(module, exports) {

$parcel$export(module.exports, "eocGlobalMaintenanceRoute", () => $665baa85f1a3583a$export$e0665f23a759e78f);
const $665baa85f1a3583a$export$e0665f23a759e78f = {
    name: 'eoc-global-maintenance',
    path: '/jira/settings/products/ops/maintenance',
    exact: true
};

});

parcelRegister("bEKnP", function(module, exports) {

$parcel$export(module.exports, "LazyMaintenance", () => $31bca194426a79fa$export$c5c7dc53d976edee);
$parcel$export(module.exports, "MaintenanceComponent", () => $31bca194426a79fa$export$76d7c25f72022339);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $31bca194426a79fa$export$c5c7dc53d976edee = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("gHZbB")), {
    moduleId: "./src/packages/eoc/maintenance/src/index.tsx"
});
const $31bca194426a79fa$export$76d7c25f72022339 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $31bca194426a79fa$export$c5c7dc53d976edee,
        pageId: "async-jira-eoc-maintenance",
        shouldShowSpinner: false
    });

});
parcelRegister("gHZbB", function(module, exports) {

let $c2a01fcd828fa4f9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c2a01fcd828fa4f9$var$load("h2MrD"),
    $c2a01fcd828fa4f9$var$load("bYT2S"),
    $c2a01fcd828fa4f9$var$load("9feTp")
]).then(()=>parcelRequire('iqyJK'));

});



parcelRegister("jAB8i", function(module, exports) {

$parcel$export(module.exports, "eocMaintenanceRouteEntry", () => $e4663459434822fe$export$e9c59d0d6bfec8a3);

var $fNKyi = parcelRequire("fNKyi");

var $ba5IO = parcelRequire("ba5IO");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $9sQfT = parcelRequire("9sQfT");

var $bEKnP = parcelRequire("bEKnP");
const $e4663459434822fe$export$e9c59d0d6bfec8a3 = (0, $7NszV.createEntry)((0, $9sQfT.eocMaintenanceRoute), ()=>({
        group: 'eoc',
        component: (0, $bEKnP.MaintenanceComponent),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $fNKyi.resources)(),
            ...(0, $ba5IO.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bEKnP.LazyMaintenance),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("9sQfT", function(module, exports) {

$parcel$export(module.exports, "eocMaintenanceRoute", () => $e19afc32053c9ada$export$7523f600b27b1b54);
const $e19afc32053c9ada$export$7523f600b27b1b54 = {
    name: 'eoc-maintenance',
    path: '/jira/ops/teams/:teamId/maintenance',
    exact: true
};

});


parcelRegister("5KvQp", function(module, exports) {

$parcel$export(module.exports, "eocOnCallRedirectRouteEntry", () => $665cd44900aa1f78$export$c5c49f69c4fe1ea6);

var $ba5IO = parcelRequire("ba5IO");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fMGN8 = parcelRequire("fMGN8");

var $fLXNK = parcelRequire("fLXNK");
const $665cd44900aa1f78$export$c5c49f69c4fe1ea6 = (0, $7NszV.createEntry)((0, $fMGN8.eocOnCallRedirectRoute), ()=>({
        group: 'eoc',
        component: (0, $fLXNK.OnCallRedirect),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ba5IO.resources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ],
        isRedirect: true
    }));

});
parcelRegister("fMGN8", function(module, exports) {

$parcel$export(module.exports, "eocOnCallRedirectRoute", () => $d0ffab051a4939b4$export$d725ece0e087d522);
const $d0ffab051a4939b4$export$d725ece0e087d522 = {
    name: 'eoc-on-call-redirect',
    path: '/jira/ops/teams/:teamId',
    exact: true
};

});

parcelRegister("fLXNK", function(module, exports) {

$parcel$export(module.exports, "OnCallRedirect", () => $da08681b2a2ed397$export$659b7ce11c160b32);
$parcel$export(module.exports, "LazyOnCall", () => $da08681b2a2ed397$export$772095aa22362f73);
$parcel$export(module.exports, "default", () => $da08681b2a2ed397$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $7tQej = parcelRequire("7tQej");
var $doZTA = parcelRequire("doZTA");
const $da08681b2a2ed397$export$659b7ce11c160b32 = ()=>{
    const [routeContext] = (0, $doZTA.useRouter)();
    const redirectionUrl = `${routeContext.location.pathname}/on-call`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: redirectionUrl
    });
};

const $da08681b2a2ed397$export$772095aa22362f73 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("3y09G")), {
    moduleId: "./src/packages/eoc/on-call/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$da08681b2a2ed397$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $da08681b2a2ed397$export$772095aa22362f73,
        pageId: "async-jira-eoc-on-call",
        shouldShowSpinner: false
    });

});
parcelRegister("3y09G", function(module, exports) {

let $2954aae92debc606$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2954aae92debc606$var$load("h2MrD"),
    $2954aae92debc606$var$load("bYT2S"),
    $2954aae92debc606$var$load("b0ycI")
]).then(()=>parcelRequire('38rnw'));

});



parcelRegister("3Yng9", function(module, exports) {

$parcel$export(module.exports, "eocOnCallRouteEntry", () => $3f27e199fbc412b1$export$ac245212b12db871);

var $7prCD = parcelRequire("7prCD");

var $ba5IO = parcelRequire("ba5IO");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $5ozXn = parcelRequire("5ozXn");

var $fLXNK = parcelRequire("fLXNK");
const $3f27e199fbc412b1$export$ac245212b12db871 = (0, $7NszV.createEntry)((0, $5ozXn.eocOnCallRoute), ()=>({
        group: 'eoc',
        component: (0, $fLXNK.default),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ba5IO.resources)(),
            ...(0, $7prCD.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fLXNK.LazyOnCall),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("7prCD", function(module, exports) {

$parcel$export(module.exports, "getTeamResource", () => $82f800c6449a7599$export$50271c9e7f21f10e);
$parcel$export(module.exports, "resources", () => $82f800c6449a7599$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $gtuj9 = parcelRequire("gtuj9");
var $9dX4l = parcelRequire("9dX4l");

var $cmqxG = parcelRequire("cmqxG");

var $6AlvD = parcelRequire("6AlvD");

var $eYjr4 = parcelRequire("eYjr4");
const $82f800c6449a7599$export$50271c9e7f21f10e = (0, $2M1hQ.createResource)({
    type: 'getTeamResource',
    getKey: ()=>'getTeamResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $gtuj9.assert)(!!teamId, new (0, $9dX4l.AssertionError)('getTeamResource', 'teamId should be set to fetch on-call'));
        return (0, $eYjr4.getTeam)(teamId);
    },
    isBrowserOnly: true
});
const $82f800c6449a7599$export$bc99aaabaf7b70a7 = ()=>[
        ...(0, $6AlvD.resources),
        (0, $cmqxG.routingRulesResource),
        $82f800c6449a7599$export$50271c9e7f21f10e
    ];

});
parcelRegister("cmqxG", function(module, exports) {

$parcel$export(module.exports, "routingRulesResource", () => $de846ba6ecb96c3b$export$7f38c73dca88500e);

var $2M1hQ = parcelRequire("2M1hQ");

var $gtuj9 = parcelRequire("gtuj9");
var $9dX4l = parcelRequire("9dX4l");

var $3FJv2 = parcelRequire("3FJv2");
const $de846ba6ecb96c3b$export$7f38c73dca88500e = (0, $2M1hQ.createResource)({
    type: 'routingRulesResource',
    getKey: ()=>'routingRulesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $gtuj9.assert)(!!teamId, new (0, $9dX4l.AssertionError)('routingRulesResource', 'teamId should be set to fetch routing-rules'));
        return (0, $3FJv2.getRoutingRules)(teamId);
    },
    isBrowserOnly: true
});

});
parcelRegister("3FJv2", function(module, exports) {

$parcel$export(module.exports, "getRoutingRules", () => $17e0afe18c58159d$export$425c24c86196521);

var $d9Cgl = parcelRequire("d9Cgl");
const $17e0afe18c58159d$export$425c24c86196521 = (teamId)=>(0, $d9Cgl.eocFetch)(`/v1/teams/${teamId}/routing-rules`);

});


parcelRegister("6AlvD", function(module, exports) {

$parcel$export(module.exports, "getSchedulesResource", () => $4c38d046a84a005e$export$6b2b3e2a53cc13e2);
$parcel$export(module.exports, "getUiPreferencesResource", () => $4c38d046a84a005e$export$5c6454d866055bdd);
$parcel$export(module.exports, "getScheduleRightsResource", () => $4c38d046a84a005e$export$9d9ecb8586783931);
$parcel$export(module.exports, "getScheduleTimeTemplatesResource", () => $4c38d046a84a005e$export$90251855f07c54b4);
$parcel$export(module.exports, "resources", () => $4c38d046a84a005e$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $6luO8 = parcelRequire("6luO8");

var $jOha3 = parcelRequire("jOha3");

var $dsRlP = parcelRequire("dsRlP");

var $hGKbj = parcelRequire("hGKbj");

var $jIpuc = parcelRequire("jIpuc");

var $8vxVY = parcelRequire("8vxVY");

var $7Loza = parcelRequire("7Loza");
const $4c38d046a84a005e$export$6b2b3e2a53cc13e2 = (0, $2M1hQ.createResource)({
    type: 'getSchedulesResource',
    getKey: ()=>'getSchedulesResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $jIpuc.endpoints).getScheduleList((0, $dsRlP.getTeamIdFromContext)(routerExtendedContext))
});
const $4c38d046a84a005e$export$5c6454d866055bdd = (0, $2M1hQ.createResource)({
    type: 'getSchedulePreferencesResource',
    getKey: ()=>'getSchedulePreferencesResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $8vxVY.endpoints).getUiPreferences((0, $dsRlP.getTeamIdFromContext)(routerExtendedContext))
});
const $4c38d046a84a005e$export$9d9ecb8586783931 = (0, $2M1hQ.createResource)({
    type: 'getScheduleRightsResource',
    getKey: ()=>'getScheduleRightsResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $7Loza.endpoints).getScheduleRights((0, $dsRlP.getTeamIdFromContext)(routerExtendedContext))
});
const $4c38d046a84a005e$export$90251855f07c54b4 = (0, $2M1hQ.createResource)({
    type: 'getScheduleTimeTemplatesResource',
    getKey: ()=>'getScheduleTimeTemplatesResourceurce',
    isBrowserOnly: true,
    getData: async ()=>(0, $hGKbj.endpoints).getScheduleTimeTemplates()
});
const $4c38d046a84a005e$export$bc99aaabaf7b70a7 = [
    $4c38d046a84a005e$export$6b2b3e2a53cc13e2,
    $4c38d046a84a005e$export$5c6454d866055bdd,
    $4c38d046a84a005e$export$9d9ecb8586783931,
    $4c38d046a84a005e$export$90251855f07c54b4,
    ...(0, $jOha3.resources),
    ...(0, $6luO8.eocCommonResources)()
];

});
parcelRegister("jOha3", function(module, exports) {

$parcel$export(module.exports, "getTimezonesResource", () => $82b7eff4b2faece3$export$7524ea9fda8149c6);
$parcel$export(module.exports, "getTimeTemplatesResource", () => $82b7eff4b2faece3$export$f045bbf39b81240d);
$parcel$export(module.exports, "resources", () => $82b7eff4b2faece3$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $9WdkK = parcelRequire("9WdkK");
const $82b7eff4b2faece3$export$7524ea9fda8149c6 = (0, $2M1hQ.createResource)({
    type: 'getEocTimezonesResource',
    getKey: ()=>'getEocTimezonesResource',
    isBrowserOnly: true,
    getData: async ()=>(0, $9WdkK.endpoints).getTimezones()
});
const $82b7eff4b2faece3$export$f045bbf39b81240d = (0, $2M1hQ.createResource)({
    type: 'getEocTimeTemplatesResource',
    getKey: ()=>'getEocTimeTemplatesResource',
    isBrowserOnly: true,
    getData: async ()=>(0, $9WdkK.endpoints).getTimeTemplates()
});
const $82b7eff4b2faece3$export$bc99aaabaf7b70a7 = [
    $82b7eff4b2faece3$export$7524ea9fda8149c6
];

});
parcelRegister("9WdkK", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $bd7971e011cb400f$export$3a2536d80ecc00e7);

var $d9Cgl = parcelRequire("d9Cgl");

var $5FIsw = parcelRequire("5FIsw");
const $bd7971e011cb400f$var$getTimezones = async ()=>{
    const response = await (0, $d9Cgl.eocFetch)((0, $5FIsw.urls).customers.timezones.url(), {
        method: 'GET'
    });
    const adjusted = response.timezones.map((timezone)=>({
            ...timezone,
            offset: timezone.offset * 60000,
            currentOffset: timezone.currentOffset * 60000
        }));
    return {
        ...response,
        timezones: adjusted
    };
};
const $bd7971e011cb400f$var$getTimeTemplates = ()=>{
    return (0, $d9Cgl.eocFetch)((0, $5FIsw.urls).schedules.timeTemplates.rotation.url(), {
        method: 'GET'
    });
};
const $bd7971e011cb400f$export$3a2536d80ecc00e7 = {
    getTimezones: $bd7971e011cb400f$var$getTimezones,
    getTimeTemplates: $bd7971e011cb400f$var$getTimeTemplates
};

});
parcelRegister("5FIsw", function(module, exports) {

$parcel$export(module.exports, "urls", () => $8d5b8aff844e88ce$export$bcae9ba627f604b6);
const $8d5b8aff844e88ce$export$bcae9ba627f604b6 = Object.freeze({
    alerts: {
        responders: {
            names: {
                url: ()=>'/v1/alerts/responders/names'
            },
            autoComplete: {
                url: ()=>'/v1/alerts/responders/auto-complete'
            },
            suggested: {
                url: ()=>'/v1/alerts/responders/suggested'
            }
        }
    },
    schedules: {
        url: ()=>`/v1/schedules`,
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`/v1/schedules/${scheduleId}`,
            clone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/clone`
            },
            name: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/name`
            },
            timezone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timezone`
            },
            enable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/enable`
            },
            disable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/disable`
            },
            webCalendarUrl: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/web-calendar-url`
            },
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timeline`
            },
            overrides: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/overrides`,
                alias: {
                    url: ({ scheduleId: scheduleId, alias: alias } = {
                        scheduleId: ':scheduleId',
                        alias: ':alias'
                    })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                },
                bulk: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                }
            },
            rotations: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/rotations`,
                rotationId: {
                    url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                        scheduleId: ':scheduleId',
                        rotationId: ':rotationId'
                    })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                    order: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                    },
                    name: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                    }
                }
            }
        },
        user: {
            webCalendarUrl: {
                url: ()=>`/v1/schedules/user/web-calendar-url`
            }
        },
        timeTemplates: {
            rotation: {
                url: ()=>'/v1/schedules/time-templates/rotation'
            }
        }
    },
    customers: {
        timezones: {
            url: ()=>'/v1/customers/timezones'
        }
    }
});

});



parcelRegister("dsRlP", function(module, exports) {

$parcel$export(module.exports, "getTeamIdFromContext", () => $f06b98358f52bb48$export$3ea727bebc3792bb);

var $gtuj9 = parcelRequire("gtuj9");
var $9dX4l = parcelRequire("9dX4l");

var $dORQn = parcelRequire("dORQn");
const $f06b98358f52bb48$export$3ea727bebc3792bb = (routerContext)=>{
    const teamId = (0, $dORQn.getSafe)(()=>routerContext.match.params.teamId, null);
    (0, $gtuj9.assert)(!(0, $dORQn.isEmpty)(teamId), new (0, $9dX4l.AssertionError)('eoc-schedule', 'teamId in routerContext is not defined'));
    return teamId;
};

});
parcelRegister("dORQn", function(module, exports) {

$parcel$export(module.exports, "getSafe", () => $fb7503dbf6cae02a$export$fedb900c0ea4e699);
$parcel$export(module.exports, "isEmpty", () => $fb7503dbf6cae02a$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "isNullOrUndefined", () => $fb7503dbf6cae02a$export$bedb7023a7733221);
$parcel$export(module.exports, "noLeadingOrTrailingSpaces", () => $fb7503dbf6cae02a$export$5fc068d42db64a99);

var $1DZ55 = parcelRequire("1DZ55");
const $fb7503dbf6cae02a$export$fedb900c0ea4e699 = (fn, defaultValue)=>{
    try {
        return fn();
    } catch  {
        return defaultValue;
    }
};
const $fb7503dbf6cae02a$export$dd1bc94b04021eeb = (input)=>{
    if (input !== 0 && input !== false && !input) return true;
    if (!(input instanceof Date) && typeof input === 'object' && Object.keys(input).length === 0) return true;
    return false;
};
const $fb7503dbf6cae02a$export$bedb7023a7733221 = (input)=>{
    return input === null || input === undefined;
};
const $fb7503dbf6cae02a$export$5fc068d42db64a99 = (message)=>({ formatMessage: formatMessage })=>(value)=>{
            if (typeof value === 'string' && (value.startsWith(' ') || value.endsWith(' '))) return message ?? formatMessage((0, $1DZ55.messages).nameSpaceValidationError);
        };

});
parcelRegister("1DZ55", function(module, exports) {

$parcel$export(module.exports, "messages", () => $54116ce6ff8b6339$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $54116ce6ff8b6339$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    /*
   Misc common messages
  */ noOne: {
        id: 'eoc-schedule.common.no-one',
        defaultMessage: 'No one',
        description: 'Name of the user whose type is no-one.'
    },
    error: {
        id: 'eoc-schedule.common.error',
        defaultMessage: 'Error',
        description: 'Just simple error message.'
    },
    tryAgain: {
        id: 'eoc-schedule.common.try-again',
        defaultMessage: 'Try again',
        description: 'Try again message when an error occurs.'
    },
    cancel: {
        id: 'eoc-schedule.common.cancel',
        defaultMessage: 'Cancel',
        description: 'A cancel button.'
    },
    confirm: {
        id: 'eoc-schedule.common.confirm',
        defaultMessage: 'Confirm',
        description: 'A confirm button.'
    },
    addOverride: {
        id: 'eoc-schedule.common.add-override',
        defaultMessage: 'Add override',
        description: 'Adding override for a period item.'
    },
    overrideButton: {
        id: 'eoc-schedule.common.override',
        defaultMessage: 'Override',
        description: 'A override button.'
    },
    saveButton: {
        id: 'eoc-schedule.common.save',
        defaultMessage: 'Save',
        description: 'A save button.'
    },
    edit: {
        id: 'eoc-schedule.common.edit',
        defaultMessage: 'Edit',
        description: 'Button for editing schedule.'
    },
    turnOff: {
        id: 'eoc-schedule.common.turn-off',
        defaultMessage: 'Turn off',
        description: 'Button for turn-offing schedule.'
    },
    turnOn: {
        id: 'eoc-schedule.common.turn-on',
        defaultMessage: 'Turn on',
        description: 'Button for turn-on schedule.'
    },
    delete: {
        id: 'eoc-schedule.common.delete',
        defaultMessage: 'Delete',
        description: 'Button for deleting schedule or rotation.'
    },
    duplicate: {
        id: 'eoc-schedule.common.duplicate',
        defaultMessage: 'Duplicate',
        description: 'Button for duplicating schedule or rotation.'
    },
    remove: {
        id: 'eoc-schedule.common.remove',
        defaultMessage: 'Remove',
        description: 'Button for removing participant.'
    },
    start: {
        id: 'eoc-schedule.common.start',
        defaultMessage: 'Start',
        description: 'Label for start time and date.'
    },
    end: {
        id: 'eoc-schedule.common.end',
        defaultMessage: 'End',
        description: 'Label for end time and date.'
    },
    startTime: {
        id: 'eoc-schedule.common.start-time',
        defaultMessage: 'Start time',
        description: 'Label for start time and date.'
    },
    endTime: {
        id: 'eoc-schedule.common.end-time',
        defaultMessage: 'End time',
        description: 'Label for end time and date.'
    },
    startDate: {
        id: 'eoc-schedule.common.start-date',
        defaultMessage: 'Start date',
        description: 'Label for start time and date.'
    },
    endDate: {
        id: 'eoc-schedule.common.end-date',
        defaultMessage: 'End date',
        description: 'Label for end time and date.'
    },
    team: {
        id: 'eoc-schedule.common.team',
        defaultMessage: 'Team',
        description: 'Label that indicates responder is of type: Team'
    },
    escalation: {
        id: 'eoc-schedule.common.escalation',
        defaultMessage: 'Escalation',
        description: 'Label that indicates responder is of type: Escalation'
    },
    schedule: {
        id: 'eoc-schedule.common.schedule',
        defaultMessage: 'Schedule',
        description: 'Label that indicates responder is of type: Schedule'
    },
    selectionCount: {
        id: 'eoc-schedule.common.selection-count',
        defaultMessage: '{count} shifts selected',
        description: 'Indicates how many shifts are selected for override.'
    },
    quickOverrideTitle: {
        id: 'eoc-schedule.common.quick-override-title',
        defaultMessage: 'Override',
        description: 'Title for quick override card.'
    },
    search: {
        id: 'eoc-schedule.common.search',
        defaultMessage: 'Search',
        description: 'Label of search icon that shown inside search participant field'
    },
    replaceWith: {
        id: 'eoc-schedule.common.replace-with',
        defaultMessage: 'Replace with',
        description: 'A button for opening popup for replacing a participant.'
    },
    participants: {
        id: 'eoc-schedule.common.participants',
        defaultMessage: 'Participants',
        description: 'Label for participants.'
    },
    addParticipants: {
        id: 'eoc-schedule.common.add-participants',
        defaultMessage: 'Add people, teams, and escalation policies',
        description: 'Placeholder text for auto complete field for participants (responders).'
    },
    select: {
        id: 'eoc-schedule.common.select',
        defaultMessage: 'Select',
        description: 'Label that indicates selecting.'
    },
    teamDeleted: {
        id: 'eoc-schedule.common.team-deleted',
        defaultMessage: 'Team deleted',
        description: 'Fallback responder name that suggest team is deleted.'
    },
    deletedSchedule: {
        id: 'eoc-schedule.common.deleted-schedule',
        defaultMessage: 'Deleted schedule',
        description: 'Fallback responder name that suggest schedule is deleted.'
    },
    deletedEscalation: {
        id: 'eoc-schedule.common.deleted-escalation',
        defaultMessage: 'Deleted escalation',
        description: 'Fallback responder name that suggest escalation is deleted.'
    },
    formerUser: {
        id: 'eoc-schedule.common.former-user',
        defaultMessage: 'Former user',
        description: 'Fallback responder name that suggest user is deactivated or deleted.'
    },
    discard: {
        id: 'eoc-schedule.common.discard',
        defaultMessage: 'Discard',
        description: 'Button for discarding.'
    },
    confirmProceed: {
        id: 'eoc-schedule.common.confirm-proceed',
        defaultMessage: 'Are you sure to proceed?',
        description: 'A confirmation for proceeding.'
    },
    /*
   Common validation related messages
  */ required: {
        id: 'eoc-schedule.common.required',
        defaultMessage: 'This field is required.',
        description: 'A text that informs users that field should be filled.'
    },
    noSpaceAtEndOrStart: {
        id: 'eoc-schedule.common.no-space-at-end-or-start',
        defaultMessage: 'Field cannot contain spaces at start or end.',
        description: 'A text that informs users that field cannot start or end with spaces.'
    },
    maxLength: {
        id: 'eoc-schedule.common.max-length',
        defaultMessage: 'Field cannot be longer than {max} characters.',
        description: 'A text that informs users that field should be shorter than certain length.'
    },
    maxValue: {
        id: 'eoc-schedule.common.max-value',
        defaultMessage: 'Field should be less than {max}.',
        description: 'A text that informs users that field should be less than certain value.'
    },
    minValue: {
        id: 'eoc-schedule.common.min-value',
        defaultMessage: 'Enter digit 1 or more.',
        description: 'This sentence instructs the user to input a numeric value of at least 1 digit or greater.'
    },
    timePast: {
        id: 'eoc-schedule.common.time-past',
        defaultMessage: 'Time should be later than current time.',
        description: 'Validation error that indicates time values is in past.'
    },
    startLaterEnd: {
        id: 'eoc-schedule.common.start-later-end',
        defaultMessage: 'Start time should be earlier than the end time.',
        description: 'Validation error that indicates start time is later than the end time.'
    },
    endEarlierStart: {
        id: 'eoc-schedule.common.end-earlier-start',
        defaultMessage: 'End time should be later than the start time.',
        description: 'Validation error that indicates end time is earlier than the start time.'
    },
    startEndSame: {
        id: 'eoc-schedule.common.start-end-same',
        defaultMessage: 'Start and end time cannot be same.',
        description: 'Validation error that indicates start and end time should be different.'
    },
    thirtyMinuteInterval: {
        id: 'eoc-schedule.common.thirty-minute-intervals',
        defaultMessage: 'Time should be defined as 30 minute intervals.',
        description: 'Validation error that indicates time can be in 30 minutes intervals.'
    },
    nameSpaceValidationError: {
        id: 'eoc-schedule.common.name-space-validation-error',
        defaultMessage: 'The name cannot start or end with a space.',
        description: 'Error message for name validation when it starts or ends with a space'
    }
});

});



parcelRegister("hGKbj", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $1749e871029bb17f$export$3a2536d80ecc00e7);

var $d9Cgl = parcelRequire("d9Cgl");

var $3p3QH = parcelRequire("3p3QH");
const $1749e871029bb17f$var$orderRotation = ({ scheduleId: scheduleId, after: after, rotationId: rotationId })=>{
    return (0, $d9Cgl.eocFetch)((0, $3p3QH.urls).schedules.scheduleId.rotations.rotationId.order.url({
        rotationId: rotationId,
        scheduleId: scheduleId
    }), {
        method: 'PATCH',
        body: {
            after: after
        }
    });
};
const $1749e871029bb17f$var$getRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
    return (0, $d9Cgl.eocFetch)((0, $3p3QH.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: rotationId
    }), {
        method: 'GET'
    });
};
const $1749e871029bb17f$var$deleteRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
    return (0, $d9Cgl.eocFetch)((0, $3p3QH.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: rotationId
    }), {
        method: 'DELETE'
    });
};
const $1749e871029bb17f$var$addRotation = ({ name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, hasEndTime: hasEndTime, rotationPeriod: rotationPeriod, scheduleId: scheduleId, timeTemplateId: timeTemplateId, timingType: timingType, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
    return (0, $d9Cgl.eocFetch)((0, $3p3QH.urls).schedules.scheduleId.rotations.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            name: name,
            responders: responders,
            restrictions: restrictions,
            rotationType: rotationType,
            timeTemplateId: timeTemplateId,
            timingType: timingType,
            rotationPeriod: rotationPeriod,
            startTimeRaw: startTimeRaw,
            endTimeRaw: endTimeRaw,
            hasEndTime: hasEndTime
        }
    });
};
const $1749e871029bb17f$var$editRotation = ({ id: id, name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, rotationPeriod: rotationPeriod, hasEndTime: hasEndTime, timingType: timingType, scheduleId: scheduleId, timeTemplateId: timeTemplateId, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
    return (0, $d9Cgl.eocFetch)((0, $3p3QH.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: id
    }), {
        method: 'PUT',
        body: {
            id: id,
            name: name,
            responders: responders,
            restrictions: restrictions,
            rotationType: rotationType,
            rotationPeriod: rotationPeriod,
            timeTemplateId: timeTemplateId,
            timingType: timingType,
            startTimeRaw: startTimeRaw,
            endTimeRaw: endTimeRaw,
            hasEndTime: hasEndTime
        }
    });
};
const $1749e871029bb17f$var$getScheduleTimeTemplates = ()=>{
    return (0, $d9Cgl.eocFetch)((0, $3p3QH.urls).schedules.timeTemplates.rotation.url(), {
        method: 'GET'
    });
};
const $1749e871029bb17f$export$3a2536d80ecc00e7 = {
    deleteRotation: $1749e871029bb17f$var$deleteRotation,
    getRotation: $1749e871029bb17f$var$getRotation,
    orderRotation: $1749e871029bb17f$var$orderRotation,
    addRotation: $1749e871029bb17f$var$addRotation,
    editRotation: $1749e871029bb17f$var$editRotation,
    getScheduleTimeTemplates: $1749e871029bb17f$var$getScheduleTimeTemplates
};

});
parcelRegister("3p3QH", function(module, exports) {

$parcel$export(module.exports, "urls", () => $c11db39eff3807b0$export$bcae9ba627f604b6);
const $c11db39eff3807b0$export$bcae9ba627f604b6 = Object.freeze({
    alerts: {
        responders: {
            names: {
                url: ()=>'/v1/alerts/responders/names'
            },
            autoComplete: {
                url: ()=>'/v1/alerts/responders/auto-complete'
            }
        }
    },
    schedules: {
        url: ()=>`/v1/schedules`,
        teams: {
            teamId: {
                url: ({ teamId: teamId } = {
                    teamId: ':teamId'
                })=>`/v1/schedules/teams/${teamId}`,
                rights: {
                    url: ({ teamId: teamId } = {
                        teamId: ':teamId'
                    })=>`/v1/schedules/teams/${teamId}/rights`
                }
            }
        },
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`/v1/schedules/${scheduleId}`,
            clone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/clone`
            },
            name: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/name`
            },
            timezone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timezone`
            },
            enable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/enable`
            },
            disable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/disable`
            },
            webCalendarUrl: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/web-calendar-url`
            },
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timeline`
            },
            overrides: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/overrides`,
                alias: {
                    url: ({ scheduleId: scheduleId, alias: alias } = {
                        scheduleId: ':scheduleId',
                        alias: ':alias'
                    })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                },
                bulk: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                }
            },
            rotations: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/rotations`,
                rotationId: {
                    url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                        scheduleId: ':scheduleId',
                        rotationId: ':rotationId'
                    })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                    order: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                    },
                    name: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                    }
                }
            }
        },
        timeTemplates: {
            rotation: {
                url: ()=>'/v1/schedules/time-templates/rotation'
            }
        }
    },
    customers: {
        timezones: {
            url: ()=>'/v1/customers/timezones'
        }
    },
    uiPreference: {
        schedule: {
            team: {
                teamId: {
                    url: ({ teamId: teamId } = {
                        teamId: ':teamId'
                    })=>`/v1/users/ui-preference/schedule/team/${teamId}`
                }
            }
        }
    },
    onboarding: {
        completeTask: {
            url: ()=>'/v1/onboarding/complete-task'
        }
    }
});

});


parcelRegister("jIpuc", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $1e05b0d43b6ca799$export$3a2536d80ecc00e7);

var $d9Cgl = parcelRequire("d9Cgl");

var $3p3QH = parcelRequire("3p3QH");
const $1e05b0d43b6ca799$var$getScheduleList = (teamId)=>{
    return (0, $d9Cgl.eocFetch)((0, $3p3QH.urls).schedules.teams.teamId.url({
        teamId: teamId
    }));
};
const $1e05b0d43b6ca799$var$updateSchedule = ({ scheduleId: scheduleId, description: description, name: name, enabled: enabled, timezone: timezone })=>{
    return (0, $d9Cgl.eocFetch)((0, $3p3QH.urls).schedules.scheduleId.url({
        scheduleId: scheduleId
    }), {
        method: 'PATCH',
        body: {
            description: description,
            name: name,
            enabled: enabled,
            timezone: timezone
        }
    });
};
const $1e05b0d43b6ca799$var$deleteSchedule = ({ scheduleId: scheduleId })=>{
    return (0, $d9Cgl.eocFetch)((0, $3p3QH.urls).schedules.scheduleId.url({
        scheduleId: scheduleId
    }), {
        method: 'DELETE'
    });
};
const $1e05b0d43b6ca799$export$3a2536d80ecc00e7 = {
    deleteSchedule: $1e05b0d43b6ca799$var$deleteSchedule,
    getScheduleList: $1e05b0d43b6ca799$var$getScheduleList,
    updateSchedule: $1e05b0d43b6ca799$var$updateSchedule
};

});

parcelRegister("8vxVY", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $431f41e090e6958e$export$3a2536d80ecc00e7);

var $d9Cgl = parcelRequire("d9Cgl");

var $3p3QH = parcelRequire("3p3QH");
const $431f41e090e6958e$var$getUiPreferences = (teamId)=>{
    return (0, $d9Cgl.eocFetch)((0, $3p3QH.urls).uiPreference.schedule.team.teamId.url({
        teamId: teamId
    }));
};
const $431f41e090e6958e$var$updateUiPreferences = ({ teamId: teamId, key: key, value: value })=>{
    return (0, $d9Cgl.eocFetch)((0, $3p3QH.urls).uiPreference.schedule.team.teamId.url({
        teamId: teamId
    }), {
        method: 'PATCH',
        body: {
            [key]: value
        }
    });
};
const $431f41e090e6958e$export$3a2536d80ecc00e7 = {
    getUiPreferences: $431f41e090e6958e$var$getUiPreferences,
    updateUiPreferences: $431f41e090e6958e$var$updateUiPreferences
};

});

parcelRegister("7Loza", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $b469ce1e8bf56ed0$export$3a2536d80ecc00e7);

var $d9Cgl = parcelRequire("d9Cgl");

var $3p3QH = parcelRequire("3p3QH");
const $b469ce1e8bf56ed0$var$getScheduleRights = (teamId)=>{
    return (0, $d9Cgl.eocFetch)((0, $3p3QH.urls).schedules.teams.teamId.rights.url({
        teamId: teamId
    }));
};
const $b469ce1e8bf56ed0$var$createSchedule = ({ description: description, name: name, teamId: teamId, timezone: timezone })=>{
    return (0, $d9Cgl.eocFetch)((0, $3p3QH.urls).schedules.url(), {
        method: 'POST',
        body: {
            description: description,
            name: name,
            teamId: teamId,
            timezone: timezone,
            // Created schedules are enabled by default
            enabled: true
        }
    });
};
const $b469ce1e8bf56ed0$var$cloneSchedule = ({ description: description, name: name, enabled: enabled, timezone: timezone, teamId: teamId, scheduleId: scheduleId })=>{
    return (0, $d9Cgl.eocFetch)((0, $3p3QH.urls).schedules.scheduleId.clone.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            description: description,
            name: name,
            enabled: enabled,
            timezone: timezone,
            teamId: teamId
        }
    });
};
const $b469ce1e8bf56ed0$export$3a2536d80ecc00e7 = {
    createSchedule: $b469ce1e8bf56ed0$var$createSchedule,
    getScheduleRights: $b469ce1e8bf56ed0$var$getScheduleRights,
    cloneSchedule: $b469ce1e8bf56ed0$var$cloneSchedule
};

});


parcelRegister("eYjr4", function(module, exports) {

$parcel$export(module.exports, "getTeam", () => $ada1e06e7d1be8e2$export$491fe77f22ab2b51);

var $d9Cgl = parcelRequire("d9Cgl");
const $ada1e06e7d1be8e2$export$491fe77f22ab2b51 = (teamId)=>(0, $d9Cgl.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    });

});


parcelRegister("5ozXn", function(module, exports) {

$parcel$export(module.exports, "eocOnCallRoute", () => $deb5dca00817980c$export$5eaa466ae8a4d7d3);
const $deb5dca00817980c$export$5eaa466ae8a4d7d3 = {
    name: 'eoc-on-call',
    path: '/jira/ops/teams/:teamId/on-call',
    exact: true
};

});


parcelRegister("2B61u", function(module, exports) {

$parcel$export(module.exports, "eocOverviewAllTeamsRouteEntry", () => $da84e8a7a2986788$export$842d7c81068bb64e);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $bh0Pj = parcelRequire("bh0Pj");

var $7NszV = parcelRequire("7NszV");

var $5OcAv = parcelRequire("5OcAv");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $6QP4T = parcelRequire("6QP4T");

var $9FJ7w = parcelRequire("9FJ7w");
const $da84e8a7a2986788$export$842d7c81068bb64e = (0, $7NszV.createEntry)((0, $6QP4T.eocOverviewAllTeamsRoute), ()=>({
        group: 'eoc',
        component: (0, $9FJ7w.EocOverviewAllTeamsComponent),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $5OcAv.getTeamsResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME,
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsOverviewNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bh0Pj.LazyHorizontalOperationsOverviewNav),
            (0, $9FJ7w.LazyOverviewAllTeamsPage)
        ]
    }));

});
parcelRegister("5OcAv", function(module, exports) {

$parcel$export(module.exports, "getTeamsResource", () => $221e2d1c864e815a$export$27d854bd39923fc7);
// eslint-disable-next-line jira/import-whitelist

var $lX9wC = parcelRequire("lX9wC");
var $6fZNT = parcelRequire("6fZNT");

var $4R6GH = parcelRequire("4R6GH");

var $2M1hQ = parcelRequire("2M1hQ");

var $3H5ry = parcelRequire("3H5ry");

const $221e2d1c864e815a$export$27d854bd39923fc7 = (0, $2M1hQ.createResource)({
    type: (0, $6fZNT.getTeamsResource).type,
    getKey: (0, $6fZNT.getTeamsResource).getKey,
    getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, isSiteAdmin: isSiteAdmin, isAdmin: isAdmin } })=>{
        if (!atlassianAccountId) return null;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const tenantInfo = await dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734]?.promise;
        const isOpsAdmin = (0, $3H5ry.checkIsOpsAdmin)(tenantInfo);
        const shouldSeeAllTeams = (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? isSiteAdmin || isAdmin || isOpsAdmin : isSiteAdmin || isAdmin;
        return (0, $lX9wC.getTeams)({
            queryParams: {
                accountId: !shouldSeeAllTeams ? atlassianAccountId : undefined,
                showAvatar: true,
                ...(0, $4R6GH.fg)('display_eoc_managed_teams_with_verified_marks') && {
                    includeTeamExternalDetails: true
                }
            }
        });
    },
    isBrowserOnly: true,
    maxAge: 0,
    depends: [
        (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
    ]
});

});
parcelRegister("lX9wC", function(module, exports) {

$parcel$export(module.exports, "getTeams", () => $e0bfb91d71a0962d$export$5a622455e94bac3);

var $d9Cgl = parcelRequire("d9Cgl");
const $e0bfb91d71a0962d$export$5a622455e94bac3 = ({ url: url, queryParams: queryParams })=>{
    const params = new URLSearchParams();
    if (queryParams.keyword) params.append('keyword', queryParams.keyword);
    if (queryParams.size) params.append('size', queryParams.size.toString());
    if (queryParams.offset) params.append('offset', queryParams.offset.toString());
    if (queryParams.accountId) params.append('memberId', queryParams.accountId);
    if (queryParams.showAvatar) params.append('showAvatar', String(queryParams.showAvatar));
    if (queryParams.includeTeamExternalDetails) params.append('includeTeamExternalDetails', String(queryParams.includeTeamExternalDetails));
    if (url) return (0, $d9Cgl.eocFetch)(`${url}${params.toString() ? `?${params.toString()}` : ''}`, {
        exactUrl: true
    });
    return (0, $d9Cgl.eocFetch)(`/v1/teams${params.toString() ? `?${params.toString()}` : ''}`);
};

});

parcelRegister("6fZNT", function(module, exports) {

$parcel$export(module.exports, "getTeamsResource", () => $f4cdc7fd2a4e5760$export$27d854bd39923fc7);

var $2M1hQ = parcelRequire("2M1hQ");

var $lX9wC = parcelRequire("lX9wC");
const $f4cdc7fd2a4e5760$export$27d854bd39923fc7 = (0, $2M1hQ.createResource)({
    type: 'getTeamsResource',
    getKey: ()=>'overview',
    getData: async ()=>{
        throw new Error('getData of getTeamsResource is not implemented in platform package, you should do it in your product');
    },
    isBrowserOnly: true
});

});


parcelRegister("6QP4T", function(module, exports) {

$parcel$export(module.exports, "eocOverviewAllTeamsRoute", () => $0f11196ea10bf082$export$dbe53627482b9f0f);
const $0f11196ea10bf082$export$dbe53627482b9f0f = {
    name: 'eoc-overview-all-teams',
    path: '/jira/ops/overview/teams',
    exact: true
};

});

parcelRegister("9FJ7w", function(module, exports) {

$parcel$export(module.exports, "LazyOverviewPage", () => $9dfc49c8c344cd92$export$c7c96cc8d6e9a8f1);
$parcel$export(module.exports, "LazyOverviewAllTeamsPage", () => $9dfc49c8c344cd92$export$9a22ecad8322834e);
$parcel$export(module.exports, "EocOverviewComponent", () => $9dfc49c8c344cd92$export$b22309f0ee469d5c);
$parcel$export(module.exports, "EocOverviewAllTeamsComponent", () => $9dfc49c8c344cd92$export$2713003ebbdbb975);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $9dfc49c8c344cd92$export$c7c96cc8d6e9a8f1 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("9v4Gk")).then((m)=>m.OverviewPage), {
    moduleId: "./src/packages/eoc/overview/src/ui/overview-page/index.tsx"
});

const $9dfc49c8c344cd92$export$9a22ecad8322834e = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("8Nnts")).then((m)=>m.AllTeamsPage), {
    moduleId: "./src/packages/eoc/overview/src/ui/all-teams-page/index.tsx"
});
const $9dfc49c8c344cd92$export$b22309f0ee469d5c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9dfc49c8c344cd92$export$c7c96cc8d6e9a8f1,
        pageId: "async-jira-eoc-overview",
        shouldShowSpinner: false
    });
const $9dfc49c8c344cd92$export$2713003ebbdbb975 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9dfc49c8c344cd92$export$9a22ecad8322834e,
        pageId: "async-jira-eoc-overview-all-teams",
        shouldShowSpinner: false
    });

});
parcelRegister("9v4Gk", function(module, exports) {

let $6eaaa3fad53fd2b9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6eaaa3fad53fd2b9$var$load("92gV4").then(()=>parcelRequire('hTI3Y'));

});

parcelRegister("8Nnts", function(module, exports) {

let $66751bca9fd8cf95$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $66751bca9fd8cf95$var$load("h2MrD"),
    $66751bca9fd8cf95$var$load("bYT2S"),
    $66751bca9fd8cf95$var$load("hbHCQ")
]).then(()=>parcelRequire('jMqXq'));

});



parcelRegister("e04XT", function(module, exports) {

$parcel$export(module.exports, "eocOverviewRouteEntry", () => $df54ba0aea7ee8de$export$f1a859c727c30be4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $bh0Pj = parcelRequire("bh0Pj");

var $7NszV = parcelRequire("7NszV");

var $5OcAv = parcelRequire("5OcAv");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $bDEHF = parcelRequire("bDEHF");

var $eZXFU = parcelRequire("eZXFU");

var $9FJ7w = parcelRequire("9FJ7w");
const $df54ba0aea7ee8de$export$f1a859c727c30be4 = (0, $7NszV.createEntry)((0, $bDEHF.eocOverviewRoute), ()=>({
        group: 'eoc',
        component: (0, $9FJ7w.EocOverviewComponent),
        layout: (0, $eZXFU.opsMigrationHubLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $5OcAv.getTeamsResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME,
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsOverviewNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bh0Pj.LazyHorizontalOperationsOverviewNav),
            (0, $9FJ7w.LazyOverviewPage)
        ]
    }));

});
parcelRegister("bDEHF", function(module, exports) {

$parcel$export(module.exports, "eocOverviewRoute", () => $82d2d783c671586e$export$cb929d46451a5c12);
const $82d2d783c671586e$export$cb929d46451a5c12 = {
    name: 'eoc-overview',
    path: '/jira/ops/overview',
    exact: true
};

});


parcelRegister("hGFnn", function(module, exports) {

$parcel$export(module.exports, "eocPermissionsRouteEntry", () => $b9f5341ba0d7de14$export$c2ced436a30c60dc);

var $h0OXF = parcelRequire("h0OXF");

var $ba5IO = parcelRequire("ba5IO");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $1N8g8 = parcelRequire("1N8g8");

var $haBWo = parcelRequire("haBWo");
const $b9f5341ba0d7de14$export$c2ced436a30c60dc = (0, $7NszV.createEntry)((0, $1N8g8.eocPermissionsRoute), ()=>({
        group: 'eoc',
        component: (0, $haBWo.default),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // pageAccessResource should be defined before memberRolesResources since they depend on it
            (0, $h0OXF.pageAccessResource),
            ...(0, $h0OXF.resources)(),
            ...(0, $ba5IO.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $haBWo.LazyMemberRoles),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("h0OXF", function(module, exports) {

$parcel$export(module.exports, "pageAccessResource", () => $a460eb2054ccc8f8$export$b0d36f8262140e35);
$parcel$export(module.exports, "memberRolesResource", () => $a460eb2054ccc8f8$export$5c4885c1f1a535b);
$parcel$export(module.exports, "getTeamResource", () => $a460eb2054ccc8f8$export$50271c9e7f21f10e);
$parcel$export(module.exports, "customTeamRolesResource", () => $a460eb2054ccc8f8$export$ed1eb48699cf7893);
$parcel$export(module.exports, "resources", () => $a460eb2054ccc8f8$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $gtuj9 = parcelRequire("gtuj9");
var $9dX4l = parcelRequire("9dX4l");

var $4VIzr = parcelRequire("4VIzr");
const $a460eb2054ccc8f8$var$mapStatus = (status, userAccessLevel)=>{
    if (userAccessLevel === 'INTERNAL_INACTIVE') return 'suspended';
    if (status === 'REQUEST_ACCESS' || status === 'DENIED_REQUEST_EXISTS' || status === 'FORBIDDEN' || status === 'DIRECT_ACCESS') return 'invite';
    if (status === 'ACCESS_EXISTS') return 'member';
    if (status === 'PENDING_REQUEST_EXISTS') return 'pending';
    if (status === '' || status === undefined) return 'member';
    return 'invite';
};
const $a460eb2054ccc8f8$var$checkPageAccessRightsOnRouteDependency = async (dependencies)=>{
    let isAuthorizedToSeeMemberRolesPage = false;
    if (dependencies[$a460eb2054ccc8f8$var$PAGE_ACCESS_RESOURCE_TYPE]) {
        const data = await dependencies[$a460eb2054ccc8f8$var$PAGE_ACCESS_RESOURCE_TYPE].promise;
        isAuthorizedToSeeMemberRolesPage = data?.productOrTeamAdmin;
    }
    return isAuthorizedToSeeMemberRolesPage;
};
const $a460eb2054ccc8f8$var$PAGE_ACCESS_RESOURCE_TYPE = 'pageAccessResource';
const $a460eb2054ccc8f8$export$b0d36f8262140e35 = (0, $2M1hQ.createResource)({
    type: $a460eb2054ccc8f8$var$PAGE_ACCESS_RESOURCE_TYPE,
    getKey: ()=>'pageAccessResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $gtuj9.assert)(!!teamId, new (0, $9dX4l.AssertionError)('pageAccessResource', 'teamId should be set to fetch page access'));
        return (0, $4VIzr.getMemberRolesPageAccess)(teamId);
    },
    isBrowserOnly: true
});
const $a460eb2054ccc8f8$export$5c4885c1f1a535b = (0, $2M1hQ.createResource)({
    type: 'memberRolesResource',
    getKey: ()=>'memberRolesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        const dependencies = routerContext.dependencies;
        (0, $gtuj9.assert)(!!teamId, new (0, $9dX4l.AssertionError)('memberRolesResource', 'teamId should be set to fetch member-roles'));
        const isAuthorizedToSeeMemberRolesPage = await $a460eb2054ccc8f8$var$checkPageAccessRightsOnRouteDependency(dependencies);
        if (!isAuthorizedToSeeMemberRolesPage) return null;
        const gqlResponse = await (0, $4VIzr.getMembers)(teamId);
        const members = gqlResponse?.data.team?.teamV2.members.edges.map((edge)=>edge.node.member) || [];
        const memberRoleResponse = await (0, $4VIzr.getRoleAndJSMLicenseInfoEndpoint)({
            platformTeamId: teamId,
            accountIds: members.map((member)=>member.accountId)
        });
        const teamMembers = members.map((user)=>{
            const userWithRole = memberRoleResponse.teamMembers.find((userWithRole)=>userWithRole.accountId === user.accountId);
            return {
                ...user,
                role: userWithRole?.roleId || 'user',
                jsmLicense: userWithRole?.jsmLicense || false,
                jiraAdmin: userWithRole?.jiraAdmin || false,
                invitationStatus: 'member'
            };
        });
        const membersWithoutJSMLicense = teamMembers.filter((teamMembers)=>!teamMembers.jsmLicense);
        if (!membersWithoutJSMLicense.length) return teamMembers;
        const accountIds = membersWithoutJSMLicense.map((member)=>member.accountId).join(',');
        try {
            const { embeddedValue: embeddedValue } = await (0, $4VIzr.getJSMInvitationStatusInfoEndpoint)({
                accountIds: accountIds
            });
            return teamMembers.map((user)=>{
                const userWithInvitationStatus = embeddedValue.find((userWithInvitationStatus)=>userWithInvitationStatus.accountId === user.accountId);
                return {
                    ...user,
                    invitationStatus: $a460eb2054ccc8f8$var$mapStatus(userWithInvitationStatus?.accessMode, userWithInvitationStatus?.userAccessLevel)
                };
            });
        } catch  {
            return teamMembers;
        }
    },
    isBrowserOnly: true,
    depends: [
        $a460eb2054ccc8f8$var$PAGE_ACCESS_RESOURCE_TYPE
    ]
});
const $a460eb2054ccc8f8$export$50271c9e7f21f10e = (0, $2M1hQ.createResource)({
    type: 'getTeamResource',
    getKey: ()=>'getTeamResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $gtuj9.assert)(!!teamId, new (0, $9dX4l.AssertionError)('getTeamResource', 'teamId should be set to fetch team info on member roles'));
        return (0, $4VIzr.getTeam)(teamId);
    },
    isBrowserOnly: true
});
const $a460eb2054ccc8f8$export$ed1eb48699cf7893 = (0, $2M1hQ.createResource)({
    type: 'customTeamRolesResource',
    getKey: ()=>'customRolesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        const dependencies = routerContext.dependencies;
        (0, $gtuj9.assert)(!!teamId, new (0, $9dX4l.AssertionError)('customTeamRolesResource', 'teamId should be set to fetch custom-team-roles'));
        const isAuthorizedToSeeMemberRolesPage = await $a460eb2054ccc8f8$var$checkPageAccessRightsOnRouteDependency(dependencies);
        if (!isAuthorizedToSeeMemberRolesPage) return null;
        return (0, $4VIzr.getCustomTeamRolesEndpoint)(teamId);
    },
    isBrowserOnly: true,
    depends: [
        $a460eb2054ccc8f8$var$PAGE_ACCESS_RESOURCE_TYPE
    ]
});
const $a460eb2054ccc8f8$export$bc99aaabaf7b70a7 = ()=>[
        $a460eb2054ccc8f8$export$5c4885c1f1a535b,
        $a460eb2054ccc8f8$export$50271c9e7f21f10e,
        $a460eb2054ccc8f8$export$ed1eb48699cf7893
    ];

});
parcelRegister("4VIzr", function(module, exports) {

$parcel$export(module.exports, "getMembers", () => $697ee495d35f96ac$export$f4931e6f9feb30c5);
$parcel$export(module.exports, "getMemberRolesPageAccess", () => $697ee495d35f96ac$export$95d4c4e762437fdd);
$parcel$export(module.exports, "getRoleAndJSMLicenseInfoEndpoint", () => $697ee495d35f96ac$export$38ab389cb64a5000);
$parcel$export(module.exports, "getJSMInvitationStatusInfoEndpoint", () => $697ee495d35f96ac$export$fd43007da8683026);
$parcel$export(module.exports, "getTeam", () => $697ee495d35f96ac$export$491fe77f22ab2b51);
$parcel$export(module.exports, "getCustomTeamRolesEndpoint", () => $697ee495d35f96ac$export$ebfa293eb1ef42f5);

var $fHpHg = parcelRequire("fHpHg");

var $d9Cgl = parcelRequire("d9Cgl");
var $he0mL = parcelRequire("he0mL");
const $697ee495d35f96ac$var$operationName = 'memberRolesTeamMembersQuery';
const $697ee495d35f96ac$export$f4931e6f9feb30c5 = (teamId)=>{
    const queryUrl = '/gateway/api/graphql';
    const teamAri = `ari:cloud:identity::team/${teamId}`;
    const siteId = (0, $he0mL.getMeta)('ajs-cloud-id');
    const membersQueryV2 = `query memberRolesTeamMembersQuery($teamId: ID!, $siteId: String!) {
		team {
			teamV2 (id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
				id
				members ${(0, $fHpHg.fg)('platform_increase_limit_of_members_query') ? '(first: 300)' : ''}{
					edges {
						cursor
						node {
							member  {
								... on AtlassianAccountUser {
									email
								}
								name
								picture
								accountId
								accountStatus
							}
							state
							role
						}
					}
				}
			}
		}
	}
	`;
    return (0, $d9Cgl.eocFetch)(queryUrl, {
        method: 'POST',
        body: JSON.stringify({
            operationName: $697ee495d35f96ac$var$operationName,
            query: membersQueryV2,
            variables: {
                teamId: teamAri,
                siteId: siteId
            }
        }),
        headers: {
            'Content-Type': 'application/json',
            'X-ExperimentalApi': 'teams-beta, team-members-beta'
        },
        exactUrl: true
    });
};
const $697ee495d35f96ac$export$95d4c4e762437fdd = (teamId)=>(0, $d9Cgl.eocFetch)(`/v1/teams/members/member-roles-page-access?platformTeamId=${teamId}`);
const $697ee495d35f96ac$export$38ab389cb64a5000 = ({ platformTeamId: platformTeamId, accountIds: accountIds })=>(0, $d9Cgl.eocFetch)(`/v1/teams/members`, {
        method: 'POST',
        body: {
            platformTeamId: platformTeamId,
            accountIds: accountIds
        }
    });
const $697ee495d35f96ac$export$fd43007da8683026 = ({ accountIds: accountIds })=>(0, $d9Cgl.eocFetch)(`/v1/users/access-request-capabilities?accountIds=${accountIds}`, {
        method: 'GET'
    });
const $697ee495d35f96ac$export$491fe77f22ab2b51 = (teamId)=>(0, $d9Cgl.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    });
const $697ee495d35f96ac$export$ebfa293eb1ef42f5 = (platformTeamId)=>(0, $d9Cgl.eocFetch)(`/v1/teams/${platformTeamId}/roles`);

});


parcelRegister("1N8g8", function(module, exports) {

$parcel$export(module.exports, "eocPermissionsRoute", () => $a690bc071b9eec32$export$8e6afd724de3be6e);
const $a690bc071b9eec32$export$8e6afd724de3be6e = {
    name: 'eoc-permissions',
    path: '/jira/ops/teams/:teamId/settings',
    exact: true
};

});

parcelRegister("haBWo", function(module, exports) {

$parcel$export(module.exports, "LazyMemberRoles", () => $54e18f7965bed61c$export$27b4fb95241ab47);
$parcel$export(module.exports, "default", () => $54e18f7965bed61c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $54e18f7965bed61c$export$27b4fb95241ab47 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("dJFME")), {
    moduleId: "./src/packages/eoc/member-roles/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$54e18f7965bed61c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $54e18f7965bed61c$export$27b4fb95241ab47,
        pageId: "async-jira-eoc-member-roles",
        shouldShowSpinner: false
    });

});
parcelRegister("dJFME", function(module, exports) {

let $9fffe3b762a42abe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9fffe3b762a42abe$var$load("gZDDu").then(()=>parcelRequire('6Zxu7'));

});



parcelRegister("iTGOF", function(module, exports) {

$parcel$export(module.exports, "alertPoliciesRouteEntry", () => $1722f4808fc919d6$export$eb1e2324ca2031e2);

var $iYYTw = parcelRequire("iYYTw");

var $ba5IO = parcelRequire("ba5IO");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $ep3S0 = parcelRequire("ep3S0");

var $jyzx5 = parcelRequire("jyzx5");
const $1722f4808fc919d6$export$eb1e2324ca2031e2 = (0, $7NszV.createEntry)((0, $ep3S0.alertPoliciesRoute), ()=>({
        group: 'eoc',
        component: (0, $jyzx5.AlertPoliciesComponent),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $iYYTw.resources)(),
            ...(0, $ba5IO.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jyzx5.LazyAlertPolicies),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("iYYTw", function(module, exports) {

$parcel$export(module.exports, "teamPolicyResource", () => $f554f09a11ae2462$export$10d7fa513f08ef83);
$parcel$export(module.exports, "notificationPolicyResource", () => $f554f09a11ae2462$export$6d5f23d9118ad678);
$parcel$export(module.exports, "globalPolicyResource", () => $f554f09a11ae2462$export$7aed80da979a5112);
$parcel$export(module.exports, "resources", () => $f554f09a11ae2462$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $7tmLL = parcelRequire("7tmLL");
const $f554f09a11ae2462$export$10d7fa513f08ef83 = (0, $2M1hQ.createResource)({
    type: 'teamPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-policy/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        // if there is no teamId, this means that we are on the global policy page.
        // so we can return null directly, instead of sending fetch request.
        if (!teamId) return null;
        return (0, $7tmLL.getTeamPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $f554f09a11ae2462$export$6d5f23d9118ad678 = (0, $2M1hQ.createResource)({
    type: 'notificationPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `notification-policy/${teamId}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        if (!teamId) return;
        return (0, $7tmLL.getNotificationPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $f554f09a11ae2462$export$7aed80da979a5112 = (0, $2M1hQ.createResource)({
    type: 'globalPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        if (teamId) return `global-policy/${teamId}`;
        return 'global-policy';
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $7tmLL.getGlobalPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $f554f09a11ae2462$export$4cb385c2db8b1e99 = (0, $2M1hQ.createResource)({
    type: 'policyMaintenanceRightsResource',
    getKey: ()=>'policy-maintenance-rights-resource',
    getData: async ()=>{
        return (0, $7tmLL.getPolicyMaintenanceRights)();
    },
    isBrowserOnly: true
});
const $f554f09a11ae2462$export$bc99aaabaf7b70a7 = ()=>[
        $f554f09a11ae2462$export$10d7fa513f08ef83,
        $f554f09a11ae2462$export$7aed80da979a5112,
        $f554f09a11ae2462$export$4cb385c2db8b1e99,
        $f554f09a11ae2462$export$6d5f23d9118ad678
    ];

});
parcelRegister("7tmLL", function(module, exports) {

$parcel$export(module.exports, "getTeamPolicies", () => $22a23960c8e6ed4d$export$fead0944caa1c797);
$parcel$export(module.exports, "getGlobalPolicies", () => $22a23960c8e6ed4d$export$17fc7fbef061a8c3);
$parcel$export(module.exports, "getNotificationPolicies", () => $22a23960c8e6ed4d$export$342525d9423e55ad);
$parcel$export(module.exports, "getPolicyMaintenanceRights", () => $22a23960c8e6ed4d$export$f630cbf5586dce0a);
$parcel$export(module.exports, "updateUIPreferenceEndpoint", () => $22a23960c8e6ed4d$export$6a437b43ab11275d);
$parcel$export(module.exports, "changePolicyOrderEndpoint", () => $22a23960c8e6ed4d$export$57186d786c96b52a);
$parcel$export(module.exports, "enablePolicyEndpoint", () => $22a23960c8e6ed4d$export$6fecd226d8e55346);
$parcel$export(module.exports, "disablePolicyEndpoint", () => $22a23960c8e6ed4d$export$8c0cd218e00b7d9b);
$parcel$export(module.exports, "deletePolicyEndpoint", () => $22a23960c8e6ed4d$export$f9feac6c1dcc516f);
$parcel$export(module.exports, "createPolicyEndpoint", () => $22a23960c8e6ed4d$export$b0108c51b962e788);
$parcel$export(module.exports, "updatePolicyEndpoint", () => $22a23960c8e6ed4d$export$8eabce250a2dd205);

var $d9Cgl = parcelRequire("d9Cgl");
const $22a23960c8e6ed4d$export$fead0944caa1c797 = (teamId)=>{
    return (0, $d9Cgl.eocFetch)(`/v1/teams/${teamId}/policies?type=alert`);
};
const $22a23960c8e6ed4d$export$17fc7fbef061a8c3 = (teamId)=>{
    if (teamId) return (0, $d9Cgl.eocFetch)(`/v1/alerts/policies?preferredUITeamId=${teamId}`);
    return (0, $d9Cgl.eocFetch)(`/v1/alerts/policies`);
};
const $22a23960c8e6ed4d$export$342525d9423e55ad = (teamId)=>{
    return (0, $d9Cgl.eocFetch)(`/v1/teams/${teamId}/policies?type=notification`);
};
const $22a23960c8e6ed4d$export$f630cbf5586dce0a = ()=>{
    return (0, $d9Cgl.eocFetch)(`/v1/alerts/ui-preferences/policy-maintenance-rights`);
};
const $22a23960c8e6ed4d$export$6a437b43ab11275d = ({ teamId: teamId, ...payload })=>{
    let url = `/v1/alerts/ui-preferences/policies`;
    if (teamId) url = `${url}?teamId=${teamId}`;
    return (0, $d9Cgl.eocFetch)(url, {
        method: 'PATCH',
        body: payload,
        responseType: 'headers'
    });
};
const $22a23960c8e6ed4d$export$57186d786c96b52a = (payload)=>{
    return (0, $d9Cgl.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/order`, {
        method: 'PATCH',
        body: {
            after: payload.after
        },
        responseType: 'headers'
    });
};
const $22a23960c8e6ed4d$export$6fecd226d8e55346 = (payload)=>{
    return (0, $d9Cgl.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/enable`, {
        method: 'POST',
        responseType: 'headers'
    });
};
const $22a23960c8e6ed4d$export$8c0cd218e00b7d9b = (payload)=>{
    return (0, $d9Cgl.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/disable`, {
        method: 'POST',
        responseType: 'headers'
    });
};
const $22a23960c8e6ed4d$export$f9feac6c1dcc516f = (payload)=>{
    return (0, $d9Cgl.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};
const $22a23960c8e6ed4d$export$b0108c51b962e788 = (payload)=>{
    return (0, $d9Cgl.eocFetch)(`/v1/teams/${payload.teamId}/policies`, {
        method: 'POST',
        body: payload
    });
};
const $22a23960c8e6ed4d$export$8eabce250a2dd205 = (payload)=>{
    return (0, $d9Cgl.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
        method: 'PUT',
        body: payload
    });
};

});


parcelRegister("ep3S0", function(module, exports) {

$parcel$export(module.exports, "alertPoliciesRoute", () => $5c0bbcca2f2afa78$export$eab7ea9e54b67f16);
const $5c0bbcca2f2afa78$export$eab7ea9e54b67f16 = {
    name: 'eoc-team-policies',
    path: '/jira/ops/teams/:teamId/policies',
    exact: true
};

});

parcelRegister("jyzx5", function(module, exports) {

$parcel$export(module.exports, "LazyAlertPolicies", () => $d64c9c110834b4a3$export$3079046c31ee50f7);
$parcel$export(module.exports, "AlertPoliciesComponent", () => $d64c9c110834b4a3$export$882bdfb7e45bd440);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $d64c9c110834b4a3$export$3079046c31ee50f7 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("lwB0K")), {
    moduleId: "./src/packages/eoc/policies/src/index.tsx"
});
const $d64c9c110834b4a3$export$882bdfb7e45bd440 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d64c9c110834b4a3$export$3079046c31ee50f7,
        pageId: "async-jira-eoc-alert-policies",
        shouldShowSpinner: false
    });

});
parcelRegister("lwB0K", function(module, exports) {

let $fab94bc1de9c33f2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fab94bc1de9c33f2$var$load("h2MrD"),
    $fab94bc1de9c33f2$var$load("bYT2S"),
    $fab94bc1de9c33f2$var$load("d7ZnT")
]).then(()=>parcelRequire('3IgJn'));

});



parcelRegister("adI0E", function(module, exports) {

$parcel$export(module.exports, "globalPoliciesRouteEntry", () => $26e6da78b3e43e9c$export$2ee2f43d380cc210);

var $iYYTw = parcelRequire("iYYTw");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $eZXFU = parcelRequire("eZXFU");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $1OKmH = parcelRequire("1OKmH");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $jyzx5 = parcelRequire("jyzx5");
const $26e6da78b3e43e9c$var$getNavigationSpecifications = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $26e6da78b3e43e9c$export$2ee2f43d380cc210 = (0, $7NszV.createEntry)((0, $1OKmH.globalPoliciesRoute), ()=>({
        group: 'eoc',
        component: (0, $jyzx5.AlertPoliciesComponent),
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $iYYTw.resources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$26e6da78b3e43e9c$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jyzx5.LazyAlertPolicies)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jyzx5.LazyAlertPolicies)
        ]
    }));

});
parcelRegister("1OKmH", function(module, exports) {

$parcel$export(module.exports, "globalPoliciesRoute", () => $a0dbfcfca37c6909$export$4eb24a8e860a3df7);
const $a0dbfcfca37c6909$export$4eb24a8e860a3df7 = {
    name: 'eoc-policies',
    path: '/jira/settings/products/ops/policies',
    exact: true
};

});


parcelRegister("dQtRM", function(module, exports) {

$parcel$export(module.exports, "eocGlobalReportsHomePageNav4RouteEntry", () => $d53f4be60f857b27$export$193586b163d4afae);

var $7Dwp8 = parcelRequire("7Dwp8");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $70Icy = parcelRequire("70Icy");

var $eZXFU = parcelRequire("eZXFU");

var $5GbXG = parcelRequire("5GbXG");
const $d53f4be60f857b27$export$193586b163d4afae = (0, $7NszV.createEntry)((0, $70Icy.eocGlobalReportsHomePageNav4Route), ()=>({
        group: 'eoc',
        component: (0, $5GbXG.OpsReportsRedirect),
        layout: (0, $eZXFU.opsMigrationHubLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $7Dwp8.resources)(),
            (0, $7Dwp8.opsReportsPermissionResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default)
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5GbXG.LazyOpsReportsRedirect),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("7Dwp8", function(module, exports) {

$parcel$export(module.exports, "opsReportsResource", () => $be1b0b17fe007241$export$8498311fc7a4ab48);
$parcel$export(module.exports, "opsReportsPermissionResource", () => $be1b0b17fe007241$export$c432f280d76e2acf);
$parcel$export(module.exports, "resources", () => $be1b0b17fe007241$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $gtuj9 = parcelRequire("gtuj9");
var $9dX4l = parcelRequire("9dX4l");

var $9srN5 = parcelRequire("9srN5");

var $aeJSp = parcelRequire("aeJSp");
const $be1b0b17fe007241$export$8498311fc7a4ab48 = (0, $2M1hQ.createResource)({
    type: 'opsReportsResource',
    getKey: ()=>'opsReportsResource',
    getData: async ()=>{
        const settings = await (0, $aeJSp.getReportSettings)();
        const api = (0, $aeJSp.getDashboards);
        return {
            settings: settings,
            dashboards: settings.showReportingMaintenance ? null : await api()
        };
    },
    maxAge: Infinity,
    isBrowserOnly: true
});
const $be1b0b17fe007241$export$c432f280d76e2acf = (0, $2M1hQ.createResource)({
    type: 'opsReportsPermissionResource',
    getKey: ({ match: match })=>{
        return `opsReportsPermissionResource-${match.params?.teamId}`;
    },
    getData: async (routerContext)=>{
        const isTeamDashboard = (0, $9srN5.isTeamReportsUrl)(routerContext.match.url);
        const teamId = routerContext.match.params?.teamId;
        (0, $gtuj9.assert)(!isTeamDashboard || !!teamId, new (0, $9dX4l.AssertionError)('opsReportsPermissionResource', 'teamId should be set to fetch reports permissions on TeamDashboard page'));
        return (0, $aeJSp.getReportRights)(teamId);
    },
    isBrowserOnly: true,
    maxAge: Infinity
});
const $be1b0b17fe007241$export$bc99aaabaf7b70a7 = ()=>[
        $be1b0b17fe007241$export$8498311fc7a4ab48,
        $be1b0b17fe007241$export$c432f280d76e2acf
    ];

});
parcelRegister("9srN5", function(module, exports) {

$parcel$export(module.exports, "withReportingPrefix", () => $e99026cd1f29d3e1$export$c0f073d636267c44);
$parcel$export(module.exports, "isTeamReportsUrl", () => $e99026cd1f29d3e1$export$f923ac475871fcad);

var $he0mL = parcelRequire("he0mL");
function $e99026cd1f29d3e1$export$c0f073d636267c44(input) {
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = (0, $he0mL.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jsm/ops/reporting/cloudId/${cloudId}/api` + input;
    return input;
}
const $e99026cd1f29d3e1$export$f923ac475871fcad = (pathName)=>pathName.startsWith('/jira/ops/teams/');

});

parcelRegister("aeJSp", function(module, exports) {

$parcel$export(module.exports, "getDashboards", () => $01b7612a0e0a00aa$export$8e4b6d6c4fec08f3);
$parcel$export(module.exports, "getReportSettings", () => $01b7612a0e0a00aa$export$9114b8a872caf5d8);
$parcel$export(module.exports, "getSsoEmbedUrlEndpoint", () => $01b7612a0e0a00aa$export$8384a95746267bd8);
$parcel$export(module.exports, "getReportRights", () => $01b7612a0e0a00aa$export$f4a61c3c8c619f12);
$parcel$export(module.exports, "getAVPEmbedTokens", () => $01b7612a0e0a00aa$export$fb46892f83504a42);

var $d9Cgl = parcelRequire("d9Cgl");

var $9srN5 = parcelRequire("9srN5");

var $h5bpV = parcelRequire("h5bpV");
const $01b7612a0e0a00aa$export$8e4b6d6c4fec08f3 = ()=>(0, $d9Cgl.eocFetch)((0, $9srN5.withReportingPrefix)('/v5/reports/dashboards'), {
        exactUrl: true,
        errorTransformer: $h5bpV.opsReportsErrorTransformer
    });
const $01b7612a0e0a00aa$export$e69121e90ce0231b = ()=>(0, $d9Cgl.eocFetch)((0, $9srN5.withReportingPrefix)('/v3/reports/dashboards'), {
        exactUrl: true,
        errorTransformer: $h5bpV.opsReportsErrorTransformer
    });
const $01b7612a0e0a00aa$export$9114b8a872caf5d8 = ()=>(0, $d9Cgl.eocFetch)((0, $9srN5.withReportingPrefix)('/v3/reports/index'), {
        exactUrl: true,
        errorTransformer: $h5bpV.opsReportsErrorTransformer
    });
const $01b7612a0e0a00aa$export$8384a95746267bd8 = (isDarkMode, dashboardId, teamId)=>{
    const queryParam = teamId ? {
        theme: isDarkMode ? 'DarkMode' : '',
        dashboardId: dashboardId,
        teamId: teamId,
        // Adding time as queryParam to avoid browser caching
        // Should ideally be handled by "Cache-Control" header from server
        _: Date.now().toString()
    } : {
        theme: isDarkMode ? 'DarkMode' : '',
        dashboardId: dashboardId,
        _: Date.now().toString()
    };
    const url = `/v3/reports/dashboard?${new URLSearchParams(queryParam).toString()}`;
    return (0, $d9Cgl.eocFetch)((0, $9srN5.withReportingPrefix)(url), {
        exactUrl: true,
        errorTransformer: $h5bpV.opsReportsErrorTransformer
    });
};
const $01b7612a0e0a00aa$export$f4a61c3c8c619f12 = (teamId)=>{
    let url = '/v3/reports/rights';
    if (teamId) url += `?teamId=${teamId}`;
    return (0, $d9Cgl.eocFetch)((0, $9srN5.withReportingPrefix)(url), {
        exactUrl: true,
        errorTransformer: $h5bpV.opsReportsErrorTransformer
    });
};
const $01b7612a0e0a00aa$export$fb46892f83504a42 = (dashboardId, teamId)=>{
    let url = '/v3/reports/embed-token';
    return (0, $d9Cgl.eocFetch)((0, $9srN5.withReportingPrefix)(url), {
        exactUrl: true,
        method: 'POST',
        body: {
            dashboardId: dashboardId,
            teamId: teamId
        },
        errorTransformer: $h5bpV.opsReportsErrorTransformer
    });
};

});
parcelRegister("h5bpV", function(module, exports) {

$parcel$export(module.exports, "opsReportsErrorTransformer", () => $d0adff3e8ea166b0$export$b170750bd4489531);

var $ig9cG = parcelRequire("ig9cG");
const $d0adff3e8ea166b0$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8)|("ISO-8859-1")|(ISO-8859-1))))/i;
const $d0adff3e8ea166b0$export$b170750bd4489531 = (e)=>{
    if ((0, $ig9cG.isHTTPError)(e)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $d0adff3e8ea166b0$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $ig9cG.StreamedHTTPError)(e, data, data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $ig9cG.StreamedHTTPError)(e, message, message));
    }
    return e;
};

});



parcelRegister("70Icy", function(module, exports) {

$parcel$export(module.exports, "eocGlobalReportsHomePageNav4Route", () => $a80c4e46a4046a66$export$e7c62a288f7d3a11);
const $a80c4e46a4046a66$export$e7c62a288f7d3a11 = {
    name: 'eoc-global-reports',
    path: '/jira/ops/reports',
    exact: true
};

});

parcelRegister("5GbXG", function(module, exports) {

$parcel$export(module.exports, "LazyOpsReports", () => $cba1f7031d59cee6$export$2404f0e35deca592);
$parcel$export(module.exports, "LazyOpsReportsRedirect", () => $cba1f7031d59cee6$export$d33ea1a773b744e);
$parcel$export(module.exports, "LazyGlobalOpsReports", () => $cba1f7031d59cee6$export$66850ec5549adba6);
$parcel$export(module.exports, "LazyOpsReportsUnsubscribe", () => $cba1f7031d59cee6$export$5fd77c3bbfb22cbd);
$parcel$export(module.exports, "OpsReportsRedirect", () => $cba1f7031d59cee6$export$22253dbadb46d0cf);
$parcel$export(module.exports, "GlobalOpsReports", () => $cba1f7031d59cee6$export$648ddf2d1f8b1c3f);
$parcel$export(module.exports, "OpsReports", () => $cba1f7031d59cee6$export$87e6a54b4f5dc91e);
$parcel$export(module.exports, "OpsReportsUnsubscribe", () => $cba1f7031d59cee6$export$7f366d77015c286f);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $cba1f7031d59cee6$export$2404f0e35deca592 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("k4RM2")), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $cba1f7031d59cee6$export$d33ea1a773b744e = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("k4RM2")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $cba1f7031d59cee6$export$66850ec5549adba6 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("k4RM2")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $cba1f7031d59cee6$export$5fd77c3bbfb22cbd = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("k4RM2")).then((exportedMembers)=>exportedMembers.OpsReportsUnsubscribe), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});
const $cba1f7031d59cee6$export$22253dbadb46d0cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cba1f7031d59cee6$export$d33ea1a773b744e,
        pageId: "async-jira-eoc-ops-reports-redirect",
        shouldShowSpinner: false
    });
const $cba1f7031d59cee6$export$648ddf2d1f8b1c3f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cba1f7031d59cee6$export$66850ec5549adba6,
        pageId: "async-jira-eoc-global-ops-reports",
        shouldShowSpinner: false
    });
const $cba1f7031d59cee6$export$87e6a54b4f5dc91e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cba1f7031d59cee6$export$2404f0e35deca592,
        pageId: "async-jira-eoc-ops-reports",
        shouldShowSpinner: false
    });
const $cba1f7031d59cee6$export$7f366d77015c286f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cba1f7031d59cee6$export$5fd77c3bbfb22cbd,
        pageId: "async-jira-eoc-ops-reports-unsubscribe",
        shouldShowSpinner: false
    });

});
parcelRegister("k4RM2", function(module, exports) {

let $e9dde4b8714e8bc7$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("1I1Wy"), 4)),
    $e9dde4b8714e8bc7$var$load("h2MrD"),
    $e9dde4b8714e8bc7$var$load("bYT2S"),
    $e9dde4b8714e8bc7$var$load("cM9em"),
    $e9dde4b8714e8bc7$var$load("fr9NE"),
    $e9dde4b8714e8bc7$var$load("4Hqzh")
]).then(()=>parcelRequire('eHCOd'));

});



parcelRegister("iDxTp", function(module, exports) {

$parcel$export(module.exports, "eocGlobalReportsNav4RouteEntry", () => $1fb5a93b84172f00$export$90a73fe101848dd);

var $7Dwp8 = parcelRequire("7Dwp8");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $7ABBf = parcelRequire("7ABBf");

var $5GbXG = parcelRequire("5GbXG");
const $1fb5a93b84172f00$export$90a73fe101848dd = (0, $7NszV.createEntry)((0, $7ABBf.eocGlobalReportsNav4Route), ()=>({
        group: 'eoc',
        component: (0, $5GbXG.GlobalOpsReports),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $7Dwp8.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5GbXG.LazyGlobalOpsReports)
        ]
    }));

});
parcelRegister("7ABBf", function(module, exports) {

$parcel$export(module.exports, "eocGlobalReportsNav4Route", () => $4c6718ca5b31c262$export$2344cc35fd2eff4e);
const $4c6718ca5b31c262$export$2344cc35fd2eff4e = {
    name: 'eoc-global-report-dashboard',
    path: '/jira/ops/reports/:dashboardId',
    exact: true
};

});


parcelRegister("bAN0d", function(module, exports) {

$parcel$export(module.exports, "eocReportsTeamRedirectRouteEntry", () => $8d76deaec1999545$export$c5606e8eeca32c0f);

var $7Dwp8 = parcelRequire("7Dwp8");

var $ba5IO = parcelRequire("ba5IO");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $8mgka = parcelRequire("8mgka");

var $5GbXG = parcelRequire("5GbXG");
const $8d76deaec1999545$export$c5606e8eeca32c0f = (0, $7NszV.createEntry)((0, $8mgka.eocReportsTeamRedirectRoute), ()=>({
        group: 'eoc',
        component: (0, $5GbXG.OpsReportsRedirect),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ba5IO.resources)(),
            ...(0, $7Dwp8.resources)(),
            (0, $7Dwp8.opsReportsPermissionResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5GbXG.LazyOpsReportsRedirect),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("8mgka", function(module, exports) {

$parcel$export(module.exports, "eocReportsTeamRedirectRoute", () => $4180c49ce19c4186$export$26b0a544e6502d55);
const $4180c49ce19c4186$export$26b0a544e6502d55 = {
    name: 'eoc-reports',
    path: '/jira/ops/teams/:teamId/reports',
    exact: true
};

});


parcelRegister("cLm5J", function(module, exports) {

$parcel$export(module.exports, "eocReportsTeamRouteEntry", () => $7f20eb6c54fad956$export$cd1c1a81e516fec5);

var $7Dwp8 = parcelRequire("7Dwp8");

var $ba5IO = parcelRequire("ba5IO");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $bSLd2 = parcelRequire("bSLd2");

var $5GbXG = parcelRequire("5GbXG");
const $7f20eb6c54fad956$export$cd1c1a81e516fec5 = (0, $7NszV.createEntry)((0, $bSLd2.eocReportsTeamRoute), ()=>({
        group: 'eoc',
        component: (0, $5GbXG.OpsReports),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ba5IO.resources)(),
            ...(0, $7Dwp8.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5GbXG.LazyOpsReports),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("bSLd2", function(module, exports) {

$parcel$export(module.exports, "eocReportsTeamRoute", () => $ffd6c3cc5b5e020a$export$c9e0796615c034f3);
const $ffd6c3cc5b5e020a$export$c9e0796615c034f3 = {
    name: 'eoc-reports-team',
    path: '/jira/ops/teams/:teamId/reports/:dashboardId',
    exact: true
};

});


parcelRegister("dbAmH", function(module, exports) {

$parcel$export(module.exports, "eocReportsUnsubscribeRouteEntry", () => $a7106536ac902eff$export$6e8d112a548528b5);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $gEF2C = parcelRequire("gEF2C");

var $5GbXG = parcelRequire("5GbXG");
const $a7106536ac902eff$export$6e8d112a548528b5 = (0, $7NszV.createEntry)((0, $gEF2C.eocReportsUnsubscribeRoute), ()=>({
        group: 'eoc',
        component: (0, $5GbXG.OpsReportsUnsubscribe),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5GbXG.LazyOpsReportsUnsubscribe)
        ]
    }));

});
parcelRegister("gEF2C", function(module, exports) {

$parcel$export(module.exports, "eocReportsUnsubscribeRoute", () => $491397448b2426d8$export$72cde899ee974e6e);
const $491397448b2426d8$export$72cde899ee974e6e = {
    name: 'eoc-reports-unsubscribe',
    path: '/jira/ops/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};

});


parcelRegister("4Xzif", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationDetailRouteEntry", () => $29aaea7e1c593cdc$export$565325825b04cec6);

var $fdawF = parcelRequire("fdawF");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $8CqQS = parcelRequire("8CqQS");

var $7OghT = parcelRequire("7OghT");

var $k3GMp = parcelRequire("k3GMp");
const $29aaea7e1c593cdc$export$565325825b04cec6 = (0, $7NszV.createEntry)((0, $8CqQS.roleBasedNotificationDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $7OghT.RoleBasedNotificationsComponent),
        layout: (0, $ibkIl.globalSettingsLayout),
        slot: (0, $k3GMp.RoleBasedNotificationDetail),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $fdawF.resources)[0],
            (0, $fdawF.resources)[1],
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        forPaint: [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7OghT.LazyRoleBasedNotifications)
        ]
    }));

});
parcelRegister("fdawF", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationsResource", () => $af2b41da6f50a683$export$9a716bf20d804ec3);
$parcel$export(module.exports, "notificationDetailResource", () => $af2b41da6f50a683$export$8ad8a0a20fd0ed5a);
$parcel$export(module.exports, "resources", () => $af2b41da6f50a683$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $gtuj9 = parcelRequire("gtuj9");
var $9dX4l = parcelRequire("9dX4l");

var $8fR6M = parcelRequire("8fR6M");
const $af2b41da6f50a683$export$9a716bf20d804ec3 = (0, $2M1hQ.createResource)({
    type: 'roleBasedNotificationsResource',
    getKey: ()=>'roleBasedNotificationsResource',
    getData: (0, $8fR6M.getRoleBasedNotificationsEndpoint),
    isBrowserOnly: true,
    maxAge: 300000
});
const $af2b41da6f50a683$export$8ad8a0a20fd0ed5a = (0, $2M1hQ.createResource)({
    type: 'notificationDetailResource',
    getKey: ({ match: match })=>{
        const settingId = match.params['id'];
        return `notificationDetailResource-id=${settingId}`;
    },
    getData: ({ match: match })=>{
        const settingId = match.params['id'];
        (0, $gtuj9.assert)(!!settingId, new (0, $9dX4l.AssertionError)('notificationDetailResource', 'settingId is required'));
        return (0, $8fR6M.getRoleBasedNotificationDetailEndpoint)(settingId);
    },
    isBrowserOnly: true
});
const $af2b41da6f50a683$export$bc99aaabaf7b70a7 = [
    $af2b41da6f50a683$export$9a716bf20d804ec3,
    $af2b41da6f50a683$export$8ad8a0a20fd0ed5a
];

});
parcelRegister("8fR6M", function(module, exports) {

$parcel$export(module.exports, "getRoleBasedNotificationsEndpoint", () => $768144ada353545b$export$db67dfe9fe98cd49);
$parcel$export(module.exports, "getRoleBasedNotificationDetailEndpoint", () => $768144ada353545b$export$5522446e6d3ee73);

var $d9Cgl = parcelRequire("d9Cgl");
const $768144ada353545b$export$db67dfe9fe98cd49 = ()=>(0, $d9Cgl.eocFetch)(`/v1/role-based-notifications`);
const $768144ada353545b$export$5522446e6d3ee73 = (settingId)=>(0, $d9Cgl.eocFetch)(`/v1/role-based-notifications/${settingId}`);

});


parcelRegister("8CqQS", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationDetailRoute", () => $8ff922c499db0d93$export$10ec812f053317c9);
const $8ff922c499db0d93$export$10ec812f053317c9 = {
    name: 'eoc-role-based-notifications-detail',
    path: '/jira/settings/products/ops/role-based-notifications/:id',
    exact: true
};

});

parcelRegister("7OghT", function(module, exports) {

$parcel$export(module.exports, "LazyRoleBasedNotifications", () => $1190c1dcb9a75d0f$export$15a244aba8f3b406);
$parcel$export(module.exports, "RoleBasedNotificationsComponent", () => $1190c1dcb9a75d0f$export$8994be6f8ad6a04a);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $1190c1dcb9a75d0f$export$15a244aba8f3b406 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("gdidc")).then((module)=>module.RoleBasedNotificationsPage), {
    moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
});
const $1190c1dcb9a75d0f$export$8994be6f8ad6a04a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1190c1dcb9a75d0f$export$15a244aba8f3b406,
        pageId: "async-jira-eoc-role-based-notifications",
        shouldShowSpinner: false
    });

});
parcelRegister("gdidc", function(module, exports) {

let $bcdbfcc49021bbc8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $bcdbfcc49021bbc8$var$load("h2MrD"),
    $bcdbfcc49021bbc8$var$load("bYT2S"),
    $bcdbfcc49021bbc8$var$load("hPzOn"),
    $bcdbfcc49021bbc8$var$load("3aNwp")
]).then(()=>parcelRequire('2ddPE'));

});


parcelRegister("k3GMp", function(module, exports) {

$parcel$export(module.exports, "RoleBasedNotificationDetail", () => $89e521226d6aac78$export$445112c3a1089cc5);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $89e521226d6aac78$export$5211e5a7ed694f98 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("gdidc")).then((module)=>module.RoleBasedNotificationDetail), {
    moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
});
const $89e521226d6aac78$export$445112c3a1089cc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $89e521226d6aac78$export$5211e5a7ed694f98,
        pageId: "async-jira-eoc-role-based-notifications",
        shouldShowSpinner: false
    });

});


parcelRegister("7mf3n", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationsRouteEntry", () => $fec308ab1c0618bc$export$60de9875bb8ef1d6);

var $fdawF = parcelRequire("fdawF");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $2bQB3 = parcelRequire("2bQB3");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $7OghT = parcelRequire("7OghT");
const $fec308ab1c0618bc$var$getNavigationSpecifications = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $fec308ab1c0618bc$export$60de9875bb8ef1d6 = (0, $7NszV.createEntry)((0, $2bQB3.roleBasedNotificationsRoute), ()=>({
        group: 'eoc',
        component: (0, $7OghT.RoleBasedNotificationsComponent),
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $fdawF.resources)[0],
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$fec308ab1c0618bc$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7OghT.LazyRoleBasedNotifications)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7OghT.LazyRoleBasedNotifications)
        ]
    }));

});
parcelRegister("2bQB3", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationsRoute", () => $2188ae80315aaff9$export$5a10092825ee32e4);
const $2188ae80315aaff9$export$5a10092825ee32e4 = {
    name: 'eoc-role-based-notifications',
    path: '/jira/settings/products/ops/role-based-notifications',
    exact: true
};

});


parcelRegister("jPcas", function(module, exports) {

$parcel$export(module.exports, "eocScheduleGlobalRouteEntry", () => $8a8ca7bd84166494$export$831e8756cdaae4ba);

var $5uXOq = parcelRequire("5uXOq");

var $cBL3X = parcelRequire("cBL3X");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $4ft8f = parcelRequire("4ft8f");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8a8ca7bd84166494$var$LazyScheduleGlobalPage = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("6wUGW")).then((m)=>m.ScheduleGlobalPage), {
    moduleId: "./src/packages/eoc/schedule-global/src/ui/index.tsx"
});
const $8a8ca7bd84166494$var$EocScheduleGlobalComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8a8ca7bd84166494$var$LazyScheduleGlobalPage,
        pageId: "async-jira-eoc-schedule-global",
        shouldShowSpinner: false
    });
const $8a8ca7bd84166494$var$getNavigationSpecifications = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $8a8ca7bd84166494$export$831e8756cdaae4ba = (0, $7NszV.createEntry)((0, $4ft8f.eocScheduleGlobalRoute), ()=>({
        group: 'eoc',
        component: $8a8ca7bd84166494$var$EocScheduleGlobalComponent,
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $cBL3X.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$8a8ca7bd84166494$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            $8a8ca7bd84166494$var$LazyScheduleGlobalPage
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            $8a8ca7bd84166494$var$LazyScheduleGlobalPage
        ]
    }));

});
parcelRegister("cBL3X", function(module, exports) {

$parcel$export(module.exports, "resources", () => $0d92df590882c101$export$bc99aaabaf7b70a7);

var $6luO8 = parcelRequire("6luO8");

var $jOha3 = parcelRequire("jOha3");
const $0d92df590882c101$export$bc99aaabaf7b70a7 = ()=>[
        (0, $jOha3.getTimezonesResource),
        (0, $jOha3.getTimeTemplatesResource),
        ...(0, $6luO8.eocCommonResources)()
    ];

});

parcelRegister("4ft8f", function(module, exports) {

$parcel$export(module.exports, "eocScheduleGlobalRoute", () => $9844eccd8c34fec5$export$10454dc485142eb6);
const $9844eccd8c34fec5$export$10454dc485142eb6 = {
    name: 'eoc-schedules',
    path: '/jira/settings/products/ops/schedules',
    exact: true
};

});

parcelRegister("6wUGW", function(module, exports) {

let $4c11b4ff6c71ccba$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $4c11b4ff6c71ccba$var$load("h2MrD"),
    $4c11b4ff6c71ccba$var$load("bYT2S"),
    $4c11b4ff6c71ccba$var$load("9nnOd")
]).then(()=>parcelRequire('94AYi'));

});


parcelRegister("k7VEf", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertDetailRouteEntry", () => $0f8c358fa6dbfa33$export$94aaa7006da9d63a);

var $iSEF2 = parcelRequire("iSEF2");

var $ivQlE = parcelRequire("ivQlE");

var $ba5IO = parcelRequire("ba5IO");

var $i5qMw = parcelRequire("i5qMw");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $fnZCh = parcelRequire("fnZCh");

var $cgOQ8 = parcelRequire("cgOQ8");
const $0f8c358fa6dbfa33$export$94aaa7006da9d63a = (0, $7NszV.createEntry)((0, $fnZCh.eocTeamAlertDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $cgOQ8.default),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ba5IO.resources)(),
            ...(0, $ivQlE.resources)(),
            ...(0, $iSEF2.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('automation_discoverability_in_jsm'), (0, $i5qMw.getAutomationDiscoveryDismissResource))
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cgOQ8.LazyAlertList),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("cgOQ8", function(module, exports) {

$parcel$export(module.exports, "LazyAlertList", () => $c4eca2f6e4b2f333$export$f4aafff31d950b6c);
$parcel$export(module.exports, "default", () => $c4eca2f6e4b2f333$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $c4eca2f6e4b2f333$export$f4aafff31d950b6c = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("lTHKb")), {
    moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c4eca2f6e4b2f333$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c4eca2f6e4b2f333$export$f4aafff31d950b6c,
        pageId: "async-jira-eoc-alert-list",
        shouldShowSpinner: false
    });

});


parcelRegister("4yINJ", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertListRouteEntry", () => $f23486e21e430737$export$de37dab3b3ed8e5c);

var $ivQlE = parcelRequire("ivQlE");

var $ba5IO = parcelRequire("ba5IO");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $fH1HX = parcelRequire("fH1HX");

var $cgOQ8 = parcelRequire("cgOQ8");
const $f23486e21e430737$export$de37dab3b3ed8e5c = (0, $7NszV.createEntry)((0, $fH1HX.eocTeamAlertListRoute), ()=>({
        group: 'eoc',
        component: (0, $cgOQ8.default),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ba5IO.resources)(),
            ...(0, $ivQlE.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cgOQ8.LazyAlertList),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("fH1HX", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertListRoute", () => $f402982842ecbfd0$export$94efd60f23d97aa5);
const $f402982842ecbfd0$export$94efd60f23d97aa5 = {
    name: 'eoc-team-alerts',
    path: '/jira/ops/teams/:teamId/alerts',
    exact: true
};

});


parcelRegister("bubms", function(module, exports) {

$parcel$export(module.exports, "eocTeamCustomerLogsDownloadRouteEntry", () => $aca15c3cadc5a7fe$export$d2ce6f09ef8aa840);

var $4qQmy = parcelRequire("4qQmy");

var $ibkIl = parcelRequire("ibkIl");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $6ZSdP = parcelRequire("6ZSdP");

var $8OJXJ = parcelRequire("8OJXJ");
const $aca15c3cadc5a7fe$export$d2ce6f09ef8aa840 = (0, $7NszV.createEntry)((0, $6ZSdP.eocTeamCustomerLogsDownloadRoute), ()=>({
        group: 'eoc',
        component: (0, $8OJXJ.CustomerLogsDownloadPage),
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $4qQmy.downloadResources)()
        ],
        forPaint: [
            (0, $8OJXJ.LazyCustomerLogsDownLoad)
        ]
    }));

});
parcelRegister("6ZSdP", function(module, exports) {

$parcel$export(module.exports, "eocTeamCustomerLogsDownloadRoute", () => $e73c1ac5cb6acb9d$export$678856ccddc0bc05);
const $e73c1ac5cb6acb9d$export$678856ccddc0bc05 = {
    name: 'eoc-team-customer-logs-download',
    path: '/jira/settings/products/ops/jira-service-management-audit-logs/download/:exportUniqueKey',
    exact: true
};

});

parcelRegister("8OJXJ", function(module, exports) {

$parcel$export(module.exports, "LazyCustomerLogs", () => $ff16a0c6b99cd2b6$export$6e30e25faf4f6dce);
$parcel$export(module.exports, "LazyCustomerLogsDownLoad", () => $ff16a0c6b99cd2b6$export$898c7cb3b28a6104);
$parcel$export(module.exports, "default", () => $ff16a0c6b99cd2b6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CustomerLogsDownloadPage", () => $ff16a0c6b99cd2b6$export$a5786cf859b7b457);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $ff16a0c6b99cd2b6$export$6e30e25faf4f6dce = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("e4FZW")), {
    moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
});

const $ff16a0c6b99cd2b6$export$898c7cb3b28a6104 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("e4FZW")).then(({ CustomerLogsDownloadPage: CustomerLogsDownloadPage })=>CustomerLogsDownloadPage), {
    moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ff16a0c6b99cd2b6$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ff16a0c6b99cd2b6$export$6e30e25faf4f6dce,
        pageId: "async-jira-eoc-customer-logs",
        shouldShowSpinner: false
    });
const $ff16a0c6b99cd2b6$export$a5786cf859b7b457 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ff16a0c6b99cd2b6$export$898c7cb3b28a6104,
        pageId: "async-jira-eoc-customer-logs-download",
        shouldShowSpinner: false
    });

});
parcelRegister("e4FZW", function(module, exports) {

let $a3f2045ce874b5cb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a3f2045ce874b5cb$var$load("cVwzB").then(()=>parcelRequire('ecO2s'));

});



parcelRegister("fOrUU", function(module, exports) {

$parcel$export(module.exports, "eocTeamCustomerLogsRouteEntry", () => $82450f458637cd82$export$42ca979ec2919b23);

var $4qQmy = parcelRequire("4qQmy");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dlUF2 = parcelRequire("dlUF2");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $8OJXJ = parcelRequire("8OJXJ");
const $82450f458637cd82$var$getNavigationSpecifications = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $82450f458637cd82$export$42ca979ec2919b23 = (0, $7NszV.createEntry)((0, $dlUF2.eocTeamCustomerLogsRoute), ()=>({
        group: 'eoc',
        component: (0, $8OJXJ.default),
        layout: (0, $eZXFU.opsSettingsLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$82450f458637cd82$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $4qQmy.resources)()
        ],
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8OJXJ.LazyCustomerLogs)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8OJXJ.LazyCustomerLogs)
        ]
    }));

});
parcelRegister("dlUF2", function(module, exports) {

$parcel$export(module.exports, "eocTeamCustomerLogsRoute", () => $3689be50764be7f7$export$4b517044f5f7830d);
const $3689be50764be7f7$export$4b517044f5f7830d = {
    name: 'eoc-team-customer-logs',
    path: '/jira/settings/products/ops/jira-service-management-audit-logs',
    exact: true
};

});


parcelRegister("g6Mf9", function(module, exports) {

$parcel$export(module.exports, "unlockOperationsRouteEntry", () => $10f9f9ad449ec307$export$c058f4d1c0667ce1);

var $ffza4 = parcelRequire("ffza4");

var $iqZds = parcelRequire("iqZds");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $l1EdH = parcelRequire("l1EdH");

var $3RJkv = parcelRequire("3RJkv");

var $1Mqbh = parcelRequire("1Mqbh");

var $3E8Yw = parcelRequire("3E8Yw");
const $10f9f9ad449ec307$export$c058f4d1c0667ce1 = (0, $7NszV.createEntry)((0, $1Mqbh.unlockOperationsRoute), ()=>({
        group: 'eoc',
        layout: (0, $iqZds.eocChangeboardingLayout),
        component: (0, $3E8Yw.default),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $l1EdH.resources)()
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3E8Yw.LazyUnlockOperations)
        ]
    }));

});
parcelRegister("l1EdH", function(module, exports) {

$parcel$export(module.exports, "resources", () => $05907c872dfc2fcc$export$bc99aaabaf7b70a7);

var $ieJ0b = parcelRequire("ieJ0b");

const $05907c872dfc2fcc$export$bc99aaabaf7b70a7 = ()=>[
        (0, $ieJ0b.transitioningDetailsResource)
    ];

});
parcelRegister("ieJ0b", function(module, exports) {

$parcel$export(module.exports, "transitioningDetailsResource", () => $86a5b96e0cefda11$export$850d76e0c9ffbdeb);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
const $86a5b96e0cefda11$export$7985153d37586c9a = (cloudId)=>(0, $eusud.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/transitioning-details`).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getTransitioningDetails',
                packageName: 'jiraRouterResourcesEocUnlockOperations',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
const $86a5b96e0cefda11$export$850d76e0c9ffbdeb = (0, $2M1hQ.createResource)({
    type: 'EOC_UNLOCK_OPERATIONS',
    getKey: ()=>'eoc-unlock-operations',
    getData: async (_, { tenantContext: { cloudId: cloudId } })=>$86a5b96e0cefda11$export$7985153d37586c9a(cloudId),
    maxAge: 0,
    isBrowserOnly: true
});

});


parcelRegister("1Mqbh", function(module, exports) {

$parcel$export(module.exports, "unlockOperationsRoute", () => $03066cf43774e262$export$30306de7e00bc5a2);
const $03066cf43774e262$export$30306de7e00bc5a2 = {
    name: 'eoc-unlock-operations',
    path: '/jira/settings/products/ops/unlock',
    exact: true
};

});

parcelRegister("3E8Yw", function(module, exports) {

$parcel$export(module.exports, "LazyUnlockOperations", () => $c4c082612871271f$export$55e4754d556d072);
$parcel$export(module.exports, "default", () => $c4c082612871271f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $c4c082612871271f$export$55e4754d556d072 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("fMHjH")), {
    moduleId: "./src/packages/eoc/unlock-operations/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c4c082612871271f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c4c082612871271f$export$55e4754d556d072,
        pageId: "eoc-products-unlock-operations",
        shouldShowSpinner: false
    });

});
parcelRegister("fMHjH", function(module, exports) {

let $b7dcf087085e09c5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b7dcf087085e09c5$var$load("laeSv").then(()=>parcelRequire('1lA3p'));

});



parcelRegister("V3Ey7", function(module, exports) {

$parcel$export(module.exports, "whoIsOnCallRouteEntry", () => $b83a8bf24279056f$export$fee33ca9661e49dd);

var $9ltFw = parcelRequire("9ltFw");

var $ffza4 = parcelRequire("ffza4");

var $iqZds = parcelRequire("iqZds");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $9Nrj8 = parcelRequire("9Nrj8");

var $hAT18 = parcelRequire("hAT18");
const $b83a8bf24279056f$var$getWhoIsOnCallResources = ()=>(0, $9ltFw.resources);
const $b83a8bf24279056f$export$fee33ca9661e49dd = (0, $7NszV.createEntry)((0, $9Nrj8.whoIsOnCallRoute), ()=>({
        group: 'eoc',
        layout: (0, $iqZds.eocChangeboardingLayout),
        component: (0, $hAT18.WhoIsOnCallComponent),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...$b83a8bf24279056f$var$getWhoIsOnCallResources()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hAT18.LazyWhoIsOnCall)
        ]
    }));

});
parcelRegister("9ltFw", function(module, exports) {

$parcel$export(module.exports, "resources", () => $c4f5e60f90fdebe5$export$bc99aaabaf7b70a7);
$parcel$export(module.exports, "widgetResources", () => $c4f5e60f90fdebe5$export$bce3244764eac6e6);
$parcel$export(module.exports, "createMyTeamsResource", () => (parcelRequire("9mULn")).createMyTeamsResource);
$parcel$export(module.exports, "createStatusResource", () => (parcelRequire("gsu6D")).createStatusResource);
$parcel$export(module.exports, "createUserTimelineResource", () => (parcelRequire("kXkKA")).createUserTimelineResource);
$parcel$export(module.exports, "createSchedulesResource", () => (parcelRequire("j12Vb")).createSchedulesResource);
parcelRequire("6luO8");
var $dvEFY = parcelRequire("dvEFY");

var $9mULn = parcelRequire("9mULn");

var $5787e = parcelRequire("5787e");

var $j12Vb = parcelRequire("j12Vb");

var $gsu6D = parcelRequire("gsu6D");

var $kXkKA = parcelRequire("kXkKA");
const $c4f5e60f90fdebe5$export$bc99aaabaf7b70a7 = [
    (0, $dvEFY.eocUserResource),
    (0, $9mULn.createMyTeamsResource)(),
    (0, $gsu6D.createStatusResource)(),
    (0, $5787e.createOpsTeamsResource)()
];
const $c4f5e60f90fdebe5$export$bce3244764eac6e6 = [
    ()=>(0, $dvEFY.eocUserResource),
    (callback, depends)=>(0, $9mULn.createMyTeamsResource)(callback, depends),
    (callback, depends)=>(0, $gsu6D.createStatusResource)(callback, depends),
    (callback, depends)=>(0, $kXkKA.createUserTimelineResource)(callback, depends),
    (callback, depends)=>(0, $j12Vb.createSchedulesResource)(callback, depends)
];

});
parcelRegister("9mULn", function(module, exports) {

$parcel$export(module.exports, "createMyTeamsResource", () => $e6eb628875ab2893$export$bf86fb90d0661bcb);

var $2M1hQ = parcelRequire("2M1hQ");

var $kZWBP = parcelRequire("kZWBP");
const $e6eb628875ab2893$export$bf86fb90d0661bcb = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'myTeamsResource',
        getKey: ()=>'myTeamsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $kZWBP.getMyTeamsEndpoint)();
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("kZWBP", function(module, exports) {

$parcel$export(module.exports, "getMyTeamsEndpoint", () => $d6200f23d8273e3f$export$abe46da7d1f191a7);

var $d9Cgl = parcelRequire("d9Cgl");
const $d6200f23d8273e3f$export$abe46da7d1f191a7 = ()=>{
    return (0, $d9Cgl.eocFetch)(`/v1/alerts/responders/suggested`);
};

});


parcelRegister("5787e", function(module, exports) {

$parcel$export(module.exports, "createOpsTeamsResource", () => $180811379bee02c0$export$99505a9d792f516c);

var $2M1hQ = parcelRequire("2M1hQ");

var $eKBLC = parcelRequire("eKBLC");
const $180811379bee02c0$export$99505a9d792f516c = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'opsTeamsResource',
        getKey: ()=>'opsTeamsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $eKBLC.getOpsTeamsEndpoint)().then((response)=>{
                return response.values;
            });
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("eKBLC", function(module, exports) {

$parcel$export(module.exports, "getOpsTeamsEndpoint", () => $94354cedc62bb820$export$7498ba30158c16cd);

var $d9Cgl = parcelRequire("d9Cgl");

var $k0fwM = parcelRequire("k0fwM");
const $94354cedc62bb820$export$7498ba30158c16cd = ()=>{
    return (0, $d9Cgl.eocFetch)((0, $k0fwM.urls).teams.url());
};

});
parcelRegister("k0fwM", function(module, exports) {

$parcel$export(module.exports, "urls", () => $5257e320bc28ec4c$export$bcae9ba627f604b6);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $5257e320bc28ec4c$export$a7c923252528b255);
$parcel$export(module.exports, "SPOTLIGHT_TOURS", () => $5257e320bc28ec4c$export$38c46ed7a5bc80a0);
$parcel$export(module.exports, "WhoIsOnCallHandler", () => $5257e320bc28ec4c$export$1e7191618d5d4548);
$parcel$export(module.exports, "WhoIsOnCallWidgetHandler", () => $5257e320bc28ec4c$export$d05bbb1ada0e07c4);
const $5257e320bc28ec4c$export$bcae9ba627f604b6 = Object.freeze({
    schedules: {
        url: ()=>`/v1/schedules`,
        user: {
            url: ()=>`${$5257e320bc28ec4c$export$bcae9ba627f604b6.schedules.url()}/user`,
            timeline: {
                url: ()=>`${$5257e320bc28ec4c$export$bcae9ba627f604b6.schedules.user.url()}/timeline`,
                export: {
                    url: ()=>`${$5257e320bc28ec4c$export$bcae9ba627f604b6.schedules.user.timeline.url()}/export`
                }
            },
            userId: {
                url: ({ userId: userId } = {
                    userId: ':userId'
                })=>`${$5257e320bc28ec4c$export$bcae9ba627f604b6.schedules.user.url()}/${userId}`
            }
        },
        onCalls: {
            url: ()=>`${$5257e320bc28ec4c$export$bcae9ba627f604b6.schedules.url()}/on-calls`
        },
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`${$5257e320bc28ec4c$export$bcae9ba627f604b6.schedules.url()}/${scheduleId}`,
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`${$5257e320bc28ec4c$export$bcae9ba627f604b6.schedules.scheduleId.url({
                        scheduleId: scheduleId
                    })}/timeline`
            }
        }
    },
    wioc: {
        status: {
            url: ()=>`${$5257e320bc28ec4c$export$bcae9ba627f604b6.schedules.url()}/user/on-calls`
        }
    },
    teams: {
        url: ()=>`/v1/teams`
    }
});
const $5257e320bc28ec4c$export$a7c923252528b255 = {
    firstOverlappingPeriod: 'eoc-who-is-on-call_first_overlapping_period'
};
const $5257e320bc28ec4c$export$38c46ed7a5bc80a0 = {
    overlappingPeriod: 'eoc-who-is-on-call-overlapping-period'
};
class $5257e320bc28ec4c$export$1e7191618d5d4548 {
    handler(message, context) {
        throw new Error('Not implemented');
    }
}
class $5257e320bc28ec4c$export$d05bbb1ada0e07c4 {
    handler(message, context) {
        throw new Error('Not implemented');
    }
}

});



parcelRegister("j12Vb", function(module, exports) {

$parcel$export(module.exports, "createSchedulesResource", () => $867bdc4bbc20b399$export$b5e65ca3f82b01c5);

var $2M1hQ = parcelRequire("2M1hQ");

var $fsVht = parcelRequire("fsVht");
const $867bdc4bbc20b399$export$b5e65ca3f82b01c5 = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'schedulesResource',
        getKey: ()=>'schedulesResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $fsVht.getSchedulesEndpoint)();
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("fsVht", function(module, exports) {

$parcel$export(module.exports, "getSchedulesEndpoint", () => $9b4fed012696ac75$export$e8e940098db1b988);

var $d9Cgl = parcelRequire("d9Cgl");

var $k0fwM = parcelRequire("k0fwM");
const $9b4fed012696ac75$export$e8e940098db1b988 = ()=>{
    return (0, $d9Cgl.eocFetch)(`${(0, $k0fwM.urls).schedules.onCalls.url()}`);
};

});


parcelRegister("gsu6D", function(module, exports) {

$parcel$export(module.exports, "createStatusResource", () => $debe7c76afad4d97$export$3d1c353e2693418c);

var $2M1hQ = parcelRequire("2M1hQ");

var $4C68p = parcelRequire("4C68p");

var $atUdD = parcelRequire("atUdD");
const $debe7c76afad4d97$export$3d1c353e2693418c = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'statusResource',
        getKey: ()=>'statusResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $4C68p.getStatus)().then((0, $atUdD.transformStatusResponse));
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("4C68p", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $c6c51799a108c627$export$b70265791d2079d4);

var $d9Cgl = parcelRequire("d9Cgl");

var $k0fwM = parcelRequire("k0fwM");
const $c6c51799a108c627$export$b70265791d2079d4 = ()=>{
    return (0, $d9Cgl.eocFetch)((0, $k0fwM.urls).wioc.status.url(), {
        method: 'GET'
    });
};

});

parcelRegister("atUdD", function(module, exports) {

$parcel$export(module.exports, "transformStatusResponse", () => $6bdee0c359184a69$export$44a749c89534e42c);
const $6bdee0c359184a69$export$44a749c89534e42c = ({ currentTimeUtcMillis: currentTimeUtcMillis, onCallUntilUtcMillis: onCallUntilUtcMillis, onCallUntilOffsetMillis: onCallUntilOffsetMillis, isCurrentOnCall: isCurrentOnCall, isParticipantOfAnyRotation: isParticipantOfAnyRotation, nextOnCallEndUtcMillis: nextOnCallEndUtcMillis, nextOnCallEndOffsetMillis: nextOnCallEndOffsetMillis, nextOnCallStartUtcMillis: nextOnCallStartUtcMillis, nextOnCallStartOffsetMillis: nextOnCallStartOffsetMillis })=>{
    return {
        currentDate: currentTimeUtcMillis,
        currentShiftEnd: onCallUntilUtcMillis,
        currentShiftEndOffset: onCallUntilOffsetMillis,
        isOnCall: isCurrentOnCall,
        isParticipantOfAnyRotation: isParticipantOfAnyRotation,
        nextEndDate: nextOnCallEndUtcMillis,
        nextEndOffset: nextOnCallEndOffsetMillis,
        nextStartDate: nextOnCallStartUtcMillis,
        nextStartOffset: nextOnCallStartOffsetMillis
    };
};

});


parcelRegister("kXkKA", function(module, exports) {

$parcel$export(module.exports, "createUserTimelineResource", () => $b2681dbe5a329166$export$a479dcc35c33def1);

var $2M1hQ = parcelRequire("2M1hQ");
parcelRequire("6luO8");
var $dvEFY = parcelRequire("dvEFY");

var $e3jfk = parcelRequire("e3jfk");
const $b2681dbe5a329166$export$a479dcc35c33def1 = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'userTimelineResource',
        getKey: ()=>'userTimelineResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            const data = await dependencies[(0, $dvEFY.eocUserResource).type]?.promise;
            // Since depends API types are not exported it's impossible to infer types,
            // thus we have to use casting
            const accountId = data?.accountId;
            const timezone = data?.timeZone;
            if (!accountId || !timezone) return null;
            return (0, $e3jfk.getWidgetTimeline)(accountId);
        },
        isBrowserOnly: true,
        depends: [
            ...depends ? depends : [],
            (0, $dvEFY.eocUserResource).type
        ]
    });

});
parcelRegister("e3jfk", function(module, exports) {

$parcel$export(module.exports, "getWidgetTimeline", () => $50e3d1f300da9f65$export$bd80cae08a85b1f0);

var $3lAmP = parcelRequire("3lAmP");

var $d9Cgl = parcelRequire("d9Cgl");

var $k0fwM = parcelRequire("k0fwM");

var $ip1SD = parcelRequire("ip1SD");
const $50e3d1f300da9f65$export$bd80cae08a85b1f0 = (accountId)=>{
    const formattedCurrent = (0, $3lAmP.default)(new Date(), 'UTC', "yyyy-MM-dd'T'HH:mm:ss.SSSXX");
    const urlParams = new URLSearchParams({
        currentDate: formattedCurrent,
        accountId: accountId,
        mode: 'timeline',
        timelineType: '6'
    });
    return (0, $d9Cgl.eocFetch)(`${(0, $k0fwM.urls).schedules.user.timeline.url()}?${urlParams.toString()}`, {
        method: 'GET'
    }).then((0, $ip1SD.transformUserTimelineResponse));
};

});
parcelRegister("3lAmP", function(module, exports) {

$parcel$export(module.exports, "default", () => $26ff8b0883669764$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $1YicW = parcelRequire("1YicW");

var $g32C9 = parcelRequire("g32C9");
function $26ff8b0883669764$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $1YicW.default)((0, $g32C9.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("1YicW", function(module, exports) {

$parcel$export(module.exports, "default", () => $16f984bb0e41ef9c$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $gUj2b = parcelRequire("gUj2b");

var $cFC1w = parcelRequire("cFC1w");
var $16f984bb0e41ef9c$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $16f984bb0e41ef9c$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($16f984bb0e41ef9c$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $cFC1w.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $gUj2b.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("gUj2b", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4f0a41d3553e92a$export$2e2bcd8739ae039);

var $e0sJp = parcelRequire("e0sJp");

var $9XTqt = parcelRequire("9XTqt");
var $c4f0a41d3553e92a$var$MILLISECONDS_IN_MINUTE = 60000;
var $c4f0a41d3553e92a$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $c4f0a41d3553e92a$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $c4f0a41d3553e92a$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $c4f0a41d3553e92a$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $c4f0a41d3553e92a$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $c4f0a41d3553e92a$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $c4f0a41d3553e92a$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $c4f0a41d3553e92a$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $c4f0a41d3553e92a$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $c4f0a41d3553e92a$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $c4f0a41d3553e92a$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $c4f0a41d3553e92a$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $e0sJp.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $e0sJp.default)('long', date, options);
        }
    }
};
function $c4f0a41d3553e92a$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $9XTqt.default)(timeZone, originalDate, true) / $c4f0a41d3553e92a$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $c4f0a41d3553e92a$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $c4f0a41d3553e92a$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $c4f0a41d3553e92a$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $c4f0a41d3553e92a$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $c4f0a41d3553e92a$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $c4f0a41d3553e92a$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $c4f0a41d3553e92a$var$formatTimezone(offset, dirtyDelimeter);
}
function $c4f0a41d3553e92a$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $c4f0a41d3553e92a$var$addLeadingZeros(minutes, 2);
}
var $c4f0a41d3553e92a$export$2e2bcd8739ae039 = $c4f0a41d3553e92a$var$formatters;

});
parcelRegister("e0sJp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3275a413f0fe9f0$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $a3275a413f0fe9f0$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $a3275a413f0fe9f0$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $a3275a413f0fe9f0$var$partsTimeZone(dtf, date) : $a3275a413f0fe9f0$var$hackyTimeZone(dtf, date);
}
function $a3275a413f0fe9f0$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $a3275a413f0fe9f0$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $a3275a413f0fe9f0$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("9XTqt", function(module, exports) {

$parcel$export(module.exports, "default", () => $74149e3675ca41d4$export$2e2bcd8739ae039);

var $heatK = parcelRequire("heatK");

var $eF9KP = parcelRequire("eF9KP");
var $74149e3675ca41d4$var$MILLISECONDS_IN_HOUR = 3600000;
var $74149e3675ca41d4$var$MILLISECONDS_IN_MINUTE = 60000;
var $74149e3675ca41d4$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $74149e3675ca41d4$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $74149e3675ca41d4$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $74149e3675ca41d4$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$74149e3675ca41d4$var$validateTimezone(hours)) return NaN;
        return -(hours * $74149e3675ca41d4$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $74149e3675ca41d4$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$74149e3675ca41d4$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $74149e3675ca41d4$var$MILLISECONDS_IN_HOUR + minutes * $74149e3675ca41d4$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($74149e3675ca41d4$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $74149e3675ca41d4$var$toUtcDate(date);
        var offset = $74149e3675ca41d4$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $74149e3675ca41d4$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $74149e3675ca41d4$var$toUtcDate(date) {
    return (0, $eF9KP.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $74149e3675ca41d4$var$calcOffset(date, timezoneString) {
    var tokens = (0, $heatK.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $eF9KP.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $74149e3675ca41d4$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $74149e3675ca41d4$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $74149e3675ca41d4$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $74149e3675ca41d4$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $74149e3675ca41d4$var$validIANATimezoneCache = {};
function $74149e3675ca41d4$var$isValidTimezoneIANAString(timeZoneString) {
    if ($74149e3675ca41d4$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $74149e3675ca41d4$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("heatK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8abdf54535b0730$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $c8abdf54535b0730$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $c8abdf54535b0730$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $c8abdf54535b0730$var$partsOffset(dtf, date) : $c8abdf54535b0730$var$hackyOffset(dtf, date);
}
var $c8abdf54535b0730$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $c8abdf54535b0730$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $c8abdf54535b0730$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $c8abdf54535b0730$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $c8abdf54535b0730$var$dtfCache = {};
function $c8abdf54535b0730$var$getDateTimeFormat(timeZone) {
    if (!$c8abdf54535b0730$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $c8abdf54535b0730$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $c8abdf54535b0730$var$dtfCache[timeZone];
}

});

parcelRegister("eF9KP", function(module, exports) {

$parcel$export(module.exports, "default", () => $aacc7605d0a88d53$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $aacc7605d0a88d53$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("cFC1w", function(module, exports) {

$parcel$export(module.exports, "default", () => $9396cf10cbe57bf8$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $9XTqt = parcelRequire("9XTqt");

var $jWvo7 = parcelRequire("jWvo7");
var $9396cf10cbe57bf8$var$MILLISECONDS_IN_HOUR = 3600000;
var $9396cf10cbe57bf8$var$MILLISECONDS_IN_MINUTE = 60000;
var $9396cf10cbe57bf8$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $9396cf10cbe57bf8$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $jWvo7.default)
};
function $9396cf10cbe57bf8$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $9396cf10cbe57bf8$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9396cf10cbe57bf8$var$splitDateString(argument);
    var parseYearResult = $9396cf10cbe57bf8$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $9396cf10cbe57bf8$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $9396cf10cbe57bf8$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $9XTqt.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $9396cf10cbe57bf8$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $9396cf10cbe57bf8$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $9396cf10cbe57bf8$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $9396cf10cbe57bf8$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9396cf10cbe57bf8$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $9396cf10cbe57bf8$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $9396cf10cbe57bf8$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $9396cf10cbe57bf8$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $9396cf10cbe57bf8$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $9396cf10cbe57bf8$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $9396cf10cbe57bf8$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$9396cf10cbe57bf8$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $9396cf10cbe57bf8$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$9396cf10cbe57bf8$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $9396cf10cbe57bf8$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$9396cf10cbe57bf8$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $9396cf10cbe57bf8$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$9396cf10cbe57bf8$var$validateWeekDate(year, week)) return new Date(NaN);
        return $9396cf10cbe57bf8$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $9396cf10cbe57bf8$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$9396cf10cbe57bf8$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9396cf10cbe57bf8$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $9396cf10cbe57bf8$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $9396cf10cbe57bf8$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$9396cf10cbe57bf8$var$validateTime(hours)) return NaN;
        return hours % 24 * $9396cf10cbe57bf8$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $9396cf10cbe57bf8$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$9396cf10cbe57bf8$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $9396cf10cbe57bf8$var$MILLISECONDS_IN_HOUR + minutes * $9396cf10cbe57bf8$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $9396cf10cbe57bf8$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$9396cf10cbe57bf8$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $9396cf10cbe57bf8$var$MILLISECONDS_IN_HOUR + minutes * $9396cf10cbe57bf8$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $9396cf10cbe57bf8$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $9396cf10cbe57bf8$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $9396cf10cbe57bf8$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9396cf10cbe57bf8$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9396cf10cbe57bf8$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $9396cf10cbe57bf8$var$isLeapYearIndex(year);
        if (isLeapYear && date > $9396cf10cbe57bf8$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $9396cf10cbe57bf8$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $9396cf10cbe57bf8$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $9396cf10cbe57bf8$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $9396cf10cbe57bf8$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $9396cf10cbe57bf8$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("jWvo7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e84bc818cdc3d4a2$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $e84bc818cdc3d4a2$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $e84bc818cdc3d4a2$export$2e2bcd8739ae039 = $e84bc818cdc3d4a2$var$tzPattern;

});



parcelRegister("g32C9", function(module, exports) {

$parcel$export(module.exports, "default", () => $baeef44c1fc5bb86$export$2e2bcd8739ae039);

var $9XTqt = parcelRequire("9XTqt");

var $cFC1w = parcelRequire("cFC1w");
function $baeef44c1fc5bb86$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $cFC1w.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $9XTqt.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});


parcelRegister("ip1SD", function(module, exports) {

$parcel$export(module.exports, "transformUserTimelineResponse", () => $8698bc8059431312$export$78049913b79774a2);

var $dY1gu = parcelRequire("dY1gu");
const $8698bc8059431312$export$78049913b79774a2 = ({ startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, startOffsetMillis: startOffsetMillis, endOffsetMillis: endOffsetMillis, utcTimeOffsetMillis: utcTimeOffsetMillis, currentTime: currentTime, periods: periods, ...data })=>{
    return {
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        nowEpoch: currentTime,
        startOffset: startOffsetMillis,
        endOffset: endOffsetMillis,
        nowOffset: utcTimeOffsetMillis,
        data: {
            ...data,
            periods: periods.map((0, $dY1gu.fromMergedPeriodResponseToClusterPeriod))
        }
    };
};

});
parcelRegister("dY1gu", function(module, exports) {

$parcel$export(module.exports, "fromMergedPeriodResponseToClusterPeriod", () => $7cf9c5a5651ff352$export$9b0bac75f135bd57);
const $7cf9c5a5651ff352$export$9b0bac75f135bd57 = (mergedPeriodResponse)=>{
    const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingPeriods: overlappingPeriods } = mergedPeriodResponse;
    const clusterPeriod = {
        id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        isTrueStartTime: isTrueStartTime,
        isTrueEndTime: isTrueEndTime,
        startOffset: periodStartOffsetMillis,
        endOffset: periodEndOffsetMillis,
        overlaps: overlappingPeriods.map($7cf9c5a5651ff352$var$fromOverlappingPeriodResponseToOverlappingPeriod)
    };
    return clusterPeriod;
};
const $7cf9c5a5651ff352$var$fromOverlappingPeriodResponseToOverlappingPeriod = (overlappingPeriodResponse)=>{
    const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingRotations: overlappingRotations, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime } = overlappingPeriodResponse;
    const overlappingPeriod = {
        id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        startOffset: periodStartOffsetMillis,
        endOffset: periodEndOffsetMillis,
        overlaps: overlappingRotations,
        isTrueStartTime: isTrueStartTime,
        isTrueEndTime: isTrueEndTime
    };
    return overlappingPeriod;
};

});





parcelRegister("9Nrj8", function(module, exports) {

$parcel$export(module.exports, "whoIsOnCallRoute", () => $44bb0c0960b12c42$export$26b06efd7311586b);
const $44bb0c0960b12c42$export$26b06efd7311586b = {
    name: 'eoc-who-is-on-call',
    path: '/jira/ops/who-is-on-call',
    exact: true
};

});

parcelRegister("hAT18", function(module, exports) {

$parcel$export(module.exports, "LazyWhoIsOnCall", () => $31a5e09bb5444d16$export$7b03e7437c5d4f77);
$parcel$export(module.exports, "WhoIsOnCallComponent", () => $31a5e09bb5444d16$export$51430a0cf6ef3c09);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $31a5e09bb5444d16$export$7b03e7437c5d4f77 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("hRDXI")), {
    moduleId: "./src/packages/eoc/who-is-on-call/src/ui/index.tsx"
});
const $31a5e09bb5444d16$export$51430a0cf6ef3c09 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $31a5e09bb5444d16$export$7b03e7437c5d4f77,
        pageId: "async-jira-eoc-who-is-on-call",
        shouldShowSpinner: false
    });

});
parcelRegister("hRDXI", function(module, exports) {

let $d0166294d1de1fca$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d0166294d1de1fca$var$load("h2MrD"),
    $d0166294d1de1fca$var$load("bYT2S"),
    $d0166294d1de1fca$var$load("g1eRw")
]).then(()=>parcelRequire('eV5T9'));

});



parcelRegister("01Za6", function(module, exports) {

$parcel$export(module.exports, "errorsNotFoundRouteEntry", () => $083d2dc437d8c2ec$export$c4c012a49b465e94);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $7gROc = parcelRequire("7gROc");
const $083d2dc437d8c2ec$export$c4c012a49b465e94 = (0, $7NszV.createEntry)((0, $7gROc.errorsNotFoundRoute), ()=>({
        group: 'errors',
        component: (0, $5lsNZ.default),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5lsNZ.LazyNotFoundErrorPage)
        ]
    }));

});
parcelRegister("7gROc", function(module, exports) {

$parcel$export(module.exports, "errorsNotFoundRoute", () => $24256311e2794309$export$465fa01c0f3a0551);
const $24256311e2794309$export$465fa01c0f3a0551 = {
    name: 'errors-not-found',
    path: '/jira/:projectType(software|servicedesk|core)'
};

});


parcelRegister("5fBQK", function(module, exports) {

$parcel$export(module.exports, "forgeAdminRouteEntry", () => $3cf9bea8e2a94905$export$9e57f00c65d37e11);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $4PkbN = parcelRequire("4PkbN");

var $hIGzE = parcelRequire("hIGzE");
const $3cf9bea8e2a94905$export$9e57f00c65d37e11 = (0, $7NszV.createEntry)((0, $4PkbN.forgeAdminRoute), ()=>({
        component: (0, $hIGzE.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $iHiHz.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hIGzE.LazyForgeAdminPage)
        ]
    }));

});
parcelRegister("4PkbN", function(module, exports) {

$parcel$export(module.exports, "forgeAdminRoute", () => $cc2d93b85ec603e1$export$157f97e6454c2a9f);
const $cc2d93b85ec603e1$export$157f97e6454c2a9f = {
    name: 'forge-spa-admin',
    path: '/jira/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("hIGzE", function(module, exports) {

$parcel$export(module.exports, "LazyForgeAdminPage", () => $bef31a55bb1643fb$export$66ee65dcd4a6458d);
$parcel$export(module.exports, "default", () => $bef31a55bb1643fb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $bef31a55bb1643fb$export$66ee65dcd4a6458d = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("8SDQN")), {
    moduleId: "./src/packages/spa-apps/forge/admin/src/index.tsx"
});
const $bef31a55bb1643fb$export$c9e5f500ef472147 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $bef31a55bb1643fb$export$66ee65dcd4a6458d,
        pageId: "forge-spa-admin",
        shouldShowSpinner: true
    });
var $bef31a55bb1643fb$export$2e2bcd8739ae039 = $bef31a55bb1643fb$export$c9e5f500ef472147;

});
parcelRegister("8SDQN", function(module, exports) {

let $67724758ef71b03a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $67724758ef71b03a$var$load("f8cIm").then(()=>parcelRequire('bqE5a'));

});



parcelRegister("hxYI0", function(module, exports) {

$parcel$export(module.exports, "forgeAdminSettingsRouteEntry", () => $10e343bd77fe2c43$export$ea8439aa1b4afbb2);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $7OevD = parcelRequire("7OevD");

var $hIGzE = parcelRequire("hIGzE");
const $10e343bd77fe2c43$export$ea8439aa1b4afbb2 = (0, $7NszV.createEntry)((0, $7OevD.forgeAdminSettingsRoute), ()=>({
        component: (0, $hIGzE.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $iHiHz.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hIGzE.LazyForgeAdminPage)
        ]
    }));

});
parcelRegister("7OevD", function(module, exports) {

$parcel$export(module.exports, "forgeAdminSettingsRoute", () => $48618cc01d3d4f81$export$392534a80a0b9b11);
const $48618cc01d3d4f81$export$392534a80a0b9b11 = {
    name: 'forge-spa-admin-settings',
    path: '/jira/settings/apps/:settingsType(configure|get-started)/:appId/:envId/:route?'
};

});


parcelRegister("dzSy7", function(module, exports) {

$parcel$export(module.exports, "forgeFieldContextualConfigurationRouteEntry", () => $f15b9bbe688647f5$export$425186ecf36e93c);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $2YqLE = parcelRequire("2YqLE");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $92r5p = parcelRequire("92r5p");

var $6bHdH = parcelRequire("6bHdH");
const $f15b9bbe688647f5$export$425186ecf36e93c = (0, $7NszV.createEntry)((0, $92r5p.forgeFieldContextualConfigurationRoute), ()=>({
        component: (0, $6bHdH.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $5bkvv.forgeCustomFieldTypeResource),
            (0, $2YqLE.fieldContextConfigPageResource),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6bHdH.LazyForgeFieldContextConfigPage)
        ]
    }));

});
parcelRegister("2YqLE", function(module, exports) {

$parcel$export(module.exports, "fieldContextConfigPageResource", () => $2520f99c62492240$export$686a607053a18611);

var $2M1hQ = parcelRequire("2M1hQ");


const $2520f99c62492240$export$686a607053a18611 = (0, $2M1hQ.createResource)({
    type: (0, $714c31c1c770eaf3$export$4b80522d38222ad),
    getKey: ()=>'data',
    getDataLoader: ()=>(parcelRequire("8UKV2")),
    maxAge: 5000
});

});
const $714c31c1c770eaf3$export$4b80522d38222ad = 'FORGE_FIELD_CONTEXTUAL_CONFIG';

parcelRegister("8UKV2", function(module, exports) {

let $67d7f2d842874403$var$load = (parcelRequire("28QjX"))(4);
module.exports = $67d7f2d842874403$var$load("ftzT3").then(()=>parcelRequire('ei6Pl'));

});


parcelRegister("92r5p", function(module, exports) {

$parcel$export(module.exports, "forgeFieldContextualConfigurationRoute", () => $5ea48a875d63d03b$export$2ee4468dd8e9636f);
const $5ea48a875d63d03b$export$2ee4468dd8e9636f = {
    name: 'forge-spa-field-context-config',
    path: '/jira/settings/issues/field/:fieldId/context/:contextId/configure/app'
};

});

parcelRegister("6bHdH", function(module, exports) {

$parcel$export(module.exports, "LazyForgeFieldContextConfigPage", () => $b96b1546635e7c38$export$c53e206c7fd6fb76);
$parcel$export(module.exports, "default", () => $b96b1546635e7c38$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $b96b1546635e7c38$export$c53e206c7fd6fb76 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("eCWI4")), {
    moduleId: "./src/packages/spa-apps/forge/field-contextual-config/src/index.tsx"
});
const $b96b1546635e7c38$export$50bd0baee0b2f946 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b96b1546635e7c38$export$c53e206c7fd6fb76,
        pageId: "forge-spa-field-context-config",
        shouldShowSpinner: true
    });
var $b96b1546635e7c38$export$2e2bcd8739ae039 = $b96b1546635e7c38$export$50bd0baee0b2f946;

});
parcelRegister("eCWI4", function(module, exports) {

let $aa6227dba04bf6ad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aa6227dba04bf6ad$var$load("5CiUy").then(()=>parcelRequire('jBnrF'));

});



parcelRegister("eKguf", function(module, exports) {

$parcel$export(module.exports, "forgeGlobalRouteEntry", () => $7633f07341519228$export$68b00eede5bc25e6);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iFaFr = parcelRequire("iFaFr");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $ic1pa = parcelRequire("ic1pa");

var $aRZh7 = parcelRequire("aRZh7");
const $7633f07341519228$export$68b00eede5bc25e6 = (0, $7NszV.createEntry)((0, $ic1pa.forgeGlobalRoute), ()=>({
        component: (0, $aRZh7.default),
        layout: (0, $aPfsS.createLayout)(),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $iFaFr.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationForgeGlobalPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aRZh7.LazyForgeGlobalPage)
        ]
    }));

});
parcelRegister("iFaFr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b86720f4c83cfbb5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

const $b86720f4c83cfbb5$var$LazyForPaintForgeGlobalPageSidebar = (0, $b7Svb.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("c5uRk")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/forge-global-page/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b86720f4c83cfbb5$var$ForgeGlobalPageSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "forgeGlobalPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b86720f4c83cfbb5$var$LazyForPaintForgeGlobalPageSidebar, null)));
$b86720f4c83cfbb5$var$ForgeGlobalPageSidebar.displayName = 'ForgeGlobalPageSidebar';
var $b86720f4c83cfbb5$export$2e2bcd8739ae039 = $b86720f4c83cfbb5$var$ForgeGlobalPageSidebar;

});
parcelRegister("c5uRk", function(module, exports) {

let $8ccde3a171bd36e2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8ccde3a171bd36e2$var$load("6eoVI").then(()=>parcelRequire('4opkK'));

});


parcelRegister("ic1pa", function(module, exports) {

$parcel$export(module.exports, "forgeGlobalRoute", () => $7d160aadc36293c5$export$4146dba061d1c72d);
const $7d160aadc36293c5$export$4146dba061d1c72d = {
    name: 'forge-spa-global',
    path: '/jira/apps/:appId/:envId/:route?'
};

});

parcelRegister("aRZh7", function(module, exports) {

$parcel$export(module.exports, "LazyForgeGlobalPage", () => $8f6029962fb4c5dc$export$332293feb5cffd72);
$parcel$export(module.exports, "default", () => $8f6029962fb4c5dc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $8f6029962fb4c5dc$export$332293feb5cffd72 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("htdRv")), {
    moduleId: "./src/packages/spa-apps/forge/global/src/index.tsx"
});
const $8f6029962fb4c5dc$export$4c36a7b018e5e5cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8f6029962fb4c5dc$export$332293feb5cffd72,
        pageId: "forge-spa-global",
        shouldShowSpinner: true
    });
var $8f6029962fb4c5dc$export$2e2bcd8739ae039 = $8f6029962fb4c5dc$export$4c36a7b018e5e5cc;

});
parcelRegister("htdRv", function(module, exports) {

let $cb7fe5c835ad0d89$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cb7fe5c835ad0d89$var$load("erHCa").then(()=>parcelRequire('eZUti'));

});



parcelRegister("7vXQn", function(module, exports) {

$parcel$export(module.exports, "forgePersonalSettingsRouteEntry", () => $20637ca5596c888a$export$bcf4a0e471a2493d);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $cRWZh = parcelRequire("cRWZh");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $jApsb = parcelRequire("jApsb");

var $jaNrZ = parcelRequire("jaNrZ");
const $20637ca5596c888a$export$bcf4a0e471a2493d = (0, $7NszV.createEntry)((0, $jApsb.forgePersonalSettingsRoute), ()=>({
        component: (0, $jaNrZ.default),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROFILE,
            sidebar: (0, $cRWZh.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationForgePersonalSettingsPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jaNrZ.LazyForgePersonalSettingsPage)
        ]
    }));

});
parcelRegister("cRWZh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fc6117fdc2ce1b9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

const $8fc6117fdc2ce1b9$var$LazyPersonalSettingsSidebar = (0, $b7Svb.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("hWZRf")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/personal-settings/src/index.tsx"
});
const $8fc6117fdc2ce1b9$var$PersonalSettingsSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "personalSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8fc6117fdc2ce1b9$var$LazyPersonalSettingsSidebar, null));
var $8fc6117fdc2ce1b9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($8fc6117fdc2ce1b9$var$PersonalSettingsSidebar);

});
parcelRegister("hWZRf", function(module, exports) {

let $d117d619b80fcb4a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d117d619b80fcb4a$var$load("gMZ9X").then(()=>parcelRequire('6re9h'));

});


parcelRegister("jApsb", function(module, exports) {

$parcel$export(module.exports, "forgePersonalSettingsRoute", () => $911d3aa14cf2fd85$export$8cf022892f01dc88);
const $911d3aa14cf2fd85$export$8cf022892f01dc88 = {
    name: 'forge-spa-personal-settings',
    path: '/jira/settings/personal/apps/:appId/:envId/:route?'
};

});

parcelRegister("jaNrZ", function(module, exports) {

$parcel$export(module.exports, "LazyForgePersonalSettingsPage", () => $407ba70330fa3fc8$export$984c6340ff981792);
$parcel$export(module.exports, "default", () => $407ba70330fa3fc8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $407ba70330fa3fc8$export$984c6340ff981792 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("cCkWx")), {
    moduleId: "./src/packages/spa-apps/forge/personal-settings/src/index.tsx"
});
const $407ba70330fa3fc8$export$fb659fde7fa91075 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $407ba70330fa3fc8$export$984c6340ff981792,
        pageId: "forge-spa-personal-settings",
        shouldShowSpinner: true
    });
var $407ba70330fa3fc8$export$2e2bcd8739ae039 = $407ba70330fa3fc8$export$fb659fde7fa91075;

});
parcelRegister("cCkWx", function(module, exports) {

let $92f94781b234f5cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $92f94781b234f5cf$var$load("lFdZ5").then(()=>parcelRequire('arSLF'));

});



parcelRegister("kCn5T", function(module, exports) {

$parcel$export(module.exports, "forgeProjectRouteEntry", () => $284a2dce5bdef34f$export$1ed77617605af86d);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $7GnDe = parcelRequire("7GnDe");

var $lgVu5 = parcelRequire("lgVu5");

var $ioJTL = parcelRequire("ioJTL");
const $284a2dce5bdef34f$export$1ed77617605af86d = (0, $7NszV.createEntry)((0, $lgVu5.forgeProjectRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $fpjJX.getServiceDeskSharedNavigationSingleResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $dxCvy.projectContextResourceWithCache),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $ioJTL.forgeProjectPageEntrypoint)
    }));

});
parcelRegister("lgVu5", function(module, exports) {

$parcel$export(module.exports, "forgeProjectRoute", () => $d3c18f0b3608cdac$export$998d01fc8f4c3224);
const $d3c18f0b3608cdac$export$998d01fc8f4c3224 = {
    name: 'forge-spa-project',
    path: '/jira/:projectType(software|software/c|core)/projects/:projectKey/apps/:appId/:envId/:route?'
};

});

parcelRegister("ioJTL", function(module, exports) {

$parcel$export(module.exports, "forgeProjectPageEntrypoint", () => $495262f31d81d9db$export$74e6ff15060a7efe);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $jVVdt = parcelRequire("jVVdt");

var $fo6b8 = parcelRequire("fo6b8");
const $495262f31d81d9db$export$74e6ff15060a7efe = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $jVVdt.forgeProjectEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("jVVdt", function(module, exports) {

$parcel$export(module.exports, "forgeProjectEntrypoint", () => $8e3be2a67cce3f64$export$109bb60f5ed960e9);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $8e3be2a67cce3f64$export$109bb60f5ed960e9 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("2t0Tj")), {
        moduleId: "a42399f5"
    }),
    getPreloadProps: ({ context: context })=>({
            extraProps: {
                match: context.match
            }
        })
});

});
parcelRegister("2t0Tj", function(module, exports) {

let $1cbefb262b10ce91$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1cbefb262b10ce91$var$load("cBmhJ").then(()=>parcelRequire('kGkpN'));

});




parcelRegister("90Rrp", function(module, exports) {

$parcel$export(module.exports, "forgeProjectServicedeskRouteEntry", () => $4f02896c605dcb0b$export$6732bea56e68d0b4);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $7GnDe = parcelRequire("7GnDe");

var $8RflP = parcelRequire("8RflP");

var $7IrJ6 = parcelRequire("7IrJ6");
const $4f02896c605dcb0b$export$6732bea56e68d0b4 = (0, $7NszV.createEntry)((0, $8RflP.forgeProjectServicedeskRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSharedNavigationSingleResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $dxCvy.projectContextResourceWithCache),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $7IrJ6.forgeProjectServicedeskPageEntrypoint)
    }));

});
parcelRegister("8RflP", function(module, exports) {

$parcel$export(module.exports, "forgeProjectServicedeskRoute", () => $e62a10d9c09b490c$export$8b83928f9f21e11);
const $e62a10d9c09b490c$export$8b83928f9f21e11 = {
    name: 'forge-spa-project-servicedesk',
    path: '/jira/:projectType(servicedesk)/projects/:projectKey/apps/:appId/:envId/:route?'
};

});

parcelRegister("7IrJ6", function(module, exports) {

$parcel$export(module.exports, "forgeProjectServicedeskPageEntrypoint", () => $c277f8b7f3958697$export$eae71fd9c3e0166a);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $jVVdt = parcelRequire("jVVdt");
const $c277f8b7f3958697$export$eae71fd9c3e0166a = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $jVVdt.forgeProjectEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});


parcelRegister("86qmt", function(module, exports) {

$parcel$export(module.exports, "forgeServicedeskQueueRouteEntry", () => $03b194d7d6d82e68$export$1486fc4f85c1237);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $levwO = parcelRequire("levwO");

var $6Z2mh = parcelRequire("6Z2mh");

var $9mZwV = parcelRequire("9mZwV");
const $03b194d7d6d82e68$export$1486fc4f85c1237 = (0, $7NszV.createEntry)((0, $levwO.forgeServicedeskQueueRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $9mZwV.forgeServiceDeskQueuePageEntrypoint)
    }));

});
parcelRegister("levwO", function(module, exports) {

$parcel$export(module.exports, "forgeServicedeskQueueRoute", () => $019035708a3fcd5d$export$b77275b989ab42a6);
const $019035708a3fcd5d$export$b77275b989ab42a6 = {
    name: 'forge-spa-servicedesk-queue',
    path: '/jira/servicedesk/projects/:projectKey/queues/apps/:appId/:envId/:route?'
};

});

parcelRegister("9mZwV", function(module, exports) {

$parcel$export(module.exports, "forgeServiceDeskQueuePageEntrypoint", () => $ebb310d709581894$export$e50db2ee9d53508e);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5buAb = parcelRequire("5buAb");
const $ebb310d709581894$export$e50db2ee9d53508e = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $5buAb.forgeServiceDeskEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("5buAb", function(module, exports) {

$parcel$export(module.exports, "forgeServiceDeskEntrypoint", () => $599bf9ac9bda7f22$export$5f56161124a4cb21);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $599bf9ac9bda7f22$export$5f56161124a4cb21 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("9uqu9")), {
        moduleId: "70dc4c33"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9uqu9", function(module, exports) {

let $6e8b75ce0f28dd8e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6e8b75ce0f28dd8e$var$load("2GKln").then(()=>parcelRequire('6Ue2s'));

});




parcelRegister("hxK6L", function(module, exports) {

$parcel$export(module.exports, "globalMailSettingsRouteEntry", () => $fc43fd37745c00e2$export$5e1236665a530df4);

var $ffza4 = parcelRequire("ffza4");

var $bwLf9 = parcelRequire("bwLf9");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $bzD24 = parcelRequire("bzD24");

var $euIkX = parcelRequire("euIkX");

var $21A4f = parcelRequire("21A4f");
const $fc43fd37745c00e2$export$5e1236665a530df4 = (0, $7NszV.createEntry)((0, $bzD24.globalMailSettingsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.global-mail-settings',
        component: (0, $bwLf9.default)(()=>true, (0, $21A4f.default), (0, $euIkX.default)),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $21A4f.LazyGlobalMailSettings)
        ]
    }));

});
parcelRegister("bwLf9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7ec252b6b084884$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var /**
 * @deprecated this does not support useRef and is being moved into a new package.
 * Use @atlassian/jira-feature-flagging-utils and componentWithCondition instead.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$a7ec252b6b084884$export$2e2bcd8739ae039 = (conditionGetter, ComponentTrue, ComponentFalse)=>{
    const ComponentWithCondition = (props)=>// @ts-expect-error - TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'. | TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'.
        conditionGetter() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentTrue, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentFalse, props);
    if (conditionGetter.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${conditionGetter.name}]`;
    // @ts-expect-error - TS2322 - Type '{ (props: P): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<P, any>'.
    return ComponentWithCondition;
};

});

parcelRegister("bzD24", function(module, exports) {

$parcel$export(module.exports, "globalMailSettingsRoute", () => $b88e0402aff618ba$export$e69b84daf70501b3);
const $b88e0402aff618ba$export$e69b84daf70501b3 = {
    name: 'global-mail-settings',
    path: '/secure/admin/global-mail-settings',
    exact: true
};

});

parcelRegister("euIkX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a0afe23818eb6ed$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3mK2k = parcelRequire("3mK2k");
var /** This exists to be used as a route since the redirect as a route and redirect as a component
 * have different props, and flow complains. */ // @ts-expect-error - Type '{}' is missing the following properties from type 'Pick<Omit<Omit<RouteContext & { flagService: FlagService; createAnalyticsEvent: (arg1: { action: string; }) => UIAnalyticsEvent; }, keyof WithAnalyticsEventsProps> & RefAttributes<...>, "flagService">, keyof RouteContext | keyof RefAttributes<...>>': location, query, route, match, action
// eslint-disable-next-line jira/import/no-anonymous-default-export
$1a0afe23818eb6ed$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mK2k.default), null);

});
parcelRegister("3mK2k", function(module, exports) {

$parcel$export(module.exports, "default", () => $1513009dd97e8af4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $3TR0I = parcelRequire("3TR0I");

var $dMnMc = parcelRequire("dMnMc");

var $dJl1T = parcelRequire("dJl1T");

var $34Vv8 = parcelRequire("34Vv8");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");

var $1bQGJ = parcelRequire("1bQGJ");

var $eNf8a = parcelRequire("eNf8a");

var $4R6GH = parcelRequire("4R6GH");

var $883db = parcelRequire("883db");
const $1513009dd97e8af4$var$THRESHOLD = 30000;
const $1513009dd97e8af4$var$getScopeType = (scope)=>{
    switch(scope.identifierType){
        case 'boardId':
            return 'board';
        case 'projectId':
        case 'projectKey':
            return scope.pageType === 'settings' ? 'projectSettings' : 'project';
        default:
            return '';
    }
};
// TODO : JFP 2250, JFP-2251 - Please add prefix here for the sessionStorageProvider and update in the test as well
const $1513009dd97e8af4$var$sessionStorageProvider = (0, $eNf8a.createSessionStorageProvider)('');
class $1513009dd97e8af4$export$836fe1ef2cfde075 extends (0, $5uXOq.Component) {
    componentDidMount() {
        // eslint-disable-next-line jira/react-magnetic-di/no-unneeded
        (0, $gKZoD.di)(sessionStorage, $1513009dd97e8af4$var$sessionStorageProvider, window);
        const { location: { pathname: pathname, search: search }, flagService: flagService, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const redirectPathname = pathname.startsWith('//') ? pathname.substr(1) : pathname;
        const lastRedirectTime = (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? Number($1513009dd97e8af4$var$sessionStorageProvider.get(redirectPathname)) : Number(sessionStorage.getItem(redirectPathname));
        if (!lastRedirectTime) (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $1513009dd97e8af4$var$sessionStorageProvider.set(redirectPathname, Date.now().toString()) : sessionStorage.setItem(redirectPathname, Date.now().toString());
        else if (Date.now() - lastRedirectTime < $1513009dd97e8af4$var$THRESHOLD) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const scopeData = (0, $dMnMc.default)(window.location.href, (0, $j8DrX.default));
            const scope = $1513009dd97e8af4$var$getScopeType(scopeData);
            (0, $dJl1T.default).safeErrorWithoutCustomerData('redirect-loop.error', 'Redirect error caused by invalid url', {
                scope: scope
            });
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                action: 'entered'
            }), 'redirect-loop entered', 'endeavour.spa.redirect-loop', {
                scope: scope
            });
            flagService.showFlag((0, $883db.errorFlag)());
            (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $1513009dd97e8af4$var$sessionStorageProvider.remove(redirectPathname) : sessionStorage.removeItem(redirectPathname);
            return;
        } else (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $1513009dd97e8af4$var$sessionStorageProvider.remove(redirectPathname) : sessionStorage.removeItem(redirectPathname);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.assign(redirectPathname + search);
    }
    render() {
        return null;
    }
}
var // @ts-expect-error - TS2345 - Argument of type 'ForwardRefExoticComponent<Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>>' is not assignable to parameter of type 'ComponentType<{ flagService: FlagService; }>'. | TS2345 - Argument of type 'typeof RedirectToLegacyRouting' is not assignable to parameter of type '(((props: WithAnalyticsEventsProps) => ReactElement<any, string | ((props: any) => ReactElement<any, any> | null) | (new (props: any) => Component<any, any, any>)> | null) & typeof RedirectToLegacyRouting) | ((new (props: WithAnalyticsEventsProps) => Component<...>) & typeof RedirectToLegacyRouting)'.
$1513009dd97e8af4$export$2e2bcd8739ae039 = (0, $1bQGJ.withRouter)((0, $34Vv8.default)((0, $3TR0I.default)()($1513009dd97e8af4$export$836fe1ef2cfde075)));

});
parcelRegister("dMnMc", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $fe24052863a91d57$export$557c2f222778cea6);
$parcel$export(module.exports, "default", () => $fe24052863a91d57$export$2e2bcd8739ae039);

var $aZsz6 = parcelRequire("aZsz6");

var $95bh0 = parcelRequire("95bh0");

var $556I0 = parcelRequire("556I0");

var $5PyNy = parcelRequire("5PyNy");

var $79s9E = parcelRequire("79s9E");
const $fe24052863a91d57$var$projectScopeDataMap = {
    routes: [
        // Query string
        /[&?]projectKey=(\w+)/i,
        // Service desk, business and some software
        /\/projects\/(\w+)/i,
        // Issue page (not root)
        /\/browse\/(\w+)-\d+\??((?!(filter=|jql=)).)*$/i,
        // Project settings
        /\/plugins\/servlet\/project-config\/(\w+)/i,
        // Service Desk project settings
        /\/servicedesk\/admin\/(\w+)/i,
        // Browse project
        /\/browse\/(\w+)\/?(\?.*)?$/i
    ],
    meta: [
        // Software
        'ghx-project-key',
        // Settings
        'projectKey',
        // Reports
        'ajs-project-key'
    ]
};
const $fe24052863a91d57$var$getProjectId = (url)=>{
    const projectIdRoutes = [
        // Query string - reports
        /[&?]selectedProjectId=(\w+)/i,
        // Query string - edit project, delete project
        /[&?]pid=(\w+)/i,
        // Query string - release notes
        /[&?]projectId=(\w+)/i,
        // Query string - connect items
        /[&?]project\.id=(\w+)/i
    ];
    return projectIdRoutes.reduce((foundId, route)=>{
        if (foundId) return foundId;
        const match = url.match(route);
        if (match != null) {
            const [, projectId] = match;
            if (projectId) return projectId;
        }
        return null;
    }, null);
};
/**
 * Extracts certain data out of the URL that is required by other data providers.
 */ const $fe24052863a91d57$var$getProjectKey = (url, getMeta)=>{
    let projectKey = null;
    $fe24052863a91d57$var$projectScopeDataMap.meta.forEach((tagName)=>{
        const value = getMeta(tagName);
        if (value && projectKey == null) projectKey = value;
    });
    $fe24052863a91d57$var$projectScopeDataMap.routes.forEach((route)=>{
        const match = url.match(route);
        if (match != null && projectKey == null) [, projectKey] = match;
    });
    return projectKey || undefined;
};
const $fe24052863a91d57$export$557c2f222778cea6 = (url)=>{
    try {
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(url, true);
        let boardId = parsed.query ? parsed.query.rapidView : null;
        if (boardId == null) {
            const match = url.match(/\/boards\/(\d+)/i);
            boardId = match ? match[1] : null;
        }
        return boardId;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return null;
    }
};
const $fe24052863a91d57$var$isProjectSettingsConnectRoute = ({ getMeta: getMeta, url: url })=>getMeta('ajs-in-admin-mode') === 'true' && (0, $556I0.default).some((regex)=>regex.test(url)) || (0, $5PyNy.default).some((regex)=>regex.test(url));
const $fe24052863a91d57$var$isProjectPage = ({ getMeta: getMeta, projectId: projectId, projectKey: projectKey, url: url })=>{
    // Project routes that have a project id in the URL
    const isProject = ()=>{
        const routes = [
            /\/secure\/ConfigureReport(!default)?\.jspa.+selectedProjectId/i,
            /\/secure\/project\/(DeleteProject|EditProject)!default\.jspa.+pid/i,
            /\/secure\/ReleaseNote.jspa.+projectId/i,
            /\/secure\/ConfigureReleaseNote.jspa.+projectId/i
        ];
        return $fe24052863a91d57$var$isProjectSettingsConnectRoute({
            getMeta: getMeta,
            url: url
        }) || routes.some((regex)=>regex.test(url));
    };
    return projectKey || projectId && isProject();
};
const $fe24052863a91d57$var$isProjectSettingsPage = ({ getMeta: getMeta, url: url })=>(0, $79s9E.default).some((route)=>url.match(route)) || $fe24052863a91d57$var$isProjectSettingsConnectRoute({
        getMeta: getMeta,
        url: url
    });
const $fe24052863a91d57$var$getProjectPageType = (getMeta, url)=>{
    if ($fe24052863a91d57$var$isProjectSettingsPage({
        getMeta: getMeta,
        url: url
    })) return 'settings';
    const decorator = getMeta('decorator');
    const isSettings = getMeta('is-settings-page') === 'true';
    return decorator === 'admin' || decorator === 'atl.admin' || isSettings ? 'settings' : undefined;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fe24052863a91d57$export$2e2bcd8739ae039 = (url, getMeta)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const extractedData = {};
    const boardId = $fe24052863a91d57$export$557c2f222778cea6(url);
    if (boardId) extractedData.boardId = boardId;
    const projectKey = url.includes('/plugins/servlet/ac/') || url.includes('/settings/projects/') ? undefined : $fe24052863a91d57$var$getProjectKey(url, getMeta);
    if (projectKey) extractedData.projectKey = projectKey;
    const projectId = $fe24052863a91d57$var$getProjectId(url);
    if (projectId) extractedData.projectId = projectId;
    const isProject = $fe24052863a91d57$var$isProjectPage({
        getMeta: getMeta,
        projectId: projectId,
        projectKey: projectKey,
        url: url
    });
    extractedData.pageType = isProject ? $fe24052863a91d57$var$getProjectPageType(getMeta, url) : undefined;
    const identifier = (0, $95bh0.getScopeIdentifier)({
        boardId: boardId,
        projectKey: projectKey,
        projectId: isProject ? projectId : null
    });
    // This gets around a flow inexact type error
    return {
        ...extractedData,
        ...identifier
    };
};

});
parcelRegister("556I0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aff61bbf8b5a2cf$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $2aff61bbf8b5a2cf$export$2e2bcd8739ae039 = [
    // Regex groups: addonKey, pageKey
    /\/plugins\/servlet\/ac\/(.+)\/([^?\s]+)/i
];

});

parcelRegister("5PyNy", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d489e15712c5e17$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $5d489e15712c5e17$export$2e2bcd8739ae039 = [
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.jiraxporter\/jira-xporter-manage-project/i,
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.xray\/xray-project-settings-all/i
];

});

parcelRegister("79s9E", function(module, exports) {

$parcel$export(module.exports, "default", () => $efe7a2022eaf0f59$export$2e2bcd8739ae039);

var $5PyNy = parcelRequire("5PyNy");
const $efe7a2022eaf0f59$var$commonClassicProjectSettingsRoutes = [
    /\/plugins\/servlet\/project-config/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/code/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/deployments/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-components/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-versions/i,
    /\/plugins\/servlet\/project-config\/.+\/fields/i,
    /\/plugins\/servlet\/project-config\/.+\/issuesecurity/i,
    /\/plugins\/servlet\/project-config\/.+\/issuetypes/i,
    /\/plugins\/servlet\/project-config\/.+\/notifications/i,
    /\/plugins\/servlet\/project-config\/.+\/permissions/i,
    /\/plugins\/servlet\/project-config\/.+\/screens/i,
    /\/plugins\/servlet\/project-config\/.+\/workflows/i,
    /\/project\/DeleteProject!default\.jspa/i,
    /\/secure\/project\/EditProject!default\.jspa/i,
    // Collectors
    /\/secure\/AddCollector/i,
    /\/secure\/InsertCollectorHelp/i,
    /\/ViewCollector!default\.jspa\?projectKey=/i,
    /\/ViewCollectors!default\.jspa\?projectKey=/i,
    // Development tools
    /\/secure\/ConfigureDevStatus.jspa\?projectKey=/i,
    // Hipchat
    /\/InstallHipChat\.jspa\?projectKey=/i,
    /\/secure\/ConfigureHipChat\.jspa\?projectKey=(.+)/i,
    // Forge
    /\/jira\/software\/c\/projects\/.+\/settings\/apps\/([a-z0-9-]+)\/([a-z0-9-]+)(\/*)?/i
];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$efe7a2022eaf0f59$export$2e2bcd8739ae039 = [
    ...$efe7a2022eaf0f59$var$commonClassicProjectSettingsRoutes,
    /\/plugins\/servlet\/project-config\/.+\/issuelayout/i,
    ...(0, $5PyNy.default),
    // Service Desk project settings
    /\/servicedesk\/admin\/(\w+)/i,
    // SPA settings
    /\/projects\/\w+\/settings(\/\w+)*/i
];

});


parcelRegister("883db", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $d8474afc40da2ee0$export$b9a7f1ebeaa76953);

var $dGrvr = parcelRequire("dGrvr");
const $d8474afc40da2ee0$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        title: (0, $dGrvr.messages).title,
        description: (0, $dGrvr.messages).description,
        messageId: 'spa-apps-common.redirect.legacy-routing.flags.flag.error.error-flag',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $dGrvr.messages).goHome,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.assign('/')
            }
        ]
    });

});
parcelRegister("dGrvr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1d710f8117ed7a9a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $1d710f8117ed7a9a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "redirect.legacy-routing.flags.error.title",
        "defaultMessage": "We can't find the page you're looking for"
    },
    description: {
        "id": "redirect.legacy-routing.flags.error.description",
        "defaultMessage": "Check your spelling in the address bar. Or, try opening this site's home page to search or browse for the content."
    },
    goHome: {
        "id": "redirect.legacy-routing.flags.error.go-home",
        "defaultMessage": "Go to the homepage"
    }
});

});




parcelRegister("21A4f", function(module, exports) {

$parcel$export(module.exports, "LazyGlobalMailSettings", () => $cc4123579e370fa7$export$a133d90b2004a90e);
$parcel$export(module.exports, "default", () => $cc4123579e370fa7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $cc4123579e370fa7$export$a133d90b2004a90e = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("aJ7We"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/global-mail-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cc4123579e370fa7$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cc4123579e370fa7$export$a133d90b2004a90e,
        pageId: "global-mail-settings",
        shouldShowSpinner: false
    });

});
parcelRegister("aJ7We", function(module, exports) {

let $7cf443b818fefa24$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7cf443b818fefa24$var$load("8yfIj").then(()=>parcelRequire('7ROZZ'));

});



parcelRegister("9jp5b", function(module, exports) {

$parcel$export(module.exports, "globalSettingsCustomFieldsRouteEntry", () => $8b3a43559c4bd90e$export$d83c2e469d070766);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $cpdjw = parcelRequire("cpdjw");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $hESSV = parcelRequire("hESSV");

var $5pSYQ = parcelRequire("5pSYQ");

var $eUwrd = parcelRequire("eUwrd");
const $8b3a43559c4bd90e$export$d83c2e469d070766 = (0, $7NszV.createEntry)((0, $hESSV.globalSettingsCustomFieldsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.custom-fields-directory',
        component: (0, $eUwrd.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $cpdjw.customFieldsDirectoryResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eUwrd.LazyCustomFieldsDirectoryAdmin)
        ]
    }));

});
parcelRegister("cpdjw", function(module, exports) {

$parcel$export(module.exports, "customFieldsDirectoryResource", () => $dcd1379dc352c4e2$export$3d783f106e15b01a);

var $2M1hQ = parcelRequire("2M1hQ");


const $dcd1379dc352c4e2$export$3d783f106e15b01a = (0, $2M1hQ.createResource)({
    type: (0, $d558514bbbbc39cd$export$f237bae095c310e7),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("3ohIo"))
});

});
const $d558514bbbbc39cd$export$f237bae095c310e7 = 'CUSTOM_FIELDS_DIRECTORY';

parcelRegister("3ohIo", function(module, exports) {

let $27815ace1378ca6d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $27815ace1378ca6d$var$load("8mAnw").then(()=>parcelRequire('fFz2g'));

});


parcelRegister("hESSV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsCustomFieldsRoute", () => $a19ed616896ad98a$export$45e7d93edcc9507f);
const $a19ed616896ad98a$export$45e7d93edcc9507f = {
    name: 'global-settings-issues-custom-fields-view',
    path: '/secure/admin/ViewCustomFields(!default)?.jspa'
};

});

parcelRegister("eUwrd", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldsDirectoryAdmin", () => $0183f6c188d0635c$export$55a5c16f39a046af);
$parcel$export(module.exports, "default", () => $0183f6c188d0635c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $0183f6c188d0635c$export$55a5c16f39a046af = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9sRM7"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/custom-fields-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0183f6c188d0635c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0183f6c188d0635c$export$55a5c16f39a046af,
        pageId: "admin-pages-custom-fields-directory",
        shouldShowSpinner: true
    });

});
parcelRegister("9sRM7", function(module, exports) {

let $6e4071338d106a80$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6e4071338d106a80$var$load("h2MrD"),
    $6e4071338d106a80$var$load("bYT2S"),
    $6e4071338d106a80$var$load("dsiAd"),
    $6e4071338d106a80$var$load("2lIOR")
]).then(()=>parcelRequire('4ZT30'));

});



parcelRegister("427L2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRouteEntry", () => $654498d18bc8ccd3$export$5519b86c9ea602e1);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $gB79g = parcelRequire("gB79g");

var $aYyVm = parcelRequire("aYyVm");
const $654498d18bc8ccd3$export$5519b86c9ea602e1 = (0, $7NszV.createEntry)((0, $gB79g.globalSettingsIssuesExplicitFieldAssociationRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        component: (0, $aYyVm.LazyExplicitFieldsProjectListPage),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aYyVm.LazyExplicitFieldsProjectListPromise)
        ]
    }));

});
parcelRegister("gB79g", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRoute", () => $7a11591dcb8250ae$export$4f2c2d125c2b811a);
const $7a11591dcb8250ae$export$4f2c2d125c2b811a = {
    name: 'global-settings-issues-explicit-field-association-project-list',
    path: '/jira/settings/issues/explicit-field-association'
};

});

parcelRegister("aYyVm", function(module, exports) {

$parcel$export(module.exports, "LazyExplicitFieldsProjectListPromise", () => $95736e1c9d4aba6e$export$7b11685155ada84d);
$parcel$export(module.exports, "LazyExplicitFieldsProjectListPage", () => $95736e1c9d4aba6e$export$e81c180c4f4833e);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $95736e1c9d4aba6e$export$7b11685155ada84d = (0, $b7Svb.lazyForPaint)(()=>{
    return (0, $7yO8g.markAsProductBundleReady)((parcelRequire("lNJzs")).then((bundle)=>bundle.ExplicitFieldAssociationProjectListApp));
}, {
    moduleId: "./src/packages/admin-pages/explicit-field-association/project-list/src/index.tsx"
});
const $95736e1c9d4aba6e$export$e81c180c4f4833e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $95736e1c9d4aba6e$export$7b11685155ada84d,
        pageId: "jira-admin-pages-explicit-field-association-project-list",
        shouldShowSpinner: true
    });

});
parcelRegister("lNJzs", function(module, exports) {

let $fdf185fc6440a040$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fdf185fc6440a040$var$load("eNmuD"),
    $fdf185fc6440a040$var$load("cM9em"),
    $fdf185fc6440a040$var$load("fr9NE"),
    $fdf185fc6440a040$var$load("h2MrD"),
    $fdf185fc6440a040$var$load("bYT2S"),
    $fdf185fc6440a040$var$load("3r4bl")
]).then(()=>parcelRequire('61Yus'));

});



parcelRegister("6pwY1", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioConversationReviewRouteEntry", () => $c952d5f6c83845ad$export$8fa9ba2d9a9de6f8);

var $ffza4 = parcelRequire("ffza4");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $e2ctp = parcelRequire("e2ctp");

var $7NszV = parcelRequire("7NszV");

var $6Z2mh = parcelRequire("6Z2mh");

var $iReeE = parcelRequire("iReeE");

var $fVuS2 = parcelRequire("fVuS2");

var $cSD7y = parcelRequire("cSD7y");

var $kgvfG = parcelRequire("kgvfG");

var $6gWZ1 = parcelRequire("6gWZ1");
const $c952d5f6c83845ad$var$getConversationReviewResources = ()=>(0, $fVuS2.resources).conversationReview;
const $c952d5f6c83845ad$export$8fa9ba2d9a9de6f8 = (0, $7NszV.createEntry)((0, $iReeE.helpCenterSettingsAgentStudioConversationReviewRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio.conversation-review',
        component: (0, $cSD7y.componentWithFG)('enable_support_center_agent_studio_page', (0, $kgvfG.AgentStudioConversationReview), (0, $5lsNZ.default)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: (0, $6gWZ1.agentStudioNavigation),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            ...$c952d5f6c83845ad$var$getConversationReviewResources()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kgvfG.LazyAgentStudioConversationReviewPage)
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("iReeE", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioConversationReviewRoute", () => $51d40744c6e2396f$export$6d3fd8c6a2cde9ea);
const $51d40744c6e2396f$export$6d3fd8c6a2cde9ea = {
    name: 'helpcenter-settings-agent-studio-conversation-review',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/review/:conversationId?',
    exact: true
};

});

parcelRegister("fVuS2", function(module, exports) {

$parcel$export(module.exports, "resources", () => $8df30c8bb3ea88b7$export$bc99aaabaf7b70a7);

var $8EOlw = parcelRequire("8EOlw");
// packages/ai-mate/csm-conversation-review/src/ui/index.tsx
const $8df30c8bb3ea88b7$var$conversationRouteNameAndPathFields = {
    name: 'conversationReview',
    path: '/:conversationId?'
};
const $8df30c8bb3ea88b7$export$bc99aaabaf7b70a7 = {
    conversationReview: [
        (0, $8EOlw.conversationsResource),
        (0, $8EOlw.messagesResource)
    ]
};

});
parcelRegister("8EOlw", function(module, exports) {

$parcel$export(module.exports, "conversationsResource", () => $bf47a8c6bbf98863$export$666da16fe604f76a);
$parcel$export(module.exports, "messagesResource", () => $bf47a8c6bbf98863$export$e5eacbe7ea3678fe);

var $2M1hQ = parcelRequire("2M1hQ");

var $l5W5X = parcelRequire("l5W5X");

var $fHpHg = parcelRequire("fHpHg");

var $addeL = parcelRequire("addeL");

var $1gCPO = parcelRequire("1gCPO");

var $gIDhJ = parcelRequire("gIDhJ");
const $bf47a8c6bbf98863$var$TWENTY_FOUR_HOURS_IN_MS = 86400000;
const $bf47a8c6bbf98863$var$THIRTY_SECONDS_IN_MS = 30000;
const $bf47a8c6bbf98863$export$666da16fe604f76a = (0, $2M1hQ.createResource)({
    type: 'CONVERSATIONS',
    getKey: (ctx)=>(0, $addeL.serialiseFiltersQueryToSearchParams)((0, $addeL.getFiltersQuery)(ctx.query)).toString(),
    getData: async (ctx)=>{
        const headers = (0, $l5W5X.createHeaders)();
        const queryString = (0, $addeL.serialiseFiltersQueryToSearchParams)((0, $addeL.getFiltersQuery)(ctx.query));
        const versionedAPIPathParam = (0, $fHpHg.fg)('csm-conversation-review-v2-apis') ? 'v2' : 'v1';
        return fetch(`${(0, $1gCPO.API_GATEWAY_BASE_URL)}/assist/csm/${versionedAPIPathParam}/reporting/conversations?${queryString}`, {
            method: 'GET',
            headers: headers
        }).then((response)=>response.json()).then((data)=>{
            let conversations = [];
            // V1
            if ('conversations' in data) conversations = data.conversations;
            // V2
            if ('items' in data) conversations = data.items;
            conversations = conversations.filter((0, $gIDhJ.isNotExcludedOwner));
            const error = 'errorMessage' in data ? data : undefined;
            return {
                conversations: conversations,
                // V2 only, needs pagination support https://product-fabric.atlassian.net/browse/CSMAI-790
                hasNext: data.hasNext || false,
                // V2 only
                cursor: data.cursor,
                error: error
            };
        });
    },
    maxAge: $bf47a8c6bbf98863$var$TWENTY_FOUR_HOURS_IN_MS,
    isBrowserOnly: true
});
const $bf47a8c6bbf98863$export$e5eacbe7ea3678fe = (0, $2M1hQ.createResource)({
    type: 'CONVERSATION_MESSAGES',
    getKey: ({ match: match })=>String(match.params.conversationId),
    getData: async ({ match: match })=>{
        const conversationId = match.params.conversationId;
        if (!conversationId) return {
            messages: [],
            error: {
                errorMessage: 'No conversationId provided',
                errors: [
                    'Missing conversationId'
                ],
                statusCode: 400
            }
        };
        const versionedAPIPathParam = (0, $fHpHg.fg)('csm-conversation-review-v2-apis') ? 'v2' : 'v1';
        const headers = (0, $l5W5X.createHeaders)();
        return fetch(`${(0, $1gCPO.API_GATEWAY_BASE_URL)}/assist/csm/${versionedAPIPathParam}/reporting/conversations/${match.params.conversationId}/messages`, {
            method: 'GET',
            headers: headers
        }).then((response)=>response.json()).then((data)=>{
            let conversation;
            let messages = [];
            if (versionedAPIPathParam === 'v2') {
                conversation = data.conversation;
                messages = data.messages;
            } else messages = Array.isArray(data) ? data : [];
            const error = 'errorMessage' in data ? data : undefined;
            return {
                conversation: conversation,
                messages: messages,
                error: error
            };
        });
    },
    maxAge: $bf47a8c6bbf98863$var$THIRTY_SECONDS_IN_MS,
    isBrowserOnly: true
});

});
parcelRegister("l5W5X", function(module, exports) {

$parcel$export(module.exports, "CLOUD_ID_HEADER", () => $2345424ce7d8de90$export$220635283667d336);
$parcel$export(module.exports, "createHeaders", () => $2345424ce7d8de90$export$197579c449ddabf4);
$parcel$export(module.exports, "getRequestHeadersForAnnotation", () => $2345424ce7d8de90$export$61dc7354b71f29a6);
const $2345424ce7d8de90$var$PRODUCT_HEADER = 'x-product';
const $2345424ce7d8de90$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
const $2345424ce7d8de90$export$220635283667d336 = 'x-cloudid';
// Hardcode this for now for the MVP
const $2345424ce7d8de90$var$CONFLUENCE_PRODUCT = 'confluence';
const $2345424ce7d8de90$var$CSM_AI_EXPERIENCE_ID = 'csm-ai';
function $2345424ce7d8de90$export$197579c449ddabf4(init) {
    return new Headers({
        [$2345424ce7d8de90$var$PRODUCT_HEADER]: $2345424ce7d8de90$var$CONFLUENCE_PRODUCT,
        [$2345424ce7d8de90$var$EXPERIENCE_ID_HEADER]: $2345424ce7d8de90$var$CSM_AI_EXPERIENCE_ID,
        ...init || {}
    });
}
function $2345424ce7d8de90$export$61dc7354b71f29a6(cloudId) {
    const headers = $2345424ce7d8de90$export$197579c449ddabf4({
        ...cloudId ? {
            [$2345424ce7d8de90$export$220635283667d336]: cloudId
        } : {},
        'Content-Type': 'application/json'
    });
    return headers;
}

});

parcelRegister("addeL", function(module, exports) {

$parcel$export(module.exports, "BUILT_IN_FILTERS_BY_PARAM", () => $927788f319e2c534$export$f0b7684dd99bf7f2);
$parcel$export(module.exports, "isValidDateQueryValue", () => $927788f319e2c534$export$5e471de6d5eefc41);
$parcel$export(module.exports, "isFilterField", () => $927788f319e2c534$export$d8a98f7533d78e24);
$parcel$export(module.exports, "serialiseFiltersQueryToSearchParams", () => $927788f319e2c534$export$4966dc62d022f1b7);
$parcel$export(module.exports, "getFiltersQuery", () => $927788f319e2c534$export$ada173b2ef64ad5d);

var $8QpSo = parcelRequire("8QpSo");

var $gA1SI = parcelRequire("gA1SI");

var $fHpHg = parcelRequire("fHpHg");
const $927788f319e2c534$var$SUPPORTED_FILTER_TYPES = [
    'string',
    'enum',
    'number',
    'boolean',
    'date'
];
const $927788f319e2c534$export$f0b7684dd99bf7f2 = {
    type: {
        label: 'Conversation type',
        param: 'type',
        type: 'enum',
        options: [
            {
                label: 'Test',
                value: 'test'
            },
            {
                label: 'Real',
                value: 'real'
            },
            {
                label: 'Imported',
                value: 'imported'
            }
        ]
    },
    reviewStatus: {
        label: 'Conversation',
        param: 'reviewStatus',
        type: 'enum',
        options: [
            {
                label: 'Good conversation',
                value: 'good'
            },
            {
                label: 'Bad conversation',
                value: 'bad'
            },
            {
                label: 'Not review',
                value: 'not-reviewed'
            }
        ]
    },
    messageReviewStatus: {
        label: 'Response',
        param: 'messageReviewStatus',
        type: 'enum',
        options: [
            {
                label: 'Reviewed',
                value: 'reviewed'
            },
            {
                label: 'Not reviewed',
                value: 'not-reviewed'
            }
        ]
    },
    lastUpdated: {
        label: 'Last updated',
        param: 'lastUpdated',
        type: 'date'
    },
    feedback: {
        label: 'Customer feedback',
        param: 'feedback',
        type: 'enum',
        options: [
            {
                label: 'Good response',
                value: 'good'
            },
            {
                label: 'Bad response',
                value: 'bad'
            }
        ]
    },
    tags: {
        label: 'Review tags',
        param: 'tags',
        type: 'enum',
        options: [
            (0, $gA1SI.accuracyTagsGroup),
            (0, $gA1SI.languageTagsGroup),
            (0, $gA1SI.problemTagsGroup)
        ]
    }
};
const $927788f319e2c534$export$3060295572f39fc0 = Object.values($927788f319e2c534$export$f0b7684dd99bf7f2);
const $927788f319e2c534$export$7be404e211e7c3aa = new Map($927788f319e2c534$export$3060295572f39fc0.map((filter)=>[
        filter.param,
        filter
    ]));
const $927788f319e2c534$export$5e471de6d5eefc41 = (value)=>{
    if (typeof value === 'string') return [
        'today',
        'yesterday',
        'past7Days',
        'past30Days'
    ].includes(value);
    if (typeof value === 'object' && value) {
        if ('to' in value && 'from' in value) return [
            'string',
            'undefined'
        ].includes(typeof value.to) && [
            'string',
            'undefined'
        ].includes(typeof value.from);
        if ('to' in value) return [
            'string',
            'undefined'
        ].includes(typeof value.to);
        if ('from' in value) return [
            'string',
            'undefined'
        ].includes(typeof value.from);
    }
    return false;
};
const $927788f319e2c534$var$BUILT_IN_FILTER_QUERY_PARAMS = $927788f319e2c534$export$3060295572f39fc0.map(({ param: param })=>param);
const $927788f319e2c534$export$53c0ae385683a670 = (param)=>{
    return $927788f319e2c534$var$BUILT_IN_FILTER_QUERY_PARAMS.some((x)=>x === param);
};
const $927788f319e2c534$export$d8a98f7533d78e24 = (param)=>{
    return $927788f319e2c534$export$53c0ae385683a670(param);
};
const $927788f319e2c534$var$QUERY_STRING_PARSERS = {
    string: (value)=>value,
    number: (value)=>isNaN(Number(value)) ? undefined : Number(value),
    boolean: (value)=>[
            'true',
            'false'
        ].some((v)=>v === value) ? value : undefined,
    enum: (value)=>value.split(','),
    date: (value)=>{
        const betweenMatch = value.match(/^between\.(\d{4}-\d{2}-\d{2}(?:T.*Z)?)?\.(\d{4}-\d{2}-\d{2}(?:T.*Z)?)?$/);
        if (betweenMatch) {
            const [, a, b] = betweenMatch ?? [];
            const from = Boolean(a) ? a : undefined;
            const to = Boolean(b) ? b : undefined;
            return {
                from: from,
                to: to
            };
        }
        const fromToMatch = value.match(/^(from|to)\.(\d{4}-\d{2}-\d{2}(?:T.*Z)?)$/);
        if (fromToMatch) {
            const [, operation, date] = fromToMatch ?? [];
            return operation === 'from' ? {
                from: date
            } : {
                to: date
            };
        }
        if ($927788f319e2c534$export$5e471de6d5eefc41(value)) return value;
    }
};
const $927788f319e2c534$var$startOfDate = (date)=>{
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    return newDate;
};
const $927788f319e2c534$var$normaliseDateString = (date, endOfDate)=>{
    const isDateOnlyString = /^\d{4}-\d{2}-\d{2}$/.test(date);
    if (!isDateOnlyString) return new Date(date);
    const d = new Date(date);
    if (!endOfDate) d.setHours(0, 0, 0, 0);
    else d.setHours(23, 59, 59, 999);
    return d;
};
const $927788f319e2c534$export$2ca7fe1ffae7d4ec = {
    type: (value)=>[
            [
                'conversationType',
                String(value)
            ]
        ],
    lastUpdated: (value)=>{
        if (typeof value === 'string') switch(value){
            case 'today':
                return [
                    [
                        'updatedAfter',
                        $927788f319e2c534$var$startOfDate(new Date()).toISOString()
                    ]
                ];
            case 'yesterday':
                return [
                    [
                        'updatedAfter',
                        $927788f319e2c534$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 1))).toISOString()
                    ],
                    [
                        'updatedBefore',
                        $927788f319e2c534$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 0))).toISOString()
                    ]
                ];
            case 'past7Days':
                return [
                    [
                        'updatedAfter',
                        $927788f319e2c534$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 7))).toISOString()
                    ]
                ];
            case 'past30Days':
                return [
                    [
                        'updatedAfter',
                        $927788f319e2c534$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 30))).toISOString()
                    ]
                ];
        }
        if (typeof value === 'object') {
            if ('from' in value && 'to' in value && value.from && value.to) return [
                [
                    'updatedAfter',
                    $927788f319e2c534$var$normaliseDateString(value.from).toISOString()
                ],
                [
                    'updatedBefore',
                    $927788f319e2c534$var$normaliseDateString(value.to, true).toISOString()
                ]
            ];
            if ('from' in value && value.from) return [
                [
                    'updatedAfter',
                    $927788f319e2c534$var$normaliseDateString(value.from).toISOString()
                ]
            ];
            if ('to' in value && value.to) return [
                [
                    'updatedBefore',
                    $927788f319e2c534$var$normaliseDateString(value.to).toISOString()
                ]
            ];
        }
        return [];
    },
    feedback: (value)=>[
            [
                'customerFeedback',
                String(value)
            ]
        ],
    reviewStatus: (value)=>[
            [
                'conversationReviewStatus',
                String(value)
            ]
        ],
    messageReviewStatus: (value)=>[
            [
                'messageReviewStatus',
                String(value)
            ]
        ],
    tags: (value)=>[
            [
                'annotatedLabels',
                String(value)
            ]
        ]
};
const $927788f319e2c534$export$35eecdfcf8366c8d = {
    ...$927788f319e2c534$export$2ca7fe1ffae7d4ec,
    lastUpdated: (value)=>{
        if (typeof value === 'string') switch(value){
            case 'today':
                return [
                    [
                        'lastMessageTimestampAfter',
                        $927788f319e2c534$var$startOfDate(new Date()).toISOString()
                    ]
                ];
            case 'yesterday':
                return [
                    [
                        'lastMessageTimestampAfter',
                        $927788f319e2c534$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 1))).toISOString()
                    ],
                    [
                        'lastMessageTimestampBefore',
                        $927788f319e2c534$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 0))).toISOString()
                    ]
                ];
            case 'past7Days':
                return [
                    [
                        'lastMessageTimestampAfter',
                        $927788f319e2c534$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 7))).toISOString()
                    ]
                ];
            case 'past30Days':
                return [
                    [
                        'lastMessageTimestampAfter',
                        $927788f319e2c534$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 30))).toISOString()
                    ]
                ];
        }
        if (typeof value === 'object') {
            if ('from' in value && 'to' in value && value.from && value.to) return [
                [
                    'lastMessageTimestampAfter',
                    $927788f319e2c534$var$normaliseDateString(value.from).toISOString()
                ],
                [
                    'lastMessageTimestampBefore',
                    $927788f319e2c534$var$normaliseDateString(value.to, true).toISOString()
                ]
            ];
            if ('from' in value && value.from) return [
                [
                    'lastMessageTimestampAfter',
                    $927788f319e2c534$var$normaliseDateString(value.from).toISOString()
                ]
            ];
            if ('to' in value && value.to) return [
                [
                    'lastMessageTimestampBefore',
                    $927788f319e2c534$var$normaliseDateString(value.to).toISOString()
                ]
            ];
        }
        return [];
    }
};
const $927788f319e2c534$export$4966dc62d022f1b7 = (0, $8QpSo.default)((query)=>{
    return Object.entries(query).reduce((searchParams, [param, value])=>{
        const filters = $927788f319e2c534$export$7be404e211e7c3aa;
        const filter = filters.get(param);
        if (!filter || typeof value === 'undefined') return searchParams;
        const serialisers = (0, $fHpHg.fg)('csm-conversation-review-v2-apis') ? $927788f319e2c534$export$35eecdfcf8366c8d : $927788f319e2c534$export$2ca7fe1ffae7d4ec;
        const serialiser = serialisers[filter.param];
        if (filter.param in serialisers) {
            const params = serialiser(value);
            params.forEach(([key, value])=>{
                searchParams.append(key, value);
            });
            return searchParams;
        }
        return searchParams;
    }, new URLSearchParams());
});
const $927788f319e2c534$export$ada173b2ef64ad5d = (0, $8QpSo.default)((query)=>{
    const filters = $927788f319e2c534$export$7be404e211e7c3aa;
    return Object.entries(query).reduce((acc, [param, value])=>{
        if (!$927788f319e2c534$export$d8a98f7533d78e24(param)) return acc;
        const filter = filters.get(param);
        if (!filter) return acc;
        try {
            const parsedValue = $927788f319e2c534$var$QUERY_STRING_PARSERS[filter.type](value);
            return {
                ...acc,
                [param]: parsedValue
            };
        } catch (err) {
            return acc;
        }
    }, {});
});

});
parcelRegister("gA1SI", function(module, exports) {

$parcel$export(module.exports, "accuracyTagsGroup", () => $4ea589769f07f4c0$export$f592d323cd45fe0b);
$parcel$export(module.exports, "languageTagsGroup", () => $4ea589769f07f4c0$export$bd57e646b9ca4d6);
$parcel$export(module.exports, "problemTagsGroup", () => $4ea589769f07f4c0$export$f12ac532d5145c52);
const $4ea589769f07f4c0$export$40b86a6296d7a6cc = [
    {
        label: 'Accurate',
        value: 'accurate'
    },
    {
        label: 'Not accurate',
        value: 'not-accurate'
    }
];
const $4ea589769f07f4c0$export$f592d323cd45fe0b = {
    label: 'Accuracy',
    options: $4ea589769f07f4c0$export$40b86a6296d7a6cc
};
const $4ea589769f07f4c0$export$f1009b3c58b25589 = [
    {
        label: 'Easy to understand',
        value: 'easy-to-understand'
    },
    {
        label: 'Hard to understand',
        value: 'hard-to-understand'
    },
    {
        label: 'Concise',
        value: 'concise'
    },
    {
        label: 'Verbose',
        value: 'verbose'
    },
    {
        label: 'Grammatical errors',
        value: 'grammatical-errors'
    },
    {
        label: 'Formatting errors',
        value: 'formatting-errors'
    },
    {
        label: 'Incorrect tone',
        value: 'incorrect-tone'
    }
];
const $4ea589769f07f4c0$export$bd57e646b9ca4d6 = {
    label: 'Language',
    options: $4ea589769f07f4c0$export$f1009b3c58b25589
};
const $4ea589769f07f4c0$export$ea5f6f7f4df4b955 = [
    {
        label: 'Vague question',
        value: 'vaque-question'
    },
    {
        label: 'Irrelevant answer',
        value: 'irrelevant-answer'
    },
    {
        label: 'Human required',
        value: 'human-required'
    },
    {
        label: 'Content not retrieved',
        value: 'content-not-retrieved'
    },
    {
        label: 'Missing links',
        value: 'missing-links'
    },
    {
        label: 'Incorrect source',
        value: 'incorrect-source'
    }
];
const $4ea589769f07f4c0$export$f12ac532d5145c52 = {
    label: 'Problems',
    options: $4ea589769f07f4c0$export$ea5f6f7f4df4b955
};

});


parcelRegister("1gCPO", function(module, exports) {

$parcel$export(module.exports, "API_GATEWAY_BASE_URL", () => $e2cb911358721f06$export$d9629d145ee9933b);
const $e2cb911358721f06$export$d9629d145ee9933b = '/gateway/api';
function $e2cb911358721f06$export$23da1d24a38b0bde() {
    const hostname = window.location.hostname;
    return hostname.includes('localhost') || hostname.includes('.stg.internal.atlassian') || hostname.includes('.stg.atlassian');
}

});

parcelRegister("gIDhJ", function(module, exports) {

$parcel$export(module.exports, "isNotExcludedOwner", () => $64b73ca7a75ec3a7$export$f4707ebc2561f73d);
// Users who's conversations should be excluded from the list
const $64b73ca7a75ec3a7$export$9112ec7e6c72159b = [
    // Staging test bot
    'ari:cloud:identity::user/61c2c7a390cfd2007154ede7',
    // Prod test bot - 'cst-e2e-test-bot
    'ari:cloud:identity::user/61bc6c272f24e70068bf462a'
];
const $64b73ca7a75ec3a7$export$f4707ebc2561f73d = (c)=>{
    return !$64b73ca7a75ec3a7$export$9112ec7e6c72159b.includes(c.owner);
};

});



parcelRegister("kgvfG", function(module, exports) {

$parcel$export(module.exports, "LazyAgentStudioOverviewPage", () => $90b72030babf7447$export$5fa375047554c75c);
$parcel$export(module.exports, "AgentStudioOverviewPage", () => $90b72030babf7447$export$3c32337b9e9c89e5);
$parcel$export(module.exports, "LazyAgentStudioConversationReviewPage", () => $90b72030babf7447$export$e5bd431cce56c023);
$parcel$export(module.exports, "AgentStudioConversationReview", () => $90b72030babf7447$export$ba343ba7cdb4cca4);
$parcel$export(module.exports, "LazyAgentStudioSimulatorPage", () => $90b72030babf7447$export$89ec1205a5fbfa5a);
$parcel$export(module.exports, "AgentStudioSimulatorComponent", () => $90b72030babf7447$export$974fe2862709837d);
$parcel$export(module.exports, "LazyAgentStudioActionsPage", () => $90b72030babf7447$export$f1d6621241cd5379);
$parcel$export(module.exports, "AgentStudioActionsComponent", () => $90b72030babf7447$export$27f9057c3758bdae);
$parcel$export(module.exports, "agentStudioKnowledgePageEntryPoint", () => $90b72030babf7447$export$a9cf3691889e3b8);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $lEnZH = parcelRequire("lEnZH");

const $90b72030babf7447$export$5fa375047554c75c = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8FtAF"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/overview/index.tsx"
});
const $90b72030babf7447$export$3c32337b9e9c89e5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $90b72030babf7447$export$5fa375047554c75c,
        pageId: "help-center-settings-agent-studio-overview",
        shouldShowSpinner: true
    });

const $90b72030babf7447$export$e5bd431cce56c023 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("aYZgg"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/conversation-review/index.tsx"
});
const $90b72030babf7447$export$ba343ba7cdb4cca4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $90b72030babf7447$export$e5bd431cce56c023,
        pageId: "help-center-settings-agent-studio-conversation-review",
        shouldShowSpinner: true
    });

const $90b72030babf7447$export$89ec1205a5fbfa5a = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("b5JNQ"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/chat-simulator/index.tsx"
});
const $90b72030babf7447$export$974fe2862709837d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $90b72030babf7447$export$89ec1205a5fbfa5a,
        pageId: "help-center-settings-agent-studio-chat-simulator",
        shouldShowSpinner: false
    });

const $90b72030babf7447$export$f1d6621241cd5379 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9c6Je"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/actions/index.tsx"
});
const $90b72030babf7447$export$27f9057c3758bdae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $90b72030babf7447$export$f1d6621241cd5379,
        pageId: "help-center-settings-agent-studio-chat-actions",
        shouldShowSpinner: false
    });
const $90b72030babf7447$export$a9cf3691889e3b8 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $lEnZH.helpCenterSettingsAgentStudioKnowledgeAppEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("lEnZH", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioKnowledgeAppEntryPoint", () => $189f4d55daa7ac84$export$9436eec1eefc1701);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $26seq = parcelRequire("26seq");

const $189f4d55daa7ac84$export$9436eec1eefc1701 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("gbzDa")), {
        moduleId: "4b9cc39b"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                serviceHubDetailsQuery: {
                    parameters: $26seq.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("26seq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5995ee8670b27cd9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<067fa7fbcebd00e597b347ca915f6034>>
 * @relayHash fd0d1d5dce03064b407037920fb2720b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e73190d907fbed87beb0dcedf5843143674119a51c7aba6c42a0159b955a42d1
const $5995ee8670b27cd9$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e73190d907fbed87beb0dcedf5843143674119a51c7aba6c42a0159b955a42d1",
        "metadata": {},
        "name": "uiServiceHubDetailsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5995ee8670b27cd9$export$2e2bcd8739ae039 = $5995ee8670b27cd9$var$node;

});

parcelRegister("gbzDa", function(module, exports) {

let $bc894fef3fed7a3a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bc894fef3fed7a3a$var$load("9cjVg").then(()=>parcelRequire('kYkWF'));

});


parcelRegister("8FtAF", function(module, exports) {

let $64f91b20b6cff067$var$load = (parcelRequire("28QjX"))(4);
module.exports = $64f91b20b6cff067$var$load("2oAxu").then(()=>parcelRequire('5SMTp'));

});

parcelRegister("aYZgg", function(module, exports) {

let $7fef072e64034ecd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7fef072e64034ecd$var$load("dsiAd"),
    $7fef072e64034ecd$var$load("b8xTT")
]).then(()=>parcelRequire('iC69g'));

});

parcelRegister("b5JNQ", function(module, exports) {

let $8133b0d39b717007$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8133b0d39b717007$var$load("8GORt").then(()=>parcelRequire('e2jOc'));

});

parcelRegister("9c6Je", function(module, exports) {

let $6b1a7436b897d95d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6b1a7436b897d95d$var$load("8HauC").then(()=>parcelRequire('eJnmn'));

});


parcelRegister("6gWZ1", function(module, exports) {

$parcel$export(module.exports, "navigation", () => $3831f5d0598d36f4$export$428e7c787d57587d);
$parcel$export(module.exports, "agentStudioNavigation", () => $3831f5d0598d36f4$export$c198b13d4a0b8cea);

var $lmyls = parcelRequire("lmyls");

var $65ItF = parcelRequire("65ItF");

var $fBTqh = parcelRequire("fBTqh");

var $cSD7y = parcelRequire("cSD7y");
const $3831f5d0598d36f4$export$428e7c787d57587d = {
    sidebarId: (0, $lmyls.SIDEBAR_ID).HELP_CENTER_SETTINGS,
    menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
    sidebar: (0, $fBTqh.default)
};
const $3831f5d0598d36f4$export$c198b13d4a0b8cea = {
    sidebarId: (0, $lmyls.SIDEBAR_ID).HELP_CENTER_SETTINGS,
    menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
    sidebar: (0, $fBTqh.default),
    horizontal: (0, $cSD7y.componentWithFG)('enable_support_center_agent_studio_page', (0, $65ItF.AsyncSupportCenterHorizontalNav), ()=>null)
};

});
parcelRegister("65ItF", function(module, exports) {

$parcel$export(module.exports, "AsyncSupportCenterHorizontalNav", () => $bc8ad4b74f43add3$export$123fcd6868b7ea3f);

var $5uXOq = parcelRequire("5uXOq");

var $kkd2O = parcelRequire("kkd2O");

var $b7Svb = parcelRequire("b7Svb");

const $bc8ad4b74f43add3$var$LazyHorizontalSupportCenterNav = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("5V2bU")).then(({ HorizontalNav: HorizontalNav })=>HorizontalNav), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/horizontal-nav/main.tsx"
});
const $bc8ad4b74f43add3$export$123fcd6868b7ea3f = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkd2O.default), {
        name: "help-center-settings-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bc8ad4b74f43add3$var$LazyHorizontalSupportCenterNav, null));
};

});
parcelRegister("5V2bU", function(module, exports) {

let $44f3f9be3b165cad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $44f3f9be3b165cad$var$load("e5tVz").then(()=>parcelRequire('70kLi'));

});


parcelRegister("fBTqh", function(module, exports) {

$parcel$export(module.exports, "default", () => $43189553e9fc21a2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

const $43189553e9fc21a2$export$ea77f88c1b841127 = (0, $b7Svb.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("bdYMF")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/help-center-settings/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $43189553e9fc21a2$var$HelpCenterSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($43189553e9fc21a2$export$ea77f88c1b841127, null)));
$43189553e9fc21a2$var$HelpCenterSettingsSidebar.displayName = 'HelpCenterSettingsSidebar';
var $43189553e9fc21a2$export$2e2bcd8739ae039 = $43189553e9fc21a2$var$HelpCenterSettingsSidebar;

});
parcelRegister("bdYMF", function(module, exports) {

let $82c00f0d63b9cb2d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $82c00f0d63b9cb2d$var$load("fQbJ3").then(()=>parcelRequire('5NHpB'));

});




parcelRegister("9sgxL", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioKnowledgeRouteEntry", () => $34dc2eb2639959d6$export$6d22d206a282d6a9);

var $4R6GH = parcelRequire("4R6GH");

var $e2ctp = parcelRequire("e2ctp");

var $5lsNZ = parcelRequire("5lsNZ");

var $fpjJX = parcelRequire("fpjJX");

var $7NszV = parcelRequire("7NszV");

var $6Z2mh = parcelRequire("6Z2mh");

var $adxFh = parcelRequire("adxFh");

var $gLUA7 = parcelRequire("gLUA7");

var $6gWZ1 = parcelRequire("6gWZ1");

var $kgvfG = parcelRequire("kgvfG");
const $34dc2eb2639959d6$export$6d22d206a282d6a9 = (0, $7NszV.createEntry)((0, $gLUA7.helpCenterSettingsAgentStudioKnowledgeRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio-knowledge',
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('enable_support_center_agent_studio_page') ? (0, $kgvfG.agentStudioKnowledgePageEntryPoint) : undefined;
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: (0, $6gWZ1.agentStudioNavigation),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $adxFh.knowledgeSourcesResource)
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("adxFh", function(module, exports) {

$parcel$export(module.exports, "knowledgeSourcesResource", () => $84b7f98c7a96b1e7$export$98ae61e83ea268b1);

var $2M1hQ = parcelRequire("2M1hQ");
const $84b7f98c7a96b1e7$var$TWENTY_FOUR_HOURS_IN_MS = 86400000;

const $84b7f98c7a96b1e7$export$98ae61e83ea268b1 = (0, $2M1hQ.createResource)({
    type: 'CSM_AGENT_CONFIGURATION_KNOWLEDGE_SOURCES',
    getKey: ()=>'knowledge-sources',
    getDataLoader: ()=>(parcelRequire("fTxav")),
    maxAge: $84b7f98c7a96b1e7$var$TWENTY_FOUR_HOURS_IN_MS,
    isBrowserOnly: true
});

});
parcelRegister("fTxav", function(module, exports) {

let $b925b8a03e0257ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b925b8a03e0257ca$var$load("10LUZ").then(()=>parcelRequire('d67LW'));

});


parcelRegister("gLUA7", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioKnowledgeRoute", () => $d0a24339f6e35337$export$f1df26b41169b43);
const $d0a24339f6e35337$export$f1df26b41169b43 = {
    name: 'helpcenter-settings-agent-studio-knowledge',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/knowledge',
    exact: true
};

});


parcelRegister("8wIny", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioChatSimulatorRouteEntry", () => $ad87a7ca26339056$export$c4240053c0a5eb9c);

var $ffza4 = parcelRequire("ffza4");

var $e2ctp = parcelRequire("e2ctp");

var $5lsNZ = parcelRequire("5lsNZ");

var $fpjJX = parcelRequire("fpjJX");

var $7NszV = parcelRequire("7NszV");

var $6Z2mh = parcelRequire("6Z2mh");

var $9MsoF = parcelRequire("9MsoF");

var $cSD7y = parcelRequire("cSD7y");

var $6gWZ1 = parcelRequire("6gWZ1");

var $kgvfG = parcelRequire("kgvfG");
const $ad87a7ca26339056$export$c4240053c0a5eb9c = (0, $7NszV.createEntry)((0, $9MsoF.helpCenterSettingsAgentStudioChatSimulatorRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio-chat-simulator',
        component: (0, $cSD7y.componentWithFG)('enable_support_center_agent_studio_page', (0, $kgvfG.AgentStudioSimulatorComponent), (0, $5lsNZ.default)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: (0, $6gWZ1.agentStudioNavigation),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kgvfG.LazyAgentStudioSimulatorPage)
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("9MsoF", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioChatSimulatorRoute", () => $6d8e604aaf253ef7$export$426c3d828fdab50e);
const $6d8e604aaf253ef7$export$426c3d828fdab50e = {
    name: 'helpcenter-settings-agent-studio-chat-simulator',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/simulator',
    exact: true
};

});


parcelRegister("2krv1", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioActionsRouteEntry", () => $3d7af2fe877a2988$export$47cbfd555c8570c0);

var $ffza4 = parcelRequire("ffza4");

var $e2ctp = parcelRequire("e2ctp");

var $5lsNZ = parcelRequire("5lsNZ");

var $fpjJX = parcelRequire("fpjJX");

var $7NszV = parcelRequire("7NszV");

var $6Z2mh = parcelRequire("6Z2mh");

var $gFEDq = parcelRequire("gFEDq");

var $cSD7y = parcelRequire("cSD7y");

var $6gWZ1 = parcelRequire("6gWZ1");

var $kgvfG = parcelRequire("kgvfG");
const $3d7af2fe877a2988$export$47cbfd555c8570c0 = (0, $7NszV.createEntry)((0, $gFEDq.helpCenterSettingsAgentStudioActionsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio-actions',
        component: (0, $cSD7y.componentWithFG)('csm-actions-framework-visibility', (0, $kgvfG.AgentStudioActionsComponent), (0, $5lsNZ.default)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: (0, $6gWZ1.agentStudioNavigation),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kgvfG.LazyAgentStudioActionsPage)
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("gFEDq", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioActionsRoute", () => $f90b0e5d1a951de0$export$5cfc987a071755e7);
const $f90b0e5d1a951de0$export$5cfc987a071755e7 = {
    name: 'helpcenter-settings-agent-studio-actions',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/actions',
    exact: true
};

});


parcelRegister("alZMU", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioRouteEntry", () => $331ec935012c0277$export$5328c10e46075e4d);

var $ffza4 = parcelRequire("ffza4");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $6Z2mh = parcelRequire("6Z2mh");

var $e2ctp = parcelRequire("e2ctp");

var $7NszV = parcelRequire("7NszV");

var $k2Bg0 = parcelRequire("k2Bg0");

var $cSD7y = parcelRequire("cSD7y");

var $kgvfG = parcelRequire("kgvfG");

var $6gWZ1 = parcelRequire("6gWZ1");
const $331ec935012c0277$export$5328c10e46075e4d = (0, $7NszV.createEntry)((0, $k2Bg0.helpCenterSettingsAgentStudioRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio',
        component: (0, $cSD7y.componentWithFG)('enable_support_center_agent_studio_page', (0, $kgvfG.AgentStudioOverviewPage), (0, $5lsNZ.default)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: (0, $6gWZ1.agentStudioNavigation),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kgvfG.LazyAgentStudioOverviewPage)
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("k2Bg0", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioRoute", () => $22c785b6be90cb91$export$b8b0efb16984db50);
const $22c785b6be90cb91$export$b8b0efb16984db50 = {
    name: 'helpcenter-settings-agent-studio',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent',
    exact: true
};

});


parcelRegister("6u3qv", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsArticlesRouteEntry", () => $32bcb1fc70286108$export$dcf98310ab461eb0);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $9kAH1 = parcelRequire("9kAH1");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $8N6gO = parcelRequire("8N6gO");
const $32bcb1fc70286108$export$dcf98310ab461eb0 = (0, $7NszV.createEntry)((0, $9kAH1.helpCenterSettingsArticlesRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.articles',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('enable_articles_page_csm') ? (0, $8N6gO.helpCenterSettingArticlesAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("9kAH1", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsArticlesRoute", () => $412bb66633bbef70$export$6445613754b0db30);
const $412bb66633bbef70$export$6445613754b0db30 = {
    name: 'helpcenter-settings-articles',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles',
    exact: true
};

});

parcelRegister("8N6gO", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingArticlesAppPageEntryPoint", () => $9b45af5968e8d332$export$5f683051fd990adb);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $630bL = parcelRequire("630bL");
const $9b45af5968e8d332$export$5f683051fd990adb = (0, $lkFvK.createPageEntryPoint)({
    main: $630bL.HelpCenterSettingsArticlesAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("630bL", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsArticlesAppEntryPoint", () => $ba27834c1284a762$export$ba888b162abf6368);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $ba27834c1284a762$export$ba888b162abf6368 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("aJrO1")), {
        moduleId: "8c0e0839"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("aJrO1", function(module, exports) {

let $7d03ad0831f2b868$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7d03ad0831f2b868$var$load("dWXjP").then(()=>parcelRequire('eFox7'));

});




parcelRegister("j2SDi", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsArticlesViewArticleRouteEntry", () => $88e0a8f5dda84f20$export$d14f4c2b666bbb54);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $6zrpv = parcelRequire("6zrpv");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $3Ap7x = parcelRequire("3Ap7x");
const $88e0a8f5dda84f20$export$d14f4c2b666bbb54 = (0, $7NszV.createEntry)((0, $6zrpv.helpCenterSettingsArticlesViewArticleRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.articles-view-article',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('enable_articles_page_csm') ? (0, $3Ap7x.helpCenterSettingViewArticleAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("6zrpv", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsArticlesViewArticleRoute", () => $2f69465d47479faa$export$c5c6fbcb1f26b87b);
const $2f69465d47479faa$export$c5c6fbcb1f26b87b = {
    name: 'helpcenter-settings-articles-view-article',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles/:articleId',
    exact: true
};

});

parcelRegister("3Ap7x", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingViewArticleAppPageEntryPoint", () => $aeb454237a95509d$export$7f08ea9d5c2912ad);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $ji0Vr = parcelRequire("ji0Vr");
const $aeb454237a95509d$export$7f08ea9d5c2912ad = (0, $lkFvK.createPageEntryPoint)({
    main: $ji0Vr.HelpCenterSettingsArticlesViewArticleAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("ji0Vr", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsArticlesViewArticleAppEntryPoint", () => $96a8b60127af2d58$export$31df33b35c5b2ee);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $96a8b60127af2d58$export$31df33b35c5b2ee = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("drDAL")), {
        moduleId: "6cb514e3"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("drDAL", function(module, exports) {

let $9c9c821e0703bddf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9c9c821e0703bddf$var$load("2fGE9").then(()=>parcelRequire('1yKGc'));

});




parcelRegister("e48vl", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCreateArticleRouteEntry", () => $57dff6ea3b7a57a0$export$882f07b6a7d364c7);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $1huwb = parcelRequire("1huwb");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $flVeW = parcelRequire("flVeW");
const $57dff6ea3b7a57a0$export$882f07b6a7d364c7 = (0, $7NszV.createEntry)((0, $1huwb.helpCenterSettingsCreateArticleRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.create-article',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('enable_articles_page_csm') ? (0, $flVeW.helpCenterSettingCreateArticleAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("1huwb", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCreateArticleRoute", () => $7549b70b1a3f48a6$export$6f4350070b3391d2);
const $7549b70b1a3f48a6$export$6f4350070b3391d2 = {
    name: 'helpcenter-settings-create-article',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles/:articleId/space/:spaceKey/edit',
    query: [
        'draftShareId?',
        'topicId?'
    ]
};

});

parcelRegister("flVeW", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingCreateArticleAppPageEntryPoint", () => $e1fa58280d3204d3$export$2dedebb94d500afa);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $ljlmd = parcelRequire("ljlmd");
const $e1fa58280d3204d3$export$2dedebb94d500afa = (0, $lkFvK.createPageEntryPoint)({
    main: $ljlmd.HelpCenterSettingsCreateArticleAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("ljlmd", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsCreateArticleAppEntryPoint", () => $fd79767a8e638019$export$dd82613d258b9120);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $fd79767a8e638019$export$dd82613d258b9120 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("8Zc83")), {
        moduleId: "d6a89104"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("8Zc83", function(module, exports) {

let $68ad6dc926981474$var$load = (parcelRequire("28QjX"))(4);
module.exports = $68ad6dc926981474$var$load("66WJW").then(()=>parcelRequire('iDGEe'));

});




parcelRegister("jSJ1v", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerAccessRouteEntry", () => $1e207cd846476f87$export$5cfeb28cf3c43d24);

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $hyajn = parcelRequire("hyajn");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $7aOCJ = parcelRequire("7aOCJ");
const $1e207cd846476f87$export$5cfeb28cf3c43d24 = (0, $7NszV.createEntry)((0, $hyajn.helpCenterSettingsCustomerAccessRoute), ()=>({
        perfMetricKey: 'help-center-settings.customer-access',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $cSD7y.componentWithFG)('jcs_master_flag', (0, $7aOCJ.HelpCenterSettingsCustomerAccess), (0, $5lsNZ.default)),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7aOCJ.LazyHelpCenterSettingsCustomerAccess)
        ],
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("hyajn", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerAccessRoute", () => $956ef53bef7f74b8$export$5adf9b8f07e4dd7b);
const $956ef53bef7f74b8$export$5adf9b8f07e4dd7b = {
    name: 'helpcenter-settings-customer-access',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/customer-access'
};

});

parcelRegister("7aOCJ", function(module, exports) {

$parcel$export(module.exports, "LazyHelpCenterSettingsCustomerAccess", () => $c2a27ef145addce1$export$2c331ddbdb6fb4ef);
$parcel$export(module.exports, "HelpCenterSettingsCustomerAccess", () => $c2a27ef145addce1$export$ab643bb246877df);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $c2a27ef145addce1$export$2c331ddbdb6fb4ef = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8bPb3"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/customer-access/src/index.tsx"
});
const $c2a27ef145addce1$export$ab643bb246877df = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c2a27ef145addce1$export$2c331ddbdb6fb4ef,
        pageId: "help-center-settings-customer-access",
        shouldShowSpinner: true
    });

});
parcelRegister("8bPb3", function(module, exports) {

let $5f670c88f1e623d6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5f670c88f1e623d6$var$load("dadpa").then(()=>parcelRequire('lQS7P'));

});



parcelRegister("lpcHT", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerAccessOldRouteEntry", () => $5f5d8f83c0f9af02$export$ee54e5be6b22301a);

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $jX8dV = parcelRequire("jX8dV");

var $6Z2mh = parcelRequire("6Z2mh");

var $6NkHq = parcelRequire("6NkHq");

var $6gWZ1 = parcelRequire("6gWZ1");

var $7aOCJ = parcelRequire("7aOCJ");
const $5f5d8f83c0f9af02$export$ee54e5be6b22301a = (0, $7NszV.createEntry)((0, $jX8dV.helpCenterSettingsCustomerAccessOldRoute), ()=>({
        perfMetricKey: 'help-center-settings.customer-access',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $cSD7y.componentWithFG)('berry-4386-add-helpcenterid-to-routes', (0, $6NkHq.NotFound), (0, $cSD7y.componentWithFG)('jcs_master_flag', (0, $7aOCJ.HelpCenterSettingsCustomerAccess), (0, $5lsNZ.default))),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7aOCJ.LazyHelpCenterSettingsCustomerAccess)
        ],
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("jX8dV", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerAccessOldRoute", () => $603d6600575c4975$export$bcfb7fe3b9c31430);
const $603d6600575c4975$export$bcfb7fe3b9c31430 = {
    name: 'helpcenter-settings-customer-access-old',
    path: '/jira/helpcenter/projects/:projectKey/settings/customer-access'
};

});

parcelRegister("6NkHq", function(module, exports) {

$parcel$export(module.exports, "NotFound", () => $7f8c6894e16771dc$export$271f9f08425019c7);

var $5uXOq = parcelRequire("5uXOq");

var $beRD7 = parcelRequire("beRD7");

var $lODMY = parcelRequire("lODMY");

var $jcw0u = parcelRequire("jcw0u");
const $7f8c6894e16771dc$var$useLocation = (0, $lODMY.createRouterSelector)(({ location: location })=>location.pathname);
const $7f8c6894e16771dc$export$271f9f08425019c7 = ()=>{
    const pathname = $7f8c6894e16771dc$var$useLocation();
    (0, $5uXOq.useEffect)(()=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'serviceHubPageNotFound',
                packageName: 'jiraServicedeskCustomerServiceServiceHubs',
                teamName: 'boysenberry'
            },
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                pathname: pathname
            }
        });
    }, [
        pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.NotFoundErrorPageAsync), null);
};

});


parcelRegister("fdHNd", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerNotificationsRouteEntry", () => $7e976989bafafd81$export$4e4f38417d267cf6);

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $6cuak = parcelRequire("6cuak");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $jp5Vz = parcelRequire("jp5Vz");
const $7e976989bafafd81$export$4e4f38417d267cf6 = (0, $7NszV.createEntry)((0, $6cuak.helpCenterSettingsCustomerNotificationsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.customer-notifications',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $cSD7y.componentWithFG)('jcs_master_flag', (0, $jp5Vz.HelpCenterSettingsCustomerNotifications), (0, $5lsNZ.default)),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jp5Vz.LazyHelpCenterSettingsCustomerNotifications)
        ],
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("6cuak", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerNotificationsRoute", () => $e11b5b1fd2c66498$export$88fcb9acf40a0827);
const $e11b5b1fd2c66498$export$88fcb9acf40a0827 = {
    name: 'helpcenter-settings-customer-notifications',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/customer-notifications'
};

});

parcelRegister("jp5Vz", function(module, exports) {

$parcel$export(module.exports, "LazyHelpCenterSettingsCustomerNotifications", () => $ce252471da0db8c1$export$b2b6550dec008a98);
$parcel$export(module.exports, "HelpCenterSettingsCustomerNotifications", () => $ce252471da0db8c1$export$2f2f18f57014444a);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $ce252471da0db8c1$export$b2b6550dec008a98 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iXzdr"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/customer-notifications/src/index.tsx"
});
const $ce252471da0db8c1$export$2f2f18f57014444a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ce252471da0db8c1$export$b2b6550dec008a98,
        pageId: "help-center-settings-customer-notifications",
        shouldShowSpinner: true
    });

});
parcelRegister("iXzdr", function(module, exports) {

let $dcd90dce395d9d79$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dcd90dce395d9d79$var$load("1Aiz0").then(()=>parcelRequire('7QYfj'));

});



parcelRegister("1BQG3", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerNotificationsOldRouteEntry", () => $73eb0aa0d8ef21c0$export$3d0b88f14285c242);

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $jDJb4 = parcelRequire("jDJb4");

var $6Z2mh = parcelRequire("6Z2mh");

var $6NkHq = parcelRequire("6NkHq");

var $6gWZ1 = parcelRequire("6gWZ1");

var $jp5Vz = parcelRequire("jp5Vz");
const $73eb0aa0d8ef21c0$export$3d0b88f14285c242 = (0, $7NszV.createEntry)((0, $jDJb4.helpCenterSettingsCustomerNotificationsOldRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.customer-notifications',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $cSD7y.componentWithFG)('berry-4386-add-helpcenterid-to-routes', (0, $6NkHq.NotFound), (0, $cSD7y.componentWithFG)('jcs_master_flag', (0, $jp5Vz.HelpCenterSettingsCustomerNotifications), (0, $5lsNZ.default))),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jp5Vz.LazyHelpCenterSettingsCustomerNotifications)
        ],
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("jDJb4", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerNotificationsOldRoute", () => $e84914640fb09c7a$export$fb837fce734b8218);
const $e84914640fb09c7a$export$fb837fce734b8218 = {
    name: 'helpcenter-settings-customer-notifications-old',
    path: '/jira/helpcenter/projects/:projectKey/settings/customer-notifications'
};

});


parcelRegister("guURi", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsDetailsRouteEntry", () => $0315c5537179bf15$export$a9c03c3c37251dd3);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $hTsNV = parcelRequire("hTsNV");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $gD7KY = parcelRequire("gD7KY");
const $0315c5537179bf15$export$a9c03c3c37251dd3 = (0, $7NszV.createEntry)((0, $hTsNV.helpCenterSettingsDetailsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.details',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs_master_flag') ? (0, $gD7KY.helpCenterSettingDetailsAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("hTsNV", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsDetailsRoute", () => $c84b441b3d2b2a1a$export$f54c1546ddea019b);
const $c84b441b3d2b2a1a$export$f54c1546ddea019b = {
    name: 'helpcenter-settings-details',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/details',
    exact: true
};

});

parcelRegister("gD7KY", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingDetailsAppPageEntryPoint", () => $145a2f3e4b766427$export$c52cb026d0dc8ed7);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $16x51 = parcelRequire("16x51");
const $145a2f3e4b766427$export$c52cb026d0dc8ed7 = (0, $lkFvK.createPageEntryPoint)({
    main: $16x51.helpCenterSettingDetailsAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("16x51", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingDetailsAppEntryPoint", () => $f508c84d71030ec3$export$519ec4ef3722cb47);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $26seq = parcelRequire("26seq");

const $f508c84d71030ec3$export$519ec4ef3722cb47 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("bNl9I")), {
        moduleId: "e9a696a2"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                serviceHubDetailsQuery: {
                    parameters: $26seq.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("bNl9I", function(module, exports) {

let $8964ae67a9e358f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8964ae67a9e358f5$var$load("4CcYk").then(()=>parcelRequire('kGNbu'));

});




parcelRegister("6RCDC", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsEmailRouteEntry", () => $a5ff5d25549b46ce$export$f95717dac47e4db3);

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $9wcYQ = parcelRequire("9wcYQ");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $lUb7T = parcelRequire("lUb7T");
const $a5ff5d25549b46ce$export$f95717dac47e4db3 = (0, $7NszV.createEntry)((0, $9wcYQ.helpCenterSettingsEmailRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.email',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $cSD7y.componentWithFG)('jcs_master_flag', (0, $lUb7T.HelpCenterSettingsEmail), (0, $5lsNZ.default)),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lUb7T.LazyHelpCenterSettingsEmail)
        ],
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("9wcYQ", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsEmailRoute", () => $1e498e8ebd1ddcd1$export$4515288a48c62087);
const $1e498e8ebd1ddcd1$export$4515288a48c62087 = {
    name: 'helpcenter-settings-email',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/email',
    exact: true
};

});

parcelRegister("lUb7T", function(module, exports) {

$parcel$export(module.exports, "LazyHelpCenterSettingsEmail", () => $6353b69d503ce9ba$export$e090cd3a62343249);
$parcel$export(module.exports, "HelpCenterSettingsEmail", () => $6353b69d503ce9ba$export$962f20e752738967);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $6353b69d503ce9ba$export$e090cd3a62343249 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("378Lo")), {
    moduleId: "./src/packages/spa-apps/help-center-settings/email/src/index.tsx"
});
const $6353b69d503ce9ba$export$962f20e752738967 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6353b69d503ce9ba$export$e090cd3a62343249,
        pageId: "help-center-settings-email",
        shouldShowSpinner: true
    });

});
parcelRegister("378Lo", function(module, exports) {

let $2448d2c542a2d71e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2448d2c542a2d71e$var$load("aUqEr").then(()=>parcelRequire('7r8zn'));

});



parcelRegister("lCetQ", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsEmailOldRouteEntry", () => $44c258e4dad582a3$export$bf5ff4f31bc0e007);

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $tCcuL = parcelRequire("tCcuL");

var $6Z2mh = parcelRequire("6Z2mh");

var $6NkHq = parcelRequire("6NkHq");

var $6gWZ1 = parcelRequire("6gWZ1");

var $lUb7T = parcelRequire("lUb7T");
const $44c258e4dad582a3$export$bf5ff4f31bc0e007 = (0, $7NszV.createEntry)((0, $tCcuL.helpCenterSettingsEmailOldRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.email',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $cSD7y.componentWithFG)('berry-4386-add-helpcenterid-to-routes', (0, $6NkHq.NotFound), (0, $cSD7y.componentWithFG)('jcs_master_flag', (0, $lUb7T.HelpCenterSettingsEmail), (0, $5lsNZ.default))),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lUb7T.LazyHelpCenterSettingsEmail)
        ],
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("tCcuL", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsEmailOldRoute", () => $82ce95272fc4d8cf$export$912dbe9f3d31fc50);
const $82ce95272fc4d8cf$export$912dbe9f3d31fc50 = {
    name: 'helpcenter-settings-email-old',
    path: '/jira/helpcenter/projects/:projectKey/settings/email',
    exact: true
};

});


parcelRegister("avQ9D", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteRouteEntry", () => $bdc73697774975eb$export$59cfd0dfcd1b4311);

var $6Z2mh = parcelRequire("6Z2mh");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $aQelL = parcelRequire("aQelL");

var $lmyls = parcelRequire("lmyls");

var $fBTqh = parcelRequire("fBTqh");

var $hVOfU = parcelRequire("hVOfU");

var $4R6GH = parcelRequire("4R6GH");

var $6gj7h = parcelRequire("6gj7h");
const $bdc73697774975eb$export$59cfd0dfcd1b4311 = (0, $7NszV.createEntry)((0, $aQelL.helpCenterSettingsSupportWebsiteRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.support-website',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).HELP_CENTER_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
            sidebar: (0, $fBTqh.default),
            horizontal: (0, $hVOfU.AsyncSupportWebsiteNav)
        },
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('enable_support_site_details_csm') ? (0, $6gj7h.HelpCenterSettingsSupportWebsiteEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)()
        ]
    }));

});
parcelRegister("aQelL", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteRoute", () => $fc3d051dfa242c89$export$c59ea9b870a0e809);
const $fc3d051dfa242c89$export$c59ea9b870a0e809 = {
    name: 'helpcenter-settings-support-website-details',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website',
    exact: true
};

});

parcelRegister("hVOfU", function(module, exports) {

$parcel$export(module.exports, "AsyncSupportWebsiteNav", () => $fe8481e5cfa634b6$export$8887f9c4b5829b78);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $fe8481e5cfa634b6$var$LazySupportWebsiteNav = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("jGpK1")).then(({ SupportWebsiteNav: SupportWebsiteNav })=>SupportWebsiteNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-csm/support-website/src/ui/index.tsx"
});
const $fe8481e5cfa634b6$export$8887f9c4b5829b78 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-csm-support-site-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fe8481e5cfa634b6$var$LazySupportWebsiteNav, null));

});
parcelRegister("jGpK1", function(module, exports) {

let $e545e83bb0244646$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e545e83bb0244646$var$load("2ssHA").then(()=>parcelRequire('9fzxT'));

});


parcelRegister("6gj7h", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteEntryPoint", () => $a1985909a25e76e4$export$91f75c485220b109);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $eiTxd = parcelRequire("eiTxd");
const $a1985909a25e76e4$export$91f75c485220b109 = (0, $lkFvK.createPageEntryPoint)({
    main: $eiTxd.HelpCenterSettingsSupportWebsiteAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("eiTxd", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteAppEntryPoint", () => $fccdb49574d19a8f$export$43c72a7c514122ed);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $fccdb49574d19a8f$export$43c72a7c514122ed = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("fzDFe")), {
        moduleId: "6e5d67aa"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("fzDFe", function(module, exports) {

let $b568e45fefdf6315$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b568e45fefdf6315$var$load("5Xo4r").then(()=>parcelRequire('hPBOL'));

});




parcelRegister("f7vKZ", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteOverviewRouteEntry", () => $032e280ea85bb67e$export$eb728930eecb0b42);

var $4R6GH = parcelRequire("4R6GH");

var $6Z2mh = parcelRequire("6Z2mh");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $69WMA = parcelRequire("69WMA");

var $fBTqh = parcelRequire("fBTqh");

var $lmyls = parcelRequire("lmyls");

var $hVOfU = parcelRequire("hVOfU");

var $cfV2M = parcelRequire("cfV2M");
const $032e280ea85bb67e$export$eb728930eecb0b42 = (0, $7NszV.createEntry)((0, $69WMA.helpCenterSettingsSupportWebsiteOverviewRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.support-website.overview',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).HELP_CENTER_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
            sidebar: (0, $fBTqh.default),
            horizontal: (0, $hVOfU.AsyncSupportWebsiteNav)
        },
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('enable_support_site_details_csm') ? (0, $cfV2M.HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)()
        ]
    }));

});
parcelRegister("69WMA", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteOverviewRoute", () => $8aa73486df339929$export$64e95782b19caeac);
const $8aa73486df339929$export$64e95782b19caeac = {
    name: 'helpcenter-settings-support-website-details-overview',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website/overview',
    exact: true
};

});

parcelRegister("cfV2M", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint", () => $5c12c4d46de7a315$export$780fd78388c1f1d1);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5Xswi = parcelRequire("5Xswi");
const $5c12c4d46de7a315$export$780fd78388c1f1d1 = (0, $lkFvK.createPageEntryPoint)({
    main: $5Xswi.HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("5Xswi", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint", () => $71148ffb5b8df6c9$export$780fd78388c1f1d1);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $65dSj = parcelRequire("65dSj");

const $71148ffb5b8df6c9$export$780fd78388c1f1d1 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("js32O")), {
        moduleId: "d27a8c99"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                serviceHubDetailsQuery: {
                    parameters: $65dSj.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("65dSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $739483af15ac3c69$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<086fc8a80466dbab70300b14e65169cd>>
 * @relayHash 97f7e29b9656db740fc7b8aa0a23f4d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 00edac7f68a877717beb0b54982122a8afa0dbc0016892d64c3d13228d7c8fb7
const $739483af15ac3c69$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "00edac7f68a877717beb0b54982122a8afa0dbc0016892d64c3d13228d7c8fb7",
        "metadata": {},
        "name": "uiSupportWebsiteOverviewServiceHubPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $739483af15ac3c69$export$2e2bcd8739ae039 = $739483af15ac3c69$var$node;

});

parcelRegister("js32O", function(module, exports) {

let $e292fe6527ee7473$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e292fe6527ee7473$var$load("1DfLY").then(()=>parcelRequire('kqMbh'));

});




parcelRegister("k826a", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsitePagesRouteEntry", () => $9bc8c8ad2937179a$export$5077ff1d96b93d83);

var $6Z2mh = parcelRequire("6Z2mh");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $h8xmH = parcelRequire("h8xmH");

var $fBTqh = parcelRequire("fBTqh");

var $lmyls = parcelRequire("lmyls");

var $hVOfU = parcelRequire("hVOfU");

var $4R6GH = parcelRequire("4R6GH");

var $fwLOb = parcelRequire("fwLOb");
const $9bc8c8ad2937179a$export$5077ff1d96b93d83 = (0, $7NszV.createEntry)((0, $h8xmH.helpCenterSettingsSupportWebsitePagesRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.support-website.pages',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).HELP_CENTER_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
            sidebar: (0, $fBTqh.default),
            horizontal: (0, $hVOfU.AsyncSupportWebsiteNav)
        },
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('enable_custom_pages_csm') ? (0, $fwLOb.HelpCenterSettingsSupportWebsitePagesAppEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)()
        ]
    }));

});
parcelRegister("h8xmH", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsitePagesRoute", () => $4b2f69811d8f88b2$export$a6eefe359f3d3ade);
const $4b2f69811d8f88b2$export$a6eefe359f3d3ade = {
    name: 'helpcenter-settings-support-website-details-pages',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website/pages',
    exact: true
};

});

parcelRegister("fwLOb", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsitePagesAppEntryPoint", () => $ba2e92bb63ab8578$export$7d51b2b14ae8000f);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $ezcM4 = parcelRequire("ezcM4");
const $ba2e92bb63ab8578$export$7d51b2b14ae8000f = (0, $lkFvK.createPageEntryPoint)({
    main: $ezcM4.HelpCenterSettingsSupportWebsitePagesAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("ezcM4", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsitePagesAppEntryPoint", () => $fa9b1e599393909a$export$7d51b2b14ae8000f);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $kHuGF = parcelRequire("kHuGF");

const $fa9b1e599393909a$export$7d51b2b14ae8000f = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("koUoF")), {
        moduleId: "c9581695"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                customPagesQuery: {
                    parameters: $kHuGF.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterARI: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
                        NUMBER_OF_PAGES_INITIAL_FETCH: 300
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("kHuGF", function(module, exports) {

$parcel$export(module.exports, "default", () => $82b3287921674b82$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc6702d6d5b729b362f762d15d7d7323>>
 * @relayHash 3fb15375f0c81d09baad81021f24d532
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 298c60ba3b0de24944a6dc739efc5011d413a8237106a9bd71fdeeea48f62fc4
const $82b3287921674b82$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "298c60ba3b0de24944a6dc739efc5011d413a8237106a9bd71fdeeea48f62fc4",
        "metadata": {
            "connection": [
                {
                    "count": "NUMBER_OF_PAGES_INITIAL_FETCH",
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "helpCenter",
                        "helpCenterPages"
                    ]
                }
            ]
        },
        "name": "uiSupportWebsiteCustomPagesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $82b3287921674b82$export$2e2bcd8739ae039 = $82b3287921674b82$var$node;

});

parcelRegister("koUoF", function(module, exports) {

let $eda1cbc8a7c91df9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eda1cbc8a7c91df9$var$load("2aTZw").then(()=>parcelRequire('lDMA6'));

});




parcelRegister("9aEQn", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsFormEditRouteEntry", () => $dca661aacd919783$export$1750cfcab794a07d);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $fCXWg = parcelRequire("fCXWg");

var $5lsNZ = parcelRequire("5lsNZ");

var $fmqJw = parcelRequire("fmqJw");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $7VD4g = parcelRequire("7VD4g");
const $dca661aacd919783$export$1750cfcab794a07d = (0, $7NszV.createEntry)((0, $fmqJw.helpCenterSettingsFormEditRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.form-edit',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs_master_flag') ? (0, $7VD4g.helpCenterSettingFormEditAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $fCXWg.formEditJirafieldsResource)
        ]
    }));

});
parcelRegister("fCXWg", function(module, exports) {

$parcel$export(module.exports, "formEditJirafieldsResource", () => $0b2fb9f25d526504$export$ca58e1498fd1ff3e);
$parcel$export(module.exports, "useFormEditJirafields", () => $0b2fb9f25d526504$export$8a76fadb956ce203);

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $0b2fb9f25d526504$var$getDataLoader = ()=>(parcelRequire("cgEfj"));
const $0b2fb9f25d526504$export$ca58e1498fd1ff3e = (0, $2M1hQ.createResource)({
    type: 'HELP_CENTER_FORM_EDIT_JIRAFIELDS_RESOURCE',
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $0b2fb9f25d526504$var$getDataLoader,
    isBrowserOnly: true
});
const $0b2fb9f25d526504$export$8a76fadb956ce203 = ()=>(0, $2YP9W.useResource)($0b2fb9f25d526504$export$ca58e1498fd1ff3e);

});
parcelRegister("cgEfj", function(module, exports) {

let $8ee632a5ddb71b49$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8ee632a5ddb71b49$var$load("dICga").then(()=>parcelRequire('5Kre9'));

});


parcelRegister("fmqJw", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsFormEditRoute", () => $76127e6b6297617e$export$31bd3e10c42460dc);
const $76127e6b6297617e$export$31bd3e10c42460dc = {
    exact: true,
    name: 'helpcenter-settings-form-edit',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/forms/:formId'
};

});

parcelRegister("7VD4g", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingFormEditAppPageEntryPoint", () => $73a7c9331a7a621d$export$2792cba2387cbc5c);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $aXX0d = parcelRequire("aXX0d");
const $73a7c9331a7a621d$export$2792cba2387cbc5c = (0, $lkFvK.createPageEntryPoint)({
    main: $aXX0d.helpCenterSettingFormEditAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("aXX0d", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingFormEditAppEntryPoint", () => $dcaafae9dc3cdb4f$export$262512d610e494f8);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $jVPFz = parcelRequire("jVPFz");

const $dcaafae9dc3cdb4f$export$262512d610e494f8 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("fOgPV")), {
        moduleId: "d82eb4d8"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId, formId: formId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                uiFormEditRoutingQuery: {
                    parameters: $jVPFz.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
                        templateFormAri: `ari:cloud:jira-customer-service::template-form/activation/${activationId}/${formId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("jVPFz", function(module, exports) {

$parcel$export(module.exports, "default", () => $05a055aee7ffa295$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c30e591465e1c9f454c03cbd845a40c4>>
 * @relayHash 262d9de463ef7dc76aa8807e0e00658d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8f1f095c8eed508445434e01169dc7e912be89d0ad06cc61c6ba8dbd54a5af55
const $05a055aee7ffa295$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8f1f095c8eed508445434e01169dc7e912be89d0ad06cc61c6ba8dbd54a5af55",
        "metadata": {},
        "name": "uiFormEditRoutingQuery",
        "operationKind": "query",
        "text": null
    }
};
var $05a055aee7ffa295$export$2e2bcd8739ae039 = $05a055aee7ffa295$var$node;

});

parcelRegister("fOgPV", function(module, exports) {

let $b82895e19d833ed1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b82895e19d833ed1$var$load("f3edP").then(()=>parcelRequire('3XNgZ'));

});




parcelRegister("gZQLD", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsFormsRouteEntry", () => $752d7b6fe60c2c67$export$9a67aaae787c9f40);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $Z9uTe = parcelRequire("Z9uTe");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $uu31h = parcelRequire("uu31h");
const $752d7b6fe60c2c67$export$9a67aaae787c9f40 = (0, $7NszV.createEntry)((0, $Z9uTe.helpCenterSettingsFormsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.forms',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs_master_flag') ? (0, $uu31h.helpCenterSettingFormsAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("Z9uTe", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsFormsRoute", () => $a0406c9ab9debc78$export$45b14c3ed47b2b3a);
const $a0406c9ab9debc78$export$45b14c3ed47b2b3a = {
    exact: true,
    name: 'helpcenter-settings-forms',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/forms'
};

});

parcelRegister("uu31h", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingFormsAppPageEntryPoint", () => $cf39360ee106b7b5$export$b50d944f3be2457f);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $UvMAc = parcelRequire("UvMAc");
const $cf39360ee106b7b5$export$b50d944f3be2457f = (0, $lkFvK.createPageEntryPoint)({
    main: $UvMAc.helpCenterSettingFormsAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("UvMAc", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingFormsAppEntryPoint", () => $dbea87a49a7edd6e$export$ce8253ab16579f12);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $gqaus = parcelRequire("gqaus");

const $dbea87a49a7edd6e$export$ce8253ab16579f12 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("c3ICD")), {
        moduleId: "c7a4dbb9"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                uiFormsQuery: {
                    parameters: $gqaus.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("gqaus", function(module, exports) {

$parcel$export(module.exports, "default", () => $22259d546684fabe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6fe209da6a9c61698a3ee523d3b6b589>>
 * @relayHash 7109e2a0122fe41fae28aba711fb3d51
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a12ba560eb94d6e44a75a30daaf4d0f03f2ca672aa75b888dd1555325eb72f17
const $22259d546684fabe$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a12ba560eb94d6e44a75a30daaf4d0f03f2ca672aa75b888dd1555325eb72f17",
        "metadata": {},
        "name": "uiFormsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $22259d546684fabe$export$2e2bcd8739ae039 = $22259d546684fabe$var$node;

});

parcelRegister("c3ICD", function(module, exports) {

let $8c7860e0a6007c51$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8c7860e0a6007c51$var$load("gZjef").then(()=>parcelRequire('a6kDH'));

});




parcelRegister("kzcqd", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsKbRouteEntry", () => $55fac3162ba94854$export$caf568619a621961);

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $dZu6u = parcelRequire("dZu6u");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $81LME = parcelRequire("81LME");
const $55fac3162ba94854$export$caf568619a621961 = (0, $7NszV.createEntry)((0, $dZu6u.helpCenterSettingsKbRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.kb',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $cSD7y.componentWithFG)('jcs_master_flag', (0, $81LME.HelpCenterSettingsKnowledgeBase), (0, $5lsNZ.default)),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $81LME.LazyHelpCenterSettingsKnowledgeBase)
        ],
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            // TODO: https://jplat.jira.atlassian.cloud/browse/BERRY-2884
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ]
    }));

});
parcelRegister("dZu6u", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsKbRoute", () => $643da700cdb365a5$export$8a784299dc7faaff);
const $643da700cdb365a5$export$8a784299dc7faaff = {
    name: 'helpcenter-settings-kb',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/kb',
    exact: true
};

});

parcelRegister("81LME", function(module, exports) {

$parcel$export(module.exports, "LazyHelpCenterSettingsKnowledgeBase", () => $d84b744908886ed8$export$92983043c677b1b1);
$parcel$export(module.exports, "HelpCenterSettingsKnowledgeBase", () => $d84b744908886ed8$export$c1d58cf9dc0a2ed3);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $d84b744908886ed8$export$92983043c677b1b1 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iOJJB"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/knowledge-settings/src/index.tsx"
});
const $d84b744908886ed8$export$c1d58cf9dc0a2ed3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d84b744908886ed8$export$92983043c677b1b1,
        pageId: "help-center-settings-knowledge-base",
        shouldShowSpinner: true
    });

});
parcelRegister("iOJJB", function(module, exports) {

let $db305f6ad0b0da65$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $db305f6ad0b0da65$var$load("h2MrD"),
    $db305f6ad0b0da65$var$load("bYT2S"),
    $db305f6ad0b0da65$var$load("7gB9a")
]).then(()=>parcelRequire('5bGBK'));

});



parcelRegister("9yhVv", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsKbOldRouteEntry", () => $fdb8ca3a3bbe17c4$export$b712a11de9bc3a67);

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $5b2i5 = parcelRequire("5b2i5");

var $6Z2mh = parcelRequire("6Z2mh");

var $6NkHq = parcelRequire("6NkHq");

var $6gWZ1 = parcelRequire("6gWZ1");

var $81LME = parcelRequire("81LME");
const $fdb8ca3a3bbe17c4$export$b712a11de9bc3a67 = (0, $7NszV.createEntry)((0, $5b2i5.helpCenterSettingsKbOldRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.kb',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $cSD7y.componentWithFG)('berry-4386-add-helpcenterid-to-routes', (0, $6NkHq.NotFound), (0, $cSD7y.componentWithFG)('jcs_master_flag', (0, $81LME.HelpCenterSettingsKnowledgeBase), (0, $5lsNZ.default))),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $81LME.LazyHelpCenterSettingsKnowledgeBase)
        ],
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            // TODO: https://jplat.jira.atlassian.cloud/browse/BERRY-2884
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ]
    }));

});
parcelRegister("5b2i5", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsKbOldRoute", () => $fe227fc1cf4b044c$export$3ceb250ec511a74e);
const $fe227fc1cf4b044c$export$3ceb250ec511a74e = {
    name: 'helpcenter-settings-kb-old',
    path: '/jira/helpcenter/projects/:projectKey/settings/kb',
    exact: true
};

});


parcelRegister("lDuCa", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsServiceHubsRouteEntry", () => $17f669f9f746c53b$export$4afd756ea4d2cf7e);

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $3Y5jq = parcelRequire("3Y5jq");

var $85NOq = parcelRequire("85NOq");
const $17f669f9f746c53b$export$4afd756ea4d2cf7e = (0, $7NszV.createEntry)((0, $3Y5jq.helpCenterSettingsServiceHubsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.service-hubs',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
        },
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs_master_flag') ? (0, $85NOq.helpCenterSettingsServiceHubsRoutePageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ]
    }));

});
parcelRegister("3Y5jq", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsServiceHubsRoute", () => $ce6844775f881a62$export$16970f28ba5bfb66);
const $ce6844775f881a62$export$16970f28ba5bfb66 = {
    exact: true,
    name: 'customer-service-helpcenter',
    path: '/jira/helpcenter'
};

});

parcelRegister("85NOq", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsServiceHubsRoutePageEntryPoint", () => $ba28558a5bb4c0c7$export$3c1cef4845013f95);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $1yeSy = parcelRequire("1yeSy");
const $ba28558a5bb4c0c7$export$3c1cef4845013f95 = (0, $lkFvK.createPageEntryPoint)({
    main: $1yeSy.helpCenterSettingsServiceHubsAppEntryPoint,
    // TODO update to right menu id
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("1yeSy", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsServiceHubsAppEntryPoint", () => $0978151941bc8303$export$68ab0caf884fe346);

var $enqBA = parcelRequire("enqBA");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");
const $0978151941bc8303$var$NUMBER_OF_HELP_CENTERS_INITIAL_FETCH = 20;
const $0978151941bc8303$var$SORT_ORDER = 'CREATED_DATE_DESCENDING';

const $0978151941bc8303$export$68ab0caf884fe346 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("dP9Yr")), {
        moduleId: "c447b568"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        return {
            queries: {
                serviceHubsQuery: {
                    parameters: $enqBA.default,
                    variables: {
                        cloudId: cloudId,
                        workspaceAri: `ari:cloud:jira:${cloudId}:workspace/${activationId}`,
                        SORT_ORDER: $0978151941bc8303$var$SORT_ORDER,
                        NUMBER_OF_HELP_CENTERS_INITIAL_FETCH: $0978151941bc8303$var$NUMBER_OF_HELP_CENTERS_INITIAL_FETCH
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("enqBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3b56a15c10c4b45$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2bfa82f2d0823efdab8d51258393ace5>>
 * @relayHash 3e3a69d2c99a9c3c9ec567802fc52640
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e0356e42e96d3adde2f74f099ff3e06573fc979ecc8bc591691d4221d6efc41
const $e3b56a15c10c4b45$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "3e0356e42e96d3adde2f74f099ff3e06573fc979ecc8bc591691d4221d6efc41",
        "metadata": {},
        "name": "srcCustomerServiceServiceHubsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e3b56a15c10c4b45$export$2e2bcd8739ae039 = $e3b56a15c10c4b45$var$node;

});

parcelRegister("dP9Yr", function(module, exports) {

let $a107c65e524f1115$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a107c65e524f1115$var$load("9pmDz").then(()=>parcelRequire('c7EOd'));

});




parcelRegister("duVOn", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsNotFoundRouteEntry", () => $16b9b96eb3704d99$export$2dced3f6d0a4894);

var $7NszV = parcelRequire("7NszV");

var $65gi0 = parcelRequire("65gi0");

var $6NkHq = parcelRequire("6NkHq");
const $16b9b96eb3704d99$export$2dced3f6d0a4894 = (0, $7NszV.createEntry)((0, $65gi0.helpCenterSettingsNotFoundRoute), ()=>({
        group: 'customer-service',
        component: (0, $6NkHq.NotFound)
    }));

});
parcelRegister("65gi0", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsNotFoundRoute", () => $a438def0ee4651b3$export$b6bc9dd96e9608e7);
const $a438def0ee4651b3$export$b6bc9dd96e9608e7 = {
    exact: false,
    name: 'customer-service-not-found',
    path: '/jira/helpcenter/:any'
};

});


parcelRegister("lVyEk", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAnalyticsRouteEntry", () => $ea9995db41d502d1$export$13d5cfdc3231d970);

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $6LApU = parcelRequire("6LApU");

var $6HgQO = parcelRequire("6HgQO");
const $ea9995db41d502d1$export$13d5cfdc3231d970 = (0, $7NszV.createEntry)((0, $6LApU.helpCenterSettingsAnalyticsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.analytics',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
        },
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs-analytics-page') ? (0, $6HgQO.helpCenterSettingsAnalyticsRoutePageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ]
    }));

});
parcelRegister("6LApU", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAnalyticsRoute", () => $02d8dbaff147f01e$export$1487d4661960397f);
const $02d8dbaff147f01e$export$1487d4661960397f = {
    exact: true,
    name: 'customer-service-helpcenter-analytics',
    path: '/jira/helpcenter/analytics'
};

});

parcelRegister("6HgQO", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAnalyticsRoutePageEntryPoint", () => $44f12967ed405696$export$cb0b3a882806ef6e);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $6aw3i = parcelRequire("6aw3i");
const $44f12967ed405696$export$cb0b3a882806ef6e = (0, $lkFvK.createPageEntryPoint)({
    main: $6aw3i.helpCenterSettingsAnalyticsAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("6aw3i", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAnalyticsAppEntryPoint", () => $0e5696f7f2194583$export$fa405dadb950b4a6);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $0e5696f7f2194583$export$fa405dadb950b4a6 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("hTDV1")), {
        moduleId: "19032ae8"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("hTDV1", function(module, exports) {

let $d07689bbcddcdcc0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d07689bbcddcdcc0$var$load("bnQBE").then(()=>parcelRequire('h1w7n'));

});




parcelRegister("h82Z7", function(module, exports) {

$parcel$export(module.exports, "homeOnboardingRedirectRouteEntry", () => $5e597886ba168534$export$2740cfaa979353b9);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $cHNCn = parcelRequire("cHNCn");

var $dzpo2 = parcelRequire("dzpo2");
const $5e597886ba168534$export$2740cfaa979353b9 = (0, $7NszV.createEntry)((0, $cHNCn.homeOnboardingRedirectRoute), ()=>({
        group: 'home',
        component: (0, $dzpo2.default),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        isRedirect: true,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("cHNCn", function(module, exports) {

$parcel$export(module.exports, "homeOnboardingRedirectRoute", () => $fc7d4480067c689f$export$2eaffde3ad991b33);
const $fc7d4480067c689f$export$2eaffde3ad991b33 = {
    name: 'home-onboarding-redirect',
    path: '/jira/your-work-onboarding',
    exact: true
};

});

parcelRegister("dzpo2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff7a191a114ce3ba$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5oFIy = parcelRequire("5oFIy");

var $lVJAU = parcelRequire("lVJAU");
/**
 * This component will cause an SPA transition (and overwrite of current history) to Your work or the Projects directory
 * depending on whether nav-v3, Your work's deep dive cards, and the JSW onboarding flows in Your work are enabled.
 */ const $ff7a191a114ce3ba$var$JiraHomeOnboardingRedirect = ()=>{
    const { replace: replace } = (0, $lVJAU.useRouterActions)();
    replace('/jira/your-work');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        eventName: "JiraHomeOnboardingRedirect loaded",
        componentName: "JiraHomeOnboardingRedirect",
        attributes: {
            isRedirectionEnabled: true
        }
    });
};
var $ff7a191a114ce3ba$export$2e2bcd8739ae039 = $ff7a191a114ce3ba$var$JiraHomeOnboardingRedirect;

});


parcelRegister("9qXuz", function(module, exports) {

$parcel$export(module.exports, "homeRedirectRouteEntry", () => $f8b2ddb194f05043$export$5379c026da4201e6);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $7R6xY = parcelRequire("7R6xY");

var $crx5O = parcelRequire("crx5O");
const $f8b2ddb194f05043$export$5379c026da4201e6 = (0, $7NszV.createEntry)((0, $7R6xY.homeRedirectRoute), ()=>({
        group: 'home',
        component: (0, $crx5O.default),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        isRedirect: true,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("7R6xY", function(module, exports) {

$parcel$export(module.exports, "homeRedirectRoute", () => $d39d4562915d89ec$export$f7a252c9d61f8f94);
const $d39d4562915d89ec$export$f7a252c9d61f8f94 = {
    name: 'home-redirect',
    path: '/jira',
    exact: true
};

});

parcelRegister("crx5O", function(module, exports) {

$parcel$export(module.exports, "default", () => $92d7d72ca8393409$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dXRYE = parcelRequire("dXRYE");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$92d7d72ca8393409$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dXRYE.default), null);

});
parcelRegister("dXRYE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5a49877dbf7e167$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $dJl1T = parcelRequire("dJl1T");

var $9vlEn = parcelRequire("9vlEn");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");

const $e5a49877dbf7e167$var$JiraBaseRedirectWrapper = ()=>{
    (0, $gKZoD.di)(window);
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $9vlEn.userHomepageResource));
    (0, $5uXOq.useEffect)(()=>{
        if (!loading && data == null) (0, $dJl1T.default).safeInfoWithoutCustomerData((0, $2791311ae97b7f0a$export$25a759e49d5049db), 'userHomepage data is null');
    }, [
        loading,
        data
    ]);
    if (loading) return null;
    // redirect to monolith to handle "/jira" route if homepageData is null (should not happen)
    if (data == null) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.replace('/jira');
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: data.homepagePreference
    });
};
var $e5a49877dbf7e167$export$2e2bcd8739ae039 = $e5a49877dbf7e167$var$JiraBaseRedirectWrapper;

});
const $2791311ae97b7f0a$export$25a759e49d5049db = 'spa-apps.common.redirect.jira-base-routing';




parcelRegister("9MSQj", function(module, exports) {

$parcel$export(module.exports, "softwareIncidentsNextGenRouteEntry", () => $1e3d0627cbc31b1a$export$fd29243dbe4103);

var $e4eHl = parcelRequire("e4eHl");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $jAXrH = parcelRequire("jAXrH");

var $9LHPC = parcelRequire("9LHPC");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $hb1PV = parcelRequire("hb1PV");

var $BrpCW = parcelRequire("BrpCW");
const $1e3d0627cbc31b1a$export$fd29243dbe4103 = (0, $7NszV.createEntry)((0, $jAXrH.softwareIncidentsNextGenRoute), ()=>({
        group: 'software',
        entryPoint () {
            return (0, $4R6GH.fg)('corex_operandi_incidents_page_in_jira') ? (0, $hb1PV.entryPoint) : (0, $BrpCW.entryPointDeprecated);
        },
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        skeleton: (0, $9LHPC.IncidentsPageSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $7GnDe.incidentsInitialPageChecksResource),
            (0, $7GnDe.incidentsCustomFieldIdResource)
        ],
        meta: {
            reporting: {
                id: 'software-incidents',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-incidents'),
                teamName: 'operandi'
            }
        },
        ufoName: 'software-incidents'
    }));

});
parcelRegister("jAXrH", function(module, exports) {

$parcel$export(module.exports, "softwareIncidentsNextGenRoute", () => $cf2d0aff779a466b$export$12e1ca6c7cfdfd49);
const $cf2d0aff779a466b$export$12e1ca6c7cfdfd49 = {
    name: 'software-incidents',
    path: '/jira/software/projects/:projectKey/incidents'
};

});

parcelRegister("9LHPC", function(module, exports) {

$parcel$export(module.exports, "IncidentsPageSkeleton", () => $cc84120449e592c1$export$3105d59d9ca899bd);
$parcel$export(module.exports, "IncidentsTableSkeleton", () => $cc84120449e592c1$export$7092b8ea63ebf9be);
/* IncidentsPageSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $c1yjJ = parcelRequire("c1yjJ");

var $80wl3 = parcelRequire("80wl3");
const $cc84120449e592c1$var$incidentsPageSkeletonStyles = null;
const $cc84120449e592c1$var$incidentsTableSkeletonStyles = null;
const $cc84120449e592c1$export$3105d59d9ca899bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-page",
        className: (0, $bwpsq.default)([
            "_1bsb1x27 _4t3i1osq _ca0q1ejb _19bv1jfw _u5f31jfw _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c1yjJ)))
    }));
const $cc84120449e592c1$export$7092b8ea63ebf9be = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-table",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($80wl3)))
    }));

});
parcelRegister("c1yjJ", function(module, exports) {
module.exports = new URL("incidents-page-app-skeleton.tpl.5b656159.svg", import.meta.url).toString();

});

parcelRegister("80wl3", function(module, exports) {
module.exports = new URL("incidents-page-table-skeleton.tpl.e8f337f1.svg", import.meta.url).toString();

});


parcelRegister("hb1PV", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $3b4ebee292145bb5$export$6333901e831d7af0);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5En1O = parcelRequire("5En1O");

var $fo6b8 = parcelRequire("fo6b8");
const $3b4ebee292145bb5$export$6333901e831d7af0 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $5En1O.incidentsPageEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("5En1O", function(module, exports) {

$parcel$export(module.exports, "incidentsPageEntryPoint", () => $b9fe885d02827a63$export$a59477eea6e8cd7f);

var $2T5vx = parcelRequire("2T5vx");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");
const $b9fe885d02827a63$var$AriGraphSortOrderInput = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $b9fe885d02827a63$var$QUERY_PARAM_SEARCH = 'search';
const $b9fe885d02827a63$var$QUERY_PARAM_PRIORITY = 'priority';
const $b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE = 'affected-service';
const $b9fe885d02827a63$var$QUERY_PARAM_STATUS = 'status';
const $b9fe885d02827a63$var$QUERY_PARAM_SORT_BY = 'sortBy';
const $b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER = 'sortOrder';
const $b9fe885d02827a63$var$STATUS_SORT_KEY = 'status';
const $b9fe885d02827a63$var$CREATED_SORT_KEY = 'created';
const $b9fe885d02827a63$var$PRIORITY_SORT_KEY = 'priority';
const $b9fe885d02827a63$var$SUMMARY_SORT_KEY = 'key';
const $b9fe885d02827a63$var$ASC_SORT_KEY = 'ASC';
const $b9fe885d02827a63$var$DESC_SORT_KEY = 'DESC';
function $b9fe885d02827a63$var$notEmpty(value) {
    return Boolean(value);
}
const $b9fe885d02827a63$var$isPriority = $b9fe885d02827a63$var$notEmpty;
const $b9fe885d02827a63$var$isStatus = (val)=>val === 'resolved' || val === 'open';
const $b9fe885d02827a63$var$isSortBy = (val)=>val === $b9fe885d02827a63$var$STATUS_SORT_KEY || val === $b9fe885d02827a63$var$CREATED_SORT_KEY || val === $b9fe885d02827a63$var$PRIORITY_SORT_KEY || val === $b9fe885d02827a63$var$SUMMARY_SORT_KEY;
const $b9fe885d02827a63$var$isSortOrder = (val)=>val === $b9fe885d02827a63$var$ASC_SORT_KEY || val === $b9fe885d02827a63$var$DESC_SORT_KEY;
const $b9fe885d02827a63$var$isAffectedService = $b9fe885d02827a63$var$notEmpty;
function $b9fe885d02827a63$var$parseParameter(parameter, parameterValidationFn) {
    return parameter == null ? undefined : parameter.split(',').map((str)=>str.trim()).filter(parameterValidationFn);
}
const $b9fe885d02827a63$var$parseQueryParams = (paramsRaw)=>{
    const result = {
        [$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY]: paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] && $b9fe885d02827a63$var$isSortBy(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY]) ? paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] : $b9fe885d02827a63$var$CREATED_SORT_KEY,
        [$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER]: paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER] && $b9fe885d02827a63$var$isSortOrder(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER]) ? paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER] : $b9fe885d02827a63$var$DESC_SORT_KEY
    };
    result[$b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE] = $b9fe885d02827a63$var$parseParameter(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE], $b9fe885d02827a63$var$isAffectedService);
    result[$b9fe885d02827a63$var$QUERY_PARAM_STATUS] = $b9fe885d02827a63$var$parseParameter(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_STATUS], $b9fe885d02827a63$var$isStatus);
    result[$b9fe885d02827a63$var$QUERY_PARAM_SEARCH] = paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SEARCH] ?? undefined;
    result[$b9fe885d02827a63$var$QUERY_PARAM_PRIORITY] = $b9fe885d02827a63$var$parseParameter(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_PRIORITY], $b9fe885d02827a63$var$isPriority);
    return result;
};
const $b9fe885d02827a63$var$getFilterValue = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
values)=>({
        ...values.length > 0 ? {
            is: values
        } : {}
    });
const $b9fe885d02827a63$var$parseStatusToFilterValues = (status)=>status.flatMap((stat)=>{
        switch(stat){
            case 'open':
                return [
                    'NEW',
                    'INDETERMINATE'
                ];
            case 'resolved':
                return [
                    'DONE'
                ];
            default:
                return [
                    'UNDEFINED'
                ];
        }
    });
const $b9fe885d02827a63$var$getGqlFiltersFromQueryParams = (parsedQueryParams)=>({
        and: [
            {
                to_status: $b9fe885d02827a63$var$getFilterValue($b9fe885d02827a63$var$parseStatusToFilterValues(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_STATUS] ?? [])),
                to_priority: $b9fe885d02827a63$var$getFilterValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_PRIORITY] ?? []),
                to_affectedServiceAris: $b9fe885d02827a63$var$getFilterValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE] ?? [])
            }
        ]
    });
const $b9fe885d02827a63$var$parseSortDirection = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC.toUpperCase():
            return $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC;
        case $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC.toUpperCase():
            return $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC;
        default:
            return defaultValue;
    }
};
const $b9fe885d02827a63$var$getSortValue = (sortOrder)=>({
        priority: 2,
        direction: $b9fe885d02827a63$var$parseSortDirection(sortOrder, $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC)
    });
// Added Inverse sort fn as data in AGS is indexed in reverse order for priority
const $b9fe885d02827a63$var$parseInverseSortDirection = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC.toUpperCase():
            return $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC;
        case $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC.toUpperCase():
            return $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC;
        default:
            return defaultValue;
    }
};
const $b9fe885d02827a63$var$getInverseSortValue = (sortOrder)=>({
        priority: 2,
        direction: $b9fe885d02827a63$var$parseInverseSortDirection(sortOrder, $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC)
    });
const $b9fe885d02827a63$var$getGraphStoreSortFromQueryParams = (parsedQueryParams)=>({
        lastModified: {
            priority: 1,
            direction: $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC
        },
        ...$b9fe885d02827a63$var$STATUS_SORT_KEY === parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] ? {
            to_status: $b9fe885d02827a63$var$getSortValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER])
        } : {},
        ...$b9fe885d02827a63$var$PRIORITY_SORT_KEY === parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] ? {
            to_priority: $b9fe885d02827a63$var$getInverseSortValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER])
        } : {},
        ...$b9fe885d02827a63$var$CREATED_SORT_KEY === parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] ? {
            createdAt: $b9fe885d02827a63$var$getSortValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER])
        } : {}
    });

const $b9fe885d02827a63$export$a59477eea6e8cd7f = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("k87Zw")).then((mod)=>mod.IncidentsPageWrapper), {
        moduleId: "5b8b4ff7"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
            queries: {
                incidentPageData: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $2T5vx.default,
                    variables: {
                        incidentPageSize: 30,
                        servicePageSize: 30,
                        cloudId: cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        filter: $b9fe885d02827a63$var$getGqlFiltersFromQueryParams($b9fe885d02827a63$var$parseQueryParams(context.query)),
                        sort: $b9fe885d02827a63$var$getGraphStoreSortFromQueryParams($b9fe885d02827a63$var$parseQueryParams(context.query)),
                        siteAri: `ari:cloud:jira::site/${cloudId}`
                    }
                }
            }
        })
});

});
parcelRegister("2T5vx", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f54a3a0d651497$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<755ee4fdc15eeb1d429180ce9f242ead>>
 * @relayHash 478a65a5e586d07574b5bbd2cc4ef630
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 50f41ae3db36d1741d384023d13472ac68cccc88abdb8a72fb04d3f7c9bc8670
const $58f54a3a0d651497$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "50f41ae3db36d1741d384023d13472ac68cccc88abdb8a72fb04d3f7c9bc8670",
        "metadata": {
            "connection": [
                {
                    "count": "servicePageSize",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "jira",
                        "jiraProjectByKey",
                        "linkedOperationsComponentsByProject"
                    ]
                }
            ]
        },
        "name": "srcIncidentsPageInternalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $58f54a3a0d651497$export$2e2bcd8739ae039 = $58f54a3a0d651497$var$node;

});

parcelRegister("k87Zw", function(module, exports) {

let $ea7ac0e40fce1d0f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ea7ac0e40fce1d0f$var$load("cRbOs").then(()=>parcelRequire('cwNeR'));

});



parcelRegister("BrpCW", function(module, exports) {

$parcel$export(module.exports, "entryPointDeprecated", () => $b39c17e33fa0794a$export$821fec5ea5acc81d);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $eXpsd = parcelRequire("eXpsd");

var $fo6b8 = parcelRequire("fo6b8");
const $b39c17e33fa0794a$export$821fec5ea5acc81d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $eXpsd.incidentsPageEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("eXpsd", function(module, exports) {

$parcel$export(module.exports, "incidentsPageEntryPoint", () => $b93c8ec26a3d236d$export$a59477eea6e8cd7f);

var $d23s9 = parcelRequire("d23s9");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $b93c8ec26a3d236d$export$a59477eea6e8cd7f = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("1Wsl9")).then((mod)=>mod.IncidentsPageLinkedServicesWrapper), {
        moduleId: "d6132459"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
            queries: {
                incidentPageData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $d23s9.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("d23s9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2978738121ef6b5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7699704d0995bbdc63133dc84290d5de>>
 * @relayHash bf929c95e6738104436e6a3b1e6f48cd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8822ca061f1e1e9e11103925231d8d61251ca06c569e9da069f1b3faa1183aaf
const $d2978738121ef6b5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8822ca061f1e1e9e11103925231d8d61251ca06c569e9da069f1b3faa1183aaf",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "jira",
                        "jiraProjectByKey",
                        "associatedComponents"
                    ]
                }
            ]
        },
        "name": "srcIncidentsLinkedServicesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $d2978738121ef6b5$export$2e2bcd8739ae039 = $d2978738121ef6b5$var$node;

});

parcelRegister("1Wsl9", function(module, exports) {

let $16a130ffdfc38f20$var$load = (parcelRequire("28QjX"))(4);
module.exports = $16a130ffdfc38f20$var$load("9C5Ze").then(()=>parcelRequire('8c2Ir'));

});




parcelRegister("3HGg1", function(module, exports) {

$parcel$export(module.exports, "issueCreateEmbedRouteEntry", () => $f0855c0baf74da48$export$abd0bbe95839baf7);

var $5uXOq = parcelRequire("5uXOq");

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $2Ql51 = parcelRequire("2Ql51");

var $ell37 = parcelRequire("ell37");

var $9NiTW = parcelRequire("9NiTW");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");
const $f0855c0baf74da48$var$handleEmbedLinkClick = (e)=>{
    const eventTarget = e.target;
    // this is used for handling all the button clicks inside the iframe to open the new link in a new tab
    // as this view is mainly used an embed view inside an iframe.
    if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') // link
    eventTarget.target = '_blank';
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f0855c0baf74da48$var$LazyIssueCreateEmbed = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("49qiH")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/issue-create-embed/src/index.tsx"
});
const $f0855c0baf74da48$var$IssueCreateEmbedLazy = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('click', $f0855c0baf74da48$var$handleEmbedLinkClick, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('click', $f0855c0baf74da48$var$handleEmbedLinkClick);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f0855c0baf74da48$var$LazyIssueCreateEmbed,
        pageId: "spa-apps/issue-create-embed",
        shouldShowSpinner: true
    }));
};
const $f0855c0baf74da48$export$abd0bbe95839baf7 = (0, $7NszV.createEntry)((0, $ell37.issueCreateEmbedRoute), ()=>({
        group: 'issue',
        component: $f0855c0baf74da48$var$IssueCreateEmbedLazy,
        resources: [
            (0, $2Ql51.themePreferenceResource)
        ],
        layout: (0, $6e4Kt.chromelessLayout),
        forPaint: [
            $f0855c0baf74da48$var$LazyIssueCreateEmbed
        ]
    }));

});
parcelRegister("ell37", function(module, exports) {

$parcel$export(module.exports, "issueCreateEmbedRoute", () => $fcce99f65e838928$export$c155f4de16b62110);
const $fcce99f65e838928$export$c155f4de16b62110 = {
    name: 'issue-create-embed',
    path: '/jira/issues/create/embed'
};

});

parcelRegister("9NiTW", function(module, exports) {

$parcel$export(module.exports, "checkAuthentication", () => $ad297a7f2ce81084$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "AuthenticationCheck", () => $ad297a7f2ce81084$export$e9b9096e887386fe);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");

var $38Y30 = parcelRequire("38Y30");
const $ad297a7f2ce81084$export$b8dbb7d6029c5413 = (tenantContext)=>Boolean(tenantContext.atlassianAccountId);
const $ad297a7f2ce81084$export$e9b9096e887386fe = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if ($ad297a7f2ce81084$export$b8dbb7d6029c5413(tenantContext)) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Y30.RedirectToLoginPage), null);
    });

});

parcelRegister("49qiH", function(module, exports) {

let $305c676d501b648c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $305c676d501b648c$var$load("kWrFZ"),
    $305c676d501b648c$var$load("hPzOn"),
    $305c676d501b648c$var$load("h2MrD"),
    $305c676d501b648c$var$load("bYT2S"),
    $305c676d501b648c$var$load("dsiAd"),
    $305c676d501b648c$var$load("4KqZA")
]).then(()=>parcelRequire('5tdjr'));

});


parcelRegister("hkNW0", function(module, exports) {

$parcel$export(module.exports, "browseIssueEmbedRouteEntry", () => $c08486eb8ed505d7$export$e275b3ca0c6ccb5e);


var $6e4Kt = parcelRequire("6e4Kt");

var $e2ctp = parcelRequire("e2ctp");

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $8ZUng = parcelRequire("8ZUng");

var $9XjL6 = parcelRequire("9XjL6");

var $3RJkv = parcelRequire("3RJkv");

var $2Ql51 = parcelRequire("2Ql51");

var $fjoQ1 = parcelRequire("fjoQ1");

var $gRzZD = parcelRequire("gRzZD");

var $lb0Dk = parcelRequire("lb0Dk");

var $lAGdd = parcelRequire("lAGdd");

var $gNStA = parcelRequire("gNStA");

var $2dmpO = parcelRequire("2dmpO");
const $c08486eb8ed505d7$export$e275b3ca0c6ccb5e = (0, $7NszV.createEntry)((0, $fjoQ1.browseIssueEmbedRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'issue',
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-opt-out-issue-view'),
        preloadOptions: {
            earlyChunks: [
                'issue-app-early-entry'
            ]
        },
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY),
        component: (0, $2dmpO.IssueEmbedComponent),
        skeleton: (0, $lb0Dk.IssueViewSkeleton),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            ...(0, $3RJkv.getModernIssueTransitionResources)(),
            ...(0, $2dmpO.getUnusedEmbedRouteResources)(),
            (0, $9XjL6.issueGiraDataResource),
            ...(0, $2dmpO.removeNonCritialGiraCallFromCriticalPath)(),
            (0, $2dmpO.conditionalForgeResource),
            (0, $8ZUng.issueViewRelayResource),
            (0, $gRzZD.workspaceResource),
            (0, $2Ql51.themePreferenceResource),
            (0, $2dmpO.conditionalSmartRepliesOptInStatusResources),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('rrr_for_context_panel_data'), (0, $lAGdd.aiContextPanelResource))
        ],
        forPaint: [
            (0, $2dmpO.LazyIssuePage)
        ],
        ufoName: 'issue-view-embed',
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$ef94a84e2990361c)
        },
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-entries/src/browseIssueEmbedRouteEntry.tsx',
                whichExportToUse: 'browseIssueEmbedRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-view.json'
        }
    }));

});
parcelRegister("8ZUng", function(module, exports) {

$parcel$export(module.exports, "issueViewRelayResource", () => $e05b8d0e5bf08042$export$55131006e6699c0a);
$parcel$export(module.exports, "useIssueViewRelayRouteResource", () => $e05b8d0e5bf08042$export$252bdba8c8e5f066);

var $3Mzpf = parcelRequire("3Mzpf");

var $k3PbQ = parcelRequire("k3PbQ");

var $6yLM4 = parcelRequire("6yLM4");

var $ao2h1 = parcelRequire("ao2h1");

var $la3vp = parcelRequire("la3vp");

var $2Yhep = parcelRequire("2Yhep");

var $gNStA = parcelRequire("gNStA");

var $4R6GH = parcelRequire("4R6GH");


var $5XgeZ = parcelRequire("5XgeZ");
const $e05b8d0e5bf08042$export$55131006e6699c0a = (0, $gNStA.browserOnlyResourceWithCondition)(()=>{
    if (0, $cdb023d06c7f62fa$export$19d68f5aa485d903) // not "browser only" if FF is on
    return !(0, $4R6GH.fg)('issue-view-ssr-perf-m1');
    return true;
}, (0, $5XgeZ.createRelayResourceDeprecated)({
    type: 'ISSUE_RELAY_DATA',
    isBrowserOnly: true,
    captureErrors: true,
    captureTraceIds: !false,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
        const { match: match } = routerContext;
        const issueKey = (0, $2Yhep.getIssueKey)(match);
        const siteAri = (0, $3Mzpf.JiraSiteAri).create({
            siteId: cloudId
        }).toString();
        const projectKey = issueKey ? (0, $k3PbQ.extractProjectKey)(issueKey) : '';
        const queryVariables = {
            cloudId: cloudId,
            issueKey: issueKey || '',
            projectKey: projectKey,
            siteAri: siteAri
        };
        return {
            parameters: (0, $la3vp.default),
            variables: {
                ...queryVariables,
                ...(0, $6yLM4.getMainIssueViewAggQueryVariables)(issueKey)
            },
            // Pass over the variables that actually would trigger a reload when they are changed=
            keyVariables: {
                ...queryVariables,
                ...(0, $6yLM4.getMainIssueViewAggQueryFeatureFlagVariables)()
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
}));
const $e05b8d0e5bf08042$export$252bdba8c8e5f066 = (options)=>(0, $ao2h1.useRelayResource)($e05b8d0e5bf08042$export$55131006e6699c0a, options);

});
parcelRegister("3Mzpf", function(module, exports) {

$parcel$export(module.exports, "JiraSiteAri", () => $2c1151bb17cb172c$export$6c0f81f222d09301);

var $gQC3n = parcelRequire("gQC3n");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/site/manifest.ts
var $2c1151bb17cb172c$var$jiraSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $gQC3n.JiraSiteAriResourceOwner),
    resourceType: (0, $gQC3n.JiraSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/jira/site/index.ts
var $2c1151bb17cb172c$export$6c0f81f222d09301 = class _JiraSiteAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.resourceIdSegmentValues.siteId;
    }
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $2c1151bb17cb172c$var$jiraSiteAriStaticOpts.qualifier,
            platformQualifier: $2c1151bb17cb172c$var$jiraSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $2c1151bb17cb172c$var$jiraSiteAriStaticOpts.resourceOwner,
            resourceType: $2c1151bb17cb172c$var$jiraSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $2c1151bb17cb172c$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $2c1151bb17cb172c$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
};

});
parcelRegister("gQC3n", function(module, exports) {

$parcel$export(module.exports, "JiraSiteAriResourceOwner", () => $032a4e897fcecef5$export$b7d590981b504412);
$parcel$export(module.exports, "JiraSiteAriResourceType", () => $032a4e897fcecef5$export$886165a991f21644);
// src/jira/site/types.ts
var $032a4e897fcecef5$export$b7d590981b504412 = "jira", $032a4e897fcecef5$export$886165a991f21644 = "site";

});


parcelRegister("k3PbQ", function(module, exports) {

$parcel$export(module.exports, "extractProjectKey", () => $bfdd97e245e93328$export$f1a2e4721b127828);

var $g5X3G = parcelRequire("g5X3G");
const $bfdd97e245e93328$export$f1a2e4721b127828 = (issueKey)=>(0, $g5X3G.toProjectKey)(issueKey.split('-')[0]);

});

parcelRegister("6yLM4", function(module, exports) {

$parcel$export(module.exports, "getMainIssueViewAggQueryFeatureFlagVariables", () => $bbb83ac7c9853fc8$export$3dd406718c5846c6);
$parcel$export(module.exports, "getMainIssueViewAggQueryVariables", () => $bbb83ac7c9853fc8$export$5896c8dc13246fe2);
/**
 * @fileOverview
 * All variables that get passed in to the mainIssueAggQuery are defined here.
 * The abstraction is necessary because there are multiple call paths to mainIssueAggQuery,
 * so having a single source of truth for the variables eliminates a vector for
 * bugs and inconsistencies when they are invoked.
 *
 * This file will be removed (and therefore the need for the linting exemption) once we reduce
 * the number of discrete call paths for mainIssueAggQuery to one. That work will be done in
 * https://jira.atlassian.com/browse/JIV-19486.
 *
 * Sorry, Tom.
 *
 * <3 Daz
 */ /* eslint-disable jira/ff/inline-usage */ 
var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $5CSGy = parcelRequire("5CSGy");


var $ldyPw = parcelRequire("ldyPw");

var $lpLR9 = parcelRequire("lpLR9");

var $j8DrX = parcelRequire("j8DrX");

var $la3vp = parcelRequire("la3vp");

var $k2DRb = parcelRequire("k2DRb");

var $6tI1D = parcelRequire("6tI1D");
const $bbb83ac7c9853fc8$var$_unused = ()=>(0, $4R6GH.fg)('jiv-19486-allow-fg-usage-in-early-scripts');
const $bbb83ac7c9853fc8$export$623cfa88de62fcd = ()=>{
    const providerVariables = (0, $la3vp.default)?.params?.providedVariables ?? {};
    return Object.entries(providerVariables).reduce((acc, [key, provider])=>{
        acc[key] = provider.get();
        return acc;
    }, {});
};
const $bbb83ac7c9853fc8$export$3dd406718c5846c6 = ()=>({
        isCompassComponentsEnabled: true,
        jiraCommentsAGGPagination: (0, $4R6GH.fg)('jira_comments_agg_pagination') || (0, $4R6GH.fg)('jira_comments_agg_pagination_consistency_check'),
        issueViewRelayConfigurationUrlFlag: (0, $4R6GH.fg)('jiv-replace-configuration-button-in-context-panel'),
        jsmSentimentCustomFieldFlag: true,
        isJPDPanelEnabled: (0, $4R6GH.fg)('jpd_idea_panel_in_issue_view'),
        issueViewRelayPriorityFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-priority'),
        // if assignee/reporter/user is true, it represents SingleSelectUserPicker being used
        issueViewRelayAssigneeFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-assignee-fg') || (0, $4R6GH.fg)('relay-migration-issue-fields-reporter') || (0, $4R6GH.fg)('relay-migration-issue-fields-user-fg'),
        issueViewRelayNumberFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-number'),
        issueViewRelaySprintFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-sprint'),
        issueViewRelayAttachmentsFlag: (0, $4R6GH.fg)('relay-migration-issue-view-attachments-'),
        issueViewRelayComponentsFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-components-select'),
        issueViewRelayResolutionFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-resolution'),
        issueViewRelaySingleLineTextFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-single-line-text-fg') || (0, $4R6GH.fg)('relay-migration-issue-fields-single-line-text-msg'),
        issueViewRelayDateFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-date-sg'),
        issueViewRelayParentFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-header-and-parent'),
        issueViewRelayProjectFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-project-select'),
        issueViewRelayDateTimeFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-date-time-fg'),
        issueViewRelayMetadataFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-metadata'),
        issueViewDesignsPanelFlag: (0, $6s1PB.expVal)('collapsed_designs_panel', 'isCollapsedDesignsPanelEnabled', false),
        issueViewDesignsPanelProvidersFlag: (0, $4R6GH.fg)('only_show_designs_panel_with_design_providers'),
        isJPDDeliveryLinkTypeFilteringEnabled: (0, $4R6GH.fg)('jpd_idea_panel_in_issue_view'),
        issueViewRelayUrlFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-url'),
        issueViewRemoveSingleVersionFieldOptionsFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-issue-version'),
        issueViewRemoveCheckboxSelectFieldOptionsFlag: (0, $4R6GH.fg)('remove_issue_field_options_main_query'),
        issueViewRelaySummaryFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-summary'),
        issueViewRelayColorFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-color'),
        issueViewRelayHeaders: (0, $4R6GH.fg)('relay-migration-issue-header-and-parent'),
        issueViewRelayPeopleAndApproversFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-people-fg') || (0, $4R6GH.fg)('relay-migration-issue-fields-approvers-fg'),
        issueViewRelayTimeTrackingFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-time-tracking'),
        issueViewRemoveRadioSelectFieldOptionsFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-radio'),
        customFieldConfigurationFlag: (0, $4R6GH.fg)('issue_view_field_config_edit'),
        isPinFieldConfigurabilityEnabled: true,
        jcsFlag: (0, $4R6GH.fg)('jcs_master_flag'),
        issueViewSmartRepliesSettingsFlag: (0, $4R6GH.fg)('smart-replies-system-setting') ?? false,
        issueViewStopFetchingJiraQueryIsAiEnabledForIssue: (0, $4R6GH.fg)('jiv-19647-stop-fetching-jira-isaienabledforissue'),
        issueViewMoveJiraQueryIsAiEnabledProjectField: (0, $4R6GH.fg)('issue_view_move_isaienable_from_project_field'),
        crossflowBannerDismissedInAggFlag: (0, $4R6GH.fg)('jiv-19897-move-user-prefs-to-mainissueagg'),
        dateFieldsMessageEnabled: (0, $6s1PB.expValEquals)('jsw_start_and_due_dates', 'cohort', 'variation'),
        chinEmbedQueryToAgg: (0, $4R6GH.fg)('issue-jiv-19838-chin-api-lookup-through-issue-key'),
        jiraThreadedCommentsEnabled: (0, $4R6GH.fg)('threaded_comments_fetch_only'),
        issueViewActivityLayoutFieldEnabled: (0, $6s1PB.expVal)('issue-view-side-panel-activity', 'isActivityInSidePanel', false),
        userThemePrefsInAggEnabled: (0, $4R6GH.fg)('custom-nav-theme-preferences-to-mainissueagg'),
        issueViewRedactionExperience: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('enable_redaction_support_in_jira_issue_view') && (0, $4R6GH.fg)('jiv-replace-configuration-button-in-context-panel') && (0, $4R6GH.fg)('relay-migration-issue-header-and-parent'),
        issueViewCoverExperimentEnabled: (0, $6s1PB.expVal)('cover-image-issue-view-experiment', 'isSharedCoverEnabled', false) || (0, $6s1PB.expVal)('cover-image-issue-view-experiment', 'isMiddleCoverEnabled', false),
        isPlaybooksEnabled: (0, $4R6GH.fg)('playbook_in_jsm_ga'),
        assignToMeUserPreloaded: (0, $4R6GH.fg)('assign-to-me-user-preloaded-in-issue-view'),
        isAutomationDiscoverabilityEnabled: (0, $4R6GH.fg)('automation_discoverability_in_jsm'),
        issueViewChildIssuesPanelPerformance: (0, $4R6GH.fg)('jira-issue-view-child-issues-panel-performance'),
        mentionedConfluencePageLinksV2PaginationFlag: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('jsw_issue_view_placeholder_template_v2') && (0, $4R6GH.fg)('jiv-19125-fetch-remote-links-in-interactive-query'),
        mentionedConfluencePageLinksPaginationFlag: !(0, $4R6GH.fg)('jsw_issue_view_placeholder_template_v2') && (0, $4R6GH.fg)('jiv-19125-fetch-remote-links-in-interactive-query')
    });
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $bbb83ac7c9853fc8$var$getURLFromWindow = ()=>new URL(window.location.href);
const $bbb83ac7c9853fc8$export$5896c8dc13246fe2 = (issueKey, url = $bbb83ac7c9853fc8$var$getURLFromWindow())=>({
        ...$bbb83ac7c9853fc8$export$623cfa88de62fcd(),
        ...$bbb83ac7c9853fc8$export$3dd406718c5846c6(),
        ...(0, $4R6GH.fg)('jiv-19906-fix-targered-permalink-on-server') ? $bbb83ac7c9853fc8$export$e2c3bddbfc195841(url) : $bbb83ac7c9853fc8$export$afa6e4ae995b8926(),
        ...$bbb83ac7c9853fc8$var$getStorageBannerVariables(),
        ...$bbb83ac7c9853fc8$var$getIssueSearchForChildIssueQueryVariables(issueKey),
        ...$bbb83ac7c9853fc8$var$getForgeSpecificVariables(),
        ...$bbb83ac7c9853fc8$var$getIsFromSoftwareCalendarOrTimelineViewQueryVariables()
    });
const $bbb83ac7c9853fc8$var$getIsFromSoftwareCalendarOrTimelineViewQueryVariables = ()=>{
    if ((0, $6s1PB.expValEquals)('jsw_start_and_due_dates', 'cohort', 'variation')) {
        if (typeof window !== 'undefined') {
            const pathname = window.location.pathname;
            const pattern = /^\/jira\/software(?:\/c)?\/projects\/[^/]+\/boards\/\d+\/(calendar|timeline)$/;
            return {
                isInTimelineOrCalendarView: pattern.test(pathname)
            };
        }
    }
    return {
        isInTimelineOrCalendarView: false
    };
};
const $bbb83ac7c9853fc8$var$getIssueSearchForChildIssueQueryVariables = (issueKey)=>({
        // will have to put jql order by rank later
        issueSearchInput: {
            childIssuesInput: {
                parentIssueKey: issueKey || ''
            }
        },
        amountOfColumns: 500,
        namespace: 'CHILD_ISSUE_PANEL',
        fieldSetIds: [],
        shouldQueryFieldSetsById: false,
        fieldSetsInput: {
            viewInput: {
                namespace: 'CHILD_ISSUE_PANEL',
                context: {
                    issueContext: {
                        issueKey: issueKey
                    }
                }
            }
        },
        fieldSetsContext: {
            issueContext: {
                issueKey: issueKey
            }
        },
        filterId: null,
        viewId: null,
        legacyChildIssueFieldIds: (0, $4R6GH.fg)('jira-issue-view-child-issues-panel-performance') ? [
            'issuetype',
            'status',
            'timetracking'
        ] : [
            'created',
            'issuetype',
            'priority',
            'status',
            'summary',
            'timetracking',
            'updated'
        ]
    });
const $bbb83ac7c9853fc8$export$afa6e4ae995b8926 = ()=>{
    const commentTargetId = (0, $6tI1D.getPermalinkId)((0, $6tI1D.COMMENTS)) || null;
    return {
        commentTargetId: commentTargetId,
        hasCommentTargetId: !!commentTargetId
    };
};
const $bbb83ac7c9853fc8$export$e2c3bddbfc195841 = (url)=>{
    let commentTargetId = null;
    if ((0, $4R6GH.fg)('jiv-19906-fix-targered-permalink-on-server')) commentTargetId = (0, $6tI1D.getPermalinkIdFromURL)((0, $6tI1D.COMMENTS), url);
    else commentTargetId = (0, $6tI1D.getPermalinkId)((0, $6tI1D.COMMENTS));
    return {
        commentTargetId: commentTargetId,
        hasCommentTargetId: !!commentTargetId
    };
};
const $bbb83ac7c9853fc8$var$getStorageBannerVariables = ()=>({
        issueViewStorageLimitsBannerFlag: (0, $lpLR9.default)((0, $j8DrX.default)).software === (0, $ldyPw.FREE_EDITION) && (0, $4R6GH.fg)('move_storage_banner_data_fetch_to_main_issue_agg'),
        offeringKey: (0, $5CSGy.getProductOfferingKeyOrThrow)((0, $c06e1abca7c13910$export$1346c9aa3cbb477d), (0, $ldyPw.STANDARD_EDITION)),
        productKey: (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)
    });
const $bbb83ac7c9853fc8$var$getForgeSpecificVariables = ()=>{
    return {
        forgeInMainIssueAggFlag: (0, $4R6GH.fg)('move_forge_data_fetch_to_main_issue_agg'),
        forgeTypes: (0, $4R6GH.fg)('move_forge_data_fetch_to_main_issue_agg') ? [
            (0, $k2DRb.ISSUE_ACTION_MODULE),
            (0, $k2DRb.ISSUE_GLANCE_MODULE),
            (0, $k2DRb.ISSUE_CONTEXT_MODULE),
            (0, $k2DRb.ISSUE_PANEL_MODULE),
            (0, $k2DRb.ISSUE_ACTIVITY_MODULE),
            (0, $k2DRb.CUSTOM_FIELD_MODULE),
            (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE),
            (0, $k2DRb.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
            (0, $k2DRb.UI_MODIFICATIONS_MODULE)
        ] : [],
        includeUserAccessForge: (0, $4R6GH.fg)('forge_query_include_user_access'),
        includeEgressOverridesForge: (0, $4R6GH.fg)('forge-ui-overrides-property-in-extension-list')
    };
};

});
parcelRegister("5CSGy", function(module, exports) {

$parcel$export(module.exports, "getProductOfferingKeyForProject", () => $75290a6120824a25$export$3ad43d25ded909ee);
$parcel$export(module.exports, "getProductOfferingKeyOrThrow", () => $75290a6120824a25$export$92c311d982d129d5);


var $1laI5 = parcelRequire("1laI5");
// Please don't use access these directly, try to implement these using common platform types such as below
const $75290a6120824a25$var$JSW_PRODUCT_OFFERING_KEYS = {
    FREE_EDITION: 'de2887c9-8a55-41d5-b5cf-ad6a5589ebed',
    STANDARD_EDITION: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526',
    PREMIUM_EDITION: '6dd805b4-da75-4374-a7a7-cf0b12f7ea07',
    UNLICENSED: null
};
const $75290a6120824a25$var$JPD_PRODUCT_OFFERING_KEYS = {
    FREE_EDITION: 'd843dd9e-23c5-4d27-af44-5009d568cb6e',
    STANDARD_EDITION: '35b9268e-66e2-45fb-81d3-dacd1e31831a',
    PREMIUM_EDITION: 'f0b24ca7-c3d8-4cac-b5ed-60f4152d4dcd',
    UNLICENSED: null
};
const $75290a6120824a25$var$JSM_PRODUCT_OFFERING_KEYS = {
    FREE_EDITION: '24656f1f-5c14-45ea-88ea-142b9c633661',
    STANDARD_EDITION: '99bcbf6c-4fff-4a45-8303-a854e7fbd17c',
    PREMIUM_EDITION: '0c6683b4-4633-4673-beca-690d171de6a5',
    UNLICENSED: null
};
const $75290a6120824a25$export$581b2a05d59c1826 = (applicationKey, applicationEdition)=>{
    switch(applicationKey){
        case 0, $c06e1abca7c13910$export$1346c9aa3cbb477d:
            return $75290a6120824a25$var$JSW_PRODUCT_OFFERING_KEYS[applicationEdition];
        case 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61:
            return $75290a6120824a25$var$JSM_PRODUCT_OFFERING_KEYS[applicationEdition];
        case 0, $c06e1abca7c13910$export$202f50ee62667e32:
            return $75290a6120824a25$var$JPD_PRODUCT_OFFERING_KEYS[applicationEdition];
        // can support more products if implemented in future
        default:
            return null;
    }
};
const $75290a6120824a25$export$3ad43d25ded909ee = (project, edition)=>{
    const application = (0, $1laI5.projectToApplicationKey)(project);
    const offeringKey = $75290a6120824a25$export$581b2a05d59c1826(application, edition);
    if (offeringKey === null) throw new Error(`Missing offering key for: ${application} ${edition}`);
    return offeringKey;
};
const $75290a6120824a25$export$92c311d982d129d5 = (applicationKey, applicationEdition)=>{
    const offeringKey = $75290a6120824a25$export$581b2a05d59c1826(applicationKey, applicationEdition);
    if (offeringKey === null) throw new Error(`Missing offering key for: ${applicationKey} ${applicationEdition}`);
    return offeringKey;
};

});
parcelRegister("1laI5", function(module, exports) {

$parcel$export(module.exports, "getTrialDaysLeft", () => $39ed199f3e5d9f33$export$954628993bf3188e);
$parcel$export(module.exports, "projectToApplicationKey", () => $39ed199f3e5d9f33$export$1af4fd6f5c543149);

var $2vSU6 = parcelRequire("2vSU6");

const $39ed199f3e5d9f33$export$9dbbf537dffaafc7 = (timestamp)=>new Date(timestamp).setUTCHours(0, 0, 0, 0);
const $39ed199f3e5d9f33$export$954628993bf3188e = (trialEndTime)=>trialEndTime && Math.ceil(($39ed199f3e5d9f33$export$9dbbf537dffaafc7(trialEndTime) - Date.now()) / 86400000);
const $39ed199f3e5d9f33$export$271517afaa0c15eb = (trialEndTime)=>{
    const trialDaysLeft = $39ed199f3e5d9f33$export$954628993bf3188e(trialEndTime);
    // Technically we do not know whether user is in grace period or not, but if user is able to access the Jira with no payment details
    // and is trialEndTime is missing or over we assume that site is in grace period
    return !trialDaysLeft || trialDaysLeft < 0;
};
const $39ed199f3e5d9f33$export$1af4fd6f5c543149 = (project)=>{
    switch(project){
        // With spork, we should update core projects as it they were Software projects
        case 0, $2vSU6.SOFTWARE_PROJECT:
        case 0, $2vSU6.CORE_PROJECT:
            return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return 0, $c06e1abca7c13910$export$202f50ee62667e32;
        default:
            throw new Error(`Unsupported project: ${project}`);
    }
};

});


parcelRegister("la3vp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d1e3365ed212162$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dca3e47ee43b9aeb97a5ce60cabcaef4>>
 * @relayHash 0eafb9843e3faf531da575a7e9f25aa4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b1212ab13cc6e3a207121a7271f0347415d98a217f48ac799513a91b4335068

var $beHGE = parcelRequire("beHGE");

var $5oQtH = parcelRequire("5oQtH");

var $5FIjM = parcelRequire("5FIjM");

var $5qm7M = parcelRequire("5qm7M");

var $dttgK = parcelRequire("dttgK");

var $ju8GE = parcelRequire("ju8GE");

var $5YQLv = parcelRequire("5YQLv");

var $asT4T = parcelRequire("asT4T");

var $hBTVA = parcelRequire("hBTVA");

var $9OzGv = parcelRequire("9OzGv");

var $33qJ8 = parcelRequire("33qJ8");

var $h6nNu = parcelRequire("h6nNu");

var $5pSyb = parcelRequire("5pSyb");

var $cKVMM = parcelRequire("cKVMM");

var $5mEVc = parcelRequire("5mEVc");

var $ef20f = parcelRequire("ef20f");

var $84KW9 = parcelRequire("84KW9");

var $3wM25 = parcelRequire("3wM25");

var $ipyFC = parcelRequire("ipyFC");

var $kT0rw = parcelRequire("kT0rw");

var $d6bux = parcelRequire("d6bux");

var $bdIYk = parcelRequire("bdIYk");

var $hjJTo = parcelRequire("hjJTo");

var $jDqgH = parcelRequire("jDqgH");

var $iwPkC = parcelRequire("iwPkC");

var $krohK = parcelRequire("krohK");

var $6NR1m = parcelRequire("6NR1m");

var $3E2yq = parcelRequire("3E2yq");

var $6sYK2 = parcelRequire("6sYK2");

var $fmbEw = parcelRequire("fmbEw");

var $hSNvs = parcelRequire("hSNvs");

var $qPPmw = parcelRequire("qPPmw");

var $8Y9hN = parcelRequire("8Y9hN");

var $4yni1 = parcelRequire("4yni1");

var $ejqaS = parcelRequire("ejqaS");

var $eXeEx = parcelRequire("eXeEx");

var $hBvdF = parcelRequire("hBvdF");
const $7d1e3365ed212162$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7b1212ab13cc6e3a207121a7271f0347415d98a217f48ac799513a91b4335068",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "jira",
                        "issueByKey",
                        "attachments"
                    ]
                }
            ]
        },
        "name": "mainIssueAggQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationconfigurationurlrelayprovider": (0, $5YQLv.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewredactionexperiencerelayprovider": (0, $5FIjM.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": (0, $h6nNu.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsparent": (0, $d6bux.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldstimetrackingrelayprovider": (0, $8Y9hN.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscheckboxselectrelayprovider": (0, $9OzGv.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscomponentsrelayprovider": (0, $33qJ8.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsoriginalestimaterelayprovider": (0, $kT0rw.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrequestparticipantsrelayprovider": (0, $3wM25.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsgrouppickerrelayprovider": (0, $5pSyb.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultigrouppickerrelayprovider": (0, $84KW9.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsteamrelayprovider": (0, $qPPmw.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsradioselectrelayprovider": (0, $hjJTo.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrichtextrelayprovider": (0, $6NR1m.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultiuserparticipantsrelayprovider": (0, $ipyFC.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrequestparticipantsrelayprovider": (0, $iwPkC.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldspeoplerelayprovider": (0, $bdIYk.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsapproversrelayprovider": (0, $asT4T.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssinglelinetextmessagerelayprovider": (0, $6sYK2.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsassigneerelayprovider": (0, $hBTVA.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsreporterrelayprovider": (0, $jDqgH.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsuserrelayprovider": (0, $4yni1.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsheaderactionsrelayprovider": (0, $cKVMM.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldswatchersrelayprovider": (0, $eXeEx.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssecuritylevelrelayprovider": (0, $3E2yq.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsvotesrelayprovider": (0, $ejqaS.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuerestrictionsrelayprovider": (0, $5mEVc.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcconcealitemsintomeatballmenuexperimentrelayprovidertsx": (0, $beHGE.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuetypeswitcherrelayprovider": (0, $ef20f.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsresolutionrelayprovider": (0, $krohK.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatusrelayprovider": (0, $hSNvs.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatuspanelrelayprovider": (0, $fmbEw.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrconeeventimprovementsenabledrelayprovider": (0, $ju8GE.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default)
        }
    }
};
var $7d1e3365ed212162$export$2e2bcd8739ae039 = $7d1e3365ed212162$var$node;

});
parcelRegister("beHGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e77216947a3d05a6$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $e77216947a3d05a6$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('_conceal_items_into_meatball_menu');
    }
};

});

parcelRegister("5FIjM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c20c48eec5732675$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $c20c48eec5732675$export$2e2bcd8739ae039 = {
    get () {
        return(// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('enable_redaction_support_in_jira_issue_view') && (0, $4R6GH.fg)('jiv-replace-configuration-button-in-context-panel') && (0, $4R6GH.fg)('relay-migration-issue-header-and-parent'));
    }
};

});

parcelRegister("ju8GE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f22f95d64a2848da$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $f22f95d64a2848da$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('one_event_improvements_1');
    }
};

});

parcelRegister("5YQLv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cc7b1249165c5cc$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $8cc7b1249165c5cc$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jiv-replace-configuration-button-in-context-panel');
    }
};

});

parcelRegister("asT4T", function(module, exports) {

$parcel$export(module.exports, "default", () => $587bfe0115b03c48$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $587bfe0115b03c48$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-approvers-fg');
    }
};

});

parcelRegister("hBTVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $317518afb86d429d$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $317518afb86d429d$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-assignee-fg');
    }
};

});

parcelRegister("9OzGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $68a7d680b4f7aa31$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $68a7d680b4f7aa31$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-checkbox-select');
    }
};

});

parcelRegister("33qJ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a066af595fad6e31$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $a066af595fad6e31$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-components-select');
    }
};

});

parcelRegister("h6nNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ea05c28112074d6$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $4ea05c28112074d6$var$isIssueViewFieldConfigEditEnabled = {
    get () {
        return (0, $4R6GH.fg)('issue_view_field_config_edit');
    }
};
var $4ea05c28112074d6$export$2e2bcd8739ae039 = $4ea05c28112074d6$var$isIssueViewFieldConfigEditEnabled;

});

parcelRegister("5pSyb", function(module, exports) {

$parcel$export(module.exports, "default", () => $46b71e3be8dfea7a$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $46b71e3be8dfea7a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-group-picker-sg');
    }
};

});

parcelRegister("cKVMM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7153ac791d0f4b40$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $7153ac791d0f4b40$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("5mEVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $dba981d8b012adb8$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $dba981d8b012adb8$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("ef20f", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dac75eea754d44b$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5dac75eea754d44b$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("84KW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $78c1aa824cd21c11$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $78c1aa824cd21c11$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-multi-group-picker-fg');
    }
};

});

parcelRegister("3wM25", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4f763f7ab8915ff$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $b4f763f7ab8915ff$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-multi-user-fg');
    }
};

});

parcelRegister("ipyFC", function(module, exports) {

$parcel$export(module.exports, "default", () => $de9ca17802c9cba7$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $de9ca17802c9cba7$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-multi-user-fg');
    }
};

});

parcelRegister("kT0rw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cdff8c37120a188$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $4cdff8c37120a188$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-original-estimate');
    }
};

});

parcelRegister("d6bux", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d9e6f2a33f8172f$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4d9e6f2a33f8172f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("bdIYk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3216c683ee81b04$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $d3216c683ee81b04$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-people-fg');
    }
};

});

parcelRegister("hjJTo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8a929bbaac9d588$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $c8a929bbaac9d588$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-radio');
    }
};

});

parcelRegister("jDqgH", function(module, exports) {

$parcel$export(module.exports, "default", () => $144d769a6379ff4e$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $144d769a6379ff4e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-reporter');
    }
};

});

parcelRegister("iwPkC", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb870d58c524b581$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $cb870d58c524b581$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-multi-user-fg');
    }
};

});

parcelRegister("krohK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ee92d752c596813$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $7ee92d752c596813$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-resolution');
    }
};

});

parcelRegister("6NR1m", function(module, exports) {

$parcel$export(module.exports, "default", () => $851058f7192cd7ee$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $851058f7192cd7ee$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-multi-line-text-fg');
    }
};

});

parcelRegister("3E2yq", function(module, exports) {

$parcel$export(module.exports, "default", () => $847675c0acc8db9e$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $847675c0acc8db9e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("6sYK2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab91eec7ddbe8f3e$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $ab91eec7ddbe8f3e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-single-line-text-msg');
    }
};

});

parcelRegister("fmbEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $afb9a48dda30cc33$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $afb9a48dda30cc33$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-resolution') || (0, $4R6GH.fg)('relay-migration-issue-fields-status');
    }
};

});

parcelRegister("hSNvs", function(module, exports) {

$parcel$export(module.exports, "default", () => $efddcea96d8714d0$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $efddcea96d8714d0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-status');
    }
};

});

parcelRegister("qPPmw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0786657423f5409$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $e0786657423f5409$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-team-field-next');
    }
};

});

parcelRegister("8Y9hN", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb6d2edf34e99bba$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $eb6d2edf34e99bba$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-time-tracking');
    }
};

});

parcelRegister("4yni1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5243bedb3fa46125$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5243bedb3fa46125$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-user-fg');
    }
};

});

parcelRegister("ejqaS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7323747132cbc58$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $c7323747132cbc58$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("eXeEx", function(module, exports) {

$parcel$export(module.exports, "default", () => $acfad9d58e7d968c$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $acfad9d58e7d968c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});


parcelRegister("6tI1D", function(module, exports) {

$parcel$export(module.exports, "PermalinkType", () => $ac458c74e4b12b29$export$b18d061fc042df1a);
$parcel$export(module.exports, "COMMENTS", () => $ac458c74e4b12b29$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $ac458c74e4b12b29$export$df36fc05622c402);
$parcel$export(module.exports, "getAllUrlParams", () => $ac458c74e4b12b29$export$dca91ad250f6b082);
$parcel$export(module.exports, "getPermalinkId", () => $ac458c74e4b12b29$export$bf42dbba4c31080e);
$parcel$export(module.exports, "getPermalinkIdFromURL", () => $ac458c74e4b12b29$export$87557f913748dcff);

var $gKZoD = parcelRequire("gKZoD");

var $dJl1T = parcelRequire("dJl1T");
const $ac458c74e4b12b29$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};
const $ac458c74e4b12b29$export$4cab9dfa8fc858f4 = 'COMMENTS';
const $ac458c74e4b12b29$export$df36fc05622c402 = 'WORKLOG';
/**
 * @deprecated this function is unsafe for using on server side code due to `window` object usage
 */ const $ac458c74e4b12b29$export$dca91ad250f6b082 = ()=>{
    (0, $gKZoD.di)(window);
    // get query string from  window
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let queryString = window.location.search.slice(1);
    // we'll store the parameters here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const obj = {};
    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];
        // split our query string into its component parts
        const arr = queryString.split('&');
        for(let i = 0; i < arr.length; i += 1){
            // separate the keys and the values
            const a = arr[i].split('=');
            // set parameter name and value (use 'true' if empty)
            const paramName = a[0];
            try {
                const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
                obj[paramName] = paramValue;
            } catch (error) {
                (0, $dJl1T.default).safeErrorWithoutCustomerData('getAllUrlParams', `Malformed value was obtained from the query string for ${paramName}`);
            }
        }
    }
    return obj;
};
const $ac458c74e4b12b29$export$bf42dbba4c31080e = (targetPermalinkType)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    if (!$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]) return null;
    const urlParams = $ac458c74e4b12b29$export$dca91ad250f6b082();
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    return urlParams[$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]];
};
const $ac458c74e4b12b29$export$87557f913748dcff = (targetPermalinkType, url)=>{
    const queryParamKey = $ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType];
    if (!queryParamKey) return null;
    return url.searchParams.get(queryParamKey);
};

});


parcelRegister("2Yhep", function(module, exports) {

$parcel$export(module.exports, "getIssueKey", () => $05d1e79edcc0dc56$export$4a030f6192bebe03);
const $05d1e79edcc0dc56$export$4a030f6192bebe03 = (match)=>{
    const fromMatch = match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : null;
    return fromMatch;
};

});

// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $cdb023d06c7f62fa$export$19d68f5aa485d903 = false;

parcelRegister("5XgeZ", function(module, exports) {

$parcel$export(module.exports, "withResourceEarlyData", () => $36d3fb93786ec5e2$export$22da5fb8c8200986);
$parcel$export(module.exports, "createRelayResourceDeprecated", () => $36d3fb93786ec5e2$export$2e279339bedcd427);

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $x9xyg = parcelRequire("x9xyg");

var $5yJb9 = parcelRequire("5yJb9");

var $5a0Nh = parcelRequire("5a0Nh");

var $kipqU = parcelRequire("kipqU");

var $2M1hQ = parcelRequire("2M1hQ");

var $1u51R = parcelRequire("1u51R");
const $36d3fb93786ec5e2$export$5664a170ac5a9781 = 5000;
const $36d3fb93786ec5e2$export$22da5fb8c8200986 = ({ type: type, getData: next, getDataLoader: getDataLoader, ...rest })=>{
    const getData = (...args)=>{
        performance.mark(`issueViewEarlyScripts:${type}:withResourceEarlyData:called`);
        if (!false && type in window) {
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
            const promise = window[type];
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            delete window[type];
            getDataLoader && promise.then(getDataLoader);
            return promise;
        }
        if (getDataLoader) return getDataLoader().then(({ default: getDataPromise })=>getDataPromise(...args));
        return next && next(...args);
    };
    return {
        ...rest,
        type: type,
        getData: getData
    };
};
const $36d3fb93786ec5e2$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $36d3fb93786ec5e2$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, $2M1hQ.createResource)({
        type: `${$36d3fb93786ec5e2$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, customContext)=>{
            const { parameters: preloadableRequest, variables: queryVariables, keyVariables: keyVariables } = getQuery(routerContext, customContext);
            // There are some variables that we don't want to trigger a reload even if they are changed, by default use 'variables', or you can also pass over
            // specific keyVariables that will trigger the reload
            const variables = keyVariables || queryVariables;
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            // sources: https://github.com/facebook/relay/blob/4b78c7dd27b286f9ee8f5b993ccb160163956999/packages/react-relay/relay-hooks/loadQuery.js#L273
            // @ts-expect-error - TS2339 - Property 'kind' does not exist on type 'GraphQLTaggedNode | PreloadableConcreteRequest<TQuery>'.
            if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                const preloadableConcreteRequest = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                preloadableRequest;
                ({ params: params } = preloadableConcreteRequest);
                ({ id: queryId } = params);
            } else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $eiowN.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: async (routerContext, customContext)=>{
            const measureName = `relay_resource_get_data:${type}`;
            const startMark = `relay_resource_get_data:${type}:start`;
            const endMark = `relay_resource_get_data:${type}:end`;
            (0, $x9xyg.setMark)(startMark);
            const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
            // We either have a sync query or an async one from loadParameters. Never neither
            // This is enforced by 2 aliases of this method having different types, but Typescript cannot infer that neatly, so we cast away the nullable case.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const query = parameters ?? await loadParameters?.();
            // loadQuery returns not a Promise, but Observable.
            // Resource waits until query Observable is completed and returns a queryReference
            // later queryReference could be used by usePreloadedQuery
            const queryReference = (0, $x9xyg.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $8Uumt.loadQuery)((0, $5yJb9.default)(), query, variables || {}, options));
            if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
            if (queryReference.id != null) (0, $kipqU.QueryPromisesMap).get(queryReference.id)?.then(()=>{
                (0, $x9xyg.setMark)(endMark);
                (0, $x9xyg.setMeasure)(measureName, startMark, endMark);
            });
            /**
			 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
			 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
			 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
			 * as well as subsequent fetches made by route transitions between spa-apps.
			 */ if (captureErrors) (0, $5a0Nh.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $1u51R.startCapturingTraceIds)(queryReference.name);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return queryReference;
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly
    });
const $36d3fb93786ec5e2$export$2e279339bedcd427 = $36d3fb93786ec5e2$var$createRelayResourceImpl;

});


parcelRegister("9XjL6", function(module, exports) {

$parcel$export(module.exports, "issueGiraDataResource", () => $94d751405759debc$export$37badecd288c49f4);

var $4R6GH = parcelRequire("4R6GH");

var $2Yhep = parcelRequire("2Yhep");

var $2M1hQ = parcelRequire("2M1hQ");

var $gNStA = parcelRequire("gNStA");


var $5XgeZ = parcelRequire("5XgeZ");

var $1UEZY = parcelRequire("1UEZY");
const $94d751405759debc$export$37badecd288c49f4 = (0, $gNStA.browserOnlyResourceWithCondition)(()=>{
    if (0, $cdb023d06c7f62fa$export$19d68f5aa485d903) // not "browser only" if FF is on
    return !(0, $4R6GH.fg)('issue-view-ssr-perf-m1');
    return true;
}, // eslint-disable-next-line @typescript-eslint/no-explicit-any
(0, $2M1hQ.createResource)((0, $5XgeZ.withResourceEarlyData)({
    type: 'ISSUE_GIRA_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $2Yhep.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $1UEZY.default)(...args),
    isBrowserOnly: true
})));

});
parcelRegister("1UEZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $48e4146cd1317713$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $ePyEO = parcelRequire("ePyEO");

var $iR3GG = parcelRequire("iR3GG");

var $2Yhep = parcelRequire("2Yhep");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$48e4146cd1317713$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
    const issueKey = (0, $2Yhep.getIssueKey)(match);
    if (!issueKey) return null;
    try {
        const { baseUrl: baseUrl } = tenantContext;
        const data = await (0, $ePyEO.default)(baseUrl, issueKey);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.issue-view.gira.getData',
            message: 'An error was thrown while prefetching issue gira data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("ePyEO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef212fbaef309294$export$2e2bcd8739ae039);

var $2nKjG = parcelRequire("2nKjG");

var $k3PbQ = parcelRequire("k3PbQ");

var $fqpdr = parcelRequire("fqpdr");

var $9kbEN = parcelRequire("9kbEN");

var $iBOrg = parcelRequire("iBOrg");
const $ef212fbaef309294$var$ISSUE_GIRA_DATA = 'issue-gira-data';
const $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric = (0, $2nKjG.metrics).custom({
    key: $ef212fbaef309294$var$ISSUE_GIRA_DATA
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ef212fbaef309294$export$2e2bcd8739ae039 = async (baseUrl, issueKey)=>{
    const projectKey = (0, $k3PbQ.extractProjectKey)(issueKey);
    const variables = {
        issueKey: issueKey,
        projectKey: projectKey
    };
    const payload = {
        query: (0, $fqpdr.buildIssueQuery)(),
        variables: variables,
        operationName: (0, $fqpdr.ISSUE_VIEW_INTERACTIVE_QUERY)
    };
    if ((0, $9kbEN.isInSample)()) $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric.start();
    try {
        const response = await (0, $iBOrg.getClient)(baseUrl).query(payload);
        // Best-effort attempt to provide `issueId` and is not guaranteed
        const issueId = response.data?.viewIssue?.issueId;
        $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric.stop({
            customData: issueId ? {
                issueId: issueId
            } : null
        });
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // Cancel the metric and re-throw the error
        $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric.cancel();
        throw error;
    }
};

});
parcelRegister("fqpdr", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", () => $3789cf83eed10ddd$export$1780a132c0453fee);
$parcel$export(module.exports, "getGiraUrl", () => $3789cf83eed10ddd$export$aefb19023b2eda55);
$parcel$export(module.exports, "getJiraQueryEcosystemFirstSeenOnIssueView", () => $3789cf83eed10ddd$export$79eba9bf6dc9960d);
$parcel$export(module.exports, "buildIssueQuery", () => $3789cf83eed10ddd$export$222ae9aca08830f0);
$parcel$export(module.exports, "getGiraRequestOptions", () => $3789cf83eed10ddd$export$e1542dc7ff749de8);
/**
 * ╔═══════════════╗
 * ║ !!IMPORTANT!! ║
 * ╚═══════════════╝
 * Please do not use statsig feature gating in this file.
 * Read https://hello.atlassian.net/wiki/spaces/JIE/pages/2858513117/Blockers+for+Statsig+in+the+issue-view
 * for why and to follow the fix.
 */ 
var $96nmc = parcelRequire("96nmc");

var $EJMEI = parcelRequire("EJMEI");

var $8TkIN = parcelRequire("8TkIN");

var $e2Vt6 = parcelRequire("e2Vt6");

var $92ECu = parcelRequire("92ECu");

var $6QL4r = parcelRequire("6QL4r");

var $5Pqa3 = parcelRequire("5Pqa3");

var $b1RJj = parcelRequire("b1RJj");

var $1HCMp = parcelRequire("1HCMp");

var $8JI9I = parcelRequire("8JI9I");

var $kNriQ = parcelRequire("kNriQ");

var $cRP2d = parcelRequire("cRP2d");
const $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING = '-created';
const $3789cf83eed10ddd$export$1780a132c0453fee = 'issueViewInteractiveQuery';
const $3789cf83eed10ddd$export$aefb19023b2eda55 = (_baseUrl, operation)=>`/rest/gira/1/${(0, $96nmc.appendOperationQuery)(operation)}`;
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $3789cf83eed10ddd$var$getURLFromWindow = ()=>new URL(window.location.href);
const $3789cf83eed10ddd$var$viewIssueQuery = (url = $3789cf83eed10ddd$var$getURLFromWindow())=>`
    viewIssue(issueKey: $issueKey) {
        canCreateSubTask
        canExportIssue
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $EJMEI.default)({
        maxResults: (0, $92ECu.NUM_INITIAL_COMMENTS_TO_LOAD),
        startAt: 0,
        orderBy: $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING,
        commentAmount: Math.floor((0, $92ECu.NUM_INITIAL_COMMENTS_TO_LOAD)),
        hydrateData: false,
        url: url
    })}
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $cRP2d.default)({
        startAt: 0,
        worklogAmount: Math.floor((0, $92ECu.NUM_INITIAL_WORKLOGS_TO_LOAD)),
        url: url
    })}
        ${(0, $e2Vt6.getEcosystemQuery)()}
        ${(0, $8TkIN.getContentPanelsQuery)()}
        ${(0, $e2Vt6.getLegacyRightWebPanelsQuery)()}
        totalAttachmentsCount
        ${(0, $5Pqa3.getContainersByTypeQuery)()}
        ${(0, $kNriQ.getRemoteLinksQuery)()}
    }
`;
const $3789cf83eed10ddd$export$79eba9bf6dc9960d = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
    }
`;
const $3789cf83eed10ddd$export$58eaa2ae4a5a410a = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
        hasAdministerPermission: hasGlobalPermission(key: ADMINISTER)
        hasUserPickerPermission: hasGlobalPermission(key: USER_PICKER)
    }
`;
const $3789cf83eed10ddd$export$222ae9aca08830f0 = (url)=>`
query ${$3789cf83eed10ddd$export$1780a132c0453fee}($issueKey: String!, $projectKey: String)  {
        ${$3789cf83eed10ddd$export$58eaa2ae4a5a410a()}
        ${(0, $b1RJj.default)()}
        ${$3789cf83eed10ddd$var$viewIssueQuery(url)}
        ${(0, $6QL4r.getJiraSettingsQuery)()}
        ${(0, $1HCMp.default)()}
        ${(0, $8JI9I.default)()}
    }

`;
const $3789cf83eed10ddd$export$e1542dc7ff749de8 = (issueKey, projectKey, url)=>{
    const payload = {
        operationName: $3789cf83eed10ddd$export$1780a132c0453fee,
        query: $3789cf83eed10ddd$export$222ae9aca08830f0(url),
        variables: {
            issueKey: issueKey,
            projectKey: projectKey
        }
    };
    return {
        method: 'POST',
        body: JSON.stringify(payload)
    };
};

});
parcelRegister("96nmc", function(module, exports) {

$parcel$export(module.exports, "appendOperationQuery", () => $8119dcf59ebfcad5$export$69694c3add0f6058);
const $8119dcf59ebfcad5$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});

parcelRegister("EJMEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ae9b8d951a6992$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $6tI1D = parcelRequire("6tI1D");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$01ae9b8d951a6992$export$2e2bcd8739ae039 = ({ maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentAmount: commentAmount, hydrateData: hydrateData = true, url: url })=>{
    const commentPermalinkId = url && (0, $4R6GH.fg)('jiv-19906-fix-targered-permalink-on-server') ? (0, $6tI1D.getPermalinkIdFromURL)((0, $6tI1D.COMMENTS), url) : (0, $6tI1D.getPermalinkId)((0, $6tI1D.COMMENTS));
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const commentParameter = commentPermalinkId !== null && commentPermalinkId !== undefined ? `, commentId: ${commentPermalinkId}` : '';
    const commentAmountParameter = commentParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
    const maxResultsParameter = commentParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
    const jiraCommentVisibility = ` jiraCommentVisibility {
    __typename
    ...on JiraRoleVisibility {
      name
    }
    ...on JiraGroupVisibility {
      group {
        groupId
        name
      }
    }
  }`;
    if ((0, $4R6GH.fg)('jira_comments_agg_pagination')) return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            totalCount
        }
    `;
    if (!(0, $4R6GH.fg)('jira_comments_agg_pagination_consistency_check') && !hydrateData) return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            totalCount
            startIndex
        }
    `;
    return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                ${jiraCommentVisibility}
                created
                updated
                jsdPublic
                bodyAdf
                jsdAuthorCanSeeRequest
                eventOccurredAt
                jsdIncidentActivityViewHidden
            }
            totalCount
            startIndex
        }
    `;
};

});

parcelRegister("8TkIN", function(module, exports) {

$parcel$export(module.exports, "getContentPanelsQuery", () => $09fdc8c72c341092$export$e6f14eac549b679d);
const $09fdc8c72c341092$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
const $09fdc8c72c341092$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
const $09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
const $09fdc8c72c341092$export$e6f14eac549b679d = ()=>`
    ${$09fdc8c72c341092$var$getContentPanelsConnectionQuery()}
    ${$09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;

});

parcelRegister("e2Vt6", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $1771eed42c62eeca$export$edefef8c65e08bd2);
$parcel$export(module.exports, "getLegacyRightWebPanelsQuery", () => $1771eed42c62eeca$export$92c9a3dc7076af51);
const $1771eed42c62eeca$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
const $1771eed42c62eeca$export$edefef8c65e08bd2 = ()=>`
    ecosystem {
      activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${$1771eed42c62eeca$var$getForgeQuery()}
    }
`;
const $1771eed42c62eeca$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;

});

parcelRegister("92ECu", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", () => $9387aa2a419a55f9$export$c46d621c29194aa4);
$parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", () => $9387aa2a419a55f9$export$b2e398ce246f55b3);
$parcel$export(module.exports, "gqlTagGira", () => $9387aa2a419a55f9$export$aeae6fc40846cf9f);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports














const $9387aa2a419a55f9$export$c46d621c29194aa4 = 5;
const $9387aa2a419a55f9$export$304a6c004edb30d8 = '-created';
const $9387aa2a419a55f9$export$b2e398ce246f55b3 = 5;
const $9387aa2a419a55f9$export$1c36ecc9afd61c73 = '-started';
const $9387aa2a419a55f9$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});

parcelRegister("6QL4r", function(module, exports) {

$parcel$export(module.exports, "getJiraSettingsQuery", () => $10470e592ba8e782$export$191f50c0f86b85ec);
const $10470e592ba8e782$export$e302502f14e3f203 = ()=>`
          timeTracking {
            isTimeTrackingEnabled
            hoursPerDay
            daysPerWeek
            defaultUnit
            format
          }
    `;
const $10470e592ba8e782$export$65e7d3d1915962da = ()=>`
          subtasks {
            enabled
          }
    `;
const $10470e592ba8e782$export$191f50c0f86b85ec = ()=>`
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;

});

parcelRegister("5Pqa3", function(module, exports) {

$parcel$export(module.exports, "getContainersByTypeQuery", () => $85e2f5a62f1697d1$export$63131b2831854cc);

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");
const $85e2f5a62f1697d1$export$e30f32dd3fd26efd = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $85e2f5a62f1697d1$export$842411c0b98baa9c = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL, CUSTOMER_CONTEXT], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $85e2f5a62f1697d1$export$63131b2831854cc = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_master_flag'), $85e2f5a62f1697d1$export$842411c0b98baa9c, $85e2f5a62f1697d1$export$e30f32dd3fd26efd);

});

parcelRegister("b1RJj", function(module, exports) {

$parcel$export(module.exports, "default", () => $42429f0fa15c54ae$export$2e2bcd8739ae039);

var $9wuCE = parcelRequire("9wuCE");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$42429f0fa15c54ae$export$2e2bcd8739ae039 = ()=>`mediaContext(issueKey: $issueKey) {
    userToken {
      token
      id
      issueId
      tokenDurationInMins
    }
    uploadToken {
      __typename
      ... on MediaUploadToken {
        endpointUrl
        token
        targetCollection
        tokenDurationInMins
        clientId
      }
      ... on FailedMediaUploadToken {
        error
      }
    }
    readToken(maxTokenLength: ${(0, $9wuCE.getMaxTokenLength)()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;

});
parcelRegister("9wuCE", function(module, exports) {

$parcel$export(module.exports, "getMaxTokenLength", () => $ebb491dcc11e8362$export$e40f2acaf1a50b00);
// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const $ebb491dcc11e8362$var$nonIE11MaxTokenLength = 2 ** 16;
const $ebb491dcc11e8362$export$e40f2acaf1a50b00 = ()=>$ebb491dcc11e8362$var$nonIE11MaxTokenLength;

});


parcelRegister("1HCMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ea17df757c74c46$export$2e2bcd8739ae039);
// A list of all keys of permissions that this transformer supports.
const $0ea17df757c74c46$export$9fc40cb6f3529ef = ()=>[
        'ADMINISTER_PROJECTS',
        'ASSIGN_ISSUES',
        'EDIT_ISSUES',
        'SCHEDULE_ISSUES',
        'ADD_COMMENTS',
        'DELETE_ALL_COMMENTS',
        'DELETE_OWN_COMMENTS',
        'EDIT_ALL_COMMENTS',
        'EDIT_OWN_COMMENTS',
        'CREATE_ISSUES',
        'DELETE_ISSUES',
        'MOVE_ISSUES',
        'MODIFY_REPORTER',
        'CREATE_ATTACHMENTS',
        'DELETE_ALL_ATTACHMENTS',
        'DELETE_OWN_ATTACHMENTS',
        'WORK_ON_ISSUES',
        'ASSIGNABLE_USER',
        'LINK_ISSUES',
        'VIEW_VOTERS_AND_WATCHERS',
        'MANAGE_WATCHERS',
        'EDIT_ALL_WORKLOGS',
        'EDIT_OWN_WORKLOGS',
        'DELETE_ALL_WORKLOGS',
        'DELETE_OWN_WORKLOGS',
        'VIEW_DEV_TOOLS',
        'SERVICEDESK_AGENT',
        'RESOLVE_ISSUES',
        'CLONE_ISSUE',
        'ARCHIVE_ISSUES',
        'UNARCHIVE_ISSUES'
    ];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0ea17df757c74c46$export$2e2bcd8739ae039 = ()=>`

    permissions(issueKey:$issueKey, keys:["${$0ea17df757c74c46$export$9fc40cb6f3529ef().join('","')}"]) {
        key
        havePermission
    }
`;

});

parcelRegister("8JI9I", function(module, exports) {

$parcel$export(module.exports, "default", () => $2232e63ddd04bbb1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $2232e63ddd04bbb1$export$2e2bcd8739ae039 = ()=>`
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;

});

parcelRegister("kNriQ", function(module, exports) {

$parcel$export(module.exports, "getRemoteLinksQuery", () => $e19ca26272d1dd4d$export$6bbc6b72b0b57f25);

var $4R6GH = parcelRequire("4R6GH");
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesPreviewFragment = ()=>`
    id
    issueId
    globalId
    href
    applicationType
    applicationName
    relationship
    title
`;
const $e19ca26272d1dd4d$var$getAssociatedIssueFragment = ()=>`
    issueId
    issueKey {
        stringValue
    }
    summary {
        textValue
    }
    status {
        statusCategoryId
        name
        statusId
    }
    priority {
        iconUrl
        name
    }
    issueType {
        iconUrl
        name
    }
    assignee {
        userValue
        {
            displayName
            avatarUrl
        }
    }
   isResolved
`;
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesDetailsFragment = ()=>`
    ... on AssociatedIssueWrapper {
        associatedIssue {
            ${$e19ca26272d1dd4d$var$getAssociatedIssueFragment()}
        }
    }
    ... on FailedRemoteIssue {
        error
        repairLink { href }
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesFragment = ()=>`
    remoteLinkedIssues {
        preview {
            ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesPreviewFragment()}
        }
        details {
            ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesDetailsFragment()}
        }
    }
`;
const $e19ca26272d1dd4d$var$getWebLinksFragment = ()=>`
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinksQueryNew = ()=>`
    remoteLinks {
        isLinkingEnabled
        confluencePages {
            linkedPages {
				pageCount
				pages {
					... on ConfluencePage {
						id
						globalId
						href
						title
						type
					}
					... on FailedRemoteLink {
						id
						error
						link {
							id
							globalId
							href
						}
						repairLink { href }
					}
				}
            }
        }
        ${$e19ca26272d1dd4d$var$getWebLinksFragment()}
        ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesFragment()}
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinksQueryOld = ()=>`
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }
`;
const $e19ca26272d1dd4d$export$6bbc6b72b0b57f25 = ()=>(0, $4R6GH.fg)('jiv-19125-fetch-remote-links-in-interactive-query') ? $e19ca26272d1dd4d$var$getRemoteLinksQueryNew() : $e19ca26272d1dd4d$var$getRemoteLinksQueryOld();

});

parcelRegister("cRP2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $354b7c85b873ab44$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $6tI1D = parcelRequire("6tI1D");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$354b7c85b873ab44$export$2e2bcd8739ae039 = ({ startAt: startAt, orderBy: orderBy, worklogAmount: worklogAmount, url: url })=>{
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const worklogPermalinkId = url && (0, $4R6GH.fg)('jiv-19906-fix-targered-permalink-on-server') ? (0, $6tI1D.getPermalinkIdFromURL)((0, $6tI1D.WORKLOG), url) : (0, $6tI1D.getPermalinkId)((0, $6tI1D.WORKLOG));
    if (worklogPermalinkId === null || worklogPermalinkId === undefined) return '';
    const worklogParameter = `, worklogId: ${worklogPermalinkId}`;
    const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
    return `
        worklogs (startAt: ${startAt}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                created
                started
                updated
                comment
                timeSpent
                timeSpentSeconds
            }
            totalCount
            startIndex
        }
    `;
};

});


parcelRegister("9kbEN", function(module, exports) {

$parcel$export(module.exports, "isInSample", () => $b9c2013a86366ec0$export$a994c91d08ead5ff);

const $b9c2013a86366ec0$export$a994c91d08ead5ff = (sampleRate = (0, $670519621927ccc4$export$9fc1f2d681a9e609))=>Math.random() <= 1 / sampleRate;

});
/**
 * Sample rates are defined as the inverse.
 * e.g. a sample rate of 100 = 1 in 100 events are sent.
 */ const $670519621927ccc4$export$9fc1f2d681a9e609 = 100; // 1%


parcelRegister("iBOrg", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $3d6ab2890da8f9df$export$6bb76d6eba7e258c);

var $7f4tk = parcelRequire("7f4tk");

var $fqpdr = parcelRequire("fqpdr");
const $3d6ab2890da8f9df$var$makeFetchClient = (baseUrl)=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $7f4tk.default)((0, $fqpdr.getGiraUrl)(baseUrl, operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            })
    });
let $3d6ab2890da8f9df$var$client;
const $3d6ab2890da8f9df$export$6bb76d6eba7e258c = (baseUrl)=>{
    if (!$3d6ab2890da8f9df$var$client) $3d6ab2890da8f9df$var$client = $3d6ab2890da8f9df$var$makeFetchClient(baseUrl);
    return $3d6ab2890da8f9df$var$client;
};

});




parcelRegister("fjoQ1", function(module, exports) {

$parcel$export(module.exports, "browseIssueEmbedRoute", () => $1c5f13cdd9ba8bf4$export$240aeec71c480594);
const $1c5f13cdd9ba8bf4$export$240aeec71c480594 = {
    name: 'issue-embed',
    path: '/browse/:issueKey(\\w+-\\d+)/embed'
};

});

parcelRegister("lb0Dk", function(module, exports) {

$parcel$export(module.exports, "IssueViewSkeleton", () => $bf9ca492e3d15685$export$49addbcdecb6e6ff);
/* IssueViewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $iMqhh = parcelRequire("iMqhh");

var $hCy6k = parcelRequire("hCy6k");

var $gERis = parcelRequire("gERis");
const $bf9ca492e3d15685$var$fullpageStyles = null;
const $bf9ca492e3d15685$var$modalStyles = null;
const $bf9ca492e3d15685$var$customSpacingStyles = null;
const $bf9ca492e3d15685$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        $bf9ca492e3d15685$var$customSpacingStyles,
        isEmbedView !== true && isModalView !== true ? $bf9ca492e3d15685$var$fullpageStyles : null,
        isModalView === true ? $bf9ca492e3d15685$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMqhh.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gERis))),
        className: (0, $bwpsq.default)([
            "_p12f1ypn _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};

});
parcelRegister("iMqhh", function(module, exports) {

$parcel$export(module.exports, "CompactModeContext", () => $db79d17d45755de5$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $db79d17d45755de5$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $db79d17d45755de5$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $8kj45 = parcelRequire("8kj45");

var $doZTA = parcelRequire("doZTA");

var $hhMVP = parcelRequire("hhMVP");
const $db79d17d45755de5$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const { Provider: $db79d17d45755de5$var$Provider, Consumer: $db79d17d45755de5$var$Consumer } = $db79d17d45755de5$export$37eeac5cc5245b18;
const $db79d17d45755de5$export$55a90a8e865a39b5 = 700;
const $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$db79d17d45755de5$export$55a90a8e865a39b5}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $db79d17d45755de5$var$useRouteKey() {
    const [routeState] = (0, $doZTA.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $db79d17d45755de5$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $db79d17d45755de5$var$useRouteKey();
    (0, $hhMVP.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $hhMVP.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4);
        (0, $hhMVP.setCachedIsCompactValue)(defaultState, key);
    }
    const [isCompact, setIsCompact] = (0, $5uXOq.useState)(defaultState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8kj45.ContainerQueryObserver), {
        query: $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY,
        onChange: (state)=>{
            (0, $hhMVP.setCachedIsCompactValue)(state, key);
            setIsCompact(state);
        },
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$Provider, {
        value: isCompact
    }, children));
};
const $db79d17d45755de5$export$20feb77b5b617e44 = $db79d17d45755de5$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db79d17d45755de5$var$StyledWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
const $7093eea63dce9286$export$ee15e0cd1efafcb4 = false;

parcelRegister("8kj45", function(module, exports) {

$parcel$export(module.exports, "ContainerQueryObserver", () => $ed10e3c030ea0408$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $ed10e3c030ea0408$var$QueryContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
let $ed10e3c030ea0408$var$currentIdSeed = 0;
function $ed10e3c030ea0408$var$generateAttributeValue() {
    return `indicator-span-${$ed10e3c030ea0408$var$currentIdSeed++}`;
}
function $ed10e3c030ea0408$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $5uXOq.useState)(defaultState);
    const handleQueryStatusChange = (0, $5uXOq.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$QueryContext.Provider, {
        value: active
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    }), children);
}
function $ed10e3c030ea0408$export$b66a67697973e01() {
    const currentState = (0, $5uXOq.useContext)($ed10e3c030ea0408$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $ed10e3c030ea0408$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $5uXOq.useMemo)(()=>$ed10e3c030ea0408$var$generateAttributeValue(), []);
    const spanRef = (0, $5uXOq.useRef)(null);
    const containerRef = (0, $5uXOq.useRef)(null);
    const currentState = $ed10e3c030ea0408$export$b66a67697973e01();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh;
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed10e3c030ea0408$var$ContainerToBeQueried = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hhMVP", function(module, exports) {

$parcel$export(module.exports, "getCachedIsCompactValue", () => $cd61c7d28b4f2500$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $cd61c7d28b4f2500$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $cd61c7d28b4f2500$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $cd61c7d28b4f2500$var$cachedIsCompactValues = {};
let $cd61c7d28b4f2500$var$previousRouteKey;
function $cd61c7d28b4f2500$export$c47621d55d10906c(key) {
    return $cd61c7d28b4f2500$var$cachedIsCompactValues[key];
}
function $cd61c7d28b4f2500$export$568b2dd75c2027b4(isCompactValue, key) {
    $cd61c7d28b4f2500$var$cachedIsCompactValues[key] = isCompactValue;
}
function $cd61c7d28b4f2500$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $cd61c7d28b4f2500$var$previousRouteKey) {
        $cd61c7d28b4f2500$var$previousRouteKey = currentRouteKey;
        delete $cd61c7d28b4f2500$var$cachedIsCompactValues[$cd61c7d28b4f2500$var$previousRouteKey];
    }
}

});


parcelRegister("gERis", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.e425fdce.svg", import.meta.url).toString();

});


parcelRegister("lAGdd", function(module, exports) {

$parcel$export(module.exports, "aiContextPanelResource", () => $f43677b290bdf8ab$export$8f6224974184ed8d);

var $2M1hQ = parcelRequire("2M1hQ");

var $4R6GH = parcelRequire("4R6GH");


var $3RV1W = parcelRequire("3RV1W");

var $1b0RC = parcelRequire("1b0RC");

var $l9pCw = parcelRequire("l9pCw");

var $3kPby = parcelRequire("3kPby");

var $70Yef = parcelRequire("70Yef");
const $f43677b290bdf8ab$var$SUPPORTED_PRACTICES = new Set([
    (0, $3bae7046e293c392$export$a364d86306d4a6d4),
    (0, $3bae7046e293c392$export$31ffe79c2b019cf)
]);
const $f43677b290bdf8ab$export$8f6224974184ed8d = (0, $2M1hQ.createResource)({
    type: 'AI-CONTEXT-PANEL-RESOURCE-TYPE',
    getKey: ({ match: match })=>{
        const issueKey = match.params.issueKey || '';
        return `aiContextPanelResource-${issueKey}`;
    },
    getData: async (routerDataContext, resourceStoreContext)=>{
        const { skipChecks: skipChecks, issueKey: issueKey } = routerDataContext.match.params;
        let { issueId: issueId, practice: practice, projectId: projectId } = routerDataContext.match.params;
        const { cloudId: cloudId, locale: locale } = resourceStoreContext.tenantContext;
        if (!issueKey) return null;
        if (skipChecks !== '1') {
            // The suggestions panel is available only on service-desk.
            // Hence filtering them out to reduce the number of calls to AGG and features APIs
            if (!(0, $3RV1W.checkLicense)(resourceStoreContext.tenantContext, 'servicedesk') || !(0, $4R6GH.fg)('jsm_issue_view_ai_context')) return null;
            const issueDetails = await (0, $3kPby.getIssueDetails)(issueKey, cloudId);
            const isAIEnabled = issueDetails.isAIEnabled;
            issueId = issueDetails.issueId;
            projectId = issueDetails.projectId;
            practice = issueDetails.practice;
            if (!isAIEnabled || !$f43677b290bdf8ab$var$SUPPORTED_PRACTICES.has(practice)) return null;
            const featureState = await (0, $70Yef.getFeatureState)(routerDataContext, resourceStoreContext);
            const isAIContextPanelDisabled = featureState?.['jsm-ai-context']?.status === (0, $3bae7046e293c392$export$8cd212c10b4124d2);
            if (isAIContextPanelDisabled) return null;
        }
        if (!issueId) throw new Error('AI context service panel resource cannot be loaded without an issueId');
        if (practice === (0, $3bae7046e293c392$export$a364d86306d4a6d4)) return (0, $1b0RC.getServiceSuggestionData)(issueId, cloudId);
        if (practice === (0, $3bae7046e293c392$export$31ffe79c2b019cf) && (0, $4R6GH.fg)('jsm_issue_view_ai_context_ops')) {
            if (!projectId) throw new Error('AI context ops panel resource cannot be loaded without a projectId');
            return (0, $l9pCw.getIncidentSuggestionEndpoint)({
                cloudId: cloudId,
                issueId: issueId,
                projectId: projectId,
                locale: locale
            });
        }
        return null;
    },
    maxAge: 0,
    isBrowserOnly: true
});

});
const $3bae7046e293c392$export$b45a36df7873757 = 'alerts';
const $3bae7046e293c392$export$a7952c5a5c371ddd = 'oncall';
const $3bae7046e293c392$export$de0bca182bc46c7f = 'services';
const $3bae7046e293c392$export$ed849d1eb34423e5 = 'similarIssues';
const $3bae7046e293c392$export$d4a1ed8524773042 = 'sentiment-analysis';
const $3bae7046e293c392$export$46f600f4680e5fd0 = 'jsm-ai-context';
const $3bae7046e293c392$export$3d2ce10d3ca55e3c = 'automaticallySetRequestType';
const $3bae7046e293c392$export$cae2404f62c0f4d7 = 'change-management';
const $3bae7046e293c392$export$31ffe79c2b019cf = 'incident-management';
const $3bae7046e293c392$export$3a20074cc38cbf69 = 'problem-management';
const $3bae7046e293c392$export$a364d86306d4a6d4 = 'service-request';
const $3bae7046e293c392$export$71f1a79e03f525 = 'post-incident-review';
const $3bae7046e293c392$export$6860c7a26d6d6d35 = 'csm-customer-context';
const $3bae7046e293c392$export$7c5ee80fcb40e9d3 = 'developer-escalation';
const $3bae7046e293c392$export$28fc94ee6c61f632 = 'products-and-entitlements';
const $3bae7046e293c392$export$93b42272f76473c9 = 'jsm-views';
const $3bae7046e293c392$export$1eb399d8c2d53748 = 'jsm-board';
const $3bae7046e293c392$export$abbcecf25bfa1e87 = 'jsm-calendar';
const $3bae7046e293c392$export$891877b4a4d60ea2 = 'jsm-project-summary';
const $3bae7046e293c392$export$66ede2c1de447f8f = 'developer-escalation';
const $3bae7046e293c392$export$c54f3fef3b7893c1 = 'request-type-category'; // remove when cleaning request_type_table_uplift
const $3bae7046e293c392$export$1ee9c534405b9b35 = 'playbooks';
const $3bae7046e293c392$export$ac0832132e8992d7 = 'automation-discoverability';
const $3bae7046e293c392$export$fc77e86331b0e2c7 = 'jcs-customer-support-escalation';
const $3bae7046e293c392$export$e927a5d1b72f0b68 = 'ENABLED';
const $3bae7046e293c392$export$8cd212c10b4124d2 = 'DISABLED';

parcelRegister("3RV1W", function(module, exports) {

$parcel$export(module.exports, "checkLicense", () => $6334356fa938c5d8$export$fe2591be8b7e59ce);
$parcel$export(module.exports, "LicenseCheck", () => $6334356fa938c5d8$export$944be0b3bf2a6feb);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");
const $6334356fa938c5d8$var$appPermissionMapper = {
    software: 'hasSoftwareAccess',
    servicedesk: 'hasServiceDeskAccess'
};
const $6334356fa938c5d8$export$fe2591be8b7e59ce = (tenantContext, type)=>Boolean(tenantContext.appPermissions && tenantContext.appPermissions[$6334356fa938c5d8$var$appPermissionMapper[type]]);
const $6334356fa938c5d8$export$944be0b3bf2a6feb = ({ children: children, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const result = $6334356fa938c5d8$export$fe2591be8b7e59ce(tenantContext, type);
        return children({
            result: result
        });
    });

});

parcelRegister("1b0RC", function(module, exports) {

$parcel$export(module.exports, "getServiceSuggestionData", () => $ea3750099e69bfcf$export$afab700af9f021de);

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $9pxAu = parcelRequire("9pxAu");

var $jgbuq = parcelRequire("jgbuq");
const $ea3750099e69bfcf$export$d8192485ee52671b = (issueId)=>`/gateway/api/firebolt/1/context-panel/${issueId}`;
const $ea3750099e69bfcf$export$afab700af9f021de = (issueId, cloudId)=>{
    if ((0, $4R6GH.fg)('context-panel-graphql-migration')) return (0, $jgbuq.getContextPanelSuggestions)(cloudId, issueId);
    const url = $ea3750099e69bfcf$export$d8192485ee52671b(issueId);
    return (0, $eusud.performGetRequest)(url).then((0, $9pxAu.transformData));
};

});
parcelRegister("9pxAu", function(module, exports) {

$parcel$export(module.exports, "transformContent", () => $2284df78f056e7a3$export$b7cb80c25ebba28e);
$parcel$export(module.exports, "parseAdf", () => $2284df78f056e7a3$export$5659c60045974de9);
$parcel$export(module.exports, "transformData", () => $2284df78f056e7a3$export$3ceb62baab058c6b);
const $2284df78f056e7a3$export$b7cb80c25ebba28e = (content)=>{
    return {
        title: $2284df78f056e7a3$export$5659c60045974de9(content.title),
        description: $2284df78f056e7a3$export$5659c60045974de9(content.description)
    };
};
const $2284df78f056e7a3$export$3ceb62baab058c6b = (data)=>({
        type: 'ServicePanelSuggestions',
        summary: $2284df78f056e7a3$export$5659c60045974de9(data.summary),
        reporterDetails: $2284df78f056e7a3$export$5659c60045974de9(data.reporterDetails),
        nextSteps: $2284df78f056e7a3$export$5659c60045974de9(data.nextSteps),
        suggestedEscalation: $2284df78f056e7a3$export$5659c60045974de9(data.suggestedEscalation),
        suggestedActions: data.suggestedActions ? data.suggestedActions.map((action)=>{
            switch(action.type){
                case 'priority':
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $2284df78f056e7a3$export$b7cb80c25ebba28e(action.content)
                    };
                case 'assignee':
                default:
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $2284df78f056e7a3$export$b7cb80c25ebba28e(action.content)
                    };
            }
        }) : []
    });
const $2284df78f056e7a3$export$5659c60045974de9 = (adfString)=>{
    if (!adfString) return null;
    try {
        return JSON.parse(adfString);
    } catch (_error) {
        return null;
    }
};

});

parcelRegister("jgbuq", function(module, exports) {

$parcel$export(module.exports, "getContextPanelSuggestions", () => $614a29b5470e1123$export$715f8fbc08922943);

var $jBcqv = parcelRequire("jBcqv");

var $8Uumt = parcelRequire("8Uumt");

var $5yJb9 = parcelRequire("5yJb9");

var $1u51R = parcelRequire("1u51R");

var $8dJMO = parcelRequire("8dJMO");
const $614a29b5470e1123$var$OPERATION_NAME = 'graphqlContextPanelQuery';
const $614a29b5470e1123$var$contextPanelQuery = (0, $jBcqv.default);
const $614a29b5470e1123$export$715f8fbc08922943 = async (cloudId, issueId)=>{
    (0, $1u51R.startCapturingTraceIds)($614a29b5470e1123$var$OPERATION_NAME);
    const graphQLResponse = await (0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), $614a29b5470e1123$var$contextPanelQuery, {
        cloudId: cloudId,
        issueId: issueId
    }).toPromise().then((data)=>{
        const traceIds = (0, $1u51R.getTraceIds)($614a29b5470e1123$var$OPERATION_NAME);
        return (0, $8dJMO.handleGraphQLresponse)(data, traceIds);
    }).catch((error)=>{
        const traceIds = (0, $1u51R.getTraceIds)($614a29b5470e1123$var$OPERATION_NAME);
        return (0, $8dJMO.handleGraphQLError)(error, traceIds);
    }).finally(()=>{
        (0, $1u51R.stopCapturingTraceIds)($614a29b5470e1123$var$OPERATION_NAME);
    });
    return graphQLResponse;
};

});
parcelRegister("jBcqv", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d8b2900debf159$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f0514ae71f1cf87f13cf8b0cfb91670>>
 * @relayHash 09eec7021c360a9e38eb37c79037a670
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 77775bf11db6efc1fca1104f7ef4a5ee6a7b9bb9595edbe6f9140d71e16dfcdb
const $86d8b2900debf159$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "issueId",
            "variableName": "issueId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "summary"
            },
            {
                "kind": "ScalarField",
                "name": "nextSteps"
            },
            {
                "kind": "ScalarField",
                "name": "reporterDetails"
            },
            {
                "kind": "ScalarField",
                "name": "suggestedEscalation"
            },
            {
                "concreteType": "AgentAISuggestAction",
                "kind": "LinkedField",
                "name": "suggestedActions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "concreteType": "AgentAISuggestedActionContent",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "title"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "description"
                            }
                        ]
                    },
                    {
                        "concreteType": "AgentAISuggestedActionContext",
                        "kind": "LinkedField",
                        "name": "context",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "fieldId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "suggestion"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "AgentAIContextPanelResponse"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlContextPanelQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentAI_contextPanel",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlContextPanelQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentAI_contextPanel",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "77775bf11db6efc1fca1104f7ef4a5ee6a7b9bb9595edbe6f9140d71e16dfcdb",
            "metadata": {},
            "name": "graphqlContextPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$86d8b2900debf159$var$node.hash = "a36eec22cb8eb04047a693d0800f10c6";
var $86d8b2900debf159$export$2e2bcd8739ae039 = $86d8b2900debf159$var$node;

});

parcelRegister("8dJMO", function(module, exports) {

$parcel$export(module.exports, "handleGraphQLresponse", () => $6716e474dac9243a$export$f09fdc2e4ab145a5);
$parcel$export(module.exports, "handleGraphQLError", () => $6716e474dac9243a$export$3af48ada790caea5);
/* eslint-disable jira/import-whitelist */ 
var $dO0aE = parcelRequire("dO0aE");

var $9pxAu = parcelRequire("9pxAu");
const $6716e474dac9243a$export$716425a07890b235 = (graphQLResponse, traceIds)=>{
    const data = graphQLResponse?.agentAI_contextPanel?.__typename === 'AgentAIContextPanelResponse' ? graphQLResponse?.agentAI_contextPanel : null;
    return {
        type: 'ServicePanelSuggestions',
        traceIds: traceIds,
        summary: (0, $9pxAu.parseAdf)(data?.summary),
        reporterDetails: (0, $9pxAu.parseAdf)(data?.reporterDetails),
        nextSteps: (0, $9pxAu.parseAdf)(data?.nextSteps),
        suggestedEscalation: (0, $9pxAu.parseAdf)(data?.suggestedEscalation),
        suggestedActions: data?.suggestedActions ? data?.suggestedActions?.map((action)=>({
                type: action.type,
                context: {
                    ...action.context,
                    suggestion: action.context?.suggestion
                },
                content: (0, $9pxAu.transformContent)(action?.content)
            })) : []
    };
};
const $6716e474dac9243a$export$f09fdc2e4ab145a5 = (graphQLResponse, traceIds)=>{
    const responseType = graphQLResponse?.agentAI_contextPanel?.__typename;
    if (responseType === 'AgentAIContextPanelResponse') return $6716e474dac9243a$export$716425a07890b235(graphQLResponse, traceIds);
    if (responseType === 'QueryError') {
        const errorMessage = graphQLResponse?.agentAI_contextPanel?.message ?? 'Unknown error';
        const errorStatus = graphQLResponse?.agentAI_contextPanel?.extensions?.[0]?.statusCode ?? 500;
        throw new (0, $dO0aE.FetchError)(errorStatus, `Error processing graphQL query: ${errorMessage}`, traceIds?.[0]);
    }
    throw new (0, $dO0aE.FetchError)(500, 'Failed to fetch data from AGG', traceIds?.[0]);
};
const $6716e474dac9243a$export$3af48ada790caea5 = (error, traceIds)=>{
    throw new (0, $dO0aE.FetchError)(500, `Failed to fetch data from AGG : ${error?.message}`, traceIds?.[0]);
};

});



parcelRegister("l9pCw", function(module, exports) {

$parcel$export(module.exports, "getIncidentSuggestionEndpoint", () => $b39b696aeaf00873$export$32b63803a24bceaa);

var $7f4tk = parcelRequire("7f4tk");

var $1p8cH = parcelRequire("1p8cH");
const $b39b696aeaf00873$export$db19de3f154d9918 = ({ cloudId: cloudId, issueId: issueId, projectId: projectId, locale: locale })=>`/gateway/api/jsm/aiops/cloudId/${cloudId}/api/v1/incident-suggestion/${issueId}?projectId=${projectId}&locale=${locale}
`;
const $b39b696aeaf00873$export$32b63803a24bceaa = (reqParams)=>{
    const url = $b39b696aeaf00873$export$db19de3f154d9918(reqParams);
    return (0, $7f4tk.default)(url, {
        method: 'GET'
    }).then((0, $1p8cH.transformResponse));
};

});
parcelRegister("1p8cH", function(module, exports) {

$parcel$export(module.exports, "transformResponse", () => $e2c7d231fb0d2d58$export$3361e9be8093ddcc);
// Resource doesn't allow imports of getEmptyADF();
const $e2c7d231fb0d2d58$var$EMPTY_DOCUMENT = {
    version: 1,
    type: 'doc',
    content: []
};
const $e2c7d231fb0d2d58$var$parseToADF = (adfString)=>{
    try {
        return JSON.parse(adfString);
    } catch (error) {
        return $e2c7d231fb0d2d58$var$EMPTY_DOCUMENT;
    }
};
const $e2c7d231fb0d2d58$var$transformContent = (content)=>{
    return {
        title: $e2c7d231fb0d2d58$var$parseToADF(content.title),
        description: $e2c7d231fb0d2d58$var$parseToADF(content.description)
    };
};
const $e2c7d231fb0d2d58$var$exhaustiveCheck = (_)=>null;
const $e2c7d231fb0d2d58$export$3361e9be8093ddcc = (response)=>{
    return {
        type: 'OpsPanelSuggestions',
        incidentSummary: {
            ...response.incidentSummary.content,
            description: $e2c7d231fb0d2d58$var$parseToADF(response.incidentSummary.content.description)
        },
        probableRCA: response.probableRCA?.content ? {
            ...response.probableRCA.content,
            description: $e2c7d231fb0d2d58$var$parseToADF(response.probableRCA.content.description)
        } : null,
        suggestedActions: response.suggestedActions.map((action)=>{
            switch(action.type){
                case 'SEVERITY':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: {
                                ...action.context.suggestion,
                                value: action.context.suggestion.name
                            }
                        },
                        content: $e2c7d231fb0d2d58$var$transformContent(action.content)
                    };
                case 'AFFECTED_SERVICES':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion.map((service)=>({
                                    id: service.id,
                                    name: service.name,
                                    data: service
                                }))
                        },
                        content: $e2c7d231fb0d2d58$var$transformContent(action.content)
                    };
                case 'PROBLEM_TICKET':
                case 'MAJOR_INCIDENT':
                case 'PRIORITY':
                case 'RESPONDERS':
                case 'RCA_WITH_AUTOMATION':
                    return {
                        ...action,
                        content: $e2c7d231fb0d2d58$var$transformContent(action.content)
                    };
                default:
                    return $e2c7d231fb0d2d58$var$exhaustiveCheck(action);
            }
        }).filter(Boolean)
    };
};

});


parcelRegister("3kPby", function(module, exports) {

$parcel$export(module.exports, "getIssueDetails", () => $c64e867b4dbdc4a9$export$da0733c355d205d6);

var $4ytlu = parcelRequire("4ytlu");

var $8Uumt = parcelRequire("8Uumt");

var $5yJb9 = parcelRequire("5yJb9");

var $2nKjG = parcelRequire("2nKjG");
const $c64e867b4dbdc4a9$var$ISSUE_DETAILS_AGG_METRIC = 'context-panel-issue-details-agg';
const $c64e867b4dbdc4a9$var$issueDetailsAggMetric = (0, $2nKjG.metrics).custom({
    key: $c64e867b4dbdc4a9$var$ISSUE_DETAILS_AGG_METRIC
});
const $c64e867b4dbdc4a9$export$da0733c355d205d6 = async (issueKey, cloudId)=>{
    $c64e867b4dbdc4a9$var$issueDetailsAggMetric.start();
    const issueDetails = await (0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), (0, $4ytlu.default), {
        issueKey: issueKey,
        cloudId: cloudId
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise().then((data)=>{
        $c64e867b4dbdc4a9$var$issueDetailsAggMetric.stop();
        return data;
    }).catch((e)=>{
        $c64e867b4dbdc4a9$var$issueDetailsAggMetric.cancel();
        throw e;
    });
    return {
        issueId: issueDetails?.jira?.issueByKey?.issueId ?? undefined,
        practice: issueDetails?.jira?.issueByKey?.fieldByIdOrAlias?.text ?? undefined,
        projectId: issueDetails?.jira?.issueByKey?.projectField?.project?.projectId ?? undefined,
        isAIEnabled: issueDetails?.jira?.issueByKey?.projectField?.project?.isAIEnabled ?? undefined
    };
};

});
parcelRegister("4ytlu", function(module, exports) {

$parcel$export(module.exports, "default", () => $84805cad546fc546$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5c34094f44d8d7b887c6cf2af036ca84>>
 * @relayHash c93ee393688d675e660c25a8e54da951
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a18593ff86489f314842ff3d23157f442a64e8cecdd87805e60d91cfa6983b41
const $84805cad546fc546$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v4 = [
        {
            "kind": "Literal",
            "name": "idOrAlias",
            "value": "servicedesk-practices"
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "text"
            }
        ],
        "type": "JiraSingleLineTextField"
    }, v6 = {
        "kind": "ScalarField",
        "name": "isAIEnabled"
    }, v7 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueDetailsForAIContextPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "fieldByIdOrAlias",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "storageKey": "fieldByIdOrAlias(idOrAlias:\"servicedesk-practices\")"
                                },
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueDetailsForAIContextPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "fieldByIdOrAlias",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v5 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ],
                                    "storageKey": "fieldByIdOrAlias(idOrAlias:\"servicedesk-practices\")"
                                },
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a18593ff86489f314842ff3d23157f442a64e8cecdd87805e60d91cfa6983b41",
            "metadata": {},
            "name": "issueDetailsForAIContextPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$84805cad546fc546$var$node.hash = "5a922137c0bc9db6f7918d3817034879";
var $84805cad546fc546$export$2e2bcd8739ae039 = $84805cad546fc546$var$node;

});


parcelRegister("70Yef", function(module, exports) {

$parcel$export(module.exports, "getFeatureState", () => $8817fa0932717f4c$export$c8c54cead17ad7fa);
// eslint-disable-next-line jira/import-whitelist

var $2nKjG = parcelRequire("2nKjG");

var $frQmB = parcelRequire("frQmB");
const $8817fa0932717f4c$var$FEATURE_STATE_METRIC = 'context-panel-feature-states';
const $8817fa0932717f4c$var$featureStateMetric = (0, $2nKjG.metrics).custom({
    key: $8817fa0932717f4c$var$FEATURE_STATE_METRIC
});
const $8817fa0932717f4c$export$c8c54cead17ad7fa = (routerDataContext, resourceStoreContext)=>{
    $8817fa0932717f4c$var$featureStateMetric.start();
    return (0, $frQmB.featuresResource)(routerDataContext, resourceStoreContext)?.then((data)=>{
        $8817fa0932717f4c$var$featureStateMetric.stop();
        return data;
    }).catch((e)=>{
        $8817fa0932717f4c$var$featureStateMetric.cancel();
        throw e;
    });
};

});
parcelRegister("frQmB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "transformRestData", () => $3a8e348215e4bd89$export$40da6ae06b8b332e);
$parcel$export(module.exports, "featuresResource", () => $3a8e348215e4bd89$export$16f81cc9da2c6c47);
$parcel$export(module.exports, "default", () => $3a8e348215e4bd89$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $x9xyg = parcelRequire("x9xyg");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $8PRuf = parcelRequire("8PRuf");

var $iR3GG = parcelRequire("iR3GG");

var $1nb22 = parcelRequire("1nb22");

var $9NiTW = parcelRequire("9NiTW");
const $3a8e348215e4bd89$export$40da6ae06b8b332e = (data)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    data.reduce((acc, { feature: feature, status: status, editable: editable })=>Object.assign(acc, {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [feature]: {
                status: status,
                editable: editable
            }
        }), {});
const $3a8e348215e4bd89$var$getFeatures = async (baseUrl, projectKey)=>{
    try {
        const data = await (0, $7f4tk.default)(`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/features`);
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return $3a8e348215e4bd89$export$40da6ae06b8b332e(data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jiraServicedeskPracticeFeaturesResource', error);
        (0, $jcw0u.default)({
            meta: {
                id: 'jiraServicedeskPracticeFeaturesResource',
                packageName: 'jiraSpa'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $3a8e348215e4bd89$export$16f81cc9da2c6c47 = ({ match: match, query: query }, { tenantContext: tenantContext })=>{
    const { params: params } = match;
    if (!(0, $9NiTW.checkAuthentication)(tenantContext)) throw (0, $iR3GG.createResourceError)({
        component: 'spa.view.routes.servicedesk.features.getData',
        message: 'Current user is not authenticated',
        name: 'AuthenticationError',
        skipSentry: true
    });
    // projectKey from url path or issueKey
    const projectKey = (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(params, 'issueKey', '')?.split('-')[0];
    if (projectKey == null) return null;
    return $3a8e348215e4bd89$var$getFeatures(tenantContext.baseUrl, projectKey);
};
var $3a8e348215e4bd89$export$2e2bcd8739ae039 = $3a8e348215e4bd89$export$16f81cc9da2c6c47;

});



parcelRegister("2dmpO", function(module, exports) {

$parcel$export(module.exports, "conditionalSmartRepliesOptInStatusResources", () => $f8439f5067be62dd$export$3cb736b345649d9b);
$parcel$export(module.exports, "conditionalForgeResource", () => $f8439f5067be62dd$export$64ecc3d62be6b4bf);
$parcel$export(module.exports, "getUnusedRouteResources", () => $f8439f5067be62dd$export$a8ad2004cacc1137);
$parcel$export(module.exports, "removeNonCritialGiraCallFromCriticalPath", () => $f8439f5067be62dd$export$b398e8f4bdfdca6);
$parcel$export(module.exports, "getUnusedEmbedRouteResources", () => $f8439f5067be62dd$export$5776b3711dd897da);
$parcel$export(module.exports, "LazyIssuePage", () => $f8439f5067be62dd$export$3e1d7c9fee0b1f1a);
$parcel$export(module.exports, "IssueComponent", () => $f8439f5067be62dd$export$c1a868ace2f38803);
$parcel$export(module.exports, "IssueEmbedComponent", () => $f8439f5067be62dd$export$ef02bcc0eb1d9ded);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $1FeCu = parcelRequire("1FeCu");

var $7DqiA = parcelRequire("7DqiA");

var $93Yeu = parcelRequire("93Yeu");

var $dAfqg = parcelRequire("dAfqg");

var $lNicp = parcelRequire("lNicp");

var $l2N2a = parcelRequire("l2N2a");

var $bmvW5 = parcelRequire("bmvW5");

var $eqN9Q = parcelRequire("eqN9Q");

var $jdjBW = parcelRequire("jdjBW");

var $1WlLE = parcelRequire("1WlLE");

var $gNStA = parcelRequire("gNStA");

var $lGGIs = parcelRequire("lGGIs");

var $5j7Th = parcelRequire("5j7Th");

var $5CPDv = parcelRequire("5CPDv");

var $b7Svb = parcelRequire("b7Svb");

var $7tQej = parcelRequire("7tQej");
var $bmKPg = parcelRequire("bmKPg");

var $lCj8l = parcelRequire("lCj8l");
const $f8439f5067be62dd$export$3cb736b345649d9b = (0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('smart-replies-system-setting'), (0, $1FeCu.smartRepliesOptInStatusResources));
const $f8439f5067be62dd$export$64ecc3d62be6b4bf = (0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('move_forge_data_fetch_to_main_issue_agg'), (0, $5CPDv.issueForgeDataResource));
const $f8439f5067be62dd$export$a8ad2004cacc1137 = ()=>(0, $4R6GH.fg)('issue_view_remove_unused_route_resources') ? [] : [
        (0, $jdjBW.issueMediaUserAuthResource),
        (0, $bmvW5.issueMediaReadPermissionResource),
        (0, $eqN9Q.issueMediaUploadPermissionResource)
    ];
const $f8439f5067be62dd$export$b398e8f4bdfdca6 = ()=>(0, $4R6GH.fg)('move_iv_noncriticalgiraquery_out_of_critical_path') ? [] : [
        (0, $lCj8l.issueGiraNonCriticalDataResource)
    ];
const $f8439f5067be62dd$export$5776b3711dd897da = ()=>(0, $4R6GH.fg)('issue_view_remove_unused_route_resources') ? // eslint-disable-next-line camelcase
    [
        (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource)
    ] : [
        ...(0, $lNicp.getBusinessProjectResources)(),
        (0, $1WlLE.queuesNavigationItems),
        (0, $jdjBW.issueMediaUserAuthResource),
        (0, $bmvW5.issueMediaReadPermissionResource),
        (0, $eqN9Q.issueMediaUploadPermissionResource)
    ];

const $f8439f5067be62dd$export$3e1d7c9fee0b1f1a = (0, $b7Svb.lazyForPaint)(()=>(0, $lGGIs.markAsBentoBundleReady)(// chunk name here MUST be kept in sync with TempLazyIssuePageWithSsrAlwaysDisabled below
    (parcelRequire("5hJCC"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
});
const $f8439f5067be62dd$export$c1a868ace2f38803 = ()=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const [issueKey] = (0, $bmKPg.usePathParam)('issueKey');
    const pageId = 'spa-issue';
    const [projectKey, issueSuffix] = issueKey !== undefined ? issueKey.split('-') : [];
    let actualIssueKey = issueKey;
    if (data?.projectKey && data.projectKey !== projectKey) actualIssueKey = `${data.projectKey}-${issueSuffix}`;
    // special handling for product discovery (=== Polaris) project issues. During the experimental phase of
    // the polaris idea view (product-specific issue view), we will redirect to a polaris-specific issue view
    // page here instead of bento.
    // this will only happen for issues of this specific project type, and only if the switchover FF is enabled
    if (!false && data?.projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT) && data?.projectKey !== undefined && actualIssueKey !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/polaris/projects/${data.projectKey}/ideas?selectedIssue=${actualIssueKey}`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f8439f5067be62dd$export$3e1d7c9fee0b1f1a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
const $f8439f5067be62dd$export$ef02bcc0eb1d9ded = ()=>{
    const [issueKey] = (0, $bmKPg.usePathParam)('issueKey');
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey || '');
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const projectId = (0, $93Yeu.useProjectId)(projectKey);
    // Special handling for product discovery (=== Polaris) project issues in embed mode.
    // We have to redirect to Polaris issue embed view instead of loading Jira issue view.
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT) && projectKey !== undefined && projectId !== undefined && issueKey !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/secure/JiraProductDiscoveryEmbedded.jspa?projectId=${projectId}&projectKey=${projectKey}&issueKey=${issueKey}`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7DqiA.EmbedModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f8439f5067be62dd$export$c1a868ace2f38803, null));
};

});
parcelRegister("1FeCu", function(module, exports) {

$parcel$export(module.exports, "smartRepliesOptInStatusResources", () => $420bb98aaad6bbf4$export$d9a3116994d66cfc);
$parcel$export(module.exports, "useSmartRepliesPreferencesResources", () => $420bb98aaad6bbf4$export$8d607fdbd07ed6ca);

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $aHuqL = parcelRequire("aHuqL");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $420bb98aaad6bbf4$export$d9a3116994d66cfc = (0, $2M1hQ.createResource)({
    type: (0, $258f696a148ea88e$export$ea895d05049da93c),
    getKey: ()=>(0, $258f696a148ea88e$export$92a8ee31fa2d5df3),
    getData: async ()=>{
        let smartRepliesOptInStatus = null;
        try {
            smartRepliesOptInStatus = await (0, $aHuqL.userPreferenceAPI).get((0, $258f696a148ea88e$export$92a8ee31fa2d5df3));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode !== 404) (0, $dJl1T.default).safeErrorWithoutCustomerData((0, $258f696a148ea88e$export$92a8ee31fa2d5df3), (0, $258f696a148ea88e$export$b8b9d90f9e5bd72b), error);
            (0, $jcw0u.default)({
                meta: {
                    id: 'smartRepliesOptInStatusResources',
                    packageName: (0, $258f696a148ea88e$export$b8b9d90f9e5bd72b),
                    teamName: 'jira-warepil'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            smartRepliesOptInStatus: smartRepliesOptInStatus
        };
    },
    maxAge: Number.MAX_VALUE
});
const $420bb98aaad6bbf4$export$8d607fdbd07ed6ca = ()=>{
    const { data: data, refresh: refresh, loading: loading } = (0, $2YP9W.useResource)($420bb98aaad6bbf4$export$d9a3116994d66cfc);
    return {
        isSmartRepliesPreferenceEnabled: data?.smartRepliesOptInStatus?.isEnabled ?? true,
        loading: loading,
        refreshData: refresh
    };
};

});
const $258f696a148ea88e$export$92a8ee31fa2d5df3 = 'jira.user.smart_replies_feature.status';
const $258f696a148ea88e$export$ea895d05049da93c = 'RESOURCE_TYPE_ISSUE_SMART_REPLIES_STATUS';
const $258f696a148ea88e$export$b8b9d90f9e5bd72b = 'jiraIssueSmartRepliesPreferences';


parcelRegister("7DqiA", function(module, exports) {

$parcel$export(module.exports, "EmbedModeContext", () => $208612f70b1dde3d$export$5eb07b3c7c0b0771);
$parcel$export(module.exports, "EmbedModeProvider", () => $208612f70b1dde3d$export$9daaf42d62e1c430);

var $5uXOq = parcelRequire("5uXOq");
const $208612f70b1dde3d$export$5eb07b3c7c0b0771 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const { Provider: $208612f70b1dde3d$var$Provider } = $208612f70b1dde3d$export$5eb07b3c7c0b0771;
const $208612f70b1dde3d$var$handleEmbedLinkClick = (e)=>{
    const eventTarget = e.target;
    if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') // link
    eventTarget.target = '_blank';
};
// When issue view is loaded within an iframe, it needs to follow the proper
// element elevation principles, found here: https://hello.atlassian.net/wiki/spaces/~460573267/pages/2355983526/Jira+Dark+Mode+-+UI+Guidelines#Element-elevation-basics
// Unfortunately the current elevation is set in the global-container, which is loaded before this Provider so
// we have to override the overrider to ensure that the proper elevation is set
const $208612f70b1dde3d$var$DarkModeMonolithStyleOverride = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    #jira-frontend {
                        background: ${"var(--ds-surface-overlay, #FFFFFF)"};
                    }
                `
        }
    });
const $208612f70b1dde3d$export$9daaf42d62e1c430 = ({ children: children })=>{
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('click', $208612f70b1dde3d$var$handleEmbedLinkClick, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('click', $208612f70b1dde3d$var$handleEmbedLinkClick);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208612f70b1dde3d$var$DarkModeMonolithStyleOverride, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208612f70b1dde3d$var$Provider, {
        value: true
    }, children));
};

});

parcelRegister("93Yeu", function(module, exports) {

$parcel$export(module.exports, "useProjectKey", () => $5f0f9360597cdbd8$export$f87be37f8e8be65);
$parcel$export(module.exports, "useProjectContextActions", () => $5f0f9360597cdbd8$export$bd73624ca941f105);
$parcel$export(module.exports, "useProjectType", () => $5f0f9360597cdbd8$export$6de29d851c914935);
$parcel$export(module.exports, "useProjectContext", () => $5f0f9360597cdbd8$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useApplication", () => $5f0f9360597cdbd8$export$aaf75bb403fe1fb5);
$parcel$export(module.exports, "useEdition", () => $5f0f9360597cdbd8$export$d56c02945cf5a9e5);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $5f0f9360597cdbd8$export$524ef4f6102ed540);
$parcel$export(module.exports, "useIsClassicProject", () => $5f0f9360597cdbd8$export$e2cf96f40a8867ce);
$parcel$export(module.exports, "useProjectId", () => $5f0f9360597cdbd8$export$16d1475ed6c26568);
$parcel$export(module.exports, "useProjectStatus", () => $5f0f9360597cdbd8$export$30f16f2782a4113b);
$parcel$export(module.exports, "useProjectConfiguration", () => $5f0f9360597cdbd8$export$af19ad68b52fa1a6);
$parcel$export(module.exports, "useProjectIssueTypes", () => $5f0f9360597cdbd8$export$80bef597b440cf71);

var $5uXOq = parcelRequire("5uXOq");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $g5X3G = parcelRequire("g5X3G");

var $9OXo1 = parcelRequire("9OXo1");

var $buby4 = parcelRequire("buby4");

var $1daUm = parcelRequire("1daUm");
const $5f0f9360597cdbd8$export$f87be37f8e8be65 = (issueKey)=>(0, $g5X3G.toProjectKey)(issueKey.split('-')[0]);
const $5f0f9360597cdbd8$export$bd73624ca941f105 = ()=>{
    const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, $buby4.useProjectContextActionStore)();
    const actions = (0, $5uXOq.useMemo)(()=>({
            setProjectContext: setProjectContext,
            mergeProjectProperty: mergeProjectProperty
        }), [
        setProjectContext,
        mergeProjectProperty
    ]);
    return [
        null,
        actions
    ];
};
const $5f0f9360597cdbd8$export$6de29d851c914935 = (projectKey)=>{
    const [projectType] = (0, $buby4.useProjectContextProjectTypeStore)({
        projectKey: projectKey
    });
    return projectType;
};
const $5f0f9360597cdbd8$export$27e24febf0f5c3bc = (projectKey)=>{
    const [projectStyle] = (0, $buby4.useProjectContextJiraProjectStyleStore)({
        projectKey: projectKey
    });
    return projectStyle;
};
const $5f0f9360597cdbd8$export$8f31c2503e1efa93 = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext;
};
const $5f0f9360597cdbd8$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
    const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
    if (projectType === undefined) {
        if (failSafely) return undefined;
        throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
    }
    return (0, $efvDm.getApplicationForProject)(projectType);
};
const $5f0f9360597cdbd8$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
    const { appEditions: appEditions } = (0, $9OXo1.useTenantContext)();
    const application = $5f0f9360597cdbd8$export$aaf75bb403fe1fb5(projectKey, failSafely);
    if (!application) return undefined;
    return (0, $ldyPw.getEdition)(application, appEditions);
};
const $5f0f9360597cdbd8$export$524ef4f6102ed540 = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.isSimplified || false;
};
const $5f0f9360597cdbd8$export$e2cf96f40a8867ce = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return !projectContext?.isSimplified;
};
const $5f0f9360597cdbd8$export$16d1475ed6c26568 = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectId;
};
const $5f0f9360597cdbd8$export$30f16f2782a4113b = (projectKey)=>{
    const [projectContext] = (0, $buby4.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectStatus;
};
const $5f0f9360597cdbd8$export$af19ad68b52fa1a6 = (projectKey)=>{
    const projectType = $5f0f9360597cdbd8$export$6de29d851c914935(projectKey);
    const isSimplified = $5f0f9360597cdbd8$export$524ef4f6102ed540(projectKey);
    return (0, $1daUm.getIssueConfiguration)({
        isSimplified: isSimplified,
        projectType: projectType
    });
};
const $5f0f9360597cdbd8$export$654dd2c557853fbe = (projectKey)=>{
    const [projectName] = (0, $buby4.useProjectContextProjectNameStore)({
        projectKey: projectKey
    });
    return projectName;
};
const $5f0f9360597cdbd8$export$80bef597b440cf71 = (projectKey)=>{
    const [issueTypes] = (0, $buby4.useProjectContextIssueTypesStore)({
        projectKey: projectKey
    });
    return issueTypes;
};

});
parcelRegister("buby4", function(module, exports) {

$parcel$export(module.exports, "useProjectContextActionStore", () => $42c27dedc1310bb2$export$9afb89c1fe103bbe);
$parcel$export(module.exports, "useProjectContextStore", () => $42c27dedc1310bb2$export$8b09478b33186ec);
$parcel$export(module.exports, "useProjectContextProjectTypeStore", () => $42c27dedc1310bb2$export$f2e1ed3b2b4707cb);
$parcel$export(module.exports, "useProjectContextJiraProjectStyleStore", () => $42c27dedc1310bb2$export$b291cf203d6481a4);
$parcel$export(module.exports, "useProjectContextProjectNameStore", () => $42c27dedc1310bb2$export$9469fde70658518);
$parcel$export(module.exports, "useProjectContextIssueTypesStore", () => $42c27dedc1310bb2$export$f73e9904779f6be5);

var $2vSU6 = parcelRequire("2vSU6");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $aDpiK = parcelRequire("aDpiK");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $42c27dedc1310bb2$var$initialState = {};
const $42c27dedc1310bb2$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'project-context',
    initialState: $42c27dedc1310bb2$var$initialState,
    actions: $aDpiK
});
const $42c27dedc1310bb2$export$9afb89c1fe103bbe = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: null
});
const $42c27dedc1310bb2$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
const $42c27dedc1310bb2$export$8b09478b33186ec = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getProjectContext
});
const $42c27dedc1310bb2$var$getProjectType = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectType;
};
const $42c27dedc1310bb2$var$getJiraProjectStyle = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.isSimplified ? (0, $2vSU6.TEAM_MANAGED_PROJECT) : (0, $2vSU6.COMPANY_MANAGED_PROJECT);
};
const $42c27dedc1310bb2$export$f2e1ed3b2b4707cb = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getProjectType
});
const $42c27dedc1310bb2$export$b291cf203d6481a4 = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getJiraProjectStyle
});
const $42c27dedc1310bb2$var$getProjectName = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectName;
};
const $42c27dedc1310bb2$export$9469fde70658518 = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getProjectName
});
const $42c27dedc1310bb2$var$getIssueTypes = (state, { projectKey: projectKey })=>{
    const projectContext = $42c27dedc1310bb2$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.issueTypes;
};
const $42c27dedc1310bb2$export$f73e9904779f6be5 = (0, $3sQ5x.createHook)($42c27dedc1310bb2$export$6f57813fe9f31bf9, {
    selector: $42c27dedc1310bb2$var$getIssueTypes
});

});
parcelRegister("aDpiK", function(module, exports) {

$parcel$export(module.exports, "setProjectContext", () => $ad16c28ce51d4ccf$export$d64151aab9ae5f09);
$parcel$export(module.exports, "mergeProjectProperty", () => $ad16c28ce51d4ccf$export$78f1c6052937615f);
const $ad16c28ce51d4ccf$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: projectContext
        });
    };
const $ad16c28ce51d4ccf$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentProjectContext = currentState[key];
        const newProjectContext = {
            ...currentProjectContext,
            ...projectContext
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: newProjectContext
        });
    };

});


parcelRegister("1daUm", function(module, exports) {

$parcel$export(module.exports, "getIssueConfiguration", () => $7afb7a15cd46bd62$export$902f6c5cc939598a);

var $65mz3 = parcelRequire("65mz3");

var $2vSU6 = parcelRequire("2vSU6");
const $7afb7a15cd46bd62$export$cdbd1eb3b05729e0 = 'flagActions';
const $7afb7a15cd46bd62$export$c161a774ec2e7e56 = 'cardCoverActions';
const $7afb7a15cd46bd62$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $7afb7a15cd46bd62$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $65mz3.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $65mz3.default).SOFTWARE_ISSUE,
        issueActions: [
            $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $65mz3.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $7afb7a15cd46bd62$export$cdbd1eb3b05729e0,
            $7afb7a15cd46bd62$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $65mz3.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $7afb7a15cd46bd62$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $65mz3.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $7afb7a15cd46bd62$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $65mz3.default).MOBILE_ISSUE,
        issueActions: []
    });
const $7afb7a15cd46bd62$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $65mz3.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $7afb7a15cd46bd62$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if (config.isSimplified) return $7afb7a15cd46bd62$export$aebf676dfa727a1c();
            return $7afb7a15cd46bd62$export$27e0678365e5dcff();
        case 0, $2vSU6.CORE_PROJECT:
            return $7afb7a15cd46bd62$export$381ce08838c53afa();
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $7afb7a15cd46bd62$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $7afb7a15cd46bd62$export$27e0678365e5dcff();
    }
    return $7afb7a15cd46bd62$export$27e0678365e5dcff();
};

});
parcelRegister("65mz3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7178ba5d31d0f054$export$2e2bcd8739ae039);
const $7178ba5d31d0f054$var$keys = {
    CONNECT_ISSUE: 'connect-issue',
    BITBUCKET_ISSUE: 'bitbucket-issue',
    CORE_ISSUE: 'core-issue',
    MOBILE_ISSUE: 'mobile-issue',
    SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
    SOFTWARE_ISSUE: 'software-issue',
    STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
    SERVICE_DESK: 'service-desk',
    EMPTY_APPLICATION_KEY: ''
};
var $7178ba5d31d0f054$export$2e2bcd8739ae039 = $7178ba5d31d0f054$var$keys;

});



parcelRegister("bmvW5", function(module, exports) {

$parcel$export(module.exports, "issueMediaReadPermissionResource", () => $2368cab4ab12a1eb$export$3b5744f70b49a5c4);

var $2M1hQ = parcelRequire("2M1hQ");

var $5XgeZ = parcelRequire("5XgeZ");
const $2368cab4ab12a1eb$export$3b5744f70b49a5c4 = (0, $2M1hQ.createResource)((0, $5XgeZ.withResourceEarlyData)({
    type: 'ISSUE_MEDIA_READ_PERM',
    getKey: ({ match: match })=>match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : '',
    getData: ()=>null,
    isBrowserOnly: true
}));

});

parcelRegister("eqN9Q", function(module, exports) {

$parcel$export(module.exports, "issueMediaUploadPermissionResource", () => $018bbab5966993b0$export$80c2a5c658bd9e1e);

var $2Yhep = parcelRequire("2Yhep");

var $2M1hQ = parcelRequire("2M1hQ");

var $5XgeZ = parcelRequire("5XgeZ");
const $018bbab5966993b0$export$80c2a5c658bd9e1e = (0, $2M1hQ.createResource)((0, $5XgeZ.withResourceEarlyData)({
    type: 'ISSUE_MEDIA_UPLOAD_PERM',
    getKey: ({ match: match })=>{
        const issueKey = (0, $2Yhep.getIssueKey)(match);
        return issueKey || '';
    },
    getData: ()=>null,
    isBrowserOnly: true
}));

});

parcelRegister("jdjBW", function(module, exports) {

$parcel$export(module.exports, "issueMediaUserAuthResource", () => $c6e148d80f21d036$export$48db4eb29e9be72c);

var $2Yhep = parcelRequire("2Yhep");

var $2M1hQ = parcelRequire("2M1hQ");

var $5XgeZ = parcelRequire("5XgeZ");
const $c6e148d80f21d036$export$48db4eb29e9be72c = (0, $2M1hQ.createResource)((0, $5XgeZ.withResourceEarlyData)({
    type: 'ISSUE_MEDIA_USER_AUTH',
    getKey: ({ match: match })=>{
        const issueKey = (0, $2Yhep.getIssueKey)(match);
        return issueKey || '';
    },
    getData: ()=>null,
    isBrowserOnly: true
}));

});

parcelRegister("5CPDv", function(module, exports) {

$parcel$export(module.exports, "issueForgeDataResource", () => $82acf7aa3865e452$export$e28b79684fb81535);

var $4R6GH = parcelRequire("4R6GH");

var $2Yhep = parcelRequire("2Yhep");

var $2M1hQ = parcelRequire("2M1hQ");


var $gNStA = parcelRequire("gNStA");

var $jj8CY = parcelRequire("jj8CY");
const $82acf7aa3865e452$export$e28b79684fb81535 = (0, $gNStA.browserOnlyResourceWithCondition)(()=>{
    if (0, $cdb023d06c7f62fa$export$19d68f5aa485d903) // not "browser only" if FF is on
    return !(0, $4R6GH.fg)('issue-view-ssr-perf-m1');
    return true;
}, // eslint-disable-next-line @typescript-eslint/no-explicit-any
(0, $2M1hQ.createResource)({
    type: 'ISSUE_FORGE_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $2Yhep.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $jj8CY.default)(...args),
    isBrowserOnly: true
}));

});
parcelRegister("jj8CY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a39eb6eca9b1263$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $hpuF5 = parcelRequire("hpuF5");

var $iR3GG = parcelRequire("iR3GG");

var $2Yhep = parcelRequire("2Yhep");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3a39eb6eca9b1263$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
    const issueKey = (0, $2Yhep.getIssueKey)(match);
    if (!issueKey) return null;
    try {
        const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
        const data = await (0, $hpuF5.fetchIssueForgeData)(cloudId, issueKey, isAnonymous);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.issue-view.forge.getData',
            message: 'An error was thrown while prefetching issue Forge data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("hpuF5", function(module, exports) {

$parcel$export(module.exports, "fetchIssueForgeData", () => $b0a1cdd28321d25a$export$44da8345d9ceca61);

var $k2DRb = parcelRequire("k2DRb");

var $5cmSg = parcelRequire("5cmSg");

var $iVaKa = parcelRequire("iVaKa");

var $7kNct = parcelRequire("7kNct");
const $b0a1cdd28321d25a$export$7c6ea4184129ef74 = (result, type)=>result.find((extensions)=>extensions.some((extension)=>extension.type === type)) || [];
const $b0a1cdd28321d25a$export$44da8345d9ceca61 = async (cloudId, issueKey, isAnonymous)=>{
    const extensions = await (0, $iVaKa.fetchModules)({
        cloudId: cloudId,
        isAnonymous: isAnonymous,
        types: [
            (0, $k2DRb.ISSUE_ACTION_MODULE),
            (0, $k2DRb.ISSUE_GLANCE_MODULE),
            (0, $k2DRb.ISSUE_CONTEXT_MODULE),
            (0, $k2DRb.ISSUE_PANEL_MODULE),
            (0, $k2DRb.ISSUE_ACTIVITY_MODULE),
            (0, $k2DRb.CUSTOM_FIELD_MODULE),
            (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE),
            (0, $k2DRb.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
            (0, $k2DRb.UI_MODIFICATIONS_MODULE)
        ],
        context: {
            issueKey: issueKey
        },
        includeHidden: true,
        includeScopes: true,
        source: (0, $k2DRb.SOURCE_ISSUE_VIEW)
    });
    const getFilteredExtensions = (filterFn)=>({
            issueAction: extensions[0, $k2DRb.ISSUE_ACTION_MODULE].filter(filterFn),
            issueGlance: extensions[0, $k2DRb.ISSUE_GLANCE_MODULE].filter(filterFn),
            issueContext: extensions[0, $k2DRb.ISSUE_CONTEXT_MODULE].filter(filterFn),
            issuePanel: extensions[0, $k2DRb.ISSUE_PANEL_MODULE].filter(filterFn),
            issueActivity: extensions[0, $k2DRb.ISSUE_ACTIVITY_MODULE].filter(filterFn),
            customField: extensions[0, $k2DRb.CUSTOM_FIELD_MODULE].filter(filterFn),
            customFieldType: extensions[0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE].filter(filterFn),
            issueViewBackgroundScript: extensions[0, $k2DRb.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE].filter(filterFn),
            uiModifications: extensions[0, $k2DRb.UI_MODIFICATIONS_MODULE].filter(filterFn)
        });
    const mappedResult = {
        ...getFilteredExtensions((extension)=>!(0, $5cmSg.isExtensionHiddenByAppAccessRules)(extension)),
        blockedExtensions: {
            ...getFilteredExtensions((extension)=>(0, $5cmSg.isExtensionHiddenByAppAccessRules)(extension))
        }
    };
    return (0, $7kNct.dedupeContextAndGlance)(mappedResult);
};

});
parcelRegister("5cmSg", function(module, exports) {

$parcel$export(module.exports, "isExtensionVisible", () => $30771269db74e480$export$41e48b53c2cc2013);
$parcel$export(module.exports, "isExtensionHidden", () => $30771269db74e480$export$3f5b3e61d567ef3);
$parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", () => $30771269db74e480$export$5c38dfa9d1f96e61);
const $30771269db74e480$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
const $30771269db74e480$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
const $30771269db74e480$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
const $30771269db74e480$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';

});

parcelRegister("7kNct", function(module, exports) {

$parcel$export(module.exports, "dedupeContextAndGlance", () => $4e352c29f229bbb8$export$17503ba1adfac304);
const $4e352c29f229bbb8$export$17503ba1adfac304 = (forgeData)=>{
    const contextInstallationIds = new Set(forgeData.issueContext?.map(({ installationId: installationId })=>installationId));
    const newGlanceItems = forgeData.issueGlance.filter(({ installationId: installationId })=>!contextInstallationIds.has(installationId));
    return {
        ...forgeData,
        issueGlance: newGlanceItems
    };
};

});




parcelRegister("lCj8l", function(module, exports) {

$parcel$export(module.exports, "issueGiraNonCriticalDataResource", () => $74422abbcf73f635$export$2d81f7bddf10f49e);

var $2Yhep = parcelRequire("2Yhep");

var $2M1hQ = parcelRequire("2M1hQ");

var $5XgeZ = parcelRequire("5XgeZ");

var $cvOMs = parcelRequire("cvOMs");
const $74422abbcf73f635$export$2d81f7bddf10f49e = (0, $2M1hQ.createResource)((0, $5XgeZ.withResourceEarlyData)({
    type: 'ISSUE_GIRA_NON_CRITICAL_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $2Yhep.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $cvOMs.default)(...args),
    isBrowserOnly: true
}));

});
parcelRegister("cvOMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $07364a38d1410c3f$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $1O6Hj = parcelRequire("1O6Hj");

var $iR3GG = parcelRequire("iR3GG");

var $2Yhep = parcelRequire("2Yhep");

var $4R6GH = parcelRequire("4R6GH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07364a38d1410c3f$export$2e2bcd8739ae039 = async ({ match: match }, _)=>{
    const issueKey = (0, $2Yhep.getIssueKey)(match);
    if (!issueKey || (0, $4R6GH.fg)('move_iv_noncriticalgiraquery_out_of_critical_path')) return null;
    try {
        const data = await (0, $1O6Hj.fetchIssueGiraNonCriticalData)(issueKey);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.issue-view.gira-non-critical.getData',
            message: 'An error was thrown while prefetching issue gira non critical data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("1O6Hj", function(module, exports) {

$parcel$export(module.exports, "nonCriticalGiraQueryExperienceTracking", () => $6bf108f87308d37b$export$f382deefb24f95ae);
$parcel$export(module.exports, "fetchIssueGiraNonCriticalData", () => $6bf108f87308d37b$export$58a9221a6c5306db);

var $jJZqs = parcelRequire("jJZqs");

var $c6dax = parcelRequire("c6dax");

var $gXz4p = parcelRequire("gXz4p");

var $iBOrg = parcelRequire("iBOrg");
const $6bf108f87308d37b$var$nonCriticalGiraQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId, isEarlyFetch: isEarlyFetch })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: isEarlyFetch ? 'issueEarlyFetchNonCriticalGiraQuery' : 'issueNonCriticalGiraQuery',
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: `Issue View ${isEarlyFetch ? 'Early Fetch ' : ''}Non Critical Gira Query`,
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $6bf108f87308d37b$export$f382deefb24f95ae = ({ wasExperienceSuccessful: wasExperienceSuccessful, isEarlyFetch: isEarlyFetch, error: error })=>{
    (0, $gXz4p.sendExperienceAnalytics)($6bf108f87308d37b$var$nonCriticalGiraQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error instanceof (0, $jJZqs.default) && error.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $jJZqs.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {},
        isEarlyFetch: isEarlyFetch
    }));
};
const $6bf108f87308d37b$export$58a9221a6c5306db = async (issueKey)=>{
    const variables = {
        issueKey: issueKey
    };
    const payload = {
        query: (0, $c6dax.buildNonCriticalGiraQuery)(),
        variables: variables,
        operationName: (0, $c6dax.ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY)
    };
    try {
        const response = await (0, $iBOrg.getClient)('').query(payload);
        $6bf108f87308d37b$export$f382deefb24f95ae({
            wasExperienceSuccessful: true,
            isEarlyFetch: false
        });
        return response;
    } catch (error) {
        $6bf108f87308d37b$export$f382deefb24f95ae({
            wasExperienceSuccessful: false,
            isEarlyFetch: false,
            error: error instanceof (0, $jJZqs.default) ? error : undefined
        });
        throw error;
    }
};

});
parcelRegister("c6dax", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY", () => $b74efd74d6a135cc$export$857f1602ca5b9d99);
$parcel$export(module.exports, "buildNonCriticalGiraQuery", () => $b74efd74d6a135cc$export$df3c3aa9d6d3f431);
$parcel$export(module.exports, "getNonCriticalGiraQueryRequestOptions", () => $b74efd74d6a135cc$export$555194bfc9159fa3);

var $jzVvW = parcelRequire("jzVvW");
const $b74efd74d6a135cc$export$857f1602ca5b9d99 = 'issueViewNonCriticalGiraQuery';
const $b74efd74d6a135cc$export$df3c3aa9d6d3f431 = ()=>`
query ${$b74efd74d6a135cc$export$857f1602ca5b9d99}($issueKey: String!) {
    viewIssue(issueKey: $issueKey) {
        ${(0, $jzVvW.getEcosystemQuery)()}
        deletableAttachmentsCount
    }
}`;
const $b74efd74d6a135cc$export$555194bfc9159fa3 = (issueKey)=>({
        method: 'POST',
        body: JSON.stringify({
            operationName: $b74efd74d6a135cc$export$857f1602ca5b9d99,
            query: $b74efd74d6a135cc$export$df3c3aa9d6d3f431(),
            variables: {
                issueKey: issueKey
            }
        })
    });

});
parcelRegister("jzVvW", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $8b485783ca3ced28$export$edefef8c65e08bd2);
const $8b485783ca3ced28$export$edefef8c65e08bd2 = ()=>`
  ecosystem {
    operations {
      name
      url: href
      tooltip
      styleClass
    }
    backgroundScripts {
      iframe {
        addonKey
        moduleKey
        options
      }
      shouldReloadOnRefresh
    }
  }
`;

});


parcelRegister("gXz4p", function(module, exports) {

$parcel$export(module.exports, "sendExperienceAnalytics", () => $b28eb6b892a8c2f7$export$4a95ada1b8228562);

var $1UikQ = parcelRequire("1UikQ");

var $7Ws94 = parcelRequire("7Ws94");

var $hh0bW = parcelRequire("hh0bW");

var $j8DrX = parcelRequire("j8DrX");
const $b28eb6b892a8c2f7$var$isSynthetic = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true';
function $b28eb6b892a8c2f7$export$4a95ada1b8228562(experienceDescription) {
    const additionalContext = {};
    const shard = (0, $j8DrX.default)('ajs-shard');
    const region = (0, $j8DrX.default)('ajs-region');
    Object.assign(additionalContext, {
        shard: shard,
        region: region
    });
    const enabledFeatureFlags = Object.fromEntries([
        ...(0, $7Ws94.allFeatureFlagsAccessed)
    ].filter(([, value])=>value));
    Object.assign(additionalContext, {
        enabledFeatureFlags: enabledFeatureFlags
    });
    const synthetics = {
        additionalAttributes: {
            synthetic: $b28eb6b892a8c2f7$var$isSynthetic(),
            ...additionalContext
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(experienceDescription, synthetics);
    (0, $hh0bW.default)(experienceDescription);
}

});
parcelRegister("hh0bW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c8a1e19e7613048$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $fjcgS = parcelRequire("fjcgS");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");
const $6c8a1e19e7613048$var$transformApplication = (application)=>{
    switch(application){
        case 0, $efvDm.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $efvDm.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $efvDm.JIRA_CORE:
            return 'jira-core';
        case 0, $efvDm.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $efvDm.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $6c8a1e19e7613048$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $ldyPw.FREE_EDITION:
            return 'jedi';
        case 0, $ldyPw.STANDARD_EDITION:
            return 'standard';
        case 0, $ldyPw.PREMIUM_EDITION:
            return 'premium';
        case 0, $ldyPw.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $6c8a1e19e7613048$var$transformAction = (action, wasExperienceSuccesful)=>{
    if (action !== undefined) return action;
    return wasExperienceSuccesful ? 'taskSuccess' : 'taskFail';
};
const $6c8a1e19e7613048$var$createAnalyticsEvent = ({ experience: experience, wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, field: field, hasEdit: hasEdit, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: $6c8a1e19e7613048$var$transformAction(action, wasExperienceSuccesful),
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            task: experience,
            ...location ? {
                reason: location
            } : {},
            ...field ? {
                field: field
            } : {},
            ...typeof hasEdit === 'boolean' ? {
                hasEdit: hasEdit
            } : {},
            analyticsSource: analyticsSource,
            application: $6c8a1e19e7613048$var$transformApplication(application),
            edition: $6c8a1e19e7613048$var$transformEdition(edition),
            ...!false && (0, $4R6GH.fg)('chronos-add-shard-data-to-operational-metrics') ? {
                shard: (0, $j8DrX.default)('ajs-shard') || '',
                region: (0, $j8DrX.default)('ajs-region') || ''
            } : {}
        }
    });
var /**
 * @param {String} experienceDescription.experience
 * @param {Boolean} experienceDescription.wasExperienceSuccesful - Deprecated: Instead set `action` to `taskSuccess` (previously `true`), `taskFail` (previously `false`) or `taskAbort`
 * @param {Action} experienceDescription.action
 * @param {String} experienceDescription.location
 * @param {String} experienceDescription.field
 * @param {String} experienceDescription.hasEdit
 * @param {String} experienceDescription.analyticsSource
 * @param {String} experienceDescription.application
 * @param {Application} experienceDescription.edition
 * @param {ApplicationEdition} experienceDescription.additionalAttributes
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$6c8a1e19e7613048$export$2e2bcd8739ae039 = (experienceDescription)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $6c8a1e19e7613048$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};

});







parcelRegister("1B0QU", function(module, exports) {

$parcel$export(module.exports, "browseIssueRouteEntry", () => $a10da1f1a9bba803$export$cef770e7c16cfcc);

var $ffza4 = parcelRequire("ffza4");


var $e2ctp = parcelRequire("e2ctp");

var $4R6GH = parcelRequire("4R6GH");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $8ZUng = parcelRequire("8ZUng");

var $9XjL6 = parcelRequire("9XjL6");

var $3RJkv = parcelRequire("3RJkv");

var $1aAOt = parcelRequire("1aAOt");

var $dxCvy = parcelRequire("dxCvy");

var $1WlLE = parcelRequire("1WlLE");

var $7GnDe = parcelRequire("7GnDe");

var $fw7Rx = parcelRequire("fw7Rx");

var $gRzZD = parcelRequire("gRzZD");

var $lb0Dk = parcelRequire("lb0Dk");

var $lAGdd = parcelRequire("lAGdd");

var $gNStA = parcelRequire("gNStA");

var $2dmpO = parcelRequire("2dmpO");
const $a10da1f1a9bba803$export$cef770e7c16cfcc = (0, $7NszV.createEntry)((0, $fw7Rx.browseIssueRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'issue',
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-opt-out-issue-view'),
        isHydrateRootEnabled: (0, $4R6GH.fg)('jfp-magma-issue-view-full-page-hydrate-root'),
        preloadOptions: {
            earlyChunks: [
                'issue-app-early-entry'
            ]
        },
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY),
        component: (0, $2dmpO.IssueComponent),
        skeleton: (0, $lb0Dk.IssueViewSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.fullPageIssuePreloadLayout)),
        navigation: {
            sidebar: (0, $hBv66.genericProjectSidebars),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3Only),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResourceOnNav3Only),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $1aAOt.getOfferingCatalogueFeaturesResource)(),
            ...(0, $2dmpO.getUnusedRouteResources)(),
            (0, $9XjL6.issueGiraDataResource),
            ...(0, $2dmpO.removeNonCritialGiraCallFromCriticalPath)(),
            (0, $2dmpO.conditionalForgeResource),
            (0, $8ZUng.issueViewRelayResource),
            (0, $1WlLE.queuesNavigationItems),
            (0, $gRzZD.workspaceResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $2dmpO.conditionalSmartRepliesOptInStatusResources),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('rrr_for_context_panel_data'), (0, $lAGdd.aiContextPanelResource))
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2dmpO.LazyIssuePage)
        ],
        ufoName: 'issue-view',
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$ef94a84e2990361c)
        },
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-entries/src/browseIssueRouteEntry.tsx',
                whichExportToUse: 'browseIssueRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-view.json',
            fetchTimeout: (0, $4R6GH.fg)('issue-view-ssr-perf-m1') ? 2000 : undefined
        }
    }));

});
parcelRegister("1aAOt", function(module, exports) {

$parcel$export(module.exports, "getOfferingCatalogueFeaturesResource", () => $3095ecb31c5b9ef2$export$d08a9fee651d30b2);

var $2M1hQ = parcelRequire("2M1hQ");


const $3095ecb31c5b9ef2$var$getDataLoader = ()=>(parcelRequire("7iPiC"));
const $3095ecb31c5b9ef2$export$ec991c565cf31550 = (0, $2M1hQ.createResource)({
    type: (0, $2e493fb3532188a0$export$23978b67a6b2068f),
    getKey: ()=>'state',
    getDataLoader: $3095ecb31c5b9ef2$var$getDataLoader,
    maxAge: 1800000
});
const $3095ecb31c5b9ef2$export$d08a9fee651d30b2 = ()=>[];

});
const $2e493fb3532188a0$export$23978b67a6b2068f = 'RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES';

parcelRegister("7iPiC", function(module, exports) {

let $551201d1e3228ab1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $551201d1e3228ab1$var$load("fsHbN").then(()=>parcelRequire('8OVUQ'));

});


parcelRegister("fw7Rx", function(module, exports) {

$parcel$export(module.exports, "browseIssueRoute", () => $b546ef0893c1765d$export$2c9c7e50a88e588b);
const $b546ef0893c1765d$export$2c9c7e50a88e588b = {
    name: 'issue',
    path: '/browse/:issueKey(\\w+-\\d+)(.*)?',
    query: [
        'filter?!=(.*)',
        'jql?!=(.*)'
    ]
};

});


parcelRegister("6HuHg", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorBrowseIssueRedirectRouteEntry", () => $87a1c7411057f7f3$export$30f8c1a53605b10b);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $53W5y = parcelRequire("53W5y");

var $1gXMV = parcelRequire("1gXMV");


var $8irO5 = parcelRequire("8irO5");

var $96TVI = parcelRequire("96TVI");

var $3uU6P = parcelRequire("3uU6P");

var $gGOoR = parcelRequire("gGOoR");

var $b8f12 = parcelRequire("b8f12");
const $87a1c7411057f7f3$export$30f8c1a53605b10b = (0, $7NszV.createEntry)((0, $53W5y.globalIssueNavigatorBrowseIssueRedirectRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        component: (0, $gGOoR.default),
        skeleton: (0, $1gXMV.GlobalIssueNavigatorSkeleton),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $b8f12.LazyGlobalIssueNavigator)
        ],
        ufoName: 'global-issue-navigator-jfe',
        navigation: (0, $8irO5.getCommonGlobalNavigation)(),
        resources: [
            ...(0, $96TVI.getCommonGlobalResources)()
        ],
        layout: (0, $2BrOV.globalLayout)
    }));

});
parcelRegister("53W5y", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorBrowseIssueRedirectRoute", () => $2ca0ba87b3cf3506$export$34695dccebecc6bc);
const $2ca0ba87b3cf3506$export$34695dccebecc6bc = {
    name: 'global-issue-navigator-browse-issue-redirect',
    path: '/browse/:issueKey?',
    query: [
        'jql|filter'
    ]
};

});

parcelRegister("1gXMV", function(module, exports) {

$parcel$export(module.exports, "GlobalIssueNavigatorSkeleton", () => $c87e28c0f4513050$export$51681996374b2585);
/* global-app.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $3hk93 = parcelRequire("3hk93");
const $c87e28c0f4513050$var$customCssStyles = null;
const $c87e28c0f4513050$export$51681996374b2585 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3hk93))),
        className: (0, $bwpsq.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });

});
parcelRegister("3hk93", function(module, exports) {
module.exports = new URL("global-issue-navigator-skeleton.tpl.b1bf4b99.svg", import.meta.url).toString();

});


parcelRegister("8irO5", function(module, exports) {

$parcel$export(module.exports, "getCommonGlobalNavigation", () => $bc5e7fba327b7679$export$2f31f4f387017d83);

var $cSD7y = parcelRequire("cSD7y");

var $lmyls = parcelRequire("lmyls");

var $8Wi6S = parcelRequire("8Wi6S");
const $bc5e7fba327b7679$export$2f31f4f387017d83 = ()=>({
        menuId: (0, $lmyls.MENU_ID).FILTERS,
        sidebar: (0, $cSD7y.componentWithFG)('make_nav3_sidebar_lazyforpaint', (0, $8Wi6S.AsyncForPaintSidebarFiltersGlobal), (0, $8Wi6S.AsyncSidebarFiltersGlobal))
    });

});
parcelRegister("8Wi6S", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c9fa7b304f828b3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AsyncSidebarFiltersGlobal", () => $7c9fa7b304f828b3$export$1af88ebe65f50e73);
$parcel$export(module.exports, "AsyncForPaintSidebarFiltersGlobal", () => $7c9fa7b304f828b3$export$7655c90db6341aa6);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

// Legacy GIN Sidebar
const $7c9fa7b304f828b3$var$LazySidebarFiltersLegacy = (0, $b7Svb.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("a8bqI")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7c9fa7b304f828b3$var$AsyncSidebarFiltersLegacy = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazySidebarFiltersLegacy, null)));
var $7c9fa7b304f828b3$export$2e2bcd8739ae039 = $7c9fa7b304f828b3$var$AsyncSidebarFiltersLegacy;

// Global-scope NIN sidebar
const $7c9fa7b304f828b3$var$LazyAfterPaintSidebarFiltersGlobal = (0, $b7Svb.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    // using direct path instead of `index` because webpack will combine multiple chunks from same file
    return (parcelRequire("kwzAX")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle.SidebarFiltersGlobal;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
});

const $7c9fa7b304f828b3$var$LazyForPaintSidebarFiltersGlobal = (0, $b7Svb.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    // using direct path instead of `index` because webpack will combine multiple chunks from same file
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("kwzAX")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle.SidebarFiltersGlobal;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
});
const $7c9fa7b304f828b3$export$1af88ebe65f50e73 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "filters-global"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazyAfterPaintSidebarFiltersGlobal, null)));
const $7c9fa7b304f828b3$export$7655c90db6341aa6 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "filters-global"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazyForPaintSidebarFiltersGlobal, null)));

});
parcelRegister("a8bqI", function(module, exports) {

let $760384795adb5a55$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $760384795adb5a55$var$load("cM9em"),
    $760384795adb5a55$var$load("fr9NE"),
    $760384795adb5a55$var$load("h2MrD"),
    $760384795adb5a55$var$load("bYT2S"),
    $760384795adb5a55$var$load("iTs3w")
]).then(()=>parcelRequire('7T8w9'));

});

parcelRegister("kwzAX", function(module, exports) {

let $ef12683b3df1ce72$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ef12683b3df1ce72$var$load("cM9em"),
    $ef12683b3df1ce72$var$load("fr9NE"),
    $ef12683b3df1ce72$var$load("h2MrD"),
    $ef12683b3df1ce72$var$load("bYT2S"),
    $ef12683b3df1ce72$var$load("2dpYI")
]).then(()=>parcelRequire('hcPI1'));

});



parcelRegister("96TVI", function(module, exports) {

$parcel$export(module.exports, "getCommonGlobalResources", () => $546bc7982ebbd30d$export$343e92405307cf8d);

var $4R6GH = parcelRequire("4R6GH");

var $96w9D = parcelRequire("96w9D");

var $8CVvd = parcelRequire("8CVvd");

var $bATyw = parcelRequire("bATyw");

var $89kiv = parcelRequire("89kiv");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $gNStA = parcelRequire("gNStA");

var $lAGdd = parcelRequire("lAGdd");
const $546bc7982ebbd30d$export$343e92405307cf8d = ()=>[
        (0, $89kiv.issueNavigatorRelayResource),
        (0, $89kiv.issueNavigatorFilterRelayResource),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('nin_request_hydrate_query_earlier'), (0, $89kiv.issueNavigatorHydrationRelayResource)),
        ...(0, $3RJkv.getNavigationResources)(),
        (0, $atU1t.navigationSidebarGlobalResource),
        (0, $bATyw.isNinGlobalScopeEnrolmentEnabledResource),
        (0, $gNStA.resourceWithCondition2)((0, $8CVvd.getWillShowNav3), (0, $96w9D.sidebarFiltersGlobalResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('rrr_for_context_panel_data'), (0, $lAGdd.aiContextPanelResource))
    ];

});
parcelRegister("96w9D", function(module, exports) {

$parcel$export(module.exports, "sidebarFiltersGlobalResource", () => $4afb52221e3a3f09$export$7e0b804085f0470d);

var $ao2h1 = parcelRequire("ao2h1");

var $gBXKh = parcelRequire("gBXKh");

var $6YG83 = parcelRequire("6YG83");
const $4afb52221e3a3f09$export$7e0b804085f0470d = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'NAVIGATION_SIDEBAR_FILTERS_GLOBAL',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $gBXKh.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("gBXKh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0f1ab872360a786$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ec2895c263a0bc866c147eac067ab3d3>>
 * @relayHash 8b92a92d7973bf2a60fc85271761fceb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0fc7dfdbeee4792faa92449e364dd4b9b51f2ed2fc3bd618160e27885c980a88
const $a0f1ab872360a786$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v5 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ],
        "type": "JiraCustomFilter"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "starredFiltersList_navigationAppsSidebarCommon"
                            },
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "systemFilters_navigationAppsSidebarFilters_SystemFiltersSection"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraFilterConnection",
                            "kind": "LinkedField",
                            "name": "favouriteFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "isFavourite",
                                    "value": false
                                }
                            ],
                            "concreteType": "JiraSystemFilterConnection",
                            "kind": "LinkedField",
                            "name": "systemFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSystemFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilter",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0fc7dfdbeee4792faa92449e364dd4b9b51f2ed2fc3bd618160e27885c980a88",
            "metadata": {},
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a0f1ab872360a786$var$node.hash = "b5467e25277d67ce676aa25dd3a16377";
var $a0f1ab872360a786$export$2e2bcd8739ae039 = $a0f1ab872360a786$var$node;

});


parcelRegister("bATyw", function(module, exports) {

$parcel$export(module.exports, "isNinGlobalScopeEnrolmentEnabledResource", () => $a818348721ae6866$export$3f6390b4131d761b);

var $2M1hQ = parcelRequire("2M1hQ");

const $a818348721ae6866$var$getDataLoader = ()=>(parcelRequire("fjGDd"));
const $a818348721ae6866$export$3f6390b4131d761b = (0, $2M1hQ.createResource)({
    type: 'NIN_GLOBAL_SCOPE_ENROLMENT_RESOURCE',
    getKey: ()=>'ninGlobalScopeEnrolment',
    getDataLoader: $a818348721ae6866$var$getDataLoader
});

});
parcelRegister("fjGDd", function(module, exports) {

let $b269b315f9daed49$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b269b315f9daed49$var$load("f9qz1").then(()=>parcelRequire('dIecw'));

});


parcelRegister("89kiv", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorRelayResource", () => $93f22f98fd07bff0$export$b4096f516fb93159);
$parcel$export(module.exports, "issueNavigatorFilterRelayResource", () => $93f22f98fd07bff0$export$44ca3a0b25f38d83);
$parcel$export(module.exports, "issueNavigatorHydrationRelayResource", () => $93f22f98fd07bff0$export$967ef0cfbd1cc946);
/* eslint-disable jira/import-whitelist */ 
var $8Uumt = parcelRequire("8Uumt");

var $gbLWS = parcelRequire("gbLWS");

var $6s1PB = parcelRequire("6s1PB");

var $9Nvh7 = parcelRequire("9Nvh7");

var $6UAdF = parcelRequire("6UAdF");

var $dXq4S = parcelRequire("dXq4S");

var $5yJb9 = parcelRequire("5yJb9");

var $kipqU = parcelRequire("kipqU");

var $ao2h1 = parcelRequire("ao2h1");

var $16Yit = parcelRequire("16Yit");

var $kvekU = parcelRequire("kvekU");

var $hTvlq = parcelRequire("hTvlq");

var $2M1hQ = parcelRequire("2M1hQ");

var $4R6GH = parcelRequire("4R6GH");

var $1TiUe = parcelRequire("1TiUe");

var $5bSAg = parcelRequire("5bSAg");

var $aBKbA = parcelRequire("aBKbA");
const $93f22f98fd07bff0$export$b4096f516fb93159 = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${(0, $5bSAg.RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY)}`,
    getKey: ()=>'issue-navigator-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, issueKey: issueKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, $aBKbA.getParams)(routerContext);
        const jqlOrFilterId = (0, $aBKbA.getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
        const maxIssuesPerPage = (0, $6UAdF.getMaxIssuesPerPage)();
        const viewConfigInput = projectKey !== undefined && projectKey !== null ? {
            viewInput: {
                namespace: (0, $6UAdF.ISSUE_SEARCH_NAMESPACE)
            }
        } : {
            staticViewInput: {
                isHierarchyEnabled: false,
                isGroupingEnabled: false,
                isHideDoneEnabled: false
            }
        };
        const staticViewInput = projectKey === undefined || projectKey === null ? {
            isHierarchyEnabled: false,
            isGroupingEnabled: false,
            isHideDoneEnabled: false
        } : undefined;
        let operationScope;
        if (projectKey !== undefined && projectKey !== null) operationScope = (0, $1TiUe.isRefactorNinToViewSchemaEnabled)() ? (0, $6UAdF.NIN_PROJECT_SCHEMA_REFACTOR_OPERATION_SCOPE) : (0, $6UAdF.NIN_PROJECT_OPERATION_SCOPE);
        else operationScope = (0, $1TiUe.isRefactorNinToViewSchemaEnabled)() ? (0, $6UAdF.NIN_GLOBAL_SCHEMA_REFACTOR_OPERATION_SCOPE) : (0, $6UAdF.NIN_GLOBAL_OPERATION_SCOPE);
        const variables = {
            cloudId: tenantContext.cloudId,
            first: issueKey == null ? maxIssuesPerPage : null,
            issueSearchInput: jqlOrFilterId,
            namespace: (0, $6UAdF.ISSUE_SEARCH_NAMESPACE),
            fieldSetsInput: (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? {
                viewInput: {
                    namespace: (0, $6UAdF.ISSUE_SEARCH_NAMESPACE),
                    filterId: Boolean(filter) && (0, $9Nvh7.isCustomFilter)(filter) ? filter : null
                }
            } : null,
            after: null,
            options: {
                issueKey: issueKey
            },
            fieldSetIds: [],
            shouldQueryFieldSetsById: false,
            filterId: Boolean(filter) && (0, $9Nvh7.isCustomFilter)(filter) ? filter : null,
            amountOfColumns: (0, $6UAdF.MAX_AMOUNT_OF_COLUMNS),
            shouldQueryHasChildren: projectKey !== null && projectKey !== undefined && (0, $6s1PB.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false),
            ...(0, $4R6GH.fg)('jsc_nin_operation_scope_fe') && {
                scope: {
                    operationScope: operationScope
                }
            },
            ...(0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isHierarchyEnabled', false) && (0, $6s1PB.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false) && {
                viewConfigInput: viewConfigInput
            },
            ...(0, $1TiUe.isRefactorNinToViewSchemaEnabled)() && {
                staticViewInput: staticViewInput
            },
            atlassianIntelligenceProductFeature: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $6UAdF.NATURAL_LANGUAGE_TO_JQL),
            projectKey: projectKey ?? '',
            shouldQueryProject: Boolean(projectKey) && ((0, $6s1PB.expValEquals)('jira_spreadsheet_component_m1', 'cohort', 'experiment') && (0, $6s1PB.expVal)('jira_list_realtime_updates', 'isEnabled', false) || (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isHierarchyEnabled', false) && (0, $6s1PB.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false)),
            groupBy: null
        };
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $hTvlq.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $93f22f98fd07bff0$export$44ca3a0b25f38d83 = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${(0, $5bSAg.RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY)}`,
    getKey: ()=>'issue-navigator-filter-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { filter: filter } = (0, $aBKbA.getParams)(routerContext);
        const includeFilter = Boolean(filter) && (0, $9Nvh7.isFilterId)(filter);
        const variables = {
            includeFilter: includeFilter,
            filterAri: includeFilter ? (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'filter',
                resourceId: filter,
                activationId: tenantContext.activationId
            }) : ''
        };
        const options = {
            fetchPolicy: includeFilter ? 'network-only' : 'store-only'
        };
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $kvekU.default), variables, options);
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $93f22f98fd07bff0$export$967ef0cfbd1cc946 = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${(0, $5bSAg.RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY)}`,
    getKey: ()=>'issue-navigator-hydration-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, $aBKbA.getParams)(routerContext);
        const jqlOrFilterId = (0, $aBKbA.getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
        const variables = {
            accountId: tenantContext.atlassianAccountId ?? '',
            cloudId: tenantContext.cloudId,
            includeUser: true,
            includeJira: true,
            isFilter: 'filterId' in jqlOrFilterId,
            jql: 'jql' in jqlOrFilterId && jqlOrFilterId.jql || '',
            filterAri: 'filterId' in jqlOrFilterId && (0, $gbLWS.JiraFilterAri).create({
                siteId: tenantContext.cloudId,
                filterId: filter,
                activationId: tenantContext.activationId
            }).toString() || '',
            viewContext: null
        };
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $16Yit.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("9Nvh7", function(module, exports) {

$parcel$export(module.exports, "isCustomFilter", () => $08e78f523b28c02b$export$31180e7f1db565e5);
$parcel$export(module.exports, "isFilterId", () => $08e78f523b28c02b$export$23be85030bd58047);
const $08e78f523b28c02b$export$31180e7f1db565e5 = (filterId)=>/^\d+$/.test(filterId);
const $08e78f523b28c02b$export$887fa95a5a5cf197 = (filterId)=>/^-\d+$/.test(filterId);
const $08e78f523b28c02b$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);

});

parcelRegister("6UAdF", function(module, exports) {

$parcel$export(module.exports, "sortDirections", () => $8e65b6d66c73d810$export$73034536b9adc928);
$parcel$export(module.exports, "FilterTypes", () => $8e65b6d66c73d810$export$ad2e3f13451a5d44);
$parcel$export(module.exports, "SearchInputTypes", () => $8e65b6d66c73d810$export$75a31bc7c097ba4b);
$parcel$export(module.exports, "views", () => $8e65b6d66c73d810$export$d0079916fe6800ac);
$parcel$export(module.exports, "defaultOrderFields", () => $8e65b6d66c73d810$export$2bd49f8f262d7cbb);
$parcel$export(module.exports, "ISSUE_SEARCH_NAMESPACE", () => $8e65b6d66c73d810$export$de2495608df10495);
$parcel$export(module.exports, "DEFAULT_ORDER_FIELD", () => $8e65b6d66c73d810$export$393cb330f31d305c);
$parcel$export(module.exports, "DEFAULT_SORT_DIRECTION", () => $8e65b6d66c73d810$export$8ea18fa9e35fdf25);
$parcel$export(module.exports, "DEFAULT_VIEW_ID", () => $8e65b6d66c73d810$export$500b5c379b5c7f2e);
$parcel$export(module.exports, "MAX_ISSUES_PER_PAGE", () => $8e65b6d66c73d810$export$f88f58d1a4b2078b);
$parcel$export(module.exports, "getMaxIssuesPerPage", () => $8e65b6d66c73d810$export$8c67ad1f64ab5a9c);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $8e65b6d66c73d810$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "PACKAGE_NAME", () => $8e65b6d66c73d810$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $8e65b6d66c73d810$export$d57b6b390e78d90f);
$parcel$export(module.exports, "EXPERIENCE_NAME", () => $8e65b6d66c73d810$export$52919046b94109dc);
$parcel$export(module.exports, "GROUPED_LIST_EXPERIENCE_ID", () => $8e65b6d66c73d810$export$88890124f795113d);
$parcel$export(module.exports, "ANALYTICS_LIST_VIEW_SOURCE_NAME", () => $8e65b6d66c73d810$export$81d9767bc5c1549e);
$parcel$export(module.exports, "ANALYTICS_DETAIL_VIEW_SOURCE_NAME", () => $8e65b6d66c73d810$export$524ae4278a57eea2);
$parcel$export(module.exports, "MAX_AMOUNT_OF_COLUMNS", () => $8e65b6d66c73d810$export$608eeb3a32afef02);
$parcel$export(module.exports, "COLUMN_TYPE_EPIC_LINK", () => $8e65b6d66c73d810$export$ce9e2d7c178a9557);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $8e65b6d66c73d810$export$1adf7afff96bbf16);
$parcel$export(module.exports, "NATURAL_LANGUAGE_TO_JQL", () => $8e65b6d66c73d810$export$55628b4c44d1522a);
$parcel$export(module.exports, "NIN_PROJECT_OPERATION_SCOPE", () => $8e65b6d66c73d810$export$fae6afe554014a45);
$parcel$export(module.exports, "NIN_GLOBAL_OPERATION_SCOPE", () => $8e65b6d66c73d810$export$39ec48f092f3ea90);
$parcel$export(module.exports, "NIN_PROJECT_SCHEMA_REFACTOR_OPERATION_SCOPE", () => $8e65b6d66c73d810$export$c61855af3c5e591e);
$parcel$export(module.exports, "NIN_GLOBAL_SCHEMA_REFACTOR_OPERATION_SCOPE", () => $8e65b6d66c73d810$export$11e11b807529f9a8);
$parcel$export(module.exports, "NIN_PROJECT_SHADOW_REQUEST_OPERATION_SCOPE", () => $8e65b6d66c73d810$export$2c213b805a8379cf);
$parcel$export(module.exports, "NIN_SIDEBAR_SCOPE", () => $8e65b6d66c73d810$export$adc96a79a4445d56);
$parcel$export(module.exports, "ISSUE_NAVIGATOR_SIDEBAR_ID", () => $8e65b6d66c73d810$export$6c35abbca3056365);
$parcel$export(module.exports, "supportedOrderFields", () => $8e65b6d66c73d810$export$3630aa1c4c69277f);
$parcel$export(module.exports, "getSupportedFieldForAlias", () => $8e65b6d66c73d810$export$eaadab3243bf458);
$parcel$export(module.exports, "isJiraIssueSearchViewMetadata", () => $8e65b6d66c73d810$export$f40fffea1f8469ac);
$parcel$export(module.exports, "isJiraSpreadsheetView", () => $8e65b6d66c73d810$export$2627fa464eafde69);

var $czfFt = parcelRequire("czfFt");
const $8e65b6d66c73d810$export$73034536b9adc928 = {
    ASC: 'ASC',
    DESC: 'DESC',
    NONE: 'NONE'
};
const $8e65b6d66c73d810$export$ad2e3f13451a5d44 = {
    ID: 'filterId',
    JQL: 'filterJql'
};
const $8e65b6d66c73d810$export$75a31bc7c097ba4b = {
    JQL: 'jql',
    FILTER: 'filter',
    FILTER_AND_JQL: 'filterAndJql'
};
const $8e65b6d66c73d810$export$d0079916fe6800ac = {
    list: 'list-view',
    detail: 'split-view'
};
const $8e65b6d66c73d810$export$2bd49f8f262d7cbb = {
    created: 'created',
    lastviewed: 'lastviewed',
    updated: 'updated'
};
const $8e65b6d66c73d810$export$de2495608df10495 = 'ISSUE_NAVIGATOR';
const $8e65b6d66c73d810$export$393cb330f31d305c = $8e65b6d66c73d810$export$2bd49f8f262d7cbb.created;
const $8e65b6d66c73d810$export$8ea18fa9e35fdf25 = $8e65b6d66c73d810$export$73034536b9adc928.DESC;
const $8e65b6d66c73d810$export$500b5c379b5c7f2e = 'list_default';
const $8e65b6d66c73d810$export$f88f58d1a4b2078b = 50;
const $8e65b6d66c73d810$export$8c67ad1f64ab5a9c = ()=>$8e65b6d66c73d810$export$f88f58d1a4b2078b;
const $8e65b6d66c73d810$export$f7109619a5e9e0d6 = 'issue-navigator-next';
const $8e65b6d66c73d810$export$b8b9d90f9e5bd72b = 'jiraIssueNavigator';
const $8e65b6d66c73d810$export$d57b6b390e78d90f = 'empanada';
const $8e65b6d66c73d810$export$52919046b94109dc = 'showPinIssueList';
const $8e65b6d66c73d810$export$88890124f795113d = 'groupedList';
const $8e65b6d66c73d810$export$81d9767bc5c1549e = 'issueNavigatorListView';
const $8e65b6d66c73d810$export$524ae4278a57eea2 = 'issueNavigatorDetailView';
const $8e65b6d66c73d810$export$af225181779390f4 = 'list_default';
const $8e65b6d66c73d810$export$608eeb3a32afef02 = (0, $czfFt.MAX_COLUMNS);
const $8e65b6d66c73d810$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $8e65b6d66c73d810$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $8e65b6d66c73d810$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $8e65b6d66c73d810$export$fae6afe554014a45 = 'NIN_PROJECT';
const $8e65b6d66c73d810$export$39ec48f092f3ea90 = 'NIN_GLOBAL';
const $8e65b6d66c73d810$export$c61855af3c5e591e = 'NIN_PROJECT_SCHEMA_REFACTOR';
const $8e65b6d66c73d810$export$11e11b807529f9a8 = 'NIN_GLOBAL_SCHEMA_REFACTOR';
const $8e65b6d66c73d810$export$2c213b805a8379cf = 'NIN_PROJECT_SHADOW_REQUEST';
const $8e65b6d66c73d810$export$adc96a79a4445d56 = 'NIN_SIDEBAR';
const $8e65b6d66c73d810$export$6c35abbca3056365 = 'IssueNavigator';
const $8e65b6d66c73d810$export$3630aa1c4c69277f = {
    created: {
        jqlTerm: 'created',
        fieldType: 'created',
        aliases: []
    },
    key: {
        jqlTerm: 'key',
        fieldType: 'issuekey',
        aliases: [
            'issuekey'
        ]
    },
    lastviewed: {
        jqlTerm: 'lastviewed',
        fieldType: 'lastviewed',
        aliases: []
    },
    priority: {
        jqlTerm: 'priority',
        fieldType: 'priority',
        aliases: []
    },
    resolved: {
        jqlTerm: 'resolved',
        fieldType: 'resolutiondate',
        aliases: []
    },
    status: {
        jqlTerm: 'status',
        fieldType: 'status',
        aliases: []
    },
    updated: {
        jqlTerm: 'updated',
        fieldType: 'updated',
        aliases: []
    },
    issuetype: {
        jqlTerm: 'issuetype',
        fieldType: 'issuetype',
        aliases: [
            'type'
        ]
    },
    assignee: {
        jqlTerm: 'assignee',
        fieldType: 'assignee',
        aliases: []
    },
    duedate: {
        jqlTerm: 'duedate',
        fieldType: 'duedate',
        aliases: []
    },
    reporter: {
        jqlTerm: 'reporter',
        fieldType: 'reporter',
        aliases: []
    },
    summary: {
        jqlTerm: 'summary',
        fieldType: 'summary',
        aliases: []
    }
};
const $8e65b6d66c73d810$export$eaadab3243bf458 = (alias)=>Object.keys($8e65b6d66c73d810$export$3630aa1c4c69277f).find((key)=>$8e65b6d66c73d810$export$3630aa1c4c69277f[key]?.aliases.includes(alias));
const $8e65b6d66c73d810$export$f40fffea1f8469ac = (data)=>[
        'JiraIssueSearchView',
        'JiraDetailedView',
        'JiraListView',
        'JiraGroupedListView'
    ].includes(data.__typename);
const $8e65b6d66c73d810$export$2627fa464eafde69 = (data)=>[
        'JiraListView',
        'JiraGroupedListView'
    ].includes(data.__typename);

});

parcelRegister("kvekU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d76682723f87707c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c0dc4a342f4ce5786fbe069292419e8>>
 * @relayHash 4722fbdc72716192181bb0830d738d17
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9373e4d70177ba3d0d672c65e67a2165b4a0d774802f56dbef66239dd52c8e5
const $d76682723f87707c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_FilterQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_filterQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_FilterQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "filterId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b9373e4d70177ba3d0d672c65e67a2165b4a0d774802f56dbef66239dd52c8e5",
            "metadata": {},
            "name": "main_FilterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d76682723f87707c$var$node.hash = "181bb07a6bafd05a2033750384a06766";
var $d76682723f87707c$export$2e2bcd8739ae039 = $d76682723f87707c$var$node;

});

parcelRegister("hTvlq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9dfb30fc1873c4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<50196c991685f578bce6fb5fc45ca646>>
 * @relayHash 2f80472faddcec8a26c0c2741a78836d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f87fa800b29fa878cf2b142851399608e47956648c0f73b4af48d1590f8e974

var $bqIzm = parcelRequire("bqIzm");

var $5oQtH = parcelRequire("5oQtH");

var $1q6lK = parcelRequire("1q6lK");

var $k3PJZ = parcelRequire("k3PJZ");

var $5qm7M = parcelRequire("5qm7M");

var $dttgK = parcelRequire("dttgK");

var $hBvdF = parcelRequire("hBvdF");
const $ff9dfb30fc1873c4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianIntelligenceProductFeature"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsContext"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "groupBy"
    }, v11 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPaginating"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v19 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v20 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryProject"
    }, v21 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v22 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v23 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v24 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v25 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v26 = [
        v25 /*: any*/ 
    ], v27 = [
        v25 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v28 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v29 = {
        "kind": "ClientExtension",
        "selections": [
            v28 /*: any*/ 
        ]
    }, v30 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "feature",
                    "variableName": "atlassianIntelligenceProductFeature"
                }
            ],
            "kind": "ObjectValue",
            "name": "atlassianIntelligenceProductFeatureInput"
        },
        v25 /*: any*/ 
    ], v31 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v32 = {
        "kind": "ScalarField",
        "name": "key"
    }, v33 = {
        "kind": "ScalarField",
        "name": "id"
    }, v34 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v35 = {
        "kind": "Variable",
        "name": "before",
        "variableName": "before"
    }, v36 = {
        "kind": "Variable",
        "name": "fieldSetsInput",
        "variableName": "fieldSetsInput"
    }, v37 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v38 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v39 = {
        "kind": "Variable",
        "name": "last",
        "variableName": "last"
    }, v40 = {
        "kind": "Variable",
        "name": "options",
        "variableName": "options"
    }, v41 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v42 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v43 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v44 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v45 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v44 /*: any*/ ,
            v33 /*: any*/ 
        ]
    }, v46 = {
        "kind": "InlineFragment",
        "selections": [
            v43 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v45 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v47 = {
        "args": [
            {
                "kind": "Literal",
                "name": "ids",
                "value": [
                    "status"
                ]
            }
        ],
        "concreteType": "JiraIssueFieldConnection",
        "kind": "LinkedField",
        "name": "fieldsById",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v31 /*: any*/ ,
                            v46 /*: any*/ ,
                            v33 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "fieldsById(ids:[\"status\"])"
    }, v48 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v49 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v48 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            },
            v33 /*: any*/ 
        ]
    }, v50 = {
        "kind": "ClientExtension",
        "selections": [
            v28 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isHighlightedIssueRow"
            }
        ]
    }, v51 = {
        "kind": "Variable",
        "name": "filterId",
        "variableName": "filterId"
    }, v52 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v53 = {
        "kind": "Variable",
        "name": "namespace",
        "variableName": "namespace"
    }, v54 = {
        "kind": "Variable",
        "name": "viewId",
        "variableName": "viewId"
    }, v55 = [
        {
            "kind": "Variable",
            "name": "context",
            "variableName": "fieldSetsContext"
        },
        v51 /*: any*/ ,
        v52 /*: any*/ ,
        v53 /*: any*/ ,
        v54 /*: any*/ 
    ], v56 = {
        "kind": "ScalarField",
        "name": "text"
    }, v57 = {
        "kind": "ScalarField",
        "name": "name"
    }, v58 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v59 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v60 = {
        "kind": "ScalarField",
        "name": "type"
    }, v61 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v62 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v63 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v57 /*: any*/ ,
                                    v33 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v64 = {
        "kind": "ScalarField",
        "name": "value"
    }, v65 = [
        v64 /*: any*/ ,
        v33 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v66 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lazyIsEditableInIssueView"
            }
        ]
    }, v67 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v65 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v65 /*: any*/ 
                    }
                ]
            },
            v66 /*: any*/ 
        ],
        "type": "JiraCascadingSelectField"
    }, v68 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v69 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v70 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v71 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "args": v68 /*: any*/ ,
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v69 /*: any*/ ,
                                    v70 /*: any*/ ,
                                    v33 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedComponentsConnection(first:1000)"
            },
            v66 /*: any*/ 
        ],
        "type": "JiraComponentsField"
    }, v72 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v73 = {
        "kind": "InlineFragment",
        "selections": [
            v72 /*: any*/ ,
            v57 /*: any*/ ,
            v66 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v74 = {
        "kind": "InlineFragment",
        "selections": [
            v56 /*: any*/ ,
            v57 /*: any*/ ,
            v66 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v75 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v76 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCommentSummary",
                "kind": "LinkedField",
                "name": "commentSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canAddComment"
                    },
                    v75 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCommentSummaryField"
    }, v77 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "uri"
            },
            v66 /*: any*/ 
        ],
        "type": "JiraUrlField"
    }, v78 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v33 /*: any*/ 
        ]
    }, v79 = [
        v78 /*: any*/ 
    ], v80 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v81 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": [
                    v75 /*: any*/ 
                ]
            },
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "fieldOption",
                "plural": false,
                "selections": [
                    v64 /*: any*/ ,
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v79 /*: any*/ 
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v79 /*: any*/ 
                    },
                    v33 /*: any*/ ,
                    v80 /*: any*/ 
                ]
            },
            v66 /*: any*/ 
        ],
        "type": "JiraSingleSelectField"
    }, v82 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v33 /*: any*/ ,
                                    v64 /*: any*/ ,
                                    v80 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v66 /*: any*/ 
        ],
        "type": "JiraMultipleSelectField"
    }, v83 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v33 /*: any*/ ,
                                    v64 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v66 /*: any*/ 
        ],
        "type": "JiraCheckboxesField"
    }, v84 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v85 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v86 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "concreteType": "JiraUserConnection",
                "kind": "LinkedField",
                "name": "selectedUsersConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraUserEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v31 /*: any*/ ,
                                    v84 /*: any*/ ,
                                    v57 /*: any*/ ,
                                    v58 /*: any*/ ,
                                    v33 /*: any*/ ,
                                    v85 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "email"
                                            }
                                        ],
                                        "type": "AtlassianAccountUser"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v66 /*: any*/ 
        ],
        "type": "JiraMultipleSelectUserPickerField"
    }, v87 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "concreteType": "JiraTeamView",
                "kind": "LinkedField",
                "name": "selectedTeam",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedName"
                    }
                ]
            },
            v66 /*: any*/ 
        ],
        "type": "JiraTeamViewField"
    }, v88 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraTimeTrackingField",
                        "kind": "LinkedField",
                        "name": "timeTrackingField",
                        "plural": false,
                        "selections": [
                            v33 /*: any*/ ,
                            {
                                "concreteType": "JiraEstimate",
                                "kind": "LinkedField",
                                "name": "originalEstimate",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "timeInSeconds"
                                    }
                                ]
                            },
                            {
                                "concreteType": "JiraTimeTrackingSettings",
                                "kind": "LinkedField",
                                "name": "timeTrackingSettings",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "workingHoursPerDay"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "workingDaysPerWeek"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "defaultFormat"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "defaultUnit"
                                    }
                                ]
                            },
                            v43 /*: any*/ ,
                            v57 /*: any*/ ,
                            v60 /*: any*/ ,
                            v66 /*: any*/ 
                        ]
                    },
                    v33 /*: any*/ 
                ]
            }
        ],
        "type": "JiraOriginalTimeEstimateField"
    }, v89 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "selectedOption",
                "plural": false,
                "selections": [
                    {
                        "alias": "label",
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    v33 /*: any*/ ,
                    v69 /*: any*/ 
                ]
            },
            v66 /*: any*/ 
        ],
        "type": "JiraRadioSelectField"
    }, v90 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "args": v68 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v33 /*: any*/ ,
                                    v57 /*: any*/ ,
                                    v69 /*: any*/ ,
                                    v70 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "versionId"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            },
            v66 /*: any*/ 
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v91 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v92 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v93 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v94 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v92 /*: any*/ ,
            v93 /*: any*/ 
        ]
    }, v95 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v68 /*: any*/ ,
                "concreteType": "JiraGoalConnection",
                "kind": "LinkedField",
                "name": "selectedGoals",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v33 /*: any*/ ,
                                    v32 /*: any*/ ,
                                    v31 /*: any*/ 
                                ]
                            },
                            v91 /*: any*/ 
                        ]
                    },
                    v94 /*: any*/ 
                ],
                "storageKey": "selectedGoals(first:1000)"
            },
            {
                "args": v68 /*: any*/ ,
                "handle": "connection",
                "key": "Goals_selectedGoals",
                "kind": "LinkedHandle",
                "name": "selectedGoals"
            }
        ],
        "type": "JiraGoalsField"
    }, v96 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "args": v68 /*: any*/ ,
                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                "kind": "LinkedField",
                "name": "confluenceRemoteIssueLinks",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v33 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "href"
                                    }
                                ]
                            }
                        ]
                    },
                    v75 /*: any*/ 
                ],
                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
            },
            v66 /*: any*/ 
        ],
        "type": "JiraConfluenceRemoteIssueLinksField"
    }, v97 = {
        "kind": "ScalarField",
        "name": "message"
    }, v98 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v97 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v99 = [
        v57 /*: any*/ ,
        v33 /*: any*/ 
    ], v100 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "componentsOld",
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v99 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraComponentsField"
    }, v101 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v102 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v57 /*: any*/ ,
            v101 /*: any*/ ,
            v66 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v103 = {
        "kind": "InlineFragment",
        "selections": [
            v72 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v104 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v105 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v32 /*: any*/ ,
                    v104 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v33 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v106 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v107 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v57 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v45 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v108 = [
        v57 /*: any*/ 
    ], v109 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v68 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v108 /*: any*/ 
                            }
                        ]
                    },
                    v75 /*: any*/ 
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v57 /*: any*/ ,
            v66 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v110 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v56 /*: any*/ ,
            v33 /*: any*/ 
        ]
    }, v111 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v78 /*: any*/ ,
            v33 /*: any*/ 
        ]
    }, v112 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v113 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v112 /*: any*/ ,
                    v57 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            },
            v33 /*: any*/ 
        ]
    }, v114 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v115 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v32 /*: any*/ ,
                    v110 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v32 /*: any*/ ,
                            v111 /*: any*/ ,
                            v113 /*: any*/ ,
                            v110 /*: any*/ ,
                            v33 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v32 /*: any*/ ,
                            v111 /*: any*/ ,
                            v113 /*: any*/ ,
                            v110 /*: any*/ ,
                            v33 /*: any*/ ,
                            v41 /*: any*/ ,
                            v114 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "summary",
                                            "issuetype",
                                            "status"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v31 /*: any*/ ,
                                                    v33 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v43 /*: any*/ ,
                                                            v56 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v43 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                    },
                                                                    v57 /*: any*/ ,
                                                                    v112 /*: any*/ ,
                                                                    v48 /*: any*/ ,
                                                                    v33 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    v46 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                            }
                        ]
                    },
                    v57 /*: any*/ ,
                    v66 /*: any*/ 
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v116 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v117 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v57 /*: any*/ ,
                    v116 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            },
            v57 /*: any*/ ,
            v66 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v118 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v57 /*: any*/ ,
                    v32 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v33 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v119 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v99 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v120 = {
        "kind": "ScalarField",
        "name": "sprintId"
    }, v121 = {
        "kind": "ScalarField",
        "name": "state"
    }, v122 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v33 /*: any*/ ,
                                    v120 /*: any*/ ,
                                    v57 /*: any*/ ,
                                    v121 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v57 /*: any*/ ,
            v66 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v123 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "args": v68 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v99 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v124 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v125 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v57 /*: any*/ ,
                    v112 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v126 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v75 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v114 /*: any*/ ,
                                            v32 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v31 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v45 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v33 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v33 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v33 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v127 = {
        "kind": "ScalarField",
        "name": "number"
    }, v128 = [
        v127 /*: any*/ 
    ], v129 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v127 /*: any*/ ,
            v57 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": v128 /*: any*/ 
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v127 /*: any*/ ,
                    v57 /*: any*/ ,
                    v66 /*: any*/ 
                ]
            },
            v66 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v130 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v60 /*: any*/ ,
                        v61 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v31 /*: any*/ ,
                                                v43 /*: any*/ ,
                                                v60 /*: any*/ ,
                                                v62 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                v63 /*: any*/ ,
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v67 /*: any*/ ,
                                                        v71 /*: any*/ ,
                                                        v73 /*: any*/ ,
                                                        v74 /*: any*/ ,
                                                        v76 /*: any*/ ,
                                                        v77 /*: any*/ ,
                                                        v81 /*: any*/ ,
                                                        v82 /*: any*/ ,
                                                        v83 /*: any*/ ,
                                                        v86 /*: any*/ ,
                                                        v87 /*: any*/ ,
                                                        v88 /*: any*/ ,
                                                        v89 /*: any*/ ,
                                                        v90 /*: any*/ ,
                                                        v95 /*: any*/ ,
                                                        v96 /*: any*/ 
                                                    ]
                                                },
                                                v98 /*: any*/ ,
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        v100 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v56 /*: any*/ 
                                                            ],
                                                            "type": "JiraSingleLineTextField"
                                                        }
                                                    ]
                                                },
                                                v102 /*: any*/ ,
                                                v103 /*: any*/ ,
                                                v105 /*: any*/ ,
                                                v106 /*: any*/ ,
                                                v74 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatusCategory",
                                                            "kind": "LinkedField",
                                                            "name": "statusCategory",
                                                            "plural": false,
                                                            "selections": [
                                                                v57 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v33 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusCategoryField"
                                                },
                                                v107 /*: any*/ ,
                                                v109 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v59 /*: any*/ ,
                                                                v57 /*: any*/ ,
                                                                v33 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraIssueTypeField"
                                                },
                                                v115 /*: any*/ ,
                                                v117 /*: any*/ ,
                                                v118 /*: any*/ ,
                                                v119 /*: any*/ ,
                                                v122 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v31 /*: any*/ ,
                                                                v84 /*: any*/ ,
                                                                v58 /*: any*/ ,
                                                                v57 /*: any*/ ,
                                                                v33 /*: any*/ ,
                                                                v85 /*: any*/ 
                                                            ]
                                                        },
                                                        v57 /*: any*/ ,
                                                        v101 /*: any*/ ,
                                                        v66 /*: any*/ 
                                                    ],
                                                    "type": "JiraSingleSelectUserPickerField"
                                                },
                                                v123 /*: any*/ ,
                                                v124 /*: any*/ ,
                                                v125 /*: any*/ ,
                                                v126 /*: any*/ ,
                                                v129 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v131 = {
        "condition": "shouldQueryFieldSetsById",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "fieldSetIds",
                        "variableName": "fieldSetIds"
                    },
                    v52 /*: any*/ 
                ],
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSetsById",
                "plural": false,
                "selections": v130 /*: any*/ 
            }
        ]
    }, v132 = {
        "kind": "InlineFragment",
        "selections": [
            v60 /*: any*/ ,
            v66 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v133 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "args": v55 /*: any*/ ,
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSetsForIssueSearchView",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v31 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v43 /*: any*/ ,
                                                                    v56 /*: any*/ ,
                                                                    v57 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleLineTextField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v43 /*: any*/ ,
                                                                    v57 /*: any*/ ,
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "user",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v31 /*: any*/ ,
                                                                            v57 /*: any*/ ,
                                                                            v58 /*: any*/ ,
                                                                            v33 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraSingleSelectUserPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v43 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v57 /*: any*/ ,
                                                                            v59 /*: any*/ ,
                                                                            v33 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraIssueTypeField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v43 /*: any*/ ,
                                                                    v45 /*: any*/ 
                                                                ],
                                                                "type": "JiraStatusCategoryField"
                                                            },
                                                            v33 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v131 /*: any*/ ,
            {
                "condition": "shouldQueryFieldSetsById",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "args": v55 /*: any*/ ,
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSetsForIssueSearchView",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldSet",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v60 /*: any*/ ,
                                            v61 /*: any*/ ,
                                            {
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fields",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v43 /*: any*/ ,
                                                                    v60 /*: any*/ ,
                                                                    v62 /*: any*/ ,
                                                                    v63 /*: any*/ ,
                                                                    {
                                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                            v67 /*: any*/ ,
                                                                            v71 /*: any*/ ,
                                                                            v73 /*: any*/ ,
                                                                            v132 /*: any*/ ,
                                                                            v76 /*: any*/ ,
                                                                            v77 /*: any*/ ,
                                                                            v81 /*: any*/ ,
                                                                            v82 /*: any*/ ,
                                                                            v83 /*: any*/ ,
                                                                            v86 /*: any*/ ,
                                                                            v87 /*: any*/ ,
                                                                            v88 /*: any*/ ,
                                                                            v89 /*: any*/ ,
                                                                            v90 /*: any*/ ,
                                                                            v95 /*: any*/ ,
                                                                            v96 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    v98 /*: any*/ ,
                                                                    {
                                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                        "kind": "Condition",
                                                                        "passingValue": false,
                                                                        "selections": [
                                                                            v100 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    v102 /*: any*/ ,
                                                                    v103 /*: any*/ ,
                                                                    v105 /*: any*/ ,
                                                                    v106 /*: any*/ ,
                                                                    v132 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraStatusCategory",
                                                                                "kind": "LinkedField",
                                                                                "name": "statusCategory",
                                                                                "plural": false,
                                                                                "selections": v108 /*: any*/ 
                                                                            }
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v107 /*: any*/ ,
                                                                    v109 /*: any*/ ,
                                                                    v115 /*: any*/ ,
                                                                    v117 /*: any*/ ,
                                                                    v118 /*: any*/ ,
                                                                    v119 /*: any*/ ,
                                                                    v122 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v60 /*: any*/ ,
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "user",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v84 /*: any*/ ,
                                                                                    v85 /*: any*/ 
                                                                                ]
                                                                            },
                                                                            v101 /*: any*/ ,
                                                                            v66 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraSingleSelectUserPickerField"
                                                                    },
                                                                    v123 /*: any*/ ,
                                                                    v124 /*: any*/ ,
                                                                    v125 /*: any*/ ,
                                                                    v126 /*: any*/ ,
                                                                    v129 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v134 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            v104 /*: any*/ ,
            {
                "concreteType": "JiraIssueTypeField",
                "kind": "LinkedField",
                "name": "issueTypeField",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "issueType",
                        "plural": false,
                        "selections": [
                            v59 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v135 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v136 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": v135 /*: any*/ ,
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSets",
                "plural": false,
                "selections": v130 /*: any*/ ,
                "storageKey": "fieldSets(first:500)"
            }
        ]
    }, v137 = {
        "kind": "ScalarField",
        "name": "totalIssueSearchResultCount"
    }, v138 = [
        {
            "kind": "Literal",
            "name": "maxCursors",
            "value": 7
        }
    ], v139 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v140 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v141 = [
        v140 /*: any*/ ,
        v91 /*: any*/ ,
        v139 /*: any*/ 
    ], v142 = {
        "concreteType": "JiraPageCursor",
        "kind": "LinkedField",
        "name": "last",
        "plural": false,
        "selections": v141 /*: any*/ 
    }, v143 = {
        "concreteType": "JiraPageCursor",
        "kind": "LinkedField",
        "name": "first",
        "plural": false,
        "selections": [
            v91 /*: any*/ ,
            v140 /*: any*/ ,
            v139 /*: any*/ 
        ]
    }, v144 = {
        "kind": "ScalarField",
        "name": "firstIssuePosition"
    }, v145 = {
        "kind": "ScalarField",
        "name": "lastIssuePosition"
    }, v146 = {
        "kind": "LinkedField",
        "name": "issueSearchError",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "messages"
                    }
                ],
                "type": "JiraInvalidJqlError"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v97 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "errorType"
                    }
                ],
                "type": "JiraInvalidSyntaxError"
            }
        ]
    }, v147 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v148 = {
        "kind": "ScalarField",
        "name": "isCappingIssueSearchResult"
    }, v149 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "args": v135 /*: any*/ ,
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldSet",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fields",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v43 /*: any*/ ,
                                                                    v31 /*: any*/ ,
                                                                    v60 /*: any*/ ,
                                                                    v33 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "fieldSets(first:500)"
                    }
                ]
            }
        ]
    }, v150 = [
        v25 /*: any*/ ,
        v51 /*: any*/ ,
        v38 /*: any*/ ,
        v53 /*: any*/ ,
        v54 /*: any*/ 
    ], v151 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueSearchViewResult"
    }, v152 = {
        "kind": "ScalarField",
        "name": "viewId"
    }, v153 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        v52 /*: any*/ 
    ], v154 = {
        "args": v153 /*: any*/ ,
        "concreteType": "JiraIssueSearchFieldSetConnection",
        "kind": "LinkedField",
        "name": "fieldSets",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueSearchFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueSearchFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v61 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v155 = {
        "kind": "ScalarField",
        "name": "hasDefaultFieldSets"
    }, v156 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v157 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v158 = {
        "kind": "ScalarField",
        "name": "isSortable"
    }, v159 = {
        "concreteType": "JiraFieldSetPreferences",
        "kind": "LinkedField",
        "name": "fieldSetPreferences",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "width"
            }
        ]
    }, v160 = {
        "concreteType": "JiraFieldType",
        "kind": "LinkedField",
        "name": "fieldType",
        "plural": false,
        "selections": [
            v156 /*: any*/ 
        ]
    }, v161 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isPlaceHolderField"
            }
        ]
    }, v162 = {
        "args": v153 /*: any*/ ,
        "concreteType": "JiraIssueSearchFieldSetConnection",
        "kind": "LinkedField",
        "name": "fieldSets",
        "plural": false,
        "selections": [
            v75 /*: any*/ ,
            {
                "concreteType": "JiraIssueSearchFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueSearchFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v60 /*: any*/ ,
                            v156 /*: any*/ ,
                            v157 /*: any*/ ,
                            v158 /*: any*/ ,
                            v159 /*: any*/ ,
                            v160 /*: any*/ ,
                            v161 /*: any*/ 
                        ]
                    }
                ]
            },
            v29 /*: any*/ 
        ]
    }, v163 = {
        "kind": "Variable",
        "name": "staticViewInput",
        "variableName": "staticViewInput"
    }, v164 = [
        v163 /*: any*/ 
    ], v165 = {
        "kind": "ScalarField",
        "name": "hideDone"
    }, v166 = {
        "args": v164 /*: any*/ ,
        "concreteType": "JiraIssueSearchViewConfigSettings",
        "kind": "LinkedField",
        "name": "viewConfigSettings",
        "plural": false,
        "selections": [
            v165 /*: any*/ 
        ]
    }, v167 = {
        "kind": "ScalarField",
        "name": "isHierarchyEnabled"
    }, v168 = {
        "kind": "ScalarField",
        "name": "canEnableHierarchy"
    }, v169 = {
        "kind": "Variable",
        "name": "groupBy",
        "variableName": "groupBy"
    }, v170 = [
        v169 /*: any*/ ,
        v38 /*: any*/ ,
        v163 /*: any*/ 
    ], v171 = {
        "concreteType": "JiraSpreadsheetGroupByConfig",
        "kind": "LinkedField",
        "name": "groupByConfig",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraField",
                "kind": "LinkedField",
                "name": "groupByField",
                "plural": false,
                "selections": [
                    v43 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            }
        ]
    }, v172 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v170 /*: any*/ ,
                "concreteType": "JiraIssueSearchViewConfigSettings",
                "kind": "LinkedField",
                "name": "viewSettings",
                "plural": false,
                "selections": [
                    v168 /*: any*/ ,
                    v171 /*: any*/ ,
                    v167 /*: any*/ ,
                    v165 /*: any*/ 
                ]
            }
        ],
        "type": "JiraSpreadsheetView",
        "abstractKey": "__isJiraSpreadsheetView"
    }, v173 = {
        "kind": "ScalarField",
        "name": "isGroupingEnabled"
    }, v174 = {
        "kind": "ScalarField",
        "name": "canEnableGrouping"
    }, v175 = [
        v167 /*: any*/ ,
        v168 /*: any*/ ,
        v173 /*: any*/ ,
        v174 /*: any*/ 
    ], v176 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v164 /*: any*/ ,
                "concreteType": "JiraIssueSearchViewConfigSettings",
                "kind": "LinkedField",
                "name": "viewConfigSettings",
                "plural": false,
                "selections": v175 /*: any*/ 
            }
        ],
        "type": "JiraIssueSearchView"
    }, v177 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v31 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ]
    }, v178 = {
        "kind": "InlineFragment",
        "selections": [
            v97 /*: any*/ ,
            v177 /*: any*/ 
        ],
        "type": "QueryError"
    }, v179 = [
        v33 /*: any*/ 
    ], v180 = {
        "kind": "InlineFragment",
        "selections": v179 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v181 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v182 = {
        "kind": "Variable",
        "name": "viewConfigInput",
        "variableName": "viewConfigInput"
    }, v183 = [
        v34 /*: any*/ ,
        v35 /*: any*/ ,
        v25 /*: any*/ ,
        v36 /*: any*/ ,
        v37 /*: any*/ ,
        v38 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ ,
        v181 /*: any*/ ,
        v182 /*: any*/ 
    ], v184 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v33 /*: any*/ ,
            v32 /*: any*/ ,
            v41 /*: any*/ ,
            v42 /*: any*/ ,
            v47 /*: any*/ ,
            v49 /*: any*/ ,
            v50 /*: any*/ ,
            v133 /*: any*/ ,
            v134 /*: any*/ 
        ]
    }, v185 = {
        "args": [
            {
                "items": [
                    {
                        "kind": "Variable",
                        "name": "filterByProjectKeys.0",
                        "variableName": "projectKey"
                    }
                ],
                "kind": "ListValue",
                "name": "filterByProjectKeys"
            }
        ],
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v186 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            v185 /*: any*/ 
        ]
    }, v187 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v92 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "startCursor"
            },
            v93 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            }
        ]
    }, v188 = {
        "concreteType": "JiraIssueNavigatorPageInfo",
        "kind": "LinkedField",
        "name": "issueNavigatorPageInfo",
        "plural": false,
        "selections": [
            v144 /*: any*/ ,
            v145 /*: any*/ 
        ]
    }, v189 = {
        "args": v138 /*: any*/ ,
        "concreteType": "JiraPageCursors",
        "kind": "LinkedField",
        "name": "pageCursors",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "around",
                "plural": true,
                "selections": v141 /*: any*/ 
            },
            v142 /*: any*/ ,
            v143 /*: any*/ 
        ],
        "storageKey": "pageCursors(maxCursors:7)"
    }, v190 = [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                v91 /*: any*/ ,
                v184 /*: any*/ ,
                v31 /*: any*/ ,
                {
                    "condition": "shouldQueryHasChildren",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        v185 /*: any*/ ,
                        {
                            "args": [
                                v24 /*: any*/ 
                            ],
                            "kind": "ScalarField",
                            "name": "canHaveChildIssues"
                        }
                    ]
                },
                v29 /*: any*/ ,
                v186 /*: any*/ ,
                v136 /*: any*/ 
            ]
        },
        v187 /*: any*/ ,
        v188 /*: any*/ ,
        v189 /*: any*/ ,
        v137 /*: any*/ ,
        v146 /*: any*/ ,
        v147 /*: any*/ ,
        v148 /*: any*/ ,
        v29 /*: any*/ ,
        v149 /*: any*/ 
    ], v191 = [
        "issueSearchInput"
    ], v192 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v170 /*: any*/ ,
                "concreteType": "JiraIssueSearchViewConfigSettings",
                "kind": "LinkedField",
                "name": "viewSettings",
                "plural": false,
                "selections": v175 /*: any*/ 
            }
        ],
        "type": "JiraSpreadsheetView",
        "abstractKey": "__isJiraSpreadsheetView"
    }, v193 = [
        v177 /*: any*/ ,
        v97 /*: any*/ 
    ], v194 = [
        v34 /*: any*/ ,
        v35 /*: any*/ ,
        v36 /*: any*/ ,
        v37 /*: any*/ ,
        v38 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ ,
        v181 /*: any*/ 
    ], v195 = [
        v34 /*: any*/ ,
        v35 /*: any*/ ,
        v37 /*: any*/ ,
        v169 /*: any*/ ,
        v38 /*: any*/ ,
        v39 /*: any*/ ,
        v181 /*: any*/ 
    ], v196 = {
        "kind": "LinkedField",
        "name": "fieldValue",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraPriority",
                        "kind": "LinkedField",
                        "name": "priority",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "priorityId"
                            },
                            v33 /*: any*/ ,
                            v116 /*: any*/ 
                        ]
                    },
                    v156 /*: any*/ 
                ],
                "type": "JiraJqlPriorityFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v31 /*: any*/ ,
                            v84 /*: any*/ ,
                            v33 /*: any*/ ,
                            v58 /*: any*/ 
                        ]
                    },
                    v156 /*: any*/ 
                ],
                "type": "JiraJqlUserFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": v179 /*: any*/ 
                    },
                    v156 /*: any*/ ,
                    v45 /*: any*/ 
                ],
                "type": "JiraJqlStatusFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": v128 /*: any*/ ,
                "type": "JiraJqlNumberFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "option",
                        "plural": false,
                        "selections": [
                            v80 /*: any*/ ,
                            v33 /*: any*/ ,
                            v78 /*: any*/ 
                        ]
                    },
                    v156 /*: any*/ 
                ],
                "type": "JiraJqlOptionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "sprint",
                        "plural": false,
                        "selections": [
                            v120 /*: any*/ ,
                            v33 /*: any*/ ,
                            v121 /*: any*/ 
                        ]
                    },
                    v156 /*: any*/ 
                ],
                "type": "JiraJqlSprintFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                            v33 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "score"
                            }
                        ]
                    },
                    v156 /*: any*/ 
                ],
                "type": "JiraJqlGoalsFieldValue"
            }
        ]
    }, v197 = {
        "kind": "ScalarField",
        "name": "fieldType"
    }, v198 = {
        "kind": "ScalarField",
        "name": "issueCount"
    }, v199 = [
        v36 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v200 = [
        v34 /*: any*/ ,
        v35 /*: any*/ ,
        v36 /*: any*/ ,
        v37 /*: any*/ ,
        v38 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ ,
        v181 /*: any*/ ,
        v182 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_IssueNavigatorQuery",
            "selections": [
                {
                    "args": [
                        v24 /*: any*/ ,
                        {
                            "items": [
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys.0",
                                    "variableName": "projectKey"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "projectKeys"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_issueQuery"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v26 /*: any*/ ,
                            "concreteType": "JiraUserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_IssueNavigator_userPreferences"
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_jira"
                        },
                        {
                            "condition": "shouldQueryProject",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v27 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "main_issueNavigator_IssueNavigatorUI_project"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v12 /*: any*/ ,
                v9 /*: any*/ ,
                v13 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v14 /*: any*/ ,
                v23 /*: any*/ ,
                v15 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v5 /*: any*/ ,
                v18 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ ,
                v16 /*: any*/ ,
                v20 /*: any*/ ,
                v11 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v17 /*: any*/ ,
                v10 /*: any*/ ,
                v19 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "main_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v26 /*: any*/ ,
                            "concreteType": "JiraUserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "jqlBuilderSearchMode"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isNaturalLanguageSpotlightTourEnabled"
                                },
                                v29 /*: any*/ 
                            ]
                        },
                        {
                            "args": v30 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "shouldShowAtlassianIntelligence"
                        },
                        {
                            "args": v30 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "atlassianIntelligenceAction",
                            "plural": false,
                            "selections": [
                                v31 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isAccessible"
                                        }
                                    ],
                                    "type": "JiraAccessAtlassianIntelligenceFeature"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "link"
                                        }
                                    ],
                                    "type": "JiraEnableAtlassianIntelligenceDeepLink"
                                }
                            ]
                        },
                        {
                            "condition": "shouldQueryProject",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v27 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        v32 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectId"
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "editIssues",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_ISSUES"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canPerform"
                                                        }
                                                    ],
                                                    "storageKey": "action(type:\"EDIT_ISSUES\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectType"
                                        },
                                        v33 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        v34 /*: any*/ ,
                                        v35 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v36 /*: any*/ ,
                                        v37 /*: any*/ ,
                                        v38 /*: any*/ ,
                                        v39 /*: any*/ ,
                                        v40 /*: any*/ 
                                    ],
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issueSearchStable",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v32 /*: any*/ ,
                                                        v33 /*: any*/ ,
                                                        v41 /*: any*/ ,
                                                        v42 /*: any*/ ,
                                                        v47 /*: any*/ ,
                                                        v49 /*: any*/ ,
                                                        v50 /*: any*/ ,
                                                        v133 /*: any*/ ,
                                                        v134 /*: any*/ 
                                                    ]
                                                },
                                                v31 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasChildren"
                                                        }
                                                    ]
                                                },
                                                v136 /*: any*/ 
                                            ]
                                        },
                                        v137 /*: any*/ ,
                                        {
                                            "args": v138 /*: any*/ ,
                                            "concreteType": "JiraPageCursors",
                                            "kind": "LinkedField",
                                            "name": "pageCursors",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "around",
                                                    "plural": true,
                                                    "selections": [
                                                        v91 /*: any*/ ,
                                                        v139 /*: any*/ ,
                                                        v140 /*: any*/ 
                                                    ]
                                                },
                                                v142 /*: any*/ ,
                                                v143 /*: any*/ 
                                            ],
                                            "storageKey": "pageCursors(maxCursors:7)"
                                        },
                                        {
                                            "concreteType": "JiraIssueNavigatorPageInfo",
                                            "kind": "LinkedField",
                                            "name": "issueNavigatorPageInfo",
                                            "plural": false,
                                            "selections": [
                                                v144 /*: any*/ ,
                                                v145 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "firstIssueKeyFromNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastIssueKeyFromPreviousPage"
                                                }
                                            ]
                                        },
                                        v146 /*: any*/ ,
                                        v147 /*: any*/ ,
                                        v148 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v149 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v150 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "issueSearchViewResult",
                                    "plural": false,
                                    "selections": [
                                        v31 /*: any*/ ,
                                        v151 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v152 /*: any*/ ,
                                                v154 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v33 /*: any*/ ,
                                                        v155 /*: any*/ ,
                                                        v162 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v166 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "args": v164 /*: any*/ ,
                                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                            "kind": "LinkedField",
                                                                            "name": "viewConfigSettings",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v167 /*: any*/ ,
                                                                                v168 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraIssueSearchView"
                                                        },
                                                        v172 /*: any*/ ,
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v176 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "args": v170 /*: any*/ ,
                                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                            "kind": "LinkedField",
                                                                            "name": "viewSettings",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v173 /*: any*/ ,
                                                                                v174 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraSpreadsheetView",
                                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraIssueSearchViewMetadata",
                                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                                }
                                            ],
                                            "type": "JiraIssueSearchView"
                                        },
                                        v178 /*: any*/ ,
                                        v180 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": v183 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issueSearch",
                                            "plural": false,
                                            "selections": v190 /*: any*/ 
                                        },
                                        {
                                            "args": v183 /*: any*/ ,
                                            "filters": v191 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "IssueNavigatorIssueSearchPagination__issueSearch",
                                            "kind": "LinkedHandle",
                                            "name": "issueSearch"
                                        },
                                        {
                                            "args": v150 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "issueSearchViewResult",
                                            "plural": false,
                                            "selections": [
                                                v31 /*: any*/ ,
                                                v151 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v152 /*: any*/ ,
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "args": v164 /*: any*/ ,
                                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                    "kind": "LinkedField",
                                                                    "name": "viewConfigSettings",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v167 /*: any*/ ,
                                                                        v165 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v33 /*: any*/ ,
                                                                v155 /*: any*/ ,
                                                                {
                                                                    "args": v153 /*: any*/ ,
                                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSets",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v75 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v61 /*: any*/ ,
                                                                                        v60 /*: any*/ ,
                                                                                        v156 /*: any*/ ,
                                                                                        v157 /*: any*/ ,
                                                                                        v158 /*: any*/ ,
                                                                                        v159 /*: any*/ ,
                                                                                        v161 /*: any*/ ,
                                                                                        v160 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v29 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v166 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "args": v164 /*: any*/ ,
                                                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "viewConfigSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v168 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraIssueSearchView"
                                                                },
                                                                v172 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isJiraIssueSearchViewMetadata"
                                                                        },
                                                                        v33 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "args": v164 /*: any*/ ,
                                                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "viewConfigSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v168 /*: any*/ ,
                                                                                        v173 /*: any*/ ,
                                                                                        v174 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraIssueSearchView"
                                                                        },
                                                                        v192 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraIssueSearchViewMetadata",
                                                            "abstractKey": "__isJiraIssueSearchViewMetadata"
                                                        }
                                                    ],
                                                    "type": "JiraIssueSearchView"
                                                },
                                                v178 /*: any*/ ,
                                                v180 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": [
                                                v25 /*: any*/ ,
                                                v38 /*: any*/ ,
                                                v53 /*: any*/ ,
                                                {
                                                    "kind": "Variable",
                                                    "name": "viewConfigInput",
                                                    "variableName": "staticViewInput"
                                                },
                                                v54 /*: any*/ 
                                            ],
                                            "kind": "LinkedField",
                                            "name": "jiraIssueSearchView",
                                            "plural": false,
                                            "selections": [
                                                v31 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraView"
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "error",
                                                    "plural": false,
                                                    "selections": v193 /*: any*/ 
                                                },
                                                v33 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v152 /*: any*/ ,
                                                        v154 /*: any*/ 
                                                    ],
                                                    "type": "JiraIssueSearchViewMetadata",
                                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v170 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v173 /*: any*/ ,
                                                                v174 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraSpreadsheetGroupByConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "groupByConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraField",
                                                                            "kind": "LinkedField",
                                                                            "name": "groupByField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v43 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v57 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "typeKey"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v167 /*: any*/ ,
                                                                v165 /*: any*/ 
                                                            ]
                                                        },
                                                        v147 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "filterId"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v155 /*: any*/ ,
                                                                v162 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v176 /*: any*/ ,
                                                                        v192 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v166 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "args": v164 /*: any*/ ,
                                                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "viewConfigSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v167 /*: any*/ ,
                                                                                        v168 /*: any*/ ,
                                                                                        v165 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraIssueSearchView"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "args": v170 /*: any*/ ,
                                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                            "kind": "LinkedField",
                                                                            "name": "viewSettings",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v165 /*: any*/ ,
                                                                                v168 /*: any*/ ,
                                                                                v171 /*: any*/ ,
                                                                                v167 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraSpreadsheetView",
                                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                                }
                                                            ],
                                                            "type": "JiraIssueSearchViewMetadata",
                                                            "abstractKey": "__isJiraIssueSearchViewMetadata"
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v194 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v91 /*: any*/ ,
                                                                        v184 /*: any*/ ,
                                                                        v31 /*: any*/ ,
                                                                        v29 /*: any*/ ,
                                                                        v186 /*: any*/ ,
                                                                        v136 /*: any*/ 
                                                                    ]
                                                                },
                                                                v187 /*: any*/ ,
                                                                v188 /*: any*/ ,
                                                                v189 /*: any*/ ,
                                                                v137 /*: any*/ ,
                                                                v146 /*: any*/ ,
                                                                v147 /*: any*/ ,
                                                                v148 /*: any*/ ,
                                                                v29 /*: any*/ ,
                                                                v149 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v194 /*: any*/ ,
                                                            "filters": v191 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "IssueNavigatorDetailedViewPagination__issues",
                                                            "kind": "LinkedHandle",
                                                            "name": "issues"
                                                        }
                                                    ],
                                                    "type": "JiraDetailedView"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v195 /*: any*/ ,
                                                            "concreteType": "JiraSpreadsheetGroupConnection",
                                                            "kind": "LinkedField",
                                                            "name": "groups",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSpreadsheetGroupEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v91 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraSpreadsheetGroup",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v31 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v147 /*: any*/ ,
                                                                                v196 /*: any*/ ,
                                                                                v197 /*: any*/ ,
                                                                                v198 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v31 /*: any*/ 
                                                                    ]
                                                                },
                                                                v187 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "groupByField"
                                                                },
                                                                v147 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraSpreadsheetGroup",
                                                                    "kind": "LinkedField",
                                                                    "name": "firstGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "args": v199 /*: any*/ ,
                                                                            "concreteType": "JiraIssueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "issues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v149 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v33 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "QueryError",
                                                                    "kind": "LinkedField",
                                                                    "name": "errors",
                                                                    "plural": true,
                                                                    "selections": v193 /*: any*/ 
                                                                },
                                                                {
                                                                    "condition": "isPaginating",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSpreadsheetGroup",
                                                                            "kind": "LinkedField",
                                                                            "name": "firstGroup",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v147 /*: any*/ ,
                                                                                v196 /*: any*/ ,
                                                                                v197 /*: any*/ ,
                                                                                v198 /*: any*/ ,
                                                                                {
                                                                                    "args": v199 /*: any*/ ,
                                                                                    "concreteType": "JiraIssueConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issues",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v31 /*: any*/ ,
                                                                                                v91 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v31 /*: any*/ ,
                                                                                                        v33 /*: any*/ ,
                                                                                                        v32 /*: any*/ ,
                                                                                                        v41 /*: any*/ ,
                                                                                                        v42 /*: any*/ ,
                                                                                                        v47 /*: any*/ ,
                                                                                                        v49 /*: any*/ ,
                                                                                                        v50 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                v131 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "shouldQueryFieldSetsById",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "args": v55 /*: any*/ ,
                                                                                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "fieldSetsForIssueSearchView",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v130 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v29 /*: any*/ ,
                                                                                                v136 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v137 /*: any*/ ,
                                                                                        v148 /*: any*/ ,
                                                                                        v94 /*: any*/ ,
                                                                                        v29 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "args": v199 /*: any*/ ,
                                                                                    "filters": [
                                                                                        "fieldSetsInput"
                                                                                    ],
                                                                                    "handle": "connection",
                                                                                    "key": "firstGroupSection_nativeIssueTable__issues",
                                                                                    "kind": "LinkedHandle",
                                                                                    "name": "issues"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v29 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v195 /*: any*/ ,
                                                            "filters": v191 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "IssueNavigatorGroupedListViewPagination__groups",
                                                            "kind": "LinkedHandle",
                                                            "name": "groups"
                                                        }
                                                    ],
                                                    "type": "JiraGroupedListView"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v200 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v190 /*: any*/ 
                                                        },
                                                        {
                                                            "args": v200 /*: any*/ ,
                                                            "filters": v191 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "IssueNavigatorListViewPagination__issues",
                                                            "kind": "LinkedHandle",
                                                            "name": "issues"
                                                        }
                                                    ],
                                                    "type": "JiraListView"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5f87fa800b29fa878cf2b142851399608e47956648c0f73b4af48d1590f8e974",
            "metadata": {},
            "name": "main_IssueNavigatorQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": (0, $bqIzm.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $k3PJZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider": (0, $1q6lK.default)
            }
        }
    };
}();
$ff9dfb30fc1873c4$var$node.hash = "344055adbfdb9e9e6653707fee1061b5";
var $ff9dfb30fc1873c4$export$2e2bcd8739ae039 = $ff9dfb30fc1873c4$var$node;

});
parcelRegister("bqIzm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d9218d128e87a96$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
const $9d9218d128e87a96$export$8777089b74f8b497 = {
    get () {
        return (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false);
    }
};
var $9d9218d128e87a96$export$2e2bcd8739ae039 = $9d9218d128e87a96$export$8777089b74f8b497;

});

parcelRegister("1q6lK", function(module, exports) {

$parcel$export(module.exports, "default", () => $181eac5504cd1c95$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");
/**
 * This is copied from jira/src/packages/issue-navigator/rollout/src/is-refactor-nin-to-view-schema-enabled.tsx
 * to reduce the imports this package has to do.
 */ const $181eac5504cd1c95$var$isRefactorNinToViewSchemaEnabled = ()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) && (0, $4R6GH.fg)('refactor_nin_to_jira_view_schema');
var $181eac5504cd1c95$export$2e2bcd8739ae039 = {
    get () {
        return $181eac5504cd1c95$var$isRefactorNinToViewSchemaEnabled();
    }
};

});


parcelRegister("1TiUe", function(module, exports) {

$parcel$export(module.exports, "isRefactorNinToViewSchemaEnabled", () => $93ea404085e2cbb5$export$7aaff298a7d1b49a);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");
const $93ea404085e2cbb5$export$7aaff298a7d1b49a = ()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) && (0, $4R6GH.fg)('refactor_nin_to_jira_view_schema');

});

parcelRegister("5bSAg", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY", () => $2134dee38b024167$export$c300d3b7f3dc697d);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY", () => $2134dee38b024167$export$b99d8b4e19091835);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY", () => $2134dee38b024167$export$1b65799bbeba8a33);
$parcel$export(module.exports, "defaultOrderFields", () => $2134dee38b024167$export$2bd49f8f262d7cbb);
$parcel$export(module.exports, "sortDirections", () => $2134dee38b024167$export$73034536b9adc928);
const $2134dee38b024167$export$c300d3b7f3dc697d = 'ISSUE_NAVIGATOR_RELAY';
const $2134dee38b024167$export$b99d8b4e19091835 = 'ISSUE_NAVIGATOR_FILTER_RELAY';
const $2134dee38b024167$export$1b65799bbeba8a33 = 'ISSUE_NAVIGATOR_HYDRATION_RELAY';
const $2134dee38b024167$export$2bd49f8f262d7cbb = {
    created: 'created',
    lastviewed: 'lastviewed',
    updated: 'updated'
};
const $2134dee38b024167$export$73034536b9adc928 = {
    ASC: 'ASC',
    DESC: 'DESC',
    NONE: 'NONE'
};

});

parcelRegister("aBKbA", function(module, exports) {

$parcel$export(module.exports, "getDefaultJqlGin", () => $b87185164056f069$export$8780b1523384f42d);
$parcel$export(module.exports, "getParams", () => $b87185164056f069$export$ec161d740909e39d);
$parcel$export(module.exports, "getJqlOrFilterId", () => $b87185164056f069$export$b968a035fc2aa57b);
/* eslint-disable jira/import-whitelist */ 
var $9Nvh7 = parcelRequire("9Nvh7");

var $g5X3G = parcelRequire("g5X3G");

var $8zzKy = parcelRequire("8zzKy");

var $5bSAg = parcelRequire("5bSAg");
const $b87185164056f069$export$8780b1523384f42d = ()=>`ORDER BY ${(0, $5bSAg.defaultOrderFields).created} ${(0, $5bSAg.sortDirections).DESC}`;
const $b87185164056f069$export$ec161d740909e39d = ({ match: { params: params }, query: query })=>{
    const { projectKey: projectKey, issueKey: issueKey } = params;
    const { filter: filter, jql: jql } = query;
    // Default JQL when no relevant query parameter is set
    const defaultJql = projectKey !== null && projectKey !== undefined ? (0, $8zzKy.getDefaultJql)((0, $g5X3G.toProjectKey)(projectKey)) : $b87185164056f069$export$8780b1523384f42d();
    return {
        page: 1,
        jql: jql,
        issueKey: issueKey,
        projectKey: projectKey,
        filter: filter,
        defaultJql: defaultJql
    };
};
const $b87185164056f069$export$b968a035fc2aa57b = (defaultJql, jqlParam, filter, projectKey)=>{
    // If JQL param has been defined (even if it's empty) we should use it
    if (typeof jqlParam === 'string') return {
        jql: jqlParam
    };
    // If filter is non-empty then use the filter parameter
    if (typeof filter === 'string' && filter !== '') {
        if ((0, $9Nvh7.isFilterId)(filter)) return {
            filterId: filter
        };
        const filterJql = projectKey !== null && projectKey !== undefined ? (0, $8zzKy.mapFilterToJql)(projectKey, filter) : undefined;
        if (filterJql !== undefined) return {
            jql: filterJql
        };
    }
    // Fallback to the default JQL if neither JQL or valid filter parameters have been provided.
    return {
        jql: defaultJql
    };
};

});
parcelRegister("8zzKy", function(module, exports) {

$parcel$export(module.exports, "isFilterKey", () => $f8caace292c4edec$export$2cad587bb603edda);
$parcel$export(module.exports, "mapFilterToJql", () => $f8caace292c4edec$export$1d71dda738f608f);
$parcel$export(module.exports, "getDefaultJql", () => $f8caace292c4edec$export$346d50fe8350b1d0);
$parcel$export(module.exports, "getUrlPrefix", () => $f8caace292c4edec$export$821d4141d135e0d0);

var $ebyGx = parcelRequire("ebyGx");

var $6UAdF = parcelRequire("6UAdF");

var $2s5Ei = parcelRequire("2s5Ei");
const $f8caace292c4edec$export$2cad587bb603edda = (filter)=>typeof filter === 'string' && filter in (0, $2s5Ei.Filters);
const $f8caace292c4edec$export$1d71dda738f608f = (projectKey, filter)=>{
    if (!$f8caace292c4edec$export$2cad587bb603edda(filter)) return undefined;
    const clauses = [
        `project = "${projectKey}"`
    ];
    let order = (0, $6UAdF.DEFAULT_ORDER_FIELD);
    const direction = (0, $6UAdF.DEFAULT_SORT_DIRECTION);
    switch((0, $2s5Ei.Filters)[filter]){
        case (0, $2s5Ei.Filters).myopenissues:
            clauses.push('assignee IN (currentUser())');
            clauses.push(`statusCategory IN (${(0, $2s5Ei.StatusCategoryValues).TO_DO}, ${(0, $2s5Ei.StatusCategoryValues).IN_PROGRESS})`);
            break;
        case (0, $2s5Ei.Filters).reportedbyme:
            clauses.push('reporter IN (currentUser())');
            break;
        case (0, $2s5Ei.Filters).allopenissues:
            clauses.push(`statusCategory IN (${(0, $2s5Ei.StatusCategoryValues).TO_DO}, ${(0, $2s5Ei.StatusCategoryValues).IN_PROGRESS})`);
            order = (0, $6UAdF.defaultOrderFields).updated;
            break;
        case (0, $2s5Ei.Filters).doneissues:
            clauses.push(`statusCategory = ${(0, $2s5Ei.StatusCategoryValues).DONE}`);
            break;
        case (0, $2s5Ei.Filters).recentlyviewed:
            order = (0, $6UAdF.defaultOrderFields).lastviewed;
            break;
        case (0, $2s5Ei.Filters).resolvedrecently:
            clauses.push('resolved >= -1w');
            order = (0, $6UAdF.defaultOrderFields).updated;
            break;
        case (0, $2s5Ei.Filters).updatedrecently:
            order = (0, $6UAdF.defaultOrderFields).updated;
            break;
        case (0, $2s5Ei.Filters).allissues:
            order = (0, $6UAdF.defaultOrderFields).created;
            break;
        default:
    }
    return `${clauses.join(' AND ')} ORDER BY ${order} ${direction}`.trim();
};
const $f8caace292c4edec$export$346d50fe8350b1d0 = (projectKey)=>`project = "${projectKey}" ORDER BY ${0, $6UAdF.DEFAULT_ORDER_FIELD} ${0, $6UAdF.DEFAULT_SORT_DIRECTION}`;
const $f8caace292c4edec$export$e5b4f9d05e643346 = (search, match)=>({
        ...(0, $ebyGx.parse)(search),
        ...match && match.params
    });
const $f8caace292c4edec$export$821d4141d135e0d0 = (url)=>{
    const match = url.match(/^(.*)\/projects.*$/);
    return (match && match[1]) ?? '';
};

});
parcelRegister("2s5Ei", function(module, exports) {

$parcel$export(module.exports, "Filters", () => $ff462caa91749c6a$export$92a576f896a9bf72);
$parcel$export(module.exports, "StatusCategoryValues", () => $ff462caa91749c6a$export$72d6e2acce8f36fd);
const $ff462caa91749c6a$export$92a576f896a9bf72 = {
    myopenissues: Symbol('myopenissues'),
    reportedbyme: Symbol('reportedbyme'),
    allopenissues: Symbol('allopenissues'),
    doneissues: Symbol('doneissues'),
    recentlyviewed: Symbol('recentlyviewed'),
    resolvedrecently: Symbol('resolvedrecently'),
    updatedrecently: Symbol('updatedrecently'),
    allissues: Symbol('allissues')
};
const $ff462caa91749c6a$export$72d6e2acce8f36fd = {
    TO_DO: '"To Do"',
    DONE: '"Done"',
    IN_PROGRESS: '"In Progress"'
};

});





parcelRegister("3uU6P", function(module, exports) {

$parcel$export(module.exports, "getRouteReporting", () => $96adb79ea93c1c80$export$1300cb25a03c28fe);
const $96adb79ea93c1c80$export$1300cb25a03c28fe = ()=>({
        id: 'issue-navigator',
        packageName: 'issueNavigator',
        teamName: 'empanada'
    });

});

parcelRegister("gGOoR", function(module, exports) {

$parcel$export(module.exports, "default", () => $265d2c27687434ef$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");

var $doZTA = parcelRequire("doZTA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$265d2c27687434ef$export$2e2bcd8739ae039 = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const issueKey = match.params.issueKey ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/issues/${issueKey}`
    });
};

});

parcelRegister("b8f12", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorGinRedirectPageEntryPoint", () => $b7591135658477a3$export$f0e4197c4e8c99ac);
$parcel$export(module.exports, "issueNavigatorPageEntryPoint", () => $b7591135658477a3$export$b75ca1c5551bc52f);
$parcel$export(module.exports, "issueNavigatorWithoutHorizontalNavPageEntryPoint", () => $b7591135658477a3$export$ebe022658b1c5d7a);
$parcel$export(module.exports, "issueNavigatorPinRedirectPageEntryPoint", () => $b7591135658477a3$export$a90e8f2ed95763c3);
$parcel$export(module.exports, "LazyGlobalIssueNavigator", () => $b7591135658477a3$export$8ff267588532c2ce);
$parcel$export(module.exports, "GinRedirect", () => $b7591135658477a3$export$3b4f172f4310bbc);

var $5uXOq = parcelRequire("5uXOq");

var $1kQCU = parcelRequire("1kQCU");

var $VILOn = parcelRequire("VILOn");

var $7SHTM = parcelRequire("7SHTM");

var $1gXMV = parcelRequire("1gXMV");

var $5j7Th = parcelRequire("5j7Th");

var $cZpsT = parcelRequire("cZpsT");

var $b7Svb = parcelRequire("b7Svb");

var $cBZvI = parcelRequire("cBZvI");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $lkFvK = parcelRequire("lkFvK");

var $mH8xj = parcelRequire("mH8xj");

var $kUl3E = parcelRequire("kUl3E");

var $4Exdo = parcelRequire("4Exdo");
const $b7591135658477a3$export$f0e4197c4e8c99ac = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4Exdo.globalIssueNavigatorGinRedirectEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).FILTERS
});
const $b7591135658477a3$export$b75ca1c5551bc52f = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $cBZvI.issueNavigatorEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $b7591135658477a3$export$ebe022658b1c5d7a = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $cBZvI.issueNavigatorEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $b7591135658477a3$export$a90e8f2ed95763c3 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $mH8xj.issueNavigatorPinRedirectEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

const $b7591135658477a3$export$8ff267588532c2ce = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("a1kns")), {
    moduleId: "./src/packages/spa-apps/global-issue-navigator/src/index.tsx"
});
const $b7591135658477a3$export$4bd5bc3fa8a52567 = ({ match: match, query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b7591135658477a3$export$8ff267588532c2ce,
        pageId: (0, $kUl3E.default)(match, query),
        shouldShowSpinner: false
    });
const $b7591135658477a3$export$3b4f172f4310bbc = (props)=>{
    const [isNinGlobalScopeEnrolmentEnabled, resourceData] = (0, $1kQCU.useGlobalScopeEnrolmentEnable)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    // Regardless of the existing localStorageData value, we update the localStorage value once we get resourceData so
    // that future renders are fast and accurate.
    (0, $5uXOq.useEffect)(()=>{
        if (resourceData !== null && resourceData !== undefined) (0, $VILOn.setIsGlobalScopeEnrolmentEnabledInLocalStorage)(resourceData);
    }, [
        resourceData
    ]);
    // If NIN in global scope is not enabled then we redirect to legacy GIN by performing a reload
    (0, $5uXOq.useEffect)(()=>{
        if (isNinGlobalScopeEnrolmentEnabled === false) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    }, [
        isNinGlobalScopeEnrolmentEnabled
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isNinGlobalScopeEnrolmentEnabled) {
            // If we are in global scope nin then reset/enable the forced opt out flag for GIN if we haven't done it already
            const globalGINFlagDisabled = (0, $VILOn.getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage)();
            if (globalGINFlagDisabled !== false) {
                !isAnonymous && (0, $7SHTM.resetGlobalScopeForcedOptOutGinFlag)();
                (0, $VILOn.setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage)();
            }
        }
    }, [
        isAnonymous,
        isNinGlobalScopeEnrolmentEnabled
    ]);
    // If NIN in global scope is enabled then we render it. If NIN in global scope is not enabled, or we're blocked
    // waiting on the resource to load then we render GlobalIssueNavigatorSkeleton.
    return isNinGlobalScopeEnrolmentEnabled === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b7591135658477a3$export$4bd5bc3fa8a52567, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1gXMV.GlobalIssueNavigatorSkeleton), null);
};

});
parcelRegister("1kQCU", function(module, exports) {

$parcel$export(module.exports, "useGlobalScopeOptOutFlow", () => $d96a4352cc61ecaf$export$f39dd0211cb78bcf);
$parcel$export(module.exports, "useGlobalScopeEnrolmentEnable", () => $d96a4352cc61ecaf$export$f45d1a4e873cac44);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $VILOn = parcelRequire("VILOn");

var $7SHTM = parcelRequire("7SHTM");

var $bATyw = parcelRequire("bATyw");

var $bVDE5 = parcelRequire("bVDE5");

var $cZpsT = parcelRequire("cZpsT");

var $2YP9W = parcelRequire("2YP9W");

var $aK1ba = parcelRequire("aK1ba");

var $cnynt = parcelRequire("cnynt");
const $d96a4352cc61ecaf$export$f39dd0211cb78bcf = (href)=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const redirectToGin = (0, $5uXOq.useCallback)(()=>{
        if (href) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.assign(href);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    }, [
        href
    ]);
    const { renderFeedbackDialog: renderFeedbackDialog } = (0, $aK1ba.default)({
        onClose: redirectToGin,
        isAdminSettingsModal: false
    });
    /**
	 * globalScopeOptOut
	 * Triggers the NIN Global Scope opt-out process, including all UI orchestration of feedback.
	 *
	 * The caller should handle "default" behaviour for when the user is already not enrolled,
	 * unless the `preventDefault` callback has been called. This allows for easy usage with links,
	 * where the onClick event's `preventDefault` can be passed.
	 *
	 * If using an event's `preventDefault`, remember to bind the event!
	 * ex: `globalScopeOptOut(event.preventDefault.bind(event));`
	 *
	 * @param {Function} preventDefault
	 */ return (0, $5uXOq.useCallback)(async (preventDefault)=>{
        // If the user has already opt-out, just allow the caller to handle the click
        if (!(0, $VILOn.getIsGlobalScopeEnrolmentEnabledFromLocalStorage)()) return;
        // Otherwise, take over the interaction
        preventDefault && preventDefault();
        try {
            // Update user preference and local storage
            !isAnonymous && await (0, $7SHTM.setIsGlobalScopeEnrolmentEnabledUserPreference)(false);
            (0, $VILOn.setIsGlobalScopeEnrolmentEnabledInLocalStorage)(false);
            renderFeedbackDialog();
            sessionStorage.setItem('showGinOptOutFlag', 'true');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            showFlag({
                type: 'error',
                title: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cnynt.default).errorOptOutTitleIssueTermRefresh : (0, $cnynt.default).errorOptOutTitle,
                description: (0, $cnynt.default).errorOptOutDesc,
                testId: 'issue-navigator-action-meatball-menu.ui.error-flag',
                messageId: 'issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.show-flag.error',
                messageType: 'transactional'
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'optOutOfNin',
                    packageName: 'jiraIssueNavigatorChangeboarding',
                    teamName: 'empanada'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
        }
    }, [
        isAnonymous,
        renderFeedbackDialog,
        showFlag
    ]);
};
const $d96a4352cc61ecaf$export$f45d1a4e873cac44 = ()=>{
    // We store localStorageData as state so that it's not recalculated during subsequent renders. We want that as a
    // guarantee, not just as a performance optimisation, so we're using useState rather than useMemo.
    //
    // The reason we want to guarantee it's only fetched during the initial render is that we want
    // isNinGlobalScopeEnrolmentEnabled to be stable if there's localStorageData. This can prevent a bug where fetch
    // true from localStorage, we render NIN, the resource returns false, we update local storage to false, and then
    // GinRedirect is rendered again by a parent component and localStorage now returns false and we redirect later
    // than we should.
    const [localStorageData] = (0, $5uXOq.useState)((0, $VILOn.getIsGlobalScopeEnrolmentEnabledFromLocalStorage));
    const { data: resourceData } = (0, $2YP9W.useResource)((0, $bATyw.isNinGlobalScopeEnrolmentEnabledResource));
    const [{ isInitialRender: isInitialRender }] = (0, $bVDE5.useSpaStateTransition)();
    // We assume NIN global scope is enabled if this is an initial render, otherwise we rely on localStorageData if it
    // exists, otherwise we use resourceData. resourceData is async, and can block for a long time, so we optimise for
    // speed rather than correctness by trusting localStorageData.
    let isNinGlobalScopeEnrolmentEnabled;
    if (isInitialRender) isNinGlobalScopeEnrolmentEnabled = true;
    else if (localStorageData !== null && localStorageData !== undefined) isNinGlobalScopeEnrolmentEnabled = localStorageData;
    else isNinGlobalScopeEnrolmentEnabled = resourceData;
    return [
        isNinGlobalScopeEnrolmentEnabled,
        resourceData
    ];
};

});
parcelRegister("VILOn", function(module, exports) {

$parcel$export(module.exports, "getIsGlobalScopeEnrolmentEnabledFromLocalStorage", () => $5dc42c779a970b72$export$55632339cd4dae9c);
$parcel$export(module.exports, "getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage", () => $5dc42c779a970b72$export$7b78bfe0a111cecf);
$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledInLocalStorage", () => $5dc42c779a970b72$export$82b2633cf7498c5e);
$parcel$export(module.exports, "setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage", () => $5dc42c779a970b72$export$458eda2352a1e223);

var $bSSG7 = parcelRequire("bSSG7");

var $dJl1T = parcelRequire("dJl1T");
const $5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY = 'jira.nin.global.scope.enrolment';
const $5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY = 'jira.user.nin.global.scope.enrolment.flag.disabled';
const $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage = (0, $bSSG7.createLocalStorageProvider)('nin-changeboarding');
const $5dc42c779a970b72$export$34434fbbe40a8047 = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.remove($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$55632339cd4dae9c = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$7b78bfe0a111cecf = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$82b2633cf7498c5e = (isNINEnrolmentEnabled)=>{
    // In practice this is very unlikely to fail, as our local storage library checks that local storage is working
    // during initialisation. However in order to be robust we will catch any errors and recover by simply deleting the
    // existing local storage value (it's just a cache, so deleting it and delegating to the server will work fine)
    try {
        $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY, isNINEnrolmentEnabled);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $dJl1T.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage value, removing instead');
        $5dc42c779a970b72$export$34434fbbe40a8047();
    }
};
const $5dc42c779a970b72$export$458eda2352a1e223 = ()=>{
    try {
        $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY, false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $dJl1T.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage flag value');
    }
};

});

parcelRegister("7SHTM", function(module, exports) {

$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledUserPreference", () => $a1fa570fc83fd392$export$2fc59b10f256dbee);
$parcel$export(module.exports, "resetGlobalScopeForcedOptOutGinFlag", () => $a1fa570fc83fd392$export$89f09c81b642e3c7);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $a1fa570fc83fd392$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION = `
    mutation SetGlobalScopeUserPreferenceMutation($input: SetMyPreferenceInput!) {
        setMyPreference(input: $input) {
            success
        }
    }
`;
const $a1fa570fc83fd392$var$setGlobalScopeUserPreference = async (input)=>{
    const result = await (0, $eusud.performPostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $a1fa570fc83fd392$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION,
            variables: {
                input: input
            }
        })
    });
    if (result.data.setMyPreference.success !== true) throw new Error(`Error setting user preference: ${input.key}`, {
        cause: result.errors?.[0]
    });
};
const $a1fa570fc83fd392$export$2fc59b10f256dbee = async (value)=>$a1fa570fc83fd392$var$setGlobalScopeUserPreference({
        key: 'jira.user.nin.global.scope.enrolment',
        value: value ? 'nin' : 'gin'
    });
const $a1fa570fc83fd392$export$89f09c81b642e3c7 = async ()=>$a1fa570fc83fd392$var$setGlobalScopeUserPreference({
        key: 'jira.user.nin.global.scope.enrolment.flag.disabled',
        value: false
    }).catch((error)=>(0, $jcw0u.default)({
            meta: {
                id: 'resetGlobalScopeGinFlag',
                packageName: 'jiraIssueNavigatorGlobalScopeEnrolment',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        }));

});

parcelRegister("aK1ba", function(module, exports) {

$parcel$export(module.exports, "default", () => $106d1fc5065910b3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $6jY6G = parcelRequire("6jY6G");

var $bw7Gm = parcelRequire("bw7Gm");

var $4DPZY = parcelRequire("4DPZY");

var $9OXo1 = parcelRequire("9OXo1");

var $g7SDw = parcelRequire("g7SDw");
const $106d1fc5065910b3$export$3fe286306fb8ddfb = 'global-scope-issue-navigator-opt-out';
const $106d1fc5065910b3$var$unknownAttributeValue = 'unknown';
const $106d1fc5065910b3$export$b028e515f8f652e0 = ({ isSiteAdmin: isSiteAdmin, routeName: routeName, routeGroup: routeGroup, projectType: projectType, isProjectSimplified: isProjectSimplified, cloudId: cloudId })=>[
        {
            id: (0, $7iULw.EntryKeys).LOCATION,
            value: (0, $4R6GH.fg)('jfp-magma-undefined-navigator') ? (0, $bw7Gm.default)(globalThis.location?.href) : (0, $bw7Gm.default)(window.location.href) // eslint-disable-line jira/jira-ssr/no-unchecked-globals-usage
        },
        {
            id: (0, $7iULw.EntryKeys).REFERER,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            value: document.referrer ? (0, $bw7Gm.default)(document.referrer) : ''
        },
        {
            id: (0, $7iULw.EntryKeys).USER_AGENT,
            value: (0, $4R6GH.fg)('jfp-magma-undefined-navigator') ? globalThis.navigator?.userAgent : navigator.userAgent // eslint-disable-line jira/jira-ssr/no-unchecked-globals-usage
        },
        {
            id: (0, $7iULw.EntryKeys).SCREEN_RESOLUTION,
            value: (0, $4R6GH.fg)('jfp-magma-undefined-navigator') ? `${globalThis.window?.screen?.width} x ${globalThis.window?.screen?.height}` : `${window.screen.width} x ${window.screen.height}` // eslint-disable-line jira/jira-ssr/no-unchecked-globals-usage
        },
        {
            id: (0, $7iULw.EntryKeys).ROUTE_NAME,
            value: routeName
        },
        {
            id: (0, $7iULw.EntryKeys).ROUTE_GROUP,
            value: routeGroup
        },
        {
            id: (0, $7iULw.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: isProjectSimplified.toString()
        },
        {
            id: (0, $7iULw.EntryKeys).IS_ADMIN,
            value: isSiteAdmin.toString()
        },
        {
            id: (0, $7iULw.EntryKeys).PROJECT_TYPE,
            value: projectType
        },
        {
            id: 'cloud-id',
            value: cloudId
        }
    ];
const $106d1fc5065910b3$export$3a73a4e2115ebf73 = ({ isAdminSettingsModal: isAdminSettingsModal = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const titleDetails = isAdminSettingsModal ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $g7SDw.default).titleDetailsAdminIssueTermRefresh : (0, $g7SDw.default).titleDetailsAdmin) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $g7SDw.default).titleDetailsUserIssueTermRefresh : (0, $g7SDw.default).titleDetailsUser);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $106d1fc5065910b3$var$feedbackTitleDetailsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        as: "p"
    }, titleDetails));
};
const $106d1fc5065910b3$var$useFeedbackDialog = ({ isAdminSettingsModal: isAdminSettingsModal = false, onClose: onClose = ()=>undefined })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const [{ data: projectData }] = (0, $4DPZY.useContainerContext)();
    const { cloudId: cloudId, isSiteAdmin: isSiteAdmin } = (0, $9OXo1.useTenantContext)();
    const routeGroup = route.group ?? $106d1fc5065910b3$var$unknownAttributeValue;
    const routeName = route.name ?? $106d1fc5065910b3$var$unknownAttributeValue;
    let projectType = $106d1fc5065910b3$var$unknownAttributeValue;
    let isProjectSimplified = false;
    if (projectData && 'project' in projectData && projectData.project) {
        projectType = projectData.project.type;
        isProjectSimplified = projectData.project.isSimplified;
    }
    const renderFeedbackDialog = (0, $5uXOq.useCallback)(()=>{
        openFeedbackCollector({
            feedbackGroupId: $106d1fc5065910b3$export$3fe286306fb8ddfb,
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR),
            onClose: onClose,
            feedbackContext: $106d1fc5065910b3$export$b028e515f8f652e0({
                isSiteAdmin: isSiteAdmin,
                cloudId: cloudId,
                routeGroup: routeGroup,
                routeName: routeName,
                projectType: projectType,
                isProjectSimplified: isProjectSimplified
            }),
            feedbackTitle: formatMessage((0, $g7SDw.default).title),
            feedbackTitleDetails: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($106d1fc5065910b3$export$3a73a4e2115ebf73, {
                isAdminSettingsModal: isAdminSettingsModal
            }),
            selectLabel: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $g7SDw.default).reasonTitleIssueTermRefresh : (0, $g7SDw.default).reasonTitle),
            // Intentional whitespace to clear the placeholder
            // (eluding feedback dialog's empty check for this prop, which includes empty string)
            summaryPlaceholder: ' ',
            submitButtonLabel: formatMessage((0, $g7SDw.default).submitCaption),
            cancelButtonLabel: formatMessage((0, $g7SDw.default).cancelCaption),
            feedbackGroupLabels: {
                empty: {
                    selectOptionLabel: formatMessage((0, $g7SDw.default).reasonPlaceholder)
                },
                bug: {
                    fieldLabel: formatMessage((0, $g7SDw.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $g7SDw.default).reasonBug)
                },
                comment: {
                    fieldLabel: formatMessage((0, $g7SDw.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $g7SDw.default).reasonSpeed)
                },
                suggestion: {
                    fieldLabel: formatMessage((0, $g7SDw.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $g7SDw.default).reasonOthers)
                },
                question: {
                    fieldLabel: formatMessage((0, $g7SDw.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $g7SDw.default).reasonParity)
                }
            }
        });
    }, [
        openFeedbackCollector,
        onClose,
        isSiteAdmin,
        cloudId,
        routeGroup,
        routeName,
        projectType,
        isProjectSimplified,
        formatMessage,
        isAdminSettingsModal
    ]);
    return {
        renderFeedbackDialog: renderFeedbackDialog
    };
};
var $106d1fc5065910b3$export$2e2bcd8739ae039 = $106d1fc5065910b3$var$useFeedbackDialog;
const $106d1fc5065910b3$var$feedbackTitleDetailsContainerStyles = (0, $2s57o.xcss)({
    marginBottom: 'space.050'
});

});
parcelRegister("7iULw", function(module, exports) {

$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", () => $384a8a865c8f714d$export$baea5c8192e79adc);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", () => $384a8a865c8f714d$export$4eda1e3a4a311d13);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", () => $384a8a865c8f714d$export$5fb38521eb7ad63c);
$parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", () => $384a8a865c8f714d$export$345c45dd28f28a32);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", () => $384a8a865c8f714d$export$8962f2e618411469);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", () => $384a8a865c8f714d$export$7d7f2319141db3c5);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", () => $384a8a865c8f714d$export$4725635e6fe1907a);
$parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", () => $384a8a865c8f714d$export$3a50f2efd6cfd6f3);
$parcel$export(module.exports, "ENTRY_POINT_ID_AIOPS", () => $384a8a865c8f714d$export$5bd148c13bb23f7a);
$parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", () => $384a8a865c8f714d$export$b4de0744c1fd450d);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", () => $384a8a865c8f714d$export$1a7c42187130faf9);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", () => $384a8a865c8f714d$export$e84c34a7e1dbcf78);
$parcel$export(module.exports, "ENTRYPOINT_ID_NAVIGATION_REFRESH", () => $384a8a865c8f714d$export$23f6d7b16d2210c1);
$parcel$export(module.exports, "ENTRY_POINT_ID_AUTODEV", () => $384a8a865c8f714d$export$1b65c2053cba0686);
$parcel$export(module.exports, "ENTRY_POINT_ID_REQUEST_TYPES_PAGE", () => $384a8a865c8f714d$export$86e0eeb08f5b7ea6);
$parcel$export(module.exports, "EntryKeys", () => $384a8a865c8f714d$export$12d01b6c311a909a);
// Jira platform project feedback JSD widget configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JGF/queues/custom/448
const $384a8a865c8f714d$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
const $384a8a865c8f714d$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
const $384a8a865c8f714d$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
const $384a8a865c8f714d$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
const $384a8a865c8f714d$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
const $384a8a865c8f714d$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
const $384a8a865c8f714d$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
const $384a8a865c8f714d$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
const $384a8a865c8f714d$export$5bd148c13bb23f7a = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';
const $384a8a865c8f714d$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
const $384a8a865c8f714d$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
const $384a8a865c8f714d$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
const $384a8a865c8f714d$export$23f6d7b16d2210c1 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
const $384a8a865c8f714d$export$1b65c2053cba0686 = '88d39839-ba5c-4704-bfd6-7fe57ed8016b';
const $384a8a865c8f714d$export$86e0eeb08f5b7ea6 = 'ee8a71e7-85aa-4121-b455-e6316922e894';
const $384a8a865c8f714d$export$12d01b6c311a909a = Object.freeze({
    CLOUD_ID: 'cloud-id',
    OPT_OUT: 'Opt-out',
    REASON: 'reason',
    FEELING: 'feeling',
    IS_ADMIN: 'is-admin',
    IS_SITE_ADMIN: 'is-site-admin',
    IS_PROJECT_SETTINGS: 'is-project-settings',
    INLINE_FEEDBACK_ID: 'inlineFeedbackId',
    IS_JSD_EVALUATOR: 'is-jsd-evaluator',
    IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
    SUPPORTED_PROJECT_TYPES: 'supported-project-types',
    FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
    FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
    FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
    LOCATION: 'Location',
    PROJECT_TYPE: 'project-type',
    BOARD_TYPE: 'board-type',
    REFERER: 'Referer',
    ROUTE_GROUP: 'route-group',
    ROUTE_NAME: 'route-name',
    USER_AGENT: 'User-Agent',
    SCREEN_RESOLUTION: 'Screen Resolution',
    SOURCE: 'Source',
    SUB_PRODUCT: 'Sub-product',
    JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
    JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
    DEPLOYMENT_PROVIDERS: 'deployment-providers',
    JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
    VERSION_CONTROL_PROVIDERS: 'version-control-providers',
    DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
    CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
    SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
    INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
    IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
    FEEDBACK_GROUP_ID: 'feedback-group-id',
    EDITION: 'edition',
    ENV: 'environment',
    SMART_REPLIES: 'smart-replies',
    COLLABORATIVE_SPRINTS: 'collaborative-sprints',
    PROJECT_RECAP_FEEDBACK_GROUP_ID: 'jira-notifications-project-recap'
});

});

parcelRegister("dseDh", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $c996142feb877ddb$export$4be696be8a3bff13);
$parcel$export(module.exports, "useFeedbackCollectorActions", () => $c996142feb877ddb$export$dfb2ee2d9e73fa48);
$parcel$export(module.exports, "FeedbackActionsSubscriber", () => $c996142feb877ddb$export$c35dbf16ebe9df04);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $c996142feb877ddb$export$d4c72bab9d6cc13a = {
    isFeedbackCollectorOpen: false,
    entrypointId: undefined,
    email: undefined,
    additionalFields: undefined,
    feedbackTitle: undefined,
    feedbackContext: undefined,
    feedbackCollectorId: undefined,
    // default value of this prop is true so making sure inititally it is true
    showTypeField: true,
    submitButtonLabel: undefined,
    canBeContactedLabel: undefined,
    summaryPlaceholder: undefined,
    feedbackGroupLabels: undefined,
    onClose: undefined,
    feedbackTitleDetails: undefined,
    triggerRef: undefined,
    renderCustomContent: undefined,
    customFeedbackOptions: []
};
const $c996142feb877ddb$export$e324594224ef24da = {
    openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
            // Reset to initial state to clear any leftover state
            dispatch($c996142feb877ddb$export$e324594224ef24da.resetFeedbackCollectorState());
            setState({
                ...feedbackCollectorProps,
                isFeedbackCollectorOpen: true
            });
        },
    closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
            const { triggerRef: triggerRef } = getState();
            if (triggerRef) // Unfortunately we need a setTimeout here to delay the execution cycle because modal is yet to be closed
            setTimeout(()=>triggerRef.current?.focus(), 50);
            setState({
                isFeedbackCollectorOpen: false,
                triggerRef: undefined
            });
        },
    resetFeedbackCollectorState: ()=>({ setState: setState })=>{
            setState({
                ...$c996142feb877ddb$export$d4c72bab9d6cc13a
            });
        },
    updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
            setState({
                renderCustomContent: updatedCustomRenderContent
            });
        },
    updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
            setState({
                additionalFields: updatedAdditionalFields
            });
        }
};
const $c996142feb877ddb$var$Store = (0, $iXqE5.createStore)({
    name: 'feedback-collector',
    initialState: $c996142feb877ddb$export$d4c72bab9d6cc13a,
    actions: $c996142feb877ddb$export$e324594224ef24da
});
const $c996142feb877ddb$export$4be696be8a3bff13 = (0, $3sQ5x.createHook)($c996142feb877ddb$var$Store);
const $c996142feb877ddb$export$dfb2ee2d9e73fa48 = (0, $3sQ5x.createActionsHook)($c996142feb877ddb$var$Store);
const $c996142feb877ddb$export$c35dbf16ebe9df04 = (0, $51nlc.createSubscriber)($c996142feb877ddb$var$Store, {
    selector: null
});

});

parcelRegister("g7SDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fa18157d389278a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $5fa18157d389278a$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title",
        "defaultMessage": "Let us know why you're moving"
    },
    titleDetailsAdmin: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-admin",
        "defaultMessage": "You and your users will be able to use the old issue search temporarily."
    },
    titleDetailsUser: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-user",
        "defaultMessage": "You'll be able to use the old issue search temporarily."
    },
    submitCaption: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.submit-caption",
        "defaultMessage": "Send feedback"
    },
    cancelCaption: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.cancel-caption",
        "defaultMessage": "Skip"
    },
    reasonTitle: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-title",
        "defaultMessage": "What is your reason to go back to the old issue search?"
    },
    reasonPlaceholder: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-placeholder",
        "defaultMessage": "Select an option"
    },
    reasonParity: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-parity",
        "defaultMessage": "Features are missing"
    },
    reasonSpeed: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-speed",
        "defaultMessage": "It's slow"
    },
    reasonBug: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-bug",
        "defaultMessage": "There's a bug"
    },
    reasonOthers: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-others",
        "defaultMessage": "Others"
    },
    reasonQuestion: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-question",
        "defaultMessage": "Can you provide more details? It'll help make search better for everyone."
    },
    titleDetailsAdminIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-admin-issue-term-refresh",
        "defaultMessage": "You'll be able to use the old way to search for work items temporarily."
    },
    titleDetailsUserIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-user-issue-term-refresh",
        "defaultMessage": "You'll be able to use the old way to search for work items temporarily."
    },
    reasonTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-title-issue-term-refresh",
        "defaultMessage": "What's the reason you're going back to the old way to searching for work items?"
    }
});
var $5fa18157d389278a$export$2e2bcd8739ae039 = $5fa18157d389278a$var$messages;

});


parcelRegister("cnynt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c37d0c1deb4d01ea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $c37d0c1deb4d01ea$var$messages = (0, $7VHMR.defineMessages)({
    errorOptOutTitle: {
        "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-title",
        "defaultMessage": "We couldn't switch to the old issue search"
    },
    errorOptOutDesc: {
        "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-desc",
        "defaultMessage": "Refresh and try again."
    },
    errorOptOutTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-title-issue-term-refresh",
        "defaultMessage": "We couldn't switch to the old search"
    }
});
var $c37d0c1deb4d01ea$export$2e2bcd8739ae039 = $c37d0c1deb4d01ea$var$messages;

});


parcelRegister("cBZvI", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorEntrypoint", () => $793b04cc2e7c7233$export$4ec136b0c737540b);

var $cfawy = parcelRequire("cfawy");

var $3rdd7 = parcelRequire("3rdd7");

var $5T6bY = parcelRequire("5T6bY");

var $4R6GH = parcelRequire("4R6GH");

const $793b04cc2e7c7233$export$4ec136b0c737540b = (0, $3rdd7.createEntryPoint)({
    root: (0, $cfawy.JSResourceForUserVisible)(()=>(parcelRequire("jPlp1")), {
        moduleId: "fcbfeb68"
    }),
    getPreloadProps: (entryPointParams)=>{
        const issueKey = entryPointParams?.context?.match?.params?.issueKey;
        // exclude nativeIssueTableEntryPoint from preloading on the issue route
        if (!issueKey && (0, $4R6GH.fg)('jira_list_issue_table_entrypoint')) return {
            entryPoints: {
                nativeIssueTableEntryPoint: {
                    entryPoint: (0, $5T6bY.nativeIssueTableEntryPoint),
                    entryPointParams: entryPointParams
                }
            }
        };
        return {};
    }
});

});
parcelRegister("5T6bY", function(module, exports) {

$parcel$export(module.exports, "nativeIssueTableEntryPoint", () => $b9fa91d89cda3ec1$export$df35b18d762f614);

var $3rdd7 = parcelRequire("3rdd7");

var $cfawy = parcelRequire("cfawy");

const $b9fa91d89cda3ec1$export$df35b18d762f614 = (0, $3rdd7.createEntryPoint)({
    root: (0, $cfawy.JSResourceForUserVisible)(()=>(parcelRequire("4afSm")).then((module)=>module.NativeIssueTableEntryPoint), {
        moduleId: "b6718107"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4afSm", function(module, exports) {

let $3084692e8e067778$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3084692e8e067778$var$load("h2MrD"),
    $3084692e8e067778$var$load("bYT2S"),
    $3084692e8e067778$var$load("dsiAd"),
    $3084692e8e067778$var$load("hPzOn"),
    $3084692e8e067778$var$load("nEBxE")
]).then(()=>parcelRequire('bPcgy'));

});


parcelRegister("jPlp1", function(module, exports) {

let $e6f361d60951f3e7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e6f361d60951f3e7$var$load("hPzOn"),
    $e6f361d60951f3e7$var$load("iIfyN")
]).then(()=>parcelRequire('jABZI'));

});


parcelRegister("mH8xj", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorPinRedirectEntrypoint", () => $5f84d963532ff7c4$export$cc17cd3f65b3828f);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $5f84d963532ff7c4$export$cc17cd3f65b3828f = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("34lNE")), {
        moduleId: "8d4a4d33"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("34lNE", function(module, exports) {

let $23c2a7c8ba622951$var$load = (parcelRequire("28QjX"))(4);
module.exports = $23c2a7c8ba622951$var$load("cb445").then(()=>parcelRequire('kF7iq'));

});


parcelRegister("kUl3E", function(module, exports) {

$parcel$export(module.exports, "default", () => $138ed00c0e48b315$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$138ed00c0e48b315$export$2e2bcd8739ae039 = ({ params: params }, { filter: filter, orderby: orderby, keyword: keyword })=>{
    const { projectKey: projectKey, issueKey: issueKey } = params;
    const pageIdPrefix = 'new-issue-navigator';
    let pageId = '';
    try {
        pageId = `${pageIdPrefix}${(projectKey !== null && projectKey !== undefined ? `-${projectKey}` : '') + (issueKey !== null && issueKey !== undefined ? `-${issueKey}` : '') + (filter !== undefined ? `-${filter}` : '') + (orderby !== undefined ? `-${orderby}` : '') + (keyword !== undefined ? `-${keyword}` : '')}`;
    } catch  {
        pageId = pageIdPrefix;
    }
    return pageId;
};

});

parcelRegister("4Exdo", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorGinRedirectEntrypoint", () => $45c50752d19052f1$export$3185a5139b079ec0);

var $cfawy = parcelRequire("cfawy");

var $3rdd7 = parcelRequire("3rdd7");

var $gbQ0u = parcelRequire("gbQ0u");

var $5T6bY = parcelRequire("5T6bY");

const $45c50752d19052f1$export$3185a5139b079ec0 = (0, $3rdd7.createEntryPoint)({
    root: (0, $cfawy.JSResourceForUserVisible)(()=>(parcelRequire("gkRjN")), {
        moduleId: "e648b5f0"
    }),
    getPreloadProps: (entryPointParams)=>{
        const issueKey = entryPointParams?.context?.match?.params?.issueKey;
        return {
            entryPoints: {
                globalIssueNavigatorEntryPoint: {
                    entryPoint: (0, $gbQ0u.globalIssueNavigatorEntryPoint),
                    entryPointParams: entryPointParams
                },
                ...!issueKey ? {
                    nativeIssueTableEntryPoint: {
                        entryPoint: (0, $5T6bY.nativeIssueTableEntryPoint),
                        entryPointParams: entryPointParams
                    }
                } : {}
            }
        };
    }
});

});
parcelRegister("gbQ0u", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorEntryPoint", () => $59bde67e61e4a211$export$79ac0647e40ae809);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $59bde67e61e4a211$export$79ac0647e40ae809 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("a1kns")).then((module)=>module.GlobalIssueNavigatorSPAEntryPoint), {
        moduleId: "90a4c476"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("a1kns", function(module, exports) {

let $74b9cde0b5fecde3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $74b9cde0b5fecde3$var$load("hPzOn"),
    $74b9cde0b5fecde3$var$load("azMOH")
]).then(()=>parcelRequire('iUdxh'));

});


parcelRegister("gkRjN", function(module, exports) {

let $be47df82ef752935$var$load = (parcelRequire("28QjX"))(4);
module.exports = $be47df82ef752935$var$load("fHfKd").then(()=>parcelRequire('5XrRK'));

});




parcelRegister("4nXyN", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorGlobalJiraRouteEntry", () => $a09e1f9770441a11$export$8925c79a030fdfe8);

var $ffza4 = parcelRequire("ffza4");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $fwSmZ = parcelRequire("fwSmZ");

var $1gXMV = parcelRequire("1gXMV");


var $7XYc4 = parcelRequire("7XYc4");

var $8irO5 = parcelRequire("8irO5");

var $96TVI = parcelRequire("96TVI");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $a09e1f9770441a11$export$8925c79a030fdfe8 = (0, $7NszV.createEntry)((0, $fwSmZ.issueNavigatorGlobalJiraRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        // delete "component" when jira_list_gin_entrypoint is cleaned up
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jira_list_gin_entrypoint'), ()=>null, (0, $b8f12.GinRedirect)),
        skeleton: (0, $1gXMV.GlobalIssueNavigatorSkeleton),
        // delete "forPaint" when jira_list_gin_entrypoint is cleaned up
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $b8f12.LazyGlobalIssueNavigator)
        ],
        ufoName: 'global-issue-navigator-jfe',
        navigation: (0, $8irO5.getCommonGlobalNavigation)(),
        resources: [
            ...(0, $96TVI.getCommonGlobalResources)()
        ],
        layout: (0, $2BrOV.globalLayout),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $4R6GH.fg)('jira_list_gin_entrypoint') ? (0, $b8f12.globalIssueNavigatorGinRedirectPageEntryPoint) : undefined
    }));

});
parcelRegister("fwSmZ", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorGlobalJiraRoute", () => $f141385b640afc92$export$286b1d26dcbbce9e);
const $f141385b640afc92$export$286b1d26dcbbce9e = {
    name: 'global-issue-navigator',
    path: '/jira/issues/:issueKey?'
};

});


parcelRegister("jrl3R", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorGlobalRouteEntry", () => $25e6f63d1902d36e$export$3e58fe44312b4093);

var $ffza4 = parcelRequire("ffza4");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $ddy4Q = parcelRequire("ddy4Q");

var $1gXMV = parcelRequire("1gXMV");


var $7XYc4 = parcelRequire("7XYc4");

var $8irO5 = parcelRequire("8irO5");

var $96TVI = parcelRequire("96TVI");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $25e6f63d1902d36e$export$3e58fe44312b4093 = (0, $7NszV.createEntry)((0, $ddy4Q.issueNavigatorGlobalRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        // delete "component" when jira_list_gin_entrypoint is cleaned up
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jira_list_gin_entrypoint'), ()=>null, (0, $b8f12.GinRedirect)),
        skeleton: (0, $1gXMV.GlobalIssueNavigatorSkeleton),
        // delete "forPaint" when jira_list_gin_entrypoint is cleaned up
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $b8f12.LazyGlobalIssueNavigator)
        ],
        ufoName: 'global-issue-navigator-jfe',
        navigation: (0, $8irO5.getCommonGlobalNavigation)(),
        resources: [
            ...(0, $96TVI.getCommonGlobalResources)()
        ],
        layout: (0, $2BrOV.globalLayout),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        isHydrateRootEnabled: (0, $4R6GH.fg)('nin-full-page-hydrate-root'),
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorGlobalRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorGlobalRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-navigator.json'
        },
        entryPoint: ()=>(0, $4R6GH.fg)('jira_list_gin_entrypoint') ? (0, $b8f12.globalIssueNavigatorGinRedirectPageEntryPoint) : undefined
    }));

});
parcelRegister("ddy4Q", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorGlobalRoute", () => $5ec8272afbf68925$export$928d3577bbe9e124);
const $5ec8272afbf68925$export$928d3577bbe9e124 = {
    name: 'global-issue-navigator',
    path: '/issues/:issueKey?'
};

});


parcelRegister("3B53X", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectBusinessRouteEntry", () => $99398975b82221bf$export$ce258b07e4b7eb8c);

var $5f2bR = parcelRequire("5f2bR");

var $4R6GH = parcelRequire("4R6GH");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $eGOUS = parcelRequire("eGOUS");

var $lHYIV = parcelRequire("lHYIV");


var $arJNO = parcelRequire("arJNO");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $99398975b82221bf$export$ce258b07e4b7eb8c = (0, $7NszV.createEntry)((0, $eGOUS.issueNavigatorProjectBusinessRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $lHYIV.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)()
        ],
        layout: (0, $aPfsS.createLayout)((0, $gyYxw.genericProjectLayout)),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $b8f12.issueNavigatorPageEntryPoint)
    }));

});
parcelRegister("eGOUS", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectBusinessRoute", () => $dd2aac8c1b4464da$export$3219766aa1a42d18);
const $dd2aac8c1b4464da$export$3219766aa1a42d18 = {
    name: 'issue-navigator-core',
    path: '/jira/core/projects/:projectKey/issues/:issueKey?'
};

});

parcelRegister("lHYIV", function(module, exports) {

$parcel$export(module.exports, "ProjectIssueNavigatorSkeleton", () => $8afa09f5da2bc6b1$export$112138f5f732a994);
/* project-app.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3HwlS = parcelRequire("3HwlS");

var $hCy6k = parcelRequire("hCy6k");

var $aw9qL = parcelRequire("aw9qL");

var $hDeVo = parcelRequire("hDeVo");
const $8afa09f5da2bc6b1$var$customCssStyles = null;
const $8afa09f5da2bc6b1$export$112138f5f732a994 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, $3HwlS.getWillShowNav4)() ? (0, (/*@__PURE__*/$parcel$interopDefault($aw9qL))) : (0, (/*@__PURE__*/$parcel$interopDefault($hDeVo))),
        className: (0, $bwpsq.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });

});
parcelRegister("aw9qL", function(module, exports) {
module.exports = new URL("project-issue-navigator-nav4-skeleton.tpl.0c4c4250.svg", import.meta.url).toString();

});

parcelRegister("hDeVo", function(module, exports) {
module.exports = new URL("project-issue-navigator-skeleton.tpl.2a1718d8.svg", import.meta.url).toString();

});


parcelRegister("arJNO", function(module, exports) {

$parcel$export(module.exports, "getCommonProjectResources", () => $bb08e11d903a04ff$export$6236a7417086ea8d);

var $4R6GH = parcelRequire("4R6GH");

var $5bkvv = parcelRequire("5bkvv");

var $1b36n = parcelRequire("1b36n");

var $a3OKn = parcelRequire("a3OKn");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $lNicp = parcelRequire("lNicp");

var $bATyw = parcelRequire("bATyw");

var $89kiv = parcelRequire("89kiv");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $gNStA = parcelRequire("gNStA");

var $lAGdd = parcelRequire("lAGdd");
const $bb08e11d903a04ff$export$6236a7417086ea8d = ()=>[
        (0, $89kiv.issueNavigatorRelayResource),
        (0, $89kiv.issueNavigatorFilterRelayResource),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('nin_request_hydrate_query_earlier'), (0, $89kiv.issueNavigatorHydrationRelayResource)),
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $lNicp.getBusinessProjectResources)(),
        (0, $a3OKn.sidebarProjectIssuesResource),
        (0, $bATyw.isNinGlobalScopeEnrolmentEnabledResource),
        // this resource is also used by the nav4 sidebar for JSM project's 'issues and filters'
        // src/packages/navigation-apps/sidebar-nav4/jsm-project-menu/src/ui/project-menu/issues-and-filters/default-filters/index.tsx
        (0, $1b36n.staticSidebarDefaultPINFiltersResource),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('rrr_for_context_panel_data'), (0, $lAGdd.aiContextPanelResource))
    ];

});
parcelRegister("1b36n", function(module, exports) {

$parcel$export(module.exports, "staticSidebarDefaultPINFiltersResource", () => $f0c33588b62c7651$export$d3efe54a881807bf);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $elyZV = parcelRequire("elyZV");
const $f0c33588b62c7651$export$d3efe54a881807bf = (0, $2M1hQ.createResource)({
    type: 'JIRA_PROJECT_DEFAULT_PIN_FILTERS_NAV_DATA',
    getKey: ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        return projectKey || 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        if (projectKey == null) return null;
        return (0, $elyZV.fetchDefaultPINFiltersNavData)(projectKey);
    },
    maxAge: 300000
});

});
parcelRegister("elyZV", function(module, exports) {

$parcel$export(module.exports, "fetchDefaultPINFiltersNavData", () => $88433d457c0f5220$export$268c1bcb44a0ddd3);

var $eusud = parcelRequire("eusud");
const $88433d457c0f5220$var$extractNavIds = (result)=>new Set((result['com.atlassian.jira.jira-projects-issue-navigator:generic-filters'] || []).map((filterNavItem)=>filterNavItem.id));
const $88433d457c0f5220$export$268c1bcb44a0ddd3 = async (projectKey)=>{
    if (projectKey == null) throw new Error('invalid project id or key');
    const result = await (0, $eusud.performGetRequest)(`/rest/filters/1.0/filters?projectKey=${projectKey}`);
    const filterNavIds = $88433d457c0f5220$var$extractNavIds(result);
    return {
        hasMyOpenIssues: filterNavIds.has('myopenissues'),
        hasReportedByMe: filterNavIds.has('reportedbyme'),
        hasAllIssues: filterNavIds.has('allissues'),
        hasAllOpenIssues: filterNavIds.has('allopenissues'),
        hasDoneIssues: filterNavIds.has('doneissues'),
        hasViewedRecently: filterNavIds.has('recentlyviewed'),
        hasCreatedRecently: filterNavIds.has('addedrecently'),
        hasResolvedRecently: filterNavIds.has('resolvedrecently'),
        hasUpdatedRecently: filterNavIds.has('updatedrecently')
    };
};

});


parcelRegister("a3OKn", function(module, exports) {

$parcel$export(module.exports, "sidebarProjectIssuesResource", () => $b491cf2963738bcf$export$be31dd7adcfd2297);

var $ao2h1 = parcelRequire("ao2h1");

var $59JDz = parcelRequire("59JDz");

var $6YG83 = parcelRequire("6YG83");
const $b491cf2963738bcf$export$be31dd7adcfd2297 = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'NAVIGATION_SIDEBAR_STARRED_FILTERS',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $59JDz.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("59JDz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bc7247f574fad09$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f9654d948e0d21eca1746252fbb0b581>>
 * @relayHash 62d616b47f1dfc22a4c3e97140061306
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1063ffb01e7d9700d29f2ab69b528826f756e1e7c6a83a44336b83304ee1aa8e
const $6bc7247f574fad09$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "starredFiltersList_navigationAppsSidebarCommon"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraFilterConnection",
                            "kind": "LinkedField",
                            "name": "favouriteFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "filterId"
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jql"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEditable"
                                                        }
                                                    ],
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1063ffb01e7d9700d29f2ab69b528826f756e1e7c6a83a44336b83304ee1aa8e",
            "metadata": {},
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6bc7247f574fad09$var$node.hash = "86a313b9769c9a6a731e02bed044f4d2";
var $6bc7247f574fad09$export$2e2bcd8739ae039 = $6bc7247f574fad09$var$node;

});




parcelRegister("glkO2", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectClassicRouteEntry", () => $41789f7b84696902$export$88d5f4117ce3d0fb);

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $eL7Ve = parcelRequire("eL7Ve");

var $lHYIV = parcelRequire("lHYIV");

var $5f2bR = parcelRequire("5f2bR");


var $arJNO = parcelRequire("arJNO");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $41789f7b84696902$export$88d5f4117ce3d0fb = (0, $7NszV.createEntry)((0, $eL7Ve.issueNavigatorProjectClassicRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $lHYIV.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $cSD7y.componentWithFG)('make_nav3_sidebar_lazyforpaint', (0, $9s3j1.ForPaintClassicSoftwareProjectSidebar), (0, $9s3j1.default)),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)()
        ],
        layout: (0, $aPfsS.createLayout)((0, $gyYxw.genericProjectLayout)),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        isHydrateRootEnabled: (0, $4R6GH.fg)('nin-full-page-hydrate-root'),
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectClassicRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorProjectClassicRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-navigator.json'
        },
        entryPoint: ()=>(0, $b8f12.issueNavigatorPageEntryPoint)
    }));

});
parcelRegister("eL7Ve", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectClassicRoute", () => $97f612a83fdbbb6d$export$8e7b74b6169d59ca);
const $97f612a83fdbbb6d$export$8e7b74b6169d59ca = {
    name: 'issue-navigator-classic',
    path: '/jira/software/c/projects/:projectKey/issues/:issueKey?'
};

});


parcelRegister("04Vlk", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectServicedeskRouteEntry", () => $20147c9440522c21$export$b779296ccb8ca1a8);

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $1WlLE = parcelRequire("1WlLE");

var $imKA4 = parcelRequire("imKA4");

var $6Z2mh = parcelRequire("6Z2mh");

var $lHYIV = parcelRequire("lHYIV");


var $arJNO = parcelRequire("arJNO");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $20147c9440522c21$export$b779296ccb8ca1a8 = (0, $7NszV.createEntry)((0, $imKA4.issueNavigatorProjectServicedeskRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $lHYIV.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $cSD7y.componentWithFG)('make_nav3_sidebar_lazyforpaint', (0, $h0bZU.ForPaintServicedeskSidebar), (0, $h0bZU.default))
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)(),
            (0, $1WlLE.queuesNavigationItems),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        layout: (0, $6Z2mh.serviceProjectLayout),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $b8f12.issueNavigatorWithoutHorizontalNavPageEntryPoint)
    }));

});
parcelRegister("imKA4", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectServicedeskRoute", () => $708b2863e92ba0fb$export$e3495d64f36ba27c);
const $708b2863e92ba0fb$export$e3495d64f36ba27c = {
    name: 'servicedesk-issues',
    path: '/jira/servicedesk/projects/:projectKey/issues/:issueKey?'
};

});


parcelRegister("flsjf", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectSoftwareRouteEntry", () => $a82ae7782e05cd6a$export$2a50f64378877c9d);

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $5vzYC = parcelRequire("5vzYC");

var $lHYIV = parcelRequire("lHYIV");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");


var $arJNO = parcelRequire("arJNO");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $a82ae7782e05cd6a$export$2a50f64378877c9d = (0, $7NszV.createEntry)((0, $5vzYC.issueNavigatorProjectSoftwareRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $lHYIV.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $cSD7y.componentWithFG)('make_nav3_sidebar_lazyforpaint', (0, $koWFd.ForPaintSoftwareProjectSidebar), (0, $koWFd.default)),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)()
        ],
        layout: (0, $aPfsS.createLayout)((0, $e7bC3.softwareProjectLayoutNoOnboarding)),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $b8f12.issueNavigatorPageEntryPoint)
    }));

});
parcelRegister("5vzYC", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectSoftwareRoute", () => $4a5b2c25740c19d3$export$b8bd410115307d80);
const $4a5b2c25740c19d3$export$b8bd410115307d80 = {
    name: 'software-issue-navigator',
    path: '/jira/software/projects/:projectKey/issues/:issueKey?'
};

});


parcelRegister("4Aamz", function(module, exports) {

$parcel$export(module.exports, "projectIssueNavigatorRouteEntry", () => $1d391d147db0115e$export$d6b778af15db7d3);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $bHhiy = parcelRequire("bHhiy");

var $f9Gea = parcelRequire("f9Gea");

var $lHYIV = parcelRequire("lHYIV");


var $arJNO = parcelRequire("arJNO");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $1d391d147db0115e$export$d6b778af15db7d3 = (0, $7NszV.createEntry)((0, $f9Gea.projectIssueNavigatorRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $lHYIV.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        layout: (0, $aPfsS.createLayout)((0, $gyYxw.genericProjectLayout)),
        entryPoint: ()=>(0, $b8f12.issueNavigatorPinRedirectPageEntryPoint)
    }));

});
parcelRegister("f9Gea", function(module, exports) {

$parcel$export(module.exports, "projectIssueNavigatorRoute", () => $2de97b1bab3baedd$export$126b16ec65343bf);
const $2de97b1bab3baedd$export$126b16ec65343bf = {
    name: 'issue-navigator',
    path: '/projects/:projectKey/issues/:issueKey?'
};

});


parcelRegister("1hbMK", function(module, exports) {

$parcel$export(module.exports, "jiraHomeRouteEntry", () => $056174761f438866$export$578dcb61ac3cb57a);

var $5uXOq = parcelRequire("5uXOq");

var $9ltFw = parcelRequire("9ltFw");

var $ffza4 = parcelRequire("ffza4");

var $3H5ry = parcelRequire("3H5ry");

var $4R6GH = parcelRequire("4R6GH");

var $l9RBL = parcelRequire("l9RBL");

var $gmpjq = parcelRequire("gmpjq");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");


var $bHhiy = parcelRequire("bHhiy");

var $aILzD = parcelRequire("aILzD");

var $gSttA = parcelRequire("gSttA");

var $3RJkv = parcelRequire("3RJkv");

var $dIHnK = parcelRequire("dIHnK");

var $5pSYQ = parcelRequire("5pSYQ");

var $gNStA = parcelRequire("gNStA");

var $7mjY3 = parcelRequire("7mjY3");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $6s1PB = parcelRequire("6s1PB");
const $056174761f438866$var$conditionalPostOfficeJiraYourWorkResource = (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('post_office_ssr_jira_your_work_enabled'), (0, $5pSYQ.postOfficeJiraYourWorkResource));
const $056174761f438866$var$conditionalJiraHomeWorkSuggestionsIsDeveloperResource = (0, $gNStA.resourceWithCondition2)(()=>(0, $6s1PB.expVal)('jira-your-work-work-suggestions-tab-experiment', 'isEnabled', false), (0, $gSttA.jiraHomeWorkSuggestionsIsDeveloperResource));

const $056174761f438866$var$LazyJiraHomePage = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("43wEx"))), {
    moduleId: "./src/packages/spa-apps/jira-home/src/index.tsx"
});
const $056174761f438866$var$checkConsolidationOnRouteDependency = async (dependencies)=>{
    const data = await dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734].promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $3H5ry.checkShouldUseJSM)(data);
};
const $056174761f438866$var$JiraHomeComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $056174761f438866$var$LazyJiraHomePage,
        pageId: "jira-home",
        shouldShowSpinner: false
    });
const $056174761f438866$export$578dcb61ac3cb57a = (0, $7NszV.createEntry)((0, $dIHnK.jiraHomeRoute), ()=>({
        group: 'home',
        ufoName: 'jira-home',
        component: $056174761f438866$var$JiraHomeComponent,
        skeleton: (0, $7mjY3.YourWorkSkeleton),
        layout: (0, $gmpjq.homepageLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $aILzD.jiraHomeResourceWithCache),
            (0, $l9RBL.jiraHomePageRightSidePanelResource),
            $056174761f438866$var$conditionalPostOfficeJiraYourWorkResource,
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $9ltFw.widgetResources).map((resourceCreator)=>resourceCreator($056174761f438866$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ])),
            $056174761f438866$var$conditionalJiraHomeWorkSuggestionsIsDeveloperResource
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $056174761f438866$var$LazyJiraHomePage
        ]
    }));

});
parcelRegister("l9RBL", function(module, exports) {

$parcel$export(module.exports, "jiraHomePageRightSidePanelResource", () => $eed57b2562d325e4$export$9cba342d9ec5384d);

var $ao2h1 = parcelRequire("ao2h1");

var $a4BhB = parcelRequire("a4BhB");

var $jKXj9 = parcelRequire("jKXj9");
const $eed57b2562d325e4$var$isBroadcastWidgetEnabled = ()=>false;
const $eed57b2562d325e4$export$9cba342d9ec5384d = (0, $ao2h1.createRelayResource)({
    type: (0, $jKXj9.JIRA_HOME_PAGE_RIGHT_SIDE_PANEL),
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $a4BhB.default),
            variables: {
                cloudId: tenantContext.cloudId,
                broadcastWidgetEnabled: $eed57b2562d325e4$var$isBroadcastWidgetEnabled()
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("a4BhB", function(module, exports) {

$parcel$export(module.exports, "default", () => $616ef8e6ff77d43c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3d73a7099a9295c02951eb57579b7d93>>
 * @relayHash a7e48eaea1f1087c0622f1648327271d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d1e74aae483d14f57577f9505f3c4efaab555f7aa6ddfb379804496ec3f405f1
const $616ef8e6ff77d43c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "broadcastWidgetEnabled"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_rightSidePanel_RootQuery",
            "selections": [
                {
                    "condition": "broadcastWidgetEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "main_homeBroadcastWidget_Widget"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_rightSidePanel_RootQuery",
            "selections": [
                {
                    "condition": "broadcastWidgetEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "concreteType": "JiraUserBroadcastMessageConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraUserBroadcastMessages",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraUserBroadcastMessageEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraUserBroadcastMessage",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "shouldDisplay"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d1e74aae483d14f57577f9505f3c4efaab555f7aa6ddfb379804496ec3f405f1",
            "metadata": {},
            "name": "main_rightSidePanel_RootQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$616ef8e6ff77d43c$var$node.hash = "174d1e9e3edb60b5684e0806b3d7342e";
var $616ef8e6ff77d43c$export$2e2bcd8739ae039 = $616ef8e6ff77d43c$var$node;

});

parcelRegister("jKXj9", function(module, exports) {

$parcel$export(module.exports, "RIGHT_PANEL_WIDTH", () => $64d3bec226f7ff92$export$750459958906793);
$parcel$export(module.exports, "RIGHT_SIDE_PANEL_EXPERIENCE", () => $64d3bec226f7ff92$export$2eb41e47cfa429b7);
$parcel$export(module.exports, "JIRA_HOME_PAGE_RIGHT_SIDE_PANEL", () => $64d3bec226f7ff92$export$6c783d91630ece21);

var $gwIPs = parcelRequire("gwIPs");
const $64d3bec226f7ff92$export$750459958906793 = (0, $gwIPs.gridSize) * 49;
const $64d3bec226f7ff92$export$2eb41e47cfa429b7 = {
    experience: 'jiraHomeRightSidePanel',
    experienceId: undefined,
    analyticsSource: 'jira-home'
};
const $64d3bec226f7ff92$export$6c783d91630ece21 = 'JIRA_HOME_PAGE_RIGHT_SIDE_PANEL';

});


parcelRegister("aILzD", function(module, exports) {

$parcel$export(module.exports, "jiraHomeResourceWithCache", () => $9f71890db935ba06$export$1da15dc2d924240c);

var $2M1hQ = parcelRequire("2M1hQ");


const $9f71890db935ba06$export$1da15dc2d924240c = (0, $2M1hQ.createResource)({
    type: (0, $dac9c443ac5dd9ad$export$e79da7e0d9d1c1f2),
    getKey: ()=>'jira-home',
    getDataLoader: ()=>(parcelRequire("kH1un")),
    maxAge: Infinity
});

});
const $dac9c443ac5dd9ad$export$e79da7e0d9d1c1f2 = 'JIRA_HOME';

parcelRegister("kH1un", function(module, exports) {

let $f108fa766d5a2294$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f108fa766d5a2294$var$load("7kTIJ").then(()=>parcelRequire('fvAUD'));

});


parcelRegister("gSttA", function(module, exports) {

$parcel$export(module.exports, "jiraHomeWorkSuggestionsIsDeveloperResource", () => $bbd3e0c5dee753c9$export$420b5969a526b86f);

var $ao2h1 = parcelRequire("ao2h1");

var $i7jMq = parcelRequire("i7jMq");

var $ef5Xn = parcelRequire("ef5Xn");

var $4Pf62 = parcelRequire("4Pf62");
const $bbd3e0c5dee753c9$export$420b5969a526b86f = (0, $ao2h1.createRelayResource)({
    type: 'JIRA_HOME_WORK_SUGGESTIONS_IS_DEVELOPER',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $i7jMq.default),
            variables: {
                cloudId: tenantContext.cloudId,
                isSoftwareLicensed: tenantContext.licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_SOFTWARE] && tenantContext.licenseStates?.software === (0, $ef5Xn.LICENSE_STATE_ACTIVE)
            }
        })
});

});
parcelRegister("i7jMq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1a456774fd54599$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9af3482c29caafe3c266b9a94e6bf614>>
 * @relayHash 33a398085fffc1c8c240023b01b17ecb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6531092ed29d33046fe36572f33533c333d5d1c7642ce67bd8f17687b4e69ba1
const $a1a456774fd54599$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isSoftwareLicensed"
        }
    ], v1 = [
        {
            "condition": "isSoftwareLicensed",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "WorkSuggestions",
                    "kind": "LinkedField",
                    "name": "workSuggestions",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "WorkSuggestionsUserProfile",
                            "kind": "LinkedField",
                            "name": "userProfileByCloudId",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "persona"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "JiraHomeWithWorkSuggestionsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "JiraHomeWithWorkSuggestionsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "6531092ed29d33046fe36572f33533c333d5d1c7642ce67bd8f17687b4e69ba1",
            "metadata": {},
            "name": "JiraHomeWithWorkSuggestionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a1a456774fd54599$var$node.hash = "2ffc84c440c4cba253c916b64a96af89";
var $a1a456774fd54599$export$2e2bcd8739ae039 = $a1a456774fd54599$var$node;

});


parcelRegister("7mjY3", function(module, exports) {

$parcel$export(module.exports, "YourWorkSkeleton", () => $305c0c711ea600ba$export$62cf62fa23284b71);
$parcel$export(module.exports, "YourWorkItemListSkeleton", () => $305c0c711ea600ba$export$31cebe1052db844);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $6L7Ws = parcelRequire("6L7Ws");

var $aN3q5 = parcelRequire("aN3q5");
const $305c0c711ea600ba$export$62cf62fa23284b71 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6L7Ws)))
    });
const $305c0c711ea600ba$export$31cebe1052db844 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aN3q5))),
        containerStyles: {
            maxHeight: '30em'
        }
    });

});
parcelRegister("6L7Ws", function(module, exports) {
module.exports = new URL("your-work-app-skeleton.tpl.14d150b5.svg", import.meta.url).toString();

});

parcelRegister("aN3q5", function(module, exports) {
module.exports = new URL("your-work-itemlist-skeleton.tpl.e9027f83.svg", import.meta.url).toString();

});


parcelRegister("43wEx", function(module, exports) {

let $2f40c5637552dc51$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2f40c5637552dc51$var$load("eLhUl").then(()=>parcelRequire('jyj7M'));

});


parcelRegister("c2KPY", function(module, exports) {

$parcel$export(module.exports, "jiraSearchRouteEntry", () => $06085f80d69fe841$export$76b74d5744e69817);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $cg1lV = parcelRequire("cg1lV");

var $7kiuE = parcelRequire("7kiuE");

var $5ZrME = parcelRequire("5ZrME");
const $06085f80d69fe841$export$76b74d5744e69817 = (0, $7NszV.createEntry)((0, $cg1lV.jiraSearchRoute), ()=>({
        group: 'redirects',
        component: (0, $7kiuE.JiraSearchRedirect),
        isRedirect: true,
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $5ZrME.jiraSearchResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("cg1lV", function(module, exports) {

$parcel$export(module.exports, "jiraSearchRoute", () => $e3d75d351326e47a$export$a3a93dcf611b611a);
const $e3d75d351326e47a$export$a3a93dcf611b611a = {
    name: 'jira-search',
    path: '/jira/search',
    exact: true
};

});

parcelRegister("7kiuE", function(module, exports) {

$parcel$export(module.exports, "JiraSearchRedirect", () => $c1df58920245e964$export$ee180957879b33ac);

var $5uXOq = parcelRequire("5uXOq");

var $lb0Dk = parcelRequire("lb0Dk");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");

var $lFlWg = parcelRequire("lFlWg");

var $5ZrME = parcelRequire("5ZrME");
const $c1df58920245e964$export$ee180957879b33ac = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $5ZrME.jiraSearchResource));
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), null);
    if (error || !data?.url) // handle api error state
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lFlWg.QuickSearchToGlobalIssueNavigatorRedirect), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: data.url,
        push: false
    });
};

});
parcelRegister("lFlWg", function(module, exports) {

$parcel$export(module.exports, "QuickSearchToGlobalIssueNavigatorRedirect", () => $2bd6861b4d276506$export$968c2900ae111000);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $bATyw = parcelRequire("bATyw");

var $7tQej = parcelRequire("7tQej");
var $ieDtd = parcelRequire("ieDtd");
var $2YP9W = parcelRequire("2YP9W");
const $2bd6861b4d276506$export$968c2900ae111000 = ({ Redirect: Redirect = (0, $7tQej.Redirect), fireScreenAnalytics: fireScreenAnalytics = (0, $8zOmE.fireScreenAnalytics), useAnalyticsEvents: useAnalyticsEvents = (0, $bngFq.useAnalyticsEvents), useCurrentRoute: useCurrentRoute = (0, $6jY6G.useCurrentRoute), useQueryParam: useQueryParam = (0, $ieDtd.useQueryParam) })=>{
    const route = useCurrentRoute();
    const [searchString] = useQueryParam('searchString');
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    let isNinEnabled;
    if ((0, $4R6GH.fg)('nin-text-fields-new-text-search-field')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ data: isNinEnabled } = (0, $2YP9W.useResource)((0, $bATyw.isNinGlobalScopeEnrolmentEnabledResource)));
    else isNinEnabled = true;
    (0, $5uXOq.useEffect)(()=>{
        if (!route) return;
        const screenEvent = createAnalyticsEvent({
            screenName: 'quickSearchRedirect',
            attributes: {
                type: route.name
            }
        });
        fireScreenAnalytics(screenEvent);
    }, [
        createAnalyticsEvent,
        fireScreenAnalytics,
        route
    ]);
    let jql;
    if (isNinEnabled && (0, $4R6GH.fg)('nin-text-fields-new-text-search-field')) jql = searchString != null ? `textfields ~ "${searchString}"` : 'ORDER BY created DESC';
    else jql = searchString != null ? `text ~ "${searchString}"` : 'order by created DESC';
    const redirectUrl = `/issues/?jql=${encodeURIComponent(jql)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: redirectUrl
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2bd6861b4d276506$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2bd6861b4d276506$export$968c2900ae111000, null);

});

parcelRegister("5ZrME", function(module, exports) {

$parcel$export(module.exports, "jiraSearchResource", () => $c763bb61845622fe$export$d23832be0ebf8a93);

var $ebyGx = parcelRequire("ebyGx");

var $7f4tk = parcelRequire("7f4tk");

var $2M1hQ = parcelRequire("2M1hQ");
const $c763bb61845622fe$export$486bd66a4d919be7 = 'RESOURCE_TYPE_JIRA_SEARCH';
const $c763bb61845622fe$export$d23832be0ebf8a93 = (0, $2M1hQ.createResource)({
    type: $c763bb61845622fe$export$486bd66a4d919be7,
    getKey: ()=>'search',
    getData: ({ query: query }, { tenantContext: tenantContext })=>{
        const { atlassianAccountId: atlassianAccountId } = tenantContext;
        if (!atlassianAccountId || !query?.searchString) return null;
        const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
            searchString: query.searchString
        });
        return (0, $7f4tk.default)(`/rest/navigation/4/quicksearch?${queryStr}`);
    },
    isBrowserOnly: true
});

});



parcelRegister("ghGCX", function(module, exports) {

$parcel$export(module.exports, "legacyRedirectRouteEntry", () => $c46fefae40525649$export$27f123cb9320355);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $7v7WP = parcelRequire("7v7WP");

var $3mK2k = parcelRequire("3mK2k");
// @ts-expect-error - Type '{}' is missing the following properties from type 'Pick<Omit<Omit<RouteContext & { flagService: FlagService; createAnalyticsEvent: (arg1: { action: string; }) => UIAnalyticsEvent; }, keyof WithAnalyticsEventsProps> & RefAttributes<...>, "flagService">, keyof RouteContext | keyof RefAttributes<...>>': query, location, route, match, action
const $c46fefae40525649$var$RedirectComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mK2k.default), null);
const $c46fefae40525649$export$27f123cb9320355 = (0, $7NszV.createEntry)((0, $7v7WP.legacyRedirectRoute), ()=>({
        component: $c46fefae40525649$var$RedirectComponent,
        layout: (0, $2BrOV.globalLayout),
        resources: [],
        isRedirect: true,
        canTransitionIn: ()=>false,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("7v7WP", function(module, exports) {

$parcel$export(module.exports, "legacyRedirectRoute", () => $5ce80937ea4d4231$export$176ff76c3ba7c4ce);
const $5ce80937ea4d4231$export$176ff76c3ba7c4ce = {
    path: '',
    name: 'legacy-redirect',
    exact: false
};

});


parcelRegister("7MpwB", function(module, exports) {

$parcel$export(module.exports, "loginEmbedRouteEntry", () => $cd382e3a47206865$export$faa46f8c5e1f06d3);

var $5uXOq = parcelRequire("5uXOq");

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $hA0Yo = parcelRequire("hA0Yo");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $cd382e3a47206865$var$LazyLoginEmbed = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("fdl6T")), {
    moduleId: "./src/packages/spa-apps/login-embed/src/index.tsx"
});
const $cd382e3a47206865$var$LoginEmbed = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cd382e3a47206865$var$LazyLoginEmbed,
        pageId: "spa-apps/login-embed",
        shouldShowSpinner: true
    });
const $cd382e3a47206865$export$faa46f8c5e1f06d3 = (0, $7NszV.createEntry)((0, $hA0Yo.loginEmbedRoute), ()=>({
        group: 'errors',
        component: $cd382e3a47206865$var$LoginEmbed,
        layout: (0, $6e4Kt.chromelessLayout)
    }));

});
parcelRegister("hA0Yo", function(module, exports) {

$parcel$export(module.exports, "loginEmbedRoute", () => $288f4f9c77816594$export$9efae7a8e8e69866);
const $288f4f9c77816594$export$9efae7a8e8e69866 = {
    name: 'login-embed',
    path: '/jira-login/embed'
};

});

parcelRegister("fdl6T", function(module, exports) {

let $b13871f53050c2a0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b13871f53050c2a0$var$load("bt202").then(()=>parcelRequire('8LbPV'));

});


parcelRegister("lLZ8x", function(module, exports) {

$parcel$export(module.exports, "appRequestsRouteEntry", () => $3506fc2f26a58302$export$423a1c80bb2f8b9a);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $dCM35 = parcelRequire("dCM35");

var $10giJ = parcelRequire("10giJ");
const $3506fc2f26a58302$export$423a1c80bb2f8b9a = (0, $7NszV.createEntry)((0, $dCM35.appRequestsRoute), ()=>({
        group: 'marketplace',
        component: (0, $10giJ.MarketplaceComponent),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $iHiHz.default)
        },
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $10giJ.LazyMarketplace)
        ],
        ufoName: 'embedded-marketplace'
    }));

});
parcelRegister("dCM35", function(module, exports) {

$parcel$export(module.exports, "appRequestsRoute", () => $03b80971c24766dc$export$df12e2a94e0a971b);
const $03b80971c24766dc$export$df12e2a94e0a971b = {
    name: 'marketplace-app-requests',
    path: '/jira/marketplace/manage/app-requests'
};

});

parcelRegister("10giJ", function(module, exports) {

$parcel$export(module.exports, "LazyMarketplace", () => $32349631214f0add$export$5919da4c9ee4707e);
$parcel$export(module.exports, "MarketplaceComponent", () => $32349631214f0add$export$f0d733b7012e9031);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $32349631214f0add$export$5919da4c9ee4707e = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("3VykK"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/marketplace/src/index.tsx"
});
const $32349631214f0add$export$f0d733b7012e9031 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $32349631214f0add$export$5919da4c9ee4707e,
        pageId: "marketplace",
        shouldShowSpinner: true
    });

});
parcelRegister("3VykK", function(module, exports) {

let $2dc153f001a9a860$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2dc153f001a9a860$var$load("h2MrD"),
    $2dc153f001a9a860$var$load("bYT2S"),
    $2dc153f001a9a860$var$load("jfNVT")
]).then(()=>parcelRequire('lA7ML'));

});



parcelRegister("g5rwu", function(module, exports) {

$parcel$export(module.exports, "findAppsRouteEntry", () => $202f2f6ea16fcbde$export$422f564c9c56a4f8);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $8Lquf = parcelRequire("8Lquf");

var $10giJ = parcelRequire("10giJ");
const $202f2f6ea16fcbde$export$422f564c9c56a4f8 = (0, $7NszV.createEntry)((0, $8Lquf.findAppsRoute), ()=>({
        group: 'marketplace',
        component: (0, $10giJ.MarketplaceComponent),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $iHiHz.default)
        },
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $10giJ.LazyMarketplace)
        ],
        ufoName: 'embedded-marketplace'
    }));

});
parcelRegister("8Lquf", function(module, exports) {

$parcel$export(module.exports, "findAppsRoute", () => $a326557081fe34cb$export$e264ef643451c60a);
const $a326557081fe34cb$export$e264ef643451c60a = {
    name: 'marketplace-index',
    path: '/jira/marketplace'
};

});


parcelRegister("1XAMa", function(module, exports) {

$parcel$export(module.exports, "promotionsRouteEntry", () => $2e7db6c4b913404f$export$875d88a44b1ff74c);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $jcvAd = parcelRequire("jcvAd");

var $10giJ = parcelRequire("10giJ");
const $2e7db6c4b913404f$export$875d88a44b1ff74c = (0, $7NszV.createEntry)((0, $jcvAd.promotionsRoute), ()=>({
        group: 'marketplace',
        component: (0, $10giJ.MarketplaceComponent),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $iHiHz.default)
        },
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $10giJ.LazyMarketplace)
        ],
        ufoName: 'embedded-marketplace'
    }));

});
parcelRegister("jcvAd", function(module, exports) {

$parcel$export(module.exports, "promotionsRoute", () => $bc8d892f5d9c1f9e$export$45df65bfacbf9a2a);
const $bc8d892f5d9c1f9e$export$45df65bfacbf9a2a = {
    name: 'marketplace-promotions',
    path: '/jira/marketplace/manage/promotions'
};

});


parcelRegister("1kSIj", function(module, exports) {

$parcel$export(module.exports, "softwareCodeRouteEntry", () => $0271d7bff18c22c8$export$eac18b7aea4cb524);

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $iZ82x = parcelRequire("iZ82x");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $lzTbm = parcelRequire("lzTbm");

var $kfztd = parcelRequire("kfztd");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $cD5C5 = parcelRequire("cD5C5");
const $0271d7bff18c22c8$export$eac18b7aea4cb524 = (0, $7NszV.createEntry)((0, $lzTbm.softwareCodeRoute), ()=>({
        group: 'software',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $cD5C5.CodePageNextGen)),
        layout: (0, $e7bC3.softwareProjectLayoutCode),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $iZ82x.codePageResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cD5C5.LazyCode)
        ],
        ufoName: 'next-gen-code'
    }));

});
parcelRegister("7uLIV", function(module, exports) {

$parcel$export(module.exports, "horizontalNavJiraResource", () => $1769860a1d0fe224$export$faeb8c89315e20da);

var $ao2h1 = parcelRequire("ao2h1");

var $ivm9B = parcelRequire("ivm9B");

var $j5YhT = parcelRequire("j5YhT");

var $1nb22 = parcelRequire("1nb22");

var $3HwlS = parcelRequire("3HwlS");

var $ktofH = parcelRequire("ktofH");

var $gNStA = parcelRequire("gNStA");

var $6YG83 = parcelRequire("6YG83");
const $1769860a1d0fe224$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
    const boardId = match.params.boardId;
    let { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    projectKey = projectKey ?? '';
    projectId = projectId ?? '';
    const projectIdOrKey = projectId || projectKey;
    const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
    const boardAri = boardId ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '';
    const projectAri = projectId ? (0, $j5YhT.JiraProjectAri).create({
        siteId: cloudId,
        projectId: projectId
    }).toString() : '';
    let containerNavigationInput;
    if (isTMPBoardRoute) containerNavigationInput = projectAri ? {
        scopeId: boardAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    else containerNavigationInput = boardAri || projectAri ? {
        scopeId: boardAri || projectAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    return {
        options: {
            fetchPolicy: 'store-and-network'
        },
        parameters: (0, $ivm9B.default),
        variables: {
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey,
            withProject: Boolean(projectIdOrKey),
            boardId: boardAri,
            withBoard: Boolean(boardAri),
            containerNavigationInput: containerNavigationInput,
            isTMPBoardRoute: isTMPBoardRoute,
            first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE)
        }
    };
};
const $1769860a1d0fe224$var$horizontalNavJiraResourceActual = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'HORIZONTAL_NAVIGATION_JIRA_QUERY',
    getQuery: $1769860a1d0fe224$export$71eec30d9db46a56
}));
const $1769860a1d0fe224$export$faeb8c89315e20da = (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)(), $1769860a1d0fe224$var$horizontalNavJiraResourceActual);

});
parcelRegister("ivm9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e7cee9907baeab7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<56fc7389bbece931fcfcec2ebac18209>>
 * @relayHash 5aecbf8ced643dda0fbf2090719a11fd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 39760e4b78a60f61d7048792cfa7feb88268d21339076646ce2f06ff23b00cb9

var $58v9Y = parcelRequire("58v9Y");

var $9pmwJ = parcelRequire("9pmwJ");

var $eiowN = parcelRequire("eiowN");
const $5e7cee9907baeab7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerNavigationInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTMPBoardRoute"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withBoard"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withProject"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "url"
    }, v11 = {
        "kind": "ScalarField",
        "name": "label"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = [
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "name"
    }, v21 = {
        "kind": "ScalarField",
        "name": "boardType"
    }, v22 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JiraHorizontalNavigationContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "input",
                                    "variableName": "containerNavigationInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraContainerNavigationResult"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "first",
                                                    "variableName": "first"
                                                }
                                            ],
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "navigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDefault"
                                                                },
                                                                v10 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "typeKey"
                                                                },
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRename"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRemove"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canSetAsDefault"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraAppSection",
                                                                            "kind": "LinkedField",
                                                                            "name": "sections",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        v12 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "envLabel"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v14 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraNavigationItem",
                                                                            "abstractKey": "__isJiraNavigationItem"
                                                                        }
                                                                    ],
                                                                    "type": "JiraAppNavigationItem"
                                                                },
                                                                v14 /*: any*/ 
                                                            ]
                                                        },
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v15 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeUrl"
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v15 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v18 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "withBoard",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "boardId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraBoard",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "withProject",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "idOrKey",
                                    "variableName": "projectIdOrKey"
                                }
                            ],
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jira_projectByIdOrKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "alias": "canEditProjectConfig",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_PROJECT_CONFIG"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ],
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                v20 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                },
                                v9 /*: any*/ ,
                                {
                                    "condition": "isTMPBoardRoute",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "projectKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "mostRecentlyViewedBoard",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                v17 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLiveTemplate"
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "39760e4b78a60f61d7048792cfa7feb88268d21339076646ce2f06ff23b00cb9",
            "metadata": {},
            "name": "HorizontalNavJiraInnerQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $58v9Y.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": (0, $9pmwJ.default)
            }
        }
    };
}();
$5e7cee9907baeab7$var$node.hash = "cfedd5347d81ca2f36fa810c25c638f4";
(0, $eiowN.PreloadableQueryRegistry).set($5e7cee9907baeab7$var$node.params.id, $5e7cee9907baeab7$var$node);
var $5e7cee9907baeab7$export$2e2bcd8739ae039 = $5e7cee9907baeab7$var$node;

});


parcelRegister("iZ82x", function(module, exports) {

$parcel$export(module.exports, "codePageResource", () => $06e9ff5230710b90$export$642ce64cf3689406);

var $ao2h1 = parcelRequire("ao2h1");

var $euUUL = parcelRequire("euUUL");

var $6mT2K = parcelRequire("6mT2K");

let $06e9ff5230710b90$var$numPullRequestsToFetch = 0;
const $06e9ff5230710b90$export$642ce64cf3689406 = (0, $ao2h1.createRelayResource)({
    type: (0, $96625f88cf395132$export$94a43d2ac55ac375),
    getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId } }) {
        const isCodeRoute = name === 'software-code' || name === 'software-code-classic';
        // Set numPullRequestsToFetch on initial call only and not on every query param change
        if (!$06e9ff5230710b90$var$numPullRequestsToFetch && isCodeRoute) $06e9ff5230710b90$var$numPullRequestsToFetch = (0, $6mT2K.getNumPullRequestsToFetch)(query);
        // Reset numPullRequestsToFetch when navigating away from the code page
        if (!isCodeRoute) $06e9ff5230710b90$var$numPullRequestsToFetch = 0;
        return {
            parameters: (0, $euUUL.default),
            options: {
                fetchPolicy: 'store-and-network'
            },
            variables: {
                cloudId: cloudId,
                projectKey: params.projectKey ?? '',
                pullRequestsUpdatedFrom: (0, $6mT2K.getPullRequestsUpdatedFromDate)(),
                numPullRequestsToFetch: $06e9ff5230710b90$var$numPullRequestsToFetch,
                siteAri: `ari:cloud:jira::site/${cloudId}`
            }
        };
    }
});

});
parcelRegister("euUUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1914e75096664626$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8a05494e8703201736c64b733e2d8d79>>
 * @relayHash 7229d6054fbf6dc991ed67c71a2bbb94
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 99f14cacd1202e4b127705c97bd2f29928e2e9c63ed356ed68528301765da861
const $1914e75096664626$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numPullRequestsToFetch"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pullRequestsUpdatedFrom"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "siteAri"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "siteAri"
        },
        {
            "kind": "Literal",
            "name": "providerTypes",
            "value": [
                "DEV_INFO"
            ]
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "status"
    }, v11 = {
        "concreteType": "JiraConfigStateConnection",
        "kind": "LinkedField",
        "name": "config",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraConfigState",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "appId"
                    },
                    v10 /*: any*/ 
                ]
            }
        ]
    }, v12 = [
        v11 /*: any*/ 
    ], v13 = [
        v7 /*: any*/ 
    ], v14 = [
        {
            "kind": "Literal",
            "name": "appId",
            "value": "bitbucket"
        },
        v8 /*: any*/ 
    ], v15 = [
        v8 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v16 = [
        {
            "kind": "Literal",
            "name": "sort",
            "value": {
                "lastModified": {
                    "direction": "DESC",
                    "priority": 1
                }
            }
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = [
        v11 /*: any*/ ,
        v17 /*: any*/ 
    ], v19 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v20 = {
        "kind": "ScalarField",
        "name": "url"
    }, v21 = [
        v17 /*: any*/ 
    ], v22 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v23 = [
        v7 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "accountId"
        },
        v6 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        v17 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainCodeInJiraUpdatedQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "DevOpsProviders",
                                    "kind": "LinkedField",
                                    "name": "providers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsDevInfoProvider",
                                            "kind": "LinkedField",
                                            "name": "devInfoProviders",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "args": v9 /*: any*/ ,
                                                    "concreteType": "JiraAppConfigState",
                                                    "kind": "LinkedField",
                                                    "name": "configState",
                                                    "plural": false,
                                                    "selections": v12 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOps.providers"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOps"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v9 /*: any*/ ,
                        "concreteType": "CodeInJira",
                        "kind": "LinkedField",
                        "name": "codeInJira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CodeInJiraUserConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CodeInJiraBitbucketWorkspace",
                                                "kind": "LinkedField",
                                                "name": "ownedBitbucketWorkspaces",
                                                "plural": true,
                                                "selections": v13 /*: any*/ 
                                            },
                                            "action": "THROW",
                                            "path": "codeInJira.userConfiguration.ownedBitbucketWorkspaces"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "codeInJira.userConfiguration"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "codeInJira"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraAppConfigState",
                                    "kind": "LinkedField",
                                    "name": "configState",
                                    "plural": false,
                                    "selections": v12 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "args": v15 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                    "kind": "LinkedField",
                                    "name": "repositories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v13 /*: any*/ 
                                        }
                                    ],
                                    "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareCodePage_MainPage"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareCodePage_Header"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareCodePage_ConnectionPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainCodeInJiraUpdatedQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "DevOpsProviders",
                            "kind": "LinkedField",
                            "name": "providers",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsDevInfoProvider",
                                    "kind": "LinkedField",
                                    "name": "devInfoProviders",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "args": v9 /*: any*/ ,
                                            "concreteType": "JiraAppConfigState",
                                            "kind": "LinkedField",
                                            "name": "configState",
                                            "plural": false,
                                            "selections": v18 /*: any*/ 
                                        },
                                        v17 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "homeUrl"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "namespace"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "CodeInJira",
                    "kind": "LinkedField",
                    "name": "codeInJira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CodeInJiraUserConfiguration",
                            "kind": "LinkedField",
                            "name": "userConfiguration",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CodeInJiraBitbucketWorkspace",
                                    "kind": "LinkedField",
                                    "name": "ownedBitbucketWorkspaces",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "uuid"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "slug"
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraAppConfigState",
                                    "kind": "LinkedField",
                                    "name": "configState",
                                    "plural": false,
                                    "selections": v18 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "args": v15 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                    "kind": "LinkedField",
                                    "name": "repositories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "providerId"
                                                                },
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "avatarUrl"
                                                                },
                                                                v20 /*: any*/ 
                                                            ],
                                                            "type": "DevOpsRepository"
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                },
                                v17 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "updatedFrom",
                                                    "variableName": "pullRequestsUpdatedFrom"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filter"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "first",
                                            "variableName": "numPullRequestsToFetch"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "sort",
                                            "value": {
                                                "lastUpdatedSortDirection": "DESC"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "project-associated-pr"
                                        }
                                    ],
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "devOpsEntityRelationships",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v10 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryName"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryId"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "author",
                                                                                    "plural": false,
                                                                                    "selections": v23 /*: any*/ 
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsReviewer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "reviewers",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v23 /*: any*/ 
                                                                                        },
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "approvalStatus"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userId"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "title"
                                                                                },
                                                                                v17 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "commentCount"
                                                                                },
                                                                                v20 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "DevOpsBranchInfo",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "destinationBranch",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "pullRequestInternalId"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryUrl"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "authorId"
                                                                                }
                                                                            ],
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        v22 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "ConfluencePage"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "ConfluenceSpace"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsFeatureFlag"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsOperationsComponentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraAutodevJob"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraConfluenceRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraCustomRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraIssueRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraWebRemoteIssueLink"
                                                                        }
                                                                    ]
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "99f14cacd1202e4b127705c97bd2f29928e2e9c63ed356ed68528301765da861",
            "metadata": {},
            "name": "mainCodeInJiraUpdatedQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1914e75096664626$var$node.hash = "e7b0f6a6904c8a1f0dcd2b6cc16ebe99";
var $1914e75096664626$export$2e2bcd8739ae039 = $1914e75096664626$var$node;

});

parcelRegister("6mT2K", function(module, exports) {

$parcel$export(module.exports, "isBitbucketProvider", () => $e46b745b21c77b2f$export$1f508885be28c4e);
$parcel$export(module.exports, "codeErrorBoundaryAttributes", () => $e46b745b21c77b2f$export$ea10bb8bdf2072e5);
$parcel$export(module.exports, "toSanitizedUrl", () => $e46b745b21c77b2f$export$36fdccbdcd093523);
$parcel$export(module.exports, "useIsOverflowWidth", () => $e46b745b21c77b2f$export$2dcd60313c8d761b);
$parcel$export(module.exports, "getPullRequestsUpdatedFromDate", () => $e46b745b21c77b2f$export$3784bdf6b4807521);
$parcel$export(module.exports, "getNumPullRequestsToFetch", () => $e46b745b21c77b2f$export$a837c7c9c7670570);

var $5uXOq = parcelRequire("5uXOq");

var $5kchp = parcelRequire("5kchp");

var $it1wb = parcelRequire("it1wb");
var $gn1v9 = parcelRequire("gn1v9");

var $eY2eW = parcelRequire("eY2eW");

var $1tSBh = parcelRequire("1tSBh");
const $e46b745b21c77b2f$export$36ebc9cd52c6b517 = (repository)=>repository === (0, $1tSBh.RepositoryTypes).REPO_BITBUCKET;
const $e46b745b21c77b2f$export$1f508885be28c4e = (providerId)=>providerId === (0, $eY2eW.VcsProviderIds).BITBUCKET || providerId === (0, $eY2eW.DataDepotProviderIds).BITBUCKET_PROD || providerId === (0, $eY2eW.DataDepotProviderIds).BITBUCKET_STG;
const $e46b745b21c77b2f$var$shouldCountToReliability = (error)=>{
    const okayErrors = [
        ...(0, $eY2eW.nonCriticalGqlErrors),
        ...(0, $eY2eW.nonReliabilityCriticalErrors)
    ];
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"HTTP status [403] while retrieving Bitbucket repository." | "HTTP status [404] while retrieving Bitbucket repository." | "Failed to retrieve Bitbucket repository because the user wasn't authorized." | "HTTP status [429] while retrieving Bitbucket repository." | "The user does not have 'View Development Tools' permi...'.
    return !okayErrors.includes(error.message);
};
const $e46b745b21c77b2f$export$ea10bb8bdf2072e5 = (error)=>{
    if (error instanceof Error) return {
        countToReliability: $e46b745b21c77b2f$var$shouldCountToReliability(error)
    };
    return {
        countToReliability: true
    };
};
const $e46b745b21c77b2f$export$36fdccbdcd093523 = (url)=>(0, $5kchp.sanitizeUrl)(url);
const $e46b745b21c77b2f$export$2dcd60313c8d761b = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref, callback)=>{
    const [isOverflow, setIsOverflow] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useLayoutEffect)(()=>{
        const { current: current } = ref;
        const trigger = ()=>{
            const hasOverflow = current.scrollWidth > current.clientWidth;
            setIsOverflow(hasOverflow);
            if (callback) callback(hasOverflow);
        };
        if (current) {
            if ('ResizeObserver' in window) new ResizeObserver(trigger).observe(current);
            trigger();
        }
    }, [
        callback,
        ref
    ]);
    return isOverflow;
};
const $e46b745b21c77b2f$export$3784bdf6b4807521 = ()=>(0, $it1wb.default)((0, $gn1v9.default)(new Date(), {
        days: (0, $eY2eW.PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS)
    })).toISOString();
const $e46b745b21c77b2f$export$a837c7c9c7670570 = (queryParams)=>{
    const hasFilterOrSortQueryParam = Object.entries(queryParams).some(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ([key, value])=>(0, $eY2eW.queryParamsToWatch).includes(key) && value !== '');
    return hasFilterOrSortQueryParam ? (0, $eY2eW.MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY) : (0, $eY2eW.PULL_REQUESTS_TABLE_PAGE_SIZE);
};

});
parcelRegister("5kchp", function(module, exports) {
'use strict';
var $3e0858899f98084b$var$invalidPrototcolRegex = /^(%20|\s)*(javascript|data)/im;
var $3e0858899f98084b$var$ctrlCharactersRegex = /[^\x20-\x7E]/gmi;
var $3e0858899f98084b$var$urlSchemeRegex = /^([^:]+):/gm;
var $3e0858899f98084b$var$relativeFirstCharacters = [
    '.',
    '/'
];
function $3e0858899f98084b$var$isRelativeUrl(url) {
    return $3e0858899f98084b$var$relativeFirstCharacters.indexOf(url[0]) > -1;
}
function $3e0858899f98084b$var$sanitizeUrl(url) {
    if (!url) return 'about:blank';
    var urlScheme, urlSchemeParseResults;
    var sanitizedUrl = url.replace($3e0858899f98084b$var$ctrlCharactersRegex, '');
    if ($3e0858899f98084b$var$isRelativeUrl(sanitizedUrl)) return sanitizedUrl;
    urlSchemeParseResults = sanitizedUrl.match($3e0858899f98084b$var$urlSchemeRegex);
    if (!urlSchemeParseResults) return 'about:blank';
    urlScheme = urlSchemeParseResults[0];
    if ($3e0858899f98084b$var$invalidPrototcolRegex.test(urlScheme)) return 'about:blank';
    return sanitizedUrl;
}
module.exports = {
    sanitizeUrl: $3e0858899f98084b$var$sanitizeUrl
};

});

parcelRegister("eY2eW", function(module, exports) {

$parcel$export(module.exports, "nonCriticalGqlErrors", () => $a2f3556545768e94$export$4b1abe4db5ed7515);
$parcel$export(module.exports, "nonReliabilityCriticalErrors", () => $a2f3556545768e94$export$687544614e0812da);
$parcel$export(module.exports, "MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY", () => $a2f3556545768e94$export$f84c6b6609a3dd30);
$parcel$export(module.exports, "PULL_REQUESTS_TABLE_PAGE_SIZE", () => $a2f3556545768e94$export$ea15b38f3901f518);
$parcel$export(module.exports, "PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS", () => $a2f3556545768e94$export$2b8b0a4489f9147b);
$parcel$export(module.exports, "COLLAPSIBLE_REGION_ID", () => $a2f3556545768e94$export$3b8f88133d28aaa6);
$parcel$export(module.exports, "REPOSITORIES_HEADER_ID", () => $a2f3556545768e94$export$256a9f141103f328);
$parcel$export(module.exports, "COLLAPSIBLE_REGION_DESCRIPTION_ID", () => $a2f3556545768e94$export$b0d4e90e40369b80);
$parcel$export(module.exports, "featureIdToHelpMap", () => $a2f3556545768e94$export$1de4eaccc23a8747);
$parcel$export(module.exports, "FILTER_CONTAINER_TEST_ID", () => $a2f3556545768e94$export$5c00a6bedc2037c8);
$parcel$export(module.exports, "NO_RESULTS_CLEAR_FILTERS_BUTTON_TEST_ID", () => $a2f3556545768e94$export$f70ce14ba902adcb);
$parcel$export(module.exports, "PULL_REQUESTS_TABLE_TEST_ID", () => $a2f3556545768e94$export$19381ed4387aa05b);
$parcel$export(module.exports, "PULL_REQUESTS_DYNAMIC_TABLE_TEST_ID", () => $a2f3556545768e94$export$f3e116f999d4c5c1);
$parcel$export(module.exports, "PULL_REQUESTS_EMPTY_STATE_TEST_ID", () => $a2f3556545768e94$export$c28f1cd40ae0394c);
$parcel$export(module.exports, "SUMMARY_CELL_TEST_ID", () => $a2f3556545768e94$export$f69d7aa9c5e17d55);
$parcel$export(module.exports, "SUMMARY_CELL_TITLE_LINK_TEST_ID", () => $a2f3556545768e94$export$4ed9a8a7faf641f);
$parcel$export(module.exports, "SUMMARY_CELL_TARGET_BRANCH_LINK_TEST_ID", () => $a2f3556545768e94$export$c5322e755fd1028d);
$parcel$export(module.exports, "SUMMARY_CELL_REPOSITORY_LINK_TEST_ID", () => $a2f3556545768e94$export$72fcd104fde041d6);
$parcel$export(module.exports, "REVIEWERS_CELL_TEST_ID", () => $a2f3556545768e94$export$d8f600a480a9c2d4);
$parcel$export(module.exports, "STATUS_CELL_TEST_ID", () => $a2f3556545768e94$export$9d9ab707c4e446cc);
$parcel$export(module.exports, "COMMENTS_CELL_TEST_ID", () => $a2f3556545768e94$export$4da3056fdbfaf111);
$parcel$export(module.exports, "LAST_UPDATED_CELL_TEST_ID", () => $a2f3556545768e94$export$e1134688b6a1032);
$parcel$export(module.exports, "PULL_REQUESTS_ERROR_STATE_TEST_ID", () => $a2f3556545768e94$export$143249aa50321d51);
$parcel$export(module.exports, "REPOSITORIES_ERROR_STATE_TEST_ID", () => $a2f3556545768e94$export$a46febdd3fe90de0);
$parcel$export(module.exports, "IMPROVED_SCM_CONFIG_SCREEN_ERROR_TEST_ID", () => $a2f3556545768e94$export$333db4cac7ee017);
$parcel$export(module.exports, "IMPROVE_READY_TO_CONNECT_EMPTY_STATE_TEST_ID", () => $a2f3556545768e94$export$5cbae081959768bd);
$parcel$export(module.exports, "REPOSITORIES_FILTER_BUTTON_TEST_ID", () => $a2f3556545768e94$export$4939c117ba49bc9e);
$parcel$export(module.exports, "AUTHOR_FILTER_BUTTON_TEST_ID", () => $a2f3556545768e94$export$5a92d7579dac6294);
$parcel$export(module.exports, "REVIEWERS_FILTER_BUTTON_TEST_ID", () => $a2f3556545768e94$export$a77ea162c15f0290);
$parcel$export(module.exports, "STATUS_FILTER_BUTTON_TEST_ID", () => $a2f3556545768e94$export$b7477204cae64b46);
$parcel$export(module.exports, "QUERY_PARAM_SUMMARY", () => $a2f3556545768e94$export$39983b6fb040a5eb);
$parcel$export(module.exports, "QUERY_PARAM_AUTHORS", () => $a2f3556545768e94$export$3d96f5f9ccd35be6);
$parcel$export(module.exports, "QUERY_PARAM_REVIEWERS", () => $a2f3556545768e94$export$8a8927c29ab32b10);
$parcel$export(module.exports, "QUERY_PARAM_STATUS", () => $a2f3556545768e94$export$3e8168848b996f7);
$parcel$export(module.exports, "QUERY_PARAM_REPOSITORIES", () => $a2f3556545768e94$export$4adc519ba40b72a6);
$parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", () => $a2f3556545768e94$export$6da773286c35ef41);
$parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", () => $a2f3556545768e94$export$810a1f7ed2facfcb);
$parcel$export(module.exports, "queryParamsToWatch", () => $a2f3556545768e94$export$ba75fb5089c0eb0b);
$parcel$export(module.exports, "VcsProviderIds", () => $a2f3556545768e94$export$7d5c3d28df5f438a);
$parcel$export(module.exports, "DataDepotProviderIds", () => $a2f3556545768e94$export$7912a169c18abe9d);
$parcel$export(module.exports, "FEEDBACK_COLLECTOR_LOCATION", () => $a2f3556545768e94$export$74189cec821240a6);
$parcel$export(module.exports, "eligibleForConfigurationScreenStatuses", () => $a2f3556545768e94$export$3f3fc252f5066c72);
$parcel$export(module.exports, "notEligibleForConfigurationScreenStatuses", () => $a2f3556545768e94$export$9ce5b1bba5f17875);
$parcel$export(module.exports, "CODE_TAB_NAMESPACE", () => $a2f3556545768e94$export$f3873cacb48e85d4);
$parcel$export(module.exports, "LOCAL_STORAGE_GO_TO_DEVELOPMENT_KEY", () => $a2f3556545768e94$export$e9ce282f5e635322);
$parcel$export(module.exports, "CODE_TAB_MIGRATION_ANALYTICS", () => $a2f3556545768e94$export$49902d80a065c2d5);
const $a2f3556545768e94$export$4b1abe4db5ed7515 = [
    'HTTP status [403] while retrieving Bitbucket repository.',
    'HTTP status [404] while retrieving Bitbucket repository.',
    "Failed to retrieve Bitbucket repository because the user wasn't authorized."
];
const $a2f3556545768e94$export$687544614e0812da = [
    'HTTP status [429] while retrieving Bitbucket repository.',
    "The user does not have 'View Development Tools' permission for the Jira project or the project does not exist",
    'The user does not have admin permission for the site, Jira, project or the project does not exist.',
    'Unable to get providers when contacting Jira due to 401 Unauthorized'
];
const $a2f3556545768e94$export$7527a73da794030d = "var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)";
const $a2f3556545768e94$export$2ecfdc24b216c295 = "var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"; // we use  in package.json file, so box-shadow here must be a value, cannot use elevation
const $a2f3556545768e94$export$f84c6b6609a3dd30 = 1000;
const $a2f3556545768e94$export$ea15b38f3901f518 = 12;
const $a2f3556545768e94$export$2b8b0a4489f9147b = 30;
const $a2f3556545768e94$export$3b8f88133d28aaa6 = 'collapsible-repository-list';
const $a2f3556545768e94$export$256a9f141103f328 = 'repository-list-header';
const $a2f3556545768e94$export$b0d4e90e40369b80 = 'repository-list-description';
const $a2f3556545768e94$export$1de4eaccc23a8747 = {
    'repository-list.pull-requests.empty-state': {
        helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
        href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
    },
    'repository-list.pull-requests.description': {
        helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
        href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
    }
};
const $a2f3556545768e94$export$5c00a6bedc2037c8 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.filter-container';
const $a2f3556545768e94$export$f70ce14ba902adcb = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.no-results.clearfiltersbutton';
const $a2f3556545768e94$export$19381ed4387aa05b = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table';
const $a2f3556545768e94$export$f3e116f999d4c5c1 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table.dynamic-table';
const $a2f3556545768e94$export$c28f1cd40ae0394c = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-empty-state';
const $a2f3556545768e94$export$f69d7aa9c5e17d55 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.summary-cell';
const $a2f3556545768e94$export$4ed9a8a7faf641f = `${$a2f3556545768e94$export$f69d7aa9c5e17d55}.title-link`;
const $a2f3556545768e94$export$c5322e755fd1028d = `${$a2f3556545768e94$export$f69d7aa9c5e17d55}.target-branch-link`;
const $a2f3556545768e94$export$72fcd104fde041d6 = `${$a2f3556545768e94$export$f69d7aa9c5e17d55}.repository-link`;
const $a2f3556545768e94$export$d8f600a480a9c2d4 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.reviewers-cell';
const $a2f3556545768e94$export$9d9ab707c4e446cc = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.status-cell';
const $a2f3556545768e94$export$4da3056fdbfaf111 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.comments-cell';
const $a2f3556545768e94$export$e1134688b6a1032 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.last-updated-cell';
const $a2f3556545768e94$export$143249aa50321d51 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-error-state';
const $a2f3556545768e94$export$a46febdd3fe90de0 = 'software-code-page.ui.pages.main-page.repositories.repository-error-state';
const $a2f3556545768e94$export$333db4cac7ee017 = 'software-code-page.ui.pages.improved-configure-step-error-state';
const $a2f3556545768e94$export$5cbae081959768bd = 'software-code-page.ui.pages.ready-to-connect-empty-state-error-state';
const $a2f3556545768e94$export$4939c117ba49bc9e = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.repository-filter.filter-button';
const $a2f3556545768e94$export$5a92d7579dac6294 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.author-filter.filter-button';
const $a2f3556545768e94$export$a77ea162c15f0290 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.reviewers-filter.filter-button';
const $a2f3556545768e94$export$b7477204cae64b46 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.status-filter.filter-button';
const $a2f3556545768e94$export$39983b6fb040a5eb = 'summaryFilter';
const $a2f3556545768e94$export$3d96f5f9ccd35be6 = 'authorsFilter';
const $a2f3556545768e94$export$8a8927c29ab32b10 = 'reviewersFilter';
const $a2f3556545768e94$export$3e8168848b996f7 = 'statusFilter';
const $a2f3556545768e94$export$4adc519ba40b72a6 = 'repositoriesFilter';
const $a2f3556545768e94$export$6da773286c35ef41 = 'sortKey';
const $a2f3556545768e94$export$810a1f7ed2facfcb = 'sortOrder';
const $a2f3556545768e94$export$ba75fb5089c0eb0b = [
    $a2f3556545768e94$export$39983b6fb040a5eb,
    $a2f3556545768e94$export$3d96f5f9ccd35be6,
    $a2f3556545768e94$export$8a8927c29ab32b10,
    $a2f3556545768e94$export$3e8168848b996f7,
    $a2f3556545768e94$export$4adc519ba40b72a6,
    $a2f3556545768e94$export$6da773286c35ef41,
    $a2f3556545768e94$export$810a1f7ed2facfcb
];
const $a2f3556545768e94$export$7d5c3d28df5f438a = {
    BITBUCKET: 'bitbucket'
};
const $a2f3556545768e94$export$7912a169c18abe9d = {
    BITBUCKET_PROD: 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9',
    BITBUCKET_STG: 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N',
    GITHUB_PROD: 'com.github.integration.production',
    GITHUB_STG: 'com.github.integration.staging'
};
const $a2f3556545768e94$export$74189cec821240a6 = 'jsw.code.page.header';
const $a2f3556545768e94$export$3f3fc252f5066c72 = [
    'NOT_CONFIGURED',
    'NOT_SET',
    'PARTIALLY_CONFIGURED'
];
const $a2f3556545768e94$export$9ce5b1bba5f17875 = [
    'CONFIGURED',
    'PROVIDER_ACTION_CONFIGURED',
    'PROVIDER_ACTION_NOT_CONFIGURED'
];
const $a2f3556545768e94$export$f3873cacb48e85d4 = 'jira-software-code-tab';
const $a2f3556545768e94$export$e9ce282f5e635322 = 'clickedGoToDevelopment';
const $a2f3556545768e94$export$49902d80a065c2d5 = 'jiraCodePageMigrationModal';

});

parcelRegister("1tSBh", function(module, exports) {

$parcel$export(module.exports, "numberToTimestamp", () => $dbe340acf3f0dbdc$export$9a7be8324d19a048);
$parcel$export(module.exports, "toProjectAri", () => $dbe340acf3f0dbdc$export$9429718a5f74f761);
$parcel$export(module.exports, "RepositoryTypes", () => $dbe340acf3f0dbdc$export$b5ab924fb433d9ea);
/**
 * Opaque types
 */ const $dbe340acf3f0dbdc$export$9a7be8324d19a048 = (time)=>{
    if (time < 0) throw new Error(`Trying to case invalid number(${time}) to Timestamp opaque type`);
    return time;
};
const $dbe340acf3f0dbdc$export$9429718a5f74f761 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
const $dbe340acf3f0dbdc$export$b5ab924fb433d9ea = {
    REPO_BITBUCKET: 'REPO_BITBUCKET',
    REPO_GITHUB: 'REPO_GITHUB',
    REPO_GITLAB: 'REPO_GITLAB'
};
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $dbe340acf3f0dbdc$var$VcsProviderNamespaces = {
    CLASSIC: 'classic',
    OAUTH: 'oauth',
    BITBUCKET: 'bitbucket'
};

});


const $96625f88cf395132$export$94a43d2ac55ac375 = 'SOFTWARE_CODE';


parcelRegister("lzTbm", function(module, exports) {

$parcel$export(module.exports, "softwareCodeRoute", () => $29efee39c2e259e2$export$9d24fc75b0f1d9a0);
const $29efee39c2e259e2$export$9d24fc75b0f1d9a0 = {
    name: 'software-code',
    path: '/jira/software/projects/:projectKey/code'
};

});

parcelRegister("kfztd", function(module, exports) {

$parcel$export(module.exports, "isDevopsFeatureDisabledInFedRamp", () => $064393a36b21cb6e$export$18bfef4995ec57b7);

var $b4PzF = parcelRequire("b4PzF");
const $064393a36b21cb6e$export$18bfef4995ec57b7 = ()=>(0, $b4PzF.isFedRamp)();

});

parcelRegister("cD5C5", function(module, exports) {

$parcel$export(module.exports, "LazyCode", () => $e02d9e74ba3f4d5c$export$4beafd9dbad29bff);
$parcel$export(module.exports, "CodePageNextGen", () => $e02d9e74ba3f4d5c$export$d9e8184332f86b53);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $bzM7d = parcelRequire("bzM7d");

const $e02d9e74ba3f4d5c$export$4beafd9dbad29bff = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("CEh0a"))), {
    moduleId: "./src/packages/spa-apps/code/src/index.tsx"
});
const $e02d9e74ba3f4d5c$export$d9e8184332f86b53 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e02d9e74ba3f4d5c$export$4beafd9dbad29bff,
        pageId: `next-gen-code-${(0, $bzM7d.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });
const $e02d9e74ba3f4d5c$export$95e2389b7ca7ccf2 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e02d9e74ba3f4d5c$export$4beafd9dbad29bff,
        pageId: `classic-code-${(0, $bzM7d.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("bzM7d", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $8d5a6727ab17b6ba$export$557c2f222778cea6);

var $ebyGx = parcelRequire("ebyGx");
const $8d5a6727ab17b6ba$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search);
    return rapidView;
};

});

parcelRegister("CEh0a", function(module, exports) {

let $0742ca25b9904af0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0742ca25b9904af0$var$load("donBI").then(()=>parcelRequire('6LEOw'));

});



parcelRegister("dBV2a", function(module, exports) {

$parcel$export(module.exports, "softwareNextgenRedirectRouteEntry", () => $8e109be01fe8b384$export$e328d22412aeb5cf);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $i4mNf = parcelRequire("i4mNf");

var $eCjie = parcelRequire("eCjie");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $7tQej = parcelRequire("7tQej");

var $21yN6 = parcelRequire("21yN6");
const $8e109be01fe8b384$var$SoftwareNextgenRedirectComponent = ({ location: location })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: (0, $21yN6.pickNextGenView)(location)
    });
const $8e109be01fe8b384$export$e328d22412aeb5cf = (0, $7NszV.createEntry)((0, $i4mNf.softwareNextgenRedirectRoute), ()=>({
        group: 'software',
        component: $8e109be01fe8b384$var$SoftwareNextgenRedirectComponent,
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eCjie.LazyBoardPage)
        ]
    }));

});
parcelRegister("fKmub", function(module, exports) {

$parcel$export(module.exports, "LazyIssueApp", () => $43c3852afc527b13$export$8c70dcc4643464f8);

var $b7Svb = parcelRequire("b7Svb");

const $43c3852afc527b13$export$8c70dcc4643464f8 = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("7F3Js")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});

});

parcelRegister("i4mNf", function(module, exports) {

$parcel$export(module.exports, "softwareNextgenRedirectRoute", () => $ddb4f261ae7c214b$export$6072946fe7f2d45a);
const $ddb4f261ae7c214b$export$6072946fe7f2d45a = {
    name: 'software-nextgen-redirect',
    path: '/secure/NextGen.jspa'
};

});

parcelRegister("eCjie", function(module, exports) {

$parcel$export(module.exports, "LazyBoardPage", () => $45a027e1703747c2$export$bd9ede4ec384f41d);
$parcel$export(module.exports, "SoftwareBoardComponent", () => $45a027e1703747c2$export$78e6ebf73d7f732b);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $45a027e1703747c2$export$bd9ede4ec384f41d = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4dj4f"))), {
    moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
});
const $45a027e1703747c2$var$getBoardId = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search);
    return rapidView;
};
const $45a027e1703747c2$export$78e6ebf73d7f732b = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $45a027e1703747c2$export$bd9ede4ec384f41d,
        pageId: `next-gen-board-${$45a027e1703747c2$var$getBoardId({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("4dj4f", function(module, exports) {

let $31172ab5acc64024$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $31172ab5acc64024$var$load("eNmuD"),
    $31172ab5acc64024$var$load("h2MrD"),
    $31172ab5acc64024$var$load("bYT2S"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("427Sh"), 4)),
    $31172ab5acc64024$var$load("cM9em"),
    $31172ab5acc64024$var$load("fr9NE"),
    $31172ab5acc64024$var$load("hPzOn"),
    $31172ab5acc64024$var$load("3dc2I")
]).then(()=>parcelRequire('dnhKp'));

});


parcelRegister("21yN6", function(module, exports) {

$parcel$export(module.exports, "pickNextGenView", () => $4ad36038fa160dbe$export$8c47088cd9b527ba);

var $ebyGx = parcelRequire("ebyGx");
const $4ad36038fa160dbe$var$PLAN = 'planning';
const $4ad36038fa160dbe$var$REPORTING = 'reporting';
const $4ad36038fa160dbe$var$REPORTS = 'reports';
const $4ad36038fa160dbe$var$constructUrlForView = (url, view, searchResult)=>{
    if (view.startsWith($4ad36038fa160dbe$var$PLAN)) return `${url}/backlog`;
    if (view.startsWith($4ad36038fa160dbe$var$REPORTING) || view.startsWith($4ad36038fa160dbe$var$REPORTS)) {
        if (searchResult.report) return `${url}/reports/${searchResult.report}`;
        return `${url}/reports`;
    }
    return url;
};
const $4ad36038fa160dbe$var$KNOWN_KEYS = [
    'rapidView',
    'projectKey',
    'view',
    'report'
];
const $4ad36038fa160dbe$var$forwardUnknownQueryParams = (url, queryParams)=>{
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(Object.entries(queryParams).filter(([k])=>!$4ad36038fa160dbe$var$KNOWN_KEYS.includes(k)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((result, [k, v])=>({
            [k]: v,
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result
        }), {}));
    if (query) return `${url}?${query}`;
    return url;
};
const $4ad36038fa160dbe$export$8c47088cd9b527ba = (location)=>{
    const searchResult = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search);
    const url = `/jira/software/projects/${searchResult.projectKey}/boards/${searchResult.rapidView}`;
    if (searchResult.view) return $4ad36038fa160dbe$var$forwardUnknownQueryParams($4ad36038fa160dbe$var$constructUrlForView(url, searchResult.view, searchResult), searchResult);
    return $4ad36038fa160dbe$var$forwardUnknownQueryParams(url, searchResult);
};

});


parcelRegister("ickyX", function(module, exports) {

$parcel$export(module.exports, "softwareReportsBurndownRouteEntry", () => $0b40776c7df01e72$export$c54d6c6781ad5beb);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $89ZnT = parcelRequire("89ZnT");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $bekEk = parcelRequire("bekEk");
const $0b40776c7df01e72$export$c54d6c6781ad5beb = (0, $7NszV.createEntry)((0, $89ZnT.softwareReportsBurndownRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.burndown-chart',
        component: (0, $bekEk.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bekEk.LazyNextGenBurndownReport)
        ]
    }));

});
parcelRegister("89ZnT", function(module, exports) {

$parcel$export(module.exports, "softwareReportsBurndownRoute", () => $07e07ef6a15f8aed$export$e0d8c26cb1430ae4);
const $07e07ef6a15f8aed$export$e0d8c26cb1430ae4 = {
    name: 'software-reports-burndown',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burndown'
};

});

parcelRegister("4GBKo", function(module, exports) {

$parcel$export(module.exports, "getTMPReportsCommonResource", () => $e8677532a1aaea76$export$f234446c23dc22a);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $e8677532a1aaea76$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $e8677532a1aaea76$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});
parcelRegister("48Ij3", function(module, exports) {

$parcel$export(module.exports, "staticSidebarJSWReportsResource", () => $d94d5098764be5f8$export$5910307042ab3f6f);

var $8YTna = parcelRequire("8YTna");

var $2M1hQ = parcelRequire("2M1hQ");

var $7xeIG = parcelRequire("7xeIG");
const $d94d5098764be5f8$export$5910307042ab3f6f = (0, $2M1hQ.createResource)({
    type: 'JIRA_SOFTWARE_REPORTS',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $8YTna.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $8YTna.getBoardId)(match, query);
        if (boardId == null) return null;
        const response = await (0, $7xeIG.fetchJSWReports)(boardId);
        return response?.reports;
    },
    maxAge: 300000
});

});
parcelRegister("7xeIG", function(module, exports) {

$parcel$export(module.exports, "fetchJSWReports", () => $61400f9195fc4c28$export$a93a577d6971da2c);

var $eusud = parcelRequire("eusud");
const $61400f9195fc4c28$export$a93a577d6971da2c = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $eusud.performGetRequest)(`/rest/agile/latest/board/${boardId}/reports`);
};

});


parcelRegister("4Bwc0", function(module, exports) {

$parcel$export(module.exports, "devOpsReportPreconditionResource", () => $5073d432665dfcf8$export$96cb0eae1b3413f4);
$parcel$export(module.exports, "useDevOpsReportPreconditionResource", () => $5073d432665dfcf8$export$e9adc6103e9ed514);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $5073d432665dfcf8$export$96cb0eae1b3413f4 = (0, $2M1hQ.createResource)({
    type: (0, $16165c7eb855363c$export$14c5ce449424c281),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("llYR0")),
    maxAge: 60000
});
const $5073d432665dfcf8$export$e9adc6103e9ed514 = ()=>(0, $2YP9W.useResource)($5073d432665dfcf8$export$96cb0eae1b3413f4);

});
const $16165c7eb855363c$export$14c5ce449424c281 = 'SOFTWARE_CYCLE_TIME_REPORT_PRECONDITION';
const $16165c7eb855363c$export$28dc7a217425f1a9 = 'VIEW_DEV_TOOLS';
const $16165c7eb855363c$export$a03e1c9d464f9477 = 'VIEW_AGGREGATED_DATA';

parcelRegister("llYR0", function(module, exports) {

let $f8bac370a50ce0d2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f8bac370a50ce0d2$var$load("goFaC").then(()=>parcelRequire('5aldt'));

});



parcelRegister("bekEk", function(module, exports) {

$parcel$export(module.exports, "LazyNextGenBurndownReport", () => $51e496184ed5259a$export$10cd1e761434952);
$parcel$export(module.exports, "default", () => $51e496184ed5259a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $bzM7d = parcelRequire("bzM7d");

const $51e496184ed5259a$export$10cd1e761434952 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("3GVHT"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports/burndown/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$51e496184ed5259a$export$2e2bcd8739ae039 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $51e496184ed5259a$export$10cd1e761434952,
        pageId: `next-gen-reports-burndown-${(0, $bzM7d.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("3GVHT", function(module, exports) {

let $2b020ebff089fd7b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2b020ebff089fd7b$var$load("72D8w").then(()=>parcelRequire('68CUZ'));

});



parcelRegister("cQer4", function(module, exports) {

$parcel$export(module.exports, "softwareReportsBurnupRouteEntry", () => $5e67b01b927c6e1e$export$e53193d8a7e7d068);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $hlvYO = parcelRequire("hlvYO");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $c3kjm = parcelRequire("c3kjm");
const $5e67b01b927c6e1e$export$e53193d8a7e7d068 = (0, $7NszV.createEntry)((0, $hlvYO.softwareReportsBurnupRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.burnup-chart',
        component: (0, $c3kjm.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $c3kjm.LazyNextGenBurnupReport)
        ]
    }));

});
parcelRegister("hlvYO", function(module, exports) {

$parcel$export(module.exports, "softwareReportsBurnupRoute", () => $7e7ef0af528823d4$export$5b818a6914ca8376);
const $7e7ef0af528823d4$export$5b818a6914ca8376 = {
    name: 'software-reports-burnup',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burnup'
};

});

parcelRegister("c3kjm", function(module, exports) {

$parcel$export(module.exports, "LazyNextGenBurnupReport", () => $2f0cf451fae61f8d$export$2ae7ab3b633c1d15);
$parcel$export(module.exports, "default", () => $2f0cf451fae61f8d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $bzM7d = parcelRequire("bzM7d");

const $2f0cf451fae61f8d$export$2ae7ab3b633c1d15 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("asGHP"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports/burnup/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2f0cf451fae61f8d$export$2e2bcd8739ae039 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2f0cf451fae61f8d$export$2ae7ab3b633c1d15,
        pageId: `next-gen-reports-burnup-${(0, $bzM7d.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("asGHP", function(module, exports) {

let $79dda56868be6049$var$load = (parcelRequire("28QjX"))(4);
module.exports = $79dda56868be6049$var$load("7R4iz").then(()=>parcelRequire('e2Cll'));

});



parcelRegister("eL5iv", function(module, exports) {

$parcel$export(module.exports, "softwareReportsControlRouteEntry", () => $c03e5ec50f5b41d2$export$3cb9570ca242f2a2);

var $e4eHl = parcelRequire("e4eHl");

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $cSD7y = parcelRequire("cSD7y");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $dL9sv = parcelRequire("dL9sv");

var $kfztd = parcelRequire("kfztd");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $9XjvH = parcelRequire("9XjvH");
const $c03e5ec50f5b41d2$export$3cb9570ca242f2a2 = (0, $7NszV.createEntry)((0, $dL9sv.softwareReportsControlRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.control-chart',
        component: (0, $cSD7y.componentWithFG)('jsw_enable_avp_control_chart', (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $9XjvH.ControlPage)), (0, $5lsNZ.default)),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9XjvH.LazyNextGenControlReport)
        ],
        meta: {
            reporting: {
                id: 'software-reports-control',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-control'),
                teamName: 'helios-reports'
            }
        }
    }));

});
parcelRegister("dL9sv", function(module, exports) {

$parcel$export(module.exports, "softwareReportsControlRoute", () => $5f561127b557eb0e$export$8c91815cd4b1c078);
const $5f561127b557eb0e$export$8c91815cd4b1c078 = {
    name: 'software-reports-control',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/control'
};

});

parcelRegister("9XjvH", function(module, exports) {

$parcel$export(module.exports, "LazyNextGenControlReport", () => $a8fc70484e9dc624$export$3b0b331107fce76);
$parcel$export(module.exports, "ControlPage", () => $a8fc70484e9dc624$export$90d0561918744b3b);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $a8fc70484e9dc624$export$3b0b331107fce76 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gKS6p"))), {
    moduleId: "./src/packages/spa-apps/control-report/src/index.tsx"
});
const $a8fc70484e9dc624$export$90d0561918744b3b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a8fc70484e9dc624$export$3b0b331107fce76,
        pageId: "controlReportNextGen",
        shouldShowSpinner: true
    });

});
parcelRegister("gKS6p", function(module, exports) {

let $c32ae8d57f06e38d$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $c32ae8d57f06e38d$var$load("h2MrD"),
    $c32ae8d57f06e38d$var$load("bYT2S"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("jdpLP"), 4)),
    $c32ae8d57f06e38d$var$load("gTfme")
]).then(()=>parcelRequire('gcELT'));

});



parcelRegister("7MlOX", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCumulativeRouteEntry", () => $940a759ddc17038b$export$7ace4d0363d78b41);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $7QybL = parcelRequire("7QybL");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $5v1XH = parcelRequire("5v1XH");
const $940a759ddc17038b$export$7ace4d0363d78b41 = (0, $7NszV.createEntry)((0, $7QybL.softwareReportsCumulativeRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.cumulative-flow-diagram',
        component: (0, $5v1XH.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5v1XH.LazyNextGenCumulativeReport)
        ]
    }));

});
parcelRegister("7QybL", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCumulativeRoute", () => $63045e7bbaab9903$export$3c48ddd40d00b0d2);
const $63045e7bbaab9903$export$3c48ddd40d00b0d2 = {
    name: 'software-reports-cumulative',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cumulative'
};

});

parcelRegister("5v1XH", function(module, exports) {

$parcel$export(module.exports, "LazyNextGenCumulativeReport", () => $d11158d5657ed65b$export$c588973e5bd18a8d);
$parcel$export(module.exports, "default", () => $d11158d5657ed65b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $bzM7d = parcelRequire("bzM7d");

const $d11158d5657ed65b$export$c588973e5bd18a8d = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lw1yN"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports/cumulative/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d11158d5657ed65b$export$2e2bcd8739ae039 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d11158d5657ed65b$export$c588973e5bd18a8d,
        pageId: `next-gen-reports-cumulative-${(0, $bzM7d.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("lw1yN", function(module, exports) {

let $fa9dcbf2427ff49c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fa9dcbf2427ff49c$var$load("8KQmP").then(()=>parcelRequire('ejLY3'));

});



parcelRegister("jK6bT", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeRouteEntry", () => $80a71bce0783e42d$export$8aee4b14556485d5);

var $e4eHl = parcelRequire("e4eHl");

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $2GkDw = parcelRequire("2GkDw");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $iftoH = parcelRequire("iftoH");

var $kfztd = parcelRequire("kfztd");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $g0ZNl = parcelRequire("g0ZNl");
const $80a71bce0783e42d$export$8aee4b14556485d5 = (0, $7NszV.createEntry)((0, $iftoH.softwareReportsCycleTimeRoute), ()=>({
        group: 'software',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $g0ZNl.CycleTimeReportNextGen)),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)(),
            (0, $2GkDw.devOpsProviderResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $g0ZNl.LazyCycleTimeReport)
        ],
        meta: {
            reporting: {
                id: 'software-reports-cycle-time',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-cycle-time'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("2GkDw", function(module, exports) {

$parcel$export(module.exports, "devOpsProviderResource", () => $3640b01f63c1fd17$export$19e58e21b24ae0d8);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $3640b01f63c1fd17$export$19e58e21b24ae0d8 = (0, $2M1hQ.createResource)({
    type: (0, $e9cf201ab81d4288$export$5f92e516f4b78544),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("bFHux")),
    maxAge: 60000
});
const $3640b01f63c1fd17$export$b80f5852c41a5ca8 = ()=>(0, $2YP9W.useResource)($3640b01f63c1fd17$export$19e58e21b24ae0d8);

});
const $e9cf201ab81d4288$export$5f92e516f4b78544 = 'SOFTWARE_DEVOPS_PROVIDERS';
const $e9cf201ab81d4288$export$d7f081d6dd0e72fc = 'bitbucket';
const $e9cf201ab81d4288$export$832d1d859726f915 = 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9';
const $e9cf201ab81d4288$export$5007979ef33118fc = 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N';

parcelRegister("bFHux", function(module, exports) {

let $87f542943d589556$var$load = (parcelRequire("28QjX"))(4);
module.exports = $87f542943d589556$var$load("7G5IV").then(()=>parcelRequire('2MQ7j'));

});


parcelRegister("iftoH", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeRoute", () => $36696e97e70723ad$export$c777bb8f2591081);
const $36696e97e70723ad$export$c777bb8f2591081 = {
    name: 'software-reports-cycle-time',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cycle-time'
};

});

parcelRegister("g0ZNl", function(module, exports) {

$parcel$export(module.exports, "LazyCycleTimeReport", () => $494bd3c8d60b6ff9$export$956f830ed027f1fb);
$parcel$export(module.exports, "CycleTimeReportNextGen", () => $494bd3c8d60b6ff9$export$e16ce0656a74a015);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $494bd3c8d60b6ff9$export$956f830ed027f1fb = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("3yswC")), {
    moduleId: "./src/packages/spa-apps/cycle-time-report/src/index.tsx"
});
const $494bd3c8d60b6ff9$export$e16ce0656a74a015 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $494bd3c8d60b6ff9$export$956f830ed027f1fb,
        pageId: "cycleTimeReportNextGen",
        shouldShowSpinner: true
    });
const $494bd3c8d60b6ff9$export$237924ba64065cc3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $494bd3c8d60b6ff9$export$956f830ed027f1fb,
        pageId: "cycleTimeReportClassic",
        shouldShowSpinner: true
    });

});
parcelRegister("3yswC", function(module, exports) {

let $296aac97230a4791$var$load = (parcelRequire("28QjX"))(4);
module.exports = $296aac97230a4791$var$load("6uzq3").then(()=>parcelRequire('iX103'));

});



parcelRegister("hvbE3", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyRouteEntry", () => $9fed6c189f0eedfa$export$c87b25c0997e584d);

var $e4eHl = parcelRequire("e4eHl");

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $2GkDw = parcelRequire("2GkDw");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $avQc9 = parcelRequire("avQc9");

var $kfztd = parcelRequire("kfztd");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $eSx59 = parcelRequire("eSx59");
const $9fed6c189f0eedfa$export$c87b25c0997e584d = (0, $7NszV.createEntry)((0, $avQc9.softwareReportsDeploymentFrequencyRoute), ()=>({
        group: 'software',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $eSx59.DeploymentFrequencyReportNextGen)),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)(),
            (0, $2GkDw.devOpsProviderResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eSx59.LazyDeploymentFrequencyReport)
        ],
        meta: {
            reporting: {
                id: 'software-reports-deployment-frequency',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-deployment-frequency'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("avQc9", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyRoute", () => $b876fc8448289e46$export$bbf45ab0423b990);
const $b876fc8448289e46$export$bbf45ab0423b990 = {
    name: 'software-reports-deployment-frequency',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/deployment-frequency'
};

});

parcelRegister("eSx59", function(module, exports) {

$parcel$export(module.exports, "LazyDeploymentFrequencyReport", () => $2f62bb5293f966a6$export$5113b2b19ec1fb53);
$parcel$export(module.exports, "DeploymentFrequencyReportNextGen", () => $2f62bb5293f966a6$export$e2db9c7426cdb53);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $2f62bb5293f966a6$export$5113b2b19ec1fb53 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("dgHVZ")), {
    moduleId: "./src/packages/spa-apps/deployment-frequency-report/src/index.tsx"
});
const $2f62bb5293f966a6$export$e2db9c7426cdb53 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2f62bb5293f966a6$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportNextGen",
        shouldShowSpinner: true
    });
const $2f62bb5293f966a6$export$655707e8ae1053d3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2f62bb5293f966a6$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportClassic",
        shouldShowSpinner: true
    });

});
parcelRegister("dgHVZ", function(module, exports) {

let $9a8ed971678d5f8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9a8ed971678d5f8b$var$load("1pebU").then(()=>parcelRequire('6pwND'));

});



parcelRegister("glwG4", function(module, exports) {

$parcel$export(module.exports, "softwareReportsRouteEntry", () => $e48b30544edfb83d$export$2eee2f4f773d5b1f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $gTLbY = parcelRequire("gTLbY");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $kgB1V = parcelRequire("kgB1V");
const $e48b30544edfb83d$export$2eee2f4f773d5b1f = (0, $7NszV.createEntry)((0, $gTLbY.softwareReportsRoute), ()=>({
        group: 'software',
        component: (0, $kgB1V.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kgB1V.LazyNextGenReportsOverview)
        ],
        ufoName: 'software-reports.overview'
    }));

});
parcelRegister("gTLbY", function(module, exports) {

$parcel$export(module.exports, "softwareReportsRoute", () => $ccee26b223b96f27$export$5bf75a5d8c554930);
const $ccee26b223b96f27$export$5bf75a5d8c554930 = {
    name: 'software-reports',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports'
};

});

parcelRegister("kgB1V", function(module, exports) {

$parcel$export(module.exports, "LazyNextGenReportsOverview", () => $5b9a94bde6be5ad0$export$dbd12c5c20c26961);
$parcel$export(module.exports, "default", () => $5b9a94bde6be5ad0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $bzM7d = parcelRequire("bzM7d");

const $5b9a94bde6be5ad0$export$dbd12c5c20c26961 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("74dLn"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports/overview/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5b9a94bde6be5ad0$export$2e2bcd8739ae039 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $5b9a94bde6be5ad0$export$dbd12c5c20c26961,
        pageId: `next-gen-reports-overview-${(0, $bzM7d.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("74dLn", function(module, exports) {

let $5253952ffc87c6cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5253952ffc87c6cf$var$load("6EDMQ").then(()=>parcelRequire('iZwfI'));

});



parcelRegister("lcFGc", function(module, exports) {

$parcel$export(module.exports, "softwareReportsVelocityRouteEntry", () => $c4602ac6f12b6703$export$7d814f4300d0e318);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $hui9h = parcelRequire("hui9h");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $jD7nj = parcelRequire("jD7nj");
const $c4602ac6f12b6703$export$7d814f4300d0e318 = (0, $7NszV.createEntry)((0, $hui9h.softwareReportsVelocityRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.velocity-report',
        component: (0, $jD7nj.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jD7nj.LazyNextGenVelocityReport)
        ]
    }));

});
parcelRegister("hui9h", function(module, exports) {

$parcel$export(module.exports, "softwareReportsVelocityRoute", () => $e44f6dc6707a4fed$export$cde83a6497756848);
const $e44f6dc6707a4fed$export$cde83a6497756848 = {
    name: 'software-reports-velocity',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/velocity'
};

});

parcelRegister("jD7nj", function(module, exports) {

$parcel$export(module.exports, "LazyNextGenVelocityReport", () => $e8c07d5c9da9c49a$export$a2ca519c668b2f72);
$parcel$export(module.exports, "default", () => $e8c07d5c9da9c49a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $bzM7d = parcelRequire("bzM7d");

const $e8c07d5c9da9c49a$export$a2ca519c668b2f72 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kpBKY"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports/velocity/src/index-old.tsx"
});
var /** @deprecated delete file after all usages have been migrated to use entry points */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$e8c07d5c9da9c49a$export$2e2bcd8739ae039 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e8c07d5c9da9c49a$export$a2ca519c668b2f72,
        pageId: `next-gen-reports-velocity-${(0, $bzM7d.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("kpBKY", function(module, exports) {

let $edc36e1e227a0444$var$load = (parcelRequire("28QjX"))(4);
module.exports = $edc36e1e227a0444$var$load("lI5SH").then(()=>parcelRequire('fRLfA'));

});



parcelRegister("056cU", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapRedirectRouteEntry", () => $ea7885e348916216$export$4180bde2c4464aed);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $ffza4 = parcelRequire("ffza4");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $itBA5 = parcelRequire("itBA5");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $7tQej = parcelRequire("7tQej");

var $kotYl = parcelRequire("kotYl");
const $ea7885e348916216$var$SoftwareTimelineLegacyRedirect = ({ query: query })=>{
    const { projectKey: projectKey, rapidView: rapidView, ...restQuery } = query;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: {
            pathname: `/jira/software/projects/${projectKey}/boards/${rapidView}/timeline`,
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(restQuery)
        }
    });
};
const $ea7885e348916216$export$4180bde2c4464aed = (0, $7NszV.createEntry)((0, $itBA5.softwareRoadmapRedirectRoute), ()=>({
        group: 'software',
        component: $ea7885e348916216$var$SoftwareTimelineLegacyRedirect,
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kotYl.LazyNextGenRoadmap)
        ]
    }));

});
parcelRegister("itBA5", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapRedirectRoute", () => $e9307309e9fea835$export$866215abd09c0f4d);
const $e9307309e9fea835$export$866215abd09c0f4d = {
    name: 'software-roadmap-redirect',
    path: '/secure/Roadmap.jspa'
};

});

parcelRegister("kotYl", function(module, exports) {

$parcel$export(module.exports, "LazyNextGenRoadmap", () => $fadca415ac9d888e$export$1339c847cf4ab57);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $fadca415ac9d888e$export$1339c847cf4ab57 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("emv4G"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fadca415ac9d888e$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $fadca415ac9d888e$export$1339c847cf4ab57,
        pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });

});
parcelRegister("emv4G", function(module, exports) {

let $a74b397f5856cd3f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a74b397f5856cd3f$var$load("7pA40").then(()=>parcelRequire('9ImcE'));

});



parcelRegister("6p9ik", function(module, exports) {

$parcel$export(module.exports, "opsgenieScheduleRedirectRouteEntry", () => $330664ff34aced93$export$75f0bcae97d54ba0);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $gr6ab = parcelRequire("gr6ab");

var $fyMYi = parcelRequire("fyMYi");
const $330664ff34aced93$export$75f0bcae97d54ba0 = (0, $7NszV.createEntry)((0, $gr6ab.opsgenieScheduleRedirectRoute), ()=>({
        group: 'components',
        component: !false ? (0, $fyMYi.OpsgenieScheduleRedirect) : (0, $fyMYi.default),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fyMYi.LazyOpsGenieSchedule)
        ],
        isRedirect: true
    }));

});
parcelRegister("gr6ab", function(module, exports) {

$parcel$export(module.exports, "opsgenieScheduleRedirectRoute", () => $65ae7cc3298d4e34$export$5d29dbb36868dff4);
const $65ae7cc3298d4e34$export$5d29dbb36868dff4 = {
    name: 'opsgenie-schedule-redirect',
    path: '/projects/:projectKey',
    query: [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:opsgenie-schedule-page'
    ]
};

});

parcelRegister("fyMYi", function(module, exports) {

$parcel$export(module.exports, "LazyOpsGenieSchedule", () => $aa55fbc557add2b7$export$3a9c3ff70731bdd6);
$parcel$export(module.exports, "OpsgenieScheduleRedirect", () => $aa55fbc557add2b7$export$6ffd640c3062d976);
$parcel$export(module.exports, "default", () => $aa55fbc557add2b7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $dRTnK = parcelRequire("dRTnK");

const $aa55fbc557add2b7$export$3a9c3ff70731bdd6 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("bebVz"))), {
    moduleId: "./src/packages/spa-apps/project/opsgenie-schedule/src/index.tsx"
});
const $aa55fbc557add2b7$export$6ffd640c3062d976 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dRTnK.RedirectToProjectType), {
        page: "/on-call-schedule"
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$aa55fbc557add2b7$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $aa55fbc557add2b7$export$3a9c3ff70731bdd6,
        pageId: "opsgenie-schedule",
        shouldShowSpinner: true
    });

});
parcelRegister("dRTnK", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $f4de23917d090f8e$export$8a3df560509448b8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $dxCvy = parcelRequire("dxCvy");

var $bVDE5 = parcelRequire("bVDE5");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");
const $f4de23917d090f8e$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $7tQej.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $bngFq.useAnalyticsEvents), useResource: useResource = (0, $2YP9W.useResource), useRouter: useRouter = (0, $doZTA.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $bVDE5.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $dxCvy.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
    (0, $5uXOq.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $2vSU6.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $2vSU6.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});

parcelRegister("bebVz", function(module, exports) {

let $82ca410e94556f70$var$load = (parcelRequire("28QjX"))(4);
module.exports = $82ca410e94556f70$var$load("bVWcI").then(()=>parcelRequire('dz9Sq'));

});



parcelRegister("SvIen", function(module, exports) {

$parcel$export(module.exports, "opsgenieScheduleRouteEntry", () => $54b4aa3079c12c39$export$f128c1c4a1f0d631);

var $e4eHl = parcelRequire("e4eHl");

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $lco6K = parcelRequire("lco6K");

var $kfztd = parcelRequire("kfztd");

var $5f2bR = parcelRequire("5f2bR");

var $fyMYi = parcelRequire("fyMYi");
const $54b4aa3079c12c39$export$f128c1c4a1f0d631 = (0, $7NszV.createEntry)((0, $lco6K.opsgenieScheduleRoute), ()=>({
        group: 'components',
        ufoName: 'project-opsgenie-schedule',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $fyMYi.default)),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: [
                (0, $koWFd.default),
                (0, $9s3j1.default)
            ],
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fyMYi.LazyOpsGenieSchedule)
        ],
        meta: {
            reporting: {
                id: 'opsgenie-schedule',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('opsgenie-schedule'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("lco6K", function(module, exports) {

$parcel$export(module.exports, "opsgenieScheduleRoute", () => $3d5ce45adc18efc0$export$534a7ac096cb1da2);
const $3d5ce45adc18efc0$export$534a7ac096cb1da2 = {
    name: 'opsgenie-schedule',
    path: '/jira/:projectType(software|software/c)/projects/:projectKey/on-call-schedule'
};

});


parcelRegister("frn0U", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesRouteEntry", () => $ec3623cf53188008$export$219b6cc00b2f91a0);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $2BrOV = parcelRequire("2BrOV");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $5UHoB = parcelRequire("5UHoB");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $fDWVs = parcelRequire("fDWVs");

var $6Z2mh = parcelRequire("6Z2mh");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $7HAuv = parcelRequire("7HAuv");

var $b7Svb = parcelRequire("b7Svb");

/** @deprecated delete component on FG clean up 'fun_1618_migrate_people_index_to_entrypoints' */ // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ec3623cf53188008$var$LazyPeopleProfiles = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("loJWs"))), {
    // becasue `@atlassian/ptc-embeddable-directory` package is not ready for SSR
    ssr: false,
    moduleId: "./src/packages/spa-apps/people-profiles/src/index-old.tsx"
});
/** @deprecated delete component on FG clean up 'fun_1618_migrate_people_index_to_entrypoints' */ const $ec3623cf53188008$var$PeopleProfilesComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ec3623cf53188008$var$LazyPeopleProfiles,
        pageId: "people-profiles",
        shouldShowSpinner: true
    });
const $ec3623cf53188008$var$peopleProfilesPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7HAuv.peopleProfilesEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PEOPLE
});
const $ec3623cf53188008$export$219b6cc00b2f91a0 = (0, $7NszV.createEntry)((0, $fDWVs.peopleProfilesRoute), ()=>({
        group: 'people-profiles',
        component: (0, $4R6GH.fg)('fun_1618_migrate_people_index_to_entrypoints') ? undefined : $ec3623cf53188008$var$PeopleProfilesComponent,
        layout: (0, $5UHoB.layoutWithCondition)(()=>(0, $6s1PB.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation'), (0, $6Z2mh.rightSidebarsLayout), (0, $2BrOV.globalLayout)),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: (0, $4R6GH.fg)('fun_1618_migrate_people_index_to_entrypoints') ? undefined : [
            (0, $ffza4.LazyAtlassianNavigation),
            $ec3623cf53188008$var$LazyPeopleProfiles
        ],
        ufoName: 'people-profiles',
        entryPoint: ()=>(0, $4R6GH.fg)('fun_1618_migrate_people_index_to_entrypoints') ? $ec3623cf53188008$var$peopleProfilesPageEntrypoint : undefined
    }));

});
parcelRegister("5UHoB", function(module, exports) {

$parcel$export(module.exports, "layoutWithCondition", () => $201222bac9c3aac5$export$c5db53e93ba35c0f);
const $201222bac9c3aac5$export$c5db53e93ba35c0f = (conditionGetter, itemTrue, itemFalse)=>({
        get isChromeless () {
            return conditionGetter() ? itemTrue.isChromeless : itemFalse.isChromeless;
        },
        get globalComponents () {
            return conditionGetter() ? itemTrue.globalComponents : itemFalse.globalComponents;
        },
        get rightSidebars () {
            return conditionGetter() ? itemTrue.rightSidebars : itemFalse.rightSidebars;
        }
    });

});

parcelRegister("fDWVs", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesRoute", () => $44b234ae71647fd2$export$1338132568be849);
const $44b234ae71647fd2$export$1338132568be849 = {
    name: 'people-index',
    path: '/jira/people/:subPath?'
};

});

parcelRegister("7HAuv", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesEntrypoint", () => $4e67e105bb4b4bfb$export$26daeb77c71acf79);

var $cfawy = parcelRequire("cfawy");

var $3rdd7 = parcelRequire("3rdd7");

const $4e67e105bb4b4bfb$export$26daeb77c71acf79 = (0, $3rdd7.createEntryPoint)({
    root: (0, $cfawy.JSResourceForUserVisible)(()=>(parcelRequire("MM4Zf")), {
        moduleId: "871dfc54"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("MM4Zf", function(module, exports) {

let $0929c762317937e4$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0929c762317937e4$var$load("eNmuD"),
    $0929c762317937e4$var$load("kfXhT"),
    $0929c762317937e4$var$load("2Lfdl"),
    $0929c762317937e4$var$load("dsiAd"),
    $0929c762317937e4$var$load("2vt1O")
]).then(()=>parcelRequire('3sora'));

});


parcelRegister("loJWs", function(module, exports) {

let $f93f79f1a39d264d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f93f79f1a39d264d$var$load("eNmuD"),
    $f93f79f1a39d264d$var$load("kfXhT"),
    $f93f79f1a39d264d$var$load("2Lfdl"),
    $f93f79f1a39d264d$var$load("dsiAd"),
    $f93f79f1a39d264d$var$load("8OEzn")
]).then(()=>parcelRequire('eE6Hn'));

});


parcelRegister("fH16o", function(module, exports) {

$parcel$export(module.exports, "generalPersonalSettingsRouteEntry", () => $c84e53d16eb519d5$export$e8b7e9281fc3db35);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $cRWZh = parcelRequire("cRWZh");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $7ziML = parcelRequire("7ziML");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $4XFHO = parcelRequire("4XFHO");

const $c84e53d16eb519d5$var$LazyGeneralPersonalSettings = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("bYYd6"))), {
    moduleId: "./src/packages/spa-apps/personal-settings/general/src/index.tsx"
});
const $c84e53d16eb519d5$var$GeneralPersonalSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c84e53d16eb519d5$var$LazyGeneralPersonalSettings,
        pageId: "personal-settings-general",
        shouldShowSpinner: true
    });
const $c84e53d16eb519d5$export$e8b7e9281fc3db35 = (0, $7NszV.createEntry)((0, $7ziML.generalPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: $c84e53d16eb519d5$var$GeneralPersonalSettingsComponent,
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROFILE,
            sidebar: (0, $cRWZh.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $4XFHO.getLabsResources)(),
            ...(0, $5bkvv.getNavigationForgePersonalSettingsPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $c84e53d16eb519d5$var$LazyGeneralPersonalSettings
        ]
    }));

});
parcelRegister("7ziML", function(module, exports) {

$parcel$export(module.exports, "generalPersonalSettingsRoute", () => $bac161cf2450c76e$export$7a6c9715a86f906b);
const $bac161cf2450c76e$export$7a6c9715a86f906b = {
    name: 'personal-settings-general',
    path: '/jira/settings/personal/general'
};

});

parcelRegister("4XFHO", function(module, exports) {

$parcel$export(module.exports, "getLabsResources", () => $0f10f97c7a06e4e8$export$18345571aa12a367);

var $b4PzF = parcelRequire("b4PzF");

var $eOlBz = parcelRequire("eOlBz");

var $ipmBb = parcelRequire("ipmBb");

var $gNStA = parcelRequire("gNStA");
const $0f10f97c7a06e4e8$export$18345571aa12a367 = ()=>[
        (0, $eOlBz.newIssueViewTransitionLockInStatusResource),
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $b4PzF.isFedRamp)(), (0, $ipmBb.nextBestTaskFeatureResource))
    ];

});
parcelRegister("ipmBb", function(module, exports) {

$parcel$export(module.exports, "nextBestTaskFeatureResource", () => $b97b42683de1c9b3$export$5d472f7d515300ca);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");

const $b97b42683de1c9b3$export$5d472f7d515300ca = (0, $2M1hQ.createResource)({
    type: (0, $167b031bfd6a6b6e$export$6f0555de4f60e84e),
    getKey: ()=>(0, $167b031bfd6a6b6e$export$7e7d7930e22ba39f),
    getData: async ()=>{
        try {
            return await (0, $eusud.performGetRequest)(`/rest/api/3/mypreferences?key=${(0, $167b031bfd6a6b6e$export$b94951a11282ae6a)}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const initialValueNeverSet = error.statusCode === 404;
            if (initialValueNeverSet) /**
				 * If the user has never set the preference, we auto enroll them and set the initial value to true.
				 */ return {
                hasUserOptedIn: true
            };
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: (0, $167b031bfd6a6b6e$export$7f111648ca05f056),
                    packageName: (0, $167b031bfd6a6b6e$export$b8b9d90f9e5bd72b)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        /* on error return false,
		 * this ensures if user is in the experiment cohort but later opted out, they don't revert to having the feature enabled */ return {
            hasUserOptedIn: false
        };
    },
    maxAge: Number.MAX_VALUE
});

});
const $167b031bfd6a6b6e$export$6f0555de4f60e84e = 'RESOURCE_TYPE_NEXT_BEST_TASK_FEATURE';
const $167b031bfd6a6b6e$export$7e7d7930e22ba39f = 'nbt-opt-in-resource-key'; // value is global for user
const $167b031bfd6a6b6e$export$b94951a11282ae6a = 'next-best-task-feature';
const $167b031bfd6a6b6e$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesNextBestTask';
const $167b031bfd6a6b6e$export$7f111648ca05f056 = 'useResource.fetchNextBestTaskOptInPreference';



parcelRegister("bYYd6", function(module, exports) {

let $8b9400d5f6c67de3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8b9400d5f6c67de3$var$load("dsU72").then(()=>parcelRequire('6keru'));

});


parcelRegister("5YggO", function(module, exports) {

$parcel$export(module.exports, "notificationsPersonalSettingsRouteEntry", () => $6f6984c8da820d1e$export$640c1b3b96c9032e);

var $5uXOq = parcelRequire("5uXOq");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $cRWZh = parcelRequire("cRWZh");

var $1C2yb = parcelRequire("1C2yb");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $d1xZH = parcelRequire("d1xZH");

var $ds5qV = parcelRequire("ds5qV");

var $a94gn = parcelRequire("a94gn");

var $h1H2H = parcelRequire("h1H2H");
const $6f6984c8da820d1e$var$personalSettingsNotificationsEntryPointPage = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $h1H2H.personalSettingsNotificationsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).NOTIFICATIONS
});
const $6f6984c8da820d1e$export$640c1b3b96c9032e = (0, $7NszV.createEntry)((0, $d1xZH.notificationsPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        skeleton: (0, $a94gn.PersonalSettingsNotificationsAppSkeleton),
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
                to: (0, $1C2yb.getNotificationsPersonalSettingsPath)()
            }),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROFILE,
            sidebar: (0, $cRWZh.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $5bkvv.getNavigationForgePersonalSettingsPageResources)()
        ],
        pageId: 'personal-settings-notifications',
        entryPoint () {
            return $6f6984c8da820d1e$var$personalSettingsNotificationsEntryPointPage;
        }
    }));

});
parcelRegister("1C2yb", function(module, exports) {

$parcel$export(module.exports, "GENERAL_PERSONAL_SETTINGS_PATH", () => $63706130a90445cd$export$693b70d1bcef8627);
$parcel$export(module.exports, "NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $63706130a90445cd$export$21946ea4c58fd4c9);
$parcel$export(module.exports, "DIGEST_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $63706130a90445cd$export$cff16c3a6aa7a3a9);
$parcel$export(module.exports, "OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $63706130a90445cd$export$2321c59d517801c8);
$parcel$export(module.exports, "getGeneralPersonalSettingsPath", () => $63706130a90445cd$export$db9e3ccc1e5e3317);
$parcel$export(module.exports, "getNotificationsPersonalSettingsPath", () => $63706130a90445cd$export$64a672523a583594);
$parcel$export(module.exports, "getAppsPersonalSettingsPath", () => $63706130a90445cd$export$1a7321c4210a3049);
const $63706130a90445cd$export$b468ccdb67523656 = '/secure/ViewPersonalSettings.jspa';
const $63706130a90445cd$export$a974f4af282a75ba = '/jira/settings/personal';
const $63706130a90445cd$export$693b70d1bcef8627 = `${$63706130a90445cd$export$a974f4af282a75ba}/general`;
const $63706130a90445cd$export$21946ea4c58fd4c9 = `${$63706130a90445cd$export$a974f4af282a75ba}/notifications`;
const $63706130a90445cd$export$cff16c3a6aa7a3a9 = `${$63706130a90445cd$export$a974f4af282a75ba}/digests`;
const $63706130a90445cd$export$1fffbb6055aa320a = `${$63706130a90445cd$export$a974f4af282a75ba}/apps`;
const $63706130a90445cd$export$2321c59d517801c8 = `${$63706130a90445cd$export$a974f4af282a75ba}/alert-notifications`;
function $63706130a90445cd$export$db9e3ccc1e5e3317() {
    return $63706130a90445cd$export$693b70d1bcef8627;
}
function $63706130a90445cd$export$88a45ae8c4b1c664() {
    return $63706130a90445cd$export$2321c59d517801c8;
}
function $63706130a90445cd$export$64a672523a583594() {
    return $63706130a90445cd$export$21946ea4c58fd4c9;
}
function $63706130a90445cd$export$1a7321c4210a3049() {
    return $63706130a90445cd$export$1fffbb6055aa320a;
}

});

parcelRegister("d1xZH", function(module, exports) {

$parcel$export(module.exports, "notificationsPersonalSettingsRoute", () => $de84b22e790c56d0$export$55ab09b9d6beb8be);
const $de84b22e790c56d0$export$55ab09b9d6beb8be = {
    name: 'personal-settings-notifications',
    path: '/jira/settings/personal/notifications'
};

});

parcelRegister("a94gn", function(module, exports) {

$parcel$export(module.exports, "PersonalSettingsNotificationsAppSkeleton", () => $e165273754ebea11$export$b542eb2d3193b983);
$parcel$export(module.exports, "PersonalSettingsNotificationsGlobalTableSkeleton", () => $e165273754ebea11$export$d58f6bbbc1838cb2);
$parcel$export(module.exports, "ProjectNotificationAccordionSkeleton", () => $e165273754ebea11$export$8cb773cb6fc17338);
/* PersonalSettingsNotificationsAppSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hCy6k = parcelRequire("hCy6k");

var $bSzQR = parcelRequire("bSzQR");

var $D73Nc = parcelRequire("D73Nc");

var $eVLyC = parcelRequire("eVLyC");

var $8z1qR = parcelRequire("8z1qR");
const $e165273754ebea11$var$maxWidthCssStyles = null;
const $e165273754ebea11$var$customCssStyles = null;
const $e165273754ebea11$export$b542eb2d3193b983 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eVLyC))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f8stt"
        ])
    });
const $e165273754ebea11$export$d58f6bbbc1838cb2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e165273754ebea11$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bSzQR))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    }));
const $e165273754ebea11$export$46fc11a564484c9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e165273754ebea11$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($D73Nc))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    }));
const $e165273754ebea11$export$8cb773cb6fc17338 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e165273754ebea11$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8z1qR))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e165273754ebea11$var$SkeletonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_c71ldgin _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bSzQR", function(module, exports) {
module.exports = new URL("global-table-skeleton-with-projects.tpl.5a5d24b9.svg", import.meta.url).toString();

});

parcelRegister("D73Nc", function(module, exports) {
module.exports = new URL("mimetype-skeleton.tpl.8b750352.svg", import.meta.url).toString();

});

parcelRegister("eVLyC", function(module, exports) {
module.exports = new URL("personal-settings-notifications-app-skeleton-with-projects.tpl.d18b3c58.svg", import.meta.url).toString();

});

parcelRegister("8z1qR", function(module, exports) {
module.exports = new URL("project-accordion-skeleton.tpl.cee2df62.svg", import.meta.url).toString();

});


parcelRegister("h1H2H", function(module, exports) {

$parcel$export(module.exports, "personalSettingsNotificationsEntryPoint", () => $0e73b796ef7555dc$export$44d710abd316d1f1);

var $7P45F = parcelRequire("7P45F");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $0e73b796ef7555dc$export$44d710abd316d1f1 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("cmelG")), {
        moduleId: "fe0c927e"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            // Queries your async component uses
            queries: {
                pageAndProject: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $7P45F.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectIds: context.query?.projectIds ? context.query.projectIds.split(',') : []
                    }
                }
            },
            // Optional - Anything extra you wish to pass to your component
            // Something from `EntryPointParams` for example
            extraProps: {
                accountId: tenantContext.atlassianAccountId
            }
        })
});

});
parcelRegister("7P45F", function(module, exports) {

$parcel$export(module.exports, "default", () => $49af4b582b9c7470$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<65f7487bbf2166c21de5aefdce342ece>>
 * @relayHash 0ace672294c09b398fb8d4f0e7526c83
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b7fd514c01c704c310af24b4bec2490f86683eb6f578c5e61833c2151685f3ba

var $jA1kf = parcelRequire("jA1kf");
const $49af4b582b9c7470$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "xsmall"
                }
            ]
        }
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "channel"
        },
        {
            "kind": "ScalarField",
            "name": "isEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ], v7 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "emailChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "inProductChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "kind": "ScalarField",
            "name": "category"
        }
    ], v8 = {
        "concreteType": "JiraNotificationPreferences",
        "kind": "LinkedField",
        "name": "preferences",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueAssigned",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueUpdated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueDeleted",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentCreated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentEdited",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentDeleted",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueCreated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueMoved",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "mentionsCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "worklogCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "miscellaneousIssueEventCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            }
        ]
    }, v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_NotificationsPageAndProjectQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_projects"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraNotificationGlobalPreference",
                                    "kind": "LinkedField",
                                    "name": "notificationGlobalPreference",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalNotificationsConfigTable_personalSettingsNotificationsConfigTable_GlobalNotificationConfigTableNew"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraNotificationOptions",
                                                "kind": "LinkedField",
                                                "name": "options",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "notificationPreferencesOptionsWrapper_personalSettingsPreferenceFields_NotificationPreferencesOptions"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.notificationGlobalPreference.options"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.notificationGlobalPreference"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ui_NotificationsPageAndProjectQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraNotificationProjectPreferenceConnection",
                            "kind": "LinkedField",
                            "name": "allNotificationProjectPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectNotificationPreferenceEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationProjectPreferences",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "args": v3 /*: any*/ ,
                            "filters": [
                                "cloudId"
                            ],
                            "handle": "connection",
                            "key": "projects_allNotificationProjectPreferences",
                            "kind": "LinkedHandle",
                            "name": "allNotificationProjectPreferences"
                        },
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraNotificationGlobalPreference",
                            "kind": "LinkedField",
                            "name": "notificationGlobalPreference",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEmailNotificationEnabled"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyWhenRoleAssigneeEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyWhenRoleReporterEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyOwnChangesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "batchWindow"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "dailyBatchLocalTime"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "emailMimeType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEmailMimeTypeEditable"
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "allJiraProjectsForModal",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "notificationConfigurationState": "DEFAULT",
                                        "sortBy": {
                                            "sortBy": "NAME"
                                        }
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 5
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b7fd514c01c704c310af24b4bec2490f86683eb6f578c5e61833c2151685f3ba",
            "metadata": {},
            "name": "ui_NotificationsPageAndProjectQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": (0, $jA1kf.default)
            }
        }
    };
}();
$49af4b582b9c7470$var$node.hash = "b001322577b49b90b0c0e44082f4b2b8";
var $49af4b582b9c7470$export$2e2bcd8739ae039 = $49af4b582b9c7470$var$node;

});
parcelRegister("jA1kf", function(module, exports) {

$parcel$export(module.exports, "default", () => $349f2b9cab96c314$export$2e2bcd8739ae039);
var $349f2b9cab96c314$export$2e2bcd8739ae039 = {
    get () {
        return true;
    }
};

});


parcelRegister("cmelG", function(module, exports) {

let $8ff2ab75b3d55813$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8ff2ab75b3d55813$var$load("5d5n9").then(()=>parcelRequire('4DJNq'));

});



parcelRegister("g3kqr", function(module, exports) {

$parcel$export(module.exports, "opsNotificationsPersonalSettingsRouteEntry", () => $cb843413a571a269$export$407513e3bdb49efe);

var $5uXOq = parcelRequire("5uXOq");

var $67GcB = parcelRequire("67GcB");parcelRequire("6luO8");
var $dvEFY = parcelRequire("dvEFY");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $cRWZh = parcelRequire("cRWZh");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $8tZGz = parcelRequire("8tZGz");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $eZXFU = parcelRequire("eZXFU");

const $cb843413a571a269$var$LazyOpsNotificationsPersonalSettings = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hDTvJ"))), {
    moduleId: "./src/packages/spa-apps/personal-settings/ops-notifications/src/index.tsx"
});
const $cb843413a571a269$var$OpsNotificationsPersonalSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cb843413a571a269$var$LazyOpsNotificationsPersonalSettings,
        pageId: "personal-settings-notifications",
        shouldShowSpinner: true
    });
const $cb843413a571a269$export$407513e3bdb49efe = (0, $7NszV.createEntry)((0, $8tZGz.opsNotificationsPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: $cb843413a571a269$var$OpsNotificationsPersonalSettingsComponent,
        layout: (0, $eZXFU.opsNotificationsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROFILE,
            sidebar: (0, $cRWZh.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $67GcB.createContactsResource)(),
            (0, $67GcB.createNotificationPreferencesResource)(),
            (0, $dvEFY.eocUserResource),
            (0, $67GcB.createMuteResource)(),
            (0, $67GcB.createQuietHoursResource)(),
            (0, $67GcB.createForwardingRulesResource)(),
            ...(0, $5bkvv.getNavigationForgePersonalSettingsPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $cb843413a571a269$var$LazyOpsNotificationsPersonalSettings
        ]
    }));

});
parcelRegister("67GcB", function(module, exports) {

$parcel$export(module.exports, "createNotificationPreferencesResource", () => $70382242de355c5b$export$731980bd233a4797);
$parcel$export(module.exports, "createContactsResource", () => $70382242de355c5b$export$b9ca444b0be3df97);
$parcel$export(module.exports, "createMuteResource", () => $70382242de355c5b$export$c849cfac68bc6e80);
$parcel$export(module.exports, "createQuietHoursResource", () => $70382242de355c5b$export$efc5e8690061f9cc);
$parcel$export(module.exports, "createForwardingRulesResource", () => $70382242de355c5b$export$5314dca65b4e5888);

var $2M1hQ = parcelRequire("2M1hQ");
parcelRequire("6luO8");
var $dvEFY = parcelRequire("dvEFY");

var $31C2N = parcelRequire("31C2N");
const $70382242de355c5b$export$731980bd233a4797 = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'notificationPreferencesResource',
        getKey: ()=>'notificationPreferencesResource',
        getData: ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $31C2N.getNotificationPreferences)();
        },
        isBrowserOnly: true,
        depends: depends
    });
const $70382242de355c5b$export$b9ca444b0be3df97 = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'contactsResource',
        getKey: ()=>'contactsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            const data = await (0, $31C2N.getContact)();
            return data.contacts;
        },
        isBrowserOnly: true,
        depends: depends
    });
const $70382242de355c5b$export$c849cfac68bc6e80 = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'muteResource',
        getKey: ()=>'muteResource',
        getData: ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $31C2N.getMuteDetail)();
        },
        isBrowserOnly: true,
        depends: depends
    });
const $70382242de355c5b$export$efc5e8690061f9cc = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'quietHoursResource',
        getKey: ()=>'quietHoursResource',
        getData: ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $31C2N.getQuietHoursDetail)();
        },
        isBrowserOnly: true,
        depends: depends
    });
const $70382242de355c5b$export$5314dca65b4e5888 = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'forwardingRulesResource',
        getKey: ()=>'forwardingRulesResource',
        getData: ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $31C2N.getForwardingRules)().then(({ values: values })=>values);
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("31C2N", function(module, exports) {

$parcel$export(module.exports, "getNotificationPreferences", () => $3fc2f6e1162be0a8$export$60e139c3026f21bc);
$parcel$export(module.exports, "getContact", () => $3fc2f6e1162be0a8$export$52411745da118fc8);
$parcel$export(module.exports, "getMuteDetail", () => $3fc2f6e1162be0a8$export$80a4e62998a806a6);
$parcel$export(module.exports, "getQuietHoursDetail", () => $3fc2f6e1162be0a8$export$44a94c74f358d02f);
$parcel$export(module.exports, "getForwardingRules", () => $3fc2f6e1162be0a8$export$2161af98e3d645a5);

var $d9Cgl = parcelRequire("d9Cgl");
const $3fc2f6e1162be0a8$export$60e139c3026f21bc = ()=>(0, $d9Cgl.eocFetch)(`/v1/users/notification-preferences`);
const $3fc2f6e1162be0a8$export$52411745da118fc8 = ()=>(0, $d9Cgl.eocFetch)(`/v1/users/contact`);
const $3fc2f6e1162be0a8$export$80a4e62998a806a6 = ()=>(0, $d9Cgl.eocFetch)(`/v1/users/notifications/mute`);
const $3fc2f6e1162be0a8$export$44a94c74f358d02f = ()=>(0, $d9Cgl.eocFetch)(`/v1/users/quiet-hours/details`);
const $3fc2f6e1162be0a8$export$2161af98e3d645a5 = ()=>(0, $d9Cgl.eocFetch)(`/v1/alerts/notifications/forwarding-rules`);

});


parcelRegister("8tZGz", function(module, exports) {

$parcel$export(module.exports, "opsNotificationsPersonalSettingsRoute", () => $84075aa9af41e0be$export$68ebdd4eccb7b383);
const $84075aa9af41e0be$export$68ebdd4eccb7b383 = {
    name: 'personal-settings-ops-notifications',
    path: '/jira/settings/personal/alert-notifications'
};

});

parcelRegister("hDTvJ", function(module, exports) {

let $cd81237da31737a2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cd81237da31737a2$var$load("h2MrD"),
    $cd81237da31737a2$var$load("bYT2S"),
    $cd81237da31737a2$var$load("3dsjz")
]).then(()=>parcelRequire('aV66n'));

});


parcelRegister("d4tTc", function(module, exports) {

$parcel$export(module.exports, "digestsNotificationsPersonalSettingsRouteEntry", () => $c698e0e2618894a9$export$6ff00ce079beb0ed);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $cRWZh = parcelRequire("cRWZh");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $b5ISR = parcelRequire("b5ISR");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $c698e0e2618894a9$var$LazyDigestsNotificationsPersonalSettings = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("ldX0j"))), {
    moduleId: "./src/packages/spa-apps/personal-settings/digests-notifications/src/index.tsx"
});
const $c698e0e2618894a9$var$DigestsNotificationsPersonalSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c698e0e2618894a9$var$LazyDigestsNotificationsPersonalSettings,
        pageId: "personal-settings-notifications",
        shouldShowSpinner: true
    });
const $c698e0e2618894a9$export$6ff00ce079beb0ed = (0, $7NszV.createEntry)((0, $b5ISR.digestsNotificationsPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: $c698e0e2618894a9$var$DigestsNotificationsPersonalSettingsComponent,
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROFILE,
            sidebar: (0, $cRWZh.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $c698e0e2618894a9$var$LazyDigestsNotificationsPersonalSettings
        ]
    }));

});
parcelRegister("b5ISR", function(module, exports) {

$parcel$export(module.exports, "digestsNotificationsPersonalSettingsRoute", () => $8043a136b458bb05$export$36b31d006b9456a1);
const $8043a136b458bb05$export$36b31d006b9456a1 = {
    name: 'personal-settings-digests',
    path: '/jira/settings/personal/digests'
};

});

parcelRegister("ldX0j", function(module, exports) {

let $f73894dd6b2a7895$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f73894dd6b2a7895$var$load("bjOJr").then(()=>parcelRequire('erUXM'));

});


parcelRegister("lPLcB", function(module, exports) {

$parcel$export(module.exports, "personalSettingsRouteEntry", () => $4a98174db89ed9a9$export$89646e32fa7698db);

var $5uXOq = parcelRequire("5uXOq");

var $67GcB = parcelRequire("67GcB");parcelRequire("6luO8");
var $dvEFY = parcelRequire("dvEFY");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $1C2yb = parcelRequire("1C2yb");

var $7NszV = parcelRequire("7NszV");


var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $bCvq0 = parcelRequire("bCvq0");

var $ds5qV = parcelRequire("ds5qV");

var $7yO8g = parcelRequire("7yO8g");

var $b7Svb = parcelRequire("b7Svb");

var $9wNN8 = parcelRequire("9wNN8");

var $4XFHO = parcelRequire("4XFHO");

const $4a98174db89ed9a9$var$LazyLegacyPersonalSettings = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("a4qfo"))), {
    moduleId: "./src/packages/spa-apps/personal-settings-legacy/src/index.tsx"
});
const $4a98174db89ed9a9$export$89646e32fa7698db = (0, $7NszV.createEntry)((0, $bCvq0.personalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
                to: (0, $1C2yb.GENERAL_PERSONAL_SETTINGS_PATH)
            }),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROFILE
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $67GcB.createContactsResource)((0, $9wNN8.checkConsolidationOnRouteDependency), [
                (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
            ]),
            (0, $67GcB.createNotificationPreferencesResource)((0, $9wNN8.checkConsolidationOnRouteDependency), [
                (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
            ]),
            (0, $dvEFY.eocUserResource),
            (0, $67GcB.createMuteResource)((0, $9wNN8.checkConsolidationOnRouteDependency), [
                (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
            ]),
            (0, $67GcB.createQuietHoursResource)((0, $9wNN8.checkConsolidationOnRouteDependency), [
                (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
            ]),
            (0, $67GcB.createForwardingRulesResource)((0, $9wNN8.checkConsolidationOnRouteDependency), [
                (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
            ]),
            ...(0, $5bkvv.getNavigationForgePersonalSettingsPageResources)(),
            ...(0, $4XFHO.getLabsResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $4a98174db89ed9a9$var$LazyLegacyPersonalSettings
        ]
    }));

});
parcelRegister("bCvq0", function(module, exports) {

$parcel$export(module.exports, "personalSettingsRoute", () => $03113dbc73778b4c$export$176d0935b95c75e8);
const $03113dbc73778b4c$export$176d0935b95c75e8 = {
    name: 'personal-settings',
    path: '/secure/ViewPersonalSettings.jspa'
};

});

parcelRegister("9wNN8", function(module, exports) {

$parcel$export(module.exports, "checkConsolidationOnRouteDependency", () => $d103219a16ecaa90$export$ac86a769188afd33);

var $3H5ry = parcelRequire("3H5ry");

const $d103219a16ecaa90$export$ac86a769188afd33 = (dependencies)=>{
    const { data: data } = dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $3H5ry.checkShouldUseJSM)(data);
};

});

parcelRegister("a4qfo", function(module, exports) {

let $754ea33fee0bb335$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $754ea33fee0bb335$var$load("eNmuD"),
    $754ea33fee0bb335$var$load("64osF")
]).then(()=>parcelRequire('3hooO'));

});


parcelRegister("3L1EU", function(module, exports) {

$parcel$export(module.exports, "polarisCollectionsRouteEntry", () => $4aedad13e1b8926d$export$a034dc25c21d1029);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $1bDWO = parcelRequire("1bDWO");

var $iI3aS = parcelRequire("iI3aS");
const $4aedad13e1b8926d$export$a034dc25c21d1029 = (0, $7NszV.createEntry)((0, $1bDWO.polarisCollectionsRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        ufoName: 'jpd.collections',
        component: (0, $iI3aS.default),
        layout: (0, $2BrOV.globalLayout),
        canTransitionIn: ()=>{
            // default is no-refresh
            return true;
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $iI3aS.LazyCollectionsPage)
        ]
    }));

});
parcelRegister("1bDWO", function(module, exports) {

$parcel$export(module.exports, "polarisCollectionsRoute", () => $31434a8eaec0208e$export$d415b74f78a5f159);
const $31434a8eaec0208e$export$d415b74f78a5f159 = {
    name: 'polaris-collections',
    path: '/jira/polaris/roadmaps/:collectionUUID?/:section?/:resource?',
    query: [
        'projects?',
        'owners?'
    ],
    exact: true
};

});

parcelRegister("iI3aS", function(module, exports) {

$parcel$export(module.exports, "LazyCollectionsPage", () => $1bfc7c5d195e4066$export$f7960e7dbd7e5265);
$parcel$export(module.exports, "default", () => $1bfc7c5d195e4066$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dWQF5 = parcelRequire("dWQF5");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $9OXo1 = parcelRequire("9OXo1");

var $b7Svb = parcelRequire("b7Svb");

var $7tQej = parcelRequire("7tQej");

const $1bfc7c5d195e4066$export$f7960e7dbd7e5265 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5Nkv0"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/collections/src/index.tsx"
});
const $1bfc7c5d195e4066$var$useJpdLicensed = ()=>{
    const context = (0, $9OXo1.useTenantContext)();
    return context.licensedProducts['jira-product-discovery'];
};
const $1bfc7c5d195e4066$export$3bba33442c4150b1 = ()=>{
    const jpdLicensed = $1bfc7c5d195e4066$var$useJpdLicensed();
    const crossProjectViewsEnabled = (0, $dWQF5.useIsCrossProjectViewsEnabled)();
    if (!jpdLicensed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira/polaris/unlicensed"
    });
    if (!crossProjectViewsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1bfc7c5d195e4066$export$f7960e7dbd7e5265,
        pageId: "async-polaris-collections",
        shouldShowSpinner: false
    });
};
var $1bfc7c5d195e4066$export$2e2bcd8739ae039 = $1bfc7c5d195e4066$export$3bba33442c4150b1;

});
parcelRegister("5Nkv0", function(module, exports) {

let $43816e10c11482a7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $43816e10c11482a7$var$load("kfXhT"),
    $43816e10c11482a7$var$load("2Lfdl"),
    $43816e10c11482a7$var$load("cM9em"),
    $43816e10c11482a7$var$load("fr9NE"),
    $43816e10c11482a7$var$load("h2MrD"),
    $43816e10c11482a7$var$load("bYT2S"),
    $43816e10c11482a7$var$load("dsiAd"),
    $43816e10c11482a7$var$load("4iOXD")
]).then(()=>parcelRequire('jaSwr'));

});



parcelRegister("g5olQ", function(module, exports) {

$parcel$export(module.exports, "polarisIdeasRouteEntry", () => $a75ffafad7078936$export$26631f98f007b2d2);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $eviST = parcelRequire("eviST");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $1Yu63 = parcelRequire("1Yu63");

var $hO84v = parcelRequire("hO84v");
const $a75ffafad7078936$export$26631f98f007b2d2 = (0, $7NszV.createEntry)((0, $1Yu63.polarisIdeasRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        ufoName: 'jpd.project',
        component: (0, $hO84v.default),
        layout: (0, $eviST.polarisProjectLayout),
        canTransitionIn: ()=>true,
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hO84v.LazyIdeasPage)
        ]
    }));

});
parcelRegister("eviST", function(module, exports) {

$parcel$export(module.exports, "polarisProjectLayout", () => $501e6cef37d28e94$export$d5273c1a2e2fe212);

var $1Du13 = parcelRequire("1Du13");

var $aPfsS = parcelRequire("aPfsS");
const $501e6cef37d28e94$export$d5273c1a2e2fe212 = (0, $aPfsS.composeLayouts)((0, $1Du13.projectLayout));

});

parcelRegister("1Yu63", function(module, exports) {

$parcel$export(module.exports, "polarisIdeasRoute", () => $3378a983c17fef3f$export$54c333cd4ed2d70e);
const $3378a983c17fef3f$export$54c333cd4ed2d70e = {
    name: 'polaris-ideas',
    path: '/jira/polaris/projects/:projectKey/ideas/:section?/:resource?',
    query: [
        'selectedIssue?',
        'issueViewLayout?'
    ],
    exact: true
};

});

parcelRegister("hO84v", function(module, exports) {

$parcel$export(module.exports, "LazyIdeasPage", () => $9c1678c5da04bd73$export$3fd7cf4494189548);
$parcel$export(module.exports, "default", () => $9c1678c5da04bd73$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $9OXo1 = parcelRequire("9OXo1");

var $b7Svb = parcelRequire("b7Svb");

var $7tQej = parcelRequire("7tQej");

const $9c1678c5da04bd73$export$3fd7cf4494189548 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5geAO"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/ideas/src/index.tsx"
});
const $9c1678c5da04bd73$var$useJpdLicensed = ()=>{
    const context = (0, $9OXo1.useTenantContext)();
    return context.licensedProducts['jira-product-discovery'];
};
const $9c1678c5da04bd73$export$8e495e768b5bbae5 = ()=>{
    const jpdLicensed = $9c1678c5da04bd73$var$useJpdLicensed();
    if (!jpdLicensed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira/polaris/unlicensed"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9c1678c5da04bd73$export$3fd7cf4494189548,
        pageId: "async-polaris-ideas",
        shouldShowSpinner: false
    });
};
var $9c1678c5da04bd73$export$2e2bcd8739ae039 = $9c1678c5da04bd73$export$8e495e768b5bbae5;

});
parcelRegister("5geAO", function(module, exports) {

let $3d49c42a22c68464$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3d49c42a22c68464$var$load("kfXhT"),
    $3d49c42a22c68464$var$load("2Lfdl"),
    $3d49c42a22c68464$var$load("cM9em"),
    $3d49c42a22c68464$var$load("fr9NE"),
    $3d49c42a22c68464$var$load("h2MrD"),
    $3d49c42a22c68464$var$load("bYT2S"),
    $3d49c42a22c68464$var$load("dsiAd"),
    $3d49c42a22c68464$var$load("2ZyA4")
]).then(()=>parcelRequire('glCkY'));

});



parcelRegister("ecUH3", function(module, exports) {

$parcel$export(module.exports, "polarisOnboardingRouteEntry", () => $9a1e9d5292b9a0dc$export$a297a71cb150e2af);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $aFVvc = parcelRequire("aFVvc");

var $brgR1 = parcelRequire("brgR1");

var $dQc5Q = parcelRequire("dQc5Q");
const $9a1e9d5292b9a0dc$export$a297a71cb150e2af = (0, $7NszV.createEntry)((0, $brgR1.polarisOnboardingRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        component: (0, $dQc5Q.default),
        layout: (0, $2BrOV.globalLayout),
        canTransitionIn: ()=>true,
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $aFVvc.projectCreatePermissionsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dQc5Q.LazyOnboardingPage)
        ]
    }));

});
parcelRegister("brgR1", function(module, exports) {

$parcel$export(module.exports, "polarisOnboardingRoute", () => $d7e18a0721187b3f$export$6696e9deb45fe980);
const $d7e18a0721187b3f$export$6696e9deb45fe980 = {
    name: 'polaris-onboarding',
    path: '/welcome/discovery',
    exact: true
};

});

parcelRegister("dQc5Q", function(module, exports) {

$parcel$export(module.exports, "LazyOnboardingPage", () => $ff87f692d7c58a17$export$13889cc3ce0d5a93);
$parcel$export(module.exports, "default", () => $ff87f692d7c58a17$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $ff87f692d7c58a17$export$13889cc3ce0d5a93 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("2DhzX"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/onboarding/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ff87f692d7c58a17$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ff87f692d7c58a17$export$13889cc3ce0d5a93,
        pageId: "async-polaris-onboarding",
        shouldShowSpinner: false
    });

});
parcelRegister("2DhzX", function(module, exports) {

let $1eacdc20ea0ccb0b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1eacdc20ea0ccb0b$var$load("5kvjN").then(()=>parcelRequire('2PQGe'));

});



parcelRegister("6okEU", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsAccessRouteEntry", () => $23f05070dbae84f0$export$9c0f51630c25c3d);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $jUKSc = parcelRequire("jUKSc");

var $4csue = parcelRequire("4csue");
const $23f05070dbae84f0$export$9c0f51630c25c3d = (0, $7NszV.createEntry)((0, $jUKSc.polarisSettingsAccessRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        component: (0, $4csue.AccessSettingsPage),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4csue.LazyAccessSettingsPage)
        ]
    }));

});
parcelRegister("jUKSc", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsAccessRoute", () => $5cb169f7c1c57d8b$export$bfdcdf76e802d67d);
const $5cb169f7c1c57d8b$export$bfdcdf76e802d67d = {
    name: 'polaris-settings-access',
    path: '/jira/settings/products/jira-product-discovery/access',
    exact: true
};

});

parcelRegister("4csue", function(module, exports) {

$parcel$export(module.exports, "LazyAccessSettingsPage", () => $ff4634525ed299f8$export$b66ea0dcd38af7f0);
$parcel$export(module.exports, "AccessSettingsPage", () => $ff4634525ed299f8$export$d46497fe68b0853c);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $ff4634525ed299f8$export$b66ea0dcd38af7f0 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("2JOff"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/settings-access/src/index.tsx"
});
const $ff4634525ed299f8$export$d46497fe68b0853c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ff4634525ed299f8$export$b66ea0dcd38af7f0,
        pageId: "async-polaris-settings-access",
        shouldShowSpinner: false
    });

});
parcelRegister("2JOff", function(module, exports) {

let $1fe6c25bf5e541eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1fe6c25bf5e541eb$var$load("6iZL1").then(()=>parcelRequire('ab4oe'));

});



parcelRegister("9YDUs", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsGlobalFieldsRouteEntry", () => $8b674ae9037c6c90$export$e29465c661741392);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $ieDqa = parcelRequire("ieDqa");

var $6gpmn = parcelRequire("6gpmn");
const $8b674ae9037c6c90$export$e29465c661741392 = (0, $7NszV.createEntry)((0, $ieDqa.polarisSettingsGlobalFieldsRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $6gpmn.polarisProductGlobalFieldsSettingsPageEntryPoint;
        }
    }));

});
parcelRegister("ieDqa", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsGlobalFieldsRoute", () => $1d178fd38105ca54$export$d1d77b6a84982ab8);
const $1d178fd38105ca54$export$d1d77b6a84982ab8 = {
    name: 'polaris-settings-global-fields',
    path: '/jira/settings/products/jira-product-discovery/global-fields',
    exact: true
};

});

parcelRegister("6gpmn", function(module, exports) {

$parcel$export(module.exports, "polarisProductGlobalFieldsSettingsPageEntryPoint", () => $dd5db072b96b7a9a$export$c682ebcd2290352f);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $gZZ5s = parcelRequire("gZZ5s");
const $dd5db072b96b7a9a$export$c682ebcd2290352f = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $gZZ5s.polarisProductGlobalFieldsSettingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});

});
parcelRegister("gZZ5s", function(module, exports) {

$parcel$export(module.exports, "polarisProductGlobalFieldsSettingsEntryPoint", () => $7946c690dff6c696$export$f2f24531058bc251);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $7946c690dff6c696$export$f2f24531058bc251 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("d1ciy")), {
        moduleId: "fead11bc"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("d1ciy", function(module, exports) {

let $97a4e88f530a6046$var$load = (parcelRequire("28QjX"))(4);
module.exports = $97a4e88f530a6046$var$load("jhjZS").then(()=>parcelRequire('b26tT'));

});




parcelRegister("gAq9g", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsEarlyAccessFeaturesRouteEntry", () => $bf181a7631938891$export$986710683a071056);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $6HnX2 = parcelRequire("6HnX2");

var $9EMQz = parcelRequire("9EMQz");
const $bf181a7631938891$export$986710683a071056 = (0, $7NszV.createEntry)((0, $6HnX2.polarisSettingsEarlyAccessFeaturesRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $9EMQz.polarisProductEAPSettingsPageEntryPoint;
        }
    }));

});
parcelRegister("6HnX2", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsEarlyAccessFeaturesRoute", () => $33928478759c7483$export$19bd38107b2ac64b);
const $33928478759c7483$export$19bd38107b2ac64b = {
    name: 'polaris-settings-early-access-features',
    path: '/jira/settings/products/jira-product-discovery/early-access-features',
    exact: true
};

});

parcelRegister("9EMQz", function(module, exports) {

$parcel$export(module.exports, "polarisProductEAPSettingsPageEntryPoint", () => $b121880695e6f137$export$1bd9d2b1f32dc9ee);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $7fx7L = parcelRequire("7fx7L");
const $b121880695e6f137$export$1bd9d2b1f32dc9ee = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7fx7L.polarisProductEAPSettingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});

});
parcelRegister("7fx7L", function(module, exports) {

$parcel$export(module.exports, "polarisProductEAPSettingsEntryPoint", () => $cd1239aae9aba238$export$92df711874ab564a);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $cd1239aae9aba238$export$92df711874ab564a = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("gQRsP")), {
        moduleId: "e4e16138"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gQRsP", function(module, exports) {

let $c44af982758c43a3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c44af982758c43a3$var$load("hwtJ2").then(()=>parcelRequire('exNFO'));

});




parcelRegister("64Fhf", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsFinancialYearRouteEntry", () => $674b4f295352d23a$export$f84465c46e6f4e58);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $hWe39 = parcelRequire("hWe39");

var $eUjyB = parcelRequire("eUjyB");
const $674b4f295352d23a$export$f84465c46e6f4e58 = (0, $7NszV.createEntry)((0, $hWe39.polarisSettingsFinancialYearRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $eUjyB.polarisProductFinancialYearSettingsPageEntryPoint;
        }
    }));

});
parcelRegister("hWe39", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsFinancialYearRoute", () => $24110e0dc48b99ee$export$cc594a4ccce25300);
const $24110e0dc48b99ee$export$cc594a4ccce25300 = {
    name: 'polaris-settings-financial-year',
    path: '/jira/settings/products/jira-product-discovery/financial-year',
    exact: true
};

});

parcelRegister("eUjyB", function(module, exports) {

$parcel$export(module.exports, "polarisProductFinancialYearSettingsPageEntryPoint", () => $54953d335cd55907$export$b1c132cd756e9b86);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $4vOBH = parcelRequire("4vOBH");
const $54953d335cd55907$export$b1c132cd756e9b86 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4vOBH.polarisProductFinancialYearSettingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});

});
parcelRegister("4vOBH", function(module, exports) {

$parcel$export(module.exports, "polarisProductFinancialYearSettingsEntryPoint", () => $b962cb3dff43d6f8$export$2e0ef763d6b208ea);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $b962cb3dff43d6f8$export$2e0ef763d6b208ea = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("1c2rE")), {
        moduleId: "47bc544f"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1c2rE", function(module, exports) {

let $0de8cef1b7badd43$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0de8cef1b7badd43$var$load("eW8DF").then(()=>parcelRequire('cqP15'));

});




parcelRegister("h3JFI", function(module, exports) {

$parcel$export(module.exports, "polarisUnlicensedRouteEntry", () => $ed78a6ddbb53401e$export$f975154b9b0ce777);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $aFVvc = parcelRequire("aFVvc");

var $aBsar = parcelRequire("aBsar");

var $5gkML = parcelRequire("5gkML");
const $ed78a6ddbb53401e$export$f975154b9b0ce777 = (0, $7NszV.createEntry)((0, $aBsar.polarisUnlicensedRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        component: (0, $5gkML.default),
        layout: (0, $2BrOV.globalLayout),
        canTransitionIn: ()=>true,
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $aFVvc.projectCreatePermissionsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5gkML.LazyUnlicensedPage)
        ]
    }));

});
parcelRegister("aBsar", function(module, exports) {

$parcel$export(module.exports, "polarisUnlicensedRoute", () => $451d03603cca57ae$export$32b1bc71501d2751);
const $451d03603cca57ae$export$32b1bc71501d2751 = {
    name: 'polaris-unlicensed',
    path: '/jira/polaris/unlicensed',
    exact: true
};

});

parcelRegister("5gkML", function(module, exports) {

$parcel$export(module.exports, "LazyUnlicensedPage", () => $14579de685a40428$export$394984ca86b38b8f);
$parcel$export(module.exports, "default", () => $14579de685a40428$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $14579de685a40428$export$394984ca86b38b8f = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("krJvb"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/unlicensed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$14579de685a40428$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $14579de685a40428$export$394984ca86b38b8f,
        pageId: "async-polaris-unlicensed",
        shouldShowSpinner: false
    });

});
parcelRegister("krJvb", function(module, exports) {

let $ee299ffc7a9dfbe6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee299ffc7a9dfbe6$var$load("c1qtf").then(()=>parcelRequire('5KpQH'));

});



parcelRegister("tdrXl", function(module, exports) {

$parcel$export(module.exports, "productsJsmChatopsAndVideosToolsRouteEntry", () => $4e0ccc70ab88c05a$export$8b55e723205ec5f3);

var $b4PzF = parcelRequire("b4PzF");

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $1pjne = parcelRequire("1pjne");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $j78rb = parcelRequire("j78rb");
const $4e0ccc70ab88c05a$var$getNavigationSpecifications = ()=>{
    return (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $4e0ccc70ab88c05a$export$8b55e723205ec5f3 = (0, $7NszV.createEntry)((0, $1pjne.productsJsmChatopsAndVideosToolsRoute), ()=>({
        group: 'global-settings',
        component: (0, $7XYc4.componentWithCondition)((0, $b4PzF.isFedRamp), (0, $5lsNZ.default), (0, $j78rb.default)),
        layout: (0, $eZXFU.opsSettingsLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$4e0ccc70ab88c05a$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $j78rb.LazyProductsJsmChatopsAndVideoTools)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $j78rb.LazyProductsJsmChatopsAndVideoTools)
        ]
    }));

});
parcelRegister("1pjne", function(module, exports) {

$parcel$export(module.exports, "productsJsmChatopsAndVideosToolsRoute", () => $233b8dbf88e7279c$export$7c663ddc097df1e8);
const $233b8dbf88e7279c$export$7c663ddc097df1e8 = {
    name: 'products-jsm-chatops-and-videos-tools',
    path: '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
    exact: true
};

});

parcelRegister("j78rb", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmChatopsAndVideoTools", () => $2b1085a0fa643a34$export$1b7f55251df02fe9);
$parcel$export(module.exports, "default", () => $2b1085a0fa643a34$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $2b1085a0fa643a34$export$1b7f55251df02fe9 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hMTgA"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-chatops-and-video-tools/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2b1085a0fa643a34$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2b1085a0fa643a34$export$1b7f55251df02fe9,
        pageId: "products-jsm-chatops-and-video-tools",
        shouldShowSpinner: false
    });

});
parcelRegister("hMTgA", function(module, exports) {

let $cf31ca27b0d02b2c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cf31ca27b0d02b2c$var$load("g6LyJ").then(()=>parcelRequire('1H43T'));

});



parcelRegister("5EloX", function(module, exports) {

$parcel$export(module.exports, "productsJsmComplianceRouteEntry", () => $a7108b06ea361a14$export$9cc9423a3967333b);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fRFcK = parcelRequire("fRFcK");

var $9WIUh = parcelRequire("9WIUh");
const $a7108b06ea361a14$export$9cc9423a3967333b = (0, $7NszV.createEntry)((0, $fRFcK.productsJsmComplianceRoute), ()=>({
        group: 'global-settings',
        component: (0, $9WIUh.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9WIUh.LazyProductsJsmCompliance)
        ],
        ufoName: 'admin.jsm-compliance'
    }));

});
parcelRegister("fRFcK", function(module, exports) {

$parcel$export(module.exports, "productsJsmComplianceRoute", () => $7de4aa1c0a8e9753$export$6196bf08f64419da);
const $7de4aa1c0a8e9753$export$6196bf08f64419da = {
    name: 'products-jsm-compliance',
    path: '/jira/settings/products/jira-service-management-compliance',
    exact: true
};

});

parcelRegister("9WIUh", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmCompliance", () => $62ef4b19010ca280$export$159d8c0e1862cd2b);
$parcel$export(module.exports, "default", () => $62ef4b19010ca280$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $62ef4b19010ca280$export$159d8c0e1862cd2b = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8U5xc"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-compliance/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$62ef4b19010ca280$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $62ef4b19010ca280$export$159d8c0e1862cd2b,
        pageId: "products-jsm-compliance",
        shouldShowSpinner: false
    });

});
parcelRegister("8U5xc", function(module, exports) {

let $67b7d8bd73dde0ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = $67b7d8bd73dde0ba$var$load("cbWbk").then(()=>parcelRequire('dxuco'));

});



parcelRegister("7p4oW", function(module, exports) {

$parcel$export(module.exports, "productsJsmConfigurationRouteEntry", () => $7c5012e44416fb27$export$461f2b06a7a914db);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $eMdJp = parcelRequire("eMdJp");

var $eKojW = parcelRequire("eKojW");
const $7c5012e44416fb27$export$461f2b06a7a914db = (0, $7NszV.createEntry)((0, $eMdJp.productsJsmConfigurationRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-configuration',
        component: (0, $eKojW.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eKojW.LazyProductsJsmConfiguration)
        ]
    }));

});
parcelRegister("eMdJp", function(module, exports) {

$parcel$export(module.exports, "productsJsmConfigurationRoute", () => $7d2ff473ef6296e1$export$2ad48fbde4743a97);
const $7d2ff473ef6296e1$export$2ad48fbde4743a97 = {
    name: 'products-jsm-configuration',
    path: '/jira/settings/products/jira-service-management-configuration',
    exact: true
};

});

parcelRegister("eKojW", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmConfiguration", () => $2e07bdac6faf88fe$export$aa3f3d5ca376f305);
$parcel$export(module.exports, "default", () => $2e07bdac6faf88fe$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $2e07bdac6faf88fe$export$aa3f3d5ca376f305 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4xSdy"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-configuration/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2e07bdac6faf88fe$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2e07bdac6faf88fe$export$aa3f3d5ca376f305,
        pageId: "products-jsm-configuration",
        shouldShowSpinner: false
    });

});
parcelRegister("4xSdy", function(module, exports) {

let $34f44cf4e5281376$var$load = (parcelRequire("28QjX"))(4);
module.exports = $34f44cf4e5281376$var$load("76E7u").then(()=>parcelRequire('14xmF'));

});



parcelRegister("GIsnE", function(module, exports) {

$parcel$export(module.exports, "productsJsmEmailRequestsRouteEntry", () => $4b72522d0ef4aab5$export$3f8d7424a47f4dd);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $3jDL8 = parcelRequire("3jDL8");

var $HR4Qz = parcelRequire("HR4Qz");
const $4b72522d0ef4aab5$export$3f8d7424a47f4dd = (0, $7NszV.createEntry)((0, $3jDL8.productsJsmEmailRequestsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-email-requests',
        component: (0, $HR4Qz.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $HR4Qz.LazyProductsJsmEmailRequests)
        ]
    }));

});
parcelRegister("3jDL8", function(module, exports) {

$parcel$export(module.exports, "productsJsmEmailRequestsRoute", () => $7687bd61dacb24e9$export$6288bb6ea42acf0c);
const $7687bd61dacb24e9$export$6288bb6ea42acf0c = {
    name: 'products-jsm-email-requests',
    path: '/jira/settings/products/jira-service-management-email-requests',
    exact: true
};

});

parcelRegister("HR4Qz", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmEmailRequests", () => $f8c99b7a302373fc$export$4c9d90d0caf04d67);
$parcel$export(module.exports, "default", () => $f8c99b7a302373fc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $f8c99b7a302373fc$export$4c9d90d0caf04d67 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5jEkL"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-email-requests/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f8c99b7a302373fc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f8c99b7a302373fc$export$4c9d90d0caf04d67,
        pageId: "products-jsm-email-requests",
        shouldShowSpinner: false
    });

});
parcelRegister("5jEkL", function(module, exports) {

let $3dee0392671059f1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3dee0392671059f1$var$load("245Fj").then(()=>parcelRequire('c81zX'));

});



parcelRegister("MSc9t", function(module, exports) {

$parcel$export(module.exports, "productsJsmFeatureUsageRouteEntry", () => $fc79a196d6d127dc$export$80a3e4dda2dcd1a4);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $lkQ6W = parcelRequire("lkQ6W");

var $gRzZD = parcelRequire("gRzZD");

var $3FCb0 = parcelRequire("3FCb0");
const $fc79a196d6d127dc$export$80a3e4dda2dcd1a4 = (0, $7NszV.createEntry)((0, $lkQ6W.productsJsmFeatureUsageRoute), ()=>({
        group: 'global-settings',
        component: (0, $3FCb0.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $gRzZD.workspaceResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3FCb0.LazyProductsJsmFeatureUsage)
        ]
    }));

});
parcelRegister("lkQ6W", function(module, exports) {

$parcel$export(module.exports, "productsJsmFeatureUsageRoute", () => $dcb61f2507bdacb1$export$f98dec539fffaa15);
const $dcb61f2507bdacb1$export$f98dec539fffaa15 = {
    name: 'products-jsm-feature-usage',
    path: '/jira/settings/products/servicedesk/feature-usage',
    exact: true
};

});

parcelRegister("3FCb0", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmFeatureUsage", () => $48028ef535c008c9$export$5ad1c1e822bd5d34);
$parcel$export(module.exports, "default", () => $48028ef535c008c9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $48028ef535c008c9$export$5ad1c1e822bd5d34 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9iauE"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-feature-usage/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$48028ef535c008c9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $48028ef535c008c9$export$5ad1c1e822bd5d34,
        pageId: "products-jsm-feature-usage",
        shouldShowSpinner: false
    });

});
parcelRegister("9iauE", function(module, exports) {

let $6c3def3ec8e0985b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6c3def3ec8e0985b$var$load("4vv1Q").then(()=>parcelRequire('g4KKw'));

});



parcelRegister("bpbCg", function(module, exports) {

$parcel$export(module.exports, "productsJsmGlobalOpsReportsRedirectRouteEntry", () => $5f3f997c6af1c603$export$289cc03f2eacd57a);

var $7Dwp8 = parcelRequire("7Dwp8");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $adTVI = parcelRequire("adTVI");

var $4HfNx = parcelRequire("4HfNx");
const $5f3f997c6af1c603$export$289cc03f2eacd57a = (0, $7NszV.createEntry)((0, $adTVI.productsJsmGlobalOpsReportsRedirectRoute), ()=>({
        group: 'global-settings',
        component: (0, $4HfNx.OpsReportsRedirect),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $7Dwp8.resources)(),
            (0, $7Dwp8.opsReportsPermissionResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4HfNx.LazyGlobalOpsReports)
        ]
    }));

});
parcelRegister("adTVI", function(module, exports) {

$parcel$export(module.exports, "productsJsmGlobalOpsReportsRedirectRoute", () => $3e538dded475ec91$export$c6d42e4b4a63248d);
const $3e538dded475ec91$export$c6d42e4b4a63248d = {
    name: 'products-jsm-global-ops-reports',
    path: '/jira/settings/products/ops/reports',
    exact: true
};

});

parcelRegister("4HfNx", function(module, exports) {

$parcel$export(module.exports, "LazyOpsReportsRedirect", () => $59dec6d88aab4fac$export$d33ea1a773b744e);
$parcel$export(module.exports, "LazyGlobalOpsReports", () => $59dec6d88aab4fac$export$66850ec5549adba6);
$parcel$export(module.exports, "OpsReportsRedirect", () => $59dec6d88aab4fac$export$22253dbadb46d0cf);
$parcel$export(module.exports, "GlobalOpsReports", () => $59dec6d88aab4fac$export$648ddf2d1f8b1c3f);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $59dec6d88aab4fac$export$2404f0e35deca592 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("k4RM2")), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $59dec6d88aab4fac$export$d33ea1a773b744e = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("k4RM2")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $59dec6d88aab4fac$export$66850ec5549adba6 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("k4RM2")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});
const $59dec6d88aab4fac$export$22253dbadb46d0cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $59dec6d88aab4fac$export$d33ea1a773b744e,
        pageId: "async-jira-eoc-ops-reports-redirect",
        shouldShowSpinner: false
    });
const $59dec6d88aab4fac$export$648ddf2d1f8b1c3f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $59dec6d88aab4fac$export$66850ec5549adba6,
        pageId: "async-jira-eoc-global-ops-reports",
        shouldShowSpinner: false
    });
const $59dec6d88aab4fac$export$87e6a54b4f5dc91e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $59dec6d88aab4fac$export$2404f0e35deca592,
        pageId: "async-jira-eoc-ops-reports",
        shouldShowSpinner: false
    });

});


parcelRegister("5X0aC", function(module, exports) {

$parcel$export(module.exports, "productsJsmGlobalOpsReportsRouteEntry", () => $61761389ad3b32bd$export$6a7fc41fb2523290);

var $7Dwp8 = parcelRequire("7Dwp8");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dDcek = parcelRequire("dDcek");

var $4HfNx = parcelRequire("4HfNx");
const $61761389ad3b32bd$export$6a7fc41fb2523290 = (0, $7NszV.createEntry)((0, $dDcek.productsJsmGlobalOpsReportsRoute), ()=>({
        group: 'global-settings',
        component: (0, $4HfNx.GlobalOpsReports),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $7Dwp8.resources)(),
            (0, $7Dwp8.opsReportsPermissionResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4HfNx.LazyOpsReportsRedirect)
        ]
    }));

});
parcelRegister("dDcek", function(module, exports) {

$parcel$export(module.exports, "productsJsmGlobalOpsReportsRoute", () => $126ddc8c4a59a59a$export$d92d66762943b115);
const $126ddc8c4a59a59a$export$d92d66762943b115 = {
    name: 'products-jsm-global-ops-reports',
    path: '/jira/settings/products/ops/reports/:dashboardId',
    exact: true
};

});


parcelRegister("fkWQj", function(module, exports) {

$parcel$export(module.exports, "productsJsmIncidentManagementToolsRouteEntry", () => $954e97d3acac763c$export$773f8e3318be1dd5);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $8PUrK = parcelRequire("8PUrK");

var $6MP9S = parcelRequire("6MP9S");
const $954e97d3acac763c$export$773f8e3318be1dd5 = (0, $7NszV.createEntry)((0, $8PUrK.productsJsmIncidentManagementToolsRoute), ()=>({
        group: 'global-settings',
        component: (0, $6MP9S.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6MP9S.LazyProductsJsmIncidentManagementTools)
        ]
    }));

});
parcelRegister("8PUrK", function(module, exports) {

$parcel$export(module.exports, "productsJsmIncidentManagementToolsRoute", () => $1d5dbffa04bebbb5$export$da6d538ddabade32);
const $1d5dbffa04bebbb5$export$da6d538ddabade32 = {
    name: 'products-jsm-incident-management-tools',
    path: '/jira/settings/products/jira-service-management-incident-management-tools',
    exact: true
};

});

parcelRegister("6MP9S", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmIncidentManagementTools", () => $63d70171d6cec69e$export$f541eb9b8f00bfaf);
$parcel$export(module.exports, "default", () => $63d70171d6cec69e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $63d70171d6cec69e$export$f541eb9b8f00bfaf = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("aW8sq"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-incident-management-tools/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$63d70171d6cec69e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $63d70171d6cec69e$export$f541eb9b8f00bfaf,
        pageId: "products-jsm-incident-management-tools",
        shouldShowSpinner: false
    });

});
parcelRegister("aW8sq", function(module, exports) {

let $7f65e1a45525d473$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7f65e1a45525d473$var$load("Z8lzP").then(()=>parcelRequire('joBQW'));

});



parcelRegister("7NO6v", function(module, exports) {

$parcel$export(module.exports, "productsJsmKbPermissionsRouteEntry", () => $b6759abef36b3efc$export$717e134eb971b450);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $2EpSF = parcelRequire("2EpSF");

var $knyuK = parcelRequire("knyuK");
const $b6759abef36b3efc$export$717e134eb971b450 = (0, $7NszV.createEntry)((0, $2EpSF.productsJsmKbPermissionsRoute), ()=>({
        group: 'global-settings',
        component: (0, $knyuK.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $knyuK.LazyProductsJsmKbPermissions)
        ]
    }));

});
parcelRegister("2EpSF", function(module, exports) {

$parcel$export(module.exports, "productsJsmKbPermissionsRoute", () => $a35de718c16ba9da$export$339486410c7a783f);
const $a35de718c16ba9da$export$339486410c7a783f = {
    name: 'products-jsm-kb-permissions',
    path: '/jira/settings/products/jira-service-management-knowledge-base-permissions',
    exact: true
};

});

parcelRegister("knyuK", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmKbPermissions", () => $724367026054fd0c$export$a3e7bdc5dbf2d47e);
$parcel$export(module.exports, "default", () => $724367026054fd0c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $724367026054fd0c$export$a3e7bdc5dbf2d47e = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cE6V9"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-kb-permissions/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$724367026054fd0c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $724367026054fd0c$export$a3e7bdc5dbf2d47e,
        pageId: "products-jsm-kb-permissions",
        shouldShowSpinner: false
    });

});
parcelRegister("cE6V9", function(module, exports) {

let $934e96cde7353903$var$load = (parcelRequire("28QjX"))(4);
module.exports = $934e96cde7353903$var$load("2dsVz").then(()=>parcelRequire('glk23'));

});



parcelRegister("gtJvE", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationsDetailsRouteEntry", () => $d5f0f03722be4af7$export$f7b6cda88404733e);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $38BXB = parcelRequire("38BXB");

var $7CBZS = parcelRequire("7CBZS");

var $6nu63 = parcelRequire("6nu63");

var $esddG = parcelRequire("esddG");

var $3RJkv = parcelRequire("3RJkv");

var $zsl89 = parcelRequire("zsl89");

var $5JNlT = parcelRequire("5JNlT");
const $d5f0f03722be4af7$export$f7b6cda88404733e = (0, $7NszV.createEntry)((0, $zsl89.productsJsmOrganizationsDetailsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-organization-page-list',
        isRedirect: false,
        component: (0, $5JNlT.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $7CBZS.productsJsmOrganizationDetailsResource),
            (0, $6nu63.productsJsmOrganizationMembersResource),
            (0, $esddG.productsJsmOrganizationListResource),
            (0, $38BXB.jsmEmailDomainsListResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5JNlT.LazyProductsJsmOrganizationDetails)
        ]
    }));

});
parcelRegister("38BXB", function(module, exports) {

$parcel$export(module.exports, "jsmEmailDomainsListResource", () => $02fee81a891a3dc1$export$8e956348e5d47a3c);

var $2M1hQ = parcelRequire("2M1hQ");


const $02fee81a891a3dc1$export$8e956348e5d47a3c = (0, $2M1hQ.createResource)({
    type: (0, $fb7ceb315fdf5327$export$2bde433b962efbdd),
    getKey: ()=>'email-domains-list',
    isBrowserOnly: true,
    getDataLoader: ()=>(parcelRequire("9eSpf"))
});

});
const $fb7ceb315fdf5327$export$2bde433b962efbdd = 'JSM_EMAIL_DOMAINS_LIST';

parcelRegister("9eSpf", function(module, exports) {

let $6b9f9fcb2b526b1d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6b9f9fcb2b526b1d$var$load("bY8Ab").then(()=>parcelRequire('bHzRo'));

});


parcelRegister("7CBZS", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationDetailsResource", () => $d8ebe0a210bfc926$export$ccda79811a15bf5);

var $2M1hQ = parcelRequire("2M1hQ");


const $d8ebe0a210bfc926$export$ccda79811a15bf5 = (0, $2M1hQ.createResource)({
    type: (0, $1b34d67fee3735c4$export$52408f1a0f23569a),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("dxjth"))
});

});
const $1b34d67fee3735c4$export$52408f1a0f23569a = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_DETAILS';

parcelRegister("dxjth", function(module, exports) {

let $9dad76087e876a52$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9dad76087e876a52$var$load("2PPIk").then(()=>parcelRequire('dXKCD'));

});


parcelRegister("6nu63", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationMembersResource", () => $36d00fa173b898da$export$65c7941bd3e14d00);

var $2M1hQ = parcelRequire("2M1hQ");

const $36d00fa173b898da$var$TEN_SECONDS_IN_MILLIS = 10000;

const $36d00fa173b898da$export$65c7941bd3e14d00 = (0, $2M1hQ.createResource)({
    type: (0, $b3f9f4e37cbce264$export$d3eec3e4b4eac6ac),
    getKey: (routerContext)=>`OrganizationMembers-${routerContext.match.params.organizationId}-${routerContext.query.page}-${routerContext.query.query}`,
    getDataLoader: ()=>(parcelRequire("g262m")),
    maxAge: $36d00fa173b898da$var$TEN_SECONDS_IN_MILLIS
});

});
const $b3f9f4e37cbce264$export$d3eec3e4b4eac6ac = 'PRODUCT_JSM_ORGANIZATION_MEMBERS';

parcelRegister("g262m", function(module, exports) {

let $bac1841127012a38$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bac1841127012a38$var$load("9Veo5").then(()=>parcelRequire('kx7O4'));

});


parcelRegister("esddG", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationListResource", () => $ad899c035903db82$export$3e38a27ad406d7f7);

var $2M1hQ = parcelRequire("2M1hQ");

const $ad899c035903db82$var$TEN_SECONDS_IN_MILLIS = 10000;

const $ad899c035903db82$export$3e38a27ad406d7f7 = (0, $2M1hQ.createResource)({
    type: (0, $5073c414a8292ea0$export$50de2841b08b875f),
    getKey: (routerContext)=>routerContext.query.page,
    getDataLoader: ()=>(parcelRequire("BETea")),
    maxAge: $ad899c035903db82$var$TEN_SECONDS_IN_MILLIS
});

});
const $5073c414a8292ea0$export$50de2841b08b875f = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST';

parcelRegister("BETea", function(module, exports) {

let $07132cac05b9bfb3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $07132cac05b9bfb3$var$load("hlkXx").then(()=>parcelRequire('v9BTs'));

});


parcelRegister("zsl89", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationsDetailsRoute", () => $a0ada8abfade1bcc$export$bc61991d01535831);
const $a0ada8abfade1bcc$export$bc61991d01535831 = {
    name: 'products-jsm-organizations',
    path: '/jira/settings/products/servicedesk/organizations/:organizationId',
    exact: true
};

});

parcelRegister("5JNlT", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmOrganizationDetails", () => $2542e7a566ffd224$export$ff149ceefa65ab70);
$parcel$export(module.exports, "default", () => $2542e7a566ffd224$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $2542e7a566ffd224$export$ff149ceefa65ab70 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6myJm"))), {
    moduleId: "./src/packages/admin-pages/products-jsm-organization-details/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2542e7a566ffd224$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2542e7a566ffd224$export$ff149ceefa65ab70,
        pageId: "products-jsm-organization-details",
        shouldShowSpinner: true
    });

});
parcelRegister("6myJm", function(module, exports) {

let $4a1fbcf48b9f9413$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4a1fbcf48b9f9413$var$load("eZECP").then(()=>parcelRequire('dgpeW'));

});



parcelRegister("hMqu9", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationsRouteEntry", () => $5dc17715cd6fddea$export$34d843946d3894aa);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $esddG = parcelRequire("esddG");

var $3RJkv = parcelRequire("3RJkv");

var $d6Cjb = parcelRequire("d6Cjb");

var $ckuB6 = parcelRequire("ckuB6");
const $5dc17715cd6fddea$export$34d843946d3894aa = (0, $7NszV.createEntry)((0, $d6Cjb.productsJsmOrganizationsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-organization-page-list',
        isRedirect: false,
        component: (0, $ckuB6.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $esddG.productsJsmOrganizationListResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ckuB6.LazyProductsJsmOrganizations)
        ]
    }));

});
parcelRegister("d6Cjb", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationsRoute", () => $aff64887f4e5e03c$export$512fa30726e0049d);
const $aff64887f4e5e03c$export$512fa30726e0049d = {
    name: 'products-jsm-organizations',
    path: '/jira/settings/products/servicedesk/organizations',
    exact: true
};

});

parcelRegister("ckuB6", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmOrganizations", () => $34fecedc618348fb$export$410bec6e06fd4723);
$parcel$export(module.exports, "default", () => $34fecedc618348fb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $34fecedc618348fb$export$410bec6e06fd4723 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eOaDh"))), {
    moduleId: "./src/packages/admin-pages/products-jsm-organizations-list/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$34fecedc618348fb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $34fecedc618348fb$export$410bec6e06fd4723,
        pageId: "products-jsm-organizations-list",
        shouldShowSpinner: true
    });

});
parcelRegister("eOaDh", function(module, exports) {

let $ac7dfb9f3268ff32$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ac7dfb9f3268ff32$var$load("1t34o").then(()=>parcelRequire('hfcIv'));

});



parcelRegister("7YRoH", function(module, exports) {

$parcel$export(module.exports, "productsJswConfigurationRouteEntry", () => $1733bfec88a8a7ea$export$2f65b1ec4ed05f91);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $hwXlc = parcelRequire("hwXlc");

var $8dDE8 = parcelRequire("8dDE8");

var $esWmF = parcelRequire("esWmF");
const $1733bfec88a8a7ea$export$2f65b1ec4ed05f91 = (0, $7NszV.createEntry)((0, $8dDE8.productsJswConfigurationRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsw-configuration',
        component: (0, $esWmF.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $hwXlc.productsJswConfigurationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $esWmF.LazyProductsJswConfiguration)
        ]
    }));

});
parcelRegister("hwXlc", function(module, exports) {

$parcel$export(module.exports, "productsJswConfigurationResource", () => $3248841597f2b624$export$b6a5741c2b47fb17);

var $2M1hQ = parcelRequire("2M1hQ");


const $3248841597f2b624$export$b6a5741c2b47fb17 = (0, $2M1hQ.createResource)({
    type: (0, $8b1aa0975152cf4f$export$73be8e1edd21e2d),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("4ZMji"))
});

});
const $8b1aa0975152cf4f$export$73be8e1edd21e2d = 'RESOURCE_TYPE_PRODUCT_JSW_CONFIGURATION';

parcelRegister("4ZMji", function(module, exports) {

let $3a325551a18485e2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3a325551a18485e2$var$load("2WYZL").then(()=>parcelRequire('bX4Lv'));

});


parcelRegister("8dDE8", function(module, exports) {

$parcel$export(module.exports, "productsJswConfigurationRoute", () => $ac36f76001e1c678$export$decdad53ba9b97af);
const $ac36f76001e1c678$export$decdad53ba9b97af = {
    name: 'products-jsw-configuration',
    path: '/jira/settings/products/jira-software-configuration',
    exact: true
};

});

parcelRegister("esWmF", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJswConfiguration", () => $90ae9e1263695143$export$f9a32397033f9ced);
$parcel$export(module.exports, "default", () => $90ae9e1263695143$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $90ae9e1263695143$export$f9a32397033f9ced = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cELzN"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-configuration/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$90ae9e1263695143$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $90ae9e1263695143$export$f9a32397033f9ced,
        pageId: "products-jsw-configuration",
        shouldShowSpinner: false
    });

});
parcelRegister("cELzN", function(module, exports) {

let $936e20268b7fc448$var$load = (parcelRequire("28QjX"))(4);
module.exports = $936e20268b7fc448$var$load("1Xl7E").then(()=>parcelRequire('1eYnA'));

});



parcelRegister("i0b8q", function(module, exports) {

$parcel$export(module.exports, "productsJswStorageManagementRouteEntry", () => $ebdca188f3705262$export$c62ca2d3fcc552a5);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $1vQWT = parcelRequire("1vQWT");

var $ab5pe = parcelRequire("ab5pe");

var $bARgN = parcelRequire("bARgN");
const $ebdca188f3705262$export$c62ca2d3fcc552a5 = (0, $7NszV.createEntry)((0, $ab5pe.productsJswStorageManagementRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsw-configuration.storage-management',
        component: (0, $bARgN.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $1vQWT.productsJswStorageManagementResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bARgN.LazyProductsJswStorageManagement)
        ]
    }));

});
parcelRegister("1vQWT", function(module, exports) {

$parcel$export(module.exports, "productsJswStorageManagementResource", () => $20cc0f4a1ad53cba$export$2cd668845b3478bd);

var $2M1hQ = parcelRequire("2M1hQ");


const $20cc0f4a1ad53cba$export$2cd668845b3478bd = (0, $2M1hQ.createResource)({
    type: (0, $593b84e85768ae60$export$1ac222647be3baf8),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("gShQz"))
});

});
const $593b84e85768ae60$export$1ac222647be3baf8 = 'RESOURCE_TYPE_PRODUCT_JSW_STORAGE_MANAGEMENT';

parcelRegister("gShQz", function(module, exports) {

let $c48f887e39812db4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c48f887e39812db4$var$load("jkZvt").then(()=>parcelRequire('a5z0r'));

});


parcelRegister("ab5pe", function(module, exports) {

$parcel$export(module.exports, "productsJswStorageManagementRoute", () => $7e2088c789cd548c$export$18f0044f00cc3996);
const $7e2088c789cd548c$export$18f0044f00cc3996 = {
    name: 'products-jsw-storage-management',
    path: '/jira/settings/products/jira-software-configuration/storage-management',
    exact: true
};

});

parcelRegister("bARgN", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJswStorageManagement", () => $bad793b8f28a1de3$export$a4f5e12ce817cbb8);
$parcel$export(module.exports, "default", () => $bad793b8f28a1de3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $bad793b8f28a1de3$export$a4f5e12ce817cbb8 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("2nlxM"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-storage-management/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bad793b8f28a1de3$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $bad793b8f28a1de3$export$a4f5e12ce817cbb8,
        pageId: "products-jsw-storage-management",
        shouldShowSpinner: true
    });

});
parcelRegister("2nlxM", function(module, exports) {

let $1bae70eb458cf73b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1bae70eb458cf73b$var$load("dsiAd"),
    $1bae70eb458cf73b$var$load("gWzc8")
]).then(()=>parcelRequire('2i4Yq'));

});



parcelRegister("jKCJe", function(module, exports) {

$parcel$export(module.exports, "proformaExportRouteEntry", () => $6ada90d55b94e879$export$27be010fc1b30f6c);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $gXbcB = parcelRequire("gXbcB");

var $6dVUC = parcelRequire("6dVUC");
const $6ada90d55b94e879$export$27be010fc1b30f6c = (0, $7NszV.createEntry)((0, $gXbcB.proformaExportRoute), ()=>({
        group: 'proforma',
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        component: (0, $6dVUC.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6dVUC.LazyProformaExport)
        ]
    }));

});
parcelRegister("gXbcB", function(module, exports) {

$parcel$export(module.exports, "proformaExportRoute", () => $e9663b2cd0ceb8c1$export$5130d152b1cda229);
const $e9663b2cd0ceb8c1$export$5130d152b1cda229 = {
    name: 'proforma-export',
    path: '/jira/forms/export',
    exact: true
};

});

parcelRegister("6dVUC", function(module, exports) {

$parcel$export(module.exports, "LazyProformaExport", () => $f012061ea42d3cc1$export$5e0d802a5d865352);
$parcel$export(module.exports, "default", () => $f012061ea42d3cc1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $f012061ea42d3cc1$export$5e0d802a5d865352 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("gbupq")), {
    moduleId: "./src/packages/spa-apps/proforma-export/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f012061ea42d3cc1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f012061ea42d3cc1$export$5e0d802a5d865352,
        pageId: "proforma-export",
        shouldShowSpinner: true
    });

});
parcelRegister("gbupq", function(module, exports) {

let $bc85430c28b58d8c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bc85430c28b58d8c$var$load("dw3QA").then(()=>parcelRequire('dtDoN'));

});



parcelRegister("iJIU8", function(module, exports) {

$parcel$export(module.exports, "proformaIssueFormsGeneralRouteEntry", () => $8d5b2002b38c1828$export$90d7a2fe9ba3bc11);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $jErk8 = parcelRequire("jErk8");

var $5cTgp = parcelRequire("5cTgp");
const $8d5b2002b38c1828$export$90d7a2fe9ba3bc11 = (0, $7NszV.createEntry)((0, $jErk8.proformaIssueFormsGeneralRoute), ()=>({
        group: 'proforma',
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        component: (0, $5cTgp.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5cTgp.LazyProformaIssueFormsGeneral)
        ],
        perfMetricKey: 'issue-forms-general'
    }));

});
parcelRegister("jErk8", function(module, exports) {

$parcel$export(module.exports, "proformaIssueFormsGeneralRoute", () => $6484903254af07fd$export$5e0c19066a4c3806);
const $6484903254af07fd$export$5e0c19066a4c3806 = {
    name: 'proforma-issue-forms-general',
    path: '/jira/forms/create',
    exact: true
};

});

parcelRegister("5cTgp", function(module, exports) {

$parcel$export(module.exports, "LazyProformaIssueFormsGeneral", () => $06427390ad9a129c$export$7c16b09eb95f1c5d);
$parcel$export(module.exports, "default", () => $06427390ad9a129c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $06427390ad9a129c$export$7c16b09eb95f1c5d = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("gzsjx")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-general/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$06427390ad9a129c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $06427390ad9a129c$export$7c16b09eb95f1c5d,
        pageId: "proforma-issue-forms-general",
        shouldShowSpinner: true
    });

});
parcelRegister("gzsjx", function(module, exports) {

let $c105e0d43a141b59$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c105e0d43a141b59$var$load("4lyh8").then(()=>parcelRequire('28Pju'));

});



parcelRegister("d6K18", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectEmbedRouteEntry", () => $93eb6540105b9307$export$99ff9a6f448db95c);

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $gtobw = parcelRequire("gtobw");

var $edJLT = parcelRequire("edJLT");
const $93eb6540105b9307$export$99ff9a6f448db95c = (0, $7NszV.createEntry)((0, $gtobw.classicBusinessProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'classic-business',
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        component: (0, $edJLT.default),
        forPaint: [
            (0, $edJLT.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    }));

});
parcelRegister("gtobw", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectEmbedRoute", () => $221926f6dc9630e3$export$92c0120052644a60);
const $221926f6dc9630e3$export$92c0120052644a60 = {
    name: 'classic-business-proforma-issue-forms-direct-embed',
    path: '/jira/core/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});

parcelRegister("edJLT", function(module, exports) {

$parcel$export(module.exports, "LazyProformaIssueFormsDirectEmbed", () => $321227a7cf9935db$export$22681210aaeb910f);
$parcel$export(module.exports, "default", () => $321227a7cf9935db$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $321227a7cf9935db$export$22681210aaeb910f = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("fNYbs")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$321227a7cf9935db$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $321227a7cf9935db$export$22681210aaeb910f,
        pageId: "proforma-issue-forms-direct-embed",
        shouldShowSpinner: true
    });

});
parcelRegister("fNYbs", function(module, exports) {

let $b81a1ddd52b0f761$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b81a1ddd52b0f761$var$load("a0moB").then(()=>parcelRequire('4RuJw'));

});



parcelRegister("lIfPP", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectRouteEntry", () => $f6035edc22ca57c1$export$8aa48763ac761f64);

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $e3tm3 = parcelRequire("e3tm3");

var $6VQ64 = parcelRequire("6VQ64");
const $f6035edc22ca57c1$export$8aa48763ac761f64 = (0, $7NszV.createEntry)((0, $e3tm3.classicBusinessProformaIssueFormsDirectRoute), ()=>({
        group: 'classic-business',
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        component: (0, $6VQ64.default),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        forPaint: [
            (0, $6VQ64.LazyProformaIssueFormsDirect)
        ],
        perfMetricKey: 'issue-forms-direct'
    }));

});
parcelRegister("e3tm3", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectRoute", () => $2adcae99a9770e81$export$97a413d49241d03b);
const $2adcae99a9770e81$export$97a413d49241d03b = {
    name: 'classic-business-proforma-issue-forms-direct',
    path: '/jira/core/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});

parcelRegister("6VQ64", function(module, exports) {

$parcel$export(module.exports, "LazyProformaIssueFormsDirect", () => $33e9f81a484baab5$export$a0f04dd35569e11);
$parcel$export(module.exports, "default", () => $33e9f81a484baab5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $33e9f81a484baab5$export$a0f04dd35569e11 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("0518c")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$33e9f81a484baab5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $33e9f81a484baab5$export$a0f04dd35569e11,
        pageId: "proforma-issue-forms-direct",
        shouldShowSpinner: true
    });

});
parcelRegister("0518c", function(module, exports) {

let $00f15862e3ee7e53$var$load = (parcelRequire("28QjX"))(4);
module.exports = $00f15862e3ee7e53$var$load("jmhtg").then(()=>parcelRequire('izbAs'));

});



parcelRegister("1rMUU", function(module, exports) {

$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectEmbedRouteEntry", () => $240624c6c03e7472$export$2792607788ca81db);

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $chOdK = parcelRequire("chOdK");

var $edJLT = parcelRequire("edJLT");
const $240624c6c03e7472$export$2792607788ca81db = (0, $7NszV.createEntry)((0, $chOdK.servicedeskProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        component: (0, $edJLT.default),
        forPaint: [
            (0, $edJLT.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    }));

});
parcelRegister("chOdK", function(module, exports) {

$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectEmbedRoute", () => $920134fe3a6eefea$export$bf24763c9fc04bde);
const $920134fe3a6eefea$export$bf24763c9fc04bde = {
    name: 'servicedesk-proforma-issue-forms-direct-embed',
    path: '/jira/servicedesk/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});


parcelRegister("36qRE", function(module, exports) {

$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectRouteEntry", () => $6c7c317c40c5c36f$export$f249c6e19ad4181e);

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $lPvHo = parcelRequire("lPvHo");

var $6Z2mh = parcelRequire("6Z2mh");

var $6VQ64 = parcelRequire("6VQ64");
const $6c7c317c40c5c36f$export$f249c6e19ad4181e = (0, $7NszV.createEntry)((0, $lPvHo.servicedeskProformaIssueFormsDirectRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        component: (0, $6VQ64.default),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        forPaint: [
            (0, $6VQ64.LazyProformaIssueFormsDirect)
        ],
        perfMetricKey: 'issue-forms-direct'
    }));

});
parcelRegister("lPvHo", function(module, exports) {

$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectRoute", () => $2c9a39a116b2202b$export$9b51b0994bb4b8f0);
const $2c9a39a116b2202b$export$9b51b0994bb4b8f0 = {
    name: 'servicedesk-proforma-issue-forms-direct',
    path: '/jira/servicedesk/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});


parcelRegister("2LfmF", function(module, exports) {

$parcel$export(module.exports, "softwareProformaIssueFormsDirectEmbedRouteEntry", () => $035b18afb2a6d438$export$6df3cef5dab31b3b);

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $6WV7L = parcelRequire("6WV7L");

var $edJLT = parcelRequire("edJLT");
const $035b18afb2a6d438$export$6df3cef5dab31b3b = (0, $7NszV.createEntry)((0, $6WV7L.softwareProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'software',
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        component: (0, $edJLT.default),
        forPaint: [
            (0, $edJLT.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    }));

});
parcelRegister("6WV7L", function(module, exports) {

$parcel$export(module.exports, "softwareProformaIssueFormsDirectEmbedRoute", () => $1f48b8cd07e58720$export$6d1b944aeb758fdb);
const $1f48b8cd07e58720$export$6d1b944aeb758fdb = {
    name: 'software-proforma-issue-forms-direct-embed',
    path: '/jira/software/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});


parcelRegister("gzdNI", function(module, exports) {

$parcel$export(module.exports, "softwareProformaIssueFormsDirectRouteEntry", () => $d039f624036d1510$export$552db754a91368f3);

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $cLf5Y = parcelRequire("cLf5Y");

var $e7bC3 = parcelRequire("e7bC3");

var $6VQ64 = parcelRequire("6VQ64");
const $d039f624036d1510$export$552db754a91368f3 = (0, $7NszV.createEntry)((0, $cLf5Y.softwareProformaIssueFormsDirectRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        component: (0, $6VQ64.default),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        forPaint: [
            (0, $6VQ64.LazyProformaIssueFormsDirect)
        ],
        perfMetricKey: 'issue-forms-direct'
    }));

});
parcelRegister("cLf5Y", function(module, exports) {

$parcel$export(module.exports, "softwareProformaIssueFormsDirectRoute", () => $8a64da0a8be5ef24$export$69db7046ead228b9);
const $8a64da0a8be5ef24$export$69db7046ead228b9 = {
    name: 'software-proforma-issue-forms-direct',
    path: '/jira/software/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});


parcelRegister("64qpc", function(module, exports) {

$parcel$export(module.exports, "projectComponentsRedirectRouteEntry", () => $4b7fc303ce7a2a17$export$b498607b4440c4ef);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $xNRJ9 = parcelRequire("xNRJ9");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $9Qrwv = parcelRequire("9Qrwv");

var $holgx = parcelRequire("holgx");
const $4b7fc303ce7a2a17$export$b498607b4440c4ef = (0, $7NszV.createEntry)((0, $9Qrwv.projectComponentsRedirectRoute), ()=>({
        group: 'components',
        component: !false ? (0, $holgx.ComponentsRedirect) : undefined,
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $xNRJ9.projectsComponentsResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        isRedirect: true
    }));

});
parcelRegister("xNRJ9", function(module, exports) {

$parcel$export(module.exports, "projectsComponentsResource", () => $e6f1f6e8951a4819$export$557cc3eff8939b3);

var $kbVA4 = parcelRequire("kbVA4");

var $2M1hQ = parcelRequire("2M1hQ");


const $e6f1f6e8951a4819$export$557cc3eff8939b3 = (0, $2M1hQ.createResource)({
    type: (0, $7f7620b307267b7d$export$ae1b86a8daeb387d),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("1ufzo")),
    maxAge: (0, $kbVA4.MIN_MAX_AGE)
});

});
const $7f7620b307267b7d$export$ae1b86a8daeb387d = 'PROJECTS_COMPONENTS';

parcelRegister("1ufzo", function(module, exports) {

let $1154aba2994a9246$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1154aba2994a9246$var$load("bUZ7U").then(()=>parcelRequire('77Eyd'));

});


parcelRegister("9Qrwv", function(module, exports) {

$parcel$export(module.exports, "projectComponentsRedirectRoute", () => $ca17ca5646521c59$export$d370abe25253fa1b);

var $jhtWp = parcelRequire("jhtWp");
const $ca17ca5646521c59$export$d370abe25253fa1b = {
    name: 'project-components-redirect',
    path: '/projects/:projectKey',
    query: (0, $jhtWp.PROJECTS_COMPONENTS_QUERY_PARAMS)
};

});
parcelRegister("jhtWp", function(module, exports) {

$parcel$export(module.exports, "PROJECTS_COMPONENTS_QUERY_PARAMS", () => $650eb9307abab3e5$export$1d7a0c194c3e83f2);
const $650eb9307abab3e5$export$1d7a0c194c3e83f2 = [
    'selectedItem=com.atlassian.jira.jira-projects-plugin:components-page'
];

});


parcelRegister("holgx", function(module, exports) {

$parcel$export(module.exports, "ComponentsRedirect", () => $15d396b2dbadf93f$export$9cf9ae84482ff18e);

var $5uXOq = parcelRequire("5uXOq");

var $aZsz6 = parcelRequire("aZsz6");

var $6XreI = parcelRequire("6XreI");
const $15d396b2dbadf93f$export$9cf9ae84482ff18e = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $aZsz6.qs).stringify(rest, true);
        return `/components${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6XreI.RedirectToProjectType), {
        page: page
    });
};

});
parcelRegister("6XreI", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $d19b3848ac7d27f0$export$8a3df560509448b8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $dxCvy = parcelRequire("dxCvy");

var $bVDE5 = parcelRequire("bVDE5");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");
const $d19b3848ac7d27f0$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $7tQej.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $bngFq.useAnalyticsEvents), useResource: useResource = (0, $2YP9W.useResource), useRouter: useRouter = (0, $doZTA.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $bVDE5.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $dxCvy.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
    (0, $5uXOq.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $2vSU6.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $2vSU6.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});



parcelRegister("87aC7", function(module, exports) {

$parcel$export(module.exports, "projectComponentsRouteEntry", () => $97d73743db912d34$export$e60f53ff5ae626cd);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $xNRJ9 = parcelRequire("xNRJ9");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $59Kn5 = parcelRequire("59Kn5");

var $lkFvK = parcelRequire("lkFvK");

var $fo6b8 = parcelRequire("fo6b8");

var $7JEuc = parcelRequire("7JEuc");
const $97d73743db912d34$var$projectComponentsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7JEuc.projectComponentsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $97d73743db912d34$export$e60f53ff5ae626cd = (0, $7NszV.createEntry)((0, $59Kn5.projectComponentsRoute), ()=>({
        group: 'components',
        ufoName: 'project-components-view',
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $xNRJ9.projectsComponentsResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$97d73743db912d34$var$projectComponentsPageEntryPoint
    }));

});
parcelRegister("59Kn5", function(module, exports) {

$parcel$export(module.exports, "projectComponentsRoute", () => $c0c0fb35b16dfdd1$export$f76189bea494b0b8);
const $c0c0fb35b16dfdd1$export$f76189bea494b0b8 = {
    name: 'project-components',
    path: '/jira/:projectType(software|software/c|servicedesk|core)/projects/:projectKey/components'
};

});

parcelRegister("7JEuc", function(module, exports) {

$parcel$export(module.exports, "projectComponentsEntrypoint", () => $ba5b4d8c4394f047$export$d90db228c6acd520);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $ba5b4d8c4394f047$export$d90db228c6acd520 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("fwBnJ")), {
        moduleId: "f6db472c"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fwBnJ", function(module, exports) {

let $b4d6d7676f777e65$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b4d6d7676f777e65$var$load("h2MrD"),
    $b4d6d7676f777e65$var$load("bYT2S"),
    $b4d6d7676f777e65$var$load("dsiAd"),
    $b4d6d7676f777e65$var$load("dRI4W")
]).then(()=>parcelRequire('2NjcZ'));

});



parcelRegister("hPrN5", function(module, exports) {

$parcel$export(module.exports, "projectNotFoundRouteEntry", () => $292badf40134cb3e$export$beae48175e3016b8);

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $frKbc = parcelRequire("frKbc");

var $T9TsM = parcelRequire("T9TsM");
const $292badf40134cb3e$var$projectNotFoundPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $T9TsM.projectNotFoundEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $292badf40134cb3e$export$beae48175e3016b8 = (0, $7NszV.createEntry)((0, $frKbc.projectNotFoundRoute), ()=>({
        group: 'errors',
        entryPoint () {
            return $292badf40134cb3e$var$projectNotFoundPageEntryPoint;
        },
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        pageId: 'project-not-found-page-id'
    }));

});
parcelRegister("frKbc", function(module, exports) {

$parcel$export(module.exports, "projectNotFoundRoute", () => $5f4b2f1efa38e84e$export$ad23ddca45852d02);
const $5f4b2f1efa38e84e$export$ad23ddca45852d02 = {
    name: 'project-not-found',
    path: '/jira/:projectType(software|servicedesk|core|polaris)/projects/not-found',
    exact: true
};

});

parcelRegister("T9TsM", function(module, exports) {

$parcel$export(module.exports, "projectNotFoundEntryPoint", () => $ad3635ddd4e67df5$export$6ffa2f426ba3b25a);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $ad3635ddd4e67df5$export$6ffa2f426ba3b25a = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("bRxt0")), {
        moduleId: "51ed29c5"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bRxt0", function(module, exports) {

let $8a2e9ac8251601e5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8a2e9ac8251601e5$var$load("d3O83").then(()=>parcelRequire('L9JRT'));

});



parcelRegister("kKEWZ", function(module, exports) {

$parcel$export(module.exports, "projectPagesLegacyRouteEntry", () => $5b3bb769f5acfa20$export$5788c5f8c4e440b1);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $4U4Td = parcelRequire("4U4Td");

var $9V7O8 = parcelRequire("9V7O8");
const $5b3bb769f5acfa20$export$5788c5f8c4e440b1 = (0, $7NszV.createEntry)((0, $4U4Td.projectPagesLegacyRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: !false ? (0, $9V7O8.PagesRedirect) : (0, $9V7O8.default),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9V7O8.LazyProjectPages)
        ],
        isRedirect: true
    }));

});
parcelRegister("4U4Td", function(module, exports) {

$parcel$export(module.exports, "projectPagesLegacyRoute", () => $25092ed805d69948$export$a82cbb9b9c689c40);
const $25092ed805d69948$export$a82cbb9b9c689c40 = {
    name: 'project-pages-legacy',
    path: '/projects/:projectKey',
    query: [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:project-pages-page'
    ]
};

});

parcelRegister("9V7O8", function(module, exports) {

$parcel$export(module.exports, "LazyProjectPages", () => $4be66c9d92628f7f$export$c2115a649411f570);
$parcel$export(module.exports, "PagesRedirect", () => $4be66c9d92628f7f$export$7c3b1828ada63555);
$parcel$export(module.exports, "default", () => $4be66c9d92628f7f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $3jbwx = parcelRequire("3jbwx");

const $4be66c9d92628f7f$export$c2115a649411f570 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hs387"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/project/pages/src/index.tsx"
});
const $4be66c9d92628f7f$export$7c3b1828ada63555 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jbwx.RedirectToProjectType), {
        page: "/pages"
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4be66c9d92628f7f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4be66c9d92628f7f$export$c2115a649411f570,
        pageId: "project-pages",
        shouldShowSpinner: false
    });

});
parcelRegister("3jbwx", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $b1c3ef54235a025d$export$8a3df560509448b8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $dxCvy = parcelRequire("dxCvy");

var $bVDE5 = parcelRequire("bVDE5");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");
const $b1c3ef54235a025d$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $7tQej.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $bngFq.useAnalyticsEvents), useResource: useResource = (0, $2YP9W.useResource), useRouter: useRouter = (0, $doZTA.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $bVDE5.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $dxCvy.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
    (0, $5uXOq.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $2vSU6.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $2vSU6.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});

parcelRegister("hs387", function(module, exports) {

let $cb477abe17a06edd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cb477abe17a06edd$var$load("3dqRu").then(()=>parcelRequire('8nMC7'));

});



parcelRegister("ljItG", function(module, exports) {

$parcel$export(module.exports, "projectPagesRouteEntry", () => $ec177ab479977ba2$export$babf32528ef518e9);

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $gTBUm = parcelRequire("gTBUm");

var $kfztd = parcelRequire("kfztd");

var $9V7O8 = parcelRequire("9V7O8");
const $ec177ab479977ba2$export$babf32528ef518e9 = (0, $7NszV.createEntry)((0, $gTBUm.projectPagesRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $9V7O8.default)),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9V7O8.LazyProjectPages)
        ]
    }));

});
parcelRegister("gTBUm", function(module, exports) {

$parcel$export(module.exports, "projectPagesRoute", () => $b32f9068985446b1$export$54a218ca6d1c056a);
const $b32f9068985446b1$export$54a218ca6d1c056a = {
    name: 'project-pages',
    path: '/jira/:projectType(software|software/c|servicedesk)/projects/:projectKey/pages'
};

});


parcelRegister("6JQwt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsComponentsRouteEntry", () => $ad71816b701c4a98$export$72497f4e39dd0df4);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $xNRJ9 = parcelRequire("xNRJ9");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cQsSp = parcelRequire("cQsSp");

var $cSUZZ = parcelRequire("cSUZZ");

var $d83t6 = parcelRequire("d83t6");
const $ad71816b701c4a98$export$72497f4e39dd0df4 = (0, $7NszV.createEntry)((0, $cQsSp.projectSettingsComponentsRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource),
            (0, $xNRJ9.projectsComponentsResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $d83t6.default),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $d83t6.LazyProjectComponentsSettings)
        ]
    }));

});
parcelRegister("cQsSp", function(module, exports) {

$parcel$export(module.exports, "projectSettingsComponentsRoute", () => $d6034f5b9e9794c0$export$79cbce13eeecd53);
const $d6034f5b9e9794c0$export$79cbce13eeecd53 = {
    name: 'project-settings-components',
    path: '/plugins/servlet/project-config/:projectKey/administer-components'
};

});

parcelRegister("d83t6", function(module, exports) {

$parcel$export(module.exports, "LazyProjectComponentsSettings", () => $2794979f407c5b17$export$bb69d8c36391123);
$parcel$export(module.exports, "default", () => $2794979f407c5b17$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aZsz6 = parcelRequire("aZsz6");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $a25Ol = parcelRequire("a25Ol");

const $2794979f407c5b17$export$bb69d8c36391123 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("fwBnJ"))), {
    moduleId: "./src/packages/spa-apps/project/components/src/index.tsx"
});
const $2794979f407c5b17$export$60cfbcd781a48d01 = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $aZsz6.qs).stringify(rest, true);
        return `/settings/components${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a25Ol.RedirectToProjectType), {
        page: page
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2794979f407c5b17$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2794979f407c5b17$export$bb69d8c36391123,
        pageId: "project-settings-components",
        shouldShowSpinner: true
    });

});
parcelRegister("a25Ol", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $55786e10b01ad2e7$export$8a3df560509448b8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $dxCvy = parcelRequire("dxCvy");

var $bVDE5 = parcelRequire("bVDE5");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");
const $55786e10b01ad2e7$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $7tQej.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $bngFq.useAnalyticsEvents), useResource: useResource = (0, $2YP9W.useResource), useRouter: useRouter = (0, $doZTA.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $bVDE5.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $dxCvy.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
    (0, $5uXOq.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $2vSU6.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $2vSU6.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});



parcelRegister("dRm2C", function(module, exports) {

$parcel$export(module.exports, "projectSettingsVersionsRouteEntry", () => $1aa15c245eff2860$export$4791201b4877aa5d);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $bC7QJ = parcelRequire("bC7QJ");

var $7GnDe = parcelRequire("7GnDe");

var $cXVqt = parcelRequire("cXVqt");

var $cSUZZ = parcelRequire("cSUZZ");

var $af7CK = parcelRequire("af7CK");
const $1aa15c245eff2860$export$4791201b4877aa5d = (0, $7NszV.createEntry)((0, $cXVqt.projectSettingsVersionsRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource),
            (0, $bC7QJ.projectVersionsRelayResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $af7CK.RelayVersions),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $af7CK.LazyRelayProjectVersions)
        ]
    }));

});
parcelRegister("bC7QJ", function(module, exports) {

$parcel$export(module.exports, "projectVersionsRelayResource", () => $d194483d3a062e97$export$7e8aa1360f86345c);
/* eslint-disable jira/import-whitelist */ 
var $8Uumt = parcelRequire("8Uumt");


var $e8T8A = parcelRequire("e8T8A");

var $5yJb9 = parcelRequire("5yJb9");

var $kipqU = parcelRequire("kipqU");

var $ao2h1 = parcelRequire("ao2h1");

var $lqMPx = parcelRequire("lqMPx");

var $2M1hQ = parcelRequire("2M1hQ");

const $d194483d3a062e97$export$7e8aa1360f86345c = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${(0, $92b865e141ed2a4f$export$59aa73792ad9507a)}`,
    getKey: ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        return `project-version-query-relay-${projectKey}`;
    },
    // @ts-expect-error - might return null
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const variables = {
            initialLoadCount: 20,
            cloudId: tenantContext.cloudId,
            projectKey: match.params.projectKey,
            filter: (0, $e8T8A.transformStatusFromParam)(query[0, $6868fc0fce0c2912$export$3e8168848b996f7]),
            searchString: query[0, $6868fc0fce0c2912$export$a181206198b7f50c] || '',
            sortBy: {
                sortByField: (0, $e8T8A.transformSortFieldFromParam)(query[0, $6868fc0fce0c2912$export$a3482d3a8df0e725]),
                order: (0, $e8T8A.transformSortOrderFromParam)(query[0, $6868fc0fce0c2912$export$71089821f361e881])
            }
        };
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $lqMPx.default), variables, {
            fetchPolicy: 'store-or-network'
        });
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
const $6868fc0fce0c2912$export$a181206198b7f50c = 'contains';
const $6868fc0fce0c2912$export$3e8168848b996f7 = 'status';
const $6868fc0fce0c2912$export$71089821f361e881 = 'orderDirection';
const $6868fc0fce0c2912$export$a3482d3a8df0e725 = 'orderField';
const $6868fc0fce0c2912$export$3c5e605ca7ade9f2 = 'NAME';
const $6868fc0fce0c2912$export$50241fe906e4f94e = 'RELEASE_DATE';
const $6868fc0fce0c2912$export$99a467bcc22b8df9 = 'START_DATE';
const $6868fc0fce0c2912$export$d44826c816b5619b = 'DESCRIPTION';
const $6868fc0fce0c2912$export$34694f8d8b23ee2a = 'SEQUENCE';
const $6868fc0fce0c2912$export$cb638d1fae624fbf = 20;
const $6868fc0fce0c2912$export$bbcbc202f2dfa28c = 3;
const $6868fc0fce0c2912$export$b983f2cb1f658a55 = 'RELEASED';
const $6868fc0fce0c2912$export$cb459d726a8530a5 = 'UNRELEASED';
const $6868fc0fce0c2912$export$c936349447a77fe0 = 'ARCHIVED';
const $6868fc0fce0c2912$export$c5ed97509d0e2aaf = 'projectVersions';

parcelRegister("e8T8A", function(module, exports) {

$parcel$export(module.exports, "transformStatusFromParam", () => $b959dd84148d7436$export$5760f9690301cdb);
$parcel$export(module.exports, "transformStatusToParam", () => $b959dd84148d7436$export$46595832dd863016);
$parcel$export(module.exports, "transformSortOrderFromParam", () => $b959dd84148d7436$export$1945e6d2f31e09e6);
$parcel$export(module.exports, "transformSortFieldFromParam", () => $b959dd84148d7436$export$f842a0d1846d319d);
$parcel$export(module.exports, "transformStatusToDropdownSelection", () => $b959dd84148d7436$export$7dad705635760cfe);
$parcel$export(module.exports, "getUpdatedDisplayedStatuses", () => $b959dd84148d7436$export$ce4c948ba1d53df4);
$parcel$export(module.exports, "getFormattedVersionDate", () => $b959dd84148d7436$export$5a6eeb16be7dd21d);


var $1O7Kb = parcelRequire("1O7Kb");

var $brjCS = parcelRequire("brjCS");

const $b959dd84148d7436$export$5760f9690301cdb = (input)=>{
    switch(input){
        case 'no-filter':
            return [
                (0, $brjCS.RELEASED),
                (0, $brjCS.UNRELEASED),
                (0, $brjCS.ARCHIVED)
            ];
        case 'all':
            return [
                (0, $brjCS.RELEASED),
                (0, $brjCS.UNRELEASED),
                (0, $brjCS.ARCHIVED)
            ];
        default:
            {
                const params = (input || '').split('-');
                const result = [
                    ...params.includes('released') ? [
                        (0, $brjCS.RELEASED)
                    ] : [],
                    ...params.includes('unreleased') ? [
                        (0, $brjCS.UNRELEASED)
                    ] : [],
                    ...params.includes('archived') ? [
                        (0, $brjCS.ARCHIVED)
                    ] : []
                ];
                return result.length ? result : [
                    (0, $brjCS.UNRELEASED)
                ];
            }
    }
};
const $b959dd84148d7436$export$46595832dd863016 = (input)=>{
    if (input) {
        if (input.length === 0) return 'no-filter';
        if (input.length > 2) return 'all';
        return [
            input.includes((0, $brjCS.RELEASED)) && [
                'released'
            ],
            input.includes((0, $brjCS.UNRELEASED)) && [
                'unreleased'
            ],
            input.includes((0, $brjCS.ARCHIVED)) && [
                'archived'
            ]
        ].filter(Boolean).join('-');
    }
    return undefined;
};
const $b959dd84148d7436$export$1945e6d2f31e09e6 = (input)=>{
    switch(input){
        case 'ASC':
            return 0, $2a9e000a443b1a95$export$1dee026a19752d6b;
        case 'DESC':
            return 0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65;
        default:
            return 0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65;
    }
};
const $b959dd84148d7436$export$f842a0d1846d319d = (input)=>{
    switch(input){
        case 'NAME':
            return 0, $6868fc0fce0c2912$export$3c5e605ca7ade9f2;
        case 'RELEASEDATE':
            return 0, $6868fc0fce0c2912$export$50241fe906e4f94e;
        case 'STARTDATE':
            return 0, $6868fc0fce0c2912$export$99a467bcc22b8df9;
        case 'DESCRIPTION':
            return 0, $6868fc0fce0c2912$export$d44826c816b5619b;
        case 'SEQUENCE':
            return 0, $6868fc0fce0c2912$export$34694f8d8b23ee2a;
        default:
            return 0, $6868fc0fce0c2912$export$34694f8d8b23ee2a;
    }
};
const $b959dd84148d7436$export$7dad705635760cfe = (input)=>{
    switch(input){
        case 'no-filter':
            return [];
        case 'all':
            return [
                (0, $brjCS.RELEASED),
                (0, $brjCS.UNRELEASED),
                (0, $brjCS.ARCHIVED)
            ];
        default:
            {
                const params = (input || '').split('-');
                const result = [
                    ...params.includes('released') ? [
                        (0, $brjCS.RELEASED)
                    ] : [],
                    ...params.includes('unreleased') ? [
                        (0, $brjCS.UNRELEASED)
                    ] : [],
                    ...params.includes('archived') ? [
                        (0, $brjCS.ARCHIVED)
                    ] : []
                ];
                return result.length ? result : [
                    (0, $brjCS.UNRELEASED)
                ];
            }
    }
};
const $b959dd84148d7436$export$ce4c948ba1d53df4 = (displayedStatuses, selectedStatuses, newStatus)=>{
    // Handle the case when a status is selected after deselection of all in dropdown where versions in all statuses are displayed despite empty selection & deselecting a status from a full selection.
    if (displayedStatuses.length === (0, $6868fc0fce0c2912$export$bbcbc202f2dfa28c)) {
        if (!selectedStatuses.length) return [
            newStatus
        ];
        return displayedStatuses.filter((status)=>status !== newStatus);
    }
    return displayedStatuses.includes(newStatus) ? displayedStatuses.filter((item)=>item !== newStatus) : [
        ...displayedStatuses,
        newStatus
    ];
};
const $b959dd84148d7436$export$5a6eeb16be7dd21d = (versionDate, formatDate)=>versionDate != null ? formatDate(new Date(versionDate), {
        timeZone: (0, $1O7Kb.VERSION_DATE_FORMAT_OPTION).timeZone,
        dateStyle: 'long'
    }) : '';

});
parcelRegister("1O7Kb", function(module, exports) {

$parcel$export(module.exports, "VERSION_DATE_FORMAT_OPTION", () => $db4b27c65287280e$export$d54c0d576c2caef5);
// Used to format date string from the server to display version start date and release date
// Server only stores date without any time information such as 2023-12-31
// Use this WHENEVER displaying version start date and release date.
// If you respect local timezone without this constant, there will be a bug that will display one day early date in negative timezones.
// https://jira.atlassian.com/browse/JSWCLOUD-22316
const $db4b27c65287280e$export$d54c0d576c2caef5 = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
};

});

parcelRegister("brjCS", function(module, exports) {

$parcel$export(module.exports, "RELEASED", () => $96a1491cb0f9d4eb$export$b983f2cb1f658a55);
$parcel$export(module.exports, "UNRELEASED", () => $96a1491cb0f9d4eb$export$cb459d726a8530a5);
$parcel$export(module.exports, "ARCHIVED", () => $96a1491cb0f9d4eb$export$c936349447a77fe0);
const $96a1491cb0f9d4eb$export$b983f2cb1f658a55 = 'RELEASED';
const $96a1491cb0f9d4eb$export$cb459d726a8530a5 = 'UNRELEASED';
const $96a1491cb0f9d4eb$export$c936349447a77fe0 = 'ARCHIVED';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$96a1491cb0f9d4eb$export$2e2bcd8739ae039 = [
    $96a1491cb0f9d4eb$export$b983f2cb1f658a55,
    $96a1491cb0f9d4eb$export$cb459d726a8530a5,
    $96a1491cb0f9d4eb$export$c936349447a77fe0
];

});


parcelRegister("lqMPx", function(module, exports) {

$parcel$export(module.exports, "default", () => $08cc25b93689af36$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4773dfa585b123cf147a002224770bf9>>
 * @relayHash dec95c3e2f1a0bed50748094ec8e58c5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f76dd05bae048a4cca05a26b3eab8c7c9e93504f0330e0480cb0b2109b0e0a50
const $08cc25b93689af36$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "initialLoadCount"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = {
        "kind": "ScalarField",
        "name": "key"
    }, v10 = {
        "alias": "jiraProjectType",
        "kind": "ScalarField",
        "name": "projectType"
    }, v11 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v12 = {
        "kind": "Variable",
        "name": "searchString",
        "variableName": "searchString"
    }, v13 = {
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "sortBy"
    }, v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v15 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v16 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v17 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v18 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v19 = [
        v11 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "initialLoadCount"
        },
        v12 /*: any*/ ,
        v13 /*: any*/ 
    ], v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v22 = [
        v21 /*: any*/ 
    ], v23 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": "DONE"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiProjectVersionsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v7 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.projectId"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.name"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.key"
                                        },
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "alias": "versions",
                                                "args": [
                                                    v11 /*: any*/ ,
                                                    v12 /*: any*/ ,
                                                    v13 /*: any*/ 
                                                ],
                                                "concreteType": "JiraVersionConnection",
                                                "kind": "LinkedField",
                                                "name": "__uiProject__versions_connection",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraVersionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            v14 /*: any*/ ,
                                                            v15 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraVersion",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v14 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "errors",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "extensions",
                                                                "plural": true,
                                                                "selections": [
                                                                    v16 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v17 /*: any*/ ,
                                                    v18 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.versions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": v19 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "table_projectVersions"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiProjectVersionsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "args": v19 /*: any*/ ,
                                    "concreteType": "JiraVersionConnection",
                                    "kind": "LinkedField",
                                    "name": "versions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraVersion",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "status"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "startDate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "releaseDate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "overdue"
                                                        },
                                                        {
                                                            "alias": "allIssues",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "ALL"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v22 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"ALL\")"
                                                        },
                                                        {
                                                            "alias": "doneIssues",
                                                            "args": v23 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v22 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"DONE\")"
                                                        },
                                                        {
                                                            "alias": "done",
                                                            "args": v23 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v22 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"DONE\")"
                                                        },
                                                        {
                                                            "alias": "inProgress",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "IN_PROGRESS"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v22 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"IN_PROGRESS\")"
                                                        },
                                                        {
                                                            "alias": "toDo",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "TODO"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v22 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"TODO\")"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "versionId"
                                                        },
                                                        v8 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v16 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v19 /*: any*/ ,
                                    "filters": [
                                        "filter",
                                        "searchString",
                                        "sortBy"
                                    ],
                                    "handle": "connection",
                                    "key": "uiProject__versions",
                                    "kind": "LinkedHandle",
                                    "name": "versions"
                                },
                                v20 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f76dd05bae048a4cca05a26b3eab8c7c9e93504f0330e0480cb0b2109b0e0a50",
            "metadata": {
                "connection": [
                    {
                        "count": "initialLoadCount",
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "jira",
                            "jiraProjectByKey",
                            "versions"
                        ]
                    }
                ]
            },
            "name": "uiProjectVersionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$08cc25b93689af36$var$node.hash = "e191f493ecf54a5896d83a31a4248426";
var $08cc25b93689af36$export$2e2bcd8739ae039 = $08cc25b93689af36$var$node;

});

const $92b865e141ed2a4f$export$59aa73792ad9507a = 'PROJECT_VERSIONS';


parcelRegister("cXVqt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsVersionsRoute", () => $b9ce459589c7232c$export$cc9450e5d7579b99);
const $b9ce459589c7232c$export$cc9450e5d7579b99 = {
    name: 'project-settings-versions',
    path: '/plugins/servlet/project-config/:projectKey/administer-versions'
};

});

parcelRegister("af7CK", function(module, exports) {

$parcel$export(module.exports, "LazyRelayProjectVersions", () => $4b5729de9815f9dc$export$9036da4fa9f7a66f);
$parcel$export(module.exports, "RelayVersions", () => $4b5729de9815f9dc$export$9aff7dab80671d9);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $4b5729de9815f9dc$export$9036da4fa9f7a66f = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gw115"))), {
    moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
});
const $4b5729de9815f9dc$export$9aff7dab80671d9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4b5729de9815f9dc$export$9036da4fa9f7a66f,
        pageId: "relay-project-versions",
        shouldShowSpinner: false
    });

});
parcelRegister("gw115", function(module, exports) {

let $c0606c5c86ededc4$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c0606c5c86ededc4$var$load("h2MrD"),
    $c0606c5c86ededc4$var$load("bYT2S"),
    $c0606c5c86ededc4$var$load("guRgf")
]).then(()=>parcelRequire('5E2pR'));

});



parcelRegister("1Ps9S", function(module, exports) {

$parcel$export(module.exports, "projectsRedirectRouteEntry", () => $c72266bbdc090734$export$56f9921db324f30);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $7MCPm = parcelRequire("7MCPm");

var $2iuKi = parcelRequire("2iuKi");
const $c72266bbdc090734$export$56f9921db324f30 = (0, $7NszV.createEntry)((0, $2iuKi.projectsRedirectRoute), ()=>({
        group: 'redirects',
        isRedirect: true,
        component: (0, $7MCPm.RedirectToLastVisitedProjectPage),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("2iuKi", function(module, exports) {

$parcel$export(module.exports, "projectsRedirectRoute", () => $3aa0370b36d3207d$export$e6bc3ea427ddafb8);
const $3aa0370b36d3207d$export$e6bc3ea427ddafb8 = {
    name: 'projects-redirect',
    path: '/projects/:projectKey',
    query: [
        'selectedItem!=(.+)'
    ],
    exact: true
};

});


parcelRegister("bRRmd", function(module, exports) {

$parcel$export(module.exports, "projectVersionsRouteEntry", () => $3890e3ec7715d603$export$982bc443ef89cc3f);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $bC7QJ = parcelRequire("bC7QJ");

var $7GnDe = parcelRequire("7GnDe");

var $1G6pd = parcelRequire("1G6pd");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $3890e3ec7715d603$var$LazyRelayProjectVersions = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gw115"))), {
    moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
});
const $3890e3ec7715d603$var$RelayVersions = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3890e3ec7715d603$var$LazyRelayProjectVersions,
        pageId: "relay-project-versions",
        shouldShowSpinner: false
    });
const $3890e3ec7715d603$export$982bc443ef89cc3f = (0, $7NszV.createEntry)((0, $1G6pd.projectVersionsRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bC7QJ.projectVersionsRelayResource)
        ],
        component: $3890e3ec7715d603$var$RelayVersions,
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $3890e3ec7715d603$var$LazyRelayProjectVersions
        ]
    }));

});
parcelRegister("1G6pd", function(module, exports) {

$parcel$export(module.exports, "projectVersionsRoute", () => $4cfeade459489896$export$fb5516756c3eba40);

var $kMGqE = parcelRequire("kMGqE");
const $4cfeade459489896$export$fb5516756c3eba40 = {
    name: 'project-versions',
    path: '/projects/:projectKey',
    query: (0, $kMGqE.PROJECTS_VERSIONS_QUERY_PARAMS)
};

});
parcelRegister("kMGqE", function(module, exports) {

$parcel$export(module.exports, "PROJECTS_VERSIONS_QUERY_PARAMS", () => $91224398be5e0171$export$ad46185437bb571a);
const $91224398be5e0171$export$ad46185437bb571a = [
    'selectedItem=com.atlassian.jira.jira-projects-plugin:release-page'
];

});



parcelRegister("52RSm", function(module, exports) {

$parcel$export(module.exports, "rovoDemandTestsRouteEntry", () => $024c87aebde011e4$export$95ed5e2f774d3f79);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $1YOP2 = parcelRequire("1YOP2");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $024c87aebde011e4$var$LazyRovoDemandTestsPage = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6yaqJ"))), {
    moduleId: "./src/packages/spa-apps/rovo-demand-tests/src/index.tsx"
});
const $024c87aebde011e4$var$RovoDemandTestsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $024c87aebde011e4$var$LazyRovoDemandTestsPage,
        pageId: "rovo-demand-tests",
        shouldShowSpinner: false
    });
const $024c87aebde011e4$export$95ed5e2f774d3f79 = (0, $7NszV.createEntry)((0, $1YOP2.rovoDemandTestsRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        component: (0, $cSD7y.componentWithFG)('jsw_rovo_demand_tests_gate', $024c87aebde011e4$var$RovoDemandTestsPage, (0, $5lsNZ.default)),
        layout: (0, $2BrOV.globalLayout),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $024c87aebde011e4$var$LazyRovoDemandTestsPage
        ]
    }));

});
parcelRegister("1YOP2", function(module, exports) {

$parcel$export(module.exports, "rovoDemandTestsRoute", () => $714e07557512b4c7$export$cb08569a5439c36a);
const $714e07557512b4c7$export$cb08569a5439c36a = {
    name: 'rovo-demand-tests',
    path: '/jira/software/rovo/discover'
};

});

parcelRegister("6yaqJ", function(module, exports) {

let $4c4e02492290b264$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4c4e02492290b264$var$load("2Nk6X").then(()=>parcelRequire('8ImNC'));

});


parcelRegister("jr7ke", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerRouteEntry", () => $4ca2e5796b93a363$export$71497b88db8291d0);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $3LHrF = parcelRequire("3LHrF");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $4ca2e5796b93a363$var$LazySandboxBundlerPage = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("bbNAB"))), {
    moduleId: "./src/packages/spa-apps/sandbox/bundler/src/index.tsx"
});
const $4ca2e5796b93a363$var$SandboxBundler = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4ca2e5796b93a363$var$LazySandboxBundlerPage,
        pageId: "sandbox-bundler",
        shouldShowSpinner: true
    });
const $4ca2e5796b93a363$export$71497b88db8291d0 = (0, $7NszV.createEntry)((0, $3LHrF.sandboxBundlerRoute), ()=>({
        group: 'sandbox',
        component: (0, $cSD7y.componentWithFG)('conditional_import_sandbox', $4ca2e5796b93a363$var$SandboxBundler, (0, $5lsNZ.default)),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $4ca2e5796b93a363$var$LazySandboxBundlerPage
        ],
        ufoName: 'sandbox-bundler'
    }));

});
parcelRegister("3LHrF", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerRoute", () => $2919d66f60e8ebb6$export$3891624aac454ec2);
const $2919d66f60e8ebb6$export$3891624aac454ec2 = {
    name: 'sandbox-bundler',
    path: '/jira/software/sandbox/bundler',
    exact: true
};

});

parcelRegister("bbNAB", function(module, exports) {

let $8257302f395a60d8$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('test_conditional_imports', function() {
        return Promise.all([
            $8257302f395a60d8$var$load("bPt22")
        ]);
    }, function() {
        return Promise.all([
            $8257302f395a60d8$var$load("h2i3B")
        ]);
    }),
    $8257302f395a60d8$var$load("lUQNB")
]).then(()=>parcelRequire('jsr3R'));

});


parcelRegister("gtcNN", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostRLLRouteEntry", () => $37a8de44636c635e$export$e0dd38ef6ff677e7);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $8v2Rt = parcelRequire("8v2Rt");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $37a8de44636c635e$var$LazySandboxBundlerPage = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("bbNAB"))), {
    moduleId: "./src/packages/spa-apps/sandbox/bundler/src/index.tsx"
});
const $37a8de44636c635e$var$SandboxBundler = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $37a8de44636c635e$var$LazySandboxBundlerPage,
        pageId: "sandbox-bundler-bifrost",
        shouldShowSpinner: true
    });
const $37a8de44636c635e$export$e0dd38ef6ff677e7 = (0, $7NszV.createEntry)((0, $8v2Rt.sandboxBundlerBifrostRLLRoute), ()=>({
        group: 'sandbox',
        component: (0, $cSD7y.componentWithFG)('conditional_import_sandbox_bifrost', $37a8de44636c635e$var$SandboxBundler, (0, $5lsNZ.default)),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $37a8de44636c635e$var$LazySandboxBundlerPage
        ],
        ufoName: 'sandbox-bundler',
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxBundlerBifrostRLLRouteEntry.tsx',
                whichExportToUse: 'sandboxBundlerBifrostRLLRouteEntry'
            },
            enabled: false
        }
    }));

});
parcelRegister("8v2Rt", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostRLLRoute", () => $d64f6dbc3099be3d$export$c21fd836e6493cee);
const $d64f6dbc3099be3d$export$c21fd836e6493cee = {
    name: 'sandbox-bundler-bifrost-rll',
    path: '/jira/software/sandbox/bundler-bifrost/rll',
    exact: true
};

});


parcelRegister("gMkpP", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostEntrypointsRouteEntry", () => $b93ec6a6f2bfa33b$export$95bd68c4f26980ed);

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $lkFvK = parcelRequire("lkFvK");

var $3RJkv = parcelRequire("3RJkv");

var $4R6GH = parcelRequire("4R6GH");

var $6LsQE = parcelRequire("6LsQE");

var $c6VcK = parcelRequire("c6VcK");

var $lmyls = parcelRequire("lmyls");

var $3JMEk = parcelRequire("3JMEk");
const $b93ec6a6f2bfa33b$var$sandboxBundlerBifrostPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3JMEk.sandboxBundlerBifrostEntryPoint),
    // using PROJECTS as a placeholder
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $b93ec6a6f2bfa33b$export$95bd68c4f26980ed = (0, $7NszV.createEntry)((0, $c6VcK.sandboxBundlerBifrostEntrypointsRoute), ()=>({
        group: 'sandbox',
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        ufoName: 'sandbox-bundler',
        entryPoint: ()=>(0, $4R6GH.fg)('conditional_import_sandbox_bifrost') ? $b93ec6a6f2bfa33b$var$sandboxBundlerBifrostPageEntryPoint : (0, $6LsQE.notFoundPageEntrypoint),
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxBundlerBifrostEntrypointsRouteEntry.tsx',
                whichExportToUse: 'sandboxBundlerBifrostEntrypointsRouteEntry'
            },
            enabled: false
        }
    }));

});
parcelRegister("c6VcK", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostEntrypointsRoute", () => $7e324bc9b2d883b2$export$1e4fe7eb44ddb2fd);
const $7e324bc9b2d883b2$export$1e4fe7eb44ddb2fd = {
    name: 'sandbox-bundler-bifrost-entrypoints',
    path: '/jira/software/sandbox/bundler-bifrost/entrypoints',
    exact: true
};

});

parcelRegister("3JMEk", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostEntryPoint", () => $aa61e252bc74573b$export$e6bb5cf1b802d157);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $aa61e252bc74573b$export$e6bb5cf1b802d157 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("bbNAB")), {
        moduleId: "ce1b1bd6"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("6mo9H", function(module, exports) {

$parcel$export(module.exports, "jsmBoardRouteEntry", () => $bbc84ec66ce4b2fd$export$44cb11fe4ca053f8);

var $ffza4 = parcelRequire("ffza4");

var $6hJYB = parcelRequire("6hJYB");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $f5kpo = parcelRequire("f5kpo");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $kk6FJ = parcelRequire("kk6FJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $hWAe2 = parcelRequire("hWAe2");

var $lfnsv = parcelRequire("lfnsv");

var $lJ1FP = parcelRequire("lJ1FP");

var $4R6GH = parcelRequire("4R6GH");

var $dCThw = parcelRequire("dCThw");
const $bbc84ec66ce4b2fd$export$44cb11fe4ca053f8 = (0, $7NszV.createEntry)((0, $kk6FJ.jsmBoardRoute), ()=>({
        group: 'servicedesk',
        component: (0, $dCThw.ServicedeskBoard),
        layout: (0, $6Z2mh.serviceProjectLayout),
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dCThw.LazyServicedeskBoard),
            (0, $dCThw.LazyServicedeskLegacyBoardSettings),
            (0, $dCThw.LazyBoardSettings)
        ],
        perfMetricKey: 'servicedesk-boards-load',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $6hJYB.AsyncViewsNav)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>!false, (0, $f7Y15.uifBoardResource)),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_configuration_migration'), (0, $lJ1FP.getEditModelResource)()),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_configuration_migration'), (0, $lfnsv.getBoardDetailsResource)()),
            (0, $dxCvy.projectContextResource)
        ]
    }));

});
parcelRegister("6hJYB", function(module, exports) {

$parcel$export(module.exports, "AsyncViewsNav", () => $7a169ab056601f38$export$b43adc74b6a33bde);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $7a169ab056601f38$var$LazyViewsNav = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("gcf6F")).then(({ ViewsBaseNav: ViewsBaseNav })=>ViewsBaseNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/views/src/ui/index.tsx"
});
const $7a169ab056601f38$export$b43adc74b6a33bde = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-jsm-views-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a169ab056601f38$var$LazyViewsNav, null));

});
parcelRegister("gcf6F", function(module, exports) {

let $bca97c2edc86c193$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bca97c2edc86c193$var$load("boaHK").then(()=>parcelRequire('l1Z7j'));

});


parcelRegister("kk6FJ", function(module, exports) {

$parcel$export(module.exports, "jsmBoardRoute", () => $f1ec4cbb5ae8c6af$export$a192088aab559fa1);
const $f1ec4cbb5ae8c6af$export$a192088aab559fa1 = {
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId',
    name: 'servicedesk-boards',
    exact: true
};

});

parcelRegister("hWAe2", function(module, exports) {

$parcel$export(module.exports, "ClassicBoardSkeleton", () => $845fd4f51bb92262$export$631611c5fdf027d5);
/* ClassicBoardSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $p7KP7 = parcelRequire("p7KP7");
const $845fd4f51bb92262$var$customCssStyles = null;
const $845fd4f51bb92262$export$631611c5fdf027d5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($p7KP7))),
        className: (0, $bwpsq.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("p7KP7", function(module, exports) {
module.exports = new URL("classic-board-app-skeleton.tpl.bf1c26f5.svg", import.meta.url).toString();

});


parcelRegister("dCThw", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskBoard", () => $2b6a3552fb449509$export$bb5ed4e7838cf30c);
$parcel$export(module.exports, "LazyBoardSettings", () => $2b6a3552fb449509$export$45bb2963a11a5163);
$parcel$export(module.exports, "LazyServicedeskLegacyBoardSettings", () => $2b6a3552fb449509$export$6828c4b2d0ff0d5d);
$parcel$export(module.exports, "ServicedeskBoard", () => $2b6a3552fb449509$export$f058c0d1561d67f3);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $7tQej = parcelRequire("7tQej");

var $4R6GH = parcelRequire("4R6GH");

const $2b6a3552fb449509$export$bb5ed4e7838cf30c = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8oCEG"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/board/src/index.tsx"
});

const $2b6a3552fb449509$export$45bb2963a11a5163 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("a1Lyd")).then((module)=>module.ServicedeskBoardSettingsAppLayout)), {
    moduleId: "./src/packages/spa-apps/servicedesk/board-settings/src/ui/index.tsx"
});

const $2b6a3552fb449509$export$6828c4b2d0ff0d5d = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5RpdY"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/legacy-board-settings/src/index.tsx"
});
const $2b6a3552fb449509$export$f058c0d1561d67f3 = (props)=>{
    const { route: route, query: query } = props;
    if (route.name !== 'servicedesk-boards') return null;
    const allowedConfigurations = [
        'columns',
        'filter',
        'quickFilters',
        'swimlanes',
        'cardColors',
        'cardLayout',
        'dateFields'
    ];
    if (query.config && !allowedConfigurations.includes(query.config) && !(0, $4R6GH.fg)('jsm_views_configuration_migration')) {
        const { config: config, ...restQuery } = query;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: {
                pathname: props.location.pathname,
                hash: '',
                search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
                    ...restQuery,
                    config: 'columns'
                })
            }
        });
    }
    return query.config ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $4R6GH.fg)('jsm_views_configuration_migration') ? $2b6a3552fb449509$export$45bb2963a11a5163 : $2b6a3552fb449509$export$6828c4b2d0ff0d5d,
        pageId: (0, $4R6GH.fg)('jsm_views_configuration_migration') ? 'spa-apps/servicedesk/boards/board-settings' : 'spa-apps/servicedesk/boards/legacy-board-settings',
        shouldShowSpinner: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2b6a3552fb449509$export$bb5ed4e7838cf30c,
        pageId: "spa-apps/servicedesk/boards/board",
        shouldShowSpinner: true
    });
};

});
parcelRegister("8oCEG", function(module, exports) {

let $61ce8cbe1346b093$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $61ce8cbe1346b093$var$load("hPzOn"),
    $61ce8cbe1346b093$var$load("h2MrD"),
    $61ce8cbe1346b093$var$load("bYT2S"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("341YM"), 4)),
    $61ce8cbe1346b093$var$load("cM9em"),
    $61ce8cbe1346b093$var$load("fr9NE"),
    $61ce8cbe1346b093$var$load("6Yvcg")
]).then(()=>parcelRequire('fnC5S'));

});

parcelRegister("a1Lyd", function(module, exports) {

let $74cee1fdb4d7ea60$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $74cee1fdb4d7ea60$var$load("hPzOn"),
    $74cee1fdb4d7ea60$var$load("h2MrD"),
    $74cee1fdb4d7ea60$var$load("bYT2S"),
    $74cee1fdb4d7ea60$var$load("8b3AY")
]).then(()=>parcelRequire('as6Z6'));

});

parcelRegister("5RpdY", function(module, exports) {

let $4445780492ba886b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4445780492ba886b$var$load("iK5gX").then(()=>parcelRequire('lWiJj'));

});



parcelRegister("cJoBA", function(module, exports) {

$parcel$export(module.exports, "servicedeskCalendarRouteEntry", () => $3ce1b2936d5b40e0$export$301bfcedbd0983b7);

var $4R6GH = parcelRequire("4R6GH");

var $6hJYB = parcelRequire("6hJYB");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $jYeNO = parcelRequire("jYeNO");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $4pwUQ = parcelRequire("4pwUQ");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $6Y2I3 = parcelRequire("6Y2I3");

var $f1mpQ = parcelRequire("f1mpQ");
const $3ce1b2936d5b40e0$export$301bfcedbd0983b7 = (0, $7NszV.createEntry)((0, $4pwUQ.servicedeskCalendarRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm-calendar',
        component: ()=>null,
        skeleton: (0, $6Y2I3.ClassicCalendarSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $6hJYB.AsyncViewsNav)
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $jYeNO.getCalendarFilterFieldsResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsd_shield_weekly_view_fast_follow') && !false, (0, $f7Y15.uifBoardResource))
        ],
        entryPoint: ()=>(0, $f1mpQ.calendarPageEntryPoint),
        meta: {
            reporting: {
                id: 'calendar',
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CALENDAR),
                teamName: 'jsd-shield'
            }
        }
    }));

});
parcelRegister("4pwUQ", function(module, exports) {

$parcel$export(module.exports, "servicedeskCalendarRoute", () => $72d318e197b1c24c$export$28a386a00670c893);
const $72d318e197b1c24c$export$28a386a00670c893 = {
    name: 'servicedesk-calendar',
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId/calendar',
    exact: true
};

});

parcelRegister("e9YVH", function(module, exports) {

$parcel$export(module.exports, "APP_NAMES", () => $26ff993b947c317f$export$4116f3d0d9d6bed7);
$parcel$export(module.exports, "toPackageName", () => $26ff993b947c317f$export$f31a652635bd75fe);
const $26ff993b947c317f$export$4116f3d0d9d6bed7 = {
    ACCOUNTS: 'servicedesk.accounts',
    APP_DISCOVERY: 'servicedesk.app-discovery',
    ATLASSIAN_ANALYTICS: 'servicedesk.atlassian-analytics',
    AUTOMATION_EDIT_RULE: 'servicedesk.automation.edit-rule',
    AUTOMATION_SUMMARY: 'servicedesk.automation.summary',
    AUTOMATION_VIEW_LOG: 'servicedesk.automation.view-log',
    BOARD: 'servicedesk.board',
    BOARD_SETTINGS: 'servicedesk.board-settings',
    CALENDAR: 'servicedesk.calendar',
    PROJECT_SUMMARY: 'servicedesk.project-summary',
    CHANGE_CALENDAR: 'servicedesk.change-calendar',
    CHANGE_MANAGEMENT_SETTINGS: 'servicedesk.change-management.settings',
    CREATE_PROJECT: 'servicedesk.create-project',
    CSAT_CONFIG: 'servicedesk.csat-configuration',
    CUSTOMER_PERMISSIONS: 'servicedesk.customer-permissions',
    CONTACTS: 'servicedesk.contacts',
    CUSTOMERS: 'servicedesk.customers',
    CUSTOMER_DETAILS: 'servicedesk.customer-details',
    CUSTOMER_SERVICE_ESCALATIONS: 'servicedesk.customer-service-escalations',
    CUSTOMER_SERVICE_PRODUCTS: 'servicedesk.customer-service-products',
    CUSTOMER_SERVICE_HELP_CENTER: 'servicedesk.customer-service-help-center',
    INVITE_TEAM_DIALOG: 'servicedesk.invite-team-dialog',
    ISSUE_SCHEDULE_CHANGE: 'servicedesk.issue.schedule-change',
    ITSM_FEATURES_SETTINGS: 'servicedesk.itsm-features.settings',
    ITSM_SAMPLE_SPACE: 'servicedesk.itsm-sample-space',
    JOURNEYS: 'servicedesk.journeys',
    JOURNEY_CONFIG: 'servicedesk.journey-config',
    GETTING_STARTED_PAGE: 'servicedesk.getting-started-page',
    KB_BROWSE_ARTICLES: 'servicedesk.knowledge-base.browse-articles',
    KB_CATEGORY: 'servicedesk.knowledge-base.category',
    KB_DRAFTS: 'servicedesk.knowledge-base.drafts',
    KB_BROWSE_CATEGORIES: 'servicedesk.knowledge-base.browse-categories',
    KB_SUGGESTED_ARTICLES: 'servicedesk.knowledge-base.suggested-articles',
    KB_EMBED_EDITOR: 'servicedesk.knowledge-article.embed-editor',
    KB_LANDING: 'servicedesk.knowledge-base.landing',
    KB_REPORTS_REQUESTS: 'servicedesk.kb-requests.reports',
    KB_SEARCH: 'servicedesk.knowledge-base.search',
    KB_SETTINGS: 'servicedesk.knowledge.settings',
    KB_SETUP: 'servicedesk.knowledge-base.setup',
    KB_VIEW_ARTICLE: 'servicedesk.knowledge-base.view-article',
    ORGANIZATION: 'servicedesk.organization',
    ORGANIZATIONS: 'servicedesk.organizations',
    ORGANIZATION_DETAILS: 'servicedesk.organization-details',
    PORTAL_SETTINGS: 'servicedesk.portal-settings',
    QUEUES_AGENT_VIEW: 'servicedesk.queues.agent-view',
    QUEUES_EDIT_VIEW: 'servicedesk.queues.edit-view',
    QUEUES_MAIN: 'servicedesk.queues.main',
    REPORTS_CUSTOM: 'servicedesk.reports.custom',
    REPORTS_CUSTOM_CREATE: 'servicedesk.reports.custom-create',
    REPORTS_CUSTOM_EDIT: 'servicedesk.reports.custom-edit',
    REPORTS_HOME_PAGE: 'servicedesk.reports.home-page',
    REPORTS_SATISFACTION: 'servicedesk.reports.satisfaction',
    REPORTS_WORKLOAD: 'servicedesk.reports.workload',
    REQUEST_TYPES_CONFIG: 'servicedesk.request-types-config',
    REQUEST_TYPE_FIELDS: 'servicedesk.request-type-fields',
    SLA_SETTINGS: 'servicedesk.sla-settings',
    VIRTUAL_AGENT_BROWSE_CONVERSATIONS: 'servicedesk.virtual-agent.browse-conversations',
    VIRTUAL_AGENT_BROWSE_INTENTS: 'servicedesk.virtual-agent.browse-intents',
    VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS: 'servicedesk.virtual-agent.browse-standard-flows',
    VIRTUAL_AGENT_LANDING: 'servicedesk.virtual-agent.landing',
    VIRTUAL_AGENT_SETTINGS: 'servicedesk.virtual-agent.settings',
    VIRTUAL_AGENT_VIEW_INTENT: 'servicedesk.virtual-agent.view-intent',
    VIRTUAL_AGENT_VIEW_STANDARD_FLOW: 'servicedesk.virtual-agent.view-standard-flow',
    VIRTUAL_AGENT_AI_ANSWERS: 'servicedesk.virtual-agent.ai-answers',
    VIRTUAL_AGENT_PERFORMANCE: 'servicedesk.virtual-agent.performance',
    PRACTICE_CONFIG_MODULE: 'servicedesk.practice-config-module',
    CREATE_SERVICE_MODAL: 'servicedesk.create-service-modal',
    UPDATE_SERVICE_MODAL: 'servicedesk.update-service-modal',
    LANGUAGE_SETTINGS: 'servicedesk.language-settings',
    LINKED_ALERTS_MODAL: 'servicedesk.link-alerts-modal',
    INSIGHT_ASSETS_REPORTS: 'servicedesk.insight-cmdb-assets_reports',
    INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT: 'servicedesk.insight-cmdb-assets_reports_default_redirect',
    INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE: 'servicedesk.insight-cmdb-assets_reports_unsubscribe',
    INSIGHT_OBJECT_VIEW: 'servicedesk.insight-cmdb-object',
    INSIGHT_OBJECT_SCHEMA: 'servicedesk.insight-cmdb-object-schema',
    INSIGHT_OBJECT_SCHEMA_CONFIGURATION: 'servicedesk.insight-cmdb-object-schema-configuration',
    INSIGHT_OBJECT_TYPE_CONFIGURATION: 'servicedesk.insight-object-type-configuration',
    INSIGHT_GLOBAL_CONFIGURATION: 'servicedesk.insight-cmdb-global-configuration',
    INSIGHT_LANDING_PAGE: 'servicedesk.insight-cmdb-landing-page',
    CUSTOMER_NOTIFICATIONS_MAIN_VIEW: 'servicedesk.customer-notifications-settings.main-view',
    CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW: 'servicedesk.customer-notifications-settings.invite-customer-view',
    CUSTOMER_NOTIFICATIONS_RULE_VIEW: 'servicedesk.customer-notifications-settings.rule-view',
    CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW: 'servicedesk.customer-notifications-settings.template-view',
    CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW: 'servicedesk.customer-notifications-settings.unknown-view',
    SERVICES_WITHOUT_PROJECT_VIEW: 'servicedesk.services-without-project-view',
    SERVICE_DETAIL_WITHOUT_PROJECT_VIEW: 'servicedesk.service-detail-without-project-view',
    WIDGET_SETTINGS: 'servicedesk.widget-settings',
    ASSETS_APP_SEARCH_RESULTS: 'assets-app.search-results-page'
};
// To match the FE error analytics pipeline convention
const $26ff993b947c317f$var$ANALYTICS_PACKAGE_NAMES = {
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ACCOUNTS]: 'servicedeskAccounts',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.APP_DISCOVERY]: 'serviceDeskAppDiscovery',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ATLASSIAN_ANALYTICS]: 'serviceDeskAtlassianAnalytics',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.AUTOMATION_EDIT_RULE]: 'servicedeskAutomationEditView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.AUTOMATION_SUMMARY]: 'servicedeskAutomationEditRule',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.AUTOMATION_VIEW_LOG]: 'servicedeskAutomationViewLog',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.BOARD]: 'servicedeskBoard',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.BOARD_SETTINGS]: 'servicedeskBoardSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CALENDAR]: 'servicedeskCalendar',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.PROJECT_SUMMARY]: 'servicedeskProjectSummary',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CHANGE_CALENDAR]: 'servicedeskChangeCalendar',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CHANGE_MANAGEMENT_SETTINGS]: 'servicedeskChangeManagementSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CREATE_PROJECT]: 'servicedeskCreateProject',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CSAT_CONFIG]: 'servicedeskCsatConfig',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CONTACTS]: 'servicedeskContacts',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_PERMISSIONS]: 'servicedeskCustomerPermissions',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMERS]: 'servicedeskCustomers',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_DETAILS]: 'servicedeskCustomerDetails',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_ESCALATIONS]: 'servicedeskCustomerServiceEscalations',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_PRODUCTS]: 'servicedeskCustomerServiceProducts',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_HELP_CENTER]: 'servicedeskCustomerServiceHelpCenter',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INVITE_TEAM_DIALOG]: 'servicedeskInviteTeamDialog',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ISSUE_SCHEDULE_CHANGE]: 'servicedeskIssueScheduleChange',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ITSM_FEATURES_SETTINGS]: 'servicedeskItsmFeaturesSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ITSM_SAMPLE_SPACE]: 'servicedeskItsmSampleSpace',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.JOURNEYS]: 'servicedeskJourneys',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.JOURNEY_CONFIG]: 'servicedeskJourneyConfig',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_BROWSE_ARTICLES]: 'servicedeskKnowledgeBaseBrowseArticles',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_BROWSE_CATEGORIES]: 'servicedeskKnowledgeBaseBrowseCategories',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_CATEGORY]: 'servicedeskKnowledgeBaseCategory',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_DRAFTS]: 'servicedeskKnowledgeBaseDrafts',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SUGGESTED_ARTICLES]: 'servicedeskKnowledgeBaseSuggestedArticles',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_EMBED_EDITOR]: 'servicedeskKnowledgeBaseEmbedEditor',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_LANDING]: 'servicedeskKnowledgeBaseLanding',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_REPORTS_REQUESTS]: 'servicedeskKbRequestsReports',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SEARCH]: 'servicedeskKnowledgeBaseSearch',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SETTINGS]: 'servicedeskKnowledgeSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SETUP]: 'servicedeskKnowledgeBaseSetup',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_VIEW_ARTICLE]: 'servicedeskKnowledgeBaseViewArticle',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.LANGUAGE_SETTINGS]: 'servicedeskLanguageSettingsTranslations',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ORGANIZATION]: 'servicedeskOrganization',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ORGANIZATIONS]: 'servicedeskOrganizations',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ORGANIZATION_DETAILS]: 'servicedeskOrganizationDetails',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.PORTAL_SETTINGS]: 'servicedeskPortalSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.QUEUES_AGENT_VIEW]: 'servicedeskQueuesAgentView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.QUEUES_EDIT_VIEW]: 'servicedeskQueuesEditView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.QUEUES_MAIN]: 'servicedeskQueuesMain',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_CUSTOM]: 'servicedeskReportsCustom',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_CREATE]: 'servicedeskReportsCustomCreate',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_EDIT]: 'servicedeskReportsCustomEdit',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_HOME_PAGE]: 'servicedeskReportsHomePage',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_SATISFACTION]: 'servicedeskReportsSatisfaction',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_WORKLOAD]: 'servicedeskReportsWorkload',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REQUEST_TYPES_CONFIG]: 'servicedeskRequestTypesConfig',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REQUEST_TYPE_FIELDS]: 'servicedeskRequestTypeFields',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.SLA_SETTINGS]: 'servicedeskSlaSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_CONVERSATIONS]: 'servicedeskVirtualAgentBrowseConversations',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_INTENTS]: 'servicedeskVirtualAgentBrowseIntents',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS]: 'servicedeskVirtualAgentBrowseStandardFlows',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_LANDING]: 'servicedeskVirtualAgentLanding',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_SETTINGS]: 'servicedeskVirtualAgentSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_INTENT]: 'servicedeskVirtualAgentViewIntent',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_STANDARD_FLOW]: 'servicedeskVirtualAgentViewStandardFlow',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_AI_ANSWERS]: 'servicedeskVirtualAgentAiAnswers',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_PERFORMANCE]: 'servicedeskVirtualAgentPerformance',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.PRACTICE_CONFIG_MODULE]: 'servicedeskPracticeConfigModule',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CREATE_SERVICE_MODAL]: 'servicedeskCreateServiceModal',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.UPDATE_SERVICE_MODAL]: 'servicedeskUpdateServiceModal',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.LINKED_ALERTS_MODAL]: 'servicedeskLinkAlertsModal',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS]: 'servicedeskAssetsReports',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT]: 'servicedeskAssetsReportsDefaultRedirect',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE]: 'servicedeskAssetsReportsUnsubscribe',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_VIEW]: 'servicedeskObjectView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA]: 'servicedeskObjectSchema',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA_CONFIGURATION]: 'servicedeskObjectSchemaConfiguration',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_TYPE_CONFIGURATION]: 'servicedeskObjectTypeConfiguration',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_GLOBAL_CONFIGURATION]: 'servicedeskInsightGlobalConfiguration',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_LANDING_PAGE]: 'servicedeskInsightLandingPage',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_MAIN_VIEW]: 'servicedeskCustomerNotificationsMainView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW]: 'servicedeskCustomerNotificationsInviteCustomerView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_RULE_VIEW]: 'servicedeskCustomerNotificationsRuleView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW]: 'servicedeskCustomerNotificationsTemplateView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW]: 'servicedeskCustomerNotificationsUnknownView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.GETTING_STARTED_PAGE]: 'servicedeskGettingStartedPage',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.SERVICES_WITHOUT_PROJECT_VIEW]: 'servicedeskServicesWithoutProjectView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.SERVICE_DETAIL_WITHOUT_PROJECT_VIEW]: 'servicedeskServiceDetailWithoutProjectView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.WIDGET_SETTINGS]: 'servicedeskWidgetSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ASSETS_APP_SEARCH_RESULTS]: 'assetsAppSearchResultsPage'
};
const $26ff993b947c317f$export$f31a652635bd75fe = (appName)=>$26ff993b947c317f$var$ANALYTICS_PACKAGE_NAMES[appName];

});

parcelRegister("6Y2I3", function(module, exports) {

$parcel$export(module.exports, "ClassicCalendarSkeleton", () => $69a8eba95a06a473$export$49d3670908a8d8fe);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $9JSfC = parcelRequire("9JSfC");
const $69a8eba95a06a473$export$49d3670908a8d8fe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9JSfC)))
    });

});
parcelRegister("9JSfC", function(module, exports) {
module.exports = new URL("classic-calendar-skeleton.tpl.3dcfde16.svg", import.meta.url).toString();

});


parcelRegister("f1mpQ", function(module, exports) {

$parcel$export(module.exports, "calendarPageEntryPoint", () => $c3ff53bf28ecf1c9$export$eda0c2fb67f7d7e7);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $faaUu = parcelRequire("faaUu");
const $c3ff53bf28ecf1c9$export$eda0c2fb67f7d7e7 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $faaUu.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("faaUu", function(module, exports) {

$parcel$export(module.exports, "calendarEntryPoint", () => $d491739a1b7483c1$export$19cf4b398f638dc6);

var $4R6GH = parcelRequire("4R6GH");

var $7JhZX = parcelRequire("7JhZX");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");
// This is the key used to store the calendar filters in the local storage
const $d491739a1b7483c1$var$ISSUE_SEARCH_INPUT_STORAGE_KEY = 'calendar-issue-search-input';
// This is the key used to store the calendar view settings in the local storage
const $d491739a1b7483c1$var$VIEW_SETTINGS_STORAGE_KEY = 'calendar-view-settings';
/**
 * Default Day Starts At Time in Calendar View Settings
 */ const $d491739a1b7483c1$var$DEFAULT_DAY_STARTS_AT = '09:00 AM';
function $d491739a1b7483c1$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
    return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
}
function $d491739a1b7483c1$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $d491739a1b7483c1$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $d491739a1b7483c1$var$createScope({ context: context, tenantContext: tenantContext }, viewId) {
    const { cloudId: cloudId } = tenantContext;
    return {
        type: 'board',
        boardId: $d491739a1b7483c1$var$toBoardAri({
            siteId: cloudId,
            boardId: String(context.match.params.boardId)
        }),
        projectKeys: (0, $4R6GH.fg)('fix_jsm_calendar_scope_issue') ? [] : [
            String(context.match.params.projectKey)
        ],
        viewId: viewId
    };
}
function $d491739a1b7483c1$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    return {
        ids: [
            scope.boardId
        ],
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
}
function $d491739a1b7483c1$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $d491739a1b7483c1$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $d491739a1b7483c1$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField, viewId: viewId }) {
    return {
        date: $d491739a1b7483c1$var$toMidnightUTCString(selectedDate),
        mode: $d491739a1b7483c1$var$toViewMode(viewRange),
        weekStart: $d491739a1b7483c1$var$toWeekStart(weekStartsOn),
        ...(0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? {
            startDateField: startDateField,
            endDateField: endDateField
        } : {},
        viewId: viewId
    };
}
function $d491739a1b7483c1$var$buildStorageKey({ cloudId: cloudId, activationId: activationId, boardId: boardId, featureKey: featureKey }) {
    const viewId = $d491739a1b7483c1$var$buildViewId({
        cloudId: cloudId,
        activationId: activationId,
        boardId: boardId
    });
    const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
    return `${LOCALSTORAGE_KEY_PREFIX}/view/${viewId}/${featureKey}`;
}
function $d491739a1b7483c1$var$getStorageValue(storageKey) {
    // window check is needed because this code is also executed on the SSR
    if (typeof window !== 'undefined') return localStorage?.getItem(storageKey) || '';
    return '';
}
function $d491739a1b7483c1$var$buildIssuesSearchInput(storageKey) {
    return {
        additionalFilterQuery: $d491739a1b7483c1$var$getStorageValue(storageKey) || ''
    };
}
function $d491739a1b7483c1$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $d491739a1b7483c1$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $d491739a1b7483c1$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}
function $d491739a1b7483c1$var$buildViewId({ cloudId: cloudId, activationId: activationId, boardId: boardId }) {
    // https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Ajira%3Aview
    return `ari:cloud:jira:${cloudId}:view/activation/${activationId}/board/${boardId}`;
}

const $d491739a1b7483c1$export$19cf4b398f638dc6 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("8RFYT")), {
        moduleId: "7a55ad65"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const { date: date } = context.query;
        const selectedDate = $d491739a1b7483c1$var$toDate(date);
        const { boardId: boardId, projectKey: projectKey } = context.match.params;
        if (!boardId || !projectKey) throw new Error('boardId and projectKey must be provided.');
        const viewId = $d491739a1b7483c1$var$buildViewId({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId
        });
        const scope = $d491739a1b7483c1$var$createScope(entryPointRouteParams, viewId || '');
        const storageKeyForIssueSearchInput = $d491739a1b7483c1$var$buildStorageKey({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId,
            featureKey: $d491739a1b7483c1$var$ISSUE_SEARCH_INPUT_STORAGE_KEY
        });
        const storageKeyForViewSettings = $d491739a1b7483c1$var$buildStorageKey({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId,
            featureKey: $d491739a1b7483c1$var$VIEW_SETTINGS_STORAGE_KEY
        });
        const defaultViewRange = 'month';
        const storedConfig = $d491739a1b7483c1$var$getStorageValue(storageKeyForViewSettings);
        const viewSettingsConfig = storedConfig ? JSON.parse(storedConfig) : {
            viewRange: defaultViewRange,
            weekStartsOn: null,
            dayStartsAt: $d491739a1b7483c1$var$DEFAULT_DAY_STARTS_AT,
            showWeekends: false,
            showIssueKey: true,
            showIn24HourClock: false,
            colorBy: 'status'
        };
        const viewRange = (0, $4R6GH.fg)('jsd_shield_jsm_calendar_weekly_view') ? viewSettingsConfig.viewRange ?? 'month' : 'month';
        const weekStartsOn = viewSettingsConfig.weekStartsOn ?? 'sunday';
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const colorBy = viewSettingsConfig.colorBy ?? 'status';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        const issuesSearchInput = $d491739a1b7483c1$var$buildIssuesSearchInput(storageKeyForIssueSearchInput);
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $7JhZX.default,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $d491739a1b7483c1$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $d491739a1b7483c1$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField,
                            viewId: viewId
                        }),
                        issuesPageSize: (0, $4R6GH.fg)('jira_calendar_lazy_load') ? 200 : 50,
                        issuesSearchInput: issuesSearchInput,
                        unscheduledIssuesSearchInput: $d491739a1b7483c1$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $d491739a1b7483c1$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $d491739a1b7483c1$var$buildSprintsSearchInput(),
                        skipSprintSearch: false,
                        viewId: viewId,
                        ...(0, $4R6GH.fg)('jsd_shield_jsm_calendar_weekly_view') && {
                            skipFieldConfig: false
                        },
                        schedulePermissionsEnabled: (0, $4R6GH.fg)('calendar_schedule_issue_permissions_check'),
                        pageLoadMoreEnabled: (0, $4R6GH.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV1Search: (0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        skipVersionsV2Search: !(0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        includeRecurrenceIndicator: false,
                        pageLoadMoreEnabledViewSettings: (0, $4R6GH.fg)('jira_calendar_load_more_pagination_view_settings')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                dayStartsAt: viewSettingsConfig.dayStartsAt,
                issueEventFields: issueEventFields,
                projectKey: projectKey,
                storageKeyForViewSettings: storageKeyForViewSettings,
                storageKeyForIssueSearchInput: storageKeyForIssueSearchInput,
                showWeekends: viewSettingsConfig.showWeekends,
                showIssueKey: viewSettingsConfig.showIssueKey,
                showIn24HourClock: viewSettingsConfig.showIn24HourClock,
                colorBy: colorBy
            }
        };
    }
});

});
parcelRegister("8RFYT", function(module, exports) {

let $6743d692229968db$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6743d692229968db$var$load("h2MrD"),
    $6743d692229968db$var$load("bYT2S"),
    $6743d692229968db$var$load("1QoV7")
]).then(()=>parcelRequire('2hdB5'));

});




parcelRegister("SBgrM", function(module, exports) {

$parcel$export(module.exports, "servicedeskChangeCalendarRouteEntry", () => $76cc3b1301a661ae$export$de5b915e23c7ce7d);

var $ffza4 = parcelRequire("ffza4");

var $1cxvE = parcelRequire("1cxvE");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $2pT4g = parcelRequire("2pT4g");

var $fpjJX = parcelRequire("fpjJX");

var $J5M3r = parcelRequire("J5M3r");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $cOMjN = parcelRequire("cOMjN");
const $76cc3b1301a661ae$export$de5b915e23c7ce7d = (0, $7NszV.createEntry)((0, $J5M3r.servicedeskChangeCalendarRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.change-calendar',
        component: (0, $cOMjN.default),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $1cxvE.AsyncJSMOperationsHorizontalNav),
            onlyShowHorizontalOnNav4: true
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $2pT4g.jsmRepackagingBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cOMjN.LazyChangeCalendar),
            (0, $1cxvE.LazyJSMOperationsHorizontalNav)
        ],
        meta: {
            reporting: {
                id: 'changeCalendar',
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CHANGE_CALENDAR),
                teamName: 'jenga'
            }
        }
    }));

});
parcelRegister("1cxvE", function(module, exports) {

$parcel$export(module.exports, "LazyJSMOperationsHorizontalNav", () => $f4b0e9313c9342f0$export$d9802671a2b1aa20);
$parcel$export(module.exports, "AsyncJSMOperationsHorizontalNav", () => $f4b0e9313c9342f0$export$d4493569f106c71);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $f4b0e9313c9342f0$export$d9802671a2b1aa20 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("cxg8X")).then(({ JSMOperationsHorizontalNav: JSMOperationsHorizontalNav })=>JSMOperationsHorizontalNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/operations/src/ui/index.tsx"
});
const $f4b0e9313c9342f0$export$d4493569f106c71 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-operations-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncHorizontalOperationsNav",
        packageName: "jiraHorizontalNavJsmOperations",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4b0e9313c9342f0$export$d9802671a2b1aa20, null)));

});
parcelRegister("cxg8X", function(module, exports) {

let $920516e2b409fc56$var$load = (parcelRequire("28QjX"))(4);
module.exports = $920516e2b409fc56$var$load("ii98U").then(()=>parcelRequire('6vvjk'));

});


parcelRegister("2pT4g", function(module, exports) {

$parcel$export(module.exports, "jsmRepackagingBannerResource", () => $f325ae4fdb8711ab$export$760ca885f96dacb6);
$parcel$export(module.exports, "useJsmRepackagingBannerResource", () => $f325ae4fdb8711ab$export$f1444ccc5653a5cb);

var $5uXOq = parcelRequire("5uXOq");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $daiqe = parcelRequire("daiqe");

const $f325ae4fdb8711ab$var$getDataLoader = ()=>(parcelRequire("d9het"));
const $f325ae4fdb8711ab$export$760ca885f96dacb6 = (0, $2M1hQ.createResource)({
    type: 'JSM_REPACKAGING_BANNER',
    getKey: ()=>'JSM_REPACKAGING_BANNER',
    getDataLoader: $f325ae4fdb8711ab$var$getDataLoader,
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});
const $f325ae4fdb8711ab$export$f1444ccc5653a5cb = (workCategory, accountId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)($f325ae4fdb8711ab$export$760ca885f96dacb6);
    (0, $5uXOq.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $5uXOq.useMemo)(()=>{
        if (error || loading || !data || !accountId) return {
            show: false
        };
        const { bannerMeta: bannerMeta, bannerDismissState: bannerDismissState } = data;
        const workCategoryDismissState = bannerDismissState?.[workCategory];
        if (!bannerMeta.show || !(bannerMeta.type === 'info' || bannerMeta.type === 'warning')) return {
            show: false
        };
        if (!workCategoryDismissState) return {
            ...bannerDismissState,
            ...bannerMeta,
            refresh: refresh
        };
        if (workCategoryDismissState.packagingChangeDate !== bannerMeta.data.packagingChangeDate) {
            (0, $daiqe.deleteBannerDismissState)({
                accountId: accountId
            });
            return {
                ...bannerMeta,
                refresh: refresh
            };
        }
        if (workCategoryDismissState.bannerHiddenUntil > Date.now()) return {
            show: false
        };
        return {
            ...bannerMeta,
            ...bannerDismissState,
            refresh: refresh
        };
    }, [
        data,
        loading,
        error,
        workCategory,
        accountId,
        refresh
    ]);
};

});
parcelRegister("daiqe", function(module, exports) {

$parcel$export(module.exports, "deleteBannerDismissState", () => $00907b0f6d0c25ed$export$e21bb99d98e8c8b4);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
async function $00907b0f6d0c25ed$export$e21bb99d98e8c8b4({ accountId: accountId }) {
    try {
        await (0, $eusud.performDeleteRequest)(`/rest/api/3/user/properties/jsm-repackaging-banners-dismiss-state?accountId=${accountId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // https://data-portal.internal.atlassian.com/analytics/registry/71209
        (0, $jcw0u.default)({
            meta: {
                id: 'deleteBannerDismissState',
                packageName: 'jiraRouterResourcesJsmRepackagingBanner',
                teamName: 'jenga'
            },
            error: error
        });
    }
}

});

parcelRegister("d9het", function(module, exports) {

let $99297b9e3e9d15bc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $99297b9e3e9d15bc$var$load("cVV3d").then(()=>parcelRequire('iKQCz'));

});


parcelRegister("J5M3r", function(module, exports) {

$parcel$export(module.exports, "servicedeskChangeCalendarRoute", () => $927ba64566bdbc92$export$3dbc16ae422c469);
const $927ba64566bdbc92$export$3dbc16ae422c469 = {
    name: 'servicedesk-change-calendar',
    path: '/jira/servicedesk/projects/:projectKey/change-calendar',
    exact: true
};

});

parcelRegister("cOMjN", function(module, exports) {

$parcel$export(module.exports, "LazyChangeCalendar", () => $f705f6e0ca7ffaf5$export$a6cec2d1c2e631eb);
$parcel$export(module.exports, "default", () => $f705f6e0ca7ffaf5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $f705f6e0ca7ffaf5$export$a6cec2d1c2e631eb = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jy01f"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/change-calendar/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f705f6e0ca7ffaf5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f705f6e0ca7ffaf5$export$a6cec2d1c2e631eb,
        pageId: "spa-apps/servicedesk/change-calendar",
        shouldShowSpinner: true
    });

});
parcelRegister("jy01f", function(module, exports) {

let $e3b1351a2189f53e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e3b1351a2189f53e$var$load("41TKw").then(()=>parcelRequire('4cmmO'));

});



parcelRegister("7kGnZ", function(module, exports) {

$parcel$export(module.exports, "assetsRouteEntry", () => $b03272cc541907e2$export$7069f3fb497264f1);

var $7NszV = parcelRequire("7NszV");

var $hPMcq = parcelRequire("hPMcq");

var $55ZOZ = parcelRequire("55ZOZ");

var $lkFvK = parcelRequire("lkFvK");

var $kVDZN = parcelRequire("kVDZN");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $b03272cc541907e2$var$assetsPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $kVDZN.landingPageEntryPoint)
});
const $b03272cc541907e2$export$7069f3fb497264f1 = (0, $7NszV.createEntry)((0, $hPMcq.assetsRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$b03272cc541907e2$var$assetsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-landing-page',
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
    }));

});
parcelRegister("hPMcq", function(module, exports) {

$parcel$export(module.exports, "assetsRoute", () => $59be8ada95f8c1d8$export$70dab2ea29192797);
const $59be8ada95f8c1d8$export$70dab2ea29192797 = {
    name: 'assets',
    path: '/jira/assets',
    exact: true
};

});

parcelRegister("55ZOZ", function(module, exports) {

$parcel$export(module.exports, "getCmdbResources", () => $15b640a3daddca1e$export$850433b0663023b8);
$parcel$export(module.exports, "getAssetsAppResources", () => $15b640a3daddca1e$export$70fc9421fb71e080);

var $3RJkv = parcelRequire("3RJkv");

var $fpjJX = parcelRequire("fpjJX");

var $gRzZD = parcelRequire("gRzZD");

var $2Ql51 = parcelRequire("2Ql51");

var $kkNtb = parcelRequire("kkNtb");
function $15b640a3daddca1e$export$850433b0663023b8() {
    return [
        ...(0, $3RJkv.getNavigationResources)(),
        ...(0, $fpjJX.getServicedeskPageContextResources)(),
        (0, $gRzZD.workspaceResource)
    ];
}
function $15b640a3daddca1e$export$70fc9421fb71e080() {
    return [
        (0, $2Ql51.themePreferenceResource),
        (0, $kkNtb.rovoEntitlementResource),
        (0, $gRzZD.workspaceResource)
    ];
}

});

parcelRegister("kVDZN", function(module, exports) {

$parcel$export(module.exports, "landingPageEntryPoint", () => $0cae44565e643672$export$36d88a15c123c06);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $0cae44565e643672$export$36d88a15c123c06 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("4gjbD")), {
        moduleId: "60961f22"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4gjbD", function(module, exports) {

let $31a78a241d06a382$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $31a78a241d06a382$var$load("h2MrD"),
    $31a78a241d06a382$var$load("bYT2S"),
    $31a78a241d06a382$var$load("cTSd1")
]).then(()=>parcelRequire('9imjS'));

});


parcelRegister("k7I8D", function(module, exports) {

$parcel$export(module.exports, "LazyAssetsLayout", () => $5490b4e7bbb569d8$export$6d4ed5b3aae01b61);
$parcel$export(module.exports, "AssetsLayout", () => $5490b4e7bbb569d8$export$fc69c032e8242676);

var $5uXOq = parcelRequire("5uXOq");

var $b7Svb = parcelRequire("b7Svb");

var $lfTZh = parcelRequire("lfTZh");

const $5490b4e7bbb569d8$export$6d4ed5b3aae01b61 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("erWN8")).then((module)=>module.AssetsLayout), {
    moduleId: "./src/packages/assets-app/layout/src/ui/index.tsx"
});
const $5490b4e7bbb569d8$export$fc69c032e8242676 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "assets-layout-async"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5490b4e7bbb569d8$export$6d4ed5b3aae01b61, null, children));

});
parcelRegister("erWN8", function(module, exports) {

let $a8513118ce344798$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a8513118ce344798$var$load("3GdhR").then(()=>parcelRequire('c2H7b'));

});


parcelRegister("7iyOx", function(module, exports) {

$parcel$export(module.exports, "AssetsPageConfigContainer", () => $084a169938ff8f74$export$68a74d1b39f069c5);

var $5uXOq = parcelRequire("5uXOq");

var $b7Svb = parcelRequire("b7Svb");

var $lfTZh = parcelRequire("lfTZh");

const $084a169938ff8f74$export$606469064c062fcd = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("16qia")).then((module)=>module.PageConfigContainer), {
    moduleId: "./src/packages/assets-app/page-config-container/src/ui/index.tsx"
});
const $084a169938ff8f74$export$68a74d1b39f069c5 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "assets-page-config-container-async"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($084a169938ff8f74$export$606469064c062fcd, null, children));

});
parcelRegister("16qia", function(module, exports) {

let $0cdabf0368bcadc3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0cdabf0368bcadc3$var$load("b5c4G").then(()=>parcelRequire('iHQhD'));

});



parcelRegister("6fdEz", function(module, exports) {

$parcel$export(module.exports, "assetsReportsRouteEntry", () => $36ddac7deaedb3c0$export$dabfe6668c5a0cc4);

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $jAA3i = parcelRequire("jAA3i");

var $e9YVH = parcelRequire("e9YVH");

var $lO0iE = parcelRequire("lO0iE");

var $lkFvK = parcelRequire("lkFvK");

var $k7I8D = parcelRequire("k7I8D");

var $55ZOZ = parcelRequire("55ZOZ");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $36ddac7deaedb3c0$var$assetsReportsPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $lO0iE.assetsReportsNav4HomeEntryPoint)
});
const $36ddac7deaedb3c0$export$dabfe6668c5a0cc4 = (0, $7NszV.createEntry)((0, $jAA3i.assetsReportsRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$36ddac7deaedb3c0$var$assetsReportsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-reports-home-page',
        resources: [
            ...(0, $55ZOZ.getAssetsAppResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("jAA3i", function(module, exports) {

$parcel$export(module.exports, "assetsReportsRoute", () => $6707851ae8c25753$export$b123ccf7df3854f4);
const $6707851ae8c25753$export$b123ccf7df3854f4 = {
    name: 'assets-reports-default-redirect',
    path: '/jira/assets/reports',
    exact: true
};

});

parcelRegister("lO0iE", function(module, exports) {

$parcel$export(module.exports, "assetsReportsNav4HomeEntryPoint", () => $4ebd26cccf0a7e53$export$1a891b207b85b219);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $4ebd26cccf0a7e53$export$1a891b207b85b219 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("4Ommz")).then((module)=>module.AssetsReportsNav4HomePage), {
        moduleId: "cd1143ba"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4Ommz", function(module, exports) {

let $380d2dc40f18d422$var$load = (parcelRequire("28QjX"))(4);
module.exports = $380d2dc40f18d422$var$load("hSg3u").then(()=>parcelRequire('je9tT'));

});



parcelRegister("8WMR9", function(module, exports) {

$parcel$export(module.exports, "assetsReportsTemplateRouteEntry", () => $e1d23f4ef8c5f349$export$c69d6dbd8091ce7b);

var $lmyls = parcelRequire("lmyls");

var $72NwO = parcelRequire("72NwO");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $21dDm = parcelRequire("21dDm");

var $e9YVH = parcelRequire("e9YVH");

var $ceEFi = parcelRequire("ceEFi");

var $55ZOZ = parcelRequire("55ZOZ");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $e1d23f4ef8c5f349$export$c69d6dbd8091ce7b = (0, $7NszV.createEntry)((0, $21dDm.assetsReportsTemplateRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        component: (0, $ceEFi.AssetsReports),
        resources: [
            ...(0, $55ZOZ.getAssetsAppResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout),
            (0, $ceEFi.LazyServicedeskCmdbAssetsReports)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $72NwO.default)
        },
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS),
                teamName: 'ITSM SAGA'
            }
        },
        perfMetricKey: 'service-management.insight-cmdb.load-assets-reports-template'
    }));

});
parcelRegister("72NwO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d99ccdcd3c9cebe4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

const $d99ccdcd3c9cebe4$export$2260a0528570f8da = (0, $b7Svb.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("d1041")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/assets-reports/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d99ccdcd3c9cebe4$var$AssetsReportsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "assets-reports-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d99ccdcd3c9cebe4$export$2260a0528570f8da, null)));
$d99ccdcd3c9cebe4$var$AssetsReportsSidebar.displayName = 'AssetsReportsSidebar';
var $d99ccdcd3c9cebe4$export$2e2bcd8739ae039 = $d99ccdcd3c9cebe4$var$AssetsReportsSidebar;

});
parcelRegister("d1041", function(module, exports) {

let $979b6b10017971e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $979b6b10017971e8$var$load("fApFb").then(()=>parcelRequire('ejeJy'));

});


parcelRegister("21dDm", function(module, exports) {

$parcel$export(module.exports, "assetsReportsTemplateRoute", () => $101c0306a4a55493$export$4255578ec14d83bb);
const $101c0306a4a55493$export$4255578ec14d83bb = {
    name: 'assets-reports',
    path: '/jira/assets/reports/:templateId',
    exact: true
};

});

parcelRegister("ceEFi", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbAssetsReports", () => $2e02aa1a19501df5$export$9f75cdfdfe8c8aaa);
$parcel$export(module.exports, "LazyServicedeskCmdbDefaultReportsRedirect", () => $2e02aa1a19501df5$export$2534c3e9f8e70d0d);
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsReportsUnsubscribe", () => $2e02aa1a19501df5$export$dec85f15dd805ac4);
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsReportsNav4HomePage", () => $2e02aa1a19501df5$export$c56cfef9aa68df09);
$parcel$export(module.exports, "AssetsReports", () => $2e02aa1a19501df5$export$d45b40d40442434);
$parcel$export(module.exports, "AssetsReportsUnsubscribe", () => $2e02aa1a19501df5$export$541b39e6d5be07df);
$parcel$export(module.exports, "AssetsReportingDefaultRedirect", () => $2e02aa1a19501df5$export$4155da54bfeacf74);
$parcel$export(module.exports, "AssetsReportsNav4HomePage", () => $2e02aa1a19501df5$export$9d28551695f98cae);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $2e02aa1a19501df5$export$9f75cdfdfe8c8aaa = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("dSf2u")).then((exportedMembers)=>exportedMembers.CmdbAssetsReports), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});

const $2e02aa1a19501df5$export$2534c3e9f8e70d0d = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("dSf2u")).then((exportedMembers)=>exportedMembers.CmdbDefaultReportsRedirect), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});

const $2e02aa1a19501df5$export$dec85f15dd805ac4 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("hMLEz")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports-unsubscribe/src/index.tsx"
});

const $2e02aa1a19501df5$export$c56cfef9aa68df09 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("dSf2u")).then((exportedMembers)=>exportedMembers.CmdbAssetsReportsNav4HomePage), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});
const $2e02aa1a19501df5$export$d45b40d40442434 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2e02aa1a19501df5$export$9f75cdfdfe8c8aaa,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports",
        shouldShowSpinner: true
    });
const $2e02aa1a19501df5$export$541b39e6d5be07df = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2e02aa1a19501df5$export$dec85f15dd805ac4,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-unsubscribe",
        shouldShowSpinner: true
    });
const $2e02aa1a19501df5$export$4155da54bfeacf74 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2e02aa1a19501df5$export$2534c3e9f8e70d0d,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-default-redirect",
        shouldShowSpinner: true
    });
const $2e02aa1a19501df5$export$9d28551695f98cae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2e02aa1a19501df5$export$c56cfef9aa68df09,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-home-page",
        shouldShowSpinner: true
    });

});
parcelRegister("dSf2u", function(module, exports) {

let $a19bfbf7acaa6259$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("i8SQL"), 4)),
    $a19bfbf7acaa6259$var$load("h2MrD"),
    $a19bfbf7acaa6259$var$load("bYT2S"),
    $a19bfbf7acaa6259$var$load("cM9em"),
    $a19bfbf7acaa6259$var$load("fr9NE"),
    $a19bfbf7acaa6259$var$load("jluSR")
]).then(()=>parcelRequire('7Jr0E'));

});

parcelRegister("hMLEz", function(module, exports) {

let $cf2be24ea4929603$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $cf2be24ea4929603$var$load("h2MrD"),
    $cf2be24ea4929603$var$load("bYT2S"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("838D9"), 4)),
    $cf2be24ea4929603$var$load("cM9em"),
    $cf2be24ea4929603$var$load("fr9NE"),
    $cf2be24ea4929603$var$load("hWDKD")
]).then(()=>parcelRequire('imnQf'));

});



parcelRegister("hSl7U", function(module, exports) {

$parcel$export(module.exports, "assetsReportsUnsubscribeRouteEntry", () => $ffecce251ff34805$export$25e4df4267166d6b);

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $dSJJZ = parcelRequire("dSJJZ");

var $e9YVH = parcelRequire("e9YVH");

var $l50mM = parcelRequire("l50mM");

var $lkFvK = parcelRequire("lkFvK");

var $55ZOZ = parcelRequire("55ZOZ");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $ffecce251ff34805$var$assetsReportsUnsubscribePageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $l50mM.assetsReportsUnsubscribeEntryPoint)
});
const $ffecce251ff34805$export$25e4df4267166d6b = (0, $7NszV.createEntry)((0, $dSJJZ.assetsReportsUnsubscribeRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$ffecce251ff34805$var$assetsReportsUnsubscribePageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-reports-unsubscribe',
        resources: [
            ...(0, $55ZOZ.getAssetsAppResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("dSJJZ", function(module, exports) {

$parcel$export(module.exports, "assetsReportsUnsubscribeRoute", () => $ff6ca822a7d33e3c$export$2b543c10e2c9e843);
const $ff6ca822a7d33e3c$export$2b543c10e2c9e843 = {
    name: 'assets-reports-unsubscribe',
    path: '/jira/assets/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};

});

parcelRegister("l50mM", function(module, exports) {

$parcel$export(module.exports, "assetsReportsUnsubscribeEntryPoint", () => $1972442ea7884b36$export$d827c87e65bb6e47);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $1972442ea7884b36$export$d827c87e65bb6e47 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("hMLEz")), {
        moduleId: "fe8b4981"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("9F4ID", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaRouteEntry", () => $28393bd3192d9d9e$export$92c5054123a75324);

var $7NszV = parcelRequire("7NszV");

var $k4Xe9 = parcelRequire("k4Xe9");

var $55ZOZ = parcelRequire("55ZOZ");

var $2iVq4 = parcelRequire("2iVq4");

var $bQHge = parcelRequire("bQHge");

var $lkFvK = parcelRequire("lkFvK");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $28393bd3192d9d9e$var$assetsSchemaPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $bQHge.assetsSchemaEntryPoint)
});
const $28393bd3192d9d9e$export$92c5054123a75324 = (0, $7NszV.createEntry)((0, $k4Xe9.assetsSchemaRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        component: (0, $2iVq4.ObjectSchemaV2),
        entryPoint: ()=>$28393bd3192d9d9e$var$assetsSchemaPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-object-schema',
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
    }));

});
parcelRegister("k4Xe9", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaRoute", () => $edb3724412b3283d$export$9515b8d2f9c8b12d);
const $edb3724412b3283d$export$9515b8d2f9c8b12d = {
    name: 'assets-schema',
    path: '/jira/assets/object-schema/:objectSchemaId'
};

});

parcelRegister("2iVq4", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbObjectSchemaV2", () => $3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc);
$parcel$export(module.exports, "ObjectSchemaV2", () => $3c1950a2c10ba0ce$export$f90a4f33c79fd86e);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("lNMR3")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-v2/src/index.tsx"
});
const $3c1950a2c10ba0ce$export$f90a4f33c79fd86e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-schema",
        shouldShowSpinner: true
    });
var $3c1950a2c10ba0ce$export$2e2bcd8739ae039 = $3c1950a2c10ba0ce$export$f90a4f33c79fd86e;

});
parcelRegister("lNMR3", function(module, exports) {

let $fdf41220376e3492$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fdf41220376e3492$var$load("6kkfK").then(()=>parcelRequire('ciybC'));

});


parcelRegister("bQHge", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaEntryPoint", () => $42b8401f19d7a816$export$bbb96f529694d699);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $42b8401f19d7a816$export$bbb96f529694d699 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("lNMR3")), {
        moduleId: "a9175d64"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("9CT95", function(module, exports) {

$parcel$export(module.exports, "assetsObjectTypeConfigurationRouteEntry", () => $90a106b2f6138f39$export$28b088de21f264eb);

var $7NszV = parcelRequire("7NszV");

var $8OvOy = parcelRequire("8OvOy");

var $e9YVH = parcelRequire("e9YVH");

var $55ZOZ = parcelRequire("55ZOZ");

var $2U2qS = parcelRequire("2U2qS");

var $lkFvK = parcelRequire("lkFvK");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $90a106b2f6138f39$var$assetsObjectTypeSettingsPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $2U2qS.assetsObjectTypeSettingsEntryPoint)
});
const $90a106b2f6138f39$export$28b088de21f264eb = (0, $7NszV.createEntry)((0, $8OvOy.assetsObjectTypeConfigurationRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$90a106b2f6138f39$var$assetsObjectTypeSettingsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-configure-object-type',
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'falcons'
            }
        },
        ufoName: 'service-management.insight-cmdb-object-type-configuration'
    }));

});
parcelRegister("8OvOy", function(module, exports) {

$parcel$export(module.exports, "assetsObjectTypeConfigurationRoute", () => $7219951fe88b4de4$export$fe5957039840ffd3);
const $7219951fe88b4de4$export$fe5957039840ffd3 = {
    name: 'assets-object-type-configuration',
    path: '/jira/assets/configure/object-type/:objectTypeId'
};

});

parcelRegister("2U2qS", function(module, exports) {

$parcel$export(module.exports, "assetsObjectTypeSettingsEntryPoint", () => $b38a85b0472f579f$export$fab2e471b162aafc);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $b38a85b0472f579f$export$fab2e471b162aafc = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("fOYqd")), {
        moduleId: "b4d985ee"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fOYqd", function(module, exports) {

let $b84a65061ec318ea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b84a65061ec318ea$var$load("hloRW").then(()=>parcelRequire('2lY4S'));

});



parcelRegister("gktyQ", function(module, exports) {

$parcel$export(module.exports, "assetsConfigurationRouteEntry", () => $fcbf97b2b57b87ef$export$1c86de5db8ff2b58);

var $7NszV = parcelRequire("7NszV");

var $9EXi9 = parcelRequire("9EXi9");

var $e9YVH = parcelRequire("e9YVH");

var $55ZOZ = parcelRequire("55ZOZ");

var $lkFvK = parcelRequire("lkFvK");

var $bdXN2 = parcelRequire("bdXN2");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $fcbf97b2b57b87ef$var$globalConfigurePageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $bdXN2.assetsGlobalSettingsEntryPoint)
});
const $fcbf97b2b57b87ef$export$1c86de5db8ff2b58 = (0, $7NszV.createEntry)((0, $9EXi9.assetsConfigurationRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        ufoName: 'servicedesk-cmdb-assets-configure',
        entryPoint: ()=>$fcbf97b2b57b87ef$var$globalConfigurePageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-configure',
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'falcons'
            }
        }
    }));

});
parcelRegister("9EXi9", function(module, exports) {

$parcel$export(module.exports, "assetsConfigurationRoute", () => $f9206ce977f9b0fa$export$266d00c8001d32ab);
const $f9206ce977f9b0fa$export$266d00c8001d32ab = {
    name: 'assets-configure',
    path: '/jira/assets/configure/global'
};

});

parcelRegister("bdXN2", function(module, exports) {

$parcel$export(module.exports, "assetsGlobalSettingsEntryPoint", () => $d81197ab248aed96$export$2b083e0274144f1b);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $d81197ab248aed96$export$2b083e0274144f1b = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("lObHS")), {
        moduleId: "b65d2969"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lObHS", function(module, exports) {

let $fe07592e599b3636$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fe07592e599b3636$var$load("aHtXH").then(()=>parcelRequire('cB0p5'));

});



parcelRegister("elyxq", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaConfigurationRouteEntry", () => $c609df68fdefe1cd$export$6c9c29c3048f2e2c);

var $7NszV = parcelRequire("7NszV");

var $6j0IA = parcelRequire("6j0IA");

var $cNynZ = parcelRequire("cNynZ");

var $e9YVH = parcelRequire("e9YVH");

var $55ZOZ = parcelRequire("55ZOZ");

var $6acMA = parcelRequire("6acMA");

var $lkFvK = parcelRequire("lkFvK");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $c609df68fdefe1cd$var$assetsSchemaSettingsPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $6acMA.assetsSchemaSettingsEntryPoint)
});
const $c609df68fdefe1cd$export$6c9c29c3048f2e2c = (0, $7NszV.createEntry)((0, $cNynZ.assetsSchemaConfigurationRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$c609df68fdefe1cd$var$assetsSchemaSettingsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-object-schema-configuration',
        resources: [
            ...(0, $55ZOZ.getAssetsAppResources)(),
            (0, $6j0IA.serviceDeskAssetsImportTypeForgeDataResource)
        ],
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        }
    }));

});
parcelRegister("6j0IA", function(module, exports) {

$parcel$export(module.exports, "serviceDeskAssetsImportTypeForgeDataResource", () => $f0c74bdf86d6b898$export$58d2462746e91c7d);

var $2M1hQ = parcelRequire("2M1hQ");

const $f0c74bdf86d6b898$var$getDataLoader = ()=>(parcelRequire("94QpK"));
const $f0c74bdf86d6b898$export$58d2462746e91c7d = (0, $2M1hQ.createResource)({
    type: 'ASSETS_IMPORT_TYPE_FORGE_DATA',
    getKey: ()=>'extensions',
    getDataLoader: $f0c74bdf86d6b898$var$getDataLoader,
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
parcelRegister("94QpK", function(module, exports) {

let $69bd252434382084$var$load = (parcelRequire("28QjX"))(4);
module.exports = $69bd252434382084$var$load("29sLe").then(()=>parcelRequire('jwVSb'));

});


parcelRegister("cNynZ", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaConfigurationRoute", () => $a7e42f61407bcdca$export$f27e51e1e8d78f80);
const $a7e42f61407bcdca$export$f27e51e1e8d78f80 = {
    name: 'assets-schema-configuration',
    path: '/jira/assets/configure/object-schema/:objectSchemaId'
};

});

parcelRegister("6acMA", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaSettingsEntryPoint", () => $f8bbd3389b616628$export$b012e15a5f6394fc);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $f8bbd3389b616628$export$b012e15a5f6394fc = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("gDJ3O")), {
        moduleId: "c93bb7f3"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gDJ3O", function(module, exports) {

let $c1d33de9092c22a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c1d33de9092c22a1$var$load("jCYvk").then(()=>parcelRequire('hEchH'));

});



parcelRegister("3T2Ye", function(module, exports) {

$parcel$export(module.exports, "assetsObjectRouteEntry", () => $615c397cb5d7287d$export$17871a1fbc6e31db);

var $7NszV = parcelRequire("7NszV");

var $8naTI = parcelRequire("8naTI");

var $1KCrA = parcelRequire("1KCrA");

var $55ZOZ = parcelRequire("55ZOZ");

var $9jDQB = parcelRequire("9jDQB");

var $lkFvK = parcelRequire("lkFvK");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $615c397cb5d7287d$var$assetsObjectPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $9jDQB.assetsObjectViewEntryPoint)
});
const $615c397cb5d7287d$export$17871a1fbc6e31db = (0, $7NszV.createEntry)((0, $1KCrA.assetsObjectRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$615c397cb5d7287d$var$assetsObjectPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-object-v2',
        resources: [
            ...(0, $55ZOZ.getAssetsAppResources)(),
            (0, $8naTI.insightObjectResource)
        ],
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load'
    }));

});
parcelRegister("8naTI", function(module, exports) {

$parcel$export(module.exports, "insightObjectResource", () => $2ad42c3dacc09c9e$export$215464c8085c5e35);

var $2M1hQ = parcelRequire("2M1hQ");

var $7JHOP = parcelRequire("7JHOP");
const $2ad42c3dacc09c9e$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT = 'SERVICEDESK_INSIGHT_OBJECT';
const $2ad42c3dacc09c9e$export$215464c8085c5e35 = (0, $2M1hQ.createResource)({
    type: $2ad42c3dacc09c9e$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT,
    getKey: ({ match: match })=>match.params.objectId || '',
    getData: $7JHOP.default,
    isBrowserOnly: true
});

});
parcelRegister("7JHOP", function(module, exports) {

$parcel$export(module.exports, "default", () => $07f064c629fd32ba$export$2e2bcd8739ae039);

var $x9xyg = parcelRequire("x9xyg");

var $dJl1T = parcelRequire("dJl1T");

var $xJtdX = parcelRequire("xJtdX");

var $7f4tk = parcelRequire("7f4tk");

var $8PRuf = parcelRequire("8PRuf");

var $iR3GG = parcelRequire("iR3GG");

var $eJOOa = parcelRequire("eJOOa");

var $ahEft = parcelRequire("ahEft");

var $9NiTW = parcelRequire("9NiTW");
const $07f064c629fd32ba$var$fetchInsightObjectDetails = async (routeDataContext, routerContext)=>{
    try {
        const { match: { params: params } } = routeDataContext;
        const { objectId: objectId } = params;
        if (objectId == null) return null;
        const workspaceId = await (0, $ahEft.default)(routeDataContext, routerContext);
        if (workspaceId == null) return null;
        const data = await (0, $7f4tk.default)((0, $eJOOa.getCmdbObjectByIdUrl)(workspaceId, objectId));
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jiraServicedeskInsightObjectResource', error);
        (0, $xJtdX.fireCmdbErrorAnalytics)({
            meta: {
                id: 'jiraServicedeskInsightObjectResource',
                packageName: 'jiraSpa'
            },
            error: error
        });
        throw error;
    }
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07f064c629fd32ba$export$2e2bcd8739ae039 = async (routeDataContext, routerContext)=>{
    const { tenantContext: tenantContext } = routerContext;
    // Early exit on these cases and return a valid response. We don't want to flood sentry.
    if (!(0, $9NiTW.checkAuthentication)(tenantContext)) throw (0, $iR3GG.createResourceError)({
        component: 'spa.view.routes.servicedesk.cmdb-object.getData',
        message: 'Current user is not authenticated',
        name: 'AuthenticationError',
        skipSentry: true
    });
    return $07f064c629fd32ba$var$fetchInsightObjectDetails(routeDataContext, routerContext);
};

});
parcelRegister("eJOOa", function(module, exports) {

$parcel$export(module.exports, "getCmdbObjectByIdUrl", () => $bba7f62e646e53a7$export$d33c3e25476d091d);
$parcel$export(module.exports, "getCmdbObjectByIdUrlWithoutQueryParams", () => $bba7f62e646e53a7$export$6ef8997552257871);
$parcel$export(module.exports, "getCmdbObjectByIdActivityUrl", () => $bba7f62e646e53a7$export$20c207abffb62450);
$parcel$export(module.exports, "getCmdbObjectByIdAvatarUrl", () => $bba7f62e646e53a7$export$31df868d16d545f8);
$parcel$export(module.exports, "getCmdbObjectByIdReferenceInfoUrl", () => $bba7f62e646e53a7$export$5044a1e9fc201773);
$parcel$export(module.exports, "getCmdbObjectCloneByIdUrl", () => $bba7f62e646e53a7$export$d7f6dc1d4f622458);
$parcel$export(module.exports, "getCmdbObjectCreateUrl", () => $bba7f62e646e53a7$export$9cdc19e8944d38cf);
$parcel$export(module.exports, "getCmdbObjectNavlistUrl", () => $bba7f62e646e53a7$export$bf9c534c2cd21829);
$parcel$export(module.exports, "getCmdbObjectNavlistQueryLanguageUrl", () => $bba7f62e646e53a7$export$b35334340ee827fa);
$parcel$export(module.exports, "getCmdbObjectRecentUrl", () => $bba7f62e646e53a7$export$a0a7c6f22bebdef0);
$parcel$export(module.exports, "getCmdbObjectQueryLanguageTotalCountUrl", () => $bba7f62e646e53a7$export$ee74f95a469c4433);
$parcel$export(module.exports, "getCmdbObjectQueryLanguageUrl", () => $bba7f62e646e53a7$export$84a34ee3f18e226);
$parcel$export(module.exports, "getCmdbAsyncObjectExportUrl", () => $bba7f62e646e53a7$export$878b627ac685384e);
$parcel$export(module.exports, "getCmdbAsyncBulkQrCodeUrl", () => $bba7f62e646e53a7$export$8eb3a6b36886db0);
$parcel$export(module.exports, "getCmdbAsyncBulkDeleteUrl", () => $bba7f62e646e53a7$export$b02201bcaeb75291);
$parcel$export(module.exports, "getCmdbAsyncBulkEditUrl", () => $bba7f62e646e53a7$export$f4d68a6f0e3217b5);

var $ebyGx = parcelRequire("ebyGx");

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/object
 */ const $bba7f62e646e53a7$var$getCmdbObjectUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/object`;
const $bba7f62e646e53a7$export$d33c3e25476d091d = (workspaceId, objectId, includeExtendedInfo = false)=>{
    const path = $bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId);
    if (!includeExtendedInfo) return `${path}?${(0, $ebyGx.stringify)({
        includeExtendedInfo: includeExtendedInfo
    })}`;
    return path;
};
const $bba7f62e646e53a7$export$6ef8997552257871 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/${objectId}`;
const $bba7f62e646e53a7$export$20c207abffb62450 = (workspaceId, objectId, queryParams)=>`${$bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId)}/activity?${(0, $ebyGx.stringify)(queryParams)}`;
const $bba7f62e646e53a7$export$31df868d16d545f8 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId)}/avatar`;
const $bba7f62e646e53a7$export$5044a1e9fc201773 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId)}/referenceinfo`;
const $bba7f62e646e53a7$export$d7f6dc1d4f622458 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/clone/${objectId}`;
const $bba7f62e646e53a7$export$9cdc19e8944d38cf = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/create`;
const $bba7f62e646e53a7$export$bf9c534c2cd21829 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/navlist`;
const $bba7f62e646e53a7$export$b35334340ee827fa = (workspaceId)=>`${$bba7f62e646e53a7$export$bf9c534c2cd21829(workspaceId)}/aql`;
const $bba7f62e646e53a7$export$a0a7c6f22bebdef0 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/recent?${(0, $ebyGx.stringify)(queryParams)}`;
const $bba7f62e646e53a7$export$ee74f95a469c4433 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/aql/totalcount`;
const $bba7f62e646e53a7$export$1016ae73c04d9079 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/search?${(0, $ebyGx.stringify)(queryParams)}`;
const $bba7f62e646e53a7$export$cb41514f2508b033 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/searchbyattributes?${(0, $ebyGx.stringify)(queryParams)}`;
const $bba7f62e646e53a7$export$84a34ee3f18e226 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/aql?${(0, $ebyGx.stringify)(queryParams)}`;
const $bba7f62e646e53a7$export$878b627ac685384e = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkexport`;
const $bba7f62e646e53a7$export$8eb3a6b36886db0 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkqrcode?${(0, $ebyGx.stringify)(queryParams)}`;
const $bba7f62e646e53a7$export$b02201bcaeb75291 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkdelete`;
const $bba7f62e646e53a7$export$f4d68a6f0e3217b5 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkedit`;

});



parcelRegister("1KCrA", function(module, exports) {

$parcel$export(module.exports, "assetsObjectRoute", () => $f53da45d067bd137$export$8f0b5215230b6dd1);
const $f53da45d067bd137$export$8f0b5215230b6dd1 = {
    name: 'assets-object',
    path: '/jira/assets/object/:objectId'
};

});

parcelRegister("9jDQB", function(module, exports) {

$parcel$export(module.exports, "assetsObjectViewEntryPoint", () => $24c507f8dd2d8705$export$4311ec530d21ec36);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $24c507f8dd2d8705$export$4311ec530d21ec36 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("aweeK")), {
        moduleId: "5026c489"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aweeK", function(module, exports) {

let $7a87efb08495ad69$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7a87efb08495ad69$var$load("hPzOn"),
    $7a87efb08495ad69$var$load("dsiAd"),
    $7a87efb08495ad69$var$load("8VYTt")
]).then(()=>parcelRequire('8V2Yz'));

});



parcelRegister("cVgRQ", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsGlobalConfigurationRouteEntry", () => $faac49f10a71388a$export$6755c90e62150ca0);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $92pmL = parcelRequire("92pmL");

var $e9YVH = parcelRequire("e9YVH");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $gXGYk = parcelRequire("gXGYk");

var $aP5Tt = parcelRequire("aP5Tt");
const $faac49f10a71388a$export$6755c90e62150ca0 = (0, $7NszV.createEntry)((0, $92pmL.servicedeskCmdbAssetsGlobalConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        ufoName: 'servicedesk-cmdb-assets-configure',
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $gXGYk.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gXGYk.LazyServicedeskCmdbGlobalConfigure)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'falcons'
            }
        }
    }));

});
parcelRegister("92pmL", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsGlobalConfigurationRoute", () => $d7e386cd256d5aa1$export$b28679181cd68abd);
const $d7e386cd256d5aa1$export$b28679181cd68abd = {
    name: 'servicedesk-cmdb-configure',
    path: '/jira/servicedesk/assets/configure/global'
};

});

parcelRegister("gXGYk", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbGlobalConfigure", () => $faa956883f49da96$export$b80bd807bad3fd0a);
$parcel$export(module.exports, "default", () => $faa956883f49da96$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $faa956883f49da96$export$b80bd807bad3fd0a = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("lObHS")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-v2/src/index.tsx"
});
const $faa956883f49da96$var$GlobalConfigure = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $faa956883f49da96$export$b80bd807bad3fd0a,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure",
        shouldShowSpinner: true
    });
var $faa956883f49da96$export$2e2bcd8739ae039 = $faa956883f49da96$var$GlobalConfigure;

});

parcelRegister("aP5Tt", function(module, exports) {

$parcel$export(module.exports, "AssetsAppRedirect", () => $8bbdf2dde395c922$export$5d5d166a9477289f);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $7tQej = parcelRequire("7tQej");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $blEB6 = parcelRequire("blEB6");
const $8bbdf2dde395c922$export$5d5d166a9477289f = ({ match: match, query: query })=>{
    const pattern = /\/jira\/servicedesk\/(assets|insight)/;
    let redirectionUrl = match.url.replace(pattern, (0, $blEB6.ASSETS_APP_ROUTE_PREFIX));
    if (Object.keys(query).length > 0) redirectionUrl += `?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query)}`;
    const analyticsAttributes = {
        matchedRoute: match.path
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "assetsAppRedirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: redirectionUrl,
        push: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: analyticsAttributes
    }));
};

});


parcelRegister("8XfJX", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectRouteEntry", () => $3695f420dde24db1$export$ed571153b6c25586);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $8naTI = parcelRequire("8naTI");

var $gyaGI = parcelRequire("gyaGI");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $8lolW = parcelRequire("8lolW");

var $aP5Tt = parcelRequire("aP5Tt");
const $3695f420dde24db1$export$ed571153b6c25586 = (0, $7NszV.createEntry)((0, $gyaGI.servicedeskCmdbAssetsObjectRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $8lolW.InsightCmdbObjectViewV2),
        resources: [
            ...(0, $55ZOZ.getCmdbResources)(),
            (0, $8naTI.insightObjectResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8lolW.LazyServicedeskCmdbObjectV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load'
    }));

});
parcelRegister("gyaGI", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectRoute", () => $2c9190d0f388a73b$export$bf02944216c526ff);
const $2c9190d0f388a73b$export$bf02944216c526ff = {
    name: 'servicedesk-cmdb-object',
    path: '/jira/servicedesk/assets/object/:objectId'
};

});

parcelRegister("8lolW", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbObjectV2", () => $3afd4c2d86bdef54$export$411c1981ced22249);
$parcel$export(module.exports, "InsightCmdbObjectViewV2", () => $3afd4c2d86bdef54$export$3c208f927c6178ee);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $3afd4c2d86bdef54$export$411c1981ced22249 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("aweeK")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-v2/src/index.tsx"
});
const $3afd4c2d86bdef54$export$3c208f927c6178ee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3afd4c2d86bdef54$export$411c1981ced22249,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-v2",
        shouldShowSpinner: true
    });
var $3afd4c2d86bdef54$export$2e2bcd8739ae039 = $3afd4c2d86bdef54$export$3c208f927c6178ee;

});


parcelRegister("5o5UE", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaConfigurationRouteEntry", () => $1bf397a941deb833$export$ce7f2af5016c6aa9);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $6j0IA = parcelRequire("6j0IA");

var $9kM4D = parcelRequire("9kM4D");

var $e9YVH = parcelRequire("e9YVH");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $2vrwM = parcelRequire("2vrwM");

var $aP5Tt = parcelRequire("aP5Tt");
const $1bf397a941deb833$export$ce7f2af5016c6aa9 = (0, $7NszV.createEntry)((0, $9kM4D.servicedeskCmdbAssetsObjectSchemaConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $2vrwM.default),
        resources: [
            ...(0, $55ZOZ.getCmdbResources)(),
            (0, $6j0IA.serviceDeskAssetsImportTypeForgeDataResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2vrwM.LazyServicedeskCmdbObjectSchemaConfiguration)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        }
    }));

});
parcelRegister("9kM4D", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaConfigurationRoute", () => $3076563cb1feeec0$export$b4a150d67181752);
const $3076563cb1feeec0$export$b4a150d67181752 = {
    name: 'servicedesk-cmdb-object-schema-configuration',
    path: '/jira/servicedesk/assets/configure/object-schema/:objectSchemaId'
};

});

parcelRegister("2vrwM", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbObjectSchemaConfiguration", () => $af13a504c251f159$export$8305a1bc1c5bee45);
$parcel$export(module.exports, "default", () => $af13a504c251f159$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $af13a504c251f159$export$8305a1bc1c5bee45 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("gDJ3O")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-configuration/src/index.tsx"
});
const $af13a504c251f159$var$ObjectSchemaConfiguration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $af13a504c251f159$export$8305a1bc1c5bee45,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-schema-configuration",
        shouldShowSpinner: true
    });
var $af13a504c251f159$export$2e2bcd8739ae039 = $af13a504c251f159$var$ObjectSchemaConfiguration;

});


parcelRegister("2OBp2", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaRouteEntry", () => $8d7a97c0aebbdbdc$export$d9dc7083d0a34d11);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $3W4zD = parcelRequire("3W4zD");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $2iVq4 = parcelRequire("2iVq4");

var $aP5Tt = parcelRequire("aP5Tt");
const $8d7a97c0aebbdbdc$export$d9dc7083d0a34d11 = (0, $7NszV.createEntry)((0, $3W4zD.servicedeskCmdbAssetsObjectSchemaRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $2iVq4.ObjectSchemaV2),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2iVq4.LazyServicedeskCmdbObjectSchemaV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
    }));

});
parcelRegister("3W4zD", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaRoute", () => $7cc0a4e0da040e16$export$6f86804eb594cd29);
const $7cc0a4e0da040e16$export$6f86804eb594cd29 = {
    name: 'servicedesk-cmdb-object-schema',
    path: '/jira/servicedesk/assets/object-schema/:objectSchemaId'
};

});


parcelRegister("29XA4", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectTypeConfigurationRouteEntry", () => $271b67f72308a1a9$export$d45b927987c92c0e);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $VSMJU = parcelRequire("VSMJU");

var $e9YVH = parcelRequire("e9YVH");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $b93Zs = parcelRequire("b93Zs");

var $aP5Tt = parcelRequire("aP5Tt");
const $271b67f72308a1a9$export$d45b927987c92c0e = (0, $7NszV.createEntry)((0, $VSMJU.servicedeskCmdbAssetsObjectTypeConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $b93Zs.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $b93Zs.LazyServicedeskCmdbConfigureObjectType)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'falcons'
            }
        },
        ufoName: 'service-management.insight-cmdb-object-type-configuration'
    }));

});
parcelRegister("VSMJU", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectTypeConfigurationRoute", () => $f41e677a77064268$export$73b901e16d5e5a02);
const $f41e677a77064268$export$73b901e16d5e5a02 = {
    name: 'servicedesk-cmdb-object-type-configuration',
    path: '/jira/servicedesk/assets/configure/object-type/:objectTypeId'
};

});

parcelRegister("b93Zs", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbConfigureObjectType", () => $14de2d11a3985015$export$926956539e1f72ba);
$parcel$export(module.exports, "default", () => $14de2d11a3985015$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $14de2d11a3985015$export$926956539e1f72ba = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("fOYqd")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-object-type/src/index.tsx"
});
const $14de2d11a3985015$var$InsightConfigureObjectType = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $14de2d11a3985015$export$926956539e1f72ba,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure-object-type",
        shouldShowSpinner: true
    });
var $14de2d11a3985015$export$2e2bcd8739ae039 = $14de2d11a3985015$var$InsightConfigureObjectType;

});


parcelRegister("aNc7A", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsRouteEntry", () => $b2f990f1e1876908$export$2621677b40f03d6c);

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $3HwlS = parcelRequire("3HwlS");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fpjJX = parcelRequire("fpjJX");

var $zCmTp = parcelRequire("zCmTp");

var $e9YVH = parcelRequire("e9YVH");

var $gRzZD = parcelRequire("gRzZD");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $ceEFi = parcelRequire("ceEFi");

var $aP5Tt = parcelRequire("aP5Tt");
const $b2f990f1e1876908$export$2621677b40f03d6c = (0, $7NszV.createEntry)((0, $zCmTp.servicedeskCmdbAssetsReportsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $ceEFi.AssetsReportsNav4HomePage), (0, $ceEFi.AssetsReportingDefaultRedirect)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $gRzZD.workspaceResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ceEFi.LazyServicedeskCmdbDefaultReportsRedirect),
            (0, $ceEFi.LazyServicedeskCmdbAssetsReportsNav4HomePage)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("zCmTp", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsRoute", () => $5c3155ab36693f37$export$a075d8b7c4c55c41);
const $5c3155ab36693f37$export$a075d8b7c4c55c41 = {
    name: 'servicedesk-cmdb-assets-reports-default-redirect',
    path: '/jira/servicedesk/assets/reports',
    exact: true
};

});


parcelRegister("4e4nJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsTemplateRouteEntry", () => $8f1e557acbc4fa67$export$51d27be4bd1db6ce);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $72NwO = parcelRequire("72NwO");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fpjJX = parcelRequire("fpjJX");

var $3b83Z = parcelRequire("3b83Z");

var $e9YVH = parcelRequire("e9YVH");

var $gRzZD = parcelRequire("gRzZD");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $ceEFi = parcelRequire("ceEFi");

var $aP5Tt = parcelRequire("aP5Tt");
const $8f1e557acbc4fa67$export$51d27be4bd1db6ce = (0, $7NszV.createEntry)((0, $3b83Z.servicedeskCmdbAssetsReportsTemplateRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $ceEFi.AssetsReports),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $gRzZD.workspaceResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ceEFi.LazyServicedeskCmdbAssetsReports)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $72NwO.default)
        },
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS),
                teamName: 'ITSM SAGA'
            }
        },
        perfMetricKey: 'service-management.insight-cmdb.load-assets-reports-template'
    }));

});
parcelRegister("3b83Z", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsTemplateRoute", () => $a647cdc489d0614a$export$9482cb7f11a7730);
const $a647cdc489d0614a$export$9482cb7f11a7730 = {
    name: 'servicedesk-cmdb-assets-reports',
    path: '/jira/servicedesk/assets/reports/:templateId',
    exact: true
};

});


parcelRegister("5nU8P", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsUnsubscribeRouteEntry", () => $3f95abeddff727cc$export$5842852f274cd739);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fpjJX = parcelRequire("fpjJX");

var $nQffI = parcelRequire("nQffI");

var $e9YVH = parcelRequire("e9YVH");

var $gRzZD = parcelRequire("gRzZD");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $ceEFi = parcelRequire("ceEFi");

var $aP5Tt = parcelRequire("aP5Tt");
const $3f95abeddff727cc$export$5842852f274cd739 = (0, $7NszV.createEntry)((0, $nQffI.servicedeskCmdbAssetsReportsUnsubscribeRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $ceEFi.AssetsReportsUnsubscribe),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $gRzZD.workspaceResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ceEFi.LazyServicedeskCmdbAssetsReportsUnsubscribe)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("nQffI", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsUnsubscribeRoute", () => $8ce2bb095b9742dc$export$66ab60d374e8e458);
const $8ce2bb095b9742dc$export$66ab60d374e8e458 = {
    name: 'servicedesk-cmdb-assets-reports-unsubscribe',
    path: '/jira/servicedesk/assets/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};

});


parcelRegister("kHVIE", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsSchemasRouteEntry", () => $bd164bb7c160f180$export$70a75f8d403c935a);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $6t4Wv = parcelRequire("6t4Wv");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $ia3qM = parcelRequire("ia3qM");

var $aP5Tt = parcelRequire("aP5Tt");
const $bd164bb7c160f180$export$70a75f8d403c935a = (0, $7NszV.createEntry)((0, $6t4Wv.servicedeskCmdbAssetsSchemasRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $ia3qM.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ia3qM.LazyServicedeskCmdbLandingPage)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
    }));

});
parcelRegister("6t4Wv", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsSchemasRoute", () => $1096c786552e99d7$export$118f7c2ddb756e80);
const $1096c786552e99d7$export$118f7c2ddb756e80 = {
    name: 'servicedesk-cmdb-assets',
    path: '/jira/servicedesk/assets',
    exact: true
};

});

parcelRegister("ia3qM", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbLandingPage", () => $3371db153f9530b2$export$f6c79e6ff37913ee);
$parcel$export(module.exports, "default", () => $3371db153f9530b2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $3371db153f9530b2$export$f6c79e6ff37913ee = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("4gjbD")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-landing-page/src/index.tsx"
});
const $3371db153f9530b2$var$LandingPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3371db153f9530b2$export$f6c79e6ff37913ee,
        pageId: "spa-apps/servicedesk/insight/cmdb-landing-page",
        shouldShowSpinner: true
    });
var $3371db153f9530b2$export$2e2bcd8739ae039 = $3371db153f9530b2$var$LandingPage;

});


parcelRegister("eHeAh", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightConfigureGlobalRouteEntry", () => $c572a1f6d205e72b$export$69b479583cd0d13f);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $h8gJx = parcelRequire("h8gJx");

var $e9YVH = parcelRequire("e9YVH");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $gXGYk = parcelRequire("gXGYk");

var $aP5Tt = parcelRequire("aP5Tt");
const $c572a1f6d205e72b$export$69b479583cd0d13f = (0, $7NszV.createEntry)((0, $h8gJx.servicedeskCmdbInsightConfigureGlobalRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        ufoName: 'servicedesk-cmdb-insight-configure-global',
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $gXGYk.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gXGYk.LazyServicedeskCmdbGlobalConfigure)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'falcons'
            }
        }
    }));

});
parcelRegister("h8gJx", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightConfigureGlobalRoute", () => $ba065f4b091a02af$export$96e5da52356f214c);
const $ba065f4b091a02af$export$96e5da52356f214c = {
    name: 'servicedesk-cmdb-configure',
    path: '/jira/servicedesk/insight/configure/global'
};

});


parcelRegister("9R3is", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightConfigureRouteEntry", () => $495bba4b83c4abb8$export$277a55a31c82cf0e);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $8xYq7 = parcelRequire("8xYq7");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $ac6Qh = parcelRequire("ac6Qh");

var $aP5Tt = parcelRequire("aP5Tt");
const $495bba4b83c4abb8$export$277a55a31c82cf0e = (0, $7NszV.createEntry)((0, $8xYq7.servicedeskCmdbInsightConfigureRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        ufoName: 'servicedesk-cmdb-insight-configure',
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $ac6Qh.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ac6Qh.LazyServicedeskCmdbConfigure)
        ]
    }));

});
parcelRegister("8xYq7", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightConfigureRoute", () => $b3ba64550401680b$export$e960ab4fcd3e80b6);
const $b3ba64550401680b$export$e960ab4fcd3e80b6 = {
    name: 'servicedesk-cmdb-configure',
    path: '/jira/servicedesk/insight/configure'
};

});

parcelRegister("ac6Qh", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbConfigure", () => $9872d73b74d97014$export$8075d4042713bf6d);
$parcel$export(module.exports, "default", () => $9872d73b74d97014$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $9872d73b74d97014$export$8075d4042713bf6d = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("lcsnz")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure/src/index.tsx"
});
const $9872d73b74d97014$var$InsightConfigure = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9872d73b74d97014$export$8075d4042713bf6d,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure",
        shouldShowSpinner: true
    });
var $9872d73b74d97014$export$2e2bcd8739ae039 = $9872d73b74d97014$var$InsightConfigure;

});
parcelRegister("lcsnz", function(module, exports) {

let $f6f0bb7ebd677f97$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f6f0bb7ebd677f97$var$load("95JPD").then(()=>parcelRequire('cKWhs'));

});



parcelRegister("lKkaY", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObject4RouteEntry", () => $20b7f48df08d140e$export$95574c3333e559d3);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $8naTI = parcelRequire("8naTI");

var $dODCf = parcelRequire("dODCf");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $8lolW = parcelRequire("8lolW");

var $aP5Tt = parcelRequire("aP5Tt");
const $20b7f48df08d140e$export$95574c3333e559d3 = (0, $7NszV.createEntry)((0, $dODCf.servicedeskCmdbInsightObject4Route), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $8lolW.InsightCmdbObjectViewV2),
        resources: [
            ...(0, $55ZOZ.getCmdbResources)(),
            (0, $8naTI.insightObjectResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8lolW.LazyServicedeskCmdbObjectV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load'
    }));

});
parcelRegister("dODCf", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObject4Route", () => $fa024efc61833843$export$223f5bacfd3d39fd);
const $fa024efc61833843$export$223f5bacfd3d39fd = {
    name: 'servicedesk-cmdb-object',
    path: '/jira/servicedesk/insight/assets/:objectId'
};

});


parcelRegister("brWuf", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaConfigurationRouteEntry", () => $dc805604e47f30ff$export$261e9b5115dfbb0a);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $6tshd = parcelRequire("6tshd");

var $e9YVH = parcelRequire("e9YVH");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $2vrwM = parcelRequire("2vrwM");

var $aP5Tt = parcelRequire("aP5Tt");
const $dc805604e47f30ff$export$261e9b5115dfbb0a = (0, $7NszV.createEntry)((0, $6tshd.servicedeskCmdbInsightObjectSchemaConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $2vrwM.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2vrwM.LazyServicedeskCmdbObjectSchemaConfiguration)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        }
    }));

});
parcelRegister("6tshd", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaConfigurationRoute", () => $0be30b09ce65a175$export$f6b688a8729943b3);
const $0be30b09ce65a175$export$f6b688a8729943b3 = {
    name: 'servicedesk-cmdb-object-schema-configuration',
    path: '/jira/servicedesk/insight/configure/object-schema/:objectSchemaId'
};

});


parcelRegister("iXsus", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaRouteEntry", () => $390b0c9138642138$export$192b200c13b0b76a);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $S3PTJ = parcelRequire("S3PTJ");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $2iVq4 = parcelRequire("2iVq4");

var $aP5Tt = parcelRequire("aP5Tt");
const $390b0c9138642138$export$192b200c13b0b76a = (0, $7NszV.createEntry)((0, $S3PTJ.servicedeskCmdbInsightObjectSchemaRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $2iVq4.ObjectSchemaV2),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2iVq4.LazyServicedeskCmdbObjectSchemaV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
    }));

});
parcelRegister("S3PTJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaRoute", () => $0050a642a1c533ba$export$fcde60ded71d4ae6);
const $0050a642a1c533ba$export$fcde60ded71d4ae6 = {
    name: 'servicedesk-cmdb-object-schema',
    path: '/jira/servicedesk/insight/object-schemas/:objectSchemaId'
};

});


parcelRegister("xwXfC", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectTypeConfigurationRouteEntry", () => $0a9518d238b0ac1f$export$de4ab140a5dbd984);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $kA9Q5 = parcelRequire("kA9Q5");

var $e9YVH = parcelRequire("e9YVH");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $b93Zs = parcelRequire("b93Zs");

var $aP5Tt = parcelRequire("aP5Tt");
const $0a9518d238b0ac1f$export$de4ab140a5dbd984 = (0, $7NszV.createEntry)((0, $kA9Q5.servicedeskCmdbInsightObjectTypeConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $b93Zs.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $b93Zs.LazyServicedeskCmdbConfigureObjectType)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'falcons'
            }
        }
    }));

});
parcelRegister("kA9Q5", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectTypeConfigurationRoute", () => $de5e134e813298dc$export$12e89d5d79d59785);
const $de5e134e813298dc$export$12e89d5d79d59785 = {
    name: 'servicedesk-cmdb-object-type-configuration',
    path: '/jira/servicedesk/insight/configure/object-type/:objectTypeId'
};

});


parcelRegister("3lpLH", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightRouteEntry", () => $a395bb20c6d1e9c8$export$3befca4eb012b818);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $cx6sj = parcelRequire("cx6sj");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $ia3qM = parcelRequire("ia3qM");

var $aP5Tt = parcelRequire("aP5Tt");
const $a395bb20c6d1e9c8$export$3befca4eb012b818 = (0, $7NszV.createEntry)((0, $cx6sj.servicedeskCmdbInsightRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $ia3qM.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ia3qM.LazyServicedeskCmdbLandingPage)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
    }));

});
parcelRegister("cx6sj", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightRoute", () => $638ad863a15aceaf$export$1efada07b7203f2d);
const $638ad863a15aceaf$export$1efada07b7203f2d = {
    name: 'servicedesk-cmdb-insight',
    path: '/jira/servicedesk/insight',
    exact: true
};

});


parcelRegister("kNZj9", function(module, exports) {

$parcel$export(module.exports, "servicedeskCreateProjectRouteEntry", () => $3e592ff21679cec3$export$ac25abe07ac3f570);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $h2JLJ = parcelRequire("h2JLJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $3e592ff21679cec3$var$LazyServiceDeskCreateProject = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("gYcsx")), {
    moduleId: "./src/packages/spa-apps/servicedesk/create-project/src/index.tsx"
});
const $3e592ff21679cec3$var$ServiceDeskCreateProject = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3e592ff21679cec3$var$LazyServiceDeskCreateProject,
        pageId: "spa-apps/servicedesk/create-project",
        shouldShowSpinner: true
    });
const $3e592ff21679cec3$export$ac25abe07ac3f570 = (0, $7NszV.createEntry)((0, $h2JLJ.servicedeskCreateProjectRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: $3e592ff21679cec3$var$ServiceDeskCreateProject,
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $3e592ff21679cec3$var$LazyServiceDeskCreateProject
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CREATE_PROJECT,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CREATE_PROJECT),
                teamName: 'itops-mithril'
            }
        }
    }));

});
parcelRegister("h2JLJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskCreateProjectRoute", () => $834f9b43560f1ccb$export$1f409a894343952a);
const $834f9b43560f1ccb$export$1f409a894343952a = {
    name: 'servicedesk-create-project',
    path: '/jira/servicedesk/create-project',
    exact: true
};

});

parcelRegister("gYcsx", function(module, exports) {

let $c5abea1d171e4e10$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c5abea1d171e4e10$var$load("740y2").then(()=>parcelRequire('3hX8x'));

});


parcelRegister("aw22a", function(module, exports) {

$parcel$export(module.exports, "customerServiceEscalationsRouteEntry", () => $e27fdc04f14a6641$export$36a7c374f4474cc1);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $e4B7v = parcelRequire("e4B7v");

var $7fRd9 = parcelRequire("7fRd9");

var $ffa20 = parcelRequire("ffa20");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $e27fdc04f14a6641$var$LazyServicedeskCustomerServiceEscalations = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hxCxd"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-service-escalations/src/index.tsx"
});
const $e27fdc04f14a6641$var$ServicedeskCustomerServiceEscalations = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e27fdc04f14a6641$var$LazyServicedeskCustomerServiceEscalations,
        pageId: "spa-apps/servicedesk/customer-service-escalations",
        shouldShowSpinner: true
    });
const $e27fdc04f14a6641$export$36a7c374f4474cc1 = (0, $7NszV.createEntry)((0, $ffa20.customerServiceEscalationsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $e4B7v.componentFilterResource),
            (0, $7fRd9.priorityFilterResource)
        ],
        component: $e27fdc04f14a6641$var$ServicedeskCustomerServiceEscalations,
        perfMetricKey: 'jsm-customer-service-escalations-component-load',
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $e27fdc04f14a6641$var$LazyServicedeskCustomerServiceEscalations
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS),
                teamName: 'boysenberry'
            }
        }
    }));

});
parcelRegister("e4B7v", function(module, exports) {

$parcel$export(module.exports, "componentFilterResource", () => $ff0131666c555211$export$306e389909032632);
$parcel$export(module.exports, "useComponentFilterResource", () => $ff0131666c555211$export$e13868d6ab2288af);

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $ff0131666c555211$var$getDataLoader = ()=>(parcelRequire("69FSS"));
const $ff0131666c555211$export$306e389909032632 = (0, $2M1hQ.createResource)({
    type: 'ESCALATIONS_COMPONENT_FILTER_RESOURCE',
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $ff0131666c555211$var$getDataLoader
});
const $ff0131666c555211$export$e13868d6ab2288af = ()=>(0, $2YP9W.useResource)($ff0131666c555211$export$306e389909032632);

});
parcelRegister("69FSS", function(module, exports) {

let $47b412a189aece82$var$load = (parcelRequire("28QjX"))(4);
module.exports = $47b412a189aece82$var$load("2IGml").then(()=>parcelRequire('hXg9m'));

});


parcelRegister("7fRd9", function(module, exports) {

$parcel$export(module.exports, "priorityFilterResource", () => $1ec7e880e057744a$export$ca03c5f9fc44703e);
$parcel$export(module.exports, "usePriorityFilterResource", () => $1ec7e880e057744a$export$3654f46b6bb12558);

var $4R6GH = parcelRequire("4R6GH");

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $1ec7e880e057744a$var$getDataLoader = ()=>(parcelRequire("hIfWZ"));
const $1ec7e880e057744a$export$ca03c5f9fc44703e = (0, $2M1hQ.createResource)({
    type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $1ec7e880e057744a$var$getDataLoader
});
const $1ec7e880e057744a$export$3654f46b6bb12558 = ()=>(0, $2YP9W.useResource)((0, $4R6GH.fg)('jcs_master_flag') ? $1ec7e880e057744a$export$ca03c5f9fc44703e : (0, $2M1hQ.createResource)({
        type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
        getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
        getDataLoader: $1ec7e880e057744a$var$getDataLoader
    }));

});
parcelRegister("hIfWZ", function(module, exports) {

let $ce52eb21a7a1fe53$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ce52eb21a7a1fe53$var$load("cfFsf").then(()=>parcelRequire('ejgJG'));

});


parcelRegister("ffa20", function(module, exports) {

$parcel$export(module.exports, "customerServiceEscalationsRoute", () => $ee1b6a45151c9b49$export$51e84b36f828d9ff);
const $ee1b6a45151c9b49$export$51e84b36f828d9ff = {
    name: 'servicedesk-customer-service-escalations',
    path: '/jira/servicedesk/projects/:projectKey/escalations',
    exact: true
};

});

parcelRegister("hxCxd", function(module, exports) {

let $cc5368f190a870cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cc5368f190a870cf$var$load("74akO").then(()=>parcelRequire('81cgT'));

});


parcelRegister("yVbxa", function(module, exports) {

$parcel$export(module.exports, "customerServiceProductsRouteEntry", () => $d306aa8b938adbc6$export$8e015e39dbc90d0b);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $cEOhb = parcelRequire("cEOhb");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $7yABM = parcelRequire("7yABM");

var $fqFCk = parcelRequire("fqFCk");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $d306aa8b938adbc6$var$LazyServicedeskCustomerServiceProducts = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("doxhn"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-service-products/src/index.tsx"
});
const $d306aa8b938adbc6$var$ServicedeskCustomerServiceProducts = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d306aa8b938adbc6$var$LazyServicedeskCustomerServiceProducts,
        pageId: "spa-apps/servicedesk/customer-service-products",
        shouldShowSpinner: true
    });
const $d306aa8b938adbc6$export$8e015e39dbc90d0b = (0, $7NszV.createEntry)((0, $fqFCk.customerServiceProductsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $cEOhb.AsyncDirectoryNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $7yABM.customerServiceProductsQueryResource)
        ],
        component: $d306aa8b938adbc6$var$ServicedeskCustomerServiceProducts,
        perfMetricKey: 'jsm-customer-service-products-component-load',
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $d306aa8b938adbc6$var$LazyServicedeskCustomerServiceProducts
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CUSTOMER_SERVICE_PRODUCTS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CUSTOMER_SERVICE_PRODUCTS),
                teamName: 'boysenberry'
            }
        }
    }));

});
parcelRegister("cEOhb", function(module, exports) {

$parcel$export(module.exports, "AsyncDirectoryNav", () => $c28aa1a42d481780$export$a237f415539577a5);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");


const $c28aa1a42d481780$var$LazyDirectoryNav = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("5lUaU")).then(({ DirectoryHorizontalNav: DirectoryHorizontalNav })=>DirectoryHorizontalNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/directory/src/ui/index.tsx"
});
const $c28aa1a42d481780$export$a237f415539577a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-jsm-directory-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c28aa1a42d481780$var$LazyDirectoryNav, null));

});
parcelRegister("5lUaU", function(module, exports) {

let $3e5a7d13f6bd0a6f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3e5a7d13f6bd0a6f$var$load("gpMCn").then(()=>parcelRequire('emSF0'));

});


parcelRegister("7yABM", function(module, exports) {

$parcel$export(module.exports, "PRODUCTS_PAGE_SIZE", () => $cbdcceb1886ba86d$export$9e59a0b3e9d74a99);
$parcel$export(module.exports, "customerServiceProductsQueryResource", () => $cbdcceb1886ba86d$export$f9257217f5333b1a);

var $ao2h1 = parcelRequire("ao2h1");

var $aPLvO = parcelRequire("aPLvO");
const $cbdcceb1886ba86d$export$9e59a0b3e9d74a99 = 50;
const $cbdcceb1886ba86d$export$f9257217f5333b1a = (0, $ao2h1.createRelayResource)({
    type: 'CUSTOMER_SERVICE_PRODUCTS_QUERY',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $aPLvO.default),
            variables: {
                cloudId: tenantContext.cloudId,
                first: $cbdcceb1886ba86d$export$9e59a0b3e9d74a99
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("aPLvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $06c174000e8c134e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4df781c51f5dfbc32b76735c59bb33af>>
 * @relayHash 081a2dfa9c4407c84bf8d024899e92b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bb8d4ae9602322e43ac61cf45c886f9ecad88afb1aaa237fd8615ea59abb7c16
const $06c174000e8c134e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = [
        v2 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcCustomerServiceProductsQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "productsPage_servicedeskCustomerServiceProducts"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcCustomerServiceProductsQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "entitlementsCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v3 /*: any*/ ,
                            "handle": "connection",
                            "key": "customerServiceProducts_productConnections",
                            "kind": "LinkedHandle",
                            "name": "productConnections"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bb8d4ae9602322e43ac61cf45c886f9ecad88afb1aaa237fd8615ea59abb7c16",
            "metadata": {},
            "name": "srcCustomerServiceProductsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$06c174000e8c134e$var$node.hash = "3c49696a6cdc337af280ec80f957ea89";
var $06c174000e8c134e$export$2e2bcd8739ae039 = $06c174000e8c134e$var$node;

});


parcelRegister("fqFCk", function(module, exports) {

$parcel$export(module.exports, "customerServiceProductsRoute", () => $ecb0fd0317e4b818$export$73e241aabf4c9c58);
const $ecb0fd0317e4b818$export$73e241aabf4c9c58 = {
    name: 'servicedesk-customer-service-products',
    path: '/jira/servicedesk/projects/:projectKey/products',
    exact: true
};

});

parcelRegister("doxhn", function(module, exports) {

let $9c0754cc3d83c429$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9c0754cc3d83c429$var$load("h2MrD"),
    $9c0754cc3d83c429$var$load("bYT2S"),
    $9c0754cc3d83c429$var$load("itg0z")
]).then(()=>parcelRequire('fSKfx'));

});


parcelRegister("dCGUp", function(module, exports) {

$parcel$export(module.exports, "servicedeskCustomerDetailsRouteEntry", () => $742f9da2fde448d1$export$97ee6e9bb7f7bd31);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $fcMlY = parcelRequire("fcMlY");

var $4lqmX = parcelRequire("4lqmX");

var $9BHIm = parcelRequire("9BHIm");

var $e9YVH = parcelRequire("e9YVH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6Z2mh = parcelRequire("6Z2mh");

var $ctGuD = parcelRequire("ctGuD");
const $742f9da2fde448d1$export$97ee6e9bb7f7bd31 = (0, $7NszV.createEntry)((0, $9BHIm.servicedeskCustomerDetailsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        component: (0, $ctGuD.ServicedeskCustomerDetails),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ctGuD.LazyServicedeskCustomerDetails)
        ],
        perfMetricKey: 'jsm-customer-details-component-load',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CUSTOMER_DETAILS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CUSTOMER_DETAILS),
                teamName: 'boysenberry'
            }
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $fcMlY.entitlementsCustomerQueryResource),
            (0, $4lqmX.uiCustomerDetailsPageQueryResource)
        ]
    }));

});
parcelRegister("fcMlY", function(module, exports) {

$parcel$export(module.exports, "entitlementsCustomerQueryResource", () => $b3b86d13796012d4$export$78737979422d6907);

var $ao2h1 = parcelRequire("ao2h1");

var $3KdBC = parcelRequire("3KdBC");
const $b3b86d13796012d4$export$78737979422d6907 = (0, $ao2h1.createRelayResource)({
    type: 'ENTITLEMENTS_CUSTOMER_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $3KdBC.default),
            variables: {
                accountId: String(match.params.customerId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("3KdBC", function(module, exports) {

$parcel$export(module.exports, "default", () => $234ef4e6f5c8b134$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2d711ace41d650be975013cf5a90d182>>
 * @relayHash 2d56ae07e9224712e6cbeb1d40c0d517
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b6e68492e4403956991e93b2bec1552e11424884520f6d91d362bfb3f950af38
const $234ef4e6f5c8b134$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v9 = [
        v7 /*: any*/ ,
        v6 /*: any*/ 
    ], v10 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "entitlementsCustomerQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v2 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "CustomerServiceProductConnection",
                                    "kind": "LinkedField",
                                    "name": "productConnections",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CustomerServiceProductEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v4 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "customerService.productConnections.edges"
                                        }
                                    ],
                                    "storageKey": "productConnections(first:1)"
                                },
                                "action": "THROW",
                                "path": "customerService.productConnections"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "individualByAccountId",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v7 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "customerService.individualByAccountId.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CustomerServiceEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlementList",
                                                        "plural": true,
                                                        "selections": [
                                                            v7 /*: any*/ ,
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "includeEntityTypeName",
                                                                        "value": true
                                                                    }
                                                                ],
                                                                "kind": "FragmentSpread",
                                                                "name": "entitlement_servicedeskCustomerServiceEntitlementsCard"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "customerService.individualByAccountId.entitlementList"
                                                },
                                                v8 /*: any*/ 
                                            ],
                                            "type": "CustomerServiceIndividual"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.individualByAccountId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "entitlementsCustomerQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "productConnections(first:1)"
                        },
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "individualByAccountId",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "concreteType": "CustomerServiceEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlementList",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceProduct",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": v9 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "entity",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v9 /*: any*/ ,
                                                            "type": "CustomerServiceOrganization"
                                                        },
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "type": "CustomerServiceIndividual"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b6e68492e4403956991e93b2bec1552e11424884520f6d91d362bfb3f950af38",
            "metadata": {},
            "name": "entitlementsCustomerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$234ef4e6f5c8b134$var$node.hash = "52b18fa6e520ef1142f20ddded30f5ba";
var $234ef4e6f5c8b134$export$2e2bcd8739ae039 = $234ef4e6f5c8b134$var$node;

});


parcelRegister("4lqmX", function(module, exports) {

$parcel$export(module.exports, "uiCustomerDetailsPageQueryResource", () => $bb7f2c1b84275683$export$d766b4bd7ad23814);

var $ao2h1 = parcelRequire("ao2h1");

var $bvCOc = parcelRequire("bvCOc");
const $bb7f2c1b84275683$export$d766b4bd7ad23814 = (0, $ao2h1.createRelayResource)({
    type: 'UI_CUSTOMER_DETAILS_PAGE_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $bvCOc.default),
            variables: {
                accountId: String(match.params.customerId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("bvCOc", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb866aea27d5a9be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<feb4ddb92be08c0d717024aa5a8194a8>>
 * @relayHash 368df621eebbab5cb9e1cf9ceded10d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c922c068178abaa255d12a88a8254e5b236724d396e47df3f3461e152127536
const $eb866aea27d5a9be$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4c922c068178abaa255d12a88a8254e5b236724d396e47df3f3461e152127536",
        "metadata": {},
        "name": "uiCustomerDetailsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $eb866aea27d5a9be$export$2e2bcd8739ae039 = $eb866aea27d5a9be$var$node;

});


parcelRegister("9BHIm", function(module, exports) {

$parcel$export(module.exports, "servicedeskCustomerDetailsRoute", () => $42ea45afdbe6f2e0$export$42c0f04d04ecd1f8);
const $42ea45afdbe6f2e0$export$42c0f04d04ecd1f8 = {
    name: 'servicedesk-customer-details',
    path: '/jira/servicedesk/projects/:projectKey/customers/:customerId',
    exact: true
};

});

parcelRegister("ctGuD", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCustomersV2", () => $11e345ce4933debe$export$864b519a4059ac6b);
$parcel$export(module.exports, "LazyServicedeskCustomerDetails", () => $11e345ce4933debe$export$6c5749ec31de847d);
$parcel$export(module.exports, "ServicedeskCustomerDetails", () => $11e345ce4933debe$export$2412523c0e3657cc);
$parcel$export(module.exports, "ServiceDeskCustomersV2", () => $11e345ce4933debe$export$ac54d7814cf71dd);
$parcel$export(module.exports, "ServiceDeskContacts", () => $11e345ce4933debe$export$db9de32a8b149a29);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $11e345ce4933debe$export$864b519a4059ac6b = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5XO8H"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customers-v2/src/index.tsx"
});

const $11e345ce4933debe$export$55118fe902ecc07a = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("kESIN")), {
    moduleId: "./src/packages/spa-apps/servicedesk/contacts/src/index.tsx"
});

const $11e345ce4933debe$export$6c5749ec31de847d = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("j2b6a"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-details/src/index.tsx"
});
const $11e345ce4933debe$export$2412523c0e3657cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $11e345ce4933debe$export$6c5749ec31de847d,
        pageId: "spa-apps/servicedesk/customer-details",
        shouldShowSpinner: true
    });
const $11e345ce4933debe$export$ac54d7814cf71dd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $11e345ce4933debe$export$864b519a4059ac6b,
        pageId: "spa-apps/servicedesk/customers-v2",
        shouldShowSpinner: true
    });
const $11e345ce4933debe$export$db9de32a8b149a29 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $11e345ce4933debe$export$55118fe902ecc07a,
        pageId: "spa-apps/servicedesk/contacts",
        shouldShowSpinner: true
    });

});
parcelRegister("5XO8H", function(module, exports) {

let $45795b0a9c04143a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $45795b0a9c04143a$var$load("iWLC2").then(()=>parcelRequire('dKNUD'));

});

parcelRegister("kESIN", function(module, exports) {

let $f0a1fda0e59ecfc1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f0a1fda0e59ecfc1$var$load("h2MrD"),
    $f0a1fda0e59ecfc1$var$load("bYT2S"),
    $f0a1fda0e59ecfc1$var$load("kKD37")
]).then(()=>parcelRequire('2XE2f'));

});

parcelRegister("j2b6a", function(module, exports) {

let $ddb6d02c8b73307d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ddb6d02c8b73307d$var$load("h2MrD"),
    $ddb6d02c8b73307d$var$load("bYT2S"),
    $ddb6d02c8b73307d$var$load("9m8WM")
]).then(()=>parcelRequire('eRp4S'));

});



parcelRegister("4KLVz", function(module, exports) {

$parcel$export(module.exports, "servicedeskCustomersV2RouteEntry", () => $499fff83668d7b3b$export$e1fa279356610d18);

var $ffza4 = parcelRequire("ffza4");

var $cEOhb = parcelRequire("cEOhb");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $eAdnc = parcelRequire("eAdnc");

var $cSD7y = parcelRequire("cSD7y");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6Z2mh = parcelRequire("6Z2mh");

var $ctGuD = parcelRequire("ctGuD");
const $499fff83668d7b3b$export$e1fa279356610d18 = (0, $7NszV.createEntry)((0, $eAdnc.servicedeskCustomersV2Route), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $cSD7y.componentWithFG)('jsm_customers_directory_page_for_all', (0, $ctGuD.ServiceDeskContacts), (0, $ctGuD.ServiceDeskCustomersV2)),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ctGuD.LazyServicedeskCustomersV2)
        ],
        perfMetricKey: 'jsm-customers-component-load',
        ufoName: 'jsm-customers-component-load',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $cEOhb.AsyncDirectoryNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        }
    }));

});
parcelRegister("eAdnc", function(module, exports) {

$parcel$export(module.exports, "servicedeskCustomersV2Route", () => $3bc65f8e809f9f4e$export$89e9e350610ee31e);
const $3bc65f8e809f9f4e$export$89e9e350610ee31e = {
    name: 'servicedesk-customers-v2',
    path: '/jira/servicedesk/projects/:projectKey/customers',
    exact: true
};

});


parcelRegister("j0BAb", function(module, exports) {

$parcel$export(module.exports, "projectServiceDeskRouteEntry", () => $3053f9214c133ac3$export$8810bfd4f6a0eb22);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $7MCPm = parcelRequire("7MCPm");

var $ludxj = parcelRequire("ludxj");

var $6Z2mh = parcelRequire("6Z2mh");
const $3053f9214c133ac3$export$8810bfd4f6a0eb22 = (0, $7NszV.createEntry)((0, $ludxj.projectServiceDeskRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: (0, $7MCPm.RedirectToLastVisitedProjectPage),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("ludxj", function(module, exports) {

$parcel$export(module.exports, "projectServiceDeskRoute", () => $be54e9dad71bd630$export$1cfc858068dd8718);
const $be54e9dad71bd630$export$1cfc858068dd8718 = {
    name: 'servicedesk-redirect',
    path: '/jira/servicedesk/projects/:projectKey',
    exact: true
};

});


parcelRegister("lqego", function(module, exports) {

$parcel$export(module.exports, "jsmGSPPageRouteEntry", () => $0bcd3ecbd91a2b8a$export$62c9b51db3e28485);

var $lkFvK = parcelRequire("lkFvK");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $ggg5j = parcelRequire("ggg5j");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $k8jl5 = parcelRequire("k8jl5");

var $5lsNZ = parcelRequire("5lsNZ");

var $cfbXi = parcelRequire("cfbXi");

var $6Z2mh = parcelRequire("6Z2mh");

var $jm3iE = parcelRequire("jm3iE");

var $d1gXy = parcelRequire("d1gXy");
const $0bcd3ecbd91a2b8a$var$gettingStartedPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $d1gXy.gettingStartedEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $0bcd3ecbd91a2b8a$export$62c9b51db3e28485 = (0, $7NszV.createEntry)((0, $cfbXi.jsmGSPPageRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        perfMetricKey: 'servicedesk-getting-started-page-load',
        skeleton: (0, $jm3iE.GettingStartedPageSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $k8jl5.servicedeskIssueTypesResource)
        ],
        entryPoint () {
            return (0, $4R6GH.fg)('gsp_production_rollout') ? $0bcd3ecbd91a2b8a$var$gettingStartedPageEntryPoint : undefined;
        },
        component: (0, $5lsNZ.default)
    }));

});
parcelRegister("k8jl5", function(module, exports) {

$parcel$export(module.exports, "servicedeskIssueTypesResource", () => $8b723afc89fdf36c$export$191ce50629f40dbe);

var $2M1hQ = parcelRequire("2M1hQ");


const $8b723afc89fdf36c$var$getDataLoader = ()=>(parcelRequire("fuOrH"));
const $8b723afc89fdf36c$export$191ce50629f40dbe = (0, $2M1hQ.createResource)({
    type: (0, $30e9f90f7be7696a$export$1ed713fe52212251),
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: $8b723afc89fdf36c$var$getDataLoader
});

});
const $30e9f90f7be7696a$export$1ed713fe52212251 = 'SERVICEDESK_ISSUE_TYPES';

parcelRegister("fuOrH", function(module, exports) {

let $b480c9d5de3291af$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b480c9d5de3291af$var$load("eNmuD"),
    $b480c9d5de3291af$var$load("lJYdj")
]).then(()=>parcelRequire('lWPKX'));

});


parcelRegister("cfbXi", function(module, exports) {

$parcel$export(module.exports, "jsmGSPPageRoute", () => $bb7f953f5cb0e8e6$export$ca7ca88684b33e1e);
const $bb7f953f5cb0e8e6$export$ca7ca88684b33e1e = {
    name: 'servicedesk-getting-started-page',
    path: '/jira/servicedesk/projects/:projectKey/getting-started',
    exact: true
};

});

parcelRegister("jm3iE", function(module, exports) {

$parcel$export(module.exports, "GettingStartedPageSkeleton", () => $562ac3cd506226fa$export$525669daa9599ec);
/* GettingStartedPageSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $d3mkW = parcelRequire("d3mkW");
const $562ac3cd506226fa$var$customCssStyles = null;
const $562ac3cd506226fa$export$525669daa9599ec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d3mkW))),
        className: (0, $bwpsq.default)([
            "_rcuj1wug _o81c1wug _1l6u1wug _149m1wug _701wukw8 _9qarbrur"
        ])
    });

});
parcelRegister("d3mkW", function(module, exports) {
module.exports = new URL("getting-started-page-app-skeleton.tpl.b9c0d034.svg", import.meta.url).toString();

});


parcelRegister("d1gXy", function(module, exports) {

$parcel$export(module.exports, "gettingStartedEntryPoint", () => $7b51534336e501eb$export$a91a58d8bb93ad8e);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $7b51534336e501eb$export$a91a58d8bb93ad8e = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("9CwpV")), {
        moduleId: "99c912b0"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9CwpV", function(module, exports) {

let $7010cf053829b89a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7010cf053829b89a$var$load("dsiAd"),
    $7010cf053829b89a$var$load("i3L0u")
]).then(()=>parcelRequire('8Xvm1'));

});



parcelRegister("awOZa", function(module, exports) {

$parcel$export(module.exports, "servicedeskItsmSampleSpaceRouteEntry", () => $e773d085694b29f0$export$61ad481262acd4e6);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $kEEAb = parcelRequire("kEEAb");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $e773d085694b29f0$var$LazyItsmSampleSpace = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("4gtqV")), {
    moduleId: "./src/packages/spa-apps/servicedesk/itsm-sample-space/src/index.tsx"
});
const $e773d085694b29f0$var$ItsmSampleSpace = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e773d085694b29f0$var$LazyItsmSampleSpace,
        pageId: "spa-apps/servicedesk/itsm-sample-space",
        shouldShowSpinner: true
    });
const $e773d085694b29f0$export$61ad481262acd4e6 = (0, $7NszV.createEntry)((0, $kEEAb.servicedeskItsmSampleSpaceRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: $e773d085694b29f0$var$ItsmSampleSpace,
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $e773d085694b29f0$var$LazyItsmSampleSpace
        ],
        perfMetricKey: 'jsm-sample-space-landing-page',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).ITSM_SAMPLE_SPACE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).ITSM_SAMPLE_SPACE),
                teamName: 'itops-mithril'
            }
        }
    }));

});
parcelRegister("kEEAb", function(module, exports) {

$parcel$export(module.exports, "servicedeskItsmSampleSpaceRoute", () => $d8477253737ee5ba$export$5bc288fedb880892);
const $d8477253737ee5ba$export$5bc288fedb880892 = {
    name: 'servicedesk-itsm-sample-space',
    path: '/jira/servicedesk/itsm-sample-space',
    exact: true
};

});

parcelRegister("4gtqV", function(module, exports) {

let $31af7ce8329ebafc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $31af7ce8329ebafc$var$load("1hp0c").then(()=>parcelRequire('5eXru'));

});


parcelRegister("eoIQt", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubAllArticlesRouteEntry", () => $a340d83cd9968ce2$export$5b55251966102ec);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2qMD5 = parcelRequire("2qMD5");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $bbBli = parcelRequire("bbBli");
const $a340d83cd9968ce2$export$5b55251966102ec = (0, $7NszV.createEntry)((0, $2qMD5.knowledgeHubAllArticlesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $bbBli.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bbBli.LazyServicedeskKnowledgeHubBrowseAllArticles)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_BROWSE_ARTICLES,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_BROWSE_ARTICLES),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("jIAHH", function(module, exports) {

$parcel$export(module.exports, "AsyncKbNav", () => $22359123c06ce2f3$export$223f755b7799fe02);

var $5uXOq = parcelRequire("5uXOq");

var $kkd2O = parcelRequire("kkd2O");

var $b71gk = parcelRequire("b71gk");

var $b7Svb = parcelRequire("b7Svb");

const $22359123c06ce2f3$var$LazyKbNav = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("605NN")).then(({ KnowledgeBaseNav: KnowledgeBaseNav })=>KnowledgeBaseNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/knowledge-base/src/ui/index.tsx"
});
const $22359123c06ce2f3$export$223f755b7799fe02 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "horizontal-jsm-kb-nav",
        packageName: "jira-horizontal-nav-jsm-knowledge-base"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkd2O.default), {
        name: "horizontal-jsm-kb-nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22359123c06ce2f3$var$LazyKbNav, null)));
};

});
parcelRegister("605NN", function(module, exports) {

let $45e73e56a1d475f8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $45e73e56a1d475f8$var$load("dqfnF").then(()=>parcelRequire('gaKUF'));

});


parcelRegister("2qMD5", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubAllArticlesRoute", () => $0168703d3ad589b1$export$20e57a83f181da7b);
const $0168703d3ad589b1$export$20e57a83f181da7b = {
    name: 'knowledge-hub-all-articles',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/browse/page/:pageId'
};

});

parcelRegister("fThMI", function(module, exports) {

$parcel$export(module.exports, "getKnowledgeHubResources", () => $885fe963549c17bc$export$5421e48e728c449f);

var $bjZiV = parcelRequire("bjZiV");

var $fpjJX = parcelRequire("fpjJX");
const $885fe963549c17bc$export$5421e48e728c449f = ()=>[
        ...(0, $fpjJX.getServicedeskPageContextResources)(),
        (0, $bjZiV.kbConfluenceContextResource)
    ];

});

parcelRegister("bbBli", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubBrowseAllArticles", () => $7877fae2c22be3a0$export$c73ba7e80a805fb2);
$parcel$export(module.exports, "default", () => $7877fae2c22be3a0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $7877fae2c22be3a0$export$c73ba7e80a805fb2 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1wSa1"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-articles/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7877fae2c22be3a0$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7877fae2c22be3a0$export$c73ba7e80a805fb2,
        pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-articles",
        shouldShowSpinner: true
    });

});
parcelRegister("1wSa1", function(module, exports) {

let $11d2cacb63d736ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $11d2cacb63d736ca$var$load("dsiAd"),
    $11d2cacb63d736ca$var$load("4ePds")
]).then(()=>parcelRequire('4uyp4'));

});



parcelRegister("kTgg2", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubArticleEmbedEditorRouteEntry", () => $a9203ca39324e16d$export$513e093ef937dc06);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $lBeuR = parcelRequire("lBeuR");

var $6Z2mh = parcelRequire("6Z2mh");

var $fThMI = parcelRequire("fThMI");

var $aNjVS = parcelRequire("aNjVS");
const $a9203ca39324e16d$export$513e093ef937dc06 = (0, $7NszV.createEntry)((0, $lBeuR.knowledgeHubArticleEmbedEditorRoute), ()=>({
        group: 'servicedesk',
        component: (0, $aNjVS.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aNjVS.LazyServiceDeskKnowledgeArticleEmbedEditor)
        ],
        perfMetricKey: 'service-management.knowledge.ep-editor'
    }));

});
parcelRegister("lBeuR", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubArticleEmbedEditorRoute", () => $e0250c214f5345c0$export$bd512c426b095693);
const $e0250c214f5345c0$export$bd512c426b095693 = {
    name: 'kb-article-embed-editor',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/space/:spaceKey/articles/:articleId/edit',
    query: [
        'draftShareId?',
        'topicId?'
    ]
};

});

parcelRegister("aNjVS", function(module, exports) {

$parcel$export(module.exports, "LazyServiceDeskKnowledgeArticleEmbedEditor", () => $398a28a595927246$export$35c6d2a033ef4c42);
$parcel$export(module.exports, "default", () => $398a28a595927246$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $398a28a595927246$export$35c6d2a033ef4c42 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("bSuyA"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-article-embed-editor/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$398a28a595927246$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $398a28a595927246$export$35c6d2a033ef4c42,
        pageId: "knowledge-article-embed-editor",
        shouldShowSpinner: true
    });

});
parcelRegister("bSuyA", function(module, exports) {

let $8a5c70cc8b9c9676$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8a5c70cc8b9c9676$var$load("03OxI").then(()=>parcelRequire('l54tv'));

});



parcelRegister("agsO7", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubArticleInCategoryRouteEntry", () => $def4faef06d1a61c$export$a67199ebb12b0f7f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $4BJB2 = parcelRequire("4BJB2");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $809cs = parcelRequire("809cs");
const $def4faef06d1a61c$export$a67199ebb12b0f7f = (0, $7NszV.createEntry)((0, $4BJB2.knowledgeHubArticleInCategoryRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.knowledge.article',
        component: (0, $809cs.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $809cs.LazyServicedeskKnowledgeHubViewArticle)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("4BJB2", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubArticleInCategoryRoute", () => $cafdb26099846497$export$3afe8482ce820835);
const $cafdb26099846497$export$3afe8482ce820835 = {
    name: 'knowledge-hub-article-in-category',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/articles/:articleId'
};

});

parcelRegister("809cs", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubViewArticle", () => $8c5dbaffda117c43$export$efd0ec49853aa81);
$parcel$export(module.exports, "default", () => $8c5dbaffda117c43$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $8c5dbaffda117c43$export$efd0ec49853aa81 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7I508"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-view-article/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8c5dbaffda117c43$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8c5dbaffda117c43$export$efd0ec49853aa81,
        pageId: "spa-apps/servicedesk/knowledge-hub/view-article",
        shouldShowSpinner: true
    });

});
parcelRegister("7I508", function(module, exports) {

let $59d0859de24a9f13$var$load = (parcelRequire("28QjX"))(4);
module.exports = $59d0859de24a9f13$var$load("6afNs").then(()=>parcelRequire('MNfxH'));

});



parcelRegister("9y8sW", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseAllArticlesRouteEntry", () => $4c224bc59177653b$export$de40c949b963d9e);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $coVHe = parcelRequire("coVHe");

var $gNStA = parcelRequire("gNStA");

var $9D0RM = parcelRequire("9D0RM");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $b4PzF = parcelRequire("b4PzF");

var $fThMI = parcelRequire("fThMI");

var $bbBli = parcelRequire("bbBli");
const $4c224bc59177653b$export$de40c949b963d9e = (0, $7NszV.createEntry)((0, $9D0RM.knowledgeHubBrowseAllArticlesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $bbBli.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>!(0, $b4PzF.isFedRamp)(), (0, $coVHe.virtualAgentKnowledgebaseTouchpointResource))
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bbBli.LazyServicedeskKnowledgeHubBrowseAllArticles)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_BROWSE_ARTICLES,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_BROWSE_ARTICLES),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("coVHe", function(module, exports) {

$parcel$export(module.exports, "virtualAgentKnowledgebaseTouchpointResource", () => $b5eb4da6bb86684f$export$1b798e6122168cca);

var $4R6GH = parcelRequire("4R6GH");

var $ao2h1 = parcelRequire("ao2h1");

var $eCMpj = parcelRequire("eCMpj");
const $b5eb4da6bb86684f$export$1b798e6122168cca = (0, $ao2h1.createRelayResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_KNOWLEDGE_BASE_TOUCHPOINT',
    isBrowserOnly: true,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $eCMpj.default),
            variables: {
                cloudId: tenantContext.cloudId,
                key: match.params.projectKey || '',
                checkForAiEnabledFF: (0, $4R6GH.fg)('require_ai_enabled_for_jsm_virtual_agent')
            }
        })
});

});
parcelRegister("eCMpj", function(module, exports) {

$parcel$export(module.exports, "default", () => $0111b96d105a115c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0c891316f71e3d453d5f0b3fea27d721>>
 * @relayHash 6846c2b353d52935ffcd97c0c83888da
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dd6752d7ca61f340baeb3c609b862f187f8cf5af8c22d46be5786ce68d776813
const $0111b96d105a115c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "dd6752d7ca61f340baeb3c609b862f187f8cf5af8c22d46be5786ce68d776813",
        "metadata": {},
        "name": "mainVirtualServiceAgentCtaCardQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0111b96d105a115c$export$2e2bcd8739ae039 = $0111b96d105a115c$var$node;

});


parcelRegister("9D0RM", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseAllArticlesRoute", () => $ef3c5487d473c383$export$c8e99e3434791c0e);
const $ef3c5487d473c383$export$c8e99e3434791c0e = {
    name: 'knowledge-hub-browse-all-articles',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/articles',
    exact: true
};

});


parcelRegister("825dq", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseAllCategoriesRouteEntry", () => $578b57d26acf701a$export$dd6c99863524ee59);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $90PHJ = parcelRequire("90PHJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $fDsbI = parcelRequire("fDsbI");
const $578b57d26acf701a$export$dd6c99863524ee59 = (0, $7NszV.createEntry)((0, $90PHJ.knowledgeHubBrowseAllCategoriesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $fDsbI.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fDsbI.LazyServicedeskKnowledgeHubBrowseAllCategories)
        ],
        perfMetricKey: 'service-management.kb-categories',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_BROWSE_CATEGORIES,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_BROWSE_CATEGORIES),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("90PHJ", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseAllCategoriesRoute", () => $74299e4842369ef4$export$256f841794b3f077);
const $74299e4842369ef4$export$256f841794b3f077 = {
    name: 'knowledge-hub-browse-all-categories',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories',
    exact: true
};

});

parcelRegister("fDsbI", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubBrowseAllCategories", () => $0ed31e41bd08d12a$export$a488cba75f18ade8);
$parcel$export(module.exports, "default", () => $0ed31e41bd08d12a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $0ed31e41bd08d12a$export$a488cba75f18ade8 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9blxO"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-categories/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0ed31e41bd08d12a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0ed31e41bd08d12a$export$a488cba75f18ade8,
        pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-categories",
        shouldShowSpinner: true
    });

});
parcelRegister("9blxO", function(module, exports) {

let $6af5da66ddddbb89$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6af5da66ddddbb89$var$load("aiUKx").then(()=>parcelRequire('dseQM'));

});



parcelRegister("h8swE", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseViewArticleRouteEntry", () => $4bb5aab980a1ec0f$export$abb9cdffbf5c943b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $8p1m6 = parcelRequire("8p1m6");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $809cs = parcelRequire("809cs");
const $4bb5aab980a1ec0f$export$abb9cdffbf5c943b = (0, $7NszV.createEntry)((0, $8p1m6.knowledgeHubBrowseViewArticleRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.knowledge.article',
        component: (0, $809cs.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $809cs.LazyServicedeskKnowledgeHubViewArticle)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("8p1m6", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseViewArticleRoute", () => $43d5800a4cfdec2f$export$ef8a9ec2979d1b10);
const $43d5800a4cfdec2f$export$ef8a9ec2979d1b10 = {
    name: 'knowledge-hub-browse-view-article',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/articles/:articleId'
};

});


parcelRegister("gGQIR", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubCategoryPageRouteEntry", () => $298d9707a87dc987$export$464b24032c2aeb02);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $8WB8S = parcelRequire("8WB8S");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $7EGTo = parcelRequire("7EGTo");
const $298d9707a87dc987$export$464b24032c2aeb02 = (0, $7NszV.createEntry)((0, $8WB8S.knowledgeHubCategoryPageRoute), ()=>({
        group: 'servicedesk',
        component: (0, $7EGTo.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7EGTo.LazyServicedeskKnowledgeHubCategory)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_CATEGORY,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_CATEGORY),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("8WB8S", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubCategoryPageRoute", () => $4f0b06054e994db5$export$79fb48a07e43639a);
const $4f0b06054e994db5$export$79fb48a07e43639a = {
    name: 'knowledge-hub-category-page',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/browse/page/:pageId'
};

});

parcelRegister("7EGTo", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubCategory", () => $cbedf43cff0d751d$export$c01a896b8d33aa9c);
$parcel$export(module.exports, "default", () => $cbedf43cff0d751d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $cbedf43cff0d751d$export$c01a896b8d33aa9c = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("2JXFr"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-category/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cbedf43cff0d751d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cbedf43cff0d751d$export$c01a896b8d33aa9c,
        pageId: "spa-apps/servicedesk/knowledge-hub/category",
        shouldShowSpinner: true
    });

});
parcelRegister("2JXFr", function(module, exports) {

let $1fee1171f8421ae9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1fee1171f8421ae9$var$load("aly08").then(()=>parcelRequire('lE3ki'));

});



parcelRegister("01hnS", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubCategoryRouteEntry", () => $2e1862f21e7b949b$export$416d7b87b4f3205e);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $k4nQf = parcelRequire("k4nQf");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $7EGTo = parcelRequire("7EGTo");
const $2e1862f21e7b949b$export$416d7b87b4f3205e = (0, $7NszV.createEntry)((0, $k4nQf.knowledgeHubCategoryRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.knowledge.category',
        component: (0, $7EGTo.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7EGTo.LazyServicedeskKnowledgeHubCategory)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_CATEGORY,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_CATEGORY),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("k4nQf", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubCategoryRoute", () => $874cf8128fc31da0$export$69ed5b0214ea6ee5);
const $874cf8128fc31da0$export$69ed5b0214ea6ee5 = {
    name: 'knowledge-hub-category',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId'
};

});


parcelRegister("8jDeK", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubDraftsRouteEntry", () => $9ba3413d02e7079e$export$4da743c0d13c2cfc);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $bltfg = parcelRequire("bltfg");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $2KDj2 = parcelRequire("2KDj2");
const $9ba3413d02e7079e$export$4da743c0d13c2cfc = (0, $7NszV.createEntry)((0, $bltfg.knowledgeHubDraftsRoute), ()=>({
        group: 'servicedesk',
        component: (0, $2KDj2.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2KDj2.LazyServicedeskKnowledgeHubDrafts)
        ],
        perfMetricKey: 'service-management.kb-drafts',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_DRAFTS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_DRAFTS),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("bltfg", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubDraftsRoute", () => $9a661013d8f5290f$export$670f3b59aa55b7ae);
const $9a661013d8f5290f$export$670f3b59aa55b7ae = {
    name: 'knowledge-hub-drafts',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/drafts',
    exact: true
};

});

parcelRegister("2KDj2", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubDrafts", () => $e2e95eba21898c94$export$53decb9d1eb60aed);
$parcel$export(module.exports, "default", () => $e2e95eba21898c94$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $e2e95eba21898c94$export$53decb9d1eb60aed = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("20UAL"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-drafts/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e2e95eba21898c94$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e2e95eba21898c94$export$53decb9d1eb60aed,
        pageId: "spa-apps/servicedesk/knowledge-hub/drafts",
        shouldShowSpinner: true
    });

});
parcelRegister("20UAL", function(module, exports) {

let $17777ad40e4d8c1b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $17777ad40e4d8c1b$var$load("dsiAd"),
    $17777ad40e4d8c1b$var$load("7Lxlr")
]).then(()=>parcelRequire('kl4T5'));

});



parcelRegister("64Uyh", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubLandingRouteEntry", () => $cd1258ca8f7bcdbf$export$671687d85e096e5b);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $bMJcR = parcelRequire("bMJcR");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $fWD3P = parcelRequire("fWD3P");
const $cd1258ca8f7bcdbf$export$671687d85e096e5b = (0, $7NszV.createEntry)((0, $bMJcR.knowledgeHubLandingRoute), ()=>({
        group: 'servicedesk',
        component: (0, $fWD3P.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fWD3P.LazyServicedeskKnowledgeHubLanding)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_LANDING,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_LANDING),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("bMJcR", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubLandingRoute", () => $5a3037062b8f539c$export$239eaf6a202e0f54);
const $5a3037062b8f539c$export$239eaf6a202e0f54 = {
    name: 'knowledge-hub-landing',
    path: '/jira/servicedesk/projects/:projectKey/knowledge',
    exact: true
};

});

parcelRegister("fWD3P", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubLanding", () => $f59132c22330e6a8$export$f1266a588cfc310b);
$parcel$export(module.exports, "default", () => $f59132c22330e6a8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $f59132c22330e6a8$export$f1266a588cfc310b = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("athpC")), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-landing/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f59132c22330e6a8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f59132c22330e6a8$export$f1266a588cfc310b,
        pageId: "spa-apps/servicedesk/knowledge-hub/landing-page",
        shouldShowSpinner: true
    });

});
parcelRegister("athpC", function(module, exports) {

let $79fa1e82ed38f620$var$load = (parcelRequire("28QjX"))(4);
module.exports = $79fa1e82ed38f620$var$load("lq9Le").then(()=>parcelRequire('baJ3W'));

});



parcelRegister("1T4J3", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSearchRouteEntry", () => $1f2e00b6e54dbec2$export$49337a3cc2431ae5);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5PTSS = parcelRequire("5PTSS");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $809cs = parcelRequire("809cs");
const $1f2e00b6e54dbec2$export$49337a3cc2431ae5 = (0, $7NszV.createEntry)((0, $5PTSS.knowledgeHubSearchRoute), ()=>({
        group: 'servicedesk',
        component: (0, $809cs.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $809cs.LazyServicedeskKnowledgeHubViewArticle)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("5PTSS", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSearchRoute", () => $27dc0fd67ac82331$export$a47c36fb081b544d);
const $27dc0fd67ac82331$export$a47c36fb081b544d = {
    name: 'knowledge-hub-search',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/search/articles/:articleId'
};

});


parcelRegister("8hATp", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSetupRouteEntry", () => $fa00eaf494d4bfab$export$b220f8194ee7c231);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5jG9Z = parcelRequire("5jG9Z");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $1iNof = parcelRequire("1iNof");
const $fa00eaf494d4bfab$export$b220f8194ee7c231 = (0, $7NszV.createEntry)((0, $5jG9Z.knowledgeHubSetupRoute), ()=>({
        group: 'servicedesk',
        component: (0, $1iNof.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1iNof.LazyServicedeskKnowledgeHubSetup)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_SETUP,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_SETUP),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("5jG9Z", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSetupRoute", () => $598bde1f568a466c$export$f20770545704547d);
const $598bde1f568a466c$export$f20770545704547d = {
    name: 'knowledge-hub-setup',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/setup'
};

});

parcelRegister("1iNof", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubSetup", () => $4cd10b3eae0d5ed2$export$6c08040d2dc71e43);
$parcel$export(module.exports, "default", () => $4cd10b3eae0d5ed2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $4cd10b3eae0d5ed2$export$6c08040d2dc71e43 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("hjF9S")), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-setup/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4cd10b3eae0d5ed2$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4cd10b3eae0d5ed2$export$6c08040d2dc71e43,
        pageId: "spa-apps/servicedesk/knowledge-hub/setup",
        shouldShowSpinner: true
    });

});
parcelRegister("hjF9S", function(module, exports) {

let $c9b42338a9002ee7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c9b42338a9002ee7$var$load("1phgE").then(()=>parcelRequire('gBJGI'));

});



parcelRegister("lrPAp", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSuggestedArticlesRouteEntry", () => $0632a084fe67a48e$export$6a7974939bde7d37);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $kO4Z1 = parcelRequire("kO4Z1");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $hnJOJ = parcelRequire("hnJOJ");
const $0632a084fe67a48e$export$6a7974939bde7d37 = (0, $7NszV.createEntry)((0, $kO4Z1.knowledgeHubSuggestedArticlesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $hnJOJ.ServiceDeskKnowledgeHubSuggestedArticles),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hnJOJ.LazyServicedeskKnowledgeHubSuggestedArticles)
        ],
        perfMetricKey: 'service-management.kb-suggested-articles',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_SUGGESTED_ARTICLES,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_SUGGESTED_ARTICLES),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("kO4Z1", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSuggestedArticlesRoute", () => $8f32a5b26dce9533$export$54edf5cef1c6b21b);
const $8f32a5b26dce9533$export$54edf5cef1c6b21b = {
    name: 'knowledge-hub-suggested-topics',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/suggested-topics',
    exact: true
};

});

parcelRegister("hnJOJ", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubSuggestedArticles", () => $70c4d3c688caba8c$export$aee7d96c2ee4c388);
$parcel$export(module.exports, "ServiceDeskKnowledgeHubSuggestedArticles", () => $70c4d3c688caba8c$export$ee4623542ebd573e);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $2WqFA = parcelRequire("2WqFA");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $70c4d3c688caba8c$export$aee7d96c2ee4c388 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jubwX"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-suggested-articles/src/index.tsx"
});
const $70c4d3c688caba8c$export$ee4623542ebd573e = ()=>{
    const { data: isAdminHubAIEnabled, loading: loading, error: error, fetchAIEnablement: fetchAIEnablement } = (0, $2WqFA.default)('jira-servicedesk');
    const showSuggestedTopics = (0, $4R6GH.fg)('suggested_topics_eap') ? !loading && !error && isAdminHubAIEnabled : (0, $4R6GH.fg)('jsm-suggested-articles-in-kb');
    (0, $5uXOq.useEffect)(()=>{
        (0, $4R6GH.fg)('suggested_topics_eap') && fetchAIEnablement();
    }, [
        fetchAIEnablement
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showSuggestedTopics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $70c4d3c688caba8c$export$aee7d96c2ee4c388,
        pageId: "spa-apps/servicedesk/knowledge-hub/suggested-articles",
        shouldShowSpinner: true
    }));
};

});
parcelRegister("2WqFA", function(module, exports) {

$parcel$export(module.exports, "default", () => $18bf020f3f366501$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $29jfS = parcelRequire("29jfS");
const $18bf020f3f366501$var$useIsAdminHubAIEnabled = (jiraProduct, version)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [isAdminHubAiToggleEnabled, setIsAdminHubAiToggleEnabled] = (0, $5uXOq.useState)(null);
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $29jfS.fetchAiEnablement)(jiraProduct, version);
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchAiEnablementStatus succeeded');
            setIsAdminHubAiToggleEnabled(response.isEnabled);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError(err);
            (0, $jcw0u.default)({
                error: err,
                meta: {
                    id: 'fetchAiEnablementStatus failed'
                }
            });
        } finally{
            setLoading(false);
        }
    }, [
        createAnalyticsEvent,
        jiraProduct,
        version
    ]);
    return {
        data: isAdminHubAiToggleEnabled,
        loading: loading,
        error: error,
        fetchAIEnablement: fetchData
    };
};
var $18bf020f3f366501$export$2e2bcd8739ae039 = $18bf020f3f366501$var$useIsAdminHubAIEnabled;

});
parcelRegister("29jfS", function(module, exports) {

$parcel$export(module.exports, "fetchAiEnablement", () => $f8e2a461a4c2e420$export$ad4105850d0ce824);

var $7f4tk = parcelRequire("7f4tk");
const $f8e2a461a4c2e420$export$2171a423b572256a = (jiraProduct, version = '1')=>`/rest/api/${version}/aiconfig/ai-enabled/${jiraProduct}`;
const $f8e2a461a4c2e420$export$ad4105850d0ce824 = (jiraProduct, version = '1')=>{
    const url = $f8e2a461a4c2e420$export$2171a423b572256a(jiraProduct, version);
    return (0, $7f4tk.default)(url, {
        method: 'GET'
    });
};

});


parcelRegister("jubwX", function(module, exports) {

let $e2f9c362d2567105$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e2f9c362d2567105$var$load("iFZBi").then(()=>parcelRequire('hY7nq'));

});



parcelRegister("ZVu1m", function(module, exports) {

$parcel$export(module.exports, "notificationLogsRouteEntry", () => $8c16ad2f5cbcb35f$export$20ab3a955246df95);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $joRT8 = parcelRequire("joRT8");

var $6Z2mh = parcelRequire("6Z2mh");

var $1RPRU = parcelRequire("1RPRU");
const $8c16ad2f5cbcb35f$export$20ab3a955246df95 = (0, $7NszV.createEntry)((0, $joRT8.notificationLogsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $1RPRU.NotificationLogs),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1RPRU.LazyNotificationLogs)
        ],
        perfMetricKey: 'jsm-notification-logs-component-load'
    }));

});
parcelRegister("joRT8", function(module, exports) {

$parcel$export(module.exports, "notificationLogsRoute", () => $7c61830ec505ffc9$export$c947c80f138bc137);
const $7c61830ec505ffc9$export$c947c80f138bc137 = {
    name: 'notification-logs',
    path: '/jira/servicedesk/projects/:projectKey/notification-logs',
    exact: true
};

});

parcelRegister("1RPRU", function(module, exports) {

$parcel$export(module.exports, "LazyNotificationLogs", () => $ce165317fbb6ef87$export$69cba5247233f8bc);
$parcel$export(module.exports, "NotificationLogs", () => $ce165317fbb6ef87$export$1139895a5af7252e);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $ce165317fbb6ef87$export$69cba5247233f8bc = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("fVOUH"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/notification-logs/src/index.tsx"
});
const $ce165317fbb6ef87$export$1139895a5af7252e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ce165317fbb6ef87$export$69cba5247233f8bc,
        pageId: "spa-apps/servicedesk/notification-logs",
        shouldShowSpinner: true
    });

});
parcelRegister("fVOUH", function(module, exports) {

let $b993ac40b5148406$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b993ac40b5148406$var$load("43uod").then(()=>parcelRequire('9feT0'));

});



parcelRegister("l1PfI", function(module, exports) {

$parcel$export(module.exports, "servicedeskOncallScheduleRouteEntry", () => $010b24cf318456cc$export$36994f6fd22da90e);

var $ffza4 = parcelRequire("ffza4");

var $1cxvE = parcelRequire("1cxvE");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $9kQCa = parcelRequire("9kQCa");

var $6Z2mh = parcelRequire("6Z2mh");

var $cysbi = parcelRequire("cysbi");
const $010b24cf318456cc$export$36994f6fd22da90e = (0, $7NszV.createEntry)((0, $9kQCa.servicedeskOncallScheduleRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.on-call-schedule',
        component: (0, $cysbi.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $1cxvE.AsyncJSMOperationsHorizontalNav),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cysbi.LazyServicedeskOpsgenieSchedule),
            (0, $1cxvE.LazyJSMOperationsHorizontalNav)
        ]
    }));

});
parcelRegister("9kQCa", function(module, exports) {

$parcel$export(module.exports, "servicedeskOncallScheduleRoute", () => $993b636c10d5f63c$export$740e6e5e982b48a9);
const $993b636c10d5f63c$export$740e6e5e982b48a9 = {
    name: 'servicedesk-oncall-schedule',
    path: '/jira/servicedesk/projects/:projectKey/on-call-schedule',
    exact: true
};

});

parcelRegister("cysbi", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskOpsgenieSchedule", () => $816d970487a82139$export$e8392650fdcd92d5);
$parcel$export(module.exports, "default", () => $816d970487a82139$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $816d970487a82139$export$e8392650fdcd92d5 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("gxKIk")), {
    moduleId: "./src/packages/spa-apps/servicedesk/opsgenie-schedule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$816d970487a82139$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $816d970487a82139$export$e8392650fdcd92d5,
        pageId: "spa-apps/servicedesk/opsgenie-schedule",
        shouldShowSpinner: true
    });

});
parcelRegister("gxKIk", function(module, exports) {

let $c0b3f6cf9b2a98cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c0b3f6cf9b2a98cf$var$load("aVjGW").then(()=>parcelRequire('gjKCT'));

});



parcelRegister("iuWOh", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationV2RouteEntry", () => $5928d6539d724a6d$export$1b6ea96c35c2472c);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $38BXB = parcelRequire("38BXB");

var $7CBZS = parcelRequire("7CBZS");

var $fpjJX = parcelRequire("fpjJX");

var $6x0wo = parcelRequire("6x0wo");

var $hlsv9 = parcelRequire("hlsv9");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gtea = parcelRequire("6gtea");
const $5928d6539d724a6d$export$1b6ea96c35c2472c = (0, $7NszV.createEntry)((0, $hlsv9.servicedeskOrganizationV2Route), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $6x0wo.serviceDeskOrganizationPanelForgeDataResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $7CBZS.productsJsmOrganizationDetailsResource),
            (0, $38BXB.jsmEmailDomainsListResource)
        ],
        component: (0, $6gtea.ServiceDeskOrganizationV2),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6gtea.LazyServicedeskOrganizationV2)
        ],
        perfMetricKey: 'jsm-organizations-component-load'
    }));

});
parcelRegister("6x0wo", function(module, exports) {

$parcel$export(module.exports, "serviceDeskOrganizationPanelForgeDataResource", () => $8bc812ed070bb2a3$export$f3c46a19f3594363);

var $2M1hQ = parcelRequire("2M1hQ");


const $8bc812ed070bb2a3$var$getDataLoader = ()=>(parcelRequire("h9bRL"));
const $8bc812ed070bb2a3$export$f3c46a19f3594363 = (0, $2M1hQ.createResource)({
    type: (0, $b6a87c89b0762905$export$66d6e1e05866ee2f),
    getKey: ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        return `extension-${projectKey}`;
    },
    getDataLoader: $8bc812ed070bb2a3$var$getDataLoader,
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
const $b6a87c89b0762905$export$66d6e1e05866ee2f = 'ORGANIZATION_PANEL_FORGE_DATA';

parcelRegister("h9bRL", function(module, exports) {

let $c7bc7b4d14923bcd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c7bc7b4d14923bcd$var$load("6fToZ").then(()=>parcelRequire('emXcY'));

});


parcelRegister("hlsv9", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationV2Route", () => $0e8ebef5d5d75a55$export$7f878f9aeac61f1e);
const $0e8ebef5d5d75a55$export$7f878f9aeac61f1e = {
    name: 'servicedesk-organization_v2',
    path: '/jira/servicedesk/projects/:projectKey/organization/:organizationId',
    exact: true
};

});

parcelRegister("6gtea", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskOrganizationV2", () => $f3c20d8fbb399193$export$1c7fcdb58f42db03);
$parcel$export(module.exports, "ServiceDeskOrganizationV2", () => $f3c20d8fbb399193$export$5f69663d85db303d);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $f3c20d8fbb399193$export$1c7fcdb58f42db03 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cvRwX"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organization-v2/src/index.tsx"
});
const $f3c20d8fbb399193$export$5f69663d85db303d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f3c20d8fbb399193$export$1c7fcdb58f42db03,
        pageId: "spa-apps/servicedesk/organization-v2",
        shouldShowSpinner: true
    });

});
parcelRegister("cvRwX", function(module, exports) {

let $91c1e756b0c2063b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $91c1e756b0c2063b$var$load("4SjA9").then(()=>parcelRequire('3BhTj'));

});



parcelRegister("cvYE5", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationDetailsRouteEntry", () => $a8b4c58f96e42722$export$a9452a74fdc4d74f);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $38BXB = parcelRequire("38BXB");

var $7CBZS = parcelRequire("7CBZS");

var $8XgXN = parcelRequire("8XgXN");

var $iTeMQ = parcelRequire("iTeMQ");

var $5tVaj = parcelRequire("5tVaj");

var $e9YVH = parcelRequire("e9YVH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6Z2mh = parcelRequire("6Z2mh");

var $rKFLU = parcelRequire("rKFLU");
const $a8b4c58f96e42722$export$a9452a74fdc4d74f = (0, $7NszV.createEntry)((0, $5tVaj.servicedeskOrganizationDetailsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        component: (0, $rKFLU.ServicedeskOrganizationDetails),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $rKFLU.LazyServicedeskOrganizationDetails)
        ],
        perfMetricKey: 'jsm-organization-details-component-load',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).ORGANIZATION_DETAILS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).ORGANIZATION_DETAILS),
                teamName: 'boysenberry'
            }
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $8XgXN.entitlementsOrganizationQueryResource),
            (0, $iTeMQ.uiOrganizationDetailsPageQueryResource),
            (0, $7CBZS.productsJsmOrganizationDetailsResource),
            (0, $38BXB.jsmEmailDomainsListResource)
        ]
    }));

});
parcelRegister("8XgXN", function(module, exports) {

$parcel$export(module.exports, "entitlementsOrganizationQueryResource", () => $275795ce1e7f33fe$export$fead08d66d56688e);

var $ao2h1 = parcelRequire("ao2h1");

var $9NGHY = parcelRequire("9NGHY");
const $275795ce1e7f33fe$export$fead08d66d56688e = (0, $ao2h1.createRelayResource)({
    type: 'ENTITLEMENTS_ORGANIZATION_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $9NGHY.default),
            variables: {
                organizationId: String(match.params.organizationId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("9NGHY", function(module, exports) {

$parcel$export(module.exports, "default", () => $42e659babe89c8d5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5505d7bd1e485943d52683e3e287125b>>
 * @relayHash 4fd7c02cf85ce43ff1f3b2c2885428f1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 01a04225033d1c240e60c2831c34cc958b17cd0c6be52ce6b65c5484adb41a6f
const $42e659babe89c8d5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "organizationId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "organizationId",
            "variableName": "organizationId"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entitlementsOrganizationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "CustomerServiceProductConnection",
                                    "kind": "LinkedField",
                                    "name": "productConnections",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CustomerServiceProductEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v3 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "customerService.productConnections.edges"
                                        }
                                    ],
                                    "storageKey": "productConnections(first:1)"
                                },
                                "action": "THROW",
                                "path": "customerService.productConnections"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "organizationByOrganizationId",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v6 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "customerService.organizationByOrganizationId.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CustomerServiceEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlementList",
                                                        "plural": true,
                                                        "selections": [
                                                            v6 /*: any*/ ,
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "includeEntityTypeName",
                                                                        "value": false
                                                                    }
                                                                ],
                                                                "kind": "FragmentSpread",
                                                                "name": "entitlement_servicedeskCustomerServiceEntitlementsCard"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "customerService.organizationByOrganizationId.entitlementList"
                                                },
                                                v7 /*: any*/ 
                                            ],
                                            "type": "CustomerServiceOrganization"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.organizationByOrganizationId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entitlementsOrganizationQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "productConnections(first:1)"
                        },
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "organizationByOrganizationId",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "CustomerServiceEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlementList",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceProduct",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "type": "CustomerServiceOrganization"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "01a04225033d1c240e60c2831c34cc958b17cd0c6be52ce6b65c5484adb41a6f",
            "metadata": {},
            "name": "entitlementsOrganizationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$42e659babe89c8d5$var$node.hash = "c2dbf2a99cb38657b66de75f23707712";
var $42e659babe89c8d5$export$2e2bcd8739ae039 = $42e659babe89c8d5$var$node;

});


parcelRegister("iTeMQ", function(module, exports) {

$parcel$export(module.exports, "uiOrganizationDetailsPageQueryResource", () => $6f42d74340bbf820$export$ab65064827d1831d);

var $ao2h1 = parcelRequire("ao2h1");

var $hpIsM = parcelRequire("hpIsM");
const $6f42d74340bbf820$export$ab65064827d1831d = (0, $ao2h1.createRelayResource)({
    type: 'UI_ORGANIZATION_DETAILS_PAGE_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $hpIsM.default),
            variables: {
                organizationId: String(match.params.organizationId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("hpIsM", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc8caf12ab702db6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<08164275d7c73aca9297baa3da2d3967>>
 * @relayHash 572d7a60b6cd2c2d7190bee47f74e0e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8425025856dcdb524ab8c9068e976910d1b94e9aab4d880ce4e0939990c08edf
const $bc8caf12ab702db6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "organizationId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "organizationId",
            "variableName": "organizationId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v8 = {
        "kind": "ScalarField",
        "name": "message"
    }, v9 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "errorType"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiOrganizationDetailsPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "organizationByOrganizationId",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "details",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "customDetailsSidebar_servicedeskCustomerServiceCustomDetailsSidebar_Inner"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CustomerServiceOrganization"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.organizationByOrganizationId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiOrganizationDetailsPageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "organizationByOrganizationId",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "details",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isCustomerServiceCustomDetailValuesQueryResult"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceCustomDetailValue",
                                                            "kind": "LinkedField",
                                                            "name": "results",
                                                            "plural": true,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canEdit"
                                                                },
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "values"
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailType",
                                                                    "kind": "LinkedField",
                                                                    "name": "type",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "options"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailConfigMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "config",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CustomerServiceCustomAttributeStyleConfiguration",
                                                                            "kind": "LinkedField",
                                                                            "name": "styleConfiguration",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "CustomerServiceCustomAttributeOptionsStyleConfiguration",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "options",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "optionValue"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "CustomerServiceCustomAttributeOptionStyle",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "style",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "backgroundColour"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "CustomerServiceCustomDetailValues"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "QueryError"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CustomerServiceOrganization"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8425025856dcdb524ab8c9068e976910d1b94e9aab4d880ce4e0939990c08edf",
            "metadata": {},
            "name": "uiOrganizationDetailsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bc8caf12ab702db6$var$node.hash = "8781f4b4eca174196d95ee737ccdc3aa";
var $bc8caf12ab702db6$export$2e2bcd8739ae039 = $bc8caf12ab702db6$var$node;

});


parcelRegister("5tVaj", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationDetailsRoute", () => $beffe8b6a9e6d0f2$export$eacc4723293cbc36);
const $beffe8b6a9e6d0f2$export$eacc4723293cbc36 = {
    name: 'servicedesk-organization-details',
    path: '/jira/servicedesk/projects/:projectKey/organizations/:organizationId',
    exact: true
};

});

parcelRegister("rKFLU", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskOrganizations", () => $b9e14ed4e63c050e$export$b40b4bfa472057b9);
$parcel$export(module.exports, "ServiceDeskOrganizations", () => $b9e14ed4e63c050e$export$4abec67d7b34dda2);
$parcel$export(module.exports, "LazyServicedeskOrganizationDetails", () => $b9e14ed4e63c050e$export$4a01866152e4a375);
$parcel$export(module.exports, "ServicedeskOrganizationDetails", () => $b9e14ed4e63c050e$export$709be875ca0a7ead);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $b9e14ed4e63c050e$export$b40b4bfa472057b9 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hlXRf"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organizations/src/index.tsx"
});
const $b9e14ed4e63c050e$export$4abec67d7b34dda2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b9e14ed4e63c050e$export$b40b4bfa472057b9,
        pageId: "spa-apps/servicedesk/organizations",
        shouldShowSpinner: true
    });

const $b9e14ed4e63c050e$export$4a01866152e4a375 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("2ncAV"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organization-details/src/index.tsx"
});
const $b9e14ed4e63c050e$export$709be875ca0a7ead = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b9e14ed4e63c050e$export$4a01866152e4a375,
        pageId: "spa-apps/servicedesk/organization-details",
        shouldShowSpinner: true
    });

});
parcelRegister("hlXRf", function(module, exports) {

let $ca22d455d06f66a9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ca22d455d06f66a9$var$load("h2MrD"),
    $ca22d455d06f66a9$var$load("bYT2S"),
    $ca22d455d06f66a9$var$load("h7cjl")
]).then(()=>parcelRequire('e2tYQ'));

});

parcelRegister("2ncAV", function(module, exports) {

let $1ba77fc90ac8a7b5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1ba77fc90ac8a7b5$var$load("h2MrD"),
    $1ba77fc90ac8a7b5$var$load("bYT2S"),
    $1ba77fc90ac8a7b5$var$load("3OcWv")
]).then(()=>parcelRequire('9LQpe'));

});



parcelRegister("2cpS3", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationsRouteEntry", () => $51233e7b4d73b144$export$cf20fe731144ca3b);

var $ffza4 = parcelRequire("ffza4");

var $cEOhb = parcelRequire("cEOhb");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bkElt = parcelRequire("bkElt");

var $e9YVH = parcelRequire("e9YVH");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6Z2mh = parcelRequire("6Z2mh");

var $rKFLU = parcelRequire("rKFLU");
const $51233e7b4d73b144$export$cf20fe731144ca3b = (0, $7NszV.createEntry)((0, $bkElt.servicedeskOrganizationsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $rKFLU.ServiceDeskOrganizations),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $rKFLU.LazyServicedeskOrganizations)
        ],
        perfMetricKey: 'jsm-organizations-component-load',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $cEOhb.AsyncDirectoryNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).ORGANIZATIONS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).ORGANIZATIONS),
                teamName: 'boysenberry'
            }
        }
    }));

});
parcelRegister("bkElt", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationsRoute", () => $3df03e0958f7e9c7$export$d4a712c5bc3c3434);
const $3df03e0958f7e9c7$export$d4a712c5bc3c3434 = {
    name: 'servicedesk-organizations',
    path: '/jira/servicedesk/projects/:projectKey/organizations',
    exact: true
};

});


parcelRegister("c0JOH", function(module, exports) {

$parcel$export(module.exports, "servicedeskProjectSummaryRouteEntry", () => $2c8ef8f8c8b8bea4$export$a24d68fcf82b16bb);

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $5wuQF = parcelRequire("5wuQF");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $5xviT = parcelRequire("5xviT");

var $dWyPA = parcelRequire("dWyPA");

var $iZ8qR = parcelRequire("iZ8qR");
const $2c8ef8f8c8b8bea4$export$a24d68fcf82b16bb = (0, $7NszV.createEntry)((0, $5wuQF.servicedeskProjectSummaryRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm.project-summary',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsm-project-summary'), ()=>null, (0, $5lsNZ.default)),
        skeleton: (0, $5xviT.ProjectSummarySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $dWyPA.getProjectSummaryFilterFieldsResource)()
        ],
        entryPoint: ()=>(0, $4R6GH.fg)('jsm-project-summary') ? (0, $iZ8qR.projectSummaryPageEntryPoint) : undefined,
        meta: {
            reporting: {
                id: 'project-summary',
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).PROJECT_SUMMARY),
                teamName: 'jsd-shield'
            }
        }
    }));

});
parcelRegister("5wuQF", function(module, exports) {

$parcel$export(module.exports, "servicedeskProjectSummaryRoute", () => $4ba559112e9c0332$export$a23b752ff24027ae);
const $4ba559112e9c0332$export$a23b752ff24027ae = {
    path: '/jira/servicedesk/projects/:projectKey/summary',
    name: 'servicedesk-project-summary'
};

});

parcelRegister("5xviT", function(module, exports) {

$parcel$export(module.exports, "ProjectSummarySkeleton", () => $d1cb7759e14ba32c$export$93a223cf4712c63d);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $jflJ3 = parcelRequire("jflJ3");
const $d1cb7759e14ba32c$export$93a223cf4712c63d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jflJ3)))
    });

});
parcelRegister("jflJ3", function(module, exports) {
module.exports = new URL("project-summary-skeleton.tpl.f2232e71.svg", import.meta.url).toString();

});


parcelRegister("dWyPA", function(module, exports) {

$parcel$export(module.exports, "getProjectSummaryFilterFieldsResource", () => $742db2d29900c944$export$efafab65f8d3c3b6);
$parcel$export(module.exports, "useGetProjectSummaryFilterFields", () => $742db2d29900c944$export$e6baafb2e3d74187);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $1nb22 = parcelRequire("1nb22");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $742db2d29900c944$var$RESOURCE_NAME = 'projectSummaryFilterFieldResource';
const $742db2d29900c944$export$6f0555de4f60e84e = 'RESOURCE_TYPE_JSM_PROJECT_SUMMARY_FILTERS';
const $742db2d29900c944$var$REQUEST_TYPE_FILTER_TYPE = 'com.atlassian.servicedesk:vp-origin';
const $742db2d29900c944$var$REQUEST_TYPE_FILTER_SEARCH_TEMPLATE = 'com.atlassian.servicedesk:vp-origin-searcher';
const $742db2d29900c944$var$PRIORITY_FILTER_TYPE = 'priority';
const $742db2d29900c944$var$PRIORITY_FILTER_SEARCH_TEMPLATE = 'priority';
const $742db2d29900c944$var$CREATED_FILTER_TYPE = 'created';
const $742db2d29900c944$var$CREATED_FILTER_SEARCH_TEMPLATE = 'created';
const $742db2d29900c944$var$reportError = (error)=>(0, $jcw0u.default)({
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        meta: {
            id: $742db2d29900c944$var$RESOURCE_NAME,
            packageName: (0, $1067b0e29a05cd94$export$b8b9d90f9e5bd72b),
            teamName: (0, $1067b0e29a05cd94$export$d57b6b390e78d90f)
        }
    });
const $742db2d29900c944$var$fetchFields = [
    'request type',
    'priority',
    'created'
];
const $742db2d29900c944$var$fetchFilterFields = async (cloudId, jqlContext)=>{
    try {
        const responses = await Promise.all($742db2d29900c944$var$fetchFields.map((searchString)=>(0, $eusud.performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $9f7e041fbe104d81$export$2b91517d6d5b4365),
                    variables: {
                        cloudId: cloudId,
                        contextFieldsFilter: {
                            searchString: searchString
                        },
                        jqlContext: jqlContext
                    }
                }),
                headers: {
                    'content-type': 'application/json',
                    'X-ExperimentalApi': 'JiraJqlBuilder'
                }
            })));
        const tryGetField = ({ data: data, name: name, type: type, searchTemplate: searchTemplate, displayName: displayName })=>{
            const edges = data?.jira?.jqlBuilder?.fields?.edges;
            const field = edges?.find((edge)=>edge?.node?.type === type && edge?.node?.searchTemplate?.key === searchTemplate)?.node;
            if (!field) $742db2d29900c944$var$reportError(new Error(`Unable to prefetch ${name}`));
            return field ? {
                ...field,
                searchTemplate: field.searchTemplate.key,
                fieldType: field.type,
                displayName: displayName ?? field.displayName
            } : undefined;
        };
        return {
            requestTypeField: tryGetField({
                data: responses[0].data,
                name: 'request type',
                type: $742db2d29900c944$var$REQUEST_TYPE_FILTER_TYPE,
                searchTemplate: $742db2d29900c944$var$REQUEST_TYPE_FILTER_SEARCH_TEMPLATE
            }),
            priorityField: tryGetField({
                data: responses[1].data,
                name: 'priority',
                type: $742db2d29900c944$var$PRIORITY_FILTER_TYPE,
                searchTemplate: $742db2d29900c944$var$PRIORITY_FILTER_SEARCH_TEMPLATE
            }),
            createdField: tryGetField({
                data: responses[2].data,
                name: 'created',
                type: $742db2d29900c944$var$CREATED_FILTER_TYPE,
                searchTemplate: $742db2d29900c944$var$CREATED_FILTER_SEARCH_TEMPLATE
            })
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $fZneA.isHttpClientErrorResponse)(error)) $742db2d29900c944$var$reportError(error);
        return {
            requestTypeField: undefined,
            priorityField: undefined,
            createdField: undefined
        };
    }
};
const $742db2d29900c944$var$getProjectKeyOrId = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $742db2d29900c944$var$filterFieldsResource = (0, $2M1hQ.createResource)({
    type: $742db2d29900c944$export$6f0555de4f60e84e,
    getKey: ({ match: match, query: query })=>$742db2d29900c944$export$6f0555de4f60e84e + $742db2d29900c944$var$getProjectKeyOrId(match, query),
    getData: ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>$742db2d29900c944$var$fetchFilterFields(cloudId, `project = '${$742db2d29900c944$var$getProjectKeyOrId(match, query)}'`),
    maxAge: Infinity
});
const $742db2d29900c944$export$efafab65f8d3c3b6 = ()=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_project_summary_filters'), $742db2d29900c944$var$filterFieldsResource);
const $742db2d29900c944$export$e6baafb2e3d74187 = ()=>{
    const { data: filterResource } = (0, $2YP9W.useResource)($742db2d29900c944$var$filterFieldsResource);
    return (0, $5uXOq.useMemo)(()=>({ requestTypeField: requestTypeField = filterResource?.requestTypeField, requestTypeDisplayName: requestTypeDisplayName, priorityDisplayName: priorityDisplayName, createdDisplayName: createdDisplayName })=>{
            const priorityField = filterResource?.priorityField;
            const createdField = filterResource?.createdField;
            return [
                ...requestTypeField ? [
                    {
                        ...requestTypeField,
                        ...requestTypeDisplayName && {
                            displayName: requestTypeDisplayName
                        }
                    }
                ] : [],
                'status',
                'assignee',
                ...priorityField ? [
                    {
                        ...priorityField,
                        ...priorityDisplayName && {
                            displayName: priorityDisplayName
                        }
                    }
                ] : [],
                ...createdField ? [
                    {
                        ...createdField,
                        ...createdDisplayName && {
                            displayName: createdDisplayName
                        }
                    }
                ] : []
            ];
        }, [
        filterResource
    ]);
};

});
const $1067b0e29a05cd94$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesServicedeskProjectSummary';
const $1067b0e29a05cd94$export$d57b6b390e78d90f = 'jsd-shield';

const $9f7e041fbe104d81$export$2b91517d6d5b4365 = `
query findFieldQuery($cloudId: ID!, $contextFieldsFilter: JiraJQLContextFieldsFilter!, $jqlContext: String!) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
        fields(jqlContextFieldsFilter: $contextFieldsFilter, jqlContext: $jqlContext) {
          ... on JiraJqlFieldConnection {
            __typename
            edges {
              node {
                jqlTerm
                displayName
                type
                searchTemplate {
                  key
                }
                operators
              }
            }
          }
          ... on QueryError {
            __typename
          }
        }
      }
  }
}
`;


parcelRegister("iZ8qR", function(module, exports) {

$parcel$export(module.exports, "projectSummaryPageEntryPoint", () => $cfa42f0318b6392e$export$ae7c241893e7dab9);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fmaTw = parcelRequire("fmaTw");
const $cfa42f0318b6392e$export$ae7c241893e7dab9 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fmaTw.projectSummaryEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("fmaTw", function(module, exports) {

$parcel$export(module.exports, "projectSummaryEntryPoint", () => $15ffffad92965566$export$95a2fe4e495efca5);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $15ffffad92965566$export$95a2fe4e495efca5 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("gm5Si")), {
        moduleId: "ac794fd1"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gm5Si", function(module, exports) {

let $be834205b0eca7ce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $be834205b0eca7ce$var$load("nwI1a").then(()=>parcelRequire('i6ZtS'));

});




parcelRegister("iYfXI", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueRouteEntry", () => $aa74409e2ad842d4$export$b43128c9b5db2a5e);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $2pT4g = parcelRequire("2pT4g");

var $fpjJX = parcelRequire("fpjJX");

var $urQ6o = parcelRequire("urQ6o");

var $6Z2mh = parcelRequire("6Z2mh");

var $iTSIT = parcelRequire("iTSIT");

var $lBKJK = parcelRequire("lBKJK");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $lAGdd = parcelRequire("lAGdd");

var $faj7G = parcelRequire("faj7G");

var $gLKd7 = parcelRequire("gLKd7");
const $aa74409e2ad842d4$export$b43128c9b5db2a5e = (0, $7NszV.createEntry)((0, $urQ6o.customPracticeQueueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $faj7G.CustomQueueRouteComponent),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        skeleton: (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $gLKd7.QueueLoadingSkeleton) : undefined,
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getKnowledgeBaseResources)(),
            ...(0, $fpjJX.getInsightResources)(),
            ...(0, $fpjJX.getIssueListSsrResource)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $2pT4g.jsmRepackagingBannerResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('rrr_for_context_panel_data'), (0, $lAGdd.aiContextPanelResource)),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $iTSIT.horizontalNavQueueResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $faj7G.LazyServicedeskQueuesAgentAndIssueView)
        ]
    }));

});
parcelRegister("jlOGG", function(module, exports) {

$parcel$export(module.exports, "newIssueViewLockInStatusResource", () => $951713022fad9069$export$647de7516d081bd8);
$parcel$export(module.exports, "useNewIssueViewLockInStatus", () => $951713022fad9069$export$d8ba398930f2f5f);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $1odlY = parcelRequire("1odlY");

const $951713022fad9069$export$647de7516d081bd8 = (0, $2M1hQ.createResource)({
    type: (0, $1odlY.RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("aFs6t")),
    maxAge: Number.MAX_VALUE
});
const $951713022fad9069$export$d8ba398930f2f5f = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($951713022fad9069$export$647de7516d081bd8);
    return {
        loading: loading,
        error: error,
        newIssueViewLockedIn: data && data.newIssueViewLockedIn
    };
};

});
parcelRegister("aFs6t", function(module, exports) {

let $7c43887441833f8f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7c43887441833f8f$var$load("83I2X").then(()=>parcelRequire('7JV09'));

});


parcelRegister("urQ6o", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueRoute", () => $41bd265d7c0f4884$export$59d0bd42aa07faad);
const $41bd265d7c0f4884$export$59d0bd42aa07faad = {
    name: 'servicedesk-practice-custom-and-issue',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/:issueKey?',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("iTSIT", function(module, exports) {

$parcel$export(module.exports, "horizontalNavQueueResource", () => $0eded50aa7688d41$export$896712202052ca56);

var $ao2h1 = parcelRequire("ao2h1");

var $4Wr19 = parcelRequire("4Wr19");

var $1Y49U = parcelRequire("1Y49U");

var $1nb22 = parcelRequire("1nb22");

var $ktofH = parcelRequire("ktofH");

var $6YG83 = parcelRequire("6YG83");
const $0eded50aa7688d41$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
    const queueId = match.params.queueId;
    let { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    projectKey = projectKey ?? '';
    projectId = projectId ?? '';
    const projectIdOrKey = projectId || projectKey;
    const queueAri = queueId ? (0, $1Y49U.JiraServicedeskQueueAri).create({
        siteId: cloudId,
        queueId: queueId || '',
        activationId: activationId
    }).toString() : '';
    const containerNavigationInput = queueAri ? {
        scopeId: queueAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    return {
        options: {
            fetchPolicy: 'store-and-network'
        },
        parameters: $4Wr19.default,
        variables: {
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey,
            containerNavigationInput: containerNavigationInput,
            first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE)
        }
    };
};
const $0eded50aa7688d41$export$896712202052ca56 = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'HORIZONTAL_NAVIGATION_JIRA_QUERY',
    getQuery: $0eded50aa7688d41$export$71eec30d9db46a56
}));

});
parcelRegister("4Wr19", function(module, exports) {

$parcel$export(module.exports, "default", () => $e49ea8e372e3d9cf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c8059f14a3201b31e0652bd91e511bc>>
 * @relayHash ad9b22c18ca56c0cec6bb77e087f1a60
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5a6395a2023b01b4b8728b98901f39635c74a467c84cd540ba5af518baccad2
const $e49ea8e372e3d9cf$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b5a6395a2023b01b4b8728b98901f39635c74a467c84cd540ba5af518baccad2",
        "metadata": {},
        "name": "HorizontalNavQueueInnerQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e49ea8e372e3d9cf$export$2e2bcd8739ae039 = $e49ea8e372e3d9cf$var$node;

});


parcelRegister("lBKJK", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalNavQueue", () => $08dafd9591b0689d$export$5f20c7610c638983);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $3HwlS = parcelRequire("3HwlS");

var $5NiYd = parcelRequire("5NiYd");

var $urQ6o = parcelRequire("urQ6o");

var $ayogX = parcelRequire("ayogX");

var $6jY6G = parcelRequire("6jY6G");

var $bmKPg = parcelRequire("bmKPg");

const $08dafd9591b0689d$var$LazyHorizontalNavQueue = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("jerUp")).then((HorizontalNavQueue)=>HorizontalNavQueue), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/queue/src/ui/HorizontalNavQueue.tsx"
});
const $08dafd9591b0689d$export$5f20c7610c638983 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const [issueKey] = (0, $bmKPg.usePathParam)('issueKey');
    const isIssueView = route.name === (0, $ayogX.customIssueRoute).name || route.name === (0, $urQ6o.customPracticeQueueRoute).name && issueKey;
    const content = !isIssueView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-nav-queue",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5NiYd.HorizontalNavSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08dafd9591b0689d$var$LazyHorizontalNavQueue, null));
    return (0, $3HwlS.getWillShowNav4)() ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $08dafd9591b0689d$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $08dafd9591b0689d$var$styles
    }, content));
};
const $08dafd9591b0689d$var$containerStyles = (0, $2s57o.xcss)({
    position: 'relative'
});
const $08dafd9591b0689d$var$styles = (0, $2s57o.xcss)({
    position: 'absolute',
    width: '100%'
});

});
parcelRegister("ayogX", function(module, exports) {

$parcel$export(module.exports, "customIssueRoute", () => $2e7fd15e22956eb6$export$2c4bc3091ab58cd0);
const $2e7fd15e22956eb6$export$2c4bc3091ab58cd0 = {
    name: 'servicedesk-queues-custom-issue-detail',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("jerUp", function(module, exports) {

let $e004f941bb5ebec1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e004f941bb5ebec1$var$load("h2MrD"),
    $e004f941bb5ebec1$var$load("bYT2S"),
    $e004f941bb5ebec1$var$load("blXgH")
]).then(()=>parcelRequire('jjRnc'));

});


parcelRegister("faj7G", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesAgentAndIssueView", () => $a3b6d4fb9a4ea620$export$6f01bfb6fc18a06e);
$parcel$export(module.exports, "CustomQueueRouteComponent", () => $a3b6d4fb9a4ea620$export$59d555419fbaa611);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $4R6GH = parcelRequire("4R6GH");

var $7yO8g = parcelRequire("7yO8g");

const $a3b6d4fb9a4ea620$export$6f01bfb6fc18a06e = (0, $b7Svb.lazyForPaint)(()=>{
    return (0, $7yO8g.markAsProductBundleReady)((parcelRequire("kH03D")));
}, {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-agent-and-issue-view/src/index.tsx"
});
const $a3b6d4fb9a4ea620$export$59d555419fbaa611 = ({ match: match })=>{
    const queueId = match.params && match.params.queueId || '';
    const issueKey = match.params && match.params.issueKey || '';
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a3b6d4fb9a4ea620$export$6f01bfb6fc18a06e,
        pageId: `spa-apps/servicedesk/queues/${queueId}/${issueKey}/${oldIssueView}`,
        shouldShowSpinner: !(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')
    });
};

});
parcelRegister("kH03D", function(module, exports) {

let $f107de414dbd0307$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f107de414dbd0307$var$load("eNmuD"),
    $f107de414dbd0307$var$load("cM9em"),
    $f107de414dbd0307$var$load("fr9NE"),
    $f107de414dbd0307$var$load("h2MrD"),
    $f107de414dbd0307$var$load("bYT2S"),
    $f107de414dbd0307$var$load("b8Jun")
]).then(()=>parcelRequire('6o1Xn'));

});


parcelRegister("gLKd7", function(module, exports) {

$parcel$export(module.exports, "QueueLoadingSkeleton", () => $1e5417896a058f9f$export$d20068523efc567f);

var $5uXOq = parcelRequire("5uXOq");

var $hoJVU = parcelRequire("hoJVU");

var $kb4zh = parcelRequire("kb4zh");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");
const $1e5417896a058f9f$export$d20068523efc567f = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && !(0, $4R6GH.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hoJVU.QueueNav3StylingPatchContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null));
};

});
parcelRegister("hoJVU", function(module, exports) {

$parcel$export(module.exports, "useStylingPatch", () => $a9c2b57f46f9d18e$export$ed35078f707ec860);
$parcel$export(module.exports, "QueueNav3StylingPatchContainer", () => $a9c2b57f46f9d18e$export$9cbbe53228ab978f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3HwlS = parcelRequire("3HwlS");

var $4R6GH = parcelRequire("4R6GH");

var $6jY6G = parcelRequire("6jY6G");

var $bmKPg = parcelRequire("bmKPg");

var $7M8Tn = parcelRequire("7M8Tn");

var $urQ6o = parcelRequire("urQ6o");

var $1D031 = parcelRequire("1D031");

var $24BFc = parcelRequire("24BFc");

var $g0YQu = parcelRequire("g0YQu");

var $lVOJN = parcelRequire("lVOJN");

var $ayogX = parcelRequire("ayogX");
const $a9c2b57f46f9d18e$export$ed35078f707ec860 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const [issueKey] = (0, $bmKPg.usePathParam)('issueKey');
    if (!(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) return {
        shouldUseStylingPatch: false
    };
    const isNav3QueueRouteOld = !(0, $3HwlS.getWillShowNav4)() && (route.name === (0, $7M8Tn.customQueueRoute).name || route.name === (0, $urQ6o.customPracticeQueueRoute).name && !issueKey);
    const isNav3QueueRouteNew = !(0, $3HwlS.getWillShowNav4)() && (route.name === (0, $7M8Tn.customQueueRoute).name || route.name === (0, $urQ6o.customPracticeQueueRoute).name || // Queue Issue View need to be included in the styling patch, so when navigate from queue to issue view, the component won't be re-rendered
    // The container is not applied to the issue view, so the styling patch won't be applied to issue view
    route.name === (0, $ayogX.customIssueRoute).name);
    const isNav3QueueRoute = (0, $4R6GH.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? isNav3QueueRouteNew : isNav3QueueRouteOld;
    const isNav3BoardRoute = !(0, $3HwlS.getWillShowNav4)() && (route.name === (0, $24BFc.customQueueBoardRoute).name || route.name === (0, $1D031.customPracticeQueueBoardRoute).name);
    const isNav3CalendarRoute = !(0, $3HwlS.getWillShowNav4)() && (route.name === (0, $g0YQu.customQueueCalendarRoute).name || route.name === (0, $lVOJN.customPracticeQueueCalendarRoute).name);
    return {
        shouldUseStylingPatch: isNav3QueueRoute || isNav3BoardRoute || isNav3CalendarRoute
    };
};
const $a9c2b57f46f9d18e$export$9cbbe53228ab978f = ({ children: children })=>{
    const { shouldUseStylingPatch: shouldUseStylingPatch } = $a9c2b57f46f9d18e$export$ed35078f707ec860();
    if (shouldUseStylingPatch || !(0, $4R6GH.fg)('jsm_fix_queue_issue_view_navigate_back_state')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "horizontal-nav-queue.controllers.styling-patch.queue-nav-3-styling-patch-container",
        className: (0, $bwpsq.default)([
            "_ca0q1h05 _vchhusvi _1e0c1txw _2lx21bp4 _4t3i1osq"
        ])
    }, children);
    return children;
};
const $a9c2b57f46f9d18e$var$nav3PaddingStyles = null;

});
parcelRegister("7M8Tn", function(module, exports) {

$parcel$export(module.exports, "customQueueRoute", () => $c0c93413dba087be$export$e1fac82ca0b0d637);
const $c0c93413dba087be$export$e1fac82ca0b0d637 = {
    name: 'servicedesk-queues-custom-view',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("1D031", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueBoardRoute", () => $63187d5cb553d47e$export$47ae519519dbd803);
const $63187d5cb553d47e$export$47ae519519dbd803 = {
    name: 'servicedesk-queues-practice-custom-board',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/board/:boardId',
    exact: true
};

});

parcelRegister("24BFc", function(module, exports) {

$parcel$export(module.exports, "customQueueBoardRoute", () => $3c41cbb682d42029$export$5407961894c40126);
const $3c41cbb682d42029$export$5407961894c40126 = {
    name: 'servicedesk-queues-custom-board',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/board/:boardId',
    exact: true
};

});

parcelRegister("g0YQu", function(module, exports) {

$parcel$export(module.exports, "customQueueCalendarRoute", () => $d63e361e6becb774$export$82a97d9fba2cfa9a);
const $d63e361e6becb774$export$82a97d9fba2cfa9a = {
    name: 'servicedesk-queues-custom-calendar',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/calendar/:boardId',
    exact: true
};

});

parcelRegister("lVOJN", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueCalendarRoute", () => $6fd1b54b722592ef$export$5a0e47b0abcf7c2f);
const $6fd1b54b722592ef$export$5a0e47b0abcf7c2f = {
    name: 'servicedesk-queues-practice-custom-calendar',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/calendar/:boardId',
    exact: true
};

});




parcelRegister("dAmDY", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueBoardRouteEntry", () => $0081c4c1a88ea88d$export$7b0b0691f8b766cf);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $1D031 = parcelRequire("1D031");

var $fpjJX = parcelRequire("fpjJX");

var $6Z2mh = parcelRequire("6Z2mh");

var $4R6GH = parcelRequire("4R6GH");

var $bHhiy = parcelRequire("bHhiy");

var $f5kpo = parcelRequire("f5kpo");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $iTSIT = parcelRequire("iTSIT");

var $3HwlS = parcelRequire("3HwlS");

var $lBKJK = parcelRequire("lBKJK");

var $dkQIn = parcelRequire("dkQIn");
const $0081c4c1a88ea88d$export$7b0b0691f8b766cf = (0, $7NszV.createEntry)((0, $1D031.customPracticeQueueBoardRoute), ()=>({
        group: 'servicedesk',
        component: (0, $5lsNZ.default),
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $3HwlS.getWillShowNav4)() ? (0, $dkQIn.boardPageEntryPoint) : (0, $dkQIn.boardPageNav3EntryPoint);
            return undefined;
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        skeleton: (0, $dkQIn.BoardSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $3HwlS.getWillShowNav4)() ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>!false, (0, $f7Y15.uifBoardResource)),
            (0, $gNStA.resourceWithCondition2)(()=>!(0, $3HwlS.getWillShowNav4)(), (0, $iTSIT.horizontalNavQueueResource))
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("dkQIn", function(module, exports) {

$parcel$export(module.exports, "boardPageNav3EntryPoint", () => $d0693ec64fdd7e2b$export$ae25ae5278cbd6a1);
$parcel$export(module.exports, "boardPageEntryPoint", () => $d0693ec64fdd7e2b$export$552f44bed039f041);
$parcel$export(module.exports, "BoardSkeleton", () => $d0693ec64fdd7e2b$export$325f821722dfa572);

var $5uXOq = parcelRequire("5uXOq");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $4R6GH = parcelRequire("4R6GH");

var $4E7Hx = parcelRequire("4E7Hx");

var $2iSWJ = parcelRequire("2iSWJ");

var $hWAe2 = parcelRequire("hWAe2");

var $hoJVU = parcelRequire("hoJVU");

var $3HwlS = parcelRequire("3HwlS");
const $d0693ec64fdd7e2b$export$ae25ae5278cbd6a1 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $2iSWJ.boardEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $d0693ec64fdd7e2b$export$552f44bed039f041 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $2iSWJ.boardEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $4E7Hx.horizontalNavQueueEntrypoint)
});
const $d0693ec64fdd7e2b$export$325f821722dfa572 = ()=>(0, $3HwlS.getWillShowNav4)() && !(0, $4R6GH.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hWAe2.ClassicBoardSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hoJVU.QueueNav3StylingPatchContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hWAe2.ClassicBoardSkeleton), null));

});
parcelRegister("4E7Hx", function(module, exports) {

$parcel$export(module.exports, "horizontalNavQueueEntrypoint", () => $67dd0a42e98143fe$export$df9ea493099a3cc4);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $4Wr19 = parcelRequire("4Wr19");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $1Y49U = parcelRequire("1Y49U");

var $1nb22 = parcelRequire("1nb22");

var $ktofH = parcelRequire("ktofH");

const $67dd0a42e98143fe$export$df9ea493099a3cc4 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("5eHTw")), {
        moduleId: "664171c5",
        moduleName: "HorizontalNavQueueInner"
    }),
    getPreloadProps: ({ context: { match: match, query: query }, tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
        const queueId = match.params.queueId;
        let { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        projectKey = projectKey ?? '';
        projectId = projectId ?? '';
        const projectIdOrKey = projectId || projectKey;
        const queueAri = queueId ? (0, $1Y49U.JiraServicedeskQueueAri).create({
            siteId: cloudId,
            queueId: queueId || '',
            activationId: activationId
        }).toString() : '';
        const containerNavigationInput = queueAri ? {
            scopeId: queueAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                horizontalNavQueueQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $4Wr19.default,
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        containerNavigationInput: containerNavigationInput,
                        first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE)
                    }
                }
            }
        };
    }
});

});
parcelRegister("5eHTw", function(module, exports) {

let $3d004f1a8f674320$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3d004f1a8f674320$var$load("h2MrD"),
    $3d004f1a8f674320$var$load("bYT2S"),
    $3d004f1a8f674320$var$load("4CqEl")
]).then(()=>parcelRequire('ftqx5'));

});


parcelRegister("2iSWJ", function(module, exports) {

$parcel$export(module.exports, "boardEntryPoint", () => $d117236cb308f3eb$export$937ca5a4cdc1a12e);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $d117236cb308f3eb$export$937ca5a4cdc1a12e = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("8oCEG")), {
        moduleId: "286ebff8"
    }),
    getPreloadProps: ()=>({})
});

});



parcelRegister("3MI0Z", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueCalendarRouteEntry", () => $ece609b32152a098$export$8e8d88d3af02e6f7);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $lVOJN = parcelRequire("lVOJN");

var $fpjJX = parcelRequire("fpjJX");

var $6Z2mh = parcelRequire("6Z2mh");

var $bHhiy = parcelRequire("bHhiy");

var $f7Y15 = parcelRequire("f7Y15");

var $jYeNO = parcelRequire("jYeNO");

var $iTSIT = parcelRequire("iTSIT");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $3HwlS = parcelRequire("3HwlS");

var $lBKJK = parcelRequire("lBKJK");

var $dPV2J = parcelRequire("dPV2J");
const $ece609b32152a098$export$8e8d88d3af02e6f7 = (0, $7NszV.createEntry)((0, $lVOJN.customPracticeQueueCalendarRoute), ()=>({
        group: 'servicedesk',
        component: (0, $5lsNZ.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $3HwlS.getWillShowNav4)() ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $3HwlS.getWillShowNav4)() ? (0, $dPV2J.calendarPageEntryPoint) : (0, $dPV2J.calendarPageNav3EntryPoint);
            return undefined;
        },
        skeleton: (0, $dPV2J.CalendarSkeleton),
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $jYeNO.getCalendarFilterFieldsResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>!(0, $3HwlS.getWillShowNav4)(), (0, $iTSIT.horizontalNavQueueResource)),
            (0, $gNStA.resourceWithCondition2)(()=>!false, (0, $f7Y15.uifBoardResource))
        ]
    }));

});
parcelRegister("dPV2J", function(module, exports) {

$parcel$export(module.exports, "calendarPageNav3EntryPoint", () => $348976a96cbb6eb5$export$4dc8c8e2c977ed01);
$parcel$export(module.exports, "calendarPageEntryPoint", () => $348976a96cbb6eb5$export$eda0c2fb67f7d7e7);
$parcel$export(module.exports, "CalendarSkeleton", () => $348976a96cbb6eb5$export$ebc7c47cc535837e);

var $5uXOq = parcelRequire("5uXOq");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $4R6GH = parcelRequire("4R6GH");

var $faaUu = parcelRequire("faaUu");

var $4E7Hx = parcelRequire("4E7Hx");

var $hoJVU = parcelRequire("hoJVU");

var $6Y2I3 = parcelRequire("6Y2I3");

var $3HwlS = parcelRequire("3HwlS");
const $348976a96cbb6eb5$export$4dc8c8e2c977ed01 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $faaUu.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $348976a96cbb6eb5$export$eda0c2fb67f7d7e7 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $faaUu.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $4E7Hx.horizontalNavQueueEntrypoint)
});
const $348976a96cbb6eb5$export$ebc7c47cc535837e = ()=>(0, $3HwlS.getWillShowNav4)() && !(0, $4R6GH.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Y2I3.ClassicCalendarSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hoJVU.QueueNav3StylingPatchContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Y2I3.ClassicCalendarSkeleton), null));

});


parcelRegister("8brgy", function(module, exports) {

$parcel$export(module.exports, "customQueueRouteEntry", () => $9125770532ebae88$export$54a295e04e6cea33);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $7M8Tn = parcelRequire("7M8Tn");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $iTSIT = parcelRequire("iTSIT");

var $lBKJK = parcelRequire("lBKJK");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $aNLeB = parcelRequire("aNLeB");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $faj7G = parcelRequire("faj7G");

var $gLKd7 = parcelRequire("gLKd7");
const $9125770532ebae88$export$54a295e04e6cea33 = (0, $7NszV.createEntry)((0, $7M8Tn.customQueueRoute), ()=>({
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        skeleton: (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $gLKd7.QueueLoadingSkeleton) : undefined,
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getInsightResources)(),
            ...(0, $fpjJX.getIssueListSsrResource)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $aNLeB.servicedeskIsItsmProjectResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $iTSIT.horizontalNavQueueResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        group: 'servicedesk',
        // It is important to keep this component consistent across the two routes so
        // that React doesn't unmount it when switching between the routes and the
        // full state is kept so that scroll position and loaded data is kept when
        // going back from issue details to the queues page.
        component: (0, $faj7G.CustomQueueRouteComponent),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $faj7G.LazyServicedeskQueuesAgentAndIssueView)
        ]
    }));

});

parcelRegister("3kqBW", function(module, exports) {

$parcel$export(module.exports, "customQueueBoardRouteEntry", () => $5785385fb89d88cf$export$f94102e9d0a3b113);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $fpjJX = parcelRequire("fpjJX");

var $24BFc = parcelRequire("24BFc");

var $6Z2mh = parcelRequire("6Z2mh");

var $4R6GH = parcelRequire("4R6GH");

var $bHhiy = parcelRequire("bHhiy");

var $f5kpo = parcelRequire("f5kpo");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $iTSIT = parcelRequire("iTSIT");

var $3HwlS = parcelRequire("3HwlS");

var $lBKJK = parcelRequire("lBKJK");

var $dkQIn = parcelRequire("dkQIn");
const $5785385fb89d88cf$export$f94102e9d0a3b113 = (0, $7NszV.createEntry)((0, $24BFc.customQueueBoardRoute), ()=>({
        group: 'servicedesk',
        component: (0, $5lsNZ.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $3HwlS.getWillShowNav4)() ? (0, $dkQIn.boardPageEntryPoint) : (0, $dkQIn.boardPageNav3EntryPoint);
            return undefined;
        },
        skeleton: (0, $dkQIn.BoardSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $3HwlS.getWillShowNav4)() ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>!false, (0, $f7Y15.uifBoardResource)),
            (0, $gNStA.resourceWithCondition2)(()=>!(0, $3HwlS.getWillShowNav4)(), (0, $iTSIT.horizontalNavQueueResource))
        ]
    }));

});

parcelRegister("79qCU", function(module, exports) {

$parcel$export(module.exports, "customQueueCalendarRouteEntry", () => $2a2221e4bb7d64f1$export$a6aaa9129c24f852);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $fpjJX = parcelRequire("fpjJX");

var $g0YQu = parcelRequire("g0YQu");

var $6Z2mh = parcelRequire("6Z2mh");

var $bHhiy = parcelRequire("bHhiy");

var $f7Y15 = parcelRequire("f7Y15");

var $jYeNO = parcelRequire("jYeNO");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $iTSIT = parcelRequire("iTSIT");

var $3HwlS = parcelRequire("3HwlS");

var $lBKJK = parcelRequire("lBKJK");

var $dPV2J = parcelRequire("dPV2J");
const $2a2221e4bb7d64f1$export$a6aaa9129c24f852 = (0, $7NszV.createEntry)((0, $g0YQu.customQueueCalendarRoute), ()=>({
        group: 'servicedesk',
        component: (0, $5lsNZ.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $3HwlS.getWillShowNav4)() ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $3HwlS.getWillShowNav4)() ? (0, $dPV2J.calendarPageEntryPoint) : (0, $dPV2J.calendarPageNav3EntryPoint);
            return undefined;
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        skeleton: (0, $dPV2J.CalendarSkeleton),
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $jYeNO.getCalendarFilterFieldsResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>!(0, $3HwlS.getWillShowNav4)(), (0, $iTSIT.horizontalNavQueueResource)),
            (0, $gNStA.resourceWithCondition2)(()=>!false, (0, $f7Y15.uifBoardResource))
        ]
    }));

});

parcelRegister("lYzgn", function(module, exports) {

$parcel$export(module.exports, "customIssueRouteEntry", () => $75b822e8abf02245$export$3813414450b75758);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $ayogX = parcelRequire("ayogX");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $lBKJK = parcelRequire("lBKJK");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $fpjJX = parcelRequire("fpjJX");

var $aNLeB = parcelRequire("aNLeB");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $faj7G = parcelRequire("faj7G");

var $gLKd7 = parcelRequire("gLKd7");
const $75b822e8abf02245$export$3813414450b75758 = (0, $7NszV.createEntry)((0, $ayogX.customIssueRoute), ()=>({
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            // Keep this consistent with the one in customQueueRouteEntry.tsx, so it won't rerender the queue agent view component
            // when navigating between queues and issues.
            // Rereder could cause problem:
            // 1. Issue view will lose issue navigator component
            // 2. When navigating back to queue, the queue will lose the scroll position.
            horizontal: (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        skeleton: (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $gLKd7.QueueLoadingSkeleton) : undefined,
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getInsightResources)(),
            ...(0, $fpjJX.getIssueListSsrResource)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $aNLeB.servicedeskIsItsmProjectResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('rrr_for_context_panel_data'), (0, $lAGdd.aiContextPanelResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        group: 'servicedesk',
        // It is important to keep this component consistent across the two routes so
        // that React doesn't unmount it when switching between the routes and the
        // full state is kept so that scroll position and loaded data is kept when
        // going back from issue details to the queues page.
        component: (0, $faj7G.CustomQueueRouteComponent),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $faj7G.LazyServicedeskQueuesAgentAndIssueView)
        ]
    }));

});

parcelRegister("6YHWn", function(module, exports) {

$parcel$export(module.exports, "servicedeskIssueRouteEntry", () => $d0c44cd76c7c1b24$export$a4bd7206a6659ad3);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $hwnr9 = parcelRequire("hwnr9");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $gNStA = parcelRequire("gNStA");

var $4R6GH = parcelRequire("4R6GH");

var $eyZxr = parcelRequire("eyZxr");
const $d0c44cd76c7c1b24$export$a4bd7206a6659ad3 = (0, $7NszV.createEntry)((0, $hwnr9.servicedeskIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $eyZxr.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getKnowledgeBaseResources)(),
            ...(0, $fpjJX.getInsightResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('rrr_for_context_panel_data'), (0, $lAGdd.aiContextPanelResource))
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eyZxr.LazyServicedeskQueuesIssueViewRedirect)
        ]
    }));

});
parcelRegister("hwnr9", function(module, exports) {

$parcel$export(module.exports, "servicedeskIssueRoute", () => $1bb6cc8a72a7dc88$export$e146d4ae5415aa9);
const $1bb6cc8a72a7dc88$export$e146d4ae5415aa9 = {
    name: 'servicedesk-issue',
    path: '/jira/servicedesk/projects/:projectKey/issue/:issueKey',
    exact: true
};

});

parcelRegister("eyZxr", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesIssueViewRedirect", () => $3e1702b77575d903$export$52593b5917c5e179);
$parcel$export(module.exports, "default", () => $3e1702b77575d903$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $3e1702b77575d903$export$52593b5917c5e179 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("gP9Je")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view-redirect/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3e1702b77575d903$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3e1702b77575d903$export$52593b5917c5e179,
        pageId: "spa-apps/servicedesk/queues/issue-view-redirect",
        shouldShowSpinner: true
    });

});
parcelRegister("gP9Je", function(module, exports) {

let $c3f8f4a8eb669e89$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c3f8f4a8eb669e89$var$load("8QnWZ").then(()=>parcelRequire('blyWx'));

});



parcelRegister("aAIWh", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeEditRouteEntry", () => $b2af11fd25aabf4a$export$5d9efd0f838d30a1);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $aDAYL = parcelRequire("aDAYL");

var $6Z2mh = parcelRequire("6Z2mh");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $4kils = parcelRequire("4kils");

var $a3285 = parcelRequire("a3285");

var $iRITI = parcelRequire("iRITI");
const $b2af11fd25aabf4a$export$5d9efd0f838d30a1 = (0, $7NszV.createEntry)((0, $aDAYL.servicedeskPracticeEditRoute), ()=>({
        group: 'servicedesk',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $a3285.ServicedeskQueuesConfig), (0, $4kils.default)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getIssueListSsrResource)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $fpjJX.getQueueConfigResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $a3285.LazyServicedeskQueuesConfig) : (0, $4kils.LazyServicedeskQueuesEditView)
        ],
        pageId: ({ query: query, match: match })=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $iRITI.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        }
    }));

});
parcelRegister("aDAYL", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeEditRoute", () => $c23ca6ea0acd72bb$export$dfaa99f66db1aa2);
const $c23ca6ea0acd72bb$export$dfaa99f66db1aa2 = {
    name: 'servicedesk-practice-edit',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit',
    exact: true,
    query: [
        'config?'
    ]
};

});

parcelRegister("4kils", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesEditView", () => $deaadf08ad128234$export$5bb02347e0261e6a);
$parcel$export(module.exports, "default", () => $deaadf08ad128234$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $deaadf08ad128234$export$5bb02347e0261e6a = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("akHhp"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-edit-view/src/index.tsx"
});
var /**
 * @deprecated Remove this when fsm_views_inside_queues_-_main_flag is cleaned up
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$deaadf08ad128234$export$2e2bcd8739ae039 = ({ match: match })=>{
    const queueId = match.params && match.params.queueId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $deaadf08ad128234$export$5bb02347e0261e6a,
        pageId: `spa-apps/servicedesk/queues/edit/${queueId}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("akHhp", function(module, exports) {

let $785d581ff45882c3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $785d581ff45882c3$var$load("K7eQv").then(()=>parcelRequire('3r23L'));

});


parcelRegister("a3285", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesConfig", () => $262e81f2d9d70ac4$export$8bc01f18d5db1178);
$parcel$export(module.exports, "ServicedeskQueuesConfig", () => $262e81f2d9d70ac4$export$ac10b7696844d33);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $7tQej = parcelRequire("7tQej");

const $262e81f2d9d70ac4$export$8bc01f18d5db1178 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("8RcCv")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-config/src/index.tsx"
});
const $262e81f2d9d70ac4$export$ac10b7696844d33 = (props)=>{
    const { query: query } = props;
    // If URL is from edit queue, then redirect to the new URL with config query param
    if (!query.config) {
        const { config: config, ...restQuery } = query;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: {
                pathname: `${props.location.pathname}`,
                hash: '',
                search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
                    ...restQuery,
                    config: 'queueConfig'
                })
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $262e81f2d9d70ac4$export$8bc01f18d5db1178,
        pageId: `spa-apps/servicedesk/queues/config/${query.config}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("8RcCv", function(module, exports) {

let $672d100a16752254$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $672d100a16752254$var$load("hPzOn"),
    $672d100a16752254$var$load("h2MrD"),
    $672d100a16752254$var$load("bYT2S"),
    $672d100a16752254$var$load("dgnBZ")
]).then(()=>parcelRequire('bgMER'));

});


parcelRegister("iRITI", function(module, exports) {

$parcel$export(module.exports, "serviceDeskQueuesConfigPageEntryPoint", () => $34887bb49cd0d1b5$export$2a7296eb9b68414);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $cZYKf = parcelRequire("cZYKf");
const $34887bb49cd0d1b5$export$2a7296eb9b68414 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $cZYKf.queuesConfigEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("cZYKf", function(module, exports) {

$parcel$export(module.exports, "queuesConfigEntrypoint", () => $4ca55b3219138116$export$bc016338e2032123);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $1Y49U = parcelRequire("1Y49U");

var $1nb22 = parcelRequire("1nb22");

var $ktofH = parcelRequire("ktofH");

var $cmFS1 = parcelRequire("cmFS1");

const $4ca55b3219138116$export$bc016338e2032123 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>{
        return (parcelRequire("8RcCv"));
    }, {
        moduleId: "2bb3c6f1"
    }),
    getPreloadProps: ({ context: { match: match, query: query, route: route }, tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
        const queueId = match.params.queueId;
        let { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        projectKey = projectKey ?? '';
        const queueAri = queueId ? (0, $1Y49U.JiraServicedeskQueueAri).create({
            siteId: cloudId,
            queueId: queueId || '',
            activationId: activationId
        }).toString() : '';
        const input = queueAri ? {
            scopeId: queueAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                mainSettingsNavigationQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $cmFS1.default),
                    variables: {
                        input: input,
                        first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE)
                    }
                }
            },
            extraProps: {
                query: query,
                match: match,
                route: route
            }
        };
    }
});

});
parcelRegister("cmFS1", function(module, exports) {

$parcel$export(module.exports, "default", () => $30f039e31305dc75$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<46e2694401dd0296d6732a14558ad98c>>
 * @relayHash dfd06866fddd95df7034205febe8eb4e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9b239a41299b531cf29a09d8abbeb2cf530d1715b2ea22ad115bc7f31e5f68f9
const $30f039e31305dc75$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "typeKey"
    }, v6 = {
        "kind": "ScalarField",
        "name": "message"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v8 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v7 /*: any*/ 
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = [
        v6 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v3 /*: any*/ ,
                v7 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainSettingsNavigationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "concreteType": "JiraNavigationItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "navigationItems",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraNavigationItemEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "jira.containerNavigation.navigationItems.edges.node"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "jira.containerNavigation.navigationItems.edges"
                                                        },
                                                        {
                                                            "concreteType": "QueryError",
                                                            "kind": "LinkedField",
                                                            "name": "errors",
                                                            "plural": true,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraContainerNavigation"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.containerNavigation"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainSettingsNavigationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "navigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v10 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v10 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9b239a41299b531cf29a09d8abbeb2cf530d1715b2ea22ad115bc7f31e5f68f9",
            "metadata": {},
            "name": "mainSettingsNavigationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$30f039e31305dc75$var$node.hash = "a86c2910ccbf2af4328e8f1d666e319c";
var $30f039e31305dc75$export$2e2bcd8739ae039 = $30f039e31305dc75$var$node;

});




parcelRegister("5fOtJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeIssueRouteEntry", () => $c4ae805410394011$export$ff51f5ad948cb987);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6yPAx = parcelRequire("6yPAx");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $gNStA = parcelRequire("gNStA");

var $4R6GH = parcelRequire("4R6GH");

var $i1TcK = parcelRequire("i1TcK");
const $c4ae805410394011$export$ff51f5ad948cb987 = (0, $7NszV.createEntry)((0, $6yPAx.servicedeskPracticeIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $i1TcK.default),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getKnowledgeBaseResources)(),
            ...(0, $fpjJX.getInsightResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('rrr_for_context_panel_data'), (0, $lAGdd.aiContextPanelResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $i1TcK.LazyServicedeskQueuesIssueView)
        ]
    }));

});
parcelRegister("6yPAx", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeIssueRoute", () => $b7f41b661071cdd5$export$38a6ee0f22e74bf3);
const $b7f41b661071cdd5$export$38a6ee0f22e74bf3 = {
    name: 'servicedesk-practice-issue',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/issue/:issueKey',
    exact: true
};

});

parcelRegister("i1TcK", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesIssueView", () => $e8099257b5d2aca0$export$164f2dfdd8dc056b);
$parcel$export(module.exports, "default", () => $e8099257b5d2aca0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $e8099257b5d2aca0$export$164f2dfdd8dc056b = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("g1Tpu")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view/src/index.tsx"
});
var /**
 * Constructs a URL path for navigating to a specific issue view within a service desk queue, incorporating optional parameters for issue identification and view customization.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$e8099257b5d2aca0$export$2e2bcd8739ae039 = ({ match: match })=>{
    const issueKey = `/${match.params && match.params.issueKey || ''}`;
    const queueId = `/${match.params && match.params.queueId || ''}`;
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e8099257b5d2aca0$export$164f2dfdd8dc056b,
        pageId: `spa-apps/servicedesk/queues/issue${queueId}${issueKey}${oldIssueView}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("g1Tpu", function(module, exports) {

let $bab7b8a36752820c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $bab7b8a36752820c$var$load("eNmuD"),
    $bab7b8a36752820c$var$load("cM9em"),
    $bab7b8a36752820c$var$load("fr9NE"),
    $bab7b8a36752820c$var$load("3vo2B")
]).then(()=>parcelRequire('6qBzG'));

});



parcelRegister("gfz2f", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeLandingRouteEntry", () => $8be1362ae286a3b1$export$881d545af6c177f1);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $gclwh = parcelRequire("gclwh");

var $6Z2mh = parcelRequire("6Z2mh");

var $erVva = parcelRequire("erVva");
const $8be1362ae286a3b1$export$881d545af6c177f1 = (0, $7NszV.createEntry)((0, $gclwh.servicedeskPracticeLandingRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: (0, $erVva.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $erVva.LazyServicedeskQueuesLanding)
        ]
    }));

});
parcelRegister("gclwh", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeLandingRoute", () => $3ecb8d0a4bfa59d9$export$3c859c71be33b36c);
const $3ecb8d0a4bfa59d9$export$3c859c71be33b36c = {
    name: 'servicedesk-practice-landing',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/(custom)?',
    exact: true
};

});

parcelRegister("erVva", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesLanding", () => $33ab495a6069d0db$export$bdf522692228bb6f);
$parcel$export(module.exports, "default", () => $33ab495a6069d0db$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $33ab495a6069d0db$export$bdf522692228bb6f = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("a27Xh")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-landing/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$33ab495a6069d0db$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $33ab495a6069d0db$export$bdf522692228bb6f,
        pageId: "spa-apps/servicedesk/queues/landing",
        shouldShowSpinner: true
    });

});
parcelRegister("a27Xh", function(module, exports) {

let $74e04300aa07cda5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $74e04300aa07cda5$var$load("h2MrD"),
    $74e04300aa07cda5$var$load("bYT2S"),
    $74e04300aa07cda5$var$load("eRCFp")
]).then(()=>parcelRequire('5ou2F'));

});



parcelRegister("gfW60", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeManageViewRouteEntry", () => $1a1c1c43e66f85e4$export$4e1b0df2a8fcae78);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $kxe3F = parcelRequire("kxe3F");

var $6Z2mh = parcelRequire("6Z2mh");

var $57W6j = parcelRequire("57W6j");
const $1a1c1c43e66f85e4$export$4e1b0df2a8fcae78 = (0, $7NszV.createEntry)((0, $kxe3F.servicedeskPracticeManageViewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $57W6j.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: (0, $fpjJX.getQueuesResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $57W6j.LazyServicedeskQueuesManageView)
        ]
    }));

});
parcelRegister("kxe3F", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeManageViewRoute", () => $bf1a5a194b52ef2d$export$125e0ab662806584);
const $bf1a5a194b52ef2d$export$125e0ab662806584 = {
    name: 'servicedesk-practice-manage-view',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/queue-settings',
    exact: true
};

});

parcelRegister("57W6j", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesManageView", () => $ad9d634f0cdcf391$export$9f1e189198f08c4a);
$parcel$export(module.exports, "default", () => $ad9d634f0cdcf391$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $ad9d634f0cdcf391$export$9f1e189198f08c4a = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cExx5"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-manage-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad9d634f0cdcf391$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ad9d634f0cdcf391$export$9f1e189198f08c4a,
        pageId: "spa-apps/servicedesk/queues/manage",
        shouldShowSpinner: true
    });

});
parcelRegister("cExx5", function(module, exports) {

let $93633b537d15efd5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $93633b537d15efd5$var$load("cFmpd").then(()=>parcelRequire('htw0K'));

});



parcelRegister("h51Kg", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeNewRouteEntry", () => $149e7521aa5247f3$export$50a04ec00cb8039);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $UrzEQ = parcelRequire("UrzEQ");

var $6Z2mh = parcelRequire("6Z2mh");

var $hw6fm = parcelRequire("hw6fm");
const $149e7521aa5247f3$export$50a04ec00cb8039 = (0, $7NszV.createEntry)((0, $UrzEQ.servicedeskPracticeNewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $hw6fm.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hw6fm.LazyServicedeskQueuesCreateView)
        ]
    }));

});
parcelRegister("UrzEQ", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeNewRoute", () => $e5aa77a45094c512$export$8595a5452f93a1fd);
const $e5aa77a45094c512$export$8595a5452f93a1fd = {
    name: 'servicedesk-practice-new',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/new',
    query: [
        'parentId?'
    ],
    exact: true
};

});

parcelRegister("hw6fm", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesCreateView", () => $093d629913ef6b8e$export$c050b699bf9e3e40);
$parcel$export(module.exports, "default", () => $093d629913ef6b8e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $093d629913ef6b8e$export$c050b699bf9e3e40 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6ILaW"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-create-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$093d629913ef6b8e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $093d629913ef6b8e$export$c050b699bf9e3e40,
        pageId: "spa-apps/servicedesk/queues/create",
        shouldShowSpinner: true
    });

});
parcelRegister("6ILaW", function(module, exports) {

let $4e4b7236aadd90f9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4e4b7236aadd90f9$var$load("jX3BJ").then(()=>parcelRequire('aQuyJ'));

});



parcelRegister("rsO8k", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesAddonRouteEntry", () => $59596f7c053ae5d7$export$23a16f20b48235b3);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $95l0v = parcelRequire("95l0v");

var $6Z2mh = parcelRequire("6Z2mh");

var $laAgE = parcelRequire("laAgE");
const $59596f7c053ae5d7$export$23a16f20b48235b3 = (0, $7NszV.createEntry)((0, $95l0v.servicedeskQueuesAddonRoute), ()=>({
        group: 'servicedesk',
        component: (0, $laAgE.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $laAgE.LazyServicedeskQueuesAddonView)
        ]
    }));

});
parcelRegister("95l0v", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesAddonRoute", () => $4884cbac3a1d9cc0$export$1465f05b88a63f13);
const $4884cbac3a1d9cc0$export$1465f05b88a63f13 = {
    name: 'servicedesk-queues-addon',
    path: '/jira/servicedesk/projects/:projectKey/queues/addon/:addonKey',
    exact: true
};

});

parcelRegister("laAgE", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesAddonView", () => $6cc059f7849819d9$export$451a7cce84b6b1e6);
$parcel$export(module.exports, "default", () => $6cc059f7849819d9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $6cc059f7849819d9$export$451a7cce84b6b1e6 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("kgyPj")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-addon-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6cc059f7849819d9$export$2e2bcd8739ae039 = ({ match: match })=>{
    const addonKey = match.params && match.params.addonKey || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6cc059f7849819d9$export$451a7cce84b6b1e6,
        pageId: `spa-apps/servicedesk/queues/addon/${addonKey}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("kgyPj", function(module, exports) {

let $ec10511d6b3a9e1e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ec10511d6b3a9e1e$var$load("j8CYW").then(()=>parcelRequire('jFMLI'));

});



parcelRegister("5JkxV", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesEditRouteEntry", () => $ce3daf0233f73856$export$ae7b71ac953d95bf);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $7n6p5 = parcelRequire("7n6p5");

var $6Z2mh = parcelRequire("6Z2mh");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $4kils = parcelRequire("4kils");

var $a3285 = parcelRequire("a3285");

var $iRITI = parcelRequire("iRITI");
const $ce3daf0233f73856$export$ae7b71ac953d95bf = (0, $7NszV.createEntry)((0, $7n6p5.servicedeskQueuesEditRoute), ()=>({
        group: 'servicedesk',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $a3285.ServicedeskQueuesConfig), (0, $4kils.default)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $fpjJX.getIssueListSsrResource)(),
            ...(0, $fpjJX.getQueueConfigResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $a3285.LazyServicedeskQueuesConfig) : (0, $4kils.LazyServicedeskQueuesEditView)
        ],
        ufoName: 'service-management.queues.edit',
        pageId: ({ query: query, match: match })=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $iRITI.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        }
    }));

});
parcelRegister("7n6p5", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesEditRoute", () => $f9047204629cbf40$export$f8fd3a1f8c33aff8);
const $f9047204629cbf40$export$f8fd3a1f8c33aff8 = {
    name: 'servicedesk-queues-edit',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/edit',
    exact: true,
    query: [
        'config?'
    ]
};

});


parcelRegister("jIBei", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesIssueRouteEntry", () => $af2173f32f306a68$export$2e4931acac9270fc);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $3lD6Q = parcelRequire("3lD6Q");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $gNStA = parcelRequire("gNStA");

var $4R6GH = parcelRequire("4R6GH");

var $i1TcK = parcelRequire("i1TcK");
const $af2173f32f306a68$export$2e4931acac9270fc = (0, $7NszV.createEntry)((0, $3lD6Q.servicedeskQueuesIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $i1TcK.default),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getKnowledgeBaseResources)(),
            ...(0, $fpjJX.getInsightResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('rrr_for_context_panel_data'), (0, $lAGdd.aiContextPanelResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $i1TcK.LazyServicedeskQueuesIssueView)
        ]
    }));

});
parcelRegister("3lD6Q", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesIssueRoute", () => $e8668889c15b3639$export$52a24b9cf42d208b);
const $e8668889c15b3639$export$52a24b9cf42d208b = {
    name: 'servicedesk-queues-issue',
    path: '/jira/servicedesk/projects/:projectKey/queues/issue/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});


parcelRegister("3oSi6", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesLandingRouteEntry", () => $725a0b4233bb029f$export$4242a81237c45c7d);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $50cHa = parcelRequire("50cHa");

var $6Z2mh = parcelRequire("6Z2mh");

var $erVva = parcelRequire("erVva");
const $725a0b4233bb029f$export$4242a81237c45c7d = (0, $7NszV.createEntry)((0, $50cHa.servicedeskQueuesLandingRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: (0, $erVva.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $erVva.LazyServicedeskQueuesLanding)
        ]
    }));

});
parcelRegister("50cHa", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesLandingRoute", () => $c48a2414491b1ed8$export$52b4c044e4929ebc);
const $c48a2414491b1ed8$export$52b4c044e4929ebc = {
    name: 'servicedesk-queues-landing',
    // Supporting optional /default for legacy backwards compatability
    path: '/jira/servicedesk/projects/:projectKey/queues/(default|custom)?',
    exact: true
};

});


parcelRegister("96BnX", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesManageViewRouteEntry", () => $4edb93f2b23424ca$export$7e9e2984a94a07b0);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $68aAJ = parcelRequire("68aAJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $57W6j = parcelRequire("57W6j");
const $4edb93f2b23424ca$export$7e9e2984a94a07b0 = (0, $7NszV.createEntry)((0, $68aAJ.servicedeskQueuesManageViewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $57W6j.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: (0, $fpjJX.getQueuesResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $57W6j.LazyServicedeskQueuesManageView)
        ]
    }));

});
parcelRegister("68aAJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesManageViewRoute", () => $d770d83963ac1c36$export$7f30d40b906894c5);
const $d770d83963ac1c36$export$7f30d40b906894c5 = {
    name: 'servicedesk-queues-manage-view',
    path: '/jira/servicedesk/projects/:projectKey/queues/queue-settings',
    exact: true
};

});


parcelRegister("fP1EY", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesNewRouteEntry", () => $43b55289272bfd02$export$9f7cc3294b3141b1);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6x8s4 = parcelRequire("6x8s4");

var $6Z2mh = parcelRequire("6Z2mh");

var $hw6fm = parcelRequire("hw6fm");
const $43b55289272bfd02$export$9f7cc3294b3141b1 = (0, $7NszV.createEntry)((0, $6x8s4.servicedeskQueuesNewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $hw6fm.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hw6fm.LazyServicedeskQueuesCreateView)
        ],
        ufoName: 'service-management.queues.new'
    }));

});
parcelRegister("6x8s4", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesNewRoute", () => $52cd0fc2ec934503$export$c1908994722d1e73);
const $52cd0fc2ec934503$export$c1908994722d1e73 = {
    name: 'servicedesk-queues-new',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/new',
    query: [
        'parentId?'
    ],
    exact: true
};

});


parcelRegister("lzLcy", function(module, exports) {

$parcel$export(module.exports, "servicedeskAtlassianAnalyticsRouteEntry", () => $f87b1ab4700345c2$export$94d6674b63b9d647);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $hejqw = parcelRequire("hejqw");

var $fpjJX = parcelRequire("fpjJX");

var $cb8ep = parcelRequire("cb8ep");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $cm4j2 = parcelRequire("cm4j2");
const $f87b1ab4700345c2$export$94d6674b63b9d647 = (0, $7NszV.createEntry)((0, $cb8ep.servicedeskAtlassianAnalyticsRoute), ()=>({
        group: 'servicedesk',
        component: (0, $cm4j2.AtlassianAnalytics),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $hejqw.servicedeskAtlassianAnalyticsResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cm4j2.LazyAtlassianAnalytics)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).ATLASSIAN_ANALYTICS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).ATLASSIAN_ANALYTICS),
                teamName: 'ITSM Saga'
            }
        }
    }));

});
parcelRegister("hejqw", function(module, exports) {

$parcel$export(module.exports, "servicedeskAtlassianAnalyticsResource", () => $ccd9a1a485573887$export$eb2deca89cf3fb61);

var $2M1hQ = parcelRequire("2M1hQ");


const $ccd9a1a485573887$var$getDataLoader = ()=>(parcelRequire("86AxT"));
const $ccd9a1a485573887$export$eb2deca89cf3fb61 = (0, $2M1hQ.createResource)({
    type: (0, $125270e59037c004$export$73cf43fb073ce577),
    getKey: ()=>'atlassian analytics',
    getDataLoader: $ccd9a1a485573887$var$getDataLoader,
    isBrowserOnly: true
});

});
const $125270e59037c004$export$73cf43fb073ce577 = 'SERVICEDESK_ATLASSIAN_ANALYTICS';

parcelRegister("86AxT", function(module, exports) {

let $5e6b3b7f542e0e9b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5e6b3b7f542e0e9b$var$load("1fLqt").then(()=>parcelRequire('ghpmF'));

});


parcelRegister("cb8ep", function(module, exports) {

$parcel$export(module.exports, "servicedeskAtlassianAnalyticsRoute", () => $9a654d65b63de676$export$399ef3a2d4288bba);
const $9a654d65b63de676$export$399ef3a2d4288bba = {
    name: 'servicedesk-atlassian-analytics',
    path: '/jira/servicedesk/projects/:projectKey/reports/atlassian-analytics',
    exact: true
};

});

parcelRegister("cm4j2", function(module, exports) {

$parcel$export(module.exports, "LazyAtlassianAnalytics", () => $8afe4cbad132cc61$export$78ffe2f6530d45d1);
$parcel$export(module.exports, "AtlassianAnalytics", () => $8afe4cbad132cc61$export$6d23a188bb96b7ab);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $8afe4cbad132cc61$export$78ffe2f6530d45d1 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("bznn6"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/atlassian-analytics/src/index.tsx"
});
const $8afe4cbad132cc61$export$6d23a188bb96b7ab = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8afe4cbad132cc61$export$78ffe2f6530d45d1,
        pageId: "spa-apps/servicedesk/atlassian-analytics",
        shouldShowSpinner: true
    });

});
parcelRegister("bznn6", function(module, exports) {

let $86c517b86b2f9d91$var$load = (parcelRequire("28QjX"))(4);
module.exports = $86c517b86b2f9d91$var$load("ahZ5Q").then(()=>parcelRequire('hUapH'));

});



parcelRegister("kZgpC", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReports2RouteEntry", () => $aba9a99d9cdea566$export$c4c0806ea684088);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $3ZP7Q = parcelRequire("3ZP7Q");

var $6Z2mh = parcelRequire("6Z2mh");

var $cVTuT = parcelRequire("cVTuT");
const $aba9a99d9cdea566$export$c4c0806ea684088 = (0, $7NszV.createEntry)((0, $3ZP7Q.servicedeskKbRequestsReports2Route), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.kb-requests',
        component: (0, $cVTuT.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cVTuT.LazyServicedeskKbRequestsReports)
        ]
    }));

});
parcelRegister("3ZP7Q", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReports2Route", () => $abd055c66022393b$export$276e2ed89304d21c);
const $abd055c66022393b$export$276e2ed89304d21c = {
    name: 'servicedesk-kb-requests-reports',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)'
};

});

parcelRegister("cVTuT", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKbRequestsReports", () => $12e91a60aa9991e2$export$f86e12b111395ad);
$parcel$export(module.exports, "default", () => $12e91a60aa9991e2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $12e91a60aa9991e2$export$f86e12b111395ad = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("i2PQu"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/kb-requests-reports/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$12e91a60aa9991e2$export$2e2bcd8739ae039 = ({ match: match })=>{
    const reportType = match.params.reportType || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $12e91a60aa9991e2$export$f86e12b111395ad,
        pageId: `spa-apps/servicedesk/reports/${reportType}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("i2PQu", function(module, exports) {

let $0363e19217fe582d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0363e19217fe582d$var$load("h2MrD"),
    $0363e19217fe582d$var$load("bYT2S"),
    $0363e19217fe582d$var$load("ktADJ")
]).then(()=>parcelRequire('exkzN'));

});



parcelRegister("auP5Z", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReportsIssueRouteEntry", () => $7f9fdb3f5341d83e$export$280a79a8f002dd58);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $8O7zJ = parcelRequire("8O7zJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $gNStA = parcelRequire("gNStA");

var $4R6GH = parcelRequire("4R6GH");

var $1hJVy = parcelRequire("1hJVy");
const $7f9fdb3f5341d83e$export$280a79a8f002dd58 = (0, $7NszV.createEntry)((0, $8O7zJ.servicedeskKbRequestsReportsIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $1hJVy.default),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('rrr_for_context_panel_data'), (0, $lAGdd.aiContextPanelResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1hJVy.LazyServicedeskReportsIssueView)
        ],
        ufoName: 'service-management.reports.issue'
    }));

});
parcelRegister("8O7zJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReportsIssueRoute", () => $8f89a0ced56a7cae$export$296aa46068d40f43);
const $8f89a0ced56a7cae$export$296aa46068d40f43 = {
    name: 'servicedesk-kb-requests-reports-time-scale-issue',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)/timescale/:timescaleId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("1hJVy", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsIssueView", () => $7281c34e15a34d51$export$c2f0d3c59c9d3bf3);
$parcel$export(module.exports, "default", () => $7281c34e15a34d51$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $7281c34e15a34d51$export$c2f0d3c59c9d3bf3 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("jjsI1")), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-issue-view/src/index.tsx"
});
var /**
 * Dynamically constructs and renders a lazy-loaded page tailored to specific Servicedesk report views. By leveraging URL parameters such as issue key and timescale ID, it enhances user navigation within the Servicedesk environment by directly accommodating varied user inquiries and historical data perspectives.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$7281c34e15a34d51$export$2e2bcd8739ae039 = ({ match: match })=>{
    const issueKey = `/${match.params && match.params.issueKey || ''}`;
    const timescaleId = `/${match.params && match.params.timescaleId || ''}`;
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7281c34e15a34d51$export$c2f0d3c59c9d3bf3,
        pageId: `spa-apps/servicedesk/reports/issue${issueKey}${timescaleId}${oldIssueView}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("jjsI1", function(module, exports) {

let $e0f60faa98eb4ccf$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e0f60faa98eb4ccf$var$load("eNmuD"),
    $e0f60faa98eb4ccf$var$load("cM9em"),
    $e0f60faa98eb4ccf$var$load("fr9NE"),
    $e0f60faa98eb4ccf$var$load("8831k")
]).then(()=>parcelRequire('kXHaM'));

});



parcelRegister("6un8I", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReportsTimeScaleRouteEntry", () => $bb1d631cc0a3bc8b$export$1c6b1e308d58ca8b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $cKqlJ = parcelRequire("cKqlJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $cVTuT = parcelRequire("cVTuT");
const $bb1d631cc0a3bc8b$export$1c6b1e308d58ca8b = (0, $7NszV.createEntry)((0, $cKqlJ.servicedeskKbRequestsReportsTimeScaleRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.kb-requests',
        component: (0, $cVTuT.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cVTuT.LazyServicedeskKbRequestsReports)
        ]
    }));

});
parcelRegister("cKqlJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReportsTimeScaleRoute", () => $7032eddc67e65c51$export$1585b6f8f1838e19);
const $7032eddc67e65c51$export$1585b6f8f1838e19 = {
    name: 'servicedesk-kb-requests-reports-time-scale',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)/timescale/:timescaleId'
};

});


parcelRegister("c97hk", function(module, exports) {

$parcel$export(module.exports, "servicedeskReports1RouteEntry", () => $28c558427771b7f4$export$8055c8b2162cf5bd);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $3HwlS = parcelRequire("3HwlS");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $cJTRV = parcelRequire("cJTRV");

var $6Z2mh = parcelRequire("6Z2mh");

var $7tQej = parcelRequire("7tQej");


var $IT9I6 = parcelRequire("IT9I6");

var $4QhHa = parcelRequire("4QhHa");
const $28c558427771b7f4$var$DefaultReportsRedirect = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/servicedesk/projects/${String(match.params.projectKey)}${(0, $d37b1fd9e7afc201$export$ddc580d759168f88)}`
    });
const $28c558427771b7f4$export$8055c8b2162cf5bd = (0, $7NszV.createEntry)((0, $cJTRV.servicedeskReports1Route), ()=>({
        group: 'servicedesk',
        component: (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $4QhHa.default), $28c558427771b7f4$var$DefaultReportsRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $IT9I6.getReportsWithKbResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4QhHa.LazyServicedeskReportsHomePage)
        ]
    }));

});
parcelRegister("cJTRV", function(module, exports) {

$parcel$export(module.exports, "servicedeskReports1Route", () => $ddba74d9a05765e5$export$f5adfd681a4e85ad);
const $ddba74d9a05765e5$export$f5adfd681a4e85ad = {
    name: 'servicedesk-reports',
    path: '/jira/servicedesk/projects/:projectKey/reports',
    exact: true
};

});

const $d37b1fd9e7afc201$export$e4c007d05145b8c2 = '/reports/all-rating';
const $d37b1fd9e7afc201$export$ddc580d759168f88 = '/reports/workload';
const $d37b1fd9e7afc201$export$13bdc187fca9c33e = '/reports';

parcelRegister("IT9I6", function(module, exports) {

$parcel$export(module.exports, "getReportsWithKbResources", () => $fbd9e6ca0682c0bc$export$1a63e9cdf8268e40);

var $bjZiV = parcelRequire("bjZiV");

var $fpjJX = parcelRequire("fpjJX");
const $fbd9e6ca0682c0bc$export$1a63e9cdf8268e40 = ()=>[
        ...(0, $fpjJX.getServicedeskPageContextResources)(),
        (0, $bjZiV.kbConfluenceContextResource)
    ];

});

parcelRegister("4QhHa", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsHomePage", () => $2636e09e0764ad56$export$121b9cfb2b001a53);
$parcel$export(module.exports, "default", () => $2636e09e0764ad56$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");


const $2636e09e0764ad56$export$121b9cfb2b001a53 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kFClp"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-home-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2636e09e0764ad56$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2636e09e0764ad56$export$121b9cfb2b001a53,
        pageId: `spa-apps/servicedesk${(0, $d37b1fd9e7afc201$export$13bdc187fca9c33e)}}`,
        shouldShowSpinner: true
    });

});
parcelRegister("kFClp", function(module, exports) {

let $f0c5615ed95190ed$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f0c5615ed95190ed$var$load("atEkV").then(()=>parcelRequire('i1BaA'));

});



parcelRegister("7sSEm", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustom4RouteEntry", () => $bc9f120c03f314db$export$5ef62fad7280cd08);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2cp29 = parcelRequire("2cp29");

var $6Z2mh = parcelRequire("6Z2mh");

var $3FrpL = parcelRequire("3FrpL");
const $bc9f120c03f314db$export$5ef62fad7280cd08 = (0, $7NszV.createEntry)((0, $2cp29.servicedeskReportsCustom4Route), ()=>({
        group: 'servicedesk',
        component: (0, $3FrpL.default),
        perfMetricKey: 'service-management.reports.custom',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3FrpL.LazyServicedeskReportsCustom)
        ],
        ufoName: 'service-management-custom-reports'
    }));

});
parcelRegister("2cp29", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustom4Route", () => $47b22144a185fe3a$export$39325072940fb58c);
const $47b22144a185fe3a$export$39325072940fb58c = {
    name: 'servicedesk-reports-custom',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId'
};

});

parcelRegister("3FrpL", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsCustom", () => $940ea7d208fcfce4$export$3ec5c3d7729889b9);
$parcel$export(module.exports, "default", () => $940ea7d208fcfce4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $940ea7d208fcfce4$export$3ec5c3d7729889b9 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lNAz6"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$940ea7d208fcfce4$export$2e2bcd8739ae039 = ({ match: match })=>{
    const reportType = match.params.reportType || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $940ea7d208fcfce4$export$3ec5c3d7729889b9,
        pageId: `spa-apps/servicedesk/reports/${reportType}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("lNAz6", function(module, exports) {

let $fdea89ae21f6665b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fdea89ae21f6665b$var$load("h2MrD"),
    $fdea89ae21f6665b$var$load("bYT2S"),
    $fdea89ae21f6665b$var$load("6sXwS")
]).then(()=>parcelRequire('gIY6j'));

});



parcelRegister("eaXgt", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomCreateRouteEntry", () => $2cf0babd3b9237c1$export$b806d1abc9172b6d);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $17wjD = parcelRequire("17wjD");

var $6Z2mh = parcelRequire("6Z2mh");

var $3I9YI = parcelRequire("3I9YI");
const $2cf0babd3b9237c1$export$b806d1abc9172b6d = (0, $7NszV.createEntry)((0, $17wjD.servicedeskReportsCustomCreateRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.custom-create',
        component: (0, $3I9YI.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3I9YI.LazyServicedeskReportsCustomCreate)
        ]
    }));

});
parcelRegister("17wjD", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomCreateRoute", () => $c5c6b7b61be9d580$export$333e623d5eb41af0);
const $c5c6b7b61be9d580$export$333e623d5eb41af0 = {
    name: 'servicedesk-reports-custom-create',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/new'
};

});

parcelRegister("3I9YI", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsCustomCreate", () => $0aaa6fdfa8d01159$export$821b8201b24f8b7d);
$parcel$export(module.exports, "default", () => $0aaa6fdfa8d01159$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $0aaa6fdfa8d01159$export$821b8201b24f8b7d = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("k8Igu"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-create/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0aaa6fdfa8d01159$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0aaa6fdfa8d01159$export$821b8201b24f8b7d,
        pageId: "spa-apps/servicedesk/reports/custom/create",
        shouldShowSpinner: true
    });

});
parcelRegister("k8Igu", function(module, exports) {

let $ea96e41f6ee27b8c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ea96e41f6ee27b8c$var$load("1v184").then(()=>parcelRequire('bYkUJ'));

});



parcelRegister("moUwl", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomEditRouteEntry", () => $79d751c5c6540b74$export$c4c3dcf824e7036e);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $b3EQX = parcelRequire("b3EQX");

var $6Z2mh = parcelRequire("6Z2mh");

var $gnyZS = parcelRequire("gnyZS");
const $79d751c5c6540b74$export$c4c3dcf824e7036e = (0, $7NszV.createEntry)((0, $b3EQX.servicedeskReportsCustomEditRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.custom-edit-view',
        component: (0, $gnyZS.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gnyZS.LazyServicedeskReportsCustomEdit)
        ]
    }));

});
parcelRegister("b3EQX", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomEditRoute", () => $175ba21e4ba52ddb$export$3b6b3105a9ef9b83);
const $175ba21e4ba52ddb$export$3b6b3105a9ef9b83 = {
    name: 'servicedesk-reports-custom-edit',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/edit'
};

});

parcelRegister("gnyZS", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsCustomEdit", () => $db3dd114755c3f65$export$53def03ace9a6c5b);
$parcel$export(module.exports, "default", () => $db3dd114755c3f65$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $db3dd114755c3f65$export$53def03ace9a6c5b = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("63o2k"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-edit/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$db3dd114755c3f65$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { reportId: reportId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $db3dd114755c3f65$export$53def03ace9a6c5b,
        pageId: `spa-apps/servicedesk/reports/custom/${reportId || ''}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("63o2k", function(module, exports) {

let $4685ab0b01e88b27$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4685ab0b01e88b27$var$load("hrAxT").then(()=>parcelRequire('cOaoL'));

});



parcelRegister("7D3Yv", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomIssueRouteEntry", () => $db3c4c23d5eb6125$export$222c6398b69dbc6d);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $7QuMl = parcelRequire("7QuMl");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $gNStA = parcelRequire("gNStA");

var $4R6GH = parcelRequire("4R6GH");

var $1hJVy = parcelRequire("1hJVy");
const $db3c4c23d5eb6125$export$222c6398b69dbc6d = (0, $7NszV.createEntry)((0, $7QuMl.servicedeskReportsCustomIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $1hJVy.default),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('rrr_for_context_panel_data'), (0, $lAGdd.aiContextPanelResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1hJVy.LazyServicedeskReportsIssueView)
        ],
        ufoName: 'service-management.reports.issue'
    }));

});
parcelRegister("7QuMl", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomIssueRoute", () => $3e79cb7a6fb28a4d$export$1cfe539c854438e8);
const $3e79cb7a6fb28a4d$export$1cfe539c854438e8 = {
    name: 'servicedesk-reports-custom-time-scale-issue',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/timescale/:timescaleId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});


parcelRegister("dgneZ", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomTimeScaleRouteEntry", () => $422e88992a614b49$export$508d5e1a59322a54);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $jBB4F = parcelRequire("jBB4F");

var $6Z2mh = parcelRequire("6Z2mh");

var $3FrpL = parcelRequire("3FrpL");
const $422e88992a614b49$export$508d5e1a59322a54 = (0, $7NszV.createEntry)((0, $jBB4F.servicedeskReportsCustomTimeScaleRoute), ()=>({
        group: 'servicedesk',
        component: (0, $3FrpL.default),
        perfMetricKey: 'service-management.reports.custom',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3FrpL.LazyServicedeskReportsCustom)
        ],
        ufoName: 'service-management-custom-reports'
    }));

});
parcelRegister("jBB4F", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomTimeScaleRoute", () => $3a492ac932fcb1b3$export$eae9a65fe3f035ef);
const $3a492ac932fcb1b3$export$eae9a65fe3f035ef = {
    name: 'servicedesk-reports-custom-time-scale',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/timescale/:timescaleId'
};

});


parcelRegister("hRN7l", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfaction2RouteEntry", () => $eebc12aca0cec40e$export$d6fb66bfd4a40ef);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $bsSH9 = parcelRequire("bsSH9");

var $6Z2mh = parcelRequire("6Z2mh");

var $8Xwpi = parcelRequire("8Xwpi");
const $eebc12aca0cec40e$export$d6fb66bfd4a40ef = (0, $7NszV.createEntry)((0, $bsSH9.servicedeskReportsSatisfaction2Route), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.satisfaction',
        component: (0, $8Xwpi.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8Xwpi.LazyServicedeskReportsSatisfaction)
        ]
    }));

});
parcelRegister("bsSH9", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfaction2Route", () => $15dedc31928a1123$export$22fd25b495033fdf);
const $15dedc31928a1123$export$22fd25b495033fdf = {
    name: 'servicedesk-reports-satisfaction',
    path: '/jira/servicedesk/projects/:projectKey/reports/all-rating'
};

});

parcelRegister("8Xwpi", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsSatisfaction", () => $66f1c14673116eb8$export$8edc7b9d922cd22f);
$parcel$export(module.exports, "default", () => $66f1c14673116eb8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");


const $66f1c14673116eb8$export$8edc7b9d922cd22f = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("2uoeO"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-satisfaction/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$66f1c14673116eb8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $66f1c14673116eb8$export$8edc7b9d922cd22f,
        pageId: `spa-apps/servicedesk${(0, $d37b1fd9e7afc201$export$e4c007d05145b8c2)}}`,
        shouldShowSpinner: true
    });

});
parcelRegister("2uoeO", function(module, exports) {

let $1d012f3d3aa03393$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1d012f3d3aa03393$var$load("ijyfm").then(()=>parcelRequire('hLsyG'));

});



parcelRegister("cU5zd", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfactionIssueRouteEntry", () => $28e15c46fa77f0cb$export$6b98300c0f2ab048);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $i69aA = parcelRequire("i69aA");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $gNStA = parcelRequire("gNStA");

var $4R6GH = parcelRequire("4R6GH");

var $1hJVy = parcelRequire("1hJVy");
const $28e15c46fa77f0cb$export$6b98300c0f2ab048 = (0, $7NszV.createEntry)((0, $i69aA.servicedeskReportsSatisfactionIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $1hJVy.default),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('rrr_for_context_panel_data'), (0, $lAGdd.aiContextPanelResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1hJVy.LazyServicedeskReportsIssueView)
        ],
        ufoName: 'service-management.reports.issue'
    }));

});
parcelRegister("i69aA", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfactionIssueRoute", () => $c513c6729e01b870$export$da606765550c7e7);
const $c513c6729e01b870$export$da606765550c7e7 = {
    name: 'servicedesk-reports-satisfaction-time-scale-issue',
    path: '/jira/servicedesk/projects/:projectKey/reports/all-rating/timescale/:timescaleId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});


parcelRegister("fSktp", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfactionTimeScaleRouteEntry", () => $460b54aef192ce9f$export$8d7026b8c74a8be8);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $lH1vR = parcelRequire("lH1vR");

var $6Z2mh = parcelRequire("6Z2mh");

var $8Xwpi = parcelRequire("8Xwpi");
const $460b54aef192ce9f$export$8d7026b8c74a8be8 = (0, $7NszV.createEntry)((0, $lH1vR.servicedeskReportsSatisfactionTimeScaleRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.satisfaction',
        component: (0, $8Xwpi.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8Xwpi.LazyServicedeskReportsSatisfaction)
        ]
    }));

});
parcelRegister("lH1vR", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfactionTimeScaleRoute", () => $51118689f933b851$export$64ae70b2d6b34c4e);
const $51118689f933b851$export$64ae70b2d6b34c4e = {
    name: 'servicedesk-reports-satisfaction-time-scale',
    path: '/jira/servicedesk/projects/:projectKey/reports/all-rating/timescale/:timescaleId'
};

});


parcelRegister("5TKdO", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsTypeRouteEntry", () => $2e5063c16517b80e$export$bc47b2df6d39fd3f);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $iYmop = parcelRequire("iYmop");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $gNStA = parcelRequire("gNStA");

var $4R6GH = parcelRequire("4R6GH");

var $IT9I6 = parcelRequire("IT9I6");

var $6Hx2y = parcelRequire("6Hx2y");
const $2e5063c16517b80e$export$bc47b2df6d39fd3f = (0, $7NszV.createEntry)((0, $iYmop.servicedeskReportsTypeRoute), ()=>({
        group: 'servicedesk',
        component: (0, $6Hx2y.default),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $IT9I6.getReportsWithKbResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('rrr_for_context_panel_data'), (0, $lAGdd.aiContextPanelResource))
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6Hx2y.LazyServicedeskReports)
        ]
    }));

});
parcelRegister("iYmop", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsTypeRoute", () => $48dd2701ffbb9a85$export$b955ac7f09c5dbb);
const $48dd2701ffbb9a85$export$b955ac7f09c5dbb = {
    name: 'servicedesk-reports-type',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportType/:reportId?/:reportsAction?/:timescaleId?/:issueKey?',
    query: [
        'oldIssueView?'
    ]
};

});

parcelRegister("6Hx2y", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReports", () => $7131a1cafe24fb0a$export$75e043cf7a4e3661);
$parcel$export(module.exports, "default", () => $7131a1cafe24fb0a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $7131a1cafe24fb0a$export$75e043cf7a4e3661 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("4Dntm")), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports/src/index.tsx"
});
var /**
 * Dynamically loads the ServicedeskReports component, enhancing user experience by using deferred loading with a visual feedback.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$7131a1cafe24fb0a$export$2e2bcd8739ae039 = ({ match: match })=>{
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7131a1cafe24fb0a$export$75e043cf7a4e3661,
        pageId: `spa-apps/servicedesk/reports/${match ? match.url : ''}${oldIssueView}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("4Dntm", function(module, exports) {

let $35fd0317dad8b137$var$load = (parcelRequire("28QjX"))(4);
module.exports = $35fd0317dad8b137$var$load("lssra").then(()=>parcelRequire('dp6PR'));

});



parcelRegister("4zSYf", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsWorkloadRouteEntry", () => $6d0123422454b447$export$793ba749f18b4dd4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $f55k4 = parcelRequire("f55k4");

var $6Z2mh = parcelRequire("6Z2mh");

var $iYH8s = parcelRequire("iYH8s");
const $6d0123422454b447$export$793ba749f18b4dd4 = (0, $7NszV.createEntry)((0, $f55k4.servicedeskReportsWorkloadRoute), ()=>({
        group: 'servicedesk',
        component: (0, $iYH8s.default),
        perfMetricKey: 'service-management.reports.workload',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $iYH8s.LazyServicedeskReportsWorkload)
        ]
    }));

});
parcelRegister("f55k4", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsWorkloadRoute", () => $339f526b78d38fe7$export$ce9b409ccf53e93c);
const $339f526b78d38fe7$export$ce9b409ccf53e93c = {
    name: 'servicedesk-reports-workload',
    path: '/jira/servicedesk/projects/:projectKey/reports/workload',
    exact: true
};

});

parcelRegister("iYH8s", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsWorkload", () => $d985dd949edfaeac$export$e805fb47fdcd991);
$parcel$export(module.exports, "default", () => $d985dd949edfaeac$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");


const $d985dd949edfaeac$export$e805fb47fdcd991 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6Ti8Q"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-workload/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d985dd949edfaeac$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d985dd949edfaeac$export$e805fb47fdcd991,
        pageId: `spa-apps/servicedesk${(0, $d37b1fd9e7afc201$export$ddc580d759168f88)}}`,
        shouldShowSpinner: true
    });

});
parcelRegister("6Ti8Q", function(module, exports) {

let $5045f3a925636f98$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5045f3a925636f98$var$load("gZXlE").then(()=>parcelRequire('bQ0Tt'));

});



parcelRegister("j175z", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceDetailsRouteEntry", () => $9ea7b1d46a5382bf$export$48af7c0b8f21929b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $fPesd = parcelRequire("fPesd");

var $6Z2mh = parcelRequire("6Z2mh");

var $eGEo2 = parcelRequire("eGEo2");
const $9ea7b1d46a5382bf$export$48af7c0b8f21929b = (0, $7NszV.createEntry)((0, $fPesd.servicedeskServiceDetailsRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.service-details',
        component: (0, $eGEo2.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eGEo2.LazyServicedeskServiceDetailsWithProjectContext)
        ]
    }));

});
parcelRegister("fPesd", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceDetailsRoute", () => $338c1e6694a650ce$export$fe5fe00b6d5eab87);
const $338c1e6694a650ce$export$fe5fe00b6d5eab87 = {
    name: 'servicedesk-service-details',
    path: '/jira/servicedesk/projects/:projectKey/services/:serviceAri'
};

});

parcelRegister("eGEo2", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskServiceDetailsWithProjectContext", () => $b6f27b3727e127d8$export$b154597f29589502);
$parcel$export(module.exports, "default", () => $b6f27b3727e127d8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $b6f27b3727e127d8$export$b154597f29589502 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("0Ih9I"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-details-with-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b6f27b3727e127d8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b6f27b3727e127d8$export$b154597f29589502,
        pageId: "spa-apps/servicedesk/service-details",
        shouldShowSpinner: true
    });

});
parcelRegister("0Ih9I", function(module, exports) {

let $0022586f543f8e02$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0022586f543f8e02$var$load("dsiAd"),
    $0022586f543f8e02$var$load("gwvLC")
]).then(()=>parcelRequire('cIaZn'));

});



parcelRegister("gQWOR", function(module, exports) {

$parcel$export(module.exports, "serviceDeskServiceDetailsWithoutProjectRouteEntry", () => $90fd21cadf51bf65$export$de2e645f69483ce);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $kew7L = parcelRequire("kew7L");

var $3jBnk = parcelRequire("3jBnk");
const $90fd21cadf51bf65$export$de2e645f69483ce = (0, $7NszV.createEntry)((0, $kew7L.serviceDeskServiceDetailsWithoutProjectRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.service-details-without-project',
        component: (0, $3jBnk.default),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3jBnk.LazyServicedeskServiceDetailsWithoutProjectContext)
        ],
        meta: {
            reporting: {
                id: 'servicedesk-service-details-without-project',
                packageName: 'jiraSpaAppsServicedeskServiceDetailsWithoutProjectContext"',
                teamName: 'Falcons'
            }
        }
    }));

});
parcelRegister("kew7L", function(module, exports) {

$parcel$export(module.exports, "serviceDeskServiceDetailsWithoutProjectRoute", () => $35fa5222e37aa796$export$25e1d58db18a7c8b);
const $35fa5222e37aa796$export$25e1d58db18a7c8b = {
    name: 'servicedesk-service-details-without-project',
    path: '/jira/servicedesk/services/:serviceAri'
};

});

parcelRegister("3jBnk", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskServiceDetailsWithoutProjectContext", () => $0bd916f0e88ab362$export$ba1931edde0ce20c);
$parcel$export(module.exports, "default", () => $0bd916f0e88ab362$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $0bd916f0e88ab362$export$ba1931edde0ce20c = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8gO5a"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-details-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0bd916f0e88ab362$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0bd916f0e88ab362$export$ba1931edde0ce20c,
        pageId: "spa-apps/servicedesk/service-details",
        shouldShowSpinner: true
    });

});
parcelRegister("8gO5a", function(module, exports) {

let $6056aaa45e265430$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6056aaa45e265430$var$load("dsiAd"),
    $6056aaa45e265430$var$load("kRkzv")
]).then(()=>parcelRequire('bWPI8'));

});



parcelRegister("zaQdk", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceModalEditRouteEntry", () => $92695f6b0e89b9c4$export$5698449b623d4af);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $hxTrJ = parcelRequire("hxTrJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $3URFK = parcelRequire("3URFK");
const $92695f6b0e89b9c4$export$5698449b623d4af = (0, $7NszV.createEntry)((0, $hxTrJ.servicedeskServiceModalEditRoute), ()=>({
        group: 'servicedesk',
        component: (0, $3URFK.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3URFK.LazyServiceUpdateModalWithProjectContext)
        ]
    }));

});
parcelRegister("hxTrJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceModalEditRoute", () => $6a799f5afeb5f72a$export$319fbbab5eb49cbf);
const $6a799f5afeb5f72a$export$319fbbab5eb49cbf = {
    name: 'servicedesk-service-modal-edit',
    path: '/jira/servicedesk/service-modal/:serviceAri'
};

});

parcelRegister("3URFK", function(module, exports) {

$parcel$export(module.exports, "LazyServiceUpdateModalWithProjectContext", () => $ca64a28173fa79b9$export$8984aadca7e15d1);
$parcel$export(module.exports, "default", () => $ca64a28173fa79b9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $ca64a28173fa79b9$export$8984aadca7e15d1 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("lDOCW")), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-update-modal-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ca64a28173fa79b9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ca64a28173fa79b9$export$8984aadca7e15d1,
        pageId: "spa-apps/servicedesk/service-update-modal",
        shouldShowSpinner: true
    });

});
parcelRegister("lDOCW", function(module, exports) {

let $fc1482f54178d535$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc1482f54178d535$var$load("6Zzbw").then(()=>parcelRequire('9LJAj'));

});



parcelRegister("4UU5H", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceModalNewRouteEntry", () => $42345241d55d66da$export$75c24699abe8e616);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $ch9Xu = parcelRequire("ch9Xu");

var $6Z2mh = parcelRequire("6Z2mh");

var $cUmrA = parcelRequire("cUmrA");
const $42345241d55d66da$export$75c24699abe8e616 = (0, $7NszV.createEntry)((0, $ch9Xu.servicedeskServiceModalNewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $cUmrA.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cUmrA.LazyServiceCreateModalWithProjectContext)
        ]
    }));

});
parcelRegister("ch9Xu", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceModalNewRoute", () => $feeac99aa6e6a420$export$5b5ea97286af2784);
const $feeac99aa6e6a420$export$5b5ea97286af2784 = {
    name: 'servicedesk-service-modal-new',
    path: '/jira/servicedesk/service-modal',
    exact: true
};

});

parcelRegister("cUmrA", function(module, exports) {

$parcel$export(module.exports, "LazyServiceCreateModalWithProjectContext", () => $cd397b20b9604e50$export$7f4092c8e7b7d3ec);
$parcel$export(module.exports, "default", () => $cd397b20b9604e50$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $cd397b20b9604e50$export$7f4092c8e7b7d3ec = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("ekzl3")), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-create-modal-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cd397b20b9604e50$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cd397b20b9604e50$export$7f4092c8e7b7d3ec,
        pageId: "spa-apps/servicedesk/service-create-modal",
        shouldShowSpinner: true
    });

});
parcelRegister("ekzl3", function(module, exports) {

let $a6ee586fd4989933$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a6ee586fd4989933$var$load("biuin").then(()=>parcelRequire('jBLt3'));

});



parcelRegister("izdjx", function(module, exports) {

$parcel$export(module.exports, "servicedeskServicesRouteEntry", () => $2498bd7e181dd343$export$5df203501090bc7f);

var $ffza4 = parcelRequire("ffza4");

var $1cxvE = parcelRequire("1cxvE");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $dePjO = parcelRequire("dePjO");

var $6Z2mh = parcelRequire("6Z2mh");

var $gLrf3 = parcelRequire("gLrf3");
const $2498bd7e181dd343$export$5df203501090bc7f = (0, $7NszV.createEntry)((0, $dePjO.servicedeskServicesRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.services',
        component: (0, $gLrf3.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $1cxvE.AsyncJSMOperationsHorizontalNav),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1cxvE.LazyJSMOperationsHorizontalNav),
            (0, $gLrf3.LazyServicedeskServicesWithProjectContext)
        ]
    }));

});
parcelRegister("dePjO", function(module, exports) {

$parcel$export(module.exports, "servicedeskServicesRoute", () => $93e32423b61f9abd$export$4a800381bda6d53c);
const $93e32423b61f9abd$export$4a800381bda6d53c = {
    name: 'servicedesk-services',
    path: '/jira/servicedesk/projects/:projectKey/services',
    exact: true
};

});

parcelRegister("gLrf3", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskServicesWithProjectContext", () => $6f003aeaf484cf06$export$4aa60213b3477cf6);
$parcel$export(module.exports, "default", () => $6f003aeaf484cf06$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $6f003aeaf484cf06$export$4aa60213b3477cf6 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("kdDQk")), {
    moduleId: "./src/packages/spa-apps/servicedesk/services-with-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6f003aeaf484cf06$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6f003aeaf484cf06$export$4aa60213b3477cf6,
        pageId: "spa-apps/servicedesk/services",
        shouldShowSpinner: true
    });

});
parcelRegister("kdDQk", function(module, exports) {

let $eb83ed8e36f3a306$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eb83ed8e36f3a306$var$load("2tGNS").then(()=>parcelRequire('6MNnt'));

});



parcelRegister("eWSeK", function(module, exports) {

$parcel$export(module.exports, "serviceDeskServicesWithoutProjectRouteEntry", () => $48a572bbef08816c$export$7031f96c25be5e14);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $ddcmX = parcelRequire("ddcmX");

var $7zD3e = parcelRequire("7zD3e");
const $48a572bbef08816c$export$7031f96c25be5e14 = (0, $7NszV.createEntry)((0, $ddcmX.serviceDeskServicesWithoutProjectRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.services-without-project',
        component: (0, $7zD3e.default),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7zD3e.LazyServicedeskServicesWithoutProjectContext)
        ],
        meta: {
            reporting: {
                id: 'servicedesk-services-without-project',
                packageName: 'jiraSpaAppsServicedeskServicesWithoutProjectContext"',
                teamName: 'Falcons'
            }
        }
    }));

});
parcelRegister("ddcmX", function(module, exports) {

$parcel$export(module.exports, "serviceDeskServicesWithoutProjectRoute", () => $1c8a671593efdd17$export$3210e7c54c21be97);
const $1c8a671593efdd17$export$3210e7c54c21be97 = {
    name: 'servicedesk-services-without-project',
    path: '/jira/servicedesk/services',
    exact: true
};

});

parcelRegister("7zD3e", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskServicesWithoutProjectContext", () => $be661d3f8fec3b0f$export$fc385e1392a8e28);
$parcel$export(module.exports, "default", () => $be661d3f8fec3b0f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $be661d3f8fec3b0f$export$fc385e1392a8e28 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("cX7Tr")), {
    moduleId: "./src/packages/spa-apps/servicedesk/services-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$be661d3f8fec3b0f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $be661d3f8fec3b0f$export$fc385e1392a8e28,
        pageId: "spa-apps/servicedesk/services",
        shouldShowSpinner: true
    });

});
parcelRegister("cX7Tr", function(module, exports) {

let $96e11e2b11ad2340$var$load = (parcelRequire("28QjX"))(4);
module.exports = $96e11e2b11ad2340$var$load("hAezd").then(()=>parcelRequire('1QgiZ'));

});



parcelRegister("16Svt", function(module, exports) {

$parcel$export(module.exports, "settingsAutomationRouteEntry", () => $2c9e65dfb42014f0$export$4df9f9dcaf8565c9);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $ii08q = parcelRequire("ii08q");

var $5pSYQ = parcelRequire("5pSYQ");

var $fMK33 = parcelRequire("fMK33");
const $2c9e65dfb42014f0$export$4df9f9dcaf8565c9 = (0, $7NszV.createEntry)((0, $ii08q.settingsAutomationRoute), ()=>({
        group: 'global-settings',
        component: (0, $fMK33.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fMK33.LazyGlobalAutomation)
        ]
    }));

});
parcelRegister("ii08q", function(module, exports) {

$parcel$export(module.exports, "settingsAutomationRoute", () => $21b53826ac35bfbd$export$b314ab31b2da625b);
const $21b53826ac35bfbd$export$b314ab31b2da625b = {
    name: 'global-automation',
    path: '/jira/settings/automation',
    exact: true
};

});

parcelRegister("fMK33", function(module, exports) {

$parcel$export(module.exports, "LazyGlobalAutomation", () => $e4cf560ebe587071$export$4189991a2992b828);
$parcel$export(module.exports, "default", () => $e4cf560ebe587071$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aZsz6 = parcelRequire("aZsz6");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $i9k4m = parcelRequire("i9k4m");

const $e4cf560ebe587071$export$4189991a2992b828 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gmYwF"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/automation/src/index.tsx"
});
const $e4cf560ebe587071$export$7c85ddcd4f0a813f = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $aZsz6.qs).stringify(rest, true);
        return `/automation${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i9k4m.RedirectToProjectType), {
        page: page
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e4cf560ebe587071$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e4cf560ebe587071$export$4189991a2992b828,
        pageId: "global-automation",
        shouldShowSpinner: false
    });

});
parcelRegister("i9k4m", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $5f4113c49e08a927$export$8a3df560509448b8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $dxCvy = parcelRequire("dxCvy");

var $bVDE5 = parcelRequire("bVDE5");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");
const $5f4113c49e08a927$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $7tQej.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $bngFq.useAnalyticsEvents), useResource: useResource = (0, $2YP9W.useResource), useRouter: useRouter = (0, $doZTA.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $bVDE5.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $dxCvy.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
    (0, $5uXOq.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $2vSU6.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $2vSU6.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});

parcelRegister("gmYwF", function(module, exports) {

let $beada69296dc2508$var$load = (parcelRequire("28QjX"))(4);
module.exports = $beada69296dc2508$var$load("bCJgs").then(()=>parcelRequire('b0ztm'));

});



parcelRegister("7m5aN", function(module, exports) {

$parcel$export(module.exports, "settingsCmdbFieldConfigRouteEntry", () => $89fe0e9a025a7c8e$export$c68a412f25295511);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $kAymX = parcelRequire("kAymX");

var $gRzZD = parcelRequire("gRzZD");

var $5Td0i = parcelRequire("5Td0i");
const $89fe0e9a025a7c8e$export$c68a412f25295511 = (0, $7NszV.createEntry)((0, $kAymX.settingsCmdbFieldConfigRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.cmdb-field-config',
        component: (0, $5Td0i.AsyncCmdbFieldConfigPage),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $gRzZD.workspaceResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5Td0i.LazyCMDBFieldConfigAdmin)
        ]
    }));

});
parcelRegister("kAymX", function(module, exports) {

$parcel$export(module.exports, "settingsCmdbFieldConfigRoute", () => $db5ba62dbec4de6f$export$5097bfaa68f86ca6);
const $db5ba62dbec4de6f$export$5097bfaa68f86ca6 = {
    name: 'global-settings-issues-cmdb-field-config',
    path: '/secure/admin/CmdbObjectFieldConfiguration'
};

});

parcelRegister("5Td0i", function(module, exports) {

$parcel$export(module.exports, "LazyCMDBFieldConfigAdmin", () => $03d0290def261ead$export$ccc6da5137e23637);
$parcel$export(module.exports, "AsyncCmdbFieldConfigPage", () => $03d0290def261ead$export$8dfbe255f554ebab);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $03d0290def261ead$export$ccc6da5137e23637 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("h6q9r"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/cmdb-field-config/src/index.tsx"
});
const $03d0290def261ead$export$8dfbe255f554ebab = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $03d0290def261ead$export$ccc6da5137e23637,
        pageId: "admin-pages-cmdb-field-config",
        shouldShowSpinner: true
    });

});
parcelRegister("h6q9r", function(module, exports) {

let $c73748543880309a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c73748543880309a$var$load("HYkbB").then(()=>parcelRequire('gXCe1'));

});



parcelRegister("kDimk", function(module, exports) {

$parcel$export(module.exports, "settingsOauthCredentialsRouteEntry", () => $360b9bb3a5e4b35a$export$d1c67ceb7c5e2d6a);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $7NszV = parcelRequire("7NszV");

var $ldGiq = parcelRequire("ldGiq");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $9Z37w = parcelRequire("9Z37w");

var $jTwes = parcelRequire("jTwes");
const $360b9bb3a5e4b35a$export$d1c67ceb7c5e2d6a = (0, $7NszV.createEntry)((0, $9Z37w.settingsOauthCredentialsRoute), ()=>({
        group: 'global-settings',
        component: (0, $jTwes.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $iHiHz.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $ldGiq.adminOauthCredentialsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jTwes.LazyOAuthCredentialsAdmin)
        ],
        ufoName: 'admin.oauth-credentials'
    }));

});
parcelRegister("ldGiq", function(module, exports) {

$parcel$export(module.exports, "adminOauthCredentialsResource", () => $b7e65fd0b40325af$export$870d7919c1ca4482);

var $2M1hQ = parcelRequire("2M1hQ");
const $b7e65fd0b40325af$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS = 'ADMIN_OAUTH_CREDENTIALS';

const $b7e65fd0b40325af$export$870d7919c1ca4482 = (0, $2M1hQ.createResource)({
    type: $b7e65fd0b40325af$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("dSeZw"))
});

});
parcelRegister("dSeZw", function(module, exports) {

let $a19bf27b38f17605$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a19bf27b38f17605$var$load("gaQPp").then(()=>parcelRequire('8EYbC'));

});


parcelRegister("9Z37w", function(module, exports) {

$parcel$export(module.exports, "settingsOauthCredentialsRoute", () => $79dbadc9937eefab$export$c0ee28def7ef8783);
const $79dbadc9937eefab$export$c0ee28def7ef8783 = {
    name: 'admin-oauth-credentials',
    path: '/secure/admin/oauth-credentials'
};

});

parcelRegister("jTwes", function(module, exports) {

$parcel$export(module.exports, "LazyOAuthCredentialsAdmin", () => $a25b27e0ebd790aa$export$101baa25055633e8);
$parcel$export(module.exports, "default", () => $a25b27e0ebd790aa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $a25b27e0ebd790aa$export$101baa25055633e8 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gUPw0"))), {
    moduleId: "./src/packages/spa-apps/admin-oauth-credentials/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a25b27e0ebd790aa$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a25b27e0ebd790aa$export$101baa25055633e8,
        pageId: "admin-oauth-credentials",
        shouldShowSpinner: true
    });

});
parcelRegister("gUPw0", function(module, exports) {

let $c509d627c638d21a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c509d627c638d21a$var$load("1cBTL").then(()=>parcelRequire('imW3j'));

});



parcelRegister("fQCGk", function(module, exports) {

$parcel$export(module.exports, "softwareBacklogEmbedRouteEntry", () => $bec4451dd2be6ad0$export$7cd14dee22609378);


var $4R6GH = parcelRequire("4R6GH");

var $fKmub = parcelRequire("fKmub");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $bAB30 = parcelRequire("bAB30");

var $9SRRO = parcelRequire("9SRRO");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $2Ql51 = parcelRequire("2Ql51");

var $78yv1 = parcelRequire("78yv1");

var $hKGEW = parcelRequire("hKGEW");
const $bec4451dd2be6ad0$export$7cd14dee22609378 = (0, $7NszV.createEntry)((0, $78yv1.softwareBacklogEmbedRoute), ()=>({
        group: 'software',
        component: (0, $hKGEW.BacklogPage),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-backlog'),
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bAB30.backlogResource),
            (0, $9SRRO.customFiltersResource),
            (0, $5bkvv.forgeBacklogModuleResource),
            (0, $5bkvv.forgeSprintModuleResource),
            (0, $2Ql51.themePreferenceResource)
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $hKGEW.LazyBacklogPage)
        ],
        ufoName: 'next-gen-backlog-embed',
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$c17f34c425972af1)
        }
    }));

});
parcelRegister("bAB30", function(module, exports) {

$parcel$export(module.exports, "backlogResource", () => $d3029439c7d3b0b0$export$31d171ba71468137);

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");


const $d3029439c7d3b0b0$export$31d171ba71468137 = (0, $gNStA.browserOnlyResourceWithCondition)(()=>false, (0, $2M1hQ.createResource)({
    type: (0, $fe839261f35d1611$export$a0ef589381533a7c),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("fjZR2")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000
}));

});
const $fe839261f35d1611$export$faa68b3df5415bcb = 'NEXTGEN_BACKLOG_CUSTOM_FILTERS';
const $fe839261f35d1611$export$a0ef589381533a7c = 'NEXTGEN_BACKLOG';

parcelRegister("fjZR2", function(module, exports) {

let $b2789c5e99dfe604$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b2789c5e99dfe604$var$load("k5lf7").then(()=>parcelRequire('lq5RB'));

});


parcelRegister("9SRRO", function(module, exports) {

$parcel$export(module.exports, "customFiltersResource", () => $87093d7252240507$export$3e390340716755de);

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $aYacW = parcelRequire("aYacW");

var $gNStA = parcelRequire("gNStA");

const $87093d7252240507$export$3e390340716755de = (0, $gNStA.browserOnlyResourceWithCondition)(()=>false, (0, $ao2h1.createRelayResource)({
    type: (0, $fe839261f35d1611$export$faa68b3df5415bcb),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $aYacW.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    captureErrors: true
}));

});
parcelRegister("aYacW", function(module, exports) {

$parcel$export(module.exports, "default", () => $16318ecaa49178e6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<066895e3c0e872466470887b4350609b>>
 * @relayHash 8bb4d5e3e502ca70e90f4e1bb2f1614f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 494a9992c544e6be8f44d8b97ba70f29edc0d248b0153079b00cda817f4f7082
const $16318ecaa49178e6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewBacklogCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "customFilter_softwareFilters_CustomFilterRelay"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewBacklogCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "494a9992c544e6be8f44d8b97ba70f29edc0d248b0153079b00cda817f4f7082",
            "metadata": {},
            "name": "viewBacklogCustomFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$16318ecaa49178e6$var$node.hash = "071c255f9696fe84a9c3982d42cfa5c0";
var $16318ecaa49178e6$export$2e2bcd8739ae039 = $16318ecaa49178e6$var$node;

});


parcelRegister("78yv1", function(module, exports) {

$parcel$export(module.exports, "softwareBacklogEmbedRoute", () => $58a7d1c6d58c26bf$export$bc022a39c42aba2f);
const $58a7d1c6d58c26bf$export$bc022a39c42aba2f = {
    name: 'software-backlog-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/backlog/embed',
    exact: true
};

});

parcelRegister("hKGEW", function(module, exports) {

$parcel$export(module.exports, "LazyBacklogPage", () => $6275b1ced1324b76$export$edb4b8cf67d7d767);
$parcel$export(module.exports, "BacklogPage", () => $6275b1ced1324b76$export$471ffbe87b75af04);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $d3645 = parcelRequire("d3645");

const $6275b1ced1324b76$export$edb4b8cf67d7d767 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("azeQh"))), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});
const $6275b1ced1324b76$export$471ffbe87b75af04 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6275b1ced1324b76$export$edb4b8cf67d7d767,
        pageId: `next-gen-backlog-${(0, $d3645.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("d3645", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $8f60ec15db3f7d28$export$557c2f222778cea6);

var $ebyGx = parcelRequire("ebyGx");
const $8f60ec15db3f7d28$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search);
    return rapidView;
};

});

parcelRegister("azeQh", function(module, exports) {

let $7b18afa2b2fd2bca$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7b18afa2b2fd2bca$var$load("h2MrD"),
    $7b18afa2b2fd2bca$var$load("bYT2S"),
    $7b18afa2b2fd2bca$var$load("cM9em"),
    $7b18afa2b2fd2bca$var$load("fr9NE"),
    $7b18afa2b2fd2bca$var$load("hPzOn"),
    $7b18afa2b2fd2bca$var$load("1QTgA")
]).then(()=>parcelRequire('1Xeln'));

});



parcelRegister("1EVpW", function(module, exports) {

$parcel$export(module.exports, "softwareBacklogRouteEntry", () => $73cbd5374edd4b4f$export$a5f8ba02d2755510);

var $ffza4 = parcelRequire("ffza4");


var $4R6GH = parcelRequire("4R6GH");

var $5f2bR = parcelRequire("5f2bR");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $bAB30 = parcelRequire("bAB30");

var $9SRRO = parcelRequire("9SRRO");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $fTg4y = parcelRequire("fTg4y");

var $i8JTM = parcelRequire("i8JTM");

var $e7bC3 = parcelRequire("e7bC3");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $hKGEW = parcelRequire("hKGEW");

var $6ypBw = parcelRequire("6ypBw");
/**
 * @deprecated delete when cleaning up fun-1606-migrate-software-backlog-to-entrypoint
 */ const $73cbd5374edd4b4f$var$getHorizontalNavResources = ()=>(0, $4R6GH.fg)('fun-1606-migrate-software-backlog-to-entrypoint') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $73cbd5374edd4b4f$export$a5f8ba02d2755510 = (0, $7NszV.createEntry)((0, $fTg4y.softwareBacklogRoute), ()=>({
        group: 'software',
        component: (0, $hKGEW.BacklogPage),
        skeleton: (0, $i8JTM.NextGenBacklogSkeleton),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-backlog'),
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3Only),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResourceOnNav3Only),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
            ...$73cbd5374edd4b4f$var$getHorizontalNavResources(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bAB30.backlogResource),
            (0, $9SRRO.customFiltersResource),
            (0, $5bkvv.forgeBacklogModuleResource),
            (0, $5bkvv.forgeSprintModuleResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        preloadOptions: {
            earlyChunks: [
                'software-backlog-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: (0, $4R6GH.fg)('fun-1606-migrate-software-backlog-to-entrypoint') ? undefined : [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hKGEW.LazyBacklogPage)
        ],
        ufoName: 'next-gen-backlog',
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$c17f34c425972af1)
        },
        entryPoint: ()=>(0, $4R6GH.fg)('fun-1606-migrate-software-backlog-to-entrypoint') ? (0, $6ypBw.backlogPageEntrypoint) : undefined
    }));

});
parcelRegister("fTg4y", function(module, exports) {

$parcel$export(module.exports, "softwareBacklogRoute", () => $bb895b75440d1fb3$export$fb454ec14936c0ab);
const $bb895b75440d1fb3$export$fb454ec14936c0ab = {
    name: 'software-backlog',
    path: '/jira/software/projects/:projectKey/boards/:boardId/backlog'
};

});

parcelRegister("i8JTM", function(module, exports) {

$parcel$export(module.exports, "NextGenBacklogSkeleton", () => $de21fa38a510bb6d$export$33cd465913cf178f);
/* NextGenBacklogSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $hCy6k = parcelRequire("hCy6k");

var $bOdHA = parcelRequire("bOdHA");
const $de21fa38a510bb6d$export$433c2e8574f2e911 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bOdHA)))
    });
const $de21fa38a510bb6d$export$88189b56881f213e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de21fa38a510bb6d$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bOdHA)))
    }));
const $de21fa38a510bb6d$export$33cd465913cf178f = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $de21fa38a510bb6d$export$88189b56881f213e, $de21fa38a510bb6d$export$433c2e8574f2e911);
// Adding this wrapper to override the border width from AppSkeletonImage
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $de21fa38a510bb6d$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bOdHA", function(module, exports) {
module.exports = new URL("next-gen-backlog-app-skeleton.tpl.28e29051.svg", import.meta.url).toString();

});


parcelRegister("6ypBw", function(module, exports) {

$parcel$export(module.exports, "backlogPageEntrypoint", () => $095a4b5c220745ce$export$1ccf08591607897d);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $fT58V = parcelRequire("fT58V");

var $krpZe = parcelRequire("krpZe");

var $6avBT = parcelRequire("6avBT");
const $095a4b5c220745ce$export$1ccf08591607897d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6avBT.nextGenBacklogEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $krpZe.nav4ProjectsContentEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("6avBT", function(module, exports) {

$parcel$export(module.exports, "nextGenBacklogEntryPoint", () => $bb040829e080170c$export$377b23d5a7dc4052);

var $cfawy = parcelRequire("cfawy");

var $3rdd7 = parcelRequire("3rdd7");

const $bb040829e080170c$export$377b23d5a7dc4052 = (0, $3rdd7.createEntryPoint)({
    root: (0, $cfawy.JSResourceForUserVisible)(()=>(parcelRequire("azeQh")), {
        moduleId: "20e1173f"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});



parcelRegister("azyVo", function(module, exports) {

$parcel$export(module.exports, "softwareBoardEmbedRouteEntry", () => $8db4a1001ea28148$export$ff8632c8a0f5d984);


var $4R6GH = parcelRequire("4R6GH");

var $fKmub = parcelRequire("fKmub");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $5qQ9I = parcelRequire("5qQ9I");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $2Ql51 = parcelRequire("2Ql51");

var $eeXsz = parcelRequire("eeXsz");

var $4IqZT = parcelRequire("4IqZT");

var $aRjc0 = parcelRequire("aRjc0");

var $2QA6X = parcelRequire("2QA6X");

var $eCjie = parcelRequire("eCjie");

var $itbWq = parcelRequire("itbWq");
const $8db4a1001ea28148$export$ff8632c8a0f5d984 = (0, $7NszV.createEntry)((0, $eeXsz.softwareBoardEmbedRoute), ()=>({
        group: 'software',
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-board'),
        component: (0, $eCjie.SoftwareBoardComponent),
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $4IqZT.conditionalBoardNBTOptInResource),
            (0, $2QA6X.conditionalBoardResource),
            (0, $aRjc0.conditionalBoardRelayResource),
            (0, $5qQ9I.boardFilterRefinementResource),
            (0, $itbWq.conditionalCustomFiltersResource),
            (0, $2Ql51.themePreferenceResource),
            (0, $5bkvv.forgeBoardModuleResource)
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $eCjie.LazyBoardPage)
        ],
        ufoName: 'next-gen-board-embed',
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$f364828958cffad0)
        }
    }));

});
parcelRegister("5qQ9I", function(module, exports) {

$parcel$export(module.exports, "boardResource", () => $21d99b29ea940c83$export$286b76e0f2661cfb);
$parcel$export(module.exports, "customFiltersResource", () => $21d99b29ea940c83$export$3e390340716755de);
$parcel$export(module.exports, "boardFilterRefinementResource", () => $21d99b29ea940c83$export$283d16e3e02421f0);
$parcel$export(module.exports, "boardRelayResource", () => $21d99b29ea940c83$export$81ac23db76b1f935);
// eslint-disable-next-line jira/import-whitelist -- Unclear how to change the config whilst we transition to flat config

var $6s1PB = parcelRequire("6s1PB");

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $6mTNg = parcelRequire("6mTNg");

var $9fgCw = parcelRequire("9fgCw");

var $ke2kk = parcelRequire("ke2kk");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");


const $21d99b29ea940c83$export$286b76e0f2661cfb = (0, $gNStA.browserOnlyResourceWithCondition)(()=>false, (0, $2M1hQ.createResource)({
    type: (0, $a00fc8fb83f2948a$export$a38ac7339e3f31db),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("j1RXG")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000
}));
const $21d99b29ea940c83$export$3e390340716755de = (0, $gNStA.browserOnlyResourceWithCondition)(()=>false, (0, $ao2h1.createRelayResource)({
    type: (0, $a00fc8fb83f2948a$export$b48bcc76a0105016),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $9fgCw.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));
const $21d99b29ea940c83$export$283d16e3e02421f0 = (0, $gNStA.resourceWithCondition2)(()=>(0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false), (0, $ao2h1.createRelayResource)({
    type: (0, $a00fc8fb83f2948a$export$339da8fd7fc0a8e9),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $ke2kk.default),
            variables: {
                cloudId: tenantContext.cloudId,
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                filterRefinementScope: {
                    board: {
                        boardId: Number(match.params.boardId)
                    }
                }
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isBrowserOnly: true
}));
const $21d99b29ea940c83$export$81ac23db76b1f935 = (0, $gNStA.browserOnlyResourceWithCondition)(()=>false, (0, $ao2h1.createRelayResource)({
    type: (0, $a00fc8fb83f2948a$export$5cef388780439aec),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $6mTNg.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("6mTNg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc6b6eeb5cc2255$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<916f92cb49153da25a6abe2a4d651185>>
 * @relayHash 1b45667561f9430ea4e961757485983b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67
const $ddc6b6eeb5cc2255$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67",
        "metadata": {},
        "name": "boardWithRouterRelayQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ddc6b6eeb5cc2255$export$2e2bcd8739ae039 = $ddc6b6eeb5cc2255$var$node;

});

parcelRegister("9fgCw", function(module, exports) {

$parcel$export(module.exports, "default", () => $59a4f75157ae0306$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e40c06e874adef0395c5788a7d119a9>>
 * @relayHash fa277d121f8f09e75035802d7ede6889
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b
const $59a4f75157ae0306$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b",
        "metadata": {},
        "name": "viewBoardCustomFiltersQuery",
        "operationKind": "query",
        "text": null
    }
};
var $59a4f75157ae0306$export$2e2bcd8739ae039 = $59a4f75157ae0306$var$node;

});

parcelRegister("ke2kk", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c6ecabe578696e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b2791ce93d3a0a0e17fee486ad965601>>
 * @relayHash 5c749d389bf268ee9226560ad568adcf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9283dbd6d43bd23893ba0d1fb905c533d07635b370710c93db0ea67cb8b41e06
const $32c6ecabe578696e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "9283dbd6d43bd23893ba0d1fb905c533d07635b370710c93db0ea67cb8b41e06",
        "metadata": {},
        "name": "boardFilterRefinementQuery",
        "operationKind": "query",
        "text": null
    }
};
var $32c6ecabe578696e$export$2e2bcd8739ae039 = $32c6ecabe578696e$var$node;

});

const $a00fc8fb83f2948a$export$a38ac7339e3f31db = 'NEXTGEN_BOARD';
const $a00fc8fb83f2948a$export$b48bcc76a0105016 = 'NEXTGEN_BOARD_CUSTOM_FILTERS';
const $a00fc8fb83f2948a$export$5cef388780439aec = 'NEXTGEN_BOARD_RELAY';
const $a00fc8fb83f2948a$export$339da8fd7fc0a8e9 = 'NEXTGEN_BOARD_FILTER_REFINEMENT';

parcelRegister("j1RXG", function(module, exports) {

let $dda7f7f2910d44da$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dda7f7f2910d44da$var$load("eNmuD"),
    $dda7f7f2910d44da$var$load("jxTcV")
]).then(()=>parcelRequire('11pNz'));

});


parcelRegister("eeXsz", function(module, exports) {

$parcel$export(module.exports, "softwareBoardEmbedRoute", () => $f06c20d996c477e6$export$f55626b64e3fcb4f);
const $f06c20d996c477e6$export$f55626b64e3fcb4f = {
    name: 'software-boards-embed',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId/embed'
};

});

parcelRegister("4IqZT", function(module, exports) {

$parcel$export(module.exports, "conditionalBoardNBTOptInResource", () => $e8f5fec2c725aeaf$export$3cdaa13b878c3c59);

var $b4PzF = parcelRequire("b4PzF");

var $ipmBb = parcelRequire("ipmBb");

var $gNStA = parcelRequire("gNStA");
const $e8f5fec2c725aeaf$export$3cdaa13b878c3c59 = (0, $gNStA.resourceWithCondition2)(()=>!(0, $b4PzF.isFedRamp)(), (0, $ipmBb.nextBestTaskFeatureResource));

});

parcelRegister("aRjc0", function(module, exports) {

$parcel$export(module.exports, "conditionalBoardRelayResource", () => $170e9c5fe0076e7e$export$ce009bf1a33fb264);

var $4R6GH = parcelRequire("4R6GH");

var $5qQ9I = parcelRequire("5qQ9I");

var $gNStA = parcelRequire("gNStA");
const $170e9c5fe0076e7e$export$ce009bf1a33fb264 = (0, $gNStA.resourceWithCondition)(()=>(0, $4R6GH.fg)('critical_board_query_with_relay'), (0, $5qQ9I.boardRelayResource));

});

parcelRegister("2QA6X", function(module, exports) {

$parcel$export(module.exports, "conditionalBoardResource", () => $ea9cac4f36af465b$export$2ba7dfd4089a1a57);

var $4R6GH = parcelRequire("4R6GH");

var $5qQ9I = parcelRequire("5qQ9I");

var $gNStA = parcelRequire("gNStA");
const $ea9cac4f36af465b$export$2ba7dfd4089a1a57 = (0, $gNStA.resourceWithCondition)(()=>!(0, $4R6GH.fg)('critical_board_query_with_relay'), (0, $5qQ9I.boardResource));

});

parcelRegister("itbWq", function(module, exports) {

$parcel$export(module.exports, "conditionalCustomFiltersResource", () => $1121c6a3d058cc47$export$ad9ac1bd5f72148c);

var $6s1PB = parcelRequire("6s1PB");

var $5qQ9I = parcelRequire("5qQ9I");

var $gNStA = parcelRequire("gNStA");
const $1121c6a3d058cc47$export$ad9ac1bd5f72148c = (0, $gNStA.resourceWithCondition2)(()=>!(0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false), (0, $5qQ9I.customFiltersResource));

});


parcelRegister("7wXr4", function(module, exports) {

$parcel$export(module.exports, "softwareBoardRouteEntry", () => $bc83504262104385$export$2964ea1cdd5afa39);

var $ffza4 = parcelRequire("ffza4");


var $4R6GH = parcelRequire("4R6GH");

var $5f2bR = parcelRequire("5f2bR");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $5qQ9I = parcelRequire("5qQ9I");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $7wTzh = parcelRequire("7wTzh");

var $11dfA = parcelRequire("11dfA");

var $gNStA = parcelRequire("gNStA");

var $e7bC3 = parcelRequire("e7bC3");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $4IqZT = parcelRequire("4IqZT");

var $aRjc0 = parcelRequire("aRjc0");

var $2QA6X = parcelRequire("2QA6X");

var $eCjie = parcelRequire("eCjie");

var $itbWq = parcelRequire("itbWq");
const $bc83504262104385$export$2964ea1cdd5afa39 = (0, $7NszV.createEntry)((0, $7wTzh.softwareBoardRoute), ()=>({
        group: 'software',
        component: (0, $eCjie.SoftwareBoardComponent),
        skeleton: (0, $11dfA.NextGenBoardSkeleton),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-board'),
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3Only),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResourceOnNav3Only),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $2QA6X.conditionalBoardResource),
            (0, $itbWq.conditionalCustomFiltersResource),
            (0, $5qQ9I.boardFilterRefinementResource),
            (0, $aRjc0.conditionalBoardRelayResource),
            (0, $4IqZT.conditionalBoardNBTOptInResource),
            (0, $5bkvv.forgeBoardModuleResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        preloadOptions: {
            earlyChunks: [
                'software-board-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eCjie.LazyBoardPage)
        ],
        ufoName: 'next-gen-board',
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$f364828958cffad0)
        }
    }));

});
parcelRegister("7wTzh", function(module, exports) {

$parcel$export(module.exports, "softwareBoardRoute", () => $4f781bb234c1132b$export$9ae2c0a566d4e0f6);
const $4f781bb234c1132b$export$9ae2c0a566d4e0f6 = {
    name: 'software-boards',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId'
};

});

parcelRegister("11dfA", function(module, exports) {

$parcel$export(module.exports, "NextGenBoardSkeleton", () => $b1638a290dc4da1e$export$25a9d0fbcb127c90);
/* NextGenBoardSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $d69qo = parcelRequire("d69qo");
const $b1638a290dc4da1e$var$customCssStyles = null;
const $b1638a290dc4da1e$export$25a9d0fbcb127c90 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d69qo))),
        className: (0, $bwpsq.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("d69qo", function(module, exports) {
module.exports = new URL("next-gen-board-app-skeleton.tpl.d10f8ca5.svg", import.meta.url).toString();

});



parcelRegister("kutfD", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarEmbedRouteEntry", () => $99cba918a9dd41cf$export$24fc07c22f0d06);

var $6e4Kt = parcelRequire("6e4Kt");

var $4R6GH = parcelRequire("4R6GH");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $2Ql51 = parcelRequire("2Ql51");

var $1oC4O = parcelRequire("1oC4O");

var $kZOse = parcelRequire("kZOse");

var $4p1Sa = parcelRequire("4p1Sa");
const $99cba918a9dd41cf$export$24fc07c22f0d06 = (0, $7NszV.createEntry)((0, $1oC4O.softwareCalendarEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $kZOse.CalendarEmbedSkeleton),
        component: (0, $kZOse.CalendarEmbedSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $4p1Sa.calendarRouteEntry;
        },
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $2Ql51.themePreferenceResource)
        ],
        ufoName: 'next-gen-calendar-embed',
        EXPERIMENTAL__shouldReload: (0, $4R6GH.fg)('jira_fix_calendar_suspending_when_switching_months') ? ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        } : undefined
    }));

});
parcelRegister("1oC4O", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarEmbedRoute", () => $e9efd1396eb47ddd$export$b55c4d4efb097c1c);
const $e9efd1396eb47ddd$export$b55c4d4efb097c1c = {
    name: 'software-calendar-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/embed',
    query: [
        'date?'
    ]
};

});

parcelRegister("4p1Sa", function(module, exports) {

$parcel$export(module.exports, "calendarRouteEntry", () => $a85dcaa61158a1a3$export$d154630e8966be91);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $dQ4vn = parcelRequire("dQ4vn");

var $fo6b8 = parcelRequire("fo6b8");
const $a85dcaa61158a1a3$export$d154630e8966be91 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dQ4vn.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("dQ4vn", function(module, exports) {

$parcel$export(module.exports, "calendarEntryPoint", () => $d8251bf369abb7ad$export$19cf4b398f638dc6);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7JhZX = parcelRequire("7JhZX");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");
const $d8251bf369abb7ad$var$SETTINGS_STORAGE_KEY = 'calendar:settings:software';
function $d8251bf369abb7ad$var$getViewSettings(key) {
    try {
        const serializedValue = globalThis.localStorage?.getItem(key);
        return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
    } catch  {
        return undefined;
    }
}
function $d8251bf369abb7ad$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
    return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
}
function $d8251bf369abb7ad$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $d8251bf369abb7ad$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
/* Given the current constraints that prevent importing route name constants into the entrypoint,
we are re-defining these constants here in order to perform a route name check.
Consider breaking this entrypoint per route to avoid these types of checks and dependencies. */ const $d8251bf369abb7ad$var$SOFTWARE_CALENDAR = 'software-calendar';
const $d8251bf369abb7ad$var$SOFTWARE_CALENDAR_EMBED = 'software-calendar-embed';
const $d8251bf369abb7ad$var$TEAM_MANAGED_CALENDAR_ROUTES = [
    $d8251bf369abb7ad$var$SOFTWARE_CALENDAR,
    $d8251bf369abb7ad$var$SOFTWARE_CALENDAR_EMBED
];
function $d8251bf369abb7ad$var$createScope({ context: context, tenantContext: tenantContext }) {
    const { cloudId: cloudId } = tenantContext;
    const isTMP = $d8251bf369abb7ad$var$TEAM_MANAGED_CALENDAR_ROUTES.includes(context.route.name);
    return {
        type: 'board',
        boardId: $d8251bf369abb7ad$var$toBoardAri({
            siteId: cloudId,
            boardId: String(context.match.params.boardId)
        }),
        projectKeys: isTMP ? [
            String(context.match.params.projectKey)
        ] : []
    };
}
function $d8251bf369abb7ad$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    const scopeInput = {
        ids: [
            scope.boardId
        ]
    };
    if ((0, $4R6GH.fg)('jira_calendar_load_more_pagination') || scope.projectKeys && scope.projectKeys.length > 0) return {
        ...scopeInput,
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
    return scopeInput;
}
function $d8251bf369abb7ad$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $d8251bf369abb7ad$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $d8251bf369abb7ad$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
    return {
        date: $d8251bf369abb7ad$var$toMidnightUTCString(selectedDate),
        mode: $d8251bf369abb7ad$var$toViewMode(viewRange),
        weekStart: $d8251bf369abb7ad$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField,
        viewId: null
    };
}
function $d8251bf369abb7ad$var$buildIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $d8251bf369abb7ad$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $d8251bf369abb7ad$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $d8251bf369abb7ad$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}

const $d8251bf369abb7ad$export$19cf4b398f638dc6 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("hV1sK")), {
        moduleId: "57ee20a5"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const scope = $d8251bf369abb7ad$var$createScope(entryPointRouteParams);
        const { date: date } = context.query;
        const selectedDate = $d8251bf369abb7ad$var$toDate(date);
        const boardId = String(context.match.params.boardId);
        const settings = (0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? $d8251bf369abb7ad$var$getViewSettings($d8251bf369abb7ad$var$SETTINGS_STORAGE_KEY) : undefined;
        const viewRange = 'month';
        const weekStartsOn = (0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? settings?.weekStartsOn ?? 'sunday' : 'sunday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $7JhZX.default,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $d8251bf369abb7ad$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $d8251bf369abb7ad$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField
                        }),
                        issuesPageSize: (0, $4R6GH.fg)('jira_calendar_lazy_load') ? 200 : 50,
                        issuesSearchInput: $d8251bf369abb7ad$var$buildIssuesSearchInput(),
                        unscheduledIssuesSearchInput: $d8251bf369abb7ad$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $d8251bf369abb7ad$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $d8251bf369abb7ad$var$buildSprintsSearchInput(),
                        includeRecurrenceIndicator: (0, $6s1PB.expValEquals)('jira-recur-single-work-item-on-schedule', 'isRecurrenceCalendarViewEnabled', true),
                        skipSprintSearch: false,
                        viewId: null,
                        schedulePermissionsEnabled: (0, $4R6GH.fg)('calendar_schedule_issue_permissions_check'),
                        pageLoadMoreEnabled: (0, $4R6GH.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV1Search: (0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        skipVersionsV2Search: !(0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        pageLoadMoreEnabledViewSettings: (0, $4R6GH.fg)('jira_calendar_load_more_pagination_view_settings')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                boardId: boardId,
                hasRecurrenceItemIndicator: (0, $6s1PB.expValEquals)('jira-recur-single-work-item-on-schedule', 'isRecurrenceCalendarViewEnabled', true)
            }
        };
    }
});

});
parcelRegister("hV1sK", function(module, exports) {

let $d0b8e504131993cc$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d0b8e504131993cc$var$load("h2MrD"),
    $d0b8e504131993cc$var$load("bYT2S"),
    $d0b8e504131993cc$var$load("iePIJ")
]).then(()=>parcelRequire('71XRW'));

});




parcelRegister("2z6Z2", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarRouteEntry", () => $31f17a935a7b6ad5$export$83b1b9036cc7961a);

var $ffza4 = parcelRequire("ffza4");

var $4R6GH = parcelRequire("4R6GH");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $582IH = parcelRequire("582IH");

var $kZOse = parcelRequire("kZOse");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $4p1Sa = parcelRequire("4p1Sa");
const $31f17a935a7b6ad5$export$83b1b9036cc7961a = (0, $7NszV.createEntry)((0, $582IH.softwareCalendarRoute), ()=>({
        group: 'software',
        skeleton: (0, $kZOse.CalendarSkeleton),
        component: (0, $kZOse.CalendarSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $4p1Sa.calendarRouteEntry;
        },
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        ufoName: 'next-gen-calendar',
        EXPERIMENTAL__shouldReload: (0, $4R6GH.fg)('jira_fix_calendar_suspending_when_switching_months') ? ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        } : undefined
    }));

});
parcelRegister("582IH", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarRoute", () => $8d2c5695d9358265$export$d6730f103a4ad844);
const $8d2c5695d9358265$export$d6730f103a4ad844 = {
    name: 'software-calendar',
    path: '/jira/software/projects/:projectKey/boards/:boardId/calendar',
    query: [
        'date?'
    ]
};

});


parcelRegister("jvZP3", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsNextGenRouteEntry", () => $fae05ab45ce767cc$export$7e5ccb20ad8e1612);

var $5uXOq = parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $b4koY = parcelRequire("b4koY");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $3V85G = parcelRequire("3V85G");

var $kfztd = parcelRequire("kfztd");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $5j7Th = parcelRequire("5j7Th");

var $8AiWD = parcelRequire("8AiWD");
const $fae05ab45ce767cc$var$DeploymentsNextGen = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $8AiWD.LazyDeployments),
        pageId: "deploymentsNextGen",
        shouldShowSpinner: true
    });
const $fae05ab45ce767cc$export$7e5ccb20ad8e1612 = (0, $7NszV.createEntry)((0, $3V85G.softwareDeploymentsNextGenRoute), ()=>({
        group: 'software',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), $fae05ab45ce767cc$var$DeploymentsNextGen),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $b4koY.deploymentPreconditionRelayResource),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8AiWD.LazyDeployments)
        ],
        meta: {
            reporting: {
                id: 'software-deployments',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-deployments'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("b4koY", function(module, exports) {

$parcel$export(module.exports, "deploymentPreconditionRelayResource", () => $b79457e490ba4467$export$50e4eedb9e6127c8);

var $ao2h1 = parcelRequire("ao2h1");

var $ajgeO = parcelRequire("ajgeO");

var $2M1hQ = parcelRequire("2M1hQ");


const $b79457e490ba4467$export$a1c09d7f7318f85c = (0, $2M1hQ.createResource)({
    type: (0, $c47c39dbdbc02648$export$2171160371fac588),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("9lUFD")),
    maxAge: 60000
});
const $b79457e490ba4467$export$50e4eedb9e6127c8 = (0, $ao2h1.createRelayResource)({
    type: (0, $c47c39dbdbc02648$export$a969d0487e348031),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $ajgeO.default),
            variables: {
                cloudId: tenantContext.cloudId,
                projectKey: String(match.params.projectKey)
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("ajgeO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0f41d4aeb9b6b93$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<946bfee09c64f3e6ddd3c9cbab07a461>>
 * @relayHash ea273678a5c985c0053babf0f185662a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0b497951b118068d82bb77e253f1fcb758c4dde1aa7f8eb01bf559f5961522f2
const $e0f41d4aeb9b6b93$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ],
        "kind": "ScalarField",
        "name": "deploymentsFeaturePreconditionByProjectKey"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v1 /*: any*/ ,
                                "action": "THROW",
                                "path": "jira.deploymentsFeaturePreconditionByProjectKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "0b497951b118068d82bb77e253f1fcb758c4dde1aa7f8eb01bf559f5961522f2",
            "metadata": {},
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e0f41d4aeb9b6b93$var$node.hash = "3337e3d6b76da02b643c63aacd15b239";
var $e0f41d4aeb9b6b93$export$2e2bcd8739ae039 = $e0f41d4aeb9b6b93$var$node;

});

const $c47c39dbdbc02648$export$2171160371fac588 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION';
const $c47c39dbdbc02648$export$a969d0487e348031 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION_RELAY';

parcelRegister("9lUFD", function(module, exports) {

let $6cf208cd9572b702$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6cf208cd9572b702$var$load("f0to4").then(()=>parcelRequire('96xO4'));

});


parcelRegister("3V85G", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsNextGenRoute", () => $80f4392aa55fd172$export$4b0939825a323ea5);
const $80f4392aa55fd172$export$4b0939825a323ea5 = {
    name: 'software-deployments',
    path: '/jira/software/projects/:projectKey/deployments'
};

});

parcelRegister("8AiWD", function(module, exports) {

$parcel$export(module.exports, "LazyDeployments", () => $5f12796bf78e522e$export$ed6d152d5551715c);

var $7yO8g = parcelRequire("7yO8g");

var $b7Svb = parcelRequire("b7Svb");

const $5f12796bf78e522e$export$ed6d152d5551715c = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cDTXl"))), {
    moduleId: "./src/packages/spa-apps/deployments/src/index.tsx"
});

});
parcelRegister("cDTXl", function(module, exports) {

let $934488486ef63d7d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $934488486ef63d7d$var$load("h2MrD"),
    $934488486ef63d7d$var$load("bYT2S"),
    $934488486ef63d7d$var$load("cBa2R")
]).then(()=>parcelRequire('5EQGR'));

});



parcelRegister("03taV", function(module, exports) {

$parcel$export(module.exports, "softwareFormBuilderRouteEntry", () => $21f43a00ab4a505f$export$e8dede7671fad23d);

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $3HwlS = parcelRequire("3HwlS");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $l2N2a = parcelRequire("l2N2a");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $6LsQE = parcelRequire("6LsQE");

var $hGNg4 = parcelRequire("hGNg4");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $evEd2 = parcelRequire("evEd2");

var $fo6b8 = parcelRequire("fo6b8");

var $lkFvK = parcelRequire("lkFvK");
const $21f43a00ab4a505f$var$formBuilderPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $evEd2.formBuilderEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $21f43a00ab4a505f$export$e8dede7671fad23d = (0, $7NszV.createEntry)((0, $hGNg4.softwareFormBuilderRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-builder',
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $5f2bR.AsyncHorizontalNavJira), ()=>null)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $21f43a00ab4a505f$var$formBuilderPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("hGNg4", function(module, exports) {

$parcel$export(module.exports, "softwareFormBuilderRoute", () => $2ce33b6906a0aad5$export$c5589046ee2a390d);
const $2ce33b6906a0aad5$export$c5589046ee2a390d = {
    name: 'software-form-builder',
    path: '/jira/software/projects/:projectKey/form/:formId/builder',
    exact: true
};

});

parcelRegister("evEd2", function(module, exports) {

$parcel$export(module.exports, "formBuilderEntrypoint", () => $169d3b5f1d6377cd$export$6d3c9fa7232f412c);

var $kTta5 = parcelRequire("kTta5");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $169d3b5f1d6377cd$export$6d3c9fa7232f412c = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("hVAiQ")), {
        moduleId: "a7e5ed4a"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formBuilderQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $kTta5.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("kTta5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e840d497ba3b73a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cd13e4f001483f4b52003ed8bc472792>>
 * @relayHash e8f0191fa153f065f7266afab384a46c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 165f5de6118450a4d0cf4ac24900ba8099a89412eebcbf8f5dee46032eb83e21
const $0e840d497ba3b73a$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "165f5de6118450a4d0cf4ac24900ba8099a89412eebcbf8f5dee46032eb83e21",
        "metadata": {},
        "name": "src_jiraSoftwareFormBuilderQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0e840d497ba3b73a$export$2e2bcd8739ae039 = $0e840d497ba3b73a$var$node;

});

parcelRegister("hVAiQ", function(module, exports) {

let $d0d3eb8887aa7ba3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d0d3eb8887aa7ba3$var$load("kWlGu").then(()=>parcelRequire('jM2sL'));

});



parcelRegister("6KvsG", function(module, exports) {

$parcel$export(module.exports, "softwareFormRouteEntry", () => $eae74982fc8ba226$export$563e3b39911993a0);

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $3HwlS = parcelRequire("3HwlS");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $l2N2a = parcelRequire("l2N2a");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $6LsQE = parcelRequire("6LsQE");

var $4kqDP = parcelRequire("4kqDP");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $eeYjL = parcelRequire("eeYjL");

var $fo6b8 = parcelRequire("fo6b8");

var $lkFvK = parcelRequire("lkFvK");
const $eae74982fc8ba226$var$formPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $eeYjL.formEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $eae74982fc8ba226$export$563e3b39911993a0 = (0, $7NszV.createEntry)((0, $4kqDP.softwareFormRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form',
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $5f2bR.AsyncHorizontalNavJira), ()=>null),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $eae74982fc8ba226$var$formPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("4kqDP", function(module, exports) {

$parcel$export(module.exports, "softwareFormRoute", () => $fca3b9cc3ce6bbb8$export$a46217d369231a5);
const $fca3b9cc3ce6bbb8$export$a46217d369231a5 = {
    name: 'software-form',
    path: '/jira/software/projects/:projectKey/form',
    exact: true
};

});

parcelRegister("eeYjL", function(module, exports) {

$parcel$export(module.exports, "formEntrypoint", () => $2a299b0a5731b934$export$b931eb60522f687a);

var $czWfL = parcelRequire("czWfL");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $2a299b0a5731b934$export$b931eb60522f687a = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("7cKEF")), {
        moduleId: "34421974"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $czWfL.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("czWfL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4080ec7d5d2fb7c3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3232935a5b9879fc4ee86b3cbc2c9c83>>
 * @relayHash 499a6633134d808842c9e8cd05fbcda0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 10cd467b6a17d91893094678f3292542a4270c9ce4e2a820600612d50bb642b5
const $4080ec7d5d2fb7c3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "10cd467b6a17d91893094678f3292542a4270c9ce4e2a820600612d50bb642b5",
        "metadata": {},
        "name": "src_jiraSoftwareFormQuery",
        "operationKind": "query",
        "text": null
    }
};
var $4080ec7d5d2fb7c3$export$2e2bcd8739ae039 = $4080ec7d5d2fb7c3$var$node;

});

parcelRegister("7cKEF", function(module, exports) {

let $53edd810b2844dbb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $53edd810b2844dbb$var$load("636Ie").then(()=>parcelRequire('jqjLM'));

});



parcelRegister("kg7GL", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitEmbedRouteEntry", () => $82aac62e73960caa$export$ac2e374edf86801f);

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $l2N2a = parcelRequire("l2N2a");

var $6LsQE = parcelRequire("6LsQE");

var $7G821 = parcelRequire("7G821");

var $4R6GH = parcelRequire("4R6GH");

var $a1Eek = parcelRequire("a1Eek");

var $lkFvK = parcelRequire("lkFvK");
const $82aac62e73960caa$var$formSubmitEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $a1Eek.formSubmitEmbedEntrypoint)
});
const $82aac62e73960caa$export$ac2e374edf86801f = (0, $7NszV.createEntry)((0, $7G821.softwareFormSubmitEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-submit-embed',
        layout: (0, $6e4Kt.chromelessLayout),
        // eslint-disable-next-line camelcase
        resources: [
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return (0, $4R6GH.fg)('jsw_forms_embed') ? $82aac62e73960caa$var$formSubmitEmbedPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("7G821", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitEmbedRoute", () => $fae57e01e4ce41f8$export$2bee26f083dc2946);
const $fae57e01e4ce41f8$export$2bee26f083dc2946 = {
    name: 'software-form-submit-embed',
    path: '/jira/software/projects/:projectKey/form/:formId/embed',
    exact: true
};

});

parcelRegister("a1Eek", function(module, exports) {

$parcel$export(module.exports, "formSubmitEmbedEntrypoint", () => $8db17a4483c62517$export$4c748d8ca82fc24);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $8db17a4483c62517$export$4c748d8ca82fc24 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("3hLcq")), {
        moduleId: "d6417f2e"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3hLcq", function(module, exports) {

let $2647926e5d4021e9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2647926e5d4021e9$var$load("9kKye").then(()=>parcelRequire('91Ac2'));

});



parcelRegister("i0tax", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitRouteEntry", () => $b1634ae98fc90f0b$export$752724866670c36);

var $6e4Kt = parcelRequire("6e4Kt");

var $6s1PB = parcelRequire("6s1PB");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $l2N2a = parcelRequire("l2N2a");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $6LsQE = parcelRequire("6LsQE");

var $lHSmT = parcelRequire("lHSmT");

var $6FnT3 = parcelRequire("6FnT3");

var $lkFvK = parcelRequire("lkFvK");
const $b1634ae98fc90f0b$var$formSubmitPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6FnT3.formSubmitEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $b1634ae98fc90f0b$export$752724866670c36 = (0, $7NszV.createEntry)((0, $lHSmT.softwareFormSubmitRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-submit',
        layout: (0, $6e4Kt.chromelessLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $b1634ae98fc90f0b$var$formSubmitPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("lHSmT", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitRoute", () => $a6eb0d1c3eac1f7e$export$75b28ee1c7f02f00);
const $a6eb0d1c3eac1f7e$export$75b28ee1c7f02f00 = {
    name: 'software-form-submit',
    path: '/jira/software/projects/:projectKey/form/:formId',
    exact: true
};

});

parcelRegister("6FnT3", function(module, exports) {

$parcel$export(module.exports, "formSubmitEntrypoint", () => $385f1a5bd4b1bf72$export$d33b8db02e0a0cb5);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $385f1a5bd4b1bf72$export$d33b8db02e0a0cb5 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("4WiS1")), {
        moduleId: "3c821c06"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4WiS1", function(module, exports) {

let $398b37717dc06151$var$load = (parcelRequire("28QjX"))(4);
module.exports = $398b37717dc06151$var$load("9z4nz").then(()=>parcelRequire('6SZAm'));

});



parcelRegister("aviVh", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitPublicRouteEntry", () => $640c017209c8df68$export$70893a47a5c041fd);

var $7NszV = parcelRequire("7NszV");

var $6LsQE = parcelRequire("6LsQE");

var $6s1PB = parcelRequire("6s1PB");

var $8SevG = parcelRequire("8SevG");

var $6e4Kt = parcelRequire("6e4Kt");

var $eRU3k = parcelRequire("eRU3k");

var $2Ql51 = parcelRequire("2Ql51");
const $640c017209c8df68$export$70893a47a5c041fd = (0, $7NszV.createEntry)((0, $8SevG.softwareFormSubmitPublicRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-submit-public',
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $2Ql51.themePreferenceResource)
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('jira_forms_public_access_experiment', 'isEnabled', 'false') ? (0, $eRU3k.formSubmitPageEntrypoint) : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("8SevG", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitPublicRoute", () => $796526da1cff6a97$export$d238522bd96fb720);
const $796526da1cff6a97$export$d238522bd96fb720 = {
    name: 'software-form-submit-public',
    path: '/jira/software/form/:formUuid',
    exact: true
};

});


parcelRegister("dl9zj", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsRouteEntry", () => $db50753f4b92496b$export$d3fcc412edfa2068);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $4R6GH = parcelRequire("4R6GH");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $9ltJc = parcelRequire("9ltJc");

var $5f2bR = parcelRequire("5f2bR");

var $83Gfh = parcelRequire("83Gfh");

var $x6sAR = parcelRequire("x6sAR");
/** @deprecated remove when cleaning up 'fun-1607-migrate-goals-route-to-entrypoints' */ const $db50753f4b92496b$var$getHorizontalNavResource = ()=>(0, $4R6GH.fg)('fun-1607-migrate-goals-route-to-entrypoints') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $db50753f4b92496b$export$d3fcc412edfa2068 = (0, $7NszV.createEntry)((0, $9ltJc.softwareGoalsRoute), ()=>({
        group: 'software',
        component: (0, $83Gfh.default),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            ...$db50753f4b92496b$var$getHorizontalNavResource()
        ],
        entryPoint: ()=>(0, $4R6GH.fg)('fun-1607-migrate-goals-route-to-entrypoints') ? (0, $x6sAR.softwareGoalsPageEntrypoint) : undefined
    }));

});
parcelRegister("9ltJc", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsRoute", () => $7d61fd42ce40e603$export$2328fed7ebee3cce);
const $7d61fd42ce40e603$export$2328fed7ebee3cce = {
    name: 'software-goals',
    exact: true,
    path: '/jira/software/projects/:projectKey/goals'
};

});

parcelRegister("83Gfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3f76df6480cd92e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $f3f76df6480cd92e$export$69b07a7049b7beab = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("aWL8K"))), {
    moduleId: "./src/packages/spa-apps/goals/src/ui/index-old.tsx"
});
var /** @deprecated remove when cleaning up 'fun-1607-migrate-goals-route-to-entrypoints' */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f3f76df6480cd92e$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f3f76df6480cd92e$export$69b07a7049b7beab,
        pageId: `atlas-goals-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });

});
parcelRegister("aWL8K", function(module, exports) {

let $7f83e334edce8825$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7f83e334edce8825$var$load("aKHFo").then(()=>parcelRequire('cBzE4'));

});


parcelRegister("x6sAR", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsPageEntrypoint", () => $f4f250cf13a0bcf2$export$6c63903b420029c0);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $gz6uQ = parcelRequire("gz6uQ");
const $f4f250cf13a0bcf2$export$6c63903b420029c0 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $gz6uQ.softwareGoalsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("gz6uQ", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsEntrypoint", () => $6005f5d27d54b399$export$a75f86449cc34a72);

var $cfawy = parcelRequire("cfawy");

var $3rdd7 = parcelRequire("3rdd7");

const $6005f5d27d54b399$export$a75f86449cc34a72 = (0, $3rdd7.createEntryPoint)({
    root: (0, $cfawy.JSResourceForUserVisible)(()=>(parcelRequire("6QKK9")), {
        moduleId: "a5f3007b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6QKK9", function(module, exports) {

let $4fcbdbaa06689c4f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4fcbdbaa06689c4f$var$load("ayM4H").then(()=>parcelRequire('lrWy4'));

});




parcelRegister("3gU47", function(module, exports) {

$parcel$export(module.exports, "softwareInboxNextGenRouteEntry", () => $d466539a61f9c01e$export$22d61f7936797fc0);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $cSD7y = parcelRequire("cSD7y");

var $cwQst = parcelRequire("cwQst");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $lHYIV = parcelRequire("lHYIV");

var $6LsQE = parcelRequire("6LsQE");

var $arJNO = parcelRequire("arJNO");

var $8RACJ = parcelRequire("8RACJ");
const $d466539a61f9c01e$export$22d61f7936797fc0 = (0, $7NszV.createEntry)((0, $cwQst.softwareInboxNextGenRoute), ()=>({
        group: 'software',
        meta: {
            reporting: {
                id: 'software-inbox-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-inbox-classic'),
                teamName: 'boysenberry'
            }
        },
        skeleton: (0, $lHYIV.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $cSD7y.componentWithFG)('make_nav3_sidebar_lazyforpaint', (0, $koWFd.ForPaintSoftwareProjectSidebar), (0, $koWFd.default)),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)()
        ],
        layout: (0, $aPfsS.createLayout)((0, $e7bC3.softwareProjectLayoutNoOnboarding)),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $4R6GH.fg)('jcs_developer_escalations') ? (0, $8RACJ.inboxPageEntryPoint) : (0, $6LsQE.notFoundPageEntrypoint)
    }));

});
parcelRegister("cwQst", function(module, exports) {

$parcel$export(module.exports, "softwareInboxNextGenRoute", () => $cd2c848c671bcda5$export$e44454ed868d0941);
const $cd2c848c671bcda5$export$e44454ed868d0941 = {
    name: 'inbox',
    path: '/jira/software/projects/:projectKey/inbox/:issueKey?'
};

});

parcelRegister("8RACJ", function(module, exports) {

$parcel$export(module.exports, "inboxPageEntryPoint", () => $3d431b841140962e$export$6da9e4ae87b73009);

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $lkFvK = parcelRequire("lkFvK");

var $c0j7k = parcelRequire("c0j7k");
const $3d431b841140962e$export$6da9e4ae87b73009 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $c0j7k.customerServiceInboxPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("c0j7k", function(module, exports) {

$parcel$export(module.exports, "customerServiceInboxPageEntrypoint", () => $30c38ea6fc569c0d$export$bf72eb0f567836ce);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $30c38ea6fc569c0d$export$bf72eb0f567836ce = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("eBJFk")), {
        moduleId: "9cc840e3"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("eBJFk", function(module, exports) {

let $aa27f1a67aa24b26$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aa27f1a67aa24b26$var$load("iqWqc").then(()=>parcelRequire('fLjxR'));

});




parcelRegister("iQsfj", function(module, exports) {

$parcel$export(module.exports, "softwareInboxClassicRouteEntry", () => $f05204c4b21c61d2$export$ca6aeb36a7b6211d);

var $e4eHl = parcelRequire("e4eHl");

var $c309A = parcelRequire("c309A");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $lHYIV = parcelRequire("lHYIV");

var $5f2bR = parcelRequire("5f2bR");

var $6LsQE = parcelRequire("6LsQE");

var $arJNO = parcelRequire("arJNO");

var $8RACJ = parcelRequire("8RACJ");
const $f05204c4b21c61d2$export$ca6aeb36a7b6211d = (0, $7NszV.createEntry)((0, $c309A.softwareInboxClassicRoute), ()=>({
        group: 'classic-software',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            reporting: {
                id: 'software-inbox-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-inbox-classic'),
                teamName: 'boysenberry'
            }
        },
        skeleton: (0, $lHYIV.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $cSD7y.componentWithFG)('make_nav3_sidebar_lazyforpaint', (0, $9s3j1.ForPaintClassicSoftwareProjectSidebar), (0, $9s3j1.default)),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)()
        ],
        layout: (0, $aPfsS.createLayout)((0, $gyYxw.genericProjectLayout)),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $4R6GH.fg)('jcs_developer_escalations') ? (0, $8RACJ.inboxPageEntryPoint) : (0, $6LsQE.notFoundPageEntrypoint)
    }));

});
parcelRegister("c309A", function(module, exports) {

$parcel$export(module.exports, "softwareInboxClassicRoute", () => $a0a29968a08b5849$export$a3612f128eff4e3c);
const $a0a29968a08b5849$export$a3612f128eff4e3c = {
    name: 'inbox-classic',
    path: '/jira/software/c/projects/:projectKey/inbox/:issueKey?'
};

});


parcelRegister("8Yag1", function(module, exports) {

$parcel$export(module.exports, "softwareListEmbedRouteEntry", () => $6b0e66505ae13519$export$1099e0e49394fa9a);

var $6e4Kt = parcelRequire("6e4Kt");

var $lkFvK = parcelRequire("lkFvK");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $f85YZ = parcelRequire("f85YZ");

var $cf2qA = parcelRequire("cf2qA");

var $cv6Sw = parcelRequire("cv6Sw");

var $aGBe9 = parcelRequire("aGBe9");
const $6b0e66505ae13519$var$listEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $cv6Sw.listEmbedEntryPoint)
});
const $6b0e66505ae13519$export$1099e0e49394fa9a = (0, $7NszV.createEntry)((0, $f85YZ.softwareListEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $cf2qA.ListEmbedSkeleton),
        entryPoint () {
            return $6b0e66505ae13519$var$listEmbedPageEntrypoint;
        },
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $aGBe9.getListProjectResources)()
        ],
        ufoName: 'next-gen-list-embed'
    }));

});
parcelRegister("f85YZ", function(module, exports) {

$parcel$export(module.exports, "softwareListEmbedRoute", () => $7b234b63625cf68c$export$70dd8df584442004);
const $7b234b63625cf68c$export$70dd8df584442004 = {
    name: 'software-list-embed',
    path: '/jira/software/projects/:projectKey/list/embed'
};

});

parcelRegister("cf2qA", function(module, exports) {

$parcel$export(module.exports, "ListSkeleton", () => $6a76608e47ef62ca$export$cbc3335f7a517046);
$parcel$export(module.exports, "ListEmbedSkeleton", () => $6a76608e47ef62ca$export$2638f1c98fe91c13);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $2viXB = parcelRequire("2viXB");

var $gSmeo = parcelRequire("gSmeo");
const $6a76608e47ef62ca$export$cbc3335f7a517046 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2viXB)))
    });
const $6a76608e47ef62ca$export$2638f1c98fe91c13 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gSmeo)))
    });

});
parcelRegister("2viXB", function(module, exports) {
module.exports = new URL("list-app-skeleton.tpl.82508714.svg", import.meta.url).toString();

});

parcelRegister("gSmeo", function(module, exports) {
module.exports = new URL("list-embed-app-skeleton.tpl.de94c811.svg", import.meta.url).toString();

});


parcelRegister("cv6Sw", function(module, exports) {

$parcel$export(module.exports, "listEmbedEntryPoint", () => $ac51f9a325b99a16$export$519bb55e1612f243);

var $EVQo4 = parcelRequire("EVQo4");

var $dMRP9 = parcelRequire("dMRP9");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");
const $ac51f9a325b99a16$var$FORMAT_RULES_FIRST = 20;

const $ac51f9a325b99a16$export$519bb55e1612f243 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("7yBuT")), {
        moduleId: "5ed7fb43"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $dMRP9.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $EVQo4.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $ac51f9a325b99a16$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("dMRP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b295f91ae484cb56$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<834fddde735677817bb414d426c4ffa7>>
 * @relayHash b1d5bddbd0778f4be3f4876e1525e6f4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 661dfc8e2a4d3163499a24e3bae8c13315e369090fa8e455d22560e15a9e00f4
const $b295f91ae484cb56$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "661dfc8e2a4d3163499a24e3bae8c13315e369090fa8e455d22560e15a9e00f4",
        "metadata": {},
        "name": "src_jiraSoftwareListEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $b295f91ae484cb56$export$2e2bcd8739ae039 = $b295f91ae484cb56$var$node;

});

parcelRegister("7yBuT", function(module, exports) {

let $5808cb8923acff99$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5808cb8923acff99$var$load("h2MrD"),
    $5808cb8923acff99$var$load("bYT2S"),
    $5808cb8923acff99$var$load("haEOE")
]).then(()=>parcelRequire('6xPmp'));

});


parcelRegister("aGBe9", function(module, exports) {

$parcel$export(module.exports, "getListProjectResources", () => $5ae376cbaf33854f$export$7bd00eef349a268a);

var $g4ZHz = parcelRequire("g4ZHz");

var $iNzEe = parcelRequire("iNzEe");

var $l2N2a = parcelRequire("l2N2a");

var $aFVvc = parcelRequire("aFVvc");
const $5ae376cbaf33854f$export$7bd00eef349a268a = ()=>[
        (0, $aFVvc.projectCreatePermissionsResource),
        (0, $iNzEe.navigationResource),
        // eslint-disable-next-line camelcase
        (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $g4ZHz.fieldsResource)
    ];

});


parcelRegister("2toxI", function(module, exports) {

$parcel$export(module.exports, "softwareListRouteEntry", () => $47240db4975f79b0$export$f30a66efa682bf2d);

var $lkFvK = parcelRequire("lkFvK");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $6L6XQ = parcelRequire("6L6XQ");

var $cf2qA = parcelRequire("cf2qA");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $3FuB0 = parcelRequire("3FuB0");

var $fo6b8 = parcelRequire("fo6b8");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $aGBe9 = parcelRequire("aGBe9");
const $47240db4975f79b0$var$listPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3FuB0.listEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $47240db4975f79b0$export$f30a66efa682bf2d = (0, $7NszV.createEntry)((0, $6L6XQ.softwareListRoute), ()=>({
        group: 'software',
        skeleton: (0, $cf2qA.ListSkeleton),
        entryPoint () {
            return $47240db4975f79b0$var$listPageEntrypoint;
        },
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $aGBe9.getListProjectResources)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        ufoName: 'next-gen-list'
    }));

});
parcelRegister("6L6XQ", function(module, exports) {

$parcel$export(module.exports, "softwareListRoute", () => $da08ebba917aac54$export$f3a5b1b732315e13);
const $da08ebba917aac54$export$f3a5b1b732315e13 = {
    name: 'software-list',
    path: '/jira/software/projects/:projectKey/list'
};

});

parcelRegister("3FuB0", function(module, exports) {

$parcel$export(module.exports, "listEntryPoint", () => $093e9fa498e2d713$export$6be4f10150ff6073);

var $EVQo4 = parcelRequire("EVQo4");

var $eV4yn = parcelRequire("eV4yn");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");
const $093e9fa498e2d713$var$FORMAT_RULES_FIRST = 20;

const $093e9fa498e2d713$export$6be4f10150ff6073 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("kumhC")), {
        moduleId: "a7ba8596"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $eV4yn.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $EVQo4.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $093e9fa498e2d713$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("eV4yn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1285db29ce222e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9589819072a0d79deedb3286a1ad0e09>>
 * @relayHash 7ca7a7e73175fabcafbcca8378817432
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e63ab64e310db9403bb03770e66a53a6920f135e0096a5f8f31a3ac88d170c0b
const $a1285db29ce222e8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e63ab64e310db9403bb03770e66a53a6920f135e0096a5f8f31a3ac88d170c0b",
        "metadata": {},
        "name": "src_jiraSoftwareListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a1285db29ce222e8$export$2e2bcd8739ae039 = $a1285db29ce222e8$var$node;

});

parcelRegister("kumhC", function(module, exports) {

let $eea7e4fbf782bf67$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $eea7e4fbf782bf67$var$load("h2MrD"),
    $eea7e4fbf782bf67$var$load("bYT2S"),
    $eea7e4fbf782bf67$var$load("62r1i")
]).then(()=>parcelRequire('ycm07'));

});



parcelRegister("5xsFH", function(module, exports) {

$parcel$export(module.exports, "softwareOnboardingRouteEntry", () => $048906688afed449$export$bb72a943d2340466);

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $c4yut = parcelRequire("c4yut");

var $2Ql51 = parcelRequire("2Ql51");

var $5TcuB = parcelRequire("5TcuB");

var $h9FIc = parcelRequire("h9FIc");
const $048906688afed449$export$bb72a943d2340466 = (0, $7NszV.createEntry)((0, $5TcuB.softwareOnboardingRoute), ()=>({
        group: 'software',
        component: (0, $h9FIc.SoftwareOnboardingPage),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $c4yut.jswOnboardingResource),
            (0, $2Ql51.themePreferenceResource)
        ],
        forPaint: [
            (0, $h9FIc.LazySoftwareOnboardingPage)
        ],
        canTransitionIn: ()=>false
    }));

});
parcelRegister("c4yut", function(module, exports) {

$parcel$export(module.exports, "jswOnboardingResource", () => $1ebe6dd05980f4f8$export$be21a2d8a350a80);
$parcel$export(module.exports, "useJswOnboardingResource", () => $1ebe6dd05980f4f8$export$83f546a45ad58d0a);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $1ebe6dd05980f4f8$export$be21a2d8a350a80 = (0, $2M1hQ.createResource)({
    type: (0, $156934826e437e4d$export$692203fca66f4d77),
    getKey: ()=>'jsw_onboarding',
    getDataLoader: ()=>(parcelRequire("jsFRV"))
});
const $1ebe6dd05980f4f8$export$83f546a45ad58d0a = ()=>(0, $2YP9W.useResource)($1ebe6dd05980f4f8$export$be21a2d8a350a80);

});
const $156934826e437e4d$export$692203fca66f4d77 = 'RESOURCE_TYPE_SOFTWARE_ONBOARDING';

parcelRegister("jsFRV", function(module, exports) {

let $e2b11c19cc89c35c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e2b11c19cc89c35c$var$load("knzjr").then(()=>parcelRequire('4W57j'));

});


parcelRegister("5TcuB", function(module, exports) {

$parcel$export(module.exports, "softwareOnboardingRoute", () => $38b80aa1ac78feb2$export$5e6c92d2f34c1e48);
const $38b80aa1ac78feb2$export$5e6c92d2f34c1e48 = {
    name: 'software-onboarding',
    path: '/welcome/software',
    exact: true
};

});

parcelRegister("h9FIc", function(module, exports) {

$parcel$export(module.exports, "LazySoftwareOnboardingPage", () => $9d1d716191d31716$export$31e9f06d3389e445);
$parcel$export(module.exports, "SoftwareOnboardingPage", () => $9d1d716191d31716$export$ee768d69c6e3a8bd);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $9d1d716191d31716$export$31e9f06d3389e445 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iUTtc"))), {
    moduleId: "./src/packages/spa-apps/software/onboarding/src/index.tsx"
});
const $9d1d716191d31716$export$ee768d69c6e3a8bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9d1d716191d31716$export$31e9f06d3389e445,
        pageId: "software-onboarding",
        shouldShowSpinner: false
    });

});
parcelRegister("iUTtc", function(module, exports) {

let $dc587c22005ec9fb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dc587c22005ec9fb$var$load("epspQ").then(()=>parcelRequire('iCmWy'));

});



parcelRegister("eFYGV", function(module, exports) {

$parcel$export(module.exports, "softwarePeriscopeNextGenRouteEntry", () => $e85cebcb4685b0b3$export$7db4d910357a4d89);

var $5uXOq = parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $b4PzF = parcelRequire("b4PzF");

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $ajKFd = parcelRequire("ajKFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $8VZpl = parcelRequire("8VZpl");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $5j7Th = parcelRequire("5j7Th");

var $lYBIs = parcelRequire("lYBIs");
const $e85cebcb4685b0b3$var$PeriscopeNextGen = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $lYBIs.LazyPeriscope),
        pageId: "softwarePeriscopeNextGen",
        shouldShowSpinner: true
    });
const $e85cebcb4685b0b3$export$7db4d910357a4d89 = (0, $7NszV.createEntry)((0, $8VZpl.softwarePeriscopeNextGenRoute), ()=>({
        group: 'software',
        component: (0, $7XYc4.componentWithCondition)((0, $b4PzF.isFedRamp), (0, $5lsNZ.default), $e85cebcb4685b0b3$var$PeriscopeNextGen),
        skeleton: (0, $ajKFd.Skeleton),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lYBIs.LazyPeriscope)
        ],
        meta: {
            reporting: {
                id: 'software-periscope',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-periscope'),
                teamName: 'nova'
            }
        }
    }));

});
parcelRegister("ajKFd", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $b9eb4b3f312b449f$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "InsightsSkeleton", () => $b9eb4b3f312b449f$export$dd0b74c715df3275);
$parcel$export(module.exports, "SuggestionsSkeleton", () => $b9eb4b3f312b449f$export$91f27b306afd627b);
$parcel$export(module.exports, "WorkItemsSkeleton", () => $b9eb4b3f312b449f$export$1660f3159b79b22b);
$parcel$export(module.exports, "WorkItemsVulnTabSkeleton", () => $b9eb4b3f312b449f$export$5aea7d4ed03d6ea6);
$parcel$export(module.exports, "WorkItemsDeploymentTabSkeleton", () => $b9eb4b3f312b449f$export$ff38ee81427877e9);
$parcel$export(module.exports, "OnCallPanelSkeleton", () => $b9eb4b3f312b449f$export$91b639eac52af99f);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $gUTyu = parcelRequire("gUTyu");

var $29cNf = parcelRequire("29cNf");
const $b9eb4b3f312b449f$export$8f31e4c4a37b8e9c = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        xcss: $b9eb4b3f312b449f$var$MainContainerStyles,
        "data-testId": "software-periscope-periscope-page.ui.loading",
        "aria-label": formatMessage((0, $29cNf.default).label),
        gap: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        xcss: $b9eb4b3f312b449f$var$leftColumnStyles,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $b9eb4b3f312b449f$var$InsightsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.PeriscopeInsightsSkeleton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $b9eb4b3f312b449f$var$WorkItemsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.PeriscopeWorkItemsSkeleton), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        xcss: $b9eb4b3f312b449f$var$rightColumnStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $b9eb4b3f312b449f$var$SuggestionsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.PeriscopeSuggestionsSkeleton), null))));
};
const $b9eb4b3f312b449f$export$dd0b74c715df3275 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $b9eb4b3f312b449f$var$InsightsContainerStyles,
        "data-testId": "software-periscope-periscope-page.insights-ui.loading",
        "aria-label": formatMessage((0, $29cNf.default).insightsLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.PeriscopeInsightsSkeleton), null));
};
const $b9eb4b3f312b449f$export$91f27b306afd627b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $b9eb4b3f312b449f$var$SuggestionsContainerStyles,
        "data-testId": "software-periscope-periscope-page.suggestions-ui.loading",
        "aria-label": formatMessage((0, $29cNf.default).suggestionsLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.PeriscopeSuggestionsSkeleton), null));
};
const $b9eb4b3f312b449f$export$1660f3159b79b22b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $b9eb4b3f312b449f$var$WorkItemsContainerStyles,
        "aria-label": formatMessage((0, $29cNf.default).workItemsLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.PeriscopeWorkItemsSkeleton), null));
};
const $b9eb4b3f312b449f$export$5aea7d4ed03d6ea6 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $b9eb4b3f312b449f$var$WorkItemsVulnTabContainerStyles,
        "aria-label": formatMessage((0, $29cNf.default).workItemsVulnTabLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.DevelopmentPageWorkItemsVulnTabSkeleton), null));
};
const $b9eb4b3f312b449f$export$ff38ee81427877e9 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $b9eb4b3f312b449f$var$WorkItemsContainerStyles,
        "aria-label": formatMessage((0, $29cNf.default).workItemsDeploymentTabLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.DevelopmentPageWorkItemsDeploymentTabSkeleton), null));
};
const $b9eb4b3f312b449f$export$91b639eac52af99f = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $b9eb4b3f312b449f$var$OnCallPanelContainterStyles,
        "aria-label": formatMessage((0, $29cNf.default).onCallPanelLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.DevelopmentPageOnCallPanelSkeleton), null));
};
const $b9eb4b3f312b449f$var$MainContainerStyles = (0, $2s57o.xcss)({
    width: '100%',
    height: '100%',
    display: 'flex',
    boxSizing: 'border-box',
    overflow: 'hidden'
});
const $b9eb4b3f312b449f$var$leftColumnStyles = (0, $2s57o.xcss)({
    flex: '2 1 0'
});
const $b9eb4b3f312b449f$var$rightColumnStyles = (0, $2s57o.xcss)({
    flex: '1 1 0'
});
const $b9eb4b3f312b449f$var$SuggestionsContainerStyles = (0, $2s57o.xcss)({
    width: '100%',
    overflow: 'hidden',
    height: '650px',
    boxSizing: 'border-box'
});
const $b9eb4b3f312b449f$var$InsightsContainerStyles = (0, $2s57o.xcss)({
    overflow: 'hidden',
    width: '100%',
    height: '385px',
    boxSizing: 'border-box'
});
const $b9eb4b3f312b449f$var$WorkItemsContainerStyles = (0, $2s57o.xcss)({
    width: '100%',
    height: '600px',
    boxSizing: 'border-box',
    overflow: 'hidden'
});
const $b9eb4b3f312b449f$var$WorkItemsVulnTabContainerStyles = (0, $2s57o.xcss)({
    width: '100%',
    height: '420px',
    boxSizing: 'border-box',
    overflow: 'hidden'
});
const $b9eb4b3f312b449f$var$OnCallPanelContainterStyles = (0, $2s57o.xcss)({
    width: '100%',
    height: '96px',
    boxSizing: 'border-box',
    overflow: 'hidden'
});

});
parcelRegister("gUTyu", function(module, exports) {

$parcel$export(module.exports, "PeriscopeSuggestionsSkeleton", () => $c6fead338751845c$export$176dfe4c14771136);
$parcel$export(module.exports, "PeriscopeInsightsSkeleton", () => $c6fead338751845c$export$afb44f298901be44);
$parcel$export(module.exports, "PeriscopeWorkItemsSkeleton", () => $c6fead338751845c$export$298a6b6a251923c2);
$parcel$export(module.exports, "DevelopmentPageWorkItemsVulnTabSkeleton", () => $c6fead338751845c$export$8940e0b80e4066d6);
$parcel$export(module.exports, "DevelopmentPageWorkItemsDeploymentTabSkeleton", () => $c6fead338751845c$export$2f5ed71a7df2d4e6);
$parcel$export(module.exports, "DevelopmentPageOnCallPanelSkeleton", () => $c6fead338751845c$export$e70f5fa3451855e2);
$parcel$export(module.exports, "DevelopmentPageCodeAgentsTabSkeleton", () => $c6fead338751845c$export$e3f7fac0f7e53296);
/* PeriscopeSuggestionsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $2vpp7 = parcelRequire("2vpp7");

var $47suu = parcelRequire("47suu");

var $2AftB = parcelRequire("2AftB");

var $aR5hR = parcelRequire("aR5hR");

var $bIAib = parcelRequire("bIAib");

var $gqrFB = parcelRequire("gqrFB");

var $2aQWX = parcelRequire("2aQWX");

var $lhdFn = parcelRequire("lhdFn");
const $c6fead338751845c$var$PeriscopePageSkeletonStyles = null;
const $c6fead338751845c$export$4aecc030c4d69f74 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-skeleton-image-periscope-page-new",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aR5hR)))
    }));
const $c6fead338751845c$export$176dfe4c14771136 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-suggestions-skeleton",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bIAib)))
    }));
const $c6fead338751845c$export$afb44f298901be44 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-insights-skeleton",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($47suu)))
    }));
const $c6fead338751845c$export$298a6b6a251923c2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2aQWX)))
    }));
const $c6fead338751845c$export$8940e0b80e4066d6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gqrFB)))
    }));
const $c6fead338751845c$export$2f5ed71a7df2d4e6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2vpp7)))
    }));
const $c6fead338751845c$export$e70f5fa3451855e2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-on-call-panel-skeleton",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2AftB)))
    }));
const $c6fead338751845c$export$e3f7fac0f7e53296 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.code-agents-tab-skeleton",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lhdFn)))
    }));

});
parcelRegister("2vpp7", function(module, exports) {
module.exports = new URL("deployment-tab-skeleton.tpl.6442d1f9.svg", import.meta.url).toString();

});

parcelRegister("47suu", function(module, exports) {
module.exports = new URL("insights.tpl.c29b665e.svg", import.meta.url).toString();

});

parcelRegister("2AftB", function(module, exports) {
module.exports = new URL("on-call-panel-skeleton.tpl.d7139b03.svg", import.meta.url).toString();

});

parcelRegister("aR5hR", function(module, exports) {
module.exports = new URL("periscope-page-full-layout.tpl.762dcdba.svg", import.meta.url).toString();

});

parcelRegister("bIAib", function(module, exports) {
module.exports = new URL("suggestions.tpl.52cb06d0.svg", import.meta.url).toString();

});

parcelRegister("gqrFB", function(module, exports) {
module.exports = new URL("vuln-tab-skeleton.tpl.1a18ea24.svg", import.meta.url).toString();

});

parcelRegister("2aQWX", function(module, exports) {
module.exports = new URL("work-items.tpl.4ee9e4f3.svg", import.meta.url).toString();

});

parcelRegister("lhdFn", function(module, exports) {
module.exports = new URL("code-agents-tab-skeleton.tpl.874ad579.svg", import.meta.url).toString();

});


parcelRegister("29cNf", function(module, exports) {

$parcel$export(module.exports, "default", () => $34a050fcfbf5d355$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $34a050fcfbf5d355$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "periscope.skeleton.label",
        "defaultMessage": "Loading"
    },
    suggestionsLabel: {
        "id": "periscope.suggestions-skeleton.label",
        "defaultMessage": "Suggestions loading"
    },
    insightsLabel: {
        "id": "periscope.insights-skeleton.label",
        "defaultMessage": "Developer insights loading"
    },
    workItemsLabel: {
        "id": "periscope.work-items-skeleton.work-items-label",
        "defaultMessage": "Work items loading"
    },
    workItemsVulnTabLabel: {
        "id": "periscope.work-items-skeleton.work-items-vuln-tab-label",
        "defaultMessage": "Work items vulnerability tab loading"
    },
    workItemsDeploymentTabLabel: {
        "id": "periscope.work-items-skeleton.work-items-deployment-tab-label",
        "defaultMessage": "Work items deployment tab loading"
    },
    onCallPanelLabel: {
        "id": "periscope.on-call-skeleton.label",
        "defaultMessage": "On call panel loading"
    }
});

});


parcelRegister("8VZpl", function(module, exports) {

$parcel$export(module.exports, "softwarePeriscopeNextGenRoute", () => $4e58e490b9dd84b4$export$9d0f329211395c25);
const $4e58e490b9dd84b4$export$9d0f329211395c25 = {
    name: 'software-periscope',
    path: '/jira/software/projects/:projectKey/development'
};

});

parcelRegister("lYBIs", function(module, exports) {

$parcel$export(module.exports, "LazyPeriscope", () => $bf387617411885b4$export$9c25b4571a88e1f);

var $7yO8g = parcelRequire("7yO8g");

var $b7Svb = parcelRequire("b7Svb");

const $bf387617411885b4$export$9c25b4571a88e1f = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("44dvG"))), {
    moduleId: "./src/packages/spa-apps/periscope/src/index.tsx"
});

});
parcelRegister("44dvG", function(module, exports) {

let $2f6203f44d0a4ec6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2f6203f44d0a4ec6$var$load("dsiAd"),
    $2f6203f44d0a4ec6$var$load("WP2Js")
]).then(()=>parcelRequire('k9ngM'));

});



parcelRegister("kxlGk", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapRouteEntry", () => $f92b7b046a2bd572$export$c1d875e34d537389);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $jsFU4 = parcelRequire("jsFU4");

var $7GnDe = parcelRequire("7GnDe");

var $gwIeN = parcelRequire("gwIeN");

var $8STJR = parcelRequire("8STJR");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $7tQej = parcelRequire("7tQej");

var $9SSv2 = parcelRequire("9SSv2");
const $f92b7b046a2bd572$var$SoftwareTimelineRedirect = ({ match: { params: { projectKey: projectKey, boardId: boardId } }, query: query })=>{
    const queryParams = new URLSearchParams(query).toString();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: {
            pathname: `/jira/software/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
            hash: '',
            search: queryParams
        }
    });
};
const $f92b7b046a2bd572$export$c1d875e34d537389 = (0, $7NszV.createEntry)((0, $gwIeN.softwareRoadmapRoute), ()=>({
        group: 'software',
        component: $f92b7b046a2bd572$var$SoftwareTimelineRedirect,
        skeleton: (0, $8STJR.RoadmapSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $jsFU4.nextGenRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9SSv2.LazyNextGenRoadmap)
        ],
        ufoName: 'next-gen-roadmap'
    }));

});
parcelRegister("jsFU4", function(module, exports) {

$parcel$export(module.exports, "nextGenRoadmapResource", () => $0b5ed5206b5a609e$export$2750f87d68dfb02a);

var $2M1hQ = parcelRequire("2M1hQ");


const $0b5ed5206b5a609e$export$2750f87d68dfb02a = (0, $2M1hQ.createResource)({
    type: (0, $87d7efe6336d8b83$export$75dfa03544a19422),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("ljDdW")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000,
    isBrowserOnly: true
});

});
const $87d7efe6336d8b83$export$75dfa03544a19422 = 'ROADMAP';
const $87d7efe6336d8b83$export$e905b9170ecbb599 = 'BOARD_CONTEXT_ROADMAP_SETTINGS';

parcelRegister("ljDdW", function(module, exports) {

let $f849cc5d577658c1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f849cc5d577658c1$var$load("eNmuD"),
    $f849cc5d577658c1$var$load("8Fxs8")
]).then(()=>parcelRequire('d0ZST'));

});


parcelRegister("gwIeN", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapRoute", () => $d2651e8c2584e2bd$export$a4a573c36fc75b30);
const $d2651e8c2584e2bd$export$a4a573c36fc75b30 = {
    name: 'software-roadmap',
    path: '/jira/software/projects/:projectKey/boards/:boardId/roadmap'
};

});

parcelRegister("8STJR", function(module, exports) {

$parcel$export(module.exports, "RoadmapSkeleton", () => $e0f5f5cb925a5d1c$export$66a1e8bb48359566);
/* RoadmapSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XYc4 = parcelRequire("7XYc4");

var $3HwlS = parcelRequire("3HwlS");

var $dCm1o = parcelRequire("dCm1o");

var $hCy6k = parcelRequire("hCy6k");

var $7jB1k = parcelRequire("7jB1k");

var $aIPZQ = parcelRequire("aIPZQ");
const $e0f5f5cb925a5d1c$var$customCssStyles = null;
const $e0f5f5cb925a5d1c$export$66a1e8bb48359566 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e0f5f5cb925a5d1c$var$AppSkeletonImageContainer, null, (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7jB1k))),
        className: (0, $bwpsq.default)([
            "_2zz1idpf"
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aIPZQ))),
        className: (0, $bwpsq.default)([
            "_2zz1idpf"
        ])
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e0f5f5cb925a5d1c$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
            __cmplp.className
        ])
    });
});
const $e0f5f5cb925a5d1c$var$AppSkeletonImageContainer = (0, $7XYc4.componentWithCondition)(()=>(0, $dCm1o.isVisualRefreshEnabled)(), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e0f5f5cb925a5d1c$var$Wrapper, null, children), (0, $5uXOq.Fragment));

});
parcelRegister("7jB1k", function(module, exports) {
module.exports = new URL("roadmap-app-skeleton-nav-refresh.tpl.ce6eb42e.svg", import.meta.url).toString();

});

parcelRegister("aIPZQ", function(module, exports) {
module.exports = new URL("roadmap-app-skeleton.tpl.a54a882d.svg", import.meta.url).toString();

});


parcelRegister("9SSv2", function(module, exports) {

$parcel$export(module.exports, "LazyNextGenRoadmap", () => $fba9adf99f1ad42b$export$1339c847cf4ab57);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $fba9adf99f1ad42b$export$1339c847cf4ab57 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("emv4G"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fba9adf99f1ad42b$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $fba9adf99f1ad42b$export$1339c847cf4ab57,
        pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });

});


parcelRegister("cyZLC", function(module, exports) {

$parcel$export(module.exports, "softwareSecurityNextGenRouteEntry", () => $9f02076ad45b829a$export$a8dcfae475505e7a);

var $5uXOq = parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $ffza4 = parcelRequire("ffza4");

var $bwLf9 = parcelRequire("bwLf9");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $en8e6 = parcelRequire("en8e6");

var $5lsNZ = parcelRequire("5lsNZ");

var $d1QwJ = parcelRequire("d1QwJ");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $5j7Th = parcelRequire("5j7Th");

var $4R6GH = parcelRequire("4R6GH");

var $6LsQE = parcelRequire("6LsQE");

var $crK2h = parcelRequire("crK2h");

var $d6VEe = parcelRequire("d6VEe");

var $7AM4I = parcelRequire("7AM4I");
const $9f02076ad45b829a$var$SecurityNextGen = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $d6VEe.LazySecurity),
        pageId: "securityNextGen",
        shouldShowSpinner: true
    });
/** @deprecated remove when cleaning up 'jira-software-security-routes-entrypoint-migration' */ const $9f02076ad45b829a$var$getHorizontalNavResource = ()=>(0, $4R6GH.fg)('jira-software-security-routes-entrypoint-migration') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $9f02076ad45b829a$export$a8dcfae475505e7a = (0, $7NszV.createEntry)((0, $d1QwJ.softwareSecurityNextGenRoute), ()=>({
        group: 'software',
        component: (0, $4R6GH.fg)('jira-software-security-routes-entrypoint-migration') ? undefined : (0, $bwLf9.default)((0, $crK2h.isSecurityPageEnabled), $9f02076ad45b829a$var$SecurityNextGen, (0, $5lsNZ.default)),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        ufoName: 'software-security-combined',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            ...$9f02076ad45b829a$var$getHorizontalNavResource(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $en8e6.securityPageResource)
        ],
        forPaint: (0, $4R6GH.fg)('jira-software-security-routes-entrypoint-migration') ? undefined : [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $d6VEe.LazySecurity)
        ],
        meta: {
            reporting: {
                id: 'software-security',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-security'),
                teamName: 'fusion-isotopes'
            }
        },
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('jira-software-security-routes-entrypoint-migration')) return (0, $crK2h.isSecurityPageEnabled)() ? (0, $7AM4I.securityPageEntrypoint) : (0, $6LsQE.notFoundPageEntrypoint);
            return undefined;
        }
    }));

});
parcelRegister("en8e6", function(module, exports) {

$parcel$export(module.exports, "securityPageResource", () => $ae0f760fa9a80a3f$export$2c5e3c161b8fe98);

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $1UBcC = parcelRequire("1UBcC");

var $ac0bf = parcelRequire("ac0bf");

const $ae0f760fa9a80a3f$var$getNumberOfVulnerabilitiesToFetch = ()=>40;
const $ae0f760fa9a80a3f$var$getNumberOfSecurityContainersToFetch = ()=>100;
let $ae0f760fa9a80a3f$var$filters;
const $ae0f760fa9a80a3f$export$2c5e3c161b8fe98 = (0, $ao2h1.createRelayResource)({
    type: (0, $0a72320b8bc3a1aa$export$f24db22c3c834cb1),
    getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId, activationId: activationId } }) {
        const isSecRoute = name === 'software-security' || name === 'software-security-classic';
        // Set filters on initial call only and not on every query param change
        if (!$ae0f760fa9a80a3f$var$filters && isSecRoute) {
            const connectionAri = (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                resourceType: 'security-container',
                cloudId: cloudId,
                activationId: activationId,
                resourceId: ''
            });
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            $ae0f760fa9a80a3f$var$filters = (0, $ac0bf.getGqlFiltersFromQueryParams)(query, connectionAri);
        }
        // Reset filters when navigating away from the security page
        if (!isSecRoute) $ae0f760fa9a80a3f$var$filters = undefined;
        return {
            parameters: (0, $1UBcC.default),
            options: {
                fetchPolicy: 'store-and-network'
            },
            variables: {
                cloudAri: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'site',
                    resourceId: cloudId
                }),
                cloudId: cloudId,
                projectKey: params.projectKey ?? '',
                numberOfVulnsToFetch: $ae0f760fa9a80a3f$var$getNumberOfVulnerabilitiesToFetch(),
                getContainers: false,
                numberOfContainersToFetch: $ae0f760fa9a80a3f$var$getNumberOfSecurityContainersToFetch(),
                filter: $ae0f760fa9a80a3f$var$filters
            }
        };
    }
});

});
parcelRegister("1UBcC", function(module, exports) {

$parcel$export(module.exports, "default", () => $511d4548ae93769f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<58ef399e8db9a4ce20f5d8d31d9f60f2>>
 * @relayHash d1a0d3c2f1741ebc29aa6c3600b91c85
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 460f75a35332aa779eeb9b79852a0dcce7b0b2e26ec14bd676a2aa9ad8963183
const $511d4548ae93769f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "getContainers"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numberOfContainersToFetch"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numberOfVulnsToFetch"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v8 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v9 = {
        "kind": "ScalarField",
        "name": "totalLinkedSecurityContainerCount"
    }, v10 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "numberOfContainersToFetch"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v12 = [
        v11 /*: any*/ 
    ], v13 = {
        "kind": "InlineFragment",
        "selections": v12 /*: any*/ ,
        "type": "ThirdPartySecurityContainer"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "numberOfVulnsToFetch"
    }, v16 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "and": {
                    "lastUpdated": {
                        "sort": {
                            "order": "ASC",
                            "priority": 1
                        }
                    }
                }
            }
        },
        v15 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "ScalarField",
        "name": "name"
    }, v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "cloudAri"
                    },
                    {
                        "kind": "Literal",
                        "name": "providerTypes",
                        "value": [
                            "SECURITY"
                        ]
                    }
                ],
                "concreteType": "DevOpsProviders",
                "kind": "LinkedField",
                "name": "providers",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "DevOpsSecurityProvider",
                        "kind": "LinkedField",
                        "name": "securityProviders",
                        "plural": true,
                        "selections": [
                            v17 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "appInstallationId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "logoUrl"
                            },
                            v18 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 100
                                    }
                                ],
                                "concreteType": "AriGraphRelationshipConnection",
                                "kind": "LinkedField",
                                "name": "linkedWorkspaces",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "AriGraphRelationship",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            v19 /*: any*/ 
                                        ]
                                    }
                                ],
                                "storageKey": "linkedWorkspaces(first:100)"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v21 = [
        v17 /*: any*/ 
    ], v22 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "ConfluencePage"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "ConfluenceSpace"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsFeatureFlag"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsOperationsComponentDetails"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsOperationsIncidentDetails"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsOperationsPostIncidentReviewDetails"
    }, v29 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsPullRequestDetails"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsRepository"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsSecurityVulnerabilityDetails"
    }, v32 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraAutodevJob"
    }, v33 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraConfluenceRemoteIssueLink"
    }, v34 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraCustomRemoteIssueLink"
    }, v35 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraIssueRemoteIssueLink"
    }, v36 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraWebRemoteIssueLink"
    }, v37 = [
        v8 /*: any*/ ,
        v15 /*: any*/ 
    ], v38 = {
        "kind": "ScalarField",
        "name": "url"
    }, v39 = {
        "kind": "ScalarField",
        "name": "key"
    }, v40 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v41 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainSecurityInJiraQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v7 /*: any*/ ,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            v8 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "getContainers",
                                                "variableName": "getContainers"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "numberOfContainersToFetch",
                                                "variableName": "numberOfContainersToFetch"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "main_softwareSecurityPage_MainPage"
                                    },
                                    v9 /*: any*/ ,
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "AriGraphRelationshipConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityContainers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationship",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "condition": "getContainers",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "data",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v14 /*: any*/ 
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jiraProjectByKey.linkedSecurityContainers"
                                    },
                                    {
                                        "alias": "linkedVulnsForAnalytics",
                                        "args": v16 /*: any*/ ,
                                        "concreteType": "GraphJiraVulnerabilityConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityVulnerabilitiesByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphJiraVulnerabilityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "GraphJiraVulnerability",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "condition": "getContainers",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                        "kind": "LinkedField",
                                                                        "name": "vulnerability",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "ThirdPartySecurityContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "securityContainer",
                                                                                "plural": false,
                                                                                "selections": v12 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.jiraProjectByKey"
                        }
                    ]
                },
                v20 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainSecurityInJiraQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v17 /*: any*/ ,
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityContainers",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "condition": "getContainers",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                v26 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                v35 /*: any*/ ,
                                                                                v36 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        v8 /*: any*/ 
                                    ],
                                    "kind": "ScalarField",
                                    "name": "totalLinkedSecurityVulnerabilityCount"
                                },
                                {
                                    "args": v37 /*: any*/ ,
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                            "kind": "LinkedField",
                                                            "name": "vulnerability",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                },
                                                                {
                                                                    "condition": "getContainers",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ThirdPartySecurityContainer",
                                                                            "kind": "LinkedField",
                                                                            "name": "securityContainer",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v17 /*: any*/ ,
                                                                                v18 /*: any*/ ,
                                                                                v38 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityIdentifier",
                                                                    "kind": "LinkedField",
                                                                    "name": "identifiers",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "displayName"
                                                                        },
                                                                        v38 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityAdditionalInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "additionalInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "content"
                                                                        },
                                                                        v38 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "status"
                                                                },
                                                                {
                                                                    "concreteType": "AriGraphRelationshipConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "linkedJiraIssues",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AriGraphRelationship",
                                                                            "kind": "LinkedField",
                                                                            "name": "nodes",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "to",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v17 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "data",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "idsOrAliases",
                                                                                                                    "value": [
                                                                                                                        "summary",
                                                                                                                        "assignee",
                                                                                                                        "status",
                                                                                                                        "issuetype"
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldsByIdOrAlias",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "status",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v17 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "statusCategory",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v39 /*: any*/ ,
                                                                                                                                        v17 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusField"
                                                                                                                },
                                                                                                                v17 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "fieldId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "text"
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "picture"
                                                                                                                                },
                                                                                                                                v17 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "small"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v17 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "issueId"
                                                                                                        },
                                                                                                        v39 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "webUrl"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssue"
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ ,
                                                                                                v25 /*: any*/ ,
                                                                                                v26 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v28 /*: any*/ ,
                                                                                                v29 /*: any*/ ,
                                                                                                v30 /*: any*/ ,
                                                                                                v31 /*: any*/ ,
                                                                                                v32 /*: any*/ ,
                                                                                                v33 /*: any*/ ,
                                                                                                v34 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                v36 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                },
                                                                v17 /*: any*/ ,
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "introducedDate"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "providerVulnerabilityId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "securityContainerId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "severity"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "description"
                                                                }
                                                            ]
                                                        },
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                v40 /*: any*/ 
                                            ]
                                        },
                                        v41 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v37 /*: any*/ ,
                                    "filters": [
                                        "filter"
                                    ],
                                    "handle": "connection",
                                    "key": "security__linkedSecurityVulnerabilitiesByProject",
                                    "kind": "LinkedHandle",
                                    "name": "linkedSecurityVulnerabilitiesByProject"
                                },
                                {
                                    "alias": "projectHaveVulnerabilityCheck",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        }
                                    ],
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                            "kind": "LinkedField",
                                                            "name": "vulnerability",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ]
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "linkedSecurityVulnerabilitiesByProject(first:1)"
                                },
                                {
                                    "alias": "linkedVulnsForAnalytics",
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "condition": "getContainers",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                    "kind": "LinkedField",
                                                                    "name": "vulnerability",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ThirdPartySecurityContainer",
                                                                            "kind": "LinkedField",
                                                                            "name": "securityContainer",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v17 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "getContainers",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "AriGraphRelationshipConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityContainers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationship",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v18 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "icon"
                                                                                        },
                                                                                        v38 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "providerName"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "lastUpdated"
                                                                                        },
                                                                                        v14 /*: any*/ ,
                                                                                        v17 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ThirdPartySecurityContainer"
                                                                                },
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                v26 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                v35 /*: any*/ ,
                                                                                v36 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v19 /*: any*/ 
                                                            ]
                                                        },
                                                        v40 /*: any*/ 
                                                    ]
                                                },
                                                v41 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "security__linkedSecurityContainers",
                                            "kind": "LinkedHandle",
                                            "name": "linkedSecurityContainers"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v20 /*: any*/ 
            ]
        },
        "params": {
            "id": "460f75a35332aa779eeb9b79852a0dcce7b0b2e26ec14bd676a2aa9ad8963183",
            "metadata": {},
            "name": "mainSecurityInJiraQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$511d4548ae93769f$var$node.hash = "e0029e5d1d9e6e62c9b62d69cc3a9f72";
var $511d4548ae93769f$export$2e2bcd8739ae039 = $511d4548ae93769f$var$node;

});

parcelRegister("ac0bf", function(module, exports) {

$parcel$export(module.exports, "getGqlFiltersFromQueryParams", () => $526907709998fa0b$export$2af359d48d48e5f1);

var $5eeaw = parcelRequire("5eeaw");

var $3zFAD = parcelRequire("3zFAD");

var $3o4IF = parcelRequire("3o4IF");
const $526907709998fa0b$var$getFilterValue = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
values, fieldStortKey, sortKey = (0, $3zFAD.initialVulnerabilityTableOptions).sortKey, sortOrder = (0, $3zFAD.initialVulnerabilityTableOptions).sortOrder)=>({
        ...values.length > 0 ? {
            values: values
        } : {},
        ...sortKey === fieldStortKey && {
            sort: {
                priority: 2,
                order: (0, $3o4IF.parseSortDirection)(sortOrder, (0, $5eeaw.AriGraphSortOrderInput).DESC)
            }
        }
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $526907709998fa0b$var$getOrDefault = (input, defaultArray)=>input.length ? input : defaultArray;
const $526907709998fa0b$export$2af359d48d48e5f1 = (queryParams, connectionAri)=>{
    const containerValues = $526907709998fa0b$var$getOrDefault((0, $3o4IF.connectionQueryParamToFilter)(queryParams[0, $3zFAD.QUERY_PARAM_CONTAINER], connectionAri).filter(Boolean), (0, $3zFAD.initialVulnerabilityTableOptions).connectionFilter);
    const statusQueryParams = (0, $3o4IF.arrayQueryParamToFilter)(queryParams[0, $3zFAD.QUERY_PARAM_VULN_STATUS]);
    return {
        and: [
            {
                lastUpdated: {
                    sort: {
                        priority: 1,
                        order: (0, $5eeaw.AriGraphSortOrderInput).DESC
                    }
                },
                to_severity: $526907709998fa0b$var$getFilterValue($526907709998fa0b$var$getOrDefault((0, $3o4IF.arrayQueryParamToFilter)(queryParams[0, $3zFAD.QUERY_PARAM_SEVERITY]).map((0, $3o4IF.parseSeverity)).filter(Boolean), (0, $3zFAD.initialVulnerabilityTableOptions).severityFilter), 'severity', queryParams[0, $3zFAD.QUERY_PARAM_SORT_KEY], queryParams[0, $3zFAD.QUERY_PARAM_SORT_ORDER]),
                to_status: $526907709998fa0b$var$getFilterValue(statusQueryParams.includes((0, $3zFAD.NO_FILTER_VULN_STATUS)) ? [] : $526907709998fa0b$var$getOrDefault(statusQueryParams.map((0, $3o4IF.parseStatus)).filter(Boolean), (0, $3zFAD.initialVulnerabilityTableOptions).statusFilter), 'status', queryParams[0, $3zFAD.QUERY_PARAM_SORT_KEY], queryParams[0, $3zFAD.QUERY_PARAM_SORT_ORDER]),
                createdAt: {
                    ...queryParams[0, $3zFAD.QUERY_PARAM_SORT_KEY] === 'introduced' && {
                        sort: {
                            priority: 2,
                            order: (0, $3o4IF.parseSortDirection)(queryParams[0, $3zFAD.QUERY_PARAM_SORT_ORDER], (0, $5eeaw.AriGraphSortOrderInput).DESC)
                        }
                    }
                },
                to_container: {
                    containerAri: {
                        value: {
                            ...containerValues.length > 0 ? {
                                values: containerValues
                            } : {}
                        }
                    }
                }
            }
        ]
    };
};

});
parcelRegister("5eeaw", function(module, exports) {

$parcel$export(module.exports, "AriGraphSortOrderInput", () => $f98addb8b52ad07a$export$3b69903df4cd6048);
const $f98addb8b52ad07a$export$3b69903df4cd6048 = {
    ASC: 'ASC',
    DESC: 'DESC'
};

});

parcelRegister("3zFAD", function(module, exports) {

$parcel$export(module.exports, "QUERY_PARAM_SEARCH", () => $d1be2b44eb126533$export$a181206198b7f50c);
$parcel$export(module.exports, "QUERY_PARAM_CONTAINER", () => $d1be2b44eb126533$export$3873b20ffa21b004);
$parcel$export(module.exports, "QUERY_PARAM_SEVERITY", () => $d1be2b44eb126533$export$af01a3d59250f3d3);
$parcel$export(module.exports, "QUERY_PARAM_VULN_STATUS", () => $d1be2b44eb126533$export$c315695f017955dc);
$parcel$export(module.exports, "QUERY_PARAM_ISSUE_STATUS", () => $d1be2b44eb126533$export$2e69a24fe65d4109);
$parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", () => $d1be2b44eb126533$export$6da773286c35ef41);
$parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", () => $d1be2b44eb126533$export$810a1f7ed2facfcb);
$parcel$export(module.exports, "NO_FILTER_VULN_STATUS", () => $d1be2b44eb126533$export$d8115099d465de4c);
$parcel$export(module.exports, "initialVulnerabilityTableOptions", () => $d1be2b44eb126533$export$e9b4ea84d666c490);
const $d1be2b44eb126533$export$a181206198b7f50c = 'search';
const $d1be2b44eb126533$export$3873b20ffa21b004 = 'container';
const $d1be2b44eb126533$export$af01a3d59250f3d3 = 'severity';
const $d1be2b44eb126533$export$c315695f017955dc = 'vulnerabilityStatus';
const $d1be2b44eb126533$export$2e69a24fe65d4109 = 'issueStatus';
const $d1be2b44eb126533$export$6da773286c35ef41 = 'sortKey';
const $d1be2b44eb126533$export$810a1f7ed2facfcb = 'sortOrder';
const $d1be2b44eb126533$export$d8115099d465de4c = 'NO-FILTERS';
const $d1be2b44eb126533$var$initialVulnerabilityTableFilters = {
    searchFilter: '',
    connectionFilter: [],
    severityFilter: [],
    statusFilter: [
        'OPEN'
    ],
    jiraIssueStatusFilter: []
};
const $d1be2b44eb126533$export$e9b4ea84d666c490 = {
    sortKey: 'severity',
    sortOrder: 'DESC',
    ...$d1be2b44eb126533$var$initialVulnerabilityTableFilters
};

});

parcelRegister("3o4IF", function(module, exports) {

$parcel$export(module.exports, "arrayQueryParamToFilter", () => $dbe4482e2428caff$export$7500862c6689a767);
$parcel$export(module.exports, "arrayFilterToQueryParam", () => $dbe4482e2428caff$export$b0dee3c5bfc7249e);
$parcel$export(module.exports, "connectionFilterToQueryParam", () => $dbe4482e2428caff$export$a6950ca4fdc8498f);
$parcel$export(module.exports, "connectionQueryParamToFilter", () => $dbe4482e2428caff$export$1040034504af5b41);
$parcel$export(module.exports, "parseSeverity", () => $dbe4482e2428caff$export$3551b8a2cbdb5162);
$parcel$export(module.exports, "parseStatus", () => $dbe4482e2428caff$export$2188844eb84f7f06);
$parcel$export(module.exports, "parseSortDirection", () => $dbe4482e2428caff$export$85cf5c73b48a482e);

var $chc6P = parcelRequire("chc6P");

var $80afZ = parcelRequire("80afZ");

var $5eeaw = parcelRequire("5eeaw");

var $i3r1A = parcelRequire("i3r1A");
const $dbe4482e2428caff$var$DELIMITER = ',';
const $dbe4482e2428caff$var$ENCODED_DELIMITER = encodeURIComponent($dbe4482e2428caff$var$DELIMITER);
// We encode the delimiter to protect the values from containing
// the same character that delimits the list.
// e.g.
// env names = ["prod,east", "prod,west"] -> "prod,east,prod,west"
const $dbe4482e2428caff$var$encodeDelimiter = (input)=>{
    const regex = new RegExp($dbe4482e2428caff$var$DELIMITER, 'g');
    return input.replace(regex, $dbe4482e2428caff$var$ENCODED_DELIMITER);
};
const $dbe4482e2428caff$var$decodeDelimiter = (input)=>{
    const regex = new RegExp($dbe4482e2428caff$var$ENCODED_DELIMITER, 'g');
    return input.replace(regex, $dbe4482e2428caff$var$DELIMITER);
};
const $dbe4482e2428caff$export$7500862c6689a767 = (queryParamString)=>queryParamString?.split($dbe4482e2428caff$var$DELIMITER)?.map($dbe4482e2428caff$var$decodeDelimiter) ?? [];
const $dbe4482e2428caff$export$b0dee3c5bfc7249e = (filterArray)=>{
    if (filterArray.length === 0) return undefined;
    return filterArray.map((entity)=>$dbe4482e2428caff$var$encodeDelimiter(entity)).join($dbe4482e2428caff$var$DELIMITER);
};
const $dbe4482e2428caff$export$a6950ca4fdc8498f = (connectionArray)=>{
    if (connectionArray.length === 0) return undefined;
    const groupedConnectionsByAppKey = connectionArray.reduce((acc, connection)=>{
        const [, , , , securityParts] = connection.split(':');
        const [, , , appKey, ...containerId] = securityParts.split('/');
        if (!acc[appKey]) acc[appKey] = [];
        acc[appKey].push(containerId.join('/'));
        return acc;
    }, {});
    return JSON.stringify(groupedConnectionsByAppKey);
};
const $dbe4482e2428caff$export$1040034504af5b41 = (queryParamString, connectionAri)=>{
    if (!queryParamString) return [];
    const groupedConnectionsByAppKey = JSON.parse(queryParamString);
    return (0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(groupedConnectionsByAppKey, (containerIds, appKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($80afZ)))(containerIds, (containerId)=>`${connectionAri}${appKey}/${containerId}`));
};
const $dbe4482e2428caff$export$3551b8a2cbdb5162 = (maybeSeverity)=>{
    switch(maybeSeverity?.toUpperCase()){
        case (0, $i3r1A.VulnerabilitySeverityEnums).CRITICAL.toUpperCase():
            return (0, $i3r1A.VulnerabilitySeverityEnums).CRITICAL;
        case (0, $i3r1A.VulnerabilitySeverityEnums).HIGH.toUpperCase():
            return (0, $i3r1A.VulnerabilitySeverityEnums).HIGH;
        case (0, $i3r1A.VulnerabilitySeverityEnums).LOW.toUpperCase():
            return (0, $i3r1A.VulnerabilitySeverityEnums).LOW;
        case (0, $i3r1A.VulnerabilitySeverityEnums).MEDIUM.toUpperCase():
            return (0, $i3r1A.VulnerabilitySeverityEnums).MEDIUM;
        case (0, $i3r1A.VulnerabilitySeverityEnums).UNKNOWN.toUpperCase():
            return (0, $i3r1A.VulnerabilitySeverityEnums).UNKNOWN;
        default:
            return undefined;
    }
};
const $dbe4482e2428caff$export$2188844eb84f7f06 = (maybeStatus)=>{
    switch(maybeStatus?.toUpperCase()){
        case (0, $i3r1A.VulnerabilityStatusEnums).OPEN.toUpperCase():
            return (0, $i3r1A.VulnerabilityStatusEnums).OPEN;
        case (0, $i3r1A.VulnerabilityStatusEnums).UNKNOWN.toUpperCase():
            return (0, $i3r1A.VulnerabilityStatusEnums).UNKNOWN;
        case (0, $i3r1A.VulnerabilityStatusEnums).CLOSED.toUpperCase():
            return (0, $i3r1A.VulnerabilityStatusEnums).CLOSED;
        case (0, $i3r1A.VulnerabilityStatusEnums).IGNORED.toUpperCase():
            return (0, $i3r1A.VulnerabilityStatusEnums).IGNORED;
        default:
            return undefined;
    }
};
const $dbe4482e2428caff$export$85cf5c73b48a482e = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case (0, $5eeaw.AriGraphSortOrderInput).ASC.toUpperCase():
            return (0, $5eeaw.AriGraphSortOrderInput).ASC;
        case (0, $5eeaw.AriGraphSortOrderInput).DESC.toUpperCase():
            return (0, $5eeaw.AriGraphSortOrderInput).DESC;
        default:
            return defaultValue;
    }
};

});
parcelRegister("chc6P", function(module, exports) {

var $ekcP3 = parcelRequire("ekcP3");

var $80afZ = parcelRequire("80afZ");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $8f007734a6a4d9ac$var$flatMap(collection, iteratee) {
    return $ekcP3($80afZ(collection, iteratee), 1);
}
module.exports = $8f007734a6a4d9ac$var$flatMap;

});
parcelRegister("80afZ", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $bxDef = parcelRequire("bxDef");

var $jXnVG = parcelRequire("jXnVG");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $5d3647a04b83e8d6$var$map(collection, iteratee) {
    var func = $8LQ84(collection) ? $1nIHN : $jXnVG;
    return func(collection, $bxDef(iteratee, 3));
}
module.exports = $5d3647a04b83e8d6$var$map;

});


parcelRegister("i3r1A", function(module, exports) {

$parcel$export(module.exports, "VulnerabilitySeverityEnums", () => $e40f3ad586d15bb3$export$c1a102938d8dc10);
$parcel$export(module.exports, "VulnerabilityStatusEnums", () => $e40f3ad586d15bb3$export$2d6749bded378262);
const $e40f3ad586d15bb3$export$c1a102938d8dc10 = {
    CRITICAL: 'CRITICAL',
    HIGH: 'HIGH',
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    UNKNOWN: 'UNKNOWN'
};
const $e40f3ad586d15bb3$export$2d6749bded378262 = {
    CLOSED: 'CLOSED',
    IGNORED: 'IGNORED',
    OPEN: 'OPEN',
    UNKNOWN: 'UNKNOWN'
};
const $e40f3ad586d15bb3$var$VulnerabilityTypeEnums = {
    DAST: 'DAST',
    SAST: 'SAST',
    SCA: 'SCA',
    UNKNOWN: 'UNKNOWN'
};

});



const $0a72320b8bc3a1aa$export$f24db22c3c834cb1 = 'SOFTWARE_SECURITY';


parcelRegister("d1QwJ", function(module, exports) {

$parcel$export(module.exports, "softwareSecurityNextGenRoute", () => $38bba03addfade00$export$a2aed78ebacc3233);
const $38bba03addfade00$export$a2aed78ebacc3233 = {
    name: 'software-security',
    path: '/jira/software/projects/:projectKey/security'
};

});

parcelRegister("crK2h", function(module, exports) {

$parcel$export(module.exports, "isSecurityPageEnabled", () => $36196b3bd8f08294$export$f99b2868577ed515);

var $4R6GH = parcelRequire("4R6GH");

var $kfztd = parcelRequire("kfztd");
const $36196b3bd8f08294$export$f99b2868577ed515 = ()=>!(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && (0, $4R6GH.fg)('isotopes-security-page-in-jira-enabled-v2');

});

parcelRegister("d6VEe", function(module, exports) {

$parcel$export(module.exports, "LazySecurity", () => $55f0942675d36799$export$30c10c4b0cb1d8e3);

var $7yO8g = parcelRequire("7yO8g");

var $b7Svb = parcelRequire("b7Svb");

const $55f0942675d36799$export$30c10c4b0cb1d8e3 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hKUPu"))), {
    moduleId: "./src/packages/spa-apps/security/src/ui/index-old.tsx"
});

});
parcelRegister("hKUPu", function(module, exports) {

let $ced2d0b6e4b3282a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ced2d0b6e4b3282a$var$load("h2MrD"),
    $ced2d0b6e4b3282a$var$load("bYT2S"),
    $ced2d0b6e4b3282a$var$load("incBn")
]).then(()=>parcelRequire('4VJKh'));

});


parcelRegister("7AM4I", function(module, exports) {

$parcel$export(module.exports, "securityPageEntrypoint", () => $3090928057015737$export$5f2f9dbf41e3e769);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $kyG7f = parcelRequire("kyG7f");

var $fo6b8 = parcelRequire("fo6b8");
const $3090928057015737$export$5f2f9dbf41e3e769 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $kyG7f.securityEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("kyG7f", function(module, exports) {

$parcel$export(module.exports, "securityEntrypoint", () => $9ed435daf1131762$export$63f7fc80f88b035a);

var $cfawy = parcelRequire("cfawy");

var $3rdd7 = parcelRequire("3rdd7");

const $9ed435daf1131762$export$63f7fc80f88b035a = (0, $3rdd7.createEntryPoint)({
    root: (0, $cfawy.JSResourceForUserVisible)(()=>(parcelRequire("2gUzc")), {
        moduleId: "c02ceeea"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2gUzc", function(module, exports) {

let $1a78f45bf325f3a8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1a78f45bf325f3a8$var$load("h2MrD"),
    $1a78f45bf325f3a8$var$load("bYT2S"),
    $1a78f45bf325f3a8$var$load("65QdE")
]).then(()=>parcelRequire('9J8Ay'));

});




parcelRegister("9EGBH", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryRouteEntry", () => $68cc040c529fc630$export$a2560b0baf928c49);

var $e4eHl = parcelRequire("e4eHl");

var $ffza4 = parcelRequire("ffza4");

var $lkFvK = parcelRequire("lkFvK");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $7P9Hl = parcelRequire("7P9Hl");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $1wsDh = parcelRequire("1wsDh");

var $fo6b8 = parcelRequire("fo6b8");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $f3iuv = parcelRequire("f3iuv");
/**
 * @deprecated delete when cleaning up project_summary_page_entry_point_migration
 */ const $68cc040c529fc630$var$getHorizontalNavResources = ()=>(0, $4R6GH.fg)('project_summary_page_entry_point_migration') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $68cc040c529fc630$var$summarySoftwarePageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1wsDh.summarySoftwareEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $68cc040c529fc630$export$a2560b0baf928c49 = (0, $7NszV.createEntry)((0, $7P9Hl.softwareSummaryRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-summary',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('helios_summary_page_experiment', 'isEnabled', false), (0, $f3iuv.SummaryPage), (0, $5lsNZ.default)),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            /// delete when cleaning up project_summary_page_entry_point_migration
            ...$68cc040c529fc630$var$getHorizontalNavResources(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $f3iuv.LazySummaryView)
        ],
        meta: {
            reporting: {
                id: 'software-summary',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-summary'),
                teamName: 'Helios - Reports'
            }
        },
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('project_summary_page_entry_point_migration')) return $68cc040c529fc630$var$summarySoftwarePageEntrypoint;
        }
    }));

});
parcelRegister("7P9Hl", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryRoute", () => $cff79d22061504ff$export$c6629202e90df62a);
const $cff79d22061504ff$export$c6629202e90df62a = {
    name: 'software-summary',
    path: '/jira/software/projects/:projectKey/summary'
};

});

parcelRegister("1wsDh", function(module, exports) {

$parcel$export(module.exports, "summarySoftwareEntrypoint", () => $be62f623caf39bbf$export$6c7cf31fcbd213b8);

var $6qQRa = parcelRequire("6qQRa");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $be62f623caf39bbf$export$6c7cf31fcbd213b8 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("iVuHf")), {
        moduleId: "078ea488"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $6qQRa.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("6qQRa", function(module, exports) {

$parcel$export(module.exports, "default", () => $84891a6ef49bdd23$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2c0776ec3e9f6a74e53887f11a831651>>
 * @relayHash 51efb3864f270fc508c3c4676be5d9f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b8af805c4172b0ed36c74fe68563d0a938d57e1cf91158c7fa6cbe92c6dc022
const $84891a6ef49bdd23$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8b8af805c4172b0ed36c74fe68563d0a938d57e1cf91158c7fa6cbe92c6dc022",
        "metadata": {},
        "name": "src_jiraSummarySoftwareQuery",
        "operationKind": "query",
        "text": null
    }
};
var $84891a6ef49bdd23$export$2e2bcd8739ae039 = $84891a6ef49bdd23$var$node;

});

parcelRegister("iVuHf", function(module, exports) {

let $dc755c891d3e3e79$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dc755c891d3e3e79$var$load("dsiAd"),
    $dc755c891d3e3e79$var$load("k74yl")
]).then(()=>parcelRequire('l0bjd'));

});


parcelRegister("f3iuv", function(module, exports) {

$parcel$export(module.exports, "LazySummaryView", () => $d82700466a756427$export$68c09444cc6f2843);
$parcel$export(module.exports, "SummaryPage", () => $d82700466a756427$export$893608e1a22999b9);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $d82700466a756427$export$68c09444cc6f2843 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("8nVRl")), {
    moduleId: "./src/packages/spa-apps/software/summary/src/index.tsx"
});
const $d82700466a756427$export$893608e1a22999b9 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d82700466a756427$export$68c09444cc6f2843,
        pageId: "software-summary",
        shouldShowSpinner: true
    });
};

});
parcelRegister("8nVRl", function(module, exports) {

let $61ad5a5dd262d9c8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $61ad5a5dd262d9c8$var$load("dsiAd"),
    $61ad5a5dd262d9c8$var$load("4VHZG")
]).then(()=>parcelRequire('iPGiI'));

});



parcelRegister("45nsl", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryEmbedRouteEntry", () => $68cfbfd8adbf1577$export$d0dcb1130082d8e);

var $e4eHl = parcelRequire("e4eHl");

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $5lsNZ = parcelRequire("5lsNZ");

var $czTBf = parcelRequire("czTBf");

var $5bkvv = parcelRequire("5bkvv");

var $dxCvy = parcelRequire("dxCvy");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $9Hxle = parcelRequire("9Hxle");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $jEWyg = parcelRequire("jEWyg");
const $68cfbfd8adbf1577$var$summarySoftwareEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $9Hxle.summarySoftwareEmbedEntrypoint)
});
const $68cfbfd8adbf1577$export$d0dcb1130082d8e = (0, $7NszV.createEntry)((0, $czTBf.softwareSummaryEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-summary-embed',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('jsw-summary-page-embed-smart-link-experiment', 'isEnabled', false), (0, $jEWyg.SummaryEmbedPage), (0, $5lsNZ.default)),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource)
        ],
        forPaint: [
            (0, $jEWyg.LazySummaryEmbedView)
        ],
        meta: {
            reporting: {
                id: 'software-summary-embed',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-summary-embed'),
                teamName: 'Helios - Reports'
            }
        },
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('project_summary_page_entry_point_migration')) return $68cfbfd8adbf1577$var$summarySoftwareEmbedPageEntrypoint;
        }
    }));

});
parcelRegister("czTBf", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryEmbedRoute", () => $47c531ece2da49b6$export$11863f01f5694529);
const $47c531ece2da49b6$export$11863f01f5694529 = {
    name: 'software-summary-embed',
    path: '/jira/software/projects/:projectKey/summary/embed'
};

});

parcelRegister("9Hxle", function(module, exports) {

$parcel$export(module.exports, "summarySoftwareEmbedEntrypoint", () => $dceaf7b32f2cb59b$export$4eeb5d2e0e9b94b6);

var $31XuO = parcelRequire("31XuO");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $dceaf7b32f2cb59b$export$4eeb5d2e0e9b94b6 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("2VumR")), {
        moduleId: "192c966d"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $31XuO.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("31XuO", function(module, exports) {

$parcel$export(module.exports, "default", () => $48d77923a7d779ad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<28aa849ce641b8c8bef67b5f178b9188>>
 * @relayHash 886a8ebe0b7faaa17276f23a1313cc2e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ec953cd8f672124749ec67356940dfd48e2bc1b926c2f3ce46d963fbecdceed3
const $48d77923a7d779ad$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ec953cd8f672124749ec67356940dfd48e2bc1b926c2f3ce46d963fbecdceed3",
        "metadata": {},
        "name": "src_jiraSummarySoftwareEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $48d77923a7d779ad$export$2e2bcd8739ae039 = $48d77923a7d779ad$var$node;

});

parcelRegister("2VumR", function(module, exports) {

let $2218760fb53967cb$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2218760fb53967cb$var$load("dsiAd"),
    $2218760fb53967cb$var$load("boIe9")
]).then(()=>parcelRequire('3aj3b'));

});


parcelRegister("jEWyg", function(module, exports) {

$parcel$export(module.exports, "LazySummaryEmbedView", () => $e2492c3e1d27fc60$export$f3f4cdbc1967d695);
$parcel$export(module.exports, "SummaryEmbedPage", () => $e2492c3e1d27fc60$export$f811b1e7f401bfca);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $e2492c3e1d27fc60$export$f3f4cdbc1967d695 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("daTmo")), {
    moduleId: "./src/packages/spa-apps/software/summary-embed/src/index.tsx"
});
const $e2492c3e1d27fc60$export$f811b1e7f401bfca = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e2492c3e1d27fc60$export$f3f4cdbc1967d695,
        pageId: "software-summary-embed",
        shouldShowSpinner: true
    });
};

});
parcelRegister("daTmo", function(module, exports) {

let $997726effa452413$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $997726effa452413$var$load("dsiAd"),
    $997726effa452413$var$load("co42o")
]).then(()=>parcelRequire('ipup0'));

});



parcelRegister("jejF3", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineRouteEntry", () => $e9207ae3efc3becd$export$ace6a996c7e99f3);

var $ffza4 = parcelRequire("ffza4");

var $4R6GH = parcelRequire("4R6GH");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $jsFU4 = parcelRequire("jsFU4");

var $7GnDe = parcelRequire("7GnDe");

var $3gei1 = parcelRequire("3gei1");

var $8STJR = parcelRequire("8STJR");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $dPHex = parcelRequire("dPHex");

var $fAhgR = parcelRequire("fAhgR");
/** @deprecated remove when cleaning up 'fun-1630-migrate-software-timeline-to-entrypoint' */ const $e9207ae3efc3becd$var$getHorizontalNavResource = ()=>(0, $4R6GH.fg)('fun-1630-migrate-software-timeline-to-entrypoint') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $e9207ae3efc3becd$export$ace6a996c7e99f3 = (0, $7NszV.createEntry)((0, $3gei1.softwareTimelineRoute), ()=>({
        group: 'software',
        component: (0, $dPHex.default),
        skeleton: (0, $8STJR.RoadmapSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            ...$e9207ae3efc3becd$var$getHorizontalNavResource(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $jsFU4.nextGenRoadmapResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dPHex.LazyNextGenRoadmap)
        ],
        entryPoint: ()=>(0, $4R6GH.fg)('fun-1630-migrate-software-timeline-to-entrypoint') ? (0, $fAhgR.softwareTimelinePageEntrypoint) : undefined,
        ufoName: 'next-gen-roadmap'
    }));

});
parcelRegister("3gei1", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineRoute", () => $2ea9397ffa8c64ef$export$d25dafcda96d5af9);
const $2ea9397ffa8c64ef$export$d25dafcda96d5af9 = {
    name: 'software-timeline',
    path: '/jira/software/projects/:projectKey/boards/:boardId/timeline'
};

});

parcelRegister("dPHex", function(module, exports) {

$parcel$export(module.exports, "LazyNextGenRoadmap", () => $fb90f6d8614b90fc$export$1339c847cf4ab57);
$parcel$export(module.exports, "default", () => $fb90f6d8614b90fc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $fb90f6d8614b90fc$export$1339c847cf4ab57 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1ofXp"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index-old.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fb90f6d8614b90fc$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $fb90f6d8614b90fc$export$1339c847cf4ab57,
        pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });

});
parcelRegister("1ofXp", function(module, exports) {

let $10346916804ecaf0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $10346916804ecaf0$var$load("5LRum").then(()=>parcelRequire('6gJ9X'));

});


parcelRegister("fAhgR", function(module, exports) {

$parcel$export(module.exports, "softwareTimelinePageEntrypoint", () => $faefef5a329d510c$export$3315ee4fac32ee8);

var $lkFvK = parcelRequire("lkFvK");

var $fo6b8 = parcelRequire("fo6b8");

var $lmyls = parcelRequire("lmyls");

var $fT58V = parcelRequire("fT58V");

var $krpZe = parcelRequire("krpZe");

var $7lSbA = parcelRequire("7lSbA");
const $faefef5a329d510c$export$3315ee4fac32ee8 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7lSbA.softwareTimelineEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $krpZe.nav4ProjectsContentEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("7lSbA", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineEntrypoint", () => $db07900879e9590e$export$85a905c235ac34bb);

var $cfawy = parcelRequire("cfawy");

var $3rdd7 = parcelRequire("3rdd7");

const $db07900879e9590e$export$85a905c235ac34bb = (0, $3rdd7.createEntryPoint)({
    root: (0, $cfawy.JSResourceForUserVisible)(()=>(parcelRequire("emv4G")), {
        moduleId: "7e6b0610"
    }),
    getPreloadProps: ()=>({})
});

});



parcelRegister("eKEYN", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailEmbedRouteEntry", () => $f99c918791c41018$export$83102a6097008c79);

var $e4eHl = parcelRequire("e4eHl");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $kt0pG = parcelRequire("kt0pG");

var $4gudm = parcelRequire("4gudm");

var $bQc17 = parcelRequire("bQc17");

var $jchNA = parcelRequire("jchNA");
const $f99c918791c41018$export$83102a6097008c79 = (0, $7NszV.createEntry)((0, $4gudm.softwareVersionDetailEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'software.version-details-page-embed',
        component: (0, $jchNA.VersionDetailPage),
        skeleton: (0, $bQc17.VersionDetailSkeleton),
        canTransitionIn: ()=>true,
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $kt0pG.versionDetailsRelayResourceCustom),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $jchNA.LazyVersionDetail)
        ],
        meta: {
            reporting: {
                id: 'software-version-detail-embed',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-version-detail-embed'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("kt0pG", function(module, exports) {

$parcel$export(module.exports, "versionDetailsRelayResourceCustom", () => $57dfad429d4f47cb$export$c56c5b19da4d0fd1);
/* eslint-disable jira/import-whitelist */ 
var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $dXq4S = parcelRequire("dXq4S");

var $5yJb9 = parcelRequire("5yJb9");

var $kipqU = parcelRequire("kipqU");

var $ao2h1 = parcelRequire("ao2h1");

var $dvgjB = parcelRequire("dvgjB");

var $kfztd = parcelRequire("kfztd");

var $20fNh = parcelRequire("20fNh");

var $9NiTW = parcelRequire("9NiTW");

var $2M1hQ = parcelRequire("2M1hQ");

const $57dfad429d4f47cb$export$c56c5b19da4d0fd1 = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${(0, $afc34106ac722f11$export$9fe575a15a87a796)}`,
    // Deliberately returning the static key, not to rerun query by resource, as different key returns null queryReference shortly while the query is running, when filter query parameter is changed,
    // which is believed to be a bug in react-resource-router part, but we don't know the reason yet.
    // Context: https://atlassian.slack.com/archives/CFLN3FEF8/p1680495188086669
    // Due to the same bug, issue navigator team is doing the similar technique: src/packages/routes/src/ui/spa/issue-navigator/resources/index.tsx
    getKey: ({ match: match })=>{
        const { versionId: versionId } = match.params;
        const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
        return `jsw-releases-version-details-main-query-relay-${parsedVersionId}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { versionId: versionId } = match.params;
        const { filters: filters, sortBy: sortBy } = (0, $20fNh.toVersionIssuesGraphQLVariables)(query);
        const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
        // eslint-disable-next-line jira/ff/inline-usage
        const variables = {
            cloudAri: (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                resourceType: 'site',
                resourceId: tenantContext.cloudId
            }),
            versionAri: (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'version/activation',
                resourceId: String(`${tenantContext.activationId}/${parsedVersionId}`)
            }),
            sortBy: sortBy,
            filters: filters,
            skip: !(0, $9NiTW.checkAuthentication)(tenantContext) || parsedVersionId.length === 0,
            isDevopsFeatureDisabledInFedRamp: (0, $kfztd.isDevopsFeatureDisabledInFedRamp)(),
            isIssueSummarisedDeploymentsMigratedToAgs: (0, $4R6GH.fg)('solaris_migrate_summurized_deployments_to_ags_re'),
            shouldIncludeDevOpsFieldsViaAgs: !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && (0, $4R6GH.fg)('solaris_migrate_summurized_deployments_to_ags_re')
        };
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $dvgjB.default), variables, {
            fetchPolicy: 'store-or-network'
        });
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
parcelRegister("dvgjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ecc7304dc73fa0e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<37952b45cd15a0551c68e3e39fcc6055>>
 * @relayHash 4d18fcb1c42e00bfa3f11ddd155c373e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 66eb79e0bbddd55d9e9908ec4f4f73d0d72e4a23120245a1c5496d50739c7671
const $8ecc7304dc73fa0e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "66eb79e0bbddd55d9e9908ec4f4f73d0d72e4a23120245a1c5496d50739c7671",
        "metadata": {},
        "name": "uiVersionDetailsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8ecc7304dc73fa0e$export$2e2bcd8739ae039 = $8ecc7304dc73fa0e$var$node;

});

parcelRegister("20fNh", function(module, exports) {

$parcel$export(module.exports, "toVersionIssuesGraphQLVariables", () => $3e331943907e0f7c$export$72df1c7780b3e8e2);
$parcel$export(module.exports, "useVersionIssuesGraphQLVariables", () => $3e331943907e0f7c$export$3d12d3ffbce57135);

var $3hGWp = parcelRequire("3hGWp");


var $jPgXx = parcelRequire("jPgXx");

var $3dG8c = parcelRequire("3dG8c");
const $3e331943907e0f7c$var$accountIdToAriStr = (accountIds)=>{
    if (accountIds == null) return null;
    return accountIds.map((accountId)=>accountId === 'UNASSIGNED' ? null : `ari:cloud:identity::user/${accountId}`);
};
const $3e331943907e0f7c$export$72df1c7780b3e8e2 = (queryParams)=>{
    const parsedQueryParams = (0, $3dG8c.parseQueryParams)(queryParams);
    return {
        filters: {
            searchStr: parsedQueryParams[0, $5d187be87424268f$export$e39925d10cebc0b] ?? null,
            epicIds: parsedQueryParams[0, $5d187be87424268f$export$b98a7875ddbefaac] ?? null,
            statusCategories: parsedQueryParams[0, $5d187be87424268f$export$c307007520232013] != null ? parsedQueryParams[0, $5d187be87424268f$export$c307007520232013].filter((0, $jPgXx.isVersionStatusCategory)) : null,
            warningCategories: parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd] ?? null,
            assigneeAccountIds: $3e331943907e0f7c$var$accountIdToAriStr(parsedQueryParams[0, $5d187be87424268f$export$f78d8c81fcad32a2])
        },
        sortBy: {
            sortByField: parsedQueryParams[0, $5d187be87424268f$export$13d5b2891ca65cd6] ?? 'CREATED',
            order: parsedQueryParams[0, $5d187be87424268f$export$810a1f7ed2facfcb] ?? 'ASC'
        }
    };
};
const $3e331943907e0f7c$export$3d12d3ffbce57135 = ()=>{
    const [queryParams] = (0, $3hGWp.useQueryParams)((0, $5d187be87424268f$export$e39925d10cebc0b), (0, $5d187be87424268f$export$b98a7875ddbefaac), (0, $5d187be87424268f$export$c307007520232013), (0, $5d187be87424268f$export$2552faed9df6a2cd), (0, $5d187be87424268f$export$f78d8c81fcad32a2), (0, $5d187be87424268f$export$13d5b2891ca65cd6), (0, $5d187be87424268f$export$810a1f7ed2facfcb));
    return $3e331943907e0f7c$export$72df1c7780b3e8e2(queryParams);
};

});
parcelRegister("3hGWp", function(module, exports) {

$parcel$export(module.exports, "useQueryParams", () => $afd0e0a12e1f2496$export$b37ee0d76c6d2fbc);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $hGgHi = parcelRequire("hGgHi");

var $9xWGk = parcelRequire("9xWGk");

var $ebyGx = parcelRequire("ebyGx");

var $doZTA = parcelRequire("doZTA");
const $afd0e0a12e1f2496$export$b37ee0d76c6d2fbc = (...queryParamsToWatch)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push, replace: replace }] = (0, $doZTA.useRouter)();
    const queryParamsRef = (0, $5uXOq.useRef)({});
    const parsedQueryParams = (0, $5uXOq.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = queryParamsToWatch.reduce((accumulator, currentValue)=>{
            accumulator[currentValue] = query[currentValue] || undefined;
            return accumulator;
        }, {});
        // update cache only when one of requested params actually changed
        // otherwise return cached value to avoid changing return object reference
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(queryParamsRef.current, newQueryParams)) queryParamsRef.current = newQueryParams;
        return queryParamsRef.current;
    }, [
        query,
        queryParamsToWatch
    ]);
    const setQueryParams = (0, $5uXOq.useCallback)((newQueryParams, options)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
            ...query,
            ...newQueryParams
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value));
        const { updateType: updateType, ...stringifyOptions } = options ?? {};
        // @ts-expect-error - TS2559 - Type '{ sort?: false | ((a: string, b: string) => number) | undefined; }' has no properties in common with type 'StringifyOptions'.
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(parsedSearch, stringifyOptions);
        const url = pathname + (strSearch !== '' ? `?${strSearch}` : '');
        updateType === 'replace' ? replace(url) : push(url);
    }, [
        pathname,
        push,
        replace,
        query
    ]);
    return [
        parsedQueryParams,
        setQueryParams
    ];
};

});

const $5d187be87424268f$export$e39925d10cebc0b = 'text';
const $5d187be87424268f$export$b98a7875ddbefaac = 'epics';
const $5d187be87424268f$export$c307007520232013 = 'statusCategory';
const $5d187be87424268f$export$2552faed9df6a2cd = 'warnings';
const $5d187be87424268f$export$f78d8c81fcad32a2 = 'assignee';
const $5d187be87424268f$export$13d5b2891ca65cd6 = 'sortBy';
const $5d187be87424268f$export$810a1f7ed2facfcb = 'sortOrder';

parcelRegister("jPgXx", function(module, exports) {

$parcel$export(module.exports, "isWarningsFilterValue", () => $1bd9df170beee33d$export$5c25bcf27380084);
$parcel$export(module.exports, "toWarningsFilterValue", () => $1bd9df170beee33d$export$ac3017cd78edb8a1);
$parcel$export(module.exports, "isVersionStatusCategory", () => $1bd9df170beee33d$export$3af93bbba0d4241a);
$parcel$export(module.exports, "isSortBy", () => $1bd9df170beee33d$export$472650e4cbd40b70);
$parcel$export(module.exports, "isSortOrder", () => $1bd9df170beee33d$export$dfece8cb679d32a3);

var $gULOk = parcelRequire("gULOk");
const $1bd9df170beee33d$export$5c25bcf27380084 = (val)=>val === 'OPEN_PULL_REQUEST' || val === 'UNREVIEWED_CODE' || val === 'FAILING_BUILD' || val === 'OPEN_REVIEW';
const $1bd9df170beee33d$export$ac3017cd78edb8a1 = (statusCategoryFromQueryParam)=>statusCategoryFromQueryParam.filter($1bd9df170beee33d$export$5c25bcf27380084);
const $1bd9df170beee33d$export$3af93bbba0d4241a = (val)=>val === (0, $gULOk.TODO) || val === (0, $gULOk.IN_PROGRESS) || val === (0, $gULOk.DONE);
const $1bd9df170beee33d$export$472650e4cbd40b70 = (val)=>val === 'ASSIGNEE' || val === 'CREATED' || val === 'KEY' || val === 'PRIORITY' || val === 'STATUS' || val === 'TYPE';
const $1bd9df170beee33d$export$dfece8cb679d32a3 = (val)=>val === 'ASC' || val === 'DESC';

});
parcelRegister("gULOk", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e77315bf13f8b83b$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e77315bf13f8b83b$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e77315bf13f8b83b$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e77315bf13f8b83b$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e77315bf13f8b83b$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e77315bf13f8b83b$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e77315bf13f8b83b$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e77315bf13f8b83b$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e77315bf13f8b83b$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e77315bf13f8b83b$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e77315bf13f8b83b$export$d928f247c903643a);
const $e77315bf13f8b83b$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e77315bf13f8b83b$export$aa456a5030160740 = 'TODO';
const $e77315bf13f8b83b$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e77315bf13f8b83b$export$71efb3495f6084f2 = 'DONE';
const $e77315bf13f8b83b$export$d9119300f9d9a815 = [
    $e77315bf13f8b83b$export$6db089fe7b26f5b6,
    $e77315bf13f8b83b$export$aa456a5030160740,
    $e77315bf13f8b83b$export$5a9ac66c2785cc13,
    $e77315bf13f8b83b$export$71efb3495f6084f2
];
const $e77315bf13f8b83b$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e77315bf13f8b83b$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e77315bf13f8b83b$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e77315bf13f8b83b$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e77315bf13f8b83b$export$71efb3495f6084f2
    }
];
const $e77315bf13f8b83b$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e77315bf13f8b83b$export$3f42f49c284d5b58 = Object.freeze({
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.NEW]: 2,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.DONE]: 3,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e77315bf13f8b83b$export$f3f919dc0f56d9eb = Object.values($e77315bf13f8b83b$export$5d42a08d46cffe7);
const $e77315bf13f8b83b$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e77315bf13f8b83b$export$6db089fe7b26f5b6;
};
const $e77315bf13f8b83b$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e77315bf13f8b83b$export$d928f247c903643a = (key)=>$e77315bf13f8b83b$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});


parcelRegister("3dG8c", function(module, exports) {

$parcel$export(module.exports, "isAnyFilterApplied", () => $89761db99e7e0304$export$e6b3ec1d09429da8);
$parcel$export(module.exports, "parseQueryParams", () => $89761db99e7e0304$export$67c4cee80a3410cd);

var $g5X3G = parcelRequire("g5X3G");


var $jPgXx = parcelRequire("jPgXx");
const $89761db99e7e0304$export$e6b3ec1d09429da8 = (parsedQueryParams)=>parsedQueryParams[0, $5d187be87424268f$export$e39925d10cebc0b] != null && parsedQueryParams[0, $5d187be87424268f$export$e39925d10cebc0b].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$b98a7875ddbefaac] != null && parsedQueryParams[0, $5d187be87424268f$export$b98a7875ddbefaac].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$c307007520232013] != null && parsedQueryParams[0, $5d187be87424268f$export$c307007520232013].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd] != null && parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$f78d8c81fcad32a2] != null && parsedQueryParams[0, $5d187be87424268f$export$f78d8c81fcad32a2].length > 0;
const $89761db99e7e0304$export$2a2e94972ab280d4 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).map((0, $g5X3G.toIssueId));
const $89761db99e7e0304$export$fb136b568c6d78b5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).filter((0, $jPgXx.isVersionStatusCategory));
const $89761db99e7e0304$export$5cb324c621ca24e8 = (paramValue)=>paramValue == null ? undefined : (0, $jPgXx.toWarningsFilterValue)(paramValue.split(',').map((str)=>str.trim()));
const $89761db99e7e0304$export$6c8eda0352c7cf5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>(0, $g5X3G.toAccountId)(str.trim()));
const $89761db99e7e0304$export$67c4cee80a3410cd = (paramsRaw)=>{
    const result = {};
    result[0, $5d187be87424268f$export$e39925d10cebc0b] = paramsRaw[0, $5d187be87424268f$export$e39925d10cebc0b];
    result[0, $5d187be87424268f$export$b98a7875ddbefaac] = $89761db99e7e0304$export$2a2e94972ab280d4(paramsRaw[0, $5d187be87424268f$export$b98a7875ddbefaac]);
    result[0, $5d187be87424268f$export$c307007520232013] = $89761db99e7e0304$export$fb136b568c6d78b5(paramsRaw[0, $5d187be87424268f$export$c307007520232013]);
    result[0, $5d187be87424268f$export$2552faed9df6a2cd] = $89761db99e7e0304$export$5cb324c621ca24e8(paramsRaw[0, $5d187be87424268f$export$2552faed9df6a2cd]);
    result[0, $5d187be87424268f$export$f78d8c81fcad32a2] = $89761db99e7e0304$export$6c8eda0352c7cf5(paramsRaw[0, $5d187be87424268f$export$f78d8c81fcad32a2]);
    result[0, $5d187be87424268f$export$13d5b2891ca65cd6] = paramsRaw[0, $5d187be87424268f$export$13d5b2891ca65cd6] && (0, $jPgXx.isSortBy)(paramsRaw[0, $5d187be87424268f$export$13d5b2891ca65cd6]) ? paramsRaw[0, $5d187be87424268f$export$13d5b2891ca65cd6] : 'CREATED';
    result[0, $5d187be87424268f$export$810a1f7ed2facfcb] = paramsRaw[0, $5d187be87424268f$export$810a1f7ed2facfcb] && (0, $jPgXx.isSortOrder)(paramsRaw[0, $5d187be87424268f$export$810a1f7ed2facfcb]) ? paramsRaw[0, $5d187be87424268f$export$810a1f7ed2facfcb] : 'ASC';
    return result;
};

});


const $afc34106ac722f11$export$9fe575a15a87a796 = 'PROJECTS_VERSION_DETAILS';


parcelRegister("4gudm", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailEmbedRoute", () => $901ac67e36c3672e$export$78d11017d9c9ed74);
const $901ac67e36c3672e$export$78d11017d9c9ed74 = {
    name: 'software-version-detail-embed',
    path: '/projects/:projectKey/versions/:versionId/tab/:tab/embed',
    exact: true
};

});

parcelRegister("bQc17", function(module, exports) {

$parcel$export(module.exports, "VersionDetailSkeleton", () => $d1c9f0513946a9ed$export$b3661a594ba34350);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $eFyfI = parcelRequire("eFyfI");
const $d1c9f0513946a9ed$export$b3661a594ba34350 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eFyfI)))
    });

});
parcelRegister("eFyfI", function(module, exports) {
module.exports = new URL("version-detail-skeleton.tpl.c4c4fc18.svg", import.meta.url).toString();

});


parcelRegister("jchNA", function(module, exports) {

$parcel$export(module.exports, "LazyVersionDetail", () => $5cbf8f752618c8e3$export$2d31f5f47e6584e0);
$parcel$export(module.exports, "VersionDetailPage", () => $5cbf8f752618c8e3$export$231cc5186b991031);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $5cbf8f752618c8e3$export$2d31f5f47e6584e0 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jeHjy"))), {
    moduleId: "./src/packages/spa-apps/version-detail/src/index.tsx"
});
const $5cbf8f752618c8e3$export$231cc5186b991031 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $5cbf8f752618c8e3$export$2d31f5f47e6584e0,
        pageId: "version-detail",
        shouldShowSpinner: false
    });

});
parcelRegister("jeHjy", function(module, exports) {

let $e010ec799a9dfd00$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e010ec799a9dfd00$var$load("cM9em"),
    $e010ec799a9dfd00$var$load("fr9NE"),
    $e010ec799a9dfd00$var$load("h2MrD"),
    $e010ec799a9dfd00$var$load("bYT2S"),
    $e010ec799a9dfd00$var$load("cnMnO")
]).then(()=>parcelRequire('2WNCY'));

});



parcelRegister("fwjnc", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailLegacyRedirectRouteEntry", () => $d779d838fb39524b$export$f29aafdff734071c);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $1ZoQ4 = parcelRequire("1ZoQ4");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $jchNA = parcelRequire("jchNA");

var $3eNdg = parcelRequire("3eNdg");
const $d779d838fb39524b$export$f29aafdff734071c = (0, $7NszV.createEntry)((0, $1ZoQ4.softwareVersionDetailLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $3eNdg.VersionDetailPageLegacyRedirect),
        canTransitionIn: ()=>true,
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: [
                (0, $koWFd.default),
                (0, $9s3j1.default)
            ],
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jchNA.LazyVersionDetail)
        ]
    }));

});
parcelRegister("1ZoQ4", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailLegacyRedirectRoute", () => $29228b2ecd57a3f4$export$3fc8dbcec208bca0);
const $29228b2ecd57a3f4$export$3fc8dbcec208bca0 = {
    name: 'software-version-detail-legacy-redirect',
    path: '/browse/:projectKey/fixforversion/:versionId'
};

});

parcelRegister("3eNdg", function(module, exports) {

$parcel$export(module.exports, "VersionDetailPageLegacyRedirect", () => $b28890d7be7b5f20$export$8524eef1a0d9339);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $b28890d7be7b5f20$export$8524eef1a0d9339 = ({ match: { params: { projectKey: projectKey, versionId: versionId, tab: tab } } })=>{
    // This should never happen as if it wasn't matched, this won't be rendered unless someone re-used this component in a wrong route.
    if (projectKey == null || versionId == null) throw Error('projectKey or versionId not found in match object of RouteContext');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/projects/${projectKey}/versions/${versionId}/tab/${tab != null ? tab : 'release-report-all-issues'}`
    });
};

});


parcelRegister("1KC4N", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailNoTabPathRedirectRouteEntry", () => $91cff4b09df91d45$export$28d16aae32969765);

var $ffza4 = parcelRequire("ffza4");

var $5f2bR = parcelRequire("5f2bR");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $aLgIl = parcelRequire("aLgIl");

var $e7bC3 = parcelRequire("e7bC3");

var $jchNA = parcelRequire("jchNA");

var $3eNdg = parcelRequire("3eNdg");
const $91cff4b09df91d45$export$28d16aae32969765 = (0, $7NszV.createEntry)((0, $aLgIl.softwareVersionDetailNoTabPathRedirectRoute), ()=>({
        group: 'software',
        component: (0, $3eNdg.VersionDetailPageLegacyRedirect),
        canTransitionIn: ()=>true,
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: [
                (0, $koWFd.default),
                (0, $9s3j1.default)
            ],
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jchNA.LazyVersionDetail)
        ]
    }));

});
parcelRegister("aLgIl", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailNoTabPathRedirectRoute", () => $bfff597194375de5$export$f22288f2d2f1b9ea);
const $bfff597194375de5$export$f22288f2d2f1b9ea = {
    name: 'software-version-detail-no-tab-path',
    path: '/projects/:projectKey/versions/:versionId'
};

});


parcelRegister("7ApVe", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailRouteEntry", () => $0034963e375ba907$export$c97dabcfe9d495fa);

var $e4eHl = parcelRequire("e4eHl");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $kt0pG = parcelRequire("kt0pG");

var $12flw = parcelRequire("12flw");

var $bQc17 = parcelRequire("bQc17");

var $e7bC3 = parcelRequire("e7bC3");

var $jchNA = parcelRequire("jchNA");
const $0034963e375ba907$export$c97dabcfe9d495fa = (0, $7NszV.createEntry)((0, $12flw.softwareVersionDetailRoute), ()=>({
        group: 'software',
        ufoName: 'software.version-details-page',
        component: (0, $jchNA.VersionDetailPage),
        skeleton: (0, $bQc17.VersionDetailSkeleton),
        canTransitionIn: ()=>true,
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: [
                (0, $koWFd.default),
                (0, $9s3j1.default)
            ]
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $kt0pG.versionDetailsRelayResourceCustom),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jchNA.LazyVersionDetail)
        ],
        meta: {
            reporting: {
                id: 'software-version-detail',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-version-detail'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("12flw", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailRoute", () => $da1ceb4f01a49a44$export$eb3633614d0521b0);
const $da1ceb4f01a49a44$export$eb3633614d0521b0 = {
    name: 'software-version-detail',
    path: '/projects/:projectKey/versions/:versionId/tab/:tab'
};

});


parcelRegister("2vUs2", function(module, exports) {

$parcel$export(module.exports, "trashProjectsDirectoryRedirectRouteEntry", () => $c7ed25d526b7ed1b$export$8ea64bac0a832a5c);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $4jMkc = parcelRequire("4jMkc");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $71tTP = parcelRequire("71tTP");

var $aphUL = parcelRequire("aphUL");

var $8gSP9 = parcelRequire("8gSP9");
const $c7ed25d526b7ed1b$export$8ea64bac0a832a5c = (0, $7NszV.createEntry)((0, $71tTP.trashProjectsDirectoryRedirectRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.trashed-projects',
        component: (0, $aphUL.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8gSP9.LazyTrashedProjectsAdmin)
        ],
        isRedirect: true
    }));

});
parcelRegister("71tTP", function(module, exports) {

$parcel$export(module.exports, "trashProjectsDirectoryRedirectRoute", () => $99acde7d7c12a8d4$export$6eafffd4489b3d4);
const $99acde7d7c12a8d4$export$6eafffd4489b3d4 = {
    name: 'trash-projects-directory',
    path: '/secure/projects/trash',
    exact: true
};

});

parcelRegister("aphUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $70186afa73ef93b4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $7tQej = parcelRequire("7tQej");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$70186afa73ef93b4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "projectsTrashRedirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira/settings/projects/trash"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));

});

parcelRegister("8gSP9", function(module, exports) {

$parcel$export(module.exports, "LazyTrashedProjectsAdmin", () => $67a748fd05680154$export$dd65a8ee0a9ac24f);
$parcel$export(module.exports, "default", () => $67a748fd05680154$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $67a748fd05680154$export$dd65a8ee0a9ac24f = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jIYLr"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/trashed-projects/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$67a748fd05680154$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $67a748fd05680154$export$dd65a8ee0a9ac24f,
        pageId: "trashed-projects",
        shouldShowSpinner: true
    });

});
parcelRegister("jIYLr", function(module, exports) {

let $e5c142e3b844004a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e5c142e3b844004a$var$load("dsiAd"),
    $e5c142e3b844004a$var$load("4t5t3")
]).then(()=>parcelRequire('lYlbz'));

});



parcelRegister("bCHhM", function(module, exports) {

$parcel$export(module.exports, "trashProjectsDirectoryRouteEntry", () => $dc548005383aa0ca$export$27d1f352c2f7acae);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $4jMkc = parcelRequire("4jMkc");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $6K0J9 = parcelRequire("6K0J9");

var $8gSP9 = parcelRequire("8gSP9");
const $dc548005383aa0ca$export$27d1f352c2f7acae = (0, $7NszV.createEntry)((0, $6K0J9.trashProjectsDirectoryRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.trashed-projects',
        component: (0, $8gSP9.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8gSP9.LazyTrashedProjectsAdmin)
        ]
    }));

});
parcelRegister("6K0J9", function(module, exports) {

$parcel$export(module.exports, "trashProjectsDirectoryRoute", () => $78ccf5c0c15f3843$export$74ec9fecd42fa96e);
const $78ccf5c0c15f3843$export$74ec9fecd42fa96e = {
    name: 'trash-projects-directory',
    path: '/jira/settings/projects/trash',
    exact: true
};

});


parcelRegister("hjvN4", function(module, exports) {

$parcel$export(module.exports, "userSegmentationRouteEntry", () => $929524b967f2ea63$export$2af76482b576a135);

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $gRaVl = parcelRequire("gRaVl");

var $1z26X = parcelRequire("1z26X");
const $929524b967f2ea63$export$2af76482b576a135 = (0, $7NszV.createEntry)((0, $gRaVl.userSegmentationRoute), ()=>({
        ufoName: 'user-segmentation',
        component: (0, $1z26X.UserSegmentation),
        layout: (0, $6e4Kt.chromelessLayout),
        forPaint: [
            (0, $1z26X.LazyUserSegmentation)
        ]
    }));

});
parcelRegister("gRaVl", function(module, exports) {

$parcel$export(module.exports, "userSegmentationRoute", () => $875097219108c022$export$b0b13170cadf6395);
const $875097219108c022$export$b0b13170cadf6395 = {
    name: 'user-segmentation',
    path: '/jira/get-started',
    exact: true
};

});

parcelRegister("1z26X", function(module, exports) {

$parcel$export(module.exports, "LazyUserSegmentation", () => $16f27a0ded4f6683$export$bf9c9e0729c919f5);
$parcel$export(module.exports, "UserSegmentation", () => $16f27a0ded4f6683$export$15f8c5ccbb9c7ec3);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $16f27a0ded4f6683$export$bf9c9e0729c919f5 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5LJ3U"))), {
    moduleId: "./src/packages/user-segmentation/src/index.tsx"
});
const $16f27a0ded4f6683$export$15f8c5ccbb9c7ec3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $16f27a0ded4f6683$export$bf9c9e0729c919f5,
        pageId: "user-segmentation",
        shouldShowSpinner: true
    });

});
parcelRegister("5LJ3U", function(module, exports) {

let $43344bec2a491c5a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $43344bec2a491c5a$var$load("eCiAS").then(()=>parcelRequire('jL0w0'));

});



parcelRegister("03CAy", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapClassicRouteEntry", () => $12d0c514ddf21fe0$export$17cff822dd3757db);

var $7NszV = parcelRequire("7NszV");

var $i1Lhe = parcelRequire("i1Lhe");

var $8STJR = parcelRequire("8STJR");

var $aPfsS = parcelRequire("aPfsS");

var $e7bC3 = parcelRequire("e7bC3");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $7uLIV = parcelRequire("7uLIV");

var $hJAri = parcelRequire("hJAri");

var $fKmub = parcelRequire("fKmub");

var $ffza4 = parcelRequire("ffza4");

var $c7uCQ = parcelRequire("c7uCQ");

var $j0EJB = parcelRequire("j0EJB");
const $12d0c514ddf21fe0$export$17cff822dd3757db = (0, $7NszV.createEntry)((0, $i1Lhe.softwareRoadmapClassicRoute), ()=>({
        group: 'classic-software',
        component: (0, $c7uCQ.TimelineRedirect),
        skeleton: (0, $8STJR.RoadmapSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.classicSoftwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $hJAri.classicRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $j0EJB.LazyRoadmapViewClassic)
        ],
        ufoName: 'classic-roadmap'
    }));

});
parcelRegister("i1Lhe", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapClassicRoute", () => $6e5bb4d1423afb31$export$79089e2853f04197);
const $6e5bb4d1423afb31$export$79089e2853f04197 = {
    name: 'software-roadmap-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/roadmap'
};

});

parcelRegister("hJAri", function(module, exports) {

$parcel$export(module.exports, "classicRoadmapResource", () => $b200b290d50f82d3$export$e755913caca1ab8e);

var $2M1hQ = parcelRequire("2M1hQ");


const $b200b290d50f82d3$export$e755913caca1ab8e = (0, $2M1hQ.createResource)({
    type: (0, $87d7efe6336d8b83$export$75dfa03544a19422),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("5RfNQ")),
    isBrowserOnly: true
});

});
parcelRegister("5RfNQ", function(module, exports) {

let $443e2925f063d06f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $443e2925f063d06f$var$load("8MG8R").then(()=>parcelRequire('g52eJ'));

});


parcelRegister("c7uCQ", function(module, exports) {

$parcel$export(module.exports, "TimelineRedirect", () => $02623e8fca40b314$export$c70b8d9ef0c891b2);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
var $doZTA = parcelRequire("doZTA");
const $02623e8fca40b314$export$c70b8d9ef0c891b2 = ()=>{
    const [{ query: query, match: match }] = (0, $doZTA.useRouter)();
    const queryParams = new URLSearchParams(query).toString();
    const { projectKey: projectKey, boardId: boardId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: {
            pathname: `/jira/software/c/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
            hash: '',
            search: queryParams
        }
    });
};

});

parcelRegister("j0EJB", function(module, exports) {

$parcel$export(module.exports, "LazyRoadmapViewClassic", () => $d9daa971618d7f64$export$84165bb08bf42eef);
$parcel$export(module.exports, "default", () => $d9daa971618d7f64$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $d9daa971618d7f64$export$84165bb08bf42eef = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iyl3O"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/classic/index-old.tsx"
});
var /** @deprecated Use entrypoint roadmapViewClassicPageEntrypoint */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$d9daa971618d7f64$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { boardId: boardId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d9daa971618d7f64$export$84165bb08bf42eef,
        pageId: `classic-roadmap-${boardId || ''}`,
        shouldShowSpinner: false
    });
};

});
parcelRegister("iyl3O", function(module, exports) {

let $d81bbd1edbcf9827$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d81bbd1edbcf9827$var$load("ghqQH").then(()=>parcelRequire('cVHeR'));

});



parcelRegister("heIfC", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineClassicRouteEntry", () => $bac13144920c2c2e$export$a822ee67d4c66296);

var $7NszV = parcelRequire("7NszV");

var $ie7vB = parcelRequire("ie7vB");

var $8STJR = parcelRequire("8STJR");

var $aPfsS = parcelRequire("aPfsS");

var $e7bC3 = parcelRequire("e7bC3");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $7uLIV = parcelRequire("7uLIV");

var $hJAri = parcelRequire("hJAri");

var $fKmub = parcelRequire("fKmub");

var $ffza4 = parcelRequire("ffza4");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $4R6GH = parcelRequire("4R6GH");

var $j0EJB = parcelRequire("j0EJB");

var $jK0PE = parcelRequire("jK0PE");
/** @deprecated remove when cleaning up 'jira-timeline-classic-route-entrypoint-migration' */ const $bac13144920c2c2e$var$getHorizontalNavResource = ()=>(0, $4R6GH.fg)('jira-timeline-classic-route-entrypoint-migration') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $bac13144920c2c2e$export$a822ee67d4c66296 = (0, $7NszV.createEntry)((0, $ie7vB.softwareTimelineClassicRoute), ()=>({
        group: 'classic-software',
        component: (0, $4R6GH.fg)('jira-timeline-classic-route-entrypoint-migration') ? undefined : (0, $j0EJB.default),
        skeleton: (0, $8STJR.RoadmapSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.classicSoftwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            ...$bac13144920c2c2e$var$getHorizontalNavResource(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $hJAri.classicRoadmapResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: (0, $4R6GH.fg)('jira-timeline-classic-route-entrypoint-migration') ? undefined : [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $j0EJB.LazyRoadmapViewClassic)
        ],
        ufoName: 'classic-roadmap',
        entryPoint: ()=>(0, $4R6GH.fg)('jira-timeline-classic-route-entrypoint-migration') ? (0, $jK0PE.roadmapViewClassicPageEntrypoint) : undefined
    }));

});
parcelRegister("ie7vB", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineClassicRoute", () => $9063b50694a4a155$export$ce5173f7e8fa932b);
const $9063b50694a4a155$export$ce5173f7e8fa932b = {
    name: 'software-timeline-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/timeline'
};

});

parcelRegister("jK0PE", function(module, exports) {

$parcel$export(module.exports, "roadmapViewClassicPageEntrypoint", () => $636a0aa010a33fb5$export$af2674d32463682f);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $9uS0k = parcelRequire("9uS0k");

var $fo6b8 = parcelRequire("fo6b8");
const $636a0aa010a33fb5$export$af2674d32463682f = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $9uS0k.roadmapViewClassicEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("9uS0k", function(module, exports) {

$parcel$export(module.exports, "roadmapViewClassicEntrypoint", () => $ec06132eb53a85c8$export$583357f75b3be3a7);

var $cfawy = parcelRequire("cfawy");

var $3rdd7 = parcelRequire("3rdd7");

const $ec06132eb53a85c8$export$583357f75b3be3a7 = (0, $3rdd7.createEntryPoint)({
    root: (0, $cfawy.JSResourceForUserVisible)(()=>(parcelRequire("apEDL")), {
        moduleId: "7a5c4192"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("apEDL", function(module, exports) {

let $794bc385c85ef4a4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $794bc385c85ef4a4$var$load("39IYm").then(()=>parcelRequire('9PBZj'));

});




parcelRegister("cjFCA", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsRouteEntry", () => $8a9bcce270c68b7d$export$4e7891e9bba3f679);

var $b4PzF = parcelRequire("b4PzF");

var $7NszV = parcelRequire("7NszV");

var $hWAe2 = parcelRequire("hWAe2");

var $i8Lv4 = parcelRequire("i8Lv4");

var $gyYxw = parcelRequire("gyYxw");

var $dxCvy = parcelRequire("dxCvy");

var $3RJkv = parcelRequire("3RJkv");

var $f5kpo = parcelRequire("f5kpo");

var $lfnsv = parcelRequire("lfnsv");

var $7GnDe = parcelRequire("7GnDe");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $lJ1FP = parcelRequire("lJ1FP");

var $gNStA = parcelRequire("gNStA");

var $f7Y15 = parcelRequire("f7Y15");

var $ipmBb = parcelRequire("ipmBb");


var $lmyls = parcelRequire("lmyls");

var $4R6GH = parcelRequire("4R6GH");

var $9s3j1 = parcelRequire("9s3j1");

var $cSD7y = parcelRequire("cSD7y");

var $e3Qmo = parcelRequire("e3Qmo");
const $8a9bcce270c68b7d$export$4e7891e9bba3f679 = (0, $7NszV.createEntry)((0, $i8Lv4.classicSoftwareBoardSettingsRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        entryPoint: ()=>(0, $e3Qmo.boardSettingsPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $cSD7y.componentWithFG)('make_nav_sidebar_lazyforpaint_in_board_and_backlog', (0, $9s3j1.ForPaintClassicSoftwareProjectSidebar), (0, $9s3j1.default)),
            sidebarId: (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? (0, $lmyls.SIDEBAR_ID).BOARD_SETTINGS : undefined
        },
        layout: (0, $gyYxw.genericProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $gNStA.resourceWithCondition2)((0, $f5kpo.shouldLoadUIFBoardResources), (0, $f7Y15.uifBoardResource)),
            // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
            (0, $gNStA.resourceWithCondition2)(()=>(0, $f5kpo.shouldLoadUIFBoardResources)() && !(0, $b4PzF.isFedRamp)(), (0, $ipmBb.nextBestTaskFeatureResource)),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)(),
            (0, $5bkvv.forgeBoardModuleResource)
        ],
        meta: {
            // Inline this statement instead of creating a (circular) dependency by importing
            // { classicBoardCapability } from '@atlassian/jira-router-routes-software-classic-board-entries/src/common/constants.tsx';
            capability: !false ? (0, $281cbd47ba46dd7d$export$664edf77d4c76110) : (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c)
        }
    }));

});
parcelRegister("i8Lv4", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsRoute", () => $4143597146033f93$export$c055a8844d0d2f5e);
const $4143597146033f93$export$c055a8844d0d2f5e = {
    name: 'rapidboard-board-settings',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/settings/:config',
    query: [
        'from-backlog?'
    ]
};

});

parcelRegister("e3Qmo", function(module, exports) {

$parcel$export(module.exports, "boardSettingsPageEntryPoint", () => $385924313962f5aa$export$e92abb48a4e0c94d);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $eoZWh = parcelRequire("eoZWh");

var $edhw8 = parcelRequire("edhw8");
const $385924313962f5aa$export$e92abb48a4e0c94d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $edhw8.classicBoardSettingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $eoZWh.nav4SidebarSettingsBoardEntryPoint)
    }
});

});
parcelRegister("eoZWh", function(module, exports) {

$parcel$export(module.exports, "nav4SidebarSettingsBoardEntryPoint", () => $8560ff5804cb640b$export$f4cb88eb97cbdc30);

var $cfawy = parcelRequire("cfawy");

var $3rdd7 = parcelRequire("3rdd7");

const $8560ff5804cb640b$export$f4cb88eb97cbdc30 = (0, $3rdd7.createEntryPoint)({
    root: (0, $cfawy.JSResourceForUserVisible)(()=>(parcelRequire("hJSbE")), {
        moduleId: "98fd14bc"
    }),
    getPreloadProps () {
        return {};
    }
});

});
parcelRegister("hJSbE", function(module, exports) {

let $cea0ac01b088712e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cea0ac01b088712e$var$load("gS3ma").then(()=>parcelRequire('gNcDN'));

});


parcelRegister("edhw8", function(module, exports) {

$parcel$export(module.exports, "classicBoardSettingsEntryPoint", () => $78b5eed4719a6123$export$fd11e3f2f113ef67);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $78b5eed4719a6123$export$fd11e3f2f113ef67 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("3edHa")).then(({ BoardSettingsSwitcher: BoardSettingsSwitcher })=>BoardSettingsSwitcher), {
        moduleId: "59af2752",
        moduleName: "BoardSettingsSwitcher"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("3edHa", function(module, exports) {

let $259d4d83ad6fc4cc$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $259d4d83ad6fc4cc$var$load("hPzOn"),
    $259d4d83ad6fc4cc$var$load("h2MrD"),
    $259d4d83ad6fc4cc$var$load("bYT2S"),
    $259d4d83ad6fc4cc$var$load("kM6u9")
]).then(()=>parcelRequire('9tGl0'));

});




parcelRegister("hu1w9", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBacklogRouteEntry", () => $bfec0a4fc8785ec0$export$9bcdab5e8a786007);

var $g87MG = parcelRequire("g87MG");

var $ffza4 = parcelRequire("ffza4");


var $e2ctp = parcelRequire("e2ctp");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $lfnsv = parcelRequire("lfnsv");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $gwlQU = parcelRequire("gwlQU");

var $16Z5s = parcelRequire("16Z5s");

var $i8JTM = parcelRequire("i8JTM");

var $5f2bR = parcelRequire("5f2bR");

var $ltiRJ = parcelRequire("ltiRJ");
const $bfec0a4fc8785ec0$export$9bcdab5e8a786007 = (0, $7NszV.createEntry)((0, $gwlQU.classicSoftwareBoardSettingsInsightsRapidboardBacklogRoute), ()=>({
        group: 'classic-software',
        ufoName: 'rapidboard-backlog-insights',
        component: (0, $ltiRJ.InsightsSettingsRedirect),
        skeleton: (0, $i8JTM.NextGenBacklogSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=planning'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $g87MG.issueHierarchyPageResource),
            (0, $lfnsv.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps),
            (0, $16Z5s.LazyRapidBoardDataApiResource),
            (0, $16Z5s.LazyRapidBoardConfigApiResource),
            (0, $16Z5s.LazyRapidBoardWrmBundleResource),
            (0, $16Z5s.LazyRapidBoardResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("gwlQU", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBacklogRoute", () => $8b16a5460c1e898c$export$e43f33a0c1ae830c);
const $8b16a5460c1e898c$export$e43f33a0c1ae830c = {
    name: 'rapidboard-backlog',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog',
    query: [
        'config=insightsConfig'
    ]
};

});

parcelRegister("16Z5s", function(module, exports) {

$parcel$export(module.exports, "UIFBoardSpa", () => $21fca9455db40549$export$2164de18d39af313);
$parcel$export(module.exports, "RapidBoardSpaPage", () => $21fca9455db40549$export$4ceb6cf2934825b2);
$parcel$export(module.exports, "LazyRapidBoard", () => $21fca9455db40549$export$9de09057ba255cc4);
$parcel$export(module.exports, "LazyRapidBoardWrmBundleResource", () => $21fca9455db40549$export$bcb5bb6438a46dcb);
$parcel$export(module.exports, "LazyRapidBoardDataApiResource", () => $21fca9455db40549$export$d4640ceb9bdd4b4);
$parcel$export(module.exports, "LazyRapidBoardConfigApiResource", () => $21fca9455db40549$export$c96c36c0cbfb2c16);
$parcel$export(module.exports, "LazyRapidBoardResource", () => $21fca9455db40549$export$2ad64ed8eb98d9e);
$parcel$export(module.exports, "LazyRapidBoardApps", () => $21fca9455db40549$export$4a8825f3e310b97);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $21fca9455db40549$export$2164de18d39af313 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("4dj4f")), {
    moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
});

const $21fca9455db40549$export$bcc6315cf211edab = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("azeQh")), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});

const $21fca9455db40549$export$a1c59527bd5131cc = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("kNui9")).then((module)=>module.BoardConfigSwitcher), {
    moduleId: "./src/packages/router-routes/software/classic/board-settings/switcher/src/index.tsx"
});
const $21fca9455db40549$export$4ceb6cf2934825b2 = (props)=>{
    const { route: route, query: query, match: match } = props;
    const basePageId = route && route.name || 'rapid-board';
    const chartParam = query.chart ? `-${query.chart}` : '';
    const boardId = query.rapidView ?? match.params.boardId;
    const pageId = `${basePageId}-${boardId}${chartParam}`;
    if ([
        'rapidboard-board',
        'rapidboard-board-embed',
        'rapidboard-user-board'
    ].includes(route.name) && !query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $21fca9455db40549$export$2164de18d39af313,
        pageId: pageId,
        shouldShowSpinner: false
    });
    if ([
        'rapidboard-backlog',
        'rapidboard-user-backlog',
        'rapidboard-backlog-embed'
    ].includes(route.name) && !query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $21fca9455db40549$export$bcc6315cf211edab,
        pageId: pageId,
        shouldShowSpinner: false
    });
    if ([
        'rapidboard-backlog',
        'rapidboard-user-backlog',
        'rapidboard-board',
        'rapidboard-board-embed',
        'rapidboard-user-board',
        'rapidboard-backlog-embed'
    ].includes(route.name) && query.config && (0, $4R6GH.fg)('simplified-boards-milestone-2_07hbk')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $21fca9455db40549$export$a1c59527bd5131cc,
        pageId: pageId,
        shouldShowSpinner: false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $21fca9455db40549$export$9de09057ba255cc4,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

const $21fca9455db40549$export$9de09057ba255cc4 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("4rbKt")), {
    moduleId: "./src/packages/spa-apps/rapid-board/src/index.tsx"
});

const $21fca9455db40549$export$bcb5bb6438a46dcb = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("dbFSD")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/wrm-bundle/get-data/index.tsx"
});

const $21fca9455db40549$export$d4640ceb9bdd4b4 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("ma8fm")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/data-api/get-data/index.tsx"
});

const $21fca9455db40549$export$c96c36c0cbfb2c16 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("gsqVU")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/config-api/get-data/index.tsx"
});

const $21fca9455db40549$export$2ad64ed8eb98d9e = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("EuXLN")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/rapidboard-resource/get-data/index.tsx"
});

const $21fca9455db40549$export$4a8825f3e310b97 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("6f1h5")), {
    moduleId: "./src/packages/entry-rapid-board-wrm-apps/src/index.tsx"
});

});
parcelRegister("kNui9", function(module, exports) {

let $f23fe196843d718b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f23fe196843d718b$var$load("h2MrD"),
    $f23fe196843d718b$var$load("bYT2S"),
    $f23fe196843d718b$var$load("hPzOn"),
    $f23fe196843d718b$var$load("fO0AD")
]).then(()=>parcelRequire('iYOPQ'));

});

parcelRegister("4rbKt", function(module, exports) {

let $33b2cc0bdb0867fb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $33b2cc0bdb0867fb$var$load("5OUMf").then(()=>parcelRequire('Gk4RP'));

});

parcelRegister("6f1h5", function(module, exports) {

let $48b521e5a561e7f8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $48b521e5a561e7f8$var$load("bcehj").then(()=>parcelRequire('73mZu'));

});


parcelRegister("ltiRJ", function(module, exports) {

$parcel$export(module.exports, "InsightsSettingsRedirect", () => $018a8accd0bb9a64$export$f7bc2c5799e41684);

var $ibA3M = parcelRequire("ibA3M");

var $ieDtd = parcelRequire("ieDtd");
const $018a8accd0bb9a64$export$f7bc2c5799e41684 = ()=>{
    const { setSelectedConfigTab: setSelectedConfigTab } = (0, $ibA3M.useSelectedConfigTab)();
    const [, setConfigParam] = (0, $ieDtd.useQueryParam)('config');
    setSelectedConfigTab('filter');
    setConfigParam('filter');
    return null;
};

});
parcelRegister("ibA3M", function(module, exports) {

$parcel$export(module.exports, "useSelectedConfigTab", () => $a2554898b8aa72da$export$9b386f1a3e61b385);

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
const $a2554898b8aa72da$export$9b386f1a3e61b385 = ()=>{
    const storageProvider = (0, $bSSG7.createLocalStorageProvider)('SelectedTabConfig');
    const SELECTED_CONFIG_TAB_KEY = 'selectedConfigTab';
    const getSelectedConfigTab = ()=>{
        if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) return storageProvider.get(SELECTED_CONFIG_TAB_KEY) || '';
        return localStorage.getItem(SELECTED_CONFIG_TAB_KEY) || '';
    };
    const setSelectedConfigTab = (newConfigTab)=>{
        if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) storageProvider.set(SELECTED_CONFIG_TAB_KEY, newConfigTab);
        else localStorage.setItem(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);
    };
    return {
        getSelectedConfigTab: getSelectedConfigTab,
        setSelectedConfigTab: setSelectedConfigTab
    };
};

});



parcelRegister("akFeA", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBoardRouteEntry", () => $f91dfbe36c62931f$export$d4cb7b5fe9faae5e);

var $g87MG = parcelRequire("g87MG");

var $ffza4 = parcelRequire("ffza4");


var $e2ctp = parcelRequire("e2ctp");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $lfnsv = parcelRequire("lfnsv");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $9Hi5X = parcelRequire("9Hi5X");

var $16Z5s = parcelRequire("16Z5s");

var $hWAe2 = parcelRequire("hWAe2");

var $5f2bR = parcelRequire("5f2bR");

var $ltiRJ = parcelRequire("ltiRJ");
const $f91dfbe36c62931f$export$d4cb7b5fe9faae5e = (0, $7NszV.createEntry)((0, $9Hi5X.classicSoftwareBoardSettingsInsightsRapidboardBoardRoute), ()=>({
        group: 'classic-software',
        ufoName: 'rapidboard-board-insights',
        component: (0, $ltiRJ.InsightsSettingsRedirect),
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $g87MG.issueHierarchyPageResource),
            (0, $lfnsv.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps),
            (0, $16Z5s.LazyRapidBoardDataApiResource),
            (0, $16Z5s.LazyRapidBoardConfigApiResource),
            (0, $16Z5s.LazyRapidBoardWrmBundleResource),
            (0, $16Z5s.LazyRapidBoardResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("9Hi5X", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBoardRoute", () => $048f30bef65f82e7$export$8c2f936709b987ac);
const $048f30bef65f82e7$export$8c2f936709b987ac = {
    name: 'rapidboard-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId',
    query: [
        'config=insightsConfig'
    ]
};

});


parcelRegister("djlm6", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarClassicEmbedRouteEntry", () => $dcd6d1616221fb9c$export$6a544072729c1964);

var $7NszV = parcelRequire("7NszV");

var $apHIk = parcelRequire("apHIk");

var $kZOse = parcelRequire("kZOse");

var $6e4Kt = parcelRequire("6e4Kt");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $2Ql51 = parcelRequire("2Ql51");

var $4R6GH = parcelRequire("4R6GH");

var $eQnNj = parcelRequire("eQnNj");
const $dcd6d1616221fb9c$export$6a544072729c1964 = (0, $7NszV.createEntry)((0, $apHIk.softwareCalendarClassicEmbedRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $kZOse.CalendarEmbedSkeleton),
        component: (0, $kZOse.CalendarEmbedSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $eQnNj.softwareCalendarRouteEntry;
        },
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $2Ql51.themePreferenceResource)
        ],
        ufoName: 'classic-calendar-embed',
        EXPERIMENTAL__shouldReload: (0, $4R6GH.fg)('jira_fix_calendar_suspending_when_switching_months') ? ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        } : undefined
    }));

});
parcelRegister("apHIk", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarClassicEmbedRoute", () => $4565df2ae20b6eec$export$ced2612fe5124ff8);
const $4565df2ae20b6eec$export$ced2612fe5124ff8 = {
    name: 'software-calendar-classic-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/embed',
    query: [
        'date?'
    ]
};

});

parcelRegister("eQnNj", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarRouteEntry", () => $24d3258934ab0fe5$export$83b1b9036cc7961a);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $dQ4vn = parcelRequire("dQ4vn");

var $fo6b8 = parcelRequire("fo6b8");
const $24d3258934ab0fe5$export$83b1b9036cc7961a = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dQ4vn.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("3J8Cl", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarClassicRouteEntry", () => $784ebb96624ec7cf$export$17ea82bdc641d5ce);

var $7NszV = parcelRequire("7NszV");

var $4R6GH = parcelRequire("4R6GH");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $501Vn = parcelRequire("501Vn");

var $kZOse = parcelRequire("kZOse");

var $aPfsS = parcelRequire("aPfsS");

var $e7bC3 = parcelRequire("e7bC3");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $fKmub = parcelRequire("fKmub");

var $ffza4 = parcelRequire("ffza4");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $eQnNj = parcelRequire("eQnNj");
const $784ebb96624ec7cf$export$17ea82bdc641d5ce = (0, $7NszV.createEntry)((0, $501Vn.softwareCalendarClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $kZOse.CalendarSkeleton),
        component: (0, $kZOse.CalendarSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $eQnNj.softwareCalendarRouteEntry;
        },
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.classicSoftwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        ufoName: 'classic-calendar',
        EXPERIMENTAL__shouldReload: (0, $4R6GH.fg)('jira_fix_calendar_suspending_when_switching_months') ? ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        } : undefined
    }));

});
parcelRegister("501Vn", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarClassicRoute", () => $ad58dc33708a3879$export$f2c3b99639d54eb8);
const $ad58dc33708a3879$export$f2c3b99639d54eb8 = {
    name: 'software-calendar-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar',
    query: [
        'date?'
    ]
};

});


parcelRegister("bhft0", function(module, exports) {

$parcel$export(module.exports, "softwareListEmbedClassicRouteEntry", () => $c10c597b1bd946e9$export$bdb096e193b6e97b);

var $7NszV = parcelRequire("7NszV");

var $1SjdQ = parcelRequire("1SjdQ");

var $cf2qA = parcelRequire("cf2qA");

var $6e4Kt = parcelRequire("6e4Kt");

var $aFVvc = parcelRequire("aFVvc");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $g4ZHz = parcelRequire("g4ZHz");

var $fKmub = parcelRequire("fKmub");

var $iNzEe = parcelRequire("iNzEe");

var $l2N2a = parcelRequire("l2N2a");

var $7KruY = parcelRequire("7KruY");
const $c10c597b1bd946e9$export$bdb096e193b6e97b = (0, $7NszV.createEntry)((0, $1SjdQ.softwareListEmbedClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $cf2qA.ListEmbedSkeleton),
        entryPoint () {
            return 0, $7KruY.softwareListEmbedRouteEntry;
        },
        layout: (0, $6e4Kt.chromelessLayout),
        // TODO: This is a copy of getProjectViewResources, but it has been copied in order to expand getNavigationSidebarProjectResource
        resources: [
            // the below 5 resources are copied from getBusinessProjectResources
            // they should be feature flagged and removed when it is safe to do so or
            // moved out of business packages
            // start getBusinessProjectResources
            (0, $aFVvc.projectCreatePermissionsResource),
            (0, $iNzEe.navigationResource),
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            // end getBusinessProjectResources
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $g4ZHz.fieldsResource)
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        ufoName: 'classic-list-embed'
    }));

});
parcelRegister("1SjdQ", function(module, exports) {

$parcel$export(module.exports, "softwareListEmbedClassicRoute", () => $6541879b6a0ea94d$export$de5fcecec40b3c98);
const $6541879b6a0ea94d$export$de5fcecec40b3c98 = {
    name: 'software-list-classic-embed',
    path: '/jira/software/c/projects/:projectKey/list/embed'
};

});

parcelRegister("7KruY", function(module, exports) {

$parcel$export(module.exports, "softwareListRouteEntry", () => $2190319388c8e440$export$f30a66efa682bf2d);
$parcel$export(module.exports, "softwareListEmbedRouteEntry", () => $2190319388c8e440$export$1099e0e49394fa9a);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $cv6Sw = parcelRequire("cv6Sw");

var $fo6b8 = parcelRequire("fo6b8");

var $3FuB0 = parcelRequire("3FuB0");
const $2190319388c8e440$export$f30a66efa682bf2d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3FuB0.listEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $2190319388c8e440$export$1099e0e49394fa9a = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $cv6Sw.listEmbedEntryPoint)
});

});


parcelRegister("6FBN4", function(module, exports) {

$parcel$export(module.exports, "softwareListClassicRouteEntry", () => $9d676290a188f14d$export$4e2a0a97feb715a5);

var $7NszV = parcelRequire("7NszV");

var $cf2qA = parcelRequire("cf2qA");

var $aPfsS = parcelRequire("aPfsS");

var $e7bC3 = parcelRequire("e7bC3");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $2J9Xf = parcelRequire("2J9Xf");

var $5f2bR = parcelRequire("5f2bR");

var $aFVvc = parcelRequire("aFVvc");

var $iNzEe = parcelRequire("iNzEe");

var $l2N2a = parcelRequire("l2N2a");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $g4ZHz = parcelRequire("g4ZHz");

var $fKmub = parcelRequire("fKmub");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $7KruY = parcelRequire("7KruY");
const $9d676290a188f14d$export$4e2a0a97feb715a5 = (0, $7NszV.createEntry)((0, $2J9Xf.softwareListClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $cf2qA.ListSkeleton),
        entryPoint () {
            return 0, $7KruY.softwareListRouteEntry;
        },
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.classicSoftwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        // TODO: This is a copy of getProjectViewResources, but it has been copied in order to replace
        //  with .
        resources: [
            // the below 5 resources are copied from getBusinessProjectResources
            // they should be feature flagged and removed when it is safe to do so or
            // moved out of business packages
            // start getBusinessProjectResources
            (0, $aFVvc.projectCreatePermissionsResource),
            (0, $iNzEe.navigationResource),
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            // end getBusinessProjectResources
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $g4ZHz.fieldsResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        ufoName: 'classic-list'
    }));

});
parcelRegister("2J9Xf", function(module, exports) {

$parcel$export(module.exports, "softwareListClassicRoute", () => $cb27ddbacbb22539$export$1bf758507ca6b2);
const $cb27ddbacbb22539$export$1bf758507ca6b2 = {
    name: 'software-list-classic',
    path: '/jira/software/c/projects/:projectKey/list'
};

});


parcelRegister("1iYkP", function(module, exports) {

$parcel$export(module.exports, "rapidboardReportRouteEntry", () => $6946c90a7efbc538$export$745f1d5a2458a2d9);

var $7NszV = parcelRequire("7NszV");

var $hwrCN = parcelRequire("hwrCN");

var $16Z5s = parcelRequire("16Z5s");

var $7o1kb = parcelRequire("7o1kb");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $7uLIV = parcelRequire("7uLIV");

var $f5kpo = parcelRequire("f5kpo");

var $fKmub = parcelRequire("fKmub");

var $ffza4 = parcelRequire("ffza4");

var $e2ctp = parcelRequire("e2ctp");

var $yxwH0 = parcelRequire("yxwH0");
const $6946c90a7efbc538$export$745f1d5a2458a2d9 = (0, $7NszV.createEntry)((0, $hwrCN.rapidboardReportRoute), ()=>({
        group: 'classic-software',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $7o1kb.ClassicReportSkeleton),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            ...(0, $yxwH0.getReportsCommonResource)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        ufoName: 'classic-report'
    }));

});
parcelRegister("hwrCN", function(module, exports) {

$parcel$export(module.exports, "rapidboardReportRoute", () => $090be05d28e65948$export$d37f637b09fb9fda);
const $090be05d28e65948$export$d37f637b09fb9fda = {
    name: 'rapidboard-report',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/:chartView'
};

});

parcelRegister("7o1kb", function(module, exports) {

$parcel$export(module.exports, "ClassicReportSkeleton", () => $61f1e37e5e1946ad$export$d7667341f4db3b8d);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $18D3n = parcelRequire("18D3n");
const $61f1e37e5e1946ad$export$d7667341f4db3b8d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($18D3n)))
    });

});
parcelRegister("18D3n", function(module, exports) {
module.exports = new URL("classic-report-app-skeleton.tpl.1daae66d.svg", import.meta.url).toString();

});


parcelRegister("yxwH0", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $c75fcd785e66868e$export$8cb713295e6b7204);
$parcel$export(module.exports, "getTMPReportsCommonResource", () => $c75fcd785e66868e$export$f234446c23dc22a);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $c75fcd785e66868e$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $c75fcd785e66868e$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("CY8KI", function(module, exports) {

$parcel$export(module.exports, "softwareReportsOverviewRouteEntry", () => $1f4532d2aef48985$export$705071d2eca06bf9);

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $4R6GH = parcelRequire("4R6GH");

var $9s3j1 = parcelRequire("9s3j1");

var $6rHGg = parcelRequire("6rHGg");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $5f2bR = parcelRequire("5f2bR");

var $lkFvK = parcelRequire("lkFvK");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $e7bC3 = parcelRequire("e7bC3");

var $dxCvy = parcelRequire("dxCvy");

var $fh5Sl = parcelRequire("fh5Sl");

var $fo6b8 = parcelRequire("fo6b8");

var $38FLy = parcelRequire("38FLy");
const $1f4532d2aef48985$var$reportsOverviewPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fh5Sl.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $1f4532d2aef48985$export$705071d2eca06bf9 = (0, $7NszV.createEntry)((0, $6rHGg.softwareReportsOverviewRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $38FLy.ReportsOverviewSkeleton),
        entryPoint () {
            return (0, $4R6GH.fg)('reports-overview-page-migration') ? $1f4532d2aef48985$var$reportsOverviewPageEntryPoint : undefined;
        },
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        ufoName: 'reports-overview'
    }));

});
parcelRegister("6rHGg", function(module, exports) {

$parcel$export(module.exports, "softwareReportsOverviewRoute", () => $70946eef546cad35$export$f38928477442c9cf);
const $70946eef546cad35$export$f38928477442c9cf = {
    name: 'software-reports',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports'
};

});

parcelRegister("38FLy", function(module, exports) {

$parcel$export(module.exports, "ReportsOverviewSkeleton", () => $b7f1d5ad6a664668$export$c70e702bcad58c36);
/* ReportsOverviewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $8DWep = parcelRequire("8DWep");
const $b7f1d5ad6a664668$var$containerStyles = {
    maxWidth: '100%'
};
const $b7f1d5ad6a664668$var$customCssStyles = null;
const $b7f1d5ad6a664668$export$c70e702bcad58c36 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8DWep))),
        containerStyles: $b7f1d5ad6a664668$var$containerStyles,
        className: (0, $bwpsq.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("8DWep", function(module, exports) {
module.exports = new URL("report-categories-skeleton.tpl.5b53a8d3.svg", import.meta.url).toString();

});



parcelRegister("3Jvzv", function(module, exports) {

$parcel$export(module.exports, "softwareReportsOverviewBoardlessRouteEntry", () => $9c5660c793001eba$export$1341f3a3578e9e4);

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $4R6GH = parcelRequire("4R6GH");

var $9s3j1 = parcelRequire("9s3j1");

var $e5NqW = parcelRequire("e5NqW");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $5f2bR = parcelRequire("5f2bR");

var $lkFvK = parcelRequire("lkFvK");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $48Ij3 = parcelRequire("48Ij3");

var $e7bC3 = parcelRequire("e7bC3");

var $dxCvy = parcelRequire("dxCvy");

var $fh5Sl = parcelRequire("fh5Sl");

var $fo6b8 = parcelRequire("fo6b8");

var $38FLy = parcelRequire("38FLy");
const $9c5660c793001eba$var$reportsOverviewPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fh5Sl.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $9c5660c793001eba$export$1341f3a3578e9e4 = (0, $7NszV.createEntry)((0, $e5NqW.softwareReportsOverviewBoardlessRoute), ()=>({
        group: 'software-reports-boardless',
        skeleton: (0, $38FLy.ReportsOverviewSkeleton),
        entryPoint () {
            return (0, $4R6GH.fg)('reports-overview-page-migration') ? $9c5660c793001eba$var$reportsOverviewPageEntryPoint : undefined;
        },
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $48Ij3.staticSidebarJSWReportsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        ufoName: 'reports-overview'
    }));

});
parcelRegister("e5NqW", function(module, exports) {

$parcel$export(module.exports, "softwareReportsOverviewBoardlessRoute", () => $ec5168f42eb9ffe8$export$e2f371bced79a0e4);
const $ec5168f42eb9ffe8$export$e2f371bced79a0e4 = {
    name: 'software-reports-boardless',
    path: '/jira/software/c/projects/:projectKey/reports',
    exact: true
};

});


parcelRegister("kYzjv", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeClassicRouteEntry", () => $8d790787867c06bf$export$1bbbe71c256ed1d0);

var $e4eHl = parcelRequire("e4eHl");

var $7NszV = parcelRequire("7NszV");

var $3vbFU = parcelRequire("3vbFU");

var $7XYc4 = parcelRequire("7XYc4");

var $kfztd = parcelRequire("kfztd");

var $5lsNZ = parcelRequire("5lsNZ");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $2GkDw = parcelRequire("2GkDw");

var $ffza4 = parcelRequire("ffza4");

var $89cBA = parcelRequire("89cBA");

var $yxwH0 = parcelRequire("yxwH0");
const $8d790787867c06bf$export$1bbbe71c256ed1d0 = (0, $7NszV.createEntry)((0, $3vbFU.softwareReportsCycleTimeClassicRoute), ()=>({
        group: 'classic-software',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $89cBA.CycleTimeReportClassic)),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $yxwH0.getReportsCommonResource)(),
            (0, $2GkDw.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $89cBA.LazyCycleTimeReport)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $89cBA.LazyCycleTimeReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-cycle-time-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-cycle-time-classic'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("3vbFU", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeClassicRoute", () => $06112c4b48f06dba$export$1e5e610e11119ea7);
const $06112c4b48f06dba$export$1e5e610e11119ea7 = {
    name: 'software-reports-cycle-time-classic',
    path: '/jira/software/c/projects/:projectKey/reports/cycle-time',
    exact: true
};

});

parcelRegister("89cBA", function(module, exports) {

$parcel$export(module.exports, "LazyCycleTimeReport", () => $f19a24813079175a$export$956f830ed027f1fb);
$parcel$export(module.exports, "CycleTimeReportClassic", () => $f19a24813079175a$export$237924ba64065cc3);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $f19a24813079175a$export$956f830ed027f1fb = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("3yswC")), {
    moduleId: "./src/packages/spa-apps/cycle-time-report/src/index.tsx"
});
const $f19a24813079175a$export$e16ce0656a74a015 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f19a24813079175a$export$956f830ed027f1fb,
        pageId: "cycleTimeReportNextGen",
        shouldShowSpinner: true
    });
const $f19a24813079175a$export$237924ba64065cc3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f19a24813079175a$export$956f830ed027f1fb,
        pageId: "cycleTimeReportClassic",
        shouldShowSpinner: true
    });

});


parcelRegister("lHzMh", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeClassicBoardRouteEntry", () => $5825ca5195a81fcb$export$9c40eb459ce6a0bc);

var $e4eHl = parcelRequire("e4eHl");

var $7NszV = parcelRequire("7NszV");

var $7AHcB = parcelRequire("7AHcB");

var $7XYc4 = parcelRequire("7XYc4");

var $kfztd = parcelRequire("kfztd");

var $5lsNZ = parcelRequire("5lsNZ");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $2GkDw = parcelRequire("2GkDw");

var $ffza4 = parcelRequire("ffza4");

var $89cBA = parcelRequire("89cBA");

var $yxwH0 = parcelRequire("yxwH0");
const $5825ca5195a81fcb$export$9c40eb459ce6a0bc = (0, $7NszV.createEntry)((0, $7AHcB.softwareReportsCycleTimeClassicBoardRoute), ()=>({
        group: 'classic-software',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $89cBA.CycleTimeReportClassic)),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $yxwH0.getReportsCommonResource)(),
            (0, $2GkDw.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $89cBA.LazyCycleTimeReport)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $89cBA.LazyCycleTimeReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-cycle-time-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-cycle-time-classic'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("7AHcB", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeClassicBoardRoute", () => $49ddf385f7fbe750$export$12423e360eb5fa9d);
const $49ddf385f7fbe750$export$12423e360eb5fa9d = {
    name: 'software-reports-cycle-time-classic-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/cycle-time',
    exact: true
};

});


parcelRegister("711QI", function(module, exports) {

$parcel$export(module.exports, "softwareFormBuilderClassicRouteEntry", () => $b4fa37ff3bdeb6f7$export$96aa488380334044);

var $7NszV = parcelRequire("7NszV");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $3OSHM = parcelRequire("3OSHM");

var $6s1PB = parcelRequire("6s1PB");

var $evEd2 = parcelRequire("evEd2");

var $fo6b8 = parcelRequire("fo6b8");

var $e7bC3 = parcelRequire("e7bC3");

var $9s3j1 = parcelRequire("9s3j1");

var $lkFvK = parcelRequire("lkFvK");

var $3HwlS = parcelRequire("3HwlS");

var $6LsQE = parcelRequire("6LsQE");

var $5f2bR = parcelRequire("5f2bR");

var $l2N2a = parcelRequire("l2N2a");
const $b4fa37ff3bdeb6f7$var$formBuilderPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $evEd2.formBuilderEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $b4fa37ff3bdeb6f7$export$96aa488380334044 = (0, $7NszV.createEntry)((0, $3OSHM.softwareFormBuilderClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-builder',
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $5f2bR.AsyncHorizontalNavJira), ()=>null)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $b4fa37ff3bdeb6f7$var$formBuilderPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("3OSHM", function(module, exports) {

$parcel$export(module.exports, "softwareFormBuilderClassicRoute", () => $9ede72c8b3eb717b$export$f6cfee0232aa1e);
const $9ede72c8b3eb717b$export$f6cfee0232aa1e = {
    name: 'software-form-builder-classic',
    path: '/jira/software/c/projects/:projectKey/form/:formId/builder',
    exact: true
};

});


parcelRegister("gcVUu", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitClassicRouteEntry", () => $331e128c3f179847$export$a7c8812838762453);

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $6LsQE = parcelRequire("6LsQE");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $6FnT3 = parcelRequire("6FnT3");

var $lkFvK = parcelRequire("lkFvK");

var $6s1PB = parcelRequire("6s1PB");

var $l2N2a = parcelRequire("l2N2a");

var $1Fd2h = parcelRequire("1Fd2h");

var $6e4Kt = parcelRequire("6e4Kt");
const $331e128c3f179847$var$formSubmitPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6FnT3.formSubmitEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $331e128c3f179847$export$a7c8812838762453 = (0, $7NszV.createEntry)((0, $1Fd2h.softwareFormSubmitClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-submit',
        layout: (0, $6e4Kt.chromelessLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $331e128c3f179847$var$formSubmitPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("1Fd2h", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitClassicRoute", () => $dcbb2b95e9b9bd2e$export$91d6851bf27349);
const $dcbb2b95e9b9bd2e$export$91d6851bf27349 = {
    name: 'software-form-submit-classic',
    path: '/jira/software/c/projects/:projectKey/form/:formId',
    exact: true
};

});


parcelRegister("dG6DF", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitEmbedClassicRouteEntry", () => $cca7fa509b94a5ef$export$ffc85d68201bbe35);

var $7NszV = parcelRequire("7NszV");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $6LsQE = parcelRequire("6LsQE");

var $l2N2a = parcelRequire("l2N2a");

var $6e4Kt = parcelRequire("6e4Kt");

var $cQaX2 = parcelRequire("cQaX2");

var $a1Eek = parcelRequire("a1Eek");

var $lkFvK = parcelRequire("lkFvK");
const $cca7fa509b94a5ef$var$formSubmitEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $a1Eek.formSubmitEmbedEntrypoint)
});
const $cca7fa509b94a5ef$export$ffc85d68201bbe35 = (0, $7NszV.createEntry)((0, $cQaX2.softwareFormSubmitEmbedClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-submit-embed',
        layout: (0, $6e4Kt.chromelessLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        // eslint-disable-next-line camelcase
        resources: [
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return (0, $4R6GH.fg)('jsw_forms_embed') ? $cca7fa509b94a5ef$var$formSubmitEmbedPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("cQaX2", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitEmbedClassicRoute", () => $7149a36cf3eab9d7$export$812703a022333f7c);
const $7149a36cf3eab9d7$export$812703a022333f7c = {
    name: 'software-form-submit-classic-embed',
    path: '/jira/software/c/projects/:projectKey/form/:formId/embed',
    exact: true
};

});


parcelRegister("efYyQ", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitClassicPublicRouteEntry", () => $0622f0c75a643879$export$df7e146d38db5cc0);

var $7NszV = parcelRequire("7NszV");

var $6LsQE = parcelRequire("6LsQE");

var $6s1PB = parcelRequire("6s1PB");

var $1AQOY = parcelRequire("1AQOY");

var $2Ql51 = parcelRequire("2Ql51");

var $6e4Kt = parcelRequire("6e4Kt");

var $eRU3k = parcelRequire("eRU3k");
const $0622f0c75a643879$export$df7e146d38db5cc0 = (0, $7NszV.createEntry)((0, $1AQOY.softwareFormSubmitClassicPublicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-submit-public',
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $2Ql51.themePreferenceResource)
        ],
        entryPoint: ()=>(0, $6s1PB.expVal)('jira_forms_public_access_experiment', 'isEnabled', 'false') ? (0, $eRU3k.formSubmitPageEntrypoint) : (0, $6LsQE.notFoundPageEntrypoint)
    }));

});
parcelRegister("1AQOY", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitClassicPublicRoute", () => $3e5868f8d7166868$export$c66ba06e288dec3f);
const $3e5868f8d7166868$export$c66ba06e288dec3f = {
    name: 'software-form-submit-classic-public',
    path: '/jira/software/c/form/:formUuid',
    exact: true
};

});


parcelRegister("kQjkp", function(module, exports) {

$parcel$export(module.exports, "softwareFormClassicRouteEntry", () => $d20dbf7f22bf9ac8$export$4bb0f20ad6471148);

var $7NszV = parcelRequire("7NszV");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $fo6b8 = parcelRequire("fo6b8");

var $6s1PB = parcelRequire("6s1PB");

var $l2N2a = parcelRequire("l2N2a");

var $iwW4Z = parcelRequire("iwW4Z");

var $6LsQE = parcelRequire("6LsQE");

var $eeYjL = parcelRequire("eeYjL");

var $lkFvK = parcelRequire("lkFvK");

var $e7bC3 = parcelRequire("e7bC3");

var $9s3j1 = parcelRequire("9s3j1");

var $3HwlS = parcelRequire("3HwlS");

var $5f2bR = parcelRequire("5f2bR");
const $d20dbf7f22bf9ac8$var$formPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $eeYjL.formEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $d20dbf7f22bf9ac8$export$4bb0f20ad6471148 = (0, $7NszV.createEntry)((0, $iwW4Z.softwareFormClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form',
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $5f2bR.AsyncHorizontalNavJira), ()=>null)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $d20dbf7f22bf9ac8$var$formPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("iwW4Z", function(module, exports) {

$parcel$export(module.exports, "softwareFormClassicRoute", () => $3b49c520878b4671$export$ae560ee5b676193d);
const $3b49c520878b4671$export$ae560ee5b676193d = {
    name: 'software-form-classic',
    path: '/jira/software/c/projects/:projectKey/form',
    exact: true
};

});


parcelRegister("1IhKQ", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsClassicRouteEntry", () => $1b0cb05431f8ca29$export$58d10390fc181fcf);

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $7uLIV = parcelRequire("7uLIV");

var $9s3j1 = parcelRequire("9s3j1");

var $5f2bR = parcelRequire("5f2bR");

var $e1lSQ = parcelRequire("e1lSQ");

var $4R6GH = parcelRequire("4R6GH");

var $8nDKE = parcelRequire("8nDKE");

var $6XlJT = parcelRequire("6XlJT");
/** @deprecated remove when cleaning up 'fun-1607-migrate-goals-route-to-entrypoints' */ const $1b0cb05431f8ca29$var$getHorizontalNavResource = ()=>(0, $4R6GH.fg)('fun-1607-migrate-goals-route-to-entrypoints') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $1b0cb05431f8ca29$export$58d10390fc181fcf = (0, $7NszV.createEntry)((0, $e1lSQ.softwareGoalsClassicRoute), ()=>({
        group: 'classic-software',
        component: (0, $8nDKE.default),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            ...$1b0cb05431f8ca29$var$getHorizontalNavResource()
        ],
        entryPoint: ()=>(0, $4R6GH.fg)('fun-1607-migrate-goals-route-to-entrypoints') ? (0, $6XlJT.softwareGoalsClassicPageEntrypoint) : undefined
    }));

});
parcelRegister("e1lSQ", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsClassicRoute", () => $9ec0c22df6343cfe$export$d12f3924cf53b545);
const $9ec0c22df6343cfe$export$d12f3924cf53b545 = {
    name: 'software-goals-classic',
    path: '/jira/software/c/projects/:projectKey/goals'
};

});

parcelRegister("8nDKE", function(module, exports) {

$parcel$export(module.exports, "default", () => $bddcce0ba616f353$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $bddcce0ba616f353$export$cabb458181f7566e = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("aWL8K"))), {
    moduleId: "./src/packages/spa-apps/goals/src/ui/index-old.tsx"
});
var /** @deprecated remove when cleaning up 'fun-1607-migrate-goals-route-to-entrypoints' */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$bddcce0ba616f353$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $bddcce0ba616f353$export$cabb458181f7566e,
        pageId: `classic-atlas-goals-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });

});

parcelRegister("6XlJT", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsClassicPageEntrypoint", () => $4a23aaa7a1201d94$export$6c6f7e606a16292);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $gz6uQ = parcelRequire("gz6uQ");
const $4a23aaa7a1201d94$export$6c6f7e606a16292 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $gz6uQ.softwareGoalsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("iwgxt", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryClassicRouteEntry", () => $ab4cacd7ed3eca70$export$f81c7c178a9483e8);

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $7uLIV = parcelRequire("7uLIV");

var $9s3j1 = parcelRequire("9s3j1");

var $5f2bR = parcelRequire("5f2bR");

var $4E1mJ = parcelRequire("4E1mJ");

var $7XYc4 = parcelRequire("7XYc4");

var $6s1PB = parcelRequire("6s1PB");

var $f3iuv = parcelRequire("f3iuv");

var $5lsNZ = parcelRequire("5lsNZ");

var $e7bC3 = parcelRequire("e7bC3");

var $ffza4 = parcelRequire("ffza4");

var $1wsDh = parcelRequire("1wsDh");

var $fo6b8 = parcelRequire("fo6b8");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");
const $ab4cacd7ed3eca70$var$summarySoftwarePageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1wsDh.summarySoftwareEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
/**
 * @deprecated delete when cleaning up project_summary_page_entry_point_migration
 */ const $ab4cacd7ed3eca70$var$getHorizontalNavResources = ()=>(0, $4R6GH.fg)('project_summary_page_entry_point_migration') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $ab4cacd7ed3eca70$export$f81c7c178a9483e8 = (0, $7NszV.createEntry)((0, $4E1mJ.softwareSummaryClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-summary',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('helios_summary_page_experiment', 'isEnabled', false), (0, $f3iuv.SummaryPage), (0, $5lsNZ.default)),
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // delete when cleaning up project_summary_page_entry_point_migration
            ...$ab4cacd7ed3eca70$var$getHorizontalNavResources(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $f3iuv.LazySummaryView)
        ],
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('project_summary_page_entry_point_migration')) return $ab4cacd7ed3eca70$var$summarySoftwarePageEntrypoint;
        }
    }));

});
parcelRegister("4E1mJ", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryClassicRoute", () => $b668e7dcab7792ea$export$b5046fccf399983f);
const $b668e7dcab7792ea$export$b5046fccf399983f = {
    name: 'software-summary-classic',
    path: '/jira/software/c/projects/:projectKey/summary'
};

});


parcelRegister("e99fJ", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryEmbedClassicRouteEntry", () => $ee0193265f7cd493$export$1dc5e581d8ca39ac);

var $7NszV = parcelRequire("7NszV");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $8zMZd = parcelRequire("8zMZd");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $jEWyg = parcelRequire("jEWyg");

var $5lsNZ = parcelRequire("5lsNZ");

var $6e4Kt = parcelRequire("6e4Kt");

var $9Hxle = parcelRequire("9Hxle");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");
const $ee0193265f7cd493$var$summarySoftwareEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $9Hxle.summarySoftwareEmbedEntrypoint)
});
const $ee0193265f7cd493$export$1dc5e581d8ca39ac = (0, $7NszV.createEntry)((0, $8zMZd.softwareSummaryEmbedClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-summary',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('jsw-summary-page-embed-smart-link-experiment', 'isEnabled', false), (0, $jEWyg.SummaryEmbedPage), (0, $5lsNZ.default)),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource)
        ],
        forPaint: [
            (0, $jEWyg.LazySummaryEmbedView)
        ],
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('project_summary_page_entry_point_migration')) return $ee0193265f7cd493$var$summarySoftwareEmbedPageEntrypoint;
        }
    }));

});
parcelRegister("8zMZd", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryEmbedClassicRoute", () => $f4e6d1316b36f71d$export$7fa3d3891ccec782);
const $f4e6d1316b36f71d$export$7fa3d3891ccec782 = {
    name: 'software-summary-classic-embed',
    path: '/jira/software/c/projects/:projectKey/summary/embed'
};

});


parcelRegister("hUUCw", function(module, exports) {

$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectRouteEntry", () => $d4fc432d647b5f41$export$8fd8b0cbd2b8730d);

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $bQgMC = parcelRequire("bQgMC");

var $e7bC3 = parcelRequire("e7bC3");

var $dxCvy = parcelRequire("dxCvy");

var $ffza4 = parcelRequire("ffza4");

var $13pw2 = parcelRequire("13pw2");
const $d4fc432d647b5f41$export$8fd8b0cbd2b8730d = (0, $7NszV.createEntry)((0, $bQgMC.softwareClassicProformaIssueFormsDirectRoute), ()=>({
        group: 'classic-software',
        component: (0, $13pw2.default),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $13pw2.LazyProformaIssueFormsDirect)
        ],
        perfMetricKey: 'issue-forms-direct'
    }));

});
parcelRegister("bQgMC", function(module, exports) {

$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectRoute", () => $a29107263e83fc90$export$92f34907c6bf7007);
const $a29107263e83fc90$export$92f34907c6bf7007 = {
    name: 'classic-software-proforma-issue-forms-direct',
    path: '/jira/software/c/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});

parcelRegister("13pw2", function(module, exports) {

$parcel$export(module.exports, "LazyProformaIssueFormsDirect", () => $480a54898b863a19$export$a0f04dd35569e11);
$parcel$export(module.exports, "default", () => $480a54898b863a19$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $480a54898b863a19$export$a0f04dd35569e11 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("0518c")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$480a54898b863a19$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $480a54898b863a19$export$a0f04dd35569e11,
        pageId: "proforma-issue-forms-direct",
        shouldShowSpinner: true
    });

});


parcelRegister("knZRG", function(module, exports) {

$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectEmbedRouteEntry", () => $e9a0be7e929de3ec$export$fdc2679a6c96e9fa);

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $kHaoU = parcelRequire("kHaoU");

var $6e4Kt = parcelRequire("6e4Kt");

var $33P3A = parcelRequire("33P3A");
const $e9a0be7e929de3ec$export$fdc2679a6c96e9fa = (0, $7NszV.createEntry)((0, $kHaoU.softwareClassicProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'classic-software',
        component: (0, $33P3A.default),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $33P3A.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    }));

});
parcelRegister("kHaoU", function(module, exports) {

$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectEmbedRoute", () => $e5452599d7d96b18$export$16987cdd084cceba);
const $e5452599d7d96b18$export$16987cdd084cceba = {
    name: 'classic-software-proforma-issue-forms-direct-embed',
    path: '/jira/software/c/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});

parcelRegister("33P3A", function(module, exports) {

$parcel$export(module.exports, "LazyProformaIssueFormsDirectEmbed", () => $a96f990777917c84$export$22681210aaeb910f);
$parcel$export(module.exports, "default", () => $a96f990777917c84$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $a96f990777917c84$export$22681210aaeb910f = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("fNYbs")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a96f990777917c84$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a96f990777917c84$export$22681210aaeb910f,
        pageId: "proforma-issue-forms-direct-embed",
        shouldShowSpinner: true
    });

});


parcelRegister("7dbQR", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicRouteEntry", () => $ec1385d68692f12b$export$e5eaafb1fb588922);

var $e4eHl = parcelRequire("e4eHl");

var $7NszV = parcelRequire("7NszV");

var $7XYc4 = parcelRequire("7XYc4");

var $5lsNZ = parcelRequire("5lsNZ");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $ffza4 = parcelRequire("ffza4");

var $7OCOC = parcelRequire("7OCOC");

var $kfztd = parcelRequire("kfztd");

var $gyYxw = parcelRequire("gyYxw");

var $hBv66 = parcelRequire("hBv66");

var $2GkDw = parcelRequire("2GkDw");

var $3woHG = parcelRequire("3woHG");

var $yxwH0 = parcelRequire("yxwH0");
const $ec1385d68692f12b$export$e5eaafb1fb588922 = (0, $7NszV.createEntry)((0, $7OCOC.softwareReportsDeploymentFrequencyClassicRoute), ()=>({
        group: 'classic-software',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $3woHG.DeploymentFrequencyReportClassic)),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $yxwH0.getReportsCommonResource)(),
            (0, $2GkDw.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $3woHG.LazyDeploymentFrequencyReport)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3woHG.LazyDeploymentFrequencyReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-deployment-frequency-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-deployment-frequency-classic'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("7OCOC", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicRoute", () => $8904c68da8a25316$export$312c410cb3b49afe);
const $8904c68da8a25316$export$312c410cb3b49afe = {
    name: 'software-reports-deployment-frequency-classic',
    path: '/jira/software/c/projects/:projectKey/reports/deployment-frequency',
    exact: true
};

});

parcelRegister("3woHG", function(module, exports) {

$parcel$export(module.exports, "LazyDeploymentFrequencyReport", () => $edf6d9a26482ed8b$export$5113b2b19ec1fb53);
$parcel$export(module.exports, "DeploymentFrequencyReportClassic", () => $edf6d9a26482ed8b$export$655707e8ae1053d3);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $edf6d9a26482ed8b$export$5113b2b19ec1fb53 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("dgHVZ")), {
    moduleId: "./src/packages/spa-apps/deployment-frequency-report/src/index.tsx"
});
const $edf6d9a26482ed8b$export$e2db9c7426cdb53 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $edf6d9a26482ed8b$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportNextGen",
        shouldShowSpinner: true
    });
const $edf6d9a26482ed8b$export$655707e8ae1053d3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $edf6d9a26482ed8b$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportClassic",
        shouldShowSpinner: true
    });

});


parcelRegister("jbAAG", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicBoardRouteEntry", () => $c8c352b6ab54773f$export$e0c7b9ad9dd8b956);

var $e4eHl = parcelRequire("e4eHl");

var $7NszV = parcelRequire("7NszV");

var $7XYc4 = parcelRequire("7XYc4");

var $5lsNZ = parcelRequire("5lsNZ");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $ffza4 = parcelRequire("ffza4");

var $jc0kT = parcelRequire("jc0kT");

var $kfztd = parcelRequire("kfztd");

var $gyYxw = parcelRequire("gyYxw");

var $hBv66 = parcelRequire("hBv66");

var $2GkDw = parcelRequire("2GkDw");

var $3woHG = parcelRequire("3woHG");

var $yxwH0 = parcelRequire("yxwH0");
const $c8c352b6ab54773f$export$e0c7b9ad9dd8b956 = (0, $7NszV.createEntry)((0, $jc0kT.softwareReportsDeploymentFrequencyClassicBoardRoute), ()=>({
        group: 'classic-software',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $3woHG.DeploymentFrequencyReportClassic)),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $yxwH0.getReportsCommonResource)(),
            (0, $2GkDw.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $3woHG.LazyDeploymentFrequencyReport)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3woHG.LazyDeploymentFrequencyReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-deployment-frequency-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-deployment-frequency-classic'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("jc0kT", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicBoardRoute", () => $a139294269da1f90$export$56d4754499615215);
const $a139294269da1f90$export$56d4754499615215 = {
    name: 'software-reports-deployment-frequency-classic-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/deployment-frequency',
    exact: true
};

});


parcelRegister("58Cy7", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBacklogRouteEntry", () => $80af0d16c3f293f2$export$568101ebd359b606);

var $7NszV = parcelRequire("7NszV");

var $2H7GR = parcelRequire("2H7GR");

var $16Z5s = parcelRequire("16Z5s");

var $i8JTM = parcelRequire("i8JTM");

var $4R6GH = parcelRequire("4R6GH");

var $aPfsS = parcelRequire("aPfsS");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $3HwlS = parcelRequire("3HwlS");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $7uLIV = parcelRequire("7uLIV");

var $f5kpo = parcelRequire("f5kpo");

var $lJ1FP = parcelRequire("lJ1FP");

var $lfnsv = parcelRequire("lfnsv");

var $fKmub = parcelRequire("fKmub");

var $ffza4 = parcelRequire("ffza4");

var $e2ctp = parcelRequire("e2ctp");

var $9s3j1 = parcelRequire("9s3j1");

var $cSD7y = parcelRequire("cSD7y");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $4xgA9 = parcelRequire("4xgA9");

var $9u12M = parcelRequire("9u12M");

var $3NItL = parcelRequire("3NItL");
/**
 * @deprecated delete when cleaning up blu-5799-jira-software-board-entrypoint-route
 */ const $80af0d16c3f293f2$var$getHorizontalNavResources = ()=>(0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $80af0d16c3f293f2$export$568101ebd359b606 = (0, $7NszV.createEntry)((0, $2H7GR.classicSoftwareBacklogRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-backlog',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $i8JTM.NextGenBacklogSkeleton),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-backlog'),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.pageLoadIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ], 'SIDEBAR')),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $cSD7y.componentWithFG)('make_nav_sidebar_lazyforpaint_in_board_and_backlog', (0, $9s3j1.ForPaintClassicSoftwareProjectSidebar), (0, $9s3j1.default)),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') ? (0, $lmyls.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // delete when cleaning up blu-5799-jira-software-board-entrypoint-route
            ...$80af0d16c3f293f2$var$getHorizontalNavResources(),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getUIFBacklogDataResource)(),
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)(),
            (0, $5bkvv.forgeBacklogModuleResource),
            (0, $5bkvv.forgeSprintModuleResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3NItL.LazyBacklogPage)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-backlog-early-entry'
            ]
        },
        meta: {
            capability: (0, $9u12M.classicBacklogCapability)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        entryPoint: ()=>((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? (0, $4xgA9.classicBacklogPageEntryPoint) : undefined
    }));

});
parcelRegister("2H7GR", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBacklogRoute", () => $fe6107d28b9a7842$export$9bfa3c0dded1688f);
const $fe6107d28b9a7842$export$9bfa3c0dded1688f = {
    name: 'rapidboard-backlog',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog'
};

});

parcelRegister("4xgA9", function(module, exports) {

$parcel$export(module.exports, "classicBacklogPageEntryPoint", () => $0d6e17d6eb5b0d6b$export$e07cd4fec395c8db);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $6avBT = parcelRequire("6avBT");

var $dwZUI = parcelRequire("dwZUI");

var $fT58V = parcelRequire("fT58V");

var $krpZe = parcelRequire("krpZe");

var $fo6b8 = parcelRequire("fo6b8");
const $0d6e17d6eb5b0d6b$export$e07cd4fec395c8db = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6avBT.nextGenBacklogEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $krpZe.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $dwZUI.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});

parcelRegister("9u12M", function(module, exports) {

$parcel$export(module.exports, "classicBacklogCapability", () => $552e03b9f8528211$export$10a7bb102137d92b);

const $552e03b9f8528211$export$10a7bb102137d92b = !false ? (0, $281cbd47ba46dd7d$export$571692eec8a399e1) : (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4);

});

parcelRegister("3NItL", function(module, exports) {

$parcel$export(module.exports, "LazyBacklogPage", () => $bc74f9ecc918272d$export$edb4b8cf67d7d767);

var $b7Svb = parcelRequire("b7Svb");

var $7yO8g = parcelRequire("7yO8g");

const $bc74f9ecc918272d$export$edb4b8cf67d7d767 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("azeQh"))), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});

});


parcelRegister("2XQq2", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBacklogEmbedRouteEntry", () => $f735d13d6cf6b150$export$1a7368427cd23b33);

var $7NszV = parcelRequire("7NszV");

var $iGbXw = parcelRequire("iGbXw");

var $4R6GH = parcelRequire("4R6GH");

var $16Z5s = parcelRequire("16Z5s");

var $6e4Kt = parcelRequire("6e4Kt");

var $f5kpo = parcelRequire("f5kpo");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $lJ1FP = parcelRequire("lJ1FP");

var $lfnsv = parcelRequire("lfnsv");

var $2Ql51 = parcelRequire("2Ql51");

var $fKmub = parcelRequire("fKmub");

var $e2ctp = parcelRequire("e2ctp");

var $3RJkv = parcelRequire("3RJkv");

var $3NItL = parcelRequire("3NItL");

var $9u12M = parcelRequire("9u12M");
const $f735d13d6cf6b150$export$1a7368427cd23b33 = (0, $7NszV.createEntry)((0, $iGbXw.classicSoftwareBacklogEmbedRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-backlog-embed',
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-backlog'),
        component: (0, $16Z5s.RapidBoardSpaPage),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            ...(0, $f5kpo.getUIFBacklogDataResource)(),
            ...(0, $f5kpo.getRapidboardResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)(),
            (0, $5bkvv.forgeBacklogModuleResource),
            (0, $5bkvv.forgeSprintModuleResource),
            (0, $2Ql51.themePreferenceResource)
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $3NItL.LazyBacklogPage)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-backlog-early-entry'
            ]
        },
        meta: {
            capability: (0, $9u12M.classicBacklogCapability)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("iGbXw", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBacklogEmbedRoute", () => $100ce1fd940d8aba$export$e6776ef8123b7136);
const $100ce1fd940d8aba$export$e6776ef8123b7136 = {
    name: 'rapidboard-backlog-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog/embed'
};

});


parcelRegister("4t69d", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardRouteEntry", () => $d579a749ad862761$export$f2cd114cf8ab53aa);

var $b4PzF = parcelRequire("b4PzF");

var $ffza4 = parcelRequire("ffza4");

var $e2ctp = parcelRequire("e2ctp");

var $4R6GH = parcelRequire("4R6GH");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $lfnsv = parcelRequire("lfnsv");

var $lJ1FP = parcelRequire("lJ1FP");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $ipmBb = parcelRequire("ipmBb");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $lB6pS = parcelRequire("lB6pS");

var $16Z5s = parcelRequire("16Z5s");

var $edJtc = parcelRequire("edJtc");

var $dEJQ9 = parcelRequire("dEJQ9");

var $hWAe2 = parcelRequire("hWAe2");

var $5f2bR = parcelRequire("5f2bR");

var $cSD7y = parcelRequire("cSD7y");

var $9V5k0 = parcelRequire("9V5k0");

var $3HwlS = parcelRequire("3HwlS");

var $lmBAt = parcelRequire("lmBAt");

var $5QYL3 = parcelRequire("5QYL3");

var $aSO4t = parcelRequire("aSO4t");
/**
 * Ordinarily it would be inadvisable to evaluate something like this in
 * a static route, as this could lead to inconsistent behaviour between
 * the server and the browser.
 *
 * In this case it is necessary and safe because:
 * 1) There are two versions of the board that share the same route
 *    and we can only tell them apart at runtime. When the old version
 *    is eventually removed, this should be cleaned up.
 * 2) No requests for board data are made on the server, so even
 *    if the value is incorrect on the server it won't be utilised
 * */ const $d579a749ad862761$var$getLayout = ()=>{
    let viewMode = 'DEFAULT';
    if ((0, $dEJQ9.isLocalStorageAvailable)()) viewMode = (0, $edJtc.getViewModeFromLocalStorage)();
    return (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.pageLoadIssuePreloadLayoutBuilder)([
        {
            query: [
                'selectedIssue'
            ]
        }
    ], viewMode));
};
/**
 * @deprecated delete when cleaning up blu-5799-jira-software-board-entrypoint-route
 */ const $d579a749ad862761$var$getHorizontalNavResources = ()=>(0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $d579a749ad862761$export$f2cd114cf8ab53aa = (0, $7NszV.createEntry)((0, $lB6pS.classicSoftwareBoardRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-board'),
        layout: $d579a749ad862761$var$getLayout(),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $cSD7y.componentWithFG)('make_nav_sidebar_lazyforpaint_in_board_and_backlog', (0, $9s3j1.ForPaintClassicSoftwareProjectSidebar), (0, $9s3j1.default)),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? (0, $lmyls.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // delete when cleaning up blu-5799-jira-software-board-entrypoint-route
            ...$d579a749ad862761$var$getHorizontalNavResources(),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $gNStA.resourceWithCondition2)((0, $f5kpo.shouldLoadUIFBoardResources), (0, $f7Y15.uifBoardResource)),
            // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
            (0, $gNStA.resourceWithCondition2)(()=>(0, $f5kpo.shouldLoadUIFBoardResources)() && !(0, $b4PzF.isFedRamp)(), (0, $ipmBb.nextBestTaskFeatureResource)),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)(),
            (0, $5bkvv.forgeBoardModuleResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.UIFBoardSpa)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-board-early-entry'
            ]
        },
        meta: {
            capability: (0, $5QYL3.classicBoardCapability)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-classic-board-entries/src/classicSoftwareBoardRouteEntry.tsx',
                whichExportToUse: 'classicSoftwareBoardRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-software-board.json'
        },
        entryPoint: ()=>((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? (0, $aSO4t.classicBoardPageEntryPoint) : undefined
    }));

});
parcelRegister("lB6pS", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardRoute", () => $9dbec22457c8ec85$export$131d51ca54849e97);
const $9dbec22457c8ec85$export$131d51ca54849e97 = {
    name: 'rapidboard-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId'
};

});

parcelRegister("edJtc", function(module, exports) {

$parcel$export(module.exports, "getViewModeFromLocalStorage", () => $75ce4ce78f606e67$export$cae7c4c591dcc261);

var $7l48d = parcelRequire("7l48d");
const $75ce4ce78f606e67$export$cae7c4c591dcc261 = ()=>{
    if (false) return 'DEFAULT';
    return (0, $7l48d.localStorage).get((0, $7l48d.VIEW_MODE_STORAGE_KEY)) || 'DEFAULT';
};

});
parcelRegister("7l48d", function(module, exports) {

$parcel$export(module.exports, "LOG_LOCATION", () => $e736233a6ed098e3$export$25a759e49d5049db);
$parcel$export(module.exports, "localStorage", () => $e736233a6ed098e3$export$c2ed3351cac403d1);
$parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", () => $e736233a6ed098e3$export$a13f7f627010bccd);

var $bSSG7 = parcelRequire("bSSG7");
const $e736233a6ed098e3$export$25a759e49d5049db = 'issue.issue-context-service';
const $e736233a6ed098e3$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('jira_issue_view');
const $e736233a6ed098e3$export$a13f7f627010bccd = 'view-mode';

});


parcelRegister("5QYL3", function(module, exports) {

$parcel$export(module.exports, "classicBoardCapability", () => $72ffa11e3a10b500$export$a6d9a03b76d2193b);

const $72ffa11e3a10b500$export$a6d9a03b76d2193b = !false ? (0, $281cbd47ba46dd7d$export$664edf77d4c76110) : (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c);

});

parcelRegister("aSO4t", function(module, exports) {

$parcel$export(module.exports, "classicBoardPageEntryPoint", () => $4fe96d7ad77574d7$export$b7ca8af848cd7993);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $7rNZV = parcelRequire("7rNZV");

var $dwZUI = parcelRequire("dwZUI");

var $fT58V = parcelRequire("fT58V");

var $krpZe = parcelRequire("krpZe");

var $fo6b8 = parcelRequire("fo6b8");
const $4fe96d7ad77574d7$export$b7ca8af848cd7993 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7rNZV.nextGenBoardEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $krpZe.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $dwZUI.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("7rNZV", function(module, exports) {

$parcel$export(module.exports, "nextGenBoardEntryPoint", () => $c106d875c43f76b2$export$bb3c6f02a735f848);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $c106d875c43f76b2$export$bb3c6f02a735f848 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("4dj4f")), {
        moduleId: "5be6be56"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});



parcelRegister("e1cjg", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardEmbedRouteEntry", () => $eac56df495f9e28b$export$b5558b683e9c45a4);

var $b4PzF = parcelRequire("b4PzF");

var $4R6GH = parcelRequire("4R6GH");

var $fKmub = parcelRequire("fKmub");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $lfnsv = parcelRequire("lfnsv");

var $lJ1FP = parcelRequire("lJ1FP");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $ipmBb = parcelRequire("ipmBb");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $2Ql51 = parcelRequire("2Ql51");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $fEr2a = parcelRequire("fEr2a");

var $16Z5s = parcelRequire("16Z5s");

var $aPfsS = parcelRequire("aPfsS");

var $5QYL3 = parcelRequire("5QYL3");
const $eac56df495f9e28b$export$b5558b683e9c45a4 = (0, $7NszV.createEntry)((0, $fEr2a.classicSoftwareBoardEmbedRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board-embed',
        component: (0, $16Z5s.RapidBoardSpaPage),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-board'),
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $gNStA.resourceWithCondition2)((0, $f5kpo.shouldLoadUIFBoardResources), (0, $f7Y15.uifBoardResource)),
            // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
            (0, $gNStA.resourceWithCondition2)(()=>(0, $f5kpo.shouldLoadUIFBoardResources)() && !(0, $b4PzF.isFedRamp)(), (0, $ipmBb.nextBestTaskFeatureResource)),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)(),
            (0, $2Ql51.themePreferenceResource),
            (0, $5bkvv.forgeBoardModuleResource)
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $16Z5s.UIFBoardSpa)
        ],
        meta: {
            capability: (0, $5QYL3.classicBoardCapability)
        }
    }));

});
parcelRegister("fEr2a", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardEmbedRoute", () => $4d20da2caca0ff94$export$122afcef7dfd252);
const $4d20da2caca0ff94$export$122afcef7dfd252 = {
    name: 'rapidboard-board-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/embed'
};

});


parcelRegister("4XUsE", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserBacklogRouteEntry", () => $5ef9e40cccee388d$export$ccde3c1d7a857b27);

var $7NszV = parcelRequire("7NszV");

var $16Z5s = parcelRequire("16Z5s");

var $f5kpo = parcelRequire("f5kpo");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $lJ1FP = parcelRequire("lJ1FP");

var $lfnsv = parcelRequire("lfnsv");

var $fKmub = parcelRequire("fKmub");

var $e2ctp = parcelRequire("e2ctp");

var $csqnl = parcelRequire("csqnl");

var $i8JTM = parcelRequire("i8JTM");

var $aPfsS = parcelRequire("aPfsS");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $7uLIV = parcelRequire("7uLIV");

var $ffza4 = parcelRequire("ffza4");

var $4R6GH = parcelRequire("4R6GH");

var $6pu8Q = parcelRequire("6pu8Q");

var $7qieH = parcelRequire("7qieH");

var $2h7lp = parcelRequire("2h7lp");
/**
 * @deprecated delete when cleaning up fun-1617-rapidboard-user-backlog-to-entrypoint
 */ const $5ef9e40cccee388d$var$getHorizontalNavResources = ()=>(0, $4R6GH.fg)('fun-1617-rapidboard-user-backlog-to-entrypoint') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $5ef9e40cccee388d$export$ccde3c1d7a857b27 = (0, $7NszV.createEntry)((0, $csqnl.rapidboardUserBacklogRoute), ()=>({
        group: 'classic-software',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $i8JTM.NextGenBacklogSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            ...$5ef9e40cccee388d$var$getHorizontalNavResources(),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getUIFBacklogDataResource)(),
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)(),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: (0, $4R6GH.fg)('fun-1617-rapidboard-user-backlog-to-entrypoint') ? undefined : [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6pu8Q.LazyBacklogPage)
        ],
        entryPoint: ()=>(0, $4R6GH.fg)('fun-1617-rapidboard-user-backlog-to-entrypoint') ? (0, $2h7lp.backlogPageEntrypoint) : undefined,
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $7qieH.classicBacklogCapability)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("csqnl", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserBacklogRoute", () => $710a0fc51c857594$export$79c2d9718e914f91);
const $710a0fc51c857594$export$79c2d9718e914f91 = {
    name: 'rapidboard-user-backlog',
    path: '/jira/people/:accountId/boards/:boardId/backlog'
};

});

parcelRegister("6pu8Q", function(module, exports) {

$parcel$export(module.exports, "LazyBacklogPage", () => $b734747efcdabcad$export$edb4b8cf67d7d767);

var $b7Svb = parcelRequire("b7Svb");

var $7yO8g = parcelRequire("7yO8g");

const $b734747efcdabcad$export$edb4b8cf67d7d767 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("azeQh"))), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});

});

parcelRegister("7qieH", function(module, exports) {

$parcel$export(module.exports, "classicBacklogCapability", () => $8c35ce65b592afc5$export$10a7bb102137d92b);

const $8c35ce65b592afc5$export$10a7bb102137d92b = !false ? (0, $281cbd47ba46dd7d$export$571692eec8a399e1) : (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4);

});

parcelRegister("2h7lp", function(module, exports) {

$parcel$export(module.exports, "backlogPageEntrypoint", () => $89c165261f1ffe48$export$1ccf08591607897d);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $6avBT = parcelRequire("6avBT");
const $89c165261f1ffe48$export$1ccf08591607897d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6avBT.nextGenBacklogEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("jqbKy", function(module, exports) {

$parcel$export(module.exports, "userBoardVelocityRouteEntry", () => $7546dfa7baced42b$export$ba0f726701b9e407);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $gyYxw = parcelRequire("gyYxw");

var $9itNB = parcelRequire("9itNB");

var $jD7nj = parcelRequire("jD7nj");
const $7546dfa7baced42b$export$ba0f726701b9e407 = (0, $7NszV.createEntry)((0, $9itNB.userBoardVelocityRoute), ()=>({
        group: 'classic-software',
        ufoName: 'software-reports.velocity-report-cmp',
        component: (0, $jD7nj.default),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jD7nj.LazyNextGenVelocityReport)
        ]
    }));

});
parcelRegister("9itNB", function(module, exports) {

$parcel$export(module.exports, "userBoardVelocityRoute", () => $75bc02f5d3dae3fa$export$57431a0e4f3a32e8);
const $75bc02f5d3dae3fa$export$57431a0e4f3a32e8 = {
    name: 'software-reports-velocity-user-board',
    path: '/jira/people/:accountId/boards/:boardId/reports/velocity'
};

});


parcelRegister("e7GI8", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserReportsOverviewRouteEntry", () => $2b4f7b178bf7d762$export$721c38d3152f9625);

var $7NszV = parcelRequire("7NszV");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $8OTYY = parcelRequire("8OTYY");

var $gyYxw = parcelRequire("gyYxw");

var $5f2bR = parcelRequire("5f2bR");

var $lkFvK = parcelRequire("lkFvK");

var $hBv66 = parcelRequire("hBv66");

var $f5kpo = parcelRequire("f5kpo");

var $fo6b8 = parcelRequire("fo6b8");

var $7GnDe = parcelRequire("7GnDe");

var $3RJkv = parcelRequire("3RJkv");

var $fh5Sl = parcelRequire("fh5Sl");
const $2b4f7b178bf7d762$var$reportsOverviewPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fh5Sl.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $2b4f7b178bf7d762$export$721c38d3152f9625 = (0, $7NszV.createEntry)((0, $8OTYY.rapidboardUserReportsOverviewRoute), ()=>({
        group: 'classic-software',
        entryPoint () {
            return (0, $4R6GH.fg)('reports-overview-page-migration') ? $2b4f7b178bf7d762$var$reportsOverviewPageEntryPoint : undefined;
        },
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            ...(0, $3RJkv.getUserBoardNavigationResources)(),
            ...(0, $f5kpo.getRapidboardResources)()
        ],
        ufoName: 'reports-overview'
    }));

});
parcelRegister("8OTYY", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserReportsOverviewRoute", () => $bd6a1ad5f3384924$export$6101ec4dca41c740);
const $bd6a1ad5f3384924$export$6101ec4dca41c740 = {
    name: 'rapidboard-user-reports-overview',
    path: '/jira/people/:accountId/boards/:boardId/reports'
};

});


parcelRegister("bbDvZ", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserReportRouteEntry", () => $aba9ebd89ef67057$export$374d78dc1cde7b56);

var $7NszV = parcelRequire("7NszV");

var $16Z5s = parcelRequire("16Z5s");

var $f5kpo = parcelRequire("f5kpo");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $fKmub = parcelRequire("fKmub");

var $e2ctp = parcelRequire("e2ctp");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $3RJkv = parcelRequire("3RJkv");

var $7uLIV = parcelRequire("7uLIV");

var $ffza4 = parcelRequire("ffza4");

var $jMZEA = parcelRequire("jMZEA");

var $7o1kb = parcelRequire("7o1kb");

var $yxwH0 = parcelRequire("yxwH0");
const $aba9ebd89ef67057$export$374d78dc1cde7b56 = (0, $7NszV.createEntry)((0, $jMZEA.rapidboardUserReportRoute), ()=>({
        group: 'classic-software',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $7o1kb.ClassicReportSkeleton),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            ...(0, $yxwH0.getReportsCommonResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("jMZEA", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserReportRoute", () => $2f9ddde12b93dadf$export$7b85bca17717def6);
const $2f9ddde12b93dadf$export$7b85bca17717def6 = {
    name: 'rapidboard-user-report',
    path: '/jira/people/:accountId/boards/:boardId/reports/:chartView'
};

});


parcelRegister("dR9Nr", function(module, exports) {

$parcel$export(module.exports, "userBoardRouteEntry", () => $9a056980ad2b7a75$export$cde4dacc737dc0f1);

var $ffza4 = parcelRequire("ffza4");

var $e2ctp = parcelRequire("e2ctp");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $lfnsv = parcelRequire("lfnsv");

var $lJ1FP = parcelRequire("lJ1FP");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $lyCs2 = parcelRequire("lyCs2");

var $hWAe2 = parcelRequire("hWAe2");

var $5f2bR = parcelRequire("5f2bR");

var $16Z5s = parcelRequire("16Z5s");
const $9a056980ad2b7a75$export$cde4dacc737dc0f1 = (0, $7NszV.createEntry)((0, $lyCs2.userBoardRoute), ()=>({
        group: 'classic-software',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)(),
            (0, $gNStA.resourceWithCondition2)((0, $f5kpo.shouldLoadUIFBoardResources), (0, $f7Y15.uifBoardResource)),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps),
            (0, $16Z5s.LazyRapidBoardDataApiResource),
            (0, $16Z5s.LazyRapidBoardConfigApiResource),
            (0, $16Z5s.LazyRapidBoardWrmBundleResource),
            (0, $16Z5s.LazyRapidBoardResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-board-early-entry'
            ]
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("lyCs2", function(module, exports) {

$parcel$export(module.exports, "userBoardRoute", () => $a9c2c98045690ca6$export$57a2a0fe739f16);
const $a9c2c98045690ca6$export$57a2a0fe739f16 = {
    name: 'rapidboard-user-board',
    path: '/jira/people/:accountId/boards/:boardId'
};

});


parcelRegister("goreX", function(module, exports) {

$parcel$export(module.exports, "userBoardSettingsRouteEntry", () => $00cdba91b5f0dbcb$export$f8e56ba3f544195d);

var $gyYxw = parcelRequire("gyYxw");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $lfnsv = parcelRequire("lfnsv");

var $lJ1FP = parcelRequire("lJ1FP");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $2aqtf = parcelRequire("2aqtf");

var $hWAe2 = parcelRequire("hWAe2");

var $e3Qmo = parcelRequire("e3Qmo");

var $lmyls = parcelRequire("lmyls");

var $4R6GH = parcelRequire("4R6GH");

var $hBv66 = parcelRequire("hBv66");

var $7uLIV = parcelRequire("7uLIV");
const $00cdba91b5f0dbcb$export$f8e56ba3f544195d = (0, $7NszV.createEntry)((0, $2aqtf.userBoardSettingsRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        entryPoint: ()=>(0, $e3Qmo.boardSettingsPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            sidebarId: (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? (0, $lmyls.SIDEBAR_ID).BOARD_SETTINGS : undefined
        },
        layout: (0, $gyYxw.genericProjectLayout),
        // This list is based on the resources needed by ./userBoardRouteEntry.tsx
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)(),
            (0, $gNStA.resourceWithCondition2)((0, $f5kpo.shouldLoadUIFBoardResources), (0, $f7Y15.uifBoardResource)),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)()
        ]
    }));

});
parcelRegister("2aqtf", function(module, exports) {

$parcel$export(module.exports, "userBoardSettingsRoute", () => $439048221d4c78c5$export$a6e04dfbb956c677);
const $439048221d4c78c5$export$a6e04dfbb956c677 = {
    name: 'rapidboard-user-board-settings',
    path: '/jira/people/:accountId/boards/:boardId/settings/:config',
    query: [
        'from-backlog?'
    ]
};

});


parcelRegister("3eN7Y", function(module, exports) {

$parcel$export(module.exports, "userBoardViewNotFoundRouteEntry", () => $6b06d90b3814210b$export$a2bfa34d08651f6d);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dnp0v = parcelRequire("dnp0v");

var $5f2bR = parcelRequire("5f2bR");

var $hhqrL = parcelRequire("hhqrL");
const $6b06d90b3814210b$export$a2bfa34d08651f6d = (0, $7NszV.createEntry)((0, $dnp0v.userBoardViewNotFoundRoute), ()=>({
        group: 'classic-software',
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $hhqrL.boardViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("dnp0v", function(module, exports) {

$parcel$export(module.exports, "userBoardViewNotFoundRoute", () => $41341d667544a268$export$ad6b96e14e735ed7);
const $41341d667544a268$export$ad6b96e14e735ed7 = {
    name: 'rapidboard-user-board-view-not-found',
    path: '/jira/people/:accountId/boards/:boardId/not-found'
};

});

parcelRegister("hhqrL", function(module, exports) {

$parcel$export(module.exports, "boardViewNotFoundPageEntrypoint", () => $c49d7c07685117d8$export$7f51979492148d53);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $8cOrT = parcelRequire("8cOrT");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

const $c49d7c07685117d8$var$main = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("6yKMz")), {
        moduleId: "83a02129",
        moduleName: "BoardViewNotFound"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const boardId = context.match.params.boardId;
        if (boardId == null) throw new Error('Board id missing');
        return {
            queries: {
                mainQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $8cOrT.default,
                    variables: {
                        boardId: `ari:cloud:jira-software:${cloudId}:board/${boardId}`
                    }
                }
            }
        };
    }
});
const $c49d7c07685117d8$export$7f51979492148d53 = (0, $lkFvK.createPageEntryPoint)({
    main: $c49d7c07685117d8$var$main,
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("8cOrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e82953f4eddfcb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39b4c2382e9edb79ca18ee82cc3dcb5e>>
 * @relayHash c015acb85644d3bee5c8b2cb145b1d66
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 082161233dbd381be9ed014242444b47bd21443811aada3c5cc8c3c2e46e7c51
const $a9e82953f4eddfcb$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "082161233dbd381be9ed014242444b47bd21443811aada3c5cc8c3c2e46e7c51",
        "metadata": {},
        "name": "BoardViewNotFoundQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a9e82953f4eddfcb$export$2e2bcd8739ae039 = $a9e82953f4eddfcb$var$node;

});

parcelRegister("6yKMz", function(module, exports) {

let $4c6a3510e2ae79d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4c6a3510e2ae79d0$var$load("aatkE").then(()=>parcelRequire('bICXK'));

});



parcelRegister("aA0rC", function(module, exports) {

$parcel$export(module.exports, "rapidboardBacklog1RouteEntry", () => $1bf0295d0982658a$export$ee2385c1acba53f2);

var $7NszV = parcelRequire("7NszV");

var $16Z5s = parcelRequire("16Z5s");

var $f5kpo = parcelRequire("f5kpo");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $fKmub = parcelRequire("fKmub");

var $e2ctp = parcelRequire("e2ctp");

var $i8JTM = parcelRequire("i8JTM");

var $aPfsS = parcelRequire("aPfsS");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $7uLIV = parcelRequire("7uLIV");

var $ffza4 = parcelRequire("ffza4");

var $3Lsjg = parcelRequire("3Lsjg");

const $1bf0295d0982658a$export$ee2385c1acba53f2 = (0, $7NszV.createEntry)((0, $3Lsjg.rapidboardBacklog1Route), ()=>({
        group: 'classic-software',
        ufoName: 'classic-backlog',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $i8JTM.NextGenBacklogSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=planning'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("3Lsjg", function(module, exports) {

$parcel$export(module.exports, "rapidboardBacklog1Route", () => $af1c8b7df470b6b1$export$ff874528b0b33a61);
const $af1c8b7df470b6b1$export$ff874528b0b33a61 = {
    name: 'rapidboard-backlog',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=(planning|planning.nodetail)'
    ]
};

});


parcelRegister("jss6V", function(module, exports) {

$parcel$export(module.exports, "rapidboardReport1RouteEntry", () => $231e2e3fd736b80c$export$7e8c0a9f6d68837);

var $7NszV = parcelRequire("7NszV");

var $16Z5s = parcelRequire("16Z5s");

var $f5kpo = parcelRequire("f5kpo");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $fKmub = parcelRequire("fKmub");

var $e2ctp = parcelRequire("e2ctp");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $3RJkv = parcelRequire("3RJkv");

var $7uLIV = parcelRequire("7uLIV");

var $ffza4 = parcelRequire("ffza4");

var $fIEje = parcelRequire("fIEje");

var $7o1kb = parcelRequire("7o1kb");

var $yxwH0 = parcelRequire("yxwH0");
const $231e2e3fd736b80c$export$7e8c0a9f6d68837 = (0, $7NszV.createEntry)((0, $fIEje.rapidboardReport1Route), ()=>({
        group: 'classic-software',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $7o1kb.ClassicReportSkeleton),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            ...(0, $yxwH0.getReportsCommonResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        ufoName: 'classic-report'
    }));

});
parcelRegister("fIEje", function(module, exports) {

$parcel$export(module.exports, "rapidboardReport1Route", () => $0732a35485277820$export$d27f9ad2fc277ff9);
const $0732a35485277820$export$d27f9ad2fc277ff9 = {
    name: 'rapidboard-report',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=reporting',
        'chart'
    ]
};

});


parcelRegister("6B4GJ", function(module, exports) {

$parcel$export(module.exports, "softwareCodeClassicRouteEntry", () => $7aa05f37015fe3d2$export$6acfada96c85cfaa);

var $7NszV = parcelRequire("7NszV");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $lmyls = parcelRequire("lmyls");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $7uLIV = parcelRequire("7uLIV");

var $ffza4 = parcelRequire("ffza4");

var $cu9WL = parcelRequire("cu9WL");

var $iZ82x = parcelRequire("iZ82x");

var $7XYc4 = parcelRequire("7XYc4");

var $kfztd = parcelRequire("kfztd");

var $5lsNZ = parcelRequire("5lsNZ");

var $e7bC3 = parcelRequire("e7bC3");

var $9s3j1 = parcelRequire("9s3j1");

var $brJ9B = parcelRequire("brJ9B");
const $7aa05f37015fe3d2$export$6acfada96c85cfaa = (0, $7NszV.createEntry)((0, $cu9WL.softwareCodeClassicRoute), ()=>({
        group: 'classic-software',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $iZ82x.codePageResource)
        ],
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $brJ9B.CodePageClassic)),
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $brJ9B.LazyCode)
        ]
    }));

});
parcelRegister("cu9WL", function(module, exports) {

$parcel$export(module.exports, "softwareCodeClassicRoute", () => $7462b5ebecb54ef7$export$d92cd77785d00ff);
const $7462b5ebecb54ef7$export$d92cd77785d00ff = {
    name: 'software-code-classic',
    path: '/jira/software/c/projects/:projectKey/code'
};

});

parcelRegister("brJ9B", function(module, exports) {

$parcel$export(module.exports, "LazyCode", () => $6049b4a08957accb$export$4beafd9dbad29bff);
$parcel$export(module.exports, "CodePageClassic", () => $6049b4a08957accb$export$95e2389b7ca7ccf2);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $iS0yP = parcelRequire("iS0yP");

const $6049b4a08957accb$export$4beafd9dbad29bff = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("CEh0a"))), {
    moduleId: "./src/packages/spa-apps/code/src/index.tsx"
});
const $6049b4a08957accb$export$d9e8184332f86b53 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6049b4a08957accb$export$4beafd9dbad29bff,
        pageId: `next-gen-code-${(0, $iS0yP.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });
const $6049b4a08957accb$export$95e2389b7ca7ccf2 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6049b4a08957accb$export$4beafd9dbad29bff,
        pageId: `classic-code-${(0, $iS0yP.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("iS0yP", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $12fea879e07c880e$export$557c2f222778cea6);

var $ebyGx = parcelRequire("ebyGx");
const $12fea879e07c880e$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search);
    return rapidView;
};

});



parcelRegister("fMbaV", function(module, exports) {

$parcel$export(module.exports, "softwareSecurityClassicRouteEntry", () => $24f436c9befc4f10$export$8acfebad16c9d6f2);

var $5uXOq = parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $ffza4 = parcelRequire("ffza4");

var $bwLf9 = parcelRequire("bwLf9");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $en8e6 = parcelRequire("en8e6");

var $5lsNZ = parcelRequire("5lsNZ");

var $g5C5j = parcelRequire("g5C5j");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $5j7Th = parcelRequire("5j7Th");

var $4R6GH = parcelRequire("4R6GH");

var $6LsQE = parcelRequire("6LsQE");

var $crK2h = parcelRequire("crK2h");

var $d6VEe = parcelRequire("d6VEe");

var $7AM4I = parcelRequire("7AM4I");
const $24f436c9befc4f10$var$SecurityClassic = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $d6VEe.LazySecurity),
        pageId: "securityClassic",
        shouldShowSpinner: true
    });
/** @deprecated remove when cleaning up 'jira-software-security-routes-entrypoint-migration' */ const $24f436c9befc4f10$var$getHorizontalNavResource = ()=>(0, $4R6GH.fg)('jira-software-security-routes-entrypoint-migration') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $24f436c9befc4f10$export$8acfebad16c9d6f2 = (0, $7NszV.createEntry)((0, $g5C5j.softwareSecurityClassicRoute), ()=>({
        group: 'classic-software',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            ...$24f436c9befc4f10$var$getHorizontalNavResource(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $en8e6.securityPageResource)
        ],
        ufoName: 'software-security-combined',
        component: (0, $4R6GH.fg)('jira-software-security-routes-entrypoint-migration') ? undefined : (0, $bwLf9.default)((0, $crK2h.isSecurityPageEnabled), $24f436c9befc4f10$var$SecurityClassic, (0, $5lsNZ.default)),
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: (0, $4R6GH.fg)('jira-software-security-routes-entrypoint-migration') ? undefined : [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $d6VEe.LazySecurity)
        ],
        meta: {
            reporting: {
                id: 'software-security-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-security-classic'),
                teamName: 'fusion-isotopes'
            }
        },
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('jira-software-security-routes-entrypoint-migration')) return (0, $crK2h.isSecurityPageEnabled)() ? (0, $7AM4I.securityPageEntrypoint) : (0, $6LsQE.notFoundPageEntrypoint);
            return undefined;
        }
    }));

});
parcelRegister("g5C5j", function(module, exports) {

$parcel$export(module.exports, "softwareSecurityClassicRoute", () => $c527ab87b834a4bd$export$b7285748f1151353);
const $c527ab87b834a4bd$export$b7285748f1151353 = {
    name: 'software-security-classic',
    path: '/jira/software/c/projects/:projectKey/security'
};

});


parcelRegister("bi9fZ", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsClassicRouteEntry", () => $3da78177932dfa66$export$dcf1f9ba660dedf6);

var $5uXOq = parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $b4koY = parcelRequire("b4koY");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $lKmRI = parcelRequire("lKmRI");

var $kfztd = parcelRequire("kfztd");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $5j7Th = parcelRequire("5j7Th");

var $8AiWD = parcelRequire("8AiWD");
const $3da78177932dfa66$var$DeploymentsClassic = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $8AiWD.LazyDeployments),
        pageId: "deploymentsClassic",
        shouldShowSpinner: true
    });
const $3da78177932dfa66$export$dcf1f9ba660dedf6 = (0, $7NszV.createEntry)((0, $lKmRI.softwareDeploymentsClassicRoute), ()=>({
        group: 'classic-software',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $b4koY.deploymentPreconditionRelayResource),
            (0, $dxCvy.projectContextResource)
        ],
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), $3da78177932dfa66$var$DeploymentsClassic),
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8AiWD.LazyDeployments)
        ],
        meta: {
            reporting: {
                id: 'software-deployments-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-deployments-classic'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("lKmRI", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsClassicRoute", () => $d186f38c5f1ffe01$export$485e4a7b82f29d70);
const $d186f38c5f1ffe01$export$485e4a7b82f29d70 = {
    name: 'software-deployments-classic',
    path: '/jira/software/c/projects/:projectKey/deployments'
};

});


parcelRegister("7Db7a", function(module, exports) {

$parcel$export(module.exports, "softwarePeriscopeClassicRouteEntry", () => $12f7aae3d37ddd7e$export$d7d49c1a51b3c0a9);

var $5uXOq = parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $b4PzF = parcelRequire("b4PzF");

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $ajKFd = parcelRequire("ajKFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $dOiL8 = parcelRequire("dOiL8");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $5j7Th = parcelRequire("5j7Th");

var $lYBIs = parcelRequire("lYBIs");
const $12f7aae3d37ddd7e$var$PeriscopeClassic = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $lYBIs.LazyPeriscope),
        pageId: "softwarePeriscopeClassic",
        shouldShowSpinner: true
    });
const $12f7aae3d37ddd7e$export$d7d49c1a51b3c0a9 = (0, $7NszV.createEntry)((0, $dOiL8.softwarePeriscopeClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $ajKFd.Skeleton),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource)
        ],
        component: (0, $7XYc4.componentWithCondition)((0, $b4PzF.isFedRamp), (0, $5lsNZ.default), $12f7aae3d37ddd7e$var$PeriscopeClassic),
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lYBIs.LazyPeriscope)
        ],
        meta: {
            reporting: {
                id: 'software-periscope-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-periscope-classic'),
                teamName: 'nova'
            }
        }
    }));

});
parcelRegister("dOiL8", function(module, exports) {

$parcel$export(module.exports, "softwarePeriscopeClassicRoute", () => $6b68b587bba860e4$export$cb5cec74f302b3c6);
const $6b68b587bba860e4$export$cb5cec74f302b3c6 = {
    name: 'software-periscope-classic',
    path: '/jira/software/c/projects/:projectKey/development'
};

});


parcelRegister("hjVS0", function(module, exports) {

$parcel$export(module.exports, "rapidboardLastVisitedProjectRedirectRouteEntry", () => $09ab131c9331c58d$export$420f86cfd239da4d);

var $7NszV = parcelRequire("7NszV");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $ffza4 = parcelRequire("ffza4");

var $Th6Kd = parcelRequire("Th6Kd");

var $7MCPm = parcelRequire("7MCPm");
const $09ab131c9331c58d$export$420f86cfd239da4d = (0, $7NszV.createEntry)((0, $Th6Kd.rapidboardLastVisitedProjectRedirectRoute), ()=>({
        group: 'classic-software',
        component: (0, $7MCPm.RedirectToLastVisitedProjectPage),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        isRedirect: true,
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("Th6Kd", function(module, exports) {

$parcel$export(module.exports, "rapidboardLastVisitedProjectRedirectRoute", () => $848732acccd8706d$export$991b1be164057e91);
const $848732acccd8706d$export$991b1be164057e91 = {
    name: 'rapidboard-last-visited-project-redirect',
    path: '/secure/RapidBoard.jspa',
    query: [
        'projectKey'
    ],
    __unsafeOrder: 1
};

});


parcelRegister("aAF0I", function(module, exports) {

$parcel$export(module.exports, "projectDirectoryRedirectRouteEntry", () => $a32e24e3142418a0$export$f1f04e35fd5f4283);

var $5uXOq = parcelRequire("5uXOq");

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $ffza4 = parcelRequire("ffza4");

var $3JE1m = parcelRequire("3JE1m");

var $ds5qV = parcelRequire("ds5qV");

var $2BrOV = parcelRequire("2BrOV");
const $a32e24e3142418a0$var$ProjectsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/projects"
    });
const $a32e24e3142418a0$export$f1f04e35fd5f4283 = (0, $7NszV.createEntry)((0, $3JE1m.projectDirectoryRedirectRoute), ()=>({
        group: 'classic-software',
        component: $a32e24e3142418a0$var$ProjectsDirectoryRedirect,
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        isRedirect: true,
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("3JE1m", function(module, exports) {

$parcel$export(module.exports, "projectDirectoryRedirectRoute", () => $0939314fcba99a8c$export$3913c8bee519225c);
const $0939314fcba99a8c$export$3913c8bee519225c = {
    name: 'project-directory-redirect',
    path: '/secure/RapidBoard.jspa'
};

});


parcelRegister("4Mj46", function(module, exports) {

$parcel$export(module.exports, "softwareIncidentsClassicRouteEntry", () => $dedf0d7500ec9709$export$c7d98bfe75274932);

var $e4eHl = parcelRequire("e4eHl");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $eIvCa = parcelRequire("eIvCa");

var $9LHPC = parcelRequire("9LHPC");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $hb1PV = parcelRequire("hb1PV");

var $BrpCW = parcelRequire("BrpCW");
const $dedf0d7500ec9709$export$c7d98bfe75274932 = (0, $7NszV.createEntry)((0, $eIvCa.softwareIncidentsClassicRoute), ()=>({
        group: 'classic-software',
        entryPoint () {
            return (0, $4R6GH.fg)('corex_operandi_incidents_page_in_jira') ? (0, $hb1PV.entryPoint) : (0, $BrpCW.entryPointDeprecated);
        },
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        skeleton: (0, $9LHPC.IncidentsPageSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $7GnDe.incidentsInitialPageChecksResource),
            (0, $7GnDe.incidentsCustomFieldIdResource)
        ],
        meta: {
            reporting: {
                id: 'software-incidents-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-incidents-classic'),
                teamName: 'operandi'
            }
        },
        ufoName: 'software-incidents'
    }));

});
parcelRegister("eIvCa", function(module, exports) {

$parcel$export(module.exports, "softwareIncidentsClassicRoute", () => $a586f286b7619cb0$export$3356a7870a2717f4);
const $a586f286b7619cb0$export$3356a7870a2717f4 = {
    name: 'software-incidents-classic',
    path: '/jira/software/c/projects/:projectKey/incidents'
};

});


parcelRegister("3I1TD", function(module, exports) {

$parcel$export(module.exports, "softwareViewNotFoundRouteEntry", () => $4bb0af0452a6f272$export$7dab5fe9ccb76142);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $l0Xu9 = parcelRequire("l0Xu9");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $1g8oF = parcelRequire("1g8oF");
const $4bb0af0452a6f272$export$7dab5fe9ccb76142 = (0, $7NszV.createEntry)((0, $l0Xu9.softwareViewNotFoundRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $1g8oF.projectViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("l0Xu9", function(module, exports) {

$parcel$export(module.exports, "softwareViewNotFoundRoute", () => $649408f22dcc013c$export$d72ea457f192511a);
const $649408f22dcc013c$export$d72ea457f192511a = {
    name: 'software-view-not-found',
    exact: true,
    path: '/jira/software/projects/:projectKey/not-found'
};

});


parcelRegister("41tjC", function(module, exports) {

$parcel$export(module.exports, "softwareViewNotFoundClassicRouteEntry", () => $96e70f692796dc17$export$191700cbad42b1f0);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $lkW1m = parcelRequire("lkW1m");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $1g8oF = parcelRequire("1g8oF");
const $96e70f692796dc17$export$191700cbad42b1f0 = (0, $7NszV.createEntry)((0, $lkW1m.softwareViewNotFoundClassicRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $1g8oF.projectViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("lkW1m", function(module, exports) {

$parcel$export(module.exports, "softwareViewNotFoundClassicRoute", () => $6d8d781058e4749c$export$7d9d54603ab2405d);
const $6d8d781058e4749c$export$7d9d54603ab2405d = {
    name: 'software-view-not-found-classic',
    exact: true,
    path: '/jira/software/c/projects/:projectKey/not-found'
};

});


parcelRegister("eAw5v", function(module, exports) {

$parcel$export(module.exports, "softwareBoardViewNotFoundRouteEntry", () => $ed8d1bfb27dbc181$export$70fda0ba037c81ca);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $aqDWp = parcelRequire("aqDWp");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $hhqrL = parcelRequire("hhqrL");
const $ed8d1bfb27dbc181$export$70fda0ba037c81ca = (0, $7NszV.createEntry)((0, $aqDWp.softwareBoardViewNotFoundRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $hhqrL.boardViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("aqDWp", function(module, exports) {

$parcel$export(module.exports, "softwareBoardViewNotFoundRoute", () => $d9228dcc50b0d701$export$4c5eaffb9e70d071);
const $d9228dcc50b0d701$export$4c5eaffb9e70d071 = {
    name: 'software-board-view-not-found',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId/not-found'
};

});


parcelRegister("wwgc5", function(module, exports) {

$parcel$export(module.exports, "softwareBoardViewNotFoundClassicRouteEntry", () => $58fb43be4cabcab8$export$bdd0e204be6866cd);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $4mEI2 = parcelRequire("4mEI2");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $hhqrL = parcelRequire("hhqrL");
const $58fb43be4cabcab8$export$bdd0e204be6866cd = (0, $7NszV.createEntry)((0, $4mEI2.softwareBoardViewNotFoundClassicRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $hhqrL.boardViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("4mEI2", function(module, exports) {

$parcel$export(module.exports, "softwareBoardViewNotFoundClassicRoute", () => $09300f0330e984d8$export$b31cf885abe93fbf);
const $09300f0330e984d8$export$b31cf885abe93fbf = {
    name: 'software-board-view-not-found-classic',
    exact: true,
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/not-found'
};

});


parcelRegister("iz3gR", function(module, exports) {

$parcel$export(module.exports, "legacyRapidBoardRouteEntry", () => $bc93178a086d6ff3$export$4a5b9e48e40676ad);

var $ffza4 = parcelRequire("ffza4");


var $e2ctp = parcelRequire("e2ctp");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $kNWOS = parcelRequire("kNWOS");

var $16Z5s = parcelRequire("16Z5s");

var $hWAe2 = parcelRequire("hWAe2");

var $5f2bR = parcelRequire("5f2bR");
const $bc93178a086d6ff3$export$4a5b9e48e40676ad = (0, $7NszV.createEntry)((0, $kNWOS.legacyRapidBoardRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("kNWOS", function(module, exports) {

$parcel$export(module.exports, "legacyRapidBoardRoute", () => $454db19224248ed1$export$2bc0c59cefa2bd5e);
const $454db19224248ed1$export$2bc0c59cefa2bd5e = {
    name: 'rapidboard-board',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView'
    ],
    __unsafeOrder: -1
};

});


parcelRegister("icwb1", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAccessRedirectRouteEntry", () => $b190785db05a7599$export$36e1851c22975fc0);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $jtZ32 = parcelRequire("jtZ32");

var $7tQej = parcelRequire("7tQej");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

var $8sFwL = parcelRequire("8sFwL");
const $b190785db05a7599$export$36e1851c22975fc0 = (0, $7NszV.createEntry)((0, $jtZ32.projectSettingsCoreAccessRedirectRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
                to: `/jira/core/projects/${String(match.params.projectKey)}/settings/access`,
                push: false
            }),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8sFwL.LazyPeopleSettings)
        ]
    }));

});
parcelRegister("jtZ32", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAccessRedirectRoute", () => $cb26bde1d38666aa$export$59e3323ba0cc224a);
const $cb26bde1d38666aa$export$59e3323ba0cc224a = {
    name: 'project-settings-core-access-redirect',
    path: '/jira/core/projects/:projectKey/settings/people',
    exact: true
};

});

parcelRegister("gTwsg", function(module, exports) {

$parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", () => $0cec9bd54a67f5ed$export$808691f5a412afa3);

var $5bkvv = parcelRequire("5bkvv");

var $loy04 = parcelRequire("loy04");

var $kJQXA = parcelRequire("kJQXA");

var $eOlBz = parcelRequire("eOlBz");

var $dxCvy = parcelRequire("dxCvy");
const $0cec9bd54a67f5ed$export$808691f5a412afa3 = ()=>[
        (0, $eOlBz.newIssueViewTransitionLockInStatusResource),
        (0, $kJQXA.navigationSidebarAutomationLegacyEnabledResource),
        (0, $dxCvy.projectContextResourceWithCache),
        (0, $5bkvv.forgeProjectSettingsModuleResource),
        (0, $loy04.staticProjectSettingsSidebarConnectAddonsNavigationResource)
    ];

});

parcelRegister("8sFwL", function(module, exports) {

$parcel$export(module.exports, "LazyPeopleSettings", () => $8dc1ced653e243b7$export$7eee4f97b7a1273);

var $7yO8g = parcelRequire("7yO8g");

var $b7Svb = parcelRequire("b7Svb");

const $8dc1ced653e243b7$export$7eee4f97b7a1273 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kwY5j"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});

});
parcelRegister("kwY5j", function(module, exports) {

let $ef2567590040fbbd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ef2567590040fbbd$var$load("gP6jR").then(()=>parcelRequire('7N8D9'));

});



parcelRegister("egxSq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAccessRouteEntry", () => $c0cf9eb9a1189c3e$export$8188648c76953df0);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $l2Ko4 = parcelRequire("l2Ko4");

var $jaAyo = parcelRequire("jaAyo");

var $5j7Th = parcelRequire("5j7Th");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

var $8sFwL = parcelRequire("8sFwL");
const $c0cf9eb9a1189c3e$var$Access = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $8sFwL.LazyPeopleSettings),
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });
const $c0cf9eb9a1189c3e$export$8188648c76953df0 = (0, $7NszV.createEntry)((0, $l2Ko4.projectSettingsCoreAccessRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $c0cf9eb9a1189c3e$var$Access,
        skeleton: (0, $jaAyo.ProjectSettingsAccessSkeleton),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8sFwL.LazyPeopleSettings)
        ],
        ufoName: 'project-settings.access'
    }));

});
parcelRegister("l2Ko4", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAccessRoute", () => $213a8c0a4e177f13$export$fe93051d5b7385a1);
const $213a8c0a4e177f13$export$fe93051d5b7385a1 = {
    name: 'project-settings-core-access',
    path: '/jira/core/projects/:projectKey/settings/access',
    exact: true
};

});

parcelRegister("jaAyo", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsAccessSkeleton", () => $e950186edd3e49fd$export$e6cc5ccd52c7fd63);
$parcel$export(module.exports, "ProjectSettingsDetailsSkeleton", () => $e950186edd3e49fd$export$bd7fd4005b84aec9);
$parcel$export(module.exports, "ProjectSettingsFeaturesSkeleton", () => $e950186edd3e49fd$export$ec1cdd0c8335373c);
/* ProjectSettingsFeaturesSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $7TlNQ = parcelRequire("7TlNQ");

var $jTu83 = parcelRequire("jTu83");

var $l6s4f = parcelRequire("l6s4f");
const $e950186edd3e49fd$var$customCssStyles = null;
const $e950186edd3e49fd$var$listOnlyStyles = null;
const $e950186edd3e49fd$export$e6cc5ccd52c7fd63 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7TlNQ))),
        className: (0, $bwpsq.default)([
            "_19pkze3t _2hwx1wug _otyrze3t _18u01wug _p12f1qe4 _11y7oza4"
        ])
    });
const $e950186edd3e49fd$export$bd7fd4005b84aec9 = ({ isListOnly: isListOnly = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jTu83))),
        className: (0, $bwpsq.default)([
            isListOnly ? "_1wgmglyw _rcuj1bdq" : "_19pkze3t _2hwx1wug _otyrze3t _18u01wug _p12f1qe4 _11y7oza4"
        ])
    });
const $e950186edd3e49fd$export$ec1cdd0c8335373c = ({ isListOnly: isListOnly = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($l6s4f))),
        className: (0, $bwpsq.default)([
            isListOnly ? "_1wgmglyw _rcuj1bdq" : "_19pkze3t _2hwx1wug _otyrze3t _18u01wug _p12f1qe4 _11y7oza4"
        ])
    });

});
parcelRegister("7TlNQ", function(module, exports) {
module.exports = new URL("project-settings-access-app-skeleton.tpl.21bb94b1.svg", import.meta.url).toString();

});

parcelRegister("jTu83", function(module, exports) {
module.exports = new URL("project-settings-details-app-skeleton.tpl.c4ebc2fd.svg", import.meta.url).toString();

});

parcelRegister("l6s4f", function(module, exports) {
module.exports = new URL("project-settings-features-app-skeleton.tpl.b8e7f249.svg", import.meta.url).toString();

});



parcelRegister("lhZGg", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreApprovalsRouteEntry", () => $391f453756ba70b6$export$728033a86ab68014);

var $18N1t = parcelRequire("18N1t");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $hIjSj = parcelRequire("hIjSj");

var $ljyNx = parcelRequire("ljyNx");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");
const $391f453756ba70b6$var$approvalsProjectSettingsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $ljyNx.approvalsProjectSettingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $391f453756ba70b6$export$728033a86ab68014 = (0, $7NszV.createEntry)((0, $hIjSj.projectSettingsCoreApprovalsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        entryPoint () {
            return $391f453756ba70b6$var$approvalsProjectSettingsPageEntryPoint;
        },
        ufoName: 'project-settings-approvals-core'
    }));

});
parcelRegister("hIjSj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreApprovalsRoute", () => $2c78c142a4e64bf0$export$ba11c8f378a2c121);
const $2c78c142a4e64bf0$export$ba11c8f378a2c121 = {
    name: 'project-settings-core-approvals',
    path: '/jira/core/projects/:projectKey/settings/approvals',
    exact: true
};

});

parcelRegister("ljyNx", function(module, exports) {

$parcel$export(module.exports, "approvalsProjectSettingsEntryPoint", () => $d1b68aa40690ad89$export$1389a6ddf34f642e);

var $bDrsD = parcelRequire("bDrsD");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $d1b68aa40690ad89$export$1389a6ddf34f642e = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("cg0Gn")), {
        moduleId: "83e2f2c2"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                approvalsSettingsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $bDrsD.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("bDrsD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ed220cf4f93fbf5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d871f3ede49d545d142f76fc4cdb7b72>>
 * @relayHash c1a8c3336b76570b82a8688f17264c3b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 270763b3ff0773a74aedea0d0dc622ebea8eee56eab0c89b0657cf49632cc53f
const $9ed220cf4f93fbf5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "270763b3ff0773a74aedea0d0dc622ebea8eee56eab0c89b0657cf49632cc53f",
        "metadata": {},
        "name": "src_jiraBusinessApprovalsSettingsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $9ed220cf4f93fbf5$export$2e2bcd8739ae039 = $9ed220cf4f93fbf5$var$node;

});

parcelRegister("cg0Gn", function(module, exports) {

let $8ec7822d487cfef7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8ec7822d487cfef7$var$load("1lXo2").then(()=>parcelRequire('8gPdF'));

});



parcelRegister("jr5gb", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAppsFieldsRouteEntry", () => $6edc0d1d8bb5be4d$export$7870a0b1630a504e);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $9qIcj = parcelRequire("9qIcj");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $6edc0d1d8bb5be4d$var$LazyConnectAppControlsSettings = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("b8ySY"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $6edc0d1d8bb5be4d$var$ConnectAppControlsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6edc0d1d8bb5be4d$var$LazyConnectAppControlsSettings,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });
const $6edc0d1d8bb5be4d$export$7870a0b1630a504e = (0, $7NszV.createEntry)((0, $9qIcj.projectSettingsCoreAppsFieldsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $6edc0d1d8bb5be4d$var$ConnectAppControlsPage,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $6edc0d1d8bb5be4d$var$LazyConnectAppControlsSettings
        ]
    }));

});
parcelRegister("9qIcj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAppsFieldsRoute", () => $68a47d7164ebf1d3$export$1c7e75ffaa491922);
const $68a47d7164ebf1d3$export$1c7e75ffaa491922 = {
    name: 'project-settings-core-apps-fields',
    path: '/jira/core/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("b8ySY", function(module, exports) {

let $81bb809bd05c9bf4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $81bb809bd05c9bf4$var$load("7gKdX").then(()=>parcelRequire('kO3mB'));

});


parcelRegister("7lZOe", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAppsRouteEntry", () => $af106c0091889a1f$export$c038a2892f34f1a9);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $hZjdc = parcelRequire("hZjdc");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $af106c0091889a1f$var$LazyConnectAppsSettings = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lXgsn"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
const $af106c0091889a1f$var$ConnectAppsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $af106c0091889a1f$var$LazyConnectAppsSettings,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });
const $af106c0091889a1f$export$c038a2892f34f1a9 = (0, $7NszV.createEntry)((0, $hZjdc.projectSettingsCoreAppsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $af106c0091889a1f$var$ConnectAppsPage,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $af106c0091889a1f$var$LazyConnectAppsSettings
        ]
    }));

});
parcelRegister("hZjdc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAppsRoute", () => $7add52f5911a831e$export$c7ac65fb0bbe767f);
const $7add52f5911a831e$export$c7ac65fb0bbe767f = {
    name: 'project-settings-core-apps',
    path: '/jira/core/projects/:projectKey/settings/apps/:appId?',
    exact: true
};

});

parcelRegister("lXgsn", function(module, exports) {

let $ffbbdf99ccd2af89$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ffbbdf99ccd2af89$var$load("cYKQ3").then(()=>parcelRequire('79qwo'));

});


parcelRegister("9rVvQ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAutomationRouteEntry", () => $1becf8cdf357266c$export$a244870e56f5c9a3);

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $bCPFV = parcelRequire("bCPFV");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

var $eBc8i = parcelRequire("eBc8i");
const $1becf8cdf357266c$export$a244870e56f5c9a3 = (0, $7NszV.createEntry)((0, $bCPFV.projectSettingsCoreAutomationRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: (0, $eBc8i.AutomationLazyPage),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eBc8i.LazyProjectSettingsJiraAutomation)
        ],
        ufoName: 'project-settings-automation-core'
    }));

});
parcelRegister("bCPFV", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAutomationRoute", () => $7024005c59ef8f32$export$65a4d727336c49f4);
const $7024005c59ef8f32$export$65a4d727336c49f4 = {
    name: 'project-settings-core-automation',
    path: '/jira/core/projects/:projectKey/settings/automation'
};

});

parcelRegister("eBc8i", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", () => $d9e4cec5af9ce718$export$dea5ad7e8eac12ae);
$parcel$export(module.exports, "AutomationLazyPage", () => $d9e4cec5af9ce718$export$88eebe21cecb82db);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $d9e4cec5af9ce718$export$dea5ad7e8eac12ae = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("iSy68")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
const $d9e4cec5af9ce718$export$88eebe21cecb82db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d9e4cec5af9ce718$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });

});
parcelRegister("iSy68", function(module, exports) {

let $038bfed7d3d76f10$var$load = (parcelRequire("28QjX"))(4);
module.exports = $038bfed7d3d76f10$var$load("e61bl").then(()=>parcelRequire('ieTY5'));

});



parcelRegister("au6vg", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAutomationV2RouteEntry", () => $d7c59ae6b2241667$export$a2c8a6767edeeaed);

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $dJG0f = parcelRequire("dJG0f");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

var $eBc8i = parcelRequire("eBc8i");
const $d7c59ae6b2241667$export$a2c8a6767edeeaed = (0, $7NszV.createEntry)((0, $dJG0f.projectSettingsCoreAutomationV2Route), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: (0, $eBc8i.AutomationLazyPage),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eBc8i.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("dJG0f", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAutomationV2Route", () => $e31b6bde721f5bf5$export$5437af2650f645e0);
const $e31b6bde721f5bf5$export$5437af2650f645e0 = {
    name: 'project-settings-core-automation',
    path: '/jira/core/projects/:projectKey/settings/automate'
};

});


parcelRegister("cLamq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDataClassificationsRouteEntry", () => $60f4334670e39dba$export$cf5194c476e8bcdb);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $brYsn = parcelRequire("brYsn");

var $jaAyo = parcelRequire("jaAyo");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $60f4334670e39dba$var$LazyDataClassificationsSettings = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1LZO6"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
const $60f4334670e39dba$var$DataClassifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $60f4334670e39dba$var$LazyDataClassificationsSettings,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });
const $60f4334670e39dba$export$cf5194c476e8bcdb = (0, $7NszV.createEntry)((0, $brYsn.projectSettingsCoreDataClassificationsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $60f4334670e39dba$var$DataClassifications,
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("brYsn", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDataClassificationsRoute", () => $46bd61981cdecbb8$export$7aae1006c82a79c0);
const $46bd61981cdecbb8$export$7aae1006c82a79c0 = {
    name: 'project-settings-core-data-classifications',
    path: '/jira/core/projects/:projectKey/settings/data-classifications',
    exact: true
};

});


parcelRegister("2vHPs", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDefaultRedirectRouteEntry", () => $72042ad67933f70e$export$df1c02c3f28b7a95);

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $1IH8G = parcelRequire("1IH8G");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

var $7dO7c = parcelRequire("7dO7c");
const $72042ad67933f70e$export$df1c02c3f28b7a95 = (0, $7NszV.createEntry)((0, $1IH8G.projectSettingsCoreDefaultRedirectRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: (0, $7dO7c.ProjectSettingsRedirect),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("1IH8G", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDefaultRedirectRoute", () => $5a27ba0a68240f95$export$322fe16ec991f12);
const $5a27ba0a68240f95$export$322fe16ec991f12 = {
    name: 'project-settings-core-redirect',
    path: '/jira/core/projects/:projectKey/settings'
};

});

parcelRegister("7dO7c", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsRedirect", () => $646d86edb6dba940$export$72130cf40a3c3778);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $7tQej = parcelRequire("7tQej");
const $646d86edb6dba940$export$72130cf40a3c3778 = ({ match: match })=>{
    const { data: data } = (0, $1J3t1.useJiraWorkmanagementProjectNavigation)();
    const { projectKey: projectKey } = match.params;
    if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/core/projects/${String(projectKey)}/settings/details`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/core/projects/${String(match.params.projectKey)}/settings/details`
    });
};

});


parcelRegister("hztdR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDetailsRouteEntry", () => $f65156aa09643d37$export$438a330ccc1e7a91);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $3yAjF = parcelRequire("3yAjF");

var $jaAyo = parcelRequire("jaAyo");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $f65156aa09643d37$var$LazyDetailsSettings = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("DVmIc"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
const $f65156aa09643d37$var$Details = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f65156aa09643d37$var$LazyDetailsSettings,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });
const $f65156aa09643d37$export$438a330ccc1e7a91 = (0, $7NszV.createEntry)((0, $3yAjF.projectSettingsCoreDetailsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $f65156aa09643d37$var$Details,
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $f65156aa09643d37$var$LazyDetailsSettings
        ]
    }));

});
parcelRegister("3yAjF", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDetailsRoute", () => $5d63f1af39ccfc34$export$14535b40530c8690);
const $5d63f1af39ccfc34$export$14535b40530c8690 = {
    name: 'project-settings-core-details',
    path: '/jira/core/projects/:projectKey/settings/details',
    exact: true
};

});

parcelRegister("DVmIc", function(module, exports) {

let $07802430dc16310d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $07802430dc16310d$var$load("cM9em"),
    $07802430dc16310d$var$load("fr9NE"),
    $07802430dc16310d$var$load("h2MrD"),
    $07802430dc16310d$var$load("bYT2S"),
    $07802430dc16310d$var$load("dsiAd"),
    $07802430dc16310d$var$load("7Jjzg")
]).then(()=>parcelRequire('9vEjY'));

});


parcelRegister("6cSNh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreFieldsRouteEntry", () => $3dfc1ebecbfe533b$export$8d8dff75124dcebc);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $e7C7O = parcelRequire("e7C7O");

var $5lsNZ = parcelRequire("5lsNZ");

var $9BCCu = parcelRequire("9BCCu");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $cSUZZ = parcelRequire("cSUZZ");

var $6s1PB = parcelRequire("6s1PB");

var $gTwsg = parcelRequire("gTwsg");
const $3dfc1ebecbfe533b$var$isEfaExperimentExposed = ()=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    return expConfig.get('isEnabled', false);
};

const $3dfc1ebecbfe533b$var$LazyFieldsSettings = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lAb40"))), {
    moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
});
const $3dfc1ebecbfe533b$var$FieldsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3dfc1ebecbfe533b$var$LazyFieldsSettings,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });
const $3dfc1ebecbfe533b$export$8d8dff75124dcebc = (0, $7NszV.createEntry)((0, $9BCCu.projectSettingsCoreFieldsRoute), ()=>({
        group: 'project-settings-core',
        ufoName: 'project-settings.fields.jwm-tmp',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            (0, $e7C7O.fieldSettingsRelayResource)
        ],
        component: (0, $7XYc4.componentWithCondition)($3dfc1ebecbfe533b$var$isEfaExperimentExposed, $3dfc1ebecbfe533b$var$FieldsPage, (0, $5lsNZ.default)),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $3dfc1ebecbfe533b$var$LazyFieldsSettings
        ]
    }));

});
parcelRegister("e7C7O", function(module, exports) {

$parcel$export(module.exports, "fieldSettingsRelayResource", () => $424e18beff0a1aec$export$68b4e700e00bad7a);

var $ao2h1 = parcelRequire("ao2h1");

var $gF6UW = parcelRequire("gF6UW");

var $1nb22 = parcelRequire("1nb22");
const $424e18beff0a1aec$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS = 'PROJECT_SETTINGS_FIELDS';
const $424e18beff0a1aec$export$68b4e700e00bad7a = (0, $ao2h1.createRelayResource)({
    type: $424e18beff0a1aec$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS,
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        return {
            parameters: (0, $gF6UW.default),
            variables: {
                projectKey: projectKey ?? '',
                cloudId: tenantContext.cloudId ?? ''
            },
            options: {
                fetchPolicy: 'network-only'
            }
        };
    }
});

});
parcelRegister("gF6UW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e41b4fca86430f4d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1b0f696a99acdc032c896617bbc53dd4>>
 * @relayHash 1fe65c7f850b0fd2bffbacc6bcd46807
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ea40ca8b1863c0995446437f03f59347faee0237ea0100149114208fb0ac90bc

var $2OU2m = parcelRequire("2OU2m");

var $eiowN = parcelRequire("eiowN");
const $e41b4fca86430f4d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = [
        v2 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "isExplicitFieldAssociationsEnabled"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "key"
    }, v10 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 30
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiFieldsPageQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "projectKey"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "fieldsTable_projectFields"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "pageHeader_projectFields_Header"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisprojectfieldsgafastfollowsgateenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "uiFieldsPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v9 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "optionsPerFieldLimit"
                                },
                                {
                                    "concreteType": "JiraFieldTypeGroupConnection",
                                    "kind": "LinkedField",
                                    "name": "projectFieldTypeGroups",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFieldTypeGroupEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFieldTypeGroup",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "displayName"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraProjectWithIssueTypeIds",
                                    "kind": "LinkedField",
                                    "name": "projectWithVisibleIssueTypeIds",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldAssociationWithIssueTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFieldAssociationWithIssueTypesEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFieldAssociationWithIssueTypes",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraField",
                                                                    "kind": "LinkedField",
                                                                    "name": "field",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldId"
                                                                        },
                                                                        v8 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "scope"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "typeName"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "description"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "typeKey"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "hasMissingConfiguration"
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueTypeConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueTypeEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v5 /*: any*/ ,
                                                                                        v6 /*: any*/ ,
                                                                                        v8 /*: any*/ ,
                                                                                        v7 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldOperation",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOperation",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canRemove"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canDelete"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canAssociateInSettings"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canEdit"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canModifyOptions"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraFieldOptionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraFieldOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "optionId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "parentOptionId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "value"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isFieldLocked"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldAssociationWithIssueTypes(first:30)"
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "filters": [
                                                "input"
                                            ],
                                            "handle": "connection",
                                            "key": "fieldsTable_fieldAssociationWithIssueTypes",
                                            "kind": "LinkedHandle",
                                            "name": "fieldAssociationWithIssueTypes"
                                        }
                                    ]
                                },
                                v8 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisprojectfieldsgafastfollowsgateenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectScopedFieldsPerProjectLimit"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectScopedFieldsCount"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ea40ca8b1863c0995446437f03f59347faee0237ea0100149114208fb0ac90bc",
            "metadata": {},
            "name": "uiFieldsPageQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisprojectfieldsgafastfollowsgateenabledrelayprovider": (0, $2OU2m.default)
            }
        }
    };
}();
$e41b4fca86430f4d$var$node.hash = "b0872e3059548632993c06522c7f5584";
(0, $eiowN.PreloadableQueryRegistry).set($e41b4fca86430f4d$var$node.params.id, $e41b4fca86430f4d$var$node);
var $e41b4fca86430f4d$export$2e2bcd8739ae039 = $e41b4fca86430f4d$var$node;

});
parcelRegister("2OU2m", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7b19278c2ec7204$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $e7b19278c2ec7204$var$isProjectFieldsGaFastFollowsEnabled = {
    get () {
        return (0, $4R6GH.fg)('project_fields_page_for_tmp_-_ga_fast_follows');
    }
};
var $e7b19278c2ec7204$export$2e2bcd8739ae039 = $e7b19278c2ec7204$var$isProjectFieldsGaFastFollowsEnabled;

});



parcelRegister("9BCCu", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreFieldsRoute", () => $03614f84baa4becb$export$7c4ee74641923239);
const $03614f84baa4becb$export$7c4ee74641923239 = {
    name: 'project-settings-core-fields',
    path: '/jira/core/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("lAb40", function(module, exports) {

let $fb658ac3baf372fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fb658ac3baf372fd$var$load("eNxsN").then(()=>parcelRequire('aRrWI'));

});


parcelRegister("lIPtt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreForgeAppsRouteEntry", () => $81842dc02c80a297$export$1006fd9f5f02b1c2);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $kXEQj = parcelRequire("kXEQj");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $81842dc02c80a297$var$LazyForgeProjectSettingsPage = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("dyX7u")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $81842dc02c80a297$var$ForgeProjectSettingsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $81842dc02c80a297$var$LazyForgeProjectSettingsPage,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
const $81842dc02c80a297$export$1006fd9f5f02b1c2 = (0, $7NszV.createEntry)((0, $kXEQj.projectSettingsCoreForgeAppsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $81842dc02c80a297$var$ForgeProjectSettingsPage,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $81842dc02c80a297$var$LazyForgeProjectSettingsPage
        ]
    }));

});
parcelRegister("kXEQj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreForgeAppsRoute", () => $ffe7ed90d4a26759$export$b34160f55b6104e9);
const $ffe7ed90d4a26759$export$b34160f55b6104e9 = {
    name: 'project-settings-core-forge-apps',
    path: '/jira/core/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("dyX7u", function(module, exports) {

let $9dfc4f49790cd87e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9dfc4f49790cd87e$var$load("414RV").then(()=>parcelRequire('ln9R3'));

});


parcelRegister("cWKD0", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreIssueTypesRouteEntry", () => $dfd719394f285715$export$95ecbacf0120fcfd);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $cXAV1 = parcelRequire("cXAV1");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $dfd719394f285715$var$LazyIssueTypeSettings = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("72vEr"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
const $dfd719394f285715$var$IssueTypePage = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $dfd719394f285715$var$LazyIssueTypeSettings,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
const $dfd719394f285715$export$95ecbacf0120fcfd = (0, $7NszV.createEntry)((0, $cXAV1.projectSettingsCoreIssueTypesRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $dfd719394f285715$var$IssueTypePage,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $dfd719394f285715$var$LazyIssueTypeSettings
        ]
    }));

});
parcelRegister("cXAV1", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreIssueTypesRoute", () => $9890a5b2bae88b9c$export$c3a32433c580b9ff);
const $9890a5b2bae88b9c$export$c3a32433c580b9ff = {
    name: 'project-settings-core-issuetypes',
    path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});


parcelRegister("d0eOH", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreIssueTypesWorkflowRouteEntry", () => $73a52ccb6b02557a$export$1dfd4811b9065dd6);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $Tp0iK = parcelRequire("Tp0iK");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $73a52ccb6b02557a$var$LazyWorkflowNavigationSettings = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lMJYe"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
const $73a52ccb6b02557a$var$WorkflowNavigationPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $73a52ccb6b02557a$var$LazyWorkflowNavigationSettings,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });
const $73a52ccb6b02557a$export$1dfd4811b9065dd6 = (0, $7NszV.createEntry)((0, $Tp0iK.projectSettingsCoreIssueTypesWorkflowRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $73a52ccb6b02557a$var$WorkflowNavigationPage,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $73a52ccb6b02557a$var$LazyWorkflowNavigationSettings
        ]
    }));

});
parcelRegister("Tp0iK", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreIssueTypesWorkflowRoute", () => $5c1b1d7296dcb1b9$export$9e79ee307216071b);
const $5c1b1d7296dcb1b9$export$9e79ee307216071b = {
    name: 'project-settings-core-issuetypes-workflow',
    path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
    exact: true
};

});

parcelRegister("lMJYe", function(module, exports) {

let $fdc1bd6fae6f08d1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fdc1bd6fae6f08d1$var$load("hPzOn"),
    $fdc1bd6fae6f08d1$var$load("h2MrD"),
    $fdc1bd6fae6f08d1$var$load("bYT2S"),
    $fdc1bd6fae6f08d1$var$load("cM9em"),
    $fdc1bd6fae6f08d1$var$load("fr9NE"),
    $fdc1bd6fae6f08d1$var$load("4a74D")
]).then(()=>parcelRequire('fEx2J'));

});


parcelRegister("bxg3m", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsEmailRouteEntry", () => $c698ffcb86d9bd83$export$da36a1671d868927);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $6IsiM = parcelRequire("6IsiM");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $c698ffcb86d9bd83$var$LazyProjectSettingsNotificationEmail = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iEUeQ"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
const $c698ffcb86d9bd83$var$EmailNotifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c698ffcb86d9bd83$var$LazyProjectSettingsNotificationEmail,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });
const $c698ffcb86d9bd83$export$da36a1671d868927 = (0, $7NszV.createEntry)((0, $6IsiM.projectSettingsCoreNotificationsEmailRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $c698ffcb86d9bd83$var$EmailNotifications,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $c698ffcb86d9bd83$var$LazyProjectSettingsNotificationEmail
        ]
    }));

});
parcelRegister("6IsiM", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsEmailRoute", () => $91d0b5fe7c793948$export$b546589f1b048dc);
const $91d0b5fe7c793948$export$b546589f1b048dc = {
    name: 'project-settings-core-notifications-notification-email',
    path: '/jira/core/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("iEUeQ", function(module, exports) {

let $d9579637b5524a61$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d9579637b5524a61$var$load("kn4Lg").then(()=>parcelRequire('d6iMp'));

});


parcelRegister("e6Vbw", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsIssueLogsRouteEntry", () => $4c1c7acc90dd4d09$export$e562140c482cb0c);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $cpVGO = parcelRequire("cpVGO");

var $femMW = parcelRequire("femMW");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");
const $4c1c7acc90dd4d09$var$emailNotificationsLogEntryPointPage = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $femMW.notificationsIssueLogsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

const $4c1c7acc90dd4d09$var$LazyNotificationsIssueLogs = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("luvxq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications-issue-logs/src/index.tsx"
});
const $4c1c7acc90dd4d09$var$NotificationsIssueLogs = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4c1c7acc90dd4d09$var$LazyNotificationsIssueLogs,
        pageId: "project-settings-software-notifications-issue-logs",
        shouldShowSpinner: false
    });
const $4c1c7acc90dd4d09$export$e562140c482cb0c = (0, $7NszV.createEntry)((0, $cpVGO.projectSettingsCoreNotificationsIssueLogsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $4c1c7acc90dd4d09$var$NotificationsIssueLogs,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $4c1c7acc90dd4d09$var$LazyNotificationsIssueLogs
        ],
        entryPoint () {
            return $4c1c7acc90dd4d09$var$emailNotificationsLogEntryPointPage;
        }
    }));

});
parcelRegister("cpVGO", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsIssueLogsRoute", () => $1ebe41c3d3a19553$export$56a8a0b88329b044);
const $1ebe41c3d3a19553$export$56a8a0b88329b044 = {
    name: 'project-settings-core-notifications-issue-logs',
    path: '/jira/core/projects/:projectKey/settings/notifications/issue-logs',
    exact: true
};

});

parcelRegister("femMW", function(module, exports) {

$parcel$export(module.exports, "notificationsIssueLogsEntryPoint", () => $6adcc3494d7c3774$export$97bbdefcbe0571ac);

var $9Cf70 = parcelRequire("9Cf70");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $6adcc3494d7c3774$export$97bbdefcbe0571ac = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("luvxq")), {
        moduleId: "b2136a4d"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                notificationLogs: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $9Cf70.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectId: Number(context?.query?.projectId ?? 0),
                        notificationType: 'INTERNAL_NOTIFICATION_ISSUE'
                    }
                }
            },
            extraProps: {
                accountId: tenantContext.atlassianAccountId,
                cloudId: tenantContext.cloudId,
                projectIds: context?.query?.projectId,
                projectKey: context?.match.params.projectKey
            }
        })
});

});
parcelRegister("9Cf70", function(module, exports) {

$parcel$export(module.exports, "default", () => $baebbc2289a2b843$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a829922c4d7e91622e88a1e75ca9c0ed>>
 * @relayHash ed735b233bfe7d6a34f4765ef97f56e9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 28e1d1e9657c726eca51c9d02a4b718874ec12653eea9e5bfcfef82047676924
const $baebbc2289a2b843$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "28e1d1e9657c726eca51c9d02a4b718874ec12653eea9e5bfcfef82047676924",
        "metadata": {},
        "name": "uiIssueNotificationLogsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $baebbc2289a2b843$export$2e2bcd8739ae039 = $baebbc2289a2b843$var$node;

});

parcelRegister("luvxq", function(module, exports) {

let $fa54dd2260ba4e4a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fa54dd2260ba4e4a$var$load("k7BTo").then(()=>parcelRequire('6ZR0a'));

});



parcelRegister("7LwJB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsRouteEntry", () => $221f77694f7c3501$export$ed481b03aa858542);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $oHytR = parcelRequire("oHytR");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $221f77694f7c3501$var$LazyNotificationsSettings = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1Ih7X"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
});
const $221f77694f7c3501$var$Notifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $221f77694f7c3501$var$LazyNotificationsSettings,
        pageId: "project-settings-software-notifications",
        shouldShowSpinner: false
    });
const $221f77694f7c3501$export$ed481b03aa858542 = (0, $7NszV.createEntry)((0, $oHytR.projectSettingsCoreNotificationsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $221f77694f7c3501$var$Notifications,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $221f77694f7c3501$var$LazyNotificationsSettings
        ]
    }));

});
parcelRegister("oHytR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsRoute", () => $3cc89fad893f0f33$export$a1ee80066685b98d);
const $3cc89fad893f0f33$export$a1ee80066685b98d = {
    name: 'project-settings-core-notifications',
    path: '/jira/core/projects/:projectKey/settings/notifications',
    exact: true
};

});

parcelRegister("1Ih7X", function(module, exports) {

let $13f72fa490c7f79d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $13f72fa490c7f79d$var$load("1gaf4").then(()=>parcelRequire('giI7i'));

});


parcelRegister("66HfJ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreProformaJiraFormBuilderRouteEntry", () => $58b256108db01248$export$46d6b55ebf21ccc);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $1y7ot = parcelRequire("1y7ot");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $58b256108db01248$var$LazyProjectSettingsProformaJiraFormBuilder = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("foxIF")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
const $58b256108db01248$var$ProformaJiraFormBuilder = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $58b256108db01248$var$LazyProjectSettingsProformaJiraFormBuilder,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });
const $58b256108db01248$export$46d6b55ebf21ccc = (0, $7NszV.createEntry)((0, $1y7ot.projectSettingsCoreProformaJiraFormBuilderRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $58b256108db01248$var$ProformaJiraFormBuilder,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $58b256108db01248$var$LazyProjectSettingsProformaJiraFormBuilder
        ],
        perfMetricKey: 'form-builder'
    }));

});
parcelRegister("1y7ot", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreProformaJiraFormBuilderRoute", () => $bffeb81c48a88921$export$4e7ce7e6ced0f291);
const $bffeb81c48a88921$export$4e7ce7e6ced0f291 = {
    name: 'project-settings-core-proforma-jira-form-builder',
    path: '/jira/core/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});

parcelRegister("foxIF", function(module, exports) {

let $b35340dd305c466e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b35340dd305c466e$var$load("h2MrD"),
    $b35340dd305c466e$var$load("bYT2S"),
    $b35340dd305c466e$var$load("dsiAd"),
    $b35340dd305c466e$var$load("iwPab")
]).then(()=>parcelRequire('1XLXC'));

});


parcelRegister("aDZxG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreProformaProjectFormsRouteEntry", () => $76ec485f5ce6229b$export$5e9e27f116094fdf);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $dcOuP = parcelRequire("dcOuP");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $76ec485f5ce6229b$var$LazyProjectSettingsProformaProjectForms = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("6bknD")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
const $76ec485f5ce6229b$var$ProformaProjectForms = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $76ec485f5ce6229b$var$LazyProjectSettingsProformaProjectForms,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });
const $76ec485f5ce6229b$export$5e9e27f116094fdf = (0, $7NszV.createEntry)((0, $dcOuP.projectSettingsCoreProformaProjectFormsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $76ec485f5ce6229b$var$ProformaProjectForms,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $76ec485f5ce6229b$var$LazyProjectSettingsProformaProjectForms
        ],
        perfMetricKey: 'forms-settings'
    }));

});
parcelRegister("dcOuP", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreProformaProjectFormsRoute", () => $ca16757f7d5a6f92$export$57fe8c5107a9c0de);
const $ca16757f7d5a6f92$export$57fe8c5107a9c0de = {
    name: 'project-settings-core-proforma-project-forms',
    path: '/jira/core/projects/:projectKey/settings/forms',
    exact: true
};

});

parcelRegister("6bknD", function(module, exports) {

let $480394438dbd52a0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $480394438dbd52a0$var$load("dWKlO").then(()=>parcelRequire('ciDU2'));

});


parcelRegister("anDMO", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsDetailsRouteEntry", () => $0d63a1f004a7576a$export$9391a147c94081db);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cubqk = parcelRequire("cubqk");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $cYgMq = parcelRequire("cYgMq");
const $0d63a1f004a7576a$export$9391a147c94081db = (0, $7NszV.createEntry)((0, $cubqk.classicProjectSettingsDetailsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $cYgMq.default),
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cYgMq.LazyDetailsSettings)
        ]
    }));

});
parcelRegister("cubqk", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsDetailsRoute", () => $1e07e61b794dca8d$export$37e0dbac44df25b9);
const $1e07e61b794dca8d$export$37e0dbac44df25b9 = {
    name: 'classic-software-details',
    path: '/jira/software/c/projects/:projectKey/settings/details',
    exact: true
};

});

parcelRegister("cYgMq", function(module, exports) {

$parcel$export(module.exports, "LazyDetailsSettings", () => $5dcf6caa5da05571$export$6f16b5efddd5c646);
$parcel$export(module.exports, "default", () => $5dcf6caa5da05571$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $5dcf6caa5da05571$export$6f16b5efddd5c646 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("DVmIc"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5dcf6caa5da05571$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $5dcf6caa5da05571$export$6f16b5efddd5c646,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });

});


parcelRegister("dYbYB", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsFeaturesRouteEntry", () => $f08d62940ca05012$export$b623393adc25556a);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $bzimk = parcelRequire("bzimk");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $4glor = parcelRequire("4glor");
const $f08d62940ca05012$export$b623393adc25556a = (0, $7NszV.createEntry)((0, $bzimk.classicProjectSettingsFeaturesRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'classic-features-page',
        component: (0, $4glor.ClassicFeaturesPage),
        skeleton: (0, $jaAyo.ProjectSettingsFeaturesSkeleton),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4glor.LazySoftwareClassicFeatures)
        ]
    }));

});
parcelRegister("bzimk", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsFeaturesRoute", () => $a3d30ca18dd07505$export$d4bf23ba6f4199d7);
const $a3d30ca18dd07505$export$d4bf23ba6f4199d7 = {
    name: 'classic-software-features',
    path: '/jira/software/c/projects/:projectKey/settings/features',
    exact: true
};

});

parcelRegister("4glor", function(module, exports) {

$parcel$export(module.exports, "LazySoftwareClassicFeatures", () => $70eea33e6c09b198$export$79fe16f960f3d89f);
$parcel$export(module.exports, "ClassicFeaturesPage", () => $70eea33e6c09b198$export$8e6f565615e921dd);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $70eea33e6c09b198$export$79fe16f960f3d89f = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("haqiI"))), {
    moduleId: "./src/packages/spa-apps/project-settings/classic-features/src/index.tsx"
});
const $70eea33e6c09b198$export$8e6f565615e921dd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $70eea33e6c09b198$export$79fe16f960f3d89f,
        pageId: "classic-features",
        shouldShowSpinner: true
    });

});
parcelRegister("haqiI", function(module, exports) {

let $c7f7c5a3d0c41183$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c7f7c5a3d0c41183$var$load("57yIp").then(()=>parcelRequire('hX1AL'));

});



parcelRegister("ffFBX", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsOpsgenieRouteEntry", () => $2bd54c69eb3061ae$export$17e7416abefe91dc);

var $ffza4 = parcelRequire("ffza4");

var $bwLf9 = parcelRequire("bwLf9");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $dcC1k = parcelRequire("dcC1k");

var $kfztd = parcelRequire("kfztd");

var $e7bC3 = parcelRequire("e7bC3");

var $1KQBW = parcelRequire("1KQBW");
const $2bd54c69eb3061ae$export$17e7416abefe91dc = (0, $7NszV.createEntry)((0, $dcC1k.classicProjectSettingsOpsgenieRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $bwLf9.default)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $1KQBW.default)),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1KQBW.LazyLinkOpsgeniePage)
        ],
        ufoName: 'project-settings.link-opsgenie'
    }));

});
parcelRegister("dcC1k", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsOpsgenieRoute", () => $f327483ffca6ed25$export$4e4a4b8762b611);
const $f327483ffca6ed25$export$4e4a4b8762b611 = {
    name: 'classic-software-link-opsgenie',
    path: '/jira/software/c/projects/:projectKey/settings/opsgenie',
    exact: true
};

});

parcelRegister("1KQBW", function(module, exports) {

$parcel$export(module.exports, "LazyLinkOpsgeniePage", () => $dab3ab2feb1de470$export$ca5dba69148b337);
$parcel$export(module.exports, "default", () => $dab3ab2feb1de470$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $dab3ab2feb1de470$export$ca5dba69148b337 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("6Rp76")), {
    moduleId: "./src/packages/spa-apps/project-settings/link-opsgenie/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dab3ab2feb1de470$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $dab3ab2feb1de470$export$ca5dba69148b337,
        pageId: "link-opsgenie-page",
        shouldShowSpinner: false
    });

});
parcelRegister("6Rp76", function(module, exports) {

let $4feb2c5cf42749bc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4feb2c5cf42749bc$var$load("2h1uc").then(()=>parcelRequire('7AMRE'));

});



parcelRegister("1IKX7", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareNotificationsIssueLogsRouteEntry", () => $ced985b0a8859572$export$cdc4e64211a34457);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5dFt2 = parcelRequire("5dFt2");

var $e7bC3 = parcelRequire("e7bC3");

var $14B4q = parcelRequire("14B4q");
const $ced985b0a8859572$export$cdc4e64211a34457 = (0, $7NszV.createEntry)((0, $5dFt2.classicProjectSettingsSoftwareNotificationsIssueLogsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.classic-issue-logs-page',
        component: (0, $14B4q.SoftwareNotificationsIssueLogs),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $14B4q.LazySoftwareNotificationsIssueLogs)
        ],
        entryPoint () {
            return 0, $14B4q.emailNotificationsLogEntryPointPage;
        }
    }));

});
parcelRegister("5dFt2", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareNotificationsIssueLogsRoute", () => $631b97d030b0c8f3$export$5e2e0a895d6a14bd);
const $631b97d030b0c8f3$export$5e2e0a895d6a14bd = {
    name: 'classic-software-notifications-issue-logs',
    path: '/jira/software/c/projects/:projectKey/settings/notifications/issue-logs',
    query: [
        'projectId'
    ]
};

});

parcelRegister("14B4q", function(module, exports) {

$parcel$export(module.exports, "emailNotificationsLogEntryPointPage", () => $e5cbde6b3cad4f8b$export$cd8964bea0e3c2);
$parcel$export(module.exports, "LazySoftwareNotificationsIssueLogs", () => $e5cbde6b3cad4f8b$export$6960a46ebd209756);
$parcel$export(module.exports, "SoftwareNotificationsIssueLogs", () => $e5cbde6b3cad4f8b$export$4b75df09cc5b4e8e);

var $5uXOq = parcelRequire("5uXOq");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $femMW = parcelRequire("femMW");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");
const $e5cbde6b3cad4f8b$export$cd8964bea0e3c2 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $femMW.notificationsIssueLogsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

const $e5cbde6b3cad4f8b$export$6960a46ebd209756 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("luvxq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications-issue-logs/src/index.tsx"
});
const $e5cbde6b3cad4f8b$export$4b75df09cc5b4e8e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e5cbde6b3cad4f8b$export$6960a46ebd209756,
        pageId: "project-settings-software-notifications-issue-logs",
        shouldShowSpinner: false
    });

});


parcelRegister("1K27j", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaEditFormsRouteEntry", () => $7a878339e2d71181$export$e730b13555ff0c60);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $gSRO9 = parcelRequire("gSRO9");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $8JnjW = parcelRequire("8JnjW");
const $7a878339e2d71181$export$e730b13555ff0c60 = (0, $7NszV.createEntry)((0, $gSRO9.classicProjectSettingsSoftwareProformaEditFormsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $8JnjW.default),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8JnjW.LazyProjectSettingsProformaJiraFormBuilder)
        ]
    }));

});
parcelRegister("gSRO9", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaEditFormsRoute", () => $db0151a276af1837$export$811ace4fee984f0e);
const $db0151a276af1837$export$811ace4fee984f0e = {
    name: 'project-settings-software-proforma-edit-forms',
    path: '/jira/software/c/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});

parcelRegister("1XdKx", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_PRODUCT", () => $3caec8e095a44ec5$export$2954328f6207617a);
$parcel$export(module.exports, "getSettingsNavigationResources", () => $3caec8e095a44ec5$export$586756e5c0542a50);
$parcel$export(module.exports, "RedirectForSettings", () => $3caec8e095a44ec5$export$fb15a6ba8980fdac);
$parcel$export(module.exports, "RedirectForSettingsForClassicProject", () => $3caec8e095a44ec5$export$f9befa0a4925b36d);

var $5uXOq = parcelRequire("5uXOq");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $1J3t1 = parcelRequire("1J3t1");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $7tQej = parcelRequire("7tQej");
const $3caec8e095a44ec5$export$2954328f6207617a = 'software';
const $3caec8e095a44ec5$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $3caec8e095a44ec5$export$586756e5c0542a50 = ()=>{
    return [
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)()
    ];
};
const $3caec8e095a44ec5$export$fb15a6ba8980fdac = ({ match: match })=>{
    const { data: data } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const { projectKey: projectKey } = match.params;
    if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
    });
};
const $3caec8e095a44ec5$export$f9befa0a4925b36d = ({ match: match })=>{
    const { data: data } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const { projectKey: projectKey } = match.params;
    if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
    });
};

});

parcelRegister("8JnjW", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsProformaJiraFormBuilder", () => $c3a9ed7dcac6be32$export$a7d63246a10aedd);
$parcel$export(module.exports, "default", () => $c3a9ed7dcac6be32$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $c3a9ed7dcac6be32$export$a7d63246a10aedd = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("foxIF")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c3a9ed7dcac6be32$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c3a9ed7dcac6be32$export$a7d63246a10aedd,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });

});


parcelRegister("8DQ40", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaFormsRouteEntry", () => $c13f5ba4ed49c128$export$5e67ac6f50ae37e1);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $epiJW = parcelRequire("epiJW");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $gyEpf = parcelRequire("gyEpf");
const $c13f5ba4ed49c128$export$5e67ac6f50ae37e1 = (0, $7NszV.createEntry)((0, $epiJW.classicProjectSettingsSoftwareProformaFormsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $gyEpf.default),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gyEpf.LazyProjectSettingsProformaProjectForms)
        ]
    }));

});
parcelRegister("epiJW", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaFormsRoute", () => $7b818f933be215b1$export$2313ca001d58ab27);
const $7b818f933be215b1$export$2313ca001d58ab27 = {
    name: 'project-settings-software-proforma-project-forms',
    path: '/jira/software/c/projects/:projectKey/settings/forms',
    exact: true
};

});

parcelRegister("gyEpf", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsProformaProjectForms", () => $97406b66ba2de080$export$38414b624a749cec);
$parcel$export(module.exports, "default", () => $97406b66ba2de080$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $97406b66ba2de080$export$38414b624a749cec = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("6bknD")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$97406b66ba2de080$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $97406b66ba2de080$export$38414b624a749cec,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });

});


parcelRegister("hdWS0", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareRedirectRouteEntry", () => $5fe7bdc999ce9cdf$export$3c7d008bbb14e2b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $7OjcI = parcelRequire("7OjcI");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");
const $5fe7bdc999ce9cdf$export$3c7d008bbb14e2b = (0, $7NszV.createEntry)((0, $7OjcI.classicProjectSettingsSoftwareRedirectRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $1XdKx.RedirectForSettingsForClassicProject),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("7OjcI", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareRedirectRoute", () => $eb74524e076aae09$export$99b695c2b8299b5a);
const $eb74524e076aae09$export$99b695c2b8299b5a = {
    // the following route should be non-exact, it will handle "index" and "404" cases
    name: 'classic-software-redirect',
    path: '/jira/software/c/projects/:projectKey/settings'
};

});


parcelRegister("9MTKv", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsToolchainRouteEntry", () => $42ebeced13391ae5$export$1fe479c54f4d7684);

var $ffza4 = parcelRequire("ffza4");

var $bwLf9 = parcelRequire("bwLf9");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $35Wvp = parcelRequire("35Wvp");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $gTGp2 = parcelRequire("gTGp2");

var $kfztd = parcelRequire("kfztd");

var $e7bC3 = parcelRequire("e7bC3");

var $aA5DA = parcelRequire("aA5DA");
const $42ebeced13391ae5$export$1fe479c54f4d7684 = (0, $7NszV.createEntry)((0, $gTGp2.classicProjectSettingsToolchainRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $bwLf9.default)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $aA5DA.default)),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource),
            (0, $35Wvp.projectSettingsToolchainResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aA5DA.LazyDevOpsConnectionsSettings)
        ],
        ufoName: 'project-settings.devops-connections'
    }));

});
parcelRegister("35Wvp", function(module, exports) {

$parcel$export(module.exports, "projectSettingsToolchainResource", () => $ed037648996bd812$export$182dfe2bc7c28567);

var $ao2h1 = parcelRequire("ao2h1");

var $avVgl = parcelRequire("avVgl");
const $ed037648996bd812$export$b8927fea69d9f414 = 'PROJECT_SETTINGS_TOOLCHAIN';
const $ed037648996bd812$export$182dfe2bc7c28567 = (0, $ao2h1.createRelayResource)({
    type: $ed037648996bd812$export$b8927fea69d9f414,
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $avVgl.default),
            variables: {
                cloudId: tenantContext?.cloudId || ''
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("avVgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5afd24d8f370d3e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a2c9dc099d3b7d79cd74bd591996a945>>
 * @relayHash f5bf042c501578b47d326c7288427026
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2fc1f152f5ebcdcb577d22b928c317e308c8daf161c302627c4f00951b909409
const $5afd24d8f370d3e2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "concreteType": "DvcsQuery",
            "kind": "LinkedField",
            "name": "dvcs",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                        }
                    ],
                    "concreteType": "DvcsBitbucketWorkspaceConnection",
                    "kind": "LinkedField",
                    "name": "bitbucketWorkspacesLinkedToSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DvcsBitbucketWorkspaceEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_projectSettingsToolchainQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_projectSettingsToolchainQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "2fc1f152f5ebcdcb577d22b928c317e308c8daf161c302627c4f00951b909409",
            "metadata": {},
            "name": "ui_projectSettingsToolchainQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5afd24d8f370d3e2$var$node.hash = "190735208b3c7baafbfc3c1808fa801b";
var $5afd24d8f370d3e2$export$2e2bcd8739ae039 = $5afd24d8f370d3e2$var$node;

});


parcelRegister("gTGp2", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsToolchainRoute", () => $8d33965caf47a037$export$7dbc23deac9553d4);
const $8d33965caf47a037$export$7dbc23deac9553d4 = {
    name: 'project-settings-software-toolchain-company-managed',
    path: '/jira/software/c/projects/:projectKey/settings/toolchain',
    exact: true
};

});

parcelRegister("aA5DA", function(module, exports) {

$parcel$export(module.exports, "LazyDevOpsConnectionsSettings", () => $11c79a07a4ec83b8$export$9d468faf674a5201);
$parcel$export(module.exports, "default", () => $11c79a07a4ec83b8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $11c79a07a4ec83b8$export$9d468faf674a5201 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("iXqfR")), {
    moduleId: "./src/packages/spa-apps/project-settings/connections/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$11c79a07a4ec83b8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $11c79a07a4ec83b8$export$9d468faf674a5201,
        pageId: "devops-connections-settings",
        shouldShowSpinner: false
    });

});
parcelRegister("iXqfR", function(module, exports) {

let $dcd21a5266daa71c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dcd21a5266daa71c$var$load("jwlH1").then(()=>parcelRequire('a0GzC'));

});



parcelRegister("d2uL5", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRouteEntry", () => $212dfb46ac85d619$export$836428e7b33b6c6c);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $j3hwR = parcelRequire("j3hwR");

var $e7bC3 = parcelRequire("e7bC3");

var $9PHNK = parcelRequire("9PHNK");
const $212dfb46ac85d619$export$836428e7b33b6c6c = (0, $7NszV.createEntry)((0, $j3hwR.legacyProjectReleasesNoteConfigRoute), ()=>({
        group: 'project-settings-software',
        resources: [
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $9PHNK.LegacyFrontendReleaseNoteRedirect),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("j3hwR", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRoute", () => $1e459e992a50ef9a$export$a9509017cabb1e30);
const $1e459e992a50ef9a$export$a9509017cabb1e30 = {
    name: 'legacy-project-releases-note-config',
    path: '/secure/ConfigureReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});

parcelRegister("9PHNK", function(module, exports) {

$parcel$export(module.exports, "BoardSettingsRedirectToCSM", () => $3fda9f3e07781c4c$export$ccce5315da25c53e);
$parcel$export(module.exports, "RoadmapSettingsRedirectToTimelineSettings", () => $3fda9f3e07781c4c$export$eaa324972a212c18);
$parcel$export(module.exports, "SpaReleaseNoteRedirectToVersionDetails", () => $3fda9f3e07781c4c$export$52fa4fd8ca9baab5);
$parcel$export(module.exports, "LegacyFrontendReleaseNoteRedirect", () => $3fda9f3e07781c4c$export$dee47264404d89a0);
$parcel$export(module.exports, "getUFOName", () => $3fda9f3e07781c4c$export$759ec9adbd19c936);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $b5AbL = parcelRequire("b5AbL");

var $7tQej = parcelRequire("7tQej");
const $3fda9f3e07781c4c$export$ccce5315da25c53e = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/columns`,
        push: false
    });
const $3fda9f3e07781c4c$export$eaa324972a212c18 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/timeline`,
        push: false
    });
const $3fda9f3e07781c4c$export$52fa4fd8ca9baab5 = ({ query: query })=>{
    const { version: versionId } = query;
    const { loading: loading, error: error, projectKey: projectKey } = (0, $b5AbL.useProjectKeyByProjectResource)();
    if (loading === false && error) return null;
    if (loading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: {
            pathname: `/projects/${projectKey}/versions/${versionId}/tab/release-report-all-issues`,
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
                isReleaseNoteModalOpen: true
            })
        }
    });
};
const $3fda9f3e07781c4c$export$dee47264404d89a0 = ({ query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: {
            pathname: '/secure/ReleaseNote.jspa',
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
                ...query,
                isRedirectedFromLegacy: true
            })
        }
    });
const $3fda9f3e07781c4c$var$ufoNamesMap = {
    'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
    'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
};
const $3fda9f3e07781c4c$export$759ec9adbd19c936 = (name)=>$3fda9f3e07781c4c$var$ufoNamesMap[name] || name;

});
parcelRegister("b5AbL", function(module, exports) {

$parcel$export(module.exports, "useProjectKeyByProjectResource", () => $347c2a822ae60413$export$899fd1c46031ece8);

var $jcw0u = parcelRequire("jcw0u");

var $2YP9W = parcelRequire("2YP9W");

var $dxCvy = parcelRequire("dxCvy");
const $347c2a822ae60413$export$899fd1c46031ece8 = (teamName)=>{
    const { data: data, error: resourceError, loading: loading } = (0, $2YP9W.useResource)((0, $dxCvy.projectContextResource));
    if (resourceError && data == null) {
        const isErrorErrorType = resourceError instanceof Error;
        const error = isErrorErrorType ? resourceError : new Error(`projectContextResource returned error resourceError: ${JSON.stringify(resourceError)}, loading: ${loading}, data: null`);
        (0, $jcw0u.default)({
            meta: {
                id: 'useResourceProjectContext',
                packageName: 'jiraRouterResourcesProjectContext',
                teamName: teamName ?? 'magma'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            loading: false,
            error: error,
            projectKey: null
        };
    }
    if (loading) return {
        loading: true,
        error: null,
        projectKey: null
    };
    // This case never happens by type definition, which you can't even mock test data for this case due to type definition. But if you don't check this, TS is not happy
    if (data == null) return {
        loading: false,
        error: new Error('projectContextResource returned data=null when loading false'),
        projectKey: null
    };
    return {
        loading: false,
        projectKey: data.projectKey,
        error: null
    };
};

});



parcelRegister("2ubrr", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteRouteEntry", () => $a8cc91e8c082e291$export$781dd53d465d270d);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $9xZTT = parcelRequire("9xZTT");

var $e7bC3 = parcelRequire("e7bC3");

var $9PHNK = parcelRequire("9PHNK");
const $a8cc91e8c082e291$export$781dd53d465d270d = (0, $7NszV.createEntry)((0, $9xZTT.legacyProjectReleasesNoteRoute), ()=>({
        group: 'project-settings-software',
        resources: [
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $9PHNK.LegacyFrontendReleaseNoteRedirect),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("9xZTT", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteRoute", () => $6ea4b44e61fd0227$export$6ef734887b6da0c8);
const $6ea4b44e61fd0227$export$6ef734887b6da0c8 = {
    name: 'legacy-project-releases-note',
    path: '/jira/secure/ReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});


parcelRegister("d7mi1", function(module, exports) {

$parcel$export(module.exports, "projectSettingsAutomationCRouteEntry", () => $93ddc77854479226$export$8a6c5a399335fa16);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $jTltG = parcelRequire("jTltG");

var $e7bC3 = parcelRequire("e7bC3");

var $kdqX9 = parcelRequire("kdqX9");
const $93ddc77854479226$export$8a6c5a399335fa16 = (0, $7NszV.createEntry)((0, $jTltG.projectSettingsAutomationCRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings-automation-c',
        component: (0, $kdqX9.default),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kdqX9.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("jTltG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsAutomationCRoute", () => $c472df0c8cbe0617$export$5337cc16f271a9cf);
const $c472df0c8cbe0617$export$5337cc16f271a9cf = {
    name: 'project-settings-automation',
    path: '/jira/software/c/projects/:projectKey/settings/automate'
};

});

parcelRegister("kdqX9", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", () => $4700cd79d99e02ea$export$dea5ad7e8eac12ae);
$parcel$export(module.exports, "default", () => $4700cd79d99e02ea$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $4700cd79d99e02ea$export$dea5ad7e8eac12ae = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("iSy68")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4700cd79d99e02ea$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4700cd79d99e02ea$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("5HfC7", function(module, exports) {

$parcel$export(module.exports, "projectSettingsAutomationRouteEntry", () => $4db68a59886d705c$export$a34f85c5b69f2c2f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $33SkB = parcelRequire("33SkB");

var $e7bC3 = parcelRequire("e7bC3");

var $kdqX9 = parcelRequire("kdqX9");

var $1XdKx = parcelRequire("1XdKx");
const $4db68a59886d705c$export$a34f85c5b69f2c2f = (0, $7NszV.createEntry)((0, $33SkB.projectSettingsAutomationRoute), ()=>({
        group: 'project-settings-software',
        ufoName: `project-settings-automation-${0, $1XdKx.SOFTWARE_PRODUCT}`,
        component: (0, $kdqX9.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kdqX9.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("33SkB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsAutomationRoute", () => $ccabe492276f268a$export$7809aa084868deea);
const $ccabe492276f268a$export$7809aa084868deea = {
    name: 'project-settings-automation',
    path: '/jira/software/projects/:projectKey/settings/automate'
};

});


parcelRegister("7QAza", function(module, exports) {

$parcel$export(module.exports, "projectSettingsForgeAppsNextgenRouteEntry", () => $0239e22c8f9a631b$export$872a0285d27dfa47);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $kvHR2 = parcelRequire("kvHR2");

var $e7bC3 = parcelRequire("e7bC3");

var $dBDdA = parcelRequire("dBDdA");

var $1XdKx = parcelRequire("1XdKx");
const $0239e22c8f9a631b$export$872a0285d27dfa47 = (0, $7NszV.createEntry)((0, $kvHR2.projectSettingsForgeAppsNextgenRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $dBDdA.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            ...(0, $dBDdA.forgeProjectSettingsPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dBDdA.LazyForgeProjectSettingsPage)
        ]
    }));

});
parcelRegister("kvHR2", function(module, exports) {

$parcel$export(module.exports, "projectSettingsForgeAppsNextgenRoute", () => $c8db0ba1a5916a92$export$8559c4a0b692890e);
const $c8db0ba1a5916a92$export$8559c4a0b692890e = {
    name: 'project-settings-software-apps-forge',
    path: '/jira/software/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("dBDdA", function(module, exports) {

$parcel$export(module.exports, "LazyForgeProjectSettingsPage", () => $fa6a5556191902b5$export$ef66d3f49a9953d8);
$parcel$export(module.exports, "forgeProjectSettingsPageResources", () => $fa6a5556191902b5$export$33d85a1b2211b38);
$parcel$export(module.exports, "default", () => $fa6a5556191902b5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5bkvv = parcelRequire("5bkvv");

var $dxCvy = parcelRequire("dxCvy");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $fa6a5556191902b5$export$ef66d3f49a9953d8 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("dyX7u")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $fa6a5556191902b5$export$33d85a1b2211b38 = ()=>[
        (0, $dxCvy.projectContextResourceWithCache),
        (0, $5bkvv.forgeProjectSettingsModuleResource)
    ];
const $fa6a5556191902b5$export$b943f48844c671a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $fa6a5556191902b5$export$ef66d3f49a9953d8,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
var $fa6a5556191902b5$export$2e2bcd8739ae039 = $fa6a5556191902b5$export$b943f48844c671a5;

});


parcelRegister("5MiVl", function(module, exports) {

$parcel$export(module.exports, "projectSettingsForgeAppsRouteEntry", () => $9bf506152004886d$export$54d0d8466c8b40dc);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $iSJL6 = parcelRequire("iSJL6");

var $e7bC3 = parcelRequire("e7bC3");

var $dBDdA = parcelRequire("dBDdA");
const $9bf506152004886d$export$54d0d8466c8b40dc = (0, $7NszV.createEntry)((0, $iSJL6.projectSettingsForgeAppsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $dBDdA.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $dBDdA.forgeProjectSettingsPageResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dBDdA.LazyForgeProjectSettingsPage)
        ]
    }));

});
parcelRegister("iSJL6", function(module, exports) {

$parcel$export(module.exports, "projectSettingsForgeAppsRoute", () => $dbb37015acdc19c0$export$f74a0b1be9d5b9f6);
const $dbb37015acdc19c0$export$f74a0b1be9d5b9f6 = {
    name: 'project-settings-software-forge-apps',
    path: '/jira/software/c/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});


parcelRegister("ee5pi", function(module, exports) {

$parcel$export(module.exports, "projectSettingsOpsgenieRouteEntry", () => $d6930e98cb7e7363$export$4b4bfb4318f5a98e);

var $ffza4 = parcelRequire("ffza4");

var $bwLf9 = parcelRequire("bwLf9");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $a8P7Z = parcelRequire("a8P7Z");

var $kfztd = parcelRequire("kfztd");

var $e7bC3 = parcelRequire("e7bC3");

var $1KQBW = parcelRequire("1KQBW");

var $1XdKx = parcelRequire("1XdKx");
const $d6930e98cb7e7363$export$4b4bfb4318f5a98e = (0, $7NszV.createEntry)((0, $a8P7Z.projectSettingsOpsgenieRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $bwLf9.default)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $1KQBW.default)),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1KQBW.LazyLinkOpsgeniePage)
        ],
        ufoName: 'project-settings.link-opsgenie'
    }));

});
parcelRegister("a8P7Z", function(module, exports) {

$parcel$export(module.exports, "projectSettingsOpsgenieRoute", () => $6ef9ba56e8ee2329$export$c7039de5a4b78802);
const $6ef9ba56e8ee2329$export$c7039de5a4b78802 = {
    name: 'project-settings-software-link-opsgenie',
    path: '/jira/software/projects/:projectKey/settings/opsgenie',
    exact: true
};

});


parcelRegister("3SReJ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAccessRedirectRouteEntry", () => $ba86f21f622e78fc$export$99415df4033272f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $9X7Hu = parcelRequire("9X7Hu");

var $e7bC3 = parcelRequire("e7bC3");

var $8ODWq = parcelRequire("8ODWq");

var $1XdKx = parcelRequire("1XdKx");
const $ba86f21f622e78fc$export$99415df4033272f = (0, $7NszV.createEntry)((0, $9X7Hu.projectSettingsSoftwareAccessRedirectRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $8ODWq.peopleAccessRedirect)(`/jira/${(0, $1XdKx.SOFTWARE_PRODUCT)}`),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8ODWq.LazyPeopleSettings)
        ]
    }));

});
parcelRegister("9X7Hu", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAccessRedirectRoute", () => $82c1f2665cb2cc20$export$55335c81a2be4654);
const $82c1f2665cb2cc20$export$55335c81a2be4654 = {
    name: 'project-settings-software-access-redirect',
    path: '/jira/software/projects/:projectKey/settings/people',
    exact: true
};

});

parcelRegister("8ODWq", function(module, exports) {

$parcel$export(module.exports, "LazyPeopleSettings", () => $3671536b80f548b9$export$7eee4f97b7a1273);
$parcel$export(module.exports, "peopleAccessRedirect", () => $3671536b80f548b9$export$45346ed2aa24e3f3);
$parcel$export(module.exports, "default", () => $3671536b80f548b9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $7tQej = parcelRequire("7tQej");

const $3671536b80f548b9$export$7eee4f97b7a1273 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kwY5j"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});
const $3671536b80f548b9$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
        push: false
    });
const $3671536b80f548b9$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3671536b80f548b9$var$PeopleAccessRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3671536b80f548b9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3671536b80f548b9$export$7eee4f97b7a1273,
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });

});


parcelRegister("aLuho", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAccessRouteEntry", () => $298f52c63e8d86c3$export$a5ead9d0de14b14b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $lJe4p = parcelRequire("lJe4p");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $8ODWq = parcelRequire("8ODWq");

var $1XdKx = parcelRequire("1XdKx");
const $298f52c63e8d86c3$export$a5ead9d0de14b14b = (0, $7NszV.createEntry)((0, $lJe4p.projectSettingsSoftwareAccessRoute), ()=>({
        group: 'project-settings-software',
        skeleton: (0, $jaAyo.ProjectSettingsAccessSkeleton),
        component: (0, $8ODWq.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8ODWq.LazyPeopleSettings)
        ],
        ufoName: 'project-settings.access'
    }));

});
parcelRegister("lJe4p", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAccessRoute", () => $b825fa291dbed4f2$export$db689602f90567d8);
const $b825fa291dbed4f2$export$db689602f90567d8 = {
    name: 'project-settings-software-access',
    path: '/jira/software/projects/:projectKey/settings/access',
    exact: true
};

});


parcelRegister("3YX4q", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAppsFieldsRouteEntry", () => $0c75b4b7b48f7f91$export$78d9c4be1503dd23);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $d6jlO = parcelRequire("d6jlO");

var $e7bC3 = parcelRequire("e7bC3");

var $5GDQc = parcelRequire("5GDQc");

var $1XdKx = parcelRequire("1XdKx");
const $0c75b4b7b48f7f91$export$78d9c4be1503dd23 = (0, $7NszV.createEntry)((0, $d6jlO.projectSettingsSoftwareAppsFieldsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $5GDQc.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5GDQc.LazyConnectAppControlsSettings)
        ]
    }));

});
parcelRegister("d6jlO", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAppsFieldsRoute", () => $d1b04e5d85adc782$export$333c94a9ec1a1535);
const $d1b04e5d85adc782$export$333c94a9ec1a1535 = {
    name: 'project-settings-software-apps-fields',
    path: '/jira/software/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("5GDQc", function(module, exports) {

$parcel$export(module.exports, "LazyConnectAppControlsSettings", () => $c49a5a5e07aed0ac$export$246ec9cdadd2a163);
$parcel$export(module.exports, "default", () => $c49a5a5e07aed0ac$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $dAfqg = parcelRequire("dAfqg");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $7tQej = parcelRequire("7tQej");

var $looJs = parcelRequire("looJs");

const $c49a5a5e07aed0ac$export$246ec9cdadd2a163 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("b8ySY"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $c49a5a5e07aed0ac$var$ConnectAppsRedirectInner = ({ match: match, basePath: basePath })=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const shouldRedirect = projectContext != null && projectContext.simplified && projectContext.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
    return shouldRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/apps/app-fields`,
        push: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $looJs.default), null);
};
const $c49a5a5e07aed0ac$export$cc3414a2d9daf70d = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c49a5a5e07aed0ac$var$ConnectAppsRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c49a5a5e07aed0ac$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c49a5a5e07aed0ac$export$246ec9cdadd2a163,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });

});
parcelRegister("looJs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab1da42a9104ecee$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $ab1da42a9104ecee$export$fa3bc297af95f169 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("bsfER"))), {
    moduleId: "./src/packages/spa-apps/project-settings/app-discovery-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ab1da42a9104ecee$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ab1da42a9104ecee$export$fa3bc297af95f169,
        pageId: "project-settings-app-discovery-settings",
        shouldShowSpinner: false
    });

});
parcelRegister("bsfER", function(module, exports) {

let $856e7497da4dc3a0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $856e7497da4dc3a0$var$load("7mkmU").then(()=>parcelRequire('jgXd4'));

});




parcelRegister("kEFGH", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAppsRouteEntry", () => $0ed53dac2f0a0ceb$export$290fcdffa80c48ce);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $g44Z8 = parcelRequire("g44Z8");

var $e7bC3 = parcelRequire("e7bC3");

var $jwbRB = parcelRequire("jwbRB");

var $1XdKx = parcelRequire("1XdKx");
const $0ed53dac2f0a0ceb$export$290fcdffa80c48ce = (0, $7NszV.createEntry)((0, $g44Z8.projectSettingsSoftwareAppsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $jwbRB.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jwbRB.LazyConnectAppsSettings)
        ]
    }));

});
parcelRegister("g44Z8", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAppsRoute", () => $2fe06dc3c4459510$export$aece357f5f434121);
const $2fe06dc3c4459510$export$aece357f5f434121 = {
    name: 'project-settings-software-apps',
    path: '/jira/software/projects/:projectKey/settings/apps/:appId?',
    exact: true
};

});

parcelRegister("jwbRB", function(module, exports) {

$parcel$export(module.exports, "LazyConnectAppsSettings", () => $0d3ebe2f9030fc49$export$3633e017e520a1c2);
$parcel$export(module.exports, "default", () => $0d3ebe2f9030fc49$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $0d3ebe2f9030fc49$export$3633e017e520a1c2 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lXgsn"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0d3ebe2f9030fc49$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0d3ebe2f9030fc49$export$3633e017e520a1c2,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });

});


parcelRegister("kwWQ0", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAutomationRouteEntry", () => $5d7bd87a7c840c7a$export$fb1f0477184046c5);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $lecb5 = parcelRequire("lecb5");

var $e7bC3 = parcelRequire("e7bC3");

var $kdqX9 = parcelRequire("kdqX9");

var $1XdKx = parcelRequire("1XdKx");
const $5d7bd87a7c840c7a$export$fb1f0477184046c5 = (0, $7NszV.createEntry)((0, $lecb5.projectSettingsSoftwareAutomationRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $kdqX9.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kdqX9.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("lecb5", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAutomationRoute", () => $fc9d7be9739092f6$export$4d430aeb28b702f8);
const $fc9d7be9739092f6$export$4d430aeb28b702f8 = {
    name: 'project-settings-software-automation',
    path: '/jira/software/projects/:projectKey/settings/automation',
    exact: true
};

});


parcelRegister("7F7I9", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCardRouteEntry", () => $f60e688753874fc2$export$ca616a5516b2e16d);

var $ffza4 = parcelRequire("ffza4");

var $1xZqw = parcelRequire("1xZqw");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $63xkH = parcelRequire("63xkH");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $lN3Iw = parcelRequire("lN3Iw");
const $f60e688753874fc2$export$ca616a5516b2e16d = (0, $7NszV.createEntry)((0, $63xkH.projectSettingsSoftwareBoardsCardRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'board-settings-apps.card-cover-settings-page.page.load',
        component: (0, $lN3Iw.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            (0, $1xZqw.cardCoverImageResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lN3Iw.LazyCard)
        ]
    }));

});
parcelRegister("1xZqw", function(module, exports) {

$parcel$export(module.exports, "cardCoverImageResource", () => $0fcabd2255a2311c$export$f37f52e28126ce75);

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $eQDse = parcelRequire("eQDse");

const $0fcabd2255a2311c$export$f37f52e28126ce75 = (0, $ao2h1.createRelayResource)({
    type: (0, $b9b0da783aed9042$export$d9d248919fbd0611),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $eQDse.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("eQDse", function(module, exports) {

$parcel$export(module.exports, "default", () => $19be575ffa3b6370$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<18030b1362ffffdd2f24b83852b88efd>>
 * @relayHash b790d69589aa0ef2a06a10dc57fc6bfc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4216a4fc24eb7ed0390f1effcdb5558af09a70f95660a0c572ae4b531ddc98fc
const $19be575ffa3b6370$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cardCoverSettingsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareBoard",
                                    "kind": "LinkedField",
                                    "name": "board",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "toggle_boardSettingsCard_CardCoverToggle"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "cardPreview_boardSettingsCard"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.board"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cardCoverSettingsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SoftwareBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CardMediaConfig",
                                    "kind": "LinkedField",
                                    "name": "cardMedia",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                },
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "4216a4fc24eb7ed0390f1effcdb5558af09a70f95660a0c572ae4b531ddc98fc",
            "metadata": {},
            "name": "cardCoverSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$19be575ffa3b6370$var$node.hash = "eb3068eeffbe9ec2fb99186c54005ea6";
var $19be575ffa3b6370$export$2e2bcd8739ae039 = $19be575ffa3b6370$var$node;

});

const $b9b0da783aed9042$export$d9d248919fbd0611 = 'BOARD_CONTEXT_CARD_COVER_SETTINGS';


parcelRegister("63xkH", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCardRoute", () => $fd58dce0fef4a2da$export$d3f185a361401db7);
const $fd58dce0fef4a2da$export$d3f185a361401db7 = {
    name: 'project-settings-software-boards-card',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/card',
    exact: true
};

});

parcelRegister("lN3Iw", function(module, exports) {

$parcel$export(module.exports, "LazyCard", () => $4bec2fc264f66dc5$export$40ff283c032abbc4);
$parcel$export(module.exports, "default", () => $4bec2fc264f66dc5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $4bec2fc264f66dc5$export$40ff283c032abbc4 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("1UlrT")), {
    moduleId: "./src/packages/spa-apps/project-settings/board-settings/card/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4bec2fc264f66dc5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4bec2fc264f66dc5$export$40ff283c032abbc4,
        pageId: "board-settings-card",
        shouldShowSpinner: false
    });

});
parcelRegister("1UlrT", function(module, exports) {

let $163ba8b11f366ddc$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("20nf9"), 4)),
    $163ba8b11f366ddc$var$load("gldEF")
]).then(()=>parcelRequire('dgQTq'));

});



parcelRegister("2OQWG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCsmRouteEntry", () => $5614131c72bf5418$export$7a31e42733ba05a0);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $g6Dtv = parcelRequire("g6Dtv");

var $e7bC3 = parcelRequire("e7bC3");

var $dtjqc = parcelRequire("dtjqc");

var $1XdKx = parcelRequire("1XdKx");
const $5614131c72bf5418$export$7a31e42733ba05a0 = (0, $7NszV.createEntry)((0, $g6Dtv.projectSettingsSoftwareBoardsCsmRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'software.next-gen.boards.column-status-mapping.page.load',
        component: (0, $dtjqc.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dtjqc.LazyCsmSettings)
        ]
    }));

});
parcelRegister("g6Dtv", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCsmRoute", () => $e2028f4601d0a4d1$export$88e68eb447e3db49);
const $e2028f4601d0a4d1$export$88e68eb447e3db49 = {
    name: 'project-settings-software-boards-csm',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/columns',
    exact: true
};

});

parcelRegister("dtjqc", function(module, exports) {

$parcel$export(module.exports, "LazyCsmSettings", () => $f25068ef108ee62d$export$de293ea44d0410ca);
$parcel$export(module.exports, "default", () => $f25068ef108ee62d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $f25068ef108ee62d$export$de293ea44d0410ca = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6KfnD"))), {
    moduleId: "./src/packages/spa-apps/project-settings/csm/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f25068ef108ee62d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f25068ef108ee62d$export$de293ea44d0410ca,
        pageId: "project-settings-csm",
        shouldShowSpinner: false
    });

});
parcelRegister("6KfnD", function(module, exports) {

let $4e92f821a6505aed$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("fg4hm"), 4)),
    $4e92f821a6505aed$var$load("kPUyC")
]).then(()=>parcelRequire('jFUmz'));

});



parcelRegister("4eRSO", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCustomFiltersRouteEntry", () => $e8af9bf5c835f1d8$export$6332ad3e1d8d721);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $cD3jo = parcelRequire("cD3jo");

var $7NszV = parcelRequire("7NszV");

var $VF0KL = parcelRequire("VF0KL");

var $e7bC3 = parcelRequire("e7bC3");

var $gqIYW = parcelRequire("gqIYW");

var $1XdKx = parcelRequire("1XdKx");
const $e8af9bf5c835f1d8$export$6332ad3e1d8d721 = (0, $7NszV.createEntry)((0, $VF0KL.projectSettingsSoftwareBoardsCustomFiltersRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.custom-filters',
        component: (0, $gqIYW.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            (0, $cD3jo.customFiltersResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gqIYW.LazyCustomFiltersSettings)
        ]
    }));

});
parcelRegister("cD3jo", function(module, exports) {

$parcel$export(module.exports, "customFiltersResource", () => $ca950ad823e84673$export$3e390340716755de);

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $WcCM5 = parcelRequire("WcCM5");

const $ca950ad823e84673$export$3e390340716755de = (0, $ao2h1.createRelayResource)({
    type: (0, $ad903674eb868bde$export$5917fd27c14066cd),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $WcCM5.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("WcCM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5edc411e6b038299$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c655bf5d42bc04990088e48dc6b757f>>
 * @relayHash 82ae1b9c2b4e7b31e211094a4e3f4f3f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c990befb5021511de9b1550aa7300067f8d87644e0d370c3754283355de50686
const $5edc411e6b038299$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "customFiltersQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CustomFilter",
                                    "kind": "LinkedField",
                                    "name": "customFilters",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "card_projectSettingsCustomFilters_customFilterFragmentRef"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.customFilters"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "card_projectSettingsCustomFilters_boardScopeFragmentRef"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "expandedCard_projectSettingsCustomFilters_boardScopeFragmentRef"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "customFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "concreteType": "FilterQuery",
                                    "kind": "LinkedField",
                                    "name": "filterQuery",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "sanitisedJql"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "errors"
                                        }
                                    ]
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        v3 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "c990befb5021511de9b1550aa7300067f8d87644e0d370c3754283355de50686",
            "metadata": {},
            "name": "customFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5edc411e6b038299$var$node.hash = "2c5c0d030a87f3820766a2a896d71275";
var $5edc411e6b038299$export$2e2bcd8739ae039 = $5edc411e6b038299$var$node;

});

const $ad903674eb868bde$export$5917fd27c14066cd = 'NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS';


parcelRegister("VF0KL", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCustomFiltersRoute", () => $0d2b719554e610ba$export$9bc9b345958a301c);
const $0d2b719554e610ba$export$9bc9b345958a301c = {
    name: 'project-settings-software-boards-custom-filters',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/custom-filters',
    exact: true
};

});

parcelRegister("gqIYW", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFiltersSettings", () => $26928850e3bfb37f$export$7e21d36a9d4548e6);
$parcel$export(module.exports, "default", () => $26928850e3bfb37f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $26928850e3bfb37f$export$7e21d36a9d4548e6 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("dnj7f")), {
    moduleId: "./src/packages/spa-apps/project-settings/custom-filters/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$26928850e3bfb37f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $26928850e3bfb37f$export$7e21d36a9d4548e6,
        pageId: "project-settings-custom-filters",
        shouldShowSpinner: true
    });

});
parcelRegister("dnj7f", function(module, exports) {

let $9bcc405904648127$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9bcc405904648127$var$load("3R5lB").then(()=>parcelRequire('keIpy'));

});



parcelRegister("b9Dpn", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsRedirectRouteEntry", () => $966af26f7fec7c46$export$cb6169207ddfd1b2);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $dieXh = parcelRequire("dieXh");

var $e7bC3 = parcelRequire("e7bC3");

var $9PHNK = parcelRequire("9PHNK");

var $1XdKx = parcelRequire("1XdKx");
const $966af26f7fec7c46$export$cb6169207ddfd1b2 = (0, $7NszV.createEntry)((0, $dieXh.projectSettingsSoftwareBoardsRedirectRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $9PHNK.BoardSettingsRedirectToCSM),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        isRedirect: true,
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("dieXh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsRedirectRoute", () => $31cf97a1a4a84207$export$989ca67485551616);
const $31cf97a1a4a84207$export$989ca67485551616 = {
    name: 'project-settings-software-boards-redirect',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId',
    exact: true
};

});


parcelRegister("eitw0", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsRoadmapRouteEntry", () => $6d01f44cfcf07c9a$export$6d5eadd440c430f5);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $2FXLN = parcelRequire("2FXLN");

var $1V8vh = parcelRequire("1V8vh");

var $e7bC3 = parcelRequire("e7bC3");

var $9PHNK = parcelRequire("9PHNK");

var $1XdKx = parcelRequire("1XdKx");

var $aXcNG = parcelRequire("aXcNG");
const $6d01f44cfcf07c9a$export$6d5eadd440c430f5 = (0, $7NszV.createEntry)((0, $1V8vh.projectSettingsSoftwareBoardsRoadmapRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $9PHNK.RoadmapSettingsRedirectToTimelineSettings),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            (0, $2FXLN.roadmapSettingsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aXcNG.LazyRoadmap)
        ]
    }));

});
parcelRegister("2FXLN", function(module, exports) {

$parcel$export(module.exports, "roadmapSettingsResource", () => $265fc06fbb6443a3$export$7901a008bd73bf46);

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $6VnEZ = parcelRequire("6VnEZ");

const $265fc06fbb6443a3$export$7901a008bd73bf46 = (0, $ao2h1.createRelayResource)({
    type: (0, $87d7efe6336d8b83$export$e905b9170ecbb599),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>{
        const { cloudId: cloudId } = tenantContext;
        return {
            parameters: (0, $6VnEZ.default),
            variables: {
                sourceAri: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                locationAri: undefined
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});

});
parcelRegister("6VnEZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a28994bc59c1b6c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<549802b43e67112dd5fba3309099c2de>>
 * @relayHash 19ad9a547bce255c35adc444386a03af
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6603bfc1272bd596fb67b3022210270e42d5bfb54ab2cf66470e7e5a8934ba80
const $4a28994bc59c1b6c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locationAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "locationARI",
            "variableName": "locationAri"
        },
        {
            "kind": "Variable",
            "name": "sourceARI",
            "variableName": "sourceAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isSprintsFeatureEnabled"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "roadmapSettingsQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "RoadmapConfiguration",
                                        "kind": "LinkedField",
                                        "name": "roadmapConfiguration",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "RoadmapBoardConfiguration",
                                                    "kind": "LinkedField",
                                                    "name": "boardConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "childIssuesSchedulingToggle_boardSettingsRoadmap"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "childIssuesSchedulingPreview_boardSettingsRoadmap"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "roadmaps.roadmapForSource.roadmapConfiguration.boardConfiguration"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapForSource.roadmapConfiguration"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "roadmapSettingsQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "RoadmapConfiguration",
                                    "kind": "LinkedField",
                                    "name": "roadmapConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "RoadmapBoardConfiguration",
                                            "kind": "LinkedField",
                                            "name": "boardConfiguration",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isChildIssuePlanningEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "childIssuePlanningMode"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6603bfc1272bd596fb67b3022210270e42d5bfb54ab2cf66470e7e5a8934ba80",
            "metadata": {},
            "name": "roadmapSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4a28994bc59c1b6c$var$node.hash = "31c20159daaa03716587a1ccbe27ab14";
var $4a28994bc59c1b6c$export$2e2bcd8739ae039 = $4a28994bc59c1b6c$var$node;

});


parcelRegister("1V8vh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsRoadmapRoute", () => $a1437557f2047801$export$17ccdaa366ec26b8);
const $a1437557f2047801$export$17ccdaa366ec26b8 = {
    name: 'project-settings-software-boards-roadmap',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/roadmap',
    exact: true
};

});

parcelRegister("aXcNG", function(module, exports) {

$parcel$export(module.exports, "LazyRoadmap", () => $50cd29d3245ccefc$export$8eca5454e72ee961);
$parcel$export(module.exports, "default", () => $50cd29d3245ccefc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $50cd29d3245ccefc$export$8eca5454e72ee961 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("eukUj")), {
    moduleId: "./src/packages/spa-apps/project-settings/board-settings/roadmap/src/index.tsx"
});
const $50cd29d3245ccefc$var$AsyncProjectSettingsRoadmap = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "project-settings.roadmap",
        teamName: "chronos",
        attributes: {
            isSynthetic: (0, $4R6GH.fg)('is_synthetic_tenant') || (0, $j8DrX.default)('ajs-is-synthetic') === 'true'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $50cd29d3245ccefc$export$8eca5454e72ee961,
        pageId: "board-settings-roadmap",
        shouldShowSpinner: false
    }));
var $50cd29d3245ccefc$export$2e2bcd8739ae039 = $50cd29d3245ccefc$var$AsyncProjectSettingsRoadmap;

});
parcelRegister("eukUj", function(module, exports) {

let $a8c415cb3ea254b3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a8c415cb3ea254b3$var$load("kO7MH").then(()=>parcelRequire('5d39M'));

});



parcelRegister("14ooS", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsTimelineRouteEntry", () => $aeb3431f883d58ca$export$cc224b8b7595975b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $2FXLN = parcelRequire("2FXLN");

var $at8lb = parcelRequire("at8lb");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $aXcNG = parcelRequire("aXcNG");
const $aeb3431f883d58ca$export$cc224b8b7595975b = (0, $7NszV.createEntry)((0, $at8lb.projectSettingsSoftwareBoardsTimelineRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'board-settings-apps.roadmap-settings-page.page.load',
        component: (0, $aXcNG.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            (0, $2FXLN.roadmapSettingsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aXcNG.LazyRoadmap)
        ]
    }));

});
parcelRegister("at8lb", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsTimelineRoute", () => $cc4b8dfb5f37c2a0$export$e116d6b2a5f71426);
const $cc4b8dfb5f37c2a0$export$e116d6b2a5f71426 = {
    name: 'project-settings-software-boards-timeline',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/timeline',
    exact: true
};

});


parcelRegister("lWR9T", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareDataClassificationsRouteEntry", () => $fb225e359b3a3445$export$cc932462de184b27);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $flo0i = parcelRequire("flo0i");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $ejqjx = parcelRequire("ejqjx");

var $1XdKx = parcelRequire("1XdKx");
const $fb225e359b3a3445$export$cc932462de184b27 = (0, $7NszV.createEntry)((0, $flo0i.projectSettingsSoftwareDataClassificationsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $ejqjx.default),
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ejqjx.LazyDataClassificationsSettings)
        ]
    })); /**
 * Contains all software settings routes using the new url format `jira/:product/projects/:projectKey/settings`.
 */ 

});
parcelRegister("flo0i", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareDataClassificationsRoute", () => $09578e3175fbd546$export$af525a8f93b72cc7);
const $09578e3175fbd546$export$af525a8f93b72cc7 = {
    name: 'project-settings-software-data-classifications',
    path: '/jira/software/projects/:projectKey/settings/data-classifications',
    exact: true
};

});

parcelRegister("ejqjx", function(module, exports) {

$parcel$export(module.exports, "LazyDataClassificationsSettings", () => $81cf21747f4c944d$export$b8abcf8aa8f4df56);
$parcel$export(module.exports, "default", () => $81cf21747f4c944d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $81cf21747f4c944d$export$b8abcf8aa8f4df56 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1LZO6"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$81cf21747f4c944d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $81cf21747f4c944d$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });

});


parcelRegister("6DlqX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareDetailsRouteEntry", () => $a903695c1ce96a1b$export$8440d3384846d9b8);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $a1v1W = parcelRequire("a1v1W");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $cYgMq = parcelRequire("cYgMq");

var $1XdKx = parcelRequire("1XdKx");
const $a903695c1ce96a1b$export$8440d3384846d9b8 = (0, $7NszV.createEntry)((0, $a1v1W.projectSettingsSoftwareDetailsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $cYgMq.default),
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cYgMq.LazyDetailsSettings)
        ]
    }));

});
parcelRegister("a1v1W", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareDetailsRoute", () => $6754d8275b08745c$export$8760347e2b0955eb);
const $6754d8275b08745c$export$8760347e2b0955eb = {
    name: 'project-settings-software-details',
    path: '/jira/software/projects/:projectKey/settings/details',
    exact: true
};

});


parcelRegister("jCfr4", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareFieldsRouteEntry", () => $2b9364818ff70bc7$export$e6b200b5a1ce3063);

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $e7C7O = parcelRequire("e7C7O");

var $5lsNZ = parcelRequire("5lsNZ");

var $eUAWy = parcelRequire("eUAWy");

var $e7bC3 = parcelRequire("e7bC3");

var $6s1PB = parcelRequire("6s1PB");

var $kwZwx = parcelRequire("kwZwx");

var $1XdKx = parcelRequire("1XdKx");
const $2b9364818ff70bc7$var$isEfaExperimentExposed = ()=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    return expConfig.get('isEnabled', false);
};
const $2b9364818ff70bc7$export$e6b200b5a1ce3063 = (0, $7NszV.createEntry)((0, $eUAWy.projectSettingsSoftwareFieldsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.fields.jsw-tmp',
        component: (0, $7XYc4.componentWithCondition)($2b9364818ff70bc7$var$isEfaExperimentExposed, (0, $kwZwx.default), (0, $5lsNZ.default)),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            (0, $e7C7O.fieldSettingsRelayResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kwZwx.LazyFieldsSettings)
        ]
    }));

});
parcelRegister("eUAWy", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareFieldsRoute", () => $507c3ff044231698$export$1ab9d3299fbc789b);
const $507c3ff044231698$export$1ab9d3299fbc789b = {
    name: 'project-settings-software-fields',
    path: '/jira/software/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("kwZwx", function(module, exports) {

$parcel$export(module.exports, "LazyFieldsSettings", () => $628b742891e4f718$export$e309780f520d125a);
$parcel$export(module.exports, "default", () => $628b742891e4f718$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $628b742891e4f718$export$e309780f520d125a = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lAb40"))), {
    moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$628b742891e4f718$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $628b742891e4f718$export$e309780f520d125a,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });

});


parcelRegister("kRn5i", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesRouteEntry", () => $a62547b317f1890b$export$84a9a2dce32d93aa);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $7Uj8H = parcelRequire("7Uj8H");

var $e7bC3 = parcelRequire("e7bC3");

var $9PHNK = parcelRequire("9PHNK");

var $6UFDl = parcelRequire("6UFDl");

var $1XdKx = parcelRequire("1XdKx");
const $a62547b317f1890b$export$84a9a2dce32d93aa = (0, $7NszV.createEntry)((0, $7Uj8H.projectSettingsSoftwareIssuetypesRoute), ()=>({
        group: 'project-settings-software',
        ufoName: (0, $9PHNK.getUFOName)('project-settings-software-issuetypes'),
        component: (0, $6UFDl.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6UFDl.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("7Uj8H", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesRoute", () => $1344929ef12856ff$export$7f26edefe51efc38);
const $1344929ef12856ff$export$7f26edefe51efc38 = {
    name: 'project-settings-software-issuetypes',
    path: '/jira/software/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});

parcelRegister("6UFDl", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeSettings", () => $8f1b2ea450c47b3b$export$36dcfb52d47cb93a);
$parcel$export(module.exports, "default", () => $8f1b2ea450c47b3b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $8f1b2ea450c47b3b$export$36dcfb52d47cb93a = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("72vEr"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8f1b2ea450c47b3b$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8f1b2ea450c47b3b$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

});


parcelRegister("3NIY8", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesWorkflowRouteEntry", () => $991168ab4a6e6879$export$58ca33ed538911cb);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $9QOPa = parcelRequire("9QOPa");

var $e7bC3 = parcelRequire("e7bC3");

var $6UFDl = parcelRequire("6UFDl");

var $1XdKx = parcelRequire("1XdKx");

var $cNuJO = parcelRequire("cNuJO");
const $991168ab4a6e6879$export$58ca33ed538911cb = (0, $7NszV.createEntry)((0, $9QOPa.projectSettingsSoftwareIssuetypesWorkflowRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $cNuJO.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6UFDl.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("9QOPa", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesWorkflowRoute", () => $2d01183c61a2983c$export$de010d824a551ec);
const $2d01183c61a2983c$export$de010d824a551ec = {
    name: 'project-settings-software-issuetypes-workflow',
    path: '/jira/software/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
    exact: true
};

});

parcelRegister("cNuJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $48f5bfd32d483aba$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $48f5bfd32d483aba$export$cb608e3696682e76 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lMJYe"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$48f5bfd32d483aba$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $48f5bfd32d483aba$export$cb608e3696682e76,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });

});


parcelRegister("fjYA2", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNextGenFeaturesRouteEntry", () => $71f1d776dd1bcb90$export$81067f5196099c81);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $hJYLH = parcelRequire("hJYLH");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $eNw6s = parcelRequire("eNw6s");

var $1XdKx = parcelRequire("1XdKx");
const $71f1d776dd1bcb90$export$81067f5196099c81 = (0, $7NszV.createEntry)((0, $hJYLH.projectSettingsSoftwareNextGenFeaturesRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.next-gen-features',
        component: (0, $eNw6s.default),
        skeleton: (0, $jaAyo.ProjectSettingsFeaturesSkeleton),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eNw6s.LazyFeaturesSettings)
        ]
    }));

});
parcelRegister("hJYLH", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNextGenFeaturesRoute", () => $78ec600058c356ce$export$12c7a1737b594a28);
const $78ec600058c356ce$export$12c7a1737b594a28 = {
    name: 'project-settings-software-next-gen-features',
    path: '/jira/software/projects/:projectKey/settings/features',
    exact: true
};

});

parcelRegister("eNw6s", function(module, exports) {

$parcel$export(module.exports, "LazyFeaturesSettings", () => $4e545f86ddd60f53$export$da4d608b99858bfc);
$parcel$export(module.exports, "default", () => $4e545f86ddd60f53$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $4e545f86ddd60f53$export$da4d608b99858bfc = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("26QBQ"))), {
    moduleId: "./src/packages/spa-apps/project-settings/next-gen-features/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4e545f86ddd60f53$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4e545f86ddd60f53$export$da4d608b99858bfc,
        pageId: "project-settings-next-gen-features",
        shouldShowSpinner: false
    });

});
parcelRegister("26QBQ", function(module, exports) {

let $1894f376da88e947$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1894f376da88e947$var$load("6IfzY").then(()=>parcelRequire('2MwfB'));

});



parcelRegister("qdq3O", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailCRouteEntry", () => $70f72ce01753856b$export$9bb08b8e1b39d15f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $iqUDj = parcelRequire("iqUDj");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $9T2qH = parcelRequire("9T2qH");

var $4glor = parcelRequire("4glor");
const $70f72ce01753856b$export$9bb08b8e1b39d15f = (0, $7NszV.createEntry)((0, $iqUDj.projectSettingsSoftwareNotificationEmailCRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $9T2qH.default),
        skeleton: (0, $jaAyo.ProjectSettingsFeaturesSkeleton),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4glor.LazySoftwareClassicFeatures),
            (0, $9T2qH.LazyProjectSettingsNotificationEmail)
        ]
    }));

});
parcelRegister("iqUDj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailCRoute", () => $660f0733dcb91b32$export$dda91725b6c4a039);
const $660f0733dcb91b32$export$dda91725b6c4a039 = {
    name: 'project-settings-software-notifications-notification-email',
    path: '/jira/software/c/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("9T2qH", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsNotificationEmail", () => $6e8f6f53c599ad60$export$ea7d73c94d9369f4);
$parcel$export(module.exports, "default", () => $6e8f6f53c599ad60$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $6e8f6f53c599ad60$export$ea7d73c94d9369f4 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iEUeQ"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6e8f6f53c599ad60$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6e8f6f53c599ad60$export$ea7d73c94d9369f4,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });

});


parcelRegister("aY70k", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailRouteEntry", () => $96e097b23221938d$export$8a17783c300fca11);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $dXGLS = parcelRequire("dXGLS");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");
const $96e097b23221938d$export$8a17783c300fca11 = (0, $7NszV.createEntry)((0, $dXGLS.projectSettingsSoftwareNotificationEmailRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $1XdKx.RedirectForSettings),
        skeleton: (0, $jaAyo.ProjectSettingsFeaturesSkeleton),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("dXGLS", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailRoute", () => $427d02b02ceb584b$export$d4ed083331cb6e00);
const $427d02b02ceb584b$export$d4ed083331cb6e00 = {
    name: 'project-settings-software-notifications-notification-email',
    path: '/jira/software/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});


parcelRegister("2wF9u", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationsIssueLogsRouteEntry", () => $c50f7899cb2834ba$export$9c37d834dfe46ebf);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $be8d4 = parcelRequire("be8d4");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $14B4q = parcelRequire("14B4q");
const $c50f7899cb2834ba$export$9c37d834dfe46ebf = (0, $7NszV.createEntry)((0, $be8d4.projectSettingsSoftwareNotificationsIssueLogsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.software.notifications.issue-logs',
        component: (0, $14B4q.SoftwareNotificationsIssueLogs),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $14B4q.LazySoftwareNotificationsIssueLogs)
        ],
        entryPoint () {
            return 0, $14B4q.emailNotificationsLogEntryPointPage;
        }
    }));

});
parcelRegister("be8d4", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationsIssueLogsRoute", () => $2685d8d8e87c6306$export$ff4977f79c273b29);
const $2685d8d8e87c6306$export$ff4977f79c273b29 = {
    name: 'project-settings-software-notifications-issue-logs',
    path: '/jira/software/projects/:projectKey/settings/notifications/issue-logs',
    exact: true
};

});


parcelRegister("feDOq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationsRouteEntry", () => $d6aa89f0f35f02a8$export$1c340fa0c9022252);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $567rt = parcelRequire("567rt");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $8Z6ZD = parcelRequire("8Z6ZD");
const $d6aa89f0f35f02a8$export$1c340fa0c9022252 = (0, $7NszV.createEntry)((0, $567rt.projectSettingsSoftwareNotificationsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.software.notifications',
        component: (0, $8Z6ZD.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8Z6ZD.LazySoftwareNotificationsSettings)
        ]
    }));

});
parcelRegister("567rt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationsRoute", () => $93d386ac6f219e91$export$c1d1892d6c07135a);
const $93d386ac6f219e91$export$c1d1892d6c07135a = {
    name: 'project-settings-software-notifications',
    path: '/jira/software/projects/:projectKey/settings/notifications',
    exact: true
};

});

parcelRegister("8Z6ZD", function(module, exports) {

$parcel$export(module.exports, "LazySoftwareNotificationsSettings", () => $576f902bdb908a77$export$69a64a29d67ca160);
$parcel$export(module.exports, "default", () => $576f902bdb908a77$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $576f902bdb908a77$export$69a64a29d67ca160 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1Ih7X"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$576f902bdb908a77$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $576f902bdb908a77$export$69a64a29d67ca160,
        pageId: "project-settings-software-notifications",
        shouldShowSpinner: false
    });

});


parcelRegister("cqk4B", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareProformaJiraFormBuilderRouteEntry", () => $219ec4fb78eddcea$export$5606059eca31e30);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $hDUMP = parcelRequire("hDUMP");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $8JnjW = parcelRequire("8JnjW");
const $219ec4fb78eddcea$export$5606059eca31e30 = (0, $7NszV.createEntry)((0, $hDUMP.projectSettingsSoftwareProformaJiraFormBuilderRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $8JnjW.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8JnjW.LazyProjectSettingsProformaJiraFormBuilder)
        ],
        perfMetricKey: 'form-builder'
    }));

});
parcelRegister("hDUMP", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareProformaJiraFormBuilderRoute", () => $b09cc9a715d5f75a$export$cf33294d9d90a855);
const $b09cc9a715d5f75a$export$cf33294d9d90a855 = {
    name: 'project-settings-software-proforma-jira-form-builder',
    path: '/jira/software/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});


parcelRegister("d66ag", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareProformaProjectFormsRouteEntry", () => $1f2ddc69ff9bd153$export$ea77a3e974b26072);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $f5WPG = parcelRequire("f5WPG");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $gyEpf = parcelRequire("gyEpf");
const $1f2ddc69ff9bd153$export$ea77a3e974b26072 = (0, $7NszV.createEntry)((0, $f5WPG.projectSettingsSoftwareProformaProjectFormsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $gyEpf.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gyEpf.LazyProjectSettingsProformaProjectForms)
        ],
        perfMetricKey: 'forms-settings'
    }));

});
parcelRegister("f5WPG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareProformaProjectFormsRoute", () => $f94052f77c0e6bf4$export$750dec948cc98062);
const $f94052f77c0e6bf4$export$750dec948cc98062 = {
    name: 'project-settings-software-proforma-project-forms',
    path: '/jira/software/projects/:projectKey/settings/forms',
    exact: true
};

});


parcelRegister("84EwA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareRedirectRouteEntry", () => $156cde955bd90b23$export$e5caf0892d6025c9);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $c8fK3 = parcelRequire("c8fK3");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");
const $156cde955bd90b23$export$e5caf0892d6025c9 = (0, $7NszV.createEntry)((0, $c8fK3.projectSettingsSoftwareRedirectRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $1XdKx.RedirectForSettings),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("c8fK3", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareRedirectRoute", () => $4fd256cbd670956d$export$168cc8ed4398c230);
const $4fd256cbd670956d$export$168cc8ed4398c230 = {
    // the following route should be non-exact, it will handle "index" and "404" cases
    name: 'project-settings-software-redirect',
    path: '/jira/software/projects/:projectKey/settings'
};

});


parcelRegister("7dYbE", function(module, exports) {

$parcel$export(module.exports, "projectSettingsToolchainRouteEntry", () => $eb246e0ef2b2c1c3$export$dd97d29f96b25d09);

var $ffza4 = parcelRequire("ffza4");

var $bwLf9 = parcelRequire("bwLf9");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $35Wvp = parcelRequire("35Wvp");

var $5lsNZ = parcelRequire("5lsNZ");

var $6eLkt = parcelRequire("6eLkt");

var $kfztd = parcelRequire("kfztd");

var $e7bC3 = parcelRequire("e7bC3");

var $aA5DA = parcelRequire("aA5DA");

var $1XdKx = parcelRequire("1XdKx");
const $eb246e0ef2b2c1c3$export$dd97d29f96b25d09 = (0, $7NszV.createEntry)((0, $6eLkt.projectSettingsToolchainRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $bwLf9.default)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $aA5DA.default)),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            (0, $35Wvp.projectSettingsToolchainResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aA5DA.LazyDevOpsConnectionsSettings)
        ],
        ufoName: 'project-settings.devops-connections'
    }));

});
parcelRegister("6eLkt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsToolchainRoute", () => $f16500562a276728$export$e3e3877ec9c5e840);
const $f16500562a276728$export$e3e3877ec9c5e840 = {
    name: 'project-settings-software-toolchain-team-managed',
    path: '/jira/software/projects/:projectKey/settings/toolchain',
    exact: true
};

});


parcelRegister("ghTLp", function(module, exports) {

$parcel$export(module.exports, "softwareReleaseNotesRouteEntry", () => $6dee187be32572f9$export$543aad2020051ecb);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $9URQe = parcelRequire("9URQe");

var $e7bC3 = parcelRequire("e7bC3");

var $9PHNK = parcelRequire("9PHNK");
const $6dee187be32572f9$export$543aad2020051ecb = (0, $7NszV.createEntry)((0, $9URQe.softwareReleaseNotesRoute), ()=>({
        group: 'project-settings-software',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $9PHNK.SpaReleaseNoteRedirectToVersionDetails),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("9URQe", function(module, exports) {

$parcel$export(module.exports, "softwareReleaseNotesRoute", () => $45e41e5c15f76352$export$a0223091962262d4);
const $45e41e5c15f76352$export$a0223091962262d4 = {
    name: 'software-release-notes',
    path: '/secure/ReleaseNote.jspa',
    query: [
        'projectId'
    ]
};

});


parcelRegister("jjqkz", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskClassicAppsRouteEntry", () => $626e75f8ec29a06e$export$aba71c4218b643ad);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $4P4Lq = parcelRequire("4P4Lq");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $hKH9R = parcelRequire("hKH9R");

var $j9RuP = parcelRequire("j9RuP");

var $01LdL = parcelRequire("01LdL");
const $626e75f8ec29a06e$export$aba71c4218b643ad = (0, $7NszV.createEntry)((0, $4P4Lq.projectSettingsServicedeskClassicAppsRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.app-discovery',
        component: (0, $j9RuP.ConnectAppsRedirect)(`/jira/${(0, $01LdL.SERVICE_DESK_PRODUCT)}`),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        isRedirect: true,
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hKH9R.LazyAppDiscoverySettings)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).APP_DISCOVERY,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).APP_DISCOVERY),
                teamName: 'it-solutions-hermes'
            }
        }
    }));

});
parcelRegister("hKH9R", function(module, exports) {

$parcel$export(module.exports, "LazyAppDiscoverySettings", () => $d7e52a3e5f45b58f$export$fa3bc297af95f169);
$parcel$export(module.exports, "default", () => $d7e52a3e5f45b58f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $d7e52a3e5f45b58f$export$fa3bc297af95f169 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("bsfER"))), {
    moduleId: "./src/packages/spa-apps/project-settings/app-discovery-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d7e52a3e5f45b58f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d7e52a3e5f45b58f$export$fa3bc297af95f169,
        pageId: "project-settings-app-discovery-settings",
        shouldShowSpinner: false
    });

});

parcelRegister("j9RuP", function(module, exports) {

$parcel$export(module.exports, "LazyConnectAppControlsSettings", () => $3f52008d1cdfa258$export$246ec9cdadd2a163);
$parcel$export(module.exports, "ConnectAppsRedirect", () => $3f52008d1cdfa258$export$cc3414a2d9daf70d);
$parcel$export(module.exports, "default", () => $3f52008d1cdfa258$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $dAfqg = parcelRequire("dAfqg");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $7tQej = parcelRequire("7tQej");

var $hKH9R = parcelRequire("hKH9R");

const $3f52008d1cdfa258$export$246ec9cdadd2a163 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("b8ySY"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $3f52008d1cdfa258$var$ConnectAppsRedirectInner = ({ match: match, basePath: basePath })=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const shouldRedirect = projectContext != null && projectContext.simplified && projectContext.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
    return shouldRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/apps/app-fields`,
        push: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKH9R.default), null);
};
const $3f52008d1cdfa258$export$cc3414a2d9daf70d = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3f52008d1cdfa258$var$ConnectAppsRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3f52008d1cdfa258$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3f52008d1cdfa258$export$246ec9cdadd2a163,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });

});

parcelRegister("01LdL", function(module, exports) {

$parcel$export(module.exports, "SERVICE_DESK_PRODUCT", () => $a51e57eb3887507b$export$5575497f0592ee94);
$parcel$export(module.exports, "defaultRedirectForSettings", () => $a51e57eb3887507b$export$c9b0516439c55d7a);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $a51e57eb3887507b$export$5575497f0592ee94 = 'servicedesk';
const $a51e57eb3887507b$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });

});


parcelRegister("7xqQs", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskDetailsRouteEntry", () => $ec64aa09583181df$export$6b37ff6fd616f383);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $7T78N = parcelRequire("7T78N");

var $6Z2mh = parcelRequire("6Z2mh");

var $jaAyo = parcelRequire("jaAyo");

var $bYT90 = parcelRequire("bYT90");
const $ec64aa09583181df$export$6b37ff6fd616f383 = (0, $7NszV.createEntry)((0, $7T78N.projectSettingsServicedeskDetailsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $bYT90.default),
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bYT90.LazyDetailsSettings)
        ]
    }));

});
parcelRegister("7T78N", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskDetailsRoute", () => $68e7499c720861f2$export$23583c23687c31c7);
const $68e7499c720861f2$export$23583c23687c31c7 = {
    name: 'project-settings-servicedesk-details',
    // /settings/details
    path: '/jira/servicedesk/projects/:projectKey/settings/details',
    exact: true
};

});

parcelRegister("bYT90", function(module, exports) {

$parcel$export(module.exports, "LazyDetailsSettings", () => $3746e6592757d8dd$export$6f16b5efddd5c646);
$parcel$export(module.exports, "default", () => $3746e6592757d8dd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $3746e6592757d8dd$export$6f16b5efddd5c646 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("DVmIc"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3746e6592757d8dd$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3746e6592757d8dd$export$6f16b5efddd5c646,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });

});


parcelRegister("peO7W", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskFieldsRouteEntry", () => $3c9b84b0d48a58a6$export$8a5eabbb292c5b39);

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $e7C7O = parcelRequire("e7C7O");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $coidL = parcelRequire("coidL");

var $6Z2mh = parcelRequire("6Z2mh");

var $6s1PB = parcelRequire("6s1PB");

var $3sOmz = parcelRequire("3sOmz");
const $3c9b84b0d48a58a6$var$isEfaExperimentExposed = ()=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    return expConfig.get('isEnabled', false);
};
const $3c9b84b0d48a58a6$export$8a5eabbb292c5b39 = (0, $7NszV.createEntry)((0, $coidL.projectSettingsServicedeskFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'project-settings.fields.jsm-tmp',
        component: (0, $7XYc4.componentWithCondition)($3c9b84b0d48a58a6$var$isEfaExperimentExposed, (0, $3sOmz.default), (0, $5lsNZ.default)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $e7C7O.fieldSettingsRelayResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3sOmz.LazyFieldsSettings)
        ]
    }));

});
parcelRegister("3sOmz", function(module, exports) {

$parcel$export(module.exports, "LazyFieldsSettings", () => $c77ac9be273e47d5$export$e309780f520d125a);
$parcel$export(module.exports, "default", () => $c77ac9be273e47d5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $c77ac9be273e47d5$export$e309780f520d125a = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lAb40"))), {
    moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c77ac9be273e47d5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c77ac9be273e47d5$export$e309780f520d125a,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });

});


parcelRegister("f1JiD", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesRouteEntry", () => $0936f5888a81e879$export$cf4a5eaa3cb7522f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6EgCy = parcelRequire("6EgCy");

var $6Z2mh = parcelRequire("6Z2mh");

var $5EbkJ = parcelRequire("5EbkJ");

var $cDJku = parcelRequire("cDJku");
const $0936f5888a81e879$export$cf4a5eaa3cb7522f = (0, $7NszV.createEntry)((0, $6EgCy.projectSettingsServicedeskIssuetypesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: (0, $cDJku.getUFOName)('project-settings-servicedesk-issuetypes'),
        component: (0, $5EbkJ.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5EbkJ.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("5EbkJ", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeSettings", () => $9d365377dbe2cbf1$export$36dcfb52d47cb93a);
$parcel$export(module.exports, "default", () => $9d365377dbe2cbf1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $9d365377dbe2cbf1$export$36dcfb52d47cb93a = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("72vEr"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9d365377dbe2cbf1$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9d365377dbe2cbf1$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

});

parcelRegister("cDJku", function(module, exports) {

$parcel$export(module.exports, "getUFOName", () => $3eab64ae9fcc418e$export$759ec9adbd19c936);
const $3eab64ae9fcc418e$var$ufoNamesMap = {
    'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
    'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
};
const $3eab64ae9fcc418e$export$759ec9adbd19c936 = (name)=>$3eab64ae9fcc418e$var$ufoNamesMap[name] || name;

});


parcelRegister("138gn", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesWorkflowRouteEntry", () => $f2cb7e5eb7db4222$export$a6c573e3904e9dbd);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $63HTu = parcelRequire("63HTu");

var $6Z2mh = parcelRequire("6Z2mh");

var $5EbkJ = parcelRequire("5EbkJ");

var $3i9aq = parcelRequire("3i9aq");
const $f2cb7e5eb7db4222$export$a6c573e3904e9dbd = (0, $7NszV.createEntry)((0, $63HTu.projectSettingsServicedeskIssuetypesWorkflowRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $3i9aq.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5EbkJ.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("63HTu", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesWorkflowRoute", () => $c901967b54883cb1$export$959cd36cc49d3b76);
const $c901967b54883cb1$export$959cd36cc49d3b76 = {
    name: 'project-settings-servicedesk-issuetypes-workflow',
    path: '/jira/servicedesk/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
    exact: true
};

});

parcelRegister("3i9aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $55da4849dbdf5d52$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $55da4849dbdf5d52$export$cb608e3696682e76 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lMJYe"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$55da4849dbdf5d52$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $55da4849dbdf5d52$export$cb608e3696682e76,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });

});


parcelRegister("fCX78", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskProformaJiraFormBuilderRouteEntry", () => $ce34267499de75f9$export$f7bbe7fb3eeb9258);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $CiTFA = parcelRequire("CiTFA");

var $6Z2mh = parcelRequire("6Z2mh");

var $aPBt5 = parcelRequire("aPBt5");
const $ce34267499de75f9$export$f7bbe7fb3eeb9258 = (0, $7NszV.createEntry)((0, $CiTFA.projectSettingsServicedeskProformaJiraFormBuilderRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $aPBt5.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aPBt5.LazyProjectSettingsProformaJiraFormBuilder)
        ],
        perfMetricKey: 'form-builder'
    }));

});
parcelRegister("CiTFA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskProformaJiraFormBuilderRoute", () => $1fa17d3fd833408f$export$f2a7862c8cde472d);
const $1fa17d3fd833408f$export$f2a7862c8cde472d = {
    name: 'project-settings-servicedesk-proforma-jira-form-builder',
    path: '/jira/servicedesk/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});

parcelRegister("aPBt5", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsProformaJiraFormBuilder", () => $5cc0224f486155a9$export$a7d63246a10aedd);
$parcel$export(module.exports, "default", () => $5cc0224f486155a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $5cc0224f486155a9$export$a7d63246a10aedd = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("foxIF")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5cc0224f486155a9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $5cc0224f486155a9$export$a7d63246a10aedd,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });

});


parcelRegister("6NqDk", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskProformaProjectFormsRouteEntry", () => $83fcac200820df4d$export$f0d9fbaec8a9f2a);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $59iBR = parcelRequire("59iBR");

var $6Z2mh = parcelRequire("6Z2mh");

var $6RowE = parcelRequire("6RowE");
const $83fcac200820df4d$export$f0d9fbaec8a9f2a = (0, $7NszV.createEntry)((0, $59iBR.projectSettingsServicedeskProformaProjectFormsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $6RowE.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6RowE.LazyProjectSettingsProformaProjectForms)
        ],
        perfMetricKey: 'forms-settings'
    }));

});
parcelRegister("6RowE", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsProformaProjectForms", () => $7c82c5f708d0cd7e$export$38414b624a749cec);
$parcel$export(module.exports, "default", () => $7c82c5f708d0cd7e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $7c82c5f708d0cd7e$export$38414b624a749cec = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("6bknD")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7c82c5f708d0cd7e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7c82c5f708d0cd7e$export$38414b624a749cec,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });

});


parcelRegister("hWZAC", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAccessRedirectRouteEntry", () => $fe3c44b562f5a007$export$7a0e75d9ac8038aa);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $kDaRO = parcelRequire("kDaRO");

var $6Z2mh = parcelRequire("6Z2mh");

var $p09kb = parcelRequire("p09kb");

var $01LdL = parcelRequire("01LdL");
const $fe3c44b562f5a007$export$7a0e75d9ac8038aa = (0, $7NszV.createEntry)((0, $kDaRO.projectSettingsServicedeskAccessRedirectRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $p09kb.peopleAccessRedirect)(`/jira/${(0, $01LdL.SERVICE_DESK_PRODUCT)}`),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $p09kb.LazyPeopleSettings)
        ]
    }));

});
parcelRegister("kDaRO", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAccessRedirectRoute", () => $8669efd5b368806c$export$115667ee60b1ec74);
const $8669efd5b368806c$export$115667ee60b1ec74 = {
    name: 'project-settings-servicedesk-access-redirect',
    path: '/jira/servicedesk/projects/:projectKey/settings/people',
    exact: true
};

});

parcelRegister("p09kb", function(module, exports) {

$parcel$export(module.exports, "LazyPeopleSettings", () => $3a1472a535e1ea00$export$7eee4f97b7a1273);
$parcel$export(module.exports, "peopleAccessRedirect", () => $3a1472a535e1ea00$export$45346ed2aa24e3f3);
$parcel$export(module.exports, "default", () => $3a1472a535e1ea00$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $7tQej = parcelRequire("7tQej");

const $3a1472a535e1ea00$export$7eee4f97b7a1273 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kwY5j"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});
const $3a1472a535e1ea00$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
        push: false
    });
const $3a1472a535e1ea00$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a1472a535e1ea00$var$PeopleAccessRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3a1472a535e1ea00$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3a1472a535e1ea00$export$7eee4f97b7a1273,
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });

});


parcelRegister("2kXpo", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAccessRouteEntry", () => $87f6949fc1184ba3$export$f7b56f6d0437146d);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $cAtSX = parcelRequire("cAtSX");

var $6Z2mh = parcelRequire("6Z2mh");

var $jaAyo = parcelRequire("jaAyo");

var $p09kb = parcelRequire("p09kb");
const $87f6949fc1184ba3$export$f7b56f6d0437146d = (0, $7NszV.createEntry)((0, $cAtSX.projectSettingsServicedeskAccessRoute), ()=>({
        group: 'project-settings-servicedesk',
        skeleton: (0, $jaAyo.ProjectSettingsAccessSkeleton),
        component: (0, $p09kb.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $p09kb.LazyPeopleSettings)
        ],
        ufoName: 'project-settings.access'
    }));

});

parcelRegister("fhlje", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAppsFieldsRouteEntry", () => $82144ad3cdad7a53$export$12f064da36fbd279);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $g49yz = parcelRequire("g49yz");

var $6Z2mh = parcelRequire("6Z2mh");

var $j9RuP = parcelRequire("j9RuP");
const $82144ad3cdad7a53$export$12f064da36fbd279 = (0, $7NszV.createEntry)((0, $g49yz.projectSettingsServicedeskAppsFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $j9RuP.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $j9RuP.LazyConnectAppControlsSettings)
        ]
    }));

});

parcelRegister("8to5X", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAppsRouteEntry", () => $0879ee567efffa41$export$d637c59982b0d896);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $fRJeY = parcelRequire("fRJeY");

var $6Z2mh = parcelRequire("6Z2mh");

var $cp0du = parcelRequire("cp0du");
const $0879ee567efffa41$export$d637c59982b0d896 = (0, $7NszV.createEntry)((0, $fRJeY.projectSettingsServicedeskAppsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $cp0du.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cp0du.LazyConnectAppsSettings)
        ]
    }));

});
parcelRegister("fRJeY", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAppsRoute", () => $d868c77dc879347a$export$ccc91c475c403d1a);
const $d868c77dc879347a$export$ccc91c475c403d1a = {
    name: 'project-settings-servicedesk-apps',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/:appId?',
    exact: true
};

});

parcelRegister("cp0du", function(module, exports) {

$parcel$export(module.exports, "LazyConnectAppsSettings", () => $841a04425f045e7e$export$3633e017e520a1c2);
$parcel$export(module.exports, "default", () => $841a04425f045e7e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $841a04425f045e7e$export$3633e017e520a1c2 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lXgsn"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$841a04425f045e7e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $841a04425f045e7e$export$3633e017e520a1c2,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });

});


parcelRegister("7B6VF", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationRouteEntry", () => $033d001835d92f56$export$7a0b8ca27efc7201);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $7HDop = parcelRequire("7HDop");

var $6Z2mh = parcelRequire("6Z2mh");

var $01Poo = parcelRequire("01Poo");

var $01LdL = parcelRequire("01LdL");
const $033d001835d92f56$export$7a0b8ca27efc7201 = (0, $7NszV.createEntry)((0, $7HDop.projectSettingsServicedeskAutomationRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: `project-settings-automation-${0, $01LdL.SERVICE_DESK_PRODUCT}`,
        component: (0, $01Poo.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $01Poo.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("01Poo", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", () => $f62e804ec9c6d7ed$export$dea5ad7e8eac12ae);
$parcel$export(module.exports, "default", () => $f62e804ec9c6d7ed$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $f62e804ec9c6d7ed$export$dea5ad7e8eac12ae = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("iSy68")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f62e804ec9c6d7ed$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f62e804ec9c6d7ed$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("dyGLN", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskDataClassificationsRouteEntry", () => $245c81b9a56de56f$export$5cea2172fd288382);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $jqtuR = parcelRequire("jqtuR");

var $6Z2mh = parcelRequire("6Z2mh");

var $jaAyo = parcelRequire("jaAyo");

var $6h9hV = parcelRequire("6h9hV");
const $245c81b9a56de56f$export$5cea2172fd288382 = (0, $7NszV.createEntry)((0, $jqtuR.projectSettingsServicedeskDataClassificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $6h9hV.default),
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6h9hV.LazyDataClassificationsSettings)
        ]
    }));

});
parcelRegister("jqtuR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskDataClassificationsRoute", () => $42b53ec38758c5f7$export$ec4d4f6583272cd);
const $42b53ec38758c5f7$export$ec4d4f6583272cd = {
    name: 'project-settings-servicedesk-data-classifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/data-classifications',
    exact: true
};

});

parcelRegister("6h9hV", function(module, exports) {

$parcel$export(module.exports, "LazyDataClassificationsSettings", () => $953aed1c2ae3d2f5$export$b8abcf8aa8f4df56);
$parcel$export(module.exports, "default", () => $953aed1c2ae3d2f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $953aed1c2ae3d2f5$export$b8abcf8aa8f4df56 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1LZO6"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$953aed1c2ae3d2f5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $953aed1c2ae3d2f5$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });

});


parcelRegister("gwCoT", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmFeaturesRouteEntry", () => $8c26b195513d6c20$export$40ca23d1e05da300);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6sNnq = parcelRequire("6sNnq");

var $jP54v = parcelRequire("jP54v");

var $6Z2mh = parcelRequire("6Z2mh");

var $bz1sy = parcelRequire("bz1sy");
const $8c26b195513d6c20$export$40ca23d1e05da300 = (0, $7NszV.createEntry)((0, $jP54v.projectSettingsServicedeskItsmFeaturesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jsm-features-settings',
        component: (0, $bz1sy.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $6sNnq.featuresResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bz1sy.LazyProjectSettingsServiceDeskItsmFeatures)
        ],
        perfMetricKey: 'jsm-features-settings'
    }));

});
parcelRegister("jP54v", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmFeaturesRoute", () => $444365caa1de116d$export$e60ffa2990540464);
const $444365caa1de116d$export$e60ffa2990540464 = {
    name: 'project-settings-servicedesk-itsm-features',
    path: '/jira/servicedesk/projects/:projectKey/settings/itsm-features',
    exact: true
};

});

parcelRegister("bz1sy", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskItsmFeatures", () => $402e11ff5e131d95$export$562be1021beb9882);
$parcel$export(module.exports, "default", () => $402e11ff5e131d95$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $402e11ff5e131d95$export$562be1021beb9882 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hqAjK"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-itsm-features/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$402e11ff5e131d95$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $402e11ff5e131d95$export$562be1021beb9882,
        pageId: "project-settings-itsm-features",
        shouldShowSpinner: true
    });

});
parcelRegister("hqAjK", function(module, exports) {

let $cb01094aa144d0a0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cb01094aa144d0a0$var$load("ay8u5").then(()=>parcelRequire('dWAhE'));

});



parcelRegister("bbdey", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsInternalNotificationsRouteEntry", () => $d5bc60012ecbb2c8$export$4a15f2c244cd196c);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2CYtL = parcelRequire("2CYtL");

var $6Z2mh = parcelRequire("6Z2mh");

var $f8FqB = parcelRequire("f8FqB");

var $e8N9g = parcelRequire("e8N9g");

var $jNJyR = parcelRequire("jNJyR");
const $d5bc60012ecbb2c8$export$4a15f2c244cd196c = (0, $7NszV.createEntry)((0, $2CYtL.projectSettingsServicedeskNotificationsInternalNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.internal-notifications',
        component: (0, $e8N9g.serviceDeskInternalNotificationsNextGenRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jNJyR.LazyProjectSettingsServiceDeskInternalNotifications),
            (0, $f8FqB.LazyInternalNotificationSettingsPage)
        ]
    }));

});
parcelRegister("f8FqB", function(module, exports) {

$parcel$export(module.exports, "LazyInternalNotificationSettingsPage", () => $c99d86239fe70688$export$501979bd6d492c43);

var $b7Svb = parcelRequire("b7Svb");

const $c99d86239fe70688$export$501979bd6d492c43 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("7GD38")), {
    moduleId: "./src/packages/servicedesk/notification-internal/src/ui/index.tsx"
});

});
parcelRegister("7GD38", function(module, exports) {

let $598abf128dee1b35$var$load = (parcelRequire("28QjX"))(4);
module.exports = $598abf128dee1b35$var$load("dBkhA").then(()=>parcelRequire('ZHF20'));

});


parcelRegister("e8N9g", function(module, exports) {

$parcel$export(module.exports, "serviceDeskInternalNotificationsNextGenRedirect", () => $68a880eb92a707c3$export$49625f83fe7ecc69);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $68a880eb92a707c3$export$49625f83fe7ecc69 = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/internal-notifications`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});

parcelRegister("jNJyR", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskInternalNotifications", () => $1956b65a2446b925$export$9c9d293dc6de29d0);
$parcel$export(module.exports, "default", () => $1956b65a2446b925$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $1956b65a2446b925$export$9c9d293dc6de29d0 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9P18X"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-internal-notifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1956b65a2446b925$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1956b65a2446b925$export$9c9d293dc6de29d0,
        pageId: "project-settings-internal-notifications",
        shouldShowSpinner: true
    });

});
parcelRegister("9P18X", function(module, exports) {

let $7269c388bfe1dd9b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7269c388bfe1dd9b$var$load("cYiLE").then(()=>parcelRequire('apjAt'));

});



parcelRegister("drVWM", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskInternalNotificationsNextGenRouteEntry", () => $a5004afda5310874$export$dfcd097af0ecd961);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $h6YNW = parcelRequire("h6YNW");

var $6Z2mh = parcelRequire("6Z2mh");

var $f8FqB = parcelRequire("f8FqB");

var $jNJyR = parcelRequire("jNJyR");
const $a5004afda5310874$export$dfcd097af0ecd961 = (0, $7NszV.createEntry)((0, $h6YNW.projectSettingsServicedeskInternalNotificationsNextGenRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.internal-notifications',
        component: (0, $jNJyR.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jNJyR.LazyProjectSettingsServiceDeskInternalNotifications),
            (0, $f8FqB.LazyInternalNotificationSettingsPage)
        ]
    }));

});

parcelRegister("t2WaR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRouteEntry", () => $fc3eddb4351c27ae$export$cc1164e0e5db595);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $buwAo = parcelRequire("buwAo");

var $6Z2mh = parcelRequire("6Z2mh");

var $6T6BC = parcelRequire("6T6BC");

var $k1jvb = parcelRequire("k1jvb");
const $fc3eddb4351c27ae$export$cc1164e0e5db595 = (0, $7NszV.createEntry)((0, $buwAo.projectSettingsServicedeskNotificationsNotificationEmailRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $k1jvb.ServiceDeskNotificationEmailNextGenRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $6T6BC.LazyProjectSettingsNotificationEmail)
        ]
    }));

});
parcelRegister("6T6BC", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsNotificationEmail", () => $6229d9dc67e508de$export$ea7d73c94d9369f4);
$parcel$export(module.exports, "default", () => $6229d9dc67e508de$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $6229d9dc67e508de$export$ea7d73c94d9369f4 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iEUeQ"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6229d9dc67e508de$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6229d9dc67e508de$export$ea7d73c94d9369f4,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });

});

parcelRegister("k1jvb", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskNotificationEmailNextGenRedirect", () => $060e0b1586db8e82$export$735e58642f560ddc);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $060e0b1586db8e82$export$735e58642f560ddc = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/notification-email`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});


parcelRegister("72XXS", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRouteEntry", () => $fd4b138cf89ddc30$export$ec0ead95e321b800);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $9ujoJ = parcelRequire("9ujoJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $6T6BC = parcelRequire("6T6BC");
const $fd4b138cf89ddc30$export$ec0ead95e321b800 = (0, $7NszV.createEntry)((0, $9ujoJ.projectSettingsServicedeskNotificationsEmailRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $6T6BC.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $6T6BC.LazyProjectSettingsNotificationEmail)
        ]
    }));

});

parcelRegister("yVmHw", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsRouteEntry", () => $a804e86b2cf06d23$export$20923f853e06d781);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $9D90J = parcelRequire("9D90J");

var $6Z2mh = parcelRequire("6Z2mh");

var $hJD3V = parcelRequire("hJD3V");
const $a804e86b2cf06d23$export$20923f853e06d781 = (0, $7NszV.createEntry)((0, $9D90J.projectSettingsServicedeskNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $hJD3V.notificationsRedirect)('customer-notifications'),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("9D90J", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsRoute", () => $f83be005a8f713dd$export$dbc53740e1d7ff79);
const $f83be005a8f713dd$export$dbc53740e1d7ff79 = {
    name: 'project-settings-servicedesk-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications',
    exact: true
};

});

parcelRegister("hJD3V", function(module, exports) {

$parcel$export(module.exports, "notificationsRedirect", () => $d3615143cfedd2aa$export$59144dd4441639fa);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $02Psx = parcelRequire("02Psx");

var $7tQej = parcelRequire("7tQej");
const $d3615143cfedd2aa$export$59144dd4441639fa = (pageUrlFragment)=>({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = projectKey !== null && projectKey !== undefined ? `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey)}/notifications/${pageUrlFragment}` : `/projects/${String(projectKey)}/settings/notifications/${pageUrlFragment}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: url,
            push: false
        });
    };

});
parcelRegister("02Psx", function(module, exports) {

$parcel$export(module.exports, "getNextgenSettingsUrl", () => $a59737cd16881573$export$26432406821aa7bf);
$parcel$export(module.exports, "getNextgenSettingsIssueTypesUrl", () => $a59737cd16881573$export$defee92e506aa306);
$parcel$export(module.exports, "getNextgenSettingsWorkflowUrl", () => $a59737cd16881573$export$9133e09a98a043dc);
$parcel$export(module.exports, "getNextgenSettingsJSDAutomationUrl", () => $a59737cd16881573$export$b0d20d18e0230e83);
$parcel$export(module.exports, "getClassicJSWSettingsUrl", () => $a59737cd16881573$export$ff0a17aa36a000df);
$parcel$export(module.exports, "getProjectSettingsDetailsUrl", () => $a59737cd16881573$export$16d52b9357bb73ab);
$parcel$export(module.exports, "getClassicIssueLayoutSettingsUrl", () => $a59737cd16881573$export$d531a9788343348f);
$parcel$export(module.exports, "getClassicRequestTypeLayoutSettingsUrl", () => $a59737cd16881573$export$dad567762dae162e);

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $2X0eJ = parcelRequire("2X0eJ");

var $3XO6n = parcelRequire("3XO6n");

var $gl0PU = parcelRequire("gl0PU");

var $1RLjE = parcelRequire("1RLjE");
const $a59737cd16881573$export$26432406821aa7bf = (projectType, projectKey)=>{
    const products = {
        [(0, $2vSU6.CORE_PROJECT)]: 'core',
        [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'servicedesk',
        [(0, $2vSU6.CUSTOMER_SERVICE_PROJECT)]: (0, $4R6GH.fg)('jcs_project_type_m3') ? 'servicedesk' : 'customerservice',
        [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
        [(0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)]: 'polaris'
    };
    const product = products[projectType];
    if (!product) {
        (0, $1RLjE.logError)((0, $3XO6n.PACKAGE_NAME), (0, $gl0PU.toErrorId)('urls'), (0, $gl0PU.toErrorMessage)(`Can't build default project settings url for project type: ${projectType}`), new Error(`Unexpected project type: ${projectType}`));
        // let's return classic url in that case
        return `/projects/${projectKey}/settings`;
    }
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return `/jira/${product}/projects/${projectKey}/ideas/settings`;
    return `/jira/${product}/projects/${projectKey}/settings`;
};
const $a59737cd16881573$export$defee92e506aa306 = (projectType, projectKey, issueTypeId, backLink)=>{
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}`;
    return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/issuetypes${issueTypeId ? `/${issueTypeId}` : ''}${(0, $2X0eJ.serializeBackLink)(backLink)}`;
};
const $a59737cd16881573$export$9133e09a98a043dc = (projectType, projectKey, issueTypeId)=>{
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/workflow`;
    return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/issuetypes/${issueTypeId}/workflow`;
};
const $a59737cd16881573$export$b0d20d18e0230e83 = (projectKey)=>`${$a59737cd16881573$export$26432406821aa7bf((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey)}/automation`;
const $a59737cd16881573$export$ff0a17aa36a000df = (projectKey)=>`/jira/software/c/projects/${projectKey}/settings`;
const $a59737cd16881573$export$16d52b9357bb73ab = (projectType, projectKey, isSimplified)=>{
    const urlBase = projectType === (0, $2vSU6.SOFTWARE_PROJECT) && !isSimplified ? $a59737cd16881573$export$ff0a17aa36a000df(projectKey) : $a59737cd16881573$export$26432406821aa7bf(projectType, projectKey);
    return `${urlBase}/details`;
};
const $a59737cd16881573$export$d531a9788343348f = ({ projectKey: projectKey, viewScreenId: viewScreenId, backLink: backLink })=>`/plugins/servlet/project-config/${projectKey}/issuelayout?screenId=${viewScreenId}${(0, $2X0eJ.serializeBackLink)(backLink)}`;
const $a59737cd16881573$export$dad567762dae162e = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/servicedesk/projects/${projectKey}/settings/request-types/request-type/${requestTypeId}${(0, $2X0eJ.serializeBackLink)(backLink)}`;

});
parcelRegister("2X0eJ", function(module, exports) {

$parcel$export(module.exports, "serializeBackLink", () => $b75ea0cca9bceab1$export$abebef1e474c32c5);
$parcel$export(module.exports, "getHrefWithBackLink", () => $b75ea0cca9bceab1$export$6d7b0d2d046b7fdd);
/**
 * When users complete task in SWIFT settings page, a UI flag shows and says "Go back to X"
 * This object configures the URL and _translated_ link text of the UI flag.
 *
 * If this backlink is not configured then SWIFT uses some default text ("Go to project") or similar.
 * Each project type has its own defaults: configured in Product features
 *
 * See https://hello.atlassian.net/wiki/spaces/JPCE/pages/700125807/SWIFT+backlinks
 */ const $b75ea0cca9bceab1$export$abebef1e474c32c5 = (backLink)=>{
    if (backLink == null) return '';
    const { url: url, title: title } = backLink;
    return `#backLinkUrl=${encodeURIComponent(url)}&backLinkTitle=${encodeURIComponent(title)}`;
};
const $b75ea0cca9bceab1$export$6d7b0d2d046b7fdd = (href, title)=>{
    if (!href || !href.length) return null;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname, search: search } = window.location;
    const backlinkData = {
        // url and title are not using encodeURIComponent here because it will be serialized later.
        url: `${pathname}${search}`,
        title: title
    };
    const backlink = $b75ea0cca9bceab1$export$abebef1e474c32c5(backlinkData);
    return `${href}${backlink}`;
};

});

parcelRegister("3XO6n", function(module, exports) {

$parcel$export(module.exports, "TASK", () => $594ec5369f29a734$export$9355e489ad16f98e);
$parcel$export(module.exports, "BUG", () => $594ec5369f29a734$export$bcf558c186108044);
$parcel$export(module.exports, "STORY", () => $594ec5369f29a734$export$1ea39a3ae330045);
$parcel$export(module.exports, "EPIC", () => $594ec5369f29a734$export$3cb4a99a332e4186);
$parcel$export(module.exports, "SUB_TASK", () => $594ec5369f29a734$export$a06f889861f6537d);
$parcel$export(module.exports, "CUSTOM", () => $594ec5369f29a734$export$952581bc40160893);
$parcel$export(module.exports, "TEMPLATES_WHITELIST", () => $594ec5369f29a734$export$dff1da4a9bab6d3e);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $594ec5369f29a734$export$39cd48613b53ce2f);
$parcel$export(module.exports, "DESCRIPTION_FIELD_TYPE", () => $594ec5369f29a734$export$56eae1056efd4899);
$parcel$export(module.exports, "ENVIRONMENT_FIELD_TYPE", () => $594ec5369f29a734$export$ca61f05d869b2ea3);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_NAME", () => $594ec5369f29a734$export$2ec42920a0df6b9a);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE", () => $594ec5369f29a734$export$40c10ba35ceb5c6b);
$parcel$export(module.exports, "JIRA_SERVICE_MANAGEMENT_APP_NAME", () => $594ec5369f29a734$export$a11dccbf88784c62);
$parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY_APP_NAME", () => $594ec5369f29a734$export$f35dc2e6deb1692e);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_APP_NAME", () => $594ec5369f29a734$export$b36025abb367eace);
$parcel$export(module.exports, "JIRA_APP_NAME", () => $594ec5369f29a734$export$ec5d0e43836cb3c7);
$parcel$export(module.exports, "toPackageName", () => $594ec5369f29a734$export$f31a652635bd75fe);
$parcel$export(module.exports, "PACKAGE_NAME", () => $594ec5369f29a734$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "NEW_FIELD_OPTION_PREFIX", () => $594ec5369f29a734$export$a2231d79966e0ccc);
$parcel$export(module.exports, "RADIO_FIELD_TYPE", () => $594ec5369f29a734$export$28a4bdf7d9b6f9);
$parcel$export(module.exports, "USERPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$9d758b3e8c6e0ed1);
$parcel$export(module.exports, "MULTIUSERPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$b0e37d421e006913);
$parcel$export(module.exports, "SELECT_FIELD_TYPE", () => $594ec5369f29a734$export$d77765147749db6b);
$parcel$export(module.exports, "CASCADINGSELECT_FIELD_TYPE", () => $594ec5369f29a734$export$42ef68d6bd555a8d);
$parcel$export(module.exports, "MULTISELECT_FIELD_TYPE", () => $594ec5369f29a734$export$4db6eb15b3c529cf);
$parcel$export(module.exports, "CHECKBOX_FIELD_TYPE", () => $594ec5369f29a734$export$ee975373b7797e8a);
$parcel$export(module.exports, "TEXT_FIELD_TYPE", () => $594ec5369f29a734$export$aa99342cc6a8ced5);
$parcel$export(module.exports, "NUMBER_FIELD_TYPE", () => $594ec5369f29a734$export$6f327bf99e20320);
$parcel$export(module.exports, "DATETIME_FIELD_TYPE", () => $594ec5369f29a734$export$dc64bdfdf9660a05);
$parcel$export(module.exports, "PROJECTPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$e6d73ed745b9a04);
$parcel$export(module.exports, "DATE_FIELD_TYPE", () => $594ec5369f29a734$export$d8b50f59220c7580);
$parcel$export(module.exports, "ASSETSPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$3a6f0a44478f1d2);
$parcel$export(module.exports, "LABELPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$68b76ef93df5a880);
$parcel$export(module.exports, "GROUPPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$e7773fccbeec45e6);
$parcel$export(module.exports, "MULTIGROUPPICKER_FIELD_TYPE", () => $594ec5369f29a734$export$b45487b145c52a37);
$parcel$export(module.exports, "VERSION_FIELD_TYPE", () => $594ec5369f29a734$export$48548129a6d117f5);
$parcel$export(module.exports, "MULTIVERSION_FIELD_TYPE", () => $594ec5369f29a734$export$722c271a9e11cb94);
$parcel$export(module.exports, "TEXTAREA_FIELD_TYPE", () => $594ec5369f29a734$export$33dbe2a903610aa1);
$parcel$export(module.exports, "emptyTenantContext", () => $594ec5369f29a734$export$ac655f5b3ff7b929);
// Issue Type Templates

var $lzeFL = parcelRequire("lzeFL");

var $5fc53 = parcelRequire("5fc53");

var $ldyPw = parcelRequire("ldyPw");

var $g5X3G = parcelRequire("g5X3G");

var $ef5Xn = parcelRequire("ef5Xn");

var $7qPn9 = parcelRequire("7qPn9");

var $5fc53 = parcelRequire("5fc53");
const $594ec5369f29a734$export$9355e489ad16f98e = 'task';
const $594ec5369f29a734$export$bcf558c186108044 = 'bug';
const $594ec5369f29a734$export$1ea39a3ae330045 = 'story';
const $594ec5369f29a734$export$3cb4a99a332e4186 = 'epic';
const $594ec5369f29a734$export$a06f889861f6537d = 'subtask';
const $594ec5369f29a734$export$952581bc40160893 = 'custom';
const $594ec5369f29a734$export$dff1da4a9bab6d3e = [
    $594ec5369f29a734$export$9355e489ad16f98e,
    $594ec5369f29a734$export$bcf558c186108044,
    $594ec5369f29a734$export$1ea39a3ae330045,
    $594ec5369f29a734$export$3cb4a99a332e4186
];
const $594ec5369f29a734$export$39cd48613b53ce2f = (0, $5fc53.TEXT_AREA_CF_TYPE);
const $594ec5369f29a734$export$56eae1056efd4899 = (0, $5fc53.DESCRIPTION_TYPE);
const $594ec5369f29a734$export$ca61f05d869b2ea3 = (0, $5fc53.ENVIRONMENT_TYPE);
const $594ec5369f29a734$export$2ec42920a0df6b9a = 'Story point estimate';
const $594ec5369f29a734$export$40c10ba35ceb5c6b = 'storyPointEstimate';
const $594ec5369f29a734$export$a4d3702d4c7481d6 = 44;
const $594ec5369f29a734$export$8a6a961f6caf7a8b = [
    $594ec5369f29a734$export$56eae1056efd4899,
    $594ec5369f29a734$export$39cd48613b53ce2f,
    $594ec5369f29a734$export$ca61f05d869b2ea3
];
const $594ec5369f29a734$export$e27914436cc13e3c = 'Jira Software';
const $594ec5369f29a734$export$a11dccbf88784c62 = 'Jira Service Management';
const $594ec5369f29a734$export$9f4aa232cbb6be46 = 'Jira Work Management';
const $594ec5369f29a734$export$b3c4739240716eb6 = 'Jira Ops';
const $594ec5369f29a734$export$f35dc2e6deb1692e = 'Jira Product Discovery';
const $594ec5369f29a734$export$b36025abb367eace = 'Jira Customer Service';
const $594ec5369f29a734$export$ec5d0e43836cb3c7 = 'Jira';
const $594ec5369f29a734$export$f31a652635bd75fe = (packageName)=>packageName;
const $594ec5369f29a734$export$b8b9d90f9e5bd72b = $594ec5369f29a734$export$f31a652635bd75fe('jiraProjectSettingsAppsCommon');
const $594ec5369f29a734$export$a2231d79966e0ccc = 'NEW_';
const $594ec5369f29a734$export$13dc44d2a9a248a4 = 'swift_openAddIssueTypeModal';
const $594ec5369f29a734$export$28a4bdf7d9b6f9 = 'radio';
const $594ec5369f29a734$export$9d758b3e8c6e0ed1 = 'userpicker';
const $594ec5369f29a734$export$b0e37d421e006913 = 'multiuserpicker';
const $594ec5369f29a734$export$d77765147749db6b = 'select';
const $594ec5369f29a734$export$42ef68d6bd555a8d = 'cascadingselect';
const $594ec5369f29a734$export$4db6eb15b3c529cf = 'multiselect';
const $594ec5369f29a734$export$ee975373b7797e8a = 'checkbox';
const $594ec5369f29a734$export$aa99342cc6a8ced5 = 'text';
const $594ec5369f29a734$export$6f327bf99e20320 = 'number';
const $594ec5369f29a734$export$dc64bdfdf9660a05 = 'datetime';
const $594ec5369f29a734$export$e6d73ed745b9a04 = 'projectpicker';
const $594ec5369f29a734$export$d8b50f59220c7580 = 'date';
const $594ec5369f29a734$export$3a6f0a44478f1d2 = 'assetspicker';
const $594ec5369f29a734$export$68b76ef93df5a880 = 'labelpicker';
const $594ec5369f29a734$export$e7773fccbeec45e6 = 'grouppicker';
const $594ec5369f29a734$export$b45487b145c52a37 = 'multigrouppicker';
const $594ec5369f29a734$export$48548129a6d117f5 = 'version';
const $594ec5369f29a734$export$722c271a9e11cb94 = 'multiversion';
const $594ec5369f29a734$export$33dbe2a903610aa1 = 'textarea';
const $594ec5369f29a734$export$ac655f5b3ff7b929 = ()=>({
        appEditions: (0, $ldyPw.populateApplicationEditions)(),
        appPermissions: (0, $7qPn9.populateApplicationPermissions)(),
        applicationKey: null,
        areProductSuggestionsEnabled: false,
        appUpdatesAvailable: null,
        atlassianAccountId: null,
        baseUrl: (0, $g5X3G.toBaseUrl)(''),
        cloudId: (0, $g5X3G.toCloudId)(''),
        activationId: (0, $g5X3G.toActivationId)(''),
        cloudName: (0, $g5X3G.toCloudName)(''),
        devopsProjectSignupSource: (0, $g5X3G.toDevopsProjectSignupSource)(''),
        environment: null,
        fabricActivityUrl: null,
        fabricNotificationLogUrl: null,
        fabricPfDirUrl: null,
        firstActivationDateMs: null,
        isAdmin: false,
        isAnonymous: false,
        isDevMode: false,
        isDevopsProjectCreationScenario: false,
        isMarketingOptOut: false,
        isSiteAdmin: false,
        languageTag: null,
        licenseStates: (0, $ef5Xn.populateApplicationLicenseStates)(),
        licensedProducts: {},
        locale: (0, $lzeFL.defaultLocale),
        loggedInUser: null,
        productCrossSellConfig: 'unknown',
        productEntitlementDetails: null,
        productPermissionGated: {
            core: false,
            software: false,
            serviceDesk: false,
            productDiscovery: false,
            customerService: false
        },
        siteAdminStatus: 'unknown',
        userFullname: null,
        xsrfToken: null,
        hasDlpEnabled: false,
        avpWorkspaceId: null
    });

});

parcelRegister("gl0PU", function(module, exports) {

$parcel$export(module.exports, "toErrorId", () => $b5e194c6e2cc34cd$export$706bbe4209d93dfe);
$parcel$export(module.exports, "toErrorMessage", () => $b5e194c6e2cc34cd$export$95506c204c060a3);
// Package name to be used in famaCatchAndLogFetchError and logError utils
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $b5e194c6e2cc34cd$export$706bbe4209d93dfe = (id)=>id;
const $b5e194c6e2cc34cd$export$95506c204c060a3 = (message)=>message;

});

parcelRegister("1RLjE", function(module, exports) {

$parcel$export(module.exports, "logError", () => $b0fc9ceb76f86c8e$export$58da9968c3170cb1);

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");
const $b0fc9ceb76f86c8e$export$58da9968c3170cb1 = (packageName, errorId, message, error, attributes)=>{
    // Send error log to analytics pipeline (i.e. SFX) and Sentry
    (0, $jcw0u.default)({
        meta: {
            packageName: packageName,
            id: errorId,
            teamName: 'morphinecake'
        },
        attributes: {
            ...attributes,
            message: message
        },
        error: error
    });
    // Send error log to Splunk
    // We use this instead of `sendToPrivacyUnsafeSplunk` to preserve error message and custom properties
    const location = `${packageName}.${errorId}`;
    (0, $dJl1T.default).unsafeErrorWithCustomerData(location, message, error);
};

});




parcelRegister("ljDIh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLanguageKeyRouteEntry", () => $2ca289138c55c124$export$db3a99044f906462);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $e4oBS = parcelRequire("e4oBS");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $k7tsS = parcelRequire("k7tsS");

var $lAfKa = parcelRequire("lAfKa");
const $2ca289138c55c124$export$db3a99044f906462 = (0, $7NszV.createEntry)((0, $e4oBS.projectSettingsServicedeskLanguageKeyRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.translations',
        component: (0, $lAfKa.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $k7tsS.languageTranslationsResource),
            (0, $k7tsS.outgoingEmailStateModelResource)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).LANGUAGE_SETTINGS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).LANGUAGE_SETTINGS),
                teamName: 'jsm-banana'
            }
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lAfKa.LazyProjectSettingsServiceDeskLanguageTranslations)
        ],
        perfMetricKey: 'jsm-language-translations'
    }));

});
parcelRegister("e4oBS", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLanguageKeyRoute", () => $8a798ea346394d71$export$194a3f27b07aafec);
const $8a798ea346394d71$export$194a3f27b07aafec = {
    name: 'project-settings-servicedesk-language-key',
    path: '/jira/servicedesk/projects/:projectKey/settings/language/:languageKey/:sidebarItemKey?'
};

});

parcelRegister("k7tsS", function(module, exports) {

$parcel$export(module.exports, "languageTranslationsResource", () => $ffad7a39054feef3$export$f51887e33895eab9);
$parcel$export(module.exports, "outgoingEmailStateModelResource", () => $ffad7a39054feef3$export$c460156a7e6b85b2);

var $2M1hQ = parcelRequire("2M1hQ");
const $ffad7a39054feef3$export$9f529be3aeae01ea = 'JSM Language Translations';
const $ffad7a39054feef3$export$ecd381e388e8c56f = "Language Support Customer Notification's Outgoing Email State";

const $ffad7a39054feef3$export$f51887e33895eab9 = (0, $2M1hQ.createResource)({
    type: 'Language Translations',
    getKey: ({ match: { params: { projectKey: projectKey, languageKey: languageKey } } })=>`${$ffad7a39054feef3$export$9f529be3aeae01ea}-${projectKey}-${languageKey}`,
    getDataLoader: ()=>(parcelRequire("8cPk6")),
    maxAge: Infinity
});

const $ffad7a39054feef3$export$c460156a7e6b85b2 = (0, $2M1hQ.createResource)({
    type: 'Outgoing Email State Model',
    getKey: ()=>`${$ffad7a39054feef3$export$ecd381e388e8c56f}`,
    getDataLoader: ()=>(parcelRequire("cjHww")),
    maxAge: Infinity
});

});
parcelRegister("8cPk6", function(module, exports) {

let $5f97417493ba58fe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5f97417493ba58fe$var$load("4BYvo").then(()=>parcelRequire('3m5cp'));

});

parcelRegister("cjHww", function(module, exports) {

let $8f7905411a0d9277$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8f7905411a0d9277$var$load("hn2iP").then(()=>parcelRequire('49aS0'));

});


parcelRegister("lAfKa", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskLanguageTranslations", () => $818bcbaaddc8bfd3$export$c029d3f514c7b3e0);
$parcel$export(module.exports, "default", () => $818bcbaaddc8bfd3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $818bcbaaddc8bfd3$export$c029d3f514c7b3e0 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("3oAzU")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-translations/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$818bcbaaddc8bfd3$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $818bcbaaddc8bfd3$export$c029d3f514c7b3e0,
        pageId: "project-settings-language-translations",
        shouldShowSpinner: true
    });

});
parcelRegister("3oAzU", function(module, exports) {

let $278ffca6f3b3c311$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $278ffca6f3b3c311$var$load("h2MrD"),
    $278ffca6f3b3c311$var$load("bYT2S"),
    $278ffca6f3b3c311$var$load("dsiAd"),
    $278ffca6f3b3c311$var$load("7tltX")
]).then(()=>parcelRequire('kG5x5'));

});



parcelRegister("lAnjX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLanguageRouteEntry", () => $bffa1bbc0966d026$export$576b048795cbefad);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $jZ1W8 = parcelRequire("jZ1W8");

var $6Z2mh = parcelRequire("6Z2mh");

var $6xGbx = parcelRequire("6xGbx");

var $lAfKa = parcelRequire("lAfKa");
const $bffa1bbc0966d026$export$576b048795cbefad = (0, $7NszV.createEntry)((0, $jZ1W8.projectSettingsServicedeskLanguageRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.languages',
        component: (0, $6xGbx.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lAfKa.LazyProjectSettingsServiceDeskLanguageTranslations)
        ]
    }));

});
parcelRegister("jZ1W8", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLanguageRoute", () => $171e592762201788$export$99b0bbae92462ac2);
const $171e592762201788$export$99b0bbae92462ac2 = {
    name: 'project-settings-servicedesk-language',
    path: '/jira/servicedesk/projects/:projectKey/settings/language',
    exact: true
};

});

parcelRegister("6xGbx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c45ee4ab52677ce$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $4c45ee4ab52677ce$export$213b8279037c9d98 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9A4fc"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-support/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4c45ee4ab52677ce$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4c45ee4ab52677ce$export$213b8279037c9d98,
        pageId: "project-settings-language-support",
        shouldShowSpinner: true
    });

});
parcelRegister("9A4fc", function(module, exports) {

let $6f9ac4a158786b32$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6f9ac4a158786b32$var$load("3JNwJ").then(()=>parcelRequire('4yiYq'));

});



parcelRegister("cONlw", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsPermissionsNextGenRouteEntry", () => $4964340980955d47$export$65a2b00cdeff4516);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $10cgn = parcelRequire("10cgn");

var $8pE1n = parcelRequire("8pE1n");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $tQ1zW = parcelRequire("tQ1zW");

var $aZDos = parcelRequire("aZDos");
const $4964340980955d47$export$65a2b00cdeff4516 = (0, $7NszV.createEntry)((0, $8pE1n.projectSettingsServicedeskChannelsPermissionsNextGenRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $tQ1zW.customerPermissionsRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $10cgn.customerPermissionsPageDataResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aZDos.LazyProjectSettingsServiceDeskCustomerPermissions)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CUSTOMER_PERMISSIONS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CUSTOMER_PERMISSIONS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        perfMetricKey: 'jsm-customer-permissions'
    }));

});
parcelRegister("10cgn", function(module, exports) {

$parcel$export(module.exports, "customerPermissionsPageDataResource", () => $35508436fc3abfb3$export$ae3446385906310c);

var $2M1hQ = parcelRequire("2M1hQ");


const $35508436fc3abfb3$export$ae3446385906310c = (0, $2M1hQ.createResource)({
    type: (0, $9cf87aec7862b8b9$export$34a89f9aaa677bb5),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("cELA6")),
    maxAge: Infinity
});

});
const $9cf87aec7862b8b9$export$34a89f9aaa677bb5 = 'CUSTOMER_PERMISSIONS';

parcelRegister("cELA6", function(module, exports) {

let $936e2119920001df$var$load = (parcelRequire("28QjX"))(4);
module.exports = $936e2119920001df$var$load("3ygSW").then(()=>parcelRequire('i9zBn'));

});


parcelRegister("tQ1zW", function(module, exports) {

$parcel$export(module.exports, "customerPermissionsRedirect", () => $467404e10c7e501f$export$59eedcca37dbbafd);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $467404e10c7e501f$export$59eedcca37dbbafd = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-permissions`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});

parcelRegister("aZDos", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskCustomerPermissions", () => $8d9798e9d24a9632$export$5367e40a24f0bd54);
$parcel$export(module.exports, "default", () => $8d9798e9d24a9632$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $8d9798e9d24a9632$export$5367e40a24f0bd54 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8xlYl"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-permissions/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8d9798e9d24a9632$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8d9798e9d24a9632$export$5367e40a24f0bd54,
        pageId: "project-settings-customer-permissions",
        shouldShowSpinner: true
    });

});
parcelRegister("8xlYl", function(module, exports) {

let $63727305a8693536$var$load = (parcelRequire("28QjX"))(4);
module.exports = $63727305a8693536$var$load("gNC9e").then(()=>parcelRequire('3eQYY'));

});



parcelRegister("28AFT", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskCustomerPermissionsRouteEntry", () => $35c7869995fcce58$export$ed034e5245184767);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $10cgn = parcelRequire("10cgn");

var $fdCkK = parcelRequire("fdCkK");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $aZDos = parcelRequire("aZDos");
const $35c7869995fcce58$export$ed034e5245184767 = (0, $7NszV.createEntry)((0, $fdCkK.projectSettingsServicedeskCustomerPermissionsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $aZDos.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $10cgn.customerPermissionsPageDataResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aZDos.LazyProjectSettingsServiceDeskCustomerPermissions)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CUSTOMER_PERMISSIONS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CUSTOMER_PERMISSIONS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        perfMetricKey: 'jsm-customer-permissions'
    }));

});

parcelRegister("gsEXA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsEmailNextGenRouteEntry", () => $61a4779d190eed13$export$b4590bec09451e4c);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $hOElL = parcelRequire("hOElL");

var $6Z2mh = parcelRequire("6Z2mh");

var $vzOOJ = parcelRequire("vzOOJ");

var $3VKX1 = parcelRequire("3VKX1");
const $61a4779d190eed13$export$b4590bec09451e4c = (0, $7NszV.createEntry)((0, $hOElL.projectSettingsServicedeskChannelsEmailNextGenRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $vzOOJ.serviceDeskEmailNextGenRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3VKX1.LazyProjectSettingsServiceDeskEmail)
        ]
    }));

});
parcelRegister("hOElL", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsEmailNextGenRoute", () => $a6fdffc3a6348da0$export$89c7bf2bac1464c2);
const $a6fdffc3a6348da0$export$89c7bf2bac1464c2 = {
    name: 'project-settings-servicedesk-channels-email-next-gen',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/email',
    exact: true
};

});

parcelRegister("vzOOJ", function(module, exports) {

$parcel$export(module.exports, "serviceDeskEmailNextGenRedirect", () => $f10a7d047f1802a3$export$86c8da903fb97c4f);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $f10a7d047f1802a3$export$86c8da903fb97c4f = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/email`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});

parcelRegister("3VKX1", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskEmail", () => $881ebeec1a2867ea$export$66d0c668045080de);
$parcel$export(module.exports, "default", () => $881ebeec1a2867ea$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kKHTt = parcelRequire("kKHTt");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $881ebeec1a2867ea$export$66d0c668045080de = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("fHXdv")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$881ebeec1a2867ea$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKHTt.HelpCenterSettingsRedirect), {
        page: "email"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $881ebeec1a2867ea$export$66d0c668045080de,
        pageId: "project-settings-email",
        shouldShowSpinner: true
    }));

});
parcelRegister("kKHTt", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsRedirect", () => $ebd0dfae741c0d7b$export$a24ec33acfeae48d);

var $k9rcv = parcelRequire("k9rcv");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $ds5qV = parcelRequire("ds5qV");

var $lODMY = parcelRequire("lODMY");

var $dAfqg = parcelRequire("dAfqg");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");

var $7XYc4 = parcelRequire("7XYc4");

var $ioBMu = parcelRequire("ioBMu");

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $aTz47 = parcelRequire("aTz47");

var $jEJ7g = parcelRequire("jEJ7g");

var $8WSu7 = parcelRequire("8WSu7");

var $jagxb = parcelRequire("jagxb");
const $ebd0dfae741c0d7b$export$c224e724e933fbea = (page, pathname)=>{
    if (page === 'customer-notifications') {
        const customerNotificationsPage = pathname.split('/settings/customer-notifications')[1];
        if (customerNotificationsPage === '/template') return 'customer-notifications-template';
        if (customerNotificationsPage === '/account-notification/invite-customer') return 'customer-notifications-invite-customer';
        if (/rule\/\d+/.test(customerNotificationsPage)) return 'customer-notifications-rule';
    }
    return page;
};
const $ebd0dfae741c0d7b$export$2d1034e371a567c6 = (page, pathname, helpCenterId)=>{
    switch(page){
        case 'kb':
            return (0, $8WSu7.getSettingsPath)(pathname.replace('/confluence-kb', '/kb'), true, helpCenterId);
        default:
            return (0, $8WSu7.getSettingsPath)(pathname, true, helpCenterId);
    }
};
const $ebd0dfae741c0d7b$var$useLocation = (0, $lODMY.createRouterSelector)((state)=>state.location);
const $ebd0dfae741c0d7b$export$b90b599f4b180ba = ({ page: page, children: children })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const useLocationOld = (0, $lODMY.createRouterSelector)((state)=>state.location);
    const location = useLocationOld();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const isJCS = (0, $jEJ7g.useIsJCSProjectType)(projectContext?.projectType);
    (0, $5uXOq.useEffect)(()=>{
        if (isJCS && !(0, $aTz47.isHelpCenterSettingsPath)()) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectSettingsToHelpCenterSettings redirected', {
                page: $ebd0dfae741c0d7b$export$c224e724e933fbea(page, location.pathname)
            });
            showFlag({
                messageId: 'servicedesk-customer-service-common.ui.help-center-settings-redirect.show-flag.error',
                messageType: 'transactional',
                type: 'error',
                title: formatMessage((0, $jagxb.default).errorTitle),
                description: formatMessage((0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $jagxb.default).description : (0, $jagxb.default).errorDescription),
                isAutoDismiss: true
            });
        }
    }, [
        createAnalyticsEvent,
        formatMessage,
        isJCS,
        location.pathname,
        page,
        showFlag
    ]);
    if (isJCS && !(0, $aTz47.isHelpCenterSettingsPath)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/helpcenter"
    });
    return children;
};
const $ebd0dfae741c0d7b$export$4e0587d8c8738b4d = ({ page: page, children: children })=>{
    const location = $ebd0dfae741c0d7b$var$useLocation();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const isJCS = projectContext?.projectType === (0, $2vSU6.CUSTOMER_SERVICE_PROJECT);
    (0, $5uXOq.useEffect)(()=>{
        if (isJCS && !(0, $aTz47.isHelpCenterSettingsPath)()) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectSettingsToHelpCenterSettings redirected', {
            page: $ebd0dfae741c0d7b$export$c224e724e933fbea(page, location.pathname)
        });
    }, [
        createAnalyticsEvent,
        isJCS,
        location.pathname,
        page
    ]);
    if (isJCS && !(0, $aTz47.isHelpCenterSettingsPath)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ebd0dfae741c0d7b$export$b65700afa6ae3ae9, {
        page: page,
        pathname: location.pathname,
        projectId: projectContext.projectId
    });
    return children;
};
const $ebd0dfae741c0d7b$export$b65700afa6ae3ae9 = ({ page: page, pathname: pathname, projectId: projectId })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const activationId = (0, $fY39E.useActivationId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const jiraProjectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    const jiraWorkspaceAri = `ari:cloud:jira:${cloudId}:workspace/${activationId}`;
    const { helpCenter: { helpCenterByHoistedProjectIdRouted: helpCenter } } = (0, $8Uumt.useLazyLoadQuery)((0, $k9rcv.default), {
        cloudId: cloudId,
        jiraProjectAri: jiraProjectAri,
        jiraWorkspaceAri: jiraWorkspaceAri
    });
    if (helpCenter.__typename !== 'HelpCenter') {
        showFlag({
            messageId: 'servicedesk-customer-service-common.ui.help-center-settings-redirect.show-flag.error.1',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage((0, $jagxb.default).errorTitle),
            description: formatMessage((0, $jagxb.default).errorDescription),
            isAutoDismiss: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
            to: "/jira/helpcenter"
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: $ebd0dfae741c0d7b$export$2d1034e371a567c6(page, pathname, (0, $ioBMu.HelpHelpCenterAri).parse(helpCenter.id).helpCenterId),
        persistSearchParams: true
    });
};
const $ebd0dfae741c0d7b$export$a24ec33acfeae48d = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jcs_project_type_m3'), $ebd0dfae741c0d7b$export$4e0587d8c8738b4d, $ebd0dfae741c0d7b$export$b90b599f4b180ba);

});
parcelRegister("k9rcv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3d97065ff4628c3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a71e1d1b1dbf7cb82e4e714dfd62b93>>
 * @relayHash e13196a4072c1e05f1d5cb92fe604cee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d94a9943ce2554eb8cf7db62a3d014b0ef4ffb159df3aec135c71cb712c22610
const $e3d97065ff4628c3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraProjectAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraWorkspaceAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "projectAri",
            "variableName": "jiraProjectAri"
        },
        {
            "kind": "Variable",
            "name": "workspaceAri",
            "variableName": "jiraWorkspaceAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": v4 /*: any*/ ,
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "helpCenterSettingsRedirectQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "HelpCenterQueryApi",
                        "kind": "LinkedField",
                        "name": "helpCenter",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterByHoistedProjectIdRouted",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "helpCenter.helpCenterByHoistedProjectIdRouted"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "helpCenter"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "helpCenterSettingsRedirectQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterByHoistedProjectIdRouted",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v4 /*: any*/ ,
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d94a9943ce2554eb8cf7db62a3d014b0ef4ffb159df3aec135c71cb712c22610",
            "metadata": {},
            "name": "helpCenterSettingsRedirectQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e3d97065ff4628c3$var$node.hash = "87969f8d9448b730bb329d59f60087f6";
var $e3d97065ff4628c3$export$2e2bcd8739ae039 = $e3d97065ff4628c3$var$node;

});

parcelRegister("ioBMu", function(module, exports) {

$parcel$export(module.exports, "HelpHelpCenterAri", () => $d647c66cee85d7d1$export$a75f3c98d930b258);

var $2DmWN = parcelRequire("2DmWN");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/help/help-center/manifest.ts
var $d647c66cee85d7d1$var$helpHelpCenterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $2DmWN.HelpHelpCenterAriResourceOwner),
    resourceType: (0, $2DmWN.HelpHelpCenterAriResourceType),
    resourceIdSlug: "{activationId}/{helpCenterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        helpCenterId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/help/help-center/index.ts
var $d647c66cee85d7d1$export$a75f3c98d930b258 = class _HelpHelpCenterAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._activationId = opts.resourceIdSegmentValues.activationId, this._helpCenterId = opts.resourceIdSegmentValues.helpCenterId;
    }
    get activationId() {
        return this._activationId;
    }
    get helpCenterId() {
        return this._helpCenterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d647c66cee85d7d1$var$helpHelpCenterAriStaticOpts.qualifier,
            platformQualifier: $d647c66cee85d7d1$var$helpHelpCenterAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $d647c66cee85d7d1$var$helpHelpCenterAriStaticOpts.resourceOwner,
            resourceType: $d647c66cee85d7d1$var$helpHelpCenterAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.helpCenterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                helpCenterId: opts.helpCenterId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $d647c66cee85d7d1$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $d647c66cee85d7d1$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            helpCenterId: this.helpCenterId
        };
    }
};

});
parcelRegister("2DmWN", function(module, exports) {

$parcel$export(module.exports, "HelpHelpCenterAriResourceOwner", () => $1eb1062b37145e8a$export$a4af98a27b4568ee);
$parcel$export(module.exports, "HelpHelpCenterAriResourceType", () => $1eb1062b37145e8a$export$f6271ed6947e9084);
// src/help/help-center/types.ts
var $1eb1062b37145e8a$export$a4af98a27b4568ee = "help", $1eb1062b37145e8a$export$f6271ed6947e9084 = "help-center";

});


parcelRegister("aTz47", function(module, exports) {

$parcel$export(module.exports, "isHelpCenterSettingsPath", () => $1e0d45f36b27f85a$export$bf8b98b87d485657);
$parcel$export(module.exports, "getHelpCenterUUIDFromPath", () => $1e0d45f36b27f85a$export$73a9fbfd9155f593);

var $gKZoD = parcelRequire("gKZoD");

var $4R6GH = parcelRequire("4R6GH");
const $1e0d45f36b27f85a$export$bf8b98b87d485657 = ()=>{
    (0, $gKZoD.di)(window);
    if (!(0, $4R6GH.fg)('jcs_master_flag')) return false;
    if (!false) return window.location.pathname.includes('jira/helpcenter/');
    return false;
};
const $1e0d45f36b27f85a$export$73a9fbfd9155f593 = ()=>{
    (0, $gKZoD.di)(window);
    if (!$1e0d45f36b27f85a$export$bf8b98b87d485657()) return '';
    if (!false) return window.location.pathname.match(/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/)?.[0];
    return '';
};

});

parcelRegister("jEJ7g", function(module, exports) {

$parcel$export(module.exports, "useAsyncIsJCS", () => $db67bf04078e8532$export$3894a8f24b665478);
$parcel$export(module.exports, "isJCSProjectType", () => $db67bf04078e8532$export$25e1541dd4631818);
$parcel$export(module.exports, "useIsJCSProjectType", () => $db67bf04078e8532$export$b78b0f34fdacd97a);
$parcel$export(module.exports, "isJCSTemplate", () => $db67bf04078e8532$export$afee907b7a66ef2b);

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");

var $O4MMs = parcelRequire("O4MMs");

var $2vSU6 = parcelRequire("2vSU6");
const $db67bf04078e8532$var$useIsJCSProjectTypeFallback = (projectType, isAsync)=>{
    const isJCS = $db67bf04078e8532$export$3894a8f24b665478();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return isAsync ? isJCS : Boolean(isJCS);
};
const $db67bf04078e8532$export$25e1541dd4631818 = (projectType)=>projectType === (0, $2vSU6.CUSTOMER_SERVICE_PROJECT) && (0, $4R6GH.fg)('jcs_project_type_m3');
const $db67bf04078e8532$export$4b74a6f22da4a0d2 = (projectType)=>projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) || $db67bf04078e8532$export$25e1541dd4631818(projectType);
const $db67bf04078e8532$export$b78b0f34fdacd97a = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_project_type_m3'), $db67bf04078e8532$export$25e1541dd4631818, $db67bf04078e8532$var$useIsJCSProjectTypeFallback);
//
//  M2 helpers, deprecated
// ---------------------
const $db67bf04078e8532$var$useIsJCSUnderFF = ()=>{
    const { 'initial.project.template.name': initialProjectTemplate } = (0, $O4MMs.useProjectProperties)([
        'initial.project.template.name'
    ]);
    return initialProjectTemplate === 'com.atlassian.jcs:customer-service-management';
};
const $db67bf04078e8532$export$927b5354181b3adf = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_master_flag'), $db67bf04078e8532$var$useIsJCSUnderFF, ()=>false);
// Undefined can be used to check if project properties has been resolved or not
const $db67bf04078e8532$var$useAsyncIsJCSUnderFF = ()=>{
    const { 'initial.project.template.name': initialProjectTemplate } = (0, $O4MMs.useProjectProperties)([
        'initial.project.template.name'
    ]);
    return initialProjectTemplate ? initialProjectTemplate === 'com.atlassian.jcs:customer-service-management' : undefined;
};
const $db67bf04078e8532$export$3894a8f24b665478 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_master_flag'), $db67bf04078e8532$var$useAsyncIsJCSUnderFF, ()=>false);
const $db67bf04078e8532$var$isJCSTemplateUnderFF = (template)=>template === 'com.atlassian.jcs:customer-service-management';
const $db67bf04078e8532$var$isJCSTemplateFallback = (template)=>false;
const $db67bf04078e8532$export$afee907b7a66ef2b = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_master_flag'), $db67bf04078e8532$var$isJCSTemplateUnderFF, $db67bf04078e8532$var$isJCSTemplateFallback);

});
parcelRegister("O4MMs", function(module, exports) {

$parcel$export(module.exports, "useProjectProperties", () => $eccdf8f1b49d4032$export$58be98885c2d686a);

var $5uXOq = parcelRequire("5uXOq");

var $74ySO = parcelRequire("74ySO");

var $ajpes = parcelRequire("ajpes");

var $4f8Oj = parcelRequire("4f8Oj");

var $lpwtK = parcelRequire("lpwtK");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $dYZ0w = parcelRequire("dYZ0w");
const $eccdf8f1b49d4032$export$d4c72bab9d6cc13a = {};
const $eccdf8f1b49d4032$var$Store = (0, $iXqE5.createStore)({
    name: 'project-properties',
    initialState: $eccdf8f1b49d4032$export$d4c72bab9d6cc13a,
    actions: $dYZ0w.actions
});
const $eccdf8f1b49d4032$export$eebf791068e870dd = (0, $3sQ5x.createHook)($eccdf8f1b49d4032$var$Store);
const $eccdf8f1b49d4032$export$58be98885c2d686a = (propertyKeys, projectIdOverride)=>{
    const { data: data } = (0, $lpwtK.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const projectId = projectIdOverride !== undefined ? projectIdOverride : data?.id && `${data.id}`;
    const [state, { get: get }] = $eccdf8f1b49d4032$export$eebf791068e870dd();
    const prevPropertyKeys = (0, $1XJ20.usePrevious)(propertyKeys);
    (0, $5uXOq.useEffect)(()=>{
        if (projectId === undefined) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraProjectPropertiesServices undefinedProjectId');
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(propertyKeys, prevPropertyKeys) && !projectIdOverride) return;
        if (projectId) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        get(projectId, propertyKeys);
    }, [
        projectId,
        propertyKeys,
        prevPropertyKeys,
        get,
        createAnalyticsEvent,
        projectIdOverride
    ]);
    return projectId !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))(state[projectId], (_, key)=>(0, (/*@__PURE__*/$parcel$interopDefault($74ySO)))(propertyKeys, key)) : {};
};

});
parcelRegister("74ySO", function(module, exports) {

var $2wwA6 = parcelRequire("2wwA6");

var $hTJwX = parcelRequire("hTJwX");

var $agVdz = parcelRequire("agVdz");

var $kPZpS = parcelRequire("kPZpS");

var $dMEgP = parcelRequire("dMEgP");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5263f72d78aeaf9c$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $5263f72d78aeaf9c$var$includes(collection, value, fromIndex, guard) {
    collection = $hTJwX(collection) ? collection : $dMEgP(collection);
    fromIndex = fromIndex && !guard ? $kPZpS(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $5263f72d78aeaf9c$var$nativeMax(length + fromIndex, 0);
    return $agVdz(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $2wwA6(collection, value, fromIndex) > -1;
}
module.exports = $5263f72d78aeaf9c$var$includes;

});

parcelRegister("dYZ0w", function(module, exports) {

$parcel$export(module.exports, "actions", () => $d36e01b4b5883936$export$e324594224ef24da);

var $9Tr6m = parcelRequire("9Tr6m");
const $d36e01b4b5883936$export$e324594224ef24da = {
    get: $9Tr6m.get
};

});
parcelRegister("9Tr6m", function(module, exports) {

$parcel$export(module.exports, "get", () => $52dc90cc0afc52f4$export$3988ae62b71be9a3);

var $k8IPx = parcelRequire("k8IPx");

var $cjFoH = parcelRequire("cjFoH");

var $66FNL = parcelRequire("66FNL");

var $fUPWG = parcelRequire("fUPWG");
const $52dc90cc0afc52f4$export$3988ae62b71be9a3 = (projectId, properties)=>({ getState: getState, setState: setState })=>{
        const currentProperties = getState()[projectId] || {};
        const missingProperties = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(properties, (0, (/*@__PURE__*/$parcel$interopDefault($66FNL)))(currentProperties));
        missingProperties.length && (0, $fUPWG.default)({
            baseUrl: '',
            projectId: projectId,
            properties: missingProperties
        }).then((fetchedProperties)=>{
            const latestProperties = getState()[projectId] || {};
            setState({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [projectId]: {
                    ...latestProperties,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    ...missingProperties.reduce((result, name)=>{
                        const reducedResult = result;
                        const fetchedProperty = fetchedProperties[name];
                        // `undefined` inside state means that property was never requested.
                        // If value returned for the property is `undefined`, we will set it to `null`,
                        // to differentiate it from the unrequested state. Otherwise, returned value will be set.
                        reducedResult[name] = (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH)))(fetchedProperty) ? null : fetchedProperty;
                        return reducedResult;
                    }, {})
                }
            });
        });
    };

});
parcelRegister("fUPWG", function(module, exports) {

$parcel$export(module.exports, "default", () => $573d8b462e0e2ec6$export$2e2bcd8739ae039);

var $1sYcL = parcelRequire("1sYcL");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$573d8b462e0e2ec6$export$2e2bcd8739ae039 = async ({ baseUrl: baseUrl, projectId: projectId, properties: properties })=>{
    const { project: project } = await (0, $1sYcL.get)(baseUrl, {
        projectId: projectId,
        projectProperties: properties,
        consumerMeta: {
            id: 'remoteGet',
            packageName: 'jiraProjectPropertiesServices',
            teamName: 'jsd-shield'
        }
    });
    return project;
};

});





parcelRegister("8WSu7", function(module, exports) {

$parcel$export(module.exports, "getSettingsPath", () => $b4b4e7a1fd793539$export$67417cd3aaee582d);

var $4R6GH = parcelRequire("4R6GH");
const $b4b4e7a1fd793539$export$67417cd3aaee582d = (path, isJCS, helpCenterId)=>{
    if (!helpCenterId) return isJCS ? path.replace('/jira/servicedesk/', '/jira/helpcenter/') : path;
    return (0, $4R6GH.fg)('berry-4386-add-helpcenterid-to-routes') ? path.replace('/jira/servicedesk/', '/jira/helpcenter/').replace('/settings', `/settings/${helpCenterId}`) : path.replace('/jira/servicedesk/', '/jira/helpcenter/');
};

});

parcelRegister("jagxb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a36eb1fdbec95bf4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a36eb1fdbec95bf4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "servicedesk-customer-service-common.help-center-settings-redirect.error-title",
        "defaultMessage": "This page has been moved"
    },
    errorDescription: {
        "id": "servicedesk-customer-service-common.help-center-settings-redirect.error-description",
        "defaultMessage": "You can find the page you\u2019re looking for in a service hub."
    },
    description: {
        "id": "servicedesk-customer-service-common.help-center-settings-redirect.description",
        "defaultMessage": "You can find the page you\u2019re looking for in a customer hub."
    }
});

});


parcelRegister("fHXdv", function(module, exports) {

let $b6f8ce6104f3867e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b6f8ce6104f3867e$var$load("7XRy3").then(()=>parcelRequire('gu2ky'));

});



parcelRegister("g3Gvc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskEmailRouteEntry", () => $0634a6ceff42062d$export$676e8af036d3e9c1);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $i62iX = parcelRequire("i62iX");

var $6Z2mh = parcelRequire("6Z2mh");

var $3VKX1 = parcelRequire("3VKX1");
const $0634a6ceff42062d$export$676e8af036d3e9c1 = (0, $7NszV.createEntry)((0, $i62iX.projectSettingsServicedeskEmailRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.settings.email-channels',
        component: (0, $3VKX1.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3VKX1.LazyProjectSettingsServiceDeskEmail)
        ]
    }));

});

parcelRegister("dseRA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskPortalSettingsRouteEntry", () => $68ffccdafeca70f6$export$2f07a0943f4553c4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $bveQD = parcelRequire("bveQD");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $34BDN = parcelRequire("34BDN");
const $68ffccdafeca70f6$export$2f07a0943f4553c4 = (0, $7NszV.createEntry)((0, $bveQD.projectSettingsServicedeskPortalSettingsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $34BDN.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $34BDN.LazyProjectSettingsServiceDeskClassicPortalSettings)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).PORTAL_SETTINGS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).PORTAL_SETTINGS),
                teamName: 'jsd-shield'
            }
        }
    }));

});
parcelRegister("34BDN", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskClassicPortalSettings", () => $2f67c1468e19aedd$export$eb662b618d6247be);
$parcel$export(module.exports, "default", () => $2f67c1468e19aedd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $2f67c1468e19aedd$export$eb662b618d6247be = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("coGiq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-classic-portal-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2f67c1468e19aedd$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2f67c1468e19aedd$export$eb662b618d6247be,
        pageId: "project-settings-classic-portal-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("coGiq", function(module, exports) {

let $9068890c7d63b8c1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9068890c7d63b8c1$var$load("35rMy").then(()=>parcelRequire('giHe4'));

});



parcelRegister("627LR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsPortalRouteEntry", () => $631bf1a02812ef78$export$7b7294b50c70e50c);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $8CwPO = parcelRequire("8CwPO");

var $cfj3a = parcelRequire("cfj3a");

var $6Z2mh = parcelRequire("6Z2mh");

var $c0aPe = parcelRequire("c0aPe");
const $631bf1a02812ef78$export$7b7294b50c70e50c = (0, $7NszV.createEntry)((0, $cfj3a.projectSettingsServicedeskChannelsPortalRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $c0aPe.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $8CwPO.portalSettingsContextResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $c0aPe.LazyProjectSettingsServiceDeskPortalSettings)
        ]
    }));

});
parcelRegister("8CwPO", function(module, exports) {

$parcel$export(module.exports, "portalSettingsContextResource", () => $9dfc351c3ebf85b6$export$4a3e29f235f3320c);

var $2M1hQ = parcelRequire("2M1hQ");
const $9dfc351c3ebf85b6$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT = 'PORTAL_SETTINGS_CONTEXT';

const $9dfc351c3ebf85b6$export$4a3e29f235f3320c = (0, $2M1hQ.createResource)({
    type: $9dfc351c3ebf85b6$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("gxkQb"))
});

});
parcelRegister("gxkQb", function(module, exports) {

let $c09fe4f0817635a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c09fe4f0817635a1$var$load("kQRxS").then(()=>parcelRequire('7wy1U'));

});


parcelRegister("c0aPe", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskPortalSettings", () => $9da321ff59a70829$export$fdbd4b1e5ae0e422);
$parcel$export(module.exports, "default", () => $9da321ff59a70829$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $9da321ff59a70829$export$fdbd4b1e5ae0e422 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("33qQ7")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-portal-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9da321ff59a70829$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9da321ff59a70829$export$fdbd4b1e5ae0e422,
        pageId: "project-settings-portal-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("33qQ7", function(module, exports) {

let $239678b7d70d0441$var$load = (parcelRequire("28QjX"))(4);
module.exports = $239678b7d70d0441$var$load("6XeFg").then(()=>parcelRequire('jQFbr'));

});



parcelRegister("3wbIE", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskExternalLinksRouteEntry", () => $95680d22988b2454$export$ca80e1d474f774d4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $6sNnq = parcelRequire("6sNnq");

var $eObGp = parcelRequire("eObGp");

var $6Z2mh = parcelRequire("6Z2mh");

var $aV9OB = parcelRequire("aV9OB");
const $95680d22988b2454$export$ca80e1d474f774d4 = (0, $7NszV.createEntry)((0, $eObGp.projectSettingsServicedeskExternalLinksRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $aV9OB.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $6sNnq.featuresResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aV9OB.LazyProjectSettingsServiceDeskExternalLinks)
        ],
        perfMetricKey: 'jsm-external-resources'
    }));

});
parcelRegister("aV9OB", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskExternalLinks", () => $15bcce9a01d18cfd$export$28482a53859ec466);
$parcel$export(module.exports, "default", () => $15bcce9a01d18cfd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $15bcce9a01d18cfd$export$28482a53859ec466 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("41Lfk"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-external-links/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$15bcce9a01d18cfd$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $15bcce9a01d18cfd$export$28482a53859ec466,
        pageId: "project-settings-external-links",
        shouldShowSpinner: true
    });

});
parcelRegister("41Lfk", function(module, exports) {

let $2eebe78a4250e824$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2eebe78a4250e824$var$load("kEacZ").then(()=>parcelRequire('7iBoV'));

});



parcelRegister("1XqXD", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsWidgetRouteEntry", () => $a95971dddf0af763$export$dcfc82c90a86b038);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $d9ukL = parcelRequire("d9ukL");

var $6Z2mh = parcelRequire("6Z2mh");

var $b0cvA = parcelRequire("b0cvA");

var $b2cnG = parcelRequire("b2cnG");
const $a95971dddf0af763$export$dcfc82c90a86b038 = (0, $7NszV.createEntry)((0, $d9ukL.projectSettingsServicedeskChannelsWidgetRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $b0cvA.widgetsNextGenRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $b2cnG.LazyProjectSettingsServiceDeskWidgetSettings)
        ]
    }));

});
parcelRegister("b0cvA", function(module, exports) {

$parcel$export(module.exports, "widgetsNextGenRedirect", () => $1ae3adbbf5c00734$export$8ba256148f9b998f);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $1ae3adbbf5c00734$export$8ba256148f9b998f = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/widget`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});

parcelRegister("b2cnG", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskWidgetSettings", () => $bf4d9e5ccdf213aa$export$216a049c4d917b0);
$parcel$export(module.exports, "default", () => $bf4d9e5ccdf213aa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $bf4d9e5ccdf213aa$export$216a049c4d917b0 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("4BLic")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-widget-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bf4d9e5ccdf213aa$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $bf4d9e5ccdf213aa$export$216a049c4d917b0,
        pageId: "project-settings-widget-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("4BLic", function(module, exports) {

let $35af4d6b49f2c84a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $35af4d6b49f2c84a$var$load("7Qhcd").then(()=>parcelRequire('dO6p9'));

});



parcelRegister("dDzIU", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskWidgetRouteEntry", () => $a1253eff07e9815b$export$d86db47c21552ca);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $8qmAq = parcelRequire("8qmAq");

var $6Z2mh = parcelRequire("6Z2mh");

var $b2cnG = parcelRequire("b2cnG");
const $a1253eff07e9815b$export$d86db47c21552ca = (0, $7NszV.createEntry)((0, $8qmAq.projectSettingsServicedeskWidgetRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $b2cnG.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $b2cnG.LazyProjectSettingsServiceDeskWidgetSettings)
        ]
    }));

});

parcelRegister("1aB8Z", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChangeManagementRouteEntry", () => $518452e4098d607c$export$a8eaf3cca1d5d936);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $gmE3I = parcelRequire("gmE3I");

var $2pT4g = parcelRequire("2pT4g");

var $fpjJX = parcelRequire("fpjJX");

var $cAofY = parcelRequire("cAofY");

var $6sNnq = parcelRequire("6sNnq");

var $aBfqj = parcelRequire("aBfqj");

var $6Z2mh = parcelRequire("6Z2mh");

var $ejiWA = parcelRequire("ejiWA");

var $eHnlx = parcelRequire("eHnlx");
const $518452e4098d607c$export$a8eaf3cca1d5d936 = (0, $7NszV.createEntry)((0, $aBfqj.projectSettingsServicedeskChangeManagementRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.change-management-settings',
        component: (0, $eHnlx.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $cAofY.serviceDeskContextResource),
            (0, $ejiWA.changeManagementSettingsProjectConfigurationResource),
            (0, $gmE3I.jsmChangeManagementSettingsGitLabGatingResource),
            (0, $6sNnq.featuresResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $2pT4g.jsmRepackagingBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eHnlx.LazyProjectSettingsServiceDeskChangeManagement)
        ]
    }));

});
parcelRegister("gmE3I", function(module, exports) {

$parcel$export(module.exports, "jsmChangeManagementSettingsGitLabGatingResource", () => $ff8ead4f49d1e745$export$315b6278d34861b4);
$parcel$export(module.exports, "useGitLabGatingResource", () => $ff8ead4f49d1e745$export$dd3715dce02ee460);

var $5uXOq = parcelRequire("5uXOq");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $ff8ead4f49d1e745$var$getDataLoader = ()=>(parcelRequire("5OUIt"));
const $ff8ead4f49d1e745$export$315b6278d34861b4 = (0, $2M1hQ.createResource)({
    type: 'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
    getKey: ()=>'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
    getDataLoader: $ff8ead4f49d1e745$var$getDataLoader,
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});
const $ff8ead4f49d1e745$export$dd3715dce02ee460 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)($ff8ead4f49d1e745$export$315b6278d34861b4);
    (0, $5uXOq.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: data?.data,
            pending: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: data?.error || error
        }), [
        data,
        loading,
        error
    ]);
};

});
parcelRegister("5OUIt", function(module, exports) {

let $43cd9dee1addc423$var$load = (parcelRequire("28QjX"))(4);
module.exports = $43cd9dee1addc423$var$load("hzh3H").then(()=>parcelRequire('4y3Yq'));

});


parcelRegister("ejiWA", function(module, exports) {

$parcel$export(module.exports, "changeManagementSettingsProjectConfigurationResource", () => $53ebb72294d46a1c$export$2413ba18ec38282d);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $2M1hQ = parcelRequire("2M1hQ");
const $53ebb72294d46a1c$export$c0636b6062501e0b = 'CHANGE_MANAGEMENT_SETTINGS_PROJECT_CONFIG';

const $53ebb72294d46a1c$var$getDataLoader = ()=>(parcelRequire("7zwum"));
const $53ebb72294d46a1c$var$getKey = ({ match: match })=>typeof match.params.projectKey === 'string' ? match.params.projectKey : '';
const $53ebb72294d46a1c$export$2413ba18ec38282d = (0, $2M1hQ.createResource)({
    type: $53ebb72294d46a1c$export$c0636b6062501e0b,
    getKey: $53ebb72294d46a1c$var$getKey,
    getDataLoader: $53ebb72294d46a1c$var$getDataLoader,
    maxAge: Infinity
});

});
parcelRegister("7zwum", function(module, exports) {

let $583500e0c2c90356$var$load = (parcelRequire("28QjX"))(4);
module.exports = $583500e0c2c90356$var$load("fIejC").then(()=>parcelRequire('k9qTQ'));

});


parcelRegister("eHnlx", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskChangeManagement", () => $8fbb06494113daae$export$e674d93688e620b3);
$parcel$export(module.exports, "default", () => $8fbb06494113daae$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $8fbb06494113daae$export$e674d93688e620b3 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("dagEo"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-change-management-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8fbb06494113daae$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8fbb06494113daae$export$e674d93688e620b3,
        pageId: "project-settings-change-management",
        shouldShowSpinner: true
    });

});
parcelRegister("dagEo", function(module, exports) {

let $99591ff9a533ab80$var$load = (parcelRequire("28QjX"))(4);
module.exports = $99591ff9a533ab80$var$load("d1IdH").then(()=>parcelRequire('eh7Vf'));

});



parcelRegister("3M4hq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIncidentManagementRouteEntry", () => $959537c21f89ae37$export$95a73b5db67dd70a);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $cAofY = parcelRequire("cAofY");

var $jHXos = parcelRequire("jHXos");

var $6Z2mh = parcelRequire("6Z2mh");

var $3uo46 = parcelRequire("3uo46");
const $959537c21f89ae37$export$95a73b5db67dd70a = (0, $7NszV.createEntry)((0, $jHXos.projectSettingsServicedeskIncidentManagementRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $3uo46.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $cAofY.serviceDeskContextResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3uo46.LazyProjectSettingsServiceDeskIncidentManagement)
        ]
    }));

});
parcelRegister("3uo46", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskIncidentManagement", () => $74652d26314b4bbc$export$7796b6d080b8c187);
$parcel$export(module.exports, "default", () => $74652d26314b4bbc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $74652d26314b4bbc$export$7796b6d080b8c187 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("ieClU"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-incident-management-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$74652d26314b4bbc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $74652d26314b4bbc$export$7796b6d080b8c187,
        pageId: "project-settings-incident-management",
        shouldShowSpinner: true
    });

});
parcelRegister("ieClU", function(module, exports) {

let $d46748c365f2f60d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d46748c365f2f60d$var$load("h2MrD"),
    $d46748c365f2f60d$var$load("bYT2S"),
    $d46748c365f2f60d$var$load("dsiAd"),
    $d46748c365f2f60d$var$load("d8OHn")
]).then(()=>parcelRequire('gZiIg'));

});



parcelRegister("a2PeW", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsChatRouteEntry", () => $7d42d939b28a59ca$export$aa27d235fc2eedf6);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $9wUes = parcelRequire("9wUes");

var $6Z2mh = parcelRequire("6Z2mh");

var $6ybDD = parcelRequire("6ybDD");

var $5qwUl = parcelRequire("5qwUl");
const $7d42d939b28a59ca$export$aa27d235fc2eedf6 = (0, $7NszV.createEntry)((0, $9wUes.projectSettingsServicedeskChannelsChatRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $6ybDD.serviceDeskChatNextGenRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5qwUl.LazyProjectSettingsServiceDeskChatSettings)
        ]
    }));

});
parcelRegister("6ybDD", function(module, exports) {

$parcel$export(module.exports, "serviceDeskChatNextGenRedirect", () => $7c240e4106c097e5$export$22c86ddb04b1359a);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $7c240e4106c097e5$export$22c86ddb04b1359a = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/chat`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});

parcelRegister("5qwUl", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskChatSettings", () => $955f7623ed5daf83$export$971347f9ac02f862);
$parcel$export(module.exports, "default", () => $955f7623ed5daf83$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $955f7623ed5daf83$export$971347f9ac02f862 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("fTNYB")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-chat-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$955f7623ed5daf83$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $955f7623ed5daf83$export$971347f9ac02f862,
        pageId: "project-settings-widget-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("fTNYB", function(module, exports) {

let $b932c25b5d2c6235$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b932c25b5d2c6235$var$load("cYnLU").then(()=>parcelRequire('k9vj7'));

});



parcelRegister("gXApH", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChatRouteEntry", () => $30ca084fd423718b$export$f030ac1baa84c682);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2I1zE = parcelRequire("2I1zE");

var $6Z2mh = parcelRequire("6Z2mh");

var $5qwUl = parcelRequire("5qwUl");
const $30ca084fd423718b$export$f030ac1baa84c682 = (0, $7NszV.createEntry)((0, $2I1zE.projectSettingsServicedeskChatRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $5qwUl.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5qwUl.LazyProjectSettingsServiceDeskChatSettings)
        ]
    }));

});

parcelRegister("amBHA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsRouteEntry", () => $e62176a0302c26c4$export$2d20001d3350adbc);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2a84P = parcelRequire("2a84P");

var $6Z2mh = parcelRequire("6Z2mh");

var $3egqP = parcelRequire("3egqP");
const $e62176a0302c26c4$export$2d20001d3350adbc = (0, $7NszV.createEntry)((0, $2a84P.projectSettingsServicedeskChannelsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $3egqP.channelsRedirect)('customer-permissions'),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("2a84P", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsRoute", () => $a400bd3af4bd9318$export$36e4210554830c2f);
const $a400bd3af4bd9318$export$36e4210554830c2f = {
    name: 'project-settings-servicedesk-channels',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels',
    exact: true
};

});

parcelRegister("3egqP", function(module, exports) {

$parcel$export(module.exports, "channelsRedirect", () => $73d598aaa606ce09$export$c7e6c0ac0abe2336);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $02Psx = parcelRequire("02Psx");

var $7tQej = parcelRequire("7tQej");
const $73d598aaa606ce09$export$c7e6c0ac0abe2336 = (pageUrlFragment)=>({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), String(projectKey))}/channels/${pageUrlFragment}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: url,
            push: false
        });
    };

});


parcelRegister("6agOS", function(module, exports) {

$parcel$export(module.exports, "servicedeskSlaSettingsRouteEntry", () => $4a495883d616d596$export$472949ed4e9ddfb0);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $4wBwP = parcelRequire("4wBwP");

var $hewRX = parcelRequire("hewRX");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $1CEnL = parcelRequire("1CEnL");
const $4a495883d616d596$export$472949ed4e9ddfb0 = (0, $7NszV.createEntry)((0, $hewRX.servicedeskSlaSettingsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).SLA_SETTINGS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).SLA_SETTINGS),
                teamName: 'bumblebee'
            }
        },
        perfMetricKey: 'jsm-sla-settings',
        component: (0, $1CEnL.ServiceDeskSlaSettings),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $4wBwP.slaMetricsDataResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1CEnL.LazyProjectSettingsServiceDeskSlaSettings)
        ]
    }));

});
parcelRegister("4wBwP", function(module, exports) {

$parcel$export(module.exports, "slaMetricsDataResource", () => $5bd842d236781a2e$export$6cdfca3e816e9661);

var $2M1hQ = parcelRequire("2M1hQ");
const $5bd842d236781a2e$export$c5fa03c9ad8df0e2 = 'SLA_METRICS';

const $5bd842d236781a2e$export$6cdfca3e816e9661 = (0, $2M1hQ.createResource)({
    type: $5bd842d236781a2e$export$c5fa03c9ad8df0e2,
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("10Gii")),
    maxAge: Infinity
});

});
parcelRegister("10Gii", function(module, exports) {

let $0bc69946dc472af5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0bc69946dc472af5$var$load("g759n").then(()=>parcelRequire('dxWU3'));

});


parcelRegister("1CEnL", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskSlaSettings", () => $45b508c287c9b763$export$a6694c07cb5be8c1);
$parcel$export(module.exports, "ServiceDeskSlaSettings", () => $45b508c287c9b763$export$c56fde3803c5a1a3);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $l8ruj = parcelRequire("l8ruj");

var $b7Svb = parcelRequire("b7Svb");

const $45b508c287c9b763$export$a6694c07cb5be8c1 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("ejCjb"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-sla-settings/src/index.tsx"
});
const $45b508c287c9b763$export$c56fde3803c5a1a3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "project-settings-service-desk-sla-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $45b508c287c9b763$export$a6694c07cb5be8c1,
        pageId: "project-settings-service-desk-sla-settings",
        shouldShowSpinner: true
    }));

});
parcelRegister("ejCjb", function(module, exports) {

let $a6c08e47a5419d7f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a6c08e47a5419d7f$var$load("gUg0Z").then(()=>parcelRequire('1rjw0'));

});



parcelRegister("7fwfr", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskFeedbackRouteEntry", () => $e67580ab8b50900d$export$5c0731470c0dc065);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6z8e6 = parcelRequire("6z8e6");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $7Txnp = parcelRequire("7Txnp");

var $7zcmB = parcelRequire("7zcmB");
const $e67580ab8b50900d$export$5c0731470c0dc065 = (0, $7NszV.createEntry)((0, $6z8e6.projectSettingsServicedeskFeedbackRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $7zcmB.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $7zcmB.LazyProjectSettingsServiceDeskFeedbackSettings),
            (0, $7Txnp.LazyCsatSettingsPage)
        ],
        perfMetricKey: 'jsm-feedback-settings',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CSAT_CONFIG,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CSAT_CONFIG),
                teamName: 'jsm-request-intake'
            }
        }
    }));

});
parcelRegister("7Txnp", function(module, exports) {

$parcel$export(module.exports, "LoadingComponent", () => $42f73bbf4237dc1b$export$7db30d367db7d20a);
$parcel$export(module.exports, "LazyCsatSettingsPage", () => $42f73bbf4237dc1b$export$32eb62914bae0e84);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $clxo5 = parcelRequire("clxo5");

var $b7Svb = parcelRequire("b7Svb");
const $42f73bbf4237dc1b$export$7db30d367db7d20a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42f73bbf4237dc1b$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
        size: "large"
    }));

const $42f73bbf4237dc1b$export$32eb62914bae0e84 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("fSZmK")), {
    moduleId: "./src/packages/servicedesk/csat/src/index.tsx"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $42f73bbf4237dc1b$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i68cl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fSZmK", function(module, exports) {

let $b90b80210fb79ee5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b90b80210fb79ee5$var$load("jT1Vf").then(()=>parcelRequire('hX8BJ'));

});


parcelRegister("7zcmB", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskFeedbackSettings", () => $4b8db06fa1ed7bd1$export$ff54bec6c7cb7d47);
$parcel$export(module.exports, "default", () => $4b8db06fa1ed7bd1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");
const $4b8db06fa1ed7bd1$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
const $4b8db06fa1ed7bd1$export$1aa47348ef6dbdda = 'project/service-desk/settings';

const $4b8db06fa1ed7bd1$export$ff54bec6c7cb7d47 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("957KQ")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-feedback-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b8db06fa1ed7bd1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4b8db06fa1ed7bd1$export$ff54bec6c7cb7d47,
        pageId: "project-settings-feedback-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("957KQ", function(module, exports) {

let $69ca988f4a859e6a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $69ca988f4a859e6a$var$load("k8jhA").then(()=>parcelRequire('d3uR0'));

});



parcelRegister("gUdrp", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskForgeAppsRouteEntry", () => $b86b6dad0a03dbe6$export$58e3b68d22b7a42b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $8L6oT = parcelRequire("8L6oT");

var $6Z2mh = parcelRequire("6Z2mh");

var $5bkvv = parcelRequire("5bkvv");

var $dxCvy = parcelRequire("dxCvy");

var $bUhjF = parcelRequire("bUhjF");
const $b86b6dad0a03dbe6$export$58e3b68d22b7a42b = (0, $7NszV.createEntry)((0, $8L6oT.projectSettingsServicedeskForgeAppsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $bUhjF.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResourceWithCache),
            (0, $5bkvv.forgeProjectSettingsModuleResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bUhjF.LazyForgeProjectSettingsPage)
        ]
    }));

});
parcelRegister("8L6oT", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskForgeAppsRoute", () => $b9987e58af4bd5dd$export$10bafd1256118bb8);
const $b9987e58af4bd5dd$export$10bafd1256118bb8 = {
    name: 'project-settings-servicedesk-forge-apps',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("bUhjF", function(module, exports) {

$parcel$export(module.exports, "LazyForgeProjectSettingsPage", () => $d4e28d950e086fee$export$ef66d3f49a9953d8);
$parcel$export(module.exports, "default", () => $d4e28d950e086fee$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $d4e28d950e086fee$export$ef66d3f49a9953d8 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("dyX7u")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $d4e28d950e086fee$export$b943f48844c671a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d4e28d950e086fee$export$ef66d3f49a9953d8,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
var $d4e28d950e086fee$export$2e2bcd8739ae039 = $d4e28d950e086fee$export$b943f48844c671a5;

});


parcelRegister("bERWs", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskRedirectRouteEntry", () => $1c4a2f62f943cd86$export$a0279fafdeb78607);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $bYwAR = parcelRequire("bYwAR");

var $6Z2mh = parcelRequire("6Z2mh");

var $01LdL = parcelRequire("01LdL");
const $1c4a2f62f943cd86$export$a0279fafdeb78607 = (0, $7NszV.createEntry)((0, $bYwAR.projectSettingsServicedeskRedirectRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $01LdL.defaultRedirectForSettings)((0, $01LdL.SERVICE_DESK_PRODUCT)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("bYwAR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskRedirectRoute", () => $dd2a76b3e525b3b0$export$3fbe0a89e4d1e816);
const $dd2a76b3e525b3b0$export$3fbe0a89e4d1e816 = {
    name: 'project-settings-servicedesk-redirect',
    path: '/jira/servicedesk/projects/:projectKey/settings'
};

});


parcelRegister("80PF8", function(module, exports) {

$parcel$export(module.exports, "servicedeskPlaybooksListRouteEntry", () => $ccdff8c69ba43bde$export$19177b8fa44e5e4d);

var $e4eHl = parcelRequire("e4eHl");

var $4R6GH = parcelRequire("4R6GH");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $8YZBz = parcelRequire("8YZBz");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $lk01G = parcelRequire("lk01G");

var $lkFvK = parcelRequire("lkFvK");

var $jom1z = parcelRequire("jom1z");
const $ccdff8c69ba43bde$var$listEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $lk01G.default),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $ccdff8c69ba43bde$export$19177b8fa44e5e4d = (0, $7NszV.createEntry)((0, $8YZBz.servicedeskPlaybooksListRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            return (0, $4R6GH.fg)('playbooks-in-jsm') ? $ccdff8c69ba43bde$var$listEntryPoint : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $jom1z.playbooksListRequestTypesResource)
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.admin-list-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('project-settings-playbooks-list'),
                teamName: 'ITOps Phantom'
            }
        },
        component: (0, $5lsNZ.default),
        ufoName: 'playbook-list'
    }));

});
parcelRegister("8YZBz", function(module, exports) {

$parcel$export(module.exports, "servicedeskPlaybooksListRoute", () => $39cfce4bc27a2e92$export$cbed08b5b0671f5f);
const $39cfce4bc27a2e92$export$cbed08b5b0671f5f = {
    name: 'project-settings-playbooks-list',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks',
    exact: true
};

});

parcelRegister("lk01G", function(module, exports) {

$parcel$export(module.exports, "default", () => $787278c10397c75e$export$2e2bcd8739ae039);

var $8fDOc = parcelRequire("8fDOc");

var $6YEEX = parcelRequire("6YEEX");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore Argument of type '{ root: ...; getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => any; }' is not assignable to parameter of type 'never'
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $787278c10397c75e$var$playbookListViewEntryPoint = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("fLDhD")), {
        moduleId: "a498670b"
    }),
    // This has been causing build errors in unrelated code. Broadening type to fix build.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = context.match.params;
        const { tab: tab = 'list', name: name = '' } = context.query;
        if (!projectKey) throw new Error('projectKey is required');
        // In case where tab is logs, we need to load the logs entry point
        // For other cases, fallback to the list entry point. This matches the current logic in the UI component.
        const entryPoints = tab === 'logs' ? {
            preloadedPlaybookLogsEntryPoint: {
                entryPoint: (0, $6YEEX.playbookLogsEntryPoint),
                entryPointParams: {
                    cloudId: tenantContext.cloudId,
                    projectKey: projectKey,
                    first: 20,
                    filter: name ? {
                        name: name
                    } : null
                }
            }
        } : {
            preloadedPlaybookListEntryPoint: {
                entryPoint: (0, $8fDOc.playbookListEntryPoint),
                entryPointParams: {
                    cloudId: tenantContext.cloudId,
                    projectKey: projectKey,
                    first: 20,
                    filter: name ? {
                        name: name
                    } : null
                }
            }
        };
        return {
            extraProps: {
                accountId: tenantContext.atlassianAccountId,
                cloudId: tenantContext.cloudId,
                projectId: context.query.projectId,
                projectKey: context.match.params.projectKey
            },
            entryPoints: entryPoints
        };
    }
});
var $787278c10397c75e$export$2e2bcd8739ae039 = $787278c10397c75e$var$playbookListViewEntryPoint;

});
parcelRegister("8fDOc", function(module, exports) {

$parcel$export(module.exports, "playbookListEntryPoint", () => $d77fb854f7f8e8b8$export$d7be5d3b24f1d526);

var $k1Mbn = parcelRequire("k1Mbn");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $d77fb854f7f8e8b8$export$d7be5d3b24f1d526 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("4zuvM")).then((module)=>module.PlaybookList), {
        moduleId: "3f3b7cb0",
        moduleName: "PlaybookList"
    }),
    getPreloadProps: (variables)=>{
        return {
            queries: {
                PlaybookListQuery: {
                    parameters: (0, $k1Mbn.default),
                    variables: variables
                }
            }
        };
    }
});

});
parcelRegister("k1Mbn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0a57d88af1f6396$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<88ca73ae55daccedd91d86ba2fee8d43>>
 * @relayHash 78fb356e6ea43583551f163d6ced2e44
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe53adcfcad2d0e19177edc15ca83f107e876141ec50ea7dc332b4e3a4b1b4ec
const $a0a57d88af1f6396$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fe53adcfcad2d0e19177edc15ca83f107e876141ec50ea7dc332b4e3a4b1b4ec",
        "metadata": {},
        "name": "PlaybookListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a0a57d88af1f6396$export$2e2bcd8739ae039 = $a0a57d88af1f6396$var$node;

});

parcelRegister("4zuvM", function(module, exports) {

let $354219465a17adc5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $354219465a17adc5$var$load("hjDJb").then(()=>parcelRequire('hM1vX'));

});


parcelRegister("6YEEX", function(module, exports) {

$parcel$export(module.exports, "playbookLogsEntryPoint", () => $60633bec6dffe3a8$export$7ebe0f850472ea07);

var $aNsVT = parcelRequire("aNsVT");

var $YWlMy = parcelRequire("YWlMy");

var $3rdd7 = parcelRequire("3rdd7");

const $60633bec6dffe3a8$export$7ebe0f850472ea07 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("6KGh6")), {
        moduleId: "c3ca80f1",
        moduleName: "PlaybookLogs"
    }),
    getPreloadProps: (variables)=>({
            queries: {
                PlaybookLogsQuery: {
                    parameters: (0, $YWlMy.default),
                    variables: variables
                }
            }
        })
});

});
parcelRegister("YWlMy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcd4a200ecef7c9e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2eb04c9c0ea7ae5e1ff7f7ae02ae5f5e>>
 * @relayHash bc6733f8be82f339f12592bf652b99df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c49f692efd9605e3a4fa9949c36c46f332d5e3fb97f4f83e5803f75267e383b
const $fcd4a200ecef7c9e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "3c49f692efd9605e3a4fa9949c36c46f332d5e3fb97f4f83e5803f75267e383b",
        "metadata": {},
        "name": "PlaybookLogsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $fcd4a200ecef7c9e$export$2e2bcd8739ae039 = $fcd4a200ecef7c9e$var$node;

});

parcelRegister("6KGh6", function(module, exports) {

let $4ea7d4e074145cde$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4ea7d4e074145cde$var$load("29wpj").then(()=>parcelRequire('baehV'));

});


parcelRegister("fLDhD", function(module, exports) {

let $b7a9b7a8306c5782$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b7a9b7a8306c5782$var$load("la2ji").then(()=>parcelRequire('6o22p'));

});


parcelRegister("jom1z", function(module, exports) {

$parcel$export(module.exports, "playbooksListRequestTypesResource", () => $4640323ec09a801b$export$43f774aa05fabd18);

var $2M1hQ = parcelRequire("2M1hQ");


var $jthxb = parcelRequire("jthxb");

var $eusud = parcelRequire("eusud");
const $4640323ec09a801b$export$43f774aa05fabd18 = (0, $2M1hQ.createResource)({
    type: 'PLAYBOOKS-LIST-REQUEST-TYPES-RESOURCE-TYPE',
    getKey: ({ match: match })=>{
        const projectKey = match.params.projectKey;
        return `playbooksListRequestTypesResource-${projectKey}`;
    },
    getData: async ({ dependencies: dependencies })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { projectId: projectId } = await (0, $jthxb.consumeDependency)(dependencies, (0, $0f463a88567f1621$export$80a60a092d9ab81));
        return (0, $eusud.performGetRequest)($4640323ec09a801b$var$getRequestTypesUrl(projectId)).then((response)=>response.ticketTypes);
    },
    maxAge: 300000,
    depends: [
        (0, $0f463a88567f1621$export$80a60a092d9ab81)
    ]
});
const $4640323ec09a801b$var$getRequestTypesUrl = (projectId)=>`/rest/servicedesk/1/servicedesk/${projectId}/request-types`;

});


parcelRegister("2r2Gu", function(module, exports) {

$parcel$export(module.exports, "servicedeskPlaybooksEditRouteEntry", () => $bdbdec3ce8186cd4$export$abfa8cd64fabd80e);

var $e4eHl = parcelRequire("e4eHl");

var $h0bZU = parcelRequire("h0bZU");

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $7GkYX = parcelRequire("7GkYX");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $lusKj = parcelRequire("lusKj");

var $lkFvK = parcelRequire("lkFvK");

var $f6cRY = parcelRequire("f6cRY");
const $bdbdec3ce8186cd4$var$editEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $lusKj.default),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $bdbdec3ce8186cd4$export$abfa8cd64fabd80e = (0, $7NszV.createEntry)((0, $7GkYX.servicedeskPlaybooksEditRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            return (0, $4R6GH.fg)('playbooks-in-jsm') ? $bdbdec3ce8186cd4$var$editEntryPoint : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.admin-edit-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('project-settings-playbooks-edit'),
                teamName: 'ITOps Phantom'
            }
        },
        component: (0, $5lsNZ.default),
        ufoName: 'playbook-edit',
        skeleton: (0, $f6cRY.PlaybookEditSkeleton)
    }));

});
parcelRegister("7GkYX", function(module, exports) {

$parcel$export(module.exports, "servicedeskPlaybooksEditRoute", () => $f6a9df88dc0097bb$export$5920ce3a2ccf6e2b);
const $f6a9df88dc0097bb$export$5920ce3a2ccf6e2b = {
    name: 'project-settings-playbooks-edit',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/:playbookId',
    exact: true
};

});

parcelRegister("lusKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c46caae51932151$export$2e2bcd8739ae039);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $l5Wv9 = parcelRequire("l5Wv9");

const $7c46caae51932151$var$playbookEditViewEntryPoint = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("6aIS8")), {
        moduleId: "15e5be42"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey, playbookId: playbookId = '' } = context.match.params;
        if (!projectKey) throw new Error('projectKey is required');
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const isNewPlaybook = !!playbookId?.includes($7c46caae51932151$var$NEW_PLAYBOOK_IDENTIFIER);
        const playbookAri = $7c46caae51932151$var$toPlaybookAri({
            siteId: cloudId,
            activationId: activationId,
            playbookId: playbookId || ''
        });
        if (isNewPlaybook) return {
            extraProps: {
                playbookAri: playbookAri,
                isNew: true
            }
        };
        return {
            queries: {
                PlaybookDetailQuery: {
                    parameters: (0, $l5Wv9.default),
                    variables: {
                        playbookAri: playbookAri
                    }
                }
            },
            extraProps: {
                playbookAri: playbookAri,
                isNew: false
            }
        };
    }
});
var $7c46caae51932151$export$2e2bcd8739ae039 = $7c46caae51932151$var$playbookEditViewEntryPoint;
function $7c46caae51932151$var$toPlaybookAri({ siteId: siteId, activationId: activationId, playbookId: playbookId }) {
    return `ari:cloud:jira:${siteId}:playbook/activation/${activationId}/${playbookId}`;
}
const $7c46caae51932151$var$NEW_PLAYBOOK_IDENTIFIER = '_new_';

});
parcelRegister("l5Wv9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1650a5e016addfe6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<41924ccb303b5d3b27264e56cf9a5101>>
 * @relayHash f01b0a348049b3c26499af7159f898e3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c6e9a099b5fe0bed228db70dab296511e1b1c69247c364583be4f0735cc57708
const $1650a5e016addfe6$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "c6e9a099b5fe0bed228db70dab296511e1b1c69247c364583be4f0735cc57708",
        "metadata": {},
        "name": "PlaybookDetailQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1650a5e016addfe6$export$2e2bcd8739ae039 = $1650a5e016addfe6$var$node;

});

parcelRegister("6aIS8", function(module, exports) {

let $47e67bee9bd936ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $47e67bee9bd936ec$var$load("h2MrD"),
    $47e67bee9bd936ec$var$load("bYT2S"),
    $47e67bee9bd936ec$var$load("dsiAd"),
    $47e67bee9bd936ec$var$load("9YF2g")
]).then(()=>parcelRequire('79e1o'));

});


parcelRegister("f6cRY", function(module, exports) {

$parcel$export(module.exports, "PlaybookEditSkeleton", () => $da382d4ceac0982f$export$8e181e27312cd7a4);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $2Eqc8 = parcelRequire("2Eqc8");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");

var $liZ21 = parcelRequire("liZ21");

var $4CMbn = parcelRequire("4CMbn");

var $cS37j = parcelRequire("cS37j");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $7Kysn = parcelRequire("7Kysn");
const $da382d4ceac0982f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    returnToList: {
        "id": "playbooks-edit-screen.playbook-item.skeleton.return-to-list",
        "defaultMessage": "Return to list"
    }
});
const $da382d4ceac0982f$export$8e181e27312cd7a4 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [playbookListLink] = (0, $7Kysn.useReturnToListUrl)();
    const actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        gap: "space.100",
        direction: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $liZ21.default), {
        appearance: "subtle",
        href: playbookListLink
    }, formatMessage($da382d4ceac0982f$export$defe85febe8b728c.returnToList)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        xcss: $da382d4ceac0982f$var$containerStyle,
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        actions: actions,
        disableTitleStyles: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        gap: "space.300",
        direction: "row",
        justifyContent: "space-between",
        xcss: $da382d4ceac0982f$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        xcss: $da382d4ceac0982f$var$stepCards,
        alignBlock: "start",
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CMbn.default), {
        height: "52px",
        width: "100%",
        isShimmering: true,
        borderRadius: "8px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CMbn.default), {
        height: "52px",
        width: "100%",
        isShimmering: true,
        borderRadius: "8px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        xcss: $da382d4ceac0982f$var$addButton,
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CMbn.default), {
        height: "40px",
        width: "40px",
        isShimmering: true,
        borderRadius: "40px"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $da382d4ceac0982f$var$detailStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CMbn.default), {
        height: "520px",
        width: "100%",
        isShimmering: true,
        borderRadius: "8px"
    }))));
};
const $da382d4ceac0982f$var$containerStyle = (0, $2s57o.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    paddingLeft: 'space.300',
    paddingRight: 'space.500',
    height: '100vh'
});
const $da382d4ceac0982f$var$detailStyle = (0, $2s57o.xcss)({
    maxWidth: '800px',
    minWidth: '440px',
    width: '45%'
});
const $da382d4ceac0982f$var$contentStyles = (0, $2s57o.xcss)({
    width: '100%',
    paddingTop: 'space.400'
});
const $da382d4ceac0982f$var$stepCards = (0, $2s57o.xcss)({
    flexGrow: 0,
    flexShrink: 1,
    flexBasis: '30%',
    maxWidth: '600px'
});
const $da382d4ceac0982f$var$addButton = (0, $2s57o.xcss)({
    height: '52px'
});

});
parcelRegister("cS37j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a15efb09f101ecb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gYshv = parcelRequire("gYshv");
const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYshv.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
    });
var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a15efb09f101ecb$var$ActionsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gYshv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7893b08ae1633d7$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cSaN1 = parcelRequire("cSaN1");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $e7893b08ae1633d7$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cSaN1.OuterWrapper), {
        children: [
            breadcrumbs,
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cSaN1.TitleWrapper), {
                truncateTitle: truncateTitle,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cSaN1.TitleContainer), {
                        truncateTitle: truncateTitle,
                        children: disableTitleStyles ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cSaN1.StyledTitleWrapper), {
                            ref: innerRef,
                            truncateTitle: truncateTitle,
                            id: id,
                            testId: testId,
                            children: children
                        })
                    }),
                    actions && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cSaN1.ActionsWrapper), {
                        children: actions
                    })
                ]
            }),
            bottomBar && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cSaN1.BottomBarWrapper), {
                children: [
                    " ",
                    bottomBar,
                    " "
                ]
            })
        ]
    });
};
var $e7893b08ae1633d7$export$2e2bcd8739ae039 = $e7893b08ae1633d7$var$PageHeader;

});
parcelRegister("cSaN1", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $6a5b4ca86afc93be$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $6a5b4ca86afc93be$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $6a5b4ca86afc93be$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $6a5b4ca86afc93be$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $6a5b4ca86afc93be$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $6a5b4ca86afc93be$export$6330225854c30dc);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
const $6a5b4ca86afc93be$var$styles = {
    bottomBar: "_1pfhpxbi"
};
const $6a5b4ca86afc93be$var$truncateStyles = null;
const $6a5b4ca86afc93be$var$outerStyles = null;
const $6a5b4ca86afc93be$var$titleStyles = null;
const $6a5b4ca86afc93be$var$titleWrapperStyles = null;
const $6a5b4ca86afc93be$var$titleWrapperTruncateStyles = null;
const $6a5b4ca86afc93be$var$titleContainerStyles = null;
const $6a5b4ca86afc93be$var$actionStyles = null;
const $6a5b4ca86afc93be$var$titleContainerTruncateStyles = null;
const $6a5b4ca86afc93be$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_6rthpxbi _1pfh1ejb _12l2idpf _ahbqidpf"
        ]),
        children: children
    });
};
const $6a5b4ca86afc93be$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h1", {
        ref: ref,
        tabIndex: -1,
        id: id,
        "data-testid": testId && `${testId}--title`,
        className: (0, $bwpsq.default)([
            "_11c8nf1z _12ji1r31 _1qu2glyw _12y31o36 _syaz1fxt _1dyz4jg8 _1pfhidpf",
            truncateTitle && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ]),
        children: children
    });
});
const $6a5b4ca86afc93be$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1y6m _1n261g80",
            truncateTitle && "_1n261q9c"
        ]),
        children: children
    });
};
const $6a5b4ca86afc93be$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _1ul9idpf _p12f1osq _6rthu2gc",
            truncateTitle && "_1o9zkb7n"
        ]),
        children: children
    });
};
const $6a5b4ca86afc93be$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _p12f1osq _6rthu2gc _ahbq1wug _bozgxy5q _o5721q9c"
        ]),
        children: children
    });
};
const $6a5b4ca86afc93be$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $6a5b4ca86afc93be$var$styles.bottomBar,
        children: children
    });
};

});



parcelRegister("7Kysn", function(module, exports) {

$parcel$export(module.exports, "getStepData", () => $d5ec6522606d2f57$export$f1427121561aecf8);
$parcel$export(module.exports, "isStep", () => $d5ec6522606d2f57$export$21684750287da054);
$parcel$export(module.exports, "useIsNewPlaybook", () => $d5ec6522606d2f57$export$d761c1032826f7f);
$parcel$export(module.exports, "getJiraPlaybookIdFromARI", () => $d5ec6522606d2f57$export$191a8b6475837449);
$parcel$export(module.exports, "useReturnToListUrl", () => $d5ec6522606d2f57$export$565f39f00aacdb73);
$parcel$export(module.exports, "getIsDescriptionEmpty", () => $d5ec6522606d2f57$export$f11d072d2cef989a);
$parcel$export(module.exports, "getStepsOrder", () => $d5ec6522606d2f57$export$812421dcb7983dd1);
$parcel$export(module.exports, "getStepsDetail", () => $d5ec6522606d2f57$export$aa46de8dc426f402);

var $8LePZ = parcelRequire("8LePZ");

var $6huwY = parcelRequire("6huwY");

var $bmKPg = parcelRequire("bmKPg");

var $04BO2 = parcelRequire("04BO2");

var $iMvey = parcelRequire("iMvey");
const $d5ec6522606d2f57$export$f1427121561aecf8 = (id, name, type, index)=>{
    return {
        stepId: id,
        name: name,
        index: index,
        type: type
    };
};
const $d5ec6522606d2f57$export$21684750287da054 = (data)=>{
    if (data) {
        const { type: type } = data;
        return type === 'INSTRUCTIONAL_RULE' || type === 'AUTOMATION_RULE';
    }
    return false;
};
const $d5ec6522606d2f57$export$cf6e5a5e05d437ad = (cloudId, activationId, playbookId)=>{
    return (0, $6huwY.JiraPlaybookAri).create({
        siteId: cloudId,
        activationId: activationId,
        playbookId: playbookId
    }).toString();
};
const $d5ec6522606d2f57$export$d761c1032826f7f = ()=>{
    const [playbookId = ''] = (0, $bmKPg.usePathParam)('playbookId');
    return playbookId.includes((0, $iMvey.NEW_PLAYBOOK_IDENTIFIER));
};
const $d5ec6522606d2f57$export$191a8b6475837449 = (playbookAri)=>{
    return (0, $6huwY.JiraPlaybookAri).parse(playbookAri).playbookId;
};
const $d5ec6522606d2f57$export$565f39f00aacdb73 = ()=>{
    const [projectKey = ''] = (0, $bmKPg.usePathParam)('projectKey');
    const playbookListLink = (0, $04BO2.getProjectSettingsPageUrl)(projectKey, 'playbooks');
    return [
        playbookListLink
    ];
};
const $d5ec6522606d2f57$export$f11d072d2cef989a = (description)=>{
    if (description && Object.keys(description).length > 0) return JSON.stringify(description) === JSON.stringify((0, $8LePZ.getEmptyADF)());
    return true;
};
const $d5ec6522606d2f57$export$812421dcb7983dd1 = (data)=>{
    return data.map((step)=>step.stepId);
};
const $d5ec6522606d2f57$export$aa46de8dc426f402 = (data)=>{
    const acc = {};
    data.forEach((step)=>{
        acc[step.stepId] = step;
    });
    return acc;
};

});
parcelRegister("8LePZ", function(module, exports) {

$parcel$export(module.exports, "getEmptyADF", () => $66deaf8519a84e70$export$d109ab46c9575565);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $ePhgB = parcelRequire("ePhgB");
const $66deaf8519a84e70$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});
parcelRegister("ePhgB", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $3b6fbc07a280ff9b$export$dd1bc94b04021eeb);
const $3b6fbc07a280ff9b$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;

});


parcelRegister("6huwY", function(module, exports) {

$parcel$export(module.exports, "JiraPlaybookAri", () => $492c036ba5123279$export$2b27259a6ef92c74);

var $cyZcy = parcelRequire("cyZcy");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/playbook/manifest.ts
var $492c036ba5123279$var$jiraPlaybookAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $cyZcy.JiraPlaybookAriResourceOwner),
    resourceType: (0, $cyZcy.JiraPlaybookAriResourceType),
    resourceIdSlug: "activation/{activationId}/{playbookId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        playbookId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/jira/playbook/index.ts
var $492c036ba5123279$export$2b27259a6ef92c74 = class _JiraPlaybookAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._playbookId = opts.resourceIdSegmentValues.playbookId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get playbookId() {
        return this._playbookId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $492c036ba5123279$var$jiraPlaybookAriStaticOpts.qualifier,
            platformQualifier: $492c036ba5123279$var$jiraPlaybookAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $492c036ba5123279$var$jiraPlaybookAriStaticOpts.resourceOwner,
            resourceType: $492c036ba5123279$var$jiraPlaybookAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.playbookId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                playbookId: opts.playbookId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $492c036ba5123279$var$jiraPlaybookAriStaticOpts);
        return new _JiraPlaybookAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $492c036ba5123279$var$jiraPlaybookAriStaticOpts);
        return new _JiraPlaybookAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            playbookId: this.playbookId
        };
    }
};

});
parcelRegister("cyZcy", function(module, exports) {

$parcel$export(module.exports, "JiraPlaybookAriResourceOwner", () => $9258225fc0ac187a$export$91235105b4a9ebd9);
$parcel$export(module.exports, "JiraPlaybookAriResourceType", () => $9258225fc0ac187a$export$5af5bf4e6f11326f);
// src/jira/playbook/types.ts
var $9258225fc0ac187a$export$91235105b4a9ebd9 = "jira", $9258225fc0ac187a$export$5af5bf4e6f11326f = "playbook";

});


parcelRegister("04BO2", function(module, exports) {

$parcel$export(module.exports, "getProjectUrl", () => $27b6cf49cbe4c1ee$export$951b86b8e730b952);
$parcel$export(module.exports, "getRequestTypesUrl", () => $27b6cf49cbe4c1ee$export$9d7c743b509e267);
$parcel$export(module.exports, "getChangeRequestTypesUrl", () => $27b6cf49cbe4c1ee$export$6096ac65eb900914);
$parcel$export(module.exports, "getProjectSettingsPageUrl", () => $27b6cf49cbe4c1ee$export$75ee62cffcd82d96);
$parcel$export(module.exports, "getProjectSettingsUrl", () => $27b6cf49cbe4c1ee$export$a497c8f8c3782075);
$parcel$export(module.exports, "getWorkflowSettingsUrl", () => $27b6cf49cbe4c1ee$export$c2a8139910ee6c);
$parcel$export(module.exports, "getJsmChangeEditionUrl", () => $27b6cf49cbe4c1ee$export$b87292f363462760);
$parcel$export(module.exports, "getUserManagementUrl", () => $27b6cf49cbe4c1ee$export$13f39b40814e5f3e);

var $2vSU6 = parcelRequire("2vSU6");

var $02Psx = parcelRequire("02Psx");

var $l3Iek = parcelRequire("l3Iek");

var $cmEH1 = parcelRequire("cmEH1");

var $2iuKi = parcelRequire("2iuKi");

var $9VXkC = parcelRequire("9VXkC");
const $27b6cf49cbe4c1ee$export$951b86b8e730b952 = (projectKey)=>(0, $9VXkC.generatePath)((0, $2iuKi.projectsRedirectRoute).path, {
        projectKey: projectKey
    });
const $27b6cf49cbe4c1ee$var$getNextgenIssueTypesUrl = (projectKey, issueTypeId)=>(0, $02Psx.getNextgenSettingsIssueTypesUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey, issueTypeId);
const $27b6cf49cbe4c1ee$export$9d7c743b509e267 = (projectKey, isSimplified = false)=>isSimplified ? $27b6cf49cbe4c1ee$var$getNextgenIssueTypesUrl(projectKey) : (0, $9VXkC.generatePath)((0, $cmEH1.projectSettingsServicedeskTicketTypesConfigRoute).path, {
        projectKey: projectKey
    });
const $27b6cf49cbe4c1ee$export$6096ac65eb900914 = (projectKey, isSimplified = false)=>isSimplified ? $27b6cf49cbe4c1ee$var$getNextgenIssueTypesUrl(projectKey) : `${$27b6cf49cbe4c1ee$export$9d7c743b509e267(projectKey, isSimplified)}/category/changes`;
const $27b6cf49cbe4c1ee$export$75ee62cffcd82d96 = (projectKey, relativeUrl)=>`/jira/servicedesk/projects/${projectKey}/settings/${relativeUrl}`;
const $27b6cf49cbe4c1ee$export$a497c8f8c3782075 = (projectKey, isSimplified = false)=>{
    const classicSettingsUrl = `/plugins/servlet/project-config/${projectKey}`;
    return isSimplified ? $27b6cf49cbe4c1ee$var$getNextgenIssueTypesUrl(projectKey) : classicSettingsUrl;
};
const $27b6cf49cbe4c1ee$export$c2a8139910ee6c = (projectKey, issueTypeId, isSimplified = false)=>{
    if (!issueTypeId) return isSimplified ? $27b6cf49cbe4c1ee$var$getNextgenIssueTypesUrl(projectKey) : (0, $9VXkC.generatePath)((0, $l3Iek.legacyProjectSettingsWorkflowsRoute).path, {
        projectKey: projectKey
    });
    return isSimplified ? $27b6cf49cbe4c1ee$var$getNextgenIssueTypesUrl(projectKey, issueTypeId) : `/plugins/servlet/project-config/${projectKey}/issuetypes/${issueTypeId}/workflow`;
};
const $27b6cf49cbe4c1ee$export$b87292f363462760 = ()=>'/admin/billing/applications/change-edition/jira-servicedesk.ondemand';
const $27b6cf49cbe4c1ee$export$13f39b40814e5f3e = ()=>'/admin/users?referrerName=JIRA';

});
parcelRegister("l3Iek", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsWorkflowsRoute", () => $31816b9f42bcb36a$export$b03606cedffdadf6);
const $31816b9f42bcb36a$export$b03606cedffdadf6 = {
    name: 'legacy-project-settings-workflows',
    path: '/plugins/servlet/project-config/:projectKey/workflows'
};

});


parcelRegister("iMvey", function(module, exports) {

$parcel$export(module.exports, "DragState", () => $a810461a6c4da09f$export$4e38e1908f8d60cc);
$parcel$export(module.exports, "DETAILS_QUERY_PARAM_VALUE", () => $a810461a6c4da09f$export$4ff6caac8d343661);
$parcel$export(module.exports, "STEP_QUERY_PARAM", () => $a810461a6c4da09f$export$10d60ba8ee33b6cd);
$parcel$export(module.exports, "NEW_PLAYBOOK_IDENTIFIER", () => $a810461a6c4da09f$export$ddc22677c31f7347);
$parcel$export(module.exports, "NEW_STEP_IDENTIFIER", () => $a810461a6c4da09f$export$a1049a464ef7c857);
const $a810461a6c4da09f$export$4e38e1908f8d60cc = {
    IDLE: 'idle',
    PREVIEW: 'preview',
    DRAGGING: 'dragging'
};
const $a810461a6c4da09f$export$4ff6caac8d343661 = 'details';
const $a810461a6c4da09f$export$10d60ba8ee33b6cd = 'step';
const $a810461a6c4da09f$export$ddc22677c31f7347 = '_new_';
const $a810461a6c4da09f$export$a1049a464ef7c857 = '_new_';

});




parcelRegister("hRMW9", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationEditRuleRouteEntry", () => $e2d087af8b87ec7f$export$568d8653c06c756e);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $7qLRc = parcelRequire("7qLRc");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2sKYo = parcelRequire("2sKYo");
const $e2d087af8b87ec7f$export$568d8653c06c756e = (0, $7NszV.createEntry)((0, $7qLRc.projectSettingsServicedeskAutomationEditRuleRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.edit-rule',
        component: (0, $2sKYo.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2sKYo.LazyProjectSettingsServiceDeskAutomationEditRule)
        ]
    }));

});
parcelRegister("7qLRc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationEditRuleRoute", () => $eafa82ab5994f857$export$9f1e5391e2d6f95);
const $eafa82ab5994f857$export$9f1e5391e2d6f95 = {
    name: 'project-settings-servicedesk-automation-edit-rule',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/ruleset/:ruleId'
};

});

parcelRegister("2sKYo", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationEditRule", () => $0645e13982e9c11f$export$c1c9a68738a9ab36);
$parcel$export(module.exports, "default", () => $0645e13982e9c11f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $0645e13982e9c11f$export$c1c9a68738a9ab36 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("fWRGt")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-edit-rule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0645e13982e9c11f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0645e13982e9c11f$export$c1c9a68738a9ab36,
        pageId: "project-settings-automation-edit-rule",
        shouldShowSpinner: true
    });

});
parcelRegister("fWRGt", function(module, exports) {

let $b9c5ea56d3750199$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b9c5ea56d3750199$var$load("1PFOk").then(()=>parcelRequire('44UJy'));

});



parcelRegister("9eiXm", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationCopyRuleRouteEntry", () => $051ebb61cb8e5385$export$1cfe280529d4ebf8);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $86FuT = parcelRequire("86FuT");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $9zLHs = parcelRequire("9zLHs");
const $051ebb61cb8e5385$export$1cfe280529d4ebf8 = (0, $7NszV.createEntry)((0, $86FuT.projectSettingsServicedeskAutomationCopyRuleRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.copy-rule',
        component: (0, $9zLHs.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9zLHs.LazyProjectSettingsServiceDeskAutomationCopyRule)
        ]
    }));

});
parcelRegister("86FuT", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationCopyRuleRoute", () => $01244213b237aa9a$export$9aa8ef0c982cee2f);
const $01244213b237aa9a$export$9aa8ef0c982cee2f = {
    name: 'project-settings-servicedesk-automation-copy-rule',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/copy/:ruleId'
};

});

parcelRegister("9zLHs", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationCopyRule", () => $10ca54f4f21ea64a$export$4a3b5f6370555dbc);
$parcel$export(module.exports, "default", () => $10ca54f4f21ea64a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $10ca54f4f21ea64a$export$4a3b5f6370555dbc = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("gIery")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-copy-rule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$10ca54f4f21ea64a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $10ca54f4f21ea64a$export$4a3b5f6370555dbc,
        pageId: "project-settings-automation-copy-rule",
        shouldShowSpinner: true
    });

});
parcelRegister("gIery", function(module, exports) {

let $c2abf596ed0b6162$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c2abf596ed0b6162$var$load("kkgDQ").then(()=>parcelRequire('9Qg7T'));

});



parcelRegister("D5QBq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationCreateRouteEntry", () => $89415bba0f887370$export$f1e32463088d9246);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $ivLNh = parcelRequire("ivLNh");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $cNpXW = parcelRequire("cNpXW");
const $89415bba0f887370$export$f1e32463088d9246 = (0, $7NszV.createEntry)((0, $ivLNh.projectSettingsServicedeskAutomationCreateRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.create-rule',
        component: (0, $cNpXW.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cNpXW.LazyProjectSettingsServiceDeskAutomationCreateRule)
        ]
    }));

});
parcelRegister("ivLNh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationCreateRoute", () => $50f5a58676cb66d1$export$6f20ce2991881c20);
const $50f5a58676cb66d1$export$6f20ce2991881c20 = {
    name: 'project-settings-servicedesk-automation-create',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/blueprint/:blueprintKey'
};

});

parcelRegister("cNpXW", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationCreateRule", () => $2a5fc816810cf307$export$5b197b51eb5ad982);
$parcel$export(module.exports, "default", () => $2a5fc816810cf307$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $2a5fc816810cf307$export$5b197b51eb5ad982 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("hTVXo")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-create-rule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2a5fc816810cf307$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2a5fc816810cf307$export$5b197b51eb5ad982,
        pageId: "project-settings-automation-create-rule",
        shouldShowSpinner: true
    });

});
parcelRegister("hTVXo", function(module, exports) {

let $d08487c6ecfc9a5a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d08487c6ecfc9a5a$var$load("7C5bc").then(()=>parcelRequire('7uVkM'));

});



parcelRegister("4eKYR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationViewLogRouteEntry", () => $6d458a597bcccee8$export$ddc45b708634b66);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $edDQg = parcelRequire("edDQg");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $i7FI3 = parcelRequire("i7FI3");
const $6d458a597bcccee8$export$ddc45b708634b66 = (0, $7NszV.createEntry)((0, $edDQg.projectSettingsServicedeskAutomationViewLogRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.log',
        component: (0, $i7FI3.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $i7FI3.LazyProjectSettingsServiceDeskAutomationViewLog)
        ]
    }));

});
parcelRegister("edDQg", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationViewLogRoute", () => $3068172667b89342$export$ea3acd3ad4eb7d38);
const $3068172667b89342$export$ea3acd3ad4eb7d38 = {
    name: 'project-settings-servicedesk-automation-view-log',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/log/:ruleId'
};

});

parcelRegister("i7FI3", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationViewLog", () => $6f8757b068912193$export$db6c5cdbc65b2b4a);
$parcel$export(module.exports, "default", () => $6f8757b068912193$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $6f8757b068912193$export$db6c5cdbc65b2b4a = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("7sbz1")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-view-log/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6f8757b068912193$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6f8757b068912193$export$db6c5cdbc65b2b4a,
        pageId: "project-settings-automation-view-log",
        shouldShowSpinner: true
    });

});
parcelRegister("7sbz1", function(module, exports) {

let $56d41e45f1921632$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56d41e45f1921632$var$load("hKaWl").then(()=>parcelRequire('5jbPW'));

});



parcelRegister("5W0wg", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationSummaryRouteEntry", () => $54707b820bd59983$export$4d6e0242b09fef3b);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $jowOt = parcelRequire("jowOt");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5G6Zw = parcelRequire("5G6Zw");
const $54707b820bd59983$export$4d6e0242b09fef3b = (0, $7NszV.createEntry)((0, $jowOt.projectSettingsServicedeskAutomationSummaryRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.summary',
        component: (0, $5G6Zw.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5G6Zw.LazyProjectSettingsServiceDeskAutomationSummary)
        ]
    }));

});
parcelRegister("jowOt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationSummaryRoute", () => $634728c55a499ff5$export$165d82a2618e4d99);
const $634728c55a499ff5$export$165d82a2618e4d99 = {
    name: 'project-settings-servicedesk-automation-summary',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation'
};

});

parcelRegister("5G6Zw", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationSummary", () => $8a03171b9122a104$export$2fc8c3fcbb365b89);
$parcel$export(module.exports, "default", () => $8a03171b9122a104$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $8a03171b9122a104$export$2fc8c3fcbb365b89 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("8Eveu")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-summary/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8a03171b9122a104$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8a03171b9122a104$export$2fc8c3fcbb365b89,
        pageId: "project-settings-automation-summary",
        shouldShowSpinner: true
    });

});
parcelRegister("8Eveu", function(module, exports) {

let $64ca4958ce994210$var$load = (parcelRequire("28QjX"))(4);
module.exports = $64ca4958ce994210$var$load("9udti").then(()=>parcelRequire('6kXBX'));

});



parcelRegister("aQ85T", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCreateRouteEntry", () => $4e9c4987ebea2357$export$fc7d1f3302418153);

var $7NszV = parcelRequire("7NszV");

var $gzxoX = parcelRequire("gzxoX");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6g6uF = parcelRequire("6g6uF");
const $4e9c4987ebea2357$export$fc7d1f3302418153 = (0, $7NszV.createEntry)((0, $gzxoX.projectSettingsServicedeskLegacyAutomationRedirectCreateRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $6g6uF.automationRedirect)('create')
    }));

});
parcelRegister("gzxoX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCreateRoute", () => $180ffea8026c8f05$export$c2a59dbe6d23efd4);
const $180ffea8026c8f05$export$c2a59dbe6d23efd4 = {
    name: 'project-settings-servicedesk-automation-redirect-create',
    path: '/projects/:projectKey/settings/automation/blueprint/:blueprintKey'
};

});

parcelRegister("6g6uF", function(module, exports) {

$parcel$export(module.exports, "automationRedirect", () => $69d1eaf61634b750$export$d6674bfa636b8090);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $02Psx = parcelRequire("02Psx");

var $g5X3G = parcelRequire("g5X3G");

var $7tQej = parcelRequire("7tQej");
const $69d1eaf61634b750$var$newAutomationUrl = (baseUrl, { match: match }, pageType)=>{
    const { projectKey: projectKey } = match.params;
    if (pageType === 'edit') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), String(projectKey))}/automation/ruleset/${ruleId || ''}`;
    }
    if (pageType === 'copy') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), String(projectKey))}/automation/copy/${ruleId || ''}`;
    }
    if (pageType === 'viewlog') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), String(projectKey))}/automation/log/${ruleId || ''}`;
    }
    if (pageType === 'create') {
        const { blueprintKey: blueprintKey } = match.params;
        return `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), String(projectKey))}/automation/blueprint/${blueprintKey || ''}`;
    }
    return `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), String(projectKey))}/automation`;
};
const $69d1eaf61634b750$export$d6674bfa636b8090 = (pageType)=>(routeContext)=>{
        // use empty string instead of actual baseUrl as router redirect handles it internally
        const emptyBaseUrl = (0, $g5X3G.toBaseUrl)('');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: $69d1eaf61634b750$var$newAutomationUrl(emptyBaseUrl, routeContext, pageType),
            push: false
        });
    };

});


parcelRegister("6kvQ5", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectEditRouteEntry", () => $d4b71d1e99902d1e$export$cf95450a3eafe8ff);

var $7NszV = parcelRequire("7NszV");

var $zrLzB = parcelRequire("zrLzB");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6g6uF = parcelRequire("6g6uF");
const $d4b71d1e99902d1e$export$cf95450a3eafe8ff = (0, $7NszV.createEntry)((0, $zrLzB.projectSettingsServicedeskLegacyAutomationRedirectEditRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $6g6uF.automationRedirect)('edit')
    }));

});
parcelRegister("zrLzB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectEditRoute", () => $7a29d6d898ef792a$export$f61e79c14e9bc0a1);
const $7a29d6d898ef792a$export$f61e79c14e9bc0a1 = {
    name: 'project-settings-servicedesk-automation-redirect-edit',
    path: '/projects/:projectKey/settings/automation/ruleset/:ruleId'
};

});


parcelRegister("bCnWj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCopyRouteEntry", () => $9834f5e7c0df5412$export$dd52be928c274980);

var $7NszV = parcelRequire("7NszV");

var $bM51X = parcelRequire("bM51X");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6g6uF = parcelRequire("6g6uF");
const $9834f5e7c0df5412$export$dd52be928c274980 = (0, $7NszV.createEntry)((0, $bM51X.projectSettingsServicedeskLegacyAutomationRedirectCopyRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $6g6uF.automationRedirect)('copy')
    }));

});
parcelRegister("bM51X", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCopyRoute", () => $60a67b19cd763b2f$export$869afe63d0e077be);
const $60a67b19cd763b2f$export$869afe63d0e077be = {
    name: 'project-settings-servicedesk-automation-redirect-copy',
    path: '/projects/:projectKey/settings/automation/copy/:ruleId'
};

});


parcelRegister("kci7Q", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectViewLogRouteEntry", () => $d28565c3ab2c87a7$export$f0eaafcdee9dfa31);

var $7NszV = parcelRequire("7NszV");

var $7wX2j = parcelRequire("7wX2j");

var $lmyls = parcelRequire("lmyls");

var $6Z2mh = parcelRequire("6Z2mh");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6g6uF = parcelRequire("6g6uF");
const $d28565c3ab2c87a7$export$f0eaafcdee9dfa31 = (0, $7NszV.createEntry)((0, $7wX2j.projectSettingsServicedeskLegacyAutomationRedirectViewLogRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $6g6uF.automationRedirect)('viewlog')
    }));

});
parcelRegister("7wX2j", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectViewLogRoute", () => $5e0bbde66fde5bf7$export$e6e772830a33ba0b);
const $5e0bbde66fde5bf7$export$e6e772830a33ba0b = {
    name: 'project-settings-servicedesk-automation-redirect-viewlog',
    path: '/projects/:projectKey/settings/automation/log/:ruleId'
};

});


parcelRegister("9Dd5o", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectSummaryRouteEntry", () => $c179245528a3d6e0$export$d6873ef17e5a0ea5);

var $7NszV = parcelRequire("7NszV");

var $1N14b = parcelRequire("1N14b");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6g6uF = parcelRequire("6g6uF");
const $c179245528a3d6e0$export$d6873ef17e5a0ea5 = (0, $7NszV.createEntry)((0, $1N14b.projectSettingsServicedeskLegacyAutomationRedirectSummaryRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $6g6uF.automationRedirect)('summary')
    }));

});
parcelRegister("1N14b", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectSummaryRoute", () => $4fd4ba182f3de844$export$fdd432d4e600f9);
const $4fd4ba182f3de844$export$fdd432d4e600f9 = {
    name: 'project-settings-servicedesk-automation-redirect-summary',
    path: '/projects/:projectKey/settings/automation/'
};

});


parcelRegister("h4Pr8", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskCustomerNotificationsRouteEntry", () => $90cce0d970ed183f$export$5a4abc64d2a82698);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $1XuFh = parcelRequire("1XuFh");

var $6Z2mh = parcelRequire("6Z2mh");

var $hASB6 = parcelRequire("hASB6");
const $90cce0d970ed183f$export$5a4abc64d2a82698 = (0, $7NszV.createEntry)((0, $1XuFh.projectSettingsServicedeskCustomerNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $hASB6.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hASB6.LazyProjectSettingsServiceDeskCustomerNotifications)
        ]
    }));

});
parcelRegister("hASB6", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskCustomerNotifications", () => $6081b8204512e323$export$c763ea321ade5f68);
$parcel$export(module.exports, "default", () => $6081b8204512e323$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kKHTt = parcelRequire("kKHTt");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $6081b8204512e323$export$c763ea321ade5f68 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("4hCWd")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-notifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6081b8204512e323$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKHTt.HelpCenterSettingsRedirect), {
        page: "customer-notifications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6081b8204512e323$export$c763ea321ade5f68,
        pageId: "project-settings-customer-notifications",
        shouldShowSpinner: true
    }));

});
parcelRegister("4hCWd", function(module, exports) {

let $31e6f4352814f5f2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $31e6f4352814f5f2$var$load("lxzGu").then(()=>parcelRequire('jp5Rx'));

});



parcelRegister("5XbrB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsCustomerNotificationsRouteEntry", () => $d08875f655bb322d$export$b4d122e49516c10d);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $3BQ4q = parcelRequire("3BQ4q");

var $6Z2mh = parcelRequire("6Z2mh");

var $kFrbC = parcelRequire("kFrbC");

var $hASB6 = parcelRequire("hASB6");
const $d08875f655bb322d$export$b4d122e49516c10d = (0, $7NszV.createEntry)((0, $3BQ4q.projectSettingsServicedeskNotificationsCustomerNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $kFrbC.ServiceDeskCustomerNotificationsNextGenRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hASB6.LazyProjectSettingsServiceDeskCustomerNotifications)
        ]
    }));

});
parcelRegister("kFrbC", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskCustomerNotificationsNextGenRedirect", () => $aa137e884608085b$export$8249a46a710af6da);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $aa137e884608085b$export$8249a46a710af6da = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-notifications`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});


parcelRegister("1ods3", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneysRouteEntry", () => $b1d24e5a00ab7abb$export$6c014a8c741bf222);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $2j3DA = parcelRequire("2j3DA");

var $6Z2mh = parcelRequire("6Z2mh");

var $4R6GH = parcelRequire("4R6GH");

var $g2OFQ = parcelRequire("g2OFQ");
const $b1d24e5a00ab7abb$export$6c014a8c741bf222 = (0, $7NszV.createEntry)((0, $2j3DA.projectSettingsServicedeskJourneysRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: 'jsm.journey-builder.journeys-list',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('journeys-list'),
                teamName: 'JSM Getting Started'
            }
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        entryPoint: ()=>(0, $4R6GH.fg)('jsm-journey-builder') ? (0, $g2OFQ.journeysPageEntryPoint) : undefined
    }));

});
parcelRegister("2j3DA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneysRoute", () => $705088c1cf32c92a$export$627d71a1dd7a9593);
const $705088c1cf32c92a$export$627d71a1dd7a9593 = {
    name: 'project-settings-servicedesk-journeys',
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys',
    exact: true
};

});

parcelRegister("g2OFQ", function(module, exports) {

$parcel$export(module.exports, "journeysPageEntryPoint", () => $afecb2c38eb0ad75$export$3b90f0eb27bdd52f);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $bbmu4 = parcelRequire("bbmu4");
const $afecb2c38eb0ad75$export$3b90f0eb27bdd52f = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $bbmu4.journeysEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("bbmu4", function(module, exports) {

$parcel$export(module.exports, "journeysEntryPoint", () => $1cbf56bd5b792bd0$export$4ded7f93dbe6eb63);

var $8FYy8 = parcelRequire("8FYy8");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $4R6GH = parcelRequire("4R6GH");

const $1cbf56bd5b792bd0$export$4ded7f93dbe6eb63 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("chFhu")), {
        moduleId: "ab11e2ef",
        moduleName: "JourneysPage"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                journeysPageQueryRef: {
                    parameters: $8FYy8.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey || '',
                        isFGEnabled: (0, $4R6GH.fg)('journey_builder_support_versioning')
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("8FYy8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dab8bc029613fb5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7e8254497be74fe1420b745f075025fe>>
 * @relayHash 9a9861d3247c936a35bd5e9ede43dec9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fc9ce67d4f42bf19709e27394ddcec5fd75853763835e0101d01770eaf3168dc
const $0dab8bc029613fb5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fc9ce67d4f42bf19709e27394ddcec5fd75853763835e0101d01770eaf3168dc",
        "metadata": {},
        "name": "JourneysPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0dab8bc029613fb5$export$2e2bcd8739ae039 = $0dab8bc029613fb5$var$node;

});

parcelRegister("chFhu", function(module, exports) {

let $8f17181dbe17b2bd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8f17181dbe17b2bd$var$load("g2xfa").then(()=>parcelRequire('iSwlg'));

});




parcelRegister("gpVZm", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationRouteEntry", () => $d346a4266360b0ae$export$7475316a4561dd76);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $gyJ1H = parcelRequire("gyJ1H");

var $6Z2mh = parcelRequire("6Z2mh");

var $4R6GH = parcelRequire("4R6GH");

var $8LFLY = parcelRequire("8LFLY");
const $d346a4266360b0ae$export$7475316a4561dd76 = (0, $7NszV.createEntry)((0, $gyJ1H.projectSettingsServicedeskJourneyConfigurationRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: 'jsm.journey-builder.journey-config',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('journey-config'),
                teamName: 'JSM Getting Started'
            }
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        entryPoint: ()=>(0, $4R6GH.fg)('jsm-journey-builder') ? (0, $8LFLY.journeyConfigPageEntryPoint) : undefined
    }));

});
parcelRegister("gyJ1H", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationRoute", () => $9a0c0a603e702cf3$export$9013e78604bfadb0);
const $9a0c0a603e702cf3$export$9013e78604bfadb0 = {
    name: 'project-settings-servicedesk-journey-configuration',
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys/:journeyId',
    exact: true
};

});

parcelRegister("8LFLY", function(module, exports) {

$parcel$export(module.exports, "journeyConfigPageEntryPoint", () => $e2e16678033c3122$export$35537410b0bf07ea);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $3HGnZ = parcelRequire("3HGnZ");
const $e2e16678033c3122$export$35537410b0bf07ea = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3HGnZ.journeyConfigEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("3HGnZ", function(module, exports) {

$parcel$export(module.exports, "journeyConfigEntryPoint", () => $1dfcd84f3f61c84b$export$26f82de7820f0c3);

var $lyoHt = parcelRequire("lyoHt");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $1dfcd84f3f61c84b$export$26f82de7820f0c3 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("8Ghxi")), {
        moduleId: "6bffb775",
        moduleName: "JourneyConfigurationPage"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        return {
            queries: {
                jiraJourneyConfiguration: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $lyoHt.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        journeyId: context.match.params.journeyId ?? '',
                        isEditing: context.match.path?.includes('journeys/:journeyId/edit')
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        };
    }
});

});
parcelRegister("lyoHt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c24657e8d4ddd13$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c0b0de939ecbe5fc805d6096ceba127>>
 * @relayHash 5edc109846e2ab57cb9baa48e241d845
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5ba739e82845a4af8ea03eed56bf5e521d73104e3c0e55784e6f61d9d3f2c644
const $5c24657e8d4ddd13$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5ba739e82845a4af8ea03eed56bf5e521d73104e3c0e55784e6f61d9d3f2c644",
        "metadata": {},
        "name": "JourneyConfigurationPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5c24657e8d4ddd13$export$2e2bcd8739ae039 = $5c24657e8d4ddd13$var$node;

});

parcelRegister("8Ghxi", function(module, exports) {

let $651fd93e1051d790$var$load = (parcelRequire("28QjX"))(4);
module.exports = $651fd93e1051d790$var$load("iUjK0").then(()=>parcelRequire('aG5pa'));

});




parcelRegister("i8buc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationEditRouteEntry", () => $c37fb91c4e26e536$export$5cbb0a0098e65c64);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $2ki4m = parcelRequire("2ki4m");

var $6Z2mh = parcelRequire("6Z2mh");

var $4R6GH = parcelRequire("4R6GH");

var $2pLla = parcelRequire("2pLla");
const $c37fb91c4e26e536$export$5cbb0a0098e65c64 = (0, $7NszV.createEntry)((0, $2ki4m.projectSettingsServicedeskJourneyConfigurationEditRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: 'jsm.journey-builder.journey-config',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('journey-config'),
                teamName: 'JSM Getting Started'
            }
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        entryPoint: ()=>(0, $4R6GH.fg)('journey_builder_support_versioning') ? (0, $2pLla.journeyConfigEditPageEntryPoint) : undefined
    }));

});
parcelRegister("2ki4m", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationEditRoute", () => $5908f0de6ed8a95e$export$f80f582ef54900c6);
const $5908f0de6ed8a95e$export$f80f582ef54900c6 = {
    name: 'project-settings-servicedesk-journey-configuration-edit',
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys/:journeyId/edit',
    exact: true
};

});

parcelRegister("2pLla", function(module, exports) {

$parcel$export(module.exports, "journeyConfigEditPageEntryPoint", () => $fdfad37cd3d1b2d6$export$7388ef888b9170a7);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $3HGnZ = parcelRequire("3HGnZ");
const $fdfad37cd3d1b2d6$export$7388ef888b9170a7 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3HGnZ.journeyConfigEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});


parcelRegister("hqIff", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskKbRouteEntry", () => $f4ec187fc157720c$export$d43e914d37d059b8);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2m3cT = parcelRequire("2m3cT");

var $6Z2mh = parcelRequire("6Z2mh");

var $gw09t = parcelRequire("gw09t");
const $f4ec187fc157720c$export$d43e914d37d059b8 = (0, $7NszV.createEntry)((0, $2m3cT.projectSettingsServicedeskKbRoute), ()=>({
        group: 'project-settings-servicedesk',
        perfMetricKey: 'service-management.kb-settings',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        component: (0, $gw09t.ServiceDeskKnowledgeBaseV2),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gw09t.LazyProjectSettingsServiceDeskKnowledgeBaseV2)
        ],
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ]
    }));

});
parcelRegister("gw09t", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskKnowledgeBaseV2", () => $0bf88a8d63415148$export$7c7186fdd8c56428);
$parcel$export(module.exports, "ServiceDeskKnowledgeBaseV2", () => $0bf88a8d63415148$export$6d92735e249274bb);

var $5uXOq = parcelRequire("5uXOq");

var $kKHTt = parcelRequire("kKHTt");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");
const $0bf88a8d63415148$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
const $0bf88a8d63415148$export$1aa47348ef6dbdda = 'project/service-desk/settings';

const $0bf88a8d63415148$export$583a442626bd3345 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("5pDyC")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-knowledge-base/src/index.tsx"
});

const $0bf88a8d63415148$export$7c7186fdd8c56428 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kTirX"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-settings/src/index.tsx"
});
const $0bf88a8d63415148$export$6d92735e249274bb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKHTt.HelpCenterSettingsRedirect), {
        page: "kb"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0bf88a8d63415148$export$7c7186fdd8c56428,
        pageId: "project-settings-knowledge-base",
        shouldShowSpinner: true
    }));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0bf88a8d63415148$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0bf88a8d63415148$export$583a442626bd3345,
        pageId: "project-settings-knowledge-base",
        shouldShowSpinner: true
    });

});
parcelRegister("5pDyC", function(module, exports) {

let $3f0df8cd03cfb76c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3f0df8cd03cfb76c$var$load("84U6s").then(()=>parcelRequire('2fak7'));

});

parcelRegister("kTirX", function(module, exports) {

let $f3574172eb0d2a0e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f3574172eb0d2a0e$var$load("h2MrD"),
    $f3574172eb0d2a0e$var$load("bYT2S"),
    $f3574172eb0d2a0e$var$load("2IJUz")
]).then(()=>parcelRequire('gCbsh'));

});



parcelRegister("1Y5eu", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypeFieldsRouteEntry", () => $d537ae27f4e9ad4c$export$515ee5ae44539ca4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $eUvlM = parcelRequire("eUvlM");

var $iWVTz = parcelRequire("iWVTz");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $bO6K2 = parcelRequire("bO6K2");
const $d537ae27f4e9ad4c$export$515ee5ae44539ca4 = (0, $7NszV.createEntry)((0, $iWVTz.projectSettingsServicedeskUnassignedTicketTypeFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $bO6K2.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $eUvlM.servicedeskPracticesResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bO6K2.LazyProjectSettingsServiceDeskTicketTypeFields)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-servicedesk-ticket-type-fields'
    }));

});
parcelRegister("iWVTz", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypeFieldsRoute", () => $0ce9ec8fbf444bc7$export$f7a986e844a111a6);
const $0ce9ec8fbf444bc7$export$f7a986e844a111a6 = {
    exact: true,
    name: 'project-settings-servicedesk-unassigned-ticket-type-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/unassigned/request-type/:requestTypeId/:tabKey?'
};

});

parcelRegister("bO6K2", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskTicketTypeFields", () => $e9f2572a89172526$export$471040ce01e559fc);
$parcel$export(module.exports, "default", () => $e9f2572a89172526$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kKHTt = parcelRequire("kKHTt");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $e9f2572a89172526$export$471040ce01e559fc = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("8rqWd")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-type-fields/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e9f2572a89172526$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKHTt.HelpCenterSettingsRedirect), {
        page: "ticket-type-fields"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e9f2572a89172526$export$471040ce01e559fc,
        pageId: "project-settings-ticket-type-fields",
        shouldShowSpinner: true
    }));

});
parcelRegister("8rqWd", function(module, exports) {

let $6255bdae1b3e73ac$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6255bdae1b3e73ac$var$load("h2MrD"),
    $6255bdae1b3e73ac$var$load("bYT2S"),
    $6255bdae1b3e73ac$var$load("9pCQy")
]).then(()=>parcelRequire('73hU9'));

});



parcelRegister("kkXdG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypeFieldsRouteEntry", () => $2aef83b11784cadf$export$49692fb0973d60ca);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $eUvlM = parcelRequire("eUvlM");

var $gfgJe = parcelRequire("gfgJe");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $bO6K2 = parcelRequire("bO6K2");
const $2aef83b11784cadf$export$49692fb0973d60ca = (0, $7NszV.createEntry)((0, $gfgJe.projectSettingsServicedeskItsmTicketTypeFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $bO6K2.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $eUvlM.servicedeskPracticesResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bO6K2.LazyProjectSettingsServiceDeskTicketTypeFields)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-servicedesk-ticket-type-fields'
    }));

});
parcelRegister("gfgJe", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypeFieldsRoute", () => $e91beb008e9026ec$export$1af0541fcb95547b);
const $e91beb008e9026ec$export$1af0541fcb95547b = {
    exact: true,
    name: 'project-settings-servicedesk-itsm-ticket-type-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice/request-type/:requestTypeId/:tabKey?'
};

});


parcelRegister("gPxpf", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskTicketTypeFieldsRouteEntry", () => $4fa5116a5c8fa3c1$export$30951c6038a30ec4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $eUvlM = parcelRequire("eUvlM");

var $7mt6L = parcelRequire("7mt6L");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $bO6K2 = parcelRequire("bO6K2");
const $4fa5116a5c8fa3c1$export$30951c6038a30ec4 = (0, $7NszV.createEntry)((0, $7mt6L.projectSettingsServicedeskTicketTypeFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $bO6K2.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $eUvlM.servicedeskPracticesResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bO6K2.LazyProjectSettingsServiceDeskTicketTypeFields)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-servicedesk-ticket-type-fields'
    }));

});
parcelRegister("7mt6L", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskTicketTypeFieldsRoute", () => $28fb213ff0720fc3$export$6c99c477ef7583ba);
const $28fb213ff0720fc3$export$6c99c477ef7583ba = {
    exact: true,
    name: 'project-settings-servicedesk-ticket-type-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/request-type/:requestTypeId/:tabKey?'
};

});


parcelRegister("3FG4O", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypesConfigRouteEntry", () => $13309764c6efb114$export$6ba31a548ab77c4);

var $ffza4 = parcelRequire("ffza4");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $2pT4g = parcelRequire("2pT4g");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $k8jl5 = parcelRequire("k8jl5");

var $1cpsA = parcelRequire("1cpsA");

var $eUvlM = parcelRequire("eUvlM");

var $6sNnq = parcelRequire("6sNnq");

var $9xhY2 = parcelRequire("9xhY2");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $dEPxR = parcelRequire("dEPxR");

var $lkFvK = parcelRequire("lkFvK");

var $4stgq = parcelRequire("4stgq");
const $13309764c6efb114$var$projectSettingsServicedeskUnassignedTicketTypesConfigPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dEPxR.TicketTypesConfigEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $13309764c6efb114$export$6ba31a548ab77c4 = (0, $7NszV.createEntry)((0, $9xhY2.projectSettingsServicedeskUnassignedTicketTypesConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $4stgq.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $eUvlM.servicedeskPracticesResource),
            (0, $k8jl5.servicedeskIssueTypesResource),
            (0, $1cpsA.servicedeskPortalGroupsResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $2pT4g.jsmRepackagingBannerResource),
            (0, $6sNnq.featuresResource)
        ],
        entryPoint () {
            if ((0, $4R6GH.fg)('request_type_table_uplift')) return $13309764c6efb114$var$projectSettingsServicedeskUnassignedTicketTypesConfigPageEntrypoint;
            return undefined;
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4stgq.LazyProjectSettingsServiceDeskTicketTypesConfig)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration'
    }));

});
parcelRegister("1cpsA", function(module, exports) {

$parcel$export(module.exports, "servicedeskPortalGroupsResource", () => $2ddee7630453f9bc$export$c7fb28234b909b2f);

var $2M1hQ = parcelRequire("2M1hQ");


const $2ddee7630453f9bc$var$getDataLoader = ()=>(parcelRequire("jWeop"));
const $2ddee7630453f9bc$var$ONE_DAY_IN_MILLIS = 86400000;
const $2ddee7630453f9bc$export$c7fb28234b909b2f = (0, $2M1hQ.createResource)({
    type: (0, $1e9c4adda1725c92$export$4160f2c498fcd32e),
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: $2ddee7630453f9bc$var$getDataLoader,
    maxAge: $2ddee7630453f9bc$var$ONE_DAY_IN_MILLIS
});

});
const $1e9c4adda1725c92$export$4160f2c498fcd32e = 'SERVICEDESK_PORTAL_GROUPS';

parcelRegister("jWeop", function(module, exports) {

let $e83e9935cdca7ba4$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e83e9935cdca7ba4$var$load("eNmuD"),
    $e83e9935cdca7ba4$var$load("4lrTa")
]).then(()=>parcelRequire('7sMSo'));

});


parcelRegister("dEPxR", function(module, exports) {

$parcel$export(module.exports, "TicketTypesConfigEntrypoint", () => $67e2a135ba1dfc6c$export$85bc484c6bab022d);

var $cfawy = parcelRequire("cfawy");

var $3rdd7 = parcelRequire("3rdd7");

var $jfTHL = parcelRequire("jfTHL");

const $67e2a135ba1dfc6c$export$85bc484c6bab022d = (0, $3rdd7.createEntryPoint)({
    root: (0, $cfawy.JSResourceForUserVisible)(()=>(parcelRequire("bKST3")), {
        moduleId: "d08c0344"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const cloudId = tenantContext.cloudId;
        const projectKey = context.match.params.projectKey;
        if (!projectKey) throw new Error('Project key is required');
        return {
            entryPoints: {
                requestTypeTableEntrypoint: {
                    entryPoint: (0, $jfTHL.requestTypeTableEntrypoint),
                    entryPointParams: {
                        projectKey: projectKey,
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("jfTHL", function(module, exports) {

$parcel$export(module.exports, "requestTypeTableEntrypoint", () => $c5ac394482ac63fe$export$ecbf0c880decd2ac);

var $cfawy = parcelRequire("cfawy");

var $3rdd7 = parcelRequire("3rdd7");

var $2K2rC = parcelRequire("2K2rC");

const $c5ac394482ac63fe$export$ecbf0c880decd2ac = (0, $3rdd7.createEntryPoint)({
    root: (0, $cfawy.JSResourceForUserVisible)(()=>(parcelRequire("cRXLt")).then((module)=>module.RequestTypesTable), {
        moduleId: "44a9b8a6"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId })=>{
        return {
            queries: {
                tableSettings: {
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    },
                    parameters: $2K2rC.default,
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("2K2rC", function(module, exports) {

$parcel$export(module.exports, "default", () => $32bd8aa55825b96f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ce045fc0dd46722872f41c70f570f768>>
 * @relayHash 989e1263c7e39eb54ef3504b593961dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bc2fb1d6504af1e571c063410348f23ce17651af7eb3f1921b9b1483b8d48cc8
const $32bd8aa55825b96f$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "bc2fb1d6504af1e571c063410348f23ce17651af7eb3f1921b9b1483b8d48cc8",
        "metadata": {},
        "name": "table_RequestTypesTableQuery",
        "operationKind": "query",
        "text": null
    }
};
var $32bd8aa55825b96f$export$2e2bcd8739ae039 = $32bd8aa55825b96f$var$node;

});

parcelRegister("cRXLt", function(module, exports) {

let $95e8cb490f044a2c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $95e8cb490f044a2c$var$load("cSBwS").then(()=>parcelRequire('hBNKS'));

});


parcelRegister("bKST3", function(module, exports) {

let $88ee90fcd0bc5fbc$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $88ee90fcd0bc5fbc$var$load("h2MrD"),
    $88ee90fcd0bc5fbc$var$load("bYT2S"),
    $88ee90fcd0bc5fbc$var$load("7Ui7A")
]).then(()=>parcelRequire('aFE6U'));

});


parcelRegister("4stgq", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskTicketTypesConfig", () => $d4145a6e3aeb3bbb$export$c26e63f8b7d3b52c);
$parcel$export(module.exports, "default", () => $d4145a6e3aeb3bbb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kKHTt = parcelRequire("kKHTt");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $d4145a6e3aeb3bbb$export$c26e63f8b7d3b52c = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("1I3D1")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-types-config/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d4145a6e3aeb3bbb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKHTt.HelpCenterSettingsRedirect), {
        page: "ticket-types-config"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d4145a6e3aeb3bbb$export$c26e63f8b7d3b52c,
        pageId: "project-settings-ticket-types-config",
        shouldShowSpinner: true
    }));

});
parcelRegister("1I3D1", function(module, exports) {

let $13ecb701d583fc64$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $13ecb701d583fc64$var$load("h2MrD"),
    $13ecb701d583fc64$var$load("bYT2S"),
    $13ecb701d583fc64$var$load("b1kaE")
]).then(()=>parcelRequire('7wKb0'));

});



parcelRegister("bl8cB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypesConfigRouteEntry", () => $1761f8f0b85b3339$export$9f40815b933b51ba);

var $ffza4 = parcelRequire("ffza4");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $2pT4g = parcelRequire("2pT4g");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $k8jl5 = parcelRequire("k8jl5");

var $1cpsA = parcelRequire("1cpsA");

var $eUvlM = parcelRequire("eUvlM");

var $6sNnq = parcelRequire("6sNnq");

var $j9HCv = parcelRequire("j9HCv");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $dEPxR = parcelRequire("dEPxR");

var $lkFvK = parcelRequire("lkFvK");

var $4stgq = parcelRequire("4stgq");
const $1761f8f0b85b3339$var$projectSettingsServicedeskItsmTicketTypesConfigPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dEPxR.TicketTypesConfigEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $1761f8f0b85b3339$export$9f40815b933b51ba = (0, $7NszV.createEntry)((0, $j9HCv.projectSettingsServicedeskItsmTicketTypesConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $4stgq.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $4R6GH.fg)('request_type_table_uplift')) return $1761f8f0b85b3339$var$projectSettingsServicedeskItsmTicketTypesConfigPageEntrypoint;
            return undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $eUvlM.servicedeskPracticesResource),
            (0, $k8jl5.servicedeskIssueTypesResource),
            (0, $1cpsA.servicedeskPortalGroupsResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $2pT4g.jsmRepackagingBannerResource),
            (0, $6sNnq.featuresResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4stgq.LazyProjectSettingsServiceDeskTicketTypesConfig)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration'
    }));

});
parcelRegister("j9HCv", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypesConfigRoute", () => $6ecc0aee1a9cf675$export$52596d9b432829c);
const $6ecc0aee1a9cf675$export$52596d9b432829c = {
    exact: true,
    name: 'project-settings-servicedesk-itsm-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice'
};

});


parcelRegister("fLbia", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskTicketTypesConfigRouteEntry", () => $0acca3ff344e5eeb$export$bcc0bb7cf7f75a0f);

var $ffza4 = parcelRequire("ffza4");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $2pT4g = parcelRequire("2pT4g");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $k8jl5 = parcelRequire("k8jl5");

var $1cpsA = parcelRequire("1cpsA");

var $eUvlM = parcelRequire("eUvlM");

var $6sNnq = parcelRequire("6sNnq");

var $cmEH1 = parcelRequire("cmEH1");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $dEPxR = parcelRequire("dEPxR");

var $lkFvK = parcelRequire("lkFvK");

var $4stgq = parcelRequire("4stgq");
const $0acca3ff344e5eeb$var$projectSettingsServicedeskTicketTypesConfigPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dEPxR.TicketTypesConfigEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $0acca3ff344e5eeb$export$bcc0bb7cf7f75a0f = (0, $7NszV.createEntry)((0, $cmEH1.projectSettingsServicedeskTicketTypesConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $4stgq.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $eUvlM.servicedeskPracticesResource),
            (0, $k8jl5.servicedeskIssueTypesResource),
            (0, $1cpsA.servicedeskPortalGroupsResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $2pT4g.jsmRepackagingBannerResource),
            (0, $6sNnq.featuresResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4stgq.LazyProjectSettingsServiceDeskTicketTypesConfig)
        ],
        entryPoint () {
            if ((0, $4R6GH.fg)('request_type_table_uplift')) return $0acca3ff344e5eeb$var$projectSettingsServicedeskTicketTypesConfigPageEntrypoint;
            return undefined;
        },
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration'
    }));

});

parcelRegister("ceMKm", function(module, exports) {

$parcel$export(module.exports, "landingPageRouteEntry", () => $6f350a9dc34d5147$export$8ccc5b384e778bac);

var $b4PzF = parcelRequire("b4PzF");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $iXFkh = parcelRequire("iXFkh");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $7pflU = parcelRequire("7pflU");

var $lkFvK = parcelRequire("lkFvK");

var $8cTxW = parcelRequire("8cTxW");

var $k6R7C = parcelRequire("k6R7C");
const $6f350a9dc34d5147$var$landingPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8cTxW.landingEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $6f350a9dc34d5147$export$8ccc5b384e778bac = (0, $7NszV.createEntry)((0, $iXFkh.landingPageRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $b4PzF.isFedRamp)()) return undefined;
            return $6f350a9dc34d5147$var$landingPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $7pflU.VirtualAgentLandingSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("iXFkh", function(module, exports) {

$parcel$export(module.exports, "landingPageRoute", () => $f5084469ecd7a21e$export$8c051c399fd812a5);
const $f5084469ecd7a21e$export$8c051c399fd812a5 = {
    // We name this virtualagentonboarding without the "-" as otherwise it would trigger
    // the nesting stack, which we don't want for onboarding
    name: 'project-settings-servicedesk-virtualagentonboarding',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent'
};

});

parcelRegister("7pflU", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentLandingSkeleton", () => $450c0f05e134cd5f$export$f4b71d7b732df8a7);
/* VirtualAgentLandingSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $gU5cD = parcelRequire("gU5cD");
const $450c0f05e134cd5f$var$customStyles = null;
const $450c0f05e134cd5f$export$f4b71d7b732df8a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gU5cD))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("gU5cD", function(module, exports) {
module.exports = new URL("virtual-agent-landing-app-skeleton.tpl.e8a7897b.svg", import.meta.url).toString();

});


parcelRegister("8cTxW", function(module, exports) {

$parcel$export(module.exports, "landingEntryPoint", () => $0f9dae747ed8bf8a$export$ad927ca7512a3a01);

var $9uqwu = parcelRequire("9uqwu");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $0f9dae747ed8bf8a$export$ad927ca7512a3a01 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("3xJD4")), {
        moduleId: "06d84010"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $9uqwu.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("9uqwu", function(module, exports) {

$parcel$export(module.exports, "default", () => $588c29ffd4ee84e7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d35800e937cb2e46de55486c256f933a>>
 * @relayHash be931dc0c604a66f9d38de7a73d831b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b0d2d2a91bd794d7e5f3219657b6c356de5e3d769077be59a9c5c4818608b57

var $7oHmH = parcelRequire("7oHmH");
const $588c29ffd4ee84e7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8b0d2d2a91bd794d7e5f3219657b6c356de5e3d769077be59a9c5c4818608b57",
        "metadata": {},
        "name": "srcVirtualAgentLandingQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $588c29ffd4ee84e7$export$2e2bcd8739ae039 = $588c29ffd4ee84e7$var$node;

});

parcelRegister("3xJD4", function(module, exports) {

let $2947d925cf6b322c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2947d925cf6b322c$var$load("atp96").then(()=>parcelRequire('52WYW'));

});


parcelRegister("k6R7C", function(module, exports) {

$parcel$export(module.exports, "FedRAMPFallbackRedirectToProjectSettings", () => $91741b5f92b89992$export$3b12aad1f47d85f8);

var $3AXtK = parcelRequire("3AXtK");
const $91741b5f92b89992$export$3b12aad1f47d85f8 = (0, $3AXtK.defaultRedirectForSettings)((0, $3AXtK.SERVICE_DESK_PRODUCT));

});
parcelRegister("3AXtK", function(module, exports) {

$parcel$export(module.exports, "SERVICE_DESK_PRODUCT", () => $a6392627f74f3006$export$5575497f0592ee94);
$parcel$export(module.exports, "defaultRedirectForSettings", () => $a6392627f74f3006$export$c9b0516439c55d7a);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $a6392627f74f3006$export$5575497f0592ee94 = 'servicedesk';
const $a6392627f74f3006$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });

});



parcelRegister("UuOK7", function(module, exports) {

$parcel$export(module.exports, "aiAnswersRouteEntry", () => $6c5c5fc65aabbb89$export$7aab6c3a99455d30);

var $b4PzF = parcelRequire("b4PzF");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $e9zsZ = parcelRequire("e9zsZ");

var $aGFv5 = parcelRequire("aGFv5");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $9PZqh = parcelRequire("9PZqh");

var $mOeIa = parcelRequire("mOeIa");

var $lkFvK = parcelRequire("lkFvK");

var $k6R7C = parcelRequire("k6R7C");
const $6c5c5fc65aabbb89$var$aiAnswersPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $mOeIa.aiAnswersEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $6c5c5fc65aabbb89$export$7aab6c3a99455d30 = (0, $7NszV.createEntry)((0, $aGFv5.aiAnswersRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $b4PzF.isFedRamp)()) return undefined;
            return $6c5c5fc65aabbb89$var$aiAnswersPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $9PZqh.VirtualAgentAiAnswersSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $e9zsZ.servicedeskVirtualAgentAiAnswersKbResource)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_AI_ANSWERS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_AI_ANSWERS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("e9zsZ", function(module, exports) {

$parcel$export(module.exports, "servicedeskVirtualAgentAiAnswersKbResource", () => $adb9f25d3efd6c0f$export$6aecd43ca01da0d9);

var $2M1hQ = parcelRequire("2M1hQ");

const $adb9f25d3efd6c0f$var$getDataLoader = ()=>(parcelRequire("gO5LU"));
const $adb9f25d3efd6c0f$export$6aecd43ca01da0d9 = (0, $2M1hQ.createResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_AI_ANSWERS_KB_RESOURCE',
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: $adb9f25d3efd6c0f$var$getDataLoader,
    isBrowserOnly: true
});

});
parcelRegister("gO5LU", function(module, exports) {

let $c3c5cafc1ee925e9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c3c5cafc1ee925e9$var$load("c3CmY").then(()=>parcelRequire('cJzMU'));

});


parcelRegister("aGFv5", function(module, exports) {

$parcel$export(module.exports, "aiAnswersRoute", () => $945f4c839611ad80$export$57dc115194d72385);
const $945f4c839611ad80$export$57dc115194d72385 = {
    name: 'project-settings-servicedesk-virtualagent-ai-answers',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/ai-answers'
};

});

parcelRegister("9PZqh", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentAiAnswersSkeleton", () => $72ea56917d7c23c3$export$5fe1280883d32350);
/* VirtualAgentAiAnswersSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $kZPCc = parcelRequire("kZPCc");
const $72ea56917d7c23c3$var$customCssStyles = null;
const $72ea56917d7c23c3$export$5fe1280883d32350 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kZPCc))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("kZPCc", function(module, exports) {
module.exports = new URL("virtual-agent-ai-answers-app-skeleton.tpl.283eb0a3.svg", import.meta.url).toString();

});


parcelRegister("mOeIa", function(module, exports) {

$parcel$export(module.exports, "aiAnswersEntryPoint", () => $a4434f7c7bc24d2f$export$5dcf9a7e1076ac6);

var $dBV63 = parcelRequire("dBV63");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $a4434f7c7bc24d2f$export$5dcf9a7e1076ac6 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("arTkl")), {
        moduleId: "b474af7a"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $dBV63.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("dBV63", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b39bedd89e67c64$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<228f2239cbae33d00d8e63897f96750c>>
 * @relayHash b317a486cf818716fa955809174baed6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aecb078bb42ac99789f2aa91d508e1d81d4288e8ceb828b1c9f3c03242f8f76f

var $7oHmH = parcelRequire("7oHmH");

var $eiowN = parcelRequire("eiowN");
const $8b39bedd89e67c64$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = [
        v2 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        v2 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "isAiEnabledInAdminHub"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "srcVirtualAgentAiAnswersQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_projectRef"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "virtualAgentConfiguration",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_servicedeskSettingsVirtualAgentAiAnswers_VirtualAgentAiAnswers_virtualAgentConfiguration"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_servicedeskSettingsVirtualAgentAiAnswers_VirtualAgentAiAnswers_jiraProjectRef"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "VirtualAgentQueryApi",
                        "kind": "LinkedField",
                        "name": "virtualAgent",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "VirtualAgentFeatures",
                                    "kind": "LinkedField",
                                    "name": "virtualAgentEntitlements",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_servicedeskSettingsVirtualAgentAiAnswers_VirtualAgentAiAnswers_virtualAgentFeatures"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "virtualAgent.virtualAgentEntitlements"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "virtualAgent"
                },
                {
                    "args": v7 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_featuresRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "srcVirtualAgentAiAnswersQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "virtualAgentConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isAiResponsesEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "defaultJiraRequestTypeId"
                                                }
                                            ],
                                            "type": "VirtualAgentConfiguration"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v9 /*: any*/ ,
                                            "type": "VirtualAgentQueryError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v9 /*: any*/ ,
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                },
                                v4 /*: any*/ ,
                                {
                                    "args": v7 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "knowledgeBaseArticlesCount",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "count"
                                                }
                                            ],
                                            "type": "KnowledgeBaseArticleCountSource"
                                        }
                                    ]
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "VirtualAgentQueryApi",
                    "kind": "LinkedField",
                    "name": "virtualAgent",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "VirtualAgentFeatures",
                            "kind": "LinkedField",
                            "name": "virtualAgentEntitlements",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "VirtualAgentQueryApi",
                    "kind": "LinkedField",
                    "name": "virtualAgent",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "VirtualAgentFeatures",
                            "kind": "LinkedField",
                            "name": "virtualAgentEntitlements",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isVirtualAgentAvailable"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": v10 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "aecb078bb42ac99789f2aa91d508e1d81d4288e8ceb828b1c9f3c03242f8f76f",
            "metadata": {},
            "name": "srcVirtualAgentAiAnswersQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
            }
        }
    };
}();
$8b39bedd89e67c64$var$node.hash = "19529bb28005c693e530427ab6ca9cc6";
(0, $eiowN.PreloadableQueryRegistry).set($8b39bedd89e67c64$var$node.params.id, $8b39bedd89e67c64$var$node);
var $8b39bedd89e67c64$export$2e2bcd8739ae039 = $8b39bedd89e67c64$var$node;

});

parcelRegister("arTkl", function(module, exports) {

let $79b757cbb478cc1b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $79b757cbb478cc1b$var$load("Nd8Dq").then(()=>parcelRequire('64AA8'));

});



parcelRegister("eAlzO", function(module, exports) {

$parcel$export(module.exports, "browseConversationsRouteEntry", () => $88c89130df57850c$export$b81210c1c5fc2e86);

var $b4PzF = parcelRequire("b4PzF");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $gvZrS = parcelRequire("gvZrS");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $cOR6Z = parcelRequire("cOR6Z");

var $2IBFQ = parcelRequire("2IBFQ");

var $lkFvK = parcelRequire("lkFvK");

var $k6R7C = parcelRequire("k6R7C");
const $88c89130df57850c$var$browseConversationsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $2IBFQ.browseConversationsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $88c89130df57850c$export$b81210c1c5fc2e86 = (0, $7NszV.createEntry)((0, $gvZrS.browseConversationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $b4PzF.isFedRamp)()) return undefined;
            return $88c89130df57850c$var$browseConversationsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $cOR6Z.VirtualAgentBrowseConversationsSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("gvZrS", function(module, exports) {

$parcel$export(module.exports, "browseConversationsRoute", () => $3541a643aa509b4d$export$c8ff4cf64e5540ec);
const $3541a643aa509b4d$export$c8ff4cf64e5540ec = {
    name: 'project-settings-servicedesk-virtualagent-browseconversations',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/conversations'
};

});

parcelRegister("cOR6Z", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentBrowseConversationsSkeleton", () => $93c172d4ef4f57d3$export$4a6267fad85ca589);
/* VirtualAgentBrowseConversationsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $eRGJ4 = parcelRequire("eRGJ4");
const $93c172d4ef4f57d3$var$customStyles = null;
const $93c172d4ef4f57d3$export$4a6267fad85ca589 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eRGJ4))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("eRGJ4", function(module, exports) {
module.exports = new URL("virtual-agent-browse-conversations-app-skeleton.tpl.9f030add.svg", import.meta.url).toString();

});


parcelRegister("2IBFQ", function(module, exports) {

$parcel$export(module.exports, "browseConversationsEntryPoint", () => $d5456be03cb88be5$export$38549013d5d5a440);

var $iAqTc = parcelRequire("iAqTc");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");
const $d5456be03cb88be5$var$DEFAULT_RANGE_DAYS = 14;

const $d5456be03cb88be5$export$38549013d5d5a440 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("gYRGa")), {
        moduleId: "1bf85952"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const end = new Date();
        const start = new Date(end);
        start.setDate(start.getDate() - $d5456be03cb88be5$var$DEFAULT_RANGE_DAYS);
        return {
            extraProps: {
                initialDateRange: {
                    start: start,
                    end: end
                }
            },
            queries: {
                page: {
                    parameters: (0, $iAqTc.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
                        startDate: start.toISOString(),
                        endDate: end.toISOString()
                    }
                }
            }
        };
    }
});

});
parcelRegister("iAqTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a4522a333dd4135$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<283ed4f377b201f98d14321a82b83de5>>
 * @relayHash 02e143cfdd95667a01d51463a678a48c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19a45252d433996c267e9e919b0907677c72d7ab779a1d8cf1a338ce162c39ae

var $d4rfp = parcelRequire("d4rfp");

var $7oHmH = parcelRequire("7oHmH");
const $6a4522a333dd4135$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "19a45252d433996c267e9e919b0907677c72d7ab779a1d8cf1a338ce162c39ae",
        "metadata": {},
        "name": "srcVirtualAgentBrowseConversationsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcisconversationfilterenabledrelayprovider": (0, $d4rfp.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $6a4522a333dd4135$export$2e2bcd8739ae039 = $6a4522a333dd4135$var$node;

});
parcelRegister("d4rfp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b78ba3d71d6b015$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $2b78ba3d71d6b015$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('expose_channels_on_va_conversation_history');
    }
};

});


parcelRegister("gYRGa", function(module, exports) {

let $c5cbe379e6a8c88c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c5cbe379e6a8c88c$var$load("7F9PY").then(()=>parcelRequire('azR8x'));

});



parcelRegister("3KtPD", function(module, exports) {

$parcel$export(module.exports, "browseIntentsRouteEntry", () => $4f05bc6eb45d46da$export$da5f3658bd3ecdde);

var $b4PzF = parcelRequire("b4PzF");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6oHoX = parcelRequire("6oHoX");

var $e9YVH = parcelRequire("e9YVH");

var $lgNzP = parcelRequire("lgNzP");

var $aAhML = parcelRequire("aAhML");

var $lkFvK = parcelRequire("lkFvK");

var $cNMs5 = parcelRequire("cNMs5");

var $k6R7C = parcelRequire("k6R7C");
const $4f05bc6eb45d46da$var$browseIntentsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $cNMs5.browseIntentsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $4f05bc6eb45d46da$export$da5f3658bd3ecdde = (0, $7NszV.createEntry)((0, $6oHoX.browseIntentsRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $b4PzF.isFedRamp)()) return undefined;
            return $4f05bc6eb45d46da$var$browseIntentsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        layout: (0, $lgNzP.browseIntentsLayout),
        skeleton: (0, $aAhML.VirtualAgentBrowseIntentsSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("6oHoX", function(module, exports) {

$parcel$export(module.exports, "browseIntentsRoute", () => $2004c35d63b7590d$export$3e227412713bc57f);
const $2004c35d63b7590d$export$3e227412713bc57f = {
    name: 'project-settings-servicedesk-virtualagent-browse-intents',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents'
};

});

parcelRegister("lgNzP", function(module, exports) {

$parcel$export(module.exports, "browseIntentsLayout", () => $3f16128d6d3a9eb8$export$6659f41b213bad05);

var $2vSU6 = parcelRequire("2vSU6");

var $aPfsS = parcelRequire("aPfsS");

var $6Z2mh = parcelRequire("6Z2mh");

var $epSYp = parcelRequire("epSYp");
// TODO Remove this whenever all service project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3f16128d6d3a9eb8$var$withServiceProjectContext = (Component)=>(0, $aPfsS.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $2vSU6.SERVICE_DESK_PROJECT)
        }
    });
const $3f16128d6d3a9eb8$export$6659f41b213bad05 = (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), {
    rightSidebars: [
        $3f16128d6d3a9eb8$var$withServiceProjectContext((0, $epSYp.default))
    ]
});

});
parcelRegister("epSYp", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdb5ff159e084339$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $hsmeR = parcelRequire("hsmeR");

var $dAfqg = parcelRequire("dAfqg");

var $iwtyI = parcelRequire("iwtyI");

var $av9sZ = parcelRequire("av9sZ");

var $Y6PAl = parcelRequire("Y6PAl");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");
const $cdb5ff159e084339$var$runtimeProps = {};
const $cdb5ff159e084339$export$36ad24b9ac79bdc8 = ()=>{
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    const panelId = rightSidebarCurrentState?.panelId ?? '';
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            key: projectContextData?.projectKey ?? '',
            isHideIntentDiscoveryWhenVaNotConfiguredEnabled: (0, $4R6GH.fg)('hide_intent_discovery_copy_when_va_not_configured')
        }), [
        cloudId,
        projectContextData
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $iwtyI.virtualAgentCreateIntentTemplateSidebarEntryPoint), entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (panelId === 'intentTemplate') entryPointActions.load();
        else entryPointActions.unload();
    }, [
        entryPointActions,
        panelId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "createIntentTemplatesSidebar",
        packageName: "jiraServicedeskSettingsVirtualAgentCreateIntentTemplates",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Y6PAl.VirtualAgentIntentTemplateSidebarSkeleton), null),
        errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cdb5ff159e084339$var$SideBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $av9sZ.ErrorDisplay), {
                refetch: ()=>window.location.reload()
            })),
        runtimeProps: $cdb5ff159e084339$var$runtimeProps
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $cdb5ff159e084339$var$SideBarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1kl7udwz _1e0c1txw _2lx21bp4 _bfhk1bhr _vchhusvi _1p57u2gc _4t3i1osq _18m91wug",
            __cmplp.className
        ])
    });
});
var $cdb5ff159e084339$export$2e2bcd8739ae039 = $cdb5ff159e084339$export$36ad24b9ac79bdc8;

});
parcelRegister("iwtyI", function(module, exports) {

$parcel$export(module.exports, "virtualAgentCreateIntentTemplateSidebarEntryPoint", () => $6713c6429155461a$export$2b1d9dc27ee42f8f);

var $aHrkz = parcelRequire("aHrkz");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $6713c6429155461a$export$2b1d9dc27ee42f8f = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("fE5Qe")), {
        moduleId: "a4e9afeb"
    }),
    getPreloadProps: ({ cloudId: cloudId, key: key, isHideIntentDiscoveryWhenVaNotConfiguredEnabled: isHideIntentDiscoveryWhenVaNotConfiguredEnabled })=>({
            queries: {
                intentTemplateQueryReference: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: (0, $aHrkz.default),
                    variables: {
                        cloudId: cloudId,
                        key: key,
                        isHideIntentDiscoveryWhenVaNotConfiguredEnabled: isHideIntentDiscoveryWhenVaNotConfiguredEnabled
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("aHrkz", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2036dd19a3f68c8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<68ca1ff3c625c48e3b3f34fcd3122e1a>>
 * @relayHash c3ecae5efac1725022957b3584c6748a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d816bb1396041500986a655dbca037f2dba1138371158641897ea361c6ff7286
const $e2036dd19a3f68c8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "d816bb1396041500986a655dbca037f2dba1138371158641897ea361c6ff7286",
        "metadata": {},
        "name": "uiVirtualAgentIntentTemplatesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e2036dd19a3f68c8$export$2e2bcd8739ae039 = $e2036dd19a3f68c8$var$node;

});

parcelRegister("fE5Qe", function(module, exports) {

let $b63f1f6aa46df801$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b63f1f6aa46df801$var$load("dsiAd"),
    $b63f1f6aa46df801$var$load("bTdk8")
]).then(()=>parcelRequire('dMvBS'));

});


parcelRegister("av9sZ", function(module, exports) {

$parcel$export(module.exports, "ErrorDisplay", () => $09828373404eee09$export$d56b0569bceb92ae);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $3s0xG = parcelRequire("3s0xG");

var $7q5TP = parcelRequire("7q5TP");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $2zwTA = parcelRequire("2zwTA");
const $09828373404eee09$export$d56b0569bceb92ae = ({ refetch: refetch })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
        header: formatMessage((0, $2zwTA.default).errorDisplayHeading),
        description: formatMessage((0, $2zwTA.default).errorDisplayDescription),
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $7q5TP.default)),
        imageWidth: 160,
        maxImageHeight: 220,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
            onClick: refetch,
            appearance: "link"
        }, formatMessage((0, $2zwTA.default).reloadNowButtonText))
    });
};

});
parcelRegister("iVgQf", function(module, exports) {

$parcel$export(module.exports, "getAkEmptyStateRenderImageFn", () => $7affac5c7e698fc8$export$ebf64b9217c1b2a3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $4Bpvs = parcelRequire("4Bpvs");
function $7affac5c7e698fc8$export$ebf64b9217c1b2a3(JiraIllustration = (0, $4Bpvs.default)) {
    return ({ maxImageWidth: // we strictly follow EmptyState's defaults
    maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
        // This wrapper emulates EmptyState's private "HeaderImage" styling
        // @see platform/packages/design-system/empty-state/src/empty-state.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        const Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
                ...__cmplp,
                style: {
                    ...__cmpls,
                    "--_yv3y2x": (0, $lD23V.default)(maxImageWidth, "px"),
                    "--_nq7wev": (0, $lD23V.default)(maxImageHeight, "px")
                },
                ref: __cmplr,
                className: (0, $bwpsq.default)([
                    "_1e0c1ule _p12f1x6a _c71lc3ce _19pkidpf _2hwx1wug _otyr1ejb _18u01wug",
                    __cmplp.className
                ])
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JiraIllustration, {
            alt: "",
            role: "presentation",
            width: imageWidth || 'auto',
            height: imageHeight || 'auto'
        }));
    };
}

});
parcelRegister("4Bpvs", function(module, exports) {

$parcel$export(module.exports, "default", () => $029e22a35a3f42f7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3uP2Y")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("kbo4z")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $dCLgq = parcelRequire("dCLgq");

var $kbo4z = parcelRequire("kbo4z");

var $3uP2Y = parcelRequire("3uP2Y");
const $029e22a35a3f42f7$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3uP2Y)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($kbo4z))
});
var $029e22a35a3f42f7$export$2e2bcd8739ae039 = $029e22a35a3f42f7$var$Illustration;
// for advanced use only
const $029e22a35a3f42f7$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("kbo4z", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("3uP2Y", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});



parcelRegister("2zwTA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2ecc7c5e37557c1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b2ecc7c5e37557c1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorDisplayHeading: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-heading",
        "defaultMessage": "We couldn\u2019t load intent templates"
    },
    errorDisplayDescription: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-description",
        "defaultMessage": "Wait a moment and then try reloading."
    },
    reloadNowButtonText: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.reload-now-button-text",
        "defaultMessage": "Reload"
    }
});

});


parcelRegister("Y6PAl", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentIntentTemplateSidebarSkeleton", () => $61dfebc80ff570f9$export$fa68b26760d5b66f);
/* VirtualAgentIntentTemplateSidebarSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $5tRSi = parcelRequire("5tRSi");
const $61dfebc80ff570f9$var$customCssStyles = null;
const $61dfebc80ff570f9$export$fa68b26760d5b66f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5tRSi))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("5tRSi", function(module, exports) {
module.exports = new URL("virtual-agent-intent-template-sidebar-app-skeleton.tpl.e2ff8557.svg", import.meta.url).toString();

});




parcelRegister("aAhML", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentBrowseIntentsSkeleton", () => $47ee42028be217a3$export$444026e4d4f156e4);
$parcel$export(module.exports, "VirtualAgentIntentsTableSkeleton", () => $47ee42028be217a3$export$9dca41144a6398d2);
$parcel$export(module.exports, "VirtualAgentStatisticsSkeleton", () => $47ee42028be217a3$export$538762e63d6466fe);
/* VirtualAgentStatisticsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $eTe4L = parcelRequire("eTe4L");

var $5IeeQ = parcelRequire("5IeeQ");

var $8v6ku = parcelRequire("8v6ku");
const $47ee42028be217a3$var$customCssStyles = null;
const $47ee42028be217a3$export$444026e4d4f156e4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eTe4L))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
const $47ee42028be217a3$export$9dca41144a6398d2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5IeeQ))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
const $47ee42028be217a3$export$538762e63d6466fe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8v6ku))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("eTe4L", function(module, exports) {
module.exports = new URL("virtual-agent-browse-intents-app-skeleton.tpl.1eeb33c1.svg", import.meta.url).toString();

});

parcelRegister("5IeeQ", function(module, exports) {
module.exports = new URL("virtual-agent-intents-table-app-skeleton.tpl.e28c55f7.svg", import.meta.url).toString();

});

parcelRegister("8v6ku", function(module, exports) {
module.exports = new URL("virtual-agent-virtual-agent-statistics-app-skeleton.tpl.19ee5056.svg", import.meta.url).toString();

});


parcelRegister("cNMs5", function(module, exports) {

$parcel$export(module.exports, "browseIntentsEntryPoint", () => $0c1a3d6ae6de7f87$export$f19c213ae2d7940f);

var $2VZl9 = parcelRequire("2VZl9");

var $ae5pE = parcelRequire("ae5pE");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");
// When changing the default time range, make sure to also update jira/src/packages/servicedesk/virtual-agent/intents/browse-intents/src/ui/index.tsx
const $0c1a3d6ae6de7f87$var$DEFAULT_TIME_RANGE_MS = 604800000; // 7 days
const $0c1a3d6ae6de7f87$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10);

const $0c1a3d6ae6de7f87$export$f19c213ae2d7940f = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("5gNK0")), {
        moduleId: "85089c8d"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $2VZl9.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                },
                statistics: {
                    parameters: (0, $ae5pE.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        startDate: $0c1a3d6ae6de7f87$var$formatFetchDate(new Date(Date.now() - $0c1a3d6ae6de7f87$var$DEFAULT_TIME_RANGE_MS)),
                        endDate: $0c1a3d6ae6de7f87$var$formatFetchDate(new Date())
                    }
                }
            }
        })
});

});
parcelRegister("2VZl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $84af76b2b1eda3ac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e26109154b1d676d1e521b3825686b61>>
 * @relayHash e82022fa110ba4e2b14d78aa1143f138
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ef03a1cbaee3d90481db48ad43fd5ff400f28b5d4eda45a80bcb122ae3b7e298

var $7oHmH = parcelRequire("7oHmH");
const $84af76b2b1eda3ac$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ef03a1cbaee3d90481db48ad43fd5ff400f28b5d4eda45a80bcb122ae3b7e298",
        "metadata": {},
        "name": "srcVirtualAgentBrowseIntentsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $84af76b2b1eda3ac$export$2e2bcd8739ae039 = $84af76b2b1eda3ac$var$node;

});

parcelRegister("ae5pE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3c21345417f9f8e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1e80ec120bc56b1532601415a1a168aa>>
 * @relayHash 92c770d34e02b4cbf895f8e8557e142c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 98ff9896a534365343e79a6d1c788e50aedc51a89613efbd1d99e193ec977064

var $2LxWa = parcelRequire("2LxWa");
const $d3c21345417f9f8e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "98ff9896a534365343e79a6d1c788e50aedc51a89613efbd1d99e193ec977064",
        "metadata": {},
        "name": "srcVirtualAgentBrowseIntentsStatisticsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaenableperformancepagerelayprovider": (0, $2LxWa.default)
        }
    }
};
var $d3c21345417f9f8e$export$2e2bcd8739ae039 = $d3c21345417f9f8e$var$node;

});
parcelRegister("2LxWa", function(module, exports) {

$parcel$export(module.exports, "default", () => $5892cca023449b49$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5892cca023449b49$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsm_va_enable_performance_page');
    }
};

});


parcelRegister("5gNK0", function(module, exports) {

let $3d6507e6bf8d4992$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3d6507e6bf8d4992$var$load("dt4qH").then(()=>parcelRequire('9r2hQ'));

});



parcelRegister("h3WYk", function(module, exports) {

$parcel$export(module.exports, "browseStandardFlowsRouteEntry", () => $f631f32c4725afe5$export$6a572c5bc9ffe9da);

var $b4PzF = parcelRequire("b4PzF");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $1r8X1 = parcelRequire("1r8X1");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $dhfPL = parcelRequire("dhfPL");

var $8HI9m = parcelRequire("8HI9m");

var $lkFvK = parcelRequire("lkFvK");

var $k6R7C = parcelRequire("k6R7C");
const $f631f32c4725afe5$var$browseStandardFlowsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8HI9m.browseStandardFlowsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $f631f32c4725afe5$export$6a572c5bc9ffe9da = (0, $7NszV.createEntry)((0, $1r8X1.browseStandardFlowsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $b4PzF.isFedRamp)()) return undefined;
            return $f631f32c4725afe5$var$browseStandardFlowsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $dhfPL.VirtualAgentBrowseStandardFlowsSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("1r8X1", function(module, exports) {

$parcel$export(module.exports, "browseStandardFlowsRoute", () => $929ca13d8a48533c$export$fd091ba8fa858397);
const $929ca13d8a48533c$export$fd091ba8fa858397 = {
    name: 'project-settings-servicedesk-virtualagent-standard-flows',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows'
};

});

parcelRegister("dhfPL", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentBrowseStandardFlowsSkeleton", () => $42ac2f7c560a8df6$export$c2bd83dd149452bd);
/* VirtualAgentBrowseStandardFlowsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $6OP2Q = parcelRequire("6OP2Q");
const $42ac2f7c560a8df6$var$customCssStyles = null;
const $42ac2f7c560a8df6$export$c2bd83dd149452bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6OP2Q))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("6OP2Q", function(module, exports) {
module.exports = new URL("virtual-agent-browse-standard-flows-app-skeleton.tpl.51e6e95a.svg", import.meta.url).toString();

});


parcelRegister("8HI9m", function(module, exports) {

$parcel$export(module.exports, "browseStandardFlowsEntryPoint", () => $32e48f8946c41f01$export$f7de8593c7455f1);

var $iARRY = parcelRequire("iARRY");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $32e48f8946c41f01$export$f7de8593c7455f1 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("cgHQs")), {
        moduleId: "c2d13204"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $iARRY.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("iARRY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e33e127e8847987$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<33233bbde56426b21cb0cf7548a863c8>>
 * @relayHash 8658a1d9e0b503030f122af7546f7fa3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b2740e61056af93841794a91099e9b96903f93d7fe50bb2475c769a63f9f5288

var $7oHmH = parcelRequire("7oHmH");
const $4e33e127e8847987$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b2740e61056af93841794a91099e9b96903f93d7fe50bb2475c769a63f9f5288",
        "metadata": {},
        "name": "srcVirtualAgentBrowseStandardFlowsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $4e33e127e8847987$export$2e2bcd8739ae039 = $4e33e127e8847987$var$node;

});

parcelRegister("cgHQs", function(module, exports) {

let $8ee8fd5f9f5ea466$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8ee8fd5f9f5ea466$var$load("kiA0q").then(()=>parcelRequire('exMWS'));

});



parcelRegister("gjuAo", function(module, exports) {

$parcel$export(module.exports, "performanceRouteEntry", () => $8e362f7bda5bcefa$export$3f75a1735cbe5a04);

var $b4PzF = parcelRequire("b4PzF");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $eIj3W = parcelRequire("eIj3W");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $lkFvK = parcelRequire("lkFvK");

var $9aT1E = parcelRequire("9aT1E");

var $k6R7C = parcelRequire("k6R7C");
const $8e362f7bda5bcefa$var$performancePageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $9aT1E.performanceEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $8e362f7bda5bcefa$export$3f75a1735cbe5a04 = (0, $7NszV.createEntry)((0, $eIj3W.performanceRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $b4PzF.isFedRamp)()) return undefined;
            return $8e362f7bda5bcefa$var$performancePageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_PERFORMANCE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_PERFORMANCE),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("eIj3W", function(module, exports) {

$parcel$export(module.exports, "performanceRoute", () => $a08dee66d983407c$export$d867623f05adedb3);
const $a08dee66d983407c$export$d867623f05adedb3 = {
    name: 'project-settings-servicedesk-virtualagent-performance',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/performance'
};

});

parcelRegister("9aT1E", function(module, exports) {

$parcel$export(module.exports, "performanceEntryPoint", () => $94968a7dbb3de852$export$52b48527e9315b46);

var $jvgzC = parcelRequire("jvgzC");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");
const $94968a7dbb3de852$var$DEFAULT_TIME_RANGE_MS = 604800000; // 7 days
const $94968a7dbb3de852$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10); // has to be truncated for proper caching in SSR

const $94968a7dbb3de852$export$52b48527e9315b46 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("yqPgk")), {
        moduleId: "25efd1aa"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $jvgzC.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
                        startDate: $94968a7dbb3de852$var$formatFetchDate(new Date(Date.now() - $94968a7dbb3de852$var$DEFAULT_TIME_RANGE_MS)),
                        endDate: $94968a7dbb3de852$var$formatFetchDate(new Date())
                    }
                }
            }
        })
});

});
parcelRegister("jvgzC", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c3ef32003964182$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<58eefedfc0be82c49e0b43a97eaa9242>>
 * @relayHash 17c134d894620f1c421b59ff04b5022d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c5b53bba13d4edd9584d3e5ae8520c04e6bcadb47f3d05d96d73c7ba53c49c74

var $7oHmH = parcelRequire("7oHmH");

var $ie9EN = parcelRequire("ie9EN");

var $gnNIl = parcelRequire("gnNIl");

var $5INZt = parcelRequire("5INZt");
const $7c3ef32003964182$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "c5b53bba13d4edd9584d3e5ae8520c04e6bcadb47f3d05d96d73c7ba53c49c74",
        "metadata": {},
        "name": "srcVirtualAgentPerformanceQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaroiteaserm1enabledrelayprovider": (0, $ie9EN.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": (0, $gnNIl.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcvsaadoptionstage1relayprovider": (0, $5INZt.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $7c3ef32003964182$export$2e2bcd8739ae039 = $7c3ef32003964182$var$node;

});
parcelRegister("ie9EN", function(module, exports) {

$parcel$export(module.exports, "default", () => $17aeaf68a5cf1454$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $17aeaf68a5cf1454$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsm-va-roi-teaser-m1');
    }
};

});

parcelRegister("gnNIl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1a08e53932eeb60$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $f1a08e53932eeb60$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsm_va_status_header');
    }
};

});

parcelRegister("5INZt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3d53b1d56e94103$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $b3d53b1d56e94103$var$RelayProvider = {
    get () {
        return (0, $4R6GH.fg)('vsa-adoption-stage-1');
    }
};
var $b3d53b1d56e94103$export$2e2bcd8739ae039 = $b3d53b1d56e94103$var$RelayProvider;

});


parcelRegister("yqPgk", function(module, exports) {

let $0677fc236a58b802$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0677fc236a58b802$var$load("2MoaQ").then(()=>parcelRequire('6G1GD'));

});



parcelRegister("9z1Wd", function(module, exports) {

$parcel$export(module.exports, "settingsRouteEntry", () => $1a59cf2a3db44036$export$1d28e19560927106);

var $b4PzF = parcelRequire("b4PzF");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $H5kLJ = parcelRequire("H5kLJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $7g2py = parcelRequire("7g2py");

var $lkFvK = parcelRequire("lkFvK");

var $7j28R = parcelRequire("7j28R");

var $k6R7C = parcelRequire("k6R7C");
const $1a59cf2a3db44036$var$settingsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7j28R.settingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $1a59cf2a3db44036$export$1d28e19560927106 = (0, $7NszV.createEntry)((0, $H5kLJ.settingsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $b4PzF.isFedRamp)()) return undefined;
            return $1a59cf2a3db44036$var$settingsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $7g2py.VirtualAgentSettingsSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("H5kLJ", function(module, exports) {

$parcel$export(module.exports, "settingsRoute", () => $b642a35d67793caf$export$847a7c378c11c645);
const $b642a35d67793caf$export$847a7c378c11c645 = {
    name: 'project-settings-servicedesk-virtualagent-settings',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/settings/:tab(basic|channels)?'
};

});

parcelRegister("7g2py", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentSettingsSkeleton", () => $d88dc21ec5f90208$export$429c43ddcb09c14c);
/* VirtualAgentSettingsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $e41HZ = parcelRequire("e41HZ");
const $d88dc21ec5f90208$var$customCssStyles = null;
const $d88dc21ec5f90208$export$429c43ddcb09c14c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e41HZ))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("e41HZ", function(module, exports) {
module.exports = new URL("virtual-agent-settings-app-skeleton.tpl.1a9c03fe.svg", import.meta.url).toString();

});


parcelRegister("7j28R", function(module, exports) {

$parcel$export(module.exports, "settingsEntryPoint", () => $a9827913d0401124$export$d34e7816b7ac181a);

var $1I4lD = parcelRequire("1I4lD");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $a9827913d0401124$export$d34e7816b7ac181a = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("l7o0m")), {
        moduleId: "ed4de71b"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $1I4lD.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("1I4lD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a14dfc5f3ce71c58$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6a8b54dff6bd67d9f566bb4eac1d257a>>
 * @relayHash 7189bee0c97cc09b10f8e1589368c2de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 392629a596a95c19575393c3c0047883914bb7cb4d8de01d923e7684c2f31d13

var $y2RTb = parcelRequire("y2RTb");

var $7oHmH = parcelRequire("7oHmH");

var $gnNIl = parcelRequire("gnNIl");
const $a14dfc5f3ce71c58$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "392629a596a95c19575393c3c0047883914bb7cb4d8de01d923e7684c2f31d13",
        "metadata": {},
        "name": "srcVirtualAgentSettingsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaenableaianswerspagerelayprovider": (0, $y2RTb.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": (0, $gnNIl.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $a14dfc5f3ce71c58$export$2e2bcd8739ae039 = $a14dfc5f3ce71c58$var$node;

});
parcelRegister("y2RTb", function(module, exports) {

$parcel$export(module.exports, "default", () => $610656e9d6041bd2$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $610656e9d6041bd2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsm_va_enable_ai_answers_page');
    }
};

});


parcelRegister("l7o0m", function(module, exports) {

let $f5fcdf4d9fe7ba37$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f5fcdf4d9fe7ba37$var$load("7SEHL").then(()=>parcelRequire('byLJY'));

});



parcelRegister("6fHM1", function(module, exports) {

$parcel$export(module.exports, "viewIntentRouteEntry", () => $29a776b5b5594505$export$e693459ab8454027);

var $b4PzF = parcelRequire("b4PzF");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $88KkK = parcelRequire("88KkK");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $l4VHA = parcelRequire("l4VHA");

var $lSSsm = parcelRequire("lSSsm");

var $lkFvK = parcelRequire("lkFvK");

var $k6R7C = parcelRequire("k6R7C");
const $29a776b5b5594505$var$viewIntentPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $lSSsm.viewIntentEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $29a776b5b5594505$export$e693459ab8454027 = (0, $7NszV.createEntry)((0, $88KkK.viewIntentRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $b4PzF.isFedRamp)()) return undefined;
            return $29a776b5b5594505$var$viewIntentPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $l4VHA.VirtualAgentViewIntentSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("88KkK", function(module, exports) {

$parcel$export(module.exports, "viewIntentRoute", () => $aecf60273505ed2c$export$bf8131fb060d0e73);
const $aecf60273505ed2c$export$bf8131fb060d0e73 = {
    name: 'project-settings-servicedesk-virtualagent-view-intent',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents/:intentId/:tab(flow|training|settings)?'
};

});

parcelRegister("l4VHA", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentViewIntentSkeleton", () => $3817d32b8c9a6704$export$72b20c10a0f18a2f);
/* VirtualAgentViewIntentSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $b1zT3 = parcelRequire("b1zT3");
const $3817d32b8c9a6704$var$customCssStyles = null;
const $3817d32b8c9a6704$export$72b20c10a0f18a2f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b1zT3))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("b1zT3", function(module, exports) {
module.exports = new URL("virtual-agent-view-intent-app-skeleton.tpl.5dd31cbb.svg", import.meta.url).toString();

});


parcelRegister("lSSsm", function(module, exports) {

$parcel$export(module.exports, "viewIntentEntryPoint", () => $ac6810a67c998d50$export$f51df662bd71ce39);

var $iD8EQ = parcelRequire("iD8EQ");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $ac6810a67c998d50$export$f51df662bd71ce39 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("e0e6N")), {
        moduleId: "bc04de30"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $iD8EQ.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        intentId: context.match.params.intentId ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("iD8EQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ed8bfdfee83271$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dedde06316e2afe5acc862762a93f4dd>>
 * @relayHash cb914e8d2219b7f49741872ae7f6d037
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a770411d52534005c4d94e2f61c74a98ed117522669e7af7701400ccbf2323f3

var $7oHmH = parcelRequire("7oHmH");
const $45ed8bfdfee83271$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a770411d52534005c4d94e2f61c74a98ed117522669e7af7701400ccbf2323f3",
        "metadata": {},
        "name": "srcVirtualAgentViewIntentQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $45ed8bfdfee83271$export$2e2bcd8739ae039 = $45ed8bfdfee83271$var$node;

});

parcelRegister("e0e6N", function(module, exports) {

let $a31c02726bee4df1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a31c02726bee4df1$var$load("jVj7l").then(()=>parcelRequire('01RYz'));

});



parcelRegister("1GAqb", function(module, exports) {

$parcel$export(module.exports, "viewStandardFlowRouteEntry", () => $af4aef3a07273742$export$84dc2dfc944b0434);

var $b4PzF = parcelRequire("b4PzF");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $iU5fA = parcelRequire("iU5fA");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $blYux = parcelRequire("blYux");

var $lkFvK = parcelRequire("lkFvK");

var $hFluH = parcelRequire("hFluH");

var $k6R7C = parcelRequire("k6R7C");
const $af4aef3a07273742$var$viewStandardFlowPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $hFluH.viewStandardFlowEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $af4aef3a07273742$export$84dc2dfc944b0434 = (0, $7NszV.createEntry)((0, $iU5fA.viewStandardFlowRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $b4PzF.isFedRamp)()) return undefined;
            return $af4aef3a07273742$var$viewStandardFlowPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $blYux.VirtualAgentViewStandardFlowSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("iU5fA", function(module, exports) {

$parcel$export(module.exports, "viewStandardFlowRoute", () => $f47ba2070dd83bf9$export$c74dca8be49046ea);
const $f47ba2070dd83bf9$export$c74dca8be49046ea = {
    name: 'project-settings-servicedesk-virtualagent-view-standard-flow',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows/:flowId/:tab(flow|settings)?'
};

});

parcelRegister("blYux", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentViewStandardFlowSkeleton", () => $cedc5dbef30f009d$export$c6d3f04e6931e3f6);
/* VirtualAgentViewStandardFlowSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $aEqL3 = parcelRequire("aEqL3");
const $cedc5dbef30f009d$var$customCssStyles = null;
const $cedc5dbef30f009d$export$c6d3f04e6931e3f6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aEqL3))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("aEqL3", function(module, exports) {
module.exports = new URL("virtual-agent-view-standard-flow-app-skeleton.tpl.ec3b149b.svg", import.meta.url).toString();

});


parcelRegister("hFluH", function(module, exports) {

$parcel$export(module.exports, "viewStandardFlowEntryPoint", () => $8d05ca45dd1a7906$export$4fd7bf09308d4abd);

var $3sOht = parcelRequire("3sOht");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $8d05ca45dd1a7906$export$4fd7bf09308d4abd = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("YDWO7")), {
        moduleId: "8e1cdfbd"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $3sOht.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        flowId: context.match.params.flowId ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("3sOht", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bc956e6a804d466$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fdb08cf0aafa260f088ff7d6988a26ff>>
 * @relayHash c41a455d3fe07bee46fd358ba122e461
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ad1b0d9d182a46ab37286f92d3ce29ce06821b61a8e30066a34f05c56ce72317

var $7oHmH = parcelRequire("7oHmH");
const $1bc956e6a804d466$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ad1b0d9d182a46ab37286f92d3ce29ce06821b61a8e30066a34f05c56ce72317",
        "metadata": {},
        "name": "srcVirtualAgentViewStandardFlowQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $1bc956e6a804d466$export$2e2bcd8739ae039 = $1bc956e6a804d466$var$node;

});

parcelRegister("YDWO7", function(module, exports) {

let $0b6497741b82b8a7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0b6497741b82b8a7$var$load("8avJm").then(()=>parcelRequire('16gIP'));

});



parcelRegister("2ytxj", function(module, exports) {

$parcel$export(module.exports, "servicedeskWorkflowConfigRouteEntry", () => $37624069b0a267c0$export$212f7f79630d5adc);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $043ka = parcelRequire("043ka");

var $6Z2mh = parcelRequire("6Z2mh");

var $j3pH1 = parcelRequire("j3pH1");
const $37624069b0a267c0$var$workflowSchemeConfigPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $j3pH1.workflowSchemeConfigEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $37624069b0a267c0$export$212f7f79630d5adc = (0, $7NszV.createEntry)((0, $043ka.servicedeskWorkflowConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        entryPoint () {
            return $37624069b0a267c0$var$workflowSchemeConfigPageEntrypoint;
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource)
        ],
        meta: {
            reporting: {
                id: 'project-settings.workflow-scheme-config',
                packageName: 'projectSettingsWorkflowSchemeConfig',
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-workflow-scheme-config'
    }));

});
parcelRegister("j3pH1", function(module, exports) {

$parcel$export(module.exports, "workflowSchemeConfigEntrypoint", () => $5e46ff6da5ce3455$export$12ccdf1d30de8ac);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $5e46ff6da5ce3455$export$12ccdf1d30de8ac = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("3jQQF")), {
        moduleId: "6be3e66b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3jQQF", function(module, exports) {

let $26ac24080aa4117b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $26ac24080aa4117b$var$load("c6xj7").then(()=>parcelRequire('3STzC'));

});



parcelRegister("7PtTb", function(module, exports) {

$parcel$export(module.exports, "softwareStaffingRouteEntry", () => $12bd43395964fa40$export$71a3a4cc27cbe00a);

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $6LsQE = parcelRequire("6LsQE");

var $dxCvy = parcelRequire("dxCvy");

var $jsFU4 = parcelRequire("jsFU4");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $3svbL = parcelRequire("3svbL");

var $8STJR = parcelRequire("8STJR");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $4R6GH = parcelRequire("4R6GH");

var $3NJu6 = parcelRequire("3NJu6");

var $1fXOB = parcelRequire("1fXOB");
/** @deprecated remove when cleaning up 'fun-1614-migrate-staffing-route-to-entrypoint' */ const $12bd43395964fa40$var$getHorizontalNavResource = ()=>(0, $4R6GH.fg)('fun-1614-migrate-staffing-route-to-entrypoint') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $12bd43395964fa40$export$71a3a4cc27cbe00a = (0, $7NszV.createEntry)((0, $3svbL.softwareStaffingRoute), ()=>({
        group: 'software',
        component: (0, $cSD7y.componentWithFG)('staffing', (0, $3NJu6.StaffingPage), (0, $5lsNZ.default)),
        skeleton: (0, $8STJR.RoadmapSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            ...$12bd43395964fa40$var$getHorizontalNavResource(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $jsFU4.nextGenRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: (0, $4R6GH.fg)('fun-1614-migrate-staffing-route-to-entrypoint') ? undefined : [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3NJu6.LazyStaffing)
        ],
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('fun-1614-migrate-staffing-route-to-entrypoint')) {
                if (!(0, $4R6GH.fg)('staffing')) return 0, $6LsQE.notFoundPageEntrypoint;
                return 0, $1fXOB.staffingRouteEntrypoint;
            }
            return undefined;
        },
        ufoName: 'next-gen-roadmap'
    }));

});
parcelRegister("3svbL", function(module, exports) {

$parcel$export(module.exports, "softwareStaffingRoute", () => $9bf480f2b06baa65$export$aa817709e0cb3b6d);
const $9bf480f2b06baa65$export$aa817709e0cb3b6d = {
    name: 'software-staffing',
    path: '/jira/software/projects/:projectKey/boards/:boardId/staffing'
};

});

parcelRegister("3NJu6", function(module, exports) {

$parcel$export(module.exports, "LazyStaffing", () => $a3816a073ffb3624$export$ddf48f2574714818);
$parcel$export(module.exports, "StaffingPage", () => $a3816a073ffb3624$export$fda035d26f486257);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $a3816a073ffb3624$export$ddf48f2574714818 = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4ljiE"))), {
    moduleId: "./src/packages/spa-apps/staffing/src/index-old.tsx"
});
const $a3816a073ffb3624$export$fda035d26f486257 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a3816a073ffb3624$export$ddf48f2574714818,
        pageId: `staffing-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });

});
parcelRegister("4ljiE", function(module, exports) {

let $32981824dc434024$var$load = (parcelRequire("28QjX"))(4);
module.exports = $32981824dc434024$var$load("9WPBO").then(()=>parcelRequire('fbIGw'));

});


parcelRegister("1fXOB", function(module, exports) {

$parcel$export(module.exports, "staffingRouteEntrypoint", () => $d9c937c27ede0b49$export$3a16ef365bcb8560);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $ewQz2 = parcelRequire("ewQz2");
const $d9c937c27ede0b49$export$3a16ef365bcb8560 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $ewQz2.staffingEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("ewQz2", function(module, exports) {

$parcel$export(module.exports, "staffingEntrypoint", () => $1f62c1dd3ab84c1d$export$94a659cc78d2756a);

var $cfawy = parcelRequire("cfawy");

var $3rdd7 = parcelRequire("3rdd7");

const $1f62c1dd3ab84c1d$export$94a659cc78d2756a = (0, $3rdd7.createEntryPoint)({
    root: (0, $cfawy.JSResourceForUserVisible)(()=>(parcelRequire("1N0gz")), {
        moduleId: "39c7d120"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1N0gz", function(module, exports) {

let $14da92e641bcdfc5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $14da92e641bcdfc5$var$load("cU2oM").then(()=>parcelRequire('g02gC'));

});




parcelRegister("8E1dI", function(module, exports) {

$parcel$export(module.exports, "cmpVelocityRouteEntry", () => $a27db4496b15726e$export$93315233fc25c1b4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $e7bC3 = parcelRequire("e7bC3");

var $jicqv = parcelRequire("jicqv");

var $jD7nj = parcelRequire("jD7nj");

var $4R6GH = parcelRequire("4R6GH");

var $fzG6k = parcelRequire("fzG6k");

var $yxwH0 = parcelRequire("yxwH0");
const $a27db4496b15726e$export$93315233fc25c1b4 = (0, $7NszV.createEntry)((0, $jicqv.cmpVelocityRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.velocity-report-cmp',
        component: (0, $4R6GH.fg)('jira_reports_route_migration_to_entry_points') ? undefined : (0, $jD7nj.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $yxwH0.getTMPReportsCommonResource)()
        ],
        forPaint: (0, $4R6GH.fg)('jira_reports_route_migration_to_entry_points') ? undefined : [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jD7nj.LazyNextGenVelocityReport)
        ],
        entryPoint: ()=>(0, $4R6GH.fg)('jira_reports_route_migration_to_entry_points') ? (0, $fzG6k.velocityReportPageEntrypoint) : undefined
    }));

});
parcelRegister("jicqv", function(module, exports) {

$parcel$export(module.exports, "cmpVelocityRoute", () => $a8cb7576e7ece3aa$export$1dfb0bd517ec7a8b);
const $a8cb7576e7ece3aa$export$1dfb0bd517ec7a8b = {
    name: 'software-reports-velocity-cmp',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/velocity'
};

});

parcelRegister("fzG6k", function(module, exports) {

$parcel$export(module.exports, "velocityReportPageEntrypoint", () => $29d7a4515738ef63$export$571ee01f62e186c8);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $kMjGT = parcelRequire("kMjGT");
const $29d7a4515738ef63$export$571ee01f62e186c8 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $kMjGT.velocityReportEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("kMjGT", function(module, exports) {

$parcel$export(module.exports, "velocityReportEntrypoint", () => $9e6b346357d67309$export$6f6bc731b8a9d27);

var $cfawy = parcelRequire("cfawy");

var $3rdd7 = parcelRequire("3rdd7");

const $9e6b346357d67309$export$6f6bc731b8a9d27 = (0, $3rdd7.createEntryPoint)({
    root: (0, $cfawy.JSResourceForUserVisible)(()=>(parcelRequire("apo0K")), {
        moduleId: "3ce1c0b2"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("apo0K", function(module, exports) {

let $793edd4603e3ceb8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $793edd4603e3ceb8$var$load("iTOtj").then(()=>parcelRequire('59dUe'));

});




parcelRegister("2yO8h", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesViewsConfigRouteEntry", () => $3766b33f9d299552$export$a5000d326f347afb);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $bfOrv = parcelRequire("bfOrv");

var $6Z2mh = parcelRequire("6Z2mh");

var $dxCvy = parcelRequire("dxCvy");

var $4R6GH = parcelRequire("4R6GH");

var $5lsNZ = parcelRequire("5lsNZ");

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lJ1FP = parcelRequire("lJ1FP");

var $iRITI = parcelRequire("iRITI");

var $e3Tce = parcelRequire("e3Tce");
const $3766b33f9d299552$export$a5000d326f347afb = (0, $7NszV.createEntry)((0, $bfOrv.servicedeskQueuesViewsConfigRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            ...(0, $fpjJX.getQueueViewConfigResource)(),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $e3Tce.LazyServicedeskQueuesViewsConfig)
        ],
        ufoName: 'service-management.views.config',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $e3Tce.ServicedeskQueuesViewsConfig), (0, $5lsNZ.default)),
        pageId: ({ query: query, match: match })=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $iRITI.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        }
    }));

});
parcelRegister("bfOrv", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesViewsConfigRoute", () => $a336f3ec9a74ea1c$export$eea17b09d67a7980);
const $a336f3ec9a74ea1c$export$eea17b09d67a7980 = {
    name: 'servicedesk-queues-views-config',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/edit/:boardId',
    query: [
        'config?'
    ],
    exact: true
};

});

parcelRegister("e3Tce", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesViewsConfig", () => $6daef49d48ee6ffb$export$12b9e920fc614605);
$parcel$export(module.exports, "ServicedeskQueuesViewsConfig", () => $6daef49d48ee6ffb$export$666845896df029ad);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

const $6daef49d48ee6ffb$export$12b9e920fc614605 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("8RcCv")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-config/src/index.tsx"
});
const $6daef49d48ee6ffb$export$666845896df029ad = (props)=>{
    const { query: query } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6daef49d48ee6ffb$export$12b9e920fc614605,
        pageId: `spa-apps/servicedesk/queues/views-config/${query.config}`,
        shouldShowSpinner: true
    });
};

});


parcelRegister("fEAJ2", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeViewsConfigRouteEntry", () => $f8d8209f3e843316$export$101c882abd4d051);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $SqPVy = parcelRequire("SqPVy");

var $6Z2mh = parcelRequire("6Z2mh");

var $dxCvy = parcelRequire("dxCvy");

var $4R6GH = parcelRequire("4R6GH");

var $5lsNZ = parcelRequire("5lsNZ");

var $7XYc4 = parcelRequire("7XYc4");

var $iRITI = parcelRequire("iRITI");

var $e3Tce = parcelRequire("e3Tce");
const $f8d8209f3e843316$export$101c882abd4d051 = (0, $7NszV.createEntry)((0, $SqPVy.servicedeskPracticeViewsConfigRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            ...(0, $fpjJX.getQueueViewConfigResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $e3Tce.LazyServicedeskQueuesViewsConfig)
        ],
        ufoName: 'service-management.views.config',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $e3Tce.ServicedeskQueuesViewsConfig), (0, $5lsNZ.default)),
        pageId: ({ query: query, match: match })=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $iRITI.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        }
    }));

});
parcelRegister("SqPVy", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeViewsConfigRoute", () => $7e4dd55084659e58$export$e8e807e90d20fe7b);
const $7e4dd55084659e58$export$e8e807e90d20fe7b = {
    name: 'servicedesk-practice-views-config',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit/:boardId',
    query: [
        'config'
    ],
    exact: true
};

});


parcelRegister("18W8Q", function(module, exports) {

$parcel$export(module.exports, "assetsSearchRouteEntry", () => $0e927da2b693a3df$export$2a3cf8cc5b9b7e6);

var $7NszV = parcelRequire("7NszV");

var $55ZOZ = parcelRequire("55ZOZ");

var $lkFvK = parcelRequire("lkFvK");

var $k7I8D = parcelRequire("k7I8D");

var $2NDia = parcelRequire("2NDia");

var $ck92c = parcelRequire("ck92c");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $0e927da2b693a3df$var$assetsSearchPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $ck92c.assetsSearchEntryPoint)
});
const $0e927da2b693a3df$export$2a3cf8cc5b9b7e6 = (0, $7NszV.createEntry)((0, $2NDia.assetsSearchRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$0e927da2b693a3df$var$assetsSearchPageEntryPoint,
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        perfMetricKey: 'assets-app.interact-with-search-page'
    }));

});
parcelRegister("2NDia", function(module, exports) {

$parcel$export(module.exports, "assetsSearchRoute", () => $a566f1c309df793b$export$6d41f99fb1a055c0);
const $a566f1c309df793b$export$6d41f99fb1a055c0 = {
    name: 'assets-search-results',
    path: '/jira/assets/search',
    exact: true
};

});

parcelRegister("ck92c", function(module, exports) {

$parcel$export(module.exports, "assetsSearchEntryPoint", () => $e8212bc60c70e700$export$5752b60b3fc851fc);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $e8212bc60c70e700$export$5752b60b3fc851fc = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("70KZs")).then((module)=>module.AssetsAppSearchEntrypointWrapper), {
        moduleId: "49468062"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("70KZs", function(module, exports) {

let $51acfbc7cb701a22$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $51acfbc7cb701a22$var$load("h2MrD"),
    $51acfbc7cb701a22$var$load("bYT2S"),
    $51acfbc7cb701a22$var$load("eNmuD"),
    $51acfbc7cb701a22$var$load("kfXhT"),
    $51acfbc7cb701a22$var$load("2Lfdl"),
    $51acfbc7cb701a22$var$load("dsiAd"),
    $51acfbc7cb701a22$var$load("ft0GV")
]).then(()=>parcelRequire('afJlR'));

});



parcelRegister("4VMm4", function(module, exports) {

$parcel$export(module.exports, "rovoSearchRouteEntry", () => $e32aede527302f76$export$64c44018a429a3ed);

var $5uXOq = parcelRequire("5uXOq");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $b7Svb = parcelRequire("b7Svb");

var $5cBfM = parcelRequire("5cBfM");

const $e32aede527302f76$var$LazyRovoSearchPage = (0, $b7Svb.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("l93IG"))), {
    moduleId: "./src/packages/spa-apps/rovo-search/src/index.tsx"
});
const $e32aede527302f76$var$RovoSearchPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e32aede527302f76$var$LazyRovoSearchPage,
        pageId: "rovo-search",
        shouldShowSpinner: false
    });
const $e32aede527302f76$export$64c44018a429a3ed = (0, $7NszV.createEntry)((0, $5cBfM.rovoSearchRoute), ()=>({
        group: 'search',
        component: $e32aede527302f76$var$RovoSearchPage,
        isRedirect: false,
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            $e32aede527302f76$var$LazyRovoSearchPage
        ]
    }));

});
parcelRegister("5cBfM", function(module, exports) {

$parcel$export(module.exports, "rovoSearchRoute", () => $361c5d3a5eacaef4$export$c45b7c601eb1ba93);
const $361c5d3a5eacaef4$export$c45b7c601eb1ba93 = {
    name: 'jira-rovo-search',
    path: '/jira/cross-product-search',
    exact: true
};

});

parcelRegister("l93IG", function(module, exports) {

let $f64d52e4ec48e221$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f64d52e4ec48e221$var$load("h2MrD"),
    $f64d52e4ec48e221$var$load("bYT2S"),
    $f64d52e4ec48e221$var$load("eNmuD"),
    $f64d52e4ec48e221$var$load("kfXhT"),
    $f64d52e4ec48e221$var$load("2Lfdl"),
    $f64d52e4ec48e221$var$load("dsiAd"),
    $f64d52e4ec48e221$var$load("byvcA")
]).then(()=>parcelRequire('4CIoa'));

});


parcelRegister("bFlFq", function(module, exports) {

$parcel$export(module.exports, "piEditIssueEmbedRouteEntry", () => $68977f9133eef8e0$export$54fd859765926fb);

var $5uXOq = parcelRequire("5uXOq");

var $7NszV = parcelRequire("7NszV");

var $gFxdE = parcelRequire("gFxdE");

var $9NiTW = parcelRequire("9NiTW");

var $5j7Th = parcelRequire("5j7Th");

var $6e4Kt = parcelRequire("6e4Kt");

var $2Ql51 = parcelRequire("2Ql51");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $68977f9133eef8e0$var$LazyPIEditIssueEmbed = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("fuAY8")).then((module)=>module.EditIssueEmbed), {
    ssr: false,
    moduleId: "./src/packages/growth/gmail-embed/src/ui/edit-issue/index.tsx"
});
const $68977f9133eef8e0$var$PIIssueEditEmbedLazy = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $68977f9133eef8e0$var$LazyPIEditIssueEmbed,
        pageId: "spa-apps/pi-issue-edit-embed",
        shouldShowSpinner: true
    }));
};
const $68977f9133eef8e0$export$54fd859765926fb = (0, $7NszV.createEntry)((0, $gFxdE.piEditIssueEmbedRoute), ()=>({
        group: 'issue',
        component: $68977f9133eef8e0$var$PIIssueEditEmbedLazy,
        resources: [
            (0, $2Ql51.themePreferenceResource)
        ],
        layout: (0, $6e4Kt.chromelessLayout),
        forPaint: [
            $68977f9133eef8e0$var$LazyPIEditIssueEmbed
        ]
    }));

});
parcelRegister("gFxdE", function(module, exports) {

$parcel$export(module.exports, "piEditIssueEmbedRoute", () => $4be1968bc1e8e50c$export$963ebe9ee36e7e80);
const $4be1968bc1e8e50c$export$963ebe9ee36e7e80 = {
    name: 'pi-issue-edit-embed',
    path: '/jira/issues/edit/pi/embed'
};

});

parcelRegister("fuAY8", function(module, exports) {

let $b476559cb044016a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b476559cb044016a$var$load("dybUG").then(()=>parcelRequire('cINTo'));

});


parcelRegister("eyDhF", function(module, exports) {

$parcel$export(module.exports, "piCreateIssueEmbedRouteEntry", () => $9f70c0379ebea475$export$7f9ffa2e2d102ba);

var $5uXOq = parcelRequire("5uXOq");

var $7NszV = parcelRequire("7NszV");

var $9NiTW = parcelRequire("9NiTW");

var $5j7Th = parcelRequire("5j7Th");

var $6e4Kt = parcelRequire("6e4Kt");

var $2Ql51 = parcelRequire("2Ql51");

var $4tkZW = parcelRequire("4tkZW");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9f70c0379ebea475$var$LazyPICreateIssueEmbed = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("6NgqA")).then((module)=>module.CreateIssueEmbed), {
    ssr: false,
    moduleId: "./src/packages/growth/gmail-embed/src/ui/create-issue/index.tsx"
});
const $9f70c0379ebea475$var$PIIssueCreateEmbedLazy = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9f70c0379ebea475$var$LazyPICreateIssueEmbed,
        pageId: "spa-apps/pi-issue-create-embed",
        shouldShowSpinner: true
    }));
};
const $9f70c0379ebea475$export$7f9ffa2e2d102ba = (0, $7NszV.createEntry)((0, $4tkZW.piCreateIssueEmbedRoute), ()=>({
        group: 'issue',
        component: $9f70c0379ebea475$var$PIIssueCreateEmbedLazy,
        resources: [
            (0, $2Ql51.themePreferenceResource)
        ],
        layout: (0, $6e4Kt.chromelessLayout),
        forPaint: [
            $9f70c0379ebea475$var$LazyPICreateIssueEmbed
        ]
    }));

});
parcelRegister("4tkZW", function(module, exports) {

$parcel$export(module.exports, "piCreateIssueEmbedRoute", () => $194e64041acf2c20$export$e38c7e6f5c65691b);
const $194e64041acf2c20$export$e38c7e6f5c65691b = {
    name: 'pi-issue-create-embed',
    path: '/jira/issues/create/pi/embed'
};

});

parcelRegister("6NgqA", function(module, exports) {

let $4f240fe46279bdf1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4f240fe46279bdf1$var$load("lSIud").then(()=>parcelRequire('1iOv0'));

});


parcelRegister("lkwO5", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCustomerServiceFeaturesRouteEntry", () => $a15bf8b76e7abde8$export$e17f02db5d9c0485);

var $9MntO = parcelRequire("9MntO");

var $4R6GH = parcelRequire("4R6GH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6sNnq = parcelRequire("6sNnq");

var $5lsNZ = parcelRequire("5lsNZ");

var $6Z2mh = parcelRequire("6Z2mh");

var $cnvpg = parcelRequire("cnvpg");
const $a15bf8b76e7abde8$export$e17f02db5d9c0485 = (0, $7NszV.createEntry)((0, $9MntO.projectSettingsCustomerServiceFeaturesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jcs-project-settings.features',
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('berry-5039-jcs-features-page') ? (0, $cnvpg.projectSettingFeaturesAppPageEntryPoint) : undefined;
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $6sNnq.featuresResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        perfMetricKey: 'jcs-project-settings.features'
    }));

});
parcelRegister("9MntO", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCustomerServiceFeaturesRoute", () => $ad71d4ac3cd19ffa$export$5498201d2eacd40d);
const $ad71d4ac3cd19ffa$export$5498201d2eacd40d = {
    name: 'project-settings-customer-service-features',
    path: '/jira/servicedesk/projects/:projectKey/settings/features',
    exact: true
};

});

parcelRegister("cnvpg", function(module, exports) {

$parcel$export(module.exports, "projectSettingFeaturesAppPageEntryPoint", () => $6330397aa7ca9f96$export$f5b640657f5a50a3);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $c5TMF = parcelRequire("c5TMF");
const $6330397aa7ca9f96$export$f5b640657f5a50a3 = (0, $lkFvK.createPageEntryPoint)({
    main: $c5TMF.projectSettingFeaturesAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("c5TMF", function(module, exports) {

$parcel$export(module.exports, "projectSettingFeaturesAppEntryPoint", () => $60cea261eed7da95$export$83a2217e7eee641e);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $60cea261eed7da95$export$83a2217e7eee641e = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("e73D9")), {
        moduleId: "92e8308d"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("e73D9", function(module, exports) {

let $a4648912bc80e14c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a4648912bc80e14c$var$load("6kPNO").then(()=>parcelRequire('bMF5U'));

});




parcelRegister("3Ro2a", function(module, exports) {

$parcel$export(module.exports, "applinksExtraAuthHealthcheckRouteEntry", () => $cbeddb358fe83012$export$cd4854d613a2c404);

var $jwnr0 = parcelRequire("jwnr0");

var $3A9DP = parcelRequire("3A9DP");

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $5pSYQ = parcelRequire("5pSYQ");
const $cbeddb358fe83012$export$cd4854d613a2c404 = (0, $7NszV.createEntry)((0, $3A9DP.applinksExtraAuthHealthcheckRoute), ()=>({
        group: 'global-settings',
        ufoName: 'applinks-extra-auth-healthcheck',
        component: (0, $cSD7y.componentWithFG)('applinks-789-extra-auth-healthcheck-frontend', (0, $jwnr0.default), (0, $5lsNZ.default)),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        canTransitionIn: ()=>(0, $4R6GH.fg)('applinks-789-extra-auth-healthcheck-frontend'),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        meta: {
            reporting: {
                id: 'Applinks',
                packageName: 'jiraAdminPagesApplinks',
                teamName: 'olympus'
            }
        }
    }));

});
parcelRegister("jwnr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e07161e92ae94550$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZw8H = parcelRequire("dZw8H");

var $l8ruj = parcelRequire("l8ruj");

var $lJ7oK = parcelRequire("lJ7oK");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e07161e92ae94550$var$HealthcheckPage = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "applinks-extra-auth-healthcheck-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJ7oK.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null));
var $e07161e92ae94550$export$2e2bcd8739ae039 = $e07161e92ae94550$var$HealthcheckPage;

});
parcelRegister("lJ7oK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a46c08b21138da0f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1bQGJ = parcelRequire("1bQGJ");

var $ismUQ = parcelRequire("ismUQ");

var $jJPaN = parcelRequire("jJPaN");
const $a46c08b21138da0f$export$7955d5fe058be414 = ()=>{
    const [healthcheck, setHealthcheck] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        (0, $ismUQ.getHealthcheck)().then((data)=>{
            setHealthcheck(data);
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jJPaN.default), {
        healthcheck: healthcheck
    });
};
var $a46c08b21138da0f$export$2e2bcd8739ae039 = (0, $1bQGJ.withRouter)($a46c08b21138da0f$export$7955d5fe058be414);

});
parcelRegister("ismUQ", function(module, exports) {

$parcel$export(module.exports, "getHealthcheck", () => $b7c49ceb2b91f3bc$export$47b0be97eea80dc5);

var $7f4tk = parcelRequire("7f4tk");
const $b7c49ceb2b91f3bc$export$47b0be97eea80dc5 = ()=>(0, $7f4tk.default)('/rest/applinks/latest/applicationlink/extraAuth/healthcheck');

});

parcelRegister("jJPaN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fe5bef83d0b878b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2Eqc8 = parcelRequire("2Eqc8");
var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $clxo5 = parcelRequire("clxo5");

var $9FSw2 = parcelRequire("9FSw2");

var $7CMCs = parcelRequire("7CMCs");

var $6imks = parcelRequire("6imks");

var $426ZA = parcelRequire("426ZA");

var $bmSXq = parcelRequire("bmSXq");
const $0fe5bef83d0b878b$var$HealthcheckPageContents = (props)=>{
    const failedPrecondition = props.healthcheck?.healthcheckPreconditions.find((item)=>item.status.statusType === 'FAILURE');
    const failedEntry = props.healthcheck?.healthcheckEntries.find((item)=>item.status.statusType === 'FAILURE');
    const failedStatus = props.healthcheck?.healthcheckStatuses.find((item)=>item.status.statusType === 'FAILURE');
    const displayFailedStatusForEntry = (healthcheck, failedItem)=>{
        let errorString = `The healthcheck failed at step "${failedItem.name}"`;
        if ('message' in failedItem.status) errorString = `${errorString} due to reason "${failedItem.status.message}".`;
        else errorString = `${errorString}.`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bmSXq.default), {
            error: errorString,
            action: healthcheck.suggestedAction,
            link: healthcheck.suggestedActionLink
        });
    };
    const displayStatus = ()=>{
        if (props.healthcheck === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
        if (failedPrecondition) return displayFailedStatusForEntry(props.healthcheck, failedPrecondition);
        if (failedEntry) return displayFailedStatusForEntry(props.healthcheck, failedEntry);
        if (failedStatus) return displayFailedStatusForEntry(props.healthcheck, failedStatus);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FSw2.default), {
            title: "Success",
            appearance: "success"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, "Extra Authenticated Applinks are ready for use."));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "applinks-extra-auth-healthcheck-page",
        teamName: "olympus",
        packageName: "applinksExtraAuthHealthcheckPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.200",
        xcss: $0fe5bef83d0b878b$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $426ZA.default), null), props.healthcheck ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.800"
    }, displayStatus(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6imks.default), {
        title: "Prerequisites",
        description: "Ensure that the following prerequisites are met before beginning the setup process.",
        healthcheckEntries: props.healthcheck.healthcheckPreconditions
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6imks.default), {
        title: "OAuth 2.0 Provider Configuration",
        description: "Extra Authentication uses an external OAuth 2.0 provider, shared by all products within your organization. The provider must be configured correctly before Application Links can be created.",
        healthcheckEntries: props.healthcheck.healthcheckEntries
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6imks.default), {
        title: "Applink Status",
        description: "Once the authentication provider is configured, you can now create Application Links. All links configured to use Extra Authentication for this site are displayed below.",
        healthcheckEntries: props.healthcheck.healthcheckStatuses
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
        testId: "applinks-extra-auth.ui.spinner",
        interactionName: "load",
        label: "Loading"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, "Loading healthcheck data")))));
};
var $0fe5bef83d0b878b$export$2e2bcd8739ae039 = $0fe5bef83d0b878b$var$HealthcheckPageContents;
const $0fe5bef83d0b878b$var$styles = (0, $2s57o.xcss)({
    padding: 'space.200'
});

});
parcelRegister("9FSw2", function(module, exports) {

$parcel$export(module.exports, "default", () => $992999896a95fc30$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bWfiu = parcelRequire("bWfiu");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $gOkqF = parcelRequire("gOkqF");

var $fPYPu = parcelRequire("fPYPu");
const $992999896a95fc30$var$sectionMessageStyles = {
    container: "_2rkoglpi _1nmz1hna",
    bleed: "_1mou1i6y _1e0c1txw",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $992999896a95fc30$var$SectionMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $fPYPu.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        as: "section",
        backgroundColor: $992999896a95fc30$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $992999896a95fc30$var$sectionMessageStyles.container,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    xcss: $992999896a95fc30$var$sectionMessageStyles.bleed,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    children: [
                        !!title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                            xcss: $992999896a95fc30$var$sectionMessageStyles.content,
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: (0, $fHpHg.fg)('platform_ads_explicit_font_styles') && $992999896a95fc30$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                })
            ]
        })
    });
});
const $992999896a95fc30$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$992999896a95fc30$var$SectionMessage.displayName = 'SectionMessage';
var $992999896a95fc30$export$2e2bcd8739ae039 = $992999896a95fc30$var$SectionMessage;

});
parcelRegister("fPYPu", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $c121b5ea31b69b1c$export$e9b82d2e21ac0c1f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5E93O = parcelRequire("5E93O");

var $k01Ou = parcelRequire("k01Ou");

var $3vNgn = parcelRequire("3vNgn");

var $bMdrA = parcelRequire("bMdrA");

var $85eFT = parcelRequire("85eFT");

const $c121b5ea31b69b1c$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $a7f8c6b391092279$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($k01Ou))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $a7f8c6b391092279$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $a7f8c6b391092279$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($85eFT))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $a7f8c6b391092279$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $a7f8c6b391092279$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5E93O))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $a7f8c6b391092279$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $a7f8c6b391092279$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $a7f8c6b391092279$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3vNgn))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $a7f8c6b391092279$export$147899de772240ec)})`
    }
};
function $c121b5ea31b69b1c$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $c121b5ea31b69b1c$var$appearanceIconSchema[appearance] || $c121b5ea31b69b1c$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});


parcelRegister("6imks", function(module, exports) {

$parcel$export(module.exports, "default", () => $12bdc979066f02a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");

var $1ITUk = parcelRequire("1ITUk");

var $cFUJ2 = parcelRequire("cFUJ2");

var $hvAON = parcelRequire("hvAON");

var $aOOzT = parcelRequire("aOOzT");

var $bWfiu = parcelRequire("bWfiu");

var $3s0xG = parcelRequire("3s0xG");
const $12bdc979066f02a9$var$HealthcheckIcon = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.status.statusType === 'SUCCESS' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cFUJ2))), {
        color: "var(--ds-icon-success, #22A06B)",
        label: "Success"
    }), props.status.statusType === 'FAILURE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hvAON))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "Unsuccessful"
    }), props.status.statusType === 'NOT_TRIED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aOOzT))), {
        color: "var(--ds-icon, #44546F)",
        label: "Not Tried"
    }));
};
const $12bdc979066f02a9$var$getColorFromStatus = (status)=>{
    if (status.statusType === 'NOT_TRIED') return 'color.text.disabled';
    return 'color.text';
};
const $12bdc979066f02a9$var$HealthcheckTitle = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: $12bdc979066f02a9$var$getColorFromStatus(props.status)
    }, props.name);
};
const $12bdc979066f02a9$var$HealthcheckComment = (props)=>{
    const message = 'message' in props.status ? props.status.message : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: $12bdc979066f02a9$var$getColorFromStatus(props.status)
    }, message);
};
const $12bdc979066f02a9$var$convertToArray = (healthcheckEntries)=>{
    const wrapWithItem = (id, content, hasChildren, children)=>{
        return {
            id: id,
            content: content,
            hasChildren: hasChildren,
            children: children
        };
    };
    return healthcheckEntries.map((entry, index)=>{
        return wrapWithItem(`entry-${index}`, entry, false);
    });
};
const $12bdc979066f02a9$var$HealthcheckTable = (props)=>{
    const healthcheckItems = $12bdc979066f02a9$var$convertToArray(props.healthcheckEntries);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "medium"
    }, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, props.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ITUk.default), {
        columns: [
            $12bdc979066f02a9$var$HealthcheckIcon,
            $12bdc979066f02a9$var$HealthcheckTitle,
            $12bdc979066f02a9$var$HealthcheckComment
        ],
        headers: [
            'Status',
            'Item',
            'Details'
        ],
        columnWidths: [
            '100px',
            '50%',
            '50%'
        ],
        items: healthcheckItems,
        label: "Healthcheck Display"
    }, healthcheckItems.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
        header: "Not tried",
        description: "Address the above issues to continue."
    })));
};
var $12bdc979066f02a9$export$2e2bcd8739ae039 = $12bdc979066f02a9$var$HealthcheckTable;

});
parcelRegister("1ITUk", function(module, exports) {

$parcel$export(module.exports, "default", () => $92472cfa2ec4cdce$export$2e2bcd8739ae039);
/* eslint-disable react/prop-types */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bn3y9 = parcelRequire("bn3y9");

var $lQxRM = parcelRequire("lQxRM");

var $4ruUL = parcelRequire("4ruUL");

var $lhKLM = parcelRequire("lhKLM");

var $kaTPA = parcelRequire("kaTPA");

var $hNE0q = parcelRequire("hNE0q");
const $92472cfa2ec4cdce$var$emptyColumnWidths = [];
function $92472cfa2ec4cdce$var$TableTree({ children: children, columns: columns, columnWidths: defaultColumnWidths = $92472cfa2ec4cdce$var$emptyColumnWidths, headers: headers, shouldExpandOnClick: shouldExpandOnClick, items: items, mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel, label: label, referencedLabel: referencedLabel }) {
    const [columnWidths, setColumnWidths] = (0, $5uXOq.useState)(defaultColumnWidths);
    const setColumnWidth = (0, $5uXOq.useCallback)((columnIndex, width)=>{
        if (width === columnWidths[columnIndex]) return;
        setColumnWidths((columnWidths)=>{
            const newColumnWidths = [
                ...columnWidths
            ];
            newColumnWidths[columnIndex] = width;
            return newColumnWidths;
        });
    }, [
        columnWidths
    ]);
    const getColumnWidth = (0, $5uXOq.useCallback)((columnIndex)=>{
        return columnWidths[columnIndex] || null;
    }, [
        columnWidths
    ]);
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            setColumnWidth: setColumnWidth,
            getColumnWidth: getColumnWidth
        }), [
        setColumnWidth,
        getColumnWidth
    ]);
    const heads = headers && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ruUL.default), {
        children: headers.map((header, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lQxRM.default), {
                columnIndex: index,
                width: columnWidths[index],
                children: header
            }, index))
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lhKLM.TableTreeContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            role: "treegrid",
            "aria-readonly": true,
            "aria-label": label,
            "aria-labelledby": referencedLabel,
            children: [
                heads,
                columns && items && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hNE0q.default), {
                    items: items,
                    render: ({ id: id, children: children, content: content })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kaTPA.default), {
                            itemId: id,
                            items: children,
                            hasChildren: !!children && children.length > 0,
                            shouldExpandOnClick: shouldExpandOnClick,
                            mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel,
                            children: columns.map((CellContent, index)=>{
                                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bn3y9.default), {
                                    columnIndex: index,
                                    width: columnWidths[index],
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(CellContent, {
                                        ...content
                                    })
                                }, `cell-${index}`);
                            })
                        })
                }),
                children
            ]
        })
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$92472cfa2ec4cdce$export$2e2bcd8739ae039 = $92472cfa2ec4cdce$var$TableTree;

});
parcelRegister("bn3y9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ef9c624c7984116$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4osgr = parcelRequire("4osgr");

var $c2Trg = parcelRequire("c2Trg");

var $fXKQT = parcelRequire("fXKQT");
const $1ef9c624c7984116$var$CellComponent = ({ children: children, singleLine: singleLine, indentLevel: indentLevel, width: width, className: className, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4osgr.default), {
        indent: indentLevel ? `calc(${"var(--ds-space-300, 25px)"} * ${indentLevel})` : undefined,
        width: width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c2Trg.default), {
            isSingleLine: singleLine,
            children: children
        })
    });
const $1ef9c624c7984116$var$Cell = (0, $fXKQT.default)($1ef9c624c7984116$var$CellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1ef9c624c7984116$export$2e2bcd8739ae039 = $1ef9c624c7984116$var$Cell;

});
parcelRegister("4osgr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa7b647f554a7c13$export$2e2bcd8739ae039);
/* common-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $fa7b647f554a7c13$var$commonStyles = null;
/**
 * __Common cell__
 */ const $fa7b647f554a7c13$var$CommonCell = ({ indent: indent, width: width, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "gridcell",
        ...props,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            '--indent': indent,
            width: width
        },
        className: (0, $bwpsq.default)([
            "_1yt413wy _11c82smr _1e0c1txw _vchhusvi _1tke1ylp _kqswh2mm _4cvr1h6o _syaz1fxt _ct361wug _1nmz1hna"
        ])
    });
var $fa7b647f554a7c13$export$2e2bcd8739ae039 = $fa7b647f554a7c13$var$CommonCell;

});

parcelRegister("c2Trg", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1df51e4d314cea6$export$2e2bcd8739ae039);
/* overflow-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $a1df51e4d314cea6$var$overflowContainerStyles = null;
/**
 * __Overflow container__
 */ const $a1df51e4d314cea6$var$OverflowContainer = ({ isSingleLine: isSingleLine, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            isSingleLine && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    });
var $a1df51e4d314cea6$export$2e2bcd8739ae039 = $a1df51e4d314cea6$var$OverflowContainer;

});

parcelRegister("fXKQT", function(module, exports) {

$parcel$export(module.exports, "default", () => $205d85d674056312$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lhKLM = parcelRequire("lhKLM");
function $205d85d674056312$export$2e2bcd8739ae039(Cell) {
    return (props)=>{
        const { setColumnWidth: setColumnWidth, getColumnWidth: getColumnWidth } = (0, $5uXOq.useContext)((0, $lhKLM.TableTreeContext));
        const { width: width, columnIndex: columnIndex, ...other } = props;
        (0, $5uXOq.useEffect)(()=>{
            if (width !== undefined && columnIndex !== undefined) setColumnWidth(columnIndex, width);
        }, [
            width,
            columnIndex,
            setColumnWidth
        ]);
        let columnWidth;
        if (width !== null && width !== undefined) columnWidth = width;
        else if (columnIndex !== undefined) columnWidth = getColumnWidth(columnIndex);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Cell, {
            width: columnWidth,
            ...other
        });
    };
}

});
parcelRegister("lhKLM", function(module, exports) {

$parcel$export(module.exports, "TableTreeContext", () => $defed9db1e6cbaae$export$662c2d348d8b71af);

var $5uXOq = parcelRequire("5uXOq");
const $defed9db1e6cbaae$export$662c2d348d8b71af = /*#__PURE__*/ (0, $5uXOq.createContext)({
    setColumnWidth: ()=>{},
    getColumnWidth: ()=>null
});

});



parcelRegister("lQxRM", function(module, exports) {

$parcel$export(module.exports, "default", () => $325dc920bad4331e$export$2e2bcd8739ae039);
/* header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4osgr = parcelRequire("4osgr");

var $fXKQT = parcelRequire("fXKQT");
const $325dc920bad4331e$var$headerStyles = null;
const $325dc920bad4331e$var$HeaderComponent = ({ width: width, children: children, onClick: onClick, id: id, role: role = 'columnheader' })=>{
    // TODO: Determine whether proper `th` elements can be used instead of
    // roles (DSP-11588)
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4osgr.default), {
        role: role,
        width: width,
        id: id,
        onClick: onClick,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz1n3s _k48pmoej"
        ]),
        children: children
    });
};
const $325dc920bad4331e$var$Header = (0, $fXKQT.default)($325dc920bad4331e$var$HeaderComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$325dc920bad4331e$export$2e2bcd8739ae039 = $325dc920bad4331e$var$Header;

});

parcelRegister("4ruUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddf75bdb83c6671b$export$2e2bcd8739ae039);
/* headers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
/* eslint-disable @repo/internal/react/no-clone-element */ const $ddf75bdb83c6671b$var$containerStyles = null;
/**
 * __Headers__
 *
 * Headers component for advanced composition of data, allowing custom data structures.
 *
 * - [Examples](https://atlassian.design/components/table-tree/examples#advanced)
 * - [Code](https://atlassian.design/components/table-tree/code#headers-props)
 */ const $ddf75bdb83c6671b$var$Headers = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "row",
        className: (0, $bwpsq.default)([
            "_179r17qy _1e0c1txw"
        ]),
        children: (0, $5uXOq.Children).map(children, (header, index)=>/*#__PURE__*/ (0, $5uXOq.cloneElement)(header, {
                key: index,
                columnIndex: index
            }))
    });
var $ddf75bdb83c6671b$export$2e2bcd8739ae039 = $ddf75bdb83c6671b$var$Headers;

});

parcelRegister("kaTPA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4364a05aff0c8dc$export$2e2bcd8739ae039);
/* row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $5Litl = parcelRequire("5Litl");

var $8NCnV = parcelRequire("8NCnV");

var $6JFqU = parcelRequire("6JFqU");
const $f4364a05aff0c8dc$var$treeRowClickableStyles = null;
const $f4364a05aff0c8dc$var$getExtendedLabel = (cellContent, cellIndex, mainColumnForExpandCollapseLabel)=>{
    /**
   * First condition - when we pass data via `items` property in `<TableTree />`
   * Second condition - when we pass data via `<Rows />` as children in `<TableTree />`.
   */ if (cellContent.hasOwnProperty('props')) return cellContent?.props[mainColumnForExpandCollapseLabel?.toLowerCase()];
    else if (cellIndex === mainColumnForExpandCollapseLabel) return cellContent;
    return undefined;
};
function $f4364a05aff0c8dc$var$Row({ shouldExpandOnClick: shouldExpandOnClick, hasChildren: hasChildren, depth: depth, renderChildren: renderChildren, isDefaultExpanded: isDefaultExpanded, data: data, onExpand: providedOnExpand, onCollapse: providedOnCollapse, mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel, expandLabel: expandLabel, collapseLabel: collapseLabel, itemId: itemId, children: children, isExpanded: isProvidedExpanded }) {
    const [isExpandedState, setIsExpandedState] = (0, $5uXOq.useState)(isDefaultExpanded || false);
    (0, $5uXOq.useEffect)(()=>{
        if (isProvidedExpanded === undefined && isDefaultExpanded !== undefined && isExpandedState !== isDefaultExpanded) setIsExpandedState(isDefaultExpanded);
    }, [
        isDefaultExpanded,
        isProvidedExpanded,
        isExpandedState
    ]);
    const onExpand = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (value)=>providedOnExpand && providedOnExpand(value),
        action: 'expanded',
        actionSubject: 'tableTree',
        componentName: 'row',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onCollapse = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (value)=>providedOnCollapse && providedOnCollapse(value),
        action: 'collapsed',
        actionSubject: 'tableTree',
        componentName: 'row',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    }); /**
       * This ensures a user won't trigger a click event and expand the accordion
       * when making a text selection.
       */ 
    const onClickHandler = (e)=>{
        const selection = window.getSelection()?.toString() || '';
        if (selection?.length === 0) onExpandToggle();
    };
    const onExpandStateChange = (isExpanded)=>{
        if (data) {
            if (isExpanded && onExpand) onExpand(data);
            else if (!isExpanded && onCollapse) onCollapse(data);
        }
    };
    const onExpandToggle = ()=>{
        if (isProvidedExpanded !== undefined) onExpandStateChange(!isProvidedExpanded);
        else setIsExpandedState((prevState)=>{
            onExpandStateChange(!prevState);
            return !prevState;
        });
    };
    const renderCell = (cell, cellIndex)=>{
        const isFirstCell = cellIndex === 0;
        const indentLevel = isFirstCell ? depth : 0;
        let cellContent = cell.props.children || [];
        const extendedLabel = $f4364a05aff0c8dc$var$getExtendedLabel(cellContent, cellIndex, mainColumnForExpandCollapseLabel);
        if (isFirstCell && hasChildren) cellContent = [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8NCnV.default), {
                expandLabel: expandLabel,
                collapseLabel: collapseLabel,
                extendedLabel: extendedLabel,
                isExpanded: isProvidedExpanded !== undefined ? isProvidedExpanded : isExpandedState,
                onExpandToggle: onExpandToggle,
                ariaControls: !!itemId ? (0, $5Litl.default)(itemId) : undefined,
                rowId: !!itemId ? itemId : ''
            }, "chevron")
        ].concat(cellContent);
         // eslint-disable-next-line @repo/internal/react/no-clone-element
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(cell, {
            key: cellIndex,
            columnIndex: cellIndex,
            indentLevel: indentLevel
        }, cellContent);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6JFqU.TreeRowContainer), {
                onClick: hasChildren && shouldExpandOnClick ? onClickHandler : undefined,
                "aria-expanded": hasChildren ? isExpandedState : undefined,
                "aria-level": depth ? depth : undefined,
                className: (0, $bwpsq.default)([
                    hasChildren && shouldExpandOnClick && "_80omtlke"
                ]),
                children: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (cell, index)=>renderCell(cell, index))
            }),
            hasChildren && (isProvidedExpanded !== undefined ? isProvidedExpanded : isExpandedState) && renderChildren && renderChildren()
        ]
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f4364a05aff0c8dc$export$2e2bcd8739ae039 = $f4364a05aff0c8dc$var$Row;

});
parcelRegister("5Litl", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc1d640cb8c4f262$export$2e2bcd8739ae039);
function $cc1d640cb8c4f262$export$2e2bcd8739ae039(id) {
    return `tabletreeitem-${id}`.replace(/[^-_a-zA-Z0-9]/g, '');
}

});

parcelRegister("8NCnV", function(module, exports) {

$parcel$export(module.exports, "default", () => $81a1daa91cd54907$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/consistent-props-definitions */ /* eslint-disable react/prop-types */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1Seuh = parcelRequire("1Seuh");

var $bKnKN = parcelRequire("bKnKN");

var $dGKFs = parcelRequire("dGKFs");

var $cwX8H = parcelRequire("cwX8H");

var $6JFqU = parcelRequire("6JFqU");
/**
 * Internal chevron component.
 */ const $81a1daa91cd54907$var$Chevron = ({ isExpanded: isExpanded, ariaControls: ariaControls, collapseLabel: collapseLabel = 'Collapse', expandLabel: expandLabel = 'Expand', rowId: rowId, extendedLabel: extendedLabel, onExpandToggle: onExpandToggle = (0, $bKnKN.default) })=>{
    const getLabel = (defaultLabel)=>extendedLabel ? `${defaultLabel} ${extendedLabel} row` : `${defaultLabel} row ${rowId}`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6JFqU.ChevronContainer), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
            appearance: "subtle",
            onClick: onExpandToggle,
            spacing: "compact",
            icon: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($dGKFs))) : (0, (/*@__PURE__*/$parcel$interopDefault($cwX8H))),
            "aria-controls": isExpanded ? ariaControls : undefined,
            label: isExpanded ? getLabel(collapseLabel) : getLabel(expandLabel)
        })
    });
};
var $81a1daa91cd54907$export$2e2bcd8739ae039 = $81a1daa91cd54907$var$Chevron;

});
parcelRegister("6JFqU", function(module, exports) {

$parcel$export(module.exports, "TreeRowContainer", () => $27af0b4f64115e6a$export$802d2031792f9e4);
$parcel$export(module.exports, "ChevronContainer", () => $27af0b4f64115e6a$export$f25bd028f55b3d30);
$parcel$export(module.exports, "LoaderItemContainer", () => $27af0b4f64115e6a$export$94ae573de7227397);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $27af0b4f64115e6a$var$treeRowContainerStyles = null;
const $27af0b4f64115e6a$export$802d2031792f9e4 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "row",
        ...props,
        className: (0, $bwpsq.default)([
            "_179r1l7n _1e0c1txw"
        ])
    });
const $27af0b4f64115e6a$var$commonCellElementStyles = null;
const $27af0b4f64115e6a$var$commonChevronContainerStyles = null;
const $27af0b4f64115e6a$export$f25bd028f55b3d30 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _4cvr1h6o _ahbqf2s7",
            "_1pfhj39m"
        ])
    });
const $27af0b4f64115e6a$var$loadingItemContainerStyles = null;
const $27af0b4f64115e6a$var$paddingLeftStyles = null;
const $27af0b4f64115e6a$export$94ae573de7227397 = ({ isRoot: isRoot, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _4cvr1h6o _ahbqf2s7",
            "_1bsb1osq",
            isRoot && "_bozg1ssb"
        ])
    });

});



parcelRegister("hNE0q", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1172082e8558b60$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6t8ZH = parcelRequire("6t8ZH");
function $f1172082e8558b60$var$Rows({ items: items, render: render, loadingLabel: loadingLabel = 'Loading' }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "rowgroup",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6t8ZH.default), {
            items: items,
            loadingLabel: loadingLabel,
            render: render
        })
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f1172082e8558b60$export$2e2bcd8739ae039 = $f1172082e8558b60$var$Rows;

});
parcelRegister("6t8ZH", function(module, exports) {

$parcel$export(module.exports, "default", () => $25a8230a89e03363$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4UUsO = parcelRequire("4UUsO");

var $5TFwy = parcelRequire("5TFwy");
function $25a8230a89e03363$var$Items({ depth: depth = 0, items: items, loadingLabel: loadingLabel, render: render }) {
    const [isLoaderShown, setIsLoaderShown] = (0, $5uXOq.useState)(false);
    const handleLoaderComplete = ()=>setIsLoaderShown(false);
    return !items || isLoaderShown ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5TFwy.default), {
        isCompleting: !!(items && items.length),
        onComplete: handleLoaderComplete,
        depth: depth + 1,
        loadingLabel: loadingLabel
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: items.map((data)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4UUsO.default), {
                data: data,
                depth: depth + 1,
                render: render,
                loadingLabel: loadingLabel
            }, data.id))
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$25a8230a89e03363$export$2e2bcd8739ae039 = $25a8230a89e03363$var$Items;

});
parcelRegister("4UUsO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3fffd3746dbd3d7$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-clone-element */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5Litl = parcelRequire("5Litl");

var $6t8ZH = parcelRequire("6t8ZH");
/**
 * __Item__
 * Internal item component.
 */ function $e3fffd3746dbd3d7$var$Item({ depth: depth = 0, data: data, render: render, loadingLabel: loadingLabel }) {
    const renderedRow = render(data);
    if (!renderedRow) return null;
    // itemId exists on RowProps, but not on RowsProps
    const itemId = 'itemId' in renderedRow.props ? renderedRow.props.itemId : undefined;
    const items = renderedRow.props.items;
    return /*#__PURE__*/ (0, $5uXOq.cloneElement)(renderedRow, {
        depth: depth,
        data: data,
        loadingLabel: loadingLabel,
        renderChildren: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                id: !!itemId ? (0, $5Litl.default)(itemId) : undefined,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6t8ZH.default), {
                    depth: depth,
                    items: items,
                    render: render,
                    loadingLabel: loadingLabel
                })
            })
    });
}
var $e3fffd3746dbd3d7$export$2e2bcd8739ae039 = $e3fffd3746dbd3d7$var$Item;

});

parcelRegister("5TFwy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e06ff0d2336da21$export$2e2bcd8739ae039);
/* eslint-disable react/prop-types */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $clxo5 = parcelRequire("clxo5");

var $4osgr = parcelRequire("4osgr");

var $6JFqU = parcelRequire("6JFqU");
const $2e06ff0d2336da21$var$LoaderItem = ({ depth: depth = 1, loadingLabel: loadingLabel, isCompleting: isCompleting, onComplete: onComplete })=>{
    const [phase, setPhase] = (0, $5uXOq.useState)('loading');
    (0, $5uXOq.useEffect)(()=>{
        if (phase === 'loading' && isCompleting) setPhase(()=>{
            onComplete();
            return 'complete';
        });
    }, [
        isCompleting,
        onComplete,
        phase
    ]);
    return phase === 'loading' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6JFqU.TreeRowContainer), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4osgr.default), {
            indent: `calc(${"var(--ds-space-300, 25px)"} * ${depth})`,
            width: "100%",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6JFqU.LoaderItemContainer), {
                isRoot: depth === 1,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {
                    size: "small",
                    testId: "table-tree-spinner",
                    label: loadingLabel
                })
            })
        })
    }) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2e06ff0d2336da21$export$2e2bcd8739ae039 = $2e06ff0d2336da21$var$LoaderItem;

});




parcelRegister("aOOzT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8514ab409cdd1786faf0e15acb24fff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e05ce9a7ac30360$var$_react = $7e05ce9a7ac30360$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7e05ce9a7ac30360$var$_baseNew = $7e05ce9a7ac30360$var$_interopRequireDefault((parcelRequire("enEmH")));
function $7e05ce9a7ac30360$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TaskToDo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for to-do task status. Used in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e05ce9a7ac30360$var$TaskToDoIcon = (props)=>/*#__PURE__*/ $7e05ce9a7ac30360$var$_react.default.createElement($7e05ce9a7ac30360$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.028 1.5H8V0h.034c1.957.008 3.75.72 5.135 1.894L12.2 3.04A6.47 6.47 0 0 0 8.03 1.5m-2.278.4a6.52 6.52 0 0 0-3.395 2.875l-1.302-.746A8.02 8.02 0 0 1 5.23.493zM14.5 8a6.47 6.47 0 0 0-.856-3.227l1.301-.745A7.97 7.97 0 0 1 16 8q0 .727-.126 1.42l-1.476-.264A6.6 6.6 0 0 0 14.5 8M1.593 6.895A6.6 6.6 0 0 0 1.5 8c0 1.194.321 2.31.882 3.27l-1.296.757A7.97 7.97 0 0 1 0 8q.001-.694.115-1.358zm8.605 7.224a6.52 6.52 0 0 0 3.419-2.845l1.295.757a8.02 8.02 0 0 1-4.208 3.5zm-6.344-1.113A6.47 6.47 0 0 0 8 14.5V16a7.97 7.97 0 0 1-5.104-1.84z" clip-rule="evenodd"/>`
    }, props));
$7e05ce9a7ac30360$var$TaskToDoIcon.displayName = 'TaskToDoIcon';
var $7e05ce9a7ac30360$var$_default = module.exports.default = $7e05ce9a7ac30360$var$TaskToDoIcon;

});


parcelRegister("426ZA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ae4fabdb7582137$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bWfiu = parcelRequire("bWfiu");

var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");
const $5ae4fabdb7582137$var$HealthcheckHeader = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "large"
    }, "Extra Auth Healthcheck"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, "Status of Extra Authenticated Application Links for your Jira Cloud site.")));
};
var $5ae4fabdb7582137$export$2e2bcd8739ae039 = $5ae4fabdb7582137$var$HealthcheckHeader;

});

parcelRegister("bmSXq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2146cc344dbb357b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9FSw2 = parcelRequire("9FSw2");
var $82qqY = parcelRequire("82qqY");

var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");
const $2146cc344dbb357b$var$HealthcheckSuggestedAction = (props)=>{
    const actions = props.link ? [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $82qqY.default), {
            key: "action",
            href: props.link
        }, "Go to page")
    ] : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FSw2.default), {
        title: "Failure",
        appearance: "error",
        actions: actions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, props.error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, props.action))));
};
var $2146cc344dbb357b$export$2e2bcd8739ae039 = $2146cc344dbb357b$var$HealthcheckSuggestedAction;

});
parcelRegister("82qqY", function(module, exports) {

$parcel$export(module.exports, "default", () => $0aa506c3a6b0d8eb$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $6tzHJ = parcelRequire("6tzHJ");

var $fHpHg = parcelRequire("fHpHg");

var $3YyrB = parcelRequire("3YyrB");
var $5sRpy = parcelRequire("5sRpy");
var $7rJgC = parcelRequire("7rJgC");
const $0aa506c3a6b0d8eb$var$styles = {
    common: "_11c82smr _syaz14q2 _k48p1wq8 _30l314q2 _9h8h16c2",
    anchor: "_1053w7te _9oik18uv _1bnx8stv _jf4cnqa1 _n0fxw7te _1vhvg3x0",
    pressable: "_bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $0aa506c3a6b0d8eb$var$SectionMessageAction = /*#__PURE__*/ (0, $5uXOq.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
    if (!linkComponent && (0, $fHpHg.fg)('platform_section_message_action_migration')) {
        if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3YyrB.default), {
            testId: testId,
            onClick: onClick,
            href: href,
            xcss: (0, $6tzHJ.cx)($0aa506c3a6b0d8eb$var$styles.common, $0aa506c3a6b0d8eb$var$styles.anchor),
            children: children
        });
        if (onClick) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $6tzHJ.cx)($0aa506c3a6b0d8eb$var$styles.common, $0aa506c3a6b0d8eb$var$styles.pressable),
            children: children
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
            as: "span",
            testId: testId,
            children: children
        });
    }
    return onClick || href ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
});
var $0aa506c3a6b0d8eb$export$2e2bcd8739ae039 = $0aa506c3a6b0d8eb$var$SectionMessageAction;

});





parcelRegister("3A9DP", function(module, exports) {

$parcel$export(module.exports, "applinksExtraAuthHealthcheckRoute", () => $1566be2cb38c0d94$export$c92684a6af97ae19);
const $1566be2cb38c0d94$export$c92684a6af97ae19 = {
    name: 'global-settings-products-applinks-extra-auth',
    path: '/jira/settings/applinks/extra-auth/healthcheck',
    exact: true
};

});



parcelRegister("gGB8S", function(module, exports) {

$parcel$export(module.exports, "startJiraSpa", () => $2f70583cb46f9994$export$f71867a5b2484020);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $fr1K2 = parcelRequire("fr1K2");

var $3NMrl = parcelRequire("3NMrl");

var $kUr4d = parcelRequire("kUr4d");

var $1POpY = parcelRequire("1POpY");

var $iyRIi = parcelRequire("iyRIi");

var $5qBRE = parcelRequire("5qBRE");

var $j5G08 = parcelRequire("j5G08");

var $1V2aV = parcelRequire("1V2aV");

var $bl6ih = parcelRequire("bl6ih");

var $k4NnA = parcelRequire("k4NnA");

var $aTq2A = parcelRequire("aTq2A");


var $87OsA = parcelRequire("87OsA");
parcelRequire("2YzDH");

var $x9xyg = parcelRequire("x9xyg");

var $4Pf62 = parcelRequire("4Pf62");

var $frBVt = parcelRequire("frBVt");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $7bkFJ = parcelRequire("7bkFJ");

var $4R6GH = parcelRequire("4R6GH");

var $hL7JE = parcelRequire("hL7JE");

var $kZBXc = parcelRequire("kZBXc");

var $cfDZ3 = parcelRequire("cfDZ3");

var $6jY6G = parcelRequire("6jY6G");

var $9F6Ii = parcelRequire("9F6Ii");

var $81ezV = parcelRequire("81ezV");

var $b7awD = parcelRequire("b7awD");

var $d1K1f = parcelRequire("d1K1f");

var $2SVPM = parcelRequire("2SVPM");

var $fGcGc = parcelRequire("fGcGc");

var $bShz7 = parcelRequire("bShz7");

var $lbyb6 = parcelRequire("lbyb6");

var $5HG6S = parcelRequire("5HG6S");

var $29g8C = parcelRequire("29g8C");

var $kKlrY = parcelRequire("kKlrY");

var $l8ruj = parcelRequire("l8ruj");

var $3qHVS = parcelRequire("3qHVS");

var $50oqM = parcelRequire("50oqM");
var $jP5md = parcelRequire("jP5md");

var $2Gs5h = parcelRequire("2Gs5h");
var $lVJAU = parcelRequire("lVJAU");

var $95Orn = parcelRequire("95Orn");

var $lODMY = parcelRequire("lODMY");

var $iLrcb = parcelRequire("iLrcb");

var $fg6X1 = parcelRequire("fg6X1");

var $c1haS = parcelRequire("c1haS");

var $2ChuC = parcelRequire("2ChuC");
// Set SPA global
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window.__SPA__ = true;
const $2f70583cb46f9994$var$altBootstrapEnabled = // It is easier to make the check against window than it is to make typescript happy here.
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
!false && typeof window !== 'undefined' && window.__SPA_BOOTSTRAP_ALT;
// In the experiment scenario, I'm moving the side-effect from immediate execution to function execution.
if (!$2f70583cb46f9994$var$altBootstrapEnabled) (0, $50oqM.LooselyLazy).init({
    mode: (()=>(0, $4R6GH.fg)('jfp_magma_jira-rll-hydrate'))() ? (0, $jP5md.MODE).HYDRATE : (0, $jP5md.MODE).RENDER,
    crossOrigin: 'anonymous',
    // hide fg access from eslint, we can do it on "pure client
    react18: (()=>(0, $4R6GH.fg)('jfp_magma_jira-rll-react-18-render'))(),
    usePostTaskPhases: (()=>(0, $4R6GH.fg)('jfp-jira-remove-rll-subscriptions'))()
});

const $2f70583cb46f9994$var$getMessages = ()=>{
    (0, $x9xyg.setMark)('jira-spa/language-pack.start');
    const messages = (parcelRequire("hWnRN"));
    (0, $x9xyg.setMark)('jira-spa/language-pack.end');
    return messages;
};
const $2f70583cb46f9994$var$superbatchInit = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.DeferScripts = {
        deferState: 'done'
    };
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body && document.body.classList.remove('deferred');
};
const $2f70583cb46f9994$var$globalSettingsArgs = {
    navigation: false,
    upflow: false
};
const $2f70583cb46f9994$var$InstallGlobalComponentsOnce = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $2ChuC.default).installLowPriorityApps(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'LowPriorityAppsArgs'.
        (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))($2f70583cb46f9994$var$globalSettingsArgs, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
        (0, $x9xyg.setMark)('JIRA_SPA_ENTRY_GLOBAL_INSTALL');
    }, []);
    return null;
};
const $2f70583cb46f9994$var$updateCapability = (capability)=>{
    (0, $87OsA.setCapability)(capability);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (capability === null && window.AJS?.$?.ajaxSettings?.headers?.[0, $281cbd47ba46dd7d$export$9a80695e72849f84]) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.AJS.$.ajaxSettings.headers[0, $281cbd47ba46dd7d$export$9a80695e72849f84];
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.AJS?.$?.ajaxSetup({
        headers: {
            [(0, $281cbd47ba46dd7d$export$9a80695e72849f84)]: capability
        }
    });
};
// @ts-expect-error - TS7031 - Binding element 'routes' implicitly has an 'any' type.
const $2f70583cb46f9994$var$CapabilityTrackerConnector = ({ routes: routes })=>{
    const { registerBlock: registerBlock } = (0, $lVJAU.useRouterActions)();
    registerBlock((nextLocation)=>{
        const nextMatchObject = (0, $2Gs5h.default)(routes, nextLocation.pathname, // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'Query | undefined'.
        nextLocation.search, '');
        $2f70583cb46f9994$var$updateCapability(nextMatchObject?.route.meta?.capability || null);
        return true;
    });
    const route = (0, $6jY6G.useCurrentRoute)();
    $2f70583cb46f9994$var$updateCapability(route.meta?.capability || null);
    return null;
};
const $2f70583cb46f9994$var$main = async (getInitialRoutes, loadLazyRoutes)=>{
    if ((0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nin_and_nav') || (0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nav_for_iv') || (0, $4R6GH.fg)('add_nav_ssr_placeholder_for_board_and_backlog')) (0, $iyRIi.collectSSRPlaceholderDimensions)(document, window);
    (0, $kKlrY.default)();
    (0, $aTq2A.initBrowserMetrics3)();
    (0, $7bkFJ.initPlatformFeatureFlags)((0, $3qHVS.visualRefreshResolverOverride));
    (0, $fg6X1.initEntryPointConfig)();
    (0, $fGcGc.addInitialPageLoadTimings)();
    (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/init', 'jira-spa.js:eval-start');
    (0, $x9xyg.setMark)('jira-spa/setup.start');
    const routes = (0, $2SVPM.measureInitialPageLoadTiming)('jira-spa/setup/routes', ()=>getInitialRoutes());
    const history = (0, $2SVPM.measureInitialPageLoadTiming)('jira-spa/setup/history', ()=>(0, $lbyb6.default)(routes));
    const initRoute = (0, $2SVPM.measureInitialPageLoadTiming)('jira-spa/setup/match-route', ()=>{
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'Query | undefined'.
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const matchedRoute = (0, $2Gs5h.default)(routes, window.location.pathname, window.location.search);
        (0, $cfDZ3.setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
        return matchedRoute;
    });
    if (initRoute != null) {
        const ufoName = (0, $1POpY.default)(initRoute.route);
        (0, $5qBRE.default)(ufoName, initRoute.route.name);
    }
    const BrowserMetricsConnector = ()=>{
        const route = (0, $6jY6G.useCurrentRoute)();
        (0, $bl6ih.browserMetrics).setRoute(route.name);
        (0, $j5G08.useUFOTransitionCompleter)();
        (0, $iLrcb.GlobalPageLoadExperience).setPageLoadId(route.perfMetricKey || 'UNKNOWN');
        return null;
    };
    (0, $iLrcb.GlobalPageLoadExperience).startPageLoad('UNKNOWN', true);
    const messages = $2f70583cb46f9994$var$getMessages();
    const tenantContext = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const { locale: locale } = tenantContext;
    const routerProps = {
        history: history,
        routes: routes,
        basePath: '',
        initialRoute: initRoute?.route,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        resourceData: window.SPA_STATE,
        resourceContext: (0, $5HG6S.getSpaRouterContext)({
            tenantContext: tenantContext
        }),
        onPrefetch: ({ route: route, match: match })=>{
            (0, $bShz7.setPrefetchStartMark)(match);
            if (!route.forPaint) return;
            route.forPaint.map((component)=>component.preload && component.preload());
        },
        isLazyRoutes: typeof loadLazyRoutes === 'function'
    };
    let SpaClientRouter;
    if (typeof loadLazyRoutes === 'function') {
        const useRouterRoutes = (0, $lODMY.createRouterSelector)((state)=>state.routes);
        SpaClientRouter = ({ children: children })=>{
            const actions = (0, $lODMY.useRouterStoreActions)();
            const currentRoutes = useRouterRoutes();
            (0, $5uXOq.useEffect)(()=>{
                let isCancelled = false;
                const loadRoutes = async ()=>{
                    if (!isCancelled) {
                        const getLazyRoutes = await loadLazyRoutes();
                        await actions.setRoutes(getLazyRoutes());
                    }
                };
                loadRoutes();
                return ()=>{
                    isCancelled = true;
                };
            }, [
                actions
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b7awD.Router), routerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
                id: "spa-main.client-router",
                packageName: "jiraEntry",
                fallback: "unmount",
                teamName: "delorean-spa"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $95Orn.AtlaspackMetricsConnector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BrowserMetricsConnector, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$CapabilityTrackerConnector, {
                routes: currentRoutes
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d1K1f.default), null)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hL7JE.NonCritical), {
                id: "spa-main.client-router.non-critical",
                teamName: "delorean-spa"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$InstallGlobalComponentsOnce, null)));
        };
    } else SpaClientRouter = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b7awD.Router), routerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            id: "spa-main.client-router",
            packageName: "jiraEntry",
            fallback: "unmount",
            teamName: "delorean-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $95Orn.AtlaspackMetricsConnector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BrowserMetricsConnector, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$CapabilityTrackerConnector, {
            routes: routes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d1K1f.default), null)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hL7JE.NonCritical), {
            id: "spa-main.client-router.non-critical",
            teamName: "delorean-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f70583cb46f9994$var$InstallGlobalComponentsOnce, null)));
    const App = ({ placeholders: placeholders })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9F6Ii.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: "jira-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointPlaceholderContext).Provider, {
            value: placeholders
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZBXc.Spa), {
            baseUrl: "",
            locale: locale,
            messages: messages,
            Router: SpaClientRouter,
            initRoute: initRoute,
            routes: routes,
            routerLinkComponent: (0, $81ezV.JiraRouterLinkConfiguration)
        }))));
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__NAV_VERSION__ = '3.0.0';
    (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/setup', 'jira-spa/setup.start', true);
    (0, $x9xyg.setMark)('_jira-spa/spa-shell.start');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const container = document.getElementById('jira-frontend');
    if (container) {
        (0, $1V2aV.getVCObserver)().setSSRElement(container);
        (0, $1V2aV.getVCObserver)().setReactRootRenderStart();
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                (0, $1V2aV.getVCObserver)().setReactRootRenderStop();
            });
        });
        const placeholders = (0, $frBVt.getPlaceholdersFromHTML)();
        const isConcurrentEnabled = (0, $c1haS.getIsConcurrentEnabled)();
        // if the feature flag is false, do not opt into concurrent features
        // if the local env var is not set, or set to false, do not opt into concurrent features
        if (!isConcurrentEnabled) (0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(App, {
            placeholders: placeholders
        }), container);
        if (isConcurrentEnabled) {
            if ((0, $4R6GH.fg)('jfp-magma-incremental-hydrate-root')) {
                const ConcurrentSpaApp = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(App, {
                        placeholders: placeholders
                    }), (0, $4R6GH.fg)('concurrent-rendering-change-advisory') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29g8C.ConcurrentAdvisory), {
                        consoleMessage: "This entire site is being rendered with React concurrent rendering go/r18"
                    }) : null);
                if (initRoute?.route?.isHydrateRootEnabled) (0, $kUr4d.hydrateRoot)(container, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConcurrentSpaApp, null));
                else {
                    const root = (0, $kUr4d.createRoot)(container);
                    root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConcurrentSpaApp, null));
                }
            } else {
                const root = (0, $kUr4d.createRoot)(container);
                root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(App, {
                    placeholders: placeholders
                }), (0, $4R6GH.fg)('concurrent-rendering-change-advisory') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29g8C.ConcurrentAdvisory), {
                    consoleMessage: "This entire site is being rendered with React concurrent rendering go/r18"
                }) : null));
            }
        }
    }
    (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/spa-shell', '_jira-spa/spa-shell.start');
    (0, $x9xyg.setMark)('JIRA_SPA_ENTRY_REACT_DOM_RENDER');
    setTimeout(()=>{
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa', 'commons-entry.js:eval-stop', 'jira-spa.js:eval-stop');
    });
    if ((0, $6s1PB.expVal)('uip_preprod_slow', 'value', 0) > 0) {
        (0, $x9xyg.setMark)('slow-start');
        const end = performance.now() + (0, $6s1PB.expVal)('uip_preprod_slow', 'value', 0);
        while(performance.now() < end);
        (0, $x9xyg.setMark)('slow-stop');
    }
    (0, $2ChuC.default).installHighPriorityApps(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'HighPriorityAppsArgs'.
    (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))($2f70583cb46f9994$var$globalSettingsArgs, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
    $2f70583cb46f9994$var$superbatchInit();
    return null;
};
const $2f70583cb46f9994$export$f71867a5b2484020 = async (getInitialRoutes, loadLazyRoutes)=>{
    if ($2f70583cb46f9994$var$altBootstrapEnabled) (0, $50oqM.LooselyLazy).init({
        mode: (0, $jP5md.MODE).RENDER,
        crossOrigin: 'anonymous'
    });
    return $2f70583cb46f9994$var$main(getInitialRoutes, loadLazyRoutes).catch((reason)=>(0, $k4NnA.reportBootstrapError)(reason));
};

});
parcelRegister("fr1K2", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $7MmCC = parcelRequire("7MmCC");

var $ftdKz = parcelRequire("ftdKz");

var $etAYC = parcelRequire("etAYC");

var $4NkAS = parcelRequire("4NkAS");

var $b2dLE = parcelRequire("b2dLE");

var $9SRAA = parcelRequire("9SRAA");

var $7GWAt = parcelRequire("7GWAt");
/** Used to compose bitmasks for cloning. */ var $b3caba7e25e0a917$var$CLONE_DEEP_FLAG = 1, $b3caba7e25e0a917$var$CLONE_FLAT_FLAG = 2, $b3caba7e25e0a917$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $b3caba7e25e0a917$var$omit = $9SRAA(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $1nIHN(paths, function(path) {
        path = $etAYC(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $4NkAS(object, $7GWAt(object), result);
    if (isDeep) result = $7MmCC(result, $b3caba7e25e0a917$var$CLONE_DEEP_FLAG | $b3caba7e25e0a917$var$CLONE_FLAT_FLAG | $b3caba7e25e0a917$var$CLONE_SYMBOLS_FLAG, $b2dLE);
    var length = paths.length;
    while(length--)$ftdKz(result, paths[length]);
    return result;
});
module.exports = $b3caba7e25e0a917$var$omit;

});
parcelRegister("ftdKz", function(module, exports) {

var $etAYC = parcelRequire("etAYC");

var $hYfgW = parcelRequire("hYfgW");

var $8lSJl = parcelRequire("8lSJl");

var $gzebZ = parcelRequire("gzebZ");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $b4343aeaece186b7$var$baseUnset(object, path) {
    path = $etAYC(path, object);
    object = $8lSJl(object, path);
    return object == null || delete object[$gzebZ($hYfgW(path))];
}
module.exports = $b4343aeaece186b7$var$baseUnset;

});
parcelRegister("8lSJl", function(module, exports) {

var $fTwLR = parcelRequire("fTwLR");

var $dM3Z8 = parcelRequire("dM3Z8");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $614abd39878e1d90$var$parent(object, path) {
    return path.length < 2 ? object : $fTwLR(object, $dM3Z8(path, 0, -1));
}
module.exports = $614abd39878e1d90$var$parent;

});


parcelRegister("b2dLE", function(module, exports) {

var $1QOns = parcelRequire("1QOns");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $808a8f8fca7f9ff7$var$customOmitClone(value) {
    return $1QOns(value) ? undefined : value;
}
module.exports = $808a8f8fca7f9ff7$var$customOmitClone;

});


parcelRegister("kUr4d", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $f38e08888af96a1f$export$882461b6382ed46c, (v) => $f38e08888af96a1f$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $f38e08888af96a1f$export$757ceba2d55c277e, (v) => $f38e08888af96a1f$export$757ceba2d55c277e = v);
var $f38e08888af96a1f$export$882461b6382ed46c;
var $f38e08888af96a1f$export$757ceba2d55c277e;
'use strict';

var $7nsd3 = parcelRequire("7nsd3");
var $f38e08888af96a1f$var$i;
$f38e08888af96a1f$export$882461b6382ed46c = $7nsd3.createRoot;
$f38e08888af96a1f$export$757ceba2d55c277e = $7nsd3.hydrateRoot;

});

parcelRegister("1POpY", function(module, exports) {

$parcel$export(module.exports, "default", () => $189aa741035da509$export$2e2bcd8739ae039);
function $189aa741035da509$export$2e2bcd8739ae039(route) {
    if (route.ufoName != null) return route.ufoName;
    return route.name;
}

});

parcelRegister("iyRIi", function(module, exports) {

$parcel$export(module.exports, "collectSSRPlaceholderDimensions", () => $262f7debd1033754$export$aee7516e57289027);
// lightweight script to scan the SSR response and collect all elements with data-ssr-placeholder attribute
// and save their size/positions in a map __SSR_PLACEHOLDERS_DIMENSIONS__ on the Window object. Each placeholderId is
// unique and maps to its corresponding elements bounding client rectangle dimensions.
function $262f7debd1033754$export$aee7516e57289027(document, window) {
    const ssrPlaceholders = document?.querySelectorAll('[data-ssr-placeholder]');
    ssrPlaceholders.forEach((elem)=>{
        const placeholderId = elem.getAttribute('data-ssr-placeholder');
        const boundingClient = elem.getBoundingClientRect();
        if (placeholderId) {
            window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
            window.__SSR_PLACEHOLDERS_DIMENSIONS__[placeholderId] = boundingClient;
        }
    });
}

});

parcelRegister("5qBRE", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd0971e9bc988992$export$2e2bcd8739ae039);
$parcel$export(module.exports, "updatePageloadName", () => $bd0971e9bc988992$export$d0f99433cd4f4028);

var $7Jxgt = parcelRequire("7Jxgt");

var $lEdH9 = parcelRequire("lEdH9");

var $7u3rk = parcelRequire("7u3rk");

var $7xBz2 = parcelRequire("7xBz2");

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");

var $cb0MQ = parcelRequire("cb0MQ");
const $bd0971e9bc988992$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function $bd0971e9bc988992$export$2e2bcd8739ae039(ufoName, routeName = ufoName) {
    const activeInteraction = (0, $lAOer.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $cb0MQ.default).current = routeName || null;
    const rate = ufoName ? (0, $7u3rk.getInteractionRate)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $lEdH9.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        const newId = (0, $7Jxgt.v4)();
        (0, $32M8E.DefaultInteractionID).current = newId;
        (0, $lAOer.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $7xBz2.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $lAOer.addHoldByID)(newId, [], $bd0971e9bc988992$var$AWAITING_PAGELOAD_NAME, $bd0971e9bc988992$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $lAOer.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $lAOer.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $lAOer.removeHoldByID)(activeInteraction.id, $bd0971e9bc988992$var$AWAITING_PAGELOAD_NAME);
    }
}
function $bd0971e9bc988992$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
    const interaction = (0, $lAOer.getActiveInteraction)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        const rate = (0, $7u3rk.getInteractionRate)(ufoName, 'page_load');
        (0, $lAOer.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $lEdH9.default)(rate)) (0, $cb0MQ.default).current = ufoName;
        else (0, $lAOer.abort)(interaction.id, 'excluded_by_sampling');
    }
    (0, $lAOer.removeHoldByID)(interaction.id, $bd0971e9bc988992$var$AWAITING_PAGELOAD_NAME);
}

});

parcelRegister("k4NnA", function(module, exports) {

$parcel$export(module.exports, "reportBootstrapError", () => $6a69127f0604feb0$export$a5c16644a2d3c205);

var $kuiU5 = parcelRequire("kuiU5");

var $hh0bW = parcelRequire("hh0bW");

var $jpY8v = parcelRequire("jpY8v");

var $4Pf62 = parcelRequire("4Pf62");

var $jcw0u = parcelRequire("jcw0u");


var $8ApFP = parcelRequire("8ApFP");
const $6a69127f0604feb0$export$649804097de83b3b = [
    // https://jplat.jira.atlassian.cloud/browse/MAGMA-2440
    {
        browser: 'Chrome',
        browserVersion: '116.0.0',
        errorMessage: /Cannot read properties of undefined \(reading 'target'\)/
    }
];
const $6a69127f0604feb0$var$checkBrowserCondition = (error, filterCriteria)=>filterCriteria.browser != null ? (0, $jpY8v.getBrowser)().name === filterCriteria.browser : true;
const $6a69127f0604feb0$var$checkBrowserVersionCondition = (error, filterCriteria)=>filterCriteria.browserVersion != null ? (0, $jpY8v.getBrowser)().version === filterCriteria.browserVersion : true;
const $6a69127f0604feb0$var$checkErrorMessageCondition = (error, filterCriteria)=>filterCriteria.errorMessage != null ? error.message.match(filterCriteria.errorMessage) : true;
const $6a69127f0604feb0$export$a66ce4bea8340820 = (error, errorFilteringCriterias)=>{
    try {
        // condition checkers must return true if they don't apply, so an empty filterCriteria will match (and block) ALL errors
        const conditionCheckers = [
            $6a69127f0604feb0$var$checkBrowserCondition,
            $6a69127f0604feb0$var$checkBrowserVersionCondition,
            $6a69127f0604feb0$var$checkErrorMessageCondition
        ];
        // Should send analytics if no filtering conditions are met
        return !errorFilteringCriterias.some((filterCriteria)=>conditionCheckers.every((conditionChecker)=>conditionChecker(error, filterCriteria)));
    } catch (e) {
        // If any error occurs during filtering, experience analytics should still be sent
        return true;
    }
};
const $6a69127f0604feb0$export$a5c16644a2d3c205 = async (error)=>{
    const tenantContextData = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    // We probably already have analytics initialised but we could have failed earlier than it
    (0, $kuiU5.default)(tenantContextData);
    // Experience analytics should only be sent if it is not filtered
    if ($6a69127f0604feb0$export$a66ce4bea8340820(error, $6a69127f0604feb0$export$649804097de83b3b)) (0, $hh0bW.default)({
        analyticsSource: (0, $9ccbd88c704da1ef$export$c9e16a15d65437),
        experience: (0, $9ccbd88c704da1ef$export$b1534bc11f201efd),
        wasExperienceSuccesful: false,
        location: (0, $9ccbd88c704da1ef$export$7dfef0177e883b05),
        application: (0, $9ccbd88c704da1ef$export$aa6008fe0169b864),
        edition: (0, $9ccbd88c704da1ef$export$39418a21fbb51487),
        additionalAttributes: (0, $8ApFP.routeAnalyticsAttributes)
    });
    (0, $jcw0u.default)({
        meta: {
            packageName: 'jiraBootstrapSlaReporter',
            id: 'bootstrap-failure',
            teamName: 'magma'
        },
        error: error,
        attributes: (0, $8ApFP.routeAnalyticsAttributes)
    });
    throw error;
};

});
const $9ccbd88c704da1ef$export$c9e16a15d65437 = 'navigationNext';
const $9ccbd88c704da1ef$export$b1534bc11f201efd = 'jiraPageContainer';
const $9ccbd88c704da1ef$export$fa4bbc89fd1f1a7 = null;
const $9ccbd88c704da1ef$export$aa6008fe0169b864 = null;
const $9ccbd88c704da1ef$export$39418a21fbb51487 = null;
const $9ccbd88c704da1ef$export$7dfef0177e883b05 = 'entry.jira-spa';
const $9ccbd88c704da1ef$var$PAGE_CONTAINER_MARK = 'jira-spa/spa-shell/page-container';
const $9ccbd88c704da1ef$export$7114284ca03133ee = `_${$9ccbd88c704da1ef$var$PAGE_CONTAINER_MARK}.end`;
const $9ccbd88c704da1ef$export$21473105c510aacc = 'jira-spa/spa-shell/page-layout';
const $9ccbd88c704da1ef$export$898b6208220685b0 = 'jira-spa/spa-shell/global-containers';
const $9ccbd88c704da1ef$export$e2bc63118050de32 = `_${$9ccbd88c704da1ef$export$898b6208220685b0}.start`;
const $9ccbd88c704da1ef$export$59f83d43fe209319 = `_${$9ccbd88c704da1ef$export$898b6208220685b0}.end`;
const $9ccbd88c704da1ef$export$fb9876ab4228d985 = 'jira-spa/spa-shell/global-components';
const $9ccbd88c704da1ef$export$c20831be6f780cb5 = `_${$9ccbd88c704da1ef$export$fb9876ab4228d985}.start`;
const $9ccbd88c704da1ef$export$398df1bca49f9884 = `_${$9ccbd88c704da1ef$export$fb9876ab4228d985}.end`;
const $9ccbd88c704da1ef$export$7048c99f32c60b34 = 'jira-spa/spa-shell/global-containers/app-base';
const $9ccbd88c704da1ef$export$3c2d8af5c7577fe7 = `_${$9ccbd88c704da1ef$export$7048c99f32c60b34}.start`;
const $9ccbd88c704da1ef$export$aac77afee74c49d0 = `_${$9ccbd88c704da1ef$export$7048c99f32c60b34}.end`;
const $9ccbd88c704da1ef$export$4f341d86a3c214 = 'jira-spa/spa-shell/global-containers/router';
const $9ccbd88c704da1ef$export$16e7ead3a8b5c366 = `_${$9ccbd88c704da1ef$export$4f341d86a3c214}.start`;
const $9ccbd88c704da1ef$export$c389f0b50840d5ca = `_${$9ccbd88c704da1ef$export$4f341d86a3c214}.end`;

parcelRegister("8ApFP", function(module, exports) {

$parcel$export(module.exports, "routeAnalyticsAttributes", () => $a83c9e8eeb3d40c2$export$c71778b3a4356b04);

var $cfDZ3 = parcelRequire("cfDZ3");

var $hVf1M = parcelRequire("hVf1M");
const $a83c9e8eeb3d40c2$export$c71778b3a4356b04 = Object.defineProperties({}, {
    routeName: {
        enumerable: true,
        get: (0, $cfDZ3.getRouteName)
    },
    userLocation: {
        enumerable: true,
        get: (0, $cfDZ3.getUserLocation)
    },
    previousSubProduct: {
        enumerable: true,
        get: (0, $cfDZ3.getPreviousSubProduct)
    },
    isProjectAdmin: {
        enumerable: true,
        get: (0, $hVf1M.getIsProjectAdmin)
    }
});

});


parcelRegister("2YzDH", function(module, exports) {
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $jOqMN = parcelRequire("jOqMN");

if (!$parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("atKhx"));
    const isDevMode = false;
    (0, $jOqMN.default).devtools = isDevMode && (()=>({
            serialize: {
                // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
                replacer: (key, value)=>value instanceof HTMLElement ? {
                        data: {
                            tagName: value.tagName,
                            className: value.className,
                            id: value.id,
                            __SANITIZED__: true
                        },
                        __serializedType__: 'HTMLElement'
                    } : value
            }
        }));
    (0, $jOqMN.default).batchUpdates = !false;
    Object.freeze((0, $jOqMN.default));
    $parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_ = true;
}

});
parcelRegister("atKhx", function(module, exports) {
const $7a108374e96e2c82$var$style = document.createElement('style');
$7a108374e96e2c82$var$style.textContent = `html,body,p,div,h1,h2,h3,h4,h5,h6,ul,ol,dl,img,pre,form,fieldset{margin:0;padding:0}img,fieldset{border:0}body,html{width:100%;height:100%}body{background-color:var(--ds-surface,#fff);color:var(--ds-text,#172b4d);font:var(--ds-font-body,normal 400 14px/1.42857 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);-ms-overflow-style:-ms-autohiding-scrollbar;text-decoration-skip-ink:auto}p,ul,ol,dl,h1,h2,h3,h4,h5,h6,blockquote,pre,form,table{margin:var(--ds-space-150,12px)0 0 0}a{color:var(--ds-link,#0052cc);text-decoration:none}a:hover{color:var(--ds-link,#0065ff);text-decoration:underline}a:active{color:var(--ds-link-pressed,#0747a6)}a:focus-visible{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#2684ff);outline-offset:var(--ds-space-025,2px)}@supports not selector(*:focus-visible){a:focus{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#4c9aff);outline-offset:var(--ds-space-025,2px)}}h1{font:var(--ds-font-heading-xlarge,600 2.07143em/1.10345 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-500)}h2{font:var(--ds-font-heading-large,500 1.71429em/1.16667 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-500)}h3{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:28px}h4{font:var(--ds-font-heading-small,600 1.14286em/1.25 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-300)}h5{font:var(--ds-font-heading-xsmall,600 1em/1.14286 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-200)}h6{font:var(--ds-font-heading-xxsmall,600 .857143em/1.33333 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-250);text-transform:uppercase}ul,ol,dl{padding-left:var(--ds-space-500,40px)}dd,dd+dt,li+li,ul ul:not(:first-child),ul style:first-child~*+ul,ol ul:not(:first-child),ol style:first-child~*+ul,ul ol:not(:first-child),ul style:first-child~*+ol,ol ol:not(:first-child),ol style:first-child~*+ol{margin-top:var(--ds-space-050,4px)}p:first-child,style:first-child+p,ul:first-child,style:first-child+ul,ol:first-child,style:first-child+ol,dl:first-child,style:first-child+dl,h1:first-child,style:first-child+h1,h2:first-child,style:first-child+h2,h3:first-child,style:first-child+h3,h4:first-child,style:first-child+h4,h5:first-child,style:first-child+h5,h6:first-child,style:first-child+h6,blockquote:first-child,style:first-child+blockquote,pre:first-child,style:first-child+pre,form:first-child,style:first-child+form,table:first-child,style:first-child+table{margin-top:0}blockquote,q{color:inherit}blockquote{padding-left:var(--ds-space-500,40px);border:none}[dir=rtl] blockquote{padding-left:0;padding-right:var(--ds-space-500,40px)}blockquote:before,q:before{content:"\u{201C}"}blockquote:after,q:after{content:"\u{201D}"}blockquote:before{float:left;text-align:right;width:1em;margin-left:-1em}[dir=rtl] blockquote:before{float:right;text-align:left;margin-right:-1em}blockquote>:last-child{display:inline-block}small{font:var(--ds-font-body-small,normal 400 11px/16px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,"Helvetica Neue",sans-serif)}code,kbd{font-family:var(--ds-font-family-code,ui-monospace,Menlo,"Segoe UI Mono","Ubuntu Mono",monospace)}var,address,dfn,cite{font-style:italic}abbr{border-bottom:1px var(--ds-border,#ccc)dotted;cursor:help}@supports (color-scheme:dark) and (color-scheme:light){[data-color-mode=light]{color-scheme:light}[data-color-mode=dark]{color-scheme:dark}}table{border-collapse:collapse;width:100%}thead,tbody,tfoot{border-bottom:2px solid var(--ds-border,#dfe1e6)}td,th{padding:var(--ds-space-050,4px)var(--ds-space-100,8px);text-align:left;border:none}th{vertical-align:top}td:first-child,style:first-child+td,th:first-child,style:first-child+th{padding-left:0}td:last-child,th:last-child{padding-right:0}caption{font:var(--ds-font-heading-medium,500 1.42857em/1.2 ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,"Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px;margin-bottom:var(--ds-space-100,8px);text-align:left}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}@-moz-document url-prefix(){img{font-size:0}img:-moz-broken{font-size:inherit}}button{font-family:inherit}.assistive{clip:rect(1px,1px,1px,1px)!important;white-space:nowrap!important;border:0!important;width:1px!important;height:1px!important;padding:0!important;position:absolute!important;overflow:hidden!important}`;
document.querySelector('head').appendChild($7a108374e96e2c82$var$style);

});


parcelRegister("7bkFJ", function(module, exports) {

$parcel$export(module.exports, "initPlatformFeatureFlags", () => $fef4d3d4b4c51b47$export$2d291317456ada16);

var $fHpHg = parcelRequire("fHpHg");

var $4R6GH = parcelRequire("4R6GH");

var $co1wz = parcelRequire("co1wz");
const $fef4d3d4b4c51b47$export$2d291317456ada16 = ([isOverride, resolver])=>{
    (0, $fHpHg.setBooleanFeatureFlagResolver)((flagKey)=>// disable existence check as platform feature >flags< might not be gates
        (0, $4R6GH.withoutFeatureExistenceCheck)(()=>isOverride(flagKey) ? resolver(flagKey) : (0, $4R6GH.fg)(flagKey) || (0, $co1wz.ff)(flagKey)));
};

});

parcelRegister("hL7JE", function(module, exports) {

$parcel$export(module.exports, "NonCritical", () => $c20017bf22691933$export$20fd89b1bf707b1a);
$parcel$export(module.exports, "default", () => $c20017bf22691933$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $6yXtV = parcelRequire("6yXtV");
const $c20017bf22691933$export$83d969795398ec56 = ({ children: children, timerThreshold: timerThreshold })=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $5uXOq.useState)(true);
    const [hasThresholdTimerExpired, setHasThresholdTimerExpired] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (timerThreshold != null) setTimeout(()=>{
            setHasThresholdTimerExpired(true);
        }, timerThreshold);
    }, [
        timerThreshold
    ]);
    if (!isFirstRun || isReady || hasThresholdTimerExpired) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    }
    return null;
};
const $c20017bf22691933$export$5b2f4b62d18632 = ({ id: id = 'non-critical-with-timer', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c20017bf22691933$export$83d969795398ec56, props));
/**
 * Delays rendering its children until the page is deemed ready, optimizing for a smoother initial load. Suitable for content that is not immediately necessary.
 */ const $c20017bf22691933$var$NonCriticalComponent = (props)=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $5uXOq.useState)(true);
    if (!isFirstRun || isReady) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    }
    return null;
};
const $c20017bf22691933$export$20fd89b1bf707b1a = ({ id: id = 'non-critical', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c20017bf22691933$var$NonCriticalComponent, props));
var $c20017bf22691933$export$2e2bcd8739ae039 = $c20017bf22691933$var$NonCriticalComponent;

});
parcelRegister("6yXtV", function(module, exports) {

$parcel$export(module.exports, "useSpaStatePageReady", () => $44de65c7edb80809$export$ea2491906b753456);
$parcel$export(module.exports, "SpaStatePageReady", () => $44de65c7edb80809$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $44de65c7edb80809$export$41e70078eeddaddc);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3sQ5x = parcelRequire("3sQ5x");

var $4oDnX = parcelRequire("4oDnX");

var $7w9eZ = parcelRequire("7w9eZ");
const $44de65c7edb80809$export$e6897aa59ee7aee5 = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    return {
        isReady: appIds.length ? appIds.every((id)=>apps[id].endTime || apps[id].timeoutTime) : false
    };
};
const $44de65c7edb80809$export$ea2491906b753456 = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: $44de65c7edb80809$export$e6897aa59ee7aee5
});
const $44de65c7edb80809$export$c34439f945fccbdf = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: setAppReady
        }));
const $44de65c7edb80809$export$41e70078eeddaddc = ({ comparer: comparer })=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oDnX.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
            op: setAppReady,
            args: comparer
        }));

});


parcelRegister("kZBXc", function(module, exports) {

$parcel$export(module.exports, "Spa", () => $454974e68bcf078d$export$6d4069f4b64f7492);

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");


var $2SVPM = parcelRequire("2SVPM");

var $erCTW = parcelRequire("erCTW");

var $erjJQ = parcelRequire("erjJQ");
const $454974e68bcf078d$export$6d4069f4b64f7492 = ({ baseUrl: baseUrl, locale: locale, messages: messages, isPrewarming: isPrewarming = false, Router: Router, routes: routes, routerLinkComponent: routerLinkComponent, initRoute: initRoute })=>{
    const pageContainerPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$21473105c510aacc), (0, $9ccbd88c704da1ef$export$59f83d43fe209319), (0, $9ccbd88c704da1ef$export$7114284ca03133ee), true, true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erCTW.PageContainer), {
        baseUrl: baseUrl,
        id: false ? 'jira.entry.ssr' : 'spa',
        locale: locale,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$7114284ca03133ee),
        onSet: pageContainerPerformanceTiming
    }), isPrewarming !== true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erjJQ.Content), {
        initRoute: initRoute,
        routes: routes
    }));
};

});
parcelRegister("gAeCk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5368db3a32c0eb20$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $x9xyg = parcelRequire("x9xyg");
const $5368db3a32c0eb20$var$PerformanceMark = ({ metricKey: metricKey, onSet: onSet })=>{
    const renderRef = (0, $5uXOq.useRef)(false);
    if (!renderRef.current) {
        renderRef.current = true;
        (0, $x9xyg.setMark)(metricKey);
        onSet && onSet();
    }
    return null;
};
var $5368db3a32c0eb20$export$2e2bcd8739ae039 = $5368db3a32c0eb20$var$PerformanceMark;

});

parcelRegister("erCTW", function(module, exports) {

$parcel$export(module.exports, "PageContainer", () => $a81b2dc7c8e9cabb$export$5f86df0ee0a255b5);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");

var $gAeCk = parcelRequire("gAeCk");

var $7CMCs = parcelRequire("7CMCs");

var $7XYc4 = parcelRequire("7XYc4");

var $14V0U = parcelRequire("14V0U");

var $g7crU = parcelRequire("g7crU");

var $jHXUj = parcelRequire("jHXUj");

var $aKiiD = parcelRequire("aKiiD");

var $cPiXk = parcelRequire("cPiXk");

var $3HwlS = parcelRequire("3HwlS");

var $iqLcb = parcelRequire("iqLcb");


var $16YKp = parcelRequire("16YKp");

var $cOwuh = parcelRequire("cOwuh");

var $iXVV6 = parcelRequire("iXVV6");

var $3Uek9 = parcelRequire("3Uek9");

var $ozeZW = parcelRequire("ozeZW");

var $2SVPM = parcelRequire("2SVPM");

var $4R6GH = parcelRequire("4R6GH");

var $lODMY = parcelRequire("lODMY");

var $17bH5 = parcelRequire("17bH5");

var $kQm4v = parcelRequire("kQm4v");

var $10qwl = parcelRequire("10qwl");

var $gmCnE = parcelRequire("gmCnE");

var $kc9FZ = parcelRequire("kc9FZ");

var $6DLIs = parcelRequire("6DLIs");

var $62C9r = parcelRequire("62C9r");

var $4s15Z = parcelRequire("4s15Z");

var $eF0qp = parcelRequire("eF0qp");

var $gxCm0 = parcelRequire("gxCm0");

var $lvpKt = parcelRequire("lvpKt");

var $8Ceqd = parcelRequire("8Ceqd");

var $jmzCL = parcelRequire("jmzCL");
const $a81b2dc7c8e9cabb$var$mainWrapperStyles = {
    root: "_4t3i1osq _1e0c1txw _2lx21bp4 _9beo1bgi",
    themed: "_11q7mmei _11q31r52"
};
/**
 * These test IDs are used in pollinator tests. Do not change lightly.
 */ const $a81b2dc7c8e9cabb$var$ROOT_TEST_ID = 'page-layout.root';
const $a81b2dc7c8e9cabb$var$MAIN_TEST_ID = 'page-layout.main';
/* IMPORTANT:
 * When making any changes to the Nav3 component, please ensure that you also make the same changes to the
 * Nav4 component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $a81b2dc7c8e9cabb$var$DefaultLayoutNav4 = ({ children: children })=>{
    const [isChromeless] = (0, $14V0U.useIsChromeless)();
    const [isFullscreen] = (0, $g7crU.useIsFullscreen)();
    const { hasTheming: hasTheming } = (0, $3Uek9.useProjectTheme)();
    const { isEnabled: isJsmPackagingUpdatesEnabled } = (0, $16YKp.useBannerJsmPackagingUpdates)();
    const currentRoute = $a81b2dc7c8e9cabb$var$useRouterRoute();
    const isIssueOrSystemAdminPage = (0, $17bH5.isSystemNavPath)(currentRoute.path) || (0, $kQm4v.isIssuesNavPath)(currentRoute.path);
    const mainWrapper = (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.Main), {
            isFixed: true,
            testId: $a81b2dc7c8e9cabb$var$MAIN_TEST_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                $a81b2dc7c8e9cabb$var$mainWrapperStyles.root,
                hasTheming && $a81b2dc7c8e9cabb$var$mainWrapperStyles.themed
            ])
        }, isJsmPackagingUpdatesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOwuh.BannerJsmPackagingUpdateAsync), null), isIssueOrSystemAdminPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10qwl.JiraTopBannerPlacement), null), content));
    const showBanner = !isChromeless && !isFullscreen;
    const showTopNav = !isChromeless && !isFullscreen;
    const showSidebar = !isChromeless && !isFullscreen;
    const showHorizontalNav = !isChromeless;
    const showRightSidebar = !isChromeless && !isFullscreen;
    const showLayoutRemoteStateUpdater = !isChromeless && !isFullscreen;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.PageLayout), {
        skipLinksLabel: "",
        testId: $a81b2dc7c8e9cabb$var$ROOT_TEST_ID
    }, showBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "banner",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gmCnE.Banner), null)), showTopNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "top-nav",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gxCm0.TopNav), null)), showSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "sidebar",
        packageName: "jiraPageContainerV2",
        fallback: (0, $4R6GH.fg)('blu-5989-show-flag-on-sidebar-error-boundary') ? 'flag' : 'unmount'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eF0qp.Sidebar), null)), mainWrapper(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showHorizontalNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $62C9r.HorizontalNav), null), children)), showRightSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "right-sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4s15Z.RightSidebar), null)), showLayoutRemoteStateUpdater && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraPageContainerV2",
        id: "layout-remote-state-updater",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHXUj.LayoutRemoteStateUpdater), null))));
};
const $a81b2dc7c8e9cabb$var$DefaultLayoutNav3 = ({ children: children })=>{
    const HorizontalNavComponent = (0, $cPiXk.useHorizontalNavComponent)();
    const { isEnabled: isJsmPackagingUpdatesEnabled } = (0, $16YKp.useBannerJsmPackagingUpdates)();
    const currentRoute = $a81b2dc7c8e9cabb$var$useRouterRoute();
    const isIssueOrSystemAdminPage = (0, $17bH5.isSystemNavPath)(currentRoute.path) || (0, $kQm4v.isIssuesNavPath)(currentRoute.path);
    let contentChildren = isJsmPackagingUpdatesEnabled || isIssueOrSystemAdminPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, isJsmPackagingUpdatesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOwuh.BannerJsmPackagingUpdateAsync), null), isIssueOrSystemAdminPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10qwl.JiraTopBannerPlacement), null), children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    if (HorizontalNavComponent != null) contentChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $62C9r.HorizontalNavWrapper), {
        navComponent: HorizontalNavComponent
    }, isJsmPackagingUpdatesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOwuh.BannerJsmPackagingUpdateAsync), null), isIssueOrSystemAdminPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10qwl.JiraTopBannerPlacement), null), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lvpKt.FullHeight), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.PageLayout), {
        skipLinksLabel: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "banner",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gmCnE.Banner), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "top-nav",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gxCm0.TopNav), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.LeftPanel), {
        width: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.Content), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "sidebar",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eF0qp.Sidebar), null)), contentChildren, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "right-sidebar",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4s15Z.RightSidebar), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "page-container",
        id: "layout-remote-state-updater",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHXUj.LayoutRemoteStateUpdater), null))));
};
const $a81b2dc7c8e9cabb$var$useRouterRoute = (0, $lODMY.createRouterSelector)((state)=>state.route);
const $a81b2dc7c8e9cabb$var$LayoutNav4 = (props)=>{
    const { LayoutOverrideComponent: LayoutOverrideComponent } = $a81b2dc7c8e9cabb$var$useRouterRoute();
    if (LayoutOverrideComponent !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LayoutOverrideComponent, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a81b2dc7c8e9cabb$var$DefaultLayoutNav4, props);
};
const $a81b2dc7c8e9cabb$var$LayoutNav3 = (props)=>{
    const { LayoutOverrideComponent: LayoutOverrideComponent } = $a81b2dc7c8e9cabb$var$useRouterRoute();
    if (LayoutOverrideComponent !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LayoutOverrideComponent, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a81b2dc7c8e9cabb$var$DefaultLayoutNav3, props);
};
const $a81b2dc7c8e9cabb$var$ConfigureThemeSetter = ()=>(0, $4R6GH.fg)('jira_theming_relay_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Ceqd.GlobalThemeSetter), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Ceqd.ThemeSetter), null);
const $a81b2dc7c8e9cabb$var$PageContainerNav4 = (props)=>{
    const { id: id, locale: locale, baseUrl: baseUrl, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent } = props;
    const pageContainerPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$898b6208220685b0), (0, $9ccbd88c704da1ef$export$e2bc63118050de32), (0, $9ccbd88c704da1ef$export$59f83d43fe209319), true, false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$e2bc63118050de32)
    }), (0, $4R6GH.fg)('jfp_magma_jira-theme-setter-correction') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a81b2dc7c8e9cabb$var$ConfigureThemeSetter, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6DLIs.GlobalContainers), {
        id: id,
        locale: locale,
        baseUrl: baseUrl,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, (0, $4R6GH.fg)('jfp_magma_jira-theme-setter-correction') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a81b2dc7c8e9cabb$var$ConfigureThemeSetter, null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$59f83d43fe209319),
        onSet: pageContainerPerformanceTiming
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "navigationNext"
    }, (0, $4R6GH.fg)('jira_theming_relay_migration') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jmzCL.ProjectThemeSetter), null), (0, $4R6GH.fg)('assets_as_an_app_kill_switch') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a81b2dc7c8e9cabb$var$DefaultLayoutNav4, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a81b2dc7c8e9cabb$var$LayoutNav4, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kc9FZ.GlobalComponents), {
        sharedGlobalComponents: (0, $ozeZW.sharedLayout).globalComponents
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aKiiD.GlobalBottomRightCornerContainer), null))));
};
/**
 * Serves as a comprehensive layout manager, orchestrating the assembly of global containers,
 * navigation components, and performance metrics into a cohesive page structure. It enhances user
 * interface by conditionally incorporating additional UI elements and ensures a uniform
 * appearance and behavior across pages through global styling. Moreover, it facilitates
 * performance optimization and analytics integration for improved user experience and
 * insights.
 */ const $a81b2dc7c8e9cabb$var$PageContainerNav3 = (props)=>{
    const { id: id, locale: locale, baseUrl: baseUrl, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent } = props;
    const pageContainerPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$898b6208220685b0), (0, $9ccbd88c704da1ef$export$e2bc63118050de32), (0, $9ccbd88c704da1ef$export$59f83d43fe209319), true, false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$e2bc63118050de32)
    }), (0, $4R6GH.fg)('jfp_magma_jira-theme-setter-correction') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a81b2dc7c8e9cabb$var$ConfigureThemeSetter, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6DLIs.GlobalContainers), {
        id: id,
        locale: locale,
        baseUrl: baseUrl,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, (0, $4R6GH.fg)('jfp_magma_jira-theme-setter-correction') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a81b2dc7c8e9cabb$var$ConfigureThemeSetter, null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$59f83d43fe209319),
        onSet: pageContainerPerformanceTiming
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "navigationNext"
    }, (0, $4R6GH.fg)('jira_theming_relay_migration') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jmzCL.ProjectThemeSetter), null), (0, $4R6GH.fg)('assets_as_an_app_kill_switch') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a81b2dc7c8e9cabb$var$DefaultLayoutNav3, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a81b2dc7c8e9cabb$var$LayoutNav3, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kc9FZ.GlobalComponents), {
        sharedGlobalComponents: (0, $ozeZW.sharedLayout).globalComponents
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aKiiD.GlobalBottomRightCornerContainer), null))));
};
const $a81b2dc7c8e9cabb$export$5f86df0ee0a255b5 = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $a81b2dc7c8e9cabb$var$PageContainerNav4, $a81b2dc7c8e9cabb$var$PageContainerNav3);

});
parcelRegister("14V0U", function(module, exports) {

$parcel$export(module.exports, "useIsChromeless", () => $96950c90e73fdad9$export$c88b74884f5222ba);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $96950c90e73fdad9$export$c88b74884f5222ba = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.isChromeless
});

});

parcelRegister("g7crU", function(module, exports) {

$parcel$export(module.exports, "useIsFullscreen", () => $aa937e51388f56fd$export$d397eccea5f37b0a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $aa937e51388f56fd$export$d397eccea5f37b0a = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.isFullscreen
});

});

parcelRegister("jHXUj", function(module, exports) {

$parcel$export(module.exports, "LayoutRemoteStateUpdater", () => $89937a782c6cb988$export$b9f3a70460995c32);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $cSD7y = parcelRequire("cSD7y");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $7XYc4 = parcelRequire("7XYc4");

var $3HwlS = parcelRequire("3HwlS");

var $iqLcb = parcelRequire("iqLcb");


var $c34Wf = parcelRequire("c34Wf");

var $90yGq = parcelRequire("90yGq");

var $2YP9W = parcelRequire("2YP9W");

var $5e5zm = parcelRequire("5e5zm");

var $gPQRI = parcelRequire("gPQRI");

var $hsmeR = parcelRequire("hsmeR");

var $2TwSO = parcelRequire("2TwSO");
/**
 * Synchronizes the layout's local state with the remote server to ensure consistency across sessions.
 * It monitors changes in the layout, such as sidebar adjustments, and updates the server accordingly.
 * Critical errors encountered during the update process are captured and reported to facilitate
 * troubleshooting and continuous improvement. This component plays a pivotal role in maintaining
 * a seamless user experience by ensuring that layout preferences are consistently reflected.
 */ const $89937a782c6cb988$var$LayoutRemoteStateUpdaterOld = ()=>{
    // left-sidebar
    const { leftSidebarState: leftSidebarState } = (0, $iqLcb.usePageLayoutResize)();
    const { isFlyoutOpen: isFlyoutOpen, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
    const resolvedLeftSidebarWidth = Math.max(leftSidebarWidth, (0, $5e5zm.DEFAULT_LEFT_SIDEBAR_WIDTH));
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $5e5zm.useLayoutStoreActions)();
    const isCollapsed = leftSidebarState.isLeftSidebarCollapsed;
    // right-sidebar
    const rightSidebarState = (0, $hsmeR.useRightSidebarState)();
    const accountId = (0, $90yGq.useAccountId)();
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $c34Wf.navigationUiStateResource));
    const isLayoutStateReady = leftSidebarWidth !== 0 && leftSidebarState.lastLeftSidebarWidth !== 0;
    (0, $5uXOq.useEffect)(()=>{
        if (!isLayoutStateReady) return;
        if (error) return;
        setLeftSidebarState({
            width: resolvedLeftSidebarWidth,
            isCollapsed: isCollapsed,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            isFlyoutOpen: isFlyoutOpen,
            isVisible: true
        });
    }, [
        error,
        isCollapsed,
        isFlyoutOpen,
        isLayoutStateReady,
        resolvedLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const updateData = (0, $5uXOq.useCallback)(async ()=>{
        if (loading) return;
        if (error) return;
        if (!isLayoutStateReady) return;
        const remoteData = {
            ...data,
            leftSidebar: {
                width: resolvedLeftSidebarWidth,
                isCollapsed: isLeftSidebarCollapsed
            },
            rightSidebar: rightSidebarState
        };
        if (accountId) try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(remoteData));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $jcw0u.default)({
                error: e,
                meta: {
                    id: 'updateServerLayoutState',
                    packageName: 'jiraLayoutController',
                    teamName: 'magma'
                }
            });
        }
    }, [
        accountId,
        data,
        error,
        isLayoutStateReady,
        isLeftSidebarCollapsed,
        loading,
        resolvedLeftSidebarWidth,
        rightSidebarState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        updateData();
    }, [
        isLeftSidebarCollapsed,
        resolvedLeftSidebarWidth,
        updateData
    ]);
    return null;
};
const $89937a782c6cb988$var$LayoutRemoteStateUpdaterOldImprovedStateManagement = ()=>{
    // This prevents eccessive state updates on page loads
    const [initialLoad, setInitialLoad] = (0, $5uXOq.useState)(true);
    const [localLeftSidebarWidthState, setLocalLeftSidebarWidthState] = (0, $5uXOq.useState)();
    const [localLeftSidebarCollapsedState, setLocalLeftSidebarCollapsedState] = (0, $5uXOq.useState)();
    const [localRightSidebarState, setLocalRightSidebarState] = (0, $5uXOq.useState)();
    // left-sidebar
    const { leftSidebarState: leftSidebarState } = (0, $iqLcb.usePageLayoutResize)();
    const { isFlyoutOpen: isFlyoutOpen, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
    const resolvedLeftSidebarWidth = Math.max(leftSidebarWidth, (0, $5e5zm.DEFAULT_LEFT_SIDEBAR_WIDTH));
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $5e5zm.useLayoutStoreActions)();
    const isCollapsed = leftSidebarState.isLeftSidebarCollapsed;
    // right-sidebar
    const rightSidebarState = (0, $hsmeR.useRightSidebarState)();
    const accountId = (0, $90yGq.useAccountId)();
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $c34Wf.navigationUiStateResource));
    const isLayoutStateReady = leftSidebarWidth !== 0 && leftSidebarState.lastLeftSidebarWidth !== 0;
    // compares local vs external state coming via chain of callbacks
    // to determine if we really need to send an update of layout state
    const sideBarChanged = (0, $5uXOq.useCallback)((externalLeftSidebarWidth, externalIsLeftSidebarCollapsed, externalRightSidebarState)=>{
        let changeDetected = false;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(externalLeftSidebarWidth, localLeftSidebarWidthState)) {
            setLocalLeftSidebarWidthState(externalLeftSidebarWidth);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(externalIsLeftSidebarCollapsed, localLeftSidebarCollapsedState)) {
            setLocalLeftSidebarCollapsedState(externalIsLeftSidebarCollapsed);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(externalRightSidebarState, localRightSidebarState)) {
            setLocalRightSidebarState(externalRightSidebarState);
            changeDetected = true;
        }
        return changeDetected;
    }, [
        localLeftSidebarCollapsedState,
        localLeftSidebarWidthState,
        localRightSidebarState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isLayoutStateReady) return;
        if (error) return;
        setLeftSidebarState({
            width: resolvedLeftSidebarWidth,
            isCollapsed: isCollapsed,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            isFlyoutOpen: isFlyoutOpen,
            isVisible: true
        });
    }, [
        error,
        isCollapsed,
        isFlyoutOpen,
        isLayoutStateReady,
        resolvedLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const updateData = (0, $5uXOq.useCallback)(async ()=>{
        if (loading) return;
        if (error) return;
        if (!isLayoutStateReady) return;
        if (!sideBarChanged(resolvedLeftSidebarWidth, isLeftSidebarCollapsed, rightSidebarState)) return;
        const remoteData = {
            ...data,
            leftSidebar: {
                width: resolvedLeftSidebarWidth,
                isCollapsed: isLeftSidebarCollapsed
            },
            rightSidebar: rightSidebarState
        };
        if (accountId) try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(remoteData));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $jcw0u.default)({
                error: e,
                meta: {
                    id: 'updateServerLayoutState',
                    packageName: 'jiraLayoutController',
                    teamName: 'magma'
                }
            });
        }
    }, [
        accountId,
        data,
        error,
        isLayoutStateReady,
        isLeftSidebarCollapsed,
        loading,
        resolvedLeftSidebarWidth,
        rightSidebarState,
        sideBarChanged
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (initialLoad) {
            setInitialLoad(false);
            setLocalLeftSidebarWidthState(resolvedLeftSidebarWidth);
            setLocalLeftSidebarCollapsedState(isLeftSidebarCollapsed);
            setLocalRightSidebarState(rightSidebarState);
        } else updateData();
    }, [
        isLeftSidebarCollapsed,
        resolvedLeftSidebarWidth,
        updateData,
        rightSidebarState,
        initialLoad
    ]);
    return null;
};
/**
 * The old layout remote state updater used a hook to subscribe to the DS left sidebar state,
 * and would then update the `react-sweet-state` store as well as the remote state.
 *
 * Now the side nav integration is wired to update the `react-sweet-state` store directly,
 * and this will just update the remote state. This is because the new side nav does not expose its
 * state through a hook. We can change this in the future if necessary.
 *
 * In the future, we could also consider moving the remote update logic into the `react-sweet-state`
 * action which updates the left sidebar, removing the need for a subscriber like this.
 */ const $89937a782c6cb988$var$LayoutRemoteStateUpdaterNew = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    const leftSidebar = (0, $gPQRI.useLeftSidebarState)();
    const rightSidebar = (0, $hsmeR.useRightSidebarState)();
    const isLeftSidebarCollapsed = leftSidebar.isCollapsed;
    const leftSidebarWidth = leftSidebar.width;
    (0, $5uXOq.useEffect)(()=>{
        if (!accountId) return;
        (0, $2TwSO.setRemoteLayoutState)({
            accountId: accountId,
            state: {
                rightSidebar: rightSidebar,
                leftSidebar: {
                    isCollapsed: isLeftSidebarCollapsed,
                    width: leftSidebarWidth
                }
            }
        });
    }, [
        accountId,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        rightSidebar
    ]);
    return null;
};
const $89937a782c6cb988$var$LayoutRemoteStateUpdaterNewImprovedStateManagement = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    const leftSidebar = (0, $gPQRI.useLeftSidebarState)();
    const rightSidebar = (0, $hsmeR.useRightSidebarState)();
    const isLeftSidebarCollapsed = leftSidebar.isCollapsed;
    const leftSidebarWidth = leftSidebar.width;
    // This prevents eccessive state updates on page loads
    const [initialLoad, setInitialLoad] = (0, $5uXOq.useState)(true);
    const [localLeftSidebarWidthState, setLocalLeftSidebarWidthState] = (0, $5uXOq.useState)();
    const [localLeftSidebarCollapsedState, setLocalLeftSidebarCollapsedState] = (0, $5uXOq.useState)();
    const [localRightSidebarState, setLocalRightSidebarState] = (0, $5uXOq.useState)();
    // compares local vs external state coming via chain of callbacks
    // to determine if we really need to send an update of layout state
    const sideBarChanged = (0, $5uXOq.useCallback)((externalLeftSidebarWidth, externalIsLeftSidebarCollapsed, externalRightSidebarState)=>{
        let changeDetected = false;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(externalLeftSidebarWidth, localLeftSidebarWidthState)) {
            setLocalLeftSidebarWidthState(externalLeftSidebarWidth);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(externalIsLeftSidebarCollapsed, localLeftSidebarCollapsedState)) {
            setLocalLeftSidebarCollapsedState(externalIsLeftSidebarCollapsed);
            changeDetected = true;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(externalRightSidebarState, localRightSidebarState)) {
            setLocalRightSidebarState(externalRightSidebarState);
            changeDetected = true;
        }
        return changeDetected;
    }, [
        localLeftSidebarCollapsedState,
        localLeftSidebarWidthState,
        localRightSidebarState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!accountId) return;
        if (initialLoad) {
            setInitialLoad(false);
            setLocalLeftSidebarWidthState(leftSidebarWidth);
            setLocalLeftSidebarCollapsedState(isLeftSidebarCollapsed);
            setLocalRightSidebarState(rightSidebar);
            return;
        }
        if (!sideBarChanged(leftSidebarWidth, isLeftSidebarCollapsed, rightSidebar)) return;
        (0, $2TwSO.setRemoteLayoutState)({
            accountId: accountId,
            state: {
                rightSidebar: rightSidebar,
                leftSidebar: {
                    isCollapsed: isLeftSidebarCollapsed,
                    width: leftSidebarWidth
                }
            }
        });
    }, [
        accountId,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        rightSidebar,
        initialLoad,
        sideBarChanged
    ]);
    return null;
};
const $89937a782c6cb988$var$LayoutRemoteStateUpdaterNewFeatureGated = (0, $cSD7y.componentWithFG)('cher-1158-remove-excessive-sidebar-layout-updates', $89937a782c6cb988$var$LayoutRemoteStateUpdaterNewImprovedStateManagement, $89937a782c6cb988$var$LayoutRemoteStateUpdaterNew);
const $89937a782c6cb988$var$LayoutRemoteStateUpdaterOldFeatureGated = (0, $cSD7y.componentWithFG)('cher-1158-remove-excessive-sidebar-layout-updates', $89937a782c6cb988$var$LayoutRemoteStateUpdaterOldImprovedStateManagement, $89937a782c6cb988$var$LayoutRemoteStateUpdaterOld);
const $89937a782c6cb988$export$b9f3a70460995c32 = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $89937a782c6cb988$var$LayoutRemoteStateUpdaterNewFeatureGated, $89937a782c6cb988$var$LayoutRemoteStateUpdaterOldFeatureGated);

});
parcelRegister("2TwSO", function(module, exports) {

$parcel$export(module.exports, "setRemoteLayoutState", () => $9d3e8b8a199ea341$export$ad53b565e6cd4261);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

async function $9d3e8b8a199ea341$export$ad53b565e6cd4261({ accountId: accountId, state: state }) {
    try {
        await (0, $89SaW.setUserProperties)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(state));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            error: e,
            meta: {
                id: 'updateServerLayoutState',
                packageName: 'jiraLayoutController',
                teamName: 'jfp-team'
            }
        });
    }
}

});


parcelRegister("aKiiD", function(module, exports) {

$parcel$export(module.exports, "GlobalBottomRightCornerContainer", () => $1ca472b9239dbdd7$export$715c8d5890c054bb);
$parcel$export(module.exports, "GlobalBottomRightCornerContainerProvider", () => $1ca472b9239dbdd7$export$1e86e3484191597c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $b71gk = parcelRequire("b71gk");

var $l8ruj = parcelRequire("l8ruj");

var $hvrWv = parcelRequire("hvrWv");

var $hsmeR = parcelRequire("hsmeR");

var $5e5zm = parcelRequire("5e5zm");
function $1ca472b9239dbdd7$export$e112b78171de7a6({ bottomOffset: bottomOffset, rightOffset: rightOffset }) {
    const [{ width: width }] = (0, $5e5zm.useDetailPanelWidth)();
    const rightSidebar = (0, $hsmeR.useActiveRightSidebarState)();
    const { registerBottomRightCornerContainer: registerBottomRightCornerContainer } = (0, $hvrWv.useBottomRightCornerActions)();
    const isSidebarOpen = rightSidebar && !rightSidebar.isCollapsed && !rightSidebar.isMinimised;
    const rightSidebarWidth = isSidebarOpen ? rightSidebar.width : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ca472b9239dbdd7$var$StyledContainer, {
        ref: registerBottomRightCornerContainer,
        "data-testid": "layout-controller.ui.bottom-right-corner.container.styled-container",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            right: `calc(${width + rightOffset + rightSidebarWidth}px + ${"var(--ds-space-300, 24px)"})`,
            bottom: `calc(${"var(--ds-space-300, 24px)"} + ${bottomOffset}px)`
        }
    });
}
const $1ca472b9239dbdd7$export$715c8d5890c054bb = ({ bottomOffset: bottomOffset = 0, rightOffset: rightOffset = 0 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "bottom-right-corner-container",
        packageName: "jira-bottom-right-corner-controller"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ca472b9239dbdd7$export$e112b78171de7a6, {
        bottomOffset: bottomOffset,
        rightOffset: rightOffset
    }));
const $1ca472b9239dbdd7$export$1e86e3484191597c = ({ children: children })=>{
    const container = (0, $hvrWv.useBottomRightCornerContainer)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "global-bottom-right-corner"
    }, container && children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ca472b9239dbdd7$export$715c8d5890c054bb, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ca472b9239dbdd7$var$StyledContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reoewfl _18m9ewfl _kqsw1n9t _1e0c1txw _1pbyfjpv _4cvresu3 _lcxvglyw",
            __cmplp.className
        ])
    });
});
$1ca472b9239dbdd7$var$StyledContainer.displayName = 'StyledContainer';

});
parcelRegister("hvrWv", function(module, exports) {

$parcel$export(module.exports, "useBottomRightCornerContainer", () => $4dcd4c0b25ba3fd4$export$84542488b6b6c309);
$parcel$export(module.exports, "useBottomRightCornerActions", () => $4dcd4c0b25ba3fd4$export$de496fd0e0151c81);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $4dcd4c0b25ba3fd4$export$84542488b6b6c309 = (0, $3sQ5x.createStateHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.bottomRightCorner.container
});
const $4dcd4c0b25ba3fd4$export$de496fd0e0151c81 = (0, $3sQ5x.createActionsHook)((0, $5e5zm.layoutStore));

});


parcelRegister("cPiXk", function(module, exports) {

$parcel$export(module.exports, "useHorizontalNavComponent", () => $2edc33969f533189$export$205771a0e64e4c7c);

var $5uXOq = parcelRequire("5uXOq");

var $5f2bR = parcelRequire("5f2bR");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $14V0U = parcelRequire("14V0U");

var $3HwlS = parcelRequire("3HwlS");

var $6jY6G = parcelRequire("6jY6G");

var $dAfqg = parcelRequire("dAfqg");

var $c1mlA = parcelRequire("c1mlA");

var $lODMY = parcelRequire("lODMY");

var $e5wyW = parcelRequire("e5wyW");

var $lODMY = parcelRequire("lODMY");

const $2edc33969f533189$export$965942f8308cd740 = (0, $lODMY.createRouterSelector)((state)=>(0, $c1mlA.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(state.query.config));
const $2edc33969f533189$export$b19560433646c65e = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    const hasBoardSettingsPageQueryParam = $2edc33969f533189$export$965942f8308cd740();
    // chromeless mode is handled in page-container package with nav4
    if (!(0, $3HwlS.getWillShowNav4)()) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isChromeless] = (0, $14V0U.useIsChromeless)();
        if (isChromeless) return null;
    }
    if (route.navigation?.horizontal == null) return null;
    // Shared horizontal navigation routes that currently live in business projects on prod
    // but we want to remove horizontal navigation on with the navigation redesign
    if (route.navigation.horizontal === (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)) {
        if ((0, $3HwlS.getWillShowNav4)()) return null;
        switch(projectData?.projectType){
            case 0, $2vSU6.CORE_PROJECT:
                return 0, $5f2bR.AsyncHorizontalNavJira;
            default:
                return null;
        }
    }
    // Board settings pages should not show the horizontal nav.
    // This is a workaround due to the fact that the software CMP board/backlog pages share the same route name
    // as the board settings pages. This code should be removed once the board settings pages have
    // their own dedicated route names.
    if (route.group === 'classic-software' && hasBoardSettingsPageQueryParam && (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('simplified-boards-milestone-2_07hbk')) return null;
    if (route.navigation.horizontal === (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)) switch(projectData?.projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return 0, $5f2bR.AsyncHorizontalNavJira;
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if ((0, $3HwlS.getWillShowNav4)()) return 0, $5f2bR.AsyncHorizontalNavJira;
            return null;
        default:
            return null;
    }
    // TODO: Remove this during jira_nav4 cleanup
    if ('onlyShowHorizontalOnNav4' in route.navigation && route.navigation.onlyShowHorizontalOnNav4) return (0, $3HwlS.getWillShowNav4)() ? route.navigation.horizontal : null;
    return route.navigation.horizontal;
};
const $2edc33969f533189$export$aae2a7dfc5c1b863 = ({ projectType: projectType, isChromeless: isChromeless, isSoftwareRouteGroup: isSoftwareRouteGroup, navigationComponent: navigationComponent, onlyShowHorizontalOnNav4: onlyShowHorizontalOnNav4, hasBoardSettingsPageQueryParam: hasBoardSettingsPageQueryParam })=>{
    // chromeless mode is handled in page-container package with nav4
    if (!(0, $3HwlS.getWillShowNav4)()) {
        if (isChromeless) return null;
    }
    if (navigationComponent == null) return null;
    // Shared horizontal navigation routes that currently live in business projects on prod
    // but we want to remove horizontal navigation on with the navigation redesign
    if (navigationComponent === (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)) {
        if ((0, $3HwlS.getWillShowNav4)()) return null;
        switch(projectType){
            case 0, $2vSU6.CORE_PROJECT:
                return 0, $5f2bR.AsyncHorizontalNavJira;
            default:
                return null;
        }
    }
    // Board settings pages should not show the horizontal nav.
    // This is a workaround due to the fact that the software CMP board/backlog pages share the same route name
    // as the board settings pages. This code should be removed once the board settings pages have
    // their own dedicated route names.
    if (isSoftwareRouteGroup && hasBoardSettingsPageQueryParam && (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('simplified-boards-milestone-2_07hbk')) return null;
    if (navigationComponent === (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)) switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return 0, $5f2bR.AsyncHorizontalNavJira;
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if ((0, $3HwlS.getWillShowNav4)()) return 0, $5f2bR.AsyncHorizontalNavJira;
            return null;
        default:
            return null;
    }
    // TODO: Remove this during jira_nav4 cleanup
    if (onlyShowHorizontalOnNav4) return (0, $3HwlS.getWillShowNav4)() ? navigationComponent : null;
    return navigationComponent;
};
const $2edc33969f533189$export$340457fee3625bbc = ()=>{
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    const hasBoardSettingsPageQueryParam = $2edc33969f533189$export$965942f8308cd740();
    const [isChromeless] = (0, $14V0U.useIsChromeless)();
    const firstRoute = (0, $5uXOq.useMemo)(()=>(0, $lODMY.getRouterState)().route, []);
    const [horizontalNavComponent, setHorizontalNavComponent] = (0, $5uXOq.useState)(()=>// initialize with the first route's horizontal nav component
        $2edc33969f533189$export$aae2a7dfc5c1b863({
            projectType: projectData?.projectType,
            isChromeless: isChromeless,
            isSoftwareRouteGroup: firstRoute?.group === 'classic-software',
            navigationComponent: firstRoute?.navigation?.horizontal ?? null,
            onlyShowHorizontalOnNav4: Boolean(firstRoute?.navigation && 'onlyShowHorizontalOnNav4' in firstRoute?.navigation && firstRoute?.navigation?.onlyShowHorizontalOnNav4),
            hasBoardSettingsPageQueryParam: hasBoardSettingsPageQueryParam
        }));
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = (0, $lODMY.addRouteListener)(({ route: route })=>{
            setHorizontalNavComponent((prevState)=>{
                const nextHorizontalNavComponent = $2edc33969f533189$export$aae2a7dfc5c1b863({
                    projectType: projectData?.projectType,
                    isChromeless: isChromeless,
                    isSoftwareRouteGroup: route?.group === 'classic-software',
                    navigationComponent: route?.navigation?.horizontal ?? null,
                    onlyShowHorizontalOnNav4: Boolean(route?.navigation && 'onlyShowHorizontalOnNav4' in route?.navigation && route?.navigation?.onlyShowHorizontalOnNav4),
                    hasBoardSettingsPageQueryParam: hasBoardSettingsPageQueryParam
                });
                if (prevState !== nextHorizontalNavComponent) return nextHorizontalNavComponent;
                return prevState;
            });
        });
        return ()=>unsubscribe();
    }, [
        projectData?.projectType,
        hasBoardSettingsPageQueryParam,
        isChromeless
    ]);
    return horizontalNavComponent;
};
const $2edc33969f533189$export$205771a0e64e4c7c = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('reduce_navigation_rerenders_1'), $2edc33969f533189$export$340457fee3625bbc, $2edc33969f533189$export$b19560433646c65e);

});
parcelRegister("c1mlA", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_METRICS_HISTOGRAM", () => $4c8f71f257051803$export$128e24da52662cdd);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION", () => $4c8f71f257051803$export$efdecbe4c9f1cd2c);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_SAC_URL_CONFIG_DISABLE_SECTION", () => $4c8f71f257051803$export$1154ed64d0d99951);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION_ANALYTICS_ID", () => $4c8f71f257051803$export$7cadd2a48a9ff918);
$parcel$export(module.exports, "DEFAULT_LEVEL_ONE_NAME", () => $4c8f71f257051803$export$a546b6d48878ce6f);
$parcel$export(module.exports, "BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES", () => $4c8f71f257051803$export$8cc83ae2b6885e0);
$parcel$export(module.exports, "boardSettingsQueryConfigParamValues", () => $4c8f71f257051803$export$a9ebdab56bd9c0c3);
$parcel$export(module.exports, "SETTINGS_CONFIG", () => $4c8f71f257051803$export$2a56ee2f9c41b5a7);
$parcel$export(module.exports, "EDIT_BOARD_CONFIG", () => $4c8f71f257051803$export$b893894941c14e43);
$parcel$export(module.exports, "ADMINISTER_PARENT_PROJECT", () => $4c8f71f257051803$export$d14d5a7c294329c5);
$parcel$export(module.exports, "USER_PICKER_PROJECT_PERMISSION_KEY", () => $4c8f71f257051803$export$1e63b013f0e45de0);
$parcel$export(module.exports, "ADMINISTER_PROJECT_PERMISSION_KEY", () => $4c8f71f257051803$export$68030ac1ea4abd4c);
$parcel$export(module.exports, "BACKLOG_FEATURE_KEY", () => $4c8f71f257051803$export$e1671d3447ddd5ad);
$parcel$export(module.exports, "SPRINTS_FEATURE_KEY", () => $4c8f71f257051803$export$46efc2c8d8106cff);
$parcel$export(module.exports, "FEATURE_ENABLED_STATUS", () => $4c8f71f257051803$export$a1046f102eae498);
const $4c8f71f257051803$export$128e24da52662cdd = '1000_1500_2000_2500_3000_4000';
const $4c8f71f257051803$export$efdecbe4c9f1cd2c = '2QE2xWf0TpDbYpk4oY9aQr';
const $4c8f71f257051803$export$1154ed64d0d99951 = 'https://support.atlassian.com/jira-software-cloud/docs/how-do-jira-permissions-work/';
const $4c8f71f257051803$export$7cadd2a48a9ff918 = `${$4c8f71f257051803$export$efdecbe4c9f1cd2c}.config-disabled-section.article.analytics`;
const $4c8f71f257051803$export$a546b6d48878ce6f = 'Epic';
const $4c8f71f257051803$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES = [
    'cardColors',
    'cardLayout',
    'columns',
    'default',
    'estimation',
    'filter',
    'swimlanes',
    'time',
    'timelineConfig',
    'quickFilters',
    'dateFields'
];
const $4c8f71f257051803$export$8cc83ae2b6885e0 = new Set($4c8f71f257051803$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES);
const $4c8f71f257051803$export$a9ebdab56bd9c0c3 = Object.fromEntries($4c8f71f257051803$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES.map((key)=>[
        key,
        key
    ]));
const $4c8f71f257051803$export$2a56ee2f9c41b5a7 = {
    default: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.filter,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isCalendarEnabled: isCalendarEnabled, isBoardEnabled: isBoardEnabled })=>isCalendarEnabled || isBoardEnabled,
        jswAllowed: true
    },
    filter: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.filter,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isCalendarEnabled: isCalendarEnabled, isBoardEnabled: isBoardEnabled })=>isCalendarEnabled || isBoardEnabled,
        jswAllowed: true
    },
    columns: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.columns,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    swimlanes: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.swimlanes,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    quickFilters: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.quickFilters,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    cardColors: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.cardColors,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    cardLayout: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.cardLayout,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isBoardEnabled: isBoardEnabled })=>isBoardEnabled,
        jswAllowed: true
    },
    estimation: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.estimation,
        userLocatedBoardAllowed: true,
        kanbanAllowed: false,
        isJsmFeatureVisible: ()=>false,
        jswAllowed: true
    },
    time: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.time,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ()=>false,
        jswAllowed: true
    },
    timelineConfig: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.timelineConfig,
        userLocatedBoardAllowed: false,
        kanbanAllowed: true,
        isJsmFeatureVisible: ()=>false,
        jswAllowed: true
    },
    dateFields: {
        configQuery: $4c8f71f257051803$export$a9ebdab56bd9c0c3.dateFields,
        userLocatedBoardAllowed: true,
        kanbanAllowed: true,
        isJsmFeatureVisible: ({ isCalendarEnabled: isCalendarEnabled })=>isCalendarEnabled,
        jswAllowed: false
    }
};
const $4c8f71f257051803$export$773ca4f5fb67778b = 60000;
const $4c8f71f257051803$export$b893894941c14e43 = 'EDIT_BOARD_CONFIG';
const $4c8f71f257051803$export$d14d5a7c294329c5 = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
'ADMINISTER_PARENT_PROJECT';
const $4c8f71f257051803$export$1e63b013f0e45de0 = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
'USER_PICKER';
const $4c8f71f257051803$export$68030ac1ea4abd4c = 'ADMINISTER';
const $4c8f71f257051803$export$e1671d3447ddd5ad = 'BACKLOG';
const $4c8f71f257051803$export$46efc2c8d8106cff = 'SPRINTS';
const $4c8f71f257051803$export$a1046f102eae498 = 'ENABLED';

});


parcelRegister("16YKp", function(module, exports) {

$parcel$export(module.exports, "useBannerJsmPackagingUpdates", () => $32df9c26e8c82916$export$a0dde3f151a99607);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $6jY6G = parcelRequire("6jY6G");

var $dAfqg = parcelRequire("dAfqg");

var $gzrJT = parcelRequire("gzrJT");

var $90yGq = parcelRequire("90yGq");

var $l2Uy7 = parcelRequire("l2Uy7");
const $32df9c26e8c82916$export$a0dde3f151a99607 = ()=>{
    const currentRoute = (0, $6jY6G.useCurrentRoute)();
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const accountId = (0, $90yGq.useAccountId)();
    const isServiceProject = project?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
    const isInJsmBoundary = (0, $5uXOq.useMemo)(()=>(0, $l2Uy7.isInJsmGlobalSettingsBoundary)(currentRoute.path) || isServiceProject, [
        isServiceProject,
        currentRoute.path
    ]);
    const { shouldShow: shouldShow, dismissAnnouncement: dismissAnnouncement } = (0, $gzrJT.useJsmRepackagingAnnouncementResource)(accountId);
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: isInJsmBoundary && shouldShow && (0, $4R6GH.fg)('jsm-packaging-pricing-changes-announcement'),
            dismissAnnouncement: dismissAnnouncement
        }), [
        dismissAnnouncement,
        isInJsmBoundary,
        shouldShow
    ]);
};

});
parcelRegister("gzrJT", function(module, exports) {

$parcel$export(module.exports, "useJsmRepackagingAnnouncementResource", () => $e073f4ec0b653e88$export$47d5fef12f2d184b);

var $5uXOq = parcelRequire("5uXOq");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $hj0lE = parcelRequire("hj0lE");

const $e073f4ec0b653e88$var$getDataLoader = ()=>(parcelRequire("8rWex"));
const $e073f4ec0b653e88$export$750cb6ed3dfc6a3 = (0, $2M1hQ.createResource)({
    type: 'JSM_REPACKAGING_ANNOUNCEMENT',
    getKey: ()=>'JSM_REPACKAGING_ANNOUNCEMENT',
    getDataLoader: $e073f4ec0b653e88$var$getDataLoader,
    maxAge: Infinity
});
const $e073f4ec0b653e88$export$47d5fef12f2d184b = (accountId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh, update: update } = (0, $2YP9W.useResource)($e073f4ec0b653e88$export$750cb6ed3dfc6a3);
    const loadingRef = (0, $5uXOq.useRef)(false);
    const errorRef = (0, $5uXOq.useRef)();
    const [userPropertiesError, setUserPropertiesError] = (0, $5uXOq.useState)();
    errorRef.current = userPropertiesError || error;
    const dismissAnnouncement = (0, $5uXOq.useCallback)(()=>{
        const announcementDismissState = {
            shouldShow: false
        };
        update(()=>({
                announcementDismissState: announcementDismissState
            }));
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                        teamName: '50cent'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $89SaW.setUserProperties)(accountId, (0, $hj0lE.JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY), JSON.stringify(announcementDismissState)).catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                        teamName: '50cent'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                loadingRef.current = false;
            });
        }
    }, [
        accountId,
        update
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $5uXOq.useMemo)(()=>{
        if (errorRef.current || loading || !data || !accountId) return {
            shouldShow: false,
            dismissAnnouncement: dismissAnnouncement
        };
        const { announcementDismissState: announcementDismissState } = data;
        if (!announcementDismissState) return {
            shouldShow: false,
            dismissAnnouncement: dismissAnnouncement
        };
        return {
            ...announcementDismissState,
            dismissAnnouncement: dismissAnnouncement
        };
    }, [
        loading,
        data,
        accountId,
        dismissAnnouncement
    ]);
};

});
parcelRegister("hj0lE", function(module, exports) {

$parcel$export(module.exports, "JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY", () => $4bad9f9efc7d29c0$export$d2137827dc00e559);
$parcel$export(module.exports, "DEFAULT_JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE", () => $4bad9f9efc7d29c0$export$341176bfdf8c92);
const $4bad9f9efc7d29c0$export$d2137827dc00e559 = 'jsm-repackaging-announcement-dismiss-state';
const $4bad9f9efc7d29c0$export$341176bfdf8c92 = {
    shouldShow: true
};

});

parcelRegister("8rWex", function(module, exports) {

let $626e044a04092900$var$load = (parcelRequire("28QjX"))(4);
module.exports = $626e044a04092900$var$load("37oAo").then(()=>parcelRequire('lGYvJ'));

});


parcelRegister("l2Uy7", function(module, exports) {

$parcel$export(module.exports, "isInJsmGlobalSettingsBoundary", () => $257d172b6cc842a0$export$c28a66ae6d31a34b);
const $257d172b6cc842a0$var$jsmGlobalSettingsPages = [
    '/jira/settings/products/jira-service-management-configuration',
    '/jira/settings/products/jira-service-management-email-requests',
    '/jira/settings/products/servicedesk/customer-access',
    '/jira/settings/products/servicedesk/authentication',
    '/jira/settings/products/servicedesk/organizations',
    '/jira/settings/products/jira-service-management-incident-management-tools',
    '/jira/settings/products/jira-service-management-compliance',
    '/jira/settings/products/servicedesk/feature-usage'
];
const $257d172b6cc842a0$var$eocGlobalSettingsPages = [
    '/jira/settings/products/ops/roles',
    '/jira/settings/products/ops/role-assignment',
    '/jira/settings/products/ops/role-based-notifications',
    '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
    '/jira/settings/products/ops/integrations',
    '/jira/settings/products/ops/heartbeats',
    '/jira/settings/products/ops/syncs',
    '/jira/settings/products/ops/policies',
    '/jira/settings/products/ops/maintenance',
    '/jira/settings/products/ops/escalation-policies',
    '/jira/settings/products/ops/incoming-call',
    '/jira/settings/products/ops/jira-service-management-audit-logs',
    '/jira/settings/products/ops/reports'
];
const $257d172b6cc842a0$var$isJsmGlobalSettingsPage = (route)=>$257d172b6cc842a0$var$jsmGlobalSettingsPages.includes(route);
const $257d172b6cc842a0$var$isEocGlobalSettingsPage = (route)=>$257d172b6cc842a0$var$eocGlobalSettingsPages.includes(route);
const $257d172b6cc842a0$export$c28a66ae6d31a34b = (route)=>$257d172b6cc842a0$var$isJsmGlobalSettingsPage(route) || $257d172b6cc842a0$var$isEocGlobalSettingsPage(route);

});


parcelRegister("cOwuh", function(module, exports) {

$parcel$export(module.exports, "BannerJsmPackagingUpdateAsync", () => $5589b5a823eb55d2$export$76c6ab35aee49900);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $5589b5a823eb55d2$var$BannerTransition = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("fq0S5")).then((module)=>module.BannerJsmPackagingUpdate), {
    moduleId: "./src/packages/platform/ui/banners/jsm-packaging-updates/src/ui/banner/index.tsx"
});
const $5589b5a823eb55d2$export$76c6ab35aee49900 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-banner-jsm-packaging-updates",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5589b5a823eb55d2$var$BannerTransition, null));

});
parcelRegister("fq0S5", function(module, exports) {

let $b399f5c71d27a0d4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b399f5c71d27a0d4$var$load("3lSYe").then(()=>parcelRequire('kuFA7'));

});


parcelRegister("3Uek9", function(module, exports) {

$parcel$export(module.exports, "useProjectTheme", () => $241dc29db19bb69f$export$18084206b9430153);

var $5uXOq = parcelRequire("5uXOq");

var $lODMY = parcelRequire("lODMY");

var $l71WK = parcelRequire("l71WK");

var $5f2bR = parcelRequire("5f2bR");

var $4R6GH = parcelRequire("4R6GH");

var $8iyFV = parcelRequire("8iyFV");

var $cPiXk = parcelRequire("cPiXk");

var $3HwlS = parcelRequire("3HwlS");

var $6jY6G = parcelRequire("6jY6G");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $e5wyW = parcelRequire("e5wyW");
const $241dc29db19bb69f$export$94f987aa4379ed89 = (0, $lODMY.createRouterSelector)((state)=>state.route.name);
const $241dc29db19bb69f$export$89f90ea8776fdb88 = (0, $lODMY.createRouterSelector)((state)=>state.route.group);
const $241dc29db19bb69f$export$93a3fc2291ccebfa = ({ route: route, HorizontalNavComponent: HorizontalNavComponent, hasSoftwareTheming: hasSoftwareTheming, isSoftwareFullTheming: isSoftwareFullTheming, isSoftwareProject: isSoftwareProject })=>{
    const routeName = route.name;
    const routeGroup = route.group;
    const isBusinessRouteGroup = routeGroup === 'classic-business';
    // eslint-disable-next-line no-nested-ternary
    const hasProjectViewNavigation = (0, $3HwlS.getWillShowNav4)() ? HorizontalNavComponent != null : (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? HorizontalNavComponent === (0, $5f2bR.AsyncHorizontalNavJira) || HorizontalNavComponent === (0, $l71WK.AsyncHorizontalOverviewNav) || HorizontalNavComponent === (0, $8iyFV.AsyncHorizontalNavPlans) : HorizontalNavComponent === (0, $5f2bR.AsyncHorizontalNavJira) || HorizontalNavComponent === (0, $l71WK.AsyncHorizontalOverviewNav);
    let hasTheming;
    if ((0, $3HwlS.getWillShowNav4)()) {
        const isSoftwareCalendarRoute = routeName === 'software-calendar' || routeName === 'software-calendar-classic';
        if (isSoftwareCalendarRoute) hasTheming = false;
        else if (isSoftwareProject) hasTheming = hasSoftwareTheming;
        else hasTheming = HorizontalNavComponent === (0, $5f2bR.AsyncHorizontalNavJira) || HorizontalNavComponent === (0, $l71WK.AsyncHorizontalOverviewNav) || routeName === 'issue';
    } else hasTheming = hasProjectViewNavigation;
    // Routes showing a themed inset layout are:
    // - all routes with the business project view navigation
    // - select software routes with contoured theming
    // - except for the routes with business group (as they already cater for the theme)
    const isInset = hasTheming && !isBusinessRouteGroup && !isSoftwareFullTheming;
    return {
        isInset: isInset,
        hasTheming: hasTheming,
        hasProjectViewNavigation: hasProjectViewNavigation
    };
};
const $241dc29db19bb69f$var$useProjectThemeNew = ()=>{
    const HorizontalNavComponent = (0, $cPiXk.useHorizontalNavComponent)();
    const { hasSoftwareTheming: hasSoftwareTheming, isSoftwareFullTheming: isSoftwareFullTheming, isSoftwareProject: isSoftwareProject } = (0, $a2e2Q.useSoftwareProjectTheming)();
    const routerState = (0, $5uXOq.useMemo)(()=>(0, $lODMY.getRouterState)(), []);
    const [projectThemeState, setProjectThemeState] = (0, $5uXOq.useState)(()=>$241dc29db19bb69f$export$93a3fc2291ccebfa({
            route: {
                name: routerState.route.name,
                group: routerState.route.group
            },
            HorizontalNavComponent: HorizontalNavComponent,
            hasSoftwareTheming: hasSoftwareTheming,
            isSoftwareFullTheming: isSoftwareFullTheming,
            isSoftwareProject: isSoftwareProject
        }));
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = (0, $lODMY.addRouteListener)(({ route: route })=>{
            setProjectThemeState((prevState)=>{
                const { isInset: isInset, hasTheming: hasTheming, hasProjectViewNavigation: hasProjectViewNavigation } = $241dc29db19bb69f$export$93a3fc2291ccebfa({
                    route: {
                        name: route.name,
                        group: route.group
                    },
                    HorizontalNavComponent: HorizontalNavComponent,
                    hasSoftwareTheming: hasSoftwareTheming,
                    isSoftwareFullTheming: isSoftwareFullTheming,
                    isSoftwareProject: isSoftwareProject
                });
                if (prevState.isInset !== isInset || prevState.hasTheming !== hasTheming || prevState.hasProjectViewNavigation !== hasProjectViewNavigation) return {
                    isInset: isInset,
                    hasTheming: hasTheming,
                    hasProjectViewNavigation: hasProjectViewNavigation
                };
                return prevState;
            });
        });
        return ()=>unsubscribe();
    }, [
        setProjectThemeState,
        HorizontalNavComponent,
        isSoftwareFullTheming,
        isSoftwareProject,
        hasSoftwareTheming
    ]);
    return projectThemeState;
};
const $241dc29db19bb69f$var$useProjectThemeOld = ()=>{
    const route = (0, $4R6GH.fg)('dee_7299_improve_route_usage_in_useprojecttheme') ? undefined : (0, $6jY6G.useCurrentRoute)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const currentRouteName = (0, $4R6GH.fg)('jira_theming_relay_migration') ? $241dc29db19bb69f$export$94f987aa4379ed89() : undefined;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const currentRouteGroup = (0, $4R6GH.fg)('jira_theming_relay_migration') ? $241dc29db19bb69f$export$89f90ea8776fdb88() : undefined;
    const routeName = currentRouteName || ((0, $4R6GH.fg)('dee_7299_improve_route_usage_in_useprojecttheme') ? undefined : route?.name);
    const routeGroup = currentRouteGroup || ((0, $4R6GH.fg)('dee_7299_improve_route_usage_in_useprojecttheme') ? undefined : route?.group);
    const HorizontalNavComponent = (0, $cPiXk.useHorizontalNavComponent)();
    const { hasSoftwareTheming: hasSoftwareTheming, isSoftwareFullTheming: isSoftwareFullTheming, isSoftwareProject: isSoftwareProject } = (0, $lmBAt.getIsSoftwareThemingEnabled)() ? (0, $a2e2Q.useSoftwareProjectTheming)() : {
        hasSoftwareTheming: false,
        isSoftwareFullTheming: false,
        isSoftwareProject: false
    };
    const isBusinessRouteGroup = routeGroup === 'classic-business';
    // eslint-disable-next-line no-nested-ternary
    const hasProjectViewNavigation = (0, $3HwlS.getWillShowNav4)() ? HorizontalNavComponent != null : (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? HorizontalNavComponent === (0, $5f2bR.AsyncHorizontalNavJira) || HorizontalNavComponent === (0, $l71WK.AsyncHorizontalOverviewNav) || HorizontalNavComponent === (0, $8iyFV.AsyncHorizontalNavPlans) : HorizontalNavComponent === (0, $5f2bR.AsyncHorizontalNavJira) || HorizontalNavComponent === (0, $l71WK.AsyncHorizontalOverviewNav);
    let hasTheming;
    if ((0, $3HwlS.getWillShowNav4)()) {
        const isSoftwareCalendarRoute = routeName === 'software-calendar' || routeName === 'software-calendar-classic';
        if (isSoftwareCalendarRoute) hasTheming = false;
        else if (isSoftwareProject) hasTheming = hasSoftwareTheming;
        else hasTheming = HorizontalNavComponent === (0, $5f2bR.AsyncHorizontalNavJira) || HorizontalNavComponent === (0, $l71WK.AsyncHorizontalOverviewNav) || routeName === 'issue';
    } else hasTheming = hasProjectViewNavigation;
    // Routes showing a themed inset layout are:
    // - all routes with the business project view navigation
    // - select software routes with contoured theming
    // - except for the routes with business group (as they already cater for the theme)
    const isInset = hasTheming && !isBusinessRouteGroup && !isSoftwareFullTheming;
    return {
        isInset: isInset,
        hasTheming: hasTheming,
        hasProjectViewNavigation: hasProjectViewNavigation
    };
};
const $241dc29db19bb69f$export$18084206b9430153 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('reduce_navigation_rerenders_1'), $241dc29db19bb69f$var$useProjectThemeNew, $241dc29db19bb69f$var$useProjectThemeOld);

});

parcelRegister("ozeZW", function(module, exports) {

$parcel$export(module.exports, "sharedLayout", () => $1e4b0a2f1ef777fb$export$5f4dc7c98070d93e);

var $5uXOq = parcelRequire("5uXOq");

var $doxsH = parcelRequire("doxsH");

var $2vSU6 = parcelRequire("2vSU6");

var $8JIza = parcelRequire("8JIza");

var $gmGW3 = parcelRequire("gmGW3");

var $8NA5p = parcelRequire("8NA5p");

var $7kqCT = parcelRequire("7kqCT");

var $jjA6o = parcelRequire("jjA6o");

var $7jo2g = parcelRequire("7jo2g");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $7N30e = parcelRequire("7N30e");

var $6s1PB = parcelRequire("6s1PB");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $hfZX4 = parcelRequire("hfZX4");

var $7Lkcv = parcelRequire("7Lkcv");

var $9YvQF = parcelRequire("9YvQF");

var $km1Z8 = parcelRequire("km1Z8");

var $lpwtK = parcelRequire("lpwtK");

var $jElqQ = parcelRequire("jElqQ");

var $kKa8l = parcelRequire("kKa8l");

var $bmetd = parcelRequire("bmetd");

var $izgL1 = parcelRequire("izgL1");

var $lyCmi = parcelRequire("lyCmi");

var $aPfsS = parcelRequire("aPfsS");

var $kgLzl = parcelRequire("kgLzl");

var $dYRe6 = parcelRequire("dYRe6");

var $koeKL = parcelRequire("koeKL");

var $9yehD = parcelRequire("9yehD");

var $dz0Q5 = parcelRequire("dz0Q5");

var $4p6rw = parcelRequire("4p6rw");

var $b7Svb = parcelRequire("b7Svb");

var $iB3m4 = parcelRequire("iB3m4");

var $6g75y = parcelRequire("6g75y");

var $9OXo1 = parcelRequire("9OXo1");

var $6xesd = parcelRequire("6xesd");

var $kkNtb = parcelRequire("kkNtb");

var $38EzX = parcelRequire("38EzX");

var $lDu2T = parcelRequire("lDu2T");

var $jnXgM = parcelRequire("jnXgM");

var $is3OJ = parcelRequire("is3OJ");
// +owner:pdhanuka
// eslint-disable-next-line jira/ff/inline-usage
const $1e4b0a2f1ef777fb$var$isPendoIntegrationEnabled = ()=>(0, $4R6GH.fg)('jira-frontend-pendo-analytics_s6sj5');

// -owner:pdhanuka
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e4b0a2f1ef777fb$var$Global = (0, $b7Svb.lazy)(()=>(parcelRequire("fZrWn")), {
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/global/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e4b0a2f1ef777fb$var$Navigation = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("bp4rt")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/navigation/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e4b0a2f1ef777fb$var$Trackers = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("awHzC")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/trackers/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e4b0a2f1ef777fb$var$RemoteActions = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("gWBZV")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/remote-actions/index.tsx"
});

// No need for a whole chunk for a single component
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e4b0a2f1ef777fb$var$AfterPaintIssuePreEval = (0, $b7Svb.lazyAfterPaint)(/* eslint-disable-next-line jira/import/webpack-magic-comment-entries */ ()=>(parcelRequire("gnXZs")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/after-paint-issue-preeval/AfterPaintIssuePreEval.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e4b0a2f1ef777fb$var$AsyncBrowserStorageControlsInit = (0, $b7Svb.lazy)(()=>(parcelRequire("d11H7")).then(({ BrowserStorageControlsInit: BrowserStorageControlsInit })=>BrowserStorageControlsInit), {
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/browser-storage-controls-init/index.tsx"
});
const $1e4b0a2f1ef777fb$var$runtimeProps = {};
const $1e4b0a2f1ef777fb$var$entryPointParams = {};
const $1e4b0a2f1ef777fb$export$3859d35c5447350b = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $kgLzl.rovoVideoModalEntryPoint), $1e4b0a2f1ef777fb$var$entryPointParams);
    const { atlassianAccountId: atlassianAccountId, cloudId: cloudId, isAnonymous: isAnonymous } = (0, $9OXo1.useTenantContext)();
    const { loading: loadingProject, data: project } = (0, $lpwtK.useProject)();
    const projectType = (0, $2vSU6.toProjectType)(project?.type);
    const { start: messageStarted } = (0, $6xesd.useCoordinationClient)();
    const rovoEntitlement = (0, $kkNtb.useRovoEntitlementResource)();
    const isRovoLLMEnabled = !!rovoEntitlement?.data?.isRovoLLMEnabled;
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        const shouldShowRovoVideoModal = async ()=>{
            const hasSeenRovoOnboarding = await (0, $6g75y.getRovoVideoOnboardingHash)(atlassianAccountId);
            if (// eslint-disable-next-line jira/ff/no-preconditioning
            !loadingProject && (0, $iB3m4.isJiraSoftware)(projectType) && (0, $4R6GH.fg)('rovo_video_player_gate') && !hasSeenRovoOnboarding && !isAnonymous && isRovoLLMEnabled) {
                const hasMessageStarted = await messageStarted();
                if (hasMessageStarted) entryPointActions.load();
            }
        };
        if ((0, $4R6GH.fg)('iv-llc-unnecessary-bundles-rovo-video-modal')) shouldShowRovoVideoModal();
        else entryPointActions.load();
    }, [
        atlassianAccountId,
        cloudId,
        entryPointActions,
        isAnonymous,
        loadingProject,
        messageStarted,
        projectType,
        isRovoLLMEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "growth.rovoVideoPlayer",
        packageName: "rovo-video-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $1e4b0a2f1ef777fb$var$runtimeProps
    });
};
const $1e4b0a2f1ef777fb$export$39abefd31dfea2bd = ()=>{
    const { data: project } = (0, $lpwtK.useProject)();
    const projectId = String(project?.id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yehD.AsyncTrialSprintBoardModalEntryPoint), {
        currentProjectId: projectId
    });
};
const $1e4b0a2f1ef777fb$export$bb0d8fff645668ce = ()=>{
    const cloudID = (0, $koeKL.useCloudId)();
    const { data: project } = (0, $lpwtK.useProject)();
    const projectType = (0, $2vSU6.toProjectType)(project?.type) || null;
    const productKey = (0, $2vSU6.projectTypeToCanonicalId)(projectType);
    const deferEditionModalEntryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudID,
            productKey: productKey
        }), [
        cloudID,
        productKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7kqCT.jiraDeferEditionModalEntryPoint), deferEditionModalEntryPointParams);
    const onComplete = (0, $5uXOq.useCallback)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8NA5p.AsyncDeferEditionEPCheckWrapper), {
        onComplete: onComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "growth.jiraDeferEditionModal",
        packageName: "jira-defer-edition-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $1e4b0a2f1ef777fb$var$runtimeProps
    }));
};
const $1e4b0a2f1ef777fb$var$EndOfTrialModalEntryPoint = ()=>{
    const hasLoaded = (0, $5uXOq.useRef)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $jjA6o.endOfTrialExtensionEntryPoint), {});
    if (!hasLoaded.current) {
        hasLoaded.current = true;
        entryPointActions.load();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "growth.endOfTrialExtension",
        packageName: "jira-end-of-trial-extension",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $1e4b0a2f1ef777fb$var$runtimeProps
    });
};
const $1e4b0a2f1ef777fb$var$DeferEditionModal = (0, $cSD7y.componentWithFG)('cross-flow-defer-edition-communication-gate', $1e4b0a2f1ef777fb$export$bb0d8fff645668ce, ()=>null);
const $1e4b0a2f1ef777fb$var$DeferRovoVideoModal = (0, $cSD7y.componentWithFG)('rovo_video_player_gate', $1e4b0a2f1ef777fb$export$3859d35c5447350b, ()=>null);
const $1e4b0a2f1ef777fb$var$DeferTrialSprintBoardModal = (0, $cSD7y.componentWithFG)('jsw-trial-sprint-board-modal-gate-v2', $1e4b0a2f1ef777fb$export$39abefd31dfea2bd, ()=>null);
const $1e4b0a2f1ef777fb$var$AsyncRecommendPremiumToStandardModal = (0, $cSD7y.componentWithFG)('recommend_standard_in_jira_eot_shared_layout_', (0, $lyCmi.AsyncRecommendPremiumToStandardModalWrapper), ()=>null);
const $1e4b0a2f1ef777fb$var$ConditionalEndOfTrialExtensionModal = (0, $cSD7y.componentWithFG)('end_of_trial_extension_kill_switch', $1e4b0a2f1ef777fb$var$EndOfTrialModalEntryPoint, ()=>null);
$1e4b0a2f1ef777fb$var$DeferEditionModal.displayName = 'DeferEditionModal';
$1e4b0a2f1ef777fb$var$DeferRovoVideoModal.displayName = 'DeferRovoVideoModal';
$1e4b0a2f1ef777fb$var$DeferTrialSprintBoardModal.displayName = 'DeferTrialSprintBoardModal';
$1e4b0a2f1ef777fb$var$AsyncRecommendPremiumToStandardModal.displayName = 'AsyncRecommendPremiumToStandardModal';
$1e4b0a2f1ef777fb$var$ConditionalEndOfTrialExtensionModal.displayName = 'ConditionalEndOfTrialExtensionModal';
const $1e4b0a2f1ef777fb$var$sharedGlobalComponents = [
    ...false ? [] : [
        (0, $kKa8l.MatchedRouteListener),
        (0, $bmetd.PreviousRouterStateListener),
        (0, $lDu2T.LoadingPhaseManager),
        (0, $hfZX4.LoadingBarUIController),
        (0, $doxsH.default),
        (0, $38EzX.BreadcrumbAdapter),
        (0, $izgL1.default),
        (0, $jElqQ.PageDwellAnalyticsListener),
        (0, $km1Z8.ImperativeAPI),
        (0, $jnXgM.TrackClicksBeforeTTI),
        (0, $dYRe6.default),
        (0, $dz0Q5.AsyncUpflowIframeComponent),
        (0, $4p6rw.JiraHeritageLoader),
        $1e4b0a2f1ef777fb$var$AsyncBrowserStorageControlsInit,
        ...$1e4b0a2f1ef777fb$var$isPendoIntegrationEnabled() ? [
            (0, $8JIza.AsyncPendoAnalyticsWrapper)
        ] : [],
        (0, $7N30e.default),
        $1e4b0a2f1ef777fb$var$RemoteActions,
        $1e4b0a2f1ef777fb$var$DeferEditionModal,
        $1e4b0a2f1ef777fb$var$DeferRovoVideoModal,
        $1e4b0a2f1ef777fb$var$DeferTrialSprintBoardModal,
        (0, $7jo2g.AsyncEndOfTrialMessageSharedWrapper),
        $1e4b0a2f1ef777fb$var$AsyncRecommendPremiumToStandardModal,
        $1e4b0a2f1ef777fb$var$ConditionalEndOfTrialExtensionModal,
        // Integrations - Keyboard shortcuts, Issue View Modal, Create Project Drawer & Create dashboard modal
        (0, $is3OJ.Integrations)
    ],
    $1e4b0a2f1ef777fb$var$Global,
    $1e4b0a2f1ef777fb$var$Navigation,
    $1e4b0a2f1ef777fb$var$Trackers,
    $1e4b0a2f1ef777fb$var$AfterPaintIssuePreEval
];
const $1e4b0a2f1ef777fb$var$SafeEmbeddedConfluencePanelWithExperiments = ()=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_issue_view_side_by_side_modeless_ep_exp');
    return expConfig.get('cohort', 'not-enrolled') === 'experiment' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9YvQF.SafeEmbeddedConfluencePanel), null) : null;
};
const $1e4b0a2f1ef777fb$export$5f4dc7c98070d93e = (0, $aPfsS.createLayout)({
    rightSidebars: [
        (0, $7Lkcv.SafeHelpPanel),
        (0, $gmGW3.SafeConversationAssistantPanel),
        $1e4b0a2f1ef777fb$var$SafeEmbeddedConfluencePanelWithExperiments
    ],
    globalComponents: $1e4b0a2f1ef777fb$var$sharedGlobalComponents
});

});
parcelRegister("doxsH", function(module, exports) {

$parcel$export(module.exports, "default", () => $899e926f09852ef7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $90yGq = parcelRequire("90yGq");

var $1NZBJ = parcelRequire("1NZBJ");
const $899e926f09852ef7$var$CacheRegistry = ()=>{
    const accountIdLoggedInUser = (0, $90yGq.useAccountId)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $1NZBJ.default).set(accountIdLoggedInUser ?? 'anonymous');
    }, [
        accountIdLoggedInUser
    ]);
    return null;
};
var $899e926f09852ef7$export$2e2bcd8739ae039 = $899e926f09852ef7$var$CacheRegistry;

});
parcelRegister("1NZBJ", function(module, exports) {

$parcel$export(module.exports, "CACHE_PREFIX", () => $e0fd77b45718946f$export$69ca515e4489d790);
$parcel$export(module.exports, "scopeGuard", () => $e0fd77b45718946f$export$653cd03438bb0386);
$parcel$export(module.exports, "default", () => $e0fd77b45718946f$export$2e2bcd8739ae039);

var $bSSG7 = parcelRequire("bSSG7");
let $e0fd77b45718946f$var$resolveCachePromise;
const $e0fd77b45718946f$var$cachePromise = new Promise((resolve)=>{
    $e0fd77b45718946f$var$resolveCachePromise = resolve;
});
const $e0fd77b45718946f$export$27be962d708928a = '__scope_key__';
const $e0fd77b45718946f$export$69ca515e4489d790 = 'cache_prefix';
const $e0fd77b45718946f$var$TIMEOUT = 10000;
const $e0fd77b45718946f$var$promiseWithMaxExecutionTime = (ms, promise)=>{
    let id;
    const timeout = new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        id = setTimeout(()=>{
            const storage = (0, $bSSG7.createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
            storage.clearAll();
            reject(new Error(`Cache scope was not set within ${$e0fd77b45718946f$var$TIMEOUT}ms`));
        }, ms);
    });
    return Promise.race([
        promise,
        timeout
    ]).then((result)=>{
        clearTimeout(id);
        return result;
    });
};
const $e0fd77b45718946f$export$653cd03438bb0386 = ()=>$e0fd77b45718946f$var$promiseWithMaxExecutionTime($e0fd77b45718946f$var$TIMEOUT, $e0fd77b45718946f$var$cachePromise);
const $e0fd77b45718946f$var$config = {
    devTools: false,
    scopes: {
        prev: null,
        current: null
    },
    set (scopeKey) {
        const storage = (0, $bSSG7.createLocalStorageProvider)($e0fd77b45718946f$export$69ca515e4489d790);
        const scopeKeyInStorage = storage.get($e0fd77b45718946f$export$27be962d708928a);
        // init value
        if (this.scopes.prev === null && this.scopes.current === null) {
            if (scopeKeyInStorage) {
                // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
                this.scopes.prev = scopeKeyInStorage;
                // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.scopes.current = scopeKeyInStorage;
            }
        }
        // same account id
        if (this.scopes.current !== scopeKey) {
            // diffrent account id
            if (this.scopes.current !== null) // scope has changed during session
            storage.clearAll();
            // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
            this.scopes.prev = this.scopes.current;
            // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.scopes.current = scopeKey;
            storage.set($e0fd77b45718946f$export$27be962d708928a, scopeKey);
        }
        // @ts-expect-error - TS7005 - Variable 'resolveCachePromise' implicitly has an 'any' type.
        $e0fd77b45718946f$var$resolveCachePromise();
    },
    get () {
        return this.scopes.current;
    }
};
var $e0fd77b45718946f$export$2e2bcd8739ae039 = $e0fd77b45718946f$var$config;

});


parcelRegister("8JIza", function(module, exports) {

$parcel$export(module.exports, "AsyncPendoAnalyticsWrapper", () => $5adeefc5ea77d534$export$1c388e7c464f3699);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $7iJwP = parcelRequire("7iJwP");

var $b7Svb = parcelRequire("b7Svb");

const $5adeefc5ea77d534$var$AsyncPendoAnalytics = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("6j4dF")).then(({ PendoAnalytics: PendoAnalytics })=>PendoAnalytics), {
    moduleId: "./src/packages/platform/services/pendo-analytics/src/index.tsx"
});
const $5adeefc5ea77d534$export$1c388e7c464f3699 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "jiraCommonPendoAnalyticsReportErrors",
        packageName: "jiraCommonPendoAnalytics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        teamName: "martech",
        id: "jiraCommonPendoAnalyticsReportErrors",
        packageName: "jiraCommonPendoAnalytics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5adeefc5ea77d534$var$AsyncPendoAnalytics, null)));

});
parcelRegister("6j4dF", function(module, exports) {

let $4977ca51ec8dd426$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4977ca51ec8dd426$var$load("4sJqf").then(()=>parcelRequire('8bI7u'));

});


parcelRegister("gmGW3", function(module, exports) {

$parcel$export(module.exports, "SafeConversationAssistantPanel", () => $836bcaaba692e6c5$export$453401d0b697d2db);

var $5uXOq = parcelRequire("5uXOq");

var $lniFT = parcelRequire("lniFT");


var $7CMCs = parcelRequire("7CMCs");

var $hsmeR = parcelRequire("hsmeR");

var $bngFq = parcelRequire("bngFq");

var $isowN = parcelRequire("isowN");

var $3HwlS = parcelRequire("3HwlS");

var $koVbs = parcelRequire("koVbs");

var $2vgok = parcelRequire("2vgok");

var $4iuvt = parcelRequire("4iuvt");
const $836bcaaba692e6c5$var$PanelInLayout = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
    const prevPanelIdRef = (0, $5uXOq.useRef)();
    const delayRef = (0, $5uXOq.useRef)(null);
    const { closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const panelId = rightSidebarCurrentState?.panelId;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const handleResizeComplete = (0, $5uXOq.useCallback)(()=>{
        createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'aiMatePanel',
            tags: [
                'atlaskit',
                'aiMate'
            ]
        }).fire((0, $lniFT.FabricChannel).aiMate);
    }, [
        createAnalyticsEvent
    ]);
    /**
   * This use effect is used to add (when is necessary) a delay
   * in the panelId => localPanelId syncing
   */ (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $537cb35f009e92c2$export$dffb4ed44e20ea9a)) {
            /**
       * The right-sidebar is showing the conversation assistant...
       */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
         * and is open, not collapsed and we want to show a panel
         * with an ID !== CONVERSATION_ASSISTANT_CONTAINER_ID
         */ setLocalPanelId(panelId);
            else /**
         * and we want to close it
         */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
                createAnalyticsEvent({
                    action: 'closed',
                    actionSubject: 'aiMatePanel',
                    source: 'AIMate',
                    tags: [
                        'atlaskit',
                        'aiMate'
                    ]
                }).fire((0, $lniFT.FabricChannel).aiMate);
            }, 310);
        } else /**
       * If the right sidebar is not showing the conversation assistant,
       * we just keep localPanelId in sync with panelId
       */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        createAnalyticsEvent,
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $537cb35f009e92c2$export$dffb4ed44e20ea9a)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isowN.PanelSplitter), {
        label: formatMessage((0, $4iuvt.default).panelSplitter),
        onResizeEnd: handleResizeComplete
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2vgok.JiraConversationAssistant), {
        onClosePanel: closeCurrentRightSidebar
    }));
};
const $836bcaaba692e6c5$export$453401d0b697d2db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-conversation-assistant-panel",
        packageName: "jiraConversationAssistant"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($836bcaaba692e6c5$var$PanelInLayout, null));

});
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $537cb35f009e92c2$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $537cb35f009e92c2$export$64aee74ba59709e5 = 439; // px
const $537cb35f009e92c2$export$1c07393c5bb1bc27 = 439; // px
const $537cb35f009e92c2$export$aa3478deee7adbeb = 350; // px
const $537cb35f009e92c2$export$21e515a86cd1733b = 'Chat';

parcelRegister("isowN", function(module, exports) {

$parcel$export(module.exports, "PanelSplitter", () => $4f3ca2da195da8a9$export$db67e3f8d3d6da0f);
/* panel-splitter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $3joPi = parcelRequire("3joPi");

var $jJsBW = parcelRequire("jJsBW");

var $hGKXL = parcelRequire("hGKXL");

var $9cPKo = parcelRequire("9cPKo");

var $fHpHg = parcelRequire("fHpHg");

var $l5MhD = parcelRequire("l5MhD");

var $4nayr = parcelRequire("4nayr");
parcelRequire("2AQVt");
var $jc0Aq = parcelRequire("jc0Aq");
parcelRequire("lRCxc");
var $7Kos0 = parcelRequire("7Kos0");
parcelRequire("6YRGu");
var $iuy0r = parcelRequire("iuy0r");

var $cBCgC = parcelRequire("cBCgC");

var $6XZE5 = parcelRequire("6XZE5");

var $a62u0 = parcelRequire("a62u0");

var $53Gc5 = parcelRequire("53Gc5");

var $fKD9L = parcelRequire("fKD9L");

var $fgnqW = parcelRequire("fgnqW");

var $kLfVv = parcelRequire("kLfVv");
const $4f3ca2da195da8a9$var$containerStyles = {
    root: "_12ji1r31 _1qu2glyw _12y31o36 _1e0cglyw _kqswstnw _u7coidpf _152tidpf _1pbykb7n _181n1ule",
    positionEnd: "_rjxpftgi",
    positionStart: "_1e02zeo2"
};
const $4f3ca2da195da8a9$var$grabAreaStyles = {
    root: "_1bsbl52n _4t3i1osq _kqswstnw _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syaz3acm _bfhk18uv _k8m01ylx _1oec1yx9 _1lww5cps _d0aluf7j _1gavfnf5 _vp7gaqb7 _30l3aqb7 _1dr21ylx _1s5z1ylx _1cg4fnf5 _le1bfnf5 _1gglglyw _9h8h16c2"
};
const $4f3ca2da195da8a9$var$lineStyles = {
    root: "_kqswstnw _1e0c1ule _1bsbjfq9 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e021v6z"
};
const $4f3ca2da195da8a9$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId })=>{
    const splitterRef = (0, $5uXOq.useRef)(null);
    const panelSplitterContext = (0, $5uXOq.useContext)((0, $6XZE5.PanelSplitterContext));
    (0, $3joPi.default)(panelSplitterContext, 'Panel splitter context must be set');
    const { panelWidth: panelWidth, onCompleteResize: onCompleteResize, resizeBounds: resizeBounds, panelRef: panelRef, resizingCssVar: resizingCssVar, portalRef: portalRef, position: position, isEnabled: isEnabled } = panelSplitterContext;
    (0, $3joPi.default)(portalRef.current, 'Portal ref must be set');
    const direction = (0, $kLfVv.useTextDirection)(portalRef.current);
    const labelId = (0, $jJsBW.useId)();
    // Separate state used for the input range width to remove the UI's dependency on the "persisted" layout state value being updated
    const [rangeInputValue, setRangeInputValue] = (0, $5uXOq.useState)(panelWidth);
    /**
   * We are using state to store the resize bounds _converted into pixel units_, so that we can update them when the window is resized.
   * Otherwise they can become out of sync with the actual viewport size, and cause a broken experience (inaccurate width percentage)
   * when the user tries to resize using the keyboard.
   */ const [rangeInputBounds, setRangeInputBounds] = (0, $5uXOq.useState)({
        // Using placeholder values here for the initial render. These will be calculated and updated when the range input is focused.
        min: 200,
        max: 500
    });
    const openLayerObserver = (0, $9cPKo.useOpenLayerObserverBehindFG)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const splitter = splitterRef.current;
        (0, $3joPi.default)(splitter, 'Splitter ref must be set');
        return (0, $l5MhD.combine)((0, $jc0Aq.blockDraggingToIFrames)({
            element: splitter
        }), (0, $4nayr.draggable)({
            element: splitter,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $7Kos0.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $iuy0r.preventUnhandled).start();
            },
            getInitialData () {
                (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                /**
         * The drag calculations require the actual computed width of the element
         * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
         * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
         */ return {
                    initialWidth: (0, $fKD9L.getPixelWidth)(panelRef.current)
                };
            },
            onDragStart ({ source: source }) {
                (0, $3joPi.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                onResizeStart?.({
                    initialWidth: source.data.initialWidth
                });
                // Close any open layers when the user starts resizing
                if ((0, $fHpHg.fg)('platform_dst_open_layer_observer_close_layers')) openLayerObserver?.closeLayers();
            },
            onDrag ({ location: location, source: source }) {
                (0, $3joPi.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                panelRef.current?.style.setProperty(resizingCssVar, `clamp(${resizeBounds.min}, ${(0, $fKD9L.getWidthFromDragLocation)({
                    initialWidth: source.data.initialWidth,
                    location: location,
                    direction: direction,
                    position: position
                })}px, ${resizeBounds.max})`);
            },
            onDrop ({ source: source }) {
                (0, $iuy0r.preventUnhandled).stop();
                (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                (0, $3joPi.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                const finalWidth = (0, $fKD9L.getPixelWidth)(panelRef.current);
                onCompleteResize(finalWidth);
                onResizeEnd?.({
                    initialWidth: source.data.initialWidth,
                    finalWidth: finalWidth
                });
                panelRef.current.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStart,
        onResizeEnd,
        panelRef,
        resizingCssVar,
        panelWidth,
        resizeBounds,
        direction,
        position,
        isEnabled,
        openLayerObserver
    ]);
    const onResizeStartStableRef = (0, $hGKXL.default)(onResizeStart);
    const onResizeEndStableRef = (0, $hGKXL.default)(onResizeEnd);
    const [keyboardResizeManager] = (0, $5uXOq.useState)(()=>(0, $fgnqW.createKeyboardResizeManager)({
            onResizeStart: (...args)=>{
                // Close any open layers when the user starts resizing with keyboard
                if ((0, $fHpHg.fg)('platform_dst_open_layer_observer_close_layers')) openLayerObserver?.closeLayers();
                onResizeStartStableRef.current?.(...args);
            },
            onResizeEnd: (...args)=>onResizeEndStableRef.current?.(...args)
        }));
    const handleSliderInputChange = (0, $5uXOq.useCallback)((event)=>{
        const value = parseInt(event.target.value);
        setRangeInputValue(value);
        /**
     * We are intentionally _not_ debouncing `onCompleteResize` as we want it to be called anytime the user changes the range input value.
     * It is an internal-only callback - it's provided by `PanelSplitterProvider`, and used by layout slots to update their layout width state.
     */ onCompleteResize(value);
        keyboardResizeManager.onResize({
            initialWidth: panelWidth,
            finalWidth: value
        });
    }, [
        onCompleteResize,
        panelWidth,
        keyboardResizeManager
    ]);
    const resizeEventListenerCleanupFn = (0, $5uXOq.useRef)(null);
    const handleSliderFocus = (0, $5uXOq.useCallback)(()=>{
        /**
     * We are only updating the range input's properties when the element is focused, as a performance optimisation.
     * It isn't necessary to recalculate these values until the element is going to be used.
     */ // Clean up any left over listeners in case `focus` was triggered again without `blur`.
        resizeEventListenerCleanupFn.current?.();
        // Update the range input value to match the current panel width.
        setRangeInputValue(panelWidth);
        // Update the range input bounds to ensure they are accurate (in case the viewport was previously resized)
        setRangeInputBounds({
            min: (0, $a62u0.convertResizeBoundToPixels)(resizeBounds.min),
            max: (0, $a62u0.convertResizeBoundToPixels)(resizeBounds.max)
        });
        /**
     * _While the slider element is focused_, add a window resize event listener to update the range input bounds
     * when the window is resized. This is needed to ensure the min and max widths accurately reflect the viewport
     * size - in case they are provided in vw units.
     *
     * This listener is cleaned up when the element is blurred.
     */ resizeEventListenerCleanupFn.current = (0, $cBeZP.bind)(window, {
            type: 'resize',
            listener: function updateState() {
                setRangeInputBounds({
                    min: (0, $a62u0.convertResizeBoundToPixels)(resizeBounds.min),
                    max: (0, $a62u0.convertResizeBoundToPixels)(resizeBounds.max)
                });
            }
        });
    }, [
        panelWidth,
        resizeBounds.max,
        resizeBounds.min
    ]);
    const handleSliderBlur = (0, $5uXOq.useCallback)(()=>{
        // Remove the resize event listener when the range input is blurred.
        resizeEventListenerCleanupFn.current?.();
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        return function cleanup() {
            // Cleanup the resize event listener when the component is unmounted.
            resizeEventListenerCleanupFn.current?.();
        };
    }, []);
    const ariaValueText = (0, $5uXOq.useMemo)(()=>`${(0, $53Gc5.getPercentageWithinPixelBounds)({
            currentWidth: rangeInputValue,
            resizeBounds: rangeInputBounds
        })}% width`, [
        rangeInputValue,
        rangeInputBounds
    ]);
    if (!isEnabled) return null;
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        className: (0, $bwpsq.default)([
            $4f3ca2da195da8a9$var$containerStyles.root,
            position === 'start' && $4f3ca2da195da8a9$var$containerStyles.positionStart,
            position === 'end' && $4f3ca2da195da8a9$var$containerStyles.positionEnd
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            ref: splitterRef,
            "data-testid": testId,
            className: (0, $bwpsq.default)([
                $4f3ca2da195da8a9$var$grabAreaStyles.root
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cBCgC.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                            type: "range",
                            value: rangeInputValue,
                            step: 20,
                            min: rangeInputBounds.min,
                            max: rangeInputBounds.max,
                            "aria-valuetext": ariaValueText,
                            "aria-labelledby": labelId,
                            onChange: handleSliderInputChange,
                            onFocus: handleSliderFocus,
                            onBlur: handleSliderBlur
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            id: labelId,
                            children: label
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    className: (0, $bwpsq.default)([
                        $4f3ca2da195da8a9$var$lineStyles.root
                    ])
                })
            ]
        })
    }), portalRef.current);
};
// Ensures that the component is only rendered on a client. Uses a `useEffect`, which is not run on servers.
const $4f3ca2da195da8a9$var$ClientOnly = ({ children: children })=>{
    const [hasMounted, setHasMounted] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        setHasMounted(true);
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: hasMounted ? children : null
    });
};
const $4f3ca2da195da8a9$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)($4f3ca2da195da8a9$var$ClientOnly, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($4f3ca2da195da8a9$var$PortaledPanelSplitter, {
            label: label,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd,
            testId: testId
        })
    });

});
parcelRegister("2AQVt", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => (parcelRequire("jc0Aq")).blockDraggingToIFrames);

var $jc0Aq = parcelRequire("jc0Aq");

});
parcelRegister("jc0Aq", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => $375245b8c8d856a3$export$6ae1d8fab001518c);

var $bAMyk = parcelRequire("bAMyk");

var $cGlU2 = parcelRequire("cGlU2");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $375245b8c8d856a3$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
let $375245b8c8d856a3$var$isActive = false;
/**
 * Start blocking dragging to iframes. Only to be called once a drag has started.
 */ function $375245b8c8d856a3$var$tryStart() {
    // There can technically be multiple registrations on the same element.
    // Adding a guard to ensure that only one registration does the blocking.
    if ($375245b8c8d856a3$var$isActive) return;
    $375245b8c8d856a3$var$isActive = true;
    // At this stage, we are also not watching for new iframe elements being added to the page
    // (we _could_ do that as a future change)
    const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$375245b8c8d856a3$var$setStyle(iframe, {
            property: 'pointer-events',
            rule: 'none',
            priority: 'important'
        }));
    // Not returning the cleanup function.
    // This code will clean itself up when the interaction ends in `onDrop()`.
    // Once a drag has started we are blocking iframes until the interaction is finished.
    const cleanup = (0, $cGlU2.combine)(...iframeCleanups, // We only need this monitor for listening to the drop
    // as our monitor in `blockDraggingToIFrames()` will only
    // call this function when the drag has started
    (0, $bAMyk.monitorForElements)({
        onDrop () {
            cleanup();
        }
    }), function release() {
        $375245b8c8d856a3$var$isActive = false;
    });
}
function $375245b8c8d856a3$export$6ae1d8fab001518c({ element: element }) {
    return (0, $bAMyk.monitorForElements)({
        onGenerateDragPreview ({ source: source }) {
            // only starting if we are dragging the provided element
            if (source.element === element) $375245b8c8d856a3$var$tryStart();
        }
    });
}

});


parcelRegister("lRCxc", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("7Kos0")).disableNativeDragPreview);

var $7Kos0 = parcelRequire("7Kos0");

});
parcelRegister("7Kos0", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => $83c84ebf8511989e$export$c588cb30ff3b876e);
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $83c84ebf8511989e$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $83c84ebf8511989e$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $83c84ebf8511989e$var$tinyTransparentImage) nativeSetDragImage($83c84ebf8511989e$var$tinyTransparentImage, 0, 0);
}

});


parcelRegister("6YRGu", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("iuy0r")).preventUnhandled);

var $iuy0r = parcelRequire("iuy0r");

});
parcelRegister("iuy0r", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => $8b57e76cff7b558c$export$453c0582481cc59d);

var $cBeZP = parcelRequire("cBeZP");

var $iDg6w = parcelRequire("iDg6w");
function $8b57e76cff7b558c$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $8b57e76cff7b558c$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $8b57e76cff7b558c$var$start() {
    $8b57e76cff7b558c$var$cleanup();
    $8b57e76cff7b558c$var$unbindEvents = (0, $cBeZP.bindAll)(window, [
        {
            type: 'dragover',
            listener: $8b57e76cff7b558c$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $8b57e76cff7b558c$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $8b57e76cff7b558c$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $8b57e76cff7b558c$var$cleanup
        },
        ...(0, $iDg6w.getBindingsForBrokenDrags)({
            onDragEnd: $8b57e76cff7b558c$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $8b57e76cff7b558c$var$cleanup() {
    $8b57e76cff7b558c$var$unbindEvents?.();
    $8b57e76cff7b558c$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $8b57e76cff7b558c$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $8b57e76cff7b558c$var$cleanup();
}
const $8b57e76cff7b558c$export$453c0582481cc59d = {
    start: $8b57e76cff7b558c$var$start,
    stop: $8b57e76cff7b558c$var$stop
};

});


parcelRegister("a62u0", function(module, exports) {

$parcel$export(module.exports, "convertResizeBoundToPixels", () => $33f341ba639a611a$export$3d412b3011b66f82);
function $33f341ba639a611a$export$3d412b3011b66f82(resizeBound) {
    if (resizeBound.endsWith('vw')) {
        // Max width was provided in `vw` units, so is relative to the viewport width.
        // e.g. 50vw = 50% of the viewport width.
        // `parseInt` will remove the `vw` suffix.
        const maxWidthFraction = parseInt(resizeBound) / 100;
        return Math.floor(window.innerWidth * maxWidthFraction);
    }
    // Max width was provided in `px` units, so we can parse it directly.
    // `parseInt` will remove the `px` suffix.
    return Math.floor(parseInt(resizeBound));
}

});

parcelRegister("53Gc5", function(module, exports) {

$parcel$export(module.exports, "getPercentageWithinPixelBounds", () => $233bdf6185a388e4$export$b5423678cdf09f5);
function $233bdf6185a388e4$export$b5423678cdf09f5({ currentWidth: currentWidth, resizeBounds: resizeBounds }) {
    const resizeRange = resizeBounds.max - resizeBounds.min;
    const widthAsPercentage = (currentWidth - resizeBounds.min) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}

});

parcelRegister("fKD9L", function(module, exports) {

$parcel$export(module.exports, "getWidthFromDragLocation", () => $1f77da03c1c23958$export$e360234971cb95b8);
$parcel$export(module.exports, "getPixelWidth", () => $1f77da03c1c23958$export$d942790ad00c41f9);
const $1f77da03c1c23958$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, direction: direction, position: position })=>{
    const diffX = location.current.input.clientX - location.initial.input.clientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
};
const $1f77da03c1c23958$export$d942790ad00c41f9 = (element)=>{
    const { width: width } = window.getComputedStyle(element);
    return parseInt(width);
};

});

parcelRegister("fgnqW", function(module, exports) {

$parcel$export(module.exports, "createKeyboardResizeManager", () => $4ae38e8dfa859310$export$f7d3d5dae65f74aa);
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $4ae38e8dfa859310$var$resizeCallbackDebounceTimeMs = 500;
function $4ae38e8dfa859310$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
	 * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
	 */ function startResizeEndTimer({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            resizingState = {
                type: 'idle'
            };
        }, $4ae38e8dfa859310$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: initialWidth,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart({
                initialWidth: initialWidth
            });
            startResizeEndTimer({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                initialWidth: resizingState.initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
    }
    return {
        onResize: onResize
    };
}

});

parcelRegister("kLfVv", function(module, exports) {

$parcel$export(module.exports, "useTextDirection", () => $2d32442f94ec60a6$export$cf24a79f32f45545);

var $5uXOq = parcelRequire("5uXOq");
const $2d32442f94ec60a6$export$cf24a79f32f45545 = (element)=>(0, $5uXOq.useMemo)(()=>{
        const { direction: direction } = window.getComputedStyle(element);
        return direction === 'rtl' ? 'rtl' : 'ltr';
    }, [
        element
    ]);

});


parcelRegister("2vgok", function(module, exports) {

$parcel$export(module.exports, "JiraConversationAssistant", () => $2321abcc17b38bef$export$da8473714271a41d);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $kzjWf = parcelRequire("kzjWf");
var $1U0LI = parcelRequire("1U0LI");


var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $hsmeR = parcelRequire("hsmeR");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $14XJw = parcelRequire("14XJw");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");

var $3HwlS = parcelRequire("3HwlS");
const $2321abcc17b38bef$var$SYNTHETIC_HEADER = 'x-issynthetic-traffic';
const $2321abcc17b38bef$export$da8473714271a41d = ({ onClosePanel: onClosePanel })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const isNav4Enabled = (0, $3HwlS.getWillShowNav4)();
    const isSyntheticTenant = (0, $j8DrX.default)('ajs-is-synthetic') === 'true' || (0, $4R6GH.fg)('is_synthetic_tenant');
    const baseUrl = (0, $co1wz.ff)('jira.frontend.ai.mate.route.stargate.to.convo.ai') ? '/gateway/api/assist-kotlin' : '/gateway/api/assist';
    const config = (0, $5uXOq.useMemo)(()=>({
            displaySubmitFlag: true,
            siteId: cloudId,
            activationId: activationId,
            product: 'jira',
            orgId: orgId,
            experienceId: 'ai-mate',
            assistanceServiceConfig: {
                // TODO: type `AssistanceServiceConfig` should be decoupled from headers to prevent the need for other required keys which shouldn't need to be defined here (`product` and `experienceId`)
                headers: isSyntheticTenant ? {
                    [$2321abcc17b38bef$var$SYNTHETIC_HEADER]: String(isSyntheticTenant)
                } : {},
                baseUrl: baseUrl
            }
        }), [
        cloudId,
        activationId,
        orgId,
        isSyntheticTenant,
        baseUrl
    ]);
    const handleResizeComplete = (0, $5uXOq.useCallback)((width)=>{
        openRightSidebar((0, $537cb35f009e92c2$export$dffb4ed44e20ea9a), width);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'aiMatePanel'
        }));
    }, [
        openRightSidebar,
        createAnalyticsEvent
    ]);
    // ROVOFE-76 - No resize wrapper for nav4 as it uses PanelSplitter now
    if (isNav4Enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $2321abcc17b38bef$var$conversationAssistantWrapperNav4Styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kzjWf.default), {
        testId: "conversation-assistant.ui.conversation-assistant",
        onCloseChat: onClosePanel,
        config: config,
        isNav4Enabled: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1U0LI.ResizeWrapper), {
        onResizeComplete: handleResizeComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $2321abcc17b38bef$var$conversationAssistantWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kzjWf.default), {
        testId: "conversation-assistant.ui.conversation-assistant",
        onCloseChat: onClosePanel,
        config: config
    })));
};
const $2321abcc17b38bef$var$conversationAssistantWrapperStyles = (0, $2s57o.xcss)({
    width: '100%'
});
const $2321abcc17b38bef$var$conversationAssistantWrapperNav4Styles = (0, $2s57o.xcss)({
    width: '100%',
    height: '100%'
});

});
parcelRegister("kzjWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa2d6450353bbabe$export$2e2bcd8739ae039);

var $4qBtX = parcelRequire("4qBtX");

var $fa2d6450353bbabe$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("86DJk")),
    loading: ()=>null
});

});
parcelRegister("4qBtX", function(module, exports) {
"use strict";
var $3396aa4dae68f4b9$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $3396aa4dae68f4b9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3396aa4dae68f4b9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $3396aa4dae68f4b9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");
var $3396aa4dae68f4b9$var$ALL_INITIALIZERS = [];
var $3396aa4dae68f4b9$var$READY_INITIALIZERS = [];
function $3396aa4dae68f4b9$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $3396aa4dae68f4b9$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $3396aa4dae68f4b9$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $3396aa4dae68f4b9$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $3396aa4dae68f4b9$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $3396aa4dae68f4b9$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $3396aa4dae68f4b9$var$render(loaded, props) {
    return $5uXOq.createElement($3396aa4dae68f4b9$var$resolve(loaded), props);
}
function $3396aa4dae68f4b9$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $3396aa4dae68f4b9$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $3396aa4dae68f4b9$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $3396aa4dae68f4b9$var$READY_INITIALIZERS.push(function() {
        if ($3396aa4dae68f4b9$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $3396aa4dae68f4b9$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $3396aa4dae68f4b9$var$_classCallCheck(this, LoadableComponent);
            var _this = $3396aa4dae68f4b9$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        LoadableComponent.prototype.componentWillMount = function componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $5uXOq.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($5uXOq.Component), _class.contextTypes = {
        loadable: $8rCP3.shape({
            report: $8rCP3.func.isRequired
        })
    }, _temp;
}
function $3396aa4dae68f4b9$var$Loadable(opts) {
    return $3396aa4dae68f4b9$var$createLoadableComponent($3396aa4dae68f4b9$var$load, opts);
}
function $3396aa4dae68f4b9$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $3396aa4dae68f4b9$var$createLoadableComponent($3396aa4dae68f4b9$var$loadMap, opts);
}
$3396aa4dae68f4b9$var$Loadable.Map = $3396aa4dae68f4b9$var$LoadableMap;
var $3396aa4dae68f4b9$var$Capture = function(_React$Component2) {
    $3396aa4dae68f4b9$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $3396aa4dae68f4b9$var$_classCallCheck(this, Capture);
        return $3396aa4dae68f4b9$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $5uXOq.Children.only(this.props.children);
    };
    return Capture;
}($5uXOq.Component);
$3396aa4dae68f4b9$var$Capture.propTypes = {
    report: $8rCP3.func.isRequired
};
$3396aa4dae68f4b9$var$Capture.childContextTypes = {
    loadable: $8rCP3.shape({
        report: $8rCP3.func.isRequired
    }).isRequired
};
$3396aa4dae68f4b9$var$Loadable.Capture = $3396aa4dae68f4b9$var$Capture;
function $3396aa4dae68f4b9$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $3396aa4dae68f4b9$var$flushInitializers(initializers);
    });
}
$3396aa4dae68f4b9$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $3396aa4dae68f4b9$var$flushInitializers($3396aa4dae68f4b9$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$3396aa4dae68f4b9$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $3396aa4dae68f4b9$var$flushInitializers($3396aa4dae68f4b9$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $3396aa4dae68f4b9$var$Loadable;

});

parcelRegister("86DJk", function(module, exports) {

let $5e6db3d5c1655d8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5e6db3d5c1655d8b$var$load("hPzOn"),
    $5e6db3d5c1655d8b$var$load("dsiAd"),
    $5e6db3d5c1655d8b$var$load("h2MrD"),
    $5e6db3d5c1655d8b$var$load("bYT2S"),
    $5e6db3d5c1655d8b$var$load("cM9em"),
    $5e6db3d5c1655d8b$var$load("fr9NE"),
    $5e6db3d5c1655d8b$var$load("6c6xh")
]).then(()=>parcelRequire('cuB2c'));

});


parcelRegister("1U0LI", function(module, exports) {

$parcel$export(module.exports, "ResizeWrapper", () => $694f54f9dcf723ff$export$c7990a6594835e51);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cBeZP = parcelRequire("cBeZP");

const $694f54f9dcf723ff$var$styles = {
    root: "_1xi2ze3t _1e0c1txw _kqsw1n9t _4t3i1i8v",
    handle: "_v564jkaz _1kl7j1ic _80omuf7j _uiztglyw _kqswstnw _154ipxbi _94n5ze3t _1ltvze3t _1bsb1tcg _13lipd34 _1jvv1bty",
    handleSpacer: "_1bsb1tcg _kqswstnw _1e0c1ule _1ltv2bgk _154ize3t _94n5ze3t"
};
const $694f54f9dcf723ff$export$c7990a6594835e51 = ({ children: children, onResizeComplete: onResizeComplete, initialWidth: initialWidth = (0, $537cb35f009e92c2$export$64aee74ba59709e5), minWidth: minWidth = (0, $537cb35f009e92c2$export$64aee74ba59709e5), maxWidth: maxWidth = '50vw' })=>{
    const [width, setWidth] = (0, $5uXOq.useState)(initialWidth);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const isDraggingRef = (0, $5uXOq.useRef)(false);
    const initialMousePositionRef = (0, $5uXOq.useRef)(0);
    const prevDistanceMovedRef = (0, $5uXOq.useRef)(0);
    const rafRef = (0, $5uXOq.useRef)(null);
    const getWrapperWidth = ()=>{
        return wrapperRef.current?.getBoundingClientRect()?.width || 0;
    };
    const handleMouseMove = (0, $5uXOq.useCallback)((event)=>{
        if (!isDraggingRef.current) return;
        const distanceMoved = event.clientX - initialMousePositionRef.current;
        let updatedWidth;
        const currentWidth = getWrapperWidth();
        // Ignore events without change
        if (distanceMoved === prevDistanceMovedRef.current || distanceMoved === 0) return;
        // Acknowledge latest direction adjustment
        prevDistanceMovedRef.current = distanceMoved;
        // Clear queued animation frame
        if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
        rafRef.current = requestAnimationFrame(()=>{
            // Update widths with upper and lower limits respected when `minWidth` and `maxWidth` are `number`
            // When `string`, we'll respect this value on the styles of the wrapper for use-cases such as '100%', '70vw' etc.
            if (distanceMoved < 0) {
                updatedWidth = currentWidth + Math.abs(distanceMoved);
                if (typeof maxWidth === 'number' && !isNaN(maxWidth)) updatedWidth = Math.min(updatedWidth, maxWidth);
            } else {
                updatedWidth = currentWidth - distanceMoved;
                if (typeof minWidth === 'number' && !isNaN(minWidth)) updatedWidth = Math.max(updatedWidth, minWidth);
            }
            setWidth(updatedWidth);
            initialMousePositionRef.current = event.clientX;
        });
    }, [
        maxWidth,
        minWidth
    ]);
    const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
        // Indicate dragging
        isDraggingRef.current = true;
        // Indicate starting point
        initialMousePositionRef.current = event.clientX;
    }, []);
    const handleMouseUp = (0, $5uXOq.useCallback)(()=>{
        if (isDraggingRef.current && onResizeComplete) onResizeComplete(wrapperRef.current?.getBoundingClientRect().width || width);
        isDraggingRef.current = false;
    }, [
        onResizeComplete,
        width
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const mouseMoveHandler = (0, $cBeZP.bind)(window, {
            type: 'mousemove',
            listener: handleMouseMove
        });
        const mouseUpHandler = (0, $cBeZP.bind)(window, {
            type: 'mouseup',
            listener: handleMouseUp
        });
        return ()=>{
            mouseMoveHandler();
            mouseUpHandler();
            if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
        };
    }, [
        handleMouseMove,
        handleMouseUp
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ref: wrapperRef,
        role: "presentation",
        "data-testid": "panel-resize-wrapper",
        style: {
            width: width,
            maxWidth: maxWidth,
            minWidth: minWidth
        },
        className: (0, $bwpsq.default)([
            $694f54f9dcf723ff$var$styles.root
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                "data-testid": "panel-resize-handle",
                onMouseDown: handleMouseDown,
                className: (0, $bwpsq.default)([
                    $694f54f9dcf723ff$var$styles.handle
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $694f54f9dcf723ff$var$styles.handleSpacer
                    ])
                })
            }),
            children
        ]
    });
};

});


parcelRegister("4iuvt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c74f41697e20fe6a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c74f41697e20fe6a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    panelSplitter: {
        "id": "platform-conversation-assistant.panelSplitter.label",
        "defaultMessage": "Resize panel"
    }
});

});


parcelRegister("8NA5p", function(module, exports) {

$parcel$export(module.exports, "AsyncDeferEditionEPCheckWrapper", () => $2684c9c6a6fb887b$export$4fa5b26bccc7e3df);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $7iJwP = parcelRequire("7iJwP");

var $b7Svb = parcelRequire("b7Svb");


// We are using an async here in addition to the jiraDeferEditionModalEntryPoint in ./entrypoint.tsx since
// we want to avoid unnecessarily preloading the expensive graphql query on each page load. Instead
// we load an async component that checks engagement-platform first if we are to show the modal or not.
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2684c9c6a6fb887b$var$AsyncDeferEditionEPCheck = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("4BXy6")).then(({ EPCheck: EPCheck })=>EPCheck), {
    ssr: false,
    moduleId: "./src/packages/growth/defer-edition-modal/src/EPCheck.tsx"
});
const $2684c9c6a6fb887b$export$4fa5b26bccc7e3df = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "defer-edition-ep-check-async",
        packageName: (0, $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        teamName: (0, $ac4f2a72f86d65c9$export$d57b6b390e78d90f),
        id: "defer-edition-ep-check-async",
        packageName: (0, $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2684c9c6a6fb887b$var$AsyncDeferEditionEPCheck, props)));

});
const $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b = 'DeferEditionModal';
const $ac4f2a72f86d65c9$export$d57b6b390e78d90f = 'transmuters-growth';
const $ac4f2a72f86d65c9$export$4b374f476a475bef = 'stg-defer-edition-crossflow-jpd';
const $ac4f2a72f86d65c9$export$3fc71bcf4d7deeea = 'stg-defer-edition-crossflow-jsw';
const $ac4f2a72f86d65c9$export$a0f8b0f73985911a = 'stg-defer-edition-crossflow-jwm';
const $ac4f2a72f86d65c9$export$bfaa609ebcf522b6 = 'stg-defer-edition-crossflow-jsm';
const $ac4f2a72f86d65c9$export$58003a8be3bebb14 = 'defer-edition-crossflow-jpd';
const $ac4f2a72f86d65c9$export$475f4ac16b63ff71 = 'defer-edition-crossflow-jsw';
const $ac4f2a72f86d65c9$export$f36bed87d45a98de = 'defer-edition-crossflow-jwm';
const $ac4f2a72f86d65c9$export$b302977ba64b0fa = 'defer-edition-crossflow-jsm';

parcelRegister("4BXy6", function(module, exports) {

let $35b8cf536de1014d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $35b8cf536de1014d$var$load("aCymh").then(()=>parcelRequire('1HKGQ'));

});


parcelRegister("7kqCT", function(module, exports) {

$parcel$export(module.exports, "jiraDeferEditionModalEntryPoint", () => $110a94ef04661997$export$51f384a783f47807);

var $fiH7W = parcelRequire("fiH7W");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");
const $110a94ef04661997$var$Fallback = ()=>null;

const $110a94ef04661997$export$51f384a783f47807 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(async ()=>{
        if (!false) return (parcelRequire("97o1U")).then(({ DeferEditionModalComponent: DeferEditionModalComponent })=>DeferEditionModalComponent);
        return $110a94ef04661997$var$Fallback;
    }, {
        moduleId: "fe342c6b"
    }),
    getPreloadProps: ({ cloudId: cloudId, productKey: productKey })=>({
            queries: {
                deferEditionModal: {
                    parameters: (0, $fiH7W.default),
                    variables: {
                        cloudId: cloudId,
                        productKey: productKey
                    }
                }
            }
        })
});

});
parcelRegister("fiH7W", function(module, exports) {

$parcel$export(module.exports, "default", () => $d18804309a0f9ffd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f7b7f568d65bb0013b875d9dc02c9ec8>>
 * @relayHash f383e862a6745bc8f6efe3f1d322accc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5db8f4ae8f0ff9144226f55dd10f2adcc53bceab974d658a4e9c23ea3e7709ce
const $d18804309a0f9ffd$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5db8f4ae8f0ff9144226f55dd10f2adcc53bceab974d658a4e9c23ea3e7709ce",
        "metadata": {},
        "name": "src_DeferEditionModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $d18804309a0f9ffd$export$2e2bcd8739ae039 = $d18804309a0f9ffd$var$node;

});

parcelRegister("97o1U", function(module, exports) {

let $6a37684cbeb505d7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6a37684cbeb505d7$var$load("hmyGT").then(()=>parcelRequire('8IIKL'));

});


parcelRegister("jjA6o", function(module, exports) {

$parcel$export(module.exports, "endOfTrialExtensionEntryPoint", () => $cd06d7cec07212f7$export$dd41abc64eb3ea80);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $cd06d7cec07212f7$export$dd41abc64eb3ea80 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("1wqqF")), {
        moduleId: "13487943"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1wqqF", function(module, exports) {

let $11bd47e52d760574$var$load = (parcelRequire("28QjX"))(4);
module.exports = $11bd47e52d760574$var$load("3AMHt").then(()=>parcelRequire('egyYq'));

});


parcelRegister("7jo2g", function(module, exports) {

$parcel$export(module.exports, "AsyncEndOfTrialMessageSharedWrapper", () => $b603c0291b5c0134$export$ae154a7bf883999f);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $7iJwP = parcelRequire("7iJwP");

var $b7Svb = parcelRequire("b7Svb");

var $bZB1h = parcelRequire("bZB1h");

const $b603c0291b5c0134$var$AsyncEndOfTrialMessageSharedGlobalComponent = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("AdRe3")).then(({ EndOfTrialMessageSharedGlobalComponent: EndOfTrialMessageSharedGlobalComponent })=>EndOfTrialMessageSharedGlobalComponent), {
    moduleId: "./src/packages/growth/end-of-trial/end-of-trial-message-shared-global-component/src/index.tsx"
});
const $b603c0291b5c0134$export$ae154a7bf883999f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "end-of-trial-message-shared-async",
        packageName: (0, $bZB1h.PACKAGE_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        teamName: (0, $bZB1h.TEAM_NAME),
        id: "end-of-trial-message-shared-async",
        packageName: (0, $bZB1h.PACKAGE_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b603c0291b5c0134$var$AsyncEndOfTrialMessageSharedGlobalComponent, null)));

});
parcelRegister("bZB1h", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $25fa48d758254005$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $25fa48d758254005$export$d57b6b390e78d90f);
$parcel$export(module.exports, "ONE_DAY_IN_MILLISECONDS", () => $25fa48d758254005$export$2cf27d95188f1c13);
const $25fa48d758254005$export$b8b9d90f9e5bd72b = '@atlassian/jira-end-of-trial-message-shared-global-component';
const $25fa48d758254005$export$d57b6b390e78d90f = 'transmuters-growth';
const $25fa48d758254005$export$2cf27d95188f1c13 = 86400000;

});

parcelRegister("AdRe3", function(module, exports) {

let $06ce1cb6c09d3cfc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $06ce1cb6c09d3cfc$var$load("eXdJ6").then(()=>parcelRequire('bOc3m'));

});


parcelRegister("hfZX4", function(module, exports) {

$parcel$export(module.exports, "LoadingBarUIController", () => $b0b17218ec347926$export$39bdf67fc71ce8c8);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $d46Cs = parcelRequire("d46Cs");

var $lsa9q = parcelRequire("lsa9q");

var $bVDE5 = parcelRequire("bVDE5");

var $doZTA = parcelRequire("doZTA");

var $04unK = parcelRequire("04unK");

var $cYUbO = parcelRequire("cYUbO");
const $b0b17218ec347926$export$54128ad8de32b897 = ({ startLoading: startLoading, resetLoading: resetLoading, finishLoading: finishLoading })=>{
    const [loadedState] = (0, $lsa9q.default)();
    (0, $5uXOq.useEffect)(()=>{
        startLoading();
        return ()=>{
            resetLoading();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (loadedState.hasLoaded) finishLoading();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
/**
 * Sets up the loading bar stylesheet and controller purely in the client
 * This is a fallback if SSR fails
 *
 */ const $b0b17218ec347926$var$LoadingBarUI = ({ shouldRender: shouldRender, routeIdentifier: routeIdentifier })=>{
    const [actions, setActions] = (0, $5uXOq.useState)({});
    const sheetRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLStyleElement | null'.
        const loadingBarActions = (0, $d46Cs.createLoadingBarActionController)(sheetRef.current);
        setActions(loadingBarActions || {});
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLStyleElement> | undefined'.
        ref: sheetRef,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    ${(0, $04unK.LOADER_STYLES_CSS_SELECTOR)} {
                        ${(0, $cYUbO.generateLoadingBarStyles)(0, (0, $04unK.getLoadingBarColor)())}
                    }
                `
        }
    }), shouldRender && actions.START && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b0b17218ec347926$export$54128ad8de32b897, {
        key: routeIdentifier,
        // @ts-expect-error - TS2339 - Property 'START' does not exist on type '{}'.
        startLoading: actions.START,
        // @ts-expect-error - TS2339 - Property 'RESET' does not exist on type '{}'.
        resetLoading: actions.RESET,
        // @ts-expect-error - TS2339 - Property 'FINISH' does not exist on type '{}'.
        finishLoading: actions.FINISH
    }));
};
const $b0b17218ec347926$export$e068deb20d61b035 = ()=>{
    let currentTransitionsCount = 0;
    let currentRouteIdentifier = '';
    let currentRouteMatch = '';
    let hasTransitioned = false;
    let key = 0;
    return (transitionsCount, routeIdentifier, routeMatch)=>{
        if (transitionsCount !== currentTransitionsCount) {
            currentTransitionsCount = transitionsCount;
            hasTransitioned = true;
        }
        if (routeIdentifier !== null && routeIdentifier !== currentRouteIdentifier || routeIdentifier === currentRouteIdentifier && routeMatch !== currentRouteMatch) {
            currentRouteIdentifier = routeIdentifier;
            currentRouteMatch = routeMatch;
            if (hasTransitioned) {
                hasTransitioned = false;
                key = currentTransitionsCount;
            }
        }
        return key;
    };
};
const $b0b17218ec347926$var$getUniqueTransitionKey = $b0b17218ec347926$export$e068deb20d61b035();
/**
 * Determines if the <LoadingBarController> should render or re-render
 * Injects dependencies into <LoadingBarController />
 *
 */ const $b0b17218ec347926$export$39bdf67fc71ce8c8 = ()=>{
    const [routerState] = (0, $doZTA.useRouter)();
    const [{ transitionsCount: transitionsCount }] = (0, $bVDE5.useSpaStateTransition)();
    const currentRoute = routerState.route && routerState.route.name;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const loaderFailedInSSR = !window.JIRA_LOADING_BAR;
    const shouldRender = (0, $04unK.getAllowedRoutes)().includes(currentRoute);
    // we generate a unique route identifier each time a transition happens
    // we use this key to force re-render of the <LoadingBarController />
    const routeIdentifier = (0, $5uXOq.useMemo)(()=>$b0b17218ec347926$var$getUniqueTransitionKey(transitionsCount, currentRoute, JSON.stringify(routerState.match)), [
        transitionsCount,
        currentRoute,
        routerState.match
    ]);
    // We always expect the loading bar to be initialised in SSR for any route in ALLOWED_ROUTES
    // If this doesn't happen, it means SSR failed or the loading bar code in SSR failed
    (0, $5uXOq.useEffect)(()=>{
        if (shouldRender && loaderFailedInSSR) (0, $dJl1T.default).safeWarnWithoutCustomerData('global-loading-bar', 'Loading bar failed to initialise in SSR. This may be because SSR failed or a bug in the loading bar code.');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loaderFailedInSSR
    ]);
    // If the loading bar fails to setup in SSR, we set up the action controller AND stylesheet in the client
    // We also do this if SSR renders a page that does not have the loading bar enabled (eg !shouldRender)
    if (loaderFailedInSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b0b17218ec347926$var$LoadingBarUI, {
        shouldRender: shouldRender,
        routeIdentifier: routeIdentifier
    });
    // if the loading bar is succesfully setup in SSR, all the client needs to do is dispatch loading actions
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (shouldRender && window.JIRA_LOADING_BAR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b0b17218ec347926$export$54128ad8de32b897, {
        key: routeIdentifier,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        startLoading: window.JIRA_LOADING_BAR.START,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        resetLoading: window.JIRA_LOADING_BAR.RESET,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        finishLoading: window.JIRA_LOADING_BAR.FINISH
    });
    return null;
};

});
parcelRegister("d46Cs", function(module, exports) {

$parcel$export(module.exports, "createLoadingBarActionController", () => $65545b2eb3978204$export$55d67d61d9d2ad3b);
// BE VERY CAREFUL IMPORTING ANY PACKAGES IN THIS FILE
// THIS CODE IS AN INLINE FRAGMENT AND RUNS BEFORE POLYFILLS AND MAY BREAK IE

var $61WP1 = parcelRequire("61WP1");
const $65545b2eb3978204$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
const $65545b2eb3978204$export$899393f3e23f724b = 15000;
const $65545b2eb3978204$export$7868b416d8929c55 = 40000;
const $65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR = 'body::before';
const $65545b2eb3978204$var$EXIT_ANIMATION_SPEED = 300;
const $65545b2eb3978204$export$99d4e8974a739853 = ()=>(0, $61WP1.getMeta)('ajs-lf-navigation-highlightcolour') || $65545b2eb3978204$export$53d51cc6d57e44da;
const $65545b2eb3978204$export$4fb8742b05de9693 = (duration)=>`
    ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0.99);
        transition-duration: ${duration}ms;
        transition-timing-function: cubic-bezier(0,1,0.5,1);
    }
`;
const $65545b2eb3978204$export$5a43e0f09174e553 = ()=>`
    ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(1);
        transition-duration: ${$65545b2eb3978204$var$EXIT_ANIMATION_SPEED}ms;
        animation: none;
        background-image: none;
    }
`;
const $65545b2eb3978204$export$6beef8c645a63156 = ()=>`
    ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0);
        transition-duration: 0ms;
        animation: none;
        background-image: none;
    }
`;
const $65545b2eb3978204$export$610cb442736abf53 = ()=>`
    @keyframes shimmer {
        from {
            left: -80%;
            width: 80%;
        }

        to {
            left: 110%;
            width: 10%;
        }
    }
`;
const $65545b2eb3978204$export$959e9e99fba397f1 = (loadingBarColor)=>`
        ${$65545b2eb3978204$var$LOADER_STYLES_CSS_SELECTOR} {
            transform: scaleX(1);
            transition-duration: 0ms;
            background: ${loadingBarColor};
            animation: shimmer 2s infinite;
        }
    `;
const $65545b2eb3978204$var$browserFocusCheck = (action)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document && document.hidden) action();
    else requestAnimationFrame(()=>{
        action();
    });
};
const $65545b2eb3978204$export$55d67d61d9d2ad3b = (stylesheet)=>{
    const { sheet: sheet } = stylesheet || {};
    if (!sheet) return undefined;
    let isRunning = false;
    let isDelayed = false;
    let exitAnimationTimer;
    let delayedAnimationTimer;
    let timeoutTimer;
    return {
        START: (duration = $65545b2eb3978204$export$899393f3e23f724b)=>{
            if (isRunning) return;
            isRunning = true;
            // requestAnimationFrame will not run until the browser tab is focused
            // if a user opens a new tab the start animation will not begin until the tab is focused
            // this can cause the loading bar css to be applied in the incorrect order
            // to solve this we remove requestAnimationFrame if the tab is not focused
            $65545b2eb3978204$var$browserFocusCheck(()=>{
                sheet.insertRule($65545b2eb3978204$export$4fb8742b05de9693(duration), sheet.cssRules.length);
            });
            // Set a new delayed animation if loader hasn't finished after `${duration}` ms
            delayedAnimationTimer = setTimeout(()=>{
                if (!isRunning) return;
                isDelayed = true;
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$610cb442736abf53(), sheet.cssRules.length);
                    sheet.insertRule($65545b2eb3978204$export$959e9e99fba397f1($65545b2eb3978204$export$99d4e8974a739853()), sheet.cssRules.length);
                });
            }, $65545b2eb3978204$export$899393f3e23f724b);
            // Remove the loader if it hasn't finished after `${TIMEOUT_TIMER}` ms
            timeoutTimer = setTimeout(()=>{
                if (!isRunning) return;
                isRunning = false;
                isDelayed = false;
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                });
                clearTimeout(exitAnimationTimer);
                clearTimeout(delayedAnimationTimer);
                clearTimeout(timeoutTimer);
            }, $65545b2eb3978204$export$7868b416d8929c55);
        },
        FINISH: ()=>{
            if (!isRunning) return;
            isRunning = false;
            if (isDelayed) {
                isDelayed = false;
                clearTimeout(exitAnimationTimer);
                clearTimeout(timeoutTimer);
                clearTimeout(delayedAnimationTimer);
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                });
                return;
            }
            $65545b2eb3978204$var$browserFocusCheck(()=>{
                sheet.insertRule($65545b2eb3978204$export$5a43e0f09174e553(), sheet.cssRules.length);
            });
            exitAnimationTimer = setTimeout(()=>{
                clearTimeout(exitAnimationTimer);
                clearTimeout(timeoutTimer);
                clearTimeout(delayedAnimationTimer);
                $65545b2eb3978204$var$browserFocusCheck(()=>{
                    sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
                });
            }, $65545b2eb3978204$var$EXIT_ANIMATION_SPEED + 500);
        },
        RESET: ()=>{
            isRunning = false;
            isDelayed = false;
            clearTimeout(exitAnimationTimer);
            clearTimeout(delayedAnimationTimer);
            clearTimeout(timeoutTimer);
            $65545b2eb3978204$var$browserFocusCheck(()=>{
                sheet.insertRule($65545b2eb3978204$export$6beef8c645a63156(), sheet.cssRules.length);
            });
        }
    };
};
const $65545b2eb3978204$var$setupLoadingBarActionController = ()=>{
    const LOADER_STYLESHEET_ID = 'loaderStylesheet';
    // @ts-expect-error - TS2322 - Type 'HTMLElement | null' is not assignable to type 'HTMLStyleElement | null'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const styleSheet = document.getElementById(LOADER_STYLESHEET_ID);
    // SSR will not attach the stylesheet for routes not included in ALLOWED_ROUTES
    if (!styleSheet || !styleSheet.sheet) return;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JIRA_LOADING_BAR = $65545b2eb3978204$export$55d67d61d9d2ad3b(styleSheet);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.JIRA_LOADING_BAR && window.JIRA_LOADING_BAR.START) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JIRA_LOADING_BAR.START();
};
$65545b2eb3978204$var$setupLoadingBarActionController();

});
parcelRegister("61WP1", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $22b3d998cd498e5f$export$c47913ca32a5c6f7);
const $22b3d998cd498e5f$export$c47913ca32a5c6f7 = (name)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const node = document.querySelector(`meta[name="${name}"]`);
    const metaValue = node && node.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
};

});


parcelRegister("04unK", function(module, exports) {

$parcel$export(module.exports, "LOADER_STYLES_CSS_SELECTOR", () => $ac75ec265428b4c8$export$2a3dd4ccb7b0a764);
$parcel$export(module.exports, "LOADER_STYLESHEET_ID", () => $ac75ec265428b4c8$export$79456f717d4431da);
$parcel$export(module.exports, "getAllowedRoutes", () => $ac75ec265428b4c8$export$c82eb262b97a76f1);
$parcel$export(module.exports, "getLoadingBarColor", () => $ac75ec265428b4c8$export$cf3a5ed89e041425);

var $8QpSo = parcelRequire("8QpSo");

var $j8DrX = parcelRequire("j8DrX");
const $ac75ec265428b4c8$var$FIRST_RELEASE_ROUTES = [
    'issue',
    'issue-embed',
    'rapidboard-backlog',
    'rapidboard-board',
    'rapidboard-report',
    'your-work',
    'projects-directory',
    'boards-directory',
    'filters-directory',
    'dashboards-directory',
    'dashboards-directory-secure',
    'project-components',
    'project-pages',
    'project-versions',
    'software-boards',
    'software-backlog',
    'software-timeline',
    'software-roadmap',
    'software-roadmap-classic',
    'software-timeline-classic',
    'software-reports',
    'software-reports-burnup',
    'software-reports-burndown',
    'software-reports-cumulative',
    'software-reports-velocity',
    'issue-navigator',
    'global-issue-navigator',
    'issue-navigator-classic',
    'issue-navigator-core',
    'software-issue-navigator',
    'system-dashboard-edit'
];
const $ac75ec265428b4c8$export$2a3dd4ccb7b0a764 = 'body::before';
const $ac75ec265428b4c8$export$79456f717d4431da = 'loaderStylesheet';
const $ac75ec265428b4c8$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
const $ac75ec265428b4c8$export$c82eb262b97a76f1 = (0, $8QpSo.default)(()=>{
    const ALLOWED_ROUTES = $ac75ec265428b4c8$var$FIRST_RELEASE_ROUTES;
    return ALLOWED_ROUTES;
});
const $ac75ec265428b4c8$export$cf3a5ed89e041425 = (0, $8QpSo.default)(()=>(0, $j8DrX.default)('ajs-lf-navigation-highlightcolour') || $ac75ec265428b4c8$export$53d51cc6d57e44da);

});

parcelRegister("cYUbO", function(module, exports) {

$parcel$export(module.exports, "generateLoadingBarStyles", () => $e5278a73a699aa95$export$3036104bc81246b1);

var $gwIPs = parcelRequire("gwIPs");

var $04unK = parcelRequire("04unK");
const $e5278a73a699aa95$export$3036104bc81246b1 = (initalProgressValue, loadingBarColor)=>`
    content: '';
    display: block;
    background: ${loadingBarColor};
    height: 3px;
    z-index: ${(0, $gwIPs.layers).navigation + 10};
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    transform: scaleX(${initalProgressValue});
    transform-origin: 0 0;
    will-change: transform;
`;
const $e5278a73a699aa95$export$85e33a4b3d661500 = (initialProgressValue = 0.3)=>`
        <style id=${0, $04unK.LOADER_STYLESHEET_ID}>
            ${0, $04unK.LOADER_STYLES_CSS_SELECTOR} {${$e5278a73a699aa95$export$3036104bc81246b1(initialProgressValue, (0, $04unK.getLoadingBarColor)())}}
        </style>`;

});


parcelRegister("7Lkcv", function(module, exports) {

$parcel$export(module.exports, "SafeHelpPanel", () => $70a8cef9c47c5a71$export$cd2ada2fb14048fc);

var $5uXOq = parcelRequire("5uXOq");

var $89SaW = parcelRequire("89SaW");

var $7CMCs = parcelRequire("7CMCs");

var $6BNJk = parcelRequire("6BNJk");

var $kspz4 = parcelRequire("kspz4");


var $7dTw7 = parcelRequire("7dTw7");

var $1SVH7 = parcelRequire("1SVH7");

var $hsmeR = parcelRequire("hsmeR");

var $90yGq = parcelRequire("90yGq");
const $70a8cef9c47c5a71$var$HelpPanel = ()=>{
    const [{ navigationData: navigationData, releaseNotesNotifications: releaseNotesNotifications }, { setNavigationData: setNavigationData, setReleaseNotesNotifications: setReleaseNotesNotifications }] = (0, $kspz4.useHelpPanel)();
    const { closeRightSidebar: closeRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    const accountId = (0, $90yGq.useAccountId)();
    (0, $5uXOq.useEffect)(()=>{
        const restoreReleaseNotesNotifications = async ()=>{
            if (accountId) try {
                // @ts-expect-error - Property 'helpPanel' does not exist on type 'unknown'.
                const { helpPanel: userPropertiesHelpPanelValue } = await (0, $89SaW.getUserProperty)(accountId, (0, $0971f751295a2324$export$783d7c02e3a0cbf));
                setReleaseNotesNotifications(userPropertiesHelpPanelValue.releaseNotesNotifications);
            } catch (err) {
                /* getUserProperty throws if not found */ setReleaseNotesNotifications(0);
            }
            else setReleaseNotesNotifications(0);
        };
        restoreReleaseNotesNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7dTw7.RemoteStateUpdater), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1SVH7.LazyHelpPanel), {
        isOpen: !rightSidebarCurrentState?.isCollapsed,
        navigationData: navigationData,
        releaseNotesNotifications: releaseNotesNotifications,
        setNavigationData: setNavigationData,
        releaseNotesNotificationsSetter: setReleaseNotesNotifications,
        hasBeenRendered: !rightSidebarCurrentState?.isCollapsed,
        onCloseHelpPanel: closeRightSidebar
    }));
};
const $70a8cef9c47c5a71$var$HelpPanelInLayout = ()=>{
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
    const prevPanelIdRef = (0, $5uXOq.useRef)();
    const delayRef = (0, $5uXOq.useRef)(null);
    const panelId = rightSidebarCurrentState?.panelId;
    /**
	 * This use effect is used to add (when is necessary) a delay
	 * in the panelId => localPanelId syncing
	 */ (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $6BNJk.HELP_PANEL_ID)) {
            /**
			 * The right-sidebar is showing the help-panel...
			 */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
				 * and is open, not collapsed and we want to show a panel
				 * with an ID !== HELP_PANEL_ID
				 */ setLocalPanelId(panelId);
            else /**
				 * and we want to close it
				 */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
            }, 310);
        } else /**
			 * If the right sidebar is not showing the help-panel,
			 * we just keep localPanelId in sync with panelId
			 */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $6BNJk.HELP_PANEL_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($70a8cef9c47c5a71$var$HelpPanel, null);
};
const $70a8cef9c47c5a71$export$cd2ada2fb14048fc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-help-panel",
        packageName: "@atlassian/jira-help-panel-right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($70a8cef9c47c5a71$var$HelpPanelInLayout, null));

});
const $0971f751295a2324$export$783d7c02e3a0cbf = 'help_panel_ui_state';

parcelRegister("7dTw7", function(module, exports) {

$parcel$export(module.exports, "RemoteStateUpdater", () => $52205ad66fbf5dd9$export$3db011870dd4330f);

var $5uXOq = parcelRequire("5uXOq");

var $laWvb = parcelRequire("laWvb");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $90yGq = parcelRequire("90yGq");

var $kspz4 = parcelRequire("kspz4");

const $52205ad66fbf5dd9$var$DEBOUNCE_TIME = 1000;
const $52205ad66fbf5dd9$export$3db011870dd4330f = ()=>{
    // right-sidebar
    const [{ releaseNotesNotifications: releaseNotesNotifications }] = (0, $kspz4.useHelpPanel)();
    const [releaseNotesNotificationsTemp, setReleaseNotesNotificationsTemp] = (0, $5uXOq.useState)(releaseNotesNotifications);
    const accountId = (0, $90yGq.useAccountId)();
    const [debouncedUpdateData] = (0, $laWvb.default)(async (newReleaseNotesNotifications)=>{
        const remoteData = {
            helpPanel: {
                releaseNotesNotifications: newReleaseNotesNotifications
            }
        };
        if (accountId) try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $0971f751295a2324$export$783d7c02e3a0cbf), JSON.stringify(remoteData));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $jcw0u.default)({
                error: e,
                meta: {
                    id: 'updateServerHelpPanelState',
                    packageName: 'jiraHelpPanelServices',
                    teamName: 'self-help-experiences'
                }
            });
        }
    }, $52205ad66fbf5dd9$var$DEBOUNCE_TIME);
    (0, $5uXOq.useEffect)(()=>{
        if (releaseNotesNotificationsTemp !== releaseNotesNotifications) {
            setReleaseNotesNotificationsTemp(releaseNotesNotifications);
            debouncedUpdateData(releaseNotesNotifications);
        }
    }, [
        debouncedUpdateData,
        releaseNotesNotifications,
        releaseNotesNotificationsTemp
    ]);
    return null;
};

});
parcelRegister("laWvb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6a7e96a5e9b4bd2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $f6a7e96a5e9b4bd2$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $5uXOq.useRef)(null);
    var maxWaitArgs = (0, $5uXOq.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $5uXOq.useRef)(false);
    var functionTimeoutHandler = (0, $5uXOq.useRef)(null);
    var isComponentUnmounted = (0, $5uXOq.useRef)(false);
    var debouncedFunction = (0, $5uXOq.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $5uXOq.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $5uXOq.useEffect)(function() {
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $5uXOq.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $5uXOq.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});


parcelRegister("1SVH7", function(module, exports) {

$parcel$export(module.exports, "LazyHelpPanel", () => $311d1a0e95633292$export$51c79455aef7d178);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $7iJwP = parcelRequire("7iJwP");

var $6s1PB = parcelRequire("6s1PB");

var $lfTZh = parcelRequire("lfTZh");

var $cYlk7 = parcelRequire("cYlk7");

var $iXVV6 = parcelRequire("iXVV6");

var $Ix35T = parcelRequire("Ix35T");

var $jVpMq = parcelRequire("jVpMq");

var $7rrMi = parcelRequire("7rrMi");

var $4RupH = parcelRequire("4RupH");
const $311d1a0e95633292$export$51c79455aef7d178 = ({ navigationData: { articleId: articleId, history: history }, setNavigationData: setNavigationData, releaseNotesNotifications: releaseNotesNotifications, releaseNotesNotificationsSetter: releaseNotesNotificationsSetter, isOpen: isOpen, onCloseHelpPanel: onCloseHelpPanel, hasBeenRendered: hasBeenRendered, routeGroup: routeGroup, routeName: routeName })=>{
    const user = (0, $cYlk7.useCurrentUser)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "help-panel",
        packageName: "jiraHelpPanel",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jVpMq.default), {
                loadingArticle: articleId.id !== ''
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "root",
        packageName: "jiraHelpPanel",
        teamName: "self-help-experiences"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rrMi.SearchContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        tags: [
            'iph'
        ],
        sourceName: "jiraHelpPanel",
        sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
        attributes: {
            searchService: (0, $6s1PB.expVal)('20240422_self_help_iph_ms3_expt', 'iph_ms3_experience_display_flag', false) ? 'help-aggregator' : 'algolia',
            routeGroup: routeGroup,
            routeName: routeName,
            userId: user?.data?.user?.accountId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Ix35T.LazyWait), {
        until: hasBeenRendered
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-lazy-help-panel",
        fallback: isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jVpMq.default), {
            loadingArticle: articleId.id !== ''
        }) : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4RupH.AsyncLazyHelpPanel), {
        navigationData: {
            articleId: articleId,
            history: history
        },
        releaseNotesNotificationsSetter: releaseNotesNotificationsSetter,
        releaseNotesNotifications: releaseNotesNotifications,
        setNavigationData: setNavigationData,
        isOpen: isOpen,
        onCloseHelpPanel: onCloseHelpPanel,
        routeGroup: routeGroup,
        routeName: routeName
    })))))));
};

});
parcelRegister("jVpMq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8bb188482996cb7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5CrlE = parcelRequire("5CrlE");
const $b8bb188482996cb7$var$HelpPanelLoading = ({ loadingArticle: loadingArticle = false })=>loadingArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5CrlE.HelpPanelContainerV2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$HeaderLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "img",
        "aria-label": "help panel loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-250, 20px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "90%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "70%"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5CrlE.HelpPanelContainerV2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$HeaderLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-500, 40px)",
        marginTop: "var(--ds-space-100, 8px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleList, {
        role: "img"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8bb188482996cb7$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })))));
var $b8bb188482996cb7$export$2e2bcd8739ae039 = $b8bb188482996cb7$var$HelpPanelLoading;
/**
 * Header
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b8bb188482996cb7$var$LoadingContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $b8bb188482996cb7$var$HeaderLoading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zlnq84 _4t3ixncg _bfhkfg4m _1bah1yb4 _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $b8bb188482996cb7$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b8bb188482996cb7$var$LoadingRectangle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { contentHeight: contentHeight, marginTop: marginTop, contentWidth: contentWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_l7mdyr": (0, $lD23V.default)(__cmplp.contentHeight),
            "--_1fj4wta": (0, $lD23V.default)(__cmplp.marginTop),
            "--_7n1eiw": (0, $lD23V.default)(__cmplp.contentWidth)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkov77o _kqswh2mm _5sag126j _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhk1v33 _1itkaioo _12vemgnk",
            __cmplp.contentHeight != null ? "_4t3i6c59" : "_4t3ipxbi",
            __cmplp.marginTop != null ? "_19pkmye1" : "_19pku2gc",
            __cmplp.contentWidth != null ? "_1bsbwd3v" : "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $b8bb188482996cb7$var$LoadignArticleList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _19pku2gc _2hwxidpf _otyridpf _18u0idpf _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _vchhusvi",
            __cmplp.className
        ])
    });
});
const $b8bb188482996cb7$var$LoadignArticleListItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _1bsb1osq _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5CrlE", function(module, exports) {

$parcel$export(module.exports, "HelpPanelContainer", () => $2dbd0534194918a8$export$37cd645d7678f7d4);
$parcel$export(module.exports, "HelpPanelContainerV2", () => $2dbd0534194918a8$export$1df7e3ebfc4c9b06);
$parcel$export(module.exports, "HelpPanelSectionMessageContainer", () => $2dbd0534194918a8$export$9f6251c714594f23);
$parcel$export(module.exports, "HelpPanelContentContainer", () => $2dbd0534194918a8$export$1cdb922eed7271d1);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $2dbd0534194918a8$export$37cd645d7678f7d4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1kl7pu5c _vchhusvi _2lx21bp4 _1bsb1feq _4t3i1osq _kqsw1n9t",
            __cmplp.className
        ])
    });
});
const $2dbd0534194918a8$export$1df7e3ebfc4c9b06 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $2dbd0534194918a8$export$37cd645d7678f7d4, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1i8v _bfhk1bhr",
            __cmplp.className
        ])
    });
});
const $2dbd0534194918a8$export$9f6251c714594f23 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _ca0qpxbi _u5f3pxbi _n3tdidpf _19bvpxbi _1bsb1osq _vchhusvi",
            __cmplp.className
        ])
    });
});
const $2dbd0534194918a8$export$1cdb922eed7271d1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1tkeidpf _kqswh2mm _18m91wug _1reo15vq _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ae4v1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});

});


parcelRegister("7rrMi", function(module, exports) {

$parcel$export(module.exports, "useSearchContext", () => $c0047fc735c61769$export$67b98b1b880a048b);
$parcel$export(module.exports, "SearchContextProvider", () => $c0047fc735c61769$export$6bd70292443463a4);

var $5uXOq = parcelRequire("5uXOq");

var $jFLAi = parcelRequire("jFLAi");
const [$c0047fc735c61769$export$67b98b1b880a048b, $c0047fc735c61769$export$70af50e847ce290a] = (0, $jFLAi.createCtx)();
const $c0047fc735c61769$export$6bd70292443463a4 = ({ children: children })=>{
    const [searchContext, setSearchContext] = (0, $5uXOq.useState)({});
    const addClickedArticleIds = (0, $5uXOq.useCallback)((query, clickedArticleId)=>{
        setSearchContext((prev)=>({
                ...prev,
                [query]: {
                    ...prev[query],
                    clickedArticleIds: prev[query]?.clickedArticleIds ? [
                        ...prev[query].clickedArticleIds,
                        clickedArticleId
                    ] : [
                        clickedArticleId
                    ]
                }
            }));
    }, []);
    const addFetchedArticleIds = (0, $5uXOq.useCallback)((query, fetchedArticles)=>{
        setSearchContext((prev)=>({
                ...prev,
                [query]: {
                    ...prev[query],
                    fetchedArticleIds: fetchedArticles
                }
            }));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c0047fc735c61769$export$70af50e847ce290a, {
        value: {
            searchContext: searchContext,
            addClickedArticleIds: addClickedArticleIds,
            addFetchedArticleIds: addFetchedArticleIds
        }
    }, children);
};

});
parcelRegister("jFLAi", function(module, exports) {

$parcel$export(module.exports, "createCtx", () => $b612e461f4fc901f$export$d653a1a643c9a98c);

var $5uXOq = parcelRequire("5uXOq");
function $b612e461f4fc901f$export$d653a1a643c9a98c() {
    const ctx = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
    function useCtx() {
        const c = (0, $5uXOq.useContext)(ctx);
        if (!c) throw new Error('useCtx must be inside a Provider with a value');
        return c;
    }
    return [
        useCtx,
        ctx.Provider
    ];
}

});


parcelRegister("4RupH", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyHelpPanel", () => $4ce54108d7c5ac07$export$7ff46d33d0f13518);

var $b7Svb = parcelRequire("b7Svb");

const $4ce54108d7c5ac07$export$7ff46d33d0f13518 = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("5ERpX")).then(({ HelpPanel: HelpPanel })=>HelpPanel), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/help-panel/src/ui/index.tsx"
});

});
parcelRegister("5ERpX", function(module, exports) {

let $41ea1fd0ee281786$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $41ea1fd0ee281786$var$load("h2MrD"),
    $41ea1fd0ee281786$var$load("bYT2S"),
    $41ea1fd0ee281786$var$load("hPzOn"),
    $41ea1fd0ee281786$var$load("cBrFc")
]).then(()=>parcelRequire('jj3on'));

});




parcelRegister("9YvQF", function(module, exports) {

$parcel$export(module.exports, "SafeEmbeddedConfluencePanel", () => $3e89344d89118823$export$2d901a489872dd0d);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $9KYrx = parcelRequire("9KYrx");

var $gXSrH = parcelRequire("gXSrH");

var $7CMCs = parcelRequire("7CMCs");

var $hsmeR = parcelRequire("hsmeR");

var $9V9QO = parcelRequire("9V9QO");
const $3e89344d89118823$var$DELAY = 310;
const $3e89344d89118823$export$2db0a2e0275af8b8 = ()=>{
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    const [{ panel: isOpen }] = (0, $gXSrH.useEmbeddedConfluenceSidePanel)();
    const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
    const prevPanelIdRef = (0, $5uXOq.useRef)();
    const delayRef = (0, $5uXOq.useRef)(null);
    const panelId = rightSidebarCurrentState?.panelId;
    const { entryPointActions: entryPointActions, entryPoint: entryPoint } = (0, $9V9QO.useEmbeddedPanelEntryPoint)();
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen) entryPointActions?.load();
    }, [
        isOpen,
        entryPointActions,
        localPanelId
    ]);
    /**
	 * This use effect is used to add (when is necessary) a delay
	 * in the panelId => localPanelId syncing
	 */ (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $9KYrx.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) {
            /**
			 * The right-sidebar is showing the embedded confluence content...
			 */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
				 * and is open, not collapsed and we want to show a panel
				 * with an ID !== EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID
				 */ setLocalPanelId(panelId);
            else /**
				 * and we want to close it
				 */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
            // TODO: trigger close analytics event
            }, $3e89344d89118823$var$DELAY);
        } else /**
			 * If the right sidebar is not showing the embedded confluence content,
			 * we just keep localPanelId in sync with panelId
			 */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $9KYrx.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $3e89344d89118823$var$panelStyles
    }, entryPoint);
};
const $3e89344d89118823$export$2d901a489872dd0d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-embedded-confluence-panel",
        packageName: "jiraIssueCreateConfluenceContent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gXSrH.EmbeddedConfluenceSidepanelContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3e89344d89118823$export$2db0a2e0275af8b8, null)));
const $3e89344d89118823$var$panelStyles = (0, $2s57o.xcss)({
    padding: 'space.100',
    height: 'calc(100vh - (var(--topNavigationHeight, 0px) + var(--bannerHeight, 0px)))'
});

});
parcelRegister("9KYrx", function(module, exports) {

$parcel$export(module.exports, "ConfluenceFeatureKeys", () => $e486b17128606747$export$746d4746bf07dd70);
$parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_KEY", () => $e486b17128606747$export$6247c7e19b71f4e);
$parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_KEY", () => $e486b17128606747$export$e34c4c923d934e7a);
$parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_PROVIDER_KEY", () => $e486b17128606747$export$ffe60197eb59ca73);
$parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY", () => $e486b17128606747$export$8d0c4a26241944b8);
$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID", () => $e486b17128606747$export$a497288e64e9a343);
const $e486b17128606747$export$746d4746bf07dd70 = {
    ENABLE_CONFLUENCE_SIGNUP: 'jira.admin.confluence.enable-integrations',
    SPRINT_RETRO: 'jira.admin.confluence.enable-sprint-retros',
    CREATE_MENU_TOP_ACTIONS: 'jira.admin.confluence.enable-content-creation-issue-top-actions',
    CREATE_MENU_CONFLUENCE_CONTENT: 'jira.admin.confluence.enable-content-creation-issue-confluence-content'
};
const $e486b17128606747$export$6247c7e19b71f4e = 'confluence-integration-controls';
const $e486b17128606747$export$e34c4c923d934e7a = 'user-confluence-access';
const $e486b17128606747$export$ffe60197eb59ca73 = 'confluence-integration-controls-session-storage';
const $e486b17128606747$export$8d0c4a26241944b8 = 'confluence-permissions-session-storage';
const $e486b17128606747$export$a497288e64e9a343 = 'embedded-confluence-panel-container';

});

parcelRegister("gXSrH", function(module, exports) {

$parcel$export(module.exports, "EmbeddedConfluenceSidepanelContainer", () => $27a5db923b3bcebb$export$a5c1c168018f0f16);
$parcel$export(module.exports, "useEmbeddedConfluenceSidePanel", () => $27a5db923b3bcebb$export$518aeea31a00450e);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $2gCtH = parcelRequire("2gCtH");

var $hsmeR = parcelRequire("hsmeR");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $9KYrx = parcelRequire("9KYrx");

var $aQLD7 = parcelRequire("aQLD7");

var $bvqNo = parcelRequire("bvqNo");

var $5labn = parcelRequire("5labn");
/**
 * Container for {@link useEmbeddedConfluenceSidePanel}. Any component that uses this hook
 * must be wrapped in this container.
 */ const $27a5db923b3bcebb$var$Container = (0, $gg7kZ.createContainer)();
const $27a5db923b3bcebb$var$DefaultStore = (0, $iXqE5.createStore)({
    actions: $aQLD7.actions,
    containedBy: $27a5db923b3bcebb$var$Container,
    initialState: $aQLD7.initialState,
    name: (0, $9KYrx.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)
});
const $27a5db923b3bcebb$var$NonContainerStore = (0, $iXqE5.createStore)({
    actions: $aQLD7.actions,
    initialState: $aQLD7.initialState,
    name: (0, $9KYrx.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)
});
const $27a5db923b3bcebb$export$a5c1c168018f0f16 = ({ children: children })=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    /*
	In order for each usage of the store to manage the same state irregardless of
	their location in the component tree, we need to wrap components in a container
	with the same scope value. This is why we use the issueKey in the scope value.
	see https://atlassian.github.io/react-sweet-state/#/advanced/container?id=scoped-data-sharing
	for more information about scoped data sharing.

	*/ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($27a5db923b3bcebb$var$Container, {
        scope: `embedded-confluence-sidepanel-${issueKey}`
    }, children);
};
const $27a5db923b3bcebb$var$defaultStoreHook = (0, $3sQ5x.createHook)($27a5db923b3bcebb$var$DefaultStore);
const $27a5db923b3bcebb$var$nonContainerStoreHook = (0, $3sQ5x.createHook)($27a5db923b3bcebb$var$NonContainerStore);
const $27a5db923b3bcebb$export$518aeea31a00450e = (embeddedConfluenceSource)=>{
    /*
		The condition below is a temporary workaround for the Side Panel experiment to avoid
		throwing an error when the Store is not contained by a container. This logic should be removed
		once the experiment has been productionized: https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/jira_issue_view_side_by_side_modeless_ep
	*/ const [embedConfluenceSidepanelConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_issue_view_side_by_side_modeless_ep_exp');
    const isInExperiment = embedConfluenceSidepanelConfig.get('cohort', 'not-enrolled') === 'experiment';
    const [state, { closeSidePanel: closeSidePanelAction, openSidePanel: openSidePanelAction, setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection, setDeferredSpaceData: setDeferredSpaceData, toggleExpandedState: toggleExpandedState, setIsDraftState: setIsDraftState, setConfluenceData: setConfluenceData }] = isInExperiment ? $27a5db923b3bcebb$var$defaultStoreHook() : $27a5db923b3bcebb$var$nonContainerStoreHook();
    const { closeRightSidebar: closeRightSidebar, openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const openSidePanel = (0, $5uXOq.useCallback)(({ contentId: contentId, contentType: contentType, data: data, hostname: hostname, isDraft: isDraft, isLive: isLive, onLinkPage: onLinkPage, onPublish: onPublish, openInModal: openInModal, mode: mode, url: url, title: title })=>{
        const { initialWidth: initialWidth, displayType: displayType } = (0, $5labn.getDisplayInformation)();
        const shouldOpenPanel = displayType === (0, $bvqNo.DisplayTypes).PANEL;
        if (shouldOpenPanel) {
            openSidePanelAction({
                contentId: contentId,
                contentType: contentType,
                embeddedConfluenceSource: embeddedConfluenceSource,
                data: data,
                displayType: displayType,
                initialWidth: initialWidth,
                hostname: hostname,
                isDraft: isDraft,
                isLive: isLive,
                mode: mode,
                onLinkPage: onLinkPage,
                onPublish: onPublish,
                shouldOpenModal: !shouldOpenPanel,
                url: url,
                title: title
            });
            openRightSidebar((0, $9KYrx.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID), initialWidth, false, true);
        } else openInModal();
    }, [
        embeddedConfluenceSource,
        openRightSidebar,
        openSidePanelAction
    ]);
    const closeSidePanel = (0, $5uXOq.useCallback)(()=>{
        closeRightSidebar((0, $9KYrx.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID));
        closeSidePanelAction();
    }, [
        closeRightSidebar,
        closeSidePanelAction
    ]);
    return [
        state,
        {
            openSidePanel: openSidePanel,
            closeSidePanel: closeSidePanel,
            setDeferredSpaceData: setDeferredSpaceData,
            setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection,
            toggleExpandedState: toggleExpandedState,
            setIsDraftState: setIsDraftState,
            setConfluenceData: setConfluenceData
        }
    ];
};

});
parcelRegister("2gCtH", function(module, exports) {

$parcel$export(module.exports, "useChildIssuesLimit", () => $9e67f38435565e11$export$8d75f312eaa63aec);
$parcel$export(module.exports, "useChildIssuesIssueLimitUrl", () => $9e67f38435565e11$export$65a59acd1ffc5bba);
$parcel$export(module.exports, "useIsModal", () => $9e67f38435565e11$export$9ce8428ff198804a);
$parcel$export(module.exports, "useIssueKey", () => $9e67f38435565e11$export$22108eca27445997);
$parcel$export(module.exports, "useIssueId", () => $9e67f38435565e11$export$9df8176b5ffce5ab);
$parcel$export(module.exports, "useIsArchived", () => $9e67f38435565e11$export$7cd1821433aafaee);
$parcel$export(module.exports, "useIsClassifyEditEnabled", () => $9e67f38435565e11$export$b23b36ed5c42e920);
$parcel$export(module.exports, "useProjectKey", () => $9e67f38435565e11$export$f87be37f8e8be65);
$parcel$export(module.exports, "useAnalyticsSource", () => $9e67f38435565e11$export$aad3917152559b87);
$parcel$export(module.exports, "useIssueContextActions", () => $9e67f38435565e11$export$d6ec1293313f49ac);
$parcel$export(module.exports, "useRapidViewMap", () => $9e67f38435565e11$export$4d204e800e4e0be7);
$parcel$export(module.exports, "useEstimationStatistic", () => $9e67f38435565e11$export$5b20e30ee6db56e9);
$parcel$export(module.exports, "useViewMode", () => $9e67f38435565e11$export$3a7c3e259b6adb93);
$parcel$export(module.exports, "useBackButtonUrl", () => $9e67f38435565e11$export$cfe64a334903927c);
$parcel$export(module.exports, "useIssueNavigatorData", () => $9e67f38435565e11$export$aa008a00bae7e7ab);
$parcel$export(module.exports, "useOnIssueKeyChange", () => $9e67f38435565e11$export$52c975cf0b623556);
$parcel$export(module.exports, "useRapidViewId", () => $9e67f38435565e11$export$b34d0ea0bf41fee);
$parcel$export(module.exports, "useViewScreenId", () => $9e67f38435565e11$export$7c142b5701b4c3f9);
$parcel$export(module.exports, "useHasSoftwareAccess", () => $9e67f38435565e11$export$dcc0d1c3cd4bd9fb);
$parcel$export(module.exports, "useIsFullPageIssueView", () => $9e67f38435565e11$export$2e131fc4108f9106);
$parcel$export(module.exports, "useIsEmbedPageIssueView", () => $9e67f38435565e11$export$4596c26005fbb859);
$parcel$export(module.exports, "useIsAiEnabledForIssue", () => $9e67f38435565e11$export$db5174c7538abe4b);
$parcel$export(module.exports, "useIsJiraIssue", () => $9e67f38435565e11$export$cf5fc815f761fb4b);

var $5uXOq = parcelRequire("5uXOq");


var $2vSU6 = parcelRequire("2vSU6");

var $4Pf62 = parcelRequire("4Pf62");

var $93Yeu = parcelRequire("93Yeu");

var $g5X3G = parcelRequire("g5X3G");

var $ef5Xn = parcelRequire("ef5Xn");

var $7trqb = parcelRequire("7trqb");

var $hqBSi = parcelRequire("hqBSi");

var $koiRX = parcelRequire("koiRX");
const $9e67f38435565e11$export$8d75f312eaa63aec = ()=>{
    const [childIssuesLimit] = (0, $koiRX.useIssueContextStoreChildIssuesLimit)();
    return childIssuesLimit;
};
const $9e67f38435565e11$export$cc6e0a43a2a9b17a = ()=>{
    const [childIssuesIssueLimitUrls] = (0, $koiRX.useIssueContextStoreChildIssuesIssueLimitUrls)();
    return childIssuesIssueLimitUrls;
};
const $9e67f38435565e11$export$65a59acd1ffc5bba = (fieldId)=>{
    const childIssuesIssueLimitUrls = $9e67f38435565e11$export$cc6e0a43a2a9b17a();
    return childIssuesIssueLimitUrls?.[fieldId];
};
const $9e67f38435565e11$export$9ce8428ff198804a = ()=>{
    const [isModal] = (0, $koiRX.useIssueContextStoreIsModal)();
    return isModal;
};
const $9e67f38435565e11$export$22108eca27445997 = ()=>{
    const [issueKey] = (0, $koiRX.useIssueContextStoreIssueKey)();
    return issueKey;
};
const $9e67f38435565e11$export$9df8176b5ffce5ab = ()=>{
    const [issueId] = (0, $koiRX.useIssueContextStoreIssueId)();
    return issueId;
};
const $9e67f38435565e11$export$7cd1821433aafaee = ()=>{
    const [isArchived] = (0, $koiRX.useIssueContextStoreIsArchived)();
    return isArchived;
};
const $9e67f38435565e11$export$b23b36ed5c42e920 = ()=>{
    const [isClassifyEditEnabled] = (0, $koiRX.useIssueContextStoreIsClassifyEditEnabled)();
    return isClassifyEditEnabled;
};
const $9e67f38435565e11$export$f87be37f8e8be65 = ()=>{
    const [issueKey] = (0, $koiRX.useIssueContextStoreIssueKey)();
    return (0, $g5X3G.toProjectKey)(issueKey.split('-')[0]);
};
const $9e67f38435565e11$export$aad3917152559b87 = ()=>{
    const [analyticsSource] = (0, $koiRX.useIssueContextStoreAnalyticsSource)();
    return analyticsSource;
};
const $9e67f38435565e11$export$d6ec1293313f49ac = ()=>{
    const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, $koiRX.useIssueContextStoreActions)();
    const actions = (0, $5uXOq.useMemo)(()=>({
            setIssueContext: setIssueContext,
            mergeIssueContext: mergeIssueContext,
            getChildIssuesLimit: getChildIssuesLimit,
            getMaxTokenLength: getMaxTokenLength,
            getIsLoadedWithPage: getIsLoadedWithPage,
            getBackButtonUrl: getBackButtonUrl,
            getIsSpaEnabled: getIsSpaEnabled,
            getIssueKey: getIssueKey,
            setDetailViewAsModal: setDetailViewAsModal,
            setDetailViewAsSidebar: setDetailViewAsSidebar,
            resetDetailView: resetDetailView
        }), [
        setIssueContext,
        mergeIssueContext,
        getChildIssuesLimit,
        getMaxTokenLength,
        getIsLoadedWithPage,
        getBackButtonUrl,
        getIsSpaEnabled,
        getIssueKey,
        setDetailViewAsModal,
        setDetailViewAsSidebar,
        resetDetailView
    ]);
    return [
        undefined,
        actions
    ];
};
const $9e67f38435565e11$export$4d204e800e4e0be7 = ()=>{
    const [rapidViewMap] = (0, $koiRX.useIssueContextRapidViewMap)();
    return rapidViewMap;
};
const $9e67f38435565e11$export$e0d7666ae716c88a = ()=>{
    const [maxTokenLength] = (0, $koiRX.useIssueContextStoreMaxTokenLength)();
    return maxTokenLength;
};
const $9e67f38435565e11$export$b4199f923267161e = ()=>{
    const [isLoadedWithPage] = (0, $koiRX.useIssueContextStoreIsLoadedWithPage)();
    return isLoadedWithPage;
};
const $9e67f38435565e11$export$5b20e30ee6db56e9 = ()=>{
    const [estimationStatistic] = (0, $koiRX.useIssueContextStoreEstimationStatistic)();
    return estimationStatistic;
};
const $9e67f38435565e11$export$4dface15d86304a4 = ()=>{
    const [isLoading] = (0, $koiRX.useIssueContextStoreIsLoading)();
    return isLoading;
};
const $9e67f38435565e11$export$3a7c3e259b6adb93 = ()=>{
    const [viewMode] = (0, $koiRX.useIssueContextStoreViewMode)();
    return viewMode;
};
const $9e67f38435565e11$export$cfe64a334903927c = ()=>{
    const [backButtonUrl] = (0, $koiRX.useIssueContextStoreBackButtonUrl)();
    return backButtonUrl;
};
const $9e67f38435565e11$export$aa008a00bae7e7ab = ()=>{
    const [issueNavigatorData] = (0, $koiRX.useIssueContextStoreIssueNavigatorData)();
    return issueNavigatorData;
};
const $9e67f38435565e11$export$b49754504c41149f = ()=>{
    const [boardId] = (0, $koiRX.useIssueContextStoreBoardId)();
    return boardId;
};
const $9e67f38435565e11$export$91aab984882a2a2c = ()=>{
    const [boardType] = (0, $koiRX.useIssueContextStoreBoardType)();
    return boardType;
};
const $9e67f38435565e11$export$dbad9dbd4871f2e9 = ()=>{
    const [isSpaEnabled] = (0, $koiRX.useIssueContextStoreIsSpaEnabled)();
    return isSpaEnabled;
};
const $9e67f38435565e11$export$7be495880d433ab9 = ()=>{
    const [loginRedirectUrl] = (0, $koiRX.useIssueContextStoreLoginRedirctUrl)();
    return loginRedirectUrl;
};
const $9e67f38435565e11$export$52c975cf0b623556 = ()=>{
    const [onIssueKeyChange] = (0, $koiRX.useIssueContextStoreOnIssueKeyChange)();
    return onIssueKeyChange;
};
const $9e67f38435565e11$export$b34d0ea0bf41fee = ()=>{
    const [rapidViewId] = (0, $koiRX.useIssueContextStoreRapidViewId)();
    return rapidViewId;
};
const $9e67f38435565e11$export$7c142b5701b4c3f9 = ()=>{
    const [viewScreenId] = (0, $koiRX.useIssueContextStoreViewScreenId)();
    return viewScreenId;
};
const $9e67f38435565e11$export$dcc0d1c3cd4bd9fb = ()=>{
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const licenseStates = (0, $7trqb.useLicenseStates)();
    const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $ef5Xn.LICENSE_STATE_ACTIVE);
    return licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
};
const $9e67f38435565e11$export$2e131fc4108f9106 = ()=>{
    const analyticsSource = $9e67f38435565e11$export$aad3917152559b87();
    return analyticsSource === (0, $fcf97b7a09088940$export$b19f949fb9713614);
};
const $9e67f38435565e11$export$4596c26005fbb859 = ()=>{
    const analyticsSource = $9e67f38435565e11$export$aad3917152559b87();
    return analyticsSource === (0, $fcf97b7a09088940$export$a5132300c5214280);
};
const $9e67f38435565e11$export$db5174c7538abe4b = ()=>{
    const [isAiEnabledForIssue] = (0, $koiRX.useIssueContextIsAiEnabledForIssue)();
    return isAiEnabledForIssue;
};
const $9e67f38435565e11$export$cf5fc815f761fb4b = ()=>{
    const issueKey = $9e67f38435565e11$export$22108eca27445997();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    return [
        (0, $2vSU6.SOFTWARE_PROJECT),
        (0, $2vSU6.CORE_PROJECT)
    ].some((type)=>type === projectType);
};

});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$2dac1950892123f5 = 'jiraTimeline';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';
const $fcf97b7a09088940$export$5f3c20fe2ff6c0a2 = 'staffing-issue';

parcelRegister("7trqb", function(module, exports) {

$parcel$export(module.exports, "useLicenseStates", () => $5fcaa3f734e9c444$export$268651a63abe408a);

var $9OXo1 = parcelRequire("9OXo1");
const $5fcaa3f734e9c444$export$268651a63abe408a = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.licenseStates;
};

});

parcelRegister("koiRX", function(module, exports) {

$parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", () => $35da250daae5206d$export$abdbea56d86b4aac);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", () => $35da250daae5206d$export$326ff2b963d51c5c);
$parcel$export(module.exports, "useIssueContextStoreIssueKey", () => $35da250daae5206d$export$44bcaaabb74e402b);
$parcel$export(module.exports, "useIssueContextStoreIssueId", () => $35da250daae5206d$export$332dcee0cf9f4e45);
$parcel$export(module.exports, "useIssueContextStoreIsArchived", () => $35da250daae5206d$export$c940355b1fc6e1c4);
$parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", () => $35da250daae5206d$export$b9eebaa1da421997);
$parcel$export(module.exports, "useIssueContextStoreIsModal", () => $35da250daae5206d$export$daa47fd600e43a32);
$parcel$export(module.exports, "useIssueContextStoreViewScreenId", () => $35da250daae5206d$export$ba2e9546ab5ba6f);
$parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", () => $35da250daae5206d$export$74d38d6c437efc1b);
$parcel$export(module.exports, "useIssueContextRapidViewMap", () => $35da250daae5206d$export$2092528ee170d9e7);
$parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", () => $35da250daae5206d$export$57898374e6239a5a);
$parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", () => $35da250daae5206d$export$ff0264ec4c015dc1);
$parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", () => $35da250daae5206d$export$6c8b81f6dca8c23d);
$parcel$export(module.exports, "useIssueContextStoreIsLoading", () => $35da250daae5206d$export$fe7085456138f0fc);
$parcel$export(module.exports, "useIssueContextStoreViewMode", () => $35da250daae5206d$export$c339e36468c12443);
$parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", () => $35da250daae5206d$export$ef3bfa2642bb98cd);
$parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", () => $35da250daae5206d$export$8accd063c74cd455);
$parcel$export(module.exports, "useIssueContextStoreBoardId", () => $35da250daae5206d$export$e7edffc2a20027e7);
$parcel$export(module.exports, "useIssueContextStoreBoardType", () => $35da250daae5206d$export$48aaa3a6bc2085d7);
$parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", () => $35da250daae5206d$export$4a4b96bcf5166327);
$parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", () => $35da250daae5206d$export$bbd8ba0180545556);
$parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", () => $35da250daae5206d$export$aaa89627762c7d00);
$parcel$export(module.exports, "useIssueContextStoreRapidViewId", () => $35da250daae5206d$export$796589b0ec52848a);
$parcel$export(module.exports, "useIssueContextIsAiEnabledForIssue", () => $35da250daae5206d$export$455ae7fd9d68b157);
$parcel$export(module.exports, "IssueContextContainer", () => $35da250daae5206d$export$93db6a8f3342dddf);
$parcel$export(module.exports, "useIssueContextStoreActions", () => $35da250daae5206d$export$965360ae27fcae98);

var $g5X3G = parcelRequire("g5X3G");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $fMAcJ = parcelRequire("fMAcJ");

var $iElCl = parcelRequire("iElCl");

var $edJtc = parcelRequire("edJtc");
const $35da250daae5206d$export$d4c72bab9d6cc13a = {
    childIssuesLimit: undefined,
    childIssuesIssueLimitUrls: undefined,
    issueKey: (0, $g5X3G.toIssueKey)(''),
    isArchived: false,
    isClassifyEditEnabled: false,
    isModal: false,
    maxTokenLength: 0,
    isLoadedWithPage: false,
    rapidViewMap: undefined,
    estimationStatistic: undefined,
    isLoading: false,
    // initialise viewMode with the value stored in local storage
    viewMode: (0, $edJtc.getViewModeFromLocalStorage)(),
    analyticsSource: undefined,
    backButtonUrl: undefined,
    issueNavigatorData: undefined,
    boardId: undefined,
    boardType: undefined,
    isSpaEnabled: false,
    loginRedirectUrl: undefined,
    onIssueKeyChange: undefined,
    rapidViewId: undefined,
    viewScreenId: undefined,
    isAiOptInEnabled: false,
    isAiEnabledForIssue: false
};
const $35da250daae5206d$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-context',
    initialState: $35da250daae5206d$export$d4c72bab9d6cc13a,
    actions: $fMAcJ.actions
});
const $35da250daae5206d$var$getIssueContext = (state)=>state;
const $35da250daae5206d$var$getIsModal = (state)=>state.isModal;
const $35da250daae5206d$var$getIssueKey = (state)=>state.issueKey;
const $35da250daae5206d$var$getIsArchived = (state)=>state.isArchived;
const $35da250daae5206d$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
const $35da250daae5206d$var$getIssueId = (state)=>state.issueId;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $35da250daae5206d$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
const $35da250daae5206d$var$getRapidViewMap = (state)=>state.rapidViewMap;
const $35da250daae5206d$var$getMaxTokenLength = (state)=>state.maxTokenLength;
const $35da250daae5206d$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
const $35da250daae5206d$var$getEstimationStatistic = (state)=>state.estimationStatistic;
const $35da250daae5206d$var$getIsLoading = (state)=>state.isLoading;
const $35da250daae5206d$var$getViewMode = (state)=>state.viewMode;
const $35da250daae5206d$var$getBackButtonUrl = (state)=>state.backButtonUrl;
const $35da250daae5206d$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
const $35da250daae5206d$var$getBoardId = (state)=>state.boardId;
const $35da250daae5206d$var$getBoardType = (state)=>state.boardType;
const $35da250daae5206d$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
const $35da250daae5206d$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
const $35da250daae5206d$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
const $35da250daae5206d$var$getRapidViewId = (state)=>state.rapidViewId;
const $35da250daae5206d$var$getViewScreenId = (state)=>state.viewScreenId;
const $35da250daae5206d$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
const $35da250daae5206d$var$getisAiEnabledForIssue = (state)=>Boolean(state.isAiEnabledForIssue);
const $35da250daae5206d$export$f6e0a3ee03299fbc = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueContext
});
const $35da250daae5206d$export$abdbea56d86b4aac = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: (0, $iElCl.getChildIssuesLimit)
});
const $35da250daae5206d$export$326ff2b963d51c5c = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: (0, $iElCl.getChildIssuesIssueLimitUrls)
});
const $35da250daae5206d$export$44bcaaabb74e402b = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueKey
});
const $35da250daae5206d$export$332dcee0cf9f4e45 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueId
});
const $35da250daae5206d$export$c940355b1fc6e1c4 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsArchived
});
const $35da250daae5206d$export$b9eebaa1da421997 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsClassifyEditEnabled
});
const $35da250daae5206d$export$daa47fd600e43a32 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsModal
});
const $35da250daae5206d$export$ba2e9546ab5ba6f = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getViewScreenId
});
const $35da250daae5206d$export$74d38d6c437efc1b = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getAnalyticsSource
});
const $35da250daae5206d$export$2092528ee170d9e7 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getRapidViewMap
});
const $35da250daae5206d$export$57898374e6239a5a = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getMaxTokenLength
});
const $35da250daae5206d$export$ff0264ec4c015dc1 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsLoadedWithPage
});
const $35da250daae5206d$export$6c8b81f6dca8c23d = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getEstimationStatistic
});
const $35da250daae5206d$export$fe7085456138f0fc = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsLoading
});
const $35da250daae5206d$export$c339e36468c12443 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getViewMode
});
const $35da250daae5206d$export$ef3bfa2642bb98cd = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getBackButtonUrl
});
const $35da250daae5206d$export$8accd063c74cd455 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIssueNavigatorData
});
const $35da250daae5206d$export$e7edffc2a20027e7 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getBoardId
});
const $35da250daae5206d$export$48aaa3a6bc2085d7 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getBoardType
});
const $35da250daae5206d$export$4a4b96bcf5166327 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsSpaEnabled
});
const $35da250daae5206d$export$bbd8ba0180545556 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getLoginRedirectUrl
});
const $35da250daae5206d$export$aaa89627762c7d00 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getOnIssueKeyChange
});
const $35da250daae5206d$export$796589b0ec52848a = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getRapidViewId
});
const $35da250daae5206d$export$7e70ee570119a0a7 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getIsAiOptInEnabled
});
const $35da250daae5206d$export$455ae7fd9d68b157 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: $35da250daae5206d$var$getisAiEnabledForIssue
});
const $35da250daae5206d$export$93db6a8f3342dddf = (0, $gg7kZ.createContainer)($35da250daae5206d$export$6f57813fe9f31bf9);
const $35da250daae5206d$export$965360ae27fcae98 = (0, $3sQ5x.createHook)($35da250daae5206d$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("fMAcJ", function(module, exports) {

$parcel$export(module.exports, "actions", () => $043cabfbcc6107f0$export$e324594224ef24da);

var $7l48d = parcelRequire("7l48d");

var $iElCl = parcelRequire("iElCl");

var $edJtc = parcelRequire("edJtc");
const $043cabfbcc6107f0$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
            ...issueContext,
            issueId: undefined,
            viewMode: issueContext.viewMode || getState().viewMode
        });
        else setState({
            ...issueContext,
            viewMode: issueContext.viewMode || getState().viewMode
        });
    };
const $043cabfbcc6107f0$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
            ...getState(),
            ...partialIssueContext,
            issueId: undefined
        });
        else setState({
            ...getState(),
            ...partialIssueContext
        });
    };
const $043cabfbcc6107f0$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, $iElCl.getChildIssuesLimit)(getState());
const $043cabfbcc6107f0$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
const $043cabfbcc6107f0$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
const $043cabfbcc6107f0$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
const $043cabfbcc6107f0$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
const $043cabfbcc6107f0$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
const $043cabfbcc6107f0$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
const $043cabfbcc6107f0$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7l48d.localStorage).set((0, $7l48d.VIEW_MODE_STORAGE_KEY), 'MODAL');
        setState({
            viewMode: 'MODAL'
        });
    };
const $043cabfbcc6107f0$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7l48d.localStorage).set((0, $7l48d.VIEW_MODE_STORAGE_KEY), 'SIDEBAR');
        setState({
            viewMode: 'SIDEBAR'
        });
    };
const $043cabfbcc6107f0$export$75007d125f198b78 = ()=>({ setState: setState })=>{
        setState({
            viewMode: (0, $edJtc.getViewModeFromLocalStorage)()
        });
    };
const $043cabfbcc6107f0$export$e324594224ef24da = {
    setIssueContext: $043cabfbcc6107f0$export$784a03c4b74da53e,
    mergeIssueContext: $043cabfbcc6107f0$export$666ee48e0eaf4f13,
    getChildIssuesLimit: $043cabfbcc6107f0$export$89b6937a83edcaa6,
    getMaxTokenLength: $043cabfbcc6107f0$export$e40f2acaf1a50b00,
    getIsLoadedWithPage: $043cabfbcc6107f0$export$2fe981b90be13483,
    getBackButtonUrl: $043cabfbcc6107f0$export$afce556782490aae,
    getIsSpaEnabled: $043cabfbcc6107f0$export$711dfa096bf81f2d,
    getIssueKey: $043cabfbcc6107f0$export$4a030f6192bebe03,
    getIsArchived: $043cabfbcc6107f0$export$b41341ac6c74ca6,
    setDetailViewAsModal: $043cabfbcc6107f0$export$77ec0de2f63f10c4,
    setDetailViewAsSidebar: $043cabfbcc6107f0$export$b303af51de56a0e,
    resetDetailView: $043cabfbcc6107f0$export$75007d125f198b78
};

});
parcelRegister("iElCl", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $fde75c94a28741e3$export$89b6937a83edcaa6);
$parcel$export(module.exports, "getChildIssuesIssueLimitUrls", () => $fde75c94a28741e3$export$8f43520910e8128c);

var $dJl1T = parcelRequire("dJl1T");

var $7l48d = parcelRequire("7l48d");
// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const $fde75c94a28741e3$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
const $fde75c94a28741e3$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData(`${(0, $7l48d.LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
    return $fde75c94a28741e3$var$FALLBACK_CHILD_ISSUES_LIMIT;
};
const $fde75c94a28741e3$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $fde75c94a28741e3$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
const $fde75c94a28741e3$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;

});




parcelRegister("aQLD7", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $0ebe24e18a9cec5a$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "actions", () => $0ebe24e18a9cec5a$export$e324594224ef24da);

var $2wsII = parcelRequire("2wsII");
var $cWJzY = parcelRequire("cWJzY");

var $bvqNo = parcelRequire("bvqNo");
const $0ebe24e18a9cec5a$export$d4c72bab9d6cc13a = {
    confluenceData: {
        contentId: '',
        contentUrl: '',
        contentData: null,
        mode: (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        isDraft: false,
        isLive: false
    },
    contentActions: {},
    contentType: (0, $bvqNo.ConfluenceContentTypes).PAGE,
    embeddedConfluenceSource: '',
    displayType: (0, $bvqNo.DisplayTypes).PANEL,
    panel: {
        initialWidth: 0,
        isOpen: false,
        isLoading: false,
        isExpanded: false
    },
    modal: {
        isOpen: false
    }
};
const $0ebe24e18a9cec5a$export$aa5d06fef96639ba = ({ contentId: contentId, contentType: contentType, embeddedConfluenceSource: embeddedConfluenceSource, data: data, displayType: displayType, initialWidth: initialWidth, hostname: hostname, isDraft: isDraft, isLive: isLive, isExpanded: isExpanded, mode: mode, onLinkPage: onLinkPage, onPublish: onPublish, shouldOpenModal: shouldOpenModal, url: url, title: title })=>({ setState: setState })=>{
        setState({
            confluenceData: {
                contentId: contentId,
                contentUrl: url,
                contentData: data,
                hostname: hostname,
                mode: mode,
                isDraft: isDraft,
                isLive: isLive,
                title: title,
                spaceKey: (0, $cWJzY.parseUrl)(url)?.spaceKey
            },
            contentActions: {
                onLinkPage: onLinkPage,
                onPublish: onPublish
            },
            embeddedConfluenceSource: embeddedConfluenceSource,
            contentType: contentType,
            displayType: displayType,
            panel: {
                initialWidth: initialWidth,
                isOpen: !shouldOpenModal,
                isExpanded: isExpanded
            },
            modal: {
                isOpen: shouldOpenModal
            }
        });
    };
const $0ebe24e18a9cec5a$export$e81b26ab493ca52a = ()=>({ setState: setState })=>{
        setState($0ebe24e18a9cec5a$export$d4c72bab9d6cc13a);
    };
const $0ebe24e18a9cec5a$export$473e6cac57a0d506 = (deferredSpaceName, deferredSpaceKey)=>({ setState: setState, getState: getState })=>{
        const { confluenceData: confluenceData, ...prevState } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                deferredSpaceName: deferredSpaceName,
                spaceKey: deferredSpaceKey || confluenceData.spaceKey
            },
            ...prevState
        });
    };
const $0ebe24e18a9cec5a$export$db9852cd4946540a = ({ isLoading: isLoading, isDeferSpaceSelection: isDeferSpaceSelection })=>({ setState: setState, getState: getState })=>{
        const { panel: panel, ...prevState } = getState();
        setState({
            ...prevState,
            isDeferSpaceSelection: isDeferSpaceSelection,
            panel: {
                ...panel,
                isLoading: isLoading
            }
        });
    };
const $0ebe24e18a9cec5a$export$b29d56f843007f2b = ()=>({ setState: setState, getState: getState })=>{
        const { panel: panel, ...prevState } = getState();
        const isCurrentlyExpanded = panel.isExpanded;
        setState({
            panel: {
                ...panel,
                isExpanded: !isCurrentlyExpanded
            },
            ...prevState
        });
    };
const $0ebe24e18a9cec5a$export$5d0561abb73760f = ({ newIsDraftState: newIsDraftState })=>({ setState: setState, getState: getState })=>{
        const { confluenceData: confluenceData, ...prevState } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                isDraft: newIsDraftState
            },
            ...prevState
        });
    };
const $0ebe24e18a9cec5a$export$1a8782a287467f35 = (newData)=>({ setState: setState, getState: getState })=>{
        const { confluenceData: confluenceData, ...prevState } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                ...newData
            },
            ...prevState
        });
    };
const $0ebe24e18a9cec5a$export$e324594224ef24da = {
    closeSidePanel: $0ebe24e18a9cec5a$export$e81b26ab493ca52a,
    openSidePanel: $0ebe24e18a9cec5a$export$aa5d06fef96639ba,
    setDeferredSpaceData: $0ebe24e18a9cec5a$export$473e6cac57a0d506,
    setIsDraftState: $0ebe24e18a9cec5a$export$5d0561abb73760f,
    setIsLoadingForDeferSpaceSelection: $0ebe24e18a9cec5a$export$db9852cd4946540a,
    toggleExpandedState: $0ebe24e18a9cec5a$export$b29d56f843007f2b,
    setConfluenceData: $0ebe24e18a9cec5a$export$1a8782a287467f35
};

});
parcelRegister("2wsII", function(module, exports) {

$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_MODE", () => $2140ab95b70a5932$export$816ef638e478449a);
var $2140ab95b70a5932$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});

});

parcelRegister("cWJzY", function(module, exports) {

$parcel$export(module.exports, "parsePageProps", () => $26ae2583e0993723$export$41eb0a358b69a9df);
$parcel$export(module.exports, "parseUrl", () => $26ae2583e0993723$export$7a5253c0f62e0150);
parcelRequire("4f7fY");
var $7ziRZ = parcelRequire("7ziRZ");

var $6nvuU = parcelRequire("6nvuU");

var $iGXQt = parcelRequire("iGXQt");

var $2wsII = parcelRequire("2wsII");

var $a4n1w = parcelRequire("a4n1w");
function $26ae2583e0993723$export$41eb0a358b69a9df(props) {
    let { contentId: contentId = '', hostname: hostname, parentProduct: parentProduct = '', spaceKey: spaceKey, url: url, allowedFeatures: allowedFeatures, mode: mode, draftShareId: draftShareId, hash: hash, themeState: themeState, ...passThroughProps } = props;
    const parsedAllowedFeatures = $26ae2583e0993723$export$350c411f568eceb9(allowedFeatures);
    if (!url) return {
        contentId: contentId,
        hostname: hostname,
        parentProduct: parentProduct,
        spaceKey: spaceKey,
        protocol: 'https:',
        mode: mode ?? (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        ...passThroughProps
    };
    const parsedProps = $26ae2583e0993723$export$7a5253c0f62e0150(url);
    if (!parsedProps) return {
        hostname: hostname,
        contentId: contentId,
        spaceKey: spaceKey,
        parentProduct: parentProduct,
        mode: mode,
        protocol: 'https:',
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        ...passThroughProps
    };
    const themeStateParsedObject = parsedProps.themeState ? (0, $6nvuU.themeStringToObject)(decodeURIComponent(parsedProps.themeState)) : undefined;
    // Override with URL-extracted props
    contentId = contentId || parsedProps.contentId;
    parentProduct = parentProduct || parsedProps.parentProduct || '';
    hostname = hostname || parsedProps.hostname || window.location.hostname;
    spaceKey = spaceKey || parsedProps.spaceKey;
    draftShareId = draftShareId || parsedProps.draftShareId;
    hash = hash || parsedProps.hash;
    themeState = themeState || themeStateParsedObject;
    let modeFromUrl;
    switch(parsedProps.route){
        case (0, $a4n1w.VIEW_PAGE).name:
        case (0, $a4n1w.VIEW_BLOG).name:
        case (0, $a4n1w.VIEW_BLOG_DATE_LEGACY).name:
            modeFromUrl = (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE;
            break;
        case (0, $a4n1w.EDIT_PAGE_EMBED).name:
        case (0, $a4n1w.EDIT_PAGE_V2).name:
            modeFromUrl = (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE;
            break;
        case (0, $a4n1w.WHITEBOARD).name:
    }
    const contentSlug = parsedProps.route === (0, $a4n1w.VIEW_BLOG_DATE_LEGACY).name ? undefined : parsedProps.contentSlug;
    return {
        allowedFeatures: parsedAllowedFeatures,
        contentId: contentId,
        draftShareId: draftShareId,
        hash: hash,
        hostname: hostname,
        mode: mode || modeFromUrl,
        parentProduct: parentProduct,
        protocol: parsedProps.protocol,
        spaceKey: spaceKey,
        themeState: themeState,
        contentSlug: contentSlug,
        ...passThroughProps
    };
}
function $26ae2583e0993723$export$7a5253c0f62e0150(url) {
    if (!url) return null;
    const matchedRoute = $26ae2583e0993723$var$findAndMatchRoute((0, $a4n1w.namedRoutes), url);
    if (!matchedRoute) return null;
    const { routeName: routeName, ...match } = matchedRoute;
    const { year: year, month: month, day: day, contentId: contentId } = match.params;
    // Validate date parameters
    const isValidYear = /^\d+$/.test(year || '');
    const isValidMonth = /^\d+$/.test(month || '');
    const isValidDay = /^\d+$/.test(day || '');
    const isValidContentId = /^\d+$/.test(contentId || '');
    // If route requires validation, and any parameter is invalid, return null
    if (routeName === (0, $a4n1w.VIEW_BLOG_DATE_LEGACY).name && (!isValidYear || !isValidMonth || !isValidDay || !isValidContentId)) return null;
    return {
        route: routeName,
        hostname: match.host,
        protocol: match.protocol,
        contentId: contentId || '',
        spaceKey: match.params.spaceKey || '',
        hash: match.hash || '',
        // EP currently supports only 1 parent product, no more than 1 parent product should be passed in
        parentProduct: Array.isArray(match.query.parentProduct) ? match.query.parentProduct[0] : match.query.parentProduct || '',
        draftShareId: Array.isArray(match.query.draftShareId) ? match.query.draftShareId[0] : match.query.draftShareId,
        themeState: match.query.themeState,
        contentSlug: match.params.contentSlug || undefined,
        query: match.query
    };
}
function $26ae2583e0993723$var$findAndMatchRoute(routes, url) {
    for (const routeKey of Object.keys(routes)){
        const route = routes[routeKey];
        const match = $26ae2583e0993723$var$matchUrl(route.pattern, url);
        if (match) return {
            routeName: route.name,
            ...match
        };
    }
    return null;
}
function $26ae2583e0993723$var$isValidURL(url) {
    try {
        new URL(url, window.location.origin);
        return true;
    } catch  {
        return false;
    }
}
function $26ae2583e0993723$var$matchUrl(pattern, url) {
    if (!$26ae2583e0993723$var$isValidURL(url)) return null;
    const parsed = new URL(url, window.location.origin);
    const pathname = parsed.pathname || '';
    const search = parsed.search || '';
    let match = (0, $7ziRZ.matchPath)({
        path: pattern,
        end: true
    }, pathname);
    // If initial match fails and the route requires query parameters, attempt to match including search
    // some of our routes need query params to match
    if (!match && search) match = (0, $7ziRZ.matchPath)({
        path: pattern,
        end: true
    }, `${pathname}${search}`);
    if (!match) return null;
    // URI decode params
    const decodedParams = {};
    if (match.params) {
        for (const [key, value] of Object.entries(match.params))if (value !== undefined) decodedParams[key] = value;
    }
    return {
        url: url,
        protocol: parsed.protocol,
        host: parsed.host,
        pathname: pathname,
        search: parsed.search,
        hash: parsed.hash,
        pattern: pattern,
        params: decodedParams,
        query: Object.fromEntries(parsed.searchParams.entries())
    };
}
function $26ae2583e0993723$export$350c411f568eceb9(allowedFeatures) {
    let parsedAllowedFeatures = {
        view: allowedFeatures?.view,
        edit: allowedFeatures?.edit
    };
    if (!allowedFeatures?.view) parsedAllowedFeatures.view = [
        ...(0, $iGXQt.DEFAULT_ALLOWED_FEATURES).view,
        'edit'
    ];
    else if (Array.isArray(allowedFeatures.view)) parsedAllowedFeatures.view = [
        ...allowedFeatures.view,
        'edit'
    ];
    return parsedAllowedFeatures;
}

});
parcelRegister("4f7fY", function(module, exports) {

$parcel$export(module.exports, "matchPath", () => (parcelRequire("7ziRZ")).matchPath);
/**
 * React Router v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $7ziRZ = parcelRequire("7ziRZ");
function $316e312a784448a8$var$_extends() {
    $316e312a784448a8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $316e312a784448a8$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $316e312a784448a8$export$3add0d5dce533e2e = /*#__PURE__*/ $5uXOq.createContext(null);
const $316e312a784448a8$export$145dfa71566a64dc = /*#__PURE__*/ $5uXOq.createContext(null);
const $316e312a784448a8$var$AwaitContext = /*#__PURE__*/ $5uXOq.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $316e312a784448a8$export$26749e8557646306 = /*#__PURE__*/ $5uXOq.createContext(null);
const $316e312a784448a8$export$c7914228fb69b0f5 = /*#__PURE__*/ $5uXOq.createContext(null);
const $316e312a784448a8$export$9072aa6dd1f93057 = /*#__PURE__*/ $5uXOq.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $316e312a784448a8$var$RouteErrorContext = /*#__PURE__*/ $5uXOq.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $316e312a784448a8$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$316e312a784448a8$export$9c954a9d03d32f4a() && (0, $7ziRZ.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $5uXOq.useContext($316e312a784448a8$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $316e312a784448a8$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $7ziRZ.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $316e312a784448a8$export$9c954a9d03d32f4a() {
    return $5uXOq.useContext($316e312a784448a8$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $316e312a784448a8$export$45d76561a5302f2b() {
    !$316e312a784448a8$export$9c954a9d03d32f4a() && (0, $7ziRZ.UNSAFE_invariant)(false);
    return $5uXOq.useContext($316e312a784448a8$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $316e312a784448a8$export$1b3f31771c5d07c() {
    return $5uXOq.useContext($316e312a784448a8$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $316e312a784448a8$export$6c330e8992e8a295(pattern) {
    !$316e312a784448a8$export$9c954a9d03d32f4a() && (0, $7ziRZ.UNSAFE_invariant)(false);
    let { pathname: pathname } = $316e312a784448a8$export$45d76561a5302f2b();
    return $5uXOq.useMemo(()=>(0, $7ziRZ.matchPath)(pattern, (0, $7ziRZ.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $316e312a784448a8$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $316e312a784448a8$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $5uXOq.useContext($316e312a784448a8$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $5uXOq.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $316e312a784448a8$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $5uXOq.useContext($316e312a784448a8$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $316e312a784448a8$var$useNavigateStable() : $316e312a784448a8$var$useNavigateUnstable();
}
function $316e312a784448a8$var$useNavigateUnstable() {
    !$316e312a784448a8$export$9c954a9d03d32f4a() && (0, $7ziRZ.UNSAFE_invariant)(false);
    let dataRouterContext = $5uXOq.useContext($316e312a784448a8$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $5uXOq.useContext($316e312a784448a8$export$26749e8557646306);
    let { matches: matches } = $5uXOq.useContext($316e312a784448a8$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $316e312a784448a8$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $7ziRZ.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $5uXOq.useRef(false);
    $316e312a784448a8$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $5uXOq.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $7ziRZ.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $7ziRZ.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $316e312a784448a8$var$OutletContext = /*#__PURE__*/ $5uXOq.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $316e312a784448a8$export$4138103a3ae699cc() {
    return $5uXOq.useContext($316e312a784448a8$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $316e312a784448a8$export$a3be3530d8e40d0b(context) {
    let outlet = $5uXOq.useContext($316e312a784448a8$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $5uXOq.createElement($316e312a784448a8$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $316e312a784448a8$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $5uXOq.useContext($316e312a784448a8$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $316e312a784448a8$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $5uXOq.useContext($316e312a784448a8$export$26749e8557646306);
    let { matches: matches } = $5uXOq.useContext($316e312a784448a8$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $316e312a784448a8$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $7ziRZ.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $5uXOq.useMemo(()=>(0, $7ziRZ.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $316e312a784448a8$export$5d3fca4a98652595(routes, locationArg) {
    return $316e312a784448a8$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $316e312a784448a8$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$316e312a784448a8$export$9c954a9d03d32f4a() && (0, $7ziRZ.UNSAFE_invariant)(false);
    let { navigator: navigator } = $5uXOq.useContext($316e312a784448a8$export$26749e8557646306);
    let { matches: parentMatches } = $5uXOq.useContext($316e312a784448a8$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $316e312a784448a8$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $7ziRZ.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $7ziRZ.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $7ziRZ.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $316e312a784448a8$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $7ziRZ.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $7ziRZ.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $5uXOq.createElement($316e312a784448a8$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $316e312a784448a8$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $7ziRZ.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $316e312a784448a8$var$DefaultErrorComponent() {
    let error = $316e312a784448a8$export$ed527bf60f6e05f2();
    let message = (0, $7ziRZ.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $5uXOq.createElement($5uXOq.Fragment, null, /*#__PURE__*/ $5uXOq.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $5uXOq.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $5uXOq.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $316e312a784448a8$var$defaultErrorElement = /*#__PURE__*/ $5uXOq.createElement($316e312a784448a8$var$DefaultErrorComponent, null);
class $316e312a784448a8$var$RenderErrorBoundary extends $5uXOq.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $5uXOq.createElement($316e312a784448a8$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $5uXOq.createElement($316e312a784448a8$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $316e312a784448a8$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $5uXOq.useContext($316e312a784448a8$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $5uXOq.createElement($316e312a784448a8$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $316e312a784448a8$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $7ziRZ.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $316e312a784448a8$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $316e312a784448a8$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $5uXOq.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $5uXOq.createElement($316e312a784448a8$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $5uXOq.createElement($316e312a784448a8$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $316e312a784448a8$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($316e312a784448a8$var$DataRouterHook || {});
var $316e312a784448a8$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($316e312a784448a8$var$DataRouterStateHook || {});
function $316e312a784448a8$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $316e312a784448a8$var$useDataRouterContext(hookName) {
    let ctx = $5uXOq.useContext($316e312a784448a8$export$3add0d5dce533e2e);
    !ctx && (0, $7ziRZ.UNSAFE_invariant)(false);
    return ctx;
}
function $316e312a784448a8$var$useDataRouterState(hookName) {
    let state = $5uXOq.useContext($316e312a784448a8$export$145dfa71566a64dc);
    !state && (0, $7ziRZ.UNSAFE_invariant)(false);
    return state;
}
function $316e312a784448a8$var$useRouteContext(hookName) {
    let route = $5uXOq.useContext($316e312a784448a8$export$9072aa6dd1f93057);
    !route && (0, $7ziRZ.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $316e312a784448a8$var$useCurrentRouteId(hookName) {
    let route = $316e312a784448a8$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $7ziRZ.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $316e312a784448a8$export$5fc8298006ad9e58() {
    return $316e312a784448a8$var$useCurrentRouteId($316e312a784448a8$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $316e312a784448a8$export$d0fd4b7106de2769() {
    let state = $316e312a784448a8$var$useDataRouterState($316e312a784448a8$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $316e312a784448a8$export$600dc272ed516c15() {
    let dataRouterContext = $316e312a784448a8$var$useDataRouterContext($316e312a784448a8$var$DataRouterHook.UseRevalidator);
    let state = $316e312a784448a8$var$useDataRouterState($316e312a784448a8$var$DataRouterStateHook.UseRevalidator);
    return $5uXOq.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $316e312a784448a8$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $316e312a784448a8$var$useDataRouterState($316e312a784448a8$var$DataRouterStateHook.UseMatches);
    return $5uXOq.useMemo(()=>matches.map((m)=>(0, $7ziRZ.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $316e312a784448a8$export$1448a5050d252c4d() {
    let state = $316e312a784448a8$var$useDataRouterState($316e312a784448a8$var$DataRouterStateHook.UseLoaderData);
    let routeId = $316e312a784448a8$var$useCurrentRouteId($316e312a784448a8$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $316e312a784448a8$export$fd5d37484eab868d(routeId) {
    let state = $316e312a784448a8$var$useDataRouterState($316e312a784448a8$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $316e312a784448a8$export$fdc00f3f26066d5e() {
    let state = $316e312a784448a8$var$useDataRouterState($316e312a784448a8$var$DataRouterStateHook.UseActionData);
    let routeId = $316e312a784448a8$var$useCurrentRouteId($316e312a784448a8$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $316e312a784448a8$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $5uXOq.useContext($316e312a784448a8$var$RouteErrorContext);
    let state = $316e312a784448a8$var$useDataRouterState($316e312a784448a8$var$DataRouterStateHook.UseRouteError);
    let routeId = $316e312a784448a8$var$useCurrentRouteId($316e312a784448a8$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $316e312a784448a8$export$78a72ddb39bdd145() {
    let value = $5uXOq.useContext($316e312a784448a8$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $316e312a784448a8$export$17f53340677d5831() {
    let value = $5uXOq.useContext($316e312a784448a8$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $316e312a784448a8$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $316e312a784448a8$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $316e312a784448a8$var$useDataRouterContext($316e312a784448a8$var$DataRouterHook.UseBlocker);
    let state = $316e312a784448a8$var$useDataRouterState($316e312a784448a8$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $5uXOq.useState("");
    let blockerFunction = $5uXOq.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $316e312a784448a8$var$_extends({}, currentLocation, {
                pathname: (0, $7ziRZ.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $316e312a784448a8$var$_extends({}, nextLocation, {
                pathname: (0, $7ziRZ.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $5uXOq.useEffect(()=>{
        let key = String(++$316e312a784448a8$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $5uXOq.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $7ziRZ.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $316e312a784448a8$var$useNavigateStable() {
    let { router: router } = $316e312a784448a8$var$useDataRouterContext($316e312a784448a8$var$DataRouterHook.UseNavigateStable);
    let id = $316e312a784448a8$var$useCurrentRouteId($316e312a784448a8$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $5uXOq.useRef(false);
    $316e312a784448a8$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $5uXOq.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $316e312a784448a8$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $316e312a784448a8$var$alreadyWarned$1 = {};
function $316e312a784448a8$var$warningOnce(key, cond, message) {
    if (!cond && !$316e312a784448a8$var$alreadyWarned$1[key]) $316e312a784448a8$var$alreadyWarned$1[key] = true;
}
const $316e312a784448a8$var$alreadyWarned = {};
function $316e312a784448a8$var$warnOnce(key, message) {
    if (!$316e312a784448a8$var$alreadyWarned[message]) {
        $316e312a784448a8$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
const $316e312a784448a8$var$logDeprecation = (flag, msg, link)=>$316e312a784448a8$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $316e312a784448a8$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if (!(renderFuture != null && renderFuture.v7_startTransition)) $316e312a784448a8$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if (!(renderFuture != null && renderFuture.v7_relativeSplatPath) && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $316e312a784448a8$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (!routerFuture.v7_fetcherPersist) $316e312a784448a8$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (!routerFuture.v7_normalizeFormMethod) $316e312a784448a8$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (!routerFuture.v7_partialHydration) $316e312a784448a8$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (!routerFuture.v7_skipActionErrorRevalidation) $316e312a784448a8$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $316e312a784448a8$var$START_TRANSITION = "startTransition";
const $316e312a784448a8$var$startTransitionImpl = $5uXOq[$316e312a784448a8$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $316e312a784448a8$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $5uXOq.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $5uXOq.useCallback((newState)=>{
        if (v7_startTransition && $316e312a784448a8$var$startTransitionImpl) $316e312a784448a8$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $5uXOq.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $5uXOq.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $5uXOq.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $5uXOq.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $5uXOq.useEffect(()=>$316e312a784448a8$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $5uXOq.createElement($5uXOq.Fragment, null, /*#__PURE__*/ $5uXOq.createElement($316e312a784448a8$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $5uXOq.createElement($316e312a784448a8$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $5uXOq.createElement($316e312a784448a8$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $5uXOq.createElement($316e312a784448a8$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $316e312a784448a8$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $316e312a784448a8$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $316e312a784448a8$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $5uXOq.useRef();
    if (historyRef.current == null) historyRef.current = (0, $7ziRZ.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $5uXOq.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $5uXOq.useCallback((newState)=>{
        v7_startTransition && $316e312a784448a8$var$startTransitionImpl ? $316e312a784448a8$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $5uXOq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $5uXOq.useEffect(()=>$316e312a784448a8$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $5uXOq.createElement($316e312a784448a8$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $316e312a784448a8$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$316e312a784448a8$export$9c954a9d03d32f4a() && (0, $7ziRZ.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $5uXOq.useContext($316e312a784448a8$export$26749e8557646306);
    let { matches: matches } = $5uXOq.useContext($316e312a784448a8$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $316e312a784448a8$export$45d76561a5302f2b();
    let navigate = $316e312a784448a8$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $7ziRZ.resolveTo)(to, (0, $7ziRZ.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $5uXOq.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $316e312a784448a8$export$910ae8079b2c2852(props) {
    return $316e312a784448a8$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $316e312a784448a8$export$e7b0ac011bb776c6(_props) {
    (0, $7ziRZ.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $316e312a784448a8$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $7ziRZ.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$316e312a784448a8$export$9c954a9d03d32f4a() && (0, $7ziRZ.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $5uXOq.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $316e312a784448a8$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $7ziRZ.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $5uXOq.useMemo(()=>{
        let trailingPathname = (0, $7ziRZ.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $5uXOq.createElement($316e312a784448a8$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $5uXOq.createElement($316e312a784448a8$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $316e312a784448a8$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $316e312a784448a8$export$5d3fca4a98652595($316e312a784448a8$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $316e312a784448a8$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $5uXOq.createElement($316e312a784448a8$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $5uXOq.createElement($316e312a784448a8$var$ResolveAwait, null, children));
}
var $316e312a784448a8$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($316e312a784448a8$var$AwaitRenderStatus || {});
const $316e312a784448a8$var$neverSettledPromise = new Promise(()=>{});
class $316e312a784448a8$var$AwaitErrorBoundary extends $5uXOq.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $316e312a784448a8$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $316e312a784448a8$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $316e312a784448a8$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $316e312a784448a8$var$AwaitRenderStatus.error : "_data" in promise ? $316e312a784448a8$var$AwaitRenderStatus.success : $316e312a784448a8$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $316e312a784448a8$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $316e312a784448a8$var$AwaitRenderStatus.error && promise._error instanceof (0, $7ziRZ.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $316e312a784448a8$var$neverSettledPromise;
        if (status === $316e312a784448a8$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $316e312a784448a8$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $5uXOq.createElement($316e312a784448a8$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $316e312a784448a8$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $5uXOq.createElement($316e312a784448a8$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $316e312a784448a8$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $316e312a784448a8$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $5uXOq.createElement($5uXOq.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $316e312a784448a8$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $5uXOq.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $5uXOq.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $5uXOq.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $316e312a784448a8$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $316e312a784448a8$export$e7b0ac011bb776c6) && (0, $7ziRZ.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $7ziRZ.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $316e312a784448a8$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $316e312a784448a8$export$daf73786167a7f72(matches) {
    return $316e312a784448a8$var$_renderMatches(matches);
}
function $316e312a784448a8$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $5uXOq.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $5uXOq.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $5uXOq.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $316e312a784448a8$export$f30f7e456d254e83(routes, opts) {
    return (0, $7ziRZ.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $316e312a784448a8$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $7ziRZ.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $316e312a784448a8$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});
parcelRegister("7ziRZ", function(module, exports) {

$parcel$export(module.exports, "Action", () => $582a7073b9f425dc$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $582a7073b9f425dc$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $582a7073b9f425dc$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $582a7073b9f425dc$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "UNSAFE_invariant", () => $582a7073b9f425dc$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $582a7073b9f425dc$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $582a7073b9f425dc$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $582a7073b9f425dc$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $582a7073b9f425dc$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $582a7073b9f425dc$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $582a7073b9f425dc$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $582a7073b9f425dc$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $582a7073b9f425dc$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $582a7073b9f425dc$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "isRouteErrorResponse", () => $582a7073b9f425dc$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $582a7073b9f425dc$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $582a7073b9f425dc$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $582a7073b9f425dc$var$_extends() {
    $582a7073b9f425dc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $582a7073b9f425dc$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $582a7073b9f425dc$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($582a7073b9f425dc$export$e19cd5f9376f8cee || ($582a7073b9f425dc$export$e19cd5f9376f8cee = {}));
const $582a7073b9f425dc$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $582a7073b9f425dc$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $582a7073b9f425dc$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $582a7073b9f425dc$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $582a7073b9f425dc$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $582a7073b9f425dc$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $582a7073b9f425dc$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $582a7073b9f425dc$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $582a7073b9f425dc$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $582a7073b9f425dc$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $582a7073b9f425dc$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $582a7073b9f425dc$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $582a7073b9f425dc$export$fe53371bee54353d(to);
    }
    return $582a7073b9f425dc$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $582a7073b9f425dc$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $582a7073b9f425dc$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $582a7073b9f425dc$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $582a7073b9f425dc$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $582a7073b9f425dc$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $582a7073b9f425dc$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $582a7073b9f425dc$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $582a7073b9f425dc$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $582a7073b9f425dc$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $582a7073b9f425dc$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $582a7073b9f425dc$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $582a7073b9f425dc$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $582a7073b9f425dc$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $582a7073b9f425dc$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $582a7073b9f425dc$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $582a7073b9f425dc$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $582a7073b9f425dc$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $582a7073b9f425dc$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($582a7073b9f425dc$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $582a7073b9f425dc$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $582a7073b9f425dc$export$e19cd5f9376f8cee.Push;
        let location = $582a7073b9f425dc$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $582a7073b9f425dc$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $582a7073b9f425dc$export$e19cd5f9376f8cee.Replace;
        let location = $582a7073b9f425dc$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $582a7073b9f425dc$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $582a7073b9f425dc$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $582a7073b9f425dc$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($582a7073b9f425dc$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($582a7073b9f425dc$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $582a7073b9f425dc$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($582a7073b9f425dc$var$ResultType || ($582a7073b9f425dc$var$ResultType = {}));
const $582a7073b9f425dc$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $582a7073b9f425dc$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $582a7073b9f425dc$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $582a7073b9f425dc$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $582a7073b9f425dc$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($582a7073b9f425dc$var$isIndexRoute(route)) {
            let indexRoute = $582a7073b9f425dc$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $582a7073b9f425dc$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $582a7073b9f425dc$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $582a7073b9f425dc$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $582a7073b9f425dc$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $582a7073b9f425dc$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $582a7073b9f425dc$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $582a7073b9f425dc$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $582a7073b9f425dc$var$flattenRoutes(routes);
    $582a7073b9f425dc$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $582a7073b9f425dc$export$30d21fd6d7295f52(pathname);
        matches = $582a7073b9f425dc$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $582a7073b9f425dc$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $582a7073b9f425dc$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $582a7073b9f425dc$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $582a7073b9f425dc$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $582a7073b9f425dc$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $582a7073b9f425dc$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $582a7073b9f425dc$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $582a7073b9f425dc$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $582a7073b9f425dc$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $582a7073b9f425dc$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $582a7073b9f425dc$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $582a7073b9f425dc$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $582a7073b9f425dc$var$paramRe = /^:[\w-]+$/;
const $582a7073b9f425dc$var$dynamicSegmentValue = 3;
const $582a7073b9f425dc$var$indexRouteValue = 2;
const $582a7073b9f425dc$var$emptySegmentValue = 1;
const $582a7073b9f425dc$var$staticSegmentValue = 10;
const $582a7073b9f425dc$var$splatPenalty = -2;
const $582a7073b9f425dc$var$isSplat = (s)=>s === "*";
function $582a7073b9f425dc$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($582a7073b9f425dc$var$isSplat)) initialScore += $582a7073b9f425dc$var$splatPenalty;
    if (index) initialScore += $582a7073b9f425dc$var$indexRouteValue;
    return segments.filter((s)=>!$582a7073b9f425dc$var$isSplat(s)).reduce((score, segment)=>score + ($582a7073b9f425dc$var$paramRe.test(segment) ? $582a7073b9f425dc$var$dynamicSegmentValue : segment === "" ? $582a7073b9f425dc$var$emptySegmentValue : $582a7073b9f425dc$var$staticSegmentValue), initialScore);
}
function $582a7073b9f425dc$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $582a7073b9f425dc$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $582a7073b9f425dc$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $582a7073b9f425dc$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $582a7073b9f425dc$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $582a7073b9f425dc$export$a5c6d149b50c1d86($582a7073b9f425dc$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $582a7073b9f425dc$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $582a7073b9f425dc$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $582a7073b9f425dc$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $582a7073b9f425dc$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $582a7073b9f425dc$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $582a7073b9f425dc$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $582a7073b9f425dc$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $582a7073b9f425dc$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $582a7073b9f425dc$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $582a7073b9f425dc$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $582a7073b9f425dc$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $582a7073b9f425dc$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $582a7073b9f425dc$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $582a7073b9f425dc$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $582a7073b9f425dc$var$normalizeSearch(search),
        hash: $582a7073b9f425dc$var$normalizeHash(hash)
    };
}
function $582a7073b9f425dc$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $582a7073b9f425dc$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $582a7073b9f425dc$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $582a7073b9f425dc$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $582a7073b9f425dc$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $582a7073b9f425dc$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $582a7073b9f425dc$export$8ccf933b0513f8d0(toArg);
    else {
        to = $582a7073b9f425dc$var$_extends({}, toArg);
        $582a7073b9f425dc$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $582a7073b9f425dc$var$getInvalidPathError("?", "pathname", "search", to));
        $582a7073b9f425dc$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $582a7073b9f425dc$var$getInvalidPathError("#", "pathname", "hash", to));
        $582a7073b9f425dc$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $582a7073b9f425dc$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $582a7073b9f425dc$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $582a7073b9f425dc$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $582a7073b9f425dc$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $582a7073b9f425dc$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $582a7073b9f425dc$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $582a7073b9f425dc$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $582a7073b9f425dc$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $582a7073b9f425dc$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $582a7073b9f425dc$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $582a7073b9f425dc$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $582a7073b9f425dc$export$4051a07651545597(data, init) {
    return new $582a7073b9f425dc$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $582a7073b9f425dc$export$42a99a7a4bc0e76a extends Error {
}
class $582a7073b9f425dc$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $582a7073b9f425dc$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $582a7073b9f425dc$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $582a7073b9f425dc$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $582a7073b9f425dc$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $582a7073b9f425dc$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $582a7073b9f425dc$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $582a7073b9f425dc$var$unwrapTrackedPromise(value) {
    if (!$582a7073b9f425dc$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $582a7073b9f425dc$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $582a7073b9f425dc$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $582a7073b9f425dc$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $582a7073b9f425dc$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $582a7073b9f425dc$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $582a7073b9f425dc$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $582a7073b9f425dc$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $582a7073b9f425dc$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $582a7073b9f425dc$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $582a7073b9f425dc$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $582a7073b9f425dc$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $582a7073b9f425dc$var$validMutationMethods = new Set($582a7073b9f425dc$var$validMutationMethodsArr);
const $582a7073b9f425dc$var$validRequestMethodsArr = [
    "get",
    ...$582a7073b9f425dc$var$validMutationMethodsArr
];
const $582a7073b9f425dc$var$validRequestMethods = new Set($582a7073b9f425dc$var$validRequestMethodsArr);
const $582a7073b9f425dc$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $582a7073b9f425dc$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $582a7073b9f425dc$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $582a7073b9f425dc$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $582a7073b9f425dc$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $582a7073b9f425dc$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $582a7073b9f425dc$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $582a7073b9f425dc$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $582a7073b9f425dc$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $582a7073b9f425dc$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $582a7073b9f425dc$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $582a7073b9f425dc$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $582a7073b9f425dc$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $582a7073b9f425dc$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $582a7073b9f425dc$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $582a7073b9f425dc$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $582a7073b9f425dc$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$582a7073b9f425dc$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$582a7073b9f425dc$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $582a7073b9f425dc$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $582a7073b9f425dc$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $582a7073b9f425dc$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $582a7073b9f425dc$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $582a7073b9f425dc$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$582a7073b9f425dc$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($582a7073b9f425dc$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $582a7073b9f425dc$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $582a7073b9f425dc$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $582a7073b9f425dc$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $582a7073b9f425dc$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $582a7073b9f425dc$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $582a7073b9f425dc$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $582a7073b9f425dc$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $582a7073b9f425dc$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $582a7073b9f425dc$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($582a7073b9f425dc$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $582a7073b9f425dc$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $582a7073b9f425dc$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $582a7073b9f425dc$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $582a7073b9f425dc$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $582a7073b9f425dc$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $582a7073b9f425dc$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $582a7073b9f425dc$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $582a7073b9f425dc$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $582a7073b9f425dc$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $582a7073b9f425dc$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $582a7073b9f425dc$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $582a7073b9f425dc$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $582a7073b9f425dc$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $582a7073b9f425dc$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $582a7073b9f425dc$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $582a7073b9f425dc$var$findNearestBoundary(matches).route.id,
            {
                type: $582a7073b9f425dc$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $582a7073b9f425dc$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($582a7073b9f425dc$var$isErrorResult(result) && $582a7073b9f425dc$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $582a7073b9f425dc$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $582a7073b9f425dc$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $582a7073b9f425dc$var$_extends({
            matches: updatedMatches || matches
        }, $582a7073b9f425dc$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $582a7073b9f425dc$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $582a7073b9f425dc$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $582a7073b9f425dc$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $582a7073b9f425dc$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $582a7073b9f425dc$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $582a7073b9f425dc$var$ResultType.error,
            error: $582a7073b9f425dc$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($582a7073b9f425dc$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $582a7073b9f425dc$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($582a7073b9f425dc$var$isDeferredResult(result)) throw $582a7073b9f425dc$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($582a7073b9f425dc$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $582a7073b9f425dc$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $582a7073b9f425dc$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $582a7073b9f425dc$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $582a7073b9f425dc$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($582a7073b9f425dc$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $582a7073b9f425dc$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $582a7073b9f425dc$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $582a7073b9f425dc$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $582a7073b9f425dc$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $582a7073b9f425dc$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $582a7073b9f425dc$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $582a7073b9f425dc$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $582a7073b9f425dc$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $582a7073b9f425dc$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $582a7073b9f425dc$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$582a7073b9f425dc$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $582a7073b9f425dc$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $582a7073b9f425dc$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $582a7073b9f425dc$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $582a7073b9f425dc$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $582a7073b9f425dc$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $582a7073b9f425dc$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $582a7073b9f425dc$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $582a7073b9f425dc$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $582a7073b9f425dc$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $582a7073b9f425dc$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $582a7073b9f425dc$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $582a7073b9f425dc$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($582a7073b9f425dc$var$isRedirectResult(actionResult) || $582a7073b9f425dc$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $582a7073b9f425dc$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($582a7073b9f425dc$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $582a7073b9f425dc$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $582a7073b9f425dc$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($582a7073b9f425dc$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($582a7073b9f425dc$var$isDeferredResult(actionResult)) throw $582a7073b9f425dc$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $582a7073b9f425dc$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $582a7073b9f425dc$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $582a7073b9f425dc$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $582a7073b9f425dc$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $582a7073b9f425dc$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $582a7073b9f425dc$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $582a7073b9f425dc$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $582a7073b9f425dc$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $582a7073b9f425dc$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $582a7073b9f425dc$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $582a7073b9f425dc$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $582a7073b9f425dc$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $582a7073b9f425dc$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $582a7073b9f425dc$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $582a7073b9f425dc$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $582a7073b9f425dc$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($582a7073b9f425dc$var$isDeferredResult(result)) result = await $582a7073b9f425dc$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $582a7073b9f425dc$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($582a7073b9f425dc$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $582a7073b9f425dc$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($582a7073b9f425dc$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $582a7073b9f425dc$export$3e9cee6b33872309(!$582a7073b9f425dc$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $582a7073b9f425dc$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $582a7073b9f425dc$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $582a7073b9f425dc$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $582a7073b9f425dc$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($582a7073b9f425dc$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $582a7073b9f425dc$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $582a7073b9f425dc$export$e19cd5f9376f8cee.Replace : $582a7073b9f425dc$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $582a7073b9f425dc$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($582a7073b9f425dc$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $582a7073b9f425dc$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $582a7073b9f425dc$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $582a7073b9f425dc$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $582a7073b9f425dc$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $582a7073b9f425dc$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($582a7073b9f425dc$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $582a7073b9f425dc$var$ResultType.redirect,
                response: $582a7073b9f425dc$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $582a7073b9f425dc$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $582a7073b9f425dc$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $582a7073b9f425dc$var$ResultType.error,
                    error: $582a7073b9f425dc$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $582a7073b9f425dc$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $582a7073b9f425dc$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $582a7073b9f425dc$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $582a7073b9f425dc$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $582a7073b9f425dc$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $582a7073b9f425dc$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $582a7073b9f425dc$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $582a7073b9f425dc$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $582a7073b9f425dc$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $582a7073b9f425dc$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $582a7073b9f425dc$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $582a7073b9f425dc$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $582a7073b9f425dc$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $582a7073b9f425dc$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$582a7073b9f425dc$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $582a7073b9f425dc$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $582a7073b9f425dc$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $582a7073b9f425dc$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $582a7073b9f425dc$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $582a7073b9f425dc$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $582a7073b9f425dc$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $582a7073b9f425dc$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $582a7073b9f425dc$export$4d0306f8f6a4585b = Symbol("deferred");
function $582a7073b9f425dc$export$3336b097a6fbc59a(routes, opts) {
    $582a7073b9f425dc$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $582a7073b9f425dc$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $582a7073b9f425dc$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $582a7073b9f425dc$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $582a7073b9f425dc$var$createLocation("", $582a7073b9f425dc$export$fe53371bee54353d(url), null, "default");
        let matches = $582a7073b9f425dc$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$582a7073b9f425dc$var$isValidMethod(method) && method !== "HEAD") {
            let error = $582a7073b9f425dc$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $582a7073b9f425dc$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $582a7073b9f425dc$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $582a7073b9f425dc$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($582a7073b9f425dc$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $582a7073b9f425dc$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $582a7073b9f425dc$var$createLocation("", $582a7073b9f425dc$export$fe53371bee54353d(url), null, "default");
        let matches = $582a7073b9f425dc$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$582a7073b9f425dc$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $582a7073b9f425dc$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $582a7073b9f425dc$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $582a7073b9f425dc$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $582a7073b9f425dc$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $582a7073b9f425dc$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($582a7073b9f425dc$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$582a7073b9f425dc$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $582a7073b9f425dc$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($582a7073b9f425dc$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $582a7073b9f425dc$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $582a7073b9f425dc$var$isResponse(result) ? result : $582a7073b9f425dc$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($582a7073b9f425dc$var$isDataStrategyResult(e) && $582a7073b9f425dc$var$isResponse(e.result)) {
                if (e.type === $582a7073b9f425dc$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($582a7073b9f425dc$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $582a7073b9f425dc$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $582a7073b9f425dc$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $582a7073b9f425dc$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($582a7073b9f425dc$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($582a7073b9f425dc$var$isDeferredResult(result)) {
            let error = $582a7073b9f425dc$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $582a7073b9f425dc$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($582a7073b9f425dc$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($582a7073b9f425dc$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $582a7073b9f425dc$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $582a7073b9f425dc$var$_extends({}, context, {
                statusCode: $582a7073b9f425dc$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $582a7073b9f425dc$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $582a7073b9f425dc$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $582a7073b9f425dc$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $582a7073b9f425dc$var$isErrorResult(pendingActionResult[1]) ? $582a7073b9f425dc$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $582a7073b9f425dc$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $582a7073b9f425dc$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $582a7073b9f425dc$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $582a7073b9f425dc$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $582a7073b9f425dc$var$callDataStrategyImpl(dataStrategy || $582a7073b9f425dc$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($582a7073b9f425dc$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $582a7073b9f425dc$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($582a7073b9f425dc$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $582a7073b9f425dc$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $582a7073b9f425dc$export$fec11da027c70692(routes, context, error) {
    let newContext = $582a7073b9f425dc$var$_extends({}, context, {
        statusCode: $582a7073b9f425dc$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $582a7073b9f425dc$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $582a7073b9f425dc$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $582a7073b9f425dc$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $582a7073b9f425dc$export$cae722b0cc860f13(to ? to : ".", $582a7073b9f425dc$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $582a7073b9f425dc$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $582a7073b9f425dc$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $582a7073b9f425dc$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $582a7073b9f425dc$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $582a7073b9f425dc$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$582a7073b9f425dc$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$582a7073b9f425dc$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $582a7073b9f425dc$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $582a7073b9f425dc$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $582a7073b9f425dc$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$582a7073b9f425dc$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$582a7073b9f425dc$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $582a7073b9f425dc$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $582a7073b9f425dc$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $582a7073b9f425dc$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $582a7073b9f425dc$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $582a7073b9f425dc$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($582a7073b9f425dc$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $582a7073b9f425dc$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $582a7073b9f425dc$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $582a7073b9f425dc$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $582a7073b9f425dc$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $582a7073b9f425dc$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $582a7073b9f425dc$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $582a7073b9f425dc$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $582a7073b9f425dc$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $582a7073b9f425dc$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $582a7073b9f425dc$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($582a7073b9f425dc$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $582a7073b9f425dc$var$shouldRevalidateLoader(match, $582a7073b9f425dc$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $582a7073b9f425dc$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $582a7073b9f425dc$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $582a7073b9f425dc$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $582a7073b9f425dc$var$shouldRevalidateLoader(fetcherMatch, $582a7073b9f425dc$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $582a7073b9f425dc$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $582a7073b9f425dc$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $582a7073b9f425dc$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $582a7073b9f425dc$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $582a7073b9f425dc$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $582a7073b9f425dc$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$582a7073b9f425dc$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $582a7073b9f425dc$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $582a7073b9f425dc$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$582a7073b9f425dc$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $582a7073b9f425dc$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $582a7073b9f425dc$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $582a7073b9f425dc$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$582a7073b9f425dc$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $582a7073b9f425dc$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $582a7073b9f425dc$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $582a7073b9f425dc$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $582a7073b9f425dc$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $582a7073b9f425dc$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $582a7073b9f425dc$var$ResultType.data,
                result: undefined
            });
        };
        return $582a7073b9f425dc$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $582a7073b9f425dc$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $582a7073b9f425dc$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $582a7073b9f425dc$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $582a7073b9f425dc$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $582a7073b9f425dc$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $582a7073b9f425dc$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $582a7073b9f425dc$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($582a7073b9f425dc$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $582a7073b9f425dc$var$ResultType.error,
                error: e
            };
        }
        if (type === $582a7073b9f425dc$var$ResultType.error) return {
            type: $582a7073b9f425dc$var$ResultType.error,
            error: new $582a7073b9f425dc$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $582a7073b9f425dc$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $582a7073b9f425dc$var$ResultType.error) {
        if ($582a7073b9f425dc$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $582a7073b9f425dc$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $582a7073b9f425dc$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $582a7073b9f425dc$var$ResultType.error,
            error: result,
            statusCode: $582a7073b9f425dc$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($582a7073b9f425dc$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $582a7073b9f425dc$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($582a7073b9f425dc$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $582a7073b9f425dc$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $582a7073b9f425dc$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $582a7073b9f425dc$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $582a7073b9f425dc$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$582a7073b9f425dc$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $582a7073b9f425dc$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $582a7073b9f425dc$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($582a7073b9f425dc$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $582a7073b9f425dc$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $582a7073b9f425dc$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($582a7073b9f425dc$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $582a7073b9f425dc$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $582a7073b9f425dc$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $582a7073b9f425dc$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $582a7073b9f425dc$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $582a7073b9f425dc$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $582a7073b9f425dc$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $582a7073b9f425dc$export$3e9cee6b33872309(!$582a7073b9f425dc$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($582a7073b9f425dc$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $582a7073b9f425dc$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $582a7073b9f425dc$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($582a7073b9f425dc$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $582a7073b9f425dc$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $582a7073b9f425dc$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $582a7073b9f425dc$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($582a7073b9f425dc$var$isErrorResult(result)) {
            let boundaryMatch = $582a7073b9f425dc$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $582a7073b9f425dc$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($582a7073b9f425dc$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $582a7073b9f425dc$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($582a7073b9f425dc$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $582a7073b9f425dc$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $582a7073b9f425dc$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $582a7073b9f425dc$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $582a7073b9f425dc$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $582a7073b9f425dc$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $582a7073b9f425dc$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $582a7073b9f425dc$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $582a7073b9f425dc$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $582a7073b9f425dc$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $582a7073b9f425dc$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $582a7073b9f425dc$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($582a7073b9f425dc$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $582a7073b9f425dc$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $582a7073b9f425dc$export$8ccf933b0513f8d0(path) : path;
    return $582a7073b9f425dc$export$fe53371bee54353d($582a7073b9f425dc$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $582a7073b9f425dc$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $582a7073b9f425dc$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $582a7073b9f425dc$var$ResultType.data || result.type === $582a7073b9f425dc$var$ResultType.error);
}
function $582a7073b9f425dc$var$isRedirectDataStrategyResultResult(result) {
    return $582a7073b9f425dc$var$isResponse(result.result) && $582a7073b9f425dc$var$redirectStatusCodes.has(result.result.status);
}
function $582a7073b9f425dc$var$isDeferredResult(result) {
    return result.type === $582a7073b9f425dc$var$ResultType.deferred;
}
function $582a7073b9f425dc$var$isErrorResult(result) {
    return result.type === $582a7073b9f425dc$var$ResultType.error;
}
function $582a7073b9f425dc$var$isRedirectResult(result) {
    return (result && result.type) === $582a7073b9f425dc$var$ResultType.redirect;
}
function $582a7073b9f425dc$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $582a7073b9f425dc$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $582a7073b9f425dc$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $582a7073b9f425dc$var$isRedirectResponse(result) {
    if (!$582a7073b9f425dc$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $582a7073b9f425dc$var$isValidMethod(method) {
    return $582a7073b9f425dc$var$validRequestMethods.has(method.toLowerCase());
}
function $582a7073b9f425dc$var$isMutationMethod(method) {
    return $582a7073b9f425dc$var$validMutationMethods.has(method.toLowerCase());
}
async function $582a7073b9f425dc$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$582a7073b9f425dc$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($582a7073b9f425dc$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $582a7073b9f425dc$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $582a7073b9f425dc$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($582a7073b9f425dc$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $582a7073b9f425dc$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $582a7073b9f425dc$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $582a7073b9f425dc$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $582a7073b9f425dc$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $582a7073b9f425dc$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $582a7073b9f425dc$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $582a7073b9f425dc$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $582a7073b9f425dc$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $582a7073b9f425dc$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $582a7073b9f425dc$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $582a7073b9f425dc$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $582a7073b9f425dc$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $582a7073b9f425dc$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $582a7073b9f425dc$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $582a7073b9f425dc$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $582a7073b9f425dc$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $582a7073b9f425dc$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $582a7073b9f425dc$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($582a7073b9f425dc$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $582a7073b9f425dc$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($582a7073b9f425dc$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $582a7073b9f425dc$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});


parcelRegister("iGXQt", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ALLOWED_FEATURES", () => $e5ba9f1e0b940d7c$export$a33327ada3a6ee4a);
$parcel$export(module.exports, "getAllowedFeatures", () => $e5ba9f1e0b940d7c$export$3207c60940c4a9b0);

var $4NmQO = parcelRequire("4NmQO");
var $2wsII = parcelRequire("2wsII");
var $e5ba9f1e0b940d7c$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $e5ba9f1e0b940d7c$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        'template-browser',
        'inline-comments'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $e5ba9f1e0b940d7c$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $e5ba9f1e0b940d7c$var$pageAllowedFeatures = {
    [(0, $2wsII.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $e5ba9f1e0b940d7c$export$a3fda3dcee62e1cc.edit,
    [(0, $2wsII.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $e5ba9f1e0b940d7c$export$a3fda3dcee62e1cc.view
};
const $e5ba9f1e0b940d7c$var$blogPostAllowedFeatures = {
    [(0, $2wsII.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $e5ba9f1e0b940d7c$export$a3fda3dcee62e1cc.edit,
    [(0, $2wsII.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $e5ba9f1e0b940d7c$export$a3fda3dcee62e1cc.view
};
const $e5ba9f1e0b940d7c$var$whiteboardAllowedFeatures = {
    [(0, $2wsII.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $e5ba9f1e0b940d7c$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $2wsII.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $e5ba9f1e0b940d7c$export$a3fda3dcee62e1cc.whiteboard
};
const $e5ba9f1e0b940d7c$var$contentTypeAllowedFeatures = {
    [(0, $4NmQO.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $e5ba9f1e0b940d7c$var$pageAllowedFeatures,
    [(0, $4NmQO.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $e5ba9f1e0b940d7c$var$blogPostAllowedFeatures,
    [(0, $4NmQO.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $e5ba9f1e0b940d7c$var$whiteboardAllowedFeatures
};
const $e5ba9f1e0b940d7c$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$e5ba9f1e0b940d7c$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];

});
parcelRegister("4NmQO", function(module, exports) {

$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_CONTENT_TYPE", () => $67ee9014da0bfeee$export$942a5fac9b8c9dc2);
var $67ee9014da0bfeee$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});

});


parcelRegister("a4n1w", function(module, exports) {

$parcel$export(module.exports, "EDIT_PAGE_EMBED", () => $805d5e42f0a7913e$export$e63a462ee45b57cf);
$parcel$export(module.exports, "EDIT_PAGE_V2", () => $805d5e42f0a7913e$export$7b1285e36c635f1f);
$parcel$export(module.exports, "VIEW_PAGE", () => $805d5e42f0a7913e$export$9257b5b55c8e2555);
$parcel$export(module.exports, "VIEW_BLOG", () => $805d5e42f0a7913e$export$91f49e7b30a9d34);
$parcel$export(module.exports, "VIEW_BLOG_DATE_LEGACY", () => $805d5e42f0a7913e$export$bd2c9bb170b3681d);
$parcel$export(module.exports, "WHITEBOARD", () => $805d5e42f0a7913e$export$fbefbcc1445e8d74);
$parcel$export(module.exports, "namedRoutes", () => $805d5e42f0a7913e$export$d4971375353d0454);
$parcel$export(module.exports, "EMBEDDED_PARENT_PRODUCTS", () => $805d5e42f0a7913e$export$5c59aa0922e65f1a);
const $805d5e42f0a7913e$export$e63a462ee45b57cf = {
    name: 'EDIT_PAGE_EMBED',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-embed/:contentId/:contentSlug?'
};
const $805d5e42f0a7913e$export$7b1285e36c635f1f = {
    name: 'EDIT_PAGE_V2',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-v2/:contentId/:contentSlug?'
};
const $805d5e42f0a7913e$export$65b723bb995d4fb6 = {
    name: 'SPACE_OVERVIEW',
    pattern: '/wiki/spaces/:spaceKey/overview'
};
const $805d5e42f0a7913e$export$9257b5b55c8e2555 = {
    name: 'VIEW_PAGE',
    pattern: '/wiki/spaces/:spaceKey/pages/:contentId/:contentSlug?'
};
const $805d5e42f0a7913e$export$91f49e7b30a9d34 = {
    name: 'VIEW_BLOG',
    pattern: '/wiki/spaces/:spaceKey/blog/:contentId/:contentSlug?'
};
const $805d5e42f0a7913e$export$bd2c9bb170b3681d = {
    name: 'VIEW_BLOG_DATE_LEGACY',
    pattern: '/wiki/spaces/:spaceKey/blog/:year/:month/:day/:contentId/:contentSlug?'
};
const $805d5e42f0a7913e$export$fbefbcc1445e8d74 = {
    name: 'WHITEBOARD',
    pattern: '/wiki/spaces/:spaceKey/whiteboard/:contentId/:contentSlug?'
};
const $805d5e42f0a7913e$export$d4971375353d0454 = {
    EDIT_PAGE_EMBED: $805d5e42f0a7913e$export$e63a462ee45b57cf,
    EDIT_PAGE_V2: $805d5e42f0a7913e$export$7b1285e36c635f1f,
    SPACE_OVERVIEW: $805d5e42f0a7913e$export$65b723bb995d4fb6,
    VIEW_PAGE: $805d5e42f0a7913e$export$9257b5b55c8e2555,
    VIEW_BLOG: $805d5e42f0a7913e$export$91f49e7b30a9d34,
    VIEW_BLOG_DATE_LEGACY: $805d5e42f0a7913e$export$bd2c9bb170b3681d,
    WHITEBOARD: $805d5e42f0a7913e$export$fbefbcc1445e8d74
};
const $805d5e42f0a7913e$export$5c59aa0922e65f1a = {
    JSM_PORTAL: 'JSM-Portal',
    JSM: 'JSM',
    JSW: 'JSW',
    JWM: 'JWM'
};

});


parcelRegister("bvqNo", function(module, exports) {

$parcel$export(module.exports, "ConfluenceContentTypes", () => $ea031aa9e3d5ef89$export$b39616d00ee96d40);
$parcel$export(module.exports, "DisplayTypes", () => $ea031aa9e3d5ef89$export$c294d3f3727c1a0);
const $ea031aa9e3d5ef89$export$b39616d00ee96d40 = {
    WHITEBOARD: 'whiteboard',
    PAGE: 'page'
};
const $ea031aa9e3d5ef89$export$c294d3f3727c1a0 = {
    MODAL: 'modal',
    PANEL: 'panel'
};

});


parcelRegister("5labn", function(module, exports) {

$parcel$export(module.exports, "getDisplayInformation", () => $e7deee7a3cbc4953$export$ee79869f97207574);
$parcel$export(module.exports, "convertUrlByContentState", () => $e7deee7a3cbc4953$export$d41c9cdfa202e9a7);

var $2wsII = parcelRequire("2wsII");

var $bvqNo = parcelRequire("bvqNo");
const $e7deee7a3cbc4953$export$37e31995727dc8d7 = 0.5;
const $e7deee7a3cbc4953$export$ee79869f97207574 = ()=>{
    /*
	We set the screen width to 50% of the screen width if the screen
	width is larger than 1024px because we want the Embedded Confluence in the side panel to
	take up half the screen width. The max of the side panel is 50% of the screen width and
	we are not able to set it wider. Jira Issue details panel will be forced down around 1875px
	screen width.
	If the screen width is less than 1024px, we'll set the panel width to 0 because we will be
	opening the EmbeddedContentModal instead and set displayType to Modal.
	This also assumes that we are currently on the full page version of a Jira Issue.
	*/ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1024) return {
        initialWidth: screenWidth * $e7deee7a3cbc4953$export$37e31995727dc8d7,
        displayType: (0, $bvqNo.DisplayTypes).PANEL
    };
    return {
        initialWidth: 0,
        displayType: (0, $bvqNo.DisplayTypes).MODAL
    };
};
const $e7deee7a3cbc4953$export$d41c9cdfa202e9a7 = ({ mode: mode, isDraft: isDraft, contentUrl: contentUrl, spaceKey: spaceKey })=>{
    // update spaceKey
    let newUrl = contentUrl.replace(/\/spaces\/.*?\/pages\//, `/spaces/${spaceKey}/pages/`);
    if (!isDraft) {
        // remove `draftShareId={id}` and the preceding `&` if it exists
        newUrl = newUrl.replace(/[&]*draftShareId=[^&]*/, '');
        if (mode === (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE) {
            if (!newUrl.includes('edit-embed')) newUrl = newUrl.replace('/pages/', '/pages/edit-embed/');
        } else if (mode === (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE) // Replaces /pages/edit-v2/ or /pages/edit-embed/ with /pages/
        newUrl = newUrl.replace(/\/pages\/edit[^/]*\//, '/pages/');
    }
    return newUrl;
};

});


parcelRegister("9V9QO", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPanelEntryPoint", () => $a6b6d10e82ec149e$export$75ef2f025ecbf1de);

var $5uXOq = parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $2wsII = parcelRequire("2wsII");
var $cWJzY = parcelRequire("cWJzY");

var $gXSrH = parcelRequire("gXSrH");

var $5labn = parcelRequire("5labn");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $BVLE8 = parcelRequire("BVLE8");

var $f3TN2 = parcelRequire("f3TN2");

var $dELl0 = parcelRequire("dELl0");

var $2POIy = parcelRequire("2POIy");

var $iwjqc = parcelRequire("iwjqc");

var $iXWB9 = parcelRequire("iXWB9");

var $4TSh0 = parcelRequire("4TSh0");

var $fvjUj = parcelRequire("fvjUj");

var $15U5v = parcelRequire("15U5v");
const $a6b6d10e82ec149e$var$entryPointParams = {};
const $a6b6d10e82ec149e$export$12346a674644c156 = 'operational';
const $a6b6d10e82ec149e$export$b81d6f4511cb89a5 = (action, eventName, params)=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent, setConfluenceData: setConfluenceData, contentUrl: contentUrl, embeddedConfluenceSourceForPanel: embeddedConfluenceSourceForPanel, isOpen: isOpen, mode: mode } = params;
    fireAnalyticsEvent({
        action: action,
        eventName: eventName,
        embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
        eventType: $a6b6d10e82ec149e$export$12346a674644c156
    });
    if (isOpen && (0, $4R6GH.fg)('jira_issue_view_expand_modeless_ep')) {
        if (eventName === 'edit-page/close') setConfluenceData({
            contentUrl: contentUrl,
            mode: (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
        });
        if (eventName === 'edit-page/load' && action === 'taskSuccess') {
            if (mode === (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE) setConfluenceData({
                contentUrl: contentUrl,
                mode: (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE
            });
        }
        if (eventName === 'edit-page/publish' && action === 'taskSuccess') {
            if (mode === (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE) setConfluenceData({
                isDraft: false,
                contentUrl: contentUrl,
                mode: (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
            });
        }
    }
};
const $a6b6d10e82ec149e$export$75ef2f025ecbf1de = ()=>{
    const { locale: locale } = (0, $koVbs.default)();
    const [state, actions] = (0, $gXSrH.useEmbeddedConfluenceSidePanel)();
    const { contentType: contentType, confluenceData: { contentId: contentId, contentUrl: contentUrl, hostname: hostname, isLive: isLive, isDraft: isDraft, title: title, mode: mode }, isDeferSpaceSelection: isDeferSpaceSelection, contentActions: { onLinkPage: onLinkPage }, panel: { isOpen: isOpen, isExpanded: isExpanded }, embeddedConfluenceSource: embeddedConfluenceSource } = state;
    const isPageDraft = isDraft && contentType === (0, $f3TN2.CONTENT_TYPE).PAGE;
    const parentProduct = (0, $fvjUj.useParentProduct)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $2POIy.embeddedPanelEntrypoint), $a6b6d10e82ec149e$var$entryPointParams);
    const embeddedConfluenceSourceForPanel = `${embeddedConfluenceSource}Panel`;
    const fireAnalyticsEvent = (0, $4TSh0.useEmbeddedPageTracking)();
    const themeState = (0, $6VxGE.default)();
    /*
  	If the user is on a custom domain, we need to update the
  	hostname to reflect the parentProduct's hostname. By providing the hostname
  	prop we will force EP to use the parentProduct's hostname instead of the content's hostname
  	when on a custom domain (see EP code here https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/confluence/embedded-confluence-common/src/page/parsePageProps.ts#75).
  */ const contentHostname = (0, $iwjqc.setHostnameForContent)(contentUrl, hostname);
    const onContentAction = (0, $5uXOq.useCallback)((action, eventName)=>{
        $a6b6d10e82ec149e$export$b81d6f4511cb89a5(action, eventName, {
            fireAnalyticsEvent: fireAnalyticsEvent,
            setConfluenceData: actions.setConfluenceData,
            contentUrl: contentUrl,
            embeddedConfluenceSourceForPanel: embeddedConfluenceSourceForPanel,
            isOpen: isOpen,
            mode: mode
        });
    }, [
        actions,
        contentUrl,
        fireAnalyticsEvent,
        embeddedConfluenceSourceForPanel,
        isOpen,
        mode
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        fireAnalyticsEvent({
            action: 'clicked',
            eventName: 'closeEmbeddedConfluencePanel',
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel
        });
        entryPointActions.unload();
        actions.closeSidePanel();
    }, [
        actions,
        fireAnalyticsEvent,
        entryPointActions,
        embeddedConfluenceSourceForPanel
    ]);
    const editAllowedFeatures = (0, $5uXOq.useMemo)(()=>[
            ...isDeferSpaceSelection ? [
                'publish-modal'
            ] : [],
            'template-browser'
        ], [
        isDeferSpaceSelection
    ]);
    const shouldApplyEditFeatures = editAllowedFeatures.length > 0 && isDraft;
    const shouldOpenPanel = isOpen && contentUrl;
    const { entryPointActions: epDraftModalActions, entryPointReferenceSubject: epDraftModalSubject } = (0, $4mO32.useEntryPoint)((0, $dELl0.draftEmbeddedPageModalEntrypoint), {});
    const { entryPointActions: epModalActions, entryPointReferenceSubject: epModalSubject } = (0, $4mO32.useEntryPoint)((0, $BVLE8.embeddedConfluencePageModalEntrypoint), {});
    const { entryPointActions: whiteboardModalActions, entryPointReferenceSubject: whiteboardModalSubject } = (0, $4mO32.useEntryPoint)((0, $15U5v.embeddedWhiteboardModalEntrypoint), {});
    const { openContinueDraftModal: openContinueDraftModal, handleEmbeddedContentAction: handleDraftContentAction, epMode: epMode } = (0, $iXWB9.useEmbeddedPageDraft)({
        url: contentUrl,
        isLive: isLive,
        embeddedConfluenceSource: embeddedConfluenceSource,
        onEmbeddedContentAction: onContentAction,
        onClose: onClose,
        linkConfluencePage: onLinkPage
    });
    const handleOnModalClose = (0, $5uXOq.useCallback)(()=>{
        actions.closeSidePanel();
        if (contentType === 'whiteboard' && (0, $4R6GH.fg)('jira_issue_view_modeless_whiteboard')) whiteboardModalActions.unload();
        else if (contentType === 'page') isPageDraft ? epDraftModalActions.unload() : epModalActions.unload();
    }, [
        actions,
        isPageDraft,
        epDraftModalActions,
        epModalActions,
        whiteboardModalActions,
        contentType
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            locale: locale,
            hasFooterLogo: false,
            isDraft: isDraft,
            isLive: isLive,
            hostname: contentHostname,
            panelTitle: title,
            navigationPolicy: undefined,
            onClose: onClose,
            onContentAction: onContentAction,
            parentProduct: parentProduct,
            spaceKey: (0, $cWJzY.parseUrl)(contentUrl)?.spaceKey,
            themeState: themeState,
            url: (0, $5labn.convertUrlByContentState)({
                mode: mode,
                isDraft: isDraft,
                contentUrl: contentUrl,
                spaceKey: (0, $cWJzY.parseUrl)(contentUrl)?.spaceKey
            }),
            mode: isPageDraft ? epMode : mode,
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
            contentId: contentId,
            contentType: contentType,
            onPublish: actions.setDeferredSpaceData,
            allowedFeatures: {
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-comments',
                    'page-reactions',
                    'inline-comments',
                    'non-licensed-share'
                ],
                ...shouldApplyEditFeatures && {
                    edit: editAllowedFeatures
                }
            },
            linkConfluencePage: onLinkPage
        }), [
        actions.setDeferredSpaceData,
        contentId,
        contentUrl,
        editAllowedFeatures,
        embeddedConfluenceSourceForPanel,
        contentHostname,
        isDraft,
        isLive,
        locale,
        title,
        mode,
        epMode,
        onClose,
        onContentAction,
        onLinkPage,
        parentProduct,
        themeState,
        shouldApplyEditFeatures,
        isPageDraft,
        contentType
    ]);
    const whiteboardModalRuntimeProps = (0, $5uXOq.useMemo)(()=>({
            isOpen: true,
            locale: locale,
            hasFooterLogo: false,
            hostname: contentHostname,
            panelTitle: title,
            navigationPolicy: undefined,
            enableContract: true,
            onClose: onClose,
            onEmbeddedContentAction: onContentAction,
            onContract: actions.toggleExpandedState,
            parentProduct: parentProduct,
            spaceKey: (0, $cWJzY.parseUrl)(contentUrl)?.spaceKey,
            themeState: themeState,
            url: contentUrl,
            embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
            contentId: contentId || (0, $cWJzY.parseUrl)(contentUrl)?.contentId || '',
            contentType: contentType
        }), [
        contentId,
        contentType,
        contentUrl,
        embeddedConfluenceSourceForPanel,
        contentHostname,
        locale,
        title,
        onClose,
        onContentAction,
        parentProduct,
        themeState,
        actions.toggleExpandedState
    ]);
    const epModalRuntimeProps = (0, $5uXOq.useMemo)(()=>({
            locale: locale,
            hasFooterLogo: false,
            isDraft: isDraft,
            isOpen: true,
            enableContract: true,
            onClose: ()=>{
                isPageDraft ? openContinueDraftModal() : handleOnModalClose();
            },
            onContract: actions.toggleExpandedState,
            parentProduct: parentProduct,
            url: (0, $5labn.convertUrlByContentState)({
                mode: mode,
                isDraft: isDraft,
                contentUrl: contentUrl,
                spaceKey: (0, $cWJzY.parseUrl)(contentUrl)?.spaceKey
            }),
            mode: isPageDraft ? epMode : mode,
            isLive: isLive,
            embeddedConfluenceSource: embeddedConfluenceSource,
            spaceKey: (0, $cWJzY.parseUrl)(contentUrl)?.spaceKey,
            contentId: (0, $cWJzY.parseUrl)(contentUrl)?.contentId,
            onPublish: actions.setDeferredSpaceData,
            allowedFeatures: {
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-comments',
                    'page-reactions',
                    'inline-comments',
                    'non-licensed-share'
                ],
                ...shouldApplyEditFeatures && {
                    edit: editAllowedFeatures
                }
            },
            linkConfluencePage: onLinkPage,
            themeState: themeState,
            onPageAction: isPageDraft ? handleDraftContentAction : onContentAction,
            navigationPolicy: undefined,
            hostname: contentHostname,
            isFullScreenEmbedView: true
        }), [
        locale,
        isDraft,
        actions.toggleExpandedState,
        actions.setDeferredSpaceData,
        parentProduct,
        isPageDraft,
        mode,
        epMode,
        contentUrl,
        isLive,
        embeddedConfluenceSource,
        themeState,
        handleDraftContentAction,
        onContentAction,
        contentHostname,
        openContinueDraftModal,
        handleOnModalClose,
        onLinkPage,
        editAllowedFeatures,
        shouldApplyEditFeatures
    ]);
    const setEntrypointActions = ()=>{
        if (!isExpanded) return entryPointActions;
        if (contentType === 'whiteboard' && (0, $4R6GH.fg)('jira_issue_view_modeless_whiteboard')) return whiteboardModalActions;
        if (contentType === 'page' && (0, $4R6GH.fg)('jira_issue_view_modeless_whiteboard')) return isDraft ? epDraftModalActions : epModalActions;
        // TODO remove this when cleaning up jira_issue_view_modeless_whiteboard
        return isDraft ? epDraftModalActions : epModalActions;
    };
    const setExpandedEntryPointData = ()=>{
        if (contentType === 'page') {
            if (isDraft) return {
                id: 'epDraftModalEntrypointContainer',
                entryPointReferenceSubject: epDraftModalSubject,
                runtimeProps: epModalRuntimeProps
            };
            return {
                id: 'epModalEntrypointContainer',
                entryPointReferenceSubject: epModalSubject,
                runtimeProps: epModalRuntimeProps
            };
        }
        if (contentType === 'whiteboard') return {
            id: 'embeddedWhiteboardModalEntrypointContainer',
            entryPointReferenceSubject: whiteboardModalSubject,
            runtimeProps: whiteboardModalRuntimeProps
        };
    };
    const entryPointData = setExpandedEntryPointData();
    // TODO remove this when cleaning up fg('jira_issue_view_modeless_whiteboard')
    const entryPointIdOld = isPageDraft ? 'epDraftModalEntrypointContainer' : 'epModalEntrypointContainer';
    // TODO remove this when cleaning up fg('jira_issue_view_modeless_whiteboard')
    const entryPointSubjectOld = isPageDraft ? epDraftModalSubject : epModalSubject;
    const expandedEntryPointContainer = ()=>{
        if ((0, $4R6GH.fg)('jira_issue_view_modeless_whiteboard')) {
            if (contentType === 'page') {
                if (isDraft) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                    entryPointReferenceSubject: epDraftModalSubject,
                    id: "epDraftModalEntrypointContainer",
                    packageName: "@atlassian/jira-issue-create-confluence-content",
                    teamName: "confluence-better-together",
                    runtimeProps: epModalRuntimeProps
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                    entryPointReferenceSubject: epModalSubject,
                    id: "epModalEntrypointContainer",
                    packageName: "@atlassian/jira-issue-create-confluence-content",
                    teamName: "confluence-better-together",
                    runtimeProps: epModalRuntimeProps
                });
            }
            if (contentType === 'whiteboard') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: whiteboardModalSubject,
                id: "embeddedWhiteboardModalEntrypointContainer",
                packageName: "@atlassian/jira-issue-create-confluence-content",
                teamName: "confluence-better-together",
                runtimeProps: whiteboardModalRuntimeProps
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointSubjectOld,
            id: entryPointIdOld,
            packageName: "@atlassian/jira-issue-create-confluence-content",
            teamName: "confluence-better-together",
            runtimeProps: epModalRuntimeProps
        });
    };
    return shouldOpenPanel && entryPointData ? {
        entryPointActions: setEntrypointActions(),
        entryPoint: isExpanded ? expandedEntryPointContainer() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "epPanelEntrypointContainer",
            packageName: "@atlassian/jira-issue-create-confluence-content",
            teamName: "confluence-better-together",
            runtimeProps: runtimeProps
        })
    } : {
        ref: undefined,
        entryPoint: null
    };
};

});
parcelRegister("BVLE8", function(module, exports) {

$parcel$export(module.exports, "embeddedConfluencePageModalEntrypoint", () => $0287eee493e1b44f$export$2798102ac94287d0);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $0287eee493e1b44f$export$2798102ac94287d0 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("iVqKC")), {
        moduleId: "73170883"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iVqKC", function(module, exports) {

let $dc724d050a6f97f6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dc724d050a6f97f6$var$load("cM9em"),
    $dc724d050a6f97f6$var$load("fr9NE"),
    $dc724d050a6f97f6$var$load("68a9Q")
]).then(()=>parcelRequire('dhviw'));

});


parcelRegister("f3TN2", function(module, exports) {

$parcel$export(module.exports, "LINK_CREATE_DRAFT_STATUS", () => $8629cdb22def106f$export$b86d51ea0323efca);
$parcel$export(module.exports, "CONTENT_TYPE", () => $8629cdb22def106f$export$a982aaff75f1c348);
$parcel$export(module.exports, "CONTENT_TYPE_TO_ENTITY_KEYS", () => $8629cdb22def106f$export$de75e0e058bd457c);

var $1AQ80 = parcelRequire("1AQ80");
const $8629cdb22def106f$export$b86d51ea0323efca = 'draft';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $8629cdb22def106f$var$LINK_CREATE_PUBLISH_STATUS = 'current';
const $8629cdb22def106f$export$a982aaff75f1c348 = {
    PAGE: 'page',
    WHITEBOARD: 'whiteboard'
};
const $8629cdb22def106f$export$de75e0e058bd457c = {
    [$8629cdb22def106f$export$a982aaff75f1c348.PAGE]: (0, $1AQ80.entityKeys).confluencePage,
    [$8629cdb22def106f$export$a982aaff75f1c348.WHITEBOARD]: (0, $1AQ80.entityKeys).confluenceWhiteboard
};

});
parcelRegister("1AQ80", function(module, exports) {

$parcel$export(module.exports, "entityKeys", () => $e02fb38517461d1d$export$be0551febfd6121e);
$parcel$export(module.exports, "ContentTypes", () => $e02fb38517461d1d$export$b9e669a853ca2f38);
$parcel$export(module.exports, "Fields", () => $e02fb38517461d1d$export$833b3e5a19fb8939);
$parcel$export(module.exports, "testIds", () => $e02fb38517461d1d$export$800daf5fbbe96aff);
$parcel$export(module.exports, "CONFLUENCE_EVENT_NAME", () => $e02fb38517461d1d$export$c312550dc4e28902);
const $e02fb38517461d1d$export$be0551febfd6121e = {
    confluencePage: 'confluence-page',
    confluenceWhiteboard: 'confluence-whiteboard'
};
const $e02fb38517461d1d$export$b9e669a853ca2f38 = {
    PAGE: 'page',
    WHITEBOARD: 'whiteboard'
};
var $e02fb38517461d1d$export$833b3e5a19fb8939 = /*#__PURE__*/ function(Fields) {
    Fields["Title"] = "title";
    Fields["Site"] = "site";
    Fields["SpacePage"] = "space_or_page";
    return Fields;
}({});
const $e02fb38517461d1d$export$800daf5fbbe96aff = {
    form: 'link-create-confluence-form',
    title: 'link-create-confluence-title',
    site: 'link-create-confluence-site-picker',
    space: 'link-create-confluence-space-picker',
    error: 'link-create-confluence-form-error'
};
const $e02fb38517461d1d$export$c312550dc4e28902 = {
    EDIT_PAGE: 'edit-page',
    EDIT_PAGE_LOAD: 'edit-page/load',
    EDIT_PAGE_PUBLISH: 'edit-page/publish',
    EDIT_PAGE_CLOSE: 'edit-page/close'
};

});


parcelRegister("dELl0", function(module, exports) {

$parcel$export(module.exports, "draftEmbeddedPageModalEntrypoint", () => $e5609c25f3baa9a1$export$11fd8fc5a8657f8);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $e5609c25f3baa9a1$export$11fd8fc5a8657f8 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("jmQps")), {
        moduleId: "a0941f4e"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jmQps", function(module, exports) {

let $e198b9d79c4e9901$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e198b9d79c4e9901$var$load("cM9em"),
    $e198b9d79c4e9901$var$load("fr9NE"),
    $e198b9d79c4e9901$var$load("cJ3gh")
]).then(()=>parcelRequire('61q45'));

});


parcelRegister("2POIy", function(module, exports) {

$parcel$export(module.exports, "embeddedPanelEntrypoint", () => $ae604dc9c27c8401$export$32561f984de7bece);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $ae604dc9c27c8401$export$32561f984de7bece = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("lMzfr")), {
        moduleId: "293c24d0"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lMzfr", function(module, exports) {

let $fdb96c3417e844b8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fdb96c3417e844b8$var$load("joESl").then(()=>parcelRequire('k1Lui'));

});


parcelRegister("iwjqc", function(module, exports) {

$parcel$export(module.exports, "createActivePageUrl", () => $5538d20fe7287eae$export$83c6318baef117fe);
$parcel$export(module.exports, "getURLFromConfluencePageResponse", () => $5538d20fe7287eae$export$e87b28852220b5cd);
$parcel$export(module.exports, "setHostnameForContent", () => $5538d20fe7287eae$export$8ccd4cc378896990);
$parcel$export(module.exports, "constructUrlIfCustomDomain", () => $5538d20fe7287eae$export$a63ef4c6a1286e2a);
$parcel$export(module.exports, "createLinkCreatePayload", () => $5538d20fe7287eae$export$af98278c506da0f4);

var $gKZoD = parcelRequire("gKZoD");

var $Geeam = parcelRequire("Geeam");

var $jg9TU = parcelRequire("jg9TU");
const $5538d20fe7287eae$export$f31b9480a5e4fdcf = (uri)=>{
    if (!uri || uri === '') return '';
    const matches = uri.match(/draftShareId=([^&])*/g);
    return matches ? matches[0].split('=')[1] : '';
};
const $5538d20fe7287eae$export$be3b1ed3560ef0e6 = ({ url: url, spaceId: spaceId, spaceKey: spaceKey })=>{
    if (!(url && spaceId && spaceKey)) return '';
    return url.replace(`spaces/${spaceId}`, `spaces/${spaceKey}`);
};
const $5538d20fe7287eae$export$83c6318baef117fe = (createPayload)=>{
    const { data: data, url: url } = createPayload;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const links = data?.links;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const spaceKey = data?.spaceKey;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const spaceId = data?.spaceId;
    const linkableUrl = $5538d20fe7287eae$export$be3b1ed3560ef0e6({
        url: url,
        spaceId: spaceId,
        spaceKey: spaceKey
    });
    if (data?.subType === 'live') return `${linkableUrl}`;
    return `${linkableUrl}?draftShareId=${$5538d20fe7287eae$export$f31b9480a5e4fdcf(links?.editui)}`;
};
const $5538d20fe7287eae$export$e87b28852220b5cd = ({ id: id, spaceKey: spaceKey, hostname: hostname })=>`${hostname}/wiki/spaces/${spaceKey}/pages/edit-v2/${id}/`;
const $5538d20fe7287eae$var$isUrlCustomDomain = (parentHost, url)=>{
    const hostname = (0, $Geeam.getHostnameFromUrl)(url);
    return (0, $jg9TU.isCustomDomain)(parentHost) || hostname && (0, $jg9TU.isCustomDomain)(hostname);
};
const $5538d20fe7287eae$export$8ccd4cc378896990 = (url, hostname)=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const parentHost = window?.location?.origin || '';
    const contentHost = hostname ?? (0, $Geeam.getHostnameFromUrl)(url);
    return $5538d20fe7287eae$var$isUrlCustomDomain(parentHost, url) ? (0, $Geeam.getHostnameFromUrl)(parentHost) : contentHost;
};
const $5538d20fe7287eae$export$a63ef4c6a1286e2a = ({ id: id, originalDomain: originalDomain, originalUrl: originalUrl, spaceKey: spaceKey, systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl })=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const currentHostname = window?.location?.origin || '';
    const hostnameFromUrl = (0, $Geeam.getHostnameFromUrl)(originalDomain);
    const systemHostName = (0, $Geeam.getHostnameFromUrl)(systemConfluenceAppLinkUrl);
    /*
		If content is not on the same tenant, and custom domain is enabled, we need to update the hostname
		to reflect the parentProduct's hostname
	*/ if (systemHostName !== hostnameFromUrl && $5538d20fe7287eae$var$isUrlCustomDomain(currentHostname, originalDomain)) return $5538d20fe7287eae$export$e87b28852220b5cd({
        id: id,
        spaceKey: spaceKey,
        hostname: currentHostname
    });
    return originalUrl;
};
const $5538d20fe7287eae$export$af98278c506da0f4 = (createResponse, url, space, cloudId)=>({
        url: url,
        ari: `ari:cloud:confluence:${cloudId}:page/${createResponse.id}`,
        objectId: createResponse.id,
        objectType: 'page',
        data: {
            spaceId: space.spaceId,
            spaceKey: space.spaceKey,
            spaceName: space.spaceName,
            status: createResponse.status,
            subType: createResponse.subtype,
            links: createResponse._links
        }
    });

});
parcelRegister("Geeam", function(module, exports) {

$parcel$export(module.exports, "getHostnameFromUrl", () => $43eec760bfcb2d7e$export$280e79c794cf814e);

var $cN3DC = parcelRequire("cN3DC");
const $43eec760bfcb2d7e$export$280e79c794cf814e = (url)=>(0, $cN3DC.isValidUrl)(url) ? new URL(url)?.hostname : '';

});
parcelRegister("cN3DC", function(module, exports) {

$parcel$export(module.exports, "isValidUrl", () => $8759602a30c2f837$export$bef94a5618bf18bf);
const $8759602a30c2f837$export$bef94a5618bf18bf = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch (e) {
        return false;
    }
};

});


parcelRegister("jg9TU", function(module, exports) {

$parcel$export(module.exports, "isCustomDomain", () => $cbdd6bc245553e48$export$97f4c254b641e719);
const $cbdd6bc245553e48$var$atlassianDomains = [
    '.atlassian.com',
    '.atlassian.net',
    '.jira-dev.com',
    '.jira.com',
    '.atlassian-stg-fedm.net',
    '.atlassian-us-gov-mod.net',
    '.atlassian-us-gov-mod.com'
];
const $cbdd6bc245553e48$export$97f4c254b641e719 = (hostname)=>!$cbdd6bc245553e48$var$atlassianDomains.some((domain)=>hostname.endsWith(domain));

});


parcelRegister("iXWB9", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPageDraft", () => $b6835e7ecd7c9a8c$export$8df6d110f6d46988);

var $5uXOq = parcelRequire("5uXOq");

var $2wsII = parcelRequire("2wsII");

var $gXSrH = parcelRequire("gXSrH");

var $jcw0u = parcelRequire("jcw0u");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $bngFq = parcelRequire("bngFq");


var $agXTJ = parcelRequire("agXTJ");

var $4TSh0 = parcelRequire("4TSh0");

var $kHHi5 = parcelRequire("kHHi5");
const $b6835e7ecd7c9a8c$export$f0ebd8c41d592251 = 'success';
const $b6835e7ecd7c9a8c$export$12346a674644c156 = 'operational';
const $b6835e7ecd7c9a8c$export$8df6d110f6d46988 = ({ isLive: isLive, embeddedConfluenceSource: embeddedConfluenceSource, onClose: onClose, url: url, onEmbeddedContentAction: onEmbeddedContentAction, linkConfluencePage: linkConfluencePage })=>{
    const [{ panel: { isOpen: isOpen } }, actions] = (0, $gXSrH.useEmbeddedConfluenceSidePanel)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [isContinueDraftOpen, setIsContinueDraftOpen] = (0, $5uXOq.useState)(false);
    const [isPublished, setIsPublished] = (0, $5uXOq.useState)(false);
    const [epMode, setEpMode] = (0, $5uXOq.useState)(isLive ? (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE : (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const fireAnalyticsEvent = (0, $4TSh0.useEmbeddedPageTracking)();
    const deferSpaceToast = (0, $co1wz.ff)('toast_defer_space_ntufi');
    const [{ confluenceData: { deferredSpaceName: deferredSpaceName } }] = (0, $gXSrH.useEmbeddedConfluenceSidePanel)();
    const handledLiveDocUrls = (0, $5uXOq.useRef)(new Set());
    (0, $5uXOq.useEffect)(()=>{
        if (deferSpaceToast && deferredSpaceName && isPublished) showFlag({
            key: (0, $7HGHK.toFlagId)((0, $a63f58192733759b$export$7f116601c876d82a)),
            type: 'success',
            title: formatMessage((0, $kHHi5.default).publishPageSuccessTitle),
            description: formatMessage((0, $kHHi5.default).deferSpacePublishPageSuccessDescription, {
                spaceName: deferredSpaceName
            }),
            messageId: 'issue-create-confluence-content.controllers.use-embedded-page-draft.show-flag.success.defer-space-publish-draft-success-flag',
            messageType: 'transactional'
        });
    }, [
        formatMessage,
        isPublished,
        deferSpaceToast,
        deferredSpaceName,
        showFlag
    ]);
    const openContinueDraftModal = (0, $5uXOq.useCallback)(()=>{
        if (!isPublished) {
            setIsContinueDraftOpen(true);
            fireAnalyticsEvent({
                action: 'clicked',
                eventName: isLive ? 'closeLiveDoc' : 'closeUnpublishedDraft',
                embeddedConfluenceSource: embeddedConfluenceSource
            });
        } else onClose && onClose();
    }, [
        embeddedConfluenceSource,
        fireAnalyticsEvent,
        isLive,
        isPublished,
        onClose
    ]);
    const closeContinueDraftModal = ()=>{
        setIsContinueDraftOpen(false);
    };
    const closeAll = ()=>{
        closeContinueDraftModal();
        onClose && onClose();
    };
    const handleEmbeddedContentAction = (0, $5uXOq.useCallback)((action, name)=>{
        const linkingSuccessDescriptionMessage = ()=>{
            if ((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3')) return isLive ? (0, $kHHi5.default).linkLiveDocSuccessDescriptionIssueTermRefresh : (0, $kHHi5.default).publishAndLinkPageSuccessDescriptionIssueTermRefresh;
            return isLive ? (0, $kHHi5.default).linkLiveDocSuccessDescription : (0, $kHHi5.default).publishAndLinkPageSuccessDescription;
        };
        if (name === 'edit-page/close') {
            if (isPublished) {
                setEpMode((0, $2wsII.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE);
                if (isOpen && (0, $4R6GH.fg)('jira_issue_view_expand_modeless_ep')) actions.setConfluenceData({
                    contentUrl: url,
                    mode: (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
                });
            } else openContinueDraftModal();
        }
        if (name === 'edit-page/load' && action === 'taskSuccess') {
            if (epMode === (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE) {
                setEpMode((0, $2wsII.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                if (isOpen && (0, $4R6GH.fg)('jira_issue_view_expand_modeless_ep')) actions.setConfluenceData({
                    contentUrl: url,
                    mode: (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE
                });
            }
        }
        if (name === 'edit-page/publish' && action === 'taskSuccess') {
            if (isOpen && (0, $4R6GH.fg)('jira_issue_view_expand_modeless_ep')) actions.setConfluenceData({
                contentUrl: url,
                isDraft: false,
                mode: (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE
            });
            fireAnalyticsEvent({
                action: $b6835e7ecd7c9a8c$export$f0ebd8c41d592251,
                eventName: isLive ? 'createLiveDoc' : 'publishDraftPage',
                embeddedConfluenceSource: embeddedConfluenceSource,
                eventType: $b6835e7ecd7c9a8c$export$12346a674644c156
            });
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            if (isPublished && !isLive) showFlag({
                key: (0, $7HGHK.toFlagId)((0, $a63f58192733759b$export$e80a06e24863c775)),
                type: 'success',
                title: formatMessage((0, $kHHi5.default).publishPageSuccessTitle),
                description: formatMessage((0, $kHHi5.default).publishPageSuccessDescription),
                messageId: 'issue-create-confluence-content.controllers.use-embedded-page-draft.show-flag.success.publish-draft-success-flag',
                messageType: 'transactional'
            });
            else {
                setIsPublished(true);
                if (isOpen && (0, $4R6GH.fg)('jira_issue_view_expand_modeless_ep')) actions.setConfluenceData({
                    contentUrl: url,
                    isDraft: false
                });
                // TODO this is a temporary solution, remove when https://hello.atlassian.net/jira/software/projects/CBT/boards/4465?selectedIssue=CBT-2895 is complete
                setTimeout(()=>{
                    try {
                        if (linkConfluencePage) {
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            linkConfluencePage((0, $agXTJ.convertToViewPageUrl)(url), analyticsEvent);
                            fireAnalyticsEvent({
                                action: $b6835e7ecd7c9a8c$export$f0ebd8c41d592251,
                                eventName: isLive ? 'linkConfluenceLiveDoc' : 'linkConfluencePage',
                                embeddedConfluenceSource: embeddedConfluenceSource,
                                eventType: $b6835e7ecd7c9a8c$export$12346a674644c156
                            });
                            if (!deferSpaceToast) showFlag({
                                key: (0, $7HGHK.toFlagId)((0, $a63f58192733759b$export$26c0043b48580bae)),
                                type: 'success',
                                title: formatMessage(isLive ? (0, $kHHi5.default).linkLiveDocSuccessTitle : (0, $kHHi5.default).publishAndLinkPageSuccessTitle),
                                description: formatMessage(linkingSuccessDescriptionMessage()),
                                messageId: 'issue-create-confluence-content.controllers.use-embedded-page-draft.show-flag.success.link-page-success-flag',
                                messageType: 'transactional'
                            });
                        }
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        (0, $jcw0u.default)({
                            meta: {
                                id: isLive ? 'linkConfluenceLiveDoc' : 'linkConfluencePage',
                                teamName: 'confluence-better-together'
                            },
                            attributes: {
                                embeddedConfluenceSource: embeddedConfluenceSource
                            },
                            error: error
                        });
                        showFlag({
                            key: (0, $7HGHK.toFlagId)((0, $a63f58192733759b$export$4164631cfaaf3681)),
                            type: 'error',
                            title: formatMessage((0, $kHHi5.default).linkPageFailedTitle),
                            description: formatMessage((0, $kHHi5.default).linkPageFailedDescription),
                            messageId: 'issue-create-confluence-content.controllers.use-embedded-page-draft.show-flag.error.link-page-failed-flag',
                            messageType: 'transactional'
                        });
                    }
                }, 3500);
            }
        }
        if (name === 'edit-page/publish' && action === 'taskFail') (0, $jcw0u.default)({
            meta: {
                id: isLive ? 'createLiveDoc' : 'publishDraftPage',
                teamName: 'confluence-better-together'
            },
            attributes: {
                embeddedConfluenceSource: embeddedConfluenceSource
            },
            error: new Error(`Error publishing draft page: {name: ${name}, action: ${action}}`)
        });
        onEmbeddedContentAction && onEmbeddedContentAction(action, name);
    }, [
        createAnalyticsEvent,
        embeddedConfluenceSource,
        epMode,
        fireAnalyticsEvent,
        formatMessage,
        isPublished,
        deferSpaceToast,
        linkConfluencePage,
        onEmbeddedContentAction,
        openContinueDraftModal,
        showFlag,
        url,
        actions,
        isOpen,
        isLive
    ]);
    // This is a little weird, but to avoid duplicating the code above, if the page is live and state local state is !isPublished,
    // we simulate the action of publishing from inside the ep modal. This in turn displays the view page, link the page to the issue
    // and show the flag about the page being published and linked.
    (0, $5uXOq.useEffect)(()=>{
        if (isLive && embeddedConfluenceSource?.endsWith('Panel') && !handledLiveDocUrls.current.has(url)) {
            handledLiveDocUrls.current.add(url);
            if (handledLiveDocUrls.current.has(url)) handleEmbeddedContentAction('taskSuccess', 'edit-page/publish');
            else handleEmbeddedContentAction('taskFail', 'edit-page/publish');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLive,
        url
    ]);
    // in the case that the user creates a live doc and then wants to create a page, we must ensure we open the draft for the page in edit mode
    (0, $5uXOq.useEffect)(()=>{
        setEpMode(isLive ? (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE : (0, $2wsII.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
    }, [
        isLive
    ]);
    return {
        isContinueDraftOpen: isContinueDraftOpen,
        openContinueDraftModal: openContinueDraftModal,
        closeContinueDraftModal: closeContinueDraftModal,
        closeAll: closeAll,
        handleEmbeddedContentAction: handleEmbeddedContentAction,
        fireAnalyticsEvent: fireAnalyticsEvent,
        epMode: epMode
    };
};

});
const $a63f58192733759b$export$e80a06e24863c775 = 'publishDraftSuccess';
const $a63f58192733759b$export$7f116601c876d82a = 'deferSpacePublishDraftSuccess';
const $a63f58192733759b$export$26c0043b48580bae = 'linkPageSuccess';
const $a63f58192733759b$export$7600137866a0229f = 'publishDraftFailed';
const $a63f58192733759b$export$4164631cfaaf3681 = 'linkPageFailed';

parcelRegister("agXTJ", function(module, exports) {

$parcel$export(module.exports, "convertToViewPageUrl", () => $eade785ed1bc7542$export$fbd50b21ccd324a6);
const $eade785ed1bc7542$export$fbd50b21ccd324a6 = (url)=>// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    url.split('/').filter((part)=>part !== 'edit-v2').join('/');

});

parcelRegister("4TSh0", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPageTracking", () => $391c3839ff18e3b3$export$9fcd107e4ed1de75);

var $5uXOq = parcelRequire("5uXOq");

var $2gCtH = parcelRequire("2gCtH");

var $bngFq = parcelRequire("bngFq");

var $9OXo1 = parcelRequire("9OXo1");

var $kEkg3 = parcelRequire("kEkg3");

var $gFmVN = parcelRequire("gFmVN");
const $391c3839ff18e3b3$export$9fcd107e4ed1de75 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const source = (0, $2gCtH.useAnalyticsSource)();
    const trackEmbeddedConfluence = (0, $5uXOq.useCallback)(({ eventName: eventName, action: action, actionSubject: actionSubject, projectType: projectType, embeddedConfluenceSource: embeddedConfluenceSource = 'jiraIssueView', eventType: eventType = 'ui', userHasConfluenceAccess: userHasConfluenceAccess, tenantHasConfluence: tenantHasConfluence, crossJoinStatus: crossJoinStatus, originProduct: originProduct, requestedProduct: requestedProduct, linkObjectType: linkObjectType, confluenceContentId: confluenceContentId })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject ?? `${eventName}`
        });
        const attributes = {
            parentProduct: (0, $gFmVN.getParentProduct)(projectType),
            tenantEditions: tenantContext?.appEditions,
            productEntitlementDetails: tenantContext?.productEntitlementDetails,
            embeddedConfluenceSource: embeddedConfluenceSource,
            jiraIssueSurfaceArea: source,
            userHasConfluenceAccess: userHasConfluenceAccess,
            tenantHasConfluence: tenantHasConfluence,
            crossJoinStatus: crossJoinStatus,
            originProduct: originProduct,
            requestedProduct: requestedProduct,
            isSiteAdmin: tenantContext?.isSiteAdmin,
            linkObjectType: linkObjectType,
            confluenceContentId: confluenceContentId
        };
        (0, $kEkg3.fireEmbeddedConfluenceAnalytics)({
            analyticsEvent: analyticsEvent,
            attributes: attributes,
            eventType: eventType,
            eventName: `${actionSubject ?? eventName} ${action}`
        });
    }, [
        source,
        tenantContext,
        createAnalyticsEvent
    ]);
    return trackEmbeddedConfluence;
};

});
parcelRegister("kEkg3", function(module, exports) {

$parcel$export(module.exports, "fireEmbeddedConfluenceAnalytics", () => $502082c06cc8bb17$export$864bc2da9014e8e9);

var $8zOmE = parcelRequire("8zOmE");
const $502082c06cc8bb17$export$864bc2da9014e8e9 = ({ analyticsEvent: analyticsEvent, attributes: attributes, eventType: eventType, eventName: eventName })=>{
    switch(eventType){
        case 'ui':
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
            break;
        case 'operational':
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        case 'track':
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        default:
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
            break;
    }
};

});

parcelRegister("gFmVN", function(module, exports) {

$parcel$export(module.exports, "ACCESS_REQUEST_CAPABILITIES", () => $e40b1af8ddf646ed$export$b4e6d6efc113ca5);
$parcel$export(module.exports, "VALID_DIRECT_ACCESS_STATUS", () => $e40b1af8ddf646ed$export$bf1e31028b579014);
$parcel$export(module.exports, "ACCESS_DENIED_STATUSES", () => $e40b1af8ddf646ed$export$2fe5bb2d968b01fc);
$parcel$export(module.exports, "LICENCE_EXCEEDED_STATUS", () => $e40b1af8ddf646ed$export$56360b096b4b4439);
$parcel$export(module.exports, "getParentProduct", () => $e40b1af8ddf646ed$export$e873edb2560a07ef);

var $2vSU6 = parcelRequire("2vSU6");




const $e40b1af8ddf646ed$export$b4e6d6efc113ca5 = {
    ACCESS_GRANTED: 'ACCESS_GRANTED',
    ACCESS_EXISTS: 'ACCESS_EXISTS',
    DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
    DIRECT_ACCESS: 'DIRECT_ACCESS',
    FORBIDDEN: 'FORBIDDEN',
    PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
    REQUEST_ACCESS: 'REQUEST_ACCESS'
};
const $e40b1af8ddf646ed$export$bf1e31028b579014 = [
    $e40b1af8ddf646ed$export$b4e6d6efc113ca5.ACCESS_EXISTS,
    $e40b1af8ddf646ed$export$b4e6d6efc113ca5.ACCESS_GRANTED,
    $e40b1af8ddf646ed$export$b4e6d6efc113ca5.PENDING_REQUEST_EXISTS
];
const $e40b1af8ddf646ed$export$2fe5bb2d968b01fc = [
    $e40b1af8ddf646ed$export$b4e6d6efc113ca5.FORBIDDEN,
    $e40b1af8ddf646ed$export$b4e6d6efc113ca5.DENIED_REQUEST_EXISTS
];
const $e40b1af8ddf646ed$export$56360b096b4b4439 = 'licence-exceeded';
const $e40b1af8ddf646ed$export$e873edb2560a07ef = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $2vSU6.CORE_PROJECT:
            return 'JWM';
        default:
            return 'JSW';
    }
};

});


parcelRegister("kHHi5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d6ce0ae8e5209ef$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7d6ce0ae8e5209ef$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    publishPageSuccessTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-success-title",
        "defaultMessage": "Published!"
    },
    publishPageSuccessDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-success-description",
        "defaultMessage": "Successfully published page"
    },
    deferSpacePublishPageSuccessDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.defer-space-publish-page-success-description",
        "defaultMessage": "Your page was successfully published in the {spaceName} space"
    },
    publishPageFailedTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-failed-title",
        "defaultMessage": "Something went wrong"
    },
    publishPageFailedDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-page-failed-description",
        "defaultMessage": "We are unable to publish your page at this time"
    },
    linkPageFailedTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-page-failed-title",
        "defaultMessage": "Something went wrong."
    },
    linkPageFailedDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-page-failed-description",
        "defaultMessage": "We are unable to link your page at this time"
    },
    publishAndLinkPageSuccessTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-and-link-page-success-title",
        "defaultMessage": "Published!"
    },
    publishAndLinkPageSuccessDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-and-link-page-success-description",
        "defaultMessage": "Your page has been published and linked to your Jira issue."
    },
    publishAndLinkPageSuccessDescriptionIssueTermRefresh: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.publish-and-link-page-success-description-issue-term-refresh",
        "defaultMessage": "Your page has been published and linked to your Jira work item."
    },
    linkLiveDocSuccessTitle: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-live-doc-success-title",
        "defaultMessage": "Live doc created"
    },
    linkLiveDocSuccessDescription: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-live-doc-success-description",
        "defaultMessage": "A live doc was created and linked to your Jira issue."
    },
    linkLiveDocSuccessDescriptionIssueTermRefresh: {
        "id": "issue-create-confluence-content.controllers.use-embedded-page-draft.link-live-doc-success-description-issue-term-refresh",
        "defaultMessage": "A live doc was created and linked to your Jira work item."
    }
});

});


parcelRegister("fvjUj", function(module, exports) {

$parcel$export(module.exports, "useParentProduct", () => $af9df26010027d57$export$1b09c6e3737c8eb7);

var $dAfqg = parcelRequire("dAfqg");

var $gFmVN = parcelRequire("gFmVN");
const $af9df26010027d57$export$1b09c6e3737c8eb7 = ()=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const projectType = data?.projectType;
    return (0, $gFmVN.getParentProduct)(projectType);
};

});

parcelRegister("15U5v", function(module, exports) {

$parcel$export(module.exports, "embeddedWhiteboardModalEntrypoint", () => $d98ca876c86f40a2$export$652b3f11839af9e6);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $d98ca876c86f40a2$export$652b3f11839af9e6 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("c0nd6")), {
        moduleId: "d273fc0f"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("c0nd6", function(module, exports) {

let $8bd77d3c26b395a8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8bd77d3c26b395a8$var$load("cM9em"),
    $8bd77d3c26b395a8$var$load("fr9NE"),
    $8bd77d3c26b395a8$var$load("ghRj1")
]).then(()=>parcelRequire('9yvvI'));

});




parcelRegister("km1Z8", function(module, exports) {

$parcel$export(module.exports, "ImperativeAPI", () => $b3ed488811f6683d$export$e2ad0ff52e7f8c84);

var $5uXOq = parcelRequire("5uXOq");

var $axSKo = parcelRequire("axSKo");

var $jH6yN = parcelRequire("jH6yN");
const $b3ed488811f6683d$export$e2ad0ff52e7f8c84 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $axSKo.Consumer), null, ({ getManager: getManager })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jH6yN.ImperativeAPI), {
            getItemManager: getManager
        }));

});
parcelRegister("axSKo", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $da7a6c3542bd9710$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $da7a6c3542bd9710$export$b3bffd4bb7da6b8f);

var $5uXOq = parcelRequire("5uXOq");

var $fr1K2 = parcelRequire("fr1K2");

var $itvk3 = parcelRequire("itvk3");

var $7KTvf = parcelRequire("7KTvf");
const $da7a6c3542bd9710$var$Context = (0, $itvk3.default)('ItemManagers');
const $da7a6c3542bd9710$export$275138de3066e8b3 = 30000;
class $da7a6c3542bd9710$export$2881499e37b75b9a extends (0, $5uXOq.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da7a6c3542bd9710$var$Context.Provider, {
            value: this.manager
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.state = {
            managers: {}
        }, this.getManager = (managerKey)=>{
            const { managers: managers } = this.state;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
            const manager = managers[managerKey];
            if (manager) return manager;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return new Promise((resolve, reject)=>{
                const message = `Timeout. "${(0, $7KTvf.fromManagerKey)(managerKey)}" wasn't registered after ${$da7a6c3542bd9710$export$275138de3066e8b3}ms`;
                const rejectTimeoutId = setTimeout(()=>reject(new Error(message)), $da7a6c3542bd9710$export$275138de3066e8b3);
                const { pendingManagers: pendingManagers } = this;
                pendingManagers[managerKey] || (pendingManagers[managerKey] = []);
                pendingManagers[managerKey].push((methods)=>{
                    clearTimeout(rejectTimeoutId);
                    resolve(methods);
                });
            });
        }, this.registerManager = (managerKey, methods)=>{
            this.setState((previousState)=>{
                if (methods == null) return {
                    managers: (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(previousState.managers, managerKey)
                };
                const managerResolvers = this.pendingManagers[managerKey];
                if (managerResolvers && managerResolvers.length) {
                    managerResolvers.forEach((resolve)=>resolve(methods));
                    managerResolvers.length = 0;
                }
                return {
                    managers: {
                        ...previousState.managers,
                        [managerKey]: Promise.resolve(methods)
                    }
                };
            });
        }, this.pendingManagers = {}, this.manager = {
            getManager: this.getManager,
            registerManager: this.registerManager
        };
    }
}
const { Consumer: $da7a6c3542bd9710$export$b3bffd4bb7da6b8f } = $da7a6c3542bd9710$var$Context;

});
parcelRegister("itvk3", function(module, exports) {

$parcel$export(module.exports, "default", () => $00b840b80ca03789$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$00b840b80ca03789$export$2e2bcd8739ae039 = (name)=>{
    const contextObjName = name || '';
    const defaultGetter = ()=>{
        throw new Error(`The Consumer for ${contextObjName} Context Object does not have a correct value. Maybe, it needs to be wrapped in its corresponding Provider`);
    };
    const Context = /*#__PURE__*/ (0, $5uXOq.createContext)(defaultGetter);
    const ContextConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Context.Consumer, null, (getValue)=>{
            const value = getValue();
            return props.children(value);
        });
    const ContextProvider = ({ value: value, children: children })=>{
        const getValue = ()=>value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Context.Provider, {
            value: getValue
        }, children);
    };
    ContextProvider.displayName = `${contextObjName}SafeProvider`;
    ContextConsumer.displayName = `${contextObjName}SafeConsumer`;
    // @ts-expect-error - TS2741 - Property '$$typeof' is missing in type '{ ({ value, children }: ProviderProps<T>): JSX.Element; displayName: string; }' but required in type 'ProviderExoticComponent<ProviderProps<T>>'. | TS2741 - Property '$$typeof' is missing in type '{ (props: Props<T>): JSX.Element; displayName: string; }' but required in type 'ExoticComponent<ConsumerProps<T>>'.
    return {
        Provider: ContextProvider,
        Consumer: ContextConsumer
    };
};

});

parcelRegister("7KTvf", function(module, exports) {

$parcel$export(module.exports, "fromManagerKey", () => $067bae373d6cebdd$export$fef172a673b3ef47);
const $067bae373d6cebdd$export$e6ee4c5f89b06a38 = (managerKey)=>managerKey;
const $067bae373d6cebdd$export$fef172a673b3ef47 = (managerKey)=>String(managerKey);

});


parcelRegister("jH6yN", function(module, exports) {

$parcel$export(module.exports, "ImperativeAPI", () => $5d8d26c2e79a214b$export$e2ad0ff52e7f8c84);

var $5uXOq = parcelRequire("5uXOq");

var $9B86Q = parcelRequire("9B86Q");

var $dJl1T = parcelRequire("dJl1T");

var $7oGEb = parcelRequire("7oGEb");

var $1ADgn = parcelRequire("1ADgn");

var $gPQRI = parcelRequire("gPQRI");

var $1J3t1 = parcelRequire("1J3t1");

var $jRCeJ = parcelRequire("jRCeJ");

var $7KTvf = parcelRequire("7KTvf");

var $lVJAU = parcelRequire("lVJAU");

var $fTkzd = parcelRequire("fTkzd");
const $5d8d26c2e79a214b$var$ERROR_LOCATION = 'legacy.imperative-api';
const $5d8d26c2e79a214b$export$e2ad0ff52e7f8c84 = ({ getItemManager: getItemManager })=>{
    const { collapseLeftSidebar: collapseLeftSidebar, expandLeftSidebar: expandLeftSidebar } = (0, $gPQRI.useLeftSidebarController)();
    const { refresh: refresh } = (0, $1J3t1.useProjectSidebarNavigation)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const sidebarState = (0, $gPQRI.useLeftSidebarState)();
    const sidebarRef = (0, $5uXOq.useRef)(sidebarState);
    const refreshSidebarRef = (0, $5uXOq.useRef)(refresh);
    const imperativeAPIRef = (0, $5uXOq.useRef)({
        viewIds: $fTkzd.viewIds,
        itemIds: $fTkzd.itemIds,
        expand: expandLeftSidebar,
        collapse: collapseLeftSidebar,
        isCollapsed: ()=>sidebarRef.current.isCollapsed,
        onCollapse: ()=>undefined,
        onCollapseStart: ()=>undefined,
        onCollapseEnd: ()=>undefined,
        onExpand: ()=>undefined,
        onExpandStart: ()=>undefined,
        onExpandEnd: ()=>undefined,
        onItemClick: ()=>undefined,
        setView: ()=>undefined,
        updateActiveView: ()=>undefined,
        setProjectRootView: ()=>undefined,
        getActiveViewItems: ()=>[],
        isInProjectContext: ()=>false,
        updateContext: ()=>undefined,
        updateData: ()=>{
            refreshSidebarRef.current();
        },
        getItemManager: (itemManagerKey)=>getItemManager(itemManagerKey).catch((e)=>{
                (0, $dJl1T.default).safeErrorWithoutCustomerData($5d8d26c2e79a214b$var$ERROR_LOCATION, `There was a problem getting "${(0, $7KTvf.fromManagerKey)(itemManagerKey)}" item manager`, e);
                throw e;
            }),
        createBoard: ()=>{
            (0, $1ADgn.default)();
        },
        modalOpen: ()=>undefined,
        modalClose: ()=>undefined,
        navigate: (url)=>push(url)
    });
    sidebarRef.current = sidebarState;
    refreshSidebarRef.current = refresh;
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $9B86Q.loadBridgeWeak)({
            name: 'jira/navigation/bridge'
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge(imperativeAPIRef.current);
        });
        (0, $7oGEb.provideNavigationApi)({
            navigate: push
        });
    }, [
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jRCeJ.NavigationUIContainer), {
        isGlobal: true
    });
};

});
parcelRegister("7oGEb", function(module, exports) {

$parcel$export(module.exports, "provideNavigationApi", () => $6e1dad164f29ee43$export$26d28e8849b2805f);
$parcel$export(module.exports, "isInIframe", () => $6e1dad164f29ee43$export$9f140ed41af5108c);
$parcel$export(module.exports, "canSpaTransition", () => $6e1dad164f29ee43$export$59e771495885068f);
$parcel$export(module.exports, "getContainerApi", () => $6e1dad164f29ee43$export$91ed870fd8df2bcb);
$parcel$export(module.exports, "getNavigationApi", () => $6e1dad164f29ee43$export$da4e5a44286a0dd0);
// Old AMD key: `ac/spa-context`
// TODO: we will improve the type later when we know the code better.
let $6e1dad164f29ee43$var$containerApi = null;
let $6e1dad164f29ee43$var$navigationApi = null;
const $6e1dad164f29ee43$export$3927fb5df700a968 = (api)=>{
    $6e1dad164f29ee43$var$containerApi = api;
};
const $6e1dad164f29ee43$export$26d28e8849b2805f = (api)=>{
    $6e1dad164f29ee43$var$navigationApi = api;
};
const $6e1dad164f29ee43$export$9f140ed41af5108c = ()=>$6e1dad164f29ee43$var$containerApi !== null;
const $6e1dad164f29ee43$export$59e771495885068f = ()=>$6e1dad164f29ee43$var$navigationApi !== null;
const $6e1dad164f29ee43$export$91ed870fd8df2bcb = ()=>$6e1dad164f29ee43$var$containerApi;
const $6e1dad164f29ee43$export$da4e5a44286a0dd0 = ()=>$6e1dad164f29ee43$var$navigationApi;
const $6e1dad164f29ee43$export$6ba42130b045ede1 = ()=>{
    $6e1dad164f29ee43$var$containerApi = null;
    $6e1dad164f29ee43$var$navigationApi = null;
};

});

parcelRegister("1ADgn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a5ce13af6407cab$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
const $7a5ce13af6407cab$var$amdModuleName = 'jira-agile/sidebar/create-board-adg3';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7a5ce13af6407cab$export$2e2bcd8739ae039 = async ()=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    const module = await (0, $7T84i.loadBridgeStrict)({
        name: $7a5ce13af6407cab$var$amdModuleName,
        wrmKeys: [
            'wrc!com.pyxis.greenhopper.jira:gh-create-board'
        ]
    });
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    return module.openCreateBoardModal();
};

});

parcelRegister("jRCeJ", function(module, exports) {

$parcel$export(module.exports, "NavigationUISubscriber", () => $54656242ba3a5025$export$d3dc1c18cfde5ddd);
$parcel$export(module.exports, "NavigationUIContainer", () => $54656242ba3a5025$export$339ec9ca159ad81f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $51nlc = parcelRequire("51nlc");

var $3h4uJ = parcelRequire("3h4uJ");
const $54656242ba3a5025$export$d3dc1c18cfde5ddd = (0, $51nlc.createSubscriber)((0, $3h4uJ.default), {
    displayName: 'NavigationUISubscriber',
    selector: null
});
const $54656242ba3a5025$export$339ec9ca159ad81f = (0, $gg7kZ.createContainer)((0, $3h4uJ.default));

});
parcelRegister("3h4uJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ca73b0c81372577$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iXqE5 = parcelRequire("iXqE5");

var $8pFbi = parcelRequire("8pFbi");
const $8ca73b0c81372577$var$initialState = {
    collapseStart: new Set(),
    collapseEnd: new Set(),
    expandStart: new Set(),
    expandEnd: new Set()
};
var $8ca73b0c81372577$export$2e2bcd8739ae039 = (0, $iXqE5.createStore)({
    name: 'navigation-ui',
    initialState: $8ca73b0c81372577$var$initialState,
    actions: $8pFbi.default
});

});
parcelRegister("8pFbi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c96738f03994c2c6$export$2e2bcd8739ae039);

var $cIPJW = parcelRequire("cIPJW");
var $aUW0i = parcelRequire("aUW0i");
var $44KUn = parcelRequire("44KUn");
var $5UAf7 = parcelRequire("5UAf7");
const $c96738f03994c2c6$var$actions = {
    collapseStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch($cIPJW.default('collapseStart', cb)),
    collapseStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch($44KUn.default('collapseStart', cb)),
    collapseStartClear: ()=>({ dispatch: dispatch })=>dispatch($aUW0i.default('collapseStart')),
    collapseStartRun: ()=>({ dispatch: dispatch })=>dispatch($5UAf7.default('collapseStart')),
    collapseEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch($cIPJW.default('collapseEnd', cb)),
    collapseEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch($44KUn.default('collapseEnd', cb)),
    collapseEndClear: ()=>({ dispatch: dispatch })=>dispatch($aUW0i.default('collapseEnd')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    collapseEndRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($5UAf7.default('collapseEnd', cb)),
    expandStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch($cIPJW.default('expandStart', cb)),
    expandStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch($44KUn.default('expandStart', cb)),
    expandStartClear: ()=>({ dispatch: dispatch })=>dispatch($aUW0i.default('expandStart')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    expandStartRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($5UAf7.default('expandStart', cb)),
    expandEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch($cIPJW.default('expandEnd', cb)),
    expandEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch($44KUn.default('expandEnd', cb)),
    expandEndClear: ()=>({ dispatch: dispatch })=>dispatch($aUW0i.default('expandEnd')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    expandEndRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($5UAf7.default('expandEnd', cb)),
    clearAll: ()=>({ dispatch: dispatch })=>{
            dispatch($c96738f03994c2c6$var$actions.collapseStartClear());
            dispatch($c96738f03994c2c6$var$actions.collapseEndClear());
            dispatch($c96738f03994c2c6$var$actions.expandStartClear());
            dispatch($c96738f03994c2c6$var$actions.expandEndClear());
        }
};
var $c96738f03994c2c6$export$2e2bcd8739ae039 = $c96738f03994c2c6$var$actions;

});
parcelRegister("cIPJW", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a193bdf9026fb7$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $44KUn = parcelRequire("44KUn");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$98a193bdf9026fb7$export$2e2bcd8739ae039 = (key, callback)=>// @ts-expect-error - TS2322 - Type '({ setState, getState, dispatch }: StoreActionApi<T>) => () => void' is not assignable to type 'Action<T, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: new Set(getState()[key]).add(callback)
        });
        return ()=>dispatch((0, $44KUn.default)(key, callback));
    };

});
parcelRegister("44KUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cd1dd9b883bc2d4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4cd1dd9b883bc2d4$export$2e2bcd8739ae039 = (key, callback)=>({ setState: setState, getState: getState })=>{
        if (!getState()[key]) return;
        const slice = new Set(getState()[key]);
        slice.delete(callback);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: slice
        });
    };

});


parcelRegister("aUW0i", function(module, exports) {

$parcel$export(module.exports, "default", () => $0765ad08a31511d2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0765ad08a31511d2$export$2e2bcd8739ae039 = (key)=>({ setState: setState })=>// @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: new Set()
        });

});

parcelRegister("5UAf7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc474c9b594a3d77$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dc474c9b594a3d77$export$2e2bcd8739ae039 = (key, ...args)=>({ getState: getState })=>// @ts-expect-error - TS2339 - Property 'forEach' does not exist on type 'Set<unknown> | T[string]'. | TS7006 - Parameter 'cb' implicitly has an 'any' type.
        (getState()[key] || new Set()).forEach((cb)=>cb(...args));

});




parcelRegister("fTkzd", function(module, exports) {

$parcel$export(module.exports, "itemIds", () => $e0d97c8d376b70de$export$443ec49e59de3663);
$parcel$export(module.exports, "viewIds", () => $e0d97c8d376b70de$export$8ee2fd038785d9dc);

var $16J3A = parcelRequire("16J3A");
const $e0d97c8d376b70de$var$ROOT = 'root/index';
const $e0d97c8d376b70de$var$ISSUES = 'root/issues';
const $e0d97c8d376b70de$var$DASHBOARDS = 'root/dashboards';
const $e0d97c8d376b70de$var$PORTFOLIO = 'root/portfolio';
const $e0d97c8d376b70de$var$WORK_SCRUM = 'work-scrum';
const $e0d97c8d376b70de$var$PLAN_SCRUM = 'plan-scrum';
const $e0d97c8d376b70de$var$WORK_KANBAN = 'work-kanban';
const $e0d97c8d376b70de$var$PLAN_KANBAN = 'plan-kanban';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES = 'pin-filter-myopenissues';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES = 'pin-filter-reportedbyme';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES = 'pin-filter-allissues';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES = 'pin-filter-allopenissues';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES = 'pin-filter-doneissues';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES = 'pin-filter-recentlyviewed';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES = 'pin-filter-addedrecently';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES = 'pin-filter-resolvedrecently';
const $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES = 'pin-filter-updatedrecently';
const $e0d97c8d376b70de$var$AGILITY = 'project/agility/index';
const $e0d97c8d376b70de$var$BUSINESS = 'project/business/index';
const $e0d97c8d376b70de$var$OPS = 'project/ops/index';
const $e0d97c8d376b70de$var$SOFTWARE = 'project/software/index';
const $e0d97c8d376b70de$var$SOFTWARE_ISSUES = 'project/software/issues';
const $e0d97c8d376b70de$var$SOFTWARE_REPORTS = 'project/software/reports';
const $e0d97c8d376b70de$var$USER = 'user/index';
const $e0d97c8d376b70de$var$USER_REPORTS = 'user/reports';
const $e0d97c8d376b70de$var$rootProjectViewIds = {
    AGILITY: $e0d97c8d376b70de$var$AGILITY,
    SERVICE_DESK: $16J3A.SERVICE_DESK,
    OPS: $e0d97c8d376b70de$var$OPS,
    BUSINESS: $e0d97c8d376b70de$var$BUSINESS,
    SOFTWARE: $e0d97c8d376b70de$var$SOFTWARE
};
const $e0d97c8d376b70de$var$rootViewIds = {
    ROOT: $e0d97c8d376b70de$var$ROOT,
    ISSUES: $e0d97c8d376b70de$var$ISSUES,
    DASHBOARDS: $e0d97c8d376b70de$var$DASHBOARDS,
    PORTFOLIO: $e0d97c8d376b70de$var$PORTFOLIO
};
const $e0d97c8d376b70de$export$443ec49e59de3663 = {
    WORK_SCRUM: $e0d97c8d376b70de$var$WORK_SCRUM,
    PLAN_SCRUM: $e0d97c8d376b70de$var$PLAN_SCRUM,
    WORK_KANBAN: $e0d97c8d376b70de$var$WORK_KANBAN,
    PLAN_KANBAN: $e0d97c8d376b70de$var$PLAN_KANBAN,
    PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES: $e0d97c8d376b70de$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES,
    ...(0, $16J3A.SERVICE_DESK_ITEMS)
};
const $e0d97c8d376b70de$export$8ee2fd038785d9dc = {
    ...$e0d97c8d376b70de$var$rootViewIds,
    ...$e0d97c8d376b70de$var$rootProjectViewIds,
    SOFTWARE_ISSUES: $e0d97c8d376b70de$var$SOFTWARE_ISSUES,
    SOFTWARE_REPORTS: $e0d97c8d376b70de$var$SOFTWARE_REPORTS,
    SERVICE_DESK_ISSUES: $16J3A.SERVICE_DESK_ISSUES,
    SERVICE_DESK_QUEUES: $16J3A.SERVICE_DESK_QUEUES,
    SERVICE_DESK_REPORTS: $16J3A.SERVICE_DESK_REPORTS,
    SERVICE_DESK_SETTINGS: $16J3A.SERVICE_DESK_SETTINGS,
    SERVICE_DESK_LANGUAGES: $16J3A.SERVICE_DESK_LANGUAGES,
    SERVICE_DESK_LEGACY_TICKET_TYPES: $16J3A.SERVICE_DESK_LEGACY_TICKET_TYPES,
    SERVICE_DESK_TRANSLATIONS: $16J3A.SERVICE_DESK_TRANSLATIONS,
    SERVICE_DESK_AUTOMATION_SUB_NAV: $16J3A.SERVICE_DESK_AUTOMATION_SUB_NAV,
    SERVICE_DESK_KNOWLEDGE_HUB: $16J3A.SERVICE_DESK_KNOWLEDGE_HUB,
    USER: $e0d97c8d376b70de$var$USER,
    USER_REPORTS: $e0d97c8d376b70de$var$USER_REPORTS
};

});
parcelRegister("16J3A", function(module, exports) {

$parcel$export(module.exports, "REPORTS_IDS", () => $6fb2b1c825061655$export$1f70a76cb421b107);
$parcel$export(module.exports, "HOME_ITEMS_IDS", () => $6fb2b1c825061655$export$9afbea2cbd37e16d);
$parcel$export(module.exports, "PRACTICES_IDS", () => $6fb2b1c825061655$export$a37f4f7add086a3);
$parcel$export(module.exports, "SERVICE_DESK_ITEMS", () => $6fb2b1c825061655$export$2108a7f32cd0bb12);
$parcel$export(module.exports, "REQUEST_TYPE_PRACTICE_NAV_ONBOARDING", () => $6fb2b1c825061655$export$712b4b205a2bcf1e);
$parcel$export(module.exports, "STARRED_QUEUE_SPOTLIGHT", () => $6fb2b1c825061655$export$e2d46b728fe0a15a);
$parcel$export(module.exports, "SERVICE_DESK", () => $6fb2b1c825061655$export$c8c1c8c3f8ddba61);
$parcel$export(module.exports, "SERVICE_DESK_ISSUES", () => $6fb2b1c825061655$export$51fa1147c138a6ed);
$parcel$export(module.exports, "SERVICE_DESK_QUEUES", () => $6fb2b1c825061655$export$456b3cfbf5e37bd8);
$parcel$export(module.exports, "SERVICE_DESK_KNOWLEDGE_HUB", () => $6fb2b1c825061655$export$9ccc8d85b210b219);
$parcel$export(module.exports, "SERVICE_DESK_REPORTS", () => $6fb2b1c825061655$export$707771f2f7e60575);
$parcel$export(module.exports, "SERVICE_DESK_SETTINGS", () => $6fb2b1c825061655$export$a87fc635598d2d50);
$parcel$export(module.exports, "SERVICE_DESK_LEGACY_TICKET_TYPES", () => $6fb2b1c825061655$export$b6bda26b77269209);
$parcel$export(module.exports, "SERVICE_DESK_LANGUAGES", () => $6fb2b1c825061655$export$776199f9e99c88e2);
$parcel$export(module.exports, "SERVICE_DESK_TRANSLATIONS", () => $6fb2b1c825061655$export$d70ba5c124463035);
$parcel$export(module.exports, "SERVICE_DESK_AUTOMATION_SUB_NAV", () => $6fb2b1c825061655$export$9a6deaa9c1af559f);
const $6fb2b1c825061655$var$HOME_QUEUES = 'queues';
const $6fb2b1c825061655$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT = 'all-itsm-queues-spotlight';
const $6fb2b1c825061655$var$HOME_ALL_TICKETS_SPOTLIGHT = 'all-tickets-spotlight';
const $6fb2b1c825061655$var$HOME_TICKET_CATEGORIES_SPOTLIGHT = 'ticket-categories-spotlight';
const $6fb2b1c825061655$var$HOME_SERVICE_REQUESTS = 'service-requests';
const $6fb2b1c825061655$var$HOME_INCIDENTS = 'incidents';
const $6fb2b1c825061655$var$HOME_CHANGES = 'changes';
const $6fb2b1c825061655$var$HOME_PROBLEMS = 'problems';
const $6fb2b1c825061655$var$HOME_POST_INCIDENT_REVIEWS = 'post-incident-reviews';
const $6fb2b1c825061655$var$HOME_CUSTOMERS = 'customers';
const $6fb2b1c825061655$var$HOME_REPORTS = 'reports';
const $6fb2b1c825061655$var$HOME_RAISE_REQUEST = 'raise-request';
const $6fb2b1c825061655$var$HOME_ISSUES = 'issues';
const $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS = 'customer-channels';
const $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT = 'customer-channels-spotlight';
const $6fb2b1c825061655$var$HOME_JSD_CHANNELS_DIALOG = 'jsd-channels-dialog';
const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE = 'knowledge-base';
const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB = 'knowledge-hub';
const $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB_NESTED = 'knowledge-hub-nested';
const $6fb2b1c825061655$var$HOME_INVITE_TEAM = 'invite-team';
const $6fb2b1c825061655$var$HOME_GIVE_FEEDBACK = 'give-feedback';
const $6fb2b1c825061655$var$HOME_SERVICES = 'services';
const $6fb2b1c825061655$var$HOME_SERVICES_SPOTLIGHT = 'services-spotlight';
const $6fb2b1c825061655$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT = 'alerts-and-on-call-spotlight';
const $6fb2b1c825061655$var$HOME_CHANGE_CALENDAR_SPOTLIGHT = 'change-calendar-spotlight';
const $6fb2b1c825061655$export$1f70a76cb421b107 = {
    REPORTS_CUSTOM: 'sd-reports-custom',
    REPORTS_ADDONS: 'sd-reports-addons',
    REPORTS_NAV_CUSTOM_ACTIONS: 'sd-reports-nav-custom-actions',
    REPORTS_NAV_TEAM: 'sd-reports-nav-team',
    REPORTS_NAV_KB: 'sd-reports-nav-kb'
};
const $6fb2b1c825061655$export$9afbea2cbd37e16d = {
    QUEUES: $6fb2b1c825061655$var$HOME_QUEUES,
    ALL_ITSM_QUEUES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT,
    ALL_TICKETS_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALL_TICKETS_SPOTLIGHT,
    TICKET_CATEGORIES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_TICKET_CATEGORIES_SPOTLIGHT,
    SERVICE_REQUEST: $6fb2b1c825061655$var$HOME_SERVICE_REQUESTS,
    INCIDENTS: $6fb2b1c825061655$var$HOME_INCIDENTS,
    CHANGES: $6fb2b1c825061655$var$HOME_CHANGES,
    PROBLEMS: $6fb2b1c825061655$var$HOME_PROBLEMS,
    CUSTOMERS: $6fb2b1c825061655$var$HOME_CUSTOMERS,
    POST_INCIDENT_REVIEWS: $6fb2b1c825061655$var$HOME_POST_INCIDENT_REVIEWS,
    REPORTS: $6fb2b1c825061655$var$HOME_REPORTS,
    RAISE_REQUEST: $6fb2b1c825061655$var$HOME_RAISE_REQUEST,
    ISSUES: $6fb2b1c825061655$var$HOME_ISSUES,
    CUSTOMER_CHANNELS: $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS,
    CUSTOMER_CHANNELS_SPOTLIGHT: $6fb2b1c825061655$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT,
    JSD_CHANNELS_DIALOG: $6fb2b1c825061655$var$HOME_JSD_CHANNELS_DIALOG,
    KNOWLEDGE_BASE: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE,
    KNOWLEDGE_BASE_HUB: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB,
    KNOWLEDGE_BASE_HUB_NESTED: $6fb2b1c825061655$var$HOME_KNOWLEDGE_BASE_HUB_NESTED,
    INVITE_TEAM: $6fb2b1c825061655$var$HOME_INVITE_TEAM,
    GIVE_FEEDBACK: $6fb2b1c825061655$var$HOME_GIVE_FEEDBACK,
    SERVICES: $6fb2b1c825061655$var$HOME_SERVICES,
    SERVICES_SPOTLIGHT: $6fb2b1c825061655$var$HOME_SERVICES_SPOTLIGHT,
    ALERTS_AND_ON_CALL_SPOTLIGHT: $6fb2b1c825061655$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT,
    CHANGE_CALENDAR_SPOTLIGHT: $6fb2b1c825061655$var$HOME_CHANGE_CALENDAR_SPOTLIGHT
};
const $6fb2b1c825061655$var$KNOWLEDGE_BASE_IDS = {
    TOP_ACTIONS: 'knowledge-hub-top-actions',
    ALL_ARTICLES: 'knowledge-hub-all-articles',
    CATEGORIES: 'knowledge-hub-categories',
    CATEGORIES_CONTEXT: 'knowledge-hub-categories-context',
    BOTTOM_ACTIONS: 'knowledge-hub-bottom-actions',
    ADD_CATEGORY: 'knowledge-hub-new-category',
    LEAVE_FEEDBACK: 'knowledge-hub-leave-feedback'
};
const $6fb2b1c825061655$var$SETTINGS_IDS = {
    DETAILS: 'details',
    PEOPLE: 'people',
    ITSM_FEATURES: 'itsm-features',
    SUMMARY: 'summary',
    DELETE_PROJECT: 'delete-project',
    ISSUE_TYPES: 'issue-types',
    FEATURES: 'features',
    REQUEST_TYPES: 'sd-request-types',
    TICKET_TYPES: 'sd-ticket-types',
    CUSTOMER_PERMISSIONS: 'sd-customer-permissions',
    LANGUAGE_SUPPORT: 'sd-language-support',
    PORTAL_SETTINGS: 'sd-portal-settings',
    EMAIL_REQUESTS: 'sd-email-requests',
    CUSTOMER_NOTIFICATIONS: 'sd-customer-notifications',
    PROJECT_WIDGET_ADDON: 'sd-project-widget-addon',
    PROJECT_WIDGET_ADDON_INSTALLER: 'sd-project-widget-addon-installer',
    PROJECT_ASSETS_AD: 'sd-project-assets-ad',
    SATISFACTION_SETTINGS: 'sd-satisfaction-settings',
    KNOWLEDGE_BASE: 'sd-knowledge-base',
    SLAS: 'sd-slas',
    AUTOMATION: 'sd-automation',
    PLAYBOOKS: 'playbooks',
    JIRA_AUTOMATION: 'jira-automation',
    AUTOMATION_SUB_NAV: 'sd-automation-sub-nav',
    JSD_APP_DISCOVERY: 'sd-app-discovery',
    JSD_INCIDENT_MANAGEMENT: 'sd-incident-management',
    JSD_CHANGE_MANAGEMENT: 'sd-change-management',
    WORKFLOWS: 'workflows',
    SCREENS: 'screens',
    FIELDS: 'fields',
    VERSIONS: 'versions',
    COMPONENTS: 'components',
    PERMISSIONS: 'permissions',
    ISSUE_SECURITY: 'issue-security',
    NOTIFICATIONS: 'notifications',
    HIPCHAT: 'hipchat',
    ISSUE_COLLECTORS: 'issue-collectors'
};
const $6fb2b1c825061655$var$QUEUES_IDS = {
    QUEUE_NEW: 'queue-new',
    QUEUE_MANAGE: 'queue-manage',
    QUEUES_ADDONS: 'sd-queues-addons',
    QUEUES_CUSTOM_ACTIONS: 'sd-queues-custom-actions',
    SD_QUEUES_CUSTOM: 'sd-queues-custom'
};
const $6fb2b1c825061655$export$a37f4f7add086a3 = {
    ADDITIONAL_ITEMS: 'sd-practices-additional-items',
    CHANGES_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-changes-queue-title-spotlight',
    CHANGES_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-changes-queue-items-spotlight',
    INCIDENTS_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-incidents-queue-title-spotlight',
    INCIDENTS_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-incidents-queue-items-spotlight'
};
const $6fb2b1c825061655$export$2108a7f32cd0bb12 = {
    SERVICE_DESK: {
        HOME: $6fb2b1c825061655$export$9afbea2cbd37e16d,
        KNOWLEDGE_BASE: $6fb2b1c825061655$var$KNOWLEDGE_BASE_IDS,
        SETTINGS: $6fb2b1c825061655$var$SETTINGS_IDS,
        QUEUES: $6fb2b1c825061655$var$QUEUES_IDS,
        REPORTS: $6fb2b1c825061655$export$1f70a76cb421b107
    }
};
const $6fb2b1c825061655$export$712b4b205a2bcf1e = {
    PRACTICE_NAV_SPOTLIGHT: 'request-type-practice-nav-spotlight',
    UNASSIGNED_NAV_SPOTLIGHT: 'request-type-unassgined-nav-spotlight'
};
const $6fb2b1c825061655$export$e2d46b728fe0a15a = 'jsm-team-starred-onboarding';
const $6fb2b1c825061655$export$c8c1c8c3f8ddba61 = 'project/service-desk/index';
const $6fb2b1c825061655$export$51fa1147c138a6ed = 'project/service-desk/issues';
const $6fb2b1c825061655$export$456b3cfbf5e37bd8 = 'project/service-desk/queues';
const $6fb2b1c825061655$export$9ccc8d85b210b219 = 'project/service-desk/knowledge-hub';
const $6fb2b1c825061655$export$707771f2f7e60575 = 'project/service-desk/reports';
const $6fb2b1c825061655$export$a87fc635598d2d50 = 'project/service-desk/settings';
const $6fb2b1c825061655$export$b6bda26b77269209 = 'project/service-desk/legacy-ticket-types';
const $6fb2b1c825061655$export$776199f9e99c88e2 = 'project/service-desk/languages';
const $6fb2b1c825061655$export$d70ba5c124463035 = 'project/service-desk/translations';
const $6fb2b1c825061655$export$9a6deaa9c1af559f = 'project/service-desk/settings/automation-sub-nav';

});




parcelRegister("jElqQ", function(module, exports) {

$parcel$export(module.exports, "PageDwellAnalyticsListener", () => $e847f78ebf17acd8$export$6cf89f098b551dad);

var $5uXOq = parcelRequire("5uXOq");

var $gPQRI = parcelRequire("gPQRI");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $dAfqg = parcelRequire("dAfqg");

var $6yXtV = parcelRequire("6yXtV");

var $hMvRp = parcelRequire("hMvRp");
const $e847f78ebf17acd8$var$WAIT_DURATION = 5000;
/**
 * Dispatches AnalyticsEvent for when a user stays on a page for a set period of time
 */ const $e847f78ebf17acd8$export$6cf89f098b551dad = ()=>{
    const [hasFired, setHasFired] = (0, $5uXOq.useState)(false);
    const route = (0, $6jY6G.useCurrentRoute)();
    const routeName = route.name;
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const isVisible = (0, $hMvRp.usePageVisibility)();
    const interval = (0, $5uXOq.useRef)(null);
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { isCollapsed: isLeftSidebarCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    (0, $5uXOq.useEffect)(()=>{
        setHasFired(false);
    }, [
        routeName
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isReady) {
            interval.current = null;
            return;
        }
        // If the page is visible, set the analytics event to run after the specified duration
        if (isVisible && !hasFired) interval.current = setTimeout(()=>{
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'page dwelled', routeName, {
                containerId: projectData?.projectId,
                containerType: projectData?.projectType,
                isLeftSidebarCollapsed: isLeftSidebarCollapsed
            });
            setHasFired(true);
        }, $e847f78ebf17acd8$var$WAIT_DURATION);
        return ()=>{
            // @ts-expect-error - TS2769 - No overload matches this call.
            interval.current = clearTimeout(interval.current);
        };
    }, [
        createAnalyticsEvent,
        hasFired,
        isReady,
        isVisible,
        routeName,
        projectData?.projectId,
        projectData?.projectType,
        isLeftSidebarCollapsed
    ]);
    return null;
};

});
parcelRegister("hMvRp", function(module, exports) {

$parcel$export(module.exports, "usePageVisibility", () => $124c6a08c4f63b4e$export$6c98eb2f12f4ec61);

var $5uXOq = parcelRequire("5uXOq");

var $laTox = parcelRequire("laTox");
const $124c6a08c4f63b4e$export$6c98eb2f12f4ec61 = ()=>{
    const [isVisible, setIsVisible] = (0, $5uXOq.useState)((0, $laTox.isPageVisible)());
    (0, $5uXOq.useEffect)(()=>{
        const onVisibilityChange = ()=>setIsVisible((0, $laTox.isPageVisible)());
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('visibilitychange', onVisibilityChange);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, []);
    return isVisible;
};

});
parcelRegister("laTox", function(module, exports) {

$parcel$export(module.exports, "supportedVisiblityEvent", () => $845c75a1dcb2afb9$export$f7132cb36c80dad);
$parcel$export(module.exports, "isPageVisible", () => $845c75a1dcb2afb9$export$ae4f9b990bc70f70);
const $845c75a1dcb2afb9$var$visibilityMap = {
    // document property: event name
    hidden: 'visibilitychange',
    mozHidden: 'mozvisibilitychange',
    msHidden: 'msvisibilitychange',
    webkitHidden: 'webkitvisibilitychange'
};
const $845c75a1dcb2afb9$var$supportedHiddenKey = Object.keys($845c75a1dcb2afb9$var$visibilityMap).find(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Document'.
(key)=>typeof document !== 'undefined' && typeof document[key] !== 'undefined');
const $845c75a1dcb2afb9$export$f7132cb36c80dad = $845c75a1dcb2afb9$var$visibilityMap[$845c75a1dcb2afb9$var$supportedHiddenKey];
const $845c75a1dcb2afb9$export$ae4f9b990bc70f70 = ()=>typeof document !== 'undefined' && !document[$845c75a1dcb2afb9$var$supportedHiddenKey];

});



parcelRegister("kKa8l", function(module, exports) {

$parcel$export(module.exports, "MatchedRouteListener", () => $6e59b41cd017c405$export$c6d9204abc182c3b);

var $5uXOq = parcelRequire("5uXOq");

var $cfDZ3 = parcelRequire("cfDZ3");

var $doZTA = parcelRequire("doZTA");
const $6e59b41cd017c405$export$c6d9204abc182c3b = ()=>{
    const [{ route: route, match: match }] = (0, $doZTA.useRouter)();
    (0, $5uXOq.useMemo)(()=>(0, $cfDZ3.setMatchedRoute)(route, match), [
        route,
        match
    ]);
    return null;
};

});

parcelRegister("bmetd", function(module, exports) {

$parcel$export(module.exports, "PreviousRouterStateListener", () => $0b73f894404a9cc2$export$49e28489f2124002);

var $5uXOq = parcelRequire("5uXOq");

var $1XJ20 = parcelRequire("1XJ20");

var $cfDZ3 = parcelRequire("cfDZ3");

var $jDDFr = parcelRequire("jDDFr");
const $0b73f894404a9cc2$export$3fd5ddd6b8e9a200 = ({ routerState: routerState })=>{
    const previousRouterState = (0, $1XJ20.usePrevious)(routerState);
    (0, $5uXOq.useEffect)(()=>{
        (0, $cfDZ3.setPreviousRouterState)(previousRouterState ?? null);
    }, [
        previousRouterState
    ]);
    return null;
};
const $0b73f894404a9cc2$export$49e28489f2124002 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDDFr.RouterSubscriber), null, (routerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b73f894404a9cc2$export$3fd5ddd6b8e9a200, {
            routerState: routerState
        })));
$0b73f894404a9cc2$export$49e28489f2124002.displayName = 'PreviousRouterStateListener';

});

parcelRegister("izgL1", function(module, exports) {

$parcel$export(module.exports, "default", () => $33c092f8fb0732f9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $01Rn4 = parcelRequire("01Rn4");

var $7nE2n = parcelRequire("7nE2n");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $5y0F0 = parcelRequire("5y0F0");
var $jDDFr = parcelRequire("jDDFr");

var $gKKyW = parcelRequire("gKKyW");
/**
 * Defines the component for the `querystring-notifier` module.
 */ const $33c092f8fb0732f9$var$QueryStringNotifier = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "querystringNotifications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7nE2n.default), null, (flagService)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDDFr.RouterSubscriber), null, ({ location: { search: search } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y0F0.RouterActions), null, ({ replace: replace })=>{
                const { showFlag: showFlag, ...query } = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search);
                if (!showFlag) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $gKKyW.default)[showFlag] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
                    eventName: "querystringNotification shown",
                    componentName: "flag",
                    attributes: {
                        showFlag: showFlag
                    }
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
                    eventName: "querystringNotification notFound",
                    componentName: "flag",
                    attributes: {
                        showFlag: showFlag
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
                    op: ()=>{
                        if ((0, $gKKyW.default)[showFlag]) flagService.showFlag((0, $gKKyW.default)[showFlag]);
                        replace(`?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query)}`);
                    }
                }));
            }))));
var $33c092f8fb0732f9$export$2e2bcd8739ae039 = $33c092f8fb0732f9$var$QueryStringNotifier;

});
parcelRegister("01Rn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $32b7c410527eddaf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line jira/react/no-class-components
class $32b7c410527eddaf$var$OpTrigger extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $32b7c410527eddaf$export$2e2bcd8739ae039 = $32b7c410527eddaf$var$OpTrigger;

});

parcelRegister("7nE2n", function(module, exports) {

$parcel$export(module.exports, "default", () => $4855eee5a10070a5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");
const $4855eee5a10070a5$var$FlagServiceSubscriber = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children((0, $pa9q9.flagService)));
var $4855eee5a10070a5$export$2e2bcd8739ae039 = $4855eee5a10070a5$var$FlagServiceSubscriber;

});

parcelRegister("gKKyW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fdf0672c10209bc$export$2e2bcd8739ae039);

var $7HGHK = parcelRequire("7HGHK");

var $lVqGY = parcelRequire("lVqGY");
const $2fdf0672c10209bc$var$notificationMessages = {
    'jsw.board-not-found': {
        id: (0, $7HGHK.toFlagId)('jsw.board-not-found'),
        type: 'error',
        title: (0, $lVqGY.default).boardNotFound,
        description: (0, $lVqGY.default).boardNotFoundDescription,
        messageId: 'query-string-notifier.common.flag.error.error.jsw.board-not-found',
        messageType: 'transactional'
    },
    'jsw.project-not-found': {
        id: (0, $7HGHK.toFlagId)('jsw.project-not-found'),
        type: 'error',
        title: (0, $lVqGY.default).projectNotFound,
        description: (0, $lVqGY.default).projectNotFoundDescription,
        messageId: 'query-string-notifier.common.flag.error.error.jsw.project-not-found',
        messageType: 'transactional'
    }
};
var $2fdf0672c10209bc$export$2e2bcd8739ae039 = $2fdf0672c10209bc$var$notificationMessages;

});
parcelRegister("lVqGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a629f5c887c4955a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
// Don't confuse Intl messages with `Flag`s
const $a629f5c887c4955a$var$messages = (0, $7VHMR.defineMessages)({
    boardNotFound: {
        "id": "query-string-notifier.common.board-not-found",
        "defaultMessage": "Board not found"
    },
    boardNotFoundDescription: {
        "id": "query-string-notifier.common.board-not-found-description",
        "defaultMessage": "You tried to access a board that doesn't exist or that you don't have permission to see."
    },
    projectNotFound: {
        "id": "query-string-notifier.common.project-not-found",
        "defaultMessage": "Project not found"
    },
    projectNotFoundDescription: {
        "id": "query-string-notifier.common.project-not-found-description",
        "defaultMessage": "You tried to access a project that doesn't exist or that you don't have permission to see."
    }
});
var $a629f5c887c4955a$export$2e2bcd8739ae039 = $a629f5c887c4955a$var$messages;

});



parcelRegister("lyCmi", function(module, exports) {

$parcel$export(module.exports, "AsyncRecommendPremiumToStandardModalWrapper", () => $881dabfa53ffbc01$export$2a43717c77dd3a56);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $7iJwP = parcelRequire("7iJwP");

var $b7Svb = parcelRequire("b7Svb");

var $gnleF = parcelRequire("gnleF");

const $881dabfa53ffbc01$var$AsyncRecommendPremiumToStandardModalComponent = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("dOnxg")).then(({ RecommendPremiumToStandardModalComponent: RecommendPremiumToStandardModalComponent })=>RecommendPremiumToStandardModalComponent), {
    moduleId: "./src/packages/growth/recommend-premium-to-standard-modal/src/index.tsx"
});
const $881dabfa53ffbc01$export$2a43717c77dd3a56 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "recommend-premium-to-standard-modal-async",
        packageName: (0, $gnleF.PACKAGE_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        teamName: (0, $gnleF.TEAM_NAME),
        id: "recommend-premium-to-standard-modal-async",
        packageName: (0, $gnleF.PACKAGE_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($881dabfa53ffbc01$var$AsyncRecommendPremiumToStandardModalComponent, null)));
};

});
parcelRegister("gnleF", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $3413b320036771c2$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $3413b320036771c2$export$d57b6b390e78d90f);
$parcel$export(module.exports, "ANALYTICS_SOURCE_NAME", () => $3413b320036771c2$export$48e1d3fa57b0a2d5);
$parcel$export(module.exports, "STARGATE_URL", () => $3413b320036771c2$export$c7e6a6b283196232);
$parcel$export(module.exports, "RECC_STANDARD_MESSAGE_ID", () => $3413b320036771c2$export$de9f5b160db96e26);
const $3413b320036771c2$export$b8b9d90f9e5bd72b = '@atlassian/jira-recommend-premium-to-standard-modal';
const $3413b320036771c2$export$d57b6b390e78d90f = 'growth-tako';
const $3413b320036771c2$export$48e1d3fa57b0a2d5 = 'recommendPremiumToStandard';
const $3413b320036771c2$export$c7e6a6b283196232 = '/gateway/api';
const $3413b320036771c2$export$de9f5b160db96e26 = new Map([
    [
        5,
        'prj-grace-period-recc-standard-msg-1'
    ],
    [
        3,
        'prj-grace-period-recc-standard-msg-2'
    ],
    [
        1,
        'prj-grace-period-recc-standard-msg-3'
    ]
]);

});

parcelRegister("dOnxg", function(module, exports) {

let $a0e2338a66524a46$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a0e2338a66524a46$var$load("aIcwu").then(()=>parcelRequire('hxssF'));

});


parcelRegister("kgLzl", function(module, exports) {

$parcel$export(module.exports, "rovoVideoModalEntryPoint", () => $1c7272db9b45cdb2$export$2f67fedc6d5555a5);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $1c7272db9b45cdb2$export$2f67fedc6d5555a5 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(async ()=>(parcelRequire("fUDrI")).then(({ RovoVideoModal: RovoVideoModal })=>RovoVideoModal), {
        moduleId: "3a307b00"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fUDrI", function(module, exports) {

let $b95aaf223f71d3d7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b95aaf223f71d3d7$var$load("l4e09").then(()=>parcelRequire('14875'));

});


parcelRegister("dYRe6", function(module, exports) {

$parcel$export(module.exports, "default", () => $05aa88b82a329166$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aZsz6 = parcelRequire("aZsz6");

var $5oFIy = parcelRequire("5oFIy");

var $dxCvy = parcelRequire("dxCvy");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");
/**
 * Ensures users are redirected to the correct project URL when there's a mismatch in the project key.
 * It preserves query parameters during redirection and logs the event for analytics.
 */ const $05aa88b82a329166$var$ProjectKeyRedirect = ({ FireOperationalAnalytics: FireOperationalAnalytics = (0, $5oFIy.FireOperationalAnalytics), Redirect: Redirect = (0, $7tQej.Redirect), useResource: useResource = (0, $2YP9W.useResource), useRouter: useRouter = (0, $doZTA.useRouter) })=>{
    const [{ location: location, match: { params: params, url: url }, query: query }] = useRouter();
    const projectKey = params.projectKey ?? query.projectKey;
    const { data: projectContext } = useResource((0, $dxCvy.projectContextResource));
    if (!projectKey || !projectContext?.projectKey) return null;
    if (projectKey === projectContext.projectKey) return null;
    const search = {
        ...query,
        ...query.projectKey ? {
            projectKey: projectContext.projectKey
        } : {}
    };
    // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
    const queryString = (0, $aZsz6.qs).stringify(search, Object.entries(search).length > 0);
    // Just a slight risk mitigation - only do the string replace if the match param is there
    const path = params.projectKey != null ? url.replace(projectKey, projectContext.projectKey) : url;
    const to = `${path}${queryString}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FireOperationalAnalytics, {
        eventName: "ProjectKeyRedirect loaded",
        componentName: "ProjectKeyRedirect",
        attributes: {
            location: location,
            projectContext: projectContext
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: to
    }));
};
var $05aa88b82a329166$export$2e2bcd8739ae039 = $05aa88b82a329166$var$ProjectKeyRedirect;

});

parcelRegister("9yehD", function(module, exports) {

$parcel$export(module.exports, "AsyncTrialSprintBoardModalEntryPoint", () => $03eb281d6ff9bb59$export$ba04f28d78ea7267);

var $5uXOq = parcelRequire("5uXOq");

var $ioD1B = parcelRequire("ioD1B");

var $eGLgs = parcelRequire("eGLgs");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $b71gk = parcelRequire("b71gk");

var $7iJwP = parcelRequire("7iJwP");

var $koeKL = parcelRequire("koeKL");

var $14XJw = parcelRequire("14XJw");

var $dRVix = parcelRequire("dRVix");

var $lpwtK = parcelRequire("lpwtK");

var $2vSU6 = parcelRequire("2vSU6");

var $5oBMG = parcelRequire("5oBMG");

var $k9JTq = parcelRequire("k9JTq");

var $ldyPw = parcelRequire("ldyPw");


var $60gvu = parcelRequire("60gvu");

var $9mxBe = parcelRequire("9mxBe");

var $j9wkq = parcelRequire("j9wkq");

var $24MMC = parcelRequire("24MMC");
const $03eb281d6ff9bb59$export$f1c59ccb370d6712 = ({ currentProjectId: currentProjectId })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const isNotTrialSprintBoardProject = (0, $60gvu.useIsNotTrialSprintBoardProject)(currentProjectId);
    const ctaLink = (0, $60gvu.useTrialSprintBoardCtaLink)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const { data: project } = (0, $lpwtK.useProject)();
    const projectType = (0, $2vSU6.toProjectType)(project?.type);
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    const productKey = projectType && (0, $2vSU6.projectTypeToCanonicalId)(projectType);
    const entitlementDetails = productKey && productEntitlementDetails?.[productKey];
    const currentDate = (0, $5uXOq.useMemo)(()=>Date.now(), []);
    const daysLeft = (0, $dRVix.getTrialDaysLeft)(currentDate, entitlementDetails?.trialEndTime) ?? 0;
    // Show the modal three times 10/11, 12/13 and 14+ days after site creation
    const eligibleForFirstModal = daysLeft === 20 || daysLeft === 19;
    const eligibleForSecondModal = daysLeft === 18 || daysLeft === 17;
    const eligibleForThirdModal = daysLeft <= 16;
    const eligibleDaysLeft = eligibleForFirstModal || eligibleForSecondModal || eligibleForThirdModal;
    const messageId = (0, $24MMC.getMessageId)(daysLeft);
    const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, $eGLgs.CoordinationClient)(cloudId, (0, $90b4560f34ff7aba$export$c7e6a6b283196232), false, orgId, 'engagement'), [
        cloudId,
        orgId
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        if (messageId) coordinationClient.stop(messageId);
    }, [
        coordinationClient,
        messageId
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            ctaLink: ctaLink,
            onClose: onClose,
            messageId: messageId ?? '',
            coordinationClient: coordinationClient
        }), [
        coordinationClient,
        ctaLink,
        messageId,
        onClose
    ]);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({}), []);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $j9wkq.trialSprintBoardModalEntryPoint), entryPointParams);
    /**
	 * Eligibility criteria for TSB Modal
	 * - Must not currently be on the trial sprint board project page, but must be on a JSW project
	 * - Must be on JSW Premium edition
	 * - Must be in their 10/11th, 12/13th or 14th+ day in trial,
	 * - CTA Link has been generated correctly
	 * - Modal must not be dismissed forever by user (value stored in local storage)
	 *  */ const isEligibleForTrialSprintBoardModal = isNotTrialSprintBoardProject && projectType === (0, $2vSU6.SOFTWARE_PROJECT) && appEditions.software === (0, $ldyPw.PREMIUM_EDITION) && Boolean(ctaLink) && eligibleDaysLeft && (0, $9mxBe.getIsTrialSprintBoardModalDismissed)() !== true && messageId;
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (isEligibleForTrialSprintBoardModal) {
            const conditionallyLoadEntryPoint = async ()=>{
                const started = await coordinationClient.start(messageId);
                if (started) entryPointActions.load();
            };
            conditionallyLoadEntryPoint();
        }
    }, [
        ctaLink,
        isNotTrialSprintBoardProject,
        coordinationClient,
        entryPointActions,
        isEligibleForTrialSprintBoardModal,
        daysLeft,
        messageId
    ]);
    return isEligibleForTrialSprintBoardModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        id: (0, $90b4560f34ff7aba$export$48e1d3fa57b0a2d5),
        packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b),
        teamName: (0, $90b4560f34ff7aba$export$d57b6b390e78d90f),
        errorFallback: "unmount",
        runtimeProps: runtimeProps,
        entryPointActions: entryPointActions,
        entryPointReferenceSubject: entryPointReferenceSubject
    }));
};
const $03eb281d6ff9bb59$export$ba04f28d78ea7267 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: `async-${(0, $90b4560f34ff7aba$export$48e1d3fa57b0a2d5)}`,
        packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        teamName: (0, $90b4560f34ff7aba$export$d57b6b390e78d90f),
        id: `async-${(0, $90b4560f34ff7aba$export$48e1d3fa57b0a2d5)}`,
        packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03eb281d6ff9bb59$export$f1c59ccb370d6712, props)));
};

});
parcelRegister("eGLgs", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $754c27d37ccd1133$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $754c27d37ccd1133$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9etNK = parcelRequire("9etNK");

var $brgOn = parcelRequire("brgOn");
var $980Xe = parcelRequire("980Xe");

var $g3Ayl = parcelRequire("g3Ayl");

var $ioD1B = parcelRequire("ioD1B");

var $10xFf = parcelRequire("10xFf");

var $4Pf62 = parcelRequire("4Pf62");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $14XJw = parcelRequire("14XJw");

var $7qPn9 = parcelRequire("7qPn9");
const $754c27d37ccd1133$var$isSyntheticTenant = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true';
class $754c27d37ccd1133$export$580a2294c917898c extends (0, $980Xe.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
        const environment = (0, $7qPn9.toEnvironment)((0, $j8DrX.default)('ajs-environment'));
        const getEnvironmentType = (env)=>{
            if (env === 'prod') return (0, $9etNK.envType).PROD;
            if (env === 'staging') return (0, $9etNK.envType).STAGING;
            return (0, $9etNK.envType).DEV;
        };
        // If a ancestor (e.g. CoordinationClient wraps CoordinationClient) is already choreographed,
        // we should not re-choreograph this CoordinationClient
        const enableChoreographer = (0, $10xFf.shouldBeChoreographed)({
            messageType: messageType
        }) && !isAlreadyChoreographedAtAncestor;
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: getEnvironmentType(environment),
            additionalData: {
                sourceProductId: (0, $g3Ayl.ProductIds).JIRA
            }
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $754c27d37ccd1133$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        this.enableChoreographer = enableChoreographer;
        this.onMessageDisposition = onMessageDisposition;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $4R6GH.fg)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, $g3Ayl.MessageDeliveryStatus).STARTED : (0, $g3Ayl.MessageDeliveryStatus).BLOCKED);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) {
                const didStop = await super.stop(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $g3Ayl.MessageDeliveryStatus).STOPPED : (0, $g3Ayl.MessageDeliveryStatus).BLOCKED);
            }
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId).then((didStart)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, $g3Ayl.MessageDeliveryStatus).STARTED : (0, $g3Ayl.MessageDeliveryStatus).BLOCKED);
            return didStart;
        });
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId).then((didStop)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $g3Ayl.MessageDeliveryStatus).STOPPED : (0, $g3Ayl.MessageDeliveryStatus).BLOCKED);
            return didStop;
        });
    }
}
function $754c27d37ccd1133$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $ioD1B.useChoreographedStatusContext)();
    const client = new $754c27d37ccd1133$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor);
    const { fallback: fallback, messageId: messageId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: client.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $brgOn.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children));
}

});

parcelRegister("dRVix", function(module, exports) {

$parcel$export(module.exports, "useLoggedInPage", () => $9ce9420d6adb67d7$export$a7ca0608784708a1);
$parcel$export(module.exports, "getTrialDaysLeft", () => $9ce9420d6adb67d7$export$954628993bf3188e);
$parcel$export(module.exports, "isInGracePeriod", () => $9ce9420d6adb67d7$export$271517afaa0c15eb);

var $2ys8y = parcelRequire("2ys8y");

var $cYlk7 = parcelRequire("cYlk7");
function $9ce9420d6adb67d7$export$a7ca0608784708a1({ pageUrl: pageUrl }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { data: currentUserData } = (0, $cYlk7.useCurrentUser)();
    const encodedPageUrl = encodeURIComponent(pageUrl);
    // The user email should always be available unless the user is anonymous, in which case they won't see the edition awareness pill anyway
    const encodedUserEmail = encodeURIComponent(currentUserData.user.emailAddress ?? '');
    // This URL will take them through the login flow (if necessary) then redirect them to the given (encoded) `pageUrl`.
    return `https://${(0, $2ys8y.getATLContextDomain)('id')}/login?continue=${encodedPageUrl}&login_hint=${encodedUserEmail}&prompt=none`;
}
const $9ce9420d6adb67d7$export$9dbbf537dffaafc7 = (timestamp)=>new Date(timestamp).setUTCHours(0, 0, 0, 0);
const $9ce9420d6adb67d7$export$954628993bf3188e = (currentDate, trialEndTime)=>trialEndTime ? Math.ceil(($9ce9420d6adb67d7$export$9dbbf537dffaafc7(trialEndTime) - currentDate) / 86400000) : undefined;
const $9ce9420d6adb67d7$export$271517afaa0c15eb = (currentDate, trialEndTime)=>{
    const trialDaysLeft = $9ce9420d6adb67d7$export$954628993bf3188e(currentDate, trialEndTime);
    // Technically we do not know whether user is in grace period or not, but if user is able to access the Jira with no payment details
    // and is trialEndTime is missing or over we assume that site is in grace period
    return !trialDaysLeft || trialDaysLeft < 0;
};

});

parcelRegister("5oBMG", function(module, exports) {

$parcel$export(module.exports, "useProductEntitlementDetails", () => $3295ae4955475ae4$export$e02d6385b5d47f5d);

var $9OXo1 = parcelRequire("9OXo1");
const $3295ae4955475ae4$export$e02d6385b5d47f5d = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.productEntitlementDetails || null;
};

});

const $90b4560f34ff7aba$export$b8b9d90f9e5bd72b = '@atlassian/jira-trial-sprint-board';
const $90b4560f34ff7aba$export$d57b6b390e78d90f = 'growth-tako';
const $90b4560f34ff7aba$export$48e1d3fa57b0a2d5 = 'trialSprintBoard';
const $90b4560f34ff7aba$export$cf8de4fabae858f0 = 'jira_premium_sample_project_id';
const $90b4560f34ff7aba$export$c7e6a6b283196232 = '/gateway/api';
const $90b4560f34ff7aba$export$e663120dbb5b4d95 = 'prj-trial-sprint-board-v2-msg-1';
const $90b4560f34ff7aba$export$a248637601302a6b = 'prj-trial-sprint-board-v2-msg-2';
const $90b4560f34ff7aba$export$389fc29b60f6a76b = 'prj-trial-sprint-board-v2-msg-3';
const $90b4560f34ff7aba$export$87b7067777cb7156 = 'trial-sprint-board';
const $90b4560f34ff7aba$export$a8c0b3da0abca1ac = 'trial-sprint-board-dismissed';

parcelRegister("60gvu", function(module, exports) {

$parcel$export(module.exports, "useCreateTrialSprintBoard", () => $bdbe1b0b24b673c2$export$22329068885bcc27);
$parcel$export(module.exports, "useIsNotTrialSprintBoardProject", () => $bdbe1b0b24b673c2$export$8b329ff03fe43c53);
$parcel$export(module.exports, "useTrialSprintBoardCtaLink", () => $bdbe1b0b24b673c2$export$a731bac57ab8049d);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $j5YhT = parcelRequire("j5YhT");

var $jX0pr = parcelRequire("jX0pr");

var $koeKL = parcelRequire("koeKL");

var $bngFq = parcelRequire("bngFq");

var $jcw0u = parcelRequire("jcw0u");


var $giJBv = parcelRequire("giJBv");

var $9mxBe = parcelRequire("9mxBe");
function $bdbe1b0b24b673c2$export$22329068885bcc27() {
    const isEligibleForExperiment = (0, $giJBv.useIsEligibleForTrialSprintBoard)();
    return ()=>{
        if (isEligibleForExperiment) (0, $9mxBe.createTrialSprintBoard)();
    };
}
const $bdbe1b0b24b673c2$export$dca4afd9682f517e = async (cloudId)=>{
    const siteTraits = await (0, $jX0pr.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    const trialSprintBoardTrait = siteTraits.find((traits)=>traits.name === (0, $90b4560f34ff7aba$export$cf8de4fabae858f0));
    if (typeof trialSprintBoardTrait?.value !== 'string') return undefined;
    return trialSprintBoardTrait.value;
};
const $bdbe1b0b24b673c2$export$5efe839f0f2e520e = async (cloudId, projectId)=>{
    const trialSprintBoardId = await $bdbe1b0b24b673c2$export$dca4afd9682f517e(cloudId);
    return trialSprintBoardId === projectId;
};
const $bdbe1b0b24b673c2$export$3b897619e437256e = async (cloudId, relayEnvironment, createAnalyticsEvent)=>{
    const trialSprintBoardId = await $bdbe1b0b24b673c2$export$dca4afd9682f517e(cloudId);
    if (trialSprintBoardId === undefined) return false;
    const projectAri = (0, $j5YhT.JiraProjectAri).create({
        siteId: cloudId,
        projectId: trialSprintBoardId
    }).toString();
    const { isProjectActive: isProjectActive, projectCreated: projectCreated } = await (0, $9mxBe.getTrialSprintBoardProjectData)(projectAri, relayEnvironment, createAnalyticsEvent);
    const millisDay = 86400000;
    const daysLeft = projectCreated ? Math.ceil((projectCreated + 30 * millisDay - Date.now()) / millisDay) : -1;
    return isProjectActive && daysLeft > 0;
};
const $bdbe1b0b24b673c2$export$d5193e0cb6586d5 = async (cloudId, relayEnvironment, createAnalyticsEvent)=>{
    const trialSprintBoardId = await $bdbe1b0b24b673c2$export$dca4afd9682f517e(cloudId);
    if (trialSprintBoardId === undefined) return undefined;
    const projectAri = (0, $j5YhT.JiraProjectAri).create({
        siteId: cloudId,
        projectId: trialSprintBoardId
    }).toString();
    const { projectKey: projectKey, boardId: boardId } = await (0, $9mxBe.getTrialSprintBoardProjectData)(projectAri, relayEnvironment, createAnalyticsEvent);
    if (projectKey === null || boardId === null) return undefined;
    const projectBoardWithIssueSelectedPath = `/jira/software/projects/${projectKey}/boards/${boardId}?selectedIssue=LEARNJIRA-1`;
    return projectBoardWithIssueSelectedPath;
};
const $bdbe1b0b24b673c2$export$8b329ff03fe43c53 = (currentProjectId)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [isNotTsbProject, setIsNotTsbProject] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        $bdbe1b0b24b673c2$export$5efe839f0f2e520e(cloudId, currentProjectId).then((isTsbProject)=>setIsNotTsbProject(!isTsbProject));
    }, [
        cloudId,
        currentProjectId
    ]);
    return isNotTsbProject;
};
const $bdbe1b0b24b673c2$export$a731bac57ab8049d = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const relayEnvironment = (0, $8Uumt.useRelayEnvironment)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [ctaLink, setCtaLink] = (0, $5uXOq.useState)('');
    (0, $5uXOq.useEffect)(()=>{
        const getCtaLink = async ()=>{
            const isProjectAvailable = await $bdbe1b0b24b673c2$export$3b897619e437256e(cloudId, relayEnvironment, createAnalyticsEvent);
            if (isProjectAvailable) {
                const tsbIssuePath = await $bdbe1b0b24b673c2$export$d5193e0cb6586d5(cloudId, relayEnvironment, createAnalyticsEvent);
                if (tsbIssuePath !== undefined) setCtaLink(tsbIssuePath);
            }
        };
        getCtaLink().catch((e)=>{
            (0, $jcw0u.default)({
                error: e,
                meta: {
                    id: 'getTrialSprintBoardProjectData',
                    packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b),
                    teamName: (0, $90b4560f34ff7aba$export$d57b6b390e78d90f)
                }
            });
        });
    }, [
        cloudId,
        createAnalyticsEvent,
        relayEnvironment
    ]);
    return ctaLink;
};

});
parcelRegister("giJBv", function(module, exports) {

$parcel$export(module.exports, "useIsEligibleForTrialSprintBoard", () => $47804f028d4aa8cc$export$e6f5647df30a55f2);

var $5uXOq = parcelRequire("5uXOq");

var $dRVix = parcelRequire("dRVix");


var $ldyPw = parcelRequire("ldyPw");

var $ef5Xn = parcelRequire("ef5Xn");

var $k9JTq = parcelRequire("k9JTq");

var $7trqb = parcelRequire("7trqb");

var $hqBSi = parcelRequire("hqBSi");

var $5oBMG = parcelRequire("5oBMG");
function $47804f028d4aa8cc$export$e6f5647df30a55f2() {
    const appEditions = (0, $k9JTq.useAppEditions)();
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const licenseStates = (0, $7trqb.useLicenseStates)();
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    const jswAppEdition = appEditions.software;
    // Only has JSW in licenses, assumed to be active given we are in onboarding flow
    const hasActiveJswLicense = licensedProducts[0, $c06e1abca7c13910$export$1346c9aa3cbb477d] && licenseStates.software === (0, $ef5Xn.LICENSE_STATE_ACTIVE) && Object.keys(licensedProducts).length === 1;
    // JSW Premium
    const isOnPremiumJsw = jswAppEdition === (0, $ldyPw.PREMIUM_EDITION);
    // On a trial
    const entitlementDetails = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d];
    const currentDate = (0, $5uXOq.useMemo)(()=>Date.now(), []);
    const trialDaysLeft = (0, $dRVix.getTrialDaysLeft)(currentDate, entitlementDetails?.trialEndTime) ?? 0;
    const isOnTrial = trialDaysLeft >= 0;
    return hasActiveJswLicense && isOnPremiumJsw && isOnTrial;
}

});

parcelRegister("9mxBe", function(module, exports) {

$parcel$export(module.exports, "createTrialSprintBoard", () => $a543aaf7c0a4dacb$export$37cea344fdf9b6ed);
$parcel$export(module.exports, "getTrialSprintBoardProjectData", () => $a543aaf7c0a4dacb$export$83e8cdb22fb8892d);
$parcel$export(module.exports, "getIsTrialSprintBoardModalDismissed", () => $a543aaf7c0a4dacb$export$2e4dd8ccc94e5fa);
$parcel$export(module.exports, "setIsTrialSprintBoardModalDismissed", () => $a543aaf7c0a4dacb$export$ad35b736c85ccec3);

var $530x5 = parcelRequire("530x5");

var $eiowN = parcelRequire("eiowN");

var $2vSU6 = parcelRequire("2vSU6");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");

var $bSSG7 = parcelRequire("bSSG7");

function $a543aaf7c0a4dacb$export$37cea344fdf9b6ed() {
    (0, $eusud.performPostRequest)('/rest/trial-project/v1/create').catch((error)=>{
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'createTrialSprintBoard',
                packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b),
                teamName: (0, $90b4560f34ff7aba$export$d57b6b390e78d90f)
            }
        });
    });
}
const $a543aaf7c0a4dacb$export$83e8cdb22fb8892d = async (projectAri, relayEnvironment, createAnalyticsEvent)=>{
    const data = await (0, $eiowN.fetchQuery)(relayEnvironment, (0, $530x5.default), {
        projectAri: projectAri
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const project = data?.jira?.jiraProject;
    const isProjectActive = project?.status === (0, $2vSU6.JIRA_PROJECT_STATUS_ACTIVE);
    const projectKey = project?.key;
    const boardId = project?.tmpBoardId;
    const projectCreated = project?.created ? new Date(project.created).getTime() : null;
    if (!project) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'trialSprintBoardProject notFound', {});
    else if (!projectKey || !boardId || !project.status || !projectCreated) (0, $jcw0u.default)({
        error: new Error('Could not retrieve all trial sprint board project data'),
        meta: {
            id: 'getTrialSprintBoardProjectData',
            packageName: (0, $90b4560f34ff7aba$export$b8b9d90f9e5bd72b),
            teamName: (0, $90b4560f34ff7aba$export$d57b6b390e78d90f)
        },
        attributes: {
            isProjectActive: isProjectActive,
            activeStatusIsPresent: !!project?.status,
            projectKeyIsPresent: !!projectKey,
            boardId: boardId ?? null,
            projectCreated: projectCreated
        }
    });
    return {
        isProjectActive: isProjectActive,
        projectKey: projectKey ?? null,
        boardId: boardId ?? null,
        projectCreated: projectCreated
    };
};
const $a543aaf7c0a4dacb$var$tsbLocalStorage = (0, $bSSG7.createLocalStorageProvider)((0, $90b4560f34ff7aba$export$87b7067777cb7156));
const $a543aaf7c0a4dacb$export$2e4dd8ccc94e5fa = ()=>{
    return $a543aaf7c0a4dacb$var$tsbLocalStorage.get((0, $90b4560f34ff7aba$export$a8c0b3da0abca1ac)) === true;
};
const $a543aaf7c0a4dacb$export$ad35b736c85ccec3 = ()=>{
    $a543aaf7c0a4dacb$var$tsbLocalStorage.set((0, $90b4560f34ff7aba$export$a8c0b3da0abca1ac), true);
};

});
parcelRegister("530x5", function(module, exports) {

$parcel$export(module.exports, "default", () => $56400afcfc79b920$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6e9ff8558faf875cd1fb3efe32191034>>
 * @relayHash d60edddcce9abded6e473e7b00b820b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 77530e950080d1180f6d423652afe470e45507cf93cfa991dff87c19978f3b49
const $56400afcfc79b920$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "key"
    }, v4 = {
        "kind": "ScalarField",
        "name": "created"
    }, v5 = {
        "kind": "ScalarField",
        "name": "tmpBoardId"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "servicesTrialSprintBoardProjectDataQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "servicesTrialSprintBoardProjectDataQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "77530e950080d1180f6d423652afe470e45507cf93cfa991dff87c19978f3b49",
            "metadata": {},
            "name": "servicesTrialSprintBoardProjectDataQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$56400afcfc79b920$var$node.hash = "0bff8aa9317d4caac17388ad150c17cb";
var $56400afcfc79b920$export$2e2bcd8739ae039 = $56400afcfc79b920$var$node;

});



parcelRegister("j9wkq", function(module, exports) {

$parcel$export(module.exports, "trialSprintBoardModalEntryPoint", () => $3261cdbb80ebb186$export$ee8e5ecce2602f9);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $3261cdbb80ebb186$export$ee8e5ecce2602f9 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("cVPKW")).then(({ TrialSprintBoardModalEntryPoint: TrialSprintBoardModalEntryPoint })=>TrialSprintBoardModalEntryPoint), {
        moduleId: "d60f0bc1"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cVPKW", function(module, exports) {

let $96a2f492aad30192$var$load = (parcelRequire("28QjX"))(4);
module.exports = $96a2f492aad30192$var$load("cOnF4").then(()=>parcelRequire('ejP4E'));

});


parcelRegister("24MMC", function(module, exports) {

$parcel$export(module.exports, "getMessageId", () => $9ca37ce08ed605de$export$7a6ec380c1221521);

const $9ca37ce08ed605de$export$7a6ec380c1221521 = (daysLeft)=>{
    if (daysLeft === 20 || daysLeft === 19) return 0, $90b4560f34ff7aba$export$e663120dbb5b4d95;
    if (daysLeft === 18 || daysLeft === 17) return 0, $90b4560f34ff7aba$export$a248637601302a6b;
    if (daysLeft <= 16) return 0, $90b4560f34ff7aba$export$389fc29b60f6a76b;
};

});


parcelRegister("dz0Q5", function(module, exports) {

$parcel$export(module.exports, "AsyncUpflowIframeComponent", () => $aab5ccb109290e76$export$7f34679273a30171);

var $5uXOq = parcelRequire("5uXOq");

var $b7Svb = parcelRequire("b7Svb");

var $cSD7y = parcelRequire("cSD7y");

var $4mO32 = parcelRequire("4mO32");

var $7XluA = parcelRequire("7XluA");

var $73aMY = parcelRequire("73aMY");

var $cMquZ = parcelRequire("cMquZ");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $aab5ccb109290e76$var$AsyncUpflowIframeComponentOld = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("4KFSs")).then((exportedModule)=>exportedModule.UpflowIframeComponent), {
    ssr: false,
    moduleId: "./src/packages/growth/up-flow/upflow-iframe-plugin/src/main.tsx"
});
const $aab5ccb109290e76$var$entryPointParams = {};
const $aab5ccb109290e76$var$props = {};
const $aab5ccb109290e76$var$AsyncUpflowIframeComponentNew = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $73aMY.upflowIframeComponentEntrypoint), $aab5ccb109290e76$var$entryPointParams);
    const [{ renderUpflowModal: renderUpflowModal }] = (0, $cMquZ.useUpflowModal)();
    // Violating react-entrypoint/no-load-in-hooks so we can experiment faster: https://hello.atlassian.net/wiki/spaces/JIE/pages/4772823699/LDR+Entrypoint+Load+Via+Hooks+For+Faster+Experimentation
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (renderUpflowModal) entryPointActions.load();
    }, [
        entryPointActions,
        renderUpflowModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "issue-onboarding-modal-lazy",
        packageName: "AsyncUpflowIframeComponent",
        placeholderName: "async-upflow-iframe-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $aab5ccb109290e76$var$props
    });
};
const $aab5ccb109290e76$export$7f34679273a30171 = (0, $cSD7y.componentWithFG)('upflow_iframe_iv_llc_unnecessary_bundles', $aab5ccb109290e76$var$AsyncUpflowIframeComponentNew, $aab5ccb109290e76$var$AsyncUpflowIframeComponentOld);

});
parcelRegister("73aMY", function(module, exports) {

$parcel$export(module.exports, "upflowIframeComponentEntrypoint", () => $1376512f73b86888$export$92c53bb1afc6d332);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $1376512f73b86888$export$92c53bb1afc6d332 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("4KFSs")).then(({ UpflowIframeComponent: UpflowIframeComponent })=>UpflowIframeComponent), {
        moduleId: "caf60ffd"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4KFSs", function(module, exports) {

let $375bf142e3595993$var$load = (parcelRequire("28QjX"))(4);
module.exports = $375bf142e3595993$var$load("1umXM").then(()=>parcelRequire('f7aUi'));

});


parcelRegister("cMquZ", function(module, exports) {

$parcel$export(module.exports, "useUpflowModal", () => $85614d266b32fe16$export$7025cc2729b71e44);

var $ldyPw = parcelRequire("ldyPw");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

const $85614d266b32fe16$var$initialState = {
    renderUpflowModal: false,
    product: 'jira-software',
    touchpointId: '',
    flow: 'learn-more',
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose: ()=>{},
    targetEdition: (0, $ldyPw.FREE_EDITION)
};
const $85614d266b32fe16$var$actions = {
    mountUpflowModal: ({ targetEdition: targetEdition, product: product, flow: flow, touchpointId: touchpointId, subRoute: subRoute, onClose: onClose, onOpen: onOpen })=>({ setState: setState })=>{
            setState({
                targetEdition: targetEdition,
                product: product,
                flow: flow,
                touchpointId: touchpointId,
                subRoute: subRoute,
                onClose: onClose,
                onOpen: onOpen,
                renderUpflowModal: true
            });
        },
    unMountUpflowModal: ()=>({ setState: setState })=>{
            setState({
                renderUpflowModal: false
            });
        }
};
const $85614d266b32fe16$var$Store = (0, $iXqE5.createStore)({
    name: (0, $3a066fc4381e3c91$export$675a4427bf3750a2),
    initialState: $85614d266b32fe16$var$initialState,
    actions: $85614d266b32fe16$var$actions
});
const $85614d266b32fe16$export$6d73384be122c2dd = (0, $51nlc.createSubscriber)($85614d266b32fe16$var$Store);
const $85614d266b32fe16$export$e672be732bd57171 = (0, $gg7kZ.createContainer)($85614d266b32fe16$var$Store);
const $85614d266b32fe16$export$7025cc2729b71e44 = (0, $3sQ5x.createHook)($85614d266b32fe16$var$Store);

});
const $3a066fc4381e3c91$export$675a4427bf3750a2 = 'upflow-modal-store';



parcelRegister("4p6rw", function(module, exports) {

$parcel$export(module.exports, "JiraHeritageLoader", () => $da151c89e6acf066$export$9499deca9933db5b);

var $5uXOq = parcelRequire("5uXOq");

var $cQZXC = parcelRequire("cQZXC");

var $1r4rO = parcelRequire("1r4rO");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $6jY6G = parcelRequire("6jY6G");

var $6yXtV = parcelRequire("6yXtV");

var $4su49 = parcelRequire("4su49");

var $kiABc = parcelRequire("kiABc");

var $8Z3n8 = parcelRequire("8Z3n8");
const $da151c89e6acf066$var$JiraHeritageLoaderOld = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [hasHeritageDownloaded, setHasHeritageDownloaded] = (0, $5uXOq.useState)(false);
    (0, $8Z3n8.useWrmStatsEffects)();
    /* eslint-disable jira/wrm/no-load-bridge */ const loadJiraHeritageDependencies = (0, $5uXOq.useCallback)(()=>{
        setHasHeritageDownloaded(true);
        (0, $4su49.asyncWrmRequire)([
            ...(0, $1r4rO.jiraSuperBatchDependencies),
            ...(0, $kiABc.getJiraHeritageDependencies)()
        ]).then(()=>(0, $cQZXC.waitForHeritage)()?.resolve?.());
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (isReady && !hasHeritageDownloaded) loadJiraHeritageDependencies();
    }, [
        hasHeritageDownloaded,
        isReady,
        loadJiraHeritageDependencies,
        route
    ]);
    return null;
};
const $da151c89e6acf066$var$JiraHeritageLoaderNew = (0, $5uXOq.Fragment);
const $da151c89e6acf066$export$9499deca9933db5b = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('no-wrm-heritage-loader'), $da151c89e6acf066$var$JiraHeritageLoaderNew, $da151c89e6acf066$var$JiraHeritageLoaderOld);
$da151c89e6acf066$export$9499deca9933db5b.displayName = 'JiraHeritageLoader';

});
parcelRegister("kiABc", function(module, exports) {

$parcel$export(module.exports, "getJiraHeritageDependencies", () => $0d81a9889d6c3d74$export$e8f6d7acd5817fa2);
const $0d81a9889d6c3d74$export$e8f6d7acd5817fa2 = ()=>[
        // superbatch resources
        // analytics
        'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
        // dependencies from HeaderFooterRendering
        'wrc!jira.webresources:key-commands',
        'wrc!jira.webresources:header',
        // . dialog
        'wrc!com.atlassian.administration.atlassian-admin-quicksearch-jira:admin-quicksearch-webresources',
        // overrides for AUI, styles and bridge apis
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
        'wrc!jira.webresources:global-static',
        // browser metrics
        'wrc!com.atlassian.jira.plugins.jira-browser-metrics:contrib',
        'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:impl',
        'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',
        // repository shortcuts from navigation
        'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:repository-shortcuts-navigation-next',
        // issue view resources
        'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources-init',
        // create board dialog
        'wrc!com.pyxis.greenhopper.jira:gh-create-board-adg3-no-condition',
        // old analytics library
        'wrc!com.atlassian.analytics.analytics-client:js-events',
        // frontend cache
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:global-cache',
        // impersonation flag (logged as someone)
        'wrc!com.atlassian.crowd.user-provisioning-vertigo-plugin:impersonation-resources',
        // flag displayed when there are too many emails on the instance
        'wrc!jira.webresources:spam-protection-flags',
        // in-product announcements (displayed e.g. if there is an incident)
        'wrc!com.atlassian.pas:pas-everypage-static',
        // Bento resources
        'wrc!com.atlassian.jira.jira-fileviewer-plugin:fileviewer',
        'wrc!com.atlassian.auiplugin:dialog2',
        'wrc!com.atlassian.jira.jira-fileviewer-plugin:atlassian-fileviewer',
        'wrc!com.atlassian.jira.jira-issue-nav-plugin:stylesheets'
    ];

});

parcelRegister("8Z3n8", function(module, exports) {

$parcel$export(module.exports, "useWrmStatsEffects", () => $b2fe1e724cbc12ec$export$7ff53723d9d2886d);

var $5uXOq = parcelRequire("5uXOq");

var $6yXtV = parcelRequire("6yXtV");

var $bVDE5 = parcelRequire("bVDE5");
const $b2fe1e724cbc12ec$export$7ff53723d9d2886d = ()=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [{ transitionsCount: transitionsCount }] = (0, $bVDE5.useSpaStateTransition)();
    (0, $5uXOq.useEffect)(()=>{
        if (isReady && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__ && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        !window.__WRM_INTERNAL_STATS__.isPageInteractive) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__.isPageInteractive = true;
    }, [
        isReady
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (transitionsCount > 0) // clear stats on transition
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WRM_INTERNAL_STATS__ = {};
    }, [
        transitionsCount
    ]);
};

});


parcelRegister("iB3m4", function(module, exports) {

$parcel$export(module.exports, "isJiraSoftware", () => $56ae562978846669$export$1810b10f6a208e90);

var $2vSU6 = parcelRequire("2vSU6");
const $56ae562978846669$export$1810b10f6a208e90 = (projectType)=>projectType && projectType === (0, $2vSU6.SOFTWARE_PROJECT);

});

parcelRegister("6g75y", function(module, exports) {

$parcel$export(module.exports, "getRovoVideoOnboardingHash", () => $4bced0a0fc8ba960$export$7ed5123ac12331e6);
$parcel$export(module.exports, "setRovoVideoOnboardingSeen", () => $4bced0a0fc8ba960$export$88c0db0edebd3404);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");
const $4bced0a0fc8ba960$export$9e35978d27ff337f = 'rovoVideoPlayerSeen';
const $4bced0a0fc8ba960$export$7ed5123ac12331e6 = async (accountId)=>{
    try {
        return accountId != null ? (await (0, $89SaW.getUserProperty)(accountId, $4bced0a0fc8ba960$export$9e35978d27ff337f)).hashId : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 404 - property has not been previously set
        if (error.statusCode === 404) return null;
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'rovoUserDismissGet',
            packageName: 'jiraRovoVideoModal'
        });
        throw error;
    }
};
const $4bced0a0fc8ba960$export$88c0db0edebd3404 = async (accountId, hashId)=>{
    try {
        if (accountId != null) return await (0, $89SaW.setUserProperties)(accountId, $4bced0a0fc8ba960$export$9e35978d27ff337f, JSON.stringify({
            hashId: hashId
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'rovoUserDismissSet',
            packageName: 'jiraRovoVideoModal'
        });
        throw error;
    }
};

});

parcelRegister("6xesd", function(module, exports) {

$parcel$export(module.exports, "useCoordinationClient", () => $67e2f11848116912$export$ddc368dc94a41e62);

var $5uXOq = parcelRequire("5uXOq");

var $eGLgs = parcelRequire("eGLgs");

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");
const $67e2f11848116912$export$ddc368dc94a41e62 = ()=>{
    const epMessageId = 'jira_rovo_video_modal_ga';
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, $eGLgs.CoordinationClient)(cloudId, '/gateway/api', false, orgId, 'engagement'), [
        cloudId,
        orgId
    ]);
    const start = (0, $5uXOq.useCallback)(async ()=>{
        if (!epMessageId) return false;
        return coordinationClient.start(epMessageId);
    }, [
        epMessageId,
        coordinationClient
    ]);
    const stop = (0, $5uXOq.useCallback)(()=>{
        if (!epMessageId) return false;
        return coordinationClient.stop(epMessageId);
    }, [
        epMessageId,
        coordinationClient
    ]);
    return {
        coordinationClient: coordinationClient,
        start: start,
        stop: stop
    };
};

});

parcelRegister("38EzX", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbAdapter", () => $3ee15d0681681178$export$2255367d5c9162b3);

var $5uXOq = parcelRequire("5uXOq");

var $67Adx = parcelRequire("67Adx");
const $3ee15d0681681178$export$2255367d5c9162b3 = ()=>{
    const baseUrl = '';
    // @ts-expect-error - TS2322 - Type '{ baseUrl: string; }' is not assignable to type 'IntrinsicAttributes & Omit<PropsWithDefault, "baseUrl" | keyof InjectedProps>'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67Adx.default), {
        baseUrl: baseUrl
    });
};

});
parcelRegister("67Adx", function(module, exports) {

$parcel$export(module.exports, "default", () => $fce4053be7c0ea3f$export$2e2bcd8739ae039);

var $9sGI6 = parcelRequire("9sGI6");

var $aYHuU = parcelRequire("aYHuU");

var $7GR7x = parcelRequire("7GR7x");

var $bQtVL = parcelRequire("bQtVL");

var $3XHss = parcelRequire("3XHss");

var $1DFxi = parcelRequire("1DFxi");
var $fce4053be7c0ea3f$export$2e2bcd8739ae039 = (0, $9sGI6.default)((0, $aYHuU.default), {
    LegacyApiBridge: // @ts-expect-error - Type 'FunctionComponent<Omit<PropsWithDefault, keyof AnalyticsEvents>>' is not assignable to type 'ComponentType<Props> | undefined'.
    $7GR7x.default,
    LegacyBreadcrumbConnector: $bQtVL.default,
    LegacyBreadcrumbState: // @ts-expect-error - TS2322 - Type 'typeof LegacyBreadcrumbState' is not assignable to type 'ComponentType<LegacyBreadcrumbStateProviderProps> | undefined'.
    $1DFxi.default,
    LegacyBreadcrumbRenderer: $3XHss.default
});

});
parcelRegister("aYHuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2640273d477c5ef9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jzjy1 = parcelRequire("jzjy1");

var $b71gk = parcelRequire("b71gk");

const $2640273d477c5ef9$var$LegacyBreadcrumbAdapter = ({ LegacyBreadcrumbRenderer: LegacyBreadcrumbRenderer, LegacyBreadcrumbState: LegacyBreadcrumbState, LegacyApiBridge: LegacyApiBridge, LegacyBreadcrumbConnector: LegacyBreadcrumbConnector })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LegacyBreadcrumbState, null, ({ api: api, state: state })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LegacyApiBridge, {
            onInsertItem: api.insertItem,
            onRemoveItem: api.removeItem,
            onSetRenderTarget: api.setTargetElement
        }), // Only activate the breadcrumb connector if there is a breadcrumb render target
        state.targetElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
            id: "legacy-breadcrumb-adapter"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LegacyBreadcrumbConnector, {
            legacyTrail: state.trail
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LegacyBreadcrumbRenderer, {
            targetElement: state.targetElement
        }))));
var $2640273d477c5ef9$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSource)('legacyBreadcrumbs', (0, $4d5e0871c06cee03$export$f636b5b56f1d624a))($2640273d477c5ef9$var$LegacyBreadcrumbAdapter);

});

parcelRegister("7GR7x", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1c2002ff619891e$export$2e2bcd8739ae039);

var $1bJTy = parcelRequire("1bJTy");

var $9sGI6 = parcelRequire("9sGI6");

var $hciGg = parcelRequire("hciGg");
const $e1c2002ff619891e$var$analyticsEvents = {
    onInsertItemFired: (analyticsEvent)=>(0, $1bJTy.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'insertItem'
            }
        }),
    onRemoveItemFired: (analyticsEvent)=>(0, $1bJTy.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'removeItem'
            }
        }),
    onSetRenderTargetFired: (analyticsEvent)=>(0, $1bJTy.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'render'
            }
        }),
    onOnBreadCrumbsUpdateFired: (analyticsEvent)=>(0, $1bJTy.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'onBreadCrumbsUpdate'
            }
        })
};
var $e1c2002ff619891e$export$2e2bcd8739ae039 = (0, $9sGI6.default)((0, $hciGg.default), $e1c2002ff619891e$var$analyticsEvents);

});
parcelRegister("1bJTy", function(module, exports) {

$parcel$export(module.exports, "fireOperationalAnalytics", () => $065c8ba87a790756$export$79f423cc3fd39762);

var $4f8Oj = parcelRequire("4f8Oj");

var $jcw0u = parcelRequire("jcw0u");

var $gvRPW = parcelRequire("gvRPW");

var $i4iBk = parcelRequire("i4iBk");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $065c8ba87a790756$var$isNotUndefined = (a)=>a !== undefined;
const $065c8ba87a790756$var$mapPayload = (payload)=>{
    const context = (0, $i4iBk.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $065c8ba87a790756$var$isNotUndefined);
};
const $065c8ba87a790756$export$79f423cc3fd39762 = (event, payload)=>{
    // Causes issues with mounting the src/packages/confluence/project-pages/src/view/examples.js component in storybook tests.
    // This is due to node_modules/@atlassiansox/analytics-web-client/dist/analytics-web-client.with-deps.js producing a reference error with the normalize function
    // This is possibly due to some scope hoisting issue with jest that is not present in the browser
    try {
        event.update({
            ...$065c8ba87a790756$var$mapPayload(payload),
            analyticsType: (0, $gvRPW.OPERATIONAL_EVENT_TYPE)
        }).fire();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            event: event,
            error: e,
            meta: {
                id: 'fireOperationalAnalytics',
                packageName: 'jiraAnalyticsWebReact',
                teamName: 'legacy-jfp-team-do-not-use'
            }
        });
    }
};

});
parcelRegister("i4iBk", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a364fe632bf506b$export$2e2bcd8739ae039);

var $cjFoH = parcelRequire("cjFoH");

var $9xWGk = parcelRequire("9xWGk");
var // AnalyticsDataPayload is cast to inexact type so that it can also accept subtypes
// eslint-disable-next-line jira/import/no-anonymous-default-export
$8a364fe632bf506b$export$2e2bcd8739ae039 = (payload)=>{
    const { tags: tags, containerId: containerId, containers: containers, containerType: containerType, objectId: objectId, objectType: objectType, attributes: attributes } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
        tags: tags,
        containerId: containerId,
        containers: containers,
        containerType: containerType,
        objectId: objectId,
        objectType: objectType,
        attributes: attributes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH))));
};

});


parcelRegister("hciGg", function(module, exports) {

$parcel$export(module.exports, "default", () => $060d1d7061b6e3c1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");

var $8oe80 = parcelRequire("8oe80");

var $c1YJb = parcelRequire("c1YJb");
// eslint-disable-next-line jira/react/no-class-components
class $060d1d7061b6e3c1$var$LegacyApiBridge extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { onInsertItem: onInsertItem, onRemoveItem: onRemoveItem, onSetRenderTarget: onSetRenderTarget, onBreadCrumbsUpdate: onBreadCrumbsUpdate } = this;
        (0, $c1YJb.default)({
            insertItem: onInsertItem,
            removeItem: onRemoveItem,
            render: onSetRenderTarget,
            onBreadCrumbsUpdate: onBreadCrumbsUpdate
        });
    }
    /* eslint-enable jira/react-no-unneeded-arrow-function-properties */ render() {
        return null;
    }
    constructor(...args){
        super(...args), /* eslint-disable jira/react-no-unneeded-arrow-function-properties */ this.onInsertItem = (item)=>{
            const { onInsertItem: onInsertItem, onInsertItemFired: onInsertItemFired } = this.props;
            onInsertItemFired();
            onInsertItem(item);
        }, this.onRemoveItem = (itemId)=>{
            const { onRemoveItem: onRemoveItem, onRemoveItemFired: onRemoveItemFired } = this.props;
            onRemoveItemFired();
            onRemoveItem(itemId);
        }, this.onSetRenderTarget = (element)=>{
            const { onSetRenderTarget: onSetRenderTarget, onSetRenderTargetFired: onSetRenderTargetFired } = this.props;
            onSetRenderTargetFired();
            onSetRenderTarget(element);
        }, this.onBreadCrumbsUpdate = ()=>{
            const { onOnBreadCrumbsUpdateFired: onOnBreadCrumbsUpdateFired } = this.props;
            onOnBreadCrumbsUpdateFired();
            return (0, $kVLXA.Observable).empty();
        };
    }
}
var $060d1d7061b6e3c1$export$2e2bcd8739ae039 = (0, $8oe80.default)('legacyApiBridge', {
    onInsertItemFired: 'apiMethodCalled',
    onRemoveItemFired: 'apiMethodCalled',
    onSetRenderTargetFired: 'apiMethodCalled',
    onOnBreadCrumbsUpdateFired: 'apiMethodCalled'
})($060d1d7061b6e3c1$var$LegacyApiBridge);

});
parcelRegister("c1YJb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8c3f644565eaafc$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $9B86Q = parcelRequire("9B86Q");

var $dJl1T = parcelRequire("dJl1T");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a8c3f644565eaafc$export$2e2bcd8739ae039 = (legacyAPI)=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $9B86Q.loadBridgeWeak)({
        name: 'jira/globalnavigator/breadcrumbs/bridge'
    }).then((bridge)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        bridge(legacyAPI);
    }).catch((err)=>(0, $dJl1T.default).safeErrorWithoutCustomerData('breadcrumbs.v2.bridge', err.toString()));

});



parcelRegister("bQtVL", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c34ce41a7e16e82$export$2e2bcd8739ae039);

var $9sGI6 = parcelRequire("9sGI6");

var $c2D8L = parcelRequire("c2D8L");

var $btYLD = parcelRequire("btYLD");

var $gEFwt = parcelRequire("gEFwt");

var $75PvK = parcelRequire("75PvK");

var $7OPFF = parcelRequire("7OPFF");

var $5fGpW = parcelRequire("5fGpW");
var $2c34ce41a7e16e82$export$2e2bcd8739ae039 = (0, $9sGI6.default)((0, $7OPFF.default), {
    Breadcrumb: $c2D8L.default,
    ProjectBreadcrumb: $gEFwt.default,
    BoardBreadcrumb: // @ts-expect-error - TS2322 - Type '{ ({  children, boardId, boardName, isSimplifiedProject, projectId, }: BoardBreadcrumbProps): JSX.Element; defaultProps: { children: null; isSimplifiedProject: boolean; projectId: undefined; }; }' is not assignable to type 'ComponentType<Partial<BoardBreadcrumbProps>> | undefined'.
    $btYLD.default,
    UserBreadcrumb: $75PvK.default,
    ContextProvider: $5fGpW.default
});

});
parcelRegister("c2D8L", function(module, exports) {

$parcel$export(module.exports, "default", () => $904f5413e35195e5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $7Jxgt = parcelRequire("7Jxgt");

var $aIVNN = parcelRequire("aIVNN");
// eslint-disable-next-line jira/react/no-class-components
class $904f5413e35195e5$var$BreadcrumbOps extends (0, $5uXOq.Component) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props){
        super(props), this.id = '';
        this.id = (0, $7Jxgt.v4)();
        if (false) this.onPushBreadcrumb();
    }
    componentDidMount() {
        this.onPushBreadcrumb();
    }
    componentDidUpdate(prevProps) {
        const { breadcrumb: prevBreadcrumb } = prevProps;
        const { api: api, breadcrumb: breadcrumb } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevBreadcrumb, breadcrumb)) api.updateBreadcrumb({
            id: this.id,
            ...breadcrumb
        });
    }
    componentWillUnmount() {
        const { api: api } = this.props;
        api.popBreadcrumb();
    }
    onPushBreadcrumb() {
        const { api: api, breadcrumb: breadcrumb } = this.props;
        api.pushBreadcrumb({
            id: this.id,
            ...breadcrumb
        });
    }
    render() {
        return null;
    }
}
const $904f5413e35195e5$var$Breadcrumb = ({ breadcrumb: breadcrumb, children: children })=>// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aIVNN.BreadcrumbActions), null, (__, actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($904f5413e35195e5$var$BreadcrumbOps, {
            api: actions,
            breadcrumb: breadcrumb
        }), children));
$904f5413e35195e5$var$Breadcrumb.defaultProps = {
    children: null
};
var $904f5413e35195e5$export$2e2bcd8739ae039 = $904f5413e35195e5$var$Breadcrumb;

});
parcelRegister("aIVNN", function(module, exports) {

$parcel$export(module.exports, "useBreadcrumbs", () => $446946e3e8bfa528$export$8cefe241bd876ca0);
$parcel$export(module.exports, "BreadcrumbActions", () => $446946e3e8bfa528$export$9862c338ec0a6884);
$parcel$export(module.exports, "BreadcrumbContainer", () => $446946e3e8bfa528$export$c7432936d9c50db7);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $446946e3e8bfa528$var$initialState = {
    trail: []
};
const $446946e3e8bfa528$export$e324594224ef24da = {
    pushBreadcrumb: (breadcrumb)=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            setState({
                trail: [
                    ...getState().trail,
                    breadcrumb
                ]
            });
        },
    popBreadcrumb: ()=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            setState({
                trail: getState().trail.slice(0, -1)
            });
        },
    updateBreadcrumb: (breadcrumb)=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
            const newTrail = getState().trail.map((item)=>item.id === breadcrumb.id ? breadcrumb : item);
            setState({
                trail: newTrail
            });
        }
};
const $446946e3e8bfa528$var$Store = (0, $iXqE5.createStore)({
    initialState: $446946e3e8bfa528$var$initialState,
    actions: $446946e3e8bfa528$export$e324594224ef24da,
    name: 'BreadcrumbSweetState'
});
const $446946e3e8bfa528$var$_BreadcrumbSubscriber = (0, $51nlc.createSubscriber)($446946e3e8bfa528$var$Store);
const $446946e3e8bfa528$export$8cefe241bd876ca0 = (0, $3sQ5x.createHook)($446946e3e8bfa528$var$Store);
const $446946e3e8bfa528$export$9862c338ec0a6884 = (0, $51nlc.createSubscriber)($446946e3e8bfa528$var$Store, {
    selector: null
});
const $446946e3e8bfa528$export$c7432936d9c50db7 = (0, $gg7kZ.createContainer)($446946e3e8bfa528$var$Store);

});


parcelRegister("btYLD", function(module, exports) {

$parcel$export(module.exports, "default", () => $97548d5fa76ccc5f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");

var $81ps3 = parcelRequire("81ps3");
const $97548d5fa76ccc5f$var$BoardBreadcrumb = ({ children: children, boardId: boardId, boardName: boardName, isSimplifiedProject: isSimplifiedProject, projectId: projectId })=>{
    const breadcrumb = {
        href: (0, $81ps3.createBoardUrl)(boardId),
        text: boardName,
        type: 'boardName',
        analyticsAttributes: {
            nextGenProject: isSimplifiedProject,
            projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
        },
        analyticsFields: {
            name: 'navigateToSubProject',
            containerId: projectId,
            containerType: 'project'
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: breadcrumb
    }, children);
};
$97548d5fa76ccc5f$var$BoardBreadcrumb.defaultProps = {
    children: null,
    isSimplifiedProject: false,
    projectId: undefined
};
var $97548d5fa76ccc5f$export$2e2bcd8739ae039 = $97548d5fa76ccc5f$var$BoardBreadcrumb;

});
parcelRegister("81ps3", function(module, exports) {

$parcel$export(module.exports, "createProjectUrl", () => $e04610b9d6540e69$export$1bdb1f038c5a2a90);
$parcel$export(module.exports, "createProjectSettingsUrl", () => $e04610b9d6540e69$export$c435fcb42a65af32);
$parcel$export(module.exports, "createBoardUrl", () => $e04610b9d6540e69$export$7037e05c8c7af6dc);

var $02Psx = parcelRequire("02Psx");
const $e04610b9d6540e69$export$1bdb1f038c5a2a90 = (projectKey)=>`/browse/${encodeURIComponent(projectKey)}`;
const $e04610b9d6540e69$export$c435fcb42a65af32 = (projectKey, projectType, isSimplified)=>{
    if (isSimplified) return (0, $02Psx.getNextgenSettingsUrl)(projectType, projectKey);
    return `/projects/${projectKey}/settings`;
};
const $e04610b9d6540e69$export$7037e05c8c7af6dc = (boardId)=>`/secure/RapidBoard.jspa?rapidView=${boardId}`;

});


parcelRegister("gEFwt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b024406020849893$export$2e2bcd8739ae039);

var $az4zD = parcelRequire("az4zD");

var $4V6Dv = parcelRequire("4V6Dv");
var $b024406020849893$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)((0, $4V6Dv.default));

});
parcelRegister("4V6Dv", function(module, exports) {

$parcel$export(module.exports, "default", () => $83ca195db24613ad$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");

var $81ps3 = parcelRequire("81ps3");

var $bnbo9 = parcelRequire("bnbo9");
const $83ca195db24613ad$var$ProjectBreadcrumb = ({ isSimplifiedProject: isSimplifiedProject, children: children, projectKey: projectKey, projectName: projectName, projectId: projectId, intl: { formatMessage: formatMessage } })=>{
    const ProjectsBreadcrumb = {
        href: '/jira/projects',
        text: formatMessage((0, $bnbo9.default).projectsTitle),
        type: 'projectsDirectory',
        analyticsAttributes: {
            nextGenProject: isSimplifiedProject,
            projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
        },
        analyticsFields: {
            name: 'navigateToProjectsList'
        }
    };
    if (projectKey != null && projectName != null) {
        const breadcrumb = {
            href: (0, $81ps3.createProjectUrl)(projectKey),
            text: projectName,
            type: 'projectName',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToProject',
                containerId: projectId,
                containerType: 'project'
            }
        };
        const ProjectNameBreadcrumb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
            breadcrumb: breadcrumb
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
            breadcrumb: ProjectsBreadcrumb
        }, ProjectNameBreadcrumb);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: ProjectsBreadcrumb
    }, children);
};
$83ca195db24613ad$var$ProjectBreadcrumb.defaultProps = {
    children: null,
    isSimplifiedProject: false,
    projectId: undefined,
    projectKey: undefined,
    projectName: undefined
};
var $83ca195db24613ad$export$2e2bcd8739ae039 = $83ca195db24613ad$var$ProjectBreadcrumb;

});
parcelRegister("bnbo9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b60cdda05341e39$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1b60cdda05341e39$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project.projects-title",
        "defaultMessage": "Projects"
    }
});

});



parcelRegister("75PvK", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc6b338da4258947$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");
const $fc6b338da4258947$var$UserBreadcrumb = ({ children: children, name: name, profileUrl: profileUrl })=>{
    const breadcrumb = {
        href: profileUrl,
        text: name,
        type: 'userName'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: breadcrumb
    }, children);
};
var $fc6b338da4258947$export$2e2bcd8739ae039 = $fc6b338da4258947$var$UserBreadcrumb;

});

parcelRegister("7OPFF", function(module, exports) {

$parcel$export(module.exports, "default", () => $760c31310830da08$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $760c31310830da08$var$toBreadcrumbData = ({ id: id, index: index, ...legacyCrumb })=>({
        ...legacyCrumb,
        legacyId: id,
        type: 'legacy'
    });
const $760c31310830da08$var$ContextBreadcrumbs = ({ ContextProvider: ContextProvider, ProjectBreadcrumb: ProjectBreadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ContextProvider, null, ({ data: data })=>{
        if (!data) return children;
        const boardBreadcrumb = data.scope ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BoardBreadcrumb, {
            boardId: data.scope.id,
            boardName: data.scope.name || 'Board'
        }, children) : children;
        return data.contextType === 'user' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(UserBreadcrumb, {
            profileUrl: data.user.profileUrl,
            name: data.user.name
        }, boardBreadcrumb) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProjectBreadcrumb, {
            projectKey: data.project.key,
            projectName: data.project.name,
            projectId: data.project.id,
            isSimplifiedProject: data.project.isSimplified
        }, boardBreadcrumb);
    });
const $760c31310830da08$var$LegacyBreadcrumbConnector = ({ legacyTrail: legacyTrail, Breadcrumb: Breadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, ProjectBreadcrumb: ProjectBreadcrumb, ContextProvider: ContextProvider })=>{
    const accumulateBreadcrumb = (accumulatedCrumbs, currentCrumb)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Breadcrumb, {
            breadcrumb: currentCrumb
        }, accumulatedCrumbs);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($760c31310830da08$var$ContextBreadcrumbs, {
        BoardBreadcrumb: BoardBreadcrumb,
        ProjectBreadcrumb: ProjectBreadcrumb,
        UserBreadcrumb: UserBreadcrumb,
        ContextProvider: ContextProvider
    }, legacyTrail.map($760c31310830da08$var$toBreadcrumbData).reverse().reduce(accumulateBreadcrumb, null));
};
var $760c31310830da08$export$2e2bcd8739ae039 = $760c31310830da08$var$LegacyBreadcrumbConnector;

});

parcelRegister("5fGpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc7aa08354ae9ed$export$2e2bcd8739ae039);

var $fr1K2 = parcelRequire("fr1K2");

var $4DPZY = parcelRequire("4DPZY");

var $bmKPg = parcelRequire("bmKPg");
var $ieDtd = parcelRequire("ieDtd");
const $2cc7aa08354ae9ed$export$9f27bc3417b4524d = ({ children: children })=>{
    const [boardId] = (0, $bmKPg.usePathParam)('boardId');
    const [rapidView] = (0, $ieDtd.useQueryParam)('rapidView');
    const [{ data: ctxData, loading: loading, error: error }] = (0, $4DPZY.useContainerContext)();
    /* Don't provide scope data if boardId does not exist in the URL as
	 * we don't want to show the board breadcrumb in this case since it
	 * indicates that we aren't in a scope context even though one may
	 * exist. */ const data = ctxData == null || boardId != null || rapidView != null ? ctxData : (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(ctxData, 'scope');
    // @ts-expect-error - TS2322 - Type 'Pick<ProjectContext | UserContext, "contextType"> | null' is not assignable to type 'ContainerContext | null'. | TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null'.
    return children({
        data: data,
        loading: loading,
        error: error
    });
};
var $2cc7aa08354ae9ed$export$2e2bcd8739ae039 = $2cc7aa08354ae9ed$export$9f27bc3417b4524d;

});


parcelRegister("3XHss", function(module, exports) {

$parcel$export(module.exports, "default", () => $65b3956e27a1612f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $dJl1T = parcelRequire("dJl1T");

var $jS4lj = parcelRequire("jS4lj");
const $65b3956e27a1612f$var$LOCATION = 'breadcrumbs.legacy-adapter.legacy-renderer';
class $65b3956e27a1612f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    componentDidCatch(error) {
        /*
            This error boundary is added to adapt to a runtime error caused by createPortal method in IE 11
        */ const { targetElement: targetElement } = this.props;
        const targetId = targetElement ? targetElement.id : 'not-found';
        (0, $dJl1T.default).safeErrorWithoutCustomerData($65b3956e27a1612f$var$LOCATION, `Failed to createPortal on ${targetId}`, error);
    }
    render() {
        const { targetElement: targetElement } = this.props;
        return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null), targetElement);
    }
}

});
parcelRegister("jS4lj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c6eafb2b612d104$export$2e2bcd8739ae039);

var $1bJTy = parcelRequire("1bJTy");

var $9sGI6 = parcelRequire("9sGI6");

var $9OXo1 = parcelRequire("9OXo1");

var $0SW74 = parcelRequire("0SW74");
const $8c6eafb2b612d104$var$fireAnalytics = (analyticsEvent)=>(0, $1bJTy.fireOperationalAnalytics)(analyticsEvent, {
        name: 'breadcrumbRendererMounted'
    });
var $8c6eafb2b612d104$export$2e2bcd8739ae039 = (0, $9sGI6.default)((0, $0SW74.default), {
    onMount: $8c6eafb2b612d104$var$fireAnalytics,
    TenantContextSubscriber: $9OXo1.TenantContextSubscriber
});

});
parcelRegister("0SW74", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa2b8169c8c69f79$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8oe80 = parcelRequire("8oe80");

var $6lcpk = parcelRequire("6lcpk");

var $aIVNN = parcelRequire("aIVNN");
// Adapt to prop type from breadcrumbs app
const $fa2b8169c8c69f79$var$mapTrailToBreadcrumbItems = (trail)=>trail.map((crumb)=>({
            ...crumb,
            target: crumb.target || '_self'
        }));
const $fa2b8169c8c69f79$var$BreadcrumbRenderer = ({ onMount: onMount })=>{
    const [{ trail: trail }] = (0, $aIVNN.useBreadcrumbs)();
    const items = (0, $5uXOq.useMemo)(()=>$fa2b8169c8c69f79$var$mapTrailToBreadcrumbItems(trail), [
        trail
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(onMount, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1tke1tcg"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lcpk.default), {
        isVisible: true,
        items: items
    }));
};
var $fa2b8169c8c69f79$export$2e2bcd8739ae039 = (0, $8oe80.default)('breadcrumbsRenderer', {
    onMount: 'mounted'
})($fa2b8169c8c69f79$var$BreadcrumbRenderer);
const $fa2b8169c8c69f79$var$breadcrumbsWrapperStyles = null;

});
parcelRegister("6lcpk", function(module, exports) {

$parcel$export(module.exports, "default", () => $741d99934750459a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jD5no = parcelRequire("jD5no");

var $j6iTu = parcelRequire("j6iTu");
function $741d99934750459a$export$2e2bcd8739ae039(props) {
    const { isVisible: isVisible, items: items } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j6iTu.default), {
        isVisible: isVisible,
        items: items
    }));
}

});
parcelRegister("j6iTu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5be1ac78992edda2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $8Rkzz = parcelRequire("8Rkzz");

var $gpo4s = parcelRequire("gpo4s");
var $8LGam = parcelRequire("8LGam");

var $koVbs = parcelRequire("koVbs");

var $hjSul = parcelRequire("hjSul");

var $92r9l = parcelRequire("92r9l");

var $2UzOj = parcelRequire("2UzOj");
const $5be1ac78992edda2$export$67abef37aa2929b0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
        ...props,
        ref: ref,
        type: "a"
    }));
function $5be1ac78992edda2$export$2e2bcd8739ae039(props) {
    const { isVisible: isVisible, items: items } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const totalItems = items.length;
    return isVisible ? // onExpand is required prop in atlaskit's breadcrumbitem component
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8LGam.default), {
        onExpand: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }, (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(items) ? // This is needed in order to render an empty breadcrumb for SSR, to avoid visual jumping when javascript kicks in.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gpo4s.default), {
        text: "",
        "aria-label": formatMessage((0, $2UzOj.default).breadcrumbsLabel)
    }) : items.map((breadcrumb, index)=>{
        const breadcrumbItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92r9l.default), {
            key: index,
            index: index,
            ariaCurrent: index + 1 === totalItems ? 'page' : undefined,
            hasSeparator: true,
            text: breadcrumb.text,
            target: __SPA__ ? undefined : breadcrumb.target,
            href: breadcrumb.href,
            component: __SPA__ ? $5be1ac78992edda2$export$67abef37aa2929b0 : undefined,
            legacyId: breadcrumb.legacyId,
            type: breadcrumb.type,
            analyticsAttributes: breadcrumb.analyticsAttributes,
            analyticsFields: breadcrumb.analyticsFields
        });
        return breadcrumbItem;
    }))) : null;
}

});
parcelRegister("gpo4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $697de2828561ef20$export$2e2bcd8739ae039);
/* breadcrumbs-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5KCCi = parcelRequire("5KCCi");

var $8Fpav = parcelRequire("8Fpav");

var $kSNMF = parcelRequire("kSNMF");
const $697de2828561ef20$var$itemWrapperStyles = null;
const $697de2828561ef20$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $697de2828561ef20$var$ICON_WIDTH_ESTIMATE = 24;
const $697de2828561ef20$var$staticItemStyles = null;
const $697de2828561ef20$var$staticItemWithTruncationStyles = null;
const $697de2828561ef20$var$staticItemWithoutTruncationStyles = null;
const $697de2828561ef20$var$BreadcrumbsItem = /*#__PURE__*/ (0, $5uXOq.memo)(({ analyticsContext: analyticsContext, component: component, href: // `createAnalyticsEvent` should be here, but throws errors on render since
// it ends up being spread on a DOM element at the very end
href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, ref: // This is overridden by the `buttonRef` below
ref, target: target, testId: testId, text: text, truncationWidth: truncationWidth, // I believe there is only `createAnalyticsEvent` left on here, but leaving
// it here to allow this to be a patch and not a major
...rest })=>{
    const buttonRef = (0, $5uXOq.useRef)(null);
    // If icons are provided we include their width in the truncation calculation to ensure we're as accurate as possible.
    // Note: this assumes icons are 24px wide which should be almost always.
    // Not really an issue if the icons are smaller, just that truncation occurs slightly earlier than you may want.
    let iconWidthAllowance = 0;
    if (iconBefore) iconWidthAllowance += $697de2828561ef20$var$ICON_WIDTH_ESTIMATE;
    if (iconAfter) iconWidthAllowance += $697de2828561ef20$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, showTooltip] = (0, $kSNMF.default)(truncationWidth, buttonRef.current, iconWidthAllowance);
    // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$697de2828561ef20$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Fpav.default), {
        ...rest,
        analyticsContext: analyticsContext,
        component: component,
        hasOverflow: hasOverflow,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        ref: buttonRef,
        target: target,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: truncationWidth ? dynamicItemStyles : undefined,
        className: (0, $bwpsq.default)([
            "_1rjc1tvq _k48p1hhk _vwz41txs",
            truncationWidth ? "_p12f8zc4" : "_1ul9grf3 _1o9zzg3v"
        ]),
        children: text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _ect41gqc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsoftgi _toskidpf _15621n76 _191d1h6o"
        ]),
        children: showTooltip ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: step
        }) : step
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$697de2828561ef20$export$2e2bcd8739ae039 = $697de2828561ef20$var$BreadcrumbsItem;

});
parcelRegister("8Fpav", function(module, exports) {

$parcel$export(module.exports, "default", () => $f75f791f622b08ac$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $cNW3X = parcelRequire("cNW3X");

var $bKnKN = parcelRequire("bKnKN");
const $f75f791f622b08ac$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $f75f791f622b08ac$var$noop = (0, $bKnKN.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $f75f791f622b08ac$var$Step = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $f75f791f622b08ac$var$noop, target: target, testId: testId, // Button does not take `createAnalyticsEvent`, but it is spread on anyway
...props }, ref)=>{
    const handleClicked = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$f75f791f622b08ac$var$analyticsAttributes
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
        ...props,
        appearance: "subtle-link",
        component: component,
        href: href,
        iconAfter: hasOverflow ? undefined : iconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        spacing: "none",
        target: target,
        testId: testId
    });
});
var $f75f791f622b08ac$export$2e2bcd8739ae039 = $f75f791f622b08ac$var$Step;

});

parcelRegister("kSNMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a2acfd7bafb31a5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");
function $2a2acfd7bafb31a5$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $5uXOq.useState)((0, $fHpHg.fg)('platform_fix_unnessesary_re-renders_in_breadcrumbs') ? Boolean(shouldCheckWidth) : true);
    const [showTooltip, setShowTooltip] = (0, $5uXOq.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $5uXOq.useEffect)(()=>{
        if (shouldCheckWidth) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance,
        shouldCheckWidth
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}

});


parcelRegister("8LGam", function(module, exports) {

$parcel$export(module.exports, "default", () => $981af12032308ae8$export$2e2bcd8739ae039);
/* breadcrumbs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $cD7p8 = parcelRequire("cD7p8");

var $bKnKN = parcelRequire("bKnKN");

var $6PY2d = parcelRequire("6PY2d");

var $39LvI = parcelRequire("39LvI");
const $981af12032308ae8$var$defaultMaxItems = 8;
const $981af12032308ae8$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $981af12032308ae8$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $981af12032308ae8$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children;
const $981af12032308ae8$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $981af12032308ae8$var$noop = (0, $bKnKN.default);
const $981af12032308ae8$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $981af12032308ae8$var$breadcrumbStyles = null;
const $981af12032308ae8$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $981af12032308ae8$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $981af12032308ae8$var$noop, analyticsContext: analyticsContext, label: label = $981af12032308ae8$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $981af12032308ae8$var$defaultEllipsisLabel } = props;
    const [expanded, setExpanse] = (0, $5uXOq.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $5uXOq.useState)(false);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $981af12032308ae8$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealed = ()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($981af12032308ae8$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    };
    (0, $39LvI.useOnRevealed)(focusFirstRevealed, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$981af12032308ae8$var$analyticsAttributes
    });
    const childrenArray = $981af12032308ae8$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(childrenArray, (child, index)=>{
        //To avoid error if child is a string
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray; // This defends against someone passing weird data, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6PY2d.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("nav", {
        "aria-label": label,
        ref: (0, $cD7p8.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("ol", {
            "data-testid": testId,
            className: (0, $bwpsq.default)([
                "_1e0c1txw _1n261g80 _syaz1wmz _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
            ]),
            children: breadcrumbsItems
        })
    });
});
const $981af12032308ae8$var$Breadcrumbs = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)($981af12032308ae8$var$InnerBreadcrumbs, {
        ...props,
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        ref: ref,
        testId: testId
    }))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $981af12032308ae8$export$2e2bcd8739ae039 = $981af12032308ae8$var$Breadcrumbs;

});
parcelRegister("6PY2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $f23df4b96913494f$export$2e2bcd8739ae039);
/* ellipsis-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $bKnKN = parcelRequire("bKnKN");
const $f23df4b96913494f$var$noop = (0, $bKnKN.default);
const $f23df4b96913494f$var$itemWrapperStyles = null;
const $f23df4b96913494f$var$staticItemStyles = null;
const $f23df4b96913494f$var$EllipsisItem = /*#__PURE__*/ (0, $5uXOq.memo)(({ label: label, onClick: onClick = $f23df4b96913494f$var$noop, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("li", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _15621n76 _191d1h6o"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
            appearance: "subtle-link",
            "aria-label": label,
            onClick: onClick,
            spacing: "none",
            testId: testId,
            className: (0, $bwpsq.default)([
                "_1rjc1tvq _k48p1hhk _vwz41txs"
            ]),
            children: "\u2026"
        })
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f23df4b96913494f$export$2e2bcd8739ae039 = $f23df4b96913494f$var$EllipsisItem;

});

parcelRegister("39LvI", function(module, exports) {

$parcel$export(module.exports, "useOnRevealed", () => $bac20d79b2a0e586$export$e9c4922b2ecf808a);

var $5uXOq = parcelRequire("5uXOq");

var $jOvxk = parcelRequire("jOvxk");
function $bac20d79b2a0e586$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $jOvxk.default)(isExpanded);
    (0, $5uXOq.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}

});


parcelRegister("92r9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $77e0cddbf99d95bf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gpo4s = parcelRequire("gpo4s");

var $dOvpK = parcelRequire("dOvpK");
class $77e0cddbf99d95bf$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            href: undefined,
            legacyId: undefined,
            type: 'unspecified',
            analyticsAttributes: {},
            analyticsFields: {},
            ariaCurrent: undefined
        };
    }
    render() {
        const { index: index, text: text, target: target, href: href, component: component, ariaCurrent: ariaCurrent } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gpo4s.default), {
            key: index,
            text: text,
            // @ts-expect-error - TS2322 - Type '(event: Event, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type '(event: MouseEvent<Element, MouseEvent>) => void'.
            onClick: this.onBreadCrumbClick,
            target: target,
            href: href,
            component: component,
            "aria-current": ariaCurrent
        });
    }
    constructor(...args){
        super(...args), this.onBreadCrumbClick = (event, analyticsEvent)=>{
            const { legacyId: legacyId, index: index, type: type, analyticsAttributes: analyticsAttributes, analyticsFields: analyticsFields } = this.props;
            (0, $dOvpK.fireUiAnalytics)(analyticsEvent, {
                name: '',
                attributes: {
                    legacyId: legacyId,
                    // change this depth value to be zero based, once Jira home crumb is added
                    depth: index + 1,
                    type: type,
                    ...analyticsAttributes
                },
                ...analyticsFields
            });
        };
    }
}

});
parcelRegister("dOvpK", function(module, exports) {

$parcel$export(module.exports, "fireUiAnalytics", () => $8c2abcc805e894f7$export$4909253b5bf1eed7);

var $4f8Oj = parcelRequire("4f8Oj");

var $gvRPW = parcelRequire("gvRPW");

var $i4iBk = parcelRequire("i4iBk");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $8c2abcc805e894f7$var$isNotUndefined = (a)=>a !== undefined;
const $8c2abcc805e894f7$var$mapPayload = (payload)=>{
    const context = (0, $i4iBk.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $8c2abcc805e894f7$var$isNotUndefined);
};
const $8c2abcc805e894f7$export$4909253b5bf1eed7 = (event, payload)=>{
    event.update({
        ...$8c2abcc805e894f7$var$mapPayload(payload),
        analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
    }).fire();
};

});


parcelRegister("2UzOj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e3ad53695e8cbba$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8e3ad53695e8cbba$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    breadcrumbsLabel: {
        "id": "navigation-apps.breadcrumbs.aria-label",
        "defaultMessage": "Empty Breadcrumbs item"
    }
});

});






parcelRegister("1DFxi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3b01c7b039743c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $9b3b01c7b039743c$var$compareBreadcrumbs = (a, b)=>a.index - b.index;
const $9b3b01c7b039743c$var$defaultInitialState = {
    trail: [],
    targetElement: null
};
class $9b3b01c7b039743c$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            initialState: $9b3b01c7b039743c$var$defaultInitialState
        };
    }
    constructor(props){
        super(props), this.onInsertItem = (item)=>{
            this.setState((state)=>({
                    trail: [
                        ...state.trail,
                        item
                    ].sort($9b3b01c7b039743c$var$compareBreadcrumbs)
                }));
        }, this.onRemoveItem = (id)=>{
            this.setState((state)=>({
                    trail: state.trail.filter((b)=>b.id !== id)
                }));
        }, /* eslint-disable react/no-unused-state */ this.onTargetSet = (targetElement)=>{
            this.setState({
                targetElement: targetElement
            });
        }, /* eslint-enable react/no-unused-state */ this.api = {
            setTargetElement: this.onTargetSet,
            insertItem: this.onInsertItem,
            removeItem: this.onRemoveItem
        };
        this.state = props.initialState;
    }
    render() {
        const { children: children } = this.props;
        return children({
            state: this.state,
            api: this.api
        });
    }
}

});



parcelRegister("lDu2T", function(module, exports) {

$parcel$export(module.exports, "LoadingPhaseManager", () => $c284a07391432f3b$export$6e4bfef9e80c7eb0);

var $5uXOq = parcelRequire("5uXOq");

var $lsa9q = parcelRequire("lsa9q");

var $8vgoa = parcelRequire("8vgoa");

var $6s1PB = parcelRequire("6s1PB");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c284a07391432f3b$export$6e4bfef9e80c7eb0 = ()=>{
    const [{ hasLoaded: hasLoaded }] = (0, $lsa9q.default)();
    const { resetPhase: resetPhase, startNextPhase: startNextPhase } = (0, $8vgoa.useLazyPhase)();
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $6s1PB.expValEquals)('rll_after_paint_phase_on_page_load', 'cohort', 'experiment')) {
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        } else if (hasLoaded) {
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        } else resetPhase();
    }, [
        hasLoaded,
        resetPhase,
        startNextPhase
    ]);
    return null;
};

});

parcelRegister("jnXgM", function(module, exports) {

$parcel$export(module.exports, "TrackClicksBeforeTTI", () => $0e1519f86dabd57c$export$2846c12b8c092470);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $6yXtV = parcelRequire("6yXtV");

var $eNf8a = parcelRequire("eNf8a");

var $4R6GH = parcelRequire("4R6GH");
const $0e1519f86dabd57c$var$cleanUrl = (pathname)=>{
    let url = pathname.replace(/\/$/, '');
    // /browse redirects or sw classic redirects
    if (/\/browse\/\w+$/.test(url)) url = 'browse';
    // replaces any occurrence of two or more capital letters,
    // or one capital letter followed by a number and also
    // two or more capital letters followed by a dash and any amount of numbers
    // (should catch all project and issue keys)
    if (/[A-Z][A-Z0-9]+(-[\d]+)*/g.test(url)) url = url.replace(/[A-Z][A-Z0-9]+(-[\d]+)*/g, 'XX');
    return url;
};
// TODO: JFP-2249 Please add the prefix for storage provider here
const $0e1519f86dabd57c$var$sessionStorageProvider = (0, $eNf8a.createSessionStorageProvider)('');
/**
 * Handles the collection and processing of user interactions that occur before the page becomes fully interactive. This enhances the understanding of user behavior during the initial loading phase.
 */ const $0e1519f86dabd57c$export$2846c12b8c092470 = ()=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isReady) return;
        try {
            const sessionStorageItems = (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $0e1519f86dabd57c$var$sessionStorageProvider.get('clicks-before-tti') : sessionStorage.getItem('clicks-before-tti');
            if (sessionStorageItems == null || sessionStorageItems === '') return;
            const items = JSON.parse(sessionStorageItems);
            items.forEach((item)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                let extras = {
                    elementId: item.dataId,
                    currentUrl: $0e1519f86dabd57c$var$cleanUrl(item.currentUrl),
                    bundleId: item.bundleId,
                    time: item.time
                };
                if (item.redirectUrl !== '') extras = {
                    ...extras,
                    redirectUrl: $0e1519f86dabd57c$var$cleanUrl(item.redirectUrl)
                };
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                    action: 'clicked'
                }), 'nonInteractiveElement clicked', '', extras);
            });
            (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $0e1519f86dabd57c$var$sessionStorageProvider.remove('clicks-before-tti') : sessionStorage.removeItem('clicks-before-tti');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }, [
        createAnalyticsEvent,
        isReady
    ]);
    return null;
};

});

parcelRegister("is3OJ", function(module, exports) {

$parcel$export(module.exports, "Integrations", () => $34fdc156b16a8047$export$99d02219d259eb94);

var $5uXOq = parcelRequire("5uXOq");

var $aDtmv = parcelRequire("aDtmv");

var $hJqhj = parcelRequire("hJqhj");

var $8jZFG = parcelRequire("8jZFG");

var $1oIjm = parcelRequire("1oIjm");
const $34fdc156b16a8047$export$99d02219d259eb94 = ()=>{
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8jZFG.KeyboardShortcuts), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJqhj.IssueViewModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1oIjm.Projects), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aDtmv.Dashboards), null));
    return null;
};

});
parcelRegister("aDtmv", function(module, exports) {

$parcel$export(module.exports, "Dashboards", () => $34586a0fe61ff38f$export$dd47e695f88fad71);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $jgE05 = parcelRequire("jgE05");

var $6jY6G = parcelRequire("6jY6G");

var $e9QkH = parcelRequire("e9QkH");

var $cZpsT = parcelRequire("cZpsT");

var $9VXkC = parcelRequire("9VXkC");
var $lVJAU = parcelRequire("lVJAU");

var $Mp6qH = parcelRequire("Mp6qH");
const $34586a0fe61ff38f$var$styles = (0, $2s57o.xcss)({
    position: 'absolute'
});
const $34586a0fe61ff38f$export$dd47e695f88fad71 = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const [isOpen, { off: modalClose }] = (0, $e9QkH.useSwitchModals)((0, $Mp6qH.MODAL_ID).DASHBOARD_CREATE);
    const { path: path } = (0, $6jY6G.useRouteByName)('dashboard-edit') ?? {};
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const onSuccess = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7031 - Binding element 'id' implicitly has an 'any' type.
    (_, { id: id })=>{
        path && push((0, $9VXkC.generatePath)(path, {
            dashboardId: id
        }));
        modalClose();
    }, [
        modalClose,
        path,
        push
    ]);
    if (isAnonymous) return null;
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $34586a0fe61ff38f$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgE05.default), {
        onSuccess: onSuccess,
        onCancel: modalClose
    })) : null;
};

});

parcelRegister("hJqhj", function(module, exports) {

$parcel$export(module.exports, "IssueViewModal", () => $7d5d4e113f958543$export$e6a284da53c503a6);

var $5uXOq = parcelRequire("5uXOq");

var $gjEtj = parcelRequire("gjEtj");

var $ecB7Y = parcelRequire("ecB7Y");

var $lfTZh = parcelRequire("lfTZh");

var $g5X3G = parcelRequire("g5X3G");

var $b7Svb = parcelRequire("b7Svb");

const $7d5d4e113f958543$export$b61e79ae300e872f = (0, $b7Svb.lazy)(()=>(parcelRequire("6TobW")), {
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
});
const $7d5d4e113f958543$export$e6a284da53c503a6 = ()=>{
    const [{ isModalOpen: isModalOpen, issueKey: issueKey, onClose: onClose, packageName: packageName, analyticsSource: analyticsSource }] = (0, $ecB7Y.useTriggerIssueViewModal)();
    return isModalOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        packageName: packageName,
        id: "issue-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "modal-issue-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7d5d4e113f958543$export$b61e79ae300e872f, {
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'AnalyticsSource'.
        analyticsSource: analyticsSource,
        issueKey: (0, $g5X3G.toIssueKey)(issueKey),
        onClose: onClose
    }))) : null;
};

});
parcelRegister("gjEtj", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $c322f875acea1654$export$c3f500e812fb1bb3);

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");

var $i2Rm5 = parcelRequire("i2Rm5");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");
const $c322f875acea1654$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $5uXOq.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});

parcelRegister("ecB7Y", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueViewModal", () => $164e67a198897250$export$fb8fdfbeb70f910c);

var $8Rkzz = parcelRequire("8Rkzz");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $164e67a198897250$export$d4c72bab9d6cc13a = {
    isModalOpen: false,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    issueKey: '',
    packageName: '',
    analyticsSource: '',
    issueCreateSessionId: undefined
};
const $164e67a198897250$export$e324594224ef24da = {
    openIssueViewModal: (nextState)=>({ setState: setState })=>{
            setState({
                ...$164e67a198897250$export$d4c72bab9d6cc13a,
                ...nextState,
                isModalOpen: true
            });
        },
    closeIssueViewModal: ()=>({ setState: setState })=>{
            setState({
                ...$164e67a198897250$export$d4c72bab9d6cc13a,
                isModalOpen: false
            });
        },
    setIssueCreateSessionId: (issueCreateSessionId)=>({ setState: setState })=>{
            setState({
                issueCreateSessionId: issueCreateSessionId
            });
        }
};
const $164e67a198897250$var$store = (0, $iXqE5.createStore)({
    name: 'issue-view.controllers.open-issue-view-modal',
    initialState: $164e67a198897250$export$d4c72bab9d6cc13a,
    actions: $164e67a198897250$export$e324594224ef24da
});
const $164e67a198897250$export$fb8fdfbeb70f910c = (0, $3sQ5x.createHook)($164e67a198897250$var$store);

});


parcelRegister("8jZFG", function(module, exports) {

$parcel$export(module.exports, "KeyboardShortcuts", () => $5e97b0340433365d$export$5176144edf2bef2b);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $7kxNZ = parcelRequire("7kxNZ");

var $jp0tf = parcelRequire("jp0tf");


var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $6BNJk = parcelRequire("6BNJk");

var $3tKCZ = parcelRequire("3tKCZ");

var $hsmeR = parcelRequire("hsmeR");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $hULKg = parcelRequire("hULKg");

var $5rzqz = parcelRequire("5rzqz");

var $lfTZh = parcelRequire("lfTZh");

var $f5nIZ = parcelRequire("f5nIZ");

var $2YP9W = parcelRequire("2YP9W");
// Retaining the old name to avoid breaking any dashboards that may break due to this refactor
const $5e97b0340433365d$var$PACKAGE_NAME = '@atlassian/jira-atlassian-navigation';
const $5e97b0340433365d$export$5176144edf2bef2b = ()=>{
    const [, { on: on }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).SEARCH);
    const [, { off: closeAllMenus }] = (0, $2Ui4E.useTopMenus)();
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const rightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const [{ isInitialLoad: isInitialLoad }, actions] = (0, $7kxNZ.useIsInitialLoadLegacyIssueCreate)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const isInitialLoadRef = (0, $5uXOq.useRef)(false);
    isInitialLoadRef.current = isInitialLoad;
    const openSearch = (0, $5uXOq.useCallback)(()=>requestAnimationFrame(()=>{
            on();
        }), [
        on
    ]);
    let currentIssueCreateVisibility = null;
    if ((0, $4R6GH.fg)('render_modern_global_issue_create_modal_experience')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: data } = (0, $2YP9W.useResource)((0, $f5nIZ.gicOptInStatusResources));
        currentIssueCreateVisibility = data && data?.gicOptInStatus;
    }
    const openIssueCreate = (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('render_modern_global_issue_create_modal_experience')) {
            if (currentIssueCreateVisibility !== null) {
                if (currentIssueCreateVisibility.isEnabled) openIssueCreateModal({
                    triggerPointKey: (0, $hULKg.GENERIC_KEYBOARD_SHORTCUT)
                });
                else {
                    (0, $jp0tf.default)({
                        isInitialLoad: isInitialLoadRef.current,
                        triggerSource: (0, $de7681b8672bb382$export$7e22286cafe320a7)
                    });
                    if (isInitialLoadRef.current) actions.clearInitialLoaded();
                }
            } else (0, $dJl1T.default).safeErrorWithoutCustomerData('global-issue-create', 'visibility data is still getting downloaded');
        } else {
            (0, $jp0tf.default)({
                isInitialLoad: isInitialLoadRef.current,
                triggerSource: (0, $de7681b8672bb382$export$7e22286cafe320a7)
            });
            if (isInitialLoadRef.current) actions.clearInitialLoaded();
        }
    }, [
        actions,
        currentIssueCreateVisibility,
        openIssueCreateModal
    ]);
    const toggleHelpPanel = (0, $5uXOq.useCallback)(()=>{
        closeAllMenus();
        if (!rightSidebarState?.isCollapsed && rightSidebarState?.panelId === (0, $6BNJk.HELP_PANEL_ID)) closeCurrentRightSidebar();
        else openRightSidebar((0, $6BNJk.HELP_PANEL_ID), (0, $6BNJk.HELP_PANEL_WIDTH));
    }, [
        closeAllMenus,
        closeCurrentRightSidebar,
        openRightSidebar,
        rightSidebarState?.isCollapsed,
        rightSidebarState?.panelId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "integrations.keyboard-shortcuts",
        packageName: $5e97b0340433365d$var$PACKAGE_NAME,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy-shortcuts",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3tKCZ.KeyboardShortcuts), {
        showIssueCreate: openIssueCreate,
        showSearch: openSearch,
        toggleHelpPanel: toggleHelpPanel,
        shouldUseHelpShortcut: true
    })));
};

});
parcelRegister("7kxNZ", function(module, exports) {

$parcel$export(module.exports, "useIsInitialLoadLegacyIssueCreate", () => $c1839ac195702930$export$8a73e89ffc4b9342);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $c1839ac195702930$var$initialState = {
    isInitialLoad: true
};
const $c1839ac195702930$export$e324594224ef24da = {
    clearInitialLoaded: ()=>({ setState: setState, getState: getState })=>{
            if (getState().isInitialLoad) setState({
                isInitialLoad: false
            });
        }
};
const $c1839ac195702930$var$store = (0, $iXqE5.createStore)({
    name: 'is-initial-load-create-issue-legacy',
    initialState: $c1839ac195702930$var$initialState,
    actions: $c1839ac195702930$export$e324594224ef24da
});
const $c1839ac195702930$export$8a73e89ffc4b9342 = (0, $3sQ5x.createHook)($c1839ac195702930$var$store);

});

parcelRegister("jp0tf", function(module, exports) {

$parcel$export(module.exports, "default", () => $16da541e59a26adc$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");

var $4R6GH = parcelRequire("4R6GH");

var $iKCxj = parcelRequire("iKCxj");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$16da541e59a26adc$export$2e2bcd8739ae039 = ({ timeout: timeout, tentatives: tentatives, isInitialLoad: // isInitialLoad tracks the initial render of global issue create dialog through this entry point (presently called from navigation create button and keyboard shortcut)
isInitialLoad, triggerSource: triggerSource, showModern: showModern } = {})=>{
    (0, $iKCxj.sendStartMarkForLegacyIssueCreate)({
        isInitialLoad: isInitialLoad,
        triggerSource: triggerSource
    });
    // eslint-disable-next-line jira/wrm/no-load-bridge
    return (0, $6BZYo.loadBridge)({
        name: 'quick-edit/init/create-dialogs',
        wrmKeys: [
            'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue-bootstrap',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs'
        ],
        timeout: timeout,
        tentatives: tentatives
    }).then((api)=>{
        if ((0, $4R6GH.fg)('render_modern_global_issue_create_modal_experience')) {
            if (showModern === true) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api.hideLoadingIndicator(false);
            else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api.showCreateDialog({
                showModern: showModern
            });
        } else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        api.showCreateDialog({});
        (0, $iKCxj.sendEndMarkForLegacyIssueCreate)({
            isInitialLoad: isInitialLoad
        });
    });
};

});
parcelRegister("iKCxj", function(module, exports) {

$parcel$export(module.exports, "sendStartMarkForLegacyIssueCreate", () => $d3fc7ef6ccbf5390$export$7dbcbf47a4e0e00f);
$parcel$export(module.exports, "sendEndMarkForLegacyIssueCreate", () => $d3fc7ef6ccbf5390$export$b5c5d408bb7fd104);

var $dvqhI = parcelRequire("dvqhI");

var $ccNll = parcelRequire("ccNll");
const $d3fc7ef6ccbf5390$export$7dbcbf47a4e0e00f = ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    if (typeof isInitialLoad === 'boolean' && triggerSource !== undefined) {
        if (isInitialLoad) (0, $ccNll.legacyIssueCreateInitialRenderInteraction).start();
        else (0, $ccNll.legacyIssueCreateTransitionInteraction).start();
        (0, $ccNll.legacyIssueCreateCombinedInteraction).start();
    }
};
const $d3fc7ef6ccbf5390$export$b5c5d408bb7fd104 = async ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    const Events = await (0, $dvqhI.apiReady)();
    const onCreateIssueDialogRendered = ()=>{
        if (typeof isInitialLoad === 'boolean') {
            if (isInitialLoad) (0, $ccNll.legacyIssueCreateInitialRenderInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            else (0, $ccNll.legacyIssueCreateTransitionInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            (0, $ccNll.legacyIssueCreateCombinedInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
        }
        Events.unbind('createIssueDialogRendered', onCreateIssueDialogRendered);
    };
    Events.bind('createIssueDialogRendered', onCreateIssueDialogRendered);
};

});
parcelRegister("dvqhI", function(module, exports) {

$parcel$export(module.exports, "apiReady", () => $548c078b9ef136c5$export$330fb1a04c974aad);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
let $548c078b9ef136c5$var$currentBridge;
const $548c078b9ef136c5$export$330fb1a04c974aad = async ()=>{
    if ($548c078b9ef136c5$var$currentBridge) return $548c078b9ef136c5$var$currentBridge;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/wrm/no-load-bridge
    const Events = await (0, $6BZYo.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    });
    $548c078b9ef136c5$var$currentBridge = Events;
    return Events;
};

});

parcelRegister("ccNll", function(module, exports) {

$parcel$export(module.exports, "legacyIssueCreateInitialRenderInteraction", () => $d1196bb7209b7b8b$export$2bc24132dfd54487);
$parcel$export(module.exports, "legacyIssueCreateTransitionInteraction", () => $d1196bb7209b7b8b$export$ba0054dee3105c90);
$parcel$export(module.exports, "legacyIssueCreateCombinedInteraction", () => $d1196bb7209b7b8b$export$52353a8848646ccd);

var $2nKjG = parcelRequire("2nKjG");
const $d1196bb7209b7b8b$export$2bc24132dfd54487 = (0, $2nKjG.metrics).interaction({
    key: 'legacy-issue-create.initial-render'
});
const $d1196bb7209b7b8b$export$ba0054dee3105c90 = (0, $2nKjG.metrics).interaction({
    key: 'legacy-issue-create.transition'
});
const $d1196bb7209b7b8b$export$52353a8848646ccd = (0, $2nKjG.metrics).interaction({
    key: 'legacy-issue-create.combined'
});

});



const $de7681b8672bb382$export$d983e94cf86f65d = 'global-create-button';
const $de7681b8672bb382$export$7e22286cafe320a7 = 'keyboard-shortcut';

parcelRegister("3tKCZ", function(module, exports) {

$parcel$export(module.exports, "KeyboardShortcuts", () => $fcab74eed8b53dd6$export$5176144edf2bef2b);

var $b7Svb = parcelRequire("b7Svb");

const $fcab74eed8b53dd6$export$5176144edf2bef2b = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("6b3uB")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/keyboard-shortcuts/src/view/index.tsx"
});

});
parcelRegister("6b3uB", function(module, exports) {

let $47f67ab98a8a8df6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $47f67ab98a8a8df6$var$load("h2MrD"),
    $47f67ab98a8a8df6$var$load("bYT2S"),
    $47f67ab98a8a8df6$var$load("6OtWH")
]).then(()=>parcelRequire('d6vlx'));

});


parcelRegister("2Ui4E", function(module, exports) {

$parcel$export(module.exports, "useTopMenus", () => $77ef209ff15299e4$export$6591d6b6c4546423);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");

var $2qauD = parcelRequire("2qauD");
const { SwitchContainer: $77ef209ff15299e4$var$SwitchContainer, useSwitch: $77ef209ff15299e4$var$useSwitch } = (0, $2qauD.createSwitchController)('atlassian-navigation-top-menus');
const $77ef209ff15299e4$export$45ccf7b2695bac19 = $77ef209ff15299e4$var$SwitchContainer;
const $77ef209ff15299e4$var$useTopMenusBase = $77ef209ff15299e4$var$useSwitch;
const $77ef209ff15299e4$export$6591d6b6c4546423 = (props)=>{
    const switcher = $77ef209ff15299e4$var$useTopMenusBase(props);
    const [{ isOpen: isCommandPaletteOpen }] = (0, $d8lE2.useCommandPaletteIsOpen)();
    const [isSwitchOpen, { off: off }] = switcher;
    (0, $5uXOq.useEffect)(()=>{
        if (isSwitchOpen && isCommandPaletteOpen) off();
    }, [
        isCommandPaletteOpen,
        isSwitchOpen,
        off
    ]);
    return switcher;
};

});

parcelRegister("hULKg", function(module, exports) {

$parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", () => $62659eb193cd5c9c$export$a05673a22505d5ee);
$parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", () => $62659eb193cd5c9c$export$c78d329777576aa0);
$parcel$export(module.exports, "MOBILE_GLOBAL_CREATE_BUTTON", () => $62659eb193cd5c9c$export$992ab052fd10f8e8);
$parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", () => $62659eb193cd5c9c$export$affdc3af7a9a4677);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", () => $62659eb193cd5c9c$export$7e9cfd1f59e60910);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", () => $62659eb193cd5c9c$export$708499dcd016e5e9);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", () => $62659eb193cd5c9c$export$e1c8789144c4c810);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", () => $62659eb193cd5c9c$export$c5afabb7a17e802);
$parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", () => $62659eb193cd5c9c$export$2086a63173b79b56);
$parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", () => $62659eb193cd5c9c$export$fe1e5e4597147709);
$parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", () => $62659eb193cd5c9c$export$9bc326812a93707);
$parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", () => $62659eb193cd5c9c$export$f352934e06f44599);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", () => $62659eb193cd5c9c$export$6ae07c77acc64360);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", () => $62659eb193cd5c9c$export$b41d0684e4b6ab1);
$parcel$export(module.exports, "JSM_CREATE_PROBLEM_FROM_INCIDENT_AI", () => $62659eb193cd5c9c$export$1110454816343634);
$parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", () => $62659eb193cd5c9c$export$be9b2b1329ff7ec9);
$parcel$export(module.exports, "JSM_PROJECT_SUMMARY_CREATE_REQUEST", () => $62659eb193cd5c9c$export$bc365eb0775af583);
$parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", () => $62659eb193cd5c9c$export$aa348159181703a0);
$parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", () => $62659eb193cd5c9c$export$f90eec3841adf619);
$parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", () => $62659eb193cd5c9c$export$718822a309bffada);
$parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", () => $62659eb193cd5c9c$export$2753dafac81e805c);
$parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", () => $62659eb193cd5c9c$export$7c4d5cc5711d9294);
$parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", () => $62659eb193cd5c9c$export$998dfc72404b9e14);
$parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", () => $62659eb193cd5c9c$export$fc180a4b5785d2f4);
$parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", () => $62659eb193cd5c9c$export$946ec0b21cb84fd0);
$parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", () => $62659eb193cd5c9c$export$5b97e2844e620e54);
$parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", () => $62659eb193cd5c9c$export$b99842c2cf46f6be);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", () => $62659eb193cd5c9c$export$8d987f6e80b74000);
$parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", () => $62659eb193cd5c9c$export$8de9fa43731c4b5b);
$parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", () => $62659eb193cd5c9c$export$87249ccbfd10fb78);
$parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", () => $62659eb193cd5c9c$export$c0eeeb31d264de76);
$parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", () => $62659eb193cd5c9c$export$f546e18e46478c84);
$parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", () => $62659eb193cd5c9c$export$1784e634ba79f1f9);
$parcel$export(module.exports, "JWM_INLINE_CREATE", () => $62659eb193cd5c9c$export$145eb8935a34e85e);
$parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", () => $62659eb193cd5c9c$export$32648b574a536c8b);
$parcel$export(module.exports, "JIRA_ISSUE_COMMENT", () => $62659eb193cd5c9c$export$220cd7b39e0b57a);
$parcel$export(module.exports, "JIRA_INBOX_CREATE_WORK_ITEM", () => $62659eb193cd5c9c$export$ab926dced0f69c1e);
$parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", () => $62659eb193cd5c9c$export$c0e2ab74dfaa67cc);
$parcel$export(module.exports, "LIST_OF_CHILD_ISSUES_TRIGGER_POINTS", () => $62659eb193cd5c9c$export$7a8328e1f8bd992b);
const $62659eb193cd5c9c$export$a05673a22505d5ee = 'forge-open-issue-create';
const $62659eb193cd5c9c$export$c78d329777576aa0 = 'global-create-button';
const $62659eb193cd5c9c$export$992ab052fd10f8e8 = 'mobile-global-create-button';
const $62659eb193cd5c9c$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $62659eb193cd5c9c$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $62659eb193cd5c9c$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $62659eb193cd5c9c$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $62659eb193cd5c9c$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $62659eb193cd5c9c$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $62659eb193cd5c9c$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $62659eb193cd5c9c$export$9bc326812a93707 = 'jsw-security-create-issue';
const $62659eb193cd5c9c$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $62659eb193cd5c9c$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $62659eb193cd5c9c$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $62659eb193cd5c9c$export$1110454816343634 = 'jsm-create-problem-from-incident-ai';
const $62659eb193cd5c9c$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $62659eb193cd5c9c$export$bc365eb0775af583 = 'jsm-project-summary-create-request';
const $62659eb193cd5c9c$export$235b856f54db8916 = 'jwm-board-create-issue';
const $62659eb193cd5c9c$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $62659eb193cd5c9c$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $62659eb193cd5c9c$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $62659eb193cd5c9c$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $62659eb193cd5c9c$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $62659eb193cd5c9c$export$aa348159181703a0 = 'software-create-issue-dialog';
const $62659eb193cd5c9c$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $62659eb193cd5c9c$export$718822a309bffada = 'create-linked-issue-command-palette';
const $62659eb193cd5c9c$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $62659eb193cd5c9c$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $62659eb193cd5c9c$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $62659eb193cd5c9c$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $62659eb193cd5c9c$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $62659eb193cd5c9c$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $62659eb193cd5c9c$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $62659eb193cd5c9c$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $62659eb193cd5c9c$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $62659eb193cd5c9c$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $62659eb193cd5c9c$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $62659eb193cd5c9c$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $62659eb193cd5c9c$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $62659eb193cd5c9c$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $62659eb193cd5c9c$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $62659eb193cd5c9c$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $62659eb193cd5c9c$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $62659eb193cd5c9c$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $62659eb193cd5c9c$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $62659eb193cd5c9c$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $62659eb193cd5c9c$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $62659eb193cd5c9c$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $62659eb193cd5c9c$export$145eb8935a34e85e = 'jwm-inline-create';
const $62659eb193cd5c9c$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
const $62659eb193cd5c9c$export$818f24c6c32e18a = 'jira-calendar-create-issue';
const $62659eb193cd5c9c$export$220cd7b39e0b57a = 'jira-issue-comment';
const $62659eb193cd5c9c$export$ab926dced0f69c1e = 'jira-inbox-create-work-item';
const $62659eb193cd5c9c$export$c0e2ab74dfaa67cc = {
    FIELD_IDS: [
        'description'
    ],
    TRIGGER_POINTS: [
        'service-desk-gen-ai-pir'
    ]
};
const $62659eb193cd5c9c$export$7a8328e1f8bd992b = [
    $62659eb193cd5c9c$export$7e9cfd1f59e60910,
    $62659eb193cd5c9c$export$708499dcd016e5e9,
    $62659eb193cd5c9c$export$e1c8789144c4c810,
    $62659eb193cd5c9c$export$c5afabb7a17e802
];

});

parcelRegister("5rzqz", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $0a31d64d52b4b5e9$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "useOpenIssueCreateModal", () => $0a31d64d52b4b5e9$export$47cf258b1046080b);
$parcel$export(module.exports, "withNewGICProvider", () => $0a31d64d52b4b5e9$export$558a195c5bfe3787);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $1Nspv = parcelRequire("1Nspv");

var $bGrWH = parcelRequire("bGrWH");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $f5nIZ = parcelRequire("f5nIZ");

var $2YP9W = parcelRequire("2YP9W");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $hULKg = parcelRequire("hULKg");

var $cKWWX = parcelRequire("cKWWX");

var $6k7U1 = parcelRequire("6k7U1");
const $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $bGrWH.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // onSiteSelection is called when a site is selected in the site picker
    onSiteSelection: null,
    // onProjectSelection is called when a project is selected in the project picker
    onProjectSelection: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $hULKg.TRIGGER_POINT_KEY_NOT_DEFINED),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // optional component - Renders external component above form fields
    ExternalControls: undefined,
    // Analytics property for board with custom filter and icc enabled
    isCustomBoardWithIcc: false,
    // optional ID of the jql swimlane we are creating issues in
    jqlSwimlaneId: undefined,
    // Analytics property for board with swimlane enabled
    swimlaneMode: undefined,
    // prefilled custom Fields if any
    prefilledCustomFields: {},
    // callback for ecosystem API to execute
    ecosystemCallback: undefined,
    // product where issue create anywhere modal is used
    product: undefined,
    // what's the consumer of the issue create anywhere modal in a product
    actionSource: undefined,
    // Field IDs that will remain visible even when the smart fields feature recommends them to be hidden.
    optOutSmartFieldIds: undefined,
    // refrence of the button from where GIC modal is triggered
    triggerButtonRef: null
};
const $0a31d64d52b4b5e9$export$e324594224ef24da = {
    restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) (0, $6k7U1.startGlobalIssueCreateMetrics)(isSubsequentLoad);
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                (0, $6k7U1.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $6k7U1.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $6k7U1.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                if ((0, $4R6GH.fg)('fix-gryf-a11y-issues')) {
                    /*
					 * This is done to always focus the Issue Create Modal trigger button whenever it's clicked
					 * so that we can store the reference of this
					 * and use that to re-focus the button whenever the modal is closed
					 */ let triggerButton;
                    const handleButtonClick = (event)=>{
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        const triggerButtonTarget = event.target;
                        triggerButton = triggerButtonTarget?.closest('button');
                        triggerButton?.focus();
                    };
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    document.addEventListener('click', handleButtonClick);
                    setTimeout(()=>{
                        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        document.removeEventListener('click', handleButtonClick);
                    }, 0);
                    setTimeout(()=>{
                        setState({
                            ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                            ...isDiscoverabilityPushEnabled && {
                                minimizableModalView: nextModalView,
                                persistentModalView: currentState.persistentModalView,
                                ...(0, $6k7U1.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                            },
                            inProgressIssueID: (0, $7Jxgt.v4)(),
                            isSubsequentLoad: currentState.isSubsequentLoad,
                            isModalOpen: true,
                            wasModalRetriggered: currentState.isModalOpen,
                            ...(0, $6s1PB.expVal)('quick_actions_m3_experiment', 'hotKeysEnabled', false) ? {
                                triggeredViaHotKey: !!nextState?.triggeredViaHotKey
                            } : {},
                            ...nextState,
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
                            triggerButtonRef: triggerButton || document.activeElement
                        });
                    }, 0);
                } else setState({
                    ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                    ...isDiscoverabilityPushEnabled && {
                        minimizableModalView: nextModalView,
                        persistentModalView: currentState.persistentModalView,
                        ...(0, $6k7U1.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                    },
                    inProgressIssueID: (0, $7Jxgt.v4)(),
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: currentState.isModalOpen,
                    ...(0, $6s1PB.expVal)('quick_actions_m3_experiment', 'hotKeysEnabled', false) ? {
                        triggeredViaHotKey: !!nextState?.triggeredViaHotKey
                    } : {},
                    ...nextState
                });
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $6k7U1.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                callbackPayload: undefined,
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $1Nspv.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                (0, $6k7U1.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $0a31d64d52b4b5e9$var$store = (0, $iXqE5.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
    actions: $0a31d64d52b4b5e9$export$e324594224ef24da
});
const $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalState = (0, $3sQ5x.createStateHook)($0a31d64d52b4b5e9$var$store);
const $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions = (0, $3sQ5x.createActionsHook)($0a31d64d52b4b5e9$var$store);
const $0a31d64d52b4b5e9$export$71e0eb7b8a91a156 = ()=>{
    const createState = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalState();
    const createActions = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $5uXOq.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...nextState?.product ? {
                product: nextState.product
            } : {},
            ...nextState?.actionSource ? {
                actionSource: nextState.actionSource
            } : {}
        };
        (0, $8zOmE.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $0a31d64d52b4b5e9$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [, { setSitePickerState: setSitePickerState }] = (0, $cKWWX.useSitePickerContext)();
    return (0, $5uXOq.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...nextState?.product ? {
                product: nextState.product
            } : {},
            ...nextState?.actionSource ? {
                actionSource: nextState.actionSource
            } : {}
        };
        (0, $8zOmE.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        // overrideCloudId only used for embedded GIC
        if (nextState?.payload?.overrideCloudId) // set cloudId inside the state if there's an override
        setSitePickerState({
            selectedCloudId: nextState?.payload?.overrideCloudId
        });
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal,
        setSitePickerState
    ]);
};
const $0a31d64d52b4b5e9$export$4c674fe824b8f278 = (0, $51nlc.createSubscriber)($0a31d64d52b4b5e9$var$store);
function $0a31d64d52b4b5e9$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $0a31d64d52b4b5e9$export$71e0eb7b8a91a156();
        const { data: data } = (0, $2YP9W.useResource)((0, $f5nIZ.gicOptInStatusResources));
        const currentIssueCreateVisibility = data && data?.gicOptInStatus;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
            ...props
        });
    };
}

});
parcelRegister("1Nspv", function(module, exports) {

$parcel$export(module.exports, "CreateIssueUFOExperience", () => $ff7fb599b8d98642$export$cd75c112ac11a83b);
$parcel$export(module.exports, "EditIssueTypeUFOExperience", () => $ff7fb599b8d98642$export$7d25d25bed94d6e2);
$parcel$export(module.exports, "CreateIssueTypeUFOExperience", () => $ff7fb599b8d98642$export$fda88e8e14acb615);
$parcel$export(module.exports, "StatusFieldLoad", () => $ff7fb599b8d98642$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $ff7fb599b8d98642$export$70208657c8d471a7);
$parcel$export(module.exports, "EcosystemAPIPrefillingUFOExperience", () => $ff7fb599b8d98642$export$b2d8f8edec75f571);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");
const $ff7fb599b8d98642$export$cd75c112ac11a83b = new (0, $kkzI0.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $ff7fb599b8d98642$export$7d25d25bed94d6e2 = new (0, $kkzI0.UFOExperience)('global-issue-create.create-issue.issue-type-field.edit-issue-type', {
    type: (0, $lrUJ4.ExperienceTypes).Operation,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom
});
const $ff7fb599b8d98642$export$fda88e8e14acb615 = new (0, $kkzI0.UFOExperience)('global-issue-create.create-issue.issue-type-field.create-issue-type', {
    type: (0, $lrUJ4.ExperienceTypes).Operation,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom
});
const $ff7fb599b8d98642$export$e890e797a25e655c = new (0, $kkzI0.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
});
const $ff7fb599b8d98642$export$70208657c8d471a7 = new (0, $kkzI0.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom,
    category: 'modern-global-issue-create.modal.issue-submit'
});
const $ff7fb599b8d98642$export$b2d8f8edec75f571 = new (0, $kkzI0.UFOExperience)('ecosystem-api-new-gic-prefilling', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom,
    category: 'ecosystem-api-new-gic-prefilling'
});

});

parcelRegister("bGrWH", function(module, exports) {

$parcel$export(module.exports, "REQUIRED", () => $4aabf2a0e09eb856$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $4aabf2a0e09eb856$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $4aabf2a0e09eb856$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $4aabf2a0e09eb856$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $4aabf2a0e09eb856$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $4aabf2a0e09eb856$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $4aabf2a0e09eb856$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $4aabf2a0e09eb856$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $4aabf2a0e09eb856$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $4aabf2a0e09eb856$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $4aabf2a0e09eb856$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $4aabf2a0e09eb856$export$8170252f0ea43511);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $4aabf2a0e09eb856$export$17bcab948893a9ba = 'worklog';
const $4aabf2a0e09eb856$export$b1c05b34d317c074 = 'REQUIRED';
const $4aabf2a0e09eb856$export$f10b32dfda12e96e = 'unknown';
const $4aabf2a0e09eb856$export$e5e4b8c32e68dd0b = 'networkError';
const $4aabf2a0e09eb856$export$2d06efb8146cd043 = 'graphQLError';
const $4aabf2a0e09eb856$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $4aabf2a0e09eb856$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $4aabf2a0e09eb856$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $4aabf2a0e09eb856$export$aac4661200ba4104 = 'worklog_startDate';
const $4aabf2a0e09eb856$export$a23c32d5cf54cba0 = 'worklog_description';
const $4aabf2a0e09eb856$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $4aabf2a0e09eb856$export$63fd567c1d0aca19 = [
    ...$4aabf2a0e09eb856$export$74ab3898ae683660,
    $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f,
    $4aabf2a0e09eb856$export$cf70f9220e6a2f50,
    $4aabf2a0e09eb856$export$aac4661200ba4104,
    $4aabf2a0e09eb856$export$a23c32d5cf54cba0
];
const $4aabf2a0e09eb856$export$983715bb9b0f9b2c = {
    [$4aabf2a0e09eb856$export$17bcab948893a9ba]: $4aabf2a0e09eb856$export$63fd567c1d0aca19
};
const $4aabf2a0e09eb856$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $4aabf2a0e09eb856$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $4aabf2a0e09eb856$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $4aabf2a0e09eb856$export$8170252f0ea43511 = 'QuickCreateIssue';

});

parcelRegister("cKWWX", function(module, exports) {

$parcel$export(module.exports, "useSitePickerContext", () => $c8055d212e869a3c$export$f8b5aae013e4cf77);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $c8055d212e869a3c$export$d4c72bab9d6cc13a = {
    selectedCloudId: '',
    siteDomain: ''
};
const $c8055d212e869a3c$export$e324594224ef24da = {
    setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                selectedCloudId: selectedCloudId || '',
                siteDomain: siteDomain || ''
            });
        }
};
const $c8055d212e869a3c$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue.fields.site-picker',
    initialState: $c8055d212e869a3c$export$d4c72bab9d6cc13a,
    actions: $c8055d212e869a3c$export$e324594224ef24da
});
const $c8055d212e869a3c$export$f8b5aae013e4cf77 = (0, $3sQ5x.createHook)($c8055d212e869a3c$export$6f57813fe9f31bf9);

});

parcelRegister("6k7U1", function(module, exports) {

$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $8a2e4df39a48d5af$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $8a2e4df39a48d5af$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $8a2e4df39a48d5af$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $8a2e4df39a48d5af$export$720579602bb055a2);

var $8yVxK = parcelRequire("8yVxK");

var $1Nspv = parcelRequire("1Nspv");

var $gEaAu = parcelRequire("gEaAu");

var $huY3x = parcelRequire("huY3x");
const $8a2e4df39a48d5af$export$550b19803bc962ec = (isSubsequentLoad)=>{
    (0, $1Nspv.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $gEaAu.globalIssueCreateModalLoadSubsequent) : (0, $gEaAu.globalIssueCreateModalLoad);
    if (isSubsequentLoad) (0, $8yVxK.default)('global-issue.create-modal-subsequent');
    else (0, $8yVxK.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $huY3x.startGlobalIssueCreateTTIWithAdjustments)();
};
const $8a2e4df39a48d5af$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $8a2e4df39a48d5af$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $8a2e4df39a48d5af$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};

});
parcelRegister("gEaAu", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $ee246606338fc99e$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $ee246606338fc99e$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $ee246606338fc99e$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $ee246606338fc99e$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $ee246606338fc99e$export$c1592e4d8d98963e);

var $2nKjG = parcelRequire("2nKjG");
const $ee246606338fc99e$export$5a01a7fa84b239c8 = (0, $2nKjG.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $ee246606338fc99e$export$c50ad3c31b6fcfc6 = (0, $2nKjG.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $ee246606338fc99e$export$4b2382574525bb0f = (0, $2nKjG.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $ee246606338fc99e$export$7839bdaa2f6a2385 = (0, $2nKjG.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $ee246606338fc99e$export$c1592e4d8d98963e = (0, $2nKjG.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("huY3x", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $06c7e44c59602f0c$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $06c7e44c59602f0c$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $06c7e44c59602f0c$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $06c7e44c59602f0c$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $06c7e44c59602f0c$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $06c7e44c59602f0c$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $06c7e44c59602f0c$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $06c7e44c59602f0c$export$d86f4868694f2aa7);
/**
 * For issue view, we moved similar constants to view-specific packages.
 * However, for GIC, such a move causes a circular dependency with @atlassian/jira-packages-controllers-use-trigger-issue-create-modal package,
 * since view-specific/gic imports trigger points constants from @atlassian/jira-packages-controllers-use-trigger-issue-create-modal.
 * Therefore, for now, let's keep it here.
 */ 
var $2nKjG = parcelRequire("2nKjG");
const $06c7e44c59602f0c$export$9f3d6f17e1da7874 = (0, $2nKjG.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ]
});
const $06c7e44c59602f0c$export$457c9fb71ad5b3a9 = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.start();
};
const $06c7e44c59602f0c$export$ef664dac649a716c = ()=>$06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('gic-tti');
const $06c7e44c59602f0c$export$30ca4c461fab486c = (customData)=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $06c7e44c59602f0c$export$27f2445288b528c = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.cancel();
};
const $06c7e44c59602f0c$export$7a2709fc1e33401a = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $06c7e44c59602f0c$export$cf3893335c93e33b = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $06c7e44c59602f0c$export$d86f4868694f2aa7 = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});




parcelRegister("1oIjm", function(module, exports) {

$parcel$export(module.exports, "Projects", () => $2e85fb8a2f8503d3$export$ca6fbb51b35e375c);

var $5uXOq = parcelRequire("5uXOq");

var $d40Fj = parcelRequire("d40Fj");

var $bKCrm = parcelRequire("bKCrm");

var $e9QkH = parcelRequire("e9QkH");

var $Mp6qH = parcelRequire("Mp6qH");
const $2e85fb8a2f8503d3$export$90cfe4f15bb50f58 = ({ open: open, close: close, setOnCloseCallback: setOnCloseCallback })=>{
    const [{ canCreateClassicProject: canCreateClassicProject }] = (0, $d40Fj.useCreateProjectPermission)();
    (0, $5uXOq.useEffect)(()=>{
        open && open({
            source: 'navigationNext',
            isNextGen: !canCreateClassicProject
        });
        setOnCloseCallback && setOnCloseCallback(close);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    return null;
};
const $2e85fb8a2f8503d3$export$ca6fbb51b35e375c = ()=>{
    const [isProjectCreateDrawerOpen, { off: closeProjectCreateDrawer }] = (0, $e9QkH.useSwitchModals)((0, $Mp6qH.MODAL_ID).PROJECT_CREATE);
    if (!isProjectCreateDrawerOpen) return null;
    // ProjectCreateDrawerProvider is in page container/navigaiton
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKCrm.ProjectCreateDrawerConsumer), null, ({ methods: { open: open, setOnCloseCallback: setOnCloseCallback } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e85fb8a2f8503d3$export$90cfe4f15bb50f58, {
            open: open,
            close: closeProjectCreateDrawer,
            setOnCloseCallback: setOnCloseCallback
        }));
};

});
parcelRegister("d40Fj", function(module, exports) {

$parcel$export(module.exports, "useCreateProjectPermission", () => $2e786b3606f3b4dc$export$c92733e8f8c1640f);
$parcel$export(module.exports, "useCreateProjectPermissionActions", () => $2e786b3606f3b4dc$export$d2b8d6f60fe99e2a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $kEnf8 = parcelRequire("kEnf8");
const $2e786b3606f3b4dc$var$Store = (0, $iXqE5.createStore)({
    name: 'create-project-permissions',
    initialState: {
        canCreateProject: false,
        canCreateClassicProject: false,
        canCreateNextGenProject: false,
        isFetching: false,
        fetchError: null,
        promise: null,
        hasFetchedOnce: false,
        hasSuccessOnce: false
    },
    actions: $kEnf8.actions
});
const $2e786b3606f3b4dc$export$5a47fbae725b8f2 = (0, $gg7kZ.createContainer)($2e786b3606f3b4dc$var$Store);
const $2e786b3606f3b4dc$export$c92733e8f8c1640f = (0, $3sQ5x.createHook)($2e786b3606f3b4dc$var$Store);
const $2e786b3606f3b4dc$export$d2b8d6f60fe99e2a = (0, $3sQ5x.createHook)($2e786b3606f3b4dc$var$Store, {
    selector: null
});

});
parcelRegister("kEnf8", function(module, exports) {

$parcel$export(module.exports, "actions", () => $005c9d409c181858$export$e324594224ef24da);

var $7f4tk = parcelRequire("7f4tk");
const $005c9d409c181858$export$963556ef97965f0b = async ()=>{
    const url = '/rest/internal/2/projectpermissions';
    const result = await (0, $7f4tk.default)(url);
    return result;
};
const $005c9d409c181858$var$handleFetch = ()=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
    async ({ setState: setState, getState: getState })=>{
        const { isFetching: isFetching } = getState();
        if (!isFetching) try {
            const result = await $005c9d409c181858$export$963556ef97965f0b();
            setState({
                ...result,
                isFetching: false,
                fetchError: null,
                hasFetchedOnce: true,
                hasSuccessOnce: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                canCreateProject: false,
                canCreateClassicProject: false,
                canCreateNextGenProject: false,
                isFetching: false,
                fetchError: error,
                hasFetchedOnce: true
            });
        }
    };
const $005c9d409c181858$export$e324594224ef24da = {
    fetchCreateProjectPermission: ()=>async ({ setState: setState, dispatch: dispatch })=>{
            const promise = dispatch($005c9d409c181858$var$handleFetch());
            setState({
                isFetching: true,
                promise: // @ts-expect-error - TS2322 - Type 'Promise<void>' is not assignable to type 'Promise<undefined>'.
                promise
            });
        }
};

});


parcelRegister("bKCrm", function(module, exports) {

$parcel$export(module.exports, "ProjectCreateDrawerProvider", () => $645a52f2fa143509$export$9a1c5dbd93c42bca);
$parcel$export(module.exports, "ProjectCreateDrawerConsumer", () => $645a52f2fa143509$export$9a8662cd60931de1);
$parcel$export(module.exports, "useProjectCreateDrawer", () => $645a52f2fa143509$export$8172ff4ed0f75a1e);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $58GFP = parcelRequire("58GFP");

var $8YEE2 = parcelRequire("8YEE2");

var $lVJAU = parcelRequire("lVJAU");

var $gL2cg = parcelRequire("gL2cg");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $645a52f2fa143509$var$Context = /*#__PURE__*/ (0, $5uXOq.createContext)({
    data: {
        shouldRenderDrawer: false,
        isOpen: false,
        isNextGen: false,
        showExperienceSelection: true,
        recommendedTemplate: undefined,
        defaultSelectedTemplateKey: '',
        source: '',
        isTemplatePickerOpenInitially: false,
        isImportProjectOpenInitially: false,
        selectedProjectType: null,
        recommendationSessionId: undefined
    },
    methods: {
        open: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        close: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onCreateStarted: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        setOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        clearOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }
});
const $645a52f2fa143509$export$839a70d8fbc9d356 = class ProjectCreateDrawerProvider extends (0, $5uXOq.Component) {
    render() {
        const { children: children } = this.props;
        const { isOpen: isOpen, isNextGen: isNextGen, source: source, showExperienceSelection: showExperienceSelection, shouldRenderDrawer: shouldRenderDrawer, recommendedTemplate: recommendedTemplate, defaultSelectedTemplateKey: defaultSelectedTemplateKey, isTemplatePickerOpenInitially: isTemplatePickerOpenInitially, isImportProjectOpenInitially: isImportProjectOpenInitially, selectedProjectType: selectedProjectType, recommendationSessionId: recommendationSessionId } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($645a52f2fa143509$var$Context.Provider, {
            value: {
                data: {
                    isOpen: isOpen,
                    isNextGen: isNextGen,
                    source: source,
                    showExperienceSelection: showExperienceSelection,
                    shouldRenderDrawer: shouldRenderDrawer,
                    recommendedTemplate: recommendedTemplate,
                    defaultSelectedTemplateKey: defaultSelectedTemplateKey,
                    isTemplatePickerOpenInitially: isTemplatePickerOpenInitially,
                    isImportProjectOpenInitially: isImportProjectOpenInitially,
                    selectedProjectType: selectedProjectType,
                    recommendationSessionId: recommendationSessionId
                },
                methods: {
                    open: this.open,
                    close: this.close,
                    onSuccess: this.onSuccess,
                    onCreateStarted: this.onCreateStarted,
                    setOnCloseCallback: this.setOnCloseCallback,
                    clearOnCloseCallback: this.clearOnCloseCallback
                }
            }
        }, children);
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: false,
            shouldRenderDrawer: false,
            isNextGen: false,
            showExperienceSelection: true,
            recommendedTemplate: undefined,
            defaultSelectedTemplateKey: '',
            source: '',
            isTemplatePickerOpenInitially: false,
            isImportProjectOpenInitially: false,
            selectedProjectType: null,
            recommendationSessionId: undefined,
            onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onSuccess = (projectKey)=>{
            if (projectKey) {
                this.props.setLocation(projectKey.returnUrl);
                this.close(true);
            } else this.close(false);
        }, // Callback that is called once when the drawer is closed.
        this.setOnCloseCallback = (callback)=>{
            this.setState({
                onCloseCallback: callback
            });
        }, this.clearOnCloseCallback = ()=>{
            this.setState({
                onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
            });
        }, this.open = (attributes = {})=>{
            // @ts-expect-error - TS2345 - Argument of type '{ isNextGen?: boolean | undefined; showExperienceSelection?: boolean | undefined; recommendedTemplate?: { templateKey: string; isSimplified: boolean; } | undefined; defaultSelectedTemplateKey?: string | undefined; ... 4 more ...; shouldRenderDrawer: true; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "source" | "isOpen" | "isNextGen" | ... 5 more ... | "isTemplatePickerOpenInitially"> | null) | Pick<...> | null'.
            this.setState({
                isOpen: true,
                shouldRenderDrawer: true,
                ...attributes
            });
        }, this.close = (projectCreated)=>{
            const callOnCloseCallBack = this.state.source === 'navigationNext' || !projectCreated;
            this.setState({
                isOpen: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                isImportProjectOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined
            });
            if (callOnCloseCallBack) // Call the added callback
            this.state.onCloseCallback();
        }, this.closeOld = ()=>{
            this.setState({
                isOpen: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined
            });
            this.state.onCloseCallback();
        }, this.onCreateStarted = (projectKey, templateKey)=>{
            if ((0, $58GFP.getIsJsmBlankProjectTemplate)(templateKey)) (0, $8YEE2.LazyComponent).preload();
            (0, $gL2cg.clearResourcesAssociatedWithProjectKey)(projectKey);
        };
    }
};
const $645a52f2fa143509$export$9a1c5dbd93c42bca = (props)=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($645a52f2fa143509$export$839a70d8fbc9d356, {
        ...props,
        setLocation: push
    });
};
const { Consumer: $645a52f2fa143509$export$9a8662cd60931de1 } = $645a52f2fa143509$var$Context;
$645a52f2fa143509$var$Context.displayName = 'ProjectCreateDrawerConsumer';
const $645a52f2fa143509$export$8172ff4ed0f75a1e = ()=>{
    const projectCreateDrawer = (0, $5uXOq.useContext)($645a52f2fa143509$var$Context);
    if (!projectCreateDrawer) throw new Error('useProjectCreateDrawer must be used within a ProjectCreateDrawerProvider');
    return projectCreateDrawer;
};

});
parcelRegister("8YEE2", function(module, exports) {

$parcel$export(module.exports, "LazyComponent", () => $300188a98a9fded7$export$31f1740ae531af94);
$parcel$export(module.exports, "AsyncProjectBuilderDrawer", () => $300188a98a9fded7$export$54a4eade9eae9473);
$parcel$export(module.exports, "canUseProjectBuilder", () => $300188a98a9fded7$export$ff317c5d87147a19);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $9noxX = parcelRequire("9noxX");

var $b7Svb = parcelRequire("b7Svb");

const $300188a98a9fded7$export$31f1740ae531af94 = (0, $b7Svb.lazy)(()=>(parcelRequire("9U5Vp")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/project-builder/src/ui/index.tsx"
});
const $300188a98a9fded7$export$54a4eade9eae9473 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "bundle-async-project-builder",
        packageName: "jira-servicedesk-project-builder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        fallback: null,
        name: "jsm-project-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9noxX.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($300188a98a9fded7$export$31f1740ae531af94, {
        isOpenInitial: !!props.isOpenInitial,
        ...props
    }))));
const $300188a98a9fded7$export$ff317c5d87147a19 = (isAdmin)=>isAdmin;

});
parcelRegister("9noxX", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskAnalyticsContext", () => $12b9024f66e7ef57$export$ac31f8f3368d6881);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

var $4DPZY = parcelRequire("4DPZY");

var $8H3A4 = parcelRequire("8H3A4");
const $12b9024f66e7ef57$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
    const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
    const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
    if ((0, $5uXOq.Children).count(children) > 0) {
        const loading = containerContextLoading || analyticsContextLoading;
        const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
        if (!shouldRenderChildren) return null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const context = {};
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        if (containerContextData && containerContextData.project) {
            // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
            const { id: id, type: type } = containerContextData.project;
            // containerType and containerId are obsolete - See https://developer.atlassian.com/platform/analytics-pipeline/getting-started/event-types/#glossary-of-terms
            // Also these dont work with screen events. See sendScreenEvent in: https://bitbucket.org/atlassian/analytics-web-client/src/master/src/analyticsWebClient.js
            // However they are kept here to not break any existing usages.
            context.containerType = 'project';
            context.containerId = `${id}`;
            // This is the preferred way to send container data for analytics
            context.containers = {
                project: {
                    id: `${id}`,
                    type: type
                }
            };
            if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), context, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
$12b9024f66e7ef57$export$ac31f8f3368d6881.defaultProps = {
    forceRenderWhileLoading: false,
    useServiceDeskAnalyticsContext: (0, $8H3A4.useServiceDeskAnalyticsContext),
    useContainerContext: (0, $4DPZY.useContainerContext)
};

});

parcelRegister("9U5Vp", function(module, exports) {

let $735df090e3ae6b43$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $735df090e3ae6b43$var$load("eNmuD"),
    $735df090e3ae6b43$var$load("hPzOn"),
    $735df090e3ae6b43$var$load("h2MrD"),
    $735df090e3ae6b43$var$load("bYT2S"),
    $735df090e3ae6b43$var$load("kWrFZ"),
    $735df090e3ae6b43$var$load("92sUi"),
    $735df090e3ae6b43$var$load("i5RRW"),
    $735df090e3ae6b43$var$load("cM9em"),
    $735df090e3ae6b43$var$load("fr9NE"),
    $735df090e3ae6b43$var$load("c8LNs")
]).then(()=>parcelRequire('c9lEE'));

});


parcelRegister("gL2cg", function(module, exports) {

$parcel$export(module.exports, "clearResourcesAssociatedWithProjectKey", () => $e1d0138bae1db723$export$c0c81c1828c7638c);

var $jcw0u = parcelRequire("jcw0u");

var $8fYaK = parcelRequire("8fYaK");
const $e1d0138bae1db723$export$c0c81c1828c7638c = (projectKey)=>{
    try {
        const { storeState: storeState } = (0, $8fYaK.getResourceStore)();
        const prevState = storeState.getState();
        storeState.setState({
            ...prevState,
            data: Object.fromEntries(Object.entries(prevState?.data).map(([resourceType, value])=>{
                // This will not clear resources that are keyed with project key as a subset of the key,
                // e.g. `projectKey-${projectKey}` or similar, so those resources may still have stale data.
                const { [projectKey]: _, ...rest } = value;
                return [
                    resourceType,
                    rest
                ];
            }))
        });
    } catch (e) {
        (0, $jcw0u.default)({
            meta: {
                id: 'clearResourcesAssociatedWithProjectKey',
                packageName: 'jiraProjectCreateDrawerContext',
                teamName: 'helix'
            },
            sendToPrivacyUnsafeSplunk: true,
            error: e instanceof Error ? e : new Error('Error occured in clearResourcesAssociatedWithProjectKey')
        });
    }
};

});




parcelRegister("fZrWn", function(module, exports) {

let $ba4239f584f8eb6f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ba4239f584f8eb6f$var$load("bnKSn").then(()=>parcelRequire('6kz4R'));

});

parcelRegister("bp4rt", function(module, exports) {

let $84d579a265c6ec8c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $84d579a265c6ec8c$var$load("kpDDc").then(()=>parcelRequire('a8CW2'));

});

parcelRegister("awHzC", function(module, exports) {

let $7a9eb15071c9a49d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7a9eb15071c9a49d$var$load("humN1").then(()=>parcelRequire('7l6f4'));

});

parcelRegister("gWBZV", function(module, exports) {

let $c55f89adb87fa794$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c55f89adb87fa794$var$load("pGAVo").then(()=>parcelRequire('hfEgP'));

});

parcelRegister("gnXZs", function(module, exports) {

let $031416007855629f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $031416007855629f$var$load("7H2mF").then(()=>parcelRequire('1GckT'));

});

parcelRegister("d11H7", function(module, exports) {

let $979caeda0b407bc0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $979caeda0b407bc0$var$load("3TwVo").then(()=>parcelRequire('aUZKu'));

});


parcelRegister("kQm4v", function(module, exports) {

$parcel$export(module.exports, "getIssuesNavigationPaths", () => $85bbb82518fd8ed6$export$a33a4d7b083ee85);
$parcel$export(module.exports, "isIssuesNavPath", () => $85bbb82518fd8ed6$export$f38c22a081278057);
const $85bbb82518fd8ed6$export$a33a4d7b083ee85 = ()=>({
        // Features
        newIssueSearchTransition: '/jira/settings/issues/new-issue-search-transition',
        timeTrackingItem: '/secure/admin/TimeTrackingAdmin.jspa',
        issueLinkingItem: '/secure/admin/ViewLinkTypes!default.jspa',
        // IssueTypes
        issueTypesHierarchyItem: '/jira/settings/issues/issue-hierarchy',
        issueTypesItem: '/jira/settings/issues/issue-types',
        issueTypeSchemesItem: '/jira/settings/issues/issue-type-schemes',
        issueTypesSubTasksItem: '/secure/admin/subtasks/ManageSubTasks.jspa',
        // Workflows
        workflowsItem: '/jira/settings/issues/workflows',
        workflowSchemesItem: '/secure/admin/ViewWorkflowSchemes.jspa',
        // Screens
        screensItem: '/jira/settings/issues/screens',
        screenSchemesItem: '/jira/settings/issues/screen-schemes',
        screensIssueTypeScreenSchemesMenu: '/jira/settings/issues/issue-type-screen-schemes',
        // Fields
        fieldsManagement: '/jira/settings/issues/fields',
        customFieldsItem: '/secure/admin/ViewCustomFields.jspa',
        fieldConfigurationsItem: '/secure/admin/ViewFieldLayouts.jspa',
        fieldConfigurationSchemes: '/secure/admin/ViewFieldLayoutSchemes.jspa',
        // Priorities
        prioritiesItem: '/jira/settings/issues/priorities',
        prioritySchemesItem: '/jira/settings/issues/priority-schemes',
        // Forms
        dataConnectionsItem: '/jira/settings/forms/data-connections',
        // IssueAttributes
        statusesItem: '/secure/admin/ViewStatuses.jspa',
        resolutionsItem: '/secure/admin/ViewResolutions.jspa',
        issueSecuritySchemesItem: '/secure/admin/ViewIssueSecuritySchemes.jspa',
        notificationSchemesItem: '/secure/admin/ViewNotificationSchemes.jspa',
        permissionSchemesItem: '/secure/admin/ViewPermissionSchemes.jspa'
    });
const $85bbb82518fd8ed6$var$getIssuesNavPaths = ()=>{
    return [
        '/jira/settings/issues/new-issue-search-transition',
        '/secure/admin/TimeTrackingAdmin',
        '/secure/admin/ViewLinkTypes',
        '/jira/settings/issues/issue-hierarchy',
        '/jira/settings/issues/issue-types',
        '/jira/settings/issues/issue-type-schemes',
        '/secure/admin/subtasks/ManageSubTasks',
        '/jira/settings/issues/workflows',
        '/secure/admin/ViewWorkflowSchemes',
        '/jira/settings/issues/screens',
        '/jira/settings/issues/screen-schemes',
        '/jira/settings/issues/issue-type-screen-schemes',
        '/jira/settings/issues/fields',
        '/secure/admin/ViewCustomFields',
        '/secure/admin/ViewFieldLayouts',
        '/secure/admin/ViewFieldLayoutSchemes',
        '/jira/settings/issues/priorities',
        '/jira/settings/issues/priority-schemes',
        '/secure/admin/ViewStatuses',
        '/secure/admin/ViewResolutions',
        '/secure/admin/ViewIssueSecuritySchemes',
        '/secure/admin/ViewNotificationSchemes',
        '/secure/admin/ViewPermissionSchemes'
    ];
};
const $85bbb82518fd8ed6$export$f38c22a081278057 = (baseUrl)=>{
    const paths = $85bbb82518fd8ed6$var$getIssuesNavPaths();
    return paths.some((path)=>baseUrl.includes(path));
};

});

parcelRegister("10qwl", function(module, exports) {

$parcel$export(module.exports, "JiraTopBannerPlacement", () => $736f603676959336$export$2a9156f5c2a2410e);

var $5uXOq = parcelRequire("5uXOq");

var $ix8Nd = parcelRequire("ix8Nd");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $4yEIl = parcelRequire("4yEIl");

var $j2nvL = parcelRequire("j2nvL");

var $jQsty = parcelRequire("jQsty");

var $5pSYQ = parcelRequire("5pSYQ");

var $ZILlH = parcelRequire("ZILlH");
const $736f603676959336$var$PLACEMENT_ID = 'jira-top-banner';
const $736f603676959336$var$TopBannerPlacement = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "topBannerPlacement",
        packageName: "top-banner-placement",
        teamName: "post-office",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4yEIl.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "top-banner-placement.jira-top-banner-placement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j2nvL.PlacementFetchProvider), {
        resource: (0, $5pSYQ.postOfficeJiraTopBannerResource)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ZILlH.default), {
        placementId: $736f603676959336$var$PLACEMENT_ID,
        // Post Office and Jira uses different versions of react-error-boundary - https://atlassian.slack.com/archives/CL6HC337Z/p1741218999095929
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
        PlacementComponent: (0, $ix8Nd.default)
    })))));
};
const $736f603676959336$export$2a9156f5c2a2410e = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    if (!(0, $jQsty.default)('killswitch_post_office_in_jira') && (0, $4R6GH.fg)('jira-issue-term-refresh-banner')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($736f603676959336$var$TopBannerPlacement, null);
    return null;
});

});
parcelRegister("ix8Nd", function(module, exports) {

$parcel$export(module.exports, "default", () => $987902e94695ae41$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $aAASp = parcelRequire("aAASp");

var $e2ICd = parcelRequire("e2ICd");
var $kZgxR = parcelRequire("kZgxR");

var $5uXOq = parcelRequire("5uXOq");

var $3jWUH = parcelRequire("3jWUH");


var $7CK2n = parcelRequire("7CK2n");
const $987902e94695ae41$export$a4ee24848b29490b = (0, $7CK2n.withJiraTopBannerIntlProvider)((0, $e2ICd.createPlacementComponent)((0, $df69f5d3899c3a85$export$a5cfae247d8360ef), ({ initialData: initialData })=>{
    const { data: data, isLoading: isLoading } = (0, $kZgxR.useInitialData)(initialData);
    const [{ message: message, status: status }, setMessageState] = (0, $5uXOq.useState)({
        message: undefined,
        status: 'loading'
    });
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $aAASp.useMessagePlacementHooks)();
    const handleDismiss = (0, $5uXOq.useCallback)(()=>{
        setMessageState({
            message: undefined,
            status: 'done'
        });
    }, []);
    (0, $5uXOq.useEffect)(()=>onMessageDismiss(handleDismiss), [
        onMessageDismiss,
        handleDismiss
    ]);
    (0, $5uXOq.useEffect)(()=>onMessageClicked(handleDismiss), [
        onMessageClicked,
        handleDismiss
    ]);
    (0, $5uXOq.useEffect)(()=>onMessageSnooze(handleDismiss), [
        onMessageSnooze,
        handleDismiss
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isLoading) {
            const newMessage = data?.messages[0];
            setMessageState({
                message: newMessage,
                status: 'done'
            });
        }
    }, [
        data,
        isLoading
    ]);
    if (isLoading || status === 'loading') return null;
    return message && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3jWUH.MessageRenderer), {
        ...message,
        messageInstanceId: message.messageInstanceId
    });
}, {
    choreographer: {
        isDefaultEnabled: false
    }
}));
var $987902e94695ae41$export$2e2bcd8739ae039 = $987902e94695ae41$export$a4ee24848b29490b;

});
parcelRegister("aAASp", function(module, exports) {

$parcel$export(module.exports, "createMessagePlacementValues", () => $f10601e680b01ce9$export$a28a0c048b24fc5a);
$parcel$export(module.exports, "MessagePlacementProvider", () => $f10601e680b01ce9$export$c7535f8ebc5b75a9);
$parcel$export(module.exports, "useMessagePlacementHooks", () => $f10601e680b01ce9$export$89f8e1f623d8f5ac);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
/**
 * Creates a Publish-Subscribe pattern for managing callbacks.
 * @returns {Array<Subscribe, Publish>} An array containing a Subscribe function and a Publish function.
 */ const $f10601e680b01ce9$var$createPubSub = ()=>{
    const subscribers = new Map();
    /**
	 * Subscribes a callback function to the pub-sub system.
	 * @param {Callback} subscriber - The callback function to subscribe.
	 * @returns A function to unsubscribe the callback.
	 */ const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    /**
	 * Publishes the payload to all subscribed callbacks.
	 * @param {Callback} payload - The payload to publish to the subscribers.
	 */ const publish = (payload)=>{
        subscribers.forEach((cb)=>cb(payload));
    };
    return [
        subscribe,
        publish
    ];
};
const $f10601e680b01ce9$export$a28a0c048b24fc5a = ()=>{
    const [onMessageSnooze, snoozeMessageFromPlacement] = $f10601e680b01ce9$var$createPubSub();
    const [onMessageDismiss, dismissMessageFromPlacement] = $f10601e680b01ce9$var$createPubSub();
    const [onMessageRead, markReadFromPlacement] = $f10601e680b01ce9$var$createPubSub();
    const [onMessageViewed, markViewedFromPlacement] = $f10601e680b01ce9$var$createPubSub();
    const [onMessageClicked, markClickedFromPlacement] = $f10601e680b01ce9$var$createPubSub();
    return {
        onMessageSnooze: onMessageSnooze,
        snoozeMessageFromPlacement: snoozeMessageFromPlacement,
        onMessageDismiss: onMessageDismiss,
        dismissMessageFromPlacement: dismissMessageFromPlacement,
        onMessageRead: onMessageRead,
        markReadFromPlacement: markReadFromPlacement,
        onMessageViewed: onMessageViewed,
        markViewedFromPlacement: markViewedFromPlacement,
        onMessageClicked: onMessageClicked,
        markClickedFromPlacement: markClickedFromPlacement
    };
};
const $f10601e680b01ce9$export$ea58328f3ceee4d4 = /*#__PURE__*/ (0, $5uXOq.createContext)($f10601e680b01ce9$export$a28a0c048b24fc5a());
const $f10601e680b01ce9$export$c7535f8ebc5b75a9 = $f10601e680b01ce9$export$ea58328f3ceee4d4.Provider;
const $f10601e680b01ce9$export$c4b5cec0911af177 = ()=>({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)($f10601e680b01ce9$export$c7535f8ebc5b75a9, {
            value: $f10601e680b01ce9$export$a28a0c048b24fc5a(),
            children: children
        });
const $f10601e680b01ce9$export$89f8e1f623d8f5ac = ()=>(0, $5uXOq.useContext)($f10601e680b01ce9$export$ea58328f3ceee4d4);

});

parcelRegister("e2ICd", function(module, exports) {

$parcel$export(module.exports, "createPlacementComponent", () => $1dea243ccb1ee301$export$8a57effc6307f916);

var $g6jw5 = parcelRequire("g6jw5");
const $1dea243ccb1ee301$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>(0, $g6jw5.createPlacementComponent)(placementId, Component, placementConfigurationOptions);

});
parcelRegister("g6jw5", function(module, exports) {

$parcel$export(module.exports, "createPlacementComponent", () => $c9bb81bd8eaa1f91$export$8a57effc6307f916);

var $2OMIu = parcelRequire("2OMIu");

var $30kbx = parcelRequire("30kbx");

var $f3wkM = parcelRequire("f3wkM");

var $lOPND = parcelRequire("lOPND");

var $9lQh9 = parcelRequire("9lQh9");
var $9Aukk = parcelRequire("9Aukk");

var $4UTPF = parcelRequire("4UTPF");
const $c9bb81bd8eaa1f91$export$eaeb39efb2b24b52 = (placementId, Component, placementConfigurationOptions)=>(0, $4UTPF.withErrorBoundary)((props)=>{
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        const stableContext = (0, $30kbx.useStableObject)(context);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9lQh9.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Aukk.StableProviders), {
                route: route,
                context: stableContext,
                placement: {
                    placementId: placementId
                },
                choreographer: placementConfigurationOptions?.choreographer,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                    context: stableContext,
                    initialData: initialData,
                    ...componentProps
                })
            })
        });
    });
const $c9bb81bd8eaa1f91$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>{
    const placement = $c9bb81bd8eaa1f91$export$eaeb39efb2b24b52(placementId, Component, placementConfigurationOptions);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $lOPND.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $f3wkM.ERROR_BOUNDARY_LOCATION),
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};

});
parcelRegister("30kbx", function(module, exports) {

$parcel$export(module.exports, "useStableObject", () => $bec475bc874a93d3$export$ed02d4adf2068b08);

var $5uXOq = parcelRequire("5uXOq");
function $bec475bc874a93d3$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $bec475bc874a93d3$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $5uXOq.useMemo)(()=>obj, $bec475bc874a93d3$export$cdf98ded28406f69(obj));
}

});

parcelRegister("f3wkM", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $a8bec41c5a29948b$export$9c542858adf7dcd0);
$parcel$export(module.exports, "ERROR_BOUNDARY_LOCATION", () => $a8bec41c5a29948b$export$71ff7382870ef1b0);
const $a8bec41c5a29948b$export$9c542858adf7dcd0 = {
    isSiteAdmin: undefined,
    locale: undefined,
    product: undefined,
    subproduct: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $a8bec41c5a29948b$export$71ff7382870ef1b0 = 'create-placement-component';

});

parcelRegister("lOPND", function(module, exports) {

$parcel$export(module.exports, "useComponentErrorHandling", () => $b1edd1250debac1d$export$3d127465d22fe4e5);

var $5uXOq = parcelRequire("5uXOq");
const $b1edd1250debac1d$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $5uXOq.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};

});

parcelRegister("9lQh9", function(module, exports) {

$parcel$export(module.exports, "PerformanceTracking", () => $eeeb78daf5be4c96$export$9a335a42ce02bdb8);

var $2OMIu = parcelRequire("2OMIu");

var $96Irh = parcelRequire("96Irh");

var $jeAWE = parcelRequire("jeAWE");

var $2x1bx = parcelRequire("2x1bx");

var $2N91T = parcelRequire("2N91T");
const $eeeb78daf5be4c96$export$9a335a42ce02bdb8 = ({ children: children, ...props })=>{
    const isUFOEnabled = (0, $96Irh.default).checkGate('enable_ufo_tracking_in_post_office');
    const { isLoading: isLoading, onMount: onMount } = (0, $2N91T.usePerformanceTracking)(props);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jeAWE.UFOv2).UFOSegment, {
        name: (0, $jeAWE.UFOv2).SegmentNames.PLACEMENT,
        children: [
            isUFOEnabled && isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jeAWE.UFOv2).UFOLoadHold, {
                name: (0, $jeAWE.UFOv2).HoldNames.PLACEMENT
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2x1bx.TrackMount), {
                onMount: onMount,
                children: children
            })
        ]
    });
};

});
parcelRegister("jeAWE", function(module, exports) {

$parcel$export(module.exports, "UFOv2", () => $983fcce4e885982c$export$c91b09caa8ecbab1);

var $8iquX = parcelRequire("8iquX");

var $5tDD0 = parcelRequire("5tDD0");
const $983fcce4e885982c$export$c91b09caa8ecbab1 = {
    /** Names for UFOv2 segments for Post Office */ SegmentNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    },
    /** Names for UFOv2 holds for Post Office */ HoldNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
        PLACEMENT: 'post-office-placement-loading',
        MESSAGE: 'post-office-message-loading'
    },
    UFOLoadHold: $8iquX.default,
    UFOSegment: $5tDD0.default
};

});

parcelRegister("2x1bx", function(module, exports) {

$parcel$export(module.exports, "TrackMount", () => $dd434a72a35484c9$export$21b400a8c8ebc91a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $dd434a72a35484c9$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
    (0, $5uXOq.useEffect)(()=>{
        const onUnmount = onMount();
        return onUnmount;
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});

parcelRegister("2N91T", function(module, exports) {

$parcel$export(module.exports, "usePerformanceTracking", () => $290eab3364e5a55a$export$317d52099614f316);

var $5uXOq = parcelRequire("5uXOq");
const $290eab3364e5a55a$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const onMount = (0, $5uXOq.useCallback)(()=>{
        return ()=>onEvent?.({
                type: 'unmount'
            });
    }, [
        onEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (initialData) initialData.then(()=>{
            onEvent?.({
                type: 'initial-data-complete'
            });
        }).catch((error)=>{
            onEvent?.({
                type: 'initial-data-error',
                error: error
            });
        }).finally(()=>{
            setIsLoading(false);
        });
        else setIsLoading(false);
    }, [
        initialData,
        onEvent
    ]);
    const onComponentError = (0, $5uXOq.useCallback)((error)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
    }, [
        onEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isLoading === false) onEvent?.({
            type: 'component-ready'
        });
    }, [
        isLoading
    ]);
    return {
        onMount: onMount,
        isLoading: isLoading,
        onComponentError: onComponentError
    };
};

});


parcelRegister("9Aukk", function(module, exports) {

$parcel$export(module.exports, "StableProviders", () => $bf4bc7f7479aacc5$export$2b6596bcb1383a71);

var $2OMIu = parcelRequire("2OMIu");

var $6HTor = parcelRequire("6HTor");

var $8otwM = parcelRequire("8otwM");

var $1z7k9 = parcelRequire("1z7k9");

var $2mHbD = parcelRequire("2mHbD");

var $51c3R = parcelRequire("51c3R");

var $1ZcCe = parcelRequire("1ZcCe");

var $9lQh9 = parcelRequire("9lQh9");
const $bf4bc7f7479aacc5$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route, choreographer: choreographer })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2mHbD.StableContextProvider), {
        context: context,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $51c3R.StablePlacementProvider), {
            placement: placement,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1ZcCe.StableRouteProvider), {
                route: route,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8otwM.StableAnaltyicsProvider), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1z7k9.StableChoreographerProvider), {
                        choreographer: choreographer,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6HTor.RenderTrackerProvider), {
                            placementId: placement.placementId,
                            children: children
                        })
                    })
                })
            })
        })
    });

});
parcelRegister("6HTor", function(module, exports) {

$parcel$export(module.exports, "RenderTrackerProvider", () => $6b2b67dad92b784e$export$2d84fd9af6c9e378);

var $2OMIu = parcelRequire("2OMIu");

var $ddiyw = parcelRequire("ddiyw");

var $5uXOq = parcelRequire("5uXOq");
/**
 * List of Placements we do not want to track placement (rendered) for, due to cost reasons, until we have a better solution.
 */ const $6b2b67dad92b784e$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS = [
    'screen-space-flags'
];
const $6b2b67dad92b784e$export$2d84fd9af6c9e378 = ({ children: children, placementId: placementId })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ddiyw.useFirePostOfficeAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if ($6b2b67dad92b784e$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS.includes(placementId)) return;
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: 'placement'
        });
    }, [
        fireAnalyticsEvent,
        placementId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});
parcelRegister("ddiyw", function(module, exports) {

$parcel$export(module.exports, "useFirePostOfficeAnalyticsEvents", () => $86c2eaabc6cc5088$export$57d19d18d6e255a5);

var $bngFq = parcelRequire("bngFq");

var $5uXOq = parcelRequire("5uXOq");
const $86c2eaabc6cc5088$export$85183a312807388d = 'postOffice';
const $86c2eaabc6cc5088$export$57d19d18d6e255a5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $5uXOq.useCallback)((eventPayload, attributes)=>{
        createAnalyticsEvent({
            ...eventPayload,
            side: 'client',
            attributes: {
                ...eventPayload.attributes,
                ...attributes
            }
        }).fire($86c2eaabc6cc5088$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};

});


parcelRegister("8otwM", function(module, exports) {

$parcel$export(module.exports, "StableAnaltyicsProvider", () => $55f0712814b9be83$export$5a66cdc9893b43e);

var $2OMIu = parcelRequire("2OMIu");

var $cnhic = parcelRequire("cnhic");
const $55f0712814b9be83$var$postOfficeAnalyticsContextData = {
    attributes: {
        build: {
            c: undefined,
            b: undefined,
            t: undefined
        }
    }
};
const $55f0712814b9be83$export$5a66cdc9893b43e = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cnhic.PostOfficeAnalyticsContext), {
        data: $55f0712814b9be83$var$postOfficeAnalyticsContextData,
        children: children
    });
};

});

parcelRegister("1z7k9", function(module, exports) {

$parcel$export(module.exports, "StableChoreographerProvider", () => $6bf4189aae416d0e$export$e68b2c75bfb5682a);
$parcel$export(module.exports, "useChoreographerContext", () => $6bf4189aae416d0e$export$cab5a8adbabcee23);

var $2OMIu = parcelRequire("2OMIu");

var $ggVl0 = parcelRequire("ggVl0");
var $k9ais = parcelRequire("k9ais");

var $5uXOq = parcelRequire("5uXOq");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
const $6bf4189aae416d0e$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;
const $6bf4189aae416d0e$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
const $6bf4189aae416d0e$var$defaultContext = {
    choreographerEnabled: $6bf4189aae416d0e$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
    setChoreographerEnabled: ()=>{},
    factory: undefined
};
const $6bf4189aae416d0e$var$ChoreographerContext = /*#__PURE__*/ (0, $5uXOq.createContext)($6bf4189aae416d0e$var$defaultContext);

const $6bf4189aae416d0e$export$e68b2c75bfb5682a = ({ children: children, choreographer: choreographer })=>{
    const [choreographerFactory, setChoreographerFactory] = (0, $5uXOq.useState)(undefined);
    const [choreographerEnabled, setChoreographerEnabled] = (0, $5uXOq.useState)(choreographer?.isDefaultEnabled ?? $6bf4189aae416d0e$var$defaultContext.choreographerEnabled);
    const environmentContext = (0, $k9ais.usePostOfficeEnvironment)();
    const context = (0, $ggVl0.usePostOfficeContext)();
    (0, $5uXOq.useEffect)(()=>{
        if (choreographerEnabled) (parcelRequire("cwRME")).then((m)=>{
            const module = $6bf4189aae416d0e$var$importHelper(m);
            setChoreographerFactory(new module.ChoreographerRegistry(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory());
        }).catch(()=>{
            setChoreographerEnabled(false);
        });
    }, [
        choreographerEnabled,
        context.product,
        environmentContext.currentEnv
    ]);
    const stableChoreographerContext = (0, $5uXOq.useMemo)(()=>({
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            setChoreographerEnabled: setChoreographerEnabled
        }), [
        choreographerFactory,
        choreographerEnabled,
        setChoreographerEnabled
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($6bf4189aae416d0e$var$ChoreographerContext.Provider, {
        value: stableChoreographerContext,
        children: children
    });
};
const $6bf4189aae416d0e$export$cab5a8adbabcee23 = ()=>(0, $5uXOq.useContext)($6bf4189aae416d0e$var$ChoreographerContext);

});
parcelRegister("ggVl0", function(module, exports) {

$parcel$export(module.exports, "defaultPostOfficeContextValue", () => $2a588e85980dae1a$export$da5dc9062cba6715);
$parcel$export(module.exports, "InternalPostOfficeContextProvider", () => $2a588e85980dae1a$export$3a10495c2cd2db0c);
$parcel$export(module.exports, "PostOfficeContextProvider", () => $2a588e85980dae1a$export$b77983be89bb0a4e);
$parcel$export(module.exports, "usePostOfficeContext", () => $2a588e85980dae1a$export$5bd9099e0ae94a43);

var $5uXOq = parcelRequire("5uXOq");
const $2a588e85980dae1a$export$da5dc9062cba6715 = {
    product: undefined,
    subproduct: undefined,
    locale: undefined,
    isSiteAdmin: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $2a588e85980dae1a$export$a228be81fcb77b42 = (0, $5uXOq.createContext)($2a588e85980dae1a$export$da5dc9062cba6715);
const $2a588e85980dae1a$export$3a10495c2cd2db0c = $2a588e85980dae1a$export$a228be81fcb77b42.Provider;
const $2a588e85980dae1a$export$b77983be89bb0a4e = $2a588e85980dae1a$export$3a10495c2cd2db0c;
const $2a588e85980dae1a$export$5bd9099e0ae94a43 = ()=>(0, $5uXOq.useContext)($2a588e85980dae1a$export$a228be81fcb77b42);

});

parcelRegister("cwRME", function(module, exports) {

let $91f23180b31e2425$var$load = (parcelRequire("28QjX"))(4);
module.exports = $91f23180b31e2425$var$load("3rsnr").then(()=>parcelRequire('aqms7'));

});


parcelRegister("2mHbD", function(module, exports) {

$parcel$export(module.exports, "StableContextProvider", () => $4635ad16673a46bb$export$d4982c0a28b18f63);

var $2OMIu = parcelRequire("2OMIu");

var $ggVl0 = parcelRequire("ggVl0");
var $30kbx = parcelRequire("30kbx");

var $f3wkM = parcelRequire("f3wkM");
const $4635ad16673a46bb$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
    const stableContext = (0, $30kbx.useStableObject)({
        ...(0, $f3wkM.DEFAULT_CONTEXT),
        ...context
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ggVl0.PostOfficeContextProvider), {
        value: stableContext,
        children: children
    });
};

});

parcelRegister("51c3R", function(module, exports) {

$parcel$export(module.exports, "StablePlacementProvider", () => $976c8379ea00cead$export$e9fd288527498af6);

var $2OMIu = parcelRequire("2OMIu");

var $30kbx = parcelRequire("30kbx");

var $2EUTa = parcelRequire("2EUTa");
const $976c8379ea00cead$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
    const stableValue = (0, $30kbx.useStableObject)(placement);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2EUTa.PlacementProvider), {
        value: stableValue,
        children: children
    });
};

});
parcelRegister("2EUTa", function(module, exports) {

$parcel$export(module.exports, "PlacementProvider", () => $ce3c5357121f811e$export$6272e220478c7f1d);
$parcel$export(module.exports, "usePlacementContext", () => $ce3c5357121f811e$export$4fc0446ee742ad80);

var $2OMIu = parcelRequire("2OMIu");

var $cnhic = parcelRequire("cnhic");

var $iHQZs = parcelRequire("iHQZs");

var $5uXOq = parcelRequire("5uXOq");
const $ce3c5357121f811e$export$6394bf86db095a8 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    placementId: undefined
});
const $ce3c5357121f811e$export$6272e220478c7f1d = ({ value: value, children: children })=>{
    const memoizedValue = (0, $5uXOq.useMemo)(()=>({
            placementId: value.placementId
        }), [
        value.placementId
    ]);
    (0, $iHQZs.usePostOfficeScreenPlacement)(memoizedValue);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ce3c5357121f811e$export$6394bf86db095a8.Provider, {
        value: memoizedValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cnhic.PostOfficeAnalyticsContext), {
            data: memoizedValue,
            children: children
        })
    });
};
const $ce3c5357121f811e$export$4fc0446ee742ad80 = ()=>(0, $5uXOq.useContext)($ce3c5357121f811e$export$6394bf86db095a8);

});
parcelRegister("iHQZs", function(module, exports) {

$parcel$export(module.exports, "PostOfficeScreenContextProvider", () => $7be062d5df09f4cd$export$ca77a8cbe94108fe);
$parcel$export(module.exports, "usePostOfficeScreenPlacement", () => $7be062d5df09f4cd$export$f51d04a086368016);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hHS4t = parcelRequire("hHS4t");
const $7be062d5df09f4cd$var$initialPlacementState = {
    currentlyMounted: [],
    hasMounted: []
};
const $7be062d5df09f4cd$var$PostOfficeScreenContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    placements: $7be062d5df09f4cd$var$initialPlacementState
});
const $7be062d5df09f4cd$export$70e19226ddeaf957 = ()=>(0, $5uXOq.useContext)($7be062d5df09f4cd$var$PostOfficeScreenContext);
const $7be062d5df09f4cd$var$PostOfficeScreenUpdateContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    placementMount: ()=>{},
    placementUnmount: ()=>{}
});
const $7be062d5df09f4cd$export$5d27c0ee02be2a23 = ()=>(0, $5uXOq.useContext)($7be062d5df09f4cd$var$PostOfficeScreenUpdateContext);
const $7be062d5df09f4cd$export$ca77a8cbe94108fe = ({ children: children })=>{
    const [placements, setPlacements] = (0, $5uXOq.useState)($7be062d5df09f4cd$var$initialPlacementState);
    const placementMount = (0, $5uXOq.useCallback)(({ placementId: placementId })=>setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: (0, $hHS4t.uniqueArray)([
                    ...state.currentlyMounted,
                    placementId
                ]),
                hasMounted: (0, $hHS4t.uniqueArray)([
                    ...state.hasMounted,
                    placementId
                ])
            }), []);
    const placementUnmount = (0, $5uXOq.useCallback)(({ placementId: placementId })=>setPlacements((state)=>!state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: state.currentlyMounted.filter((e)=>e !== placementId)
            }), []);
    const postOfficeScreenUpdateContext = (0, $5uXOq.useMemo)(()=>({
            placementMount: placementMount,
            placementUnmount: placementUnmount
        }), [
        placementMount,
        placementUnmount
    ]);
    const postOfficeScreenContext = (0, $5uXOq.useMemo)(()=>({
            placements: placements
        }), [
        placements
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7be062d5df09f4cd$var$PostOfficeScreenUpdateContext.Provider, {
        value: postOfficeScreenUpdateContext,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($7be062d5df09f4cd$var$PostOfficeScreenContext.Provider, {
            value: postOfficeScreenContext,
            children: children
        })
    });
};
const $7be062d5df09f4cd$export$f51d04a086368016 = ({ placementId: placementId })=>{
    const { placementMount: placementMount, placementUnmount: placementUnmount } = $7be062d5df09f4cd$export$5d27c0ee02be2a23();
    (0, $5uXOq.useEffect)(()=>{
        if (!placementId) return;
        placementMount({
            placementId: placementId
        });
        return ()=>{
            placementUnmount({
                placementId: placementId
            });
        };
    }, [
        placementId,
        placementMount,
        placementUnmount
    ]);
};

});
parcelRegister("hHS4t", function(module, exports) {

$parcel$export(module.exports, "uniqueArray", () => $e1d243333aeb86d5$export$bbd17ecb0679edd7);
const $e1d243333aeb86d5$export$bbd17ecb0679edd7 = (input)=>Array.from(new Set(input).values());

});




parcelRegister("1ZcCe", function(module, exports) {

$parcel$export(module.exports, "StableRouteProvider", () => $0aa90403cb1ade07$export$ce13d00e696dfc96);

var $2OMIu = parcelRequire("2OMIu");

var $7LKoA = parcelRequire("7LKoA");
var $30kbx = parcelRequire("30kbx");

var $eJvAJ = parcelRequire("eJvAJ");
const $0aa90403cb1ade07$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
    const href = (0, $eJvAJ.useLocationHref)();
    const stableRoute = (0, $30kbx.useStableObject)(route ?? {
        previous: href,
        current: href
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7LKoA.PostOfficeRouteContext).Provider, {
        value: stableRoute,
        children: children
    });
};

});
parcelRegister("7LKoA", function(module, exports) {

$parcel$export(module.exports, "PostOfficeRouteContext", () => $62c318a41c57bfc6$export$f7f47a74e8b47b1f);
$parcel$export(module.exports, "PostOfficeRouteProvider", () => $62c318a41c57bfc6$export$89eadc6b3e5f4e9e);
$parcel$export(module.exports, "usePostOfficeRoute", () => $62c318a41c57bfc6$export$79301b66f7808cd8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8tyNL = parcelRequire("8tyNL");

var $30kbx = parcelRequire("30kbx");
const $62c318a41c57bfc6$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $62c318a41c57bfc6$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
        state = {
            previous: state.current,
            current: next,
            searchParams: routeChange.next?.searchParams
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $62c318a41c57bfc6$var$usePostOfficeRouteStore = ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $8tyNL.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $30kbx.useStableObject)(route);
};
const $62c318a41c57bfc6$var$initialState = {
    previous: undefined,
    current: undefined,
    searchParams: undefined
};
const $62c318a41c57bfc6$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$62c318a41c57bfc6$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined,
        searchParams: initialUrl?.searchParams
    });
const $62c318a41c57bfc6$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $5uXOq.createContext)($62c318a41c57bfc6$var$initialState);
const $62c318a41c57bfc6$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $5uXOq.useRef)();
    if (!ref.current) ref.current = $62c318a41c57bfc6$export$98c77e1bd702ed15(props);
    const route = $62c318a41c57bfc6$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($62c318a41c57bfc6$export$f7f47a74e8b47b1f.Provider, {
        value: route,
        children: children
    });
};
const $62c318a41c57bfc6$export$79301b66f7808cd8 = ()=>(0, $5uXOq.useContext)($62c318a41c57bfc6$export$f7f47a74e8b47b1f); //Route listener

});

parcelRegister("eJvAJ", function(module, exports) {

$parcel$export(module.exports, "useLocationHref", () => $d8419c244aee9b70$export$49fc3f3d8c7f99);
const $d8419c244aee9b70$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
const $d8419c244aee9b70$export$49fc3f3d8c7f99 = ()=>{
    return $d8419c244aee9b70$var$isLocationAvailable() ? globalThis.location.href : undefined;
};

});



parcelRegister("4UTPF", function(module, exports) {

$parcel$export(module.exports, "withErrorBoundary", () => $e3df8a0c98fba3f5$export$f0c7a449e0cfaec7);

var $2OMIu = parcelRequire("2OMIu");


var $ddiyw = parcelRequire("ddiyw");

var $exWMY = parcelRequire("exWMY");
const $e3df8a0c98fba3f5$export$f0c7a449e0cfaec7 = (Component)=>({ errorBoundaryLocation: errorBoundaryLocation, fallbackRender: fallbackRender, onError: onError, ...data })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ddiyw.useFirePostOfficeAnalyticsEvents)();
        const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                if (onError) onError(error, info);
                fireAnalyticsEvent({
                    eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
                    action: 'caughtError',
                    actionSubject: 'PostOfficeErrorBoundary',
                    actionSubjectId: additionalAnalytics.errorBoundaryLocation
                }, {
                    error: error,
                    info: info
                });
            };
        const internalFallbackRender = (FallbackRender)=>(props)=>{
                if (FallbackRender) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - Confluence Local Consumption - 'FallbackRender' cannot be used as a JSX component. Its return type 'ReactNode' is not a valid JSX element. Type 'undefined' is not assignable to type 'Element | null'.
                return /*#__PURE__*/ (0, $2OMIu.jsx)(FallbackRender, {
                    ...props
                });
                return null;
            };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $exWMY.ErrorBoundary), {
            fallbackRender: internalFallbackRender(fallbackRender),
            onError: internalOnError({
                errorBoundaryLocation: errorBoundaryLocation
            }, onError),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...data
            })
        });
    };

});
parcelRegister("exWMY", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $a971bfffb2c22071$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
'use client';
const $a971bfffb2c22071$export$b16d9fb1a22de840 = (0, $5uXOq.createContext)(null);
const $a971bfffb2c22071$var$initialState = {
    didCatch: false,
    error: null
};
class $a971bfffb2c22071$export$e926676385687eaf extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $a971bfffb2c22071$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($a971bfffb2c22071$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $a971bfffb2c22071$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($a971bfffb2c22071$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $5uXOq.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $5uXOq.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $5uXOq.createElement)($a971bfffb2c22071$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $a971bfffb2c22071$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $a971bfffb2c22071$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $a971bfffb2c22071$export$c052f6604b7d51fe() {
    const context = (0, $5uXOq.useContext)($a971bfffb2c22071$export$b16d9fb1a22de840);
    $a971bfffb2c22071$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $5uXOq.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $5uXOq.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $a971bfffb2c22071$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $5uXOq.forwardRef)((props, ref)=>(0, $5uXOq.createElement)($a971bfffb2c22071$export$e926676385687eaf, errorBoundaryProps, (0, $5uXOq.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});




parcelRegister("kZgxR", function(module, exports) {

$parcel$export(module.exports, "useInitialData", () => $adf556fc63dea129$export$5523c5f3222291d0);

var $5uXOq = parcelRequire("5uXOq");

var $02EmO = parcelRequire("02EmO");
const $adf556fc63dea129$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $5uXOq.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $02EmO.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};

});
parcelRegister("02EmO", function(module, exports) {

$parcel$export(module.exports, "AlreadyRunningError", () => $ca4bafb6eca4235c$export$8c5224d3af2f3c8b);
$parcel$export(module.exports, "useData", () => $ca4bafb6eca4235c$export$c1cf1cf4c5d51937);

var $ddiyw = parcelRequire("ddiyw");

var $lzG7s = parcelRequire("lzG7s");

var $5uXOq = parcelRequire("5uXOq");

var $hMtay = parcelRequire("hMtay");
class $ca4bafb6eca4235c$export$8c5224d3af2f3c8b extends Error {
    constructor(){
        super('Request is already running.');
        this.name = 'AlreadyRunningError';
    }
}
const $ca4bafb6eca4235c$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
    const [state, setState] = (0, $5uXOq.useState)((0, $hMtay.toLoading)());
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ddiyw.useFirePostOfficeAnalyticsEvents)();
    const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
        name: 'unknown'
    };
    (0, $5uXOq.useEffect)(()=>{
        if (typeof promiseToResolve !== 'function') return;
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        promiseToResolve({
            signal: signal
        })?.then((0, $hMtay.assertResponseIsOk)).then((res)=>res.json()).then((data)=>{
            setState((0, $hMtay.toData)(data));
            fireAnalyticsEvent({
                action: 'resolved',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, $lzG7s.camelCase)(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes
                }
            });
        }).catch((err)=>{
            if (err instanceof $ca4bafb6eca4235c$export$8c5224d3af2f3c8b || signal.aborted) return;
            const errorState = (0, $hMtay.toError)(err);
            fireAnalyticsEvent({
                action: 'rejected',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, $lzG7s.camelCase)(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes,
                    errorName: errorState.error.name ?? 'unknown',
                    errorMessage: errorState.error.message ?? 'unknown'
                }
            });
            setState(errorState);
        });
        return ()=>{
            abortController.abort();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promiseToResolve
    ]);
    return state;
};

});
parcelRegister("lzG7s", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("hMtay", function(module, exports) {

$parcel$export(module.exports, "assertResponseIsOk", () => $cfed604ac54edf35$export$b3732c8ff6f9c463);
$parcel$export(module.exports, "toLoading", () => $cfed604ac54edf35$export$f9a5bd0ffba29ffc);
$parcel$export(module.exports, "toError", () => $cfed604ac54edf35$export$cc3b967c039ed3e7);
$parcel$export(module.exports, "toData", () => $cfed604ac54edf35$export$24a6b176bdc41ce5);
const $cfed604ac54edf35$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $cfed604ac54edf35$export$b3732c8ff6f9c463 = (res)=>{
    if (res.ok) return res;
    throw new Error($cfed604ac54edf35$export$18a0019e5439b209(res));
};
const $cfed604ac54edf35$export$f9a5bd0ffba29ffc = ()=>({
        isLoading: true,
        data: undefined,
        error: undefined
    });
const $cfed604ac54edf35$export$cc3b967c039ed3e7 = (error)=>({
        isLoading: false,
        error: error instanceof Error ? error : Error(String(error)),
        data: undefined
    });
const $cfed604ac54edf35$export$24a6b176bdc41ce5 = (data)=>({
        isLoading: false,
        error: undefined,
        data: data
    });

});



parcelRegister("3jWUH", function(module, exports) {

$parcel$export(module.exports, "MessageRenderer", () => $23c009709fc6cc3c$export$2df1250b8f917a59);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $aMNd8 = parcelRequire("aMNd8");

var $2QibG = parcelRequire("2QibG");

var $1ZJzi = parcelRequire("1ZJzi");
const $23c009709fc6cc3c$export$e30378e28ad3e6ab = {
    ...(0, $2QibG.default),
    ...(0, $1ZJzi.default)
};
const { initializeMessageRenderer: $23c009709fc6cc3c$export$bce4e5106d86e473, MessageRenderer: $23c009709fc6cc3c$export$2df1250b8f917a59 } = (0, $aMNd8.asMessageRenderer)($23c009709fc6cc3c$export$e30378e28ad3e6ab);

});
parcelRegister("aMNd8", function(module, exports) {

$parcel$export(module.exports, "asMessageRenderer", () => $3aefc0bbdbf1eed1$export$7b7e5a348ef9a7c1);
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $2OMIu = parcelRequire("2OMIu");

var $96Irh = parcelRequire("96Irh");

var $30kbx = parcelRequire("30kbx");

var $55GjK = parcelRequire("55GjK");
var $jeAWE = parcelRequire("jeAWE");

var $iSjjB = parcelRequire("iSjjB");

var $eFcnR = parcelRequire("eFcnR");

var $g9Rt9 = parcelRequire("g9Rt9");
var $cxwD2 = parcelRequire("cxwD2");
var $f7sfm = parcelRequire("f7sfm");
var $2x1bx = parcelRequire("2x1bx");
var $4UTPF = parcelRequire("4UTPF");

var $6NLx9 = parcelRequire("6NLx9");

var $5uXOq = parcelRequire("5uXOq");

var $7hNKr = parcelRequire("7hNKr");
const $3aefc0bbdbf1eed1$var$STABLE_EMPTY_OBJECT = {};
const $3aefc0bbdbf1eed1$export$9750eb54d7c7e789 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        ...props,
        children: children
    });
};
const $3aefc0bbdbf1eed1$export$7b7e5a348ef9a7c1 = (messageComponents, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return /*#__PURE__*/ (0, $5uXOq.memo)(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, SuspenseBoundary: SuspenseBoundary = (0, $5uXOq.Suspense), ...data })=>{
            const isUFOEnabled = (0, $96Irh.default).checkGate('enable_ufo_tracking_in_post_office');
            const recommendationSessionStable = (0, $30kbx.useStableObject)(recommendationSession ?? $3aefc0bbdbf1eed1$var$STABLE_EMPTY_OBJECT);
            const postOfficeStable = (0, $30kbx.useStableObject)(postOffice ?? $3aefc0bbdbf1eed1$var$STABLE_EMPTY_OBJECT);
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $5uXOq.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $55GjK.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2x1bx.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $5uXOq.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $iSjjB.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $iSjjB.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $5uXOq.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jeAWE.UFOv2).UFOLoadHold, {
                        name: (0, $jeAWE.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                        children: loadingFallback ?? null
                    }), [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                const componentPropsStable = (0, $30kbx.useStableObject)(componentProps);
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                return (0, $96Irh.default).checkGate('po-refactor-message-renderer-provider') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f7sfm.MessageRendererProvider), {
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    recommendationSession: recommendationSessionStable === $3aefc0bbdbf1eed1$var$STABLE_EMPTY_OBJECT ? undefined : recommendationSessionStable,
                    messageSuccessComponent: messageSuccessComponent,
                    componentProps: componentPropsStable,
                    loadingFallback: loadingFallback,
                    triggerId: triggerId,
                    messageCreationType: messageCreationType,
                    postOffice: postOfficeStable,
                    isUFOEnabled: isUFOEnabled,
                    SuspenseBoundary: SuspenseBoundary,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                        ...componentProps
                    })
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7hNKr.ChoreographerWrapper), {
                    messageId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g9Rt9.FeatureFlaggedUfoWrapper), {
                        messageTemplateId: messageTemplateId,
                        isEnabled: isUFOEnabled,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eFcnR.MessageContextProvider), {
                            value: {
                                messageInstanceId: messageInstanceId,
                                messageTemplateId: messageTemplateId,
                                triggerId: triggerId,
                                messageCreationType: messageCreationType,
                                transactionAccountId: componentProps.transactionAccountId,
                                analyticsDetails: postOffice?.analyticsDetails
                            },
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6NLx9.RecommendationProvider), {
                                value: recommendationSession ?? {},
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)(SuspenseBoundary, {
                                    fallback: loadingComponent,
                                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cxwD2.MessageAnalyticsContextProvider), {
                                        children: [
                                            messageSuccessComponent,
                                            /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                                                ...componentProps
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                });
            };
            return (0, $4UTPF.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        });
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};

});
parcelRegister("55GjK", function(module, exports) {

$parcel$export(module.exports, "UFOv1", () => $2204ea052ae660ad$export$96236906ebaa7f87);

var $hhWKz = parcelRequire("hhWKz");

var $fhKaW = parcelRequire("fhKaW");
const $2204ea052ae660ad$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $hhWKz.MessagePerformanceTracker,
    PlacementPerformanceTracker: $fhKaW.PlacementPerformanceTracker
};

});
parcelRegister("hhWKz", function(module, exports) {

$parcel$export(module.exports, "MessagePerformanceTracker", () => $2258f83a04d7be92$export$ae5c73c7c4f454e6);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $5WtaI = parcelRequire("5WtaI");
class $2258f83a04d7be92$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $kkzI0.UFOExperience)((0, $5WtaI.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $lrUJ4.ExperienceTypes).Load,
            platform: {
                component: (0, $5WtaI.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $kkzI0.UFOExperience)(`${(0, $5WtaI.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $lrUJ4.ExperienceTypes).Load,
            platform: {
                component: (0, $5WtaI.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}

});
parcelRegister("5WtaI", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceNames", () => $206558bbfd4f706c$export$cc7ddf8ca628f6f1);
$parcel$export(module.exports, "POST_OFFICE_PLATFORM_NAME", () => $206558bbfd4f706c$export$6d482cfa20c9d220);
const $206558bbfd4f706c$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $206558bbfd4f706c$export$6d482cfa20c9d220 = 'post-office';

});


parcelRegister("fhKaW", function(module, exports) {

$parcel$export(module.exports, "PlacementPerformanceTracker", () => $cacbb6066396be7c$export$8b48c2105ba0b35a);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $5WtaI = parcelRequire("5WtaI");
const $cacbb6066396be7c$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $cacbb6066396be7c$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $lrUJ4.ExperienceTypes).Load,
    platform: {
        component: (0, $5WtaI.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$cacbb6066396be7c$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$cacbb6066396be7c$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$cacbb6066396be7c$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$cacbb6066396be7c$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$cacbb6066396be7c$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$cacbb6066396be7c$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$cacbb6066396be7c$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$cacbb6066396be7c$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $cacbb6066396be7c$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$cacbb6066396be7c$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$cacbb6066396be7c$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$cacbb6066396be7c$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $cacbb6066396be7c$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $cacbb6066396be7c$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$cacbb6066396be7c$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $cacbb6066396be7c$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $kkzI0.UFOExperience)((0, $5WtaI.UFOExperienceNames).PLACEMENT, $cacbb6066396be7c$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $kkzI0.UFOExperience)(`${(0, $5WtaI.UFOExperienceNames).PLACEMENT}.${placementId}`, $cacbb6066396be7c$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}

});


parcelRegister("iSjjB", function(module, exports) {

$parcel$export(module.exports, "InvalidMessageTemplateIdError", () => $3023577c52e62572$export$19cb89dd679394cb);
$parcel$export(module.exports, "MessageRendererEmptyValidationResponseError", () => $3023577c52e62572$export$3dfc27a8d3942f4d);
var $3023577c52e62572$export$b9722560029694e7 = /*#__PURE__*/ function(PostOfficeErrorCodes) {
    PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
    PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
    PostOfficeErrorCodes["NotAbleToProcessEmailTemplateError"] = "NotAbleToProcessEmailTemplateError";
    PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
    PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
    PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
    PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
    PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
    PostOfficeErrorCodes["HandlerValidationError"] = "HandlerValidationError";
    PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
    PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
    PostOfficeErrorCodes["JourneyNotFoundError"] = "JourneyNotFoundError";
    PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
    PostOfficeErrorCodes["MessageTemplateActionValidationError"] = "MessageTemplateActionValidationError";
    PostOfficeErrorCodes["MessageTemplateActionHandlerTimeoutError"] = "MessageTemplateActionHandlerTimeoutError";
    PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
    PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
    PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
    PostOfficeErrorCodes["DigestEngineFailedSendError"] = "DigestEngineFailedSendError";
    PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
    PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
    PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
    PostOfficeErrorCodes["UnsupportedEmailError"] = "UnsupportedEmailError";
    PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
    PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
    PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
    PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
    PostOfficeErrorCodes["AllMessagesFailureHydrationAtPlacementError"] = "AllMessagesFailureHydrationAtPlacementError";
    PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
    PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
    PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
    PostOfficeErrorCodes["RichRecipientError"] = "RichRecipientError";
    PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
    PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
    PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
    PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
    PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
    PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
    PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    PostOfficeErrorCodes["HydrationDeliveryNoDataFoundError"] = "HydrationDeliveryNoDataFoundError";
    PostOfficeErrorCodes["PlacementMessageError"] = "PlacementMessageError";
    PostOfficeErrorCodes["PlacementError"] = "PlacementError";
    PostOfficeErrorCodes["PlacementSystemError"] = "PlacementSystemError";
    PostOfficeErrorCodes["PlacementRuntimeError"] = "PlacementRuntimeError";
    PostOfficeErrorCodes["PlacementMiddlewareError"] = "PlacementMiddlewareError";
    PostOfficeErrorCodes["SendOutNotFoundError"] = "SendOutNotFoundError";
    PostOfficeErrorCodes["SendOutUpdateForbiddenError"] = "SendOutUpdateForbiddenError";
    PostOfficeErrorCodes["SendOutUserStatusTransitionForbiddenError"] = "SendOutUserStatusTransitionForbiddenError";
    PostOfficeErrorCodes["SendOutValidationError"] = "SendOutValidationError";
    PostOfficeErrorCodes["SendOutFailedToInitiateApprovalRequest"] = "SendOutFailedToInitiateApprovalRequest";
    PostOfficeErrorCodes["MessageTemplateError"] = "MessageTemplateError";
    return PostOfficeErrorCodes;
}({});
class $3023577c52e62572$export$46f86d28cd0a5d38 extends Error {
}
class $3023577c52e62572$export$627bc00a5ef5f6ae extends Error {
}
class $3023577c52e62572$export$d145ea5319863172 extends Error {
    constructor(message, code, cause){
        super(message, {
            cause: cause
        }), this.code = code;
    }
}
function $3023577c52e62572$export$4cb1ea6034a33155(error) {
    return typeof error === 'object' && !!error && 'status' in error && typeof error.status === 'number';
}
function $3023577c52e62572$export$aed524b0009b5631(error) {
    return typeof error === 'object' && !!error && 'logLevel' in error && typeof error.logLevel === 'string';
}
class $3023577c52e62572$export$ed601cd0dc1a1be7 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(args){
        super('Error in message template code', "MessageTemplateError", args.cause);
        this.name = this.constructor.name;
        this.messageTemplateId = args.messageTemplateId;
        this.triggerId = args.triggerId;
        this.function = args.function;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$8d39b103586e9fd4 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message){
        super(message, "NotAbleToProcessEmailTemplateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$f649da38897d27f7 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$c2852c1c4d9aba3e extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionProcessingError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$4b7b4e09547e4bb3 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionMethodInvocationError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$360a094a97597d87 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message){
        super(message, "RecipientExpansionManagerError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$4d068b43eb55165b extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$ac007ee150add337 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message){
        super(message, "ReceiverInputValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$b79ba63f8ae791e0 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message){
        super(message, "HandlerValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$19cb89dd679394cb extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message){
        super(message, "InvalidMessageTemplateIdError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$78651662ad470cc5 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(){
        super('Message Template not found', "MessageTemplateNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$8a5041670cdd8db2 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(){
        super('Journey not found', "JourneyNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$1240ddc25cf964e6 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(){
        super('Message Template action handler validation error', "MessageTemplateActionValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$3c4884b7ae7fe517 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(timeoutInSeconds = 5){
        super(`Message Template action handler timed out after ${timeoutInSeconds} seconds`, "MessageTemplateActionHandlerTimeoutError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$913b8e68dc7ae8fe extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(){
        super('Placement not found', "PlacementNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$3dfc27a8d3942f4d extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(){
        super('Message Renderer received empty response from validator', "MessageRendererEmptyValidationResponseError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$e5ccdf8bbfead7a2 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "IngestionHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$823733742d803ae6 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "OrchestrationHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$1caa32527f23acd2 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(errorCause){
        super('Failed to send digest event to orchestration queue', "DigestEngineFailedSendError");
        this.name = this.constructor.name;
        this.errorCause = errorCause;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$a6f2aad8fa094b39 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(accountId){
        super('Unable to get user details for the given account ID', "UnableToGetUserDetailsError"), this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$2f1e27130c2bf271 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message, payloadSize){
        super(message, "InvalidPayloadError");
        this.name = this.constructor.name;
        this.payloadSize = payloadSize;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$d0dc094613469f2b extends $3023577c52e62572$export$46f86d28cd0a5d38 {
    constructor(message, workspaceId){
        super(message);
        this.name = this.constructor.name;
        this.workspaceId = workspaceId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$5603eab37ce562f5 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(fileType){
        super('The attachment file is not supported', "UnsupportedAttachmentType");
        this.name = this.constructor.name;
        this.fileType = fileType;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$b35ca1cf49054efc extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message, email){
        super(message, "UnsupportedEmailError");
        this.name = this.constructor.name;
        this.email = email;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$e0e9aa0e9c6b37ff extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message, error){
        super(message, "InvalidEmailRequestHeader");
        this.name = this.constructor.name;
        this.error = error;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$3ad818f64601e141 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message){
        super(message, "NonProdEmailDomainError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$25470bb6cba4fba0 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
        super('messageTemplateId not supported by placement', "UnsupportedMessageAtPlacementError");
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$ce14d445679448b6 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(error, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
        super(error?.message ?? 'unknown error', "HydrationFailureAtPlacementError");
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.messageInstanceId = messageInstanceId;
        this.placementId = placementId;
        this.stack = error?.stack;
    }
}
class $3023577c52e62572$export$c9a26a17db1045c8 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor({ placementId: placementId }){
        super('All messages failed at placement', "AllMessagesFailureHydrationAtPlacementError");
        this.name = this.constructor.name;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$8ab4fb362168b928 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(){
        super('Unexpected invocation of validate() function for push delivery channel', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$2afd69f57fe5285f extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(){
        super('Recipient expander not found for mapper', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$7635d2b1a281d626 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message, errors){
        super(message, "GrowthRecRecommendationsError");
        this.errors = errors;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$9e1c6d00e675bc86 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message, recipient){
        super(message, "RichRecipientError");
        this.name = this.constructor.name;
        this.recipient = recipient;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$90bef7fa95eca3fa extends Error {
    constructor(status){
        super('Posting Mobile Notifications message failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$6d1a4929f6ff1a32 extends $3023577c52e62572$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$89bf5f64fbf0698 extends $3023577c52e62572$export$46f86d28cd0a5d38 {
    constructor(message, error){
        super(message, {
            ...error ? {
                cause: error
            } : {}
        }), this.error = error;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$c19fc5e8aa4e064d extends Error {
    constructor(){
        super('Ingestion source is required when custom profile is specified');
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$2d3a68dab93b8cc4 extends Error {
    constructor(){
        super('A renderRedacted function is required when redactionLevel is set to a non-null value');
        this.name = this.constructor.name;
    }
}
class $3023577c52e62572$export$175c1dbb0d7c238a extends Error {
    constructor(status){
        super('Enqueueing email failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$23fab744b3076342 extends Error {
    constructor(message, status){
        super(message), this.message = message, this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$194adecfa0265ea1 extends Error {
    constructor(msg, messageInstanceId, error){
        super(msg);
        this.msg = msg;
        this.messageInstanceId = messageInstanceId;
        if (error instanceof Error) this.stack = error.stack;
        else Error.captureStackTrace(this, this.constructor);
        this.name = this.constructor.name;
    }
}
class $3023577c52e62572$export$c504492f06c975b5 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor({ ipmNumber: ipmNumber, variantFromStatsig: variantFromStatsig, contentfulLocale: contentfulLocale }){
        super('hydrate delivery marketing-screen-space-flag-contentful-usecase No data found for the user', "HydrationDeliveryNoDataFoundError");
        this.name = this.constructor.name;
        this.ipmNumber = ipmNumber;
        this.variantFromStatsig = variantFromStatsig;
        this.contentfulLocale = contentfulLocale;
        Error.captureStackTrace(this, this.constructor);
    }
}

});

parcelRegister("eFcnR", function(module, exports) {

$parcel$export(module.exports, "MessageContextProvider", () => $f3127689662c06ba$export$42de33f7652dc3de);
$parcel$export(module.exports, "useMessageContext", () => $f3127689662c06ba$export$a5b6d14a2e25725a);

var $5uXOq = parcelRequire("5uXOq");
const $f3127689662c06ba$var$initialValue = {};
const $f3127689662c06ba$export$b060d577040138d8 = (0, $5uXOq.createContext)($f3127689662c06ba$var$initialValue);
const $f3127689662c06ba$export$42de33f7652dc3de = $f3127689662c06ba$export$b060d577040138d8.Provider;
const $f3127689662c06ba$export$a5b6d14a2e25725a = ()=>(0, $5uXOq.useContext)($f3127689662c06ba$export$b060d577040138d8);

});

parcelRegister("g9Rt9", function(module, exports) {

$parcel$export(module.exports, "FeatureFlaggedUfoWrapper", () => $b0f548f7f0e4c1bf$export$8e6fb7035018b3e4);

var $2OMIu = parcelRequire("2OMIu");

var $jeAWE = parcelRequire("jeAWE");
const $b0f548f7f0e4c1bf$export$8e6fb7035018b3e4 = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jeAWE.UFOv2).UFOSegment, {
        name: (0, $jeAWE.UFOv2).SegmentNames.MESSAGE,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jeAWE.UFOv2).UFOSegment, {
            name: `${(0, $jeAWE.UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});

parcelRegister("cxwD2", function(module, exports) {

$parcel$export(module.exports, "MessageAnalyticsContextProvider", () => $2e3fcdbae78acb99$export$1737ab199e83455e);
$parcel$export(module.exports, "useMessageAnalyticsContext", () => $2e3fcdbae78acb99$export$bb426ba114b64992);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $2e3fcdbae78acb99$var$defaultMessageAnalyticsContextValue = {
    fireMessageViewedInMessageComponent: null,
    setFireMessageViewedInMessageComponent: ()=>{}
};
const $2e3fcdbae78acb99$export$c81717973c6c4a90 = /*#__PURE__*/ (0, $5uXOq.createContext)($2e3fcdbae78acb99$var$defaultMessageAnalyticsContextValue);
const $2e3fcdbae78acb99$export$1737ab199e83455e = ({ children: children })=>{
    const fireMessageViewedInMessageComponent = (0, $5uXOq.useRef)(false);
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent,
            setFireMessageViewedInMessageComponent: (value)=>{
                fireMessageViewedInMessageComponent.current = value;
            }
        }), [
        fireMessageViewedInMessageComponent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2e3fcdbae78acb99$export$c81717973c6c4a90.Provider, {
        value: contextValue,
        children: children
    });
};
const $2e3fcdbae78acb99$export$bb426ba114b64992 = ()=>(0, $5uXOq.useContext)($2e3fcdbae78acb99$export$c81717973c6c4a90);

});

parcelRegister("f7sfm", function(module, exports) {

$parcel$export(module.exports, "MessageRendererProvider", () => $1eaf097979fe8fef$export$5fe06fe68913d493);

var $2OMIu = parcelRequire("2OMIu");

var $jeAWE = parcelRequire("jeAWE");

var $eFcnR = parcelRequire("eFcnR");

var $6NLx9 = parcelRequire("6NLx9");

var $5uXOq = parcelRequire("5uXOq");

var $cFgHJ = parcelRequire("cFgHJ");

var $g9Rt9 = parcelRequire("g9Rt9");

var $cxwD2 = parcelRequire("cxwD2");
const $1eaf097979fe8fef$var$DEFAULT_RECOMMENDATION_SESSION = {};
const $1eaf097979fe8fef$export$5fe06fe68913d493 = ({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, recommendationSession: recommendationSession, messageSuccessComponent: messageSuccessComponent, componentProps: componentProps, loadingFallback: loadingFallback, triggerId: triggerId, messageCreationType: messageCreationType, postOffice: postOffice, isUFOEnabled: isUFOEnabled, children: children, SuspenseBoundary: SuspenseBoundary = (0, $5uXOq.Suspense) })=>{
    const loadingComponent = (0, $5uXOq.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jeAWE.UFOv2).UFOLoadHold, {
            name: (0, $jeAWE.UFOv2).HoldNames.MESSAGE,
            children: loadingFallback ?? null
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: loadingFallback ?? null
        }), [
        loadingFallback,
        isUFOEnabled
    ]);
    const messageContextMemo = (0, $5uXOq.useMemo)(()=>({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            componentProps: componentProps,
            postOffice: postOffice
        }), [
        messageInstanceId,
        messageTemplateId,
        triggerId,
        messageCreationType,
        componentProps,
        postOffice
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFgHJ.ChoreographerWrapper), {
        messageId: messageInstanceId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g9Rt9.FeatureFlaggedUfoWrapper), {
            messageTemplateId: messageTemplateId,
            isEnabled: isUFOEnabled,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eFcnR.MessageContextProvider), {
                value: messageContextMemo,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6NLx9.RecommendationProvider), {
                    value: recommendationSession ?? $1eaf097979fe8fef$var$DEFAULT_RECOMMENDATION_SESSION,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(SuspenseBoundary, {
                        fallback: loadingComponent,
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cxwD2.MessageAnalyticsContextProvider), {
                            children: [
                                messageSuccessComponent,
                                children
                            ]
                        })
                    })
                })
            })
        })
    });
};

});
parcelRegister("6NLx9", function(module, exports) {

$parcel$export(module.exports, "RecommendationProvider", () => $3c770c90c429215d$export$f60e87d7b5f59562);
$parcel$export(module.exports, "useRecommendationContext", () => $3c770c90c429215d$export$3321c0b02f750bcc);

var $2OMIu = parcelRequire("2OMIu");

var $htBRZ = parcelRequire("htBRZ");

var $5uXOq = parcelRequire("5uXOq");
const $3c770c90c429215d$export$ba2f44035effd9c1 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    sessionId: undefined,
    entityId: undefined
});
const $3c770c90c429215d$export$f60e87d7b5f59562 = ({ value: value, children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3c770c90c429215d$export$ba2f44035effd9c1.Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
            data: value,
            children: children
        })
    });
};
const $3c770c90c429215d$export$3321c0b02f750bcc = ()=>(0, $5uXOq.useContext)($3c770c90c429215d$export$ba2f44035effd9c1);

});

parcelRegister("cFgHJ", function(module, exports) {

$parcel$export(module.exports, "ChoreographerWrapper", () => $3a4569dcbed80977$export$8db7ba034addcd65);

var $2OMIu = parcelRequire("2OMIu");

var $96Irh = parcelRequire("96Irh");

var $ddiyw = parcelRequire("ddiyw");

var $5uXOq = parcelRequire("5uXOq");

var $1z7k9 = parcelRequire("1z7k9");
const $3a4569dcbed80977$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
    return null;
};
const $3a4569dcbed80977$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $1z7k9.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ddiyw.useFirePostOfficeAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $96Irh.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $96Irh.default).checkGate('enable_choreographed_post_office_messages');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) return /*#__PURE__*/ (0, $2OMIu.jsx)($3a4569dcbed80977$var$ChoreographedComponent, {
            choreographerFactory: factory,
            messageId: messageId,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});


parcelRegister("7hNKr", function(module, exports) {

$parcel$export(module.exports, "ChoreographerWrapper", () => $cc7e963dbb2f5717$export$8db7ba034addcd65);

var $2OMIu = parcelRequire("2OMIu");

var $96Irh = parcelRequire("96Irh");

var $ddiyw = parcelRequire("ddiyw");

var $1z7k9 = parcelRequire("1z7k9");

var $5uXOq = parcelRequire("5uXOq");
const $cc7e963dbb2f5717$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
    return null;
};
const $cc7e963dbb2f5717$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $1z7k9.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ddiyw.useFirePostOfficeAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $96Irh.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $96Irh.default).checkGate('enable_choreographed_post_office_messages');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) return /*#__PURE__*/ (0, $2OMIu.jsx)($cc7e963dbb2f5717$var$ChoreographedComponent, {
            choreographerFactory: factory,
            messageId: messageId,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});


parcelRegister("2QibG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2894dd7ac6292bc$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $2M3II = parcelRequire("2M3II");
var $d2894dd7ac6292bc$export$2e2bcd8739ae039 = {
    'jira-ipm-issue-to-work-top-banner': (0, $2M3II.default)
};

});
parcelRegister("2M3II", function(module, exports) {

$parcel$export(module.exports, "default", () => $0516b5ae51f4bed0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $4hBFe = parcelRequire("4hBFe");

var $8RbeD = parcelRequire("8RbeD");
const $0516b5ae51f4bed0$export$b3890eb0ae9dca99 = (0, $8RbeD.createRender)(({ messageInstanceId: messageInstanceId, readMoreLink: readMoreLink })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4hBFe.TopBannerMessage), {
        readMoreLink: readMoreLink,
        messageInstanceId: messageInstanceId
    }));
var $0516b5ae51f4bed0$export$2e2bcd8739ae039 = $0516b5ae51f4bed0$export$b3890eb0ae9dca99;

});
parcelRegister("4hBFe", function(module, exports) {

$parcel$export(module.exports, "TopBannerMessage", () => $0a91de91d76e9721$export$71f678cc6412ce95);

var $2OMIu = parcelRequire("2OMIu");

var $eh9vz = parcelRequire("eh9vz");

var $gHU1R = parcelRequire("gHU1R");
var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $gVM6m = parcelRequire("gVM6m");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $aAASp = parcelRequire("aAASp");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
const $0a91de91d76e9721$var$pressableStyles = (0, $2s57o.xcss)({
    color: 'color.text.inverse',
    cursor: 'pointer',
    textDecoration: 'underline',
    ':hover': {
        color: 'color.text.inverse',
        textDecoration: 'underline'
    },
    ':active': {
        textDecoration: 'none'
    }
});
const $0a91de91d76e9721$var$ComingSoonMessage = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        id: "post-office.placement.jira-top-banner.primary-message",
        description: "Coming soon message for the Jira top banner",
        defaultMessage: "As we roll out 'work' as the new term for items tracked in Jira, you may still see 'issue' in some areas."
    });
const $0a91de91d76e9721$var$ReadMoreLink = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $gHU1R.default), {
        href: "https://community.atlassian.com/t5/Jira-articles/It-s-here-Work-is-the-new-collective-term-for-all-items-you/ba-p/2954892",
        rel: "noopener noreferrer",
        target: "_blank",
        xcss: $0a91de91d76e9721$var$pressableStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "st-office.placement.jira-top-banner.primary-cta-text",
            description: "Read more link for the Jira top banner",
            defaultMessage: "Read about this terminology change"
        })
    });
const $0a91de91d76e9721$export$71f678cc6412ce95 = ({ messageInstanceId: messageInstanceId })=>{
    const { dismissMessageFromPlacement: dismissMessageFromPlacement } = (0, $aAASp.useMessagePlacementHooks)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
        backgroundColor: "color.background.neutral.bold",
        padding: "space.200",
        testId: "jira-top-banner",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2Eqc8.default), {
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6eFvr.default), {
                    color: "color.text.inverse",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)($0a91de91d76e9721$var$ComingSoonMessage, {}),
                        "\xa0",
                        /*#__PURE__*/ (0, $2OMIu.jsx)($0a91de91d76e9721$var$ReadMoreLink, {})
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gVM6m.default), {
                    backgroundColor: "color.background.neutral.bold",
                    onClick: ()=>dismissMessageFromPlacement({
                            messageInstanceId: messageInstanceId
                        }),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eh9vz))), {
                        color: "var(--ds-text-inverse, #FFFFFF)",
                        label: "Dismiss"
                    })
                })
            ]
        })
    });
};

});

parcelRegister("8RbeD", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $4a480270135c198a$export$78c758434c34d601);

var $6ifjo = parcelRequire("6ifjo");
const { createRender: $4a480270135c198a$export$78c758434c34d601, createValidate: $4a480270135c198a$export$2859a83e4d6da57d } = (0, $6ifjo.createClientPipeline)();
const { createHydrate: $4a480270135c198a$export$c905bc718befd59b, createHydrateExample: $4a480270135c198a$export$1f41223e5b0a6622, createTransformMetadata: $4a480270135c198a$export$88fe13b4d13f8423 } = (0, $6ifjo.createServerPipeline)();

});
parcelRegister("6ifjo", function(module, exports) {

$parcel$export(module.exports, "createServerPipeline", () => $91375a40b26a6041$export$b8fedcd4634de5cd);
$parcel$export(module.exports, "createClientPipeline", () => $91375a40b26a6041$export$7d57dbe7f7617174);

var $2OMIu = parcelRequire("2OMIu");

var $j7YDj = parcelRequire("j7YDj");
const $91375a40b26a6041$export$7693b71d48f1bf7e = ()=>(render)=>(renderProps)=>{
            const rendered = render(renderProps);
            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j7YDj.MessageViewed), {}),
                    rendered
                ]
            });
        };
const $91375a40b26a6041$export$b4a84c754a962eee = ()=>(transformMetadata)=>(params)=>transformMetadata(params);
const $91375a40b26a6041$export$62864968b8b09cdf = ()=>(hydrate)=>(requestContext, placementContext, messageContext)=>hydrate(requestContext, placementContext, messageContext);
const $91375a40b26a6041$var$exampleHydrator = (hydrateExample, config)=>(_requestContext, placementContext, messageContext)=>{
        const _config = config;
        return {
            ...hydrateExample({
                ..._config?.requestContext ?? {}
            }, placementContext, messageContext),
            ..._config?.additionalRenderProps ?? {}
        };
    };
const $91375a40b26a6041$export$803c53721d530406 = ()=>(hydrateExample, config)=>$91375a40b26a6041$var$exampleHydrator(hydrateExample, config);
const $91375a40b26a6041$var$initializeValidate = ()=>(validate)=>(apiResponse)=>{
            try {
                validate(apiResponse);
            } catch (error) {
                throw error instanceof Error ? error : new Error(typeof error === 'string' ? error : 'Unknown validation error');
            }
            return apiResponse;
        };
const $91375a40b26a6041$export$b8fedcd4634de5cd = ()=>({
        createHydrate: $91375a40b26a6041$export$62864968b8b09cdf(),
        createHydrateExample: $91375a40b26a6041$export$803c53721d530406(),
        createTransformMetadata: $91375a40b26a6041$export$b4a84c754a962eee()
    });
const $91375a40b26a6041$export$7d57dbe7f7617174 = ()=>({
        createValidate: $91375a40b26a6041$var$initializeValidate(),
        createRender: $91375a40b26a6041$export$7693b71d48f1bf7e()
    });

});
parcelRegister("j7YDj", function(module, exports) {

$parcel$export(module.exports, "ManualMessageViewedEvent", () => $0279287873867410$export$de534803cb07dfcc);
$parcel$export(module.exports, "MessageViewed", () => $0279287873867410$export$14fe1fc3395b6e3f);

var $2OMIu = parcelRequire("2OMIu");

var $bpU8k = parcelRequire("bpU8k");

var $lFpSS = parcelRequire("lFpSS");

var $5uXOq = parcelRequire("5uXOq");

var $huaDn = parcelRequire("huaDn");

var $cxwD2 = parcelRequire("cxwD2");

var $2x1bx = parcelRequire("2x1bx");
const $0279287873867410$export$de534803cb07dfcc = ({ children: children })=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent, setFireMessageViewedInMessageComponent: setFireMessageViewedInMessageComponent } = (0, $cxwD2.useMessageAnalyticsContext)();
    if (fireMessageViewedInMessageComponent) setFireMessageViewedInMessageComponent(true);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};
const $0279287873867410$export$14fe1fc3395b6e3f = ()=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent } = (0, $cxwD2.useMessageAnalyticsContext)();
    const { messageViewed: messageViewed } = (0, $lFpSS.useMessageEvent)();
    const { messageInstanceViewed: messageInstanceViewed, messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $bpU8k.useMessageInstanceEvent)();
    const hasDeliveredSuccessfullyBeenFired = (0, $5uXOq.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $5uXOq.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    // messageViewed returns a promise of void, which is incompatible with the TrackMount onMount prop
    const messageViewedVoidFunction = (0, $5uXOq.useCallback)(()=>{
        // Only fire the message viewed event if the message viewed event is not fired in the message component.
        if (fireMessageViewedInMessageComponent && !fireMessageViewedInMessageComponent.current) {
            messageViewed();
            messageInstanceViewed();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2x1bx.TrackMount), {
        onMount: messageViewedVoidFunction
    });
};
const $0279287873867410$export$4c73c6f545b966b7 = ({ children: children })=>{
    const messageRef = (0, $5uXOq.useRef)(null);
    const { messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $bpU8k.useMessageInstanceEvent)();
    const { inViewport: inViewport, enterCount: enterCount } = (0, $huaDn.useInViewport)(messageRef, {});
    const hasDeliveredSuccessfullyBeenFired = (0, $5uXOq.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $5uXOq.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("section", {
        ref: messageRef,
        children: [
            inViewport && enterCount >= 1 ? /*#__PURE__*/ (0, $2OMIu.jsx)($0279287873867410$export$14fe1fc3395b6e3f, {}) : null,
            children
        ]
    });
};

});
parcelRegister("bpU8k", function(module, exports) {

$parcel$export(module.exports, "useMessageInstanceEvent", () => $a3041837ebdef1bc$export$39b0f5626e96f41e);

var $ggVl0 = parcelRequire("ggVl0");

var $eFcnR = parcelRequire("eFcnR");

var $2EUTa = parcelRequire("2EUTa");

var $6NLx9 = parcelRequire("6NLx9");

var $5uXOq = parcelRequire("5uXOq");

var $dadai = parcelRequire("dadai");

var $dk8p3 = parcelRequire("dk8p3");
const $a3041837ebdef1bc$export$39b0f5626e96f41e = ()=>{
    if (!globalThis.window.postOfficeMessageInstanceEventClient) globalThis.window.postOfficeMessageInstanceEventClient = new (0, $dk8p3.MessageInstanceEventClient)();
    const client = globalThis.window.postOfficeMessageInstanceEventClient;
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, triggerId: messageTriggerId, messageCreationType: messageCreationType } = (0, $eFcnR.useMessageContext)();
    const { placementId: placementId } = (0, $2EUTa.usePlacementContext)();
    const browserContext = (0, $ggVl0.usePostOfficeContext)();
    const recommendationContext = (0, $6NLx9.useRecommendationContext)();
    const messageInstanceDeliveredSuccessfully = (0, $5uXOq.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $dadai.MessageInstanceEventContextError)());
            return;
        }
        const event = {
            messageEventType: 'deliverySuccessful',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: transactionAccountId ? {
                ...additionalMetadataFromFrontend,
                transactionAccountId: transactionAccountId
            } : additionalMetadataFromFrontend,
            messageTriggerId: messageTriggerId,
            messageCreationType: messageCreationType,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(event);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        recommendationContext.entityId,
        recommendationContext.sessionId
    ]);
    const messageInstanceViewed = (0, $5uXOq.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $dadai.MessageInstanceEventContextError)());
            return;
        }
        const event = {
            messageEventType: 'viewed',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: transactionAccountId ? {
                ...additionalMetadataFromFrontend,
                transactionAccountId: transactionAccountId
            } : additionalMetadataFromFrontend,
            messageTriggerId: messageTriggerId,
            messageCreationType: messageCreationType,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(event);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        recommendationContext.entityId,
        recommendationContext.sessionId
    ]);
    const messageInstanceClicked = (0, $5uXOq.useCallback)(async (params)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $dadai.MessageInstanceEventContextError)());
            return;
        }
        const clickEventPayload = {
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            messageCreationType: messageCreationType,
            messageTriggerId: messageTriggerId,
            ...params,
            additionalMetadataFromFrontend: transactionAccountId ? {
                ...params.additionalMetadataFromFrontend,
                transactionAccountId: transactionAccountId
            } : params.additionalMetadataFromFrontend,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(clickEventPayload);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        recommendationContext.entityId,
        recommendationContext.sessionId
    ]);
    return {
        messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully,
        messageInstanceViewed: messageInstanceViewed,
        messageInstanceClicked: messageInstanceClicked
    };
};

});
parcelRegister("dadai", function(module, exports) {

$parcel$export(module.exports, "MessageInstanceEventContextError", () => $13eabc7989eac29b$export$9ffc53d3edc152da);
class $13eabc7989eac29b$export$9ffc53d3edc152da extends Error {
    constructor(){
        super('useMessageInstanceEvent must be used inside a Message template render component.');
    }
}
class $13eabc7989eac29b$export$6c3423e1c9ff4d5b extends Error {
    constructor(){
        super('Unknown action type');
    }
}

});

parcelRegister("dk8p3", function(module, exports) {

$parcel$export(module.exports, "MessageInstanceEventClient", () => $7813b67f6b66bb28$export$4564cfc2de39be55);
const $7813b67f6b66bb28$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/message-instance-event/bulk`;
const $7813b67f6b66bb28$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $7813b67f6b66bb28$var$MESSAGE_EVENTS_BATCH_SIZE = 30;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("fS9d8"));
class $7813b67f6b66bb28$export$4564cfc2de39be55 {
    async sendMessageInstanceEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $7813b67f6b66bb28$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async sendEventsToBackend(events) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $7813b67f6b66bb28$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $7813b67f6b66bb28$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendEventsToBackend(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($7813b67f6b66bb28$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $7813b67f6b66bb28$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendEventsToBackend(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $7813b67f6b66bb28$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}

});
parcelRegister("fS9d8", function(module, exports) {

$parcel$export(module.exports, "Headers", () => $b8e30b448f738d08$export$79b704688b15c0f4);
$parcel$export(module.exports, "Request", () => $b8e30b448f738d08$export$7fa6c5b6f8193917);
$parcel$export(module.exports, "Response", () => $b8e30b448f738d08$export$9f633d56d7ec90d3);
$parcel$export(module.exports, "DOMException", () => $b8e30b448f738d08$export$fe58bcf938607f6a);
$parcel$export(module.exports, "fetch", () => $b8e30b448f738d08$export$e7aa7bc5c1b3cfb3);
/* eslint-disable no-prototype-builtins */ var $b8e30b448f738d08$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== 'undefined' && $parcel$global || {};
var $b8e30b448f738d08$var$support = {
    searchParams: 'URLSearchParams' in $b8e30b448f738d08$var$g,
    iterable: 'Symbol' in $b8e30b448f738d08$var$g && 'iterator' in Symbol,
    blob: 'FileReader' in $b8e30b448f738d08$var$g && 'Blob' in $b8e30b448f738d08$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in $b8e30b448f738d08$var$g,
    arrayBuffer: 'ArrayBuffer' in $b8e30b448f738d08$var$g
};
function $b8e30b448f738d08$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($b8e30b448f738d08$var$support.arrayBuffer) {
    var $b8e30b448f738d08$var$viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var $b8e30b448f738d08$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $b8e30b448f738d08$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $b8e30b448f738d08$var$normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $b8e30b448f738d08$var$normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $b8e30b448f738d08$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($b8e30b448f738d08$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $b8e30b448f738d08$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $b8e30b448f738d08$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $b8e30b448f738d08$var$normalizeName(name);
    value = $b8e30b448f738d08$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype['delete'] = function(name) {
    delete this.map[$b8e30b448f738d08$var$normalizeName(name)];
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $b8e30b448f738d08$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($b8e30b448f738d08$var$normalizeName(name));
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$b8e30b448f738d08$var$normalizeName(name)] = $b8e30b448f738d08$var$normalizeValue(value);
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $b8e30b448f738d08$var$iteratorFor(items);
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $b8e30b448f738d08$var$iteratorFor(items);
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $b8e30b448f738d08$var$iteratorFor(items);
};
if ($b8e30b448f738d08$var$support.iterable) $b8e30b448f738d08$export$79b704688b15c0f4.prototype[Symbol.iterator] = $b8e30b448f738d08$export$79b704688b15c0f4.prototype.entries;
function $b8e30b448f738d08$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function $b8e30b448f738d08$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $b8e30b448f738d08$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $b8e30b448f738d08$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $b8e30b448f738d08$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $b8e30b448f738d08$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise;
}
function $b8e30b448f738d08$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function $b8e30b448f738d08$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $b8e30b448f738d08$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = '';
        } else if (typeof body === 'string') this._bodyText = body;
        else if ($b8e30b448f738d08$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($b8e30b448f738d08$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($b8e30b448f738d08$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($b8e30b448f738d08$var$support.arrayBuffer && $b8e30b448f738d08$var$support.blob && $b8e30b448f738d08$var$isDataView(body)) {
            this._bodyArrayBuffer = $b8e30b448f738d08$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($b8e30b448f738d08$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $b8e30b448f738d08$var$isArrayBufferView(body))) this._bodyArrayBuffer = $b8e30b448f738d08$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if ($b8e30b448f738d08$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if ($b8e30b448f738d08$var$support.blob) this.blob = function() {
        var rejected = $b8e30b448f738d08$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $b8e30b448f738d08$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($b8e30b448f738d08$var$support.blob) return this.blob().then($b8e30b448f738d08$var$readBlobAsArrayBuffer);
        else throw new Error('could not read as ArrayBuffer');
    };
    this.text = function() {
        var rejected = $b8e30b448f738d08$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $b8e30b448f738d08$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($b8e30b448f738d08$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if ($b8e30b448f738d08$var$support.formData) this.formData = function() {
        return this.text().then($b8e30b448f738d08$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $b8e30b448f738d08$var$methods = [
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE'
];
function $b8e30b448f738d08$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $b8e30b448f738d08$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $b8e30b448f738d08$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $b8e30b448f738d08$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $b8e30b448f738d08$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $b8e30b448f738d08$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new $b8e30b448f738d08$export$79b704688b15c0f4(options.headers);
    this.method = $b8e30b448f738d08$var$normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ('AbortController' in $b8e30b448f738d08$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
$b8e30b448f738d08$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $b8e30b448f738d08$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $b8e30b448f738d08$var$decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $b8e30b448f738d08$var$parseHeaders(rawHeaders) {
    var headers = new $b8e30b448f738d08$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn('Response ' + error.message);
            }
        }
    });
    return headers;
}
$b8e30b448f738d08$var$Body.call($b8e30b448f738d08$export$7fa6c5b6f8193917.prototype);
function $b8e30b448f738d08$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $b8e30b448f738d08$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new $b8e30b448f738d08$export$79b704688b15c0f4(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
$b8e30b448f738d08$var$Body.call($b8e30b448f738d08$export$9f633d56d7ec90d3.prototype);
$b8e30b448f738d08$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $b8e30b448f738d08$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $b8e30b448f738d08$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$b8e30b448f738d08$export$9f633d56d7ec90d3.error = function() {
    var response = new $b8e30b448f738d08$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ''
    });
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response;
};
var $b8e30b448f738d08$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$b8e30b448f738d08$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($b8e30b448f738d08$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new $b8e30b448f738d08$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $b8e30b448f738d08$export$fe58bcf938607f6a = $b8e30b448f738d08$var$g.DOMException;
try {
    new $b8e30b448f738d08$export$fe58bcf938607f6a();
} catch (err) {
    $b8e30b448f738d08$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $b8e30b448f738d08$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $b8e30b448f738d08$export$fe58bcf938607f6a.prototype.constructor = $b8e30b448f738d08$export$fe58bcf938607f6a;
}
function $b8e30b448f738d08$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $b8e30b448f738d08$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $b8e30b448f738d08$export$fe58bcf938607f6a('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $b8e30b448f738d08$var$parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $b8e30b448f738d08$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request timed out'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $b8e30b448f738d08$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && $b8e30b448f738d08$var$g.location.href ? $b8e30b448f738d08$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if ($b8e30b448f738d08$var$support.blob) xhr.responseType = 'blob';
            else if ($b8e30b448f738d08$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof $b8e30b448f738d08$export$79b704688b15c0f4 || $b8e30b448f738d08$var$g.Headers && init.headers instanceof $b8e30b448f738d08$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($b8e30b448f738d08$var$normalizeName(name));
                xhr.setRequestHeader(name, $b8e30b448f738d08$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
$b8e30b448f738d08$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$b8e30b448f738d08$var$g.fetch) {
    $b8e30b448f738d08$var$g.fetch = $b8e30b448f738d08$export$e7aa7bc5c1b3cfb3;
    $b8e30b448f738d08$var$g.Headers = $b8e30b448f738d08$export$79b704688b15c0f4;
    $b8e30b448f738d08$var$g.Request = $b8e30b448f738d08$export$7fa6c5b6f8193917;
    $b8e30b448f738d08$var$g.Response = $b8e30b448f738d08$export$9f633d56d7ec90d3;
}

});



parcelRegister("lFpSS", function(module, exports) {

$parcel$export(module.exports, "useMessageEvent", () => $915c9ab2db68b367$export$3cbbf1e81e2ecb39);

var $aAASp = parcelRequire("aAASp");
var $ggVl0 = parcelRequire("ggVl0");

var $eFcnR = parcelRequire("eFcnR");

var $2EUTa = parcelRequire("2EUTa");

var $6NLx9 = parcelRequire("6NLx9");

var $5uXOq = parcelRequire("5uXOq");

var $jlpHn = parcelRequire("jlpHn");

var $5CBu0 = parcelRequire("5CBu0");

var $cwNOk = parcelRequire("cwNOk");
const $915c9ab2db68b367$export$3cbbf1e81e2ecb39 = ()=>{
    if (!globalThis.window.postOfficeMessageEventClient) globalThis.window.postOfficeMessageEventClient = new (0, $5CBu0.MessageEventClient)();
    const client = globalThis.window.postOfficeMessageEventClient;
    const { dismissMessageFromPlacement: dismissMessageFromPlacement, markReadFromPlacement: markReadFromPlacement, markClickedFromPlacement: markClickedFromPlacement, markViewedFromPlacement: markViewedFromPlacement, snoozeMessageFromPlacement: snoozeMessageFromPlacement } = (0, $aAASp.useMessagePlacementHooks)();
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails } = (0, $eFcnR.useMessageContext)();
    const { placementId: placementId } = (0, $2EUTa.usePlacementContext)();
    const browserContext = (0, $ggVl0.usePostOfficeContext)();
    const recommendationContext = (0, $6NLx9.useRecommendationContext)();
    const context = {
        browser: browserContext,
        recommendation: recommendationContext
    };
    /**
	 * Marks all messages as read. Calls markAllAsReadEvent() as the API call
	 */ const markAllAsRead = (0, $5uXOq.useCallback)(async (messages)=>{
        const messagesEventPostPayload = messages.map((message)=>{
            const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId } = message;
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jlpHn.MessageLifecycleContextError)();
            return {
                messageInstanceId: message['messageInstanceId'],
                messageTemplateId: message['messageTemplateId'],
                type: (0, $cwNOk.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            };
        });
        try {
            await client.markAllAsReadEvent(messagesEventPostPayload);
        } catch (error) {
            throw new (0, $jlpHn.MessageLifecycleClientError)();
        }
    }, [
        client,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as read. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageRead = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jlpHn.MessageLifecycleContextError)();
        markReadFromPlacement({
            messageInstanceId: messageInstanceId
        });
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $cwNOk.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        } catch (error) {
            throw new (0, $jlpHn.MessageLifecycleClientError)();
        }
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        markReadFromPlacement
    ]);
    /**
	 * Marks a message as unread. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageUnread = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jlpHn.MessageLifecycleContextError)();
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $cwNOk.InAppMessageEventType).Unread,
                placement: placementId,
                createdAt: Date.now(),
                context: context,
                analyticsDetails: analyticsDetails
            });
        } catch (error) {
            throw new (0, $jlpHn.MessageLifecycleClientError)();
        }
    }, [
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as viewed. This event is fired automatically and should not need to be fired manually in the message component.
	 */ const messageViewed = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jlpHn.MessageLifecycleContextError)();
        markViewedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $cwNOk.InAppMessageEventType).Viewed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markViewedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageClicked = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jlpHn.MessageLifecycleContextError)();
        markClickedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $cwNOk.InAppMessageEventType).Clicked,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markClickedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Lower value than messageClicked (use for options like: "Learn More"), not to be used as a dismiss
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageClickedSecondary = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jlpHn.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $cwNOk.InAppMessageEventType).ClickedSecondary,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as acknowledged
	 */ const messageAcknowledged = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jlpHn.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $cwNOk.InAppMessageEventType).Acknowledged,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as dismissed.
	 * This event is used as a negative reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageDismissed = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jlpHn.MessageLifecycleContextError)();
        dismissMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $cwNOk.InAppMessageEventType).Dismissed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        dismissMessageFromPlacement
    ]);
    /**
	 * Marks a message as snoozed.
	 * This event is not used to train the Post Office Defacto Bandit ML Model.
	 */ const messageSnoozed = (0, $5uXOq.useCallback)(async (snoozeDays)=>{
        const MILLIS_IN_A_DAY = 86400000;
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jlpHn.MessageLifecycleContextError)();
        snoozeMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        const statusExpiryTime = Date.now() + snoozeDays * MILLIS_IN_A_DAY;
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $cwNOk.InAppMessageEventType).Snoozed,
            placement: placementId,
            createdAt: Date.now(),
            statusExpiryTime: statusExpiryTime,
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        snoozeMessageFromPlacement
    ]);
    return {
        markAllAsRead: markAllAsRead,
        messageRead: messageRead,
        messageUnread: messageUnread,
        messageViewed: messageViewed,
        messageClicked: messageClicked,
        messageClickedSecondary: messageClickedSecondary,
        messageAcknowledged: messageAcknowledged,
        messageDismissed: messageDismissed,
        messageSnoozed: messageSnoozed
    };
};

});
parcelRegister("jlpHn", function(module, exports) {

$parcel$export(module.exports, "MessageLifecycleContextError", () => $2242ff7b9be7eb6a$export$12bb62b204112f55);
$parcel$export(module.exports, "MessageLifecycleClientError", () => $2242ff7b9be7eb6a$export$44f397e2afeb89e0);
class $2242ff7b9be7eb6a$export$12bb62b204112f55 extends Error {
    constructor(){
        super('useMessageLifecycle must be used inside a Message template render component.');
    }
}
class $2242ff7b9be7eb6a$export$44f397e2afeb89e0 extends Error {
    constructor(){
        super('API call to /messages failed due to an error');
    }
}

});

parcelRegister("5CBu0", function(module, exports) {

$parcel$export(module.exports, "MessageEventClient", () => $1119338145cb433f$export$ae86a6dabe385178);
const $1119338145cb433f$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/messages/lifecycle`;
const $1119338145cb433f$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $1119338145cb433f$var$MESSAGE_EVENTS_BATCH_SIZE = 250;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("fS9d8"));
class $1119338145cb433f$export$ae86a6dabe385178 {
    async sendEvent(event) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(event)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    batchSendEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $1119338145cb433f$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async markAllAsReadEvent(messages) {
        this.batchEvents.push(...messages);
        await this.flushBatchEvents();
    }
    async sendMessageEvents(events) {
        const url = `${this.endpointUrl}/bulk`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send batch events to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $1119338145cb433f$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $1119338145cb433f$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendMessageEvents(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($1119338145cb433f$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $1119338145cb433f$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendMessageEvents(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $1119338145cb433f$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}

});

parcelRegister("cwNOk", function(module, exports) {

$parcel$export(module.exports, "InAppMessageEventType", () => $7e8eb241b4b10053$export$b31ffc6f7c85f1b);
var $7e8eb241b4b10053$export$b31ffc6f7c85f1b = /*#__PURE__*/ function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Snoozed"] = "snoozed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
    return InAppMessageEventType;
}({});

});


parcelRegister("huaDn", function(module, exports) {

$parcel$export(module.exports, "useInViewport", () => $cbad7cb89a03ebf8$export$6215040b989f9b0f, (v) => $cbad7cb89a03ebf8$export$6215040b989f9b0f = v);
var $cbad7cb89a03ebf8$export$1e511d4a378977f5;
var $cbad7cb89a03ebf8$export$6215040b989f9b0f;
var $cbad7cb89a03ebf8$export$436b63fa4855237f;
var $cbad7cb89a03ebf8$export$2e2bcd8739ae039;
var $cbad7cb89a03ebf8$export$95cef81be5ddcfd4;
"use strict";
$cbad7cb89a03ebf8$export$1e511d4a378977f5 = true;
$cbad7cb89a03ebf8$export$6215040b989f9b0f = $cbad7cb89a03ebf8$export$436b63fa4855237f = $cbad7cb89a03ebf8$export$2e2bcd8739ae039 = $cbad7cb89a03ebf8$export$95cef81be5ddcfd4 = void 0;

var $cbad7cb89a03ebf8$var$_handleViewport = $cbad7cb89a03ebf8$var$_interopRequireDefault((parcelRequire("T3qHg")));
$cbad7cb89a03ebf8$export$436b63fa4855237f = $cbad7cb89a03ebf8$var$_handleViewport.default;

var $cbad7cb89a03ebf8$var$_useInViewport = $cbad7cb89a03ebf8$var$_interopRequireDefault((parcelRequire("3FJrj")));
$cbad7cb89a03ebf8$export$6215040b989f9b0f = $cbad7cb89a03ebf8$var$_useInViewport.default;
function $cbad7cb89a03ebf8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var $cbad7cb89a03ebf8$var$customProps = $cbad7cb89a03ebf8$export$95cef81be5ddcfd4 = [
    'inViewport',
    'enterCount',
    'leaveCount'
];
var $cbad7cb89a03ebf8$var$_default = $cbad7cb89a03ebf8$export$2e2bcd8739ae039 = $cbad7cb89a03ebf8$var$_handleViewport.default;

});
parcelRegister("T3qHg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $0a57cc36f8cb8118$export$1e511d4a378977f5, (v) => $0a57cc36f8cb8118$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $0a57cc36f8cb8118$export$2e2bcd8739ae039, (v) => $0a57cc36f8cb8118$export$2e2bcd8739ae039 = v);
var $0a57cc36f8cb8118$export$1e511d4a378977f5;
var $0a57cc36f8cb8118$export$2e2bcd8739ae039;
"use strict";
$0a57cc36f8cb8118$export$1e511d4a378977f5 = true;
$0a57cc36f8cb8118$export$2e2bcd8739ae039 = void 0;

var $5uXOq = parcelRequire("5uXOq");

var $0a57cc36f8cb8118$var$_hoistNonReactStatics = $0a57cc36f8cb8118$var$_interopRequireDefault((parcelRequire("dY8Js")));

var $0a57cc36f8cb8118$var$_useInViewport = $0a57cc36f8cb8118$var$_interopRequireDefault((parcelRequire("3FJrj")));

var $1aHjR = parcelRequire("1aHjR");

var $2OMIu = parcelRequire("2OMIu");
var $0a57cc36f8cb8118$var$_excluded = [
    "onEnterViewport",
    "onLeaveViewport"
];
function $0a57cc36f8cb8118$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $0a57cc36f8cb8118$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $0a57cc36f8cb8118$var$_extends() {
    return $0a57cc36f8cb8118$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0a57cc36f8cb8118$var$_extends.apply(null, arguments);
}
function $0a57cc36f8cb8118$var$handleViewport(TargetComponent, options, config) {
    if (options === void 0) options = $1aHjR.defaultOptions;
    if (config === void 0) config = $1aHjR.defaultConfig;
    var ForwardedRefComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
        var refProps = {
            forwardedRef: ref
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(TargetComponent, $0a57cc36f8cb8118$var$_extends({}, props, refProps));
    });
    var InViewport = (_ref)=>{
        var { onEnterViewport: onEnterViewport = $1aHjR.noop, onLeaveViewport: onLeaveViewport = $1aHjR.noop } = _ref, restProps = $0a57cc36f8cb8118$var$_objectWithoutPropertiesLoose(_ref, $0a57cc36f8cb8118$var$_excluded);
        var node = (0, $5uXOq.useRef)(null);
        var { inViewport: inViewport, enterCount: enterCount, leaveCount: leaveCount } = (0, $0a57cc36f8cb8118$var$_useInViewport.default)(node, options, config, {
            onEnterViewport: onEnterViewport,
            onLeaveViewport: onLeaveViewport
        });
        var props = $0a57cc36f8cb8118$var$_extends({}, restProps, {
            inViewport: inViewport,
            enterCount: enterCount,
            leaveCount: leaveCount
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ForwardedRefComponent, $0a57cc36f8cb8118$var$_extends({}, props, {
            ref: node
        }));
    };
    var name = TargetComponent.displayName || TargetComponent.name || 'Component';
    InViewport.displayName = "handleViewport(" + name + ")";
    return (0, $0a57cc36f8cb8118$var$_hoistNonReactStatics.default)(InViewport, ForwardedRefComponent);
}
var $0a57cc36f8cb8118$var$_default = $0a57cc36f8cb8118$export$2e2bcd8739ae039 = $0a57cc36f8cb8118$var$handleViewport;

});
parcelRegister("3FJrj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $2ac872c90dc0d9fc$export$1e511d4a378977f5, (v) => $2ac872c90dc0d9fc$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $2ac872c90dc0d9fc$export$2e2bcd8739ae039, (v) => $2ac872c90dc0d9fc$export$2e2bcd8739ae039 = v);
var $2ac872c90dc0d9fc$export$1e511d4a378977f5;
var $2ac872c90dc0d9fc$export$2e2bcd8739ae039;
"use strict";
$2ac872c90dc0d9fc$export$1e511d4a378977f5 = true;
$2ac872c90dc0d9fc$export$2e2bcd8739ae039 = void 0;

var $5uXOq = parcelRequire("5uXOq");

var $1aHjR = parcelRequire("1aHjR");
var $2ac872c90dc0d9fc$var$defaultMutationObserverOption = {
    attributes: true,
    childList: true,
    subtree: true
};
var $2ac872c90dc0d9fc$var$useInViewport = function useInViewport(target, options, config, props) {
    if (options === void 0) options = $1aHjR.defaultOptions;
    if (config === void 0) config = $1aHjR.defaultConfig;
    if (props === void 0) props = $1aHjR.defaultProps;
    var { onEnterViewport: onEnterViewport, onLeaveViewport: onLeaveViewport } = props;
    var [, forceUpdate] = (0, $5uXOq.useState)();
    var observer = (0, $5uXOq.useRef)();
    var inViewportRef = (0, $5uXOq.useRef)(false);
    var intersected = (0, $5uXOq.useRef)(false);
    var enterCountRef = (0, $5uXOq.useRef)(0);
    var leaveCountRef = (0, $5uXOq.useRef)(0);
    // State to track when target is available
    var [isTargetReady, setIsTargetReady] = (0, $5uXOq.useState)(Boolean(target.current));
    function startObserver(_ref) {
        var { observerRef: observerRef } = _ref;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.observe(node);
        }
    }
    function stopObserver(_ref2) {
        var { observerRef: observerRef } = _ref2;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.unobserve(node);
        }
        observerRef == null || observerRef.disconnect();
        observer.current = null;
    }
    var handleIntersection = (entries)=>{
        var entry = entries[0] || {};
        var { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = entry;
        var isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0;
        // enter
        if (!intersected.current && isInViewport) {
            intersected.current = true;
            onEnterViewport == null || onEnterViewport();
            enterCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
            return;
        }
        // leave
        if (intersected.current && !isInViewport) {
            intersected.current = false;
            onLeaveViewport == null || onLeaveViewport();
            if (config.disconnectOnLeave && observer.current) // disconnect observer on leave
            observer.current.disconnect();
            leaveCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
        }
    };
    function initIntersectionObserver(_ref3) {
        var { observerRef: observerRef } = _ref3;
        if (!observerRef) {
            observer.current = new IntersectionObserver(handleIntersection, options);
            return observer.current;
        }
        return observerRef;
    }
    (0, $5uXOq.useEffect)(()=>{
        var observerRef = observer.current;
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        observerRef = initIntersectionObserver({
            observerRef: observerRef
        });
        startObserver({
            observerRef: observerRef
        });
        return ()=>{
            stopObserver({
                observerRef: observerRef
            });
        };
    }, [
        target.current,
        options,
        config,
        onEnterViewport,
        onLeaveViewport
    ]);
    // Use MutationObserver to detect when `target.current` becomes non-null
    // only at start up
    (0, $5uXOq.useEffect)(()=>{
        var currentElement = target.current;
        var mutationObserver = null;
        // MutationObserver callback to check when the target ref is assigned
        var handleOnChange = ()=>{
            if (target.current && !isTargetReady) {
                setIsTargetReady(true);
                if (mutationObserver) mutationObserver.disconnect();
            }
        };
        if (currentElement) setIsTargetReady(true); // If target is already available, mark it ready
        else {
            // Observe changes to detect when `target.current` becomes non-null
            mutationObserver = new MutationObserver(handleOnChange);
            mutationObserver.observe(document.body, $2ac872c90dc0d9fc$var$defaultMutationObserverOption);
        }
        // Cleanup function to stop observing when the component unmounts
        return ()=>{
            if (mutationObserver) mutationObserver.disconnect();
        };
    }, [
        target.current
    ]);
    return {
        inViewport: inViewportRef.current,
        enterCount: enterCountRef.current,
        leaveCount: leaveCountRef.current
    };
};
var $2ac872c90dc0d9fc$var$_default = $2ac872c90dc0d9fc$export$2e2bcd8739ae039 = $2ac872c90dc0d9fc$var$useInViewport;

});
parcelRegister("1aHjR", function(module, exports) {

$parcel$export(module.exports, "noop", () => $0da853e95098c517$export$8793edee2d425525, (v) => $0da853e95098c517$export$8793edee2d425525 = v);
$parcel$export(module.exports, "defaultProps", () => $0da853e95098c517$export$9c21a3269931e1e6, (v) => $0da853e95098c517$export$9c21a3269931e1e6 = v);
$parcel$export(module.exports, "defaultOptions", () => $0da853e95098c517$export$ba43bf67f3d48107, (v) => $0da853e95098c517$export$ba43bf67f3d48107 = v);
$parcel$export(module.exports, "defaultConfig", () => $0da853e95098c517$export$f84bd70098573c5c, (v) => $0da853e95098c517$export$f84bd70098573c5c = v);
var $0da853e95098c517$export$1e511d4a378977f5;
var $0da853e95098c517$export$8793edee2d425525;
var $0da853e95098c517$export$9c21a3269931e1e6;
var $0da853e95098c517$export$ba43bf67f3d48107;
var $0da853e95098c517$export$f84bd70098573c5c;
"use strict";
$0da853e95098c517$export$1e511d4a378977f5 = true;
$0da853e95098c517$export$8793edee2d425525 = $0da853e95098c517$export$9c21a3269931e1e6 = $0da853e95098c517$export$ba43bf67f3d48107 = $0da853e95098c517$export$f84bd70098573c5c = void 0;
var $0da853e95098c517$var$defaultOptions = $0da853e95098c517$export$ba43bf67f3d48107 = {};
var $0da853e95098c517$var$defaultConfig = $0da853e95098c517$export$f84bd70098573c5c = {
    disconnectOnLeave: false
};
var $0da853e95098c517$var$noop = ()=>{};
$0da853e95098c517$export$8793edee2d425525 = $0da853e95098c517$var$noop;
var $0da853e95098c517$var$defaultProps = $0da853e95098c517$export$9c21a3269931e1e6 = {
    onEnterViewport: $0da853e95098c517$var$noop,
    onLeaveViewport: $0da853e95098c517$var$noop
};

});









parcelRegister("1ZJzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cb563fb86042b44$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $8xuqQ = parcelRequire("8xuqQ");
var $5cb563fb86042b44$export$2e2bcd8739ae039 = {
    'message-template-template': (0, $8xuqQ.default)
};

});
parcelRegister("8xuqQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0df649a89e63788$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $4hBFe = parcelRequire("4hBFe");
parcelRequire("5uXOq");

var $jcyDR = parcelRequire("jcyDR");
const $c0df649a89e63788$export$b3890eb0ae9dca99 = (0, $jcyDR.createRender)(({ messageInstanceId: messageInstanceId, readMoreLink: readMoreLink })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4hBFe.TopBannerMessage), {
        readMoreLink: readMoreLink,
        messageInstanceId: messageInstanceId
    }));
var $c0df649a89e63788$export$2e2bcd8739ae039 = $c0df649a89e63788$export$b3890eb0ae9dca99;

});
parcelRegister("jcyDR", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $43e7e81987df4a8b$export$78c758434c34d601);

var $6ifjo = parcelRequire("6ifjo");
const { createRender: $43e7e81987df4a8b$export$78c758434c34d601, createValidate: $43e7e81987df4a8b$export$2859a83e4d6da57d } = (0, $6ifjo.createClientPipeline)();
const { createHydrate: $43e7e81987df4a8b$export$c905bc718befd59b, createHydrateExample: $43e7e81987df4a8b$export$1f41223e5b0a6622, createTransformMetadata: $43e7e81987df4a8b$export$88fe13b4d13f8423 } = (0, $6ifjo.createServerPipeline)();

});




/* GeneratedContentHash: 90a7d45c313eaf24d28f3e71b65ecf55df9e4f5806226e92484289f49713e5bf */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $df69f5d3899c3a85$export$a5cfae247d8360ef = 'jira-top-banner';

parcelRegister("7CK2n", function(module, exports) {

$parcel$export(module.exports, "withJiraTopBannerIntlProvider", () => $c3b0379f060f60c9$export$2a49ebed7015cea4);
/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $lyW0g = parcelRequire("lyW0g");

var $bINgh = parcelRequire("bINgh");

var $fJUJM = parcelRequire("fJUJM");
const $c3b0379f060f60c9$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $bINgh.messagesLoader)(locale),
        (0, $fJUJM.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $c3b0379f060f60c9$export$2a49ebed7015cea4 = (Component)=>{
    return (0, $lyW0g.withIntlProvider)({
        messagesLoader: $c3b0379f060f60c9$export$d5a462ce7bd04520
    }, Component);
};

});
parcelRegister("lyW0g", function(module, exports) {

$parcel$export(module.exports, "withIntlProvider", () => $6c5d5073182ce361$export$a5d940130f33be3f);

var $2OMIu = parcelRequire("2OMIu");

var $2vvBP = parcelRequire("2vvBP");
const $6c5d5073182ce361$export$a5d940130f33be3f = (intlProviderProps, Component)=>({ preloadedMessages: preloadedMessages, ...props })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2vvBP.default), {
            ...intlProviderProps,
            messages: preloadedMessages,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...props
            })
        });
    };

});
parcelRegister("2vvBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6222cebaa5b6365a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $ddiyw = parcelRequire("ddiyw");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $f7cRw = parcelRequire("f7cRw");
function $6222cebaa5b6365a$var$useFetchLocale() {
    let locale = 'en';
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ddiyw.useFirePostOfficeAnalyticsEvents)();
    try {
        const { locale: intlLocale } = (0, $koVbs.default)();
        locale = intlLocale;
    } catch (err) {
        fireAnalyticsEvent({
            action: 'errored',
            actionSubject: 'intlProvider',
            eventType: 'operational',
            attributes: {
                errorMessage: err
            }
        });
    }
    return {
        locale: locale
    };
}
function $6222cebaa5b6365a$export$2e2bcd8739ae039(props) {
    const { locale: locale } = $6222cebaa5b6365a$var$useFetchLocale();
    const messages = (0, $f7cRw.useIntlMessages)(locale, props.messagesLoader, props.messages);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: locale,
        messages: messages,
        children: props.children
    });
}

});
parcelRegister("f7cRw", function(module, exports) {

$parcel$export(module.exports, "useIntlMessages", () => $a208f595baafbf49$export$2641ec9a2025a81f);

var $ddiyw = parcelRequire("ddiyw");

var $5uXOq = parcelRequire("5uXOq");
const $a208f595baafbf49$export$2641ec9a2025a81f = (locale, messageLoader, initialMessages)=>{
    const [messages, setMessages] = (0, $5uXOq.useState)(initialMessages);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ddiyw.useFirePostOfficeAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (initialMessages) return;
        messageLoader(locale).then((loadedMessages)=>{
            if (loadedMessages && loadedMessages.messages) setMessages(loadedMessages.messages);
            if (loadedMessages?.errors?.length > 0) fireAnalyticsEvent({
                action: 'errored',
                actionSubject: 'intlMessagesLoader',
                eventType: 'operational',
                attributes: {
                    locale: locale,
                    errorMessage: loadedMessages.errors
                }
            });
        })// eslint-disable-next-line no-console
        .catch(console.error);
    }, [
        locale,
        initialMessages
    ]);
    return messages;
};

});



parcelRegister("bINgh", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $d0f470b32a931227$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $5Zjdq = parcelRequire("5Zjdq");

var $2AtjH = parcelRequire("2AtjH");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d0f470b32a931227$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $d0f470b32a931227$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $2AtjH.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("1Aa6w")));
        case 'da':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("jdey0")));
        case 'de':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("4Dj4W")));
        case 'en-GB':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("kv72q")));
        case 'en-US':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("hcGnX")));
        case 'en-XA':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("7GQkj")));
        case 'en-XB':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("7q60Z")));
        case 'en-ZZ':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("bJuCa")));
        case 'en':
            return $d0f470b32a931227$var$importHelper(await Promise.resolve((parcelRequire("5Zjdq"))));
        case 'es':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("7Ebgw")));
        case 'et':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("8ZUOb")));
        case 'fi':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("5CKGD")));
        case 'fr':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("kTRhT")));
        case 'hu':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("i6G7w")));
        case 'it':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("7Rm47")));
        case 'ja':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("entUQ")));
        case 'ko':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("fbWbn")));
        case 'nb':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("acY2A")));
        case 'nl':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("4OwMB")));
        case 'pl':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("fCvWB")));
        case 'pt-BR':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("1hpg4")));
        case 'ro':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("7oyaA")));
        case 'ru':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("2TjRL")));
        case 'sv':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("eKbNm")));
        case 'th':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("bmowM")));
        case 'tr':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("f1Wu8")));
        case 'uk':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("hffaE")));
        case 'vi':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("5afCd")));
        case 'zh-CN':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("77AfZ")));
        case 'zh-TW':
            return $d0f470b32a931227$var$importHelper(await (parcelRequire("9ffzi")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($5Zjdq));
    }
};

});
parcelRegister("5Zjdq", function(module, exports) {
module.exports = JSON.parse('{"jira-pulsar.jira-common.celebration-icon.body_image_alt":[{"type":0,"value":"Celebration icon"}],"jira-pulsar.jira-common.exclamation-icon.body_image_alt":[{"type":0,"value":"Exclamation icon"}],"jira-pulsar.jira-common.message-template.text.body.display.old.field.value":[{"type":0,"value":"was: "},{"type":1,"value":"oldFieldValue"}],"jira-pulsar.jira-common.right-arrow-icon.no-translate":[{"type":0,"value":"&#x2192;"}],"jira-pulsar.jira-contact-admin.message-template.email.body.from.contact.admin":[{"type":0,"value":"From:"}],"jira-pulsar.jira-contact-admin.message-template.email.body.new.message.from.contact.admin":[{"type":0,"value":"New message from Contact Administrators page"}],"jira-pulsar.jira-contact-admin.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"header"}],"jira-pulsar.jira-issue-approval-decided.right.arrow.image.alt.no-translate":[{"type":0,"value":"->"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.assigned.to":[{"type":0,"value":"Assigned to: "},{"type":1,"value":"assignee"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers":[{"type":0,"value":"Approvers: "}],"jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers.plus.no-translate":[{"type":0,"value":"+"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.by.user.subject":[{"type":1,"value":"user"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.subject":[{"type":1,"value":"issueLabel"},{"type":0,"value":" has been approved"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.declined.by.user.subject":[{"type":1,"value":"user"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.required":[{"type":1,"value":"issueLink"},{"type":0,"value":" requires your approval"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.required.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.footer.contact.us":[{"type":0,"value":"Contact Us"}],"jira-pulsar.jira-issue-approval.message-template.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"jira-pulsar.jira-issue-approval.message-template.email.footer.dot.no-translate":[{"type":0,"value":"&bull;"}],"jira-pulsar.jira-issue-approval.message-template.email.footer.location":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jira-pulsar.jira-issue-approval.message-template.email.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-archived.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" archived "},{"type":1,"value":"issueKey"}],"jira-pulsar.jira-issue-archived.message-template.redacted.email.subject":[{"type":0,"value":"("},{"type":1,"value":"issueKey"},{"type":0,"value":") work item was archived"}],"jira-pulsar.jira-issue-assign.message-template-template.email.body.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"assigned"}],"type":8,"value":"b"},{"type":0,"value":" this work item to you"}],"jira-pulsar.jira-issue-assign.message-template.email.redacted.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"issueKey"},{"type":0,"value":" work item was updated"}],"jira-pulsar.jira-issue-assign.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"issueKey"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assigned.email.body.assignee":[{"type":0,"value":"Assignee"}],"jira-pulsar.jira-issue-assigned.email.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-comment-delete.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-comment-delete.message-template.hipppa.view.update":[{"type":0,"value":"Comment: "},{"children":[{"type":0,"value":"View update"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-comment-delete.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-comment-update.email.body.added":[{"type":0,"value":"Added"}],"jira-pulsar.jira-issue-comment-update.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-comment-update.email.body.edited":[{"type":0,"value":"Edited"}],"jira-pulsar.jira-issue-comment-update.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira-pulsar.jira-issue-comment-update.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-comment.body_image_alt":[{"type":0,"value":"Icon for comment on a Jira issue"}],"jira-pulsar.jira-issue-comment.email.body.view-comment":[{"type":0,"value":"View comment"}],"jira-pulsar.jira-issue-comment.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-create.email.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-moved.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"issueKey"},{"type":0,"value":" "},{"type":1,"value":"summary"}],"jira-pulsar.jira-issue-moved.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-moved.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"issueKey"},{"type":0,"value":" Work item was updated"}],"jira-pulsar.jira-issue-reopen.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"jira-pulsar.jira-issue-reopen.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira-pulsar.jira-issue-reopen.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"jira-pulsar.jira-issue-reopen.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"jira-pulsar.jira-issue-reopened.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-update.email.body.slash.no-translate":[{"type":0,"value":" \u2192 "}],"jira-pulsar.jira-issue-update.message-template.changeby":[{"type":0,"value":"Change by: "},{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-update.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-update.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-update.message-template.hipppa.view.update":[{"children":[{"type":0,"value":"View update"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-work-started.message-template.email.body.started":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"started work on this work item"}],"type":8,"value":"color"}],"jira-pulsar.jira-issue-work-started.message-template.email.redacted.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-work-stopped.message-template.email.body.stopped":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"stopped work on this work item"}],"type":8,"value":"color"}],"jira-pulsar.jira-issue-work-stopped.message-template.email.redacted.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-work-stopped.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" stopped "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-worklog-delete.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-worklog-delete.email.body.work.log.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-worklog-update.email.body.edited":[{"type":0,"value":"Edited"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.add.worklog.title":[{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"},{"type":0,"value":" "},{"children":[{"type":0,"value":"added a worklog"}],"type":8,"value":"strong"},{"type":0,"value":" on "},{"children":[{"type":1,"value":"issueKey"}],"type":8,"value":"b"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.change.by":[{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.add.comment":[{"children":[{"type":0,"value":"Add Comment"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.description":[{"children":[{"type":0,"value":"View work description"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.entry.logged.by":[{"type":1,"value":"entry"},{"type":0,"value":" logged by "},{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklogged.body_image_alt":[{"type":0,"value":"Product logo"}],"jira.default.subject":[{"type":0,"value":"[JIRA] Project Update: "},{"type":1,"value":"projectName"},{"type":0,"value":" ("},{"type":1,"value":"projectKey"},{"type":0,"value":")"}],"jira.jira-bulk.message-template.email.header":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"sent you"}],"type":8,"value":"strong"},{"type":0,"value":" a message."}],"jira.jira-bulk.message-template.email.subject.user.provided.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"subject"}],"jira.jira-bulk.message-template.text.message":[{"type":1,"value":"user"},{"type":0,"value":" sent you a message"}],"jira.jira-common.email.footer.get.apps":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "}],"jira.jira-common.email.footer.give.feedback":[{"type":0,"value":"Give feedback"}],"jira.jira-common.email.footer.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-common.email.footer.open.attachment":[{"type":0,"value":"Open the work item to view attachments over 100 KB"}],"jira.jira-common.email.footer.privacy.policy":[{"type":0,"value":"Privacy Policy"}],"jira.jira-common.email.footer.sent.by":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-common.email.slash.no-translate":[{"type":0,"value":"/"}],"jira.jira-common.message-template.text.body.assignee.label":[{"type":0,"value":"Assignee:"}],"jira.jira-common.message-template.text.body.attachments.label":[{"type":0,"value":"Attachments:"}],"jira.jira-common.message-template.text.body.key.label":[{"type":0,"value":"Key:"}],"jira.jira-common.message-template.text.body.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-common.message-template.text.body.priority.label":[{"type":0,"value":"Priority:"}],"jira.jira-common.message-template.text.body.project.label":[{"type":0,"value":"Project:"}],"jira.jira-common.message-template.text.body.reporter.heading":[{"type":0,"value":"Reporter: "}],"jira.jira-common.message-template.text.body.reporter.label":[{"type":0,"value":"Reporter:"}],"jira.jira-common.message-template.text.body.sent.by":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-common.message-template.text.body.work.type.label":[{"type":0,"value":"Work type:"}],"jira.jira-filter-subscription.message-template.email.table.filter-label":[{"type":0,"value":"Filter: "}],"jira.jira-filter-subscription.message-template.email.table.header":[{"type":0,"value":"Work Item Subscription"}],"jira.jira-filter-subscription.message-template.email.table.subscriber-label":[{"type":0,"value":"Subscriber:"}],"jira.jira-issue-approval-decided.message-template.approval.by.user":[{"type":1,"value":"user"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLink"}],"jira.jira-issue-approval-decided.message-template.approval.event.allapproved.transition":[{"type":1,"value":"issueTypeName"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.plural":[{"type":1,"value":"remainingApprovals"},{"type":0,"value":" more approvals required to move this "},{"type":1,"value":"issueTypeName"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.singular":[{"type":0,"value":"1 more approval required to move this "},{"type":1,"value":"issueTypeName"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.declined.transition":[{"type":1,"value":"issueTypeName"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.declined.by.user":[{"type":1,"value":"user"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLink"}],"jira.jira-issue-approval.message-template.approval.required.title":[{"type":1,"value":"issueLabel"},{"type":0,"value":" requires your approval"}],"jira.jira-issue-approval.message-template.approval.title.all-approved":[{"type":1,"value":"issueLink"},{"type":0,"value":" has been approved!"}],"jira.jira-issue-approval.message-template.email.approval.approved":[{"type":0,"value":"Approved"}],"jira.jira-issue-approval.message-template.email.approval.approvers.remaining":[{"type":1,"value":"remainingApprovers"},{"type":0,"value":" more approvals required to move this "},{"type":1,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-approval.message-template.email.approval.assigned.to":[{"type":0,"value":"Assigned to: "},{"type":1,"value":"assignee"}],"jira.jira-issue-approval.message-template.email.approval.declined":[{"type":0,"value":"Declined"}],"jira.jira-issue-approval.message-template.email.approval.declined.transition":[{"type":1,"value":"issueType"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"declinedStatus"}],"jira.jira-issue-approval.message-template.email.approval.event.approvers":[{"type":0,"value":"Approvers: "}],"jira.jira-issue-approval.message-template.email.approval.one.approver.remaining":[{"type":0,"value":"1 more approval required to move this "},{"type":1,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-approval.message-template.email.approval.view.work.item":[{"type":0,"value":"View "},{"type":1,"value":"issueType"}],"jira.jira-issue-approval.message-template.email.approved.by":[{"type":1,"value":"deciderName"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLabel"}],"jira.jira-issue-approval.message-template.email.declined.by":[{"type":1,"value":"deciderName"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLabel"}],"jira.jira-issue-approval.message-template.email.footer.contact.us":[{"type":0,"value":"Contact Us"}],"jira.jira-issue-approval.message-template.email.footer.location":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jira.jira-issue-approval.message-template.email.footer.privacy.policy":[{"type":0,"value":"Privacy Policy"}],"jira.jira-issue-approval.message-template.email.issue.approved":[{"type":1,"value":"issueLabel"},{"type":0,"value":" has been approved!"}],"jira.jira-issue-approval.message-template.email.issue.has.moved.from":[{"type":1,"value":"issueType"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-archived.message-template.email.subject":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"archived a work item."}],"type":8,"value":"strong"}],"jira.jira-issue-archived.message-template.redacted.email.subject":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"archived a work item."}],"type":8,"value":"strong"}],"jira.jira-issue-archived.message-template.text.archived.work.item":[{"type":1,"value":"user"},{"type":0,"value":" archived "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-assign.text.body.assigned":[{"type":0,"value":" "},{"type":1,"value":"user"},{"type":0,"value":" reassigned "},{"type":1,"value":"issueKey"}],"jira.jira-issue-assign.text.body.assignee.update":[{"type":0,"value":"Assignee: "},{"type":1,"value":"assigneeName"},{"type":0,"value":" was: ("},{"type":1,"value":"oldAssigneeName"},{"type":0,"value":")"}],"jira.jira-issue-assign.text.body.sentby":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-issue-batch.email.body.issue.comments.heading":[{"type":0,"value":"Comments"}],"jira.jira-issue-batch.email.body.issue.created.heading":[{"type":0,"value":"Work item created"}],"jira.jira-issue-batch.email.body.issue.updates.heading":[{"type":0,"value":"Updates"}],"jira.jira-issue-batch.email.body.issue.worklog.heading":[{"type":0,"value":"Work log"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" added a new comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" updated a comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.created.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"created a work item"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a work item"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work items"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.dot":[{"type":0,"value":". "}],"jira.jira-issue-batch.email.body.summary.issue.separator.comma":[{"type":0,"value":", "}],"jira.jira-issue-batch.email.body.summary.issue.updates.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"type":1,"value":"count"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.updates.multiple.users.heading":[{"type":1,"value":"user"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.updates.two.users.heading":[{"type":1,"value":"user"},{"type":0,"value":" and "},{"type":1,"value":"user1"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" added a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" started a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" updated a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issueId"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira.jira-issue-batch.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] Updates for "},{"type":1,"value":"issueId"}],"jira.jira-issue-closed.message-template.text.email.body":[{"type":1,"value":"user"},{"type":0,"value":" closed "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-comment-delete.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment-delete.message-template.text.comment.was.deleted":[{"type":0,"value":"Comment: was deleted"}],"jira.jira-issue-comment-delete.message-template.text.updated.work.item":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-comment-update.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"edited a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment-update.message-template.text.body.comment.was":[{"type":0,"value":"was (Author: "},{"type":1,"value":"authorName"},{"type":0,"value":"):"}],"jira.jira-issue-comment-update.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" edited a comment on "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-comment.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"added a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-common.message-template.text.body.common.author":[{"type":0,"value":"Author:"}],"jira.jira-issue-common.message-template.text.body.common.issue.author":[{"type":0,"value":"Author:"}],"jira.jira-issue-create.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"created a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-create.email.body.view.attachments":[{"type":0,"value":"View Attachments"}],"jira.jira-issue-create.email.body.view.components":[{"type":0,"value":"View Components"}],"jira.jira-issue-create.email.body.view.description":[{"type":0,"value":"View description"}],"jira.jira-issue-create.email.body.view.environment":[{"type":0,"value":"View environment"}],"jira.jira-issue-create.email.body.view.labels":[{"type":0,"value":"View labels"}],"jira.jira-issue-create.email.body.view.work.type":[{"type":0,"value":"View Work Type"}],"jira.jira-issue-create.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" created "},{"type":1,"value":"issueKey"}],"jira.jira-issue-create.message-template.text.body.common.issue.key":[{"type":0,"value":"Key"}],"jira.jira-issue-create.message-template.text.body.common.summary":[{"type":0,"value":"Summary"}],"jira.jira-issue-create.message-template.text.email.body.created":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"jira.jira-issue-create.text.body.common.assignee":[{"type":0,"value":"Assignee"}],"jira.jira-issue-create.text.body.common.attachments":[{"type":0,"value":"Attachments"}],"jira.jira-issue-create.text.body.common.created":[{"type":0,"value":"Created"}],"jira.jira-issue-create.text.body.common.description":[{"type":0,"value":"Description"}],"jira.jira-issue-create.text.body.common.priority":[{"type":0,"value":"Priority"}],"jira.jira-issue-create.text.body.common.reporter":[{"type":0,"value":"Reporter"}],"jira.jira-issue-create.text.body.common.status":[{"type":0,"value":"Status"}],"jira.jira-issue-create.text.body.common.work.type":[{"type":0,"value":"Work type"}],"jira.jira-issue-delete.message-template.email.body.workitem.deleted":[{"type":1,"value":"actioner"},{"type":0,"value":" deleted this work item at "},{"type":1,"value":"timestamp"}],"jira.jira-issue-delete.message-template.redacted.email.body.workitem.deleted":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted"}],"type":8,"value":"strong"},{"type":0,"value":" a work item"}],"jira.jira-issue-delete.message-template.text.deleted.work.item":[{"type":1,"value":"user"},{"type":0,"value":" deleted "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-filter-subscription.message-template.email.subject":[{"type":0,"value":"[JIRA] Subscription: "},{"type":1,"value":"filterName"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header":[{"type":0,"value":"Work Item Subscription"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header.filter-name":[{"type":0,"value":"Filter: "},{"type":1,"value":"filterName"},{"type":1,"value":"count"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header.subscriber-info":[{"type":0,"value":"Subscriber: "},{"type":1,"value":"subscriberName"}],"jira.jira-issue-mention.email.body.colon.no-translate":[{"type":0,"value":": "}],"jira.jira-issue-mention.email.body.mentioned.you":[{"type":0,"value":" mentioned you "}],"jira.jira-issue-mention.email.body.onWorkItem.you":[{"type":0,"value":" on a work item "}],"jira.jira-issue-mention.email.body.spaces.no-translate":[{"type":0,"value":"&nbsp;&nbsp;"}],"jira.jira-issue-mention.email.body.view.work.item":[{"type":0,"value":" View work item "}],"jira.jira-issue-mention.email.subject.mention":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-mention.push.mentioned.you":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"jira.jira-issue-mention.push.mentioned.you.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on this work item"}],"jira.jira-issue-mention.text.body.addComment":[{"type":0,"value":" Add Comment: "}],"jira.jira-issue-mention.text.body.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-issue-mention.text.body.mention.hint":[{"type":0,"value":" Hint: You can mention someone in a work item description or comment by typing  \\"@\\" in front of their username."}],"jira.jira-issue-mention.text.body.mentioned":[{"type":0,"value":" mentioned you on "}],"jira.jira-issue-mention.text.body.sentby":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-issue-mention.text.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira.jira-issue-mention.text.body.viewOnline":[{"type":0,"value":" View Online: "}],"jira.jira-issue-moved.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"moved a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-moved.message-template.text.email.body":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-notify.email.body.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"b"},{"type":0,"value":" a work item with you"}],"jira.jira-issue-notify.email.subject.notify":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared \\""},{"type":1,"value":"issueKey"},{"type":0,"value":" "},{"type":1,"value":"summary"},{"type":0,"value":"\\" with you"}],"jira.jira-issue-reopened.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" reopened "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-resolved.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" resolved "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-search.message-template.email.subject.filter.results":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared the filter \\""},{"type":1,"value":"filterName"},{"type":0,"value":"\\" with you"}],"jira.jira-issue-search.message-template.email.subject.search.results":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared a search result with you"}],"jira.jira-issue-share.message-template.email.header.filter":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"strong"},{"type":0,"value":" a filter with you."}],"jira.jira-issue-share.message-template.email.header.results":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"strong"},{"type":0,"value":" a search result with you."}],"jira.jira-issue-share.message-template.email.view.results":[{"type":0,"value":"View search results"}],"jira.jira-issue-share.message-template.text.shared.filter.heading":[{"type":1,"value":"user"},{"type":0,"value":" shared a filter with you"}],"jira.jira-issue-share.message-template.text.shared.results.heading":[{"type":1,"value":"user"},{"type":0,"value":" shared a search result with you"}],"jira.jira-issue-share.message-template.text.shared.with.others":[{"type":0,"value":"Also shared with"}],"jira.jira-issue-test.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] test template "},{"type":1,"value":"issueKey"}],"jira.jira-issue-update.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-update.message-template.email.body.worklog.change.by":[{"type":0,"value":"Change by: "}],"jira.jira-issue-update.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-work-started.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"made "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" update"}]},"other":{"value":[{"type":7},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfUpdates"}],"type":8,"value":"strong"}],"jira.jira-issue-work-started.message-template.text.header":[{"type":0,"value":"Work on "},{"type":1,"value":"workItemKey"},{"type":0,"value":" started by "},{"type":1,"value":"user"}],"jira.jira-issue-work-stopped.message-template.text.header":[{"type":0,"value":"Work on "},{"type":1,"value":"workItemKey"},{"type":0,"value":" stopped by "},{"type":1,"value":"user"}],"jira.jira-issue-worklog-delete.message-template.email.redacted.body.title":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted a worklog"}],"type":8,"value":"b"},{"type":0,"value":" on a work item"}],"jira.jira-issue-worklog-delete.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" deleted a worklog on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-worklog-deleted.message-template.text.email.body.deleted.worklog":[{"type":0,"value":"The following worklog was deleted:"}],"jira.jira-issue-worklog-update.message-template.email.body.title":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"edited 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklog-update.message-template.email.redacted.body.title":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a worklog"}],"type":8,"value":"b"},{"type":0,"value":" on a work item"}],"jira.jira-issue-worklog-updated.message-template.email.body.description":[{"type":0,"value":"Description"}],"jira.jira-issue-worklog-updated.message-template.email.body.timeLogged":[{"type":0,"value":"Time logged"}],"jira.jira-issue-worklogged.message-template.email.body.description":[{"type":0,"value":"Description: "}],"jira.jira-issue-worklogged.message-template.email.body.logTitle":[{"type":0,"value":"Work log"}],"jira.jira-issue-worklogged.message-template.email.body.timelogged":[{"type":0,"value":"Time logged: "}],"jira.jira-issue-worklogged.message-template.email.body.title":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"added 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklogged.message-template.email.body.updateTitle":[{"type":0,"value":"Updates"}],"jira.jira-issue-worklogged.message-template.email.body.worklog.change.by":[{"type":0,"value":"Change by: "}],"jira.jira-issue-worklogged.message-template.email.body.worklog.entry":[{"type":0,"value":"Worklog entry:"}],"jira.jira-issue-worklogged.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" logged work on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-worklogged.message-template.text.body.common.change.by":[{"type":0,"value":"Change by"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.created.on":[{"type":0,"value":"Created on:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.by":[{"type":0,"value":"Edited by:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.on":[{"type":0,"value":"Edited on:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.key":[{"type":0,"value":"Key:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.worklog.entry.label":[{"type":0,"value":"Worklog entry"}],"jira.jira-issue-worklogged.message-template.text.body.common.project":[{"type":0,"value":"Project:"}],"jira.jira-issue-worklogged.message-template.text.body.common.start.date":[{"type":0,"value":"Start Date:"}],"jira.jira-issue-worklogged.message-template.text.body.common.time.spent":[{"type":0,"value":"Time Spent:"}],"jira.jira-issue-worklogged.message-template.text.body.common.url":[{"type":0,"value":"URL:"}],"jira.jira-issue-worklogged.message-template.text.body.common.view.work.description":[{"type":0,"value":"View work description"}],"jira.jira-issue-worklogged.message-template.text.body.common.work.type":[{"type":0,"value":"Work type:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.body":[{"type":0,"value":"Work Description:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.description":[{"type":0,"value":"Worklog Description:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.description.was":[{"type":0,"value":"Worklog Description was:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.id":[{"type":0,"value":"Worklog Id:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.estimated":[{"type":0,"value":"Remaining Estimate:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.spent":[{"type":0,"value":"Worklog Time Spent:"}],"jira.jira-issue-worklogged.message-template.text.body.redacted.logged.by":[{"type":1,"value":"worklogEntry"},{"type":0,"value":" logged by "},{"type":1,"value":"actioner"}],"jira.jira-issue-worklogged.message-template.text.email.body.created":[{"type":1,"value":"user"},{"type":0,"value":" logged work on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-worklogged.message-template.text.email.body.tracking":[{"type":0,"value":"Issue time Tracking"}],"jira.jira-project-event-archived-restore.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project restored from archive "}],"jira.jira-project-event-archived.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project archived"}],"jira.jira-project-event-delete-failed.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Could not permanently delete the project "}],"jira.jira-project-event-deleted-restore.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project restored from trash"}],"jira.jira-project-event-deleted.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project moved to trash"}],"jira.jira-project-event-user-invited.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"userName"},{"type":0,"value":") invited you to ("},{"type":1,"value":"projectName"},{"type":0,"value":")  "}],"jira.project.event.restore.admin.permission.generic.message":[{"type":0,"value":"Only Jira admins can restore the project."}],"jira.user.premium-plan.requested.email.explaination":[{"type":0,"value":"You can try Jira Premium for free with no commitment. This trial period includes access\\n\\t\\t\\t\\tto our advanced planning features plus other great functionalities that unlock new ways\\n\\t\\t\\t\\tof working for your teams."}],"jira.user.premium-plan.requested.email.greeting":[{"type":0,"value":"Hi,"}],"jira.user.premium-plan.requested.email.learn-more":[{"type":0,"value":"Learn more about Jira Premium."}],"jira.user.premium-plan.requested.email.start-trial":[{"type":0,"value":"Start your Jira Premium trial"}],"jira.user.premium-plan.requested.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" has requested a free trial of Jira Premium"}],"jira.user.premium-plan.requested.email.text":[{"type":1,"value":"user"},{"type":0,"value":" has requested a free trial of Jira Premium."}],"note.added.by.user":[{"type":1,"value":"userName"},{"type":0,"value":" added this note"}],"post-office.jira-pulsar.jira-issue-approval.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-archived.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-closed.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-comment-delete.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-comment-update.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-delete.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-generic.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-moved.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-resolved.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-update.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.placement.jira-top-banner.primary-message":[{"type":0,"value":"As we roll out \'work\' as the new term for items tracked in Jira, you may still see \'issue\' in some areas."}],"postoffice.jira.issue.common.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.metioned.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.metioned.get-android.no-translate":[{"type":0,"value":" Android "}],"postoffice.jira.issue.metioned.get-ios.no-translate":[{"type":0,"value":" iOS. "}],"postoffice.jira.issue.metioned.get-or.no-translate":[{"type":0,"value":" or"}],"postoffice.jira.issue.work.started.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.work.stopped.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.worklogged.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.project.event.avatar.no-translate":[{"type":0,"value":"avatar"}],"postoffice.jira.project.event.blueprint.no-translate":[{"type":0,"value":"blueprintLogo"}],"postoffice.jira.project.event.globe.no-translate":[{"type":0,"value":"globeLogo"}],"postoffice.jira.project.event.logo.no-translate":[{"type":0,"value":"logo"}],"postoffice.jira.project.event.write.no-translate":[{"type":0,"value":"writeLogo"}],"push.mobile.issue.approval.requested.description":[{"type":0,"value":"on "},{"type":1,"value":"summary"}],"push.mobile.issue.approval.requested.title":[{"type":0,"value":"Approval requested"}],"push.mobile.issue.assignment.description.assigned.others":[{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"assignee"}],"push.mobile.issue.assignment.description.assigned.you":[{"type":1,"value":"user"},{"type":0,"value":" assigned you to "},{"type":1,"value":"summary"}],"push.mobile.issue.assignment.description.unassigned.others":[{"type":1,"value":"user"},{"type":0,"value":" unassigned "},{"type":1,"value":"oldAssignee"},{"type":0,"value":" from "},{"type":1,"value":"summary"}],"push.mobile.issue.assignment.description.unassigned.you":[{"type":1,"value":"user"},{"type":0,"value":" unassigned you from "},{"type":1,"value":"summary"}],"push.mobile.issue.attachment.added.description":[{"type":1,"value":"user"},{"type":0,"value":" added an attachment to "},{"type":1,"value":"summary"}],"push.mobile.issue.attachment.added.description.redacted":[{"type":1,"value":"user"},{"type":0,"value":" added an attachment"}],"push.mobile.issue.comment.added.android.description":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.added.ios.body.redacted":[{"type":0,"value":"commented on this work item"}],"push.mobile.issue.comment.added.ios.subtitle":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.android.description":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.android.description.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you in a comment on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.ios.subtitle":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.ios.subtitle.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you in a comment on this work item"}],"push.mobile.issue.create.android.description":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"push.mobile.issue.create.android.title":[{"type":0,"value":"Work item Created"}],"push.mobile.issue.create.ios.body.redacted":[{"type":0,"value":"Open to view work item details"}],"push.mobile.issue.create.ios.subtitle":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"push.mobile.issue.transition.description.resolved":[{"type":0,"value":"\u2714 "},{"type":1,"value":"user"},{"type":0,"value":" resolved "},{"type":1,"value":"summary"}],"push.mobile.issue.transition.description.resolved.redacted":[{"type":0,"value":"\u2714 "},{"type":1,"value":"user"},{"type":0,"value":" resolved this work item"}],"push.mobile.issue.transition.ios.description":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"status"}],"push.mobile.issue.transition.ios.description.redacted":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"status"}],"st-office.placement.jira-top-banner.primary-cta-text":[{"type":0,"value":"Read about this terminology change"}],"template.project.event.admins.permission.message":[{"type":0,"value":"Only Jira admins can restore the project."}],"template.project.event.project.archive.restore.body.template":[{"type":0,"value":" "},{"type":1,"value":"userName"},{"type":0,"value":" restored this project from archive on "},{"type":1,"value":"eventTime"}],"template.project.event.project.archived.body.template":[{"type":1,"value":"userName"},{"type":0,"value":" archived this project on "},{"type":1,"value":"eventTime"}],"template.project.event.project.archived.body.template.archive-link":[{"type":0,"value":"archive "}],"template.project.event.project.archived.body.template.archive.forever":[{"type":0,"value":" forever"}],"template.project.event.project.archived.body.template.generic.message":[{"type":0,"value":"This project and its issues, components, attachments, and versions will be available in the "}],"template.project.event.project.deleted.body.template":[{"type":1,"value":"userName"},{"type":0,"value":" moved this project to trash on "},{"type":1,"value":"eventTime"}],"template.project.event.project.deleted.body.template.archive.forever":[{"type":0,"value":"forever"}],"template.project.event.project.deleted.body.template.generic.message":[{"type":0,"value":"This project and its issues, components, attachments, and versions will be available in the "}],"template.project.event.project.deleted.body.template.trash-link":[{"type":0,"value":"trash "}],"template.project.event.project.deleted.failure.body.template.generic.message":[{"type":0,"value":"It\'s probably a temporary problem. "}],"template.project.event.project.deleted.failure.body.template.trash-link":[{"type":0,"value":" Go to trash "}],"template.project.event.project.deleted.failurebody.template.archive.forever":[{"type":0,"value":" and try again. If it persists, please contact support. "}],"template.project.event.project.deleted.restore.body.template":[{"type":0,"value":" "},{"type":1,"value":"userName"},{"type":0,"value":" restored this project from trash on "},{"type":1,"value":"eventTime"}],"template.project.event.project.deletion.failure.body.template":[{"type":0,"value":"We couldn\'t delete this project"}],"template.project.event.project.privacy.contactus.template":[{"type":0,"value":"Contact us"}],"template.project.event.project.privacy.copyright.template":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"template.project.event.project.privacy.location.template":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"template.project.event.project.privacy.policy.template":[{"type":0,"value":"Privacy policy"}],"template.project.event.project.privacy.policy.template.dot":[{"type":0,"value":"."}],"template.project.event.project.user.invited.and.message":[{"type":0,"value":" and"}],"template.project.event.project.user.invited.collborate.message":[{"type":0,"value":"Collaborate, align, and deliver work, all in"}],"template.project.event.project.user.invited.collect.message":[{"type":0,"value":"Collect and send work to other teams or stakeholders using "}],"template.project.event.project.user.invited.forms.message":[{"type":0,"value":"  forms"}],"template.project.event.project.user.invited.join.link":[{"type":0,"value":"Join the Project"}],"template.project.event.project.user.invited.learn.more.message":[{"type":0,"value":"Learn more about Jira "}],"template.project.event.project.user.invited.list.message":[{"type":0,"value":" list, board, calendar"}],"template.project.event.project.user.invited.one.place.message":[{"type":0,"value":" one place"}],"template.project.event.project.user.invited.timeline.message":[{"type":0,"value":" timeline"}],"template.project.event.project.user.invited.use.jira.generic.message":[{"type":0,"value":"Use Jira to..."}],"template.project.event.project.user.invited.view.work.message":[{"type":0,"value":"View work your way using the"}],"template.project.event.project.user.invited.views.message":[{"type":0,"value":" views"}],"template.subscription.filter.count.issue-term-refresh":[{"type":0,"value":" ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":")"}],"template.subscription.filter.footer.edit.subscription":[{"type":0,"value":"here"}],"template.subscription.filter.html.subset.issue-term-refresh":[{"type":0,"value":"Displaying "},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" matched work items. "}],"template.subscription.filter.html.view.filter.work-items":[{"type":0,"value":"View all of them"}],"template.subscription.filter.redacted.html.edit":[{"type":0,"value":"You may edit this subscription "}],"template.subscription.filter.redacted.html.view.filter":[{"type":0,"value":"Details are hidden to protect sensitive data."}],"template.subscription.filter.redacted.html.view.filter.link":[{"type":0,"value":"View the filter"}],"template.subscription.filter.subcount.issue-term-refresh":[{"type":0,"value":"  ("},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" work items)"}],"template.subscription.filter.text.count.issue-term-refresh":[{"type":0,"value":" ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":")"}],"template.subscription.filter.text.subcount.issue-term-refresh":[{"type":0,"value":" ("},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" work items)"}],"user.avatar.alt":[{"type":0,"value":"User avatar"}]}');

});

parcelRegister("1Aa6w", function(module, exports) {

let $1270fdb742b02ece$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1270fdb742b02ece$var$load("jowT6").then(()=>parcelRequire('48qyU'));

});

parcelRegister("jdey0", function(module, exports) {

let $dfca8409d725924e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dfca8409d725924e$var$load("ilQK3").then(()=>parcelRequire('hOArl'));

});

parcelRegister("4Dj4W", function(module, exports) {

let $35f99a9549952d07$var$load = (parcelRequire("28QjX"))(4);
module.exports = $35f99a9549952d07$var$load("8OCbm").then(()=>parcelRequire('ff5v9'));

});

parcelRegister("kv72q", function(module, exports) {

let $eecc29882d9c490a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eecc29882d9c490a$var$load("3aGx7").then(()=>parcelRequire('bj47Q'));

});

parcelRegister("hcGnX", function(module, exports) {

let $c8646f813b8e2e9c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c8646f813b8e2e9c$var$load("7IUB7").then(()=>parcelRequire('cKalR'));

});

parcelRegister("7GQkj", function(module, exports) {

let $59950b9e7e11bfd7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $59950b9e7e11bfd7$var$load("7kVoX").then(()=>parcelRequire('dOvIp'));

});

parcelRegister("7q60Z", function(module, exports) {

let $566fa09217addec4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $566fa09217addec4$var$load("3JEf6").then(()=>parcelRequire('090Qi'));

});

parcelRegister("bJuCa", function(module, exports) {

let $88aba516ce66ea42$var$load = (parcelRequire("28QjX"))(4);
module.exports = $88aba516ce66ea42$var$load("gbxN6").then(()=>parcelRequire('em7Y8'));

});

parcelRegister("7Ebgw", function(module, exports) {

let $591501e5e9daf222$var$load = (parcelRequire("28QjX"))(4);
module.exports = $591501e5e9daf222$var$load("fXVMa").then(()=>parcelRequire('3TOuk'));

});

parcelRegister("8ZUOb", function(module, exports) {

let $68d0162df4d2e44c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $68d0162df4d2e44c$var$load("kF1Zi").then(()=>parcelRequire('15XFj'));

});

parcelRegister("5CKGD", function(module, exports) {

let $4184b757159e0f4c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4184b757159e0f4c$var$load("h74XT").then(()=>parcelRequire('6KYJl'));

});

parcelRegister("kTRhT", function(module, exports) {

let $f372477d4bddc3e2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f372477d4bddc3e2$var$load("e5buu").then(()=>parcelRequire('bTw5r'));

});

parcelRegister("i6G7w", function(module, exports) {

let $d2e975beda48ab05$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d2e975beda48ab05$var$load("gKk36").then(()=>parcelRequire('4vwvk'));

});

parcelRegister("7Rm47", function(module, exports) {

let $5b8e99637abcb4ad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5b8e99637abcb4ad$var$load("8KLWf").then(()=>parcelRequire('kiVdS'));

});

parcelRegister("entUQ", function(module, exports) {

let $a77a6b575378cddc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a77a6b575378cddc$var$load("1m6vp").then(()=>parcelRequire('4LxZT'));

});

parcelRegister("fbWbn", function(module, exports) {

let $b0f503eab46e2bf6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b0f503eab46e2bf6$var$load("boJ01").then(()=>parcelRequire('7RDR5'));

});

parcelRegister("acY2A", function(module, exports) {

let $76e9993039665fc4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $76e9993039665fc4$var$load("kvQ8n").then(()=>parcelRequire('30NnA'));

});

parcelRegister("4OwMB", function(module, exports) {

let $381542ee889eb8cb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $381542ee889eb8cb$var$load("aUV6Y").then(()=>parcelRequire('2U8sz'));

});

parcelRegister("fCvWB", function(module, exports) {

let $b5f32f11497a3597$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b5f32f11497a3597$var$load("hzHvU").then(()=>parcelRequire('dWVUA'));

});

parcelRegister("1hpg4", function(module, exports) {

let $0eeaf8bef0855402$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0eeaf8bef0855402$var$load("4U258").then(()=>parcelRequire('4Q2fc'));

});

parcelRegister("7oyaA", function(module, exports) {

let $562547b886ce6cd9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $562547b886ce6cd9$var$load("go3oZ").then(()=>parcelRequire('cxPmB'));

});

parcelRegister("2TjRL", function(module, exports) {

let $21b020d8e8773d6e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $21b020d8e8773d6e$var$load("9gEN4").then(()=>parcelRequire('kG4oH'));

});

parcelRegister("eKbNm", function(module, exports) {

let $abbe82da7570d126$var$load = (parcelRequire("28QjX"))(4);
module.exports = $abbe82da7570d126$var$load("4ZC4l").then(()=>parcelRequire('4faK1'));

});

parcelRegister("bmowM", function(module, exports) {

let $8454c67acdaf36ee$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8454c67acdaf36ee$var$load("9hyfr").then(()=>parcelRequire('ichil'));

});

parcelRegister("f1Wu8", function(module, exports) {

let $af1450f085f72719$var$load = (parcelRequire("28QjX"))(4);
module.exports = $af1450f085f72719$var$load("gYu8q").then(()=>parcelRequire('kI6fy'));

});

parcelRegister("hffaE", function(module, exports) {

let $c8df9af69fe1fcef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c8df9af69fe1fcef$var$load("8ZjHb").then(()=>parcelRequire('dAQGl'));

});

parcelRegister("5afCd", function(module, exports) {

let $3c29ffd2f1b16124$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3c29ffd2f1b16124$var$load("deIvc").then(()=>parcelRequire('bf3fm'));

});

parcelRegister("77AfZ", function(module, exports) {

let $52f54fb1f5174b12$var$load = (parcelRequire("28QjX"))(4);
module.exports = $52f54fb1f5174b12$var$load("02YkI").then(()=>parcelRequire('6XXyt'));

});

parcelRegister("9ffzi", function(module, exports) {

let $6bb1974d7acef5dd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6bb1974d7acef5dd$var$load("4wyjm").then(()=>parcelRequire('3aukh'));

});


parcelRegister("fJUJM", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $e662814fb82cdf34$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $bZUHK = parcelRequire("bZUHK");

var $2AtjH = parcelRequire("2AtjH");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e662814fb82cdf34$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $e662814fb82cdf34$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $2AtjH.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("5AXCj")));
        case 'da':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("khTA5")));
        case 'de':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("9mRna")));
        case 'en-GB':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("e1SVQ")));
        case 'en-US':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("6N3fx")));
        case 'en-XA':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("2Ctko")));
        case 'en-XB':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("dqAu2")));
        case 'en-ZZ':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("bqySC")));
        case 'en':
            return $e662814fb82cdf34$var$importHelper(await Promise.resolve((parcelRequire("bZUHK"))));
        case 'es':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("fMzTR")));
        case 'et':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("fI5Zq")));
        case 'fi':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("6iui9")));
        case 'fr':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("lMW8m")));
        case 'hu':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("5ubwJ")));
        case 'it':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("iYqkj")));
        case 'ja':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("kC4Lp")));
        case 'ko':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("ghA7e")));
        case 'nb':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("e1JKl")));
        case 'nl':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("1XwIM")));
        case 'pl':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("leHHs")));
        case 'pt-BR':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("lj54n")));
        case 'ro':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("6rIs0")));
        case 'ru':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("6ipoX")));
        case 'sv':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("htVCY")));
        case 'th':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("fwKNL")));
        case 'tr':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("krOcU")));
        case 'uk':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("iAh7o")));
        case 'vi':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("1Vpu8")));
        case 'zh-CN':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("jM2lN")));
        case 'zh-TW':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("gIlyn")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($bZUHK));
    }
};

});
parcelRegister("bZUHK", function(module, exports) {
module.exports = JSON.parse("{\"post-office-template.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"post-office-template.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"post-office-template.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"post-office-template.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"post-office-template.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"post-office-template.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"post-office-template.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.components.{component-name}.{location-name}.{message-name}\":[{\"type\":0,\"value\":\"Example\"}],\"post-office.post-office-template.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.post-office-template.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");

});

parcelRegister("5AXCj", function(module, exports) {

let $412e8f367e3232ab$var$load = (parcelRequire("28QjX"))(4);
module.exports = $412e8f367e3232ab$var$load("dyQbB").then(()=>parcelRequire('8TGXU'));

});

parcelRegister("khTA5", function(module, exports) {

let $ec508267a61f3b18$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ec508267a61f3b18$var$load("32QYd").then(()=>parcelRequire('lWsj3'));

});

parcelRegister("9mRna", function(module, exports) {

let $6d1f91cdde5ca2f2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6d1f91cdde5ca2f2$var$load("4l7ZQ").then(()=>parcelRequire('grGfH'));

});

parcelRegister("e1SVQ", function(module, exports) {

let $a36bc5092acb7349$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a36bc5092acb7349$var$load("3d8Qb").then(()=>parcelRequire('drL7k'));

});

parcelRegister("6N3fx", function(module, exports) {

let $4f19d6ff16d87799$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4f19d6ff16d87799$var$load("1yDVc").then(()=>parcelRequire('7JbDo'));

});

parcelRegister("2Ctko", function(module, exports) {

let $1e85e14edbec266b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1e85e14edbec266b$var$load("2DU0q").then(()=>parcelRequire('aoD1a'));

});

parcelRegister("dqAu2", function(module, exports) {

let $9c6a00ec88d947c5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9c6a00ec88d947c5$var$load("8cWT4").then(()=>parcelRequire('aRs4b'));

});

parcelRegister("bqySC", function(module, exports) {

let $851d2dd3f415fdeb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $851d2dd3f415fdeb$var$load("7o9pj").then(()=>parcelRequire('7RqNa'));

});

parcelRegister("fMzTR", function(module, exports) {

let $b7d72fb5d2802984$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b7d72fb5d2802984$var$load("e4Idr").then(()=>parcelRequire('2HMYZ'));

});

parcelRegister("fI5Zq", function(module, exports) {

let $b6ff9c81c74459fa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b6ff9c81c74459fa$var$load("8mepu").then(()=>parcelRequire('dG47B'));

});

parcelRegister("6iui9", function(module, exports) {

let $495bebd2ea958386$var$load = (parcelRequire("28QjX"))(4);
module.exports = $495bebd2ea958386$var$load("dMRB2").then(()=>parcelRequire('15aZt'));

});

parcelRegister("lMW8m", function(module, exports) {

let $fdcb2cd6f0e21307$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fdcb2cd6f0e21307$var$load("kuElu").then(()=>parcelRequire('4xOJg'));

});

parcelRegister("5ubwJ", function(module, exports) {

let $3fe8b21bdf4122db$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3fe8b21bdf4122db$var$load("rE0x9").then(()=>parcelRequire('bZPwi'));

});

parcelRegister("iYqkj", function(module, exports) {

let $03908d6d7bf5af66$var$load = (parcelRequire("28QjX"))(4);
module.exports = $03908d6d7bf5af66$var$load("4Dwf2").then(()=>parcelRequire('i2rQL'));

});

parcelRegister("kC4Lp", function(module, exports) {

let $f01b0d3d5e186961$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f01b0d3d5e186961$var$load("c9qyC").then(()=>parcelRequire('byicS'));

});

parcelRegister("ghA7e", function(module, exports) {

let $bdaa3fb17fc3040e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bdaa3fb17fc3040e$var$load("kPmXi").then(()=>parcelRequire('6Crb3'));

});

parcelRegister("e1JKl", function(module, exports) {

let $a364a4fd3098a966$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a364a4fd3098a966$var$load("h8Me2").then(()=>parcelRequire('kAj5d'));

});

parcelRegister("1XwIM", function(module, exports) {

let $16d4aee7706a9721$var$load = (parcelRequire("28QjX"))(4);
module.exports = $16d4aee7706a9721$var$load("9jpLq").then(()=>parcelRequire('bJDhT'));

});

parcelRegister("leHHs", function(module, exports) {

let $f75ccdb375a43784$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f75ccdb375a43784$var$load("ieQDS").then(()=>parcelRequire('jVGfH'));

});

parcelRegister("lj54n", function(module, exports) {

let $f82f4e0a20ee5fef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f82f4e0a20ee5fef$var$load("3yHdQ").then(()=>parcelRequire('eJMof'));

});

parcelRegister("6rIs0", function(module, exports) {

let $4b17beaf2dd0e82f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4b17beaf2dd0e82f$var$load("lcAhY").then(()=>parcelRequire('graEZ'));

});

parcelRegister("6ipoX", function(module, exports) {

let $495820c1744cf404$var$load = (parcelRequire("28QjX"))(4);
module.exports = $495820c1744cf404$var$load("hyioc").then(()=>parcelRequire('fTAyV'));

});

parcelRegister("htVCY", function(module, exports) {

let $cba1d8c0060ffbc9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cba1d8c0060ffbc9$var$load("avXYJ").then(()=>parcelRequire('3zrQg'));

});

parcelRegister("fwKNL", function(module, exports) {

let $b4de26012cfa1cfc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b4de26012cfa1cfc$var$load("hjAQK").then(()=>parcelRequire('3zK2p'));

});

parcelRegister("krOcU", function(module, exports) {

let $ee2d4660c617ef98$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee2d4660c617ef98$var$load("5O6ot").then(()=>parcelRequire('dbL6c'));

});

parcelRegister("iAh7o", function(module, exports) {

let $d878de16c3e324e2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d878de16c3e324e2$var$load("DQUYM").then(()=>parcelRequire('6vQva'));

});

parcelRegister("1Vpu8", function(module, exports) {

let $166ee2218b6f6f2b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $166ee2218b6f6f2b$var$load("bfhS3").then(()=>parcelRequire('5NDsz'));

});

parcelRegister("jM2lN", function(module, exports) {

let $e65452c91820d12f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e65452c91820d12f$var$load("dH62H").then(()=>parcelRequire('g9sed'));

});

parcelRegister("gIlyn", function(module, exports) {

let $c2b17976ef7f88ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c2b17976ef7f88ca$var$load("jynfz").then(()=>parcelRequire('c3H0z'));

});




parcelRegister("4yEIl", function(module, exports) {

$parcel$export(module.exports, "PostOfficeProvider", () => $21214568f856c41e$export$fb465b6e855c1e85);
$parcel$export(module.exports, "PostOfficeRouterListener", () => $21214568f856c41e$export$9f8d3084fd3d5fc0);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $4R6GH = parcelRequire("4R6GH");

var $jQsty = parcelRequire("jQsty");

var $lpwtK = parcelRequire("lpwtK");

var $14XJw = parcelRequire("14XJw");

var $fY39E = parcelRequire("fY39E");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $cNd4s = parcelRequire("cNd4s");

var $DVljb = parcelRequire("DVljb");

var $3TYPx = parcelRequire("3TYPx");
var $keqfq = parcelRequire("keqfq");

var $doZTA = parcelRequire("doZTA");

var $adncp = parcelRequire("adncp");
const $21214568f856c41e$var$JiraPostOfficeProvider = ({ children: children })=>{
    const { data: data } = (0, $lpwtK.useProject)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const locale = (0, $DVljb.useLocale)();
    const environment = (0, $2tT7R.useEnvironment)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const editions = (0, $k9JTq.useAppEditions)();
    const subproduct = data?.type;
    const edition = (0, $adncp.subproductToEdition)(subproduct, editions);
    const context = (0, $5uXOq.useMemo)(()=>{
        return {
            current: {
                ...(0, $adncp.tenantToPostOfficeContext)({
                    activationId: activationId,
                    cloudId: cloudId,
                    isSiteAdmin: isSiteAdmin,
                    locale: locale
                }),
                orgId: orgId,
                productEdition: edition || undefined,
                subproduct: subproduct
            }
        };
    }, [
        cloudId,
        orgId,
        activationId,
        subproduct,
        isSiteAdmin,
        locale,
        edition
    ]);
    const env = (0, $5uXOq.useMemo)(()=>({
            env: (0, $adncp.transformJiraEnvToPostOfficeEnvironment)(environment)
        }), [
        environment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3TYPx.PostOfficeProvider), {
        context: context,
        environment: env
    }, children);
};
const $21214568f856c41e$export$fb465b6e855c1e85 = ({ children: children })=>{
    // Using the Feature Gate used for the placement app-switcher-discovery-section because PostOfficeProvider is always needed when the app-switcher-discovery-section is enabled
    const isPostOfficeEnabled = !(0, $jQsty.default)('killswitch_post_office_in_jira');
    return isPostOfficeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "postOfficeJiraProvider",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($21214568f856c41e$var$JiraPostOfficeProvider, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $21214568f856c41e$var$ReactResourceRouterListener = ({ children: children })=>{
    const [route] = (0, $doZTA.useRouter)();
    (0, $keqfq.usePostOfficeRouteUpdate)([
        route.basePath,
        route.location.pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $21214568f856c41e$export$9f8d3084fd3d5fc0 = ({ children: children })=>{
    const isPostOfficeEnabled = !(0, $jQsty.default)('killswitch_post_office_in_jira');
    return isPostOfficeEnabled && (0, $4R6GH.fg)('post-office-screen-space-overlay-jfe') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($21214568f856c41e$var$ReactResourceRouterListener, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};

});
parcelRegister("3TYPx", function(module, exports) {

$parcel$export(module.exports, "PostOfficeProvider", () => $1a63e82e2d6ab167$export$fb465b6e855c1e85);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ggVl0 = parcelRequire("ggVl0");

var $k9ais = parcelRequire("k9ais");

var $keqfq = parcelRequire("keqfq");

var $iHQZs = parcelRequire("iHQZs");

var $j5kk0 = parcelRequire("j5kk0");

var $30kbx = parcelRequire("30kbx");

var $aAASp = parcelRequire("aAASp");

var $4FPR0 = parcelRequire("4FPR0");
const $1a63e82e2d6ab167$export$fb465b6e855c1e85 = ({ environment: envWithOverrides, context: context, children: children })=>{
    const stableEnvironment = (0, $30kbx.useStableObject)((0, $4FPR0.generateEnvironmentConfigWithOverrides)((0, $k9ais.defaultEnvironmentValues), envWithOverrides));
    const stableContext = (0, $30kbx.useStableObject)($1a63e82e2d6ab167$var$composeConfig((0, $ggVl0.defaultPostOfficeContextValue), context.current));
    const memoizedMessagePlacementValues = (0, $5uXOq.useMemo)(()=>(0, $aAASp.createMessagePlacementValues)(), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9ais.PostOfficeEnvironmentProvider), {
        value: stableEnvironment,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ggVl0.InternalPostOfficeContextProvider), {
            value: stableContext,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iHQZs.PostOfficeScreenContextProvider), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aAASp.MessagePlacementProvider), {
                    value: memoizedMessagePlacementValues,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $keqfq.RouteListenerProvider), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j5kk0.TriggerContextProvider), {
                            children: children
                        })
                    })
                })
            })
        })
    });
};
const $1a63e82e2d6ab167$var$composeConfig = (base, ...rest)=>rest.reduce((acc, v)=>{
        // Bring logic inline with lodash merge
        // Iterator (right) properties that resolve to undefined are skipped if an Accumulator (left) value already exists
        for(const key in v)if (typeof v[key] === 'undefined') delete v[key];
        return {
            ...acc,
            ...v
        };
    }, {
        ...base
    });

});
parcelRegister("keqfq", function(module, exports) {

$parcel$export(module.exports, "usePostOfficeRouteUpdate", () => $cb9c71bd126023f0$export$bb606326acdd1a64);
$parcel$export(module.exports, "RouteListenerProvider", () => $cb9c71bd126023f0$export$31986273b686f5ea);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bkD77 = parcelRequire("bkD77");

var $7LKoA = parcelRequire("7LKoA");
const $cb9c71bd126023f0$var$noop = ()=>{};
const $cb9c71bd126023f0$var$RouteListenerContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    update: $cb9c71bd126023f0$var$noop
});
const $cb9c71bd126023f0$export$7a2084f4baac29a7 = ()=>(0, $bkD77.createSimplePubSub)();
const $cb9c71bd126023f0$export$72fd8977abf03d60 = ()=>(0, $5uXOq.useContext)($cb9c71bd126023f0$var$RouteListenerContext);
const $cb9c71bd126023f0$export$755edb1665399d41 = ()=>{
    const ref = (0, $5uXOq.useRef)();
    if (!ref.current) ref.current = $cb9c71bd126023f0$export$7a2084f4baac29a7();
    const [routeSubscriber, updateRoute] = ref.current;
    const routeConfig = (0, $5uXOq.useMemo)(()=>({
            initialUrl: new URL(window.location.href),
            routeSubscriber: routeSubscriber
        }), [
        routeSubscriber
    ]);
    const routeUpdater = (0, $5uXOq.useMemo)(()=>({
            update: updateRoute
        }), [
        updateRoute
    ]);
    return [
        routeConfig,
        routeUpdater
    ];
};
const $cb9c71bd126023f0$export$bb606326acdd1a64 = (deps)=>{
    const { update: update } = $cb9c71bd126023f0$export$72fd8977abf03d60();
    (0, $5uXOq.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        update({
            next: new URL(window.location.href)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
const $cb9c71bd126023f0$export$31986273b686f5ea = ({ children: children })=>{
    const [route, routeUpdater] = $cb9c71bd126023f0$export$755edb1665399d41();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($cb9c71bd126023f0$var$RouteListenerContext.Provider, {
        value: routeUpdater,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7LKoA.PostOfficeRouteProvider), {
            ...route,
            children: children
        })
    });
};

});
parcelRegister("bkD77", function(module, exports) {

$parcel$export(module.exports, "createSimplePubSub", () => $5a68086fa6118d51$export$92469b55607f005b);
const $5a68086fa6118d51$export$92469b55607f005b = ()=>{
    const subscribers = new Map();
    const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const publish = (payload)=>{
        subscribers.forEach((callback)=>callback(payload));
    };
    return [
        subscribe,
        publish
    ];
};

});


parcelRegister("j5kk0", function(module, exports) {

$parcel$export(module.exports, "TriggerContextProvider", () => $af1a979995a7009c$export$e80a5720bb4c8fe3);
$parcel$export(module.exports, "useTrigger", () => $af1a979995a7009c$export$3b196fe93a948c18);
$parcel$export(module.exports, "useFirePostOfficeTrigger", () => $af1a979995a7009c$export$83b33e5fe4cce64);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $af1a979995a7009c$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $af1a979995a7009c$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $af1a979995a7009c$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($af1a979995a7009c$var$initialActiveTriggerState);
const $af1a979995a7009c$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($af1a979995a7009c$var$initialTriggerDispatchState);
const $af1a979995a7009c$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $5uXOq.useState)($af1a979995a7009c$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $5uXOq.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $5uXOq.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $5uXOq.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($af1a979995a7009c$var$TriggerContext.Provider, {
        value: triggerContextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($af1a979995a7009c$var$TriggerDispatchContext.Provider, {
            value: triggerContexDispatchValue,
            children: children
        })
    });
};
const $af1a979995a7009c$export$454c1d7c35958f5e = ()=>(0, $5uXOq.useContext)($af1a979995a7009c$var$TriggerContext);
const $af1a979995a7009c$export$23cbf084e08bdb93 = ()=>(0, $5uXOq.useContext)($af1a979995a7009c$var$TriggerDispatchContext);
const $af1a979995a7009c$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $af1a979995a7009c$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $af1a979995a7009c$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $af1a979995a7009c$export$23cbf084e08bdb93();
    const fireTrigger = (0, $5uXOq.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};

});

parcelRegister("4FPR0", function(module, exports) {

$parcel$export(module.exports, "generateEnvironmentConfigWithOverrides", () => $0363165f9cd8d022$export$ae3dab16eb1fc2cc);
const $0363165f9cd8d022$export$ae3dab16eb1fc2cc = (defaultEnvironmentValues, environmentWithOverrides)=>{
    const { env: env, overrides: overrides } = environmentWithOverrides;
    return {
        currentEnv: env,
        envConfigs: {
            ...defaultEnvironmentValues.envConfigs,
            [env]: {
                remoteModule: {
                    origin: overrides?.remoteModule?.origin ?? defaultEnvironmentValues.envConfigs[env].remoteModule.origin,
                    pathname: overrides?.remoteModule?.pathname ?? defaultEnvironmentValues.envConfigs[env].remoteModule.pathname,
                    searchParams: overrides?.remoteModule?.searchParams ?? defaultEnvironmentValues.envConfigs[env].remoteModule.searchParams
                },
                api: {
                    origin: overrides?.api?.origin ?? defaultEnvironmentValues.envConfigs[env].api.origin,
                    pathname: overrides?.api?.pathname ?? defaultEnvironmentValues.envConfigs[env].api.pathname,
                    searchParams: overrides?.api?.searchParams ?? defaultEnvironmentValues.envConfigs[env].api.searchParams
                }
            }
        }
    };
};

});



parcelRegister("j2nvL", function(module, exports) {

$parcel$export(module.exports, "PlacementFetchProvider", () => $d1dd0ebdae4a4c66$export$9be10e5cc29463c9);

var $5uXOq = parcelRequire("5uXOq");

var $jm1yu = parcelRequire("jm1yu");

var $fyLzM = parcelRequire("fyLzM");
const $d1dd0ebdae4a4c66$export$9be10e5cc29463c9 = ({ children: children, resource: resource })=>{
    const fetch = (0, $fyLzM.usePlacementSSRFetch)(resource);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jm1yu.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};

});
parcelRegister("jm1yu", function(module, exports) {

$parcel$export(module.exports, "usePlacementFetchingContext", () => $34e99787e88fad9f$export$e1e2cdb0425a9fa8);
$parcel$export(module.exports, "PlacementFetchingProvider", () => $34e99787e88fad9f$export$5f25a6ddf0324fa8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $34e99787e88fad9f$export$afec669dc416ee7e = /*#__PURE__*/ (0, $5uXOq.createContext)({
    fetch: (...args)=>globalThis.fetch(...args)
});
const $34e99787e88fad9f$export$e1e2cdb0425a9fa8 = ()=>(0, $5uXOq.useContext)($34e99787e88fad9f$export$afec669dc416ee7e);
const $34e99787e88fad9f$export$5f25a6ddf0324fa8 = ({ fetch: fetch, children: children })=>{
    const value = (0, $5uXOq.useMemo)(()=>({
            fetch: fetch
        }), [
        fetch
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($34e99787e88fad9f$export$afec669dc416ee7e.Provider, {
        value: value,
        children: children
    });
};

});


parcelRegister("ZILlH", function(module, exports) {

$parcel$export(module.exports, "default", () => $71405a30e5d17f84$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $30kbx = parcelRequire("30kbx");

var $2RXFI = parcelRequire("2RXFI");

var $e2ICd = parcelRequire("e2ICd");

var $5uXOq = parcelRequire("5uXOq");

var $2JIyR = parcelRequire("2JIyR");

const $71405a30e5d17f84$var$STABLE_OBJECT = {};
const $71405a30e5d17f84$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $5uXOq.useMemo)(()=>(0, $e2ICd.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $30kbx.useStableObject)(placementProps ?? $71405a30e5d17f84$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2RXFI.default), {
        placementId: placementId,
        consumptionType: "local",
        onEvent: onEvent,
        disableInitialData: disableInitialData,
        children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2JIyR.default), {
                analyticsChannel: (0, $ca7b69aae3473d90$export$85183a312807388d),
                placementId: placementId,
                onError: sharedOnEvent,
                fallback: ErrorFallback,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(MemoizedPlacement, {
                    initialData: initialData,
                    context: context,
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore - Confluence Local Consumption
                    errorFallback: ErrorFallback,
                    ...stableLocalPlacementProps,
                    children: children
                })
            })
    });
};
var $71405a30e5d17f84$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($71405a30e5d17f84$var$Placement);

});
parcelRegister("2RXFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8aead34fad01c03$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $cnhic = parcelRequire("cnhic");

var $96Irh = parcelRequire("96Irh");

var $ggVl0 = parcelRequire("ggVl0");
var $7LKoA = parcelRequire("7LKoA");
var $30kbx = parcelRequire("30kbx");

var $55GjK = parcelRequire("55GjK");
var $jeAWE = parcelRequire("jeAWE");

var $jm1yu = parcelRequire("jm1yu");

var $5uXOq = parcelRequire("5uXOq");


var $2eHYz = parcelRequire("2eHYz");

var $2UQuz = parcelRequire("2UQuz");
const $d8aead34fad01c03$var$useInitialDataIfEnabled = (placementId, context, baseUrl, path, disableInitialData)=>{
    const fetcher = (0, $jm1yu.usePlacementFetchingContext)();
    return (0, $5uXOq.useMemo)(()=>disableInitialData ? undefined : (0, $2eHYz.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context,
        fetcher.fetch
    ]);
};
const $d8aead34fad01c03$var$Placement = ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = (0, $96Irh.default).checkGate('enable_ufo_tracking_in_post_office');
    const postOfficeRoute = (0, $7LKoA.usePostOfficeRoute)();
    const context = (0, $ggVl0.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $2UQuz.useBuildBasePath)();
    const stableContextWithRoute = (0, $30kbx.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $5uXOq.useMemo)(()=>isUFOEnabled ? new (0, $55GjK.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    // Callback function to listen to the different stages of the remote component and track its performance
    const remoteComponentOnEvent = (0, $5uXOq.useCallback)(({ type: type, error: error })=>{
        placementOnEvent?.({
            type: type,
            error: error
        });
        switch(type){
            case 'fetch-complete':
                ufoV1PlacementTracker?.markFetchComplete();
                break;
            case 'fetch-error':
                ufoV1PlacementTracker?.markFetchFailure(error);
                break;
            case 'render-complete':
                ufoV1PlacementTracker?.markRenderComplete();
                break;
            case 'render-error':
                ufoV1PlacementTracker?.markRenderFailure(error);
                break;
            case 'initial-data-complete':
                ufoV1PlacementTracker?.markInitialDataComplete();
                break;
            case 'initial-data-error':
                ufoV1PlacementTracker?.markInitialDataFailure(error);
                break;
            case 'component-error':
                ufoV1PlacementTracker?.markComponentFailure(error);
                break;
            case 'component-ready':
                ufoV1PlacementTracker?.markComponentReady();
                break;
            case 'unmount':
                ufoV1PlacementTracker?.markComponentAborted();
                break;
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker
    ]);
    const initialData = $d8aead34fad01c03$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $5uXOq.useMemo)(()=>({
            source: (0, $861ed2a668863e6a$export$f7109619a5e9e0d6),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app'
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($d8aead34fad01c03$var$FeatureFlaggedUfoWrapper, {
        placementId: placementId,
        isEnabled: isUFOEnabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cnhic.PostOfficeAnalyticsContext), {
            data: placementAnalyticsContext,
            children: children({
                initialData: initialData,
                context: stableContextWithRoute,
                onEvent: remoteComponentOnEvent
            })
        })
    });
};
var $d8aead34fad01c03$export$2e2bcd8739ae039 = $d8aead34fad01c03$var$Placement;
const $d8aead34fad01c03$var$FeatureFlaggedUfoWrapper = ({ isEnabled: isEnabled, placementId: placementId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jeAWE.UFOv2).UFOSegment, {
        name: (0, $jeAWE.UFOv2).SegmentNames.PLACEMENT,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jeAWE.UFOv2).UFOSegment, {
            name: `${(0, $jeAWE.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});
const $861ed2a668863e6a$export$85183a312807388d = 'postOffice';
const $861ed2a668863e6a$export$f7109619a5e9e0d6 = 'post-office-frontend';

parcelRegister("2UQuz", function(module, exports) {

$parcel$export(module.exports, "useBuildBasePath", () => $b225cf1355bc34a5$export$83d6c58b7ab7ae67);

var $kBATP = parcelRequire("kBATP");
var $k9ais = parcelRequire("k9ais");

var $5uXOq = parcelRequire("5uXOq");
const $b225cf1355bc34a5$export$83d6c58b7ab7ae67 = ()=>{
    const postOfficeEnvironment = (0, $k9ais.usePostOfficeEnvironment)();
    return (0, $5uXOq.useMemo)(()=>(0, $kBATP.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
        postOfficeEnvironment.currentEnv,
        postOfficeEnvironment.envConfigs
    ]);
};

});


parcelRegister("2JIyR", function(module, exports) {

$parcel$export(module.exports, "default", () => $76d767b143660fe0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $3TR0I = parcelRequire("3TR0I");

var $5uXOq = parcelRequire("5uXOq");
class $76d767b143660fe0$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
}
var $76d767b143660fe0$export$2e2bcd8739ae039 = (0, $3TR0I.default)()($76d767b143660fe0$var$ErrorBoundary);

});

const $ca7b69aae3473d90$export$85183a312807388d = 'postOffice';



parcelRegister("gmCnE", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $08223c6bc94e2fa4$export$3b4e64e77073e307);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $gwIPs = parcelRequire("gwIPs");


var $2Upgn = parcelRequire("2Upgn");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $asgRx = parcelRequire("asgRx");

var $6ohPr = parcelRequire("6ohPr");

var $3HwlS = parcelRequire("3HwlS");

var $iqLcb = parcelRequire("iqLcb");

var $9L6Zg = parcelRequire("9L6Zg");

var $gk4cG = parcelRequire("gk4cG");

var $adRnT = parcelRequire("adRnT");

var $iaN8D = parcelRequire("iaN8D");

var $14pJv = parcelRequire("14pJv");

var $921us = parcelRequire("921us");

var $9Cdg4 = parcelRequire("9Cdg4");

var $aAExw = parcelRequire("aAExw");

var $9ylrc = parcelRequire("9ylrc");

var $l8ruj = parcelRequire("l8ruj");

var $dm0Uk = parcelRequire("dm0Uk");

var $fbxog = parcelRequire("fbxog");

var $9nsmf = parcelRequire("9nsmf");
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 */ const $08223c6bc94e2fa4$var$TEST_ID = 'page-layout.banner';
const $08223c6bc94e2fa4$export$496ffd8dda3bf451 = ()=>{
    const banner = (0, $9L6Zg.useBanner)();
    return banner.isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.Banner), {
        height: banner.height,
        testId: $08223c6bc94e2fa4$var$TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08223c6bc94e2fa4$var$BannerContent, {
        bannerName: banner.name
    }))) : null;
};
const $08223c6bc94e2fa4$export$b5cfff585ada92ce = ()=>{
    const banner = (0, $9L6Zg.useBanner)();
    return banner.isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dm0Uk.ZIndexWrapper), {
        zIndex: (0, $gwIPs.layers).banner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.Banner), {
        height: banner.height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08223c6bc94e2fa4$var$BannerContent, {
        bannerName: banner.name
    })))) : null;
};
const $08223c6bc94e2fa4$export$103625f8bec052d0 = ({ onDismiss: onDismiss })=>{
    const banner = (0, $9L6Zg.useBanner)();
    const oldBannerHeight = banner.isEnabled ? banner.height || 56 : 0;
    // the prompt banner height is 44px;
    // if the `banner.height` is undefined, use the default banner height which is 56px;
    const bannerContainerHeight = oldBannerHeight + 44;
    // TODO: check with dismissible banners
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dm0Uk.ZIndexWrapper), {
        zIndex: (0, $gwIPs.layers).banner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.Banner), {
        height: bannerContainerHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fbxog.AsyncNav4PromptBanner), {
        onDismiss: onDismiss
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: {
            height: oldBannerHeight
        },
        className: (0, $bwpsq.default)([
            "_kqswh2mm"
        ])
    }, banner.isEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08223c6bc94e2fa4$var$BannerContent, {
        bannerName: banner.name
    })))));
};
/** Adding the position value so that old banner's Dismiss icon is displayed properly */ const $08223c6bc94e2fa4$var$oldBannerWrapper = null;
const $08223c6bc94e2fa4$export$df6dbe80b191d8d3 = ()=>{
    const { shouldShowPromptBanner: shouldShowPromptBanner, setDismissed: setDismissed } = (0, $9nsmf.useNav4PromptBanner)();
    return shouldShowPromptBanner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08223c6bc94e2fa4$export$103625f8bec052d0, {
        onDismiss: setDismissed
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08223c6bc94e2fa4$export$b5cfff585ada92ce, null);
};
const $08223c6bc94e2fa4$var$BannerContent = ({ bannerName: bannerName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, bannerName === (0, $gk4cG.NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $adRnT.BannerAnnouncementAsync), null), bannerName === (0, $asgRx.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ohPr.IPBlocklistingBannerAsync), null), bannerName === (0, $aAExw.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ylrc.ReturnToMobileBanner), null), bannerName === (0, $91be75e714d10b24$export$41956b146268af93) && (0, $4R6GH.fg)('jfp-magma-cookie-controls-banner-show') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Upgn.CookieConsentBannerAsync), null), bannerName === (0, $iaN8D.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $14pJv.BannerTransitionAsync), null), bannerName === (0, $921us.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Cdg4.MailExpiryBannerAsync), null));
const $08223c6bc94e2fa4$export$3b4e64e77073e307 = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $08223c6bc94e2fa4$export$496ffd8dda3bf451, $08223c6bc94e2fa4$export$df6dbe80b191d8d3);

});
const $91be75e714d10b24$export$41956b146268af93 = 'COOKIE_CONSENT_BANNER';
const $91be75e714d10b24$export$ed7cc0d417ee89e = 74;
const $91be75e714d10b24$export$ff6e18f7d82b549c = 320;

parcelRegister("2Upgn", function(module, exports) {

$parcel$export(module.exports, "CookieConsentBannerAsync", () => $8357736d9e1344aa$export$f110a9cbbbd3fa3a);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8357736d9e1344aa$var$LazyCookieConsentBanner = (0, $b7Svb.lazy)(()=>// chunk name is async-ccb to avoid scripts with cookie/banner keywords getting blocked
    (parcelRequire("1Ou8X")).then(({ CookieConsentBanner: CookieConsentBanner })=>CookieConsentBanner), {
    moduleId: "./src/packages/platform/ui/banners/cookie-consent/src/ui/banner/CookieConsentBanner.tsx"
});
const $8357736d9e1344aa$export$f110a9cbbbd3fa3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $8357736d9e1344aa$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-cookie-consent-banner",
        packageName: "jiraCookieConsentBanner",
        teamName: "Magma"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-cookie-consent-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8357736d9e1344aa$var$LazyCookieConsentBanner, null))));
const $8357736d9e1344aa$var$boxStyles = (0, $2s57o.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    height: '100%'
});

});
parcelRegister("1Ou8X", function(module, exports) {

let $1521d7d144c84de4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1521d7d144c84de4$var$load("lK1GY").then(()=>parcelRequire('vtgYF'));

});


parcelRegister("asgRx", function(module, exports) {

$parcel$export(module.exports, "bannerHeight", () => $692526aac37c19f2$export$86047f02632f9f5b);
$parcel$export(module.exports, "BANNER_NAME", () => $692526aac37c19f2$export$41956b146268af93);

var $gwIPs = parcelRequire("gwIPs");
const $692526aac37c19f2$export$86047f02632f9f5b = (0, $gwIPs.gridSize) * 7;
const $692526aac37c19f2$export$41956b146268af93 = 'IP_BLOCK_LISTING_BANNER';

});

parcelRegister("6ohPr", function(module, exports) {

$parcel$export(module.exports, "IPBlocklistingBannerAsync", () => $f9467d6df1e451da$export$fafc306b802ab39d);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f9467d6df1e451da$var$IPBlocklistingBannerComp = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("gjywe")).then((m)=>m.IPBlocklistingBanner), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/ip-block-listing-banner/src/main.tsx"
});
const $f9467d6df1e451da$export$fafc306b802ab39d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-ip-block-listing-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f9467d6df1e451da$var$IPBlocklistingBannerComp, null));

});
parcelRegister("gjywe", function(module, exports) {

let $be09326c444c2b83$var$load = (parcelRequire("28QjX"))(4);
module.exports = $be09326c444c2b83$var$load("12K5T").then(()=>parcelRequire('h9o9V'));

});


parcelRegister("9L6Zg", function(module, exports) {

$parcel$export(module.exports, "useBanner", () => $83eb9a3cdcaec997$export$de40f69ba30f2376);

var $5uXOq = parcelRequire("5uXOq");

var $iPh5B = parcelRequire("iPh5B");

var $4R6GH = parcelRequire("4R6GH");

var $iMzQW = parcelRequire("iMzQW");

var $14V0U = parcelRequire("14V0U");

var $6RMJw = parcelRequire("6RMJw");

var $hESBP = parcelRequire("hESBP");

var $2jAre = parcelRequire("2jAre");

var $lrZro = parcelRequire("lrZro");
const $83eb9a3cdcaec997$var$noBanner = {
    name: null,
    height: 0,
    isEnabled: false
};
const $83eb9a3cdcaec997$export$de40f69ba30f2376 = ()=>{
    const [isChromeless] = (0, $14V0U.useIsChromeless)();
    const announcement = (0, $6RMJw.useBannerAnnouncement)();
    const transition = (0, $hESBP.useBannerEocTransition)();
    const returnToMobile = (0, $lrZro.useBannerReturnToMobile)();
    const IPBlocklisting = (0, $iMzQW.useBannerIPBlocklisting)();
    const cookieConsent = (0, $4R6GH.fg)('jfp-magma-cookie-controls-banner-show') // eslint-disable-next-line react-hooks/rules-of-hooks
     ? (0, $iPh5B.useBannerCookieConsent)() : undefined;
    const mailExpiry = (0, $2jAre.useBannerMailExpiry)();
    return (0, $5uXOq.useMemo)(()=>{
        // cookie consent banner has the highest priority
        if (cookieConsent?.isEnabled) return cookieConsent;
        if (isChromeless) return $83eb9a3cdcaec997$var$noBanner;
        if (IPBlocklisting.isEnabled) return IPBlocklisting;
        if (returnToMobile.isEnabled) return returnToMobile;
        if (announcement.isEnabled) return announcement;
        if (transition?.isEnabled) return transition;
        if (mailExpiry?.isEnabled) return mailExpiry;
        return $83eb9a3cdcaec997$var$noBanner;
    }, [
        cookieConsent,
        isChromeless,
        IPBlocklisting,
        returnToMobile,
        announcement,
        transition,
        mailExpiry
    ]);
};

});
parcelRegister("iPh5B", function(module, exports) {

$parcel$export(module.exports, "useBannerCookieConsent", () => $e552544bdd302edb$export$c7a51b5ee06f5794);

var $5uXOq = parcelRequire("5uXOq");

var $lPu4t = parcelRequire("lPu4t");

var $2eyDn = parcelRequire("2eyDn");


var $gubdC = parcelRequire("gubdC");
const $e552544bdd302edb$export$5503c67b1001ec45 = (data)=>{
    try {
        return data && (0, $lPu4t.shouldRenderBannerPrefetched)(data);
    } catch (e) {
        return true;
    }
};
const $e552544bdd302edb$export$c7a51b5ee06f5794 = ()=>{
    const [{ isDismissed: isDismissed, height: height }, { onShow: onShow }] = (0, $gubdC.useCookieConsentBannerSettings)();
    const { data: data } = (0, $2eyDn.useConsentBannerUserPreferencesResource)();
    (0, $5uXOq.useEffect)(()=>{
        const shouldRender = $e552544bdd302edb$export$5503c67b1001ec45(data);
        // only show banner if banner should be shown and not in iframe
        if (shouldRender && !(0, $gubdC.isInIframe)()) // the initial state of banner is "Dismissed" so we need to show it if we "think" it should be shown
        // in case we are making a mistake and CookieBanner will not display
        // it will inform us via `onConsentBannerBailOut` and we will dismiss the banner again.
        onShow();
    }, [
        data,
        onShow
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: !isDismissed,
            name: (0, $91be75e714d10b24$export$41956b146268af93),
            height: height
        }), [
        isDismissed,
        height
    ]);
};

});
parcelRegister("lPu4t", function(module, exports) {

$parcel$export(module.exports, "shouldRenderBannerPrefetched", () => $ee1a8706bfe84648$export$6406464aa126433e);

var $fHpHg = parcelRequire("fHpHg");

var $b6Vi9 = parcelRequire("b6Vi9");

var $2JZQn = parcelRequire("2JZQn");

var $j15Uc = parcelRequire("j15Uc");
const $ee1a8706bfe84648$export$6406464aa126433e = (prefetchedPreferencesData)=>{
    if ((0, $fHpHg.fg)('platform_moonjelly_bsc_ssr_killswitch')) // If the bsc ssr killswitch is enabled, we should not show the banner
    // in SSR context
    return false;
    if (!prefetchedPreferencesData) // If prefetched prefs are missing (presumably SSR prefetching failed), but are still trying to compute
    // banner state, we have no info to calculate from so, we need to show the banner to be compliant
    return true;
    if ('consentToken' in prefetchedPreferencesData) {
        // We've been given cached cookie data, validate it before use.
        // If invalid, we can't determine anything, show the banner for compliance sake
        const { isValid: isValid } = (0, $2JZQn.checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
        return isValid ? (0, $j15Uc.getBannerVisibility)(prefetchedPreferencesData) : true;
    }
    // We've been given ConsentHub response data, format it appropriately
    const consentPrefsData = (0, $b6Vi9.buildConsentPreferences)(prefetchedPreferencesData);
    return (0, $j15Uc.getBannerVisibility)(consentPrefsData);
};

});

parcelRegister("gubdC", function(module, exports) {

$parcel$export(module.exports, "isInIframe", () => $53f6acf0285fde21$export$9f140ed41af5108c);
$parcel$export(module.exports, "useCookieConsentBannerSettings", () => $53f6acf0285fde21$export$ae97931560f092a4);
$parcel$export(module.exports, "useCookieConsentBannerSettingsActions", () => $53f6acf0285fde21$export$ecbab4dc5f9ad844);

var $gKZoD = parcelRequire("gKZoD");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $53f6acf0285fde21$export$9f140ed41af5108c = ()=>{
    (0, $gKZoD.di)(window);
    if (false) return false;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window !== window.top;
};
const $53f6acf0285fde21$export$aa1483cc2e197f6e = ()=>{
    if (false) return false;
    return true;
};
const $53f6acf0285fde21$export$d4c72bab9d6cc13a = {
    isDismissed: $53f6acf0285fde21$export$aa1483cc2e197f6e(),
    height: 0
};
const $53f6acf0285fde21$export$e324594224ef24da = {
    onShow: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isDismissed: false
            });
        },
    onDismiss: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isDismissed: true
            });
        },
    setHeight: (height)=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                height: height
            });
        }
};
const $53f6acf0285fde21$var$Store = (0, $iXqE5.createStore)({
    name: 'cookie-consent-banner',
    initialState: $53f6acf0285fde21$export$d4c72bab9d6cc13a,
    actions: $53f6acf0285fde21$export$e324594224ef24da
});
const $53f6acf0285fde21$export$ae97931560f092a4 = (0, $3sQ5x.createHook)($53f6acf0285fde21$var$Store);
const $53f6acf0285fde21$export$ecbab4dc5f9ad844 = (0, $3sQ5x.createActionsHook)($53f6acf0285fde21$var$Store);

});


parcelRegister("iMzQW", function(module, exports) {

$parcel$export(module.exports, "useBannerIPBlocklisting", () => $014906e38669dbae$export$564412c1d9cd4ccc);

var $5uXOq = parcelRequire("5uXOq");

var $9B86Q = parcelRequire("9B86Q");

var $asgRx = parcelRequire("asgRx");
const $014906e38669dbae$export$564412c1d9cd4ccc = ()=>{
    const [shouldShowBanner, setBannerState] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $9B86Q.loadBridgeWeak)({
            name: 'jira/global-components/ipblocklisting/bridge'
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge({
                showIPBlocklistBanner: ()=>setBannerState(true),
                hideIPBlocklistBanner: ()=>setBannerState(false)
            });
        });
    }, []);
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: shouldShowBanner,
            name: (0, $asgRx.BANNER_NAME),
            height: (0, $asgRx.bannerHeight)
        }), [
        shouldShowBanner
    ]);
};

});

parcelRegister("6RMJw", function(module, exports) {

$parcel$export(module.exports, "useBannerAnnouncement", () => $6710252c02f204b2$export$1e775b1ab04f2888);

var $5uXOq = parcelRequire("5uXOq");

var $5kYzp = parcelRequire("5kYzp");

var $cZpsT = parcelRequire("cZpsT");

var $gk4cG = parcelRequire("gk4cG");
const $6710252c02f204b2$export$1e775b1ab04f2888 = ()=>{
    const { data: data } = (0, $5kYzp.useAnnouncementBannerSettingsV4Resource)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: Boolean(data?.isEnabled) && !data?.isDismissed && (data?.visibility === 'private' && !isAnonymous || data?.visibility === 'public'),
            name: (0, $gk4cG.NAME),
            height: (0, $gk4cG.HEIGHT)
        }), [
        data?.isDismissed,
        data?.isEnabled,
        data?.visibility,
        isAnonymous
    ]);
};

});
parcelRegister("gk4cG", function(module, exports) {

$parcel$export(module.exports, "HEIGHT", () => $8ea828cd42179fda$export$809d2b099693a9a8);
$parcel$export(module.exports, "NAME", () => $8ea828cd42179fda$export$3c5e605ca7ade9f2);

var $gwIPs = parcelRequire("gwIPs");
const $8ea828cd42179fda$export$809d2b099693a9a8 = (0, $gwIPs.gridSize) * 8;
const $8ea828cd42179fda$export$3c5e605ca7ade9f2 = 'ANNOUNCEMENT';

});


parcelRegister("hESBP", function(module, exports) {

$parcel$export(module.exports, "useBannerEocTransition", () => $304370119e420b48$export$b6539a8209f95b48);

var $5uXOq = parcelRequire("5uXOq");

var $ez5GD = parcelRequire("ez5GD");

var $201IG = parcelRequire("201IG");

var $8J6rn = parcelRequire("8J6rn");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $iaN8D = parcelRequire("iaN8D");
const $304370119e420b48$export$b6539a8209f95b48 = ()=>{
    const { data: data, error: error } = (0, $ez5GD.useOgConsolidationUserState)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { isTransitionEligible: isTransitionEligible, error: tenantInfoError } = (0, $8J6rn.useOgTenantInfo)();
    const isEnabled = Boolean((isAdmin || isSiteAdmin) && // Tenant info
    !tenantInfoError && isTransitionEligible && // User state
    !error && data && (!data.isTransitionBannerDismissed || (0, $201IG.shouldRenderBenefitModal)({
        bannerDismissedAt: data.transitionBannerDismissedAt,
        isDismissed: data.isBenefitModalDismissed
    })));
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: isEnabled,
            name: (0, $iaN8D.BANNER_NAME),
            height: data && (0, $201IG.shouldRenderBenefitModal)({
                bannerDismissedAt: data.transitionBannerDismissedAt
            }) ? 0 : (0, $iaN8D.HEIGHT)
        }), [
        data,
        isEnabled
    ]);
};

});
parcelRegister("ez5GD", function(module, exports) {

$parcel$export(module.exports, "useOgConsolidationUserState", () => $e71f39314801737b$export$c35632c02599163f);

var $5uXOq = parcelRequire("5uXOq");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $iXaZ3 = parcelRequire("iXaZ3");

var $kMiZJ = parcelRequire("kMiZJ");

var $9OXo1 = parcelRequire("9OXo1");

var $2YP9W = parcelRequire("2YP9W");

var $fLIp1 = parcelRequire("fLIp1");
const $e71f39314801737b$export$c35632c02599163f = ()=>{
    const errorRef = (0, $5uXOq.useRef)();
    const loadingRef = (0, $5uXOq.useRef)(false);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { data: data, update: updateTransitionResource, error: transitionResourceError } = (0, $2YP9W.useResource)((0, $kMiZJ.consolidationUserStateResource));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [userPropertiesError, setUserPropertiesError] = (0, $5uXOq.useState)();
    errorRef.current = userPropertiesError || transitionResourceError;
    const { atlassianAccountId: accountId } = (0, $9OXo1.useTenantContext)();
    const update = (0, $5uXOq.useCallback)((newState)=>{
        if (errorRef.current) // If there is an error on resource or update, we don't want to update the state
        return Promise.reject(errorRef.current);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        let updatedData = {};
        updateTransitionResource((oldState)=>{
            updatedData = {
                ...oldState,
                ...newState
            };
            return updatedData;
        });
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraEocChangeboarding',
                        teamName: 'alexstrasza'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $89SaW.setUserProperties)(accountId, (0, $iXaZ3.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY), JSON.stringify(updatedData)).catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                showFlag({
                    type: 'error',
                    isAutoDismiss: true,
                    title: formatMessage((0, $fLIp1.default).errorFlagTitle),
                    messageId: 'eoc-changeboarding.controllers.use-og-consolidation-user-state.show-flag.error.jira-modal',
                    messageType: 'transactional'
                });
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraEocChangeboarding',
                        teamName: 'alexstrasza'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                loadingRef.current = false;
            });
        }
        return Promise.resolve();
    }, [
        updateTransitionResource,
        accountId,
        formatMessage,
        showFlag
    ]);
    const reopenTransitionLozenge = (0, $5uXOq.useCallback)(()=>{
        update({
            isTransitionHomeHidden: false
        });
    }, [
        update
    ]);
    return {
        data: data,
        update: update,
        error: errorRef.current,
        reopenTransitionLozenge: reopenTransitionLozenge
    };
};

});
parcelRegister("fLIp1", function(module, exports) {

$parcel$export(module.exports, "default", () => $19c9811268c2fa85$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $19c9811268c2fa85$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "eoc-changeboarding.controllers.use-og-consolidation-user-state.error-flag-title",
        "defaultMessage": "Something went wrong while updating user properties."
    }
});

});


parcelRegister("201IG", function(module, exports) {

$parcel$export(module.exports, "shouldRenderBenefitModal", () => $f068b5042603902f$export$25a52eb2dc74e2f9);
const $f068b5042603902f$export$25a52eb2dc74e2f9 = ({ isDismissed: isDismissed, bannerDismissedAt: bannerDismissedAt })=>{
    if (!bannerDismissedAt || isDismissed) return false;
    return Math.ceil((new Date().getTime() - bannerDismissedAt) / 1000 / 60 / 60 / 24) >= 14;
};

});

parcelRegister("iaN8D", function(module, exports) {

$parcel$export(module.exports, "HEIGHT", () => $d45809d2691157ce$export$809d2b099693a9a8);
$parcel$export(module.exports, "BANNER_NAME", () => $d45809d2691157ce$export$41956b146268af93);

var $gwIPs = parcelRequire("gwIPs");
const $d45809d2691157ce$export$809d2b099693a9a8 = (0, $gwIPs.gridSize) * 6;
const $d45809d2691157ce$export$41956b146268af93 = 'EOC_TRANSITION';

});


parcelRegister("2jAre", function(module, exports) {

$parcel$export(module.exports, "useBannerMailExpiry", () => $85ae441f6f576caa$export$3906461ac9b87d2);

var $5uXOq = parcelRequire("5uXOq");

var $hZhhj = parcelRequire("hZhhj");

var $921us = parcelRequire("921us");

var $1cxlJ = parcelRequire("1cxlJ");
const $85ae441f6f576caa$export$3906461ac9b87d2 = ()=>{
    const { responseStatus: responseStatus, state: state } = (0, $hZhhj.useIncomingMailExpiryStatus)();
    const { onStateFetch: onStateFetch } = (0, $1cxlJ.useBannerActions)();
    const { isBannerShown: isBannerShown } = (0, $1cxlJ.useBannerState)();
    (0, $5uXOq.useEffect)(()=>{
        if (responseStatus === 'error') {
            onStateFetch((0, $hZhhj.DEFAULT_RESPONSE));
            return;
        }
        if (responseStatus === 'success') onStateFetch(state);
    }, [
        onStateFetch,
        responseStatus,
        state
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: isBannerShown,
            name: (0, $921us.BANNER_NAME),
            height: (0, $921us.HEIGHT)
        }), [
        isBannerShown
    ]);
};

});
parcelRegister("921us", function(module, exports) {

$parcel$export(module.exports, "HEIGHT", () => $c8abb4ba3ebc926f$export$809d2b099693a9a8);
$parcel$export(module.exports, "BANNER_NAME", () => $c8abb4ba3ebc926f$export$41956b146268af93);

var $gwIPs = parcelRequire("gwIPs");
const $c8abb4ba3ebc926f$export$809d2b099693a9a8 = (0, $gwIPs.gridSize) * 6;
const $c8abb4ba3ebc926f$export$41956b146268af93 = 'MAIL_EXPIRY_REMINDER';

});

parcelRegister("1cxlJ", function(module, exports) {

$parcel$export(module.exports, "useBannerActions", () => $b47a5e6c2ea18541$export$664f3e2467f0f5af);
$parcel$export(module.exports, "useBannerState", () => $b47a5e6c2ea18541$export$fa4ffa872ee90bd0);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $b47a5e6c2ea18541$export$d4c72bab9d6cc13a = {
    isBannerShown: false,
    isAdmin: false,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $b47a5e6c2ea18541$export$e324594224ef24da = {
    onDismiss: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isBannerShown: false
            });
        },
    onStateFetch: ({ showBanner: showBanner, isAdmin: isAdmin, OauthTypes: OauthTypes = [
        'GMAIL_OAUTH'
    ] })=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isBannerShown: showBanner && isAdmin,
                isAdmin: isAdmin,
                OauthTypes: OauthTypes
            });
        }
};
const $b47a5e6c2ea18541$var$Store = (0, $iXqE5.createStore)({
    name: 'mail-expiry-banner',
    initialState: $b47a5e6c2ea18541$export$d4c72bab9d6cc13a,
    actions: $b47a5e6c2ea18541$export$e324594224ef24da
});
const $b47a5e6c2ea18541$export$664f3e2467f0f5af = (0, $3sQ5x.createActionsHook)($b47a5e6c2ea18541$var$Store);
const $b47a5e6c2ea18541$export$fa4ffa872ee90bd0 = (0, $3sQ5x.createStateHook)($b47a5e6c2ea18541$var$Store);

});


parcelRegister("lrZro", function(module, exports) {

$parcel$export(module.exports, "useBannerReturnToMobileState", () => $2d8151e19ddaa4d5$export$571311559507e90);
$parcel$export(module.exports, "useBannerReturnToMobile", () => $2d8151e19ddaa4d5$export$a898dd7b7ec9917a);

var $5uXOq = parcelRequire("5uXOq");

var $bCdIp = parcelRequire("bCdIp");

var $c0dQj = parcelRequire("c0dQj");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $aAExw = parcelRequire("aAExw");
const $2d8151e19ddaa4d5$var$initialState = {
    isEnabled: (0, $bCdIp.shouldShowReturnToMobileBanner)()
};
const $2d8151e19ddaa4d5$var$actions = {
    disable: ()=>({ setState: setState })=>{
            setState({
                isEnabled: false
            });
        }
};
const $2d8151e19ddaa4d5$var$store = (0, $iXqE5.createStore)({
    initialState: $2d8151e19ddaa4d5$var$initialState,
    actions: $2d8151e19ddaa4d5$var$actions
});
const $2d8151e19ddaa4d5$export$571311559507e90 = (0, $3sQ5x.createHook)($2d8151e19ddaa4d5$var$store);
const $2d8151e19ddaa4d5$export$a898dd7b7ec9917a = ()=>{
    const [{ isEnabled: isEnabledOriginal }] = $2d8151e19ddaa4d5$export$571311559507e90();
    const isEnabled = (0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)() ? isEnabledOriginal && (0, $bCdIp.shouldShowReturnToMobileBannerMobileMvp)() : isEnabledOriginal;
    return (0, $5uXOq.useMemo)(()=>({
            isEnabled: isEnabled,
            name: (0, $aAExw.BANNER_NAME),
            height: (0, $aAExw.mobileBannerHeight)
        }), [
        isEnabled
    ]);
};

});
parcelRegister("aAExw", function(module, exports) {

$parcel$export(module.exports, "mobileBannerHeight", () => $61da032f64bef3a5$export$aa875602f5712b77);
$parcel$export(module.exports, "BANNER_NAME", () => $61da032f64bef3a5$export$41956b146268af93);
$parcel$export(module.exports, "ENCODED_APPLE_APP_STORE_URL", () => $61da032f64bef3a5$export$698c82a2c8445300);

var $gwIPs = parcelRequire("gwIPs");
const $61da032f64bef3a5$export$aa875602f5712b77 = (0, $gwIPs.gridSize) * 6;
const $61da032f64bef3a5$export$41956b146268af93 = 'RETURN_TO_MOBILE_BANNER';
const $61da032f64bef3a5$export$698c82a2c8445300 = encodeURIComponent('https://itunes.apple.com/app/apple-store/id1006972087');

});



parcelRegister("adRnT", function(module, exports) {

$parcel$export(module.exports, "BannerAnnouncementAsync", () => $30e1d77986915234$export$aa03f7909e0828ec);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $30e1d77986915234$var$BannerAnnouncement = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("bDn9q")).then((module)=>module.BannerAnnouncement), {
    ssr: true,
    moduleId: "./src/packages/platform/ui/banners/announcement/src/ui/banner-v2/BannerAnnouncement.tsx"
});
const $30e1d77986915234$export$aa03f7909e0828ec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-platform-ui-banners-announcement",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($30e1d77986915234$var$BannerAnnouncement, null));

});
parcelRegister("bDn9q", function(module, exports) {

let $87854b8f79226078$var$load = (parcelRequire("28QjX"))(4);
module.exports = $87854b8f79226078$var$load("bxnv2").then(()=>parcelRequire('dqid6'));

});


parcelRegister("14pJv", function(module, exports) {

$parcel$export(module.exports, "BannerTransitionAsync", () => $710b388646922007$export$8bf182764b9d2eb8);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $710b388646922007$var$BannerTransition = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("gMRW1")).then((module)=>module.BannerTransition), {
    moduleId: "./src/packages/platform/ui/banners/eoc-transition/src/ui/banner/index.tsx"
});
const $710b388646922007$export$8bf182764b9d2eb8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-banner-eoc-transition",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($710b388646922007$var$BannerTransition, null));

});
parcelRegister("gMRW1", function(module, exports) {

let $c38af758a7b0052c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c38af758a7b0052c$var$load("1OPKz").then(()=>parcelRequire('iGIQS'));

});


parcelRegister("9Cdg4", function(module, exports) {

$parcel$export(module.exports, "MailExpiryBannerAsync", () => $9a323272de0aa4c0$export$11a26ffa2d1b48ed);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $9a323272de0aa4c0$var$LazyMailExpiryBanner = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("7hR3x")).then(({ MailExpiryReminder: MailExpiryReminder })=>MailExpiryReminder), {
    moduleId: "./src/packages/platform/ui/banners/mail-expiry-reminder/src/ui/view.tsx"
});
const $9a323272de0aa4c0$export$11a26ffa2d1b48ed = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-mail-expiry-banner",
        packageName: "jiraPlatformUiMailExpiryReminder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-mail-expiry-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9a323272de0aa4c0$var$LazyMailExpiryBanner, null)));

});
parcelRegister("7hR3x", function(module, exports) {

let $54e346c12b7318b0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $54e346c12b7318b0$var$load("hjh1F").then(()=>parcelRequire('4tHNi'));

});


parcelRegister("9ylrc", function(module, exports) {

$parcel$export(module.exports, "ReturnToMobileBanner", () => $369ea7a3ed2830c2$export$81c4f1e869d5a87);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $369ea7a3ed2830c2$var$LazyReturnToMobileBanner = (0, $b7Svb.lazy)(()=>(parcelRequire("h9ega")).then(({ ReturnToMobileBanner: ReturnToMobileBanner })=>ReturnToMobileBanner), {
    moduleId: "./src/packages/platform/ui/return-to-mobile-banner/src/ReturnToMobileBanner.tsx"
});
const $369ea7a3ed2830c2$export$81c4f1e869d5a87 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-return-to-mobile-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($369ea7a3ed2830c2$var$LazyReturnToMobileBanner, null));

});
parcelRegister("h9ega", function(module, exports) {

let $c7be56a540302283$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c7be56a540302283$var$load("6z7Lu").then(()=>parcelRequire('cqWnC'));

});


parcelRegister("dm0Uk", function(module, exports) {

$parcel$export(module.exports, "ZIndexWrapper", () => $1be350c372161cad$export$6bdda512681a5774);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $1be350c372161cad$export$6bdda512681a5774 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { zIndex: zIndex, top: top, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w6mvmh": (0, $lD23V.default)(__cmplp.zIndex),
            "--_1vj9tq": (0, $lD23V.default)(__cmplp.top)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pby1fcb _kqswh2mm _154i1ter",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fbxog", function(module, exports) {

$parcel$export(module.exports, "AsyncNav4PromptBanner", () => $4a78c7c1f2d73e4c$export$f3facdeebaa0ea8);

var $5uXOq = parcelRequire("5uXOq");

var $kkd2O = parcelRequire("kkd2O");

var $b7Svb = parcelRequire("b7Svb");

const $4a78c7c1f2d73e4c$var$LazyNav4PromptBanner = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("iFZq8")).then(({ Nav4PromptBanner: Nav4PromptBanner })=>Nav4PromptBanner), {
    moduleId: "./src/packages/page-container-v2/src/common/ui/banner/nav4-prompt-banner/Nav4PromptBanner.tsx"
});
const $4a78c7c1f2d73e4c$export$f3facdeebaa0ea8 = ({ onDismiss: onDismiss })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkd2O.default), {
        name: "async-nav4-prompt-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a78c7c1f2d73e4c$var$LazyNav4PromptBanner, {
        onDismiss: onDismiss
    }));
};

});
parcelRegister("iFZq8", function(module, exports) {

let $d98bb3313f1d7a91$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d98bb3313f1d7a91$var$load("4zAqG").then(()=>parcelRequire('f6tst'));

});


parcelRegister("9nsmf", function(module, exports) {

$parcel$export(module.exports, "useNav4PromptBanner", () => $74cab3969c9fa05a$export$afd25c01a9db872a);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $itmJb = parcelRequire("itmJb");

var $8CVvd = parcelRequire("8CVvd");

var $bSSG7 = parcelRequire("bSSG7");
const $74cab3969c9fa05a$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('jira-nav4-prompt-banner');
const $74cab3969c9fa05a$var$NAV4_PROMPT_BANNER_DISMISSED = 'jira.nav4-prompt-banner.dismissed';
const $74cab3969c9fa05a$var$NAV4_PROMPT_BANNER_UPDATED_DISMISSED = 'jira.nav4-prompt-banner.updated.dismissed';
const $74cab3969c9fa05a$export$afd25c01a9db872a = ()=>{
    const [isDismissed, setDismissed] = (0, $5uXOq.useState)($74cab3969c9fa05a$var$localStorageProvider.get($74cab3969c9fa05a$var$NAV4_PROMPT_BANNER_DISMISSED));
    const [isUpdatedDismissed, setUpdatedDismissed] = (0, $5uXOq.useState)($74cab3969c9fa05a$var$localStorageProvider.get($74cab3969c9fa05a$var$NAV4_PROMPT_BANNER_UPDATED_DISMISSED));
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isNav3 = (0, $8CVvd.getWillShowNav3)();
    const shouldShowPromptBanner = isAdmin && isNav3 && !isDismissed && (0, $4R6GH.fg)('blu-6963-nav4-phase-1-admin-banner');
    const shouldShowPromptBannerUpdated = isAdmin && isNav3 && !isUpdatedDismissed && (0, $4R6GH.fg)('blu-6963-nav4-phase-1-admin-banner-pre-phase-2');
    (0, $5uXOq.useEffect)(()=>{
        $74cab3969c9fa05a$var$localStorageProvider.set($74cab3969c9fa05a$var$NAV4_PROMPT_BANNER_DISMISSED, isDismissed);
    }, [
        isDismissed
    ]);
    (0, $5uXOq.useEffect)(()=>{
        $74cab3969c9fa05a$var$localStorageProvider.set($74cab3969c9fa05a$var$NAV4_PROMPT_BANNER_UPDATED_DISMISSED, isUpdatedDismissed);
    }, [
        isUpdatedDismissed
    ]);
    return (0, $4R6GH.fg)('blu-6963-nav4-phase-1-admin-banner-pre-phase-2') ? {
        shouldShowPromptBanner: shouldShowPromptBannerUpdated,
        setDismissed: setUpdatedDismissed
    } : {
        shouldShowPromptBanner: shouldShowPromptBanner,
        setDismissed: setDismissed
    };
};

});


parcelRegister("kc9FZ", function(module, exports) {

$parcel$export(module.exports, "GlobalComponents", () => $87d424e5b411dd1e$export$461c2ed3163c74ff);

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");

var $7CMCs = parcelRequire("7CMCs");


var $6jY6G = parcelRequire("6jY6G");

var $aPfsS = parcelRequire("aPfsS");

var $2SVPM = parcelRequire("2SVPM");

var $imS60 = parcelRequire("imS60");
const $87d424e5b411dd1e$var$routeComponents = [];
const $87d424e5b411dd1e$var$RouteGlobalComponents = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $aPfsS.renderGlobalComponents)(route.layout?.globalComponents || $87d424e5b411dd1e$var$routeComponents));
};
// This component is necessary to ensure that the error boundary picks up errors in the renderGlobalComponents function
const $87d424e5b411dd1e$var$SharedGlobalComponents = ({ sharedGlobalComponents: sharedGlobalComponents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $aPfsS.renderGlobalComponents)(sharedGlobalComponents));
const $87d424e5b411dd1e$export$461c2ed3163c74ff = ({ sharedGlobalComponents: sharedGlobalComponents })=>{
    const globalComponentsPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$fb9876ab4228d985), (0, $9ccbd88c704da1ef$export$c20831be6f780cb5), (0, $9ccbd88c704da1ef$export$398df1bca49f9884), true, true);
    }, []);
    /**
	 * !!! DO NOT ADD INDIVIDUAL COMPONENTS TO THIS FILE !!!
	 *
	 * They should be defined as part of the `sharedGlobalComponents` constant, or defined on the route
	 * definition `layout` key.
	 *
	 * @see https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/platform/ui/layouts/jira-shared-layout/README.md
	 * @see https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/platform/ui/layouts/README.md
	 */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$c20831be6f780cb5)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-global-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "shared-global-components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87d424e5b411dd1e$var$SharedGlobalComponents, {
        sharedGlobalComponents: sharedGlobalComponents
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "route-global-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "route-global-components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87d424e5b411dd1e$var$RouteGlobalComponents, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$398df1bca49f9884),
        onSet: globalComponentsPerformanceTiming
    }));
};

});

parcelRegister("6DLIs", function(module, exports) {

$parcel$export(module.exports, "GlobalContainers", () => $1f7483f6f5b15b02$export$3b677a7048d7ae0);

var $5uXOq = parcelRequire("5uXOq");

var $1nQDQ = parcelRequire("1nQDQ");

var $irJ4w = parcelRequire("irJ4w");

var $jD5no = parcelRequire("jD5no");

var $2i4sA = parcelRequire("2i4sA");

var $gAeCk = parcelRequire("gAeCk");

var $5tsrJ = parcelRequire("5tsrJ");

var $j8DrX = parcelRequire("j8DrX");

var $lJ5jf = parcelRequire("lJ5jf");

var $3HwlS = parcelRequire("3HwlS");


var $8ApFP = parcelRequire("8ApFP");

var $4yEIl = parcelRequire("4yEIl");

var $iPMn1 = parcelRequire("iPMn1");

var $fiv1r = parcelRequire("fiv1r");

var $14XJw = parcelRequire("14XJw");

var $2SVPM = parcelRequire("2SVPM");

var $9OXo1 = parcelRequire("9OXo1");

var $eKtC8 = parcelRequire("eKtC8");

var $bAjl9 = parcelRequire("bAjl9");

var $lvG9V = parcelRequire("lvG9V");

var $gPTB6 = parcelRequire("gPTB6");

var $9kep9 = parcelRequire("9kep9");

var $eSznd = parcelRequire("eSznd");

var $ivvwC = parcelRequire("ivvwC");
const $1f7483f6f5b15b02$export$3b677a7048d7ae0 = ({ id: id, children: children, baseUrl: baseUrl, locale: locale, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
    const globalContainersPerformanceTiming = (0, $5uXOq.useCallback)(()=>{
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$4f341d86a3c214), (0, $9ccbd88c704da1ef$export$16e7ead3a8b5c366), (0, $9ccbd88c704da1ef$export$c389f0b50840d5ca), true, true);
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)((0, $9ccbd88c704da1ef$export$7048c99f32c60b34), (0, $9ccbd88c704da1ef$export$3c2d8af5c7577fe7), (0, $9ccbd88c704da1ef$export$aac77afee74c49d0), true, true);
    }, []);
    const { data: orgId } = (0, $14XJw.useOrgId)();
    // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const MonolithStyleOverride = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: `
                        body#jira {
                            overflow-x: hidden;
                            overflow-y: auto;
                        }

                        #jira-frontend {
                            background: ${"var(--ds-surface, #FFFFFF)"};
                        }

                        #jira_request_timing_info {
                            margin: 0;
                        }
                    `
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bAjl9.IntlProviders), {
        messages: messages,
        locale: locale
    }, __SPA__ && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MonolithStyleOverride, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $j8DrX.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irJ4w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5tsrJ.default), {
        orgId: orgId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2i4sA.ViewExperienceTrackingProvider), {
        analyticsSource: (0, $9ccbd88c704da1ef$export$c9e16a15d65437),
        experience: (0, $9ccbd88c704da1ef$export$b1534bc11f201efd),
        experienceId: (0, $9ccbd88c704da1ef$export$fa4bbc89fd1f1a7),
        application: (0, $9ccbd88c704da1ef$export$aa6008fe0169b864),
        edition: (0, $9ccbd88c704da1ef$export$39418a21fbb51487),
        additionalAttributes: (0, $8ApFP.routeAnalyticsAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eKtC8.ErrorBoundary), {
        id: id,
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$16e7ead3a8b5c366)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Router, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1nQDQ.default), {
        UNSAFE_isThemingDisabled: true,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$c389f0b50840d5ca)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9kep9.PageConfigContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lvG9V.MetricsContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fiv1r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPTB6.NavigationContainers), {
        baseUrl: baseUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivvwC.UserContainers), {
        baseUrl: baseUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eSznd.UiManagers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$3c2d8af5c7577fe7)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4yEIl.PostOfficeRouterListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        id: "page-container-v2.nav-v3.app-base",
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: (0, $9ccbd88c704da1ef$export$aac77afee74c49d0),
        onSet: globalContainersPerformanceTiming
    }), (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJ5jf.SidebarNav4ControllerProvider), null, children) : children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iPMn1.ScreenSpaceFlagsPlacement), null)))))))))))))));
};

});
parcelRegister("1nQDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $072edb073cd7b337$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i7GAe = parcelRequire("i7GAe");

var $4FiSH = parcelRequire("4FiSH");
const $072edb073cd7b337$var$InsideAppProviderContext = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
/**
 * __App provider__
 *
 * An app provider provides app level configuration such as global theming.
 *
 * Place it at the root of your application.
 */ function $072edb073cd7b337$var$AppProvider({ children: children, defaultColorMode: defaultColorMode = 'light', defaultTheme: defaultTheme, routerLinkComponent: routerLinkComponent, UNSAFE_isThemingDisabled: UNSAFE_isThemingDisabled }) {
    const isInsideAppProvider = (0, $5uXOq.useContext)($072edb073cd7b337$var$InsideAppProviderContext);
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    const routerLinkProvider = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i7GAe.default), {
        routerLinkComponent: routerLinkComponent,
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($072edb073cd7b337$var$InsideAppProviderContext.Provider, {
        value: true,
        children: UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4FiSH.default), {
            defaultColorMode: defaultColorMode,
            defaultTheme: defaultTheme,
            children: routerLinkProvider
        })
    });
}
var $072edb073cd7b337$export$2e2bcd8739ae039 = $072edb073cd7b337$var$AppProvider;

});

parcelRegister("2i4sA", function(module, exports) {

$parcel$export(module.exports, "ViewExperienceTrackingProvider", () => $c08cc6207a190361$export$a5efa46877be148f);
$parcel$export(module.exports, "SubExperienceTrackingProvider", () => $c08cc6207a190361$export$e0241c84ce5db240);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $jNwWT = parcelRequire("jNwWT");

var $aD4Nm = parcelRequire("aD4Nm");

var $ehKaJ = parcelRequire("ehKaJ");
const $c08cc6207a190361$export$a5efa46877be148f = ({ isExperienceReady: isExperienceReady, experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes, children: children })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehKaJ.default), {
        isExperienceReady: isExperienceReady,
        experience: experience,
        experienceId: experienceId,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        additionalAttributes: additionalAttributes
    }, children);
$c08cc6207a190361$export$a5efa46877be148f.defaultProps = {
    isExperienceReady: true,
    experienceId: null,
    additionalAttributes: {}
};
var $c08cc6207a190361$export$2e2bcd8739ae039 = $c08cc6207a190361$export$a5efa46877be148f;
const $c08cc6207a190361$export$e0241c84ce5db240 = ({ children: children, location: location, parentProviders: parentProviders })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : // DO NOT use `useContext` or `static contextType = ...` to consume this context
    // as the tree walker used in SSR does not support hooks
    // and SSR does not support `static contextType` setting
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jNwWT.default).Consumer, null, (context)=>{
        if (context == null) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('experience-sub-provider.missing-provider', 'Experience sub-provider rendered without a parent provider');
            return children;
        }
        const { experienceId: experienceId } = context;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD4Nm.ExperienceTracker), {
            location: location,
            parentProviders: parentProviders
        }, (trackerCallbacks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehKaJ.default), {
                parentTrackerCallbacks: trackerCallbacks,
                experience: location,
                experienceId: experienceId,
                analyticsSource: null,
                application: null,
                edition: null,
                isExperienceReady: true
            }, children));
    });
$c08cc6207a190361$export$e0241c84ce5db240.defaultProps = {
    parentProviders: null
};

});
parcelRegister("ehKaJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a267f2f54170b1c1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hh0bW = parcelRequire("hh0bW");


var $jNwWT = parcelRequire("jNwWT");
class $a267f2f54170b1c1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            parentTrackerCallbacks: null,
            additionalAttributes: {}
        };
    }
    constructor(props){
        super(props), this.onPending = ()=>{
            this.pendingCount += 1;
            this.shouldTrackExperience = true;
            this.checkAndStartTimer();
        }, this.onSuccess = ()=>{
            this.pendingCount -= 1;
            this.checkAndStartTimer();
        }, this.onFailure = (location, additionalAttributes)=>{
            // We need to track failure *immediately*, otherwise this component may
            // be unmounted and we'd miss our chance.
            this.trackExperience({
                wasExperienceSuccesful: false,
                location: location,
                additionalAttributes: additionalAttributes
            });
        }, this.onAbort = (location, additionalAttributes)=>{
            this.trackExperience({
                wasExperienceSuccesful: false,
                action: (0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8),
                location: location,
                additionalAttributes: additionalAttributes
            });
        };
        this.resetExperience();
    }
    componentDidMount() {
        this.checkAndStartTimer();
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isExperienceReady && this.props.isExperienceReady) this.checkAndStartTimer();
    }
    componentDidCatch(error) {
        // This catches any errors that bubble up to the Provider that
        // may not be caught by any ExperienceTrackers
        this.trackExperience({
            wasExperienceSuccesful: false,
            location: 'error-reached-provider',
            additionalAttributes: {
                errorMessage: error.message,
                errorName: error.name,
                ...this.props?.additionalAttributes
            }
        });
        // We're deliberately rethrowing the error here because we don't want to interfere with
        // any error handling the container app may have in place.
        throw error;
    }
    componentWillUnmount() {
        clearTimeout(this.timerId);
    }
    checkAndStartTimer() {
        if (this.shouldTrackExperience && this.props.isExperienceReady) this.startTimer();
    }
    startTimer() {
        clearTimeout(this.timerId);
        this.timerId = setTimeout(()=>{
            if (this.pendingCount === 0) this.trackExperience({
                wasExperienceSuccesful: true
            });
        }, 1000);
    }
    // Resetting must not call setState since this can be executed in the render phase
    resetExperience() {
        clearTimeout(this.timerId);
        this.timerId = undefined;
        this.shouldTrackExperience = false;
        this.hasTrackedExperience = false;
        this.pendingCount = 0;
        this.memoizedContext = {
            consumerCallbacks: {
                onPending: this.onPending,
                onSuccess: this.onSuccess,
                onFailure: this.onFailure,
                onAbort: this.onAbort
            },
            experienceId: this.props.experienceId,
            experience: this.props.experience
        };
    }
    trackExperience({ wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, additionalAttributes: additionalAttributes }) {
        if (this.hasTrackedExperience) // We only ever want to send a single success/failure event for an experience
        return;
        this.hasTrackedExperience = true;
        const { parentTrackerCallbacks: parentTrackerCallbacks, additionalAttributes: additionalAttributesFromProps } = this.props;
        if (parentTrackerCallbacks) {
            if (wasExperienceSuccesful) parentTrackerCallbacks.onExperienceSuccess();
            else parentTrackerCallbacks.onExperienceFailure(location, {
                ...additionalAttributesFromProps,
                ...additionalAttributes
            });
        } else {
            const { experience: experience } = this.memoizedContext;
            const { analyticsSource: analyticsSource, application: application, edition: edition } = this.props;
            analyticsSource && (0, $hh0bW.default)({
                experience: experience,
                action: action,
                wasExperienceSuccesful: wasExperienceSuccesful,
                location: location,
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: {
                    ...additionalAttributesFromProps,
                    ...additionalAttributes
                }
            });
        }
    }
    // Check every render to reset the experience state instance variables
    checkExperienceIdForExperienceReset() {
        if (this.memoizedContext.experienceId !== this.props.experienceId) this.resetExperience();
    }
    render() {
        this.checkExperienceIdForExperienceReset();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jNwWT.default).Provider, {
            value: this.memoizedContext
        }, this.props.children);
    }
}

});
const $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $c0ec49ac5a1e4009$export$b48b3d1872522384 = 'taskFail';
const $c0ec49ac5a1e4009$export$aeeb00d0845d24d8 = 'taskAbort';



parcelRegister("iPMn1", function(module, exports) {

$parcel$export(module.exports, "ScreenSpaceFlagsPlacement", () => $3ba8955bb8ac2826$export$f6564e60882bdf90);

var $5uXOq = parcelRequire("5uXOq");

var $4P6dh = parcelRequire("4P6dh");

var $4R6GH = parcelRequire("4R6GH");

var $jQsty = parcelRequire("jQsty");

var $ZILlH = parcelRequire("ZILlH");

var $7kpP2 = parcelRequire("7kpP2");

const $3ba8955bb8ac2826$var$PLACEMENT_ID = 'screen-space-flags';
const $3ba8955bb8ac2826$export$f6564e60882bdf90 = ()=>{
    return !false && !(0, $jQsty.default)((0, $d0ca21152325de6b$export$37d4bb5bc0e315db)) && (0, $4R6GH.fg)('post-office-screen-space-overlay-jfe') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7kpP2.ScreenSpaceFlagPlacementPreviewSwitcher), {
        // https://switcheroo.atlassian.com/ui/gates/8fe500fb-6c32-48c7-be3f-caf511e97a8e/key/post-office_enable_screen-space-preview_jfe
        isEnabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ZILlH.default), {
        placementId: $3ba8955bb8ac2826$var$PLACEMENT_ID,
        PlacementComponent: (0, $4P6dh.default),
        disableInitialData: true
    })) : null;
};

});
parcelRegister("4P6dh", function(module, exports) {

$parcel$export(module.exports, "ScreenSpaceFlagsPlacementComponent", () => $2a2e0f9f256ac748$export$c60b43809441c5b0);
$parcel$export(module.exports, "default", () => $2a2e0f9f256ac748$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $96Irh = parcelRequire("96Irh");

var $gpqq8 = parcelRequire("gpqq8");
var $aAASp = parcelRequire("aAASp");

var $ddiyw = parcelRequire("ddiyw");

var $e2ICd = parcelRequire("e2ICd");
var $kZgxR = parcelRequire("kZgxR");

var $hvAAP = parcelRequire("hvAAP");

var $eZLrf = parcelRequire("eZLrf");

var $5WiNI = parcelRequire("5WiNI");


var $hYSou = parcelRequire("hYSou");
const $2a2e0f9f256ac748$export$c60b43809441c5b0 = (0, $hYSou.withScreenSpaceFlagsIntlProvider)((0, $e2ICd.createPlacementComponent)((0, $71e5a4e9be702d09$export$a5cfae247d8360ef), ({ initialData: initialData })=>{
    const [localMessageState, setLocalMessageState] = (0, $5uXOq.useState)();
    (0, $kZgxR.useInitialData)(initialData);
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $aAASp.useMessagePlacementHooks)();
    const handleDismiss = ({ messageInstanceId: messageInstanceId })=>{
        setLocalMessageState((current)=>current ? current.filter((e)=>e.messageInstanceId !== messageInstanceId) : undefined);
    };
    (0, $5uXOq.useEffect)(()=>onMessageDismiss(handleDismiss), [
        onMessageDismiss
    ]);
    (0, $5uXOq.useEffect)(()=>onMessageClicked(handleDismiss), [
        onMessageClicked
    ]);
    (0, $5uXOq.useEffect)(()=>onMessageSnooze(handleDismiss), [
        onMessageSnooze
    ]);
    const activeScopes = (0, $gpqq8.usePostOfficeContextScope)({
        scopes: $eZLrf.scopes
    });
    const messagesState = (0, $hvAAP.usePlacementApi)('/update-messages', {
        requestOptions: {
            method: 'POST',
            body: JSON.stringify(activeScopes)
        },
        throttleTime: 100,
        autoRefetch: {
            isEnabled: !!activeScopes.updateKey && typeof localMessageState === 'undefined',
            updateKey: activeScopes.updateKey ?? ''
        }
    });
    (0, $5uXOq.useEffect)(()=>{
        if (messagesState?.data?.messages?.length) setLocalMessageState(messagesState.data.messages);
    }, [
        messagesState.data
    ]);
    return (0, $96Irh.default).checkGate('post-office-screen-space-flags-shadow') ? /*#__PURE__*/ (0, $2OMIu.jsx)($2a2e0f9f256ac748$var$SuppressIfModalIsPresent, {
        children: localMessageState?.slice(0, 1).map(({ messageInstanceId: messageInstanceId, ...props })=>// Adding @ts-ingore to suppress the error in confluence typecheck and below error is not thrown in post-office typecheck
            // This error exists because confluence is using react 16 and post-office is using react 18
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - 'ReactNode | ReactElement<any, any>' is not a valid JSX element.
            /*#__PURE__*/ (0, $5uXOq.createElement)((0, $5WiNI.MessageRenderer), {
                ...props,
                key: messageInstanceId,
                id: messageInstanceId,
                messageInstanceId: messageInstanceId,
                onDismissed: ()=>setLocalMessageState([])
            }))
    }) : null;
}));
var $2a2e0f9f256ac748$export$2e2bcd8739ae039 = $2a2e0f9f256ac748$export$c60b43809441c5b0;
const $2a2e0f9f256ac748$var$SuppressIfModalIsPresent = ({ children: children })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ddiyw.useFirePostOfficeAnalyticsEvents)();
    const [isVisible, setIsVisible] = (0, $5uXOq.useState)(true);
    const handleVisibilityChange = (0, $5uXOq.useCallback)((modalOnScreen)=>{
        const shouldShow = !modalOnScreen;
        if (!shouldShow) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'suppressed',
            actionSubject: 'screenSpaceFlags'
        });
        setIsVisible(shouldShow);
    }, [
        fireAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const modalOnScreen = !!globalThis.document.querySelector('.atlaskit-portal-container .atlaskit-portal [role=dialog]');
        handleVisibilityChange(modalOnScreen);
    }, [
        handleVisibilityChange
    ]);
    return (0, $96Irh.default).checkGate('post-office-screen-space-flags-modal-detector') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: isVisible && children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});
parcelRegister("gpqq8", function(module, exports) {

$parcel$export(module.exports, "usePostOfficeContextScope", () => $4098044450395ec5$export$daf66a67c26dc848);

var $5uXOq = parcelRequire("5uXOq");

var $kye0Q = parcelRequire("kye0Q");

var $ggVl0 = parcelRequire("ggVl0");

var $7LKoA = parcelRequire("7LKoA");

var $bkD77 = parcelRequire("bkD77");
const $4098044450395ec5$export$daf66a67c26dc848 = (config)=>{
    const scopeNames = $4098044450395ec5$var$scopesNamesAsString(config.scopes);
    const matchScopes = (0, $5uXOq.useCallback)((input)=>$4098044450395ec5$export$ec890b48cae4cc1c(config)(input), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        scopeNames
    ]);
    const [state, setState] = (0, $5uXOq.useState)($4098044450395ec5$var$initialState);
    const route = (0, $7LKoA.usePostOfficeRoute)();
    const context = (0, $ggVl0.usePostOfficeContext)();
    const next = matchScopes({
        route: route,
        context: context
    });
    $4098044450395ec5$var$usePostOfficeScopeSpy(state, config);
    (0, $5uXOq.useEffect)(()=>{
        if ($4098044450395ec5$export$fcc046cb16c47539({
            next: next,
            state: state
        })) setState(({ current: current })=>({
                updateKey: Math.random().toString(36).substring(2),
                current: next,
                previous: current
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        $4098044450395ec5$var$scopesNamesAsString(next)
    ]);
    return state;
};
const $4098044450395ec5$var$scopesNamesAsString = (scopes = [])=>scopes.map((e)=>e.name).sort().join(',');
const $4098044450395ec5$var$initialState = {
    updateKey: undefined,
    current: [],
    previous: []
};
const $4098044450395ec5$var$createMatchScope = ({ route: route, context: context })=>(input)=>{
        const contextMatch = route?.current ? {
            route: $4098044450395ec5$var$extractRelevantUrlFields(route.current),
            context: context
        } : {
            route: undefined,
            context: context
        };
        const inputMatch = input.when;
        return $4098044450395ec5$var$matchScope({
            contextMatch: contextMatch,
            inputMatch: inputMatch
        });
    };
const $4098044450395ec5$var$extractRelevantUrlFields = (route)=>{
    const { hostname: hostname, pathname: pathname } = new URL(route);
    return {
        hostname: hostname,
        pathname: pathname
    };
};
const $4098044450395ec5$var$matchScope = ({ contextMatch: contextMatch, inputMatch: inputMatch })=>(0, (/*@__PURE__*/$parcel$interopDefault($kye0Q)))(contextMatch, inputMatch, (contextValue, inputValue)=>$4098044450395ec5$var$isValueMatchDeep({
            contextValue: contextValue,
            inputValue: inputValue
        }));
const $4098044450395ec5$var$isValueMatch = ({ contextValue: contextValue, inputValue: inputValue })=>{
    if (!contextValue || !inputValue) return false;
    if (typeof inputValue === 'string') return contextValue === inputValue;
    if (inputValue?.equals) return contextValue === inputValue.equals;
    if (!inputValue?.matches) return false;
    if (typeof inputValue.matches !== 'string' || typeof contextValue !== 'string') return false;
    return new RegExp(inputValue.matches).test(contextValue);
};
const $4098044450395ec5$var$isValueMatchDeep = ({ contextValue: contextValue, inputValue: inputValue })=>typeof inputValue === 'object' && typeof contextValue === 'object' ? $4098044450395ec5$var$matchScope({
        contextMatch: contextValue,
        inputMatch: inputValue
    }) : $4098044450395ec5$var$isValueMatch({
        contextValue: contextValue,
        inputValue: inputValue
    });
const $4098044450395ec5$export$ec890b48cae4cc1c = ({ scopes: scopes })=>(input)=>scopes.filter($4098044450395ec5$var$createMatchScope(input)).map((scope)=>({
                name: scope.name
            }));
const $4098044450395ec5$export$fcc046cb16c47539 = ({ next: next, state: state })=>{
    const currentSet = Array.from(new Set(state.current.map((e)=>e.name)));
    const nextSet = Array.from(new Set(next.map((e)=>e.name)));
    if (nextSet.length !== currentSet.length) return true;
    return !nextSet.every((e)=>currentSet.includes(e));
};
// Scope Spy
const $4098044450395ec5$var$usePostOfficeScopeSpy = (state, config)=>{
    if (config?.consoleSpy && typeof window !== 'undefined' && !window?.postOffice?.scopes) {
        const [listen, update] = (0, $bkD77.createSimplePubSub)();
        window.postOffice = {
            ...window.postOffice,
            scopes: {
                [config?.consoleSpy.name]: {
                    listen: listen,
                    update: update,
                    list: config.scopes
                }
            }
        };
    }
    (0, $5uXOq.useEffect)(()=>{
        if (!config?.consoleSpy) return;
        if (!window.postOffice?.scopes) return;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        window.postOffice?.scopes?.[config?.consoleSpy.name]?.update?.(state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        $4098044450395ec5$var$scopesNamesAsString(state.current)
    ]);
};

});
parcelRegister("kye0Q", function(module, exports) {

var $b1bUS = parcelRequire("b1bUS");

var $2TGin = parcelRequire("2TGin");
/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */ function $ef61da41fa345164$var$isMatchWith(object, source, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    return $b1bUS(object, source, $2TGin(source), customizer);
}
module.exports = $ef61da41fa345164$var$isMatchWith;

});


parcelRegister("hvAAP", function(module, exports) {

$parcel$export(module.exports, "usePlacementApi", () => $bc438897dc52c739$export$201bbce8187a6e3c);

var $ggVl0 = parcelRequire("ggVl0");

var $jm1yu = parcelRequire("jm1yu");

var $d43BM = parcelRequire("d43BM");

var $2EUTa = parcelRequire("2EUTa");

var $5uXOq = parcelRequire("5uXOq");
const $bc438897dc52c739$export$201bbce8187a6e3c = (path, config)=>{
    const { placementId: placementId } = (0, $2EUTa.usePlacementContext)();
    const context = (0, $ggVl0.usePostOfficeContext)();
    const fetcher = (0, $jm1yu.usePlacementFetchingContext)();
    const placementApi = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!placementId) return ()=>({
                isLoading: false,
                data: undefined,
                error: new Error('No placementId found, make this is used as a child of PlacementProvider')
            });
        return (0, $d43BM.createUsePlacement)(placementId, fetcher);
    }, [
        placementId,
        fetcher
    ]);
    return placementApi(path, context, config?.requestOptions, {
        throttleTime: config?.throttleTime,
        isEnabled: config?.autoRefetch?.isEnabled,
        deps: [
            config?.autoRefetch?.updateKey
        ]
    });
};

});
parcelRegister("d43BM", function(module, exports) {

$parcel$export(module.exports, "createUsePlacement", () => $a4f776a6cf9deba7$export$ee1d67e435d25cb5);

var $47CCc = parcelRequire("47CCc");

var $5uXOq = parcelRequire("5uXOq");

var $02EmO = parcelRequire("02EmO");
const $a4f776a6cf9deba7$var$depsIsValid = (deps)=>Array.isArray(deps);
const $a4f776a6cf9deba7$export$ee1d67e435d25cb5 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const dependencyList = $a4f776a6cf9deba7$var$depsIsValid(config?.deps) ? [
            ...config.deps,
            config?.isEnabled
        ] : [
            path,
            config?.isEnabled
        ];
        const timerRef = (0, $5uXOq.useRef)();
        const isRunningPromise = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                if (timerRef.current) clearTimeout(timerRef.current);
            };
        }, []);
        const promiseToResolve = (0, $5uXOq.useMemo)(()=>{
            if (config?.isEnabled === false) return undefined;
            return ({ signal: signal })=>{
                if (isRunningPromise.current) return Promise.reject(new (0, $02EmO.AlreadyRunningError)());
                isRunningPromise.current = true;
                timerRef.current = setTimeout(()=>{
                    isRunningPromise.current = false;
                }, config?.throttleTime ?? 0);
                return (0, $47CCc.fetchPlacementData)(placementId, path, context, fetcher, {
                    ...requestOptions,
                    signal: signal
                });
            };
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        dependencyList);
        return (0, $02EmO.useData)(promiseToResolve, {
            analytics: {
                name: placementId,
                path: path
            }
        });
    };
};

});
parcelRegister("47CCc", function(module, exports) {

$parcel$export(module.exports, "fetchPlacementData", () => $d21625b57f87e3c2$export$ce743d02f83ee521);
const $d21625b57f87e3c2$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $d21625b57f87e3c2$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $d21625b57f87e3c2$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$d21625b57f87e3c2$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $d21625b57f87e3c2$export$ce743d02f83ee521 = (placementId, path, context, fetcher, requestOptions)=>{
    const defaultHeaders = {
        credentials: 'include',
        mode: 'cors',
        'Content-Type': 'application/json'
    };
    const normalizedPath = `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const contextAsSearchParams = new URLSearchParams($d21625b57f87e3c2$var$stringifyObjectValues(context)).toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$d21625b57f87e3c2$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return fetcher.fetch(url, {
        ...requestOptions,
        headers: {
            ...defaultHeaders,
            ...requestOptions?.headers
        }
    });
};

});



parcelRegister("eZLrf", function(module, exports) {

$parcel$export(module.exports, "scopes", () => $45de07aebd16aefe$export$54a06e3f4a159ad8);
const $45de07aebd16aefe$export$54a06e3f4a159ad8 = [
    {
        name: 'all',
        when: {
            route: {
                pathname: {
                    matches: '.*'
                }
            }
        }
    },
    {
        name: 'admin/all',
        when: {
            context: {
                product: 'admin'
            }
        }
    },
    {
        name: 'admin/products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'products'
                }
            }
        }
    },
    {
        name: 'admin/discovered-products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'discovered-products'
                }
            }
        }
    },
    {
        name: 'admin/domains',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'domains'
                }
            }
        }
    },
    {
        name: 'admin/user-access-settings',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'user-access-settings'
                }
            }
        }
    },
    {
        name: 'admin/authentication-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'authentication-policies'
                }
            }
        }
    },
    {
        name: 'admin/users',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'users'
                }
            }
        }
    },
    {
        name: 'admin/audit-log',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'audit-log'
                }
            }
        }
    },
    {
        name: 'admin/billing-preview',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'billing-preview'
                }
            }
        }
    },
    {
        name: 'admin/data-security-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'data-security-policies'
                }
            }
        }
    },
    {
        name: 'jira/all',
        when: {
            context: {
                product: 'jira'
            }
        }
    },
    {
        name: 'jira/kanban',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'board'
                }
            }
        }
    },
    {
        name: 'confluence/all',
        when: {
            context: {
                product: 'confluence'
            }
        }
    },
    {
        name: 'pop3/all',
        when: {
            context: {
                product: 'pop3'
            }
        }
    },
    {
        name: 'pop3/send-it',
        when: {
            context: {
                product: 'pop3'
            },
            route: {
                pathname: {
                    matches: 'send-it'
                }
            }
        }
    },
    {
        name: 'trello/all',
        when: {
            context: {
                product: 'trello'
            }
        }
    },
    {
        name: 'jira/queue',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'queue'
                }
            }
        }
    },
    {
        name: 'jira/browse',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'browse'
                }
            }
        }
    },
    {
        name: 'jira/issues',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'issues'
                }
            }
        }
    },
    {
        name: 'jira/software',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software'
                }
            }
        }
    },
    {
        name: 'jira/polaris',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/polaris'
                }
            }
        }
    },
    {
        name: 'jira/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'backlog'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk'
                }
            }
        }
    },
    {
        name: 'jira/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '.*(?=.*project)(?=.*setting).*'
                }
            }
        }
    },
    {
        name: 'jira/your-work',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'your-work'
                }
            }
        }
    },
    {
        // Handles both CMP Software and Business
        name: 'jira/cmp/project-settings/people',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'plugins/servlet/project-config/.*?/people'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/access'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/access'
                }
            }
        }
    }
];

});

parcelRegister("5WiNI", function(module, exports) {

$parcel$export(module.exports, "MessageRenderer", () => $9c3bdc98cca2fbe2$export$2df1250b8f917a59);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $aMNd8 = parcelRequire("aMNd8");

var $9wuA2 = parcelRequire("9wuA2");

var $lkxCI = parcelRequire("lkxCI");

var $57zZG = parcelRequire("57zZG");

var $e0e77 = parcelRequire("e0e77");

var $1zJe1 = parcelRequire("1zJe1");

var $54lFD = parcelRequire("54lFD");

var $8boD4 = parcelRequire("8boD4");

var $kuhIw = parcelRequire("kuhIw");
const $9c3bdc98cca2fbe2$export$e30378e28ad3e6ab = {
    ...(0, $9wuA2.default),
    ...(0, $lkxCI.default),
    ...(0, $57zZG.default),
    ...(0, $e0e77.default),
    ...(0, $1zJe1.default),
    ...(0, $54lFD.default),
    ...(0, $8boD4.default),
    ...(0, $kuhIw.default)
};
const { initializeMessageRenderer: $9c3bdc98cca2fbe2$export$bce4e5106d86e473, MessageRenderer: $9c3bdc98cca2fbe2$export$2df1250b8f917a59 } = (0, $aMNd8.asMessageRenderer)($9c3bdc98cca2fbe2$export$e30378e28ad3e6ab);

});
parcelRegister("9wuA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab02bbe8331cfe5d$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");



var $ab02bbe8331cfe5d$export$2e2bcd8739ae039 = {
    'confluence-commented-on-page-nudge': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("eI5Oj"))),
    'confluence-mentioned-in-comment-nudge': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("bxQH9"))),
    'confluence-mentioned-on-page-nudge': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("limek")))
};

});
parcelRegister("eI5Oj", function(module, exports) {

let $ab59ae9b6d6c6614$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ab59ae9b6d6c6614$var$load("lHBow").then(()=>parcelRequire('eWREH'));

});

parcelRegister("bxQH9", function(module, exports) {

let $867ba6ea41576e5c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $867ba6ea41576e5c$var$load("3Ep1H").then(()=>parcelRequire('6iASB'));

});

parcelRegister("limek", function(module, exports) {

let $f80c85dabfc169a7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f80c85dabfc169a7$var$load("dc4LL").then(()=>parcelRequire('e1C7X'));

});


parcelRegister("lkxCI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d82825850788abe$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");

var $0d82825850788abe$export$2e2bcd8739ae039 = {
    'jira-access-page-contact-sales-nudge': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("1AnTh")))
};

});
parcelRegister("1AnTh", function(module, exports) {

let $127baf701505526f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $127baf701505526f$var$load("iXbx2").then(()=>parcelRequire('efEkx'));

});


parcelRegister("57zZG", function(module, exports) {

$parcel$export(module.exports, "default", () => $cac1aaaefd3a55da$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");

var $cac1aaaefd3a55da$export$2e2bcd8739ae039 = {
    'jira-forms-conditional-fields-changeboarding': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("fxmWJ")))
};

});
parcelRegister("fxmWJ", function(module, exports) {

let $b4fbbcbd6d755997$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b4fbbcbd6d755997$var$load("64QTa").then(()=>parcelRequire('gbtl7'));

});


parcelRegister("e0e77", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4636aa98a14dac7$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");

var $a4636aa98a14dac7$export$2e2bcd8739ae039 = {
    'marketing-screen-space-flag-contentful-usecase': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("k20C8")))
};

});
parcelRegister("k20C8", function(module, exports) {

let $e95478824b578f2a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e95478824b578f2a$var$load("idBCe").then(()=>parcelRequire('hyM6F'));

});


parcelRegister("1zJe1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d26e5ccfb6ccbcf2$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");

var $d26e5ccfb6ccbcf2$export$2e2bcd8739ae039 = {
    'mercury-edit-hierarchy-spotlight': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("lUn9A")))
};

});
parcelRegister("lUn9A", function(module, exports) {

let $ff30c9c1d959ad61$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ff30c9c1d959ad61$var$load("jElL3").then(()=>parcelRequire('kv9oC'));

});


parcelRegister("54lFD", function(module, exports) {

$parcel$export(module.exports, "default", () => $ead23cfbceb0300e$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");

var $ead23cfbceb0300e$export$2e2bcd8739ae039 = {
    'end-of-trial-extension': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("87iWa")))
};

});
parcelRegister("87iWa", function(module, exports) {

let $5e8daababcb9df20$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5e8daababcb9df20$var$load("dT127").then(()=>parcelRequire('L8FVn'));

});


parcelRegister("8boD4", function(module, exports) {

$parcel$export(module.exports, "default", () => $eede2b477d7c8ed1$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");

var $eede2b477d7c8ed1$export$2e2bcd8739ae039 = {
    'message-template-template': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("6fkeW")))
};

});
parcelRegister("6fkeW", function(module, exports) {

let $48c3d80eb69e92c6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $48c3d80eb69e92c6$var$load("hxTj6").then(()=>parcelRequire('2qDjb'));

});


parcelRegister("kuhIw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f90ac805800e577c$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $5uXOq = parcelRequire("5uXOq");



var $f90ac805800e577c$export$2e2bcd8739ae039 = {
    'test-message-inapp': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("9aA0h"))),
    'test-message-inapp-implicit-pendo': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("5jlBO"))),
    'test-message-tap-ingestion-trigger-subscription': /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("9PpP3")))
};

});
parcelRegister("9aA0h", function(module, exports) {

let $6ad0f9c695de32dd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6ad0f9c695de32dd$var$load("1lfVU").then(()=>parcelRequire('9M09V'));

});

parcelRegister("5jlBO", function(module, exports) {

let $3ddf7d28c223774d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3ddf7d28c223774d$var$load("CDTCX").then(()=>parcelRequire('a8qag'));

});

parcelRegister("9PpP3", function(module, exports) {

let $727ce845a4686c54$var$load = (parcelRequire("28QjX"))(4);
module.exports = $727ce845a4686c54$var$load("3awYZ").then(()=>parcelRequire('hqI2g'));

});



/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $71e5a4e9be702d09$export$a5cfae247d8360ef = 'screen-space-flags';

parcelRegister("hYSou", function(module, exports) {

$parcel$export(module.exports, "withScreenSpaceFlagsIntlProvider", () => $f74eb148a254456f$export$b0eee5de066b2bf5);
/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $lyW0g = parcelRequire("lyW0g");

var $5sgas = parcelRequire("5sgas");

var $fcJ0k = parcelRequire("fcJ0k");

var $2dP7d = parcelRequire("2dP7d");

var $eUS5g = parcelRequire("eUS5g");

var $bV4gU = parcelRequire("bV4gU");

var $dCTL2 = parcelRequire("dCTL2");

var $fJUJM = parcelRequire("fJUJM");

var $kZ7Oy = parcelRequire("kZ7Oy");
const $f74eb148a254456f$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $5sgas.messagesLoader)(locale),
        (0, $fcJ0k.messagesLoader)(locale),
        (0, $2dP7d.messagesLoader)(locale),
        (0, $eUS5g.messagesLoader)(locale),
        (0, $bV4gU.messagesLoader)(locale),
        (0, $dCTL2.messagesLoader)(locale),
        (0, $fJUJM.messagesLoader)(locale),
        (0, $kZ7Oy.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $f74eb148a254456f$export$b0eee5de066b2bf5 = (Component)=>{
    return (0, $lyW0g.withIntlProvider)({
        messagesLoader: $f74eb148a254456f$export$d5a462ce7bd04520
    }, Component);
};

});
parcelRegister("5sgas", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $7d3c37c8709bff28$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $dU7yi = parcelRequire("dU7yi");

var $2AtjH = parcelRequire("2AtjH");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7d3c37c8709bff28$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;































const $7d3c37c8709bff28$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $2AtjH.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("gD3HZ")));
        case 'da':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("c5uwD")));
        case 'de':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("eOnG5")));
        case 'en-GB':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("2dEkS")));
        case 'en-US':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("2639H")));
        case 'en-XA':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("lG42T")));
        case 'en-XB':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("f946f")));
        case 'en-ZZ':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("2NuJP")));
        case 'en':
            return $7d3c37c8709bff28$var$importHelper(await Promise.resolve((parcelRequire("dU7yi"))));
        case 'es':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("9udOh")));
        case 'et':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("drIvG")));
        case 'fi':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("5ocfS")));
        case 'fr':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("2X4dh")));
        case 'hu':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("elkju")));
        case 'it':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("bZzmg")));
        case 'ja':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("k6ozU")));
        case 'ko':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("horFd")));
        case 'nb':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("ic586")));
        case 'nl':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("gVolN")));
        case 'pl':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("6F3S7")));
        case 'pt-BR':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("9784C")));
        case 'ro':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("6Unlx")));
        case 'ru':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("7KXwg")));
        case 'sv':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("kYvdD")));
        case 'th':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("dTOv7")));
        case 'tr':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("aHWYt")));
        case 'uk':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("lwjDR")));
        case 'vi':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("fY4tq")));
        case 'zh-CN':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("EUPUH")));
        case 'zh-TW':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("fqAld")));
        case 'zh':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("56ePW")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($dU7yi));
    }
};

});
parcelRegister("dU7yi", function(module, exports) {
module.exports = JSON.parse('{"app-switcher-discovery-section.discover-more-products":[{"type":0,"value":"Discover more apps"}],"app-switcher-discovery-section.more-atlassian-products":[{"type":0,"value":"More Atlassian apps"}],"app-switcher-discovery-section.recommended-for-your-team":[{"type":0,"value":"Recommended for your team"}],"first-party-recommendation.reason-1":[{"type":0,"value":"the size of your team"}],"first-party-recommendation.reason-2":[{"type":0,"value":"your existing Atlassian products"}],"growth.admin-hub-recommendation.actions-heading":[{"type":0,"value":"Actions"}],"growth.admin-hub-recommendation.free-plan":[{"type":0,"value":"Free, cancel anytime"}],"growth.admin-hub-recommendation.heading":[{"type":0,"value":"Recommended based on your existing products"}],"growth.admin-hub-recommendation.plan-heading":[{"type":0,"value":"Plan"}],"growth.admin-hub-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"growth.app-switcher-discovery-section.flag.description":[{"type":0,"value":"You won\u2019t see this here as often."}],"growth.app-switcher-discovery-section.flag.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"growth.app-switcher-discovery-section.wac-toast.close.aria-label":[{"type":0,"value":"Dismiss toast"}],"growth.recommendation-atlas.value-proposition":[{"type":0,"value":"Your company\'s teamwork directory"}],"growth.recommendation-confluence.cta.label":[{"type":0,"value":"Try Confluence"}],"growth.recommendation-confluence.jira-your-work.description":[{"type":0,"value":"Create a centralized space to organize requirements, release notes, goals, and more."}],"growth.recommendation-confluence.jira-your-work.header":[{"type":0,"value":"Get everyone on the same page"}],"growth.recommendation-confluence.jira-your-work.header-image-alt-text":[{"type":0,"value":"Multiple people collaborating and commenting on the same page at the same time"}],"growth.recommendation-confluence.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.product-alt-text":[{"type":0,"value":"A document titled quarterly planning. The document has details like mission, scope and a monthly plan."}],"growth.recommendation-confluence.product-heading":[{"type":0,"value":"Create one source of truth, for all"}],"growth.recommendation-confluence.product-name.header":[{"type":0,"value":"Collaborate on pages in real-time"}],"growth.recommendation-confluence.product-subheading":[{"type":0,"value":"Create and link documents like release notes, product requirements, and roadmaps from a single place."}],"growth.recommendation-confluence.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.value-proposition":[{"type":0,"value":"Document collaboration"}],"growth.recommendation-jira.product-alt-text":[{"type":0,"value":"A board view to move tasks from to do, to in progress to done"}],"growth.recommendation-jira.product-heading":[{"type":0,"value":"Plan and track work across teams"}],"growth.recommendation-jira.product-subheading":[{"type":0,"value":"Break big ideas down into achievable steps. Organize work, create milestones, map dependencies, and get visibility across all teams."}],"growth.recommendation-jpd-product-roadmap.value-proposition":[{"type":0,"value":"Align everyone with custom roadmaps"}],"growth.recommendation-jpd.admin-hub-recommendation-value-proposition":[{"type":0,"value":"Plan and deliver all on the same platform"}],"growth.recommendation-jpd.cta.label":[{"type":0,"value":"Try Jira Product Discovery"}],"growth.recommendation-jpd.jira-your-work.description":[{"type":0,"value":"Prioritize your ideas then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.jira-your-work.header":[{"type":0,"value":"Build right features, the right way"}],"growth.recommendation-jpd.jira-your-work.header-image-alt-text":[{"type":0,"value":"An idea in Jira Product Discovery automatically turning into an Epic in Jira"}],"growth.recommendation-jpd.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.product-alt-text":[{"type":0,"value":"Five ideas are all organized into now, next and later groups, with a goal, score and effort ranking connected to each idea."}],"growth.recommendation-jpd.product-heading":[{"type":0,"value":"Build the right features, the right way"}],"growth.recommendation-jpd.product-name.header":[{"type":0,"value":"Transform insights into action plans"}],"growth.recommendation-jpd.product-subheading":[{"type":0,"value":"Capture and prioritize your ideas, then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.value-proposition":[{"type":0,"value":"Prioritize, collaborate, and deliver new ideas"}],"growth.recommendation-jsm-work-request.value-proposition":[{"type":0,"value":"Create one place to manage requests"}],"growth.recommendation-jsm.admin-hub-recommendation-value-prop":[{"type":0,"value":"Bring your developers, IT, and operations onto the same platform."}],"growth.recommendation-jsm.cta.label":[{"type":0,"value":"Try Jira Service Management"}],"growth.recommendation-jsm.jira-your-work.description":[{"type":0,"value":"Connect support teams with development teams to get the full picture, from request to resolution."}],"growth.recommendation-jsm.jira-your-work.header":[{"type":0,"value":"Link your teams, make work visible"}],"growth.recommendation-jsm.jira-your-work.header-image-alt-text":[{"type":0,"value":"Requests from Slack, Teams and email turning into a Jira Service Management request automatically"}],"growth.recommendation-jsm.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.product-alt-text":[{"type":0,"value":"Seven requests are all organized in one place, with a status and project connected to each request."}],"growth.recommendation-jsm.product-heading":[{"type":0,"value":"Make your work more visible"}],"growth.recommendation-jsm.product-name.header":[{"type":0,"value":"Automate workflows for faster resolutions"}],"growth.recommendation-jsm.product-subheading":[{"type":0,"value":"Connect Dev and Ops teams on a single platform to collaborate and connect the whole picture, from request to resolution."}],"growth.recommendation-jsm.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.value-proposition":[{"type":0,"value":"Collaborative IT service management"}],"growth.recommendation-jsw-dynamic-description.value-proposition":[{"type":0,"value":"Plan, track, and organize any project"}],"growth.recommendation-jsw-visualize-work.cta.label":[{"type":0,"value":"Try Jira"}],"growth.recommendation-jsw-visualize-work.product-name.header":[{"type":0,"value":"Visualize your projects in lists, boards, and more"}],"growth.recommendation-jsw-visualize-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsw.recommendations.dropdown-menu-trigger.aria-label":[{"type":1,"value":"productName"},{"type":0,"value":" options"}],"growth.recommendation-jsw.value-proposition":[{"type":0,"value":"Project and issue tracking"}],"growth.recommendation-jwm.value-proposition":[{"type":0,"value":"ITSM that unlocks high-velocity teams"}],"growth.recommendation-loom.cta.label":[{"type":0,"value":"Try Loom"}],"growth.recommendation-loom.product-name.header":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-loom.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-loom.value-proposition":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-opsgenie.value-proposition":[{"type":0,"value":"Modern incident management"}],"growth.recommendation-product-store.learn-cta-button-text":[{"type":0,"value":"Learn more"}],"growth.recommendation-product-store.try-cta-button-text":[{"type":0,"value":"Try it now"}],"growth.recommendation-rovo.value-proposition":[{"type":0,"value":"Elevate teamwork with AI"}],"post-office.ad-controls.default-reason.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"post-office.ad-controls.default-reason.team-size":[{"type":0,"value":"the size of your team"}],"post-office.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"post-office.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"post-office.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.dropdown-menu-trigger.aria-label":[{"type":1,"value":"messageInstanceId"},{"type":0,"value":" options menu"}],"post-office.ad-controls.dropdown-menu-trigger.tooltip":[{"type":0,"value":"More actions"}],"post-office.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"post-office.ad-controls.reasons-modal.body":[{"type":0,"value":"We think you\'d find this relevant. This is based on:"}],"post-office.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"post-office.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.close-button.tooltip":[{"type":0,"value":"Close"}],"post-office.confluence-banner-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.confluence-side-nav.next-best-action.craete-space-header":[{"type":0,"value":"Centralize your team\'s projects, and docs."}],"post-office.confluence-side-nav.next-best-action.create-page-cta-message":[{"type":0,"value":"Create page"}],"post-office.confluence-side-nav.next-best-action.create-page-header":[{"type":0,"value":"Plan projects, take notes, and track tasks."}],"post-office.confluence-side-nav.next-best-action.create-space-cta-message":[{"type":0,"value":"Create space"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-cta-message":[{"type":0,"value":"Create whiteboard"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-header":[{"type":0,"value":"Dream up new ideas, and visualize your work."}],"post-office.growth.recommendation-jpd.confluence-home-banner.description":[{"type":0,"value":"Make sure your team is building the right things with Jira Product Discovery."}],"post-office.growth.recommendation-jpd.confluence-home-banner.header":[{"type":0,"value":"Capture your ideas and customer feedback all in one place"}],"post-office.growth.recommendation-jpd.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Discovery Product Logo"}],"post-office.growth.recommendation-jsm.confluence-home-banner.description":[{"type":0,"value":"Automatically turn Slack, Teams, and email requests into tickets."}],"post-office.growth.recommendation-jsm.confluence-home-banner.header":[{"type":0,"value":"See the whole picture, from request to resolution"}],"post-office.growth.recommendation-jsm.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Service Management Product Logo"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.description":[{"type":0,"value":"See analytics and insights about what your team is working on at any moment"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.header":[{"type":0,"value":"Sync real-time data from Jira to any document in Confluence"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.description":[{"type":0,"value":"76% customers shipped projects faster after adding Confluence and Jira."}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.header":[{"type":0,"value":"Build world-class products, fast"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.description":[{"type":0,"value":"Jira lets you view your project and tasks in a way that works for you and your team."}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.header":[{"type":0,"value":"Visualize any project in a list, board, backlog, and more"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.jira-side-nav-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.jira-your-work-first-party-recommendation.learn-more":[{"type":0,"value":"Learn more"}],"post-office.jira-your-work-first-party-recommendation.learn-more.alt-text":[{"type":0,"value":"Discover more about "},{"type":1,"value":"product"}],"post-office.jira-your-work-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.jira-your-work-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"recommendation-controls.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"recommendation-controls.team-size":[{"type":0,"value":"the size of your team"}],"recommendations.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"recommendations.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"recommendations.ad-controls.reasons-modal.accept-button.label":[{"type":0,"value":"Ok"}],"recommendations.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"recommendations.ad-controls.reasons-modal.body":[{"type":0,"value":"We think that "},{"type":1,"value":"productName"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"recommendations.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"recommendations.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"switcher.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"switcher.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"test":[{"type":0,"value":"default message"}]}');

});

parcelRegister("gD3HZ", function(module, exports) {

let $c1b32a4a377309b5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c1b32a4a377309b5$var$load("iOlnk").then(()=>parcelRequire('bQlUN'));

});

parcelRegister("c5uwD", function(module, exports) {

let $8ccda157f31ef721$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8ccda157f31ef721$var$load("kjB4S").then(()=>parcelRequire('1UEkc'));

});

parcelRegister("eOnG5", function(module, exports) {

let $ac881a19965142ab$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ac881a19965142ab$var$load("88iU8").then(()=>parcelRequire('ls6D6'));

});

parcelRegister("2dEkS", function(module, exports) {

let $19dc157a563efc24$var$load = (parcelRequire("28QjX"))(4);
module.exports = $19dc157a563efc24$var$load("jTZeb").then(()=>parcelRequire('8QCI8'));

});

parcelRegister("2639H", function(module, exports) {

let $186e96e3d0f26f30$var$load = (parcelRequire("28QjX"))(4);
module.exports = $186e96e3d0f26f30$var$load("4a4SV").then(()=>parcelRequire('docQr'));

});

parcelRegister("lG42T", function(module, exports) {

let $fc80a89d47d25c53$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc80a89d47d25c53$var$load("8iKip").then(()=>parcelRequire('aESw6'));

});

parcelRegister("f946f", function(module, exports) {

let $b06ae064fb65af65$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b06ae064fb65af65$var$load("hGhmW").then(()=>parcelRequire('fHsGT'));

});

parcelRegister("2NuJP", function(module, exports) {

let $209800595bc038bf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $209800595bc038bf$var$load("lHgWo").then(()=>parcelRequire('527kD'));

});

parcelRegister("9udOh", function(module, exports) {

let $6e81a0c159cc7645$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6e81a0c159cc7645$var$load("e9K7A").then(()=>parcelRequire('itO8c'));

});

parcelRegister("drIvG", function(module, exports) {

let $9ca052ba688e7363$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9ca052ba688e7363$var$load("bEkDv").then(()=>parcelRequire('43dyL'));

});

parcelRegister("5ocfS", function(module, exports) {

let $3ec8b33aaf6526db$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3ec8b33aaf6526db$var$load("b4T4f").then(()=>parcelRequire('5soOF'));

});

parcelRegister("2X4dh", function(module, exports) {

let $22645c1deea271fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $22645c1deea271fd$var$load("8zIAF").then(()=>parcelRequire('99QN5'));

});

parcelRegister("elkju", function(module, exports) {

let $a712c8a7233a32b6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a712c8a7233a32b6$var$load("bXCfz").then(()=>parcelRequire('3XnEp'));

});

parcelRegister("bZzmg", function(module, exports) {

let $8bb0d1925f7f5f9a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8bb0d1925f7f5f9a$var$load("dBuyA").then(()=>parcelRequire('lGfIU'));

});

parcelRegister("k6ozU", function(module, exports) {

let $ea276ee0e849fa41$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ea276ee0e849fa41$var$load("ivCKU").then(()=>parcelRequire('5vRyJ'));

});

parcelRegister("horFd", function(module, exports) {

let $ca9a23042cf9997b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ca9a23042cf9997b$var$load("aW45P").then(()=>parcelRequire('7ZpXJ'));

});

parcelRegister("ic586", function(module, exports) {

let $d3ed53a3bfa1951a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d3ed53a3bfa1951a$var$load("3e3dr").then(()=>parcelRequire('4LBXw'));

});

parcelRegister("gVolN", function(module, exports) {

let $c524dbbdcc4effcf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c524dbbdcc4effcf$var$load("gNdh9").then(()=>parcelRequire('iiqFK'));

});

parcelRegister("6F3S7", function(module, exports) {

let $4d9993481a07647c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4d9993481a07647c$var$load("3jfTc").then(()=>parcelRequire('1VIL4'));

});

parcelRegister("9784C", function(module, exports) {

let $6a2b07b9782325e6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6a2b07b9782325e6$var$load("9Fqso").then(()=>parcelRequire('8gBDp'));

});

parcelRegister("6Unlx", function(module, exports) {

let $507a1529dee35089$var$load = (parcelRequire("28QjX"))(4);
module.exports = $507a1529dee35089$var$load("8yLyY").then(()=>parcelRequire('elxbR'));

});

parcelRegister("7KXwg", function(module, exports) {

let $5a5aff9e03c39611$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5a5aff9e03c39611$var$load("3A6dW").then(()=>parcelRequire('38qbF'));

});

parcelRegister("kYvdD", function(module, exports) {

let $f451a0a9105784c5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f451a0a9105784c5$var$load("gPHZK").then(()=>parcelRequire('leI6s'));

});

parcelRegister("dTOv7", function(module, exports) {

let $a1e795ddbc91a3e2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a1e795ddbc91a3e2$var$load("bPFgQ").then(()=>parcelRequire('jH5ke'));

});

parcelRegister("aHWYt", function(module, exports) {

let $7cbbaa9f2aedbb80$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7cbbaa9f2aedbb80$var$load("iuxQP").then(()=>parcelRequire('jrMkA'));

});

parcelRegister("lwjDR", function(module, exports) {

let $faabd29609d9d77b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $faabd29609d9d77b$var$load("eAuKg").then(()=>parcelRequire('hcrf5'));

});

parcelRegister("fY4tq", function(module, exports) {

let $b9ffedf68e46f95d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b9ffedf68e46f95d$var$load("jVK6j").then(()=>parcelRequire('hduFx'));

});

parcelRegister("EUPUH", function(module, exports) {

let $07afd30cb1b0f757$var$load = (parcelRequire("28QjX"))(4);
module.exports = $07afd30cb1b0f757$var$load("fcDu7").then(()=>parcelRequire('4XouL'));

});

parcelRegister("fqAld", function(module, exports) {

let $b3b5795082e56521$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b3b5795082e56521$var$load("9Xxsh").then(()=>parcelRequire('ajlMz'));

});

parcelRegister("56ePW", function(module, exports) {

let $3b69059443888267$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3b69059443888267$var$load("aWIjN").then(()=>parcelRequire('2QqTx'));

});


parcelRegister("fcJ0k", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $d1e806c3df33d3d0$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $lgJJ2 = parcelRequire("lgJJ2");

var $2AtjH = parcelRequire("2AtjH");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d1e806c3df33d3d0$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $d1e806c3df33d3d0$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $2AtjH.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("6xHpa")));
        case 'da':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("cXDYZ")));
        case 'de':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("3xkhA")));
        case 'en-GB':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("cN028")));
        case 'en-US':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("30SWm")));
        case 'en-XA':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("gMyQm")));
        case 'en-XB':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("avV03")));
        case 'en-ZZ':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("6FI1Q")));
        case 'en':
            return $d1e806c3df33d3d0$var$importHelper(await Promise.resolve((parcelRequire("lgJJ2"))));
        case 'es':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("ao2ht")));
        case 'et':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("7TiAx")));
        case 'fi':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("bcjL1")));
        case 'fr':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("4e1Zp")));
        case 'hu':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("2GbA6")));
        case 'it':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("fzaKP")));
        case 'ja':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("i2cNl")));
        case 'ko':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("equb4")));
        case 'nb':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("4P9iF")));
        case 'nl':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("eqSb9")));
        case 'pl':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("4zdg2")));
        case 'pt-BR':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("kCuak")));
        case 'ro':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("70ZUN")));
        case 'ru':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("a1uo2")));
        case 'sv':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("h8sB7")));
        case 'th':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("2GeBl")));
        case 'tr':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("kFnwz")));
        case 'uk':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("kocI2")));
        case 'vi':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("byjpk")));
        case 'zh-CN':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("kIUIE")));
        case 'zh-TW':
            return $d1e806c3df33d3d0$var$importHelper(await (parcelRequire("cBwKH")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($lgJJ2));
    }
};

});
parcelRegister("lgJJ2", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("6xHpa", function(module, exports) {

let $4c377e7117f6ec51$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4c377e7117f6ec51$var$load("1VtfS").then(()=>parcelRequire('ghNj7'));

});

parcelRegister("cXDYZ", function(module, exports) {

let $96fa0274574b10f2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $96fa0274574b10f2$var$load("bXdro").then(()=>parcelRequire('4zIgG'));

});

parcelRegister("3xkhA", function(module, exports) {

let $29342fe2dfe5a052$var$load = (parcelRequire("28QjX"))(4);
module.exports = $29342fe2dfe5a052$var$load("35LYU").then(()=>parcelRequire('lm6LN'));

});

parcelRegister("cN028", function(module, exports) {

let $94fa164c76108ca2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $94fa164c76108ca2$var$load("ebxtv").then(()=>parcelRequire('2WU7D'));

});

parcelRegister("30SWm", function(module, exports) {

let $231bfd321f8466b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $231bfd321f8466b2$var$load("94waC").then(()=>parcelRequire('ju82O'));

});

parcelRegister("gMyQm", function(module, exports) {

let $c37c283fb270751d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c37c283fb270751d$var$load("dyYGo").then(()=>parcelRequire('9mahg'));

});

parcelRegister("avV03", function(module, exports) {

let $7a79039fd89cbbcc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7a79039fd89cbbcc$var$load("9iCRc").then(()=>parcelRequire('9egsI'));

});

parcelRegister("6FI1Q", function(module, exports) {

let $4db8b9948fe420f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4db8b9948fe420f5$var$load("cWASZ").then(()=>parcelRequire('2CO28'));

});

parcelRegister("ao2ht", function(module, exports) {

let $78fdea2eeefecbaf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $78fdea2eeefecbaf$var$load("aDBRp").then(()=>parcelRequire('bzHDB'));

});

parcelRegister("7TiAx", function(module, exports) {

let $5bec16b30e7cc2e9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5bec16b30e7cc2e9$var$load("cp7kj").then(()=>parcelRequire('am9OH'));

});

parcelRegister("bcjL1", function(module, exports) {

let $82702420d6e02d64$var$load = (parcelRequire("28QjX"))(4);
module.exports = $82702420d6e02d64$var$load("hngmk").then(()=>parcelRequire('hTrC3'));

});

parcelRegister("4e1Zp", function(module, exports) {

let $313a0347c8028bc7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $313a0347c8028bc7$var$load("dWAyV").then(()=>parcelRequire('ge2sO'));

});

parcelRegister("2GbA6", function(module, exports) {

let $1f387cd625fa6758$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1f387cd625fa6758$var$load("lKPDj").then(()=>parcelRequire('1CUwH'));

});

parcelRegister("fzaKP", function(module, exports) {

let $b5527775bb42d585$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b5527775bb42d585$var$load("baSOi").then(()=>parcelRequire('2gR6K'));

});

parcelRegister("i2cNl", function(module, exports) {

let $d21256b3b1033da6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d21256b3b1033da6$var$load("bmhAT").then(()=>parcelRequire('bZ81h'));

});

parcelRegister("equb4", function(module, exports) {

let $a80ae7046f460cf6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a80ae7046f460cf6$var$load("6uy7R").then(()=>parcelRequire('lpOGC'));

});

parcelRegister("4P9iF", function(module, exports) {

let $383323a471fb5861$var$load = (parcelRequire("28QjX"))(4);
module.exports = $383323a471fb5861$var$load("gaTHv").then(()=>parcelRequire('gWm25'));

});

parcelRegister("eqSb9", function(module, exports) {

let $a81d85338512016c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a81d85338512016c$var$load("3ggtd").then(()=>parcelRequire('7QhPQ'));

});

parcelRegister("4zdg2", function(module, exports) {

let $3534b700453ec5c8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3534b700453ec5c8$var$load("f6BA6").then(()=>parcelRequire('heGHy'));

});

parcelRegister("kCuak", function(module, exports) {

let $f02ec1803d648785$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f02ec1803d648785$var$load("xeuuJ").then(()=>parcelRequire('aJxSm'));

});

parcelRegister("70ZUN", function(module, exports) {

let $51b88f8d04d62cd4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $51b88f8d04d62cd4$var$load("9VJcE").then(()=>parcelRequire('7hxYU'));

});

parcelRegister("a1uo2", function(module, exports) {

let $74c191874b1eb82b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $74c191874b1eb82b$var$load("4EiTq").then(()=>parcelRequire('abZyd'));

});

parcelRegister("h8sB7", function(module, exports) {

let $c7995df3473122e3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c7995df3473122e3$var$load("iLcYa").then(()=>parcelRequire('gFKpr'));

});

parcelRegister("2GeBl", function(module, exports) {

let $1f3ad48a61b735a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1f3ad48a61b735a1$var$load("8e146").then(()=>parcelRequire('aaute'));

});

parcelRegister("kFnwz", function(module, exports) {

let $f0b9e268bd026760$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f0b9e268bd026760$var$load("ffDKI").then(()=>parcelRequire('eZ0lf'));

});

parcelRegister("kocI2", function(module, exports) {

let $ed7fe856fa9c2878$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ed7fe856fa9c2878$var$load("eFTsD").then(()=>parcelRequire('Aa5aQ'));

});

parcelRegister("byjpk", function(module, exports) {

let $8691eca22648fbda$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8691eca22648fbda$var$load("depnK").then(()=>parcelRequire('dvDJz'));

});

parcelRegister("kIUIE", function(module, exports) {

let $f163e9ee97280d20$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f163e9ee97280d20$var$load("a3INn").then(()=>parcelRequire('01aMQ'));

});

parcelRegister("cBwKH", function(module, exports) {

let $92d258a3cc61b21c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $92d258a3cc61b21c$var$load("3bG8M").then(()=>parcelRequire('dPYKb'));

});


parcelRegister("2dP7d", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $c03e6859b50c9bbe$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $1H5X6 = parcelRequire("1H5X6");

var $2AtjH = parcelRequire("2AtjH");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c03e6859b50c9bbe$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $c03e6859b50c9bbe$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $2AtjH.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("bH95u")));
        case 'da':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("huECG")));
        case 'de':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("byJMr")));
        case 'en-GB':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("9jYrJ")));
        case 'en-US':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("hTCUr")));
        case 'en-XA':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("8bHov")));
        case 'en-XB':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("6Xz45")));
        case 'en-ZZ':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("bmX60")));
        case 'en':
            return $c03e6859b50c9bbe$var$importHelper(await Promise.resolve((parcelRequire("1H5X6"))));
        case 'es':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("eKbAc")));
        case 'et':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("ijWyB")));
        case 'fi':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("kT6QV")));
        case 'fr':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("8xDuk")));
        case 'hu':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("ifQUW")));
        case 'it':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("egTYT")));
        case 'ja':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("ipamc")));
        case 'ko':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("6l8HE")));
        case 'nb':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("i3wlC")));
        case 'nl':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("46k7f")));
        case 'pl':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("5Vlee")));
        case 'pt-BR':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("5lHAg")));
        case 'ro':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("3ci8e")));
        case 'ru':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("788u4")));
        case 'sv':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("1UgmJ")));
        case 'th':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("6Kbu4")));
        case 'tr':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("eD1Wg")));
        case 'uk':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("eLd3G")));
        case 'vi':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("fpsEp")));
        case 'zh-CN':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("4MAeE")));
        case 'zh-TW':
            return $c03e6859b50c9bbe$var$importHelper(await (parcelRequire("kg7Yj")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($1H5X6));
    }
};

});
parcelRegister("1H5X6", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("bH95u", function(module, exports) {

let $883ac27a9fa6ae7f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $883ac27a9fa6ae7f$var$load("ctDpr").then(()=>parcelRequire('6Q9Tm'));

});

parcelRegister("huECG", function(module, exports) {

let $cbc4bfe38863db5d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cbc4bfe38863db5d$var$load("cMSkI").then(()=>parcelRequire('l1L3U'));

});

parcelRegister("byJMr", function(module, exports) {

let $86a661b6e6f71bce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $86a661b6e6f71bce$var$load("4LyZq").then(()=>parcelRequire('cq29m'));

});

parcelRegister("9jYrJ", function(module, exports) {

let $6c94c6cc68aa64d6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6c94c6cc68aa64d6$var$load("asR20").then(()=>parcelRequire('3Q7BL'));

});

parcelRegister("hTCUr", function(module, exports) {

let $d075c1515184ddec$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d075c1515184ddec$var$load("frwee").then(()=>parcelRequire('bEyV4'));

});

parcelRegister("8bHov", function(module, exports) {

let $5f610301cb6a772e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5f610301cb6a772e$var$load("4NYzh").then(()=>parcelRequire('2T8KF'));

});

parcelRegister("6Xz45", function(module, exports) {

let $511373eebd1492b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $511373eebd1492b4$var$load("33bpP").then(()=>parcelRequire('7nn2C'));

});

parcelRegister("bmX60", function(module, exports) {

let $846f97028807cb1e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $846f97028807cb1e$var$load("3vYo3").then(()=>parcelRequire('gedwp'));

});

parcelRegister("eKbAc", function(module, exports) {

let $abbe58b32a7bd300$var$load = (parcelRequire("28QjX"))(4);
module.exports = $abbe58b32a7bd300$var$load("fUrBL").then(()=>parcelRequire('dvvJ8'));

});

parcelRegister("ijWyB", function(module, exports) {

let $d5676c8adbd0bade$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d5676c8adbd0bade$var$load("6dT7c").then(()=>parcelRequire('jIPOV'));

});

parcelRegister("kT6QV", function(module, exports) {

let $f34e427bf1e04cfe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f34e427bf1e04cfe$var$load("6IDv4").then(()=>parcelRequire('64Fy9'));

});

parcelRegister("8xDuk", function(module, exports) {

let $638009528bd4fe62$var$load = (parcelRequire("28QjX"))(4);
module.exports = $638009528bd4fe62$var$load("386zu").then(()=>parcelRequire('2Eqp0'));

});

parcelRegister("ifQUW", function(module, exports) {

let $d4a2acff8a3f211c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d4a2acff8a3f211c$var$load("5lsf6").then(()=>parcelRequire('bF0Un'));

});

parcelRegister("egTYT", function(module, exports) {

let $a63dfbfe878fd7df$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a63dfbfe878fd7df$var$load("47QFu").then(()=>parcelRequire('fDAYy'));

});

parcelRegister("ipamc", function(module, exports) {

let $d662987cf9f4da71$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d662987cf9f4da71$var$load("9XTp5").then(()=>parcelRequire('dEGTY'));

});

parcelRegister("6l8HE", function(module, exports) {

let $49db747837c072bf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $49db747837c072bf$var$load("8VfHj").then(()=>parcelRequire('23CSD'));

});

parcelRegister("i3wlC", function(module, exports) {

let $d25199609bd4aa95$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d25199609bd4aa95$var$load("aSDdB").then(()=>parcelRequire('kn1Mg'));

});

parcelRegister("46k7f", function(module, exports) {

let $2fc75393d18c657e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2fc75393d18c657e$var$load("bl7zF").then(()=>parcelRequire('aaQJa'));

});

parcelRegister("5Vlee", function(module, exports) {

let $4502be30a0b7177c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4502be30a0b7177c$var$load("6cb4X").then(()=>parcelRequire('jKRJg'));

});

parcelRegister("5lHAg", function(module, exports) {

let $3e50b8c25b5adae4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3e50b8c25b5adae4$var$load("cNE5I").then(()=>parcelRequire('5DnPR'));

});

parcelRegister("3ci8e", function(module, exports) {

let $25408eae105816ff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $25408eae105816ff$var$load("6Oc3K").then(()=>parcelRequire('lbhiX'));

});

parcelRegister("788u4", function(module, exports) {

let $530fdc87483f0a8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $530fdc87483f0a8b$var$load("7aLqb").then(()=>parcelRequire('iNW9E'));

});

parcelRegister("1UgmJ", function(module, exports) {

let $1637b74e721de72d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1637b74e721de72d$var$load("cwlcF").then(()=>parcelRequire('8fhda'));

});

parcelRegister("6Kbu4", function(module, exports) {

let $4e8ff26ddcf90ad3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4e8ff26ddcf90ad3$var$load("hJVvU").then(()=>parcelRequire('kbjGk'));

});

parcelRegister("eD1Wg", function(module, exports) {

let $aa66363794e5377a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aa66363794e5377a$var$load("55Men").then(()=>parcelRequire('l96Bx'));

});

parcelRegister("eLd3G", function(module, exports) {

let $abef959d2c1ef5ad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $abef959d2c1ef5ad$var$load("3DBOl").then(()=>parcelRequire('iDHCU'));

});

parcelRegister("fpsEp", function(module, exports) {

let $b37f6a44871f2d3e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b37f6a44871f2d3e$var$load("ijIZV").then(()=>parcelRequire('2QNHt'));

});

parcelRegister("4MAeE", function(module, exports) {

let $37b7c0b84b5ab0b8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $37b7c0b84b5ab0b8$var$load("gc3a2").then(()=>parcelRequire('af3P6'));

});

parcelRegister("kg7Yj", function(module, exports) {

let $ebfb7c4b0b7970a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ebfb7c4b0b7970a1$var$load("4Vdro").then(()=>parcelRequire('eiBQC'));

});


parcelRegister("eUS5g", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $8c5d2f0798cc4c14$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $aYJir = parcelRequire("aYJir");

var $2AtjH = parcelRequire("2AtjH");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8c5d2f0798cc4c14$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $8c5d2f0798cc4c14$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $2AtjH.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("4fxjQ")));
        case 'da':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("cYoTn")));
        case 'de':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("aidun")));
        case 'en-GB':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("gyhNF")));
        case 'en-US':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("4UDfJ")));
        case 'en-XA':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("bglgR")));
        case 'en-XB':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("6rW3d")));
        case 'en-ZZ':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("5rM0l")));
        case 'en':
            return $8c5d2f0798cc4c14$var$importHelper(await Promise.resolve((parcelRequire("aYJir"))));
        case 'es':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("dthpV")));
        case 'et':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("8K21T")));
        case 'fi':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("dae8O")));
        case 'fr':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("54v4h")));
        case 'hu':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("jThuj")));
        case 'it':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("dcri6")));
        case 'ja':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("dXvCU")));
        case 'ko':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("bxPxu")));
        case 'nb':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("6K7JY")));
        case 'nl':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("3dhIu")));
        case 'pl':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("1TpLq")));
        case 'pt-BR':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("bgXCs")));
        case 'ro':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("cei6C")));
        case 'ru':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("lDy9z")));
        case 'sv':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("1hR55")));
        case 'th':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("aTgD7")));
        case 'tr':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("9o9jU")));
        case 'uk':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("atuf1")));
        case 'vi':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("gFTAA")));
        case 'zh-CN':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("p2rjz")));
        case 'zh-TW':
            return $8c5d2f0798cc4c14$var$importHelper(await (parcelRequire("5EB5G")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($aYJir));
    }
};

});
parcelRegister("aYJir", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("4fxjQ", function(module, exports) {

let $318268a18bc4c1c6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $318268a18bc4c1c6$var$load("8atXE").then(()=>parcelRequire('ldxRd'));

});

parcelRegister("cYoTn", function(module, exports) {

let $971e65b1884a49b9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $971e65b1884a49b9$var$load("jifTW").then(()=>parcelRequire('guzJ5'));

});

parcelRegister("aidun", function(module, exports) {

let $77e60c6cb87ad5df$var$load = (parcelRequire("28QjX"))(4);
module.exports = $77e60c6cb87ad5df$var$load("ggbeo").then(()=>parcelRequire('6XJCa'));

});

parcelRegister("gyhNF", function(module, exports) {

let $c0cda111358241ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c0cda111358241ca$var$load("1Mz5o").then(()=>parcelRequire('c7sZn'));

});

parcelRegister("4UDfJ", function(module, exports) {

let $393ad7235ca000eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $393ad7235ca000eb$var$load("417lP").then(()=>parcelRequire('iieRa'));

});

parcelRegister("bglgR", function(module, exports) {

let $8331b0522ef33fcb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8331b0522ef33fcb$var$load("1zZsr").then(()=>parcelRequire('7PaJY'));

});

parcelRegister("6rW3d", function(module, exports) {

let $4b224b694dec2c59$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4b224b694dec2c59$var$load("hxrDi").then(()=>parcelRequire('jnAvl'));

});

parcelRegister("5rM0l", function(module, exports) {

let $3f74b6109ba464e1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3f74b6109ba464e1$var$load("bXDOO").then(()=>parcelRequire('5VUKY'));

});

parcelRegister("dthpV", function(module, exports) {

let $9ceb7e7d374d06fc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9ceb7e7d374d06fc$var$load("7CTvn").then(()=>parcelRequire('dj3rb'));

});

parcelRegister("8K21T", function(module, exports) {

let $65d4319dff0fff25$var$load = (parcelRequire("28QjX"))(4);
module.exports = $65d4319dff0fff25$var$load("iSut4").then(()=>parcelRequire('5zKBB'));

});

parcelRegister("dae8O", function(module, exports) {

let $99572dacd581272d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $99572dacd581272d$var$load("3Lrzu").then(()=>parcelRequire('1pN2h'));

});

parcelRegister("54v4h", function(module, exports) {

let $3b156cec27fc2214$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3b156cec27fc2214$var$load("4PrZv").then(()=>parcelRequire('gJgOB'));

});

parcelRegister("jThuj", function(module, exports) {

let $e7b0b81a8812bff9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e7b0b81a8812bff9$var$load("17b0i").then(()=>parcelRequire('6HAdB'));

});

parcelRegister("dcri6", function(module, exports) {

let $99c190c9e5f23e21$var$load = (parcelRequire("28QjX"))(4);
module.exports = $99c190c9e5f23e21$var$load("groqf").then(()=>parcelRequire('kqbAM'));

});

parcelRegister("dXvCU", function(module, exports) {

let $a299516ace92315d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a299516ace92315d$var$load("hnpuv").then(()=>parcelRequire('6fRvM'));

});

parcelRegister("bxPxu", function(module, exports) {

let $867ac15c66d51b04$var$load = (parcelRequire("28QjX"))(4);
module.exports = $867ac15c66d51b04$var$load("8mbov").then(()=>parcelRequire('3NNHU'));

});

parcelRegister("6K7JY", function(module, exports) {

let $4e8d0b1148f40393$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4e8d0b1148f40393$var$load("f3idK").then(()=>parcelRequire('eU56m'));

});

parcelRegister("3dhIu", function(module, exports) {

let $25705424ecc2b8b7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $25705424ecc2b8b7$var$load("1ohIg").then(()=>parcelRequire('lbewa'));

});

parcelRegister("1TpLq", function(module, exports) {

let $160ee9a9caa7af09$var$load = (parcelRequire("28QjX"))(4);
module.exports = $160ee9a9caa7af09$var$load("3DNIy").then(()=>parcelRequire('44Pob'));

});

parcelRegister("bgXCs", function(module, exports) {

let $834f6f80e653511a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $834f6f80e653511a$var$load("c8QnK").then(()=>parcelRequire('5eEqc'));

});

parcelRegister("cei6C", function(module, exports) {

let $8e74d64424c16bcf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8e74d64424c16bcf$var$load("kiMhf").then(()=>parcelRequire('1IDq8'));

});

parcelRegister("lDy9z", function(module, exports) {

let $fc07bba7ccc40d4d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc07bba7ccc40d4d$var$load("9Vj79").then(()=>parcelRequire('aNJAm'));

});

parcelRegister("1hR55", function(module, exports) {

let $0f008dc409d9ae95$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0f008dc409d9ae95$var$load("6jozN").then(()=>parcelRequire('izhUs'));

});

parcelRegister("aTgD7", function(module, exports) {

let $7edbf0ccde92096d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7edbf0ccde92096d$var$load("3u9UD").then(()=>parcelRequire('kGPp7'));

});

parcelRegister("9o9jU", function(module, exports) {

let $6d5d95b5f275ebee$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6d5d95b5f275ebee$var$load("5JR52").then(()=>parcelRequire('3aABw'));

});

parcelRegister("atuf1", function(module, exports) {

let $7a04121c4e32de02$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7a04121c4e32de02$var$load("b5wfG").then(()=>parcelRequire('Awrcv'));

});

parcelRegister("gFTAA", function(module, exports) {

let $c23b988992f381de$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c23b988992f381de$var$load("d4o6y").then(()=>parcelRequire('dOwnI'));

});

parcelRegister("p2rjz", function(module, exports) {

let $04b43a5c2526ca97$var$load = (parcelRequire("28QjX"))(4);
module.exports = $04b43a5c2526ca97$var$load("1YHMR").then(()=>parcelRequire('jvyKv'));

});

parcelRegister("5EB5G", function(module, exports) {

let $41dd75a15db9fd7b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $41dd75a15db9fd7b$var$load("cdbJ8").then(()=>parcelRequire('hL1wh'));

});


parcelRegister("bV4gU", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $d56c11c435ac4d24$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $3NihO = parcelRequire("3NihO");

var $2AtjH = parcelRequire("2AtjH");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d56c11c435ac4d24$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $d56c11c435ac4d24$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $2AtjH.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("2YqzM")));
        case 'da':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("jExHw")));
        case 'de':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("lxdgL")));
        case 'en-GB':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("5w77j")));
        case 'en-US':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("789ug")));
        case 'en-XA':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("3Y1FA")));
        case 'en-XB':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("l3AvZ")));
        case 'en-ZZ':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("4u1xn")));
        case 'en':
            return $d56c11c435ac4d24$var$importHelper(await Promise.resolve((parcelRequire("3NihO"))));
        case 'es':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("ujSBf")));
        case 'et':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("7m9zI")));
        case 'fi':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("1haba")));
        case 'fr':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("5jrSa")));
        case 'hu':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("k0WNk")));
        case 'it':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("6v7iH")));
        case 'ja':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("3wPug")));
        case 'ko':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("i0F94")));
        case 'nb':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("lgxqf")));
        case 'nl':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("b5H0f")));
        case 'pl':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("fPtbq")));
        case 'pt-BR':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("43lAi")));
        case 'ro':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("7fPNZ")));
        case 'ru':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("8xH63")));
        case 'sv':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("53IQe")));
        case 'th':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("koMoy")));
        case 'tr':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("eSpAJ")));
        case 'uk':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("29N2d")));
        case 'vi':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("kmbsg")));
        case 'zh-CN':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("1ftTa")));
        case 'zh-TW':
            return $d56c11c435ac4d24$var$importHelper(await (parcelRequire("4dPJ9")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($3NihO));
    }
};

});
parcelRegister("3NihO", function(module, exports) {
module.exports = JSON.parse("{\"got-it\":[{\"type\":0,\"value\":\"Got it\"}],\"mercury.email.footer.sent-by\":[{\"type\":0,\"value\":\"This message was sent to you by Atlassian Focus\"}],\"mercury.email.footer.unsubscribe\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"mercury.focus-areas.arrow-icon.alt\":[{\"type\":0,\"value\":\"arrow-icon\"}],\"mercury.focus-areas.arrow-right-icon.alt\":[{\"type\":0,\"value\":\"arrow-right-icon\"}],\"mercury.focus-areas.calendar-icon.alt\":[{\"type\":0,\"value\":\"calendar-icon\"}],\"mercury.focus-areas.date-changed\":[{\"type\":0,\"value\":\"Date Changed\"}],\"mercury.focus-areas.focus-area.alt\":[{\"type\":0,\"value\":\"focus-area-icon\"}],\"mercury.focus-areas.focus-footer.alt\":[{\"type\":0,\"value\":\"Atlassian footer\"}],\"mercury.focus-areas.focus-icon.alt\":[{\"type\":0,\"value\":\"Focus area icon\"}],\"mercury.focus-areas.for\":[{\"type\":0,\"value\":\"for\"}],\"mercury.focus-areas.heading\":[{\"type\":0,\"value\":\"You're following \"},{\"type\":1,\"value\":\"total\"},{\"type\":0,\"value\":\" active focus areas, here's the breakdown.\"}],\"mercury.focus-areas.no-target-date.alt\":[{\"type\":0,\"value\":\"No target date set\"}],\"mercury.focus-areas.status-changed\":[{\"type\":0,\"value\":\"Status changed\"}],\"mercury.focus-areas.view-area\":[{\"type\":0,\"value\":\"View Focus Area\"}],\"mercury.focus.catch.up.link\":[{\"type\":0,\"value\":\"Jump into Atlassian Focus\"}],\"mercury.focus.catch.up.text\":[{\"type\":0,\"value\":\"Want to catch up on previous updates? \"},{\"type\":1,\"value\":\"link\"}],\"mercury.mercury-monthly-digest.message-template.email.subject.no-translate\":[{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\", here are your monthly focus area updates\"}],\"mercury.message-templates.edit-focus-area-heirarchy-spotlight-body\":[{\"type\":0,\"value\":\"Whenever you need to make changes to your hierarchy you can do so from settings.\"}],\"mercury.message-templates.edit-focus-area-heirarchy-spotlight-heading\":[{\"type\":0,\"value\":\"Edit your focus area hierarchy\"}]}");

});

parcelRegister("2YqzM", function(module, exports) {

let $22a5ccd88cc3f123$var$load = (parcelRequire("28QjX"))(4);
module.exports = $22a5ccd88cc3f123$var$load("5BErq").then(()=>parcelRequire('7azBh'));

});

parcelRegister("jExHw", function(module, exports) {

let $e4ebe51110d45a8f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e4ebe51110d45a8f$var$load("j27ZS").then(()=>parcelRequire('hZCLr'));

});

parcelRegister("lxdgL", function(module, exports) {

let $fad6f916c427b75e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fad6f916c427b75e$var$load("2Rgmt").then(()=>parcelRequire('CbJbW'));

});

parcelRegister("5w77j", function(module, exports) {

let $40457629066c98d7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $40457629066c98d7$var$load("c6Wov").then(()=>parcelRequire('k3RNF'));

});

parcelRegister("789ug", function(module, exports) {

let $5310a3b88f366e34$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5310a3b88f366e34$var$load("7W59i").then(()=>parcelRequire('b8UWL'));

});

parcelRegister("3Y1FA", function(module, exports) {

let $2e3845447098900a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2e3845447098900a$var$load("kAWvw").then(()=>parcelRequire('1Cnkz'));

});

parcelRegister("l3AvZ", function(module, exports) {

let $f54633e2b18c9e5f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f54633e2b18c9e5f$var$load("iuCZA").then(()=>parcelRequire('304fa'));

});

parcelRegister("4u1xn", function(module, exports) {

let $343b280ef20b0f42$var$load = (parcelRequire("28QjX"))(4);
module.exports = $343b280ef20b0f42$var$load("kKUHt").then(()=>parcelRequire('9rB8a'));

});

parcelRegister("ujSBf", function(module, exports) {

let $05b23923b375b2c3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $05b23923b375b2c3$var$load("iEBb3").then(()=>parcelRequire('hjajg'));

});

parcelRegister("7m9zI", function(module, exports) {

let $55b203dc816a9054$var$load = (parcelRequire("28QjX"))(4);
module.exports = $55b203dc816a9054$var$load("fbjG6").then(()=>parcelRequire('ePXk1'));

});

parcelRegister("1haba", function(module, exports) {

let $0edf4650cc330085$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0edf4650cc330085$var$load("crMsn").then(()=>parcelRequire('jvn8u'));

});

parcelRegister("5jrSa", function(module, exports) {

let $3de459022d386fdf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3de459022d386fdf$var$load("eqjAL").then(()=>parcelRequire('jFX1p'));

});

parcelRegister("k0WNk", function(module, exports) {

let $e9216a22a8c51385$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e9216a22a8c51385$var$load("9XuVr").then(()=>parcelRequire('lcP30'));

});

parcelRegister("6v7iH", function(module, exports) {

let $4bbb4d0e473bb897$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4bbb4d0e473bb897$var$load("2Q3RU").then(()=>parcelRequire('czWl2'));

});

parcelRegister("3wPug", function(module, exports) {

let $291c4c84a26ca481$var$load = (parcelRequire("28QjX"))(4);
module.exports = $291c4c84a26ca481$var$load("avOmc").then(()=>parcelRequire('aEqGz'));

});

parcelRegister("i0F94", function(module, exports) {

let $d1c824a7ef0ef6da$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d1c824a7ef0ef6da$var$load("ifpQG").then(()=>parcelRequire('b6nGj'));

});

parcelRegister("lgxqf", function(module, exports) {

let $f7b50497156094f2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f7b50497156094f2$var$load("f9SrL").then(()=>parcelRequire('mtjLb'));

});

parcelRegister("b5H0f", function(module, exports) {

let $813184d59dcd6acd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $813184d59dcd6acd$var$load("75E1q").then(()=>parcelRequire('hGttD'));

});

parcelRegister("fPtbq", function(module, exports) {

let $b862419e5c2720f0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b862419e5c2720f0$var$load("6VyRb").then(()=>parcelRequire('12Ita'));

});

parcelRegister("43lAi", function(module, exports) {

let $2f382f719633af79$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2f382f719633af79$var$load("giKXu").then(()=>parcelRequire('9mWvT'));

});

parcelRegister("7fPNZ", function(module, exports) {

let $54821e8b0b49db76$var$load = (parcelRequire("28QjX"))(4);
module.exports = $54821e8b0b49db76$var$load("jSMGJ").then(()=>parcelRequire('372c6'));

});

parcelRegister("8xH63", function(module, exports) {

let $6382d5de56932dcf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6382d5de56932dcf$var$load("8NLHL").then(()=>parcelRequire('4AQDU'));

});

parcelRegister("53IQe", function(module, exports) {

let $3af004243582bae6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3af004243582bae6$var$load("13iRR").then(()=>parcelRequire('fmfKL'));

});

parcelRegister("koMoy", function(module, exports) {

let $ed9b96c8fb324671$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ed9b96c8fb324671$var$load("dtjHC").then(()=>parcelRequire('2jCba'));

});

parcelRegister("eSpAJ", function(module, exports) {

let $ad49f5c731b2bb06$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ad49f5c731b2bb06$var$load("futb7").then(()=>parcelRequire('5Bldy'));

});

parcelRegister("29N2d", function(module, exports) {

let $1922754e66813b0f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1922754e66813b0f$var$load("7f4x9").then(()=>parcelRequire('K5ywD'));

});

parcelRegister("kmbsg", function(module, exports) {

let $ed1ebf718ea0f5bf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ed1ebf718ea0f5bf$var$load("ZGtxl").then(()=>parcelRequire('cN0bp'));

});

parcelRegister("1ftTa", function(module, exports) {

let $0e8e6073ea4cfad6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0e8e6073ea4cfad6$var$load("kxn8x").then(()=>parcelRequire('luhns'));

});

parcelRegister("4dPJ9", function(module, exports) {

let $3130804688c90f8d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3130804688c90f8d$var$load("aLvnz").then(()=>parcelRequire('iVM3R'));

});


parcelRegister("dCTL2", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $0f2fb40303be8d11$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $2eALO = parcelRequire("2eALO");

var $2AtjH = parcelRequire("2AtjH");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0f2fb40303be8d11$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $0f2fb40303be8d11$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $2AtjH.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("28Nob")));
        case 'da':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("l8sIU")));
        case 'de':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("dPOaE")));
        case 'en-GB':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("4I1dF")));
        case 'en-US':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("jcoma")));
        case 'en-XA':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("h5kAL")));
        case 'en-XB':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("kqt3s")));
        case 'en-ZZ':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("33716")));
        case 'en':
            return $0f2fb40303be8d11$var$importHelper(await Promise.resolve((parcelRequire("2eALO"))));
        case 'es':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("j1UX2")));
        case 'et':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("iGm9t")));
        case 'fi':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("1aqle")));
        case 'fr':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("1kfMs")));
        case 'hu':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("40QVU")));
        case 'it':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("6dW83")));
        case 'ja':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("3hlq6")));
        case 'ko':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("chWhK")));
        case 'nb':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("c1Qob")));
        case 'nl':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("lJsiH")));
        case 'pl':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("fuizT")));
        case 'pt-BR':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("7Z0EG")));
        case 'ro':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("ff1an")));
        case 'ru':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("hBnxo")));
        case 'sv':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("7Bytw")));
        case 'th':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("d0UwQ")));
        case 'tr':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("gkP82")));
        case 'uk':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("h10sc")));
        case 'vi':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("c6Vy2")));
        case 'zh-CN':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("6SUx9")));
        case 'zh-TW':
            return $0f2fb40303be8d11$var$importHelper(await (parcelRequire("2FYGy")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($2eALO));
    }
};

});
parcelRegister("2eALO", function(module, exports) {
module.exports = JSON.parse('{"app.accept":[{"type":0,"value":"Accept"}],"app.reject":[{"type":0,"value":"Reject"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"ecosystem-forge-apps.ecosystem-forge-apps-in-app.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"jira.jira-project-pages-gdrive-deprecation.message-template.email.subject":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-1":[{"type":0,"value":"We\'re reaching out to notify you that from April 23rd 2024, syncing Google Drive shared drives will no longer be supported in Project Pages for the users in your site. Users will no longer be able to access their shared drives Jira as we are removing the feature, but they will still be able to sync Confluence spaces to Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-2":[{"type":0,"value":"Please note that we are not deleting any data within Google Drive itself. The change only affects the ability to sync, link, and access Google Shared Drives from Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-3":[{"type":0,"value":"This is part of our ongoing efforts to streamline our services and ensure the highest quality experience for our users."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-4":[{"type":0,"value":"Next steps:"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-5":[{"type":0,"value":"We are committed to providing you with the best possible experience, and appreciate your understanding as we make these necessary improvements. Thank you for your continued support."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-1":[{"type":0,"value":"No immediate action is required from your end regarding this deprecation. However, we understand that this change may impact your workflow, and we are here to support you through this transition."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-3":[{"type":0,"value":"For any feedback, or further questions and assistance with change management, please contact jnguyen2@atlassian.com"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.greeting":[{"type":0,"value":"Dear Admin,"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.title":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-weekly-digest.message-template.email.subject":[{"type":0,"value":"Your weekly digest for Jira project: "},{"type":1,"value":"projectName"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCompletion":[{"type":0,"value":"issues completed in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCreated":[{"type":0,"value":"issues created in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesUpdated":[{"type":0,"value":"issues updated in the past week"}],"jira.jira-weekly-digest.test-message.email.body.plusSign":[{"type":0,"value":"+"}],"jira.jira-weekly-digest.test-message.email.header":[{"type":0,"value":"Here\'s your weekly digest for Jira ("},{"type":1,"value":"projectName"},{"type":0,"value":") over the past week"}],"jira.jira-weekly-digest.test-message.email.headerDescription":[{"type":0,"value":"You\u2019re receiving this email because you have opted in to receive weekly updates for this project in Jira."}],"jira.jira-weekly-digest.test-message.email.playbookBodyText":[{"type":0,"value":"Atlassian Playbook"}],"jira.jira-weekly-digest.test-message.email.playbookHeader":[{"type":0,"value":"Has your team conducted a retrospective recently?"}],"jira.jira-weekly-digest.test-message.email.playbookSubheader":[{"type":0,"value":"A retrospective gives you an opportunity to review your latest project progress and make improvements for the future. Find out more at "},{"type":1,"value":"link"},{"type":0,"value":"."}],"jira.jira-weekly-digest.test-message.email.tableHeader":[{"type":0,"value":"Weekly Summary"}],"jira.suppression-email-notification-email.contact-us":[{"type":0,"value":"contact us"}],"jira.suppression-email-notification-email.email.body":[{"type":0,"value":"This is an automatated message to notify you that the jira "},{"type":1,"value":"emailType"},{"type":0,"value":" email \\n\\t\\t\\t\\t\\t\\tto "},{"type":1,"value":"affectedUserEmail"},{"type":0,"value":" has been suppressed. Please visit this "},{"type":1,"value":"unsuppressApiLink"},{"type":0,"value":" to unsuppress the user\'s email."}],"jira.suppression-email-notification-email.email.body.goodbye":[{"type":0,"value":"Please "},{"type":1,"value":"contactUsLink"},{"type":0,"value":" if the issue persists, we\'re always happy to help."}],"jira.suppression-email-notification-email.email.body.regards":[{"type":0,"value":"Jira Notifications Team"}],"jira.suppression-email-notification-email.email.body.signoff":[{"type":0,"value":"Regards,"}],"jira.suppression-email-notification-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"jira.suppression-email-notification-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira.suppression-email-notification-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"playground.playground-local-execution-message.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"playground.playground-local-execution-message.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"playground.playground-local-execution-message.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hello, fellow child "},{"type":1,"value":"name"},{"type":0,"value":","}],"playground.playground-local-execution-message.test-message.email.body.no-translate":[{"type":0,"value":"We are currently trying to locally execute this message!"}],"playground.playground-local-execution-message.test-message.email.body.regards.no-translate":[{"type":0,"value":"Playground Team"}],"playground.playground-local-execution-message.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"playground.playground-local-execution-message.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office.commerce-common.unsuppress-email-link":[{"type":0,"value":"link"}],"post-office.jira-email.contact-us":[{"type":0,"value":"contact us"}],"post-office.playground.go-faster-techops-rollup-notifier.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.playground.test-playground-message.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}]}');

});

parcelRegister("28Nob", function(module, exports) {

let $18f2a3c6b8c9cfe9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $18f2a3c6b8c9cfe9$var$load("i7Fm9").then(()=>parcelRequire('dDRuh'));

});

parcelRegister("l8sIU", function(module, exports) {

let $f630a031219498f0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f630a031219498f0$var$load("3eJtM").then(()=>parcelRequire('ahxST'));

});

parcelRegister("dPOaE", function(module, exports) {

let $a126f4a186a50e1d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a126f4a186a50e1d$var$load("kR29d").then(()=>parcelRequire('6sWT1'));

});

parcelRegister("4I1dF", function(module, exports) {

let $36dc37aa72fdab05$var$load = (parcelRequire("28QjX"))(4);
module.exports = $36dc37aa72fdab05$var$load("f6D72").then(()=>parcelRequire('caK1o'));

});

parcelRegister("jcoma", function(module, exports) {

let $dfa208026acb683f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dfa208026acb683f$var$load("35Vym").then(()=>parcelRequire('id8PS'));

});

parcelRegister("h5kAL", function(module, exports) {

let $c702e06b1365fbcf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c702e06b1365fbcf$var$load("1yRD0").then(()=>parcelRequire('dFwHd'));

});

parcelRegister("kqt3s", function(module, exports) {

let $edecc608686addc4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $edecc608686addc4$var$load("dfxiP").then(()=>parcelRequire('hzBa5'));

});

parcelRegister("33716", function(module, exports) {

let $2387184ae47150a5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2387184ae47150a5$var$load("7mJtW").then(()=>parcelRequire('2vldl'));

});

parcelRegister("j1UX2", function(module, exports) {

let $ddaa49a3ad51ee40$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ddaa49a3ad51ee40$var$load("eqvKH").then(()=>parcelRequire('1GsSP'));

});

parcelRegister("iGm9t", function(module, exports) {

let $d99d551fb9665493$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d99d551fb9665493$var$load("eO1Kc").then(()=>parcelRequire('9YXCZ'));

});

parcelRegister("1aqle", function(module, exports) {

let $0d9b28754e996110$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0d9b28754e996110$var$load("k150Y").then(()=>parcelRequire('d9G69'));

});

parcelRegister("1kfMs", function(module, exports) {

let $0f73e66b58029b45$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0f73e66b58029b45$var$load("REa2k").then(()=>parcelRequire('gJLsS'));

});

parcelRegister("40QVU", function(module, exports) {

let $2ec038ea609501c1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2ec038ea609501c1$var$load("cUaXv").then(()=>parcelRequire('IQCwV'));

});

parcelRegister("6dW83", function(module, exports) {

let $48810c2f950c1dd7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $48810c2f950c1dd7$var$load("7YoHl").then(()=>parcelRequire('aD5Gf'));

});

parcelRegister("3hlq6", function(module, exports) {

let $263393313f9e03ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = $263393313f9e03ec$var$load("gtKzZ").then(()=>parcelRequire('bnIgA'));

});

parcelRegister("chWhK", function(module, exports) {

let $8f2448d02a3c5b5e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8f2448d02a3c5b5e$var$load("dOM9P").then(()=>parcelRequire('lu78M'));

});

parcelRegister("c1Qob", function(module, exports) {

let $8c1e3766a710090b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8c1e3766a710090b$var$load("1Uxg1").then(()=>parcelRequire('fAWMX'));

});

parcelRegister("lJsiH", function(module, exports) {

let $041538c9b7a20e4c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $041538c9b7a20e4c$var$load("gYFh9").then(()=>parcelRequire('eZwJm'));

});

parcelRegister("fuizT", function(module, exports) {

let $b46811886c44eb51$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b46811886c44eb51$var$load("eYO2a").then(()=>parcelRequire('4NXAh'));

});

parcelRegister("7Z0EG", function(module, exports) {

let $5cfebd05d0799dda$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5cfebd05d0799dda$var$load("6zVgB").then(()=>parcelRequire('djf2I'));

});

parcelRegister("ff1an", function(module, exports) {

let $b189295d2916a806$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b189295d2916a806$var$load("8WdEb").then(()=>parcelRequire('ghIma'));

});

parcelRegister("hBnxo", function(module, exports) {

let $cd082677de4edf69$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cd082677de4edf69$var$load("aSECf").then(()=>parcelRequire('feZzX'));

});

parcelRegister("7Bytw", function(module, exports) {

let $5896bb2d6d4d2d4e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5896bb2d6d4d2d4e$var$load("33utS").then(()=>parcelRequire('11Rcp'));

});

parcelRegister("d0UwQ", function(module, exports) {

let $97971fe29daaccea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $97971fe29daaccea$var$load("5ktVa").then(()=>parcelRequire('kZtV9'));

});

parcelRegister("gkP82", function(module, exports) {

let $be462cac9b17d6c5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $be462cac9b17d6c5$var$load("6zOKb").then(()=>parcelRequire('31cpo'));

});

parcelRegister("h10sc", function(module, exports) {

let $c632e1c7547c4294$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c632e1c7547c4294$var$load("3x2J6").then(()=>parcelRequire('fxLXC'));

});

parcelRegister("c6Vy2", function(module, exports) {

let $8d12af649fd28579$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8d12af649fd28579$var$load("ig02a").then(()=>parcelRequire('7Bh2L'));

});

parcelRegister("6SUx9", function(module, exports) {

let $5033a39e5497c891$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5033a39e5497c891$var$load("8gfFI").then(()=>parcelRequire('fuSM8'));

});

parcelRegister("2FYGy", function(module, exports) {

let $1f2e7bf1e5bc1833$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1f2e7bf1e5bc1833$var$load("wE0iQ").then(()=>parcelRequire('km4YR'));

});


parcelRegister("kZ7Oy", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $1269c265d489534a$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $fHO1s = parcelRequire("fHO1s");

var $2AtjH = parcelRequire("2AtjH");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1269c265d489534a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $1269c265d489534a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $2AtjH.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("fOgrq")));
        case 'da':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("efmlV")));
        case 'de':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("3B3Ji")));
        case 'en-GB':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("4Tr54")));
        case 'en-US':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("Eb7JP")));
        case 'en-XA':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("241wg")));
        case 'en-XB':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("8smiy")));
        case 'en-ZZ':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("6a2Vv")));
        case 'en':
            return $1269c265d489534a$var$importHelper(await Promise.resolve((parcelRequire("fHO1s"))));
        case 'es':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("4uiXw")));
        case 'et':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("3vFdG")));
        case 'fi':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("gaIkE")));
        case 'fr':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("fF5pV")));
        case 'hu':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("37bMy")));
        case 'it':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("98n09")));
        case 'ja':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("hTBB0")));
        case 'ko':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("jjM3Z")));
        case 'nb':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("4LT4y")));
        case 'nl':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("j6kGJ")));
        case 'pl':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("lmzib")));
        case 'pt-BR':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("4NUeB")));
        case 'ro':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("eYD1m")));
        case 'ru':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("5dSbb")));
        case 'sv':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("bJDUm")));
        case 'th':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("3cPmd")));
        case 'tr':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("bNJbb")));
        case 'uk':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("ioxF9")));
        case 'vi':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("foI7c")));
        case 'zh-CN':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("4KGtJ")));
        case 'zh-TW':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("6DrnH")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($fHO1s));
    }
};

});
parcelRegister("fHO1s", function(module, exports) {
module.exports = JSON.parse("{\"admin-hub.ci-test.message-template-template-hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"ci-generation.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"ci-generation.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"ci-generation.email.body.img.alt\":[{\"type\":0,\"value\":\"This is the alt text for the image\"}],\"ci-generation.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"ci-generation.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"ci-generation.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"ci-generation.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.test-message-digest-email-template.test-message.email.body.digest-title\":[{\"type\":0,\"value\":\"You have \"},{\"type\":1,\"value\":\"numberOfMsg\"},{\"type\":0,\"value\":\" new messages!\"}],\"post-office.test-message-digest-email-template.test-message.email.body.message-body\":[{\"type\":1,\"value\":\"defaultMessage\"}],\"post-office.test-message.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\".\"}],\"post-office.test-messages.test-message-load-test-push-flow-email-mobile-push.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push-jira-ugc.redacted.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a redacted test mobile push notification from post office.\"}],\"post-office.test-messages.test-message-mobile-push-jira-ugc.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push.redacted.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a redacted mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-transform-metadata.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.test-slack-notification.sample-hello-message\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"product-store-personal-use-case.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}],\"test-messages.app-switcher-discovery-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-discovery-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.app-switcher-upgrade-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-upgrade-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.in-app-example.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.jira-navigation-topbar-edition-awareness.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.redacted-email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.team-message-email-ugc.message-template.email.redacted.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Redacted Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-digest-email.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-digest-email.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-digest-email.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hey \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-digest-email.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. Here is your daily digest (rick) rollup for the \"},{\"type\":1,\"value\":\"site\"},{\"type\":0,\"value\":\" workspace\"}],\"test-messages.test-message-digest-email.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-digest-email.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-digest-email.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-cdn.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-cdn.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-cdn.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-cdn.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-cdn.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-cdn.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-cdn.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-mfc.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-mfc.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-mfc.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-mfc.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-mfc.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-mfc.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-mfc.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-ugc.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-ugc.message-template-template.email.redacted.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-ugc.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-ugc.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-ugc.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-ugc.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-ugc.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.no-translate\":[{\"type\":0,\"value\":\"This is a redacted test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-ugc.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-grouped-recipients.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hello\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-inapp-engagement.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-inapp-engagement.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-inapp-engagement.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-marketing.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-marketing.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-marketing.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-marketing.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-marketing.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-marketing.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-marketing.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-message-failures.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-message-failures.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-message-failures.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-message-failures.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-message-failures.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-message-failures.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-message-failures.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-persona-email.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-persona-email.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-persona-email.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-persona-email.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-persona-email.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-persona-email.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-raw-recipients.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-raw-recipients.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.greeting.no-translate\":[{\"type\":1,\"value\":\"greeting\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.hello.name.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi,\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-raw-recipients.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-transform-metadata.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-transform-metadata.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-transform-metadata.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.app.img.alt.large\":[{\"type\":0,\"value\":\"test image 2\"}],\"test-messages.test-message.app.img.alt.plant\":[{\"type\":0,\"value\":\"test image 1\"}],\"test-messages.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.redacted-email.body\":[{\"type\":0,\"value\":\"This is the redacted version of the test email message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.redacted-email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.redacted-email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.redacted-email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.redacted-email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"wac-global-nav-product-recommendation.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}]}");

});

parcelRegister("fOgrq", function(module, exports) {

let $b8284774feb44180$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b8284774feb44180$var$load("9SoxW").then(()=>parcelRequire('cIJ7t'));

});

parcelRegister("efmlV", function(module, exports) {

let $a5f3ce2fe8500f6b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a5f3ce2fe8500f6b$var$load("bRKmQ").then(()=>parcelRequire('4BlC0'));

});

parcelRegister("3B3Ji", function(module, exports) {

let $29e7b865494dae74$var$load = (parcelRequire("28QjX"))(4);
module.exports = $29e7b865494dae74$var$load("fBfPs").then(()=>parcelRequire('cWcaf'));

});

parcelRegister("4Tr54", function(module, exports) {

let $39014e2596c10076$var$load = (parcelRequire("28QjX"))(4);
module.exports = $39014e2596c10076$var$load("6qYbg").then(()=>parcelRequire('4LSMP'));

});

parcelRegister("Eb7JP", function(module, exports) {

let $078c5d7fa33382b7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $078c5d7fa33382b7$var$load("8xY1p").then(()=>parcelRequire('5c4St'));

});

parcelRegister("241wg", function(module, exports) {

let $180d2238743e2fa0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $180d2238743e2fa0$var$load("ihleU").then(()=>parcelRequire('FNCsh'));

});

parcelRegister("8smiy", function(module, exports) {

let $62823c3758afa475$var$load = (parcelRequire("28QjX"))(4);
module.exports = $62823c3758afa475$var$load("hPPLz").then(()=>parcelRequire('dM2yG'));

});

parcelRegister("6a2Vv", function(module, exports) {

let $47c5f26b3f2cbac1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $47c5f26b3f2cbac1$var$load("9Dy0D").then(()=>parcelRequire('lvKzQ'));

});

parcelRegister("4uiXw", function(module, exports) {

let $3448aba5dc42c6ce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3448aba5dc42c6ce$var$load("iTASK").then(()=>parcelRequire('hcDbV'));

});

parcelRegister("3vFdG", function(module, exports) {

let $28e43db2cb85b8d9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $28e43db2cb85b8d9$var$load("cZJF7").then(()=>parcelRequire('7FNmp'));

});

parcelRegister("gaIkE", function(module, exports) {

let $bc5ff7ef3c17d95f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bc5ff7ef3c17d95f$var$load("hlo4z").then(()=>parcelRequire('h7nPi'));

});

parcelRegister("fF5pV", function(module, exports) {

let $b66ee31aee6fa739$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b66ee31aee6fa739$var$load("bFahX").then(()=>parcelRequire('fjVt7'));

});

parcelRegister("37bMy", function(module, exports) {

let $244b2a363fdf4710$var$load = (parcelRequire("28QjX"))(4);
module.exports = $244b2a363fdf4710$var$load("af6La").then(()=>parcelRequire('jos5m'));

});

parcelRegister("98n09", function(module, exports) {

let $6a66b400b8bab102$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6a66b400b8bab102$var$load("43bKP").then(()=>parcelRequire('5WuLD'));

});

parcelRegister("hTBB0", function(module, exports) {

let $d074bc7dedf1a94e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d074bc7dedf1a94e$var$load("4UXsQ").then(()=>parcelRequire('g8lYr'));

});

parcelRegister("jjM3Z", function(module, exports) {

let $e105131156beac37$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e105131156beac37$var$load("7eqQ5").then(()=>parcelRequire('jDutY'));

});

parcelRegister("4LT4y", function(module, exports) {

let $3796456e31430419$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3796456e31430419$var$load("ap9Z2").then(()=>parcelRequire('1JL7m'));

});

parcelRegister("j6kGJ", function(module, exports) {

let $de7ea017d5a0877e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $de7ea017d5a0877e$var$load("lcXsH").then(()=>parcelRequire('50ncH'));

});

parcelRegister("lmzib", function(module, exports) {

let $f8d707567b2b6a7f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f8d707567b2b6a7f$var$load("8Dtcb").then(()=>parcelRequire('icSuz'));

});

parcelRegister("4NUeB", function(module, exports) {

let $37f75c0eb7f92c84$var$load = (parcelRequire("28QjX"))(4);
module.exports = $37f75c0eb7f92c84$var$load("dtMzo").then(()=>parcelRequire('5ggMx'));

});

parcelRegister("eYD1m", function(module, exports) {

let $ae74f008c9c9d2f3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ae74f008c9c9d2f3$var$load("drzY7").then(()=>parcelRequire('fIeJ4'));

});

parcelRegister("5dSbb", function(module, exports) {

let $3cd83191a8f20b53$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3cd83191a8f20b53$var$load("VPbvD").then(()=>parcelRequire('ifhWq'));

});

parcelRegister("bJDUm", function(module, exports) {

let $88b2da952badd698$var$load = (parcelRequire("28QjX"))(4);
module.exports = $88b2da952badd698$var$load("4Dgpf").then(()=>parcelRequire('dhiF2'));

});

parcelRegister("3cPmd", function(module, exports) {

let $255a5499e3bbcfea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $255a5499e3bbcfea$var$load("5knkb").then(()=>parcelRequire('aEI8u'));

});

parcelRegister("bNJbb", function(module, exports) {

let $89775100d2f33d32$var$load = (parcelRequire("28QjX"))(4);
module.exports = $89775100d2f33d32$var$load("lLdwH").then(()=>parcelRequire('5prwP'));

});

parcelRegister("ioxF9", function(module, exports) {

let $d644949d6f721ee5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d644949d6f721ee5$var$load("9L3MV").then(()=>parcelRequire('33SMQ'));

});

parcelRegister("foI7c", function(module, exports) {

let $b35b514086aa6861$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b35b514086aa6861$var$load("UnQhJ").then(()=>parcelRequire('gUEw4'));

});

parcelRegister("4KGtJ", function(module, exports) {

let $375c68a2000fb187$var$load = (parcelRequire("28QjX"))(4);
module.exports = $375c68a2000fb187$var$load("exOuq").then(()=>parcelRequire('bC1CY'));

});

parcelRegister("6DrnH", function(module, exports) {

let $4d4b9feeca8594d8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4d4b9feeca8594d8$var$load("cBYCT").then(()=>parcelRequire('e36el'));

});




parcelRegister("7kpP2", function(module, exports) {

$parcel$export(module.exports, "ScreenSpaceFlagPlacementPreviewSwitcher", () => $89dc9ce1dc1e1a77$export$46db7cd62b063064);

var $2OMIu = parcelRequire("2OMIu");

var $7LKoA = parcelRequire("7LKoA");

var $3Qetj = parcelRequire("3Qetj");

var $4P6dh = parcelRequire("4P6dh");

var $fTMY0 = parcelRequire("fTMY0");

var $ZILlH = parcelRequire("ZILlH");
const $89dc9ce1dc1e1a77$export$16e97e6603eadea = ({ PlacementComponent: PlacementComponent, placementId: placementId, eligibleMessages: eligibleMessages, errorFallback: errorFallback = null, onError: onError, returnOverride: returnOverride, disableInitialData: disableInitialData })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $fTMY0.ErrorBoundary), {
        fallback: errorFallback,
        onError: onError,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Qetj.PlacementPreviewProvider), {
            eligibleMessages: eligibleMessages,
            returnOverride: returnOverride,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ZILlH.default), {
                PlacementComponent: PlacementComponent,
                placementId: placementId,
                disableInitialData: disableInitialData
            })
        })
    });
const $89dc9ce1dc1e1a77$export$46db7cd62b063064 = ({ isEnabled: isEnabled, children: children })=>{
    const { searchParams: searchParams } = (0, $7LKoA.usePostOfficeRoute)();
    const previewId = searchParams?.get('contentfulPreviewId');
    const hasPreviewType = Boolean(searchParams?.get('contentfulPreviewId'));
    const eligibleMessage = [
        {
            messageInstanceId: 'messageInstanceId',
            messageTemplateId: 'marketing-screen-space-flag-contentful-usecase',
            messageCategory: 'Engagement',
            context: {
                id: previewId
            },
            createdAt: new Date().toString(),
            eventTime: new Date().toString(),
            triggerId: 'triggerId',
            messageCreationType: 'explicit'
        }
    ];
    if (isEnabled && hasPreviewType) return /*#__PURE__*/ (0, $2OMIu.jsx)($89dc9ce1dc1e1a77$export$16e97e6603eadea, {
        placementId: "screen-space-flags",
        PlacementComponent: (0, $4P6dh.ScreenSpaceFlagsPlacementComponent),
        eligibleMessages: eligibleMessage
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});
parcelRegister("3Qetj", function(module, exports) {

$parcel$export(module.exports, "PlacementPreviewProvider", () => $98b4820fc2fad817$export$52e362b70e115c68);

var $2OMIu = parcelRequire("2OMIu");

var $jm1yu = parcelRequire("jm1yu");

var $5uXOq = parcelRequire("5uXOq");
const $98b4820fc2fad817$export$e5ffd38dcf6e5c53 = `/gateway/api/post-office/api/v1/placements/`;
const $98b4820fc2fad817$export$85c4756977e87c75 = `/gateway/api/post-office/api/v1/placement-preview/`;
const $98b4820fc2fad817$export$52e362b70e115c68 = ({ returnOverride: returnOverride, eligibleMessages: eligibleMessages, children: children })=>{
    const fetch = (0, $5uXOq.useMemo)(()=>{
        if (returnOverride) return $98b4820fc2fad817$export$fb5156757134712c({
            returnOverride: returnOverride
        });
        return $98b4820fc2fad817$export$c05392ff95b4319d({
            eligibleMessages: eligibleMessages
        });
    }, [
        eligibleMessages,
        returnOverride
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jm1yu.PlacementFetchingProvider), {
        fetch: fetch,
        children: children
    });
};
const $98b4820fc2fad817$export$fb5156757134712c = ({ returnOverride: returnOverride })=>async ()=>{
        return new Response(JSON.stringify(returnOverride), {
            status: 200,
            statusText: 'ok'
        });
    };
const $98b4820fc2fad817$export$c05392ff95b4319d = ({ eligibleMessages: eligibleMessages })=>(url, options)=>{
        const finalUrl = url.replace($98b4820fc2fad817$export$e5ffd38dcf6e5c53, $98b4820fc2fad817$export$85c4756977e87c75);
        const payload = {
            originalMethod: options?.method || 'GET',
            originalBody: $98b4820fc2fad817$var$parseBody(options?.body),
            eligibleMessages: eligibleMessages
        };
        return globalThis.fetch(finalUrl, {
            ...options,
            method: 'POST',
            headers: {
                ...options?.headers || {}
            },
            body: $98b4820fc2fad817$var$stringifyPayload(payload)
        });
    };
const $98b4820fc2fad817$var$objectHasKeys = (input)=>!!Object.keys(input).length;
const $98b4820fc2fad817$var$parseBody = (body)=>{
    if (typeof body === 'undefined' || body === null) return undefined;
    try {
        const parsedBody = JSON.parse(body);
        if ($98b4820fc2fad817$var$objectHasKeys(parsedBody)) return parsedBody;
        throw new Error();
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};
const $98b4820fc2fad817$var$stringifyPayload = (payload)=>{
    try {
        return JSON.stringify(payload);
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};

});

parcelRegister("fTMY0", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $b931f9e352156f61$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
'use client';
const $b931f9e352156f61$export$b16d9fb1a22de840 = (0, $5uXOq.createContext)(null);
const $b931f9e352156f61$var$initialState = {
    didCatch: false,
    error: null
};
class $b931f9e352156f61$export$e926676385687eaf extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $b931f9e352156f61$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($b931f9e352156f61$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $b931f9e352156f61$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($b931f9e352156f61$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $5uXOq.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $5uXOq.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $5uXOq.createElement)($b931f9e352156f61$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $b931f9e352156f61$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $b931f9e352156f61$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $b931f9e352156f61$export$c052f6604b7d51fe() {
    const context = (0, $5uXOq.useContext)($b931f9e352156f61$export$b16d9fb1a22de840);
    $b931f9e352156f61$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $5uXOq.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $5uXOq.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $b931f9e352156f61$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $5uXOq.forwardRef)((props, ref)=>(0, $5uXOq.createElement)($b931f9e352156f61$export$e926676385687eaf, errorBoundaryProps, (0, $5uXOq.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});


const $d0ca21152325de6b$export$37d4bb5bc0e315db = 'killswitch_post_office_in_jira';


parcelRegister("eKtC8", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $31b7f947593face8$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $b71gk = parcelRequire("b71gk");
const $31b7f947593face8$export$e926676385687eaf = ({ children: children, id: id, withExperienceTracker: withExperienceTracker })=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: id
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: "jiraEntry",
        fallback: "page",
        withExperienceTracker: withExperienceTracker
    }, children);
};

});

parcelRegister("bAjl9", function(module, exports) {

$parcel$export(module.exports, "IntlProviders", () => $fad1cef37914a278$export$c9d8cd4516cc55a8);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $1nUas = parcelRequire("1nUas");
const $fad1cef37914a278$export$c9d8cd4516cc55a8 = ({ children: children, locale: locale, messages: messages })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1nUas.IntlProvider), {
        messages: messages,
        locale: (0, $lzeFL.standardizeLocale)(locale)
    }, children);

});
parcelRegister("1nUas", function(module, exports) {

$parcel$export(module.exports, "IntlProvider", () => $0264700d4de7e638$export$480518999dfc4151);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
const $0264700d4de7e638$export$480518999dfc4151 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i5FdW.default), {
        ...props,
        defaultLocale: props.locale
    }, children);

});


parcelRegister("lvG9V", function(module, exports) {

$parcel$export(module.exports, "MetricsContainers", () => $2bc2dec1250f1cf8$export$2d1617bc0040e5d9);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $1OjhZ = parcelRequire("1OjhZ");

var $8ApFP = parcelRequire("8ApFP");

var $iXVV6 = parcelRequire("iXVV6");

var $kDdFQ = parcelRequire("kDdFQ");
const $2bc2dec1250f1cf8$export$2d1617bc0040e5d9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: (0, $8ApFP.routeAnalyticsAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1OjhZ.ExperienceTrackerProvider), null, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "metrics-containers-subproduct-updater",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kDdFQ.SubProductUpdater), null)), children));

});
parcelRegister("1OjhZ", function(module, exports) {

$parcel$export(module.exports, "ExperienceTrackerProvider", () => $5cef917adb45d092$export$6f49c95a810d59fa);

var $5uXOq = parcelRequire("5uXOq");

var $bFNgM = parcelRequire("bFNgM");
var $47QoQ = parcelRequire("47QoQ");

var $9sAyK = parcelRequire("9sAyK");
const $5cef917adb45d092$var$useUnmount = (callback)=>(0, $5uXOq.useEffect)(()=>callback, [
        callback
    ]);
const $5cef917adb45d092$export$6f49c95a810d59fa = ({ children: children })=>{
    const [experienceTracker] = (0, $5uXOq.useState)(new (0, $bFNgM.ExperienceTracker)());
    const [cleanupSliSub] = (0, $5uXOq.useState)(()=>experienceTracker.subscribe((0, $9sAyK.sliSubscriber)));
    const cleanup = (0, $5uXOq.useCallback)(()=>{
        cleanupSliSub();
    }, [
        cleanupSliSub
    ]);
    $5cef917adb45d092$var$useUnmount(cleanup);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47QoQ.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, children);
};

});
parcelRegister("bFNgM", function(module, exports) {

$parcel$export(module.exports, "ExperienceTracker", () => $8499e9a5eb1eebc7$export$12b6b072930fd68f);

var $eSD9k = parcelRequire("eSD9k");
class $8499e9a5eb1eebc7$export$12b6b072930fd68f {
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $eSD9k.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
}

});
parcelRegister("eSD9k", function(module, exports) {

$parcel$export(module.exports, "Experience", () => $900476547114f74a$export$c90b54e658fc4d7c);

var $bd2th = parcelRequire("bd2th");
function $900476547114f74a$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $900476547114f74a$export$c90b54e658fc4d7c {
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this._hasStopped = false;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $900476547114f74a$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $900476547114f74a$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $bd2th.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $900476547114f74a$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
}

});
parcelRegister("bd2th", function(module, exports) {

$parcel$export(module.exports, "ExperienceTimeoutError", () => $39ee952f71f5b729$export$d27a2b6293f7631c);
class $39ee952f71f5b729$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}

});



parcelRegister("9sAyK", function(module, exports) {

$parcel$export(module.exports, "sliSubscriber", () => $6b2f2360dd11edee$export$db0b99fe17114899);

var $fjcgS = parcelRequire("fjcgS");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

const $6b2f2360dd11edee$var$transformApplication = (application)=>{
    switch(application){
        case 0, $efvDm.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $efvDm.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $efvDm.JIRA_CORE:
            return 'jira-core';
        case 0, $efvDm.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $efvDm.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $6b2f2360dd11edee$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $ldyPw.FREE_EDITION:
            return 'jedi';
        case 0, $ldyPw.STANDARD_EDITION:
            return 'standard';
        case 0, $ldyPw.PREMIUM_EDITION:
            return 'premium';
        case 0, $ldyPw.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $6b2f2360dd11edee$var$createAnalyticsEvent = ({ experience: experience, action: action, location: location, analyticsSource: analyticsSource, application: application, edition: edition, errorMessage: errorMessage, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: action,
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            // any attribute on top of this is overridable by any tracker
            task: experience,
            reason: location,
            analyticsSource: analyticsSource,
            application: $6b2f2360dd11edee$var$transformApplication(application),
            edition: $6b2f2360dd11edee$var$transformEdition(edition),
            ...errorMessage && {
                errorMessage: errorMessage
            }
        }
    });
const $6b2f2360dd11edee$var$reportSli = (experienceDescription)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $6b2f2360dd11edee$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};
const $6b2f2360dd11edee$export$db0b99fe17114899 = (event)=>{
    const { name: name, action: action } = event;
    // @ts-expect-error - TS2339 - Property 'disableSli' does not exist on type '{}'. | TS2339 - Property 'analyticsSource' does not exist on type '{}'. | TS2339 - Property 'application' does not exist on type '{}'. | TS2339 - Property 'edition' does not exist on type '{}'. | TS2339 - Property 'location' does not exist on type '{}'.
    const { disableSli: disableSli, analyticsSource: analyticsSource, application: application, edition: edition, location: location, ...additionalAttributes } = event.attributes || {};
    if (disableSli) return;
    switch(action){
        case 0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a:
            $6b2f2360dd11edee$var$reportSli({
                experience: name,
                action: (0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $c0ec49ac5a1e4009$export$b48b3d1872522384:
            $6b2f2360dd11edee$var$reportSli({
                experience: name,
                action: (0, $c0ec49ac5a1e4009$export$b48b3d1872522384),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                ...event.error && {
                    errorMessage: String(event.error)
                },
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8:
            $6b2f2360dd11edee$var$reportSli({
                experience: name,
                action: (0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                additionalAttributes: additionalAttributes
            });
            break;
        default:
    }
};

});


parcelRegister("kDdFQ", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5dc03f10b4b74566$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $cfDZ3 = parcelRequire("cfDZ3");

var $16v4H = parcelRequire("16v4H");
const $5dc03f10b4b74566$export$eb40d3df56aa5c53 = ()=>{
    const subProduct = (0, $16v4H.useSubProduct)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $cfDZ3.setSubProduct)(subProduct);
    }, [
        subProduct
    ]);
    return null;
};

});


parcelRegister("gPTB6", function(module, exports) {

$parcel$export(module.exports, "NavigationContainers", () => $1720b620f5483501$export$36f9ed697cae18ae);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $8ploF = parcelRequire("8ploF");
let $1720b620f5483501$var$Containers = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
if (!false) $1720b620f5483501$var$Containers = (0, $8ploF.ClientOnlyNavigationContainers);
const $1720b620f5483501$export$36f9ed697cae18ae = ({ baseUrl: baseUrl, children: children })=>{
    (0, $gKZoD.di)($1720b620f5483501$var$Containers);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1720b620f5483501$var$Containers, {
        baseUrl: baseUrl
    }, children);
};

});
parcelRegister("8ploF", function(module, exports) {

$parcel$export(module.exports, "ClientOnlyNavigationContainers", () => $f5cf024286957bf6$export$68d7c1e44acfd599);

var $5uXOq = parcelRequire("5uXOq");

var $axSKo = parcelRequire("axSKo");
const $f5cf024286957bf6$export$68d7c1e44acfd599 = ({ children: children })=>{
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $axSKo.Provider), null, children);
    return null;
};

});


parcelRegister("9kep9", function(module, exports) {

$parcel$export(module.exports, "PageConfigContainers", () => $83e79f36d4d977db$export$9c661932489b4130);

var $5uXOq = parcelRequire("5uXOq");

var $9MAC1 = parcelRequire("9MAC1");

var $j8DrX = parcelRequire("j8DrX");

var $lODMY = parcelRequire("lODMY");

var $4CAXd = parcelRequire("4CAXd");

var $aX7Cy = parcelRequire("aX7Cy");
const $83e79f36d4d977db$var$useRouterRoute = (0, $lODMY.createRouterSelector)((state)=>state.route);
const $83e79f36d4d977db$export$9c661932489b4130 = ({ children: children })=>{
    const { PageConfigContainerOverride: PageConfigContainerOverride } = $83e79f36d4d977db$var$useRouterRoute();
    if (PageConfigContainerOverride !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PageConfigContainerOverride, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MAC1.ThemeContainer), {
        isGlobal: true,
        getMeta: (0, $j8DrX.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleContainer), {
        titleSuffix: (0, $aX7Cy.ripTitleTemplateFromMeta)((0, $j8DrX.default))
    }, children));
};

});
parcelRegister("9MAC1", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $a1f770a9d49220c1$export$93d4e7f90805808f);
$parcel$export(module.exports, "ThemeContainer", () => $a1f770a9d49220c1$export$11eb671888ed6e7d);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $LtWMd = parcelRequire("LtWMd");
const $a1f770a9d49220c1$var$initialState = {
    navigationTheme: {
        shouldShowTitle: false,
        logoUrl: '',
        usesCustomColours: false,
        backgroundColor: '',
        highlightColor: ''
    }
};
const $a1f770a9d49220c1$var$Store = (0, $iXqE5.createStore)({
    name: 'theme',
    initialState: $a1f770a9d49220c1$var$initialState,
    actions: $LtWMd
});
const $a1f770a9d49220c1$export$74e6aa5aeff5e82e = (0, $51nlc.createSubscriber)($a1f770a9d49220c1$var$Store);
const $a1f770a9d49220c1$export$93d4e7f90805808f = (0, $3sQ5x.createHook)($a1f770a9d49220c1$var$Store);
const $a1f770a9d49220c1$export$11eb671888ed6e7d = (0, $gg7kZ.createContainer)($a1f770a9d49220c1$var$Store, {
    onInit: $LtWMd.bootstrap
});

});
parcelRegister("LtWMd", function(module, exports) {

$parcel$export(module.exports, "bootstrap", () => $9594f0aa641d3463$export$36aff1fbb4f5dfc6);
$parcel$export(module.exports, "update", () => $9594f0aa641d3463$export$722fbec263ad908a);

const $9594f0aa641d3463$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { getMeta: getMeta })=>{
        const ajsBackgroundColor = getMeta('ajs-lf-navigation-bgcolour');
        const ajsHighlightColor = getMeta('ajs-lf-navigation-highlightcolour');
        // we need to use color code directly here to compare it with hex code in meta tags
        const hasNavv3CustomColors = ajsBackgroundColor != null && ajsHighlightColor != null && (ajsBackgroundColor !== (0, $a7f8c6b391092279$exports).N0 || ajsHighlightColor !== (0, $a7f8c6b391092279$exports).B400);
        const navigationTheme = {
            shouldShowTitle: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            logoUrl: getMeta('ajs-lf-top-adg3-logourl') || '',
            usesCustomColours: getMeta('ajs-lf-top-adg3-hascustomcolours') === 'true',
            backgroundColor: ajsBackgroundColor || "var(--ds-background-inverse-subtle, #00000029)",
            highlightColor: ajsHighlightColor || "var(--ds-text-brand, #0C66E4)"
        };
        if (hasNavv3CustomColors) navigationTheme.usesCustomColours = true;
        setState({
            navigationTheme: navigationTheme
        });
    };
const $9594f0aa641d3463$export$722fbec263ad908a = (item)=>({ setState: setState, getState: getState })=>{
        const navigationTheme = {
            ...getState().navigationTheme,
            ...item
        };
        setState({
            navigationTheme: navigationTheme
        });
    };

});


parcelRegister("4CAXd", function(module, exports) {

$parcel$export(module.exports, "useDocumentTitleActions", () => $5f36a4118f941187$export$57c0fda036e12d67);
$parcel$export(module.exports, "DocumentTitleContainer", () => $5f36a4118f941187$export$1aad43993172f16f);
$parcel$export(module.exports, "DocumentTitleSubscriber", () => $5f36a4118f941187$export$b88d5abf3e0bec8c);
$parcel$export(module.exports, "DocumentTitleHelper", () => $5f36a4118f941187$export$573bf8d2ae7d60dc);
$parcel$export(module.exports, "DocumentTitleHelperOld", () => $5f36a4118f941187$export$1b644a069f382802);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $3Nww0 = parcelRequire("3Nww0");

var $aX7Cy = parcelRequire("aX7Cy");
const $5f36a4118f941187$var$initialState = {
    title: '',
    defaultTitle: '',
    contextArray: []
};
const $5f36a4118f941187$var$Store = (0, $iXqE5.createStore)({
    name: 'document-title',
    initialState: $5f36a4118f941187$var$initialState,
    actions: $3Nww0.actions
});
const $5f36a4118f941187$export$57c0fda036e12d67 = (0, $3sQ5x.createActionsHook)($5f36a4118f941187$var$Store);
const $5f36a4118f941187$export$4b208edda918084f = (0, $3sQ5x.createHook)($5f36a4118f941187$var$Store);
const $5f36a4118f941187$export$1aad43993172f16f = (0, $gg7kZ.createContainer)($5f36a4118f941187$var$Store, {
    displayName: 'DocumentTitleContainer'
});
const $5f36a4118f941187$export$b88d5abf3e0bec8c = (0, $51nlc.createSubscriber)($5f36a4118f941187$var$Store, {
    displayName: 'DocumentTitleSubscriber'
});
const $5f36a4118f941187$export$573bf8d2ae7d60dc = ({ title: title })=>{
    const { addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle, updateTitle: updateTitle } = $5f36a4118f941187$export$57c0fda036e12d67();
    const identifierRef = (0, $5uXOq.useRef)(Symbol(title));
    const onUpdate = (0, $5uXOq.useCallback)(()=>{
        updateTitle(title, identifierRef.current);
    }, [
        updateTitle,
        title
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const titleRef = identifierRef.current;
        addDocumentTitle(titleRef, title);
        return ()=>{
            removeDocumentTitle(titleRef);
            onUpdate();
        };
    }, [
        addDocumentTitle,
        onUpdate,
        removeDocumentTitle,
        title
    ]);
    (0, $5uXOq.useEffect)(()=>{
        onUpdate();
    }, [
        onUpdate
    ]);
    return null;
};
class $5f36a4118f941187$export$1b644a069f382802 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.myself = Symbol('document title identifier');
        this.props.addDocumentTitle(this.myself);
    }
    componentDidMount() {
        this.updateTitle();
    }
    componentDidUpdate() {
        this.updateTitle();
    }
    componentWillUnmount() {
        this.props.removeDocumentTitle(this.myself);
        this.updateTitle();
    }
    updateTitle() {
        if ((0, $aX7Cy.checkDocumentTitle)(this.myself, this.props.contextArray)) this.props.setTitle(this.props.title);
    }
    render() {
        return null;
    }
}

});
parcelRegister("3Nww0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $ba5e66d563aca941$export$e324594224ef24da);

var $9vNeL = parcelRequire("9vNeL");

var $5Oj7f = parcelRequire("5Oj7f");

var $gJBAO = parcelRequire("gJBAO");

var $8DEaw = parcelRequire("8DEaw");
const $ba5e66d563aca941$export$e324594224ef24da = {
    setTitle: $9vNeL.setTitle,
    addDocumentTitle: $5Oj7f.addDocumentTitle,
    removeDocumentTitle: $gJBAO.removeDocumentTitle,
    updateTitle: $8DEaw.updateTitle
};

});
parcelRegister("9vNeL", function(module, exports) {

$parcel$export(module.exports, "setTitle", () => $aa0c91bbbd212a23$export$420a7f2fd9cad6f6);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $aX7Cy = parcelRequire("aX7Cy");
const $aa0c91bbbd212a23$export$420a7f2fd9cad6f6 = (title)=>({ setState: setState, getState: getState }, { titleSuffix: titleSuffix })=>{
        const state = getState();
        const titleTemplate = titleSuffix ? `%s - ${titleSuffix}` : '%s - Jira';
        const newTitle = (0, $aX7Cy.createTitleFromTemplate)(title, titleTemplate);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.title = newTitle;
        setState({
            ...state,
            title: newTitle
        });
    };

});
parcelRegister("aX7Cy", function(module, exports) {

$parcel$export(module.exports, "createTitleFromTemplate", () => $45855f8363268b1b$export$3795256dd54a9c9d);
$parcel$export(module.exports, "ripTitleTemplateFromMeta", () => $45855f8363268b1b$export$b7d18105f80195c);
$parcel$export(module.exports, "checkDocumentTitle", () => $45855f8363268b1b$export$7f8be70a0bed1bae);

var $4R6GH = parcelRequire("4R6GH");
const $45855f8363268b1b$export$3795256dd54a9c9d = (title, template)=>template.replace(/%s/, title);
const $45855f8363268b1b$export$b7d18105f80195c = (getMeta)=>getMeta('ajs-app-title');
const $45855f8363268b1b$export$7f8be70a0bed1bae = (symbol, contextArray)=>{
    const lastDocumentTitle = contextArray[contextArray.length - 1];
    if ((0, $4R6GH.fg)('jira-concurrent-document-title')) {
        if (typeof lastDocumentTitle === 'object' && lastDocumentTitle.symbol === symbol) return true;
        return false;
    }
    if (lastDocumentTitle === symbol) return true;
    return false;
};

});


parcelRegister("5Oj7f", function(module, exports) {

$parcel$export(module.exports, "addDocumentTitle", () => $53f35561ab86eb34$export$a0c188c0ea474bb8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");
const $53f35561ab86eb34$export$a0c188c0ea474bb8 = (symbol, title)=>({ setState: setState, getState: getState })=>{
        const { contextArray: contextArray } = getState();
        title && (0, $4R6GH.fg)('jira-concurrent-document-title') ? contextArray.push({
            title: title,
            symbol: symbol
        }) : contextArray.push(symbol);
        setState({
            contextArray: contextArray
        });
    };

});

parcelRegister("gJBAO", function(module, exports) {

$parcel$export(module.exports, "removeDocumentTitle", () => $bcdbd43154f62b45$export$e844009b77f80a72);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");
const $bcdbd43154f62b45$export$e844009b77f80a72 = (titleSymbol)=>({ setState: setState, getState: getState })=>{
        const { contextArray: contextArray } = getState();
        setState({
            contextArray: (0, $4R6GH.fg)('jira-concurrent-document-title') ? contextArray.filter((titleContext)=>typeof titleContext === 'object' && titleContext.symbol !== titleSymbol) : contextArray.filter((symbol)=>symbol !== titleSymbol)
        });
    };

});

parcelRegister("8DEaw", function(module, exports) {

$parcel$export(module.exports, "updateTitle", () => $a1d3af230daa7254$export$bf6f7165e46e2479);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");

var $aX7Cy = parcelRequire("aX7Cy");
const $a1d3af230daa7254$var$generateTitle = (title, titleSuffix)=>{
    const titleTemplate = titleSuffix ? `%s - ${titleSuffix}` : '%s - Jira';
    const newTitle = (0, $aX7Cy.createTitleFromTemplate)(title, titleTemplate);
    return newTitle;
};
const $a1d3af230daa7254$export$bf6f7165e46e2479 = (title, context)=>({ setState: setState, getState: getState }, { titleSuffix: titleSuffix })=>{
        const state = getState();
        const contextItem = state.contextArray.find((item)=>{
            if (typeof item === 'object') return item.symbol === context;
            return false;
        });
        // If there is no contextItem, it means that the component has been unmounted
        // And we'll just use the last used title from the contextArray
        if (!contextItem && state.contextArray.length && (0, $4R6GH.fg)('jira-concurrent-document-title')) {
            const lastContextItem = state.contextArray[state.contextArray.length - 1];
            let newTitle = '';
            // This will always be an object but we have to check it to make TS happy
            if (typeof lastContextItem === 'object') newTitle = $a1d3af230daa7254$var$generateTitle(lastContextItem.title, titleSuffix);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.title = newTitle;
            setState({
                title: newTitle
            });
            return;
        }
        if ((0, $aX7Cy.checkDocumentTitle)(context, state.contextArray)) {
            const newTitle = $a1d3af230daa7254$var$generateTitle(title, titleSuffix);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.title = newTitle;
            setState({
                title: newTitle
            });
        }
    };

});




parcelRegister("eSznd", function(module, exports) {

$parcel$export(module.exports, "UiManagers", () => $ca023ab667a452ba$export$41286c339a88ca24);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $e0Brz = parcelRequire("e0Brz");

var $5zgk6 = parcelRequire("5zgk6");

var $9rAvm = parcelRequire("9rAvm");
let $ca023ab667a452ba$var$ClientUiManagers = (0, $5uXOq.Fragment);
if (!false) // @ts-expect-error - TS2741 - Property '$$typeof' is missing in type '({ children }: ClientUiManagersProps) => JSX.Element' but required in type 'ExoticComponent<{ children?: ReactNode; }>'.
$ca023ab667a452ba$var$ClientUiManagers = (0, $9rAvm.ClientUiManagers);
const $ca023ab667a452ba$export$41286c339a88ca24 = ({ children: children })=>{
    (0, $gKZoD.di)($ca023ab667a452ba$var$ClientUiManagers);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5zgk6.LayoutManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0Brz.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca023ab667a452ba$var$ClientUiManagers, null, children)));
};

});
parcelRegister("e0Brz", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbManager", () => $e20dc5e8426041f9$export$cd5073909dd92c28);

var $5uXOq = parcelRequire("5uXOq");

var $aIVNN = parcelRequire("aIVNN");
const $e20dc5e8426041f9$export$cd5073909dd92c28 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aIVNN.BreadcrumbContainer), null, children);

});

parcelRegister("5zgk6", function(module, exports) {

$parcel$export(module.exports, "LayoutManager", () => $20f0b1159f4863ef$export$4a04ad01c410b415);

var $5uXOq = parcelRequire("5uXOq");

var $c34Wf = parcelRequire("c34Wf");

var $lODMY = parcelRequire("lODMY");
var $2YP9W = parcelRequire("2YP9W");

var $gg7kZ = parcelRequire("gg7kZ");

var $8CM3x = parcelRequire("8CM3x");

var $5e5zm = parcelRequire("5e5zm");
const $20f0b1159f4863ef$var$LayoutContainer = (0, $gg7kZ.createContainer)((0, $5e5zm.layoutStore), {
    displayName: 'JiraLayoutContainer',
    onInit: ()=>({ dispatch: dispatch }, { leftSidebar: leftSidebar, rightSidebar: rightSidebar, isChromeless: isChromeless })=>{
            dispatch((0, $8CM3x.actions).setIsChromeless(isChromeless));
            dispatch((0, $8CM3x.actions).setLeftSidebarState(leftSidebar));
            dispatch((0, $8CM3x.actions).setRightSidebarState(rightSidebar));
        },
    onUpdate: ()=>({ dispatch: dispatch }, { isChromeless: isChromeless })=>{
            dispatch((0, $8CM3x.actions).setIsChromeless(isChromeless));
        }
});
const $20f0b1159f4863ef$var$DEFFAULT_RIGHT_SIDEBAR_STATE = {
    stackState: []
};
const $20f0b1159f4863ef$var$useIsChromeless = (0, $lODMY.createRouterSelector)((state)=>state.route.layout?.isChromeless === true || state.route.entryPoint?.()?.toString() === 'ChromelessEntryPoint');
const $20f0b1159f4863ef$export$4a04ad01c410b415 = ({ children: children })=>{
    const { data: data } = (0, $2YP9W.useResource)((0, $c34Wf.navigationUiStateResource));
    const isChromeless = $20f0b1159f4863ef$var$useIsChromeless();
    const isLeftSidebarCollapsed = data?.leftSidebar?.isCollapsed ?? false;
    const leftSidebarWidth = data?.leftSidebar?.width ?? (0, $5e5zm.DEFAULT_LEFT_SIDEBAR_WIDTH);
    const leftSidebar = (0, $5uXOq.useMemo)(()=>({
            isVisible: true,
            isCollapsed: isLeftSidebarCollapsed,
            width: leftSidebarWidth,
            isFlyoutOpen: false
        }), [
        isLeftSidebarCollapsed,
        leftSidebarWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20f0b1159f4863ef$var$LayoutContainer, {
        isGlobal: true,
        isChromeless: isChromeless,
        leftSidebar: leftSidebar,
        rightSidebar: $20f0b1159f4863ef$var$DEFFAULT_RIGHT_SIDEBAR_STATE
    }, children);
};

});

parcelRegister("9rAvm", function(module, exports) {

$parcel$export(module.exports, "ClientUiManagers", () => $2b5f3846e82b020b$export$d1db6ae5bf84e489);

var $5uXOq = parcelRequire("5uXOq");

var $inni2 = parcelRequire("inni2");

var $6pvrS = parcelRequire("6pvrS");

var $4041n = parcelRequire("4041n");

var $pa9q9 = parcelRequire("pa9q9");

var $2HbP2 = parcelRequire("2HbP2");

var $4yEIl = parcelRequire("4yEIl");

var $bKCrm = parcelRequire("bKCrm");
const $2b5f3846e82b020b$export$d1db6ae5bf84e489 = ({ children: children })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6pvrS.CrossFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4yEIl.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKCrm.ProjectCreateDrawerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4041n.FavoriteChangeProvider), {
        onShowFlag: showFlag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inni2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2HbP2.ModalContextProvider), null, children))))));
};

});
parcelRegister("6pvrS", function(module, exports) {

$parcel$export(module.exports, "CrossFlowProvider", () => $2cd77fddb456dca8$export$d900e4062895cd7c);

var $5uXOq = parcelRequire("5uXOq");

var $hEhtI = parcelRequire("hEhtI");

var $fjcgS = parcelRequire("fjcgS");

var $koeKL = parcelRequire("koeKL");

var $DVljb = parcelRequire("DVljb");

var $g2XuF = parcelRequire("g2XuF");

var $5emZd = parcelRequire("5emZd");
// DELOR-412 Remove explicit mock once we make analytics a no-op in SSR
const $2cd77fddb456dca8$var$getAnalyticsInstance = ()=>false ? Promise.resolve({
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendUIEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendOperationalEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendTrackEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendScreenEvent: ()=>{}
    }) : (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>client.getInstance());
const $2cd77fddb456dca8$export$d900e4062895cd7c = ({ children: children })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const locale = (0, $DVljb.useLocale)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hEhtI.default), {
        cloudId: cloudId,
        // @ts-expect-error - TS2322 - Type 'Promise<typeof AnalyticsWebClient> | Promise<{ sendUIEvent: () => void; sendOperationalEvent: () => void; sendTrackEvent: () => void; sendScreenEvent: () => void; }>' is not assignable to type 'MaybePromise<AnalyticsWebClientInterface>'.
        analyticsClient: $2cd77fddb456dca8$var$getAnalyticsInstance(),
        locale: locale,
        plugins: [
            (0, $g2XuF.getContainersPlugin),
            (0, $5emZd.getUsersPlugin)
        ]
    }, children);
};

});
parcelRegister("hEhtI", function(module, exports) {

$parcel$export(module.exports, "default", () => $96ff869443847a43$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $emp0A = parcelRequire("emp0A");

const $96ff869443847a43$var$JiraProvider = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $emp0A.CrossFlowProvider), {
        ...props,
        originProduct: "jira"
    });
};
var $96ff869443847a43$export$2e2bcd8739ae039 = $96ff869443847a43$var$JiraProvider;

});
parcelRegister("emp0A", function(module, exports) {

$parcel$export(module.exports, "CrossFlowProvider", () => $fb01c4db10cab221$export$d900e4062895cd7c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $Q9DHJ = parcelRequire("Q9DHJ");

var $8dUOv = parcelRequire("8dUOv");

var $7FtoK = parcelRequire("7FtoK");

var $aEtkg = parcelRequire("aEtkg");

var $jOh9b = parcelRequire("jOh9b");

var $cM7De = parcelRequire("cM7De");

var $gmERf = parcelRequire("gmERf");

var $cKYxd = parcelRequire("cKYxd");

var $dEeq3 = parcelRequire("dEeq3");

const $fb01c4db10cab221$var$IntegrationView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("cpAki")));
const $fb01c4db10cab221$export$79d79d8dd8574306 = (IntegrationView)=>(props)=>{
        const { children: children, analyticsClient: analyticsClient, originProduct: originProduct, redirectToWac: redirectToWac, env: env, plugins: plugins = [], globalExperimentalOptions: globalExperimentalOptions, onError: onError, ...baseProviderProps } = props;
        const onCloseResolver = (0, $5uXOq.useRef)();
        const [firstHandshakeReceived, setFirstHandshakeReceived] = (0, $5uXOq.useState)(false);
        const fireEvent = (0, $5uXOq.useMemo)(()=>(0, $7FtoK.analyticsWrapper)(analyticsClient), [
            analyticsClient
        ]);
        const [requestOptions, setRequestOptions] = (0, $5uXOq.useState)();
        const onAnalyticsEvent = (0, $5uXOq.useCallback)((payload)=>{
            const gasV3Event = (0, $aEtkg.transformEvent)(payload);
            if (gasV3Event) {
                const enrichedEvent = (0, $cKYxd.enrichWithRequestOptions)((0, $gmERf.enrichWithPackageDetails)(gasV3Event), requestOptions);
                fireEvent(enrichedEvent);
            }
        }, [
            fireEvent,
            requestOptions
        ]);
        const onHandShake = (0, $5uXOq.useCallback)((appName)=>{
            if (!firstHandshakeReceived) {
                onAnalyticsEvent({
                    payload: {
                        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
                        action: (0, $dEeq3.uiInitialized),
                        actionSubject: (0, $dEeq3.crossFlowActionSubject),
                        attributes: {
                            appName: appName
                        }
                    },
                    context: [
                        {
                            source: $dEeq3.source
                        }
                    ]
                });
                setFirstHandshakeReceived(true);
            }
        }, [
            firstHandshakeReceived,
            onAnalyticsEvent
        ]);
        const onOpen = (0, $5uXOq.useCallback)((options)=>{
            /**
     * Reset first handshake state to ensure 1:1 value of open invoked and handshake received
     * Caveat that if open api is invoked while cross flow support UI is already mounted there will be mismatch of openInvoked events to uiInitialized events
     */ setFirstHandshakeReceived(false);
            const analyticsEvent = {
                // setRequestOptions does not update the state right away (updates on the next render) so for the openInvoked event we need to manually append the sourceComponent and sourceContext
                payload: (0, $cKYxd.enrichWithRequestOptions)({
                    eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
                    action: (0, $dEeq3.openInvoked),
                    actionSubject: (0, $dEeq3.crossFlowActionSubject)
                }, options),
                context: [
                    {
                        source: $dEeq3.source
                    }
                ]
            };
            onAnalyticsEvent(analyticsEvent);
            // Short circuit requestOptions for WAC expansions
            if (options.journey === (0, $Q9DHJ.Journeys).GET_STARTED && redirectToWac) {
                (0, $jOh9b.setProductSignUpLocation)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                const completionStatus = {};
                return Promise.resolve(completionStatus);
            }
            const updatedExperimentalOptions = {
                ...globalExperimentalOptions || {},
                // "globalExperimentalOptions" will be injected to EVERY crossFlow invoke
                ...options.experimentalOptions || {} // "options.experimentalOptions" takes care of passing experimentalOptions to ONE specific crossFlow invoke
            };
            options.experimentalOptions = updatedExperimentalOptions;
            setRequestOptions(options);
            return new Promise((resolve)=>{
                onCloseResolver.current = resolve;
            });
        }, [
            onAnalyticsEvent,
            env,
            redirectToWac,
            globalExperimentalOptions
        ]);
        const onClose = (0, $5uXOq.useCallback)((completionStatus)=>{
            setFirstHandshakeReceived(false);
            setRequestOptions(undefined);
            onCloseResolver.current && onCloseResolver.current(completionStatus);
        }, []);
        const { colorMode: colorMode } = (0, $8dUOv.default)();
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $Q9DHJ.BaseCrossFlowApiProvider), {
            onOpen: onOpen,
            children: [
                children,
                requestOptions && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cM7De.ErrorBoundary), {
                    onAnalyticsEvent: onAnalyticsEvent,
                    onError: onError,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                        fallback: null,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)(IntegrationView, {
                            ...baseProviderProps,
                            ...requestOptions,
                            onAnalyticsEvent: onAnalyticsEvent,
                            originProduct: originProduct,
                            theme: colorMode,
                            onClose: onClose,
                            onHandShake: onHandShake,
                            plugins: plugins,
                            env: env,
                            redirectToWac: redirectToWac,
                            zIndex: requestOptions.zIndex ?? 1000
                        })
                    })
                })
            ]
        });
    };
const $fb01c4db10cab221$export$d900e4062895cd7c = $fb01c4db10cab221$export$79d79d8dd8574306($fb01c4db10cab221$var$IntegrationView);

});
parcelRegister("7FtoK", function(module, exports) {

$parcel$export(module.exports, "analyticsWrapper", () => $5dcc80d6355cb813$export$91b4dd3bfc301325);

const $5dcc80d6355cb813$export$91b4dd3bfc301325 = (analyticsClient)=>{
    return (event)=>{
        return Promise.resolve(analyticsClient).then((client)=>{
            switch(event.eventType){
                case 0, $4e2819b72987a07d$export$a1562d08625f5d7e:
                    client.sendUIEvent(event);
                    break;
                case 0, $4e2819b72987a07d$export$947dac6c72b26f81:
                    client.sendTrackEvent(event);
                    break;
                case 0, $4e2819b72987a07d$export$12346a674644c156:
                    client.sendOperationalEvent(event);
                    break;
                case 0, $4e2819b72987a07d$export$f1d537d508d2945a:
                    client.sendScreenEvent(event);
                    break;
            }
        });
    };
};

});

parcelRegister("aEtkg", function(module, exports) {

$parcel$export(module.exports, "transformEvent", () => $b4e043649017de98$export$3f40e8c44448be30);
// Copied from xflow-ui. We post raw analytics events (context and payload only) from xflow-ui to consumer (CFE), transform on consumer and post to gasv3.

const $b4e043649017de98$var$GROWTH_TAG = 'growth';
const $b4e043649017de98$var$extractFromEventContext = (propertyNames, context)=>context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContextProp = contextItem ? contextItem[propertyName] : null;
            acc.push(navContextProp || contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
const $b4e043649017de98$var$getSources = (context)=>$b4e043649017de98$var$extractFromEventContext([
        'source'
    ], context);
const $b4e043649017de98$var$getExtraAttributes = (context)=>context.reduce((ans, { attributes: attributes, ...contextProps })=>{
        const newAttributes = {
            ...ans,
            ...contextProps
        };
        return attributes ? {
            ...newAttributes,
            ...attributes
        } : newAttributes;
    }, {});
const $b4e043649017de98$var$getPackageInfo = (context)=>context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $b4e043649017de98$var$last = (values)=>values[values.length - 1];
const $b4e043649017de98$export$3f40e8c44448be30 = (event)=>{
    const { context: context, payload: payload } = event;
    if (!payload) return null;
    const sources = $b4e043649017de98$var$getSources(context);
    const source = $b4e043649017de98$var$last(sources) || (0, $4e2819b72987a07d$export$b055de0e665cb20c);
    const extraAttributes = $b4e043649017de98$var$getExtraAttributes(context);
    const { packageName: packageName, packageVersion: packageVersion } = $b4e043649017de98$var$last($b4e043649017de98$var$getPackageInfo(context)) || {};
    const { eventType: eventType = (0, $4e2819b72987a07d$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = payload;
    const attributes = {
        packageName: packageName,
        packageVersion: packageVersion,
        ...extraAttributes,
        ...payloadAttributes
    };
    const tags = payload.tags || [];
    tags.push($b4e043649017de98$var$GROWTH_TAG);
    switch(eventType){
        case 0, $4e2819b72987a07d$export$a1562d08625f5d7e:
        case 0, $4e2819b72987a07d$export$12346a674644c156:
        case 0, $4e2819b72987a07d$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: tags.slice(0)
            };
        case 0, $4e2819b72987a07d$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                source: source,
                tags: tags.slice(0)
            };
        default:
            break;
    }
    return null;
};

});

parcelRegister("jOh9b", function(module, exports) {

$parcel$export(module.exports, "setProductSignUpLocation", () => $175eb06b5f16bb88$export$2827e2473cb9a346);

var $bBrJC = parcelRequire("bBrJC");


var $aidkJ = parcelRequire("aidkJ");
const $175eb06b5f16bb88$var$utmCampaignMap = {
    'atlassian-switcher': (0, $aidkJ.UtmCampaign)['atlassian-switcher']
};
const $175eb06b5f16bb88$var$isBundledProduct = (productKey)=>{
    return [
        (0, $bBrJC.Targets).JIRA_SOFTWARE,
        (0, $bBrJC.Targets).JIRA_SERVICE_DESK,
        (0, $bBrJC.Targets).JIRA_CORE,
        (0, $bBrJC.Targets).CONFLUENCE
    ].includes(productKey);
};
const $175eb06b5f16bb88$var$getBundleSignUpParams = (productKey)=>{
    const bundles = {
        [(0, $bBrJC.Targets).JIRA_SOFTWARE]: 'jira-software',
        [(0, $bBrJC.Targets).JIRA_SERVICE_DESK]: 'jira-service-desk',
        [(0, $bBrJC.Targets).JIRA_CORE]: 'jira-core',
        [(0, $bBrJC.Targets).CONFLUENCE]: 'confluence'
    };
    // Bundles default to free
    return `bundle=${bundles[productKey]}&edition=free`;
};
const $175eb06b5f16bb88$var$isProductWithCustomSignUpPath = (productKey)=>{
    return [
        (0, $bBrJC.Targets).OPSGENIE
    ].includes(productKey);
};
const $175eb06b5f16bb88$var$getProductCustomSignUpPath = (productKey)=>{
    // Only Opsgenie. Trello, Bitbucket and Statuspage are handled by Product Store directly.
    const links = {
        [(0, $bBrJC.Targets).OPSGENIE]: (0, $397eca2ead3b5c67$export$fb1e43fdafe12e9b)
    };
    return links[productKey];
};
const $175eb06b5f16bb88$var$isSourceComponentWithUtmParams = (sourceComponent)=>{
    return Boolean($175eb06b5f16bb88$var$utmCampaignMap[sourceComponent]);
};
const $175eb06b5f16bb88$var$getUtmParams = (sourceComponent, sourceContext)=>{
    let utmParams = '';
    if (sourceComponent && $175eb06b5f16bb88$var$isSourceComponentWithUtmParams(sourceComponent)) {
        utmParams = utmParams + `utm_campaign=${$175eb06b5f16bb88$var$utmCampaignMap[sourceComponent]}&utm_medium=in_product_ad`;
        if (sourceContext) utmParams = utmParams + `&utm_source=${sourceContext}`;
    }
    return utmParams;
};
const $175eb06b5f16bb88$export$39eab502fc96327d = (productKey, env, sourceComponent, sourceContext)=>{
    const wacUrl = env === 'staging' ? (0, $397eca2ead3b5c67$export$c37558e5c67d2b01) : (0, $397eca2ead3b5c67$export$f199baf8dfc7621e);
    const utmParams = $175eb06b5f16bb88$var$getUtmParams(sourceComponent, sourceContext);
    let queryParams = '';
    let bundleParams = '';
    let path = (0, $397eca2ead3b5c67$export$2a45a00073911255);
    if ($175eb06b5f16bb88$var$isBundledProduct(productKey)) {
        path = (0, $397eca2ead3b5c67$export$e6c04a1dd86d1c14);
        bundleParams = $175eb06b5f16bb88$var$getBundleSignUpParams(productKey);
    } else if ($175eb06b5f16bb88$var$isProductWithCustomSignUpPath(productKey)) path = $175eb06b5f16bb88$var$getProductCustomSignUpPath(productKey);
    if (!!bundleParams) queryParams = queryParams + `?${bundleParams}`;
    if (!!utmParams) queryParams = queryParams + (!!queryParams ? '&' : '?') + utmParams;
    return wacUrl + path + queryParams;
};
const $175eb06b5f16bb88$export$2827e2473cb9a346 = (productKey, env = 'production', sourceComponent, sourceContext)=>{
    const url = $175eb06b5f16bb88$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
    window.open(url, '_blank');
};

});
const $397eca2ead3b5c67$export$c37558e5c67d2b01 = 'https://qa-wac.internal.atlassian.com';
const $397eca2ead3b5c67$export$f199baf8dfc7621e = 'https://www.atlassian.com';
const $397eca2ead3b5c67$export$fb1e43fdafe12e9b = '/software/opsgenie/try';
const $397eca2ead3b5c67$export$e6c04a1dd86d1c14 = '/try/cloud/signup';
const $397eca2ead3b5c67$export$2a45a00073911255 = '/software';

parcelRegister("aidkJ", function(module, exports) {

$parcel$export(module.exports, "UtmCampaign", () => $8547188511f99a32$export$fc604aa353a97e10);
var $8547188511f99a32$export$fc604aa353a97e10 = /*#__PURE__*/ function(UtmCampaign) {
    UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
    return UtmCampaign;
}({});

});


parcelRegister("cM7De", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $a9c5a6da95ed7541$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");

var $dEeq3 = parcelRequire("dEeq3");
const $a9c5a6da95ed7541$var$name = "platform-pkg";
const $a9c5a6da95ed7541$var$version = "0.0.0-use.local";
const $a9c5a6da95ed7541$var$payload = {
    eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
    action: (0, $dEeq3.errorBoundaryAction),
    actionSubject: (0, $dEeq3.errorBoundaryActionSubject)
};
const $a9c5a6da95ed7541$var$context = [
    {
        source: $dEeq3.source
    },
    {
        packageName: $a9c5a6da95ed7541$var$name,
        packageVersion: $a9c5a6da95ed7541$var$version
    }
];
class $a9c5a6da95ed7541$export$e926676385687eaf extends (0, $5uXOq.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        this.props.onAnalyticsEvent({
            payload: $a9c5a6da95ed7541$var$payload,
            context: $a9c5a6da95ed7541$var$context
        });
        if (this.props.onError) this.props.onError(error);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}

});
parcelRegister("dEeq3", function(module, exports) {

$parcel$export(module.exports, "source", () => $3423ca8a41f87ef3$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "errorBoundaryAction", () => $3423ca8a41f87ef3$export$9d8252a268f4fa72);
$parcel$export(module.exports, "errorBoundaryActionSubject", () => $3423ca8a41f87ef3$export$1045419caf49b395);
$parcel$export(module.exports, "crossFlowActionSubject", () => $3423ca8a41f87ef3$export$d54c183f56e39aa5);
$parcel$export(module.exports, "uiInitialized", () => $3423ca8a41f87ef3$export$e5c2c058fa8068a6);
$parcel$export(module.exports, "openInvoked", () => $3423ca8a41f87ef3$export$e67cdcb8867a3bd0);

const $3423ca8a41f87ef3$export$b4d5da5f34fb77ad = 'crossFlowProvider';
const $3423ca8a41f87ef3$export$9d8252a268f4fa72 = 'errorCaught';
const $3423ca8a41f87ef3$export$1045419caf49b395 = 'errorBoundary';
const $3423ca8a41f87ef3$export$d54c183f56e39aa5 = 'crossFlowSupport';
const $3423ca8a41f87ef3$export$e5c2c058fa8068a6 = 'uiInitialized';
const $3423ca8a41f87ef3$export$e67cdcb8867a3bd0 = 'openInvoked';

});


parcelRegister("gmERf", function(module, exports) {

$parcel$export(module.exports, "enrichWithPackageDetails", () => $32f5831ec1b49b6c$export$59518efab336a8b5);
const $32f5831ec1b49b6c$var$version = "0.0.0-use.local";
const $32f5831ec1b49b6c$export$84f9cf7ef89d4c26 = {
    version: $32f5831ec1b49b6c$var$version
};
const $32f5831ec1b49b6c$export$59518efab336a8b5 = (event)=>{
    const attributes = {
        ...event.attributes || {},
        crossFlowSupport: $32f5831ec1b49b6c$export$84f9cf7ef89d4c26
    };
    return {
        ...event,
        attributes: attributes
    };
};

});

parcelRegister("cKYxd", function(module, exports) {

$parcel$export(module.exports, "enrichWithRequestOptions", () => $9bba179cd0be7505$export$a5a156dc5df42f0);
const $9bba179cd0be7505$export$a5a156dc5df42f0 = (event, requestOptions)=>{
    if (!requestOptions) return event;
    const attributes = {
        // Spread the extra analytics attributes first, because we don't want consumers to override any event attributes below
        ...requestOptions.extraAnalyticsAttributes || {},
        ...event.attributes || {},
        sourceComponent: requestOptions.sourceComponent,
        sourceContext: requestOptions.sourceContext
    };
    return {
        ...event,
        attributes: attributes
    };
};

});

parcelRegister("cpAki", function(module, exports) {

let $9093ff77c1377674$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9093ff77c1377674$var$load("h2MrD"),
    $9093ff77c1377674$var$load("bYT2S"),
    $9093ff77c1377674$var$load("9tVM0")
]).then(()=>parcelRequire('2HNrd'));

});



parcelRegister("g2XuF", function(module, exports) {

$parcel$export(module.exports, "getContainersPlugin", () => $014cd965663d7125$export$81d1d40061d190bc);
parcelRequire("8DdAA");
var $d53yJ = parcelRequire("d53yJ");
var $8DdAA = parcelRequire("8DdAA");

var $4Pf62 = parcelRequire("4Pf62");
const $014cd965663d7125$var$getCloudId = async ()=>{
    const { cloudName: cloudName, cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const containers = [
        {
            id: cloudId,
            displayName: cloudName,
            type: (0, $d53yJ.ContainerTypes).ATLASSIAN_CLOUD_ID
        }
    ];
    return {
        type: (0, $d53yJ.ContainerTypes).ATLASSIAN_CLOUD_ID,
        containers: containers
    };
};
const $014cd965663d7125$export$81d1d40061d190bc = (0, $8DdAA.createGetContainersPlugin)($014cd965663d7125$var$getCloudId);

});
parcelRegister("8DdAA", function(module, exports) {

$parcel$export(module.exports, "createGetContainersPlugin", () => $699dd2922cf51bc1$export$76378b0f825c024c);
$parcel$export(module.exports, "createGetUsersPlugin", () => $699dd2922cf51bc1$export$8feb7eae83cf8cd5);
$parcel$export(module.exports, "ContainerTypes", () => (parcelRequire("d53yJ")).ContainerTypes);
$parcel$export(module.exports, "UserIdTypes", () => (parcelRequire("d53yJ")).UserIdTypes);

var $d53yJ = parcelRequire("d53yJ");
const $699dd2922cf51bc1$export$76378b0f825c024c = (fetch)=>{
    return [
        (0, $d53yJ.PluginTypes).GetContainers,
        fetch
    ];
};
const $699dd2922cf51bc1$export$8feb7eae83cf8cd5 = (fetch)=>{
    return [
        (0, $d53yJ.PluginTypes).GetUsers,
        fetch
    ];
};
const $699dd2922cf51bc1$export$21d120847be2aff4 = (fetch)=>{
    return [
        (0, $d53yJ.PluginTypes).GetSuggestedSiteNames,
        fetch
    ];
};
const $699dd2922cf51bc1$export$d7c1699c6a2ca18a = (fetch)=>{
    return [
        (0, $d53yJ.PluginTypes).GetAvailableSites,
        fetch
    ];
};

});
parcelRegister("d53yJ", function(module, exports) {

$parcel$export(module.exports, "PluginTypes", () => $fad1425d5cb6a7de$export$a235a73f7b906dce);
$parcel$export(module.exports, "ContainerTypes", () => $fad1425d5cb6a7de$export$6e383182a26455ff);
$parcel$export(module.exports, "UserIdTypes", () => $fad1425d5cb6a7de$export$e391bab95adb8396);
// Data Plugin definition and utility types
const $fad1425d5cb6a7de$export$a235a73f7b906dce = {
    GetContainers: 'GetContainers',
    GetUsers: 'GetUsers',
    GetSuggestedSiteNames: 'GetSuggestedSiteNames',
    GetAvailableSites: 'GetAvailableSites'
};
const $fad1425d5cb6a7de$export$6e383182a26455ff = {
    BITBUCKET_WORKSPACE: 'bitbucket-workspace',
    ATLASSIAN_CLOUD_ID: 'ATLASSIAN_CLOUD_ID',
    JIRA_SOFTWARE_PROJECT: 'JIRA_SOFTWARE_PROJECT'
};
const $fad1425d5cb6a7de$export$e391bab95adb8396 = {
    ATLASSIAN_ACCOUNT_ID: 'ATLASSIAN_ACCOUNT_ID',
    TRELLO_ID: 'TRELLO_ID'
};
const $fad1425d5cb6a7de$export$4f378ba35c571906 = {
    JIRA_BUSINESS: 'JIRA_BUSINESS',
    JIRA_SERVICE_DESK: 'JIRA_SERVICE_DESK',
    JIRA_SOFTWARE: 'JIRA_SOFTWARE',
    CONFLUENCE: 'CONFLUENCE',
    OPSGENIE: 'OPSGENIE',
    BITBUCKET: 'BITBUCKET',
    STATUSPAGE: 'STATUSPAGE',
    TRELLO: 'TRELLO',
    COMPASS: 'COMPASS'
};

});



parcelRegister("5emZd", function(module, exports) {

$parcel$export(module.exports, "getUsersPlugin", () => $83dd2c216cba0381$export$7c44908d2777db01);

var $8DdAA = parcelRequire("8DdAA");
var $d53yJ = parcelRequire("d53yJ");
const $83dd2c216cba0381$var$getUsers = async (containerId)=>{
    const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
    try {
        const response = await fetch(getUsersUrl, {
            credentials: 'same-origin'
        });
        if (response.ok) {
            const data = await response.json();
            return data.map((value)=>({
                    id: value.id,
                    idType: (0, $d53yJ.UserIdTypes).ATLASSIAN_ACCOUNT_ID,
                    displayName: value.displayName
                }));
        }
        throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
    }
};
const $83dd2c216cba0381$export$7c44908d2777db01 = (0, $8DdAA.createGetUsersPlugin)($83dd2c216cba0381$var$getUsers);

});


parcelRegister("2HbP2", function(module, exports) {

$parcel$export(module.exports, "ModalContextProvider", () => $d012230882eb31a4$export$7c9538f5f3c365e9);

var $5uXOq = parcelRequire("5uXOq");

var $kW74I = parcelRequire("kW74I");

var $4R6GH = parcelRequire("4R6GH");

var $gJdig = parcelRequire("gJdig");
const $d012230882eb31a4$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $5uXOq.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $5uXOq.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $d012230882eb31a4$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $5uXOq.useRef)(1);
    const [modals, setModals] = (0, $5uXOq.useState)([]);
    const modalContext = (0, $5uXOq.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gJdig.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kW74I.default), null, modals.map((modal)=>{
        return (0, $4R6GH.fg)('jpo-31059_modal_close_behaviour_controls') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d012230882eb31a4$var$RenderModal, {
            key: modal.key,
            modal: modal
        }) : // @ts-expect-error - TS2739 - Complaining about lack of the new props, will be deleted on jpo-31059_modal_close_behaviour_controls cleanup
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(modal.component, {
            key: modal.key,
            onClose: modal.close
        });
    })));
}

});



parcelRegister("ivvwC", function(module, exports) {

$parcel$export(module.exports, "UserContainers", () => $0fd080febb09e205$export$c1b371eec908681a);

var $5uXOq = parcelRequire("5uXOq");

var $d9VAQ = parcelRequire("d9VAQ");

var $leRCk = parcelRequire("leRCk");
const $0fd080febb09e205$export$c1b371eec908681a = ({ baseUrl: baseUrl, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $leRCk.UserContainer), {
        isGlobal: true,
        baseUrl: baseUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9VAQ.UserPreferencesContainer), {
        isGlobal: true
    }, children));

});
parcelRegister("d9VAQ", function(module, exports) {

$parcel$export(module.exports, "UserPreferencesContainer", () => $3038471ea054300f$export$aa278641ded1adf);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $51nlc = parcelRequire("51nlc");

var $eYegl = parcelRequire("eYegl");
const $3038471ea054300f$export$be74e04eaea4530 = (0, $51nlc.createSubscriber)((0, $eYegl.default), {
    displayName: 'UserPreferencesSubscriber'
});
const $3038471ea054300f$export$aa278641ded1adf = (0, $gg7kZ.createContainer)((0, $eYegl.default));

});
parcelRegister("eYegl", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc414d73e667f785$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iXqE5 = parcelRequire("iXqE5");

var $7AJyg = parcelRequire("7AJyg");
const $bc414d73e667f785$var$initialState = {
    'issue-view-experiment': {
        data: {
            value: false
        },
        loading: false,
        error: null
    }
};
var // @ts-expect-error - TS2344 - Type 'typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/user-preferences/src/actions/index")' does not satisfy the constraint 'Record<string, ActionThunk<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/user-preferences/src/actions/index")>>'.
$bc414d73e667f785$export$2e2bcd8739ae039 = (0, $iXqE5.createStore)({
    name: 'user-preference',
    initialState: $bc414d73e667f785$var$initialState,
    actions: $7AJyg
});

});
parcelRegister("7AJyg", function(module, exports) {

$parcel$export(module.exports, "fetch", () => (parcelRequire("g6Vt5")).default);
$parcel$export(module.exports, "fetchIssueCreate", () => (parcelRequire("ePV4l")).default);
$parcel$export(module.exports, "updateExperiment", () => (parcelRequire("8Lrq8")).default);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $g6Vt5 = parcelRequire("g6Vt5");

var $ePV4l = parcelRequire("ePV4l");

var $8Lrq8 = parcelRequire("8Lrq8");

});
parcelRegister("g6Vt5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a561c8a03710a3f2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $goEOn = parcelRequire("goEOn");
var /**
 * Initiates data retrieval for a user preference, ensuring no duplicate requests are made.
 * Updates the application state with retrieved data or an error, accordingly.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$a561c8a03710a3f2$export$2e2bcd8739ae039 = (preferenceKey)=>async ({ setState: setState, getState: getState }, { baseUrl: baseUrl })=>{
        const currentState = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<State>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<State>'.
        if (currentState[preferenceKey] && currentState[preferenceKey].loading) return;
        setState({
            [preferenceKey]: {
                data: currentState.data,
                loading: true,
                error: null
            }
        });
        try {
            const data = await (0, $goEOn.default)({
                baseUrl: baseUrl,
                preferenceKey: preferenceKey
            });
            setState({
                [preferenceKey]: {
                    data: data,
                    loading: false,
                    error: null
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                [preferenceKey]: {
                    data: getState().data,
                    loading: false,
                    error: err
                }
            });
        }
    };

});
parcelRegister("goEOn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0be3c96b3fac1b7f$export$2e2bcd8739ae039);

var $4Lzq2 = parcelRequire("4Lzq2");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0be3c96b3fac1b7f$export$2e2bcd8739ae039 = async ({ baseUrl: baseUrl, preferenceKey: preferenceKey })=>{
    try {
        const result = await (0, $4Lzq2.default)(baseUrl, preferenceKey);
        return {
            value: result
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        if (e.statusCode === 404) return {
            value: undefined
        };
        throw e;
    }
};

});
parcelRegister("4Lzq2", function(module, exports) {

$parcel$export(module.exports, "default", () => $efdd8b3604a0d493$export$2e2bcd8739ae039);

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$efdd8b3604a0d493$export$2e2bcd8739ae039 = (baseUrl, key)=>{
    const requestUrl = `${baseUrl}/rest/api/3/mypreferences?key=${key}`;
    return (0, $eusud.performGetRequest)(requestUrl);
};

});



parcelRegister("ePV4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $01fcb0eb90bce4cf$export$2e2bcd8739ae039);

var $g6Vt5 = parcelRequire("g6Vt5");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$01fcb0eb90bce4cf$export$2e2bcd8739ae039 = ()=>(0, $g6Vt5.default)('issue-create');

});

parcelRegister("8Lrq8", function(module, exports) {

$parcel$export(module.exports, "default", () => $aea442a302ef98b1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$aea442a302ef98b1$export$2e2bcd8739ae039 = (experimentKey, value)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: { data: { value: boolean; }; loading: false; error: null; }; }' is not assignable to parameter of type 'Partial<State>'.
        setState({
            [experimentKey]: {
                data: {
                    value: value
                },
                loading: false,
                error: null
            }
        });
    };

});






parcelRegister("62C9r", function(module, exports) {

$parcel$export(module.exports, "HorizontalNav", () => $df8ca37c4f42ad24$export$3821fe730064297d);
$parcel$export(module.exports, "HorizontalNavWrapper", () => $df8ca37c4f42ad24$export$8798384053a023ae);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $cPiXk = parcelRequire("cPiXk");

var $5HBvJ = parcelRequire("5HBvJ");

var $2Ioew = parcelRequire("2Ioew");


var $l8ruj = parcelRequire("l8ruj");

var $7CMCs = parcelRequire("7CMCs");

var $frBVt = parcelRequire("frBVt");

var $5NiYd = parcelRequire("5NiYd");

var $3HwlS = parcelRequire("3HwlS");

var $erBFB = parcelRequire("erBFB");
const $df8ca37c4f42ad24$var$NavErrorBoundaryFallback = ()=>// null = equivalent of "unmount"
    // We should do more graceful degradation.
    // Let's review this after dogfooding:
    // Tracked https://hello.jira.atlassian.cloud/browse/SEA-3059
    null;
const $df8ca37c4f42ad24$var$entrypointContainerProps = {};
const $df8ca37c4f42ad24$export$3821fe730064297d = ()=>{
    const HorizontalNavComponent = (0, $cPiXk.useHorizontalNavComponent)();
    // Consume the horizontal nav entry point if defined, otherwise fallback to the old horizontal nav component
    const horizontalNavEntryPointReference = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$948d4d345566aed3));
    const horizontalNavFallback = horizontalNavEntryPointReference?.extraProps?.fallback || (0, $5NiYd.HorizontalNavSkeleton);
    if (horizontalNavEntryPointReference && (0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HBvJ.NavErrorBoundary), {
        packageName: "page-container",
        id: "projectNavigationSkipLink",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.ProjectViewNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "horizontal-nav-through-entry-point"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "horizontal-nav-through-entry-point",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointReferencePlaceholder), {
        name: "horizontal-nav-through-entry-point",
        fallback: horizontalNavFallback(),
        entryPointReference: horizontalNavEntryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: horizontalNavEntryPointReference,
        props: $df8ca37c4f42ad24$var$entrypointContainerProps
    })))));
    return HorizontalNavComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HBvJ.NavErrorBoundary), {
        packageName: "page-container",
        id: "spa-horizontal-nav",
        fallback: $df8ca37c4f42ad24$var$NavErrorBoundaryFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HBvJ.NavErrorBoundary), {
        packageName: "page-container",
        id: "projectNavigationSkipLink",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.ProjectViewNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HorizontalNavComponent, null));
};
const $df8ca37c4f42ad24$export$8798384053a023ae = ({ children: children, navComponent: HorizontalNavComponent })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df8ca37c4f42ad24$var$ThemedContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HBvJ.NavErrorBoundary), {
        packageName: "page-container",
        id: "spa-horizontal-nav",
        fallback: $df8ca37c4f42ad24$var$NavErrorBoundaryFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HBvJ.NavErrorBoundary), {
        packageName: "page-container",
        id: "projectNavigationSkipLink",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.ProjectViewNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HorizontalNavComponent, null)), children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df8ca37c4f42ad24$var$ThemedContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7mmei _1reo15vq _18m915vq _11q31r52",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5HBvJ", function(module, exports) {

$parcel$export(module.exports, "NavErrorBoundary", () => $4c38307f7d6b54b7$export$afc779e659fd533f);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $jcw0u = parcelRequire("jcw0u");

var $7XYc4 = parcelRequire("7XYc4");

var $3HwlS = parcelRequire("3HwlS");
const $4c38307f7d6b54b7$export$1d1321d2b374d697 = ()=>{
    if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
    if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
    return false;
};
function $4c38307f7d6b54b7$var$inferNavRevision() {
    // This is brittle since we have several FFs https://hello.atlassian.net/wiki/spaces/SEA/pages/3841892327/Jira+Nav+v4+Feature+Flags
    // if possible, try to pass the revision explicitly as a prop
    return (0, $3HwlS.getWillShowNav4)() ? 'v4' : 'v3';
}
function $4c38307f7d6b54b7$var$getExtraAttributes(_error) {
    const attributes = {
        rev: $4c38307f7d6b54b7$var$inferNavRevision()
    };
    return attributes;
}
function $4c38307f7d6b54b7$var$getAnalyticsPayload(error, meta, navRevision) {
    const payload = {
        error: error,
        meta: {
            // intentionally fixed metas
            // so that we generate a unique event signature
            // so that we can register it in the analytics portal: https://data-portal.internal.atlassian.com/analytics/registry/67955
            // so that we get the attributes to show up in Splunk: https://splunk.paas-inf.net/en-GB/app/search/2024_sea2744_jira_nav_v4_container_navigation
            id: 'logic',
            packageName: 'JiraNav'
        },
        attributes: {
            ...$4c38307f7d6b54b7$var$getExtraAttributes(error),
            // forward the original meta as attributes to identify the location
            pkg: meta.packageName,
            id: meta.id,
            // if explicitly passed, override the rev
            ...navRevision && {
                rev: navRevision
            }
        },
        skipSentry: true
    };
    return payload;
}
const $4c38307f7d6b54b7$export$5ac21f1e947e70d6 = (props)=>{
    const { id: id, packageName: packageName, navRevision: navRevision } = props;
    const onError = (0, $5uXOq.useMemo)(()=>{
        const meta = {
            id: id,
            packageName: packageName
        };
        const _onError = (...args)=>{
            if ($4c38307f7d6b54b7$export$1d1321d2b374d697()) // this is a local test environment, don't send anything
            return;
            const [_, error] = args;
            (0, $jcw0u.default)($4c38307f7d6b54b7$var$getAnalyticsPayload(error, meta, navRevision));
        };
        return _onError;
    }, [
        id,
        packageName,
        navRevision
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        ...props,
        onError: onError
    });
};
const $4c38307f7d6b54b7$export$afc779e659fd533f = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4c38307f7d6b54b7$export$5ac21f1e947e70d6, props), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), props));

});

parcelRegister("erBFB", function(module, exports) {

$parcel$export(module.exports, "TopNavigationSkipLink", () => $cd61d83e2e343ff1$export$47de2191d46337b7);
$parcel$export(module.exports, "LeftSidebarSkipLink", () => $cd61d83e2e343ff1$export$46697df0d7c5e8be);
$parcel$export(module.exports, "ProjectViewNavigationSkipLink", () => $cd61d83e2e343ff1$export$2e2fc9c237996c06);
$parcel$export(module.exports, "MainContentSkipLink", () => $cd61d83e2e343ff1$export$b1498dd122ea3284);

var $koVbs = parcelRequire("koVbs");

var $iqLcb = parcelRequire("iqLcb");

var $lOt1w = parcelRequire("lOt1w");
const $cd61d83e2e343ff1$export$47de2191d46337b7 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $iqLcb.useCustomSkipLink)('ak-jira-navigation', formatMessage((0, $lOt1w.default).skipToJiraNavigation), 0);
    return null;
};
const $cd61d83e2e343ff1$export$46697df0d7c5e8be = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $iqLcb.useCustomSkipLink)('ak-side-navigation', formatMessage((0, $lOt1w.default).skipToSideNavigation), 1);
    return null;
};
const $cd61d83e2e343ff1$export$2e2fc9c237996c06 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $iqLcb.useCustomSkipLink)('ak-project-view-navigation', formatMessage((0, $lOt1w.default).skipToProjectViewNavigation), 2);
    return null;
};
const $cd61d83e2e343ff1$export$b1498dd122ea3284 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $iqLcb.useCustomSkipLink)('ak-main-content', formatMessage((0, $lOt1w.default).skipToMainContent), 3);
    return null;
};

});
parcelRegister("lOt1w", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d368a0de790f751$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2d368a0de790f751$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    skipToJiraNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-jira-navigation",
        "defaultMessage": "Skip to Jira Navigation"
    },
    skipToSideNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-side-navigation",
        "defaultMessage": "Skip to Side Navigation"
    },
    skipToProjectViewNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-project-view-navigation",
        "defaultMessage": "Skip to View Navigation"
    },
    skipToMainContent: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-main-content",
        "defaultMessage": "Skip to Main Content"
    }
});

});



parcelRegister("4s15Z", function(module, exports) {

$parcel$export(module.exports, "RightSidebar", () => $ac6bd493ba1cffad$export$84d58c19c21f637f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");


var $2Ioew = parcelRequire("2Ioew");

var $frBVt = parcelRequire("frBVt");

var $7CMCs = parcelRequire("7CMCs");

var $7XYc4 = parcelRequire("7XYc4");

var $hsmeR = parcelRequire("hsmeR");

var $3HwlS = parcelRequire("3HwlS");

var $iqLcb = parcelRequire("iqLcb");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $aPfsS = parcelRequire("aPfsS");

var $ozeZW = parcelRequire("ozeZW");

var $l8ruj = parcelRequire("l8ruj");
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 * It's only added once the component is rendered client-side.
 */ const $ac6bd493ba1cffad$var$TEST_ID = 'page-layout.aside';
/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $ac6bd493ba1cffad$var$routeComponents = [];
const $ac6bd493ba1cffad$var$SharedRightSidebars = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $aPfsS.renderGlobalComponents)((0, $ozeZW.sharedLayout).rightSidebars));
const $ac6bd493ba1cffad$var$RightSidebarRouteComponents = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $aPfsS.renderGlobalComponents)(route.layout?.rightSidebars || $ac6bd493ba1cffad$var$routeComponents));
};
const $ac6bd493ba1cffad$export$fb85bbdbfb3e6869 = ()=>null;
const $ac6bd493ba1cffad$var$RightSidebarThroughEntrypoint = ()=>{
    const rightSideBarEntryPointReference = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb));
    if (!rightSideBarEntryPointReference) return null;
    const rightSideBarFallback = rightSideBarEntryPointReference?.extraProps?.fallback || $ac6bd493ba1cffad$export$fb85bbdbfb3e6869;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "right-sidebar-through-entrypoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-through-entrypoint",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointReferencePlaceholder), {
        name: "right-sidebar-through-entrypoint",
        fallback: rightSideBarFallback(),
        entryPointReference: rightSideBarEntryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: rightSideBarEntryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    }))));
};
const $ac6bd493ba1cffad$var$NewRightSidebar = ()=>{
    const lastPanelIdRef = (0, $5uXOq.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
            panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
            isClosed: rightSidebarCurrentState?.panelId == null,
            isMinimised: !!rightSidebarCurrentState?.isMinimised,
            isCollapsed: !!rightSidebarCurrentState?.isCollapsed
        });
        lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
    }, [
        createAnalyticsEvent,
        rightSidebarCurrentState?.panelId,
        rightSidebarCurrentState?.isMinimised,
        rightSidebarCurrentState?.isCollapsed
    ]);
    if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.RightPanel), {
        width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0,
        testId: $ac6bd493ba1cffad$var$TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-right-sidebars",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$SharedRightSidebars, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-route-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarRouteComponents, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarThroughEntrypoint, null))));
};
/**
 * Manages visibility and behavior of the right sidebar in the user interface, adapting to user interactions and system events. It enhances user experience by providing dynamic control over the sidebar's presentation, including features for collapsing and minimizing, alongside tracking user interactions for analytical purposes.
 */ const $ac6bd493ba1cffad$var$OldRightSidebar = ()=>{
    const lastPanelIdRef = (0, $5uXOq.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
            panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
            isClosed: rightSidebarCurrentState?.panelId == null,
            isMinimised: !!rightSidebarCurrentState?.isMinimised,
            isCollapsed: !!rightSidebarCurrentState?.isCollapsed
        });
        lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
    }, [
        createAnalyticsEvent,
        rightSidebarCurrentState?.panelId,
        rightSidebarCurrentState?.isMinimised,
        rightSidebarCurrentState?.isCollapsed
    ]);
    if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarPanelWrapper, {
        id: "right-sidebar-panel-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.RightSidebar), {
        width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-right-sidebars",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$SharedRightSidebars, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-route-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarRouteComponents, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac6bd493ba1cffad$var$RightSidebarThroughEntrypoint, null)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ac6bd493ba1cffad$var$RightSidebarPanelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1bgi _iu1g1fl4 _1ej2b4wl",
            __cmplp.className
        ])
    });
});
const $ac6bd493ba1cffad$export$84d58c19c21f637f = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $ac6bd493ba1cffad$var$NewRightSidebar, $ac6bd493ba1cffad$var$OldRightSidebar);

});

parcelRegister("eF0qp", function(module, exports) {

$parcel$export(module.exports, "Sidebar", () => $803f61b5dea1399f$export$1ba59dacbcbf90fe);

var $fZBia = parcelRequire("fZBia");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ajpes = parcelRequire("ajpes");

var $8Uumt = parcelRequire("8Uumt");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $2s57o = parcelRequire("2s57o");

var $jF7K5 = parcelRequire("jF7K5");

var $5e7oM = parcelRequire("5e7oM");

var $azzrO = parcelRequire("azzrO");

var $gwIPs = parcelRequire("gwIPs");

var $7CMCs = parcelRequire("7CMCs");

var $7XYc4 = parcelRequire("7XYc4");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $aWse0 = parcelRequire("aWse0");

var $gPQRI = parcelRequire("gPQRI");

var $5e5zm = parcelRequire("5e5zm");

var $2fwuR = parcelRequire("2fwuR");

var $acDan = parcelRequire("acDan");

var $c6x3L = parcelRequire("c6x3L");

var $3HwlS = parcelRequire("3HwlS");

var $4DrQd = parcelRequire("4DrQd");

var $eGkew = parcelRequire("eGkew");

var $iqLcb = parcelRequire("iqLcb");

var $lfTZh = parcelRequire("lfTZh");

var $6jY6G = parcelRequire("6jY6G");

var $ao2h1 = parcelRequire("ao2h1");

var $5M3R9 = parcelRequire("5M3R9");

var $4V52L = parcelRequire("4V52L");

var $16v4H = parcelRequire("16v4H");

var $cZpsT = parcelRequire("cZpsT");

var $DVljb = parcelRequire("DVljb");

var $l8ruj = parcelRequire("l8ruj");

var $isowN = parcelRequire("isowN");
var $jN4ko = parcelRequire("jN4ko");
var $jW8hD = parcelRequire("jW8hD");

var $ht71P = parcelRequire("ht71P");

var $5gylp = parcelRequire("5gylp");

var $erBFB = parcelRequire("erBFB");

var $gxq4u = parcelRequire("gxq4u");

var $7x18A = parcelRequire("7x18A");
const $803f61b5dea1399f$var$footerStyles = {
    root: "_bfhkhp5a"
};
const $803f61b5dea1399f$var$SidebarNew = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $2fwuR.sidebarNav4UiStateResource));
    if (isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "sidebar.anonymous"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.PlaceholderNew), {
        name: "nav4-ignore.sidebar.anonymous"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarInternalAnonymous, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4.sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.PlaceholderNew), {
        name: "nav4-ignore.sidebar"
    }, queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarInternal, {
        queryReference: queryReference
    }) : null));
};
const $803f61b5dea1399f$var$SidebarInternalAnonymous = ()=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const defaultCollapsed = false;
    const defaultWidth = 340;
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $5e5zm.useLayoutStoreActions)();
    const onExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: false
        });
    }, [
        setLeftSidebarState
    ]);
    const onCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: true
        });
    }, [
        setLeftSidebarState
    ]);
    const onResizeEnd = (0, $5uXOq.useCallback)(({ finalWidth: finalWidth })=>{
        setLeftSidebarState({
            width: finalWidth
        });
    }, [
        setLeftSidebarState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c6x3L.SidebarNav4ContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jN4ko.SideNav), {
        testId: $803f61b5dea1399f$var$TEST_ID,
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        onExpand: onExpand,
        onCollapse: onCollapse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gylp.SidebarEntryPointSelector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isowN.PanelSplitter), {
        label: formatMessage((0, $gxq4u.messages).sideBarPanelSplitterLabel),
        onResizeEnd: onResizeEnd,
        testId: "page-container-v2.common.ui.sidebar.panel-splitter"
    })));
};
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 */ const $803f61b5dea1399f$var$TEST_ID = 'page-layout.sidebar';
const $803f61b5dea1399f$var$SidebarInternal = ({ queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const subProduct = (0, $16v4H.useSubProduct)();
    const data = (0, $8Uumt.usePreloadedQuery)((0, $fZBia.default), queryReference); /*
                                                                                               	Backend may respond with an error with the reason as Navigation UI state user property does not exist
                                                                                               	under a scenario where a new user joins an existing Jira site.
                                                                                               	When this happens, UI would not have data coming through from sidebarSelectorQuery.
                                                                                               	So, default values are used in such a case.
                                                                                               */ 
    const defaultCollapsed = data?.jira?.navigationUIState?.isLeftSidebarCollapsed ?? (0, $4DrQd.IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT);
    const defaultWidth = data?.jira?.navigationUIState?.leftSidebarWidth ?? (0, $4DrQd.LEFT_SIDEBAR_EXPANDED_MIN_WIDTH);
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $5e5zm.useLayoutStoreActions)();
    const onExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: false
        });
    }, [
        setLeftSidebarState
    ]);
    const onCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        if (screen === 'desktop') setLeftSidebarState({
            isCollapsed: true
        });
    }, [
        setLeftSidebarState
    ]);
    const onResizeEnd = (0, $5uXOq.useCallback)(({ finalWidth: finalWidth })=>{
        setLeftSidebarState({
            width: finalWidth
        });
    }, [
        setLeftSidebarState
    ]);
    const locale = (0, $DVljb.useLocale)();
    const showPersistentInvite = // Ensure that we can turn off the locale check with a feature gate if needed
    // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('navx_persistent_invite_jira_new_non_free') && // Do not trigger an exposure on the experiment for non-English locales
    (locale?.toLowerCase().startsWith('en') ?? false) && (0, $6s1PB.expVal)('navx_persistent_invite_jira_new_non_free_exp', 'global_invite_enabled', false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c6x3L.SidebarNav4ContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jN4ko.SideNav), {
        testId: $803f61b5dea1399f$var$TEST_ID,
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        onExpand: onExpand,
        onCollapse: onCollapse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gylp.SidebarEntryPointSelector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jW8hD.SideNavFooter), {
        xcss: $803f61b5dea1399f$var$footerStyles.root
    }, showPersistentInvite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $803f61b5dea1399f$var$globalInviteButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jF7K5.GlobalInvite), {
        testId: "page-container-v2.common.ui.sidebar.global-invite",
        product: "jira",
        subProduct: subProduct ?? undefined,
        showFlag: showFlag
    }, formatMessage((0, $gxq4u.messages).globalInviteButtonLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4V52L.SidebarFeedbackButton), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4V52L.SidebarFeedbackButton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isowN.PanelSplitter), {
        label: formatMessage((0, $gxq4u.messages).sideBarPanelSplitterLabel),
        onResizeEnd: onResizeEnd,
        testId: "page-container-v2.common.ui.sidebar.panel-splitter"
    }), (0, $4R6GH.fg)('cc-onboarding-nudge-confluence-bundled-users-gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ht71P.AsyncNudgeBundledUsersFlagContainer), null)));
};
const $803f61b5dea1399f$var$SIDEBAR_TEST_ID = 'ContextualNavigation';
const $803f61b5dea1399f$var$SIDEBAR_TRACE_KEY = 'sidebar';
const $803f61b5dea1399f$var$sidebarOverrides = {
    ResizeButton: {
        render: (Component, props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
                id: "sidebar-resize-tooltip",
                packageName: "page-container",
                fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
                name: "side_bar_button",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7x18A.AsyncResizeButtonTooltip), {
                isLeftSidebarCollapsed: props.isLeftSidebarCollapsed
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props))))
    }
};
const $803f61b5dea1399f$var$SidebarInternalOld = ({ sidebar: sidebar })=>{
    const { width: width, isCollapsed: isCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const intl = (0, $aWse0.useIntlV2)();
    const shouldNotRenderSidebarInServerSide = false && isCollapsed;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "left-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarStyleOverrides, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "leftSidebarSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.LeftSidebarSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.LeftSidebar), {
        isFixed: true,
        width: width,
        testId: $803f61b5dea1399f$var$SIDEBAR_TEST_ID,
        resizeButtonLabel: intl.formatMessage((0, $gxq4u.messages).sidebarNavigation),
        collapsedState: isCollapsed ? 'collapsed' : 'expanded',
        overrides: $803f61b5dea1399f$var$sidebarOverrides,
        id: "ak-side-navigation"
    }, !shouldNotRenderSidebarInServerSide && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, route !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        type: "start",
        traceKey: $803f61b5dea1399f$var$SIDEBAR_TRACE_KEY
    })), sidebar, route !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavSidebarSSRPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        type: "end",
        traceKey: $803f61b5dea1399f$var$SIDEBAR_TRACE_KEY
    })))), (0, $4R6GH.fg)('cc-onboarding-nudge-confluence-bundled-users-gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ht71P.AsyncNudgeBundledUsersFlagContainer), null)));
};
const $803f61b5dea1399f$var$SidebarInternalOldMemo = /*#__PURE__*/ (0, $5uXOq.memo)($803f61b5dea1399f$var$SidebarInternalOld, (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))); // moved children as function outside the `Sidebar` so that the function is not re-created every time `Sidebar` is re-rendered.
const $803f61b5dea1399f$var$renderChildren = (sidebar)=>sidebar !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($803f61b5dea1399f$var$SidebarInternalOldMemo, {
        sidebar: sidebar
    }) : null;
const $803f61b5dea1399f$var$SidebarOld = ()=>{
    const { shouldRender: shouldRender } = (0, $gPQRI.useLeftSidebarState)();
    const route = (0, $6jY6G.useCurrentRoute)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGkew.SidebarSelectorProvider), {
        sidebar: route.navigation?.sidebar ?? null
    }, $803f61b5dea1399f$var$renderChildren);
};
const $803f61b5dea1399f$export$1ba59dacbcbf90fe = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $803f61b5dea1399f$var$SidebarNew, $803f61b5dea1399f$var$SidebarOld); /**
                                                                                         * In the @atlaskit/page-layout, resize control uses button for
                                                                                         * the grab area. At the same time, legacy batch.css reset all
                                                                                         * the button to have a box-shadow when focused. So when user
                                                                                         * resizing the sidebar, they will see two blue lines around
                                                                                         * the grab area.
                                                                                         */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $803f61b5dea1399f$var$SidebarStyleOverrides = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1d7w7yr": (0, $lD23V.default)((0, $gwIPs.layers).leftSidebar)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1pbyg9ti _14c1glyw",
            __cmplp.className
        ])
    });
});
const $803f61b5dea1399f$var$globalInviteButtonStyles = (0, $2s57o.xcss)({
    flexGrow: 1
});

});
parcelRegister("jF7K5", function(module, exports) {

$parcel$export(module.exports, "GlobalInvite", () => $99319ef0f44cbcec$export$93cb436db3d27b7e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $gvznG = parcelRequire("gvznG");

var $1lcQ6 = parcelRequire("1lcQ6");

var $1ne4p = parcelRequire("1ne4p");

const $99319ef0f44cbcec$var$LazyGlobalInviteModalDialogContent = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("aRIkw")).then((module)=>({
            default: module.ModalDialogContent
        })));
function $99319ef0f44cbcec$var$AsyncGlobalInviteModalDialogContent(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gvznG.ErrorState), {}),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1lcQ6.LoadingState), {}),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($99319ef0f44cbcec$var$LazyGlobalInviteModalDialogContent, {
                ...props
            })
        })
    });
}
const $99319ef0f44cbcec$export$93cb436db3d27b7e = (0, $1ne4p.withModalDialog)($99319ef0f44cbcec$var$AsyncGlobalInviteModalDialogContent);

});
parcelRegister("gvznG", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $1efd4f4bfdd7abd0$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bWfiu = parcelRequire("bWfiu");

var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $inX3V = parcelRequire("inX3V");
const $1efd4f4bfdd7abd0$var$styles = (0, $2s57o.xcss)({
    paddingBlock: 'space.1000',
    paddingInline: 'space.100',
    textAlign: 'center'
});
function $1efd4f4bfdd7abd0$export$c1ed4f415b9e7023() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bEIgH.default), {
        space: "space.050",
        testId: "global-invite--error-state",
        xcss: $1efd4f4bfdd7abd0$var$styles,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                size: "xsmall",
                children: formatMessage((0, $inX3V.messages).errorStateHeading)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6eFvr.default), {
                size: "small",
                color: "color.text.subtle",
                children: formatMessage((0, $inX3V.messages).errorStateDescription)
            })
        ]
    });
}

});
parcelRegister("inX3V", function(module, exports) {

$parcel$export(module.exports, "messages", () => $10acfd84e29e78b4$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $10acfd84e29e78b4$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    errorStateHeading: {
        id: 'navigation.global-invite.error-state-heading',
        description: "Heading of the error state UI indicating we couldn't load the invite people widget.",
        defaultMessage: "We can't load the invite list right now"
    },
    errorStateDescription: {
        id: 'navigation.global-invite.error-state-description',
        description: "Description of the error state UI indicating we couldn't load the invite people widget.",
        defaultMessage: 'Try refreshing the page or contact us if the problem persists.'
    }
});

});


parcelRegister("1lcQ6", function(module, exports) {

$parcel$export(module.exports, "LoadingState", () => $93f44098250ba83c$export$62aa48085237e36f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $0yZbT = parcelRequire("0yZbT");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");

var $4CMbn = parcelRequire("4CMbn");

var $cBCgC = parcelRequire("cBCgC");

var $jSFiv = parcelRequire("jSFiv");
const $93f44098250ba83c$var$styles = (0, $2s57o.xcss)({
    paddingBlock: 'space.500',
    paddingInline: 'space.300'
});
function $93f44098250ba83c$export$62aa48085237e36f() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const items = Array.from({
        length: 5
    }, (_, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4CMbn.default), {
            isShimmering: true,
            width: "100%",
            height: "var(--ds-space-200, 16px)",
            testId: "skeleton-shimmering"
        }, index));
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $0yZbT.default), {
        xcss: $93f44098250ba83c$var$styles,
        testId: "global-invite--loading-state",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
                children: formatMessage((0, $jSFiv.messages).loadingLabel)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bEIgH.default), {
                space: "space.100",
                testId: "skeleton-group",
                children: items
            })
        ]
    });
}

});
parcelRegister("jSFiv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $606f2875c5abf5c4$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $606f2875c5abf5c4$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    loadingLabel: {
        id: 'navigation.global-invite.loading-visually-hidden-label',
        description: 'Visually hidden text to indicate the invite people UI is loading.',
        defaultMessage: 'Loading'
    }
});

});


parcelRegister("1ne4p", function(module, exports) {

$parcel$export(module.exports, "withModalDialog", () => $33369da4c421dea7$export$2d7d84d397d9a585);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bMFGq = parcelRequire("bMFGq");

var $6tzHJ = parcelRequire("6tzHJ");

var $jorqd = parcelRequire("jorqd");
var $hordk = parcelRequire("hordk");
var $g1QfP = parcelRequire("g1QfP");
var $kW74I = parcelRequire("kW74I");

var $eWkgo = parcelRequire("eWkgo");


var $4p7bM = parcelRequire("4p7bM");
const $33369da4c421dea7$var$styles = {
    close: "_ca0q1ejb"
};
function $33369da4c421dea7$export$2d7d84d397d9a585(Content) {
    return function ModalDialog({ testId: testId = (0, $ac32ac5f09147e78$export$bb76aeb9f599715c), triggerElement: TriggerElement, children: children, ...props }) {
        const { formatMessage: formatMessage } = (0, $koVbs.default)();
        const [isModalDialogOpen, setIsModalDialogOpen] = (0, $5uXOq.useState)(false);
        const openModalDialog = (0, $5uXOq.useCallback)(()=>{
            setIsModalDialogOpen(true);
        }, []);
        const closeModalDialog = (0, $5uXOq.useCallback)(()=>{
            setIsModalDialogOpen(false);
        }, []);
        const focusDialog = (0, $5uXOq.useCallback)((node)=>{
            // Focus the dialog's container when it finishes opening
            node.focus();
        }, []);
        return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            "data-testid": testId,
            children: [
                TriggerElement ? /*#__PURE__*/ (0, $2OMIu.jsx)(TriggerElement, {
                    onClick: openModalDialog
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMFGq.default), {
                    shouldFitContainer: true,
                    onClick: openModalDialog,
                    testId: `${testId}--${(0, $ac32ac5f09147e78$export$1dab7caa4b20a4cc)}`,
                    children: children
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kW74I.default), {
                    children: isModalDialogOpen ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hordk.default), {
                        width: "small",
                        shouldScrollInViewport: true,
                        shouldReturnFocus: true,
                        onClose: closeModalDialog,
                        onOpenComplete: focusDialog,
                        label: formatMessage((0, $4p7bM.messages).modalDialogLabel),
                        testId: `${testId}--${(0, $ac32ac5f09147e78$export$7622d28bacf170d1)}`,
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $g1QfP.default), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eWkgo.default), {
                                    justifyContent: "end",
                                    xcss: (0, $6tzHJ.cx)($33369da4c421dea7$var$styles.close),
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jorqd.CloseButton), {
                                        onClick: closeModalDialog
                                    })
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)(Content, {
                                    closeModalDialog: closeModalDialog,
                                    ...props
                                })
                            ]
                        })
                    }) : null
                })
            ]
        });
    };
}

});
const $ac32ac5f09147e78$export$bb76aeb9f599715c = 'global-invite';
const $ac32ac5f09147e78$export$7622d28bacf170d1 = 'modal-dialog';
const $ac32ac5f09147e78$export$1dab7caa4b20a4cc = 'trigger-element';

parcelRegister("4p7bM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $820bacb5c8977888$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $820bacb5c8977888$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    modalDialogLabel: {
        id: 'navigation.global-invite.modal-dialog-label',
        description: 'Accessible label of the modal dialog for assistive technologies users.',
        defaultMessage: 'Invite people'
    }
});

});


parcelRegister("aRIkw", function(module, exports) {

let $7e913d9e2b1be042$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7e913d9e2b1be042$var$load("6nYFs").then(()=>parcelRequire('4pl6C'));

});


parcelRegister("aWse0", function(module, exports) {

$parcel$export(module.exports, "useIntlV2", () => $6b28e3c9e1c89fbd$export$d82607073b68786);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");
const $6b28e3c9e1c89fbd$export$d82607073b68786 = ()=>{
    const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, $koVbs.default)();
    // Only recreate intl object if reference to originral intl changes.
    const memoisedIntl = (0, $5uXOq.useMemo)(()=>{
        const modifiedIntl = {
            messages: // @ts-expect-error - TS2322 - Type 'Record<string, string> | Record<string, MessageFormatElement[]>' is not assignable to type '{ [id: string]: string; }'.
            messages,
            locale: locale,
            formats: formats,
            formatDate: formatDate,
            formatMessage: formatMessage,
            formatNumber: formatNumber,
            formatPlural: formatPlural,
            formatTime: formatTime
        };
        return modifiedIntl;
    }, [
        formatDate,
        formatMessage,
        formatPlural,
        formatTime,
        formatNumber,
        formats,
        locale,
        messages
    ]);
    return memoisedIntl;
};

});

parcelRegister("eGkew", function(module, exports) {

$parcel$export(module.exports, "SidebarSelectorProvider", () => $8451f19a8196b45e$export$6af584355cfb32c6);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $2vSU6 = parcelRequire("2vSU6");

var $lpwtK = parcelRequire("lpwtK");

var $lGo7j = parcelRequire("lGo7j");

var $cin8p = parcelRequire("cin8p");

var $awp39 = parcelRequire("awp39");

var $b69Lc = parcelRequire("b69Lc");

var $dlYil = parcelRequire("dlYil");

var $jjzbO = parcelRequire("jjzbO");

var $hWtQt = parcelRequire("hWtQt");

var $jfqNX = parcelRequire("jfqNX");

var $gZbSF = parcelRequire("gZbSF");

var $dmKXV = parcelRequire("dmKXV");

var $iFaFr = parcelRequire("iFaFr");

var $4IWRY = parcelRequire("4IWRY");

var $hBv66 = parcelRequire("hBv66");

var $iHiHz = parcelRequire("iHiHz");

var $cOg46 = parcelRequire("cOg46");

var $7AyKX = parcelRequire("7AyKX");

var $koWFd = parcelRequire("koWFd");

var $937TY = parcelRequire("937TY");

var $lgSL3 = parcelRequire("lgSL3");

var $h0bZU = parcelRequire("h0bZU");

var $9s3j1 = parcelRequire("9s3j1");

var $2IHt2 = parcelRequire("2IHt2");

var $hz6Yb = parcelRequire("hz6Yb");

var $2YP9W = parcelRequire("2YP9W");
const $8451f19a8196b45e$var$renderProjectSidebar = ({ data: project, loading: loading })=>{
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
        isFull: true
    });
    if (!project) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2IHt2.default), null);
    switch(project.type){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
        case 0, $2vSU6.CUSTOMER_SERVICE_PROJECT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h0bZU.default), null);
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lgSL3.default), null);
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if (project.isSimplified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $koWFd.default), null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9s3j1.default), null);
        // delete when cleaning up getWillShowNav4
        case 0, $2vSU6.CORE_PROJECT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dmKXV.default), null);
        default:
            // TODO: render error
            return null;
    }
};
// Since argument of `renderProjectSidebar` is similar to `props` object of a React component
// so we can convert normal function to functional component
const $8451f19a8196b45e$var$ProjectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)($8451f19a8196b45e$var$renderProjectSidebar, (0, (/*@__PURE__*/$parcel$interopDefault($ajpes))));
const $8451f19a8196b45e$export$6af584355cfb32c6 = ({ sidebar: sidebar, children: children })=>{
    const projectState = (0, $lpwtK.useProject)();
    const isInsightMenuSelected = (0, $jjzbO.useInsight)();
    const shouldRenderInsightObjectSchemaSidebar = (0, $jjzbO.useInsightObjectSchemaSidebar)();
    const { selected: pSelected, loading: pLoading } = (0, $gZbSF.useProjectConnectItems)();
    const { selected: prSelected, loading: prLoading } = (0, $hWtQt.useProjectReportsConnectItems)();
    const { selected: psSelected, loading: psLoading } = (0, $jfqNX.useProjectSettingsConnectItems)();
    const { selected: gSelected, loading: gLoading } = (0, $dlYil.useGlobalConnectItems)();
    const { selected: gsSelected, loading: gsLoading } = (0, $b69Lc.useGlobalSettingsConnectItems)();
    const { selected: gssSelected, loading: gssLoading } = (0, $awp39.useGlobalSettingsSystemConnectItems)();
    const { data: gresData, loading: gresLoading } = (0, $2YP9W.useResource)((0, $hz6Yb.connectGeneralResources));
    const { sections: fgSections, loading: fgLoading } = (0, $4IWRY.useForgeGlobalPageItems)();
    // CHOOK-247 - move to 'servicedesk-cmdb-object-schema' route in packages/routes/src/ui/spa/servicedesk/cmdb/index.js
    // once new page is rolled out. Hard-coded here since it isn't possible to have the Route navigation.sidebar
    // property change dynamically at runtime.
    if (shouldRenderInsightObjectSchemaSidebar) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7AyKX.default), null));
    if (isInsightMenuSelected) // fullscreen connect with no sidebar
    return null;
    if (sidebar === (0, $937TY.default)) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $937TY.default), null));
    if (sidebar === (0, $iFaFr.default)) {
        if (fgLoading) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
            isFull: true
        }));
        if (fgSections?.length) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iFaFr.default), null));
        return children(null);
    }
    if (!Array.isArray(sidebar)) {
        const Sidebar = sidebar;
        return children(Sidebar != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Sidebar, null) : null);
    }
    if (sidebar === (0, $hBv66.genericConnectSidebars)) {
        const foundInProject = pSelected || prSelected || psSelected || [
            'jiraProjectAdminTabPanels'
        ].includes(gresData?.moduleType);
        const foundSomewhere = foundInProject || gSelected || gsSelected || gssSelected;
        const stillLoading = pLoading || prLoading || psLoading || gLoading || gsLoading || gssLoading || gresLoading;
        if (stillLoading && !foundSomewhere) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
            isFull: true
        }));
        if (foundInProject) {
            const projectSidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8451f19a8196b45e$var$ProjectSidebar, projectState);
            return children(projectSidebar);
        }
        if (gSelected) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cin8p.default), null));
        if (gsSelected || [
            'configurePage',
            'postInstallPage'
        ].includes(gresData?.moduleType)) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iHiHz.default), null));
        if (gssSelected || [
            'adminPages'
        ].includes(gresData?.moduleType)) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOg46.default), null));
        // not found, assume fullscreen connect with no sidebar
        return children(null);
    }
    const projectSidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8451f19a8196b45e$var$ProjectSidebar, projectState);
    return children(projectSidebar);
};

});
parcelRegister("b69Lc", function(module, exports) {

$parcel$export(module.exports, "useGlobalSettingsConnectItems", () => $ba4edc5b901e34a6$export$f0785b98c99d344c);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $aUDLa = parcelRequire("aUDLa");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $4gymV = parcelRequire("4gymV");

var $5W6pd = parcelRequire("5W6pd");
// use memoised functions per hook to avoid re-computation between same hooks
const $ba4edc5b901e34a6$var$getItemsMemo = (0, $8QpSo.default)((d)=>(0, $4gymV.getLinks)(d, [
        'admin_plugins_menu'
    ], {
        skipFilter: true
    })// remove sections also statically defined
    .filter((v)=>![
            'upm_section',
            'jpo-ws-admin'
        ].includes(v.id)).map((0, $5W6pd.transformLink)).filter(Boolean));
const $ba4edc5b901e34a6$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $ba4edc5b901e34a6$export$f0785b98c99d344c = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $aUDLa.useNavigationGlobalResource)();
    const items = (0, $5uXOq.useMemo)(()=>data && $ba4edc5b901e34a6$var$getItemsMemo(data), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $ba4edc5b901e34a6$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("dlYil", function(module, exports) {

$parcel$export(module.exports, "useGlobalConnectItems", () => $17cad8174f7acae6$export$ee355b2e42d6462b);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $aUDLa = parcelRequire("aUDLa");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $4gymV = parcelRequire("4gymV");

var $5W6pd = parcelRequire("5W6pd");
// use memoised functions per hook to avoid re-computation between same hooks
const $17cad8174f7acae6$var$getItemsMemo = (0, $8QpSo.default)((d)=>(0, $4gymV.getLinks)(d, [
        'global-navigation-product'
    ]).map((0, $5W6pd.transformLink)).filter((item)=>item != null && item.items));
const $17cad8174f7acae6$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $17cad8174f7acae6$export$ee355b2e42d6462b = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $aUDLa.useNavigationGlobalResource)();
    const sidebars = (0, $5uXOq.useMemo)(()=>data && $17cad8174f7acae6$var$getItemsMemo(data), [
        data
    ]);
    const searchResult = (0, $5uXOq.useMemo)(()=>{
        let result = {
            stack: [],
            selected: null,
            title: null,
            data: null
        };
        if (sidebars != null) sidebars.some((sidebar)=>{
            const { items: items } = sidebar || {};
            if (!sidebar || !route || items == null) return false;
            const found = $17cad8174f7acae6$var$findItemAndStackMemo(items, route.name, location);
            if (found) {
                // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'null'. | TS2322 - Type 'ConnectDataItem[]' is not assignable to type 'null'.
                result = {
                    ...found,
                    title: sidebar.name,
                    data: items
                };
                return true;
            }
            return false;
        });
        return result;
    }, [
        sidebars,
        route,
        location
    ]);
    return {
        ...searchResult,
        loading: loading,
        error: error
    };
};

});

parcelRegister("jjzbO", function(module, exports) {

$parcel$export(module.exports, "useInsight", () => $25e0b1dc21125803$export$e24dad0705701755);
$parcel$export(module.exports, "useInsightObjectSchemaSidebar", () => $25e0b1dc21125803$export$1f0bd21403710fc);

var $3HwlS = parcelRequire("3HwlS");

var $6jY6G = parcelRequire("6jY6G");
const $25e0b1dc21125803$export$e24dad0705701755 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    if (route.navigation) return route.navigation.menuId === 'INSIGHT';
    return false;
};
const $25e0b1dc21125803$export$1f0bd21403710fc = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    if ((0, $3HwlS.getWillShowNav4)()) return false;
    return route.name === 'servicedesk-cmdb-object-schema';
};

});

parcelRegister("hWtQt", function(module, exports) {

$parcel$export(module.exports, "useProjectReportsConnectItems", () => $a740427f233367ba$export$a1c75c386c088992);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
const $a740427f233367ba$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $a740427f233367ba$export$a1c75c386c088992 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectReportsSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data != null ? data.map((0, $5W6pd.transformLinkV4)).filter(Boolean) : [], [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $a740427f233367ba$var$findItemAndStackMemo(items, route.name, location, [
            'reports'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        error: error,
        loading: loading,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("jfqNX", function(module, exports) {

$parcel$export(module.exports, "useProjectSettingsConnectItems", () => $662340ab1e9d2787$export$41a50100db18b578);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
// use memoised functions per hook to avoid re-computation between same hooks
const $662340ab1e9d2787$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $662340ab1e9d2787$export$41a50100db18b578 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectSettingsSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, $5W6pd.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $662340ab1e9d2787$var$findItemAndStackMemo(items, route.name, location, [
            'settings'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("gZbSF", function(module, exports) {

$parcel$export(module.exports, "useProjectConnectItems", () => $fcf7bc53994ae8f3$export$f23d0c24c77d7608);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
const $fcf7bc53994ae8f3$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $fcf7bc53994ae8f3$export$f23d0c24c77d7608 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, $5W6pd.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $fcf7bc53994ae8f3$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("4IWRY", function(module, exports) {

$parcel$export(module.exports, "useForgeGlobalPageItems", () => $e660bc01a5db5a53$export$ff333fd2f0bf5254);

var $5uXOq = parcelRequire("5uXOq");

var $4NrfJ = parcelRequire("4NrfJ");

var $7Tlti = parcelRequire("7Tlti");

var $c70gQ = parcelRequire("c70gQ");

var $doZTA = parcelRequire("doZTA");
const $e660bc01a5db5a53$export$ff333fd2f0bf5254 = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const { data: modules, loading: loading, error: error } = (0, $4NrfJ.useGlobalForgeApps)();
    const extension = (0, $c70gQ.useMatchedExtension)({
        modules: modules,
        match: match
    });
    const sections = (0, $5uXOq.useMemo)(()=>extension && (0, $7Tlti.toSections)(extension), [
        extension
    ]);
    return {
        extension: extension,
        sections: sections,
        loading: loading,
        error: error
    };
};

});
parcelRegister("4NrfJ", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $7a76aaaa3a23f02a$export$ed6342e0e28465a6);
$parcel$export(module.exports, "useGlobalForgeApps", () => $7a76aaaa3a23f02a$export$f834c14187f80532);

var $5uXOq = parcelRequire("5uXOq");

var $e0AC8 = parcelRequire("e0AC8");

var $5cmSg = parcelRequire("5cmSg");

var $5bkvv = parcelRequire("5bkvv");

var $2YP9W = parcelRequire("2YP9W");
const $7a76aaaa3a23f02a$export$ed6342e0e28465a6 = (extension)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/apps/${appId}/${envId}`;
};
const $7a76aaaa3a23f02a$export$f834c14187f80532 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $5bkvv.forgeGlobalModuleResource));
    return (0, $5uXOq.useMemo)(()=>({
            data: data ? data.filter((0, $5cmSg.isExtensionVisible)) : null,
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});

parcelRegister("7Tlti", function(module, exports) {

$parcel$export(module.exports, "toSections", () => $25b31557e9750c03$export$29678d1e04c0e8c4);

var $8QpSo = parcelRequire("8QpSo");
/**
 * Just in case someone passes a broken object we don't want to blow up the sidebar
 */ const $25b31557e9750c03$var$normalizeSection = (section)=>({
        header: section?.header,
        pages: Array.isArray(section?.pages) ? section.pages.map((page)=>({
                icon: page?.icon,
                route: page?.route,
                title: page?.title
            })) : []
    });
const $25b31557e9750c03$export$29678d1e04c0e8c4 = (0, $8QpSo.default)((extension)=>{
    const { properties: properties } = extension;
    // Only Custom UI supports subpages
    if (typeof properties.resource !== 'string') return [];
    // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.pages !== 'undefined' && properties.pages?.length) // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return [
        {
            pages: properties.pages
        }
    ].map($25b31557e9750c03$var$normalizeSection);
    // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.sections !== 'undefined' && properties.sections?.length) // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return properties.sections.map($25b31557e9750c03$var$normalizeSection);
    return [];
});

});

parcelRegister("c70gQ", function(module, exports) {

$parcel$export(module.exports, "useMatchedExtension", () => $b661f1f04cec9385$export$13375c0abccaf6f6);
$parcel$export(module.exports, "useExtensionBasePath", () => $b661f1f04cec9385$export$25abed85383f0fbb);

var $5uXOq = parcelRequire("5uXOq");

var $e0AC8 = parcelRequire("e0AC8");
const $b661f1f04cec9385$export$13375c0abccaf6f6 = ({ modules: modules, match: match })=>(0, $5uXOq.useMemo)(()=>(modules || []).find((app)=>{
            const parsedExtensionId = (0, $e0AC8.parseExtensionId)(app.id);
            return parsedExtensionId.appId === match.params.appId && parsedExtensionId.envId === match.params.envId;
        }), [
        modules,
        match.params.appId,
        match.params.envId
    ]);
const $b661f1f04cec9385$export$25abed85383f0fbb = (baseUrl, route)=>route !== undefined ? baseUrl.replace(/\/?$/, '').slice(0, -route.length - 1) : baseUrl.replace(/\/?$/, '');

});


parcelRegister("7AyKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cf06d255b5e49f4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

const $6cf06d255b5e49f4$var$LazyInsightObjectSchemaSidebar = (0, $b7Svb.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("7p1kq")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/insight-object-schema/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6cf06d255b5e49f4$var$InsightObjectSchemaSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "insight-object-schema-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6cf06d255b5e49f4$var$LazyInsightObjectSchemaSidebar, null)));
$6cf06d255b5e49f4$var$InsightObjectSchemaSidebar.displayName = 'InsightObjectSchemaSidebar';
var $6cf06d255b5e49f4$export$2e2bcd8739ae039 = $6cf06d255b5e49f4$var$InsightObjectSchemaSidebar;

});
parcelRegister("7p1kq", function(module, exports) {

let $563be60290e7179c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $563be60290e7179c$var$load("92sUi"),
    $563be60290e7179c$var$load("i5RRW"),
    $563be60290e7179c$var$load("hPzOn"),
    $563be60290e7179c$var$load("a8Tkc")
]).then(()=>parcelRequire('48ZOK'));

});


parcelRegister("lgSL3", function(module, exports) {

$parcel$export(module.exports, "default", () => $756fa7b51ff3cfd4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $b7Svb = parcelRequire("b7Svb");

const $756fa7b51ff3cfd4$var$LazyPolarisProjectSidebar = (0, $b7Svb.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("5FN3v")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/polaris/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $756fa7b51ff3cfd4$var$PolarisProjectSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "polarisProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($756fa7b51ff3cfd4$var$LazyPolarisProjectSidebar, null)));
$756fa7b51ff3cfd4$var$PolarisProjectSidebar.displayName = 'PolarisProjectSidebar';
var $756fa7b51ff3cfd4$export$2e2bcd8739ae039 = $756fa7b51ff3cfd4$var$PolarisProjectSidebar;

});
parcelRegister("5FN3v", function(module, exports) {

let $4216d57c4bb96c55$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4216d57c4bb96c55$var$load("blsmD").then(()=>parcelRequire('aSh9m'));

});



parcelRegister("4V52L", function(module, exports) {

$parcel$export(module.exports, "SidebarFeedbackButton", () => $ea1c2dd9a94de02f$export$b270ed097d20c023);

var $5uXOq = parcelRequire("5uXOq");

var $bMFGq = parcelRequire("bMFGq");
var $1Seuh = parcelRequire("1Seuh");

var $k4cWJ = parcelRequire("k4cWJ");

var $8zIDr = parcelRequire("8zIDr");

var $5KCCi = parcelRequire("5KCCi");

var $6eFvr = parcelRequire("6eFvr");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $iSSFh = parcelRequire("iSSFh");

var $dkkQn = parcelRequire("dkkQn");

var $4DrQd = parcelRequire("4DrQd");

var $bw7Gm = parcelRequire("bw7Gm");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $DVljb = parcelRequire("DVljb");

var $83YFz = parcelRequire("83YFz");
function $ea1c2dd9a94de02f$export$b270ed097d20c023() {
    const environment = (0, $2tT7R.useEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { openFeedbackCollector: openFeedbackCollector, closeFeedbackCollector: closeFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const formattedMessageNode = (0, $5uXOq.useMemo)(()=>{
        if ((0, $4R6GH.fg)('blu-6965-nav-feedback-modal-link-update')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $83YFz.default).feedbackTitleDetailsNoLink)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zIDr.default), {
            href: "https://support.atlassian.com/jira-software-cloud/docs/what-is-the-new-navigation-in-jira/",
            onClick: closeFeedbackCollector,
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $83YFz.default).feedbackTitleLearnMoreLinkText)));
        const showFeedbackTitleDetailsWithLink = (0, $iSSFh.getWillShowNav4UserOptIn)() || (0, $dkkQn.getWillShowNav4UserOptOut)();
        return showFeedbackTitleDetailsWithLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $83YFz.default).feedbackTitleDetailsWithLink,
            values: {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zIDr.default), {
                        href: "/jira/settings/personal/general",
                        onClick: closeFeedbackCollector
                    }, chunks)
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $83YFz.default).feedbackTitleDetailsNoLink);
    }, [
        closeFeedbackCollector
    ]);
    const onClickHandler = (0, $5uXOq.useCallback)(()=>{
        openFeedbackCollector({
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_NAVIGATION_REFRESH),
            feedbackContext: [
                {
                    id: 'environment',
                    value: environment
                },
                {
                    id: 'cloud-id',
                    value: cloudId
                },
                {
                    id: 'location',
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    value: (0, $bw7Gm.default)(window?.location?.href ?? '')
                }
            ],
            feedbackGroupId: (0, $4DrQd.NAV4_GENERAL_FEEDBACK_GROUP_ID),
            feedbackTitle: formatMessage((0, $83YFz.default).feedbackTitle),
            feedbackTitleDetails: formattedMessageNode
        });
    }, [
        cloudId,
        environment,
        formatMessage,
        formattedMessageNode,
        openFeedbackCollector
    ]);
    const locale = (0, $DVljb.useLocale)();
    const showPersistentInvite = // Ensure that we can turn off the locale check with a feature gate if needed
    // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('navx_persistent_invite_jira_new_non_free') && // Do not trigger an exposure on the experiment for non-English locales
    (locale?.toLowerCase().startsWith('en') ?? false) && (0, $6s1PB.expVal)('navx_persistent_invite_jira_new_non_free_exp', 'global_invite_enabled', false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: formatMessage((0, $83YFz.default).sidebarFeedbackButtonLabel),
        position: "top"
    }, showPersistentInvite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($k4cWJ))),
        onClick: onClickHandler,
        label: formatMessage((0, $83YFz.default).sidebarFeedbackButtonLabel)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMFGq.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($k4cWJ))),
        appearance: "subtle",
        onClick: onClickHandler
    }, formatMessage((0, $83YFz.default).sidebarFeedbackButtonLabel)));
}

});
parcelRegister("k4cWJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c12e14f5c33454d538618fce8415497d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e9be39395faf2a13$var$_react = $e9be39395faf2a13$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e9be39395faf2a13$var$_baseNew = $e9be39395faf2a13$var$_interopRequireDefault((parcelRequire("enEmH")));
function $e9be39395faf2a13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e9be39395faf2a13$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $e9be39395faf2a13$var$_react.default.createElement($e9be39395faf2a13$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3.096a.5.5 0 0 0-.686-.464L7.5 4.758v4.734l5.314 2.126a.5.5 0 0 0 .686-.464zm-6 8.012 4.757 1.903A2 2 0 0 0 15 11.154V3.096a2 2 0 0 0-2.743-1.857L6.606 3.5H3a2 2 0 0 0-2 2v3.25a2 2 0 0 0 2 2h.5V13a2 2 0 0 0 2 2h1.25a.75.75 0 0 0 .75-.75zM6 9.25H3a.5.5 0 0 1-.5-.5V5.5A.5.5 0 0 1 3 5h3zm0 1.5v2.75h-.5A.5.5 0 0 1 5 13v-2.25z" clip-rule="evenodd"/>`
    }, props));
$e9be39395faf2a13$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $e9be39395faf2a13$var$_default = module.exports.default = $e9be39395faf2a13$var$MegaphoneIcon;

});

parcelRegister("iSSFh", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4UserOptIn", () => $b7ad847389ccec8d$export$46a00895da9889a2);

var $4R6GH = parcelRequire("4R6GH");

var $1i1R1 = parcelRequire("1i1R1");

var $7ZQ0U = parcelRequire("7ZQ0U");
const $b7ad847389ccec8d$export$46a00895da9889a2 = ()=>{
    if (!(0, $4R6GH.fg)('jira_nav4')) return false;
    // Previous stages were mutually exclusive. GA is not.
    // Therefore, we need to make sure the customer is not in another stage before showing user opt in.
    if ((0, $7ZQ0U.getIsInPreGaStage)()) return false;
    // Later GA phases eclipse earlier phases.
    if ((0, $4R6GH.fg)('jira_nav4_ga_phase-3') || (0, $4R6GH.fg)('jira_nav4_ga_phase-2')) return false;
    if ((0, $4R6GH.fg)('jira_nav4_ga_phase-1')) return (0, $1i1R1.getIsAdmin)();
    return (0, $4R6GH.fg)('jira_nav4_ga_sandboxes');
};

});
parcelRegister("7ZQ0U", function(module, exports) {

$parcel$export(module.exports, "getIsInPreGaStage", () => $57f16b943396f007$export$a57a1aacc1a1fc6e);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");
const $57f16b943396f007$export$a57a1aacc1a1fc6e = ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding') || (0, $4R6GH.fg)('jira_nav4_eap') || (0, $4R6GH.fg)('jira_nav4_beta_existing-customers') || (0, $4R6GH.fg)('jira_nav4_beta_sandboxes') || (0, $6s1PB.expVal)('jira_nav4_beta_free-customers', 'willShowNav4', false) || (0, $6s1PB.expVal)('jira_nav4_beta_new-customers', 'willShowNav4', false) || (0, $6s1PB.expVal)('confluence_jira_nav4_new_customers', 'willShowNav4', false);

});


parcelRegister("dkkQn", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4UserOptOut", () => $1db1544bbdad6d19$export$acb346134ed05173);

var $4R6GH = parcelRequire("4R6GH");

var $9Qkfw = parcelRequire("9Qkfw");

var $d1JDF = parcelRequire("d1JDF");

var $99Ynm = parcelRequire("99Ynm");
const $1db1544bbdad6d19$export$acb346134ed05173 = ()=>{
    // Pre-GA logic.
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('jira_nav4') && ((0, $9Qkfw.getWillShowNav4UserOptOutForDogfooding)() || (0, $4R6GH.fg)('jira_nav4_eap') || (0, $4R6GH.fg)('jira_nav4_beta_existing-customers')) || // User opt out is being shared with visual refresh. It should show if visual refresh is on regardless of nav4.
    (0, $d1JDF.getWillShowNav4UserOptOutForVisualRefresh)() && !(0, $4R6GH.fg)('nav4_visual_refresh_merger')) return true;
    if (!(0, $4R6GH.fg)('jira_nav4')) return false;
    return (0, $99Ynm.getWillShowNav4UserOptOutForGa)();
};

});
parcelRegister("9Qkfw", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4UserOptOutForDogfooding", () => $a6cd9fbcbab14454$export$9edbe3a98989e15b);

var $4R6GH = parcelRequire("4R6GH");
const $a6cd9fbcbab14454$export$9edbe3a98989e15b = ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding') && ((0, $4R6GH.fg)('jira_nav4_dogfooding_phase-1') || (0, $4R6GH.fg)('jira_nav4_dogfooding_phase-2'));

});

parcelRegister("d1JDF", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4UserOptOutForVisualRefresh", () => $1ed6defa01bf1a51$export$17e35ae7beae962d);

var $4R6GH = parcelRequire("4R6GH");
const $1ed6defa01bf1a51$export$17e35ae7beae962d = ()=>(0, $4R6GH.fg)('visual-refresh') && ((0, $4R6GH.fg)('visual-refresh-dogfood') || (0, $4R6GH.fg)('visual-refresh-eap') || (0, $4R6GH.fg)('visual-refresh-beta-existing-customers'));

});

parcelRegister("99Ynm", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4UserOptOutForGa", () => $fac91b2cf3168ada$export$6484838cfeef2f5);

var $4R6GH = parcelRequire("4R6GH");

var $1i1R1 = parcelRequire("1i1R1");

var $7ZQ0U = parcelRequire("7ZQ0U");
const $fac91b2cf3168ada$export$6484838cfeef2f5 = ()=>{
    // Previous stages were mutually exclusive. GA is not.
    // Therefore, we need to make sure the customer is not in another stage before showing user opt out.
    if ((0, $7ZQ0U.getIsInPreGaStage)()) return false;
    // Later GA phases eclipse earlier phases.
    if ((0, $4R6GH.fg)('jira_nav4_ga_phase-3')) return false;
    if ((0, $4R6GH.fg)('jira_nav4_ga_phase-2')) return true;
    if ((0, $4R6GH.fg)('jira_nav4_ga_phase-1')) return !(0, $1i1R1.getIsAdmin)() && (0, $1i1R1.getIsNav4TenantOptIn)();
    return false;
};

});


parcelRegister("83YFz", function(module, exports) {

$parcel$export(module.exports, "default", () => $583ab6a643d91da5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $583ab6a643d91da5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sidebarFeedbackButtonLabel: {
        "id": "sidebar-nav4-feedback-button.sidebar-feedback-button-label",
        "defaultMessage": "Give feedback on the new navigation"
    },
    feedbackTitle: {
        "id": "sidebar-nav4-feedback-button.utils.use-nav4-feedback-collector.feedback-title",
        "defaultMessage": "Help us improve the new navigation"
    },
    feedbackTitleDetailsWithLink: {
        "id": "sidebar-nav4-feedback-button.feedback-title-details",
        "defaultMessage": "We\u2019d love to hear about your experience with the new navigation. If needed, <a>you can switch back to the old navigation</a>."
    },
    feedbackTitleDetailsNoLink: {
        "id": "sidebar-nav4-feedback-button.feedback-title-details-no-link",
        "defaultMessage": "We\u2019d love to hear about your experience with the new navigation."
    },
    feedbackTitleLearnMoreLinkText: {
        "id": "sidebar-nav4-feedback-button.feedback-title-learn-more-link-text",
        "defaultMessage": "Learn more about the new navigation"
    }
});

});


parcelRegister("jW8hD", function(module, exports) {

$parcel$export(module.exports, "SideNavFooter", () => $0a27a4f4a3c93434$export$b773c4c9cf740fbe);
/* side-nav-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $0a27a4f4a3c93434$var$styles = {
    root: "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _7myae4h9 _1sw7nqa1 _qgnumuej"
};
const $0a27a4f4a3c93434$export$b773c4c9cf740fbe = ({ children: children, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $0a27a4f4a3c93434$var$styles.root,
            xcss
        ]),
        children: children
    });
};

});

parcelRegister("ht71P", function(module, exports) {

$parcel$export(module.exports, "AsyncNudgeBundledUsersFlagContainer", () => $7676eec527946b59$export$30d9dff000fbaa2d);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7676eec527946b59$var$NudgeBundledUsersFlagContainer = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("7OQYz")).then((module)=>module.NudgeBundledUsersXflow), {
    ssr: false,
    moduleId: "./src/packages/growth/nudge-bundled-users-to-join-connie/src/ui/index.tsx"
});
const $7676eec527946b59$export$30d9dff000fbaa2d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "nudgeBundledUserFlag",
        packageName: "nudgeBundledUsersToJoinConnie",
        fallback: "unmount",
        teamName: "confluenceOnboarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nudge-bundled-users-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7676eec527946b59$var$NudgeBundledUsersFlagContainer, null)));

});
parcelRegister("7OQYz", function(module, exports) {

let $5b164bdb9bdbb17c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5b164bdb9bdbb17c$var$load("ev3ZS").then(()=>parcelRequire('6vucW'));

});


parcelRegister("5gylp", function(module, exports) {

$parcel$export(module.exports, "SidebarEntryPointSelector", () => $d6305ce20becbb27$export$7b792d211e60bd1d);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2Ioew = parcelRequire("2Ioew");


var $frBVt = parcelRequire("frBVt");

var $7CMCs = parcelRequire("7CMCs");

var $cSD7y = parcelRequire("cSD7y");

var $7VBev = parcelRequire("7VBev");

var $l8ruj = parcelRequire("l8ruj");

var $6jY6G = parcelRequire("6jY6G");

var $jKa0E = parcelRequire("jKa0E");




var $3F9p6 = parcelRequire("3F9p6");

var $iXVV6 = parcelRequire("iXVV6");

var $23Lmh = parcelRequire("23Lmh");

var $fwGlt = parcelRequire("fwGlt");
const $d6305ce20becbb27$export$7b792d211e60bd1d = (0, $cSD7y.componentWithFG)('blu-5799-jira-software-board-entrypoint-route', $d6305ce20becbb27$var$Nav4SidebarEntryPointContainer, (0, $23Lmh.SidebarSelector));
function $d6305ce20becbb27$var$Nav4SidebarEntryPointContainer() {
    const currentRoute = (0, $6jY6G.useCurrentRoute)();
    const paramsForGetNav4SidebarId = (0, $fwGlt.useGetParamsForGetNav4SidebarId)();
    const currentSidebarId = (0, $fwGlt.getNav4SidebarId)(paramsForGetNav4SidebarId);
    const currentEntryPointRef = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5));
    const [sidebarConfig, setSidebarConfig] = (0, $5uXOq.useState)(()=>{
        // We want to avoid switching between the SidebarSelector and the sidebar entryPoint as we navigate through the SPA.
        // To do that, we need to keep using the __initial__ sidebar entryPoint if we haven't changed sidebars.
        // When we do switch sidebars, keep using SidebarSelector from that point onwards (for now).
        // When all of the sidebars are using entryPoints, we can deprecate the SidebarSelector.
        const attributes = {
            navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $68cb678dc917978e$export$2ee9e5a3556c1e43),
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            stage: (0, $3F9p6.getNav4Rollout)().stage
        };
        return {
            Component: ()=>currentEntryPointRef && currentRoute.navigation?.sidebarId === currentSidebarId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                    name: "nav4-sidebar-entrypoint"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
                    fallback: "flag",
                    id: "nav4-sidebar-entrypoint",
                    packageName: "jira-page-container-v2"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jKa0E.NavigateBackProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                    attributes: attributes
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointReferencePlaceholder), {
                    name: "nav4-sidebar-entrypoint-placeholder",
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null),
                    entryPointReference: currentEntryPointRef
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
                    entryPointReference: currentEntryPointRef,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    props: {}
                })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $23Lmh.SidebarSelector), null),
            sidebarId: currentSidebarId
        };
    });
    (0, $5uXOq.useEffect)(()=>{
        if (sidebarConfig.sidebarId !== currentSidebarId) setSidebarConfig({
            Component: (0, $23Lmh.SidebarSelector),
            sidebarId: currentSidebarId
        });
    }, [
        currentSidebarId,
        sidebarConfig.sidebarId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(sidebarConfig.Component, null);
}

});
parcelRegister("3F9p6", function(module, exports) {

$parcel$export(module.exports, "getNav4Rollout", () => $826ce4e4d6cfd68d$export$84a05d3b37ec5d2);

var $9glig = parcelRequire("9glig");

var $cxSdl = parcelRequire("cxSdl");

var $hMlwW = parcelRequire("hMlwW");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7qZOo = parcelRequire("7qZOo");

var $hUCm2 = parcelRequire("hUCm2");

var $8O1QZ = parcelRequire("8O1QZ");

var $32Frn = parcelRequire("32Frn");

var $laQnH = parcelRequire("laQnH");
const $826ce4e4d6cfd68d$export$84a05d3b37ec5d2 = (0, (/*@__PURE__*/$parcel$interopDefault($9glig)))([
    [
        ()=>!(0, $4R6GH.fg)('jira_nav4'),
        (0, (/*@__PURE__*/$parcel$interopDefault($cxSdl)))((0, $7qZOo.NAV4_ROLLOUT_NONE))
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding'),
        (0, $8O1QZ.getNav4RolloutForDogfooding)
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_eap'),
        (0, $32Frn.getNav4RolloutForEap)
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_beta_existing-customers'),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('existing-customers')
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_beta_sandboxes'),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('sandboxes')
    ],
    [
        ()=>(0, $6s1PB.expVal)('jira_nav4_beta_free-customers', 'willShowNav4', false),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('free-customers')
    ],
    [
        ()=>(0, $6s1PB.expVal)('jira_nav4_beta_new-customers', 'willShowNav4', false),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('new-customers')
    ],
    [
        ()=>(0, $6s1PB.expVal)('confluence_jira_nav4_new_customers', 'willShowNav4', false),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('new-customers-x')
    ],
    // Break up cond for easier testing.
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($hMlwW))),
        (0, $laQnH.getNav4RolloutForGaAndBeyond)
    ]
]);

});
parcelRegister("7qZOo", function(module, exports) {

$parcel$export(module.exports, "NAV4_ROLLOUT_NONE", () => $92928f70e02753a5$export$3b602cac1f385c06);
$parcel$export(module.exports, "NAV4_ROLLOUT_MOBILE", () => $92928f70e02753a5$export$e748a16828d2f61f);
const $92928f70e02753a5$export$3b602cac1f385c06 = {
    stage: 'none'
};
const $92928f70e02753a5$export$e748a16828d2f61f = {
    stage: 'mobile'
};

});

parcelRegister("hUCm2", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForBetaCohort", () => $8194d49fe31934aa$export$d0b7d7e3a8d0a0c9);

var $1i1R1 = parcelRequire("1i1R1");
const $8194d49fe31934aa$export$d0b7d7e3a8d0a0c9 = (cohort)=>()=>cohort !== 'existing-customers' ? {
            stage: 'beta',
            cohort: cohort
        } : {
            stage: 'beta',
            cohort: cohort,
            isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
        };

});

parcelRegister("8O1QZ", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForDogfooding", () => $48ac6742e168ff29$export$f1e751a9a9d68fb5);

var $9glig = parcelRequire("9glig");

var $hMlwW = parcelRequire("hMlwW");

var $4R6GH = parcelRequire("4R6GH");

var $1i1R1 = parcelRequire("1i1R1");
const $48ac6742e168ff29$var$dogfoodingPhase = (phase)=>()=>phase !== 3 ? {
            stage: 'dogfooding',
            phase: phase,
            isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
        } : {
            stage: 'dogfooding',
            phase: phase
        };
const $48ac6742e168ff29$export$f1e751a9a9d68fb5 = (0, (/*@__PURE__*/$parcel$interopDefault($9glig)))([
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding_phase-2'),
        $48ac6742e168ff29$var$dogfoodingPhase(2)
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding_phase-1'),
        $48ac6742e168ff29$var$dogfoodingPhase(1)
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($hMlwW))),
        $48ac6742e168ff29$var$dogfoodingPhase(3)
    ]
]);

});

parcelRegister("32Frn", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForEap", () => $d3197687d5551826$export$42dd8c002a342b8);

var $1i1R1 = parcelRequire("1i1R1");
const $d3197687d5551826$export$42dd8c002a342b8 = ()=>({
        stage: 'eap',
        isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
    });

});

parcelRegister("laQnH", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForGaAndBeyond", () => $8c7cc40a2449f7a7$export$99bed161b1040362);

var $9glig = parcelRequire("9glig");

var $cxSdl = parcelRequire("cxSdl");

var $hMlwW = parcelRequire("hMlwW");

var $4R6GH = parcelRequire("4R6GH");

var $c0dQj = parcelRequire("c0dQj");

var $1i1R1 = parcelRequire("1i1R1");

var $7qZOo = parcelRequire("7qZOo");
const $8c7cc40a2449f7a7$export$99bed161b1040362 = (0, (/*@__PURE__*/$parcel$interopDefault($9glig)))([
    // Later GA phases eclipse earlier phases.
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_phase-3'),
        ()=>({
                stage: 'ga',
                phase: 3
            })
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_phase-2'),
        ()=>({
                stage: 'ga',
                phase: 2,
                isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_phase-1'),
        ()=>({
                stage: 'ga',
                phase: 1,
                isAdmin: (0, $1i1R1.getIsAdmin)(),
                isTenantOptIn: (0, $1i1R1.getIsNav4TenantOptIn)(),
                isUserOptIn: (0, $1i1R1.getIsNav4UserOptIn)(),
                isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_sandboxes'),
        ()=>({
                stage: 'ga',
                cohort: 'sandboxes',
                isUserOptIn: (0, $1i1R1.getIsNav4UserOptIn)()
            })
    ],
    [
        ()=>(0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)(),
        (0, (/*@__PURE__*/$parcel$interopDefault($cxSdl)))((0, $7qZOo.NAV4_ROLLOUT_MOBILE))
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($hMlwW))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cxSdl)))((0, $7qZOo.NAV4_ROLLOUT_NONE))
    ]
]);

});


parcelRegister("23Lmh", function(module, exports) {

$parcel$export(module.exports, "SidebarSelector", () => $fdebb2e5052d145f$export$7937e2d32a777fcb);

var $5uXOq = parcelRequire("5uXOq");

var $3TY9o = parcelRequire("3TY9o");

var $2vSU6 = parcelRequire("2vSU6");

var $8J6rn = parcelRequire("8J6rn");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");




var $3F9p6 = parcelRequire("3F9p6");

var $jKa0E = parcelRequire("jKa0E");

var $3ed52 = parcelRequire("3ed52");

var $gyZtn = parcelRequire("gyZtn");

var $dOB7H = parcelRequire("dOB7H");

var $dEbXe = parcelRequire("dEbXe");

var $Tdcaw = parcelRequire("Tdcaw");

var $fbami = parcelRequire("fbami");

var $bCaZu = parcelRequire("bCaZu");

var $gYSoA = parcelRequire("gYSoA");

var $ieEgo = parcelRequire("ieEgo");

var $7s8Fa = parcelRequire("7s8Fa");

var $kNJsg = parcelRequire("kNJsg");

var $aWnEG = parcelRequire("aWnEG");

var $2KXa8 = parcelRequire("2KXa8");

var $hrRcW = parcelRequire("hrRcW");

var $lF3VU = parcelRequire("lF3VU");

var $bJJms = parcelRequire("bJJms");

var $6ZLHo = parcelRequire("6ZLHo");

var $7VBev = parcelRequire("7VBev");

var $YiTdm = parcelRequire("YiTdm");

var $kqEpF = parcelRequire("kqEpF");

var $1G9rm = parcelRequire("1G9rm");

var $drQWa = parcelRequire("drQWa");

var $5XLFZ = parcelRequire("5XLFZ");

var $2DtJE = parcelRequire("2DtJE");

var $cnyf1 = parcelRequire("cnyf1");

var $iXVV6 = parcelRequire("iXVV6");

var $dAfqg = parcelRequire("dAfqg");

var $c1mlA = parcelRequire("c1mlA");

var $lODMY = parcelRequire("lODMY");

var $lODMY = parcelRequire("lODMY");

var $jnN73 = parcelRequire("jnN73");
const $fdebb2e5052d145f$export$aa65c2aacd155f7f = (0, $7XYc4.componentWithCondition)(()=>// eslint-disable-next-line jira/ff/inline-expVal-params -- ESLint rule doesn't understand the array type
    (0, $6s1PB.expVal)('jira_nav4_hot_113350_changes', 'keys', []).includes('blu-5991-sync-load-nav4-sidebar'), (0, $gyZtn.SidebarContent), (0, $3ed52.default));
const $fdebb2e5052d145f$var$entitySettingsSidebarAnalyticsAttributes = {
    navigationLayer: (0, $ce9c0831aed9ffb3$export$33d8c916a600c5e9)
};
const $fdebb2e5052d145f$var$ProjectSettingsSidebarSelector = ()=>{
    const { data: project, loading: loading, error: error } = (0, $dAfqg.useProjectContext)();
    let sidebar = null;
    if (loading) sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null);
    if (error) throw error;
    if (project?.projectType === (0, $2vSU6.CORE_PROJECT)) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ZLHo.default), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bJJms.default), {
        project: project
    });
    if (project?.projectType === (0, $2vSU6.SOFTWARE_PROJECT)) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnyf1.default), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2DtJE.default), {
        project: project
    });
    if (project?.projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kqEpF.default), {
        project: project
    });
    if (project?.projectType === (0, $2vSU6.CUSTOMER_SERVICE_PROJECT) && (0, $4R6GH.fg)('jcs_project_type_m3')) sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5XLFZ.AsyncJcsProjectSettingsSidebar), {
        project: project
    });
    if (project?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) || project?.projectType === (0, $2vSU6.CUSTOMER_SERVICE_PROJECT) && !(0, $4R6GH.fg)('jcs_project_type_m3')) sidebar = project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $drQWa.AsyncJsmTmpProjectSettingsSidebar), {
        project: project
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1G9rm.AsyncJsmCmpProjectSettingsSidebar), {
        project: project
    });
    if (!sidebar) throw new Error(`No project settings sidebar found for the project type: ${project?.projectType}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        containerId: project ? String(project.projectId) : undefined,
        containerType: "project",
        attributes: $fdebb2e5052d145f$var$entitySettingsSidebarAnalyticsAttributes
    }, sidebar);
};
const $fdebb2e5052d145f$var$BoardSettingsSidebar = ()=>{
    const { data: project, loading: loading, error: error } = (0, $dAfqg.useProjectContext)();
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dEbXe.Skeleton), null);
    if (error) throw error;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        containerId: project ? String(project.projectId) : undefined,
        containerType: "project",
        attributes: $fdebb2e5052d145f$var$entitySettingsSidebarAnalyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOB7H.default), null));
};
const $fdebb2e5052d145f$var$REDIRECT_ROUTES_NAMES = new Set([
    'browse-project-redirect',
    'servicedesk-redirect'
]);
const $fdebb2e5052d145f$var$getSidebarForRoute = (state, { configParam: configParam, shouldUseJSM: shouldUseJSM, isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive, isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive, isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive })=>{
    const sidebarId = state.route.navigation?.sidebarId;
    const pathname = state.location.pathname;
    switch(sidebarId){
        case (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lF3VU.default), null);
        case (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS:
            if (!pathname.includes('/discover')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fbami.default), null);
            break;
        case (0, $lmyls.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ieEgo.default), null);
        case (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bCaZu.default), null);
        case (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS:
            if (pathname.includes('/jira-service-management-chatops-and-video-tools') && shouldUseJSM && (0, $4R6GH.fg)('fix_chatops_new_nav_bug')) break;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYSoA.default), null);
        case (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aWnEG.default), null);
        case (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hrRcW.default), null);
        case (0, $lmyls.SIDEBAR_ID).HELP_CENTER_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KXa8.default), null);
        case (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fdebb2e5052d145f$var$ProjectSettingsSidebarSelector, null);
        case (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7s8Fa.default), null);
        default:
            break;
    }
    if (state.route.name === 'polaris-ideas' && state.match.params.section === 'settings' || isProjectSettingsConnectAppActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fdebb2e5052d145f$var$ProjectSettingsSidebarSelector, null);
    if (state.route.group === 'classic-software' && (0, $c1mlA.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(configParam) && (0, $4R6GH.fg)('simplified-boards-milestone-2_07hbk')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fdebb2e5052d145f$var$BoardSettingsSidebar, null);
    if (isGlobalAppsSettingsConnectItemActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fbami.default), null);
    if (isGlobalSystemSettingsConnectItemActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aWnEG.default), null);
};
const $fdebb2e5052d145f$export$ac727539f28734c4 = (state)=>{
    return !$fdebb2e5052d145f$var$REDIRECT_ROUTES_NAMES.has(state.route.name);
};
const $fdebb2e5052d145f$export$7ea19f35e3a0b199 = (0, $lODMY.createRouterSelector)($fdebb2e5052d145f$export$ac727539f28734c4);
const $fdebb2e5052d145f$export$b1253b9403840da1 = ()=>{
    const { saveCurrentRoute: saveCurrentRoute } = (0, $jKa0E.useNavigateBack)();
    const { isActive: isGlobalAppsSettingsConnectItemActive } = (0, $Tdcaw.useGlobalAppsSettingsConnectItemActive)();
    const { isActive: isGlobalSystemSettingsConnectItemActive } = (0, $kNJsg.useGlobalSystemSettingsConnectItemActive)();
    const { isActive: isProjectSettingsConnectAppActive } = (0, $YiTdm.useIsConnectAppActive)();
    const { shouldUseJSM: shouldUseJSM } = (0, $8J6rn.useOgTenantInfo)();
    const isNonRedirectRoute = $fdebb2e5052d145f$export$7ea19f35e3a0b199();
    const configParam = (0, $jnN73.useMaybeConfigParam)() || '';
    const location = (0, $3TY9o.useLocation)();
    const [sidebar, setSidebar] = (0, $5uXOq.useState)($fdebb2e5052d145f$var$getSidebarForRoute((0, $lODMY.getRouterState)(), {
        configParam: configParam,
        shouldUseJSM: shouldUseJSM,
        isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive,
        isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive,
        isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive
    }));
    (0, $5uXOq.useEffect)(()=>{
        return (0, $lODMY.addRouteListener)((state)=>{
            setSidebar($fdebb2e5052d145f$var$getSidebarForRoute(state, {
                configParam: state.query.config || state.match.params.config || '',
                isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive,
                isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive,
                isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive,
                shouldUseJSM: shouldUseJSM
            }));
        });
    }, [
        isGlobalAppsSettingsConnectItemActive,
        isGlobalSystemSettingsConnectItemActive,
        isProjectSettingsConnectAppActive,
        shouldUseJSM
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!sidebar && isNonRedirectRoute) {
            const url = `${location.pathname}${location.search}${location.hash}`;
            saveCurrentRoute(url);
        }
    }, [
        isNonRedirectRoute,
        location,
        saveCurrentRoute,
        sidebar
    ]);
    if (sidebar) return sidebar;
    // Main nav (with "Your work", Starred, Recent items etc.)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fdebb2e5052d145f$export$aa65c2aacd155f7f, null);
};
const $fdebb2e5052d145f$export$7937e2d32a777fcb = ()=>{
    const attributes = (0, $5uXOq.useMemo)(()=>({
            navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $68cb678dc917978e$export$2ee9e5a3556c1e43),
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            stage: (0, $3F9p6.getNav4Rollout)().stage
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jKa0E.NavigateBackProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fdebb2e5052d145f$export$b1253b9403840da1, null)));
};

});
parcelRegister("3ed52", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2e015ea5d0812b1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $a2e015ea5d0812b1$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>Promise.resolve((parcelRequire("gyZtn"))).then(({ SidebarContent: SidebarContent })=>SidebarContent), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/core/src/index.tsx"
});
const $a2e015ea5d0812b1$var$AsyncSidebarContent = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "asyncSidebarContent",
        packageName: "jiraNavigationAppsSidebarNav4SidebarContent",
        teamName: "jira-cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazySidebarContent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2e015ea5d0812b1$var$LazySidebarContent, null))));
$a2e015ea5d0812b1$var$AsyncSidebarContent.displayName = 'AsyncSidebarContent';
var // Used in jira/src/packages/page-container-v2/src/common/ui/sidebar
$a2e015ea5d0812b1$export$2e2bcd8739ae039 = $a2e015ea5d0812b1$var$AsyncSidebarContent;

});

parcelRegister("dOB7H", function(module, exports) {

$parcel$export(module.exports, "default", () => $358df587d3e80a76$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $dEbXe = parcelRequire("dEbXe");

const $358df587d3e80a76$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("hJSbE")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/board/src/ui/main.tsx"
});
const $358df587d3e80a76$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.board-settings",
        packageName: "jiraNavigationAppsSidebarNav4BoardSettings",
        ufoName: "nav4.sidebar.board-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.board-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dEbXe.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($358df587d3e80a76$var$LazySidebarContent, null)));
var $358df587d3e80a76$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($358df587d3e80a76$var$AsyncSidebar);

});
parcelRegister("dEbXe", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $ff13cb96c7f2cede$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");
const $ff13cb96c7f2cede$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $ff13cb96c7f2cede$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $ff13cb96c7f2cede$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $ff13cb96c7f2cede$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $ff13cb96c7f2cede$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $ff13cb96c7f2cede$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $ff13cb96c7f2cede$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $ff13cb96c7f2cede$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $ff13cb96c7f2cede$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $ff13cb96c7f2cede$var$menuItem
    })));
const $ff13cb96c7f2cede$var$containerStyles = (0, $2s57o.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200'
});
const $ff13cb96c7f2cede$var$backButton = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $ff13cb96c7f2cede$var$headingSkeleton = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $ff13cb96c7f2cede$var$menuItem = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});


parcelRegister("Tdcaw", function(module, exports) {

$parcel$export(module.exports, "useGlobalSettingsConnectItems", () => $a54a68c44d0262b5$export$f0785b98c99d344c);
$parcel$export(module.exports, "useIsAppsSettingsConnectAppModule", () => $a54a68c44d0262b5$export$8dd86b1eb9fdf786);
$parcel$export(module.exports, "useGlobalAppsSettingsConnectItemActive", () => $a54a68c44d0262b5$export$83008eebb9fccef3);

var $5uXOq = parcelRequire("5uXOq");

var $8maDO = parcelRequire("8maDO");

var $hWBtO = parcelRequire("hWBtO");

var $efOLn = parcelRequire("efOLn");

var $bYoAQ = parcelRequire("bYoAQ");

var $hz6Yb = parcelRequire("hz6Yb");

var $3TY9o = parcelRequire("3TY9o");

var $8j0rr = parcelRequire("8j0rr");
const $a54a68c44d0262b5$var$getItems = (d)=>(0, $hWBtO.getLinks)(d, [
        'admin_plugins_menu'
    ], {
        skipFilter: true
    }).filter((v)=>![
            'upm_section',
            'jpo-ws-admin'
        ].includes(v.id)) // remove sections also statically defined
    .map((0, $efOLn.transformLink)) // Apply transformation to each link
    .filter(Boolean); // Remove falsy values
const $a54a68c44d0262b5$export$f0785b98c99d344c = ()=>{
    const { data: data, loading: loading, error: error } = (0, $bYoAQ.useNavigationGlobalResource)();
    const items = (0, $5uXOq.useMemo)(()=>data && $a54a68c44d0262b5$var$getItems(data), [
        data
    ]);
    return {
        data: items,
        loading: loading,
        error: error
    };
};
const $a54a68c44d0262b5$export$ae997bf97ec22b71 = new Set([
    'configurePage',
    'postInstallPage'
]);
const $a54a68c44d0262b5$export$8dd86b1eb9fdf786 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $hz6Yb.useConnectGeneralResource)();
    return {
        isActive: $a54a68c44d0262b5$export$ae997bf97ec22b71.has(data?.moduleType),
        loading: loading,
        error: error
    };
};
const $a54a68c44d0262b5$export$83008eebb9fccef3 = ()=>{
    const location = (0, $3TY9o.useLocation)();
    const route = (0, $8j0rr.useRoute)();
    const { data: data, loading: loading, error: error } = $a54a68c44d0262b5$export$f0785b98c99d344c();
    const { isActive: isAppsSettingsConnectAppModuleActive, loading: isAppsSettingsConnectAppModuleLoading, error: isAppsSettingsConnectAppModuleError } = $a54a68c44d0262b5$export$8dd86b1eb9fdf786();
    const isActive = (0, $5uXOq.useMemo)(()=>Boolean(route && data && (0, $8maDO.findItemAndStack)(data, route.name, location)?.selected), [
        data,
        route,
        location
    ]);
    return {
        isActive: isActive || isAppsSettingsConnectAppModuleActive,
        loading: loading || isAppsSettingsConnectAppModuleLoading,
        error: error || isAppsSettingsConnectAppModuleError
    };
};

});
parcelRegister("8maDO", function(module, exports) {

$parcel$export(module.exports, "findItemAndStack", () => $c4af9df81f308e02$export$751e2e6237002565);

var $ajpes = parcelRequire("ajpes");

var $k0iPT = parcelRequire("k0iPT");
// JSPA-1062 remove qs items that might not always be there
const $c4af9df81f308e02$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $c4af9df81f308e02$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $c4af9df81f308e02$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
    let found = null;
    if (!(0, $k0iPT.CONNECT_ROUTES_SET).has(routeName)) return found;
    const locationQuery = $c4af9df81f308e02$var$splitRelevantQs(location.search);
    items.some((item)=>{
        const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
        const itemQuery = $c4af9df81f308e02$var$splitRelevantQs(itemQs);
        const sameQuery = $c4af9df81f308e02$var$isSameQuery(locationQuery, itemQuery);
        if (item.section !== true && itemPath === location.pathname && sameQuery) {
            found = {
                stack: parentStack,
                selected: item
            };
            return true;
        }
        if (item.items) {
            const stack = item.section === true ? parentStack : parentStack.concat(item.id);
            found = $c4af9df81f308e02$export$751e2e6237002565(item.items, routeName, location, stack);
        }
        return Boolean(found);
    });
    return found;
};

});

parcelRegister("hWBtO", function(module, exports) {

$parcel$export(module.exports, "getLinks", () => $90a1a565c575dc5b$export$8054dcb2b42da45c);

var $9KzPc = parcelRequire("9KzPc");
const $90a1a565c575dc5b$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
        if (item.id === legacyId) return item.links;
        return item.links && $90a1a565c575dc5b$var$findChildLinks(item.links, legacyId);
    }).find(Boolean);
const $90a1a565c575dc5b$var$getLinksFromSidebar = (sidebarConfig, legacyId)=>{
    const links = legacyId != null ? $90a1a565c575dc5b$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
    return links || [];
};
const $90a1a565c575dc5b$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
    const acc = [];
    locations.forEach((location)=>{
        const links = $90a1a565c575dc5b$var$getLinksFromSidebar(sidebarConfig, location);
        if (omitSections === true) {
            // merge 2 arrays in good performance way
            Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
            return;
        }
        // merge 2 arrays in good performance way
        Array.prototype.push.apply(acc, links);
    });
    return acc.filter((item)=>{
        if (!item) return false;
        if (skipFilter === true) return true;
        const hasConnectPrefix = item.id && item.id.includes((0, $9KzPc.connectPrefix));
        if (hasConnectPrefix) return true;
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"sd-reports-addons" | "sd-queues-addons" | "com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent"'.
        const isConnectSection = (0, $9KzPc.connectSections).includes(item.id);
        if (isConnectSection) return true;
        const isJsdConnectSection = item.id && item.id.includes((0, $9KzPc.jsdConnectPrefix));
        if (isJsdConnectSection) return true;
        return false;
    });
};

});
parcelRegister("9KzPc", function(module, exports) {

$parcel$export(module.exports, "connectPrefix", () => $f13744297e4a8bc9$export$196d83ebd873fb40);
$parcel$export(module.exports, "jsdConnectPrefix", () => $f13744297e4a8bc9$export$7fac8f726f52d70);
$parcel$export(module.exports, "connectSections", () => $f13744297e4a8bc9$export$b1c2c1fc5d10280);

var $16J3A = parcelRequire("16J3A");
const $f13744297e4a8bc9$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
const $f13744297e4a8bc9$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
const $f13744297e4a8bc9$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
const $f13744297e4a8bc9$var$jsdQueuesConnectSection = 'sd-queues-addons';
const $f13744297e4a8bc9$export$b1c2c1fc5d10280 = [
    $f13744297e4a8bc9$var$legacyAddonPanelLinkId,
    (0, $16J3A.REPORTS_IDS).REPORTS_ADDONS,
    $f13744297e4a8bc9$var$jsdQueuesConnectSection
];

});


parcelRegister("efOLn", function(module, exports) {

$parcel$export(module.exports, "transformLink", () => $179f73798c754e8b$export$5a32dc366b1d641f);
$parcel$export(module.exports, "transformLinkV4", () => $179f73798c754e8b$export$27267b6b6650eaa5);
const $179f73798c754e8b$export$5a32dc366b1d641f = (link)=>{
    const items = link.links && link.links.length ? link.links.map($179f73798c754e8b$export$5a32dc366b1d641f).filter(Boolean) : undefined;
    // section item
    if (link.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(link.name)
        };
        return {
            id: link.id,
            name: String(link.name),
            section: !!link.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: link.id,
        name: String(link.name),
        url: link.url,
        iconUrl: link.iconUrl || '',
        styleClass: link.styleClass || '',
        items: items
    };
};
const $179f73798c754e8b$export$27267b6b6650eaa5 = (data)=>{
    const items = data.links && data.links.length ? data.links.map($179f73798c754e8b$export$27267b6b6650eaa5).filter(Boolean) : undefined;
    // section item
    if (data.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(data.name)
        };
        return {
            id: data.id,
            name: String(data.name),
            section: !!data.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: data.id,
        name: String(data.name),
        url: data.url,
        iconUrl: data.iconUrl || '',
        styleClass: data.styleClass || '',
        items: items
    };
};

});

parcelRegister("bYoAQ", function(module, exports) {

$parcel$export(module.exports, "useNavigationGlobalResource", () => $37852a2b10dca6fc$export$1e1c317ed5b99faa);

var $atU1t = parcelRequire("atU1t");

var $2YP9W = parcelRequire("2YP9W");
const $37852a2b10dca6fc$export$1e1c317ed5b99faa = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $atU1t.navigationSidebarGlobalResource));
    return {
        data: data && data.response,
        loading: loading,
        error: error
    };
};

});


parcelRegister("fbami", function(module, exports) {

$parcel$export(module.exports, "default", () => $f82a04fb3eb62635$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $cnlm7 = parcelRequire("cnlm7");

var $i8077 = parcelRequire("i8077");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $aUDLa = parcelRequire("aUDLa");

var $9OXo1 = parcelRequire("9OXo1");

var $gJkov = parcelRequire("gJkov");

const $f82a04fb3eb62635$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("3I4WP")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/apps/src/ui/main.tsx"
});
const $f82a04fb3eb62635$var$AsyncSidebar = ()=>{
    const { data: data } = (0, $aUDLa.useNavigationGlobalResource)();
    const { isDevMode: isDevMode, isAdmin: isAdmin } = (0, $9OXo1.useTenantContext)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $gJkov.extractData)(data, isDevMode, isAdmin), [
        data,
        isDevMode,
        isAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.apps-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsAppsSettings",
        ufoName: "nav4.sidebar.global-settings.apps-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnlm7.SidebarContent), {
        currentPageName: "apps",
        hasGeneralConfiguration: extractedData?.hasGeneralConfiguration,
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-apps.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.apps-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8077.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f82a04fb3eb62635$var$LazySidebarContent, null))));
};
var $f82a04fb3eb62635$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($f82a04fb3eb62635$var$AsyncSidebar);

});
parcelRegister("3I4WP", function(module, exports) {

let $2b3951ac34ef9a23$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2b3951ac34ef9a23$var$load("4HmNO").then(()=>parcelRequire('6JIAx'));

});


parcelRegister("bCaZu", function(module, exports) {

$parcel$export(module.exports, "default", () => $58b39e5bf0fb90a0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $cnlm7 = parcelRequire("cnlm7");

var $i8077 = parcelRequire("i8077");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $aUDLa = parcelRequire("aUDLa");

var $9OXo1 = parcelRequire("9OXo1");

var $gJkov = parcelRequire("gJkov");

const $58b39e5bf0fb90a0$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("lVi5M")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/issues/src/ui/main.tsx"
});
const $58b39e5bf0fb90a0$var$AsyncSidebar = ()=>{
    const { data: data } = (0, $aUDLa.useNavigationGlobalResource)();
    const { isDevMode: isDevMode, isAdmin: isAdmin } = (0, $9OXo1.useTenantContext)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $gJkov.extractData)(data, isDevMode, isAdmin), [
        data,
        isDevMode,
        isAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.issues-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsIssuesSettings",
        ufoName: "nav4.sidebar.global-settings.issues-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnlm7.SidebarContent), {
        currentPageName: "issues",
        hasGeneralConfiguration: extractedData?.hasGeneralConfiguration,
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-issues.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.issues-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8077.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58b39e5bf0fb90a0$var$LazySidebarContent, null))));
};
var $58b39e5bf0fb90a0$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($58b39e5bf0fb90a0$var$AsyncSidebar);

});
parcelRegister("lVi5M", function(module, exports) {

let $ff5cf496d85717b6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ff5cf496d85717b6$var$load("hEv4j").then(()=>parcelRequire('fUdDx'));

});


parcelRegister("gYSoA", function(module, exports) {

$parcel$export(module.exports, "default", () => $425ce2b571ab3ef5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $cnlm7 = parcelRequire("cnlm7");

var $i8077 = parcelRequire("i8077");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $aUDLa = parcelRequire("aUDLa");

var $9OXo1 = parcelRequire("9OXo1");

var $gJkov = parcelRequire("gJkov");

const $425ce2b571ab3ef5$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("7IrLK")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/products/src/ui/main.tsx"
});
const $425ce2b571ab3ef5$var$AsyncSidebar = ()=>{
    const { data: data } = (0, $aUDLa.useNavigationGlobalResource)();
    const { isDevMode: isDevMode, isAdmin: isAdmin } = (0, $9OXo1.useTenantContext)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $gJkov.extractData)(data, isDevMode, isAdmin), [
        data,
        isDevMode,
        isAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.products-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProductsSettings",
        ufoName: "nav4.sidebar.global-settings.products-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnlm7.SidebarContent), {
        currentPageName: "products",
        hasGeneralConfiguration: extractedData?.hasGeneralConfiguration,
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-products.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.products-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8077.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($425ce2b571ab3ef5$var$LazySidebarContent, null))));
};
var $425ce2b571ab3ef5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($425ce2b571ab3ef5$var$AsyncSidebar);

});
parcelRegister("7IrLK", function(module, exports) {

let $59e22edb030ab902$var$load = (parcelRequire("28QjX"))(4);
module.exports = $59e22edb030ab902$var$load("eOt8B").then(()=>parcelRequire('864s3'));

});


parcelRegister("ieEgo", function(module, exports) {

$parcel$export(module.exports, "default", () => $b88bb6161ed4902f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $cnlm7 = parcelRequire("cnlm7");

var $i8077 = parcelRequire("i8077");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $aUDLa = parcelRequire("aUDLa");

var $9OXo1 = parcelRequire("9OXo1");

var $gJkov = parcelRequire("gJkov");

const $b88bb6161ed4902f$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("h73ua")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/projects/src/ui/main.tsx"
});
const $b88bb6161ed4902f$var$AsyncSidebar = ()=>{
    const { data: data } = (0, $aUDLa.useNavigationGlobalResource)();
    const { isDevMode: isDevMode, isAdmin: isAdmin } = (0, $9OXo1.useTenantContext)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $gJkov.extractData)(data, isDevMode, isAdmin), [
        data,
        isDevMode,
        isAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.projects-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProjectsSettings",
        ufoName: "nav4.sidebar.global-settings.projects-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnlm7.SidebarContent), {
        currentPageName: "projects",
        hasGeneralConfiguration: extractedData?.hasGeneralConfiguration,
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-projects.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.projects-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8077.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b88bb6161ed4902f$var$LazySidebarContent, null))));
};
var $b88bb6161ed4902f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($b88bb6161ed4902f$var$AsyncSidebar);

});
parcelRegister("h73ua", function(module, exports) {

let $c755cb429d9ac233$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c755cb429d9ac233$var$load("7bkDd").then(()=>parcelRequire('fbdwm'));

});


parcelRegister("kNJsg", function(module, exports) {

$parcel$export(module.exports, "useGlobalSystemSettingsConnectItems", () => $90305fd4b8d90c67$export$68950d4e14439158);
$parcel$export(module.exports, "useGlobalSystemSettingsConnectItemActive", () => $90305fd4b8d90c67$export$5efb701a2106707a);

var $5uXOq = parcelRequire("5uXOq");

var $8maDO = parcelRequire("8maDO");

var $hWBtO = parcelRequire("hWBtO");

var $efOLn = parcelRequire("efOLn");

var $fgeiD = parcelRequire("fgeiD");

var $bYoAQ = parcelRequire("bYoAQ");

var $hz6Yb = parcelRequire("hz6Yb");

var $3TY9o = parcelRequire("3TY9o");

var $8j0rr = parcelRequire("8j0rr");
const $90305fd4b8d90c67$var$getItems = (d)=>(0, $hWBtO.getLinks)(d, [
        'admin_system_menu'
    ], {
        skipFilter: true
    }).map((0, $efOLn.transformLink)) // Apply transformation to each link
    .filter(Boolean); // Remove falsy values
const $90305fd4b8d90c67$export$68950d4e14439158 = (0, $fgeiD.withThrowOnError)(()=>{
    const { data: data, loading: loading, error: error } = (0, $bYoAQ.useNavigationGlobalResource)();
    const items = (0, $5uXOq.useMemo)(()=>data && $90305fd4b8d90c67$var$getItems(data), [
        data
    ]);
    return {
        data: items,
        loading: loading,
        error: error
    };
});
const $90305fd4b8d90c67$export$5efb701a2106707a = ()=>{
    const location = (0, $3TY9o.useLocation)();
    const route = (0, $8j0rr.useRoute)();
    const { data: data, loading: loading, error: error } = $90305fd4b8d90c67$export$68950d4e14439158();
    const { data: connectGeneralData, loading: connectGeneralResourceLoading, error: connectGeneralResourceError } = (0, $hz6Yb.useConnectGeneralResource)();
    const isActive = (0, $5uXOq.useMemo)(()=>Boolean(route && data && (0, $8maDO.findItemAndStack)(data, route.name, location)?.selected), [
        data,
        route,
        location
    ]);
    return {
        isActive: isActive || connectGeneralData?.moduleType === 'adminPages',
        loading: loading || connectGeneralResourceLoading,
        error: error || connectGeneralResourceError
    };
};

});
parcelRegister("fgeiD", function(module, exports) {

$parcel$export(module.exports, "withThrowOnError", () => $f9ce174aaa2e063b$export$a018832f2ec4dc91);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $gKZoD = parcelRequire("gKZoD");
const $f9ce174aaa2e063b$var$isDataEmpty = (data)=>data == null;
function $f9ce174aaa2e063b$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        // tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
        (0, $gKZoD.di)(theHook);
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $f9ce174aaa2e063b$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});


parcelRegister("aWnEG", function(module, exports) {

$parcel$export(module.exports, "default", () => $59776b430a24875d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $cnlm7 = parcelRequire("cnlm7");

var $i8077 = parcelRequire("i8077");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $aUDLa = parcelRequire("aUDLa");

var $9OXo1 = parcelRequire("9OXo1");

var $gJkov = parcelRequire("gJkov");

const $59776b430a24875d$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("3XBoR")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/system/src/ui/main.tsx"
});
const $59776b430a24875d$var$AsyncSidebar = ()=>{
    const { data: data } = (0, $aUDLa.useNavigationGlobalResource)();
    const { isDevMode: isDevMode, isAdmin: isAdmin } = (0, $9OXo1.useTenantContext)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $gJkov.extractData)(data, isDevMode, isAdmin), [
        data,
        isDevMode,
        isAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.global-settings.system-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsSystemSettings",
        ufoName: "nav4.sidebar.global-settings.system-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnlm7.SidebarContent), {
        currentPageName: "system",
        hasGeneralConfiguration: extractedData?.hasGeneralConfiguration,
        testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-system.ui.sidebar-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.global-settings.system-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8077.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59776b430a24875d$var$LazySidebarContent, null))));
};
var $59776b430a24875d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($59776b430a24875d$var$AsyncSidebar);

});
parcelRegister("3XBoR", function(module, exports) {

let $2e23e4a5d6656988$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2e23e4a5d6656988$var$load("9yM86").then(()=>parcelRequire('rQUQs'));

});


parcelRegister("2KXa8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5d93ac4546abf11$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $aUxXz = parcelRequire("aUxXz");

const $b5d93ac4546abf11$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("fcVC0")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/help-center/src/ui/main.tsx"
});
const $b5d93ac4546abf11$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.help-center-settings",
        packageName: "jiraNavigationAppsSidebarNav4HelpCenterSettings",
        ufoName: "nav4.sidebar.help-center-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.help-center-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aUxXz.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5d93ac4546abf11$var$LazySidebarContent, null)));
var $b5d93ac4546abf11$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($b5d93ac4546abf11$var$AsyncSidebar);

});
parcelRegister("aUxXz", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $c42d7c14b1508227$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");
const $c42d7c14b1508227$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $c42d7c14b1508227$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $c42d7c14b1508227$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $c42d7c14b1508227$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $c42d7c14b1508227$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $c42d7c14b1508227$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $c42d7c14b1508227$var$menuItem
    })));
const $c42d7c14b1508227$var$backButton = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $c42d7c14b1508227$var$headingSkeleton = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $c42d7c14b1508227$var$menuItem = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("fcVC0", function(module, exports) {

let $b124aa8c9b03d8be$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b124aa8c9b03d8be$var$load("jvUDk").then(()=>parcelRequire('22iKv'));

});


parcelRegister("hrRcW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e7cdaae12475462$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $jUfLV = parcelRequire("jUfLV");

const $8e7cdaae12475462$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("l3e0e")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/personal/src/ui/main.tsx"
});
const $8e7cdaae12475462$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.personal-settings",
        packageName: "jiraNavigationAppsSidebarNav4PersonalSettings",
        ufoName: "nav4.sidebar.personal-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.personal-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jUfLV.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e7cdaae12475462$var$LazySidebarContent, null)));
var $8e7cdaae12475462$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($8e7cdaae12475462$var$AsyncSidebar);

});
parcelRegister("jUfLV", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $1cdf070fb698d8d2$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");
const $1cdf070fb698d8d2$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $1cdf070fb698d8d2$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $1cdf070fb698d8d2$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $1cdf070fb698d8d2$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $1cdf070fb698d8d2$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $1cdf070fb698d8d2$var$menuItem
    })));
const $1cdf070fb698d8d2$var$containerStyles = (0, $2s57o.xcss)({
    paddingBlock: 'space.200',
    paddingInline: 'space.200'
});
const $1cdf070fb698d8d2$var$backButton = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $1cdf070fb698d8d2$var$headingSkeleton = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $1cdf070fb698d8d2$var$menuItem = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("l3e0e", function(module, exports) {

let $f534bd749e6bb7c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f534bd749e6bb7c0$var$load("6lHZh").then(()=>parcelRequire('hox2O'));

});


parcelRegister("lF3VU", function(module, exports) {

$parcel$export(module.exports, "default", () => $442721cda4044790$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $bhcrK = parcelRequire("bhcrK");

const $442721cda4044790$var$LazyPlanSettingsSidebar = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("aTJub")).then(({ PlanSettingsSidebar: PlanSettingsSidebar })=>PlanSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/plan/src/ui/main.tsx"
});
const $442721cda4044790$var$AsyncSidebar = ({ store: store })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "asyncSidebarPlanSettings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bhcrK.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($442721cda4044790$var$LazyPlanSettingsSidebar, {
        store: store
    }));
var $442721cda4044790$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($442721cda4044790$var$AsyncSidebar);

});
parcelRegister("bhcrK", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $d204c752b5086975$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");

var $6s1PB = parcelRequire("6s1PB");
const $d204c752b5086975$export$8f31e4c4a37b8e9c = ()=>{
    return (0, $6s1PB.expVal)('m1_features_page_experiment', 'cohort', 'not-enrolled') === 'variation' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$titleSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$titleSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$subtitleItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $d204c752b5086975$var$menuItem
    })));
};
const $d204c752b5086975$var$titleSkeleton = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-800, 64px)",
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});
const $d204c752b5086975$var$backButton = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});
const $d204c752b5086975$var$headingSkeleton = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $d204c752b5086975$var$menuItem = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $d204c752b5086975$var$subtitleItem = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    width: "var(--ds-space-1000, 80px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("aTJub", function(module, exports) {

let $7ef252f9d5b31702$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7ef252f9d5b31702$var$load("b8Lgd").then(()=>parcelRequire('7UsxD'));

});


parcelRegister("bJJms", function(module, exports) {

$parcel$export(module.exports, "default", () => $cce9becc602ac5ad$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $cce9becc602ac5ad$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("2GckN")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/business/company-managed/src/ui/main.tsx"
});
const $cce9becc602ac5ad$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.business.company-managed",
        packageName: "jiraNavigationAppsSidebarNav4BusinessCompanyManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.business.company-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.project-settings.business.company-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cce9becc602ac5ad$var$LazySidebarContent, {
        project: project
    })));
var $cce9becc602ac5ad$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($cce9becc602ac5ad$var$AsyncSidebar);

});
parcelRegister("2GckN", function(module, exports) {

let $1f3912664fda03bf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1f3912664fda03bf$var$load("f7rnD").then(()=>parcelRequire('kaECc'));

});


parcelRegister("6ZLHo", function(module, exports) {

$parcel$export(module.exports, "default", () => $b222bb97daacff3e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $b222bb97daacff3e$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("jq9Gq")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/business/team-managed/src/ui/main.tsx"
});
const $b222bb97daacff3e$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.business.team-managed",
        packageName: "jiraNavigationAppsSidebarNav4BusinessTeamManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.business.team-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.project-settings.business.team-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b222bb97daacff3e$var$LazySidebarContent, {
        project: project
    })));
var $b222bb97daacff3e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($b222bb97daacff3e$var$AsyncSidebar);

});
parcelRegister("jq9Gq", function(module, exports) {

let $e237f4edfe57fac6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e237f4edfe57fac6$var$load("l1ol4").then(()=>parcelRequire('v17He'));

});


parcelRegister("YiTdm", function(module, exports) {

$parcel$export(module.exports, "useIsConnectAppActive", () => $c92d349d32b0fe9a$export$249b2e8512031cae);

var $5uXOq = parcelRequire("5uXOq");

var $8maDO = parcelRequire("8maDO");

var $3TY9o = parcelRequire("3TY9o");

var $8j0rr = parcelRequire("8j0rr");

var $eNZur = parcelRequire("eNZur");
const $c92d349d32b0fe9a$export$249b2e8512031cae = ()=>{
    const location = (0, $3TY9o.useLocation)();
    const route = (0, $8j0rr.useRoute)();
    const { data: connectApps, error: error, loading: loading } = (0, $eNZur.useConnectApps)();
    const isActive = (0, $5uXOq.useMemo)(()=>Boolean((0, $8maDO.findItemAndStack)(connectApps, route.name, location)?.selected), [
        connectApps,
        location,
        route.name
    ]);
    return {
        isActive: isActive,
        loading: loading,
        error: error
    };
};

});
parcelRegister("eNZur", function(module, exports) {

$parcel$export(module.exports, "useConnectApps", () => $5ce3bcf534d9d0ea$export$4864478dcab77643);

var $5uXOq = parcelRequire("5uXOq");

var $loy04 = parcelRequire("loy04");

var $efOLn = parcelRequire("efOLn");

var $9MFH3 = parcelRequire("9MFH3");
const $5ce3bcf534d9d0ea$export$4864478dcab77643 = ()=>{
    const { data: connectResourceItems, error: error, loading: loading } = (0, $loy04.useProjectSettingsSidebarConnectAddonsNavigationResource)();
    const connectApps = (0, $5uXOq.useMemo)(()=>{
        if (connectResourceItems == null) return [];
        const transformedConnectApps = [];
        for (const item of connectResourceItems){
            const transformedItem = (0, $efOLn.transformLinkV4)(item);
            if (transformedItem && !(0, $9MFH3.LEGACY_CONNECT_ITEM_IDS).has(transformedItem.id)) transformedConnectApps.push(transformedItem);
        }
        return transformedConnectApps;
    }, [
        connectResourceItems
    ]);
    return {
        data: connectApps,
        loading: loading,
        error: error
    };
};

});
parcelRegister("9MFH3", function(module, exports) {

$parcel$export(module.exports, "LEGACY_CONNECT_ITEM_IDS", () => $b25e3cd9691dd3ed$export$911a3d81a5d162b6);
// This is a list of known legacy connect item IDs that is used to filter out unecessary connect items
// from being rendered in the connect sections
const $b25e3cd9691dd3ed$export$911a3d81a5d162b6 = new Set([
    // Global Settings Static Legacy IDs
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy IDs
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation'
]);

});



parcelRegister("kqEpF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2c80e831fc4dee6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $c2c80e831fc4dee6$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("jbdYr")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/product-discovery/src/ui/main.tsx"
});
const $c2c80e831fc4dee6$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.jpd-settings",
        packageName: "jiraNavigationAppsSidebarNav4ProjectSettingsJpdSettings",
        ufoName: "nav4.sidebar.project-settings.jpd-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.project-settings.jpd-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2c80e831fc4dee6$var$LazySidebarContent, {
        project: project
    })));
var $c2c80e831fc4dee6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($c2c80e831fc4dee6$var$AsyncSidebar);

});
parcelRegister("jbdYr", function(module, exports) {

let $df69e2504f674ab2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $df69e2504f674ab2$var$load("9Dnuj").then(()=>parcelRequire('aDwWR'));

});


parcelRegister("1G9rm", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmCmpProjectSettingsSidebar", () => $5b1e7bac8593a90d$export$2ce6ad449436c545);

var $5uXOq = parcelRequire("5uXOq");

var $juTur = parcelRequire("juTur");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $84dyl = parcelRequire("84dyl");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $5b1e7bac8593a90d$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("8wGmo")).then(({ JSMCmpProjectSettingsSidebar: JSMCmpProjectSettingsSidebar })=>JSMCmpProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/service-desk/company-managed/src/main.tsx"
});
const $5b1e7bac8593a90d$var$analyticsAttributes = {
    projectStyle: 'cmp',
    // reset '3' being sent from outside-of-nav4 Context. navState is used instead.
    // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
    navVersion: undefined
};
const $5b1e7bac8593a90d$export$2ce6ad449436c545 = /*#__PURE__*/ (0, $5uXOq.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.jsm-cmp-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JsmCmpProjectSettings",
        teamName: "jsm-getting-started",
        ufoName: "nav4.sidebar.jsm-cmp-project-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juTur.ContextualAnalyticsData), {
        menuId: (0, $84dyl.MENU_ID_JSM_SETTINGS),
        attributes: $5b1e7bac8593a90d$var$analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.jsm-cmp-project-settings.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5b1e7bac8593a90d$var$LazySidebarContent, {
        project: project
    })))));

});
parcelRegister("84dyl", function(module, exports) {

$parcel$export(module.exports, "MENU_ID_JSM_SETTINGS", () => $8fdaf51231934b8c$export$4c5fa21d31710030);
$parcel$export(module.exports, "PROJECT_SETTINGS_COMMON_ANALYTICS_ATTRIBUTES", () => $8fdaf51231934b8c$export$8092325c2fa271de);


const $8fdaf51231934b8c$export$4c5fa21d31710030 = 'project/service-desk/settings';
const $8fdaf51231934b8c$var$COMMON_ANALYTICS_ATTRIBUTES = {
    componentType: (0, $1e554a683893bd46$export$4165a3d0da3bd147),
    level: 1
};
const $8fdaf51231934b8c$export$8092325c2fa271de = {
    ...$8fdaf51231934b8c$var$COMMON_ANALYTICS_ATTRIBUTES,
    actionSubjectId: (0, $d59b407ab907bf7b$export$13171e509c859bbf)
};

});

parcelRegister("8wGmo", function(module, exports) {

let $63522bbe24e0a087$var$load = (parcelRequire("28QjX"))(4);
module.exports = $63522bbe24e0a087$var$load("k1zH8").then(()=>parcelRequire('58Da3'));

});


parcelRegister("drQWa", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmTmpProjectSettingsSidebar", () => $723c8db5701ca405$export$dadf0f8c840cb26d);

var $5uXOq = parcelRequire("5uXOq");

var $juTur = parcelRequire("juTur");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $84dyl = parcelRequire("84dyl");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $723c8db5701ca405$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("4tepa")).then(({ JSMTmpProjectSettingsSidebar: JSMTmpProjectSettingsSidebar })=>JSMTmpProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/service-desk/team-managed/src/main.tsx"
});
const $723c8db5701ca405$var$analyticsAttributes = {
    projectStyle: 'tmp',
    // reset '3' being sent from outside-of-nav4 Context. navState is used instead.
    // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
    navVersion: undefined
};
const $723c8db5701ca405$export$dadf0f8c840cb26d = /*#__PURE__*/ (0, $5uXOq.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.jsm-tmp-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JsmTmpProjectSettings",
        teamName: "jsm-getting-started",
        ufoName: "nav4.sidebar.jsm-tmp-project-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juTur.ContextualAnalyticsData), {
        menuId: (0, $84dyl.MENU_ID_JSM_SETTINGS),
        attributes: $723c8db5701ca405$var$analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.jsm-tmp-project-settings.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($723c8db5701ca405$var$LazySidebarContent, {
        project: project
    })))));

});
parcelRegister("4tepa", function(module, exports) {

let $34150b5d08264f9d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $34150b5d08264f9d$var$load("h2MrD"),
    $34150b5d08264f9d$var$load("bYT2S"),
    $34150b5d08264f9d$var$load("2ALx4")
]).then(()=>parcelRequire('dJT47'));

});


parcelRegister("5XLFZ", function(module, exports) {

$parcel$export(module.exports, "AsyncJcsProjectSettingsSidebar", () => $81b56f1e8067cd32$export$e82f1de9c94b7cd9);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $81b56f1e8067cd32$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("hhnIh")).then(({ JcsProjectSettingsSidebar: JcsProjectSettingsSidebar })=>JcsProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/customer-service/src/main.tsx"
});
const $81b56f1e8067cd32$export$e82f1de9c94b7cd9 = /*#__PURE__*/ (0, $5uXOq.memo)(({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.jcs-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JCSProjectSettings",
        teamName: "Boysenberry",
        ufoName: "nav4.sidebar.jcs-project-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.jcs-project-settings.loading-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($81b56f1e8067cd32$var$LazySidebarContent, {
        project: project
    }))));

});
parcelRegister("hhnIh", function(module, exports) {

let $c9466b245f6f4cf2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c9466b245f6f4cf2$var$load("ipMfX").then(()=>parcelRequire('4Cs4A'));

});


parcelRegister("2DtJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd62495e40b7984d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $fd62495e40b7984d$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("7fj2W")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/software/company-managed/src/ui/main.tsx"
});
const $fd62495e40b7984d$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.software.company-managed",
        packageName: "jiraNavigationAppsSidebarNav4SoftwareCompanyManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.software.company-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.project-settings.software.company-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fd62495e40b7984d$var$LazySidebarContent, {
        project: project
    })));
var $fd62495e40b7984d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($fd62495e40b7984d$var$AsyncSidebar);

});
parcelRegister("7fj2W", function(module, exports) {

let $5468b5559112e2b6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5468b5559112e2b6$var$load("iNMXx").then(()=>parcelRequire('cLlaG'));

});


parcelRegister("cnyf1", function(module, exports) {

$parcel$export(module.exports, "default", () => $713dabe47adbee45$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cljJ9 = parcelRequire("cljJ9");

var $7VBev = parcelRequire("7VBev");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $713dabe47adbee45$var$LazySidebarContent = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("3NKqK")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/project/software/team-managed/src/ui/main.tsx"
});
const $713dabe47adbee45$var$AsyncSidebar = ({ project: project })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cljJ9.SidebarBoundary), {
        id: "nav4.sidebar.project-settings.software.team-managed",
        packageName: "jiraNavigationAppsSidebarNav4SoftwareTeamManagedProjectSettings",
        ufoName: "nav4.sidebar.project-settings.software.team-managed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav4.sidebar.project-settings.software.team-managed",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VBev.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($713dabe47adbee45$var$LazySidebarContent, {
        project: project
    })));
var $713dabe47adbee45$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($713dabe47adbee45$var$AsyncSidebar);

});
parcelRegister("3NKqK", function(module, exports) {

let $2c49f6ccbfb98383$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2c49f6ccbfb98383$var$load("cxRoY").then(()=>parcelRequire('4yoHz'));

});


parcelRegister("jnN73", function(module, exports) {

$parcel$export(module.exports, "useConfigParam", () => $bf62a20c6a76ddbe$export$b8842df7174e4acb);
$parcel$export(module.exports, "useMaybeConfigParam", () => $bf62a20c6a76ddbe$export$2135334620af5209);

var $4R6GH = parcelRequire("4R6GH");

var $bmKPg = parcelRequire("bmKPg");
var $ieDtd = parcelRequire("ieDtd");

var $e5wyW = parcelRequire("e5wyW");

var $3HwlS = parcelRequire("3HwlS");

var $c1mlA = parcelRequire("c1mlA");
const $bf62a20c6a76ddbe$export$b8842df7174e4acb = (0, $e5wyW.functionWithCondition)(()=>((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && // Delete line when cleaning up blu-7261
    (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route'), $bf62a20c6a76ddbe$var$useConfigParamNew, $bf62a20c6a76ddbe$var$useConfigQueryOld);
function $bf62a20c6a76ddbe$var$useConfigQueryOld() {
    const [configQuery] = (0, $ieDtd.useQueryParam)('config');
    if (!configQuery) throw new Error('No config param found');
    const result = $bf62a20c6a76ddbe$var$isConfigQuery(configQuery) ? configQuery : null;
    return result;
}
function $bf62a20c6a76ddbe$var$useConfigParamNew() {
    const configParam = $bf62a20c6a76ddbe$export$2135334620af5209();
    if (!configParam) throw new Error('No config param found');
    const result = $bf62a20c6a76ddbe$var$isConfigQuery(configParam) ? configParam : null;
    return result;
}
function $bf62a20c6a76ddbe$export$2135334620af5209() {
    const [configPath] = (0, $bmKPg.usePathParam)('config');
    const [configQuery] = (0, $ieDtd.useQueryParam)('config');
    return configPath || configQuery;
}
const $bf62a20c6a76ddbe$var$isConfigQuery = (configQuery)=>(0, $c1mlA.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(configQuery);

});


parcelRegister("fwGlt", function(module, exports) {

$parcel$export(module.exports, "getNav4SidebarId", () => $2dc081c673538ce6$export$8cea2a93fc3986aa);
$parcel$export(module.exports, "useGetParamsForGetNav4SidebarId", () => $2dc081c673538ce6$export$e102a5137dc15645);

var $5uXOq = parcelRequire("5uXOq");

var $lmyls = parcelRequire("lmyls");

var $c1mlA = parcelRequire("c1mlA");

var $4R6GH = parcelRequire("4R6GH");

var $Tdcaw = parcelRequire("Tdcaw");

var $kNJsg = parcelRequire("kNJsg");

var $YiTdm = parcelRequire("YiTdm");

var $8J6rn = parcelRequire("8J6rn");

var $lODMY = parcelRequire("lODMY");

var $jnN73 = parcelRequire("jnN73");
function $2dc081c673538ce6$export$8cea2a93fc3986aa(params) {
    const { configParam: configParam, isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive, isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive, isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive, routerState: routerState, shouldUseJSM: shouldUseJSM } = params;
    const sidebarId = routerState.route.navigation?.sidebarId;
    const pathname = routerState.location.pathname;
    // Deal with the exceptions...
    if (sidebarId === (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS && !pathname.includes('/discover')) return sidebarId;
    if (sidebarId === (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS) {
        if (pathname.includes('/jira-service-management-chatops-and-video-tools') && shouldUseJSM && (0, $4R6GH.fg)('fix_chatops_new_nav_bug')) return (0, $lmyls.SIDEBAR_ID).CONTENT;
        return sidebarId;
    }
    // Project settings sidebars
    if (routerState.route.name === 'polaris-ideas' && routerState.match.params.section === 'settings' || isProjectSettingsConnectAppActive) return (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS;
    // Board settings sidebar
    if (routerState.route.group === 'classic-software' && (0, $c1mlA.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(configParam) && (0, $4R6GH.fg)('simplified-boards-milestone-2_07hbk')) return (0, $lmyls.SIDEBAR_ID).BOARD_SETTINGS;
    if (isGlobalAppsSettingsConnectItemActive) return (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS;
    if (isGlobalSystemSettingsConnectItemActive) return (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS;
    return sidebarId || (0, $lmyls.SIDEBAR_ID).CONTENT;
}
function $2dc081c673538ce6$export$e102a5137dc15645(params = {}) {
    const { routerState: routerState = (0, $lODMY.getRouterState)() } = params;
    const { isActive: isGlobalAppsSettingsConnectItemActive } = (0, $Tdcaw.useGlobalAppsSettingsConnectItemActive)();
    const { isActive: isGlobalSystemSettingsConnectItemActive } = (0, $kNJsg.useGlobalSystemSettingsConnectItemActive)();
    const { isActive: isProjectSettingsConnectAppActive } = (0, $YiTdm.useIsConnectAppActive)();
    const { shouldUseJSM: shouldUseJSM } = (0, $8J6rn.useOgTenantInfo)();
    const configParam = (0, $jnN73.useMaybeConfigParam)() || '';
    const data = (0, $5uXOq.useMemo)(()=>({
            configParam: configParam,
            isGlobalAppsSettingsConnectItemActive: isGlobalAppsSettingsConnectItemActive,
            isGlobalSystemSettingsConnectItemActive: isGlobalSystemSettingsConnectItemActive,
            isProjectSettingsConnectAppActive: isProjectSettingsConnectAppActive,
            routerState: routerState,
            shouldUseJSM: shouldUseJSM
        }), [
        configParam,
        isGlobalAppsSettingsConnectItemActive,
        isGlobalSystemSettingsConnectItemActive,
        isProjectSettingsConnectAppActive,
        routerState,
        shouldUseJSM
    ]);
    return data;
}

});


parcelRegister("gxq4u", function(module, exports) {

$parcel$export(module.exports, "messages", () => $17a71abc75e8d96c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $17a71abc75e8d96c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    sidebarNavigation: {
        "id": "page-container-v2.common.sidebar.sidebar-navigation",
        "defaultMessage": "Sidebar navigation"
    },
    sideBarPanelSplitterLabel: {
        "id": "page-container-v2.common.sidebar.side-bar-panel-splitter-label",
        "defaultMessage": "Resize side navigation panel"
    },
    globalInviteButtonLabel: {
        "id": "page-container-v2.common.sidebar.global-invite-button-label",
        "defaultMessage": "Invite people"
    }
});

});

parcelRegister("7x18A", function(module, exports) {

$parcel$export(module.exports, "AsyncResizeButtonTooltip", () => $15587b8ab3be3aba$export$e12f5b3a390577de);

var $b7Svb = parcelRequire("b7Svb");

const $15587b8ab3be3aba$export$e12f5b3a390577de = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("6Atwz")), {
    ssr: false,
    moduleId: "./src/packages/page-container-v2/src/common/ui/sidebar/resize-button-tooltip/main.tsx"
});

});
parcelRegister("6Atwz", function(module, exports) {

let $4cbd01cda671fce8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4cbd01cda671fce8$var$load("ikCLZ").then(()=>parcelRequire('iIrS6'));

});



parcelRegister("gxCm0", function(module, exports) {

$parcel$export(module.exports, "TopNav", () => $5815562a2673ba2a$export$41d0d88a6b0e456f);

var $5uXOq = parcelRequire("5uXOq");

var $5e7oM = parcelRequire("5e7oM");

var $azzrO = parcelRequire("azzrO");

var $Mp6qH = parcelRequire("Mp6qH");

var $ghgbB = parcelRequire("ghgbB");

var $eoNiZ = parcelRequire("eoNiZ");

var $e6AHy = parcelRequire("e6AHy");


var $gwIPs = parcelRequire("gwIPs");

var $7CMCs = parcelRequire("7CMCs");

var $93jKl = parcelRequire("93jKl");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $3bl6P = parcelRequire("3bl6P");

var $9aaiB = parcelRequire("9aaiB");

var $5X3WH = parcelRequire("5X3WH");

var $3HwlS = parcelRequire("3HwlS");

var $iqLcb = parcelRequire("iqLcb");

var $lfTZh = parcelRequire("lfTZh");

var $5M3R9 = parcelRequire("5M3R9");

var $l8ruj = parcelRequire("l8ruj");

var $erBFB = parcelRequire("erBFB");

var $dm0Uk = parcelRequire("dm0Uk");

var $iIpJ6 = parcelRequire("iIpJ6");
/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $5815562a2673ba2a$var$APP_NAVIGATION_TRACE_KEY = 'app_navigation';
const $5815562a2673ba2a$var$LegacyPageNavigationStyles = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    #page-body { width: 100vw; max-width: 100%; }
                    #cloneissueprogressform { margin-top: ${(0, $gwIPs.gridSize) * 3}px; }
                    [data-testid="Content"] {margin-top: calc(${(0, $81918a2ef6db1f93$export$d60454526e2281af)})!important;}
                    #view-projects-content { margin-top: calc(-1 * ${(0, $81918a2ef6db1f93$export$d60454526e2281af)}); } /* admin project dir hack */
                `
        }
    });
/**
 * This test ID is used in pollinator tests. Do not change lightly.
 * It's only added once the component is rendered client-side.
 */ const $5815562a2673ba2a$var$TEST_ID = 'page-layout.top-nav';
function $5815562a2673ba2a$var$NewTopNav() {
    const { shouldRender: shouldRender } = (0, $9aaiB.useTopNavState)();
    const theme = (0, $eoNiZ.useNav4Theme)();
    // Signal that Nav4 has been seen. Memoized, so it's safe to use it like this.
    if ((0, $4R6GH.fg)('jira_nav_version_exposure')) (0, $5X3WH.sendNavExposure)({
        componentName: 'nav4'
    });
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4.topNav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "topNavigationSkipLink",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.TopNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5815562a2673ba2a$var$LegacyPageNavigationStyles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.TopNavigation), {
        isFixed: true,
        testId: $5815562a2673ba2a$var$TEST_ID,
        theme: theme
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ghgbB.AtlassianNavigationStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "navigation.atlassian-navigation",
        packageName: "jiraPageContainerV2",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.PlaceholderNew), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e6AHy.JiraAtlassianNavigationSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iIpJ6.AsyncAtlassianNavigation), null)))));
}
/**
 * This has been inlined from `@atlassian/jira-common-constants/src/page-layout`
 * because it isn't used anywhere else, and to prevent new usage.
 */ const $5815562a2673ba2a$var$HORIZONTAL_GLOBAL_NAV_HEIGHT = 56;
/**
 * Implements a responsive top navigation bar that adjusts for fullscreen view and renders
 * based on application state. It ensures seamless navigation experience across different
 * sections of the application while handling errors gracefully and tracking performance.
 */ function $5815562a2673ba2a$var$OldTopNav() {
    const fullscreenRef = (0, $5uXOq.useRef)(null);
    const { isFullscreen: isFullscreen } = (0, $3bl6P.useIsFullscreen)(fullscreenRef.current);
    const { shouldRender: shouldRender } = (0, $9aaiB.useTopNavState)();
    const onFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MAIN)
    });
    if ((0, $4R6GH.fg)('jira_nav_version_exposure')) (0, $5X3WH.sendNavExposure)({
        componentName: 'nav3'
    });
    const height = isFullscreen ? 0 : $5815562a2673ba2a$var$HORIZONTAL_GLOBAL_NAV_HEIGHT;
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "top-navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "topNavigationSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.TopNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5815562a2673ba2a$var$LegacyPageNavigationStyles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dm0Uk.ZIndexWrapper), {
        zIndex: (0, $gwIPs.layers).navigation,
        // @ts-expect-error - TS2322 - Type '{ children: Element; zIndex: 200; top: string; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<ThemedOuterStyledProps<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, any>, any, any>> & Readonly<...> & Readonly<...>'.
        top: (0, $iqLcb.UNSAFE_DO_NOT_USE_BANNER_HEIGHT),
        "data-fullscreen-id": "fullscreen.page-container-v2.topnav",
        ref: fullscreenRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.TopNavigation), {
        isFixed: true,
        height: height,
        id: "ak-jira-navigation"
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ghgbB.AtlassianNavigationStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "navigation.atlassian-navigation",
        packageName: "jiraPageContainer",
        fallback: "flag",
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e6AHy.JiraAtlassianNavigationSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavTopPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_TOP_MARKS).bundleLoadStart
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavTopSSRPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderSsrStart
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        type: "start",
        traceKey: $5815562a2673ba2a$var$APP_NAVIGATION_TRACE_KEY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iIpJ6.AsyncAtlassianNavigation), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        type: "end",
        traceKey: $5815562a2673ba2a$var$APP_NAVIGATION_TRACE_KEY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavTopSSRPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderSsrEnd
    }))))));
}
const $5815562a2673ba2a$export$41d0d88a6b0e456f = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $5815562a2673ba2a$var$NewTopNav, $5815562a2673ba2a$var$OldTopNav);

});
parcelRegister("ghgbB", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigationStart", () => $d610646e169deef8$export$831e6a6e875b5ef8);

var $5uXOq = parcelRequire("5uXOq");

var $kaHBi = parcelRequire("kaHBi");

var $8CVvd = parcelRequire("8CVvd");


var $4oDnX = parcelRequire("4oDnX");

var $6IzHB = parcelRequire("6IzHB");

var $doZTA = parcelRequire("doZTA");

var $Mp6qH = parcelRequire("Mp6qH");
const $d610646e169deef8$export$831e6a6e875b5ef8 = ()=>{
    const [{ location: location }] = (0, $doZTA.useRouter)();
    const [, { setAppStartWithAppId: setAppStartWithAppId }] = (0, $4oDnX.useSpaStateActions)();
    const pageId = (0, $6IzHB.usePageId)();
    const startRef = (0, $5uXOq.useRef)({
        location: location,
        startTime: Date.now()
    });
    (0, $5uXOq.useMemo)(()=>{
        if (location !== startRef.current.location) startRef.current = {
            location: location,
            startTime: Date.now()
        };
    }, [
        location
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setAppStartWithAppId((0, $146ecce9d079a34d$export$3a54edb6ba4daa82), startRef.current.startTime);
    }, [
        location,
        setAppStartWithAppId
    ]);
    return (0, $8CVvd.getWillShowNav3)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaHBi.ExperienceStart), {
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MAIN),
        analyticsSource: "atlassian-navigation",
        experienceId: pageId
    });
};

});

parcelRegister("eoNiZ", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $96d5309c36bfdfee$export$93d4e7f90805808f);
$parcel$export(module.exports, "useNav4Theme", () => $96d5309c36bfdfee$export$b761e7abf0bdf352);

var $5uXOq = parcelRequire("5uXOq");

var $ltsrX = parcelRequire("ltsrX");

var $zbAwE = parcelRequire("zbAwE");
var $6VxGE = parcelRequire("6VxGE");

var $9MAC1 = parcelRequire("9MAC1");

var $2Ql51 = parcelRequire("2Ql51");

var $bt2pf = parcelRequire("bt2pf");

var $ihBhD = parcelRequire("ihBhD");
const $96d5309c36bfdfee$var$caseInsensitiveEquals = (one, two)=>one.toLowerCase() === two.toLowerCase();
const $96d5309c36bfdfee$var$calculateBackground = (backgroundColor, isDarkMode)=>{
    // White is a proxy for 'default' when setting accent colours, we really want to default to 'elevation.surface'
    if ($96d5309c36bfdfee$var$caseInsensitiveEquals(backgroundColor, '#ffffff')) {
        // getTokenValue doesn't work in SSR thus hardcode, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
        const fallback = isDarkMode ? '#1d2125' : '#ffffff';
        // Can't be getToken() as AK Nav needs a hex string. It parses it to determine the correct text color
        return (0, $zbAwE.default)('elevation.surface', fallback);
    }
    return isDarkMode ? (0, $ihBhD.capLightness)(backgroundColor, 35) : backgroundColor;
};
const $96d5309c36bfdfee$var$useIsDarkThemeResolver = ()=>{
    // The best source of theme info. But doesn't work in SSR, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    // This works in SSR, but we need the browser to resolve 'auto', so we are wrong in SSR if 'auto' resolves to 'dark'
    const { theme: preference } = (0, $2Ql51.useThemePreference)();
    return false ? preference === 'dark' : colorMode === 'dark';
};
const $96d5309c36bfdfee$export$93d4e7f90805808f = ()=>{
    const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, $9MAC1.useTheme)();
    const isDarkMode = $96d5309c36bfdfee$var$useIsDarkThemeResolver();
    const bg = (0, $5uXOq.useMemo)(()=>$96d5309c36bfdfee$var$calculateBackground(backgroundColor, isDarkMode), [
        backgroundColor,
        isDarkMode
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $bt2pf.addThemeColor)(bg);
    }, [
        bg
    ]);
    if (!usesCustomColours) return undefined;
    return (0, $ltsrX.generateTheme)({
        name: 'jira',
        backgroundColor: bg,
        highlightColor: highlightColor
    });
};
const $96d5309c36bfdfee$export$b761e7abf0bdf352 = ()=>{
    /**
   * The colors chosen by the site admin in the site settings
   */ const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, $9MAC1.useTheme)();
    /**
   * Whether the user is currently using dark mode,
   * or their configured preference if this is SSR.
   */ const isDarkMode = $96d5309c36bfdfee$var$useIsDarkThemeResolver();
    /**
   * The adjusted background color.
   *
   * When the user is in dark mode, the lightness of the background color is capped.
   */ const bg = (0, $5uXOq.useMemo)(()=>$96d5309c36bfdfee$var$calculateBackground(backgroundColor, isDarkMode), [
        backgroundColor,
        isDarkMode
    ]);
    /**
   * Creates / updates a theme-color meta tag:
   * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta/name/theme-color
   *
   * Some browsers will use this to change the color of their UI.
   */ (0, $5uXOq.useEffect)(()=>{
        (0, $bt2pf.addThemeColor)(bg);
    }, [
        bg
    ]);
    if (!usesCustomColours) return undefined;
    return {
        backgroundColor: bg,
        highlightColor: highlightColor
    };
};

});
parcelRegister("bt2pf", function(module, exports) {

$parcel$export(module.exports, "addThemeColor", () => $274a73c0f1d6297a$export$7b20d133831b2b0f);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
const $274a73c0f1d6297a$var$getMetaNode = (name)=>document.querySelector(`meta[name="${name}"]`);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $274a73c0f1d6297a$var$getHead = ()=>document.head || document.querySelector('head');
const $274a73c0f1d6297a$export$7b20d133831b2b0f = (content)=>{
    if (!content || typeof document === 'undefined' || false) return;
    const existingMeta = $274a73c0f1d6297a$var$getMetaNode('theme-color');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const meta = document.createElement('meta');
    meta.name = 'theme-color';
    meta.content = content;
    if (existingMeta) existingMeta.replaceWith?.(meta);
    else {
        const head = $274a73c0f1d6297a$var$getHead();
        if (head) head.appendChild?.(meta);
    }
};

});

parcelRegister("ihBhD", function(module, exports) {

$parcel$export(module.exports, "capLightness", () => $dbd7508aaed6851f$export$8b5544bab97b10dd);
const $dbd7508aaed6851f$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $dbd7508aaed6851f$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $dbd7508aaed6851f$var$rgbFromHex = (input)=>{
    const fullHex = $dbd7508aaed6851f$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $dbd7508aaed6851f$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $dbd7508aaed6851f$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $dbd7508aaed6851f$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $dbd7508aaed6851f$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $dbd7508aaed6851f$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $dbd7508aaed6851f$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $dbd7508aaed6851f$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $dbd7508aaed6851f$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $dbd7508aaed6851f$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $dbd7508aaed6851f$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $dbd7508aaed6851f$var$rgbToLch = (rgb)=>$dbd7508aaed6851f$var$labToLch($dbd7508aaed6851f$var$xyzToLab($dbd7508aaed6851f$var$rgbToXyz(rgb)));
const $dbd7508aaed6851f$var$lchToRgb = (lch)=>$dbd7508aaed6851f$var$xyzToRgb($dbd7508aaed6851f$var$labToXyz($dbd7508aaed6851f$var$lchToLab(lch)));
const $dbd7508aaed6851f$export$8b5544bab97b10dd = (color, capPercent)=>{
    const rgb = $dbd7508aaed6851f$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $dbd7508aaed6851f$var$rgbToLch(rgb);
    if (lch.l > capPercent) lch.l = $dbd7508aaed6851f$var$clamp(capPercent, 0, 100);
    return $dbd7508aaed6851f$var$rgbToHex($dbd7508aaed6851f$var$lchToRgb(lch));
};

});


parcelRegister("e6AHy", function(module, exports) {

$parcel$export(module.exports, "JiraAtlassianNavigationSkeleton", () => $33751c6bf425b3ee$export$38e532bc6b824200);

var $5uXOq = parcelRequire("5uXOq");

var $6hU4c = parcelRequire("6hU4c");

var $8iquX = parcelRequire("8iquX");

var $eoNiZ = parcelRequire("eoNiZ");
const $33751c6bf425b3ee$export$38e532bc6b824200 = ()=>{
    const theme = (0, $eoNiZ.useTheme)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iquX.default), {
        name: "top-navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6hU4c.NavigationSkeleton), {
        theme: theme
    }));
};

});
parcelRegister("6hU4c", function(module, exports) {

$parcel$export(module.exports, "NavigationSkeleton", () => $701e64f3add55f03$export$ad5e8e6ace98cc2);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");



var $4ZDdq = parcelRequire("4ZDdq");
var $C4qHS = parcelRequire("C4qHS");

var $13iPf = parcelRequire("13iPf");

var $iqgsD = parcelRequire("iqgsD");

var $gHHeZ = parcelRequire("gHHeZ");

var $gGkCN = parcelRequire("gGkCN");

var $8cGQh = parcelRequire("8cGQh");
function $701e64f3add55f03$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $701e64f3add55f03$var$containerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $40a49d4606bee4e1$export$30fa7cc5f2690a43),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $a7f8c6b391092279$export$3e51e8f1440314ba)})`}`,
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
const $701e64f3add55f03$var$leftStyles = {
    name: "vtikxo",
    styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
};
const $701e64f3add55f03$var$rightStyles = {
    name: "1mwlrd6",
    styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
};
const $701e64f3add55f03$export$ad5e8e6ace98cc2 = ({ primaryItemsCount: primaryItemsCount = 4, secondaryItemsCount: secondaryItemsCount = 4, theme: theme = (0, $4ZDdq.defaultTheme), showSiteName: showSiteName = false, shouldShowSearch: shouldShowSearch = true, testId: testId })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $C4qHS.ThemeProvider), {
        value: theme
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $701e64f3add55f03$var$containerStyles,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $701e64f3add55f03$var$leftStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $13iPf.IconButtonSkeleton), {
        marginLeft: 0,
        marginRight: 5,
        size: 26
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gHHeZ.ProductHomeSkeleton), {
        showSiteName: showSiteName
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iqgsD.PrimaryItemsContainerSkeleton), {
        count: primaryItemsCount
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $701e64f3add55f03$var$rightStyles
    }, shouldShowSearch && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8cGQh.SearchSkeleton), null), Array.from({
        length: secondaryItemsCount
    }, (_, index)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $13iPf.IconButtonSkeleton), {
            key: index,
            marginLeft: 0,
            marginRight: 4,
            size: 26
        })), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gGkCN.ProfileSkeleton), null))));
};

});
const $40a49d4606bee4e1$export$30fa7cc5f2690a43 = 56;
const $40a49d4606bee4e1$export$4033a111ca79977d = 1280;
const $40a49d4606bee4e1$export$24ec62cee78b7042 = 1130;
const $40a49d4606bee4e1$export$d8bde68ac946124f = '--ds--ans--fbc';
const $40a49d4606bee4e1$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $40a49d4606bee4e1$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $40a49d4606bee4e1$export$d81606c1fc5119bc = '--ds--ans--c';
const $40a49d4606bee4e1$export$65f656ad520ea71 = '--ds--ans--bc';

parcelRegister("13iPf", function(module, exports) {

$parcel$export(module.exports, "IconButtonSkeleton", () => $768258e4aced739d$export$7a24471cb6f25433);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $h4hQR = parcelRequire("h4hQR");
function $768258e4aced739d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $768258e4aced739d$var$buttonHeight = "var(--ds-space-400, 32px)";
const $768258e4aced739d$var$skeletonStyles = {
    name: "28gj0e",
    styles: "border-radius:var(--ds-border-radius-circle, 50%);opacity:0.15"
};
const $768258e4aced739d$export$7a24471cb6f25433 = ({ className: className, marginLeft: marginLeft, marginRight: marginRight, size: size })=>{
    const theme = (0, $h4hQR.useTheme)();
    const dynamicStyles = {
        marginLeft: typeof marginLeft === 'number' ? marginLeft : "var(--ds-space-050, 4px)",
        marginRight: typeof marginRight === 'number' ? marginRight : 0,
        width: typeof size === 'number' ? size : $768258e4aced739d$var$buttonHeight,
        height: typeof size === 'number' ? size : $768258e4aced739d$var$buttonHeight,
        ...theme.mode.skeleton
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: dynamicStyles,
        css: $768258e4aced739d$var$skeletonStyles
    });
};

});

parcelRegister("iqgsD", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemsContainerSkeleton", () => $f6e908764755f16a$export$fdfc48d2117b79a8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $bNKCD = parcelRequire("bNKCD");
function $f6e908764755f16a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f6e908764755f16a$var$primaryButtonSkeletonStyles = {
    name: "yn5kop",
    styles: "margin-inline-end:var(--ds-space-150, 12px);margin-inline-start:var(--ds-space-150, 12px)"
};
const $f6e908764755f16a$export$fdfc48d2117b79a8 = /*#__PURE__*/ (0, $5uXOq.memo)(({ count: count })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, Array.from({
        length: count
    }, (_, index)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bNKCD.PrimaryButtonSkeleton), {
            key: index,
            css: $f6e908764755f16a$var$primaryButtonSkeletonStyles
        }))));

});
parcelRegister("bNKCD", function(module, exports) {

$parcel$export(module.exports, "PrimaryButtonSkeleton", () => $24210aaecd71fe68$export$4bc51fe36728414d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $h4hQR = parcelRequire("h4hQR");
const $24210aaecd71fe68$var$paddingAll = 4;
const $24210aaecd71fe68$var$buttonHeight = 32;
const $24210aaecd71fe68$var$skeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    width: '68px',
    height: `${$24210aaecd71fe68$var$buttonHeight - $24210aaecd71fe68$var$paddingAll * 2.5}px`,
    borderRadius: "var(--ds-border-radius, 4px)",
    opacity: 0.15
});
const $24210aaecd71fe68$export$4bc51fe36728414d = (props)=>{
    const theme = (0, $h4hQR.useTheme)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $24210aaecd71fe68$var$skeletonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    });
};

});


parcelRegister("gHHeZ", function(module, exports) {

$parcel$export(module.exports, "ProductHomeSkeleton", () => $6d926541f4bd10f5$export$3e79e535d76cce4b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $h4hQR = parcelRequire("h4hQR");

var $hNUWC = parcelRequire("hNUWC");
const $6d926541f4bd10f5$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $6d926541f4bd10f5$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $6d926541f4bd10f5$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $6d926541f4bd10f5$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $6d926541f4bd10f5$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $6d926541f4bd10f5$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $6d926541f4bd10f5$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $6d926541f4bd10f5$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $6d926541f4bd10f5$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $6d926541f4bd10f5$var$VAR_SITE_TITLE_BG_COLOR_AFTER = '--site-title-bg-color-after';
const $6d926541f4bd10f5$var$productHomeButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:active': {
        backgroundColor: `var(${$6d926541f4bd10f5$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$6d926541f4bd10f5$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$6d926541f4bd10f5$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus': {
        backgroundColor: `var(${$6d926541f4bd10f5$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        boxShadow: `var(${$6d926541f4bd10f5$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS})`,
        color: `var(${$6d926541f4bd10f5$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: 0
    },
    '&:hover': {
        backgroundColor: `var(${$6d926541f4bd10f5$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$6d926541f4bd10f5$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$6d926541f4bd10f5$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $40a49d4606bee4e1$export$4033a111ca79977d) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $40a49d4606bee4e1$export$4033a111ca79977d}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $6d926541f4bd10f5$var$productLogoStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    width: 120,
    maxWidth: 120,
    height: 24,
    maxHeight: 28,
    opacity: 0.15,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $40a49d4606bee4e1$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
const $6d926541f4bd10f5$var$productIconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    width: 28,
    height: 28,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    opacity: 0.15,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $40a49d4606bee4e1$export$4033a111ca79977d}px)`]: {
        display: 'none'
    }
});
const $6d926541f4bd10f5$var$siteTitleStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    width: "var(--ds-space-500, 40px)",
    alignItems: 'center',
    backgroundColor: 'transparent',
    marginInlineEnd: "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        width: '100%',
        height: 14,
        backgroundColor: `var(${$6d926541f4bd10f5$var$VAR_SITE_TITLE_BG_COLOR_AFTER})`,
        borderRadius: "var(--ds-border-radius, 4px)",
        content: '""'
    }
});
const $6d926541f4bd10f5$export$3e79e535d76cce4b = ({ showSiteName: showSiteName })=>{
    const theme = (0, $h4hQR.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const productHomeButtonDynamicStyles = (0, $hNUWC.stripEmptyProperties)({
        [$6d926541f4bd10f5$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$6d926541f4bd10f5$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$6d926541f4bd10f5$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$6d926541f4bd10f5$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$6d926541f4bd10f5$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$6d926541f4bd10f5$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$6d926541f4bd10f5$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$6d926541f4bd10f5$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$6d926541f4bd10f5$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
        [$6d926541f4bd10f5$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
    });
    const siteTitleDynamicStyles = {
        borderRight: theme.mode.productHome.borderRight,
        opacity: theme.mode.skeleton.opacity,
        [$6d926541f4bd10f5$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $6d926541f4bd10f5$var$productHomeButtonStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $6d926541f4bd10f5$var$productLogoStyles
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $6d926541f4bd10f5$var$productIconStyles
    })), showSiteName && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: siteTitleDynamicStyles,
        css: $6d926541f4bd10f5$var$siteTitleStyles
    }));
};

});

parcelRegister("gGkCN", function(module, exports) {

$parcel$export(module.exports, "ProfileSkeleton", () => $2186406f17a7a5d0$export$2bab43fd33adda3b);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $13iPf = parcelRequire("13iPf");
const $2186406f17a7a5d0$export$2bab43fd33adda3b = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $13iPf.IconButtonSkeleton), {
        marginLeft: 6,
        marginRight: 6,
        size: 26
    });

});

parcelRegister("8cGQh", function(module, exports) {

$parcel$export(module.exports, "SearchSkeleton", () => $4566752dfe235097$export$d8fbade3e5bbb8e0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $h4hQR = parcelRequire("h4hQR");

var $13iPf = parcelRequire("13iPf");
const $4566752dfe235097$var$searchInputContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginRight: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginLeft: "var(--ds-space-250, 20px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $40a49d4606bee4e1$export$24ec62cee78b7042) - 1}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        display: 'none !important'
    }
});
const $4566752dfe235097$var$searchInputSkeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxSizing: 'border-box',
    width: '220px',
    height: "var(--ds-space-400, 32px)",
    padding: `0 ${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-500, 40px)"}`,
    borderRadius: "var(--ds-border-radius-200, 6px)",
    opacity: 0.15
});
const $4566752dfe235097$var$searchIconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $40a49d4606bee4e1$export$24ec62cee78b7042}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        display: 'none !important'
    }
});
const $4566752dfe235097$export$d8fbade3e5bbb8e0 = ()=>{
    const theme = (0, $h4hQR.useTheme)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $4566752dfe235097$var$searchInputContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $4566752dfe235097$var$searchInputSkeletonStyles
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $13iPf.IconButtonSkeleton), {
        css: $4566752dfe235097$var$searchIconStyles,
        marginRight: 5,
        size: 26
    }));
};

});



parcelRegister("3bl6P", function(module, exports) {

$parcel$export(module.exports, "useIsFullscreen", () => $0124d1f81a2437a4$export$d397eccea5f37b0a);

var $5uXOq = parcelRequire("5uXOq");
const $0124d1f81a2437a4$var$fullscreenClassnameExists = (target)=>target?.classList.contains('fullscreen') ?? false;
const $0124d1f81a2437a4$export$d397eccea5f37b0a = (target)=>{
    const [isFullscreen, setIsFullscreen] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        const handleFullscreen = ()=>{
            setIsFullscreen($0124d1f81a2437a4$var$fullscreenClassnameExists(target));
        };
        const mutationObserver = new MutationObserver(handleFullscreen);
        if (target) mutationObserver.observe(target, {
            attributes: true
        });
        return ()=>mutationObserver.disconnect();
    }, [
        target
    ]);
    return {
        isFullscreen: isFullscreen
    };
};

});

parcelRegister("9aaiB", function(module, exports) {

$parcel$export(module.exports, "useTopNavState", () => $dd484d7e2bde5991$export$bccbd45ab793bd09);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $dd484d7e2bde5991$var$useTopNav = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>({
            ...state.topNavigation,
            shouldRender: !state.isChromeless
        })
});
const $dd484d7e2bde5991$export$bccbd45ab793bd09 = ()=>{
    const [state] = $dd484d7e2bde5991$var$useTopNav();
    return state;
};

});

parcelRegister("5X3WH", function(module, exports) {

$parcel$export(module.exports, "sendNavExposure", () => $f4ce7b379b641f97$export$4d75b96ec704d87d);

var $gJBT6 = parcelRequire("gJBT6");

var $4R6GH = parcelRequire("4R6GH");

var $3F9p6 = parcelRequire("3F9p6");

var $fjcgS = parcelRequire("fjcgS");
const $f4ce7b379b641f97$export$4d75b96ec704d87d = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($f4ce7b379b641f97$var$_sendNavExposure, (p)=>p.componentName);
/**
 * Note: The componentName is being used as the actionSubject.
 *       When a new navigation-version is released, it will require registering
 *       a new GASv3 event and a new trait. THIS IS BY DESIGN, as the creation
 *       of new navigation systems is infrequent (every 2-3 years).
 */ function $f4ce7b379b641f97$var$_sendNavExposure(params) {
    const { componentName: componentName } = params;
    if ((0, $4R6GH.fg)('jira_mobile_opt_out_nav4_trait')) {
        const nav4RolloutStage = (0, $3F9p6.getNav4Rollout)().stage;
        /**
		 * Prevent mobile nav4 views from registering the trait as having seen Nav4
		 * This is because mobile users have only seen a small subset of Nav4
		 */ if (nav4RolloutStage === 'mobile') // Return the component name to help memoize do it's job
        return componentName;
    }
    // This analytics event updates it's corresponding TAP trait,
    // once the GAS event is registered, and then the TAP trait is registered.
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.getInstance().sendTrackEvent({
            actionSubject: componentName,
            action: 'viewed',
            source: 'navExposure',
            attributes: {}
        });
    });
    // Return the component name to help memoize do it's job
    return componentName;
}

});

parcelRegister("iIpJ6", function(module, exports) {

$parcel$export(module.exports, "AsyncAtlassianNavigation", () => $8c4a7263d22ebdbf$export$932edb7b1b20d079);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $adY3A = parcelRequire("adY3A");

var $jC2al = parcelRequire("jC2al");

var $e6AHy = parcelRequire("e6AHy");

var $fDtbf = parcelRequire("fDtbf");


var $2Ioew = parcelRequire("2Ioew");

var $frBVt = parcelRequire("frBVt");

var $2SVPM = parcelRequire("2SVPM");
const $8c4a7263d22ebdbf$export$932edb7b1b20d079 = ()=>{
    const topNavEntryPointReference = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae));
    (0, $5uXOq.useState)(()=>{
        if (!false && topNavEntryPointReference) /* @ts-expect-error - TS2339 - We're using JSResourceReference from @atlassian/react-async. */ (0, $adY3A.topNavigationEntryPoint).root.onComplete(()=>{
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
            const resources = performance.getEntriesByType('mark');
            for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $fDtbf.JS_EVAL_START))) {
                (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
                break;
            }
        });
        return undefined;
    });
    return topNavEntryPointReference ? // There is already a Placeholder in parent
    // remove this one when EntryPointPlaceholder merges with Placeholder
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointReferencePlaceholder), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e6AHy.JiraAtlassianNavigationSkeleton), null),
        entryPointReference: topNavEntryPointReference
    }, topNavEntryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: topNavEntryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jC2al.AtlassianNavigation), null);
};

});
parcelRegister("jC2al", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigation", () => $ad8c46bf54ef52df$export$f66ccb39f60980e5);

var $7XYc4 = parcelRequire("7XYc4");

var $6s1PB = parcelRequire("6s1PB");

var $ffza4 = parcelRequire("ffza4");

var $9DfkH = parcelRequire("9DfkH");
const $ad8c46bf54ef52df$export$f66ccb39f60980e5 = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('blu-6139_sync_load_nav4_top_bar', 'isEnabled', false), (0, $9DfkH.default), (0, $ffza4.LazyAtlassianNavigation));

});
parcelRegister("9DfkH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "AtlassianNavigation", () => $daeb815c48fa02e2$export$f66ccb39f60980e5);
$parcel$export(module.exports, "default", () => $daeb815c48fa02e2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $43icZ = parcelRequire("43icZ");

var $5e7oM = parcelRequire("5e7oM");

var $azzrO = parcelRequire("azzrO");

var $13iNl = parcelRequire("13iNl");

var $4keKa = parcelRequire("4keKa");

var $9WcgH = parcelRequire("9WcgH");

var $bcn6L = parcelRequire("bcn6L");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $jQsty = parcelRequire("jQsty");

var $c0dQj = parcelRequire("c0dQj");

var $bBulW = parcelRequire("bBulW");

var $hwY9o = parcelRequire("hwY9o");

var $jzLyJ = parcelRequire("jzLyJ");

var $3HwlS = parcelRequire("3HwlS");

var $6jY6G = parcelRequire("6jY6G");

var $dAfqg = parcelRequire("dAfqg");

var $apeap = parcelRequire("apeap");

var $daoB1 = parcelRequire("daoB1");

var $koeKL = parcelRequire("koeKL");

var $cZpsT = parcelRequire("cZpsT");

var $cNd4s = parcelRequire("cNd4s");

var $cSD7y = parcelRequire("cSD7y");

var $7XYc4 = parcelRequire("7XYc4");

var $l0cYe = parcelRequire("l0cYe");

var $eoNiZ = parcelRequire("eoNiZ");

var $cibbb = parcelRequire("cibbb");

var $6RKvu = parcelRequire("6RKvu");

var $jUhOq = parcelRequire("jUhOq");

var $96WTB = parcelRequire("96WTB");

var $crC7i = parcelRequire("crC7i");

var $MBTxm = parcelRequire("MBTxm");

var $jyW1v = parcelRequire("jyW1v");

var $inFGE = parcelRequire("inFGE");

var $klog1 = parcelRequire("klog1");

var $7bwNu = parcelRequire("7bwNu");

var $0396H = parcelRequire("0396H");

var $fwJYI = parcelRequire("fwJYI");

var $ag3PC = parcelRequire("ag3PC");

var $2YzXO = parcelRequire("2YzXO");

var $2E6jA = parcelRequire("2E6jA");
const $daeb815c48fa02e2$var$isSPA = ()=>{
    if (false) return false;
    if (typeof window !== 'undefined') return window.__SPA__;
    return false;
};
const $daeb815c48fa02e2$export$f66ccb39f60980e5 = (0, $cSD7y.componentWithFG)('blu-7045-separate-nav4-nav4-topnav-rendering', $daeb815c48fa02e2$var$AtlassianNavigationNew, $daeb815c48fa02e2$var$AtlassianNavigationOld);
var $daeb815c48fa02e2$export$2e2bcd8739ae039 = $daeb815c48fa02e2$export$f66ccb39f60980e5;
const $daeb815c48fa02e2$var$TopNavComponent = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $daeb815c48fa02e2$var$Nav4TopNav, $daeb815c48fa02e2$var$Nav3TopNav);
function $daeb815c48fa02e2$var$AtlassianNavigationNew() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($daeb815c48fa02e2$var$TopNavComponent, null), (0, $4R6GH.fg)('jira_nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzLyJ.default), null), (0, $4R6GH.fg)('jira_mobile_web_mvp_2_feature_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0dQj.MobileWebExperimentExposure), null), (0, $4R6GH.fg)('jira_mobile_web_mvp_view_panel_kill_switch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0dQj.MobileWebExperimentViewPanelNewTenantsExposure), null), (0, $4R6GH.fg)('jira_mobile_web_mvp_view_panel_kill_switch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0dQj.MobileWebExperimentViewPanelExistingUserExposure), null));
}
function $daeb815c48fa02e2$var$Nav4TopNav() {
    const theme = (0, $eoNiZ.useTheme)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isMobileExperience = (0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)();
    const nav4NavigationProps = (0, $5uXOq.useMemo)(()=>isMobileExperience ? {
            hideSideNavToggleButton: true,
            renderSearch: (0, $c0dQj.isMobileAndInViewPanelIterationExperiment)() ? (0, $fwJYI.Search) : undefined,
            renderNotifications: (0, $c0dQj.isMobileAndInViewPanelIterationExperiment)() ? (0, $inFGE.Notifications) : undefined
        } : {
            renderAppSwitcher: $daeb815c48fa02e2$var$Nav4AppSwitcherMaybe,
            renderSearch: (0, $fwJYI.Search),
            renderEditionAwareness: (0, $bBulW.EditionAwareness),
            renderHelp: (0, $crC7i.Help),
            renderNotifications: (0, $inFGE.Notifications),
            renderConversationAssistant: (0, $jUhOq.ConversationAssistant),
            renderSettings: (0, $ag3PC.Settings),
            renderProfile: (0, $7bwNu.Profile),
            renderSignIn: (0, $2YzXO.SignIn)
        }, [
        isMobileExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $43icZ.TopNav4), {
        renderProductHome: (0, $klog1.ProductHome),
        renderCreate: (0, $96WTB.Create),
        renderNav4Notifications: (0, $2E6jA.Nav4NotificationsData),
        ...nav4NavigationProps,
        theme: theme,
        label: formatMessage((0, $jyW1v.default).topNav)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0396H.NavigationRouterListener), null), isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9WcgH.default), null));
}
function $daeb815c48fa02e2$var$Nav3TopNav() {
    const topNavSegment = (0, $azzrO.useNavPerformanceMetrics)();
    topNavSegment.mark((0, $5e7oM.NAVIGATION_TOP_MARKS).renderStart);
    const cloudId = (0, $koeKL.useCloudId)();
    const applicationPermissions = (0, $daoB1.useApplicationPermissions)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const renderNavigation = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cibbb.TopNav3), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !isAnonymous && !(0, $jQsty.default)('navigation.disable.prefetched.data.for.dropdowns') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MBTxm.InitialDataLoader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4keKa.RecommendationLoader), {
            recommendations: (0, $13iNl.recommendations)
        })))), [
        isAnonymous
    ]);
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const projectContext = (0, $dAfqg.useProjectContext)();
    const customData = (0, $5uXOq.useMemo)(()=>{
        return {
            route: routeName,
            projectType: projectContext?.data?.projectType ?? 'UNKNOWN',
            isSPA: $daeb815c48fa02e2$var$isSPA()
        };
    }, [
        routeName,
        projectContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l0cYe.NavigationSuccessTrackerForNav3), null, isAnonymous ? renderNavigation() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $apeap.RecentsContainer), {
        isGlobal: true,
        cloudId: cloudId,
        applicationPermissions: applicationPermissions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bcn6L.FavoritesContainer), {
        isGlobal: true,
        applicationPermissions: applicationPermissions
    }, renderNavigation()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0396H.NavigationRouterListener), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavTopPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavTopPerformanceReport), {
        customData: customData
    }), isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9WcgH.default), null));
}
function $daeb815c48fa02e2$var$AtlassianNavigationOld() {
    const topNavSegment = (0, $azzrO.useNavPerformanceMetrics)();
    topNavSegment.mark((0, $5e7oM.NAVIGATION_TOP_MARKS).renderStart);
    const theme = (0, $eoNiZ.useTheme)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const applicationPermissions = (0, $daoB1.useApplicationPermissions)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isMobileExperience = (0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)();
    const nav4NavigationProps = (0, $5uXOq.useMemo)(()=>isMobileExperience ? {
            hideSideNavToggleButton: true,
            renderSearch: (0, $c0dQj.isMobileAndInViewPanelIterationExperiment)() ? (0, $fwJYI.Search) : undefined,
            renderNotifications: (0, $c0dQj.isMobileAndInViewPanelIterationExperiment)() ? (0, $inFGE.Notifications) : undefined
        } : {
            renderAppSwitcher: (0, $6RKvu.AppSwitcher),
            renderSearch: (0, $fwJYI.Search),
            renderEditionAwareness: (0, $bBulW.EditionAwareness),
            renderHelp: (0, $crC7i.Help),
            renderNotifications: (0, $inFGE.Notifications),
            renderConversationAssistant: (0, $jUhOq.ConversationAssistant),
            renderSettings: (0, $ag3PC.Settings),
            renderProfile: (0, $7bwNu.Profile),
            renderSignIn: (0, $2YzXO.SignIn)
        }, [
        isMobileExperience
    ]);
    const route = (0, $6jY6G.useCurrentRoute)();
    const renderNavigation = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $43icZ.TopNav4), {
            label: formatMessage((0, $jyW1v.default).topNav),
            renderProductHome: (0, $klog1.ProductHome),
            renderCreate: (0, $96WTB.Create),
            renderNav4Notifications: (0, $2E6jA.Nav4NotificationsData),
            ...nav4NavigationProps,
            theme: theme
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cibbb.TopNav3), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !isAnonymous && !(0, $jQsty.default)('navigation.disable.prefetched.data.for.dropdowns') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MBTxm.InitialDataLoader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4keKa.RecommendationLoader), {
            recommendations: (0, $13iNl.recommendations)
        })))), [
        formatMessage,
        isAnonymous,
        nav4NavigationProps,
        theme
    ]);
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const projectContext = (0, $dAfqg.useProjectContext)();
    const customData = (0, $5uXOq.useMemo)(()=>{
        return {
            route: routeName,
            projectType: projectContext?.data?.projectType ?? 'UNKNOWN',
            isSPA: $daeb815c48fa02e2$var$isSPA()
        };
    }, [
        routeName,
        projectContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l0cYe.NavigationSuccessTrackerForNav3), null, isAnonymous ? renderNavigation() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $apeap.RecentsContainer), {
        isGlobal: true,
        cloudId: cloudId,
        applicationPermissions: applicationPermissions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bcn6L.FavoritesContainer), {
        isGlobal: true,
        applicationPermissions: applicationPermissions
    }, renderNavigation()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0396H.NavigationRouterListener), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavTopPerformanceMark), {
        metricKey: (0, $5e7oM.NAVIGATION_TOP_MARKS).renderEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzrO.NavTopPerformanceReport), {
        customData: customData
    }), isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9WcgH.default), null), (0, $4R6GH.fg)('jira_nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzLyJ.default), null), (0, $4R6GH.fg)('jira_mobile_web_mvp_2_feature_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0dQj.MobileWebExperimentExposure), null), (0, $4R6GH.fg)('jira_mobile_web_mvp_view_panel_kill_switch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0dQj.MobileWebExperimentViewPanelNewTenantsExposure), null), (0, $4R6GH.fg)('jira_mobile_web_mvp_view_panel_kill_switch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0dQj.MobileWebExperimentViewPanelExistingUserExposure), null));
}
const $daeb815c48fa02e2$var$Nav4AppSwitcherMaybe = (0, $cSD7y.componentWithFG)('blu-6347-app-switcher-ep', (0, $hwY9o.AppSwitcher), (0, $6RKvu.AppSwitcher));

});
parcelRegister("43icZ", function(module, exports) {

$parcel$export(module.exports, "TopNav4", () => $08200948c12fa2de$export$76799253f2c58923);

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $AameC = parcelRequire("AameC");

var $1hrBl = parcelRequire("1hrBl");
const $08200948c12fa2de$export$76799253f2c58923 = (0, $7XYc4.componentWithCondition)(()=>// eslint-disable-next-line jira/ff/inline-expVal-params -- ESLint rule doesn't understand the array type
    (0, $6s1PB.expVal)('jira_nav4_hot_113350_changes', 'keys', []).includes('blu-5991-sync-load-nav4-sidebar'), (0, $1hrBl.AtlaskitAtlassianNavigationNav4), (0, $AameC.default));

});
parcelRegister("AameC", function(module, exports) {

$parcel$export(module.exports, "default", () => $60452d4d89241ae5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $b7Svb = parcelRequire("b7Svb");

var $lfTZh = parcelRequire("lfTZh");


const $60452d4d89241ae5$var$LazyAtlaskitAtlassianNavigationNav4 = (0, $b7Svb.lazyForPaint)(()=>Promise.resolve((parcelRequire("1hrBl"))).then(({ AtlaskitAtlassianNavigationNav4: AtlaskitAtlassianNavigationNav4 })=>AtlaskitAtlassianNavigationNav4), {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation-nav4/src/ui/atlaskit-atlassian-navigation-nav4/AtlaskitAtlassianNavigationNav4.tsx"
});
const $60452d4d89241ae5$var$AsyncAtlaskitAtlassianNavigationNav4 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncAtlaskitAtlassianNavigationNav4",
        packageName: (0, $acc1306b50923620$export$b8b9d90f9e5bd72b),
        teamName: (0, $acc1306b50923620$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.PlaceholderNew), {
        name: "lazyAtlaskitAtlassianNavigationNav4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60452d4d89241ae5$var$LazyAtlaskitAtlassianNavigationNav4, props))));
$60452d4d89241ae5$var$AsyncAtlaskitAtlassianNavigationNav4.displayName = 'AsyncAtlaskitAtlassianNavigationNav4';
var $60452d4d89241ae5$export$2e2bcd8739ae039 = $60452d4d89241ae5$var$AsyncAtlaskitAtlassianNavigationNav4;

});
const $acc1306b50923620$export$b8b9d90f9e5bd72b = 'jiraAtlassianNavigationNav4';
const $acc1306b50923620$export$d57b6b390e78d90f = 'jira-cosmos';
const $acc1306b50923620$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';

parcelRegister("1hrBl", function(module, exports) {

$parcel$export(module.exports, "AtlaskitAtlassianNavigationNav4", () => $95ae6691967260e6$export$c1591611a45b21ea);

var $iae3b = parcelRequire("iae3b");

var $9ZLcT = parcelRequire("9ZLcT");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $5NM6P = parcelRequire("5NM6P");

var $6Lyip = parcelRequire("6Lyip");

var $cSD7y = parcelRequire("cSD7y");

var $koVbs = parcelRequire("koVbs");

var $fwzEJ = parcelRequire("fwzEJ");




var $ivGSs = parcelRequire("ivGSs");

var $3F9p6 = parcelRequire("3F9p6");

var $4DrQd = parcelRequire("4DrQd");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");

var $ao2h1 = parcelRequire("ao2h1");

var $cZpsT = parcelRequire("cZpsT");

var $i9F5t = parcelRequire("i9F5t");
var $3TeMH = parcelRequire("3TeMH");
var $axa9g = parcelRequire("axa9g");
var $2wunj = parcelRequire("2wunj");

var $7CMCs = parcelRequire("7CMCs");

var $l8ruj = parcelRequire("l8ruj");

var $6s1PB = parcelRequire("6s1PB");


var $5ORdX = parcelRequire("5ORdX");

var $k9kxe = parcelRequire("k9kxe");
const $95ae6691967260e6$var$Nav4TopNavigation = (0, $cSD7y.componentWithFG)('blu-5614-topnav-sidebar-toggle-button-for-ssr', $95ae6691967260e6$var$TopNavNew, $95ae6691967260e6$var$TopNavNoUserPrefs);
function $95ae6691967260e6$export$c1591611a45b21ea(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "atlaskit-atlassian-navigation-nav4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "AtlaskitAtlassianNavigationNav4",
        packageName: (0, $acc1306b50923620$export$b8b9d90f9e5bd72b),
        teamName: (0, $acc1306b50923620$export$d57b6b390e78d90f),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95ae6691967260e6$var$Nav4TopNavigation, props)));
}
function $95ae6691967260e6$var$TopNavNew(props) {
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    if (isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95ae6691967260e6$var$TopNavNoUserPrefs, props);
     // This intermediate step is to avoid fetching a user-preference-resource for an anonymous user.
    // Because hooks cannot be conditionally called, we create a new component.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95ae6691967260e6$var$TopNavNewUserPrefs, props);
}
function $95ae6691967260e6$var$TopNavNewUserPrefs(props) {
    const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $fwzEJ.topNav4UIStateResource)); // This intermediate step is to avoid using a null queryReference.
    // Maybe this should be a skeleton? Or is that taken care of by the page-container-v2?
    return queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95ae6691967260e6$var$TopNavNewCommonWrapper, {
        queryReference: queryReference,
        ...props
    }) : null;
}
function $95ae6691967260e6$var$TopNavNewCommonWrapper(props) {
    const { queryReference: queryReference } = props;
    const data = (0, $8Uumt.usePreloadedQuery)((0, $9ZLcT.default), queryReference);
    const defaultCollapsed = data?.jira?.navigationUIState?.isLeftSidebarCollapsed ?? (0, $4DrQd.IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT); // @ts-expect-error - The code works, the query reference was generated by the relay compiler.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95ae6691967260e6$var$TopNavCommon, {
        ...props,
        defaultCollapsed: defaultCollapsed,
        queryReference: data
    });
}
function $95ae6691967260e6$var$TopNavNoUserPrefs(props) {
    const data = (0, $8Uumt.useLazyLoadQuery)((0, $iae3b.default), {
        includeExtraMenuItems: (0, $6s1PB.expVal)('jira_nav4_hot_113350_account_menu_experiment', 'cohort', false)
    }); // @ts-expect-error - The code works, the query reference was generated by the relay compiler.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95ae6691967260e6$var$TopNavCommon, {
        ...props,
        queryReference: data
    });
}
function $95ae6691967260e6$var$TopNavCommon(props) {
    const { defaultCollapsed: defaultCollapsed = false, hideSideNavToggleButton: hideSideNavToggleButton, queryReference: queryReference, renderCreate: Create, renderHelp: Help, renderAppSwitcher: AppSwitcher, renderNotifications: Notifications, renderNav4Notifications: Nav4NotificationsData, renderConversationAssistant: ConversationAssistant, renderProductHome: ProductHome, renderProfile: Profile, renderSettings: Settings, renderSearch: Search, renderEditionAwareness: EditionAwareness, renderSignIn: SignIn } = props;
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const attributes = (0, $5uXOq.useMemo)(()=>({
            navigationLayer: (0, $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22),
            navigationContainer: (0, $68cb678dc917978e$export$793ed84f5e13fedc),
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            stage: (0, $3F9p6.getNav4Rollout)().stage
        }), []);
    const onClickSideNavToggleButton = (0, $5uXOq.useCallback)((_, analyticsEvent, _attributes)=>{
        const payload = (0, $ivGSs.getSideNavToggleButtonAnalyticEventPayload)(_attributes?.isSideNavVisible, (0, $3F9p6.getNav4Rollout)().stage);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, payload);
    }, []);
    const renderNotificationsForNavVersion = (0, $5uXOq.useCallback)(()=>{
        if (Notifications !== undefined) {
            if ((0, $6s1PB.expVal)('blu-6229-nav4-top-nav-notifications-perf', 'cohort', false)) // @ts-expect-error - The code works, the query reference was generated by the relay compiler.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Nav4NotificationsData, {
                queryReference: queryReference
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Notifications, null);
        }
        return null;
    }, [
        Nav4NotificationsData,
        Notifications,
        queryReference
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3TeMH.HomeActions), null, hideSideNavToggleButton ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lyip.OnboardingSpotlightMaybe), {
        spotlight: (0, $5NM6P.Nav4OnboardingComponentNames).JIRA_SIDEBAR_TOGGLE_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $axa9g.SideNavToggleButton), {
        defaultCollapsed: defaultCollapsed,
        onClick: onClickSideNavToggleButton,
        collapseLabel: formatMessage((0, $5ORdX.messages).sideNavToggleButtonCollapseLabel),
        expandLabel: formatMessage((0, $5ORdX.messages).sideNavToggleButtonExpandLabel)
    })), AppSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AppSwitcher, null), ProductHome && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProductHome, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i9F5t.CommonActions), null, Search && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Search, null), Create && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Create, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2wunj.UserActions), null, EditionAwareness && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EditionAwareness, null), !isAnonymous && ConversationAssistant && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConversationAssistant, null), !isAnonymous && renderNotificationsForNavVersion(), Help && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Help, null), Settings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Settings, null), Profile && !(0, $6s1PB.expVal)('jira_nav4_hot_113350_account_menu_experiment', 'cohort', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Profile, null) : // @ts-expect-error - The code works, the query reference was generated by the relay compiler.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9kxe.Nav4Profile), {
        queryReference: queryReference
    }), SignIn && !(0, $6s1PB.expVal)('jira_nav4_hot_113350_account_menu_experiment', 'cohort', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SignIn, null)));
}

});
parcelRegister("iae3b", function(module, exports) {

$parcel$export(module.exports, "default", () => $303bb8e80a52e9e7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<21be8fe1affb04a113b0a2d81348ec67>>
 * @relayHash 6359c7466250a87a7078454059df31e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fa1294317b44e1df3f0811cc45e1d348c18cc974682f38c63caa8e7e7e82a61b
const $303bb8e80a52e9e7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeExtraMenuItems"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AtlaskitAtlassianNavigationNav4Query",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Profile"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AtlaskitAtlassianNavigationNav4Query",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "condition": "includeExtraMenuItems",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "email"
                                                }
                                            ],
                                            "type": "AtlassianAccountUser"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fa1294317b44e1df3f0811cc45e1d348c18cc974682f38c63caa8e7e7e82a61b",
            "metadata": {},
            "name": "AtlaskitAtlassianNavigationNav4Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$303bb8e80a52e9e7$var$node.hash = "336aadcb522264aa7ac06a9dd94f4c95";
var $303bb8e80a52e9e7$export$2e2bcd8739ae039 = $303bb8e80a52e9e7$var$node;

});

parcelRegister("5ORdX", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7e3b94d939630c6f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7e3b94d939630c6f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    sideNavToggleButtonCollapseLabel: {
        "id": "atlassian-navigation-nav4.atlaskit-atlassian-navigation-nav4.side-nav-toggle-button-collapse-label",
        "defaultMessage": "Collapse sidebar ["
    },
    sideNavToggleButtonExpandLabel: {
        "id": "atlassian-navigation-nav4.atlaskit-atlassian-navigation-nav4.side-nav-toggle-button-expand-label",
        "defaultMessage": "Expand sidebar ["
    }
});

});

parcelRegister("k9kxe", function(module, exports) {

$parcel$export(module.exports, "Nav4Profile", () => $a99665d29fdf5a2b$export$c928b6dc7cf1e4c6);

var $3QjWU = parcelRequire("3QjWU");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $cnhic = parcelRequire("cnhic");

var $vCqQa = parcelRequire("vCqQa");

var $clxo5 = parcelRequire("clxo5");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $Pxnvj = parcelRequire("Pxnvj");

var $hfZl4 = parcelRequire("hfZl4");
var $1VOot = parcelRequire("1VOot");

var $c0dQj = parcelRequire("c0dQj");

var $2EqxS = parcelRequire("2EqxS");

var $cYlk7 = parcelRequire("cYlk7");

var $2Ql51 = parcelRequire("2Ql51");

var $cZpsT = parcelRequire("cZpsT");

var $9OXo1 = parcelRequire("9OXo1");

var $6s1PB = parcelRequire("6s1PB");

var $6cNb0 = parcelRequire("6cNb0");

var $57H0d = parcelRequire("57H0d");

var $j671u = parcelRequire("j671u");

var $904lL = parcelRequire("904lL");

var $jplDq = parcelRequire("jplDq");
var $4e1uB = parcelRequire("4e1uB");
var $fR8PR = parcelRequire("fR8PR");
var $bXAyW = parcelRequire("bXAyW");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $cLIpE = parcelRequire("cLIpE");
const $a99665d29fdf5a2b$export$c928b6dc7cf1e4c6 = ({ queryReference: queryReference })=>{
    const data = (0, $8Uumt.useFragment)((0, $3QjWU.default), queryReference);
    const { data: { user: user } } = (0, $cYlk7.useCurrentUser)();
    const { theme: theme, setTheme: setTheme } = (0, $2Ql51.useThemePreference)();
    const profileLink = (0, $2EqxS.useProfileLink)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { environment: environment } = (0, $9OXo1.useTenantContext)();
    const isMobileExperience = (0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)();
    const identityEnv = (0, $57H0d.getIdentityEnv)(environment);
    const currentWindow = (0, $57H0d.getWindow)();
    const siteUrl = (0, $57H0d.getSiteUrl)(currentWindow);
    const [userBoardId, userBoardOwnerAccountId] = (0, $904lL.useUserBoardId)(false);
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'profile');
    const isUserType = (maybeUser)=>'emailAddress' in maybeUser;
    const emailAddress = isUserType(user) && user.emailAddress ? user.emailAddress : '';
    const links = (0, $1VOot.useAccountLinks)({
        email: emailAddress,
        identityEnvironment: identityEnv,
        application: 'jira',
        continueUrl: siteUrl,
        isLoggedOut: isAnonymous
    });
    if ((0, $6s1PB.expVal)('jira_nav4_hot_113350_account_menu_experiment', 'cohort', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a99665d29fdf5a2b$export$793e3aab7101233f, {
        testId: (0, $6cNb0.testIdGenerate)('secondary-actions', 'profile'),
        picture: data?.me?.user?.picture,
        email: emailAddress || '',
        logInLink: links.logInLink
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hfZl4.AccountNav3), {
        name: (0, $6s1PB.expVal)('jira_nav4_hot_113350_account_menu_experiment', 'cohort', false) ? data?.me?.user?.name : user?.userFullname,
        picture: data?.me?.user?.picture,
        trustPicture: (0, $6s1PB.expVal)('jira_nav4_hot_113350_account_menu_experiment', 'cohort', false),
        email: (0, $6s1PB.expVal)('jira_nav4_hot_113350_account_menu_experiment', 'cohort', false) ? data?.me?.user?.email || '' : emailAddress,
        viewProfileLink: isMobileExperience ? undefined : profileLink,
        onThemeChange: setTheme,
        currentTheme: theme,
        identityEnvironment: identityEnv,
        application: "jira",
        continueUrl: siteUrl,
        isLoggedOut: isAnonymous,
        extraMenuItems: (0, $6s1PB.expVal)('jira_nav4_hot_113350_account_menu_experiment', 'cohort', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j671u.MenuNav4), {
            userBoardId: userBoardId,
            userBoardOwnerAccountId: userBoardOwnerAccountId,
            testIdPrefix: testIdPrefix
        })
    });
};
const $a99665d29fdf5a2b$export$793e3aab7101233f = ({ testId: testId, picture: picture, email: email, logInLink: logInLink })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            includeExtraMenuItems: true
        }), []);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $cLIpE.Nav4ProfileMenuEntryPoint), entryPointParams);
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onClosePopup: ()=>{
                setIsOpen(false);
            },
            testId: testId
        }), [
        testId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnhic.NavigationAnalyticsContext), {
        data: (0, $bXAyW.ANALYTICS_CONTEXT)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jplDq.AccountMenuIntlProvider), null, logInLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4e1uB.AccountMenuLoggedOutStateNav3), {
        testId: testId && `${testId}--logged-out-state`,
        logInLink: logInLink
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $vCqQa.default), {
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
        },
        testId: testId,
        placement: "bottom",
        trigger: (triggerProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
                name: "profile-spotlight"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fR8PR.AccountMenuTriggerNav3), {
                ref: (element)=>{
                    triggerRef(element);
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                },
                onClick: ()=>{
                    setIsOpen((open)=>!open);
                },
                testId: testId && `${testId}--trigger`,
                picture: picture,
                trustPicture: true,
                email: email,
                "aria-expanded": isOpen,
                "aria-haspopup": true,
                "aria-controls": testId && `${testId}--content`,
                "data-ds--level": triggerProps['data-ds--level']
            }));
        },
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "atlassian-navigation-profile-menu",
                packageName: "atlassian-navigation-profile-menu",
                errorFallback: "flag",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                    xcss: $a99665d29fdf5a2b$var$Nav4AccountMenuContentSkeletonStyles,
                    padding: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), null)),
                runtimeProps: runtimeProps
            })
    })));
};
// These styles are defined to ensure that the initial popup for the AccountMenu content is the same width when
// displaying the skeleton loader as when displaying the actual content.
const $a99665d29fdf5a2b$var$Nav4AccountMenuContentSkeletonStyles = (0, $2s57o.xcss)({
    width: '304px',
    height: '307px'
});

});
parcelRegister("3QjWU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5287ccf2951923b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a0dac0c0853631e9e179741e03cf11a9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f5287ccf2951923b$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "includeExtraMenuItems"
        }
    ],
    "kind": "Fragment",
    "name": "Nav4Profile",
    "selections": [
        {
            "concreteType": "AuthenticationContext",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeExtraMenuItems",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "email"
                                        }
                                    ],
                                    "type": "AtlassianAccountUser"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$f5287ccf2951923b$var$node.hash = "c382d788a3ba66968e52b96eae589c15";
var $f5287ccf2951923b$export$2e2bcd8739ae039 = $f5287ccf2951923b$var$node;

});

parcelRegister("2EqxS", function(module, exports) {

$parcel$export(module.exports, "useAtlassianPersonalSettingsLink", () => $58d844745b0a5554$export$8ac70acdad00754b);
$parcel$export(module.exports, "useSwitchAccountLink", () => $58d844745b0a5554$export$dce6af3168fb6ced);
$parcel$export(module.exports, "useProfileLink", () => $58d844745b0a5554$export$b8f25e615dd30d7b);
$parcel$export(module.exports, "getBeforeEntity", () => $58d844745b0a5554$export$5b8580d0254a9349);
$parcel$export(module.exports, "getBoardLink", () => $58d844745b0a5554$export$ff5c49b7852aca68);
$parcel$export(module.exports, "getLinkFromProject", () => $58d844745b0a5554$export$dd9458ee44edd0c6);
$parcel$export(module.exports, "getQueueLink", () => $58d844745b0a5554$export$b44363840d1b683e);
$parcel$export(module.exports, "getIsClassicSoftwareProject", () => $58d844745b0a5554$export$286ea82aef1c76e9);
$parcel$export(module.exports, "getUsersApps", () => $58d844745b0a5554$export$ad0fd737fbd4a083);

var $ebyGx = parcelRequire("ebyGx");

var $2ys8y = parcelRequire("2ys8y");

var $j0xEB = parcelRequire("j0xEB");

var $iN5FK = parcelRequire("iN5FK");

var $hqguB = parcelRequire("hqguB");

var $kk6FJ = parcelRequire("kk6FJ");

var $ludxj = parcelRequire("ludxj");

var $urQ6o = parcelRequire("urQ6o");

var $7M8Tn = parcelRequire("7M8Tn");

var $7wTzh = parcelRequire("7wTzh");

var $lB6pS = parcelRequire("lB6pS");

var $lyCs2 = parcelRequire("lyCs2");

var $ee0rS = parcelRequire("ee0rS");

var $90yGq = parcelRequire("90yGq");

var $lmyls = parcelRequire("lmyls");

var $6cNb0 = parcelRequire("6cNb0");
const $58d844745b0a5554$export$ab902790e443b0ec = ()=>`${(0, $2ys8y.getATLContextUrl)('id')}/login`;
const $58d844745b0a5554$export$8ac70acdad00754b = (destinationAccountEmail)=>{
    const loginLink = $58d844745b0a5554$export$ab902790e443b0ec();
    const destinationUrl = `${(0, $2ys8y.getATLContextUrl)('id')}/manage-profile/profile-and-visibility`;
    return destinationAccountEmail ? `${loginLink}?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        application: 'jira',
        continue: destinationUrl,
        login_hint: destinationAccountEmail,
        prompt: 'none'
    })}` : destinationUrl;
};
const $58d844745b0a5554$export$dce6af3168fb6ced = ()=>{
    const loginLink = $58d844745b0a5554$export$ab902790e443b0ec();
    const { href: href } = (0, $j0xEB.default)() || {};
    return `${loginLink}?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        application: 'jira',
        continue: href,
        prompt: 'select_account'
    })}`;
};
const $58d844745b0a5554$export$b8f25e615dd30d7b = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    return `/jira/people/${accountId || ''}`;
};
const $58d844745b0a5554$export$5b8580d0254a9349 = (favoriteItems)=>favoriteItems && favoriteItems.length > 0 ? {
        id: String(favoriteItems[0].id),
        type: favoriteItems[0].type
    } : {
        id: undefined,
        type: undefined
    };
const $58d844745b0a5554$export$ff5c49b7852aca68 = (item)=>{
    const { attributes: attributes, attributes: { parentType: parentType }, id: id } = item;
    const boardId = String(id);
    if (parentType === 'project') {
        // @ts-expect-error - TS2339 - Property 'nextgen' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'. | TS2339 - Property 'projectKey' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'. | TS2339 - Property 'projectType' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'.
        const { nextgen: nextgen, projectKey: projectKey, projectType: projectType } = attributes;
        if (projectType === 'business') return {
            params: {
                projectKey: projectKey
            },
            query: {},
            route: (0, $hqguB.jiraBusinessProjectRedirectRoute)
        };
        if (projectType === 'service_desk') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $kk6FJ.jsmBoardRoute)
        };
        if (nextgen === 'true') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $7wTzh.softwareBoardRoute)
        };
        return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $lB6pS.classicSoftwareBoardRoute)
        };
    }
    if (parentType === 'user') {
        // @ts-expect-error - TS2339 - Property 'userAccountId' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'.
        const { userAccountId: accountId } = attributes;
        return {
            params: {
                boardId: boardId,
                accountId: accountId
            },
            query: {},
            route: (0, $lyCs2.userBoardRoute)
        };
    }
    return {
        params: undefined,
        query: undefined,
        route: undefined
    };
};
const $58d844745b0a5554$export$dd9458ee44edd0c6 = (item)=>{
    const { attributes: { projectType: projectType, boardId: boardId, nextgen: nextgen, projectKey: projectKey } } = item;
    if (projectType === 'business') return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $hqguB.jiraBusinessProjectRedirectRoute)
    };
    if (boardId !== undefined) {
        if (nextgen === 'true') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $7wTzh.softwareBoardRoute)
        };
        return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $lB6pS.classicSoftwareBoardRoute)
        };
    }
    if (projectType === 'service_desk') return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $ludxj.projectServiceDeskRoute)
    };
    return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $iN5FK.browseProjectRedirectRoute)
    };
};
const $58d844745b0a5554$export$b44363840d1b683e = (item)=>{
    const { attributes: { projectKey: projectKey, queuesCategory: queuesCategory }, id: id } = item;
    return {
        params: {
            projectKey: projectKey,
            ...queuesCategory != null && queuesCategory !== '' ? {
                practiceType: (0, $ee0rS.toShortFormItsmPractice)(queuesCategory)
            } : {},
            queueId: String(id)
        },
        route: queuesCategory != null && queuesCategory !== '' ? (0, $urQ6o.customPracticeQueueRoute) : (0, $7M8Tn.customQueueRoute)
    };
};
const $58d844745b0a5554$export$286ea82aef1c76e9 = (attributes)=>attributes.parentType === 'user' || attributes.parentType === 'project' && attributes.projectType === 'software' && attributes.nextgen === 'false';
const $58d844745b0a5554$export$ad0fd737fbd4a083 = (items)=>items.filter((item)=>item.id !== (0, $lmyls.ADDON_ID).DISCOVER);

});
parcelRegister("j0xEB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b1198aeec732ce1$export$2e2bcd8739ae039);
/**
 * Wrap window.location so that it's testable.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $9b1198aeec732ce1$export$2e2bcd8739ae039 = ()=>{
    if (typeof window !== 'undefined') return window.location;
    return undefined;
};

});

parcelRegister("ee0rS", function(module, exports) {

$parcel$export(module.exports, "toShortFormItsmPractice", () => $3a8490f36704bba6$export$db58a56259f511a2);

var $oCMSG = parcelRequire("oCMSG");
const $3a8490f36704bba6$var$longToShortConversionMap = {
    [(0, $oCMSG.CHANGES)]: (0, $oCMSG.SHORT_FORM_CHANGES),
    [(0, $oCMSG.INCIDENTS)]: (0, $oCMSG.SHORT_FORM_INCIDENTS),
    [(0, $oCMSG.PROBLEMS)]: (0, $oCMSG.SHORT_FORM_PROBLEMS),
    [(0, $oCMSG.SERVICE_REQUEST)]: (0, $oCMSG.SHORT_FORM_SERVICE_REQUEST),
    [(0, $oCMSG.POST_INCIDENT_REVIEWS)]: (0, $oCMSG.SHORT_FORM_POST_INCIDENT_REVIEWS),
    [(0, $oCMSG.DEVELOPER_ESCALATION)]: (0, $oCMSG.SHORT_FORM_DEVELOPER_ESCALATION)
};
function $3a8490f36704bba6$var$isLongForm(workCategoryKey) {
    return !!workCategoryKey && workCategoryKey in $3a8490f36704bba6$var$longToShortConversionMap;
}
const $3a8490f36704bba6$export$db58a56259f511a2 = (workCategoryKey)=>{
    if ($3a8490f36704bba6$var$isLongForm(workCategoryKey)) return $3a8490f36704bba6$var$longToShortConversionMap[workCategoryKey];
    return null;
};

});

parcelRegister("6cNb0", function(module, exports) {

$parcel$export(module.exports, "testIdConcat", () => $c1f136d19203abbc$export$794609946480f79c);
$parcel$export(module.exports, "testIdGenerate", () => $c1f136d19203abbc$export$3b86b974ae586844);
const $c1f136d19203abbc$var$PREFIX = 'atlassian-navigation-';
const $c1f136d19203abbc$var$SEPARATOR = '--';
const $c1f136d19203abbc$var$isValid = (value)=>value != null && value !== '';
const $c1f136d19203abbc$export$794609946480f79c = (id, ...items)=>[
        id,
        ...items
    ].filter(Boolean).join($c1f136d19203abbc$var$SEPARATOR).toLowerCase();
const $c1f136d19203abbc$export$3b86b974ae586844 = (first, ...rest)=>// @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | undefined'.
    $c1f136d19203abbc$export$794609946480f79c($c1f136d19203abbc$var$PREFIX + ($c1f136d19203abbc$var$isValid(first) ? `-${first}` : ''), ...rest);

});


parcelRegister("57H0d", function(module, exports) {

$parcel$export(module.exports, "getWindow", () => $323b60151b6ebcfa$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getSiteUrl", () => $323b60151b6ebcfa$export$63fdf20f02fdbaf2);
$parcel$export(module.exports, "getIdentityEnv", () => $323b60151b6ebcfa$export$b3f2b8c6cd294d68);
const $323b60151b6ebcfa$export$38b2d434cce3ea22 = ()=>window;
const $323b60151b6ebcfa$export$63fdf20f02fdbaf2 = (currentWindow)=>{
    if (!currentWindow.false) return `${currentWindow.location.protocol}//${currentWindow.location.host}`;
    return '';
};
const $323b60151b6ebcfa$export$b3f2b8c6cd294d68 = (env)=>{
    switch(env){
        case 'local':
            return 'staging';
        case 'dev':
            return 'staging';
        case 'staging':
            return 'staging';
        case 'prod':
            return 'prod';
        default:
            return 'prod';
    }
};

});

parcelRegister("j671u", function(module, exports) {

$parcel$export(module.exports, "MenuNav4", () => $e1c78c1b6d55a8ee$export$60113ca6a29c7a92);
/* main-nav4.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $d6a7c = parcelRequire("d6a7c");
var $70rf1 = parcelRequire("70rf1");

var $2vSU6 = parcelRequire("2vSU6");

var $3bQtK = parcelRequire("3bQtK");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $dAfqg = parcelRequire("dAfqg");

var $lyCs2 = parcelRequire("lyCs2");


var $jrUuh = parcelRequire("jrUuh");

var $4QigF = parcelRequire("4QigF");


var $5VgFy = parcelRequire("5VgFy");

var $6e9wd = parcelRequire("6e9wd");

var $lwZRC = parcelRequire("lwZRC");

var $ckmlX = parcelRequire("ckmlX");

var $j6Dnq = parcelRequire("j6Dnq");
const $e1c78c1b6d55a8ee$export$60113ca6a29c7a92 = ({ testIdPrefix: testIdPrefix, userBoardId: userBoardId, userBoardOwnerAccountId: userBoardOwnerAccountId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $acc1306b50923620$export$69cbedccc0df48)
    });
    (0, $5uXOq.useEffect)(()=>{
        onSuccess();
    }, [
        onSuccess
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-popup');
    const testIdContent = (0, $6cNb0.testIdConcat)(testId, 'content');
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $jrUuh.useJsmOnboardingType)();
    (0, $5uXOq.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        fetchOnboardingType,
        projectContextData?.projectId,
        projectContextData?.projectType
    ]);
    const showInJwmProjects = projectContextData?.projectType === (0, $2vSU6.CORE_PROJECT);
    const showInSoftwareProjects = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const showInJsmProjects = projectContextData?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $e7830161eb8674f1$export$6f454e69bce3a691);
    let yourBoardsRoute;
    let yourBoardsParams;
    let yourBoardsQuery;
    if (userBoardId != null) {
        yourBoardsRoute = (0, $lyCs2.userBoardRoute);
        yourBoardsParams = {
            accountId: userBoardOwnerAccountId,
            boardId: String(userBoardId)
        };
    }
    const boardOffset = userBoardId == null ? -1 : 0;
    const showQuickstartOpenMenuItem = showInJwmProjects || showInSoftwareProjects || showInJsmProjects;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6e9wd.MenuList), null, showQuickstartOpenMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4QigF.OpenMenuItem), {
        MenuItem: (0, $5VgFy.MenuItem)
    }), userBoardId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        hasSeparator: true,
        testId: testIdContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdContent, 'jira')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6a7c.default), {
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'heading')
    }, formatMessage((0, $ckmlX.default).jira)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6e9wd.MenuListItem), {
        ariaLabel: formatMessage((0, $ckmlX.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5VgFy.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'your-boards',
            menuItemType: 'jira',
            position: 1
        },
        href: `/jira/people/${String(userBoardOwnerAccountId)}/boards/${userBoardId}`,
        params: yourBoardsParams,
        query: yourBoardsQuery,
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-your-boards'),
        to: yourBoardsRoute
    }, formatMessage((0, $ckmlX.default).yourBoards))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lwZRC.StandardToPremiumPubTouchpoint), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j6Dnq.ExtraItemsNav4), {
        startPosition: 5 + boardOffset,
        testIdPrefix: testIdContent,
        itemAriaLabel: formatMessage((0, $ckmlX.default).jira)
    }));
};

});
const $e7830161eb8674f1$export$6f454e69bce3a691 = 'business';
const $e7830161eb8674f1$export$e6952b12ade67489 = 'default';

parcelRegister("jrUuh", function(module, exports) {

$parcel$export(module.exports, "useJsmOnboardingType", () => $664311160f9d0bff$export$5daaa68c3a578af9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $gcnn5 = parcelRequire("gcnn5");
const $664311160f9d0bff$export$d4c72bab9d6cc13a = {
    projectId: undefined,
    data: undefined,
    error: undefined,
    isLoading: false
};
const $664311160f9d0bff$var$Store = (0, $iXqE5.createStore)({
    initialState: $664311160f9d0bff$export$d4c72bab9d6cc13a,
    actions: $gcnn5.actions,
    name: 'JSMOnboardingType'
});
const $664311160f9d0bff$export$5daaa68c3a578af9 = (0, $3sQ5x.createHook)($664311160f9d0bff$var$Store);

});
parcelRegister("gcnn5", function(module, exports) {

$parcel$export(module.exports, "actions", () => $efcda9e0ca78f7c5$export$e324594224ef24da);

var $5R3PH = parcelRequire("5R3PH");
const $efcda9e0ca78f7c5$export$e324594224ef24da = {
    fetchOnboardingType: $5R3PH.fetchOnboardingType
};

});
parcelRegister("5R3PH", function(module, exports) {

$parcel$export(module.exports, "fetchOnboardingType", () => $a0d1630df8d288ca$export$ea62467635172b55);

var $2vSU6 = parcelRequire("2vSU6");

var $7f4tk = parcelRequire("7f4tk");
const $a0d1630df8d288ca$var$getOnboardingTypeUrl = (projectId)=>`/rest/servicedesk/onboarding/1/onboarding-type/project/${projectId}`;
const $a0d1630df8d288ca$export$ea62467635172b55 = (projectId, projectType)=>async ({ getState: getState, setState: setState })=>{
        if (!projectId || projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT)) return;
        const { data: data, isLoading: isLoading, projectId: oldProjectId } = getState();
        if (projectId !== oldProjectId) setState({
            data: undefined,
            projectId: undefined
        });
        if (data || isLoading) return;
        setState({
            projectId: projectId,
            isLoading: true,
            error: undefined
        });
        try {
            const onboardingTypeResponse = await (0, $7f4tk.default)($a0d1630df8d288ca$var$getOnboardingTypeUrl(String(projectId)));
            setState({
                isLoading: false,
                data: onboardingTypeResponse
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isLoading: false,
                error: error
            });
        }
    };

});



parcelRegister("4QigF", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingChecklist", () => $a3ce66216f7840ff$export$aea93106aaeec3fc);
$parcel$export(module.exports, "JswOnboardingButton", () => $a3ce66216f7840ff$export$c0cbc1198da400db);
$parcel$export(module.exports, "LazyOpenMenuItem", () => $a3ce66216f7840ff$export$e6a8d3e2a6acc946);
$parcel$export(module.exports, "OpenMenuItem", () => $a3ce66216f7840ff$export$67c4b22563f33286);

var $5uXOq = parcelRequire("5uXOq");

var $kkd2O = parcelRequire("kkd2O");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");

var $30rnQ = parcelRequire("30rnQ");

var $iuzc0 = parcelRequire("iuzc0");

var $l8ruj = parcelRequire("l8ruj");

var $b7Svb = parcelRequire("b7Svb");

var $cSD7y = parcelRequire("cSD7y");

var $5Nzrp = parcelRequire("5Nzrp");

var $eIh4F = parcelRequire("eIh4F");

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/deprecations/no-rll-client-async-experiences
const $a3ce66216f7840ff$var$LazyChecklistAsync = (0, $b7Svb.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("5Nzrp"))).then(({ JswOnboardingChecklistNext: JswOnboardingChecklistNext })=>JswOnboardingChecklistNext), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/onboarding/onboarding-checklist-next/src/ui/onboarding-checklist/index.tsx"
});
const $a3ce66216f7840ff$var$OnboardingChecklist = (0, $cSD7y.componentWithFG)('convert_software-onboarding-checklist_to_sync', (0, $5Nzrp.JswOnboardingChecklistNext), $a3ce66216f7840ff$var$LazyChecklistAsync);
const $a3ce66216f7840ff$var$FallbackChecklist = ()=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $353uQ.qsChecklistAutoLoadTime).start();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $a3ce66216f7840ff$export$aea93106aaeec3fc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "quickstart"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncChecklistComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkd2O.default), {
        name: "software-onboarding-checklist-new",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ce66216f7840ff$var$FallbackChecklist, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ce66216f7840ff$var$OnboardingChecklist, null))));

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/deprecations/no-rll-client-async-experiences
const $a3ce66216f7840ff$var$LazyOpenButtonAsync = (0, $b7Svb.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("eIh4F"))).then(({ JswOnboardingButtonNext: JswOnboardingButtonNext })=>JswOnboardingButtonNext), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-quickstart/src/ui/onboarding-button/index.tsx"
});
const $a3ce66216f7840ff$var$FallbackButton = ()=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $353uQ.qsButtonAutoLoadTime).start();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $a3ce66216f7840ff$export$c0cbc1198da400db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncChecklistButtonComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkd2O.default), {
        name: "software-onboarding-checklist-button-new",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ce66216f7840ff$var$FallbackButton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iuzc0.QuickstartPillVisibilityContainer), {
        scope: "ListPageQuickstartPill"
    }, (0, $4R6GH.fg)('convert_software_onboarding_button_to_be_sync') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eIh4F.JswOnboardingButtonNext), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ce66216f7840ff$var$LazyOpenButtonAsync, null))));

const $a3ce66216f7840ff$export$e6a8d3e2a6acc946 = (0, $b7Svb.lazy)(()=>(parcelRequire("hXb6V")).then(({ OpenMenuItem: OpenMenuItem })=>{
        (0, $353uQ.openMenuItemLoadTime).mark((0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END);
        return OpenMenuItem;
    }), {
    moduleId: "./src/packages/software/onboarding-quickstart/src/ui/open-menu-item/index.tsx"
});
const $a3ce66216f7840ff$var$SubmitOpenMenuItemLoadStart = ()=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $353uQ.openMenuItemLoadTime).start();
        (0, $353uQ.openMenuItemLoadTime).mark((0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $a3ce66216f7840ff$export$67c4b22563f33286 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncOpenMenuItemComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkd2O.default), {
        name: "software-onboarding-checklist-open-menu-item",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ce66216f7840ff$var$SubmitOpenMenuItemLoadStart, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ce66216f7840ff$export$e6a8d3e2a6acc946, props)));

});
parcelRegister("94Uc1", function(module, exports) {

$parcel$export(module.exports, "PANEL_ID", () => $5bee65240229f284$export$e1d562d81d0e502d);
$parcel$export(module.exports, "PANEL_WIDTH", () => $5bee65240229f284$export$e05cfff20e9274e6);
$parcel$export(module.exports, "PERFORMANCE_METRIC_PREFIX", () => $5bee65240229f284$export$495d0560d6ea05d0);
$parcel$export(module.exports, "PERFORMANCE_MARK", () => $5bee65240229f284$export$5da8d06749e84d86);
const $5bee65240229f284$export$e1d562d81d0e502d = 'jsw-nux-onboarding-checklist';
const $5bee65240229f284$export$e05cfff20e9274e6 = 360;
const $5bee65240229f284$export$495d0560d6ea05d0 = 'onboarding-quickstart';
const $5bee65240229f284$export$5da8d06749e84d86 = {
    BUNDLE_LOAD_START: 'bundleLoaded',
    BUNDLE_LOAD_END: 'bundleLoadedEnd'
};

});

parcelRegister("353uQ", function(module, exports) {

$parcel$export(module.exports, "isMetricRunning", () => $56fd78ac33bc6df4$export$5c2d3e87043198cf);
$parcel$export(module.exports, "openMenuItemLoadTime", () => $56fd78ac33bc6df4$export$9aef270bc11ae96b);
$parcel$export(module.exports, "qsButtonAutoLoadTime", () => $56fd78ac33bc6df4$export$844f48c93ed69757);
$parcel$export(module.exports, "qsChecklistAutoLoadTime", () => $56fd78ac33bc6df4$export$c501d2dfab0e9e45);
$parcel$export(module.exports, "qsChecklistMinimiseInteraction", () => $56fd78ac33bc6df4$export$ac78fba7425e64da);
$parcel$export(module.exports, "qsChecklistDismissInteraction", () => $56fd78ac33bc6df4$export$494d4094aaa2bc4d);
$parcel$export(module.exports, "qsButtonOpenInteraction", () => $56fd78ac33bc6df4$export$da7d38041ee220c8);
$parcel$export(module.exports, "qsButtonDismissInteraction", () => $56fd78ac33bc6df4$export$ce2841e9d619cdfd);
// @ts-expect-error - TS2305 - Module '"@atlassian/browser-metrics"' has no exported member 'BaseMetric'.

var $2nKjG = parcelRequire("2nKjG");

var $94Uc1 = parcelRequire("94Uc1");
const $56fd78ac33bc6df4$export$5c2d3e87043198cf = (metric)=>metric?.state === 'started';
const $56fd78ac33bc6df4$export$9aef270bc11ae96b = (0, $2nKjG.metrics).custom({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.open.menu-item.load`,
    timings: [
        {
            key: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $56fd78ac33bc6df4$export$844f48c93ed69757 = (0, $2nKjG.metrics).custom({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.button.load`,
    timings: [
        {
            key: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $56fd78ac33bc6df4$export$c501d2dfab0e9e45 = (0, $2nKjG.metrics).custom({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.checklist.load`,
    timings: [
        {
            key: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $56fd78ac33bc6df4$export$ac78fba7425e64da = (0, $2nKjG.metrics).interaction({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.checklist.minimize`
});
const $56fd78ac33bc6df4$export$494d4094aaa2bc4d = (0, $2nKjG.metrics).interaction({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.checklist.dismiss`
});
const $56fd78ac33bc6df4$export$da7d38041ee220c8 = (0, $2nKjG.metrics).interaction({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.button.open`
});
const $56fd78ac33bc6df4$export$ce2841e9d619cdfd = (0, $2nKjG.metrics).interaction({
    key: `${(0, $94Uc1.PERFORMANCE_METRIC_PREFIX)}.button.dismiss`
});

});

parcelRegister("iuzc0", function(module, exports) {

$parcel$export(module.exports, "QuickstartPillVisibilityContainer", () => $eb306ed6e1ecf691$export$1a5202e8ea7b76ab);
$parcel$export(module.exports, "useQuickstartPillVisibilityStore", () => $eb306ed6e1ecf691$export$70dc54081d2075ff);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $eb306ed6e1ecf691$var$actions = {
    toggleShowQuickstart: ({ showQuickstartPill: showQuickstartPill })=>({ setState: setState })=>{
            setState({
                showQuickstartPill: showQuickstartPill
            });
        }
};
const $eb306ed6e1ecf691$var$initialState = {
    showQuickstartPill: null
};
const $eb306ed6e1ecf691$var$Store = (0, $iXqE5.createStore)({
    initialState: $eb306ed6e1ecf691$var$initialState,
    actions: $eb306ed6e1ecf691$var$actions,
    name: 'JiraQuickstartPillVisibility'
});
const $eb306ed6e1ecf691$export$1a5202e8ea7b76ab = (0, $gg7kZ.createContainer)($eb306ed6e1ecf691$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            setState({
                ...$eb306ed6e1ecf691$var$initialState
            });
        }
});
const $eb306ed6e1ecf691$export$70dc54081d2075ff = (0, $3sQ5x.createHook)($eb306ed6e1ecf691$var$Store);

});

parcelRegister("5Nzrp", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingChecklistNext", () => $c4258442d9598a49$export$bbc4e97e9a15a84b);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $8iquX = parcelRequire("8iquX");

var $kkd2O = parcelRequire("kkd2O");

var $7CMCs = parcelRequire("7CMCs");

var $hsmeR = parcelRequire("hsmeR");

var $30rnQ = parcelRequire("30rnQ");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $52Vcw = parcelRequire("52Vcw");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");

var $9TQ3l = parcelRequire("9TQ3l");
const $c4258442d9598a49$export$bbc4e97e9a15a84b = ()=>{
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const { openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const currentRightSidebarPanelId = currentRightSidebarState?.panelId;
    const isRightSidePanelMinimised = currentRightSidebarState?.isMinimised ?? false;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>()=>{
            closeRightSidebar((0, $94Uc1.PANEL_ID));
            (0, $52Vcw.fireAnalyticsOnCloseRightHandSidebar)(createAnalyticsEvent, {
                quickstartStatus: quickstartStatus,
                isRightSidePanelCollapsed: isRightSidePanelMinimised,
                isRightSidePanelMinimised: isRightSidePanelMinimised,
                currentRightSidebarPanelId: currentRightSidebarPanelId || '',
                trigger: 'JswOnboardingChecklistNext'
            });
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $5uXOq.useEffect)(()=>{
        if ((quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED || quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED) && (0, $353uQ.isMetricRunning)((0, $353uQ.qsChecklistAutoLoadTime))) // QS Checklist loading cancelled for page load action
        (0, $353uQ.qsChecklistAutoLoadTime).cancel();
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED && (0, $353uQ.isMetricRunning)((0, $353uQ.qsChecklistDismissInteraction))) // User interaction completed for QS Checklist dismiss action
        (0, $353uQ.qsChecklistDismissInteraction).stop();
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED && currentRightSidebarPanelId === (0, $94Uc1.PANEL_ID)) {
            closeRightSidebar((0, $94Uc1.PANEL_ID));
            (0, $52Vcw.fireAnalyticsOnCloseRightHandSidebar)(createAnalyticsEvent, {
                quickstartStatus: quickstartStatus,
                isRightSidePanelCollapsed: isRightSidePanelMinimised,
                isRightSidePanelMinimised: isRightSidePanelMinimised,
                currentRightSidebarPanelId: currentRightSidebarPanelId || '',
                trigger: 'JswOnboardingChecklistNext'
            });
            return;
        }
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN && currentRightSidebarPanelId !== (0, $94Uc1.PANEL_ID)) {
            openRightSidebar((0, $94Uc1.PANEL_ID), (0, $94Uc1.PANEL_WIDTH));
            (0, $52Vcw.fireAnalyticsOnOpenRightHandSidebar)(createAnalyticsEvent, {
                quickstartStatus: quickstartStatus,
                isRightSidePanelCollapsed: isRightSidePanelMinimised,
                isRightSidePanelMinimised: isRightSidePanelMinimised,
                currentRightSidebarPanelId: currentRightSidebarPanelId || '',
                openRightSidebarAsMinimised: false,
                openRightSidebarToTop: false,
                trigger: 'JswOnboardingChecklistNext'
            });
        }
    }, [
        currentRightSidebarPanelId,
        openRightSidebar,
        closeRightSidebar,
        quickstartStatus,
        createAnalyticsEvent,
        isRightSidePanelMinimised
    ]);
    if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iquX.default), {
        name: "quickstart-fetching-data"
    });
    if (quickstartStatus !== (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "internalChecklistComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        sendToPrivacyUnsafeSplunk: true,
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkd2O.default), {
        name: "software-onboarding-checklist-next",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9TQ3l.AsyncJswOnboardingChecklistInternal), null)));
};

});
parcelRegister("9TQ3l", function(module, exports) {

$parcel$export(module.exports, "AsyncJswOnboardingChecklistInternal", () => $9a33006f56b5e7d2$export$9f3262905af42485);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/deprecations/no-rll-client-async-experiences
const $9a33006f56b5e7d2$var$Checklist = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("8kmlI")).then(({ JswOnboardingChecklistFinal: JswOnboardingChecklistFinal })=>{
        (0, $353uQ.qsChecklistAutoLoadTime).mark((0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END);
        return JswOnboardingChecklistFinal;
    }), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/onboarding/onboarding-checklist-next/src/ui/onboarding-checklist/checklist/index.tsx"
});
const $9a33006f56b5e7d2$var$ChecklistInternalLoadStart = ()=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $353uQ.qsChecklistAutoLoadTime).mark((0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $9a33006f56b5e7d2$export$9f3262905af42485 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-checklist-view-internal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9a33006f56b5e7d2$var$ChecklistInternalLoadStart, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9a33006f56b5e7d2$var$Checklist, null));

});
parcelRegister("8kmlI", function(module, exports) {

let $6101870eea9197e9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6101870eea9197e9$var$load("eNmuD"),
    $6101870eea9197e9$var$load("cM9em"),
    $6101870eea9197e9$var$load("fr9NE"),
    $6101870eea9197e9$var$load("h2MrD"),
    $6101870eea9197e9$var$load("bYT2S"),
    $6101870eea9197e9$var$load("fCxZC")
]).then(()=>parcelRequire('2wwLq'));

});



parcelRegister("eIh4F", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingButtonNext", () => $51c1715fc5801c45$export$bc3535037a418fa9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bngFq = parcelRequire("bngFq");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $hsmeR = parcelRequire("hsmeR");

var $ACELo = parcelRequire("ACELo");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");

var $30rnQ = parcelRequire("30rnQ");

var $8Bc5A = parcelRequire("8Bc5A");

var $1ffS1 = parcelRequire("1ffS1");

var $cE2Qr = parcelRequire("cE2Qr");

var $52Vcw = parcelRequire("52Vcw");

var $6jY6G = parcelRequire("6jY6G");

var $iuzc0 = parcelRequire("iuzc0");

var $9OXo1 = parcelRequire("9OXo1");

var $ieDtd = parcelRequire("ieDtd");

var $hPKVy = parcelRequire("hPKVy");

var $lysGg = parcelRequire("lysGg");
const $51c1715fc5801c45$export$7127386abbb0f79c = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const [selectedIssueValue] = (0, $ieDtd.useQueryParam)('selectedIssue');
    const [viewValue] = (0, $ieDtd.useQueryParam)('view');
    const isInRoadMapRoute = (0, $1ffS1.isRoadmapRoute)(route?.name);
    const isInBacklogRoute = route?.name === 'software-backlog';
    const isInBoardRoute = route?.name === 'software-boards';
    const isInRapidBoardBacklogRoute = route?.name === 'rapidboard-backlog';
    const isInRapidBoardBoardRoute = route?.name === 'rapidboard-board';
    // CMP & TMP Roadmap, and TMP backlog & board use selectedIssue query param
    if ((isInRoadMapRoute || isInBacklogRoute || isInBoardRoute) && Boolean(selectedIssueValue)) return true;
    // CMP backlog use view="detail" query param
    // (detail view can be triggered from the meatball menu on the issue modal)
    if (isInRapidBoardBacklogRoute) return viewValue === 'detail';
    // CMP Active Sprints and Kanban board uses view=detail query param
    // (detail view can be triggered from the meatball menu on the issue modal)
    if (isInRapidBoardBoardRoute && viewValue === 'detail') return true;
    return false;
};
const $51c1715fc5801c45$export$bc3535037a418fa9 = ()=>{
    // using hooks for TenantContext and SPA router in order to reduce the component tree
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const isIssueViewOpened = $51c1715fc5801c45$export$7127386abbb0f79c();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const isRightSidePanelMinimised = currentRightSidebarState?.isMinimised ?? false;
    const currentRightSidebarPanelId = currentRightSidebarState?.panelId;
    const [{ showQuickstartPill: showQuickstartPill }] = (0, $iuzc0.useQuickstartPillVisibilityStore)();
    (0, $5uXOq.useEffect)(()=>{
        if ((quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED || quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN) && (0, $353uQ.isMetricRunning)((0, $353uQ.qsButtonAutoLoadTime))) // QS Button loading cancelled for page load action
        (0, $353uQ.qsButtonAutoLoadTime).cancel();
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED && (0, $353uQ.isMetricRunning)((0, $353uQ.qsButtonDismissInteraction))) // User interaction completed for QS Button dismiss action
        (0, $353uQ.qsButtonDismissInteraction).stop();
        if (quickstartStatus !== (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED) return;
        // check if quickstart panel is already shown in minimised state in right-hand sidebar
        if (currentRightSidebarPanelId === (0, $94Uc1.PANEL_ID) && isRightSidePanelMinimised === true) return;
        openRightSidebar((0, $94Uc1.PANEL_ID), (0, $94Uc1.PANEL_WIDTH), true);
        (0, $52Vcw.fireAnalyticsOnOpenRightHandSidebar)(createAnalyticsEvent, {
            quickstartStatus: quickstartStatus,
            isRightSidePanelCollapsed: isRightSidePanelMinimised,
            isRightSidePanelMinimised: isRightSidePanelMinimised,
            currentRightSidebarPanelId: currentRightSidebarPanelId || '',
            openRightSidebarAsMinimised: true,
            openRightSidebarToTop: false,
            trigger: 'JswOnboardingButtonNext'
        });
    }, [
        isRightSidePanelMinimised,
        openRightSidebar,
        currentRightSidebarPanelId,
        quickstartStatus,
        createAnalyticsEvent
    ]);
    if (quickstartStatus !== (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED || showQuickstartPill !== null && !showQuickstartPill && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.pathname.endsWith('/list')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "internalChecklistButtonComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        sendToPrivacyUnsafeSplunk: true,
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ACELo.JiraBottomRightCornerOutlet), {
        orderFromRight: 1,
        id: "software-onboarding-quickstart-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51c1715fc5801c45$var$QuickstartButtonContainer, {
        isIssueViewOpened: isIssueViewOpened,
        "data-testid": "software-onboarding-quickstart.ui.onboarding-button.onboarding-button"
    }, (0, $4R6GH.fg)('convert_software_onboarding_button_to_be_sync') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lysGg.JswOnboardingChecklistButton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hPKVy.AsyncJswOnboardingButtonInternal), {
        tenantContext: tenantContext
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $51c1715fc5801c45$var$QuickstartButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIssueViewOpened: isIssueViewOpened, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isIssueViewOpened ? "_1e0cglyw" : "_1e0c1kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ACELo", function(module, exports) {

$parcel$export(module.exports, "JiraBottomRightCornerOutlet", () => $8d24666022201b4c$export$ee54e6ed235df65e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7nsd3 = parcelRequire("7nsd3");

var $b71gk = parcelRequire("b71gk");

var $hvrWv = parcelRequire("hvrWv");
const $8d24666022201b4c$var$OutletWithPortal = ({ orderFromRight: orderFromRight, children: children, id: id })=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const portalWrapper = (0, $5uXOq.useRef)(document.createElement('div'));
    const container = (0, $hvrWv.useBottomRightCornerContainer)();
    if (!container) throw new Error('GlobalBottomRightContainer could not be found. Please ensure that this container was rendered on the page.');
    const { insertBottomRightCornerPortal: insertBottomRightCornerPortal, removeBottomRightCornerPortal: removeBottomRightCornerPortal } = (0, $hvrWv.useBottomRightCornerActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (container) {
            const indexToRender = insertBottomRightCornerPortal({
                orderFromRight: orderFromRight,
                id: id
            });
            // @ts-expect-error - TS2538 - Type 'Promise<void>' cannot be used as an index type. | TS2538 - Type 'void' cannot be used as an index type.
            container.insertBefore(portalWrapper.current, container.children[indexToRender]);
        }
        // required as eslint complains about the ref in cleanup function
        const portalCurrent = portalWrapper.current;
        return ()=>{
            container?.removeChild(portalCurrent);
            removeBottomRightCornerPortal(id);
        };
    }, [
        container,
        id,
        orderFromRight,
        insertBottomRightCornerPortal,
        removeBottomRightCornerPortal
    ]);
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8d24666022201b4c$var$StyledOutlet, null, children), portalWrapper.current);
};
const $8d24666022201b4c$export$ee54e6ed235df65e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "bottom-right-corner-outlet",
        packageName: "jira-bottom-right-corner-controller",
        extraEventData: {
            portalId: props.id
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8d24666022201b4c$var$OutletWithPortal, props));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8d24666022201b4c$var$StyledOutlet = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1vgl1wug _1ko9pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hPKVy", function(module, exports) {

$parcel$export(module.exports, "AsyncJswOnboardingButtonInternal", () => $a716aabf2dd9ad95$export$a3ad38c2440b163);

var $5uXOq = parcelRequire("5uXOq");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a716aabf2dd9ad95$var$Button = (0, $b7Svb.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("lysGg"))).then(({ JswOnboardingChecklistButton: JswOnboardingChecklistButton })=>{
        (0, $353uQ.qsButtonAutoLoadTime).mark((0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_END);
        return JswOnboardingChecklistButton;
    }), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-quickstart/src/ui/onboarding-button/open-button/index.tsx"
});
const $a716aabf2dd9ad95$var$ButtonInternalLoadStart = ()=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $353uQ.qsButtonAutoLoadTime).mark((0, $94Uc1.PERFORMANCE_MARK).BUNDLE_LOAD_START);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $a716aabf2dd9ad95$export$a3ad38c2440b163 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-checklist-button-internal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a716aabf2dd9ad95$var$ButtonInternalLoadStart, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a716aabf2dd9ad95$var$Button, props));

});
parcelRegister("lysGg", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingChecklistButton", () => $abb3d5d8a2c0e8b0$export$235000cc42ca709a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aBnek = parcelRequire("aBnek");

var $bngFq = parcelRequire("bngFq");

var $hsmeR = parcelRequire("hsmeR");

var $94Uc1 = parcelRequire("94Uc1");

var $353uQ = parcelRequire("353uQ");


var $8Bc5A = parcelRequire("8Bc5A");

var $izv86 = parcelRequire("izv86");

var $cE2Qr = parcelRequire("cE2Qr");

var $52Vcw = parcelRequire("52Vcw");

var $2OMDV = parcelRequire("2OMDV");
var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");


var $4i99S = parcelRequire("4i99S");
const $abb3d5d8a2c0e8b0$var$ChecklistButtonAnaylticsWrapper = (0, $2OMDV.AnalyticsEventToProps)('button', {
    onClick: 'clicked'
})((0, $aBnek.default));
const $abb3d5d8a2c0e8b0$export$235000cc42ca709a = ()=>{
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const [, { nextSetChecklistIsDismissed: nextSetChecklistIsDismissed, setNudgeStep: setNudgeStep, setHasNudgeActive: setHasNudgeActive }] = (0, $cE2Qr.useQuickstartActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const openChecklist = (0, $4i99S.useOpenChecklist)();
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const [remoteStateFromHook] = (0, $cE2Qr.useJswOnboarding)();
    const currentRightSidebarPanelId = currentRightSidebarState?.panelId;
    const onDismiss = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        (0, $353uQ.qsButtonDismissInteraction).start();
        nextSetChecklistIsDismissed(true);
        setNudgeStep((0, $6784cbc7d62e5d7c$export$7aa8bceae32c7862));
        setHasNudgeActive(true);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $52Vcw.fireAnalyticsOnQuickstartDismiss)(analyticsEvent, {
            projectId: remoteStateFromHook.projectState?.projectId,
            productType: (0, $izv86.getProductType)(remoteStateFromHook.projectState?.projectType)
        }, 'button');
    }, [
        createAnalyticsEvent,
        nextSetChecklistIsDismissed,
        setNudgeStep,
        setHasNudgeActive,
        remoteStateFromHook
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if ((0, $353uQ.isMetricRunning)((0, $353uQ.qsButtonAutoLoadTime))) // QS Button loading completed on page load action
        (0, $353uQ.qsButtonAutoLoadTime).stop();
        if ((0, $353uQ.isMetricRunning)((0, $353uQ.qsChecklistMinimiseInteraction))) // User interaction completed for QS Checklist minimise action
        (0, $353uQ.qsChecklistMinimiseInteraction).stop();
    }, []);
    if (currentRightSidebarPanelId !== (0, $94Uc1.PANEL_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abb3d5d8a2c0e8b0$var$TriggerWrapper, {
        reposition: quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
        sourceName: (0, $8e02302c3f52a3b4$export$75cc63c8ac8ae533)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            projectId: remoteStateFromHook.projectState?.projectId,
            productType: (0, $izv86.getProductType)(remoteStateFromHook.projectState?.projectType)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abb3d5d8a2c0e8b0$var$ChecklistButtonAnaylticsWrapper, {
        isOpen: quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED,
        title: "Quickstart",
        onClick: (event, analyticsEvent)=>{
            (0, $353uQ.qsButtonOpenInteraction).start();
            openChecklist({
                trigger: 'JswOnboardingChecklistButton'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $8e02302c3f52a3b4$export$75cc63c8ac8ae533), {
                projectId: remoteStateFromHook.projectState?.projectId,
                productType: (0, $izv86.getProductType)(remoteStateFromHook.projectState?.projectType)
            });
        },
        onDismiss: onDismiss
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $abb3d5d8a2c0e8b0$var$TriggerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { reposition: reposition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564vccv _syaz1gjq _80omtlke",
            __cmplp.reposition ? "_otyr8vuz" : "_otyridpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2OMDV", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $28422a5dfa4a4065$export$3e9ef96ba97ea9dc);

var $3TR0I = parcelRequire("3TR0I");
const $28422a5dfa4a4065$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $28422a5dfa4a4065$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $3TR0I.default)($28422a5dfa4a4065$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

// Used for analytics event context for secondary (floating button) view
const $8e02302c3f52a3b4$export$75cc63c8ac8ae533 = 'nuxOnboardingQuickstartButton';

parcelRegister("4i99S", function(module, exports) {

$parcel$export(module.exports, "useOpenChecklist", () => $5c528ffca81c6bae$export$318fa8576ad8aa73);

var $bngFq = parcelRequire("bngFq");

var $hsmeR = parcelRequire("hsmeR");

var $94Uc1 = parcelRequire("94Uc1");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $52Vcw = parcelRequire("52Vcw");
const $5c528ffca81c6bae$export$318fa8576ad8aa73 = ()=>{
    const [{ openTask: currentOpenTask }, { nextSetChecklistIsOpen: nextSetChecklistIsOpen, nextSetChecklistIsDismissed: nextSetChecklistIsDismissed, nextOpenTask: nextOpenTask }] = (0, $cE2Qr.useJswOnboarding)();
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const currentPanelId = currentRightSidebarState?.panelId;
    const openChecklist = ({ trigger: trigger, openTask: openTask })=>{
        if (openTask && openTask !== currentOpenTask) nextOpenTask(openTask);
        openRightSidebar((0, $94Uc1.PANEL_ID), (0, $94Uc1.PANEL_WIDTH), false, true);
        (0, $52Vcw.fireAnalyticsOnOpenRightHandSidebar)(createAnalyticsEvent, {
            quickstartStatus: quickstartStatus,
            currentRightSidebarPanelId: currentPanelId || '',
            openRightSidebarToTop: true,
            trigger: trigger
        });
        if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED) nextSetChecklistIsDismissed(false);
        else nextSetChecklistIsOpen(true);
    };
    return openChecklist;
};

});




parcelRegister("hXb6V", function(module, exports) {

let $d12090b295ff7551$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d12090b295ff7551$var$load("aOcsJ").then(()=>parcelRequire('jVPxT'));

});


parcelRegister("5VgFy", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $a287374312b47606$export$2ce376c2cc3355c8);

var $5uXOq = parcelRequire("5uXOq");

var $7H980 = parcelRequire("7H980");

var $h1Skt = parcelRequire("h1Skt");

var $2j8gO = parcelRequire("2j8gO");

var $l4RTn = parcelRequire("l4RTn");
const $a287374312b47606$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, params: params, query: query, replace: replace, target: target, to: to, type: type, ...rest }, ref)=>{
    const onClickHandler = (0, $l4RTn.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    if (to != null && __SPA__) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2j8gO.RouteLinkItem), {
        ref: ref,
        onClick: onClickHandler,
        params: params,
        query: query,
        replace: replace,
        target: target,
        to: to,
        type: type,
        ...rest
    });
    return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h1Skt.LinkItem), {
        ref: ref,
        href: href,
        target: target,
        onClick: onClickHandler,
        ...rest
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        ref: ref,
        onClick: onClickHandler,
        ...rest
    });
});

});
parcelRegister("h1Skt", function(module, exports) {

$parcel$export(module.exports, "LinkItem", () => $d01d9eadf1c4c537$export$532cb6865ebe8946);

var $5uXOq = parcelRequire("5uXOq");

var $44qT7 = parcelRequire("44qT7");

var $9xqMZ = parcelRequire("9xqMZ");
const $d01d9eadf1c4c537$export$532cb6865ebe8946 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ href: href, target: target, onClick: onClick, ...rest }, ref)=>{
    const navigate = (0, $9xqMZ.useNavigate)({
        href: href,
        onClick: onClick,
        target: target
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44qT7.default), {
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : '',
        onClick: navigate,
        ref: ref,
        ...rest
    });
});

});
parcelRegister("9xqMZ", function(module, exports) {

$parcel$export(module.exports, "useNavigate", () => $58d3fdc92300b506$export$9770f232ac06a008);

var $5uXOq = parcelRequire("5uXOq");

var $lVJAU = parcelRequire("lVJAU");
const $58d3fdc92300b506$export$9770f232ac06a008 = ({ href: href, target: target, onClick: onClick, useRouterActions: useRouterActions = (0, $lVJAU.useRouterActions), useCallback: useCallback = (0, $5uXOq.useCallback) })=>{
    const { push: push } = useRouterActions();
    return useCallback((event)=>{
        onClick && onClick(event);
        if (event.ctrlKey || event.metaKey || event.defaultPrevented || target === '_blank') return;
        event.preventDefault();
        push(href);
    }, [
        push,
        href,
        target,
        onClick
    ]);
};

});


parcelRegister("2j8gO", function(module, exports) {

$parcel$export(module.exports, "RouteLinkItem", () => $51491ac4f945fa1d$export$5885e1e37551a766);

var $5uXOq = parcelRequire("5uXOq");

var $2COCu = parcelRequire("2COCu");

var $hjSul = parcelRequire("hjSul");
const $51491ac4f945fa1d$export$5885e1e37551a766 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ rel: rel, target: target, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2COCu.default), {
        component: (0, $hjSul.Link),
        rel: rel ?? (target === '_blank' ? 'noopener noreferrer' : ''),
        target: target,
        prefetch: "hover",
        ref: ref,
        ...props
    }));

});

parcelRegister("l4RTn", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $0a514b9f30dcd204$export$a81c45382e7253ac);

var $2uT3N = parcelRequire("2uT3N");

var $2Ui4E = parcelRequire("2Ui4E");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");
const $0a514b9f30dcd204$export$a81c45382e7253ac = ({ analytics: analytics, fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), onClick: onClick, useAnalyticsEvents: useAnalyticsEvents = (0, $bngFq.useAnalyticsEvents), useOverflowStatus: useOverflowStatus = (0, $2uT3N.useOverflowStatus), useTopMenus: useTopMenus = (0, $2Ui4E.useTopMenus) } = {})=>{
    const [, { off: closeMenu }] = useTopMenus();
    const { isVisible: isVisible, closeOverflowMenu: closeOverflowMenu } = useOverflowStatus();
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const { actionSubjectId: actionSubjectId, ...analyticsRest } = analytics;
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationMenuItem'
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fireUIAnalytics(analyticsEvent, actionSubjectId, {
            ...analyticsRest,
            isInMore: !isVisible
        });
        onClick && onClick(event);
        if (event.ctrlKey || event.metaKey) return;
        closeMenu();
        closeOverflowMenu();
    };
};

});


parcelRegister("6e9wd", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $0fd6665e618bdb77$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "MenuListItem", () => $0fd6665e618bdb77$export$6c2f3257abc4825b);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");
const $0fd6665e618bdb77$export$d4c4e98c5044dc8 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "ul",
        xcss: $0fd6665e618bdb77$var$removeDefaultListStyles
    }, children);
const $0fd6665e618bdb77$export$6c2f3257abc4825b = ({ children: children, ariaLabel: ariaLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "li",
        xcss: $0fd6665e618bdb77$var$removeDefaultListStyles,
        "aria-label": ariaLabel
    }, children);
const $0fd6665e618bdb77$var$removeDefaultListStyles = (0, $2s57o.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});

});

parcelRegister("lwZRC", function(module, exports) {

$parcel$export(module.exports, "StandardToPremiumPubTouchpoint", () => $6a708ba8cfda3999$export$ed538b2b0eb2751);

var $aE7yh = parcelRequire("aE7yh");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $d6a7c = parcelRequire("d6a7c");
var $70rf1 = parcelRequire("70rf1");

var $2Ui4E = parcelRequire("2Ui4E");

var $lmyls = parcelRequire("lmyls");

var $koVbs = parcelRequire("koVbs");

var $6s1PB = parcelRequire("6s1PB");

var $4YnVl = parcelRequire("4YnVl");

var $7CMCs = parcelRequire("7CMCs");

var $cNd4s = parcelRequire("cNd4s");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $cSD7y = parcelRequire("cSD7y");

var $9uGVy = parcelRequire("9uGVy");

var $gyBod = parcelRequire("gyBod");

var $jPvhy = parcelRequire("jPvhy");

var $lk9cj = parcelRequire("lk9cj");

var $an2OZ = parcelRequire("an2OZ");

var $foK1Z = parcelRequire("foK1Z");
function $6a708ba8cfda3999$var$StandardToPremiumPubTouchpointImpl() {
    const [, { off: closeMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).PROFILE);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { product: product = '', edition: edition } = (0, $lk9cj.useProductAndEdition)();
    const { hasFetched: hasFetchedDismissedEditionAwarenessPillState, isDismissed: hasDismissedEditionAwarenessPill } = (0, $9uGVy.useIsEditionAwarenessPillDismissed)();
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'editionAwarenessStandardToPremiumPUB');
        closeMenu();
    }, [
        closeMenu,
        createAnalyticsEvent
    ]);
    /**
   * We won't know for certain if the user is currently on a paid standard plan until we query for the entitlement
   * However, we can know for certain if they are not on any type of standard plan
   * If they are not on a standard plan, we can skip the query
   */ let isPossiblyPaidStandard = false;
    if (edition === 'standard') {
        if (product === 'jira') isPossiblyPaidStandard = (0, $4R6GH.fg)('edition_awareness_upsell_jira_fg');
        if (product === 'jira-service-management') isPossiblyPaidStandard = (0, $4R6GH.fg)('edition_awareness_upsell_jsm_fg');
    }
    // basic eligibility conditions
    const isEligibleForExperiment = isPossiblyPaidStandard && isSiteAdmin && hasFetchedDismissedEditionAwarenessPillState && hasDismissedEditionAwarenessPill;
    let cohort = 'not-enrolled';
    if (isEligibleForExperiment) cohort = (0, $6s1PB.expVal)('edition_awareness_upsell_jira_ab', 'cohort', 'not-enrolled');
    // Only call api if the user is eligible and enrolled in the experiment
    const shouldSkip = cohort !== 'treatment';
    const data = (0, $8Uumt.useLazyLoadQuery)((0, $aE7yh.default), {
        cloudId: cloudId,
        shouldSkip: shouldSkip,
        productKey: product ? (0, $jPvhy.getHamsKey)(product) : '' // will be skipped regardless if product is undefined
    });
    const paidEntitlement = data?.tenantContexts?.[0]?.entitlementInfo?.paidEntitlement;
    const isInvoiceable = paidEntitlement?.subscription?.accountDetails?.invoiceGroup?.invoiceable;
    const canUpgrade = Boolean(paidEntitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser && paidEntitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl);
    if (!paidEntitlement || !isInvoiceable || !canUpgrade) return null;
    const experienceUrl = paidEntitlement.experienceCapabilities?.changeOfferingV2?.experienceUrl ?? undefined;
    const learnMoreUrl = (0, $an2OZ.buildLearnMoreLink)(experienceUrl);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "editionAwarenessStandardToPremiumPUB",
        sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6a7c.default), null, formatMessage((0, $foK1Z.default).upgrade)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gyBod.StandardToPremiumModalEntrypointTrigger), {
        product: product,
        experienceUrl: experienceUrl,
        learnMoreUrl: learnMoreUrl,
        onClick: handleOnClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YnVl.EditionAwarenessStandardPubTouchpoint), {
        product: product
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            cohort: cohort,
            flagKey: 'edition_awareness_upsell_jira_ab'
        }
    }));
}
function $6a708ba8cfda3999$var$StandardToPremiumPubTouchpointWithErrorBoundary() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "editionAwarenessStandardToPremiumPubTouchpoint",
        packageName: "jiraEditionAwarenessForStandardToPremium",
        fallback: "unmount",
        teamName: "luna-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6a708ba8cfda3999$var$StandardToPremiumPubTouchpointImpl, null));
}
const $6a708ba8cfda3999$export$ed538b2b0eb2751 = (0, $cSD7y.componentWithFG)('edition_awareness_upsell_jira_ab_fg', $6a708ba8cfda3999$var$StandardToPremiumPubTouchpointWithErrorBoundary, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null));

});
parcelRegister("aE7yh", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe9663d0f5034e16$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<47d32ff7c36122fa39897b48fe0f9a0e>>
 * @relayHash c7324e9819e70c7df227b1da0e5f9ed8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9559fd56bec53bc3ae3d1aac1974c98b76d67946b87c7eda3c47edc8bca6c42b
const $fe9663d0f5034e16$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "productKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldSkip"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "where",
            "value": {
                "inTrialOrPreDunning": false
            }
        }
    ], v4 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "premium"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v6 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v7 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = [
        v9 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "standardToPremiumPubTouchpointQuery",
            "selections": [
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": "paidEntitlement",
                                            "args": v3 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "experienceCapabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v4 /*: any*/ ,
                                                            "kind": "LinkedField",
                                                            "name": "changeOfferingV2",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ 
                                                            ],
                                                            "storageKey": "changeOfferingV2(offeringName:\"premium\")"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "accountDetails",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "invoiceGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "entitlement(where:{\"inTrialOrPreDunning\":false})"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "standardToPremiumPubTouchpointQuery",
            "selections": [
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "alias": "paidEntitlement",
                                            "args": v3 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "experienceCapabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "args": v4 /*: any*/ ,
                                                            "kind": "LinkedField",
                                                            "name": "changeOfferingV2",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ 
                                                            ],
                                                            "storageKey": "changeOfferingV2(offeringName:\"premium\")"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "accountDetails",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "invoiceGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v10 /*: any*/ ,
                                                                            "type": "CcpInvoiceGroup"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v10 /*: any*/ ,
                                                            "type": "CcpSubscription"
                                                        }
                                                    ]
                                                },
                                                v9 /*: any*/ 
                                            ],
                                            "storageKey": "entitlement(where:{\"inTrialOrPreDunning\":false})"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9559fd56bec53bc3ae3d1aac1974c98b76d67946b87c7eda3c47edc8bca6c42b",
            "metadata": {},
            "name": "standardToPremiumPubTouchpointQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fe9663d0f5034e16$var$node.hash = "855ed0d991a0791b463b2dda5ef90efb";
var $fe9663d0f5034e16$export$2e2bcd8739ae039 = $fe9663d0f5034e16$var$node;

});

parcelRegister("9uGVy", function(module, exports) {

$parcel$export(module.exports, "useIsEditionAwarenessPillDismissed", () => $16a1e29b9123e8d1$export$7cb865d6d91f9a4d);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $jPvhy = parcelRequire("jPvhy");
const $16a1e29b9123e8d1$export$7cb865d6d91f9a4d = ()=>{
    const [hasFetched, setHasFetched] = (0, $5uXOq.useState)(false);
    const [isDismissed, setIsDismissed] = (0, $5uXOq.useState)(true);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('edition_awareness_upsell_jira_aa_fg') || (0, $4R6GH.fg)('edition_awareness_upsell_jira_ab_fg')) (0, $jPvhy.fetchEditionAwarenessPillDismissed)().then((result)=>{
            setIsDismissed(!!result);
            setHasFetched(true);
        });
    }, []);
    const handleDismiss = (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('edition_awareness_upsell_jira_aa_fg') || (0, $4R6GH.fg)('edition_awareness_upsell_jira_ab_fg')) {
            setIsDismissed(true);
            (0, $jPvhy.setEditionAwarenessPillDismissed)(true);
        }
    }, []);
    return {
        hasFetched: hasFetched,
        isDismissed: isDismissed,
        handleDismiss: handleDismiss
    };
};

});
parcelRegister("jPvhy", function(module, exports) {

$parcel$export(module.exports, "getHamsKey", () => $439f9424d8ca41fa$export$291d012eb0744b34);
$parcel$export(module.exports, "setEditionAwarenessPillDismissed", () => $439f9424d8ca41fa$export$b0b754c480c139ac);
$parcel$export(module.exports, "fetchEditionAwarenessPillDismissed", () => $439f9424d8ca41fa$export$1eb6cd4dd0048115);

var $aHuqL = parcelRequire("aHuqL");

var $jcw0u = parcelRequire("jcw0u");

const $439f9424d8ca41fa$var$ProductKeyToHAMSMap = {
    jira: 'jira-software',
    'jira-product-discovery': 'jira-product-discovery',
    'jira-service-management': 'jira-servicedesk'
};
const $439f9424d8ca41fa$export$291d012eb0744b34 = (product)=>{
    return $439f9424d8ca41fa$var$ProductKeyToHAMSMap[product];
};
const $439f9424d8ca41fa$export$b0b754c480c139ac = async (value)=>{
    try {
        await (0, $aHuqL.userPreferenceAPI).set((0, $27f794e239d3d8c4$export$83e119fb36bc846a), value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $jcw0u.default)({
            error: err,
            meta: {
                id: 'setEditionAwarenessPillDismissed',
                packageName: (0, $27f794e239d3d8c4$export$52483b87432059f1)
            }
        });
    }
};
const $439f9424d8ca41fa$export$1eb6cd4dd0048115 = async ()=>{
    try {
        return await (0, $aHuqL.userPreferenceAPI).get((0, $27f794e239d3d8c4$export$83e119fb36bc846a));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (err.statusCode !== 404) // 404 is acceptable as it means user hasn't dismissed it yet
        (0, $jcw0u.default)({
            error: err,
            meta: {
                id: 'fetchEditionAwarenessPillDismissed',
                packageName: (0, $27f794e239d3d8c4$export$52483b87432059f1)
            }
        });
        return null;
    }
};

});
const $27f794e239d3d8c4$export$52483b87432059f1 = 'jiraEditionAwarenessForStandardToPremium';
const $27f794e239d3d8c4$export$83e119fb36bc846a = 'jira.user.theme.standard-to-premium-ea-pill.dismissed';



parcelRegister("gyBod", function(module, exports) {

$parcel$export(module.exports, "StandardToPremiumModalEntrypointTrigger", () => $a2a14da66d3e934c$export$976615bbf89d8782);

var $5uXOq = parcelRequire("5uXOq");

var $7H980 = parcelRequire("7H980");

var $2KAtx = parcelRequire("2KAtx");

var $5UWF6 = parcelRequire("5UWF6");

var $hYoRS = parcelRequire("hYoRS");
const $a2a14da66d3e934c$export$976615bbf89d8782 = ({ children: children, product: product, experienceUrl: experienceUrl, learnMoreUrl: learnMoreUrl, onClick: onClick })=>{
    const { url: learnMoreHref = '' } = (0, $5UWF6.useTracedUrl)(learnMoreUrl ?? '/admin/billing');
    // admin/billing redirects to the subscription page
    const { url: changeOfferingHref = '' } = (0, $5UWF6.useTracedUrl)(experienceUrl ?? '/admin/billing');
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            product: product,
            learnMoreHref: learnMoreHref,
            changeOfferingHref: changeOfferingHref
        }), [
        product,
        learnMoreHref,
        changeOfferingHref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $hYoRS.standardToPremiumModalEntryPoint),
        entryPointProps: entryPointProps,
        interactionName: "standard-to-premium-modal",
        useInternalModal: true,
        modalProps: {
            width: 'x-large',
            shouldCloseOnOverlayClick: true,
            shouldCloseOnEscapePress: true
        }
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
            onClick: onClick,
            ref: ref
        }, children));
};

});
parcelRegister("5UWF6", function(module, exports) {

$parcel$export(module.exports, "useTracedUrl", () => $f86ae6590de30575$export$5eea7bde9861e87b);

var $5uXOq = parcelRequire("5uXOq");

var $2VHHh = parcelRequire("2VHHh");
function $f86ae6590de30575$export$5eea7bde9861e87b(untracedUrl) {
    const origin = (0, $5uXOq.useMemo)(()=>new (0, $2VHHh.default)({
            product: 'jira'
        }), []);
    const url = (0, $5uXOq.useMemo)(()=>untracedUrl ? origin.addToUrl(untracedUrl) : undefined, [
        untracedUrl,
        origin
    ]);
    return {
        url: url,
        origin: origin
    };
}

});

parcelRegister("hYoRS", function(module, exports) {

$parcel$export(module.exports, "standardToPremiumModalEntryPoint", () => $e5cfaf5eabd8c4a0$export$e2f72ec158f4526d);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $e5cfaf5eabd8c4a0$export$e2f72ec158f4526d = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("Awlcm")), {
        moduleId: "d31b6b17"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("Awlcm", function(module, exports) {

let $06dc7323700fd02f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $06dc7323700fd02f$var$load("ktpeh").then(()=>parcelRequire('6Zwhu'));

});



parcelRegister("lk9cj", function(module, exports) {

$parcel$export(module.exports, "useProductAndEdition", () => $10793f21f1ca9c0d$export$b0f1c0403c557678);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $hLQN7 = parcelRequire("hLQN7");

var $lpwtK = parcelRequire("lpwtK");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $4SswE = parcelRequire("4SswE");
const $10793f21f1ca9c0d$export$b0f1c0403c557678 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const { loading: loading, data: project } = (0, $lpwtK.useProject)();
    const siteHasOnlyJira = (0, $4SswE.useSiteHasOnlyJira)();
    const { getIsEligibleForJsmPremiumPillExperiment: getIsEligibleForJsmPremiumPillExperiment } = (0, $hLQN7.useJsmPremiumPillExperiment)();
    // Show premium pill button for JSM premium trial experiment
    const projectType = (0, $5uXOq.useMemo)(()=>{
        if (loading) return;
        const type = (0, $2vSU6.toProjectType)(project?.type);
        if (type) return type;
        if (siteHasOnlyJira) return 0, $2vSU6.SOFTWARE_PROJECT;
        if (getIsEligibleForJsmPremiumPillExperiment()) // If the user is on the JSM assets page, we want to default the project type to JSM
        return 0, $2vSU6.SERVICE_DESK_PROJECT;
    }, [
        loading,
        project?.type,
        siteHasOnlyJira,
        getIsEligibleForJsmPremiumPillExperiment
    ]);
    const localEdition = (0, $5uXOq.useMemo)(()=>{
        if (!projectType) return;
        return (0, $ldyPw.getEditionForProject)(projectType, appEditions);
    }, [
        appEditions,
        projectType
    ]);
    const { product: product, edition: edition } = (0, $5uXOq.useMemo)(()=>{
        if (!projectType || !localEdition) // We don't have a product or edition, so return nothing
        return {};
        if (projectType === (0, $2vSU6.CORE_PROJECT) && !siteHasOnlyJira) // We are supporting only JWM implicit licensing when the parent license is JSW
        // Do not show on core products if site does not have only Jira
        return {};
        return {
            product: $10793f21f1ca9c0d$var$getEaProduct(projectType),
            edition: $10793f21f1ca9c0d$var$getEaEdition(localEdition)
        };
    }, [
        localEdition,
        projectType,
        siteHasOnlyJira
    ]);
    return {
        product: product,
        edition: edition
    };
};
const $10793f21f1ca9c0d$var$getEaEdition = (e)=>{
    if (e === 'FREE_EDITION') return 'free';
    if (e === 'STANDARD_EDITION') return 'standard';
    if (e === 'PREMIUM_EDITION') return 'premium';
};
const $10793f21f1ca9c0d$var$getEaProduct = (p)=>{
    if (p === (0, $2vSU6.SOFTWARE_PROJECT)) return 'jira';
    if (p === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return 'jira-product-discovery';
    if (p === (0, $2vSU6.SERVICE_DESK_PROJECT)) return 'jira-service-management';
    if (p === (0, $2vSU6.CORE_PROJECT)) return 'jira';
};

});
parcelRegister("hLQN7", function(module, exports) {

$parcel$export(module.exports, "useJsmPremiumPillExperiment", () => $504e7a848a9d3d9b$export$b59e3fcc3b941876);
$parcel$export(module.exports, "isCMDBPage", () => $504e7a848a9d3d9b$export$acdcb04b84a589b3);

var $2vSU6 = parcelRequire("2vSU6");

var $6jY6G = parcelRequire("6jY6G");

var $dAfqg = parcelRequire("dAfqg");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");
const $504e7a848a9d3d9b$export$b59e3fcc3b941876 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const edition = (0, $ldyPw.getEditionForProject)((0, $2vSU6.SERVICE_DESK_PROJECT), appEditions);
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const isJSM = project?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const isOnCMDBPage = $504e7a848a9d3d9b$export$acdcb04b84a589b3(route.name);
    const getIsEligibleForJsmPremiumPillExperiment = ()=>{
        if (edition !== (0, $ldyPw.PREMIUM_EDITION)) return false;
        if (isOnCMDBPage && isSiteAdmin) // only siteAdmins on CMDB pages are eligible
        return true;
        if (!project) return false;
        if (!isJSM) return false;
        if (project.simplified) // simplified project does not have the premium features
        return false;
        const isProjectAdmin = !!project.isProjectAdmin;
        // finally check if they are an admin who can change features for the project
        return isProjectAdmin || isSiteAdmin;
    };
    return {
        getIsEligibleForJsmPremiumPillExperiment: getIsEligibleForJsmPremiumPillExperiment,
        isOnCMDBPage: isOnCMDBPage
    };
};
const $504e7a848a9d3d9b$export$acdcb04b84a589b3 = (routeName)=>{
    return [
        'servicedesk-cmdb-assets',
        'servicedesk-cmdb-configure',
        'servicedesk-cmdb-object',
        'servicedesk-cmdb-object-schema',
        'servicedesk-cmdb-object-schema-configuration',
        'servicedesk-cmdb-object-type-configuration',
        'servicedesk-cmdb-assets-reports',
        'servicedesk-cmdb-assets-reports-default-redirect',
        'servicedesk-cmdb-assets-reports-unsubscribe',
        'servicedesk-cmdb-insight',
        'servicedesk-cmdb-configure',
        'servicedesk-cmdb-object',
        'servicedesk-cmdb-object-schema',
        'servicedesk-cmdb-object-schema-configuration',
        'servicedesk-cmdb-object-type-configuration'
    ].includes(routeName);
};

});

parcelRegister("4SswE", function(module, exports) {

$parcel$export(module.exports, "useSiteHasOnlyJira", () => $b6d886096eb5e5b4$export$8ce0db5ac54a6136);

var $cVzoY = parcelRequire("cVzoY");


var $9OXo1 = parcelRequire("9OXo1");
function $b6d886096eb5e5b4$export$8ce0db5ac54a6136() {
    const tenantContext = (0, $9OXo1.useTenantContext)();
    try {
        const [firstExplicitlyLicensedProduct, ...rest] = (0, $cVzoY.default)(tenantContext);
        return rest.length === 0 && firstExplicitlyLicensedProduct === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d);
    } catch  {
        return false;
    }
}

});


parcelRegister("an2OZ", function(module, exports) {

$parcel$export(module.exports, "buildLearnMoreLink", () => $16b1918907d3952c$export$340c557654f9b70);
const $16b1918907d3952c$var$FALLBACK_URL = '/admin/billing';
function $16b1918907d3952c$export$340c557654f9b70(href) {
    if (!href) return $16b1918907d3952c$var$FALLBACK_URL;
    try {
        const url = new URL(href);
        // Check if this is a HAMS URL by looking for 'change-edition' in the path
        if (url.pathname.includes('change-edition')) {
            // For HAMS URLs, we want to remove /premium from the path
            url.pathname = url.pathname.replace('/premium', '');
            return url.toString();
        }
        // For CCP URLs, we just need to remove the offering parameters
        url.searchParams.delete('offeringName');
        url.searchParams.delete('offeringname');
        return url.toString();
    } catch  {
        return $16b1918907d3952c$var$FALLBACK_URL;
    }
}

});

parcelRegister("foK1Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $11f40dea63877669$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $11f40dea63877669$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    upgrade: {
        "id": "jira-edition-awareness-for-standard-to-premium.standard-to-premium-pub-touchpoint.menu.upgrade",
        "defaultMessage": "Upgrade"
    }
});

});


parcelRegister("ckmlX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cda9ec250c8f96e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8cda9ec250c8f96e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    giveFeedback: {
        "id": "atlassian-navigation-nav4.profile.menu.give-feedback",
        "defaultMessage": "Give us feedback"
    },
    yourBoards: {
        "id": "atlassian-navigation-nav4.profile.menu.your-boards",
        "defaultMessage": "Your boards"
    },
    new: {
        "id": "atlassian-navigation-nav4.profile.menu.new",
        "defaultMessage": "new"
    },
    personalSettings: {
        "id": "atlassian-navigation-nav4.profile.menu.personal-settings",
        "defaultMessage": "Personal settings"
    },
    logout: {
        "id": "atlassian-navigation-nav4.profile.menu.logout",
        "defaultMessage": "Log out"
    },
    jira: {
        "id": "atlassian-navigation-nav4.profile.menu.jira",
        "defaultMessage": "Jira"
    },
    account: {
        "id": "atlassian-navigation-nav4.profile.menu.account",
        "defaultMessage": "Account"
    },
    profile: {
        "id": "atlassian-navigation-nav4.profile.menu.profile",
        "defaultMessage": "Profile"
    },
    notifications: {
        "id": "atlassian-navigation-nav4.profile.menu.notifications",
        "defaultMessage": "Notifications"
    }
});

});

parcelRegister("j6Dnq", function(module, exports) {

$parcel$export(module.exports, "ExtraItemsNav4", () => $f13d910bb1a99a5c$export$ee2972db91c46b97);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $70rf1 = parcelRequire("70rf1");

var $hrlU6 = parcelRequire("hrlU6");

var $6cNb0 = parcelRequire("6cNb0");

var $atU1t = parcelRequire("atU1t");

var $2YP9W = parcelRequire("2YP9W");

var $5VgFy = parcelRequire("5VgFy");

var $6e9wd = parcelRequire("6e9wd");
const $f13d910bb1a99a5c$var$useConnectItems = ()=>{
    const { data: resourceData, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $atU1t.navigationSidebarGlobalResource));
    const data = resourceData?.response;
    (0, $5uXOq.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        error,
        loading,
        refresh
    ]);
    return data ? (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, 'global.profile.items', []).filter((item)=>![
            'view_profile',
            'log_out'
        ].includes(item.id)) : [];
};
const $f13d910bb1a99a5c$var$Item = ({ url: url, name: name, id: id, styleClass: styleClass, itemAriaLabel: itemAriaLabel, position: position, testId: testId })=>{
    const webItemRef = (0, $5uXOq.useRef)(null);
    const isDialog = styleClass && (0, $hrlU6.isConnectDialogWebItem)(styleClass);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (isDialog) (0, $hrlU6.withConnectHost)((connectHost)=>{
            if (styleClass && webItemRef.current) connectHost.triggerWebItem(webItemRef.current, styleClass, url);
        });
    }, [
        isDialog,
        styleClass,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6e9wd.MenuListItem), {
        key: url,
        ariaLabel: itemAriaLabel || ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5VgFy.MenuItem), {
        ref: webItemRef,
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: id,
            menuItemType: 'jira',
            position: position
        },
        href: isDialog ? undefined : url,
        onClick: isDialog ? onClick : undefined,
        testId: testId
    }, name));
};
const $f13d910bb1a99a5c$export$56021421a935c353 = ({ startPosition: startPosition, testIdPrefix: testIdPrefix, itemAriaLabel: itemAriaLabel })=>{
    const connectItems = $f13d910bb1a99a5c$var$useConnectItems();
    if (!connectItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, connectItems.map(({ id: id, name: name, url: url, styleClass: styleClass }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f13d910bb1a99a5c$var$Item, {
            key: url,
            url: url,
            name: name,
            id: id,
            styleClass: styleClass,
            itemAriaLabel: itemAriaLabel,
            position: startPosition + idx,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, `item-addon-${idx}`)
        });
    }));
};
const $f13d910bb1a99a5c$export$ee2972db91c46b97 = ({ startPosition: startPosition, testIdPrefix: testIdPrefix, itemAriaLabel: itemAriaLabel })=>{
    const connectItems = $f13d910bb1a99a5c$var$useConnectItems();
    if (!connectItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        hasSeparator: true
    }, connectItems.map(({ id: id, name: name, url: url, styleClass: styleClass }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f13d910bb1a99a5c$var$Item, {
            key: url,
            url: url,
            name: name,
            id: id,
            styleClass: styleClass,
            itemAriaLabel: itemAriaLabel,
            position: startPosition + idx,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, `item-addon-${idx}`)
        });
    }));
};

});


parcelRegister("904lL", function(module, exports) {

$parcel$export(module.exports, "useUserBoardId", () => $8c0c1ab8ec5b52ee$export$e6e895063f36c814);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $6yXtV = parcelRequire("6yXtV");
const $8c0c1ab8ec5b52ee$export$e6e895063f36c814 = (shouldRun)=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [userBoard, setUserBoard] = (0, $5uXOq.useState)(null);
    const shouldFetch = shouldRun || isReady;
    (0, $5uXOq.useEffect)(()=>{
        if (!shouldFetch || userBoard) return;
        setUserBoard(null);
        const requestUrl = '/rest/greenhopper/1.0/rapidviews/recent?maxResults=1&userBoard=true';
        (0, $eusud.performGetRequest)(requestUrl).then((result)=>{
            const [board] = result.views;
            if (board) setUserBoard(board);
        }).catch(()=>{
        // user board fetch failed, ignore
        });
    }, [
        shouldFetch,
        userBoard,
        setUserBoard
    ]);
    return userBoard && userBoard.location ? [
        userBoard.id,
        userBoard.location.accountId
    ] : [
        null,
        null
    ];
};

});

parcelRegister("cLIpE", function(module, exports) {

$parcel$export(module.exports, "Nav4ProfileMenuEntryPoint", () => $876c2695d1976e10$export$e30a856958207b6);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $bVJxC = parcelRequire("bVJxC");

const $876c2695d1976e10$export$e30a856958207b6 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("eICwl")), {
        moduleId: "18b1d8bb"
    }),
    getPreloadProps: ({ includeExtraMenuItems: includeExtraMenuItems })=>({
            queries: {
                profileMenuQuery: {
                    parameters: $bVJxC.default,
                    variables: {
                        includeExtraMenuItems: includeExtraMenuItems
                    }
                }
            }
        })
});

});
parcelRegister("bVJxC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5925de38e3f3e959$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc9c2fcd14832ff6f021278465d2a9bc>>
 * @relayHash 73520ae724cd725d1b8a9eaf5e2c16fc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2757426f0a0e166111d8064199946a10478bc2b410dc09def2c817aed218a3c8
const $5925de38e3f3e959$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2757426f0a0e166111d8064199946a10478bc2b410dc09def2c817aed218a3c8",
        "metadata": {},
        "name": "profileMenuQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5925de38e3f3e959$export$2e2bcd8739ae039 = $5925de38e3f3e959$var$node;

});

parcelRegister("eICwl", function(module, exports) {

let $ab730e2d451965b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ab730e2d451965b2$var$load("9oequ").then(()=>parcelRequire('eWrtG'));

});






parcelRegister("13iNl", function(module, exports) {

$parcel$export(module.exports, "recommendations", () => $56dde49bc4054ac6$export$b7e5cef71fa42514);

var $a334R = parcelRequire("a334R");


const $56dde49bc4054ac6$var$createRecommendationsList = ()=>{
    const recommendationsList = [];
    recommendationsList.push((0, $a334R.default));
    // Add your own templates
    return recommendationsList;
};
const $56dde49bc4054ac6$export$b7e5cef71fa42514 = $56dde49bc4054ac6$var$createRecommendationsList();

});
parcelRegister("a334R", function(module, exports) {

$parcel$export(module.exports, "default", () => $fccc347b1e897d64$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3gy1Y = parcelRequire("3gy1Y");

var $Q9DHJ = parcelRequire("Q9DHJ");
var $bBrJC = parcelRequire("bBrJC");

var $cNW3X = parcelRequire("cNW3X");

var $eOat1 = parcelRequire("eOat1");

var $6eFvr = parcelRequire("6eFvr");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $90yGq = parcelRequire("90yGq");

var $2tT7R = parcelRequire("2tT7R");

var $aRT0u = parcelRequire("aRT0u");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $fZneA = parcelRequire("fZneA");

var $iKwST = parcelRequire("iKwST");

var $5ZJgM = parcelRequire("5ZJgM");

var $9SPvU = parcelRequire("9SPvU");

var $kwgZt = parcelRequire("kwgZt");

var $cmzJ2 = parcelRequire("cmzJ2");

var $kklBj = parcelRequire("kklBj");

var $66CIA = parcelRequire("66CIA");

var $77N15 = parcelRequire("77N15");

var $hb557 = parcelRequire("hb557");

var $5RxQU = parcelRequire("5RxQU");

var $7Y8xQ = parcelRequire("7Y8xQ");

var $ltvET = parcelRequire("ltvET");
const $fccc347b1e897d64$export$da956fe610b96f73 = ()=>{
    const [moreInformationModal, setMoreInformationModal] = (0, $5uXOq.useState)(false);
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $aRT0u.useFireCrossFlowAnalyticsEvents)();
    const [, { setRecommendationDismissal: setRecommendationDismissal }] = (0, $cmzJ2.useProjectMenuRecommendations)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const accountId = (0, $90yGq.useAccountId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const crossFlow = (0, $Q9DHJ.useCrossFlow)();
    const environment = (0, $2tT7R.useEnvironment)();
    const jpdCloudCCPProductID = (0, $hb557.getProductTypeCcpReferenceIdMapForEnv)(environment).PRODUCT_DISCOVERY;
    const jpdRecommendationContent = (0, $5uXOq.useMemo)(()=>{
        return (0, $6s1PB.expValEquals)('grw-1467_jpd_content_change_in_project_menu', 'cohort', 'variation') ? {
            projectTitle: (0, $5RxQU.default).projectTitleProductRoadmap,
            projectDescription: (0, $5RxQU.default).projectDescriptionProductRoadmap,
            projectKey: (0, $hb557.JPD_ROADMAP_KEY),
            projectAvatar: (0, $77N15.default)
        } : {
            projectTitle: (0, $5RxQU.default).projectTitle,
            projectDescription: (0, $5RxQU.default).projectDescription,
            projectKey: (0, $hb557.JPD_KEY),
            projectAvatar: (0, $ltvET.default)
        };
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (crossFlow.isEnabled) fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'projectsMenu'
        }, {
            recommendedProductIds: [
                jpdCloudCCPProductID
            ],
            source: 'projectsMenuSection'
        }, {
            navigationVersion: 'v3',
            jpdContentChangeInProjectsMenuCohort: (0, $6s1PB.expVal)('grw-1467_jpd_content_change_in_project_menu', 'cohort', 'not-enrolled')
        });
        else (0, $jcw0u.default)({
            error: new Error(crossFlow.reason),
            meta: {
                id: crossFlow.reason,
                packageName: 'jiraAtlassianNavigationRecommendations'
            }
        });
    }, [
        createAnalyticsEvent,
        crossFlow,
        fireViewedUIEvent,
        jpdCloudCCPProductID
    ]);
    const openCrossFlow = (0, $5uXOq.useCallback)(async (templateId)=>{
        const extensions = (0, $3gy1Y.createProvisioningPageExtensions)({
            actions: {
                primary: {
                    behaviour: (0, $3gy1Y.Behaviours).LAND,
                    prompt: (0, $3gy1Y.Prompts).NEXT,
                    options: {
                        targetTab: (0, $3gy1Y.TargetTabs).SAME,
                        urlParams: {
                            templateId: templateId
                        }
                    }
                }
            }
        });
        if (crossFlow.isEnabled) crossFlow.apiV1.open({
            journey: (0, $Q9DHJ.Journeys).GET_STARTED,
            targetProduct: (0, $bBrJC.Targets).JIRA_PRODUCT_DISCOVERY,
            sourceComponent: 'projectsMenu',
            sourceContext: 'tryThisRecommendation',
            extensions: extensions,
            v1: true
        });
    }, [
        crossFlow
    ]);
    const onRecommendationClicked = (0, $5uXOq.useCallback)(()=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'tryThisRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v3'
        });
        openCrossFlow(jpdRecommendationContent.projectKey);
    }, [
        fireInteractedUIEvent,
        jpdCloudCCPProductID,
        jpdRecommendationContent.projectKey,
        openCrossFlow
    ]);
    const onLearnMoreClicked = (0, $5uXOq.useCallback)(()=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'learnMore'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v3'
        });
        setMoreInformationModal(true);
    }, [
        fireInteractedUIEvent,
        jpdCloudCCPProductID
    ]);
    const onLearnMoreClosed = (0, $5uXOq.useCallback)(()=>{
        setMoreInformationModal(false);
    }, []);
    const onDismissClicked = (0, $5uXOq.useCallback)(()=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'dismissRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        }, {
            navigationVersion: 'v3'
        });
        setRecommendationDismissal();
        if (accountId) (0, $89SaW.setUserProperties)(accountId, (0, $hb557.JPD_RECOMMENDATION_DISMISS_USER_PROPERTY), 'true').catch((error)=>(0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'dismissJpdRecommendation',
                    packageName: 'jiraAtlassianNavigationRecommendations',
                    teamName: 'navigation'
                }
            }));
    }, [
        accountId,
        fireInteractedUIEvent,
        jpdCloudCCPProductID,
        setRecommendationDismissal
    ]);
    const onClickPrivacyPolicy = (0, $5uXOq.useCallback)(()=>{
        const clickedLinkBaseEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $8zOmE.fireUIAnalytics)(clickedLinkBaseEvent, 'adControlsPrivacyPolicy');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKwST.RecommendationContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ZJgM.RecommendationHeader), {
        title: formatMessage((0, $5RxQU.default).recommendedText),
        onDismissClicked: onDismissClicked,
        onLearnMoreClicked: onLearnMoreClicked
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9SPvU.RecommendationMenuItem), {
        title: formatMessage(jpdRecommendationContent.projectTitle),
        description: formatMessage(jpdRecommendationContent.projectDescription),
        onClick: onRecommendationClicked,
        lozenge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
            appearance: "new",
            isBold: false
        }, formatMessage((0, $5RxQU.default).lozengeText)),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(jpdRecommendationContent.projectAvatar, null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kwgZt.RecommendationModal), {
        isOpen: moreInformationModal,
        onClose: onLearnMoreClosed,
        title: formatMessage((0, $5RxQU.default).reasonsModalTitle),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $5RxQU.default).reasonsModalExplanation, {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
                    as: "strong"
                }, chunks)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $5RxQU.default).reasonsModalBulletOneSpork)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $5RxQU.default).reasonsModalBulletTwo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
            appearance: "link",
            spacing: "none",
            href: (0, $hb557.DATA_PRIVACY_LINK),
            target: "_blank",
            onClick: onClickPrivacyPolicy
        }, formatMessage((0, $5RxQU.default).privacyPolicy))),
        primaryCta: formatMessage((0, $5RxQU.default).reasonsModalButtonOk)
    }));
};
const $fccc347b1e897d64$var$checkEligibility = async (recommendationContext, analyticsEvent)=>{
    const { areProductSuggestionsEnabled: areProductSuggestionsEnabled, licensedProducts: licensedProducts, canCreateProject: canCreateProject, accountId: accountId, cloudId: cloudId, environment: environment } = recommendationContext;
    if ((0, $4R6GH.fg)('grw-1467_jpd_reco_eligibility_override_gate')) return {
        isEligible: true,
        reason: 'Eligibility override gate is enabled'
    };
    if (!areProductSuggestionsEnabled) return {
        isEligible: false,
        reason: 'Product suggestions are disabled'
    };
    if ((0, $7Y8xQ.hasJpdLicense)(licensedProducts)) return {
        isEligible: false,
        reason: 'Instance has JPD license'
    };
    if (!canCreateProject) return {
        isEligible: false,
        reason: 'User cannot create projects'
    };
    const [dismissed, appRecommendations] = await Promise.all([
        (0, $89SaW.getUserProperty)(accountId, (0, $hb557.JPD_RECOMMENDATION_DISMISS_USER_PROPERTY)).catch((error)=>{
            // If not found, then the user hasn't dismissed the ad.
            // 404 - user property not found,
            if (error.statusCode === 404) return false;
            const expectedErrors = [
                429,
                // rate limit exceeded
                401,
                // unauthorised
                403,
                // forbidden
                null,
                // client error
                undefined // client error
            ];
            // 50x - network errors
            // We shouldn't see the recommendation
            if (expectedErrors.includes(error.statusCode) || error.statusCode >= 500 || (0, $fZneA.isClientFetchError)(error)) return true;
            throw Error(`${error.statusCode}, JPD recommendation dismissal failed. ${error.name}: ${error.message}`, error);
        }),
        (0, $66CIA.fetchAppRecommendations)(cloudId, environment, analyticsEvent)
    ]);
    if (dismissed) return {
        isEligible: false,
        reason: 'JPD recommendation dismissed'
    };
    if (!appRecommendations?.some((recommendation)=>recommendation?.entityId === (0, $hb557.JPD_ENTITY_ID))) return {
        isEligible: false,
        reason: 'JPD was not in the recommend apps'
    };
    return {
        isEligible: true,
        reason: 'Pass all checks'
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fccc347b1e897d64$export$2e2bcd8739ae039 = {
    key: (0, $hb557.JPD_RECOMMENDATION_KEY),
    shouldRender: async (recommendationContext, analyticsEvent)=>{
        (0, $kklBj.projectsMenuDropdownLoadJpdRecommendation).start();
        const { isEligible: isEligible, reason: reason } = await $fccc347b1e897d64$var$checkEligibility(recommendationContext, analyticsEvent);
        if ((0, $4R6GH.fg)('pm_jpd_reco_operational_event_activated')) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.loadJpdRecommendation succeeded', {
            reason: reason,
            isEligible: isEligible
        });
        (0, $kklBj.projectsMenuDropdownLoadJpdRecommendation).success();
        return isEligible;
    },
    onLoadError: (error)=>{
        (0, $kklBj.projectsMenuDropdownLoadJpdRecommendation).failure();
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'loadJpdRecommendation',
                packageName: 'jiraAtlassianNavigationRecommendations',
                teamName: 'navigation'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    },
    Component: $fccc347b1e897d64$export$da956fe610b96f73
};

});
parcelRegister("iKwST", function(module, exports) {

$parcel$export(module.exports, "RecommendationContainer", () => $3f1017feb0eddea7$export$97f31f44c68c1d5);

var $5uXOq = parcelRequire("5uXOq");

var $70rf1 = parcelRequire("70rf1");

var $iXVV6 = parcelRequire("iXVV6");
const $3f1017feb0eddea7$export$97f31f44c68c1d5 = ({ children: children, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        hasSeparator: true
    }, children));

});

parcelRegister("5ZJgM", function(module, exports) {

$parcel$export(module.exports, "RecommendationHeader", () => $04eaa3b92b265d65$export$3beeaceb068c75b1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $bWfiu = parcelRequire("bWfiu");

var $elaEw = parcelRequire("elaEw");

var $7H980 = parcelRequire("7H980");
var $aOrxC = parcelRequire("aOrxC");
var $70rf1 = parcelRequire("70rf1");

var $2Eqc8 = parcelRequire("2Eqc8");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $jgJNO = parcelRequire("jgJNO");

var $9xvcL = parcelRequire("9xvcL");
const $04eaa3b92b265d65$export$3beeaceb068c75b1 = ({ title: title, onDismissClicked: onDismissClicked, onLearnMoreClicked: onLearnMoreClicked })=>{
    const [isActionsMenuOpen, setIsActionsMenuOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        xcss: $04eaa3b92b265d65$var$HeadingItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        xcss: $04eaa3b92b265d65$var$TitleItemStyles
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isActionsMenuOpen,
        placement: "bottom-start",
        messageId: "atlassian-navigation-recommendations.common.ui.recommendation-section.recommendation-header.popup",
        messageType: "transactional",
        onClose: ()=>setIsActionsMenuOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), {
                onClick: (e)=>e.stopPropagation()
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
                onClick: onDismissClicked
            }, formatMessage((0, $9xvcL.default).dismissButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
                onClick: onLearnMoreClicked
            }, formatMessage((0, $9xvcL.default).learnMoreButtonText)))),
        shouldUseCaptureOnOutsideClick: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04eaa3b92b265d65$var$MeatballMenuTrigger, {
                ...triggerProps,
                appearance: "subtle",
                onClick: ()=>setIsActionsMenuOpen(()=>!isActionsMenuOpen),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($elaEw))), {
                    LEGACY_size: "medium",
                    spacing: "spacious",
                    label: (0, $4R6GH.fg)('blu-6205_misc_nav3_a11y_fixes') ? formatMessage((0, $9xvcL.default).moreButtonLabel, {
                        title: title
                    }) : 'more'
                })
            }),
        shouldRenderToParent: (0, $4R6GH.fg)('blu-6205_misc_nav3_a11y_fixes')
    }));
};
const $04eaa3b92b265d65$var$HeadingItemStyles = (0, $2s57o.xcss)({
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    marginTop: 'space.050'
});
const $04eaa3b92b265d65$var$TitleItemStyles = (0, $2s57o.xcss)({
    color: 'color.text.accent.gray'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04eaa3b92b265d65$var$MeatballMenuTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $cNW3X.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbzwfg _4t3izwfg _1di6fg4m",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9xvcL", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa08673ea438366b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $aa08673ea438366b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    learnMoreButtonText: {
        "id": "atlassian-navigation-recommendations.common.recommendation-section.recommendation-header.learn-more-button-text",
        "defaultMessage": "Why am I seeing this?"
    },
    dismissButtonText: {
        "id": "atlassian-navigation-recommendations.common.recommendation-section.recommendation-header.dismiss-button-text",
        "defaultMessage": "Not interested"
    },
    dismissConfirmationText: {
        "id": "atlassian-navigation-recommendations.common.recommendation-section.recommendation-header.dismiss-confirmation-text",
        "defaultMessage": "You won't be seeing this here anymore"
    },
    moreButtonLabel: {
        "id": "atlassian-navigation-recommendations.common.recommendation-section.recommendation-header.more-button-label",
        "defaultMessage": "More options for {title} section"
    }
});

});


parcelRegister("9SPvU", function(module, exports) {

$parcel$export(module.exports, "RecommendationMenuItem", () => $56fe10413c20ceb0$export$aab9ce3de285230c);

var $5uXOq = parcelRequire("5uXOq");

var $44qT7 = parcelRequire("44qT7");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
const $56fe10413c20ceb0$export$aab9ce3de285230c = ({ iconBefore: iconBefore, onClick: onClick, title: title, lozenge: lozenge = null, description: description })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44qT7.default), {
        iconBefore: iconBefore,
        onClick: onClick,
        description: description,
        href: "#"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        space: "space.100"
    }, title, lozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, lozenge)));

});

parcelRegister("kwgZt", function(module, exports) {

$parcel$export(module.exports, "RecommendationModal", () => $6e7f095537455847$export$d5c06ba24e862b67);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");
var $kW74I = parcelRequire("kW74I");

var $6eFvr = parcelRequire("6eFvr");

var $7NYq5 = parcelRequire("7NYq5");
const $6e7f095537455847$export$d5c06ba24e862b67 = ({ isOpen: isOpen, onClose: onClose, title: title, body: body, primaryCta: primaryCta })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kW74I.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "atlassian-navigation-recommendations.common.ui.recommendation-section.recommendation-modal.modal",
        messageType: "transactional",
        shouldCloseOnEscapePress: true,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUaFh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Sb4G.default), null, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1QfP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        as: "p"
    }, body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CjwE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "primary",
        onClick: onClose
    }, primaryCta))));

});

parcelRegister("cmzJ2", function(module, exports) {

$parcel$export(module.exports, "useProjectMenuRecommendations", () => $5442a73b6e3e578d$export$d4048a5b8ab1acff);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5hXPP = parcelRequire("5hXPP");
const $5442a73b6e3e578d$var$initialState = {
    status: 'idle'
};
const $5442a73b6e3e578d$var$store = (0, $iXqE5.createStore)({
    actions: $5hXPP.actions,
    initialState: $5442a73b6e3e578d$var$initialState,
    name: 'atlassian-navigation-recommendation'
});
const $5442a73b6e3e578d$export$d4048a5b8ab1acff = (0, $3sQ5x.createHook)($5442a73b6e3e578d$var$store);

});
parcelRegister("5hXPP", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5033aa90e3adb7fd$export$e324594224ef24da);

var $s7Ri8 = parcelRequire("s7Ri8");
const $5033aa90e3adb7fd$export$e95368803793838f = (recommendations, recommendationContext, analyticsEvent)=>async ({ getState: getState, setState: setState })=>{
        const { status: status } = getState();
        if (status !== 'idle') return;
        setState({
            status: 'loading'
        });
        const shuffledRecommendations = (0, (/*@__PURE__*/$parcel$interopDefault($s7Ri8)))(recommendations);
        try {
            const recommendationStatus = await Promise.all(shuffledRecommendations.map(async (recommendation)=>{
                let isEnabled = false;
                try {
                    isEnabled = await recommendation.shouldRender(recommendationContext, analyticsEvent);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    recommendation.onLoadError(error);
                }
                return {
                    key: recommendation.key,
                    isEnabled: isEnabled
                };
            }));
            const selectedRecommendation = recommendationStatus.find((result)=>result.isEnabled);
            setState({
                status: 'success',
                recommendationKey: selectedRecommendation?.key || null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                status: 'error',
                error: error
            });
        }
    };
const $5033aa90e3adb7fd$var$setRecommendationDismissal = ()=>({ setState: setState })=>{
        setState({
            recommendationKey: null
        });
    };
const $5033aa90e3adb7fd$export$e324594224ef24da = {
    loadRecommendations: $5033aa90e3adb7fd$export$e95368803793838f,
    setRecommendationDismissal: $5033aa90e3adb7fd$var$setRecommendationDismissal
};

});


parcelRegister("kklBj", function(module, exports) {

$parcel$export(module.exports, "projectsMenuDropdownRecommendationSelector", () => $4c06b486be8bb39b$export$2b83859c1548ffb5);
$parcel$export(module.exports, "projectsMenuDropdownLoadJpdRecommendation", () => $4c06b486be8bb39b$export$a784c5bbb21ea554);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");
const $4c06b486be8bb39b$export$2b83859c1548ffb5 = new (0, $kkzI0.UFOExperience)('projects-menu-dropdown.recommendation-selector', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
});
const $4c06b486be8bb39b$export$a784c5bbb21ea554 = new (0, $kkzI0.UFOExperience)('projects-menu-dropdown.load-jpd-recommendation', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("66CIA", function(module, exports) {

$parcel$export(module.exports, "fetchAppRecommendations", () => $78725ead7cfc4b7c$export$8665956217263d00);

var $5rZL1 = parcelRequire("5rZL1");

var $8Uumt = parcelRequire("8Uumt");

var $8zOmE = parcelRequire("8zOmE");

var $fZneA = parcelRequire("fZneA");


var $6FSDe = parcelRequire("6FSDe");
const $78725ead7cfc4b7c$export$f2d50cdc12f57d0b = (0, $5rZL1.default);
const $78725ead7cfc4b7c$export$8665956217263d00 = async (cloudId, environment, analyticsEvent)=>{
    const appRecommendationState = (0, $6FSDe.getCachedAppRecommendationState)();
    if (appRecommendationState !== null && Date.now() - appRecommendationState.fetchRecommendationTimeStamp < (0, $3202ab0bf207425f$export$424ba99fce04562)) return appRecommendationState.appRecommendations ?? [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const data = await (0, $8Uumt.fetchQuery)(environment, $78725ead7cfc4b7c$export$f2d50cdc12f57d0b, {
        cloudId: cloudId
    }).toPromise().catch((err)=>{
        const expectedErrors = [
            401,
            // Unauthorised
            403,
            // Forbidden
            null,
            // Client error
            undefined // Client error
        ];
        if (expectedErrors.includes(err.statusCode) || (0, $fZneA.isClientFetchError)(err)) return {};
        throw Error(`App recommendation ${err.name} error: ${err.message}`, {
            cause: err
        });
    });
    const appRecommendations = data?.growthRecommendations?.recommendations?.data;
    if (!appRecommendations) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.fetchAppRecommendations empty', {
        response: `${JSON.stringify(data)}`
    });
    (0, $6FSDe.setCachedAppRecommendationState)({
        appRecommendations: appRecommendations,
        fetchRecommendationTimeStamp: Date.now()
    });
    return appRecommendations ?? [];
};

});
parcelRegister("5rZL1", function(module, exports) {

$parcel$export(module.exports, "default", () => $739e1bf50f170603$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63d29fc2e4b7b13b5431ad6d77aafb97>>
 * @relayHash e631e61cba47acbda6811ed1a287d9f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 620b7134d06fa893e7db6526963c4d8afbe3dc9c5b0428d93f35a2c73fa2ea86
const $739e1bf50f170603$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Literal",
                    "name": "product",
                    "value": "jira"
                },
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Literal",
                    "name": "useCase",
                    "value": "jiraProjectMenuRecommendations"
                }
            ],
            "kind": "ObjectValue",
            "name": "context"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 2
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "entityId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchAppRecommendationsV2Query",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v2 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "growthRecommendations.recommendations.data.entityId"
                                                        }
                                                    ],
                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchAppRecommendationsV2Query",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ],
                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "620b7134d06fa893e7db6526963c4d8afbe3dc9c5b0428d93f35a2c73fa2ea86",
            "metadata": {},
            "name": "fetchAppRecommendationsV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$739e1bf50f170603$var$node.hash = "eaaab66d3f41b01ce8e8a969a422ff60";
var $739e1bf50f170603$export$2e2bcd8739ae039 = $739e1bf50f170603$var$node;

});

const $3202ab0bf207425f$export$424ba99fce04562 = 600000;

parcelRegister("6FSDe", function(module, exports) {

$parcel$export(module.exports, "setCachedAppRecommendationState", () => $69d5e6aa5b3a01d0$export$4bb2da71ae03947f);
$parcel$export(module.exports, "getCachedAppRecommendationState", () => $69d5e6aa5b3a01d0$export$951c5f8396f4dcb);

var $bSSG7 = parcelRequire("bSSG7");
const $69d5e6aa5b3a01d0$var$store = (0, $bSSG7.createLocalStorageProvider)('projects-menu-jpd-recommendation');
const $69d5e6aa5b3a01d0$var$APP_RECOMMENDATION_STATE = 'app-recommendation-state';
function $69d5e6aa5b3a01d0$export$4bb2da71ae03947f(appRecommendationState) {
    $69d5e6aa5b3a01d0$var$store.set($69d5e6aa5b3a01d0$var$APP_RECOMMENDATION_STATE, JSON.stringify(appRecommendationState));
}
function $69d5e6aa5b3a01d0$export$951c5f8396f4dcb() {
    const state = $69d5e6aa5b3a01d0$var$store.get($69d5e6aa5b3a01d0$var$APP_RECOMMENDATION_STATE);
    return state ? JSON.parse(state) : null;
}
function $69d5e6aa5b3a01d0$export$a73955031198b1b8() {
    $69d5e6aa5b3a01d0$var$store.remove($69d5e6aa5b3a01d0$var$APP_RECOMMENDATION_STATE);
}

});


parcelRegister("77N15", function(module, exports) {

$parcel$export(module.exports, "default", () => $29218c4ee11cd071$export$2e2bcd8739ae039);
/* product-roadmap-project-avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $ew55A = parcelRequire("ew55A");

var $eLDVj = parcelRequire("eLDVj");
const $29218c4ee11cd071$var$ProductRoadmapProjectAvatar = ()=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $ew55A.default), {
        appearance: "square",
        borderColor: "transparent",
        size: "small",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eLDVj))),
        name: "Jira Product Discovery Roadmap Template"
    });
};
var $29218c4ee11cd071$export$2e2bcd8739ae039 = $29218c4ee11cd071$var$ProductRoadmapProjectAvatar;

});
parcelRegister("eLDVj", function(module, exports) {
module.exports = new URL("product-roadmap-project-icon.7eb40fb0.svg", import.meta.url).toString();

});


parcelRegister("hb557", function(module, exports) {

$parcel$export(module.exports, "JPD_RECOMMENDATION_KEY", () => $aa2162acaf3862c0$export$3e6ff24c4f517c4f);
$parcel$export(module.exports, "JPD_KEY", () => $aa2162acaf3862c0$export$a9c4e38d8a74acd2);
$parcel$export(module.exports, "JPD_ROADMAP_KEY", () => $aa2162acaf3862c0$export$c11145b8eb60b18b);
$parcel$export(module.exports, "JPD_RECOMMENDATION_DISMISS_USER_PROPERTY", () => $aa2162acaf3862c0$export$52b9dedc0088f8);
$parcel$export(module.exports, "DATA_PRIVACY_LINK", () => $aa2162acaf3862c0$export$aefe1c8741b24a28);
$parcel$export(module.exports, "JPD_ENTITY_ID", () => $aa2162acaf3862c0$export$909712ccf16883d);
$parcel$export(module.exports, "getProductTypeCcpReferenceIdMapForEnv", () => $aa2162acaf3862c0$export$29629758934356a6);

var $7HXPn = parcelRequire("7HXPn");
const $aa2162acaf3862c0$export$3e6ff24c4f517c4f = 'jpd-recommendation';
const $aa2162acaf3862c0$export$a9c4e38d8a74acd2 = 'jpd.product-discovery';
const $aa2162acaf3862c0$export$c11145b8eb60b18b = 'jpd.product-roadmap';
const $aa2162acaf3862c0$export$52b9dedc0088f8 = 'JpdRecommendationDismissed';
const $aa2162acaf3862c0$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';
const $aa2162acaf3862c0$export$909712ccf16883d = 'jira.polaris:discovery';
const $aa2162acaf3862c0$export$29629758934356a6 = (environment)=>{
    const env = environment === 'prod' ? 'prod' : 'staging';
    return {
        BUSINESS: (0, $7HXPn.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_work_management_cloud,
        SOFTWARE: (0, $7HXPn.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_software_cloud,
        SERVICE_DESK: (0, $7HXPn.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_service_management_cloud,
        PRODUCT_DISCOVERY: (0, $7HXPn.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_product_discovery
    };
};

});

parcelRegister("5RxQU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f55eacc0b9ee9dc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3f55eacc0b9ee9dc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    learnMoreButtonText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.learn-more-button-text",
        "defaultMessage": "Why am I seeing this?"
    },
    projectDescription: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-description",
        "defaultMessage": "Capture ideas with Jira Product Discovery"
    },
    projectDescriptionProductRoadmap: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-description-roadmap",
        "defaultMessage": "Jira Product Discovery project"
    },
    lozengeText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.lozenge-text",
        "defaultMessage": "try"
    },
    dismissButtonText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.dismiss-button-text",
        "defaultMessage": "Not interested"
    },
    recommendedText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.recommended-text",
        "defaultMessage": "Recommended"
    },
    dismissConfirmationTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.dismiss-confirmation-title",
        "defaultMessage": "Got it, thanks for letting us know"
    },
    dismissConfirmationText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.dismiss-confirmation-text",
        "defaultMessage": "You won't be seeing this here anymore"
    },
    projectTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-title",
        "defaultMessage": "New discovery project"
    },
    projectTitleProductRoadmap: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-title-product-roadmap",
        "defaultMessage": "Create a roadmap"
    },
    reasonsModalTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-title",
        "defaultMessage": "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-explanation",
        "defaultMessage": "We think <strong>Jira Product Discovery</strong> will improve your team's productivity. The recommendation is based on:"
    },
    reasonsModalBulletOneSpork: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-one-spork",
        "defaultMessage": "the tools you use (Jira)"
    },
    reasonsModalBulletTwo: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two",
        "defaultMessage": "the way you use your existing tools and products"
    },
    privacyPolicy: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.privacy-policy",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    reasonsModalButtonOk: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok",
        "defaultMessage": "Ok"
    },
    reasonsModalButtonOkCapitalised: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok-capitalised",
        "defaultMessage": "OK"
    }
});

});

parcelRegister("7Y8xQ", function(module, exports) {

$parcel$export(module.exports, "hasJpdLicense", () => $b21ff31ac89e5c24$export$2ea69a0925803655);
const $b21ff31ac89e5c24$export$2ea69a0925803655 = (licensedProducts)=>licensedProducts['jira-product-discovery'] === true;

});

parcelRegister("ltvET", function(module, exports) {

$parcel$export(module.exports, "default", () => $01d9ea02d6eb7527$export$2e2bcd8739ae039);
/* jira-product-discovery-icon-enhanced.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $j7leM = parcelRequire("j7leM");

var $eWkgo = parcelRequire("eWkgo");
const $01d9ea02d6eb7527$var$styles = {
    JiraProductDiscoveryIconEnhancedStyle: "_2rkoiti9 _1bsb1f4h _4t3i1f4h _bfhkm7j4"
};
const $01d9ea02d6eb7527$var$JiraProductDiscoveryIconEnhanced = ()=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $eWkgo.default), {
        xcss: (0, $DEWI6.cx)($01d9ea02d6eb7527$var$styles.JiraProductDiscoveryIconEnhancedStyle),
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $j7leM.JiraProductDiscoveryIcon), {
        appearance: "brand",
        size: "small"
    }));
};
var $01d9ea02d6eb7527$export$2e2bcd8739ae039 = $01d9ea02d6eb7527$var$JiraProductDiscoveryIconEnhanced;

});



parcelRegister("4keKa", function(module, exports) {

$parcel$export(module.exports, "RecommendationLoader", () => $f62159ce20629294$export$f17bc1d33db805f2);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $bngFq = parcelRequire("bngFq");

var $d40Fj = parcelRequire("d40Fj");

var $90yGq = parcelRequire("90yGq");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");

var $dkqym = parcelRequire("dkqym");

var $hqBSi = parcelRequire("hqBSi");

var $DVljb = parcelRequire("DVljb");

var $9OXo1 = parcelRequire("9OXo1");

var $cmzJ2 = parcelRequire("cmzJ2");
const $f62159ce20629294$export$f17bc1d33db805f2 = ({ recommendations: recommendations })=>{
    const [, { loadRecommendations: loadRecommendations }] = (0, $cmzJ2.useProjectMenuRecommendations)();
    const accountId = (0, $90yGq.useAccountId)();
    const locale = (0, $DVljb.useLocale)();
    const cloudId = (0, $koeKL.useCloudId)();
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const firstActivationDateMs = (0, $dkqym.useFirstActivationDateMs)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const { software: edition } = (0, $k9JTq.useAppEditions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [{ hasSuccessOnce: hasSuccessOnce, canCreateProject: canCreateProject }] = (0, $d40Fj.useCreateProjectPermission)();
    const { areProductSuggestionsEnabled: areProductSuggestionsEnabled } = (0, $9OXo1.useTenantContext)();
    (0, $5uXOq.useEffect)(()=>{
        if (hasSuccessOnce && accountId) loadRecommendations(recommendations, {
            locale: locale,
            accountId: accountId,
            cloudId: cloudId,
            licensedProducts: licensedProducts,
            firstActivationDateMs: firstActivationDateMs,
            areProductSuggestionsEnabled: areProductSuggestionsEnabled,
            edition: edition,
            environment: environment,
            canCreateProject: canCreateProject
        }, createAnalyticsEvent({}));
    }, [
        hasSuccessOnce,
        canCreateProject,
        accountId,
        loadRecommendations,
        createAnalyticsEvent,
        locale,
        cloudId,
        licensedProducts,
        firstActivationDateMs,
        areProductSuggestionsEnabled,
        edition,
        environment,
        recommendations
    ]);
    return null;
};

});

parcelRegister("9WcgH", function(module, exports) {

$parcel$export(module.exports, "default", () => $430f11f9411f5e73$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $430f11f9411f5e73$var$LazyCustomThemeAdminFlag = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("dj7lc")), {
    ssr: false,
    moduleId: "./src/packages/theme/custom-theme-admin-flag/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$430f11f9411f5e73$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async.jira.custom-theme-admin-flag",
        packageName: "customThemeAdminFlag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "custom-theme-admin-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($430f11f9411f5e73$var$LazyCustomThemeAdminFlag, null)));

});
parcelRegister("dj7lc", function(module, exports) {

let $9b02be733a7a8823$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9b02be733a7a8823$var$load("hmVFt").then(()=>parcelRequire('jWgLY'));

});


parcelRegister("bcn6L", function(module, exports) {

$parcel$export(module.exports, "useFavoriteActions", () => $23bcf74af5f22e12$export$e17993c41bc4dc38);
$parcel$export(module.exports, "useFavoriteBoards", () => $23bcf74af5f22e12$export$896ce0ae2b68d03a);
$parcel$export(module.exports, "useFavoriteDashboards", () => $23bcf74af5f22e12$export$7f929adce53e9217);
$parcel$export(module.exports, "useFavoriteProjects", () => $23bcf74af5f22e12$export$e92f6fc9e0c6d135);
$parcel$export(module.exports, "useFavoriteFilters", () => $23bcf74af5f22e12$export$49e6afd92506d2b4);
$parcel$export(module.exports, "useFavoriteQueues", () => $23bcf74af5f22e12$export$b09f7ee747d8bc9);
$parcel$export(module.exports, "useFavoritePlans", () => $23bcf74af5f22e12$export$56f40dc3d5e1af94);
$parcel$export(module.exports, "FavoritesContainer", () => $23bcf74af5f22e12$export$878515009e0790e0);


var $20jWj = parcelRequire("20jWj");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

const $23bcf74af5f22e12$var$emptyItemState = {
    items: null,
    isFetching: false,
    fetchError: null,
    promise: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false
};
const $23bcf74af5f22e12$export$d4c72bab9d6cc13a = {
    [(0, $49a076eb01652100$export$f95f1a684a17f189)]: {
        ...$23bcf74af5f22e12$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$6e58b6b0aa48a271)]: {
        ...$23bcf74af5f22e12$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$6737b9227f60f39d)]: {
        ...$23bcf74af5f22e12$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$91a9dba2d38d9a6f)]: {
        ...$23bcf74af5f22e12$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$20f1031cc9fdf29e)]: {
        ...$23bcf74af5f22e12$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$eebccb886b064713)]: {
        ...$23bcf74af5f22e12$var$emptyItemState
    }
};
const $23bcf74af5f22e12$var$transformItems = (items)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    items.reduce((acc, itemResponse)=>{
        if (itemResponse.id === 'favourite-boards') acc[0, $49a076eb01652100$export$f95f1a684a17f189] = itemResponse.items;
        if (itemResponse.id === 'favourite-filters') acc[0, $49a076eb01652100$export$6737b9227f60f39d] = itemResponse.items;
        if (itemResponse.id === 'favourite-dashboards') acc[0, $49a076eb01652100$export$6e58b6b0aa48a271] = itemResponse.items;
        if (itemResponse.id === 'favourite-projects') acc[0, $49a076eb01652100$export$91a9dba2d38d9a6f] = itemResponse.items;
        if (itemResponse.id === 'favourite-queues') acc[0, $49a076eb01652100$export$20f1031cc9fdf29e] = itemResponse.items;
        if (itemResponse.id === 'favourite-plans') acc[0, $49a076eb01652100$export$eebccb886b064713] = itemResponse.items;
        return acc;
    }, {});
const $23bcf74af5f22e12$var$loadFavoriteItems = (amount = (0, $7a1562bd0ca086b0$export$ea341e6cc435ed40), types)=>async ({ setState: setState, getState: getState })=>{
        const typesToFetch = types.filter((type)=>!getState()[type].isFetching);
        if (typesToFetch.length) try {
            const promise = (0, $20jWj.fetchFavoriteItems)({
                count: amount,
                types: typesToFetch
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const loadingState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                };
                return acc;
            }, {});
            setState(loadingState);
            const itemResponse = await promise;
            const transformed = $23bcf74af5f22e12$var$transformItems(itemResponse);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const responseState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    items: transformed[type],
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                };
                return acc;
            }, {});
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                };
                return acc;
            }, {});
            setState(errorState);
        }
    };
const $23bcf74af5f22e12$export$e324594224ef24da = {
    loadFavoriteAll: (amount)=>async (actions2, props)=>{
            $23bcf74af5f22e12$var$loadFavoriteItems(amount, [
                props.applicationPermissions.hasSoftwareAccess ? (0, $49a076eb01652100$export$f95f1a684a17f189) : undefined,
                (0, $49a076eb01652100$export$6e58b6b0aa48a271),
                (0, $49a076eb01652100$export$91a9dba2d38d9a6f),
                (0, $49a076eb01652100$export$6737b9227f60f39d),
                props.applicationPermissions.hasServiceDeskAccess ? (0, $49a076eb01652100$export$20f1031cc9fdf29e) : undefined,
                props.applicationPermissions.hasSoftwareAccess ? (0, $49a076eb01652100$export$eebccb886b064713) : undefined
            ].filter(Boolean))(actions2);
        },
    loadFavouriteBoards: (amount)=>$23bcf74af5f22e12$var$loadFavoriteItems(amount, [
            (0, $49a076eb01652100$export$f95f1a684a17f189)
        ]),
    loadFavoriteProjects: (amount)=>$23bcf74af5f22e12$var$loadFavoriteItems(amount, [
            (0, $49a076eb01652100$export$91a9dba2d38d9a6f)
        ]),
    loadFavoriteDashboards: (amount)=>$23bcf74af5f22e12$var$loadFavoriteItems(amount, [
            (0, $49a076eb01652100$export$6e58b6b0aa48a271)
        ]),
    loadFavoriteFilters: (amount)=>$23bcf74af5f22e12$var$loadFavoriteItems(amount, [
            (0, $49a076eb01652100$export$6737b9227f60f39d)
        ]),
    loadFavouriteQueues: (amount)=>$23bcf74af5f22e12$var$loadFavoriteItems(amount, [
            (0, $49a076eb01652100$export$20f1031cc9fdf29e)
        ]),
    loadFavoritePlans: (amount)=>$23bcf74af5f22e12$var$loadFavoriteItems(amount, [
            (0, $49a076eb01652100$export$eebccb886b064713)
        ])
};
const $23bcf74af5f22e12$var$store = (0, $iXqE5.createStore)({
    name: (0, $7a1562bd0ca086b0$export$7a3d0824e907e616),
    actions: $23bcf74af5f22e12$export$e324594224ef24da,
    initialState: $23bcf74af5f22e12$export$d4c72bab9d6cc13a
});
const $23bcf74af5f22e12$export$e17993c41bc4dc38 = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: null
});
const $23bcf74af5f22e12$export$896ce0ae2b68d03a = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$f95f1a684a17f189]
});
const $23bcf74af5f22e12$export$7f929adce53e9217 = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$6e58b6b0aa48a271]
});
const $23bcf74af5f22e12$export$e92f6fc9e0c6d135 = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$91a9dba2d38d9a6f]
});
const $23bcf74af5f22e12$export$49e6afd92506d2b4 = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$6737b9227f60f39d]
});
const $23bcf74af5f22e12$export$b09f7ee747d8bc9 = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$20f1031cc9fdf29e]
});
const $23bcf74af5f22e12$export$56f40dc3d5e1af94 = (0, $3sQ5x.createHook)($23bcf74af5f22e12$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$eebccb886b064713]
});
const $23bcf74af5f22e12$export$878515009e0790e0 = (0, $gg7kZ.createContainer)($23bcf74af5f22e12$var$store);

});
const $49a076eb01652100$export$91a9dba2d38d9a6f = 'projects';
const $49a076eb01652100$export$ebb48b08205007c5 = 'issues';
const $49a076eb01652100$export$6737b9227f60f39d = 'filters';
const $49a076eb01652100$export$6e58b6b0aa48a271 = 'dashboards';
const $49a076eb01652100$export$20f1031cc9fdf29e = 'queues';
const $49a076eb01652100$export$f95f1a684a17f189 = 'boards';
const $49a076eb01652100$export$3c11110d46d67e8c = 'jwmBoards';
const $49a076eb01652100$export$5e2cc09b58170ca2 = 'addons';
const $49a076eb01652100$export$eebccb886b064713 = 'plans';
const $49a076eb01652100$export$1c2ea36059c73937 = 'alerts';

parcelRegister("20jWj", function(module, exports) {

$parcel$export(module.exports, "fetchFavoriteItems", () => $7a715a28552f71dc$export$ba7e2966560509a6);

var $6eBRn = parcelRequire("6eBRn");

var $ebyGx = parcelRequire("ebyGx");

var $5HnTq = parcelRequire("5HnTq");

var $fPruT = parcelRequire("fPruT");

const $7a715a28552f71dc$var$handleError = (error)=>{
    throw error;
};
// This is horrible but the API is wrong: the type returned is singular while
// everywhere else (even in add/remove) is plural
// @ts-expect-error - TS7031 - Binding element 'items' implicitly has an 'any' type.
const $7a715a28552f71dc$var$convertTypeToPlural = ({ items: items, ...rest })=>({
        ...rest,
        // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
        items: items.filter(Boolean).map((item)=>({
                ...item,
                type: `${item.type}s`
            }))
    });
const $7a715a28552f71dc$export$ba7e2966560509a6 = async ({ count: count, types: types = [
    (0, $49a076eb01652100$export$91a9dba2d38d9a6f),
    (0, $49a076eb01652100$export$6e58b6b0aa48a271),
    (0, $49a076eb01652100$export$6737b9227f60f39d),
    (0, $49a076eb01652100$export$eebccb886b064713)
] })=>{
    const query = (0, $ebyGx.stringify)((0, (/*@__PURE__*/$parcel$interopDefault($6eBRn)))(types.map((type)=>[
            type,
            count
        ])));
    const url = `/rest/internal/2/favourites?${query}`;
    try {
        const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
        if (!response.ok) {
            const errorCode = response.status;
            if (errorCode === 401) return $7a715a28552f71dc$var$handleError(new (0, $fPruT.AuthenticationError)(`${errorCode}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $7a715a28552f71dc$var$handleError(new Error(errorCode));
        }
        const resp = await response.json();
        return resp.map($7a715a28552f71dc$var$convertTypeToPlural);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $7a715a28552f71dc$var$handleError(error);
    }
};
const $7a715a28552f71dc$export$77fc2acdef452939 = async (item)=>{
    const url = '/rest/internal/2/favourites';
    try {
        const response = await fetch(url, {
            ...(0, $5HnTq.getDefaultOptions)(url),
            method: 'POST',
            body: JSON.stringify({
                entity: {
                    id: item.id,
                    type: item.type
                },
                beforeEntityPosition: null
            })
        });
        if (!response.ok) {
            const errorCode = response.status;
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $7a715a28552f71dc$var$handleError(new Error(errorCode));
        }
        const result = await response.json();
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $7a715a28552f71dc$var$handleError(error);
    }
};
const $7a715a28552f71dc$export$acbe6ca9570854bd = async (item)=>{
    const url = `/rest/internal/2/favourites/${item.type}/${item.id}`;
    try {
        const response = await fetch(url, {
            ...(0, $5HnTq.getDefaultOptions)(url),
            method: 'DELETE'
        });
        if (!response.ok) {
            const errorCode = response.status;
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $7a715a28552f71dc$var$handleError(new Error(errorCode));
        }
        const result = await response.json();
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $7a715a28552f71dc$var$handleError(error);
    }
};

});
parcelRegister("fPruT", function(module, exports) {

$parcel$export(module.exports, "AuthenticationError", () => $95af1b43dc18895e$export$cf0c46b07324e9c5);
class $95af1b43dc18895e$export$cf0c46b07324e9c5 extends Error {
    constructor(message){
        super(message);
        this.name = 'AuthenticationError';
        this.skipSentry = true;
        this.statusCode = 401;
    }
}

});


const $7a1562bd0ca086b0$export$ea341e6cc435ed40 = 15;
const $7a1562bd0ca086b0$export$7a3d0824e907e616 = 'navigation-favourite-store';


parcelRegister("bBulW", function(module, exports) {

$parcel$export(module.exports, "EditionAwareness", () => $60ceaac5e0b6e842$export$a55b02efe3d62583);

var $5uXOq = parcelRequire("5uXOq");

var $eyWK5 = parcelRequire("eyWK5");

var $2vSU6 = parcelRequire("2vSU6");

var $hLQN7 = parcelRequire("hLQN7");

var $9uGVy = parcelRequire("9uGVy");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $lpwtK = parcelRequire("lpwtK");

var $iXVV6 = parcelRequire("iXVV6");
var $bngFq = parcelRequire("bngFq");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");

var $l8ruj = parcelRequire("l8ruj");

var $4SswE = parcelRequire("4SswE");

var $avEd9 = parcelRequire("avEd9");

var $koeKL = parcelRequire("koeKL");

var $jX0pr = parcelRequire("jX0pr");

var $jcw0u = parcelRequire("jcw0u");


var $bQaTP = parcelRequire("bQaTP");

var $bocwx = parcelRequire("bocwx");

var $4XZMs = parcelRequire("4XZMs");

var $4Smhc = parcelRequire("4Smhc");
// Experiment specific code to be removed during cleanup
const $60ceaac5e0b6e842$var$isEnrolledInJPDFreeToStandard = ()=>{
    const [config] = (0, $6s1PB.UNSAFE_noExposureExp)('jpd-free-to-upgrade-pill-au-awareness');
    const cohort = config.get('cohort', 'not-enrolled');
    return cohort !== 'not-enrolled';
};
const $60ceaac5e0b6e842$var$UFOProductAndEditionCustomData = ({ projectType: projectType, applicationEdition: applicationEdition })=>{
    const product = (0, $4Smhc.getEaProduct)(projectType);
    const edition = (0, $4Smhc.getEaEdition)(applicationEdition);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyWK5.default), {
        data: {
            product: product,
            edition: edition
        }
    });
};
const $60ceaac5e0b6e842$export$c12287ea2271e73f = async (cloudId, traitName)=>{
    const traits = await (0, $jX0pr.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    const foundTrait = traits.find((trait)=>trait.name === traitName);
    if (!foundTrait) return null;
    return foundTrait;
};
const $60ceaac5e0b6e842$var$EditionAwarenessWithCommonAnalytics = ()=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const { loading: loading, data: project } = (0, $lpwtK.useProject)();
    const siteHasOnlyJira = (0, $4SswE.useSiteHasOnlyJira)();
    const { getIsEligibleForJsmPremiumPillExperiment: getIsEligibleForJsmPremiumPillExperiment } = (0, $hLQN7.useJsmPremiumPillExperiment)();
    // Show premium pill button for JSM premium trial experiment
    // If the JSW EA top nav relocation is active, we want to default the project type to JSW
    // so that the pill can show even on product-agnostic pages (e.g. "Your work")
    const defaultProjectType = (0, $5uXOq.useMemo)(()=>{
        if (siteHasOnlyJira) return 0, $2vSU6.SOFTWARE_PROJECT;
        if (getIsEligibleForJsmPremiumPillExperiment()) // If the user is on the JSM assets page, we want to default the project type to JSM
        return 0, $2vSU6.SERVICE_DESK_PROJECT;
        return undefined;
    }, [
        getIsEligibleForJsmPremiumPillExperiment,
        siteHasOnlyJira
    ]);
    const projectType = (0, $2vSU6.toProjectType)(project?.type) || defaultProjectType;
    if (loading || !projectType) return null;
    const edition = (0, $ldyPw.getEditionForProject)(projectType, appEditions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            projectType: projectType,
            applicationEdition: edition,
            siteHasJswOnly: siteHasOnlyJira,
            isSiteAdmin: isSiteAdmin
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60ceaac5e0b6e842$var$ProductAndEditionChecker, {
        projectType: projectType,
        edition: edition,
        siteHasOnlyJira: siteHasOnlyJira
    }), (0, $4R6GH.fg)('new_ea_ufo_custom_data_info') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60ceaac5e0b6e842$var$UFOProductAndEditionCustomData, {
        projectType: projectType,
        applicationEdition: edition
    }));
};
const $60ceaac5e0b6e842$var$ProductAndEditionChecker = (props)=>{
    const { projectType: projectType, edition: edition, siteHasOnlyJira: siteHasOnlyJira } = props;
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [siteType, setSiteType] = (0, $5uXOq.useState)(undefined);
    // While the migration to the platform component is in progress we need to call the trait on the old component to pass to the FreeButton
    (0, $5uXOq.useEffect)(()=>{
        if (siteType === undefined) {
            if (edition === (0, $ldyPw.FREE_EDITION)) {
                if ((0, $4R6GH.fg)('load_growth_cohort_trait')) $60ceaac5e0b6e842$export$c12287ea2271e73f(cloudId, 'growth_discount_cohort').then((trait)=>{
                    if (trait && (trait.value === 'EDU' || trait.value === 'ORG')) setSiteType(trait.value);
                    else setSiteType('UNKNOWN');
                }).catch((e)=>{
                    setSiteType(null);
                    const event = createAnalyticsEvent({});
                    (0, $jcw0u.default)({
                        event: event,
                        meta: {
                            id: 'editionAwarenessGrowthCohortTrait',
                            packageName: 'edition-awareness',
                            teamName: 'growth-tako'
                        },
                        error: e,
                        sendToPrivacyUnsafeSplunk: true
                    });
                });
                else setSiteType(null);
            } else setSiteType(null);
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        edition,
        siteType
    ]);
    // We need to wait for the siteType to be set before rendering the button so we can send it to the platform component
    if (siteType === undefined) return null;
    if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) switch(edition){
        case 0, $ldyPw.FREE_EDITION:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                name: "edition-awareness-jsm-free-to-standard"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bocwx.EditionAwarenessButton), {
                applicationEdition: edition,
                applicationKey: "jira-servicedesk",
                projectType: projectType,
                siteType: siteType
            }));
        case 0, $ldyPw.STANDARD_EDITION:
        case 0, $ldyPw.PREMIUM_EDITION:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                name: "edition-awareness-jsw-jsm-standard-premium-trial"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XZMs.TrialPill), {
                productKey: "jira-servicedesk",
                projectType: projectType,
                edition: edition
            }));
        default:
            return null;
    }
    else if (projectType === (0, $2vSU6.SOFTWARE_PROJECT)) switch(edition){
        case 0, $ldyPw.FREE_EDITION:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                name: "edition-awareness-jsw-free"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bocwx.EditionAwarenessButton), {
                applicationEdition: edition,
                applicationKey: "jira-software",
                projectType: projectType,
                siteHasJswOnly: siteHasOnlyJira,
                siteType: siteType
            }));
        case 0, $ldyPw.STANDARD_EDITION:
        case 0, $ldyPw.PREMIUM_EDITION:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                name: "edition-awareness-jsw-jsm-standard-premium-trial"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XZMs.TrialPill), {
                productKey: "jira-software",
                projectType: projectType,
                edition: edition
            }));
        default:
            return null;
    }
    else if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) {
        if ((0, $4R6GH.fg)('jpd_disable_edition_awareness')) return null;
        switch(edition){
            case 0, $ldyPw.FREE_EDITION:
                if ($60ceaac5e0b6e842$var$isEnrolledInJPDFreeToStandard()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                    name: "edition-awareness-jpd-free-to-standard"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bocwx.EditionAwarenessButton), {
                    applicationEdition: "FREE_EDITION",
                    applicationKey: "jira-product-discovery",
                    projectType: projectType,
                    siteType: siteType
                }));
                return null;
            case 0, $ldyPw.STANDARD_EDITION:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                    name: "edition-awareness-jpd-standard-premium-trial"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XZMs.TrialPill), {
                    productKey: "jira-product-discovery",
                    projectType: projectType,
                    edition: edition
                }));
            // JPD has a premium offering that is currently in beta with a plan to release in FY25 Q3/4
            // We're for now ensuring the experience does not show to customers as it currently shows JSM content
            // and we don't have a set list of features to update the content to.
            case 0, $ldyPw.PREMIUM_EDITION:
            default:
                return null;
        }
    } else if (projectType === (0, $2vSU6.CORE_PROJECT)) // We are supporting only JWM implicit licensing when the parent license is JSW
    switch(edition){
        case 0, $ldyPw.FREE_EDITION:
            if (siteHasOnlyJira) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                name: "edition-awareness-jsw-free"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bocwx.EditionAwarenessButton), {
                applicationEdition: edition,
                applicationKey: "jira-software",
                projectType: projectType,
                siteHasJswOnly: siteHasOnlyJira,
                siteType: siteType
            }));
            return null;
        case 0, $ldyPw.STANDARD_EDITION:
            if (siteHasOnlyJira) // productKey is set to "jira-software", because it only has an entitlement with JSW, not with JWM.
            // projectType is the real value ("business").
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                name: "edition-awareness-implicit-jwm-standard-trial"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XZMs.TrialPill), {
                edition: edition,
                productKey: "jira-software",
                projectType: (0, $2vSU6.CORE_PROJECT)
            }));
            return null;
        case 0, $ldyPw.PREMIUM_EDITION:
            // Core projects are partially supported - only for implicit JWM, on premium, on the top nav
            if (siteHasOnlyJira) // productKey is set to "jira-software", because it only has an entitlement with JSW, not with JWM.
            // projectType is the real value ("business").
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                name: "edition-awareness-implicit-jwm-premium-trial"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XZMs.TrialPill), {
                edition: edition,
                productKey: (0, $2vSU6.projectTypeToCanonicalId)((0, $2vSU6.SOFTWARE_PROJECT)),
                projectType: (0, $2vSU6.CORE_PROJECT)
            }));
            return null;
        default:
            return null;
    }
    return null;
};
const $60ceaac5e0b6e842$var$EditionAwarenessPlatform = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { product: product, edition: edition, buttonProps: buttonProps } = (0, $bQaTP.useProductAndEdition)();
    const { isDismissed: isDismissed, handleDismiss: handleDismiss } = (0, $9uGVy.useIsEditionAwarenessPillDismissed)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [siteType, setSiteType] = (0, $5uXOq.useState)(undefined);
    (0, $5uXOq.useEffect)(()=>{
        if (siteType === undefined) {
            if (edition === 'free') {
                if ((0, $4R6GH.fg)('load_growth_cohort_trait')) $60ceaac5e0b6e842$export$c12287ea2271e73f(cloudId, 'growth_discount_cohort').then((trait)=>{
                    if (trait && (trait.value === 'EDU' || trait.value === 'ORG')) setSiteType(trait.value);
                    else setSiteType('UNKNOWN');
                }).catch((e)=>{
                    setSiteType(null);
                    const event = createAnalyticsEvent({});
                    (0, $jcw0u.default)({
                        event: event,
                        meta: {
                            id: 'editionAwarenessGrowthCohortTrait',
                            packageName: 'edition-awareness',
                            teamName: 'growth-tako'
                        },
                        error: e,
                        sendToPrivacyUnsafeSplunk: true
                    });
                });
                else setSiteType(null);
            } else setSiteType(null);
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        edition,
        siteType
    ]);
    if (!product || !edition || !buttonProps) return null;
    // We need to wait for the siteType to be set before rendering the button so we can send it to the platform component
    if (siteType === undefined) return null;
    const { projectType: projectType, applicationEdition: applicationEdition, siteHasJswOnly: siteHasJswOnly, applicationKey: applicationKey } = buttonProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            projectType: projectType,
            applicationEdition: applicationEdition,
            siteHasJswOnly: siteHasJswOnly,
            isSiteAdmin: isSiteAdmin,
            product: product,
            edition: edition
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $avEd9.EditionAwareness), {
        freeButton: // handle typechecking for free button
        projectType !== (0, $2vSU6.CUSTOMER_SERVICE_PROJECT) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bocwx.EditionAwarenessButton), {
            applicationEdition: (0, $ldyPw.FREE_EDITION),
            applicationKey: applicationKey,
            projectType: projectType,
            siteHasJswOnly: siteHasJswOnly,
            siteType: siteType
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyWK5.default), {
            data: {
                product: product,
                edition: edition
            }
        })),
        trialButton: // handling type checking for trial button
        (applicationEdition === (0, $ldyPw.STANDARD_EDITION) || applicationEdition === (0, $ldyPw.PREMIUM_EDITION)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XZMs.TrialButton), {
            edition: applicationEdition,
            productKey: applicationKey,
            projectType: projectType
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyWK5.default), {
            data: {
                product: product,
                edition: edition
            }
        })),
        edition: edition,
        cloudId: cloudId,
        product: product,
        userRoles: isSiteAdmin ? [
            'SITE_ADMIN'
        ] : [],
        hasDismissedButton: isDismissed,
        onDismissButton: handleDismiss,
        siteType: siteType
    }));
};
const $60ceaac5e0b6e842$export$a55b02efe3d62583 = ()=>{
    // This component is not rendered on the server, we don't have enough information to determine if it will be renderer or not
    // Don't remove because it may cause the SSR to fail, at this point it because the EditonAwarenessButton is using useLazyLoadQuery
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $af6ccefcb1f83341$export$f19f2573d2fc7010),
        packageName: (0, $af6ccefcb1f83341$export$b8b9d90f9e5bd72b),
        fallback: "unmount",
        teamName: "growth-tako"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "edition-awareness"
    }, (0, $4R6GH.fg)('new_ea_jira_audience_and_timing') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60ceaac5e0b6e842$var$EditionAwarenessPlatform, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60ceaac5e0b6e842$var$EditionAwarenessWithCommonAnalytics, null)));
};

});
const $af6ccefcb1f83341$export$f19f2573d2fc7010 = 'EditionAwareness';
const $af6ccefcb1f83341$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarEditionAwareness';

parcelRegister("bQaTP", function(module, exports) {

$parcel$export(module.exports, "useProductAndEdition", () => $f3ac7751023fca6b$export$b0f1c0403c557678);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $hLQN7 = parcelRequire("hLQN7");

var $lpwtK = parcelRequire("lpwtK");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $6s1PB = parcelRequire("6s1PB");

var $4SswE = parcelRequire("4SswE");

var $4Smhc = parcelRequire("4Smhc");
// Experiment specific code to be removed during cleanup
const $f3ac7751023fca6b$var$isEnrolledInJPDFreeToStandard = ()=>{
    const [config] = (0, $6s1PB.UNSAFE_noExposureExp)('jpd-free-to-upgrade-pill-au-awareness');
    const cohort = config.get('cohort', 'not-enrolled');
    return cohort !== 'not-enrolled';
};
const $f3ac7751023fca6b$export$b0f1c0403c557678 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const { loading: loading, data: project } = (0, $lpwtK.useProject)();
    const siteHasOnlyJira = (0, $4SswE.useSiteHasOnlyJira)();
    const { getIsEligibleForJsmPremiumPillExperiment: getIsEligibleForJsmPremiumPillExperiment } = (0, $hLQN7.useJsmPremiumPillExperiment)();
    // Show premium pill button for JSM premium trial experiment
    const projectType = (0, $5uXOq.useMemo)(()=>{
        if (loading) return;
        const type = (0, $2vSU6.toProjectType)(project?.type);
        if (type) return type;
        if (siteHasOnlyJira) return 0, $2vSU6.SOFTWARE_PROJECT;
        if (getIsEligibleForJsmPremiumPillExperiment()) // If the user is on the JSM assets page, we want to default the project type to JSM
        return 0, $2vSU6.SERVICE_DESK_PROJECT;
    }, [
        loading,
        project?.type,
        siteHasOnlyJira,
        getIsEligibleForJsmPremiumPillExperiment
    ]);
    const applicationEdition = (0, $5uXOq.useMemo)(()=>{
        if (!projectType) return;
        if (siteHasOnlyJira) return (0, $ldyPw.getEditionForProject)((0, $2vSU6.SOFTWARE_PROJECT), appEditions);
        return (0, $ldyPw.getEditionForProject)(projectType, appEditions);
    }, [
        appEditions,
        projectType,
        siteHasOnlyJira
    ]);
    const { product: product, edition: edition } = (0, $5uXOq.useMemo)(()=>{
        if (!projectType || !applicationEdition) // We don't have a product or edition, so return nothing
        return {};
        if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT) && applicationEdition === (0, $ldyPw.FREE_EDITION) && !$f3ac7751023fca6b$var$isEnrolledInJPDFreeToStandard()) // JPD in free is in the process of being rolled out to 100%, this check is to be removed in cleanup
        return {};
        if (projectType === (0, $2vSU6.CORE_PROJECT) && !siteHasOnlyJira) // We are supporting only JWM implicit licensing when the parent license is JSW
        // Do not show on core products if site does not have only Jira
        return {};
        return {
            product: (0, $4Smhc.getEaProduct)(projectType),
            edition: (0, $4Smhc.getEaEdition)(applicationEdition)
        };
    }, [
        applicationEdition,
        projectType,
        siteHasOnlyJira
    ]);
    const buttonProps = (0, $5uXOq.useMemo)(()=>{
        // this code is to be cleaned up when EA content is moved to platform
        if (!product || !edition || !projectType || !applicationEdition) return;
        const applicationKey = (0, $4Smhc.getApplicationKey)(product);
        if (!applicationKey) return;
        return {
            projectType: projectType,
            applicationEdition: applicationEdition,
            siteHasJswOnly: siteHasOnlyJira,
            applicationKey: applicationKey
        };
    }, [
        edition,
        applicationEdition,
        product,
        projectType,
        siteHasOnlyJira
    ]);
    return {
        product: product,
        edition: edition,
        buttonProps: buttonProps
    };
};

});
parcelRegister("4Smhc", function(module, exports) {

$parcel$export(module.exports, "getEaEdition", () => $ca516994f7b24da4$export$97723d6c29d019f0);
$parcel$export(module.exports, "getEaProduct", () => $ca516994f7b24da4$export$b624a828f547dd8);
$parcel$export(module.exports, "getApplicationKey", () => $ca516994f7b24da4$export$64cdf48cf6b90ca3);

var $2vSU6 = parcelRequire("2vSU6");
const $ca516994f7b24da4$export$97723d6c29d019f0 = (e)=>{
    if (e === 'FREE_EDITION') return 'free';
    if (e === 'STANDARD_EDITION') return 'standard';
    if (e === 'PREMIUM_EDITION') return 'premium';
};
const $ca516994f7b24da4$export$b624a828f547dd8 = (p)=>{
    if (p === (0, $2vSU6.SOFTWARE_PROJECT)) return 'jira';
    if (p === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return 'jira-product-discovery';
    if (p === (0, $2vSU6.SERVICE_DESK_PROJECT)) return 'jira-service-management';
    if (p === (0, $2vSU6.CORE_PROJECT)) return 'jira';
};
const $ca516994f7b24da4$export$64cdf48cf6b90ca3 = (product)=>{
    if (product === 'jira') return 'jira-software';
    if (product === 'jira-product-discovery') return 'jira-product-discovery';
    if (product === 'jira-service-management') return 'jira-servicedesk';
};

});


parcelRegister("bocwx", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessButton", () => $61e6eaefd3d39783$export$57ddd9301662f8e4);

var $jHoa7 = parcelRequire("jHoa7");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $lrpci = parcelRequire("lrpci");

var $2vSU6 = parcelRequire("2vSU6");

var $7CMCs = parcelRequire("7CMCs");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $5CSGy = parcelRequire("5CSGy");

var $koVbs = parcelRequire("koVbs");

var $2KAtx = parcelRequire("2KAtx");

var $lfTZh = parcelRequire("lfTZh");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $iXVV6 = parcelRequire("iXVV6");


var $ldyPw = parcelRequire("ldyPw");

var $koeKL = parcelRequire("koeKL");

var $5oBMG = parcelRequire("5oBMG");

var $aKJYy = parcelRequire("aKJYy");

var $e7Hfh = parcelRequire("e7Hfh");

var $dnl6l = parcelRequire("dnl6l");

var $kUyoc = parcelRequire("kUyoc");

var $jBhBB = parcelRequire("jBhBB");
const $61e6eaefd3d39783$export$925bb9ccf400a715 = {
    [(0, $c06e1abca7c13910$export$202f50ee62667e32)]: 'user',
    [(0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61)]: 'agent',
    [(0, $c06e1abca7c13910$export$1346c9aa3cbb477d)]: 'user'
};
const $61e6eaefd3d39783$var$TargetOfferings = {
    [(0, $ldyPw.FREE_EDITION)]: (0, $ldyPw.STANDARD_EDITION)
};
const $61e6eaefd3d39783$var$JPD_LIMITED_USERS_LEFT_LIMIT = 1;
const $61e6eaefd3d39783$var$JSM_LIMITED_USERS_LEFT_LIMIT = 1;
const $61e6eaefd3d39783$var$JSW_LIMITED_USERS_LEFT_LIMIT = 7;
const $61e6eaefd3d39783$var$getButtonState = (applicationKey, licensedUsers, licensedUserLimit, eduOrgExperimentEnabled)=>{
    if (eduOrgExperimentEnabled) return {
        message: (0, $kUyoc.default).eduOrgDiscount,
        appearance: 'default'
    };
    if (!licensedUsers || licensedUsers <= 0 || !licensedUserLimit || licensedUserLimit <= 0) return {
        message: (0, $kUyoc.default).upgrade,
        appearance: 'default'
    };
    if (applicationKey === (0, $c06e1abca7c13910$export$202f50ee62667e32)) {
        if (licensedUsers >= licensedUserLimit) return {
            message: (0, $kUyoc.default).noCreatorsLeft,
            appearance: 'danger'
        };
        if (licensedUsers > $61e6eaefd3d39783$var$JPD_LIMITED_USERS_LEFT_LIMIT) return {
            message: (0, $kUyoc.default).limitedCreatorsLeft,
            appearance: 'warning'
        };
    }
    if (applicationKey === (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61)) {
        if (licensedUsers >= licensedUserLimit) return {
            message: (0, $kUyoc.default).noAgentsLeft,
            appearance: 'danger'
        };
        if (licensedUsers > $61e6eaefd3d39783$var$JSM_LIMITED_USERS_LEFT_LIMIT) return {
            message: (0, $kUyoc.default).limitedAgentsLeft,
            appearance: 'warning'
        };
    }
    if (applicationKey === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)) {
        if (licensedUsers >= licensedUserLimit) return {
            message: (0, $kUyoc.default).noUsersLeft,
            appearance: 'danger'
        };
        if (licensedUsers >= $61e6eaefd3d39783$var$JSW_LIMITED_USERS_LEFT_LIMIT) return {
            message: (0, $kUyoc.default).limitedUsersLeft,
            appearance: 'warning'
        };
    }
    return {
        message: (0, $kUyoc.default).upgrade,
        appearance: 'default'
    };
};
const $61e6eaefd3d39783$var$MODAL_PROPS = {
    width: 968
};
const $61e6eaefd3d39783$export$57ddd9301662f8e4 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "EditionAwarenessButton",
        packageName: "edition-awareness",
        fallback: "unmount",
        teamName: "growth-tako"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "edition-awareness-button-placeholder",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($61e6eaefd3d39783$export$eeffe9779f022c43, props)));
};
const $61e6eaefd3d39783$export$eeffe9779f022c43 = (props)=>{
    const { applicationKey: applicationKey, projectType: projectType, siteHasJswOnly: siteHasJswOnly, siteType: siteType } = props;
    // We are checking this requisites on the parent, but we are just adding it as a safeguard to avoid the API to be called for this invalid use case
    if (projectType === (0, $2vSU6.CORE_PROJECT) && (applicationKey !== 'jira-software' || !siteHasJswOnly)) throw new Error('CORE_PROJECT is only supported for Jira Software only sites');
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    const billingSourceSystem = productEntitlementDetails?.[applicationKey]?.billingSourceSystem === 'CCP' ? 'CCP' : 'HAMS';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            billingSourceSystem: billingSourceSystem,
            applicationKey: applicationKey,
            siteType: siteType
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($61e6eaefd3d39783$var$EditionAwarenessButtonWithQuery, {
        ...props,
        billingSourceSystem: billingSourceSystem
    }));
};
const $61e6eaefd3d39783$var$EditionAwarenessButtonWithQuery = (props)=>{
    const { applicationEdition: applicationEdition, applicationKey: applicationKey, projectType: projectType, siteType: siteType } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const chargeElement = $61e6eaefd3d39783$export$925bb9ccf400a715[applicationKey];
    const offeringKey = (0, $5CSGy.getProductOfferingKeyOrThrow)(applicationKey, $61e6eaefd3d39783$var$TargetOfferings[applicationEdition]);
    const data = (0, $8Uumt.useLazyLoadQuery)((0, $jHoa7.default), {
        cloudId: cloudId,
        hamsProductKey: applicationKey,
        chargeElement: chargeElement,
        offeringKey: offeringKey,
        isCurrentUserBillingAdminAttributeFgEnabled: (0, $4R6GH.fg)('jira_edition_awareness_add_isbillingadmin_attr'),
        isNewEaJiraAudienceAndTimingEnabled: (0, $4R6GH.fg)('new_ea_jira_audience_and_timing')
    });
    const entitlement = data.tenantContexts?.[0]?.entitlementInfo?.entitlement;
    const licensedUsers = entitlement?.latestUsageForChargeElement;
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    const licensedUserLimit = productEntitlementDetails?.[applicationKey]?.unitCount;
    // this is always true if the gate is turned on as we have performed this check in the platform audience and timing
    const isAvailableToUser = (0, $4R6GH.fg)('new_ea_jira_audience_and_timing') ? true : entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser;
    const hasUpgradeUrl = (0, $4R6GH.fg)('new_ea_jira_audience_and_timing') ? true : Boolean(entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl);
    const canUpgrade = Boolean(isAvailableToUser && hasUpgradeUrl);
    const isBillingAdmin = entitlement?.transactionAccount?.isCurrentUserBillingAdmin;
    const hasPartialInformation = !licensedUsers || licensedUsers <= 0 || !licensedUserLimit || licensedUserLimit <= 0;
    (0, $5uXOq.useEffect)(()=>{
        // licensedUserLimit is not fetch from the API, but is still required information and we want to fire an error if it's not available
        if (isAvailableToUser === null || isAvailableToUser === undefined || isAvailableToUser === true && !hasUpgradeUrl || hasPartialInformation) {
            // Creating the event will add the analytics context attributes
            const event = createAnalyticsEvent({});
            (0, $jcw0u.default)({
                event: event,
                meta: {
                    id: 'editionAwarenessNextQuery',
                    packageName: 'edition-awareness',
                    teamName: 'growth-tako'
                },
                attributes: (0, $e7Hfh.handleUndefinedInObjectForAnalytics)({
                    isAvailableToUser: isAvailableToUser,
                    hasUpgradeUrl: hasUpgradeUrl,
                    licensedUsers: licensedUsers,
                    licensedUserLimit: licensedUserLimit
                }),
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        createAnalyticsEvent,
        isAvailableToUser,
        licensedUserLimit,
        licensedUsers,
        hasPartialInformation,
        hasUpgradeUrl
    ]);
    const shouldSeeButton = (0, $aKJYy.useShouldSeeButton)({
        applicationEdition: applicationEdition,
        applicationKey: applicationKey,
        canUpgrade: canUpgrade,
        projectType: projectType
    });
    if (!shouldSeeButton) return null;
    const { message: message, appearance: appearance } = $61e6eaefd3d39783$var$getButtonState(applicationKey, licensedUsers, licensedUserLimit, false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: (0, $4R6GH.fg)('jira_edition_awareness_add_isbillingadmin_attr') ? {
            appearance: appearance,
            licensedUsers: licensedUsers,
            licensedUserLimit: licensedUserLimit,
            isBillingAdmin: isBillingAdmin
        } : {
            appearance: appearance,
            licensedUsers: licensedUsers,
            licensedUserLimit: licensedUserLimit
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($61e6eaefd3d39783$var$EditionAwarenessButtonComponent, {
        ...props,
        message: message,
        appearance: appearance,
        offeringKey: offeringKey,
        renderedWithPartialInformation: hasPartialInformation,
        siteType: siteType
    }));
};
const $61e6eaefd3d39783$var$EditionAwarenessButtonComponent = (props)=>{
    const { applicationEdition: applicationEdition, applicationKey: applicationKey, projectType: projectType, siteHasJswOnly: siteHasJswOnly, billingSourceSystem: billingSourceSystem, message: message, appearance: appearance, offeringKey: offeringKey, renderedWithPartialInformation: renderedWithPartialInformation = false, siteType: siteType } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'editionAwarenessButton');
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'editionAwarenessFreePill');
    }, [
        createAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'button'
        }), 'editionAwarenessButton', {
            renderedWithPartialInformation: renderedWithPartialInformation
        });
        // Adding partial information here, but we may delete this event soon
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'button'
        }), 'editionAwarenessFreePill', {
            renderedWithPartialInformation: renderedWithPartialInformation
        });
    }, [
        createAnalyticsEvent,
        renderedWithPartialInformation
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            applicationEdition: applicationEdition,
            applicationKey: applicationKey,
            projectType: projectType,
            siteHasJswOnly: siteHasJswOnly,
            billingSourceSystem: billingSourceSystem,
            siteType: siteType
        }), [
        applicationEdition,
        applicationKey,
        projectType,
        siteHasJswOnly,
        billingSourceSystem,
        siteType
    ]);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            jiraApplicationKey: (0, $jBhBB.getJiraApplicationKeyForProject)(projectType),
            cloudId: cloudId,
            applicationKey: applicationKey,
            offeringKey: offeringKey ?? '',
            chargeElement: $61e6eaefd3d39783$export$925bb9ccf400a715[applicationKey],
            projectType: (0, $2vSU6.convertToJiraProjectType)(projectType),
            isAvatarsFGEnabled: (0, $4R6GH.fg)('jira_ea_modal_avatars_gate')
        }), [
        applicationKey,
        cloudId,
        offeringKey,
        projectType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $dnl6l.editionAwarenessModalEntryPoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        modalProps: $61e6eaefd3d39783$var$MODAL_PROPS,
        interactionName: "edition-awareness-modal",
        useInternalModal: false
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lrpci.EditionAwarenessButton), {
            status: appearance,
            upgradeIconType: "gem",
            // This is how the examples in and tests are setup
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            onClick: handleOnClick
        }, formatMessage(message)));
};

});
parcelRegister("jHoa7", function(module, exports) {

$parcel$export(module.exports, "default", () => $5211c7c5cc82f413$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b9b9d7b454a73eff8adf8e815e0ef8fe>>
 * @relayHash 9d3616546ae5d04c5eb5104942c55cab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a4a1fa1f00dc32a0c9a06cc2503c38fc752dd1049b2dc0f81cecd881890d81d7
const $5211c7c5cc82f413$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chargeElement"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hamsProductKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isCurrentUserBillingAdminAttributeFgEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isNewEaJiraAudienceAndTimingEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offeringKey"
    }, v6 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v7 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "offeringKey",
            "variableName": "offeringKey"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v11 = {
        "args": [
            {
                "kind": "Variable",
                "name": "chargeElement",
                "variableName": "chargeElement"
            }
        ],
        "kind": "ScalarField",
        "name": "latestUsageForChargeElement"
    }, v12 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v13 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v14 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editionAwarenessNextQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "condition": "isNewEaJiraAudienceAndTimingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "args": v8 /*: any*/ ,
                                                            "kind": "LinkedField",
                                                            "name": "changeOfferingV2",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v11 /*: any*/ ,
                                        {
                                            "condition": "isCurrentUserBillingAdminAttributeFgEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "transactionAccount",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editionAwarenessNextQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                {
                                                    "condition": "isNewEaJiraAudienceAndTimingEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "args": v8 /*: any*/ ,
                                                            "kind": "LinkedField",
                                                            "name": "changeOfferingV2",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v11 /*: any*/ ,
                                        {
                                            "condition": "isCurrentUserBillingAdminAttributeFgEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "transactionAccount",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v14 /*: any*/ 
                                                            ],
                                                            "type": "CcpTransactionAccount"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a4a1fa1f00dc32a0c9a06cc2503c38fc752dd1049b2dc0f81cecd881890d81d7",
            "metadata": {},
            "name": "editionAwarenessNextQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5211c7c5cc82f413$var$node.hash = "0815a3d05dade2a96a9e399fd5b5948e";
var $5211c7c5cc82f413$export$2e2bcd8739ae039 = $5211c7c5cc82f413$var$node;

});

parcelRegister("aKJYy", function(module, exports) {

$parcel$export(module.exports, "useShouldSeeButton", () => $653e38467b5cc68a$export$dc0322901b5ae67b);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");
/**
 * Experiment specific code to be removed during cleanup
 */ const $653e38467b5cc68a$var$trackJDPFreeToStandardExposure = ({ createAnalyticsEvent: createAnalyticsEvent, applicationKey: applicationKey, applicationEdition: applicationEdition })=>{
    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({
        type: 'sendTrackEvent',
        action: 'exposed',
        actionSubject: 'feature'
    }), 'feature exposed', 'editionAwarenessButton', {
        flagKey: 'jpd-free-to-upgrade-pill-au-awareness',
        value: (0, $6s1PB.expVal)('jpd-free-to-upgrade-pill-au-awareness', 'cohort', 'not-enrolled'),
        growthInitiative: 'transmuters',
        applicationKey: applicationKey,
        applicationEdition: applicationEdition
    });
};
/**
 * Experiment specific code to be removed during cleanup
 */ const $653e38467b5cc68a$var$useShouldSeeJPDFreeToStandardExperiment = ({ applicationKey: applicationKey, applicationEdition: applicationEdition, canUpgrade: canUpgrade })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [config] = (0, $6s1PB.UNSAFE_noExposureExp)('jpd-free-to-upgrade-pill-au-awareness');
    const cohort = config.get('cohort', 'not-enrolled');
    const isEnrolled = cohort !== 'not-enrolled';
    const shouldSeeButton = canUpgrade && applicationKey === 'jira-product-discovery' && applicationEdition === 'FREE_EDITION';
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnrolled) return;
        if (!shouldSeeButton) return;
        $653e38467b5cc68a$var$trackJDPFreeToStandardExposure({
            createAnalyticsEvent: createAnalyticsEvent,
            applicationEdition: applicationEdition,
            applicationKey: applicationKey
        });
    }, [
        isEnrolled,
        createAnalyticsEvent,
        applicationEdition,
        applicationKey,
        shouldSeeButton
    ]);
    return cohort === 'variation' && shouldSeeButton;
};
const $653e38467b5cc68a$export$dc0322901b5ae67b = ({ applicationKey: applicationKey, applicationEdition: applicationEdition, canUpgrade: canUpgrade, projectType: projectType })=>{
    const shouldSeeJPDFreeToStandardExperiment = $653e38467b5cc68a$var$useShouldSeeJPDFreeToStandardExperiment({
        applicationEdition: applicationEdition,
        applicationKey: applicationKey,
        canUpgrade: canUpgrade
    });
    if (shouldSeeJPDFreeToStandardExperiment) return true;
    if (canUpgrade && applicationEdition === 'FREE_EDITION') {
        // Released 100% for JSM
        if (applicationKey === 'jira-servicedesk') return true;
        if (applicationKey === 'jira-software') {
            // Checking the JWM experiment
            if (projectType === (0, $2vSU6.CORE_PROJECT)) return (0, $6s1PB.expValEquals)('edition_awareness_on_jwm', 'isEnabled', true);
            // Released 100% for JSW
            return true;
        }
    }
    return false;
};

});

parcelRegister("e7Hfh", function(module, exports) {

$parcel$export(module.exports, "handleUndefinedInObjectForAnalytics", () => $5e080700484beb4b$export$c402f26ab7c377ac);
function $5e080700484beb4b$export$c402f26ab7c377ac(input) {
    if (typeof input === 'object') return JSON.parse(JSON.stringify(input, (_, value)=>typeof value === 'undefined' ? 'undefined' : value));
    return input;
}

});

parcelRegister("dnl6l", function(module, exports) {

$parcel$export(module.exports, "editionAwarenessModalEntryPoint", () => $2cefc61447230c0a$export$dd136db78a637fd0);

var $1zkg6 = parcelRequire("1zkg6");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $2cefc61447230c0a$export$dd136db78a637fd0 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("559eZ")), {
        moduleId: "31852d1c"
    }),
    getPreloadProps: ({ cloudId: cloudId, jiraApplicationKey: jiraApplicationKey, applicationKey: applicationKey, offeringKey: offeringKey, chargeElement: chargeElement, projectType: projectType, isAvatarsFGEnabled: isAvatarsFGEnabled })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                editionAwareness: {
                    parameters: (0, $1zkg6.default),
                    variables: {
                        cloudId: cloudId,
                        jiraApplicationKey: jiraApplicationKey,
                        hamsProductKey: applicationKey,
                        offeringKey: offeringKey,
                        chargeElement: chargeElement,
                        projectType: projectType,
                        isAvatarsFGEnabled: isAvatarsFGEnabled
                    }
                }
            }
        })
});

});
parcelRegister("1zkg6", function(module, exports) {

$parcel$export(module.exports, "default", () => $40f30b931ec7517b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<49ec598e80dc172e6cad4c1dd2ef945f>>
 * @relayHash 60508ac552f02ed69773e0e19b90de78
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2b02b40f27ce5c8c3225d6a27e82a9706924145c4b461f4a3f6ce1d65ea2418f
const $40f30b931ec7517b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2b02b40f27ce5c8c3225d6a27e82a9706924145c4b461f4a3f6ce1d65ea2418f",
        "metadata": {},
        "name": "wrapperEditionAwarenessModalWrapperQuery",
        "operationKind": "query",
        "text": null
    }
};
var $40f30b931ec7517b$export$2e2bcd8739ae039 = $40f30b931ec7517b$var$node;

});

parcelRegister("559eZ", function(module, exports) {

let $3b34966dc8436dc5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3b34966dc8436dc5$var$load("3Q6GO").then(()=>parcelRequire('flkxC'));

});


parcelRegister("kUyoc", function(module, exports) {

$parcel$export(module.exports, "default", () => $80fa0347e5551aca$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $80fa0347e5551aca$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noCreatorsLeft: {
        "id": "navigation-apps-sidebar-edition-awareness.edition-awareness-next.no-creators-left",
        "defaultMessage": "No creators left"
    },
    limitedCreatorsLeft: {
        "id": "navigation-apps-sidebar-edition-awareness.edition-awareness-next.limited-creators-left",
        "defaultMessage": "Limited creators left"
    },
    noAgentsLeft: {
        "id": "navigation-apps-sidebar-edition-awareness.edition-awareness-next.no-agents-left",
        "defaultMessage": "No agents left"
    },
    limitedAgentsLeft: {
        "id": "navigation-apps-sidebar-edition-awareness.edition-awareness-next.limited-agents-left",
        "defaultMessage": "Limited agents left"
    },
    noUsersLeft: {
        "id": "navigation-apps-sidebar-edition-awareness.edition-awareness-next.no-users-left",
        "defaultMessage": "No users left"
    },
    limitedUsersLeft: {
        "id": "navigation-apps-sidebar-edition-awareness.edition-awareness-next.limited-users-left",
        "defaultMessage": "Limited users left"
    },
    upgrade: {
        "id": "navigation-apps-sidebar-edition-awareness.edition-awareness-next.upgrade",
        "defaultMessage": "Upgrade"
    },
    eduOrgDiscount: {
        "id": "navigation-apps-sidebar-edition-awareness.edition-awareness-next.edu-org-discount.non-final",
        "defaultMessage": "Education discount"
    }
});

});

parcelRegister("jBhBB", function(module, exports) {

$parcel$export(module.exports, "getJiraApplicationKeyForProject", () => $83c8d697d552ecd6$export$3b968c78e8fbd1dd);

var $2vSU6 = parcelRequire("2vSU6");

var $efvDm = parcelRequire("efvDm");
const $83c8d697d552ecd6$export$3b968c78e8fbd1dd = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return 0, $efvDm.JIRA_SOFTWARE;
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 0, $efvDm.JIRA_SERVICE_DESK;
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return 0, $efvDm.JIRA_PRODUCT_DISCOVERY;
        default:
            throw new Error(`Unrecognised project type: ${projectType}`);
    }
};

});


parcelRegister("4XZMs", function(module, exports) {

$parcel$export(module.exports, "TrialPill", () => $6970f6913a0b966d$export$dd77a69c423022b0);
$parcel$export(module.exports, "TrialButton", () => $6970f6913a0b966d$export$2355153fb46bfcc3);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $8iquX = parcelRequire("8iquX");

var $2vSU6 = parcelRequire("2vSU6");

var $ld2hZ = parcelRequire("ld2hZ");

var $hLQN7 = parcelRequire("hLQN7");

var $6s1PB = parcelRequire("6s1PB");

var $dRVix = parcelRequire("dRVix");

var $ldyPw = parcelRequire("ldyPw");

var $koeKL = parcelRequire("koeKL");

var $9OXo1 = parcelRequire("9OXo1");

var $5oBMG = parcelRequire("5oBMG");

var $4R6GH = parcelRequire("4R6GH");

var $6ZmIe = parcelRequire("6ZmIe");

var $6Myxd = parcelRequire("6Myxd");

var $73N85 = parcelRequire("73N85");

var $jasTs = parcelRequire("jasTs");

var $h1xoN = parcelRequire("h1xoN");
const $6970f6913a0b966d$var$TrialPillComponent = ({ edition: edition, productKey: productKey, projectType: projectType, entitlementDetails: entitlementDetails })=>{
    const { billingSourceSystem: billingSourceSystem } = entitlementDetails;
    const [shouldRenderPill, setShouldRenderPill] = (0, $5uXOq.useState)(null);
    const relayEnvironment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const fireEligibilityCheckEvent = (0, $h1xoN.useEligibilityCheckEvent)({
        productKey: productKey,
        projectType: projectType,
        edition: edition,
        entitlementDetails: entitlementDetails
    });
    const { loading: billingInformationLoading, data: billingInformation, error: billingInformationError, fetch: fetchBillingInformation } = (0, $ld2hZ.useService)((0, $73N85.getBillingInformation));
    const { isOnCMDBPage: isOnCMDBPage, getIsEligibleForJsmPremiumPillExperiment: getIsEligibleForJsmPremiumPillExperiment } = (0, $hLQN7.useJsmPremiumPillExperiment)();
    (0, $5uXOq.useEffect)(()=>{
        fetchBillingInformation({
            cloudId: cloudId,
            productKey: productKey,
            relayEnvironment: relayEnvironment
        });
    }, [
        fetchBillingInformation,
        cloudId,
        productKey,
        relayEnvironment
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (billingInformationError) {
            fireEligibilityCheckEvent('error', {
                error: (0, $h1xoN.transformError)(billingInformationError)
            });
            setShouldRenderPill(false);
            return;
        }
        if (billingInformation) {
            const ineligibilityReasons = (0, $h1xoN.getIneligibilityReasons)(billingInformation);
            if (ineligibilityReasons.length > 0) {
                /*
								We are only checking if the product user can pay when the only ineligibility reason is that they are not a billing admin.
								If there are other ineligibility reasons present, they are not eligible for our experiment.
								 */ const shouldPerformProductUserChecks = billingSourceSystem === 'CCP' && billingInformation.isBillingAdmin === false && ineligibilityReasons.length === 1 && ineligibilityReasons[0] === 'notBillingAdmin';
                if (shouldPerformProductUserChecks) try {
                    (0, $6Myxd.canProductUserPay)(cloudId, productKey, relayEnvironment).then((canPay)=>{
                        setShouldRenderPill(canPay);
                        fireEligibilityCheckEvent(canPay ? null : 'productUserCannotPay', {
                            billingInformation: billingInformation,
                            ineligibilityReasons: ineligibilityReasons
                        });
                    });
                } catch (error) {
                    fireEligibilityCheckEvent('canProductUserPayError', {
                        error: (0, $h1xoN.transformError)(error),
                        billingInformation: billingInformation,
                        ineligibilityReasons: ineligibilityReasons
                    });
                    setShouldRenderPill(false);
                }
                else {
                    // Choose only first reason to keep even backward compatible, other reason could be still retrieved from billingInformation
                    fireEligibilityCheckEvent(ineligibilityReasons[0], {
                        billingInformation: billingInformation,
                        ineligibilityReasons: ineligibilityReasons
                    });
                    setShouldRenderPill(false);
                }
            } else {
                const notInTrialOrGracePeriod = (0, $4R6GH.fg)('jira_edition_awareness_isgraceperiod_check_fix') ? billingInformation.preDunningStatus !== 'IN_PRE_DUNNING' && entitlementDetails.trialEndTime === undefined : false;
                if (notInTrialOrGracePeriod) {
                    fireEligibilityCheckEvent('notInTrialOrGracePeriod', {
                        billingInformation: billingInformation
                    });
                    setShouldRenderPill(false);
                } else {
                    fireEligibilityCheckEvent(null, {
                        billingInformation: billingInformation
                    });
                    setShouldRenderPill(true);
                }
            }
        } else setShouldRenderPill(false);
    }, [
        billingInformation,
        billingInformationError,
        billingSourceSystem,
        cloudId,
        fireEligibilityCheckEvent,
        productKey,
        relayEnvironment,
        entitlementDetails
    ]);
    if (billingInformationLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iquX.default), {
        name: "edition-awareness-billing-information-loading"
    });
    if (!billingInformation) return null;
    if (shouldRenderPill) {
        if (getIsEligibleForJsmPremiumPillExperiment() && isOnCMDBPage && (0, $6s1PB.expValEquals)('jsm_premium_trial_pill_experiment', 'cohort', 'control')) return null;
        if (projectType === (0, $2vSU6.CORE_PROJECT) && edition === (0, $ldyPw.STANDARD_EDITION)) {
            // For CONTROL and NOT-ENROLLED we are not showing the pill, but using the funtion to fire the exposure
            if (!(0, $6s1PB.expValEquals)('edition_awareness_on_jwm', 'isEnabled', true)) return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ZmIe.EditionAwarenessContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jasTs.TrialPillButton), {
            productKey: productKey,
            projectType: projectType,
            edition: edition,
            entitlementDetails: entitlementDetails,
            invoiceGroupId: billingInformation.invoiceGroupId,
            transactionAccountId: billingInformation.transactionAccountId,
            isBillingAdmin: billingInformation.isBillingAdmin,
            trialLengthDays: billingInformation.trialLengthDays,
            preDunningStatus: billingInformation.preDunningStatus
        }));
    }
    return null;
};
const $6970f6913a0b966d$export$dd77a69c423022b0 = ({ productKey: productKey, projectType: projectType, edition: edition })=>{
    const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(null);
    const { productEntitlementDetails: productEntitlementDetails } = (0, $9OXo1.useTenantContext)();
    const entitlementDetails = productEntitlementDetails?.[productKey];
    const billingSourceSystem = entitlementDetails?.billingSourceSystem || 'HAMS'; // If billingSourceSystem is not set, it is HAMS
    // override the billingSourceSystem to not be null
    const memoizedEntitlementDetails = (0, $5uXOq.useMemo)(()=>({
            ...entitlementDetails,
            billingSourceSystem: billingSourceSystem
        }), [
        billingSourceSystem,
        entitlementDetails
    ]);
    // Checking whether site is in trial or grace period (14 days after trial ends).
    // We can do this for HAMS but not for CCP. CCP has feature called pre-dunning.
    // We do not know how to identify pre-dunning since new subscription is created without trialEndDate
    // so we basically have to check invoiceability or everyone on CCP
    const currentDate = (0, $5uXOq.useMemo)(()=>Date.now(), []);
    const trialDaysLeft = (0, $dRVix.getTrialDaysLeft)(currentDate, entitlementDetails?.trialEndTime);
    const notInTrialOrGracePeriod = billingSourceSystem === 'HAMS' && (!trialDaysLeft || trialDaysLeft < -14);
    const fireEligibilityCheckEvent = (0, $h1xoN.useEligibilityCheckEvent)({
        productKey: productKey,
        projectType: projectType,
        edition: edition,
        entitlementDetails: entitlementDetails
    });
    (0, $5uXOq.useEffect)(()=>{
        // This check should be always false, and it is here to make sure component works even if it would get mounted outside parent EditionAwareness component
        if (edition !== (0, $ldyPw.STANDARD_EDITION) && edition !== (0, $ldyPw.PREMIUM_EDITION)) {
            fireEligibilityCheckEvent('invalidEdition');
            setShouldRender(false);
        } else if (!entitlementDetails) {
            fireEligibilityCheckEvent('missingEntitlementDetails', {
                productEntitlementDetails: productEntitlementDetails
            });
            setShouldRender(false);
        } else if (notInTrialOrGracePeriod) {
            fireEligibilityCheckEvent('notInTrialOrGracePeriod');
            setShouldRender(false);
        } else setShouldRender(true);
    }, [
        edition,
        entitlementDetails,
        fireEligibilityCheckEvent,
        productEntitlementDetails,
        notInTrialOrGracePeriod
    ]);
    if (shouldRender) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6970f6913a0b966d$var$TrialPillComponent, {
        edition: edition,
        productKey: productKey,
        projectType: projectType,
        entitlementDetails: memoizedEntitlementDetails
    });
    return null;
};
const $6970f6913a0b966d$export$2355153fb46bfcc3 = ({ productKey: productKey, projectType: projectType, edition: edition })=>{
    const { isOnCMDBPage: isOnCMDBPage, getIsEligibleForJsmPremiumPillExperiment: getIsEligibleForJsmPremiumPillExperiment } = (0, $hLQN7.useJsmPremiumPillExperiment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const relayEnvironment = (0, $8Uumt.useRelayEnvironment)();
    const { loading: billingInformationLoading, data: billingInformation, error: billingInformationError, fetch: fetchBillingInformation } = (0, $ld2hZ.useService)((0, $73N85.getBillingInformationForTrialButton));
    (0, $5uXOq.useEffect)(()=>{
        fetchBillingInformation({
            cloudId: cloudId,
            productKey: productKey,
            relayEnvironment: relayEnvironment
        });
    }, [
        fetchBillingInformation,
        cloudId,
        productKey,
        relayEnvironment
    ]);
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    const entitlementDetails = productEntitlementDetails?.[productKey];
    // If billingSourceSystem is not set, it is HAMS
    const billingSourceSystem = entitlementDetails?.billingSourceSystem || 'HAMS';
    // override the billingSourceSystem to not be null
    const memoizedEntitlementDetails = (0, $5uXOq.useMemo)(()=>({
            ...entitlementDetails,
            billingSourceSystem: billingSourceSystem
        }), [
        billingSourceSystem,
        entitlementDetails
    ]);
    const fireEligibilityCheckEvent = (0, $h1xoN.useEligibilityCheckEvent)({
        productKey: productKey,
        projectType: projectType,
        edition: edition,
        entitlementDetails: entitlementDetails
    });
    (0, $5uXOq.useEffect)(()=>{
        if (billingInformationError) fireEligibilityCheckEvent('error', {
            error: (0, $h1xoN.transformError)(billingInformationError),
            flagKey: 'new_ea_jira_audience_and_timing'
        });
    }, [
        billingInformationError,
        fetchBillingInformation,
        fireEligibilityCheckEvent
    ]);
    if (billingInformationLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iquX.default), {
        name: "edition-awareness-billing-information-loading"
    });
    if (!billingInformation || billingInformationError) return null;
    const notInTrialOrGracePeriod = (0, $4R6GH.fg)('jira_edition_awareness_isgraceperiod_check_fix') ? billingInformation.preDunningStatus !== 'IN_PRE_DUNNING' && memoizedEntitlementDetails?.trialEndTime === undefined : false;
    if (notInTrialOrGracePeriod) {
        fireEligibilityCheckEvent('notInTrialOrGracePeriod', {
            billingInformation: billingInformation
        });
        return null;
    }
    if (getIsEligibleForJsmPremiumPillExperiment() && isOnCMDBPage && (0, $6s1PB.expValEquals)('jsm_premium_trial_pill_experiment', 'cohort', 'control')) return null;
    if (projectType === (0, $2vSU6.CORE_PROJECT) && edition === (0, $ldyPw.STANDARD_EDITION)) {
        // For CONTROL and NOT-ENROLLED we are not showing the pill, but using the function to fire the exposure
        if (!(0, $6s1PB.expValEquals)('edition_awareness_on_jwm', 'isEnabled', true)) return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ZmIe.EditionAwarenessContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jasTs.TrialPillButton), {
        productKey: productKey,
        projectType: projectType,
        edition: edition,
        entitlementDetails: memoizedEntitlementDetails,
        invoiceGroupId: billingInformation.invoiceGroupId,
        transactionAccountId: billingInformation.transactionAccountId,
        isBillingAdmin: billingInformation.isBillingAdmin,
        trialLengthDays: billingInformation.trialLengthDays,
        preDunningStatus: billingInformation.preDunningStatus
    }));
};

});
parcelRegister("6ZmIe", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessContainer", () => $db10faa007327a9e$export$cf82788c7ae9c400);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $db10faa007327a9e$export$cf82788c7ae9c400 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1y6m _1o9zidpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6Myxd", function(module, exports) {

$parcel$export(module.exports, "canProductUserPay", () => $1afb83811cce850d$export$2559b2eb40941f10);

var $fD89J = parcelRequire("fD89J");

var $8Uumt = parcelRequire("8Uumt");

const $1afb83811cce850d$export$62297b13309008b2 = (0, $fD89J.default);
const $1afb83811cce850d$export$2559b2eb40941f10 = async (cloudId, productKey, relayEnvironment)=>{
    // JPD product key as used by Commerce does not include .ondemand
    const commerceProductKey = productKey === (0, $c06e1abca7c13910$export$202f50ee62667e32) ? productKey : `${productKey}.ondemand`;
    const variables = {
        cloudId: cloudId,
        productKey: commerceProductKey
    };
    const response = await (0, $8Uumt.fetchQuery)(relayEnvironment, $1afb83811cce850d$export$62297b13309008b2, variables, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const entitlementInfo = response?.tenantContexts && response.tenantContexts.length > 0 ? response.tenantContexts[0]?.entitlementInfo : undefined;
    const canPay = entitlementInfo?.entitlement?.subscription?.accountDetails?.invoiceGroup?.experienceCapabilities?.configurePaymentV2?.isAvailableToUser;
    return Boolean(canPay);
};

});
parcelRegister("fD89J", function(module, exports) {

$parcel$export(module.exports, "default", () => $52c41a3edf7df773$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<908c5b7125a328e4906add51c3f599a6>>
 * @relayHash 8a93eccb6a4de8033f8d5f8ad3cd8e40
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 214adfa29ea1bab0c1a4893dc453d76b1c749f86c52652514fb64580b5f60ffb
const $52c41a3edf7df773$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "productKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        v5 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "canProductUserPayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "experienceCapabilities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "configurePaymentV2",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v3 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "tenantContexts.entitlementInfo.entitlement.subscription.accountDetails.invoiceGroup.experienceCapabilities.configurePaymentV2.isAvailableToUser"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "canProductUserPayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "experienceCapabilities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "configurePaymentV2",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v3 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v6 /*: any*/ ,
                                                                    "type": "CcpInvoiceGroup"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v6 /*: any*/ ,
                                                    "type": "CcpSubscription"
                                                }
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "214adfa29ea1bab0c1a4893dc453d76b1c749f86c52652514fb64580b5f60ffb",
            "metadata": {},
            "name": "canProductUserPayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$52c41a3edf7df773$var$node.hash = "0064ac2d6628f537533e7f6c91f85010";
var $52c41a3edf7df773$export$2e2bcd8739ae039 = $52c41a3edf7df773$var$node;

});


parcelRegister("73N85", function(module, exports) {

$parcel$export(module.exports, "getBillingInformation", () => $bf6e8e3c9b87751c$export$8299b86bb18aafc1);
$parcel$export(module.exports, "getBillingInformationForTrialButton", () => $bf6e8e3c9b87751c$export$5331649224cf20da);

var $LsMDL = parcelRequire("LsMDL");

var $fKZAU = parcelRequire("fKZAU");
const $bf6e8e3c9b87751c$export$8299b86bb18aafc1 = async ({ cloudId: cloudId, productKey: productKey, relayEnvironment: relayEnvironment })=>{
    if (!cloudId) throw new Error('empty cloudId');
    if (!productKey) throw new Error('empty productKey');
    return (0, $fKZAU.getBillingInformationGraphql)(cloudId, productKey, relayEnvironment);
};
const $bf6e8e3c9b87751c$export$5331649224cf20da = async ({ cloudId: cloudId, productKey: productKey, relayEnvironment: relayEnvironment })=>{
    if (!cloudId) throw new Error('empty cloudId');
    if (!productKey) throw new Error('empty productKey');
    return (0, $LsMDL.getTrialButtonBillingInformationGraphql)(cloudId, productKey, relayEnvironment);
};

});
parcelRegister("LsMDL", function(module, exports) {

$parcel$export(module.exports, "getTrialButtonBillingInformationGraphql", () => $a84f74d8e00cc4fe$export$40aed388bcec5ed5);

var $aoCHP = parcelRequire("aoCHP");

var $eiowN = parcelRequire("eiowN");

var $4R6GH = parcelRequire("4R6GH");

const $a84f74d8e00cc4fe$export$62297b13309008b2 = (0, $aoCHP.default);
const $a84f74d8e00cc4fe$export$40aed388bcec5ed5 = async (cloudId, productKey, relayEnvironment)=>{
    // The product key as used by Commerce.
    // JPD product key as used by Commerce does not include .ondemand
    const commerceProductKey = productKey === (0, $c06e1abca7c13910$export$202f50ee62667e32) ? productKey : `${productKey}.ondemand`;
    const response = await (0, $eiowN.fetchQuery)(relayEnvironment, $a84f74d8e00cc4fe$export$62297b13309008b2, {
        cloudId: cloudId,
        productKey: commerceProductKey,
        isTrialCountdownFgExpEnabled: (0, $4R6GH.fg)('jira_edition_awareness_trial_countdown_gate'),
        isInGracePeriodFixFgEnabled: (0, $4R6GH.fg)('jira_edition_awareness_isgraceperiod_check_fix')
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const entitlementInfo = response?.tenantContexts && response.tenantContexts.length > 0 ? response.tenantContexts[0]?.entitlementInfo : undefined;
    const entitlement = entitlementInfo?.entitlement;
    const subscription = entitlement?.subscription;
    const invoiceGroup = subscription?.accountDetails?.invoiceGroup;
    const transactionAccount = entitlement?.transactionAccount;
    const offering = entitlement?.offering;
    return {
        transactionAccountId: transactionAccount?.key ?? null,
        invoiceGroupId: invoiceGroup?.id ?? null,
        isBillingAdmin: transactionAccount?.isCurrentUserBillingAdmin ?? null,
        trialLengthDays: offering?.trial?.lengthDays ?? null,
        preDunningStatus: entitlement?.preDunning?.status ?? null
    };
};

});
parcelRegister("aoCHP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa76c64201abbdc3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1297e52fc3bd1f2c835d01b332b497dd>>
 * @relayHash 20386ffeec0ab803889474656029a2be
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2753e00bae59e3ce31da8be67a8707519147394821c376e30cd60c5f2f7cf5b7
const $fa76c64201abbdc3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isInGracePeriodFixFgEnabled"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTrialCountdownFgExpEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productKey"
    }, v4 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v6 = [
        {
            "kind": "Literal",
            "name": "where",
            "value": {
                "AND": [
                    {
                        "inTrialOrPreDunning": true
                    }
                ]
            }
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = [
        v7 /*: any*/ 
    ], v9 = {
        "kind": "InlineFragment",
        "selections": v8 /*: any*/ ,
        "type": "CcpInvoiceGroup"
    }, v10 = {
        "kind": "ScalarField",
        "name": "key"
    }, v11 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "CcpOfferingTrial",
                "kind": "LinkedField",
                "name": "trial",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lengthDays"
                    }
                ]
            }
        ],
        "type": "CcpOffering"
    }, v13 = {
        "kind": "ScalarField",
        "name": "status"
    }, v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "trialButtonJiraEditionAwarenessQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "isTrialCountdownFgExpEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "offering",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isInGracePeriodFixFgEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "preDunning",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "entitlement(where:{\"AND\":[{\"inTrialOrPreDunning\":true}]})"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "trialButtonJiraEditionAwarenessQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                {
                                    "args": v6 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v8 /*: any*/ ,
                                                    "type": "CcpSubscription"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v8 /*: any*/ ,
                                                    "type": "CcpTransactionAccount"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isTrialCountdownFgExpEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "offering",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v8 /*: any*/ ,
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isInGracePeriodFixFgEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "preDunning",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "storageKey": "entitlement(where:{\"AND\":[{\"inTrialOrPreDunning\":true}]})"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2753e00bae59e3ce31da8be67a8707519147394821c376e30cd60c5f2f7cf5b7",
            "metadata": {},
            "name": "trialButtonJiraEditionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fa76c64201abbdc3$var$node.hash = "dc0b5366e028422220b8a574e3c6b641";
var $fa76c64201abbdc3$export$2e2bcd8739ae039 = $fa76c64201abbdc3$var$node;

});


parcelRegister("fKZAU", function(module, exports) {

$parcel$export(module.exports, "getBillingInformationGraphql", () => $e0e609b1459fd4e4$export$719aff12724d0b22);

var $ltbFE = parcelRequire("ltbFE");

var $eiowN = parcelRequire("eiowN");

var $4R6GH = parcelRequire("4R6GH");

const $e0e609b1459fd4e4$export$62297b13309008b2 = (0, $ltbFE.default);
const $e0e609b1459fd4e4$export$719aff12724d0b22 = async (cloudId, productKey, relayEnvironment)=>{
    // The product key as used by Commerce.
    // JPD product key as used by Commerce does not include .ondemand
    const commerceProductKey = productKey === (0, $c06e1abca7c13910$export$202f50ee62667e32) ? productKey : `${productKey}.ondemand`;
    const response = await (0, $eiowN.fetchQuery)(relayEnvironment, $e0e609b1459fd4e4$export$62297b13309008b2, {
        cloudId: cloudId,
        productKey: commerceProductKey,
        isTrialCountdownFgExpEnabled: (0, $4R6GH.fg)('jira_edition_awareness_trial_countdown_gate'),
        isInGracePeriodFixFgEnabled: (0, $4R6GH.fg)('jira_edition_awareness_isgraceperiod_check_fix')
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const entitlementInfo = response?.tenantContexts && response.tenantContexts.length > 0 ? response.tenantContexts[0]?.entitlementInfo : undefined;
    const entitlement = entitlementInfo?.entitlement;
    const subscription = entitlement?.subscription;
    const invoiceGroup = subscription?.accountDetails?.invoiceGroup;
    const pricingPlan = subscription?.pricingPlan;
    const transactionAccount = entitlement?.transactionAccount;
    const offering = entitlement?.offering;
    return {
        notInTrialOrPredunning: entitlement === null,
        invoiceable: invoiceGroup?.invoiceable ?? null,
        transactionAccountId: transactionAccount?.key ?? null,
        invoiceGroupId: invoiceGroup?.id ?? null,
        isBillingAdmin: transactionAccount?.isCurrentUserBillingAdmin ?? null,
        partnerManaged: transactionAccount?.isManagedByPartner ?? null,
        billingInterval: pricingPlan?.primaryCycle?.interval ?? null,
        pricingPlanType: pricingPlan?.type ?? null,
        overriddenEdition: entitlement?.overriddenEdition ?? null,
        trialLengthDays: offering?.trial?.lengthDays ?? null,
        preDunningStatus: entitlement?.preDunning?.status ?? null,
        rawResponse: response
    };
};

});
parcelRegister("ltbFE", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e95e63bf2bebacd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8a3f51c153d3b7fe998180764934a6f2>>
 * @relayHash 73e0bb7569fcd9f92e71b0f85aff9096
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a26d4e935e9be681e324f39c22c1a9aa997f113864a513e7dc2e3475f12570e7
const $1e95e63bf2bebacd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isInGracePeriodFixFgEnabled"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTrialCountdownFgExpEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productKey"
    }, v4 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v6 = [
        {
            "kind": "Literal",
            "name": "where",
            "value": {
                "AND": [
                    {
                        "inTrialOrPreDunning": true
                    }
                ]
            }
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = {
        "kind": "InlineFragment",
        "selections": v9 /*: any*/ ,
        "type": "CcpInvoiceGroup"
    }, v11 = {
        "kind": "ScalarField",
        "name": "interval"
    }, v12 = {
        "kind": "ScalarField",
        "name": "type"
    }, v13 = {
        "kind": "ScalarField",
        "name": "key"
    }, v14 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v15 = {
        "kind": "ScalarField",
        "name": "isManagedByPartner"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "overriddenEdition"
            }
        ],
        "type": "HamsEntitlement"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "CcpOfferingTrial",
                "kind": "LinkedField",
                "name": "trial",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lengthDays"
                    }
                ]
            }
        ],
        "type": "CcpOffering"
    }, v18 = {
        "kind": "ScalarField",
        "name": "status"
    }, v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": v9 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "commerceSharedApiEditionAwarenessTrialQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v7 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "tenantContexts.entitlementInfo.entitlement.subscription.accountDetails.invoiceGroup.invoiceable"
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "pricingPlan",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "primaryCycle",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v11 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "tenantContexts.entitlementInfo.entitlement.subscription.pricingPlan.primaryCycle.interval"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v12 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "tenantContexts.entitlementInfo.entitlement.subscription.pricingPlan.type"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v13 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "tenantContexts.entitlementInfo.entitlement.transactionAccount.key"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v14 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "tenantContexts.entitlementInfo.entitlement.transactionAccount.isCurrentUserBillingAdmin"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v15 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "tenantContexts.entitlementInfo.entitlement.transactionAccount.isManagedByPartner"
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        {
                                            "condition": "isTrialCountdownFgExpEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "offering",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isInGracePeriodFixFgEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "preDunning",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "entitlement(where:{\"AND\":[{\"inTrialOrPreDunning\":true}]})"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "commerceSharedApiEditionAwarenessTrialQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v19 /*: any*/ ,
                                {
                                    "args": v6 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "pricingPlan",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "primaryCycle",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v11 /*: any*/ 
                                                            ]
                                                        },
                                                        v12 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v9 /*: any*/ ,
                                                    "type": "CcpSubscription"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v9 /*: any*/ ,
                                                    "type": "CcpTransactionAccount"
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        {
                                            "condition": "isTrialCountdownFgExpEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "offering",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isInGracePeriodFixFgEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "preDunning",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "storageKey": "entitlement(where:{\"AND\":[{\"inTrialOrPreDunning\":true}]})"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a26d4e935e9be681e324f39c22c1a9aa997f113864a513e7dc2e3475f12570e7",
            "metadata": {},
            "name": "commerceSharedApiEditionAwarenessTrialQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1e95e63bf2bebacd$var$node.hash = "7edf1870581993241b5e20b9206e30e3";
var $1e95e63bf2bebacd$export$2e2bcd8739ae039 = $1e95e63bf2bebacd$var$node;

});



parcelRegister("jasTs", function(module, exports) {

$parcel$export(module.exports, "TrialPillButton", () => $59e268577d5e3e0c$export$19063b5b00c8046c);

var $5uXOq = parcelRequire("5uXOq");

var $2VHHh = parcelRequire("2VHHh");

var $Pxnvj = parcelRequire("Pxnvj");

var $5KCCi = parcelRequire("5KCCi");

var $lrpci = parcelRequire("lrpci");

var $2vSU6 = parcelRequire("2vSU6");

var $hLQN7 = parcelRequire("hLQN7");

var $4du81 = parcelRequire("4du81");

var $5Q4f1 = parcelRequire("5Q4f1");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");

var $2KAtx = parcelRequire("2KAtx");

var $aIlMT = parcelRequire("aIlMT");

var $cIObI = parcelRequire("cIObI");

var $dRVix = parcelRequire("dRVix");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $cNd4s = parcelRequire("cNd4s");

var $DVljb = parcelRequire("DVljb");

var $1fNl5 = parcelRequire("1fNl5");

var $eb7dL = parcelRequire("eb7dL");

var $8qT8y = parcelRequire("8qT8y");
const $59e268577d5e3e0c$var$TrialButtonText = ({ inGracePeriod: inGracePeriod, trialDaysLeft: trialDaysLeft, edition: edition, trialCountdownExperimentEnabled: trialCountdownExperimentEnabled, trialLengthDays: trialLengthDays })=>{
    if (inGracePeriod) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        id: "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.add-payment-details-sentence-case",
        defaultMessage: "Add payment details"
    });
    // Trial Countdown Experiment
    // If trial is still in its first half, show trial message instead of trial days left
    const shouldShowTrialMessage = trialCountdownExperimentEnabled && !!trialDaysLeft && !!trialLengthDays && trialDaysLeft > Math.ceil(trialLengthDays / 2);
    if (shouldShowTrialMessage) {
        if (edition === (0, $ldyPw.PREMIUM_EDITION)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            id: "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.premium-trial",
            defaultMessage: "Premium trial"
        });
        if (edition === (0, $ldyPw.STANDARD_EDITION)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            id: "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.standard-trial",
            defaultMessage: "Standard trial"
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        id: "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.days-left-button",
        defaultMessage: "{trialDaysLeft, plural, one {# day} other {# days}} left",
        values: {
            trialDaysLeft: trialDaysLeft
        }
    });
};
const $59e268577d5e3e0c$var$TooltipText = ({ showAddPaymentDetails: showAddPaymentDetails })=>{
    return showAddPaymentDetails ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        id: "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.add-payment-details-tooltip",
        defaultMessage: "Add payment details to keep your subscription"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        id: "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.trial-button-tooltip",
        defaultMessage: "More about your trial and how to pay"
    });
};
const $59e268577d5e3e0c$var$TrialPillButtonInner = ({ productKey: productKey, projectType: projectType, edition: edition, entitlementDetails: entitlementDetails, invoiceGroupId: invoiceGroupId, transactionAccountId: transactionAccountId, isBillingAdmin: isBillingAdmin, trialLengthDays: trialLengthDays, preDunningStatus: preDunningStatus })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const locale = (0, $DVljb.useLocale)();
    const environment = (0, $2tT7R.useEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { trialEndTime: trialEndTime, billingSourceSystem: billingSourceSystem } = entitlementDetails;
    const atlOrigin = (0, $5uXOq.useMemo)(()=>new (0, $2VHHh.default)({
            product: 'jira'
        }), []);
    const currentDate = (0, $5uXOq.useMemo)(()=>Date.now(), []);
    const trialDaysLeft = (0, $dRVix.getTrialDaysLeft)(currentDate, trialEndTime);
    const inGracePeriod = (0, $4R6GH.fg)('jira_edition_awareness_isgraceperiod_check_fix') ? preDunningStatus === 'IN_PRE_DUNNING' : (0, $dRVix.isInGracePeriod)(currentDate, trialEndTime);
    const isEnglishLocale = locale.startsWith('en');
    const isJswStandard = productKey === 'jira-software' && edition === (0, $ldyPw.STANDARD_EDITION);
    // User sees JSTO if they are a billing and site admin, and in a JSW standard trial that is not in grace period
    const jstoTarget = !!isBillingAdmin && isSiteAdmin && isJswStandard && !inGracePeriod;
    const shouldShowJsmJpdTrialAwarenessModalV2 = (0, $cIObI.isEligibleForJsmJpdTrialAwarenessV2)(projectType);
    const rawJstoUrl = `${(0, $4du81.WAC_URL)[environment]}/software/jira?ref=edition_awareness_standard_trial_${billingSourceSystem.toLowerCase()}&cloudSiteId=${cloudId}`;
    const jstoUrl = (0, $dRVix.useLoggedInPage)({
        pageUrl: rawJstoUrl
    });
    const addBillingDetailsUrl = billingSourceSystem === 'CCP' ? `${(0, $5Q4f1.getAdminBaseUrl)()}/billing/${transactionAccountId}/${invoiceGroupId}/payment-flow?referrer=${(0, $eb7dL.productAbbreviations)[productKey]}` : `${(0, $5Q4f1.getAdminBaseUrl)()}/s/${cloudId}/billing/paymentdetails/add`;
    // Trial Countdown (TC) Experiment
    const [trialCountdownExperimentConfig, fireTrialCountdownExperimentExposure] = // eslint-disable-next-line jira/ff/unsafe-no-exposure
    (0, $6s1PB.UNSAFE_noExposureExp)('jira_edition_awareness_trial_countdown');
    // TC Statsig value
    const trialCountdownExperimentValue = trialCountdownExperimentConfig.get('isEnabled', undefined);
    // User is eligible for TC experiment if the FG is on, they are not in grace period, and are on CCP
    const isEligibleForTrialCountdownExperiment = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('jira_edition_awareness_trial_countdown_gate') && !inGracePeriod && !!trialDaysLeft && !!trialLengthDays && billingSourceSystem === 'CCP';
    // TC Experiment Features are enabled when they are eligible and in variation (isEnabled = true)
    const trialCountdownExperimentEnabled = isEligibleForTrialCountdownExperiment && trialCountdownExperimentValue;
    // Additional TC experiment analytics attributes for eligible users
    const trialCountdownExperimentAnalyticsAttributes = (0, $5uXOq.useMemo)(()=>isEligibleForTrialCountdownExperiment ? {
            trialCountdownExperimentEnabled: trialCountdownExperimentEnabled,
            trialLengthDays: trialLengthDays,
            trialDaysLeft: trialDaysLeft
        } : {}, [
        isEligibleForTrialCountdownExperiment,
        trialCountdownExperimentEnabled,
        trialLengthDays,
        trialDaysLeft
    ]);
    // Fires TC experiment exposure for eligible users
    (0, $5uXOq.useEffect)(()=>{
        if (isEligibleForTrialCountdownExperiment) fireTrialCountdownExperimentExposure();
    }, [
        fireTrialCountdownExperimentExposure,
        isEligibleForTrialCountdownExperiment
    ]);
    const { getIsEligibleForJsmPremiumPillExperiment: getIsEligibleForJsmPremiumPillExperiment } = (0, $hLQN7.useJsmPremiumPillExperiment)();
    const isJSMPremiumPillExperiment = getIsEligibleForJsmPremiumPillExperiment() && (0, $6s1PB.expValEquals)('jsm_premium_trial_pill_experiment', 'cohort', 'variation');
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>{
        const attributes = {
            edition: edition,
            productKey: productKey,
            projectType: projectType,
            isEnglishLocale: isEnglishLocale,
            entitlementDetails: entitlementDetails,
            transactionAccountId: transactionAccountId,
            invoiceGroupId: invoiceGroupId,
            isBillingAdmin: isBillingAdmin,
            ...trialCountdownExperimentAnalyticsAttributes
        };
        return attributes;
    }, [
        edition,
        entitlementDetails,
        invoiceGroupId,
        isEnglishLocale,
        productKey,
        projectType,
        transactionAccountId,
        isBillingAdmin,
        trialCountdownExperimentAnalyticsAttributes
    ]);
    const getUrl = ()=>{
        if (jstoTarget) return atlOrigin.addToUrl(jstoUrl);
        if (inGracePeriod) return atlOrigin.addToUrl(addBillingDetailsUrl);
        return undefined;
    };
    const url = getUrl();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const target = jstoTarget ? 'JSTO' : 'BillingScreen';
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'editionAwarenessTrialPill', {
            ...analyticsAttributes,
            ...jstoTarget || inGracePeriod ? {
                target: target,
                ...atlOrigin.toAnalyticsAttributes({
                    hasGeneratedId: true
                })
            } : {},
            ...shouldShowJsmJpdTrialAwarenessModalV2 ? {
                jsmJpdTrialAwarenessModalV2: {
                    shouldShowJsmJpdTrialAwarenessModalV2: shouldShowJsmJpdTrialAwarenessModalV2
                }
            } : {}
        });
    }, [
        inGracePeriod,
        createAnalyticsEvent,
        jstoTarget,
        analyticsAttributes,
        atlOrigin,
        shouldShowJsmJpdTrialAwarenessModalV2
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'button'
        }), 'editionAwarenessTrialPill', {
            ...analyticsAttributes,
            isSiteAdmin: isSiteAdmin
        });
    }, [
        analyticsAttributes,
        createAnalyticsEvent,
        isSiteAdmin
    ]);
    const trialModalEntryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            productKey: productKey,
            jiraProjectType: (0, $2vSU6.convertToJiraProjectType)(projectType),
            jiraApplicationKey: (0, $efvDm.getApplicationKeyForProject)(projectType)
        }), [
        cloudId,
        productKey,
        projectType
    ]);
    const trialModalEntryPointProps = (0, $5uXOq.useMemo)(()=>({
            projectType: projectType,
            edition: edition
        }), [
        projectType,
        edition
    ]);
    // Trial Countdown Experiment
    // If trial is 3 days or less, swap the button to the warning state
    const shouldShowWarningStatus = trialCountdownExperimentEnabled && trialDaysLeft <= 3;
    const buttonStatus = shouldShowWarningStatus ? 'warning' : 'default';
    if (isJSMPremiumPillExperiment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8qT8y.Dropdown), {
        applicationEdition: (0, $ldyPw.PREMIUM_EDITION),
        productKey: productKey,
        analyticsAttributes: analyticsAttributes,
        trialEndTime: trialEndTime
    }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lrpci.EditionAwarenessButton), {
            ...triggerProps.triggerProps,
            onClick: (...args)=>{
                onClick();
                triggerProps.onClick && triggerProps.onClick(...args);
            },
            ref: triggerProps.ref,
            status: buttonStatus,
            upgradeIconType: "gem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59e268577d5e3e0c$var$TrialButtonText, {
            inGracePeriod: inGracePeriod,
            trialDaysLeft: trialDaysLeft,
            edition: edition,
            trialCountdownExperimentEnabled: trialCountdownExperimentEnabled,
            trialLengthDays: trialLengthDays
        })));
    const shouldShowLinkButton = url !== undefined;
    if (shouldShowLinkButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59e268577d5e3e0c$var$TooltipText, {
            showAddPaymentDetails: inGracePeriod
        }),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lrpci.EditionAwarenessLinkButton), {
            ...tooltipProps,
            onClick: onClick,
            href: url,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: tooltipProps.ref,
            status: buttonStatus,
            ...inGracePeriod ? {
                icon: 'missing-payment-details'
            } : {
                upgradeIconType: 'gem'
            },
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59e268577d5e3e0c$var$TrialButtonText, {
            inGracePeriod: inGracePeriod,
            trialDaysLeft: trialDaysLeft,
            edition: edition,
            trialCountdownExperimentEnabled: trialCountdownExperimentEnabled,
            trialLengthDays: trialLengthDays
        })));
    if (shouldShowJsmJpdTrialAwarenessModalV2) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $aIlMT.editionAwarenessTrialModalEntryPoint),
        entryPointParams: trialModalEntryPointParams,
        entryPointProps: trialModalEntryPointProps,
        interactionName: "edition-awareness-trial-modal",
        useInternalModal: false
    }, (modalProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lrpci.EditionAwarenessButton), {
            onClick: onClick,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: modalProps.ref,
            status: buttonStatus,
            upgradeIconType: "gem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59e268577d5e3e0c$var$TrialButtonText, {
            inGracePeriod: inGracePeriod,
            trialDaysLeft: trialDaysLeft,
            edition: edition,
            trialCountdownExperimentEnabled: trialCountdownExperimentEnabled,
            trialLengthDays: trialLengthDays
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1fNl5.BillingDetailsPopup), {
        analyticsAttributes: analyticsAttributes,
        edition: edition,
        addBillingDetailsUrl: addBillingDetailsUrl,
        billingSourceSystem: billingSourceSystem
    }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lrpci.EditionAwarenessButton), {
            ...triggerProps.triggerProps,
            onClick: (...args)=>{
                onClick();
                triggerProps.onClick && triggerProps.onClick(...args);
            },
            status: buttonStatus,
            upgradeIconType: "gem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59e268577d5e3e0c$var$TrialButtonText, {
            inGracePeriod: inGracePeriod,
            trialDaysLeft: trialDaysLeft,
            edition: edition,
            trialCountdownExperimentEnabled: trialCountdownExperimentEnabled,
            trialLengthDays: trialLengthDays
        })));
};
const $59e268577d5e3e0c$export$19063b5b00c8046c = (props)=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { isBillingAdmin: isBillingAdmin } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isSiteAdmin: isSiteAdmin,
            isBillingAdmin: isBillingAdmin
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
        name: "edition-awareness-trial-pill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($59e268577d5e3e0c$var$TrialPillButtonInner, props)));
};

});
parcelRegister("4du81", function(module, exports) {

$parcel$export(module.exports, "WAC_URL", () => $fc5bec1ad49de5dc$export$5e8c8041aa206ba5);
const $fc5bec1ad49de5dc$export$5e8c8041aa206ba5 = {
    prod: 'https://www.atlassian.com',
    dev: 'https://wac.stg.internal.atlassian.com',
    local: 'https://wac.stg.internal.atlassian.com',
    staging: 'https://wac.stg.internal.atlassian.com'
};

});

parcelRegister("aIlMT", function(module, exports) {

$parcel$export(module.exports, "editionAwarenessTrialModalEntryPoint", () => $c80dd7db540444a3$export$de2f955c8fd39788);

var $6DUTU = parcelRequire("6DUTU");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $c80dd7db540444a3$export$de2f955c8fd39788 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("efm1x")), {
        moduleId: "3928dd3c"
    }),
    // @ts-expect-error - JiraApplicationKey in AGG schema does not support CUSTOMER_SERVICE
    getPreloadProps: ({ cloudId: cloudId, productKey: productKey, jiraProjectType: jiraProjectType, jiraApplicationKey: jiraApplicationKey })=>({
            extraProps: {
                productKey: productKey
            },
            entryPoints: {},
            queries: {
                editionAwarenessTrialModalQueryRef: {
                    parameters: (0, $6DUTU.default),
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: productKey,
                        projectType: jiraProjectType,
                        jiraApplicationKey: jiraApplicationKey
                    }
                }
            }
        })
});

});
parcelRegister("6DUTU", function(module, exports) {

$parcel$export(module.exports, "default", () => $935ec38654561fdb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<45ee832797c03b8798f69beb928ca933>>
 * @relayHash f8669320f615468380f6b7329bb72c76
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6546241374c7e5f338745b6f42592108f946e14ec69934c2a80661773984a24e
const $935ec38654561fdb$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6546241374c7e5f338745b6f42592108f946e14ec69934c2a80661773984a24e",
        "metadata": {},
        "name": "main_EditionAwarenessTrialModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $935ec38654561fdb$export$2e2bcd8739ae039 = $935ec38654561fdb$var$node;

});

parcelRegister("efm1x", function(module, exports) {

let $a5f38ce1efc57933$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a5f38ce1efc57933$var$load("iTtmS").then(()=>parcelRequire('knOvt'));

});


parcelRegister("cIObI", function(module, exports) {

$parcel$export(module.exports, "fireButtonAnalytics", () => $cbdf4524f0c3a34f$export$ac665b9f9662b94a);
$parcel$export(module.exports, "isSupportedProjectType", () => $cbdf4524f0c3a34f$export$fa630a47d84fb39a);
$parcel$export(module.exports, "isEligibleForJsmJpdTrialAwarenessV2", () => $cbdf4524f0c3a34f$export$e4cf86ec01cea940);
$parcel$export(module.exports, "projectTypeToApplicationKey", () => $cbdf4524f0c3a34f$export$83de85c996456cf6);
$parcel$export(module.exports, "getApplicationName", () => $cbdf4524f0c3a34f$export$e248db7c9a3cd59);
$parcel$export(module.exports, "getProductReferrerKey", () => $cbdf4524f0c3a34f$export$b4fb3304d5d8fc5f);

var $2vSU6 = parcelRequire("2vSU6");

var $8zOmE = parcelRequire("8zOmE");

const $cbdf4524f0c3a34f$export$37f449592e04a567 = [
    (0, $2vSU6.SERVICE_DESK_PROJECT),
    (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)
];
const $cbdf4524f0c3a34f$export$ac665b9f9662b94a = (createAnalyticsEvent, actionSubjectId, attributes)=>{
    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    }), actionSubjectId, {
        ...attributes
    });
};
const $cbdf4524f0c3a34f$export$fa630a47d84fb39a = (value)=>{
    const projectType = (0, $2vSU6.toProjectType)(value);
    return !!projectType && $cbdf4524f0c3a34f$export$37f449592e04a567.includes(projectType);
};
const $cbdf4524f0c3a34f$export$e4cf86ec01cea940 = (projectType)=>(0, $2vSU6.toProjectType)(projectType) === (0, $2vSU6.SERVICE_DESK_PROJECT) || (0, $2vSU6.toProjectType)(projectType) === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT);
const $cbdf4524f0c3a34f$export$83de85c996456cf6 = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
        case 0, $2vSU6.CORE_PROJECT:
            return 0, $c06e1abca7c13910$export$db515c8cec1e6f79;
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return 0, $c06e1abca7c13910$export$202f50ee62667e32;
        default:
            return 0, $c06e1abca7c13910$export$db515c8cec1e6f79;
    }
};
const $cbdf4524f0c3a34f$var$JIRA_SERVICE_MANAGEMENT_APP_NAME = 'Jira Service Management';
const $cbdf4524f0c3a34f$var$JIRA_PRODUCT_DISCOVERY_APP_NAME = 'Jira Product Discovery';
const $cbdf4524f0c3a34f$export$e248db7c9a3cd59 = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return 'Jira';
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $cbdf4524f0c3a34f$var$JIRA_SERVICE_MANAGEMENT_APP_NAME;
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return $cbdf4524f0c3a34f$var$JIRA_PRODUCT_DISCOVERY_APP_NAME;
        default:
            throw new Error(`Unknown project type: ${projectType}`);
    }
};
const $cbdf4524f0c3a34f$export$b4fb3304d5d8fc5f = (projectType)=>{
    if (projectType === (0, $2vSU6.SOFTWARE_PROJECT)) return 'jsw';
    if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) return 'jsm';
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return 'jpd';
    if (projectType === (0, $2vSU6.CORE_PROJECT)) return 'jwm';
    return null;
};

});

parcelRegister("1fNl5", function(module, exports) {

$parcel$export(module.exports, "BillingDetailsPopup", () => $662b99a3c507e81e$export$9ba9c2a8da5fd7c5);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2VHHh = parcelRequire("2VHHh");

var $cNW3X = parcelRequire("cNW3X");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $eaVnq = parcelRequire("eaVnq");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $70Wxp = parcelRequire("70Wxp");

var $e2N0p = parcelRequire("e2N0p");

var $eydIU = parcelRequire("eydIU");

var $ldyPw = parcelRequire("ldyPw");


var $61Rd1 = parcelRequire("61Rd1");
const $662b99a3c507e81e$var$ReverseTrialExperimentErrorBoundary = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $af6ccefcb1f83341$export$f19f2573d2fc7010),
        packageName: (0, $af6ccefcb1f83341$export$b8b9d90f9e5bd72b),
        fallback: "unmount",
        teamName: "growth-tako"
    }, children);
const $662b99a3c507e81e$var$PopupInner = ({ url: url, defaultPopupInner: defaultPopupInner, onFireUiAnalyticsEvent: onFireUiAnalyticsEvent })=>{
    const { premiumTrialOnSignup: premiumTrialOnSignup, isReady: isReady } = (0, $70Wxp.useFetchOnboardingReverseTrial)();
    if (!isReady) return null;
    if (isReady && premiumTrialOnSignup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eydIU.ReverseTrialExperimentPopupContent), {
        billingPageUrl: url,
        onFireUiAnalyticsEvent: onFireUiAnalyticsEvent
    });
    return defaultPopupInner;
};
const $662b99a3c507e81e$var$ReverseTrialExperimentForceOpen = ({ onPopupToggle: onPopupToggle })=>{
    const { premiumTrialOnSignup: premiumTrialOnSignup } = (0, $70Wxp.useFetchOnboardingReverseTrial)();
    (0, $e2N0p.useForceOpenPremiumPopupOnDay3)({
        shouldRun: premiumTrialOnSignup,
        onPopupToggle: onPopupToggle
    });
    return null;
};
const $662b99a3c507e81e$var$PopupBackground = ({ defaultBackground: defaultBackground })=>{
    const { premiumTrialOnSignup: premiumTrialOnSignup, isReady: isReady } = (0, $70Wxp.useFetchOnboardingReverseTrial)();
    if (!isReady || premiumTrialOnSignup) return null;
    return defaultBackground;
};
const $662b99a3c507e81e$export$9ba9c2a8da5fd7c5 = ({ initialOpenState: initialOpenState = false, edition: edition, addBillingDetailsUrl: addBillingDetailsUrl, analyticsAttributes: analyticsAttributes, children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(initialOpenState);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { premiumTrialOnSignup: premiumTrialOnSignup, isReady: isReady } = (0, $70Wxp.useFetchOnboardingReverseTrial)();
    const popupTitle = formatMessage(edition === (0, $ldyPw.STANDARD_EDITION) ? (0, $61Rd1.default).addPaymentDetailsPopupStandardTitle : (0, $61Rd1.default).addPaymentDetailsPopupPremiumTitle);
    const popupContent = formatMessage(edition === (0, $ldyPw.STANDARD_EDITION) ? (0, $61Rd1.default).addPaymentDetailsPopupStandardContent : (0, $61Rd1.default).addPaymentDetailsPopupPremiumContent);
    const atlOrigin = (0, $5uXOq.useMemo)(()=>new (0, $2VHHh.default)({
            product: 'jira'
        }), []);
    const url = atlOrigin.addToUrl(addBillingDetailsUrl);
    const fireUIAnalyticsEvent = (0, $5uXOq.useCallback)((action, actionSubject, actionSubjectId, attributes = {})=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        }), actionSubjectId, {
            ...analyticsAttributes,
            ...attributes
        });
    }, [
        analyticsAttributes,
        createAnalyticsEvent
    ]);
    const onClickButton = (0, $5uXOq.useCallback)(()=>{
        fireUIAnalyticsEvent('clicked', 'button', 'paymentDetailsPopupItem', {
            ...atlOrigin.toAnalyticsAttributes({
                hasGeneratedId: true
            })
        });
        setIsOpen(false);
    }, [
        atlOrigin,
        fireUIAnalyticsEvent
    ]);
    const onPopupToggle = (0, $5uXOq.useCallback)(// autoOpened is temporary for monitoring jsw_reverse_trials_feature_gate
    (show, autoOpened)=>{
        fireUIAnalyticsEvent('toggled', 'popup', 'editionAwarenessTrialPillPopup', {
            show: show,
            ...autoOpened !== undefined && {
                autoOpened: autoOpened
            }
        });
        setIsOpen(show);
    }, [
        fireUIAnalyticsEvent
    ]);
    const onTriggerClick = (0, $5uXOq.useCallback)(()=>{
        onPopupToggle(!isOpen);
    }, [
        onPopupToggle,
        isOpen
    ]);
    const getPopupPlacement = ()=>{
        if (isReady && premiumTrialOnSignup) return 'bottom-end';
        return 'bottom-start';
    };
    const defaultPopupInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "h3",
        xcss: $662b99a3c507e81e$var$popupHeadingStyles
    }, popupTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "p",
        xcss: $662b99a3c507e81e$var$popupContentStyles
    }, popupContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "primary",
        href: url,
        target: "_blank",
        onClick: onClickButton
    }, formatMessage((0, $61Rd1.default).addPaymentDetailsPopupButton)));
    const defaultBackground = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($662b99a3c507e81e$var$Background, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaVnq.default), {
        alt: "premium-trial-banner"
    }));
    const adjustAnalyticsAttributes = ()=>{
        // Checking for undefined specifically because if the user is not targeted, the value will be undefined
        if (isReady && premiumTrialOnSignup !== undefined) return {
            ...analyticsAttributes,
            isPremiumTrialOnSignup: premiumTrialOnSignup
        };
        return analyticsAttributes;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $4R6GH.fg)('jsw_reverse_trials_feature_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($662b99a3c507e81e$var$ReverseTrialExperimentErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($662b99a3c507e81e$var$ReverseTrialExperimentForceOpen, {
        onPopupToggle: onPopupToggle
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        messageId: "navigation-apps-sidebar-edition-awareness.ui.trial-pill.trial-pill-button.billing-details-popup.popup.jira-popup",
        messageType: "transactional",
        isOpen: isOpen,
        onClose: ()=>onPopupToggle(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                sourceName: "trialPillPopup",
                sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
                attributes: adjustAnalyticsAttributes()
            }), (0, $4R6GH.fg)('jsw_reverse_trials_feature_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($662b99a3c507e81e$var$ReverseTrialExperimentErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($662b99a3c507e81e$var$PopupBackground, {
                defaultBackground: defaultBackground
            })) : defaultBackground, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($662b99a3c507e81e$var$PopupWrapper, null, (0, $4R6GH.fg)('jsw_reverse_trials_feature_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($662b99a3c507e81e$var$ReverseTrialExperimentErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($662b99a3c507e81e$var$PopupInner, {
                url: url,
                defaultPopupInner: defaultPopupInner,
                onFireUiAnalyticsEvent: fireUIAnalyticsEvent
            })) : defaultPopupInner)),
        placement: getPopupPlacement(),
        trigger: (triggerProps)=>children({
                triggerProps: triggerProps,
                onClick: onTriggerClick
            })
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $662b99a3c507e81e$var$PopupWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1ogy _ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $662b99a3c507e81e$var$Background = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q71osb _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $662b99a3c507e81e$var$popupHeadingStyles = (0, $2s57o.xcss)({
    color: 'color.text',
    font: 'font.heading.medium'
});
const $662b99a3c507e81e$var$popupContentStyles = (0, $2s57o.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.150',
    color: 'color.text.subtle',
    font: 'font.body.small'
});

});
parcelRegister("eaVnq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5b1a8d0d5980476$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $10uhO = parcelRequire("10uhO");
const $f5b1a8d0d5980476$export$abdf1e325e38b834 = (0, (/*@__PURE__*/$parcel$interopDefault($10uhO)));
const $f5b1a8d0d5980476$export$87ec2877821a8f12 = (0, (/*@__PURE__*/$parcel$interopDefault($10uhO)));
const $f5b1a8d0d5980476$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: $f5b1a8d0d5980476$export$abdf1e325e38b834,
    srcDark: $f5b1a8d0d5980476$export$87ec2877821a8f12,
    autoDark: false
});
var $f5b1a8d0d5980476$export$2e2bcd8739ae039 = $f5b1a8d0d5980476$var$Illustration;
// for advanced use only
const $f5b1a8d0d5980476$export$a179c88182cb9d56 = [
    0,
    0,
    241,
    107
];

});
parcelRegister("10uhO", function(module, exports) {
module.exports = new URL("premium-trial.bdfe4386.svg", import.meta.url).toString();

});


parcelRegister("70Wxp", function(module, exports) {

$parcel$export(module.exports, "useFetchOnboardingReverseTrial", () => $5ec4a2aef6f6d0e2$export$349fbee95cd03b58);

var $5uXOq = parcelRequire("5uXOq");

var $AK64q = parcelRequire("AK64q");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $gh567 = parcelRequire("gh567");

var $7aHUB = parcelRequire("7aHUB");
const $5ec4a2aef6f6d0e2$var$store = (0, $iXqE5.createStore)({
    name: 'jsw-onboarding-reverse-trial',
    initialState: (0, $AK64q.initialCachedEndpointState),
    actions: $7aHUB.actions
});
const $5ec4a2aef6f6d0e2$export$6758b294795e1644 = (0, $3sQ5x.createHook)($5ec4a2aef6f6d0e2$var$store);
const $5ec4a2aef6f6d0e2$export$349fbee95cd03b58 = ()=>{
    const isTargetedForReverseTrials = (0, $gh567.useIsTargetedForReverseTrials)();
    const [{ fetchedOnce: fetchedOnce, isFetching: isFetching, data: data }, { getPremiumTrialOnSignup: getPremiumTrialOnSignup }] = $5ec4a2aef6f6d0e2$export$6758b294795e1644();
    (0, $5uXOq.useEffect)(()=>{
        if (isTargetedForReverseTrials && !fetchedOnce && !isFetching && data === undefined) // @ts-expect-error Arguments for the rest parameter 'args' were not provided.
        getPremiumTrialOnSignup();
    }, [
        data,
        fetchedOnce,
        getPremiumTrialOnSignup,
        isFetching,
        isTargetedForReverseTrials
    ]);
    if (!isTargetedForReverseTrials) // If not targeted, no fetching is done. Data is ready to be read
    return {
        premiumTrialOnSignup: undefined,
        reverseTrialCohort: data?.reverseTrialCohort,
        isReady: true
    };
    return {
        premiumTrialOnSignup: data?.premiumTrialOnSignup,
        reverseTrialCohort: data?.reverseTrialCohort,
        isReady: fetchedOnce && !isFetching
    };
};

});
parcelRegister("AK64q", function(module, exports) {

$parcel$export(module.exports, "initialCachedEndpointState", () => $e18633c22e50182e$export$aaed2d023c5dc2c);
const $e18633c22e50182e$export$aaed2d023c5dc2c = {
    isFetching: false,
    wasFetched: false,
    fetchedOnce: false,
    fetchError: null
};

});

parcelRegister("gh567", function(module, exports) {

$parcel$export(module.exports, "useIsTargetedForReverseTrials", () => $b8cd58920d764600$export$897219a3ca9649b9);

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $dAfqg = parcelRequire("dAfqg");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");
const $b8cd58920d764600$export$897219a3ca9649b9 = ()=>{
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const jswEdition = (0, $k9JTq.useAppEditions)().software;
    if ((0, $4R6GH.fg)('jsw_reverse_trials_feature_gate')) {
        const isCurrentProjectJSW = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
        if (jswEdition === (0, $ldyPw.PREMIUM_EDITION) && isCurrentProjectJSW) return true;
        return false;
    }
    return false;
};

});

parcelRegister("7aHUB", function(module, exports) {

$parcel$export(module.exports, "actions", () => $9bc9ce12e98e96a1$export$e324594224ef24da);

var $7bRcT = parcelRequire("7bRcT");

var $bfWlw = parcelRequire("bfWlw");
const $9bc9ce12e98e96a1$var$getPremiumTrialOnSignup = (0, $7bRcT.cachedEndpointCall)((0, $bfWlw.getOnboardingPremiumTrialWithRethrow));
const $9bc9ce12e98e96a1$export$e324594224ef24da = {
    getPremiumTrialOnSignup: $9bc9ce12e98e96a1$var$getPremiumTrialOnSignup
};

});
parcelRegister("7bRcT", function(module, exports) {

$parcel$export(module.exports, "cachedEndpointCall", () => $69bbbca5d7164078$export$9ab04ab45a9b99da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $69bbbca5d7164078$export$9ab04ab45a9b99da = (call)=>(params)=>async ({ getState: getState, setState: setState })=>{
            const { isFetching: isFetching, wasFetched: wasFetched, fetchedOnce: fetchedOnce } = getState();
            if (isFetching || wasFetched) return;
            setState({
                isFetching: true
            });
            try {
                const data = await call(params);
                if (data !== null) setState({
                    data: data,
                    wasFetched: true
                });
                else setState({
                    wasFetched: fetchedOnce
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    fetchError: error
                });
            } finally{
                setState({
                    isFetching: false,
                    fetchedOnce: true
                });
            }
        };

});



parcelRegister("e2N0p", function(module, exports) {

$parcel$export(module.exports, "useForceOpenPremiumPopupOnDay3", () => $02b1ccb7eeb6fc53$export$6cc86e1de6373a57);

var $5uXOq = parcelRequire("5uXOq");


var $9yQlD = parcelRequire("9yQlD");

var $6s1PB = parcelRequire("6s1PB");
const $02b1ccb7eeb6fc53$export$6cc86e1de6373a57 = ({ shouldRun: shouldRun, onPopupToggle: onPopupToggle })=>{
    (0, $5uXOq.useEffect)(()=>{
        if (shouldRun) {
            const onboardingStartedTimestamp = Number((0, $9yQlD.localStorageProvider).get((0, $6784cbc7d62e5d7c$export$69fe8832c4f79a32)));
            if (onboardingStartedTimestamp) {
                const threeDays = 259200000;
                // If the user has onboarded 3 or more days ago, force open the premium popup
                if (Date.now() - onboardingStartedTimestamp > threeDays) {
                    if (!(0, $6s1PB.expValEquals)('jsw_ea_popover_open_vs_close', 'cohort', 'variation')) onPopupToggle(true, true);
                    (0, $9yQlD.localStorageProvider).remove((0, $6784cbc7d62e5d7c$export$69fe8832c4f79a32));
                }
            }
        }
    }, [
        shouldRun,
        onPopupToggle
    ]);
};

});

parcelRegister("eydIU", function(module, exports) {

$parcel$export(module.exports, "ReverseTrialExperimentPopupContent", () => $80d9c8248bf39770$export$2409664383bedc18);

var $5uXOq = parcelRequire("5uXOq");

var $bWfiu = parcelRequire("bWfiu");

var $7VIfr = parcelRequire("7VIfr");

var $hWGQo = parcelRequire("hWGQo");

var $acmVr = parcelRequire("acmVr");

var $0yZbT = parcelRequire("0yZbT");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $4i99S = parcelRequire("4i99S");

var $6s1PB = parcelRequire("6s1PB");

var $jOXuX = parcelRequire("jOXuX");

var $j5B5j = parcelRequire("j5B5j");

var $5OXJT = parcelRequire("5OXJT");

var $1VQfH = parcelRequire("1VQfH");
const $80d9c8248bf39770$export$2409664383bedc18 = ({ billingPageUrl: billingPageUrl, onFireUiAnalyticsEvent: onFireUiAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const openChecklist = (0, $4i99S.useOpenChecklist)();
    const [{ currentTaskGroupParent: currentTaskGroupParent }, { changeTaskGroupParent: changeTaskGroupParent, nextOpenTask: nextOpenTask }] = (0, $cE2Qr.useJswOnboarding)();
    const { isReady: isReady, isTailoredOnboardingM3EnabledAndEligible: isTailoredOnboardingM3EnabledAndEligible } = (0, $jOXuX.useIsTailoredOnboardingEnabledAndEligible)();
    const isHidePremiumFeatureMenuItem = isReady && (isTailoredOnboardingM3EnabledAndEligible || !isTailoredOnboardingM3EnabledAndEligible && (0, $6s1PB.expValEquals)('jira_rt_quickstart_m1', 'isEnabled', true));
    const onClickExplorePremiumFeatures = (0, $5uXOq.useCallback)(()=>{
        onFireUiAnalyticsEvent('clicked', 'button', 'trialPillExplorePremium');
        const taskGroupToEnter = (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK);
        if (currentTaskGroupParent !== taskGroupToEnter) changeTaskGroupParent(taskGroupToEnter);
        openChecklist({
            trigger: 'ReverseTrialPopup'
        });
        nextOpenTask((0, $8Bc5A.ADVANCED_ROADMAPS_TASK), {
            closeNudge: true
        });
    }, [
        onFireUiAnalyticsEvent,
        currentTaskGroupParent,
        openChecklist,
        nextOpenTask,
        changeTaskGroupParent
    ]);
    const onLinkClick = (0, $5uXOq.useCallback)((title)=>{
        onFireUiAnalyticsEvent('clicked', 'button', title);
    }, [
        onFireUiAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "small"
    }, formatMessage((0, $1VQfH.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        as: "ul",
        xcss: $80d9c8248bf39770$var$listContainerStyles,
        alignInline: "stretch"
    }, !isHidePremiumFeatureMenuItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5OXJT.ListItem), {
        title: formatMessage((0, $1VQfH.default).explorePremiumFeaturesLink),
        onClick: onClickExplorePremiumFeatures,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWGQo))), {
            label: "",
            LEGACY_size: "small"
        })
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5OXJT.ListItem), {
        title: formatMessage((0, $1VQfH.default).addPaymentDetailsLink),
        link: billingPageUrl,
        onClick: ()=>onLinkClick('trialPillAddPaymentDetails'),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7VIfr))), {
            label: "",
            LEGACY_size: "small"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j5B5j.ChangePlansUrlProvider), null, (changePlansUrl)=>changePlansUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5OXJT.ListItem), {
            title: formatMessage((0, $1VQfH.default).endTrialAndChangePlansLink),
            link: changePlansUrl,
            onClick: ()=>onLinkClick('trialPillChangePlans'),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acmVr))), {
                label: "",
                LEGACY_size: "small"
            })
        }) : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "p",
        xcss: $80d9c8248bf39770$var$downgradeTextStyles
    }, formatMessage((0, $1VQfH.default).afterTrial)));
};
const $80d9c8248bf39770$var$listContainerStyles = (0, $2s57o.xcss)({
    listStyle: 'none',
    marginTop: 'space.100',
    padding: 'space.0'
});
const $80d9c8248bf39770$var$downgradeTextStyles = (0, $2s57o.xcss)({
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle'
});

});
parcelRegister("j5B5j", function(module, exports) {

$parcel$export(module.exports, "ChangePlansUrlProvider", () => $1b260664017d263d$export$9ff771dc2e9e202f);

var $4Sf7d = parcelRequire("4Sf7d");

var $5uXOq = parcelRequire("5uXOq");

var $2VHHh = parcelRequire("2VHHh");

var $8Uumt = parcelRequire("8Uumt");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $lfTZh = parcelRequire("lfTZh");

var $koeKL = parcelRequire("koeKL");
const $1b260664017d263d$var$Query = (0, $4Sf7d.default);
const $1b260664017d263d$var$ChangePlansUrlProviderInner = ({ children: children, queryReference: queryReference })=>{
    const data = (0, $8Uumt.usePreloadedQuery)($1b260664017d263d$var$Query, queryReference);
    const changeOfferingCapability = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.experienceCapabilities?.changeOffering;
    const changeOfferingUrl = changeOfferingCapability?.experienceUrl;
    const origin = new (0, $2VHHh.default)({
        product: 'jira'
    });
    const changeOfferingUrlWithAtlOrigin = changeOfferingUrl ? origin.addToUrl(changeOfferingUrl) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children(changeOfferingUrlWithAtlOrigin));
};
const $1b260664017d263d$export$9ff771dc2e9e202f = ({ children: children })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)($1b260664017d263d$var$Query);
    (0, $5uXOq.useEffect)(()=>{
        if (queryReference === null) loadQuery({
            cloudId: cloudId,
            productKey: 'jira-software.ondemand',
            offeringKey: 'de2887c9-8a55-41d5-b5cf-ad6a5589ebed'
        });
    }, [
        cloudId,
        loadQuery,
        queryReference
    ]);
    if (!queryReference) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "reverse-trials-popup-change-plans",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            as: "li",
            xcss: $1b260664017d263d$var$skeletonStyles
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1b260664017d263d$var$ChangePlansUrlProviderInner, {
        queryReference: queryReference
    }, children));
};
const $1b260664017d263d$var$skeletonStyles = (0, $2s57o.xcss)({
    height: '20px',
    marginTop: 'space.0',
    backgroundColor: 'elevation.surface.hovered'
});

});
parcelRegister("4Sf7d", function(module, exports) {

$parcel$export(module.exports, "default", () => $05014b6f280d5660$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2e58941af1d1bdd65e58a2d14853219a>>
 * @relayHash 0f2fcd3025e057b4d4b8841160775500
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5cc154205f88b37c4f3711723d2c2d442e6c0cc8b52d51ac23970adce7e18d56
const $05014b6f280d5660$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offeringKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productKey"
    }, v3 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "offeringKey",
            "variableName": "offeringKey"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "changePlansUrlProviderQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOffering",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "changePlansUrlProviderQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOffering",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5cc154205f88b37c4f3711723d2c2d442e6c0cc8b52d51ac23970adce7e18d56",
            "metadata": {},
            "name": "changePlansUrlProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$05014b6f280d5660$var$node.hash = "1760b2a2f58cf86916d00a388c2bff98";
var $05014b6f280d5660$export$2e2bcd8739ae039 = $05014b6f280d5660$var$node;

});


parcelRegister("5OXJT", function(module, exports) {

$parcel$export(module.exports, "ListItem", () => $3ba212747341c36c$export$a7b06bfba60a8a78);

var $5uXOq = parcelRequire("5uXOq");

var $1nSOt = parcelRequire("1nSOt");

var $2Do6f = parcelRequire("2Do6f");

var $6P0Kj = parcelRequire("6P0Kj");

var $gHU1R = parcelRequire("gHU1R");
var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $2GZKW = parcelRequire("2GZKW");
var $2s57o = parcelRequire("2s57o");
const $3ba212747341c36c$var$ListItemContent = ({ title: title, icon: icon, hasLink: hasLink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2GZKW.default), {
        templateColumns: "16px 1fr 16px",
        columnGap: "space.200",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, hasLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6P0Kj))), {
        label: "",
        LEGACY_size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Do6f))), {
        label: "",
        LEGACY_size: "small"
    })));
const $3ba212747341c36c$export$a7b06bfba60a8a78 = ({ title: title, link: link, icon: icon, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        as: "li",
        xcss: $3ba212747341c36c$var$listItemStyles,
        direction: "column"
    }, link ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gHU1R.default), {
        href: link,
        target: "_blank",
        xcss: $3ba212747341c36c$var$linkStyles,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ba212747341c36c$var$ListItemContent, {
        title: title,
        icon: icon,
        hasLink: true
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1nSOt.default), {
        onClick: onClick,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    padding: 0,
                    height: 'auto',
                    width: '100%',
                    background: 'none',
                    fontWeight: "var(--ds-font-weight-regular, 400)",
                    textAlign: 'left',
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    lineHeight: '18px'
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ba212747341c36c$var$ListItemContent, {
        title: title,
        icon: icon
    })));
const $3ba212747341c36c$var$listItemStyles = (0, $2s57o.xcss)({
    marginTop: 'space.0',
    paddingBlock: 'space.100'
});
const $3ba212747341c36c$var$linkStyles = (0, $2s57o.xcss)({
    color: 'color.text',
    fontWeight: "var(--ds-font-weight-regular, 400)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '18px',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline'
    }
});

});

parcelRegister("1VQfH", function(module, exports) {

$parcel$export(module.exports, "default", () => $06a6220a6c43b429$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $06a6220a6c43b429$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "reverse-trial.reverse-trial-popup.title",
        "defaultMessage": "Your 30-day Premium trial"
    },
    explorePremiumFeaturesLink: {
        "id": "reverse-trial.reverse-trial-popup.explore-premium-features-link",
        "defaultMessage": "Explore Premium features"
    },
    addPaymentDetailsLink: {
        "id": "reverse-trial.reverse-trial-popup.add-payment-details-link",
        "defaultMessage": "Add payment details to stay on Premium"
    },
    endTrialAndChangePlansLink: {
        "id": "reverse-trial.reverse-trial-popup.end-trial-and-change-plans-link",
        "defaultMessage": "End trial and change plans"
    },
    afterTrial: {
        "id": "reverse-trial.reverse-trial-popup.after-trial",
        "defaultMessage": "After your trial, we\u2019ll downgrade you to Free."
    }
});

});


parcelRegister("61Rd1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6683ec13cb4bf534$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6683ec13cb4bf534$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addPaymentDetailsPopupStandardTitle: {
        "id": "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.billing-details-popup.add-payment-details-popup-standard-title",
        "defaultMessage": "Standard trial"
    },
    addPaymentDetailsPopupPremiumTitle: {
        "id": "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.billing-details-popup.add-payment-details-popup-premium-title",
        "defaultMessage": "Premium trial"
    },
    addPaymentDetailsPopupStandardContent: {
        "id": "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.billing-details-popup.add-payment-details-popup-standard-content",
        "defaultMessage": "To stay on the Standard plan after your trial, add your payment details."
    },
    addPaymentDetailsPopupPremiumContent: {
        "id": "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.billing-details-popup.add-payment-details-popup-premium-content",
        "defaultMessage": "To stay on the Premium plan after your trial, add your payment details."
    },
    addPaymentDetailsPopupButton: {
        "id": "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.billing-details-popup.add-payment-details-popup-button",
        "defaultMessage": "Add payment details"
    }
});

});


parcelRegister("eb7dL", function(module, exports) {

$parcel$export(module.exports, "productAbbreviations", () => $ae278b6315a6d207$export$80fc9257f50a9ad4);
const $ae278b6315a6d207$export$80fc9257f50a9ad4 = {
    'jira-software': 'jsw',
    'jira-servicedesk': 'jsm',
    'jira-product-discovery': 'jpd',
    'jira-customer-service': 'jcs',
    'jira-core': 'jwm',
    jira: 'jira'
};

});

parcelRegister("8qT8y", function(module, exports) {

$parcel$export(module.exports, "Dropdown", () => $4ad63844d8ba4e6e$export$931cbfb6bfb85fc);

var $5uXOq = parcelRequire("5uXOq");

var $eRJ8t = parcelRequire("eRJ8t");

var $7HwtN = parcelRequire("7HwtN");


var $hLQN7 = parcelRequire("hLQN7");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $6s1PB = parcelRequire("6s1PB");

var $7mPT9 = parcelRequire("7mPT9");

var $lpwtK = parcelRequire("lpwtK");

var $4gitP = parcelRequire("4gitP");

var $jgJNO = parcelRequire("jgJNO");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $70Wxp = parcelRequire("70Wxp");

var $e2N0p = parcelRequire("e2N0p");

var $koeKL = parcelRequire("koeKL");
/**
 * This was a capability developed during reverse trials where we automatically open the dialog after
 * 3 days of being on the trial. This happens for all customers that have a premium trial on sign up.
 */ const $4ad63844d8ba4e6e$var$useAutoOpenPopover = (openDialog, analyticsAttributes)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const onPopupToggle = (0, $5uXOq.useCallback)(()=>{
        // this is just used when we are opening the dialog 3 days after the customer
        // has started their trial, to force it open without the customers interaction
        openDialog();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'popup'
        }), 'editionAwarenessTrialPillPopup', {
            ...analyticsAttributes,
            autoOpened: true
        });
    }, [
        openDialog,
        createAnalyticsEvent,
        analyticsAttributes
    ]);
    const { premiumTrialOnSignup: premiumTrialOnSignup, isReady: isReady } = (0, $70Wxp.useFetchOnboardingReverseTrial)();
    (0, $e2N0p.useForceOpenPremiumPopupOnDay3)({
        shouldRun: Boolean(isReady && premiumTrialOnSignup),
        onPopupToggle: onPopupToggle
    });
};
const $4ad63844d8ba4e6e$export$931cbfb6bfb85fc = ({ productKey: productKey, applicationEdition: applicationEdition, children: children, analyticsAttributes: analyticsAttributes, trialEndTime: trialEndTime })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    // While rendering this component, the project loading is already done
    // so we can skip the check for loading state
    const { data: project } = (0, $lpwtK.useProject)();
    const [dialogOpen, { on: openDialog, toggle: toggleDialog, off: closeDialog }] = (0, $4gitP.useBoolean)(false);
    const { getIsEligibleForJsmPremiumPillExperiment: getIsEligibleForJsmPremiumPillExperiment } = (0, $hLQN7.useJsmPremiumPillExperiment)();
    const isJSMPremiumPillExperiment = getIsEligibleForJsmPremiumPillExperiment() && (0, $6s1PB.expValEquals)('jsm_premium_trial_pill_experiment', 'cohort', 'variation');
    const handleTogglePopup = (0, $5uXOq.useCallback)((_event, analyticsEvent)=>{
        const updatedEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'toggled',
                actionSubject: 'popup'
            }));
        const show = !dialogOpen;
        (0, $8zOmE.fireUIAnalytics)(updatedEvent, 'editionAwarenessTrialPillPopup', {
            ...analyticsAttributes,
            show: show
        });
        toggleDialog();
    }, [
        dialogOpen,
        analyticsAttributes,
        toggleDialog
    ]);
    const handleTogglePopupJSMPremiumPillExperiment = (0, $5uXOq.useCallback)((_event, analyticsEvent)=>{
        const updatedEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'toggled',
                actionSubject: 'popup'
            }));
        const show = !dialogOpen;
        (0, $8zOmE.fireUIAnalytics)(updatedEvent, 'editionAwarenessTrialPillPopup', {
            ...analyticsAttributes,
            show: show,
            flagKey: 'jsm_premium_trial_pill_experiment'
        });
        toggleDialog();
    }, [
        dialogOpen,
        analyticsAttributes,
        toggleDialog
    ]);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            productKey: productKey,
            projectKey: project?.key
        }), [
        cloudId,
        productKey,
        project?.key
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7HwtN.editionAwarenessDropdownEntryPoint), entryPointParams);
    const loadEntryPoint = entryPointActions.load;
    const onAutoOpen = (0, $5uXOq.useCallback)(()=>{
        loadEntryPoint();
        openDialog();
    }, [
        loadEntryPoint,
        openDialog
    ]);
    $4ad63844d8ba4e6e$var$useAutoOpenPopover(onAutoOpen, analyticsAttributes);
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, true);
    const onFeatureClick = (0, $5uXOq.useCallback)((e, analyticsEvent, featureId)=>{
        // We only want to close the dropdown if the user clicked on the invite people feature
        if (featureId === (0, $3ea4f07209ba1295$export$7d1e0ac6dfe346c1)) handleTogglePopup(e, analyticsEvent);
        // close the dropdown if the user clicks on any of the JSM premium features
        if ([
            (0, $3ea4f07209ba1295$export$511697131d9ae829),
            (0, $3ea4f07209ba1295$export$7d4b5a5e9873378b),
            (0, $3ea4f07209ba1295$export$29ed47667495f403),
            (0, $3ea4f07209ba1295$export$2ab1d308787c64ab)
        ].includes(featureId)) handleTogglePopupJSMPremiumPillExperiment(e, analyticsEvent);
    }, [
        handleTogglePopup,
        handleTogglePopupJSMPremiumPillExperiment
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            productKey: productKey,
            applicationEdition: applicationEdition,
            onFeatureClick: onFeatureClick,
            trialEndTime: trialEndTime,
            onMaybeLaterClick: closeDialog
        }), [
        productKey,
        applicationEdition,
        onFeatureClick,
        trialEndTime,
        closeDialog
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "editionAwareness",
        sourceType: (0, $4d5e0871c06cee03$export$d1123261ca8831d2)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRJ8t.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        messageId: "navigation-apps-sidebar-edition-awareness.ui.trial-pill.trial-pill-button.dropdown.popup.jira-popup",
        messageType: "transactional",
        isOpen: dialogOpen,
        onClose: closeDialog,
        placement: "bottom-end",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "editionAwarenessDropdown",
                packageName: "@atlassian/jira-navigation-apps-sidebar-edition-awareness",
                teamName: "growth-tako",
                runtimeProps: runtimeProps,
                fallback: null
            }),
        trigger: (triggerProps)=>children({
                triggerProps: triggerProps,
                onClick: isJSMPremiumPillExperiment ? handleTogglePopupJSMPremiumPillExperiment : handleTogglePopup,
                ref: (0, $7mPT9.mergeRefs)(triggerProps.ref, triggerRef)
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};

});
parcelRegister("7HwtN", function(module, exports) {

$parcel$export(module.exports, "editionAwarenessDropdownEntryPoint", () => $8eed9654f212e17c$export$6174a9b4a39703f0);

var $2A44E = parcelRequire("2A44E");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $8eed9654f212e17c$export$6174a9b4a39703f0 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("8w6Zq")), {
        moduleId: "23d579fa"
    }),
    getPreloadProps: ({ cloudId: cloudId, productKey: productKey, projectKey: projectKey })=>({
            entryPoints: {},
            extraProps: {
                projectKey: projectKey
            },
            queries: {
                editionAwareness: {
                    parameters: (0, $2A44E.default),
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: productKey,
                        projectKey: projectKey ?? '',
                        hasProjectKey: (projectKey ?? '').trim().length > 0
                    }
                }
            }
        })
});

});
parcelRegister("2A44E", function(module, exports) {

$parcel$export(module.exports, "default", () => $2040a1acef6661fe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<599d55fee81a02a6aaf62a5e625b6ddd>>
 * @relayHash 59c81584cbd2cc164000b6897e83d0b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7f341057c760f4aae078dd67aac57ffbf214d101f22b50313c566bd001d07f0c
const $2040a1acef6661fe$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7f341057c760f4aae078dd67aac57ffbf214d101f22b50313c566bd001d07f0c",
        "metadata": {},
        "name": "uiWrapperEditionAwarenessDropdownWrapperQuery",
        "operationKind": "query",
        "text": null
    }
};
var $2040a1acef6661fe$export$2e2bcd8739ae039 = $2040a1acef6661fe$var$node;

});

parcelRegister("8w6Zq", function(module, exports) {

let $6336bbe4c61c5311$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6336bbe4c61c5311$var$load("chVLP").then(()=>parcelRequire('bOFuj'));

});


const $3ea4f07209ba1295$export$7d1e0ac6dfe346c1 = 'invite-people';
const $3ea4f07209ba1295$export$abfb3fcc6de06e8 = 'automations';
const $3ea4f07209ba1295$export$512ef3af712e0daf = 'user-activity-logs';
const $3ea4f07209ba1295$export$ce2cd9308980f6d = 'atlassian-intelligence';
const $3ea4f07209ba1295$export$423cb3369ffa713 = 'issue-permissions';
const $3ea4f07209ba1295$export$5e1287b9e6d3c46a = 'custom-project-roles';
const $3ea4f07209ba1295$export$82c25e7c6c8c0a93 = 'data-residency';
const $3ea4f07209ba1295$export$1466466c54b5d969 = 'audit-logs';
const $3ea4f07209ba1295$export$b6970527fbedd427 = 'custom-branding';
const $3ea4f07209ba1295$export$511697131d9ae829 = 'change-management';
const $3ea4f07209ba1295$export$7d4b5a5e9873378b = 'incident-management';
const $3ea4f07209ba1295$export$29ed47667495f403 = 'assets';
const $3ea4f07209ba1295$export$2ab1d308787c64ab = 'virtual-service-agent';

parcelRegister("4gitP", function(module, exports) {

$parcel$export(module.exports, "useBoolean", () => $8919d7bf970a6d03$export$c32275ecbd12948f);

var $5uXOq = parcelRequire("5uXOq");
function $8919d7bf970a6d03$export$c32275ecbd12948f(initialValue = false) {
    if (typeof initialValue !== 'boolean') throw new Error('initialValue must be `true` or `false`');
    const [value, setValue] = (0, $5uXOq.useState)(initialValue);
    const handlers = (0, $5uXOq.useMemo)(()=>({
            toggle: ()=>setValue((prevValue)=>!prevValue),
            on: ()=>setValue(true),
            off: ()=>setValue(false),
            setValue: setValue
        }), []);
    return [
        value,
        handlers
    ];
}

});



parcelRegister("h1xoN", function(module, exports) {

$parcel$export(module.exports, "useEligibilityCheckEvent", () => $2b432038ec40b196$export$a49d52669a91865e);
$parcel$export(module.exports, "getIneligibilityReasons", () => $2b432038ec40b196$export$3a5909afc297b5c6);
$parcel$export(module.exports, "transformError", () => $2b432038ec40b196$export$78c6267359db7e73);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $cNd4s = parcelRequire("cNd4s");
const $2b432038ec40b196$export$a49d52669a91865e = ({ productKey: productKey, edition: edition, entitlementDetails: entitlementDetails, projectType: projectType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    return (0, $5uXOq.useCallback)((ineligibilityReason, attributes = {})=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'eligibilityCriteria checked', 'editionAwarenessTrialPill', {
            ineligibilityReason: ineligibilityReason,
            isSiteAdmin: isSiteAdmin,
            productKey: productKey,
            projectType: projectType,
            edition: edition,
            entitlementDetails: entitlementDetails,
            ...attributes
        });
    }, [
        createAnalyticsEvent,
        edition,
        entitlementDetails,
        isSiteAdmin,
        productKey,
        projectType
    ]);
};
const $2b432038ec40b196$export$3a5909afc297b5c6 = (billingInformation)=>{
    const ineligibilityReasons = [];
    if (billingInformation.rawResponse) {
        if (billingInformation.rawResponse?.tenantContexts == null) {
            ineligibilityReasons.push('missingTenantContexts');
            return ineligibilityReasons;
        }
        if (billingInformation.rawResponse?.tenantContexts[0] == null) {
            ineligibilityReasons.push('missingTenantContext');
            return ineligibilityReasons;
        }
        if (billingInformation.rawResponse?.tenantContexts[0]?.entitlementInfo == null) {
            ineligibilityReasons.push('missingEntitlementInfo');
            return ineligibilityReasons;
        }
    }
    if (billingInformation.notInTrialOrPredunning) {
        ineligibilityReasons.push('notInTrialOrPredunning');
        // Return early, as other reasons could not be determined as data are missing in the query
        return ineligibilityReasons;
    }
    // Billing admin explicitly checks false value excluding null/undefined to make sure we use it as reason only if it was intentionally populated
    if (billingInformation.isBillingAdmin !== true) {
        if (billingInformation.isBillingAdmin === false) ineligibilityReasons.push('notBillingAdmin');
        else ineligibilityReasons.push('billingAdminIsNull');
    }
    // Invoiceability is also explicitly checked for not being false since we are showing pill only to sites which were explicitly marked as not invoiceable
    // it is safer not to show pill in case the value comes as null or undefined then show it to ineligible user
    if (billingInformation.invoiceable !== false) {
        if (billingInformation.invoiceable === null) ineligibilityReasons.push('invoiceableIsNull');
        else ineligibilityReasons.push('invoiceable');
    }
    if (!(0, $4R6GH.fg)('trial_edition_awareness_extra_eligibility_check')) return ineligibilityReasons;
    if (billingInformation.partnerManaged === true) ineligibilityReasons.push('partnerManaged');
    if (billingInformation?.billingInterval === 'YEAR') ineligibilityReasons.push('annualBillingCycle');
    if (billingInformation.pricingPlanType && ![
        'COMMERCIAL',
        'COMMUNITY'
    ].includes(billingInformation.pricingPlanType)) ineligibilityReasons.push(`pricingType:${billingInformation.pricingPlanType}`);
    if ([
        'enterprise',
        'atlassian-together'
    ].includes(billingInformation.overriddenEdition || '')) ineligibilityReasons.push(`overriddenEdition:${billingInformation.overriddenEdition}`);
    return ineligibilityReasons;
};
const $2b432038ec40b196$export$78c6267359db7e73 = (error)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const errorObject = {};
    Object.getOwnPropertyNames(error).filter((name)=>name !== 'stack').forEach((name)=>{
        if (name === 'cause') errorObject[name] = error[name]?.message;
        else errorObject[name] = error[name];
    });
    return errorObject;
};

});



parcelRegister("hwY9o", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $d4fd492eb2e40a4e$export$9923361bd43fa030);

var $5uXOq = parcelRequire("5uXOq");

var $lmyls = parcelRequire("lmyls");

var $7v7MP = parcelRequire("7v7MP");

var $5dB4r = parcelRequire("5dB4r");
function $d4fd492eb2e40a4e$export$9923361bd43fa030() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7v7MP.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).APP_SWITCHER
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5dB4r.AppSwitcherTrigger), null));
}

});
parcelRegister("7v7MP", function(module, exports) {

$parcel$export(module.exports, "TopLevelErrorBoundary", () => $6b518e11974f2558$export$b70f1d8bd509b358);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

const $6b518e11974f2558$export$b70f1d8bd509b358 = ({ id: id, children: children })=>{
    const EVENT_DATA = (0, $5uXOq.useMemo)(()=>({
            id: id
        }), [
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: `${(0, $0c0ba767096dfef6$export$4766f0c4b6fe35dc)}.${id}`,
        packageName: (0, $0c0ba767096dfef6$export$b8b9d90f9e5bd72b),
        extraEventData: EVENT_DATA,
        fallback: "unmount"
    }, children);
};

});
const $0c0ba767096dfef6$export$b8b9d90f9e5bd72b = '@atlassian/jira-atlassian-navigation';
const $0c0ba767096dfef6$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $0c0ba767096dfef6$export$9934c8d98fd9e572 = 'atlassianSwitcher';


parcelRegister("5dB4r", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherTrigger", () => $a8bf655658f4721c$export$dc8723dff0e69fcb);

var $5uXOq = parcelRequire("5uXOq");

var $7HgmV = parcelRequire("7HgmV");


var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $5EVwR = parcelRequire("5EVwR");

var $izWh3 = parcelRequire("izWh3");

var $21e8k = parcelRequire("21e8k");
function $a8bf655658f4721c$export$dc8723dff0e69fcb() {
    const [isOpen, { on: openMenu, off: closeMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).APP_SWITCHER);
    const triggerAnalytics = (0, $7HgmV.useNavigationItemAnalytics)({
        navigationItemId: (0, $0c0ba767096dfef6$export$9934c8d98fd9e572)
    });
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        openMenu();
        triggerAnalytics();
    }, [
        openMenu,
        triggerAnalytics
    ]);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            isOpen: isOpen,
            onClose: closeMenu,
            onOpen: onOpen
        }), [
        isOpen,
        closeMenu,
        onOpen
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $5EVwR.AppSwitcherIntegrationEntrypoint), entryPointParams);
    const entrypointRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $izWh3.AppSwitcherPlaceholderButton), {
        onOpen: onOpen,
        ref: entrypointRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "app-switcher-content",
        packageName: "jira-navigation-apps-topnav4-app-switcher",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $21e8k.AppSwitcherPlaceholderWithLoadingPopup), null),
        errorFallback: "flag",
        runtimeProps: entryPointParams
    }));
}

});
parcelRegister("7HgmV", function(module, exports) {

$parcel$export(module.exports, "useNavigationItemAnalytics", () => $bc1fd758f3d9a30e$export$444d136efe970fd3);

var $5uXOq = parcelRequire("5uXOq");

var $2uT3N = parcelRequire("2uT3N");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");
function $bc1fd758f3d9a30e$export$444d136efe970fd3({ navigationItemId: navigationItemId }) {
    const { isVisible: isVisible } = (0, $2uT3N.useOverflowStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((attributes = {})=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, navigationItemId, {
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            ...attributes,
            isInMore: !isVisible,
            navigationLayer: 'global'
        });
    }, [
        createAnalyticsEvent,
        isVisible,
        navigationItemId
    ]);
}

});

parcelRegister("5EVwR", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherIntegrationEntrypoint", () => $daebaf75796cc394$export$7b5dbeab5e41f2a4);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $daebaf75796cc394$export$7b5dbeab5e41f2a4 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("gse8C")), {
        moduleId: "9be44a41"
    }),
    getPreloadProps: (params)=>({
            extraProps: params
        })
});

});
parcelRegister("gse8C", function(module, exports) {

let $bfaa3a5b0c047d0a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bfaa3a5b0c047d0a$var$load("h6luW").then(()=>parcelRequire('2Z7LQ'));

});


parcelRegister("izWh3", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherPlaceholderButton", () => $e454bff21ac6d401$export$46b00316abad4d7b);

var $5uXOq = parcelRequire("5uXOq");

var $6puUq = parcelRequire("6puUq");

var $Pxnvj = parcelRequire("Pxnvj");

var $3BUx0 = parcelRequire("3BUx0");

var $kuGny = parcelRequire("kuGny");

var $cSD7y = parcelRequire("cSD7y");
const $e454bff21ac6d401$export$46b00316abad4d7b = /*#__PURE__*/ (0, $5uXOq.forwardRef)($e454bff21ac6d401$var$AppSwitcherPBWithRef);
function $e454bff21ac6d401$var$AppSwitcherPBWithRef({ onOpen: onOpen, onMouseEnter: onMouseEnter }, ref) {
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3BUx0.AppSwitcher), {
        label: (0, $kuGny.SwitchToTooltipText),
        ref: ref
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e454bff21ac6d401$var$AppSwitcherPlaceholderButtonForBrowser, {
        ref: ref,
        onOpen: onOpen,
        onMouseEnter: onMouseEnter
    });
}
const $e454bff21ac6d401$var$AppSwitcherPlaceholderButtonForBrowser = /*#__PURE__*/ (0, $5uXOq.forwardRef)($e454bff21ac6d401$var$AppSwitcherPlaceholderButtonForBrowserWithRef);
function $e454bff21ac6d401$var$AppSwitcherPlaceholderButtonForBrowserWithRef({ onOpen: onOpen, onMouseEnter: onMouseEnter }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e454bff21ac6d401$var$AppSwitcherLightWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3BUx0.AppSwitcher), {
        ref: ref,
        onClick: onOpen,
        onMouseEnter: onMouseEnter,
        label: (0, $kuGny.SwitchToTooltipText),
        "aria-expanded": false,
        "aria-haspopup": true
    }));
}
const $e454bff21ac6d401$var$AppSwitcherLightWrapper = (0, $cSD7y.componentWithFG)('app_switcher_spotlight_gate', $e454bff21ac6d401$var$SpotLightWrapper, (0, $5uXOq.Fragment));
function $e454bff21ac6d401$var$SpotLightWrapper(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
        name: "app-switcher-spotlight"
    }, props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6puUq.EngagementSpotlight), {
        engagementId: "app-switcher-spotlight"
    }));
}

});

parcelRegister("21e8k", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherPlaceholderWithLoadingPopup", () => $b3f4dfbdd92538a6$export$35c8740d616fd043);

var $5uXOq = parcelRequire("5uXOq");

var $4CMbn = parcelRequire("4CMbn");

var $eWkgo = parcelRequire("eWkgo");
var $2GZKW = parcelRequire("2GZKW");
var $2s57o = parcelRequire("2s57o");

var $jgJNO = parcelRequire("jgJNO");

var $3BUx0 = parcelRequire("3BUx0");

var $kuGny = parcelRequire("kuGny");
function $b3f4dfbdd92538a6$export$35c8740d616fd043() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f4dfbdd92538a6$var$SkeletonContent, null),
        isOpen: true,
        messageId: "navigation-apps-topnav4-app-switcher.ui.trigger.popup.loading.popup",
        messageType: "transactional",
        placement: "bottom-start",
        shouldRenderToParent: true,
        trigger: $b3f4dfbdd92538a6$var$Trigger
    });
}
function $b3f4dfbdd92538a6$var$Trigger(triggerProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3BUx0.AppSwitcher), {
        ...triggerProps,
        label: (0, $kuGny.SwitchToTooltipText),
        "aria-expanded": false,
        "aria-haspopup": true
    });
}
function $b3f4dfbdd92538a6$var$SkeletonContent() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2GZKW.default), {
        xcss: $b3f4dfbdd92538a6$var$containerStyles,
        rowGap: "space.200",
        columnGap: "space.150",
        templateColumns: "32px 1fr"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f4dfbdd92538a6$var$SkeletonItems, null));
}
function $b3f4dfbdd92538a6$var$SkeletonItems() {
    return Array.from({
        length: 5
    }).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CMbn.default), {
            width: "32px",
            height: "32px",
            isShimmering: true,
            borderRadius: "8px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
            justifyContent: "center",
            direction: "column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CMbn.default), {
            width: "100%",
            height: "10px",
            isShimmering: true,
            borderRadius: "4px"
        }))));
}
const $b3f4dfbdd92538a6$var$containerStyles = (0, $2s57o.xcss)({
    width: '250px',
    padding: 'space.200'
});

});



parcelRegister("jzLyJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6a4f4791eb95a6a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $f6a4f4791eb95a6a$var$LazyNav4RolloutAnalytics = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("jG8Mq")).then(({ Nav4RolloutAnalytics: Nav4RolloutAnalytics })=>Nav4RolloutAnalytics), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/rollout/analytics/src/index.tsx"
});
const $f6a4f4791eb95a6a$var$AsyncNav4RolloutAnalytics = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-nav4-rollout-analytics",
        fallback: "unmount",
        packageName: "jiraNavigationAppsSidebarNav4RolloutAnalytics",
        teamName: "jira-cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy-nav4-rollout-analytics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f6a4f4791eb95a6a$var$LazyNav4RolloutAnalytics, null)));
$f6a4f4791eb95a6a$var$AsyncNav4RolloutAnalytics.displayName = 'AsyncNav4RolloutAnalytics';
var $f6a4f4791eb95a6a$export$2e2bcd8739ae039 = $f6a4f4791eb95a6a$var$AsyncNav4RolloutAnalytics;

});
parcelRegister("jG8Mq", function(module, exports) {

let $e538c0185ff10c14$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e538c0185ff10c14$var$load("5pPTh").then(()=>parcelRequire('1O92x'));

});


parcelRegister("apeap", function(module, exports) {

$parcel$export(module.exports, "useRecentActions", () => $c11b2121dbe8e38b$export$5c0647984dfa7d27);
$parcel$export(module.exports, "useRecentAllSingleList", () => $c11b2121dbe8e38b$export$9a54f46f5b7734c);
$parcel$export(module.exports, "useWorkedOnAllSingleList", () => $c11b2121dbe8e38b$export$e8278a7bcff1ec98);
$parcel$export(module.exports, "useRecentBoards", () => $c11b2121dbe8e38b$export$3731bd023be4f71);
$parcel$export(module.exports, "useRecentDashboards", () => $c11b2121dbe8e38b$export$81cb5beef51d43ca);
$parcel$export(module.exports, "useRecentProjects", () => $c11b2121dbe8e38b$export$f6b9a13c4ec08b45);
$parcel$export(module.exports, "useRecentFilters", () => $c11b2121dbe8e38b$export$8d2bfb6d3657bae2);
$parcel$export(module.exports, "useRecentQueues", () => $c11b2121dbe8e38b$export$8756abb0bb90a56e);
$parcel$export(module.exports, "RecentsContainer", () => $c11b2121dbe8e38b$export$5de14a1c1400859e);


var $165Uv = parcelRequire("165Uv");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

const $c11b2121dbe8e38b$var$emptyItemState = {
    items: null,
    isFetching: false,
    fetchError: null,
    promise: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false
};
const $c11b2121dbe8e38b$export$d4c72bab9d6cc13a = {
    [(0, $49a076eb01652100$export$f95f1a684a17f189)]: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$6e58b6b0aa48a271)]: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$6737b9227f60f39d)]: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$91a9dba2d38d9a6f)]: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    },
    [(0, $49a076eb01652100$export$20f1031cc9fdf29e)]: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    },
    workedOn: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    },
    all: {
        ...$c11b2121dbe8e38b$var$emptyItemState
    }
};
const $c11b2121dbe8e38b$var$transformItems = (items)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    items.reduce((acc, itemResponse)=>{
        if (itemResponse.id === 'quick-search-boards') acc[0, $49a076eb01652100$export$f95f1a684a17f189] = itemResponse.items;
        if (itemResponse.id === 'quick-search-filters') acc[0, $49a076eb01652100$export$6737b9227f60f39d] = itemResponse.items;
        if (itemResponse.id === 'quick-search-dashboards') acc[0, $49a076eb01652100$export$6e58b6b0aa48a271] = itemResponse.items;
        if (itemResponse.id === 'quick-search-projects') acc[0, $49a076eb01652100$export$91a9dba2d38d9a6f] = itemResponse.items;
        if (itemResponse.id === 'quick-search-queues') acc[0, $49a076eb01652100$export$20f1031cc9fdf29e] = itemResponse.items;
        return acc;
    }, {});
const $c11b2121dbe8e38b$var$transformWorkedOnItems = (response)=>// select the right data and rename it
    response.data.activities.myActivities.workedOn.nodes.map(({ object: { id: id, localResourceId: localResourceId, name: name, extension: extension, iconUrl: iconUrl, url: url, containers: containers, type: type } })=>({
            id: id,
            localResourceId: localResourceId,
            title: name,
            metadata: extension.issueKey,
            avatarUrl: iconUrl,
            url: url,
            attributes: {
                containerName: containers.find((container)=>container.type === 'PROJECT')?.name
            },
            type: `${type.toLowerCase()}s`
        }));
const $c11b2121dbe8e38b$var$getQueryConfig = (amount, types)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    types.reduce((acc, type)=>{
        acc[type] = amount;
        return acc;
    }, {});
const $c11b2121dbe8e38b$var$loadRecentItems = (amount = (0, $e706d38cada11fb1$export$22ea57e66775a6b2), types)=>async ({ setState: setState, getState: getState })=>{
        const typesToFetch = types.filter((type)=>!getState()[type].isFetching);
        if (typesToFetch.length) try {
            const promise = (0, $165Uv.fetchRecentItems)({
                counts: $c11b2121dbe8e38b$var$getQueryConfig(amount, typesToFetch)
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const loadingState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                };
                return acc;
            }, {});
            setState(loadingState);
            const itemResponse = await promise;
            const transformed = $c11b2121dbe8e38b$var$transformItems(itemResponse || []);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const responseState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    items: transformed[type],
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                };
                return acc;
            }, {});
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                };
                return acc;
            }, {});
            setState(errorState);
        }
    };
const $c11b2121dbe8e38b$var$loadRecentItemsSingleList = (amount = (0, $e706d38cada11fb1$export$5f1b6c5e9d257e5e), types)=>async ({ setState: setState, getState: getState })=>{
        if (types.length) try {
            const promise = (0, $165Uv.fetchRecentItemsSingleList)({
                types: types,
                limit: amount
            });
            const loadingState = {
                all: {
                    ...getState().all,
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                }
            };
            setState(loadingState);
            const itemResponse = await promise;
            const responseState = {
                all: {
                    items: itemResponse != null ? itemResponse[0].items : [],
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                }
            };
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            const errorState = {
                all: {
                    ...getState().all,
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                }
            };
            setState(errorState);
        }
    };
const $c11b2121dbe8e38b$var$loadWorkedOnItems = (amount = (0, $e706d38cada11fb1$export$8666f31c8873bff))=>async ({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        try {
            const promise = (0, $165Uv.fetchWorkedOnItems)({
                cloudId: cloudId,
                amount: amount
            });
            const loadingState = {
                workedOn: {
                    ...getState().workedOn,
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                }
            };
            setState(loadingState);
            const itemResponse = await promise;
            const transformedItems = $c11b2121dbe8e38b$var$transformWorkedOnItems(itemResponse);
            const responseState = {
                workedOn: {
                    items: transformedItems,
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                }
            };
            // @ts-expect-error - TS2345 - Argument of type '{ workedOn: { items: { id: string | number; localResourceId: string; title: string; metadata: string; avatarUrl: string; url: string; attributes: { containerName: string | null | undefined; }; type: string; }[]; ... 4 more ...; hasSuccessOnce: boolean; }; }' is not assignable to parameter of type 'Partial<State>'.
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            const errorState = {
                workedOn: {
                    ...getState().workedOn,
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                }
            };
            setState(errorState);
        }
    };
const $c11b2121dbe8e38b$export$e324594224ef24da = {
    loadRecentAll: (amount)=>async (actions2, props)=>{
            $c11b2121dbe8e38b$var$loadRecentItems(amount, [
                props.applicationPermissions.hasSoftwareAccess ? (0, $49a076eb01652100$export$f95f1a684a17f189) : undefined,
                (0, $49a076eb01652100$export$6e58b6b0aa48a271),
                (0, $49a076eb01652100$export$91a9dba2d38d9a6f),
                (0, $49a076eb01652100$export$6737b9227f60f39d),
                props.applicationPermissions.hasServiceDeskAccess ? (0, $49a076eb01652100$export$20f1031cc9fdf29e) : undefined
            ].filter(Boolean))(actions2);
        },
    loadRecentAllSingleList: (amount)=>async (actions2, props)=>{
            $c11b2121dbe8e38b$var$loadRecentItemsSingleList(amount, [
                props.applicationPermissions.hasSoftwareAccess ? (0, $49a076eb01652100$export$f95f1a684a17f189) : undefined,
                (0, $49a076eb01652100$export$6e58b6b0aa48a271),
                (0, $49a076eb01652100$export$91a9dba2d38d9a6f),
                (0, $49a076eb01652100$export$6737b9227f60f39d),
                (0, $49a076eb01652100$export$ebb48b08205007c5),
                props.applicationPermissions.hasServiceDeskAccess ? (0, $49a076eb01652100$export$20f1031cc9fdf29e) : undefined
            ].filter(Boolean))(actions2);
        },
    loadWorkedOnAllSingleList: $c11b2121dbe8e38b$var$loadWorkedOnItems,
    loadRecentBoards: (amount)=>$c11b2121dbe8e38b$var$loadRecentItems(amount, [
            (0, $49a076eb01652100$export$f95f1a684a17f189)
        ]),
    loadRecentProjects: (amount)=>$c11b2121dbe8e38b$var$loadRecentItems(amount, [
            (0, $49a076eb01652100$export$91a9dba2d38d9a6f)
        ]),
    loadRecentDashboards: (amount)=>$c11b2121dbe8e38b$var$loadRecentItems(amount, [
            (0, $49a076eb01652100$export$6e58b6b0aa48a271)
        ]),
    loadRecentFilters: (amount)=>$c11b2121dbe8e38b$var$loadRecentItems(amount, [
            (0, $49a076eb01652100$export$6737b9227f60f39d)
        ]),
    loadRecentQueues: (amount)=>$c11b2121dbe8e38b$var$loadRecentItems(amount, [
            (0, $49a076eb01652100$export$20f1031cc9fdf29e)
        ])
};
const $c11b2121dbe8e38b$var$store = (0, $iXqE5.createStore)({
    name: (0, $e706d38cada11fb1$export$eb2b39783d051b9),
    actions: $c11b2121dbe8e38b$export$e324594224ef24da,
    initialState: $c11b2121dbe8e38b$export$d4c72bab9d6cc13a
});
const $c11b2121dbe8e38b$export$5c0647984dfa7d27 = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: null
});
const $c11b2121dbe8e38b$export$9a54f46f5b7734c = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state.all
});
const $c11b2121dbe8e38b$export$e8278a7bcff1ec98 = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state.workedOn
});
const $c11b2121dbe8e38b$export$3731bd023be4f71 = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$f95f1a684a17f189]
});
const $c11b2121dbe8e38b$export$81cb5beef51d43ca = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$6e58b6b0aa48a271]
});
const $c11b2121dbe8e38b$export$f6b9a13c4ec08b45 = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$91a9dba2d38d9a6f]
});
const $c11b2121dbe8e38b$export$8d2bfb6d3657bae2 = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$6737b9227f60f39d]
});
const $c11b2121dbe8e38b$export$8756abb0bb90a56e = (0, $3sQ5x.createHook)($c11b2121dbe8e38b$var$store, {
    selector: (state)=>state[0, $49a076eb01652100$export$20f1031cc9fdf29e]
});
const $c11b2121dbe8e38b$export$5de14a1c1400859e = (0, $gg7kZ.createContainer)($c11b2121dbe8e38b$var$store);

});
parcelRegister("165Uv", function(module, exports) {

$parcel$export(module.exports, "fetchRecentItems", () => $892c454fe92da960$export$20d49db97b653a7b);
$parcel$export(module.exports, "fetchRecentItemsSingleList", () => $892c454fe92da960$export$a00963dad78984b8);
$parcel$export(module.exports, "fetchWorkedOnItems", () => $892c454fe92da960$export$f3763cb0ecc90572);

var $ebyGx = parcelRequire("ebyGx");


var $5HnTq = parcelRequire("5HnTq");

var $fPruT = parcelRequire("fPruT");

const $892c454fe92da960$var$PATH_BUCKETED = '/rest/internal/2/productsearch/search';
const $892c454fe92da960$var$PATH_SINGLE_LIST = '/rest/internal/2/productsearch/singleRecentList';
// dummy handle error
const $892c454fe92da960$var$handleError = (error)=>{
    throw error;
};
const $892c454fe92da960$var$toQuery = ({ counts: counts })=>// @ts-expect-error - TS2769 - No overload matches this call.
    Object.keys(counts) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((result, itemType)=>{
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<ItemType, number>>'.
        result.push(`${itemType}=${counts[itemType]}`);
        return result;
    }, []).join(',');
const $892c454fe92da960$export$20d49db97b653a7b = async ({ counts: counts })=>{
    const url = `${$892c454fe92da960$var$PATH_BUCKETED}?${(0, $ebyGx.stringify)({
        counts: $892c454fe92da960$var$toQuery({
            counts: counts
        }),
        type: Object.keys(counts).join(',')
    })}`;
    try {
        const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
        const { status: status } = response;
        if (!response.ok) {
            if (status === (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)) return $892c454fe92da960$var$handleError(new (0, $fPruT.AuthenticationError)(`${status}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $892c454fe92da960$var$handleError(new Error(status));
        }
        if (status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return null;
        return response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $892c454fe92da960$var$handleError(error);
    }
};
const $892c454fe92da960$export$a00963dad78984b8 = async ({ types: types, limit: limit })=>{
    const url = $892c454fe92da960$var$PATH_SINGLE_LIST;
    try {
        const response = await fetch(url, {
            ...(0, $5HnTq.getDefaultOptions)(url),
            method: 'POST',
            body: JSON.stringify({
                groups: [
                    {
                        types: types,
                        limit: limit
                    }
                ]
            })
        });
        const { status: status } = response;
        if (!response.ok) {
            if (status === (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)) return $892c454fe92da960$var$handleError(new (0, $fPruT.AuthenticationError)(`${status}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $892c454fe92da960$var$handleError(new Error(status));
        }
        if (status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return null;
        return response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $892c454fe92da960$var$handleError(error);
    }
};
const $892c454fe92da960$export$f3763cb0ecc90572 = async ({ cloudId: cloudId, amount: amount })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                operationName: 'jira_NavigationActivity',
                query: (0, $ec61554fda4e6d64$export$2b91517d6d5b4365),
                variables: {
                    first: amount,
                    cloudID: cloudId
                }
            })
        });
        const { status: status } = response;
        if (!response.ok) {
            if (status === (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)) return $892c454fe92da960$var$handleError(new (0, $fPruT.AuthenticationError)(`${status}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $892c454fe92da960$var$handleError(new Error(status));
        }
        return response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $892c454fe92da960$var$handleError(error);
    }
};

});
const $ec61554fda4e6d64$export$2b91517d6d5b4365 = `
fragment NavigationActivityItem on ActivitiesItem {
  id
  timestamp
  object {
    id
    name
    localResourceId
    type
    url
    iconUrl
    containers {
      name
      type
    }
    extension {
      ... on ActivitiesJiraIssue {
        issueKey
      }
    }
  }
}

query jira_NavigationActivity($first: Int, $cloudID: ID!) {
  activities {
    myActivities {
      workedOn(
        first: $first,
        filters: [
          {
            type: AND,
            arguments: {
              cloudIds: [$cloudID],
              products: [JIRA, JIRA_BUSINESS, JIRA_SOFTWARE, JIRA_OPS, JIRA_SERVICE_DESK]
            }
          }
        ]
      ) {
        nodes {
          ...NavigationActivityItem
        }
      }
    }
  }
}

`;


const $e706d38cada11fb1$export$eb2b39783d051b9 = 'navigation-recents-store';
const $e706d38cada11fb1$export$22ea57e66775a6b2 = 5;
const $e706d38cada11fb1$export$8666f31c8873bff = 10;
const $e706d38cada11fb1$export$5f1b6c5e9d257e5e = 20;


parcelRegister("l0cYe", function(module, exports) {

$parcel$export(module.exports, "NavigationSuccessTrackerForNav3", () => $35aca48cac64f980$export$9013eebe7301dfe1);

var $5uXOq = parcelRequire("5uXOq");

var $g0Gtc = parcelRequire("g0Gtc");

var $3bQtK = parcelRequire("3bQtK");

var $7XYc4 = parcelRequire("7XYc4");

var $8CVvd = parcelRequire("8CVvd");

var $6jY6G = parcelRequire("6jY6G");

var $Mp6qH = parcelRequire("Mp6qH");
const $35aca48cac64f980$var$EmptyFragment = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
const $35aca48cac64f980$var$NavigationSuccessTracker = ({ children: children })=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const ViewExperienceSuccessTrackerComponent = route.isRedirect === true ? $35aca48cac64f980$var$EmptyFragment : (0, $g0Gtc.ExperienceSuccessTracker);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ViewExperienceSuccessTrackerComponent, {
        location: "atlassian-navigation-main",
        parentProviders: null,
        failureEventAttributes: null
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MAIN)
    }));
};
const $35aca48cac64f980$export$9013eebe7301dfe1 = (0, $7XYc4.componentWithCondition)((0, $8CVvd.getWillShowNav3), $35aca48cac64f980$var$NavigationSuccessTracker, (0, $5uXOq.Fragment));

});

parcelRegister("cibbb", function(module, exports) {

$parcel$export(module.exports, "TopNav3", () => $aa4de88b490eda4d$export$658e2de86b367732);

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $bWmoi = parcelRequire("bWmoi");

var $1eJCs = parcelRequire("1eJCs");
const $aa4de88b490eda4d$export$658e2de86b367732 = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('blu-6139_sync_load_nav4_top_bar', 'isEnabled', false), (0, $bWmoi.TopNavAsync), (0, $1eJCs.TopNavSync));

});
parcelRegister("bWmoi", function(module, exports) {

$parcel$export(module.exports, "TopNavAsync", () => $ab2ac48f46df03ff$export$44495c3894c87663);

var $fDtbf = parcelRequire("fDtbf");

var $2SVPM = parcelRequire("2SVPM");

var $b7Svb = parcelRequire("b7Svb");

const $ab2ac48f46df03ff$export$44495c3894c87663 = (0, $b7Svb.lazyForPaint)(()=>{
    const bundleReady = Promise.resolve((parcelRequire("1eJCs"))).then(({ TopNavSync: TopNavSync })=>TopNavSync);
    if (!false) bundleReady.then(()=>{
        (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $fDtbf.JS_EVAL_START))) {
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
            break;
        }
    });
    return bundleReady;
}, {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/top-nav/sync.tsx"
});

});
parcelRegister("1eJCs", function(module, exports) {

$parcel$export(module.exports, "TopNavSync", () => $d3216ffc7db3f41d$export$c095e90014f78159);
/* sync.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jUalr = parcelRequire("jUalr");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $bBulW = parcelRequire("bBulW");

var $6jY6G = parcelRequire("6jY6G");

var $cZpsT = parcelRequire("cZpsT");

var $dWQF5 = parcelRequire("dWQF5");

var $jyW1v = parcelRequire("jyW1v");

var $6RKvu = parcelRequire("6RKvu");

var $96WTB = parcelRequire("96WTB");

var $crC7i = parcelRequire("crC7i");

var $klog1 = parcelRequire("klog1");

var $7bwNu = parcelRequire("7bwNu");

var $ag3PC = parcelRequire("ag3PC");

var $2YzXO = parcelRequire("2YzXO");

var $1mNGt = parcelRequire("1mNGt");

var $lbp13 = parcelRequire("lbp13");

var $a5zoF = parcelRequire("a5zoF");

var $jSplz = parcelRequire("jSplz");

var $3bzLW = parcelRequire("3bzLW");

var $cvQRb = parcelRequire("cvQRb");

var $9i62K = parcelRequire("9i62K");

var $el0Fl = parcelRequire("el0Fl");

var $6U0zt = parcelRequire("6U0zt");

var $fwJYI = parcelRequire("fwJYI");

var $eoNiZ = parcelRequire("eoNiZ");

var $jUhOq = parcelRequire("jUhOq");

var $inFGE = parcelRequire("inFGE");
/*
    The DiscoverMore component is from experiment TBLZ-197, so rather than updating the Atlassian Navigation
    package we are extending the renderNotifications prop for now.
    If this experiment is productionised, we will move the code into the appropriate location.
*/ const $d3216ffc7db3f41d$var$RenderNotificationsWithConversationAssistant = ()=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isAnonymous = (0, $4R6GH.fg)('rovo_chat_hide_for_jira_anon_users') ? (0, $cZpsT.useIsAnonymous)() : false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jUhOq.ConversationAssistant), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inFGE.Notifications), null));
};
const $d3216ffc7db3f41d$var$SearchWithoutProps = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fwJYI.Search), null);
const $d3216ffc7db3f41d$var$EditionAwarenessAndSearch = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d3216ffc7db3f41d$var$EditionAwarenessWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBulW.EditionAwareness), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d3216ffc7db3f41d$var$SearchWithoutProps, null));
const $d3216ffc7db3f41d$export$c095e90014f78159 = ()=>{
    const theme = (0, $eoNiZ.useTheme)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const showAssets = (0, $9i62K.useShowAssets)();
    const showRoadmapsOld = (0, $el0Fl.useShowRoadmaps)();
    const showRoadmaps = (0, $dWQF5.useIsCrossProjectViewsEnabled)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const PrimaryMenuItemsNav3 = (0, $5uXOq.useMemo)(()=>[
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1mNGt.OpenOverflowMenuForPlansSpotlightObserver), {
                key: "arj-open-overflow-menu-for-plans-spotlight-observer"
            }),
            !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lbp13.YourWorkDropdown), {
                key: "yourWorkDropdown"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a5zoF.Projects), {
                key: "projects"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jSplz.Filters), {
                key: "filters"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bzLW.Dashboards), {
                key: "dashboards"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cvQRb.People), {
                key: "people"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1mNGt.Plans), {
                key: "plans"
            }),
            ((0, $4R6GH.fg)('polaris_roadmaps_old_nav_fix') ? showRoadmaps : showRoadmapsOld) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $el0Fl.Roadmaps), {
                key: "roadmaps"
            }),
            showAssets && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9i62K.Insight), {
                key: "insight"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6U0zt.Addons), {
                key: "addons"
            })
        ].filter(Boolean), [
        isAnonymous,
        showAssets,
        showRoadmaps,
        showRoadmapsOld
    ]); // @ts-expect-error - Type 'string' is not assignable to type 'RouteName'.
    const ssrPlaceholderEnabledRoutes = [
        ...(0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nin_and_nav') ? [
            'global-issue-navigator',
            'software-issue-navigator',
            'issue-navigator-classic',
            'servicedesk-issues',
            'issue-navigator-core'
        ] : [],
        ...(0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nav_for_iv') ? [
            'issue'
        ] : [],
        ...(0, $4R6GH.fg)('add_nav_ssr_placeholder_for_board_and_backlog') ? [
            'rapidboard-board',
            'rapidboard-backlog'
        ] : []
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jUalr.AtlassianNavigation), {
        primaryItems: PrimaryMenuItemsNav3,
        label: formatMessage((0, $jyW1v.default).topNav),
        moreLabel: formatMessage((0, $jyW1v.default).more),
        renderAppSwitcher: (0, $6RKvu.AppSwitcher),
        renderCreate: (0, $96WTB.Create),
        renderHelp: (0, $crC7i.Help),
        renderNotifications: $d3216ffc7db3f41d$var$RenderNotificationsWithConversationAssistant,
        renderProductHome: (0, $klog1.ProductHome),
        renderProfile: (0, $7bwNu.Profile),
        renderSearch: $d3216ffc7db3f41d$var$EditionAwarenessAndSearch,
        renderSettings: (0, $ag3PC.Settings),
        renderSignIn: (0, $2YzXO.SignIn),
        theme: theme,
        testId: (0, $6cNb0.testIdGenerate)(null),
        isServer: false,
        isSSRPlaceholderEnabled: ssrPlaceholderEnabledRoutes.includes(route.name)
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d3216ffc7db3f41d$var$EditionAwarenessWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxpxbi _j2s1glyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jyW1v", function(module, exports) {

$parcel$export(module.exports, "default", () => $8abfadba6a4f23da$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8abfadba6a4f23da$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    topNav: {
        "id": "atlassian-navigation.top-nav",
        "defaultMessage": "Primary"
    },
    more: {
        "id": "atlassian-navigation.more",
        "defaultMessage": "More"
    }
});

});

parcelRegister("6RKvu", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $133f3cac4f90ffa1$export$9923361bd43fa030);

var $5uXOq = parcelRequire("5uXOq");

var $9jFq3 = parcelRequire("9jFq3");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $iPj86 = parcelRequire("iPj86");
const $133f3cac4f90ffa1$var$AppSwitcher = ({ AppSwitcherIntegration: AppSwitcherIntegration = (0, $9jFq3.AppSwitcher), useTopMenus: useTopMenus = (0, $2Ui4E.useTopMenus), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics) })=>{
    const [isOpen, { on: openMenu, off: closeMenu }] = useTopMenus((0, $lmyls.MENU_ID).APP_SWITCHER);
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).APP_SWITCHER
    });
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        openMenu();
        triggerAnalytics();
    }, [
        openMenu,
        triggerAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AppSwitcherIntegration, {
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: closeMenu
    });
};
const $133f3cac4f90ffa1$export$9923361bd43fa030 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).APP_SWITCHER
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($133f3cac4f90ffa1$var$AppSwitcher, props));

});
parcelRegister("9jFq3", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $20a8f1ac93bd5269$export$9923361bd43fa030);

var $5uXOq = parcelRequire("5uXOq");

var $6puUq = parcelRequire("6puUq");

var $Pxnvj = parcelRequire("Pxnvj");

var $ksLsv = parcelRequire("ksLsv");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $4R6GH = parcelRequire("4R6GH");

var $gMP0k = parcelRequire("gMP0k");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $20a8f1ac93bd5269$var$LazyAppSwitcher = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("6clh9")).then((module)=>module.AppSwitcher), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation-switcher-integration/src/main.tsx"
});
const $20a8f1ac93bd5269$var$AppSwitcherWithSpotlight = (props)=>{
    return (0, $4R6GH.fg)('app_switcher_spotlight_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
        name: "app-switcher-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gMP0k.AppSwitcherLight), props)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6puUq.EngagementSpotlight), {
        engagementId: "app-switcher-spotlight"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gMP0k.AppSwitcherLight), props);
};
const $20a8f1ac93bd5269$export$9923361bd43fa030 = (props)=>{
    const checkJpdCrossJoinNudgeEligibility = (0, $ksLsv.useJpdCrossJoinNudgeEligibility)();
    const showConfluenceCrossJoinNudge = (0, $ksLsv.useCrossJoinNudge)();
    const showJpdCrossJoinNudge = (0, $ksLsv.useJpdCrossJoinNudge)();
    (0, $5uXOq.useEffect)(()=>{
        checkJpdCrossJoinNudgeEligibility().then((isEligible)=>isEligible ? showJpdCrossJoinNudge() : showConfluenceCrossJoinNudge());
    }, [
        checkJpdCrossJoinNudgeEligibility,
        showConfluenceCrossJoinNudge,
        showJpdCrossJoinNudge
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
        $20a8f1ac93bd5269$var$LazyAppSwitcher.preload();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "app-switcher.integration.async",
        packageName: "NavigationIntegrations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy-app-switcher",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gMP0k.AppSwitcherLight), null)
    }, props.isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20a8f1ac93bd5269$var$LazyAppSwitcher, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20a8f1ac93bd5269$var$AppSwitcherWithSpotlight, {
        onOpen: props.onOpen,
        onMouseEnter: handleMouseEnter
    })));
};

});
parcelRegister("ksLsv", function(module, exports) {

$parcel$export(module.exports, "useCrossJoinNudge", () => $d9661dec9418aa61$export$3c6c113f7a90d3c8);
$parcel$export(module.exports, "useCrossJoinNudgeYourWorkEligibility", () => $d9661dec9418aa61$export$1708bc6112f5b6aa);
$parcel$export(module.exports, "CrossJoinNudgeYourWork", () => $d9661dec9418aa61$export$eb1ab086083a0ea3);
$parcel$export(module.exports, "useJpdCrossJoinNudgeEligibility", () => $d9661dec9418aa61$export$cf17b7d2f952c993);
$parcel$export(module.exports, "useJpdCrossJoinNudge", () => $d9661dec9418aa61$export$b59148260d6e0135);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $hqBSi = parcelRequire("hqBSi");

var $lODMY = parcelRequire("lODMY");
var $lVJAU = parcelRequire("lVJAU");

var $2q33c = parcelRequire("2q33c");

var $eRI0j = parcelRequire("eRI0j");

var $1e3dw = parcelRequire("1e3dw");

var $dxdji = parcelRequire("dxdji");

var $3yRDf = parcelRequire("3yRDf");

var $kB1IK = parcelRequire("kB1IK");

var $iVil7 = parcelRequire("iVil7");

var $j2ykK = parcelRequire("j2ykK");

var $e1J1K = parcelRequire("e1J1K");

var $8mTEW = parcelRequire("8mTEW");

var $aLcWc = parcelRequire("aLcWc");

var $25NDO = parcelRequire("25NDO");

var $iu3ma = parcelRequire("iu3ma");

var $fVgtE = parcelRequire("fVgtE");

var $eCsnX = parcelRequire("eCsnX");

var $4kGsO = parcelRequire("4kGsO");

var $fmenl = parcelRequire("fmenl");

var $khNyR = parcelRequire("khNyR");
const $d9661dec9418aa61$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS = 5;
const $d9661dec9418aa61$var$MAX_NUMBER_OF_JPD_COLLABORATORS = 10;
const $d9661dec9418aa61$var$MAX_FEATURE_VISIT_COUNT = 3;
const $d9661dec9418aa61$export$3c6c113f7a90d3c8 = ()=>{
    const sessionId = (0, $5uXOq.useRef)((0, $7Jxgt.v4)());
    const getNudgeRecommendations = (0, $j2ykK.useNudgeRecommendations)({
        sessionId: sessionId.current
    });
    const cloudId = (0, $koeKL.useCloudId)();
    const getFilteredCollaborators = (0, $dxdji.useFilteredUsersFromCollaborationGraph)(cloudId, 'confluence', $d9661dec9418aa61$var$MAX_NUMBER_OF_CONFLUENCE_COLLABORATORS);
    const showRequestAccessPromptFlag = (0, $eCsnX.useRequestAccessPromptFlag)();
    const showSuccessFlag = (0, $4kGsO.useRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $fVgtE.useRequestAccessErrorFlag)();
    const { getNudgeState: getNudgeStateV2a, setNudgeDismissed: setNudgeDismissedV2a } = (0, $kB1IK.useNudgeStateV2a)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const userId = (0, $90yGq.useAccountId)() || '';
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const isYourWorkRoute = (0, $lODMY.useIsActiveRoute)('your-work');
    return (0, $5uXOq.useCallback)(async ()=>{
        try {
            if (isYourWorkRoute) return;
            if (!licensedProducts.confluence) return;
            if ((0, $1e3dw.isFeatureVisited)('crossJoinNudgesConfluence', 30)) return;
            if (await (0, $aLcWc.isSiteOptedOut)(cloudId)) {
                (0, $eRI0j.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesConfluence');
                return;
            }
            if (await (0, $iVil7.hasProductAccess)('confluence', cloudId)) return;
            if (!await (0, $e1J1K.fetchIsRequestAccessCapable)('confluence', cloudId)) return;
            if (!await (0, $8mTEW.isSite7DaysOld)('confluence', cloudId)) return;
            // Since V2A Rollout to 100%, all nudge will use V2A Logic
            if (await getNudgeStateV2a() === 'DISMISSED') return;
            const featureVisitedCount = await (0, $1e3dw.getFeatureVisitedCount)(userId);
            if (featureVisitedCount >= $d9661dec9418aa61$var$MAX_FEATURE_VISIT_COUNT) return;
            const onSubmit = async ()=>{
                try {
                    const accessStatus = await (0, $2q33c.requestAccess)('confluence', cloudId, userId, 'crossJoinNudgesConfluence', createAnalyticsEvent);
                    if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/wiki');
                    else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') showSuccessFlag();
                    else showErrorFlag('confluence');
                } catch  {
                    showErrorFlag('confluence');
                }
            };
            const users = await getFilteredCollaborators();
            const isContextualBandit = users.length === 0;
            const entityId = isContextualBandit ? await getNudgeRecommendations() : undefined;
            showRequestAccessPromptFlag({
                users: users,
                onSubmit: onSubmit,
                onOptout: setNudgeDismissedV2a,
                snoozeFor30Days: ()=>(0, $1e3dw.snoozeFeatureFor30Days)('crossJoinNudgesConfluence'),
                integration: 'crossJoinNudgesConfluence',
                isContextualBandit: isContextualBandit,
                entityId: entityId,
                featureVisitedCount: featureVisitedCount
            });
            (0, $1e3dw.increaseFeatureVisitedCount)(userId, featureVisitedCount + 1);
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'slo.crossJoinNudgesConfluence succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eRI0j.fireErrorAnalytics)('useCrossJoinNudges', error, {
                cloudId: cloudId
            });
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        getFilteredCollaborators,
        getNudgeRecommendations,
        getNudgeStateV2a,
        isYourWorkRoute,
        licensedProducts.confluence,
        push,
        setNudgeDismissedV2a,
        showErrorFlag,
        showRequestAccessPromptFlag,
        showSuccessFlag,
        userId
    ]);
};
const $d9661dec9418aa61$export$1708bc6112f5b6aa = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { isVisited: isVisited } = (0, $1e3dw.useSnooze)('crossJoinNudgesYourWork');
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const { getNudgeState: getNudgeState } = (0, $kB1IK.useNudgeStateYourWork)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [isEligible, setIsEligible] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        const checkEligibility = async ()=>{
            try {
                if (!licensedProducts.confluence) return;
                if (isVisited()) return;
                if (await (0, $aLcWc.isSiteOptedOut)(cloudId)) {
                    (0, $eRI0j.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesYourWork');
                    return;
                }
                if (await getNudgeState() === 'DISMISSED') return;
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confluenceAccessCheck started', {
                    touchpoint: 'jiraYourWork'
                });
                const hasAccessToConfluence = await (0, $iVil7.fetchCachedAccessCheck)(createAnalyticsEvent, 'confluence', cloudId, 'jiraYourWork');
                if (hasAccessToConfluence === null) return;
                if (hasAccessToConfluence) return;
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck started', {
                    touchpoint: 'jiraYourWork'
                });
                const isRaCapable = await (0, $e1J1K.fetchCachedIsConfluenceRACapable)(createAnalyticsEvent, cloudId, 'jiraYourWork');
                if (isRaCapable === null) return;
                if (!isRaCapable) return;
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'siteAgeCheck started', {
                    touchpoint: 'jiraYourWork'
                });
                if (!await (0, $8mTEW.isSite7DaysOld)('confluence', cloudId)) return;
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'promotionalCard eligibleCheckSucceeded', {
                    touchpoint: 'jiraYourWork'
                });
                setIsEligible(true);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eRI0j.fireErrorAnalytics)('useCrossJoinNudgeYourWorkEligibility', error, {
                    cloudId: cloudId
                });
            }
        };
        checkEligibility();
    }, [
        cloudId,
        getNudgeState,
        isVisited,
        licensedProducts.confluence,
        createAnalyticsEvent
    ]);
    return isEligible;
};
const $d9661dec9418aa61$var$CrossJoinNudgeYourWorkWithChecks = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const userId = (0, $90yGq.useAccountId)() || '';
    const showSuccessFlag = (0, $4kGsO.useRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $fVgtE.useRequestAccessErrorFlag)();
    const { setNudgeDismissed: setNudgeDismissed } = (0, $kB1IK.useNudgeStateYourWork)();
    const { snoozeFor7Days: snoozeFor7Days, snoozeFor30Days: snoozeFor30Days, increaseVisitedCount: increaseVisitedCount } = (0, $1e3dw.useSnooze)('crossJoinNudgesYourWork');
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [isDismissed, setIsDismissed] = (0, $5uXOq.useState)(false);
    const { collaborators: collaborators, isLoading: isCollaboratorsLoading } = (0, $25NDO.useCollaborators)(true);
    const { visitedCount: visitedCount, isLoading: isVisitedCountLoading } = (0, $iu3ma.useVisitedCount)(true, 'crossJoinNudgesYourWork');
    const onDismiss = (0, $5uXOq.useCallback)(()=>{
        snoozeFor7Days();
        increaseVisitedCount(visitedCount + 1);
        setIsDismissed(true);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard dismissed', 'crossJoinNudges');
    }, [
        createAnalyticsEvent,
        visitedCount,
        increaseVisitedCount,
        snoozeFor7Days
    ]);
    const onSubmit = (0, $5uXOq.useCallback)(async ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard submitted', 'crossJoinNudges');
        try {
            const accessStatus = await (0, $2q33c.requestAccess)('confluence', cloudId, userId, 'crossJoinNudgesYourWork', createAnalyticsEvent);
            (0, $e1J1K.resetRACapableCache)();
            if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/wiki');
            else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') {
                showSuccessFlag();
                setIsDismissed(true);
            } else {
                showErrorFlag('confluence');
                setNudgeDismissed();
                setIsDismissed(true);
            }
        } catch (err) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'promotionalCard submitError', {
                err: err
            });
            showErrorFlag('confluence');
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        push,
        setNudgeDismissed,
        showErrorFlag,
        showSuccessFlag,
        userId
    ]);
    const onSnooze = (0, $5uXOq.useCallback)(()=>{
        snoozeFor30Days();
        increaseVisitedCount(visitedCount + 1);
        setIsDismissed(true);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard snoozed', 'crossJoinNudges');
    }, [
        createAnalyticsEvent,
        visitedCount,
        increaseVisitedCount,
        snoozeFor30Days
    ]);
    const onOptOut = (0, $5uXOq.useCallback)(()=>{
        setNudgeDismissed();
        setIsDismissed(true);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard optedOut', 'crossJoinNudges');
    }, [
        createAnalyticsEvent,
        setNudgeDismissed
    ]);
    let secondaryAction;
    switch(visitedCount){
        case 0:
            secondaryAction = 'none';
            break;
        case 1:
            secondaryAction = 'snooze';
            break;
        default:
            secondaryAction = 'opt-out';
    }
    const onRender = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'promotionalCard shown', 'crossJoinNudges', {
            secondaryAction: secondaryAction,
            collaborators: collaborators.length
        });
    }, [
        collaborators.length,
        createAnalyticsEvent,
        secondaryAction
    ]);
    const shouldShow = !isCollaboratorsLoading && !isVisitedCountLoading && !isDismissed;
    return shouldShow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khNyR.CrossJoinNudgeYourWorkCard), {
        collaborators: collaborators,
        onRender: onRender,
        onDismiss: secondaryAction === 'none' ? onDismiss : onSnooze,
        onSubmit: onSubmit,
        onSnooze: secondaryAction === 'snooze' ? onSnooze : undefined,
        onOptOut: secondaryAction === 'opt-out' ? onOptOut : undefined
    }) : null;
};
const $d9661dec9418aa61$export$eb1ab086083a0ea3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fmenl.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9661dec9418aa61$var$CrossJoinNudgeYourWorkWithChecks, null));
const $d9661dec9418aa61$export$cf17b7d2f952c993 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const isJpdRoute = (0, $lODMY.useIsActiveRoute)('polaris-ideas');
    return (0, $5uXOq.useCallback)(async ()=>{
        try {
            if ((0, $1e3dw.isFeatureVisited)('crossJoinNudgesJiraToJpd', 30)) return false;
            if (isJpdRoute) return false;
            const eligibilityResponse = await (0, $3yRDf.checkJpdCrossJoinNudgeEligibility)({
                cloudId: cloudId,
                licensedProducts: licensedProducts
            });
            if (!eligibilityResponse.eligible) {
                if (eligibilityResponse.ineligibilityReason === 'SITE_OPTED_OUT') (0, $eRI0j.fireSiteOptedOutAnalytics)(createAnalyticsEvent, 'crossJoinNudgesJiraToJpd');
                return false;
            }
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eRI0j.fireErrorAnalytics)('crossJoinNudgesJiraToJpd', error, {
                cloudId: cloudId
            });
            return false;
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        isJpdRoute,
        licensedProducts
    ]);
};
const $d9661dec9418aa61$export$b59148260d6e0135 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const userId = (0, $90yGq.useAccountId)() || '';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const getFilteredCollaborators = (0, $dxdji.useFilteredUsersFromCollaborationGraph)(cloudId, 'jira-product-discovery', $d9661dec9418aa61$var$MAX_NUMBER_OF_JPD_COLLABORATORS);
    const showRequestAccessPromptFlag = (0, $eCsnX.useRequestAccessPromptFlag)();
    const showSuccessFlag = (0, $4kGsO.useRequestAccessSuccessFlag)();
    const showErrorFlag = (0, $fVgtE.useRequestAccessErrorFlag)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { snoozeFor30Days: snoozeFor30Days, getVisitedCount: getVisitedCount, increaseVisitedCount: increaseVisitedCount } = (0, $1e3dw.useSnooze)('crossJoinNudgesJiraToJpd');
    const { getNudgeState: getNudgeState, setNudgeDismissed: setNudgeDismissed } = (0, $kB1IK.useNudgeStateJiraToJpd)();
    return (0, $5uXOq.useCallback)(async ()=>{
        try {
            const collaboratorsOnJpd = await getFilteredCollaborators();
            const onSubmit = async ()=>{
                try {
                    const accessStatus = await (0, $2q33c.requestAccess)('jira-product-discovery', cloudId, userId, 'crossJoinNudgesJiraToJpd', createAnalyticsEvent);
                    if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') push('/jira/projects');
                    else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') showSuccessFlag();
                    else showErrorFlag('jira-product-discovery');
                } catch  {
                    showErrorFlag('jira-product-discovery');
                }
            };
            const isUserOptOut = await getNudgeState() === 'DISMISSED';
            const featureVisitedCount = await getVisitedCount();
            if (isUserOptOut || featureVisitedCount >= $d9661dec9418aa61$var$MAX_FEATURE_VISIT_COUNT) return;
            showRequestAccessPromptFlag({
                users: collaboratorsOnJpd,
                onSubmit: onSubmit,
                onOptout: setNudgeDismissed,
                snoozeFor30Days: snoozeFor30Days,
                integration: 'crossJoinNudgesJiraToJpd',
                featureVisitedCount: featureVisitedCount
            });
            increaseVisitedCount(featureVisitedCount + 1);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eRI0j.fireErrorAnalytics)('crossJoinNudgesJiraToJpd', error, {
                cloudId: cloudId
            });
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        getFilteredCollaborators,
        getNudgeState,
        getVisitedCount,
        increaseVisitedCount,
        push,
        setNudgeDismissed,
        showErrorFlag,
        showRequestAccessPromptFlag,
        showSuccessFlag,
        snoozeFor30Days,
        userId
    ]);
};

});
parcelRegister("2q33c", function(module, exports) {

$parcel$export(module.exports, "requestAccess", () => $340b4be4ceadd42a$export$cd9e5995821603e1);

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");

var $eRI0j = parcelRequire("eRI0j");
const $340b4be4ceadd42a$var$URL = '/gateway/api/invitations/v1/access-requests/request';
const $340b4be4ceadd42a$export$cd9e5995821603e1 = async (product, cloudId, userId, integration, createAnalyticsEvent)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    try {
        const response = await (0, $7f4tk.default)($340b4be4ceadd42a$var$URL, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource: resource
            })
        });
        const { results: results } = response;
        const result = results[resource];
        const analyticsAttributes = {
            userId: userId,
            products: [
                product
            ],
            inviteResult: [
                {
                    resourceAri: resource,
                    status: result
                }
            ],
            integration: integration
        };
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'productAccess requested', userId, analyticsAttributes);
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eRI0j.fireErrorAnalytics)(integration, error);
        throw new Error(`${integration} request access error`);
    }
};

});
parcelRegister("eRI0j", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $befbec547801077a$export$a27c21aa3ed8f0f1);
$parcel$export(module.exports, "fireSiteOptedOutAnalytics", () => $befbec547801077a$export$b6a30d1aef42926f);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
const $befbec547801077a$export$a27c21aa3ed8f0f1 = (id, error, attributes = {})=>(0, $jcw0u.default)({
        meta: {
            id: id,
            packageName: 'jiraCrossJoinNudges'
        },
        attributes: attributes,
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
const $befbec547801077a$export$b6a30d1aef42926f = (createAnalyticsEvent, integration)=>{
    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'eligibility checked', {
        flagKey: 'NON_CONTEXTUAL_CJNS',
        ineligibilityReason: 'SITE_OPTED_OUT',
        integration: integration
    });
};

});


parcelRegister("1e3dw", function(module, exports) {

$parcel$export(module.exports, "isFeatureVisited", () => $6d6d9cc23b530639$export$262c003deb93a450);
$parcel$export(module.exports, "snoozeFeatureFor30Days", () => $6d6d9cc23b530639$export$788659dbff920e5f);
$parcel$export(module.exports, "getFeatureVisitedCount", () => $6d6d9cc23b530639$export$64c6861c3bbd89a2);
$parcel$export(module.exports, "increaseFeatureVisitedCount", () => $6d6d9cc23b530639$export$41554dcbb74e65ef);
$parcel$export(module.exports, "useSnooze", () => $6d6d9cc23b530639$export$26ba987533188b38);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");

var $jcw0u = parcelRequire("jcw0u");

var $90yGq = parcelRequire("90yGq");

var $2lgIf = parcelRequire("2lgIf");
const $6d6d9cc23b530639$var$VISITED_COUNT_KEY = 'CROSS_JOIN_NUDGE_CONFLUENCE_VISITED_COUNT';
const $6d6d9cc23b530639$var$ONE_DAY_IN_MILLISECONDS = 86400000;
const $6d6d9cc23b530639$var$crossJoinNudgeVisitedCache = (0, $bSSG7.createLocalStorageProvider)('cross-join-nudge-visited');
const $6d6d9cc23b530639$var$visitedKeys = {
    crossJoinNudgesConfluence: 'cross.join.nudges.confluence.visited',
    crossJoinNudgesJiraToJpd: 'cross.join.nudges.jpd.visited',
    crossJoinNudgesYourWork: 'cross.join.nudges.your.work'
};
const $6d6d9cc23b530639$export$262c003deb93a450 = (integration, snoozeForDays)=>{
    try {
        if ($6d6d9cc23b530639$var$getFeatureVisited(integration)) return true;
        $6d6d9cc23b530639$var$setFeatureVisited(integration, snoozeForDays);
        // A small cohort of users have local storage completely disabled.
        // This code detects that and always returns visited=true for those users
        if (!$6d6d9cc23b530639$var$getFeatureVisited(integration)) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'featureVisitedLocalStorageNotAvailabe',
                    packageName: 'jiraCrossJoinNudges'
                }
            });
            return true;
        }
        return false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'useFeatureVisited',
                packageName: 'jiraCrossJoinNudges'
            },
            error: error,
            skipSentry: true,
            sendToPrivacyUnsafeSplunk: true
        });
        return true;
    }
};
const $6d6d9cc23b530639$var$setFeatureVisited = (integration, numOfDaysSnoozed)=>{
    const key = $6d6d9cc23b530639$var$visitedKeys[integration];
    const SNOOZE_UNTIL_TIMESTAMP = new Date().getTime() + $6d6d9cc23b530639$var$ONE_DAY_IN_MILLISECONDS * numOfDaysSnoozed;
    $6d6d9cc23b530639$var$crossJoinNudgeVisitedCache.set(key, SNOOZE_UNTIL_TIMESTAMP);
};
const $6d6d9cc23b530639$export$7a91674e4b755c4b = (integration)=>{
    $6d6d9cc23b530639$var$setFeatureVisited(integration, 7);
};
const $6d6d9cc23b530639$export$788659dbff920e5f = (integration)=>{
    $6d6d9cc23b530639$var$setFeatureVisited(integration, 30);
};
const $6d6d9cc23b530639$var$getFeatureVisited = (integration)=>{
    const key = $6d6d9cc23b530639$var$visitedKeys[integration];
    const snoozeUntilTimestampString = $6d6d9cc23b530639$var$crossJoinNudgeVisitedCache.get(key);
    if (snoozeUntilTimestampString !== null) {
        const SNOOZE_UNTIL_TIMESTAMP = parseInt(snoozeUntilTimestampString, 10);
        const TIMESTAMP = new Date().getTime();
        if (!Number.isNaN(SNOOZE_UNTIL_TIMESTAMP) && TIMESTAMP < SNOOZE_UNTIL_TIMESTAMP) return true;
    }
    return false;
};
const $6d6d9cc23b530639$export$64c6861c3bbd89a2 = async (accountId, propertyKey = $6d6d9cc23b530639$var$VISITED_COUNT_KEY)=>{
    if (!accountId) return 0;
    const visitedCount = await (0, $2lgIf.getUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        defaultValue: 0
    });
    return !Number.isNaN(visitedCount.value) ? visitedCount.value : 0;
};
const $6d6d9cc23b530639$export$41554dcbb74e65ef = async (accountId, incrementedCount, propertyKey = $6d6d9cc23b530639$var$VISITED_COUNT_KEY)=>{
    await (0, $2lgIf.setUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        propertyValue: incrementedCount
    });
};
const $6d6d9cc23b530639$export$26ba987533188b38 = (integration)=>{
    const key = $6d6d9cc23b530639$var$visitedKeys[integration];
    const accountId = (0, $90yGq.useAccountId)() || '';
    const countKey = `${key}.count`;
    return (0, $5uXOq.useMemo)(()=>({
            snoozeFor7Days: ()=>$6d6d9cc23b530639$export$7a91674e4b755c4b(integration),
            snoozeFor30Days: ()=>$6d6d9cc23b530639$export$788659dbff920e5f(integration),
            getVisitedCount: ()=>$6d6d9cc23b530639$export$64c6861c3bbd89a2(accountId, countKey),
            increaseVisitedCount: (incrementedCount)=>$6d6d9cc23b530639$export$41554dcbb74e65ef(accountId, incrementedCount, countKey),
            isVisited: ()=>$6d6d9cc23b530639$var$getFeatureVisited(integration)
        }), [
        accountId,
        countKey,
        integration
    ]);
};

});
parcelRegister("2lgIf", function(module, exports) {

$parcel$export(module.exports, "setUserProperty", () => $a2f0508e2b69d572$export$ba821ce5e177c7ef);
$parcel$export(module.exports, "getUserProperty", () => $a2f0508e2b69d572$export$b3126db2ef6e34ed);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $a2f0508e2b69d572$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $a2f0508e2b69d572$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $a2f0508e2b69d572$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $eusud.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: `SET_${propertyKey}`,
                packageName: 'jiraCrossJoinNudges'
            },
            error: error
        });
    }
};
const $a2f0508e2b69d572$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $a2f0508e2b69d572$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await (0, $eusud.performGetRequest)(url);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};

});


parcelRegister("dxdji", function(module, exports) {

$parcel$export(module.exports, "useUsersFromCollaborationGraph", () => $05df166a7944f9a9$export$b05786e1a14be004);
$parcel$export(module.exports, "useFilteredUsersFromCollaborationGraph", () => $05df166a7944f9a9$export$4509f086e4a8422);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $9OXo1 = parcelRequire("9OXo1");

var $62RUt = parcelRequire("62RUt");
const $05df166a7944f9a9$var$COLLABORATION_GRAPH_MAX_RESULTS = 50;
const $05df166a7944f9a9$export$b05786e1a14be004 = (cloudId)=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $9OXo1.useTenantContext)();
    return (0, $5uXOq.useCallback)(async ()=>{
        try {
            const payload = {
                context: {
                    contextType: 'crossJoinNudges',
                    principalId: atlassianAccountId,
                    siteId: cloudId
                },
                modelRequestParams: {
                    experience: 'CgUserNearbyUser'
                },
                expanded: true,
                maxNumberOfResults: $05df166a7944f9a9$var$COLLABORATION_GRAPH_MAX_RESULTS,
                userId: atlassianAccountId
            };
            const options = {
                body: JSON.stringify(payload)
            };
            return (0, $eusud.performPostRequest)('/gateway/api/collaboration/v1/collaborationgraph/user/user', options).then((entities)=>entities.collaborationGraphEntities.filter((en)=>en.userProfile !== undefined && en.userProfile?.account_type !== 'app' && en.userProfile?.account_status !== 'deactivated' && en.userProfile?.account_status !== 'deleted').map((en)=>({
                        id: en.userProfile.account_id,
                        name: en.userProfile.name,
                        avatar: en.userProfile.picture
                    })));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'useUsersFromCollaborationGraph',
                    packageName: 'jiraCrossJoinNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Get collaborators error');
        }
    }, [
        atlassianAccountId,
        cloudId
    ]);
};
const $05df166a7944f9a9$export$4509f086e4a8422 = (cloudId, targetProduct, maxCollaborators)=>{
    const getCollaborators = $05df166a7944f9a9$export$b05786e1a14be004(cloudId);
    return (0, $5uXOq.useCallback)(async ()=>{
        const collaborators = await getCollaborators();
        let collaboratorsOnTargetProduct;
        if (targetProduct === 'confluence') collaboratorsOnTargetProduct = await (0, $62RUt.getConfluenceUsers)(collaborators, cloudId);
        else collaboratorsOnTargetProduct = await (0, $62RUt.getUsersWithProductAccess)(cloudId, targetProduct, collaborators);
        return collaboratorsOnTargetProduct.slice(0, maxCollaborators);
    }, [
        cloudId,
        getCollaborators,
        targetProduct,
        maxCollaborators
    ]);
};

});
parcelRegister("62RUt", function(module, exports) {

$parcel$export(module.exports, "getConfluenceUsers", () => $1080fa8edae179da$export$71bcfe5bb11155f7);
$parcel$export(module.exports, "getUsersWithProductAccess", () => $1080fa8edae179da$export$a68fadaa3a8b5e25);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");
const $1080fa8edae179da$var$URL = '/gateway/api/growth/cross-join-nudges-confluence/get-permitted-confluence-users';
const $1080fa8edae179da$export$71bcfe5bb11155f7 = async (collaborators, cloudId)=>{
    try {
        if (!collaborators || collaborators.length === 0) return [];
        const accountIds = collaborators.map((c)=>c.id);
        const confluenceUsers = await (0, $7f4tk.default)($1080fa8edae179da$var$URL, {
            method: 'POST',
            body: JSON.stringify({
                cloudId: cloudId,
                accountIds: accountIds
            })
        });
        return collaborators.filter((c)=>confluenceUsers.includes(c.id));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'getConfluenceUsers',
                packageName: 'jiraCrossJoinNudges'
            },
            attributes: {
                cloudId: cloudId,
                accountIds: JSON.stringify(collaborators.map((c)=>c.id)),
                errorResponse: $1080fa8edae179da$var$getErrorResponse(error)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw new Error('Get Confluence users error');
    }
};
const $1080fa8edae179da$var$getErrorResponse = (error)=>{
    try {
        return JSON.stringify(error);
    } catch (e) {
        // Swallow error as the error is already in the analytic event.
        return undefined;
    }
};
const $1080fa8edae179da$var$getInviteesUrl = '/gateway/api/growth/invite-on-link-insert/get-invitees';
const $1080fa8edae179da$export$a68fadaa3a8b5e25 = async (cloudId, product, collaborators)=>{
    const accountIds = collaborators.map((u)=>u.id);
    const lackingAccess = await (0, $7f4tk.default)($1080fa8edae179da$var$getInviteesUrl, {
        method: 'POST',
        body: JSON.stringify({
            cloudId: cloudId,
            product: product,
            accountIds: accountIds
        })
    });
    return collaborators.filter((c)=>!lackingAccess.includes(c.id));
};

});


parcelRegister("3yRDf", function(module, exports) {

$parcel$export(module.exports, "checkJpdCrossJoinNudgeEligibility", () => $d99d20f3b9663c7b$export$db3bc6af881f6bd0);

var $iVil7 = parcelRequire("iVil7");

var $e1J1K = parcelRequire("e1J1K");

var $8mTEW = parcelRequire("8mTEW");

var $aLcWc = parcelRequire("aLcWc");
const $d99d20f3b9663c7b$export$db3bc6af881f6bd0 = async ({ cloudId: cloudId, licensedProducts: licensedProducts })=>{
    if (!licensedProducts['jira-product-discovery']) return {
        eligible: false,
        ineligibilityReason: 'NO_JPD_LICENCE'
    };
    if (await (0, $aLcWc.isSiteOptedOut)(cloudId)) return {
        eligible: false,
        ineligibilityReason: 'SITE_OPTED_OUT'
    };
    if (!await (0, $8mTEW.isSite7DaysOld)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'NEW_SITE_LESS_THAN_7_DAYS_OLD'
    };
    if (await (0, $iVil7.hasProductAccess)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'ALREADY_HAVE_ACCESS'
    };
    if (!await (0, $e1J1K.fetchIsRequestAccessCapable)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'NOT_ELIGIBLE_FOR_REQUEST_ACCESS'
    };
    return {
        eligible: true
    };
};

});
parcelRegister("iVil7", function(module, exports) {

$parcel$export(module.exports, "hasProductAccess", () => $543bba9bf251c6d1$export$61073fd69a83a1e3);
$parcel$export(module.exports, "fetchCachedAccessCheck", () => $543bba9bf251c6d1$export$cd2f9bc003d00b45);

var $bSSG7 = parcelRequire("bSSG7");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");
const $543bba9bf251c6d1$var$URL = '/gateway/api/permissions/permitted';
const $543bba9bf251c6d1$export$61073fd69a83a1e3 = async (product, cloudId)=>{
    const data = {
        permissionId: 'write',
        resourceId: `ari:cloud:${product}::site/${cloudId}`
    };
    const response = await (0, $7f4tk.default)($543bba9bf251c6d1$var$URL, {
        method: 'POST',
        body: JSON.stringify(data)
    });
    return response.permitted;
};
// Purposefully set this to 7 days as it's unlikely user can be kicked out of Confluence when they already have access
const $543bba9bf251c6d1$var$PERMISSION_CACHE_KEY_EXPIRY_MS = 604800000;
const $543bba9bf251c6d1$var$crossJoinApiCache = (0, $bSSG7.createLocalExpirableStorageProvider)('cross-join-nudge-conf-perms-api-cache');
const $543bba9bf251c6d1$export$cd2f9bc003d00b45 = async (createAnalyticsEvent, product, cloudId, touchpoint)=>{
    const cacheKey = `cross.join.${product}.cache.key`;
    let permissionResponse = $543bba9bf251c6d1$var$crossJoinApiCache.get(cacheKey);
    if (permissionResponse === undefined) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck cacheMiss', {
            touchpoint: touchpoint,
            product: product
        });
        try {
            permissionResponse = await $543bba9bf251c6d1$export$61073fd69a83a1e3(product, cloudId);
        } catch (err) {
            // No PII from identity exception so fire operational analytics consistently
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck fetchError', {
                touchpoint: touchpoint,
                product: product,
                err: err,
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true
            });
            return null;
        }
        try {
            $543bba9bf251c6d1$var$crossJoinApiCache.set(cacheKey, permissionResponse, Date.now() + $543bba9bf251c6d1$var$PERMISSION_CACHE_KEY_EXPIRY_MS);
        } catch (err) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck setError', {
                touchpoint: touchpoint,
                product: product,
                err: err,
                skipSentry: true
            });
            return permissionResponse;
        }
        return permissionResponse;
    }
    (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck cacheHit', {
        touchpoint: touchpoint,
        product: product
    });
    return permissionResponse;
};

});

parcelRegister("e1J1K", function(module, exports) {

$parcel$export(module.exports, "fetchIsRequestAccessCapable", () => $b1d9429bb117b963$export$c75518284e8dee24);
$parcel$export(module.exports, "fetchCachedIsConfluenceRACapable", () => $b1d9429bb117b963$export$f5767c68446c14cb);
$parcel$export(module.exports, "resetRACapableCache", () => $b1d9429bb117b963$export$5191fc85eb825b4b);

var $bSSG7 = parcelRequire("bSSG7");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");
const $b1d9429bb117b963$export$c75518284e8dee24 = async (product, cloudId)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    const params = new URLSearchParams({
        resource: resource
    });
    const URL = `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
    const response = await (0, $7f4tk.default)(URL, {
        credentials: 'include'
    });
    const requestCapabilities = response.results[resource];
    return requestCapabilities === 'DIRECT_ACCESS' || requestCapabilities === 'REQUEST_ACCESS';
};
const $b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY = 'cross.join.confluence-capabilities.cache.key';
// This is set to 1 day only as capabilties has many more states e.g PENDING_REQUEST_EXISTS, APPROVED_REQUEST_EXISTS etc
// We expect capabilities to change more often than product access
const $b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY_EXPIRY_MS = 86400000;
const $b1d9429bb117b963$var$crossJoinApiCache = (0, $bSSG7.createLocalExpirableStorageProvider)('cross-join-nudge-conf-capabilities-api-cache');
const $b1d9429bb117b963$export$f5767c68446c14cb = async (createAnalyticsEvent, cloudId, touchpoint)=>{
    let isRACapable = $b1d9429bb117b963$var$crossJoinApiCache.get($b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY);
    if (isRACapable === undefined) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck cacheMiss', {
            touchpoint: touchpoint
        });
        try {
            isRACapable = await $b1d9429bb117b963$export$c75518284e8dee24('confluence', cloudId);
        } catch (err) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck fetchError', {
                touchpoint: touchpoint,
                err: err,
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true
            });
            return null;
        }
        $b1d9429bb117b963$export$a901680cf5ecfb6c(createAnalyticsEvent, isRACapable, touchpoint);
        return isRACapable;
    }
    (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck cacheHit', {
        touchpoint: touchpoint
    });
    return isRACapable;
};
const $b1d9429bb117b963$export$a901680cf5ecfb6c = (createAnalyticsEvent, value, touchpoint)=>{
    try {
        $b1d9429bb117b963$var$crossJoinApiCache.set($b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY, value, Date.now() + $b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY_EXPIRY_MS);
    } catch (err) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck setError', {
            touchpoint: touchpoint,
            err: err,
            skipSentry: true
        });
    }
};
const $b1d9429bb117b963$export$5191fc85eb825b4b = ()=>{
    $b1d9429bb117b963$var$crossJoinApiCache.remove($b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY);
};

});

parcelRegister("8mTEW", function(module, exports) {

$parcel$export(module.exports, "isSite7DaysOld", () => $f2be65df141d6690$export$23b7746c9e6ae406);

var $jX0pr = parcelRequire("jX0pr");
const $f2be65df141d6690$var$ACTIVATION_TRAITS = {
    confluence: 'confluence.ondemand.activationDate',
    'jira-product-discovery': 'jira-product-discovery.activationDate'
};
const $f2be65df141d6690$export$23b7746c9e6ae406 = async (product, cloudId)=>{
    const siteTraits = await (0, $jX0pr.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    return $f2be65df141d6690$var$findAndCheckActivationDate(product, siteTraits);
};
const $f2be65df141d6690$var$findAndCheckActivationDate = (product, traits)=>{
    const traitName = $f2be65df141d6690$var$ACTIVATION_TRAITS[product] || undefined;
    if (!traitName) throw Error(`Unknown activation trait key for site product ${product}`);
    const activationTrait = traits.find((trait)=>trait.name === traitName);
    if (activationTrait?.value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const oneWeekLaterActivation = new Date(activationTrait?.value);
        oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
        const today = new Date();
        return today >= oneWeekLaterActivation;
    }
    return false;
};

});

parcelRegister("aLcWc", function(module, exports) {

$parcel$export(module.exports, "isSiteOptedOut", () => $8240992145844482$export$3475487c10c1ac17);

var $jX0pr = parcelRequire("jX0pr");
const $8240992145844482$export$3475487c10c1ac17 = async (cloudId)=>{
    const siteTraits = await (0, $jX0pr.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    const optoutTraitValue = siteTraits.find((trait)=>trait.name === 'optout_all_messages')?.value;
    return typeof optoutTraitValue === 'boolean' && optoutTraitValue;
};

});


parcelRegister("kB1IK", function(module, exports) {

$parcel$export(module.exports, "useNudgeStateV2a", () => $b95457efaa0607a0$export$1721ab60f4854021);
$parcel$export(module.exports, "useNudgeStateYourWork", () => $b95457efaa0607a0$export$766742495b6411cb);
$parcel$export(module.exports, "useNudgeStateJiraToJpd", () => $b95457efaa0607a0$export$13bdd3f195e673d5);

var $5uXOq = parcelRequire("5uXOq");

var $90yGq = parcelRequire("90yGq");

var $2lgIf = parcelRequire("2lgIf");
const $b95457efaa0607a0$var$getNudgeState = async (key, accountId)=>{
    if (!accountId) return 'NONE';
    const nudgeState = await (0, $2lgIf.getUserProperty)({
        accountId: accountId,
        propertyKey: key,
        defaultValue: 'NONE'
    });
    return nudgeState.value;
};
const $b95457efaa0607a0$var$setNudgeDismissState = async (key, accountId)=>{
    if (!accountId) return;
    await (0, $2lgIf.setUserProperty)({
        accountId: accountId,
        propertyKey: key,
        propertyValue: 'DISMISSED'
    });
};
const $b95457efaa0607a0$var$useNudgeState = (key)=>{
    const accountId = (0, $90yGq.useAccountId)();
    return (0, $5uXOq.useMemo)(()=>({
            getNudgeState: ()=>$b95457efaa0607a0$var$getNudgeState(key, accountId),
            setNudgeDismissed: ()=>$b95457efaa0607a0$var$setNudgeDismissState(key, accountId)
        }), [
        accountId,
        key
    ]);
};
const $b95457efaa0607a0$export$1721ab60f4854021 = ()=>$b95457efaa0607a0$var$useNudgeState('CROSS_JOIN_NUDGES_CONFLUENCE_V2A');
const $b95457efaa0607a0$export$766742495b6411cb = ()=>$b95457efaa0607a0$var$useNudgeState('CROSS_JOIN_NUDGES_YOUR_WORK');
const $b95457efaa0607a0$export$13bdd3f195e673d5 = ()=>$b95457efaa0607a0$var$useNudgeState('CROSS_JOIN_NUDGES_JIRA_TO_JPD');

});

parcelRegister("j2ykK", function(module, exports) {

$parcel$export(module.exports, "useNudgeRecommendations", () => $121d391ba9d9ad8d$export$20e6812ba5f3fc39);

var $5uXOq = parcelRequire("5uXOq");

var $7uvRP = parcelRequire("7uvRP");

var $jcw0u = parcelRequire("jcw0u");

var $16v4H = parcelRequire("16v4H");

var $koeKL = parcelRequire("koeKL");

var $j68Ae = parcelRequire("j68Ae");
const $121d391ba9d9ad8d$var$CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE = 'crossJoinNudge';
function $121d391ba9d9ad8d$export$20e6812ba5f3fc39({ sessionId: sessionId }) {
    const cloudId = (0, $koeKL.useCloudId)();
    const subProduct = (0, $16v4H.useSubProduct)();
    const contextResolver = (0, $5uXOq.useCallback)(()=>({
            product: 'jira',
            useCase: $121d391ba9d9ad8d$var$CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE,
            tenantId: cloudId,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            subproduct: subProduct,
            sessionId: sessionId
        }), [
        cloudId,
        subProduct,
        sessionId
    ]);
    const { getRecommendations: getRecommendations } = (0, $7uvRP.default)({
        contextResolver: contextResolver
    });
    return (0, $5uXOq.useCallback)(async ()=>{
        try {
            const result = await getRecommendations(1, $121d391ba9d9ad8d$var$asEntityIdList((0, $j68Ae.EntityList)));
            const { response: { data: data } = {} } = result;
            // This type assertion is necessary because useRecommendations don't support generic entityId
            const recommendedEntityId = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            data && data.length > 0 && data[0].entityId || undefined;
            return recommendedEntityId;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'recommendationFetchFailed',
                    packageName: 'jiraCrossJoinNudges',
                    teamName: 'groot-growth'
                },
                error: error
            });
            throw new Error('Get nudge recommendations error');
        }
    }, [
        getRecommendations
    ]);
}
const $121d391ba9d9ad8d$var$asEntityIdList = (entities)=>entities.map((entity)=>({
            entityId: entity
        }));

});
parcelRegister("j68Ae", function(module, exports) {

$parcel$export(module.exports, "EntityList", () => $06f3a0084a41bde1$export$8bb466c13870163e);
$parcel$export(module.exports, "getDynamicMessages", () => $06f3a0084a41bde1$export$b916a1b5c615f6eb);

var $rrn66 = parcelRequire("rrn66");
const $06f3a0084a41bde1$export$8bb466c13870163e = [
    'nudgeCandidate01',
    'nudgeCandidate02',
    'nudgeCandidate03',
    'nudgeCandidate04',
    'nudgeCandidate05',
    'nudgeCandidate06',
    'nudgeCandidate07'
];
const $06f3a0084a41bde1$var$messageVariantsKeyMap = {
    default: {
        title: 'title',
        description: 'description',
        joinButton: 'joinButton'
    },
    nudgeCandidate01: {
        title: 'titleNudgeCandidate01',
        description: 'descriptionNudgeCandidate01',
        joinButton: 'joinButtonNudgeCandidate01'
    },
    nudgeCandidate02: {
        title: 'titleNudgeCandidate02',
        description: 'descriptionNudgeCandidate02',
        joinButton: 'joinButtonNudgeCandidate02'
    },
    nudgeCandidate03: {
        title: 'titleNudgeCandidate03',
        description: 'descriptionNudgeCandidate03',
        joinButton: 'joinButtonNudgeCandidate03'
    },
    nudgeCandidate04: {
        title: 'titleNudgeCandidate04',
        description: 'descriptionNudgeCandidate04',
        joinButton: 'joinButtonNudgeCandidate04'
    },
    nudgeCandidate05: {
        title: 'titleNudgeCandidate05',
        description: 'descriptionNudgeCandidate05',
        joinButton: 'joinButtonNudgeCandidate05'
    },
    nudgeCandidate06: {
        title: 'titleNudgeCandidate06',
        description: 'descriptionNudgeCandidate06',
        joinButton: 'joinButtonNudgeCandidate06'
    },
    nudgeCandidate07: {
        title: 'titleNudgeCandidate07',
        description: 'descriptionNudgeCandidate07',
        joinButton: 'joinButtonNudgeCandidate07'
    }
};
const $06f3a0084a41bde1$export$b916a1b5c615f6eb = (isContextualBandit, entityId)=>{
    // Handle case when entityId is unexpected
    if (!(entityId in $06f3a0084a41bde1$var$messageVariantsKeyMap)) return undefined;
    // If v2B is not enabled we just passthrough default message keys
    const usedEntityId = isContextualBandit ? entityId : 'default';
    const titleKey = $06f3a0084a41bde1$var$messageVariantsKeyMap[usedEntityId].title;
    const descriptionKey = $06f3a0084a41bde1$var$messageVariantsKeyMap[usedEntityId].description;
    const joinButtonKey = $06f3a0084a41bde1$var$messageVariantsKeyMap[usedEntityId].joinButton;
    return {
        title: (0, $rrn66.messages)[titleKey],
        description: (0, $rrn66.messages)[descriptionKey],
        joinButton: (0, $rrn66.messages)[joinButtonKey]
    };
};

});
parcelRegister("rrn66", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7f6fd96fbb5dfa11$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7f6fd96fbb5dfa11$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title",
        "defaultMessage": "Your team is now using Confluence"
    },
    titleNudgeCandidate01: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-01",
        "defaultMessage": "Join your teammates in Confluence"
    },
    titleNudgeCandidate02: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-02",
        "defaultMessage": "Collaborate together in Confluence"
    },
    titleNudgeCandidate03: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-03",
        "defaultMessage": "Your team is working in Confluence"
    },
    titleNudgeCandidate04: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-04",
        "defaultMessage": "Unify your projects in Confluence"
    },
    titleNudgeCandidate05: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-05",
        "defaultMessage": "Bring projects together in Confluence"
    },
    titleNudgeCandidate06: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-06",
        "defaultMessage": "Create a single source of truth"
    },
    titleNudgeCandidate07: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-07",
        "defaultMessage": "Create a single source of truth"
    },
    description: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description",
        "defaultMessage": "Organize team knowledge, capture ideas, and share requirements for your Jira projects."
    },
    descriptionNudgeCandidate01: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-01",
        "defaultMessage": "Create a single source of truth for project decisions and software documentation."
    },
    descriptionNudgeCandidate02: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-02",
        "defaultMessage": "Capture, consolidate, and share team knowledge, in one centralized place."
    },
    descriptionNudgeCandidate03: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-03",
        "defaultMessage": "Create project pages to build a shared understanding for better decision-making."
    },
    descriptionNudgeCandidate04: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-04",
        "defaultMessage": "Organize project information and sync it to Jira tasks to track and hit your goals faster."
    },
    descriptionNudgeCandidate05: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-05",
        "defaultMessage": "Capture information in project pages and sync to Jira tasks to track your milestones."
    },
    descriptionNudgeCandidate06: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-06",
        "defaultMessage": "Consolidate information in one place and sync to Jira tasks for automatic updates."
    },
    descriptionNudgeCandidate07: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-07",
        "defaultMessage": "Join your team in Confluence to consolidate project information in one place."
    },
    joinButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate01: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-01",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate02: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-02",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate03: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-03",
        "defaultMessage": "Join your team"
    },
    joinButtonNudgeCandidate04: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-04",
        "defaultMessage": "Join Confluence"
    },
    joinButtonNudgeCandidate05: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-05",
        "defaultMessage": "Join Confluence"
    },
    joinButtonNudgeCandidate06: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-06",
        "defaultMessage": "Join Confluence"
    },
    joinButtonNudgeCandidate07: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-07",
        "defaultMessage": "Join Confluence"
    },
    remindMeLaterButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.remind-me-later-button",
        "defaultMessage": "Remind me later"
    },
    notInterestedButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.not-interested-button",
        "defaultMessage": "Not interested"
    },
    urgencyTitle: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.urgency-title",
        "defaultMessage": "{viewCount, select, 0 {Your team is now using Confluence} 1 {Your team is working in Confluence} other {Your team is waiting for you in Confluence}}"
    },
    titleJpdNudge: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.title-jpd-nudge",
        "defaultMessage": "Join your team in using Jira Product Discovery"
    },
    descriptionJpdNudge: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.description-jpd-nudge",
        "defaultMessage": "Prioritize ideas, share custom roadmaps, and unify your workflow from discovery to delivery."
    },
    getStartedButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.get-started-button",
        "defaultMessage": "Get started"
    },
    doNotShowAgainButton: {
        "id": "cross-join-nudges.common.request-access-prompt-flag.do-not-show-again-button",
        "defaultMessage": "Don't show again"
    }
});

});



parcelRegister("25NDO", function(module, exports) {

$parcel$export(module.exports, "useCollaborators", () => $e74b148a91bec82c$export$1ccc4f4de0326402);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $koeKL = parcelRequire("koeKL");

var $dxdji = parcelRequire("dxdji");

var $62RUt = parcelRequire("62RUt");
const $e74b148a91bec82c$export$1ccc4f4de0326402 = (isEnrolled)=>{
    const [collaborators, setCollaborators] = (0, $5uXOq.useState)([]);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const cloudId = (0, $koeKL.useCloudId)();
    const getCollaborators = (0, $dxdji.useUsersFromCollaborationGraph)(cloudId);
    (0, $5uXOq.useEffect)(()=>{
        const fetch = async ()=>{
            try {
                const users = await getCollaborators();
                if (!!users && users.length !== 0) {
                    const confluenceUsers = await (0, $62RUt.getConfluenceUsers)(users, cloudId);
                    setCollaborators(confluenceUsers);
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useCollaborators',
                        packageName: 'jiraCrossJoinNudges'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } finally{
                setIsLoading(false);
            }
        };
        if (isEnrolled) fetch();
    }, [
        cloudId,
        getCollaborators,
        isEnrolled
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            collaborators: collaborators,
            isLoading: isLoading
        }), [
        collaborators,
        isLoading
    ]);
};

});

parcelRegister("iu3ma", function(module, exports) {

$parcel$export(module.exports, "useVisitedCount", () => $4e26577f827b3885$export$fb7c0ffa45d7cd29);

var $5uXOq = parcelRequire("5uXOq");

var $1e3dw = parcelRequire("1e3dw");
const $4e26577f827b3885$export$fb7c0ffa45d7cd29 = (isEnrolled, integration)=>{
    const [visitedCount, setVisitedCount] = (0, $5uXOq.useState)(0);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const { getVisitedCount: getVisitedCount } = (0, $1e3dw.useSnooze)(integration);
    (0, $5uXOq.useEffect)(()=>{
        const fetch = async ()=>{
            const count = await getVisitedCount();
            setVisitedCount(count);
            setIsLoading(false);
        };
        if (isEnrolled) fetch();
    }, [
        getVisitedCount,
        isEnrolled
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            visitedCount: visitedCount,
            isLoading: isLoading
        }), [
        visitedCount,
        isLoading
    ]);
};

});

parcelRegister("fVgtE", function(module, exports) {

$parcel$export(module.exports, "useRequestAccessErrorFlag", () => $c964d6607e689cdd$export$d8e2d94eec4efe85);

var $5uXOq = parcelRequire("5uXOq");

var $fHfPB = parcelRequire("fHfPB");
var $3KRpp = parcelRequire("3KRpp");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $jiuN9 = parcelRequire("jiuN9");

var $dcbMS = parcelRequire("dcbMS");

var $jhRnv = parcelRequire("jhRnv");
const $c964d6607e689cdd$export$d8e2d94eec4efe85 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagService)();
    return (0, $5uXOq.useCallback)((product)=>{
        const id = `error-${(0, $dcbMS.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $fHfPB.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c964d6607e689cdd$export$e1d0d64874873c8b, {
                    ...props,
                    id: id,
                    product: product,
                    onDismiss: dismiss
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $c964d6607e689cdd$var$JIRA_SUPPORT_LINK = 'https://support.atlassian.com/contact/';
const $c964d6607e689cdd$export$e1d0d64874873c8b = ({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.ErrorFlag), {
        ...props,
        onDismissed: onDismiss,
        title: formatMessage((0, $jhRnv.messages).title, {
            productDisplayName: (0, $jiuN9.ProductDisplayNames)[props.product]
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $jhRnv.messages).description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            href: $c964d6607e689cdd$var$JIRA_SUPPORT_LINK
        }, formatMessage((0, $jhRnv.messages).action)), "."))
    });
};

});
parcelRegister("jiuN9", function(module, exports) {

$parcel$export(module.exports, "ProductDisplayNames", () => $27198ad0b5fea339$export$46d857911d19ac95);
const $27198ad0b5fea339$export$46d857911d19ac95 = {
    confluence: 'Confluence',
    'jira-product-discovery': 'Jira Product Discovery'
};

});

parcelRegister("dcbMS", function(module, exports) {

$parcel$export(module.exports, "generateId", () => $390ca3140b8da28e$export$567fc7097e064344);
let $390ca3140b8da28e$var$id = 0;
const $390ca3140b8da28e$export$567fc7097e064344 = ()=>{
    $390ca3140b8da28e$var$id += 1;
    return String($390ca3140b8da28e$var$id);
};

});

parcelRegister("jhRnv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1a71831a465b380b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $1a71831a465b380b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "cross-join-nudges.request-access-error-flag.title",
        "defaultMessage": "We couldn't add you to {productDisplayName}"
    },
    description: {
        "id": "cross-join-nudges.request-access-error-flag.description",
        "defaultMessage": "Try again in a few minutes. If you still aren't able to join, "
    },
    action: {
        "id": "cross-join-nudges.request-access-error-flag.action",
        "defaultMessage": "contact support"
    }
});

});


parcelRegister("eCsnX", function(module, exports) {

$parcel$export(module.exports, "useRequestAccessPromptFlag", () => $3517fb24263f5c55$export$233a6a0aca8c9091);

var $5uXOq = parcelRequire("5uXOq");

var $fHfPB = parcelRequire("fHfPB");
var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $90yGq = parcelRequire("90yGq");

var $koVbs = parcelRequire("koVbs");

var $j68Ae = parcelRequire("j68Ae");

var $dcbMS = parcelRequire("dcbMS");

var $rrn66 = parcelRequire("rrn66");

var $c62ZK = parcelRequire("c62ZK");
const $3517fb24263f5c55$export$233a6a0aca8c9091 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const userId = (0, $90yGq.useAccountId)() || '';
    return (0, $5uXOq.useCallback)(({ users: users, onOptout: onOptout, onSubmit: onSubmit, snoozeFor30Days: snoozeFor30Days, integration: integration, isContextualBandit: isContextualBandit = false, entityId: entityId = 'default', sessionId: sessionId = '', featureVisitedCount: featureVisitedCount = 0 })=>{
        const id = `request-access-${(0, $dcbMS.generateId)()}`;
        const dismissTheFlag = ()=>dismissFlag((0, $fHfPB.dismissFlag)(id));
        const eventAttributes = {
            collaborators: users.length,
            userId: userId,
            isContextualBandit: isContextualBandit,
            entityId: entityId,
            sessionId: sessionId,
            featureVisitedCount: featureVisitedCount
        };
        const submit = async ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', integration, eventAttributes);
            dismissTheFlag();
            await onSubmit();
        };
        const dismiss = ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'flag dismissed', integration, eventAttributes);
            dismissTheFlag();
        };
        const dismissAndOptout = ()=>{
            dismiss();
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'flag optedOut', integration, eventAttributes);
            onOptout();
        };
        const dismissAndSnooze = ()=>{
            dismissTheFlag();
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'flag snoozed', integration, eventAttributes);
            snoozeFor30Days();
        };
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'nudge viewed', integration, eventAttributes);
        const cjnMessages = $3517fb24263f5c55$export$690fb20bf40f4dd8(formatMessage, integration, isContextualBandit, entityId, featureVisitedCount);
        const avatarOrientation = integration === 'crossJoinNudgesJiraToJpd' ? 'horizontal' : 'vertical';
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c62ZK.RequestAccessPromptFlag), {
                    ...props,
                    id: id,
                    users: users,
                    onDismiss: dismiss,
                    onSnoozeAndDismiss: dismissAndSnooze,
                    onOptoutAndDismiss: dismissAndOptout,
                    onSubmit: submit,
                    avatarOrientation: avatarOrientation,
                    messages: cjnMessages,
                    featureVisitedCount: featureVisitedCount
                })
        });
    }, [
        formatMessage,
        createAnalyticsEvent,
        dismissFlag,
        showFlag,
        userId
    ]);
};
const $3517fb24263f5c55$export$690fb20bf40f4dd8 = (formatMessage, integration, isContextualBandit, entityId, featureVisitedCount)=>{
    if (integration === 'crossJoinNudgesJiraToJpd') return {
        title: formatMessage((0, $rrn66.messages).titleJpdNudge),
        description: formatMessage((0, $rrn66.messages).descriptionJpdNudge),
        joinButton: formatMessage((0, $rrn66.messages).getStartedButton),
        remindMeLaterButton: formatMessage((0, $rrn66.messages).remindMeLaterButton),
        notInterestedButton: formatMessage((0, $rrn66.messages).doNotShowAgainButton)
    };
    if (integration === 'crossJoinNudgesConfluence') {
        const dynamicMessages = (0, $j68Ae.getDynamicMessages)(isContextualBandit, entityId) || (0, $rrn66.messages);
        const infoFlagTitle = isContextualBandit ? formatMessage((0, $rrn66.messages).title) : formatMessage((0, $rrn66.messages).urgencyTitle, {
            viewCount: featureVisitedCount
        });
        return {
            title: infoFlagTitle,
            description: formatMessage(dynamicMessages.description),
            joinButton: formatMessage(dynamicMessages.joinButton),
            remindMeLaterButton: formatMessage((0, $rrn66.messages).remindMeLaterButton),
            notInterestedButton: formatMessage((0, $rrn66.messages).notInterestedButton)
        };
    }
    throw new Error(`Unexpected integration ${integration}`);
};

});
parcelRegister("c62ZK", function(module, exports) {

$parcel$export(module.exports, "RequestAccessPromptFlag", () => $d6fe99398ee70a31$export$9b8813c3601640da);
/* flag-common.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $k01Ou = parcelRequire("k01Ou");

var $2Eqc8 = parcelRequire("2Eqc8");
var $gVM6m = parcelRequire("gVM6m");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");

var $3KRpp = parcelRequire("3KRpp");

var $2zDkN = parcelRequire("2zDkN");

var $9Rp90 = parcelRequire("9Rp90");
const $d6fe99398ee70a31$export$9b8813c3601640da = ({ users: users, onSubmit: onSubmit, onDismiss: onDismiss, onOptoutAndDismiss: onOptoutAndDismiss, onSnoozeAndDismiss: onSnoozeAndDismiss, messages: messages, avatarOrientation: avatarOrientation, featureVisitedCount: featureVisitedCount, ...props })=>{
    const handleOnSubmit = (0, $5uXOq.useCallback)(async ()=>{
        await onSubmit();
    }, [
        onSubmit
    ]);
    const customFlagFooterProps = (0, $5uXOq.useMemo)(()=>({
            // Workaround to achieve primary button + avatars in the footer.
            //
            // How this works:
            // We pass a dummy `action` that gets displayed in the Flag's footer
            // by the custom `linkComponent`. The component displays our actual footer.
            // This way, we don't occupy the limited space inside `description`.
            //
            // Why not use `actions` normally?
            // Because our Avatar Group is not an action, and even our Submit button
            // should be bold & blue (appearance="primary") which is not supported
            // by the AK Flag.
            //
            // Why not put this in `description`?
            // Because that one has a max height equivalent to 5 lines of text,
            // and our footer is taller than 2, causing an unwanted scrollbar
            // to show.
            actions: [
                {
                    content: '',
                    onClick: (0, $2zDkN.noop)
                }
            ],
            linkComponent: ()=>{
                let secondETA = null;
                if (featureVisitedCount === 1) secondETA = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gVM6m.default), {
                    xcss: $d6fe99398ee70a31$var$linkButtonStyles,
                    onClick: onSnoozeAndDismiss
                }, messages.remindMeLaterButton);
                else if (featureVisitedCount > 1) secondETA = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gVM6m.default), {
                    xcss: $d6fe99398ee70a31$var$linkButtonStyles,
                    onClick: onOptoutAndDismiss
                }, messages.notInterestedButton);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
                    alignInline: "start",
                    grow: "fill",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gVM6m.default), {
                    xcss: $d6fe99398ee70a31$var$linkButtonStyles,
                    onClick: handleOnSubmit
                }, messages.joinButton), !!secondETA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                    className: (0, $bwpsq.default)([
                        "_1kt95qml _fntnutpp _eid3utpp"
                    ])
                }), secondETA);
            }
        }), [
        featureVisitedCount,
        handleOnSubmit,
        messages,
        onSnoozeAndDismiss,
        onOptoutAndDismiss
    ]);
    const customIcon = (0, $5uXOq.useMemo)(()=>{
        return users.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Rp90.FlagCompatibleAvatarGroup), {
            alignment: avatarOrientation,
            maxAvatarCount: 2,
            tooltipPosition: "bottom",
            data: users.map((user)=>({
                    name: user.name,
                    src: user.avatar,
                    appearance: 'circle'
                })),
            size: "small",
            boundariesElement: "scrollParent"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k01Ou))), {
            spacing: "spacious",
            color: "var(--ds-icon-information, #1D7AFC)",
            label: ""
        });
    }, [
        users,
        avatarOrientation
    ]);
    const FLAG_MESSAGE_TYPE = 'marketing';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.InfoFlag), {
        ...props,
        ...customFlagFooterProps,
        onDismissed: featureVisitedCount === 0 ? onDismiss : onSnoozeAndDismiss,
        title: messages.title,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
            className: (0, $bwpsq.default)([
                "_1reoewfl _18m9ewfl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0ccj1k _1yyj11wp _sudp1e54 _otyru2gc"
            ])
        }, messages.description)),
        icon: customIcon,
        messageType: FLAG_MESSAGE_TYPE,
        messageId: "cross-join-nudges.ui.request-access-prompt-flag.info-flag.request-access-prompt-flag"
    });
};
const $d6fe99398ee70a31$var$linkButtonStyles = (0, $2s57o.xcss)({
    maxWidth: '150',
    maxHeight: '3lh',
    overflow: 'hidden',
    color: 'color.link',
    backgroundColor: 'color.background.neutral.subtle',
    borderWidth: '0',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    cursor: 'pointer',
    padding: '0',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $d6fe99398ee70a31$var$linkButtonSeparatorStyles = null;
const $d6fe99398ee70a31$var$mainContentContainerStyles = null;

});
parcelRegister("2zDkN", function(module, exports) {

$parcel$export(module.exports, "noop", () => $8dec5faa18776ff2$export$8793edee2d425525);
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $8dec5faa18776ff2$export$8793edee2d425525 = ()=>{};

});

parcelRegister("9Rp90", function(module, exports) {

$parcel$export(module.exports, "FlagCompatibleAvatarGroup", () => $28afe71c94c1415f$export$29beada2d5f93289);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cnu9t = parcelRequire("cnu9t");

var $44cng = parcelRequire("44cng");

var $2zDkN = parcelRequire("2zDkN");
const $28afe71c94c1415f$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED = 99;
const $28afe71c94c1415f$var$OVERFLOW_USER_MARKER = '$$$overflow-user-marker';
const $28afe71c94c1415f$export$29beada2d5f93289 = ({ alignment: alignment, maxAvatarCount: maxAvatarCount, tooltipPosition: tooltipPosition, data: data, ...props })=>{
    const { data: customData, overrides: customOverrides } = (0, $5uXOq.useMemo)(()=>$28afe71c94c1415f$export$bc55c1ff86d63c4d({
            data: data,
            maxAvatarCount: maxAvatarCount
        }), [
        data,
        maxAvatarCount
    ]);
    const avatarGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44cng.default), {
        maxCount: maxAvatarCount,
        data: customData,
        overrides: customOverrides,
        boundariesElement: "scrollParent",
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ // @ts-ignore
        tooltipPosition: tooltipPosition,
        onMoreClick: (0, $2zDkN.noop),
        ...props
    });
    if (alignment === 'vertical') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28afe71c94c1415f$var$VerticalAvatarGroupContainer, null, avatarGroup);
    return avatarGroup;
};
const $28afe71c94c1415f$export$bc55c1ff86d63c4d = ({ data: users, maxAvatarCount: maxAvatarCount })=>{
    const overflows = users.length > maxAvatarCount;
    const lastFeaturedUser = maxAvatarCount - 1;
    const featuredUsers = users.slice(0, lastFeaturedUser);
    const overflowUsers = users.slice(lastFeaturedUser);
    const overflowMarkerDummyUser = $28afe71c94c1415f$export$1b8d8867a2d1ffbd(overflowUsers);
    const processedUsers = overflows ? [
        ...featuredUsers,
        overflowMarkerDummyUser
    ] : users;
    const overrides = {
        Avatar: {
            render: (AvatarComponent, avatarProps)=>{
                if (avatarProps.name === overflowMarkerDummyUser.name && avatarProps.key === overflowMarkerDummyUser.key) return $28afe71c94c1415f$var$renderAvatarWithOverflowCount(AvatarComponent, avatarProps, overflowUsers.length);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AvatarComponent, avatarProps);
            }
        }
    };
    return {
        overrides: overrides,
        data: processedUsers
    };
};
const $28afe71c94c1415f$export$1b8d8867a2d1ffbd = (overflowUsers)=>({
        name: overflowUsers.map((u)=>u.name).join(', '),
        key: $28afe71c94c1415f$var$OVERFLOW_USER_MARKER
    });
const $28afe71c94c1415f$var$renderAvatarWithOverflowCount = (AvatarComponent, avatarProps, overflowCount)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AvatarComponent, {
        name: avatarProps.name,
        appearance: avatarProps.appearance,
        size: avatarProps.size,
        borderColor: avatarProps.borderColor,
        stackIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cnu9t.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28afe71c94c1415f$var$AvatarOverflowCountContainer, null, `+${Math.min(overflowCount, $28afe71c94c1415f$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED)}`)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $28afe71c94c1415f$var$AvatarOverflowCountContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _6a6z1h6o _1bsb1osq _4t3i1osq _1e0c11p5 _bfhkm7j4 _syaz1fxt _y3gn1h6o _k48p1wq8",
            __cmplp.className
        ])
    });
});
const $28afe71c94c1415f$var$VerticalAvatarGroupContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ogvv1bp4 _3mc9idpf _1hlaidpf _1qu0x0bf",
            __cmplp.className
        ])
    });
});

});



parcelRegister("4kGsO", function(module, exports) {

$parcel$export(module.exports, "useRequestAccessSuccessFlag", () => $4a287e4fddaeb389$export$184b02cbba392fc0);

var $5uXOq = parcelRequire("5uXOq");

var $fHfPB = parcelRequire("fHfPB");
var $3KRpp = parcelRequire("3KRpp");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $dcbMS = parcelRequire("dcbMS");

var $dJlGU = parcelRequire("dJlGU");
const $4a287e4fddaeb389$export$184b02cbba392fc0 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagService)();
    return (0, $5uXOq.useCallback)(()=>{
        const id = `success-${(0, $dcbMS.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $fHfPB.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a287e4fddaeb389$export$567128fc1024c9cf, {
                    ...props,
                    id: id,
                    onDismiss: dismiss
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $4a287e4fddaeb389$export$567128fc1024c9cf = ({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessFlag), {
        ...props,
        onDismissed: onDismiss,
        title: formatMessage((0, $dJlGU.messages).title),
        // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $dJlGU.messages).description))
    });
};

});
parcelRegister("dJlGU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $49198865101fe328$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $49198865101fe328$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "cross-join-nudges.request-access-success-flag.title",
        "defaultMessage": "A request was sent to your admins"
    },
    description: {
        "id": "cross-join-nudges.request-access-success-flag.description",
        "defaultMessage": "You'll receive an email once they've reviewed it."
    }
});

});


parcelRegister("fmenl", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $14caa3dc0d5e6e39$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $jcw0u = parcelRequire("jcw0u");
const $14caa3dc0d5e6e39$export$e926676385687eaf = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        onError: (_, error)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'cross-join-nudges-your-work-error-boundary'
                },
                error: error
            });
        }
    }, children);

});

parcelRegister("khNyR", function(module, exports) {

$parcel$export(module.exports, "CrossJoinNudgeYourWorkCard", () => $910a9b371bd7ff78$export$7ac60ccf67d54f65);

var $5uXOq = parcelRequire("5uXOq");

var $44cng = parcelRequire("44cng");

var $bMFGq = parcelRequire("bMFGq");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $2s57o = parcelRequire("2s57o");

var $5aHb0 = parcelRequire("5aHb0");

var $fTfAU = parcelRequire("fTfAU");

var $eci4O = parcelRequire("eci4O");

var $g8hgP = parcelRequire("g8hgP");

var $8Ahxt = parcelRequire("8Ahxt");

var $juXaV = parcelRequire("juXaV");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $kQvK1 = parcelRequire("kQvK1");
const $910a9b371bd7ff78$var$Actions = ({ onSubmit: onSubmit, onSnooze: onSnooze, onOptOut: onOptOut, collaborators: collaborators })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMFGq.default), {
        onClick: onSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $kQvK1.messages).joinYourTeam,
        values: {
            collaborators: collaborators.length,
            collaborator: collaborators[0]?.name.split(' ')[0]
        }
    })), onSnooze && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMFGq.default), {
        appearance: "subtle",
        onClick: onSnooze
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kQvK1.messages).remindMeLater)), onOptOut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMFGq.default), {
        appearance: "subtle",
        onClick: onOptOut
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kQvK1.messages).notInterested)));
const $910a9b371bd7ff78$var$Avatars = ({ collaborators: collaborators })=>{
    const data = [
        (0, (/*@__PURE__*/$parcel$interopDefault($8Ahxt))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fTfAU))),
        (0, (/*@__PURE__*/$parcel$interopDefault($eci4O))),
        (0, (/*@__PURE__*/$parcel$interopDefault($g8hgP)))
    ].map((src)=>({
            name: '',
            src: src
        }));
    for (const [i, user] of collaborators.entries())data[i] = {
        name: user.name,
        src: user.avatar
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $910a9b371bd7ff78$var$AvatarWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44cng.default), {
        appearance: "stack",
        data: data,
        maxCount: 4,
        size: "large",
        borderColor: "white",
        testId: "cross-join-nudges.ui.your-work-widget.ui"
    }));
};
const $910a9b371bd7ff78$export$7ac60ccf67d54f65 = /*#__PURE__*/ (0, $5uXOq.memo)(({ onRender: onRender, collaborators: collaborators, onDismiss: onDismiss, ...actionsProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    onRender();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $910a9b371bd7ff78$var$Wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($910a9b371bd7ff78$var$Avatars, {
        collaborators: collaborators
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5aHb0.PromotionalCard), {
        header: formatMessage((0, $kQvK1.messages).header, {
            collaborators: collaborators.length,
            collaborator: collaborators[0]?.name
        }),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($juXaV))),
        imageAltText: formatMessage((0, $kQvK1.messages).imageAltText),
        description: formatMessage((0, $kQvK1.messages).description),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($910a9b371bd7ff78$var$Actions, {
            ...actionsProps,
            collaborators: collaborators
        }),
        reason: formatMessage((0, $kQvK1.messages).tooltip),
        analyticsSource: "cross-join-nudges-your-work",
        onDismiss: onDismiss
    }));
});
const $910a9b371bd7ff78$var$AvatarWrapper = (0, $2s57o.xcss)({
    position: 'absolute',
    zIndex: 'card',
    left: '144px',
    top: '35px'
});
const $910a9b371bd7ff78$var$Wrapper = (0, $2s57o.xcss)({
    display: 'inline-block',
    position: 'relative'
});

});
parcelRegister("5aHb0", function(module, exports) {

$parcel$export(module.exports, "PromotionalCard", () => $e71e2c86ce67b28e$export$418393e556a23457);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $i95f5 = parcelRequire("i95f5");

var $bWfiu = parcelRequire("bWfiu");

var $kweMg = parcelRequire("kweMg");

var $c6Cwb = parcelRequire("c6Cwb");

var $5KCCi = parcelRequire("5KCCi");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $bVZ71 = parcelRequire("bVZ71");
const $e71e2c86ce67b28e$export$418393e556a23457 = ({ imageUrl: imageUrl, imageAltText: imageAltText, header: header, description: description, primaryAction: primaryAction, reason: reason, analyticsSource: analyticsSource, isDismissLoading: isDismissLoading, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926),
        sourceName: analyticsSource
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e71e2c86ce67b28e$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e71e2c86ce67b28e$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i95f5.default), {
        appearance: "subtle",
        spacing: "none",
        isLoading: isDismissLoading,
        "aria-label": formatMessage((0, $bVZ71.default).dismiss),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kweMg))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "",
            color: "var(--ds-icon-warning-inverse, #172B4D)"
        }),
        onClick: (e, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, `${analyticsSource}Dismiss`);
            onDismiss();
        }
    })), imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e71e2c86ce67b28e$var$ImageContainer, {
        imageUrl: imageUrl
    }, imageAltText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        role: "img",
        "aria-label": imageAltText
    }) : null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e71e2c86ce67b28e$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e71e2c86ce67b28e$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "medium",
        as: "h2"
    }, header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e71e2c86ce67b28e$var$Description, null, description), primaryAction, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e71e2c86ce67b28e$var$Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: reason,
        onShow: (analyticsEvent)=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'promotionalCardInfo')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e71e2c86ce67b28e$var$FooterContent, {
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c6Cwb))), {
        LEGACY_size: "small",
        label: ""
    }), formatMessage((0, $bVZ71.default).footerContent))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e71e2c86ce67b28e$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _bfhkvuon _16qs9g9j _1bsb1gwv _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e71e2c86ce67b28e$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _c71lckbl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e71e2c86ce67b28e$var$ImageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { imageUrl: imageUrl, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ntxwly": (0, $lD23V.default)(`url(${__cmplp.imageUrl})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1lrw1dfr _4t3ibv7e _1bsb1osq _1itklex0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e71e2c86ce67b28e$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e71e2c86ce67b28e$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _19pkutpp _otyrutpp _syaz1fxt _c71l1wqb",
            __cmplp.className
        ])
    });
});
const $e71e2c86ce67b28e$var$Footer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dozgxb _1e0c1txw _1bah1h6o _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc _syaz131l",
            __cmplp.className
        ])
    });
});
const $e71e2c86ce67b28e$var$FooterContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _11c81o8v _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e71e2c86ce67b28e$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iv47k _1xi21ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bVZ71", function(module, exports) {

$parcel$export(module.exports, "default", () => $a789b7df29ddb8f2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a789b7df29ddb8f2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dismiss: {
        "id": "home-common-ui.promotional-card.dismiss",
        "defaultMessage": "Close"
    },
    footerContent: {
        "id": "home-common-ui.promotional-card.footer-content",
        "defaultMessage": "Why am I seeing this?"
    }
});

});


parcelRegister("fTfAU", function(module, exports) {
module.exports = new URL("Angie.ce60f296.svg", import.meta.url).toString();

});

parcelRegister("eci4O", function(module, exports) {
module.exports = new URL("Ed.d7b4103d.svg", import.meta.url).toString();

});

parcelRegister("g8hgP", function(module, exports) {
module.exports = new URL("More.e627945d.svg", import.meta.url).toString();

});

parcelRegister("8Ahxt", function(module, exports) {
module.exports = new URL("Norah.1b131c52.svg", import.meta.url).toString();

});

parcelRegister("juXaV", function(module, exports) {
module.exports = new URL("generic-background.3268bb58.svg", import.meta.url).toString();

});

parcelRegister("kQvK1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f46761a434cbf7ed$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f46761a434cbf7ed$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    header: {
        "id": "cross-join-nudges.your-work.header",
        "defaultMessage": "{collaborators, plural, =0 {Your team is using Confluence} one {{collaborator} is using Confluence} other {{collaborator} and others are using Confluence}}"
    },
    description: {
        "id": "cross-join-nudges.your-work.description",
        "defaultMessage": "Organize team knowledge, capture ideas, and share requirements for your Jira projects."
    },
    joinYourTeam: {
        "id": "cross-join-nudges.your-work.join-your-team",
        "defaultMessage": "{collaborators, plural, one {Join {collaborator}} other {Join your team}}"
    },
    remindMeLater: {
        "id": "cross-join-nudges.your-work.remind-me-later",
        "defaultMessage": "Remind me later"
    },
    notInterested: {
        "id": "cross-join-nudges.your-work.not-interested",
        "defaultMessage": "Not interested"
    },
    tooltip: {
        "id": "cross-join-nudges.your-work.tooltip",
        "defaultMessage": "You're seeing this suggestion because you may want to use Confluence to work with the same people you work with in Jira. Your Jira teammates already use Confluence."
    },
    imageAltText: {
        "id": "cross-join-nudges.your-work.image-alt-text",
        "defaultMessage": "Your team collaborating on a document in Confluence"
    }
});

});



parcelRegister("gMP0k", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherLight", () => $eedf22ad32c5f711$export$3787c612f09492c8);

var $5uXOq = parcelRequire("5uXOq");

var $eBmnm = parcelRequire("eBmnm");

var $kTvze = parcelRequire("kTvze");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $3BUx0 = parcelRequire("3BUx0");

var $kuGny = parcelRequire("kuGny");
const $eedf22ad32c5f711$export$3787c612f09492c8 = ({ onOpen: onOpen, onMouseEnter: onMouseEnter })=>{
    if (false) {
        if ((0, $3HwlS.getWillShowNav4)()) {
            if ((0, $4R6GH.fg)('jira_nav4_beta_drop_2')) // TODO: when cleaning up we can probably remove the Nav 4 server branch
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3BUx0.AppSwitcher), {
                label: (0, $kuGny.SwitchToTooltipText)
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kTvze.Nav4SkeletonSwitcherButton), {
                label: ""
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kTvze.SkeletonSwitcherButton), {
            label: ""
        });
    }
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3BUx0.AppSwitcher), {
        onClick: onOpen,
        onMouseEnter: onMouseEnter,
        label: (0, $kuGny.SwitchToTooltipText),
        "aria-expanded": false,
        "aria-haspopup": true
    });
    // @ts-expect-error - TS2741 - Property 'tooltip' is missing in type '{ onClick: (() => void) | undefined; }' but required in type 'BaseIconButtonProps'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eBmnm.AppSwitcher), {
        onClick: onOpen,
        onMouseEnter: onMouseEnter
    });
};

});

parcelRegister("6clh9", function(module, exports) {

let $48345dfc33e61795$var$load = (parcelRequire("28QjX"))(4);
module.exports = $48345dfc33e61795$var$load("aD9jw").then(()=>parcelRequire('djIOy'));

});


parcelRegister("4uXxK", function(module, exports) {

$parcel$export(module.exports, "TopLevelErrorBoundary", () => $7f8668208bdb1964$export$b70f1d8bd509b358);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $Mp6qH = parcelRequire("Mp6qH");
const $7f8668208bdb1964$export$b70f1d8bd509b358 = ({ id: id, children: children })=>{
    const EVENT_DATA = (0, $5uXOq.useMemo)(()=>({
            id: id
        }), [
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: `${(0, $Mp6qH.TOP_LEVEL_ERROR_BOUNDARY_ID)}.${id}`,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        extraEventData: EVENT_DATA,
        fallback: "unmount"
    }, children);
};

});

parcelRegister("iPj86", function(module, exports) {

$parcel$export(module.exports, "useNavigationItemAnalytics", () => $e639936782444614$export$444d136efe970fd3);

var $5uXOq = parcelRequire("5uXOq");

var $2uT3N = parcelRequire("2uT3N");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");
const $e639936782444614$export$444d136efe970fd3 = ({ navigationItemId: navigationItemId })=>{
    const { isVisible: isVisible } = (0, $2uT3N.useOverflowStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((attributes = {})=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, navigationItemId, {
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            ...attributes,
            isInMore: !isVisible,
            navigationLayer: 'global'
        });
    }, [
        createAnalyticsEvent,
        isVisible,
        navigationItemId
    ]);
};

});


parcelRegister("96WTB", function(module, exports) {

$parcel$export(module.exports, "Create", () => $c8d9a30d843c92d0$export$8ade6fcbf3a7de5d);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $7kxNZ = parcelRequire("7kxNZ");

var $jp0tf = parcelRequire("jp0tf");


var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $9YT0J = parcelRequire("9YT0J");

var $c0dQj = parcelRequire("c0dQj");

var $6cNb0 = parcelRequire("6cNb0");

var $hULKg = parcelRequire("hULKg");

var $5rzqz = parcelRequire("5rzqz");

var $f5nIZ = parcelRequire("f5nIZ");

var $kxEY7 = parcelRequire("kxEY7");

var $cZpsT = parcelRequire("cZpsT");

var $2YP9W = parcelRequire("2YP9W");

var $Mp6qH = parcelRequire("Mp6qH");

var $3S5gG = parcelRequire("3S5gG");

var $4uXxK = parcelRequire("4uXxK");

var $iPj86 = parcelRequire("iPj86");

var $ktmuI = parcelRequire("ktmuI");

var $8fSk0 = parcelRequire("8fSk0");

var $twalS = parcelRequire("twalS");
const $c8d9a30d843c92d0$var$noop = ()=>undefined;
const $c8d9a30d843c92d0$var$Create = ({ AkCreate: AkCreate = (0, $3S5gG.Create), NudgeTooltip: NudgeTooltip = (0, $kxEY7.NavigationCreateIssueButtonWrapperNudgeAsync), onCreateClick: onCreateClick = (0, $jp0tf.default), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useIsInitialLoadLegacyIssueCreate: // @ts-expect-error - TS2339 - Property 'useIsInitialLoadLegacyIssueCreate' does not exist on type 'CreateProps'.
useIsInitialLoadLegacyIssueCreate = (0, $7kxNZ.useIsInitialLoadLegacyIssueCreate) })=>{
    const testId = (0, $6cNb0.testIdGenerate)('create');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    (0, $9YT0J.useInitializePersistentIssueCreateModalView)();
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).CREATE
    });
    const [{ isInitialLoad: isInitialLoad }, actions] = useIsInitialLoadLegacyIssueCreate();
    let currentIssueCreateVisibility = null;
    const gicOptInStateOverridden = (0, $5uXOq.useRef)(false);
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const isMobileExperienceEnabled = (0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)();
    if ((0, $4R6GH.fg)('render_modern_global_issue_create_modal_experience')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: data, update: update } = (0, $2YP9W.useResource)((0, $f5nIZ.gicOptInStatusResources));
        if (isAnonymous && !gicOptInStateOverridden.current) {
            update(()=>({
                    gicOptInStatus: {
                        isEnabled: true
                    }
                }));
            gicOptInStateOverridden.current = true;
        }
        currentIssueCreateVisibility = data && data?.gicOptInStatus;
    }
    const onClick = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        if ((0, $4R6GH.fg)('render_modern_global_issue_create_modal_experience')) {
            if (currentIssueCreateVisibility !== null) {
                if (currentIssueCreateVisibility.isEnabled) {
                    (0, $ktmuI.GlobalIssueCreateFromTopNav).abort({
                        force: true
                    });
                    (0, $ktmuI.GlobalIssueCreateFromTopNav).start();
                    (0, $ktmuI.GlobalIssueCreateFromTopNav).addMetadata({
                        inputDelay: Math.round(performance.now() - e.timeStamp)
                    });
                    const nextState = {
                        disableCreationSuccessFlag: (0, $twalS.shouldDisableGICFlagCreation)(),
                        triggerPointKey: (0, $hULKg.GENERIC_GLOBAL_CREATE_BUTTON),
                        ...isMobileExperienceEnabled ? {
                            displayMinimizableButtons: false,
                            displayCreateAnotherIssueToggle: false,
                            triggerPointKey: (0, $hULKg.MOBILE_GLOBAL_CREATE_BUTTON)
                        } : {}
                    };
                    openIssueCreateModal(nextState);
                } else {
                    onCreateClick({
                        isInitialLoad: isInitialLoad,
                        triggerSource: (0, $de7681b8672bb382$export$d983e94cf86f65d)
                    });
                    if (isInitialLoad) actions.clearInitialLoaded();
                }
            } else (0, $dJl1T.default).safeErrorWithoutCustomerData('global-issue-create', 'visibility data is still getting downloaded');
        } else {
            onCreateClick({
                isInitialLoad: isInitialLoad,
                triggerSource: (0, $de7681b8672bb382$export$d983e94cf86f65d)
            });
            if (isInitialLoad) actions.clearInitialLoaded();
        }
        triggerAnalytics();
    }, [
        actions,
        currentIssueCreateVisibility,
        isInitialLoad,
        isMobileExperienceEnabled,
        onCreateClick,
        openIssueCreateModal,
        triggerAnalytics
    ]);
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NudgeTooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkCreate, {
        onClick: onClick,
        text: formatMessage((0, $8fSk0.default).create),
        testId: testId,
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $8fSk0.default).createButtonAriaLabelIssueTermRefresh : (0, $8fSk0.default).createButtonAriaLabel)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkCreate, {
        onClick: $c8d9a30d843c92d0$var$noop,
        text: formatMessage((0, $8fSk0.default).create),
        testId: testId,
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $8fSk0.default).createButtonAriaLabelIssueTermRefresh : (0, $8fSk0.default).createButtonAriaLabel)
    });
};
const $c8d9a30d843c92d0$export$8ade6fcbf3a7de5d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).CREATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8d9a30d843c92d0$var$Create, props));

});
parcelRegister("9YT0J", function(module, exports) {

$parcel$export(module.exports, "useInitializePersistentIssueCreateModalView", () => $d36676d86816c70e$export$9086117e14a55509);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $c0dQj = parcelRequire("c0dQj");

var $5rzqz = parcelRequire("5rzqz");

var $dAfqg = parcelRequire("dAfqg");

var $cn7wb = parcelRequire("cn7wb");
const $d36676d86816c70e$export$9086117e14a55509 = ()=>{
    const [{ shouldShowMiniModalSpotlight: shouldShowMiniModalSpotlight }, { setShouldPushMiniModalDiscoverability: setShouldPushMiniModalDiscoverability, setPersistentModalView: setPersistentModalView }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const hasUserSeenMiniModal = (0, $5uXOq.useRef)(false);
    const isJSM = projectContext?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
    const { data: resource } = (0, $cn7wb.usePersistentIssueCreateModalViewResource)();
    const isMobileExperienceEnabled = (0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)();
    /**
	 * It only handles the initialization part as after the modal is opened the persistentModalView
	 * would be handled by the `actions` of `useTriggerIssueCreateModal`.
	 */ (0, $5uXOq.useEffect)(()=>{
        setPersistentModalView(resource?.view || 'modal');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
	 * JSM has opted out so we update the `shouldPushMiniModalDiscoverability` on every project change
	 * until the discoverability push has been done, meaning that the user has seen the mini modal being
	 * shown as the default modal.
	 *
	 * Mobile is also opting out of having any mini modal discoverability and not interacting with any of the discoverability state
	 * for if the user returns to desktop.
	 *
	 * If the user has seen the mini modal from discoverability push (hasUserSeenMiniModal) or
	 * dismiss its nudge (isDiscoPushComplete), shouldPushMiniModalDiscoverability should never be true again.
	 */ (0, $5uXOq.useEffect)(()=>{
        if (resource?.isDiscoPushComplete || hasUserSeenMiniModal.current) setShouldPushMiniModalDiscoverability(false);
        else setShouldPushMiniModalDiscoverability(!isJSM && !isMobileExperienceEnabled);
    }, [
        resource?.isDiscoPushComplete,
        setShouldPushMiniModalDiscoverability,
        isJSM,
        isMobileExperienceEnabled
    ]);
    /**
	 * `shouldShowMiniModalSpotlight` can be used to determine if user has seen the mini modal
	 * as it is only set `onModalOpen`, which means, if it is true, the modal is opened with mini view
	 * and the user will see it.
	 */ (0, $5uXOq.useEffect)(()=>{
        if (shouldShowMiniModalSpotlight && !hasUserSeenMiniModal.current) hasUserSeenMiniModal.current = true;
    }, [
        shouldShowMiniModalSpotlight
    ]);
    return null;
};

});
parcelRegister("cn7wb", function(module, exports) {

$parcel$export(module.exports, "usePersistentIssueCreateModalViewResource", () => $c55164aa1e8f5a83$export$20dbed3226e737bc);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $aHuqL = parcelRequire("aHuqL");

var $2YP9W = parcelRequire("2YP9W");


var $3X1Xr = parcelRequire("3X1Xr");
const $c55164aa1e8f5a83$export$20dbed3226e737bc = ()=>{
    const { data: data, update: update } = (0, $2YP9W.useResource)((0, $3X1Xr.persistentIssueCreateModalViewResource));
    const updateView = (0, $5uXOq.useCallback)(async (view)=>{
        try {
            await (0, $aHuqL.userPreferenceAPI).set((0, $fa76c7a777da2375$export$15187a597cef02df), view);
            update((state)=>({
                    ...state,
                    view: view
                }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'persistentIssueCreateModalViewState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    const updateIsDiscoPushComplete = (0, $5uXOq.useCallback)(async (isDiscoPushComplete = true)=>{
        try {
            await (0, $aHuqL.userPreferenceAPI).set((0, $fa76c7a777da2375$export$8977f91a75d8d265), isDiscoPushComplete);
            update((state)=>({
                    ...state,
                    isDiscoPushComplete: isDiscoPushComplete
                }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'miniModalDiscoverabilityPushState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    return {
        data: data,
        updateView: updateView,
        updateIsDiscoPushComplete: updateIsDiscoPushComplete
    };
};

});


parcelRegister("kxEY7", function(module, exports) {

$parcel$export(module.exports, "NavigationCreateIssueButtonWrapperNudgeAsync", () => $6b9c90b8c1e1a472$export$fc0840474cb1fce9);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $dsvCp = parcelRequire("dsvCp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6b9c90b8c1e1a472$var$NavigationCreateIssueButtonLazy = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("MFaxE")).then((exportedModule)=>exportedModule.NavigationCreateIssueButtonWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-create-issue/index.tsx"
});
const $6b9c90b8c1e1a472$export$fc0840474cb1fce9 = ({ children: children })=>{
    const shouldShowNudge = (0, $dsvCp.useCanShowQuickstartNudge)();
    if (!shouldShowNudge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$aba87e019f5ccb8d),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$aba87e019f5ccb8d)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-navigation-create-issue-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6b9c90b8c1e1a472$var$NavigationCreateIssueButtonLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$aba87e019f5ccb8d)
    }, children)));
};

});
parcelRegister("dsvCp", function(module, exports) {

$parcel$export(module.exports, "useCanShowQuickstartNudge", () => $6331d14932d8e8e2$export$b687eb4905cdc15a);

var $heI7y = parcelRequire("heI7y");
const $6331d14932d8e8e2$export$b687eb4905cdc15a = ()=>{
    const [{ hasOpened: hasOpened }] = (0, $heI7y.useHasOpened)();
    return hasOpened;
};

});

parcelRegister("MFaxE", function(module, exports) {

let $09246b1f001cc1f1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $09246b1f001cc1f1$var$load("aQQdr").then(()=>parcelRequire('9NAtJ'));

});


parcelRegister("3S5gG", function(module, exports) {

$parcel$export(module.exports, "Create", () => $321e94af7b02d9cb$export$8ade6fcbf3a7de5d);

var $5uXOq = parcelRequire("5uXOq");

var $6mZMG = parcelRequire("6mZMG");

var $ayYib = parcelRequire("ayYib");

var $bMFGq = parcelRequire("bMFGq");

var $46OkO = parcelRequire("46OkO");

var $0yZbT = parcelRequire("0yZbT");

var $4R6GH = parcelRequire("4R6GH");

var $kvHKs = parcelRequire("kvHKs");

var $2gP8z = parcelRequire("2gP8z");

var $3HwlS = parcelRequire("3HwlS");

var $5CrDn = parcelRequire("5CrDn");
// This id is required to ensure pollinator tests work between Nav3 and Nav4
const $321e94af7b02d9cb$var$TEST_ID_NAV_4 = 'atlassian-navigation--create-button';
const $321e94af7b02d9cb$export$8ade6fcbf3a7de5d = (props)=>{
    if (false) {
        if ((0, $3HwlS.getWillShowNav4)()) {
            if ((0, $4R6GH.fg)('jira_nav4_beta_drop_2')) // TODO: when cleaning up we can probably remove the Nav 4 server branch
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5CrDn.CreateButton), {
                testId: $321e94af7b02d9cb$var$TEST_ID_NAV_4
            }, props.text);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMFGq.default), {
                appearance: "primary",
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($46OkO))),
                testId: props.testId
            }, props.text);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ayYib.SkeletonCreateButton), {
            text: props.text,
            testId: props.testId
        });
    }
    if ((0, $3HwlS.getWillShowNav4)()) {
        const { onClick: onClick, text: text } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gP8z.SpotlightTarget), {
            name: (0, $kvHKs.GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5CrDn.CreateButton), {
            onClick: onClick,
            testId: $321e94af7b02d9cb$var$TEST_ID_NAV_4
        }, text)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6mZMG.Create), props);
};

});
parcelRegister("2gP8z", function(module, exports) {

$parcel$export(module.exports, "SpotlightTarget", () => $bac5b90628bba66f$export$e29577842f211e22);

var $5uXOq = parcelRequire("5uXOq");

var $Pxnvj = parcelRequire("Pxnvj");

var $axUP7 = parcelRequire("axUP7");
const $bac5b90628bba66f$var$SpotlightTargetWrapper = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
const $bac5b90628bba66f$export$e29577842f211e22 = (0, $axUP7.withNestingOptimisation)($bac5b90628bba66f$var$SpotlightTargetWrapper);

});


parcelRegister("ktmuI", function(module, exports) {

$parcel$export(module.exports, "GlobalIssueCreateFromTopNav", () => $903a8c36bcdb4b23$export$177dc7755a3f80f2);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");
var $16Yvd = parcelRequire("16Yvd");
const $903a8c36bcdb4b23$export$177dc7755a3f80f2 = new (0, $kkzI0.UFOExperience)('global-issue-create-from-top-nav', {
    type: (0, $lrUJ4.ExperienceTypes).Operation,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom,
    until: (0, $16Yvd.untilAll)([
        {
            category: 'global-issue-create.create-issue'
        }
    ])
});
const $903a8c36bcdb4b23$export$2b83859c1548ffb5 = new (0, $kkzI0.UFOExperience)('projects-menu-dropdown.recommendation-selector', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
});
const $903a8c36bcdb4b23$export$a784c5bbb21ea554 = new (0, $kkzI0.UFOExperience)('projects-menu-dropdown.load-jpd-recommendation', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("8fSk0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d702f6d77050354f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d702f6d77050354f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    create: {
        "id": "atlassian-navigation.create.create",
        "defaultMessage": "Create"
    },
    createButtonAriaLabel: {
        "id": "atlassian-navigation.create.create-button-aria-label",
        "defaultMessage": "Create issue"
    },
    createButtonAriaLabelIssueTermRefresh: {
        "id": "atlassian-navigation.create.create-button-aria-label-issue-term-refresh",
        "defaultMessage": "Create"
    }
});

});

parcelRegister("twalS", function(module, exports) {

$parcel$export(module.exports, "shouldDisableGICFlagCreation", () => $ea9b0b430c82f5e1$export$fc4d210bb6a1528a);

var $gKZoD = parcelRequire("gKZoD");

var $Mp6qH = parcelRequire("Mp6qH");
const $ea9b0b430c82f5e1$export$fc4d210bb6a1528a = ()=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return (0, $Mp6qH.JSW_TMP_BACKLOG_BOARD_REGEXP).test(window.location.pathname);
};

});


parcelRegister("crC7i", function(module, exports) {

$parcel$export(module.exports, "Help", () => $2e020bcbc529c0ab$export$1be7516c0280bee8);

var $5uXOq = parcelRequire("5uXOq");

var $6puUq = parcelRequire("6puUq");

var $Pxnvj = parcelRequire("Pxnvj");

var $lePq2 = parcelRequire("lePq2");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $6BNJk = parcelRequire("6BNJk");

var $kspz4 = parcelRequire("kspz4");

var $koVbs = parcelRequire("koVbs");

var $hsmeR = parcelRequire("hsmeR");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $6cNb0 = parcelRequire("6cNb0");

var $g8I5C = parcelRequire("g8I5C");

var $3HwlS = parcelRequire("3HwlS");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $1XJ20 = parcelRequire("1XJ20");

var $4DPZY = parcelRequire("4DPZY");

var $ajOhG = parcelRequire("ajOhG");

var $heI7y = parcelRequire("heI7y");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $1bshq = parcelRequire("1bshq");

var $8dSZI = parcelRequire("8dSZI");

var $iPj86 = parcelRequire("iPj86");

var $5ofLo = parcelRequire("5ofLo");

var $kPpft = parcelRequire("kPpft");
const $2e020bcbc529c0ab$var$Badge = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ofLo.Badge), props);
};
const $2e020bcbc529c0ab$var$SpotlightTargetComponent = (0, $7XYc4.componentWithCondition)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('blu-5788-spotlight-help-button'), $2e020bcbc529c0ab$var$JWMFeedbackSpotlightWrapper, $2e020bcbc529c0ab$var$SpotlightTargetComponentOriginal);
function $2e020bcbc529c0ab$var$SpotlightTargetComponentOriginal({ children: children }) {
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e020bcbc529c0ab$var$SpotlightTarget, {
        name: (0, $Mp6qH.HELP_SPOTLIGHT_KEY)
    }, children), (0, $4R6GH.fg)('add_engagement_spotlight_to_navbar_button') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6puUq.EngagementSpotlight), {
        name: (0, $Mp6qH.HELP_SPOTLIGHT_KEY)
    }));
}
function $2e020bcbc529c0ab$var$SpotlightTarget({ children: children, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
}
function $2e020bcbc529c0ab$var$JWMFeedbackSpotlightWrapper({ children: children }) {
    const renderNudgeWrapper = (0, $5uXOq.useCallback)((kids)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ajOhG.FeedbackNudgeAsync), null, kids), []);
    const [{ hasOpened: shouldShowNudge }] = (0, $heI7y.useHasOpened)();
    const [isUnloaded] = (0, $cE2Qr.useIsDismissed)();
    const [openTask] = (0, $cE2Qr.useOpenTask)();
    const [, { setHasNudgeActive: setHasNudgeActive }] = (0, $cE2Qr.useQuickstartActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isUnloaded && openTask === (0, $8Bc5A.JWM_FEEDBACK_TASK) && shouldShowNudge) setHasNudgeActive(true);
    }, [
        isUnloaded,
        openTask,
        shouldShowNudge,
        setHasNudgeActive
    ]);
    return !false && shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8I5C.QuickstartNudge), {
        renderWrapper: renderNudgeWrapper
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e020bcbc529c0ab$var$SpotlightTargetComponentOriginal, null, children);
}
function $2e020bcbc529c0ab$var$Help() {
    const [{ data: projectData }] = (0, $4DPZY.useContainerContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isMenuOpen, { off: closeMenu, on: openMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).HELP);
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const [topMenusValue, { off: closeAllMenus }] = (0, $2Ui4E.useTopMenus)();
    const [, { setNavigationData: setNavigationData }] = (0, $kspz4.useHelpPanelActions)();
    const { releaseNotesNotifications: releaseNotesNotifications, setReleaseNotesNotifications: setReleaseNotesNotifications } = (0, $8dSZI.useHelpButtonState)();
    const helpButtonRef = (0, $5uXOq.useRef)(null);
    let isProjectSimplified = false;
    if (projectData && 'project' in projectData && projectData.project) isProjectSimplified = projectData.project.isSimplified;
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const attributes = {
        helpPanelVersion: (0, $6BNJk.HELP_PANEL_VERSION),
        helpPanelType: 'inProductHelp',
        nextGenProject: isProjectSimplified
    };
    const triggerAnalytics = (0, $iPj86.useNavigationItemAnalytics)({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).HELP
    });
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const isHelpPanelOpenedPreviously = (0, $1XJ20.usePrevious)(currentRightSidebarState);
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'help');
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (currentRightSidebarState && currentRightSidebarState.panelId === (0, $6BNJk.HELP_PANEL_ID) && !currentRightSidebarState.isCollapsed) closeCurrentRightSidebar();
        else openRightSidebar((0, $6BNJk.HELP_PANEL_ID), (0, $6BNJk.HELP_PANEL_WIDTH), false, true);
        closeAllMenus();
        setNavigationData({
            articleId: {
                id: '',
                type: (0, $lePq2.ARTICLE_TYPE).HELP_ARTICLE
            },
            history: []
        });
        // Shows if the help panel is currently open or closed
        const isPanelOpen = currentRightSidebarState?.panelId === (0, $6BNJk.HELP_PANEL_ID) && !currentRightSidebarState?.isCollapsed;
        triggerAnalytics({
            ...attributes,
            isOpened: !isPanelOpen
        });
    }, [
        triggerAnalytics,
        attributes,
        currentRightSidebarState,
        closeAllMenus,
        setNavigationData,
        closeCurrentRightSidebar,
        openRightSidebar
    ]);
    const badge = (0, $5uXOq.useCallback)(()=>{
        if (isAnonymous) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e020bcbc529c0ab$var$Badge, {
            isNotificationCleared: releaseNotesNotifications === 0
        });
    }, [
        isAnonymous,
        releaseNotesNotifications
    ]);
    const TriggerComponent = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-trigger'),
            "data-vc": `atlassian-navigation-help${false ? '-ssr' : ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e020bcbc529c0ab$var$SpotlightTargetComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1bshq.Help), {
            ...triggerProps,
            isSelected: isMenuOpen,
            badge: badge,
            onClick: onClick,
            tooltip: formatMessage((0, $kPpft.default).tooltip),
            label: formatMessage((0, $kPpft.default).label),
            ref: helpButtonRef
        }))), [
        testIdPrefix,
        isMenuOpen,
        badge,
        onClick,
        formatMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!currentRightSidebarState?.isCollapsed && releaseNotesNotifications !== 0) setReleaseNotesNotifications(0);
    }, [
        releaseNotesNotifications,
        setReleaseNotesNotifications,
        currentRightSidebarState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (currentRightSidebarState?.panelId === (0, $6BNJk.HELP_PANEL_ID) && !currentRightSidebarState?.isCollapsed) openMenu();
        else {
            closeMenu();
            if (isHelpPanelOpenedPreviously?.panelId === (0, $6BNJk.HELP_PANEL_ID) && !currentRightSidebarState) requestAnimationFrame(()=>helpButtonRef.current?.focus());
        }
    }, [
        closeMenu,
        currentRightSidebarState,
        isHelpPanelOpenedPreviously,
        openMenu,
        topMenusValue
    ]);
    if (// eslint-disable-next-line jira/ff/inline-expVal-params -- ESLint rule doesn't understand the array type
    (0, $6s1PB.expVal)('jira_nav4_hot_113350_changes', 'keys', []).includes('blu-6050-render-help-button-once')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-trigger'),
        "data-vc": `atlassian-navigation-help${false ? '-ssr' : ''}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e020bcbc529c0ab$var$SpotlightTargetComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1bshq.Help), {
        "aria-expanded": false,
        "aria-haspopup": false,
        isSelected: isMenuOpen,
        badge: badge,
        onClick: onClick,
        tooltip: formatMessage((0, $kPpft.default).tooltip),
        label: formatMessage((0, $kPpft.default).label),
        ref: helpButtonRef
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TriggerComponent, {
        "aria-expanded": false,
        "aria-haspopup": false
    });
}
const $2e020bcbc529c0ab$export$1be7516c0280bee8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).HELP
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e020bcbc529c0ab$var$Help, null));

});
parcelRegister("ajOhG", function(module, exports) {

$parcel$export(module.exports, "FeedbackNudgeAsync", () => $9b3ebbbcc2dff472$export$be3f2958452e7be9);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9b3ebbbcc2dff472$var$FeedbackNudgeLazy = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("fWEUS")).then((exportedModule)=>exportedModule.FeedbackNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-feedback/index.tsx"
});
const $9b3ebbbcc2dff472$export$be3f2958452e7be9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$e9e47a7ad42e71f5),
        fallback: children,
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$e9e47a7ad42e71f5)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "feedback-onboarding-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b3ebbbcc2dff472$var$FeedbackNudgeLazy, null, children)));
$9b3ebbbcc2dff472$export$be3f2958452e7be9.displayName = 'FeedbackNudgeAsync';

});
parcelRegister("fWEUS", function(module, exports) {

let $b9bc02f10de4cb97$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b9bc02f10de4cb97$var$load("eSNL6").then(()=>parcelRequire('5YJ1A'));

});


parcelRegister("1bshq", function(module, exports) {

$parcel$export(module.exports, "Help", () => $a05c7042ce796542$export$1be7516c0280bee8);

var $5uXOq = parcelRequire("5uXOq");

var $4ZDon = parcelRequire("4ZDon");

var $bp39N = parcelRequire("bp39N");

var $3HwlS = parcelRequire("3HwlS");

var $fQryW = parcelRequire("fQryW");

var $6s1PB = parcelRequire("6s1PB");
const $a05c7042ce796542$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    if (!(0, $6s1PB.expVal)('blu-6875-nav4-perf-help-button', 'cohort', false) && false) {
        if ((0, $3HwlS.getWillShowNav4)()) // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bp39N.Nav4SkeletonHelpButton), {
            label: props.tooltip
        });
        // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bp39N.SkeletonHelpButton), {
            label: props.tooltip
        });
    }
    if ((0, $3HwlS.getWillShowNav4)()) {
        const { badge: badge, onClick: onClick, isSelected: isSelected, label: label } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQryW.Help), {
            badge: badge,
            label: label,
            onClick: onClick,
            isSelected: isSelected,
            ref: ref
        });
    }
    const buttonProps = {
        ...props,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ZDon.Help), buttonProps);
});

});

parcelRegister("8dSZI", function(module, exports) {

$parcel$export(module.exports, "useHelpButtonState", () => $dbb456bea3760752$export$e3d3de46b23d1ede);

var $5uXOq = parcelRequire("5uXOq");

var $90yGq = parcelRequire("90yGq");

var $a6zkS = parcelRequire("a6zkS");
const $dbb456bea3760752$export$53f45136e435c2fd = 'help_button_ui_state';
const $dbb456bea3760752$export$e3d3de46b23d1ede = ()=>{
    const [releaseNotesNotifications, setReleaseNotesNotifications] = (0, $5uXOq.useState)(null);
    const [userReleaseNotesNotifications, setUserReleaseNotesNotifications] = (0, $5uXOq.useState)(null);
    const accountId = (0, $90yGq.useAccountId)();
    const updateData = (0, $5uXOq.useCallback)(()=>{
        if (userReleaseNotesNotifications !== null) {
            const newReleaseNotesNotificationsValue = userReleaseNotesNotifications !== undefined ? userReleaseNotesNotifications : 100;
            if (releaseNotesNotifications !== null) {
                if (userReleaseNotesNotifications !== releaseNotesNotifications) {
                    const remoteData = {
                        helpPanelMenu: {
                            releaseNotesNotifications: releaseNotesNotifications
                        }
                    };
                    (0, $a6zkS.updateHelpButtonState)(accountId, remoteData);
                }
            } else setReleaseNotesNotifications(newReleaseNotesNotificationsValue);
        }
    }, [
        accountId,
        releaseNotesNotifications,
        userReleaseNotesNotifications
    ]);
    const restoreReleaseNotesNotifications = (0, $5uXOq.useCallback)(async ()=>{
        if (accountId) {
            const userPropertiesHelpButtonValue = await (0, $a6zkS.getHelpButtonState)(accountId);
            setUserReleaseNotesNotifications(userPropertiesHelpButtonValue?.releaseNotesNotifications);
        } else setUserReleaseNotesNotifications(0);
    }, [
        accountId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (userReleaseNotesNotifications === null) restoreReleaseNotesNotifications();
        else updateData();
    }, [
        userReleaseNotesNotifications,
        restoreReleaseNotesNotifications,
        updateData
    ]);
    return {
        releaseNotesNotifications: releaseNotesNotifications,
        setReleaseNotesNotifications: setReleaseNotesNotifications
    };
};

});
parcelRegister("a6zkS", function(module, exports) {

$parcel$export(module.exports, "updateHelpButtonState", () => $67d0104a4e9a215c$export$c70764abdc0ffd52);
$parcel$export(module.exports, "getHelpButtonState", () => $67d0104a4e9a215c$export$9716b2ae6c8887b0);

var $8QpSo = parcelRequire("8QpSo");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");

const $67d0104a4e9a215c$export$c70764abdc0ffd52 = async (accountId, data)=>{
    if (accountId !== null) try {
        await (0, $89SaW.setUserProperties)(accountId, (0, $2c95e3030594e0a4$export$53f45136e435c2fd), JSON.stringify(data));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            error: e,
            meta: {
                id: 'updateServerHelpButtonState',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            }
        });
    }
};
const $67d0104a4e9a215c$var$getHelpButtonStateNew = (0, $8QpSo.default)(async (accountId)=>{
    try {
        // @ts-expect-error - Property 'helpPanelMenu' does not exist on type 'unknown'.
        const { helpPanelMenu: userPropertiesHelpButtonValue } = await (0, $89SaW.getUserProperty)(accountId, (0, $2c95e3030594e0a4$export$53f45136e435c2fd));
        return userPropertiesHelpButtonValue;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            error: e,
            meta: {
                id: 'getHelpButtonState',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            }
        });
    }
    return null;
});
const $67d0104a4e9a215c$var$getHelpButtonStateOld = async (accountId)=>{
    try {
        // @ts-expect-error - Property 'helpPanelMenu' does not exist on type 'unknown'.
        const { helpPanelMenu: userPropertiesHelpButtonValue } = await (0, $89SaW.getUserProperty)(accountId, (0, $2c95e3030594e0a4$export$53f45136e435c2fd));
        return userPropertiesHelpButtonValue;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            error: e,
            meta: {
                id: 'getHelpButtonState',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            }
        });
    }
    return null;
};
const $67d0104a4e9a215c$export$9716b2ae6c8887b0 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('user-properties-iv-llc-unnecessary-api'), $67d0104a4e9a215c$var$getHelpButtonStateNew, $67d0104a4e9a215c$var$getHelpButtonStateOld);

});
const $2c95e3030594e0a4$export$53f45136e435c2fd = 'help_button_ui_state';



parcelRegister("5ofLo", function(module, exports) {

$parcel$export(module.exports, "Badge", () => $04b8d99d5802ffbb$export$37acb3580601e69a);

var $5uXOq = parcelRequire("5uXOq");

var $7FUon = parcelRequire("7FUon");

var $kspz4 = parcelRequire("kspz4");

var $admgR = parcelRequire("admgR");
class $04b8d99d5802ffbb$var$MockNotificationLogClient extends (0, $7FUon.NotificationLogClient) {
    constructor(countValue){
        super('', ''), this.count = 0;
        this.count = countValue;
    }
    countUnseenNotifications() {
        return Promise.resolve({
            count: this.count
        });
    }
}
const $04b8d99d5802ffbb$var$emptyClient = new $04b8d99d5802ffbb$var$MockNotificationLogClient(0);
const $04b8d99d5802ffbb$export$32bd6ac078326cec = async (isNotificationCleared)=>{
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [{ releaseNotesNotifications: releaseNotesNotifications }] = (0, $kspz4.useHelpPanel)();
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const notificationLogProvider = (0, $5uXOq.useMemo)(()=>new $04b8d99d5802ffbb$var$MockNotificationLogClient(releaseNotesNotifications), [
        releaseNotesNotifications
    ]);
    const result = await Promise.resolve(isNotificationCleared || false || releaseNotesNotifications === 0 ? $04b8d99d5802ffbb$var$emptyClient : notificationLogProvider);
    return result;
};
const $04b8d99d5802ffbb$export$37acb3580601e69a = ({ isNotificationCleared: isNotificationCleared })=>{
    const [notifications, setNotifications] = (0, $5uXOq.useState)(0);
    const notificationLogProvider = $04b8d99d5802ffbb$export$32bd6ac078326cec(isNotificationCleared);
    (0, $5uXOq.useEffect)(()=>{
        const initNotifications = async ()=>{
            const result = await notificationLogProvider;
            setNotifications(result.count);
        };
        initNotifications();
    }, [
        notificationLogProvider
    ]);
    return notifications > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $admgR.LazyNotifications), {
        max: 3,
        appearance: "primary"
    }, notifications) : null;
};

});
parcelRegister("admgR", function(module, exports) {

$parcel$export(module.exports, "LazyNotifications", () => $c9ac2a12d590e98a$export$eebecbd0322becdd);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $Mp6qH = parcelRequire("Mp6qH");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c9ac2a12d590e98a$var$Notifications = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("fbNJG")), {
    ssr: false,
    moduleId: "../platform/packages/design-system/badge/src/index.tsx"
});
const $c9ac2a12d590e98a$export$eebecbd0322becdd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "help.atlaskit-badge",
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        teamName: "navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy-notification-badge",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9ac2a12d590e98a$var$Notifications, props)));

});
parcelRegister("fbNJG", function(module, exports) {

let $b0ee769b86c2e9a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b0ee769b86c2e9a1$var$load("6g12u").then(()=>parcelRequire('8zEOf'));

});



parcelRegister("kPpft", function(module, exports) {

$parcel$export(module.exports, "default", () => $e66fc02bdc2bad41$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e66fc02bdc2bad41$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "atlassian-navigation.help.tooltip",
        "defaultMessage": "Help"
    },
    label: {
        "id": "atlassian-navigation.help.label",
        "defaultMessage": "Help"
    }
});

});


parcelRegister("klog1", function(module, exports) {

$parcel$export(module.exports, "ProductHome", () => $0ec9a9378b2b1a20$export$32d61f70e04b6020);

var $5uXOq = parcelRequire("5uXOq");

var $iXjIy = parcelRequire("iXjIy");
var $eUk3o = parcelRequire("eUk3o");

var $iItCF = parcelRequire("iItCF");
var $7esE0 = parcelRequire("7esE0");
var $39fIG = parcelRequire("39fIG");
var $c4F0u = parcelRequire("c4F0u");
var $j7leM = parcelRequire("j7leM");
var $cii2t = parcelRequire("cii2t");
var $ds5Yo = parcelRequire("ds5Yo");
var $hshbs = parcelRequire("hshbs");

var $5986g = parcelRequire("5986g");
var $jf6er = parcelRequire("jf6er");

var $9NAcc = parcelRequire("9NAcc");
var $iP5mc = parcelRequire("iP5mc");

var $uYpSO = parcelRequire("uYpSO");
var $e6boy = parcelRequire("e6boy");

var $biEXp = parcelRequire("biEXp");
var $2WMBe = parcelRequire("2WMBe");

var $0yZbT = parcelRequire("0yZbT");

var $4R6GH = parcelRequire("4R6GH");

var $7XYc4 = parcelRequire("7XYc4");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");

var $kJP8l = parcelRequire("kJP8l");

var $kHBTM = parcelRequire("kHBTM");

var $lVJAU = parcelRequire("lVJAU");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $52wwV = parcelRequire("52wwV");

var $iPj86 = parcelRequire("iPj86");

var $b2u1Z = parcelRequire("b2u1Z");

var $l6mLM = parcelRequire("l6mLM");
const $0ec9a9378b2b1a20$export$6d49a893c897b0cc = {
    jira: {
        icon: (0, $39fIG.JiraIcon),
        logo: (0, $c4F0u.JiraLogo)
    },
    serviceDesk: {
        icon: (0, $ds5Yo.JiraServiceManagementIcon),
        logo: (0, $hshbs.JiraServiceManagementLogo)
    },
    'product-discovery': {
        icon: (0, $j7leM.JiraProductDiscoveryIcon),
        logo: (0, $cii2t.JiraProductDiscoveryLogo)
    },
    'customer-service': {
        icon: (0, $iItCF.AtlassianIcon),
        logo: (0, $7esE0.AtlassianLogo)
    }
};
const $0ec9a9378b2b1a20$export$c133be38c8dacddb = {
    jira: {
        icon: (0, $5986g.JiraIcon),
        logo: (0, $jf6er.JiraLogo)
    },
    serviceDesk: {
        icon: (0, $9NAcc.JiraServiceManagementIcon),
        logo: (0, $iP5mc.JiraServiceManagementLogo)
    },
    'product-discovery': {
        icon: (0, $uYpSO.JiraProductDiscoveryIcon),
        logo: (0, $e6boy.JiraProductDiscoveryLogo)
    },
    'customer-service': {
        icon: (0, $biEXp.CustomerServiceManagementIcon),
        logo: (0, $2WMBe.CustomerServiceManagementLogo)
    }
};
const $0ec9a9378b2b1a20$var$ProductHome = (0, $7XYc4.componentWithCondition)(()=>(0, $3HwlS.getWillShowNav4)(), $0ec9a9378b2b1a20$var$ProductHomeNew, $0ec9a9378b2b1a20$var$ProductHomeOld);
const $0ec9a9378b2b1a20$export$32d61f70e04b6020 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).HOME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ec9a9378b2b1a20$var$ProductHome, props));
function $0ec9a9378b2b1a20$var$ProductHomeOld({ AkCustomProductHome: AkCustomProductHome = (0, $iXjIy.default), AkProductHome: AkProductHome = (0, $eUk3o.default), useCustomLogo: useCustomLogo = (0, $52wwV.useCustomLogo), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useProductName: useProductName = (0, $kJP8l.useProductName), useRouterActions: useRouterActions = (0, $lVJAU.useRouterActions), useSiteTitle: useSiteTitle = (0, $b2u1Z.useSiteTitle) }) {
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('product-home-');
    const logoUrl = useCustomLogo();
    const productName = useProductName();
    const siteTitleData = useSiteTitle();
    const siteTitle = siteTitleData.shouldShow && siteTitleData.value || undefined;
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).LOGO
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = useRouterActions();
    const homeUrl = '/jira';
    const navigateToHome = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'ev' implicitly has an 'any' type.
    (ev)=>{
        triggerAnalytics();
        if (ev.ctrlKey || ev.metaKey) return;
        ev.preventDefault();
        push(homeUrl);
    }, [
        triggerAnalytics,
        push,
        homeUrl
    ]);
    if (logoUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkCustomProductHome, {
        iconUrl: logoUrl,
        logoUrl: logoUrl,
        logoAlt: formatMessage((0, $l6mLM.default).customLogoAltText),
        iconAlt: formatMessage((0, $l6mLM.default).customIconAltText),
        href: homeUrl,
        onClick: navigateToHome,
        siteTitle: siteTitle,
        testId: testIdPrefix
    });
    const label = $0ec9a9378b2b1a20$var$getLogoLabel(formatMessage, productName);
    const { icon: Icon, logo: Logo } = $0ec9a9378b2b1a20$var$getProductIconAndLogo(productName, undefined, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkProductHome, {
        icon: Icon,
        logo: Logo,
        href: homeUrl,
        onClick: navigateToHome,
        siteTitle: siteTitle,
        testId: testIdPrefix
    });
}
function $0ec9a9378b2b1a20$var$ProductHomeNew({ useCustomLogo: useCustomLogo = (0, $52wwV.useCustomLogo), useCustomIcon: useCustomIcon = (0, $52wwV.useCustomIcon), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useProductName: useProductName = (0, $kJP8l.useProductName), useRouterActions: useRouterActions = (0, $lVJAU.useRouterActions) }) {
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('product-home-');
    const logoUrl = useCustomLogo();
    const iconUrl = useCustomIcon();
    const productName = useProductName();
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).LOGO
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = useRouterActions();
    const homeUrl = '/jira';
    const navigateToHome = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'ev' implicitly has an 'any' type.
    (ev)=>{
        triggerAnalytics();
        if (ev.ctrlKey || ev.metaKey) return;
        ev.preventDefault();
        push(homeUrl);
    }, [
        triggerAnalytics,
        push,
        homeUrl
    ]);
    const { icon: ProductIcon, logo: ProductLogo } = $0ec9a9378b2b1a20$var$getProductIconAndLogo(productName, testIdPrefix);
    const Logo = (0, $5uXOq.useMemo)(()=>logoUrl ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ec9a9378b2b1a20$var$CustomImgNav4, {
                alt: formatMessage((0, $l6mLM.default).customLogoAltText),
                src: logoUrl,
                testId: `${testIdPrefix}-logo`
            }) : ProductLogo, [
        logoUrl,
        ProductLogo,
        formatMessage,
        testIdPrefix
    ]);
    const Icon = (0, $5uXOq.useMemo)(()=>logoUrl && iconUrl ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ec9a9378b2b1a20$var$CustomImgNav4, {
                alt: formatMessage((0, $l6mLM.default).customIconAltText),
                src: iconUrl,
                testId: `${testIdPrefix}-icon`
            }) : ProductIcon, [
        logoUrl,
        iconUrl,
        ProductIcon,
        testIdPrefix,
        formatMessage
    ]);
    const label = $0ec9a9378b2b1a20$var$getLogoLabel(formatMessage, productName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        testId: `${testIdPrefix}-container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHBTM.NavLogo), {
        label: label,
        icon: Icon,
        logo: Logo,
        href: homeUrl,
        onClick: navigateToHome
    }));
}
// formatMessage is intentionally an any type due to absence of easily importable type, and because actual
// type definition contains any as well!
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0ec9a9378b2b1a20$var$getLogoLabel(formatMessage, productName) {
    let label = '';
    if (productName === 'serviceDesk') label = formatMessage((0, $l6mLM.default).jsmLogoLabel);
    else if (productName === 'product-discovery') label = formatMessage((0, $l6mLM.default).jpdLogoLabel);
    else if (productName === 'customer-service') label = formatMessage((0, $l6mLM.default).jcsLogoLabel);
    else label = formatMessage((0, $l6mLM.default).jiraLogoLabel);
    return label;
}
/**
 * Due to typescript limitations (props type clashes), we need to handle the icon and logo components differently for the
 * new and old navigation apps. This function returns the appropriate components based on the product name.
 */ function $0ec9a9378b2b1a20$var$getProductIconAndLogo(productName, testIdPrefix, label) {
    const productKey = productName === 'core' || productName === 'software' ? 'jira' : productName;
    const { icon: OldIconComponent, logo: OldLogoComponent } = $0ec9a9378b2b1a20$export$6d49a893c897b0cc[productKey];
    const { icon: NewIconComponent, logo: NewLogoComponent } = $0ec9a9378b2b1a20$export$c133be38c8dacddb[productKey];
    const createComponent = (Component, type)=>(props)=>{
            const additionalProps = {};
            // Nav v3 sets a testId, Nav v4 sets a label
            if (testIdPrefix) additionalProps.testId = `${testIdPrefix}-${type}`;
            if (label) additionalProps.label = label;
            // Casting required due to complexities of the different component prop types
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                ...additionalProps
            });
        };
    const oldIcon = createComponent(OldIconComponent, 'icon');
    const oldLogo = createComponent(OldLogoComponent, 'logo');
    const newIcon = createComponent(NewIconComponent, 'icon');
    const newLogo = createComponent(NewLogoComponent, 'logo');
    return (0, $4R6GH.fg)('platform-team25-app-icon-tiles') ? {
        icon: newIcon,
        logo: newLogo
    } : {
        icon: oldIcon,
        logo: oldLogo
    };
}
function $0ec9a9378b2b1a20$var$CustomImgNav4({ alt: alt, src: src, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: src,
        alt: alt,
        "data-testid": testId
    });
}

});
parcelRegister("kJP8l", function(module, exports) {

$parcel$export(module.exports, "useProductName", () => $fbc3e5a1ff3e1b43$export$dde400a84de238be);

var $daoB1 = parcelRequire("daoB1");

var $kLseK = parcelRequire("kLseK");
const $fbc3e5a1ff3e1b43$export$dde400a84de238be = ()=>{
    const appPermissions = (0, $daoB1.useApplicationPermissions)();
    return (0, $kLseK.getProductName)(appPermissions);
};

});
parcelRegister("kLseK", function(module, exports) {

$parcel$export(module.exports, "getProductName", () => $255564fdcf8ca770$export$aa3f36fe5dd1f237);

var $4R6GH = parcelRequire("4R6GH");
const $255564fdcf8ca770$export$aa3f36fe5dd1f237 = (permissions)=>{
    if ((0, $4R6GH.fg)('jcs_master_flag')) {
        const { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCustomerServiceAccess: hasCustomerServiceAccess, hasCoreAccess: hasCoreAccess, hasProductDiscoveryAccess: hasProductDiscoveryAccess } = permissions;
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ProductName'.
        return ([
            {
                condition: hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess && !hasCustomerServiceAccess,
                value: 'software'
            },
            {
                condition: hasServiceDeskAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess && !hasCustomerServiceAccess,
                value: 'serviceDesk'
            },
            {
                condition: hasCoreAccess && !hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess && !hasCustomerServiceAccess,
                value: 'core'
            },
            {
                condition: hasProductDiscoveryAccess && !hasSoftwareAccess && !hasServiceDeskAccess && !hasCustomerServiceAccess,
                value: 'product-discovery'
            },
            {
                condition: hasCustomerServiceAccess && !hasProductDiscoveryAccess && !hasSoftwareAccess && !hasServiceDeskAccess,
                value: 'customer-service'
            }
        ].find((item)=>item.condition) || {
            value: 'jira'
        }).value;
    }
    const { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess, hasProductDiscoveryAccess: hasProductDiscoveryAccess } = permissions;
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ProductName'.
    return ([
        {
            condition: hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess,
            value: 'software'
        },
        {
            condition: hasServiceDeskAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess,
            value: 'serviceDesk'
        },
        {
            condition: hasCoreAccess && !hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess,
            value: 'core'
        },
        {
            condition: hasProductDiscoveryAccess && !hasSoftwareAccess && !hasServiceDeskAccess,
            value: 'product-discovery'
        }
    ].find((item)=>item.condition) || {
        value: 'jira'
    }).value;
};

});


parcelRegister("52wwV", function(module, exports) {

$parcel$export(module.exports, "useCustomLogo", () => $aa86f48989803edf$export$9891fb86d6b41647);
$parcel$export(module.exports, "useCustomIcon", () => $aa86f48989803edf$export$9e69c21df0138642);

var $5uXOq = parcelRequire("5uXOq");

var $j8DrX = parcelRequire("j8DrX");
const $aa86f48989803edf$export$9891fb86d6b41647 = ()=>(0, $5uXOq.useMemo)(()=>(0, $j8DrX.default)('ajs-lf-top-adg3-logourl'), []);
const $aa86f48989803edf$export$9e69c21df0138642 = ()=>(0, $5uXOq.useMemo)(()=>(0, $j8DrX.default)('ajs-fspage-favicon'), []);

});

parcelRegister("b2u1Z", function(module, exports) {

$parcel$export(module.exports, "useSiteTitle", () => $fc4a3f770cbe7bdc$export$3e157e0d79928990);

var $5uXOq = parcelRequire("5uXOq");

var $j8DrX = parcelRequire("j8DrX");
const $fc4a3f770cbe7bdc$export$3e157e0d79928990 = ()=>(0, $5uXOq.useMemo)(()=>({
            shouldShow: (0, $j8DrX.default)('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            value: (0, $j8DrX.default)('ajs-app-title')
        }), []);

});

parcelRegister("l6mLM", function(module, exports) {

$parcel$export(module.exports, "default", () => $874346879bf58ddf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $874346879bf58ddf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    customLogoAltText: {
        "id": "atlassian-navigation.product-home.custom-logo-alt-text",
        "defaultMessage": "Custom Jira logo"
    },
    customIconAltText: {
        "id": "atlassian-navigation.product-home.custom-icon-alt-text",
        "defaultMessage": "Custom Jira icon"
    },
    jiraLogoLabel: {
        "id": "atlassian-navigation.product-home.jira-logo-label",
        "defaultMessage": "Go to your Jira homepage"
    },
    jsmLogoLabel: {
        "id": "atlassian-navigation.product-home.jsm-logo-label",
        "defaultMessage": "Go to your Jira Service Management homepage"
    },
    jpdLogoLabel: {
        "id": "atlassian-navigation.product-home.jpd-logo-label",
        "defaultMessage": "Go to your Jira Product Discovery homepage"
    },
    jcsLogoLabel: {
        "id": "atlassian-navigation.product-home.jcs-logo-label",
        "defaultMessage": "Go to your Jira Customer Service homepage"
    }
});

});


parcelRegister("7bwNu", function(module, exports) {

$parcel$export(module.exports, "Profile", () => $4d6ab55be4705ca2$export$5120f2d0b8d4cab8);

var $5uXOq = parcelRequire("5uXOq");

var $6puUq = parcelRequire("6puUq");

var $2Xq9Q = parcelRequire("2Xq9Q");

var $ew55A = parcelRequire("ew55A");

var $Pxnvj = parcelRequire("Pxnvj");

var $vCqQa = parcelRequire("vCqQa");

var $cbmHg = parcelRequire("cbmHg");

var $ixNeq = parcelRequire("ixNeq");

var $kaHBi = parcelRequire("kaHBi");

var $4R6GH = parcelRequire("4R6GH");

var $aWse0 = parcelRequire("aWse0");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");


var $cE2Qr = parcelRequire("cE2Qr");

var $cYlk7 = parcelRequire("cYlk7");

var $2Ql51 = parcelRequire("2Ql51");

var $3t5QD = parcelRequire("3t5QD");

var $9yzc5 = parcelRequire("9yzc5");

var $4QigF = parcelRequire("4QigF");

var $7uSIc = parcelRequire("7uSIc");

var $koeKL = parcelRequire("koeKL");

var $7XYc4 = parcelRequire("7XYc4");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $iPj86 = parcelRequire("iPj86");

var $1yM7R = parcelRequire("1yM7R");

var $k7xP2 = parcelRequire("k7xP2");

var $ebznH = parcelRequire("ebznH");

var $ixpv2 = parcelRequire("ixpv2");
const $4d6ab55be4705ca2$var$SpotlightTargetDI = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
const $4d6ab55be4705ca2$var$handleMouseEnter = ()=>{
    (0, $4QigF.LazyOpenMenuItem).preload();
    (0, $9yzc5.NavigationProfileNavItemWrapperNudgeLazy).preload();
};
const $4d6ab55be4705ca2$var$Nav3ProfileOld = ({ AkProfile: AkProfile = (0, $2Xq9Q.Profile), Avatar: Avatar = (0, $ew55A.default), Menu: Menu = (0, $ebznH.Menu), Popup: Popup = (0, $vCqQa.default), SpotlightTarget: SpotlightTarget = $4d6ab55be4705ca2$var$SpotlightTargetDI, useCurrentUser: useCurrentUser = (0, $cYlk7.useCurrentUser), useExperienceStart: useExperienceStart = (0, $kaHBi.useExperienceStart), useIntl: useIntl = (0, $aWse0.useIntlV2), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useTopMenus: useTopMenus = (0, $2Ui4E.useTopMenus), useUserBoardId: useUserBoardId = (0, $1yM7R.useUserBoardId) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const [isMenuOpen, { toggle: toggleMenu, off: closeMenu }] = useTopMenus((0, $lmyls.MENU_ID).PROFILE);
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROFILE
    });
    const { data: { user: user } } = useCurrentUser();
    const onStart = useExperienceStart({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROFILE,
        analyticsSource: 'atlassian-navigation'
    });
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const [hasNudgeActive] = (0, $cE2Qr.useHasNudgeActive)();
    const [userBoardId, userBoardOwnerAccountId] = useUserBoardId(isMenuOpen);
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'profile');
    const [userTraits, { setUserTraits: setUserTraits }] = (0, $ixNeq.useUserTraits)();
    const fetchUserTraits = (0, $ixNeq.useFetchUserTraitsOld)();
    const setUserTraitsIfNotAvailable = (0, $5uXOq.useCallback)(async ()=>{
        if (user.isAnonymous) return;
        if (!userTraits?.attributes?.length && userTraits?.attributes !== null) {
            const newTraits = await fetchUserTraits();
            // We must explicitly check for false because fetchUserTraits returns "false" when pending, and "null" when traits are empty.
            if (newTraits !== false) setUserTraits(newTraits);
        }
    }, [
        user.isAnonymous,
        userTraits?.attributes,
        fetchUserTraits,
        setUserTraits
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        onStart();
        toggleMenu();
        triggerAnalytics();
    }, [
        onStart,
        toggleMenu,
        triggerAnalytics
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Menu, {
            userBoardId: userBoardId,
            userBoardOwnerAccountId: userBoardOwnerAccountId,
            testIdPrefix: testIdPrefix
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        userBoardId,
        userBoardOwnerAccountId,
        testIdPrefix
    ]);
    const Trigger = (0, $5uXOq.useCallback)((triggerProps)=>// eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-trigger'),
            onMouseOver: setUserTraitsIfNotAvailable,
            onFocus: setUserTraitsIfNotAvailable
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            conditionsToApplyWrapper: (0, $6784cbc7d62e5d7c$export$7aa8bceae32c7862) === nudgeStep && hasNudgeActive,
            Wrapper: (0, $9yzc5.NavigationProfileNavItemWrapperNudgeAsync)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkProfile, {
            ...triggerProps,
            icon: // NOTE: This SpotlightTarget can be used throughout Jira not just within
            // the current package. They're often used for onboarding or changeboarding
            // experiences and allow an Atlaskit spotlight to be attached to page elements.
            // If you need to change this, make sure you check where the target ID is being used
            // and contact the relevant team as necessary. This Sourcegraph link should help :)
            // http://go/src/PROFILE_SPOTLIGHT_KEY
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SpotlightTarget, {
                name: (0, $Mp6qH.PROFILE_SPOTLIGHT_KEY)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Avatar, {
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                src: user.avatarUrls ? user.avatarUrls['48x48'] : undefined,
                size: "small",
                borderColor: "transparent"
            })),
            isSelected: isMenuOpen,
            onClick: onClick,
            tooltip: formatMessage((0, $ixpv2.default).tooltip),
            onMouseEnter: $4d6ab55be4705ca2$var$handleMouseEnter,
            "aria-label": formatMessage((0, $ixpv2.default).tooltip),
            id: "atlassian-navigation.ui.profile.icon"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6puUq.EngagementSpotlight), {
            engagementId: (0, $Mp6qH.PROFILE_SPOTLIGHT_KEY)
        })), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        formatMessage,
        isMenuOpen,
        onClick,
        testIdPrefix,
        user,
        nudgeStep,
        hasNudgeActive
    ]);
    if (user.isAnonymous) return null;
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Trigger, {
        "aria-expanded": false,
        "aria-haspopup": true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Popup, {
        content: content,
        isOpen: isMenuOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        shouldRenderToParent: true,
        trigger: Trigger,
        label: formatMessage((0, $ixpv2.default).tooltip),
        role: "menu"
    });
};
const $4d6ab55be4705ca2$var$Nav3ProfileWithForge = ({ AkProfile: AkProfile = (0, $2Xq9Q.Profile), Avatar: Avatar = (0, $ew55A.default), Menu: Menu = (0, $ebznH.Menu), Popup: Popup = (0, $vCqQa.default), SpotlightTarget: SpotlightTarget = $4d6ab55be4705ca2$var$SpotlightTargetDI, useCurrentUser: useCurrentUser = (0, $cYlk7.useCurrentUser), useExperienceStart: useExperienceStart = (0, $kaHBi.useExperienceStart), useIntl: useIntl = (0, $aWse0.useIntlV2), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useTopMenus: useTopMenus = (0, $2Ui4E.useTopMenus), useUserBoardId: useUserBoardId = (0, $1yM7R.useUserBoardId) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const [isMenuOpen, { toggle: toggleMenu, off: closeMenu }] = useTopMenus((0, $lmyls.MENU_ID).PROFILE);
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROFILE
    });
    const { data: { user: user } } = useCurrentUser();
    const onStart = useExperienceStart({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROFILE,
        analyticsSource: 'atlassian-navigation'
    });
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const [hasNudgeActive] = (0, $cE2Qr.useHasNudgeActive)();
    const [userBoardId, userBoardOwnerAccountId] = useUserBoardId(isMenuOpen);
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'profile');
    const [userTraits, { setUserTraits: setUserTraits }] = (0, $ixNeq.useUserTraits)();
    const fetchUserTraits = (0, $ixNeq.useFetchUserTraitsOld)();
    const [, { load: loadForgePersonalSettingsItem }] = (0, $7uSIc.useForgePersonalSettingsItems)();
    const cloudId = (0, $koeKL.useCloudId)();
    const setUserTraitsIfNotAvailable = (0, $5uXOq.useCallback)(async ()=>{
        if (user.isAnonymous) return;
        if (!userTraits?.attributes?.length && userTraits?.attributes !== null) {
            const newTraits = await fetchUserTraits();
            // We must explicitly check for false because fetchUserTraits returns "false" when pending, and "null" when traits are empty.
            if (newTraits !== false) setUserTraits(newTraits);
        }
    }, [
        user.isAnonymous,
        userTraits?.attributes,
        fetchUserTraits,
        setUserTraits
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        onStart();
        loadForgePersonalSettingsItem({
            cloudId: cloudId,
            isAnonymous: user.isAnonymous
        });
        toggleMenu();
        triggerAnalytics();
    }, [
        onStart,
        toggleMenu,
        triggerAnalytics,
        loadForgePersonalSettingsItem,
        cloudId,
        user.isAnonymous
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Menu, {
            userBoardId: userBoardId,
            userBoardOwnerAccountId: userBoardOwnerAccountId,
            testIdPrefix: testIdPrefix
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        userBoardId,
        userBoardOwnerAccountId,
        testIdPrefix
    ]);
    const Trigger = (0, $5uXOq.useCallback)((triggerProps)=>// eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-trigger'),
            onMouseOver: setUserTraitsIfNotAvailable,
            onFocus: setUserTraitsIfNotAvailable
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            conditionsToApplyWrapper: (0, $6784cbc7d62e5d7c$export$7aa8bceae32c7862) === nudgeStep && hasNudgeActive,
            Wrapper: (0, $9yzc5.NavigationProfileNavItemWrapperNudgeAsync)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkProfile, {
            ...triggerProps,
            icon: // NOTE: This SpotlightTarget can be used throughout Jira not just within
            // the current package. They're often used for onboarding or changeboarding
            // experiences and allow an Atlaskit spotlight to be attached to page elements.
            // If you need to change this, make sure you check where the target ID is being used
            // and contact the relevant team as necessary. This Sourcegraph link should help :)
            // http://go/src/PROFILE_SPOTLIGHT_KEY
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SpotlightTarget, {
                name: (0, $Mp6qH.PROFILE_SPOTLIGHT_KEY)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Avatar, {
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                src: user.avatarUrls ? user.avatarUrls['48x48'] : undefined,
                size: "small",
                borderColor: "transparent"
            })),
            isSelected: isMenuOpen,
            onClick: onClick,
            tooltip: formatMessage((0, $ixpv2.default).tooltip),
            onMouseEnter: $4d6ab55be4705ca2$var$handleMouseEnter,
            "aria-label": formatMessage((0, $ixpv2.default).tooltip),
            id: "atlassian-navigation.ui.profile.icon"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6puUq.EngagementSpotlight), {
            engagementId: (0, $Mp6qH.PROFILE_SPOTLIGHT_KEY)
        })), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        formatMessage,
        isMenuOpen,
        onClick,
        testIdPrefix,
        user,
        nudgeStep,
        hasNudgeActive
    ]);
    if (user.isAnonymous) return null;
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Trigger, {
        "aria-expanded": false,
        "aria-haspopup": true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Popup, {
        content: content,
        isOpen: isMenuOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        shouldRenderToParent: true,
        trigger: Trigger,
        label: formatMessage((0, $ixpv2.default).tooltip),
        role: "menu"
    });
};
const $4d6ab55be4705ca2$var$Nav3Profile = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('forge-ui-project-web-items'), $4d6ab55be4705ca2$var$Nav3ProfileWithForge, $4d6ab55be4705ca2$var$Nav3ProfileOld);
const $4d6ab55be4705ca2$var$Nav4Profile = ({ AccountMenu: AccountMenu = (0, $cbmHg.AccountMenuNav3), AkProfile: AkProfile = (0, $2Xq9Q.Profile), Avatar: Avatar = (0, $ew55A.default), MenuNav4: MenuNav4 = (0, $k7xP2.MenuNav4), useCurrentUser: useCurrentUser = (0, $cYlk7.useCurrentUser), useIntl: useIntl = (0, $aWse0.useIntlV2), useUserBoardId: useUserBoardId = (0, $1yM7R.useUserBoardId) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const { theme: theme, setTheme: setTheme } = (0, $2Ql51.useThemePreference)();
    const { data: { user: user } } = useCurrentUser();
    // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & User)'.
    const emailAddress = user.emailAddress || '';
    const atlassianSettingsLink = (0, $2EqxS.useAtlassianPersonalSettingsLink)(emailAddress);
    const switchAccountLink = (0, $2EqxS.useSwitchAccountLink)();
    const profileLink = (0, $2EqxS.useProfileLink)();
    const [userBoardId, userBoardOwnerAccountId] = useUserBoardId(false);
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'profile');
    if (user.isAnonymous) return null;
    if (false && !(0, $4R6GH.fg)('jira_nav4_beta_drop_2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AkProfile, {
        "aria-haspopup": true,
        "aria-expanded": false,
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, 'trigger'),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Avatar, {
            size: "small",
            borderColor: "transparent"
        }),
        tooltip: formatMessage((0, $ixpv2.default).tooltip),
        "aria-label": formatMessage((0, $ixpv2.default).tooltip),
        id: "atlassian-navigation.ui.profile.icon"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AccountMenu, {
        testId: testIdPrefix,
        // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'DataBasic | (DataBasic & User)'.
        name: user.displayName,
        // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & User)'.
        picture: user.avatarUrls ? user.avatarUrls['48x48'] : undefined,
        email: emailAddress,
        viewProfileLink: profileLink,
        manageProfileLink: atlassianSettingsLink,
        switchAccountLink: switchAccountLink,
        logOutLink: "/logout",
        onThemeChange: setTheme,
        currentTheme: theme,
        extraMenuItems: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuNav4, {
            userBoardId: userBoardId,
            userBoardOwnerAccountId: userBoardOwnerAccountId,
            testIdPrefix: testIdPrefix
        })
    });
};
const $4d6ab55be4705ca2$var$Profile = (props)=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('jira_nav4_new_identity_menu') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d6ab55be4705ca2$var$Nav4Profile, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d6ab55be4705ca2$var$Nav3Profile, props);
const $4d6ab55be4705ca2$export$5120f2d0b8d4cab8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROFILE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d6ab55be4705ca2$var$Profile, props));

});
parcelRegister("ixNeq", function(module, exports) {

$parcel$export(module.exports, "useFetchUserTraitsOld", () => $5e172a254cf471a7$export$d5a27009aa54a078);
$parcel$export(module.exports, "useUserTraits", () => $5e172a254cf471a7$export$49363c8b904e0dc7);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $5e172a254cf471a7$var$setUserTraits = (newTraits)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        setState({
            ...currentUserTraits,
            attributes: newTraits
        });
    };
const $5e172a254cf471a7$var$addUserTrait = (trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        if (currentUserTraits.attributes?.some((t)=>t.name === trait.name)) return;
        setState({
            attributes: currentUserTraits.attributes?.concat(trait) ?? [
                trait
            ]
        });
    };
const $5e172a254cf471a7$var$fetchUserTraits = (cloudId, accountId)=>async ({ getState: getState, setState: setState })=>{
        if (!accountId) return null;
        const state = getState();
        if (state.attributes !== null) return;
        const getUserTraits = async ()=>{
            try {
                const userTraitsData = await (0, $eusud.performGetRequest)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`);
                return userTraitsData?.attributes ?? [];
            } catch  {
                return null;
            }
        };
        const userTraits = await getUserTraits();
        setState({
            attributes: userTraits
        });
    };
const $5e172a254cf471a7$var$actions = {
    setUserTraits: $5e172a254cf471a7$var$setUserTraits,
    fetchUserTraits: $5e172a254cf471a7$var$fetchUserTraits,
    addUserTrait: $5e172a254cf471a7$var$addUserTrait
};
const $5e172a254cf471a7$var$initialState = {
    attributes: null
};
const $5e172a254cf471a7$export$d5a27009aa54a078 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const accountId = (0, $90yGq.useAccountId)();
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    return (0, $5uXOq.useCallback)(async ()=>{
        if (!accountId) return null;
        const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const getUserTraits = async ()=>{
            try {
                setLoading(true);
                const userTraitsData = await (0, $eusud.performGetRequest)(url);
                // If a user has no attributes on their account, return null so we know
                // not to keep trying to fetch data.
                return !userTraitsData?.attributes?.length ? null : userTraitsData?.attributes;
            } catch  {
                return null;
            } finally{
                setLoading(false);
            }
        };
        if (!loading) {
            const userTraits = await getUserTraits();
            return userTraits;
        }
        return false;
    }, [
        accountId,
        cloudId,
        loading
    ]);
};
const $5e172a254cf471a7$export$6e688ed53ae076d5 = (0, $iXqE5.createStore)({
    initialState: $5e172a254cf471a7$var$initialState,
    actions: $5e172a254cf471a7$var$actions,
    name: 'UserTraits'
});
const $5e172a254cf471a7$export$49363c8b904e0dc7 = (0, $3sQ5x.createHook)($5e172a254cf471a7$export$6e688ed53ae076d5);
const $5e172a254cf471a7$export$4f249a943026a90b = (0, $3sQ5x.createActionsHook)($5e172a254cf471a7$export$6e688ed53ae076d5);

});

parcelRegister("3t5QD", function(module, exports) {

$parcel$export(module.exports, "ConditionalNudgeWrapper", () => $44a5067dcee1bfd9$export$56d544c4f479b7fb);

var $5uXOq = parcelRequire("5uXOq");
const $44a5067dcee1bfd9$export$56d544c4f479b7fb = ({ children: children, Wrapper: Wrapper, conditionsToApplyWrapper: conditionsToApplyWrapper, ...restProps })=>{
    if (conditionsToApplyWrapper && !false && children !== null && children !== false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, restProps, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};

});

parcelRegister("9yzc5", function(module, exports) {

$parcel$export(module.exports, "NavigationProfileNavItemWrapperNudgeLazy", () => $e1b30bf1670573e8$export$3651b15d92c1c280);
$parcel$export(module.exports, "NavigationProfileNavItemWrapperNudgeAsync", () => $e1b30bf1670573e8$export$deb2cae843941204);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

const $e1b30bf1670573e8$export$3651b15d92c1c280 = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("9bwTp")).then((exportedModule)=>exportedModule.NavigationProfileNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-profile/index.tsx"
});
const $e1b30bf1670573e8$export$deb2cae843941204 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: "asyncProfileNudge",
        fallback: children,
        attributes: {
            NAVIGATION_APPS_PROFILE_ITEM_NUDGE_ID: $6784cbc7d62e5d7c$export$7aa8bceae32c7862
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "navigation-profile-nav-item-wrapper-nudge-lazy",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e1b30bf1670573e8$export$3651b15d92c1c280, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$7aa8bceae32c7862)
    }, children)));
$e1b30bf1670573e8$export$deb2cae843941204.displayName = 'NavigationProfileNavItemWrapperNudgeAsync';

});
parcelRegister("9bwTp", function(module, exports) {

let $6afea7f33a3fc6d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6afea7f33a3fc6d5$var$load("91SdU").then(()=>parcelRequire('doFig'));

});


parcelRegister("7uSIc", function(module, exports) {

$parcel$export(module.exports, "useForgePersonalSettingsItems", () => $bf0aca3f9b0d9b8d$export$455fadc65ea0bef0);

var $9XE6b = parcelRequire("9XE6b");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $iVaKa = parcelRequire("iVaKa");

var $3HwlS = parcelRequire("3HwlS");

var $1C2yb = parcelRequire("1C2yb");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $bf0aca3f9b0d9b8d$var$getItemHref = (extension)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `${(0, $1C2yb.getAppsPersonalSettingsPath)()}/${appId}/${envId}`;
};
const $bf0aca3f9b0d9b8d$var$handleFetch = ({ cloudId: cloudId, isAnonymous: isAnonymous })=>async ({ setState: setState, getState: getState })=>{
        const { fetchForgeModule: fetchForgeModule, isFetching: isFetching } = getState();
        if (!isFetching) try {
            // If Nav4 is enabled, we don't need to fetch personalSettings items since they are implemented elsewhere.
            if ((0, $3HwlS.getWillShowNav4)()) return;
            const promise = fetchForgeModule({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                context: {},
                includeHidden: false,
                types: [
                    (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
                ],
                source: (0, $k2DRb.SOURCE_NAVIGATION)
            });
            setState({
                isFetching: true,
                fetchError: null,
                promise: promise
            });
            const data = await promise;
            const personalSettingsPageData = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)) || [];
            const items = personalSettingsPageData.map((extension)=>({
                    id: extension.id,
                    title: extension.properties.title,
                    avatarUrl: extension.properties.icon,
                    url: $bf0aca3f9b0d9b8d$var$getItemHref(extension),
                    environmentType: extension.environmentType,
                    environmentKey: extension.environmentKey,
                    module: (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
                }));
            setState({
                items: items,
                isFetching: false,
                fetchError: null,
                promise: null
            });
        } catch (fetchError) {
            setState({
                ...getState(),
                fetchError: fetchError instanceof Error ? fetchError : null,
                promise: null
            });
        }
    };
const $bf0aca3f9b0d9b8d$var$actions = {
    load: ({ cloudId: cloudId, isAnonymous: isAnonymous })=>async ({ dispatch: dispatch })=>{
            await dispatch($bf0aca3f9b0d9b8d$var$handleFetch({
                cloudId: cloudId,
                isAnonymous: isAnonymous
            }));
        }
};
const $bf0aca3f9b0d9b8d$export$a51e606fadb150f6 = (defaults)=>{
    const initialState = {
        fetchForgeModule: defaults.fetchForgeModule,
        items: [],
        promise: null,
        fetchError: null,
        isFetching: false
    };
    const Store = (0, $iXqE5.createStore)({
        name: 'forge-personal-settings-items-store',
        actions: $bf0aca3f9b0d9b8d$var$actions,
        initialState: initialState
    });
    const ForgePersonalSettingsItemsTestContainer = (0, $gg7kZ.createContainer)(Store, {
        onInit: ()=>(api, props)=>{
                api.setState(props);
            }
    });
    const selector = ({ items: items, fetchError: fetchError, promise: promise, isFetching: isFetching })=>({
            items: items,
            fetchError: fetchError,
            promise: promise,
            isFetching: isFetching
        });
    const ForgePersonalSettingsItemsSubscriber = (0, $51nlc.createSubscriber)(Store, {
        displayName: 'ForgePersonalSettingsItemsSubscriber',
        selector: selector
    });
    const useForgePersonalSettingsItems = (0, $3sQ5x.createHook)(Store, {
        selector: selector
    });
    return {
        ForgePersonalSettingsItemsSubscriber: ForgePersonalSettingsItemsSubscriber,
        useForgePersonalSettingsItems: useForgePersonalSettingsItems,
        ForgePersonalSettingsItemsTestContainer: ForgePersonalSettingsItemsTestContainer
    };
};
const { useForgePersonalSettingsItems: $bf0aca3f9b0d9b8d$export$455fadc65ea0bef0 } = $bf0aca3f9b0d9b8d$export$a51e606fadb150f6({
    fetchForgeModule: (0, $iVaKa.fetchModules)
});

});

parcelRegister("1yM7R", function(module, exports) {

$parcel$export(module.exports, "useUserBoardId", () => $c7748d5d5fa92b7a$export$e6e895063f36c814);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $6yXtV = parcelRequire("6yXtV");
const $c7748d5d5fa92b7a$export$e6e895063f36c814 = (shouldRun)=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [userBoard, setUserBoard] = (0, $5uXOq.useState)(null);
    const shouldFetch = shouldRun || isReady;
    (0, $5uXOq.useEffect)(()=>{
        if (!shouldFetch || userBoard) return;
        setUserBoard(null);
        const requestUrl = '/rest/greenhopper/1.0/rapidviews/recent?maxResults=1&userBoard=true';
        (0, $eusud.performGetRequest)(requestUrl).then((result)=>{
            const [board] = result.views;
            if (board) setUserBoard(board);
        }).catch(()=>{
        // user board fetch failed, ignore
        });
    }, [
        shouldFetch,
        userBoard,
        setUserBoard
    ]);
    return userBoard && userBoard.location ? [
        userBoard.id,
        userBoard.location.accountId
    ] : [
        null,
        null
    ];
};

});

parcelRegister("k7xP2", function(module, exports) {

$parcel$export(module.exports, "MenuNav4", () => $b62ef795f8dd8307$export$60113ca6a29c7a92);
/* main-nav4.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $d6a7c = parcelRequire("d6a7c");
var $70rf1 = parcelRequire("70rf1");

var $2vSU6 = parcelRequire("2vSU6");

var $3bQtK = parcelRequire("3bQtK");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $dAfqg = parcelRequire("dAfqg");

var $lyCs2 = parcelRequire("lyCs2");


var $jrUuh = parcelRequire("jrUuh");

var $4QigF = parcelRequire("4QigF");

var $lwZRC = parcelRequire("lwZRC");

var $Mp6qH = parcelRequire("Mp6qH");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $dgPkW = parcelRequire("dgPkW");

var $cEIWv = parcelRequire("cEIWv");
const $b62ef795f8dd8307$export$60113ca6a29c7a92 = ({ testIdPrefix: testIdPrefix, userBoardId: userBoardId, userBoardOwnerAccountId: userBoardOwnerAccountId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $5uXOq.useEffect)(()=>{
        onSuccess();
    }, [
        onSuccess
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-popup');
    const testIdContent = (0, $6cNb0.testIdConcat)(testId, 'content');
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $jrUuh.useJsmOnboardingType)();
    (0, $5uXOq.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        fetchOnboardingType,
        projectContextData?.projectId,
        projectContextData?.projectType
    ]);
    const showInJwmProjects = projectContextData?.projectType === (0, $2vSU6.CORE_PROJECT);
    const showInSoftwareProjects = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const showInJsmProjects = projectContextData?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $e7830161eb8674f1$export$6f454e69bce3a691);
    let yourBoardsRoute;
    let yourBoardsParams;
    let yourBoardsQuery;
    if (userBoardId != null) {
        yourBoardsRoute = (0, $lyCs2.userBoardRoute);
        yourBoardsParams = {
            accountId: userBoardOwnerAccountId,
            boardId: String(userBoardId)
        };
    }
    const boardOffset = userBoardId == null ? -1 : 0;
    const showQuickstartOpenMenuItem = showInJwmProjects || showInSoftwareProjects || showInJsmProjects;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, showQuickstartOpenMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4QigF.OpenMenuItem), {
        MenuItem: (0, $d4B4Y.MenuItem)
    }), userBoardId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        hasSeparator: true,
        testId: testIdContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdContent, 'jira')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6a7c.default), {
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'heading')
    }, formatMessage((0, $cEIWv.default).jira)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $cEIWv.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'your-boards',
            menuItemType: 'jira',
            position: 1
        },
        href: `/jira/people/${String(userBoardOwnerAccountId)}/boards/${userBoardId}`,
        params: yourBoardsParams,
        query: yourBoardsQuery,
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-your-boards'),
        to: yourBoardsRoute
    }, formatMessage((0, $cEIWv.default).yourBoards))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lwZRC.StandardToPremiumPubTouchpoint), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dgPkW.ExtraItemsNav4), {
        startPosition: 5 + boardOffset,
        testIdPrefix: testIdContent,
        itemAriaLabel: formatMessage((0, $cEIWv.default).jira)
    }));
};

});
parcelRegister("d4B4Y", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $ac79b65b740c9d18$export$2ce376c2cc3355c8);

var $5uXOq = parcelRequire("5uXOq");

var $7H980 = parcelRequire("7H980");

var $jngLf = parcelRequire("jngLf");

var $9YfZr = parcelRequire("9YfZr");

var $6oGXD = parcelRequire("6oGXD");
const $ac79b65b740c9d18$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, params: params, query: query, replace: replace, target: target, to: to, type: type, ...rest }, ref)=>{
    const onClickHandler = (0, $6oGXD.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    if (to != null && __SPA__) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9YfZr.RouteLinkItem), {
        ref: ref,
        onClick: onClickHandler,
        params: params,
        query: query,
        replace: replace,
        target: target,
        to: to,
        type: type,
        ...rest
    });
    return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jngLf.LinkItem), {
        ref: ref,
        href: href,
        target: target,
        onClick: onClickHandler,
        ...rest
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        ref: ref,
        onClick: onClickHandler,
        ...rest
    });
});

});
parcelRegister("jngLf", function(module, exports) {

$parcel$export(module.exports, "LinkItem", () => $3ef5556c5063294d$export$532cb6865ebe8946);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $44qT7 = parcelRequire("44qT7");

var $gRLNg = parcelRequire("gRLNg");
const $3ef5556c5063294d$export$532cb6865ebe8946 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ href: href, target: target, onClick: onClick, ...rest }, ref)=>{
    const navigate = (0, $gRLNg.useNavigate)({
        href: href,
        onClick: onClick,
        target: target
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ef5556c5063294d$export$8c0773eab230d49e, {
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : '',
        onClick: navigate,
        ref: ref,
        ...rest
    });
});
const $3ef5556c5063294d$export$8c0773eab230d49e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $44qT7.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1nrm18uv _1a3b18uv _9oik18uv _c2wa1kw7 _4fpr1kw7 _1bnx1kw7 _1iohnqa1 _5goinqa1 _jf4cnqa1 _9h8h1kw7 _f8pj1kw7 _30l31kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gRLNg", function(module, exports) {

$parcel$export(module.exports, "useNavigate", () => $f019fb7f0ef5833c$export$9770f232ac06a008);

var $5uXOq = parcelRequire("5uXOq");

var $lVJAU = parcelRequire("lVJAU");
const $f019fb7f0ef5833c$export$9770f232ac06a008 = ({ href: href, target: target, onClick: onClick, useRouterActions: useRouterActions = (0, $lVJAU.useRouterActions), useCallback: useCallback = (0, $5uXOq.useCallback) })=>{
    const { push: push } = useRouterActions();
    return useCallback((event)=>{
        onClick && onClick(event);
        if (event.ctrlKey || event.metaKey || event.defaultPrevented || target === '_blank') return;
        event.preventDefault();
        push(href);
    }, [
        push,
        href,
        target,
        onClick
    ]);
};

});


parcelRegister("9YfZr", function(module, exports) {

$parcel$export(module.exports, "RouteLinkItem", () => $3031a27cd367c26b$export$5885e1e37551a766);

var $5uXOq = parcelRequire("5uXOq");

var $2COCu = parcelRequire("2COCu");

var $hjSul = parcelRequire("hjSul");
const $3031a27cd367c26b$export$5885e1e37551a766 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ rel: rel, target: target, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2COCu.default), {
        component: (0, $hjSul.Link),
        rel: rel ?? (target === '_blank' ? 'noopener noreferrer' : ''),
        target: target,
        prefetch: "hover",
        ref: ref,
        ...props
    }));

});

parcelRegister("6oGXD", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $a8a7ed1bfe9b49e0$export$a81c45382e7253ac);

var $2uT3N = parcelRequire("2uT3N");

var $2Ui4E = parcelRequire("2Ui4E");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");
const $a8a7ed1bfe9b49e0$export$a81c45382e7253ac = ({ analytics: analytics, fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), onClick: onClick, useAnalyticsEvents: useAnalyticsEvents = (0, $bngFq.useAnalyticsEvents), useOverflowStatus: useOverflowStatus = (0, $2uT3N.useOverflowStatus), useTopMenus: useTopMenus = (0, $2Ui4E.useTopMenus) } = {})=>{
    const [, { off: closeMenu }] = useTopMenus();
    const { isVisible: isVisible, closeOverflowMenu: closeOverflowMenu } = useOverflowStatus();
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const { actionSubjectId: actionSubjectId, ...analyticsRest } = analytics;
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationMenuItem'
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fireUIAnalytics(analyticsEvent, actionSubjectId, {
            ...analyticsRest,
            isInMore: !isVisible
        });
        onClick && onClick(event);
        if (event.ctrlKey || event.metaKey) return;
        closeMenu();
        closeOverflowMenu();
    };
};

});


parcelRegister("7ilb8", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $44f127900c12f92a$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "MenuListItem", () => $44f127900c12f92a$export$6c2f3257abc4825b);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");
const $44f127900c12f92a$export$d4c4e98c5044dc8 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "ul",
        xcss: $44f127900c12f92a$var$removeDefaultListStyles
    }, children);
const $44f127900c12f92a$export$6c2f3257abc4825b = ({ children: children, ariaLabel: ariaLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "li",
        xcss: $44f127900c12f92a$var$removeDefaultListStyles,
        "aria-label": ariaLabel
    }, children);
const $44f127900c12f92a$var$removeDefaultListStyles = (0, $2s57o.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});

});

parcelRegister("dgPkW", function(module, exports) {

$parcel$export(module.exports, "ExtraItems", () => $78c0b34ec312aabb$export$56021421a935c353);
$parcel$export(module.exports, "ExtraItemsNav4", () => $78c0b34ec312aabb$export$ee2972db91c46b97);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $70rf1 = parcelRequire("70rf1");

var $hrlU6 = parcelRequire("hrlU6");

var $6cNb0 = parcelRequire("6cNb0");

var $atU1t = parcelRequire("atU1t");

var $2YP9W = parcelRequire("2YP9W");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");
const $78c0b34ec312aabb$var$useConnectItems = ()=>{
    const { data: resourceData, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $atU1t.navigationSidebarGlobalResource));
    const data = resourceData?.response;
    (0, $5uXOq.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        error,
        loading,
        refresh
    ]);
    return data ? (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, 'global.profile.items', []).filter((item)=>![
            'view_profile',
            'log_out'
        ].includes(item.id)) : [];
};
const $78c0b34ec312aabb$var$Item = ({ url: url, name: name, id: id, styleClass: styleClass, itemAriaLabel: itemAriaLabel, position: position, testId: testId })=>{
    const webItemRef = (0, $5uXOq.useRef)(null);
    const isDialog = styleClass && (0, $hrlU6.isConnectDialogWebItem)(styleClass);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (isDialog) (0, $hrlU6.withConnectHost)((connectHost)=>{
            if (styleClass && webItemRef.current) connectHost.triggerWebItem(webItemRef.current, styleClass, url);
        });
    }, [
        isDialog,
        styleClass,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        key: url,
        ariaLabel: itemAriaLabel || ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        ref: webItemRef,
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: id,
            menuItemType: 'jira',
            position: position
        },
        href: isDialog ? undefined : url,
        onClick: isDialog ? onClick : undefined,
        testId: testId
    }, name));
};
const $78c0b34ec312aabb$export$56021421a935c353 = ({ startPosition: startPosition, testIdPrefix: testIdPrefix, itemAriaLabel: itemAriaLabel })=>{
    const connectItems = $78c0b34ec312aabb$var$useConnectItems();
    if (!connectItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, connectItems.map(({ id: id, name: name, url: url, styleClass: styleClass }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($78c0b34ec312aabb$var$Item, {
            key: url,
            url: url,
            name: name,
            id: id,
            styleClass: styleClass,
            itemAriaLabel: itemAriaLabel,
            position: startPosition + idx,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, `item-addon-${idx}`)
        });
    }));
};
const $78c0b34ec312aabb$export$ee2972db91c46b97 = ({ startPosition: startPosition, testIdPrefix: testIdPrefix, itemAriaLabel: itemAriaLabel })=>{
    const connectItems = $78c0b34ec312aabb$var$useConnectItems();
    if (!connectItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        hasSeparator: true
    }, connectItems.map(({ id: id, name: name, url: url, styleClass: styleClass }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($78c0b34ec312aabb$var$Item, {
            key: url,
            url: url,
            name: name,
            id: id,
            styleClass: styleClass,
            itemAriaLabel: itemAriaLabel,
            position: startPosition + idx,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, `item-addon-${idx}`)
        });
    }));
};

});

parcelRegister("cEIWv", function(module, exports) {

$parcel$export(module.exports, "default", () => $521f3eedcdcca1a6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $521f3eedcdcca1a6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    giveFeedback: {
        "id": "atlassian-navigation.profile.menu.give-feedback",
        "defaultMessage": "Give us feedback"
    },
    yourBoards: {
        "id": "atlassian-navigation.profile.menu.your-boards",
        "defaultMessage": "Your boards"
    },
    new: {
        "id": "atlassian-navigation.profile.menu.new",
        "defaultMessage": "new"
    },
    personalSettings: {
        "id": "atlassian-navigation.profile.menu.personal-settings",
        "defaultMessage": "Personal settings"
    },
    logout: {
        "id": "atlassian-navigation.profile.menu.logout",
        "defaultMessage": "Log out"
    },
    jira: {
        "id": "atlassian-navigation.profile.menu.jira",
        "defaultMessage": "Jira"
    },
    account: {
        "id": "atlassian-navigation.profile.menu.account",
        "defaultMessage": "Account"
    },
    profile: {
        "id": "atlassian-navigation.profile.menu.profile",
        "defaultMessage": "Profile"
    },
    notifications: {
        "id": "atlassian-navigation.profile.menu.notifications",
        "defaultMessage": "Notifications"
    }
});

});


parcelRegister("ebznH", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $32d3ea680525e18b$export$d9b273488cd8ce6f);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6puUq = parcelRequire("6puUq");

var $eOat1 = parcelRequire("eOat1");

var $d6a7c = parcelRequire("d6a7c");
var $70rf1 = parcelRequire("70rf1");

var $Pxnvj = parcelRequire("Pxnvj");

var $ixNeq = parcelRequire("ixNeq");

var $2vSU6 = parcelRequire("2vSU6");

var $3bQtK = parcelRequire("3bQtK");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $1C2yb = parcelRequire("1C2yb");

var $cYlk7 = parcelRequire("cYlk7");

var $dAfqg = parcelRequire("dAfqg");

var $fDWVs = parcelRequire("fDWVs");

var $7ziML = parcelRequire("7ziML");

var $d1xZH = parcelRequire("d1xZH");

var $lyCs2 = parcelRequire("lyCs2");


var $jrUuh = parcelRequire("jrUuh");

var $4QigF = parcelRequire("4QigF");

var $90yGq = parcelRequire("90yGq");

var $lwZRC = parcelRequire("lwZRC");

var $Mp6qH = parcelRequire("Mp6qH");

var $d4B4Y = parcelRequire("d4B4Y");

var $ag3sS = parcelRequire("ag3sS");

var $7ilb8 = parcelRequire("7ilb8");

var $5DUZ0 = parcelRequire("5DUZ0");

var $dgPkW = parcelRequire("dgPkW");

var $4WZuY = parcelRequire("4WZuY");

var $cEIWv = parcelRequire("cEIWv");

var $fUv6Z = parcelRequire("fUv6Z");

var $3CMYn = parcelRequire("3CMYn");
const $32d3ea680525e18b$export$d9b273488cd8ce6f = ({ testIdPrefix: testIdPrefix, userBoardId: userBoardId, userBoardOwnerAccountId: userBoardOwnerAccountId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: { user: user } } = (0, $cYlk7.useCurrentUser)();
    const accountId = (0, $90yGq.useAccountId)();
    const profileLink = (0, $2EqxS.useProfileLink)();
    const onSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $5uXOq.useEffect)(()=>{
        onSuccess();
    }, [
        onSuccess
    ]);
    const profileParams = {
        subPath: accountId
    };
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-popup');
    const testIdContent = (0, $6cNb0.testIdConcat)(testId, 'content');
    const testIdFooter = (0, $6cNb0.testIdConcat)(testId, 'footer');
    const [upgradeEditionMenuShown, setUpgradeEditionMenuShown] = (0, $5uXOq.useState)(false);
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $jrUuh.useJsmOnboardingType)();
    (0, $5uXOq.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        fetchOnboardingType,
        projectContextData?.projectId,
        projectContextData?.projectType
    ]);
    const showInJwmProjects = projectContextData?.projectType === (0, $2vSU6.CORE_PROJECT);
    const showInSoftwareProjects = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const showInJsmProjects = projectContextData?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $e7830161eb8674f1$export$6f454e69bce3a691);
    let yourBoardsRoute;
    let yourBoardsParams;
    let yourBoardsQuery;
    if (userBoardId != null) {
        yourBoardsRoute = (0, $lyCs2.userBoardRoute);
        yourBoardsParams = {
            accountId: userBoardOwnerAccountId,
            boardId: String(userBoardId)
        };
    }
    const boardOffset = userBoardId == null ? -1 : 0;
    const [userTraits] = (0, $ixNeq.useUserTraits)();
    const showNotificationsNewLozenge = (0, $5uXOq.useMemo)(()=>{
        const accountCreationDate = userTraits?.attributes?.find((trait)=>trait?.name === 'jira_first_active')?.value;
        const aWeekAgo = new Date(Date.now() - 604800000);
        let isNewUser = false;
        if (accountCreationDate && typeof accountCreationDate === 'string') isNewUser = new Date(accountCreationDate) > aWeekAgo;
        return !isNewUser;
    }, [
        userTraits
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // The Spotlight components listen to the resize event to
        // update their positioning. This will fix Spotlights pulse overlap
        // that are shown on Menu items. Without this the pulse are located
        /// at incorrect position.
        setTimeout(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.dispatchEvent(new Event('resize'));
        }, 0);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId,
        role: "dialog",
        "aria-labelledby": "atlassian-navigation-account-dialog-heading",
        className: (0, $bwpsq.default)([
            "_syaz1fxt"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ag3sS.MenuLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdContent, 'account')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6a7c.default), {
        id: "atlassian-navigation-account-dialog-heading",
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'account', 'heading')
    }, formatMessage((0, $cEIWv.default).account)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5DUZ0.AccountDetails // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
    ), {
        email: user.emailAddress || '',
        userFullname: user.userFullname,
        avatarSrc: user.avatarUrls ? user.avatarUrls['32x32'] : undefined,
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'account')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lwZRC.StandardToPremiumPubTouchpoint), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        hasSeparator: upgradeEditionMenuShown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3CMYn.UpgradeEditionMenuItem), {
        setUpgradeEditionMenuShown: setUpgradeEditionMenuShown
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        hasSeparator: upgradeEditionMenuShown || !upgradeEditionMenuShown,
        testId: testIdContent
    }, (showInJwmProjects || showInSoftwareProjects || showInJsmProjects) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4QigF.OpenMenuItem), {
        MenuItem: (0, $d4B4Y.MenuItem)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdContent, 'jira')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6a7c.default), {
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'heading')
    }, formatMessage((0, $cEIWv.default).jira)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $cEIWv.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'profile',
            menuItemType: 'jira',
            position: 0
        },
        href: profileLink,
        params: profileParams,
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-profile'),
        to: (0, $fDWVs.peopleProfilesRoute)
    }, formatMessage((0, $cEIWv.default).profile))), userBoardId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $cEIWv.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'your-boards',
            menuItemType: 'jira',
            position: 1
        },
        href: `/jira/people/${String(userBoardOwnerAccountId)}/boards/${userBoardId}`,
        params: yourBoardsParams,
        query: yourBoardsQuery,
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-your-boards'),
        to: yourBoardsRoute
    }, formatMessage((0, $cEIWv.default).yourBoards))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $cEIWv.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'personal-settings',
            menuItemType: 'jira',
            position: 2 + boardOffset
        },
        href: (0, $1C2yb.getGeneralPersonalSettingsPath)(),
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-personal-settings'),
        to: (0, $7ziML.generalPersonalSettingsRoute)
    }, formatMessage((0, $cEIWv.default).personalSettings))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $cEIWv.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
        name: "notifications-menu-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'notifications',
            menuItemType: 'jira',
            position: 3 + boardOffset
        },
        href: (0, $1C2yb.getNotificationsPersonalSettingsPath)(),
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-notifications'),
        to: (0, $d1xZH.notificationsPersonalSettingsRoute),
        iconAfter: showNotificationsNewLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
            appearance: "new"
        }, formatMessage((0, $cEIWv.default).new)) : null
    }, formatMessage((0, $cEIWv.default).notifications)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6puUq.EngagementSpotlight), {
        engagementId: "notifications-menu-spotlight"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $cEIWv.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fUv6Z.default), {
        testId: (0, $6cNb0.testIdConcat)(testIdContent, 'jira', 'item-theme'),
        itemPosition: 4 + boardOffset
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dgPkW.ExtraItems), {
        startPosition: 5 + boardOffset,
        testIdPrefix: testIdContent,
        itemAriaLabel: formatMessage((0, $cEIWv.default).jira)
    }), (0, $4R6GH.fg)('forge-ui-project-web-items') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4WZuY.ForgeItems), {
        startPosition: 6 + boardOffset,
        testIdPrefix: testIdContent,
        itemAriaLabel: formatMessage((0, $cEIWv.default).jira)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        hasSeparator: true,
        testId: testIdFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdFooter, 'items')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'logout',
            menuItemType: 'action',
            position: 0
        },
        href: "/logout",
        testId: (0, $6cNb0.testIdConcat)(testIdFooter, 'items', 'item-log-out')
    }, formatMessage((0, $cEIWv.default).logout))))));
};
const $32d3ea680525e18b$var$styles = null;

});
parcelRegister("ag3sS", function(module, exports) {

$parcel$export(module.exports, "MenuLayout", () => $a3bb5b7f7abc0b96$export$dc2a07138b27c65b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $aOrxC = parcelRequire("aOrxC");

var $gwIPs = parcelRequire("gwIPs");
const $a3bb5b7f7abc0b96$export$dc2a07138b27c65b = ({ children: children, isWide: isWide = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3bb5b7f7abc0b96$var$Wrapper, {
        isWide: isWide
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), {
        maxHeight: $a3bb5b7f7abc0b96$var$maxHeight
    }, children));
const $a3bb5b7f7abc0b96$var$starStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3bb5b7f7abc0b96$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isWide: isWide, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1d8u6ab": (0, $lD23V.default)(__cmplp.isWide ? `${(0, $gwIPs.gridSize) * 40}px` : `${(0, $gwIPs.gridSize) * 29.25}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul911kg _p12f1c3h _107nidpf _js70kb7n _nqzgkb7n _ziy7kb7n",
            __cmplp.className
        ])
    });
});
const $a3bb5b7f7abc0b96$var$maxHeight = `calc(100vh - ${(0, $gwIPs.gridSize) * 25}px)`;

});

parcelRegister("5DUZ0", function(module, exports) {

$parcel$export(module.exports, "AccountDetails", () => $a1d7ada73782364f$export$66e04d0aacdb3b2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ew55A = parcelRequire("ew55A");

var $6P0Kj = parcelRequire("6P0Kj");

var $44qT7 = parcelRequire("44qT7");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $8ZSbf = parcelRequire("8ZSbf");
const $a1d7ada73782364f$export$66e04d0aacdb3b2 = ({ email: email, userFullname: userFullname, avatarSrc: avatarSrc, testId: testId })=>{
    const atlassianSettingsLink = (0, $2EqxS.useAtlassianPersonalSettingsLink)(email);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1d7ada73782364f$export$8f1912fff52a55aa, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1d7ada73782364f$export$33e9904f45a9e453, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1d7ada73782364f$export$f7513421c53ce141, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew55A.default), {
        appearance: "circle",
        size: "medium",
        src: avatarSrc
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1d7ada73782364f$export$e0d971bef63c8b8f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a1d7ada73782364f$export$101fbca3a406e1fd, null, userFullname), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("small", null, email)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'manage-account',
            menuItemType: 'account',
            position: 1
        },
        href: atlassianSettingsLink,
        testId: (0, $6cNb0.testIdConcat)(testId, 'manage-account'),
        target: "_blank",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6P0Kj))), {
            LEGACY_size: "small",
            color: "var(--ds-icon-subtle, #626F86)",
            label: ""
        })
    }, formatMessage((0, $8ZSbf.default).manageAccount)))));
};
const $a1d7ada73782364f$export$8f1912fff52a55aa = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $44qT7.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_lcxvglyw",
            __cmplp.className
        ])
    });
});
const $a1d7ada73782364f$export$33e9904f45a9e453 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $a1d7ada73782364f$export$f7513421c53ce141 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $a1d7ada73782364f$export$101fbca3a406e1fd = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz4gktf",
            __cmplp.className
        ])
    });
});
const $a1d7ada73782364f$export$e0d971bef63c8b8f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx29ee3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8ZSbf", function(module, exports) {

$parcel$export(module.exports, "default", () => $818e6cdec46716cd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $818e6cdec46716cd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    manageAccount: {
        "id": "atlassian-navigation.profile.menu.account-details.manage-account",
        "defaultMessage": "Manage account"
    }
});

});


parcelRegister("4WZuY", function(module, exports) {

$parcel$export(module.exports, "ForgeItems", () => $46180a8b75e73408$export$ee772b0fa73d37fd);

var $5uXOq = parcelRequire("5uXOq");

var $7uSIc = parcelRequire("7uSIc");

var $1rTGO = parcelRequire("1rTGO");

var $lLB03 = parcelRequire("lLB03");

var $k2DRb = parcelRequire("k2DRb");

var $l1LNZ = parcelRequire("l1LNZ");

var $h0JHu = parcelRequire("h0JHu");

var $e0AC8 = parcelRequire("e0AC8");

var $6cNb0 = parcelRequire("6cNb0");

var $1C2yb = parcelRequire("1C2yb");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");
const $46180a8b75e73408$var$BaseForgeItems = ({ startPosition: startPosition, testIdPrefix: testIdPrefix, itemAriaLabel: itemAriaLabel })=>{
    const [{ items: forgeStoreItems }] = (0, $7uSIc.useForgePersonalSettingsItems)();
    const shouldTriggerForgeScreenEvent = forgeStoreItems && forgeStoreItems.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (forgeStoreItems || []).map((item, idx)=>{
        const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(item.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
            key: item.id,
            ariaLabel: itemAriaLabel || ''
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'profileNavigationMenuItem',
                menuItemId: item.id,
                menuItemType: 'jira',
                position: startPosition + idx
            },
            href: `${(0, $1C2yb.getAppsPersonalSettingsPath)()}/${appId}/${envId}`,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, `item-addon-${idx}`),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1LNZ.ForgeIcon), {
                url: item.avatarUrl
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h0JHu.ExtensionTitle), {
            extensionEnvType: item.environmentType,
            extensionEnvKey: item.environmentKey,
            extensionName: item.title,
            autoTruncate: true
        })));
    }), shouldTriggerForgeScreenEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
        }
    }));
};
const $46180a8b75e73408$export$ee772b0fa73d37fd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLB03.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($46180a8b75e73408$var$BaseForgeItems, props));

});
parcelRegister("lLB03", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $8f6f5ad08b6537de$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $8f6f5ad08b6537de$export$e1a79e3d472c925a);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");
const $8f6f5ad08b6537de$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $8f6f5ad08b6537de$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE),
        ...props,
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER)
    });

});

parcelRegister("l1LNZ", function(module, exports) {

$parcel$export(module.exports, "ForgeIcon", () => $59ad601e153227ad$export$fe0464db4dc93ab4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $41Nl9 = parcelRequire("41Nl9");

var $k4j3t = parcelRequire("k4j3t");
const $59ad601e153227ad$export$fe0464db4dc93ab4 = ({ url: url })=>{
    return url && String(url).trim().length > 0 ? /*#__PURE__*/ $5uXOq.createElement((0, $k4j3t.IconCustom), {
        shouldChangeFillColor: false,
        url: url
    }) : /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($41Nl9))), {
        color: "var(--ds-icon, #44546F)",
        spacing: "spacious",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        label: ""
    });
};

});

parcelRegister("h0JHu", function(module, exports) {

$parcel$export(module.exports, "ExtensionTitle", () => $8acb929a7e4cf7fc$export$3aa4a75e461c581c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $k2DRb = parcelRequire("k2DRb");

var $fl3Yy = parcelRequire("fl3Yy");
const $8acb929a7e4cf7fc$var$shouldShowEnv = (extensionEnvType)=>[
        (0, $k2DRb.STAGING_ENVIRONMENT),
        (0, $k2DRb.DEVELOPMENT_ENVIRONMENT)
    ].includes(extensionEnvType);
const $8acb929a7e4cf7fc$var$ExtensionTitleText = /*#__PURE__*/ (0, $5uXOq.memo)(({ text: text, autoTruncate: autoTruncate })=>{
    if (!autoTruncate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, text, " ");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $8acb929a7e4cf7fc$var$extensionTitleTextWrapperStyles
    }, text);
});
const $8acb929a7e4cf7fc$export$3aa4a75e461c581c = ({ extensionEnvType: extensionEnvType, extensionEnvKey: extensionEnvKey, extensionName: extensionName, autoTruncate: autoTruncate })=>{
    if (!$8acb929a7e4cf7fc$var$shouldShowEnv(extensionEnvType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, extensionName);
    const Wrapper = autoTruncate ? $8acb929a7e4cf7fc$var$TruncatableExtensionTitleWrapper : $8acb929a7e4cf7fc$var$ExtensionTitleWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8acb929a7e4cf7fc$var$ExtensionTitleText, {
        text: (0, $fl3Yy.nameWithCustomEnvironment)(extensionName, extensionEnvType, extensionEnvKey),
        autoTruncate: !!autoTruncate
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
        environmentType: extensionEnvType
    }));
};
const $8acb929a7e4cf7fc$var$extensionTitleTextWrapperStyles = (0, $2s57o.xcss)({
    paddingRight: 'space.050',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexGrow: 1
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8acb929a7e4cf7fc$var$ExtensionTitleWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1q9y _13aiidpf",
            __cmplp.className
        ])
    });
});
const $8acb929a7e4cf7fc$var$TruncatableExtensionTitleWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1q9y _13aiidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fl3Yy", function(module, exports) {

$parcel$export(module.exports, "EnvironmentLozenge", () => $730173a4987fa3e4$export$278f8e01799d0418);
$parcel$export(module.exports, "nameWithCustomEnvironment", () => $730173a4987fa3e4$export$f9338c21ba7c7334);

var $5uXOq = parcelRequire("5uXOq");

var $eOat1 = parcelRequire("eOat1");

var $k2DRb = parcelRequire("k2DRb");

var $ousew = parcelRequire("ousew");

var $8Je4V = parcelRequire("8Je4V");
const $730173a4987fa3e4$export$50589a87e4fb3dae = (environmentType)=>{
    switch(environmentType){
        case 0, $k2DRb.DEVELOPMENT_ENVIRONMENT:
            return (0, $8Je4V.messages).developmentEnvironmentLozenge;
        case 0, $k2DRb.STAGING_ENVIRONMENT:
            return (0, $8Je4V.messages).stagingEnvironmentLozenge;
        default:
            return null;
    }
};
const $730173a4987fa3e4$export$278f8e01799d0418 = (props)=>{
    const { environmentType: environmentType } = props;
    const labelKey = $730173a4987fa3e4$export$50589a87e4fb3dae(environmentType);
    return labelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        testId: "forge-ui-extension-title.ui.environment-lozenge.lozenge",
        appearance: environmentType === (0, $k2DRb.DEVELOPMENT_ENVIRONMENT) ? 'default' : 'moved'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), labelKey)) : null;
};
const $730173a4987fa3e4$export$f9338c21ba7c7334 = (name, environmentType, environmentKey)=>{
    if (environmentType === (0, $k2DRb.DEVELOPMENT_ENVIRONMENT) && environmentKey && environmentKey !== (0, $k2DRb.DEFAULT_ENVIRONMENT_KEY)) return `${name} - ${environmentKey}`;
    return name;
};

});
parcelRegister("8Je4V", function(module, exports) {

$parcel$export(module.exports, "messages", () => $838ac71f7259b5ef$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $838ac71f7259b5ef$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    developmentEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.development-environment-lozenge",
        "defaultMessage": "DEV"
    },
    stagingEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.staging-environment-lozenge",
        "defaultMessage": "STG"
    }
});

});




parcelRegister("fUv6Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $f86718ba415abca4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $e2wv7 = parcelRequire("e2wv7");

const $f86718ba415abca4$export$31f1740ae531af94 = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("2W6fH")), {
    moduleId: "./src/packages/navigation-apps/theme-switcher-menu/src/index.tsx"
});
const $f86718ba415abca4$var$AsyncThemeSwitcherItem = ({ testId: testId, itemPosition: itemPosition })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "nav-theme-options-list-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2wv7.default), {
            testId: testId,
            itemPosition: itemPosition,
            isDisabled: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f86718ba415abca4$export$31f1740ae531af94, {
        renderTriggerButton: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2wv7.default), {
                testId: testId,
                itemPosition: itemPosition,
                ...props
            })
    }));
var $f86718ba415abca4$export$2e2bcd8739ae039 = $f86718ba415abca4$var$AsyncThemeSwitcherItem;

});
parcelRegister("e2wv7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fbe3dba557d8dae$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cwX8H = parcelRequire("cwX8H");

var $7H980 = parcelRequire("7H980");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $1lFrC = parcelRequire("1lFrC");
const $0fbe3dba557d8dae$var$TriggerButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ testId: testId, itemPosition: itemPosition, ...rest }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        ...rest,
        // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
        ref: ref,
        onClick: (e)=>{
            e.stopPropagation();
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'navigationMenuItem'
            });
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'profileNavigationMenuItem', {
                menuItemId: 'theme',
                menuItemType: 'jira',
                position: itemPosition
            });
        },
        testId: testId,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cwX8H))), {
            spacing: "spacious",
            color: "var(--ds-icon-subtle, #626F86)",
            label: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0fbe3dba557d8dae$var$Text, null, formatMessage((0, $1lFrC.default).text)));
});
var $0fbe3dba557d8dae$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $0fbe3dba557d8dae$var$TriggerButton;
const $0fbe3dba557d8dae$var$Text = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1lFrC", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe8ea74039b76a2c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fe8ea74039b76a2c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    text: {
        "id": "atlassian-navigation.profile.menu.theme-switcher-item.trigger-button.text",
        "defaultMessage": "Theme"
    }
});

});


parcelRegister("2W6fH", function(module, exports) {

let $2235d917235523fc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2235d917235523fc$var$load("isB7h").then(()=>parcelRequire('dFrEV'));

});


parcelRegister("3CMYn", function(module, exports) {

$parcel$export(module.exports, "UpgradeEditionMenuItem", () => $f3e948dade64bc0d$export$30403e009ec5f9cd);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6P0Kj = parcelRequire("6P0Kj");

var $eOat1 = parcelRequire("eOat1");

var $d6a7c = parcelRequire("d6a7c");

var $iMd5l = parcelRequire("iMd5l");

var $cVzoY = parcelRequire("cVzoY");

var $7CMCs = parcelRequire("7CMCs");

var $cSD7y = parcelRequire("cSD7y");

var $aWse0 = parcelRequire("aWse0");

var $lpwtK = parcelRequire("lpwtK");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $bngFq = parcelRequire("bngFq");

var $ldyPw = parcelRequire("ldyPw");

var $9OXo1 = parcelRequire("9OXo1");

var $eZxaN = parcelRequire("eZxaN");

var $cMquZ = parcelRequire("cMquZ");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");


var $5s42E = parcelRequire("5s42E");
const $f3e948dade64bc0d$export$4a94253c58c6e2cb = ({ product: product })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const productEdition = product ? (0, $iMd5l.getProductEdition)(product, tenantContext) : (0, $ldyPw.FREE_EDITION);
    const trialLength = (0, $eZxaN.getTrialLength)(productEdition, (0, $ldyPw.STANDARD_EDITION));
    const freeEditionMenuItemInfo = (0, $5s42E.getFreeEditionMenuItem)((0, $aWse0.useIntlV2), trialLength);
    const [, { mountUpflowModal: mountUpflowModal }] = (0, $cMquZ.useUpflowModal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        eventName: (0, $8f22f2c66c400ef9$export$23de212b4b92e749),
        attributes: {
            currentEdition: productEdition,
            growthFeature: (0, $8f22f2c66c400ef9$export$2c864ccb7debe0d4),
            touchpointId: freeEditionMenuItemInfo.touchpointId,
            flowId: freeEditionMenuItemInfo.flowId,
            computedProduct: product
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6a7c.default), null, freeEditionMenuItemInfo.heading), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'persistentUpgradeNavigationMenuItem',
            menuItemId: freeEditionMenuItemInfo.touchpointId,
            menuItemType: 'action',
            position: 0
        },
        onClick: ()=>{
            const analyticEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireUIAnalytics)(analyticEvent, (0, $8f22f2c66c400ef9$export$2b421d13e998fdbb), {
                currentEdition: productEdition,
                growthFeature: (0, $8f22f2c66c400ef9$export$2c864ccb7debe0d4),
                touchpointId: freeEditionMenuItemInfo.touchpointId,
                flowId: freeEditionMenuItemInfo.flowId,
                computedProduct: product
            });
            if (product && freeEditionMenuItemInfo.displayUpflowModal === true) mountUpflowModal({
                targetEdition: (0, $ldyPw.STANDARD_EDITION),
                product: product,
                flow: (0, $8f22f2c66c400ef9$export$195e756c24f2ef95),
                touchpointId: freeEditionMenuItemInfo.touchpointId
            });
        },
        href: (0, $5s42E.getHref)(freeEditionMenuItemInfo, product),
        target: product ? undefined : '_blank',
        iconAfter: product ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6P0Kj))), {
            LEGACY_size: "small",
            color: "var(--ds-icon-subtle, #626F86)",
            label: ""
        })
    }, freeEditionMenuItemInfo.content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f3e948dade64bc0d$var$LozengeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: freeEditionMenuItemInfo.lozengeAppearance,
        isBold: true
    }, freeEditionMenuItemInfo.tagContent, ' '))))));
};
const $f3e948dade64bc0d$var$UpgradeEditionMenuItemOld = ({ setUpgradeEditionMenuShown: setUpgradeEditionMenuShown })=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { data: projectData, loading: projectDataLoading } = (0, $lpwtK.useProject)();
    if (projectDataLoading) return null;
    const { isSiteAdmin: isSiteAdmin } = tenantContext;
    const explicitlyLicensedProducts = (0, $cVzoY.default)(tenantContext);
    const applicationKey = (0, $5s42E.getActivePageApplicationKey)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    projectData?.type, explicitlyLicensedProducts);
    if (!(0, $5s42E.shouldRenderMenuItem)(isSiteAdmin, applicationKey, explicitlyLicensedProducts, tenantContext)) {
        setUpgradeEditionMenuShown(false);
        return null;
    } // Add separator bar in the menu
    setUpgradeEditionMenuShown(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $8f22f2c66c400ef9$export$5fa54bc771a7eb8f),
        packageName: (0, $8f22f2c66c400ef9$export$b8b9d90f9e5bd72b),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f3e948dade64bc0d$export$4a94253c58c6e2cb, {
        product: applicationKey
    }));
};
const $f3e948dade64bc0d$var$UpgradeEditionMenuItemNew = ({ setUpgradeEditionMenuShown: setUpgradeEditionMenuShown })=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { data: projectData, loading: projectDataLoading } = (0, $lpwtK.useProject)();
    const { isSiteAdmin: isSiteAdmin } = tenantContext;
    const explicitlyLicensedProducts = (0, $cVzoY.default)(tenantContext);
    const applicationKey = (0, $5s42E.getActivePageApplicationKey)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    projectData?.type, explicitlyLicensedProducts);
    const shouldRender = (0, $5s42E.shouldRenderMenuItem)(isSiteAdmin, applicationKey, explicitlyLicensedProducts, tenantContext);
    (0, $5uXOq.useEffect)(()=>{
        if (projectDataLoading) return;
         // Add separator bar in the menu if the menu item should be rendered
        setUpgradeEditionMenuShown(shouldRender);
    }, [
        projectDataLoading,
        setUpgradeEditionMenuShown,
        shouldRender
    ]);
    if (projectDataLoading) return null;
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $8f22f2c66c400ef9$export$5fa54bc771a7eb8f),
        packageName: (0, $8f22f2c66c400ef9$export$b8b9d90f9e5bd72b),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f3e948dade64bc0d$export$4a94253c58c6e2cb, {
        product: applicationKey
    }));
};
const $f3e948dade64bc0d$export$30403e009ec5f9cd = (0, $cSD7y.componentWithFG)('jira-concurrent-update-while-rendering', $f3e948dade64bc0d$var$UpgradeEditionMenuItemNew, $f3e948dade64bc0d$var$UpgradeEditionMenuItemOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f3e948dade64bc0d$var$LozengeContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iMd5l", function(module, exports) {

$parcel$export(module.exports, "getProductEdition", () => $658df12da4e62335$export$53e066a63a960439);

const $658df12da4e62335$export$53e066a63a960439 = (product, tenantContext)=>{
    if (product === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)) return tenantContext.appEditions.software;
    if (product === (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61)) return tenantContext.appEditions.serviceDesk;
    return tenantContext.appEditions.core;
};

});

parcelRegister("eZxaN", function(module, exports) {

$parcel$export(module.exports, "getTrialLength", () => $5e237061bb3a578d$export$23d271f9e8cb9c4);

var $ldyPw = parcelRequire("ldyPw");

const $5e237061bb3a578d$export$23d271f9e8cb9c4 = (currentEdition, targetEdition)=>{
    if (currentEdition === (0, $ldyPw.FREE_EDITION) && targetEdition === (0, $ldyPw.STANDARD_EDITION)) return 0, $554094dc1f31a42a$export$b7a3952d12e24333;
    return 0, $554094dc1f31a42a$export$940ef4a039f45970;
};

});
const $554094dc1f31a42a$export$b7a3952d12e24333 = 14;
const $554094dc1f31a42a$export$940ef4a039f45970 = 30;


const $8f22f2c66c400ef9$export$195e756c24f2ef95 = 'persistent-upgrade';
const $8f22f2c66c400ef9$export$2c864ccb7debe0d4 = 'persistentUpgrade';
const $8f22f2c66c400ef9$export$b8b9d90f9e5bd72b = 'persistentUpgrade';
const $8f22f2c66c400ef9$export$5fa54bc771a7eb8f = 'persistentUpgradeMenu';
const $8f22f2c66c400ef9$export$2b421d13e998fdbb = 'persistentUpgradeMenu clicked';
const $8f22f2c66c400ef9$export$23de212b4b92e749 = 'persistentUpgradeMenu viewed';

parcelRegister("5s42E", function(module, exports) {

$parcel$export(module.exports, "shouldRenderMenuItem", () => $19aa5f523a249503$export$6335c904eace2f3);
$parcel$export(module.exports, "getFreeEditionMenuItem", () => $19aa5f523a249503$export$cce6104d08ee5a15);
$parcel$export(module.exports, "getActivePageApplicationKey", () => $19aa5f523a249503$export$44df08af6d5522d3);
$parcel$export(module.exports, "getHref", () => $19aa5f523a249503$export$81842c1ae19d378b);

var $2vSU6 = parcelRequire("2vSU6");

var $iMd5l = parcelRequire("iMd5l");


var $ldyPw = parcelRequire("ldyPw");

var $if9zJ = parcelRequire("if9zJ");
const $19aa5f523a249503$var$isFreeEdition = (product, tenantContext)=>{
    const productEdition = (0, $iMd5l.getProductEdition)(product, tenantContext);
    return productEdition === (0, $ldyPw.FREE_EDITION);
};
const $19aa5f523a249503$var$productIsJSMOrJSW = (product)=>product === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d) || product === (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61);
const $19aa5f523a249503$var$hasFreeJSMOrJSW = (explicitlyLicensedProducts, tenantContext)=>explicitlyLicensedProducts.some((product)=>$19aa5f523a249503$var$productIsJSMOrJSW(product) && $19aa5f523a249503$var$isFreeEdition(product, tenantContext));
const $19aa5f523a249503$export$6335c904eace2f3 = (isSiteAdmin, product, explicitlyLicensedProducts, tenantContext)=>{
    if (!isSiteAdmin) return false;
    if (!product) // If we're on a product-agnostic page (e.g "Your Work") we can still render the menu item
    // as long as there is a free JSM or JSW. The menu item will link to the "Manage Subscriptions" page.
    return $19aa5f523a249503$var$hasFreeJSMOrJSW(explicitlyLicensedProducts, tenantContext);
    // If we're in JSM or JSW Free, render the menu item.
    if (product && $19aa5f523a249503$var$productIsJSMOrJSW(product)) return $19aa5f523a249503$var$isFreeEdition(product, tenantContext);
    return false;
};
const $19aa5f523a249503$export$cce6104d08ee5a15 = (intl, trialLength)=>({
        heading: intl().formatMessage((0, $if9zJ.default).upgrade),
        content: intl().formatMessage((0, $if9zJ.default).tryStandardPlan),
        tagContent: intl().formatMessage((0, $if9zJ.default).trialPeriod, {
            trialLength: trialLength
        }),
        lozengeAppearance: 'inprogress',
        touchpointId: 'preTrialMenu',
        flowId: 'upgradeFlow',
        displayUpflowModal: true
    });
const $19aa5f523a249503$export$636823a5af1468e4 = (subProduct, explicitlyLicensedProducts)=>{
    if (subProduct === 'software') return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
    if (subProduct === 'serviceDesk') return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
    if (subProduct === 'core') return 0, $c06e1abca7c13910$export$db515c8cec1e6f79;
    // If subProduct is null, we may be on a product-agnostic page e.g. "Your Work"
    // In there is only one licensed product, we can infer what the user is using
    if (explicitlyLicensedProducts.length === 1) return explicitlyLicensedProducts[0];
    return null;
};
const $19aa5f523a249503$export$b6487772e5a4e151 = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
        case 0, $2vSU6.CORE_PROJECT:
            return 0, $c06e1abca7c13910$export$db515c8cec1e6f79;
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return 0, $c06e1abca7c13910$export$202f50ee62667e32;
        default:
            return null;
    }
};
const $19aa5f523a249503$export$44df08af6d5522d3 = (projectType, explicitlyLicensedProducts)=>{
    const applicationKey = $19aa5f523a249503$export$b6487772e5a4e151(projectType);
    if (applicationKey !== null) return applicationKey;
    // If applicationKey is null, we may be on a product-agnostic page e.g. "Your Work"
    // In there is only one licensed product, we can infer what the user is using
    if (explicitlyLicensedProducts.length === 1) return explicitlyLicensedProducts[0];
    return null;
};
const $19aa5f523a249503$export$81842c1ae19d378b = (freeEditionMenuItemInfo, product)=>{
    if (!product) return '/admin/billing/applications';
    return freeEditionMenuItemInfo.href ? freeEditionMenuItemInfo.href(freeEditionMenuItemInfo.touchpointId) : '';
};

});
parcelRegister("if9zJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4771b447ad228e16$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4771b447ad228e16$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    upgrade: {
        "id": "atlassian-navigation.profile.menu.upgrade-edition.upgrade",
        "defaultMessage": "Upgrade"
    },
    tryStandardPlan: {
        "id": "atlassian-navigation.profile.menu.upgrade-edition.try-standard-plan",
        "defaultMessage": "Try the Standard plan"
    },
    trialPeriod: {
        "id": "atlassian-navigation.profile.menu.upgrade-edition.trial-period",
        "defaultMessage": "free {trialLength}-day trial"
    }
});

});




parcelRegister("ixpv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2baac40d089a40ee$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2baac40d089a40ee$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "atlassian-navigation.profile.tooltip",
        "defaultMessage": "Your profile and settings"
    }
});

});


parcelRegister("ag3PC", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $f891c4e4f71955d4$export$c72f6eaae7b9adff);

var $5uXOq = parcelRequire("5uXOq");

var $22Gxp = parcelRequire("22Gxp");

var $70rf1 = parcelRequire("70rf1");

var $kaHBi = parcelRequire("kaHBi");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");

var $jgJNO = parcelRequire("jgJNO");

var $cZpsT = parcelRequire("cZpsT");

var $ctLcP = parcelRequire("ctLcP");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $cSD7y = parcelRequire("cSD7y");

var $Mp6qH = parcelRequire("Mp6qH");

var $amOJR = parcelRequire("amOJR");

var $iPj86 = parcelRequire("iPj86");

var $ag3sS = parcelRequire("ag3sS");

var $9TMfX = parcelRequire("9TMfX");

var $6WLja = parcelRequire("6WLja");

var $4uXxK = parcelRequire("4uXxK");

var $hrU50 = parcelRequire("hrU50");

var $3Ug2v = parcelRequire("3Ug2v");

var $asDBE = parcelRequire("asDBE");
function $f891c4e4f71955d4$export$c72f6eaae7b9adff() {
    const SettingsMenu = (0, $cSD7y.componentWithFG)('blu-3339-nav4-topnav-settings-entrypoint', $f891c4e4f71955d4$var$SettingsContainer, $f891c4e4f71955d4$var$SettingsInner);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).SETTINGS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SettingsMenu, null));
}
function $f891c4e4f71955d4$var$SettingsContainer() {
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    if (isAnonymous) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f891c4e4f71955d4$var$SettingsInner, null);
}
function $f891c4e4f71955d4$var$SettingsInner() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // remove when cleaning up fg: blu-3339-nav4-topnav-settings-entrypoint
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const [isOpen, { toggle: toggleMenu, off: closeMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).SETTINGS);
    const triggerAnalytics = (0, $iPj86.useNavigationItemAnalytics)({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).SETTINGS
    });
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).SETTINGS,
        analyticsSource: 'atlassian-navigation'
    });
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (!(0, $3HwlS.getWillShowNav4)()) onStart();
        toggleMenu();
        triggerAnalytics({
            shownCommandPalettePrompt: true
        });
    }, [
        onStart,
        toggleMenu,
        triggerAnalytics
    ]);
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'settings');
    // replace this with useId from react 18 when stable
    const id = (0, $22Gxp.useUID)();
    const titleId = `top-navigation-settings-header-${id}-title`;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $3Ug2v.settingsMenuEntryPoint), {});
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const Trigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-trigger'),
            "data-vc": `atlassian-navigation-settings${false ? '-ssr' : ''}`
        }, (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctLcP.Settings), {
            ...triggerProps,
            ref: (element)=>{
                if ((0, $4R6GH.fg)('blu-3339-nav4-topnav-settings-entrypoint')) triggerRef(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref?.(element);
            },
            onClick: onClick,
            isSelected: isOpen,
            interactionName: "nav4-topNav-settings",
            label: formatMessage((0, $asDBE.default).settings)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $amOJR.Settings), {
            ...triggerProps,
            ref: (element)=>{
                if ((0, $4R6GH.fg)('blu-3339-nav4-topnav-settings-entrypoint')) triggerRef(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref?.(element);
            },
            onClick: onClick,
            tooltip: formatMessage((0, $asDBE.default).settings),
            isSelected: isOpen
        })), [
        formatMessage,
        isOpen,
        onClick,
        testIdPrefix,
        triggerRef
    ]);
    const content = (0, $5uXOq.useCallback)(()=>(0, $4R6GH.fg)('blu-3339-nav4-topnav-settings-entrypoint') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            id: "nav4-topNav-settings",
            entryPointReferenceSubject: entryPointReferenceSubject,
            packageName: (0, $Mp6qH.PACKAGE_NAME),
            errorFallback: "flag",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ag3sS.MenuLayout), {
                isWide: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
                isScrollable: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9TMfX.MenuSkeletonContent), {
                testIdPrefix: testIdPrefix
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
                hasSeparator: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6WLja.MenuSkeletonFooter), {
                testIdPrefix: testIdPrefix
            }))),
            runtimeProps: {
                testIdPrefix: testIdPrefix,
                titleId: titleId
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hrU50.Menu), {
            testIdPrefix: testIdPrefix,
            titleId: titleId
        }), [
        entryPointReferenceSubject,
        testIdPrefix,
        titleId
    ]);
    // remove when cleaning up fg: blu-3339-nav4-topnav-settings-entrypoint
    if (isAnonymous) return null;
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Trigger, {
        "aria-expanded": false,
        "aria-haspopup": true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        titleId: titleId,
        isOpen: isOpen,
        content: content,
        onClose: closeMenu,
        placement: "bottom-end",
        messageId: "atlassian-navigation.ui.settings.popup",
        messageType: "transactional",
        trigger: Trigger,
        label: formatMessage((0, $asDBE.default).settings),
        shouldRenderToParent: true
    });
}

});
parcelRegister("amOJR", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $70f9abb464fd04b1$export$c72f6eaae7b9adff);

var $5uXOq = parcelRequire("5uXOq");

var $lMdw2 = parcelRequire("lMdw2");

var $hpqc1 = parcelRequire("hpqc1");

var $3HwlS = parcelRequire("3HwlS");
const $70f9abb464fd04b1$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    if (false) {
        if ((0, $3HwlS.getWillShowNav4)()) // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hpqc1.Nav4SkeletonSettingsButton), {
            label: props.tooltip
        });
        // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hpqc1.SkeletonSettingsButton), {
            label: props.tooltip
        });
    }
    const buttonProps = {
        ...props,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lMdw2.Settings), buttonProps);
});

});

parcelRegister("9TMfX", function(module, exports) {

$parcel$export(module.exports, "MenuSkeletonContent", () => $4a37f7ab6d486120$export$8db7a6d33c26b25f);

var $5uXOq = parcelRequire("5uXOq");

var $Wkf8o = parcelRequire("Wkf8o");
var $eCE62 = parcelRequire("eCE62");

var $6cNb0 = parcelRequire("6cNb0");
const $4a37f7ab6d486120$export$8db7a6d33c26b25f = ({ testIdPrefix: testIdPrefix })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'skeleton')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Wkf8o.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true,
        width: "62.5%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true,
        width: "50%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true,
        width: "62.5%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true,
        width: "50%"
    }));

});

parcelRegister("6WLja", function(module, exports) {

$parcel$export(module.exports, "MenuSkeletonFooter", () => $a62f60b9f9c94621$export$efa6bae06cf20a1);

var $5uXOq = parcelRequire("5uXOq");

var $eCE62 = parcelRequire("eCE62");

var $6cNb0 = parcelRequire("6cNb0");
const $a62f60b9f9c94621$export$efa6bae06cf20a1 = ({ testIdPrefix: testIdPrefix, numItems: numItems = 2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'skeleton')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        width: "50%"
    }), numItems >= 2 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        width: "50%"
    }));

});

parcelRegister("hrU50", function(module, exports) {

$parcel$export(module.exports, "MenuWithEntryPoint", () => $c4588c969d854f97$export$677b98f370fe145);
$parcel$export(module.exports, "Menu", () => $c4588c969d854f97$export$d9b273488cd8ce6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $70rf1 = parcelRequire("70rf1");
var $Wkf8o = parcelRequire("Wkf8o");
var $eCE62 = parcelRequire("eCE62");

var $5U49F = parcelRequire("5U49F");

var $8J6rn = parcelRequire("8J6rn");

var $7CMCs = parcelRequire("7CMCs");

var $3bQtK = parcelRequire("3bQtK");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");

var $daoB1 = parcelRequire("daoB1");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $l8ruj = parcelRequire("l8ruj");

var $Mp6qH = parcelRequire("Mp6qH");

var $ag3sS = parcelRequire("ag3sS");

var $jNHMi = parcelRequire("jNHMi");

var $e57bL = parcelRequire("e57bL");

var $asDBE = parcelRequire("asDBE");

var $6svfi = parcelRequire("6svfi");

var $b59xm = parcelRequire("b59xm");
function $c4588c969d854f97$export$677b98f370fe145({ props: { testIdPrefix: testIdPrefix, titleId: titleId } }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c4588c969d854f97$export$d9b273488cd8ce6f, {
        testIdPrefix: testIdPrefix,
        titleId: titleId
    });
}
const $c4588c969d854f97$export$d9b273488cd8ce6f = ({ testIdPrefix: testIdPrefix, titleId: titleId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const appPermissions = (0, $daoB1.useApplicationPermissions)();
    const manageUsersPermission = (0, $jNHMi.useManageUsersPermission)();
    const { isOpsAdmin: isOpsAdmin, loading: isOgTenantInfoLoading } = (0, $8J6rn.useOgTenantInfo)();
    const willShowNav4 = (0, $3HwlS.getWillShowNav4)();
    const settingsNavigationItems = (0, $5uXOq.useMemo)(()=>(0, $5U49F.getGlobalSettingsAdminItems)(formatMessage, appPermissions, {
            isAdmin: isAdmin,
            isSiteAdmin: isSiteAdmin,
            manageUsersPermission: manageUsersPermission,
            isOpsAdmin: isOpsAdmin
        }, willShowNav4), [
        formatMessage,
        appPermissions,
        isAdmin,
        isSiteAdmin,
        manageUsersPermission,
        willShowNav4,
        isOpsAdmin
    ]);
    const onSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $5uXOq.useEffect)(()=>{
        if (!willShowNav4) onSuccess();
    }, [
        onSuccess,
        willShowNav4
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-popup');
    const testIdHeader = (0, $6cNb0.testIdConcat)(testId, 'header');
    if (willShowNav4) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "nav4-topNav-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $lmyls.MENU_ID).SETTINGS,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ag3sS.MenuLayout), {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6svfi.Personal), {
        testIdPrefix: testId
    }), settingsNavigationItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e57bL.Home), {
        settingsDrawerItems: settingsNavigationItems,
        testIdPrefix: testId
    }), manageUsersPermission.loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Wkf8o.default), {
        testId: `${testId}--loading-skeleton--heading`,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        testId: `${testId}--loading-skeleton--item`,
        isShimmering: true,
        hasIcon: true
    })) : settingsNavigationItems.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b59xm.Warning), {
        testIdPrefix: testId
    }))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ag3sS.MenuLayout), {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c4588c969d854f97$var$SettingsTitle, {
        ...testIdHeader != null ? {
            'data-testid': testIdHeader
        } : {},
        id: titleId
    }, formatMessage((0, $asDBE.default).settings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6svfi.Personal), {
        testIdPrefix: testId
    }), settingsNavigationItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e57bL.Home), {
        settingsDrawerItems: settingsNavigationItems,
        testIdPrefix: testId
    }), manageUsersPermission.loading || isOgTenantInfoLoading && (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Wkf8o.default), {
        testId: `${testId}--loading-skeleton--heading`,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        testId: `${testId}--loading-skeleton--item`,
        isShimmering: true,
        hasIcon: true
    })) : settingsNavigationItems.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b59xm.Warning), {
        testIdPrefix: testId
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c4588c969d854f97$var$SettingsTitle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8lodh _ca0q1ejb _u5f31ejb _n3tdu2gc _19bvv47k",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5U49F", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $a2085cc62fde1196$export$be58b4326e23250f);
$parcel$export(module.exports, "getGlobalSettingsAdminItems", () => $a2085cc62fde1196$export$d637bf5a394b4534);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $hbr4z = parcelRequire("hbr4z");

var $6YfOV = parcelRequire("6YfOV");

var $3f3VS = parcelRequire("3f3VS");

var $bY4ef = parcelRequire("bY4ef");

var $ef9tG = parcelRequire("ef9tG");

var $41Nl9 = parcelRequire("41Nl9");

var $eoggv = parcelRequire("eoggv");

var $8AbsI = parcelRequire("8AbsI");

var $cQJCJ = parcelRequire("cQJCJ");

var $eGeCO = parcelRequire("eGeCO");

var $i0frO = parcelRequire("i0frO");

var $6P0Kj = parcelRequire("6P0Kj");

var $lggcf = parcelRequire("lggcf");

var $7PkLr = parcelRequire("7PkLr");

var $kAA90 = parcelRequire("kAA90");

var $3kZDu = parcelRequire("3kZDu");

var $4R6GH = parcelRequire("4R6GH");

var $6awYZ = parcelRequire("6awYZ");

var $b4PzF = parcelRequire("b4PzF");

var $2f2jJ = parcelRequire("2f2jJ");

var $8K9T4 = parcelRequire("8K9T4");

var $dzeHJ = parcelRequire("dzeHJ");

var $6lwNs = parcelRequire("6lwNs");

var $3JGmH = parcelRequire("3JGmH");
const $a2085cc62fde1196$var$getApplicationsMenuLink = (appPermissions)=>{
    if (appPermissions.hasSoftwareAccess) return '/jira/settings/products/jira-software-configuration';
    if (appPermissions.hasServiceDeskAccess) return '/jira/settings/products/jira-service-management-configuration';
    return '/plugins/servlet/applinks/listApplicationLinks';
};
const $a2085cc62fde1196$export$f3a5db2467c22913 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i0frO))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$export$3055c15ea575d46c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ef9tG))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$export$43db94b81c32328a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8AbsI))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$export$583f26efcd800ae2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQJCJ))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$export$627b4c7b9568cd5d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($41Nl9))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$export$4464648b9631e67f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, {
        dark: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGeCO))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$export$7b659dc9c22493b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$be58b4326e23250f, {
        dark: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3f3VS))), {
        label: "",
        LEGACY_size: "small",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($eoggv))),
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $a2085cc62fde1196$var$getAdminSectionOld = (formatMessage, appPermissions)=>({
        id: (0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).SYSTEM_ADMIN,
        type: 'Group',
        hasSeparator: true,
        sideHeading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$export$b79014a8ad5d31bf, {
                "aria-label": formatMessage((0, $2f2jJ.isMacOs)() ? (0, $6lwNs.default).jiraSettingsCommandPaletteMacScreenReader : (0, $6lwNs.default).jiraSettingsCommandPaletteOtherScreenReader)
            }, formatMessage((0, $2f2jJ.isMacOs)() ? (0, $6lwNs.default).jiraSettingsCommandPaletteMac : (0, $6lwNs.default).jiraSettingsCommandPaletteOther, {
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
                        as: "strong",
                        size: "small",
                        color: "inherit"
                    }, chunks),
                wrapper: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$var$CommandPaletteShortcutsContainer, null, chunks),
                key: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$var$KeyboardShortcut, null, chunks),
                command: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2085cc62fde1196$var$KeyboardShortcut, {
                        isMeta: true
                    }, chunks)
            })),
        items: [
            {
                goTo: 'root/global-settings/system',
                // sets active navigation 2nd level menu and an active item in navigation menu, via `navApi.setView(goTo)`
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).SYSTEM,
                legacyId: 'admin_system_menu',
                href: '/jira/settings/system/general-configuration',
                text: formatMessage((0, $6lwNs.default).system),
                type: 'Item',
                before: $a2085cc62fde1196$export$f3a5db2467c22913
            },
            {
                goTo: 'root/global-settings/applications',
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).APPLICATIONS,
                legacyId: 'admin_applications_menu',
                href: $a2085cc62fde1196$var$getApplicationsMenuLink(appPermissions),
                text: formatMessage((0, $6lwNs.default).applications),
                type: 'Item',
                before: $a2085cc62fde1196$export$3055c15ea575d46c
            },
            {
                goTo: 'root/global-settings/projects',
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).MANAGE_PROJECTS,
                legacyId: 'admin_project_menu',
                href: '/jira/settings/projects/manage',
                text: formatMessage((0, $6lwNs.default).projects),
                type: 'Item',
                before: $a2085cc62fde1196$export$43db94b81c32328a
            },
            {
                goTo: 'root/global-settings/issues',
                id: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).WORK : (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).ISSUES,
                legacyId: 'admin_issues_menu',
                href: '/jira/settings/issues/issue-types',
                text: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $6lwNs.default).issuesIssueTermRefresh : (0, $6lwNs.default).issues),
                type: 'Item',
                before: $a2085cc62fde1196$export$583f26efcd800ae2
            },
            ...!(0, $b4PzF.isFedRamp)() ? [
                {
                    goTo: 'root/global-settings/addons',
                    id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).PLUGINS,
                    legacyId: 'admin_plugins_menu',
                    href: (0, $6awYZ.getEmceeDiscoverLink)({
                        source: 'side_nav_find_new_addons'
                    }),
                    text: formatMessage((0, $6lwNs.default).addons),
                    type: 'Item',
                    before: $a2085cc62fde1196$export$627b4c7b9568cd5d
                }
            ] : []
        ]
    });
const $a2085cc62fde1196$var$getAdminSectionNew = (formatMessage, appPermissions)=>({
        id: (0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).SYSTEM_ADMIN,
        type: 'Group',
        hasSeparator: true,
        heading: formatMessage((0, $6lwNs.default).jiraAdminSettingsNonFinal),
        items: [
            {
                goTo: 'root/global-settings/system',
                // sets active navigation 2nd level menu and an active item in navigation menu, via `navApi.setView(goTo)`
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).SYSTEM,
                legacyId: 'admin_system_menu',
                href: '/jira/settings/system/general-configuration',
                text: formatMessage((0, $6lwNs.default).system),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kAA90))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $6lwNs.default).systemDescriptionNonFinal)
            },
            {
                goTo: 'root/global-settings/applications',
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).APPLICATIONS,
                legacyId: 'admin_applications_menu',
                href: $a2085cc62fde1196$var$getApplicationsMenuLink(appPermissions),
                text: formatMessage((0, $6lwNs.default).applications),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hbr4z))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $6lwNs.default).productsDescriptionNonFinal)
            },
            {
                goTo: 'root/global-settings/projects',
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).MANAGE_PROJECTS,
                legacyId: 'admin_project_menu',
                href: '/jira/settings/projects/manage',
                text: formatMessage((0, $6lwNs.default).projects),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7PkLr))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $6lwNs.default).projectsDescriptionNonFinal)
            },
            {
                goTo: 'root/global-settings/issues',
                id: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).WORK : (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).ISSUES,
                legacyId: 'admin_issues_menu',
                href: '/jira/settings/issues/issue-types',
                text: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $6lwNs.default).issuesIssueTermRefresh : (0, $6lwNs.default).issues),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bY4ef))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $6lwNs.default).issuesDescriptionNonFinalIssueTermRefresh : (0, $6lwNs.default).issuesDescriptionNonFinal)
            },
            ...!(0, $b4PzF.isFedRamp)() ? [
                {
                    goTo: 'root/global-settings/addons',
                    id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).PLUGINS,
                    legacyId: 'admin_plugins_menu',
                    href: (0, $8K9T4.manageAppsRoute).path,
                    text: formatMessage((0, $6lwNs.default).addons),
                    type: 'Item',
                    before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6YfOV))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    description: formatMessage((0, $6lwNs.default).appsDescriptionNonFinal)
                }
            ] : [],
            {
                id: 'keyboad-shortcut-tip',
                type: 'Content',
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                        as: "li",
                        xcss: $a2085cc62fde1196$var$jiraCommandPalletteTipContainerStyles,
                        "aria-label": formatMessage((0, $2f2jJ.isMacOs)() ? (0, $6lwNs.default).jiraSettingsCommandPaletteMacScreenReader : (0, $6lwNs.default).jiraSettingsCommandPaletteOtherScreenReader)
                    }, formatMessage((0, $2f2jJ.isMacOs)() ? (0, $6lwNs.default).jiraSettingsCommandPaletteMac : (0, $6lwNs.default).jiraSettingsCommandPaletteOther, {
                        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
                                size: "small"
                            }, chunks),
                        wrapper: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                                xcss: $a2085cc62fde1196$var$commandPalleteShortcutStyles
                            }, chunks),
                        key: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
                                alignItems: "center",
                                justifyContent: "center",
                                xcss: $a2085cc62fde1196$var$keyboardShortcutStyles
                            }, chunks),
                        command: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
                                alignItems: "center",
                                justifyContent: "center",
                                xcss: $a2085cc62fde1196$var$keyboardShortcutStyles
                            }, chunks)
                    }))
            }
        ]
    });
const $a2085cc62fde1196$export$8c65af5cbebd63ff = (formatMessage, isSiteAdmin, canManageUsers)=>({
        id: (0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).SITE_ADMIN,
        heading: formatMessage((0, $6lwNs.default).atlassianAdminSettingsNonFinal),
        type: 'Group',
        hasSeparator: false,
        items: [
            ...canManageUsers || isSiteAdmin ? [
                {
                    id: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_IDS).USER_MANAGEMENT,
                    legacyId: 'user_management_section',
                    href: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_HREFS).USER_MANAGEMENT,
                    text: formatMessage((0, $6lwNs.default).userManagement),
                    type: 'Item',
                    before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3kZDu))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lggcf))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    target: '_blank',
                    description: formatMessage((0, $6lwNs.default).userManagementDescriptionNonFinal)
                }
            ] : [],
            ...isSiteAdmin && !(0, $b4PzF.isFedRamp)() ? [
                {
                    id: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_IDS).BILLING,
                    legacyId: 'admin_billing_section',
                    href: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_HREFS).BILLING,
                    text: formatMessage((0, $6lwNs.default).billing),
                    type: 'Item',
                    before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3f3VS))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lggcf))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    target: '_blank',
                    description: formatMessage((0, $6lwNs.default).billingDescriptionNonFinal)
                }
            ] : []
        ]
    });
const $a2085cc62fde1196$export$ed6905715e0eb76 = (formatMessage, isSiteAdmin, canManageUsers)=>({
        id: (0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).SITE_ADMIN,
        type: 'Group',
        hasSeparator: false,
        items: [
            ...canManageUsers || isSiteAdmin ? [
                {
                    id: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_IDS).USER_MANAGEMENT,
                    legacyId: 'user_management_section',
                    href: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_HREFS).USER_MANAGEMENT,
                    text: formatMessage((0, $6lwNs.default).userManagement),
                    type: 'Item',
                    before: $a2085cc62fde1196$export$4464648b9631e67f,
                    // @ts-expect-error - TS2769 - No overload matches this call.
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6P0Kj))), {
                            LEGACY_size: "small"
                        }),
                    target: '_blank'
                }
            ] : [],
            ...isSiteAdmin && !(0, $b4PzF.isFedRamp)() ? [
                {
                    id: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_IDS).BILLING,
                    legacyId: 'admin_billing_section',
                    href: (0, $3JGmH.SITE_ADMIN_SETTINGS_ITEM_HREFS).BILLING,
                    text: formatMessage((0, $6lwNs.default).billing),
                    type: 'Item',
                    before: $a2085cc62fde1196$export$7b659dc9c22493b,
                    // @ts-expect-error - TS2769 - No overload matches this call.
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6P0Kj))), {
                            LEGACY_size: "small"
                        }),
                    target: '_blank'
                }
            ] : []
        ]
    });
const $a2085cc62fde1196$export$b77c692c620409dc = (formatMessage)=>({
        id: (0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).OPS_ADMIN,
        type: 'Group',
        hasSeparator: false,
        items: [
            {
                goTo: 'root/global-settings/applications',
                id: (0, $3JGmH.ADMIN_SETTINGS_ITEM_IDS).APPLICATIONS,
                legacyId: 'admin_applications_menu',
                href: '/jira/settings/products/ops/role-assignment',
                text: formatMessage((0, $6lwNs.default).applications),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hbr4z))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $6lwNs.default).productsDescriptionNonFinal)
            }
        ]
    });
const $a2085cc62fde1196$export$d637bf5a394b4534 = (formatMessage, appPermissions, userRoles, willShowNav4)=>{
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin, manageUsersPermission: manageUsersPermission } = userRoles;
    const result = [];
    if (isAdmin) {
        const getAdminSection = willShowNav4 ? $a2085cc62fde1196$var$getAdminSectionNew : $a2085cc62fde1196$var$getAdminSectionOld;
        result.push(getAdminSection(formatMessage, appPermissions));
    }
    // Adding these items to the end because `manageUsersPermission` may change after the initial
    // render because it is determined by an async API call. It will need to be the responsibility
    // of the consumer to show a loading state if needed.
    if (isSiteAdmin || manageUsersPermission.loading === false && manageUsersPermission.canManageUsers) {
        const getSiteAdminSection = willShowNav4 ? $a2085cc62fde1196$export$8c65af5cbebd63ff : $a2085cc62fde1196$export$ed6905715e0eb76;
        result.push(getSiteAdminSection(formatMessage, userRoles.isSiteAdmin, manageUsersPermission.canManageUsers));
    }
    if (!willShowNav4 && !userRoles.isAdmin && userRoles.isOpsAdmin && (0, $4R6GH.fg)('operations-tenant-info-endpoint-update')) result.push($a2085cc62fde1196$export$b77c692c620409dc(formatMessage));
    return result;
};
const $a2085cc62fde1196$export$be58b4326e23250f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { dark: dark, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1e0c116y _4cvr1h6o _1bah1h6o _4t3i1tcg _1bsb1tcg",
            __cmplp.dark ? "_11q7cdhy" : "_11q7b29m",
            __cmplp.className
        ])
    });
});
const $a2085cc62fde1196$var$CommandPaletteShortcutsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpv77o _1e0c116y",
            __cmplp.className
        ])
    });
});
const $a2085cc62fde1196$var$KeyboardShortcut = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $dzeHJ.FilledLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _1bsb1wug _1ul9dlk8 _4t3idlk8 _16jlidpf _vwz4wk7l _y3gn1h6o _ca0qidpf _u5f3v77o _n3tdidpf _19bvv77o _vchhusvi _1p1dglyw",
            __cmplp.isMeta ? "_1wyb1bt6" : "_1wybc4v4",
            __cmplp.className
        ])
    });
});
const $a2085cc62fde1196$export$b79014a8ad5d31bf = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _k48pi7a9 _syaz1dyx _1p1dglyw",
            __cmplp.className
        ])
    });
});
const $a2085cc62fde1196$var$commandPalleteShortcutStyles = (0, $2s57o.xcss)({
    display: 'inline-flex',
    gap: 'space.025'
});
const $a2085cc62fde1196$var$jiraCommandPalletteTipContainerStyles = (0, $2s57o.xcss)({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginInlineStart: 'space.200',
    marginBlock: 'space.200',
    color: 'color.text.subtle',
    listStyleType: 'none'
});
const $a2085cc62fde1196$var$keyboardShortcutStyles = (0, $2s57o.xcss)({
    minWidth: '14px',
    height: '14px',
    backgroundColor: 'color.background.accent.blue.subtlest',
    color: 'color.text.subtle',
    padding: 'space.025',
    borderRadius: 'border.radius',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

});
parcelRegister("8K9T4", function(module, exports) {

$parcel$export(module.exports, "manageAppsRoute", () => $796c64c2599268cb$export$d5409be3b4016aab);
const $796c64c2599268cb$export$d5409be3b4016aab = {
    name: 'global-settings-addons-upm',
    path: '/plugins/servlet/upm'
};

});

parcelRegister("dzeHJ", function(module, exports) {

$parcel$export(module.exports, "OutlinedLozenge", () => $0f9445e21ac061f1$export$224f9ad7f31e0de6);
$parcel$export(module.exports, "FilledLozenge", () => $0f9445e21ac061f1$export$586a428fe10f5ae0);
$parcel$export(module.exports, "SearchLozenge", () => $0f9445e21ac061f1$export$2ccc7861eeb7b337);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $0f9445e21ac061f1$var$Lozenge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _11c8dcr7 _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3igktf _1bsbgktf _vwz41crf _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $0f9445e21ac061f1$export$224f9ad7f31e0de6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81u0j _19it3ju0 _k48p1pd9 _1p1dangw _bfhk1j9a _syaz131l _vchhusvi",
            __cmplp.className
        ])
    });
});
const $0f9445e21ac061f1$export$586a428fe10f5ae0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81u0j _kqswh2mm _1p1dangw _1pbykb7n _1s6krwve _rfx31l7b _1cs8stnw _1kt9b3bt _154psxj9 _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
            __cmplp.className
        ])
    });
});
const $0f9445e21ac061f1$export$2ccc7861eeb7b337 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1bsb1ris _bfhkm7j4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6lwNs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f568e348dc45627$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9f568e348dc45627$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    settings: {
        "id": "navigation-next.navigation-views.root.common.settings",
        "defaultMessage": "Jira settings"
    },
    system: {
        "id": "navigation-next.navigation-views.root.global-settings.home.system",
        "defaultMessage": "System"
    },
    applications: {
        "id": "navigation-next.navigation-views.root.global-settings.home.applications",
        "defaultMessage": "Products"
    },
    projects: {
        "id": "navigation-next.navigation-views.root.global-settings.home.projects",
        "defaultMessage": "Projects"
    },
    issues: {
        "id": "navigation-next.navigation-views.root.global-settings.home.issues",
        "defaultMessage": "Issues"
    },
    addons: {
        "id": "navigation-next.navigation-views.root.global-settings.home.addons",
        "defaultMessage": "Apps"
    },
    recommendations: {
        "id": "navigation-next.navigation-views.root.global-settings.home.recommendations",
        "defaultMessage": "Recommendations"
    },
    userManagement: {
        "id": "navigation-next.navigation-views.root.global-settings.home.user-management",
        "defaultMessage": "User management"
    },
    billing: {
        "id": "navigation-next.navigation-views.root.global-settings.home.billing",
        "defaultMessage": "Billing"
    },
    discoverApplications: {
        "id": "navigation-next.navigation-views.root.global-settings.home.discover-applications",
        "defaultMessage": "Discover applications"
    },
    jiraSettingsCommandPaletteMac: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-mac",
        "defaultMessage": "<strong>Tip:</strong> Try <wrapper><command>\u2318</command><key>K</key></wrapper> to search Jira settings"
    },
    jiraSettingsCommandPaletteOther: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-other",
        "defaultMessage": "<strong>Tip:</strong> Try <wrapper><key>Ctrl</key><key>K</key></wrapper> to search Jira settings"
    },
    jiraSettingsCommandPaletteMacScreenReader: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-mac-screen-reader",
        "defaultMessage": "Tip: Try command K to search Jira settings"
    },
    jiraSettingsCommandPaletteOtherScreenReader: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-other-screen-reader",
        "defaultMessage": "Tip: Try control K to search Jira settings"
    },
    'site-admin': {
        "id": "navigation-apps.settings-drawer.section.site-admin",
        "defaultMessage": "Atlassian admin"
    },
    'system-admin': {
        "id": "navigation-apps.settings-drawer.section.system-admin",
        "defaultMessage": "Jira settings"
    },
    'ops-admin': {
        "id": "navigation-apps.settings-drawer.section.ops-admin",
        "defaultMessage": "Jira settings"
    },
    'trusted-user': {
        "id": "navigation-apps.settings-drawer.section.trusted-user",
        "defaultMessage": "Atlassian admin"
    },
    'personal-settings': {
        "id": "navigation-apps.settings-drawer.section.personal-settings",
        "defaultMessage": "Personal settings"
    },
    'admin-system-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-system-menu",
        "defaultMessage": "Manage your general configuration, global permissions, look and feel and more."
    },
    'admin-applications-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-applications-menu",
        "defaultMessage": "Manage your Jira products' settings and integrations."
    },
    'admin-manage-project-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-manage-project-menu",
        "defaultMessage": "Manage your project settings, categories, and more."
    },
    'admin-issues-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-issues-menu",
        "defaultMessage": "Configure your issue types, workflows, screens, custom fields and more."
    },
    'admin-issues-menu-issue-term-refresh': {
        "id": "navigation-apps.settings-drawer.section.item.admin-issues-menu-issue-term-refresh",
        "defaultMessage": "Configure your work types, workflows, screens, custom fields and more."
    },
    'admin-plugins-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-plugins-menu",
        "defaultMessage": "Add and manage Jira Marketplace apps."
    },
    'user-management-section': {
        "id": "navigation-apps.settings-drawer.section.item.user-management-section",
        "defaultMessage": "Add users, groups, and manage access requests."
    },
    'admin-billing-section': {
        "id": "navigation-apps.settings-drawer.section.item.admin-billing-section",
        "defaultMessage": "Update your billing details, manage your subscriptions and more."
    },
    'trusted-admin-user-management-section': {
        "id": "navigation-apps.settings-drawer.section.item.trusted-admin-user-management-section",
        "defaultMessage": "Invite users to your site."
    },
    'discover-applications-section': {
        "id": "navigation-apps.settings-drawer.section.item.discover-applications-section",
        "defaultMessage": "Try more Atlassian products."
    },
    // NAV4 Messages
    personalJiraSettingsNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.personal-jira-settings-non-final",
        "defaultMessage": "Personal Jira settings"
    },
    jiraAdminSettingsNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.jira-admin-settings-non-final",
        "defaultMessage": "Jira admin settings"
    },
    systemDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.system-description-non-final",
        "defaultMessage": "Manage general configuration, security, automation, user interface, and more"
    },
    productsDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.products-description-non-final",
        "defaultMessage": "Manage Jira products' access, settings, and integrations"
    },
    projectsDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.projects-description-non-final",
        "defaultMessage": "Manage project settings, categories, and more"
    },
    issuesDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.issues-description-non-final",
        "defaultMessage": "Configure issue types, workflows, screens, fields, and more"
    },
    appsDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.apps-description-non-final",
        "defaultMessage": "Add and manage Jira Marketplace apps and integrations"
    },
    atlassianAdminSettingsNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.atlassian-admin-settings-non-final",
        "defaultMessage": "Atlassian admin settings"
    },
    userManagementDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.user-management-description-non-final",
        "defaultMessage": "Manage users, groups, and access requests"
    },
    billingDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.billing-description-non-final",
        "defaultMessage": "Update your billing details, manage subscriptions, and more"
    },
    issuesIssueTermRefresh: {
        "id": "navigation-next.navigation-views.root.global-settings.home.issues-issue-term-refresh",
        "defaultMessage": "Work items"
    },
    issuesDescriptionNonFinalIssueTermRefresh: {
        "id": "atlassian-navigation-nav4.common.settings-content.issues-description-non-final-issue-term-refresh",
        "defaultMessage": "Configure work types, workflows, screens, fields, and more"
    }
});

});

parcelRegister("3JGmH", function(module, exports) {

$parcel$export(module.exports, "JIRA_SETTINGS_SECTION_IDS", () => $421ed2d9886b9bc8$export$7266225366740ba0);
$parcel$export(module.exports, "ADMIN_SETTINGS_ITEM_IDS", () => $421ed2d9886b9bc8$export$4718c8ac53a477e1);
$parcel$export(module.exports, "SITE_ADMIN_SETTINGS_ITEM_IDS", () => $421ed2d9886b9bc8$export$b23679adb37958a8);
$parcel$export(module.exports, "SITE_ADMIN_SETTINGS_ITEM_HREFS", () => $421ed2d9886b9bc8$export$9cc74e3c0b8831f9);
const $421ed2d9886b9bc8$export$7266225366740ba0 = {
    SETTINGS_TITLE: 'settings-title',
    SITE_ADMIN: 'site-admin',
    SYSTEM_ADMIN: 'system-admin',
    OPS_ADMIN: 'ops-admin',
    TRUSTED_USER: 'trusted-user',
    PERSONAL: 'personal-settings'
};
const $421ed2d9886b9bc8$export$4718c8ac53a477e1 = {
    SYSTEM: 'admin-system-menu',
    APPLICATIONS: 'admin-applications-menu',
    ISSUES: 'admin-issues-menu',
    WORK: 'admin-issues-menu-issue-term-refresh',
    PLUGINS: 'admin-plugins-menu',
    RECOMMENDATIONS: 'admin-recommendations',
    MANAGE_PROJECTS: 'admin-manage-project-menu'
};
const $421ed2d9886b9bc8$export$b23679adb37958a8 = {
    USER_MANAGEMENT: 'user-management-section',
    BILLING: 'admin-billing-section'
};
const $421ed2d9886b9bc8$export$9cc74e3c0b8831f9 = {
    USER_MANAGEMENT: '/admin/users?referrerName=JIRA',
    BILLING: '/admin/billing-preview?referrerName=JIRA'
};

});


parcelRegister("jNHMi", function(module, exports) {

$parcel$export(module.exports, "useManageUsersPermission", () => $723fd3490632416b$export$d156f64dc61f3ce9);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $14XJw = parcelRequire("14XJw");

var $90yGq = parcelRequire("90yGq");

var $cNd4s = parcelRequire("cNd4s");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $723fd3490632416b$var$initialState = {
    loading: true,
    canManageUsers: undefined
};
const $723fd3490632416b$var$Store = (0, $iXqE5.createStore)({
    initialState: $723fd3490632416b$var$initialState,
    actions: {
        fetch: ({ orgId: orgId, accountId: accountId, isSiteAdmin: isSiteAdmin })=>async ({ setState: setState, getState: getState })=>{
                if (getState().canManageUsers !== undefined) // Shortcut - Don't fetch again if we already have the data
                return;
                if (accountId == null || orgId == null) {
                    // Shortcut - Anonymous users cannot manage users, and orgId is required
                    setState({
                        loading: false,
                        canManageUsers: false
                    });
                    return;
                }
                if (isSiteAdmin) {
                    // Shortcut - Site admins can manage users
                    setState({
                        loading: false,
                        canManageUsers: true
                    });
                    return;
                }
                setState({
                    loading: true
                });
                try {
                    const { permitted: permitted } = await (0, $eusud.performPostRequest)('/gateway/api/permissions/permitted', {
                        body: JSON.stringify({
                            resourceId: `ari:cloud:platform::org/${orgId}`,
                            principalId: `ari:cloud:identity::user/${accountId}`,
                            permissionId: 'manage-users'
                        })
                    });
                    setState({
                        loading: false,
                        canManageUsers: permitted
                    });
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    // Fail safe - if we can't fetch the data, assume the user can't manage users
                    setState({
                        loading: false,
                        canManageUsers: false
                    });
                    (0, $jcw0u.default)({
                        meta: {
                            id: 'fetchManageUsersPermission',
                            packageName: 'jiraAtlassianNavigation',
                            teamName: 'navigation'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            }
    },
    name: 'ManageUsersPermissionInternal'
});
const $723fd3490632416b$var$useManageUsersPermissionInternal = (0, $3sQ5x.createHook)($723fd3490632416b$var$Store);
const $723fd3490632416b$export$d156f64dc61f3ce9 = ()=>{
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const accountId = (0, $90yGq.useAccountId)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const [state, { fetch: fetch }] = $723fd3490632416b$var$useManageUsersPermissionInternal();
    (0, $5uXOq.useEffect)(()=>{
        fetch({
            accountId: accountId,
            orgId: orgId,
            isSiteAdmin: isSiteAdmin
        });
    }, [
        fetch,
        accountId,
        orgId,
        isSiteAdmin
    ]);
    return state;
};

});

parcelRegister("e57bL", function(module, exports) {

$parcel$export(module.exports, "Home", () => $f8508cd3b3bbf491$export$b94310965bed44e6);

var $5uXOq = parcelRequire("5uXOq");

var $70rf1 = parcelRequire("70rf1");

var $6lwNs = parcelRequire("6lwNs");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $4drrb = parcelRequire("4drrb");
const $f8508cd3b3bbf491$export$b94310965bed44e6 = ({ messages: messages = (0, $6lwNs.default), settingsDrawerItems: settingsDrawerItems, testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, settingsDrawerItems.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
            key: group.id,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, group.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4drrb.HomeHeading), {
            group: group,
            messages: messages,
            testIdPrefix: testIdPrefix
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, group.items && group.items.map((item, idx)=>{
            if (item.type === 'Content' && item.content) {
                const content = item.content({
                    update: ()=>Promise.resolve(null),
                    isOpen: false,
                    setInitialFocusRef: ()=>null
                });
                if ((0, $4R6GH.fg)('concurrent-rendering-fix-unique-list-key')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                    key: item.id
                }, content);
                return content;
            }
            if (item.href === null || item.href === undefined) return null;
            if (item.text === null || item.text === undefined) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
                key: item.id,
                ariaLabel: formatMessage(messages[group.id])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
                analytics: {
                    actionSubjectId: 'settingsNavigationMenuItem',
                    menuItemId: item.id,
                    menuItemType: group.id === 'site-admin' ? 'adminSettings' : 'jiraSettings',
                    position: idx
                },
                iconBefore: item.before ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(item.before, null) : null,
                iconAfter: item.after ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(item.after, {
                    isHover: true
                }) : null,
                href: item.href,
                // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type '(("_self" | "_blank" | "_parent" | "_top") & HTMLAttributeAnchorTarget) | undefined'.
                target: item.target,
                testId: (0, $6cNb0.testIdConcat)(testIdPrefix, group.id, `item-${item.id}`),
                description: item.description || ''
            }, item.text || ''));
        })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, settingsDrawerItems.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
            key: group.id,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, group.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4drrb.HomeHeading), {
            group: group,
            messages: messages,
            testIdPrefix: testIdPrefix
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, group.items && group.items.map((item, idx)=>{
            if (item.href === null || item.href === undefined) return null;
            if (item.text === null || item.text === undefined) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
                key: item.id,
                ariaLabel: formatMessage(messages[group.id])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
                analytics: {
                    actionSubjectId: 'settingsNavigationMenuItem',
                    menuItemId: item.id,
                    menuItemType: group.id === 'site-admin' ? 'adminSettings' : 'jiraSettings',
                    position: idx
                },
                iconBefore: item.before ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(item.before, null) : null,
                iconAfter: item.after ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(item.after, {
                    isHover: true
                }) : null,
                href: item.href,
                // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type '(("_self" | "_blank" | "_parent" | "_top") & HTMLAttributeAnchorTarget) | undefined'.
                target: item.target,
                testId: (0, $6cNb0.testIdConcat)(testIdPrefix, group.id, `item-${item.id}`),
                description: messages[item.id] ? formatMessage(messages[item.id]) : undefined
            }, item.text || ''));
        })))));
};

});
parcelRegister("4drrb", function(module, exports) {

$parcel$export(module.exports, "HomeHeading", () => $fd56d3368a0677f4$export$e2344e30272a44c1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $d6a7c = parcelRequire("d6a7c");

var $bWfiu = parcelRequire("bWfiu");

var $0yZbT = parcelRequire("0yZbT");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");

var $4R6GH = parcelRequire("4R6GH");

const $fd56d3368a0677f4$export$e2344e30272a44c1 = ({ group: group, messages: messages, testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const headingMessage = (0, $5uXOq.useMemo)(()=>formatMessage(messages[group.id]), [
        formatMessage,
        group.id,
        messages
    ]);
    if ((0, $3HwlS.getWillShowNav4)()) {
        if ((0, $4R6GH.fg)('blu-4620-settings-popup-headings-a11y-fix')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            paddingInline: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
            as: "h2",
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, group.id, 'heading'),
            size: "xxsmall"
        }, group.heading || ''));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
            "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, group.id, 'heading'),
            className: (0, $bwpsq.default)([
                "_11c8dcr7 _syaz131l _k48p1pd9 _ahbqpxbi _19pku2gc _otyr12x7"
            ])
        }, group.heading || '');
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6a7c.default), {
        headingLevel: 3,
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, group.id, 'heading')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fd56d3368a0677f4$var$HeadingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, headingMessage), !!group.sideHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": (0, $f524727bc2d3810c$export$f707547fc95f31c2)
    }, group.sideHeading())));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fd56d3368a0677f4$var$HeadingContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $fd56d3368a0677f4$var$sectionHeadingStyles = null;

});
const $f524727bc2d3810c$export$f707547fc95f31c2 = 'atlassian-navigation.ui.settings.menu.home.heading.side-heading';



parcelRegister("asDBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e49dd60f5b63059$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6e49dd60f5b63059$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    settings: {
        "id": "atlassian-navigation.settings.menu.settings",
        "defaultMessage": "Settings"
    }
});

});

parcelRegister("6svfi", function(module, exports) {

$parcel$export(module.exports, "Personal", () => $3dfa9666dd9cff1a$export$3965927bf7a81700);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $imLNv = parcelRequire("imLNv");

var $3cwUp = parcelRequire("3cwUp");

var $7mOjd = parcelRequire("7mOjd");

var $jPRPG = parcelRequire("jPRPG");

var $6P0Kj = parcelRequire("6P0Kj");

var $d6a7c = parcelRequire("d6a7c");
var $70rf1 = parcelRequire("70rf1");

var $bWfiu = parcelRequire("bWfiu");

var $0yZbT = parcelRequire("0yZbT");

var $3JGmH = parcelRequire("3JGmH");

var $5U49F = parcelRequire("5U49F");

var $6lwNs = parcelRequire("6lwNs");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $3HwlS = parcelRequire("3HwlS");

var $1C2yb = parcelRequire("1C2yb");

var $cYlk7 = parcelRequire("cYlk7");

var $7ziML = parcelRequire("7ziML");

var $cSD7y = parcelRequire("cSD7y");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $6zdS6 = parcelRequire("6zdS6");
const $3dfa9666dd9cff1a$export$3965927bf7a81700 = ({ testIdPrefix: testIdPrefix })=>{
    const { data: data } = (0, $cYlk7.useCurrentUser)();
    // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
    const email = data.user?.emailAddress;
    const atlassianPersonalSettingsLink = (0, $2EqxS.useAtlassianPersonalSettingsLink)(email);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'personal-settings');
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3dfa9666dd9cff1a$var$HeadingComponent, {
        heading: formatMessage((0, $6lwNs.default).personalJiraSettingsNonFinal),
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $6lwNs.default).personalJiraSettingsNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'settingsNavigationMenuItem',
            menuItemId: 'personal-jira-settings',
            menuItemType: 'personalSettings',
            position: 0
        },
        description: formatMessage((0, $6zdS6.default).generalSettingsDescriptionNonFinal),
        href: (0, $1C2yb.getGeneralPersonalSettingsPath)(),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3cwUp))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        }),
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-personal-jira-settings'),
        to: (0, $7ziML.generalPersonalSettingsRoute)
    }, formatMessage((0, $6zdS6.default).generalSettingsLabelNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $6lwNs.default).personalJiraSettingsNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'settingsNavigationMenuItem',
            menuItemId: 'account-settings',
            menuItemType: 'personalSettings',
            position: 1
        },
        description: formatMessage((0, $6zdS6.default).notificationSettingsDescriptionNonFinal),
        href: "/jira/settings/personal/notifications",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($imLNv))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        }),
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-account-settings')
    }, formatMessage((0, $6zdS6.default).notificationSettingsLabelNonFinal)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6a7c.default), {
        headingLevel: 3,
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $6lwNs.default)[(0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).PERSONAL])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $6lwNs.default)[(0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).PERSONAL])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'settingsNavigationMenuItem',
            menuItemId: 'account-settings',
            menuItemType: 'personalSettings',
            position: 0
        },
        description: formatMessage((0, $6zdS6.default).accountSettingsDescription),
        href: atlassianPersonalSettingsLink,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5U49F.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7mOjd))), {
            size: "small",
            primaryColor: "var(--ds-icon-inverse, #FFFFFF)",
            label: ""
        })),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6P0Kj))), {
            LEGACY_size: "small",
            label: ""
        }),
        target: "_blank",
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-account-settings')
    }, formatMessage((0, $6zdS6.default).accountSettings))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
        ariaLabel: formatMessage((0, $6lwNs.default)[(0, $3JGmH.JIRA_SETTINGS_SECTION_IDS).PERSONAL])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'settingsNavigationMenuItem',
            menuItemId: 'personal-jira-settings',
            menuItemType: 'personalSettings',
            position: 1
        },
        description: formatMessage((0, $6zdS6.default).personalJiraSettingsDescription),
        href: (0, $1C2yb.getGeneralPersonalSettingsPath)(),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5U49F.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jPRPG))), {
            LEGACY_size: "small",
            color: "var(--ds-icon-inverse, #FFFFFF)",
            label: ""
        })),
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-personal-jira-settings'),
        to: (0, $7ziML.generalPersonalSettingsRoute)
    }, formatMessage((0, $6zdS6.default).personalJiraSettings)))));
};
const $3dfa9666dd9cff1a$var$HeadingOld = (props)=>{
    const { heading: heading, testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz131l _k48p1pd9 _ahbqpxbi _19pku2gc _otyr12x7"
        ])
    }, heading);
};
const $3dfa9666dd9cff1a$var$HeadingNew = (props)=>{
    const { heading: heading, testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        paddingInline: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        as: "h2",
        testId: testId,
        size: "xxsmall"
    }, heading));
};
const $3dfa9666dd9cff1a$var$HeadingComponent = (0, $cSD7y.componentWithFG)('blu-4620-settings-popup-headings-a11y-fix', $3dfa9666dd9cff1a$var$HeadingNew, $3dfa9666dd9cff1a$var$HeadingOld);
const $3dfa9666dd9cff1a$var$sectionHeadingStyles = null;

});
parcelRegister("6zdS6", function(module, exports) {

$parcel$export(module.exports, "default", () => $73a9428fb9b2a405$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $73a9428fb9b2a405$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    accountSettings: {
        "id": "atlassian-navigation.settings.menu.personal.account-settings",
        "defaultMessage": "Atlassian account settings"
    },
    accountSettingsDescription: {
        "id": "atlassian-navigation.settings.menu.personal.account-settings-description",
        "defaultMessage": "Manage your language, time zone, and other profile information."
    },
    personalJiraSettings: {
        "id": "atlassian-navigation.settings.menu.personal.personal-jira-settings",
        "defaultMessage": "Personal Jira settings"
    },
    personalJiraSettingsDescription: {
        "id": "atlassian-navigation.settings.menu.personal.personal-jira-settings-description",
        "defaultMessage": "Manage your email notifications and other Jira settings."
    },
    // Nav4 Messages
    generalSettingsLabelNonFinal: {
        "id": "atlassian-navigation.settings.menu.personal.general-settings-label-non-final",
        "defaultMessage": "General settings"
    },
    generalSettingsDescriptionNonFinal: {
        "id": "atlassian-navigation.settings.menu.personal.general-settings-description-non-final",
        "defaultMessage": "Manage language, time zone, and other personal preferences"
    },
    notificationSettingsLabelNonFinal: {
        "id": "atlassian-navigation.settings.menu.personal.notification-settings-label-non-final",
        "defaultMessage": "Notification settings"
    },
    notificationSettingsDescriptionNonFinal: {
        "id": "atlassian-navigation.settings.menu.personal.notification-settings-description-non-final",
        "defaultMessage": "Manage email and in-product notifications from Jira"
    }
});

});


parcelRegister("b59xm", function(module, exports) {

$parcel$export(module.exports, "Warning", () => $d53d46adbad8e7db$export$c688898c4e3580ee);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8zIDr = parcelRequire("8zIDr");

var $70rf1 = parcelRequire("70rf1");

var $ousew = parcelRequire("ousew");

var $aWse0 = parcelRequire("aWse0");

var $6cNb0 = parcelRequire("6cNb0");

var $8Vm26 = parcelRequire("8Vm26");
const $d53d46adbad8e7db$export$c688898c4e3580ee = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'warning');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d53d46adbad8e7db$export$e6dfd72ab29f8598, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $8Vm26.default).noAdminPermissionMessage,
        values: {
            contact: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zIDr.default), {
                href: "/secure/ContactAdministrators!default.jspa"
            }, formatMessage((0, $8Vm26.default).noAdminPermissionMessageContact))
        }
    })));
};
const $d53d46adbad8e7db$export$e6dfd72ab29f8598 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d53d46adbad8e7db$var$Outer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d53d46adbad8e7db$var$Inner, null, children));
// eslint-disable-next-line @atlaskit/design-system/use-primitives, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d53d46adbad8e7db$var$Outer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3v47k _n3tdutpp _19bvv47k",
            __cmplp.className
        ])
    });
});
const $d53d46adbad8e7db$var$Inner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _p12f1kdj _bfhk1tzq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8Vm26", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed016ce81d29e02d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ed016ce81d29e02d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noAdminPermissionMessage: {
        "id": "atlassian-navigation.settings.menu.warning.no-admin-permission-message",
        "defaultMessage": "You do not have access to Jira settings or Atlassian admin, {contact} to grant you access."
    },
    noAdminPermissionMessageContact: {
        "id": "atlassian-navigation.settings.menu.warning.no-admin-permission-message-contact",
        "defaultMessage": "contact your Jira admin"
    }
});

});



parcelRegister("3Ug2v", function(module, exports) {

$parcel$export(module.exports, "settingsMenuEntryPoint", () => $2f15e587ee559e13$export$61e5d93bdc8bc226);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $2f15e587ee559e13$export$61e5d93bdc8bc226 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("hrU50"))).then(({ MenuWithEntryPoint: MenuWithEntryPoint })=>MenuWithEntryPoint), {
        moduleId: "c918b04e"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("2YzXO", function(module, exports) {

$parcel$export(module.exports, "SignIn", () => $ecced68b9b5eee26$export$b64708c6f1b3ed96);

var $5uXOq = parcelRequire("5uXOq");

var $620fp = parcelRequire("620fp");

var $1ASTt = parcelRequire("1ASTt");

var $aWse0 = parcelRequire("aWse0");

var $3HwlS = parcelRequire("3HwlS");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $iPj86 = parcelRequire("iPj86");

var $avqpn = parcelRequire("avqpn");

var $jZF14 = parcelRequire("jZF14");
const $ecced68b9b5eee26$var$SignIn = ({ useDestinationParam: useDestinationParam = (0, $jZF14.useDestinationParam), useIntl: useIntl = (0, $aWse0.useIntlV2), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useIsAnonymous: useIsAnonymous = (0, $cZpsT.useIsAnonymous) })=>{
    const destinationParam = useDestinationParam();
    const isAnonymous = useIsAnonymous();
    const { formatMessage: formatMessage } = useIntl();
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).SIGN_IN
    });
    if (!isAnonymous) return null;
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $620fp.default), {
        href: `/login.jsp?${destinationParam}`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1ASTt))),
        label: formatMessage((0, $avqpn.default).signIn),
        isTooltipDisabled: false,
        appearance: "subtle",
        // @ts-expect-error - TS2769 - No overload matches this call.
        onClick: triggerAnalytics
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $620fp.default), {
        href: `/login.jsp?${destinationParam}`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1ASTt))),
        label: formatMessage((0, $avqpn.default).signIn),
        isTooltipDisabled: false,
        appearance: "subtle",
        // @ts-expect-error - TS2769 - No overload matches this call.
        onClick: triggerAnalytics
    }));
};
const $ecced68b9b5eee26$export$b64708c6f1b3ed96 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).SIGN_IN
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ecced68b9b5eee26$var$SignIn, props));

});
parcelRegister("avqpn", function(module, exports) {

$parcel$export(module.exports, "default", () => $04389e942ceaefeb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $04389e942ceaefeb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    signIn: {
        "id": "atlassian-navigation.sign-in.sign-in",
        "defaultMessage": "Sign in"
    }
});

});

parcelRegister("jZF14", function(module, exports) {

$parcel$export(module.exports, "useDestinationParam", () => $80954d3accb3f049$export$c9c176e0725165cc);

var $j0xEB = parcelRequire("j0xEB");
const $80954d3accb3f049$export$c9c176e0725165cc = ()=>{
    const { href: href = null } = (0, $j0xEB.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return `os_destination=${encodedRedirectUrl}`;
    }
    return '';
};

});


parcelRegister("1mNGt", function(module, exports) {

$parcel$export(module.exports, "Plans", () => $73b77f33bee79d45$export$fa027c23da0a12ea);
$parcel$export(module.exports, "OpenOverflowMenuForPlansSpotlightObserver", () => $73b77f33bee79d45$export$c741bc6980da6a32);

var $5uXOq = parcelRequire("5uXOq");

var $2uT3N = parcelRequire("2uT3N");

var $bcn6L = parcelRequire("bcn6L");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $88fdg = parcelRequire("88fdg");

var $h9iZl = parcelRequire("h9iZl");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $4XiFK = parcelRequire("4XiFK");

var $ebYJ0 = parcelRequire("ebYJ0");

var $7Fvqy = parcelRequire("7Fvqy");

var $edhzr = parcelRequire("edhzr");

var $2eMU9 = parcelRequire("2eMU9");

var $2FrC0 = parcelRequire("2FrC0");
const $73b77f33bee79d45$var$PlansDropdown = ()=>{
    const [isPlansVisible] = (0, $h9iZl.useNavigationPlansVisibility)();
    const [{ hasFetchedOnce: hasFetchedOncePlans }, { loadFavoritePlans: loadFavorite }] = (0, $bcn6L.useFavoritePlans)();
    const [{ hasSuccessOnce: hasSuccessOnce }, { load: load }] = (0, $88fdg.usePlansItems)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isStandardOrFree = (0, $7Fvqy.useIsStandardOrFreeJSW)();
    // Initialise items data
    (0, $5uXOq.useEffect)(()=>{
        !hasSuccessOnce && !isStandardOrFree && isPlansVisible && load();
    }, [
        hasSuccessOnce,
        load,
        isPlansVisible,
        isStandardOrFree
    ]);
    // Keep items data fresh
    const onBeforeMenuOpen = (0, $5uXOq.useCallback)(()=>{
        if (!isStandardOrFree) {
            load();
            if (!hasFetchedOncePlans) loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
        }
    }, // We dont care about hasFetchedOncePlans, it will generate a new call back which then closes the popup
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        load,
        loadFavorite
    ]);
    if (!isPlansVisible) return null;
    /**
   * Cannot do <Popup ... MenuTrigger={MenuTrigger} /> because
   * Popup passes exact common MenuTrigger props which doesn't have DI components
   * that makes Flow complains about props passing to customized MenuTrigger
   * */ // @ts-expect-error - TS2322 - Type '((instance: unknown) => void) | MutableRefObject<unknown> | null' is not assignable to type 'Ref<MenuTriggerProps> | undefined'.
    // FIXME: Navigation should fix that by extracting the forwarded component
    // eslint-disable-next-line react/no-unstable-nested-components
    const FinalMenuTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $edhzr.MenuTrigger), {
            ...props,
            ref: ref
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XiFK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebYJ0.Popup), {
        menuId: (0, $lmyls.MENU_ID).PLANS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PLANS,
        Menu: (0, $2eMU9.default),
        // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to type 'ComponentType<MenuTriggerProps> | undefined'.
        MenuTrigger: FinalMenuTrigger,
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $2FrC0.default).plans)
    }, formatMessage((0, $2FrC0.default).plans)));
};
const $73b77f33bee79d45$export$fa027c23da0a12ea = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).PLANS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73b77f33bee79d45$var$PlansDropdown, null));
const $73b77f33bee79d45$export$c741bc6980da6a32 = ()=>{
    const [isPlansVisible] = (0, $h9iZl.useNavigationPlansVisibility)();
    const [shouldShow] = (0, $cE2Qr.useShouldShowNudge)({
        itemNames: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK)
        ]
    });
    const WRAPPER_UID = 'plans-spotlight-target-wrapper';
    const spotlightVisible = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    !false && document.querySelector(`[data-uid="${WRAPPER_UID}"]`) != null;
    const { openOverflowMenu: openOverflowMenu } = (0, $2uT3N.useOverflowStatus)();
    (0, $5uXOq.useEffect)(()=>{
        isPlansVisible && shouldShow && !spotlightVisible && openOverflowMenu();
    }, [
        isPlansVisible,
        openOverflowMenu,
        shouldShow,
        spotlightVisible
    ]);
    return null;
};

});
parcelRegister("88fdg", function(module, exports) {

$parcel$export(module.exports, "usePlansItems", () => $fbc1adaeeb4c0d23$export$9386de9ff002702a);

var $jjts0 = parcelRequire("jjts0");

var $g5X3G = parcelRequire("g5X3G");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $fbc1adaeeb4c0d23$var$handleFetch = ()=>async ({ setState: setState, getState: getState })=>{
        const { fetchPlansItems: fetchPlansItems, baseUrl: baseUrl, isFetching: isFetching } = getState();
        if (!isFetching) try {
            const promise = fetchPlansItems(baseUrl);
            setState({
                isFetching: true,
                fetchError: null,
                promise: promise
            });
            const items = await promise;
            setState({
                items: items,
                hasFetchedOnce: true,
                hasSuccessOnce: true,
                isFetching: false,
                fetchError: null,
                promise: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            setState({
                ...getState(),
                fetchError: fetchError,
                hasFetchedOnce: true,
                isFetching: false,
                promise: null
            });
        }
    };
const $fbc1adaeeb4c0d23$var$actions = {
    load: ()=>async ({ dispatch: dispatch })=>{
            const promise = dispatch($fbc1adaeeb4c0d23$var$handleFetch());
            await promise;
        }
};
const $fbc1adaeeb4c0d23$export$b0dd7d935d0978a4 = ({ storeName: storeName = 'plans-item-store', fetchPlansItems: fetchPlansItems })=>{
    const initialState = {
        baseUrl: (0, $g5X3G.toBaseUrl)(''),
        fetchPlansItems: fetchPlansItems,
        hasFetchedOnce: false,
        hasSuccessOnce: false,
        items: null,
        fetchError: null,
        promise: null,
        isFetching: false
    };
    const Store = (0, $iXqE5.createStore)({
        name: storeName,
        actions: $fbc1adaeeb4c0d23$var$actions,
        initialState: initialState
    });
    const selector = ({ items: items, hasFetchedOnce: hasFetchedOnce, fetchError: fetchError, promise: promise, hasSuccessOnce: hasSuccessOnce, isFetching: isFetching })=>({
            items: items,
            hasFetchedOnce: hasFetchedOnce,
            hasSuccessOnce: hasSuccessOnce,
            fetchError: fetchError,
            promise: promise,
            isFetching: isFetching
        });
    const usePlansItems = (0, $3sQ5x.createHook)(Store, {
        selector: selector
    });
    return {
        usePlansItems: usePlansItems
    };
};
const { usePlansItems: $fbc1adaeeb4c0d23$export$9386de9ff002702a } = $fbc1adaeeb4c0d23$export$b0dd7d935d0978a4({
    fetchPlansItems: (0, $jjts0.fetchPlansItems)
});

});
parcelRegister("jjts0", function(module, exports) {

$parcel$export(module.exports, "fetchPlansItems", () => $9279033d6121eb6e$export$ae5884604a8ac77b);

var $5HnTq = parcelRequire("5HnTq");

var $g5X3G = parcelRequire("g5X3G");

const $9279033d6121eb6e$var$handleError = (error)=>{
    throw error;
};
const $9279033d6121eb6e$var$transformResult = ({ isVisible: isVisible, staticLinks: staticLinks, recentPlans: recentPlans = [] })=>{
    const recentItems = recentPlans.map(({ planId: planId, scenarioId: scenarioId, title: title, url: url })=>({
            id: `${planId}|${scenarioId}`,
            title: title || '',
            url: url,
            type: (0, $49a076eb01652100$export$eebccb886b064713)
        }));
    return {
        isVisible: isVisible,
        recent: recentItems,
        links: staticLinks
    };
};
const $9279033d6121eb6e$export$ae5884604a8ac77b = async (baseUrl = (0, $g5X3G.toBaseUrl)(''))=>{
    const url = `${baseUrl}/rest/jpo/1.0/navigation`;
    try {
        const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
        if (response.ok) {
            const result = await response.json();
            return $9279033d6121eb6e$var$transformResult(result);
        }
        return $9279033d6121eb6e$var$handleError(new Error(response.statusText));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $9279033d6121eb6e$var$handleError(error);
    }
};

});


parcelRegister("4XiFK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f53eb447f22f4276$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");
const $f53eb447f22f4276$var$PopupBoxWrapper = ({ children: children })=>{
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $f53eb447f22f4276$var$popupBoxWrapperStyles
    }, children);
    // Wraped children in <></> to avoid returning undefined
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $f53eb447f22f4276$var$popupBoxWrapperStyles = (0, $2s57o.xcss)({
    color: 'color.text',
    height: '100%'
});
var $f53eb447f22f4276$export$2e2bcd8739ae039 = $f53eb447f22f4276$var$PopupBoxWrapper;

});

parcelRegister("ebYJ0", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $85fdbd4ad4faa6ef$export$129a32eedafa97c5);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2uT3N = parcelRequire("2uT3N");

var $vCqQa = parcelRequire("vCqQa");

var $2Ui4E = parcelRequire("2Ui4E");

var $6cNb0 = parcelRequire("6cNb0");

var $gAtvZ = parcelRequire("gAtvZ");

var $fVbkk = parcelRequire("fVbkk");

var $8JFi2 = parcelRequire("8JFi2");
const $85fdbd4ad4faa6ef$var$OFFSET = [
    12,
    -11
];
const $85fdbd4ad4faa6ef$export$129a32eedafa97c5 = ({ Menu: Menu, MenuTrigger: MenuTrigger = (0, $fVbkk.MenuTrigger), children: children, menuId: menuId, navigationItemId: navigationItemId, onBeforeMenuOpen: onBeforeMenuOpen = ()=>undefined, label: label })=>{
    const [isMenuOpen, { off: closeMenu }] = (0, $2Ui4E.useTopMenus)(menuId);
    const [isEventFromSpotlightTour] = (0, $gAtvZ.useFromSpotlightTour)('spotlight');
    const { isVisible: isVisible } = (0, $2uT3N.useOverflowStatus)();
    const Trigger = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuTrigger, {
            ...props,
            onBeforeMenuOpen: onBeforeMenuOpen,
            menuId: menuId,
            navigationItemId: navigationItemId,
            "aria-haspopup": false
        }, children), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        children,
        menuId,
        navigationItemId,
        onBeforeMenuOpen
    ]);
    const testId = (0, $6cNb0.testIdGenerate)('primary-actions', menuId, 'menu-popup');
    const Content = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            onClick: (0, $8JFi2.stopPropagation),
            "data-testid": testId,
            role: "presentation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Menu, {
            ...props,
            testIdPrefix: testId
        }, children)), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        children,
        testId
    ]);
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Trigger, {
        "aria-expanded": false,
        "aria-haspopup": false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $vCqQa.default), {
        shouldRenderToParent: true,
        isOpen: isMenuOpen,
        onClose: isEventFromSpotlightTour ? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) : closeMenu,
        content: Content,
        offset: isVisible ? undefined : $85fdbd4ad4faa6ef$var$OFFSET,
        placement: isVisible ? 'bottom-start' : 'right-start',
        trigger: Trigger,
        label: label
    });
};

});
parcelRegister("gAtvZ", function(module, exports) {

$parcel$export(module.exports, "useFromSpotlightTour", () => $27f5c6431be57d88$export$dc0191efbad6291c);

var $2qauD = parcelRequire("2qauD");
const { useSwitch: $27f5c6431be57d88$var$useSwitch } = (0, $2qauD.createSwitchController)('spotlight');
const $27f5c6431be57d88$export$dc0191efbad6291c = $27f5c6431be57d88$var$useSwitch;

});

parcelRegister("fVbkk", function(module, exports) {

$parcel$export(module.exports, "MenuTrigger", () => $bb37eb68c16a7749$export$27d2ad3c5815583e);
$parcel$export(module.exports, "ChevronRightIcon", () => $bb37eb68c16a7749$export$b837bd7eac09a33e);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $2uT3N = parcelRequire("2uT3N");

var $cwX8H = parcelRequire("cwX8H");

var $7H980 = parcelRequire("7H980");

var $2Ui4E = parcelRequire("2Ui4E");

var $6cNb0 = parcelRequire("6cNb0");

var $hjSul = parcelRequire("hjSul");

var $kAJ4Y = parcelRequire("kAJ4Y");

var $iPj86 = parcelRequire("iPj86");

var $jmHsa = parcelRequire("jmHsa");

var $5MZG9 = parcelRequire("5MZG9");

var $jngLf = parcelRequire("jngLf");

var $9YfZr = parcelRequire("9YfZr");
const $bb37eb68c16a7749$export$27d2ad3c5815583e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ href: href, menuId: menuId, navigationItemId: navigationItemId, onBeforeMenuOpen: onBeforeMenuOpen = ()=>undefined, params: params, query: query, replace: replace, to: to, type: type, analyticsAttributes: analyticsAttributes, ...rest }, ref)=>{
    const [isMenuOpen, { off: closeMenu, toggle: toggleMenu }] = (0, $2Ui4E.useTopMenus)(menuId);
    const { isVisible: isVisible } = (0, $2uT3N.useOverflowStatus)();
    const isHighlighted = (0, $kAJ4Y.useMenuHighlighted)(menuId);
    const triggerAnalytics = (0, $iPj86.useNavigationItemAnalytics)({
        navigationItemId: navigationItemId
    });
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (!isMenuOpen) onBeforeMenuOpen();
        toggleMenu();
        triggerAnalytics(analyticsAttributes);
    }, [
        analyticsAttributes,
        isMenuOpen,
        onBeforeMenuOpen,
        toggleMenu,
        triggerAnalytics
    ]);
    // close menu on unmount
    (0, $5uXOq.useEffect)(()=>closeMenu, [
        closeMenu
    ]);
    const testId = (0, $6cNb0.testIdGenerate)('primary-actions', menuId, 'menu-trigger');
    if (isVisible) return href != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jmHsa.PrimaryButton), {
        ...rest,
        component: (0, $hjSul.Link),
        href: href,
        isHighlighted: isHighlighted,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // @ts-expect-error - Type '"a"' is not assignable to type '"submit" | "reset" | "button" | undefined'
        type: "a"
    }) : // @ts-expect-error - iconBefore types mismatch ReactNode vs ReactChild
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5MZG9.PrimaryDropdownButton), {
        ...rest,
        isHighlighted: isHighlighted,
        isSelected: isMenuOpen,
        onClick: onClick,
        ref: ref,
        testId: testId
    });
    if (to != null && __SPA__) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9YfZr.RouteLinkItem), {
        ...rest,
        onClick: onClick,
        params: params,
        query: query,
        replace: replace,
        testId: testId,
        to: to,
        type: type
    });
    return href != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jngLf.LinkItem), {
        ...rest,
        href: href,
        onClick: onClick,
        testId: testId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7H980.default), {
        ...rest,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb37eb68c16a7749$export$b837bd7eac09a33e, null),
        isSelected: isMenuOpen,
        onClick: onClick,
        testId: testId
    }));
});
// re-render regression detection
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'ForwardRefExoticComponent<Pick<any, string | number | symbol> & RefAttributes<MenuTriggerProps>>'.
$bb37eb68c16a7749$export$27d2ad3c5815583e.whyDidYouRender = {
    customName: 'MenuTrigger'
};
const $bb37eb68c16a7749$export$b837bd7eac09a33e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb37eb68c16a7749$var$ChevronWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cwX8H))), {
        spacing: "spacious",
        label: ""
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb37eb68c16a7749$var$ChevronWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_tzy4105o _2hwxmgjw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kAJ4Y", function(module, exports) {

$parcel$export(module.exports, "useMenuHighlighted", () => $afe91b4b16cc8923$export$d47286bd4be0870d);


var $2Ioew = parcelRequire("2Ioew");

var $6jY6G = parcelRequire("6jY6G");
const $afe91b4b16cc8923$export$d47286bd4be0870d = (menuId)=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const topNavEntryPointReference = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae));
    if (route.navigation) return route.navigation.menuId === menuId;
    if (topNavEntryPointReference) return topNavEntryPointReference.extraProps.menuId === menuId;
    return false;
};

});

parcelRegister("jmHsa", function(module, exports) {

$parcel$export(module.exports, "PrimaryButton", () => $d112cde340963e02$export$ac16a6a04d9b7c84);

var $5uXOq = parcelRequire("5uXOq");

var $eXSfx = parcelRequire("eXSfx");

var $dEOiD = parcelRequire("dEOiD");
const $d112cde340963e02$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dEOiD.SkeletonPrimaryButton), {
        text: props.children === undefined ? '' : props.children,
        isHighlighted: props.isHighlighted
    });
    const buttonProps = {
        ...props,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eXSfx.PrimaryButton), buttonProps);
});

});

parcelRegister("5MZG9", function(module, exports) {

$parcel$export(module.exports, "PrimaryDropdownButton", () => $e5d31dff0e605df2$export$bb3af89fb196520d);

var $5uXOq = parcelRequire("5uXOq");

var $jRAgj = parcelRequire("jRAgj");

var $dEOiD = parcelRequire("dEOiD");
const $e5d31dff0e605df2$export$bb3af89fb196520d = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dEOiD.SkeletonPrimaryButton), {
        isDropdownButton: true,
        isHighlighted: props.isHighlighted,
        text: props.children === undefined ? '' : props.children
    });
    const buttonProps = {
        ...props,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jRAgj.PrimaryDropdownButton), buttonProps);
});

});


parcelRegister("8JFi2", function(module, exports) {

$parcel$export(module.exports, "stopPropagation", () => $df06b43d1eb10455$export$51134cce184326b9);
const $df06b43d1eb10455$export$51134cce184326b9 = (e)=>e.stopPropagation();

});


parcelRegister("edhzr", function(module, exports) {

$parcel$export(module.exports, "MenuTrigger", () => $4c1d4dc7eac32f82$export$27d2ad3c5815583e);

var $5uXOq = parcelRequire("5uXOq");

var $fVbkk = parcelRequire("fVbkk");

var $fcc8T = parcelRequire("fcc8T");
const $4c1d4dc7eac32f82$export$27d2ad3c5815583e = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fcc8T.MenuTrigger), {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        ...props,
        ref: ref
    });
});

});
parcelRegister("fcc8T", function(module, exports) {

$parcel$export(module.exports, "MenuTrigger", () => $4bbcc669498d0877$export$27d2ad3c5815583e);

var $5uXOq = parcelRequire("5uXOq");

var $6puUq = parcelRequire("6puUq");

var $2uT3N = parcelRequire("2uT3N");

var $inni2 = parcelRequire("inni2");
var $Pxnvj = parcelRequire("Pxnvj");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $88fdg = parcelRequire("88fdg");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $dsvCp = parcelRequire("dsvCp");

var $8QMHF = parcelRequire("8QMHF");

var $k9JTq = parcelRequire("k9JTq");

var $fVbkk = parcelRequire("fVbkk");

var $j94qH = parcelRequire("j94qH");
const $4bbcc669498d0877$var$WRAPPER_UID = 'plans-spotlight-target-wrapper';
const $4bbcc669498d0877$var$useDelayedSpotlight = ()=>{
    const [ready, setSpotlightReady] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>setSpotlightReady(true), 100);
        return ()=>clearTimeout(timeoutId);
    }, []);
    return ready;
};
const $4bbcc669498d0877$var$useWrapper = ()=>{
    const ref = (0, $5uXOq.useRef)(null);
    return {
        ref: ref
    };
};
const $4bbcc669498d0877$var$state = {
    hasSpotlightShown: false,
    hasSpotlightDone: false
};
/**
 * The spotlight is forced closed on any click (outside of the menu), which is unexpected behavior
 * This hook will try to re-open the "More" dropdown when the "Plans" is unmounted until the user
 * clicks "Done" on the spotlight
 */ const $4bbcc669498d0877$var$useSpotlightForceOpen = ()=>{
    const { isVisible: isVisible, openOverflowMenu: openOverflowMenu } = (0, $2uT3N.useOverflowStatus)();
    const isDropdownItem = !isVisible;
    (0, $5uXOq.useLayoutEffect)(()=>()=>{
            const updateState = ()=>{
                /**
				 * The actual wrapper is supposed to be unmounted, so, if there is
				 * another wrapper element, it must be the cloned one on the spotlight
				 */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                const spotlightVisible = document.querySelector(`[data-uid="${$4bbcc669498d0877$var$WRAPPER_UID}"]`) != null;
                /**
				 * The dropdown menu is required to remaining openned after clicking Done on the
				 * spotlight. So openOverflowMenu() will be called until state.hasSpotlightDone is true.
				 */ $4bbcc669498d0877$var$state.hasSpotlightShown = $4bbcc669498d0877$var$state.hasSpotlightShown || spotlightVisible;
                if (isDropdownItem && spotlightVisible && $4bbcc669498d0877$var$state.hasSpotlightShown && !$4bbcc669498d0877$var$state.hasSpotlightDone) openOverflowMenu();
                if ($4bbcc669498d0877$var$state.hasSpotlightShown && !spotlightVisible) $4bbcc669498d0877$var$state.hasSpotlightDone = true;
            };
            queueMicrotask(updateState);
        }, [
        isDropdownItem,
        openOverflowMenu
    ]);
};
const $4bbcc669498d0877$export$56d544c4f479b7fb = ({ children: children, isVisible: isVisible })=>{
    const shouldShowNudge = (0, $dsvCp.useCanShowQuickstartNudge)();
    return shouldShowNudge && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8QMHF.NavigationPlansNavItemWrapperNudgeAsync), {
        isInsideMenu: !isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j94qH.FullHeightTextColorWrapper), null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $4bbcc669498d0877$export$27d2ad3c5815583e = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, triggerRef)=>{
    const wrapper = $4bbcc669498d0877$var$useWrapper();
    const ready = $4bbcc669498d0877$var$useDelayedSpotlight();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const jswEdition = appEditions ? (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions) : undefined;
    const [shouldShow] = (0, $cE2Qr.useShouldShowNudge)({
        itemNames: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK)
        ]
    });
    $4bbcc669498d0877$var$useSpotlightForceOpen();
    const { isVisible: isVisible } = (0, $2uT3N.useOverflowStatus)();
    const [{ items: items }] = (0, $88fdg.usePlansItems)();
    const analyticsAttributes = {
        isAbleToCreateSamplePlan: !!items?.links?.createSamplePlan?.isVisible,
        ...jswEdition ? {
            jswEdition: jswEdition
        } : {}
    };
    const [isMenuOpen, { toggle: toggleMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).PLANS);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldShow && !isMenuOpen) toggleMenu();
    }, [
        isMenuOpen,
        shouldShow,
        toggleMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        backgroundColor: "color.background.neutral.subtle",
        xcss: $4bbcc669498d0877$var$triggerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inni2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
        name: "nav-advanced-roadmaps-plans-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        "data-uid": $4bbcc669498d0877$var$WRAPPER_UID,
        ref: wrapper.ref,
        backgroundColor: "color.background.neutral.subtle",
        xcss: $4bbcc669498d0877$var$triggerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4bbcc669498d0877$export$56d544c4f479b7fb, {
        isVisible: isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        ref: triggerRef,
        analyticsAttributes: analyticsAttributes,
        ...props
    })))), ready && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6puUq.EngagementSpotlight), {
        engagementId: "nav-advanced-roadmaps-plans-spotlight"
    })));
});
const $4bbcc669498d0877$var$triggerWrapperStyles = (0, $2s57o.xcss)({
    height: '100%',
    display: 'flex',
    flexGrow: 1
});

});
parcelRegister("8QMHF", function(module, exports) {

$parcel$export(module.exports, "NavigationPlansNavItemWrapperNudgeAsync", () => $721bcfa7775fc750$export$e2e248a8ac2b2891);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $721bcfa7775fc750$var$NavigationPlansNavItemLazy = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("dQ3BD")).then((exportedModule)=>exportedModule.NavigationPlansNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-plans/index.tsx"
});
const $721bcfa7775fc750$export$e2e248a8ac2b2891 = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$46d9a3d441dfd22b),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$46d9a3d441dfd22b)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-navigation-plans-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($721bcfa7775fc750$var$NavigationPlansNavItemLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$46d9a3d441dfd22b),
        isInsideMenu: isInsideMenu
    }, children)));

});
parcelRegister("dQ3BD", function(module, exports) {

let $a132edbf4b630ea2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a132edbf4b630ea2$var$load("6qSxH").then(()=>parcelRequire('gf2wp'));

});


parcelRegister("j94qH", function(module, exports) {

$parcel$export(module.exports, "FullHeightTextColorWrapper", () => $1e4986b0c19053de$export$19a17a164d8e4de3);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $1e4986b0c19053de$export$7ac7d6a768c2e9b2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1e0c1txw _4cvr1h6o _16jlkb7n _19pnkb7n _13aikb7n _1gqrf1ug",
            __cmplp.className
        ])
    });
});
const $1e4986b0c19053de$export$19a17a164d8e4de3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1e0c1txw _4cvr1h6o _syaz1fxt _16jlkb7n _19pnkb7n _13aikb7n _1gqrf1ug",
            __cmplp.className
        ])
    });
});

});



parcelRegister("2eMU9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5668dcd9601b742$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $70rf1 = parcelRequire("70rf1");

var $g0Gtc = parcelRequire("g0Gtc");

var $7CMCs = parcelRequire("7CMCs");

var $bcn6L = parcelRequire("bcn6L");

var $lmyls = parcelRequire("lmyls");

var $6cNb0 = parcelRequire("6cNb0");

var $lfTZh = parcelRequire("lfTZh");

var $Mp6qH = parcelRequire("Mp6qH");

var $8vzcp = parcelRequire("8vzcp");

var $ag3sS = parcelRequire("ag3sS");

var $9TMfX = parcelRequire("9TMfX");

var $6WLja = parcelRequire("6WLja");

var $7Fvqy = parcelRequire("7Fvqy");

var $hZbyv = parcelRequire("hZbyv");

var $42REw = parcelRequire("42REw");

var $53HSR = parcelRequire("53HSR");

var $6MUS3 = parcelRequire("6MUS3");

var $5n6PC = parcelRequire("5n6PC");

var $aProA = parcelRequire("aProA");
const $c5668dcd9601b742$var$EVENT_DATA = {
    id: (0, $lmyls.MENU_ID).PLANS
};
const $c5668dcd9601b742$var$Menu = ({ ActionFooter: ActionFooter = (0, $hZbyv.ActionFooter), AdminFooter: AdminFooter = (0, $42REw.AdminFooter), Content: Content = (0, $53HSR.default), FavoriteContent: // @ts-expect-error - TS2339 - Property 'FavoriteContent' does not exist on type 'MenuProps'.
FavoriteContent = (0, $6MUS3.FavoriteContent), Error: Error = (0, $8vzcp.MenuError), JSErrorBoundary: JSErrorBoundary = (0, $7CMCs.JSErrorBoundary), Layout: Layout = (0, $ag3sS.MenuLayout), LoadStatus: LoadStatus = (0, $5n6PC.LoadStatus), Section: Section = (0, $70rf1.default), SkeletonContent: SkeletonContent = (0, $9TMfX.MenuSkeletonContent), SkeletonFooter: SkeletonFooter = (0, $6WLja.MenuSkeletonFooter), ViewExperienceSuccessTracker: ViewExperienceSuccessTracker = (0, $g0Gtc.ExperienceSuccessTracker), testIdPrefix: testIdPrefix, useFavorite: // @ts-expect-error - TS2339 - Property 'useFavorite' does not exist on type 'MenuProps'.
useFavorite = (0, $bcn6L.useFavoritePlans) })=>{
    const [, { loadFavoritePlans: loadFavorite }] = useFavorite();
    const contentTestId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'content');
    const actionFooterTestId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'action-footer');
    const adminFooterTestId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'admin-footer');
    const isStandardOrFree = (0, $7Fvqy.useIsStandardOrFreeJSW)();
    const errorFallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Error, {
            testIdPrefix: contentTestId
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contentTestId
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // Refresh favourites on close to update if user has toggled any item
            !isStandardOrFree && loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
        }, [
        loadFavorite,
        isStandardOrFree
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Layout, {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JSErrorBoundary, {
        id: (0, $lmyls.MENU_ID).PLANS,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: errorFallback,
        withExperienceTracker: true,
        extraEventData: $c5668dcd9601b742$var$EVENT_DATA
    }, isStandardOrFree ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aProA.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        isScrollable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "plans-menu-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonContent, {
            testIdPrefix: contentTestId
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ViewExperienceSuccessTracker, {
        location: "atlassian-navigation--primary-actions--plans--menu-popup--content",
        failureEventAttributes: null,
        parentProviders: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatus, {
        shouldThrowError: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FavoriteContent, {
        testIdPrefix: contentTestId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Content, {
        testIdPrefix: contentTestId
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "plans-menu-footer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonFooter, {
            testIdPrefix: contentTestId
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatus, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ActionFooter, {
        testIdPrefix: actionFooterTestId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AdminFooter, {
        testIdPrefix: adminFooterTestId
    }))))));
};
var $c5668dcd9601b742$export$2e2bcd8739ae039 = $c5668dcd9601b742$var$Menu;

});
parcelRegister("8vzcp", function(module, exports) {

$parcel$export(module.exports, "MenuError", () => $51a1ea955baf80ff$export$b4cb8426191db8b3);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $jyltl = parcelRequire("jyltl");

var $bIXOn = parcelRequire("bIXOn");

var $itL3d = parcelRequire("itL3d");
const $51a1ea955baf80ff$export$b4cb8426191db8b3 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const errorText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51a1ea955baf80ff$var$TextWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51a1ea955baf80ff$var$Heading, null, formatMessage((0, $itL3d.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $itL3d.default).errorBody)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jyltl.MenuInfo), {
        imgAltText: formatMessage((0, $itL3d.default).errorImg),
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($bIXOn))),
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, 'error'),
        text: errorText,
        useSmallImage: true
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $51a1ea955baf80ff$var$TextWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f31ejb _n3tdidpf _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $51a1ea955baf80ff$var$Heading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "strong", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jyltl", function(module, exports) {

$parcel$export(module.exports, "MenuInfo", () => $c2ec3089b9809088$export$14caacd677140cdb);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $c2ec3089b9809088$export$14caacd677140cdb = ({ imgAltText: imgAltText, imgHeight: imgHeight, imgSrc: imgSrc, text: text, useSmallImage: useSmallImage = false, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2ec3089b9809088$export$895814aa5a1cf38c, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2ec3089b9809088$export$e54065c861f556f9, {
        alt: imgAltText || '',
        imgHeight: imgHeight,
        src: imgSrc,
        useSmallImage: useSmallImage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2ec3089b9809088$export$7c3018f441722857, null, text));
const $c2ec3089b9809088$export$895814aa5a1cf38c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsbnklw _1e0c1txw _y3gn1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $c2ec3089b9809088$export$e54065c861f556f9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { useSmallImage: useSmallImage, imgHeight: imgHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ve50id": (0, $lD23V.default)(__cmplp.imgHeight, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1ule _ca0qv47k _u5f3idpf _n3tdpxbi _19bvidpf _p12f1osq",
            __cmplp.useSmallImage ? "_1bsb16xz" : "_1bsb1lit",
            __cmplp.imgHeight != null ? "_4t3i1m1g" : "_4t3i1wug",
            __cmplp.className
        ])
    });
});
const $c2ec3089b9809088$export$7c3018f441722857 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _ca0qidpf _u5f3v47k _n3tdv47k _19bvv47k",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bIXOn", function(module, exports) {
module.exports = new URL("generic-error.bc45c66a.svg", import.meta.url).toString();

});

parcelRegister("itL3d", function(module, exports) {

$parcel$export(module.exports, "default", () => $9730b8dbc9b9bc1a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9730b8dbc9b9bc1a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorHeading: {
        "id": "atlassian-navigation.common.menu.error.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "atlassian-navigation.common.menu.error.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    },
    errorImg: {
        "id": "atlassian-navigation.common.menu.error.error-img",
        "defaultMessage": "An image showing that an error has occurred"
    }
});

});


parcelRegister("hZbyv", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $adef3029a926b6d1$export$2d2b754ac238f9aa);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $88fdg = parcelRequire("88fdg");

var $gD5Z0 = parcelRequire("gD5Z0");

var $4LAva = parcelRequire("4LAva");

var $L0P37 = parcelRequire("L0P37");

var $9EGDV = parcelRequire("9EGDV");

var $eemc9 = parcelRequire("eemc9");
const $adef3029a926b6d1$export$2d2b754ac238f9aa = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ items: items }] = (0, $88fdg.usePlansItems)();
    const isPlanListEmpty = (0, $eemc9.useIsPlanListEmpty)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'action-footer');
    const [, { openDrawer: openCreateNewPlanWizardDrawer }] = (0, $gD5Z0.useCreateNewPlanWizardDrawer)();
    const [, { open: openCreateSamplePlanModal }] = (0, $4LAva.useCreateSamplePlan)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        openCreateNewPlanWizardDrawer();
    }, [
        openCreateNewPlanWizardDrawer
    ]);
    if (!items || !items.links) return null;
    const { links: links } = items;
    const { managePlans: managePlans, createPlan: createPlan, createSamplePlan: createSamplePlan } = links;
    const isAnyItemVisible = managePlans.isVisible || createPlan.isVisible;
    if (!isAnyItemVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testId": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $L0P37.MenuItem), {
        ...links.managePlans,
        title: formatMessage((0, $9EGDV.default).managePlans),
        testIdPrefix: testIdPrefix
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $L0P37.MenuItem), {
        id: links.createPlan.id,
        isVisible: links.createPlan.isVisible && !isPlanListEmpty,
        title: formatMessage((0, $9EGDV.default).createPlan),
        testIdPrefix: testIdPrefix,
        onClick: onClick
    }), createSamplePlan && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $L0P37.MenuItem), {
        id: createSamplePlan.id,
        isVisible: createSamplePlan.isVisible && !isPlanListEmpty,
        title: formatMessage((0, $9EGDV.default).createDemoPlan),
        testIdPrefix: testIdPrefix,
        onClick: openCreateSamplePlanModal
    }));
};

});
parcelRegister("L0P37", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $3555250889c231c3$export$2ce376c2cc3355c8);

var $5uXOq = parcelRequire("5uXOq");

var $6cNb0 = parcelRequire("6cNb0");

var $d4B4Y = parcelRequire("d4B4Y");
const $3555250889c231c3$export$2ce376c2cc3355c8 = ({ id: id, url: url, title: title, isVisible: isVisible, onClick: onClick, testIdPrefix: testIdPrefix })=>isVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'plansNavigationMenuItem',
            menuItemId: id,
            menuItemType: 'action'
        },
        href: url,
        key: id,
        onClick: onClick,
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, `item-${id}`)
    }, title) : null;

});

parcelRegister("9EGDV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b84dd9eb74c4947$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1b84dd9eb74c4947$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    managePlans: {
        "id": "atlassian-navigation.plans.menu.action-footer.manage-plans",
        "defaultMessage": "View all plans"
    },
    createPlan: {
        "id": "atlassian-navigation.plans.menu.action-footer.create-plan",
        "defaultMessage": "Create plan"
    },
    createDemoPlan: {
        "id": "atlassian-navigation.plans.menu.action-footer.create-demo-plan",
        "defaultMessage": "Create demo plan"
    }
});

});

parcelRegister("eemc9", function(module, exports) {

$parcel$export(module.exports, "useIsPlanListEmpty", () => $6d7bc7f34f360a53$export$5b132e35e5bd9b74);

var $dMJS0 = parcelRequire("dMJS0");
const $6d7bc7f34f360a53$export$5b132e35e5bd9b74 = ()=>{
    const { recentItems: recentItems, favoriteItems: favoriteItems } = (0, $dMJS0.usePlanNavItems)();
    const hasRecentItems = recentItems && recentItems.length > 0;
    const hasFavoriteItems = favoriteItems && favoriteItems.length > 0;
    return !(hasRecentItems || hasFavoriteItems);
};

});
parcelRegister("dMJS0", function(module, exports) {

$parcel$export(module.exports, "useBoardNavItems", () => $104764fbcbb91fe4$export$cad67ea3bdbadd5e);
$parcel$export(module.exports, "useDashboardNavItems", () => $104764fbcbb91fe4$export$eb662c364f65f2a5);
$parcel$export(module.exports, "useFilterNavItems", () => $104764fbcbb91fe4$export$b00ea32725560f5d);
$parcel$export(module.exports, "usePlanNavItems", () => $104764fbcbb91fe4$export$8448c28cc43804d4);
$parcel$export(module.exports, "useProjectNavItems", () => $104764fbcbb91fe4$export$4a9469e6b2e4297c);
$parcel$export(module.exports, "useRecentNavItems", () => $104764fbcbb91fe4$export$5cfe5f7fc9ab5417);
$parcel$export(module.exports, "useQueueNavItems", () => $104764fbcbb91fe4$export$7723949d2540d672);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $bcn6L = parcelRequire("bcn6L");

var $4041n = parcelRequire("4041n");

var $88fdg = parcelRequire("88fdg");

var $apeap = parcelRequire("apeap");
const $104764fbcbb91fe4$var$getFavouriteAndRecentItems = (recentItems, favoriteItems, changedItems)=>{
    const mapChangedItems = (item)=>{
        const changedItem = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(changedItems, item.id);
        return changedItem ? {
            ...item,
            favourite: changedItem.value
        } : item;
    };
    const updatedFavorites = favoriteItems ? favoriteItems.map(mapChangedItems) : [];
    const updatedRecents = recentItems ? recentItems.map(mapChangedItems) : [];
    // this logic relies on the fact that we defer update favorites store on dropdown close
    // so we can assume that favorites list always affects recent list
    const favoritesIds = updatedFavorites.map((item)=>item.id);
    const filteredRecents = updatedRecents.filter((item)=>!favoritesIds.includes(Number(item.id)));
    return {
        favoriteItems: updatedFavorites,
        recentItems: filteredRecents
    };
};
const $104764fbcbb91fe4$var$getFilteredViewedItems = (viewedItems, // @ts-expect-error - TS2304 - Cannot find name 'IssueItem'.
workedOnItems)=>viewedItems?.filter((viewedItem)=>!workedOnItems?.some(// @ts-expect-error - TS2304 - Cannot find name 'IssueItem'.
        (workedOnItem)=>parseInt(workedOnItem.localResourceId, 10) === viewedItem.id && workedOnItem.type === viewedItem.type)) || [];
const $104764fbcbb91fe4$export$cad67ea3bdbadd5e = ()=>{
    const { changeFavorite: changeFavorite, items: { boards: changedItems } } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const [recentData] = (0, $apeap.useRecentBoards)();
    const [favoriteData] = (0, $bcn6L.useFavoriteBoards)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $5uXOq.useMemo)(()=>$104764fbcbb91fe4$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $104764fbcbb91fe4$export$eb662c364f65f2a5 = ()=>{
    const { changeFavorite: changeFavorite, items: { dashboards: changedItems } } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const [recentData] = (0, $apeap.useRecentDashboards)();
    const [favoriteData] = (0, $bcn6L.useFavoriteDashboards)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $5uXOq.useMemo)(()=>$104764fbcbb91fe4$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $104764fbcbb91fe4$export$b00ea32725560f5d = ()=>{
    const { changeFavorite: changeFavorite, items: { filters: changedItems } } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const [recentData] = (0, $apeap.useRecentFilters)();
    const [favoriteData] = (0, $bcn6L.useFavoriteFilters)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $5uXOq.useMemo)(()=>$104764fbcbb91fe4$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $104764fbcbb91fe4$export$8448c28cc43804d4 = ()=>{
    const { changeFavorite: changeFavorite, items: { plans: changedItems } } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const [{ items: items }] = (0, $88fdg.usePlansItems)();
    const [favoriteData] = (0, $bcn6L.useFavoritePlans)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $5uXOq.useMemo)(()=>{
        const recentPlans = items?.recent ? items.recent.map(// the id is a concatenation of planId and scenarioId...
        // we need to strip the scenario so we just have the plan id
        (plan)=>({
                ...plan,
                id: plan.id.toString().split('|')[0]
            })) : [];
        return $104764fbcbb91fe4$var$getFavouriteAndRecentItems(recentPlans, favoriteData.items, changedItems);
    }, [
        items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $104764fbcbb91fe4$export$4a9469e6b2e4297c = ()=>{
    const { changeFavorite: changeFavorite, items: { projects: changedItems } } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const [recentData] = (0, $apeap.useRecentProjects)();
    const [favoriteData] = (0, $bcn6L.useFavoriteProjects)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $5uXOq.useMemo)(()=>$104764fbcbb91fe4$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $104764fbcbb91fe4$export$5cfe5f7fc9ab5417 = ()=>{
    const [viewedData] = (0, $apeap.useRecentAllSingleList)();
    const [workedOnData] = (0, $apeap.useWorkedOnAllSingleList)();
    const viewedItems = (0, $5uXOq.useMemo)(()=>$104764fbcbb91fe4$var$getFilteredViewedItems(viewedData.items, workedOnData.items), [
        viewedData.items,
        workedOnData.items
    ]);
    return {
        workedOnItems: workedOnData.items || [],
        viewedItems: viewedItems
    };
};
const $104764fbcbb91fe4$export$7723949d2540d672 = ()=>{
    const { changeFavorite: changeFavorite, items: { queues: changedItems } } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const [recentData] = (0, $apeap.useRecentQueues)();
    const [favoriteData] = (0, $bcn6L.useFavoriteQueues)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $5uXOq.useMemo)(()=>$104764fbcbb91fe4$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};

});



parcelRegister("42REw", function(module, exports) {

$parcel$export(module.exports, "AdminFooter", () => $7b2abd444f379ab5$export$d7aa9aad32d41ef6);

var $5uXOq = parcelRequire("5uXOq");

var $70rf1 = parcelRequire("70rf1");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $88fdg = parcelRequire("88fdg");

var $d4B4Y = parcelRequire("d4B4Y");

var $7Josu = parcelRequire("7Josu");
const $7b2abd444f379ab5$export$d7aa9aad32d41ef6 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ items: items }] = (0, $88fdg.usePlansItems)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'admin-footer');
    if (!items || !items.links) return null;
    const { links: { settings: { id: id, isVisible: isVisible } } } = items;
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        hasSeparator: true,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'planSettingsNavigationMenuItem',
            menuItemId: id,
            menuItemType: 'action'
        },
        href: "/jira/plans/settings/permissions",
        key: id,
        testId: (0, $6cNb0.testIdConcat)(testId, `item-${id}`)
    }, formatMessage((0, $7Josu.default).settings)));
};

});
parcelRegister("7Josu", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7ecad56cc035bca$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f7ecad56cc035bca$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    settings: {
        "id": "atlassian-navigation.plans.menu.admin-footer.settings",
        "defaultMessage": "Settings"
    }
});

});


parcelRegister("53HSR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a598b0994a63b7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $d6a7c = parcelRequire("d6a7c");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $4R6GH = parcelRequire("4R6GH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $dMJS0 = parcelRequire("dMJS0");

var $9ZBW7 = parcelRequire("9ZBW7");

var $gJFyv = parcelRequire("gJFyv");
// request to include icon in atlaskit
// https://ecosystem.atlassian.net/jira/servicedesk/projects/DS/queues/issue/DS-7743
// https://jdog.jira-dev.com/browse/JPO-18296
const $c5a598b0994a63b7$var$IconPlans = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: 24,
        width: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-icon, #44546F)",
        d: "M10 8a1 1 0 000 2h4a1 1 0 100-2h-4zM10 12a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM10 14a1 1 0 100 2h2a1 1 0 100-2h-2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-icon, #44546F)",
        fillRule: "evenodd",
        d: "M8 4a2 2 0 012-2h4a2 2 0 012 2h1a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2h1zm6 3a2 2 0 001.732-1H17v12H7V6h1.268A2 2 0 0010 7h4zm0-3h-4v1h4V4z",
        clipRule: "evenodd"
    }));
const $c5a598b0994a63b7$var$Content = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { recentItems: recentItems, favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.usePlanNavItems)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items');
    const hasRecentItems = recentItems && recentItems.length > 0;
    const hasFavoriteItems = favoriteItems && favoriteItems.length > 0;
    if (!hasRecentItems && !hasFavoriteItems) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ZBW7.default), {
        testIdPrefix: (0, $6cNb0.testIdConcat)(testIdPrefix, 'empty')
    });
    return hasRecentItems ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testId": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6a7c.default), {
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, 'heading')
    }, formatMessage((0, $gJFyv.default).recent)), recentItems.map((item, index)=>{
        const { id: id, favourite: isFavourite, title: title } = item;
        const contextItem = changedItems[id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { id: beforeEntityId, type: beforeEntityType } = (0, $2EqxS.getBeforeEntity)(favoriteItems);
        const itemTitle = title || formatMessage((0, $gJFyv.default).untitledPlan);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'plansNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'recent',
                position: index
            },
            href: item.url,
            key: item.id,
            testId: (0, $6cNb0.testIdConcat)(testIdPrefix, `item-${index}`),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c5a598b0994a63b7$var$IconPlans, null),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                beforeEntityId: beforeEntityId,
                beforeEntityType: beforeEntityType,
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: itemTitle,
                isPending: isPending,
                menuItemType: "recent",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.PLANS_ITEM_TYPE)
            }),
            "aria-label": (0, $4R6GH.fg)('blu-6205_misc_nav3_a11y_fixes') ? itemTitle : undefined
        }, itemTitle);
    })) : null;
};
var $c5a598b0994a63b7$export$2e2bcd8739ae039 = $c5a598b0994a63b7$var$Content;

});
parcelRegister("fhtpB", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $fd1b3cb9e133f54f$export$8d5dab2ad1e19ea0);

var $5uXOq = parcelRequire("5uXOq");

var $2uT3N = parcelRequire("2uT3N");

var $hcObS = parcelRequire("hcObS");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");
const $fd1b3cb9e133f54f$export$8d5dab2ad1e19ea0 = ({ beforeEntityId: // @ts-expect-error - TS2339 - Property 'beforeEntityId' does not exist on type 'FavoriteButtonProps'.
beforeEntityId, beforeEntityType: // @ts-expect-error - TS2339 - Property 'beforeEntityType' does not exist on type 'FavoriteButtonProps'.
beforeEntityType, id: id, isFavorite: isFavorite, favoriteItemName: favoriteItemName, isPending: isPending, menuItemType: menuItemType, onChangeFavorite: onChangeFavorite, type: type })=>{
    const { isVisible: isVisible } = (0, $2uT3N.useOverflowStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const contextualAnalyticsDataAttributes = (0, $5uXOq.useMemo)(()=>({
            isInMore: !isVisible,
            menuType: type,
            menuItemType: menuItemType
        }), [
        isVisible,
        menuItemType,
        type
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const beforeEntity = beforeEntityId != null && beforeEntityType != null ? {
            beforeEntity: {
                id: beforeEntityId,
                type: beforeEntityType
            }
        } : undefined;
        onChangeFavorite({
            id: id,
            value: !isFavorite,
            type: type,
            ...beforeEntity
        });
        const actionSubject = type.slice(0, type.length - 1); // remove "s" from type ("projects" -> "project", etc)
        const action = isFavorite ? 'unstarred' : 'starred';
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, id);
    }, [
        beforeEntityId,
        beforeEntityType,
        createAnalyticsEvent,
        id,
        isFavorite,
        onChangeFavorite,
        type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: contextualAnalyticsDataAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), {
        isSmall: true,
        isShownInList: true,
        isFavorite: isFavorite,
        favoriteItemName: favoriteItemName,
        pending: isPending,
        onClick: onClick
    }));
};

});
parcelRegister("hcObS", function(module, exports) {

$parcel$export(module.exports, "FavoriteButtonWrapper", () => $0a68425ce3fc2fa8$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $0a68425ce3fc2fa8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $cNW3X = parcelRequire("cNW3X");

var $X3Phd = parcelRequire("X3Phd");

var $fkyxu = parcelRequire("fkyxu");

var $k71Jv = parcelRequire("k71Jv");

var $awkL7 = parcelRequire("awkL7");

var $kzEYk = parcelRequire("kzEYk");

var $1fvKj = parcelRequire("1fvKj");

var $8iquX = parcelRequire("8iquX");

var $5KCCi = parcelRequire("5KCCi");

var $iQv12 = parcelRequire("iQv12");

var $7XYc4 = parcelRequire("7XYc4");

var $az4zD = parcelRequire("az4zD");

var $dCm1o = parcelRequire("dCm1o");

var $6fQ6A = parcelRequire("6fQ6A");
const $0a68425ce3fc2fa8$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper';
class $0a68425ce3fc2fa8$export$f8ad2acf0ec4860f extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $0a68425ce3fc2fa8$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iquX.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$export$db65185b5889c83, {
            "data-testid": $0a68425ce3fc2fa8$var$SKELETON_TEST_ID,
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const buttonContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($X3Phd))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($awkL7))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6fQ6A.default).removeFromStarred)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fkyxu))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($k71Jv))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6fQ6A.default).addToStarred)
        }));
        const renderIcon = ()=>{
            const label = isFavorite ? formatMessage((0, $6fQ6A.default).removeFromStarred) : formatMessage((0, $6fQ6A.default).addToStarred);
            let StarIconComponent;
            if (isSmall) StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($kzEYk))) : (0, (/*@__PURE__*/$parcel$interopDefault($1fvKj)));
            else StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($X3Phd))) : (0, (/*@__PURE__*/$parcel$interopDefault($fkyxu)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label
            });
        };
        const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, renderIcon());
        const tooltipContent = isFavorite ? formatMessage((0, $6fQ6A.default).removeFromStarred) : formatMessage((0, $6fQ6A.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $6fQ6A.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $6fQ6A.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        }, (0, $dCm1o.isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
    }
    constructor(...args){
        super(...args), this.state = {
            isAnimating: false
        }, this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        }, this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $0a68425ce3fc2fa8$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $az4zD.injectIntlV2))($0a68425ce3fc2fa8$export$f8ad2acf0ec4860f);
const $0a68425ce3fc2fa8$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0a68425ce3fc2fa8$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_11vn1ssb _1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
});
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBase = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseNew, $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0a68425ce3fc2fa8$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isFavorite ? "_syaz1oqg" : "_syaz1oju",
            __cmplp.isFavorite ? "_30l31vop" : "_30l3wdcn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0a68425ce3fc2fa8$export$db65185b5889c83 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6fQ6A", function(module, exports) {

$parcel$export(module.exports, "default", () => $10bc2ec5d9a72db1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $10bc2ec5d9a72db1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});

});



parcelRegister("9ZBW7", function(module, exports) {

$parcel$export(module.exports, "default", () => $72e027cbf3ff743a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $ousew = parcelRequire("ousew");

var $6cNb0 = parcelRequire("6cNb0");

var $88fdg = parcelRequire("88fdg");

var $gD5Z0 = parcelRequire("gD5Z0");

var $4LAva = parcelRequire("4LAva");

var $8zOmE = parcelRequire("8zOmE");

var $jyltl = parcelRequire("jyltl");

var $1x6mD = parcelRequire("1x6mD");

var $iy6PK = parcelRequire("iy6PK");
const $72e027cbf3ff743a$var$EmptyWithCTAs = ({ testIdPrefix: testIdPrefix })=>{
    const [{ items: items }] = (0, $88fdg.usePlansItems)();
    const [, { openDrawer: openCreateNewPlanWizardDrawer }] = (0, $gD5Z0.useCreateNewPlanWizardDrawer)();
    const [, { open: openCreateSamplePlanModal }] = (0, $4LAva.useCreateSamplePlan)();
    const handleRequestCreateSamplePlan = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'navigationCreateSamplePlan');
        openCreateSamplePlanModal();
    }, [
        openCreateSamplePlanModal
    ]);
    const handleRequestCreatePlan = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'navigationCreatePlan');
        openCreateNewPlanWizardDrawer();
    }, [
        openCreateNewPlanWizardDrawer
    ]);
    const createPlan = items?.links?.createPlan;
    const createSamplePlan = items?.links?.createSamplePlan;
    const hasButtons = Boolean(createPlan?.isVisible || createSamplePlan?.isVisible);
    const text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $iy6PK.default).plansText)), hasButtons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $72e027cbf3ff743a$var$buttonGroupStyles
    }, createSamplePlan?.isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        onClick: handleRequestCreateSamplePlan
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $iy6PK.default).createDemoPlan)), createPlan?.isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "primary",
        onClick: handleRequestCreatePlan
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $iy6PK.default).createPlan))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jyltl.MenuInfo), {
        imgAltText: "",
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($1x6mD))),
        testId: (0, $6cNb0.testIdConcat)(testIdPrefix, 'empty'),
        text: text
    });
};
var $72e027cbf3ff743a$export$2e2bcd8739ae039 = $72e027cbf3ff743a$var$EmptyWithCTAs;
const $72e027cbf3ff743a$var$buttonGroupStyles = (0, $2s57o.xcss)({
    marginTop: 'space.200',
    display: 'flex',
    gap: 'space.100',
    justifyContent: 'center'
});

});
parcelRegister("1x6mD", function(module, exports) {
module.exports = new URL("plans-empty.7a647633.svg", import.meta.url).toString();

});

parcelRegister("iy6PK", function(module, exports) {

$parcel$export(module.exports, "default", () => $20432d5456b05a6a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $20432d5456b05a6a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    plansText: {
        "id": "atlassian-navigation.plans.menu.content.empty.plans-text",
        "defaultMessage": "Create up-to-date plans from multiple teams and projects."
    },
    createPlan: {
        "id": "atlassian-navigation.plans.menu.content.empty.create-plan",
        "defaultMessage": "Create plan"
    },
    createDemoPlan: {
        "id": "atlassian-navigation.plans.menu.content.empty.create-demo-plan",
        "defaultMessage": "Create demo plan"
    },
    learnMore: {
        "id": "atlassian-navigation.plans.menu.content.empty.learn-more",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("gJFyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f1da9814d244cf8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9f1da9814d244cf8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "atlassian-navigation.plans.menu.content.recent",
        "defaultMessage": "Recent"
    },
    untitledPlan: {
        "id": "atlassian-navigation.plans.menu.content.untitled-plan",
        "defaultMessage": "Untitled plan"
    }
});

});


parcelRegister("6MUS3", function(module, exports) {

$parcel$export(module.exports, "FavoriteContent", () => $4f470a059723f912$export$297af018011b145a);

var $5uXOq = parcelRequire("5uXOq");

var $d6a7c = parcelRequire("d6a7c");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $8jQu6 = parcelRequire("8jQu6");

var $4R6GH = parcelRequire("4R6GH");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $56fXm = parcelRequire("56fXm");

var $dMJS0 = parcelRequire("dMJS0");

var $fbx6q = parcelRequire("fbx6q");
// request to include icon in atlaskit
// https://ecosystem.atlassian.net/jira/servicedesk/projects/DS/queues/issue/DS-7743
// https://jdog.jira-dev.com/browse/JPO-18296
const $4f470a059723f912$var$IconPlans = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: 24,
        width: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-icon, #44546F)",
        d: "M10 8a1 1 0 000 2h4a1 1 0 100-2h-4zM10 12a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM10 14a1 1 0 100 2h2a1 1 0 100-2h-2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-icon, #44546F)",
        fillRule: "evenodd",
        d: "M8 4a2 2 0 012-2h4a2 2 0 012 2h1a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2h1zm6 3a2 2 0 001.732-1H17v12H7V6h1.268A2 2 0 0010 7h4zm0-3h-4v1h4V4z",
        clipRule: "evenodd"
    }));
const $4f470a059723f912$export$297af018011b145a = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.usePlanNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>favoriteItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)), [
        favoriteItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-starred');
    return favoriteItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testId": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6a7c.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $fbx6q.default).starred)), itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const itemTitle = title || formatMessage((0, $fbx6q.default).untitledPlan);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'plansNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'starred',
                position: idx,
                starred: Boolean(isFavourite)
            },
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f470a059723f912$var$IconPlans, null),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: itemTitle,
                isPending: isPending,
                menuItemType: "starred",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.PLANS_ITEM_TYPE)
            }),
            key: id,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            "aria-label": (0, $4R6GH.fg)('blu-6205_misc_nav3_a11y_fixes') ? itemTitle : undefined
        }, itemTitle);
    }), favoriteItems.length >= (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $56fXm.MenuItemViewAll), {
        analytics: {
            actionSubjectId: 'plansNavigationMenuItem',
            menuItemId: 'viewAll',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            position: (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)
        },
        href: "/jira/plans",
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: (0, $8jQu6.plansDirectoryRoute)
    })) : null;
};

});
parcelRegister("56fXm", function(module, exports) {

$parcel$export(module.exports, "MenuItemViewAll", () => $fec3d6e24cccbb91$export$2d5ce40137c4f96d);

var $5uXOq = parcelRequire("5uXOq");

var $2Do6f = parcelRequire("2Do6f");

var $koVbs = parcelRequire("koVbs");

var $d4B4Y = parcelRequire("d4B4Y");

var $awxdD = parcelRequire("awxdD");
const $fec3d6e24cccbb91$var$viewAllCssFn = ()=>({
        '&, &:hover, &:focus, & span': {
            color: "var(--ds-link, #0C66E4)",
            textDecoration: 'none'
        },
        '&:active': {
            color: "var(--ds-link-pressed, #0055CC)",
            textDecoration: 'none'
        }
    });
const $fec3d6e24cccbb91$export$2d5ce40137c4f96d = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        ...props,
        target: "_blank",
        cssFn: $fec3d6e24cccbb91$var$viewAllCssFn,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Do6f))), {
            spacing: "spacious",
            label: formatMessage((0, $awxdD.default).viewAllStarred)
        })
    }, formatMessage((0, $awxdD.default).viewAllStarred));
};

});
parcelRegister("awxdD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6318f13bf447304$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f6318f13bf447304$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAllStarred: {
        "id": "atlassian-navigation.common.menu.view-all.view-all-starred",
        "defaultMessage": "View all starred"
    }
});

});


parcelRegister("fbx6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c5162b46fd824b0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c5162b46fd824b0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    starred: {
        "id": "atlassian-navigation.plans.menu.favorite-content.starred",
        "defaultMessage": "Starred"
    },
    untitledPlan: {
        "id": "atlassian-navigation.plans.menu.favorite-content.untitled-plan",
        "defaultMessage": "Untitled plan"
    }
});

});


parcelRegister("5n6PC", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $28d55793d37ab45d$export$c7df4a3f1b89de01);

var $5uXOq = parcelRequire("5uXOq");

var $88fdg = parcelRequire("88fdg");

var $dHtVS = parcelRequire("dHtVS");
const $28d55793d37ab45d$export$c7df4a3f1b89de01 = ({ LoadStatusCommon: LoadStatusCommon = (0, $dHtVS.LoadStatus), usePlansItems: usePlansItems = (0, $88fdg.usePlansItems), shouldThrowError: shouldThrowError = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: usePlansItems
    });

});
parcelRegister("dHtVS", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $97c251fd319eb785$export$c7df4a3f1b89de01);
const $97c251fd319eb785$export$c7df4a3f1b89de01 = ({ useProvider: useProvider, shouldThrowError: shouldThrowError = false })=>{
    // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    const [{ fetchError: fetchError, isFetching: isFetching = false, promise: promise, hasSuccessOnce: hasSuccessOnce = false } = {}] = useProvider();
    if (fetchError != null && shouldThrowError && !hasSuccessOnce) throw fetchError;
    if (isFetching && !hasSuccessOnce) throw promise;
    return null;
};

});



parcelRegister("2FrC0", function(module, exports) {

$parcel$export(module.exports, "default", () => $10a254be368ab7ac$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $10a254be368ab7ac$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    plans: {
        "id": "atlassian-navigation.plans.plans",
        "defaultMessage": "Plans"
    }
});

});


parcelRegister("lbp13", function(module, exports) {

$parcel$export(module.exports, "YourWorkDropdown", () => $4aa4f1efd8bce12b$export$3f0b217fc9bdcb2b);

var $5uXOq = parcelRequire("5uXOq");

var $3zm3p = parcelRequire("3zm3p");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $koeKL = parcelRequire("koeKL");

var $dp4Da = parcelRequire("dp4Da");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $4XiFK = parcelRequire("4XiFK");

var $ebYJ0 = parcelRequire("ebYJ0");

var $e8iSm = parcelRequire("e8iSm");

var $bJsBT = parcelRequire("bJsBT");

var $fFuPf = parcelRequire("fFuPf");
const $4aa4f1efd8bce12b$var$YourWorkDropdown = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const activityClient = (0, $dp4Da.useActivityClient)('v3', 'jira');
    const cloudId = (0, $koeKL.useCloudId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3zm3p.AlertsStoreContainer), {
        cloudId: cloudId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8iSm.RecentActivityContainer), {
        activityClient: activityClient,
        cloudId: cloudId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XiFK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebYJ0.Popup), {
        menuId: (0, $lmyls.MENU_ID).HOME,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).HOME,
        Menu: (0, $bJsBT.AsyncMenu),
        label: formatMessage((0, $fFuPf.default).title)
    }, formatMessage((0, $fFuPf.default).title)))));
};
const $4aa4f1efd8bce12b$export$3f0b217fc9bdcb2b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).HOME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4aa4f1efd8bce12b$var$YourWorkDropdown, null));

});
parcelRegister("3zm3p", function(module, exports) {

$parcel$export(module.exports, "useAlertsStore", () => $d7740626dfebecb7$export$52a528b1f45cfa42);
$parcel$export(module.exports, "AlertsStoreContainer", () => $d7740626dfebecb7$export$dac8df4ae2328540);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $DWjzc = parcelRequire("DWjzc");

var $aT1mD = parcelRequire("aT1mD");
const $d7740626dfebecb7$export$a2290b0841306a43 = {
    items: null,
    isFetching: false,
    fetchError: null,
    promise: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false,
    totalCount: 0
};
const $d7740626dfebecb7$export$d4c72bab9d6cc13a = {};
const $d7740626dfebecb7$var$loadAlerts = ({ searchParams: searchParams, key: key, shouldOverwrite: shouldOverwrite = true })=>async ({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        if (!cloudId) throw new Error('`cloudId` is required please wrap your component with `AlertsStoreContainer`, and provide the prop.');
        if (!key) throw new Error('`key` is required please provie a unique key for each query.');
        try {
            const promise = (0, $aT1mD.fetchAlerts)({
                cloudId: cloudId,
                searchParams: searchParams
            });
            setState({
                ...getState(),
                [key]: {
                    ...$d7740626dfebecb7$export$a2290b0841306a43,
                    ...getState()[key],
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                }
            });
            const response = await promise;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const alerts = response?.values ?? null;
            const newItems = shouldOverwrite ? alerts : [
                ...getState()[key]?.items ?? [],
                ...alerts
            ];
            setState({
                ...getState(),
                [key]: {
                    ...getState()[key],
                    items: newItems,
                    totalCount: newItems.length,
                    hasSuccessOnce: true,
                    hasFetchedOnce: true,
                    isFetching: false
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                [key]: {
                    ...$d7740626dfebecb7$export$a2290b0841306a43,
                    ...getState()[key],
                    fetchError: error,
                    hasFetchedOnce: true,
                    isFetching: false
                }
            });
            throw error;
        }
    };
const $d7740626dfebecb7$var$removeAlert = ({ alertId: alertId, key: key })=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            [key]: {
                ...$d7740626dfebecb7$export$a2290b0841306a43,
                ...getState()[key],
                items: getState()[key]?.items?.filter((alert)=>alert.id !== alertId) ?? []
            }
        });
    };
const $d7740626dfebecb7$export$e324594224ef24da = {
    loadAlerts: $d7740626dfebecb7$var$loadAlerts,
    removeAlert: $d7740626dfebecb7$var$removeAlert
};
const $d7740626dfebecb7$var$alertsStore = (0, $iXqE5.createStore)({
    name: (0, $DWjzc.ALERTS_STORE_NAME),
    actions: $d7740626dfebecb7$export$e324594224ef24da,
    initialState: $d7740626dfebecb7$export$d4c72bab9d6cc13a
});
const $d7740626dfebecb7$export$52a528b1f45cfa42 = (0, $3sQ5x.createHook)($d7740626dfebecb7$var$alertsStore, {
    selector: (state)=>state
});
const $d7740626dfebecb7$export$dac8df4ae2328540 = (0, $gg7kZ.createContainer)($d7740626dfebecb7$var$alertsStore);

});
parcelRegister("DWjzc", function(module, exports) {

$parcel$export(module.exports, "ALERTS_STORE_NAME", () => $44a8ac0f9ca87731$export$6793992c0b67d9c9);
$parcel$export(module.exports, "PredefinedQueries", () => $44a8ac0f9ca87731$export$ed6721f2880ce367);
const $44a8ac0f9ca87731$export$6793992c0b67d9c9 = 'navigation-alerts-store';
const $44a8ac0f9ca87731$var$ONLY_MY_SELECTOR_QUERY = '(acknowledgedBy: me OR owner: me OR responders: me)';
const $44a8ac0f9ca87731$export$ed6721f2880ce367 = {
    MY_OPEN_ALERTS: `status: open AND acknowledged: false AND snoozed: false AND ${$44a8ac0f9ca87731$var$ONLY_MY_SELECTOR_QUERY}`,
    MY_ACKED_ALERTS: `status: open AND acknowledged: true AND ${$44a8ac0f9ca87731$var$ONLY_MY_SELECTOR_QUERY}`,
    MY_SNOOZED_ALERTS: `status: open AND acknowledged: false AND snoozed: true AND ${$44a8ac0f9ca87731$var$ONLY_MY_SELECTOR_QUERY}`
};

});

parcelRegister("aT1mD", function(module, exports) {

$parcel$export(module.exports, "fetchAlerts", () => $523404c6486132da$export$f7b1e2075b3da718);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $g9E9n = parcelRequire("g9E9n");
const $523404c6486132da$export$f7b1e2075b3da718 = async ({ cloudId: cloudId, searchParams: searchParams })=>{
    try {
        const params = new URLSearchParams(searchParams ?? {});
        const result = await (0, $7f4tk.default)(`/gateway/api/jsm/ops/web/${cloudId}/v1/alerts/?${params.toString()}`);
        if (!result) throw Error('Could not retrieve alerts');
        // https://data-portal.internal.atlassian.com/analytics/registry/50237
        (0, $g9E9n.getAnalyticsWebClient)().getInstance().sendOperationalEvent({
            action: 'succeeded',
            actionSubject: 'jiraPlatformServicesAlertsStore.fetchAlerts',
            source: 'alertsStore'
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // https://data-portal.internal.atlassian.com/analytics/registry/50236
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchAlerts',
                packageName: 'jiraAlertsStore',
                teamName: 'alexstrasza'
            },
            attributes: {
                error: error,
                searchParams: searchParams
            },
            error: error
        });
        throw error;
    }
};

});


parcelRegister("e8iSm", function(module, exports) {

$parcel$export(module.exports, "RecentActivityContainer", () => $468ae279ad84e880$export$7143acbf492040ba);
$parcel$export(module.exports, "useRecentActivities", () => $468ae279ad84e880$export$623d449f25492804);
$parcel$export(module.exports, "useRecentActivitiesActions", () => $468ae279ad84e880$export$394af696e502ba5d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $8PtXb = parcelRequire("8PtXb");
const $468ae279ad84e880$var$initialState = {
    items: null,
    fetchError: null,
    hasSuccessOnce: false,
    isFetching: false,
    promise: null
};
const $468ae279ad84e880$var$store = (0, $iXqE5.createStore)({
    actions: $8PtXb.actions,
    initialState: $468ae279ad84e880$var$initialState,
    name: 'navigation-your-work-recent-activites'
});
const $468ae279ad84e880$export$7143acbf492040ba = (0, $gg7kZ.createContainer)($468ae279ad84e880$var$store);
const $468ae279ad84e880$export$623d449f25492804 = (0, $3sQ5x.createHook)($468ae279ad84e880$var$store);
const $468ae279ad84e880$export$394af696e502ba5d = (0, $3sQ5x.createHook)($468ae279ad84e880$var$store, {
    selector: null
});

});
parcelRegister("8PtXb", function(module, exports) {

$parcel$export(module.exports, "actions", () => $b1f4ac60f5b38eb1$export$e324594224ef24da);

var $4R6GH = parcelRequire("4R6GH");
const $b1f4ac60f5b38eb1$var$PRODUCTS = [
    'jira'
];
const $b1f4ac60f5b38eb1$var$loadRecentActivities = ()=>async ({ setState: setState }, meta)=>{
        setState({
            isFetching: true,
            fetchError: null
        });
        try {
            const filter = (0, $4R6GH.fg)('blu-3344-worked-on-menu-fix') ? {
                limit: 10,
                rootContainerIds: [
                    `ari:cloud:platform::site/${meta.cloudId}`
                ],
                products: $b1f4ac60f5b38eb1$var$PRODUCTS
            } : {
                limit: 10,
                rootContainerIds: [
                    `ari:cloud:platform::site/${meta.cloudId}`
                ],
                objectTypes: [
                    'issue'
                ],
                products: $b1f4ac60f5b38eb1$var$PRODUCTS
            };
            const promise = meta.activityClient.fetchActivities([
                50,
                125,
                250
            ], filter, [
                'workedOn'
            ]);
            setState({
                promise: promise
            });
            const activityItems = await promise;
            setState({
                hasSuccessOnce: true,
                items: activityItems,
                isFetching: false
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isFetching: false,
                fetchError: error
            });
        }
    };
const $b1f4ac60f5b38eb1$export$e324594224ef24da = {
    loadRecentActivities: $b1f4ac60f5b38eb1$var$loadRecentActivities
};

});


parcelRegister("bJsBT", function(module, exports) {

$parcel$export(module.exports, "AsyncMenu", () => $6ff062438cc4c15e$export$81adf29ff528dc9c);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $Mp6qH = parcelRequire("Mp6qH");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6ff062438cc4c15e$var$LazyMenu = (0, $b7Svb.lazy)(()=>(parcelRequire("hIehY")).then(({ Menu: Menu })=>Menu), {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/your-work-dropdown/menu/index.tsx"
});
const $6ff062438cc4c15e$export$81adf29ff528dc9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "your-work-dropdown-menu",
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        teamName: "navigation",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "your-work-dropdown-menu",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ff062438cc4c15e$var$LazyMenu, null)));

});
parcelRegister("hIehY", function(module, exports) {

let $ce51a1394f9a4b37$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ce51a1394f9a4b37$var$load("hPzOn"),
    $ce51a1394f9a4b37$var$load("fzehJ")
]).then(()=>parcelRequire('j5yhG'));

});


parcelRegister("fFuPf", function(module, exports) {

$parcel$export(module.exports, "default", () => $29c95956b90fd313$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $29c95956b90fd313$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "atlassian-navigation.your-work-dropdown.title",
        "defaultMessage": "Your work"
    }
});

});


parcelRegister("a5zoF", function(module, exports) {

$parcel$export(module.exports, "Projects", () => $a73319cb81e190a5$export$ca6fbb51b35e375c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $cmzJ2 = parcelRequire("cmzJ2");

var $kklBj = parcelRequire("kklBj");

var $13iNl = parcelRequire("13iNl");

var $kaHBi = parcelRequire("kaHBi");

var $bcn6L = parcelRequire("bcn6L");

var $koVbs = parcelRequire("koVbs");

var $d40Fj = parcelRequire("d40Fj");

var $lmyls = parcelRequire("lmyls");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $apeap = parcelRequire("apeap");

var $hchBL = parcelRequire("hchBL");

var $90yGq = parcelRequire("90yGq");

var $k9JTq = parcelRequire("k9JTq");

var $cZpsT = parcelRequire("cZpsT");

var $DVljb = parcelRequire("DVljb");

var $9OXo1 = parcelRequire("9OXo1");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $fVbkk = parcelRequire("fVbkk");

var $ebYJ0 = parcelRequire("ebYJ0");

var $f7TWB = parcelRequire("f7TWB");

var $b21tm = parcelRequire("b21tm");
const $a73319cb81e190a5$var$ProjectsAnonymous = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const baseUrl = '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        href: `${baseUrl}/jira/projects`,
        menuId: (0, $lmyls.MENU_ID).PROJECTS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROJECTS
    }, formatMessage((0, $b21tm.default).projects));
};
const $a73319cb81e190a5$var$ProjectsLoggedIn = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const locale = (0, $DVljb.useLocale)();
    const accountId = (0, $90yGq.useAccountId)();
    const { cloudId: cloudId, licensedProducts: licensedProducts, firstActivationDateMs: firstActivationDateMs, areProductSuggestionsEnabled: areProductSuggestionsEnabled } = (0, $9OXo1.useTenantContext)();
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const [{ hasFetchedOnce: hasFetchedOnceFavorites }, { loadFavoriteProjects: loadFavorite }] = (0, $bcn6L.useFavoriteProjects)();
    const [, { loadRecentProjects: loadRecent }] = (0, $apeap.useRecentProjects)();
    const [, { loadRecommendations: loadRecommendations }] = (0, $cmzJ2.useProjectMenuRecommendations)();
    const { software: edition } = (0, $k9JTq.useAppEditions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const [{ hasSuccessOnce: hasFetchedCreateProjectPermissions, canCreateProject: canCreateProject }] = (0, $d40Fj.useCreateProjectPermission)();
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROJECTS,
        analyticsSource: 'atlassian-navigation'
    });
    const onBeforeMenuOpen = (0, $5uXOq.useCallback)(()=>{
        onStart();
        (0, $kklBj.projectsMenuDropdownRecommendationSelector).start();
        // refresh recents on open to add recently visited pages
        loadRecent((0, $Mp6qH.DEFAULT_LOAD_COUNT_RECENT));
        if (accountId) {
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown viewed', 'projectsMenuDropdown');
            if (hasFetchedCreateProjectPermissions) loadRecommendations((0, $13iNl.recommendations), {
                locale: locale,
                cloudId: cloudId,
                accountId: accountId,
                licensedProducts: licensedProducts,
                edition: edition,
                firstActivationDateMs: firstActivationDateMs,
                areProductSuggestionsEnabled: areProductSuggestionsEnabled,
                environment: environment,
                canCreateProject: canCreateProject
            }, createAnalyticsEvent({}));
        }
        // load favourites only if not loaded already (optimisation to reduce requests)
        if (!hasFetchedOnceFavorites) loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
    }, [
        onStart,
        loadRecent,
        accountId,
        hasFetchedOnceFavorites,
        loadFavorite,
        createAnalyticsEvent,
        hasFetchedCreateProjectPermissions,
        loadRecommendations,
        locale,
        cloudId,
        licensedProducts,
        edition,
        firstActivationDateMs,
        areProductSuggestionsEnabled,
        environment,
        canCreateProject
    ]);
    const onRef = (0, $5uXOq.useCallback)((ref)=>{
        // We want the last of these nodes, but can spotlight as a fallback any intermediaries
        // It may cause the spotlight border to be bigger than intended (around the entire block element)
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const refToFirstChild = ref && ref.firstChild;
        const refToFirstGrandchild = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refToFirstChild && refToFirstChild.firstChild;
        const refToFirstGreatGrandchild = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refToFirstGrandchild && refToFirstGrandchild.firstChild;
        register(`NAVIGATION_${(0, $lmyls.MENU_ID).PROJECTS}`, refToFirstGreatGrandchild || refToFirstGrandchild || refToFirstChild || ref);
    }, [
        register
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a73319cb81e190a5$export$e6dfd72ab29f8598, {
        ref: onRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebYJ0.Popup), {
        menuId: (0, $lmyls.MENU_ID).PROJECTS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PROJECTS,
        Menu: (0, $f7TWB.Menu),
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $b21tm.default).projects)
    }, formatMessage((0, $b21tm.default).projects)));
};
const $a73319cb81e190a5$var$ProjectWithAuth = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a73319cb81e190a5$var$ProjectsAnonymous, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a73319cb81e190a5$var$ProjectsLoggedIn, null);
};
const $a73319cb81e190a5$export$ca6fbb51b35e375c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).PROJECTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a73319cb81e190a5$var$ProjectWithAuth, null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a73319cb81e190a5$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt _4t3i1osq _ae4v1h6o _11l41osq",
            false && "_1kibidpf _1laeidpf _1f5yidpf _kq8jidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hchBL", function(module, exports) {

$parcel$export(module.exports, "useGlobalRef", () => $b03364e48d8512c5$export$361e4f658203e95);
$parcel$export(module.exports, "useGlobalRefStoreActions", () => $b03364e48d8512c5$export$3c6c6911d09d7d8a);
$parcel$export(module.exports, "withGlobalRef", () => $b03364e48d8512c5$export$6b4b878b04fd3017);

var $5uXOq = parcelRequire("5uXOq");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $b03364e48d8512c5$var$store = (0, $iXqE5.createStore)({
    initialState: {},
    actions: {
        register: (key, ref)=>({ setState: setState })=>{
                setState({
                    [key]: ref || undefined
                });
            }
    },
    name: 'refs-store'
});
const $b03364e48d8512c5$export$4beaa3baa53198e4 = (0, $gg7kZ.createContainer)($b03364e48d8512c5$var$store);
const $b03364e48d8512c5$var$useGlobalRefStateSelector = (0, $3sQ5x.createStateHook)($b03364e48d8512c5$var$store, {
    selector: (state, key)=>state[key]
});
const $b03364e48d8512c5$export$361e4f658203e95 = (key)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        $b03364e48d8512c5$var$useGlobalRefStateSelector(key)
    ];
const $b03364e48d8512c5$export$3c6c6911d09d7d8a = (0, $3sQ5x.createHook)($b03364e48d8512c5$var$store, {
    selector: null
});
const $b03364e48d8512c5$export$6b4b878b04fd3017 = (propName, refName)=>(Component)=>(props)=>{
            const [ref] = $b03364e48d8512c5$export$361e4f658203e95(refName);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                [propName]: ref
            });
        };

});

parcelRegister("f7TWB", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $14a03ca5c167a73f$export$d9b273488cd8ce6f);

var $5uXOq = parcelRequire("5uXOq");

var $70rf1 = parcelRequire("70rf1");

var $Pxnvj = parcelRequire("Pxnvj");

var $13iNl = parcelRequire("13iNl");

var $bEK4U = parcelRequire("bEK4U");

var $kLaXN = parcelRequire("kLaXN");

var $7CMCs = parcelRequire("7CMCs");

var $93jKl = parcelRequire("93jKl");

var $bcn6L = parcelRequire("bcn6L");

var $d40Fj = parcelRequire("d40Fj");

var $lmyls = parcelRequire("lmyls");

var $6cNb0 = parcelRequire("6cNb0");

var $lfTZh = parcelRequire("lfTZh");

var $Mp6qH = parcelRequire("Mp6qH");

var $8vzcp = parcelRequire("8vzcp");

var $ag3sS = parcelRequire("ag3sS");

var $9TMfX = parcelRequire("9TMfX");

var $6WLja = parcelRequire("6WLja");

var $2KGAL = parcelRequire("2KGAL");

var $1xLtH = parcelRequire("1xLtH");

var $4nCpW = parcelRequire("4nCpW");

var $4ci63 = parcelRequire("4ci63");

var $i4bJa = parcelRequire("i4bJa");
const $14a03ca5c167a73f$var$EVENT_DATA = {
    id: (0, $lmyls.MENU_ID).PROJECTS
};
const $14a03ca5c167a73f$export$d9b273488cd8ce6f = ({ AuthenticationErrorBoundary: AuthenticationErrorBoundary = (0, $kLaXN.AuthenticationErrorBoundary), Empty: Empty = (0, $2KGAL.Empty), Error: Error = (0, $8vzcp.MenuError), FavoriteContent: FavoriteContent = (0, $1xLtH.FavoriteContent), Footer: Footer = (0, $4nCpW.Footer), JSErrorBoundary: JSErrorBoundary = (0, $7CMCs.JSErrorBoundary), Layout: Layout = (0, $ag3sS.MenuLayout), LoadStatus: LoadStatus = (0, $4ci63.LoadStatus), RecentContent: RecentContent = (0, $i4bJa.RecentContent), RecommendationSelector: RecommendationSelector = (0, $bEK4U.RecommendationSelector), recommendations: recommendations = (0, $13iNl.recommendations), Section: Section = (0, $70rf1.default), SkeletonContent: SkeletonContent = (0, $9TMfX.MenuSkeletonContent), SkeletonFooter: SkeletonFooter = (0, $6WLja.MenuSkeletonFooter), SpotlightTarget: SpotlightTarget = (0, $Pxnvj.default), testIdPrefix: testIdPrefix, useCreateProjectPermission: // @ts-expect-error - TS2322 - Type 'HookFunction<State, BoundActions<State, { readonly fetchCreateProjectPermission: (baseUrl: string) => Action<State, void, void | Promise<void>>; }>, void>' is not assignable to type 'UseCreateProjectPermissionType'.
useCreateProjectPermission = (0, $d40Fj.useCreateProjectPermission), useExperienceFail: useExperienceFail = (0, $93jKl.useExperienceFail), useFavorite: useFavorite = (0, $bcn6L.useFavoriteProjects) })=>{
    const [, { loadFavoriteProjects: loadFavorite }] = useFavorite();
    const [{ hasFetchedOnce: hasFetchedOncePermissions, isFetching: isFetching }, { fetchCreateProjectPermission: fetchCreateProjectPermission }] = useCreateProjectPermission();
    const onFail = useExperienceFail({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $5uXOq.useEffect)(()=>()=>{
            // Refresh favourites on close to update if user has toggled any item
            loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
        }, [
        loadFavorite
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasFetchedOncePermissions && !isFetching) fetchCreateProjectPermission();
    }, [
        hasFetchedOncePermissions,
        isFetching,
        fetchCreateProjectPermission
    ]);
    const testIdContent = (0, $6cNb0.testIdConcat)(testIdPrefix, 'content');
    const testIdFooter = (0, $6cNb0.testIdConcat)(testIdPrefix, 'footer');
    const errorFallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Error, {
            testIdPrefix: testIdContent
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        testIdContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SpotlightTarget, {
        name: (0, $Mp6qH.PROJECTS_SPOTLIGHT_KEY)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Layout, {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        isScrollable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JSErrorBoundary, {
        id: (0, $lmyls.MENU_ID).PROJECTS,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: errorFallback,
        withExperienceTracker: true,
        extraEventData: $14a03ca5c167a73f$var$EVENT_DATA,
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AuthenticationErrorBoundary, {
        render: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Empty, {
        testIdPrefix: testIdContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "filters",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonContent, {
            testIdPrefix: testIdContent
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatus, {
        shouldThrowError: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FavoriteContent, {
        testIdPrefix: testIdContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RecentContent, {
        testIdPrefix: testIdContent
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RecommendationSelector, {
        recommendations: recommendations
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "footer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonFooter, {
            testIdPrefix: testIdFooter
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatus, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Footer, {
        testIdPrefix: testIdFooter
    })))));
};

});
parcelRegister("bEK4U", function(module, exports) {

$parcel$export(module.exports, "RecommendationSelector", () => $3c478d901993099b$export$f97cd4c3e697ffee);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $luvXZ = parcelRequire("luvXZ");

var $cmzJ2 = parcelRequire("cmzJ2");

var $kklBj = parcelRequire("kklBj");
const $3c478d901993099b$export$f97cd4c3e697ffee = ({ recommendations: recommendations })=>{
    const [state] = (0, $cmzJ2.useProjectMenuRecommendations)();
    if (state.status !== 'success') return null;
    const selectedRecommendation = recommendations.find((recommendation)=>recommendation.key === state.recommendationKey);
    return selectedRecommendation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: `projects-menu-recommendation.${selectedRecommendation.key}`,
        packageName: "jiraAtlassianNavigationRecommendations",
        onError: ()=>(0, $kklBj.projectsMenuDropdownRecommendationSelector).failure(),
        fallback: "unmount",
        teamName: "navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            recommendationKey: selectedRecommendation.key
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luvXZ.ExperienceSuccess), {
        experience: (0, $kklBj.projectsMenuDropdownRecommendationSelector)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(selectedRecommendation.Component, null))) : null;
};

});

parcelRegister("kLaXN", function(module, exports) {

$parcel$export(module.exports, "AuthenticationErrorBoundary", () => $2792454dc55144b9$export$124b2dc1d1aab5e6);

var $5uXOq = parcelRequire("5uXOq");

var $fPruT = parcelRequire("fPruT");
class $2792454dc55144b9$export$124b2dc1d1aab5e6 extends (0, $5uXOq.Component) {
    componentDidCatch(error, info) {
        if (error instanceof (0, $fPruT.AuthenticationError)) {
            this.setState({
                caughtError: {
                    error: error,
                    info: info
                }
            });
            return;
        }
        throw error;
    }
    render() {
        const { caughtError: caughtError } = this.state;
        const { children: children, render: renderFallback } = this.props;
        if (!caughtError) return children;
        return renderFallback();
    }
    constructor(...args){
        super(...args), this.state = {
            caughtError: null
        };
    }
}

});

parcelRegister("2KGAL", function(module, exports) {

$parcel$export(module.exports, "Empty", () => $bae626c9288cadc7$export$1f74963c34e8bfec);

var $5uXOq = parcelRequire("5uXOq");

var $6eFvr = parcelRequire("6eFvr");

var $3bQtK = parcelRequire("3bQtK");

var $bcn6L = parcelRequire("bcn6L");

var $aWse0 = parcelRequire("aWse0");

var $6cNb0 = parcelRequire("6cNb0");

var $apeap = parcelRequire("apeap");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $jyltl = parcelRequire("jyltl");

var $dMJS0 = parcelRequire("dMJS0");

var $5cgeH = parcelRequire("5cgeH");

var $RQqjE = parcelRequire("RQqjE");
const $bae626c9288cadc7$var$learnMoreHref = 'https://confluence.atlassian.com/adminjiracloud/creating-editing-deleting-and-hiding-projects-844500729.html';
const $bae626c9288cadc7$export$1f74963c34e8bfec = ({ MenuInfo: MenuInfo = (0, $jyltl.MenuInfo), children: children, testIdPrefix: testIdPrefix, useExperienceSuccess: useExperienceSuccess = (0, $3bQtK.useExperienceSuccess), useFavorite: useFavorite = (0, $bcn6L.useFavoriteProjects), useIntl: useIntl = (0, $aWse0.useIntlV2), useIsAnonymous: useIsAnonymous = (0, $cZpsT.useIsAnonymous), useItems: useItems = (0, $dMJS0.useProjectNavItems), useRecent: useRecent = (0, $apeap.useRecentProjects) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const isAnonymous = useIsAnonymous();
    const onSuccess = useExperienceSuccess({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    const text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        as: "p"
    }, formatMessage((0, $RQqjE.default).emptyText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: $bae626c9288cadc7$var$learnMoreHref,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $RQqjE.default).learnMore))));
    const [{ isFetching: isFetchingFavorite, hasSuccessOnce: hasSuccessOnceFavorite, fetchError: fetchErrorFavorite }] = useFavorite();
    const [{ isFetching: isFetchingRecent, hasSuccessOnce: hasSuccessOnceRecent, fetchError: fetchErrorRecent }] = useRecent();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = useItems();
    const notEmpty = favoriteItems.length || //  should show fav items
    recentItems.length || // should show recent items
    isFetchingFavorite && !hasSuccessOnceFavorite || // should show fav skeleton
    isFetchingRecent && !hasSuccessOnceRecent || // should show recent skeleton
    fetchErrorFavorite || // should show error
    fetchErrorRecent; // should show error
    // it appears that when fetch error get thrown in loadstatus, the promise is still pending here
    // let's take the most simple approach for now
    const shouldShowEmptyForAnonymous = isAnonymous;
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'empty');
    (0, $5uXOq.useEffect)(()=>{
        const isSuccess = hasSuccessOnceFavorite && hasSuccessOnceRecent;
        if (isSuccess) onSuccess();
    }, [
        hasSuccessOnceFavorite,
        hasSuccessOnceRecent,
        onSuccess
    ]);
    return notEmpty && !shouldShowEmptyForAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuInfo, {
        imgAltText: formatMessage((0, $RQqjE.default).emptyImg),
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($5cgeH))),
        imgHeight: 138,
        testId: testId,
        text: text
    });
};

});
parcelRegister("5cgeH", function(module, exports) {
module.exports = new URL("project-empty.0864e274.svg", import.meta.url).toString();

});

parcelRegister("RQqjE", function(module, exports) {

$parcel$export(module.exports, "default", () => $15aec9727c6dd925$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $15aec9727c6dd925$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyText: {
        "id": "atlassian-navigation.projects.menu.empty.empty-text",
        "defaultMessage": "Make the most of your Atlassian products by extending them with projects."
    },
    learnMore: {
        "id": "atlassian-navigation.projects.menu.empty.learn-more",
        "defaultMessage": "Learn more"
    },
    emptyImg: {
        "id": "atlassian-navigation.projects.menu.empty.empty-img",
        "defaultMessage": "An image showing that the projects dropdown menu is empty"
    }
});

});


parcelRegister("1xLtH", function(module, exports) {

$parcel$export(module.exports, "FavoriteContent", () => $e1a4963a7cc4d825$export$297af018011b145a);

var $5uXOq = parcelRequire("5uXOq");

var $ew55A = parcelRequire("ew55A");

var $d6a7c = parcelRequire("d6a7c");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $4R6GH = parcelRequire("4R6GH");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $56fXm = parcelRequire("56fXm");

var $dMJS0 = parcelRequire("dMJS0");

var $Yyrw8 = parcelRequire("Yyrw8");
const $e1a4963a7cc4d825$export$297af018011b145a = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.useProjectNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>favoriteItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)), [
        favoriteItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-starred');
    const projectsUrl = '/jira/projects?page=1&sortKey=favourite&sortOrder=DESC';
    return favoriteItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6a7c.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $Yyrw8.default).starred)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, metadata: metadata, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { params: params, query: query, route: to } = (0, $2EqxS.getLinkFromProject)(item);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
            key: id,
            ariaLabel: formatMessage((0, $Yyrw8.default).starred)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'projectsNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'starred',
                position: idx,
                starred: Boolean(isFavourite)
            },
            description: metadata,
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew55A.default), {
                appearance: "square",
                size: "small",
                borderColor: "transparent",
                src: item.avatarUrl
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "starred",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.PROJECTS_ITEM_TYPE)
            }),
            params: params,
            query: query,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            to: to,
            "aria-label": (0, $4R6GH.fg)('blu-6205_misc_nav3_a11y_fixes') ? `${title} ${metadata || ''}` : undefined
        }, title));
    })), favoriteItems.length >= (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $56fXm.MenuItemViewAll), {
        analytics: {
            actionSubjectId: 'projectsNavigationMenuItem',
            menuItemId: 'viewAll',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            position: (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)
        },
        href: projectsUrl,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: projectsUrl
    })) : null;
};

});
parcelRegister("Yyrw8", function(module, exports) {

$parcel$export(module.exports, "default", () => $826ed05c79892831$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $826ed05c79892831$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    starred: {
        "id": "atlassian-navigation.projects.menu.favorite-content.starred",
        "defaultMessage": "Starred"
    }
});

});


parcelRegister("4nCpW", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $feb4a5abece4d737$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $d40Fj = parcelRequire("d40Fj");

var $6cNb0 = parcelRequire("6cNb0");

var $foR3E = parcelRequire("foR3E");

var $e9QkH = parcelRequire("e9QkH");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $d4B4Y = parcelRequire("d4B4Y");

var $kdlJi = parcelRequire("kdlJi");
const $feb4a5abece4d737$export$a06f1c675e846f6f = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const [, { on: openProjectCreateDrawer }] = (0, $e9QkH.useSwitchModals)((0, $Mp6qH.MODAL_ID).PROJECT_CREATE);
    const [{ canCreateProject: canCreateProject }] = (0, $d40Fj.useCreateProjectPermission)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'projectsNavigationMenuItem',
            menuItemId: 'viewAll',
            menuItemType: 'action',
            position: 0
        },
        href: "/jira/projects",
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: (0, $foR3E.projectsDirectoryRoute)
    }, formatMessage((0, $kdlJi.default).viewAll)), !isAnonymous && canCreateProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'projectsNavigationMenuItem',
            menuItemId: 'create',
            menuItemType: 'action',
            position: 1
        },
        onClick: openProjectCreateDrawer,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-create')
    }, formatMessage((0, $kdlJi.default).createProject)));
};

});
parcelRegister("kdlJi", function(module, exports) {

$parcel$export(module.exports, "default", () => $54e62ef08eaa20a3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $54e62ef08eaa20a3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createProject: {
        "id": "atlassian-navigation.projects.menu.footer.create-project",
        "defaultMessage": "Create project"
    },
    viewAll: {
        "id": "atlassian-navigation.projects.menu.footer.view-all",
        "defaultMessage": "View all projects"
    },
    importProject: {
        "id": "atlassian-navigation.projects.menu.footer.import-project",
        "defaultMessage": "Import project"
    }
});

});


parcelRegister("4ci63", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $0e36b7ec65a0b373$export$c7df4a3f1b89de01);

var $5uXOq = parcelRequire("5uXOq");

var $2N6bN = parcelRequire("2N6bN");

var $bcn6L = parcelRequire("bcn6L");

var $d40Fj = parcelRequire("d40Fj");

var $apeap = parcelRequire("apeap");

var $dHtVS = parcelRequire("dHtVS");
const $0e36b7ec65a0b373$export$c7df4a3f1b89de01 = ({ LoadStatusCommon: LoadStatusCommon = (0, $dHtVS.LoadStatus), shouldThrowError: shouldThrowError = false, useCreateProjectPermission: // @ts-expect-error - TS2322 - Type 'HookFunction<State, BoundActions<State, { readonly fetchCreateProjectPermission: (baseUrl: string) => Action<State, void, void | Promise<void>>; }>, void>' is not assignable to type 'UseCreateProjectPermissionType'.
useCreateProjectPermission = (0, $d40Fj.useCreateProjectPermission), useFavorite: useFavorite = (0, $bcn6L.useFavoriteProjects), useRecent: useRecent = (0, $apeap.useRecentProjects) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useCreateProjectPermission
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useFavorite
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useRecent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatusCommon, {
        shouldThrowError: false,
        useProvider: (0, $2N6bN.usePersonalizationProvider)
    }));

});
parcelRegister("2N6bN", function(module, exports) {

$parcel$export(module.exports, "usePersonalizationProvider", () => $5d7e4157825488be$export$816e978a144775ee);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $f9blZ = parcelRequire("f9blZ");
const $5d7e4157825488be$var$store = (0, $iXqE5.createStore)({
    name: 'create-project-permissions',
    initialState: {
        traits: [],
        siteTraits: [],
        isFetching: false,
        fetchError: null,
        promise: null,
        hasFetchedOnce: false,
        hasSuccessOnce: false
    },
    actions: $f9blZ.actions
});
const $5d7e4157825488be$export$816e978a144775ee = (0, $3sQ5x.createHook)($5d7e4157825488be$var$store);

});
parcelRegister("f9blZ", function(module, exports) {

$parcel$export(module.exports, "actions", () => $3a9df0465aab2f9e$export$e324594224ef24da);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

const $3a9df0465aab2f9e$var$performGetRequestForTraits = async (url)=>{
    try {
        const response = await (0, $eusud.performGetRequest)(url);
        if (response?.attributes) return {
            data: response.attributes,
            error: null
        };
        throw Error('response is not defined or null');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'jwmSampleProjectService',
                packageName: (0, $fb261d53ea98c20e$export$b8b9d90f9e5bd72b),
                teamName: 'jira-werewolves'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            data: [],
            error: error
        };
    }
};
const $3a9df0465aab2f9e$export$820a550ad3fb8364 = (cloudId, atlassianAccountId)=>async ({ setState: setState, getState: getState })=>{
        const { isFetching: isFetching } = getState();
        if (!isFetching) {
            setState({
                isFetching: true,
                fetchError: null
            });
            const siteTraitUrl = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
            const siteUserTraitUrl = `${siteTraitUrl}/user/${atlassianAccountId}`;
            const [{ data: listofSiteUserTraits, error: errorOnSiteUser }, { data: listofSiteTraits, error: errorOnSite }] = await Promise.all([
                $3a9df0465aab2f9e$var$performGetRequestForTraits(siteUserTraitUrl),
                $3a9df0465aab2f9e$var$performGetRequestForTraits(siteTraitUrl)
            ]);
            const errors = errorOnSiteUser || errorOnSite;
            setState({
                traits: listofSiteUserTraits,
                siteTraits: listofSiteTraits,
                isFetching: false,
                fetchError: errors,
                hasFetchedOnce: true,
                ...errors ? {} : {
                    hasSuccessOnce: true
                }
            });
        }
    };
const $3a9df0465aab2f9e$export$e324594224ef24da = {
    fetchTraits: (cloudId, atlassianAccountId)=>async ({ setState: setState, dispatch: dispatch })=>{
            const promise = dispatch($3a9df0465aab2f9e$export$820a550ad3fb8364(cloudId, atlassianAccountId));
            setState({
                isFetching: true,
                promise: promise
            });
        }
};

});
const $fb261d53ea98c20e$export$b8b9d90f9e5bd72b = 'jira-business.sample-project';
const $fb261d53ea98c20e$export$529244c5c5612bf2 = 'jwmSampleProjectCreateFailure';
const $fb261d53ea98c20e$export$fc53f723f5163588 = 'jira_software_ui_moon_experiment_create_jwm_sample_experiment_project_created_first';
const $fb261d53ea98c20e$export$ce71307e913afd12 = 'jira-core_business_project_created_first';
const $fb261d53ea98c20e$export$142f18c04fa33074 = 'export-issues-xflow-modal';
const $fb261d53ea98c20e$export$2667e34461b211df = 'invite-business-teams-modal';
const $fb261d53ea98c20e$export$63fbd2796586b8eb = 'projects-menu-existing-users';
const $fb261d53ea98c20e$export$d25895a47354c866 = 'projects-menu-new-users';
const $fb261d53ea98c20e$export$b807b84bb648264b = 'onboarding-checklist';
const $fb261d53ea98c20e$export$bf3fe75eb774ca83 = 'projects-jwm-empty-list';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $fb261d53ea98c20e$var$ISSUE_LINKS_ON_JSW_BOARD_CARDS = 'issue-links-on-jsw-board-cards';




parcelRegister("i4bJa", function(module, exports) {

$parcel$export(module.exports, "RecentContent", () => $dd89c0b17853b373$export$a2873dc4e96d8e90);

var $5uXOq = parcelRequire("5uXOq");

var $ew55A = parcelRequire("ew55A");

var $d6a7c = parcelRequire("d6a7c");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $4R6GH = parcelRequire("4R6GH");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $dMJS0 = parcelRequire("dMJS0");

var $9uulb = parcelRequire("9uulb");
const $dd89c0b17853b373$export$a2873dc4e96d8e90 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { recentItems: recentItems, favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.useProjectNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>recentItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_RECENT)), [
        recentItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-recent');
    return recentItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6a7c.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $9uulb.default).recent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, metadata: metadata, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { id: beforeEntityId, type: beforeEntityType } = (0, $2EqxS.getBeforeEntity)(favoriteItems);
        const { params: params, query: query, route: to } = (0, $2EqxS.getLinkFromProject)(item);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
            key: id,
            ariaLabel: formatMessage((0, $9uulb.default).recent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'projectsNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'recent',
                position: idx,
                starred: Boolean(isFavourite)
            },
            description: metadata,
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew55A.default), {
                appearance: "square",
                size: "small",
                borderColor: "transparent",
                src: item.avatarUrl
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                beforeEntityId: beforeEntityId,
                beforeEntityType: beforeEntityType,
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "recent",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.PROJECTS_ITEM_TYPE)
            }),
            params: params,
            query: query,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            to: to,
            "aria-label": (0, $4R6GH.fg)('blu-6205_misc_nav3_a11y_fixes') ? `${title} ${metadata || ''}` : undefined
        }, title));
    }))) : null;
};

});
parcelRegister("9uulb", function(module, exports) {

$parcel$export(module.exports, "default", () => $58ba7fa57975d970$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $58ba7fa57975d970$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "atlassian-navigation.projects.menu.recent-content.recent",
        "defaultMessage": "Recent"
    }
});

});



parcelRegister("b21tm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d7261af77ace424$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7d7261af77ace424$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projects: {
        "id": "atlassian-navigation.projects.projects",
        "defaultMessage": "Projects"
    }
});

});


parcelRegister("jSplz", function(module, exports) {

$parcel$export(module.exports, "Filters", () => $05595fb4c275b9c8$export$92a576f896a9bf72);

var $5uXOq = parcelRequire("5uXOq");

var $kaHBi = parcelRequire("kaHBi");

var $bcn6L = parcelRequire("bcn6L");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $apeap = parcelRequire("apeap");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $fVbkk = parcelRequire("fVbkk");

var $4XiFK = parcelRequire("4XiFK");

var $ebYJ0 = parcelRequire("ebYJ0");

var $kawVZ = parcelRequire("kawVZ");

var $7ikvo = parcelRequire("7ikvo");
const $05595fb4c275b9c8$var$FiltersAnonymous = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        href: "/jira/filters?searchName=&Search=Search&filterView=search",
        menuId: (0, $lmyls.MENU_ID).FILTERS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).FILTERS
    }, formatMessage((0, $7ikvo.default).filters));
};
const $05595fb4c275b9c8$var$FiltersLoggedIn = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ hasFetchedOnce: hasFetchedOnceFavorites }, { loadFavoriteFilters: loadFavorite }] = (0, $bcn6L.useFavoriteFilters)();
    const [, { loadRecentFilters: loadRecent }] = (0, $apeap.useRecentFilters)();
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).FILTERS,
        analyticsSource: 'atlassian-navigation'
    });
    const onBeforeMenuOpen = (0, $5uXOq.useCallback)(()=>{
        onStart();
        // refresh recents on open to add recently visited pages
        loadRecent((0, $Mp6qH.DEFAULT_LOAD_COUNT_RECENT));
        // load favourites only if not loaded already (optimisation to reduce requests)
        if (!hasFetchedOnceFavorites) loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
    }, [
        hasFetchedOnceFavorites,
        loadFavorite,
        loadRecent,
        onStart
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XiFK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebYJ0.Popup), {
        menuId: (0, $lmyls.MENU_ID).FILTERS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).FILTERS,
        Menu: (0, $kawVZ.Menu),
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $7ikvo.default).filters)
    }, formatMessage((0, $7ikvo.default).filters)));
};
const $05595fb4c275b9c8$var$FiltersWithAuth = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($05595fb4c275b9c8$var$FiltersAnonymous, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($05595fb4c275b9c8$var$FiltersLoggedIn, null);
};
const $05595fb4c275b9c8$export$92a576f896a9bf72 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).FILTERS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($05595fb4c275b9c8$var$FiltersWithAuth, null));

});
parcelRegister("kawVZ", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $37b6403ac89429a0$export$d9b273488cd8ce6f);

var $5uXOq = parcelRequire("5uXOq");

var $70rf1 = parcelRequire("70rf1");

var $kLaXN = parcelRequire("kLaXN");

var $7CMCs = parcelRequire("7CMCs");

var $93jKl = parcelRequire("93jKl");

var $bcn6L = parcelRequire("bcn6L");

var $lmyls = parcelRequire("lmyls");

var $6cNb0 = parcelRequire("6cNb0");

var $lfTZh = parcelRequire("lfTZh");

var $Mp6qH = parcelRequire("Mp6qH");

var $8vzcp = parcelRequire("8vzcp");

var $ag3sS = parcelRequire("ag3sS");

var $9TMfX = parcelRequire("9TMfX");

var $6WLja = parcelRequire("6WLja");

var $aC6ao = parcelRequire("aC6ao");

var $bBBg3 = parcelRequire("bBBg3");

var $7xt41 = parcelRequire("7xt41");

var $1Q2KE = parcelRequire("1Q2KE");

var $lQ0sa = parcelRequire("lQ0sa");
const $37b6403ac89429a0$var$EVENT_DATA = {
    id: (0, $lmyls.MENU_ID).FILTERS
};
const $37b6403ac89429a0$export$d9b273488cd8ce6f = ({ AuthenticationErrorBoundary: AuthenticationErrorBoundary = (0, $kLaXN.AuthenticationErrorBoundary), Empty: Empty = (0, $aC6ao.Empty), Error: Error = (0, $8vzcp.MenuError), FavoriteContent: FavoriteContent = (0, $bBBg3.FavoriteContent), Footer: Footer = (0, $7xt41.Footer), JSErrorBoundary: JSErrorBoundary = (0, $7CMCs.JSErrorBoundary), Layout: Layout = (0, $ag3sS.MenuLayout), LoadStatus: LoadStatus = (0, $1Q2KE.LoadStatus), RecentContent: RecentContent = (0, $lQ0sa.RecentContent), Section: Section = (0, $70rf1.default), SkeletonContent: SkeletonContent = (0, $9TMfX.MenuSkeletonContent), SkeletonFooter: SkeletonFooter = (0, $6WLja.MenuSkeletonFooter), testIdPrefix: testIdPrefix, useExperienceFail: useExperienceFail = (0, $93jKl.useExperienceFail), useFavorite: useFavorite = (0, $bcn6L.useFavoriteFilters) })=>{
    const [, { loadFavoriteFilters: loadFavorite }] = useFavorite();
    const onFail = useExperienceFail({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $5uXOq.useEffect)(()=>()=>{
            // Refresh favourites on close to update if user has toggled any item
            loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
        }, [
        loadFavorite
    ]);
    const testIdContent = (0, $6cNb0.testIdConcat)(testIdPrefix, 'content');
    const testIdFooter = (0, $6cNb0.testIdConcat)(testIdPrefix, 'footer');
    const errorFallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Error, {
            testIdPrefix: testIdContent
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        testIdContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Layout, {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        isScrollable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JSErrorBoundary, {
        id: (0, $lmyls.MENU_ID).FILTERS,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: errorFallback,
        withExperienceTracker: true,
        extraEventData: $37b6403ac89429a0$var$EVENT_DATA,
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AuthenticationErrorBoundary, {
        render: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Empty, {
        testIdPrefix: testIdContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "atlassian-navigation-filters-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonContent, {
            testIdPrefix: testIdContent
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatus, {
        shouldThrowError: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FavoriteContent, {
        testIdPrefix: testIdContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RecentContent, {
        testIdPrefix: testIdContent
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "atlassian-navigation-filters-footer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonFooter, {
            testIdPrefix: testIdFooter
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatus, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Footer, {
        testIdPrefix: testIdFooter
    }))));
};

});
parcelRegister("aC6ao", function(module, exports) {

$parcel$export(module.exports, "Empty", () => $c74c3409b5a3434a$export$1f74963c34e8bfec);

var $5uXOq = parcelRequire("5uXOq");

var $6eFvr = parcelRequire("6eFvr");

var $3bQtK = parcelRequire("3bQtK");

var $bcn6L = parcelRequire("bcn6L");

var $4R6GH = parcelRequire("4R6GH");

var $aWse0 = parcelRequire("aWse0");

var $6cNb0 = parcelRequire("6cNb0");

var $apeap = parcelRequire("apeap");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $jyltl = parcelRequire("jyltl");

var $dMJS0 = parcelRequire("dMJS0");

var $jbyOm = parcelRequire("jbyOm");

var $dODGv = parcelRequire("dODGv");
const $c74c3409b5a3434a$var$learnMoreHref = 'https://confluence.atlassian.com/jirasoftwarecloud/searching-for-issues-764478280.html#Searchingforissues-SearchallofJira';
const $c74c3409b5a3434a$export$1f74963c34e8bfec = ({ MenuInfo: MenuInfo = (0, $jyltl.MenuInfo), children: children, testIdPrefix: testIdPrefix, useExperienceSuccess: useExperienceSuccess = (0, $3bQtK.useExperienceSuccess), useFavorite: useFavorite = (0, $bcn6L.useFavoriteFilters), useIntl: useIntl = (0, $aWse0.useIntlV2), useIsAnonymous: useIsAnonymous = (0, $cZpsT.useIsAnonymous), useItems: useItems = (0, $dMJS0.useFilterNavItems), useRecent: useRecent = (0, $apeap.useRecentFilters) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const isAnonymous = useIsAnonymous();
    const onSuccess = useExperienceSuccess({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    const text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        as: "p"
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $dODGv.default).emptyTextIssueTermRefresh : (0, $dODGv.default).emptyText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: $c74c3409b5a3434a$var$learnMoreHref,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $dODGv.default).learnMore))));
    const [{ isFetching: isFetchingFavorite, hasSuccessOnce: hasSuccessOnceFavorite, fetchError: fetchErrorFavorite }] = useFavorite();
    const [{ isFetching: isFetchingRecent, hasSuccessOnce: hasSuccessOnceRecent, fetchError: fetchErrorRecent }] = useRecent();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = useItems();
    const notEmpty = favoriteItems.length || //  should show fav items
    recentItems.length || // should show recent items
    isFetchingFavorite && !hasSuccessOnceFavorite || // should show fav skeleton
    isFetchingRecent && !hasSuccessOnceRecent || // should show recent skeleton
    fetchErrorFavorite || // should show error
    fetchErrorRecent; // should show error
    const shouldShowEmptyForAnonymous = isAnonymous;
    (0, $5uXOq.useEffect)(()=>{
        const isSuccess = hasSuccessOnceFavorite && hasSuccessOnceRecent;
        if (isSuccess) onSuccess();
    }, [
        hasSuccessOnceFavorite,
        hasSuccessOnceRecent,
        onSuccess
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'empty');
    return notEmpty && !shouldShowEmptyForAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuInfo, {
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($jbyOm))),
        testId: testId,
        text: text
    });
};

});
parcelRegister("jbyOm", function(module, exports) {
module.exports = new URL("filter-empty.4c92f05b.svg", import.meta.url).toString();

});

parcelRegister("dODGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $56a795574a4eb398$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $56a795574a4eb398$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyText: {
        "id": "atlassian-navigation.filters.menu.empty.empty-text",
        "defaultMessage": "Search for issues across all projects and save them as filters."
    },
    learnMore: {
        "id": "atlassian-navigation.filters.menu.empty.learn-more",
        "defaultMessage": "Learn more"
    },
    emptyImg: {
        "id": "atlassian-navigation.filters.menu.empty.empty-img",
        "defaultMessage": "An image showing that the apps dropdown menu is empty"
    },
    emptyTextIssueTermRefresh: {
        "id": "atlassian-navigation.filters.menu.empty.empty-text-issue-term-refresh",
        "defaultMessage": "Search for work items across all projects and save them as filters."
    }
});

});


parcelRegister("bBBg3", function(module, exports) {

$parcel$export(module.exports, "FavoriteContent", () => $e72dd94e33471bbd$export$297af018011b145a);

var $5uXOq = parcelRequire("5uXOq");

var $8nT7B = parcelRequire("8nT7B");

var $d6a7c = parcelRequire("d6a7c");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $4zlUA = parcelRequire("4zlUA");

var $6cNb0 = parcelRequire("6cNb0");

var $f4La7 = parcelRequire("f4La7");

var $4R6GH = parcelRequire("4R6GH");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $56fXm = parcelRequire("56fXm");

var $dMJS0 = parcelRequire("dMJS0");

var $31jbO = parcelRequire("31jbO");
const $e72dd94e33471bbd$export$297af018011b145a = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.useFilterNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>favoriteItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)), [
        favoriteItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-starred');
    const filtersUrl = '/jira/filters?page=1&sortKey=favourite&sortOrder=DESC';
    return favoriteItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6a7c.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $31jbO.default).starred)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const filterParams = {
            issueKey: ''
        };
        const filterQuery = {
            filter: String(id)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
            key: id,
            ariaLabel: formatMessage((0, $31jbO.default).starred)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'filtersNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'starred',
                position: idx,
                starred: Boolean(isFavourite)
            },
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8nT7B))), {
                spacing: "spacious",
                label: ""
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "starred",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.FILTERS_ITEM_TYPE)
            }),
            params: filterParams,
            query: filterQuery,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            to: (0, $f4La7.globalIssueNavigatorRoute),
            onClick: (0, $4zlUA.handleGinSPAClick),
            "aria-label": (0, $4R6GH.fg)('blu-6205_misc_nav3_a11y_fixes') ? title : undefined
        }, title));
    })), favoriteItems.length >= (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $56fXm.MenuItemViewAll), {
        analytics: {
            actionSubjectId: 'filtersNavigationMenuItem',
            menuItemId: 'viewAll',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            position: (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)
        },
        href: filtersUrl,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: filtersUrl
    })) : null;
};

});
parcelRegister("f4La7", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorRoute", () => $4d3f2b1accc05e7a$export$f4c8e8bc55cd2008);
const $4d3f2b1accc05e7a$export$f4c8e8bc55cd2008 = {
    name: 'legacy-gin',
    path: '/issues/:issueKey(.*)?'
};

});

parcelRegister("31jbO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1350230aaed398a9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1350230aaed398a9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    starred: {
        "id": "atlassian-navigation.filters.menu.favorite-content.starred",
        "defaultMessage": "Starred"
    }
});

});


parcelRegister("7xt41", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $8201760f444f9d16$export$a06f1c675e846f6f);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $b6S3k = parcelRequire("b6S3k");

var $d4B4Y = parcelRequire("d4B4Y");

var $aXYEG = parcelRequire("aXYEG");
// Removes the bullet (•) and padding from <li>
const $8201760f444f9d16$var$filterUnorderedList = null;
const $8201760f444f9d16$export$a06f1c675e846f6f = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items');
    return (0, $4R6GH.fg)('camptasks-1105-filter-menu-list-markup') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'filtersNavigationMenuItem',
            menuItemId: 'viewAll',
            menuItemType: 'action',
            position: 0
        },
        href: "/jira/filters?searchName=&Search=Search&filterView=search",
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: (0, $b6S3k.filtersDirectoryRoute)
    }, formatMessage((0, $aXYEG.default).viewAll))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'filtersNavigationMenuItem',
            menuItemId: 'create',
            menuItemType: 'action',
            position: 1
        },
        href: `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-create')
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $aXYEG.default).viewAllIssuesIssueTermRefresh : (0, $aXYEG.default).viewAllIssues)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'filtersNavigationMenuItem',
            menuItemId: 'viewAll',
            menuItemType: 'action',
            position: 0
        },
        href: "/jira/filters?searchName=&Search=Search&filterView=search",
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: (0, $b6S3k.filtersDirectoryRoute)
    }, formatMessage((0, $aXYEG.default).viewAll)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'filtersNavigationMenuItem',
            menuItemId: 'create',
            menuItemType: 'action',
            position: 1
        },
        href: `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-create')
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $aXYEG.default).viewAllIssuesIssueTermRefresh : (0, $aXYEG.default).viewAllIssues)));
};

});
parcelRegister("aXYEG", function(module, exports) {

$parcel$export(module.exports, "default", () => $04b207ae58b19dda$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $04b207ae58b19dda$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAllIssues: {
        "id": "atlassian-navigation.filters.menu.footer.view-all-issues",
        "defaultMessage": "View all issues"
    },
    viewAll: {
        "id": "atlassian-navigation.filters.menu.footer.view-all",
        "defaultMessage": "View all filters"
    },
    viewAllIssuesIssueTermRefresh: {
        "id": "atlassian-navigation.filters.menu.footer.view-all-issues-issue-term-refresh",
        "defaultMessage": "View all work items"
    }
});

});


parcelRegister("1Q2KE", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $5044ac4fa9b31340$export$c7df4a3f1b89de01);

var $5uXOq = parcelRequire("5uXOq");

var $bcn6L = parcelRequire("bcn6L");

var $apeap = parcelRequire("apeap");

var $dHtVS = parcelRequire("dHtVS");
const $5044ac4fa9b31340$export$c7df4a3f1b89de01 = ({ LoadStatusCommon: LoadStatusCommon = (0, $dHtVS.LoadStatus), shouldThrowError: shouldThrowError = false, useFavorite: useFavorite = (0, $bcn6L.useFavoriteFilters), useRecent: useRecent = (0, $apeap.useRecentFilters) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useFavorite
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useRecent
    }));

});

parcelRegister("lQ0sa", function(module, exports) {

$parcel$export(module.exports, "RecentContent", () => $2e9bf8b639eae23f$export$a2873dc4e96d8e90);

var $5uXOq = parcelRequire("5uXOq");

var $8nT7B = parcelRequire("8nT7B");

var $d6a7c = parcelRequire("d6a7c");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $4zlUA = parcelRequire("4zlUA");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $f4La7 = parcelRequire("f4La7");

var $4R6GH = parcelRequire("4R6GH");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $7ilb8 = parcelRequire("7ilb8");

var $dMJS0 = parcelRequire("dMJS0");

var $k3GIG = parcelRequire("k3GIG");
const $2e9bf8b639eae23f$export$a2873dc4e96d8e90 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { recentItems: recentItems, favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.useFilterNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>recentItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_RECENT)), [
        recentItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-recent');
    return recentItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6a7c.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $k3GIG.default).recent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuList), null, itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { id: beforeEntityId, type: beforeEntityType } = (0, $2EqxS.getBeforeEntity)(favoriteItems);
        const filterParams = {
            issueKey: ''
        };
        const filterQuery = {
            filter: String(id)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ilb8.MenuListItem), {
            key: id,
            ariaLabel: formatMessage((0, $k3GIG.default).recent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'filtersNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'recent',
                position: idx,
                starred: Boolean(isFavourite)
            },
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8nT7B))), {
                spacing: "spacious",
                label: ""
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                beforeEntityId: beforeEntityId,
                beforeEntityType: beforeEntityType,
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "recent",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.FILTERS_ITEM_TYPE)
            }),
            params: filterParams,
            query: filterQuery,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            to: (0, $f4La7.globalIssueNavigatorRoute),
            onClick: (0, $4zlUA.handleGinSPAClick),
            "aria-label": (0, $4R6GH.fg)('blu-6205_misc_nav3_a11y_fixes') ? title : undefined
        }, title));
    }))) : null;
};

});
parcelRegister("k3GIG", function(module, exports) {

$parcel$export(module.exports, "default", () => $e96da9bc3d6ed1b2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e96da9bc3d6ed1b2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "atlassian-navigation.filters.menu.recent-content.recent",
        "defaultMessage": "Recent"
    }
});

});



parcelRegister("7ikvo", function(module, exports) {

$parcel$export(module.exports, "default", () => $49764f41cba0da7b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $49764f41cba0da7b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filters: {
        "id": "atlassian-navigation.filters.filters",
        "defaultMessage": "Filters"
    }
});

});


parcelRegister("3bzLW", function(module, exports) {

$parcel$export(module.exports, "Dashboards", () => $f1da5b4afde35356$export$dd47e695f88fad71);

var $5uXOq = parcelRequire("5uXOq");

var $kaHBi = parcelRequire("kaHBi");

var $bcn6L = parcelRequire("bcn6L");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $apeap = parcelRequire("apeap");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $fVbkk = parcelRequire("fVbkk");

var $4XiFK = parcelRequire("4XiFK");

var $ebYJ0 = parcelRequire("ebYJ0");

var $7HJPM = parcelRequire("7HJPM");

var $lQgHF = parcelRequire("lQgHF");
const $f1da5b4afde35356$var$DashboardsAnonymous = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        href: "/jira/dashboards",
        menuId: (0, $lmyls.MENU_ID).DASHBOARDS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).DASHBOARDS
    }, formatMessage((0, $lQgHF.default).dashboards));
};
const $f1da5b4afde35356$var$DashboardsLoggedIn = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ hasFetchedOnce: hasFetchedOnceFavorites }, { loadFavoriteDashboards: loadFavorite }] = (0, $bcn6L.useFavoriteDashboards)();
    const [, { loadRecentDashboards: loadRecent }] = (0, $apeap.useRecentDashboards)();
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).DASHBOARDS,
        analyticsSource: 'atlassian-navigation'
    });
    const onBeforeMenuOpen = (0, $5uXOq.useCallback)(()=>{
        onStart();
        // refresh recents on open to add recently visited pages
        loadRecent((0, $Mp6qH.DEFAULT_LOAD_COUNT_RECENT));
        // load favourites only if not loaded already (optimisation to reduce requests)
        if (!hasFetchedOnceFavorites) loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
    }, [
        hasFetchedOnceFavorites,
        loadFavorite,
        loadRecent,
        onStart
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XiFK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebYJ0.Popup), {
        menuId: (0, $lmyls.MENU_ID).DASHBOARDS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).DASHBOARDS,
        Menu: (0, $7HJPM.Menu),
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $lQgHF.default).dashboards)
    }, formatMessage((0, $lQgHF.default).dashboards)));
};
const $f1da5b4afde35356$var$DashboardsComponent = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1da5b4afde35356$var$DashboardsAnonymous, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1da5b4afde35356$var$DashboardsLoggedIn, null);
};
const $f1da5b4afde35356$export$dd47e695f88fad71 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).DASHBOARDS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1da5b4afde35356$var$DashboardsComponent, null));

});
parcelRegister("7HJPM", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $9f76f48ca86ed8d3$export$d9b273488cd8ce6f);

var $5uXOq = parcelRequire("5uXOq");

var $70rf1 = parcelRequire("70rf1");

var $kLaXN = parcelRequire("kLaXN");

var $7CMCs = parcelRequire("7CMCs");

var $93jKl = parcelRequire("93jKl");

var $bcn6L = parcelRequire("bcn6L");

var $lmyls = parcelRequire("lmyls");

var $6cNb0 = parcelRequire("6cNb0");

var $lfTZh = parcelRequire("lfTZh");

var $Mp6qH = parcelRequire("Mp6qH");

var $8vzcp = parcelRequire("8vzcp");

var $ag3sS = parcelRequire("ag3sS");

var $9TMfX = parcelRequire("9TMfX");

var $6WLja = parcelRequire("6WLja");

var $e8DNP = parcelRequire("e8DNP");

var $6gxIx = parcelRequire("6gxIx");

var $7qz2O = parcelRequire("7qz2O");

var $8nbY6 = parcelRequire("8nbY6");

var $dKlaW = parcelRequire("dKlaW");
const $9f76f48ca86ed8d3$var$EVENT_DATA = {
    id: (0, $lmyls.MENU_ID).DASHBOARDS
};
const $9f76f48ca86ed8d3$export$d9b273488cd8ce6f = ({ testIdPrefix: testIdPrefix })=>{
    const [, { loadFavoriteDashboards: loadFavorite }] = (0, $bcn6L.useFavoriteDashboards)();
    const onFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $5uXOq.useEffect)(()=>()=>{
            // Refresh favourites on close to update if user has toggled any item
            loadFavorite((0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV));
        }, [
        loadFavorite
    ]);
    const testIdContent = (0, $6cNb0.testIdConcat)(testIdPrefix, 'content');
    const testIdFooter = (0, $6cNb0.testIdConcat)(testIdPrefix, 'footer');
    const errorFallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8vzcp.MenuError), {
            testIdPrefix: testIdContent
        }), [
        testIdContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ag3sS.MenuLayout), {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        isScrollable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $lmyls.MENU_ID).DASHBOARDS,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: errorFallback,
        withExperienceTracker: true,
        extraEventData: $9f76f48ca86ed8d3$var$EVENT_DATA,
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kLaXN.AuthenticationErrorBoundary), {
        render: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8DNP.Empty), {
        testIdPrefix: testIdContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "navigation-apps-dashboards-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9TMfX.MenuSkeletonContent), {
            testIdPrefix: testIdContent
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8nbY6.LoadStatus), {
        shouldThrowError: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6gxIx.FavoriteContent), {
        testIdPrefix: testIdContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dKlaW.RecentContent), {
        testIdPrefix: testIdContent
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70rf1.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "navigation-apps-dashboards-footer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6WLja.MenuSkeletonFooter), {
            testIdPrefix: testIdFooter
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8nbY6.LoadStatus), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7qz2O.Footer), {
        testIdPrefix: testIdFooter
    }))));
};

});
parcelRegister("e8DNP", function(module, exports) {

$parcel$export(module.exports, "Empty", () => $281eb0020f130a6b$export$1f74963c34e8bfec);

var $5uXOq = parcelRequire("5uXOq");

var $6eFvr = parcelRequire("6eFvr");

var $3bQtK = parcelRequire("3bQtK");

var $bcn6L = parcelRequire("bcn6L");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $apeap = parcelRequire("apeap");

var $cZpsT = parcelRequire("cZpsT");

var $Mp6qH = parcelRequire("Mp6qH");

var $jyltl = parcelRequire("jyltl");

var $dMJS0 = parcelRequire("dMJS0");

var $go6GE = parcelRequire("go6GE");

var $4MIFv = parcelRequire("4MIFv");
const $281eb0020f130a6b$var$learnMoreHref = 'https://confluence.atlassian.com/jiracorecloud/configuring-dashboards-765593585.html';
const $281eb0020f130a6b$export$1f74963c34e8bfec = ({ children: children, testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const onSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    const text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        as: "p"
    }, formatMessage((0, $4MIFv.default).emptyText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: $281eb0020f130a6b$var$learnMoreHref,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $4MIFv.default).learnMore))));
    const [{ hasSuccessOnce: hasSuccessOnceFavorite, isFetching: isFetchingFavorite, fetchError: fetchErrorFavorite }] = (0, $bcn6L.useFavoriteDashboards)();
    const [{ hasSuccessOnce: hasSuccessOnceRecent, isFetching: isFetchingRecent, fetchError: fetchErrorRecent }] = (0, $apeap.useRecentDashboards)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $dMJS0.useDashboardNavItems)();
    const notEmpty = favoriteItems.length || //  should show fav items
    recentItems.length || // should show recent items
    isFetchingFavorite && !hasSuccessOnceFavorite || // should show fav skeleton
    isFetchingRecent && !hasSuccessOnceRecent || // should show recent skeleton
    fetchErrorFavorite || // should show error
    fetchErrorRecent; // should show error
    const shouldShowEmptyForAnonymous = isAnonymous;
    (0, $5uXOq.useEffect)(()=>{
        const isSuccess = hasSuccessOnceFavorite && hasSuccessOnceRecent;
        if (isSuccess) onSuccess();
    }, [
        hasSuccessOnceFavorite,
        hasSuccessOnceRecent,
        onSuccess
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'empty');
    return notEmpty && !shouldShowEmptyForAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jyltl.MenuInfo), {
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($go6GE))),
        testId: testId,
        text: text
    });
};

});
parcelRegister("go6GE", function(module, exports) {
module.exports = new URL("dashboards-empty.ed2e5362.svg", import.meta.url).toString();

});

parcelRegister("4MIFv", function(module, exports) {

$parcel$export(module.exports, "default", () => $69bb4571f94cb527$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $69bb4571f94cb527$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyText: {
        "id": "atlassian-navigation.dashboards.menu.empty.empty-text",
        "defaultMessage": "Create a dashboard to track the status of your projects."
    },
    learnMore: {
        "id": "atlassian-navigation.dashboards.menu.empty.learn-more",
        "defaultMessage": "More about dashboards"
    },
    emptyImg: {
        "id": "atlassian-navigation.dashboards.menu.empty.empty-img",
        "defaultMessage": "An image showing that the apps dropdown menu is empty"
    }
});

});


parcelRegister("6gxIx", function(module, exports) {

$parcel$export(module.exports, "FavoriteContent", () => $96d17f8a5c6dc94c$export$297af018011b145a);

var $5uXOq = parcelRequire("5uXOq");

var $jjjbg = parcelRequire("jjjbg");

var $d6a7c = parcelRequire("d6a7c");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $5gOBf = parcelRequire("5gOBf");

var $4R6GH = parcelRequire("4R6GH");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $56fXm = parcelRequire("56fXm");

var $dMJS0 = parcelRequire("dMJS0");

var $fBffT = parcelRequire("fBffT");
const $96d17f8a5c6dc94c$export$297af018011b145a = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.useDashboardNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>favoriteItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)), [
        favoriteItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-starred');
    const dashboardsUrl = '/jira/dashboards?page=1&sortKey=favourite&sortOrder=DESC';
    return favoriteItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6a7c.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $fBffT.default).starred)), itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, metadata: metadata, title: title } = item;
        const contextItem = changedItems[id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'dashboardsNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'starred',
                position: idx,
                starred: Boolean(isFavourite)
            },
            description: metadata,
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jjjbg))), {
                spacing: "spacious",
                label: "dashboard"
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "starred",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.DASHBOARDS_ITEM_TYPE)
            }),
            key: id,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            to: (0, $5gOBf.dashboardViewRoute),
            params: {
                dashboardId: String(id)
            },
            "aria-label": (0, $4R6GH.fg)('blu-6205_misc_nav3_a11y_fixes') ? `${title} ${metadata || ''}` : undefined
        }, title);
    }), favoriteItems.length >= (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $56fXm.MenuItemViewAll), {
        analytics: {
            actionSubjectId: 'dashboardsNavigationMenuItem',
            menuItemId: 'viewAll',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            position: (0, $Mp6qH.DEFAULT_LOAD_COUNT_FAV)
        },
        href: dashboardsUrl,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: dashboardsUrl
    })) : null;
};

});
parcelRegister("fBffT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e9605aa9ba39b44$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4e9605aa9ba39b44$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    starred: {
        "id": "atlassian-navigation.dashboards.menu.favorite-content.starred",
        "defaultMessage": "Starred"
    }
});

});


parcelRegister("7qz2O", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $9ea4139d651cf8bc$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $6cNb0 = parcelRequire("6cNb0");

var $dDmlh = parcelRequire("dDmlh");

var $cZpsT = parcelRequire("cZpsT");

var $d4B4Y = parcelRequire("d4B4Y");

var $a3jaK = parcelRequire("a3jaK");

var $cuZpl = parcelRequire("cuZpl");
const $9ea4139d651cf8bc$export$a06f1c675e846f6f = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items');
    const dashboardsUrl = '/jira/dashboards';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'dashboardsNavigationMenuItem',
            menuItemId: 'viewAll',
            menuItemType: 'action',
            position: 0
        },
        href: dashboardsUrl,
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-view-all'),
        to: (0, $dDmlh.dashboardsDirectoryRoute)
    }, formatMessage((0, $cuZpl.default).viewAll)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a3jaK.CreateButton), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'item-create')
    }));
};

});
parcelRegister("a3jaK", function(module, exports) {

$parcel$export(module.exports, "CreateButton", () => $2b806b55754512d0$export$6d3c345ce7c38fd9);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $e9QkH = parcelRequire("e9QkH");

var $Mp6qH = parcelRequire("Mp6qH");

var $d4B4Y = parcelRequire("d4B4Y");

var $eqacc = parcelRequire("eqacc");
const $2b806b55754512d0$export$6d3c345ce7c38fd9 = ({ testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { on: modalOpen }] = (0, $e9QkH.useSwitchModals)((0, $Mp6qH.MODAL_ID).DASHBOARD_CREATE);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
        analytics: {
            actionSubjectId: 'dashboardsNavigationMenuItem',
            menuItemId: 'create',
            menuItemType: 'action',
            position: 1
        },
        onClick: modalOpen,
        testId: testId
    }, formatMessage((0, $eqacc.default).createButton));
};

});
parcelRegister("eqacc", function(module, exports) {

$parcel$export(module.exports, "default", () => $956db87aa6fc3521$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $956db87aa6fc3521$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createButton: {
        "id": "atlassian-navigation.dashboards.menu.footer.create-button.create-button",
        "defaultMessage": "Create dashboard"
    },
    notAllowed: {
        "id": "atlassian-navigation.dashboards.menu.footer.create-button.not-allowed",
        "defaultMessage": "You must be logged in to create dashboards"
    }
});

});


parcelRegister("cuZpl", function(module, exports) {

$parcel$export(module.exports, "default", () => $55607ccb6f8aac9f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $55607ccb6f8aac9f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewAll: {
        "id": "atlassian-navigation.dashboards.menu.footer.view-all",
        "defaultMessage": "View all dashboards"
    }
});

});


parcelRegister("8nbY6", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $e364b42a3e2b8e03$export$c7df4a3f1b89de01);

var $5uXOq = parcelRequire("5uXOq");

var $bcn6L = parcelRequire("bcn6L");

var $apeap = parcelRequire("apeap");

var $dHtVS = parcelRequire("dHtVS");
const $e364b42a3e2b8e03$export$c7df4a3f1b89de01 = ({ shouldThrowError: shouldThrowError = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHtVS.LoadStatus), {
        shouldThrowError: shouldThrowError,
        useProvider: (0, $bcn6L.useFavoriteDashboards)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHtVS.LoadStatus), {
        shouldThrowError: shouldThrowError,
        useProvider: (0, $apeap.useRecentDashboards)
    }));

});

parcelRegister("dKlaW", function(module, exports) {

$parcel$export(module.exports, "RecentContent", () => $e3bdcf72a295ac60$export$a2873dc4e96d8e90);

var $5uXOq = parcelRequire("5uXOq");

var $jjjbg = parcelRequire("jjjbg");

var $d6a7c = parcelRequire("d6a7c");

var $eXQym = parcelRequire("eXQym");

var $koVbs = parcelRequire("koVbs");

var $2EqxS = parcelRequire("2EqxS");

var $6cNb0 = parcelRequire("6cNb0");

var $5gOBf = parcelRequire("5gOBf");

var $4R6GH = parcelRequire("4R6GH");

var $Mp6qH = parcelRequire("Mp6qH");

var $fhtpB = parcelRequire("fhtpB");

var $d4B4Y = parcelRequire("d4B4Y");

var $dMJS0 = parcelRequire("dMJS0");

var $pwPQz = parcelRequire("pwPQz");
const $e3bdcf72a295ac60$export$a2873dc4e96d8e90 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { recentItems: recentItems, favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $dMJS0.useDashboardNavItems)();
    const itemsToShow = (0, $5uXOq.useMemo)(()=>recentItems.slice(0, (0, $Mp6qH.DEFAULT_LOAD_COUNT_RECENT)), [
        recentItems
    ]);
    const testId = (0, $6cNb0.testIdConcat)(testIdPrefix, 'items-recent');
    return recentItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6a7c.default), {
        testId: (0, $6cNb0.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $pwPQz.default).recent)), itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, metadata: metadata, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { id: beforeEntityId, type: beforeEntityType } = (0, $2EqxS.getBeforeEntity)(favoriteItems);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4B4Y.MenuItem), {
            analytics: {
                actionSubjectId: 'dashboardsNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'recent',
                position: idx,
                starred: Boolean(isFavourite)
            },
            description: metadata,
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jjjbg))), {
                spacing: "spacious",
                label: ""
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtpB.FavoriteButton), {
                beforeEntityId: beforeEntityId,
                beforeEntityType: beforeEntityType,
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "recent",
                onChangeFavorite: onChangeFavorite,
                type: (0, $eXQym.DASHBOARDS_ITEM_TYPE)
            }),
            key: id,
            testId: (0, $6cNb0.testIdConcat)(testId, `item-${idx}`),
            to: (0, $5gOBf.dashboardViewRoute),
            params: {
                dashboardId: String(id)
            },
            "aria-label": (0, $4R6GH.fg)('blu-6205_misc_nav3_a11y_fixes') ? `${title} ${metadata || ''}` : undefined
        }, title);
    })) : null;
};

});
parcelRegister("pwPQz", function(module, exports) {

$parcel$export(module.exports, "default", () => $037213aaba1faf3d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $037213aaba1faf3d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    recent: {
        "id": "atlassian-navigation.dashboards.menu.recent-content.recent",
        "defaultMessage": "Recent"
    },
    viewAll: {
        "id": "atlassian-navigation.dashboards.menu.recent-content.view-all",
        "defaultMessage": "View all recent"
    }
});

});



parcelRegister("lQgHF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4360ba769f596109$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4360ba769f596109$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dashboards: {
        "id": "atlassian-navigation.dashboards.dashboards",
        "defaultMessage": "Dashboards"
    }
});

});


parcelRegister("cvQRb", function(module, exports) {

$parcel$export(module.exports, "People", () => $c53dc2abd00215a4$export$8d3edc4d62e152ad);

var $5uXOq = parcelRequire("5uXOq");

var $2AtjH = parcelRequire("2AtjH");

var $koVbs = parcelRequire("koVbs");

var $goAXv = parcelRequire("goAXv");

var $57aZp = parcelRequire("57aZp");

const $c53dc2abd00215a4$export$8d3edc4d62e152ad = ()=>{
    const { locale: locale } = (0, $koVbs.default)();
    return(// this won't have any effect on those using the old people-menu except it will still cache
    // the remotely configured result for when they are rolled out to the new version
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $goAXv.PeopleAndTeamsConfigurationProvider), {
        product: "jira",
        locale: (0, $2AtjH.default)(locale)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57aZp.People), null)));
};

});
parcelRegister("57aZp", function(module, exports) {

$parcel$export(module.exports, "People", () => $73ab25b84abebed5$export$8d3edc4d62e152ad);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $4mBKK = parcelRequire("4mBKK");

var $2Xf08 = parcelRequire("2Xf08");

var $2uT3N = parcelRequire("2uT3N");

var $eRJ8t = parcelRequire("eRJ8t");
var $lhDyE = parcelRequire("lhDyE");

var $bSSG7 = parcelRequire("bSSG7");

var $1wn1U = parcelRequire("1wn1U");

var $2N6bN = parcelRequire("2N6bN");

var $2vSU6 = parcelRequire("2vSU6");

var $joX8T = parcelRequire("joX8T");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $1wpPp = parcelRequire("1wpPp");

var $4ywcn = parcelRequire("4ywcn");

var $8igKv = parcelRequire("8igKv");

var $eIokK = parcelRequire("eIokK");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $1J3t1 = parcelRequire("1J3t1");


var $8GOso = parcelRequire("8GOso");

var $6jY6G = parcelRequire("6jY6G");

var $cYlk7 = parcelRequire("cYlk7");

var $14XJw = parcelRequire("14XJw");

var $ldyPw = parcelRequire("ldyPw");

var $at1Nr = parcelRequire("at1Nr");

var $69X1g = parcelRequire("69X1g");

var $heI7y = parcelRequire("heI7y");

var $dkqym = parcelRequire("dkqym");

var $cZpsT = parcelRequire("cZpsT");

var $9OXo1 = parcelRequire("9OXo1");

var $2C9Mo = parcelRequire("2C9Mo");

var $lVJAU = parcelRequire("lVJAU");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $fVbkk = parcelRequire("fVbkk");

var $j94qH = parcelRequire("j94qH");

var $gAtvZ = parcelRequire("gAtvZ");

var $kAJ4Y = parcelRequire("kAJ4Y");

var $iPj86 = parcelRequire("iPj86");

var $annPD = parcelRequire("annPD");

var $ccG8Y = parcelRequire("ccG8Y");
const $73ab25b84abebed5$var$STORAGE_KEY = 'jwm.invite-business-teams-modal-viwed-timestamp';
const $73ab25b84abebed5$var$SITE_USER_TRAIT_HAS_VIEW_EXPERIMENT = 'jira_screen_viewed_invitebusinessteamsmodal_first';
const $73ab25b84abebed5$var$STORAGE_PROVIDER_KEY = 'jira_invite-business-teams-modal';
const $73ab25b84abebed5$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)($73ab25b84abebed5$var$STORAGE_PROVIDER_KEY);
const $73ab25b84abebed5$var$PeopleMenuDropdown = ()=>{
    const [inviteBusinessTeamsModalData, setInviteBusinessTeamsModalData] = (0, $5uXOq.useState)({
        isOpen: false,
        userCounts: 0
    });
    const [isMenuOpen, { off: closeMenu, on: openMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).PEOPLE);
    const baseUrl = '';
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const isHighlighted = (0, $kAJ4Y.useMenuHighlighted)((0, $lmyls.MENU_ID).PEOPLE);
    const triggerAnalytics = (0, $iPj86.useNavigationItemAnalytics)({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).PEOPLE
    });
    const [isEventFromSpotlightTour] = (0, $gAtvZ.useFromSpotlightTour)('spotlight');
    const checkUsersGroupPermission = (0, $annPD.useBrowseUsersGroupsPermissions)();
    const checkUsersGroupPermissionNext = (0, $annPD.useBrowseUsersGroupsPermissionsNext)(isMenuOpen);
    const isEnabledForTailoredOnboardingM2 = (0, $4R6GH.fg)('jira_tailored_onboarding_jtbd_feature_gate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8GOso.useIsTailoredOnboardingM2ForQuickstartEnabled)() : false;
    const addFlag = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'appearance' implicitly has an 'any' type.
    ({ appearance: appearance, ...flagProps })=>{
        if (appearance === 'success' || appearance === 'normal') showFlag((serviceProps)=>{
            const props = {
                messageId: 'atlassian-navigation.ui.people.menu-with-configuration.props.success-flag',
                messageType: 'transactional',
                ...flagProps,
                ...serviceProps
            };
            // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ywcn.default), props);
        });
        if (appearance === 'warning') showFlag((serviceProps)=>{
            const props = {
                messageId: 'atlassian-navigation.ui.people.menu-with-configuration.props.warning-flag',
                messageType: 'transactional',
                ...flagProps,
                ...serviceProps
            };
            // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8igKv.default), props);
        });
        if (appearance === 'error') showFlag((serviceProps)=>{
            const props = {
                messageId: 'atlassian-navigation.ui.people.menu-with-configuration.props.error-flag',
                messageType: 'transactional',
                ...flagProps,
                ...serviceProps
            };
            // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wpPp.default), props);
        });
    }, [
        showFlag
    ]);
    // @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type.
    const pushRoute = (0, $5uXOq.useCallback)((url)=>push(`${baseUrl}${url}`), [
        baseUrl,
        push
    ]);
    const peopleMenuWrapperRef = (0, $2Xf08.useRegisterNudgeTarget)((0, $6784cbc7d62e5d7c$export$77bc79debbf5c069), true).ref;
    const { data: { user: user } } = (0, $cYlk7.useCurrentUser)();
    const teamCreateDialogProps = (0, $5uXOq.useMemo)(()=>{
        const dialogProps = {
            currentUser: {
                id: user.accountId || '',
                fullName: user.userFullname,
                // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                email: user.emailAddress !== undefined ? user.emailAddress : '',
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                avatarUrl: user?.avatarUrls ? user.avatarUrls['16x16'] : '',
                nickname: user?.userFullname
            },
            enableMembershipSettingsChoice: true
        };
        dialogProps.onClose = ()=>{
            if (peopleMenuWrapperRef?.current) requestAnimationFrame(()=>{
                peopleMenuWrapperRef?.current?.querySelector('button')?.focus();
            });
        };
        return dialogProps;
    // the peopleMenuWrapperRef doesn't change as the condition if FG is static
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // close menu when transitioning to other pages.
        if (!(0, $4R6GH.fg)('dont-auto-close-people-menu')) closeMenu();
        // close menu on unmount
        return ()=>{
            if (!(0, $4R6GH.fg)('dont-auto-close-people-menu')) closeMenu();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route
    ]);
    const { data: projectSidebarNavigationData } = (0, $1J3t1.useProjectSidebarNavigation)();
    const subProduct = (0, $eIokK.projectTypeToSubProduct)(projectSidebarNavigationData?.projectType);
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId, appEditions: { software: software } } = (0, $9OXo1.useTenantContext)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const invitePeopleExperimentalFeatures = (0, $5uXOq.useMemo)(()=>({
            inviteThirdPartyTeams: (0, $joX8T.VARIATION),
            coreInvitesDriveMultiProductInvites: (0, $4R6GH.fg)('core_invites_drive_multi_product_invites_gate')
        }), []);
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('core_invites_drive_multi_product_invites');
    const isDriveMultiProductInviteEnabled = expConfig.get('cohort', (0, $joX8T.NOT_ENROLLED)) === (0, $joX8T.VARIATION);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const continueUrl = window.location.href;
    const entryPoint = (0, $4mO32.useEntryPoint)((0, $1wn1U.inviteBusinessTeamsModalEntryPoint), {});
    const [{ traits: traits }] = (0, $2N6bN.usePersonalizationProvider)();
    const firstActivationDateMs = (0, $dkqym.useFirstActivationDateMs)();
    const storedValue = $73ab25b84abebed5$export$c2ed3351cac403d1.get($73ab25b84abebed5$var$STORAGE_KEY);
    const isSoftwareProject = subProduct === (0, $2vSU6.SOFTWARE_PROJECT);
    const isValidAppEdition = software === (0, $ldyPw.FREE_EDITION) || software === (0, $ldyPw.STANDARD_EDITION);
    const isValidSiteAge = firstActivationDateMs && (0, $4mBKK.default)(new Date(), firstActivationDateMs) > 28;
    const hasDismissedInviteBefore = storedValue || traits.some((trait)=>trait.name === $73ab25b84abebed5$var$SITE_USER_TRAIT_HAS_VIEW_EXPERIMENT);
    const showModal = Boolean(isSoftwareProject && isValidAppEdition && isValidSiteAge && !hasDismissedInviteBefore && !isDriveMultiProductInviteEnabled);
    const { openModal: openModal } = (0, $lhDyE.useInvitePeopleModal)({
        continueUrl: continueUrl,
        enableThirdParty: true,
        experimentalFeatures: invitePeopleExperimentalFeatures,
        displayInfiSpotlight: true,
        orgId: orgId,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        showFlag: addFlag,
        source: 'peopleMenu',
        subProduct: subProduct,
        experimental_applicationEdition: software,
        navigation: {
            directoryContextEntryPoint: '/jira'
        },
        onSubmit: async (data)=>{
            const { inviteUsersResponse: inviteUsersResponse } = await data.defaultOnSubmit();
            // Handle invite business team modal experiment
            if (showModal) {
                const invitedJswUsers = (0, $ccG8Y.getInvitedJswUsers)(inviteUsersResponse);
                const invitedJswUserCount = invitedJswUsers.length;
                // make sure we only display our modal when invites are JSW
                if (invitedJswUserCount > 0) {
                    setInviteBusinessTeamsModalData({
                        isOpen: true,
                        userCounts: invitedJswUserCount
                    });
                    // Make sure user only see the dialog once, and avoid loading traits everytime when user invites a person
                    $73ab25b84abebed5$export$c2ed3351cac403d1.set($73ab25b84abebed5$var$STORAGE_KEY, String(new Date()));
                    entryPoint.entryPointActions.load();
                }
            }
        },
        // this is used to handle `add more people` button clicked, we need to hide invite business team modal
        ...showModal ? {
            experimental_onReopenHandler: ()=>{
                openModal();
                setInviteBusinessTeamsModalData({
                    isOpen: false,
                    userCounts: 0
                });
            }
        } : {}
    });
    const invitePeopleHandlers = (0, $5uXOq.useMemo)(()=>({
            handleClick: openModal
        }), [
        openModal
    ]);
    if (!atlassianAccountId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $lmyls.MENU_ID).PEOPLE,
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: "unmount",
        teamName: "navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73ab25b84abebed5$export$5d16118c15d58d20, {
        ref: peopleMenuWrapperRef,
        "data-testid": `menu-${(0, $Mp6qH.NAVIGATION_ITEM_ID).PEOPLE}-wrapper`
    }, (isEnabledForTailoredOnboardingM2 || (0, $4R6GH.fg)('jira-always-render-invite-nudge')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $at1Nr.InviteTeamNudgeAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2C9Mo.default), {
        shouldRenderToParent: true,
        product: "jira",
        cloudId: cloudId,
        userId: atlassianAccountId,
        isBrowseUsersEnabled: (0, $4R6GH.fg)('dont-auto-close-people-menu') ? checkUsersGroupPermissionNext : checkUsersGroupPermission,
        // allow PeopleMenu to do transitions to in-product People Directory
        pushRoute: pushRoute,
        isHighlighted: isHighlighted,
        // @ts-expect-error - TS2322 - Type '({ appearance, ...flagProps }: { [x: string]: any; appearance: any; }) => void' is not assignable to type '(flag: Flag) => void'.
        addFlag: addFlag,
        onClick: triggerAnalytics,
        // manage open state
        isOpen: isMenuOpen,
        onOpen: openMenu,
        onClose: isEventFromSpotlightTour ? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) : closeMenu,
        customChevronIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.ChevronRightIcon), null),
        enablePreFetchingByHovering: false,
        subProduct: subProduct,
        isSSR: false,
        orgId: orgId ?? undefined,
        teamCreateDialogProps: teamCreateDialogProps,
        invitePeopleHandlers: invitePeopleHandlers,
        isSectionList: true
    })), inviteBusinessTeamsModalData.isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPoint.entryPointReferenceSubject,
        id: "invite-business-teams-modal",
        packageName: "jira-business.invite-business-teams",
        teamName: "jira-werewolves",
        runtimeProps: {
            userCounts: inviteBusinessTeamsModalData.userCounts,
            onClose: ()=>{
                setInviteBusinessTeamsModalData({
                    isOpen: false,
                    userCounts: 0
                });
            }
        },
        entryPointActions: entryPoint.entryPointActions
    }));
};
const $73ab25b84abebed5$var$PeopleWithAuth = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { isVisible: isVisible } = (0, $2uT3N.useOverflowStatus)();
    const [{ hasOpened: shouldShowNudge }] = (0, $heI7y.useHasOpened)();
    if (isAnonymous) return null;
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "navigation.people-menu.with-nudgetooltip",
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: "unmount",
        teamName: "navigation"
    }, shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69X1g.NavigationPeopleNavItemWrapperNudgeAsync), {
        isInsideMenu: !isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j94qH.FullHeightTextColorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRJ8t.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73ab25b84abebed5$var$PeopleMenuDropdown, null)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j94qH.FullHeightTextColorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRJ8t.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73ab25b84abebed5$var$PeopleMenuDropdown, null))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73ab25b84abebed5$var$PeopleMenuDropdown, null);
};
const $73ab25b84abebed5$export$8d3edc4d62e152ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).PEOPLE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73ab25b84abebed5$var$PeopleWithAuth, null));
const $73ab25b84abebed5$export$5d16118c15d58d20 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4t3i1osq _16jlkb7n _shj5kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1wn1U", function(module, exports) {

$parcel$export(module.exports, "inviteBusinessTeamsModalEntryPoint", () => $0865312f111a9e5e$export$f4db71d255c0573);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $0865312f111a9e5e$export$f4db71d255c0573 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("ijciO")).then((module)=>module.InviteBusinessTeamsModal), {
        moduleId: "c8fe5655"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("ijciO", function(module, exports) {

let $d5438b5a1230898f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d5438b5a1230898f$var$load("h2MrD"),
    $d5438b5a1230898f$var$load("bYT2S"),
    $d5438b5a1230898f$var$load("hPzOn"),
    $d5438b5a1230898f$var$load("sV6r3")
]).then(()=>parcelRequire('72cfG'));

});


parcelRegister("joX8T", function(module, exports) {

$parcel$export(module.exports, "COHORT", () => $a85d1363752adaec$export$3d370c33621572df);
$parcel$export(module.exports, "NOT_ENROLLED", () => $a85d1363752adaec$export$5b7423264d48ab04);
$parcel$export(module.exports, "CONTROL", () => $a85d1363752adaec$export$43f367b3e957f219);
$parcel$export(module.exports, "VARIATION", () => $a85d1363752adaec$export$fa04ad826acc90da);

var $co1wz = parcelRequire("co1wz");
const $a85d1363752adaec$export$3d370c33621572df = 'cohort';
const $a85d1363752adaec$export$5b7423264d48ab04 = 'not-enrolled';
const $a85d1363752adaec$export$43f367b3e957f219 = 'control';
const $a85d1363752adaec$export$9ba2bc3b1bdc1519 = 'experiment';
const $a85d1363752adaec$export$fa04ad826acc90da = 'variation';
const $a85d1363752adaec$export$6486974e39493fa6 = 'variation-1';
const $a85d1363752adaec$export$7d994996134ad562 = 'variation-2';
const $a85d1363752adaec$export$795e7d69b248dcd0 = 'variation-3';
const $a85d1363752adaec$export$c9c947c57470b787 = 'variation-4';
const $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
    $a85d1363752adaec$export$5b7423264d48ab04,
    $a85d1363752adaec$export$43f367b3e957f219,
    $a85d1363752adaec$export$9ba2bc3b1bdc1519,
    $a85d1363752adaec$export$fa04ad826acc90da,
    $a85d1363752adaec$export$6486974e39493fa6,
    $a85d1363752adaec$export$7d994996134ad562,
    $a85d1363752adaec$export$795e7d69b248dcd0,
    $a85d1363752adaec$export$c9c947c57470b787
];
var // Use optionalValidExperimentGroups to further restrict the list of cohorts
// eslint-disable-next-line jira/import/no-anonymous-default-export
$a85d1363752adaec$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, $co1wz.getMultivariateFeatureFlag)(experimentFeatureFlag, $a85d1363752adaec$export$5b7423264d48ab04, validExperimentGroups);

});

parcelRegister("8GOso", function(module, exports) {

$parcel$export(module.exports, "usePersonalisationActions", () => $adde9919a40069db$export$5b1d43353c334c00);
$parcel$export(module.exports, "useCommonEligibilityConditionsForJtbdOnboarding", () => $adde9919a40069db$export$c89644b13b6e777f);
$parcel$export(module.exports, "useCommonEligibilityConditionsForTOM2P5", () => $adde9919a40069db$export$b633031bd0a88786);
$parcel$export(module.exports, "useTailoredOnboardingPersonalisationAttributes", () => $adde9919a40069db$export$9aad8798ea46e07f);
$parcel$export(module.exports, "useTailoredOnboardingPersonalisationM2", () => $adde9919a40069db$export$5875295cb096b1f2);
$parcel$export(module.exports, "useIsTailoredOnboardingM2ForQuickstartEnabled", () => $adde9919a40069db$export$6bc15f8ade1cf36);
$parcel$export(module.exports, "useFireExposureForTailoredOnboardingM2ForQuickstart", () => $adde9919a40069db$export$369994803661d31);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $cNd4s = parcelRequire("cNd4s");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $dAfqg = parcelRequire("dAfqg");

var $AK64q = parcelRequire("AK64q");

var $8UmI9 = parcelRequire("8UmI9");

var $4mXzi = parcelRequire("4mXzi");

var $iAFnF = parcelRequire("iAFnF");

var $1OQiY = parcelRequire("1OQiY");
const $adde9919a40069db$var$store = (0, $iXqE5.createStore)({
    name: 'jira-onboarding-personalisation',
    initialState: (0, $AK64q.initialCachedEndpointState),
    actions: $4mXzi.actions
});
const $adde9919a40069db$export$5b1d43353c334c00 = (0, $3sQ5x.createActionsHook)($adde9919a40069db$var$store);
const $adde9919a40069db$export$31a443426d101362 = (0, $3sQ5x.createHook)($adde9919a40069db$var$store);
const $adde9919a40069db$export$c89644b13b6e777f = ()=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const isBusinessProject = projectContextData?.projectType === undefined || // letting undefined pass for non-project context usage, eg: onboarding
    projectContextData?.projectType === (0, $2vSU6.CORE_PROJECT); // limiting only to CORE for Tailired Onboarding M2 usage
    return (0, $4R6GH.fg)('gups_personalisation_api_integration_improvements') ? isBusinessProject && isSiteAdmin && (0, $4R6GH.fg)('jira_tailored_onboarding_jtbd_feature_gate') : isSiteAdmin && (0, $4R6GH.fg)('jira_tailored_onboarding_jtbd_feature_gate');
};
const $adde9919a40069db$export$b633031bd0a88786 = ()=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { isBusinessProject: isBusinessProject } = (0, $8UmI9.useIsBusinessProject)();
    return isBusinessProject && isSiteAdmin && (0, $4R6GH.fg)('tailored_onboarding_m2p5_gate');
};
const $adde9919a40069db$export$6f87e1662a24f8b9 = ({ isEligible: isEligible, experienceTypes: experienceTypes, additionalParameters: additionalParameters })=>{
    const [{ fetchedOnce: fetchedOnce, isFetching: isFetching, data: data }, { fetchOnboardingPersonalisation: fetchOnboardingPersonalisation }] = $adde9919a40069db$export$31a443426d101362();
    (0, $5uXOq.useEffect)(()=>{
        if (isEligible && !fetchedOnce && !isFetching && data === undefined) fetchOnboardingPersonalisation({
            experienceTypes: experienceTypes,
            additionalParameters: additionalParameters
        });
    }, [
        additionalParameters,
        data,
        experienceTypes,
        fetchOnboardingPersonalisation,
        fetchedOnce,
        isEligible,
        isFetching
    ]);
    if (!isEligible) // If not eligible, no fetching is done. Data is ready to be read
    return {
        data: undefined,
        isReady: true
    };
    return {
        data: data,
        isReady: fetchedOnce && !isFetching
    };
};
const $adde9919a40069db$export$9aad8798ea46e07f = ()=>{
    const isEligibleForTailoredOnboardingM2 = $adde9919a40069db$export$c89644b13b6e777f();
    const { data: personalisationData, isReady: personalisationDataIsReady } = $adde9919a40069db$export$6f87e1662a24f8b9({
        isEligible: isEligibleForTailoredOnboardingM2
    });
    return {
        personalisationDataIsReady: personalisationDataIsReady,
        teamType: personalisationData?.matched.variants.find((variant)=>variant.startsWith('teamType.'))?.replace('teamType.', ''),
        jtbd: personalisationData?.matched.variants.filter((variant)=>variant.startsWith('jtbd.option_')).map((option)=>option.replace('jtbd.option_', '')).join(',')
    };
};
const $adde9919a40069db$export$5875295cb096b1f2 = ({ isEligible: isEligible, additionalParameters: additionalParameters })=>{
    const hasSentErrorOnce = (0, $5uXOq.useRef)(false);
    const { data: data, isReady: isReady } = $adde9919a40069db$export$6f87e1662a24f8b9({
        isEligible: isEligible,
        experienceTypes: [
            'QUICKSTART',
            'TEMPLATE',
            'LANDING_PAGE'
        ],
        additionalParameters: additionalParameters
    });
    try {
        const conditionalProjectType = `projectType.${additionalParameters?.projectType}`;
        // If projectType is not given as parameter, ignore restriction to match on projectType
        const isMatchingProjectType = Boolean(!additionalParameters?.projectType || data?.matched.variants.some((variant)=>variant === conditionalProjectType));
        const isMatchingTeamType = Boolean(data?.matched.variants.some((variant)=>variant.startsWith('teamType.') && (0, $iAFnF.ELIGIBLE_TEAM_TYPES_M2_FULL_NOTATION).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            variant.split('.')[1])));
        const isMatchingJtbd = Boolean(data?.matched.variants.some((variant)=>variant.startsWith('jtbd')));
        const matched = Boolean(data && isMatchingJtbd && isMatchingProjectType && isMatchingTeamType);
        return {
            isReady: isReady,
            data: {
                matched: matched,
                matchedVariants: {
                    projectType: isMatchingProjectType,
                    tt: isMatchingTeamType,
                    jtbd: isMatchingJtbd
                },
                QUICKSTART: matched && data ? data.experience.QUICKSTART : [],
                TEMPLATE: matched && data ? data.experience.TEMPLATE?.[0] : undefined,
                LANDING_PAGE: matched && data ? data.experience.LANDING_PAGE?.[0] : undefined
            }
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!hasSentErrorOnce.current) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'useTailoredOnboardingPersonalisationM2',
                    packageName: 'jiraOnboardingCore',
                    teamName: 'jlove-makkuro'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            hasSentErrorOnce.current = true;
        }
    }
    return {
        isReady: isReady,
        data: {
            matched: false,
            matchedVariants: {
                jtbd: false,
                tt: false,
                projectType: false
            },
            QUICKSTART: [],
            TEMPLATE: undefined,
            LANDING_PAGE: undefined
        }
    };
};
const $adde9919a40069db$export$6bc15f8ade1cf36 = ()=>{
    const isEligibleForJtbdOnboarding = $adde9919a40069db$export$c89644b13b6e777f();
    const isEnabled = (0, $1OQiY.isTailoredOnboardingM2ExperimentFlagEnabled)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const projectType = (0, $4R6GH.fg)('tailored_onboarding_m3_gate') ? projectContextData?.projectType : (0, $2vSU6.CORE_PROJECT);
    const { isReady: personalisationDataIsReady, data: personalisationData } = $adde9919a40069db$export$5875295cb096b1f2({
        isEligible: isEligibleForJtbdOnboarding,
        additionalParameters: {
            projectType: projectType
        }
    });
    return Boolean(personalisationDataIsReady && personalisationData.QUICKSTART && personalisationData.QUICKSTART?.length > 0 && isEnabled);
};
const $adde9919a40069db$export$369994803661d31 = ({ projectType: projectType })=>{
    const isEligibleForJtbdOnboarding = $adde9919a40069db$export$c89644b13b6e777f();
    const { isReady: personalisationDataIsReady, data: personalisationData } = $adde9919a40069db$export$5875295cb096b1f2({
        isEligible: isEligibleForJtbdOnboarding,
        additionalParameters: {
            projectType: (0, $2vSU6.CORE_PROJECT)
        }
    });
    if (projectType === (0, $2vSU6.CORE_PROJECT) && personalisationDataIsReady && personalisationData.matched && personalisationData.QUICKSTART && personalisationData.QUICKSTART?.length > 0) (0, $6s1PB.expVal)('jira_tailored_onboarding_jtbd', 'isEnabled', false);
};

});
parcelRegister("8UmI9", function(module, exports) {

$parcel$export(module.exports, "useIsBusinessProject", () => $d1bed05bd9fbc7d5$export$f1bf366948a19b0f);

var $dAfqg = parcelRequire("dAfqg");

var $2vSU6 = parcelRequire("2vSU6");
const $d1bed05bd9fbc7d5$export$f1bf366948a19b0f = ()=>{
    const { data: data, loading: loading } = (0, $dAfqg.useProjectContext)();
    const isBusinessProject = data?.projectType === (0, $2vSU6.CORE_PROJECT);
    return {
        isBusinessProject: isBusinessProject,
        loading: loading
    };
};

});

parcelRegister("4mXzi", function(module, exports) {

$parcel$export(module.exports, "actions", () => $f50a5e3bb7b9f239$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7bRcT = parcelRequire("7bRcT");

var $FroD7 = parcelRequire("FroD7");
const $f50a5e3bb7b9f239$var$fetchOnboardingPersonalisation = (0, $7bRcT.cachedEndpointCall)((args)=>(0, $FroD7.fetchOnboardingPersonalisationWithRethrow)(args));
const $f50a5e3bb7b9f239$var$trackPersonalisationAction = ({ additionalParameters: additionalParameters })=>()=>(0, $FroD7.trackPersonalisation)({
            additionalParameters: additionalParameters
        });
const $f50a5e3bb7b9f239$export$e324594224ef24da = {
    fetchOnboardingPersonalisation: $f50a5e3bb7b9f239$var$fetchOnboardingPersonalisation,
    trackPersonalisation: $f50a5e3bb7b9f239$var$trackPersonalisationAction
};

});
parcelRegister("FroD7", function(module, exports) {

$parcel$export(module.exports, "fetchOnboardingPersonalisationWithRethrow", () => $501ec097caecd266$export$6bc39428b6510a7c);
$parcel$export(module.exports, "trackPersonalisation", () => $501ec097caecd266$export$9835c32b78102887);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $fv5ut = parcelRequire("fv5ut");
const $501ec097caecd266$var$PERSONALISATION_ENDPOINT = '/rest/personalisation/v1/experience';
const $501ec097caecd266$var$TRACK_PERSONALISATION_ENDPOINT = '/rest/personalisation/v1/track';
const $501ec097caecd266$var$responseHasAllRequestedExperienceTypes = ({ response: response, requestedExperienceTypes: requestedExperienceTypes })=>requestedExperienceTypes.every((requestedExperienceType)=>response.experience[requestedExperienceType]);
const $501ec097caecd266$export$6bc39428b6510a7c = async ({ experienceTypes: experienceTypes = [
    'QUICKSTART',
    'TEMPLATE',
    'LANDING_PAGE'
], additionalParameters: additionalParameters })=>{
    try {
        const localStorageOnboardingPersonalisationResponse = (0, $fv5ut.getLocalStorageOnboardingPersonalisationResponse)();
        if (localStorageOnboardingPersonalisationResponse && $501ec097caecd266$var$responseHasAllRequestedExperienceTypes({
            response: localStorageOnboardingPersonalisationResponse,
            requestedExperienceTypes: experienceTypes
        })) return localStorageOnboardingPersonalisationResponse;
        const response = await (0, $eusud.performPostRequestWithRetry)($501ec097caecd266$var$PERSONALISATION_ENDPOINT, {
            body: JSON.stringify({
                experienceTypes: experienceTypes,
                additionalParameters: additionalParameters
            })
        });
        if (response) {
            const mergedResponse = {
                experience: {
                    ...localStorageOnboardingPersonalisationResponse?.experience,
                    ...response.experience
                },
                matched: response.matched
            };
            (0, $fv5ut.setLocalStorageOnboardingPersonalisationResponse)(mergedResponse);
            return mergedResponse;
        }
        throw new Error('response from OnboardingPersonalisation is falsy');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'fetchOnboardingPersonalisationWithRethrow',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $501ec097caecd266$export$9835c32b78102887 = ({ additionalParameters: additionalParameters })=>{
    try {
        (0, $eusud.performPostRequestWithRetry)($501ec097caecd266$var$TRACK_PERSONALISATION_ENDPOINT, {
            body: JSON.stringify({
                additionalParameters: additionalParameters
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'trackOnboardingPersonalisation',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});
parcelRegister("fv5ut", function(module, exports) {

$parcel$export(module.exports, "getLocalStorageOnboardingPersonalisationResponse", () => $673c953eac85fdf0$export$e9fb5b94c03fa495);
$parcel$export(module.exports, "setLocalStorageOnboardingPersonalisationResponse", () => $673c953eac85fdf0$export$dda9cd59669fc243);

var $bSSG7 = parcelRequire("bSSG7");

var $jcw0u = parcelRequire("jcw0u");
const $673c953eac85fdf0$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE = 'response';
const $673c953eac85fdf0$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('jira-onboarding-personalisation');
const $673c953eac85fdf0$export$e9fb5b94c03fa495 = ()=>{
    try {
        return $673c953eac85fdf0$var$localStorage.get($673c953eac85fdf0$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPersonalisation',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return undefined;
    }
};
const $673c953eac85fdf0$export$dda9cd59669fc243 = (response)=>{
    try {
        $673c953eac85fdf0$var$localStorage.set($673c953eac85fdf0$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE, response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPersonalisationResponse',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});



parcelRegister("iAFnF", function(module, exports) {

$parcel$export(module.exports, "ELIGIBLE_TEAM_TYPES_M2_FULL_NOTATION", () => $afa1ef0e1c3d15e2$export$1d38dc41bb005254);

var $5PxqD = parcelRequire("5PxqD");
const $afa1ef0e1c3d15e2$export$1d38dc41bb005254 = [
    (0, $5PxqD.USER_SEGMENTATION_TEAM_TYPE_MARKETING),
    (0, $5PxqD.USER_SEGMENTATION_TEAM_TYPE_OPERATIONS)
];

});
parcelRegister("5PxqD", function(module, exports) {

$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_MARKETING", () => $5d0851fa8905d151$export$e4824f74b9879164);
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_OPERATIONS", () => $5d0851fa8905d151$export$4f3cb0844009af52);
$parcel$export(module.exports, "userBelongsToBusinessUserSegCategory", () => $5d0851fa8905d151$export$517f94ab07724226);

var $jcw0u = parcelRequire("jcw0u");
// Roles defined in user segmentation
const $5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER = 'designer';
const $5d0851fa8905d151$export$572242e58bd07594 = 'customer-service';
const $5d0851fa8905d151$export$d7de553940261eba = 'it-support';
const $5d0851fa8905d151$export$4c29d0d04c15e55d = 'human-resources';
const $5d0851fa8905d151$export$3950f7f841bf94b6 = 'finance';
const $5d0851fa8905d151$export$881249b988b6030f = 'legal';
const $5d0851fa8905d151$export$e4824f74b9879164 = 'marketing';
const $5d0851fa8905d151$export$4f3cb0844009af52 = 'operations';
const $5d0851fa8905d151$export$1a65d50c4a641bb4 = 'sales';
const $5d0851fa8905d151$export$b8b1ac856ba1434b = 'software-development';
// Unique identifier used where all roles in a team type are eligible
const $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE = 'all-roles-eligible';
const $5d0851fa8905d151$export$2f3f9640393bd078 = 'unknown';
const $5d0851fa8905d151$export$4c9a72dac5ce80ae = '';
// @ts-expect-error - It seems to be missing some translations (for all-roles-eligible).
const $5d0851fa8905d151$var$USER_SEGMENTATION_CLIENT_MAPPING = {
    [$5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER]: [
        'Designer',
        'Disainer',
        "Dise\xf1ador",
        'Formgivare',
        "Nh\xe0 thi\u1EBFt k\u1EBF",
        'Projektant',
        'Suunnittelija',
        "Tasar\u0131mc\u0131",
        "Tervez\u0151",
        "\u0414\u0438\u0437\u0430\u0439\u043D\u0435\u0440",
        "\u0E19\u0E31\u0E01\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A",
        "\u30C7\u30B6\u30A4\u30CA\u30FC",
        "\u8A2D\u8A08\u5E2B",
        "\u8BBE\u8BA1\u5E08",
        "\uB514\uC790\uC774\uB108"
    ],
    [$5d0851fa8905d151$export$572242e58bd07594]: [
        'Asiakaspalvelu',
        'Atendimento ao cliente',
        'Customer Service',
        "D\u1ECBch v\u1EE5 kh\xe1ch h\xe0ng",
        'Klantenservice',
        'Klienditeenindus',
        'Kundenservice',
        'Kundeservice',
        'Kundservice',
        "M\xfc\u015Fteri Hizmetleri",
        "Obs\u0142uga klienta",
        "Service \xe0 la client\xe8le",
        "Servicio de atenci\xf3n al cliente",
        'Servizio clienti',
        "Servi\xe7o de apoio ao cliente",
        "Z\xe1kaznick\xfd servis",
        "Z\xe1kazn\xedcky servis",
        "\xdcgyf\xe9lszolg\xe1lati",
        "\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432",
        "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
        "\u30AB\u30B9\u30BF\u30DE\u30FC \u30B5\u30FC\u30D3\u30B9",
        "\u5BA2\u6237\u670D\u52A1",
        "\u9867\u5BA2\u670D\u52D9",
        "\uACE0\uAC1D \uC11C\uBE44\uC2A4"
    ],
    [$5d0851fa8905d151$export$d7de553940261eba]: [
        'Assistenza IT',
        "BT Deste\u011Fi",
        "H\u1ED7 tr\u1EE3 CNTT",
        'IT',
        'IT Support',
        'IT podpora',
        "IT \u30B5\u30DD\u30FC\u30C8",
        "IT \u652F\u6301",
        "IT \u652F\u63F4",
        "IT \uC9C0\uC6D0",
        'IT_Support',
        "IT_st\xf8tte",
        'IT_support',
        'IT_tugi',
        'IT_tuki',
        "Informatikai t\xe1mogat\xe1si",
        'Soporte de TI',
        'Suporte de TI',
        "Support\xa0IT",
        'Wsparcie IT',
        "\u0418\u0422-\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u043E\u0457 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438",
        "\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19 IT"
    ],
    [$5d0851fa8905d151$export$3950f7f841bf94b6]: [
        'Ekonomi',
        'Finance',
        'Financeiro',
        'Financie',
        'Finans',
        'Finanse',
        'Finants',
        'Finanza',
        'Finanzas',
        'Finanzen',
        "Finan\xe7as",
        "P\xe9nz\xfcgyi",
        'Rahoitus',
        "T\xe0i ch\xednh",
        "\xd8konomi",
        "\u0424\u0438\u043D\u0430\u043D\u0441\u044B",
        "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
        "\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19",
        "\u8CA1\u52D9",
        "\u91D1\u878D",
        "\uC7AC\uBB34"
    ],
    [$5d0851fa8905d151$export$4c29d0d04c15e55d]: [
        'HR',
        "Henkil\xf6st\xf6hallinto",
        'Human Resources',
        'Human resources',
        'human-resources',
        "Lidsk\xe9 zdroje",
        'Menneskelige ressourcer',
        "Nh\xe2n s\u1EF1",
        'Personal',
        "Personalfr\xe5gor",
        'RH',
        'Recursos Humanos',
        'Recursos humanos',
        'Risorse umane',
        "Szem\xe9lyzeti",
        'Zasoby ludzkie',
        "\u0130nsan Kaynaklar\u0131",
        "\u013Dudsk\xe9 zdroje",
        "\u0412\u0456\u0434\u0434\u0456\u043B \u043A\u0430\u0434\u0440\u0456\u0432",
        "\u041A\u0430\u0434\u0440\u043E\u0432\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E32\u0E01\u0E23\u0E1A\u0E38\u0E04\u0E04\u0E25",
        "\u4EBA\u4E8B",
        "\u4EBA\u529B\u8CC7\u6E90",
        "\u4EBA\u529B\u8D44\u6E90",
        "\uC778\uC0AC"
    ],
    [$5d0851fa8905d151$export$881249b988b6030f]: [
        "Departamento jur\xeddico",
        'Hukuk',
        'Jogi',
        'Jura',
        'Juridik',
        'Juridisk',
        "Jur\xeddico",
        'Legal',
        'Legale',
        'Oikeudelliset asiat',
        "Ph\xe1p l\xfd",
        'Prawo',
        "Pr\xe1vne oddelenie",
        "Pr\xe1vn\xed odd\u011Blen\xed",
        'Rechtliches',
        'Service juridique',
        "\xd5igus",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22",
        "\u6CD5\u52D9",
        "\u6CD5\u5F8B",
        "\uBC95\uB960"
    ],
    [$5d0851fa8905d151$export$e4824f74b9879164]: [
        "Markedsf\xf8ring",
        'Marketing',
        'Markkinointi',
        "Marknadsf\xf6ring",
        'Pazarlama',
        "Ti\u1EBFp th\u1ECB",
        'Turundus',
        "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433",
        "\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14",
        "\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0",
        "\u8425\u9500",
        "\u884C\u92B7",
        "\uB9C8\uCF00\uD305"
    ],
    [$5d0851fa8905d151$export$4f3cb0844009af52]: [
        'Drift',
        'Haldus',
        'Operacional',
        'Operaciones',
        'Operacje',
        'Operasyonlar',
        'Operations',
        'Operativer Betrieb',
        'Operazioni',
        "Opera\xe7\xf5es",
        "Op\xe9rations",
        "Prev\xe1dzka",
        'Provoz',
        'Toiminnot',
        "V\u1EADn h\xe0nh",
        "\xdczemeltet\xe9si",
        "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E1D\u0E48\u0E32\u0E22\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23",
        "\u30AA\u30DA\u30EC\u30FC\u30B7\u30E7\u30F3",
        "\u71DF\u904B",
        "\u8FD0\u8425",
        "\uC6B4\uC601"
    ],
    [$5d0851fa8905d151$export$1a65d50c4a641bb4]: [
        "B\xe1n h\xe0ng",
        "F\xf6rs\xe4ljning",
        'Myynti',
        "M\xfc\xfck",
        'Predaj',
        'Prodej',
        'Sales',
        'Salg',
        "Sat\u0131\u015F",
        "Sprzeda\u017C",
        'Vendas',
        'Vendite',
        'Ventas',
        'Ventes',
        'Vertrieb',
        "\xc9rt\xe9kes\xedt\xe9si",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0438",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
        "\u0E1D\u0E48\u0E32\u0E22\u0E02\u0E32\u0E22",
        "\u30BB\u30FC\u30EB\u30B9",
        "\u92B7\u552E",
        "\u9500\u552E",
        "\uC601\uC5C5"
    ],
    [$5d0851fa8905d151$export$b8b1ac856ba1434b]: [
        'Desarrollo de software',
        'Desenvolvimento de software',
        "D\xe9veloppement logiciel",
        'Ohjelmistokehitys',
        "Ph\xe1t tri\u1EC3n ph\u1EA7n m\u1EC1m",
        'Programutveckling',
        'Programvareutvikling',
        'Software Development',
        'Softwareentwicklung',
        'Softwareontwikkeling',
        'Softwareudvikling',
        'Sviluppo software',
        "Szoftverfejleszt\u0151",
        'Tarkvaraarendus',
        'Tworzenie oprogramowania',
        "V\xfdvoj softv\xe9ru",
        "V\xfdvoj softwaru",
        "Yaz\u0131l\u0131m Geli\u015Ftirme",
        "\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u041F\u041E",
        "\u0420\u043E\u0437\u0440\u043E\u0431\u043A\u0430 \u041F\u0417",
        "\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C",
        "\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u958B\u767A",
        "\u8EDF\u9AD4\u958B\u767C",
        "\u8F6F\u4EF6\u5F00\u53D1",
        "\uC18C\uD504\uD2B8\uC6E8\uC5B4 \uAC1C\uBC1C"
    ]
};
const $5d0851fa8905d151$var$BUSINESS_TEAM_TYPES = [
    $5d0851fa8905d151$export$4c29d0d04c15e55d,
    $5d0851fa8905d151$export$3950f7f841bf94b6,
    $5d0851fa8905d151$export$881249b988b6030f,
    $5d0851fa8905d151$export$e4824f74b9879164,
    $5d0851fa8905d151$export$4f3cb0844009af52,
    $5d0851fa8905d151$export$1a65d50c4a641bb4,
    $5d0851fa8905d151$export$b8b1ac856ba1434b
];
const $5d0851fa8905d151$var$BUSINESS_ROLES_PER_TEAM_TYPE = {
    [$5d0851fa8905d151$export$4c29d0d04c15e55d]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$3950f7f841bf94b6]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$881249b988b6030f]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$e4824f74b9879164]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$4f3cb0844009af52]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$1a65d50c4a641bb4]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$b8b1ac856ba1434b]: [
        $5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER
    ]
};
const $5d0851fa8905d151$var$getNormalizedEntry = (userSegValue)=>{
    const lowerCaseUserSegValue = userSegValue.toLowerCase();
    return Object.entries($5d0851fa8905d151$var$USER_SEGMENTATION_CLIENT_MAPPING).find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, translatedValues])=>translatedValues.map((v)=>v.toLowerCase()).includes(lowerCaseUserSegValue));
};
const $5d0851fa8905d151$export$d0bc507f0556398 = (value)=>{
    if (value === '') return $5d0851fa8905d151$export$4c9a72dac5ce80ae;
    const normalizedEntry = $5d0851fa8905d151$var$getNormalizedEntry(value);
    return normalizedEntry !== undefined ? normalizedEntry[0] : $5d0851fa8905d151$export$2f3f9640393bd078;
};
class $5d0851fa8905d151$var$SkipSentryError extends Error {
    constructor(message){
        super(message);
        this.skipSentry = true;
    }
}
const $5d0851fa8905d151$var$fireAnalyticsError = ({ id: id, field: field, error: error, unMatchedValue: unMatchedValue })=>{
    (0, $jcw0u.default)({
        meta: {
            id: id,
            packageName: 'jiraOnboardingCore'
        },
        attributes: {
            field: field,
            unMatchedValue: unMatchedValue
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $5d0851fa8905d151$export$af8a28b856b3556f = (teamType)=>{
    if (!teamType) return false;
    const normalizedTeamType = $5d0851fa8905d151$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'isInSoftwareTeam',
        field: 'teamType',
        error: new $5d0851fa8905d151$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    return normalizedTeamType === $5d0851fa8905d151$export$b8b1ac856ba1434b;
};
const $5d0851fa8905d151$export$517f94ab07724226 = (userAccountData)=>{
    const { teamType: teamType = '', role: role = '' } = userAccountData;
    const normalizedTeamType = $5d0851fa8905d151$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToBusinessUserSegCategory',
        field: 'teamType',
        error: new $5d0851fa8905d151$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    const normalizedRole = $5d0851fa8905d151$export$d0bc507f0556398(role);
    if (normalizedRole === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToBusinessUserSegCategory',
        field: 'role',
        error: new $5d0851fa8905d151$var$SkipSentryError('role mapping is not found'),
        unMatchedValue: role
    });
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'UserSegmentationTeamTypes'.
    const isTeamTypeEligible = $5d0851fa8905d151$var$BUSINESS_TEAM_TYPES.includes(normalizedTeamType);
    const isRoleEligible = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<UserSegmentationTeamTypes, UserSegmentationRoleTypes[]>>'.
    $5d0851fa8905d151$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes($5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE) || // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<UserSegmentationTeamTypes, UserSegmentationRoleTypes[]>>'.
    $5d0851fa8905d151$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes(normalizedRole);
    return isTeamTypeEligible && isRoleEligible;
};
const $5d0851fa8905d151$export$6710e0127706b297 = (userAccountData)=>{
    const { teamType: teamType = '', role: role = '' } = userAccountData;
    const normalizedTeamType = $5d0851fa8905d151$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToSoftwareUserSegCategory',
        field: 'teamType',
        error: new $5d0851fa8905d151$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    const normalizedRole = $5d0851fa8905d151$export$d0bc507f0556398(role);
    if (normalizedRole === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToSoftwareUserSegCategory',
        field: 'role',
        error: new $5d0851fa8905d151$var$SkipSentryError('role mapping is not found'),
        unMatchedValue: role
    });
    const isTeamTypeEligible = normalizedTeamType === $5d0851fa8905d151$export$b8b1ac856ba1434b;
    const isRoleEligible = normalizedRole !== $5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER;
    return isTeamTypeEligible && isRoleEligible;
};

});


parcelRegister("1OQiY", function(module, exports) {

$parcel$export(module.exports, "isTailoredOnboardingM2ExperimentFlagEnabled", () => $58aa46dba9dc7a65$export$4f4879e3b4202c87);

var $6s1PB = parcelRequire("6s1PB");
const $58aa46dba9dc7a65$export$4f4879e3b4202c87 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_tailored_onboarding_jtbd');
    return expConfig.get('isEnabled', false);
};

});


parcelRegister("69X1g", function(module, exports) {

$parcel$export(module.exports, "NavigationPeopleNavItemWrapperNudgeAsync", () => $affd57fc52973db7$export$57ea67608b7cb448);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $affd57fc52973db7$var$NavigationPeopleNavItemLazy = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("hNMiE")).then((exportedModule)=>exportedModule.NavigationPeopleNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-people/index.tsx"
});
const $affd57fc52973db7$export$57ea67608b7cb448 = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$b74a8fdb2c75b869),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$b74a8fdb2c75b869)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "navigation-people-nav-item-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($affd57fc52973db7$var$NavigationPeopleNavItemLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$b74a8fdb2c75b869),
        isInsideMenu: isInsideMenu
    }, children)));

});
parcelRegister("hNMiE", function(module, exports) {

let $cf5c7a9e0a381680$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cf5c7a9e0a381680$var$load("cG8r2").then(()=>parcelRequire('5NaVN'));

});


parcelRegister("annPD", function(module, exports) {

$parcel$export(module.exports, "useBrowseUsersGroupsPermissionsNext", () => $72cc6e3d980d69b6$export$f16858a6f1359756);
$parcel$export(module.exports, "useBrowseUsersGroupsPermissions", () => $72cc6e3d980d69b6$export$c12f7f185a3a245f);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $6yXtV = parcelRequire("6yXtV");
const $72cc6e3d980d69b6$var$deferredPromise = ()=>{
    const deferred = {
        resolve: undefined,
        reject: undefined
    };
    const promise = new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        // @ts-expect-error - TS2322 - Type '(result: boolean) => void' is not assignable to type 'undefined'.
        deferred.resolve = (result)=>{
            resolve(result);
        };
        // @ts-expect-error - TS2322 - Type '(error?: any) => void' is not assignable to type 'undefined'.
        deferred.reject = reject;
    });
    return {
        promise: promise,
        ...deferred
    };
};
class $72cc6e3d980d69b6$var$BrowseUsersGroupsCacheClient {
    fetch() {
        const requestUrl = '/rest/internal/latest/userPermission/browseUsersGroups';
        if (this.promise !== null) return this.promise;
        this.promise = (0, $eusud.performGetRequest)(requestUrl);
        return this.promise;
    }
    constructor(){
        this.promise = null;
    }
}
const $72cc6e3d980d69b6$var$client = new $72cc6e3d980d69b6$var$BrowseUsersGroupsCacheClient();
const $72cc6e3d980d69b6$export$f16858a6f1359756 = (force)=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [{ promise: promise, resolve: resolve, reject: reject }] = (0, $5uXOq.useState)($72cc6e3d980d69b6$var$deferredPromise());
    (0, $5uXOq.useEffect)(()=>{
        if ((isReady || force) && (0, $4R6GH.fg)('dont-auto-close-people-menu')) $72cc6e3d980d69b6$var$client.fetch().then(resolve).catch(reject);
    }, [
        isReady,
        reject,
        resolve,
        force
    ]);
    return (0, $5uXOq.useCallback)(()=>promise, [
        promise
    ]);
};
const $72cc6e3d980d69b6$export$c12f7f185a3a245f = ()=>{
    const [{ isReady: isReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [{ promise: promise, resolve: resolve, reject: reject }] = (0, $5uXOq.useState)($72cc6e3d980d69b6$var$deferredPromise());
    (0, $5uXOq.useEffect)(()=>{
        if (isReady && !(0, $4R6GH.fg)('dont-auto-close-people-menu')) {
            const requestUrl = '/rest/internal/latest/userPermission/browseUsersGroups';
            (0, $eusud.performGetRequest)(requestUrl).then(resolve).catch(reject);
        }
    }, [
        isReady,
        reject,
        resolve
    ]);
    return (0, $5uXOq.useCallback)(()=>promise, [
        promise
    ]);
};

});

parcelRegister("ccG8Y", function(module, exports) {

$parcel$export(module.exports, "getInvitedJswUsers", () => $4cc455613015c89b$export$4b81d3bf9fd2c126);

var $jcw0u = parcelRequire("jcw0u");


var $dXq4S = parcelRequire("dXq4S");

const $4cc455613015c89b$export$4b81d3bf9fd2c126 = (inviteUsersResponse)=>{
    try {
        if (inviteUsersResponse.status === 'fulfilled' && inviteUsersResponse.value.responseStatus === 'success' && 'invited' in inviteUsersResponse.value.response) {
            const invitedUsers = inviteUsersResponse.value.response.invited;
            return invitedUsers.filter((invitedUser)=>{
                const productInvites = Object.keys(invitedUser.results);
                return productInvites.some((invite)=>{
                    const ari = (0, $dXq4S.toAri)(invite);
                    return ari ? (0, $dXq4S.getAriConfig)(ari).resourceOwner === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d) && invitedUser.results[invite] === 'INVITED' : false;
                });
            });
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            error: e,
            meta: {
                id: 'getInvitedJswUsers',
                packageName: (0, $05e1e29a026d4606$export$b8b9d90f9e5bd72b),
                teamName: 'growth-tako'
            }
        });
    }
    return [];
};

});
const $05e1e29a026d4606$export$b8b9d90f9e5bd72b = 'jiraGrowthUtils';




parcelRegister("9i62K", function(module, exports) {

$parcel$export(module.exports, "useShowAssets", () => $ecfb0cbe48af33be$export$6d1797fe1bb33b7a);
$parcel$export(module.exports, "Insight", () => $ecfb0cbe48af33be$export$f9e7e087e1968b4a);

var $5uXOq = parcelRequire("5uXOq");

var $bliJ7 = parcelRequire("bliJ7");

var $7CMCs = parcelRequire("7CMCs");

var $lmyls = parcelRequire("lmyls");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $ktP1V = parcelRequire("ktP1V");

var $ahEft = parcelRequire("ahEft");

var $90yGq = parcelRequire("90yGq");

var $9OXo1 = parcelRequire("9OXo1");

var $4uXxK = parcelRequire("4uXxK");

var $4XiFK = parcelRequire("4XiFK");

var $hFLLE = parcelRequire("hFLLE");
const $ecfb0cbe48af33be$export$6d1797fe1bb33b7a = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    const isJSMUser = appPermissions.hasServiceDeskAccess;
    if ((0, $ktP1V.isCMDBEnabledInEnvironment)()) {
        if (isJSMUser) return true;
    }
    return false;
};
const $ecfb0cbe48af33be$var$Insight = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const isPremiumUser = (0, $ahEft.isLicensedPremiumUser)(tenantContext);
    const isJSMUser = appPermissions.hasServiceDeskAccess;
    const [hasDismissed] = (0, $bliJ7.useUserHasDismissed)();
    const showUpsell = hasDismissed === false && isJSMUser;
    (0, $5uXOq.useEffect)(()=>{
        if (!isPremiumUser && showUpsell) // fire analytics event only for non-premium users that haven't dimissed the Assets upsell page button.
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'cmdbUpsellPageButton viewed', {
            serviceDeskEdition: tenantContext.appEditions?.serviceDesk,
            isSiteAdmin: tenantContext.isSiteAdmin
        });
    }, [
        createAnalyticsEvent,
        isPremiumUser,
        showUpsell,
        tenantContext.appEditions?.serviceDesk,
        tenantContext.isSiteAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "InsightNavMenu",
        packageName: "jiraAtlassianNavigation",
        fallback: "unmount"
    }, !isPremiumUser && showUpsell || isPremiumUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hFLLE.InsightMenuItem), null) : null);
};
const $ecfb0cbe48af33be$export$f9e7e087e1968b4a = ()=>{
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).INSIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bliJ7.CmdbUpsellPageContainer), {
        isGlobal: true,
        atlassianAccountId: atlassianAccountId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XiFK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ecfb0cbe48af33be$var$Insight, null))));
};

});
parcelRegister("bliJ7", function(module, exports) {

$parcel$export(module.exports, "CmdbUpsellPageContainer", () => $215e0f2cc3aecb56$export$185a1503ee62245e);
$parcel$export(module.exports, "useUserHasDismissed", () => $215e0f2cc3aecb56$export$168f6ca47f2dd0d7);
$parcel$export(module.exports, "useCmdbUpsellPageStoreActions", () => $215e0f2cc3aecb56$export$7bdf1f3cf5d7163b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $8aeF9 = parcelRequire("8aeF9");
var $9jmKp = parcelRequire("9jmKp");
const $215e0f2cc3aecb56$export$185a1503ee62245e = (0, $gg7kZ.createContainer)();
const $215e0f2cc3aecb56$var$initialState = {
    userHasDismissed: undefined
};
const $215e0f2cc3aecb56$var$store = (0, $iXqE5.createStore)({
    initialState: $215e0f2cc3aecb56$var$initialState,
    actions: $8aeF9,
    containedBy: $215e0f2cc3aecb56$export$185a1503ee62245e,
    handlers: {
        onInit: $9jmKp.fetchInitialState
    }
});
const $215e0f2cc3aecb56$export$168f6ca47f2dd0d7 = (0, $3sQ5x.createHook)($215e0f2cc3aecb56$var$store, {
    selector: (state)=>state.userHasDismissed
});
const $215e0f2cc3aecb56$export$81f35d374558f538 = (0, $3sQ5x.createHook)($215e0f2cc3aecb56$var$store);
const $215e0f2cc3aecb56$export$7bdf1f3cf5d7163b = (0, $3sQ5x.createActionsHook)($215e0f2cc3aecb56$var$store);
const $215e0f2cc3aecb56$export$d766ac3cb3a067c0 = (0, $51nlc.createSubscriber)($215e0f2cc3aecb56$var$store);

});
parcelRegister("8aeF9", function(module, exports) {

$parcel$export(module.exports, "fetchInitialState", () => (parcelRequire("9jmKp")).fetchInitialState);
$parcel$export(module.exports, "toggleShowPage", () => (parcelRequire("hVpHy")).toggleShowPage);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $9jmKp = parcelRequire("9jmKp");

var $hVpHy = parcelRequire("hVpHy");

});
parcelRegister("9jmKp", function(module, exports) {

$parcel$export(module.exports, "fetchInitialState", () => $bf172d9d821cf507$export$84ded0ac7058ab7a);

var $eeyUP = parcelRequire("eeyUP");
const $bf172d9d821cf507$export$84ded0ac7058ab7a = ()=>async ({ setState: setState, getState: getState }, { atlassianAccountId: atlassianAccountId })=>{
        if (getState().userHasDismissed === undefined) {
            const userHasDismissed = await (0, $eeyUP.fetchHasDismissedProperty)(atlassianAccountId);
            setState({
                userHasDismissed: userHasDismissed
            });
        }
    };

});
parcelRegister("eeyUP", function(module, exports) {

$parcel$export(module.exports, "fetchHasDismissedProperty", () => $2f0ac8757ae7c53f$export$872c472220985d8b);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

const $2f0ac8757ae7c53f$export$872c472220985d8b = async (atlassianAccountId)=>{
    const meta = {
        id: 'fetchUpsellDismissedProperty',
        packageName: 'jiraCmdbUpsellPage'
    };
    if (atlassianAccountId === null) {
        const error = new Error('atlassianAccountId is null');
        (0, $jcw0u.default)({
            error: error,
            meta: meta
        });
        return false;
    }
    try {
        await (0, $89SaW.getUserProperty)(atlassianAccountId, (0, $8f514cf95b75cc66$export$38c3dc12cf3da533));
        return true;
    } catch (error) {
        if (error instanceof Error && (0, $jcw0u.isNetworkError)(error)) // don't capture analytics for this error as this is expected when a user has dimissed
        return false;
        (0, $jcw0u.default)({
            error: error instanceof Error ? error : undefined,
            meta: meta
        });
        return false;
    }
};

});
const $8f514cf95b75cc66$export$38c3dc12cf3da533 = 'jsm-cmdb-upsell-page-dismissed';



parcelRegister("hVpHy", function(module, exports) {

$parcel$export(module.exports, "toggleShowPage", () => $983267917c332983$export$76132886e83e1a9a);

var $b7zXG = parcelRequire("b7zXG");

var $eWMDa = parcelRequire("eWMDa");
const $983267917c332983$export$76132886e83e1a9a = ()=>async ({ getState: getState, dispatch: dispatch })=>{
        const { userHasDismissed: userHasDismissed } = getState();
        if (userHasDismissed) dispatch((0, $eWMDa.enablePage)());
        else if (userHasDismissed === false) dispatch((0, $b7zXG.dismissPage)());
    };

});
parcelRegister("b7zXG", function(module, exports) {

$parcel$export(module.exports, "dismissPage", () => $54ab437faf58b2ea$export$b6e8cf6e649eeb96);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

const $54ab437faf58b2ea$export$b6e8cf6e649eeb96 = ()=>async ({ setState: setState }, { atlassianAccountId: atlassianAccountId })=>{
        // Optimistically hide Assets from the navigation bar immediately
        setState({
            userHasDismissed: true
        });
        try {
            // The specific value being set doesn't matter as long as the property *has* been set
            atlassianAccountId && await (0, $89SaW.setUserProperties)(atlassianAccountId, (0, $8f514cf95b75cc66$export$38c3dc12cf3da533), '1');
        } catch (error) {
            // When setting the user property fails, we still want to hide Assets from the navigation bar
            (0, $jcw0u.default)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'fetchUpsellDismissedProperty',
                    packageName: 'jiraCmdbUpsellPage'
                }
            });
        }
    };

});

parcelRegister("eWMDa", function(module, exports) {

$parcel$export(module.exports, "enablePage", () => $72e0594a39999a08$export$d904731aa3799771);

var $jcw0u = parcelRequire("jcw0u");


var $5aUqV = parcelRequire("5aUqV");
const $72e0594a39999a08$export$d904731aa3799771 = ()=>async ({ setState: setState }, { atlassianAccountId: atlassianAccountId })=>{
        // Optimistically show Assets in the navigation bar immediately
        setState({
            userHasDismissed: false
        });
        try {
            atlassianAccountId && await (0, $5aUqV.deleteUserProperties)('', atlassianAccountId, (0, $8f514cf95b75cc66$export$38c3dc12cf3da533));
        } catch (error) {
            (0, $jcw0u.default)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'fetchUpsellEnabledProperty',
                    packageName: 'jiraCmdbUpsellPage'
                }
            });
        }
    };

});
parcelRegister("5aUqV", function(module, exports) {

$parcel$export(module.exports, "deleteUserProperties", () => $9af5c0a0f8e96e9b$export$3de6197fc2f24c03);

var $89SaW = parcelRequire("89SaW");

var $6no39 = parcelRequire("6no39");
const $9af5c0a0f8e96e9b$export$3de6197fc2f24c03 = async (baseUrl, accountId, propertyKey)=>{
    const url = (0, $89SaW.getUserPropertiesUrl)(accountId, propertyKey);
    return fetch(url, {
        ...(0, $6no39.getDefaultOptions)(url),
        method: 'DELETE'
    });
};

});





parcelRegister("hFLLE", function(module, exports) {

$parcel$export(module.exports, "InsightMenuItem", () => $944d4f2112c8b786$export$eb258e2cec2937f9);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $blEB6 = parcelRequire("blEB6");

var $9OXo1 = parcelRequire("9OXo1");

var $4R6GH = parcelRequire("4R6GH");

var $Mp6qH = parcelRequire("Mp6qH");

var $fVbkk = parcelRequire("fVbkk");

var $7rU7r = parcelRequire("7rU7r");
const $944d4f2112c8b786$export$eb258e2cec2937f9 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSiteAdmin: isSiteAdmin, appEditions: appEditions } = (0, $9OXo1.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        href: (0, $blEB6.getLandingPageUrl)(),
        target: (0, $4R6GH.fg)('assets_as_an_app_v2') ? '_blank' : undefined,
        menuId: (0, $lmyls.MENU_ID).INSIGHT,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).INSIGHT,
        analyticsAttributes: {
            isSiteAdmin: isSiteAdmin,
            serviceDeskEdition: appEditions?.serviceDesk
        }
    }, formatMessage((0, $7rU7r.default).titleCmdbAssets));
};

});
parcelRegister("7rU7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $421905193c27f8ab$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $421905193c27f8ab$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    titleCmdbAssets: {
        "id": "atlassian-navigation.insight.title-cmdb-assets",
        "defaultMessage": "Assets"
    }
});

});



parcelRegister("el0Fl", function(module, exports) {

$parcel$export(module.exports, "useShowRoadmaps", () => $767dc22cd21e9a9b$export$9564042b1b0a7d8f);
$parcel$export(module.exports, "Roadmaps", () => $767dc22cd21e9a9b$export$a68bc1ba98e0d580);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $aOD49 = parcelRequire("aOD49");

var $dWQF5 = parcelRequire("dWQF5");

var $9OXo1 = parcelRequire("9OXo1");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $fVbkk = parcelRequire("fVbkk");

var $6yVM4 = parcelRequire("6yVM4");
const $767dc22cd21e9a9b$export$9564042b1b0a7d8f = ()=>{
    const { appPermissions: appPermissions } = (0, $9OXo1.useTenantContext)();
    const isRoadmapsEnabled = (0, $dWQF5.useIsCrossProjectViewsEnabled)();
    return appPermissions.hasProductDiscoveryAccess && isRoadmapsEnabled;
};
const $767dc22cd21e9a9b$export$90296ede40c0af4a = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $9OXo1.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVbkk.MenuTrigger), {
        href: (0, $aOD49.getCollectionsPageUrl)(),
        menuId: (0, $lmyls.MENU_ID).ROADMAPS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).ROADMAPS,
        analyticsAttributes: {
            isSiteAdmin: isSiteAdmin
        }
    }, formatMessage((0, $6yVM4.default).titleJpdRoadmaps));
};
const $767dc22cd21e9a9b$export$a68bc1ba98e0d580 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).ROADMAPS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($767dc22cd21e9a9b$export$90296ede40c0af4a, null));

});
parcelRegister("6yVM4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe7682072c5451b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2fe7682072c5451b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    titleJpdRoadmaps: {
        "id": "atlassian-navigation.roadmaps.title-jpd-roadmaps",
        "defaultMessage": "Roadmaps"
    }
});

});


parcelRegister("6U0zt", function(module, exports) {

$parcel$export(module.exports, "Addons", () => $10f4e1510a5de408$export$a97e6a0578b4c83);

var $5uXOq = parcelRequire("5uXOq");

var $2uT3N = parcelRequire("2uT3N");

var $kJH82 = parcelRequire("kJH82");

var $azzrO = parcelRequire("azzrO");

var $kaHBi = parcelRequire("kaHBi");

var $6s1PB = parcelRequire("6s1PB");

var $eKYL7 = parcelRequire("eKYL7");

var $koVbs = parcelRequire("koVbs");

var $lmyls = parcelRequire("lmyls");

var $iXVV6 = parcelRequire("iXVV6");

var $dAfqg = parcelRequire("dAfqg");

var $a4k7n = parcelRequire("a4k7n");

var $heI7y = parcelRequire("heI7y");

var $9OXo1 = parcelRequire("9OXo1");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $j94qH = parcelRequire("j94qH");

var $ebYJ0 = parcelRequire("ebYJ0");

var $h5OKf = parcelRequire("h5OKf");

var $1bhgl = parcelRequire("1bhgl");

var $dEiSH = parcelRequire("dEiSH");
const $10f4e1510a5de408$var$AddonsView = ()=>{
    const { key: projectIdOrKey } = (0, $dAfqg.useProjectContext)();
    const [, { load: loadItem, setContext: setContext }] = (0, $kJH82.useAddon)();
    const [, { load: loadForgeItem }] = (0, $eKYL7.useForgeGlobalItems)();
    (0, $5uXOq.useEffect)(()=>{
        setContext({
            projectIdOrKey: projectIdOrKey
        });
    }, [
        projectIdOrKey,
        setContext
    ]);
    const [{ hasSuccessOnce: hasSuccessOnceUserSegmentation }, { loadPersonalisedAppsUserSegmentation: loadPersonalisedAppsUserSegmentation }] = (0, $h5OKf.usePersonalisedAppsTeamType)();
    const { cloudId: cloudId, isAnonymous: isAnonymous } = (0, $9OXo1.useTenantContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).ADDONS,
        analyticsSource: 'atlassian-navigation'
    });
    const onBeforeMenuOpen = (0, $5uXOq.useCallback)(()=>{
        onStart();
        loadItem();
        loadForgeItem({
            cloudId: cloudId,
            isAnonymous: isAnonymous
        });
        !hasSuccessOnceUserSegmentation && loadPersonalisedAppsUserSegmentation();
        (0, $azzrO.NAVIGATION_TOP_DROPDOWN_MARKS).ADDONS.start();
    }, [
        onStart,
        loadItem,
        hasSuccessOnceUserSegmentation,
        loadPersonalisedAppsUserSegmentation,
        loadForgeItem,
        cloudId,
        isAnonymous
    ]);
    const attributes = (0, $5uXOq.useMemo)(()=>({
            isEmbeddedMarketplaceEnabledForEndUsers: (0, $6s1PB.expVal)('enduser-emcee-discover', 'value', true),
            isEmbeddedMarketplaceSpaEnabled: true
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebYJ0.Popup), {
        menuId: (0, $lmyls.MENU_ID).ADDONS,
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).ADDONS,
        Menu: (0, $1bhgl.AsyncMenu),
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $dEiSH.default).apps)
    }, formatMessage((0, $dEiSH.default).apps)));
};
const $10f4e1510a5de408$export$a97e6a0578b4c83 = ()=>{
    const { isVisible: isVisible } = (0, $2uT3N.useOverflowStatus)();
    const [{ hasOpened: shouldShowNudge }] = (0, $heI7y.useHasOpened)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $lmyls.MENU_ID).ADDONS
    }, !false && shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a4k7n.NavigationAppsNavItemWrapperNudgeAsync), {
        isInsideMenu: !isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j94qH.FullHeightTextColorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10f4e1510a5de408$var$AddonsView, null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10f4e1510a5de408$var$AddonsView, null));
};

});
parcelRegister("kJH82", function(module, exports) {

$parcel$export(module.exports, "useAddon", () => $0672771da90f2be9$export$550c6d89b9b85724);

var $6Rmr1 = parcelRequire("6Rmr1");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $0672771da90f2be9$var$handleFetch = ()=>async ({ setState: setState, getState: getState })=>{
        const { fetchAddons: fetchAddons, fetchAddonContext: fetchAddonContext, isFetching: isFetching } = getState();
        if (!isFetching) try {
            const promise = fetchAddons(undefined, fetchAddonContext);
            setState({
                isFetching: true,
                fetchError: null,
                promise: promise
            });
            const items = await promise;
            setState({
                items: items,
                hasFetchedOnce: true,
                hasSuccessOnce: true,
                isFetching: false,
                fetchError: null,
                promise: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            setState({
                ...getState(),
                fetchError: fetchError,
                hasFetchedOnce: true,
                isFetching: false,
                promise: null
            });
        }
    };
const $0672771da90f2be9$var$actions = {
    load: ()=>async ({ dispatch: dispatch })=>{
            const promise = dispatch($0672771da90f2be9$var$handleFetch());
            await promise;
        },
    setFavourite: (item, isAddon)=>async ({ setState: setState, getState: getState })=>{
            const { items: items, addToFavorite: addToFavorite, removeFromFavorite: removeFromFavorite } = getState();
            const newItemData = {
                ...item,
                favourite: true
            };
            if (isAddon) {
                setState({
                    items: [
                        newItemData,
                        ...items
                    ]
                });
                await addToFavorite(newItemData);
            } else {
                setState({
                    items: items.filter((theItem)=>theItem.id !== item.id)
                });
                await removeFromFavorite(item);
            }
        },
    setContext: (context)=>({ setState: setState })=>{
            setState({
                fetchAddonContext: context
            });
        }
};
const $0672771da90f2be9$export$f350d6bef9972cd3 = (defaults)=>{
    const initialState = {
        fetchAddons: defaults.fetchAddons,
        fetchAddonContext: {},
        addToFavorite: defaults.addToFavorite,
        removeFromFavorite: defaults.removeFromFavorite,
        hasFetchedOnce: false,
        hasSuccessOnce: false,
        items: [],
        fetchError: null,
        promise: null,
        isFetching: false
    };
    const Store = (0, $iXqE5.createStore)({
        name: 'addon-store',
        actions: $0672771da90f2be9$var$actions,
        initialState: initialState
    });
    const AddonContainer = (0, $gg7kZ.createContainer)(Store, {
        onInit: ()=>(api, props)=>{
                api.setState({
                    fetchAddons: props.fetchAddons,
                    addToFavorite: props.addToFavorite,
                    removeFromFavorite: props.removeFromFavorite
                });
            }
    });
    const AddonTestContainer = (0, $gg7kZ.createContainer)(Store, {
        onInit: ()=>(api, props)=>{
                api.setState(props);
            }
    });
    const selector = ({ items: items, hasFetchedOnce: hasFetchedOnce, fetchError: fetchError, promise: promise, hasSuccessOnce: hasSuccessOnce, isFetching: isFetching })=>({
            items: items,
            hasFetchedOnce: hasFetchedOnce,
            hasSuccessOnce: hasSuccessOnce,
            fetchError: fetchError,
            promise: promise,
            isFetching: isFetching
        });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const AddonSubscriber = (0, $51nlc.createSubscriber)(Store, {
        displayName: 'AddonSubscriber',
        selector: selector
    }); // Bug with createSubscriber type means that React children end up "never"
    // Deprecated: to be removed
    const useAddonActions = (0, $3sQ5x.createHook)(Store, {
        selector: selector
    });
    const useAddon = (0, $3sQ5x.createHook)(Store, {
        selector: selector
    });
    return {
        AddonSubscriber: AddonSubscriber,
        useAddonActions: useAddonActions,
        useAddon: useAddon,
        AddonTestContainer: AddonTestContainer,
        AddonContainer: AddonContainer
    };
};
const $0672771da90f2be9$var$defaultAddToFavorite = ()=>// TODO: to be implemented when api is ready
    new Promise(()=>null);
const $0672771da90f2be9$var$defaultRemoveFromFavorite = ()=>// TODO: to be implemented when api is ready
    new Promise(()=>null);
const { useAddon: $0672771da90f2be9$export$550c6d89b9b85724 } = $0672771da90f2be9$export$f350d6bef9972cd3({
    fetchAddons: (0, $6Rmr1.fetchAddonItems),
    addToFavorite: $0672771da90f2be9$var$defaultAddToFavorite,
    removeFromFavorite: $0672771da90f2be9$var$defaultRemoveFromFavorite
});

});
parcelRegister("6Rmr1", function(module, exports) {

$parcel$export(module.exports, "fetchAddonItems", () => $c9dd134b6cc78152$export$fe5ef9b24322d3c1);

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");

var $g5X3G = parcelRequire("g5X3G");

var $fPruT = parcelRequire("fPruT");

const $c9dd134b6cc78152$var$handleError = (error)=>{
    // Temp
    throw error;
};
const $c9dd134b6cc78152$export$fe5ef9b24322d3c1 = async (baseUrl = (0, $g5X3G.toBaseUrl)(''), context)=>{
    const params = $c9dd134b6cc78152$var$getContextParams(context);
    const url = `${baseUrl}/rest/navigation/3/global/addons${params ? `?${params}` : ''}`;
    try {
        const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
        if (!response.ok) {
            const errorCode = response.status;
            if (errorCode === 401) return $c9dd134b6cc78152$var$handleError(new (0, $fPruT.AuthenticationError)(`${errorCode}`));
            return $c9dd134b6cc78152$var$handleError(new (0, $jJZqs.default)(errorCode, response.statusText));
        }
        const addonsItems = await response.json();
        // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
        return addonsItems.map((item)=>({
                id: item.id,
                title: item.name,
                avatarUrl: item.iconUrl,
                type: (0, $49a076eb01652100$export$5e2cc09b58170ca2),
                url: item.url,
                className: item.styleClass
            }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // network issue
        return $c9dd134b6cc78152$var$handleError(error);
    }
};
function $c9dd134b6cc78152$var$getContextParams(context) {
    const filteredParams = Object.fromEntries(Object.entries(context || {}).filter(([, value])=>!!value));
    return new URLSearchParams(filteredParams).toString();
}

});


parcelRegister("eKYL7", function(module, exports) {

$parcel$export(module.exports, "useForgeGlobalItems", () => $b1e0d26740806b04$export$fa6081acdcc112a0);

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $5cmSg = parcelRequire("5cmSg");

var $iVaKa = parcelRequire("iVaKa");

var $3HwlS = parcelRequire("3HwlS");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $b1e0d26740806b04$var$getItemHref = (extension)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/apps/${appId}/${envId}`;
};
const $b1e0d26740806b04$var$transformTitle = (title, environmentType, environmentKey)=>{
    if (environmentType === (0, $k2DRb.DEVELOPMENT_ENVIRONMENT) && environmentKey !== (0, $k2DRb.DEFAULT_ENVIRONMENT_KEY)) return `${title} - ${environmentKey}`;
    return title;
};
const $b1e0d26740806b04$var$handleFetch = ({ cloudId: cloudId, isAnonymous: isAnonymous })=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
    async ({ setState: setState, getState: getState })=>{
        const { isFetching: isFetching } = getState();
        if (!isFetching) try {
            // If Nav4 is enabled, we don't need to fetch global items since they are implemented elsewhere.
            if ((0, $3HwlS.getWillShowNav4)()) return;
            const promise = (0, $iVaKa.fetchModules)({
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                context: {},
                includeHidden: true,
                types: [
                    (0, $k2DRb.GLOBAL_PAGE_MODULE)
                ],
                source: (0, $k2DRb.SOURCE_NAVIGATION)
            });
            setState({
                isFetching: true,
                fetchError: null,
                promise: promise
            });
            const data = await promise;
            const globalPageData = data ? data[0, $k2DRb.GLOBAL_PAGE_MODULE] : [];
            const items = globalPageData.filter((0, $5cmSg.isExtensionVisible)).map((extension)=>({
                    id: extension.id,
                    title: $b1e0d26740806b04$var$transformTitle(extension.properties.title, extension.environmentType, extension.environmentKey),
                    avatarUrl: extension.properties.icon,
                    url: $b1e0d26740806b04$var$getItemHref(extension),
                    environmentType: extension.environmentType,
                    module: (0, $k2DRb.GLOBAL_PAGE_MODULE)
                }));
            setState({
                items: items,
                hasFetchedOnce: true,
                hasSuccessOnce: true,
                isFetching: false,
                fetchError: null,
                promise: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            setState({
                ...getState(),
                fetchError: fetchError,
                hasFetchedOnce: true,
                isFetching: false,
                promise: null
            });
        }
    };
const $b1e0d26740806b04$var$actions = {
    load: ({ cloudId: cloudId, isAnonymous: isAnonymous })=>async ({ dispatch: dispatch })=>{
            const promise = dispatch($b1e0d26740806b04$var$handleFetch({
                cloudId: cloudId,
                isAnonymous: isAnonymous
            }));
            await promise;
        }
};
const $b1e0d26740806b04$export$a87c2a3d589b7efd = ()=>{
    const initialState = {
        hasFetchedOnce: false,
        hasSuccessOnce: false,
        items: [],
        promise: null,
        fetchError: null,
        isFetching: false
    };
    const Store = (0, $iXqE5.createStore)({
        name: 'forge-global-items-store',
        actions: // @ts-expect-error - TS2322 - Type '{ readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<void>; }' is not assignable to type 'Record<string, ActionThunk<{ fetchForgeModule: (arg1: { cloudId: string; moduleName: FullPageModule; }) => Promise<FullPage[] | null>; hasFetchedOnce: boolean; ... 4 more ...; isFetching: boolean; }, { ...; }>>'.
        $b1e0d26740806b04$var$actions,
        initialState: initialState
    });
    // @ts-expect-error - TS2344 - Type '{ readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<void>; }' does not satisfy the constraint 'Record<string, ActionThunk<GenericState<I>, { readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<...>; }>>'.
    const ForgeGlobalItemsTestContainer = (0, $gg7kZ.createContainer)(Store, {
        onInit: ()=>(api, props)=>{
                api.setState(props);
            }
    });
    const selector = ({ items: // @ts-expect-error - TS7031 - Binding element 'items' implicitly has an 'any' type.
    items, hasFetchedOnce: // @ts-expect-error - TS7031 - Binding element 'hasFetchedOnce' implicitly has an 'any' type.
    hasFetchedOnce, fetchError: // @ts-expect-error - TS7031 - Binding element 'fetchError' implicitly has an 'any' type.
    fetchError, promise: // @ts-expect-error - TS7031 - Binding element 'promise' implicitly has an 'any' type.
    promise, hasSuccessOnce: // @ts-expect-error - TS7031 - Binding element 'hasSuccessOnce' implicitly has an 'any' type.
    hasSuccessOnce, isFetching: // @ts-expect-error - TS7031 - Binding element 'isFetching' implicitly has an 'any' type.
    isFetching })=>({
            items: items,
            hasFetchedOnce: hasFetchedOnce,
            fetchError: fetchError,
            promise: promise,
            hasSuccessOnce: hasSuccessOnce,
            isFetching: isFetching
        });
    // @ts-expect-error - TS2344 - Type '{ readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<void>; }' does not satisfy the constraint 'Record<string, ActionThunk<GenericState<I>, { readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<...>; }>>'.
    const ForgeGlobalItemsSubscriber = (0, $51nlc.createSubscriber)(Store, {
        displayName: 'ForgeGlobalItemsSubscriber',
        selector: selector
    });
    const useForgeGlobalItems = (0, $3sQ5x.createHook)(Store, {
        selector: selector
    });
    // @ts-expect-error - TS2322 - Type 'HookFunction<{ items: any; hasFetchedOnce: any; fetchError: any; promise: any; hasSuccessOnce: any; isFetching: any; }, BoundActions<{ fetchForgeModule: (arg1: { cloudId: string; moduleName: FullPageModule; }) => Promise<...>; ... 5 more ...; isFetching: boolean; }, Record<...>>, void>' is not assignable to type '() => HookReturnValue<GenericPublicState<I>, { readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<...>; }>'.
    return {
        ForgeGlobalItemsSubscriber: ForgeGlobalItemsSubscriber,
        useForgeGlobalItems: useForgeGlobalItems,
        ForgeGlobalItemsTestContainer: ForgeGlobalItemsTestContainer
    };
};
const { useForgeGlobalItems: $b1e0d26740806b04$export$fa6081acdcc112a0 } = $b1e0d26740806b04$export$a87c2a3d589b7efd();

});

parcelRegister("h5OKf", function(module, exports) {

$parcel$export(module.exports, "usePersonalisedAppsTeamType", () => $1c093da579689f30$export$952bf3a355bf4d23);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $cE27s = parcelRequire("cE27s");
const $1c093da579689f30$var$initialState = {
    isLoading: false,
    isSuccess: false,
    error: null,
    promise: null,
    teamType: undefined,
    hasSuccessOnce: false
};
const $1c093da579689f30$var$store = (0, $iXqE5.createStore)({
    actions: $cE27s.actions,
    initialState: $1c093da579689f30$var$initialState,
    name: 'atlassian-navigation-addons-personalised-apps-team-type'
});
const $1c093da579689f30$export$952bf3a355bf4d23 = (0, $3sQ5x.createHook)($1c093da579689f30$var$store);
const $1c093da579689f30$export$202fd798d158e553 = (0, $3sQ5x.createHook)($1c093da579689f30$var$store, {
    selector: null
});

});
parcelRegister("cE27s", function(module, exports) {

$parcel$export(module.exports, "actions", () => $cbb59c8ecf2badc7$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $i5yN4 = parcelRequire("i5yN4");

var $26xre = parcelRequire("26xre");
const $cbb59c8ecf2badc7$var$loadPersonalisedAppsUserSegmentation = ()=>async ({ setState: setState })=>{
        const promise = (0, $i5yN4.getUserSegmentationData)();
        setState({
            error: null,
            isLoading: true,
            isSuccess: false,
            promise: promise
        });
        try {
            const { team: team } = await promise;
            const teamType = (0, $26xre.mapUserTeamTypeToTeamType)(team);
            setState({
                teamType: teamType,
                isSuccess: true,
                hasSuccessOnce: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                error: error
            });
        } finally{
            setState({
                isLoading: false
            });
        }
    };
const $cbb59c8ecf2badc7$export$e324594224ef24da = {
    loadPersonalisedAppsUserSegmentation: $cbb59c8ecf2badc7$var$loadPersonalisedAppsUserSegmentation
};

});
parcelRegister("i5yN4", function(module, exports) {

$parcel$export(module.exports, "getUserSegmentationData", () => $d567b9983c1fa90f$export$f0a14a7cbbb7397e);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $d567b9983c1fa90f$var$GET_ME_URL = '/gateway/api/me';
const $d567b9983c1fa90f$export$318c25600a19e2ee = ()=>(0, $eusud.performGetRequest)($d567b9983c1fa90f$var$GET_ME_URL);
const $d567b9983c1fa90f$export$f0a14a7cbbb7397e = async ()=>{
    let response = {
        jobTitle: undefined,
        team: undefined
    };
    try {
        const { extended_profile: extendedProfile } = await $d567b9983c1fa90f$export$318c25600a19e2ee();
        const { job_title: jobTitle, team_type: team } = extendedProfile;
        response = {
            jobTitle: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'undefined'.
            jobTitle,
            team: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'undefined'.
            team
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // failed to fetch user segmentation data, analytics will be added later
        (0, $jcw0u.default)({
            meta: {
                id: 'getUserSegmentationData',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            },
            error: error
        });
    }
    return response;
};

});

parcelRegister("26xre", function(module, exports) {

$parcel$export(module.exports, "mapUserTeamTypeToTeamType", () => $3464a59742bad1ac$export$38b9d6b529723f8c);

var $2nA8w = parcelRequire("2nA8w");
const $3464a59742bad1ac$export$38b9d6b529723f8c = (team)=>{
    switch(team){
        case (0, $2nA8w.PERSONALISED_APPS_TEAM_TYPES).softwareDevelopment:
            return (0, $2nA8w.PERSONALISED_APPS_TEAM_TYPES).softwareDevelopment;
        case (0, $2nA8w.PERSONALISED_APPS_TEAM_TYPES).itSupport:
            return (0, $2nA8w.PERSONALISED_APPS_TEAM_TYPES).itSupport;
        default:
            return (0, $2nA8w.PERSONALISED_APPS_TEAM_TYPES).marketing;
    }
};

});
parcelRegister("2nA8w", function(module, exports) {

$parcel$export(module.exports, "PERSONALISED_APPS_TEAM_TYPES", () => $e0c89db7eea0cd0a$export$2bdcfab7823ff30);
const $e0c89db7eea0cd0a$export$2bdcfab7823ff30 = {
    marketing: 'Business Management and Operations',
    itSupport: 'IT Support',
    softwareDevelopment: 'Software Development'
};

});




parcelRegister("1bhgl", function(module, exports) {

$parcel$export(module.exports, "AsyncMenu", () => $ed4263c510e6df56$export$81adf29ff528dc9c);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $70rf1 = parcelRequire("70rf1");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");
var $Ix35T = parcelRequire("Ix35T");

var $ag3sS = parcelRequire("ag3sS");

var $9TMfX = parcelRequire("9TMfX");
const $ed4263c510e6df56$var$Skeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ag3sS.MenuLayout), {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed4263c510e6df56$var$AppsSectionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9TMfX.MenuSkeletonContent), null)));

const $ed4263c510e6df56$export$c49a6d699b74b197 = (0, $b7Svb.lazy)(()=>(parcelRequire("dwRIK")).then((module)=>module.Menu), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/addons/menu/index.tsx"
});
const $ed4263c510e6df56$export$81adf29ff528dc9c = ({ shouldLoad: shouldLoad = true })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Ix35T.LazyWait), {
        until: shouldLoad
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed4263c510e6df56$var$Skeleton, null),
        name: "lazy-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed4263c510e6df56$export$c49a6d699b74b197, null)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $ed4263c510e6df56$var$AppsSectionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $70rf1.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1tke12am",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dwRIK", function(module, exports) {

let $9d97ef5115e8ee46$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9d97ef5115e8ee46$var$load("3xImw").then(()=>parcelRequire('4opAu'));

});


parcelRegister("dEiSH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4ce60ec2367163b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f4ce60ec2367163b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    apps: {
        "id": "atlassian-navigation.addons.apps",
        "defaultMessage": "Apps"
    }
});

});


parcelRegister("fwJYI", function(module, exports) {

$parcel$export(module.exports, "Search", () => $e3b17dd8db2850a9$export$4b85d3515bd863a5);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

var $Mp6qH = parcelRequire("Mp6qH");

var $gIk9n = parcelRequire("gIk9n");

var $crtj2 = parcelRequire("crtj2");

var $gIJdF = parcelRequire("gIJdF");
const $e3b17dd8db2850a9$var$LoadingSkeleton = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gIJdF.Skeleton), {
        placeholder: formatMessage((0, $gIk9n.default).interactiveSearchSkeletonPlaceholder),
        ariaLabel: formatMessage((0, $gIk9n.default).interactiveSearchSkeletonAriaLabel)
    });
};
const $e3b17dd8db2850a9$var$SearchDialogMetricStart = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $crtj2.searchDialogMetric).startFromPageLoad();
        (0, $crtj2.searchDialogMetric).mark((0, $crtj2.SEARCH_DIALOG_DOWNLOAD_START_MARK));
    }, []);
    return null;
};
const $e3b17dd8db2850a9$var$SearchDialogMetricEnd = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $crtj2.searchDialogMetric).mark((0, $crtj2.SEARCH_DIALOG_DOWNLOAD_END_MARK));
    }, []);
    return null;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e3b17dd8db2850a9$var$LazySearch = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("66zAu")).then((m)=>m.Search), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/search/main.tsx"
});
const $e3b17dd8db2850a9$export$4b85d3515bd863a5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "search",
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e3b17dd8db2850a9$var$SearchDialogMetricStart, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy-search",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e3b17dd8db2850a9$var$LoadingSkeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e3b17dd8db2850a9$var$LazySearch, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e3b17dd8db2850a9$var$SearchDialogMetricEnd, null)));

});
parcelRegister("gIk9n", function(module, exports) {

$parcel$export(module.exports, "default", () => $b88bffd5106f4b78$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b88bffd5106f4b78$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    updated: {
        "id": "atlassian-navigation.search.updated",
        "defaultMessage": "Updated"
    },
    interactiveSearchSkeletonPlaceholder: {
        "id": "atlassian-navigation.search.interactive-search-skeleton-placeholder",
        "defaultMessage": "Search"
    },
    interactiveSearchSkeletonAriaLabel: {
        "id": "atlassian-navigation.search.interactive-search-skeleton-aria-label",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("crtj2", function(module, exports) {

$parcel$export(module.exports, "SEARCH_DIALOG_DOWNLOAD_START_MARK", () => $f04658be14f95c1c$export$8cd6a987249a6f33);
$parcel$export(module.exports, "SEARCH_DIALOG_DOWNLOAD_END_MARK", () => $f04658be14f95c1c$export$80ab6637ae730993);
$parcel$export(module.exports, "searchDialogMetric", () => $f04658be14f95c1c$export$46d64d80a1040e9b);

var $2nKjG = parcelRequire("2nKjG");
const $f04658be14f95c1c$var$SEARCH_DIALOG_METRIC_KEY = 'search-dialog';
const $f04658be14f95c1c$export$8cd6a987249a6f33 = 'download-start';
const $f04658be14f95c1c$export$80ab6637ae730993 = 'download-end';
const $f04658be14f95c1c$export$46d64d80a1040e9b = (0, $2nKjG.metrics).pageSegmentLoad({
    key: $f04658be14f95c1c$var$SEARCH_DIALOG_METRIC_KEY,
    timings: [
        {
            key: 'download',
            startMark: $f04658be14f95c1c$export$8cd6a987249a6f33,
            endMark: $f04658be14f95c1c$export$80ab6637ae730993
        }
    ]
});

});

parcelRegister("gIJdF", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $315a2135ffa56c8b$export$8f31e4c4a37b8e9c);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $3HwlS = parcelRequire("3HwlS");

var $h3DPn = parcelRequire("h3DPn");

var $gAdxH = parcelRequire("gAdxH");

var $eoNiZ = parcelRequire("eoNiZ");
const $315a2135ffa56c8b$export$8f31e4c4a37b8e9c = ({ ProductSearchInputSkeleton: ProductSearchInputSkeleton = (0, $gAdxH.ProductSearchInputSkeleton), useTheme: useTheme = (0, $eoNiZ.useTheme), placeholder: placeholder, ariaLabel: ariaLabel })=>{
    /**
	 * The nav3 custom theme object
	 */ const theme = useTheme();
    /**
	 * A nav4 search theme that works with the nav3 theming API
	 */ const newTheme = (0, $h3DPn.useLegacySearchTheme)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProductSearchInputSkeleton, {
        shouldFillContainer: (0, $3HwlS.getWillShowNav4)(),
        theme: (0, $3HwlS.getWillShowNav4)() ? newTheme : theme && theme.mode && theme.mode.search,
        placeholder: placeholder,
        ariaLabel: ariaLabel
    });
};

});

parcelRegister("66zAu", function(module, exports) {

let $471ee88c2d3af691$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $471ee88c2d3af691$var$load("h2MrD"),
    $471ee88c2d3af691$var$load("bYT2S"),
    $471ee88c2d3af691$var$load("hPzOn"),
    $471ee88c2d3af691$var$load("dsiAd"),
    $471ee88c2d3af691$var$load("3G8pv")
]).then(()=>parcelRequire('1jMgA'));

});


parcelRegister("jUhOq", function(module, exports) {

$parcel$export(module.exports, "ConversationAssistant", () => $a6baf802cdb95631$export$9777b121d71c4de1);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");

var $6Dd8Z = parcelRequire("6Dd8Z");

var $jVuEq = parcelRequire("jVuEq");

var $dETjw = parcelRequire("dETjw");

var $jAO3g = parcelRequire("jAO3g");


var $7XYc4 = parcelRequire("7XYc4");

var $hsmeR = parcelRequire("hsmeR");

var $2Ui4E = parcelRequire("2Ui4E");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $kkNtb = parcelRequire("kkNtb");

var $koeKL = parcelRequire("koeKL");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $ideHW = parcelRequire("ideHW");
const $a6baf802cdb95631$var$AssistantButton = (0, $7XYc4.componentWithCondition)(()=>(0, $3HwlS.getWillShowNav4)(), (0, $jAO3g.ConversationAssistantButtonNav4), (0, $jAO3g.ConversationAssistantButton));
const $a6baf802cdb95631$var$ConversationAssistantButton = ()=>{
    const [_topMenusValue, { off: closeAllMenus }] = (0, $2Ui4E.useTopMenus)();
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const { panelId: panelId, isCollapsed: isCollapsed } = (0, $hsmeR.useActiveRightSidebarState)() || {};
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const isActive = panelId === (0, $537cb35f009e92c2$export$dffb4ed44e20ea9a) && !isCollapsed;
    const onButtonClickOld = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), 'aiMate', {
            opened: isCollapsed,
            isActive: isActive
        });
        if (isActive) closeCurrentRightSidebar();
        else openRightSidebar((0, $537cb35f009e92c2$export$dffb4ed44e20ea9a), (0, $537cb35f009e92c2$export$64aee74ba59709e5), false, true);
        closeAllMenus();
    }, [
        closeAllMenus,
        closeCurrentRightSidebar,
        createAnalyticsEvent,
        isActive,
        isCollapsed,
        openRightSidebar
    ]);
    const onButtonClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), 'aiMate', {
            opened: !isActive,
            isActive: isActive
        });
        isActive ? closeCurrentRightSidebar() : openRightSidebar((0, $537cb35f009e92c2$export$dffb4ed44e20ea9a), (0, $537cb35f009e92c2$export$64aee74ba59709e5), false, true);
        closeAllMenus();
    }, [
        isActive,
        closeAllMenus,
        closeCurrentRightSidebar,
        openRightSidebar,
        createAnalyticsEvent
    ]);
    const buttonRender = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "span",
        paddingInlineStart: (0, $3HwlS.getWillShowNav4)() ? undefined : 'space.050',
        testId: "atlassian-navigation.ui.conversation-assistant.app-navigation-ai-mate",
        role: // This element is a direct descendant of the top nav actions list, so needs the listitem role.
        // While the button is internally wrapped in a listitem, screen readers do not pick this up due to multiple wrapper elements.
        (0, $3HwlS.getWillShowNav4)() ? 'listitem' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a6baf802cdb95631$var$AssistantButton, {
        onClick: (0, $3HwlS.getWillShowNav4)() ? onButtonClick : onButtonClickOld,
        isActive: isActive,
        siteId: cloudId,
        productKey: "jira"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, buttonRender, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dETjw.ChatContextSubscriber), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Dd8Z.ChatOpenerSubscriber), {
        onTriggerOpeningChat: ()=>{
            if (!isActive) openRightSidebar((0, $537cb35f009e92c2$export$dffb4ed44e20ea9a), (0, $537cb35f009e92c2$export$64aee74ba59709e5), false, true);
        }
    }));
};
const $a6baf802cdb95631$export$9777b121d71c4de1 = ()=>{
    const { data: data } = (0, $kkNtb.useRovoEntitlementResource)();
    const shouldShowConversationAssistantButton = data?.isRovoLLMEnabled ?? false;
    const buttonRender = shouldShowConversationAssistantButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a6baf802cdb95631$var$ConversationAssistantButton, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ideHW.RovoDemandTest), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).CONVERSATION_ASSISTANT
    }, buttonRender, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jVuEq.RovoEntitlementSetter), {
        isRovoEnabled: shouldShowConversationAssistantButton
    }));
};

});
parcelRegister("ideHW", function(module, exports) {

$parcel$export(module.exports, "RovoDemandTest", () => $458b20de6608c1cd$export$6b60f48811782803);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $6NNA3 = parcelRequire("6NNA3");

var $5QEhh = parcelRequire("5QEhh");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");
const $458b20de6608c1cd$var$RovoDemandTestButton = ()=>{
    const isEnrolled = (0, $6NNA3.useIsEnrolledInExperience)();
    const buttonRender = isEnrolled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5QEhh.default), null) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, buttonRender);
};
const $458b20de6608c1cd$var$RovoDemandTestButtonWithErrorBoundary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).ROVO_DEMAND_TESTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($458b20de6608c1cd$var$RovoDemandTestButton, null));
const $458b20de6608c1cd$export$6b60f48811782803 = (0, $cSD7y.componentWithFG)('jsw_rovo_demand_tests_gate', $458b20de6608c1cd$var$RovoDemandTestButtonWithErrorBoundary, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null));

});
parcelRegister("6NNA3", function(module, exports) {

$parcel$export(module.exports, "useIsEnrolledInExperience", () => $83c9cc042cf76acf$export$32dd30a4116853f7);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $5oBMG = parcelRequire("5oBMG");
const $83c9cc042cf76acf$export$32dd30a4116853f7 = ()=>{
    const productEntitlementDetails = (0, $5oBMG.useProductEntitlementDetails)();
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig, fireExperimentExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_rovo_demand_tests_page');
    const cohort = expConfig.get('cohort', 'not-enrolled');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const isInTrial = (0, $5uXOq.useMemo)(()=>{
        const supportedProducts = [
            'jira-software',
            'jira-product-discovery',
            'jira-servicedesk'
        ];
        let trialing = false;
        if (productEntitlementDetails) Object.keys(productEntitlementDetails).forEach((product)=>{
            if (supportedProducts.includes(product) && productEntitlementDetails[product].trialEndTime) trialing = true;
        });
        return trialing;
    }, [
        productEntitlementDetails
    ]);
    const isEnrolled = (0, $5uXOq.useMemo)(()=>{
        if (cohort === 'not-enrolled' || isInTrial) return false;
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraRovoDemandTesting exposed', {
            cohort: cohort
        });
        fireExperimentExposure();
        return cohort === 'test';
    }, [
        cohort,
        isInTrial,
        createAnalyticsEvent,
        fireExperimentExposure
    ]);
    if (isEnrolled) return true;
    return false;
};

});

parcelRegister("5QEhh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c2f9e5997133cbe$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eXSfx = parcelRequire("eXSfx");

var $kk4W6 = parcelRequire("kk4W6");

var $0yZbT = parcelRequire("0yZbT");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $1f8Sx = parcelRequire("1f8Sx");
const $3c2f9e5997133cbe$var$defaultButtonStyles = {
    paddingInline: '8px'
};
const $3c2f9e5997133cbe$var$inactiveButtonStyles = {
    background: "var(--ds-background-neutral, #091E420F)"
};
function $3c2f9e5997133cbe$export$2e2bcd8739ae039() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const isActive = window.location.href.endsWith('software/rovo/discover');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "jiraRovoDemandTesting topNavButton",
        sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "span",
        paddingInlineStart: (0, $3HwlS.getWillShowNav4)() ? undefined : 'space.050',
        role: (0, $3HwlS.getWillShowNav4)() ? 'listitem' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eXSfx.PrimaryButton), {
        href: "/jira/software/rovo/discover",
        /* eslint-disable-next-line jira/react/no-style-attribute */ style: {
            /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ ...$3c2f9e5997133cbe$var$defaultButtonStyles,
            ...!isActive && $3c2f9e5997133cbe$var$inactiveButtonStyles
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kk4W6.RovoIcon), {
            size: "xsmall",
            label: ""
        }),
        tooltip: formatMessage((0, $1f8Sx.default).discoverRovoButtonTooltip),
        isSelected: isActive,
        onClick: (_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'rovoDemandTestButton');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1f8Sx.default).rovoButtonCopy))));
}

});
parcelRegister("1f8Sx", function(module, exports) {

$parcel$export(module.exports, "default", () => $923d3bf735ccc9b6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $923d3bf735ccc9b6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    rovoButtonCopy: {
        "id": "jira-rovo-demand-testing.ui.top-nav-button.rovo-button-copy",
        "defaultMessage": "Rovo"
    },
    discoverRovoButtonTooltip: {
        "id": "jira-rovo-demand-testing.ui.top-nav-button.rovo-discover-button-tooltip",
        "defaultMessage": "Discover Rovo"
    }
});

});




parcelRegister("inFGE", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $611a60e3341e79e1$export$36ba2f559d49a8f6);
$parcel$export(module.exports, "NotificationsContentWrapper", () => $611a60e3341e79e1$export$34c02505a1643f00);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $vCqQa = parcelRequire("vCqQa");

var $dwE2v = parcelRequire("dwE2v");

var $7CMCs = parcelRequire("7CMCs");

var $kaHBi = parcelRequire("kaHBi");

var $aWse0 = parcelRequire("aWse0");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $6cNb0 = parcelRequire("6cNb0");

var $c0dQj = parcelRequire("c0dQj");

var $lfTZh = parcelRequire("lfTZh");

var $cZpsT = parcelRequire("cZpsT");

var $b7Svb = parcelRequire("b7Svb");

var $7XYc4 = parcelRequire("7XYc4");

var $Mp6qH = parcelRequire("Mp6qH");

var $4uXxK = parcelRequire("4uXxK");

var $keCgG = parcelRequire("keCgG");

var $iPj86 = parcelRequire("iPj86");

var $5vuhU = parcelRequire("5vuhU");


var $b7Ryd = parcelRequire("b7Ryd");

const $611a60e3341e79e1$var$BadgeDI = (0, $b7Svb.lazy)(()=>(parcelRequire("iFJwV")).then(({ Badge: Badge })=>Badge), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/notifications/badge/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $611a60e3341e79e1$var$MenuDI = (0, $b7Svb.lazy)(()=>(parcelRequire("dCfOd")).then(({ Menu: Menu })=>Menu), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/notifications/menu/index.tsx"
});
const $611a60e3341e79e1$var$Notifications = ({ Badge: Badge = $611a60e3341e79e1$var$BadgeDI, ErrorBoundary: ErrorBoundary = (0, $7CMCs.JSErrorBoundary), Icon: Icon = (0, $keCgG.Notification), Menu: Menu = $611a60e3341e79e1$var$MenuDI, NotificationContentFrame: NotificationContentFrame = $611a60e3341e79e1$var$NotificationContentFrameDI, Popup: Popup = (0, $vCqQa.default), useExperienceStart: useExperienceStart = (0, $kaHBi.useExperienceStart), useIntl: useIntl = (0, $aWse0.useIntlV2), useIsAnonymous: useIsAnonymous = (0, $cZpsT.useIsAnonymous), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $iPj86.useNavigationItemAnalytics), useTopMenus: useTopMenus = (0, $2Ui4E.useTopMenus) })=>{
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'notifications');
    const { formatMessage: formatMessage } = useIntl();
    const isAnonymous = useIsAnonymous();
    const [isNotificationCleared, setIsNotificationCleared] = (0, $5uXOq.useState)(false);
    const [notificationCount, setNotificationCount] = (0, $5uXOq.useState)(0);
    const handleCountUpdate = (0, $5uXOq.useCallback)((newCount)=>{
        setNotificationCount(newCount);
    }, []);
    const [isMenuOpen, { toggle: toggleMenu, off: closeMenu, on: openMenu }] = useTopMenus((0, $lmyls.MENU_ID).NOTIFICATIONS);
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).NOTIFICATIONS
    });
    const onStart = useExperienceStart({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).NOTIFICATIONS,
        analyticsSource: 'atlassian-navigation'
    });
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (isMenuOpen) performance.clearMarks('notification.list.render.start');
        else performance.mark('notification.list.render.start');
        onStart();
        toggleMenu();
        triggerAnalytics();
        setIsNotificationCleared(true);
    }, [
        isMenuOpen,
        onStart,
        toggleMenu,
        triggerAnalytics
    ]);
    const handleNotificationIconHover = ()=>{
        $611a60e3341e79e1$var$MenuDI.preload();
    };
    (0, $5vuhU.useRegisterNotificationsInCommandPalette)(onClick);
    const content = (0, $5uXOq.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NotificationContentFrame, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorBoundary, {
            id: "notifications.list.async",
            packageName: "AtlassianNavigation",
            teamName: "navigation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "notification-menu-native",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Menu, {
            scheduleUpdate: update,
            testIdPrefix: testIdPrefix
        })))), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        testIdPrefix
    ]);
    const badge = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorBoundary, {
            id: "notifications.badge.async",
            packageName: "AtlassianNavigation",
            teamName: "navigation",
            fallback: "unmount"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "badge",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Badge, {
            isNotificationCleared: isNotificationCleared,
            setIsNotificationCleared: setIsNotificationCleared,
            isNotificationDrawerOpen: isMenuOpen,
            onNotificationCountChange: handleCountUpdate
        }))), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isNotificationCleared,
        isMenuOpen
    ]);
    const badgeEmpty = (0, $5uXOq.useCallback)(()=>null, []);
    const notificationsLabel = notificationCount < (0, $3c41b45407aae96c$export$14c62ba6f49b806f) ? formatMessage((0, $b7Ryd.default).label, {
        count: notificationCount
    }) : formatMessage((0, $b7Ryd.default).overNineNotifications);
    const trigger = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-trigger'),
            "data-vc": `atlassian-navigation-notifications${false ? '-ssr' : ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
            ...triggerProps,
            badge: badge,
            isSelected: isMenuOpen,
            onClick: onClick,
            onMouseEnter: handleNotificationIconHover,
            tooltip: formatMessage((0, $b7Ryd.default).tooltip),
            label: notificationsLabel,
            onViewRequests: openMenu
        })), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        badge,
        isMenuOpen,
        onClick,
        formatMessage,
        testIdPrefix,
        notificationCount
    ]);
    if (isAnonymous) return null;
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        badge: badgeEmpty,
        tooltip: formatMessage((0, $b7Ryd.default).tooltip)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Popup, {
        content: content,
        isOpen: isMenuOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        trigger: trigger,
        shouldRenderToParent: true,
        shouldFitViewport: (0, $c0dQj.isMobileAndInViewPanelIterationExperiment)() ? true : undefined
    });
};
const $611a60e3341e79e1$export$36ba2f559d49a8f6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uXxK.TopLevelErrorBoundary), {
        id: (0, $Mp6qH.NAVIGATION_ITEM_ID).NOTIFICATIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dwE2v.UsingNotificationsToImproveAdminApprovalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($611a60e3341e79e1$var$Notifications, props)));
const $611a60e3341e79e1$var$NotificationContentFrameDIOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1w2c _4t3i54ef _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $611a60e3341e79e1$var$notificationContentFrameStyles = null;
const $611a60e3341e79e1$var$NotificationContentFrameDIWithResponsiveWidth = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1bsb1xd4 _4t3i54ef _1e0c1txw _g7111w2c"
        ])
    }, children); // TODO: When the cleanup is done, remove the exported wrapper component below please (see NotificationsContentWrapper)
//       Add fix the import in the Nav4Notifications componponent (which is colocated)
const $611a60e3341e79e1$var$NotificationContentFrameDI = (0, $7XYc4.componentWithCondition)(()=>(0, $c0dQj.isMobileAndInViewPanelIterationExperiment)(), $611a60e3341e79e1$var$NotificationContentFrameDIWithResponsiveWidth, $611a60e3341e79e1$var$NotificationContentFrameDIOld); // This has been created to circumvent a ratcheting rule and avoid an ESLint suppression
const $611a60e3341e79e1$export$34c02505a1643f00 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($611a60e3341e79e1$var$NotificationContentFrameDI, null, children);
};

});
parcelRegister("dwE2v", function(module, exports) {

$parcel$export(module.exports, "CoordinationStopProvider", () => $108b0001dbc2c488$export$83d026e3dd5706d);
$parcel$export(module.exports, "UsingNotificationsToImproveAdminApprovalProvider", () => $108b0001dbc2c488$export$a5554f3421878be1);
$parcel$export(module.exports, "useUsingNotificationsToImproveAdminApprovalContext", () => $108b0001dbc2c488$export$3e450d633150d6ca);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");

var $9OXo1 = parcelRequire("9OXo1");

const $108b0001dbc2c488$var$TouchpointContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    hasSpotlightBeenShown: true,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    markSpotlightAsShown: ()=>{}
});
const $108b0001dbc2c488$var$localStorage = (0, $bSSG7.createLocalStorageProvider)((0, $95839ee75937f648$export$67a034c701fa7ff6));
const $108b0001dbc2c488$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $108b0001dbc2c488$export$a5554f3421878be1 = ({ children: children })=>{
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = (0, $9OXo1.useTenantContext)();
    const [hasSpotlightBeenShown, setHasSpotlightBeenShown] = (0, $5uXOq.useState)(true);
    const spotlightLocalStorageKey = `${(0, $95839ee75937f648$export$7a86d77850136bf4)}_${cloudId}_${atlassianAccountId}`;
    (0, $5uXOq.useEffect)(()=>{
        setHasSpotlightBeenShown($108b0001dbc2c488$var$localStorage.get(spotlightLocalStorageKey) || false);
    }, [
        spotlightLocalStorageKey
    ]);
    const markSpotlightAsShown = (0, $5uXOq.useCallback)(()=>{
        $108b0001dbc2c488$var$localStorage.set(spotlightLocalStorageKey, true);
        setHasSpotlightBeenShown(true);
    }, [
        setHasSpotlightBeenShown,
        spotlightLocalStorageKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($108b0001dbc2c488$var$TouchpointContext.Provider, {
        value: {
            hasSpotlightBeenShown: hasSpotlightBeenShown,
            markSpotlightAsShown: markSpotlightAsShown
        }
    }, children);
};
const $108b0001dbc2c488$export$3e450d633150d6ca = ()=>(0, $5uXOq.useContext)($108b0001dbc2c488$var$TouchpointContext);

});
const $95839ee75937f648$export$67a034c701fa7ff6 = 'uniapa';
const $95839ee75937f648$export$7a86d77850136bf4 = 'has-spotlight-been-shown';
const $95839ee75937f648$export$d2ea4f931a71a509 = 'jira-admin-product-request-spotlight';


parcelRegister("keCgG", function(module, exports) {

$parcel$export(module.exports, "Notification", () => $5d149cd838a80129$export$14834abbfce3b8cd);

var $5uXOq = parcelRequire("5uXOq");

var $55UTN = parcelRequire("55UTN");

var $7g4lj = parcelRequire("7g4lj");

var $inni2 = parcelRequire("inni2");
var $Pxnvj = parcelRequire("Pxnvj");
var $98UVV = parcelRequire("98UVV");


var $dwE2v = parcelRequire("dwE2v");

var $lglOU = parcelRequire("lglOU");

var $eGLgs = parcelRequire("eGLgs");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $9OXo1 = parcelRequire("9OXo1");

var $eYOaQ = parcelRequire("eYOaQ");

var $6s1PB = parcelRequire("6s1PB");
// Should this live in the migration layer (@atlassian/jira-navigation-system) instead?
const $5d149cd838a80129$var$renderNotifications = (props, ref)=>{
    const { onViewRequests: onViewRequests, ...notificationProps } = props;
    if ((0, $3HwlS.getWillShowNav4)()) {
        const { badge: badge, onClick: onClick, isSelected: isSelected, label: label } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYOaQ.Notifications), {
            badge: badge,
            label: label,
            onClick: onClick,
            isSelected: isSelected,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- PLEASE FIX - ENABLING FLAT LINT CONFIG
            ref: ref
        });
    }
    const buttonProps = {
        ...notificationProps,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $55UTN.Notifications), buttonProps);
};
const $5d149cd838a80129$export$14834abbfce3b8cd = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { markSpotlightAsShown: markSpotlightAsShown, hasSpotlightBeenShown: hasSpotlightBeenShown } = (0, $dwE2v.useUsingNotificationsToImproveAdminApprovalContext)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { isSiteAdmin: isSiteAdmin } = (0, $9OXo1.useTenantContext)();
    // As an experiment we will bypass the SSR route for notifications so that instead of rendering
    // a skeleton component that will be replaced by the real component, we will render the real component.
    // This means that TTVC should increase because there will be less work to do on the client side.
    if ((0, $3HwlS.getWillShowNav4)()) {
        if (!(0, $6s1PB.expVal)('blu-6229-nav4-top-nav-notifications-perf', 'cohort', false) && false) // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7g4lj.Nav4SkeletonNotificationButton), {
            label: props.tooltip
        });
    } else if (false) // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7g4lj.SkeletonNotificationButton), {
        label: props.tooltip
    });
    const { onViewRequests: onViewRequests, ...notificationProps } = props;
    /**
	 * Send analytics event when user clicks "Close" or "View requests" button on the request spotlight
	 * Event registry - https://data-portal.internal.atlassian.com/analytics/registry/52348
	 * @param {"close"|"viewRequests"} buttonType
	 */ const handleSendAnalyticsEventForClickRequestSpotlightButton = (buttonType)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'requestSpotlightButton', {
            buttonType: buttonType,
            isSiteAdmin: isSiteAdmin
        });
    };
    const shouldShowRequestsSpotlight = isSiteAdmin && !hasSpotlightBeenShown;
    if (!shouldShowRequestsSpotlight) return $5d149cd838a80129$var$renderNotifications(notificationProps, ref);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inni2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
        name: "admin-request-spotlight"
    }, $5d149cd838a80129$var$renderNotifications(notificationProps, ref)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $98UVV.default), null, isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: (0, $95839ee75937f648$export$d2ea4f931a71a509),
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dwE2v.CoordinationStopProvider), null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lglOU.UsingNotificationsToImproveAdminApprovalSpotlight), {
            onViewRequests: ()=>{
                setIsSpotlightActive(false);
                markSpotlightAsShown();
                onViewRequests && onViewRequests();
                handleSendAnalyticsEventForClickRequestSpotlightButton('viewRequests');
                stop && stop();
            },
            onClose: ()=>{
                setIsSpotlightActive(false);
                markSpotlightAsShown();
                handleSendAnalyticsEventForClickRequestSpotlightButton('close');
                stop && stop();
            }
        })))));
});

});
parcelRegister("lglOU", function(module, exports) {

$parcel$export(module.exports, "UsingNotificationsToImproveAdminApprovalSpotlight", () => $76067028c6c9ade1$export$aa9f9fc1c08b114f);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $ehdJY = parcelRequire("ehdJY");

var $9OXo1 = parcelRequire("9OXo1");

var $a2BKa = parcelRequire("a2BKa");
const $76067028c6c9ade1$export$aa9f9fc1c08b114f = ({ onViewRequests: onViewRequests, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $9OXo1.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926),
        sourceName: "requestSpotlight",
        attributes: {
            isSiteAdmin: isSiteAdmin
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                onClick: onViewRequests,
                text: formatMessage((0, $a2BKa.default).uniapaSpotlightViewRequestsButtonText)
            },
            {
                onClick: onClose,
                text: formatMessage((0, $a2BKa.default).uniapaSpotlightCloseButtonText),
                appearance: 'subtle'
            }
        ],
        target: "admin-request-spotlight",
        key: "admin-request-spotlight",
        targetRadius: 100,
        dialogPlacement: "bottom right",
        dialogWidth: 275,
        targetBgColor: "var(--ds-icon-inverse, #FFFFFF)",
        messageId: "cross-flow-using-notifications-to-improve-admin-approval.ui.jira-spotlight.admin-request-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $a2BKa.default).uniapaSpotlightNotificationText))));
};

});
parcelRegister("a2BKa", function(module, exports) {

$parcel$export(module.exports, "default", () => $801cdcf6d45d9579$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $801cdcf6d45d9579$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    uniapaSpotlightNotificationText: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-notification-text",
        "defaultMessage": "When someone in your team requests a new product you'll get a notification here now."
    },
    uniapaSpotlightCloseButtonText: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-close-button-text",
        "defaultMessage": "Close"
    },
    uniapaSpotlightViewRequestsButtonText: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-view-requests-button-text",
        "defaultMessage": "View requests"
    }
});

});



parcelRegister("5vuhU", function(module, exports) {

$parcel$export(module.exports, "useRegisterNotificationsInCommandPalette", () => $179b48f3297e7dbc$export$1859b18f10ade54c);

var $5uXOq = parcelRequire("5uXOq");

var $hcJMf = parcelRequire("hcJMf");

var $5p1kJ = parcelRequire("5p1kJ");

var $5rVQI = parcelRequire("5rVQI");

var $eG9rp = parcelRequire("eG9rp");

var $1Kt4o = parcelRequire("1Kt4o");

var $5zCdk = parcelRequire("5zCdk");

var $jh7L9 = parcelRequire("jh7L9");

var $koVbs = parcelRequire("koVbs");


var $2ju1i = parcelRequire("2ju1i");
const $179b48f3297e7dbc$export$1859b18f10ade54c = (onClick)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getKeywords: getKeywords } = (0, $eG9rp.useCommandKeywords)();
    const commands = [
        {
            id: (0, $309f32bbf2afff80$export$e0226a83abddbd07),
            name: formatMessage((0, $2ju1i.messages).checkNotifications),
            primaryAction: {
                type: (0, $jh7L9.CommandActionType).PERFORM,
                perform: onClick
            },
            keywords: getKeywords('checkNotificationsSynonyms'),
            section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).quickActions,
            priority: (0, $5rVQI.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).checkNotifications,
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hcJMf))), {
                        spacing: "spacious",
                        label: formatMessage((0, $2ju1i.messages).checkNotifications)
                    })
            },
            analytics: {
                action: 'checkNotifications'
            }
        }
    ];
    (0, $5zCdk.useRegisterCommands)((0, $1Kt4o.COMMAND_PALETTE_REGISTRY_IDS).CHECK_NOTIFICATIONS, commands);
};

});
parcelRegister("5zCdk", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommands", () => $c2fc115f119fcec7$export$3f626f8a5dbc29e4);

var $6QoIp = parcelRequire("6QoIp");
const $c2fc115f119fcec7$export$3f626f8a5dbc29e4 = (0, $6QoIp.useRegisterCommandsWithRegistry);

});

const $309f32bbf2afff80$export$e0226a83abddbd07 = 'check-notifications';

parcelRegister("2ju1i", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0cb403ddbf46e2b7$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0cb403ddbf46e2b7$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    checkNotifications: {
        "id": "atlassian-navigation.notifications.command-palette.check-notifications",
        "defaultMessage": "Check notifications"
    }
});

});


const $3c41b45407aae96c$export$14c62ba6f49b806f = 9;

parcelRegister("b7Ryd", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4d3829bacc3127c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a4d3829bacc3127c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "atlassian-navigation.notifications.tooltip",
        "defaultMessage": "Notifications"
    },
    oldLabel: {
        "id": "atlassian-navigation.notifications.old-label",
        "defaultMessage": "Notifications"
    },
    label: {
        "id": "atlassian-navigation.notifications.label",
        "defaultMessage": "{count, plural, =0{ Notifications} one{{count, number} Notification} other{{count, number} Notifications}}"
    },
    overNineNotifications: {
        "id": "atlassian-navigation.notifications.over-nine-notifications",
        "defaultMessage": "Over 9 Notifications"
    }
});

});

parcelRegister("iFJwV", function(module, exports) {

let $d97f5fa76aee5758$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d97f5fa76aee5758$var$load("6D4FW").then(()=>parcelRequire('6z8GT'));

});

parcelRegister("dCfOd", function(module, exports) {

let $9e9b164ff9be51c4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9e9b164ff9be51c4$var$load("gnhz7").then(()=>parcelRequire('hJbTL'));

});





parcelRegister("MBTxm", function(module, exports) {

$parcel$export(module.exports, "InitialDataLoader", () => $0c63bc4f7fc4fb59$export$867ec025b81eadf3);

var $5uXOq = parcelRequire("5uXOq");

var $kJH82 = parcelRequire("kJH82");

var $2N6bN = parcelRequire("2N6bN");


var $bcn6L = parcelRequire("bcn6L");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $eKYL7 = parcelRequire("eKYL7");

var $7uSIc = parcelRequire("7uSIc");

var $d40Fj = parcelRequire("d40Fj");

var $apeap = parcelRequire("apeap");

var $lsa9q = parcelRequire("lsa9q");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $cZpsT = parcelRequire("cZpsT");
const $0c63bc4f7fc4fb59$var$InitialDataLoaderOld = ()=>{
    const [, { loadRecentAll: loadRecentAll }] = (0, $apeap.useRecentActions)();
    const [, { loadFavoriteAll: loadFavoriteAll }] = (0, $bcn6L.useFavoriteActions)();
    const [, { fetchCreateProjectPermission: fetchCreateProjectPermission }] = (0, $d40Fj.useCreateProjectPermissionActions)();
    const [, { load: loadForgeGlobalItem }] = (0, $eKYL7.useForgeGlobalItems)();
    const [, { load: loadAddons }] = (0, $kJH82.useAddon)();
    const [, { fetchTraits: fetchTraits }] = (0, $2N6bN.usePersonalizationProvider)();
    const hasFetchedAll = (0, $5uXOq.useRef)(false);
    const [{ hasLoaded: hasLoaded }] = (0, $lsa9q.default)();
    const [hasTimedOut, setHasTimedOut] = (0, $5uXOq.useState)(false);
    const accountId = (0, $90yGq.useAccountId)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const cloudId = (0, $koeKL.useCloudId)();
    (0, $5uXOq.useEffect)(()=>{
        if ((hasLoaded || hasTimedOut) && !hasFetchedAll.current) {
            loadRecentAll();
            loadFavoriteAll((0, $7a1562bd0ca086b0$export$ea341e6cc435ed40));
            loadForgeGlobalItem({
                cloudId: cloudId,
                isAnonymous: isAnonymous
            });
            fetchCreateProjectPermission();
            loadAddons();
            hasFetchedAll.current = true;
        }
    }, [
        hasLoaded,
        hasTimedOut,
        hasFetchedAll,
        loadRecentAll,
        loadFavoriteAll,
        fetchCreateProjectPermission,
        loadForgeGlobalItem,
        loadAddons,
        accountId,
        fetchTraits,
        cloudId,
        isAnonymous
    ]);
    // given not all pages use SpaStateReady yet, we fallback to timeout
    // so we preload nav items anyway after some time
    (0, $5uXOq.useEffect)(()=>{
        let t;
        if (!hasLoaded) t = setTimeout(()=>setHasTimedOut(true), 10000);
        return ()=>clearTimeout(t);
    }, [
        hasLoaded,
        setHasTimedOut
    ]);
    return null;
};
const $0c63bc4f7fc4fb59$var$InitialDataLoaderWithForgePersonalSettingsModule = ()=>{
    const [, { loadRecentAll: loadRecentAll }] = (0, $apeap.useRecentActions)();
    const [, { loadFavoriteAll: loadFavoriteAll }] = (0, $bcn6L.useFavoriteActions)();
    const [, { fetchCreateProjectPermission: fetchCreateProjectPermission }] = (0, $d40Fj.useCreateProjectPermissionActions)();
    const [, { load: loadForgeGlobalItem }] = (0, $eKYL7.useForgeGlobalItems)();
    const [, { load: loadForgePersonalSettingsItem }] = (0, $7uSIc.useForgePersonalSettingsItems)();
    const [, { load: loadAddons }] = (0, $kJH82.useAddon)();
    const [, { fetchTraits: fetchTraits }] = (0, $2N6bN.usePersonalizationProvider)();
    const hasFetchedAll = (0, $5uXOq.useRef)(false);
    const [{ hasLoaded: hasLoaded }] = (0, $lsa9q.default)();
    const [hasTimedOut, setHasTimedOut] = (0, $5uXOq.useState)(false);
    const accountId = (0, $90yGq.useAccountId)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const cloudId = (0, $koeKL.useCloudId)();
    (0, $5uXOq.useEffect)(()=>{
        if ((hasLoaded || hasTimedOut) && !hasFetchedAll.current) {
            loadRecentAll();
            loadFavoriteAll((0, $7a1562bd0ca086b0$export$ea341e6cc435ed40));
            loadForgeGlobalItem({
                cloudId: cloudId,
                isAnonymous: isAnonymous
            });
            loadForgePersonalSettingsItem({
                cloudId: cloudId,
                isAnonymous: isAnonymous
            });
            fetchCreateProjectPermission();
            loadAddons();
            hasFetchedAll.current = true;
        }
    }, [
        hasLoaded,
        hasTimedOut,
        hasFetchedAll,
        loadRecentAll,
        loadFavoriteAll,
        fetchCreateProjectPermission,
        loadForgeGlobalItem,
        loadForgePersonalSettingsItem,
        loadAddons,
        accountId,
        fetchTraits,
        cloudId,
        isAnonymous
    ]);
    // given not all pages use SpaStateReady yet, we fallback to timeout
    // so we preload nav items anyway after some time
    (0, $5uXOq.useEffect)(()=>{
        let t;
        if (!hasLoaded) t = setTimeout(()=>setHasTimedOut(true), 10000);
        return ()=>clearTimeout(t);
    }, [
        hasLoaded,
        setHasTimedOut
    ]);
    return null;
};
const $0c63bc4f7fc4fb59$export$867ec025b81eadf3 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('forge-ui-project-web-items'), $0c63bc4f7fc4fb59$var$InitialDataLoaderWithForgePersonalSettingsModule, $0c63bc4f7fc4fb59$var$InitialDataLoaderOld);

});

parcelRegister("0396H", function(module, exports) {

$parcel$export(module.exports, "NavigationRouterListener", () => $fe5862efafb61dce$export$85575e1c48f0a517);

var $5uXOq = parcelRequire("5uXOq");

var $doZTA = parcelRequire("doZTA");

var $hUGiV = parcelRequire("hUGiV");
const $fe5862efafb61dce$export$85575e1c48f0a517 = ()=>{
    const [{ route: route, location: location, match: match }] = (0, $doZTA.useRouter)();
    const onEnd = (0, $hUGiV.useAtlassianNavigationEnd)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        onEnd();
    }, [
        route,
        match,
        location,
        onEnd
    ]);
    return null;
};

});
parcelRegister("hUGiV", function(module, exports) {

$parcel$export(module.exports, "useAtlassianNavigationEnd", () => $c2d6674a75325f63$export$4b9602c0fdb8b1bb);

var $5uXOq = parcelRequire("5uXOq");


var $4oDnX = parcelRequire("4oDnX");
const $c2d6674a75325f63$export$4b9602c0fdb8b1bb = ()=>{
    const [, { setAppReadyWithAppId: setAppReadyWithAppId }] = (0, $4oDnX.useSpaStateActions)();
    return (0, $5uXOq.useCallback)(()=>{
        setAppReadyWithAppId((0, $146ecce9d079a34d$export$3a54edb6ba4daa82));
    }, [
        setAppReadyWithAppId
    ]);
};

});


parcelRegister("2E6jA", function(module, exports) {

$parcel$export(module.exports, "Nav4NotificationsData", () => $61e3aa9159c11335$export$4be76e93f368ccd9);

var $4P1ax = parcelRequire("4P1ax");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $Mp6qH = parcelRequire("Mp6qH");

var $dFNPB = parcelRequire("dFNPB");
const $61e3aa9159c11335$export$4be76e93f368ccd9 = (props)=>{
    const { queryReference: queryReference } = props;
    const fragmentData = (0, $8Uumt.useFragment)((0, $4P1ax.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "nav4-notifications-error-boundary",
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        teamName: (0, $Mp6qH.TEAM_NAME),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dFNPB.Nav4Notifications), {
        fragmentData: fragmentData
    }));
};

});
parcelRegister("4P1ax", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c394e155eea9691$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab5a4efb2e4c302f6507731481aad167>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2c394e155eea9691$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "Nav4NotificationsData",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Nav4Notifications"
        }
    ],
    "type": "Query"
};
$2c394e155eea9691$var$node.hash = "359a3dc4bc79536755e5a1c2e1775462";
var $2c394e155eea9691$export$2e2bcd8739ae039 = $2c394e155eea9691$var$node;

});

parcelRegister("dFNPB", function(module, exports) {

$parcel$export(module.exports, "Nav4Notifications", () => $aa3a9f45bb52149a$export$c50c32b171c62438);

var $aH68m = parcelRequire("aH68m");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $vCqQa = parcelRequire("vCqQa");

var $6cNb0 = parcelRequire("6cNb0");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $2Ui4E = parcelRequire("2Ui4E");

var $lmyls = parcelRequire("lmyls");

var $kaHBi = parcelRequire("kaHBi");

var $koVbs = parcelRequire("koVbs");

var $b7Svb = parcelRequire("b7Svb");

var $c0dQj = parcelRequire("c0dQj");

var $Mp6qH = parcelRequire("Mp6qH");

var $iPj86 = parcelRequire("iPj86");

var $keCgG = parcelRequire("keCgG");

var $6v03K = parcelRequire("6v03K");

var $inFGE = parcelRequire("inFGE");

var $8s8Nt = parcelRequire("8s8Nt");


var $b7Ryd = parcelRequire("b7Ryd");

var $5vuhU = parcelRequire("5vuhU");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $aa3a9f45bb52149a$var$LazyMenu = (0, $b7Svb.lazy)(()=>(parcelRequire("dCfOd")).then(({ Menu: Menu })=>Menu), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/notifications/menu/index.tsx"
});
const $aa3a9f45bb52149a$export$c50c32b171c62438 = (props)=>{
    const { fragmentData: fragmentData } = props;
    const [data, refetch] = (0, $8Uumt.useRefetchableFragment)((0, $aH68m.default), fragmentData);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // Check for new notifications every 60 seconds. This is currently done through polling because
    // Relay subscriptions are not yet supported server side. This polling will need to be replaced with
    // a subscription in the future (when notifications are migrated to Post Office).
    (0, $6v03K.usePolling)(()=>{
        refetch({}, {
            fetchPolicy: 'store-and-network'
        });
    }, 60000);
    const fetchedNotificationsCount = data.notifications?.unseenNotificationCount ?? 0;
    // Initialise the state to false on page load, but use an effect to update it if the unseen notification
    // count changes (i.e. as a result of polling) to ensure the badge is shown when there are new notifications.
    const [isNotificationCleared, setIsNotificationCleared] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (fetchedNotificationsCount > 0) setIsNotificationCleared(false);
    }, [
        fetchedNotificationsCount
    ]);
    // If notifications have been cleared, force the badge to be 0. This crudely addresses a race condition where
    // opening the menu (which resets the unseen notification count) does not complete before a refetch completes.
    const notificationsCount = isNotificationCleared ? 0 : fetchedNotificationsCount;
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'notifications');
    const [isMenuOpen, { toggle: toggleMenu, off: closeMenu, on: openMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).NOTIFICATIONS);
    const content = (0, $5uXOq.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inFGE.NotificationsContentWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            id: "notifications.list.async",
            packageName: "AtlassianNavigation",
            teamName: "navigation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "notification-menu-native",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aa3a9f45bb52149a$var$LazyMenu, {
            scheduleUpdate: update,
            testIdPrefix: testIdPrefix
        })))), [
        testIdPrefix
    ]);
    const triggerAnalytics = (0, $iPj86.useNavigationItemAnalytics)({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).NOTIFICATIONS
    });
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $Mp6qH.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $Mp6qH.NAVIGATION_ITEM_ID).NOTIFICATIONS,
        analyticsSource: 'atlassian-navigation'
    });
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (isMenuOpen) performance.clearMarks('notification.list.render.start');
        else performance.mark('notification.list.render.start');
        onStart();
        toggleMenu();
        triggerAnalytics();
        // Always set isNotificationCleared to true when the menu trigger is clicked
        // that there are no unseen notifications).
        setIsNotificationCleared(true);
    // PLEASE NOTE: Refetching the notifications does not occur here because for some reason
    // it blocks the popup from being closed.
    }, [
        isMenuOpen,
        onStart,
        toggleMenu,
        triggerAnalytics
    ]);
    (0, $5vuhU.useRegisterNotificationsInCommandPalette)(onClick);
    const badge = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8s8Nt.Nav4NotificationsBadge), {
            count: notificationsCount
        }), [
        notificationsCount
    ]);
    const notificationsLabel = notificationsCount < (0, $3c41b45407aae96c$export$14c62ba6f49b806f) ? formatMessage((0, $b7Ryd.default).label, {
        count: notificationsCount
    }) : formatMessage((0, $b7Ryd.default).overNineNotifications);
    const trigger = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-trigger'),
            "data-vc": `atlassian-navigation-notifications${false ? '-ssr' : ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $keCgG.Notification), {
            ...triggerProps,
            badge: badge,
            isSelected: isMenuOpen,
            onClick: onClick,
            tooltip: formatMessage((0, $b7Ryd.default).tooltip),
            label: notificationsLabel,
            onViewRequests: openMenu
        })), [
        badge,
        formatMessage,
        isMenuOpen,
        notificationsLabel,
        onClick,
        openMenu,
        testIdPrefix
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $vCqQa.default), {
        content: content,
        isOpen: isMenuOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        trigger: trigger,
        shouldRenderToParent: true,
        shouldFitViewport: (0, $c0dQj.isMobileAndInViewPanelIterationExperiment)() ? true : undefined
    });
};

});
parcelRegister("aH68m", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a2c8d85b91b234$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9d31a2a7e7aa24f0bb9199cbe5b83962>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $gtPMQ = parcelRequire("gtPMQ");
const $66a2c8d85b91b234$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $gtPMQ.default)
        }
    },
    "name": "Nav4Notifications",
    "selections": [
        {
            "concreteType": "InfluentsNotificationQuery",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "unseenNotificationCount"
                }
            ]
        }
    ],
    "type": "Query"
};
$66a2c8d85b91b234$var$node.hash = "d448e13b720687c07d75fad3fc7575b7";
var $66a2c8d85b91b234$export$2e2bcd8739ae039 = $66a2c8d85b91b234$var$node;

});
parcelRegister("gtPMQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $73db3f026027cd2f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bbab04c071b13e6260e5510bf40dce7d>>
 * @relayHash 444679d14e7ecdbf4baf8b6b3566d94f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0c34169bf7c147ea89ec061b04eaf98de6da2b49dee73be2fbc895253423b35f
const $73db3f026027cd2f$var$node = {
    "fragment": {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "Nav4NotificationsQuery",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "Nav4Notifications"
            }
        ],
        "type": "Query"
    },
    "kind": "Request",
    "operation": {
        "argumentDefinitions": [],
        "kind": "Operation",
        "name": "Nav4NotificationsQuery",
        "selections": [
            {
                "concreteType": "InfluentsNotificationQuery",
                "kind": "LinkedField",
                "name": "notifications",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "unseenNotificationCount"
                    }
                ]
            }
        ]
    },
    "params": {
        "id": "0c34169bf7c147ea89ec061b04eaf98de6da2b49dee73be2fbc895253423b35f",
        "metadata": {},
        "name": "Nav4NotificationsQuery",
        "operationKind": "query",
        "text": null
    }
};
$73db3f026027cd2f$var$node.hash = "d448e13b720687c07d75fad3fc7575b7";
var $73db3f026027cd2f$export$2e2bcd8739ae039 = $73db3f026027cd2f$var$node;

});


parcelRegister("6v03K", function(module, exports) {

$parcel$export(module.exports, "usePolling", () => $05a8008a7f962bd5$export$a11f73e3adecd502);

var $5uXOq = parcelRequire("5uXOq");
const $05a8008a7f962bd5$export$a11f73e3adecd502 = (callback, delay)=>{
    const callbackRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const tick = ()=>{
            if (callbackRef.current) callbackRef.current();
        };
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
    }, [
        delay
    ]);
};

});

parcelRegister("8s8Nt", function(module, exports) {

$parcel$export(module.exports, "Nav4NotificationsBadge", () => $f526d936b34d800d$export$c4129d57a4559409);

var $5uXOq = parcelRequire("5uXOq");

var $jd94h = parcelRequire("jd94h");
const $f526d936b34d800d$export$c4129d57a4559409 = (props)=>{
    const { count: count } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jd94h.Nav4NotificationsIndicator), {
        count: count
    });
};

});
parcelRegister("jd94h", function(module, exports) {

$parcel$export(module.exports, "Nav4NotificationsIndicator", () => $e95bd3f66906bc5b$export$6891e3964002ac9);

var $5uXOq = parcelRequire("5uXOq");

var $2esxr = parcelRequire("2esxr");
const $e95bd3f66906bc5b$var$MAX_NOTIFICATIONS_COUNT = 9;
const $e95bd3f66906bc5b$export$6891e3964002ac9 = (props)=>{
    const { appearance: appearance = 'important', count: count, max: max = $e95bd3f66906bc5b$var$MAX_NOTIFICATIONS_COUNT } = props;
    return count ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-test-selector": "NotificationIndicator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2esxr.default), {
        testId: "atlassian-navigation.ui.notifications.notification-indicator-badge",
        max: max,
        appearance: appearance
    }, count)) : null;
};

});








parcelRegister("lvpKt", function(module, exports) {

$parcel$export(module.exports, "FullHeight", () => $c63a700e8bea75a2$export$33e617ec5e4e4f76);

var $5uXOq = parcelRequire("5uXOq");
const $c63a700e8bea75a2$var$styleFullHeight = {
    height: '100vh'
};
const $c63a700e8bea75a2$export$33e617ec5e4e4f76 = ({ children: children })=>// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: $c63a700e8bea75a2$var$styleFullHeight
    }, children);

});

parcelRegister("8Ceqd", function(module, exports) {

$parcel$export(module.exports, "GlobalThemeSetter", () => $5b61f4226ddd6087$export$c8947eb2c95eab56);
$parcel$export(module.exports, "ThemeSetter", () => $5b61f4226ddd6087$export$ce1303eaa27a0d3a);

var $5uXOq = parcelRequire("5uXOq");

var $2CeVI = parcelRequire("2CeVI");
var $6VxGE = parcelRequire("6VxGE");

var $fjcgS = parcelRequire("fjcgS");

var $dZJHS = parcelRequire("dZJHS");

var $2Ql51 = parcelRequire("2Ql51");

var $2YP9W = parcelRequire("2YP9W");
const $5b61f4226ddd6087$var$darkThemeMediaMatchQuery = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');

const $5b61f4226ddd6087$export$c8947eb2c95eab56 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $2Ql51.themePreferenceResource));
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    const [isThemeStylesInHead, setIsThemeStylesInHead] = (0, $5uXOq.useState)(false);
    const setThemeWithToken = (0, $5uXOq.useCallback)(async (theme)=>{
        if (theme !== colorMode) {
            const { loadThemeTokens: loadThemeTokens } = await (parcelRequire("hCILh"));
            loadThemeTokens(theme);
        }
    }, [
        colorMode
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (loading || error || !data) return undefined;
        // Combine the themes 'dark', 'light' and 'auto' after @atlaskit/tokens@1.0.0
        // https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/27634
        if (data?.theme === 'auto') {
            setThemeWithToken($5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light');
            const handler = (e)=>{
                setThemeWithToken(e.matches ? 'dark' : 'light');
            };
            $5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.addEventListener('change', handler);
            return ()=>{
                $5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.removeEventListener('change', handler);
            };
        }
        if (data?.theme === 'dark' || data?.theme === 'light') setThemeWithToken(data?.theme);
        if (!data?.theme) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.documentElement.removeAttribute('data-theme');
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.documentElement.removeAttribute('data-color-mode');
        }
        return undefined;
    }, [
        data,
        loading,
        error,
        setThemeWithToken
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (loading || error || !data) return;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            if (data?.theme) client.setUIViewedAttributes({
                theme: data.theme
            });
            else client.removeUIViewedAttribute('theme');
        });
    }, [
        data,
        loading,
        error
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            client.setUIViewedAttributes({
                OStheme: $5b61f4226ddd6087$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light'
            });
        });
    }, []);
    // @atlaskit/tokens expects the theme styles to be in the <head /> but they're
    // initally rendered in the "jira-ssr" container in the <body /> and then moved to the
    // <head />. The following prevents the styles from being re-rendered in the <body />.
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.head.querySelector('style[data-theme]')) setIsThemeStylesInHead(true);
    }, []);
    if (!data?.theme || !data?.attrs || !data?.styles) return null;
    const ssrAutoScript = (0, $2CeVI.default)(data.theme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !isThemeStylesInHead ? data.styles.map((theme)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
            key: theme.id,
            ...theme.attrs,
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: theme.css
            }
        })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: data.styles.map((theme)=>`document.head.appendChild(document.body.querySelector('style[data-theme="${theme.id}"]'));`).join('\n')
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: Object.entries(data.attrs).map(([key, val])=>{
                if (key === 'data-color-mode' && ssrAutoScript) return '';
                return `document.documentElement.setAttribute("${key}", "${val}");`;
            }).join('\n')
        }
    }), ssrAutoScript ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: ssrAutoScript
        }
    }) : null);
};
const $5b61f4226ddd6087$export$ce1303eaa27a0d3a = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5b61f4226ddd6087$export$c8947eb2c95eab56, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZJHS.ThemeSetterOld), null));
};

});
parcelRegister("2CeVI", function(module, exports) {

$parcel$export(module.exports, "default", () => $59bfeacdc6ae6ae3$export$2e2bcd8739ae039);

var $fHpHg = parcelRequire("fHpHg");

var $d5aOx = parcelRequire("d5aOx");

var $iiK23 = parcelRequire("iiK23");
/**
 * Provides a script that, when executed before paint, sets the `data-color-mode` attribute based on the current system theme,
 * to enable SSR support for automatic theme switching, avoid a flash of un-themed content on first paint.
 *
 * @param {string} colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 *
 * @returns {string} A string to be added to the innerHTML of a script tag in the document head
 */ const $59bfeacdc6ae6ae3$var$getSSRAutoScript = (colorMode, // TODO: This should be marked as required once safe to roll out.
contrastMode)=>{
    if (colorMode !== 'auto' && contrastMode !== 'auto') return undefined;
    const setColorMode = colorMode === 'auto' ? `\n  try {
    const darkModeMql = window.matchMedia('${0, $iiK23.darkModeMediaQuery}');
    const colorMode = darkModeMql.matches ? 'dark' : 'light';
    document.documentElement.setAttribute('${0, $d5aOx.COLOR_MODE_ATTRIBUTE}', colorMode);
  } catch (e) {}` : '';
    const setContrastMode = contrastMode === 'auto' && (0, $fHpHg.fg)('platform_increased-contrast-themes') ? `\n  try {
    const contrastModeMql = window.matchMedia('${0, $iiK23.moreContrastMediaQuery}');
    const contrastMode = contrastModeMql.matches ? 'more' : 'no-preference';
    document.documentElement.setAttribute('${0, $d5aOx.CONTRAST_MODE_ATTRIBUTE}', contrastMode);
  } catch (e) {}` : '';
    return `(() => {${setColorMode}${setContrastMode}})()`;
};
var $59bfeacdc6ae6ae3$export$2e2bcd8739ae039 = $59bfeacdc6ae6ae3$var$getSSRAutoScript;

});

parcelRegister("dZJHS", function(module, exports) {

$parcel$export(module.exports, "ThemeSetter", () => $724d37049e8e9e6c$export$ce1303eaa27a0d3a);
$parcel$export(module.exports, "ThemeSetterOld", () => $724d37049e8e9e6c$export$f46dd86f0ba85c53);

var $ekkrg = parcelRequire("ekkrg");

var $cEpZ8 = parcelRequire("cEpZ8");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7eveN = parcelRequire("7eveN");

var $ceKVk = parcelRequire("ceKVk");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $6jY6G = parcelRequire("6jY6G");

var $dC4s3 = parcelRequire("dC4s3");

var $1MaBz = parcelRequire("1MaBz");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");
const $724d37049e8e9e6c$export$ce1303eaa27a0d3a = ({ queryReference: queryReference })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const data = (0, $8Uumt.usePreloadedQuery)((0, $cEpZ8.default), queryReference);
    const backgroundData = (0, $8Uumt.useFragment)((0, $ekkrg.default), data.jira_projectByIdOrKey?.background ?? null);
    const { hasSoftwareTheming: hasSoftwareTheming, isSoftwareProject: isSoftwareProject } = (0, $lmBAt.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        hasSoftwareTheming: false,
        isSoftwareProject: false
    };
    const media = (0, $5uXOq.useMemo)(()=>{
        return data.jira.mediaClientId && data.jira.mediaExternalEndpointUrl ? {
            clientId: data.jira.mediaClientId,
            externalEndpointUrl: data.jira.mediaExternalEndpointUrl
        } : null;
    }, [
        data.jira.mediaClientId,
        data.jira.mediaExternalEndpointUrl
    ]);
    const projectTheme = (0, $5uXOq.useMemo)(()=>{
        let themeSetting = null;
        if (!backgroundData) return null;
        switch(backgroundData.__typename){
            case 'JiraColorBackground':
                themeSetting = {
                    type: 'color',
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    value: backgroundData.colorValue
                };
                break;
            case 'JiraGradientBackground':
                themeSetting = {
                    type: 'color',
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    value: backgroundData.gradientValue
                };
                break;
            case 'JiraMediaBackground':
                if (backgroundData.customBackground != null) {
                    const { id: id, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken, sourceType: sourceType, sourceIdentifier: sourceIdentifier, altText: altText } = backgroundData.customBackground;
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    themeSetting = {
                        type: 'image',
                        value: 'image',
                        id: id,
                        mediaApiFileId: mediaApiFileId,
                        mediaReadToken: mediaReadToken,
                        sourceType: sourceType,
                        sourceIdentifier: sourceIdentifier,
                        altText: altText
                    };
                }
                break;
            default:
                themeSetting = null;
        }
        return themeSetting ? {
            themeSetting: themeSetting,
            entityId: `project/${data.jira_projectByIdOrKey?.projectId}`
        } : null;
    }, [
        backgroundData,
        data.jira_projectByIdOrKey?.projectId
    ]);
    const overviewTheme = (0, $7eveN.useOverviewTheme)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const entityTheme = (0, $5uXOq.useMemo)(()=>{
        let result = projectTheme ?? overviewTheme;
        if (result != null) {
            const isFormSubmitView = route.name === 'classic-business-form-submit' || route.name === 'classic-business-form-submit-embed';
            // the form submit view doesn't use the project theme colors
            // since it is accessed externally to the project
            // remove themeSetting for pages in software projects that don't support theming yet
            if (isFormSubmitView || isSoftwareProject && !hasSoftwareTheming) result = {
                ...result,
                themeSetting: null
            };
        }
        return result;
    }, [
        projectTheme,
        overviewTheme,
        route.name,
        isSoftwareProject,
        hasSoftwareTheming
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const projectId = data.jira_projectByIdOrKey?.projectId;
        if (projectId && (0, $4R6GH.fg)('jira_theming_relay_migration')) {
            if (data.jira_projectByIdOrKey?.projectType === 'BUSINESS' || data.jira_projectByIdOrKey?.projectType === 'SOFTWARE' && (0, $lmBAt.getIsSoftwareThemingEnabled)()) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'theme evaluated', {
                theme: entityTheme?.themeSetting?.value,
                projectId: projectId
            });
        }
    }, [
        entityTheme?.themeSetting?.value,
        data.jira_projectByIdOrKey?.projectId,
        data.jira_projectByIdOrKey?.projectType,
        createAnalyticsEvent
    ]);
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !(0, $4R6GH.fg)('jira_theming_relay_migration') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1MaBz.ThemeContainer), {
        isGlobal: true,
        entityTheme: entityTheme
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC4s3.ThemeTokensSetter), (0, $4R6GH.fg)('jira_theming_relay_migration') ? {
        media: media,
        themeSetting: entityTheme?.themeSetting,
        projectType: data.jira_projectByIdOrKey?.projectType
    } : {}));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, entityTheme != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1MaBz.ThemeContainerOld), {
        isGlobal: true,
        ...entityTheme
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC4s3.ThemeTokensSetter), (0, $4R6GH.fg)('jira_theming_relay_migration') ? {
        media: media,
        themeSetting: entityTheme?.themeSetting,
        projectType: data.jira_projectByIdOrKey?.projectType
    } : {}));
};
const $724d37049e8e9e6c$export$f46dd86f0ba85c53 = ()=>{
    const projectTheme = (0, $ceKVk.useProjectTheme)();
    const overviewTheme = (0, $7eveN.useOverviewTheme)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const entityTheme = (0, $5uXOq.useMemo)(()=>{
        let result = projectTheme ?? overviewTheme;
        if (result != null) {
            const isFormSubmitView = route.name === 'classic-business-form-submit' || route.name === 'classic-business-form-submit-embed';
            // the form submit view doesn't use the project theme colors
            // since it is accessed externally to the project
            if (isFormSubmitView) result = {
                ...result,
                themeSetting: null
            };
        }
        return result;
    }, [
        projectTheme,
        overviewTheme,
        route.name
    ]);
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1MaBz.ThemeContainer), {
        isGlobal: true,
        entityTheme: entityTheme
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC4s3.ThemeTokensSetter), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, entityTheme != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1MaBz.ThemeContainerOld), {
        isGlobal: true,
        ...entityTheme
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC4s3.ThemeTokensSetter), null));
};

});
parcelRegister("ekkrg", function(module, exports) {

$parcel$export(module.exports, "default", () => $db9c998655de9ba4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<38b934d4b5d93776c09bdfb8c487999e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $db9c998655de9ba4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ThemeSetterBackground",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorValue"
                }
            ],
            "type": "JiraColorBackground"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "gradientValue"
                }
            ],
            "type": "JiraGradientBackground"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraCustomBackground",
                    "kind": "LinkedField",
                    "name": "customBackground",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "mediaApiFileId"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "durationInSeconds",
                                    "value": 900
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "mediaReadToken",
                            "storageKey": "mediaReadToken(durationInSeconds:900)"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "sourceType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "sourceIdentifier"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "altText"
                        }
                    ]
                }
            ],
            "type": "JiraMediaBackground"
        }
    ],
    "type": "JiraActiveBackgroundDetailsResult",
    "abstractKey": "__isJiraActiveBackgroundDetailsResult"
};
$db9c998655de9ba4$var$node.hash = "a2889b0cfa3689dd4a7f6c279739caba";
var $db9c998655de9ba4$export$2e2bcd8739ae039 = $db9c998655de9ba4$var$node;

});

parcelRegister("7eveN", function(module, exports) {

$parcel$export(module.exports, "useOverviewTheme", () => $c0a2b1dfc34915dc$export$a55763fd17eab357);

var $6cG4N = parcelRequire("6cG4N");

var $jrO9m = parcelRequire("jrO9m");
const $c0a2b1dfc34915dc$export$a55763fd17eab357 = ()=>{
    const { data: data } = (0, $jrO9m.useOverview)();
    if (data != null) return {
        themeSetting: {
            type: 'color',
            value: data.theme ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG).name
        },
        entityId: `overview/${data.id}`
    };
    return null;
};

});

parcelRegister("ceKVk", function(module, exports) {

$parcel$export(module.exports, "useProjectTheme", () => $f0c1f93a3181b765$export$18084206b9430153);

var $5uXOq = parcelRequire("5uXOq");

var $6cG4N = parcelRequire("6cG4N");

var $l2N2a = parcelRequire("l2N2a");

var $2YP9W = parcelRequire("2YP9W");
const $f0c1f93a3181b765$export$18084206b9430153 = ()=>{
    const { data: data } = (0, $2YP9W.useResource)((0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource));
    return (0, $5uXOq.useMemo)(()=>{
        if (data != null) {
            const entityId = `project/${data.currentProject?.id}`;
            const themeSetting = data.themeSetting ?? {
                type: 'color',
                value: (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG).name
            };
            return {
                themeSetting: themeSetting,
                entityId: entityId
            };
        }
        return null;
    }, [
        data
    ]);
};

});

parcelRegister("dC4s3", function(module, exports) {

$parcel$export(module.exports, "ThemeTokensSetter", () => $5026069bddf1adf4$export$41f41c7ff10d45cd);

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $6cG4N = parcelRequire("6cG4N");

var $fHEdP = parcelRequire("fHEdP");

var $3HwlS = parcelRequire("3HwlS");

var $1MaBz = parcelRequire("1MaBz");


var $lmBAt = parcelRequire("lmBAt");

var $1r9V3 = parcelRequire("1r9V3");

var $4rtoO = parcelRequire("4rtoO");
/**
 * Will merge multiple themes together, with the last theme taking precedence.
 * The first argument is the base theme, and the rest are partial themes that
 * will be merged into the base theme.
 */ function $5026069bddf1adf4$var$mergeThemes(theme, ...partialThemes) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, theme, ...partialThemes);
}
const $5026069bddf1adf4$var$buildHorizontalNavVariables = (theme)=>{
    if ((0, $3HwlS.getWillShowNav4)()) return `${0, $b99d1770e7224860$export$539c074adec2188a}: ${theme['color.link']};
${0, $b99d1770e7224860$export$1cfe9795423425c}: ${theme['color.background.neutral.hovered']};
${0, $b99d1770e7224860$export$6f76912df5477959}: ${theme['color.link.pressed']};
${0, $b99d1770e7224860$export$fac615ceaa871e35}: ${theme['color.text.subtle']};
${0, $b99d1770e7224860$export$7748fdcd335afdc0}: ${theme['color.text']};
${0, $b99d1770e7224860$export$88e550ed188132a7}: ${theme['color.elevation.surface']};
${0, $b99d1770e7224860$export$e2e8fadb946a45d2}: ${theme['color.border.selected']};
${0, $b99d1770e7224860$export$4cd72d361867c565}: ${theme['color.border']};
${0, $b99d1770e7224860$export$be4d7e23cb48401e}:  ${theme['color.background.neutral']};`;
    return '';
};
const $5026069bddf1adf4$var$buildThemeVariables = (config, backgroundImageUrl, isDarkMode, projectType)=>{
    const applicationColorMode = isDarkMode ? 'dark' : 'light';
    const brightnessOverrides = config.brightness === 'high' && !isDarkMode ? (0, $6cG4N.HIGH_BRIGHTNESS_THEME) : (0, $6cG4N.LOW_BRIGHTNESS_THEME);
    const isImageConfig = config.name === 'image';
    const isGradientConfig = (0, $fHEdP.themeManager).isGradientTheme(config.name);
    /**
   * The base theme and the custom theme get merged here, with the custom theme taking precedence.
   * If you want to override configurations globally, then you should make modifications to the
   * BASE_THEME, while if you want to customize a specific theme, then you should make modifications
   * in the theme's themselves.
   */ const theme = $5026069bddf1adf4$var$mergeThemes(// the base theme for the application
    (0, $6cG4N.BASE_THEME), // the brightness overrides
    isImageConfig ? {} : brightnessOverrides, // gradient specific overrides
    isGradientConfig ? (0, $6cG4N.GRADIENT_THEME) : {}, // The custom background configuration
    config.theme[applicationColorMode]);
    let elevationSurface = theme['elevation.surface'] ?? theme['color.elevation.surface'];
    if (backgroundImageUrl) // in dark mode, the image will be darkened by blending with a black transparent background
    elevationSurface = `url(${backgroundImageUrl}) center center / cover no-repeat${isDarkMode ? ' #0000004d' : ''}`;
    else if (applicationColorMode === 'dark') {
        if ((0, $6cG4N.NO_BACKGROUND_CONFIG).name !== config.name && !isGradientConfig && !(0, $lmBAt.getIsSoftwareThemingEnabled)() || (0, $6cG4N.NO_BACKGROUND_CONFIG).name !== config.name && !isGradientConfig && (0, $lmBAt.getIsSoftwareThemingEnabled)() && (projectType || '').toUpperCase() !== (0, $2vSU6.SOFTWARE_PROJECT).toUpperCase() // remove using empty string as a fallback when cleaning up jira_theming_milestone_1
        ) /**
       * Add a gradient to the elevation surface for any themes in dark mode. This could be done in the
       * meta configuration but it's easier to do bulk edits here.
       */ elevationSurface = `linear-gradient(180deg, ${theme['color.elevation.surface']} 0%, ${"var(--ds-surface, #FFFFFF)"} 400px)`;
    }
    // Wrapper configuration
    const withWrapper = config.name !== (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG).name;
    const wrapperBackground = withWrapper ? "var(--ds-surface, #FFFFFF)" : 'unset';
    const wrapperBorderRadius = withWrapper ? `${0, $gwIPs.gridSize}px` : '0';
    const isNav4 = (0, $3HwlS.getWillShowNav4)();
    const businessWrapperWithBackgroundHeight = isNav4 ? (0, $6cG4N.NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT) : (0, $6cG4N.BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT);
    const businessWrapperHeight = isNav4 ? (0, $6cG4N.NAV4_BUSINESS_WRAPPER_HEIGHT) : (0, $6cG4N.BUSINESS_WRAPPER_HEIGHT);
    const wrapperHeight = withWrapper ? businessWrapperWithBackgroundHeight : businessWrapperHeight;
    const wrapperPadding = withWrapper ? `${0, $6cG4N.BUSINESS_WRAPPER_PADDING}px` : '0';
    const wrapperWidth = withWrapper ? (0, $6cG4N.BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH) : (0, $6cG4N.BUSINESS_WRAPPER_WIDTH);
    return `
${(0, $6cG4N.Variables).BACKDROP_FILTER}: ${isImageConfig ? 'blur(8px)' : 'none'};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST}: ${theme['color.background.neutral.subtle.hovered.contrast']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_ACCENT_SELECTED}: ${theme['color.background.accent.selected']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_BRAND_BOLD}: ${theme['color.background.brand.bold']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_BRAND_BOLD_HOVERED}: ${theme['color.background.brand.bold.hovered']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_BRAND_BOLD_PRESSED}: ${theme['color.background.brand.bold.pressed']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_DISABLED}: ${theme['color.background.disabled']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_INPUT}: ${theme['color.background.input']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_NEUTRAL}: ${theme['color.background.neutral']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_NEUTRAL_HOVERED}: ${theme['color.background.neutral.hovered']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_NEUTRAL_PRESSED}: ${theme['color.background.neutral.pressed']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED}: ${theme['color.background.neutral.subtle.hovered']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED}: ${theme['color.background.neutral.subtle.pressed']};
${(0, $6cG4N.Variables).COLOR_BACKGROUND_SELECTED}: ${theme['color.background.selected']};
${(0, $6cG4N.Variables).COLOR_BORDER}: ${theme['color.border']};
${(0, $6cG4N.Variables).COLOR_BORDER_INPUT}: ${theme['color.border.input']};
${(0, $6cG4N.Variables).COLOR_BORDER_INVERSE}: ${theme['color.border.inverse']};
${(0, $6cG4N.Variables).COLOR_BORDER_SELECTED}: ${theme['color.border.selected']};
${(0, $6cG4N.Variables).COLOR_ELEVATION_SURFACE}: ${theme['color.elevation.surface']};
${(0, $6cG4N.Variables).COLOR_ELEVATION_SURFACE_SUNKEN}: ${theme['color.elevation.surface.sunken']};
${(0, $6cG4N.Variables).COLOR_ICON_DANGER}: ${theme['color.icon.danger']};
${(0, $6cG4N.Variables).COLOR_ICON_INFORMATION}: ${theme['color.icon.information']};
${(0, $6cG4N.Variables).COLOR_ICON_SUCCESS}: ${theme['color.icon.success']};
${(0, $6cG4N.Variables).COLOR_ICON_WARNING}: ${theme['color.icon.warning']};
${(0, $6cG4N.Variables).COLOR_LINK}: ${theme['color.link']};
${(0, $6cG4N.Variables).COLOR_LINK_PRESSED}: ${theme['color.link.pressed']};
${(0, $6cG4N.Variables).COLOR_SKELETON}: ${theme['color.skeleton']};
${(0, $6cG4N.Variables).COLOR_TEXT}: ${theme['color.text']};
${(0, $6cG4N.Variables).COLOR_TEXT_ACCENT_SELECTED}: ${theme['color.text.accent.selected']};
${(0, $6cG4N.Variables).COLOR_TEXT_DISABLED}: ${theme['color.text.disabled']};
${(0, $6cG4N.Variables).COLOR_TEXT_INVERSE}: ${theme['color.text.inverse']};
${(0, $6cG4N.Variables).COLOR_TEXT_SELECTED}: ${theme['color.text.selected']};
${(0, $6cG4N.Variables).COLOR_TEXT_SUBTLE}: ${theme['color.text.subtle']};
${(0, $6cG4N.Variables).COLOR_TEXT_SUBTLEST}: ${theme['color.text.subtlest']};
${(0, $6cG4N.Variables).CONTENT_HEIGHT}: ${businessWrapperHeight};
${(0, $6cG4N.Variables).CONTENT_WIDTH}: ${0, $6cG4N.BUSINESS_WRAPPER_WIDTH};
${(0, $6cG4N.Variables).ELEVATION_SURFACE}: ${elevationSurface};
${(0, $6cG4N.Variables).ELEVATION_SURFACE_CONTRAST}: ${theme['elevation.surface.contrast']};
${(0, $6cG4N.Variables).ELEVATION_SURFACE_CONTRAST_BOLDER}: ${theme['elevation.surface.contrast.bolder']};
${(0, $6cG4N.Variables).WRAPPER_BACKGROUND}: ${wrapperBackground};
${(0, $6cG4N.Variables).WRAPPER_BORDER_RADIUS}: ${wrapperBorderRadius};
${(0, $6cG4N.Variables).WRAPPER_HEIGHT}: ${wrapperHeight};
${(0, $6cG4N.Variables).WRAPPER_PADDING}: ${wrapperPadding};
${(0, $6cG4N.Variables).WRAPPER_WIDTH}: ${wrapperWidth};
${$5026069bddf1adf4$var$buildHorizontalNavVariables(theme)}`;
};
const $5026069bddf1adf4$export$41f41c7ff10d45cd = /*#__PURE__*/ (0, $5uXOq.memo)(({ themeSetting: themeSettingFromProps, media: // rename it to "themeSetting" when cleaning up jira_theming_relay_migration
media, projectType: projectType = null })=>{
    const [{ themeSetting: themeSetting }] = (0, $4R6GH.fg)('jira_theming_relay_migration') ? [
        {
            themeSetting: undefined
        }
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $1MaBz.useThemeHook)();
    const backgroundConfig = (0, $fHEdP.themeManager).get({
        themeSetting: (0, $4R6GH.fg)('jira_theming_relay_migration') ? themeSettingFromProps : themeSetting,
        enableImages: true
    });
    const backgroundImageUrl = (0, $4R6GH.fg)('jira_theming_relay_migration') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4rtoO.useBackgroundImageUrl)(themeSettingFromProps, media) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $1r9V3.useBackgroundImageUrlOld)(themeSetting);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `:root{ ${$5026069bddf1adf4$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, false, projectType)} }
        [data-color-mode=dark]{ ${$5026069bddf1adf4$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, true, projectType)} }`
        }
    }));
});

});
parcelRegister("fHEdP", function(module, exports) {

$parcel$export(module.exports, "themeManager", () => $a34e148e1f33a06a$export$aba92a7f3273f617);
$parcel$export(module.exports, "generateMediaImageUrl", () => $a34e148e1f33a06a$export$fe2402bbc6ac3125);
$parcel$export(module.exports, "getBackgroundConfigs", () => $a34e148e1f33a06a$export$224c78c119a97f91);

var $6cG4N = parcelRequire("6cG4N");
const $a34e148e1f33a06a$var$ALL_COLOR_BACKGROUND_CONFIGS = [
    ...(0, $6cG4N.FIXED_COLOR_BACKGROUND_CONFIGS),
    ...(0, $6cG4N.ADAPTIVE_COLOR_BACKGROUND_CONFIGS),
    (0, $6cG4N.NO_BACKGROUND_CONFIG)
];
const $a34e148e1f33a06a$var$ALL_GRADIENT_BACKGROUND_CONFIGS = [
    ...(0, $6cG4N.GRADIENT_BACKGROUND_CONFIGS),
    ...(0, $6cG4N.ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS)
];
/**
 * This is a temporary class that will be used to transition between the old
 * and new theme systems. Once the old theme system is removed, this class
 * will be removed as well.
 */ class $a34e148e1f33a06a$var$ThemeManager {
    init() {
        $a34e148e1f33a06a$var$ALL_GRADIENT_BACKGROUND_CONFIGS.forEach((theme)=>{
            this.gradients.set(theme.name, theme);
            this.gradientNames.add(theme.name);
        });
        $a34e148e1f33a06a$var$ALL_COLOR_BACKGROUND_CONFIGS.forEach((theme)=>{
            this.colors.set(theme.name, theme);
            this.colorNames.add(theme.name);
        });
        (0, $6cG4N.BACKGROUND_CONFIGS_OLD).forEach((theme)=>{
            this.oldColorNames.add(theme.name);
        });
    }
    isColorTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.colorNames.has(themeName);
    }
    isOldColorTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.oldColorNames.has(themeName);
    }
    isGradientTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.gradientNames.has(themeName);
    }
    isImageTheme(themeSetting) {
        return themeSetting.type === 'image';
    }
    getGradient(themeName) {
        return this.gradients.get(themeName);
    }
    getColor(themeName) {
        return this.colors.get(themeName);
    }
    /**
	 * Gets the theme meta for the given theme setting and version.
	 * This is used because we want to handle cases where users get flag
	 * variations during rollout that change what background is allowed.
	 * For example, if you have a new background color, but the flag is off,
	 * we want to revert back to the default background color instead.
	 * @param themeSetting the name setting with its type and value.
	 * @param enableImages determines if image backgrounds are enabled.
	 * @returns the meta information for the theme.
	 */ get({ themeSetting: themeSetting, enableImages: enableImages }) {
        if (!themeSetting) return 0, $6cG4N.DEFAULT_BACKGROUND_CONFIG;
        if (enableImages && themeSetting.type === 'image') return 0, $6cG4N.IMAGE_BACKGROUND_CONFIG;
        if (this.isGradientTheme(themeSetting.value)) return this.getGradient(themeSetting.value) ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG);
        if (this.isColorTheme(themeSetting.value)) return this.getColor(themeSetting.value) ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG);
        // we have an old color on the image version
        return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $6cG4N.OLD_TO_NEW_BACKGROUND_CONFIG_MAP)[themeSetting.value] ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG));
    }
    constructor(){
        this.gradients = new Map();
        this.gradientNames = new Set();
        this.colors = new Map();
        this.colorNames = new Set();
        this.oldColorNames = new Set();
        this.isValidTheme = (themeSetting)=>this.isColorTheme(themeSetting.value) || this.isOldColorTheme(themeSetting.value) || this.isGradientTheme(themeSetting.value) || this.isImageTheme(themeSetting);
    }
}
const $a34e148e1f33a06a$export$aba92a7f3273f617 = new $a34e148e1f33a06a$var$ThemeManager();
$a34e148e1f33a06a$export$aba92a7f3273f617.init();
function $a34e148e1f33a06a$export$fe2402bbc6ac3125({ mediaApiFileId: mediaApiFileId, mediaClientId: mediaClientId, mediaExternalEndpointUrl: mediaExternalEndpointUrl, mediaEndpoint: mediaEndpoint, ...queryParams }) {
    const url = new URL(`${mediaExternalEndpointUrl}/file/${mediaApiFileId}/${mediaEndpoint}`);
    url.searchParams.append('client', mediaClientId);
    Object.entries(queryParams).forEach(([param, value])=>url.searchParams.append(param, String(value)));
    return url.toString();
}
function $a34e148e1f33a06a$export$224c78c119a97f91(withAdaptiveColorTheme) {
    return withAdaptiveColorTheme ? {
        backgroundColorConfigs: (0, $6cG4N.ADAPTIVE_COLOR_BACKGROUND_CONFIGS),
        gradientBackgroundConfigs: (0, $6cG4N.ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS)
    } : {
        backgroundColorConfigs: (0, $6cG4N.FIXED_COLOR_BACKGROUND_CONFIGS),
        gradientBackgroundConfigs: (0, $6cG4N.GRADIENT_BACKGROUND_CONFIGS)
    };
}

});

parcelRegister("1MaBz", function(module, exports) {

$parcel$export(module.exports, "ThemeContainerOld", () => $5ffb1b62a0c37aa6$export$c6e50a832af54243);
$parcel$export(module.exports, "ThemeContainer", () => $5ffb1b62a0c37aa6$export$11eb671888ed6e7d);
$parcel$export(module.exports, "useThemeHook", () => $5ffb1b62a0c37aa6$export$b95ba2c6b597cfbb);
$parcel$export(module.exports, "useThemeSetting", () => $5ffb1b62a0c37aa6$export$87d26f94ea053d38);
$parcel$export(module.exports, "useSelectedThemeSetting", () => $5ffb1b62a0c37aa6$export$4ba6f9d407e18961);
// Delete file when cleaning up jira_theming_relay_migration

var $ajpes = parcelRequire("ajpes");

var $fHEdP = parcelRequire("fHEdP");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");
const $5ffb1b62a0c37aa6$var$setTheme = (newTheme)=>({ getState: getState, setState: setState })=>{
        const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
        if ((0, $fHEdP.themeManager).isValidTheme(newTheme) && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(themeSetting?.value, newTheme?.value)) setState({
            entityId: entityId,
            selectedThemeSetting: selectedThemeSetting,
            themeSetting: newTheme
        });
    };
const $5ffb1b62a0c37aa6$var$setSelectedThemeSetting = (newTheme)=>({ getState: getState, setState: setState })=>{
        const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
        if (newTheme === null || (0, $fHEdP.themeManager).isValidTheme(newTheme) && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(selectedThemeSetting?.type === 'image' ? selectedThemeSetting?.id : selectedThemeSetting?.value, newTheme?.type === 'image' ? newTheme?.id : newTheme?.value)) setState({
            entityId: entityId,
            themeSetting: themeSetting,
            selectedThemeSetting: newTheme
        });
    };
const $5ffb1b62a0c37aa6$var$actions = {
    setTheme: $5ffb1b62a0c37aa6$var$setTheme,
    setSelectedThemeSetting: $5ffb1b62a0c37aa6$var$setSelectedThemeSetting
};
const $5ffb1b62a0c37aa6$var$initialState = {
    themeSetting: null,
    selectedThemeSetting: null,
    entityId: ''
};
const $5ffb1b62a0c37aa6$var$Store = (0, $iXqE5.createStore)({
    initialState: $5ffb1b62a0c37aa6$var$initialState,
    actions: $5ffb1b62a0c37aa6$var$actions,
    name: 'ProjectTheme'
});
const $5ffb1b62a0c37aa6$export$c6e50a832af54243 = (0, $gg7kZ.createContainer)($5ffb1b62a0c37aa6$var$Store, {
    onInit: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme),
    onUpdate: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme)
});
const $5ffb1b62a0c37aa6$export$11eb671888ed6e7d = (0, $gg7kZ.createContainer)($5ffb1b62a0c37aa6$var$Store, {
    onInit: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
            setState(entityTheme ?? $5ffb1b62a0c37aa6$var$initialState);
        },
    onUpdate: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
            setState(entityTheme ?? $5ffb1b62a0c37aa6$var$initialState);
        }
});
const $5ffb1b62a0c37aa6$export$b95ba2c6b597cfbb = (0, $3sQ5x.createHook)($5ffb1b62a0c37aa6$var$Store);
const $5ffb1b62a0c37aa6$var$getThemeSetting = (0, $6dDSs.createSelector)((state)=>state.themeSetting, (themeSetting)=>themeSetting);
const $5ffb1b62a0c37aa6$export$87d26f94ea053d38 = (0, $3sQ5x.createHook)($5ffb1b62a0c37aa6$var$Store, {
    selector: $5ffb1b62a0c37aa6$var$getThemeSetting
});
const $5ffb1b62a0c37aa6$var$getSelectedThemeSetting = (0, $6dDSs.createSelector)((state)=>state.selectedThemeSetting, (selectedThemeSetting)=>selectedThemeSetting);
const $5ffb1b62a0c37aa6$export$4ba6f9d407e18961 = (0, $3sQ5x.createHook)($5ffb1b62a0c37aa6$var$Store, {
    selector: $5ffb1b62a0c37aa6$var$getSelectedThemeSetting
});

});

const $b99d1770e7224860$export$4e0ee83a0c7b54a2 = 2;
const $b99d1770e7224860$export$d1b9ea3245b6a5de = 3;
const $b99d1770e7224860$export$d07bba395c9390f1 = 32;
const $b99d1770e7224860$export$29911ec08ab2ca2d = 5;
const $b99d1770e7224860$export$6e51fff3d6bf4e8a = 12;
const $b99d1770e7224860$export$b61e6f89a9db76de = 4;
const $b99d1770e7224860$export$7fd2e391116c6ef5 = 9;
const $b99d1770e7224860$export$e1633e494d305bfb = 'MORE';
const $b99d1770e7224860$export$1cfe9795423425c = '--horizontal-navigation-color-background-neutral-hovered';
const $b99d1770e7224860$export$539c074adec2188a = '--horizontal-navigation-color-link';
const $b99d1770e7224860$export$6f76912df5477959 = '--horizontal-navigation-color-link-pressed';
const $b99d1770e7224860$export$fac615ceaa871e35 = '--horizontal-navigation-color-text-subtle';
const $b99d1770e7224860$export$7748fdcd335afdc0 = '--horizontal-navigation-color-text';
const $b99d1770e7224860$export$88e550ed188132a7 = '--horizontal-navigation-color-elevation-surface';
const $b99d1770e7224860$export$e2e8fadb946a45d2 = '--horizontal-navigation-color-border-selected';
const $b99d1770e7224860$export$4cd72d361867c565 = '--horizontal-navigation-color-border';
const $b99d1770e7224860$export$be4d7e23cb48401e = '--horizontal-navigation-color-background-neutral';
const $b99d1770e7224860$export$cf26c31143daa350 = '--hn-yjlbv';

parcelRegister("1r9V3", function(module, exports) {

$parcel$export(module.exports, "useBackgroundImageUrlOld", () => $e9bd8754684007f4$export$c21a1b84671989e3);
// TODO: delete this file on jira_theming_relay_migration cleanup

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $fHEdP = parcelRequire("fHEdP");

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $l2N2a = parcelRequire("l2N2a");

var $azoug = parcelRequire("azoug");
const $e9bd8754684007f4$export$c21a1b84671989e3 = (themeSetting)=>{
    (0, $gKZoD.di)(URL, fetch);
    const media = (0, $l2N2a.useMediaConfiguration_DEPRECATED_DO_NOT_USE)();
    const lowResUrl = (0, $5uXOq.useMemo)(()=>media && themeSetting?.type === 'image' ? (0, $fHEdP.generateMediaImageUrl)({
            mediaClientId: media.clientId,
            mediaExternalEndpointUrl: media.externalEndpointUrl,
            mediaApiFileId: themeSetting.mediaApiFileId,
            token: themeSetting.mediaReadToken,
            mediaEndpoint: 'image',
            width: 1000,
            'max-age': Number.MAX_SAFE_INTEGER
        }) : null, [
        media,
        themeSetting
    ]);
    const [imageUrl, setImageUrl] = (0, $5uXOq.useState)(lowResUrl);
    const currentThemeId = (0, $5uXOq.useRef)(null);
    currentThemeId.current = themeSetting?.type === 'image' ? themeSetting.id : null;
    (0, $5uXOq.useEffect)(()=>{
        setImageUrl(lowResUrl);
        // if we don't have an image theme, do nothing
        if (!media || themeSetting?.type !== 'image') return;
        // build a new URL to the /binary path
        const binaryUrl = (0, $fHEdP.generateMediaImageUrl)({
            mediaClientId: media.clientId,
            mediaExternalEndpointUrl: media.externalEndpointUrl,
            mediaApiFileId: themeSetting.mediaApiFileId,
            mediaEndpoint: 'binary',
            'max-age': Number.MAX_SAFE_INTEGER
        });
        // send a request to fetch the image with the binary URL with bearer token authentication
        fetch(binaryUrl.toString(), {
            headers: {
                Authorization: `Bearer ${themeSetting.mediaReadToken}`
            }
        }).then((response)=>response.blob()).then((blob)=>{
            const objectUrl = URL.createObjectURL(blob);
            if (currentThemeId.current === themeSetting.id) {
                setImageUrl(objectUrl);
                // send viewing analytics to Unsplash for Unsplash images
                if (themeSetting.sourceType === 'UNSPLASH' && themeSetting.sourceIdentifier) (0, $azoug.unsplashTracker).trackImage(themeSetting.sourceIdentifier);
            }
        }).catch((error)=>{
            // only fire error analytics if the error is not a client fetch error (e.g. network error, aborted)
            if (!(0, $fZneA.isClientFetchError)(error)) (0, $jcw0u.default)({
                meta: {
                    id: 'fetchBinaryBackgroundImage',
                    packageName: 'jiraProjectThemeComponents',
                    teamName: 'work-management-frontier'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        themeSetting,
        media,
        lowResUrl
    ]);
    return imageUrl;
};

});
parcelRegister("azoug", function(module, exports) {

$parcel$export(module.exports, "unsplashTracker", () => $959ca91ba94e3a4e$export$1869e04dbed4c16c);

var $azYnG = parcelRequire("azYnG");

var $lFKmC = parcelRequire("lFKmC");
const $959ca91ba94e3a4e$var$APP_ID = '7066';
const $959ca91ba94e3a4e$export$ca6dda5263526f75 = `https://views.unsplash.com/v?app_id=${$959ca91ba94e3a4e$var$APP_ID}`;
const $959ca91ba94e3a4e$var$MAX_URL_LENGTH = 2083; // the maximum length of a URL in most browsers
const $959ca91ba94e3a4e$var$ID_LENGTH = 12; // the length of an unsplash image id
const $959ca91ba94e3a4e$export$28219189b23a0628 = Math.floor($959ca91ba94e3a4e$var$MAX_URL_LENGTH / $959ca91ba94e3a4e$var$ID_LENGTH);
/**
 * This class is responsible for tracking unsplash images that are displayed in the app.
 * This is needed for legal reasons to comply with the Unsplash API terms of service.
 * It will track the image when it is displayed and then track it again every 10 minutes.
 */ class $959ca91ba94e3a4e$var$UnsplashTracker {
    /**
	 * Send a request to the Unsplash API to track the image views.
	 * This will send a request for all the images in the queue.
	 * If the request fails, the images will be added back to the queue.
	 */ send() {
        if (this.queue.size === 0) return;
        const imageIds = Array.from(this.queue);
        this.queue.clear();
        (0, (/*@__PURE__*/$parcel$interopDefault($azYnG)))(imageIds, $959ca91ba94e3a4e$export$28219189b23a0628).forEach((chunkIds)=>{
            const url = `${$959ca91ba94e3a4e$export$ca6dda5263526f75}&photoId=${chunkIds.join(',')}`;
            const now = new Date();
            imageIds.forEach((imageId)=>{
                this.trackedImages.set(imageId, now);
            });
            const handleFailure = ()=>{
                // if the request fails, add the image ids back to the queue
                imageIds.forEach((imageId)=>{
                    this.queue.add(imageId);
                    this.trackedImages.delete(imageId);
                });
            };
            fetch(url).then((response)=>{
                if (!response.ok) handleFailure();
            }).catch(()=>handleFailure());
        });
    }
    /**
	 * Track an image view. This will add the image to the queue to be tracked.
	 * If the image was tracked less than 10 minutes ago, it will not be added to the queue.
	 * @param sourceIdentifier The Unsplash photo id to track. Usually formatted as `photo-<something>-<id>`
	 * @returns void
	 */ trackImage(sourceIdentifier) {
        const imageId = sourceIdentifier.split('-').pop(); // photo-1696144706485-ff7825ec8481 -> ff7825ec8481
        if (!imageId) return;
        const lastTracked = this.trackedImages.get(imageId);
        if (lastTracked && Date.now() - lastTracked.getTime() < this.trackingInterval) return;
        this.queue.add(imageId);
        this.sendDebounced();
    }
    /**
	 * Track an image view while it is in the viewport. This will track the image when it is displayed
	 * and then track it again every 10 minutes.
	 * @param element The element that contains the image
	 * @param sourceIdentifier The Unsplash photo id to track. Usually formatted as `photo-<something>-<id>`
	 * @returns A function to stop tracking the image
	 */ trackWhileInViewport(element, sourceIdentifier) {
        let trackIntervalId = null;
        const observer = new IntersectionObserver((entry)=>{
            if (entry[0].isIntersecting && !trackIntervalId) {
                $959ca91ba94e3a4e$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                trackIntervalId = window.setInterval(()=>{
                    $959ca91ba94e3a4e$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                }, this.trackingInterval + 10); // extra 10ms to ensure the interval is always greater than 10 minutes
            } else if (trackIntervalId) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearInterval(trackIntervalId);
        }, {
            rootMargin: '0px',
            threshold: 1.0
        });
        observer.observe(element);
        return ()=>{
            observer.disconnect();
            if (trackIntervalId) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearInterval(trackIntervalId);
        };
    }
    static getInstance() {
        if (!$959ca91ba94e3a4e$var$UnsplashTracker.instance) $959ca91ba94e3a4e$var$UnsplashTracker.instance = new $959ca91ba94e3a4e$var$UnsplashTracker();
        return $959ca91ba94e3a4e$var$UnsplashTracker.instance;
    }
    constructor(){
        this.trackedImages = new Map();
        this.trackingInterval = 600000 // 10 minutes
        ;
        this.queue = new Set();
        this.sendDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(this.send, 1000);
    }
}
const $959ca91ba94e3a4e$export$1869e04dbed4c16c = $959ca91ba94e3a4e$var$UnsplashTracker.getInstance();

});
parcelRegister("azYnG", function(module, exports) {

var $dM3Z8 = parcelRequire("dM3Z8");

var $4rDUz = parcelRequire("4rDUz");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7b3c02adf390bcc6$var$nativeCeil = Math.ceil, $7b3c02adf390bcc6$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $7b3c02adf390bcc6$var$chunk(array, size, guard) {
    if (guard ? $4rDUz(array, size, guard) : size === undefined) size = 1;
    else size = $7b3c02adf390bcc6$var$nativeMax($kPZpS(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($7b3c02adf390bcc6$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = $dM3Z8(array, index, index += size);
    return result;
}
module.exports = $7b3c02adf390bcc6$var$chunk;

});



parcelRegister("4rtoO", function(module, exports) {

$parcel$export(module.exports, "useBackgroundImageUrl", () => $71f1c3b940e0c2ec$export$16f28a2a10ece447);

var $5uXOq = parcelRequire("5uXOq");

var $fHEdP = parcelRequire("fHEdP");

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $azoug = parcelRequire("azoug");
const $71f1c3b940e0c2ec$export$16f28a2a10ece447 = (themeSetting, media)=>{
    const lowResUrl = (0, $5uXOq.useMemo)(()=>media && themeSetting?.type === 'image' ? (0, $fHEdP.generateMediaImageUrl)({
            mediaClientId: media.clientId,
            mediaExternalEndpointUrl: media.externalEndpointUrl,
            mediaApiFileId: themeSetting.mediaApiFileId,
            token: themeSetting.mediaReadToken,
            mediaEndpoint: 'image',
            width: 1000,
            'max-age': Number.MAX_SAFE_INTEGER
        }) : null, [
        media,
        themeSetting
    ]);
    const [imageUrl, setImageUrl] = (0, $5uXOq.useState)(lowResUrl);
    const previousThemeId = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (themeSetting?.type !== 'image') {
            previousThemeId.current = null;
            setImageUrl(null);
            return;
        }
        if (previousThemeId.current !== themeSetting.id && media) {
            previousThemeId.current = themeSetting.id;
            setImageUrl(lowResUrl);
            // build a new URL to the /binary path
            const binaryUrl = (0, $fHEdP.generateMediaImageUrl)({
                mediaClientId: media.clientId,
                mediaExternalEndpointUrl: media.externalEndpointUrl,
                mediaApiFileId: themeSetting.mediaApiFileId,
                mediaEndpoint: 'binary',
                'max-age': Number.MAX_SAFE_INTEGER
            });
            // send a request to fetch the image with the binary URL with bearer token authentication
            fetch(binaryUrl.toString(), {
                headers: {
                    Authorization: `Bearer ${themeSetting.mediaReadToken}`
                }
            }).then((response)=>response.blob()).then((blob)=>{
                const objectUrl = URL.createObjectURL(blob);
                setImageUrl(objectUrl);
                // send viewing analytics to Unsplash for Unsplash images
                if (themeSetting.sourceType === 'UNSPLASH' && themeSetting.sourceIdentifier) (0, $azoug.unsplashTracker).trackImage(themeSetting.sourceIdentifier);
            }).catch((error)=>{
                // only fire error analytics if the error is not a client fetch error (e.g. network error, aborted)
                if (!(0, $fZneA.isClientFetchError)(error)) (0, $jcw0u.default)({
                    meta: {
                        id: 'fetchBinaryBackgroundImage',
                        packageName: 'jiraProjectThemeComponents',
                        teamName: 'work-management-frontier'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        }
    }, [
        themeSetting,
        media,
        lowResUrl
    ]);
    return imageUrl;
};

});



parcelRegister("hCILh", function(module, exports) {

let $cd48b4fffadf1c55$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cd48b4fffadf1c55$var$load("OgDz0").then(()=>parcelRequire('gEdc8'));

});


parcelRegister("jmzCL", function(module, exports) {

$parcel$export(module.exports, "ProjectThemeSetter", () => $1f748255f8976437$export$fd1b0084c5bb04a9);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $ao2h1 = parcelRequire("ao2h1");

var $dZJHS = parcelRequire("dZJHS");

var $9V5k0 = parcelRequire("9V5k0");

var $dC4s3 = parcelRequire("dC4s3");
const $1f748255f8976437$export$fd1b0084c5bb04a9 = ()=>{
    const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $9V5k0.projectThemeResource));
    if (!queryReference) /* The resource is available only for routes enabled for theming.
		We still need to set the default token color by using ThemeTokenSetter for all other routes.
		This can be removed once theming is enabled for all pages. */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC4s3.ThemeTokensSetter), {
        themeSetting: null
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "projectThemeSetter",
        packageName: "jiraPageContainerV2",
        teamName: "deliveroo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "project-theme-setter-placeholder",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZJHS.ThemeSetter), {
        queryReference: queryReference
    })));
};

});


parcelRegister("erjJQ", function(module, exports) {

$parcel$export(module.exports, "Content", () => $780b11bdb912365c$export$7c6e2c02157bb7d2);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $cSD7y = parcelRequire("cSD7y");

var $7XYc4 = parcelRequire("7XYc4");

var $5jPIk = parcelRequire("5jPIk");

var $3HwlS = parcelRequire("3HwlS");

var $iqLcb = parcelRequire("iqLcb");

var $3Uek9 = parcelRequire("3Uek9");

var $gk293 = parcelRequire("gk293");

var $5M3R9 = parcelRequire("5M3R9");

var $enQ8X = parcelRequire("enQ8X");

var $lODMY = parcelRequire("lODMY");

var $erBFB = parcelRequire("erBFB");

var $h0PjI = parcelRequire("h0PjI");
/* IMPORTANT:
 * When making any changes to the Nav3 component, please ensure that you also make the same changes to the
 * Nav4 component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $780b11bdb912365c$var$SPA_TRACE_KEY = 'spa';
const $780b11bdb912365c$var$DefaultLayoutContentNav4 = (props)=>{
    const { isInset: isInset, hasTheming: hasTheming } = (0, $3Uek9.useProjectTheme)();
    const renderContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "mainContentSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.MainContentSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
        type: "start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $enQ8X.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
        type: "end"
    }));
    if (hasTheming) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gk293.ThemedContentLayout), {
        appearance: isInset ? 'inset' : 'default'
    }, renderContent);
    return renderContent;
};
const $780b11bdb912365c$var$DefaultLayoutContentNav3 = (props)=>{
    const { isInset: isInset, hasProjectViewNavigation: hasProjectViewNavigation } = (0, $3Uek9.useProjectTheme)();
    const renderContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5jPIk.MainHeightFixCss), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "mainContentSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erBFB.MainContentSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqLcb.Main), {
        id: "ak-main-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
        type: "start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $enQ8X.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
        type: "end"
    })));
    if (hasProjectViewNavigation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gk293.ProjectThemeWrapper), {
        withWhiteBackground: isInset
    }, renderContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h0PjI.LayoutMainWrapper), null, renderContent);
};
const $780b11bdb912365c$var$DefaultLayoutContent = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $780b11bdb912365c$var$DefaultLayoutContentNav4, $780b11bdb912365c$var$DefaultLayoutContentNav3);
const $780b11bdb912365c$var$useRouterRoute = (0, $lODMY.createRouterSelector)((state)=>state.route);
const $780b11bdb912365c$var$ContentNew = (props)=>{
    const { LayoutOverrideComponent: LayoutOverrideComponent } = $780b11bdb912365c$var$useRouterRoute();
    if (LayoutOverrideComponent !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
        type: "start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $enQ8X.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5M3R9.RenderTracerMark), {
        traceKey: $780b11bdb912365c$var$SPA_TRACE_KEY,
        type: "end"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($780b11bdb912365c$var$DefaultLayoutContent, props);
};
const $780b11bdb912365c$export$7c6e2c02157bb7d2 = (0, $cSD7y.componentWithFG)(// Note: this is a kill-switch so true=old component, false=new component
'assets_as_an_app_kill_switch', $780b11bdb912365c$var$DefaultLayoutContent, $780b11bdb912365c$var$ContentNew);

});
parcelRegister("5jPIk", function(module, exports) {

$parcel$export(module.exports, "MainHeightFixCss", () => $cf8c915f080efbd8$export$2fcd4100c556a49e);

var $5uXOq = parcelRequire("5uXOq");

const $cf8c915f080efbd8$export$2fcd4100c556a49e = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `[data-ds--page-layout--slot="main"] { height: calc(100vh - ${(0, $81918a2ef6db1f93$export$d60454526e2281af)}) }`
        }
    });

});

parcelRegister("gk293", function(module, exports) {

$parcel$export(module.exports, "ThemedContentLayout", () => $24fd52a828227843$export$c2c3c7c0b13a1f9d);
$parcel$export(module.exports, "ProjectThemeWrapper", () => $24fd52a828227843$export$65c56727ada4372d);
/* ProjectThemeWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3HwlS = parcelRequire("3HwlS");

var $jtC5b = parcelRequire("jtC5b");
const $24fd52a828227843$var$styles = {
    rootOld: "_kqswh2mm",
    root: "_kqswh2mm",
    fullHeight: "_1tkeidpf _4t3i1osq",
    insetRoot: "_1yt4y9h4",
    insetContainer: "_2rko1gnp _bfhkp043"
};
const $24fd52a828227843$export$c2c3c7c0b13a1f9d = ({ children: children, appearance: appearance })=>/*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            (0, $3HwlS.getWillShowNav4)() && $24fd52a828227843$var$styles.root,
            !(0, $3HwlS.getWillShowNav4)() && $24fd52a828227843$var$styles.rootOld,
            $24fd52a828227843$var$styles.fullHeight,
            appearance === 'inset' && $24fd52a828227843$var$styles.insetRoot
        ])
    }, /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $24fd52a828227843$var$styles.fullHeight,
            appearance === 'inset' && $24fd52a828227843$var$styles.insetContainer
        ])
    }, children));
const $24fd52a828227843$export$65c56727ada4372d = ({ withWhiteBackground: withWhiteBackground, children: children })=>{
    if (withWhiteBackground) return /*#__PURE__*/ $5uXOq.createElement((0, $jtC5b.OuterWrapperWithBackground), null, /*#__PURE__*/ $5uXOq.createElement((0, $jtC5b.InnerWrapperWithBackground), null, children));
    return /*#__PURE__*/ $5uXOq.createElement((0, $jtC5b.OuterWrapper), null, /*#__PURE__*/ $5uXOq.createElement((0, $jtC5b.InnerWrapper), null, children));
};

});
parcelRegister("jtC5b", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $c37919f3b01a53ae$export$edaaad985a878983);
$parcel$export(module.exports, "OuterWrapperWithBackground", () => $c37919f3b01a53ae$export$69c6ec128d3729c9);
$parcel$export(module.exports, "InnerWrapper", () => $c37919f3b01a53ae$export$f185744748c379a7);
$parcel$export(module.exports, "InnerWrapperWithBackground", () => $c37919f3b01a53ae$export$2e149d12a18af14b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XYc4 = parcelRequire("7XYc4");

var $3HwlS = parcelRequire("3HwlS");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $c37919f3b01a53ae$var$Nav3OuterWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _154i14em",
            __cmplp.className
        ])
    });
});
const $c37919f3b01a53ae$var$Nav4OuterWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _154iv7uf",
            __cmplp.className
        ])
    });
});
const $c37919f3b01a53ae$export$edaaad985a878983 = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $c37919f3b01a53ae$var$Nav4OuterWrapper, $c37919f3b01a53ae$var$Nav3OuterWrapper);
const $c37919f3b01a53ae$export$69c6ec128d3729c9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $c37919f3b01a53ae$export$edaaad985a878983, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4y9h4",
            __cmplp.className
        ])
    });
});
const $c37919f3b01a53ae$export$f185744748c379a7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_iu1g1fl4 _fok81wug _q7c11wug _2d3f3q3i _japi1o48",
            __cmplp.className
        ])
    });
});
const $c37919f3b01a53ae$export$2e149d12a18af14b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $c37919f3b01a53ae$export$f185744748c379a7, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1gnp _bfhkp043 _2d3f15y4 _japizntk",
            __cmplp.className
        ])
    });
});

});


parcelRegister("enQ8X", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f1817a083d388c8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jD5no = parcelRequire("jD5no");

var $gAeCk = parcelRequire("gAeCk");

var $2SVPM = parcelRequire("2SVPM");

var $gEwZr = parcelRequire("gEwZr");
const $1f1817a083d388c8$var$onSpaShellReady = ()=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/spa-shell/core', '_jira-spa/spa-shell.start', 'JIRA_SPA_SHELL_READY');
};
const $1f1817a083d388c8$var$Spa = ({ initRoute: initRoute = null, routes: routes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: "JIRA_SPA_SHELL_READY",
        onSet: $1f1817a083d388c8$var$onSpaShellReady
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEwZr.default), {
        initRoute: initRoute,
        routes: routes
    }));
var $1f1817a083d388c8$export$2e2bcd8739ae039 = $1f1817a083d388c8$var$Spa;

});
parcelRegister("gEwZr", function(module, exports) {

$parcel$export(module.exports, "default", () => $308f7fd68513e9ff$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fq71H = parcelRequire("fq71H");

var $8Orxo = parcelRequire("8Orxo");

var $1POpY = parcelRequire("1POpY");

var $g9Y8U = parcelRequire("g9Y8U");

var $kb4zh = parcelRequire("kb4zh");

var $x9xyg = parcelRequire("x9xyg");

var $dJl1T = parcelRequire("dJl1T");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $lfTZh = parcelRequire("lfTZh");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $2SVPM = parcelRequire("2SVPM");

var $4oDnX = parcelRequire("4oDnX");

var $6IjvB = parcelRequire("6IjvB");

var $imS60 = parcelRequire("imS60");

var $lODMY = parcelRequire("lODMY");
var $2Gs5h = parcelRequire("2Gs5h");
var $lVJAU = parcelRequire("lVJAU");

var $fzsaE = parcelRequire("fzsaE");

var $iLrcb = parcelRequire("iLrcb");

var $l9F59 = parcelRequire("l9F59");

var $i6dHx = parcelRequire("i6dHx");

var $Smjim = parcelRequire("Smjim");
const $308f7fd68513e9ff$var$REMOTE_ACTIONS_OFF = 'OFF';
const $308f7fd68513e9ff$var$REMOTE_ACTIONS_PERFORM = 'PERFORM';
const $308f7fd68513e9ff$var$useRouterLocation = (0, $lODMY.createRouterSelector)((state)=>state.location);
const $308f7fd68513e9ff$var$useRouterAction = (0, $lODMY.createRouterSelector)((state)=>state.action);
const $308f7fd68513e9ff$var$useRouterQuery = (0, $lODMY.createRouterSelector)((state)=>state.query);
const $308f7fd68513e9ff$var$useRouterRoute = (0, $lODMY.createRouterSelector)((state)=>state.route);
const $308f7fd68513e9ff$var$useRouterMatch = (0, $lODMY.createRouterSelector)((state)=>state.match);
const $308f7fd68513e9ff$var$useRouterRoutes = (0, $lODMY.createRouterSelector)((state)=>state.routes);
const $308f7fd68513e9ff$var$useIsLazyRoutes = (0, $lODMY.createRouterSelector)((state)=>state.isLazyRoutes);
let $308f7fd68513e9ff$var$hasPendingForceReloadAction = false;
const $308f7fd68513e9ff$var$getRemoteActionsRolloutStage = ()=>(0, $4R6GH.fg)('remote_actions_-_killswitch_-_temporary') ? $308f7fd68513e9ff$var$REMOTE_ACTIONS_PERFORM : $308f7fd68513e9ff$var$REMOTE_ACTIONS_OFF;
const $308f7fd68513e9ff$export$88fe66870dd8f843 = (value)=>{
    $308f7fd68513e9ff$var$hasPendingForceReloadAction = value;
};
const $308f7fd68513e9ff$export$39e8f9fc07dd3395 = ()=>$308f7fd68513e9ff$var$hasPendingForceReloadAction;
const $308f7fd68513e9ff$var$fireRemoteActionAnalytics = (analyticsEvent, eventAction, remoteAction, currentRoute, targetRoute, attempts, lastAttemptedAt)=>(0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `remoteAction ${eventAction}`, {
        source: 'transitionBlocker',
        actionId: remoteAction != null && remoteAction.id != null ? String(remoteAction.id) : '',
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        frontendVersion: window.BUILD_KEY,
        currentRouteName: currentRoute?.route.name || '',
        targetRouteName: targetRoute?.route.name || '',
        remoteActionsRolloutStage: $308f7fd68513e9ff$var$getRemoteActionsRolloutStage(),
        attempts: attempts,
        lastAttemptedAt: lastAttemptedAt
    });
const $308f7fd68513e9ff$var$updateSentryBreadcrumb = (route, nextRoute)=>{
    const from = route.path + (route.query ? `?${route.query.join('&')}` : '');
    const to = nextRoute?.path + (nextRoute?.query ? `?${nextRoute.query.join('&')}` : '');
    (0, $fq71H.addBreadcrumb)({
        type: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
};
/**
 * Manages the routing, analytics, and remote actions within a single-page application (SPA).
 * This component sets up initial routes, enables analytics tracking, and handles SPA transitions.
 * It incorporates custom logic for page reloading or redirection under certain conditions
 * and ensures safe rendering of route components within an error boundary context.
 */ const $308f7fd68513e9ff$var$Spa = ({ routes: routes, initRoute: initRoute = null })=>{
    (0, $5uXOq.useMemo)(()=>{
        (0, $x9xyg.setMark)('jira-spa/view.start');
    }, []);
    const checkShouldResetPage = (0, $5uXOq.useMemo)(()=>(0, $6IjvB.createCheckShouldResetPage)(), []);
    const currentMatchObjectRef = (0, $5uXOq.useRef)(initRoute);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/view', 'jira-spa/view.start', true);
    }, []);
    const { registerBlock: registerBlock } = (0, $lVJAU.useRouterActions)();
    const location = $308f7fd68513e9ff$var$useRouterLocation();
    const action = $308f7fd68513e9ff$var$useRouterAction();
    const query = $308f7fd68513e9ff$var$useRouterQuery();
    const route = $308f7fd68513e9ff$var$useRouterRoute();
    const match = $308f7fd68513e9ff$var$useRouterMatch();
    const isLazyRoutes = $308f7fd68513e9ff$var$useIsLazyRoutes();
    const routerRoutes = $308f7fd68513e9ff$var$useRouterRoutes();
    // If the Lazy Route Map experiment is enabled, we want to use the routes from
    // the router, not from props as they will be changing dynamically during page lifetime
    if (isLazyRoutes) // eslint-disable-next-line no-param-reassign
    routes = routerRoutes;
    const { shouldPerformAction: shouldPerformAction, performAction: performAction } = (0, $fzsaE.useShouldPerformAction)({
        actionName: 'forceReload'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    /* We update currentMatch only if it's not a redirect. So in canTransitionIn we can compare
	 * actual routes instead of comparing against the redirect one */ if (route.isRedirect !== true) currentMatchObjectRef.current = {
        route: route,
        match: match
    };
    const [, { resetCurrentPage: resetCurrentPage }] = (0, $4oDnX.useSpaStateActions)();
    /* We regiser the blocker on every render to be sure that it gets added as first item
	 * even when the route changes (so it gets called last). It will be added only once anyway.
	 * This is our custom block() API that accepts promises.
	 * This code allows us to disable an SPA transition and trigger a full page reload
	 * in case the route we are moving out (or in) needs it. */ const transitionBlocker = (0, $5uXOq.useCallback)((nextLocation, nextAction)=>{
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'Query | undefined'.
        const nextMatch = (0, $2Gs5h.default)(routes, nextLocation.pathname, nextLocation.search);
        const canDo = (0, $l9F59.default)(currentMatchObjectRef.current, nextMatch);
        // Checking how many routes is a proxy for determining whether the lazy routes have been loaded
        // canDo might still be true if this is a transition from an issue to an issue
        if (isLazyRoutes && !canDo && routes.length <= 3) (0, $dJl1T.default).safeInfoWithoutCustomerData('lazy_routes.transition', 'failure', {
            route: nextMatch?.route.name
        });
        if (!canDo) {
            const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location[windowAction]((0, $8Orxo.createPath)(nextLocation));
        }
        const remoteActionsRolloutStage = $308f7fd68513e9ff$var$getRemoteActionsRolloutStage();
        if (remoteActionsRolloutStage !== $308f7fd68513e9ff$var$REMOTE_ACTIONS_OFF && createAnalyticsEvent !== null) {
            const currentMatch = currentMatchObjectRef.current;
            if (canDo && currentMatch?.route.name !== nextMatch?.route.name && shouldPerformAction && $308f7fd68513e9ff$var$hasPendingForceReloadAction === false) {
                $308f7fd68513e9ff$var$hasPendingForceReloadAction = true;
                const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                performAction((remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $308f7fd68513e9ff$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'performed', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.location[windowAction]((0, $8Orxo.createPath)(nextLocation));
                }, (remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $308f7fd68513e9ff$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'cancelled', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                });
            }
        }
        return canDo;
    }, [
        performAction,
        routes,
        shouldPerformAction,
        createAnalyticsEvent,
        isLazyRoutes
    ]);
    const resetCurrentPageBeforeRouteChangeBlocker = (0, $5uXOq.useCallback)((nextLocation, nextAction)=>{
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'Query | undefined'.
        const nextMatchObject = (0, $2Gs5h.default)(routes, nextLocation.pathname, nextLocation.search);
        if (nextMatchObject && match && route) {
            const { match: nextMatch, route: nextRoute } = nextMatchObject;
            const shouldReset = checkShouldResetPage({
                nextMatch: nextMatch,
                nextRoute: nextRoute,
                currentMatch: match,
                currentRoute: route,
                action: nextAction
            });
            const nextRouteUfoName = (0, $1POpY.default)(nextRoute);
            if (shouldReset) {
                resetCurrentPage(nextRouteUfoName, nextRoute.name);
                (0, $iLrcb.GlobalPageLoadExperience).setPageLoadId(nextRoute.perfMetricKey || 'UNKNOWN');
            }
            const isCurrentRouteRedirecting = route.isRedirect === true;
            if (isCurrentRouteRedirecting) {
                const currentRouteName = (0, $1POpY.default)(route);
                (0, $g9Y8U.default)(currentRouteName, nextRouteUfoName, nextRoute.name, performance.now());
            }
        }
        $308f7fd68513e9ff$var$updateSentryBreadcrumb(route, nextMatchObject?.route);
        return true;
    }, [
        checkShouldResetPage,
        match,
        resetCurrentPage,
        route,
        routes
    ]);
    registerBlock(transitionBlocker);
    registerBlock(resetCurrentPageBeforeRouteChangeBlocker);
    const renderRouteComponent = (0, $5uXOq.useCallback)(()=>{
        const { component: RouteComponent, shouldOptOutConcurrentMode: shouldOptOutConcurrentMode, isStrictModeEnabled: isStrictModeEnabled, skeleton: skeleton } = route;
        const Skeleton = skeleton || (0, $kb4zh.default);
        if ((0, $4R6GH.fg)('jira-concurrent-incremental')) {
            if (!shouldOptOutConcurrentMode) return (0, $4R6GH.fg)('fix-suspense-tesseract-error') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.PlaceholderWithNativeSuspense), {
                name: "concurrent-root",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i6dHx.ConcurrentRootComponent), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i6dHx.ConcurrentRootComponent), null);
        }
        if (RouteComponent) {
            if ((0, $4R6GH.fg)('fix-suspense-tesseract-error')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($308f7fd68513e9ff$var$ConditionalStrictMode, {
                isEnabled: isStrictModeEnabled
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.PlaceholderWithNativeSuspense), {
                name: "route-component",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RouteComponent, {
                location: location,
                route: route,
                match: match,
                action: action,
                query: query
            })));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($308f7fd68513e9ff$var$ConditionalStrictMode, {
                isEnabled: isStrictModeEnabled
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RouteComponent, {
                location: location,
                route: route,
                match: match,
                action: action,
                query: query
            }));
        }
    }, [
        action,
        location,
        match,
        query,
        route
    ]);
    if (!(route && match)) return null;
    const { meta: meta, skeleton: skeleton } = route;
    const Skeleton = skeleton || (0, $kb4zh.default);
    const entryPoint = route.entryPoint?.();
    const { reporting: reporting } = meta || {};
    const renderRouteEntryPointContainer = ()=>{
        if ((0, $4R6GH.fg)('fix-suspense-tesseract-error')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.PlaceholderWithNativeSuspense), {
            name: "route-entry-point-container",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Smjim.RouteEntryPointContainer), {
            location: location,
            route: route,
            match: match,
            action: action,
            query: query
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Smjim.RouteEntryPointContainer), {
            location: location,
            route: route,
            match: match,
            action: action,
            query: query
        });
    };
    /* Render a <Route> component instead of the page directly so the match prop can be
	 * propagated down to components wrapped with the withRouter HOC. Unfortunately, this
	 * means we forfeit the right to access query params via match is provided by <Route>
	 * rather than our custom matchRoute function. */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "route-component"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        // explicitly coerce undefined to string to make flow happy
        id: `routeApp.${String(route.name)}`,
        packageName: "jiraSpa",
        extraEventData: {
            routeGroup: route.group ?? '',
            isSSR: false
        },
        fallback: "page",
        sendToPrivacyUnsafeSplunk: Boolean(reporting),
        ...reporting
    }, entryPoint ? renderRouteEntryPointContainer() : renderRouteComponent()));
};
function $308f7fd68513e9ff$var$ConditionalStrictMode(props) {
    // Default to true
    const { isEnabled: isEnabled = true, children: children } = props;
    // This flag just gives us a kill switch
    if (isEnabled && (0, $4R6GH.fg)('jfp-jira-incremental-strict-mode')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.StrictMode), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
}
var $308f7fd68513e9ff$export$2e2bcd8739ae039 = $308f7fd68513e9ff$var$Spa;

});
parcelRegister("8Orxo", function(module, exports) {

$parcel$export(module.exports, "addLeadingSlash", () => $66a85aa0db68ca7e$export$5b4913142e03bca8, (v) => $66a85aa0db68ca7e$export$5b4913142e03bca8 = v);
$parcel$export(module.exports, "hasBasename", () => $66a85aa0db68ca7e$export$10497c7ce66fcb84, (v) => $66a85aa0db68ca7e$export$10497c7ce66fcb84 = v);
$parcel$export(module.exports, "stripBasename", () => $66a85aa0db68ca7e$export$b69e3301ce081aa3, (v) => $66a85aa0db68ca7e$export$b69e3301ce081aa3 = v);
$parcel$export(module.exports, "stripTrailingSlash", () => $66a85aa0db68ca7e$export$d95b4586d238a081, (v) => $66a85aa0db68ca7e$export$d95b4586d238a081 = v);
$parcel$export(module.exports, "parsePath", () => $66a85aa0db68ca7e$export$8ccf933b0513f8d0, (v) => $66a85aa0db68ca7e$export$8ccf933b0513f8d0 = v);
$parcel$export(module.exports, "createPath", () => $66a85aa0db68ca7e$export$fe53371bee54353d, (v) => $66a85aa0db68ca7e$export$fe53371bee54353d = v);
var $66a85aa0db68ca7e$export$1e511d4a378977f5;
var $66a85aa0db68ca7e$export$5b4913142e03bca8;
var $66a85aa0db68ca7e$export$79c5b1569e3be9e6;
var $66a85aa0db68ca7e$export$10497c7ce66fcb84;
var $66a85aa0db68ca7e$export$b69e3301ce081aa3;
var $66a85aa0db68ca7e$export$d95b4586d238a081;
var $66a85aa0db68ca7e$export$8ccf933b0513f8d0;
var $66a85aa0db68ca7e$export$fe53371bee54353d;
'use strict';
$66a85aa0db68ca7e$export$1e511d4a378977f5 = true;
var $66a85aa0db68ca7e$var$addLeadingSlash = $66a85aa0db68ca7e$export$5b4913142e03bca8 = function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
};
var $66a85aa0db68ca7e$var$stripLeadingSlash = $66a85aa0db68ca7e$export$79c5b1569e3be9e6 = function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
};
var $66a85aa0db68ca7e$var$hasBasename = $66a85aa0db68ca7e$export$10497c7ce66fcb84 = function hasBasename(path, prefix) {
    return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};
var $66a85aa0db68ca7e$var$stripBasename = $66a85aa0db68ca7e$export$b69e3301ce081aa3 = function stripBasename(path, prefix) {
    return $66a85aa0db68ca7e$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};
var $66a85aa0db68ca7e$var$stripTrailingSlash = $66a85aa0db68ca7e$export$d95b4586d238a081 = function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};
var $66a85aa0db68ca7e$var$parsePath = $66a85aa0db68ca7e$export$8ccf933b0513f8d0 = function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
};
var $66a85aa0db68ca7e$var$createPath = $66a85aa0db68ca7e$export$fe53371bee54353d = function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
    return path;
};

});

parcelRegister("g9Y8U", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e1183d53450b542$export$2e2bcd8739ae039);

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");

var $cb0MQ = parcelRequire("cb0MQ");
function $2e1183d53450b542$export$2e2bcd8739ae039(fromUfoName, nextUfoName, nextRouteName, time) {
    (0, $cb0MQ.default).current = nextUfoName;
    const interactionId = (0, $32M8E.DefaultInteractionID).current;
    if (interactionId) (0, $lAOer.addRedirect)(interactionId, fromUfoName, nextUfoName, nextRouteName, time);
}

});

parcelRegister("6IjvB", function(module, exports) {

$parcel$export(module.exports, "createCheckShouldResetPage", () => $f43999df472d4d05$export$ffb8c03de895ae3);

var $ajpes = parcelRequire("ajpes");

var $4R6GH = parcelRequire("4R6GH");

var $vrkiK = parcelRequire("vrkiK");
const $f43999df472d4d05$var$isReplaceActionAndPIN = (action, route)=>action === 'REPLACE' && route.group === 'issue-navigator';
const $f43999df472d4d05$var$isReplaceActionAndJPD = (action, route)=>action === 'REPLACE' && route.name === 'polaris-ideas' && (0, $4R6GH.fg)('jpd-ignore-page-reset-on-route-replacing');
const $f43999df472d4d05$export$ffb8c03de895ae3 = ()=>{
    let rapidBoardPaths = [];
    return ({ currentMatch: currentMatch, currentRoute: currentRoute, nextMatch: nextMatch, nextRoute: nextRoute, action: action })=>{
        let shouldReset = true;
        if ($f43999df472d4d05$var$isReplaceActionAndPIN(action, nextRoute) || $f43999df472d4d05$var$isReplaceActionAndJPD(action, nextRoute) || currentRoute.isRedirect === true) shouldReset = false;
        else {
            const cleanMatch = (0, $vrkiK.getApdexMatchObject)(currentMatch, currentRoute);
            const cleanNextMatch = (0, $vrkiK.getApdexMatchObject)(nextMatch, nextRoute);
            shouldReset = !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(cleanMatch, cleanNextMatch) && shouldReset;
            if (shouldReset) {
                // RapidboardPaths is being persisted here.
                // resetDone boolean is calculated in the util function.
                const [paths, resetBoolean] = (0, $vrkiK.calcRapidBoardResetStateV2)(rapidBoardPaths, nextRoute.name, !!nextMatch.query.useStoredSettings);
                rapidBoardPaths = paths;
                if ((0, $vrkiK.isValidRoute)(nextRoute) || nextRoute.group === 'classic-software') shouldReset = !resetBoolean;
            }
        }
        return shouldReset;
    };
};

});
parcelRegister("vrkiK", function(module, exports) {

$parcel$export(module.exports, "calcRapidBoardResetState", () => $fd0af9cf1691807e$export$2350ed3ff6c1a082);
$parcel$export(module.exports, "getApdexMatchObject", () => $fd0af9cf1691807e$export$47e434f08768932b);
$parcel$export(module.exports, "calcRapidBoardResetStateV2", () => $fd0af9cf1691807e$export$dbd9185166d0d04c);
$parcel$export(module.exports, "isValidRoute", () => $fd0af9cf1691807e$export$9f3e656a7f6a3adc);
const $fd0af9cf1691807e$export$2350ed3ff6c1a082 = (boardPaths, routeName, useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 'browse-project-redirect':
            rapidBoardPaths = [
                'browse-project-redirect'
            ];
            resetDone = true;
            break;
        case 'rapidboard-board':
        case 'rapidboard-board-embed':
        case 'rapidboard-backlog':
        case 'rapidboard-report':
            if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                resetDone = false;
                break;
            }
            if (!useStoredSettings && rapidBoardPaths.indexOf('browse-project-redirect') > -1 && rapidBoardPaths.indexOf('useStoredSettings') > -1 || rapidBoardPaths.indexOf('useStoredSettings') > -1) resetDone = true;
            rapidBoardPaths = [];
            break;
        default:
            resetDone = false;
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $fd0af9cf1691807e$export$47e434f08768932b = (match, route)=>{
    let cleanMatch = {
        ...match,
        params: {
            ...match.params
        },
        query: {
            ...match.query
        }
    };
    if (route.apdexIgnoreParams && route.apdexIgnoreParams.length > 0) route.apdexIgnoreParams.forEach((apdexIgnoreParam)=>{
        const { params: params, query: query } = match;
        const paramKeys = params && Object.keys(params);
        const queryKeys = query && Object.keys(query);
        const isIgnoreInParams = paramKeys && paramKeys.length > 0 && paramKeys.indexOf(apdexIgnoreParam) >= 0;
        const isIgnoreInQuery = queryKeys && queryKeys.length > 0 && queryKeys.indexOf(apdexIgnoreParam) >= 0;
        if (isIgnoreInParams) cleanMatch.params[apdexIgnoreParam] = apdexIgnoreParam;
        if (isIgnoreInQuery) cleanMatch.query[apdexIgnoreParam] = apdexIgnoreParam;
    });
    if (match.query && match.query.view && match.query.view === 'detail') // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'string'.
    cleanMatch.query.view = undefined;
    if (match.query && match.query.view && match.query.view === 'planning.nodetail') cleanMatch.query.view = 'planning';
    cleanMatch = {
        ...cleanMatch,
        url: ''
    };
    return cleanMatch;
};
const $fd0af9cf1691807e$export$dbd9185166d0d04c = (boardPaths, routeName, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 'browse-project-redirect':
            rapidBoardPaths = [];
            resetDone = true;
            break;
        case 'rapidboard-backlog':
        case 'rapidboard-board':
        case 'rapidboard-report':
            // use search to navigate to board
            if (rapidBoardPaths.includes('browse-project-redirect') || rapidBoardPaths.includes('useStoredSettings')) {
                resetDone = true;
                rapidBoardPaths = [];
                break;
            } else if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                break;
            } else {
                rapidBoardPaths = [];
                break;
            }
        default:
            if (rapidBoardPaths.includes('browse-project-redirect')) {
                resetDone = true;
                rapidBoardPaths = [];
            }
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $fd0af9cf1691807e$export$d5eae90e177f1bdd = (appId, state, searchDepth = 0)=>{
    if (state) {
        const { currentPage: currentPage, visitedPages: visitedPages } = state;
        const visitedPageLength = visitedPages.length;
        if (currentPage && currentPage.apps[appId]) return true;
        if (visitedPageLength === 0 || searchDepth <= 0) return false;
        for(let i = 1; i <= Math.min(searchDepth, visitedPageLength); i += 1){
            if (visitedPages[visitedPageLength - i].apps[appId]) return true;
        }
    }
    return false;
};
const $fd0af9cf1691807e$export$9f3e656a7f6a3adc = (routeToCheck)=>{
    switch(routeToCheck.name){
        case 'issue':
        case 'issue-embed':
        case 'issue-navigator':
        case 'issue-navigator-classic':
        case 'issue-navigator-core':
        case 'servicedesk-issues':
            return true;
        default:
            return false;
    }
};

});


parcelRegister("fzsaE", function(module, exports) {

$parcel$export(module.exports, "useShouldPerformAction", () => $f5900bc678cbf89c$export$1bfa74483a8ca772);

var $5uXOq = parcelRequire("5uXOq");

var $kgeYq = parcelRequire("kgeYq");

var $6H0Ar = parcelRequire("6H0Ar");
const $f5900bc678cbf89c$export$1bfa74483a8ca772 = ({ actionName: actionName })=>{
    const metas = (0, $kgeYq.useMeta)();
    const remoteActions = (0, $kgeYq.useRemoteActionsData)();
    const { saveActionPerformedAttempt: saveActionPerformedAttempt } = (0, $kgeYq.useRemoteActionsStoreActions)();
    const [actionToPerform, setActionToPerform] = (0, $5uXOq.useState)();
    const [shouldPerformAction, setShouldPerformAction] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        // Check whether or not the action (actionName) should be performed:
        // - when the remote actions available list changes
        // - when the metas for the actions change
        const matchedAction = Object.values(remoteActions).find((action)=>{
            if (action.name !== actionName) return false;
            return true;
        });
        if (!matchedAction) return;
        setActionToPerform(matchedAction);
        setShouldPerformAction((0, $6H0Ar.computeShouldPerformAction)(matchedAction, metas));
    }, [
        actionName,
        remoteActions,
        metas
    ]);
    const performAction = (onSuccess, onCancel)=>{
        if (!actionToPerform) // just in case someone calls the function and don't check if they should before
        // maybe throw an error?
        return;
        const metaForAnalytics = {
            attempts: metas[actionToPerform.id]?.attemptCounts ?? 0,
            lastAttemptedAt: metas[actionToPerform.id]?.lastPerformAttemptedAt
        };
        if (shouldPerformAction) // For now, the onSuccess will handle:
        // * create analytics event
        // * fire the event
        onSuccess(actionToPerform, metaForAnalytics);
        else // For now, the onCancel will handle:
        // * create analytics event
        // * fire the event
        onCancel(actionToPerform, metaForAnalytics);
        saveActionPerformedAttempt(actionToPerform.id);
        // We just attempted to perfom the action, reset.
        setShouldPerformAction(false);
    };
    return {
        shouldPerformAction: shouldPerformAction,
        performAction: performAction
    };
};

});
parcelRegister("kgeYq", function(module, exports) {

$parcel$export(module.exports, "RemoteActionsContainer", () => $d9ba2626345ececd$export$28c2e4c663a86266);
$parcel$export(module.exports, "useRemoteActions", () => $d9ba2626345ececd$export$333357b3de3e67a0);
$parcel$export(module.exports, "useRemoteActionsData", () => $d9ba2626345ececd$export$3cc006661ae2a759);
$parcel$export(module.exports, "useMeta", () => $d9ba2626345ececd$export$3fb9275d3845bd5a);
$parcel$export(module.exports, "useRemoteActionLastUpdatedAt", () => $d9ba2626345ececd$export$1d013261a2e6e0f9);
$parcel$export(module.exports, "useRemoteActionsStoreActions", () => $d9ba2626345ececd$export$3fd21eaf97df4718);

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
var $jOqMN = parcelRequire("jOqMN");

var $VqhDv = parcelRequire("VqhDv");
// jira freezes the global defaults object
if (!Object.isFrozen((0, $jOqMN.default))) (0, $jOqMN.default).devtools = false;
const $d9ba2626345ececd$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        meta: {},
        remoteActions: {},
        lastUpdatedAt: 0,
        isLoaded: false,
        product: undefined
    },
    actions: $VqhDv.actions,
    name: 'remoteActionsStore'
});
const $d9ba2626345ececd$export$28c2e4c663a86266 = (0, $gg7kZ.createContainer)($d9ba2626345ececd$var$Store, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch((0, $VqhDv.actions).initStore());
        }
});
const $d9ba2626345ececd$export$333357b3de3e67a0 = (selector)=>(0, $3sQ5x.createHook)($d9ba2626345ececd$var$Store, {
        selector: selector
    })();
const $d9ba2626345ececd$export$3cc006661ae2a759 = (0, $3sQ5x.createStateHook)($d9ba2626345ececd$var$Store, {
    selector: (state)=>state.remoteActions
});
const $d9ba2626345ececd$export$3fb9275d3845bd5a = (0, $3sQ5x.createStateHook)($d9ba2626345ececd$var$Store, {
    selector: (state)=>state.meta
});
const $d9ba2626345ececd$export$1d013261a2e6e0f9 = (0, $3sQ5x.createStateHook)($d9ba2626345ececd$var$Store, {
    selector: (state)=>state.lastUpdatedAt
});
const $d9ba2626345ececd$export$3fd21eaf97df4718 = (0, $3sQ5x.createActionsHook)($d9ba2626345ececd$var$Store);

});
parcelRegister("VqhDv", function(module, exports) {

$parcel$export(module.exports, "actions", () => $ac967394d4cfc187$export$e324594224ef24da);

var $aeA7h = parcelRequire("aeA7h");

var $1CZHv = parcelRequire("1CZHv");

var $dCTyG = parcelRequire("dCTyG");

var $jur4x = parcelRequire("jur4x");
const $ac967394d4cfc187$export$e324594224ef24da = {
    processRemoteActions: $dCTyG.processRemoteActions,
    saveActionPerformedAttempt: $jur4x.saveActionPerformedAttempt,
    initStore: $1CZHv.initStore,
    clearActionId: $aeA7h.clearActionId
};

});
parcelRegister("aeA7h", function(module, exports) {

$parcel$export(module.exports, "clearActionId", () => $5823715eaffccd4e$export$8d8b492eefa9efba);

var $jrIXX = parcelRequire("jrIXX");
const $5823715eaffccd4e$export$8d8b492eefa9efba = (actionId)=>({ getState: getState, setState: setState }, { product: product })=>{
        const { meta: meta } = getState();
        const newMeta = {
            ...meta
        };
        delete newMeta[actionId];
        setState({
            meta: newMeta
        });
        (0, $jrIXX.writeRemoteActionsMetasToLocalStorage)(product, meta);
    };

});
parcelRegister("jrIXX", function(module, exports) {

$parcel$export(module.exports, "readRemoteActionsMetasFromLocalStorage", () => $7155f8b15998d8a8$export$a221266a05084986);
$parcel$export(module.exports, "writeRemoteActionsMetasToLocalStorage", () => $7155f8b15998d8a8$export$7228aaade919a8b6);
const $7155f8b15998d8a8$export$b9e25d3c75cffd71 = 'atlassian-remote-actions';
const $7155f8b15998d8a8$export$a221266a05084986 = (product)=>{
    try {
        return JSON.parse(localStorage.getItem(`${$7155f8b15998d8a8$export$b9e25d3c75cffd71}.${product}`) || '{}');
    } catch (e) {
        console.warn('Could not load from localStorage', e);
        return {};
    }
};
const $7155f8b15998d8a8$export$7228aaade919a8b6 = (product, remoteActionsMetas)=>{
    try {
        localStorage.setItem(`${$7155f8b15998d8a8$export$b9e25d3c75cffd71}.${product}`, JSON.stringify(remoteActionsMetas));
    } catch (e) {
        console.warn('Could not load from localStorage', e);
    }
};

});


parcelRegister("1CZHv", function(module, exports) {

$parcel$export(module.exports, "initStore", () => $51a85c0f0c3053b6$export$41f27b3823a442c6);

var $jrIXX = parcelRequire("jrIXX");
const $51a85c0f0c3053b6$export$41f27b3823a442c6 = ()=>({ setState: setState }, { product: product })=>{
        // TODO Async read from Localstorage.
        setState({
            meta: (0, $jrIXX.readRemoteActionsMetasFromLocalStorage)(product),
            isLoaded: true,
            product: product
        });
    };

});

parcelRegister("dCTyG", function(module, exports) {

$parcel$export(module.exports, "processRemoteActions", () => $404f5a5eff20fc81$export$15e69d1dd38ccaa3);

var $duDuW = parcelRequire("duDuW");
const $404f5a5eff20fc81$export$15e69d1dd38ccaa3 = (productData, remoteActionsResponse)=>({ getState: getState, setState: setState })=>{
        const { lastUpdatedAt: lastUpdatedAt, meta: meta } = getState();
        if (remoteActionsResponse.lastUpdatedAt <= lastUpdatedAt) // data has not been updated, nothing to do
        return;
        const remoteActions = remoteActionsResponse.remoteActions.reduce((updatedRemoteActions, remoteAction)=>{
            if ((0, $duDuW.shouldProcessRemoteAction)(remoteAction)) {
                const shouldAddAction = remoteAction.conditions.every((condition)=>(0, $duDuW.isActionConditionSatisfied)(productData, condition));
                if (shouldAddAction) updatedRemoteActions[remoteAction.id] = remoteAction;
            }
            // no updates
            return updatedRemoteActions;
        }, {});
        setState({
            // only keep the meta for the remote actions that are still present. This is to avoid
            // keeping stale meta which would otherwise grow indefinitely.
            meta: Object.keys(remoteActions).reduce((newMeta, id)=>{
                newMeta[id] = meta[id];
                return newMeta;
            }, {}),
            remoteActions: remoteActions,
            lastUpdatedAt: remoteActionsResponse.lastUpdatedAt
        });
    };

});
parcelRegister("duDuW", function(module, exports) {

$parcel$export(module.exports, "isActionConditionSatisfied", () => $526f5f16a4923d8e$export$9262d8191a70c677);
$parcel$export(module.exports, "shouldProcessRemoteAction", () => $526f5f16a4923d8e$export$c7cc93192d09a3d7);

var $19Qz4 = parcelRequire("19Qz4");
const $526f5f16a4923d8e$var$isFeatureFlagConditionSatisfied = (getFeatureFlagValue, condition)=>condition.affectedFeatureFlagValue === getFeatureFlagValue(condition.featureFlagKey);
const $526f5f16a4923d8e$var$isFeatureGateConditionSatisfied = (getFeatureGateValue, condition)=>getFeatureGateValue && condition.affectedFeatureGateValue === getFeatureGateValue(condition.featureGateKey);
const $526f5f16a4923d8e$var$isBuildInAffectedRangeV2 = (getBuildKey, getBuildInfoFromKey, condition)=>{
    try {
        const { buildNumber: currentBuildNumber, buildType: currentBuildType } = getBuildInfoFromKey(getBuildKey());
        const { buildNumber: firstAffectedBuildNumber, buildType: firstAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[0]);
        const { buildNumber: lastAffectedBuildNumber, buildType: lastAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[1]);
        if (firstAffectedBuildType !== currentBuildType || lastAffectedBuildType !== currentBuildType) return false;
        if (firstAffectedBuildNumber <= currentBuildNumber && currentBuildNumber <= lastAffectedBuildNumber) return true;
    } catch (error) {
        console.warn('error while parsing a build key', error);
    }
    return false;
};
const $526f5f16a4923d8e$export$9262d8191a70c677 = (productData, condition)=>{
    switch(condition.type){
        case (0, $19Qz4.ConditionType).buildRange:
            return $526f5f16a4923d8e$var$isBuildInAffectedRangeV2(productData.getBuildKey, productData.getBuildInfoFromKey, condition);
        case (0, $19Qz4.ConditionType).featureFlag:
            return $526f5f16a4923d8e$var$isFeatureFlagConditionSatisfied(productData.getFeatureFlagValue, condition);
        case (0, $19Qz4.ConditionType).featureGate:
            return $526f5f16a4923d8e$var$isFeatureGateConditionSatisfied(productData.getFeatureGateValue, condition);
        default:
            return false;
    }
};
const $526f5f16a4923d8e$export$c7cc93192d09a3d7 = (remoteAction)=>remoteAction.enabled;

});
parcelRegister("19Qz4", function(module, exports) {

$parcel$export(module.exports, "ConditionType", () => $d5b16b4ef489b315$export$748d1c753cdf4bfd);
var $d5b16b4ef489b315$export$748d1c753cdf4bfd = /*#__PURE__*/ function(ConditionType) {
    ConditionType["featureFlag"] = "featureFlag";
    ConditionType["featureGate"] = "featureGate";
    ConditionType["buildRange"] = "buildRange";
    return ConditionType;
}({});

});



parcelRegister("jur4x", function(module, exports) {

$parcel$export(module.exports, "saveActionPerformedAttempt", () => $4f1265fdad10128e$export$e3144a2e886e0e77);

var $jrIXX = parcelRequire("jrIXX");
const $4f1265fdad10128e$export$e3144a2e886e0e77 = (actionId)=>({ getState: getState, setState: setState })=>{
        const { meta: meta, product: product } = getState();
        const currentAttemptCount = meta[actionId]?.attemptCounts || 0;
        const updatedMetas = {
            ...meta,
            [actionId]: {
                lastPerformAttemptedAt: Date.now(),
                attemptCounts: currentAttemptCount + 1
            }
        };
        setState({
            meta: updatedMetas
        });
        // Can not happen.
        if (!product) throw new Error('Product is not defined.');
        (0, $jrIXX.writeRemoteActionsMetasToLocalStorage)(product, updatedMetas);
    };

});



parcelRegister("6H0Ar", function(module, exports) {

$parcel$export(module.exports, "computeShouldPerformAction", () => $2f4e836fc7143570$export$6e0db227c9674096);

const $2f4e836fc7143570$export$50dbcb44bba3aa5c = 60;
const $2f4e836fc7143570$export$b21f5a6e7051e2c2 = (actionMetas)=>{
    const now = Date.now();
    const timeDiff = now - actionMetas.lastPerformAttemptedAt;
    return timeDiff > $2f4e836fc7143570$export$50dbcb44bba3aa5c * 1000;
};
const $2f4e836fc7143570$export$6c7cf2cb7d75fad3 = (actionMetas)=>actionMetas.attemptCounts < (0, $61c64791091cf7a7$export$f2c0b74311ada874);
const $2f4e836fc7143570$export$6e0db227c9674096 = (action, metas)=>{
    const actionMetas = metas[action.id];
    if (!actionMetas) // No meta, we have not attempted to perform this action yet.
    return true;
    if (!$2f4e836fc7143570$export$6c7cf2cb7d75fad3(actionMetas)) // TODO: send a "cancelled analytics event ?"
    return false;
    if (!$2f4e836fc7143570$export$b21f5a6e7051e2c2(actionMetas)) return false;
    // All the conditions are satisfied, we can perform the action.
    return true;
};

});
const $61c64791091cf7a7$export$f2b2f5ef0b498d26 = 5000;
const $61c64791091cf7a7$export$f2c0b74311ada874 = 3;
const $61c64791091cf7a7$export$af2ff676951003fe = 60000;
const $61c64791091cf7a7$export$388bd7a7ebb11e7 = 'atlassian-remote-actions-v1';



parcelRegister("l9F59", function(module, exports) {

$parcel$export(module.exports, "default", () => $c27c60eec62bb2f2$export$2e2bcd8739ae039);

var $ajpes = parcelRequire("ajpes");
/**
 * Determines the feasibility of transitioning between routes in a SPA, considering initial loads,
 * user agent constraints, and predefined route conditions. Ensures seamless navigation by
 * evaluating route matches and permissions.
 */ const $c27c60eec62bb2f2$var$transitionValidator = (currentMatch, nextMatch)=>{
    // if we load SPA on a redirect route, we transition immediately skipping the checks
    if (!currentMatch) return true;
    // if next route missing (should not happen as we have a catch all route) or mobile, trigger reload
    if (!nextMatch) return false;
    // If we are still on same route and same match params, skip transition checks
    const isSameRoute = currentMatch.route === nextMatch.route;
    const isSameMatch = (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(currentMatch.match, nextMatch.match);
    if (isSameRoute && isSameMatch) return true;
    // check we can transition into next route
    // @ts-expect-error - TS2339 - Property 'canTransitionIn' does not exist on type 'Route'.
    const canDoNext = nextMatch.route.canTransitionIn?.(currentMatch, nextMatch) ?? true;
    if (canDoNext) return true;
    return false;
};
var $c27c60eec62bb2f2$export$2e2bcd8739ae039 = $c27c60eec62bb2f2$var$transitionValidator;

});

parcelRegister("i6dHx", function(module, exports) {

$parcel$export(module.exports, "ConcurrentRootComponent", () => $1fd1d5f168f244bb$export$3224d596e9b1971);

var $5uXOq = parcelRequire("5uXOq");

var $kUr4d = parcelRequire("kUr4d");

var $jsLXn = parcelRequire("jsLXn");

var $4R6GH = parcelRequire("4R6GH");

var $lODMY = parcelRequire("lODMY");

var $29g8C = parcelRequire("29g8C");
const $1fd1d5f168f244bb$var$useRouterLocation = (0, $lODMY.createRouterSelector)((state)=>state.location);
const $1fd1d5f168f244bb$var$useRouterAction = (0, $lODMY.createRouterSelector)((state)=>state.action);
const $1fd1d5f168f244bb$var$useRouterQuery = (0, $lODMY.createRouterSelector)((state)=>state.query);
const $1fd1d5f168f244bb$var$useRouterRoute = (0, $lODMY.createRouterSelector)((state)=>state.route);
const $1fd1d5f168f244bb$var$useRouterMatch = (0, $lODMY.createRouterSelector)((state)=>state.match);
const $1fd1d5f168f244bb$var$RouteComponentWithRouterProps = ()=>{
    const location = $1fd1d5f168f244bb$var$useRouterLocation();
    const action = $1fd1d5f168f244bb$var$useRouterAction();
    const query = $1fd1d5f168f244bb$var$useRouterQuery();
    const route = $1fd1d5f168f244bb$var$useRouterRoute();
    const match = $1fd1d5f168f244bb$var$useRouterMatch();
    const { component: RouteComponent } = route;
    return RouteComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(RouteComponent, {
        location: location,
        route: route,
        match: match,
        action: action,
        query: query
    });
};
function $1fd1d5f168f244bb$export$3224d596e9b1971() {
    const containerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (!containerRef.current) // this is actually "impossible"
        throw new Error('ref is not set');
        const root = (0, $kUr4d.createRoot)(containerRef.current);
        root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jsLXn.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1fd1d5f168f244bb$var$RouteComponentWithRouterProps, null), (0, $4R6GH.fg)('concurrent-rendering-change-advisory') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29g8C.ConcurrentAdvisory), null) : null));
        return ()=>{
            // We need the setTimeout to avoid this error:
            // `Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.`
            setTimeout(()=>{
                root.unmount();
            });
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: "concurrent-route-component",
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            display: 'contents'
        },
        ref: containerRef
    });
}

});
parcelRegister("jsLXn", function(module, exports) {

$parcel$export(module.exports, "JiraContextContainer", () => $88b19a22a09480ac$export$6f7845cc5e693f16);

var $5uXOq = parcelRequire("5uXOq");

var $irJ4w = parcelRequire("irJ4w");

var $lzeFL = parcelRequire("lzeFL");

var $5tsrJ = parcelRequire("5tsrJ");

var $1OjhZ = parcelRequire("1OjhZ");

var $j8DrX = parcelRequire("j8DrX");

var $1nUas = parcelRequire("1nUas");

var $2HbP2 = parcelRequire("2HbP2");

var $8ApFP = parcelRequire("8ApFP");

var $iXVV6 = parcelRequire("iXVV6");

var $fiv1r = parcelRequire("fiv1r");

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");

var $a83ud = parcelRequire("a83ud");
const $88b19a22a09480ac$var$ContextualAnalyticsDataFeatureFlagged = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: (0, $8ApFP.routeAnalyticsAttributes)
    }, children);

const $88b19a22a09480ac$export$6f7845cc5e693f16 = (props)=>{
    const state = {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        messages: (parcelRequire("hWnRN"))
    };
    const { data: orgId } = (0, $14XJw.useOrgId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88b19a22a09480ac$var$ContextualAnalyticsDataFeatureFlagged, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $j8DrX.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1nUas.IntlProvider), {
            messages: state.messages,
            locale: (0, $lzeFL.standardizeLocale)(tenantContext.locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irJ4w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5tsrJ.default), {
            orgId: orgId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1OjhZ.ExperienceTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fiv1r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2HbP2.ModalContextProvider), null, props.children)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a83ud.LoadingPhaseManager), null));
};

});
parcelRegister("a83ud", function(module, exports) {

$parcel$export(module.exports, "LoadingPhaseManager", () => $852e6ed10ffe3afe$export$6e4bfef9e80c7eb0);

var $5uXOq = parcelRequire("5uXOq");

var $8vgoa = parcelRequire("8vgoa");
const $852e6ed10ffe3afe$export$6e4bfef9e80c7eb0 = ()=>{
    const { startNextPhase: startNextPhase } = (0, $8vgoa.useLazyPhase)();
    (0, $5uXOq.useEffect)(()=>{
        /**
     * Only start next phase if we are not in the SPA, because there is a second
     * LoadingPhaseManager specifically for the SPA, and we want it to transition at the correct time.
     * If we start this here inside the SPA, we will start RLL next phase and get lazyAfterPaint
     * bundles too early.
     */ if (__SPA__) return;
        /* Outside the SPA, we don't currently have a good proxy for page loads.
     * So for now we start the "after paint" phase a few seconds after mounting.
     */ setTimeout(()=>{
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        }, 2000);
    }, [
        startNextPhase
    ]);
    return null;
};

});

parcelRegister("hWnRN", function(module, exports) {
module.exports = __LANG;

});


parcelRegister("29g8C", function(module, exports) {

$parcel$export(module.exports, "ConcurrentAdvisory", () => $3f6cbe094065dc4a$export$e7a8408a6ddec2cb);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable jira/react/no-style-attribute */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $5uXOq = parcelRequire("5uXOq");
function $3f6cbe094065dc4a$export$e7a8408a6ddec2cb(props) {
    const { consoleMessage: consoleMessage = 'This route is being rendered with React concurrent rendering go/r18' } = props;
    const [isAdvisoryVisible, setIsAdvisoryVisible] = (0, $5uXOq.useState)(true);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line no-console
        console.log(`%c\u{203C}\u{FE0F} ${consoleMessage} \u{203C}\u{FE0F}
If you encounter any problems, report them to https://atlassian.enterprise.slack.com/archives/C06176WU6PQ`, 'color: white; background: darkred; font-size: 16px; padding: 4px');
        const timer = setTimeout(()=>{
            setIsAdvisoryVisible(false);
        }, 5000);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        consoleMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: {
            position: 'absolute',
            left: 8,
            top: 12,
            display: 'flex',
            alignItems: 'center',
            // By giving this element a height of 0 and no pointer events, we ensure that it doesn't interfere with the page.
            // To make is visible again, we then set the overflow to "visible".
            height: 0,
            overflow: 'visible',
            pointerEvents: 'none',
            zIndex: 99999999
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: {
            backgroundColor: isAdvisoryVisible ? 'white' : 'red',
            borderRadius: '50%',
            width: 8,
            height: 8,
            zIndex: 20
        }
    }), isAdvisoryVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: {
            backgroundColor: 'red',
            color: 'white',
            height: '1.5em',
            marginLeft: -12,
            paddingLeft: 16,
            paddingRight: 8,
            borderRadius: 4,
            zIndex: 10
        }
    }, "Rendered in React concurrent mode go/r18"));
}

});


parcelRegister("Smjim", function(module, exports) {

$parcel$export(module.exports, "RouteEntryPointContainer", () => $813341ccf863a0ac$export$3e4cdfb894377bc9);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dJl1T = parcelRequire("dJl1T");


var $2Ioew = parcelRequire("2Ioew");

var $frBVt = parcelRequire("frBVt");

var $7LpuY = parcelRequire("7LpuY");

var $dZw8H = parcelRequire("dZw8H");
const $813341ccf863a0ac$var$LOCATION = 'route-entry-point-container';
const $813341ccf863a0ac$export$fb85bbdbfb3e6869 = ()=>null;
const $813341ccf863a0ac$export$3e4cdfb894377bc9 = ({ location: location, route: route, match: match, action: action, query: query })=>{
    const entryPointReference = (0, $2Ioew.usePageLayoutEntryPoint)((0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48));
    // in order to show a spinner while page loading -> `route.skeleton=Spinner`
    const Skeleton = route.skeleton || $813341ccf863a0ac$export$fb85bbdbfb3e6869;
    (0, $5uXOq.useEffect)(()=>{
        if (route.isRedirect) (0, $dJl1T.default).safeWarnWithoutCustomerData($813341ccf863a0ac$var$LOCATION, `EntryPoint was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    if (!entryPointReference) return null;
    let pageId = route.name;
    if (route.pageId) {
        if (typeof route.pageId === 'function') pageId = route.pageId({
            route: route,
            action: action,
            location: location,
            match: match,
            query: query
        });
        else pageId = route.pageId;
    }
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointReferencePlaceholder), {
        entryPointReference: entryPointReference,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null),
        name: "route_entry_point_redirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: {}
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7LpuY.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointReferencePlaceholder), {
        entryPointReference: entryPointReference,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null),
        name: "route_entry_point"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: entryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    }))));
};

});



parcelRegister("h0PjI", function(module, exports) {

$parcel$export(module.exports, "LayoutMainWrapper", () => $571ff4fe4ca2a221$export$712225703044cda);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $571ff4fe4ca2a221$export$712225703044cda = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1bgi _iu1g1fl4 _2d3f16n6",
            __cmplp.className
        ])
    });
});

});



parcelRegister("9F6Ii", function(module, exports) {

$parcel$export(module.exports, "StrictMode", () => $02febe252cc7980c$export$5f8d39834fd61797);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
const $02febe252cc7980c$export$5f8d39834fd61797 = ({ children: children })=>{
    // allow developers to disable strict mode for local development
    const isStrictModeDisabled = !(0, $4R6GH.fg)('jira-enable-strict-mode');
    if (isStrictModeDisabled) return children;
    // React.StrictMode usage is enabled by default
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).StrictMode, null, children);
};

});

parcelRegister("81ezV", function(module, exports) {

$parcel$export(module.exports, "JiraRouterLinkConfiguration", () => $33ea5bfeb747665b$export$a580704a2f3cfca);

var $5uXOq = parcelRequire("5uXOq");

var $hjSul = parcelRequire("hjSul");
const $33ea5bfeb747665b$export$a580704a2f3cfca = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
    if (// Links can be initially rendered with `href` not defined in some cases
    !href || typeof href === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
        ref: ref,
        href: href || '#',
        ...rest
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
        ref: ref,
        href: href.href,
        to: href.to,
        replace: href.replace,
        params: href.params,
        query: href.query,
        prefetch: href.prefetch,
        ...rest
    }, children);
});

});

parcelRegister("b7awD", function(module, exports) {

$parcel$export(module.exports, "Router", () => $87aa2fd82c8be71a$export$55185c17a0fcbe46);

var $5uXOq = parcelRequire("5uXOq");

var $15Xx4 = parcelRequire("15Xx4");

var $d8orV = parcelRequire("d8orV");
const $87aa2fd82c8be71a$export$55185c17a0fcbe46 = ({ children: children, ...props })=>{
    const pluginsWithOverride = (0, $d8orV.usePlugins)({
        resourceContext: props.resourceContext,
        resourceData: props.resourceData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $15Xx4.Router), {
        plugins: pluginsWithOverride,
        ...props
    }, children);
};

});
parcelRegister("d8orV", function(module, exports) {

$parcel$export(module.exports, "usePlugins", () => $0614c9d3afc2dd7f$export$c41e96fd89bc6106);

var $5uXOq = parcelRequire("5uXOq");

var $a2g00 = parcelRequire("a2g00");

var $5yJb9 = parcelRequire("5yJb9");

var $9OXo1 = parcelRequire("9OXo1");

var $8Y8sk = parcelRequire("8Y8sk");
const $0614c9d3afc2dd7f$export$c41e96fd89bc6106 = ({ resourceContext: resourceContext, resourceData: resourceData })=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    // make sure "plugins" are created only once, ignore prop change/rerender
    const [pluginsWithOverride] = (0, $5uXOq.useState)(()=>{
        const jiraPlugins = [];
        const resourcesPlugin = (0, $8Y8sk.createResourcesPlugin)({
            context: resourceContext,
            resourceData: resourceData
        });
        jiraPlugins.push(resourcesPlugin);
        jiraPlugins.push((0, $a2g00.createEntryPointsPlugin)({
            environment: (0, $5yJb9.default)(),
            entryPointParams: {
                tenantContext: tenantContext
            }
        }));
        return jiraPlugins;
    });
    return pluginsWithOverride;
};

});
parcelRegister("a2g00", function(module, exports) {

$parcel$export(module.exports, "createEntryPointsPlugin", () => $e3cbf02360bc6f96$export$33586718f82f356f);

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $3gC8D = parcelRequire("3gC8D");

var $3I4nj = parcelRequire("3I4nj");

var $ktB2C = parcelRequire("ktB2C");

var $9dbn9 = parcelRequire("9dbn9");

var $gH2st = parcelRequire("gH2st");
const $e3cbf02360bc6f96$export$33586718f82f356f = ({ environment: environment, entryPointParams: entryPointParams })=>({
        id: 'entry-points-plugin',
        routeLoad: ({ context: context })=>{
            const entryPoint = context.route.entryPoint?.();
            const prefetchingRoute = (0, $3I4nj.getPrefetchingRoute)();
            let entryPointReference = null;
            if (entryPoint) {
                // check if route EntryPoint is already prefethed right before being loaded
                if (prefetchingRoute && (0, $3gC8D.isSameRouteMatch)({
                    prevContextMatch: prefetchingRoute.routerContext.match,
                    nextContextMatch: context.match
                }) && !(0, $3gC8D.isExpired)(prefetchingRoute.expiresAt)) entryPointReference = prefetchingRoute.entryPointReference;
                else {
                    const entryPointParamsWithContext = {
                        context: context,
                        ...entryPointParams
                    };
                    const loadEntryPointsWithContext = ()=>(0, $8Uumt.loadEntryPoint)({
                            getEnvironment: ()=>environment
                        }, entryPoint, entryPointParamsWithContext);
                    entryPointReference = false && (0, $4R6GH.fg)('jira-ssr-prevent-prewarming-entrypoint-in-prefetch') ? (0, $gH2st.default)(entryPoint, entryPointParamsWithContext, loadEntryPointsWithContext) : loadEntryPointsWithContext();
                }
            }
            // saving entryPointReference helps to prevent cases when same EntryPoint is fetched multiple times
            // important when fetchPolicy=network-only is used
            (0, $3I4nj.getEntryPointsStore)().actions.setLastLoadedRoute({
                route: context.route,
                entryPointReference: entryPointReference
            });
            return {
                entryPoint: entryPointReference
            };
        },
        routePrefetch: ({ nextContext: nextContext })=>{
            const entryPoint = nextContext.route.entryPoint?.();
            if (entryPoint) {
                const prevPrefetchingRoute = (0, $3I4nj.getPrefetchingRoute)();
                // check if EntryPoint is already prefetched and not expired
                if (prevPrefetchingRoute && (0, $3gC8D.isSameRouteMatch)({
                    prevContextMatch: prevPrefetchingRoute.routerContext.match,
                    nextContextMatch: nextContext.match
                }) && !(0, $3gC8D.isExpired)(prevPrefetchingRoute.expiresAt)) return;
                const entryPointReference = (0, $8Uumt.loadEntryPoint)({
                    getEnvironment: ()=>environment
                }, entryPoint, {
                    context: nextContext,
                    ...entryPointParams
                });
                (0, $3I4nj.getEntryPointsStore)().actions.setPrefetchingRoute({
                    routerContext: nextContext,
                    expiresAt: (0, $3gC8D.getExpiresAt)(),
                    entryPointReference: entryPointReference
                });
            } else (0, $3I4nj.getEntryPointsStore)().actions.setPrefetchingRoute({
                routerContext: nextContext,
                expiresAt: 0,
                entryPointReference: null
            });
        },
        waitForEntryPoint: ()=>{
            const lastLoadedRoute = (0, $3I4nj.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $ktB2C.waitForEntryPoint)(entryPointReference);
            return Promise.resolve();
        },
        getStats: async ()=>{
            const lastLoadedRoute = (0, $3I4nj.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $9dbn9.getEntryPointStats)(entryPointReference);
            return [];
        }
    });

});
parcelRegister("3gC8D", function(module, exports) {

$parcel$export(module.exports, "getExpiresAt", () => $f48ce76f20803aec$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "isExpired", () => $f48ce76f20803aec$export$57947cfd429801a2);
$parcel$export(module.exports, "isSameRouteMatch", () => $f48ce76f20803aec$export$5997e70fc4543270);
const $f48ce76f20803aec$export$37d3126be6549b13 = 10000;
const $f48ce76f20803aec$export$b65d7ba7fbf150f1 = ()=>$f48ce76f20803aec$export$37d3126be6549b13 + Date.now();
const $f48ce76f20803aec$export$57947cfd429801a2 = (expiresAt)=>expiresAt < Date.now();
const $f48ce76f20803aec$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $f48ce76f20803aec$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $f48ce76f20803aec$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $f48ce76f20803aec$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});

parcelRegister("ktB2C", function(module, exports) {

$parcel$export(module.exports, "waitForEntryPoint", () => $67d2b262678828c6$export$944f853f194e5dd5);

var $kipqU = parcelRequire("kipqU");
const $67d2b262678828c6$export$944f853f194e5dd5 = (entryPointConfig)=>{
    const promises = [];
    try {
        entryPointConfig.getComponent();
    } catch (err) {
        if (err instanceof Promise) promises.push(err);
        else throw err;
    }
    const { queries: queries, entryPoints: entryPoints } = entryPointConfig;
    if (queries) Object.keys(queries).forEach((key)=>{
        if (queries[key].id) {
            const queryPromise = (0, $kipqU.QueryPromisesMap).get(String(queries[key].id));
            if (queryPromise) promises.push(queryPromise);
        }
    });
    if (entryPoints) Object.keys(entryPoints).forEach((key)=>{
        const nestedEntryPointPromise = $67d2b262678828c6$export$944f853f194e5dd5(entryPoints[key]);
        promises.push(nestedEntryPointPromise);
    });
    return Promise.allSettled(promises);
};

});

parcelRegister("9dbn9", function(module, exports) {

$parcel$export(module.exports, "getEntryPointStats", () => $61c2db9f130d2efd$export$ee016802bdebb378);

var $kipqU = parcelRequire("kipqU");
const $61c2db9f130d2efd$export$14ba46fa7bd4c0a9 = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
const $61c2db9f130d2efd$export$982a0a12103fb99f = async (promise)=>{
    if (!promise) return 'resolved';
    try {
        if (await Promise.race([
            promise,
            Promise.resolve('timeout')
        ]) === 'timeout') return 'pending';
        return 'resolved';
    } catch (e) {
        return 'rejected';
    }
};
const $61c2db9f130d2efd$var$getEntrypointQueryState = async (queryId)=>{
    const queryPromise = (0, $kipqU.QueryPromisesMap).get(queryId);
    return {
        queryId: queryId,
        status: await $61c2db9f130d2efd$export$982a0a12103fb99f(queryPromise)
    };
};
const $61c2db9f130d2efd$export$ee016802bdebb378 = (entryPointConfig)=>{
    const result = [];
    const analyseEntrypoint = ({ queries: queries, entryPoints: entryPoints })=>{
        if (queries) Object.keys(queries).forEach((key)=>{
            if (queries[key].id) result.push($61c2db9f130d2efd$var$getEntrypointQueryState(String(queries[key].id)));
        });
        if (entryPoints) Object.entries(entryPoints).forEach(([, entryPoint])=>{
            analyseEntrypoint(entryPoint);
        });
    };
    analyseEntrypoint(entryPointConfig);
    return Promise.all(result);
};

});

parcelRegister("gH2st", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d282350af6c97c4$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $cfawy = parcelRequire("cfawy");

var $6jQmc = parcelRequire("6jQmc");

var $klZ80 = parcelRequire("klZ80");

const $7d282350af6c97c4$var$DummyAsyncModule = (0, $cfawy.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("klZ80"))), {
    moduleId: "7d80bb6f",
    moduleName: "ReactFragment"
} // using a real async import to make the js-resource transformers/babel-plugins happy
);
$7d282350af6c97c4$var$DummyAsyncModule.getModuleIfRequired = ()=>(0, $klZ80.default); // prevent attempts to fetch the module async at all

/**
 * Run a given loadEntryPoint function without loading the entrypoint modules, then load them right afterwards.
 *
 * This is to prevent triggering the loading of entrypoints modules inline with the data fetching.
 * When JS modules are inline-required (such as in SSR when async modules are converted to inline-requires)
 * this leads to inline-evaluating all dependencies for large component modules before kicking off the data for them.
 * This causes a measurable performance hit (~20-80ms in many cases) before we even kick off critical data fetches.
 *
 * Deferring the module loading until after the data fetching allows the module execution to occur in the less critical
 * idle time while waiting for data fetches to return.
 */ function $7d282350af6c97c4$var$loadEntryPointDataThenModules(entryPoint, entryPointParams, loadEntryPointCallback) {
    const originalModulesByEntrypointRef = new Map();
    (0, $6jQmc.default)(entryPoint, entryPointParams, (loopingEntryPoint)=>{
        originalModulesByEntrypointRef.set(loopingEntryPoint, loopingEntryPoint.root);
        // eslint-disable-next-line no-param-reassign
        loopingEntryPoint.root = $7d282350af6c97c4$var$DummyAsyncModule;
    });
    try {
        return loadEntryPointCallback();
    } finally{
        (0, $6jQmc.default)(entryPoint, entryPointParams, (loopingEntryPoint)=>{
            const originalModule = originalModulesByEntrypointRef.get(loopingEntryPoint);
            if (!originalModule) throw new Error('Original module not found for entrypoint');
            // eslint-disable-next-line no-param-reassign
            loopingEntryPoint.root = originalModule;
        });
        // Kicks off the loading of the original modules as they would have, but after the data fetches have been started
        // Without this, entrypoints may have trouble rendering
        // Wrap it in a promise to prevent it from affecting timers that start synchronously after this function
        Promise.resolve().then(function() {
            return Promise.resolve((parcelRequire("klZ80")));
        }).then((res)=>originalModulesByEntrypointRef.forEach((entryPointModule)=>{
                const jsModule = entryPointModule.getModuleIfRequired();
                if (jsModule != null) return;
                entryPointModule.load();
            }));
    }
}
var $7d282350af6c97c4$export$2e2bcd8739ae039 = $7d282350af6c97c4$var$loadEntryPointDataThenModules;

});
parcelRegister("6jQmc", function(module, exports) {

$parcel$export(module.exports, "default", () => $692ea781fc4c525f$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Recursively run through all nested entrypoints with a given callback
 */ function $692ea781fc4c525f$var$forAllEntryPoints(entryPoint, entryPointParams, callback) {
    callback(entryPoint);
    const preloadProps = entryPoint.getPreloadProps(entryPointParams);
    const entryPoints = preloadProps.entryPoints;
    if (!entryPoints) return;
    Object.values(entryPoints).forEach(({ entryPoint: nestedEntryPoint, entryPointParams: nestedParams })=>{
        if (nestedEntryPoint) $692ea781fc4c525f$var$forAllEntryPoints(nestedEntryPoint, nestedParams, callback);
    });
}
var $692ea781fc4c525f$export$2e2bcd8739ae039 = $692ea781fc4c525f$var$forAllEntryPoints;

});

parcelRegister("klZ80", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $73d7313e0b755887$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $73d7313e0b755887$var$ReactFragment = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
var $73d7313e0b755887$export$2e2bcd8739ae039 = $73d7313e0b755887$var$ReactFragment;

});



parcelRegister("8Y8sk", function(module, exports) {

$parcel$export(module.exports, "createResourcesPlugin", () => $d3b2f44f58ee61bb$export$23ed892c481a96fe);

var $8fYaK = parcelRequire("8fYaK");

var $4CEu1 = parcelRequire("4CEu1");
const $d3b2f44f58ee61bb$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $d3b2f44f58ee61bb$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $8fYaK.getResourceStore)().actions;
    const nextResources = (0, $4CEu1.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $d3b2f44f58ee61bb$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $8fYaK.getResourceStore)().actions;
    const nextResources = (0, $4CEu1.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $d3b2f44f58ee61bb$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $8fYaK.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $d3b2f44f58ee61bb$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $d3b2f44f58ee61bb$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $d3b2f44f58ee61bb$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $8fYaK.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $8fYaK.getResourceStore)().actions;
            const nextResources = (0, $4CEu1.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $8fYaK.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("4CEu1", function(module, exports) {

$parcel$export(module.exports, "getResourcesForNextLocation", () => $448a0fea894dd469$export$7cbbc763e2f3d65d);

var $9KbzN = parcelRequire("9KbzN");

var $dj41J = parcelRequire("dj41J");
const $448a0fea894dd469$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $dj41J.routeHasResources)(nextRoute)) return [];
    if ((0, $dj41J.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $9KbzN.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $9KbzN.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("9KbzN", function(module, exports) {

$parcel$export(module.exports, "getResourceIdentifier", () => $82cfa1d66d41fab5$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $82cfa1d66d41fab5$export$cd7fbe7e979df558);
const $82cfa1d66d41fab5$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $82cfa1d66d41fab5$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$82cfa1d66d41fab5$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("dj41J", function(module, exports) {

$parcel$export(module.exports, "routeHasResources", () => $9c8422e0259b24f6$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $9c8422e0259b24f6$export$221027ff1aa38f82);
const $9c8422e0259b24f6$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $9c8422e0259b24f6$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});





parcelRegister("d1K1f", function(module, exports) {

$parcel$export(module.exports, "default", () => $fffa056866f763fb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $6vAaw = parcelRequire("6vAaw");

var $gccSB = parcelRequire("gccSB");

var $6YRTH = parcelRequire("6YRTH");

var $j8DrX = parcelRequire("j8DrX");

var $1bQGJ = parcelRequire("1bQGJ");

var $TtQEC = parcelRequire("TtQEC");

var $7IBED = parcelRequire("7IBED");

var $5Jsi2 = parcelRequire("5Jsi2");
const $fffa056866f763fb$var$sessionQueryParams = [
    'searchSessionId',
    'searchObjectId',
    'searchContainerId',
    'searchContentType'
];
const $fffa056866f763fb$var$sessionMeta = [
    'ajs-search-session-id',
    'ajs-search-object-id',
    'ajs-search-container-id',
    'ajs-search-content-type'
];
const $fffa056866f763fb$var$removeDwellComponent = (placeholderId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const element = document.getElementById(placeholderId);
    if (placeholderId && element) (0, $7nsd3.unmountComponentAtNode)(element);
};
const $fffa056866f763fb$var$removeSessionMeta = ()=>$fffa056866f763fb$var$sessionMeta.forEach((0, $7IBED.removeMetaTag));
// @ts-expect-error - TS7031 - Binding element 'sessionId' implicitly has an 'any' type. | TS7031 - Binding element 'objectId' implicitly has an 'any' type. | TS7031 - Binding element 'containerId' implicitly has an 'any' type. | TS7031 - Binding element 'objectType' implicitly has an 'any' type.
const $fffa056866f763fb$var$addSessionMeta = ({ sessionId: sessionId, objectId: objectId, containerId: containerId, objectType: objectType })=>{
    const newMeta = {
        'ajs-search-session-id': sessionId,
        'ajs-search-object-id': objectId,
        'ajs-search-container-id': containerId,
        'ajs-search-content-type': objectType
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(newMeta).forEach(([name, content])=>(0, $7IBED.addMetaTag)(name, content));
};
const $fffa056866f763fb$var$getPreviousSessionId = ()=>(0, $j8DrX.default)('ajs-search-session-id');
class $fffa056866f763fb$export$f1e582dddb502dd6 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props), this.onClearSessionEvent = ()=>{
            if (this.state.shouldRemoveSessionBeIgnored) this.setState({
                shouldRemoveSessionBeIgnored: false
            });
        }, this.onHistoryChange = (location)=>{
            $fffa056866f763fb$var$removeDwellComponent('search-dwell-time');
            const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($6vAaw))).parse(location.pathname + location.search, true);
            const queryString = parsedUrl.query || {};
            const { searchSessionId: searchSessionId, searchObjectId: searchObjectId, searchContainerId: searchContainerId, searchContentType: searchContentType } = queryString;
            const { path: path } = parsedUrl;
            const previousSessionId = $fffa056866f763fb$var$getPreviousSessionId();
            const { shouldRemoveSessionBeIgnored: shouldRemoveSessionBeIgnored } = this.state;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(previousSessionId) && !shouldRemoveSessionBeIgnored) $fffa056866f763fb$var$removeSessionMeta();
            if (searchSessionId) {
                (0, $6YRTH.default)($fffa056866f763fb$var$sessionQueryParams);
                const newState = {
                    sessionId: searchSessionId,
                    objectId: searchObjectId,
                    objectType: searchContentType,
                    containerId: searchContainerId,
                    previousSessionId: $fffa056866f763fb$var$getPreviousSessionId()
                };
                $fffa056866f763fb$var$addSessionMeta(newState);
                const shouldRemoveSession = !!(0, $5Jsi2.skipClearSessionURLs).find((skipUrlRegex)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(path) ? skipUrlRegex.test(path) : false);
                // @ts-expect-error - TS2345 - Argument of type '{ shouldRemoveSessionBeIgnored: boolean; sessionId: string | string[]; objectId: string | string[] | undefined; objectType: string | string[] | undefined; containerId: string | string[] | undefined; previousSessionId: string | null; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "containerId" | "objectType" | "objectId" | "sessionId" | "previousSessionId" | "shouldRemoveSessionBeIgnored"> | null) | Pick<...> | null'.
                this.setState({
                    ...newState,
                    shouldRemoveSessionBeIgnored: shouldRemoveSession
                });
            }
        };
        this.props.history.listen(this.onHistoryChange);
        this.state = {
            shouldRemoveSessionBeIgnored: false,
            sessionId: ''
        };
    }
    componentDidMount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener((0, $5Jsi2.CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener((0, $5Jsi2.CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
    }
    render() {
        if (this.state && this.state.sessionId) {
            const { objectId: objectId, containerId: containerId, objectType: objectType, sessionId: sessionId, previousSessionId: previousSessionId } = this.state;
            const data = {
                objectId: objectId,
                containerId: containerId,
                objectType: objectType,
                source: objectType,
                actionSubject: objectType,
                attributes: {
                    previousSessionId: previousSessionId
                }
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $TtQEC.default), {
                sessionId: sessionId,
                data: data
            });
        }
        return null;
    }
}
var $fffa056866f763fb$export$2e2bcd8739ae039 = (0, $1bQGJ.withRouter)($fffa056866f763fb$export$f1e582dddb502dd6);

});
parcelRegister("6YRTH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3bd6eeaf3add142$export$2e2bcd8739ae039);

var $6vAaw = parcelRequire("6vAaw");

var $fr1K2 = parcelRequire("fr1K2");
var /**
 * Use to remove query params from url without reload or change history
 * One use case is to remove any tracking id from the url to avoid problems in copy & paste urls or sharing links between users
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$e3bd6eeaf3add142$export$2e2bcd8739ae039 = (paramsToStrip)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($6vAaw))).parse(window.location.href, true);
        const strippedQuery = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(parsedUrl.query || {}, paramsToStrip);
        let strippedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($6vAaw))).format({
            ...parsedUrl,
            search: undefined,
            query: strippedQuery
        });
        // we don't want to encode : to %3A in connect project pages
        const isConnect = /\?|&selectedItem=com.atlassian.plugins.atlassian-connect-plugin:/.test(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.search);
        if (isConnect) strippedUrl = strippedUrl.replace(/selectedItem=com.atlassian.plugins.atlassian-connect-plugin%3A/g, (match)=>match.replace(/%3A/i, ':'));
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.history.replaceState({}, '', strippedUrl);
    } catch (e) {
    /* uri might be malformed */ }
};

});

parcelRegister("TtQEC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ee37fd26b4ccf1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $jzjy1 = parcelRequire("jzjy1");

var $jD5no = parcelRequire("jD5no");


var $l7nSX = parcelRequire("l7nSX");
const $c8ee37fd26b4ccf1$var$defaultSource = 'dwellComponent';
const $c8ee37fd26b4ccf1$var$defaultActionSubject = 'dwellComponent';
const $c8ee37fd26b4ccf1$var$getDwellComponent = (source, actionSubject)=>(0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $jzjy1.AnalyticsSubject)(actionSubject || $c8ee37fd26b4ccf1$var$defaultActionSubject), (0, $jzjy1.AnalyticsSource)(source || $c8ee37fd26b4ccf1$var$defaultSource, (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)))((0, $l7nSX.default));
class $c8ee37fd26b4ccf1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static getDerivedStateFromProps(props) {
        const { data: data } = props;
        return {
            DwellTimeComponent: $c8ee37fd26b4ccf1$var$getDwellComponent(data.source, data.actionSubject)
        };
    }
    constructor(props){
        super(props);
        this.state = {
            DwellTimeComponent: null
        };
    }
    render() {
        const { sessionId: sessionId, data: data } = this.props;
        const { DwellTimeComponent: DwellTimeComponent } = this.state;
        const enrichedData = {
            ...data,
            source: data && data.source || $c8ee37fd26b4ccf1$var$defaultSource,
            actionSubject: data && data.actionSubject || $c8ee37fd26b4ccf1$var$defaultActionSubject
        };
        if (sessionId && DwellTimeComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DwellTimeComponent, {
            sessionId: sessionId,
            data: enrichedData
        }));
        return null;
    }
}

});
parcelRegister("l7nSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c5cee06f4a100e3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6iXGJ = parcelRequire("6iXGJ");

var $8oe80 = parcelRequire("8oe80");

var $hhweD = parcelRequire("hhweD");
class $8c5cee06f4a100e3$export$1c7ccff61c195c75 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { data: data, sessionId: sessionId } = this.props;
        // @ts-expect-error - TS2741 - Property 'prototype' is missing in type 'DwellTimeHelper' but required in type 'typeof DwellTimeHelper'.
        this.dwellHelper = new (0, $6iXGJ.default)(this.sendDwellEvent, data, sessionId);
        // @ts-expect-error - TS2339 - Property 'start' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.start();
    }
    componentDidUpdate(oldProps) {
        if (oldProps.sessionId !== this.props.sessionId && this.dwellHelper !== null) // @ts-expect-error - TS2339 - Property 'newPage' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.newPage(this.props.data, this.props.sessionId);
    }
    componentWillUnmount() {
        if (this.dwellHelper) {
            // @ts-expect-error - TS2339 - Property 'stop' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.stop();
            // @ts-expect-error - TS2339 - Property 'destroy' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.destroy();
        }
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, this.props.children);
    }
    constructor(...args){
        super(...args), this.sendDwellEvent = (payload)=>(0, $hhweD.fireTrackAnalytics)(this.props.createAnalyticsEvent(), payload);
    }
}
var $8c5cee06f4a100e3$export$2e2bcd8739ae039 = (0, $8oe80.default)('dwellTime', {
    onDwell: 'dwelled'
})($8c5cee06f4a100e3$export$1c7ccff61c195c75);

});
parcelRegister("hhweD", function(module, exports) {

$parcel$export(module.exports, "fireTrackAnalytics", () => $a4297ed46523d116$export$13990ad4625571ed);

var $4f8Oj = parcelRequire("4f8Oj");

var $gvRPW = parcelRequire("gvRPW");

var $i4iBk = parcelRequire("i4iBk");
const $a4297ed46523d116$var$isNotUndefined = (a)=>a !== undefined;
const $a4297ed46523d116$var$mapPayload = (payload)=>{
    const context = (0, $i4iBk.default)(payload);
    const { action: action, actionSubjectId: actionSubjectId } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        action: action,
        actionSubjectId: actionSubjectId
    }, $a4297ed46523d116$var$isNotUndefined);
};
const $a4297ed46523d116$export$13990ad4625571ed = (event, payload)=>{
    event.update({
        ...$a4297ed46523d116$var$mapPayload(payload),
        analyticsType: (0, $gvRPW.TRACK_EVENT_TYPE)
    }).fire();
};

});



parcelRegister("7IBED", function(module, exports) {

$parcel$export(module.exports, "addMetaTag", () => $751334a79f9a31ee$export$c79fd820617d7f);
$parcel$export(module.exports, "removeMetaTag", () => $751334a79f9a31ee$export$4267657a25105d9d);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
const $751334a79f9a31ee$export$c9d44c736471c518 = (name)=>document.querySelector(`meta[name="${name}"]`);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $751334a79f9a31ee$var$getHead = ()=>document.head || document.querySelector('head');
const $751334a79f9a31ee$export$c79fd820617d7f = (name, content)=>{
    if (!name || !content) return;
    const existingMeta = $751334a79f9a31ee$export$c9d44c736471c518(name);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const meta = document.createElement('meta');
    meta.name = name;
    meta.content = content;
    if (existingMeta) existingMeta.parentNode?.replaceChild(meta, existingMeta);
    else {
        const head = $751334a79f9a31ee$var$getHead();
        if (head) head.appendChild(meta);
    }
};
const $751334a79f9a31ee$export$4267657a25105d9d = (name)=>{
    const meta = $751334a79f9a31ee$export$c9d44c736471c518(name);
    if (meta) meta.parentNode?.removeChild(meta);
};

});

parcelRegister("5Jsi2", function(module, exports) {

$parcel$export(module.exports, "CLEAR_SEARCH_SESSION", () => $65e6525a854bf206$export$b669eaa3e4786d5c);
$parcel$export(module.exports, "skipClearSessionURLs", () => $65e6525a854bf206$export$c092460ed33e0e35);
const $65e6525a854bf206$export$b669eaa3e4786d5c = 'CLEAR_SEARCH_SESSION';
const $65e6525a854bf206$export$c092460ed33e0e35 = [
    /.*RapidBoard.jspa.*/,
    /\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/,
    /\/jira\/people\/.*\/boards\/.*/
];

});


parcelRegister("fGcGc", function(module, exports) {

$parcel$export(module.exports, "addInitialPageLoadTimings", () => $e9a0ff6532e2be2e$export$ce440b3d0fa0d5ed);

var $4R6GH = parcelRequire("4R6GH");

var $2SVPM = parcelRequire("2SVPM");

var $6oVP0 = parcelRequire("6oVP0");
const $e9a0ff6532e2be2e$export$ce440b3d0fa0d5ed = ()=>{
    if (false) return;
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush', 'ssr.spa.early-common-flush:start', 'ssr.spa.early-route-flush:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/metatags', 'ssr.spa.metatags:start', 'ssr.spa.metatags:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig', 'ssr.spa.statsig:start', 'ssr.spa.statsig:end');
    if ((0, $4R6GH.fg)('jira-ssr-perf-portal-cleanup')) {
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig', 'ssr.spa.statsig-gate-values:start', 'ssr.spa.statsig-gate-values:end');
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig-parse', 'statsig-parse:start', 'statsig-parse:end');
        // In legacy SSR, parsing happens inline with processing the flush. In modern SSR or static fallback scenarios for legacy SSR, the parse will be timed seperately.
        // What we want to avoid is confusing people with a "parse timer" in legacy SSR breakdown charts that doesn't overlap with the "statsig" timer (it would have a very low volume, but it would distract people during perf-investigations)
        // This will make the statsig-parse timer fully overlap with "statsig" when the parsing happens inline, and will start at a different time otherwise
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig-parse', 'ssr.spa.statsig:start', 'ssr.spa.statsig:start');
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/inline-scripts-common', 'ssr.spa.inline-assets:start', 'ssr.spa.inline-assets:end');
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/inline-scripts-route', 'ssr.spa.async-inline-assets:start', 'ssr.spa.async-inline-assets:end');
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/css-assets', 'ssr.spa.css-assets:start', 'ssr.spa.css-assets:end');
    } else {
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/inline-scripts', 'ssr.spa.feature-flags:end', 'ssr.spa.early-common-flush:end');
        (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('css-assets', 'ssr.spa.css-assets:start', 'ssr.spa.css-assets:end');
    }
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/feature-flags', 'ssr.spa.feature-flags:start', 'ssr.spa.feature-flags:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/route-preload', 'ssr.spa.early-route-flush:start', 'ssr.spa.early-route-flush:end');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output', 'ssr.spa.start', 'ssr.spa.state');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/styles', 'ssr.spa.start', 'ssr.spa.styles');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/html', 'ssr.spa.styles', 'ssr.spa.html');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/state', 'ssr.spa.html', 'ssr.spa.state');
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/language-pack', 'jira-spa/language-pack.start', 'jira-spa/language-pack.end', true, true);
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    (0, $4R6GH.fg)('add-loading-bundles-span-initial-load') && (0, $6oVP0.observePreloadedBundlesProgress)();
};

});
parcelRegister("6oVP0", function(module, exports) {

$parcel$export(module.exports, "observePreloadedBundlesProgress", () => $953aaa0a85a87020$export$2169bfe6cd4f4439);

var $3fRWr = parcelRequire("3fRWr");
let $953aaa0a85a87020$var$po = null;
let $953aaa0a85a87020$var$timeout = null;
let $953aaa0a85a87020$var$started = false;
const $953aaa0a85a87020$export$2169bfe6cd4f4439 = ()=>{
    if (false || $953aaa0a85a87020$var$started || !globalThis.PerformanceObserver) return;
    $953aaa0a85a87020$var$started = true;
    const expectedEntries = new Set(Array.from(globalThis.document?.querySelectorAll?.('link[rel=modulepreload]') || []).map((el)=>el.getAttribute('href')).filter((url)=>url?.includes('jira-frontend-bifrost')));
    /* eslint-disable @typescript-eslint/consistent-type-assertions */ const loadedResources = Array.from(globalThis.performance?.getEntriesByType('resource')).filter(({ name: name })=>{
        if (expectedEntries.has(name)) {
            expectedEntries.delete(name);
            return true;
        }
        return false;
    });
    if (expectedEntries.size > 0) {
        $953aaa0a85a87020$var$timeout = setTimeout(()=>{
            $953aaa0a85a87020$var$po?.disconnect();
        }, 30000);
        $953aaa0a85a87020$var$po = new PerformanceObserver((entry)=>{
            entry.getEntries().forEach((e)=>{
                if (expectedEntries.has(e.name)) {
                    expectedEntries.delete(e.name);
                    loadedResources.push(e);
                }
                if (expectedEntries.size === 0) {
                    $953aaa0a85a87020$var$timeout !== null && clearTimeout($953aaa0a85a87020$var$timeout);
                    $953aaa0a85a87020$var$po?.disconnect();
                    $953aaa0a85a87020$var$processCapturedData(loadedResources);
                }
            });
        });
    } else $953aaa0a85a87020$var$processCapturedData(loadedResources);
/* eslint-enable @typescript-eslint/consistent-type-assertions */ };
const $953aaa0a85a87020$var$determineMinAndMax = (agg, entry)=>{
    if (agg.min === null || entry.startTime < agg.min) // eslint-disable-next-line no-param-reassign
    agg.min = entry.startTime;
    if (agg.max === null || entry.responseEnd > agg.max) // eslint-disable-next-line no-param-reassign
    agg.max = entry.responseEnd;
};
const $953aaa0a85a87020$var$processCapturedData = (loadedResources)=>{
    const { all: all, common: common, route: route } = loadedResources.reduce((agg, entry)=>{
        $953aaa0a85a87020$var$determineMinAndMax(agg.all, entry);
        if ($953aaa0a85a87020$var$isCommon(entry)) $953aaa0a85a87020$var$determineMinAndMax(agg.common, entry);
        else $953aaa0a85a87020$var$determineMinAndMax(agg.route, entry);
        return agg;
    }, {
        all: {
            max: null,
            min: null
        },
        common: {
            max: null,
            min: null
        },
        route: {
            max: null,
            min: null
        }
    });
    if (all.max === null || all.min === null) return;
    $953aaa0a85a87020$var$setTimings('preloading-bundles', all);
    $953aaa0a85a87020$var$setTimings('preloading-bundles/common', common);
    $953aaa0a85a87020$var$setTimings('preloading-bundles/route', route);
};
const $953aaa0a85a87020$var$isCommon = (entry)=>{
    const url = entry.name;
    const hasJiraSpa = url.includes('jira-spa');
    const isSharedWithoutNav = url.includes('/shared') && !url.includes('atlassian-navigation');
    const isNavWithVendor = url.includes('atlassian-navigation') && url.includes('vendor');
    return (hasJiraSpa || isSharedWithoutNav || isNavWithVendor) && url.endsWith('.js');
};
const $953aaa0a85a87020$var$setTimings = (label, { min: min, max: max })=>{
    if (max === null || min === null) return;
    const startMark = `${label}-start`;
    const stopMark = `${label}-end`;
    performance.mark(startMark, {
        startTime: min
    });
    performance.mark(stopMark, {
        startTime: max
    });
    (0, $3fRWr.addTimingFromPerformanceMark)(label, startMark, stopMark, true, true);
};

});


parcelRegister("bShz7", function(module, exports) {

$parcel$export(module.exports, "setPrefetchStartMark", () => $fd73e472799b8227$export$405fde3eab8e39f6);
$parcel$export(module.exports, "getPrefetchStartMark", () => $fd73e472799b8227$export$cbaceb7ffa84279);
$parcel$export(module.exports, "clearPrefetchStartMarks", () => $fd73e472799b8227$export$d6b0928f07bafe57);
const $fd73e472799b8227$var$prefetchTiming = new Map();
const $fd73e472799b8227$export$405fde3eab8e39f6 = (match)=>{
    const currentMatch = JSON.stringify(match);
    if (!$fd73e472799b8227$var$prefetchTiming.has(currentMatch)) $fd73e472799b8227$var$prefetchTiming.set(currentMatch, {
        startPrefetchTime: Date.now()
    });
};
const $fd73e472799b8227$export$cbaceb7ffa84279 = (match)=>{
    const currentMatch = JSON.stringify(match);
    const { startPrefetchTime: startPrefetchTime } = $fd73e472799b8227$var$prefetchTiming.get(currentMatch) || {
        startPrefetchTime: null
    };
    return startPrefetchTime;
};
const $fd73e472799b8227$export$d6b0928f07bafe57 = (match)=>{
    if (!$fd73e472799b8227$var$prefetchTiming || !$fd73e472799b8227$var$prefetchTiming.keys) return;
    const currentMatch = JSON.stringify(match);
    const keys = Array.from($fd73e472799b8227$var$prefetchTiming.keys());
    keys.forEach((mark)=>{
        if (mark !== currentMatch && $fd73e472799b8227$var$prefetchTiming.has(mark)) $fd73e472799b8227$var$prefetchTiming.delete(mark);
    });
};

});

parcelRegister("lbyb6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab2f047cd976509c$export$2e2bcd8739ae039);
/* eslint-disable no-await-in-loop */ 
var $dJl1T = parcelRequire("dJl1T");

var $7bpAK = parcelRequire("7bpAK");
var $2Gs5h = parcelRequire("2Gs5h");
const $ab2f047cd976509c$var$LOCATION = 'spa.create-spa-history';
const $ab2f047cd976509c$var$createCustomHistoryBlock = (routeBlockFns, currentRoutes, history)=>(blockFn)=>{
        const matchedRoute = (0, $2Gs5h.default)(currentRoutes, history.location.pathname, // @ts-expect-error - wrong type of matchRoute (it accepts query param as string)
        history.location.search);
        // This should never be the case as in SPA we have a default route
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!matchedRoute) return ()=>{};
        if (!routeBlockFns.includes(blockFn)) routeBlockFns.push(blockFn);
        // returns an "unregister" block
        return ()=>{
            const idx = routeBlockFns.indexOf(blockFn);
            if (idx !== -1) routeBlockFns.splice(idx, 1);
        };
    };
const $ab2f047cd976509c$var$createSpaHistory = (initialRoutes)=>{
    const routeBlockFns = [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    let blockArgs = [];
    let nextMatchedRoute;
    const currentRoutes = initialRoutes;
    const history = (0, $7bpAK.createBrowserHistory)({
        /* We abuse this api to allow us to run as many blockers as we want, allowing the transition
		 * to resume only when all return true or bail out as soon as the first one returns false */ getUserConfirmation: (__, done)=>{
            const matchedRoute = (0, $2Gs5h.default)(currentRoutes, history.location.pathname, // @ts-expect-error - wrong type of matchRoute (it accepts query param as string)
            history.location.search);
            // This should never be the case as in SPA we have a default route
            if (!matchedRoute || !nextMatchedRoute) return done(true);
            // we execute the blockers in reverse order, so the last registered is the first to run
            // They are executed synchronously until one returns false or a promise
            // If a promise is returned we execute all remaining blockers as chained promises
            let sync = true;
            for(let i = routeBlockFns.length - 1; i >= 0; i -= 1){
                const result = routeBlockFns[i](...blockArgs);
                if (result instanceof Promise) {
                    sync = false;
                    routeBlockFns.slice(0, i + 1).reverse().reduce(// eslint-disable-next-line @typescript-eslint/no-loop-func
                    (promise, blocker)=>promise.then((res)=>res === false ? Promise.resolve(false) : blocker(...blockArgs)), Promise.resolve(result)).then((res)=>{
                        routeBlockFns.length = 0;
                        done(res);
                    }).catch((err)=>{
                        (0, $dJl1T.default).safeErrorWithoutCustomerData($ab2f047cd976509c$var$LOCATION, 'Error with getUserConfirmation', err);
                        done(true);
                    });
                    break;
                }
                if (result === false) {
                    done(false);
                    return;
                }
            }
            if (sync) {
                routeBlockFns.length = 0;
                done(true);
            }
        }
    });
    // For lazy loaded route maps we need to keep track of the current routes here
    // as they will be changing. When we "match" for the route blocking code we need
    // to ensure we match against the current routes, not the routes at the time the function
    // was created.
    history.refreshRoutes = (newRoutes)=>{
        // Replace currentRoutes in place as it's captured in a closure above..
        currentRoutes.length = 0;
        currentRoutes.push(...newRoutes);
    };
    /* We set the main "blocker", that is also used enable next location access in getUserConfirmation
	 * (going around getUserConfirmation API limitations) */ history.block((location, action)=>{
        blockArgs = [
            location,
            action
        ];
        nextMatchedRoute = (0, $2Gs5h.default)(currentRoutes, location.pathname, // @ts-expect-error - wrong type of matchRoute (it accepts query param as string)
        location.search);
        // Must return a string or getUserConfirmation is not called
        return '';
    });
    // @ts-expect-error - we're using a custom blocker
    history.block = $ab2f047cd976509c$var$createCustomHistoryBlock(routeBlockFns, currentRoutes, history);
    return history;
};
var /**
 * Monkey patches the push/replace methods of the react router history object to
 * perform a full page refresh instead of history push/replace when a route is not valid
 * (i.e. legacy pages). This is required to fix the browser back button not working correctly
 * after redirecting to a legacy page.
 * JSPA-900
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$ab2f047cd976509c$export$2e2bcd8739ae039 = (routes)=>$ab2f047cd976509c$var$createSpaHistory(routes);

});

parcelRegister("5HG6S", function(module, exports) {

$parcel$export(module.exports, "getSpaRouterContext", () => $804f5602998bd8a4$export$1f61c5e3f6410afa);
const $804f5602998bd8a4$export$1f61c5e3f6410afa = ({ tenantContext: tenantContext })=>({
        tenantContext: tenantContext
    });

});

parcelRegister("kKlrY", function(module, exports) {

$parcel$export(module.exports, "default", () => $71f44f620ca2fe28$export$2e2bcd8739ae039);

var $i9YTk = parcelRequire("i9YTk");

var $lAOer = parcelRequire("lAOer");

var $eH557 = parcelRequire("eH557");

var $5b3DZ = parcelRequire("5b3DZ");
var $j03C1 = parcelRequire("j03C1");

var $6kyhr = parcelRequire("6kyhr");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $aZWa4 = parcelRequire("aZWa4");

var $3dQJA = parcelRequire("3dQJA");

var $5i16O = parcelRequire("5i16O");

var $fJbQ9 = parcelRequire("fJbQ9");

var $itoGf = parcelRequire("itoGf");

var $dQKfU = parcelRequire("dQKfU");
const $71f44f620ca2fe28$var$getUFOConfigFromLD = ()=>(0, $co1wz.getFeatureFlagValue)('ufo.config', {});
const $71f44f620ca2fe28$var$getUFOConfigFromStatsig = ()=>{
    // TODO: https://product-fabric.atlassian.net/browse/AFO-2949 - replace these with Statsig dynamic config values
    return {
        autoGeneratedRate: 1000,
        enabled: true,
        removeUFOPrefixList: [
            'project-versions',
            'filters-directory'
        ],
        removePageSegmentsUFOPrefixes: true,
        doNotAbortActivePressInteractionOnTransition: [
            'jsm-create-cmp-request-type-from-template',
            'jsm-create-tmp-request-type-from-template'
        ],
        killswitch: [
            'jira.fe.load.UNKNOWN'
        ],
        awaitForSegments: {
            'global-issue.create-modal': [
                'issue-view-details'
            ],
            'global-issue.create-modal-subsequent': [
                'issue-view-details'
            ]
        },
        removeAllUFOPrefix: true,
        rates: {
            'issue-view-activity-button-worklog': 1,
            'issue-view-activity-button-history': 1,
            'issue-view-activity-button-comments': 1,
            'arj-toggle-view-mode': 1,
            'global-issue.create-modal-subsequent': 5,
            unknown: 1000,
            'issue-view-activity-button-forge-app': 1,
            'view-mode': 1,
            'backlog.issue-view-opened': 5,
            'create-web-link-inline-field-type-tracing': 1000,
            'issue-view-activity-button-connect-app': 1,
            'single-line-text-field-type-tracing': 100,
            'issue-view-activity-button-all': 1,
            'backlog.card-hover': 100,
            'child-issue-inline-create-type-tracing': 100,
            'show-insights-button': 100,
            'board.issue-view-opened': 5,
            'issue-view-activity-button-jsd-comments': 1,
            'backlog.card-list-toggle': 5,
            'global-issue.create-modal': 5,
            'issue-view-activity-button-approvals': 1
        },
        kind: {
            generic: 0,
            hover: 0,
            legacy: 1,
            page_load: 1,
            press: 1,
            transition: 1,
            typing: 0
        },
        awaitBM3TTI: [
            'jwm_project_pages',
            'software-plan-dependencies',
            'advanced-roadmaps.page-plan.dependencies-tab.load-time',
            'servicedesk-cmdb-object-type-configuration',
            'service-management.insight-cmdb-object-type-configuration',
            'project-components-view',
            'project-components',
            'project-settings-components',
            'people-index',
            'people-profiles',
            'rapidboard-report',
            'classic-report',
            'project-settings-servicedesk-ticket-type-fields',
            'project-settings.issue-type.jsm-cmp-customer-view',
            'project-settings.issue-type.jsm-cmp-agent-view',
            'archived-project-direct-link',
            'project-archived',
            'servicedesk-queues-new',
            'service-management.queues.new',
            'board-settings-apps.insights-settings-page.page.load',
            'admin-oauth-credentials',
            'admin.oauth-credentials',
            'polaris-ideas',
            'project-settings-software-boards-csm',
            'jira.fe.page-load.software.next-gen.boards.column-status-mapping.page.load',
            'project-settings-servicedesk-language',
            'service-management.languages',
            'project-settings-servicedesk-language-key',
            'service-management.translations',
            'project-settings-servicedesk-classic-apps',
            'service-management.app-discovery',
            'marketplace-index',
            'embedded-marketplace',
            'project-settings-servicedesk-portal-settings',
            'service-management.portal-settings',
            'service-management.portal-settings.portal-groups',
            'project-settings-servicedesk-automation-create',
            'service-management.automation.create-rule',
            'servicedesk-customers-v2',
            'jsm-customers-component-load',
            'archived-project-direct-link',
            'project-archived',
            'project-settings-software-boards-csm',
            'software.next-gen.boards.column-status-mapping.page.load',
            'jira-connect',
            'knowledge-hub-category',
            'service-management.knowledge.category',
            'servicedesk-queues-landing',
            'servicedesk-practice-landing',
            'servicedesk-practice-custom-and-issue',
            'servicedesk-practice-custom-issue',
            'servicedesk-practice-custom-view',
            'servicedesk-queues-custom-and-issue',
            'servicedesk-queues-custom-issue',
            'servicedesk-queues-custom-view'
        ],
        rules: [],
        capability: {
            feature_flag_access: 1,
            react_profiler: 1
        },
        typingMethod: 'timeout',
        removeInteractionsUFOPrefixes: true,
        doNotAbortActivePressInteraction: [
            'global-issue.create-modal',
            'global-issue.create-modal-subsequent'
        ],
        ufoNameOverrides: {
            'global-issue-navigator': {
                'global-issue-navigator': 'global-issue-navigator-jfe',
                'new-issue-navigator': 'global-new-issue-navigator'
            },
            'global-issue-navigator-jfe': {
                'global-issue-navigator-jfe': 'global-issue-navigator-jfe',
                'new-issue-navigator': 'global-new-issue-navigator'
            },
            'polaris-ideas': {
                'project-settings.details': 'project-settings-details-polaris-ideas'
            },
            'project-settings-servicedesk-portal-settings': {
                'service-management.portal-settings': 'service-management.portal-settings',
                'service-management.portal-settings.portal-groups': 'service-management.portal-settings.portal-groups'
            },
            'project-settings-servicedesk-ticket-type-fields': {
                'project-settings.issue-type.jsm-cmp-agent-view': 'project-settings.issue-type.jsm-cmp-agent-view',
                'project-settings.issue-type.jsm-cmp-customer-view': 'project-settings.issue-type.jsm-cmp-customer-view'
            },
            'servicedesk-practice-custom-and-issue': {
                'service-management.queues.issue': 'servicedesk-practice-custom-issue',
                'service-management.queues.view': 'servicedesk-practice-custom-view'
            },
            'servicedesk-queues-custom-and-issue': {
                'service-management.queues.issue': 'servicedesk-queues-custom-issue',
                'service-management.queues.view': 'servicedesk-queues-custom-view'
            }
        },
        enableCompleteUsingDoubleRAF: true
    };
};
function $71f44f620ca2fe28$var$getAdditionalJiraFields(interaction) {
    try {
        return {
            jira: (0, $3dQJA.getJiraCustomData)(interaction)
        };
    } catch (error) {
        return {};
    }
}

function $71f44f620ca2fe28$var$loadJiraAnalyticsWebClient() {
    return Promise.resolve((parcelRequire("fjcgS")));
}
function $71f44f620ca2fe28$export$2e2bcd8739ae039() {
    const ufoConfigFromFF = (0, $4R6GH.fg)('ufo-use-statsig-config-jira') ? $71f44f620ca2fe28$var$getUFOConfigFromStatsig() : $71f44f620ca2fe28$var$getUFOConfigFromLD();
    (0, $aZWa4.retrieveAndSetPageLoadTrace)((0, $j8DrX.default));
    (0, $5b3DZ.configure)((0, $itoGf.jiraResourceTimingsConfig));
    (0, $j03C1.startResourceTimingBuffer)();
    if (!(0, $4R6GH.fg)('jira-disable-ufo-bundle-eval-timings')) (0, $i9YTk.configure)((0, $fJbQ9.jiraBundleEvalTimingsConfig));
    (0, $6kyhr.configure)((0, $dQKfU.jiraSsrConfig));
    (0, $5i16O.GlobalReactLooselyLazyProfiler).current = (0, $lAOer.ModuleLoadingProfiler);
    const perfPushFY25ExperienceRates = {
        'issue-view': 1,
        'new-issue-navigator': 1,
        'classic-board': 1,
        'classic-backlog': 1,
        'next-gen-board': 1,
        'jwm.list-view': 1,
        'jwm.jwm-board': 1,
        'jwm.summary-view': 1,
        dashboard: 1,
        'software-issue-navigator': 1,
        'global-new-issue-navigator': 1,
        'issue-navigator': 1,
        'issue-navigator-classic': 1,
        'issue-navigator-core': 1,
        'servicedesk-issues': 1
    };
    const ssrWhitelist = [];
    if ((0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nin_and_nav')) ssrWhitelist.push('software-issue-navigator', 'global-new-issue-navigator', 'issue-navigator-classic', 'issue-navigator-core', 'servicedesk-issues');
    if ((0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nav_for_iv')) ssrWhitelist.push('issue-view');
    if ((0, $4R6GH.fg)('add_nav_ssr_placeholder_for_board_and_backlog')) ssrWhitelist.push('classic-board', 'classic-backlog');
    let assetsConfig = {};
    if ((0, $4R6GH.fg)('new_chr_classification')) assetsConfig = {
        classification: {
            all: true,
            allAtlassian: ({ entry: entry })=>{
                const isAtlassian = entry.name.includes('atl-pass.net/') || entry.name.includes('cloudfront') && entry.name.includes('batch.js');
                return isAtlassian;
            },
            preloaded: ({ entry: entry, SSRDoneTime: SSRDoneTime })=>{
                return SSRDoneTime && entry.startTime <= SSRDoneTime;
            }
        }
    };
    (0, $eH557.init)($71f44f620ca2fe28$var$loadJiraAnalyticsWebClient(), {
        ...ufoConfigFromFF,
        enableSegmentHighlighting: (0, $4R6GH.fg)('ufo_enable_segment_highlighting_jira'),
        enableAdditionalPerformanceMarks: (0, $4R6GH.fg)('ufo_enable_segment_highlighting_jira'),
        product: 'jira',
        region: (0, $j8DrX.default)('ajs-region') || 'unknown',
        additionalPayloadData: $71f44f620ca2fe28$var$getAdditionalJiraFields,
        postInteractionLog: {
            enabled: (0, $4R6GH.fg)('ufo_capture_late_rerenders_jira'),
            rates: perfPushFY25ExperienceRates
        },
        experimentalInteractionMetrics: {
            enabled: (0, $4R6GH.fg)('ufo-enable-experimental-holds-jira'),
            rates: perfPushFY25ExperienceRates
        },
        manuallyTrackReactProfilerMounts: (0, $4R6GH.fg)('ufo-manually-track-segment-mount-phase-jira'),
        vc: {
            enabled: true,
            heatmapSize: 200,
            oldDomUpdates: false,
            devToolsEnabled: (0, $4R6GH.fg)('uip_vc_devtools'),
            selectorConfig: {
                id: true,
                role: !(0, $4R6GH.fg)('uip_disable_vc_role_selector'),
                className: true,
                testId: false
            },
            ssr: (0, $4R6GH.fg)('uip_vc_ssr'),
            ssrWhitelist: ssrWhitelist,
            stopVCAtInteractionFinish: (0, $4R6GH.fg)('stop_vc_at_interaction_finish')
        },
        enableBetterPageVisibilityApi: true,
        assetsConfig: assetsConfig
    });
}

});
parcelRegister("i9YTk", function(module, exports) {

$parcel$export(module.exports, "configure", () => $2a4b31348297fef7$export$8d21e34596265fa2);
$parcel$export(module.exports, "getBundleEvalTimings", () => $2a4b31348297fef7$export$2eda1519e91a4386);

var $9iPjD = parcelRequire("9iPjD");
let $2a4b31348297fef7$var$config = null;
function $2a4b31348297fef7$export$8d21e34596265fa2(bundleEvalTimingConfiguration) {
    $2a4b31348297fef7$var$config = bundleEvalTimingConfiguration;
}
const $2a4b31348297fef7$var$getPerformanceObject = ()=>(window ?? {}).performance;
function $2a4b31348297fef7$export$2eda1519e91a4386(interactionStartTime) {
    if ($2a4b31348297fef7$var$config == null) return {};
    const started = {};
    const timings = {};
    const cachedConfig = $2a4b31348297fef7$var$config;
    const performance = $2a4b31348297fef7$var$getPerformanceObject();
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = cachedConfig.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= interactionStartTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: (0, $9iPjD.roundEpsilon)(started[name].startTime - interactionStartTime),
                duration: (0, $9iPjD.roundEpsilon)(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (Object.keys(timings).length === 0) return {};
    return timings;
}

});
parcelRegister("9iPjD", function(module, exports) {

$parcel$export(module.exports, "roundEpsilon", () => $b269d683809c5cab$export$56014375de40214b);
const $b269d683809c5cab$export$56014375de40214b = (num, places = 3)=>{
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
};

});


parcelRegister("eH557", function(module, exports) {

$parcel$export(module.exports, "init", () => $137a6d772c8ecfc6$export$2cd8252107eb640b);

var $fHpHg = parcelRequire("fHpHg");

var $9qJsq = parcelRequire("9qJsq");

var $7u3rk = parcelRequire("7u3rk");

var $GecrJ = parcelRequire("GecrJ");

var $5zYYx = parcelRequire("5zYYx");

var $lAOer = parcelRequire("lAOer");

var $1V2aV = parcelRequire("1V2aV");

var $hPdPb = parcelRequire("hPdPb");
let $137a6d772c8ecfc6$var$initialized = false;
function $137a6d772c8ecfc6$var$sinkInteraction(instance, payloadPackage) {
    (0, $lAOer.sinkInteractionHandler)((interactionId, interaction)=>{
        (0, $hPdPb.default)(()=>{
            payloadPackage.createPayloads(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        });
    });
}
function $137a6d772c8ecfc6$var$sinkExperimentalInteractionMetrics(instance, payloadPackage) {
    (0, $GecrJ.sinkExperimentalHandler)((interactionId, interaction)=>{
        (0, $hPdPb.default)(()=>{
            const payloadPromise = payloadPackage.createExperimentalMetricsPayload(interactionId, interaction);
            payloadPromise.then((payload)=>{
                if (payload) {
                    if ((0, $fHpHg.fg)('enable_ufo_devtools_api_for_extra_events')) {
                        // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                        const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                        if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    }
                    instance.sendOperationalEvent(payload);
                }
            });
        });
    });
}
function $137a6d772c8ecfc6$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $lAOer.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, $hPdPb.default)(()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and also by Criterion
                if ((0, $fHpHg.fg)('enable_ufo_devtools_api_for_extra_events')) {
                    const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                }
                instance.sendOperationalEvent(payload);
            }
        });
    });
}


const $137a6d772c8ecfc6$export$2cd8252107eb640b = (analyticsWebClientAsync, config)=>{
    if ($137a6d772c8ecfc6$var$initialized) return;
    (0, $7u3rk.setUFOConfig)(config);
    if (config.vc?.enabled) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig
        };
        (0, $1V2aV.getVCObserver)(vcOptions).start({
            startTime: 0
        });
        (0, $lAOer.postInteractionLog).initializeVCObserver(vcOptions);
        (0, $lAOer.postInteractionLog).startVCObserver({
            startTime: 0
        });
        if (config?.experimentalInteractionMetrics?.enabled) (0, $GecrJ.experimentalVC).initialize(vcOptions).start({
            startTime: 0
        });
    }
    (0, $5zYYx.setupHiddenTimingCapture)();
    (0, $9qJsq.startLighthouseObserver)();
    $137a6d772c8ecfc6$var$initialized = true;
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("htfxx")),
        (parcelRequire("kDxBd"))
    ]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            const instance = client.getInstance();
            $137a6d772c8ecfc6$var$sinkInteraction(instance, payloadPackage);
            if (config?.experimentalInteractionMetrics?.enabled) $137a6d772c8ecfc6$var$sinkExperimentalInteractionMetrics(instance, payloadPackage);
            if (config.postInteractionLog?.enabled) $137a6d772c8ecfc6$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
        });
        else if (awc.sendOperationalEvent) {
            $137a6d772c8ecfc6$var$sinkInteraction(awc, payloadPackage);
            if (config?.experimentalInteractionMetrics?.enabled) $137a6d772c8ecfc6$var$sinkExperimentalInteractionMetrics(awc, payloadPackage);
            if (config.postInteractionLog?.enabled) $137a6d772c8ecfc6$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
        }
    });
};

});
parcelRegister("9qJsq", function(module, exports) {

$parcel$export(module.exports, "startLighthouseObserver", () => $2b5fc6d47fc710cc$export$5ecf2aafafee3e0);
$parcel$export(module.exports, "getLighthouseMetrics", () => $2b5fc6d47fc710cc$export$b46cecdf698e4bb5);

var $7hgtw = parcelRequire("7hgtw");

var $3oqaK = parcelRequire("3oqaK");

var $64Kli = parcelRequire("64Kli");

var $eRFl5 = parcelRequire("eRFl5");

var $t7fhi = parcelRequire("t7fhi");
function $2b5fc6d47fc710cc$export$5ecf2aafafee3e0() {
    (0, $t7fhi.startLSObserver)();
    (0, $t7fhi.startLTObserver)();
}
const $2b5fc6d47fc710cc$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
    const tbt = (0, $64Kli.getTBT)(start, stop, (0, $eRFl5.EntriesBuffer)[(0, $3oqaK.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $7hgtw.getCLS)(start, stop, (0, $eRFl5.EntriesBuffer)[(0, $3oqaK.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
};

});
parcelRegister("7hgtw", function(module, exports) {

$parcel$export(module.exports, "getCLS", () => $019860aeaca4a4d2$export$fc6227831ee7c7);
const $019860aeaca4a4d2$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("3oqaK", function(module, exports) {

$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $e0ada90d9c44ac34$export$a4def92db6fc8e17);
const $e0ada90d9c44ac34$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("64Kli", function(module, exports) {

$parcel$export(module.exports, "getTBT", () => $8b4ff5336dfdd489$export$2d6e933b35bd3407);
const $8b4ff5336dfdd489$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $8b4ff5336dfdd489$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $8b4ff5336dfdd489$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $8b4ff5336dfdd489$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $8b4ff5336dfdd489$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });

});

parcelRegister("eRFl5", function(module, exports) {

$parcel$export(module.exports, "EntriesBuffer", () => $67114ae28ab7da99$export$f7dc16cbd16f7bbe);

var $3oqaK = parcelRequire("3oqaK");
class $67114ae28ab7da99$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $67114ae28ab7da99$export$f7dc16cbd16f7bbe = {
    [(0, $3oqaK.PerformanceObserverEntryTypes).LongTask]: new $67114ae28ab7da99$export$2c6e86519c9e8188(),
    [(0, $3oqaK.PerformanceObserverEntryTypes).LayoutShift]: new $67114ae28ab7da99$export$2c6e86519c9e8188()
};

});

parcelRegister("t7fhi", function(module, exports) {

$parcel$export(module.exports, "startLSObserver", () => $c4bac6bdd3e2b6a5$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $c4bac6bdd3e2b6a5$export$54fb8b6aaf70ec9c);

var $3oqaK = parcelRequire("3oqaK");

var $eRFl5 = parcelRequire("eRFl5");
let $c4bac6bdd3e2b6a5$var$pe = null;
const $c4bac6bdd3e2b6a5$var$getObserver = ()=>{
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($c4bac6bdd3e2b6a5$var$pe !== null) return $c4bac6bdd3e2b6a5$var$pe;
    $c4bac6bdd3e2b6a5$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $3oqaK.PerformanceObserverEntryTypes).LayoutShift) (0, $eRFl5.EntriesBuffer)[(0, $3oqaK.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $3oqaK.PerformanceObserverEntryTypes).LongTask) (0, $eRFl5.EntriesBuffer)[(0, $3oqaK.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    });
    return $c4bac6bdd3e2b6a5$var$pe;
};
const $c4bac6bdd3e2b6a5$export$768ccc3ab7bac3ea = ()=>{
    $c4bac6bdd3e2b6a5$var$getObserver()?.observe({
        type: (0, $3oqaK.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
const $c4bac6bdd3e2b6a5$export$54fb8b6aaf70ec9c = ()=>{
    $c4bac6bdd3e2b6a5$var$getObserver()?.observe({
        type: (0, $3oqaK.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});


parcelRegister("hPdPb", function(module, exports) {

$parcel$export(module.exports, "default", () => $124d50da8149ad1e$export$2e2bcd8739ae039);

var $gg6CF = parcelRequire("gg6CF");

var $fHpHg = parcelRequire("fHpHg");
function $124d50da8149ad1e$export$2e2bcd8739ae039(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function' && (0, $fHpHg.fg)('ufo_payload_use_idle_callback')) window.requestIdleCallback(work);
    else (0, $gg6CF.unstable_scheduleCallback)((0, $gg6CF.unstable_IdlePriority), work);
}

});

parcelRegister("htfxx", function(module, exports) {

let $cb8132fd24b5778d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cb8132fd24b5778d$var$load("cM9em"),
    $cb8132fd24b5778d$var$load("fr9NE"),
    $cb8132fd24b5778d$var$load("d6Jjq")
]).then(()=>parcelRequire('f5HvF'));

});

parcelRegister("kDxBd", function(module, exports) {

let $f061834cb745830e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f061834cb745830e$var$load("3GEC7").then(()=>parcelRequire('sbCtV'));

});


parcelRegister("5b3DZ", function(module, exports) {

$parcel$export(module.exports, "configure", () => $c05deb6f4663c2ba$export$8d21e34596265fa2);
$parcel$export(module.exports, "getConfig", () => $c05deb6f4663c2ba$export$44487a86467333c3);

var $7u3rk = parcelRequire("7u3rk");
const $c05deb6f4663c2ba$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
const $c05deb6f4663c2ba$var$getAllowedParams = ()=>{
    const config = (0, $7u3rk.getConfig)();
    return config?.allowedResourcesParams || $c05deb6f4663c2ba$var$defaultAllowedParams;
};
const $c05deb6f4663c2ba$var$handleQueryParams = (urlString)=>{
    try {
        if (typeof urlString !== 'string') return urlString;
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const allowedParams = $c05deb6f4663c2ba$var$getAllowedParams();
        for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
        return url.toString();
    } catch (e) {
        return urlString;
    }
};
let $c05deb6f4663c2ba$var$config = {
    mapResources: (url)=>url,
    sanitiseEndpoints: (url)=>{
        return $c05deb6f4663c2ba$var$handleQueryParams(url);
    }
};
function $c05deb6f4663c2ba$export$8d21e34596265fa2(resourceTimingConfig) {
    const newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: (url)=>{
            const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $c05deb6f4663c2ba$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $c05deb6f4663c2ba$var$config = newConfig;
}
const $c05deb6f4663c2ba$export$44487a86467333c3 = ()=>$c05deb6f4663c2ba$var$config;

});

parcelRegister("j03C1", function(module, exports) {

$parcel$export(module.exports, "startResourceTimingBuffer", () => $3c65b15215d5dc30$export$a311cb1baa7d2d62);

var $1W0iO = parcelRequire("1W0iO");
function $3c65b15215d5dc30$export$a311cb1baa7d2d62() {
    (0, $1W0iO.resourceTimingBuffer).start();
}

});
parcelRegister("1W0iO", function(module, exports) {

$parcel$export(module.exports, "resourceTimingBuffer", () => $b064a4533dc92dfc$export$bea963256235a63e);
$parcel$export(module.exports, "filterResourceTimings", () => $b064a4533dc92dfc$export$4138a729ef1db028);

var $9iPjD = parcelRequire("9iPjD");
const $b064a4533dc92dfc$var$getPerformanceObject = ()=>(window ?? {}).performance;
const $b064a4533dc92dfc$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
const $b064a4533dc92dfc$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: (entry)=>{
        const duration = (0, $9iPjD.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        const totalBackendTimeEntry = entry.serverTiming?.find((timing)=>timing.name === 'atl-edge') || entry.serverTiming?.find(// timing name should come from per-product config in the future
        (timing)=>timing.name === 'total' || timing.name === 'filter-request-papi');
        const serverTime = totalBackendTimeEntry ? (0, $9iPjD.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        const networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $9iPjD.roundEpsilon)(entry.startTime),
            duration: (0, $9iPjD.roundEpsilon)(entry.duration),
            fetchStart: (0, $9iPjD.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $9iPjD.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $9iPjD.roundEpsilon)(entry.responseStart || 0),
            requestStart: (0, $9iPjD.roundEpsilon)(entry.requestStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $9iPjD.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $9iPjD.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start: ()=>{
        const performance = $b064a4533dc92dfc$var$getPerformanceObject();
        const PerformanceObserver = $b064a4533dc92dfc$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($b064a4533dc92dfc$export$bea963256235a63e.observer) return;
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $b064a4533dc92dfc$export$bea963256235a63e.timings = resources.map((resource)=>$b064a4533dc92dfc$export$bea963256235a63e.transformResource(resource));
        $b064a4533dc92dfc$export$bea963256235a63e.observer = new PerformanceObserver($b064a4533dc92dfc$export$bea963256235a63e.addTimings);
        $b064a4533dc92dfc$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: ()=>{
        if ($b064a4533dc92dfc$export$bea963256235a63e.observer) {
            $b064a4533dc92dfc$export$bea963256235a63e.observer.disconnect();
            $b064a4533dc92dfc$export$bea963256235a63e.observer = null;
        }
        $b064a4533dc92dfc$export$bea963256235a63e.timings = [];
    },
    addTimings: (list)=>{
        const entries = list.getEntries().map((entry)=>$b064a4533dc92dfc$export$bea963256235a63e.transformResource(entry));
        const overflow = $b064a4533dc92dfc$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $b064a4533dc92dfc$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $b064a4533dc92dfc$export$bea963256235a63e.maxSize;
            $b064a4533dc92dfc$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $b064a4533dc92dfc$export$bea963256235a63e.timings.push(...entries);
    }
};
const $b064a4533dc92dfc$var$isValidTiming = (timing, startTime, endTime)=>timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
const $b064a4533dc92dfc$export$4138a729ef1db028 = (startTime, endTime)=>{
    const performance = $b064a4533dc92dfc$var$getPerformanceObject();
    const PerformanceObserver = $b064a4533dc92dfc$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$b064a4533dc92dfc$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>$b064a4533dc92dfc$var$isValidTiming(timing, startTime, endTime));
        return null;
    }
    return $b064a4533dc92dfc$export$bea963256235a63e.timings.filter((timing)=>$b064a4533dc92dfc$var$isValidTiming(timing, startTime, endTime));
};

});


parcelRegister("6kyhr", function(module, exports) {

$parcel$export(module.exports, "configure", () => $f27813f03221d132$export$8d21e34596265fa2);
$parcel$export(module.exports, "getSSRTimings", () => $f27813f03221d132$export$bf7408e83532dcd0);
$parcel$export(module.exports, "getSSRSuccess", () => $f27813f03221d132$export$c7ad864055e75537);
$parcel$export(module.exports, "getSSRDoneTime", () => $f27813f03221d132$export$3def7672244bab0c);
$parcel$export(module.exports, "getSSRFeatureFlags", () => $f27813f03221d132$export$1c4a9b5e6e22393d);
const $f27813f03221d132$var$NESTED_METRIC_SEPARATOR = '/';
const $f27813f03221d132$var$filterEntry = (entry)=>!(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
const $f27813f03221d132$var$mapEntry = (entry)=>({
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    });
const $f27813f03221d132$var$SSR_PREFIX = 'ssr';
const $f27813f03221d132$var$mapKey = (key)=>{
    if (key === 'total') return $f27813f03221d132$var$SSR_PREFIX;
    return `${$f27813f03221d132$var$SSR_PREFIX}${$f27813f03221d132$var$NESTED_METRIC_SEPARATOR}${key}`;
};
let $f27813f03221d132$var$config;
function $f27813f03221d132$export$8d21e34596265fa2(ssrConfig) {
    $f27813f03221d132$var$config = ssrConfig;
}
function $f27813f03221d132$export$bf7408e83532dcd0() {
    if (!$f27813f03221d132$var$config?.getTimings) return {};
    const timings = $f27813f03221d132$var$config.getTimings();
    if (!timings) return {};
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($f27813f03221d132$var$filterEntry(entry[1])) acc[$f27813f03221d132$var$mapKey(entry[0])] = $f27813f03221d132$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $f27813f03221d132$export$c7ad864055e75537() {
    return !!$f27813f03221d132$var$config?.getDoneMark();
}
function $f27813f03221d132$export$3def7672244bab0c() {
    return $f27813f03221d132$var$config?.getDoneMark() ?? undefined;
}
function $f27813f03221d132$export$1c4a9b5e6e22393d() {
    if (!$f27813f03221d132$var$config?.getFeatureFlags) return undefined;
    try {
        return $f27813f03221d132$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch (e) {}
    return undefined;
}

});

parcelRegister("aZWa4", function(module, exports) {

$parcel$export(module.exports, "retrieveAndSetPageLoadTrace", () => $b515f2bc55199ff5$export$1a71d2bbe236de99);

var $7xBz2 = parcelRequire("7xBz2");
let $b515f2bc55199ff5$var$alreadySet = false;
const $b515f2bc55199ff5$export$1a71d2bbe236de99 = (getMeta)=>{
    if (false || $b515f2bc55199ff5$var$alreadySet) return;
    const traceId = getMeta('X-B3-TraceId') || '';
    const spanId = traceId?.substring(traceId.length - 16) || ''; // set root span ID by convention
    $b515f2bc55199ff5$var$alreadySet = true;
    (0, $7xBz2.setActiveTrace)(traceId, spanId, 'page_load');
};

});

parcelRegister("3dQJA", function(module, exports) {

$parcel$export(module.exports, "getJiraCustomData", () => $f5569bfee184b069$export$abf5e20822fa925);

var $5uXOq = parcelRequire("5uXOq");

var $j8DrX = parcelRequire("j8DrX");

var $3HwlS = parcelRequire("3HwlS");

var $sUexw = parcelRequire("sUexw");

var $5YDBW = parcelRequire("5YDBW");

var $5uZVJ = parcelRequire("5uZVJ");

var $eV38z = parcelRequire("eV38z");

var $jgkaQ = parcelRequire("jgkaQ");

var $9NJeU = parcelRequire("9NJeU");

var $3Itig = parcelRequire("3Itig");

var $6R03U = parcelRequire("6R03U");

var $bo7zb = parcelRequire("bo7zb");

var $ax2PR = parcelRequire("ax2PR");

var $4xsv9 = parcelRequire("4xsv9");

function $f5569bfee184b069$export$abf5e20822fa925(interaction) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let customData = {};
    const shard = (0, $j8DrX.default)('ajs-shard');
    if (shard !== null && shard !== '') customData.shard = shard;
    customData['network:assetEncoding'] = (0, $sUexw.getAssetEncoding)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const buildVariant = window.BUILD_VARIANT;
    if (buildVariant) customData['app:buildVariant'] = buildVariant;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const bundlerVersion = window.BUNDLER_VERSION;
    if (bundlerVersion) customData['app:bundlerVersion'] = bundlerVersion;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const useBifrostGateway = window.USE_BIFROST_GATEWAY;
    if (useBifrostGateway) customData['app:useBifrostGateway'] = useBifrostGateway;
    customData.navType = (0, $3HwlS.getWillShowNav4)() ? 'nav4' : 'nav3';
    customData.httpProtocol = performance.getEntriesByType('resource')// @ts-expect-error - TS2339  - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'. | TS2339 - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'.
    .find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)?.nextHopProtocol ?? 'unknown';
    const { start: start, end: end, apdex: apdex } = interaction;
    const stop = apdex?.[0]?.stopTime ?? end;
    customData.memory = (0, $9NJeU.getMemoryUsageReport)({
        start: start,
        stop: stop
    });
    const lightHouseMetrics = (0, $eV38z.getLighthouseMetrics)({
        start: start,
        stop: stop
    });
    customData = {
        ...customData,
        ...lightHouseMetrics
    };
    if (interaction.type === 'page_load') customData = {
        ...customData,
        ...(0, $jgkaQ.getMarks)({
            start: start
        }),
        ...(0, $3Itig.getPageSizeMetrics)(),
        ...(0, $3Itig.getExtraNavigationTimings)(),
        ...(0, $bo7zb.getServerDurationMetrics)(),
        ...(0, $6R03U.getRouterResourceMetrics)(),
        ...(0, $4xsv9.getWRMStats)(),
        ...(0, $3Itig.getPageSizeInfo)({
            start: start,
            stop: stop
        }),
        ...(0, $5YDBW.getCacheHitRatio)({
            start: start
        }),
        ...(0, $5uZVJ.getCHRInfo)({
            start: start
        }),
        ...(0, $ax2PR.getSSRStateInformation)(),
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        'app:version:web': window.BUILD_KEY,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        'app:version:ssr': window.SSR_BUILD_KEY,
        'app:framework:name': 'react',
        'app:framework:version': (0, $5uXOq.version)
    };
    return customData;
}

});
parcelRegister("sUexw", function(module, exports) {

$parcel$export(module.exports, "getAssetEncoding", () => $7cf3b2ddfe1abab1$export$fd12d8f45e126585);
function $7cf3b2ddfe1abab1$export$fd12d8f45e126585() {
    const assetEncodings = Array.prototype.map// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    .call(document.querySelectorAll('script[data-encoding], link[data-encoding]'), (i)=>i.getAttribute('data-encoding')) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, i)=>{
        // @ts-expect-error - TS2538 - Type 'unknown' cannot be used as an index type.
        acc[i] = true;
        return acc;
    }, {});
    const uniqueEncodings = Object.keys(assetEncodings).sort();
    let result = 'unknown';
    if (uniqueEncodings.length === 1) [result] = uniqueEncodings;
    if (uniqueEncodings.length > 1) result = `mixed: ${uniqueEncodings.toString()}`;
    return result;
}

});

parcelRegister("5YDBW", function(module, exports) {

$parcel$export(module.exports, "getCacheHitRatio", () => $62c0824bd7614469$export$e8a9322c3d9da8a6);

var $6RCeq = parcelRequire("6RCeq");
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $62c0824bd7614469$var$cacheableTypes = [
    'script',
    'link'
];
const $62c0824bd7614469$var$CACHE_NETWORK = 'network';
const $62c0824bd7614469$var$CACHE_MEMORY = 'memory';
const $62c0824bd7614469$var$CACHE_DISK = 'disk';
const $62c0824bd7614469$var$calculateTransferType = (type, duration, size)=>{
    if (!$62c0824bd7614469$var$cacheableTypes.includes(type)) return $62c0824bd7614469$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $62c0824bd7614469$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $62c0824bd7614469$var$CACHE_DISK;
    if (size === undefined) return null;
    return $62c0824bd7614469$var$CACHE_NETWORK;
};
const $62c0824bd7614469$export$e8a9322c3d9da8a6 = ({ start: start })=>{
    let fromCache = 0;
    let preloadFromCache = 0;
    let total = 0;
    let totalPreload = 0;
    // initial load only
    if (start !== 0) return {};
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $6RCeq.default).getEntriesByType('resource')){
            // The BM3 resource timing collector checks for whether the timing information is available,
            // but we can make the assumption that it is for this Jira specific collector.
            const transferType = $62c0824bd7614469$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
            const isPreload = entry.initiatorType === 'link';
            if (transferType === 'disk' || transferType === 'memory') {
                fromCache += 1;
                if (isPreload) preloadFromCache += 1;
            }
            if (transferType !== null) {
                total += 1;
                if (isPreload) totalPreload += 1;
            }
        }
        const result = {};
        if (total > 0) result.cacheHitRatio = fromCache / total;
        if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
        return result;
    } catch (e) {
        return {};
    }
};

});

parcelRegister("5uZVJ", function(module, exports) {

$parcel$export(module.exports, "getCHRInfo", () => $e76f22784dfe18ae$export$9e005e111be93521);

var $x9xyg = parcelRequire("x9xyg");

var $6RCeq = parcelRequire("6RCeq");

var $d1SfZ = parcelRequire("d1SfZ");
const $e76f22784dfe18ae$var$SPA_SSR_RENDERED = 'ssr.spa.rendered';
const $e76f22784dfe18ae$export$1faf7d001841a41c = ()=>(0, $x9xyg.getMark)($e76f22784dfe18ae$var$SPA_SSR_RENDERED)?.startTime || null;
const $e76f22784dfe18ae$export$9e005e111be93521 = ({ start: start })=>{
    // initial load only
    if (start !== 0) return {};
    const ssrMark = $e76f22784dfe18ae$export$1faf7d001841a41c();
    const reporter = new (0, $d1SfZ.CHRReporter)(ssrMark);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $6RCeq.default).getEntriesByType('resource'))reporter.add(entry);
        const chr = reporter.get();
        return chr === null ? {} : {
            chr: chr
        };
    } catch (e) {
        return {};
    }
};

});
parcelRegister("d1SfZ", function(module, exports) {

$parcel$export(module.exports, "CHRReporter", () => $850475b27a81c50e$export$7d0d4cfb6455ffa5);

var $4R6GH = parcelRequire("4R6GH");

var $d1r8j = parcelRequire("d1r8j");
class $850475b27a81c50e$export$7d0d4cfb6455ffa5 {
    constructor(ssrMark){
        this.preloaded = new (0, $d1r8j.CHRSummary)();
        this.all = new (0, $d1r8j.CHRSummary)();
        this.ssrMark = null;
        this.ssrMark = ssrMark;
    }
    isPreloaded(item) {
        const isPreloadedByLink = item.initiatorType === 'link';
        const isPreloadedByPreloadModule = item.initiatorType === 'other' && item.name?.endsWith('.js') && (0, $4R6GH.fg)('ufo_support_other_resource_type_js');
        const isBeforeSSR = this.ssrMark === null || item.startTime < this.ssrMark;
        return (isPreloadedByLink || isPreloadedByPreloadModule) && isBeforeSSR;
    }
    add(item) {
        if (item.encodedBodySize === 0) return;
        if (this.isPreloaded(item)) this.preloaded.add(item);
        this.all.add(item);
    }
    static round(n) {
        return Math.round(n * 10000) / 10000;
    }
    makePayload(summary) {
        const bundlesLoadType = {
            mem: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $d1r8j.CHRSummary).MEMORY_KEY] / summary.bundlesCount),
            disk: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $d1r8j.CHRSummary).DISK_KEY] / summary.bundlesCount),
            net: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $d1r8j.CHRSummary).NETWORK_KEY] / summary.bundlesCount)
        };
        const bundlesRatio = $850475b27a81c50e$export$7d0d4cfb6455ffa5.round((summary.bundles[(0, $d1r8j.CHRSummary).MEMORY_KEY] + summary.bundles[(0, $d1r8j.CHRSummary).DISK_KEY]) / summary.bundlesCount);
        const sizeLoadType = {
            mem: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.size[(0, $d1r8j.CHRSummary).MEMORY_KEY] / summary.sizeTotal),
            disk: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.size[(0, $d1r8j.CHRSummary).DISK_KEY] / summary.sizeTotal),
            net: $850475b27a81c50e$export$7d0d4cfb6455ffa5.round(summary.size[(0, $d1r8j.CHRSummary).NETWORK_KEY] / summary.sizeTotal)
        };
        const sizeRatio = $850475b27a81c50e$export$7d0d4cfb6455ffa5.round((summary.size[(0, $d1r8j.CHRSummary).MEMORY_KEY] + summary.size[(0, $d1r8j.CHRSummary).DISK_KEY]) / summary.sizeTotal);
        return {
            bundles: {
                ratio: bundlesRatio,
                count: summary.bundlesCount,
                loadType: bundlesLoadType
            },
            size: {
                ratio: sizeRatio,
                total: summary.sizeTotal,
                loadType: sizeLoadType
            }
        };
    }
    get() {
        if (this.all.bundlesCount === 0) return null;
        return {
            preloaded: this.makePayload(this.preloaded),
            all: this.makePayload(this.all)
        };
    }
}

});
parcelRegister("d1r8j", function(module, exports) {

$parcel$export(module.exports, "CHRSummary", () => $d000becd84478ee1$export$783d6618ee601ba);

var $4R6GH = parcelRequire("4R6GH");

var $80WiQ = parcelRequire("80WiQ");
const $d000becd84478ee1$var$calculateTransferType = (name, type, duration, size)=>{
    if ((0, $4R6GH.fg)('ufo_support_other_resource_type_js')) {
        if (!(0, $80WiQ.cacheableTypes).includes(type) && !(type === 'other' && name.includes('.js'))) return null;
    } else if (!(0, $80WiQ.cacheableTypes).includes(type)) return null;
    if ((size === undefined || size === 0) && duration === 0) return $d000becd84478ee1$export$783d6618ee601ba.MEMORY_KEY;
    if (size === 0 && duration > 0) return $d000becd84478ee1$export$783d6618ee601ba.DISK_KEY;
    if (size === undefined) return null;
    return $d000becd84478ee1$export$783d6618ee601ba.NETWORK_KEY;
};
class $d000becd84478ee1$export$783d6618ee601ba {
    static{
        this.MEMORY_KEY = 'mem';
    }
    static{
        this.DISK_KEY = 'disk';
    }
    static{
        this.NETWORK_KEY = 'net';
    }
    add(item) {
        const type = $d000becd84478ee1$var$calculateTransferType(item.name, item.initiatorType, item.duration, item.transferSize);
        if (type === null) return;
        this.bundles[type] += 1;
        this.bundlesCount += 1;
        this.size[type] += item.encodedBodySize;
        this.sizeTotal += item.encodedBodySize;
    }
    constructor(){
        this.bundles = {
            [$d000becd84478ee1$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$d000becd84478ee1$export$783d6618ee601ba.DISK_KEY]: 0,
            [$d000becd84478ee1$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.bundlesCount = 0;
        this.size = {
            [$d000becd84478ee1$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$d000becd84478ee1$export$783d6618ee601ba.DISK_KEY]: 0,
            [$d000becd84478ee1$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.sizeTotal = 0;
    }
}

});
parcelRegister("80WiQ", function(module, exports) {

$parcel$export(module.exports, "cacheableTypes", () => $0b57baf495baebc5$export$5e1aa91d6932ddaa);
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $0b57baf495baebc5$export$5e1aa91d6932ddaa = [
    'script',
    'link'
];

});




parcelRegister("eV38z", function(module, exports) {

$parcel$export(module.exports, "getLighthouseMetrics", () => $45336243ca9d66b9$export$b46cecdf698e4bb5);

var $akIBh = parcelRequire("akIBh");

var $5HXkx = parcelRequire("5HXkx");

var $7hESW = parcelRequire("7hESW");

var $aOwtG = parcelRequire("aOwtG");

var $8YqT3 = parcelRequire("8YqT3");
function $45336243ca9d66b9$export$5ecf2aafafee3e0() {
    (0, $8YqT3.startLSObserver)();
    (0, $8YqT3.startLTObserver)();
}
const $45336243ca9d66b9$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
    const tbt = (0, $7hESW.getTBT)(start, stop, (0, $aOwtG.EntriesBuffer)[(0, $5HXkx.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $akIBh.getCLS)(start, stop, (0, $aOwtG.EntriesBuffer)[(0, $5HXkx.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
};

});
parcelRegister("akIBh", function(module, exports) {

$parcel$export(module.exports, "getCLS", () => $b182c515ac203eb1$export$fc6227831ee7c7);
const $b182c515ac203eb1$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("5HXkx", function(module, exports) {

$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $b2a196da23758bb0$export$a4def92db6fc8e17);
const $b2a196da23758bb0$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("7hESW", function(module, exports) {

$parcel$export(module.exports, "getTBT", () => $e79996724decdf66$export$2d6e933b35bd3407);
const $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $e79996724decdf66$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $e79996724decdf66$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });

});

parcelRegister("aOwtG", function(module, exports) {

$parcel$export(module.exports, "EntriesBuffer", () => $14dd3fd4391f2796$export$f7dc16cbd16f7bbe);

var $5HXkx = parcelRequire("5HXkx");
class $14dd3fd4391f2796$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $14dd3fd4391f2796$export$f7dc16cbd16f7bbe = {
    [(0, $5HXkx.PerformanceObserverEntryTypes).LongTask]: new $14dd3fd4391f2796$export$2c6e86519c9e8188(),
    [(0, $5HXkx.PerformanceObserverEntryTypes).LayoutShift]: new $14dd3fd4391f2796$export$2c6e86519c9e8188()
};

});

parcelRegister("8YqT3", function(module, exports) {

$parcel$export(module.exports, "startLSObserver", () => $f3198686c7919898$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $f3198686c7919898$export$54fb8b6aaf70ec9c);

var $5HXkx = parcelRequire("5HXkx");

var $aOwtG = parcelRequire("aOwtG");
let $f3198686c7919898$var$pe = null;
const $f3198686c7919898$var$getObserver = ()=>{
    if ($f3198686c7919898$var$pe !== null) return $f3198686c7919898$var$pe;
    $f3198686c7919898$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $5HXkx.PerformanceObserverEntryTypes).LayoutShift) (0, $aOwtG.EntriesBuffer)[(0, $5HXkx.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $5HXkx.PerformanceObserverEntryTypes).LongTask) (0, $aOwtG.EntriesBuffer)[(0, $5HXkx.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    });
    return $f3198686c7919898$var$pe;
};
const $f3198686c7919898$export$768ccc3ab7bac3ea = ()=>{
    $f3198686c7919898$var$getObserver().observe({
        type: (0, $5HXkx.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
const $f3198686c7919898$export$54fb8b6aaf70ec9c = ()=>{
    $f3198686c7919898$var$getObserver().observe({
        type: (0, $5HXkx.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});


parcelRegister("jgkaQ", function(module, exports) {

$parcel$export(module.exports, "getMarks", () => $0fe8913ad7f2f853$export$9d952633c9c2237b);

var $bobSR = parcelRequire("bobSR");

var $fDtbf = parcelRequire("fDtbf");
const $0fe8913ad7f2f853$export$9d952633c9c2237b = (data)=>{
    const userTiming = (0, $bobSR.getUserTiming)();
    if (userTiming === null) return null;
    const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
    // @ts-expect-error - TS7031 - Binding element 'baseName' implicitly has an 'any' type. | TS7031 - Binding element 'collection' implicitly has an 'any' type.
    const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
        let candidateName = baseName;
        // If <name> is taken, we'll try <name>_2 and increment from there
        let counter = 2;
        let validName;
        while(!validName)if (candidateName in collection) {
            candidateName = `${baseName}_${counter}`;
            counter += 1;
        } else validName = candidateName;
        return validName;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const marks = {};
    // Excludes mark starting with '_'. This allows marks to opt-out from the report.
    userTiming.filter(// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    (item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith((0, $fDtbf.JS_EVAL_START)) && !item.name.endsWith((0, $fDtbf.JS_EVAL_STOP)) && item.startTime >= data.start)// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    .forEach((item)=>{
        const name = getNextAvailableName({
            baseName: `mark__${sanitizeName(item.name)}`,
            collection: marks
        });
        marks[name] = Math.round(item.startTime - data.start);
    });
    return marks;
};

});

parcelRegister("9NJeU", function(module, exports) {

$parcel$export(module.exports, "getMemoryUsageReport", () => $8fa3790b95082ce5$export$e5bd2d61c7c80651);
/**
 * Memory usage report.
 *
 * In the future may be extended to contain `performance.measureUserAgentSpecificMemory` if Jira
 * front-end uses cross-origin isolation.
 */ const $8fa3790b95082ce5$export$e5bd2d61c7c80651 = ({ start: start, stop: stop })=>{
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    if (typeof performance === 'undefined' || performance?.memory == null) return null;
    const sessionTime = Math.round(stop - start);
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = performance.memory;
    return {
        sessionTime: sessionTime,
        performanceMemoryEntry: {
            jsHeapSizeLimit: jsHeapSizeLimit,
            totalJSHeapSize: totalJSHeapSize,
            usedJSHeapSize: usedJSHeapSize
        }
    };
};

});

parcelRegister("3Itig", function(module, exports) {

$parcel$export(module.exports, "getPageSizeMetrics", () => $d593ead38e6ee650$export$84e3d676f1564c75);
$parcel$export(module.exports, "getExtraNavigationTimings", () => $d593ead38e6ee650$export$b37a70af06e58097);
$parcel$export(module.exports, "getPageSizeInfo", () => $d593ead38e6ee650$export$b72e035af6568be7);

var $6RCeq = parcelRequire("6RCeq");
const $d593ead38e6ee650$export$84e3d676f1564c75 = ()=>{
    let maxDepth = -1;
    let maxWidth = -1;
    let numElements = 0;
    // As described in the lighthouse DOM audit - https://web.dev/dom-size/
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
        if (!el) return;
        if (depth > maxDepth) maxDepth = depth;
        if (el.children.length > maxWidth) maxWidth = el.children.length;
        let child = el.firstElementChild;
        while(child){
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child, depth + 1);
            // If element has shadow dom, traverse into that tree.
            if (child.shadowRoot) // @ts-expect-error - TS2345 - Argument of type 'ShadowRoot' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
            child = child.nextElementSibling;
            numElements += 1;
        }
    };
    calculateDOMsizeAndDepth();
    return {
        totalBodyElements: numElements,
        maxNestedLevels: maxDepth,
        maxChildElements: maxWidth
    };
};
const $d593ead38e6ee650$export$b37a70af06e58097 = ()=>{
    if (!(0, $6RCeq.default)) return {};
    const navigation = (0, $6RCeq.default).getEntriesByType('navigation')[0];
    if (!navigation) return {};
    return {
        // From https://www.w3.org/TR/navigation-timing-2/
        // @ts-expect-error - TS2339 - Property 'decodedBodySize' does not exist on type 'PerformanceEntry'.
        decodedBodySize: navigation.decodedBodySize,
        // @ts-expect-error - TS2339 - Property 'encodedBodySize' does not exist on type 'PerformanceEntry'.
        encodedBodySize: navigation.encodedBodySize,
        // @ts-expect-error - TS2339 - Property 'transferSize' does not exist on type 'PerformanceEntry'.
        transferSize: navigation.transferSize
    };
};
const $d593ead38e6ee650$var$assetsTypes = [
    'script',
    'link'
];
const $d593ead38e6ee650$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
    const pageSize = $d593ead38e6ee650$export$b37a70af06e58097();
    if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
    const decoded = {
        total: pageSize.decodedBodySize,
        pageSize: pageSize.decodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const encoded = {
        total: pageSize.encodedBodySize,
        pageSize: pageSize.encodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const net = {
        total: pageSize.transferSize,
        assets: 0,
        endpoints: 0
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    for (const entry of (0, $6RCeq.default).getEntriesByType('resource')){
        if (entry.startTime > stop) continue;
        if ($d593ead38e6ee650$var$assetsTypes.includes(entry.initiatorType)) {
            decoded.total += entry.decodedBodySize;
            decoded.assets += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.assets += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.assets += entry.transferSize;
        } else {
            decoded.total += entry.decodedBodySize;
            decoded.endpoints += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.endpoints += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.endpoints += entry.transferSize;
        }
    }
    const returnValue = {};
    Object.keys(decoded).forEach((key)=>{
        returnValue[`size:decoded:${key}`] = decoded[key];
    });
    Object.keys(encoded).forEach((key)=>{
        returnValue[`size:encoded:${key}`] = encoded[key];
    });
    Object.keys(net).forEach((key)=>{
        returnValue[`size:net:${key}`] = net[key];
    });
    return returnValue;
};

});

parcelRegister("6R03U", function(module, exports) {

$parcel$export(module.exports, "getRouterResourceMetrics", () => $7077665729c4125c$export$e703af446a67c7f4);
const $7077665729c4125c$export$e703af446a67c7f4 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const ssrRouterResourceTimeouts = window.SPA_STATE ? Object.keys(window.SPA_STATE).filter((key)=>{
        if (key !== key.toUpperCase()) return false;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resource = window.SPA_STATE[key];
        if (typeof resource !== 'object') return false;
        const resourceResponse = resource[Object.keys(resource)[0]];
        return resourceResponse?.error?.name === 'TimeoutError';
    }) : [];
    return {
        ssrRouterResourceTimeouts: ssrRouterResourceTimeouts
    };
};

});

parcelRegister("bo7zb", function(module, exports) {

$parcel$export(module.exports, "getServerDurationMetrics", () => $c797c35a7f1d14f1$export$efd8b60b870e5282);
const $c797c35a7f1d14f1$export$efd8b60b870e5282 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const metrics = {};
    try {
        // server duration metric is buried in a hidden form near end of </body>
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverDurationElem = document.querySelector('#jira_request_timing_info [title="jira.request.server.time"]');
        if (serverDurationElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverDuration = Number(serverDurationElem.value);
            if (serverDuration > 0) metrics.serverDuration = Math.round(serverDuration);
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceIdElem = document.querySelector('#jira_request_timing_info [title="jira.request.trace.id"]');
        if (serverTraceIdElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceId = serverTraceIdElem.value;
            metrics.serverRequestTraceId = serverRequestTraceId;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceSampledElem = document.querySelector('#jira_request_timing_info [title="jira.request.sampled"]');
        if (serverTraceSampledElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceSampled = serverTraceSampledElem.value;
            switch(serverRequestTraceSampled){
                case 'true':
                    metrics.serverRequestTraceSampled = true;
                    break;
                case 'false':
                    metrics.serverRequestTraceSampled = false;
                    break;
                default:
                    metrics.serverRequestTraceSampled = null;
                    break;
            }
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const concurrentRequestsElem = document.querySelector('#jira_request_timing_info [name="jira.request.concurrent.requests"]');
        if (concurrentRequestsElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const concurrentRequests = concurrentRequestsElem.value;
            metrics.concurrentRequests = concurrentRequests;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverRequestStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.start.millis"]');
        if (serverRequestStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestStartTime = serverRequestStartTimeElem.value;
            metrics.serverRequestStartTime = serverRequestStartTime;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const frontendFlushStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.frontend.flush.start"]');
        if (frontendFlushStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const frontendFlushStartTime = frontendFlushStartTimeElem.value;
            metrics.frontendFlushStartTime = frontendFlushStartTime;
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ignored) {
    /* noop */ }
    return metrics;
};

});

parcelRegister("ax2PR", function(module, exports) {

$parcel$export(module.exports, "getSSRStateInformation", () => $cefad605288b959d$export$9a46186893ad76bd);

var $x9xyg = parcelRequire("x9xyg");
const $cefad605288b959d$var$getState = ()=>{
    if ((0, $x9xyg.getMark)('ssr.spa.state')?.startTime) return 'success';
    if ((0, $x9xyg.getMark)('ssr.spa.early-common-flush:end')?.startTime) return 'spa-render-failure';
    return 'static-fallback';
};
const $cefad605288b959d$export$9a46186893ad76bd = ()=>{
    return {
        'ssr:state': $cefad605288b959d$var$getState()
    };
};

});

parcelRegister("4xsv9", function(module, exports) {

$parcel$export(module.exports, "getWRMStats", () => $a91d766509875677$export$d2d916ddd03b82bc);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a91d766509875677$export$d2d916ddd03b82bc = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};
    return {
        wrmStats: wrmStats
    };
};

});


parcelRegister("fJbQ9", function(module, exports) {

$parcel$export(module.exports, "jiraBundleEvalTimingsConfig", () => $f9b1cc066b55fe02$export$791b8c0cbd574ea9);

var $fDtbf = parcelRequire("fDtbf");
const $f9b1cc066b55fe02$export$791b8c0cbd574ea9 = {
    mapPerformanceMark: (mark)=>{
        if (mark.endsWith((0, $fDtbf.JS_EVAL_START))) return {
            name: mark.substring(0, mark.indexOf((0, $fDtbf.JS_EVAL_START))),
            type: 'start'
        };
        if (mark.endsWith((0, $fDtbf.JS_EVAL_STOP))) return {
            name: mark.substring(0, mark.indexOf((0, $fDtbf.JS_EVAL_STOP))),
            type: 'end'
        };
        return null;
    }
};

});

parcelRegister("itoGf", function(module, exports) {

$parcel$export(module.exports, "jiraResourceTimingsConfig", () => $be8f5f0d3efbf58f$export$8fa71550bcdc2104);

var $aZsz6 = parcelRequire("aZsz6");

var $6pIol = parcelRequire("6pIol");
const $be8f5f0d3efbf58f$var$isWRMResource = (url)=>url.includes('/batch.js') || url.includes('/batch.css');
const $be8f5f0d3efbf58f$var$getWRMAssetName = (url)=>{
    const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
    const assetName = (0, $6pIol.sanitiseAssetName)(false)(url);
    if (!resources) return assetName;
    return `wrm/${resources}/${assetName}`;
};
const $be8f5f0d3efbf58f$var$getFileName = (url)=>$be8f5f0d3efbf58f$var$isWRMResource(url) ? $be8f5f0d3efbf58f$var$getWRMAssetName(url) : (0, $6pIol.sanitiseAssetName)(false)(url);
const $be8f5f0d3efbf58f$var$sanitiseEndpoints = (url)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(url, true);
    /**
	 * For endpoints with operation or operationName queryParam we will shorten the url
	 * as ufo pipeline will only get the `operation` query param for aggregation
	 */ const { operation: operation, operationName: operationName } = parsedUrl.query;
    const operationNameOverride = operation ?? operationName;
    if (operationNameOverride) return `/${operation}?operation=${operation}`;
    const fileName = parsedUrl.pathname.replace(/\/(project|agent)(-config|s)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(servicedesk)(-data)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(browse|automation|pagination|permissions|async|dialog|itsm)\/([A-Z0-9]+)/g, '/$1/<project-key>').replace(/\/(board)(s)?\/([0-9]+)/g, '/$1$2/<board-id>').replace(/\/(\w+)-(\d+)\//i, '/<issue-key>/').replace(/\/pq\/[a-fA-F0-9]+/i, '/pq/<id>') // persisted queries
    .replace(/\/user\/[a-fA-F0-9\-:]+/i, '/user/<user-id>') // engage targeting
    .replace(/[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/i, '<uuid>').replace(/\/\d+$/i, '/<id>');
    return fileName;
};
const $be8f5f0d3efbf58f$export$8fa71550bcdc2104 = {
    sanitiseEndpoints: $be8f5f0d3efbf58f$var$sanitiseEndpoints,
    mapResources: $be8f5f0d3efbf58f$var$getFileName,
    hasTimingHeaders: (url)=>url.includes('jira-frontend-static') || url.includes('jira-frontend-branch') || url.includes('jira-frontend-bifrost') || $be8f5f0d3efbf58f$var$isWRMResource(url),
    // @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type.
    xhrFilter: (url)=>url.includes('/rest/greenhopper/')
};

});

parcelRegister("dQKfU", function(module, exports) {

$parcel$export(module.exports, "jiraSsrConfig", () => $ba8cdb329bff9946$export$7bcf91e323db67dd);

var $LpImS = parcelRequire("LpImS");

var $x9xyg = parcelRequire("x9xyg");

var $6RCeq = parcelRequire("6RCeq");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

/** given a timings object, add a timer that starts at the earliest start time and ends at the latest end time */ function $ba8cdb329bff9946$var$insertTotalTiming(/**
	 * key of the total timing that will be inserted to the given timings object
	 */ key, timings) {
    const timingValues = timings && Object.values(timings);
    if (!timingValues || !timingValues.length) return timings;
    const startTime = Math.min(...timingValues.map(({ startTime: startTime })=>startTime));
    const endTime = timingValues.reduce((max, { startTime: startTime, duration: duration })=>Math.max(max, startTime + duration), 0);
    const duration = endTime - startTime;
    // eslint-disable-next-line no-param-reassign
    timings[key] = {
        startTime: startTime,
        duration: duration
    };
    return timings;
}
/**
 * Apply key and startTimOffset overrides to a timings object
 */ function $ba8cdb329bff9946$var$applyTimingOverrides(timings, { startTimeOffsetMs: startTimeOffsetMs = 0, prefix: prefix = '' } = {}) {
    return timings && Object.fromEntries(Object.entries(timings).map(([key, value])=>{
        const startTime = value.startTime + startTimeOffsetMs;
        return [
            [
                prefix,
                key
            ].filter(Boolean).join('/'),
            {
                ...value,
                startTime: startTime
            }
        ];
    }));
}
function $ba8cdb329bff9946$var$getTesseractTimings() {
    if (!globalThis.SPA_STATE) return null;
    const detailRenderTrace = globalThis.SPA_STATE['ssr/detail_render_trace'];
    const detailRequestTrace = globalThis.SPA_STATE['ssr/detail_request_trace'];
    const highLevelMetrics = globalThis.SPA_STATE['ssr/metrics'];
    const timings = (0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(detailRenderTrace?.data?.traces) || {};
    if (highLevelMetrics?.data) {
        if ('ssrTotal' in highLevelMetrics.data) {
            // empty string to represent the total time for these timings, applyTimingOverrides will add the relevant namespace later
            const totalKey = (0, $4R6GH.fg)('jira-ssr-update-perf-portal-timings') ? '' : 'total'; // total is a special key that is no longer treated special when jira-ssr-update-perf-portal-timings is enabled
            timings[totalKey] = {
                startTime: 0,
                duration: highLevelMetrics.data.ssrTotal
            };
        }
        if ('ssrGetStyle' in highLevelMetrics.data) timings.styles = {
            startTime: highLevelMetrics.data.ssrGetStyle - highLevelMetrics.data.ssrGetStyle,
            duration: highLevelMetrics.data.ssrGetStyle
        };
        if ('ssrPrefetch' in highLevelMetrics.data) {
            const prefetchStartTime = Object.values(((0, $4R6GH.fg)('jira-ssr-perf-portal-cleanup') ? detailRequestTrace?.data : detailRenderTrace?.data?.traces) || {}).reduce((min, { startTime: startTime })=>min === -1 || min > startTime ? startTime : min, -1);
            timings.prefetch = {
                startTime: prefetchStartTime,
                duration: highLevelMetrics.data.ssrPrefetch
            };
        }
    }
    if (detailRequestTrace?.data) Object.entries(detailRequestTrace.data).forEach(([key, value])=>{
        timings[`prefetch/${key}`] = value;
    });
    if (!(0, $4R6GH.fg)('jira-ssr-update-perf-portal-timings')) return timings;
    return $ba8cdb329bff9946$var$insertTotalTiming('', timings); // while there is already a 'ssrTotal', it seems to exclude some timings, so we'll take the end to end as the actual total time
}
// add early-flush/ prefix to timing keys which are early flush timings
const $ba8cdb329bff9946$var$jiraFeGatewayEarlyFlushKeys = new Set([
    'metatags',
    'feature-flags',
    'statsig',
    'inline-assets',
    'async-inline-assets',
    'css-assets',
    'priority-assets',
    'early-route-flush'
]);
// and filter out these keys since they are not UFO visualisation friendly
const $ba8cdb329bff9946$var$jiraFeGatewayFilteredKeys = [
    'early-common-flush',
    'prerender-total',
    'resolve-assets'
];
function $ba8cdb329bff9946$var$getJiraFeGatewayTimings() {
    const rawTimings = globalThis._JFGTimings;
    if (!rawTimings) return null;
    const jiraFeGatewayTimings = Object.fromEntries(rawTimings.filter(({ name: name })=>!$ba8cdb329bff9946$var$jiraFeGatewayFilteredKeys.includes(name)).map(({ startTime: startTime, duration: duration, name: name })=>[
            $ba8cdb329bff9946$var$jiraFeGatewayEarlyFlushKeys.has(name) ? `early-flush/${name}` : name,
            {
                startTime: startTime,
                duration: duration
            }
        ]));
    return $ba8cdb329bff9946$var$insertTotalTiming(// there's no end to end timer so we calculate one
    '', jiraFeGatewayTimings);
}
function $ba8cdb329bff9946$var$getLegacyMonolithTimingDuration(timingMetricKey) {
    /* eslint-disable-next-line @typescript-eslint/consistent-type-assertions */ const inputElementWithTimingValue = globalThis.document?.querySelector(`#jira_request_timing_info [title="${timingMetricKey}"]`);
    return Number(inputElementWithTimingValue?.value ?? 0);
}
function $ba8cdb329bff9946$var$getLegacyJiraMonolithTimings() {
    const duration = $ba8cdb329bff9946$var$getLegacyMonolithTimingDuration('jira.request.server.time');
    if (!duration) // if we don't have this, fallback to no jira timings, we might be going through bifrost instead
    return null;
    const timings = {
        // empty string to represent the total time for these timings, applyTimingOverrides will add the relevant namespace later
        '': {
            startTime: 0,
            duration: duration
        },
        'flush-head': {
            startTime: 0,
            duration: $ba8cdb329bff9946$var$getLegacyMonolithTimingDuration('jira.request.server.head.time')
        }
    };
    return timings;
}
const $ba8cdb329bff9946$var$monolithTimerRenames = {
    'jira-request-server-time': ''
};
function $ba8cdb329bff9946$var$getJiraMonolithTimings() {
    if (!globalThis._monolithTimings) return $ba8cdb329bff9946$var$getLegacyJiraMonolithTimings();
    return Object.fromEntries(Object.entries(globalThis._monolithTimings).map(([name, { start: startTime, duration: duration }])=>[
            $ba8cdb329bff9946$var$monolithTimerRenames[name] ?? name,
            {
                startTime: startTime,
                duration: duration
            }
        ]));
}
function $ba8cdb329bff9946$var$getBifrostGatewayTimings(jiraBeTimings, tesseractTimings) {
    // this is a placeholder function, we don't get any real bifrost timings yet
    // in the meantime, let's set a placeholder only if we have no monolith timings and some tesseract timings
    if (jiraBeTimings || !tesseractTimings) return null;
    const timings = {
        // empty string to represent the total time for these timings, applyTimingOverrides will add the relevant namespace later
        '': {
            startTime: 0,
            duration: tesseractTimings['']?.duration
        }
    };
    return timings;
}
/**
 * Get the offset required to align the ending of the timerToShift with the ending of the referenceTimer
 * But if the referenceTimer is smaller than the timerToShift (it shouldn't be, this is for timerToShifts that in practice are triggered within the reference timer)
 * then at least align the start times
 */ function $ba8cdb329bff9946$var$getOffsetToAlignTimers(referenceTimer, timerToShift) {
    if (!referenceTimer || !timerToShift) return null;
    if (referenceTimer.duration >= timerToShift.duration) return referenceTimer.startTime + referenceTimer.duration - (timerToShift.startTime + timerToShift.duration);
    else return referenceTimer.startTime - timerToShift.startTime;
}
function $ba8cdb329bff9946$var$getJfgOffset({ jiraFeGatewayTimings: jiraFeGatewayTimings, jiraBeTimings: jiraBeTimings }) {
    // Push back the start of jfg so it's ending aligns with either the full monolith time or if we have the more specific timer for fetching jfg, use that
    const jiraBeTiming = jiraBeTimings?.['jira-monolith/feGateway'] ?? jiraBeTimings?.['jira-monolith'];
    return $ba8cdb329bff9946$var$getOffsetToAlignTimers(jiraBeTiming, jiraFeGatewayTimings?.['']) ?? 0;
}
/**
 * Get the offset required to align the ending of the tesseract timer with either
 * the ending of the jira-fe-gateway/fetch-tesseract timer or the bifrost-gateway timer
 */ function $ba8cdb329bff9946$var$getTesseractOffset({ tesseractTimings: tesseractTimings, jiraFeGatewayTimings: jiraFeGatewayTimings, bifrostGatewayTimings: bifrostGatewayTimings }) {
    const jiraFeGatewayTiming = jiraFeGatewayTimings?.['jira-fe-gateway/fetch-tesseract'];
    const jiraBeTesseractOffest = $ba8cdb329bff9946$var$getOffsetToAlignTimers(jiraFeGatewayTiming, tesseractTimings?.['']);
    const bifrostGatewayTiming = bifrostGatewayTimings?.['bifrost-gateway'];
    const bifrostOffset = $ba8cdb329bff9946$var$getOffsetToAlignTimers(bifrostGatewayTiming, tesseractTimings?.['']);
    return bifrostOffset ?? jiraBeTesseractOffest ?? 0;
}
function $ba8cdb329bff9946$var$getEdgeTime() {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const navigatonPerfTimingEntry = (0, $6RCeq.default)?.getEntriesByType('navigation')?.[0];
    return navigatonPerfTimingEntry?.serverTiming?.find(({ name: name })=>name === ((0, $4R6GH.fg)('jira-ssr-perf-portal-cleanup') ? 'atl-edge-internal' : 'atl-edge'))?.duration ?? 0;
}
function $ba8cdb329bff9946$export$6d488733a547304() {
    if (!(0, $4R6GH.fg)('jira-ssr-update-perf-portal-timings')) return $ba8cdb329bff9946$var$getTesseractTimings();
    const jiraBeTimings = $ba8cdb329bff9946$var$getJiraMonolithTimings();
    const jiraFeGatewayTimings = $ba8cdb329bff9946$var$getJiraFeGatewayTimings();
    const tesseractTimings = $ba8cdb329bff9946$var$getTesseractTimings();
    const bifrostGatewayTimings = $ba8cdb329bff9946$var$getBifrostGatewayTimings(jiraBeTimings, tesseractTimings);
    // Calculate offsets and apply them to the timings
    // this needs to be done in stages so that the offsets from the last stages apply to the next too
    const edgeTime = $ba8cdb329bff9946$var$getEdgeTime();
    const finalJiraBeTimings = $ba8cdb329bff9946$var$applyTimingOverrides(jiraBeTimings, {
        startTimeOffsetMs: edgeTime,
        prefix: 'jira-monolith'
    });
    const finalBifrostGatewayTimings = $ba8cdb329bff9946$var$applyTimingOverrides(bifrostGatewayTimings, {
        startTimeOffsetMs: edgeTime,
        prefix: 'bifrost-gateway'
    });
    const jfgOffset = $ba8cdb329bff9946$var$getJfgOffset({
        jiraFeGatewayTimings: jiraFeGatewayTimings,
        jiraBeTimings: finalJiraBeTimings
    });
    const finalJfgTimings = $ba8cdb329bff9946$var$applyTimingOverrides(jiraFeGatewayTimings, {
        startTimeOffsetMs: jfgOffset,
        prefix: 'jira-fe-gateway'
    });
    const tesseractOffset = $ba8cdb329bff9946$var$getTesseractOffset({
        tesseractTimings: tesseractTimings,
        jiraFeGatewayTimings: finalJfgTimings,
        bifrostGatewayTimings: finalBifrostGatewayTimings
    });
    const finalTesseractTimings = $ba8cdb329bff9946$var$applyTimingOverrides(tesseractTimings, {
        startTimeOffsetMs: tesseractOffset,
        prefix: 'tesseract'
    });
    const timings = {
        ...edgeTime && {
            edge: {
                startTime: 0,
                duration: edgeTime
            }
        },
        ...finalJiraBeTimings,
        ...finalJfgTimings,
        ...finalBifrostGatewayTimings,
        ...finalTesseractTimings
    };
    $ba8cdb329bff9946$var$insertTotalTiming('total', timings); // UFO treats 'total' as a special key for ssr timings that translates to 'ssr'
    return Object.keys(timings).length ? timings : null;
}
const $ba8cdb329bff9946$var$SSR_FF_META_TAG = 'spa-service-flags';
let $ba8cdb329bff9946$var$ffCache;
let $ba8cdb329bff9946$var$ffCacheInitialiser = ()=>{
    try {
        const metaTagValue = (0, $j8DrX.default)($ba8cdb329bff9946$var$SSR_FF_META_TAG);
        if (metaTagValue === null) return null;
        $ba8cdb329bff9946$var$ffCache = JSON.parse(metaTagValue) || null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        $ba8cdb329bff9946$var$ffCache = null;
    }
    $ba8cdb329bff9946$var$ffCacheInitialiser = null;
};
function $ba8cdb329bff9946$var$getFeatureFlags() {
    if ($ba8cdb329bff9946$var$ffCacheInitialiser != null) $ba8cdb329bff9946$var$ffCacheInitialiser();
    return $ba8cdb329bff9946$var$ffCache;
}
const $ba8cdb329bff9946$export$7bcf91e323db67dd = {
    getDoneMark: ()=>{
        // report failure if the entry point status is fail
        if ((0, $4R6GH.fg)('jira-ssr-enable-sfx-in-spa-render')) {
            if (globalThis.SPA_STATE?.['ssr/entry_point_status']?.match(/error|timeout/)) return null;
        } else if (globalThis.SPA_STATE?.['ssr/entry_point_status'] === 'fail') return null;
        if ((0, $4R6GH.fg)('ssr_success_when_spa_success')) {
            const SPASSRRenderedMark = (0, $x9xyg.getMark)((0, $ce556f125dee8174$export$135c96ab5afee429))?.startTime;
            if (SPASSRRenderedMark && (0, $x9xyg.getMark)('ssr.spa.state')?.startTime) return SPASSRRenderedMark;
            return null;
        }
        return (0, $x9xyg.getMark)((0, $ce556f125dee8174$export$135c96ab5afee429))?.startTime || null;
    },
    getTimings: $ba8cdb329bff9946$export$6d488733a547304,
    getFeatureFlags: $ba8cdb329bff9946$var$getFeatureFlags
};

});


parcelRegister("3qHVS", function(module, exports) {

$parcel$export(module.exports, "visualRefreshResolverOverride", () => $56907fa85239d7b0$export$73a94df81a7c0f2c);

var $dCm1o = parcelRequire("dCm1o");
const $56907fa85239d7b0$var$visualRefreshPlatformFlags = [
    'platform-component-visual-refresh',
    'platform-visual-refresh-icons-legacy-facade',
    'platform-visual-refresh-icons'
];
const $56907fa85239d7b0$export$73a94df81a7c0f2c = [
    (flagKey)=>$56907fa85239d7b0$var$visualRefreshPlatformFlags.includes(flagKey),
    (0, $dCm1o.isVisualRefreshEnabled)
];

});

parcelRegister("95Orn", function(module, exports) {

$parcel$export(module.exports, "AtlaspackMetricsConnector", () => $b6ff4b948a92fab7$export$a0da2371f93e56de);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $fjcgS = parcelRequire("fjcgS");

var $7CMCs = parcelRequire("7CMCs");

var $g6GsR = parcelRequire("g6GsR");
function $b6ff4b948a92fab7$export$2e97bdb0a62c1cbf() {
    if (!(0, $4R6GH.fg)('atlaspack_runtime_metrics')) return ()=>{
    /**/ };
    const fn = async (event)=>{
        try {
            if (event.detail === undefined || !event.detail.action) return;
            const { action: action, attributes: attributes = {} } = event.detail;
            // Get client or wait for it to initialize
            const analyticsWebClient = await (0, $fjcgS.getAnalyticsWebClientPromise)();
            const analyticsClient = analyticsWebClient.getInstance();
            // Fire event
            analyticsClient.sendOperationalEvent({
                source: 'devinfra-app-framework',
                actionSubject: 'atlaspack',
                action: action,
                attributes: {
                    ...attributes,
                    ...(0, $g6GsR.pageContext)()
                }
            });
        } catch (error) {
        // Suppress
        }
    };
    globalThis.addEventListener('atlaspack:analytics', fn);
    return ()=>globalThis.removeEventListener('atlaspack:analytics', fn);
}
function $b6ff4b948a92fab7$var$AtlaspackMetricsConnectorInner() {
    (0, $5uXOq.useEffect)($b6ff4b948a92fab7$export$2e97bdb0a62c1cbf, [
        globalThis
    ]);
    return null;
}
function $b6ff4b948a92fab7$export$a0da2371f93e56de() {
    if (!(0, $4R6GH.fg)('atlaspack_runtime_metrics')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "atlaspack_runtime_metrics",
        packageName: "@atlassian/jira-atlaspack-global-metrics",
        fallback: "unmount",
        teamName: "devinfra-app-framework"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6ff4b948a92fab7$var$AtlaspackMetricsConnectorInner, null));
}

});
parcelRegister("g6GsR", function(module, exports) {

$parcel$export(module.exports, "pageContext", () => $4ed3945fbf79d82f$export$bb8fabbb9eed884a);

var $cfDZ3 = parcelRequire("cfDZ3");
function $4ed3945fbf79d82f$export$bb8fabbb9eed884a() {
    return {
        routeName: $4ed3945fbf79d82f$var$getSafe(()=>(0, $cfDZ3.getUserLocation)()),
        userLocation: $4ed3945fbf79d82f$var$getSafe(()=>(0, $cfDZ3.getRouteName)()),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        bundlerVersion: $4ed3945fbf79d82f$var$getSafe(()=>globalThis.BUNDLER_VERSION),
        buildVariant: $4ed3945fbf79d82f$var$getSafe(()=>globalThis.BUILD_VARIANT)
    };
}
function $4ed3945fbf79d82f$var$getSafe(fn) {
    try {
        return fn();
    } catch (error) {
        return 'unknown';
    }
}

});


parcelRegister("fg6X1", function(module, exports) {

$parcel$export(module.exports, "initEntryPointConfig", () => $a2d25b84ef5ddd7e$export$93a6801f9db838c4);

var $5uXOq = parcelRequire("5uXOq");

var $l8ruj = parcelRequire("l8ruj");

var $lfTZh = parcelRequire("lfTZh");

var $ajG9J = parcelRequire("ajG9J");

var $i2Rm5 = parcelRequire("i2Rm5");
const $a2d25b84ef5ddd7e$var$ModalErrorFallback = ({ error: error })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
        id: "",
        error: error
    });
};
function $a2d25b84ef5ddd7e$export$93a6801f9db838c4() {
    (0, $ajG9J.initEntryPointConfig)({
        PlaceholderComponent: ({ name: name, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
                name: name || '',
                ...props
            }),
        UFOSegmentComponent: (0, $l8ruj.default),
        ModalErrorFallback: $a2d25b84ef5ddd7e$var$ModalErrorFallback
    });
}

});

parcelRegister("2ChuC", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe3490a17e762431$export$2e2bcd8739ae039);

var $fr1K2 = parcelRequire("fr1K2");

var $6YRTH = parcelRequire("6YRTH");

var $j8DrX = parcelRequire("j8DrX");

var $7AZuS = parcelRequire("7AZuS");

var $7o9iL = parcelRequire("7o9iL");

const $fe3490a17e762431$var$renderEngagementMessages = ()=>{
    (parcelRequire("7i4PU"));
};

const $fe3490a17e762431$var$renderProfileCardNextLegacy = ()=>{
    (parcelRequire("dxZMM"));
};

const $fe3490a17e762431$var$renderHeartbeat = ()=>{
    (parcelRequire("jzW9D"));
};

const $fe3490a17e762431$var$loadUpFlowAPI = ()=>(parcelRequire("h7Vx2"));

const $fe3490a17e762431$var$installConnectModules = ()=>(parcelRequire("feIhl"));
const $fe3490a17e762431$var$markSafeForAnalytics = (str)=>str || null;
const $fe3490a17e762431$var$renderSearchDwellTimeComponent = ()=>{
    const searchSessionId = (0, $j8DrX.default)('ajs-search-session-id');
    const containerId = (0, $j8DrX.default)('ajs-search-container-id');
    const objectId = (0, $j8DrX.default)('ajs-search-object-id');
    const objectType = (0, $j8DrX.default)('ajs-search-content-type');
    (0, $6YRTH.default)([
        'searchSessionId',
        'searchObjectId',
        'searchContainerId',
        'searchContentType'
    ]);
    (0, $7o9iL.default)('search-dwell-time', $fe3490a17e762431$var$markSafeForAnalytics(searchSessionId), {
        containerId: $fe3490a17e762431$var$markSafeForAnalytics(containerId),
        objectId: $fe3490a17e762431$var$markSafeForAnalytics(objectId),
        objectType: $fe3490a17e762431$var$markSafeForAnalytics(objectType),
        actionSubject: $fe3490a17e762431$var$markSafeForAnalytics(objectType),
        source: $fe3490a17e762431$var$markSafeForAnalytics(objectType)
    });
};
const $fe3490a17e762431$var$installHighPriorityApps = (args)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'JiraContextContainer'.
    const priorityApps = [];
    if (args.flags) priorityApps.push((0, $7AZuS.renderFlags)());
    if (args.navigation) priorityApps.push(args.renderNavigation());
    return priorityApps;
};
const $fe3490a17e762431$var$installLowPriorityApps = (args)=>{
    if (args.upflow) $fe3490a17e762431$var$loadUpFlowAPI();
    if (args.profileCardNextLegacy) $fe3490a17e762431$var$renderProfileCardNextLegacy();
    if (args.connectModules) $fe3490a17e762431$var$installConnectModules();
    if (args.engagementMessages) $fe3490a17e762431$var$renderEngagementMessages();
    if (args.heartbeat) $fe3490a17e762431$var$renderHeartbeat();
    if (args.searchDwellTimeComponent) $fe3490a17e762431$var$renderSearchDwellTimeComponent();
};
const $fe3490a17e762431$var$installAppsWithPriorityOrder = async (args)=>{
    await Promise.all($fe3490a17e762431$var$installHighPriorityApps({
        flags: args.flags,
        navigation: args.navigation,
        renderNavigation: args.renderNavigation
    }));
    $fe3490a17e762431$var$installLowPriorityApps((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(args, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
};
const $fe3490a17e762431$var$defaultArgs = {
    flags: true,
    navigation: true,
    upflow: true,
    profileCardNextLegacy: true,
    heartbeat: true,
    connectModules: true,
    engagementMessages: true,
    searchDwellTimeComponent: true,
    renderNavigation: ()=>null
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fe3490a17e762431$export$2e2bcd8739ae039 = {
    install: (args)=>{
        const argsWithDefaults = {
            ...$fe3490a17e762431$var$defaultArgs,
            ...args
        };
        // @ts-expect-error - TS2345 - Argument of type '{ flags: boolean; navigation: boolean; renderNavigation: (() => any) | (() => null); upflow: boolean; heartbeat: boolean; profileCardNextLegacy: boolean; connectModules: boolean; originTracing?: boolean | undefined; engagementMessages: boolean; searchDwellTimeComponent: boolean; }' is not assignable to parameter of type 'GlobalArgs'.
        $fe3490a17e762431$var$installAppsWithPriorityOrder(argsWithDefaults);
    },
    installHighPriorityApps: (args)=>{
        const { flags: flags, navigation: navigation, renderNavigation: renderNavigation } = {
            ...$fe3490a17e762431$var$defaultArgs,
            ...args
        };
        $fe3490a17e762431$var$installHighPriorityApps({
            flags: flags,
            navigation: navigation,
            renderNavigation: renderNavigation
        });
    },
    installLowPriorityApps: (args)=>{
        const installArgs = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))({
            ...$fe3490a17e762431$var$defaultArgs,
            ...args
        }, [
            'flags',
            'navigation',
            'renderNavigation'
        ]);
        $fe3490a17e762431$var$installLowPriorityApps(installArgs);
    }
};

});
parcelRegister("7AZuS", function(module, exports) {

$parcel$export(module.exports, "renderFlags", () => $271711a34feab2aa$export$b6228dc14c5adf51);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $dJl1T = parcelRequire("dJl1T");

var $jsLXn = parcelRequire("jsLXn");

var $iNWLk = parcelRequire("iNWLk");

var $9F6Ii = parcelRequire("9F6Ii");

var $b7Svb = parcelRequire("b7Svb");
const $271711a34feab2aa$var$throwError = (message)=>{
    const error = new Error(message);
    (0, $dJl1T.default).safeErrorWithoutCustomerData('flags.entry', message, error);
    throw error;
};
const $271711a34feab2aa$var$getContainer = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let container = document.getElementById('flags');
    if (container == null) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        container = document.createElement('div');
        container.id = 'flags';
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body.appendChild(container);
        else $271711a34feab2aa$var$throwError('document.body was not found whilst trying to create the flags container');
    }
    return container;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $271711a34feab2aa$var$Flags = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("amLL8")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $271711a34feab2aa$var$AfterPaintFlags = (0, $b7Svb.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("amLL8")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
});
const $271711a34feab2aa$export$b6228dc14c5adf51 = ()=>(0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9F6Ii.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jsLXn.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: "flags-entry"
    }, __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($271711a34feab2aa$var$AfterPaintFlags, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($271711a34feab2aa$var$Flags, null)))), $271711a34feab2aa$var$getContainer());

});
parcelRegister("amLL8", function(module, exports) {

let $78c101733f7c73a9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $78c101733f7c73a9$var$load("hPzOn"),
    $78c101733f7c73a9$var$load("cM9em"),
    $78c101733f7c73a9$var$load("fr9NE"),
    $78c101733f7c73a9$var$load("h46oV")
]).then(()=>parcelRequire('3jTq3'));

});


parcelRegister("7o9iL", function(module, exports) {

$parcel$export(module.exports, "default", () => $87698987077682aa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $9F6Ii = parcelRequire("9F6Ii");

var $TtQEC = parcelRequire("TtQEC");
const $87698987077682aa$var$getPlaceholder = (placeholderId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const existingPlaceholder = document.getElementById(placeholderId);
    if (existingPlaceholder) return existingPlaceholder;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const div = document.createElement('div');
    div.id = placeholderId;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body.appendChild(div);
    else throw new Error('document.body was not found whilst trying to create the dwell component placeholder.');
    return div;
};
const $87698987077682aa$var$renderDwellTimeComponent = (placeholder, sessionId, data = {})=>{
    if (placeholder && sessionId) (0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9F6Ii.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $TtQEC.default), {
        sessionId: sessionId,
        data: data
    })), $87698987077682aa$var$getPlaceholder(placeholder));
};
var $87698987077682aa$export$2e2bcd8739ae039 = $87698987077682aa$var$renderDwellTimeComponent;

});

parcelRegister("7i4PU", function(module, exports) {

let $54edf7327e18545e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $54edf7327e18545e$var$load("hPzOn"),
    $54edf7327e18545e$var$load("cM9em"),
    $54edf7327e18545e$var$load("fr9NE"),
    $54edf7327e18545e$var$load("h2MrD"),
    $54edf7327e18545e$var$load("bYT2S"),
    $54edf7327e18545e$var$load("2ZtG1")
]).then(()=>parcelRequire('2Q8el'));

});

parcelRegister("dxZMM", function(module, exports) {

let $9dce48cd330800c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9dce48cd330800c0$var$load("cM9em"),
    $9dce48cd330800c0$var$load("fr9NE"),
    $9dce48cd330800c0$var$load("eNmuD"),
    $9dce48cd330800c0$var$load("hPzOn"),
    $9dce48cd330800c0$var$load("h2MrD"),
    $9dce48cd330800c0$var$load("bYT2S"),
    $9dce48cd330800c0$var$load("54DPr")
]).then(()=>parcelRequire('forzB'));

});

parcelRegister("jzW9D", function(module, exports) {

let $e40e6574e3580374$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e40e6574e3580374$var$load("bERdS").then(()=>parcelRequire('8ymsB'));

});

parcelRegister("h7Vx2", function(module, exports) {

let $c77fb7b878cc8e70$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c77fb7b878cc8e70$var$load("3PrnJ"),
    $c77fb7b878cc8e70$var$load("h2MrD"),
    $c77fb7b878cc8e70$var$load("bYT2S"),
    $c77fb7b878cc8e70$var$load("cM9em"),
    $c77fb7b878cc8e70$var$load("fr9NE"),
    $c77fb7b878cc8e70$var$load("kWrFZ"),
    $c77fb7b878cc8e70$var$load("92sUi"),
    $c77fb7b878cc8e70$var$load("i5RRW"),
    $c77fb7b878cc8e70$var$load("9vNc4"),
    $c77fb7b878cc8e70$var$load("4ogRW"),
    $c77fb7b878cc8e70$var$load("kfXhT"),
    $c77fb7b878cc8e70$var$load("2Lfdl"),
    $c77fb7b878cc8e70$var$load("hPzOn"),
    $c77fb7b878cc8e70$var$load("dsiAd"),
    $c77fb7b878cc8e70$var$load("eNmuD"),
    $c77fb7b878cc8e70$var$load("dzRix")
]).then(()=>parcelRequire('faPQm'));

});

parcelRegister("feIhl", function(module, exports) {

let $b17a82a97a323842$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b17a82a97a323842$var$load("Nlduf").then(()=>parcelRequire('jEc6C'));

});



parcelRegister("594zW", function(module, exports) {

$parcel$export(module.exports, "startJiraSpa", () => $345aa43775a5b794$export$f71867a5b2484020);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $fr1K2 = parcelRequire("fr1K2");

var $3NMrl = parcelRequire("3NMrl");

var $kUr4d = parcelRequire("kUr4d");

var $1POpY = parcelRequire("1POpY");

var $iyRIi = parcelRequire("iyRIi");

var $5qBRE = parcelRequire("5qBRE");

var $j5G08 = parcelRequire("j5G08");

var $1V2aV = parcelRequire("1V2aV");

var $bl6ih = parcelRequire("bl6ih");

var $k4NnA = parcelRequire("k4NnA");

var $aTq2A = parcelRequire("aTq2A");


var $87OsA = parcelRequire("87OsA");
parcelRequire("2YzDH");

var $x9xyg = parcelRequire("x9xyg");

var $dn0m5 = parcelRequire("dn0m5");

var $4Pf62 = parcelRequire("4Pf62");

var $frBVt = parcelRequire("frBVt");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $7bkFJ = parcelRequire("7bkFJ");

var $4R6GH = parcelRequire("4R6GH");

var $hL7JE = parcelRequire("hL7JE");

var $kZBXc = parcelRequire("kZBXc");

var $cfDZ3 = parcelRequire("cfDZ3");

var $6jY6G = parcelRequire("6jY6G");

var $9F6Ii = parcelRequire("9F6Ii");

var $81ezV = parcelRequire("81ezV");

var $b7awD = parcelRequire("b7awD");

var $d1K1f = parcelRequire("d1K1f");

var $2SVPM = parcelRequire("2SVPM");

var $fGcGc = parcelRequire("fGcGc");

var $bShz7 = parcelRequire("bShz7");

var $lbyb6 = parcelRequire("lbyb6");

var $5HG6S = parcelRequire("5HG6S");

var $29g8C = parcelRequire("29g8C");

var $kKlrY = parcelRequire("kKlrY");

var $l8ruj = parcelRequire("l8ruj");

var $3qHVS = parcelRequire("3qHVS");

var $50oqM = parcelRequire("50oqM");
var $jP5md = parcelRequire("jP5md");

var $2Gs5h = parcelRequire("2Gs5h");
var $lVJAU = parcelRequire("lVJAU");

var $lODMY = parcelRequire("lODMY");

var $iLrcb = parcelRequire("iLrcb");

var $95Orn = parcelRequire("95Orn");

var $fg6X1 = parcelRequire("fg6X1");

var $c1haS = parcelRequire("c1haS");

var $2ChuC = parcelRequire("2ChuC");
// Set SPA global
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window.__SPA__ = true;

const $345aa43775a5b794$var$getMessages = ()=>{
    (0, $x9xyg.setMark)('jira-spa/language-pack.start');
    const messages = (parcelRequire("hWnRN"));
    (0, $x9xyg.setMark)('jira-spa/language-pack.end');
    return messages;
};
const $345aa43775a5b794$var$superbatchInit = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.DeferScripts = {
        deferState: 'done'
    };
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body?.classList.remove('deferred');
};
const $345aa43775a5b794$var$globalSettingsArgs = {
    navigation: false,
    upflow: false
};
const $345aa43775a5b794$var$InstallGlobalComponentsOnce = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $2ChuC.default).installLowPriorityApps(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'LowPriorityAppsArgs'.
        (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))($345aa43775a5b794$var$globalSettingsArgs, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
        (0, $x9xyg.setMark)('JIRA_SPA_ENTRY_GLOBAL_INSTALL');
    }, []);
    return null;
};
const $345aa43775a5b794$var$updateCapability = (capability)=>{
    (0, $87OsA.setCapability)(capability);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (capability === null && window.AJS?.$?.ajaxSettings?.headers?.[0, $281cbd47ba46dd7d$export$9a80695e72849f84]) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.AJS.$.ajaxSettings.headers[0, $281cbd47ba46dd7d$export$9a80695e72849f84];
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.AJS?.$?.ajaxSetup({
        headers: {
            [(0, $281cbd47ba46dd7d$export$9a80695e72849f84)]: capability
        }
    });
};
// @ts-expect-error - TS7031 - Binding element 'routes' implicitly has an 'any' type.
const $345aa43775a5b794$var$CapabilityTrackerConnector = ({ routes: routes })=>{
    const { registerBlock: registerBlock } = (0, $lVJAU.useRouterActions)();
    registerBlock((nextLocation)=>{
        const nextMatchObject = (0, $2Gs5h.default)(routes, nextLocation.pathname, // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'Query | undefined'.
        nextLocation.search, '');
        $345aa43775a5b794$var$updateCapability(nextMatchObject?.route.meta?.capability || null);
        return true;
    });
    const route = (0, $6jY6G.useCurrentRoute)();
    $345aa43775a5b794$var$updateCapability(route.meta?.capability || null);
    return null;
};
const $345aa43775a5b794$var$main = async (getInitialRoutes, loadLazyRoutes)=>{
    (0, $x9xyg.setMark)('_jira-spa/main-start');
    const deps = new (0, $dn0m5.SpaBootstrapDependencies)(window);
    // This guarantees we can wait until our dependencies arrive.
    // It's not ideal, because we're blocking immediately upon starting up the SPA.
    // From here the game is to move these promises as far down in to the control flow as possible.
    (0, $x9xyg.setMark)('_jira-spa/main-before-early-deps');
    await Promise.allSettled([
        deps.statsigValues(),
        deps.launchDarklyValues(),
        deps.tenantContext()
    ]);
    (0, $x9xyg.setMark)('_jira-spa/main-after-early-deps');
    (0, $kKlrY.default)();
    (0, $aTq2A.initBrowserMetrics3)();
    (0, $7bkFJ.initPlatformFeatureFlags)((0, $3qHVS.visualRefreshResolverOverride));
    (0, $fg6X1.initEntryPointConfig)();
    (0, $fGcGc.addInitialPageLoadTimings)();
    (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/init', 'jira-spa.js:eval-start');
    (0, $x9xyg.setMark)('jira-spa/setup.start');
    const routes = (0, $2SVPM.measureInitialPageLoadTiming)('jira-spa/setup/routes', ()=>getInitialRoutes());
    const history = (0, $2SVPM.measureInitialPageLoadTiming)('jira-spa/setup/history', ()=>(0, $lbyb6.default)(routes));
    const initRoute = (0, $2SVPM.measureInitialPageLoadTiming)('jira-spa/setup/match-route', ()=>{
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'Query | undefined'.
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const matchedRoute = (0, $2Gs5h.default)(routes, window.location.pathname, window.location.search);
        (0, $cfDZ3.setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
        return matchedRoute;
    });
    if (initRoute != null) {
        const ufoName = (0, $1POpY.default)(initRoute.route);
        (0, $5qBRE.default)(ufoName, initRoute.route.name);
    }
    const BrowserMetricsConnector = ()=>{
        const route = (0, $6jY6G.useCurrentRoute)();
        (0, $bl6ih.browserMetrics).setRoute(route.name);
        (0, $j5G08.useUFOTransitionCompleter)();
        (0, $iLrcb.GlobalPageLoadExperience).setPageLoadId(route.perfMetricKey || 'UNKNOWN');
        return null;
    };
    const messages = $345aa43775a5b794$var$getMessages();
    const tenantContext = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const { locale: locale } = tenantContext;
    let routerProps;
    const getRouterProps = (resourceData)=>{
        return {
            history: history,
            routes: routes,
            basePath: '',
            initialRoute: initRoute?.route,
            resourceData: resourceData,
            resourceContext: (0, $5HG6S.getSpaRouterContext)({
                tenantContext: tenantContext
            }),
            onPrefetch: ({ route: route, match: match })=>{
                (0, $bShz7.setPrefetchStartMark)(match);
                if (!route.forPaint) return;
                route.forPaint.map((component)=>component.preload?.());
            },
            isLazyRoutes: typeof loadLazyRoutes === 'function'
        };
    };
    let SpaClientRouter;
    if (typeof loadLazyRoutes === 'function') {
        const useRouterRoutes = (0, $lODMY.createRouterSelector)((state)=>state.routes);
        SpaClientRouter = ({ children: children })=>{
            const actions = (0, $lODMY.useRouterStoreActions)();
            const currentRoutes = useRouterRoutes();
            (0, $5uXOq.useEffect)(()=>{
                let isCancelled = false;
                const loadRoutes = async ()=>{
                    if (!isCancelled) {
                        const getLazyRoutes = await loadLazyRoutes();
                        await actions.setRoutes(getLazyRoutes());
                    }
                };
                loadRoutes();
                return ()=>{
                    isCancelled = true;
                };
            }, [
                actions
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b7awD.Router), routerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
                id: "spa-main.client-router",
                packageName: "jiraEntry",
                fallback: "unmount",
                teamName: "delorean-spa"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $95Orn.AtlaspackMetricsConnector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BrowserMetricsConnector, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($345aa43775a5b794$var$CapabilityTrackerConnector, {
                routes: currentRoutes
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d1K1f.default), null)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hL7JE.NonCritical), {
                id: "spa-main.client-router.non-critical",
                teamName: "delorean-spa"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($345aa43775a5b794$var$InstallGlobalComponentsOnce, null)));
        };
    } else SpaClientRouter = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b7awD.Router), routerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            id: "spa-main.client-router",
            packageName: "jiraEntry",
            fallback: "unmount",
            teamName: "delorean-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $95Orn.AtlaspackMetricsConnector), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BrowserMetricsConnector, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($345aa43775a5b794$var$CapabilityTrackerConnector, {
            routes: routes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d1K1f.default), null)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hL7JE.NonCritical), {
            id: "spa-main.client-router.non-critical",
            teamName: "delorean-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($345aa43775a5b794$var$InstallGlobalComponentsOnce, null)));
    const App = ({ placeholders: placeholders })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9F6Ii.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: "jira-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointPlaceholderContext).Provider, {
            value: placeholders
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZBXc.Spa), {
            baseUrl: "",
            locale: locale,
            messages: messages,
            Router: SpaClientRouter,
            initRoute: initRoute,
            routes: routes,
            routerLinkComponent: (0, $81ezV.JiraRouterLinkConfiguration)
        }))));
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__NAV_VERSION__ = '3.0.0';
    (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/setup', 'jira-spa/setup.start', true);
    (0, $x9xyg.setMark)('_jira-spa/spa-shell.start');
    // This function is normally run as soon as the SSR service flushes the DOM element containing the server-rendered HTML.
    // There some conditions in which it could or should be re-run...
    // (1) The SSR service reports a hard failure,
    // (2) The SSR response is taking too long to flush (a soft failure), or
    // (3) Something goes wrong during running the function itself.
    // In any of these cases, the client can choose to run this function again to attempt a recovery.
    const renderSpa = ({ didSsrRenderSpa: didSsrRenderSpa, container: container, spaState: spaState })=>{
        (0, $x9xyg.setMark)('_jira-spa/render-spa-fn-start');
        // Notify whether there was a complete SSR success or if there were render problems.
        (0, $iLrcb.GlobalPageLoadExperience).addMetadata({
            didSsrRenderSpa: didSsrRenderSpa
        });
        // SPA_STATE is untyped, but we have passed it in to Router like this for ages and nobody complained.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        routerProps = getRouterProps(spaState);
        (0, $1V2aV.getVCObserver)().setSSRElement(container);
        (0, $1V2aV.getVCObserver)().setReactRootRenderStart();
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                (0, $1V2aV.getVCObserver)().setReactRootRenderStop();
            });
        });
        if ((0, $4R6GH.fg)('jira-spa-bootstrap-changes-2025-03-05')) (0, $50oqM.LooselyLazy).init({
            mode: (0, $4R6GH.fg)('jfp_magma_jira-rll-hydrate') ? (0, $jP5md.MODE).HYDRATE : (0, $jP5md.MODE).RENDER,
            crossOrigin: 'anonymous',
            react18: (0, $4R6GH.fg)('jfp_magma_jira-rll-react-18-render'),
            usePostTaskPhases: (0, $4R6GH.fg)('jfp-jira-remove-rll-subscriptions')
        });
        const placeholders = (0, $frBVt.getPlaceholdersFromHTML)();
        if ((0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nin_and_nav') || (0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nav_for_iv') || (0, $4R6GH.fg)('add_nav_ssr_placeholder_for_board_and_backlog')) (0, $iyRIi.collectSSRPlaceholderDimensions)(document, window);
        const isConcurrentEnabled = (0, $c1haS.getIsConcurrentEnabled)();
        // if the feature flag is false, do not opt into concurrent features
        // if the local env var is not set, or set to false, do not opt into concurrent features
        if (!isConcurrentEnabled) (0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(App, {
            placeholders: placeholders
        }), container);
        if (isConcurrentEnabled) {
            if ((0, $4R6GH.fg)('jfp-magma-incremental-hydrate-root')) {
                const ConcurrentSpaApp = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(App, {
                        placeholders: placeholders
                    }), (0, $4R6GH.fg)('concurrent-rendering-change-advisory') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29g8C.ConcurrentAdvisory), {
                        consoleMessage: "This entire site is being rendered with React concurrent rendering go/r18"
                    }) : null);
                if (initRoute?.route?.isHydrateRootEnabled) (0, $kUr4d.hydrateRoot)(container, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConcurrentSpaApp, null));
                else {
                    const root = (0, $kUr4d.createRoot)(container);
                    root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConcurrentSpaApp, null));
                }
            } else {
                const root = (0, $kUr4d.createRoot)(container);
                root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(App, {
                    placeholders: placeholders
                }), (0, $4R6GH.fg)('concurrent-rendering-change-advisory') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29g8C.ConcurrentAdvisory), {
                    consoleMessage: "This entire site is being rendered with React concurrent rendering go/r18"
                }) : null));
            }
        }
        (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/spa-shell', '_jira-spa/spa-shell.start');
        (0, $x9xyg.setMark)('JIRA_SPA_ENTRY_REACT_DOM_RENDER');
        if ((0, $6s1PB.expVal)('uip_preprod_slow', 'value', 0) > 0) {
            (0, $x9xyg.setMark)('slow-start');
            const end = performance.now() + (0, $6s1PB.expVal)('uip_preprod_slow', 'value', 0);
            while(performance.now() < end);
            (0, $x9xyg.setMark)('slow-stop');
        }
        (0, $2ChuC.default).installHighPriorityApps(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'HighPriorityAppsArgs'.
        (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))($345aa43775a5b794$var$globalSettingsArgs, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
        $345aa43775a5b794$var$superbatchInit();
        // Post-initialisation, post-render timings
        setTimeout(()=>{
            (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa', 'commons-entry.js:eval-stop', 'jira-spa.js:eval-stop');
            (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/early-deps-delay', '_jira-spa/main-before-early-deps', '_jira-spa/main-after-early-deps');
            (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/dom-deps-delay', '_jira-spa/main-before-dom-deps', '_jira-spa/main-after-dom-deps');
            (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/render-spa-fn', '_jira-spa/render-spa-fn-start', '_jira-spa/render-spa-fn-stop');
        });
        (0, $x9xyg.setMark)('_jira-spa/render-spa-fn-stop');
    };
    // This is where we actually begin the rendering process by awaiting our dependencies.
    (0, $x9xyg.setMark)('_jira-spa/main-before-dom-deps');
    return Promise.all([
        deps.didSsrRenderSpa(),
        deps.domElement(),
        deps.spaState()
    ]).then(([didSsrRenderSpa, container, spaState])=>{
        (0, $x9xyg.setMark)('_jira-spa/main-after-dom-deps');
        renderSpa({
            didSsrRenderSpa: didSsrRenderSpa,
            container: container,
            spaState: spaState
        });
    }, (error)=>{
        (0, $x9xyg.setMark)('jira-spa/main-dom-deps-error');
        (0, $iLrcb.GlobalPageLoadExperience).addMetadata({
            initialRenderError: error
        });
        // Attempt a graceful recovery on the client side by rendering the whole app ourselves.
        // If we're on the server, bail immediately.
        if (false) throw error;
        /* eslint-disable jira/jira-ssr/no-unchecked-globals-usage */ let el = document.getElementById('jira-frontend');
        if (!el) {
            // Hide the server-provided `jira-frontend` element. The server + network might be slow, so
            // it may still arrive from the server... but by that time we will be rendering ourselves,
            // so we want to avoid the browser rendering anything inside it.
            const style = document.createElement('style');
            style.textContent = '#jira-frontend ~ #jira-frontend { display:none !important; }';
            document.body.appendChild(style);
            // Create a new fallback container to render the app inside.
            el = document.createElement('div');
            el.setAttribute('id', 'jira-frontend');
            el.setAttribute('data-spa-element', 'client');
            document.body.appendChild(el);
        } else el.setAttribute('data-spa-element', 'server');
        el.setAttribute('data-spa-retry', '');
        // Render the app.
        renderSpa({
            didSsrRenderSpa: false,
            container: el,
            spaState: undefined
        });
    /* eslint-enable jira/jira-ssr/no-unchecked-globals-usage */ });
};
const $345aa43775a5b794$export$f71867a5b2484020 = async (getInitialRoutes, loadLazyRoutes)=>{
    if (!(0, $4R6GH.fg)('jira-spa-bootstrap-changes-2025-03-05')) (0, $50oqM.LooselyLazy).init({
        mode: (0, $4R6GH.fg)('jfp_magma_jira-rll-hydrate') ? (0, $jP5md.MODE).HYDRATE : (0, $jP5md.MODE).RENDER,
        crossOrigin: 'anonymous',
        react18: (0, $4R6GH.fg)('jfp_magma_jira-rll-react-18-render'),
        usePostTaskPhases: (0, $4R6GH.fg)('jfp-jira-remove-rll-subscriptions')
    });
    (0, $iLrcb.GlobalPageLoadExperience).startPageLoad('UNKNOWN', true);
    return $345aa43775a5b794$var$main(getInitialRoutes, loadLazyRoutes).catch((reason)=>{
        (0, $iLrcb.GlobalPageLoadExperience).failure();
        return (0, $k4NnA.reportBootstrapError)(reason);
    });
};

});
parcelRegister("dn0m5", function(module, exports) {

$parcel$export(module.exports, "SpaBootstrapDependencies", () => $f0440b069d03fdc9$export$a6c58ffe0a3c3ff3);

var $4Pf62 = parcelRequire("4Pf62");

var $y7eb2 = parcelRequire("y7eb2");

var $1zAKS = parcelRequire("1zAKS");
const $f0440b069d03fdc9$var$POLLING_INTERVAL_MS = 30;
async function $f0440b069d03fdc9$var$testForThingWithTimeout(testFn, timeoutMs = 5000) {
    const startTime = Date.now();
    let result;
    return new Promise((resolve, reject)=>{
        try {
            result = testFn();
        } catch (e) {
            reject(e);
        }
        if (result) return resolve(result);
        const interval = setInterval(()=>{
            if (Date.now() - startTime >= timeoutMs) {
                clearInterval(interval);
                return reject();
            }
            try {
                result = testFn();
            } catch (e) {
                reject(e);
            }
            if (result) {
                clearInterval(interval);
                resolve(result);
            }
        }, $f0440b069d03fdc9$var$POLLING_INTERVAL_MS);
    });
}
class $f0440b069d03fdc9$export$a6c58ffe0a3c3ff3 {
    #windowObject;
    #timeoutMs;
    constructor(window, timeoutMs = 5000){
        this.window = window;
        this.timeoutMs = timeoutMs;
        this.#windowObject = window;
        this.#timeoutMs = timeoutMs;
    }
    domElement(timeoutMs = 15000) {
        return $f0440b069d03fdc9$var$testForThingWithTimeout(()=>{
            if (this.#windowObject.document.readyState === 'complete') throw new Error('Element will not arrive from server');
            return this.#windowObject.document.getElementById('jira-frontend');
        }, timeoutMs || this.#timeoutMs).catch(()=>{
            throw Error('Could not locate jira-frontend element');
        });
    }
    didSsrRenderSpa() {
        return $f0440b069d03fdc9$var$testForThingWithTimeout(()=>'__SSR_FALLBACK__' in this.#windowObject || this.#windowObject.SSR_DETAILS && 'spa_state_written' in this.#windowObject.SSR_DETAILS || 'SPA_STATE' in this.#windowObject).then(()=>Boolean(this.#windowObject.SPA_STATE) || Boolean(this.#windowObject.SSR_DETAILS?.spa_state_written) || false).catch(()=>false);
    }
    spaState() {
        return this.didSsrRenderSpa().then(()=>this.#windowObject.SPA_STATE).catch(()=>undefined);
    }
    statsigValues() {
        return $f0440b069d03fdc9$var$testForThingWithTimeout((0, $1zAKS._haveValuesArrived), this.#timeoutMs).catch(()=>{
            throw Error('Could not locate Statsig values');
        });
    }
    launchDarklyValues() {
        return $f0440b069d03fdc9$var$testForThingWithTimeout((0, $y7eb2._haveValuesArrived), this.#timeoutMs).catch(()=>{
            throw Error('Could not locate LaunchDarkly values');
        });
    }
    /** @deprecated using tenant context and meta tags is a bad data access pattern that we want to see disappear. */ tenantContext() {
        return $f0440b069d03fdc9$var$testForThingWithTimeout((0, $4Pf62._haveValuesArrived), this.#timeoutMs).catch(()=>{
            throw Error('Could not locate tenant context values');
        });
    }
}

});


$parcel$global.rwr("jfj4N", () => { parcelRequire("lRSO6");
parcelRequire("8oLfs");

var $x9xyg = parcelRequire("x9xyg");

var $VVnlL = parcelRequire("VVnlL");

var $gGB8S = parcelRequire("gGB8S");

var $594zW = parcelRequire("594zW");
(0, $x9xyg.setMark)('JIRA_SPA_ENTRY_LOADED');
// It is easier to make the check against window than it is to make typescript happy here.
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
if (!false && typeof window !== 'undefined' && window.__SPA_BOOTSTRAP_ALT) (0, $594zW.startJiraSpa)((0, $VVnlL.getSpaRoutes));
else (0, $gGB8S.startJiraSpa)((0, $VVnlL.getSpaRoutes));
 }, ["eNmuD","dsiAd","hPzOn","2Lfdl","kfXhT","4ogRW","9vNc4","i5RRW","92sUi","kWrFZ","bYT2S","h2MrD","fr9NE","cM9em","1WmWM"]);
// error types
const $4cff3ad70ea80f75$export$6c8cb487d6ffc522 = 'QueryError';
const $4cff3ad70ea80f75$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $4cff3ad70ea80f75$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $4cff3ad70ea80f75$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $4cff3ad70ea80f75$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $4cff3ad70ea80f75$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $4cff3ad70ea80f75$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $4cff3ad70ea80f75$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $4cff3ad70ea80f75$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $4cff3ad70ea80f75$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $4cff3ad70ea80f75$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $4cff3ad70ea80f75$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


$parcel$global.rlb("jfj4N")
//# sourceMappingURL=jira-spa.9af2818a.js.map
